
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec7c7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec7c7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});





parcelRegister("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || /** @type {(array: readonly unknown[], value: unknown) => keyof array} */ function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {Int8Array | Uint8Array | Uint8ClampedArray | Int16Array | Uint16Array | Int32Array | Uint32Array | Float32Array | Float64Array | BigInt64Array | BigUint64Array} TypedArray */ /** @typedef {'Int8Array' | 'Uint8Array' | 'Uint8ClampedArray' | 'Int16Array' | 'Uint16Array' | 'Int32Array' | 'Uint32Array' | 'Float32Array' | 'Float64Array' | 'BigInt64Array' | 'BigUint64Array'} TypedArrayName */ /** @type {{ [k in `\$${TypedArrayName}`]?: (receiver: TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call } & { __proto__: null }} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(fn);
});
/** @type {import('.')} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<tryAllTypedArrays>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, typeof cache>} */ /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<tryAllSlices>} */ var found = false;
    $gFhA7(// eslint-disable-next-line no-extra-parens
    /** @type {any} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRegister("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
"use strict";
var /** @type {ReturnType<import('.')>} */ $63bfbecf41903c8f$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $63bfbecf41903c8f$var$g[$63bfbecf41903c8f$var$possibleNames[i]] === "function") // @ts-expect-error
    out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});


parcelRegister("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("gsd36", function(module, exports) {

$parcel$export(module.exports, "configureChains", () => configureChains);
$parcel$export(module.exports, "createConfig", () => createConfig);
$parcel$export(module.exports, "connect", () => connect);
$parcel$export(module.exports, "disconnect", () => disconnect);
$parcel$export(module.exports, "fetchBalance", () => fetchBalance);
$parcel$export(module.exports, "getAccount", () => getAccount);
$parcel$export(module.exports, "getNetwork", () => getNetwork);
$parcel$export(module.exports, "signMessage", () => signMessage);
$parcel$export(module.exports, "switchNetwork", () => switchNetwork);
$parcel$export(module.exports, "watchAccount", () => watchAccount);
$parcel$export(module.exports, "watchNetwork", () => watchNetwork);
$parcel$export(module.exports, "fetchEnsAvatar", () => fetchEnsAvatar);
$parcel$export(module.exports, "fetchEnsName", () => fetchEnsName);

var $baiWq = parcelRequire("baiWq");

var $l3rDK = parcelRequire("l3rDK");

var $83kyS = parcelRequire("83kyS");
var $PaH4P = parcelRequire("PaH4P");
var $g69ST = parcelRequire("g69ST");
var $8tKwY = parcelRequire("8tKwY");
var $53GlG = parcelRequire("53GlG");
var $fDKcx = parcelRequire("fDKcx");
var $34q4g = parcelRequire("34q4g");
var $8hd5S = parcelRequire("8hd5S");
var $bTOZ4 = parcelRequire("bTOZ4");
var $5BBzT = parcelRequire("5BBzT");
var $kRozl = parcelRequire("kRozl");
var $lvNQN = parcelRequire("lvNQN");
var $fCd4Y = parcelRequire("fCd4Y");

var $gAovx = parcelRequire("gAovx");

var $88tPr = parcelRequire("88tPr");

var $iNkrR = parcelRequire("iNkrR");

var $f3gEZ = parcelRequire("f3gEZ");
function configureChains(defaultChains, providers, { batch = {
    multicall: {
        wait: 32
    }
}, pollingInterval = 4e3, rank, retryCount, retryDelay, stallTimeout } = {}) {
    if (!defaultChains.length) throw new Error("must have at least one chain");
    let chains = [];
    const httpUrls = {};
    const wsUrls = {};
    for (const chain of defaultChains){
        let configExists = false;
        for (const provider of providers){
            const apiConfig = provider(chain);
            if (!apiConfig) continue;
            configExists = true;
            if (!chains.some(({ id })=>id === chain.id)) chains = [
                ...chains,
                apiConfig.chain
            ];
            httpUrls[chain.id] = [
                ...httpUrls[chain.id] || [],
                ...apiConfig.rpcUrls.http
            ];
            if (apiConfig.rpcUrls.webSocket) wsUrls[chain.id] = [
                ...wsUrls[chain.id] || [],
                ...apiConfig.rpcUrls.webSocket
            ];
        }
        if (!configExists) throw new Error([
            `Could not find valid provider configuration for chain "${chain.name}".
`,
            "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.",
            "Read more: https://wagmi.sh/core/providers/jsonRpc"
        ].join("\n"));
    }
    return {
        chains: chains,
        publicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainHttpUrls = httpUrls[activeChain.id];
            if (!chainHttpUrls || !chainHttpUrls[0]) throw new Error(`No providers configured for chain "${activeChain.id}"`);
            const publicClient = (0, $83kyS.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $PaH4P.fallback)(chainHttpUrls.map((url)=>(0, $g69ST.http)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        },
        webSocketPublicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainWsUrls = wsUrls[activeChain.id];
            if (!chainWsUrls || !chainWsUrls[0]) return void 0;
            const publicClient = (0, $83kyS.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $PaH4P.fallback)(chainWsUrls.map((url)=>(0, $8tKwY.webSocket)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        }
    };
}
var ChainMismatchError = class extends Error {
    constructor({ activeChain, targetChain }){
        super(`Chain mismatch: Expected "${targetChain}", received "${activeChain}".`);
        this.name = "ChainMismatchError";
    }
};
var ChainNotConfiguredError = class extends Error {
    constructor({ chainId, connectorId }){
        super(`Chain "${chainId}" not configured${connectorId ? ` for connector "${connectorId}"` : ""}.`);
        this.name = "ChainNotConfigured";
    }
};
var ConnectorAlreadyConnectedError = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorAlreadyConnectedError";
        this.message = "Connector already connected";
    }
};
var ConfigChainsNotFound = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConfigChainsNotFound";
        this.message = "No chains were found on the wagmi config. Some functions that require a chain may not work.";
    }
};
var SwitchChainNotSupportedError = class extends Error {
    constructor({ connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        this.name = "SwitchChainNotSupportedError";
    }
};
// src/utils/deepEqual.ts
function deepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
// src/utils/deserialize.ts
var findAndReplace = (cacheRef, { find, replace })=>{
    if (cacheRef && find(cacheRef)) return replace(cacheRef);
    if (typeof cacheRef !== "object") return cacheRef;
    if (Array.isArray(cacheRef)) return cacheRef.map((item)=>findAndReplace(item, {
            find: find,
            replace: replace
        }));
    if (cacheRef instanceof Object) return Object.entries(cacheRef).reduce((curr, [key, value])=>({
            ...curr,
            [key]: findAndReplace(value, {
                find: find,
                replace: replace
            })
        }), {});
    return cacheRef;
};
function deserialize(cachedString) {
    const cache = JSON.parse(cachedString);
    const deserializedCacheWithBigInts = findAndReplace(cache, {
        find: (data)=>typeof data === "string" && data.startsWith("#bigint."),
        replace: (data)=>BigInt(data.replace("#bigint.", ""))
    });
    return deserializedCacheWithBigInts;
}
// src/utils/getParameters.ts
function getCallParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        blockNumber: args.blockNumber,
        blockTag: args.blockTag,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getSendTransactionParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getUnit(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $53GlG.weiUnits)[unit]);
}
// src/utils/serialize.ts
function getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
function getCutoff(array, value) {
    const { length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
function createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, getReferenceKey(keys, valueCutoff)) : `[ref=${getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function serialize(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, createReplacer((key, value_)=>{
        const value2 = typeof value_ === "bigint" ? `#bigint.${value_.toString()}` : value_;
        return replacer?.(key, value2) || value2;
    }, circularReplacer), indent ?? void 0);
}
// src/storage.ts
var noopStorage = {
    getItem: (_key)=>"",
    setItem: (_key, _value)=>null,
    removeItem: (_key)=>null
};
function createStorage({ deserialize: deserialize2 = deserialize, key: prefix = "wagmi", serialize: serialize2 = serialize, storage }) {
    return {
        ...storage,
        getItem: (key, defaultState = null)=>{
            const value = storage.getItem(`${prefix}.${key}`);
            try {
                return value ? deserialize2(value) : defaultState;
            } catch (error) {
                console.warn(error);
                return defaultState;
            }
        },
        setItem: (key, value)=>{
            if (value === null) storage.removeItem(`${prefix}.${key}`);
            else try {
                storage.setItem(`${prefix}.${key}`, serialize2(value));
            } catch (err) {
                console.error(err);
            }
        },
        removeItem: (key)=>storage.removeItem(`${prefix}.${key}`)
    };
}
// src/config.ts
var storeKey = "store";
var _isAutoConnecting, _lastUsedConnector, _addEffects, addEffects_fn;
var Config = class {
    constructor({ autoConnect = false, connectors = [
        new (0, $baiWq.InjectedConnector)()
    ], publicClient, storage = createStorage({
        storage: typeof window !== "undefined" ? window.localStorage : noopStorage
    }), logger = {
        warn: console.warn
    }, webSocketPublicClient }){
        (0, $l3rDK.__privateAdd)(this, _addEffects);
        this.publicClients = /* @__PURE__ */ new Map();
        this.webSocketPublicClients = /* @__PURE__ */ new Map();
        (0, $l3rDK.__privateAdd)(this, _isAutoConnecting, void 0);
        (0, $l3rDK.__privateAdd)(this, _lastUsedConnector, void 0);
        this.args = {
            autoConnect: autoConnect,
            connectors: connectors,
            logger: logger,
            publicClient: publicClient,
            storage: storage,
            webSocketPublicClient: webSocketPublicClient
        };
        let status = "disconnected";
        let chainId;
        if (autoConnect) try {
            const rawState = storage.getItem(storeKey);
            const data = rawState?.state?.data;
            status = data?.account ? "reconnecting" : "connecting";
            chainId = data?.chain?.id;
        } catch (_error) {}
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(storage));
        this.store = (0, $iNkrR.createStore)((0, $88tPr.subscribeWithSelector)((0, $88tPr.persist)(()=>({
                connectors: connectors_,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                status: status,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }), {
            name: storeKey,
            storage: storage,
            partialize: (state)=>({
                    ...autoConnect && {
                        data: {
                            account: state?.data?.account,
                            chain: state?.data?.chain
                        }
                    },
                    chains: state?.chains
                }),
            version: 2
        })));
        this.storage = storage;
        (0, $l3rDK.__privateSet)(this, _lastUsedConnector, storage?.getItem("wallet"));
        (0, $l3rDK.__privateMethod)(this, _addEffects, addEffects_fn).call(this);
        if (autoConnect && typeof window !== "undefined") setTimeout(async ()=>await this.autoConnect(), 0);
    }
    get chains() {
        return this.store.getState().chains;
    }
    get connectors() {
        return this.store.getState().connectors;
    }
    get connector() {
        return this.store.getState().connector;
    }
    get data() {
        return this.store.getState().data;
    }
    get error() {
        return this.store.getState().error;
    }
    get lastUsedChainId() {
        return this.data?.chain?.id;
    }
    get publicClient() {
        return this.store.getState().publicClient;
    }
    get status() {
        return this.store.getState().status;
    }
    get subscribe() {
        return this.store.subscribe;
    }
    get webSocketPublicClient() {
        return this.store.getState().webSocketPublicClient;
    }
    setState(updater) {
        const newState = typeof updater === "function" ? updater(this.store.getState()) : updater;
        this.store.setState(newState, true);
    }
    clearState() {
        this.setState((x)=>({
                ...x,
                chains: void 0,
                connector: void 0,
                data: void 0,
                error: void 0,
                status: "disconnected"
            }));
    }
    async destroy() {
        if (this.connector) await this.connector.disconnect?.();
        (0, $l3rDK.__privateSet)(this, _isAutoConnecting, false);
        this.clearState();
        this.store.destroy();
    }
    async autoConnect() {
        if ((0, $l3rDK.__privateGet)(this, _isAutoConnecting)) return;
        (0, $l3rDK.__privateSet)(this, _isAutoConnecting, true);
        this.setState((x)=>({
                ...x,
                status: x.data?.account ? "reconnecting" : "connecting"
            }));
        const sorted = (0, $l3rDK.__privateGet)(this, _lastUsedConnector) ? [
            ...this.connectors
        ].sort((x)=>x.id === (0, $l3rDK.__privateGet)(this, _lastUsedConnector) ? -1 : 1) : this.connectors;
        let connected = false;
        for (const connector of sorted){
            if (!connector.ready || !connector.isAuthorized) continue;
            const isAuthorized = await connector.isAuthorized();
            if (!isAuthorized) continue;
            const data = await connector.connect();
            this.setState((x)=>({
                    ...x,
                    connector: connector,
                    chains: connector?.chains,
                    data: data,
                    status: "connected"
                }));
            connected = true;
            break;
        }
        if (!connected) this.setState((x)=>({
                ...x,
                data: void 0,
                status: "disconnected"
            }));
        (0, $l3rDK.__privateSet)(this, _isAutoConnecting, false);
        return this.data;
    }
    setConnectors(connectors) {
        this.args = {
            ...this.args,
            connectors: connectors
        };
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(this.args.storage));
        this.setState((x)=>({
                ...x,
                connectors: connectors_
            }));
    }
    getPublicClient({ chainId } = {}) {
        let publicClient_ = this.publicClients.get(-1);
        if (publicClient_ && publicClient_?.chain.id === chainId) return publicClient_;
        publicClient_ = this.publicClients.get(chainId ?? -1);
        if (publicClient_) return publicClient_;
        const { publicClient } = this.args;
        publicClient_ = typeof publicClient === "function" ? publicClient({
            chainId: chainId
        }) : publicClient;
        this.publicClients.set(chainId ?? -1, publicClient_);
        return publicClient_;
    }
    setPublicClient(publicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            publicClient: publicClient
        };
        this.publicClients.clear();
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                })
            }));
    }
    getWebSocketPublicClient({ chainId } = {}) {
        let webSocketPublicClient_ = this.webSocketPublicClients.get(-1);
        if (webSocketPublicClient_ && webSocketPublicClient_?.chain.id === chainId) return webSocketPublicClient_;
        webSocketPublicClient_ = this.webSocketPublicClients.get(chainId ?? -1);
        if (webSocketPublicClient_) return webSocketPublicClient_;
        const { webSocketPublicClient } = this.args;
        webSocketPublicClient_ = typeof webSocketPublicClient === "function" ? webSocketPublicClient({
            chainId: chainId
        }) : webSocketPublicClient;
        if (webSocketPublicClient_) this.webSocketPublicClients.set(chainId ?? -1, webSocketPublicClient_);
        return webSocketPublicClient_;
    }
    setWebSocketPublicClient(webSocketPublicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            webSocketPublicClient: webSocketPublicClient
        };
        this.webSocketPublicClients.clear();
        this.setState((x)=>({
                ...x,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    }
    setLastUsedConnector(lastUsedConnector = null) {
        this.storage?.setItem("wallet", lastUsedConnector);
    }
};
_isAutoConnecting = new WeakMap();
_lastUsedConnector = new WeakMap();
_addEffects = new WeakSet();
addEffects_fn = function() {
    const onChange = (data)=>{
        this.setState((x)=>({
                ...x,
                data: {
                    ...x.data,
                    ...data
                }
            }));
    };
    const onDisconnect = ()=>{
        this.clearState();
    };
    const onError = (error)=>{
        this.setState((x)=>({
                ...x,
                error: error
            }));
    };
    this.store.subscribe(({ connector })=>connector, (connector, prevConnector)=>{
        prevConnector?.off?.("change", onChange);
        prevConnector?.off?.("disconnect", onDisconnect);
        prevConnector?.off?.("error", onError);
        if (!connector) return;
        connector.on?.("change", onChange);
        connector.on?.("disconnect", onDisconnect);
        connector.on?.("error", onError);
    });
    const { publicClient, webSocketPublicClient } = this.args;
    const subscribePublicClient = typeof publicClient === "function";
    const subscribeWebSocketPublicClient = typeof webSocketPublicClient === "function";
    if (subscribePublicClient || subscribeWebSocketPublicClient) this.store.subscribe(({ data })=>data?.chain?.id, (chainId)=>{
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    });
};
var config;
function createConfig(args) {
    const config_ = new Config(args);
    config = config_;
    return config_;
}
function getConfig() {
    if (!config) throw new Error("No wagmi config found. Ensure you have set up a config: https://wagmi.sh/react/config");
    return config;
}
// src/actions/accounts/connect.ts
async function connect({ chainId, connector }) {
    const config2 = getConfig();
    const activeConnector = config2.connector;
    if (activeConnector && connector.id === activeConnector.id) throw new ConnectorAlreadyConnectedError();
    try {
        config2.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        const data = await connector.connect({
            chainId: chainId
        });
        config2.setLastUsedConnector(connector.id);
        config2.setState((x)=>({
                ...x,
                connector: connector,
                chains: connector?.chains,
                data: data,
                status: "connected"
            }));
        config2.storage.setItem("connected", true);
        return {
            ...data,
            connector: connector
        };
    } catch (err) {
        config2.setState((x)=>{
            return {
                ...x,
                status: x.connector ? "connected" : "disconnected"
            };
        });
        throw err;
    }
}
// src/actions/accounts/disconnect.ts
async function disconnect() {
    const config2 = getConfig();
    if (config2.connector) await config2.connector.disconnect();
    config2.clearState();
    config2.storage.removeItem("connected");
}
// src/constants/abis.ts
var erc20ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc20ABI_bytes32 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc721ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
var erc4626ABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
async function fetchToken({ address, chainId, formatUnits: unit = 18 }) {
    async function fetchToken_({ abi }) {
        const erc20Config = {
            address: address,
            abi: abi,
            chainId: chainId
        };
        const [decimals, name, symbol, totalSupply] = await readContracts({
            allowFailure: false,
            contracts: [
                {
                    ...erc20Config,
                    functionName: "decimals"
                },
                {
                    ...erc20Config,
                    functionName: "name"
                },
                {
                    ...erc20Config,
                    functionName: "symbol"
                },
                {
                    ...erc20Config,
                    functionName: "totalSupply"
                }
            ]
        });
        return {
            address: address,
            decimals: decimals,
            name: name,
            symbol: symbol,
            totalSupply: {
                formatted: (0, $fDKcx.formatUnits)(totalSupply, getUnit(unit)),
                value: totalSupply
            }
        };
    }
    try {
        return await fetchToken_({
            abi: erc20ABI
        });
    } catch (err) {
        if (err instanceof (0, $34q4g.ContractFunctionExecutionError)) {
            const { name, symbol, ...rest } = await fetchToken_({
                abi: erc20ABI_bytes32
            });
            return {
                name: (0, $8hd5S.hexToString)((0, $bTOZ4.trim)(name, {
                    dir: "right"
                })),
                symbol: (0, $8hd5S.hexToString)((0, $bTOZ4.trim)(symbol, {
                    dir: "right"
                })),
                ...rest
            };
        }
        throw err;
    }
}
// src/actions/viem/getPublicClient.ts
function getPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getPublicClient({
        chainId: chainId
    }) || config2.publicClient;
    return config2.publicClient;
}
// src/actions/viem/getWalletClient.ts
async function getWalletClient({ chainId } = {}) {
    const config2 = getConfig();
    const walletClient = await config2.connector?.getWalletClient?.({
        chainId: chainId
    }) || null;
    return walletClient;
}
// src/actions/viem/getWebSocketPublicClient.ts
function getWebSocketPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getWebSocketPublicClient({
        chainId: chainId
    }) || config2.webSocketPublicClient;
    return config2.webSocketPublicClient;
}
// src/actions/viem/watchPublicClient.ts
function watchPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getPublicClient(args));
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return unsubscribe;
}
function watchWalletClient({ chainId }, callback) {
    const config2 = getConfig();
    const handleChange = async ({ chainId: chainId_ })=>{
        if (chainId && chainId_ && chainId !== chainId_) return;
        const walletClient = await getWalletClient({
            chainId: chainId
        });
        if (!getConfig().connector) return callback(null);
        return callback(walletClient);
    };
    const unsubscribe = config2.subscribe(({ data, connector })=>({
            account: data?.account,
            chainId: data?.chain?.id,
            connector: connector
        }), handleChange, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return unsubscribe;
}
// src/actions/viem/watchWebSocketPublicClient.ts
function watchWebSocketPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getWebSocketPublicClient(args));
    const unsubscribe = config2.subscribe(({ webSocketPublicClient })=>webSocketPublicClient, handleChange);
    return unsubscribe;
}
// src/actions/contracts/prepareWriteContract.ts
async function prepareWriteContract({ abi, address, args, chainId, dataSuffix, functionName, walletClient: walletClient_, ...config2 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const { account, accessList, blockNumber, blockTag, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, value } = getCallParameters(config2);
    const { result, request } = await publicClient.simulateContract({
        abi: abi,
        address: address,
        functionName: functionName,
        args: args,
        account: account || walletClient.account,
        accessList: accessList,
        blockNumber: blockNumber,
        blockTag: blockTag,
        dataSuffix: dataSuffix,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        value: value
    });
    const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === functionName);
    return {
        mode: "prepared",
        request: {
            ...request,
            abi: minimizedAbi,
            chainId: chainId
        },
        result: result
    };
}
function getContract({ address, abi, chainId, walletClient }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return (0, $5BBzT.getContract)({
        address: address,
        abi: abi,
        publicClient: publicClient,
        walletClient: walletClient
    });
}
// src/actions/contracts/multicall.ts
async function multicall({ chainId, contracts, blockNumber, blockTag, ...args }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (!publicClient.chains) throw new ConfigChainsNotFound();
    if (chainId && publicClient.chain.id !== chainId) throw new ChainNotConfiguredError({
        chainId: chainId
    });
    return publicClient.multicall({
        allowFailure: args.allowFailure ?? true,
        blockNumber: blockNumber,
        blockTag: blockTag,
        contracts: contracts
    });
}
// src/actions/contracts/readContract.ts
async function readContract({ address, account, chainId, abi, args, functionName, blockNumber, blockTag }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.readContract({
        abi: abi,
        address: address,
        account: account,
        functionName: functionName,
        args: args,
        blockNumber: blockNumber,
        blockTag: blockTag
    });
}
async function readContracts({ contracts, blockNumber, blockTag, ...args }) {
    const { allowFailure = true } = args;
    try {
        const publicClient = getPublicClient();
        const contractsByChainId = contracts.reduce((contracts2, contract, index)=>{
            const chainId = contract.chainId ?? publicClient.chain.id;
            return {
                ...contracts2,
                [chainId]: [
                    ...contracts2[chainId] || [],
                    {
                        contract: contract,
                        index: index
                    }
                ]
            };
        }, {});
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts2])=>multicall({
                    allowFailure: allowFailure,
                    chainId: parseInt(chainId),
                    contracts: contracts2.map(({ contract })=>contract),
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts2)=>contracts2.map(({ index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (err) {
        if (err instanceof (0, $34q4g.ContractFunctionExecutionError)) throw err;
        const promises = ()=>contracts.map((contract)=>readContract({
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: void 0,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}
function watchContractEvent({ address, abi, chainId, eventName }, callback) {
    let unwatch;
    const watchEvent = async ()=>{
        if (unwatch) unwatch();
        const publicClient = getWebSocketPublicClient({
            chainId: chainId
        }) || getPublicClient({
            chainId: chainId
        });
        unwatch = publicClient.watchContractEvent({
            address: address,
            abi: abi,
            eventName: eventName,
            onLogs: callback
        });
    };
    watchEvent();
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), watchEvent, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return ()=>{
        unwatch?.();
        unsubscribe();
    };
}
function watchBlockNumber(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchBlockNumber({
            onBlockNumber: callback,
            emitOnBegin: true,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    if (args.listen) createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (args.listen && !args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchMulticall.ts
function watchMulticall(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await multicall(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContract.ts
function watchReadContract(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContract(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContracts.ts
function watchReadContracts(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContracts(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/writeContract.ts
async function writeContract(config2) {
    const walletClient = await getWalletClient({
        chainId: config2.chainId
    });
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    if (config2.chainId) assertActiveChain({
        chainId: config2.chainId
    });
    let request;
    if (config2.mode === "prepared") request = config2.request;
    else {
        const { chainId: _, mode: __, ...args } = config2;
        const res = await prepareWriteContract(args);
        request = res.request;
    }
    const hash = await walletClient.writeContract({
        ...request,
        chain: config2.chainId ? {
            id: config2.chainId
        } : null
    });
    return {
        hash: hash
    };
}
// src/actions/accounts/fetchBalance.ts
async function fetchBalance({ address, chainId, formatUnits: unit, token }) {
    const config2 = getConfig();
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (token) {
        const fetchContractBalance = async ({ abi })=>{
            const erc20Config = {
                abi: abi,
                address: token,
                chainId: chainId
            };
            const [value2, decimals, symbol] = await readContracts({
                allowFailure: false,
                contracts: [
                    {
                        ...erc20Config,
                        functionName: "balanceOf",
                        args: [
                            address
                        ]
                    },
                    {
                        ...erc20Config,
                        functionName: "decimals"
                    },
                    {
                        ...erc20Config,
                        functionName: "symbol"
                    }
                ]
            });
            return {
                decimals: decimals,
                formatted: (0, $fDKcx.formatUnits)(value2 ?? "0", getUnit(unit ?? decimals)),
                symbol: symbol,
                value: value2
            };
        };
        try {
            return await fetchContractBalance({
                abi: erc20ABI
            });
        } catch (err) {
            if (err instanceof (0, $34q4g.ContractFunctionExecutionError)) {
                const { symbol, ...rest } = await fetchContractBalance({
                    abi: erc20ABI_bytes32
                });
                return {
                    symbol: (0, $8hd5S.hexToString)((0, $bTOZ4.trim)(symbol, {
                        dir: "right"
                    })),
                    ...rest
                };
            }
            throw err;
        }
    }
    const chains = [
        ...config2.publicClient.chains || [],
        ...config2.chains ?? []
    ];
    const value = await publicClient.getBalance({
        address: address
    });
    const chain = chains.find((x)=>x.id === publicClient.chain.id);
    return {
        decimals: chain?.nativeCurrency.decimals ?? 18,
        formatted: (0, $fDKcx.formatUnits)(value ?? "0", getUnit(unit ?? 18)),
        symbol: chain?.nativeCurrency.symbol ?? "ETH",
        value: value
    };
}
// src/actions/accounts/getAccount.ts
function getAccount() {
    const { data, connector, status } = getConfig();
    switch(status){
        case "connected":
            return {
                address: data?.account,
                connector: connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: !!data?.account,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: void 0,
                connector: void 0,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}
// src/actions/accounts/getNetwork.ts
function getNetwork() {
    const config2 = getConfig();
    const chainId = config2.data?.chain?.id;
    const activeChains = config2.chains ?? [];
    const activeChain = [
        ...config2.publicClient?.chains || [],
        ...activeChains
    ].find((x)=>x.id === chainId) ?? {
        id: chainId,
        name: `Chain ${chainId}`,
        network: `${chainId}`,
        nativeCurrency: {
            name: "Ether",
            decimals: 18,
            symbol: "ETH"
        },
        rpcUrls: {
            default: {
                http: [
                    ""
                ]
            },
            public: {
                http: [
                    ""
                ]
            }
        }
    };
    return {
        chain: chainId ? {
            ...activeChain,
            ...config2.data?.chain,
            id: chainId
        } : void 0,
        chains: activeChains
    };
}
// src/actions/accounts/signMessage.ts
async function signMessage(args) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    return await walletClient.signMessage({
        message: args.message
    });
}
// src/actions/accounts/signTypedData.ts
async function signTypedData({ domain, message, primaryType, types }) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    const { chainId } = domain;
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    return walletClient.signTypedData({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
}
// src/actions/accounts/switchNetwork.ts
async function switchNetwork({ chainId }) {
    const { connector } = getConfig();
    if (!connector) throw new (0, $gAovx.ConnectorNotFoundError)();
    if (!connector.switchChain) throw new SwitchChainNotSupportedError({
        connector: connector
    });
    return connector.switchChain(chainId);
}
function watchAccount(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getAccount());
    const unsubscribe = config2.subscribe(({ data, connector, status })=>selector({
            address: data?.account,
            connector: connector,
            status: status
        }), handleChange, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return unsubscribe;
}
function watchNetwork(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getNetwork());
    const unsubscribe = config2.subscribe(({ data, chains })=>selector({
            chainId: data?.chain?.id,
            chains: chains
        }), handleChange, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return unsubscribe;
}

async function fetchEnsAddress({ chainId, name }) {
    const { normalize } = await (parcelRequire("2a1GB"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const address = await publicClient.getEnsAddress({
        name: normalize(name)
    });
    try {
        if (address === "0x0000000000000000000000000000000000000000") return null;
        return address ? (0, $kRozl.getAddress)(address) : null;
    } catch (_error) {
        return null;
    }
}

// src/actions/ens/fetchEnsAvatar.ts
async function fetchEnsAvatar({ name, chainId }) {
    const { normalize } = await (parcelRequire("2a1GB"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const avatar = await publicClient.getEnsAvatar({
        name: normalize(name)
    });
    return avatar;
}
async function fetchEnsName({ address, chainId }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getEnsName({
        address: (0, $kRozl.getAddress)(address)
    });
}

// src/actions/ens/fetchEnsResolver.ts
async function fetchEnsResolver({ chainId, name }) {
    const { normalize } = await (parcelRequire("2a1GB"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const resolver = await publicClient.getEnsResolver({
        name: normalize(name)
    });
    return resolver;
}
// src/actions/network-status/fetchBlockNumber.ts
async function fetchBlockNumber({ chainId } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const blockNumber = await publicClient.getBlockNumber();
    return blockNumber;
}
async function fetchFeeData({ chainId, formatUnits: units = "gwei" } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const block = await publicClient.getBlock();
    let gasPrice = null;
    try {
        gasPrice = await publicClient.getGasPrice();
    } catch  {}
    let lastBaseFeePerGas = null;
    let maxFeePerGas = null;
    let maxPriorityFeePerGas = null;
    if (block?.baseFeePerGas) {
        lastBaseFeePerGas = block.baseFeePerGas;
        maxPriorityFeePerGas = (0, $lvNQN.parseGwei)("1");
        maxFeePerGas = block.baseFeePerGas * 2n + maxPriorityFeePerGas;
    }
    const unit = getUnit(units);
    const formatted = {
        gasPrice: gasPrice ? (0, $fDKcx.formatUnits)(gasPrice, unit) : null,
        maxFeePerGas: maxFeePerGas ? (0, $fDKcx.formatUnits)(maxFeePerGas, unit) : null,
        maxPriorityFeePerGas: maxPriorityFeePerGas ? (0, $fDKcx.formatUnits)(maxPriorityFeePerGas, unit) : null
    };
    return {
        lastBaseFeePerGas: lastBaseFeePerGas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        formatted: formatted
    };
}
// src/actions/transactions/fetchTransaction.ts
async function fetchTransaction({ chainId, hash }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getTransaction({
        hash: hash
    });
}
async function prepareSendTransaction({ accessList, account, chainId, data, gas: gas_, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to: to_, value, walletClient: walletClient_ }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const to = (to_ && !(0, $fCd4Y.isAddress)(to_) ? await fetchEnsAddress({
        name: to_
    }) : to_) || void 0;
    if (to && !(0, $fCd4Y.isAddress)(to)) throw new Error("Invalid address");
    const gas = typeof gas_ === "undefined" ? await publicClient.estimateGas({
        accessList: accessList,
        account: walletClient.account,
        data: data,
        gas: gas_ ?? void 0,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    }) : gas_ || void 0;
    return {
        accessList: accessList,
        account: account,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: "prepared",
        nonce: nonce,
        to: to,
        value: value,
        ...chainId ? {
            chainId: chainId
        } : {}
    };
}
// src/actions/transactions/sendTransaction.ts
async function sendTransaction({ accessList, account, chainId, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, mode, nonce, to, value }) {
    const walletClient = await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $gAovx.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    let args;
    if (mode === "prepared") args = {
        account: account,
        accessList: accessList,
        chain: null,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    };
    else args = await prepareSendTransaction({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas || null,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    });
    const hash = await walletClient.sendTransaction({
        ...args,
        chain: chainId ? {
            id: chainId
        } : null
    });
    return {
        hash: hash
    };
}
async function waitForTransaction({ chainId, confirmations = 1, hash, onReplaced, timeout = 0 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const receipt = await publicClient.waitForTransactionReceipt({
        hash: hash,
        confirmations: confirmations,
        onReplaced: onReplaced,
        timeout: timeout
    });
    if (receipt.status === "reverted") {
        const txn = await publicClient.getTransaction({
            hash: receipt.transactionHash
        });
        const code = await publicClient.call({
            ...txn,
            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : void 0,
            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : void 0,
            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : void 0
        });
        const reason = (0, $8hd5S.hexToString)(`0x${code.substring(138)}`);
        throw new Error(reason);
    }
    return receipt;
}
function watchPendingTransactions(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchPendingTransactions({
            onTransactions: callback,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (!args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $f3gEZ.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/utils/assertActiveChain.ts
function assertActiveChain({ chainId }) {
    const { chain: activeChain, chains } = getNetwork();
    const activeChainId = activeChain?.id;
    if (activeChainId && chainId !== activeChainId) throw new ChainMismatchError({
        activeChain: chains.find((x)=>x.id === activeChainId)?.name ?? `Chain ${activeChainId}`,
        targetChain: chains.find((x)=>x.id === chainId)?.name ?? `Chain ${chainId}`
    });
}

});
parcelRegister("baiWq", function(module, exports) {

$parcel$export(module.exports, "InjectedConnector", () => $820f523e96bfde8a$export$2180bbd5f43a00b6);

var $gAovx = parcelRequire("gAovx");

var $8oV45 = parcelRequire("8oV45");

var $ltFnW = parcelRequire("ltFnW");

var $kRozl = parcelRequire("kRozl");
var $1mQc6 = parcelRequire("1mQc6");
var $dS1Df = parcelRequire("dS1Df");
var $9kZsO = parcelRequire("9kZsO");
var $hKqyW = parcelRequire("hKqyW");
// src/utils/getInjectedName.ts
function $820f523e96bfde8a$var$getInjectedName(ethereum) {
    if (!ethereum) return "Injected";
    const getName = (provider)=>{
        if (provider.isApexWallet) return "Apex Wallet";
        if (provider.isAvalanche) return "Core Wallet";
        if (provider.isBackpack) return "Backpack";
        if (provider.isBifrost) return "Bifrost Wallet";
        if (provider.isBitKeep) return "BitKeep";
        if (provider.isBitski) return "Bitski";
        if (provider.isBlockWallet) return "BlockWallet";
        if (provider.isBraveWallet) return "Brave Wallet";
        if (provider.isCoin98) return "Coin98 Wallet";
        if (provider.isCoinbaseWallet) return "Coinbase Wallet";
        if (provider.isDawn) return "Dawn Wallet";
        if (provider.isDefiant) return "Defiant";
        if (provider.isDesig) return "Desig Wallet";
        if (provider.isEnkrypt) return "Enkrypt";
        if (provider.isExodus) return "Exodus";
        if (provider.isFordefi) return "Fordefi";
        if (provider.isFrame) return "Frame";
        if (provider.isFrontier) return "Frontier Wallet";
        if (provider.isGamestop) return "GameStop Wallet";
        if (provider.isHaqqWallet) return "HAQQ Wallet";
        if (provider.isHyperPay) return "HyperPay Wallet";
        if (provider.isImToken) return "ImToken";
        if (provider.isHaloWallet) return "Halo Wallet";
        if (provider.isKuCoinWallet) return "KuCoin Wallet";
        if (provider.isMathWallet) return "MathWallet";
        if (provider.isNovaWallet) return "Nova Wallet";
        if (provider.isOkxWallet || provider.isOKExWallet) return "OKX Wallet";
        if (provider.isOktoWallet) return "Okto Wallet";
        if (provider.isOneInchIOSWallet || provider.isOneInchAndroidWallet) return "1inch Wallet";
        if (provider.isOneKey) return "OneKey Wallet";
        if (provider.isOpera) return "Opera";
        if (provider.isPhantom) return "Phantom";
        if (provider.isPortal) return "Ripio Portal";
        if (provider.isRabby) return "Rabby Wallet";
        if (provider.isRainbow) return "Rainbow";
        if (provider.isSafePal) return "SafePal Wallet";
        if (provider.isStatus) return "Status";
        if (provider.isSubWallet) return "SubWallet";
        if (provider.isTalisman) return "Talisman";
        if (provider.isTally) return "Taho";
        if (provider.isTokenPocket) return "TokenPocket";
        if (provider.isTokenary) return "Tokenary";
        if (provider.isTrust || provider.isTrustWallet) return "Trust Wallet";
        if (provider.isTTWallet) return "TTWallet";
        if (provider.isXDEFI) return "XDEFI Wallet";
        if (provider.isZeal) return "Zeal";
        if (provider.isZerion) return "Zerion";
        if (provider.isMetaMask) return "MetaMask";
    };
    if (ethereum.providers?.length) {
        const nameSet = /* @__PURE__ */ new Set();
        let unknownCount = 1;
        for (const provider of ethereum.providers){
            let name = getName(provider);
            if (!name) {
                name = `Unknown Wallet #${unknownCount}`;
                unknownCount += 1;
            }
            nameSet.add(name);
        }
        const names = [
            ...nameSet
        ];
        if (names.length) return names;
        return names[0] ?? "Injected";
    }
    return getName(ethereum) ?? "Injected";
}
// src/injected.ts
var $820f523e96bfde8a$var$_provider;
var $820f523e96bfde8a$export$2180bbd5f43a00b6 = class extends (0, $ltFnW.Connector) {
    constructor({ chains: chains, options: options_ } = {}){
        const options = {
            shimDisconnect: true,
            getProvider () {
                if (typeof window === "undefined") return;
                const ethereum = window.ethereum;
                if (ethereum?.providers && ethereum.providers.length > 0) return ethereum.providers[0];
                return ethereum;
            },
            ...options_
        };
        super({
            chains: chains,
            options: options
        });
        this.id = "injected";
        (0, $ltFnW.__privateAdd)(this, $820f523e96bfde8a$var$_provider, void 0);
        this.shimDisconnectKey = `${this.id}.shimDisconnect`;
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $kRozl.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = (0, $8oV45.normalizeChainId)(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = async (error)=>{
            if (error.code === 1013) {
                const provider = await this.getProvider();
                if (provider) {
                    const isAuthorized = await this.getAccount();
                    if (isAuthorized) return;
                }
            }
            this.emit("disconnect");
            if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
        };
        const provider = options.getProvider();
        if (typeof options.name === "string") this.name = options.name;
        else if (provider) {
            const detectedName = $820f523e96bfde8a$var$getInjectedName(provider);
            if (options.name) this.name = options.name(detectedName);
            else if (typeof detectedName === "string") this.name = detectedName;
            else this.name = detectedName[0];
        } else this.name = "Injected";
        this.ready = !!provider;
    }
    async connect({ chainId: chainId } = {}) {
        try {
            const provider = await this.getProvider();
            if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
            if (provider.on) {
                provider.on("accountsChanged", this.onAccountsChanged);
                provider.on("chainChanged", this.onChainChanged);
                provider.on("disconnect", this.onDisconnect);
            }
            this.emit("message", {
                type: "connecting"
            });
            const accounts = await provider.request({
                method: "eth_requestAccounts"
            });
            const account = (0, $kRozl.getAddress)(accounts[0]);
            let id = await this.getChainId();
            let unsupported = this.isChainUnsupported(id);
            if (chainId && id !== chainId) {
                const chain = await this.switchChain(chainId);
                id = chain.id;
                unsupported = this.isChainUnsupported(id);
            }
            if (this.options.shimDisconnect) this.storage?.setItem(this.shimDisconnectKey, true);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (this.isUserRejectedRequestError(error)) throw new (0, $1mQc6.UserRejectedRequestError)(error);
            if (error.code === -32002) throw new (0, $1mQc6.ResourceUnavailableRpcError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        if (!provider?.removeListener) return;
        provider.removeListener("accountsChanged", this.onAccountsChanged);
        provider.removeListener("chainChanged", this.onChainChanged);
        provider.removeListener("disconnect", this.onDisconnect);
        if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
    }
    async getAccount() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
        const accounts = await provider.request({
            method: "eth_accounts"
        });
        return (0, $kRozl.getAddress)(accounts[0]);
    }
    async getChainId() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
        return provider.request({
            method: "eth_chainId"
        }).then((0, $8oV45.normalizeChainId));
    }
    async getProvider() {
        const provider = this.options.getProvider();
        if (provider) (0, $ltFnW.__privateSet)(this, $820f523e96bfde8a$var$_provider, provider);
        return (0, $ltFnW.__privateGet)(this, $820f523e96bfde8a$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider(),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $dS1Df.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $9kZsO.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            if (this.options.shimDisconnect && !this.storage?.getItem(this.shimDisconnectKey)) return false;
            const provider = await this.getProvider();
            if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
            const account = await this.getAccount();
            return !!account;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
        const id = (0, $hKqyW.numberToHex)(chainId);
        try {
            await Promise.all([
                provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: id
                        }
                    ]
                }),
                new Promise((res)=>this.on("change", ({ chain: chain })=>{
                        if (chain?.id === chainId) res();
                    }))
            ]);
            return this.chains.find((x)=>x.id === chainId) ?? {
                id: chainId,
                name: `Chain ${id}`,
                network: `${id}`,
                nativeCurrency: {
                    name: "Ether",
                    decimals: 18,
                    symbol: "ETH"
                },
                rpcUrls: {
                    default: {
                        http: [
                            ""
                        ]
                    },
                    public: {
                        http: [
                            ""
                        ]
                    }
                }
            };
        } catch (error) {
            const chain = this.chains.find((x)=>x.id === chainId);
            if (!chain) throw new (0, $gAovx.ChainNotConfiguredForConnectorError)({
                chainId: chainId,
                connectorId: this.id
            });
            if (error.code === 4902 || error?.data?.originalError?.code === 4902) try {
                await provider.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: id,
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                chain.rpcUrls.public?.http[0] ?? ""
                            ],
                            blockExplorerUrls: this.getBlockExplorerUrls(chain)
                        }
                    ]
                });
                const currentChainId = await this.getChainId();
                if (currentChainId !== chainId) throw new (0, $1mQc6.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                return chain;
            } catch (error2) {
                throw new (0, $1mQc6.UserRejectedRequestError)(error2);
            }
            if (this.isUserRejectedRequestError(error)) throw new (0, $1mQc6.UserRejectedRequestError)(error);
            throw new (0, $1mQc6.SwitchChainError)(error);
        }
    }
    async watchAsset({ address: address, decimals: decimals = 18, image: image, symbol: symbol }) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $gAovx.ConnectorNotFoundError)();
        return provider.request({
            method: "wallet_watchAsset",
            params: {
                type: "ERC20",
                options: {
                    address: address,
                    decimals: decimals,
                    image: image,
                    symbol: symbol
                }
            }
        });
    }
    isUserRejectedRequestError(error) {
        return error.code === 4001;
    }
};
$820f523e96bfde8a$var$_provider = new WeakMap();

});
parcelRegister("gAovx", function(module, exports) {

$parcel$export(module.exports, "ChainNotConfiguredForConnectorError", () => $c13304da80e6fee7$export$9e27fc4704f8e4c3);
$parcel$export(module.exports, "ConnectorNotFoundError", () => $c13304da80e6fee7$export$9f8a797207d6544e);
// src/errors.ts
var $c13304da80e6fee7$export$9e27fc4704f8e4c3 = class extends Error {
    constructor({ chainId: chainId, connectorId: connectorId }){
        super(`Chain "${chainId}" not configured for connector "${connectorId}".`);
        this.name = "ChainNotConfiguredForConnectorError";
    }
};
var $c13304da80e6fee7$export$9f8a797207d6544e = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorNotFoundError";
        this.message = "Connector not found";
    }
};

});

parcelRegister("8oV45", function(module, exports) {

$parcel$export(module.exports, "normalizeChainId", () => $61dcd4851b42d96f$export$723927690c88894d);
// src/utils/normalizeChainId.ts
function $61dcd4851b42d96f$export$723927690c88894d(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if (typeof chainId === "bigint") return Number(chainId);
    return chainId;
}

});

parcelRegister("ltFnW", function(module, exports) {

$parcel$export(module.exports, "__privateGet", () => $fa2c689f95a768d4$export$18a094aefa070634);
$parcel$export(module.exports, "__privateAdd", () => $fa2c689f95a768d4$export$addf369becd23283);
$parcel$export(module.exports, "__privateSet", () => $fa2c689f95a768d4$export$42432efe6614d3b4);
$parcel$export(module.exports, "__privateMethod", () => $fa2c689f95a768d4$export$fa92d15b718fce20);
$parcel$export(module.exports, "Connector", () => $fa2c689f95a768d4$export$b2278035370d6017);

var $3vRz3 = parcelRequire("3vRz3");

var $kqytL = parcelRequire("kqytL");
var $gQr7o = parcelRequire("gQr7o");
var $fa2c689f95a768d4$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $fa2c689f95a768d4$export$18a094aefa070634 = (obj, member, getter)=>{
    $fa2c689f95a768d4$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $fa2c689f95a768d4$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $fa2c689f95a768d4$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $fa2c689f95a768d4$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $fa2c689f95a768d4$export$fa92d15b718fce20 = (obj, member, method)=>{
    $fa2c689f95a768d4$var$__accessCheck(obj, member, "access private method");
    return method;
};
var $fa2c689f95a768d4$export$b2278035370d6017 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor({ chains: chains = [
        (0, $kqytL.mainnet),
        (0, $gQr7o.goerli)
    ], options: options }){
        super();
        this.chains = chains;
        this.options = options;
    }
    getBlockExplorerUrls(chain) {
        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
        if (blockExplorer) return [
            blockExplorer.url,
            ...Object.values(blockExplorers).map((x)=>x.url)
        ];
    }
    isChainUnsupported(chainId) {
        return !this.chains.some((x)=>x.id === chainId);
    }
    setStorage(storage) {
        this.storage = storage;
    }
};

});
parcelRegister("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("kqytL", function(module, exports) {

$parcel$export(module.exports, "mainnet", () => $edf0fb31db254ed8$export$536d3e0d2c7baf54);

var $foFRw = parcelRequire("foFRw");
const $edf0fb31db254ed8$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $foFRw.defineChain)({
    id: 1,
    network: "homestead",
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        },
        public: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
            blockCreated: 16966585
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});

});
parcelRegister("foFRw", function(module, exports) {

$parcel$export(module.exports, "defineChain", () => $b35991e63be05bbf$export$b6380ff64616a4fb);
function $b35991e63be05bbf$export$b6380ff64616a4fb(chain, config = {}) {
    const { fees: fees = chain.fees, formatters: formatters = chain.formatters, serializers: serializers = chain.serializers } = config;
    return {
        ...chain,
        fees: fees,
        formatters: formatters,
        serializers: serializers
    };
}

});


parcelRegister("gQr7o", function(module, exports) {

$parcel$export(module.exports, "goerli", () => $c43689c63af9ee93$export$50b37201a1017e1e);

var $foFRw = parcelRequire("foFRw");
const $c43689c63af9ee93$export$50b37201a1017e1e = /*#__PURE__*/ (0, $foFRw.defineChain)({
    id: 5,
    network: "goerli",
    name: "Goerli",
    nativeCurrency: {
        name: "Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-goerli.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        },
        public: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0x56522D00C410a43BFfDF00a9A569489297385790",
            blockCreated: 8765204
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 6507670
        }
    },
    testnet: true
});

});


parcelRegister("kRozl", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $f2fbd0d036434097$export$9ff46e8f6df13548);
$parcel$export(module.exports, "getAddress", () => $f2fbd0d036434097$export$88411125f012957a);

var $2VOm9 = parcelRequire("2VOm9");

var $9sHEt = parcelRequire("9sHEt");

var $cq8a0 = parcelRequire("cq8a0");

var $fCd4Y = parcelRequire("fCd4Y");
function $f2fbd0d036434097$export$9ff46e8f6df13548(address_, chainId) {
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $cq8a0.keccak256)((0, $9sHEt.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    return `0x${address.join("")}`;
}
function $f2fbd0d036434097$export$88411125f012957a(address, chainId) {
    if (!(0, $fCd4Y.isAddress)(address)) throw new (0, $2VOm9.InvalidAddressError)({
        address: address
    });
    return $f2fbd0d036434097$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("2VOm9", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $2227f75a512f376e$export$66c44d927ffead98);

var $hRZHI = parcelRequire("hRZHI");
class $2227f75a512f376e$export$66c44d927ffead98 extends (0, $hRZHI.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAddressError"
        });
    }
}

});
parcelRegister("hRZHI", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $d027400e6bc61e16$export$a490eb03cb7a0a5e);

var $k9Ckd = parcelRequire("k9Ckd");
class $d027400e6bc61e16$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ViemError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $k9Ckd.getVersion)()
        });
        const details = args.cause instanceof $d027400e6bc61e16$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $d027400e6bc61e16$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}.html${args.docsSlug ? `#${args.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $d027400e6bc61e16$var$walk(this, fn);
    }
}
function $d027400e6bc61e16$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $d027400e6bc61e16$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("k9Ckd", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $eac2607b351377b0$export$b7fbffef12272e40);
$parcel$export(module.exports, "getUrl", () => $eac2607b351377b0$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getVersion", () => $eac2607b351377b0$export$c506eb22e615ba4a);

var $gK3el = parcelRequire("gK3el");
const $eac2607b351377b0$export$b7fbffef12272e40 = (address)=>address;
const $eac2607b351377b0$export$94df0e59ebebf4a7 = (url)=>url;
const $eac2607b351377b0$export$c506eb22e615ba4a = ()=>`viem@${0, $gK3el.version}`;

});
parcelRegister("gK3el", function(module, exports) {

$parcel$export(module.exports, "version", () => $c30372b5e7ea11e7$export$83d89fbfd8236492);
const $c30372b5e7ea11e7$export$83d89fbfd8236492 = "1.21.3";

});




parcelRegister("9sHEt", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $6e3896ec657dc96d$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $6e3896ec657dc96d$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $6e3896ec657dc96d$export$c8dd6bc66a63753c);

var $hRZHI = parcelRequire("hRZHI");

var $01CEa = parcelRequire("01CEa");

var $bvbVr = parcelRequire("bvbVr");

var $8hd5S = parcelRequire("8hd5S");

var $hKqyW = parcelRequire("hKqyW");
const $6e3896ec657dc96d$var$encoder = /*#__PURE__*/ new TextEncoder();
function $6e3896ec657dc96d$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $6e3896ec657dc96d$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $6e3896ec657dc96d$export$771517697a68241(value, opts);
    if ((0, $01CEa.isHex)(value)) return $6e3896ec657dc96d$export$31c96b9df38bc8d4(value, opts);
    return $6e3896ec657dc96d$export$c8dd6bc66a63753c(value, opts);
}
function $6e3896ec657dc96d$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $8hd5S.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $bvbVr.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $6e3896ec657dc96d$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $6e3896ec657dc96d$var$charCodeToBase16(char) {
    if (char >= $6e3896ec657dc96d$var$charCodeMap.zero && char <= $6e3896ec657dc96d$var$charCodeMap.nine) return char - $6e3896ec657dc96d$var$charCodeMap.zero;
    if (char >= $6e3896ec657dc96d$var$charCodeMap.A && char <= $6e3896ec657dc96d$var$charCodeMap.F) return char - ($6e3896ec657dc96d$var$charCodeMap.A - 10);
    if (char >= $6e3896ec657dc96d$var$charCodeMap.a && char <= $6e3896ec657dc96d$var$charCodeMap.f) return char - ($6e3896ec657dc96d$var$charCodeMap.a - 10);
    return undefined;
}
function $6e3896ec657dc96d$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $8hd5S.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $bvbVr.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $6e3896ec657dc96d$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $6e3896ec657dc96d$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $hRZHI.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $6e3896ec657dc96d$export$49ad9be85c347998(value, opts) {
    const hex = (0, $hKqyW.numberToHex)(value, opts);
    return $6e3896ec657dc96d$export$31c96b9df38bc8d4(hex);
}
function $6e3896ec657dc96d$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $6e3896ec657dc96d$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $8hd5S.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $bvbVr.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("01CEa", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $004e1293f1ad2c24$export$8a9b6341a7c96bc);
function $004e1293f1ad2c24$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("bvbVr", function(module, exports) {

$parcel$export(module.exports, "pad", () => $85fbd71c6b509201$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $85fbd71c6b509201$export$1bcd51c0fce8ee55);

var $emRAG = parcelRequire("emRAG");
function $85fbd71c6b509201$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $85fbd71c6b509201$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $85fbd71c6b509201$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $85fbd71c6b509201$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $emRAG.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $85fbd71c6b509201$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $emRAG.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("emRAG", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $a75cb0bbaf4030fb$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $a75cb0bbaf4030fb$export$70445dc308a7f3d5);

var $hRZHI = parcelRequire("hRZHI");
class $a75cb0bbaf4030fb$export$cfcd41bba8b36dbd extends (0, $hRZHI.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $a75cb0bbaf4030fb$export$70445dc308a7f3d5 extends (0, $hRZHI.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeExceedsPaddingSizeError"
        });
    }
}

});


parcelRegister("8hd5S", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $606a116e8d6e339c$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $606a116e8d6e339c$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $606a116e8d6e339c$export$92a44656ec81b584);
$parcel$export(module.exports, "hexToString", () => $606a116e8d6e339c$export$f4bc7e46f3eb3ac3);
$parcel$export(module.exports, "hexToBool", () => $606a116e8d6e339c$export$bde1d77e6fe6c41e);

var $1E5F8 = parcelRequire("1E5F8");

var $getgY = parcelRequire("getgY");

var $bTOZ4 = parcelRequire("bTOZ4");

var $9sHEt = parcelRequire("9sHEt");
function $606a116e8d6e339c$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $getgY.size)(hexOrBytes) > size) throw new (0, $1E5F8.SizeOverflowError)({
        givenSize: (0, $getgY.size)(hexOrBytes),
        maxSize: size
    });
}
function $606a116e8d6e339c$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $606a116e8d6e339c$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $606a116e8d6e339c$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $606a116e8d6e339c$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $606a116e8d6e339c$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $9sHEt.hexToBytes)(hex, opts);
}
function $606a116e8d6e339c$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $606a116e8d6e339c$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $606a116e8d6e339c$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $606a116e8d6e339c$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $bTOZ4.trim)(hex);
    }
    if ((0, $bTOZ4.trim)(hex) === "0x00") return false;
    if ((0, $bTOZ4.trim)(hex) === "0x01") return true;
    throw new (0, $1E5F8.InvalidHexBooleanError)(hex);
}
function $606a116e8d6e339c$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($606a116e8d6e339c$export$92a44656ec81b584(hex, opts));
}
function $606a116e8d6e339c$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $9sHEt.hexToBytes)(hex);
    if (opts.size) {
        $606a116e8d6e339c$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $bTOZ4.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("1E5F8", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $132deb57a1eb75fc$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $132deb57a1eb75fc$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $132deb57a1eb75fc$export$beb44ed4f8747d0e);

var $hRZHI = parcelRequire("hRZHI");
class $132deb57a1eb75fc$export$8615cc40e20f1eb extends (0, $hRZHI.BaseError) {
    constructor({ consumed: consumed, length: length }){
        super(`Consumed bytes (${consumed}) is shorter than data length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooLongError"
        });
    }
}
class $132deb57a1eb75fc$export$9579bcdb57e90be3 extends (0, $hRZHI.BaseError) {
    constructor({ length: length, dataLength: dataLength }){
        super(`Data length (${dataLength - 1}) is shorter than consumed bytes length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooShortError"
        });
    }
}
class $132deb57a1eb75fc$export$47d164a8071229a9 extends (0, $hRZHI.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntegerOutOfRangeError"
        });
    }
}
class $132deb57a1eb75fc$export$52fc62e5266c8838 extends (0, $hRZHI.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidBytesBooleanError"
        });
    }
}
class $132deb57a1eb75fc$export$f574ac54e35514c extends (0, $hRZHI.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexBooleanError"
        });
    }
}
class $132deb57a1eb75fc$export$ef05eafd11dd4a83 extends (0, $hRZHI.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexValueError"
        });
    }
}
class $132deb57a1eb75fc$export$a63b8c38d2c828ee extends (0, $hRZHI.BaseError) {
    constructor({ nextOffset: nextOffset, offset: offset }){
        super(`Next offset (${nextOffset}) is greater than previous offset + consumed bytes (${offset})`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "OffsetOutOfBoundsError"
        });
    }
}
class $132deb57a1eb75fc$export$beb44ed4f8747d0e extends (0, $hRZHI.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeOverflowError"
        });
    }
}

});

parcelRegister("getgY", function(module, exports) {

$parcel$export(module.exports, "size", () => $bd14a91c1c82393a$export$346677f925de839c);

var $01CEa = parcelRequire("01CEa");
function $bd14a91c1c82393a$export$346677f925de839c(value) {
    if ((0, $01CEa.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});

parcelRegister("bTOZ4", function(module, exports) {

$parcel$export(module.exports, "trim", () => $8a9c61224c45e869$export$87c2784dc9fc4ab);
function $8a9c61224c45e869$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("hKqyW", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $cebb564da406f1e6$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $cebb564da406f1e6$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $cebb564da406f1e6$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $cebb564da406f1e6$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $cebb564da406f1e6$export$58b867e287a802c8);

var $1E5F8 = parcelRequire("1E5F8");

var $bvbVr = parcelRequire("bvbVr");

var $8hd5S = parcelRequire("8hd5S");
const $cebb564da406f1e6$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $cebb564da406f1e6$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $cebb564da406f1e6$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $cebb564da406f1e6$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $cebb564da406f1e6$export$b5c95dec4f62ef7a(value, opts);
    return $cebb564da406f1e6$export$58b867e287a802c8(value, opts);
}
function $cebb564da406f1e6$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $8hd5S.assertSize)(hex, {
            size: opts.size
        });
        return (0, $bvbVr.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $cebb564da406f1e6$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $cebb564da406f1e6$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $8hd5S.assertSize)(hex, {
            size: opts.size
        });
        return (0, $bvbVr.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $cebb564da406f1e6$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $1E5F8.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $bvbVr.pad)(hex, {
        size: size
    });
    return hex;
}
const $cebb564da406f1e6$var$encoder = /*#__PURE__*/ new TextEncoder();
function $cebb564da406f1e6$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $cebb564da406f1e6$var$encoder.encode(value_);
    return $cebb564da406f1e6$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("cq8a0", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $90ae3e37546b9085$export$f8151fce47ad1c35);

var $1Fwbw = parcelRequire("1Fwbw");

var $01CEa = parcelRequire("01CEa");

var $9sHEt = parcelRequire("9sHEt");

var $hKqyW = parcelRequire("hKqyW");
function $90ae3e37546b9085$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $1Fwbw.keccak_256)((0, $01CEa.isHex)(value, {
        strict: false
    }) ? (0, $9sHEt.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $hKqyW.toHex)(bytes);
}

});
parcelRegister("1Fwbw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $2PKct = parcelRequire("2PKct");

var $12L6O = parcelRequire("12L6O");

var $crmK1 = parcelRequire("crmK1");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$137296019e7c0379$var$SHA3_PI, $137296019e7c0379$var$SHA3_ROTL, $137296019e7c0379$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $137296019e7c0379$var$_0n = /* @__PURE__ */ BigInt(0);
const $137296019e7c0379$var$_1n = /* @__PURE__ */ BigInt(1);
const $137296019e7c0379$var$_2n = /* @__PURE__ */ BigInt(2);
const $137296019e7c0379$var$_7n = /* @__PURE__ */ BigInt(7);
const $137296019e7c0379$var$_256n = /* @__PURE__ */ BigInt(256);
const $137296019e7c0379$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $137296019e7c0379$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $137296019e7c0379$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $137296019e7c0379$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $137296019e7c0379$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $137296019e7c0379$var$_1n ^ (R >> $137296019e7c0379$var$_7n) * $137296019e7c0379$var$_0x71n) % $137296019e7c0379$var$_256n;
        if (R & $137296019e7c0379$var$_2n) t ^= $137296019e7c0379$var$_1n << ($137296019e7c0379$var$_1n << /* @__PURE__ */ BigInt(j)) - $137296019e7c0379$var$_1n;
    }
    $137296019e7c0379$var$_SHA3_IOTA.push(t);
}
const [$137296019e7c0379$var$SHA3_IOTA_H, $137296019e7c0379$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $12L6O.split)($137296019e7c0379$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $137296019e7c0379$var$rotlH = (h, l, s)=>s > 32 ? (0, $12L6O.rotlBH)(h, l, s) : (0, $12L6O.rotlSH)(h, l, s);
const $137296019e7c0379$var$rotlL = (h, l, s)=>s > 32 ? (0, $12L6O.rotlBL)(h, l, s) : (0, $12L6O.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $137296019e7c0379$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $137296019e7c0379$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $137296019e7c0379$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $137296019e7c0379$var$SHA3_ROTL[t];
            const Th = $137296019e7c0379$var$rotlH(curH, curL, shift);
            const Tl = $137296019e7c0379$var$rotlL(curH, curL, shift);
            const PI = $137296019e7c0379$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $137296019e7c0379$var$SHA3_IOTA_H[round];
        s[1] ^= $137296019e7c0379$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $137296019e7c0379$var$keccakP;
class $137296019e7c0379$var$Keccak extends $crmK1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $2PKct.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $crmK1.u32)(this.state);
    }
    keccak() {
        $137296019e7c0379$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $2PKct.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $crmK1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $2PKct.exists)(this, false);
        (0, $2PKct.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $2PKct.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $2PKct.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $137296019e7c0379$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $137296019e7c0379$var$Keccak;
const $137296019e7c0379$var$gen = (suffix, blockLen, outputLen)=>(0, $crmK1.wrapConstructor)(()=>new $137296019e7c0379$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $137296019e7c0379$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $137296019e7c0379$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $137296019e7c0379$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $137296019e7c0379$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $137296019e7c0379$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $137296019e7c0379$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $137296019e7c0379$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $137296019e7c0379$var$gen(0x01, 72, 64);
const $137296019e7c0379$var$genShake = (suffix, blockLen, outputLen)=>(0, $crmK1.wrapXOFConstructorWithOpts)((opts = {})=>new $137296019e7c0379$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $137296019e7c0379$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $137296019e7c0379$var$genShake(0x1f, 136, 32);

});
parcelRegister("2PKct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $21042e974b2daeac$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $21042e974b2daeac$var$number;
function $21042e974b2daeac$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $21042e974b2daeac$var$bool;
function $21042e974b2daeac$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $21042e974b2daeac$var$bytes;
function $21042e974b2daeac$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $21042e974b2daeac$var$number(hash.outputLen);
    $21042e974b2daeac$var$number(hash.blockLen);
}
module.exports.hash = $21042e974b2daeac$var$hash;
function $21042e974b2daeac$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $21042e974b2daeac$var$exists;
function $21042e974b2daeac$var$output(out, instance) {
    $21042e974b2daeac$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $21042e974b2daeac$var$output;
const $21042e974b2daeac$var$assert = {
    number: $21042e974b2daeac$var$number,
    bool: $21042e974b2daeac$var$bool,
    bytes: $21042e974b2daeac$var$bytes,
    hash: $21042e974b2daeac$var$hash,
    exists: $21042e974b2daeac$var$exists,
    output: $21042e974b2daeac$var$output
};
module.exports.default = $21042e974b2daeac$var$assert;

});

parcelRegister("12L6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $0c2a85322c3963d1$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $0c2a85322c3963d1$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $0c2a85322c3963d1$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $0c2a85322c3963d1$var$U32_MASK64),
        l: Number(n >> $0c2a85322c3963d1$var$_32n & $0c2a85322c3963d1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $0c2a85322c3963d1$var$_32n & $0c2a85322c3963d1$var$U32_MASK64) | 0,
        l: Number(n & $0c2a85322c3963d1$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $0c2a85322c3963d1$var$fromBig;
function $0c2a85322c3963d1$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $0c2a85322c3963d1$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $0c2a85322c3963d1$var$split;
const $0c2a85322c3963d1$var$toBig = (h, l)=>BigInt(h >>> 0) << $0c2a85322c3963d1$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $0c2a85322c3963d1$var$toBig;
// for Shift in [0, 32)
const $0c2a85322c3963d1$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $0c2a85322c3963d1$var$shrSH;
const $0c2a85322c3963d1$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $0c2a85322c3963d1$var$shrSL;
// Right rotate for Shift in [1, 32)
const $0c2a85322c3963d1$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $0c2a85322c3963d1$var$rotrSH;
const $0c2a85322c3963d1$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $0c2a85322c3963d1$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $0c2a85322c3963d1$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $0c2a85322c3963d1$var$rotrBH;
const $0c2a85322c3963d1$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $0c2a85322c3963d1$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $0c2a85322c3963d1$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $0c2a85322c3963d1$var$rotr32H;
const $0c2a85322c3963d1$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $0c2a85322c3963d1$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $0c2a85322c3963d1$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $0c2a85322c3963d1$var$rotlSH;
const $0c2a85322c3963d1$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $0c2a85322c3963d1$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $0c2a85322c3963d1$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $0c2a85322c3963d1$var$rotlBH;
const $0c2a85322c3963d1$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $0c2a85322c3963d1$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $0c2a85322c3963d1$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $0c2a85322c3963d1$var$add;
// Addition with more than 2 elements
const $0c2a85322c3963d1$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $0c2a85322c3963d1$var$add3L;
const $0c2a85322c3963d1$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $0c2a85322c3963d1$var$add3H;
const $0c2a85322c3963d1$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $0c2a85322c3963d1$var$add4L;
const $0c2a85322c3963d1$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $0c2a85322c3963d1$var$add4H;
const $0c2a85322c3963d1$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $0c2a85322c3963d1$var$add5L;
const $0c2a85322c3963d1$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $0c2a85322c3963d1$var$add5H;
// prettier-ignore
const $0c2a85322c3963d1$var$u64 = {
    fromBig: $0c2a85322c3963d1$var$fromBig,
    split: $0c2a85322c3963d1$var$split,
    toBig: $0c2a85322c3963d1$var$toBig,
    shrSH: $0c2a85322c3963d1$var$shrSH,
    shrSL: $0c2a85322c3963d1$var$shrSL,
    rotrSH: $0c2a85322c3963d1$var$rotrSH,
    rotrSL: $0c2a85322c3963d1$var$rotrSL,
    rotrBH: $0c2a85322c3963d1$var$rotrBH,
    rotrBL: $0c2a85322c3963d1$var$rotrBL,
    rotr32H: $0c2a85322c3963d1$var$rotr32H,
    rotr32L: $0c2a85322c3963d1$var$rotr32L,
    rotlSH: $0c2a85322c3963d1$var$rotlSH,
    rotlSL: $0c2a85322c3963d1$var$rotlSL,
    rotlBH: $0c2a85322c3963d1$var$rotlBH,
    rotlBL: $0c2a85322c3963d1$var$rotlBL,
    add: $0c2a85322c3963d1$var$add,
    add3L: $0c2a85322c3963d1$var$add3L,
    add3H: $0c2a85322c3963d1$var$add3H,
    add4L: $0c2a85322c3963d1$var$add4L,
    add4H: $0c2a85322c3963d1$var$add4H,
    add5H: $0c2a85322c3963d1$var$add5H,
    add5L: $0c2a85322c3963d1$var$add5L
};
module.exports.default = $0c2a85322c3963d1$var$u64;

});

parcelRegister("crmK1", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $9saf9 = parcelRequire("9saf9");
const $90e9a594deafcf5a$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $90e9a594deafcf5a$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $90e9a594deafcf5a$var$u8;
const $90e9a594deafcf5a$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $90e9a594deafcf5a$var$u32;
// Cast array to view
const $90e9a594deafcf5a$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $90e9a594deafcf5a$var$createView;
// The rotate right (circular right shift) operation for uint32
const $90e9a594deafcf5a$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $90e9a594deafcf5a$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $90e9a594deafcf5a$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $90e9a594deafcf5a$var$bytesToHex(bytes) {
    if (!$90e9a594deafcf5a$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $90e9a594deafcf5a$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $90e9a594deafcf5a$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $90e9a594deafcf5a$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $90e9a594deafcf5a$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $90e9a594deafcf5a$var$nextTick = async ()=>{};
module.exports.nextTick = $90e9a594deafcf5a$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $90e9a594deafcf5a$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $90e9a594deafcf5a$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $90e9a594deafcf5a$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $90e9a594deafcf5a$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $90e9a594deafcf5a$var$toBytes(data) {
    if (typeof data === "string") data = $90e9a594deafcf5a$var$utf8ToBytes(data);
    if (!$90e9a594deafcf5a$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $90e9a594deafcf5a$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $90e9a594deafcf5a$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$90e9a594deafcf5a$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $90e9a594deafcf5a$var$concatBytes;
// For runtime check if class implements interface
class $90e9a594deafcf5a$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $90e9a594deafcf5a$var$Hash;
const $90e9a594deafcf5a$var$toStr = {}.toString;
function $90e9a594deafcf5a$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $90e9a594deafcf5a$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $90e9a594deafcf5a$var$checkOpts;
function $90e9a594deafcf5a$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($90e9a594deafcf5a$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $90e9a594deafcf5a$var$wrapConstructor;
function $90e9a594deafcf5a$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($90e9a594deafcf5a$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $90e9a594deafcf5a$var$wrapConstructorWithOpts;
function $90e9a594deafcf5a$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($90e9a594deafcf5a$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $90e9a594deafcf5a$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $90e9a594deafcf5a$var$randomBytes(bytesLength = 32) {
    if ($9saf9.crypto && typeof $9saf9.crypto.getRandomValues === "function") return $9saf9.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $90e9a594deafcf5a$var$randomBytes;

});
parcelRegister("9saf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("fCd4Y", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $b5e48ce55ca71ff2$export$977e255126d763d6);
const $b5e48ce55ca71ff2$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
function $b5e48ce55ca71ff2$export$977e255126d763d6(address) {
    return $b5e48ce55ca71ff2$var$addressRegex.test(address);
}

});


parcelRegister("1mQc6", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", () => $0ff0552fdee97351$export$aa31e6432f136746);
$parcel$export(module.exports, "InvalidRequestRpcError", () => $0ff0552fdee97351$export$ff7b9f15f3eb8d4d);
$parcel$export(module.exports, "MethodNotFoundRpcError", () => $0ff0552fdee97351$export$4c4044ac99c8d2d3);
$parcel$export(module.exports, "InvalidParamsRpcError", () => $0ff0552fdee97351$export$c600faffd3cbd390);
$parcel$export(module.exports, "InternalRpcError", () => $0ff0552fdee97351$export$4e62fafb20e19fd7);
$parcel$export(module.exports, "InvalidInputRpcError", () => $0ff0552fdee97351$export$3ba2994324ab015e);
$parcel$export(module.exports, "ResourceNotFoundRpcError", () => $0ff0552fdee97351$export$466772c50c6d6751);
$parcel$export(module.exports, "ResourceUnavailableRpcError", () => $0ff0552fdee97351$export$270451347568a637);
$parcel$export(module.exports, "TransactionRejectedRpcError", () => $0ff0552fdee97351$export$f714565c9176e28);
$parcel$export(module.exports, "MethodNotSupportedRpcError", () => $0ff0552fdee97351$export$b106fe05a02d89c5);
$parcel$export(module.exports, "LimitExceededRpcError", () => $0ff0552fdee97351$export$2c6f5ab73129d9d7);
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", () => $0ff0552fdee97351$export$662f3764fa426a13);
$parcel$export(module.exports, "UserRejectedRequestError", () => $0ff0552fdee97351$export$4af5b080d9e9e1a6);
$parcel$export(module.exports, "UnauthorizedProviderError", () => $0ff0552fdee97351$export$cc1057a5779c7ffa);
$parcel$export(module.exports, "UnsupportedProviderMethodError", () => $0ff0552fdee97351$export$6a557500ae315a49);
$parcel$export(module.exports, "ProviderDisconnectedError", () => $0ff0552fdee97351$export$abb104bf1dd9c38b);
$parcel$export(module.exports, "ChainDisconnectedError", () => $0ff0552fdee97351$export$ef186cf1cda0444);
$parcel$export(module.exports, "SwitchChainError", () => $0ff0552fdee97351$export$d4ddb31968a9d366);
$parcel$export(module.exports, "UnknownRpcError", () => $0ff0552fdee97351$export$bfc830e1ec76e31b);

var $hRZHI = parcelRequire("hRZHI");

var $5pGkz = parcelRequire("5pGkz");
const $0ff0552fdee97351$var$unknownErrorCode = -1;
class $0ff0552fdee97351$export$5460eff990f31920 extends (0, $hRZHI.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = cause.name;
        this.code = cause instanceof (0, $5pGkz.RpcRequestError) ? cause.code : code ?? $0ff0552fdee97351$var$unknownErrorCode;
    }
}
class $0ff0552fdee97351$export$417589b978208a8f extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderRpcError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $0ff0552fdee97351$export$aa31e6432f136746 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$aa31e6432f136746.code,
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ParseRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $0ff0552fdee97351$export$ff7b9f15f3eb8d4d extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$ff7b9f15f3eb8d4d.code,
            shortMessage: "JSON is not a valid request object."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidRequestRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $0ff0552fdee97351$export$4c4044ac99c8d2d3 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$4c4044ac99c8d2d3.code,
            shortMessage: "The method does not exist / is not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotFoundRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $0ff0552fdee97351$export$c600faffd3cbd390 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$c600faffd3cbd390.code,
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParamsRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $0ff0552fdee97351$export$4e62fafb20e19fd7 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$4e62fafb20e19fd7.code,
            shortMessage: "An internal error was received."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InternalRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $0ff0552fdee97351$export$3ba2994324ab015e extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$3ba2994324ab015e.code,
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidInputRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $0ff0552fdee97351$export$466772c50c6d6751 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$466772c50c6d6751.code,
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $0ff0552fdee97351$export$270451347568a637 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$270451347568a637.code,
            shortMessage: "Requested resource not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceUnavailableRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $0ff0552fdee97351$export$f714565c9176e28 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$f714565c9176e28.code,
            shortMessage: "Transaction creation failed."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionRejectedRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $0ff0552fdee97351$export$b106fe05a02d89c5 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$b106fe05a02d89c5.code,
            shortMessage: "Method is not implemented."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotSupportedRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $0ff0552fdee97351$export$2c6f5ab73129d9d7 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$2c6f5ab73129d9d7.code,
            shortMessage: "Request exceeds defined limit."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "LimitExceededRpcError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $0ff0552fdee97351$export$662f3764fa426a13 extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$662f3764fa426a13.code,
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "JsonRpcVersionUnsupportedError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $0ff0552fdee97351$export$4af5b080d9e9e1a6 extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$4af5b080d9e9e1a6.code,
            shortMessage: "User rejected the request."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UserRejectedRequestError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $0ff0552fdee97351$export$cc1057a5779c7ffa extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$cc1057a5779c7ffa.code,
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnauthorizedProviderError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $0ff0552fdee97351$export$6a557500ae315a49 extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$6a557500ae315a49.code,
            shortMessage: "The Provider does not support the requested method."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedProviderMethodError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $0ff0552fdee97351$export$abb104bf1dd9c38b extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$abb104bf1dd9c38b.code,
            shortMessage: "The Provider is disconnected from all chains."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderDisconnectedError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $0ff0552fdee97351$export$ef186cf1cda0444 extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$ef186cf1cda0444.code,
            shortMessage: "The Provider is not connected to the requested chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDisconnectedError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $0ff0552fdee97351$export$d4ddb31968a9d366 extends $0ff0552fdee97351$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $0ff0552fdee97351$export$d4ddb31968a9d366.code,
            shortMessage: "An error occurred when attempting to switch chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainError"
        });
    }
}
Object.defineProperty($0ff0552fdee97351$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $0ff0552fdee97351$export$bfc830e1ec76e31b extends $0ff0552fdee97351$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            shortMessage: "An unknown RPC error occurred."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownRpcError"
        });
    }
}

});
parcelRegister("5pGkz", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", () => $3f101f8993811097$export$715ba3385e9f2cf0);
$parcel$export(module.exports, "WebSocketRequestError", () => $3f101f8993811097$export$e1d72a3a26ed1bc);
$parcel$export(module.exports, "RpcRequestError", () => $3f101f8993811097$export$a823590631c47261);
$parcel$export(module.exports, "TimeoutError", () => $3f101f8993811097$export$66d311bf29d5c89c);

var $41CuJ = parcelRequire("41CuJ");

var $hRZHI = parcelRequire("hRZHI");

var $k9Ckd = parcelRequire("k9Ckd");
class $3f101f8993811097$export$715ba3385e9f2cf0 extends (0, $hRZHI.BaseError) {
    constructor({ body: body, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $k9Ckd.getUrl)(url)}`,
                body && `Request body: ${(0, $41CuJ.stringify)(body)}`
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $3f101f8993811097$export$e1d72a3a26ed1bc extends (0, $hRZHI.BaseError) {
    constructor({ body: body, details: details, url: url }){
        super("WebSocket request failed.", {
            details: details,
            metaMessages: [
                `URL: ${(0, $k9Ckd.getUrl)(url)}`,
                `Request body: ${(0, $41CuJ.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WebSocketRequestError"
        });
    }
}
class $3f101f8993811097$export$a823590631c47261 extends (0, $hRZHI.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $k9Ckd.getUrl)(url)}`,
                `Request body: ${(0, $41CuJ.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
class $3f101f8993811097$export$66d311bf29d5c89c extends (0, $hRZHI.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $k9Ckd.getUrl)(url)}`,
                `Request body: ${(0, $41CuJ.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TimeoutError"
        });
    }
}

});
parcelRegister("41CuJ", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $2ee51dacfe886c4d$export$fac44ee5b035f737);
const $2ee51dacfe886c4d$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});



parcelRegister("dS1Df", function(module, exports) {

$parcel$export(module.exports, "createWalletClient", () => $a191959ddd29c677$export$362b8ea2edbd9090);

var $j15d8 = parcelRequire("j15d8");

var $gEU2n = parcelRequire("gEU2n");
function $a191959ddd29c677$export$362b8ea2edbd9090(parameters) {
    const { key: key = "wallet", name: name = "Wallet Client", transport: transport } = parameters;
    const client = (0, $j15d8.createClient)({
        ...parameters,
        key: key,
        name: name,
        transport: (opts)=>transport({
                ...opts,
                retryCount: 0
            }),
        type: "walletClient"
    });
    return client.extend((0, $gEU2n.walletActions));
}

});
parcelRegister("j15d8", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $dd8227176d580304$export$5d730b7aed1a3eb0);

var $3VerT = parcelRequire("3VerT");

var $eQBpb = parcelRequire("eQBpb");
function $dd8227176d580304$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $3VerT.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $eQBpb.uid)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}

});
parcelRegister("3VerT", function(module, exports) {

$parcel$export(module.exports, "parseAccount", () => $2db1e731b0883463$export$11027cbf6cf15da2);
function $2db1e731b0883463$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("eQBpb", function(module, exports) {

$parcel$export(module.exports, "uid", () => $acf2efed4862b580$export$e2a22331486dcca0);
const $acf2efed4862b580$var$size = 256;
let $acf2efed4862b580$var$index = $acf2efed4862b580$var$size;
let $acf2efed4862b580$var$buffer;
function $acf2efed4862b580$export$e2a22331486dcca0(length = 11) {
    if (!$acf2efed4862b580$var$buffer || $acf2efed4862b580$var$index + length > $acf2efed4862b580$var$size * 2) {
        $acf2efed4862b580$var$buffer = "";
        $acf2efed4862b580$var$index = 0;
        for(let i = 0; i < $acf2efed4862b580$var$size; i++)$acf2efed4862b580$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $acf2efed4862b580$var$buffer.substring($acf2efed4862b580$var$index, $acf2efed4862b580$var$index++ + length);
}

});


parcelRegister("gEU2n", function(module, exports) {

$parcel$export(module.exports, "walletActions", () => $c20bd99fdc893333$export$d07041b4ed194fbc);

var $fG2bm = parcelRequire("fG2bm");

var $gnvTm = parcelRequire("gnvTm");

var $lJh8R = parcelRequire("lJh8R");

var $eOiCg = parcelRequire("eOiCg");

var $3m4Ma = parcelRequire("3m4Ma");

var $fYp3D = parcelRequire("fYp3D");

var $63GHZ = parcelRequire("63GHZ");

var $4AJf1 = parcelRequire("4AJf1");

var $lmZn1 = parcelRequire("lmZn1");

var $fGDeB = parcelRequire("fGDeB");

var $3ikaK = parcelRequire("3ikaK");

var $dRPkG = parcelRequire("dRPkG");

var $9lCy4 = parcelRequire("9lCy4");

var $hnXQr = parcelRequire("hnXQr");

var $dUqG4 = parcelRequire("dUqG4");

var $4hCRV = parcelRequire("4hCRV");
function $c20bd99fdc893333$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $gnvTm.addChain)(client, args),
        deployContract: (args)=>(0, $lJh8R.deployContract)(client, args),
        getAddresses: ()=>(0, $eOiCg.getAddresses)(client),
        getChainId: ()=>(0, $fG2bm.getChainId)(client),
        getPermissions: ()=>(0, $3m4Ma.getPermissions)(client),
        prepareTransactionRequest: (args)=>(0, $fYp3D.prepareTransactionRequest)(client, args),
        requestAddresses: ()=>(0, $63GHZ.requestAddresses)(client),
        requestPermissions: (args)=>(0, $4AJf1.requestPermissions)(client, args),
        sendRawTransaction: (args)=>(0, $lmZn1.sendRawTransaction)(client, args),
        sendTransaction: (args)=>(0, $fGDeB.sendTransaction)(client, args),
        signMessage: (args)=>(0, $3ikaK.signMessage)(client, args),
        signTransaction: (args)=>(0, $dRPkG.signTransaction)(client, args),
        signTypedData: (args)=>(0, $9lCy4.signTypedData)(client, args),
        switchChain: (args)=>(0, $hnXQr.switchChain)(client, args),
        watchAsset: (args)=>(0, $dUqG4.watchAsset)(client, args),
        writeContract: (args)=>(0, $4hCRV.writeContract)(client, args)
    };
}

});
parcelRegister("fG2bm", function(module, exports) {

$parcel$export(module.exports, "getChainId", () => $b69c789bde4bf89d$export$850fa7b3891187c);

var $8hd5S = parcelRequire("8hd5S");
async function $b69c789bde4bf89d$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    });
    return (0, $8hd5S.hexToNumber)(chainIdHex);
}

});

parcelRegister("gnvTm", function(module, exports) {

$parcel$export(module.exports, "addChain", () => $bec7886098bce5d5$export$e648161d6b1bb565);

var $hKqyW = parcelRequire("hKqyW");
async function $bec7886098bce5d5$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: (0, $hKqyW.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    });
}

});

parcelRegister("lJh8R", function(module, exports) {

$parcel$export(module.exports, "deployContract", () => $fd1b18f9627c6630$export$46c7a79747abe6a9);

var $5LWH6 = parcelRequire("5LWH6");

var $fGDeB = parcelRequire("fGDeB");
function $fd1b18f9627c6630$export$46c7a79747abe6a9(walletClient, { abi: abi, args: args, bytecode: bytecode, ...request }) {
    const calldata = (0, $5LWH6.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $fGDeB.sendTransaction)(walletClient, {
        ...request,
        data: calldata
    });
}

});
parcelRegister("5LWH6", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", () => $433edefcadbb59a8$export$d7a7276006273fbd);

var $ddib9 = parcelRequire("ddib9");

var $kTOx8 = parcelRequire("kTOx8");

var $e9Gwc = parcelRequire("e9Gwc");
const $433edefcadbb59a8$var$docsPath = "/docs/contract/encodeDeployData";
function $433edefcadbb59a8$export$d7a7276006273fbd({ abi: abi, args: args, bytecode: bytecode }) {
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $ddib9.AbiConstructorNotFoundError)({
        docsPath: $433edefcadbb59a8$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $ddib9.AbiConstructorParamsNotFoundError)({
        docsPath: $433edefcadbb59a8$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $ddib9.AbiConstructorParamsNotFoundError)({
        docsPath: $433edefcadbb59a8$var$docsPath
    });
    const data = (0, $e9Gwc.encodeAbiParameters)(description.inputs, args);
    return (0, $kTOx8.concatHex)([
        bytecode,
        data
    ]);
}

});
parcelRegister("ddib9", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", () => $99ea972df9465c68$export$efa723f306cf6168);
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", () => $99ea972df9465c68$export$4faec14323ef9c47);
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", () => $99ea972df9465c68$export$7a409e433c5f3a8c);
$parcel$export(module.exports, "AbiDecodingZeroDataError", () => $99ea972df9465c68$export$a063cde4013f1935);
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", () => $99ea972df9465c68$export$a851da9bf50b557);
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", () => $99ea972df9465c68$export$19c281dc8e23a2ea);
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", () => $99ea972df9465c68$export$20737d495bb13c2d);
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", () => $99ea972df9465c68$export$8959cb729fefe1ea);
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", () => $99ea972df9465c68$export$f83210ce5f9b901f);
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", () => $99ea972df9465c68$export$3b44baeac92e4d3a);
$parcel$export(module.exports, "AbiEventNotFoundError", () => $99ea972df9465c68$export$c7be62baad13b157);
$parcel$export(module.exports, "AbiFunctionNotFoundError", () => $99ea972df9465c68$export$c4faa308ea7f9b2);
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", () => $99ea972df9465c68$export$26f2edb605108b34);
$parcel$export(module.exports, "AbiItemAmbiguityError", () => $99ea972df9465c68$export$fdbba54ba15f2c2d);
$parcel$export(module.exports, "BytesSizeMismatchError", () => $99ea972df9465c68$export$a0eb884ede5c87eb);
$parcel$export(module.exports, "DecodeLogDataMismatch", () => $99ea972df9465c68$export$3978f86c08fc8c25);
$parcel$export(module.exports, "DecodeLogTopicsMismatch", () => $99ea972df9465c68$export$6d7c6f419cf52377);
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", () => $99ea972df9465c68$export$53ed98b886965f49);
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", () => $99ea972df9465c68$export$cf94ccff0ff97c65);
$parcel$export(module.exports, "InvalidArrayError", () => $99ea972df9465c68$export$710dd6d4f78cc47e);
$parcel$export(module.exports, "InvalidDefinitionTypeError", () => $99ea972df9465c68$export$81781a0fcfb9ed95);

var $lU0UI = parcelRequire("lU0UI");

var $getgY = parcelRequire("getgY");

var $hRZHI = parcelRequire("hRZHI");
class $99ea972df9465c68$export$efa723f306cf6168 extends (0, $hRZHI.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$4faec14323ef9c47 extends (0, $hRZHI.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$68a7b570091cba69 extends (0, $hRZHI.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $99ea972df9465c68$export$7a409e433c5f3a8c extends (0, $hRZHI.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $lU0UI.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $99ea972df9465c68$export$a063cde4013f1935 extends (0, $hRZHI.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingZeroDataError"
        });
    }
}
class $99ea972df9465c68$export$a851da9bf50b557 extends (0, $hRZHI.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $99ea972df9465c68$export$19c281dc8e23a2ea extends (0, $hRZHI.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $getgY.size)(value)}) does not match expected size (bytes${expectedSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $99ea972df9465c68$export$20737d495bb13c2d extends (0, $hRZHI.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingLengthMismatchError"
        });
    }
}
class $99ea972df9465c68$export$d47cf5ef47eda817 extends (0, $hRZHI.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorInputsNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$86b719574b683f04 extends (0, $hRZHI.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$8959cb729fefe1ea extends (0, $hRZHI.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $99ea972df9465c68$export$f83210ce5f9b901f extends (0, $hRZHI.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $99ea972df9465c68$export$3b44baeac92e4d3a extends (0, $hRZHI.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$c7be62baad13b157 extends (0, $hRZHI.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$c4faa308ea7f9b2 extends (0, $hRZHI.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$26f2edb605108b34 extends (0, $hRZHI.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$14373147a0e60810 extends (0, $hRZHI.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $99ea972df9465c68$export$fdbba54ba15f2c2d extends (0, $hRZHI.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $lU0UI.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $lU0UI.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItemAmbiguityError"
        });
    }
}
class $99ea972df9465c68$export$a0eb884ede5c87eb extends (0, $hRZHI.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BytesSizeMismatchError"
        });
    }
}
class $99ea972df9465c68$export$3978f86c08fc8c25 extends (0, $hRZHI.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $lU0UI.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $99ea972df9465c68$export$6d7c6f419cf52377 extends (0, $hRZHI.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $lU0UI.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $99ea972df9465c68$export$53ed98b886965f49 extends (0, $hRZHI.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiEncodingType"
        });
    }
}
class $99ea972df9465c68$export$cf94ccff0ff97c65 extends (0, $hRZHI.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiDecodingType"
        });
    }
}
class $99ea972df9465c68$export$710dd6d4f78cc47e extends (0, $hRZHI.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidArrayError"
        });
    }
}
class $99ea972df9465c68$export$81781a0fcfb9ed95 extends (0, $hRZHI.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidDefinitionTypeError"
        });
    }
}
class $99ea972df9465c68$export$a16541e2fe420ef1 extends (0, $hRZHI.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("lU0UI", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $ff1f8960b1e7d0e4$export$dc5d0ff4fc2fdee1);
$parcel$export(module.exports, "formatAbiParams", () => $ff1f8960b1e7d0e4$export$849e499971de75b3);

var $ddib9 = parcelRequire("ddib9");
function $ff1f8960b1e7d0e4$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $ddib9.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$ff1f8960b1e7d0e4$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $ff1f8960b1e7d0e4$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$ff1f8960b1e7d0e4$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $ff1f8960b1e7d0e4$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$ff1f8960b1e7d0e4$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});


parcelRegister("kTOx8", function(module, exports) {

$parcel$export(module.exports, "concat", () => $f370249365c057ae$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatHex", () => $f370249365c057ae$export$f6cc0b64b5a999af);
function $f370249365c057ae$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $f370249365c057ae$export$f6cc0b64b5a999af(values);
    return $f370249365c057ae$export$287dd7971339c972(values);
}
function $f370249365c057ae$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $f370249365c057ae$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("e9Gwc", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", () => $a4e2e335de4f7a2e$export$448ea0950d6dd7d7);
$parcel$export(module.exports, "getArrayComponents", () => $a4e2e335de4f7a2e$export$ab502cfdbb1a0d07);

var $ddib9 = parcelRequire("ddib9");

var $2VOm9 = parcelRequire("2VOm9");

var $fCd4Y = parcelRequire("fCd4Y");

var $kTOx8 = parcelRequire("kTOx8");

var $bvbVr = parcelRequire("bvbVr");

var $getgY = parcelRequire("getgY");

var $btGtV = parcelRequire("btGtV");

var $hKqyW = parcelRequire("hKqyW");
function $a4e2e335de4f7a2e$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $ddib9.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $a4e2e335de4f7a2e$var$prepareParams({
        params: params,
        values: values
    });
    const data = $a4e2e335de4f7a2e$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $a4e2e335de4f7a2e$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($a4e2e335de4f7a2e$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $a4e2e335de4f7a2e$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $a4e2e335de4f7a2e$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $a4e2e335de4f7a2e$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $a4e2e335de4f7a2e$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $a4e2e335de4f7a2e$var$encodeAddress(value);
    if (param.type === "bool") return $a4e2e335de4f7a2e$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $a4e2e335de4f7a2e$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $a4e2e335de4f7a2e$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $a4e2e335de4f7a2e$var$encodeString(value);
    throw new (0, $ddib9.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $a4e2e335de4f7a2e$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $getgY.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $hKqyW.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $getgY.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $kTOx8.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $a4e2e335de4f7a2e$var$encodeAddress(value) {
    if (!(0, $fCd4Y.isAddress)(value)) throw new (0, $2VOm9.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $bvbVr.padHex)(value.toLowerCase())
    };
}
function $a4e2e335de4f7a2e$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $ddib9.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $ddib9.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $a4e2e335de4f7a2e$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $a4e2e335de4f7a2e$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $hKqyW.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $kTOx8.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $kTOx8.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $a4e2e335de4f7a2e$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $getgY.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $bvbVr.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $kTOx8.concat)([
                (0, $bvbVr.padHex)((0, $hKqyW.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== parseInt(paramSize)) throw new (0, $ddib9.AbiEncodingBytesSizeMismatchError)({
        expectedSize: parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $bvbVr.padHex)(value, {
            dir: "right"
        })
    };
}
function $a4e2e335de4f7a2e$var$encodeBool(value) {
    return {
        dynamic: false,
        encoded: (0, $bvbVr.padHex)((0, $hKqyW.boolToHex)(value))
    };
}
function $a4e2e335de4f7a2e$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $hKqyW.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $a4e2e335de4f7a2e$var$encodeString(value) {
    const hexValue = (0, $hKqyW.stringToHex)(value);
    const partsLength = Math.ceil((0, $getgY.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $bvbVr.padHex)((0, $btGtV.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $kTOx8.concat)([
            (0, $bvbVr.padHex)((0, $hKqyW.numberToHex)((0, $getgY.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $a4e2e335de4f7a2e$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $a4e2e335de4f7a2e$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $a4e2e335de4f7a2e$var$encodeParams(preparedParams) : (0, $kTOx8.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $a4e2e335de4f7a2e$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("btGtV", function(module, exports) {

$parcel$export(module.exports, "slice", () => $85b35b1c0d7e9763$export$58adb3bec8346d0f);

var $emRAG = parcelRequire("emRAG");

var $01CEa = parcelRequire("01CEa");

var $getgY = parcelRequire("getgY");
function $85b35b1c0d7e9763$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $01CEa.isHex)(value, {
        strict: false
    })) return $85b35b1c0d7e9763$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $85b35b1c0d7e9763$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $85b35b1c0d7e9763$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $getgY.size)(value) - 1) throw new (0, $emRAG.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $getgY.size)(value)
    });
}
function $85b35b1c0d7e9763$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $getgY.size)(value) !== end - start) throw new (0, $emRAG.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $getgY.size)(value)
    });
}
function $85b35b1c0d7e9763$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $85b35b1c0d7e9763$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $85b35b1c0d7e9763$var$assertEndOffset(value, start, end);
    return value;
}
function $85b35b1c0d7e9763$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $85b35b1c0d7e9763$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $85b35b1c0d7e9763$var$assertEndOffset(value, start, end);
    return value;
}

});



parcelRegister("fGDeB", function(module, exports) {

$parcel$export(module.exports, "sendTransaction", () => $b6b93665bd3885d7$export$8e0e7ffc78696d30);

var $3VerT = parcelRequire("3VerT");

var $guJoU = parcelRequire("guJoU");

var $ey1K2 = parcelRequire("ey1K2");

var $qRqH4 = parcelRequire("qRqH4");

var $csjHW = parcelRequire("csjHW");

var $2IJNQ = parcelRequire("2IJNQ");

var $5vDfU = parcelRequire("5vDfU");

var $6AVm0 = parcelRequire("6AVm0");

var $fG2bm = parcelRequire("fG2bm");

var $fYp3D = parcelRequire("fYp3D");

var $lmZn1 = parcelRequire("lmZn1");
async function $b6b93665bd3885d7$export$8e0e7ffc78696d30(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = (0, $3VerT.parseAccount)(account_);
    try {
        (0, $6AVm0.assertRequest)(args);
        let chainId;
        if (chain !== null) {
            chainId = await (0, $5vDfU.getAction)(client, (0, $fG2bm.getChainId), "getChainId")({});
            (0, $ey1K2.assertCurrentChain)({
                currentChainId: chainId,
                chain: chain
            });
        }
        if (account.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $5vDfU.getAction)(client, (0, $fYp3D.prepareTransactionRequest), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value,
                ...rest
            });
            if (!chainId) chainId = await (0, $5vDfU.getAction)(client, (0, $fG2bm.getChainId), "getChainId")({});
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction({
                ...request,
                chainId: chainId
            }, {
                serializer: serializer
            });
            return await (0, $5vDfU.getAction)(client, (0, $lmZn1.sendRawTransaction), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $2IJNQ.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $csjHW.extract)(rest, {
                format: chainFormat
            }),
            accessList: accessList,
            data: data,
            from: account.address,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        return await client.request({
            method: "eth_sendTransaction",
            params: [
                request
            ]
        });
    } catch (err) {
        throw (0, $qRqH4.getTransactionError)(err, {
            ...args,
            account: account,
            chain: args.chain || undefined
        });
    }
}

});
parcelRegister("guJoU", function(module, exports) {

$parcel$export(module.exports, "AccountNotFoundError", () => $c022aa5759c7e576$export$62ee6b05f0767f28);

var $hRZHI = parcelRequire("hRZHI");
class $c022aa5759c7e576$export$62ee6b05f0767f28 extends (0, $hRZHI.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AccountNotFoundError"
        });
    }
}

});

parcelRegister("ey1K2", function(module, exports) {

$parcel$export(module.exports, "assertCurrentChain", () => $a9759783c5728277$export$390d312ab46d0597);

var $f4g5S = parcelRequire("f4g5S");
function $a9759783c5728277$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $f4g5S.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $f4g5S.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}

});
parcelRegister("f4g5S", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", () => $af83b69b1b45f2d5$export$f2b2bfa70417796b);
$parcel$export(module.exports, "ChainMismatchError", () => $af83b69b1b45f2d5$export$535d82255cc17992);
$parcel$export(module.exports, "ChainNotFoundError", () => $af83b69b1b45f2d5$export$b7f33b26fea1ae0b);
$parcel$export(module.exports, "ClientChainNotConfiguredError", () => $af83b69b1b45f2d5$export$64807f0e18658482);

var $hRZHI = parcelRequire("hRZHI");
class $af83b69b1b45f2d5$export$f2b2bfa70417796b extends (0, $hRZHI.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDoesNotSupportContract"
        });
    }
}
class $af83b69b1b45f2d5$export$535d82255cc17992 extends (0, $hRZHI.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainMismatchError"
        });
    }
}
class $af83b69b1b45f2d5$export$b7f33b26fea1ae0b extends (0, $hRZHI.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotFoundError"
        });
    }
}
class $af83b69b1b45f2d5$export$64807f0e18658482 extends (0, $hRZHI.BaseError) {
    constructor(){
        super("No chain was provided to the Client.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ClientChainNotConfiguredError"
        });
    }
}
class $af83b69b1b45f2d5$export$4836eb835ffca5b2 extends (0, $hRZHI.BaseError) {
    constructor({ chainId: chainId }){
        super(`Chain ID "${chainId}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidChainIdError"
        });
    }
}

});


parcelRegister("qRqH4", function(module, exports) {

$parcel$export(module.exports, "getTransactionError", () => $050bdfd1363810bb$export$da1758db1985646e);

var $jryAi = parcelRequire("jryAi");

var $i50rN = parcelRequire("i50rN");

var $hN2nD = parcelRequire("hN2nD");
function $050bdfd1363810bb$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $hN2nD.getNodeError)(err, args);
        if (cause instanceof (0, $jryAi.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $i50rN.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("jryAi", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", () => $e27b5da902e33527$export$a558573a20f90d54);
$parcel$export(module.exports, "FeeCapTooHighError", () => $e27b5da902e33527$export$63c545de2a2ec844);
$parcel$export(module.exports, "FeeCapTooLowError", () => $e27b5da902e33527$export$dbd5936ae1758966);
$parcel$export(module.exports, "NonceTooHighError", () => $e27b5da902e33527$export$6147426561fdc965);
$parcel$export(module.exports, "NonceTooLowError", () => $e27b5da902e33527$export$2bb6d6395b589b3b);
$parcel$export(module.exports, "NonceMaxValueError", () => $e27b5da902e33527$export$71cf1d500f9be262);
$parcel$export(module.exports, "InsufficientFundsError", () => $e27b5da902e33527$export$b276096bbba16879);
$parcel$export(module.exports, "IntrinsicGasTooHighError", () => $e27b5da902e33527$export$7ad883b4998b9615);
$parcel$export(module.exports, "IntrinsicGasTooLowError", () => $e27b5da902e33527$export$813ccdcce0428bcf);
$parcel$export(module.exports, "TransactionTypeNotSupportedError", () => $e27b5da902e33527$export$a20c52a8beca5c20);
$parcel$export(module.exports, "TipAboveFeeCapError", () => $e27b5da902e33527$export$6ef9dd5e2f836046);
$parcel$export(module.exports, "UnknownNodeError", () => $e27b5da902e33527$export$d6085363229de344);

var $5AWCV = parcelRequire("5AWCV");

var $hRZHI = parcelRequire("hRZHI");
class $e27b5da902e33527$export$a558573a20f90d54 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($e27b5da902e33527$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $e27b5da902e33527$export$63c545de2a2ec844 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $5AWCV.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooHigh"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $e27b5da902e33527$export$dbd5936ae1758966 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $5AWCV.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooLow"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $e27b5da902e33527$export$6147426561fdc965 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooHighError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $e27b5da902e33527$export$2bb6d6395b589b3b extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooLowError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $e27b5da902e33527$export$71cf1d500f9be262 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $e27b5da902e33527$export$b276096bbba16879 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds/
});
class $e27b5da902e33527$export$7ad883b4998b9615 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $e27b5da902e33527$export$813ccdcce0428bcf extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $e27b5da902e33527$export$a20c52a8beca5c20 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $e27b5da902e33527$export$6ef9dd5e2f836046 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $5AWCV.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $5AWCV.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($e27b5da902e33527$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $e27b5da902e33527$export$d6085363229de344 extends (0, $hRZHI.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownNodeError"
        });
    }
}

});
parcelRegister("5AWCV", function(module, exports) {

$parcel$export(module.exports, "formatGwei", () => $412dcaa0d6752898$export$a716d64a7f646b61);

var $53GlG = parcelRequire("53GlG");

var $fDKcx = parcelRequire("fDKcx");
function $412dcaa0d6752898$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $fDKcx.formatUnits)(wei, (0, $53GlG.gweiUnits)[unit]);
}

});
parcelRegister("53GlG", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $3aee15279d99e93f$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $3aee15279d99e93f$export$a26120bf8be88528);
$parcel$export(module.exports, "weiUnits", () => $3aee15279d99e93f$export$b959b3594ea07183);
const $3aee15279d99e93f$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $3aee15279d99e93f$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $3aee15279d99e93f$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("fDKcx", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $b62e561f19902e99$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits.html
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $b62e561f19902e99$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});



parcelRegister("i50rN", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", () => $d2990a7253a563d8$export$cde3d1388a9feac3);
$parcel$export(module.exports, "FeeConflictError", () => $d2990a7253a563d8$export$4e13f9693b10724d);
$parcel$export(module.exports, "InvalidSerializableTransactionError", () => $d2990a7253a563d8$export$f2282ba9c8899971);
$parcel$export(module.exports, "TransactionExecutionError", () => $d2990a7253a563d8$export$17fc407b5aeb1e96);
$parcel$export(module.exports, "TransactionNotFoundError", () => $d2990a7253a563d8$export$23c42bc218867b7c);
$parcel$export(module.exports, "TransactionReceiptNotFoundError", () => $d2990a7253a563d8$export$df65591684d92652);
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", () => $d2990a7253a563d8$export$69578a09754f4b33);

var $5btZA = parcelRequire("5btZA");

var $5AWCV = parcelRequire("5AWCV");

var $hRZHI = parcelRequire("hRZHI");
function $d2990a7253a563d8$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $d2990a7253a563d8$export$4e13f9693b10724d extends (0, $hRZHI.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeConflictError"
        });
    }
}
class $d2990a7253a563d8$export$8ffce3f13fa2ade4 extends (0, $hRZHI.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidLegacyVError"
        });
    }
}
class $d2990a7253a563d8$export$f2282ba9c8899971 extends (0, $hRZHI.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $d2990a7253a563d8$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializableTransactionError"
        });
    }
}
class $d2990a7253a563d8$export$e410925d6bb07863 extends (0, $hRZHI.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $d2990a7253a563d8$export$75fa267d8b74b3b9 extends (0, $hRZHI.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $d2990a7253a563d8$export$f5e370fd7cd91580 extends (0, $hRZHI.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStorageKeySizeError"
        });
    }
}
class $d2990a7253a563d8$export$17fc407b5aeb1e96 extends (0, $hRZHI.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $d2990a7253a563d8$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $5btZA.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $5AWCV.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionExecutionError"
        });
        this.cause = cause;
    }
}
class $d2990a7253a563d8$export$23c42bc218867b7c extends (0, $hRZHI.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionNotFoundError"
        });
    }
}
class $d2990a7253a563d8$export$df65591684d92652 extends (0, $hRZHI.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionReceiptNotFoundError"
        });
    }
}
class $d2990a7253a563d8$export$69578a09754f4b33 extends (0, $hRZHI.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});
parcelRegister("5btZA", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $3c653eb32f35b464$export$11bc63b4c03ea518);

var $53GlG = parcelRequire("53GlG");

var $fDKcx = parcelRequire("fDKcx");
function $3c653eb32f35b464$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $fDKcx.formatUnits)(wei, (0, $53GlG.etherUnits)[unit]);
}

});


parcelRegister("hN2nD", function(module, exports) {

$parcel$export(module.exports, "getNodeError", () => $cf38dbf1facb534f$export$218ee3a1c831c34e);

var $hRZHI = parcelRequire("hRZHI");

var $jryAi = parcelRequire("jryAi");

var $5pGkz = parcelRequire("5pGkz");

var $1mQc6 = parcelRequire("1mQc6");
function $cf38dbf1facb534f$export$620efda101db5601(err) {
    return err instanceof (0, $1mQc6.TransactionRejectedRpcError) || err instanceof (0, $1mQc6.InvalidInputRpcError) || err instanceof (0, $5pGkz.RpcRequestError) && err.code === (0, $jryAi.ExecutionRevertedError).code;
}
function $cf38dbf1facb534f$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err.walk((e)=>e.code === (0, $jryAi.ExecutionRevertedError).code);
    if (executionRevertedError instanceof (0, $hRZHI.BaseError)) return new (0, $jryAi.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $jryAi.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $jryAi.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $jryAi.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $jryAi.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $jryAi.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $jryAi.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $jryAi.NonceTooHighError).nodeMessage.test(message)) return new (0, $jryAi.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $jryAi.NonceTooLowError).nodeMessage.test(message)) return new (0, $jryAi.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $jryAi.NonceMaxValueError).nodeMessage.test(message)) return new (0, $jryAi.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $jryAi.InsufficientFundsError).nodeMessage.test(message)) return new (0, $jryAi.InsufficientFundsError)({
        cause: err
    });
    if ((0, $jryAi.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $jryAi.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $jryAi.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $jryAi.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $jryAi.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $jryAi.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $jryAi.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $jryAi.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $jryAi.UnknownNodeError)({
        cause: err
    });
}

});


parcelRegister("csjHW", function(module, exports) {

$parcel$export(module.exports, "extract", () => $9117631d6b9a70e8$export$f9380c9a627682d3);
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $9117631d6b9a70e8$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("2IJNQ", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", () => $1fb338567772b5e9$export$d23fcba447c86a8e);

var $hKqyW = parcelRequire("hKqyW");

var $7NJHE = parcelRequire("7NJHE");
const $1fb338567772b5e9$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2"
};
function $1fb338567772b5e9$export$d23fcba447c86a8e(transactionRequest) {
    return {
        ...transactionRequest,
        gas: typeof transactionRequest.gas !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.gas) : undefined,
        gasPrice: typeof transactionRequest.gasPrice !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.gasPrice) : undefined,
        maxFeePerGas: typeof transactionRequest.maxFeePerGas !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.maxPriorityFeePerGas) : undefined,
        nonce: typeof transactionRequest.nonce !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.nonce) : undefined,
        type: typeof transactionRequest.type !== "undefined" ? $1fb338567772b5e9$export$b2a848539dcbb25f[transactionRequest.type] : undefined,
        value: typeof transactionRequest.value !== "undefined" ? (0, $hKqyW.numberToHex)(transactionRequest.value) : undefined
    };
}
const $1fb338567772b5e9$export$aba208618cee26e3 = /*#__PURE__*/ (0, $7NJHE.defineFormatter)("transactionRequest", $1fb338567772b5e9$export$d23fcba447c86a8e);

});
parcelRegister("7NJHE", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", () => $5ae08fad12756671$export$5d08535cc975931a);
function $5ae08fad12756671$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("5vDfU", function(module, exports) {

$parcel$export(module.exports, "getAction", () => $402e4c5e54db030b$export$6ca3170acb89054);
/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $402e4c5e54db030b$export$6ca3170acb89054(client, action, // Some minifiers drop `Function.prototype.name`, meaning that `action.name`
// will not work. For that case, the consumer needs to pass the name explicitly.
name) {
    return (params)=>client[action.name || name]?.(params) ?? action(client, params);
}

});

parcelRegister("6AVm0", function(module, exports) {

$parcel$export(module.exports, "assertRequest", () => $4cd2982b2b76b0cb$export$5378021d985ceaf8);

var $3VerT = parcelRequire("3VerT");

var $2VOm9 = parcelRequire("2VOm9");

var $jryAi = parcelRequire("jryAi");

var $i50rN = parcelRequire("i50rN");

var $fCd4Y = parcelRequire("fCd4Y");
function $4cd2982b2b76b0cb$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $3VerT.parseAccount)(account_) : undefined;
    if (account && !(0, $fCd4Y.isAddress)(account.address)) throw new (0, $2VOm9.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $fCd4Y.isAddress)(to)) throw new (0, $2VOm9.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $i50rN.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $jryAi.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $jryAi.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("fYp3D", function(module, exports) {

$parcel$export(module.exports, "prepareTransactionRequest", () => $ba0fe5856150d7af$export$2e8a9232fb815d77);

var $3VerT = parcelRequire("3VerT");

var $7zqCh = parcelRequire("7zqCh");

var $62gnX = parcelRequire("62gnX");

var $iWQbX = parcelRequire("iWQbX");

var $6Tx2t = parcelRequire("6Tx2t");

var $guJoU = parcelRequire("guJoU");

var $9uU9Z = parcelRequire("9uU9Z");

var $5vDfU = parcelRequire("5vDfU");

var $6AVm0 = parcelRequire("6AVm0");

var $2creJ = parcelRequire("2creJ");
async function $ba0fe5856150d7af$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, chain: chain, gas: gas, nonce: nonce, type: type } = args;
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)();
    const account = (0, $3VerT.parseAccount)(account_);
    const block = await (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({
        blockTag: "latest"
    });
    const request = {
        ...args,
        from: account.address
    };
    if (typeof nonce === "undefined") request.nonce = await (0, $5vDfU.getAction)(client, (0, $6Tx2t.getTransactionCount), "getTransactionCount")({
        address: account.address,
        blockTag: "pending"
    });
    if (typeof type === "undefined") try {
        request.type = (0, $2creJ.getTransactionType)(request);
    } catch  {
        // infer type from block
        request.type = typeof block.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
    }
    if (request.type === "eip1559") {
        // EIP-1559 fees
        const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $7zqCh.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $9uU9Z.MaxFeePerGasTooLowError)({
            maxPriorityFeePerGas: maxPriorityFeePerGas
        });
        request.maxPriorityFeePerGas = maxPriorityFeePerGas;
        request.maxFeePerGas = maxFeePerGas;
    } else {
        // Legacy fees
        if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $9uU9Z.Eip1559FeesNotSupportedError)();
        const { gasPrice: gasPrice_ } = await (0, $7zqCh.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request,
            type: "legacy"
        });
        request.gasPrice = gasPrice_;
    }
    if (typeof gas === "undefined") request.gas = await (0, $5vDfU.getAction)(client, (0, $62gnX.estimateGas), "estimateGas")({
        ...request,
        account: {
            address: account.address,
            type: "json-rpc"
        }
    });
    (0, $6AVm0.assertRequest)(request);
    return request;
}

});
parcelRegister("7zqCh", function(module, exports) {

$parcel$export(module.exports, "estimateFeesPerGas", () => $583072be63735de2$export$8193bed8c46d2831);
$parcel$export(module.exports, "internal_estimateFeesPerGas", () => $583072be63735de2$export$67115e8707c5a9e);

var $9uU9Z = parcelRequire("9uU9Z");

var $5vDfU = parcelRequire("5vDfU");

var $7bzPW = parcelRequire("7bzPW");

var $iWQbX = parcelRequire("iWQbX");

var $cyKo6 = parcelRequire("cyKo6");
async function $583072be63735de2$export$8193bed8c46d2831(client, args) {
    return $583072be63735de2$export$67115e8707c5a9e(client, args);
}
async function $583072be63735de2$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $9uU9Z.BaseFeeScalarError)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") return chain.fees.estimateFeesPerGas({
        block: block_,
        client: client,
        multiply: multiply,
        request: request,
        type: type
    });
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $9uU9Z.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = request?.maxPriorityFeePerGas ? request.maxPriorityFeePerGas : await (0, $7bzPW.internal_estimateMaxPriorityFeePerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $5vDfU.getAction)(client, (0, $cyKo6.getGasPrice), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}

});
parcelRegister("9uU9Z", function(module, exports) {

$parcel$export(module.exports, "BaseFeeScalarError", () => $6ea27a9df674764f$export$200c092bedf29ac0);
$parcel$export(module.exports, "Eip1559FeesNotSupportedError", () => $6ea27a9df674764f$export$dcf53c0ae183fb46);
$parcel$export(module.exports, "MaxFeePerGasTooLowError", () => $6ea27a9df674764f$export$bcf9730904a1086f);

var $5AWCV = parcelRequire("5AWCV");

var $hRZHI = parcelRequire("hRZHI");
class $6ea27a9df674764f$export$200c092bedf29ac0 extends (0, $hRZHI.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseFeeScalarError"
        });
    }
}
class $6ea27a9df674764f$export$dcf53c0ae183fb46 extends (0, $hRZHI.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Eip1559FeesNotSupportedError"
        });
    }
}
class $6ea27a9df674764f$export$bcf9730904a1086f extends (0, $hRZHI.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $5AWCV.formatGwei)(maxPriorityFeePerGas)} gwei).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MaxFeePerGasTooLowError"
        });
    }
}

});

parcelRegister("7bzPW", function(module, exports) {

$parcel$export(module.exports, "estimateMaxPriorityFeePerGas", () => $53b55bec5af0a270$export$fd79a693887f886c);
$parcel$export(module.exports, "internal_estimateMaxPriorityFeePerGas", () => $53b55bec5af0a270$export$59275bafd388148);

var $9uU9Z = parcelRequire("9uU9Z");

var $8hd5S = parcelRequire("8hd5S");

var $5vDfU = parcelRequire("5vDfU");

var $iWQbX = parcelRequire("iWQbX");

var $cyKo6 = parcelRequire("cyKo6");
async function $53b55bec5af0a270$export$fd79a693887f886c(client, args) {
    return $53b55bec5af0a270$export$59275bafd388148(client, args);
}
async function $53b55bec5af0a270$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    if (typeof chain?.fees?.defaultPriorityFee === "function") {
        const block = block_ || await (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({});
        return chain.fees.defaultPriorityFee({
            block: block,
            client: client,
            request: request
        });
    }
    if (typeof chain?.fees?.defaultPriorityFee !== "undefined") return chain?.fees?.defaultPriorityFee;
    try {
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $8hd5S.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({}),
            (0, $5vDfU.getAction)(client, (0, $cyKo6.getGasPrice), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $9uU9Z.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}

});
parcelRegister("iWQbX", function(module, exports) {

$parcel$export(module.exports, "getBlock", () => $dcb62103d5d0c23b$export$ea0af84ed2e77902);

var $94N0Y = parcelRequire("94N0Y");

var $hKqyW = parcelRequire("hKqyW");

var $4GuSx = parcelRequire("4GuSx");
async function $dcb62103d5d0c23b$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    });
    if (!block) throw new (0, $94N0Y.BlockNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $4GuSx.formatBlock);
    return format(block);
}

});
parcelRegister("94N0Y", function(module, exports) {

$parcel$export(module.exports, "BlockNotFoundError", () => $69ba820e6ab947c8$export$f5a00468af285e38);

var $hRZHI = parcelRequire("hRZHI");
class $69ba820e6ab947c8$export$f5a00468af285e38 extends (0, $hRZHI.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BlockNotFoundError"
        });
    }
}

});

parcelRegister("4GuSx", function(module, exports) {

$parcel$export(module.exports, "formatBlock", () => $3693098ab0820354$export$ba1152bc4017d62a);

var $7NJHE = parcelRequire("7NJHE");

var $4FTzq = parcelRequire("4FTzq");
function $3693098ab0820354$export$ba1152bc4017d62a(block) {
    const transactions = block.transactions?.map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $4FTzq.formatTransaction)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $3693098ab0820354$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $7NJHE.defineFormatter)("block", $3693098ab0820354$export$ba1152bc4017d62a);

});
parcelRegister("4FTzq", function(module, exports) {

$parcel$export(module.exports, "transactionType", () => $367618df0cf7d2aa$export$cd5f936b62a5e91);
$parcel$export(module.exports, "formatTransaction", () => $367618df0cf7d2aa$export$b02b16590d26dadc);

var $8hd5S = parcelRequire("8hd5S");

var $7NJHE = parcelRequire("7NJHE");
const $367618df0cf7d2aa$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559"
};
function $367618df0cf7d2aa$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $8hd5S.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $8hd5S.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $367618df0cf7d2aa$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    return transaction_;
}
const $367618df0cf7d2aa$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $7NJHE.defineFormatter)("transaction", $367618df0cf7d2aa$export$b02b16590d26dadc);

});



parcelRegister("cyKo6", function(module, exports) {

$parcel$export(module.exports, "getGasPrice", () => $924ca4acb2695eb0$export$89c15b50d46d3f8c);
/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice.html
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $924ca4acb2695eb0$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}

});



parcelRegister("62gnX", function(module, exports) {

$parcel$export(module.exports, "estimateGas", () => $464fa3cad4fe34cd$export$e0580ae1f48db848);

var $3VerT = parcelRequire("3VerT");

var $guJoU = parcelRequire("guJoU");

var $hKqyW = parcelRequire("hKqyW");

var $1RCLO = parcelRequire("1RCLO");

var $csjHW = parcelRequire("csjHW");

var $2IJNQ = parcelRequire("2IJNQ");

var $6AVm0 = parcelRequire("6AVm0");

var $fYp3D = parcelRequire("fYp3D");
async function $464fa3cad4fe34cd$export$e0580ae1f48db848(client, args) {
    const account_ = args.account ?? client.account;
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)({
        docsPath: "/docs/actions/public/estimateGas"
    });
    const account = (0, $3VerT.parseAccount)(account_);
    try {
        const { accessList: accessList, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = account.type === "local" ? await (0, $fYp3D.prepareTransactionRequest)(client, args) : args;
        const blockNumberHex = blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        (0, $6AVm0.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $2IJNQ.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $csjHW.extract)(rest, {
                format: chainFormat
            }),
            from: account.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        const balance = await client.request({
            method: "eth_estimateGas",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        return BigInt(balance);
    } catch (err) {
        throw (0, $1RCLO.getEstimateGasError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}

});
parcelRegister("1RCLO", function(module, exports) {

$parcel$export(module.exports, "getEstimateGasError", () => $15b8d0a341634008$export$f201b805dbcd7c48);

var $hfI8D = parcelRequire("hfI8D");

var $jryAi = parcelRequire("jryAi");

var $hN2nD = parcelRequire("hN2nD");
function $15b8d0a341634008$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $hN2nD.getNodeError)(err, args);
        if (cause instanceof (0, $jryAi.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $hfI8D.EstimateGasExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("hfI8D", function(module, exports) {

$parcel$export(module.exports, "EstimateGasExecutionError", () => $c8f613512b0f1912$export$9e393e362ab0c102);

var $5btZA = parcelRequire("5btZA");

var $5AWCV = parcelRequire("5AWCV");

var $hRZHI = parcelRequire("hRZHI");

var $i50rN = parcelRequire("i50rN");
class $c8f613512b0f1912$export$9e393e362ab0c102 extends (0, $hRZHI.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $i50rN.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $5btZA.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $5AWCV.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EstimateGasExecutionError"
        });
        this.cause = cause;
    }
}

});



parcelRegister("6Tx2t", function(module, exports) {

$parcel$export(module.exports, "getTransactionCount", () => $505181f859f1addc$export$b18e66333ec1361e);

var $8hd5S = parcelRequire("8hd5S");

var $hKqyW = parcelRequire("hKqyW");
async function $505181f859f1addc$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : blockTag
        ]
    });
    return (0, $8hd5S.hexToNumber)(count);
}

});

parcelRegister("2creJ", function(module, exports) {

$parcel$export(module.exports, "getTransactionType", () => $19a1d45ca315e442$export$944c6678cd5a1ea8);

var $i50rN = parcelRequire("i50rN");
function $19a1d45ca315e442$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $i50rN.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}

});


parcelRegister("lmZn1", function(module, exports) {

$parcel$export(module.exports, "sendRawTransaction", () => $f8eb41e99a9abd09$export$4e309754b4830e29);
/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction.html
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $f8eb41e99a9abd09$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    });
}

});



parcelRegister("eOiCg", function(module, exports) {

$parcel$export(module.exports, "getAddresses", () => $ac842cfe7102082f$export$17d5f00cfd692b8a);

var $kRozl = parcelRequire("kRozl");
async function $ac842cfe7102082f$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === "local") return [
        client.account.address
    ];
    const addresses = await client.request({
        method: "eth_accounts"
    });
    return addresses.map((address)=>(0, $kRozl.checksumAddress)(address));
}

});

parcelRegister("3m4Ma", function(module, exports) {

$parcel$export(module.exports, "getPermissions", () => $271721908f94a12e$export$e10fd44ca431fa8e);
/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions.html
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $271721908f94a12e$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: "wallet_getPermissions"
    });
    return permissions;
}

});

parcelRegister("63GHZ", function(module, exports) {

$parcel$export(module.exports, "requestAddresses", () => $469426eeeb61f0dd$export$87c5bcc1dede6f06);

var $kRozl = parcelRequire("kRozl");
async function $469426eeeb61f0dd$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: "eth_requestAccounts"
    });
    return addresses.map((address)=>(0, $kRozl.getAddress)(address));
}

});

parcelRegister("4AJf1", function(module, exports) {

$parcel$export(module.exports, "requestPermissions", () => $357d9e3130d6f03a$export$8cec5d3683c6896e);
/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions.html
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $357d9e3130d6f03a$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: "wallet_requestPermissions",
        params: [
            permissions
        ]
    });
}

});

parcelRegister("3ikaK", function(module, exports) {

$parcel$export(module.exports, "signMessage", () => $2662b352a0ab4bbd$export$1d9a7a8a40780de);

var $3VerT = parcelRequire("3VerT");

var $guJoU = parcelRequire("guJoU");

var $hKqyW = parcelRequire("hKqyW");
async function $2662b352a0ab4bbd$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $3VerT.parseAccount)(account_);
    if (account.type === "local") return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $hKqyW.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $hKqyW.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    });
}

});

parcelRegister("dRPkG", function(module, exports) {

$parcel$export(module.exports, "signTransaction", () => $a1880b316b4aa44c$export$6ad02cc4966b42ab);

var $3VerT = parcelRequire("3VerT");

var $guJoU = parcelRequire("guJoU");


var $ey1K2 = parcelRequire("ey1K2");

var $2IJNQ = parcelRequire("2IJNQ");

var $5vDfU = parcelRequire("5vDfU");

var $hKqyW = parcelRequire("hKqyW");

var $6AVm0 = parcelRequire("6AVm0");

var $fG2bm = parcelRequire("fG2bm");
async function $a1880b316b4aa44c$export$6ad02cc4966b42ab(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = args;
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, $3VerT.parseAccount)(account_);
    (0, $6AVm0.assertRequest)({
        account: account,
        ...args
    });
    const chainId = await (0, $5vDfU.getAction)(client, (0, $fG2bm.getChainId), "getChainId")({});
    if (chain !== null) (0, $ey1K2.assertCurrentChain)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $2IJNQ.formatTransactionRequest);
    if (account.type === "local") return account.signTransaction({
        ...transaction,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: "eth_signTransaction",
        params: [
            {
                ...format(transaction),
                chainId: (0, $hKqyW.numberToHex)(chainId),
                from: account.address
            }
        ]
    });
}

});

parcelRegister("9lCy4", function(module, exports) {

$parcel$export(module.exports, "signTypedData", () => $6ce3fa233fdec7c3$export$9f05de2db4d31153);

var $3VerT = parcelRequire("3VerT");

var $guJoU = parcelRequire("guJoU");

var $01CEa = parcelRequire("01CEa");

var $41CuJ = parcelRequire("41CuJ");

var $7pLLx = parcelRequire("7pLLx");
async function $6ce3fa233fdec7c3$export$9f05de2db4d31153(client, { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    if (!account_) throw new (0, $guJoU.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, $3VerT.parseAccount)(account_);
    const types = {
        EIP712Domain: (0, $7pLLx.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $7pLLx.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.type === "local") return account.signTypedData({
        domain: domain,
        primaryType: primaryType,
        types: types,
        message: message
    });
    const typedData = (0, $41CuJ.stringify)({
        domain: domain ?? {},
        primaryType: primaryType,
        types: types,
        message: message
    }, (_, value)=>(0, $01CEa.isHex)(value) ? value.toLowerCase() : value);
    return client.request({
        method: "eth_signTypedData_v4",
        params: [
            account.address,
            typedData
        ]
    });
}

});
parcelRegister("7pLLx", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", () => $565feb79652f8587$export$fac174f558903e26);
$parcel$export(module.exports, "getTypesForEIP712Domain", () => $565feb79652f8587$export$6a292159484ee032);

var $ddib9 = parcelRequire("ddib9");

var $2VOm9 = parcelRequire("2VOm9");

var $fCd4Y = parcelRequire("fCd4Y");

var $getgY = parcelRequire("getgY");

var $hKqyW = parcelRequire("hKqyW");

var $15qcv = parcelRequire("15qcv");

var $kTHs7 = parcelRequire("kTHs7");
function $565feb79652f8587$export$fac174f558903e26({ domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    const types = types_;
    const validateData = (struct, value_)=>{
        for (const param of struct){
            const { name: name, type: type_ } = param;
            const type = type_;
            const value = value_[name];
            const integerMatch = type.match((0, $15qcv.integerRegex));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $hKqyW.numberToHex)(value, {
                    signed: base === "int",
                    size: parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $fCd4Y.isAddress)(value)) throw new (0, $2VOm9.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $15qcv.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $getgY.size)(value) !== parseInt(size_)) throw new (0, $ddib9.BytesSizeMismatchError)({
                    expectedSize: parseInt(size_),
                    givenSize: (0, $getgY.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    if (primaryType !== "EIP712Domain") {
        // Validate message types.
        const type = types[primaryType];
        validateData(type, message);
    }
}
function $565feb79652f8587$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        typeof domain?.chainId === "number" && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $565feb79652f8587$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $kTHs7.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $565feb79652f8587$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}

});
parcelRegister("15qcv", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", () => $0caa94faf8c9222b$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $0caa94faf8c9222b$export$45902cc189596eef);
const $0caa94faf8c9222b$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $0caa94faf8c9222b$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $0caa94faf8c9222b$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});

parcelRegister("kTHs7", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", () => $f36aa67ace109812$export$9e2bd399d9aaab56);
$parcel$export(module.exports, "hashDomain", () => $f36aa67ace109812$export$d4e887b08c47faea);
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $e9Gwc = parcelRequire("e9Gwc");

var $kTOx8 = parcelRequire("kTOx8");

var $hKqyW = parcelRequire("hKqyW");

var $cq8a0 = parcelRequire("cq8a0");

var $7pLLx = parcelRequire("7pLLx");
function $f36aa67ace109812$export$9e2bd399d9aaab56({ domain: domain_, message: message, primaryType: primaryType, types: types_ }) {
    const domain = typeof domain_ === "undefined" ? {} : domain_;
    const types = {
        EIP712Domain: (0, $7pLLx.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $7pLLx.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($f36aa67ace109812$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($f36aa67ace109812$var$hashStruct({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $cq8a0.keccak256)((0, $kTOx8.concat)(parts));
}
function $f36aa67ace109812$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $f36aa67ace109812$var$hashStruct({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $f36aa67ace109812$var$hashStruct({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $f36aa67ace109812$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $cq8a0.keccak256)(encoded);
}
function $f36aa67ace109812$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $f36aa67ace109812$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $f36aa67ace109812$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $e9Gwc.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $f36aa67ace109812$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $hKqyW.toHex)($f36aa67ace109812$var$encodeType({
        primaryType: primaryType,
        types: types
    }));
    return (0, $cq8a0.keccak256)(encodedHashType);
}
function $f36aa67ace109812$var$encodeType({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $f36aa67ace109812$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $f36aa67ace109812$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$f36aa67ace109812$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $f36aa67ace109812$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $cq8a0.keccak256)($f36aa67ace109812$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $cq8a0.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $cq8a0.keccak256)((0, $hKqyW.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$f36aa67ace109812$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $cq8a0.keccak256)((0, $e9Gwc.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});



parcelRegister("hnXQr", function(module, exports) {

$parcel$export(module.exports, "switchChain", () => $ca83019ab37fbc22$export$15599da40e72d2f);

var $hKqyW = parcelRequire("hKqyW");
async function $ca83019ab37fbc22$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: (0, $hKqyW.numberToHex)(id)
            }
        ]
    });
}

});

parcelRegister("dUqG4", function(module, exports) {

$parcel$export(module.exports, "watchAsset", () => $a20532f0150d301c$export$7eea68d1a70548bd);
/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset.html
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $a20532f0150d301c$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: "wallet_watchAsset",
        params: params
    });
    return added;
}

});

parcelRegister("4hCRV", function(module, exports) {

$parcel$export(module.exports, "writeContract", () => $31e6e67b1f6439f8$export$4c0f201bc17cbf23);

var $bpUXq = parcelRequire("bpUXq");

var $5vDfU = parcelRequire("5vDfU");

var $fGDeB = parcelRequire("fGDeB");
async function $31e6e67b1f6439f8$export$4c0f201bc17cbf23(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request }) {
    const data = (0, $bpUXq.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    const hash = await (0, $5vDfU.getAction)(client, (0, $fGDeB.sendTransaction), "sendTransaction")({
        data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
        to: address,
        ...request
    });
    return hash;
}

});
parcelRegister("bpUXq", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", () => $84fe3610f7e7c85c$export$f4ee15df45da9f03);

var $ddib9 = parcelRequire("ddib9");

var $kTOx8 = parcelRequire("kTOx8");

var $1JPyH = parcelRequire("1JPyH");

var $e9Gwc = parcelRequire("e9Gwc");

var $lU0UI = parcelRequire("lU0UI");

var $gIJMr = parcelRequire("gIJMr");
function $84fe3610f7e7c85c$export$f4ee15df45da9f03({ abi: abi, args: args, functionName: functionName }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $gIJMr.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $ddib9.AbiFunctionNotFoundError)(functionName, {
            docsPath: "/docs/contract/encodeFunctionData"
        });
    }
    if (abiItem.type !== "function") throw new (0, $ddib9.AbiFunctionNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeFunctionData"
    });
    const definition = (0, $lU0UI.formatAbiItem)(abiItem);
    const signature = (0, $1JPyH.getFunctionSelector)(definition);
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $e9Gwc.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $kTOx8.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("1JPyH", function(module, exports) {

$parcel$export(module.exports, "getFunctionSelector", () => $1441fce482cfa995$export$98bae2de9b88fbac);

var $btGtV = parcelRequire("btGtV");

var $9sHEt = parcelRequire("9sHEt");

var $8EOJl = parcelRequire("8EOJl");

var $cq8a0 = parcelRequire("cq8a0");
const $1441fce482cfa995$var$hash = (value)=>(0, $cq8a0.keccak256)((0, $9sHEt.toBytes)(value));
const $1441fce482cfa995$export$98bae2de9b88fbac = (fn)=>(0, $btGtV.slice)($1441fce482cfa995$var$hash((0, $8EOJl.getFunctionSignature)(fn)), 0, 4);

});
parcelRegister("8EOJl", function(module, exports) {

$parcel$export(module.exports, "getFunctionSignature", () => $64d969230a9e4840$export$d7a3ed3159f7637d);

var $7DCXE = parcelRequire("7DCXE");

var $gNptd = parcelRequire("gNptd");
const $64d969230a9e4840$export$d7a3ed3159f7637d = (fn_)=>{
    const fn = (()=>{
        if (typeof fn_ === "string") return fn_;
        return (0, $7DCXE.formatAbiItem)(fn_);
    })();
    return (0, $gNptd.normalizeSignature)(fn);
};

});
parcelRegister("7DCXE", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $58fa65c77bb178ce$export$dc5d0ff4fc2fdee1);

var $6CWrw = parcelRequire("6CWrw");
function $58fa65c77bb178ce$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $6CWrw.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $6CWrw.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    else if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $6CWrw.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $6CWrw.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "constructor") return `constructor(${(0, $6CWrw.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    else if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("6CWrw", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", () => $4d33a038748858a0$export$c55dbda1a081631e);

var $8NuvV = parcelRequire("8NuvV");
function $4d33a038748858a0$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $8NuvV.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("8NuvV", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", () => $667a91c6a53cbbcf$export$c75e01ebc733dc6b);

var $hMUqM = parcelRequire("hMUqM");
const $667a91c6a53cbbcf$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $667a91c6a53cbbcf$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($667a91c6a53cbbcf$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $667a91c6a53cbbcf$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $hMUqM.execTyped)($667a91c6a53cbbcf$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $667a91c6a53cbbcf$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("hMUqM", function(module, exports) {

$parcel$export(module.exports, "execTyped", () => $cf32b15b387dc70a$export$1cca4755fb17f5bd);
function $cf32b15b387dc70a$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $cf32b15b387dc70a$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $cf32b15b387dc70a$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $cf32b15b387dc70a$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("gNptd", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", () => $c3a4fad0637e9a76$export$5cba87ebe4d0307a);

var $hRZHI = parcelRequire("hRZHI");
function $c3a4fad0637e9a76$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $hRZHI.BaseError)("Unable to normalize signature.");
    return result;
}

});



parcelRegister("gIJMr", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", () => $c2c4446f88d064e9$export$99b134cd177e9574);


var $ddib9 = parcelRequire("ddib9");

var $01CEa = parcelRequire("01CEa");

var $iXtZJ = parcelRequire("iXtZJ");

var $1JPyH = parcelRequire("1JPyH");

var $fCd4Y = parcelRequire("fCd4Y");
function $c2c4446f88d064e9$export$99b134cd177e9574({ abi: abi, args: args = [], name: name }) {
    const isSelector = (0, $01CEa.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $1JPyH.getFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $iXtZJ.getEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $c2c4446f88d064e9$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $c2c4446f88d064e9$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $ddib9.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $c2c4446f88d064e9$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $fCd4Y.isAddress)(arg);
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $c2c4446f88d064e9$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$c2c4446f88d064e9$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $c2c4446f88d064e9$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $c2c4446f88d064e9$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $fCd4Y.isAddress)(args[parameterIndex]);
            if (types.includes("address") && types.includes("bytes")) return (0, $fCd4Y.isAddress)(args[parameterIndex]);
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("iXtZJ", function(module, exports) {

$parcel$export(module.exports, "getEventSelector", () => $dcd501067c294c1e$export$199f4d2b0dfd4569);

var $9sHEt = parcelRequire("9sHEt");

var $aqjCV = parcelRequire("aqjCV");

var $cq8a0 = parcelRequire("cq8a0");
const $dcd501067c294c1e$var$hash = (value)=>(0, $cq8a0.keccak256)((0, $9sHEt.toBytes)(value));
const $dcd501067c294c1e$export$199f4d2b0dfd4569 = (fn)=>$dcd501067c294c1e$var$hash((0, $aqjCV.getEventSignature)(fn));

});
parcelRegister("aqjCV", function(module, exports) {

$parcel$export(module.exports, "getEventSignature", () => $796b8e8c795a9345$export$8edf22f667ee2562);

var $8EOJl = parcelRequire("8EOJl");
const $796b8e8c795a9345$export$8edf22f667ee2562 = (fn)=>{
    return (0, $8EOJl.getFunctionSignature)(fn);
};

});







parcelRegister("9kZsO", function(module, exports) {

$parcel$export(module.exports, "custom", () => $6cc5a8b682091ac4$export$4c00f665f0d4b443);

var $6WKkf = parcelRequire("6WKkf");
function $6cc5a8b682091ac4$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $6WKkf.createTransport)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}

});
parcelRegister("6WKkf", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $50ec182a72bdb6e3$export$d09f50d9ab7f7b69);

var $3NSu6 = parcelRequire("3NSu6");
function $50ec182a72bdb6e3$export$d09f50d9ab7f7b69({ key: key, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $3NSu6.buildRequest)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay
        }),
        value: value
    };
}

});
parcelRegister("3NSu6", function(module, exports) {

$parcel$export(module.exports, "isDeterministicError", () => $2c50362bbca6413e$export$9c98b0fe9b5c1674);
$parcel$export(module.exports, "buildRequest", () => $2c50362bbca6413e$export$6c5295ef7e82f2b2);

var $hRZHI = parcelRequire("hRZHI");

var $5pGkz = parcelRequire("5pGkz");

var $1mQc6 = parcelRequire("1mQc6");

var $8dquR = parcelRequire("8dquR");
const $2c50362bbca6413e$export$9c98b0fe9b5c1674 = (error)=>{
    if ("code" in error) return error.code !== -1 && error.code !== -32004 && error.code !== -32005 && error.code !== -32042 && error.code !== -32603;
    if (error instanceof (0, $5pGkz.HttpRequestError) && error.status) return error.status !== 403 && error.status !== 408 && error.status !== 413 && error.status !== 429 && error.status !== 500 && error.status !== 502 && error.status !== 503 && error.status !== 504;
    return false;
};
function $2c50362bbca6413e$export$6c5295ef7e82f2b2(request, { retryDelay: retryDelay = 150, retryCount: retryCount = 3 } = {}) {
    return async (args)=>(0, $8dquR.withRetry)(async ()=>{
            try {
                return await request(args);
            } catch (err_) {
                const err = err_;
                switch(err.code){
                    // -32700
                    case (0, $1mQc6.ParseRpcError).code:
                        throw new (0, $1mQc6.ParseRpcError)(err);
                    // -32600
                    case (0, $1mQc6.InvalidRequestRpcError).code:
                        throw new (0, $1mQc6.InvalidRequestRpcError)(err);
                    // -32601
                    case (0, $1mQc6.MethodNotFoundRpcError).code:
                        throw new (0, $1mQc6.MethodNotFoundRpcError)(err);
                    // -32602
                    case (0, $1mQc6.InvalidParamsRpcError).code:
                        throw new (0, $1mQc6.InvalidParamsRpcError)(err);
                    // -32603
                    case (0, $1mQc6.InternalRpcError).code:
                        throw new (0, $1mQc6.InternalRpcError)(err);
                    // -32000
                    case (0, $1mQc6.InvalidInputRpcError).code:
                        throw new (0, $1mQc6.InvalidInputRpcError)(err);
                    // -32001
                    case (0, $1mQc6.ResourceNotFoundRpcError).code:
                        throw new (0, $1mQc6.ResourceNotFoundRpcError)(err);
                    // -32002
                    case (0, $1mQc6.ResourceUnavailableRpcError).code:
                        throw new (0, $1mQc6.ResourceUnavailableRpcError)(err);
                    // -32003
                    case (0, $1mQc6.TransactionRejectedRpcError).code:
                        throw new (0, $1mQc6.TransactionRejectedRpcError)(err);
                    // -32004
                    case (0, $1mQc6.MethodNotSupportedRpcError).code:
                        throw new (0, $1mQc6.MethodNotSupportedRpcError)(err);
                    // -32005
                    case (0, $1mQc6.LimitExceededRpcError).code:
                        throw new (0, $1mQc6.LimitExceededRpcError)(err);
                    // -32006
                    case (0, $1mQc6.JsonRpcVersionUnsupportedError).code:
                        throw new (0, $1mQc6.JsonRpcVersionUnsupportedError)(err);
                    // 4001
                    case (0, $1mQc6.UserRejectedRequestError).code:
                        throw new (0, $1mQc6.UserRejectedRequestError)(err);
                    // 4100
                    case (0, $1mQc6.UnauthorizedProviderError).code:
                        throw new (0, $1mQc6.UnauthorizedProviderError)(err);
                    // 4200
                    case (0, $1mQc6.UnsupportedProviderMethodError).code:
                        throw new (0, $1mQc6.UnsupportedProviderMethodError)(err);
                    // 4900
                    case (0, $1mQc6.ProviderDisconnectedError).code:
                        throw new (0, $1mQc6.ProviderDisconnectedError)(err);
                    // 4901
                    case (0, $1mQc6.ChainDisconnectedError).code:
                        throw new (0, $1mQc6.ChainDisconnectedError)(err);
                    // 4902
                    case (0, $1mQc6.SwitchChainError).code:
                        throw new (0, $1mQc6.SwitchChainError)(err);
                    // CAIP-25: User Rejected Error
                    // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                    case 5000:
                        throw new (0, $1mQc6.UserRejectedRequestError)(err);
                    default:
                        if (err_ instanceof (0, $hRZHI.BaseError)) throw err_;
                        throw new (0, $1mQc6.UnknownRpcError)(err);
                }
            }
        }, {
            delay: ({ count: count, error: error })=>{
                // If we find a Retry-After header, let's retry after the given time.
                if (error && error instanceof (0, $5pGkz.HttpRequestError)) {
                    const retryAfter = error?.headers?.get("Retry-After");
                    if (retryAfter?.match(/\d/)) return parseInt(retryAfter) * 1000;
                }
                // Otherwise, let's retry with an exponential backoff.
                return ~~(1 << count) * retryDelay;
            },
            retryCount: retryCount,
            shouldRetry: ({ error: error })=>!$2c50362bbca6413e$export$9c98b0fe9b5c1674(error)
        });
}

});
parcelRegister("8dquR", function(module, exports) {

$parcel$export(module.exports, "withRetry", () => $5fb4175b30aab47d$export$188df5ecf8e7961a);

var $6Sfwh = parcelRequire("6Sfwh");
function $5fb4175b30aab47d$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $6Sfwh.wait)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}

});
parcelRegister("6Sfwh", function(module, exports) {

$parcel$export(module.exports, "wait", () => $5013d3177d75fa00$export$5c069c93d2b7493f);
async function $5013d3177d75fa00$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}

});






parcelRegister("l3rDK", function(module, exports) {

$parcel$export(module.exports, "__privateGet", () => $f53f51864e65790b$export$18a094aefa070634);
$parcel$export(module.exports, "__privateAdd", () => $f53f51864e65790b$export$addf369becd23283);
$parcel$export(module.exports, "__privateSet", () => $f53f51864e65790b$export$42432efe6614d3b4);
$parcel$export(module.exports, "__privateMethod", () => $f53f51864e65790b$export$fa92d15b718fce20);
var $f53f51864e65790b$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $f53f51864e65790b$export$18a094aefa070634 = (obj, member, getter)=>{
    $f53f51864e65790b$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $f53f51864e65790b$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $f53f51864e65790b$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $f53f51864e65790b$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $f53f51864e65790b$export$fa92d15b718fce20 = (obj, member, method)=>{
    $f53f51864e65790b$var$__accessCheck(obj, member, "access private method");
    return method;
};

});

parcelRegister("83kyS", function(module, exports) {

$parcel$export(module.exports, "createPublicClient", () => $5dce8d9beeb05858$export$d8e090d8c6a7a6ad);

var $j15d8 = parcelRequire("j15d8");

var $8J6TO = parcelRequire("8J6TO");
function $5dce8d9beeb05858$export$d8e090d8c6a7a6ad(parameters) {
    const { key: key = "public", name: name = "Public Client" } = parameters;
    const client = (0, $j15d8.createClient)({
        ...parameters,
        key: key,
        name: name,
        type: "publicClient"
    });
    return client.extend((0, $8J6TO.publicActions));
}

});
parcelRegister("8J6TO", function(module, exports) {

$parcel$export(module.exports, "publicActions", () => $65a7e0bf97c89ecd$export$8705b583fa097d24);

var $9tNbV = parcelRequire("9tNbV");

var $Gf6FT = parcelRequire("Gf6FT");

var $585Nk = parcelRequire("585Nk");

var $t0kAd = parcelRequire("t0kAd");

var $43V7q = parcelRequire("43V7q");

var $5UENw = parcelRequire("5UENw");

var $e7SwC = parcelRequire("e7SwC");

var $faFP4 = parcelRequire("faFP4");

var $8EBm8 = parcelRequire("8EBm8");

var $5CdWx = parcelRequire("5CdWx");

var $6sOif = parcelRequire("6sOif");

var $7zqCh = parcelRequire("7zqCh");

var $62gnX = parcelRequire("62gnX");

var $7bzPW = parcelRequire("7bzPW");

var $5He1z = parcelRequire("5He1z");

var $iWQbX = parcelRequire("iWQbX");

var $3UJoG = parcelRequire("3UJoG");

var $ih5nb = parcelRequire("ih5nb");

var $iF16N = parcelRequire("iF16N");

var $fG2bm = parcelRequire("fG2bm");

var $dTTZ8 = parcelRequire("dTTZ8");

var $kFa52 = parcelRequire("kFa52");

var $6TIie = parcelRequire("6TIie");

var $lp9LI = parcelRequire("lp9LI");

var $cyKo6 = parcelRequire("cyKo6");

var $5Nq0J = parcelRequire("5Nq0J");

var $eaoEh = parcelRequire("eaoEh");

var $atvoB = parcelRequire("atvoB");

var $hXcoh = parcelRequire("hXcoh");

var $b2g55 = parcelRequire("b2g55");

var $6Tx2t = parcelRequire("6Tx2t");

var $61kUj = parcelRequire("61kUj");

var $4zwOV = parcelRequire("4zwOV");

var $2R9Q8 = parcelRequire("2R9Q8");

var $lAUaG = parcelRequire("lAUaG");

var $4XNZD = parcelRequire("4XNZD");

var $5jn9g = parcelRequire("5jn9g");

var $5Tu5P = parcelRequire("5Tu5P");

var $iiw4Y = parcelRequire("iiw4Y");

var $4tCqx = parcelRequire("4tCqx");

var $9xZqj = parcelRequire("9xZqj");

var $aJhYs = parcelRequire("aJhYs");

var $6qc7z = parcelRequire("6qc7z");

var $6tj4z = parcelRequire("6tj4z");

var $fYp3D = parcelRequire("fYp3D");

var $lmZn1 = parcelRequire("lmZn1");
function $65a7e0bf97c89ecd$export$8705b583fa097d24(client) {
    return {
        call: (args)=>(0, $5UENw.call)(client, args),
        createBlockFilter: ()=>(0, $e7SwC.createBlockFilter)(client),
        createContractEventFilter: (args)=>(0, $faFP4.createContractEventFilter)(client, args),
        createEventFilter: (args)=>(0, $8EBm8.createEventFilter)(client, args),
        createPendingTransactionFilter: ()=>(0, $5CdWx.createPendingTransactionFilter)(client),
        estimateContractGas: (args)=>(0, $6sOif.estimateContractGas)(client, args),
        estimateGas: (args)=>(0, $62gnX.estimateGas)(client, args),
        getBalance: (args)=>(0, $5He1z.getBalance)(client, args),
        getBlock: (args)=>(0, $iWQbX.getBlock)(client, args),
        getBlockNumber: (args)=>(0, $3UJoG.getBlockNumber)(client, args),
        getBlockTransactionCount: (args)=>(0, $ih5nb.getBlockTransactionCount)(client, args),
        getBytecode: (args)=>(0, $iF16N.getBytecode)(client, args),
        getChainId: ()=>(0, $fG2bm.getChainId)(client),
        getContractEvents: (args)=>(0, $dTTZ8.getContractEvents)(client, args),
        getEnsAddress: (args)=>(0, $9tNbV.getEnsAddress)(client, args),
        getEnsAvatar: (args)=>(0, $Gf6FT.getEnsAvatar)(client, args),
        getEnsName: (args)=>(0, $585Nk.getEnsName)(client, args),
        getEnsResolver: (args)=>(0, $t0kAd.getEnsResolver)(client, args),
        getEnsText: (args)=>(0, $43V7q.getEnsText)(client, args),
        getFeeHistory: (args)=>(0, $kFa52.getFeeHistory)(client, args),
        estimateFeesPerGas: (args)=>(0, $7zqCh.estimateFeesPerGas)(client, args),
        getFilterChanges: (args)=>(0, $6TIie.getFilterChanges)(client, args),
        getFilterLogs: (args)=>(0, $lp9LI.getFilterLogs)(client, args),
        getGasPrice: ()=>(0, $cyKo6.getGasPrice)(client),
        getLogs: (args)=>(0, $5Nq0J.getLogs)(client, args),
        getProof: (args)=>(0, $eaoEh.getProof)(client, args),
        estimateMaxPriorityFeePerGas: (args)=>(0, $7bzPW.estimateMaxPriorityFeePerGas)(client, args),
        getStorageAt: (args)=>(0, $atvoB.getStorageAt)(client, args),
        getTransaction: (args)=>(0, $hXcoh.getTransaction)(client, args),
        getTransactionConfirmations: (args)=>(0, $b2g55.getTransactionConfirmations)(client, args),
        getTransactionCount: (args)=>(0, $6Tx2t.getTransactionCount)(client, args),
        getTransactionReceipt: (args)=>(0, $61kUj.getTransactionReceipt)(client, args),
        multicall: (args)=>(0, $4zwOV.multicall)(client, args),
        prepareTransactionRequest: (args)=>(0, $fYp3D.prepareTransactionRequest)(client, args),
        readContract: (args)=>(0, $2R9Q8.readContract)(client, args),
        sendRawTransaction: (args)=>(0, $lmZn1.sendRawTransaction)(client, args),
        simulateContract: (args)=>(0, $lAUaG.simulateContract)(client, args),
        verifyMessage: (args)=>(0, $5jn9g.verifyMessage)(client, args),
        verifyTypedData: (args)=>(0, $5Tu5P.verifyTypedData)(client, args),
        uninstallFilter: (args)=>(0, $4XNZD.uninstallFilter)(client, args),
        waitForTransactionReceipt: (args)=>(0, $iiw4Y.waitForTransactionReceipt)(client, args),
        watchBlocks: (args)=>(0, $9xZqj.watchBlocks)(client, args),
        watchBlockNumber: (args)=>(0, $4tCqx.watchBlockNumber)(client, args),
        watchContractEvent: (args)=>(0, $aJhYs.watchContractEvent)(client, args),
        watchEvent: (args)=>(0, $6qc7z.watchEvent)(client, args),
        watchPendingTransactions: (args)=>(0, $6tj4z.watchPendingTransactions)(client, args)
    };
}

});
parcelRegister("9tNbV", function(module, exports) {

$parcel$export(module.exports, "getEnsAddress", () => $6e6cfae232f96e6a$export$24b77c7e87f05b8d);

var $kbkUi = parcelRequire("kbkUi");

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $avhWP = parcelRequire("avhWP");

var $bTOZ4 = parcelRequire("bTOZ4");

var $hKqyW = parcelRequire("hKqyW");

var $3x0mD = parcelRequire("3x0mD");

var $4GcYa = parcelRequire("4GcYa");

var $eOVQX = parcelRequire("eOVQX");

var $5vDfU = parcelRequire("5vDfU");

var $2R9Q8 = parcelRequire("2R9Q8");
async function $6e6cfae232f96e6a$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $bpUXq.encodeFunctionData)({
            abi: (0, $kbkUi.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $4GcYa.namehash)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $4GcYa.namehash)(name)
                ]
            }
        });
        const res = await (0, $5vDfU.getAction)(client, (0, $2R9Q8.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $kbkUi.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $hKqyW.toHex)((0, $eOVQX.packetToBytes)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const address = (0, $6FtIl.decodeFunctionResult)({
            abi: (0, $kbkUi.addressResolverAbi),
            args: coinType != null ? [
                (0, $4GcYa.namehash)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $bTOZ4.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if ((0, $3x0mD.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});
parcelRegister("kbkUi", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", () => $eb150d6725c582b1$export$4e233219477ffb48);
$parcel$export(module.exports, "universalResolverResolveAbi", () => $eb150d6725c582b1$export$400f1d40cf4f98fe);
$parcel$export(module.exports, "universalResolverReverseAbi", () => $eb150d6725c582b1$export$fd0db820daeebac9);
$parcel$export(module.exports, "textResolverAbi", () => $eb150d6725c582b1$export$4e6990b9fd834e88);
$parcel$export(module.exports, "addressResolverAbi", () => $eb150d6725c582b1$export$4c61cc2994c5d90b);
$parcel$export(module.exports, "universalSignatureValidatorAbi", () => $eb150d6725c582b1$export$b10682c3fa53fbd1);
/* [Multicall3](https://github.com/mds1/multicall) */ const $eb150d6725c582b1$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $eb150d6725c582b1$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    }
];
const $eb150d6725c582b1$export$400f1d40cf4f98fe = [
    ...$eb150d6725c582b1$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $eb150d6725c582b1$export$fd0db820daeebac9 = [
    ...$eb150d6725c582b1$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $eb150d6725c582b1$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $eb150d6725c582b1$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $eb150d6725c582b1$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $eb150d6725c582b1$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_signer",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];

});

parcelRegister("6FtIl", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", () => $4dad9f0aa3ca166d$export$3a05a90c230f925);

var $ddib9 = parcelRequire("ddib9");

var $f8KNN = parcelRequire("f8KNN");

var $gIJMr = parcelRequire("gIJMr");
const $4dad9f0aa3ca166d$var$docsPath = "/docs/contract/decodeFunctionResult";
function $4dad9f0aa3ca166d$export$3a05a90c230f925({ abi: abi, args: args, functionName: functionName, data: data }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $gIJMr.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $ddib9.AbiFunctionNotFoundError)(functionName, {
            docsPath: $4dad9f0aa3ca166d$var$docsPath
        });
    }
    if (abiItem.type !== "function") throw new (0, $ddib9.AbiFunctionNotFoundError)(undefined, {
        docsPath: $4dad9f0aa3ca166d$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $ddib9.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $4dad9f0aa3ca166d$var$docsPath
    });
    const values = (0, $f8KNN.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});
parcelRegister("f8KNN", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", () => $b05be84b9a5b7add$export$84d51ac2fffabd56);

var $ddib9 = parcelRequire("ddib9");

var $kRozl = parcelRequire("kRozl");

var $getgY = parcelRequire("getgY");

var $btGtV = parcelRequire("btGtV");

var $bTOZ4 = parcelRequire("bTOZ4");

var $8hd5S = parcelRequire("8hd5S");

var $e9Gwc = parcelRequire("e9Gwc");
function $b05be84b9a5b7add$export$84d51ac2fffabd56(params, data) {
    if (data === "0x" && params.length > 0) throw new (0, $ddib9.AbiDecodingZeroDataError)();
    if ((0, $getgY.size)(data) && (0, $getgY.size)(data) < 32) throw new (0, $ddib9.AbiDecodingDataSizeTooSmallError)({
        data: data,
        params: params,
        size: (0, $getgY.size)(data)
    });
    return $b05be84b9a5b7add$var$decodeParams({
        data: data,
        params: params
    });
}
function $b05be84b9a5b7add$var$decodeParams({ data: data, params: params }) {
    const decodedValues = [];
    let position = 0;
    for(let i = 0; i < params.length; i++){
        if (position >= (0, $getgY.size)(data)) throw new (0, $ddib9.AbiDecodingDataSizeTooSmallError)({
            data: data,
            params: params,
            size: (0, $getgY.size)(data)
        });
        const param = params[i];
        const { consumed: consumed, value: value } = $b05be84b9a5b7add$var$decodeParam({
            data: data,
            param: param,
            position: position
        });
        decodedValues.push(value);
        // Step across the data by the amount of data consumed by this parameter.
        position += consumed;
    }
    return decodedValues;
}
function $b05be84b9a5b7add$var$decodeParam({ data: data, param: param, position: position }) {
    const arrayComponents = (0, $e9Gwc.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $b05be84b9a5b7add$var$decodeArray(data, {
            length: length,
            param: {
                ...param,
                type: type
            },
            position: position
        });
    }
    if (param.type === "tuple") return $b05be84b9a5b7add$var$decodeTuple(data, {
        param: param,
        position: position
    });
    if (param.type === "string") return $b05be84b9a5b7add$var$decodeString(data, {
        position: position
    });
    if (param.type.startsWith("bytes")) return $b05be84b9a5b7add$var$decodeBytes(data, {
        param: param,
        position: position
    });
    const value = (0, $btGtV.slice)(data, position, position + 32, {
        strict: true
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $b05be84b9a5b7add$var$decodeNumber(value, {
        param: param
    });
    if (param.type === "address") return $b05be84b9a5b7add$var$decodeAddress(value);
    if (param.type === "bool") return $b05be84b9a5b7add$var$decodeBool(value);
    throw new (0, $ddib9.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
function $b05be84b9a5b7add$var$decodeAddress(value) {
    return {
        consumed: 32,
        value: (0, $kRozl.checksumAddress)((0, $btGtV.slice)(value, -20))
    };
}
function $b05be84b9a5b7add$var$decodeArray(data, { param: param, length: length, position: position }) {
    // If the length of the array is not known in advance (dynamic array),
    // we will need to decode the offset of the array data.
    if (!length) {
        // Get the offset of the array data.
        const offset = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, position, position + 32, {
            strict: true
        }));
        // Get the length of the array from the offset.
        const length = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, offset, offset + 32, {
            strict: true
        }));
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const decodedChild = $b05be84b9a5b7add$var$decodeParam({
                data: (0, $btGtV.slice)(data, offset + 32),
                param: param,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($b05be84b9a5b7add$var$hasDynamicChild(param)) {
        // Get the child type of the array.
        const arrayComponents = (0, $e9Gwc.getArrayComponents)(param.type);
        // If the child type is not known, the array is dynamic.
        const dynamicChild = !arrayComponents?.[0];
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const offset = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, position, position + 32, {
                strict: true
            }));
            const decodedChild = $b05be84b9a5b7add$var$decodeParam({
                data: (0, $btGtV.slice)(data, offset),
                param: param,
                position: dynamicChild ? consumed : i * 32
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of each element in the array is known,
    // the array data is encoded contiguously after the array.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const decodedChild = $b05be84b9a5b7add$var$decodeParam({
            data: data,
            param: param,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value.push(decodedChild.value);
    }
    return {
        value: value,
        consumed: consumed
    };
}
function $b05be84b9a5b7add$var$decodeBool(value) {
    return {
        consumed: 32,
        value: (0, $8hd5S.hexToBool)(value)
    };
}
function $b05be84b9a5b7add$var$decodeBytes(data, { param: param, position: position }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // If we don't have a size, we're dealing with a dynamic-size array
        // so we need to read the offset of the data part first.
        const offset = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, position, position + 32, {
            strict: true
        }));
        const length = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, offset, offset + 32, {
            strict: true
        }));
        // If there is no length, we have zero data.
        if (length === 0) return {
            consumed: 32,
            value: "0x"
        };
        const value = (0, $btGtV.slice)(data, offset + 32, offset + 32 + length, {
            strict: true
        });
        return {
            consumed: 32,
            value: value
        };
    }
    const value = (0, $btGtV.slice)(data, position, position + parseInt(size), {
        strict: true
    });
    return {
        consumed: 32,
        value: value
    };
}
function $b05be84b9a5b7add$var$decodeNumber(value, { param: param }) {
    const signed = param.type.startsWith("int");
    const size = parseInt(param.type.split("int")[1] || "256");
    return {
        consumed: 32,
        value: size > 48 ? (0, $8hd5S.hexToBigInt)(value, {
            signed: signed
        }) : (0, $8hd5S.hexToNumber)(value, {
            signed: signed
        })
    };
}
function $b05be84b9a5b7add$var$decodeString(data, { position: position }) {
    const offset = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, position, position + 32, {
        strict: true
    }));
    const length = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, offset, offset + 32, {
        strict: true
    }));
    // If there is no length, we have zero data (empty string).
    if (length === 0) return {
        consumed: 32,
        value: ""
    };
    const value = (0, $8hd5S.hexToString)((0, $bTOZ4.trim)((0, $btGtV.slice)(data, offset + 32, offset + 32 + length, {
        strict: true
    })));
    return {
        consumed: 32,
        value: value
    };
}
function $b05be84b9a5b7add$var$decodeTuple(data, { param: param, position: position }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($b05be84b9a5b7add$var$hasDynamicChild(param)) {
        const offset = (0, $8hd5S.hexToNumber)((0, $btGtV.slice)(data, position, position + 32, {
            strict: true
        }));
        // Decode each component of the tuple, starting at the offset.
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            const decodedChild = $b05be84b9a5b7add$var$decodeParam({
                data: (0, $btGtV.slice)(data, offset),
                param: component,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
        }
        return {
            consumed: 32,
            value: value
        };
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const decodedChild = $b05be84b9a5b7add$var$decodeParam({
            data: data,
            param: component,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
    }
    return {
        consumed: consumed,
        value: value
    };
}
function $b05be84b9a5b7add$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($b05be84b9a5b7add$var$hasDynamicChild);
    const arrayComponents = (0, $e9Gwc.getArrayComponents)(param.type);
    if (arrayComponents && $b05be84b9a5b7add$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});


parcelRegister("avhWP", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", () => $7a5ab8b884c3d207$export$cf4414608a078996);

var $f4g5S = parcelRequire("f4g5S");
function $7a5ab8b884c3d207$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $f4g5S.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $f4g5S.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("3x0mD", function(module, exports) {

$parcel$export(module.exports, "isNullUniversalResolverError", () => $2924bc7042e1e20c$export$78f90e26b9356cd7);

var $uQNGc = parcelRequire("uQNGc");

var $hRZHI = parcelRequire("hRZHI");

var $34q4g = parcelRequire("34q4g");
function $2924bc7042e1e20c$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $hRZHI.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $34q4g.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $34q4g.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $uQNGc.panicReasons)[50]) return true;
    return false;
}

});
parcelRegister("uQNGc", function(module, exports) {

$parcel$export(module.exports, "panicReasons", () => $05cbc27e2c4fbf00$export$a618024566d3d221);
$parcel$export(module.exports, "solidityError", () => $05cbc27e2c4fbf00$export$730e9cc7aaa8ca20);
$parcel$export(module.exports, "solidityPanic", () => $05cbc27e2c4fbf00$export$e45b3aea1c5b33e6);
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $05cbc27e2c4fbf00$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $05cbc27e2c4fbf00$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $05cbc27e2c4fbf00$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("34q4g", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", () => $23c5f75496b2be56$export$e67b04e2cd29b7d);
$parcel$export(module.exports, "ContractFunctionExecutionError", () => $23c5f75496b2be56$export$399e62fddbe24423);
$parcel$export(module.exports, "ContractFunctionRevertedError", () => $23c5f75496b2be56$export$b3a6b9663001535f);
$parcel$export(module.exports, "ContractFunctionZeroDataError", () => $23c5f75496b2be56$export$46f5208cdcd5a621);
$parcel$export(module.exports, "RawContractError", () => $23c5f75496b2be56$export$5b877bc4d7d9d460);

var $3VerT = parcelRequire("3VerT");

var $uQNGc = parcelRequire("uQNGc");

var $exqIB = parcelRequire("exqIB");

var $lU0UI = parcelRequire("lU0UI");

var $7mZYv = parcelRequire("7mZYv");

var $gIJMr = parcelRequire("gIJMr");

var $5btZA = parcelRequire("5btZA");

var $5AWCV = parcelRequire("5AWCV");

var $ddib9 = parcelRequire("ddib9");

var $hRZHI = parcelRequire("hRZHI");

var $i50rN = parcelRequire("i50rN");

var $k9Ckd = parcelRequire("k9Ckd");
class $23c5f75496b2be56$export$e67b04e2cd29b7d extends (0, $hRZHI.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const account = account_ ? (0, $3VerT.parseAccount)(account_) : undefined;
        const prettyArgs = (0, $i50rN.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $5btZA.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $5AWCV.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $5AWCV.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CallExecutionError"
        });
        this.cause = cause;
    }
}
class $23c5f75496b2be56$export$399e62fddbe24423 extends (0, $hRZHI.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $gIJMr.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $7mZYv.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $lU0UI.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $i50rN.prettyPrint)({
            address: contractAddress && (0, $k9Ckd.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Contract Call:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionExecutionError"
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $23c5f75496b2be56$export$b3a6b9663001535f extends (0, $hRZHI.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $exqIB.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $uQNGc.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $lU0UI.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $7mZYv.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $ddib9.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.reason = reason;
        this.signature = signature;
    }
}
class $23c5f75496b2be56$export$46f5208cdcd5a621 extends (0, $hRZHI.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionZeroDataError"
        });
    }
}
class $23c5f75496b2be56$export$5b877bc4d7d9d460 extends (0, $hRZHI.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "");
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RawContractError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("exqIB", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", () => $a958df7687580621$export$8f7898b7bcae6080);

var $uQNGc = parcelRequire("uQNGc");

var $ddib9 = parcelRequire("ddib9");

var $btGtV = parcelRequire("btGtV");

var $1JPyH = parcelRequire("1JPyH");

var $f8KNN = parcelRequire("f8KNN");

var $lU0UI = parcelRequire("lU0UI");
function $a958df7687580621$export$8f7898b7bcae6080({ abi: abi, data: data }) {
    const signature = (0, $btGtV.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $ddib9.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $uQNGc.solidityError),
        (0, $uQNGc.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $1JPyH.getFunctionSelector)((0, $lU0UI.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $ddib9.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $f8KNN.decodeAbiParameters)(abiItem.inputs, (0, $btGtV.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});

parcelRegister("7mZYv", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", () => $55daa9613e81879c$export$5266ec2b0e3e9205);

var $41CuJ = parcelRequire("41CuJ");
function $55daa9613e81879c$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $41CuJ.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});



parcelRegister("4GcYa", function(module, exports) {

$parcel$export(module.exports, "namehash", () => $3685251aab4eee16$export$91d651ee363e1209);

var $kTOx8 = parcelRequire("kTOx8");

var $9sHEt = parcelRequire("9sHEt");

var $hKqyW = parcelRequire("hKqyW");

var $cq8a0 = parcelRequire("cq8a0");

var $Dvqqs = parcelRequire("Dvqqs");
function $3685251aab4eee16$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $hKqyW.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $Dvqqs.encodedLabelToLabelhash)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $9sHEt.toBytes)(hashFromEncodedLabel) : (0, $cq8a0.keccak256)((0, $9sHEt.stringToBytes)(labels[i]), "bytes");
        result = (0, $cq8a0.keccak256)((0, $kTOx8.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $hKqyW.bytesToHex)(result);
}

});
parcelRegister("Dvqqs", function(module, exports) {

$parcel$export(module.exports, "encodedLabelToLabelhash", () => $076c050705f30b58$export$cbf748cac2e87c52);

var $01CEa = parcelRequire("01CEa");
function $076c050705f30b58$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $01CEa.isHex)(hash)) return null;
    return hash;
}

});


parcelRegister("eOVQX", function(module, exports) {

$parcel$export(module.exports, "packetToBytes", () => $aca29ca62142dbb7$export$8a0899f9ded0844);

var $9sHEt = parcelRequire("9sHEt");

var $mQCZ0 = parcelRequire("mQCZ0");

var $5Y1RG = parcelRequire("5Y1RG");
function $aca29ca62142dbb7$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $9sHEt.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $9sHEt.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $9sHEt.stringToBytes)((0, $mQCZ0.encodeLabelhash)((0, $5Y1RG.labelhash)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}

});
parcelRegister("mQCZ0", function(module, exports) {

$parcel$export(module.exports, "encodeLabelhash", () => $044ae0f709f4c548$export$c23ac52da6ff5062);
function $044ae0f709f4c548$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}

});

parcelRegister("5Y1RG", function(module, exports) {

$parcel$export(module.exports, "labelhash", () => $458400ac0d7f1e59$export$83615f6c30436a69);

var $9sHEt = parcelRequire("9sHEt");

var $hKqyW = parcelRequire("hKqyW");

var $cq8a0 = parcelRequire("cq8a0");

var $Dvqqs = parcelRequire("Dvqqs");
function $458400ac0d7f1e59$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $hKqyW.bytesToHex)(result);
    return (0, $Dvqqs.encodedLabelToLabelhash)(label) || (0, $cq8a0.keccak256)((0, $9sHEt.stringToBytes)(label));
}

});


parcelRegister("2R9Q8", function(module, exports) {

$parcel$export(module.exports, "readContract", () => $21482a021bb226f4$export$43af7de392176737);

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $fkFeI = parcelRequire("fkFeI");

var $5vDfU = parcelRequire("5vDfU");

var $5UENw = parcelRequire("5UENw");
async function $21482a021bb226f4$export$43af7de392176737(client, { abi: abi, address: address, args: args, functionName: functionName, ...callRequest }) {
    const calldata = (0, $bpUXq.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $5vDfU.getAction)(client, (0, $5UENw.call), "call")({
            data: calldata,
            to: address,
            ...callRequest
        });
        return (0, $6FtIl.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (err) {
        throw (0, $fkFeI.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}

});
parcelRegister("fkFeI", function(module, exports) {

$parcel$export(module.exports, "getContractError", () => $b298b5f3a899d3f8$export$4414444aba6ddd8a);

var $ddib9 = parcelRequire("ddib9");

var $hRZHI = parcelRequire("hRZHI");

var $34q4g = parcelRequire("34q4g");

var $1mQc6 = parcelRequire("1mQc6");
const $b298b5f3a899d3f8$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $b298b5f3a899d3f8$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const { code: code, data: data, message: message, shortMessage: shortMessage } = err instanceof (0, $34q4g.RawContractError) ? err : err instanceof (0, $hRZHI.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const cause = (()=>{
        if (err instanceof (0, $ddib9.AbiDecodingZeroDataError)) return new (0, $34q4g.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $b298b5f3a899d3f8$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $1mQc6.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $34q4g.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage ?? message
        });
        return err;
    })();
    return new (0, $34q4g.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}

});

parcelRegister("5UENw", function(module, exports) {

$parcel$export(module.exports, "call", () => $44e1d4464aa0456a$export$848feb93d8f32b9b);

var $3VerT = parcelRequire("3VerT");

var $kbkUi = parcelRequire("kbkUi");

var $5ernn = parcelRequire("5ernn");

var $hRZHI = parcelRequire("hRZHI");

var $f4g5S = parcelRequire("f4g5S");

var $34q4g = parcelRequire("34q4g");

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $avhWP = parcelRequire("avhWP");

var $hKqyW = parcelRequire("hKqyW");

var $aqnZ2 = parcelRequire("aqnZ2");

var $csjHW = parcelRequire("csjHW");

var $2IJNQ = parcelRequire("2IJNQ");

var $l9LFI = parcelRequire("l9LFI");

var $6AVm0 = parcelRequire("6AVm0");

async function $44e1d4464aa0456a$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    const account = account_ ? (0, $3VerT.parseAccount)(account_) : undefined;
    try {
        (0, $6AVm0.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $2IJNQ.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $csjHW.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        if (batch && $44e1d4464aa0456a$var$shouldPerformMulticall({
            request: request
        })) try {
            return await $44e1d4464aa0456a$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $f4g5S.ClientChainNotConfiguredError)) && !(err instanceof (0, $f4g5S.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $44e1d4464aa0456a$export$6ef1a527f868ca75(err);
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("6C7Ni"));
        if (data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        throw (0, $aqnZ2.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $44e1d4464aa0456a$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $5ernn.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $44e1d4464aa0456a$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $f4g5S.ClientChainNotConfiguredError)();
        multicallAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $l9LFI.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $bpUXq.encodeFunctionData)({
                abi: (0, $kbkUi.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $6FtIl.decodeFunctionResult)({
                abi: (0, $kbkUi.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $34q4g.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $44e1d4464aa0456a$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $hRZHI.BaseError))) return undefined;
    const error = err.walk();
    return typeof error.data === "object" ? error.data.data : error.data;
}

});
parcelRegister("5ernn", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", () => $3cf37ee3e64b7c2e$export$25fd9a7ba13a8409);
const $3cf37ee3e64b7c2e$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("aqnZ2", function(module, exports) {

$parcel$export(module.exports, "getCallError", () => $796eefb02f9aee03$export$7a3a4dfb724485e1);

var $34q4g = parcelRequire("34q4g");

var $jryAi = parcelRequire("jryAi");

var $hN2nD = parcelRequire("hN2nD");
function $796eefb02f9aee03$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $hN2nD.getNodeError)(err, args);
        if (cause instanceof (0, $jryAi.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $34q4g.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});

parcelRegister("l9LFI", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", () => $f66f6adaa32c109b$export$24d3fde68b7c4167);
const $f66f6adaa32c109b$var$schedulerCache = /*#__PURE__*/ new Map();
function $f66f6adaa32c109b$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.reject?.(err);
            }
        });
    };
    const flush = ()=>$f66f6adaa32c109b$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$f66f6adaa32c109b$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$f66f6adaa32c109b$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const pendingPromise = {};
            const promise = new Promise((resolve, reject)=>{
                pendingPromise.resolve = resolve;
                pendingPromise.reject = reject;
            });
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    pendingPromise: pendingPromise
                });
                return promise;
            }
            setScheduler({
                args: args,
                pendingPromise: pendingPromise
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});

parcelRegister("6C7Ni", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c6XYb").then(()=>parcelRequire("d36sf"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});





parcelRegister("Gf6FT", function(module, exports) {

$parcel$export(module.exports, "getEnsAvatar", () => $07efa439c9457d8d$export$65f1d2b9649a54e5);

var $hTa5l = parcelRequire("hTa5l");

var $5vDfU = parcelRequire("5vDfU");

var $43V7q = parcelRequire("43V7q");
async function $07efa439c9457d8d$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, name: name, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $5vDfU.getAction)(client, (0, $43V7q.getEnsText), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress
    });
    if (!record) return null;
    try {
        return await (0, $hTa5l.parseAvatarRecord)(client, {
            record: record,
            gatewayUrls: gatewayUrls
        });
    } catch  {
        return null;
    }
}

});
parcelRegister("hTa5l", function(module, exports) {

$parcel$export(module.exports, "parseAvatarRecord", () => $d05f656e9d81a905$export$3713446b2fba5);

var $fGhNh = parcelRequire("fGhNh");
async function $d05f656e9d81a905$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $d05f656e9d81a905$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $fGhNh.parseAvatarUri)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $d05f656e9d81a905$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $fGhNh.parseNftUri)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $fGhNh.getNftTokenUri)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $fGhNh.resolveAvatarUri)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $fGhNh.parseAvatarUri)({
            uri: (0, $fGhNh.getJsonImage)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $fGhNh.getMetadataAvatarUri)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}

});
parcelRegister("fGhNh", function(module, exports) {

$parcel$export(module.exports, "resolveAvatarUri", () => $b6a894b96be8b697$export$9c878106a0d8edac);
$parcel$export(module.exports, "getJsonImage", () => $b6a894b96be8b697$export$9be3fe34a3333ecb);
$parcel$export(module.exports, "getMetadataAvatarUri", () => $b6a894b96be8b697$export$b9759ed161b5e3c5);
$parcel$export(module.exports, "parseAvatarUri", () => $b6a894b96be8b697$export$1f4e569649d3a793);
$parcel$export(module.exports, "parseNftUri", () => $b6a894b96be8b697$export$e78cf22c9d52ca8a);
$parcel$export(module.exports, "getNftTokenUri", () => $b6a894b96be8b697$export$29b8ee2b96a1ed4f);

var $2R9Q8 = parcelRequire("2R9Q8");

var $40KXy = parcelRequire("40KXy");
const $b6a894b96be8b697$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $b6a894b96be8b697$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $b6a894b96be8b697$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $b6a894b96be8b697$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $b6a894b96be8b697$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $b6a894b96be8b697$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $b6a894b96be8b697$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $b6a894b96be8b697$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $b6a894b96be8b697$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $b6a894b96be8b697$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($b6a894b96be8b697$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $b6a894b96be8b697$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($b6a894b96be8b697$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $40KXy.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $b6a894b96be8b697$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $40KXy.EnsAvatarInvalidMetadataError)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $b6a894b96be8b697$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $b6a894b96be8b697$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $b6a894b96be8b697$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $40KXy.EnsAvatarUriResolutionError)({
            uri: uri
        });
    }
}
async function $b6a894b96be8b697$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $b6a894b96be8b697$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $b6a894b96be8b697$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $40KXy.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $b6a894b96be8b697$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $40KXy.EnsAvatarInvalidNftUriError)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $40KXy.EnsAvatarInvalidNftUriError)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $40KXy.EnsAvatarInvalidNftUriError)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $40KXy.EnsAvatarInvalidNftUriError)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $40KXy.EnsAvatarInvalidNftUriError)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $b6a894b96be8b697$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $2R9Q8.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $2R9Q8.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $40KXy.EnsAvatarUnsupportedNamespaceError)({
        namespace: nft.namespace
    });
}

});
parcelRegister("40KXy", function(module, exports) {

$parcel$export(module.exports, "EnsAvatarInvalidMetadataError", () => $2ebb96b98cdee95b$export$3d9377558041f9cf);
$parcel$export(module.exports, "EnsAvatarInvalidNftUriError", () => $2ebb96b98cdee95b$export$74a8ea52cecec305);
$parcel$export(module.exports, "EnsAvatarUriResolutionError", () => $2ebb96b98cdee95b$export$f202ff3d50da14eb);
$parcel$export(module.exports, "EnsAvatarUnsupportedNamespaceError", () => $2ebb96b98cdee95b$export$45137f20297c5e74);

var $hRZHI = parcelRequire("hRZHI");
class $2ebb96b98cdee95b$export$3d9377558041f9cf extends (0, $hRZHI.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $2ebb96b98cdee95b$export$74a8ea52cecec305 extends (0, $hRZHI.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $2ebb96b98cdee95b$export$f202ff3d50da14eb extends (0, $hRZHI.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUriResolutionError"
        });
    }
}
class $2ebb96b98cdee95b$export$45137f20297c5e74 extends (0, $hRZHI.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}

});



parcelRegister("43V7q", function(module, exports) {

$parcel$export(module.exports, "getEnsText", () => $2f53bfd23f8e1808$export$2b2c96dabd62b431);

var $kbkUi = parcelRequire("kbkUi");

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $avhWP = parcelRequire("avhWP");

var $hKqyW = parcelRequire("hKqyW");

var $3x0mD = parcelRequire("3x0mD");

var $4GcYa = parcelRequire("4GcYa");

var $eOVQX = parcelRequire("eOVQX");

var $5vDfU = parcelRequire("5vDfU");

var $2R9Q8 = parcelRequire("2R9Q8");
async function $2f53bfd23f8e1808$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const res = await (0, $5vDfU.getAction)(client, (0, $2R9Q8.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $kbkUi.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $hKqyW.toHex)((0, $eOVQX.packetToBytes)(name)),
                (0, $bpUXq.encodeFunctionData)({
                    abi: (0, $kbkUi.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $4GcYa.namehash)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const record = (0, $6FtIl.decodeFunctionResult)({
            abi: (0, $kbkUi.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if ((0, $3x0mD.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});


parcelRegister("585Nk", function(module, exports) {

$parcel$export(module.exports, "getEnsName", () => $3bc231ccb3bb3781$export$e1b98d9bc05a9fc2);

var $kbkUi = parcelRequire("kbkUi");

var $avhWP = parcelRequire("avhWP");

var $hKqyW = parcelRequire("hKqyW");

var $3x0mD = parcelRequire("3x0mD");

var $eOVQX = parcelRequire("eOVQX");

var $5vDfU = parcelRequire("5vDfU");

var $2R9Q8 = parcelRequire("2R9Q8");
async function $3bc231ccb3bb3781$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const [name, resolvedAddress] = await (0, $5vDfU.getAction)(client, (0, $2R9Q8.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $kbkUi.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $hKqyW.toHex)((0, $eOVQX.packetToBytes)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if ((0, $3x0mD.isNullUniversalResolverError)(err, "reverse")) return null;
        throw err;
    }
}

});

parcelRegister("t0kAd", function(module, exports) {

$parcel$export(module.exports, "getEnsResolver", () => $0572f7465c6414ac$export$ba1240cd558e6b31);

var $avhWP = parcelRequire("avhWP");

var $hKqyW = parcelRequire("hKqyW");

var $eOVQX = parcelRequire("eOVQX");

var $5vDfU = parcelRequire("5vDfU");

var $2R9Q8 = parcelRequire("2R9Q8");
async function $0572f7465c6414ac$export$ba1240cd558e6b31(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const [resolverAddress] = await (0, $5vDfU.getAction)(client, (0, $2R9Q8.readContract), "readContract")({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [
                    {
                        type: "bytes"
                    }
                ],
                name: "findResolver",
                outputs: [
                    {
                        type: "address"
                    },
                    {
                        type: "bytes32"
                    }
                ],
                stateMutability: "view",
                type: "function"
            }
        ],
        functionName: "findResolver",
        args: [
            (0, $hKqyW.toHex)((0, $eOVQX.packetToBytes)(name))
        ],
        blockNumber: blockNumber,
        blockTag: blockTag
    });
    return resolverAddress;
}

});

parcelRegister("e7SwC", function(module, exports) {

$parcel$export(module.exports, "createBlockFilter", () => $a48c03aa7af8b02a$export$651edd5ecf84bf98);

var $kP653 = parcelRequire("kP653");
async function $a48c03aa7af8b02a$export$651edd5ecf84bf98(client) {
    const getRequest = (0, $kP653.createFilterRequestScope)(client, {
        method: "eth_newBlockFilter"
    });
    const id = await client.request({
        method: "eth_newBlockFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "block"
    };
}

});
parcelRegister("kP653", function(module, exports) {

$parcel$export(module.exports, "createFilterRequestScope", () => $f28d498420544abb$export$b7aadf80a875f555);
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $f28d498420544abb$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}

});


parcelRegister("faFP4", function(module, exports) {

$parcel$export(module.exports, "createContractEventFilter", () => $b0b83b49d0e3d88b$export$36f99fdb90149e8b);

var $6Pvid = parcelRequire("6Pvid");

var $hKqyW = parcelRequire("hKqyW");

var $kP653 = parcelRequire("kP653");
async function $b0b83b49d0e3d88b$export$36f99fdb90149e8b(client, { address: address, abi: abi, args: args, eventName: eventName, fromBlock: fromBlock, strict: strict, toBlock: toBlock }) {
    const getRequest = (0, $kP653.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    const topics = eventName ? (0, $6Pvid.encodeEventTopics)({
        abi: abi,
        args: args,
        eventName: eventName
    }) : undefined;
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $hKqyW.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $hKqyW.numberToHex)(toBlock) : toBlock,
                topics: topics
            }
        ]
    });
    return {
        abi: abi,
        args: args,
        eventName: eventName,
        id: id,
        request: getRequest(id),
        strict: strict,
        type: "event"
    };
}

});
parcelRegister("6Pvid", function(module, exports) {

$parcel$export(module.exports, "encodeEventTopics", () => $4f8fc79d071d2e5d$export$64e9f7ca5ce29acd);

var $ddib9 = parcelRequire("ddib9");

var $dUbUe = parcelRequire("dUbUe");

var $9sHEt = parcelRequire("9sHEt");

var $iXtZJ = parcelRequire("iXtZJ");

var $cq8a0 = parcelRequire("cq8a0");

var $e9Gwc = parcelRequire("e9Gwc");

var $lU0UI = parcelRequire("lU0UI");

var $gIJMr = parcelRequire("gIJMr");
function $4f8fc79d071d2e5d$export$64e9f7ca5ce29acd({ abi: abi, eventName: eventName, args: args }) {
    let abiItem = abi[0];
    if (eventName) {
        abiItem = (0, $gIJMr.getAbiItem)({
            abi: abi,
            args: args,
            name: eventName
        });
        if (!abiItem) throw new (0, $ddib9.AbiEventNotFoundError)(eventName, {
            docsPath: "/docs/contract/encodeEventTopics"
        });
    }
    if (abiItem.type !== "event") throw new (0, $ddib9.AbiEventNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeEventTopics"
    });
    const definition = (0, $lU0UI.formatAbiItem)(abiItem);
    const signature = (0, $iXtZJ.getEventSelector)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>Array.isArray(args_[i]) ? args_[i].map((_, j)=>$4f8fc79d071d2e5d$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                })) : args_[i] ? $4f8fc79d071d2e5d$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $4f8fc79d071d2e5d$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $cq8a0.keccak256)((0, $9sHEt.toBytes)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $dUbUe.FilterTypeNotSupportedError)(param.type);
    return (0, $e9Gwc.encodeAbiParameters)([
        param
    ], [
        value
    ]);
}

});
parcelRegister("dUbUe", function(module, exports) {

$parcel$export(module.exports, "FilterTypeNotSupportedError", () => $a1f9bd98f1c14d38$export$f71f080d25382681);

var $hRZHI = parcelRequire("hRZHI");
class $a1f9bd98f1c14d38$export$f71f080d25382681 extends (0, $hRZHI.BaseError) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FilterTypeNotSupportedError"
        });
    }
}

});



parcelRegister("8EBm8", function(module, exports) {

$parcel$export(module.exports, "createEventFilter", () => $64cf094def49e4fe$export$977ab14bbccde633);

var $6Pvid = parcelRequire("6Pvid");

var $hKqyW = parcelRequire("hKqyW");

var $kP653 = parcelRequire("kP653");
async function $64cf094def49e4fe$export$977ab14bbccde633(client, { address: address, args: args, event: event, events: events_, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = {}) {
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    const getRequest = (0, $kP653.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $6Pvid.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $hKqyW.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $hKqyW.numberToHex)(toBlock) : toBlock,
                ...topics.length ? {
                    topics: topics
                } : {}
            }
        ]
    });
    return {
        abi: events,
        args: args,
        eventName: event ? event.name : undefined,
        fromBlock: fromBlock,
        id: id,
        request: getRequest(id),
        strict: strict,
        toBlock: toBlock,
        type: "event"
    };
}

});

parcelRegister("5CdWx", function(module, exports) {

$parcel$export(module.exports, "createPendingTransactionFilter", () => $416b51297871ee70$export$d455ed04c3e85241);

var $kP653 = parcelRequire("kP653");
async function $416b51297871ee70$export$d455ed04c3e85241(client) {
    const getRequest = (0, $kP653.createFilterRequestScope)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}

});

parcelRegister("6sOif", function(module, exports) {

$parcel$export(module.exports, "estimateContractGas", () => $4b4c5eca93b89094$export$7b896b3a3695de87);

var $3VerT = parcelRequire("3VerT");

var $bpUXq = parcelRequire("bpUXq");

var $fkFeI = parcelRequire("fkFeI");

var $5vDfU = parcelRequire("5vDfU");

var $62gnX = parcelRequire("62gnX");
async function $4b4c5eca93b89094$export$7b896b3a3695de87(client, { abi: abi, address: address, args: args, functionName: functionName, ...request }) {
    const data = (0, $bpUXq.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const gas = await (0, $5vDfU.getAction)(client, (0, $62gnX.estimateGas), "estimateGas")({
            data: data,
            to: address,
            ...request
        });
        return gas;
    } catch (err) {
        const account = request.account ? (0, $3VerT.parseAccount)(request.account) : undefined;
        throw (0, $fkFeI.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/estimateContractGas",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("5He1z", function(module, exports) {

$parcel$export(module.exports, "getBalance", () => $425bd8d29784efa2$export$df96cd8d56be0ab1);

var $hKqyW = parcelRequire("hKqyW");
async function $425bd8d29784efa2$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}

});

parcelRegister("3UJoG", function(module, exports) {

$parcel$export(module.exports, "getBlockNumber", () => $2d99d101fd725dc2$export$9328b5c92c53a20e);

var $7CQ94 = parcelRequire("7CQ94");
const $2d99d101fd725dc2$var$cacheKey = (id)=>`blockNumber.${id}`;
function $2d99d101fd725dc2$export$bc78c57a2d1b4a2b(id) {
    return (0, $7CQ94.getCache)($2d99d101fd725dc2$var$cacheKey(id));
}
async function $2d99d101fd725dc2$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime, maxAge: maxAge } = {}) {
    const blockNumberHex = await (0, $7CQ94.withCache)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $2d99d101fd725dc2$var$cacheKey(client.uid),
        cacheTime: maxAge ?? cacheTime
    });
    return BigInt(blockNumberHex);
}

});
parcelRegister("7CQ94", function(module, exports) {

$parcel$export(module.exports, "getCache", () => $58d48801bb7e4a0f$export$e2575ed62a2f107b);
$parcel$export(module.exports, "withCache", () => $58d48801bb7e4a0f$export$33b32b3abf8170f0);
const $58d48801bb7e4a0f$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $58d48801bb7e4a0f$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $58d48801bb7e4a0f$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $58d48801bb7e4a0f$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $58d48801bb7e4a0f$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $58d48801bb7e4a0f$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Infinity }) {
    const cache = $58d48801bb7e4a0f$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}

});


parcelRegister("ih5nb", function(module, exports) {

$parcel$export(module.exports, "getBlockTransactionCount", () => $d4ddfb7da7704217$export$8c2de5be7f4dfc0);

var $8hd5S = parcelRequire("8hd5S");

var $hKqyW = parcelRequire("hKqyW");
async function $d4ddfb7da7704217$export$8c2de5be7f4dfc0(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = "latest" } = {}) {
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    let count;
    if (blockHash) count = await client.request({
        method: "eth_getBlockTransactionCountByHash",
        params: [
            blockHash
        ]
    });
    else count = await client.request({
        method: "eth_getBlockTransactionCountByNumber",
        params: [
            blockNumberHex || blockTag
        ]
    });
    return (0, $8hd5S.hexToNumber)(count);
}

});

parcelRegister("iF16N", function(module, exports) {

$parcel$export(module.exports, "getBytecode", () => $d95cea7de30a231d$export$81e5c8d8c8aa6ce1);

var $hKqyW = parcelRequire("hKqyW");
async function $d95cea7de30a231d$export$81e5c8d8c8aa6ce1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const hex = await client.request({
        method: "eth_getCode",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    if (hex === "0x") return undefined;
    return hex;
}

});

parcelRegister("dTTZ8", function(module, exports) {

$parcel$export(module.exports, "getContractEvents", () => $a1ebd6e517c86175$export$1e175955db02d8d);

var $gIJMr = parcelRequire("gIJMr");

var $5vDfU = parcelRequire("5vDfU");

var $5Nq0J = parcelRequire("5Nq0J");
async function $a1ebd6e517c86175$export$1e175955db02d8d(client, { abi: abi, address: address, args: args, blockHash: blockHash, eventName: eventName, fromBlock: fromBlock, toBlock: toBlock, strict: strict }) {
    const event = eventName ? (0, $gIJMr.getAbiItem)({
        abi: abi,
        name: eventName
    }) : undefined;
    const events = !event ? abi.filter((x)=>x.type === "event") : undefined;
    return (0, $5vDfU.getAction)(client, (0, $5Nq0J.getLogs), "getLogs")({
        address: address,
        args: args,
        blockHash: blockHash,
        event: event,
        events: events,
        fromBlock: fromBlock,
        toBlock: toBlock,
        strict: strict
    });
}

});
parcelRegister("5Nq0J", function(module, exports) {

$parcel$export(module.exports, "getLogs", () => $4385b48ebb89f893$export$cb5260c832aab30a);

var $ddib9 = parcelRequire("ddib9");

var $eh2OY = parcelRequire("eh2OY");

var $6Pvid = parcelRequire("6Pvid");

var $hKqyW = parcelRequire("hKqyW");

var $1sSKo = parcelRequire("1sSKo");
async function $4385b48ebb89f893$export$cb5260c832aab30a(client, { address: address, blockHash: blockHash, fromBlock: fromBlock, toBlock: toBlock, event: event, events: events_, args: args, strict: strict_ } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $6Pvid.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    let logs;
    if (blockHash) logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                blockHash: blockHash
            }
        ]
    });
    else logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                fromBlock: typeof fromBlock === "bigint" ? (0, $hKqyW.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $hKqyW.numberToHex)(toBlock) : toBlock
            }
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = events ? (0, $eh2OY.decodeEventLog)({
                abi: events,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $1sSKo.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $ddib9.DecodeLogDataMismatch) || err instanceof (0, $ddib9.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $1sSKo.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});
parcelRegister("eh2OY", function(module, exports) {

$parcel$export(module.exports, "decodeEventLog", () => $a644d774dd0d2411$export$ec0597e81db3d947);

var $ddib9 = parcelRequire("ddib9");

var $iXtZJ = parcelRequire("iXtZJ");

var $f8KNN = parcelRequire("f8KNN");

var $lU0UI = parcelRequire("lU0UI");
const $a644d774dd0d2411$var$docsPath = "/docs/contract/decodeEventLog";
function $a644d774dd0d2411$export$ec0597e81db3d947({ abi: abi, data: data, strict: strict_, topics: topics }) {
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $ddib9.AbiEventSignatureEmptyTopicsError)({
        docsPath: $a644d774dd0d2411$var$docsPath
    });
    const abiItem = abi.find((x)=>x.type === "event" && signature === (0, $iXtZJ.getEventSelector)((0, $lU0UI.formatAbiItem)(x)));
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $ddib9.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $a644d774dd0d2411$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $ddib9.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[param.name || i] = $a644d774dd0d2411$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $f8KNN.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $ddib9.AbiDecodingDataSizeTooSmallError)) throw new (0, $ddib9.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: err.data,
                    params: err.params,
                    size: err.size
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $ddib9.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $a644d774dd0d2411$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $f8KNN.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}

});

parcelRegister("1sSKo", function(module, exports) {

$parcel$export(module.exports, "formatLog", () => $1112dfa1338d156a$export$fccdbdc2b9d7893);
function $1112dfa1338d156a$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}

});



parcelRegister("kFa52", function(module, exports) {

$parcel$export(module.exports, "getFeeHistory", () => $f0af74b836275e8c$export$66598bc0c00a958e);

var $hKqyW = parcelRequire("hKqyW");

var $32RZs = parcelRequire("32RZs");
async function $f0af74b836275e8c$export$66598bc0c00a958e(client, { blockCount: blockCount, blockNumber: blockNumber, blockTag: blockTag = "latest", rewardPercentiles: rewardPercentiles }) {
    const blockNumberHex = blockNumber ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: "eth_feeHistory",
        params: [
            (0, $hKqyW.numberToHex)(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles
        ]
    });
    return (0, $32RZs.formatFeeHistory)(feeHistory);
}

});
parcelRegister("32RZs", function(module, exports) {

$parcel$export(module.exports, "formatFeeHistory", () => $237b7055e2c1971a$export$6c26435bc7761d23);
function $237b7055e2c1971a$export$6c26435bc7761d23(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value)=>BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward)=>reward.map((value)=>BigInt(value)))
    };
}

});


parcelRegister("6TIie", function(module, exports) {

$parcel$export(module.exports, "getFilterChanges", () => $505a3ccb5b083dca$export$e69fa84ce52a94fd);

var $ddib9 = parcelRequire("ddib9");

var $eh2OY = parcelRequire("eh2OY");

var $1sSKo = parcelRequire("1sSKo");
async function $505a3ccb5b083dca$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        if (typeof log === "string") return log;
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $eh2OY.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $1sSKo.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $ddib9.DecodeLogDataMismatch) || err instanceof (0, $ddib9.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args undefined if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $1sSKo.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("lp9LI", function(module, exports) {

$parcel$export(module.exports, "getFilterLogs", () => $f95382a0c9cc1df1$export$776d3b8c33a8b58);

var $ddib9 = parcelRequire("ddib9");

var $eh2OY = parcelRequire("eh2OY");

var $1sSKo = parcelRequire("1sSKo");
async function $f95382a0c9cc1df1$export$776d3b8c33a8b58(_client, { filter: filter }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: "eth_getFilterLogs",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $eh2OY.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $1sSKo.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $ddib9.DecodeLogDataMismatch) || err instanceof (0, $ddib9.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $1sSKo.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("eaoEh", function(module, exports) {

$parcel$export(module.exports, "getProof", () => $a5051e97048abe0e$export$4a314c097411dc17);

var $hKqyW = parcelRequire("hKqyW");

var $ezCVe = parcelRequire("ezCVe");
async function $a5051e97048abe0e$export$4a314c097411dc17(client, { address: address, blockNumber: blockNumber, blockTag: blockTag_, storageKeys: storageKeys }) {
    const blockTag = blockTag_ ?? "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const proof = await client.request({
        method: "eth_getProof",
        params: [
            address,
            storageKeys,
            blockNumberHex || blockTag
        ]
    });
    return (0, $ezCVe.formatProof)(proof);
}

});
parcelRegister("ezCVe", function(module, exports) {

$parcel$export(module.exports, "formatProof", () => $a9c286b4f8b7a87a$export$f37c234f0c7125e3);

var $8hd5S = parcelRequire("8hd5S");
function $a9c286b4f8b7a87a$var$formatStorageProof(storageProof) {
    return storageProof.map((proof)=>({
            ...proof,
            value: BigInt(proof.value)
        }));
}
function $a9c286b4f8b7a87a$export$f37c234f0c7125e3(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $8hd5S.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $a9c286b4f8b7a87a$var$formatStorageProof(proof.storageProof) : undefined
    };
}

});


parcelRegister("atvoB", function(module, exports) {

$parcel$export(module.exports, "getStorageAt", () => $7a04f76463d8fbb9$export$14e244c1a3c8527e);

var $hKqyW = parcelRequire("hKqyW");
async function $7a04f76463d8fbb9$export$14e244c1a3c8527e(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest", slot: slot }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    const data = await client.request({
        method: "eth_getStorageAt",
        params: [
            address,
            slot,
            blockNumberHex || blockTag
        ]
    });
    return data;
}

});

parcelRegister("hXcoh", function(module, exports) {

$parcel$export(module.exports, "getTransaction", () => $d1218edef940c001$export$ec0c6556a09b65b8);

var $i50rN = parcelRequire("i50rN");

var $hKqyW = parcelRequire("hKqyW");

var $4FTzq = parcelRequire("4FTzq");
async function $d1218edef940c001$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $hKqyW.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $hKqyW.numberToHex)(index)
        ]
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $hKqyW.numberToHex)(index)
        ]
    });
    if (!transaction) throw new (0, $i50rN.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $4FTzq.formatTransaction);
    return format(transaction);
}

});

parcelRegister("b2g55", function(module, exports) {

$parcel$export(module.exports, "getTransactionConfirmations", () => $808c5afeb2360390$export$e2ccc904d713b66d);

var $5vDfU = parcelRequire("5vDfU");

var $3UJoG = parcelRequire("3UJoG");

var $hXcoh = parcelRequire("hXcoh");
async function $808c5afeb2360390$export$e2ccc904d713b66d(client, { hash: hash, transactionReceipt: transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        (0, $5vDfU.getAction)(client, (0, $3UJoG.getBlockNumber), "getBlockNumber")({}),
        hash ? (0, $5vDfU.getAction)(client, (0, $hXcoh.getTransaction), "getBlockNumber")({
            hash: hash
        }) : undefined
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}

});

parcelRegister("61kUj", function(module, exports) {

$parcel$export(module.exports, "getTransactionReceipt", () => $46230dd17ec99ba3$export$6b1ceb3cd5f8b21f);

var $i50rN = parcelRequire("i50rN");

var $efmiS = parcelRequire("efmiS");
async function $46230dd17ec99ba3$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    });
    if (!receipt) throw new (0, $i50rN.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $efmiS.formatTransactionReceipt);
    return format(receipt);
}

});
parcelRegister("efmiS", function(module, exports) {

$parcel$export(module.exports, "formatTransactionReceipt", () => $a5f3c466d55e3940$export$30da670e49d6fc31);

var $8hd5S = parcelRequire("8hd5S");

var $7NJHE = parcelRequire("7NJHE");

var $1sSKo = parcelRequire("1sSKo");

var $4FTzq = parcelRequire("4FTzq");
const $a5f3c466d55e3940$var$statuses = {
    "0x0": "reverted",
    "0x1": "success"
};
function $a5f3c466d55e3940$export$30da670e49d6fc31(transactionReceipt) {
    return {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $1sSKo.formatLog)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $8hd5S.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $a5f3c466d55e3940$var$statuses[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $4FTzq.transactionType)[transactionReceipt.type] || transactionReceipt.type : null
    };
}
const $a5f3c466d55e3940$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $7NJHE.defineFormatter)("transactionReceipt", $a5f3c466d55e3940$export$30da670e49d6fc31);

});


parcelRegister("4zwOV", function(module, exports) {

$parcel$export(module.exports, "multicall", () => $3543e3be0146ff45$export$60ef70589ee4f7ad);

var $kbkUi = parcelRequire("kbkUi");

var $ddib9 = parcelRequire("ddib9");

var $hRZHI = parcelRequire("hRZHI");

var $34q4g = parcelRequire("34q4g");

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $avhWP = parcelRequire("avhWP");

var $fkFeI = parcelRequire("fkFeI");

var $5vDfU = parcelRequire("5vDfU");

var $2R9Q8 = parcelRequire("2R9Q8");
async function $3543e3be0146ff45$export$60ef70589ee4f7ad(client, args) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, contracts: contracts, multicallAddress: multicallAddress_ } = args;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $avhWP.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $bpUXq.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $fkFeI.getContractError)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $5vDfU.getAction)(client, (0, $2R9Q8.readContract), "readContract")({
            abi: (0, $kbkUi.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3"
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $ddib9.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $34q4g.RawContractError)({
                    data: returnData
                });
                const result = (0, $6FtIl.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $fkFeI.getContractError)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $hRZHI.BaseError)("multicall results mismatch");
    return results;
}

});

parcelRegister("lAUaG", function(module, exports) {

$parcel$export(module.exports, "simulateContract", () => $fb88883bce2f0143$export$e8798d551e27a374);

var $3VerT = parcelRequire("3VerT");

var $6FtIl = parcelRequire("6FtIl");

var $bpUXq = parcelRequire("bpUXq");

var $fkFeI = parcelRequire("fkFeI");

var $5vDfU = parcelRequire("5vDfU");

var $5UENw = parcelRequire("5UENw");
async function $fb88883bce2f0143$export$e8798d551e27a374(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest }) {
    const account = callRequest.account ? (0, $3VerT.parseAccount)(callRequest.account) : undefined;
    const calldata = (0, $bpUXq.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $5vDfU.getAction)(client, (0, $5UENw.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest
        });
        const result = (0, $6FtIl.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        return {
            result: result,
            request: {
                abi: abi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest
            }
        };
    } catch (err) {
        throw (0, $fkFeI.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("4XNZD", function(module, exports) {

$parcel$export(module.exports, "uninstallFilter", () => $39d373b321f4d41c$export$54eb7d691768f7f3);
/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types.html#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter.html
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter.html)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter.html)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter.html)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $39d373b321f4d41c$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}

});

parcelRegister("5jn9g", function(module, exports) {

$parcel$export(module.exports, "verifyMessage", () => $3de0aee8ed2e7add$export$228d0e772cc158cb);

var $66CnA = parcelRequire("66CnA");

var $jI4rY = parcelRequire("jI4rY");
async function $3de0aee8ed2e7add$export$228d0e772cc158cb(client, { address: address, message: message, signature: signature, ...callRequest }) {
    const hash = (0, $66CnA.hashMessage)(message);
    return (0, $jI4rY.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});
parcelRegister("66CnA", function(module, exports) {

$parcel$export(module.exports, "hashMessage", () => $472112f5eea89112$export$d4c241cec96564c1);

var $hoxPU = parcelRequire("hoxPU");

var $kTOx8 = parcelRequire("kTOx8");

var $9sHEt = parcelRequire("9sHEt");

var $cq8a0 = parcelRequire("cq8a0");
function $472112f5eea89112$export$d4c241cec96564c1(message, to_) {
    const messageBytes = (()=>{
        if (typeof message === "string") return (0, $9sHEt.stringToBytes)(message);
        if (message.raw instanceof Uint8Array) return message.raw;
        return (0, $9sHEt.toBytes)(message.raw);
    })();
    const prefixBytes = (0, $9sHEt.stringToBytes)(`${(0, $hoxPU.presignMessagePrefix)}${messageBytes.length}`);
    return (0, $cq8a0.keccak256)((0, $kTOx8.concat)([
        prefixBytes,
        messageBytes
    ]), to_);
}

});
parcelRegister("hoxPU", function(module, exports) {

$parcel$export(module.exports, "presignMessagePrefix", () => $ca9eecbd70dd4df9$export$39d5d904b514ff63);
const $ca9eecbd70dd4df9$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";

});


parcelRegister("jI4rY", function(module, exports) {

$parcel$export(module.exports, "verifyHash", () => $e595941732068367$export$434ee6408013d7f2);

var $kbkUi = parcelRequire("kbkUi");

var $1WTOl = parcelRequire("1WTOl");

var $34q4g = parcelRequire("34q4g");

var $iJSMQ = parcelRequire("iJSMQ");

var $5vDfU = parcelRequire("5vDfU");

var $01CEa = parcelRequire("01CEa");
var $hKqyW = parcelRequire("hKqyW");
var $5LWH6 = parcelRequire("5LWH6");

var $5UENw = parcelRequire("5UENw");
async function $e595941732068367$export$434ee6408013d7f2(client, { address: address, hash: hash, signature: signature, ...callRequest }) {
    const signatureHex = (0, $01CEa.isHex)(signature) ? signature : (0, $hKqyW.toHex)(signature);
    try {
        const { data: data } = await (0, $5vDfU.getAction)(client, (0, $5UENw.call), "call")({
            data: (0, $5LWH6.encodeDeployData)({
                abi: (0, $kbkUi.universalSignatureValidatorAbi),
                args: [
                    address,
                    hash,
                    signatureHex
                ],
                bytecode: (0, $1WTOl.universalSignatureValidatorByteCode)
            }),
            ...callRequest
        });
        return (0, $iJSMQ.isBytesEqual)(data ?? "0x0", "0x1");
    } catch (error) {
        if (error instanceof (0, $34q4g.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
        // this can happen for many reasons, for example if signer can not be recovered from the signature
        // or if the signature has no valid format
        return false;
        throw error;
    }
}

});
parcelRegister("1WTOl", function(module, exports) {

$parcel$export(module.exports, "universalSignatureValidatorByteCode", () => $16b68020ff79b9d3$export$76c7202cd92b9dbb);
const $16b68020ff79b9d3$export$76c7202cd92b9dbb = "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";

});

parcelRegister("iJSMQ", function(module, exports) {

$parcel$export(module.exports, "isBytesEqual", () => $da46ed7dd4ea837c$export$88282e62826c5bec);

var $gTQLa = parcelRequire("gTQLa");

var $9sHEt = parcelRequire("9sHEt");

var $01CEa = parcelRequire("01CEa");
function $da46ed7dd4ea837c$export$88282e62826c5bec(a_, b_) {
    const a = (0, $01CEa.isHex)(a_) ? (0, $9sHEt.toBytes)(a_) : a_;
    const b = (0, $01CEa.isHex)(b_) ? (0, $9sHEt.toBytes)(b_) : b_;
    return (0, $gTQLa.equalBytes)(a, b);
}

});
parcelRegister("gTQLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $c4dab55d072acd13$var$_0n = BigInt(0);
const $c4dab55d072acd13$var$_1n = BigInt(1);
const $c4dab55d072acd13$var$_2n = BigInt(2);
const $c4dab55d072acd13$var$u8a = (a)=>a instanceof Uint8Array;
const $c4dab55d072acd13$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $c4dab55d072acd13$var$bytesToHex(bytes) {
    if (!$c4dab55d072acd13$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $c4dab55d072acd13$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $c4dab55d072acd13$var$bytesToHex;
function $c4dab55d072acd13$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $c4dab55d072acd13$var$numberToHexUnpadded;
function $c4dab55d072acd13$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $c4dab55d072acd13$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $c4dab55d072acd13$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $c4dab55d072acd13$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $c4dab55d072acd13$var$bytesToNumberBE(bytes) {
    return $c4dab55d072acd13$var$hexToNumber($c4dab55d072acd13$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $c4dab55d072acd13$var$bytesToNumberBE;
function $c4dab55d072acd13$var$bytesToNumberLE(bytes) {
    if (!$c4dab55d072acd13$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $c4dab55d072acd13$var$hexToNumber($c4dab55d072acd13$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $c4dab55d072acd13$var$bytesToNumberLE;
function $c4dab55d072acd13$var$numberToBytesBE(n, len) {
    return $c4dab55d072acd13$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $c4dab55d072acd13$var$numberToBytesBE;
function $c4dab55d072acd13$var$numberToBytesLE(n, len) {
    return $c4dab55d072acd13$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $c4dab55d072acd13$var$numberToBytesLE;
// Unpadded, rarely used
function $c4dab55d072acd13$var$numberToVarBytesBE(n) {
    return $c4dab55d072acd13$var$hexToBytes($c4dab55d072acd13$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $c4dab55d072acd13$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $c4dab55d072acd13$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $c4dab55d072acd13$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($c4dab55d072acd13$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $c4dab55d072acd13$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $c4dab55d072acd13$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$c4dab55d072acd13$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $c4dab55d072acd13$var$concatBytes;
function $c4dab55d072acd13$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $c4dab55d072acd13$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $c4dab55d072acd13$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $c4dab55d072acd13$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $c4dab55d072acd13$var$bitLen(n) {
    let len;
    for(len = 0; n > $c4dab55d072acd13$var$_0n; n >>= $c4dab55d072acd13$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $c4dab55d072acd13$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $c4dab55d072acd13$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $c4dab55d072acd13$var$_1n;
}
module.exports.bitGet = $c4dab55d072acd13$var$bitGet;
/**
 * Sets single bit at position.
 */ const $c4dab55d072acd13$var$bitSet = (n, pos, value)=>{
    return n | (value ? $c4dab55d072acd13$var$_1n : $c4dab55d072acd13$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $c4dab55d072acd13$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $c4dab55d072acd13$var$bitMask = (n)=>($c4dab55d072acd13$var$_2n << BigInt(n - 1)) - $c4dab55d072acd13$var$_1n;
module.exports.bitMask = $c4dab55d072acd13$var$bitMask;
// DRBG
const $c4dab55d072acd13$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $c4dab55d072acd13$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $c4dab55d072acd13$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $c4dab55d072acd13$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $c4dab55d072acd13$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $c4dab55d072acd13$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($c4dab55d072acd13$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($c4dab55d072acd13$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $c4dab55d072acd13$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $c4dab55d072acd13$var$createHmacDrbg;
// Validating curves and fields
const $c4dab55d072acd13$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $c4dab55d072acd13$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $c4dab55d072acd13$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $c4dab55d072acd13$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});




parcelRegister("5Tu5P", function(module, exports) {

$parcel$export(module.exports, "verifyTypedData", () => $44a96ea067933c76$export$3603b1c1bcd76798);

var $kTHs7 = parcelRequire("kTHs7");

var $jI4rY = parcelRequire("jI4rY");
async function $44a96ea067933c76$export$3603b1c1bcd76798(client, { address: address, signature: signature, message: message, primaryType: primaryType, types: types, domain: domain, ...callRequest }) {
    const hash = (0, $kTHs7.hashTypedData)({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
    return (0, $jI4rY.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});

parcelRegister("iiw4Y", function(module, exports) {

$parcel$export(module.exports, "waitForTransactionReceipt", () => $d522cab3b240a152$export$694ec9bdf0bb55cf);

var $94N0Y = parcelRequire("94N0Y");

var $i50rN = parcelRequire("i50rN");

var $5vDfU = parcelRequire("5vDfU");

var $8N9mJ = parcelRequire("8N9mJ");

var $8dquR = parcelRequire("8dquR");

var $41CuJ = parcelRequire("41CuJ");

var $iWQbX = parcelRequire("iWQbX");

var $hXcoh = parcelRequire("hXcoh");

var $61kUj = parcelRequire("61kUj");

var $4tCqx = parcelRequire("4tCqx");
async function $d522cab3b240a152$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, timeout: timeout }) {
    const observerId = (0, $41CuJ.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject)=>{
        if (timeout) setTimeout(()=>reject(new (0, $i50rN.WaitForTransactionReceiptTimeoutError)({
                hash: hash
            })), timeout);
        const _unobserve = (0, $8N9mJ.observe)(observerId, {
            onReplaced: onReplaced,
            resolve: resolve,
            reject: reject
        }, (emit)=>{
            const _unwatch = (0, $5vDfU.getAction)(client, (0, $4tCqx.watchBlockNumber), "watchBlockNumber")({
                emitMissed: true,
                emitOnBegin: true,
                poll: true,
                pollingInterval: pollingInterval,
                async onBlockNumber (blockNumber_) {
                    if (retrying) return;
                    let blockNumber = blockNumber_;
                    const done = (fn)=>{
                        _unwatch();
                        fn();
                        _unobserve();
                    };
                    try {
                        // If we already have a valid receipt, let's check if we have enough
                        // confirmations. If we do, then we can resolve.
                        if (receipt) {
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            done(()=>emit.resolve(receipt));
                            return;
                        }
                        // Get the transaction to check if it's been replaced.
                        // We need to retry as some RPC Providers may be slow to sync
                        // up mined transactions.
                        if (!transaction) {
                            retrying = true;
                            await (0, $8dquR.withRetry)(async ()=>{
                                transaction = await (0, $5vDfU.getAction)(client, (0, $hXcoh.getTransaction), "getTransaction")({
                                    hash: hash
                                });
                                if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                            }, {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6
                            });
                            retrying = false;
                        }
                        // Get the receipt to check if it's been processed.
                        receipt = await (0, $5vDfU.getAction)(client, (0, $61kUj.getTransactionReceipt), "getTransactionReceipt")({
                            hash: hash
                        });
                        // Check if we have enough confirmations. If not, continue polling.
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                    } catch (err) {
                        // If the receipt is not found, the transaction will be pending.
                        // We need to check if it has potentially been replaced.
                        if (transaction && (err instanceof (0, $i50rN.TransactionNotFoundError) || err instanceof (0, $i50rN.TransactionReceiptNotFoundError))) try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $8dquR.withRetry)(()=>(0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6,
                                shouldRetry: ({ error: error })=>error instanceof (0, $94N0Y.BlockNotFoundError)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $5vDfU.getAction)(client, (0, $61kUj.getTransactionReceipt), "getTransactionReceipt")({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = "replaced";
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                        else done(()=>emit.reject(err));
                    }
                }
            });
        });
    });
}

});
parcelRegister("8N9mJ", function(module, exports) {

$parcel$export(module.exports, "observe", () => $666a2a2c7e67708f$export$d1203567a167490e);
const $666a2a2c7e67708f$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $666a2a2c7e67708f$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $666a2a2c7e67708f$var$callbackCount = 0;
function $666a2a2c7e67708f$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$666a2a2c7e67708f$var$callbackCount;
    const getListeners = ()=>$666a2a2c7e67708f$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $666a2a2c7e67708f$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const cleanup = $666a2a2c7e67708f$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $666a2a2c7e67708f$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $666a2a2c7e67708f$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}

});

parcelRegister("4tCqx", function(module, exports) {

$parcel$export(module.exports, "watchBlockNumber", () => $3427adad99c778fa$export$fc5f622dd0d82466);

var $8hd5S = parcelRequire("8hd5S");

var $5vDfU = parcelRequire("5vDfU");

var $8N9mJ = parcelRequire("8N9mJ");

var $44Xso = parcelRequire("44Xso");

var $41CuJ = parcelRequire("41CuJ");

var $3UJoG = parcelRequire("3UJoG");
function $3427adad99c778fa$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $41CuJ.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $8N9mJ.observe)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $44Xso.poll)(async ()=>{
                try {
                    const blockNumber = await (0, $5vDfU.getAction)(client, (0, $3UJoG.getBlockNumber), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const blockNumber = (0, $8hd5S.hexToBigInt)(data.result?.number);
                        onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}

});
parcelRegister("44Xso", function(module, exports) {

$parcel$export(module.exports, "poll", () => $2f85a809a27f30ce$export$e0c10349b2c5e1d4);

var $6Sfwh = parcelRequire("6Sfwh");
function $2f85a809a27f30ce$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $6Sfwh.wait)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $6Sfwh.wait)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}

});



parcelRegister("9xZqj", function(module, exports) {

$parcel$export(module.exports, "watchBlocks", () => $6f36d787903e62ee$export$f04bd2888af8db20);

var $4GuSx = parcelRequire("4GuSx");

var $5vDfU = parcelRequire("5vDfU");

var $8N9mJ = parcelRequire("8N9mJ");

var $44Xso = parcelRequire("44Xso");

var $41CuJ = parcelRequire("41CuJ");

var $iWQbX = parcelRequire("iWQbX");
function $6f36d787903e62ee$export$f04bd2888af8db20(client, { blockTag: blockTag = "latest", emitMissed: emitMissed = false, emitOnBegin: emitOnBegin = false, onBlock: onBlock, onError: onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = ()=>{
        const observerId = (0, $41CuJ.stringify)([
            "watchBlocks",
            client.uid,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $8N9mJ.observe)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, (emit)=>(0, $44Xso.poll)(async ()=>{
                try {
                    const block = await (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({
                        blockTag: blockTag,
                        includeTransactions: includeTransactions
                    });
                    if (block.number && prevBlock?.number) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (block.number === prevBlock.number) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (block.number - prevBlock.number > 1 && emitMissed) for(let i = prevBlock?.number + 1n; i < block.number; i++){
                            const block = await (0, $5vDfU.getAction)(client, (0, $iWQbX.getBlock), "getBlock")({
                                blockNumber: i,
                                includeTransactions: includeTransactions
                            });
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                    if (// If no previous block exists, emit.
                    !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
                    blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    block.number && block.number > prevBlock.number) {
                        emit.onBlock(block, prevBlock);
                        prevBlock = block;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlocks = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const format = client.chain?.formatters?.block?.format || (0, $4GuSx.formatBlock);
                        const block = format(data.result);
                        onBlock(block, prevBlock);
                        prevBlock = block;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}

});

parcelRegister("aJhYs", function(module, exports) {

$parcel$export(module.exports, "watchContractEvent", () => $7cfc0ca3d613952a$export$2a02a63daa2df376);

var $8N9mJ = parcelRequire("8N9mJ");

var $44Xso = parcelRequire("44Xso");

var $41CuJ = parcelRequire("41CuJ");

var $ddib9 = parcelRequire("ddib9");

var $1mQc6 = parcelRequire("1mQc6");

var $eh2OY = parcelRequire("eh2OY");

var $6Pvid = parcelRequire("6Pvid");

var $1sSKo = parcelRequire("1sSKo");

var $5vDfU = parcelRequire("5vDfU");

var $faFP4 = parcelRequire("faFP4");

var $3UJoG = parcelRequire("3UJoG");

var $dTTZ8 = parcelRequire("dTTZ8");

var $6TIie = parcelRequire("6TIie");

var $4XNZD = parcelRequire("4XNZD");
function $7cfc0ca3d613952a$export$2a02a63daa2df376(client, { abi: abi, address: address, args: args, batch: batch = true, eventName: eventName, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollContractEvent = ()=>{
        const observerId = (0, $41CuJ.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval
        ]);
        const strict = strict_ ?? false;
        return (0, $8N9mJ.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $44Xso.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $5vDfU.getAction)(client, (0, $faFP4.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $5vDfU.getAction)(client, (0, $6TIie.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $5vDfU.getAction)(client, (0, $3UJoG.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $5vDfU.getAction)(client, (0, $dTTZ8.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber,
                            strict: strict
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $1mQc6.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $5vDfU.getAction)(client, (0, $4XNZD.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const topics = eventName ? (0, $6Pvid.encodeEventTopics)({
                    abi: abi,
                    eventName: eventName,
                    args: args
                }) : [];
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $eh2OY.decodeEventLog)({
                                abi: abi,
                                data: log.data,
                                topics: log.topics,
                                strict: strict_
                            });
                            const formatted = (0, $1sSKo.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $ddib9.DecodeLogDataMismatch) || err instanceof (0, $ddib9.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $1sSKo.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}

});

parcelRegister("6qc7z", function(module, exports) {

$parcel$export(module.exports, "watchEvent", () => $4ace92cd73636910$export$f6260ad5441916b4);

var $8N9mJ = parcelRequire("8N9mJ");

var $44Xso = parcelRequire("44Xso");

var $41CuJ = parcelRequire("41CuJ");

var $ddib9 = parcelRequire("ddib9");

var $1mQc6 = parcelRequire("1mQc6");

var $5vDfU = parcelRequire("5vDfU");

var $6Pvid = parcelRequire("6Pvid");
var $eh2OY = parcelRequire("eh2OY");
var $1sSKo = parcelRequire("1sSKo");

var $8EBm8 = parcelRequire("8EBm8");

var $3UJoG = parcelRequire("3UJoG");

var $6TIie = parcelRequire("6TIie");

var $5Nq0J = parcelRequire("5Nq0J");

var $4XNZD = parcelRequire("4XNZD");
function $4ace92cd73636910$export$f6260ad5441916b4(client, { address: address, args: args, batch: batch = true, event: event, events: events, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const strict = strict_ ?? false;
    const pollEvent = ()=>{
        const observerId = (0, $41CuJ.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval
        ]);
        return (0, $8N9mJ.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $44Xso.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $5vDfU.getAction)(client, (0, $8EBm8.createEventFilter), "createEventFilter")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $5vDfU.getAction)(client, (0, $6TIie.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $5vDfU.getAction)(client, (0, $3UJoG.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $5vDfU.getAction)(client, (0, $5Nq0J.getLogs), "getLogs")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $1mQc6.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $5vDfU.getAction)(client, (0, $4XNZD.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const events_ = events ?? (event ? [
                    event
                ] : undefined);
                let topics = [];
                if (events_) {
                    topics = [
                        events_.flatMap((event)=>(0, $6Pvid.encodeEventTopics)({
                                abi: [
                                    event
                                ],
                                eventName: event.name,
                                args: args
                            }))
                    ];
                    if (event) topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $eh2OY.decodeEventLog)({
                                abi: events_,
                                data: log.data,
                                topics: log.topics,
                                strict: strict
                            });
                            const formatted = (0, $1sSKo.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $ddib9.DecodeLogDataMismatch) || err instanceof (0, $ddib9.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $1sSKo.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}

});

parcelRegister("6tj4z", function(module, exports) {

$parcel$export(module.exports, "watchPendingTransactions", () => $4b643ef110febc4e$export$223080172c87e789);

var $5vDfU = parcelRequire("5vDfU");

var $8N9mJ = parcelRequire("8N9mJ");

var $44Xso = parcelRequire("44Xso");

var $41CuJ = parcelRequire("41CuJ");

var $5CdWx = parcelRequire("5CdWx");

var $6TIie = parcelRequire("6TIie");

var $4XNZD = parcelRequire("4XNZD");
function $4b643ef110febc4e$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $41CuJ.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $8N9mJ.observe)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $44Xso.poll)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $5vDfU.getAction)(client, (0, $5CdWx.createPendingTransactionFilter), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $5vDfU.getAction)(client, (0, $6TIie.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $5vDfU.getAction)(client, (0, $4XNZD.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}

});



parcelRegister("PaH4P", function(module, exports) {

$parcel$export(module.exports, "fallback", () => $099d0f192cd8dd83$export$bcd1dd1f397bba12);

var $3NSu6 = parcelRequire("3NSu6");

var $6Sfwh = parcelRequire("6Sfwh");

var $6WKkf = parcelRequire("6WKkf");
function $099d0f192cd8dd83$export$bcd1dd1f397bba12(transports_, config = {}) {
    const { key: key = "fallback", name: name = "Fallback", rank: rank = false, retryCount: retryCount, retryDelay: retryDelay } = config;
    return ({ chain: chain, pollingInterval: pollingInterval = 4000, timeout: timeout })=>{
        let transports = transports_;
        let onResponse = ()=>{};
        const transport = (0, $6WKkf.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const fetch = async (i = 0)=>{
                    const transport = transports[i]({
                        chain: chain,
                        retryCount: 0,
                        timeout: timeout
                    });
                    try {
                        const response = await transport.request({
                            method: method,
                            params: params
                        });
                        onResponse({
                            method: method,
                            params: params,
                            response: response,
                            transport: transport,
                            status: "success"
                        });
                        return response;
                    } catch (err) {
                        onResponse({
                            error: err,
                            method: method,
                            params: params,
                            transport: transport,
                            status: "error"
                        });
                        // If the error is deterministic, we don't need to fall back.
                        // So throw the error.
                        if ((0, $3NSu6.isDeterministicError)(err)) throw err;
                        // If we've reached the end of the fallbacks, throw the error.
                        if (i === transports.length - 1) throw err;
                        // Otherwise, try the next fallback.
                        return fetch(i + 1);
                    }
                };
                return fetch();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: (fn)=>onResponse = fn,
            transports: transports.map((fn)=>fn({
                    chain: chain,
                    retryCount: 0
                }))
        });
        if (rank) {
            const rankOptions = typeof rank === "object" ? rank : {};
            $099d0f192cd8dd83$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: rankOptions.interval ?? pollingInterval,
                onTransports: (transports_)=>transports = transports_,
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $099d0f192cd8dd83$export$f2bce5ae3fda4e76({ chain: chain, interval: interval = 4000, onTransports: onTransports, sampleCount: sampleCount = 10, timeout: timeout = 1000, transports: transports, weights: weights = {} }) {
    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
    const samples = [];
    const rankTransports_ = async ()=>{
        // 1. Take a sample from each Transport.
        const sample = await Promise.all(transports.map(async (transport)=>{
            const transport_ = transport({
                chain: chain,
                retryCount: 0,
                timeout: timeout
            });
            const start = Date.now();
            let end;
            let success;
            try {
                await transport_.request({
                    method: "net_listening"
                });
                success = 1;
            } catch  {
                success = 0;
            } finally{
                end = Date.now();
            }
            const latency = end - start;
            return {
                latency: latency,
                success: success
            };
        }));
        // 2. Store the sample. If we have more than `sampleCount` samples, remove
        // the oldest sample.
        samples.push(sample);
        if (samples.length > sampleCount) samples.shift();
        // 3. Calculate the max latency from samples.
        const maxLatency = Math.max(...samples.map((sample)=>Math.max(...sample.map(({ latency: latency })=>latency))));
        // 4. Calculate the score for each Transport.
        const scores = transports.map((_, i)=>{
            const latencies = samples.map((sample)=>sample[i].latency);
            const meanLatency = latencies.reduce((acc, latency)=>acc + latency, 0) / latencies.length;
            const latencyScore = 1 - meanLatency / maxLatency;
            const successes = samples.map((sample)=>sample[i].success);
            const stabilityScore = successes.reduce((acc, success)=>acc + success, 0) / successes.length;
            if (stabilityScore === 0) return [
                0,
                i
            ];
            return [
                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                i
            ];
        }).sort((a, b)=>b[0] - a[0]);
        // 5. Sort the Transports by score.
        onTransports(scores.map(([, i])=>transports[i]));
        // 6. Wait, and then rank again.
        await (0, $6Sfwh.wait)(interval);
        rankTransports_();
    };
    rankTransports_();
}

});

parcelRegister("g69ST", function(module, exports) {

$parcel$export(module.exports, "http", () => $bb84dfb2f1a0d9f8$export$7d6f1c8842f9f527);

var $5pGkz = parcelRequire("5pGkz");

var $bfr1q = parcelRequire("bfr1q");

var $l9LFI = parcelRequire("l9LFI");

var $iptY0 = parcelRequire("iptY0");

var $6WKkf = parcelRequire("6WKkf");
function $bb84dfb2f1a0d9f8$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", name: name = "HTTP JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $bfr1q.UrlRequiredError)();
        return (0, $6WKkf.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $l9LFI.createBatchScheduler)({
                    id: `${url}`,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>(0, $iptY0.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await (0, $iptY0.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $5pGkz.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url
        });
    };
}

});
parcelRegister("bfr1q", function(module, exports) {

$parcel$export(module.exports, "UrlRequiredError", () => $83060e72642413aa$export$d0a48bf953f3c239);

var $hRZHI = parcelRequire("hRZHI");
class $83060e72642413aa$export$d0a48bf953f3c239 extends (0, $hRZHI.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro"
        });
    }
}

});

parcelRegister("iptY0", function(module, exports) {

$parcel$export(module.exports, "getSocket", () => $d671ce9aaed49427$export$361cf94c2d913fd4);
$parcel$export(module.exports, "rpc", () => $d671ce9aaed49427$export$82f5954781486db2);

var $7UGX6 = parcelRequire("7UGX6");

var $5pGkz = parcelRequire("5pGkz");

var $l9LFI = parcelRequire("l9LFI");

var $1754o = parcelRequire("1754o");

var $41CuJ = parcelRequire("41CuJ");
let $d671ce9aaed49427$var$id = 0;
async function $d671ce9aaed49427$var$http(url, { body: body, fetchOptions: fetchOptions = {}, timeout: timeout = 10000 }) {
    const { headers: headers, method: method, signal: signal_ } = fetchOptions;
    try {
        const response = await (0, $1754o.withTimeout)(async ({ signal: signal })=>{
            const response = await fetch(url, {
                ...fetchOptions,
                body: Array.isArray(body) ? (0, $41CuJ.stringify)(body.map((body)=>({
                        jsonrpc: "2.0",
                        id: body.id ?? $d671ce9aaed49427$var$id++,
                        ...body
                    }))) : (0, $41CuJ.stringify)({
                    jsonrpc: "2.0",
                    id: body.id ?? $d671ce9aaed49427$var$id++,
                    ...body
                }),
                headers: {
                    ...headers,
                    "Content-Type": "application/json"
                },
                method: method || "POST",
                signal: signal_ || (timeout > 0 ? signal : undefined)
            });
            return response;
        }, {
            errorInstance: new (0, $5pGkz.TimeoutError)({
                body: body,
                url: url
            }),
            timeout: timeout,
            signal: true
        });
        let data;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
        else data = await response.text();
        if (!response.ok) throw new (0, $5pGkz.HttpRequestError)({
            body: body,
            details: (0, $41CuJ.stringify)(data.error) || response.statusText,
            headers: response.headers,
            status: response.status,
            url: url
        });
        return data;
    } catch (err) {
        if (err instanceof (0, $5pGkz.HttpRequestError)) throw err;
        if (err instanceof (0, $5pGkz.TimeoutError)) throw err;
        throw new (0, $5pGkz.HttpRequestError)({
            body: body,
            details: err.message,
            url: url
        });
    }
}
const $d671ce9aaed49427$export$d1a9365cd3e8f4dd = /*#__PURE__*/ new Map();
async function $d671ce9aaed49427$export$361cf94c2d913fd4(url) {
    let socket = $d671ce9aaed49427$export$d1a9365cd3e8f4dd.get(url);
    // If the socket already exists, return it.
    if (socket) return socket;
    const { schedule: schedule } = (0, $l9LFI.createBatchScheduler)({
        id: url,
        fn: async ()=>{
            const webSocket = new (0, $7UGX6.WebSocket)(url);
            // Set up a cache for incoming "synchronous" requests.
            const requests = new Map();
            // Set up a cache for subscriptions (eth_subscribe).
            const subscriptions = new Map();
            const onMessage = ({ data: data })=>{
                const message = JSON.parse(data);
                const isSubscription = message.method === "eth_subscription";
                const id = isSubscription ? message.params.subscription : message.id;
                const cache = isSubscription ? subscriptions : requests;
                const callback = cache.get(id);
                if (callback) callback({
                    data: data
                });
                if (!isSubscription) cache.delete(id);
            };
            const onClose = ()=>{
                $d671ce9aaed49427$export$d1a9365cd3e8f4dd.delete(url);
                webSocket.removeEventListener("close", onClose);
                webSocket.removeEventListener("message", onMessage);
            };
            // Setup event listeners for RPC & subscription responses.
            webSocket.addEventListener("close", onClose);
            webSocket.addEventListener("message", onMessage);
            // Wait for the socket to open.
            if (webSocket.readyState === (0, $7UGX6.WebSocket).CONNECTING) await new Promise((resolve, reject)=>{
                if (!webSocket) return;
                webSocket.onopen = resolve;
                webSocket.onerror = reject;
            });
            // Create a new socket instance.
            socket = Object.assign(webSocket, {
                requests: requests,
                subscriptions: subscriptions
            });
            $d671ce9aaed49427$export$d1a9365cd3e8f4dd.set(url, socket);
            return [
                socket
            ];
        }
    });
    const [_, [socket_]] = await schedule();
    return socket_;
}
function $d671ce9aaed49427$var$webSocket(socket, { body: body, onResponse: onResponse }) {
    if (socket.readyState === socket.CLOSED || socket.readyState === socket.CLOSING) throw new (0, $5pGkz.WebSocketRequestError)({
        body: body,
        url: socket.url,
        details: "Socket is closed."
    });
    const id_ = $d671ce9aaed49427$var$id++;
    const callback = ({ data: data })=>{
        const message = JSON.parse(data);
        if (typeof message.id === "number" && id_ !== message.id) return;
        onResponse?.(message);
        // If we are subscribing to a topic, we want to set up a listener for incoming
        // messages.
        if (body.method === "eth_subscribe" && typeof message.result === "string") socket.subscriptions.set(message.result, callback);
        // If we are unsubscribing from a topic, we want to remove the listener.
        if (body.method === "eth_unsubscribe") socket.subscriptions.delete(body.params?.[0]);
    };
    socket.requests.set(id_, callback);
    socket.send(JSON.stringify({
        jsonrpc: "2.0",
        ...body,
        id: id_
    }));
    return socket;
}
async function $d671ce9aaed49427$var$webSocketAsync(socket, { body: body, timeout: timeout = 10000 }) {
    return (0, $1754o.withTimeout)(()=>new Promise((onResponse)=>$d671ce9aaed49427$export$82f5954781486db2.webSocket(socket, {
                body: body,
                onResponse: onResponse
            })), {
        errorInstance: new (0, $5pGkz.TimeoutError)({
            body: body,
            url: socket.url
        }),
        timeout: timeout
    });
}
const $d671ce9aaed49427$export$82f5954781486db2 = {
    http: $d671ce9aaed49427$var$http,
    webSocket: $d671ce9aaed49427$var$webSocket,
    webSocketAsync: $d671ce9aaed49427$var$webSocketAsync
};

});
parcelRegister("7UGX6", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $5c2f14c4e1a690d9$export$3909fb301d3dc8c9);

var $2WxnA = parcelRequire("2WxnA");
const $5c2f14c4e1a690d9$export$3909fb301d3dc8c9 = (0, $2WxnA.getNativeWebSocket)();

});
parcelRegister("2WxnA", function(module, exports) {

$parcel$export(module.exports, "getNativeWebSocket", () => $224ae407b70ac65d$export$f67cfa4655f7ea21);
function $224ae407b70ac65d$export$f67cfa4655f7ea21() {
    if (typeof WebSocket !== "undefined") return WebSocket;
    if (typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    if (typeof window.WebSocket !== "undefined") return window.WebSocket;
    if (typeof self.WebSocket !== "undefined") return self.WebSocket;
    throw new Error("`WebSocket` is not supported in this environment");
}

});


parcelRegister("1754o", function(module, exports) {

$parcel$export(module.exports, "withTimeout", () => $0cfa60aed82c0181$export$e86e19342bc4850e);
function $0cfa60aed82c0181$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout);
                resolve(await fn({
                    signal: controller?.signal
                }));
            } catch (err) {
                if (err.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}

});



parcelRegister("8tKwY", function(module, exports) {

$parcel$export(module.exports, "webSocket", () => $62c5203749c1bd2d$export$debf5095acd2163f);

var $5pGkz = parcelRequire("5pGkz");

var $bfr1q = parcelRequire("bfr1q");

var $iptY0 = parcelRequire("iptY0");

var $6WKkf = parcelRequire("6WKkf");
function $62c5203749c1bd2d$export$debf5095acd2163f(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { key: key = "webSocket", name: name = "WebSocket JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
        if (!url_) throw new (0, $bfr1q.UrlRequiredError)();
        return (0, $6WKkf.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const socket = await (0, $iptY0.getSocket)(url_);
                const { error: error, result: result } = await (0, $iptY0.rpc).webSocketAsync(socket, {
                    body: body,
                    timeout: timeout
                });
                if (error) throw new (0, $5pGkz.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "webSocket"
        }, {
            getSocket () {
                return (0, $iptY0.getSocket)(url_);
            },
            async subscribe ({ params: params, onData: onData, onError: onError }) {
                const socket = await (0, $iptY0.getSocket)(url_);
                const { result: subscriptionId } = await new Promise((resolve, reject)=>(0, $iptY0.rpc).webSocket(socket, {
                        body: {
                            method: "eth_subscribe",
                            params: params
                        },
                        onResponse (response) {
                            if (response.error) {
                                reject(response.error);
                                onError?.(response.error);
                                return;
                            }
                            if (typeof response.id === "number") {
                                resolve(response);
                                return;
                            }
                            if (response.method !== "eth_subscription") return;
                            onData(response.params);
                        }
                    }));
                return {
                    subscriptionId: subscriptionId,
                    async unsubscribe () {
                        return new Promise((resolve)=>(0, $iptY0.rpc).webSocket(socket, {
                                body: {
                                    method: "eth_unsubscribe",
                                    params: [
                                        subscriptionId
                                    ]
                                },
                                onResponse: resolve
                            }));
                    }
                };
            }
        });
    };
}

});

parcelRegister("5BBzT", function(module, exports) {

$parcel$export(module.exports, "getContract", () => $414d8ea7b565e9f8$export$f518c38144e1f9d);

var $5vDfU = parcelRequire("5vDfU");

var $faFP4 = parcelRequire("faFP4");

var $6sOif = parcelRequire("6sOif");

var $dTTZ8 = parcelRequire("dTTZ8");

var $2R9Q8 = parcelRequire("2R9Q8");

var $lAUaG = parcelRequire("lAUaG");

var $aJhYs = parcelRequire("aJhYs");

var $4hCRV = parcelRequire("4hCRV");
function $414d8ea7b565e9f8$export$f518c38144e1f9d({ abi: abi, address: address, publicClient: publicClient, walletClient: walletClient }) {
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi){
        if (item.type === "function") {
            if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
            else hasWriteFunction = true;
        } else if (item.type === "event") hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent) break;
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $414d8ea7b565e9f8$export$b1d653474fdb0f41(parameters);
                    return (0, $5vDfU.getAction)(publicClient, (0, $2R9Q8.readContract), "readContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $414d8ea7b565e9f8$export$b1d653474fdb0f41(parameters);
                    return (0, $5vDfU.getAction)(publicClient, (0, $lAUaG.simulateContract), "simulateContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $414d8ea7b565e9f8$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $5vDfU.getAction)(publicClient, (0, $faFP4.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $414d8ea7b565e9f8$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $5vDfU.getAction)(publicClient, (0, $dTTZ8.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $414d8ea7b565e9f8$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $5vDfU.getAction)(publicClient, (0, $aJhYs.watchContractEvent), "watchContractEvent")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $414d8ea7b565e9f8$export$b1d653474fdb0f41(parameters);
                    return (0, $5vDfU.getAction)(walletClient, (0, $4hCRV.writeContract), "writeContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $414d8ea7b565e9f8$export$b1d653474fdb0f41(parameters);
                    const client = publicClient ?? walletClient;
                    return (0, $5vDfU.getAction)(client, (0, $6sOif.estimateContractGas), "estimateContractGas")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options,
                        account: options.account ?? walletClient.account
                    });
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $414d8ea7b565e9f8$export$b1d653474fdb0f41(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}
function $414d8ea7b565e9f8$export$5d0aafa8249eb606(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some((x)=>x.indexed);
    else if (values.length === 2) hasArgs = true;
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}

});

parcelRegister("lvNQN", function(module, exports) {

$parcel$export(module.exports, "parseGwei", () => $fa9329848b9f7b53$export$7a255715fecbb534);

var $53GlG = parcelRequire("53GlG");

var $b2JLK = parcelRequire("b2JLK");
function $fa9329848b9f7b53$export$7a255715fecbb534(ether, unit = "wei") {
    return (0, $b2JLK.parseUnits)(ether, (0, $53GlG.gweiUnits)[unit]);
}

});
parcelRegister("b2JLK", function(module, exports) {

$parcel$export(module.exports, "parseUnits", () => $80a362693274f5f9$export$203ae30b4f6490b3);
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits.html
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $80a362693274f5f9$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}

});


parcelRegister("88tPr", function(module, exports) {

$parcel$export(module.exports, "persist", () => $5ec635760157368f$export$9a6132153fba2e0, (v) => $5ec635760157368f$export$9a6132153fba2e0 = v);
$parcel$export(module.exports, "subscribeWithSelector", () => $5ec635760157368f$export$5c593627aef9f076, (v) => $5ec635760157368f$export$5c593627aef9f076 = v);
var $5ec635760157368f$export$1be1fc439b849fdf;
var $5ec635760157368f$export$95a3b7b12ab518f9;
var $5ec635760157368f$export$6922d3b3a607469e;
var $5ec635760157368f$export$9a6132153fba2e0;
var $5ec635760157368f$export$4feba8a1bc8e9afd;
var $5ec635760157368f$export$5c593627aef9f076;
"use strict";
function $5ec635760157368f$var$_extends() {
    $5ec635760157368f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ec635760157368f$var$_extends.apply(this, arguments);
}
function $5ec635760157368f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5ec635760157368f$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $5ec635760157368f$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $5ec635760157368f$var$redux = $5ec635760157368f$var$reduxImpl;
var $5ec635760157368f$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $5ec635760157368f$var$_excluded2 = [
    "connection"
];
var $5ec635760157368f$var$trackedConnections = new Map();
var $5ec635760157368f$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $5ec635760157368f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $5ec635760157368f$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $5ec635760157368f$var$trackedConnections.get(options.name);
    if (existingConnection) return $5ec635760157368f$var$_extends({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5ec635760157368f$var$trackedConnections.set(options.name, newConnection);
    return $5ec635760157368f$var$_extends({
        type: "tracked",
        store: store
    }, newConnection);
};
var $5ec635760157368f$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $5ec635760157368f$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $5ec635760157368f$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $5ec635760157368f$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($5ec635760157368f$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $5ec635760157368f$var$_extends({}, $5ec635760157368f$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5ec635760157368f$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $5ec635760157368f$var$devtools = $5ec635760157368f$var$devtoolsImpl;
var $5ec635760157368f$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var $5ec635760157368f$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $5ec635760157368f$var$subscribeWithSelector = $5ec635760157368f$var$subscribeWithSelectorImpl;
var $5ec635760157368f$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $5ec635760157368f$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $5ec635760157368f$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $5ec635760157368f$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $5ec635760157368f$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            storage: $5ec635760157368f$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$persistImpl = function persistImpl(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) return $5ec635760157368f$var$oldImpl(config, baseOptions);
    return $5ec635760157368f$var$newImpl(config, baseOptions);
};
var $5ec635760157368f$var$persist = $5ec635760157368f$var$persistImpl;
$5ec635760157368f$export$1be1fc439b849fdf = $5ec635760157368f$var$combine;
$5ec635760157368f$export$95a3b7b12ab518f9 = $5ec635760157368f$var$createJSONStorage;
$5ec635760157368f$export$6922d3b3a607469e = $5ec635760157368f$var$devtools;
$5ec635760157368f$export$9a6132153fba2e0 = $5ec635760157368f$var$persist;
$5ec635760157368f$export$4feba8a1bc8e9afd = $5ec635760157368f$var$redux;
$5ec635760157368f$export$5c593627aef9f076 = $5ec635760157368f$var$subscribeWithSelector;

});

parcelRegister("iNkrR", function(module, exports) {
"use strict";
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = $daecaa38e3584fd1$var$vanilla;
module.exports = $daecaa38e3584fd1$var$vanilla;
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("f3gEZ", function(module, exports) {
"use strict";
function $af540f293314ba66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af540f293314ba66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af540f293314ba66$var$_arrayLikeToArray(o, minLen);
}
function $af540f293314ba66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af540f293314ba66$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $af540f293314ba66$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af540f293314ba66$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $af540f293314ba66$var$shallow = function(objA, objB) {
    return $af540f293314ba66$var$shallow$1(objA, objB);
};
module.exports.default = $af540f293314ba66$var$shallow;
module.exports.shallow = $af540f293314ba66$var$shallow$1;
module.exports = $af540f293314ba66$var$shallow;
module.exports.shallow = $af540f293314ba66$var$shallow$1;
module.exports.default = module.exports;

});

parcelRegister("2a1GB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iS54V").then(()=>parcelRequire("8Z419"));

});


parcelRegister("lDt57", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $fc03cc7843f50881$export$c506eb22e615ba4a, (v) => $fc03cc7843f50881$export$c506eb22e615ba4a = v);
$parcel$export(module.exports, "proxy", () => $fc03cc7843f50881$export$923f96dd5afa9ce6, (v) => $fc03cc7843f50881$export$923f96dd5afa9ce6 = v);
$parcel$export(module.exports, "ref", () => $fc03cc7843f50881$export$eff4d24c3ff7876e, (v) => $fc03cc7843f50881$export$eff4d24c3ff7876e = v);
$parcel$export(module.exports, "snapshot", () => $fc03cc7843f50881$export$b8801ea43165ed7d, (v) => $fc03cc7843f50881$export$b8801ea43165ed7d = v);
$parcel$export(module.exports, "subscribe", () => $fc03cc7843f50881$export$ec068583843480e7, (v) => $fc03cc7843f50881$export$ec068583843480e7 = v);
$parcel$export(module.exports, "unstable_buildProxyFunction", () => $fc03cc7843f50881$export$e7b04d37d9502758, (v) => $fc03cc7843f50881$export$e7b04d37d9502758 = v);
var $fc03cc7843f50881$export$c506eb22e615ba4a;
var $fc03cc7843f50881$export$923f96dd5afa9ce6;
var $fc03cc7843f50881$export$eff4d24c3ff7876e;
var $fc03cc7843f50881$export$b8801ea43165ed7d;
var $fc03cc7843f50881$export$ec068583843480e7;
var $fc03cc7843f50881$export$e7b04d37d9502758;
"use strict";

var $fkrbD = parcelRequire("fkrbD");
var $fc03cc7843f50881$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $fc03cc7843f50881$var$proxyStateMap = new WeakMap();
var $fc03cc7843f50881$var$refSet = new WeakSet();
var $fc03cc7843f50881$var$buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return $fc03cc7843f50881$var$isObject(x) && !$fc03cc7843f50881$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        $fkrbD.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if ($fc03cc7843f50881$var$refSet.has(value)) $fkrbD.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($fc03cc7843f50881$var$proxyStateMap.has(value)) {
                var _ref = $fc03cc7843f50881$var$proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!$fc03cc7843f50881$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
                removePropListener(prop);
                if ($fc03cc7843f50881$var$isObject(value)) value = $fkrbD.getUntracked(value) || value;
                var nextValue = value;
                if (value instanceof Promise) value.then(function(v) {
                    value.status = "fulfilled";
                    value.value = v;
                    notifyUpdate([
                        "resolve",
                        [
                            prop
                        ],
                        v
                    ]);
                }).catch(function(e) {
                    value.status = "rejected";
                    value.reason = e;
                    notifyUpdate([
                        "reject",
                        [
                            prop
                        ],
                        e
                    ]);
                });
                else {
                    if (!$fc03cc7843f50881$var$proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                    var childProxyState = !$fc03cc7843f50881$var$refSet.has(nextValue) && $fc03cc7843f50881$var$proxyStateMap.get(nextValue);
                    if (childProxyState) addPropListener(prop, childProxyState);
                }
                Reflect.set(target, prop, nextValue, receiver);
                notifyUpdate([
                    "set",
                    [
                        prop
                    ],
                    value,
                    prevValue
                ]);
                return true;
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $fc03cc7843f50881$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        $fc03cc7843f50881$var$proxyStateMap,
        $fc03cc7843f50881$var$refSet,
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $fc03cc7843f50881$var$_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction(), $fc03cc7843f50881$var$defaultProxyFunction = $fc03cc7843f50881$var$_buildProxyFunction[0];
function $fc03cc7843f50881$var$proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return $fc03cc7843f50881$var$defaultProxyFunction(initialObject);
}
function $fc03cc7843f50881$var$getVersion(proxyObject) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $fc03cc7843f50881$var$subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $fc03cc7843f50881$var$snapshot(proxyObject, handlePromise) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $fc03cc7843f50881$var$ref(obj) {
    $fc03cc7843f50881$var$refSet.add(obj);
    return obj;
}
var $fc03cc7843f50881$var$unstable_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction;
$fc03cc7843f50881$export$c506eb22e615ba4a = $fc03cc7843f50881$var$getVersion;
$fc03cc7843f50881$export$923f96dd5afa9ce6 = $fc03cc7843f50881$var$proxy;
$fc03cc7843f50881$export$eff4d24c3ff7876e = $fc03cc7843f50881$var$ref;
$fc03cc7843f50881$export$b8801ea43165ed7d = $fc03cc7843f50881$var$snapshot;
$fc03cc7843f50881$export$ec068583843480e7 = $fc03cc7843f50881$var$subscribe;
$fc03cc7843f50881$export$e7b04d37d9502758 = $fc03cc7843f50881$var$unstable_buildProxyFunction;

});
parcelRegister("fkrbD", function(module, exports) {

$parcel$export(module.exports, "createProxy", () => $b28dcff9705b9efe$export$7865d0c7f908de6b);
$parcel$export(module.exports, "isChanged", () => $b28dcff9705b9efe$export$3a85b3f4caf02b6f);
$parcel$export(module.exports, "getUntracked", () => $b28dcff9705b9efe$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $b28dcff9705b9efe$export$2c8383c890e26a1c);
$parcel$export(module.exports, "affectedToPathList", () => $b28dcff9705b9efe$export$10e85fc10e680a16);
const $b28dcff9705b9efe$var$e = Symbol(), $b28dcff9705b9efe$var$t = Symbol(), $b28dcff9705b9efe$var$r = "a", $b28dcff9705b9efe$var$n = "w";
let $b28dcff9705b9efe$var$o = (e, t)=>new Proxy(e, t);
const $b28dcff9705b9efe$var$s = Object.getPrototypeOf, $b28dcff9705b9efe$var$c = new WeakMap, $b28dcff9705b9efe$var$l = (e)=>e && ($b28dcff9705b9efe$var$c.has(e) ? $b28dcff9705b9efe$var$c.get(e) : $b28dcff9705b9efe$var$s(e) === Object.prototype || $b28dcff9705b9efe$var$s(e) === Array.prototype), $b28dcff9705b9efe$var$f = (e)=>"object" == typeof e && null !== e, $b28dcff9705b9efe$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($b28dcff9705b9efe$var$s(e), t);
}, $b28dcff9705b9efe$var$u = (e)=>e[$b28dcff9705b9efe$var$t] || e, $b28dcff9705b9efe$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$b28dcff9705b9efe$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $b28dcff9705b9efe$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $b28dcff9705b9efe$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$b28dcff9705b9efe$var$r].get(o);
                if (s || (s = {}, c[$b28dcff9705b9efe$var$r].set(o, s)), e === $b28dcff9705b9efe$var$n) s[$b28dcff9705b9efe$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $b28dcff9705b9efe$var$t ? o : (f("k", n), $b28dcff9705b9efe$export$7865d0c7f908de6b(Reflect.get(e, n), c[$b28dcff9705b9efe$var$r], c.c, c.t)),
            has: (t, n)=>n === $b28dcff9705b9efe$var$e ? (l = !0, c[$b28dcff9705b9efe$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($b28dcff9705b9efe$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $b28dcff9705b9efe$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$b28dcff9705b9efe$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $b28dcff9705b9efe$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$b28dcff9705b9efe$var$f(e) || !$b28dcff9705b9efe$var$f(t)) return !0;
    const s = r.get($b28dcff9705b9efe$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$b28dcff9705b9efe$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $b28dcff9705b9efe$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $b28dcff9705b9efe$export$badc26589cf7bb38 = (t)=>!!$b28dcff9705b9efe$var$l(t) && $b28dcff9705b9efe$var$e in t, $b28dcff9705b9efe$export$80d2cee7ee556e99 = (e)=>$b28dcff9705b9efe$var$l(e) && e[$b28dcff9705b9efe$var$t] || null, $b28dcff9705b9efe$export$2c8383c890e26a1c = (e, t = !0)=>{
    $b28dcff9705b9efe$var$c.set(e, t);
}, $b28dcff9705b9efe$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $b28dcff9705b9efe$var$f(e) && s.add(e);
        const i = $b28dcff9705b9efe$var$f(e) && t.get($b28dcff9705b9efe$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$b28dcff9705b9efe$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $b28dcff9705b9efe$export$9b4d5450dbd8e67e = (e)=>{
    $b28dcff9705b9efe$var$o = e;
};

});


parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});


parcelRegister("bG7tm", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", () => (parcelRequire("hCS0p")).initializeTheming);
$parcel$export(module.exports, "setColorTheme", () => (parcelRequire("hCS0p")).setColorTheme);
$parcel$export(module.exports, "setThemeVariables", () => (parcelRequire("hCS0p")).setThemeVariables);
$parcel$export(module.exports, "UiHelperUtil", () => (parcelRequire("8iLLL")).UiHelperUtil);
$parcel$export(module.exports, "TransactionUtil", () => (parcelRequire("jbpJN")).TransactionUtil);
$parcel$export(module.exports, "customElement", () => (parcelRequire("33Xir")).customElement);

var $iuM9s = parcelRequire("iuM9s");

var $jzyqy = parcelRequire("jzyqy");

var $6GKXg = parcelRequire("6GKXg");

var $lUN2G = parcelRequire("lUN2G");

var $cJIBV = parcelRequire("cJIBV");

var $gpqzP = parcelRequire("gpqzP");

var $cbfCt = parcelRequire("cbfCt");

var $64e2j = parcelRequire("64e2j");

var $hlUtV = parcelRequire("hlUtV");

var $eYY4L = parcelRequire("eYY4L");

var $ixPM7 = parcelRequire("ixPM7");

var $4GsCo = parcelRequire("4GsCo");

var $1jqc7 = parcelRequire("1jqc7");

var $djZE0 = parcelRequire("djZE0");

var $2momN = parcelRequire("2momN");

var $d07io = parcelRequire("d07io");

var $gkhm0 = parcelRequire("gkhm0");

var $kgTK1 = parcelRequire("kgTK1");

var $gictS = parcelRequire("gictS");

var $8lemW = parcelRequire("8lemW");

var $ggPbf = parcelRequire("ggPbf");

var $7zfrA = parcelRequire("7zfrA");

var $lIOMa = parcelRequire("lIOMa");

var $lX1F6 = parcelRequire("lX1F6");

var $hxKVm = parcelRequire("hxKVm");

var $lkWmQ = parcelRequire("lkWmQ");

var $dO2t7 = parcelRequire("dO2t7");

var $iFdxB = parcelRequire("iFdxB");

var $eZwNa = parcelRequire("eZwNa");

var $fh2KG = parcelRequire("fh2KG");

var $hxyvY = parcelRequire("hxyvY");

var $9Zob9 = parcelRequire("9Zob9");

var $j4rli = parcelRequire("j4rli");

var $gcK7E = parcelRequire("gcK7E");

var $frCtt = parcelRequire("frCtt");

var $epvAl = parcelRequire("epvAl");

var $izma1 = parcelRequire("izma1");

var $1sNrH = parcelRequire("1sNrH");

var $5Vkr9 = parcelRequire("5Vkr9");

var $9nUds = parcelRequire("9nUds");

var $iY2T0 = parcelRequire("iY2T0");

var $hcAH3 = parcelRequire("hcAH3");

var $dTlfF = parcelRequire("dTlfF");

var $8c8lB = parcelRequire("8c8lB");

var $jvzBe = parcelRequire("jvzBe");

var $30YuI = parcelRequire("30YuI");

var $gXhFf = parcelRequire("gXhFf");

var $d6bsG = parcelRequire("d6bsG");

var $2jqGy = parcelRequire("2jqGy");

var $6AlJM = parcelRequire("6AlJM");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $jbpJN = parcelRequire("jbpJN");

var $33Xir = parcelRequire("33Xir");
$parcel$exportWildcard(module.exports, $iuM9s);
$parcel$exportWildcard(module.exports, $jzyqy);
$parcel$exportWildcard(module.exports, $6GKXg);
$parcel$exportWildcard(module.exports, $lUN2G);
$parcel$exportWildcard(module.exports, $cJIBV);
$parcel$exportWildcard(module.exports, $gpqzP);
$parcel$exportWildcard(module.exports, $cbfCt);
$parcel$exportWildcard(module.exports, $64e2j);
$parcel$exportWildcard(module.exports, $hlUtV);
$parcel$exportWildcard(module.exports, $eYY4L);
$parcel$exportWildcard(module.exports, $ixPM7);
$parcel$exportWildcard(module.exports, $4GsCo);
$parcel$exportWildcard(module.exports, $1jqc7);
$parcel$exportWildcard(module.exports, $djZE0);
$parcel$exportWildcard(module.exports, $2momN);
$parcel$exportWildcard(module.exports, $d07io);
$parcel$exportWildcard(module.exports, $gkhm0);
$parcel$exportWildcard(module.exports, $kgTK1);
$parcel$exportWildcard(module.exports, $gictS);
$parcel$exportWildcard(module.exports, $8lemW);
$parcel$exportWildcard(module.exports, $ggPbf);
$parcel$exportWildcard(module.exports, $7zfrA);
$parcel$exportWildcard(module.exports, $lIOMa);
$parcel$exportWildcard(module.exports, $lX1F6);
$parcel$exportWildcard(module.exports, $hxKVm);
$parcel$exportWildcard(module.exports, $lkWmQ);
$parcel$exportWildcard(module.exports, $dO2t7);
$parcel$exportWildcard(module.exports, $iFdxB);
$parcel$exportWildcard(module.exports, $eZwNa);
$parcel$exportWildcard(module.exports, $fh2KG);
$parcel$exportWildcard(module.exports, $hxyvY);
$parcel$exportWildcard(module.exports, $9Zob9);
$parcel$exportWildcard(module.exports, $j4rli);
$parcel$exportWildcard(module.exports, $gcK7E);
$parcel$exportWildcard(module.exports, $frCtt);
$parcel$exportWildcard(module.exports, $epvAl);
$parcel$exportWildcard(module.exports, $izma1);
$parcel$exportWildcard(module.exports, $1sNrH);
$parcel$exportWildcard(module.exports, $5Vkr9);
$parcel$exportWildcard(module.exports, $9nUds);
$parcel$exportWildcard(module.exports, $iY2T0);
$parcel$exportWildcard(module.exports, $hcAH3);
$parcel$exportWildcard(module.exports, $dTlfF);
$parcel$exportWildcard(module.exports, $8c8lB);
$parcel$exportWildcard(module.exports, $jvzBe);
$parcel$exportWildcard(module.exports, $30YuI);
$parcel$exportWildcard(module.exports, $gXhFf);
$parcel$exportWildcard(module.exports, $d6bsG);
$parcel$exportWildcard(module.exports, $2jqGy);
$parcel$exportWildcard(module.exports, $6AlJM);

});
parcelRegister("iuM9s", function(module, exports) {

$parcel$export(module.exports, "WuiCard", () => $d770613bd78b3269$export$9de547c596d443f7);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $imjea = parcelRequire("imjea");
var $d770613bd78b3269$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d770613bd78b3269$export$9de547c596d443f7 = class WuiCard extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`<slot></slot>`;
    }
};
$d770613bd78b3269$export$9de547c596d443f7.styles = [
    (0, $hCS0p.resetStyles),
    (0, $imjea.default)
];
$d770613bd78b3269$export$9de547c596d443f7 = $d770613bd78b3269$var$__decorate([
    (0, $33Xir.customElement)("wui-card")
], $d770613bd78b3269$export$9de547c596d443f7);

});
parcelRegister("dYFMW", function(module, exports) {
$parcel$export(module.exports, "html", () => (parcelRequire("8AeG9")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("gy3vm")).LitElement);
$parcel$export(module.exports, "css", () => (parcelRequire("6qGkP")).css);
$parcel$export(module.exports, "svg", () => (parcelRequire("8AeG9")).svg);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("6qGkP")).unsafeCSS);
parcelRequire("05dpB");
parcelRequire("8AeG9");
parcelRequire("gy3vm");
parcelRequire("jWOWS");

});
parcelRegister("05dpB", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $00fadf10c81d1d3e$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $00fadf10c81d1d3e$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $00fadf10c81d1d3e$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("6qGkP")).css);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("6qGkP")).unsafeCSS);

var $6qGkP = parcelRequire("6qGkP");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $00fadf10c81d1d3e$var$i, defineProperty: $00fadf10c81d1d3e$var$e, getOwnPropertyDescriptor: $00fadf10c81d1d3e$var$r, getOwnPropertyNames: $00fadf10c81d1d3e$var$h, getOwnPropertySymbols: $00fadf10c81d1d3e$var$o, getPrototypeOf: $00fadf10c81d1d3e$var$n } = Object, $00fadf10c81d1d3e$var$a = globalThis, $00fadf10c81d1d3e$var$c = $00fadf10c81d1d3e$var$a.trustedTypes, $00fadf10c81d1d3e$var$l = $00fadf10c81d1d3e$var$c ? $00fadf10c81d1d3e$var$c.emptyScript : "", $00fadf10c81d1d3e$var$p = $00fadf10c81d1d3e$var$a.reactiveElementPolyfillSupport, $00fadf10c81d1d3e$var$d = (t, s)=>t, $00fadf10c81d1d3e$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $00fadf10c81d1d3e$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $00fadf10c81d1d3e$export$53a6892c50694894 = (t, s)=>!$00fadf10c81d1d3e$var$i(t, s), $00fadf10c81d1d3e$var$y = {
    attribute: !0,
    type: String,
    converter: $00fadf10c81d1d3e$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $00fadf10c81d1d3e$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $00fadf10c81d1d3e$var$a.litPropertyMetadata ??= new WeakMap;
class $00fadf10c81d1d3e$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $00fadf10c81d1d3e$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $00fadf10c81d1d3e$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $00fadf10c81d1d3e$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $00fadf10c81d1d3e$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($00fadf10c81d1d3e$var$d("elementProperties"))) return;
        const t = $00fadf10c81d1d3e$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($00fadf10c81d1d3e$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($00fadf10c81d1d3e$var$d("properties"))) {
            const t = this.properties, s = [
                ...$00fadf10c81d1d3e$var$h(t),
                ...$00fadf10c81d1d3e$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $6qGkP.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $6qGkP.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $6qGkP.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $00fadf10c81d1d3e$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $00fadf10c81d1d3e$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $00fadf10c81d1d3e$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$00fadf10c81d1d3e$export$c7c07a37856565d.elementStyles = [], $00fadf10c81d1d3e$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $00fadf10c81d1d3e$export$c7c07a37856565d[$00fadf10c81d1d3e$var$d("elementProperties")] = new Map, $00fadf10c81d1d3e$export$c7c07a37856565d[$00fadf10c81d1d3e$var$d("finalized")] = new Map, $00fadf10c81d1d3e$var$p?.({
    ReactiveElement: $00fadf10c81d1d3e$export$c7c07a37856565d
}), ($00fadf10c81d1d3e$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("6qGkP", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", () => $4ae602a5ecfe904c$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $4ae602a5ecfe904c$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $4ae602a5ecfe904c$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $4ae602a5ecfe904c$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4ae602a5ecfe904c$var$t = globalThis, $4ae602a5ecfe904c$export$b4d10f6001c083c2 = $4ae602a5ecfe904c$var$t.ShadowRoot && (void 0 === $4ae602a5ecfe904c$var$t.ShadyCSS || $4ae602a5ecfe904c$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $4ae602a5ecfe904c$var$s = Symbol(), $4ae602a5ecfe904c$var$o = new WeakMap;
class $4ae602a5ecfe904c$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $4ae602a5ecfe904c$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($4ae602a5ecfe904c$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $4ae602a5ecfe904c$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $4ae602a5ecfe904c$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $4ae602a5ecfe904c$export$8d80f9cac07cdb3 = (t)=>new $4ae602a5ecfe904c$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $4ae602a5ecfe904c$var$s), $4ae602a5ecfe904c$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $4ae602a5ecfe904c$export$505d1e8739bad805(o, t, $4ae602a5ecfe904c$var$s);
}, $4ae602a5ecfe904c$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($4ae602a5ecfe904c$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $4ae602a5ecfe904c$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $4ae602a5ecfe904c$export$ee69dfd951e24778 = $4ae602a5ecfe904c$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $4ae602a5ecfe904c$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("8AeG9", function(module, exports) {

$parcel$export(module.exports, "html", () => $63fd1270e1d8cadc$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $63fd1270e1d8cadc$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "noChange", () => $63fd1270e1d8cadc$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $63fd1270e1d8cadc$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $63fd1270e1d8cadc$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $63fd1270e1d8cadc$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $63fd1270e1d8cadc$var$t = globalThis, $63fd1270e1d8cadc$var$i = $63fd1270e1d8cadc$var$t.trustedTypes, $63fd1270e1d8cadc$var$s = $63fd1270e1d8cadc$var$i ? $63fd1270e1d8cadc$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $63fd1270e1d8cadc$var$e = "$lit$", $63fd1270e1d8cadc$var$h = `lit$${(Math.random() + "").slice(9)}$`, $63fd1270e1d8cadc$var$o = "?" + $63fd1270e1d8cadc$var$h, $63fd1270e1d8cadc$var$n = `<${$63fd1270e1d8cadc$var$o}>`, $63fd1270e1d8cadc$var$r = document, $63fd1270e1d8cadc$var$l = ()=>$63fd1270e1d8cadc$var$r.createComment(""), $63fd1270e1d8cadc$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $63fd1270e1d8cadc$var$a = Array.isArray, $63fd1270e1d8cadc$var$u = (t)=>$63fd1270e1d8cadc$var$a(t) || "function" == typeof t?.[Symbol.iterator], $63fd1270e1d8cadc$var$d = "[ 	\n\f\r]", $63fd1270e1d8cadc$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $63fd1270e1d8cadc$var$v = /-->/g, $63fd1270e1d8cadc$var$_ = />/g, $63fd1270e1d8cadc$var$m = RegExp(`>|${$63fd1270e1d8cadc$var$d}(?:([^\\s"'>=/]+)(${$63fd1270e1d8cadc$var$d}*=${$63fd1270e1d8cadc$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $63fd1270e1d8cadc$var$p = /'/g, $63fd1270e1d8cadc$var$g = /"/g, $63fd1270e1d8cadc$var$$ = /^(?:script|style|textarea|title)$/i, $63fd1270e1d8cadc$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $63fd1270e1d8cadc$export$c0bb0b647f701bb5 = $63fd1270e1d8cadc$var$y(1), $63fd1270e1d8cadc$export$7ed1367e7fa1ad68 = $63fd1270e1d8cadc$var$y(2), $63fd1270e1d8cadc$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $63fd1270e1d8cadc$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $63fd1270e1d8cadc$var$A = new WeakMap, $63fd1270e1d8cadc$var$E = $63fd1270e1d8cadc$var$r.createTreeWalker($63fd1270e1d8cadc$var$r, 129);
function $63fd1270e1d8cadc$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $63fd1270e1d8cadc$var$s ? $63fd1270e1d8cadc$var$s.createHTML(i) : i;
}
const $63fd1270e1d8cadc$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $63fd1270e1d8cadc$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $63fd1270e1d8cadc$var$f ? "!--" === u[1] ? c = $63fd1270e1d8cadc$var$v : void 0 !== u[1] ? c = $63fd1270e1d8cadc$var$_ : void 0 !== u[2] ? ($63fd1270e1d8cadc$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $63fd1270e1d8cadc$var$m) : void 0 !== u[3] && (c = $63fd1270e1d8cadc$var$m) : c === $63fd1270e1d8cadc$var$m ? ">" === u[0] ? (c = r ?? $63fd1270e1d8cadc$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $63fd1270e1d8cadc$var$m : '"' === u[3] ? $63fd1270e1d8cadc$var$g : $63fd1270e1d8cadc$var$p) : c === $63fd1270e1d8cadc$var$g || c === $63fd1270e1d8cadc$var$p ? c = $63fd1270e1d8cadc$var$m : c === $63fd1270e1d8cadc$var$v || c === $63fd1270e1d8cadc$var$_ ? c = $63fd1270e1d8cadc$var$f : (c = $63fd1270e1d8cadc$var$m, r = void 0);
        const x = c === $63fd1270e1d8cadc$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $63fd1270e1d8cadc$var$f ? s + $63fd1270e1d8cadc$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $63fd1270e1d8cadc$var$e + s.slice(d) + $63fd1270e1d8cadc$var$h + x) : s + $63fd1270e1d8cadc$var$h + (-2 === d ? i : x);
    }
    return [
        $63fd1270e1d8cadc$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $63fd1270e1d8cadc$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $63fd1270e1d8cadc$var$P(t, s);
        if (this.el = $63fd1270e1d8cadc$var$V.createElement(f, n), $63fd1270e1d8cadc$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $63fd1270e1d8cadc$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($63fd1270e1d8cadc$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($63fd1270e1d8cadc$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $63fd1270e1d8cadc$var$k : "?" === e[1] ? $63fd1270e1d8cadc$var$H : "@" === e[1] ? $63fd1270e1d8cadc$var$I : $63fd1270e1d8cadc$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($63fd1270e1d8cadc$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($63fd1270e1d8cadc$var$$.test(r.tagName)) {
                    const t = r.textContent.split($63fd1270e1d8cadc$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $63fd1270e1d8cadc$var$i ? $63fd1270e1d8cadc$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $63fd1270e1d8cadc$var$l()), $63fd1270e1d8cadc$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $63fd1270e1d8cadc$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $63fd1270e1d8cadc$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($63fd1270e1d8cadc$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $63fd1270e1d8cadc$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $63fd1270e1d8cadc$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $63fd1270e1d8cadc$var$N(t, i, s = t, e) {
    if (i === $63fd1270e1d8cadc$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $63fd1270e1d8cadc$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $63fd1270e1d8cadc$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $63fd1270e1d8cadc$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $63fd1270e1d8cadc$var$r).importNode(i, !0);
        $63fd1270e1d8cadc$var$E.currentNode = e;
        let h = $63fd1270e1d8cadc$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $63fd1270e1d8cadc$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $63fd1270e1d8cadc$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $63fd1270e1d8cadc$var$E.nextNode(), o++);
        }
        return $63fd1270e1d8cadc$var$E.currentNode = $63fd1270e1d8cadc$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $63fd1270e1d8cadc$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $63fd1270e1d8cadc$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $63fd1270e1d8cadc$var$N(this, t, i), $63fd1270e1d8cadc$var$c(t) ? t === $63fd1270e1d8cadc$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $63fd1270e1d8cadc$export$45b790e32b2810ee && this._$AR(), this._$AH = $63fd1270e1d8cadc$export$45b790e32b2810ee) : t !== this._$AH && t !== $63fd1270e1d8cadc$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $63fd1270e1d8cadc$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $63fd1270e1d8cadc$export$45b790e32b2810ee && $63fd1270e1d8cadc$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($63fd1270e1d8cadc$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $63fd1270e1d8cadc$var$V.createElement($63fd1270e1d8cadc$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $63fd1270e1d8cadc$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $63fd1270e1d8cadc$var$A.get(t.strings);
        return void 0 === i && $63fd1270e1d8cadc$var$A.set(t.strings, i = new $63fd1270e1d8cadc$var$V(t)), i;
    }
    k(t) {
        $63fd1270e1d8cadc$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $63fd1270e1d8cadc$var$M(this.S($63fd1270e1d8cadc$var$l()), this.S($63fd1270e1d8cadc$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $63fd1270e1d8cadc$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $63fd1270e1d8cadc$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $63fd1270e1d8cadc$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $63fd1270e1d8cadc$var$N(this, t, i, 0), o = !$63fd1270e1d8cadc$var$c(t) || t !== this._$AH && t !== $63fd1270e1d8cadc$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $63fd1270e1d8cadc$var$N(this, e[s + n], i, n), r === $63fd1270e1d8cadc$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$63fd1270e1d8cadc$var$c(r) || r !== this._$AH[n], r === $63fd1270e1d8cadc$export$45b790e32b2810ee ? t = $63fd1270e1d8cadc$export$45b790e32b2810ee : t !== $63fd1270e1d8cadc$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $63fd1270e1d8cadc$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $63fd1270e1d8cadc$var$k extends $63fd1270e1d8cadc$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $63fd1270e1d8cadc$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $63fd1270e1d8cadc$var$H extends $63fd1270e1d8cadc$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $63fd1270e1d8cadc$export$45b790e32b2810ee);
    }
}
class $63fd1270e1d8cadc$var$I extends $63fd1270e1d8cadc$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $63fd1270e1d8cadc$var$N(this, t, i, 0) ?? $63fd1270e1d8cadc$export$45b790e32b2810ee) === $63fd1270e1d8cadc$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $63fd1270e1d8cadc$export$45b790e32b2810ee && s !== $63fd1270e1d8cadc$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $63fd1270e1d8cadc$export$45b790e32b2810ee && (s === $63fd1270e1d8cadc$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $63fd1270e1d8cadc$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $63fd1270e1d8cadc$var$N(this, t);
    }
}
const $63fd1270e1d8cadc$export$8613d1ca9052b22e = {
    P: $63fd1270e1d8cadc$var$e,
    A: $63fd1270e1d8cadc$var$h,
    C: $63fd1270e1d8cadc$var$o,
    M: 1,
    L: $63fd1270e1d8cadc$var$P,
    R: $63fd1270e1d8cadc$var$S,
    D: $63fd1270e1d8cadc$var$u,
    V: $63fd1270e1d8cadc$var$N,
    I: $63fd1270e1d8cadc$var$M,
    H: $63fd1270e1d8cadc$var$R,
    N: $63fd1270e1d8cadc$var$H,
    U: $63fd1270e1d8cadc$var$I,
    B: $63fd1270e1d8cadc$var$k,
    F: $63fd1270e1d8cadc$var$L
}, $63fd1270e1d8cadc$var$Z = $63fd1270e1d8cadc$var$t.litHtmlPolyfillSupport;
$63fd1270e1d8cadc$var$Z?.($63fd1270e1d8cadc$var$V, $63fd1270e1d8cadc$var$M), ($63fd1270e1d8cadc$var$t.litHtmlVersions ??= []).push("3.1.2");
const $63fd1270e1d8cadc$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $63fd1270e1d8cadc$var$M(i.insertBefore($63fd1270e1d8cadc$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("gy3vm", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("6qGkP")).css);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("6qGkP")).unsafeCSS);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("05dpB")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("8AeG9")).html);
$parcel$export(module.exports, "svg", () => (parcelRequire("8AeG9")).svg);
$parcel$export(module.exports, "render", () => (parcelRequire("8AeG9")).render);
$parcel$export(module.exports, "noChange", () => (parcelRequire("8AeG9")).noChange);

$parcel$export(module.exports, "LitElement", () => $c0c28a488e36c74f$export$3f2f9f5909897157);

var $05dpB = parcelRequire("05dpB");

var $8AeG9 = parcelRequire("8AeG9");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $c0c28a488e36c74f$export$3f2f9f5909897157 extends (0, $05dpB.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $8AeG9.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $8AeG9.noChange;
    }
}
$c0c28a488e36c74f$export$3f2f9f5909897157._$litElement$ = !0, $c0c28a488e36c74f$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $c0c28a488e36c74f$export$3f2f9f5909897157
});
const $c0c28a488e36c74f$var$r = globalThis.litElementPolyfillSupport;
$c0c28a488e36c74f$var$r?.({
    LitElement: $c0c28a488e36c74f$export$3f2f9f5909897157
});
const $c0c28a488e36c74f$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.4");

});

parcelRegister("jWOWS", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e85af4737b434661$export$6acf61af03e62db = !1;

});


parcelRegister("hCS0p", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", () => $cd4fe0aa51803b7c$export$8ee9916a43f985de);
$parcel$export(module.exports, "setColorTheme", () => $cd4fe0aa51803b7c$export$718db041b82c5d23);
$parcel$export(module.exports, "setThemeVariables", () => $cd4fe0aa51803b7c$export$b6ed091aa8078e9b);
$parcel$export(module.exports, "resetStyles", () => $cd4fe0aa51803b7c$export$6b6f359a824920a4);
$parcel$export(module.exports, "elementStyles", () => $cd4fe0aa51803b7c$export$e7ba49a1dbca65c7);
$parcel$export(module.exports, "colorStyles", () => $cd4fe0aa51803b7c$export$ab44001f5690ee9c);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
let $cd4fe0aa51803b7c$var$themeTag = undefined;
let $cd4fe0aa51803b7c$var$darkModeTag = undefined;
let $cd4fe0aa51803b7c$var$lightModeTag = undefined;
function $cd4fe0aa51803b7c$export$8ee9916a43f985de(themeVariables, themeMode) {
    $cd4fe0aa51803b7c$var$themeTag = document.createElement("style");
    $cd4fe0aa51803b7c$var$darkModeTag = document.createElement("style");
    $cd4fe0aa51803b7c$var$lightModeTag = document.createElement("style");
    $cd4fe0aa51803b7c$var$themeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).core.cssText;
    $cd4fe0aa51803b7c$var$darkModeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).dark.cssText;
    $cd4fe0aa51803b7c$var$lightModeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($cd4fe0aa51803b7c$var$themeTag);
    document.head.appendChild($cd4fe0aa51803b7c$var$darkModeTag);
    document.head.appendChild($cd4fe0aa51803b7c$var$lightModeTag);
    $cd4fe0aa51803b7c$export$718db041b82c5d23(themeMode);
}
function $cd4fe0aa51803b7c$export$718db041b82c5d23(themeMode) {
    if ($cd4fe0aa51803b7c$var$darkModeTag && $cd4fe0aa51803b7c$var$lightModeTag) {
        if (themeMode === "light") {
            $cd4fe0aa51803b7c$var$darkModeTag.removeAttribute("media");
            $cd4fe0aa51803b7c$var$lightModeTag.media = "enabled";
        } else {
            $cd4fe0aa51803b7c$var$lightModeTag.removeAttribute("media");
            $cd4fe0aa51803b7c$var$darkModeTag.media = "enabled";
        }
    }
}
function $cd4fe0aa51803b7c$export$b6ed091aa8078e9b(themeVariables) {
    if ($cd4fe0aa51803b7c$var$themeTag && $cd4fe0aa51803b7c$var$darkModeTag && $cd4fe0aa51803b7c$var$lightModeTag) {
        $cd4fe0aa51803b7c$var$themeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).core.cssText;
        $cd4fe0aa51803b7c$var$darkModeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).dark.cssText;
        $cd4fe0aa51803b7c$var$lightModeTag.textContent = $cd4fe0aa51803b7c$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $cd4fe0aa51803b7c$var$createRootStyles(themeVariables) {
    return {
        core: (0, $6qGkP.css)`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      :root {
        --w3m-color-mix-strength: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-color-mix-strength"] ? `${themeVariables["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-font-family"] || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-font-size-master"] || "10px")};
        --w3m-border-radius-master: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-border-radius-master"] || "4px")};
        --w3m-z-index: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-z-index"] || 100)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(20, 20, 20, 0.8);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-blue-100: var(--wui-color-blue-base-100);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-accent-glass-090: var(--wui-accent-glass-base-090);
        --wui-accent-glass-080: var(--wui-accent-glass-base-080);
        --wui-accent-glass-020: var(--wui-accent-glass-base-020);
        --wui-accent-glass-015: var(--wui-accent-glass-base-015);
        --wui-accent-glass-010: var(--wui-accent-glass-base-010);
        --wui-accent-glass-005: var(--wui-accent-glass-base-005);
        --wui-accent-glass-002: var(--wui-accent-glass-base-002);

        --wui-color-fg-100: var(--wui-color-fg-base-100);
        --wui-color-fg-125: var(--wui-color-fg-base-125);
        --wui-color-fg-150: var(--wui-color-fg-base-150);
        --wui-color-fg-175: var(--wui-color-fg-base-175);
        --wui-color-fg-200: var(--wui-color-fg-base-200);
        --wui-color-fg-225: var(--wui-color-fg-base-225);
        --wui-color-fg-250: var(--wui-color-fg-base-250);
        --wui-color-fg-275: var(--wui-color-fg-base-275);
        --wui-color-fg-300: var(--wui-color-fg-base-300);

        --wui-color-bg-100: var(--wui-color-bg-base-100);
        --wui-color-bg-125: var(--wui-color-bg-base-125);
        --wui-color-bg-150: var(--wui-color-bg-base-150);
        --wui-color-bg-175: var(--wui-color-bg-base-175);
        --wui-color-bg-200: var(--wui-color-bg-base-200);
        --wui-color-bg-225: var(--wui-color-bg-base-225);
        --wui-color-bg-250: var(--wui-color-bg-base-250);
        --wui-color-bg-275: var(--wui-color-bg-base-275);
        --wui-color-bg-300: var(--wui-color-bg-base-300);

        --wui-color-success-100: var(--wui-color-success-base-100);
        --wui-color-error-100: var(--wui-color-error-base-100);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-base-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-box-shadow-blue: rgba(71, 161, 255, 0.16);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 16%, transparent);

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            var(--w3m-default)
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            var(--w3m-default)
          );

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );

          --wui-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-300)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-300)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-base-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );
        }
      }
    `,
        light: (0, $6qGkP.css)`
      :root {
        --w3m-color-mix: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#fff")};
        --w3m-accent: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#47a1ff")};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: #191a1a;

        --wui-color-blue-base-100: #47a1ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #59aaff;
        --wui-color-accent-base-080: #6cb4ff;

        --wui-accent-glass-base-090: rgba(71, 161, 255, 0.9);
        --wui-accent-glass-base-080: rgba(71, 161, 255, 0.8);
        --wui-accent-glass-base-020: rgba(71, 161, 255, 0.2);
        --wui-accent-glass-base-015: rgba(71, 161, 255, 0.15);
        --wui-accent-glass-base-010: rgba(71, 161, 255, 0.1);
        --wui-accent-glass-base-005: rgba(71, 161, 255, 0.05);
        --wui-accent-glass-base-002: rgba(71, 161, 255, 0.02);

        --wui-color-fg-base-100: #e4e7e7;
        --wui-color-fg-base-125: #d0d5d5;
        --wui-color-fg-base-150: #a8b1b1;
        --wui-color-fg-base-175: #a8b0b0;
        --wui-color-fg-base-200: #949e9e;
        --wui-color-fg-base-225: #868f8f;
        --wui-color-fg-base-250: #788080;
        --wui-color-fg-base-275: #788181;
        --wui-color-fg-base-300: #6e7777;

        --wui-color-bg-base-100: #141414;
        --wui-color-bg-base-125: #191a1a;
        --wui-color-bg-base-150: #1e1f1f;
        --wui-color-bg-base-175: #222525;
        --wui-color-bg-base-200: #272a2a;
        --wui-color-bg-base-225: #2c3030;
        --wui-color-bg-base-250: #313535;
        --wui-color-bg-base-275: #363b3b;
        --wui-color-bg-base-300: #3b4040;

        --wui-color-success-base-100: #26d962;
        --wui-color-error-base-100: #f25a67;

        --wui-success-glass-001: rgba(38, 217, 98, 0.01);
        --wui-success-glass-002: rgba(38, 217, 98, 0.02);
        --wui-success-glass-005: rgba(38, 217, 98, 0.05);
        --wui-success-glass-010: rgba(38, 217, 98, 0.1);
        --wui-success-glass-015: rgba(38, 217, 98, 0.15);
        --wui-success-glass-020: rgba(38, 217, 98, 0.2);
        --wui-success-glass-025: rgba(38, 217, 98, 0.25);
        --wui-success-glass-030: rgba(38, 217, 98, 0.3);
        --wui-success-glass-060: rgba(38, 217, 98, 0.6);
        --wui-success-glass-080: rgba(38, 217, 98, 0.8);

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: var(--wui-success-glass-015);
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-base-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;

        --wui-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-gray-glass-080: rgba(255, 255, 255, 0.8);
      }
    `,
        dark: (0, $6qGkP.css)`
      :root {
        --w3m-color-mix: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#000")};
        --w3m-accent: ${(0, $6qGkP.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#3396ff")};
        --w3m-default: #000;

        --wui-color-modal-bg-base: #fff;

        --wui-color-blue-base-100: #3396ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #2d7dd2;
        --wui-color-accent-base-080: #2978cc;

        --wui-accent-glass-base-090: rgba(51, 150, 255, 0.9);
        --wui-accent-glass-base-080: rgba(51, 150, 255, 0.8);
        --wui-accent-glass-base-020: rgba(51, 150, 255, 0.2);
        --wui-accent-glass-base-015: rgba(51, 150, 255, 0.15);
        --wui-accent-glass-base-010: rgba(51, 150, 255, 0.1);
        --wui-accent-glass-base-005: rgba(51, 150, 255, 0.05);
        --wui-accent-glass-base-002: rgba(51, 150, 255, 0.02);

        --wui-color-fg-base-100: #141414;
        --wui-color-fg-base-125: #2d3131;
        --wui-color-fg-base-150: #474d4d;
        --wui-color-fg-base-175: #636d6d;
        --wui-color-fg-base-200: #798686;
        --wui-color-fg-base-225: #828f8f;
        --wui-color-fg-base-250: #8b9797;
        --wui-color-fg-base-275: #95a0a0;
        --wui-color-fg-base-300: #9ea9a9;

        --wui-color-bg-base-100: #ffffff;
        --wui-color-bg-base-125: #f5fafa;
        --wui-color-bg-base-150: #f3f8f8;
        --wui-color-bg-base-175: #eef4f4;
        --wui-color-bg-base-200: #eaf1f1;
        --wui-color-bg-base-225: #e5eded;
        --wui-color-bg-base-250: #e1e9e9;
        --wui-color-bg-base-275: #dce7e7;
        --wui-color-bg-base-300: #d8e3e3;

        --wui-color-success-base-100: #26b562;
        --wui-color-error-base-100: #f05142;

        --wui-success-glass-001: rgba(38, 181, 98, 0.01);
        --wui-success-glass-002: rgba(38, 181, 98, 0.02);
        --wui-success-glass-005: rgba(38, 181, 98, 0.05);
        --wui-success-glass-010: rgba(38, 181, 98, 0.1);
        --wui-success-glass-015: rgba(38, 181, 98, 0.15);
        --wui-success-glass-020: rgba(38, 181, 98, 0.2);
        --wui-success-glass-025: rgba(38, 181, 98, 0.25);
        --wui-success-glass-030: rgba(38, 181, 98, 0.3);
        --wui-success-glass-060: rgba(38, 181, 98, 0.6);
        --wui-success-glass-080: rgba(38, 181, 98, 0.8);

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-base-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-gray-glass-080: rgba(0, 0, 0, 0.8);
      }
    `
    };
}
const $cd4fe0aa51803b7c$export$6b6f359a824920a4 = (0, $6qGkP.css)`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`;
const $cd4fe0aa51803b7c$export$e7ba49a1dbca65c7 = (0, $6qGkP.css)`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    outline: none;
    border: 1px solid transparent;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-005);
    }

    button:active:enabled {
      transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
      background-color: var(--wui-gray-glass-010);
    }

    button[data-variant='fill']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='accentBg']:hover:enabled {
      background: var(--wui-accent-glass-015);
    }

    button[data-variant='accentBg']:active:enabled {
      background: var(--wui-accent-glass-020);
    }
  }

  button:disabled {
    cursor: not-allowed;
    background-color: var(--wui-gray-glass-005);
  }

  button[data-variant='shade']:disabled,
  button[data-variant='accent']:disabled,
  button[data-variant='accentBg']:disabled {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-gray-glass-015);
    filter: grayscale(1);
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  button:focus-visible,
  a:focus-visible {
    border: 1px solid var(--wui-color-accent-100);
    background-color: var(--wui-gray-glass-005);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  button[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  button[data-variant='fill']:disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
  }

  button[data-variant='fill']:disabled > wui-icon {
    color: var(--wui-gray-glass-015);
  }

  button[data-variant='shade'] {
    color: var(--wui-color-fg-200);
  }

  button[data-variant='accent'],
  button[data-variant='accentBg'] {
    color: var(--wui-color-accent-100);
  }

  button[data-variant='accentBg'] {
    background: var(--wui-accent-glass-010);
    border: 1px solid var(--wui-accent-glass-010);
  }

  button[data-variant='fullWidth'] {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    height: 56px;
    border: none;
    background-color: var(--wui-gray-glass-002);
    color: var(--wui-color-fg-200);
    gap: var(--wui-spacing-xs);
  }

  button:active:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  button[data-variant='fill']:active:enabled {
    background-color: var(--wui-color-accent-080);
    border: 1px solid var(--wui-gray-glass-010);
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`;
const $cd4fe0aa51803b7c$export$ab44001f5690ee9c = (0, $6qGkP.css)`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }
`;

});

parcelRegister("33Xir", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $23afa5f3f27079b1$export$da64fc29f17f9d0e);
function $23afa5f3f27079b1$var$standardCustomElement(tagName, descriptor) {
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $23afa5f3f27079b1$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $23afa5f3f27079b1$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $23afa5f3f27079b1$var$legacyCustomElement(tagName, classOrDescriptor) : $23afa5f3f27079b1$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});

parcelRegister("imjea", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d9323b7cf5d32f$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $d5d9323b7cf5d32f$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-color-modal-bg);
    overflow: hidden;
  }
`;

});


parcelRegister("jzyqy", function(module, exports) {

$parcel$export(module.exports, "WuiIcon", () => $e3fbfdc53b1c952a$export$10b8e15b42b9fa26);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $9gEQu = parcelRequire("9gEQu");

var $9E6fH = parcelRequire("9E6fH");

var $gBkae = parcelRequire("gBkae");

var $4VD8T = parcelRequire("4VD8T");

var $fakyv = parcelRequire("fakyv");

var $67aMg = parcelRequire("67aMg");

var $bPyqG = parcelRequire("bPyqG");

var $ckmRj = parcelRequire("ckmRj");

var $01nsN = parcelRequire("01nsN");

var $cDtBa = parcelRequire("cDtBa");

var $2hJE5 = parcelRequire("2hJE5");

var $3dHZS = parcelRequire("3dHZS");

var $h8bQS = parcelRequire("h8bQS");

var $cI7Pa = parcelRequire("cI7Pa");

var $8f0SV = parcelRequire("8f0SV");

var $8nSsg = parcelRequire("8nSsg");

var $8hNJk = parcelRequire("8hNJk");

var $7nwRK = parcelRequire("7nwRK");

var $8KkCc = parcelRequire("8KkCc");

var $fcX6L = parcelRequire("fcX6L");

var $3xgn0 = parcelRequire("3xgn0");

var $9W36v = parcelRequire("9W36v");

var $9WRDT = parcelRequire("9WRDT");

var $4P2fY = parcelRequire("4P2fY");

var $dL01n = parcelRequire("dL01n");

var $gyZvy = parcelRequire("gyZvy");

var $fYcZT = parcelRequire("fYcZT");

var $1nPQc = parcelRequire("1nPQc");

var $kBXf5 = parcelRequire("kBXf5");

var $dsuLr = parcelRequire("dsuLr");

var $aHJRg = parcelRequire("aHJRg");

var $coy0y = parcelRequire("coy0y");

var $hHnCR = parcelRequire("hHnCR");

var $92mMj = parcelRequire("92mMj");

var $aaSXS = parcelRequire("aaSXS");

var $4DK9k = parcelRequire("4DK9k");

var $2lz22 = parcelRequire("2lz22");

var $ae8Ax = parcelRequire("ae8Ax");

var $bMzfl = parcelRequire("bMzfl");

var $h0Fug = parcelRequire("h0Fug");

var $19sOk = parcelRequire("19sOk");

var $eSCyl = parcelRequire("eSCyl");

var $8K7Dx = parcelRequire("8K7Dx");

var $5Izow = parcelRequire("5Izow");

var $buLAj = parcelRequire("buLAj");

var $7gDmF = parcelRequire("7gDmF");

var $4GYaU = parcelRequire("4GYaU");

var $1MMrL = parcelRequire("1MMrL");

var $bWLxW = parcelRequire("bWLxW");

var $bYqAX = parcelRequire("bYqAX");

var $9VhKk = parcelRequire("9VhKk");

var $7JXVM = parcelRequire("7JXVM");

var $HyFdL = parcelRequire("HyFdL");

var $jhn1S = parcelRequire("jhn1S");

var $cyMzh = parcelRequire("cyMzh");

var $hm7hZ = parcelRequire("hm7hZ");
var $e3fbfdc53b1c952a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $e3fbfdc53b1c952a$var$svgOptions = {
    allWallets: (0, $9E6fH.allWalletsSvg),
    alpha: (0, $hm7hZ.alphaSvg),
    appStore: (0, $gBkae.appStoreSvg),
    chromeStore: (0, $8f0SV.chromeStoreSvg),
    apple: (0, $4VD8T.appleSvg),
    arrowBottom: (0, $fakyv.arrowBottomSvg),
    arrowLeft: (0, $67aMg.arrowLeftSvg),
    arrowRight: (0, $bPyqG.arrowRightSvg),
    arrowTop: (0, $ckmRj.arrowTopSvg),
    browser: (0, $01nsN.browserSvg),
    checkmark: (0, $cDtBa.checkmarkSvg),
    chevronBottom: (0, $2hJE5.chevronBottomSvg),
    chevronLeft: (0, $3dHZS.chevronLeftSvg),
    chevronRight: (0, $h8bQS.chevronRightSvg),
    chevronTop: (0, $cI7Pa.chevronTopSvg),
    clock: (0, $8nSsg.clockSvg),
    close: (0, $8hNJk.closeSvg),
    compass: (0, $8KkCc.compassSvg),
    coinPlaceholder: (0, $7nwRK.coinPlaceholderSvg),
    copy: (0, $fcX6L.copySvg),
    cursor: (0, $3xgn0.cursorSvg),
    desktop: (0, $9W36v.desktopSvg),
    disconnect: (0, $9WRDT.disconnectSvg),
    discord: (0, $4P2fY.discordSvg),
    etherscan: (0, $dL01n.etherscanSvg),
    extension: (0, $gyZvy.extensionSvg),
    externalLink: (0, $fYcZT.externalLinkSvg),
    facebook: (0, $1nPQc.facebookSvg),
    filters: (0, $kBXf5.filtersSvg),
    github: (0, $dsuLr.githubSvg),
    google: (0, $aHJRg.googleSvg),
    helpCircle: (0, $coy0y.helpCircleSvg),
    infoCircle: (0, $hHnCR.infoCircleSvg),
    mail: (0, $92mMj.mailSvg),
    mobile: (0, $aaSXS.mobileSvg),
    networkPlaceholder: (0, $4DK9k.networkPlaceholderSvg),
    nftPlaceholder: (0, $2lz22.nftPlaceholderSvg),
    off: (0, $ae8Ax.offSvg),
    playStore: (0, $bMzfl.playStoreSvg),
    qrCode: (0, $h0Fug.qrCodeIcon),
    refresh: (0, $19sOk.refreshSvg),
    search: (0, $eSCyl.searchSvg),
    swapHorizontal: (0, $8K7Dx.swapHorizontalSvg),
    swapHorizontalBold: (0, $5Izow.swapHorizontalBoldSvg),
    swapVertical: (0, $buLAj.swapVerticalSvg),
    telegram: (0, $7gDmF.telegramSvg),
    twitch: (0, $4GYaU.twitchSvg),
    twitter: (0, $1MMrL.twitterSvg),
    twitterIcon: (0, $bWLxW.twitterIconSvg),
    verify: (0, $bYqAX.verifySvg),
    verifyFilled: (0, $9VhKk.verifyFilledSvg),
    wallet: (0, $HyFdL.walletSvg),
    walletConnect: (0, $jhn1S.walletConnectSvg),
    walletPlaceholder: (0, $7JXVM.walletPlaceholderSvg),
    warningCircle: (0, $cyMzh.warningCircleSvg)
};
let $e3fbfdc53b1c952a$export$10b8e15b42b9fa26 = class WuiIcon extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "copy";
        this.color = "fg-300";
    }
    render() {
        this.style.cssText = `
      --local-color: ${`var(--wui-color-${this.color});`}
      --local-width: ${`var(--wui-icon-size-${this.size});`}
    `;
        return (0, $8AeG9.html)`${$e3fbfdc53b1c952a$var$svgOptions[this.name]}`;
    }
};
$e3fbfdc53b1c952a$export$10b8e15b42b9fa26.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.colorStyles),
    (0, $9gEQu.default)
];
$e3fbfdc53b1c952a$var$__decorate([
    (0, $kRRY9.property)()
], $e3fbfdc53b1c952a$export$10b8e15b42b9fa26.prototype, "size", void 0);
$e3fbfdc53b1c952a$var$__decorate([
    (0, $kRRY9.property)()
], $e3fbfdc53b1c952a$export$10b8e15b42b9fa26.prototype, "name", void 0);
$e3fbfdc53b1c952a$var$__decorate([
    (0, $kRRY9.property)()
], $e3fbfdc53b1c952a$export$10b8e15b42b9fa26.prototype, "color", void 0);
$e3fbfdc53b1c952a$export$10b8e15b42b9fa26 = $e3fbfdc53b1c952a$var$__decorate([
    (0, $33Xir.customElement)("wui-icon")
], $e3fbfdc53b1c952a$export$10b8e15b42b9fa26);

});
parcelRegister("7AsZS", function(module, exports) {
$parcel$export(module.exports, "property", () => (parcelRequire("kRRY9")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("dBBvD")).state);
parcelRequire("fOVFC");
parcelRequire("kRRY9");
parcelRequire("dBBvD");
parcelRequire("7MWJz");
parcelRequire("88KDE");
parcelRequire("8K2ED");
parcelRequire("694m7");
parcelRequire("lzh1i");
parcelRequire("bEjaw");

});
parcelRegister("fOVFC", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b84842a636574584$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("kRRY9", function(module, exports) {

$parcel$export(module.exports, "property", () => $f3129f0cfed906e5$export$d541bacb2bda4494);

var $05dpB = parcelRequire("05dpB");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f3129f0cfed906e5$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $05dpB.defaultConverter),
    reflect: !1,
    hasChanged: (0, $05dpB.notEqual)
}, $f3129f0cfed906e5$export$8d623b1670eb40f4 = (t = $f3129f0cfed906e5$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $f3129f0cfed906e5$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $f3129f0cfed906e5$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("dBBvD", function(module, exports) {

$parcel$export(module.exports, "state", () => $9e7bd39a4283a498$export$ca000e230c0caa3e);

var $kRRY9 = parcelRequire("kRRY9");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9e7bd39a4283a498$export$ca000e230c0caa3e(r) {
    return (0, $kRRY9.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("7MWJz", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5aba93711d0cb3b5$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("88KDE", function(module, exports) {

var $eltdi = parcelRequire("eltdi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5ed33f81b8733747$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $eltdi.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $eltdi.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("eltdi", function(module, exports) {

$parcel$export(module.exports, "desc", () => $a719b003c2477efb$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a719b003c2477efb$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("8K2ED", function(module, exports) {

var $eltdi = parcelRequire("eltdi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $65d4adb66606c3f4$var$e;
function $65d4adb66606c3f4$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $eltdi.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($65d4adb66606c3f4$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("694m7", function(module, exports) {

var $eltdi = parcelRequire("eltdi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4796f64cea668c02$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $eltdi.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("lzh1i", function(module, exports) {

var $eltdi = parcelRequire("eltdi");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fb3a11a87e0cde3a$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $eltdi.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("bEjaw", function(module, exports) {

var $eltdi = parcelRequire("eltdi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $87b24ca38cac3a77$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $eltdi.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("9gEQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf54abe0d3b2d30$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $6bf54abe0d3b2d30$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    aspect-ratio: 1 / 1;
    color: var(--local-color);
    width: var(--local-width);
  }

  svg {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
`;

});

parcelRegister("9E6fH", function(module, exports) {

$parcel$export(module.exports, "allWalletsSvg", () => $705cb30710f8de83$export$7d5fd172cc1c231a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $705cb30710f8de83$export$7d5fd172cc1c231a = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 24 24">
  <path
    style="fill: var(--wui-color-accent-100);"
    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
  />
</svg>`;

});

parcelRegister("gBkae", function(module, exports) {

$parcel$export(module.exports, "appStoreSvg", () => $c15fbe3393fe7ccc$export$bda99385bd09fbb7);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $c15fbe3393fe7ccc$export$bda99385bd09fbb7 = (0, $8AeG9.svg)`
<svg width="36" height="36">
  <path
    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"
    fill="url(#a)"
  />
  <path
    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"
    fill="#fff"
  />
  <defs>
    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#18BFFB" />
      <stop offset="1" stop-color="#2072F3" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("4VD8T", function(module, exports) {

$parcel$export(module.exports, "appleSvg", () => $396ad92a32f8e63c$export$3f5c85d1c093200);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $396ad92a32f8e63c$export$3f5c85d1c093200 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#000" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("fakyv", function(module, exports) {

$parcel$export(module.exports, "arrowBottomSvg", () => $b0a7bc183bbb9e1f$export$6f382756ddebc10);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $b0a7bc183bbb9e1f$export$6f382756ddebc10 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("67aMg", function(module, exports) {

$parcel$export(module.exports, "arrowLeftSvg", () => $473bc1b474eea96c$export$539cc194b4601565);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $473bc1b474eea96c$export$539cc194b4601565 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("bPyqG", function(module, exports) {

$parcel$export(module.exports, "arrowRightSvg", () => $89cf2a1925dee5e0$export$8c76deeccbfa0068);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $89cf2a1925dee5e0$export$8c76deeccbfa0068 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("ckmRj", function(module, exports) {

$parcel$export(module.exports, "arrowTopSvg", () => $8f991596134f1ab6$export$2903aa7e1dab2e70);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $8f991596134f1ab6$export$2903aa7e1dab2e70 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("01nsN", function(module, exports) {

$parcel$export(module.exports, "browserSvg", () => $00424b7ba0906745$export$9a659d11e13bcec5);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $00424b7ba0906745$export$9a659d11e13bcec5 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("cDtBa", function(module, exports) {

$parcel$export(module.exports, "checkmarkSvg", () => $933016355f8b708d$export$1e994e99baa45d19);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $933016355f8b708d$export$1e994e99baa45d19 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M12.04 2.65c.47.3.6.91.3 1.38l-5.78 9a1 1 0 0 1-1.61.1L1.73 9.27A1 1 0 1 1 3.27 8L5.6 10.8l5.05-7.85a1 1 0 0 1 1.38-.3Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("2hJE5", function(module, exports) {

$parcel$export(module.exports, "chevronBottomSvg", () => $1aa0938c9763074e$export$515090d56df26148);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $1aa0938c9763074e$export$515090d56df26148 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3dHZS", function(module, exports) {

$parcel$export(module.exports, "chevronLeftSvg", () => $2584b6deae95c04f$export$dd4e32e981ac6b2);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $2584b6deae95c04f$export$dd4e32e981ac6b2 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("h8bQS", function(module, exports) {

$parcel$export(module.exports, "chevronRightSvg", () => $c78c608cc4459618$export$79c9cf11f1aff07c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $c78c608cc4459618$export$79c9cf11f1aff07c = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("cI7Pa", function(module, exports) {

$parcel$export(module.exports, "chevronTopSvg", () => $940fa9d19d492f6d$export$95ea2c128f24f835);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $940fa9d19d492f6d$export$95ea2c128f24f835 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8f0SV", function(module, exports) {

$parcel$export(module.exports, "chromeStoreSvg", () => $60006923f6bf2a86$export$a97c1f844e68ea51);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $60006923f6bf2a86$export$a97c1f844e68ea51 = (0, $8AeG9.svg)`<svg width="36" height="36" fill="none">
  <path
    fill="#fff"
    fill-opacity=".05"
    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"
  />
  <path
    stroke="#fff"
    stroke-opacity=".05"
    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"
  />
  <path
    fill="url(#a)"
    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"
  />
  <path
    fill="url(#b)"
    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"
  />
  <path
    fill="url(#c)"
    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"
  />
  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />
  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />
  <defs>
    <linearGradient
      id="a"
      x1="6.294"
      x2="41.1"
      y1="5.995"
      y2="5.995"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D93025" />
      <stop offset="1" stop-color="#EA4335" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="20.953"
      x2="37.194"
      y1="32.143"
      y2="2.701"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCC934" />
      <stop offset="1" stop-color="#FBBC04" />
    </linearGradient>
    <linearGradient
      id="c"
      x1="25.873"
      x2="9.632"
      y1="31.2"
      y2="1.759"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1E8E3E" />
      <stop offset="1" stop-color="#34A853" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("8nSsg", function(module, exports) {

$parcel$export(module.exports, "clockSvg", () => $61aab64b447da753$export$36e96663783b415c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $61aab64b447da753$export$36e96663783b415c = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 2.99a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-4a1 1 0 0 1 1 1v2.58l1.85 1.85a1 1 0 0 1-1.41 1.42L6.29 8.69A1 1 0 0 1 6 8v-3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8hNJk", function(module, exports) {

$parcel$export(module.exports, "closeSvg", () => $60867ca056564292$export$e973b7b7b0b44400);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $60867ca056564292$export$e973b7b7b0b44400 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("7nwRK", function(module, exports) {

$parcel$export(module.exports, "coinPlaceholderSvg", () => $55f42cd8a1b6c685$export$c48cbfcb1f749517);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $55f42cd8a1b6c685$export$c48cbfcb1f749517 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8KkCc", function(module, exports) {

$parcel$export(module.exports, "compassSvg", () => $65e29c53a928357a$export$9fe5dd11ac55c8d4);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $65e29c53a928357a$export$9fe5dd11ac55c8d4 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fcX6L", function(module, exports) {

$parcel$export(module.exports, "copySvg", () => $b125d3a2613ba2c4$export$ec40c5c35ef5dd82);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $b125d3a2613ba2c4$export$ec40c5c35ef5dd82 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.5 0h1.67c.68 0 1.26 0 1.73.04.5.05.97.14 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73V6.5c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.43.03-.95.03-1.57.03 0 .62 0 1.14-.04 1.57-.04.5-.14.97-.4 1.42-.29.52-.72.95-1.24 1.24-.44.26-.92.35-1.41.4-.48.04-1.05.04-1.74.04H4.83c-.68 0-1.26 0-1.73-.04-.5-.05-.97-.14-1.42-.4-.52-.3-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.42A20.9 20.9 0 0 1 0 11.17V9.5c0-.69 0-1.26.04-1.74.05-.5.14-.97.4-1.41.3-.52.72-.95 1.24-1.25.45-.25.92-.35 1.42-.4.43-.03.95-.03 1.57-.03 0-.62 0-1.14.04-1.57.04-.5.14-.97.4-1.42.29-.52.72-.95 1.24-1.24.44-.26.92-.35 1.41-.4A20.9 20.9 0 0 1 9.5 0ZM4.67 6.67c-.63 0-1.06 0-1.4.03-.35.03-.5.09-.6.14-.2.12-.38.3-.5.5-.05.1-.1.24-.14.6C2 8.32 2 8.8 2 9.54v1.59c0 .73 0 1.22.03 1.6.04.35.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h1.58c.74 0 1.22 0 1.6-.03.36-.04.5-.1.6-.15.2-.11.38-.29.5-.5.05-.09.1-.24.14-.6.03-.33.03-.76.03-1.39-.6 0-1.13 0-1.57-.04-.5-.04-.97-.14-1.41-.4-.52-.29-.95-.72-1.25-1.24a3.39 3.39 0 0 1-.4-1.41c-.03-.44-.03-.96-.03-1.57Zm3.27-4.64c-.36.04-.5.1-.6.15-.2.11-.38.29-.5.5-.05.09-.1.24-.14.6-.03.37-.03.86-.03 1.6v1.58c0 .74 0 1.22.03 1.6.03.36.09.5.14.6.12.2.3.38.5.5.1.05.24.1.6.14.38.03.86.03 1.6.03h1.59c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6V4.87c0-.73 0-1.22-.03-1.6a1.46 1.46 0 0 0-.15-.6c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.14-.37-.03-.86-.03-1.6-.03H9.55c-.74 0-1.22 0-1.6.03Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3xgn0", function(module, exports) {

$parcel$export(module.exports, "cursorSvg", () => $293126e67eff4c15$export$615c57907ad3661f);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $293126e67eff4c15$export$615c57907ad3661f = (0, $8AeG9.svg)` <svg fill="none" viewBox="0 0 13 4">
  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />
</svg>`;

});

parcelRegister("9W36v", function(module, exports) {

$parcel$export(module.exports, "desktopSvg", () => $73bbf03b777200ea$export$7a2123fcf97e10d1);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $73bbf03b777200ea$export$7a2123fcf97e10d1 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"
    clip-rule="evenodd"
  />
  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />
</svg>`;

});

parcelRegister("9WRDT", function(module, exports) {

$parcel$export(module.exports, "disconnectSvg", () => $73e3241ae6fe5630$export$50fbdab79b8f082d);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $73e3241ae6fe5630$export$50fbdab79b8f082d = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4P2fY", function(module, exports) {

$parcel$export(module.exports, "discordSvg", () => $382dacf810c8bdc1$export$29470bd7472aef51);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $382dacf810c8bdc1$export$29470bd7472aef51 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("dL01n", function(module, exports) {

$parcel$export(module.exports, "etherscanSvg", () => $a03fae61282dd84f$export$fad2d5a54496223b);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $a03fae61282dd84f$export$fad2d5a54496223b = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"
  />
</svg>`;

});

parcelRegister("gyZvy", function(module, exports) {

$parcel$export(module.exports, "extensionSvg", () => $c0ef8884edd79e7f$export$df81a22cbcc6237a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $c0ef8884edd79e7f$export$df81a22cbcc6237a = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fYcZT", function(module, exports) {

$parcel$export(module.exports, "externalLinkSvg", () => $ba068a9cecdd7171$export$34a422f948687038);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $ba068a9cecdd7171$export$34a422f948687038 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("1nPQc", function(module, exports) {

$parcel$export(module.exports, "facebookSvg", () => $102026f6eac1f141$export$1ff5018c782ba6f);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $102026f6eac1f141$export$1ff5018c782ba6f = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"
        />
      </g>
    </g>
    <path
      fill="#1877F2"
      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"
    />
    <path
      fill="#fff"
      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"
    />
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("kBXf5", function(module, exports) {

$parcel$export(module.exports, "filtersSvg", () => $f01537a2a59fc523$export$9261929cf6dcbff0);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $f01537a2a59fc523$export$9261929cf6dcbff0 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("dsuLr", function(module, exports) {

$parcel$export(module.exports, "githubSvg", () => $9cc5c109d74726ac$export$f094865edb198013);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $9cc5c109d74726ac$export$f094865edb198013 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("aHJRg", function(module, exports) {

$parcel$export(module.exports, "googleSvg", () => $7cb17e058f89bfe6$export$62a66155552ed9b0);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $7cb17e058f89bfe6$export$62a66155552ed9b0 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#fff" fill-opacity=".05" />
      <g clip-path="url(#c)">
        <path
          fill="#4285F4"
          d="M20 17.7v4.65h6.46a5.53 5.53 0 0 1-2.41 3.61l3.9 3.02c2.26-2.09 3.57-5.17 3.57-8.82 0-.85-.08-1.67-.22-2.46H20Z"
        />
        <path
          fill="#34A853"
          d="m13.27 22.17-.87.67-3.11 2.42A12 12 0 0 0 20 31.9c3.24 0 5.96-1.07 7.94-2.9l-3.9-3.03A7.15 7.15 0 0 1 20 27.12a7.16 7.16 0 0 1-6.72-4.94v-.01Z"
        />
        <path
          fill="#FBBC05"
          d="M9.29 14.5a11.85 11.85 0 0 0 0 10.76l3.99-3.1a7.19 7.19 0 0 1 0-4.55l-4-3.1Z"
        />
        <path
          fill="#EA4335"
          d="M20 12.66c1.77 0 3.34.61 4.6 1.8l3.43-3.44A11.51 11.51 0 0 0 20 7.89c-4.7 0-8.74 2.69-10.71 6.62l3.99 3.1A7.16 7.16 0 0 1 20 12.66Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("coy0y", function(module, exports) {

$parcel$export(module.exports, "helpCircleSvg", () => $90621b310d4bdd73$export$cbf7b9dd25929c90);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $90621b310d4bdd73$export$cbf7b9dd25929c90 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hHnCR", function(module, exports) {

$parcel$export(module.exports, "infoCircleSvg", () => $ce28c7632a8418a7$export$313082e449e2d152);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $ce28c7632a8418a7$export$313082e449e2d152 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("92mMj", function(module, exports) {

$parcel$export(module.exports, "mailSvg", () => $6945f83f4a80f758$export$a9b1939cca165cd6);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $6945f83f4a80f758$export$a9b1939cca165cd6 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("aaSXS", function(module, exports) {

$parcel$export(module.exports, "mobileSvg", () => $768579667dab66ac$export$b6a7821857ebc7d7);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $768579667dab66ac$export$b6a7821857ebc7d7 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4DK9k", function(module, exports) {

$parcel$export(module.exports, "networkPlaceholderSvg", () => $360e9a45351a2e08$export$8eef6146d36b9527);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $360e9a45351a2e08$export$8eef6146d36b9527 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 22 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("2lz22", function(module, exports) {

$parcel$export(module.exports, "nftPlaceholderSvg", () => $1b58b78324f9e5fe$export$cacef02b4679549a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $1b58b78324f9e5fe$export$cacef02b4679549a = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("ae8Ax", function(module, exports) {

$parcel$export(module.exports, "offSvg", () => $7721dfacd03826fc$export$7ec09ee48c3bf315);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $7721dfacd03826fc$export$7ec09ee48c3bf315 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("bMzfl", function(module, exports) {

$parcel$export(module.exports, "playStoreSvg", () => $893f849d14d7525b$export$65007b9f28ed0950);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $893f849d14d7525b$export$65007b9f28ed0950 = (0, $8AeG9.svg)` <svg
  width="36"
  height="36"
  fill="none"
>
  <path
    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
    fill="#fff"
    fill-opacity=".05"
  />
  <path
    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"
    fill="#EA4335"
  />
  <path
    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"
    fill="#FBBC04"
  />
  <path
    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"
    fill="#4285F4"
  />
  <path
    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"
    fill="#34A853"
  />
  <path
    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"
    stroke="#fff"
    stroke-opacity=".05"
  />
</svg>`;

});

parcelRegister("h0Fug", function(module, exports) {

$parcel$export(module.exports, "qrCodeIcon", () => $c6229e3adb8417c0$export$b033e2eb4807deba);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $c6229e3adb8417c0$export$b033e2eb4807deba = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"
  />
</svg>`;

});

parcelRegister("19sOk", function(module, exports) {

$parcel$export(module.exports, "refreshSvg", () => $0d6cfaeb77935d2a$export$bbe3b42eaaf82fae);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $0d6cfaeb77935d2a$export$bbe3b42eaaf82fae = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("eSCyl", function(module, exports) {

$parcel$export(module.exports, "searchSvg", () => $ad5403a53c7245cf$export$28881e95f40c5f68);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $ad5403a53c7245cf$export$28881e95f40c5f68 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8K7Dx", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalSvg", () => $65d88b1bb7d50062$export$43cc65051e9f7716);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $65d88b1bb7d50062$export$43cc65051e9f7716 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("5Izow", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalBoldSvg", () => $429c846757faa6f3$export$6929881544dda4e0);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $429c846757faa6f3$export$6929881544dda4e0 = (0, $8AeG9.svg)`<svg width="10" height="10" viewBox="0 0 10 10">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("buLAj", function(module, exports) {

$parcel$export(module.exports, "swapVerticalSvg", () => $85e7686712c1c3b6$export$8fbc1b2c09145763);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $85e7686712c1c3b6$export$8fbc1b2c09145763 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("7gDmF", function(module, exports) {

$parcel$export(module.exports, "telegramSvg", () => $54a89008bf8a760c$export$367999698d7de87a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $54a89008bf8a760c$export$367999698d7de87a = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("4GYaU", function(module, exports) {

$parcel$export(module.exports, "twitchSvg", () => $36a9c32d93937794$export$759b73a5195b6264);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $36a9c32d93937794$export$759b73a5195b6264 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("1MMrL", function(module, exports) {

$parcel$export(module.exports, "twitterSvg", () => $14cfdaa737a690cd$export$dd8df3e26aa6585);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $14cfdaa737a690cd$export$dd8df3e26aa6585 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1D9BF0" />
      <path
        fill="#fff"
        d="M30 13.81c-.74.33-1.53.55-2.36.65.85-.51 1.5-1.32 1.8-2.27-.79.47-1.66.8-2.6 1a4.1 4.1 0 0 0-7 3.73c-3.4-.17-6.42-1.8-8.45-4.28a4.1 4.1 0 0 0 1.27 5.47c-.67-.02-1.3-.2-1.86-.5a4.1 4.1 0 0 0 3.3 4.07c-.58.15-1.21.19-1.86.07a4.1 4.1 0 0 0 3.83 2.85A8.25 8.25 0 0 1 10 26.3a11.62 11.62 0 0 0 6.29 1.84c7.62 0 11.92-6.44 11.66-12.2.8-.59 1.5-1.3 2.05-2.13Z"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("bWLxW", function(module, exports) {

$parcel$export(module.exports, "twitterIconSvg", () => $8b29fe3e974cb646$export$d6bfd63304732c58);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $8b29fe3e974cb646$export$d6bfd63304732c58 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"
  />
</svg>`;

});

parcelRegister("bYqAX", function(module, exports) {

$parcel$export(module.exports, "verifySvg", () => $8b79ed85fe1e5907$export$dddaa7bddf7e22f);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $8b79ed85fe1e5907$export$dddaa7bddf7e22f = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 28 28">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9VhKk", function(module, exports) {

$parcel$export(module.exports, "verifyFilledSvg", () => $739733f9f0f4a051$export$1f9737848f580d88);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $739733f9f0f4a051$export$1f9737848f580d88 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m4.1 12.43-.45-.78-.93-.2a1.65 1.65 0 0 1-1.31-1.8l.1-.86-.61-.71a1.65 1.65 0 0 1 0-2.16l.6-.7-.09-.85c-.1-.86.47-1.64 1.3-1.81l.94-.2.45-.78A1.65 1.65 0 0 1 6.23.9l.77.36.78-.36c.77-.36 1.69-.07 2.12.66l.47.8.91.2c.84.17 1.4.95 1.31 1.8l-.1.86.6.7c.54.62.54 1.54.01 2.16l-.6.71.09.86c.1.85-.47 1.63-1.3 1.8l-.92.2-.47.79a1.65 1.65 0 0 1-2.12.66L7 12.74l-.77.36c-.78.35-1.7.07-2.13-.67Zm5.74-6.9a1 1 0 1 0-1.68-1.07L6.32 7.3l-.55-.66a1 1 0 0 0-1.54 1.28l1.43 1.71a1 1 0 0 0 1.61-.1l2.57-4Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("7JXVM", function(module, exports) {

$parcel$export(module.exports, "walletPlaceholderSvg", () => $5a2b3967348c4bee$export$e1456ec7b14fe70e);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $5a2b3967348c4bee$export$e1456ec7b14fe70e = (0, $8AeG9.svg)`
  <svg fill="none" viewBox="0 0 48 44">
    <path
      style="fill: var(--wui-color-bg-300);"
      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"
    />
    <path
      style="fill: var(--wui-color-fg-200);"
      fill-rule="evenodd"
      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"
      clip-rule="evenodd"
    />
  </svg>
`;

});

parcelRegister("HyFdL", function(module, exports) {

$parcel$export(module.exports, "walletSvg", () => $082ee7c966f484af$export$9025df5921500944);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $082ee7c966f484af$export$9025df5921500944 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("jhn1S", function(module, exports) {

$parcel$export(module.exports, "walletConnectSvg", () => $e091780225dfc448$export$84e288e571149f90);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $e091780225dfc448$export$84e288e571149f90 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 96 67">
  <path
    fill="currentColor"
    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"
  />
  <path
    stroke="#000"
    stroke-opacity=".1"
    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"
  />
</svg>`;

});

parcelRegister("cyMzh", function(module, exports) {

$parcel$export(module.exports, "warningCircleSvg", () => $924e5597d1885be6$export$6e55d6021a3f4197);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $924e5597d1885be6$export$6e55d6021a3f4197 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hm7hZ", function(module, exports) {

$parcel$export(module.exports, "alphaSvg", () => $ca2a2532b8860c25$export$edfb17bf4e624987);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $ca2a2532b8860c25$export$edfb17bf4e624987 = (0, $8AeG9.svg)`<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.687 0.557043C11.1462 0.671832 11.4254 1.13706 11.3106 1.59615C11.2044 2.02082 11.0975 2.51184 10.9822 3.04102C10.7176 4.25623 10.4091 5.6727 9.96482 6.94907C10.1435 7.58939 10.3065 8.16905 10.4935 8.68429C10.6447 9.10072 10.7858 9.39487 10.9179 9.58289C11.0055 9.70747 11.0597 9.74443 11.0748 9.75277C11.096 9.75724 11.1075 9.75764 11.1531 9.71916C11.2342 9.65067 11.3386 9.50891 11.4426 9.28357C11.5416 9.06892 11.614 8.8366 11.662 8.6497C11.6854 8.55831 11.7019 8.48242 11.7122 8.43111C11.7174 8.40555 11.7209 8.38638 11.723 8.37476L11.725 8.36363C11.8 7.89659 12.2395 7.57864 12.7068 7.65342C13.1742 7.72822 13.4925 8.16766 13.4177 8.63494C13.4153 8.64924 13.42 8.62063 13.4177 8.63494L13.4175 8.63596L13.4173 8.63721L13.4168 8.64037L13.4153 8.64924L13.4105 8.67692C13.4064 8.69961 13.4006 8.73069 13.3929 8.76891C13.3776 8.84516 13.3545 8.95091 13.3224 9.07586C13.2593 9.32166 13.1564 9.66085 12.9992 10.0015C12.8469 10.3315 12.6139 10.7288 12.2595 11.0282C11.8757 11.3523 11.35 11.5553 10.7293 11.4312C10.1645 11.3183 9.77597 10.939 9.51527 10.5681C9.2535 10.1957 9.05129 9.7349 8.88212 9.26898C8.87877 9.25975 8.87542 9.25049 8.87208 9.2412C8.03954 10.4941 6.83375 11.4479 5.03926 11.4479C3.48049 11.4479 2.31021 10.7159 1.56788 9.63945C0.846767 8.5938 0.544023 7.25403 0.573206 5.9702C0.60242 4.68505 0.966023 3.36073 1.69055 2.33272C2.42915 1.28475 3.5614 0.531453 5.03927 0.531453C6.44937 0.531453 7.4408 1.29593 8.1276 2.27567C8.48261 2.7821 8.77248 3.36668 9.0177 3.97383C9.1059 3.59106 9.18901 3.20908 9.27086 2.83294C9.39492 2.26277 9.51606 1.70605 9.64752 1.18046C9.76235 0.721369 10.2277 0.442254 10.687 0.557043ZM8.16354 6.87693C8.08689 6.60534 8.01003 6.33741 7.93241 6.08076C7.59522 4.96581 7.22132 3.969 6.72371 3.25914C6.24674 2.57873 5.72135 2.24516 5.03927 2.24516C4.21565 2.24516 3.56947 2.6422 3.09195 3.31975C2.60035 4.01725 2.31013 4.99361 2.28705 6.00913C2.26393 7.02599 2.51041 7.9869 2.97927 8.66676C3.42691 9.31586 4.08734 9.73417 5.03926 9.73417C6.48097 9.73417 7.4216 8.72164 8.14437 6.9249C8.15079 6.90893 8.15718 6.89294 8.16354 6.87693Z" fill="#47A1FF"/>
</svg>`;

});


parcelRegister("6GKXg", function(module, exports) {

$parcel$export(module.exports, "WuiImage", () => $4deb1692550c2f83$export$6985d0bcc76e605c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $6EO9p = parcelRequire("6EO9p");
var $4deb1692550c2f83$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4deb1692550c2f83$export$6985d0bcc76e605c = class WuiImage extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.src = "./path/to/image.jpg";
        this.alt = "Image";
    }
    render() {
        return (0, $8AeG9.html)`<img src=${this.src} alt=${this.alt} />`;
    }
};
$4deb1692550c2f83$export$6985d0bcc76e605c.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.colorStyles),
    (0, $6EO9p.default)
];
$4deb1692550c2f83$var$__decorate([
    (0, $kRRY9.property)()
], $4deb1692550c2f83$export$6985d0bcc76e605c.prototype, "src", void 0);
$4deb1692550c2f83$var$__decorate([
    (0, $kRRY9.property)()
], $4deb1692550c2f83$export$6985d0bcc76e605c.prototype, "alt", void 0);
$4deb1692550c2f83$export$6985d0bcc76e605c = $4deb1692550c2f83$var$__decorate([
    (0, $33Xir.customElement)("wui-image")
], $4deb1692550c2f83$export$6985d0bcc76e605c);

});
parcelRegister("6EO9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8d6164c31a9f46$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $4d8d6164c31a9f46$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    border-radius: inherit;
  }
`;

});


parcelRegister("lUN2G", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingHexagon", () => $ff44deba7961e39b$export$8429fc8b8d557b81);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $7mjRN = parcelRequire("7mjRN");
var $ff44deba7961e39b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ff44deba7961e39b$export$8429fc8b8d557b81 = class WuiLoadingHexagon extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <svg viewBox="0 0 54 59">
        <path
          id="wui-loader-path"
          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"
        />
        <use xlink:href="#wui-loader-path"></use>
      </svg>
    `;
    }
};
$ff44deba7961e39b$export$8429fc8b8d557b81.styles = [
    (0, $hCS0p.resetStyles),
    (0, $7mjRN.default)
];
$ff44deba7961e39b$export$8429fc8b8d557b81 = $ff44deba7961e39b$var$__decorate([
    (0, $33Xir.customElement)("wui-loading-hexagon")
], $ff44deba7961e39b$export$8429fc8b8d557b81);

});
parcelRegister("7mjRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b9ff95286fc2bd$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $55b9ff95286fc2bd$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
  }

  svg {
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
    fill: none;
    stroke: transparent;
    stroke-linecap: round;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  use {
    stroke: var(--wui-color-accent-100);
    stroke-width: 2px;
    stroke-dasharray: 54, 118;
    stroke-dashoffset: 172;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("cJIBV", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingSpinner", () => $945c4ac34f200e04$export$3a84ab9b4ee14f8a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $gtoyL = parcelRequire("gtoyL");
var $945c4ac34f200e04$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $945c4ac34f200e04$export$3a84ab9b4ee14f8a = class WuiLoadingSpinner extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.color = "accent-100";
        this.size = "lg";
    }
    render() {
        this.style.cssText = `--local-color: var(--wui-color-${this.color});`;
        this.dataset["size"] = this.size;
        return (0, $8AeG9.html)`<svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50"></circle>
    </svg>`;
    }
};
$945c4ac34f200e04$export$3a84ab9b4ee14f8a.styles = [
    (0, $hCS0p.resetStyles),
    (0, $gtoyL.default)
];
$945c4ac34f200e04$var$__decorate([
    (0, $kRRY9.property)()
], $945c4ac34f200e04$export$3a84ab9b4ee14f8a.prototype, "color", void 0);
$945c4ac34f200e04$var$__decorate([
    (0, $kRRY9.property)()
], $945c4ac34f200e04$export$3a84ab9b4ee14f8a.prototype, "size", void 0);
$945c4ac34f200e04$export$3a84ab9b4ee14f8a = $945c4ac34f200e04$var$__decorate([
    (0, $33Xir.customElement)("wui-loading-spinner")
], $945c4ac34f200e04$export$3a84ab9b4ee14f8a);

});
parcelRegister("gtoyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe267d2fe660c79$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $bfe267d2fe660c79$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
  }

  :host([data-size='sm']) > svg {
    width: 12px;
    height: 12px;
  }

  :host([data-size='md']) > svg {
    width: 16px;
    height: 16px;
  }

  :host([data-size='lg']) > svg {
    width: 24px;
    height: 24px;
  }

  :host([data-size='xl']) > svg {
    width: 32px;
    height: 32px;
  }

  svg {
    animation: rotate 2s linear infinite;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  circle {
    fill: none;
    stroke: var(--local-color);
    stroke-width: 4px;
    stroke-dasharray: 1, 124;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  :host([data-size='md']) > svg > circle {
    stroke-width: 6px;
  }

  :host([data-size='sm']) > svg > circle {
    stroke-width: 8px;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 124;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 124;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dashoffset: -125;
    }
  }
`;

});


parcelRegister("gpqzP", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingThumbnail", () => $bf2398bb702424e0$export$a8f5e0b29edd5ad2);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $3bfpg = parcelRequire("3bfpg");
var $bf2398bb702424e0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bf2398bb702424e0$export$a8f5e0b29edd5ad2 = class WuiLoadingThumbnail extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.radius = 36;
    }
    render() {
        return this.svgLoaderTemplate();
    }
    svgLoaderTemplate() {
        const radius = this.radius > 50 ? 50 : this.radius;
        const standardValue = 36;
        const radiusFactor = standardValue - radius;
        const dashArrayStart = 116 + radiusFactor;
        const dashArrayEnd = 245 + radiusFactor;
        const dashOffset = 360 + radiusFactor * 1.75;
        return (0, $8AeG9.html)`
      <svg viewBox="0 0 110 110" width="110" height="110">
        <rect
          x="2"
          y="2"
          width="106"
          height="106"
          rx=${radius}
          stroke-dasharray="${dashArrayStart} ${dashArrayEnd}"
          stroke-dashoffset=${dashOffset}
        />
      </svg>
    `;
    }
};
$bf2398bb702424e0$export$a8f5e0b29edd5ad2.styles = [
    (0, $hCS0p.resetStyles),
    (0, $3bfpg.default)
];
$bf2398bb702424e0$var$__decorate([
    (0, $kRRY9.property)({
        type: Number
    })
], $bf2398bb702424e0$export$a8f5e0b29edd5ad2.prototype, "radius", void 0);
$bf2398bb702424e0$export$a8f5e0b29edd5ad2 = $bf2398bb702424e0$var$__decorate([
    (0, $33Xir.customElement)("wui-loading-thumbnail")
], $bf2398bb702424e0$export$a8f5e0b29edd5ad2);

});
parcelRegister("3bfpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $250e5998c04511fe$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $250e5998c04511fe$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  svg {
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  rect {
    fill: none;
    stroke: var(--wui-color-accent-100);
    stroke-width: 4px;
    stroke-linecap: round;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("cbfCt", function(module, exports) {

$parcel$export(module.exports, "WuiShimmer", () => $8de2a0d6c3beebd7$export$22033065aa649938);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $33Xir = parcelRequire("33Xir");

var $ichq9 = parcelRequire("ichq9");
var $8de2a0d6c3beebd7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8de2a0d6c3beebd7$export$22033065aa649938 = class WuiShimmer extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.width = "";
        this.height = "";
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
      width: ${this.width};
      height: ${this.height};
      border-radius: ${`clamp(0px,var(--wui-border-radius-${this.borderRadius}), 40px)`};
    `;
        return (0, $8AeG9.html)`<slot></slot>`;
    }
};
$8de2a0d6c3beebd7$export$22033065aa649938.styles = [
    (0, $ichq9.default)
];
$8de2a0d6c3beebd7$var$__decorate([
    (0, $kRRY9.property)()
], $8de2a0d6c3beebd7$export$22033065aa649938.prototype, "width", void 0);
$8de2a0d6c3beebd7$var$__decorate([
    (0, $kRRY9.property)()
], $8de2a0d6c3beebd7$export$22033065aa649938.prototype, "height", void 0);
$8de2a0d6c3beebd7$var$__decorate([
    (0, $kRRY9.property)()
], $8de2a0d6c3beebd7$export$22033065aa649938.prototype, "borderRadius", void 0);
$8de2a0d6c3beebd7$export$22033065aa649938 = $8de2a0d6c3beebd7$var$__decorate([
    (0, $33Xir.customElement)("wui-shimmer")
], $8de2a0d6c3beebd7$export$22033065aa649938);

});
parcelRegister("ichq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3f6dc5e1d938317$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $d3f6dc5e1d938317$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-200) 5%,
      var(--wui-color-bg-200) 48%,
      var(--wui-color-bg-300) 55%,
      var(--wui-color-bg-300) 60%,
      var(--wui-color-bg-300) calc(60% + 10px),
      var(--wui-color-bg-200) calc(60% + 12px),
      var(--wui-color-bg-200) 100%
    );
    background-size: 250%;
    animation: shimmer 3s linear infinite reverse;
  }

  @keyframes shimmer {
    from {
      background-position: -250% 0;
    }
    to {
      background-position: 250% 0;
    }
  }
`;

});


parcelRegister("64e2j", function(module, exports) {

$parcel$export(module.exports, "WuiText", () => $46ae011e1a7c6751$export$406e1aa02d8022e4);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("3lsiw");
var $hhV5l = parcelRequire("hhV5l");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $9Cerm = parcelRequire("9Cerm");
var $46ae011e1a7c6751$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $46ae011e1a7c6751$export$406e1aa02d8022e4 = class WuiText extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "paragraph-500";
        this.color = "fg-300";
        this.align = "left";
    }
    render() {
        const classes = {
            [`wui-font-${this.variant}`]: true,
            [`wui-color-${this.color}`]: true
        };
        this.style.cssText = `
      --local-align: ${this.align};
      --local-color: var(--wui-color-${this.color});
    `;
        return (0, $8AeG9.html)`<slot class=${(0, $hhV5l.classMap)(classes)}></slot>`;
    }
};
$46ae011e1a7c6751$export$406e1aa02d8022e4.styles = [
    (0, $hCS0p.resetStyles),
    (0, $9Cerm.default)
];
$46ae011e1a7c6751$var$__decorate([
    (0, $kRRY9.property)()
], $46ae011e1a7c6751$export$406e1aa02d8022e4.prototype, "variant", void 0);
$46ae011e1a7c6751$var$__decorate([
    (0, $kRRY9.property)()
], $46ae011e1a7c6751$export$406e1aa02d8022e4.prototype, "color", void 0);
$46ae011e1a7c6751$var$__decorate([
    (0, $kRRY9.property)()
], $46ae011e1a7c6751$export$406e1aa02d8022e4.prototype, "align", void 0);
$46ae011e1a7c6751$export$406e1aa02d8022e4 = $46ae011e1a7c6751$var$__decorate([
    (0, $33Xir.customElement)("wui-text")
], $46ae011e1a7c6751$export$406e1aa02d8022e4);

});
parcelRegister("3lsiw", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("hhV5l")).classMap);
parcelRequire("hhV5l");

});
parcelRegister("hhV5l", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $c9604e1f99583a7c$export$56cc687933817664);

var $8AeG9 = parcelRequire("8AeG9");

var $dL6tn = parcelRequire("dL6tn");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c9604e1f99583a7c$export$56cc687933817664 = (0, $dL6tn.directive)(class extends (0, $dL6tn.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $dL6tn.PartType).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $8AeG9.noChange;
    }
});

});
parcelRegister("dL6tn", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $a044af8458b2f60a$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $a044af8458b2f60a$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $a044af8458b2f60a$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a044af8458b2f60a$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $a044af8458b2f60a$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $a044af8458b2f60a$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("9Cerm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7002dd327457d909$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $7002dd327457d909$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex !important;
  }

  slot {
    display: inline-block;
    font-style: normal;
    font-family: var(--wui-font-family);
    font-feature-settings:
      'tnum' on,
      'lnum' on,
      'case' on;
    line-height: 130%;
    font-weight: var(--wui-font-weight-regular);
    overflow: inherit;
    text-overflow: inherit;
    text-align: var(--local-align);
    color: var(--local-color);
  }

  .wui-font-large-500,
  .wui-font-large-600,
  .wui-font-large-700 {
    font-size: var(--wui-font-size-large);
    letter-spacing: var(--wui-letter-spacing-large);
  }

  .wui-font-paragraph-500,
  .wui-font-paragraph-600,
  .wui-font-paragraph-700 {
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
  }

  .wui-font-small-400,
  .wui-font-small-500,
  .wui-font-small-600 {
    font-size: var(--wui-font-size-small);
    letter-spacing: var(--wui-letter-spacing-small);
  }

  .wui-font-tiny-500,
  .wui-font-tiny-600 {
    font-size: var(--wui-font-size-tiny);
    letter-spacing: var(--wui-letter-spacing-tiny);
  }

  .wui-font-micro-700,
  .wui-font-micro-600 {
    font-size: var(--wui-font-size-micro);
    letter-spacing: var(--wui-letter-spacing-micro);
    text-transform: uppercase;
  }

  .wui-font-small-400,
  .wui-font-paragraph-400 {
    font-weight: var(--wui-font-weight-light);
  }

  .wui-font-large-700,
  .wui-font-paragraph-700,
  .wui-font-micro-700 {
    font-weight: var(--wui-font-weight-bold);
  }

  .wui-font-large-600,
  .wui-font-paragraph-600,
  .wui-font-small-600,
  .wui-font-tiny-600,
  .wui-font-micro-600 {
    font-weight: var(--wui-font-weight-medium);
  }
`;

});


parcelRegister("hlUtV", function(module, exports) {

$parcel$export(module.exports, "WuiVisual", () => $ca2035e5a1628536$export$e6365a334c1a5845);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $jGeEU = parcelRequire("jGeEU");

var $egBTV = parcelRequire("egBTV");

var $H5xwQ = parcelRequire("H5xwQ");

var $jcRxX = parcelRequire("jcRxX");

var $2ZUgK = parcelRequire("2ZUgK");

var $3ryUf = parcelRequire("3ryUf");

var $9lh8c = parcelRequire("9lh8c");

var $dZoWS = parcelRequire("dZoWS");

var $9aayr = parcelRequire("9aayr");

var $4Z4P6 = parcelRequire("4Z4P6");

var $g20y9 = parcelRequire("g20y9");

var $llPe7 = parcelRequire("llPe7");

var $ksWYz = parcelRequire("ksWYz");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $9qI08 = parcelRequire("9qI08");
var $ca2035e5a1628536$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $ca2035e5a1628536$var$svgOptions = {
    browser: (0, $jGeEU.browserSvg),
    dao: (0, $egBTV.daoSvg),
    defi: (0, $H5xwQ.defiSvg),
    defiAlt: (0, $jcRxX.defiAltSvg),
    eth: (0, $2ZUgK.ethSvg),
    layers: (0, $3ryUf.layersSvg),
    lock: (0, $9lh8c.lockSvg),
    login: (0, $dZoWS.loginSvg),
    network: (0, $9aayr.networkSvg),
    nft: (0, $4Z4P6.nftSvg),
    noun: (0, $g20y9.nounSvg),
    profile: (0, $llPe7.profileSvg),
    system: (0, $ksWYz.systemSvg)
};
let $ca2035e5a1628536$export$e6365a334c1a5845 = class WuiVisual extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "browser";
    }
    render() {
        return (0, $8AeG9.html)`${$ca2035e5a1628536$var$svgOptions[this.name]}`;
    }
};
$ca2035e5a1628536$export$e6365a334c1a5845.styles = [
    (0, $hCS0p.resetStyles),
    (0, $9qI08.default)
];
$ca2035e5a1628536$var$__decorate([
    (0, $kRRY9.property)()
], $ca2035e5a1628536$export$e6365a334c1a5845.prototype, "name", void 0);
$ca2035e5a1628536$export$e6365a334c1a5845 = $ca2035e5a1628536$var$__decorate([
    (0, $33Xir.customElement)("wui-visual")
], $ca2035e5a1628536$export$e6365a334c1a5845);

});
parcelRegister("jGeEU", function(module, exports) {

$parcel$export(module.exports, "browserSvg", () => $e53d4f7f53229843$export$9a659d11e13bcec5);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $e53d4f7f53229843$export$9a659d11e13bcec5 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="30" />
  <circle cx="30" cy="30" r="3" fill="#fff" />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"
  />
  <path
    fill="#1DC956"
    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"
  />
  <path
    fill="#86F999"
    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"
  />
  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
</svg> `;

});

parcelRegister("egBTV", function(module, exports) {

$parcel$export(module.exports, "daoSvg", () => $a62ff5aa5d6ddf70$export$4c380a6200fee43);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $a62ff5aa5d6ddf70$export$4c380a6200fee43 = (0, $8AeG9.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#clip0_7734_50402)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#EB8B47"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"
      fill="#FF974C"
    />
    <path
      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_7734_50402">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("H5xwQ", function(module, exports) {

$parcel$export(module.exports, "defiSvg", () => $0818505a518c3be6$export$400ef2a1f7fc3217);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $0818505a518c3be6$export$400ef2a1f7fc3217 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#1DC956"
      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"
    />
    <path
      fill="#2BEE6C"
      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"
    />
    <path
      fill="#fff"
      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />
    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
    <path
      stroke="#fff"
      stroke-opacity=".1"
      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("jcRxX", function(module, exports) {

$parcel$export(module.exports, "defiAltSvg", () => $dfb8ac8cdf730d87$export$f1568dd015c8f3b9);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $dfb8ac8cdf730d87$export$f1568dd015c8f3b9 = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="30" />
    <path
      fill="#E87DE8"
      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"
    />
    <path
      fill="#fff"
      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M31 0v60h-2V0h2Z" />
    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("2ZUgK", function(module, exports) {

$parcel$export(module.exports, "ethSvg", () => $22eced2ce422fe12$export$9c7a8a6662d6e69b);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $22eced2ce422fe12$export$9c7a8a6662d6e69b = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#987DE8" rx="30" />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"
      clip-rule="evenodd"
    />
    <path
      fill="#643CDD"
      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"
    />
    <path
      fill="#BDADEB"
      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"
    />
    <path
      fill="#643CDD"
      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"
    />
    <path
      fill="#BDADEB"
      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"
    />
    <path
      fill="#401AB3"
      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"
    />
    <path
      fill="#7C5AE2"
      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("3ryUf", function(module, exports) {

$parcel$export(module.exports, "layersSvg", () => $281ef85c1ae9ab72$export$92af4cd19d37b5ea);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $281ef85c1ae9ab72$export$92af4cd19d37b5ea = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="3" />
  <path
    fill="#1FAD7E"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#86F999"
    stroke="#fff"
    stroke-width="2"
    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("9lh8c", function(module, exports) {

$parcel$export(module.exports, "lockSvg", () => $6cd35d27e6c82deb$export$70be6a782cc364be);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $6cd35d27e6c82deb$export$70be6a782cc364be = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#C653C6" rx="3" />
  <path
    fill="#fff"
    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"
  />
  <path
    fill="#E87DE8"
    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"
  />
  <path
    fill="#E87DE8"
    fill-rule="evenodd"
    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"
    clip-rule="evenodd"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("dZoWS", function(module, exports) {

$parcel$export(module.exports, "loginSvg", () => $a2f4532805e795b0$export$c9aa74efff8430c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $a2f4532805e795b0$export$c9aa74efff8430c = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#EB8B47"
      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"
    />
    <path
      stroke="#062B2B"
      stroke-opacity=".1"
      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"
    />
    <path
      fill="#FF974C"
      stroke="#fff"
      stroke-width="2"
      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"
    />
    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("9aayr", function(module, exports) {

$parcel$export(module.exports, "networkSvg", () => $6abd3c241b0d6087$export$1a3efa751581ed0a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $6abd3c241b0d6087$export$1a3efa751581ed0a = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#00ACE6" rx="30" />
    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />
    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />
    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("4Z4P6", function(module, exports) {

$parcel$export(module.exports, "nftSvg", () => $3a1099b64c0e86c6$export$1c5022265b1a9f1f);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $3a1099b64c0e86c6$export$1c5022265b1a9f1f = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="3" />
    <path
      fill="#E87DE8"
      stroke="#fff"
      stroke-width="2"
      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"
      clip-rule="evenodd"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("g20y9", function(module, exports) {

$parcel$export(module.exports, "nounSvg", () => $babd427046f163a3$export$3bfdd1a0cad16fad);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $babd427046f163a3$export$3bfdd1a0cad16fad = (0, $8AeG9.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#794CFF" rx="3" />
  <path
    fill="#987DE8"
    stroke="#fff"
    stroke-width="2"
    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"
  />
  <path fill="#fff" d="M37.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />
  <path fill="#fff" d="M19.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />
  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("llPe7", function(module, exports) {

$parcel$export(module.exports, "profileSvg", () => $f8b34bb5d3e39724$export$f1a0ec1d6376e59);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $f8b34bb5d3e39724$export$f1a0ec1d6376e59 = (0, $8AeG9.svg)`<svg
  viewBox="0 0 60 60"
  fill="none"
>
  <g clip-path="url(#1)">
    <rect width="60" height="60" rx="30" fill="#00ACE6" />
    <path
      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />
    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />
    <path
      d="M31 20L28 28H32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" rx="30" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("ksWYz", function(module, exports) {

$parcel$export(module.exports, "systemSvg", () => $ee642b958b7f5f56$export$5752b741a746ef10);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $ee642b958b7f5f56$export$5752b741a746ef10 = (0, $8AeG9.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#1)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#794CFF"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />
    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("9qI08", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd8ac80f809af02$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $6dd8ac80f809af02$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: 55px;
    height: 55px;
  }
`;

});


parcelRegister("eYY4L", function(module, exports) {

$parcel$export(module.exports, "WuiAccountButton", () => $ae854512b3ceb20e$export$bfec9622ebde4e9e);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("6GKXg");
parcelRequire("64e2j");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");
parcelRequire("4GsCo");
parcelRequire("8lemW");

var $eIKBA = parcelRequire("eIKBA");
var $ae854512b3ceb20e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ae854512b3ceb20e$export$bfec9622ebde4e9e = class WuiAccountButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.networkSrc = undefined;
        this.avatarSrc = undefined;
        this.balance = undefined;
        this.disabled = false;
        this.isProfileName = false;
        this.address = "";
        this.charsStart = 4;
        this.charsEnd = 6;
    }
    render() {
        return (0, $8AeG9.html)`
      <button
        ?disabled=${this.disabled}
        class=${(0, $ljfXw.ifDefined)(this.balance ? undefined : "local-no-balance")}
      >
        ${this.balanceTemplate()}
        <wui-flex gap="xxs" alignItems="center">
          <wui-avatar
            .imageSrc=${this.avatarSrc}
            alt=${this.address}
            address=${this.address}
          ></wui-avatar>
          <wui-text variant="paragraph-600" color="inherit">
            ${(0, $8iLLL.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: this.isProfileName ? 18 : this.charsStart,
            charsEnd: this.isProfileName ? 0 : this.charsEnd,
            truncate: this.isProfileName ? "end" : "middle"
        })}
          </wui-text>
        </wui-flex>
      </button>
    `;
    }
    balanceTemplate() {
        if (this.balance) {
            const networkElement = this.networkSrc ? (0, $8AeG9.html)`<wui-image src=${this.networkSrc}></wui-image>` : (0, $8AeG9.html)`
            <wui-icon-box
              size="sm"
              iconColor="fg-200"
              backgroundColor="fg-300"
              icon="networkPlaceholder"
            ></wui-icon-box>
          `;
            return (0, $8AeG9.html)`
        ${networkElement}
        <wui-text variant="paragraph-600" color="inherit"> ${this.balance} </wui-text>
      `;
        }
        return null;
    }
};
$ae854512b3ceb20e$export$bfec9622ebde4e9e.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $eIKBA.default)
];
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "networkSrc", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "avatarSrc", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "balance", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "disabled", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "isProfileName", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "address", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "charsStart", void 0);
$ae854512b3ceb20e$var$__decorate([
    (0, $kRRY9.property)()
], $ae854512b3ceb20e$export$bfec9622ebde4e9e.prototype, "charsEnd", void 0);
$ae854512b3ceb20e$export$bfec9622ebde4e9e = $ae854512b3ceb20e$var$__decorate([
    (0, $33Xir.customElement)("wui-account-button")
], $ae854512b3ceb20e$export$bfec9622ebde4e9e);

});
parcelRegister("96Axb", function(module, exports) {
$parcel$export(module.exports, "ifDefined", () => (parcelRequire("ljfXw")).ifDefined);
parcelRequire("ljfXw");

});
parcelRegister("ljfXw", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $f837c0719e0ddf05$export$f68dd208b5df064d);

var $8AeG9 = parcelRequire("8AeG9");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f837c0719e0ddf05$export$f68dd208b5df064d = (o)=>o ?? (0, $8AeG9.nothing);

});


parcelRegister("d6bsG", function(module, exports) {

$parcel$export(module.exports, "WuiFlex", () => $9894b9eb4b0b9004$export$cb455767ea18ce95);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");

var $fH4PD = parcelRequire("fH4PD");
var $9894b9eb4b0b9004$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9894b9eb4b0b9004$export$cb455767ea18ce95 = class WuiFlex extends (0, $gy3vm.LitElement) {
    render() {
        this.style.cssText = `
      flex-direction: ${this.flexDirection};
      flex-wrap: ${this.flexWrap};
      flex-basis: ${this.flexBasis};
      flex-grow: ${this.flexGrow};
      flex-shrink: ${this.flexShrink};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $8AeG9.html)`<slot></slot>`;
    }
};
$9894b9eb4b0b9004$export$cb455767ea18ce95.styles = [
    (0, $hCS0p.resetStyles),
    (0, $fH4PD.default)
];
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "flexDirection", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "flexWrap", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "flexBasis", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "flexGrow", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "flexShrink", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "alignItems", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "justifyContent", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "columnGap", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "rowGap", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "gap", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "padding", void 0);
$9894b9eb4b0b9004$var$__decorate([
    (0, $kRRY9.property)()
], $9894b9eb4b0b9004$export$cb455767ea18ce95.prototype, "margin", void 0);
$9894b9eb4b0b9004$export$cb455767ea18ce95 = $9894b9eb4b0b9004$var$__decorate([
    (0, $33Xir.customElement)("wui-flex")
], $9894b9eb4b0b9004$export$cb455767ea18ce95);

});
parcelRegister("8iLLL", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", () => $60b50f2f2c9d6c19$export$be769b74c01bc1bc);
const $60b50f2f2c9d6c19$export$be769b74c01bc1bc = {
    getSpacingStyles (spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? `var(--wui-spacing-${spacing[index]})` : undefined;
        else if (typeof spacing === "string") return `var(--wui-spacing-${spacing})`;
        return undefined;
    },
    getFormattedDate (date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName (url) {
        const newUrl = new URL(url);
        return newUrl.hostname;
    },
    getTruncateString ({ string: string, charsStart: charsStart, charsEnd: charsEnd, truncate: truncate }) {
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return `${string.substring(0, charsStart)}...`;
        else if (truncate === "start") return `...${string.substring(string.length - charsEnd)}`;
        return `${string.substring(0, Math.floor(charsStart))}...${string.substring(string.length - Math.floor(charsEnd))}`;
    },
    generateAvatarColors (address) {
        const hash = address.toLowerCase().replace(/^0x/iu, "");
        const baseColor = hash.substring(0, 6);
        const rgbColor = this.hexToRgb(baseColor);
        const masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        const radius = Number(masterBorderRadius?.replace("px", ""));
        const edge = 100 - 3 * radius;
        const gradientCircle = `${edge}% ${edge}% at 65% 40%`;
        const colors = [];
        for(let i = 0; i < 5; i += 1){
            const tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push(`rgb(${tintedColor[0]}, ${tintedColor[1]}, ${tintedColor[2]})`);
        }
        return `
    --local-color-1: ${colors[0]};
    --local-color-2: ${colors[1]};
    --local-color-3: ${colors[2]};
    --local-color-4: ${colors[3]};
    --local-color-5: ${colors[4]};
    --local-radial-circle: ${gradientCircle}
   `;
    },
    hexToRgb (hex) {
        const bigint = parseInt(hex, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor (rgb, tint) {
        const [r, g, b] = rgb;
        const tintedR = Math.round(r + (255 - r) * tint);
        const tintedG = Math.round(g + (255 - g) * tint);
        const tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber (character) {
        const regex = {
            number: /^[0-9]+$/u
        };
        return regex.number.test(character);
    },
    getColorTheme (theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
            return "light";
        }
        return "dark";
    }
};

});

parcelRegister("fH4PD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ce9eab2801b9f5$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $b6ce9eab2801b9f5$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("4GsCo", function(module, exports) {

$parcel$export(module.exports, "WuiAvatar", () => $369148aa0098f630$export$21cc36693be5eb11);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("6GKXg");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");

var $6TTuK = parcelRequire("6TTuK");
var $369148aa0098f630$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $369148aa0098f630$export$21cc36693be5eb11 = class WuiAvatar extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.alt = undefined;
        this.address = undefined;
    }
    render() {
        return (0, $8AeG9.html)`${this.visualTemplate()}`;
    }
    visualTemplate() {
        if (this.imageSrc) {
            this.dataset["variant"] = "image";
            return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "avatar"}></wui-image>`;
        } else if (this.address) {
            this.dataset["variant"] = "generated";
            const cssColors = (0, $8iLLL.UiHelperUtil).generateAvatarColors(this.address);
            this.style.cssText = cssColors;
            return null;
        }
        this.dataset["variant"] = "default";
        return null;
    }
};
$369148aa0098f630$export$21cc36693be5eb11.styles = [
    (0, $hCS0p.resetStyles),
    (0, $6TTuK.default)
];
$369148aa0098f630$var$__decorate([
    (0, $kRRY9.property)()
], $369148aa0098f630$export$21cc36693be5eb11.prototype, "imageSrc", void 0);
$369148aa0098f630$var$__decorate([
    (0, $kRRY9.property)()
], $369148aa0098f630$export$21cc36693be5eb11.prototype, "alt", void 0);
$369148aa0098f630$var$__decorate([
    (0, $kRRY9.property)()
], $369148aa0098f630$export$21cc36693be5eb11.prototype, "address", void 0);
$369148aa0098f630$export$21cc36693be5eb11 = $369148aa0098f630$var$__decorate([
    (0, $33Xir.customElement)("wui-avatar")
], $369148aa0098f630$export$21cc36693be5eb11);

});
parcelRegister("6TTuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5062ed42b51a8bcf$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $5062ed42b51a8bcf$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    overflow: hidden;
    position: relative;
  }

  :host([data-variant='generated']) {
    --mixed-local-color-1: var(--local-color-1);
    --mixed-local-color-2: var(--local-color-2);
    --mixed-local-color-3: var(--local-color-3);
    --mixed-local-color-4: var(--local-color-4);
    --mixed-local-color-5: var(--local-color-5);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host([data-variant='generated']) {
      --mixed-local-color-1: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-1)
      );
      --mixed-local-color-2: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-2)
      );
      --mixed-local-color-3: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-3)
      );
      --mixed-local-color-4: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-4)
      );
      --mixed-local-color-5: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-5)
      );
    }
  }

  :host([data-variant='generated']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      var(--local-radial-circle),
      #fff 0.52%,
      var(--mixed-local-color-5) 31.25%,
      var(--mixed-local-color-3) 51.56%,
      var(--mixed-local-color-2) 65.63%,
      var(--mixed-local-color-1) 82.29%,
      var(--mixed-local-color-4) 100%
    );
  }

  :host([data-variant='default']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      #f5ccfc 31.25%,
      #dba4f5 51.56%,
      #9a8ee8 65.63%,
      #6493da 82.29%,
      #6ebdea 100%
    );
  }
`;

});


parcelRegister("8lemW", function(module, exports) {

$parcel$export(module.exports, "WuiIconBox", () => $612b6e4b44ac149c$export$df20651935c1141);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $kyJrk = parcelRequire("kyJrk");
var $612b6e4b44ac149c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $612b6e4b44ac149c$export$df20651935c1141 = class WuiIconBox extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.background = "transparent";
        this.border = false;
        this.borderColor = "wui-color-bg-125";
        this.icon = "copy";
    }
    render() {
        const iconSize = this.iconSize || this.size;
        const isLg = this.size === "lg";
        const isXl = this.size === "xl";
        const bgMix = isLg ? "12%" : "16%";
        const borderRadius = isLg ? "xxs" : isXl ? "s" : "3xl";
        const isGray = this.background === "gray";
        const isOpaque = this.background === "opaque";
        const isColorChange = this.backgroundColor === "accent-100" && isOpaque || this.backgroundColor === "success-100" && isOpaque || this.backgroundColor === "error-100" && isOpaque || this.backgroundColor === "inverse-100" && isOpaque;
        let bgValueVariable = `var(--wui-color-${this.backgroundColor})`;
        if (isColorChange) bgValueVariable = `var(--wui-icon-box-bg-${this.backgroundColor})`;
        else if (isGray) bgValueVariable = `var(--wui-gray-${this.backgroundColor})`;
        this.style.cssText = `
       --local-bg-value: ${bgValueVariable};
       --local-bg-mix: ${isColorChange || isGray ? `100%` : bgMix};
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-icon-box-size-${this.size});
       --local-border: ${this.borderColor === "wui-color-bg-125" ? `2px` : `1px`} solid ${this.border ? `var(--${this.borderColor})` : `transparent`}
   `;
        return (0, $8AeG9.html)` <wui-icon color=${this.iconColor} size=${iconSize} name=${this.icon}></wui-icon> `;
    }
};
$612b6e4b44ac149c$export$df20651935c1141.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $kyJrk.default)
];
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "size", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "backgroundColor", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "iconColor", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "iconSize", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "background", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "border", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "borderColor", void 0);
$612b6e4b44ac149c$var$__decorate([
    (0, $kRRY9.property)()
], $612b6e4b44ac149c$export$df20651935c1141.prototype, "icon", void 0);
$612b6e4b44ac149c$export$df20651935c1141 = $612b6e4b44ac149c$var$__decorate([
    (0, $33Xir.customElement)("wui-icon-box")
], $612b6e4b44ac149c$export$df20651935c1141);

});
parcelRegister("kyJrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef7a3b07cc5c6edd$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ef7a3b07cc5c6edd$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: var(--wui-gray-glass-020);
    border-radius: var(--local-border-radius);
    box-shadow: 0 0 0 1px var(--local-border);
    width: var(--local-size);
    height: var(--local-size);
    min-height: var(--local-size);
    min-width: var(--local-size);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host {
      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);
    }
  }
`;

});


parcelRegister("eIKBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab795394331010e1$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ab795394331010e1$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    background: var(--wui-gray-glass-002);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-005);
  }

  button:disabled {
    background: var(--wui-gray-glass-015);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-flex > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-flex > wui-avatar {
    filter: grayscale(1);
  }

  button:has(wui-image) {
    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
  }

  wui-text {
    color: var(--wui-color-fg-100);
  }

  wui-flex > wui-text {
    color: var(--wui-color-fg-200);
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-flex {
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);
  }

  button.local-no-balance {
    border-radius: 0px;
    border: none;
    background: transparent;
  }

  wui-avatar {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 2px var(--wui-accent-glass-010);
  }

  @media (max-width: 500px) {
    button {
      gap: 0px;
      padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) !important;
      height: 32px;
    }
    wui-image,
    wui-icon-box,
    button > wui-text {
      visibility: hidden;
      width: 0px;
      height: 0px;
    }
    button {
      border-radius: 0px;
      border: none;
      background: transparent;
      padding: 0px;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }

    button:active:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }
  }
`;

});


parcelRegister("ixPM7", function(module, exports) {

$parcel$export(module.exports, "WuiAllWalletsImage", () => $d8037889eb87b205$export$92558ad1dd06e644);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("dTlfF");
parcelRequire("8lemW");

var $bYbuP = parcelRequire("bYbuP");
var $d8037889eb87b205$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d8037889eb87b205$var$TOTAL_IMAGES = 4;
let $d8037889eb87b205$export$92558ad1dd06e644 = class WuiAllWalletsImage extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
    }
    render() {
        const isPlaceholders = this.walletImages.length < $d8037889eb87b205$var$TOTAL_IMAGES;
        return (0, $8AeG9.html)`${this.walletImages.slice(0, $d8037889eb87b205$var$TOTAL_IMAGES).map(({ src: src, walletName: walletName })=>(0, $8AeG9.html)`
            <wui-wallet-image
              size="inherit"
              imageSrc=${src}
              name=${(0, $ljfXw.ifDefined)(walletName)}
            ></wui-wallet-image>
          `)}
      ${isPlaceholders ? [
            ...Array($d8037889eb87b205$var$TOTAL_IMAGES - this.walletImages.length)
        ].map(()=>(0, $8AeG9.html)` <wui-wallet-image size="inherit" name=""></wui-wallet-image>`) : null}
      <wui-flex>
        <wui-icon-box
          size="xxs"
          iconSize="xxs"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>`;
    }
};
$d8037889eb87b205$export$92558ad1dd06e644.styles = [
    (0, $hCS0p.resetStyles),
    (0, $bYbuP.default)
];
$d8037889eb87b205$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $d8037889eb87b205$export$92558ad1dd06e644.prototype, "walletImages", void 0);
$d8037889eb87b205$export$92558ad1dd06e644 = $d8037889eb87b205$var$__decorate([
    (0, $33Xir.customElement)("wui-all-wallets-image")
], $d8037889eb87b205$export$92558ad1dd06e644);

});
parcelRegister("dTlfF", function(module, exports) {

$parcel$export(module.exports, "WuiWalletImage", () => $a1d0e58dee689422$export$2df48f4f4e74a226);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("6GKXg");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("8lemW");

var $42g1Z = parcelRequire("42g1Z");
var $a1d0e58dee689422$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a1d0e58dee689422$export$2df48f4f4e74a226 = class WuiWalletImage extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "";
        this.installed = false;
        this.badgeSize = "xs";
    }
    render() {
        let borderRadius = "xxs";
        if (this.size === "lg") borderRadius = "m";
        else if (this.size === "md") borderRadius = "xs";
        else borderRadius = "xxs";
        this.style.cssText = `
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-wallet-image-size-${this.size});
   `;
        if (this.walletIcon) this.dataset["walletIcon"] = this.walletIcon;
        return (0, $8AeG9.html)`
      <wui-flex justifyContent="center" alignItems="center"> ${this.templateVisual()} </wui-flex>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        else if (this.walletIcon) return (0, $8AeG9.html)`<wui-icon
        data-parent-size="md"
        size="md"
        color="inherit"
        name=${this.walletIcon}
      ></wui-icon>`;
        return (0, $8AeG9.html)`<wui-icon
      data-parent-size=${this.size}
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$a1d0e58dee689422$export$2df48f4f4e74a226.styles = [
    (0, $hCS0p.resetStyles),
    (0, $42g1Z.default)
];
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)()
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "size", void 0);
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)()
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "name", void 0);
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)()
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "imageSrc", void 0);
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)()
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "walletIcon", void 0);
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "installed", void 0);
$a1d0e58dee689422$var$__decorate([
    (0, $kRRY9.property)()
], $a1d0e58dee689422$export$2df48f4f4e74a226.prototype, "badgeSize", void 0);
$a1d0e58dee689422$export$2df48f4f4e74a226 = $a1d0e58dee689422$var$__decorate([
    (0, $33Xir.customElement)("wui-wallet-image")
], $a1d0e58dee689422$export$2df48f4f4e74a226);

});
parcelRegister("42g1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f03c8c959216405$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $2f03c8c959216405$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    background-color: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-size);
    height: var(--local-size);
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host > wui-flex {
    overflow: hidden;
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host([name='Extension'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  :host([data-wallet-icon='allWallets']) {
    background-color: var(--wui-all-wallets-bg-100);
  }

  :host([data-wallet-icon='allWallets'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  wui-icon[data-parent-size='inherit'] {
    width: 75%;
    height: 75%;
    align-items: center;
  }

  wui-icon[data-parent-size='sm'] {
    width: 18px;
    height: 18px;
  }

  wui-icon[data-parent-size='md'] {
    width: 24px;
    height: 24px;
  }

  wui-icon[data-parent-size='lg'] {
    width: 42px;
    height: 42px;
  }

  wui-icon[data-parent-size='full'] {
    width: 100%;
    height: 100%;
  }

  :host > wui-icon-box {
    position: absolute;
    overflow: hidden;
    right: -1px;
    bottom: -2px;
    z-index: 1;
    border: 2px solid var(--wui-color-bg-base-150, #1e1f1f);
    padding: 1px;
  }
`;

});


parcelRegister("bYbuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6e37319c07d432$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $8b6e37319c07d432$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    border-radius: var(--wui-border-radius-xxs);
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--wui-spacing-4xs);
    padding: 3.75px !important;
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host > wui-wallet-image {
    width: 14px;
    height: 14px;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-flex {
    padding: 2px;
    position: fixed;
    overflow: hidden;
    left: 34px;
    bottom: 8px;
    background: var(--dark-background-150, #1e1f1f);
    border-radius: 50%;
    z-index: 2;
    display: flex;
  }
`;

});


parcelRegister("1jqc7", function(module, exports) {

$parcel$export(module.exports, "WuiButton", () => $0f4be273c211471f$export$5496564a8aaab1b8);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("cJIBV");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $1LxgC = parcelRequire("1LxgC");
var $0f4be273c211471f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0f4be273c211471f$export$5496564a8aaab1b8 = class WuiButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.fullWidth = false;
        this.loading = false;
        this.variant = "fill";
        this.hasIconLeft = false;
        this.hasIconRight = false;
    }
    render() {
        this.style.cssText = `
    --local-width: ${this.fullWidth ? "100%" : "auto"};
    --local-opacity-100: ${this.loading ? 0 : 1};
    --local-opacity-000: ${this.loading ? 1 : 0};`;
        const textVariant = this.size === "md" ? "paragraph-600" : "small-600";
        return (0, $8AeG9.html)`
      <button
        data-variant=${this.variant}
        data-icon-left=${this.hasIconLeft}
        data-icon-right=${this.hasIconRight}
        data-size=${this.size}
        ?disabled=${this.disabled || this.loading}
        ontouchstart
      >
        ${this.loadingTemplate()}
        <slot name="iconLeft" @slotchange=${()=>this.handleSlotLeftChange()}></slot>
        <wui-text variant=${textVariant} color="inherit">
          <slot></slot>
        </wui-text>
        <slot name="iconRight" @slotchange=${()=>this.handleSlotRightChange()}></slot>
      </button>
    `;
    }
    handleSlotLeftChange() {
        this.hasIconLeft = true;
    }
    handleSlotRightChange() {
        this.hasIconRight = true;
    }
    loadingTemplate() {
        if (this.loading) return (0, $8AeG9.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $8AeG9.html)``;
    }
};
$0f4be273c211471f$export$5496564a8aaab1b8.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $1LxgC.default)
];
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)()
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "size", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "disabled", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "fullWidth", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "loading", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)()
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "variant", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "hasIconLeft", void 0);
$0f4be273c211471f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $0f4be273c211471f$export$5496564a8aaab1b8.prototype, "hasIconRight", void 0);
$0f4be273c211471f$export$5496564a8aaab1b8 = $0f4be273c211471f$var$__decorate([
    (0, $33Xir.customElement)("wui-button")
], $0f4be273c211471f$export$5496564a8aaab1b8);

});
parcelRegister("1LxgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1493fc5d20e26e17$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $1493fc5d20e26e17$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    width: var(--local-width);
    position: relative;
  }

  button {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    width: var(--local-width);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-010);
  }

  button[data-size='sm'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s);
  }

  button[data-size='sm'][data-icon-left='true'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  button[data-size='sm'][data-icon-right='true'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-xs) var(--wui-spacing-xxs)
      var(--wui-spacing-s);
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button[data-size='md'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'][data-icon-left='true'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);
  }

  button[data-size='md'][data-icon-right='true'] {
    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);
  }

  wui-loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all 200ms ease-in-out;
    transform: translate(-50%, -50%);
    opacity: var(--local-opacity-000);
  }
`;

});


parcelRegister("djZE0", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelectLoader", () => $9b2cde001c1355a0$export$fc388e944144bd3a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $lOEVC = parcelRequire("lOEVC");
parcelRequire("cbfCt");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $i7mhr = parcelRequire("i7mhr");
var $9b2cde001c1355a0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9b2cde001c1355a0$export$fc388e944144bd3a = class WuiCardSelectLoader extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "wallet";
    }
    render() {
        return (0, $8AeG9.html)`
      ${this.shimmerTemplate()}
      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>
    `;
    }
    shimmerTemplate() {
        if (this.type === "network") return (0, $8AeG9.html)` <wui-shimmer
          data-type=${this.type}
          width="48px"
          height="54px"
          borderRadius="xs"
        ></wui-shimmer>
        ${0, $lOEVC.networkSvg}`;
        return (0, $8AeG9.html)`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
    }
};
$9b2cde001c1355a0$export$fc388e944144bd3a.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $i7mhr.default)
];
$9b2cde001c1355a0$var$__decorate([
    (0, $kRRY9.property)()
], $9b2cde001c1355a0$export$fc388e944144bd3a.prototype, "type", void 0);
$9b2cde001c1355a0$export$fc388e944144bd3a = $9b2cde001c1355a0$var$__decorate([
    (0, $33Xir.customElement)("wui-card-select-loader")
], $9b2cde001c1355a0$export$fc388e944144bd3a);

});
parcelRegister("lOEVC", function(module, exports) {

$parcel$export(module.exports, "networkSvg", () => $fe1e03fdf5070a6e$export$1a3efa751581ed0a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $fe1e03fdf5070a6e$export$1a3efa751581ed0a = (0, $8AeG9.svg)`<svg  viewBox="0 0 48 54" fill="none">
  <path
    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"
  />
</svg>`;

});

parcelRegister("i7mhr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d30a29d5865ad739$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $d30a29d5865ad739$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) 10px;
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    position: relative;
  }

  wui-shimmer[data-type='network'] {
    border: none;
    -webkit-clip-path: var(--wui-path-network);
    clip-path: var(--wui-path-network);
  }

  svg {
    position: absolute;
    width: 48px;
    height: 54px;
    z-index: 1;
  }

  svg > path {
    stroke: var(--wui-gray-glass-010);
    stroke-width: 1px;
  }
`;

});


parcelRegister("2momN", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelect", () => $1b8089909f61c121$export$815c16e0af51756a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("j4rli");
parcelRequire("dTlfF");

var $lPSCw = parcelRequire("lPSCw");
var $1b8089909f61c121$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1b8089909f61c121$export$815c16e0af51756a = class WuiCardSelect extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "Unknown";
        this.type = "wallet";
        this.imageSrc = undefined;
        this.disabled = false;
        this.selected = false;
        this.installed = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <button data-selected=${(0, $ljfXw.ifDefined)(this.selected)} ?disabled=${this.disabled} ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color=${this.selected ? "accent-100" : "inherit"}>
          ${this.name}
        </wui-text>
      </button>
    `;
    }
    imageTemplate() {
        if (this.type === "network") return (0, $8AeG9.html)`
        <wui-network-image
          .selected=${this.selected}
          imageSrc=${(0, $ljfXw.ifDefined)(this.imageSrc)}
          name=${this.name}
        >
        </wui-network-image>
      `;
        return (0, $8AeG9.html)`
      <wui-wallet-image
        size="md"
        imageSrc=${(0, $ljfXw.ifDefined)(this.imageSrc)}
        name=${this.name}
        .installed=${this.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
    }
};
$1b8089909f61c121$export$815c16e0af51756a.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $lPSCw.default)
];
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)()
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "name", void 0);
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)()
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "type", void 0);
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)()
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "imageSrc", void 0);
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "disabled", void 0);
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "selected", void 0);
$1b8089909f61c121$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $1b8089909f61c121$export$815c16e0af51756a.prototype, "installed", void 0);
$1b8089909f61c121$export$815c16e0af51756a = $1b8089909f61c121$var$__decorate([
    (0, $33Xir.customElement)("wui-card-select")
], $1b8089909f61c121$export$815c16e0af51756a);

});
parcelRegister("j4rli", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkImage", () => $de2399aacf47cea7$export$4dc5510728d31c71);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $lOEVC = parcelRequire("lOEVC");

var $5KmP3 = parcelRequire("5KmP3");
parcelRequire("jzyqy");
parcelRequire("6GKXg");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $9LUdq = parcelRequire("9LUdq");
var $de2399aacf47cea7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $de2399aacf47cea7$export$4dc5510728d31c71 = class WuiNetworkImage extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "uknown";
        this.selected = false;
    }
    render() {
        const isLg = this.size === "lg";
        this.style.cssText = `
      --local-stroke: ${this.selected ? "var(--wui-color-accent-100)" : "var(--wui-gray-glass-010)"};
      --local-path: ${isLg ? "var(--wui-path-network-lg)" : "var(--wui-path-network)"};
      --local-width: ${isLg ? "86px" : "48px"};
      --local-height: ${isLg ? "96px" : "54px"};
      --local-icon-size: ${isLg ? "42px" : "24px"};
    `;
        return (0, $8AeG9.html)`${this.templateVisual()} ${isLg ? (0, $5KmP3.networkLgSvg) : (0, $lOEVC.networkSvg)}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$de2399aacf47cea7$export$4dc5510728d31c71.styles = [
    (0, $hCS0p.resetStyles),
    (0, $9LUdq.default)
];
$de2399aacf47cea7$var$__decorate([
    (0, $kRRY9.property)()
], $de2399aacf47cea7$export$4dc5510728d31c71.prototype, "size", void 0);
$de2399aacf47cea7$var$__decorate([
    (0, $kRRY9.property)()
], $de2399aacf47cea7$export$4dc5510728d31c71.prototype, "name", void 0);
$de2399aacf47cea7$var$__decorate([
    (0, $kRRY9.property)()
], $de2399aacf47cea7$export$4dc5510728d31c71.prototype, "imageSrc", void 0);
$de2399aacf47cea7$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $de2399aacf47cea7$export$4dc5510728d31c71.prototype, "selected", void 0);
$de2399aacf47cea7$export$4dc5510728d31c71 = $de2399aacf47cea7$var$__decorate([
    (0, $33Xir.customElement)("wui-network-image")
], $de2399aacf47cea7$export$4dc5510728d31c71);

});
parcelRegister("5KmP3", function(module, exports) {

$parcel$export(module.exports, "networkLgSvg", () => $42f2f3b79083ea72$export$e89348f8999b186a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
const $42f2f3b79083ea72$export$e89348f8999b186a = (0, $8AeG9.svg)`<svg width="86" height="96" fill="none">
  <path
    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"
  />
</svg>`;

});

parcelRegister("9LUdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d41c15c6a348c8$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $71d41c15c6a348c8$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-width);
    height: var(--local-height);
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    fill: var(--wui-gray-glass-002);
  }

  svg > path {
    stroke: var(--local-stroke);
    transition: stroke var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image {
    width: 100%;
    height: 100%;
    -webkit-clip-path: var(--local-path);
    clip-path: var(--local-path);
    background: var(--wui-gray-glass-002);
  }

  wui-icon {
    transform: translateY(-5%);
    width: var(--local-icon-size);
    height: var(--local-icon-size);
  }
`;

});


parcelRegister("lPSCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe58baddcceaf9f9$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $fe58baddcceaf9f9$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    flex-direction: column;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: var(--wui-icon-box-size-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-accent-glass-010);
  }
`;

});


parcelRegister("d07io", function(module, exports) {

$parcel$export(module.exports, "WuiChip", () => $9770ef3890ac48ac$export$418286c4c7ff87c6);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("6GKXg");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");

var $iNIpE = parcelRequire("iNIpE");
var $9770ef3890ac48ac$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9770ef3890ac48ac$export$418286c4c7ff87c6 = class WuiChip extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "fill";
        this.imageSrc = undefined;
        this.disabled = false;
        this.icon = "externalLink";
        this.href = "";
        this.text = undefined;
    }
    render() {
        const isSmall = this.variant === "success" || this.variant === "transparent" || this.variant === "shadeSmall";
        const textVariant = isSmall ? "small-600" : "paragraph-600";
        return (0, $8AeG9.html)`
      <a
        rel="noreferrer"
        target="_blank"
        href=${this.href}
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
      >
        ${this.imageTemplate()}
        <wui-text variant=${textVariant} color="inherit">
          ${this.title ? this.title : (0, $8iLLL.UiHelperUtil).getHostName(this.href)}
        </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </a>
    `;
    }
    imageTemplate() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return null;
    }
};
$9770ef3890ac48ac$export$418286c4c7ff87c6.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $iNIpE.default)
];
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)()
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "variant", void 0);
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)()
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "imageSrc", void 0);
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "disabled", void 0);
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)()
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "icon", void 0);
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)()
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "href", void 0);
$9770ef3890ac48ac$var$__decorate([
    (0, $kRRY9.property)()
], $9770ef3890ac48ac$export$418286c4c7ff87c6.prototype, "text", void 0);
$9770ef3890ac48ac$export$418286c4c7ff87c6 = $9770ef3890ac48ac$var$__decorate([
    (0, $33Xir.customElement)("wui-chip")
], $9770ef3890ac48ac$export$418286c4c7ff87c6);

});
parcelRegister("iNIpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $daff410a2cf6698d$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $daff410a2cf6698d$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  a {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  a.disabled > wui-icon,
  a.disabled > wui-image {
    filter: grayscale(1);
  }

  a[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  a[data-variant='shade'],
  a[data-variant='shadeSmall'] {
    background-color: transparent;
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  a[data-variant='success'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-success-glass-010);
    background-color: var(--wui-success-glass-010);
    color: var(--wui-color-success-100);
  }

  a[data-variant='transparent'] {
    column-gap: var(--wui-spacing-xxs);
    background-color: transparent;
    color: var(--wui-color-fg-150);
  }

  a[data-variant='transparent'],
  a[data-variant='success'],
  a[data-variant='shadeSmall'] {
    padding: 7px var(--wui-spacing-s) 7px 10px;
  }

  a[data-variant='transparent']:has(wui-text:first-child),
  a[data-variant='success']:has(wui-text:first-child),
  a[data-variant='shadeSmall']:has(wui-text:first-child) {
    padding: 7px var(--wui-spacing-s);
  }

  a[data-variant='fill'],
  a[data-variant='shade'] {
    column-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  a[data-variant='fill']:has(wui-text:first-child),
  a[data-variant='shade']:has(wui-text:first-child) {
    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);
  }

  a[data-variant='fill'] > wui-image,
  a[data-variant='shade'] > wui-image {
    width: 24px;
    height: 24px;
  }

  a[data-variant='fill'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);
  }

  a[data-variant='shade'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-010);
  }

  a[data-variant='fill'] > wui-icon,
  a[data-variant='shade'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-image,
  a[data-variant='success'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-icon,
  a[data-variant='success'] > wui-icon,
  a[data-variant='shadeSmall'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  a[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  a[data-variant='shade']:focus-visible,
  a[data-variant='shadeSmall']:focus-visible {
    background-color: var(--wui-gray-glass-015);
  }

  a[data-variant='transparent']:focus-visible {
    background-color: var(--wui-gray-glass-005);
  }

  a[data-variant='success']:focus-visible {
    background-color: var(--wui-success-glass-015);
  }

  a.disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    a[data-variant='fill']:hover {
      background-color: var(--wui-color-accent-090);
    }

    a[data-variant='shade']:hover,
    a[data-variant='shadeSmall']:hover {
      background-color: var(--wui-gray-glass-015);
    }

    a[data-variant='transparent']:hover {
      background-color: var(--wui-gray-glass-005);
    }

    a[data-variant='success']:hover {
      background-color: var(--wui-success-glass-015);
    }
  }

  a[data-variant='fill']:active {
    background-color: var(--wui-color-accent-080);
  }

  a[data-variant='shade']:active,
  a[data-variant='shadeSmall']:active {
    background-color: var(--wui-gray-glass-020);
  }

  a[data-variant='transparent']:active {
    background-color: var(--wui-gray-glass-010);
  }

  a[data-variant='success']:active {
    background-color: var(--wui-success-glass-020);
  }
`;

});


parcelRegister("gkhm0", function(module, exports) {

$parcel$export(module.exports, "WuiConnectButton", () => $be2bf9b945874fea$export$7e12422df5cbb04c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("cJIBV");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $80VYn = parcelRequire("80VYn");
var $be2bf9b945874fea$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $be2bf9b945874fea$export$7e12422df5cbb04c = class WuiConnectButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.loading = false;
    }
    render() {
        const textVariant = this.size === "md" ? "paragraph-600" : "small-600";
        return (0, $8AeG9.html)`
      <button data-size=${this.size} ?disabled=${this.loading} ontouchstart>
        ${this.loadingTemplate()}
        <wui-text variant=${textVariant} color=${this.loading ? "accent-100" : "inherit"}>
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    loadingTemplate() {
        if (!this.loading) return null;
        return (0, $8AeG9.html)`<wui-loading-spinner size=${this.size} color="accent-100"></wui-loading-spinner>`;
    }
};
$be2bf9b945874fea$export$7e12422df5cbb04c.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $80VYn.default)
];
$be2bf9b945874fea$var$__decorate([
    (0, $kRRY9.property)()
], $be2bf9b945874fea$export$7e12422df5cbb04c.prototype, "size", void 0);
$be2bf9b945874fea$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $be2bf9b945874fea$export$7e12422df5cbb04c.prototype, "loading", void 0);
$be2bf9b945874fea$export$7e12422df5cbb04c = $be2bf9b945874fea$var$__decorate([
    (0, $33Xir.customElement)("wui-connect-button")
], $be2bf9b945874fea$export$7e12422df5cbb04c);

});
parcelRegister("80VYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d5b4aff4c17b1c4$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $5d5b4aff4c17b1c4$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: block;
  }

  button {
    background: var(--wui-color-accent-100);
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    gap: var(--wui-spacing-xs);
  }

  button.loading {
    background: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-gray-glass-010);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-080);
    }
  }

  button:focus-visible {
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-color-accent-090);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-size='sm'] {
    padding: 6.75px 10px 7.25px;
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
    color: var(--wui-color-inverse-100);
  }

  button[data-size='md'] {
    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'] + wui-text {
    padding-left: var(--wui-spacing-3xs);
  }

  @media (max-width: 500px) {
    button[data-size='md'] {
      height: 32px;
      padding: 5px 12px;
    }

    button[data-size='md'] > wui-text > slot {
      font-size: 14px !important;
    }
  }

  wui-loading-spinner {
    width: 14px;
    height: 14px;
  }

  wui-loading-spinner::slotted(svg) {
    width: 10px !important;
    height: 10px !important;
  }

  button[data-size='sm'] > wui-loading-spinner {
    width: 12px;
    height: 12px;
  }
`;

});


parcelRegister("kgTK1", function(module, exports) {

$parcel$export(module.exports, "WuiCtaButton", () => $ec208a53dbe29032$export$4cb12aabb6d5d23c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("64e2j");
parcelRequire("1jqc7");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $ie8VL = parcelRequire("ie8VL");
var $ec208a53dbe29032$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ec208a53dbe29032$export$4cb12aabb6d5d23c = class WuiCtaButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.label = "";
        this.buttonLabel = "";
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex
        justifyContent="space-between"
        alignItems="center"
        .padding=${[
            "1xs",
            "2l",
            "1xs",
            "2l"
        ]}
      >
        <wui-text variant="paragraph-500" color="fg-200">${this.label}</wui-text>
        <wui-button size="sm" variant="accent">
          ${this.buttonLabel}
          <wui-icon size="xs" color="inherit" slot="iconRight" name="chevronRight"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$ec208a53dbe29032$export$4cb12aabb6d5d23c.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $ie8VL.default)
];
$ec208a53dbe29032$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $ec208a53dbe29032$export$4cb12aabb6d5d23c.prototype, "disabled", void 0);
$ec208a53dbe29032$var$__decorate([
    (0, $kRRY9.property)()
], $ec208a53dbe29032$export$4cb12aabb6d5d23c.prototype, "label", void 0);
$ec208a53dbe29032$var$__decorate([
    (0, $kRRY9.property)()
], $ec208a53dbe29032$export$4cb12aabb6d5d23c.prototype, "buttonLabel", void 0);
$ec208a53dbe29032$export$4cb12aabb6d5d23c = $ec208a53dbe29032$var$__decorate([
    (0, $33Xir.customElement)("wui-cta-button")
], $ec208a53dbe29032$export$4cb12aabb6d5d23c);

});
parcelRegister("ie8VL", function(module, exports) {

$parcel$export(module.exports, "default", () => $036ca7119a97991d$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $036ca7119a97991d$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("gictS", function(module, exports) {

$parcel$export(module.exports, "WuiEmailInput", () => $bdc802336227137f$export$99face4607bb46ea);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("lX1F6");

var $6gBdx = parcelRequire("6gBdx");
var $bdc802336227137f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bdc802336227137f$export$99face4607bb46ea = class WuiEmailInput extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-input-text
        placeholder="Email"
        icon="mail"
        size="md"
        .disabled=${this.disabled}
        .value=${this.value}
        data-testid="wui-email-input"
      ></wui-input-text>
      ${this.templateError()}
    `;
    }
    templateError() {
        if (this.errorMessage) return (0, $8AeG9.html)`<wui-text variant="tiny-500" color="error-100">${this.errorMessage}</wui-text>`;
        return null;
    }
};
$bdc802336227137f$export$99face4607bb46ea.styles = [
    (0, $hCS0p.resetStyles),
    (0, $6gBdx.default)
];
$bdc802336227137f$var$__decorate([
    (0, $kRRY9.property)()
], $bdc802336227137f$export$99face4607bb46ea.prototype, "errorMessage", void 0);
$bdc802336227137f$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $bdc802336227137f$export$99face4607bb46ea.prototype, "disabled", void 0);
$bdc802336227137f$var$__decorate([
    (0, $kRRY9.property)()
], $bdc802336227137f$export$99face4607bb46ea.prototype, "value", void 0);
$bdc802336227137f$export$99face4607bb46ea = $bdc802336227137f$var$__decorate([
    (0, $33Xir.customElement)("wui-email-input")
], $bdc802336227137f$export$99face4607bb46ea);

});
parcelRegister("lX1F6", function(module, exports) {

$parcel$export(module.exports, "WuiInputText", () => $ffb065b0ea5979b6$export$487c694bc02cf7da);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("i6b12");
var $fUwov = parcelRequire("fUwov");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $eqjqC = parcelRequire("eqjqC");
var $ffb065b0ea5979b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ffb065b0ea5979b6$export$487c694bc02cf7da = class WuiInputText extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $fUwov.createRef)();
        this.size = "md";
        this.disabled = false;
        this.placeholder = "";
        this.type = "text";
    }
    render() {
        const sizeClass = `wui-size-${this.size}`;
        return (0, $8AeG9.html)` ${this.templateIcon()}
      <input
        ${(0, $fUwov.ref)(this.inputElementRef)}
        class=${sizeClass}
        type=${this.type}
        enterkeyhint=${(0, $ljfXw.ifDefined)(this.enterKeyHint)}
        ?disabled=${this.disabled}
        placeholder=${this.placeholder}
        @input=${this.dispatchInputChangeEvent.bind(this)}
        value=${(0, $ljfXw.ifDefined)(this.value)}
      />
      <slot></slot>`;
    }
    templateIcon() {
        if (this.icon) return (0, $8AeG9.html)`<wui-icon
        data-input=${this.size}
        size="sm"
        color="inherit"
        name=${this.icon}
      ></wui-icon>`;
        return null;
    }
    dispatchInputChangeEvent() {
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: this.inputElementRef.value?.value,
            bubbles: true,
            composed: true
        }));
    }
};
$ffb065b0ea5979b6$export$487c694bc02cf7da.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $eqjqC.default)
];
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "size", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "icon", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "disabled", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "placeholder", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "type", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "keyHint", void 0);
$ffb065b0ea5979b6$var$__decorate([
    (0, $kRRY9.property)()
], $ffb065b0ea5979b6$export$487c694bc02cf7da.prototype, "value", void 0);
$ffb065b0ea5979b6$export$487c694bc02cf7da = $ffb065b0ea5979b6$var$__decorate([
    (0, $33Xir.customElement)("wui-input-text")
], $ffb065b0ea5979b6$export$487c694bc02cf7da);

});
parcelRegister("i6b12", function(module, exports) {
$parcel$export(module.exports, "createRef", () => (parcelRequire("fUwov")).createRef);
$parcel$export(module.exports, "ref", () => (parcelRequire("fUwov")).ref);
parcelRequire("fUwov");

});
parcelRegister("fUwov", function(module, exports) {

$parcel$export(module.exports, "createRef", () => $b95536c757f7c93a$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "ref", () => $b95536c757f7c93a$export$eff4d24c3ff7876e);

var $8AeG9 = parcelRequire("8AeG9");

var $f4sI1 = parcelRequire("f4sI1");

var $dL6tn = parcelRequire("dL6tn");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b95536c757f7c93a$export$7d1e3a5e95ceca43 = ()=>new $b95536c757f7c93a$var$h;
class $b95536c757f7c93a$var$h {
}
const $b95536c757f7c93a$var$o = new WeakMap, $b95536c757f7c93a$export$eff4d24c3ff7876e = (0, $dL6tn.directive)(class extends (0, $f4sI1.AsyncDirective) {
    render(i) {
        return 0, $8AeG9.nothing;
    }
    update(i, [s]) {
        const e = s !== this.Y;
        return e && void 0 !== this.Y && this.rt(void 0), (e || this.lt !== this.ct) && (this.Y = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $8AeG9.nothing;
    }
    rt(t) {
        if ("function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $b95536c757f7c93a$var$o.get(i);
            void 0 === s && (s = new WeakMap, $b95536c757f7c93a$var$o.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $b95536c757f7c93a$var$o.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});

});
parcelRegister("f4sI1", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", () => $af8d7fbb97348c92$export$7d025501802325e);

var $cF78q = parcelRequire("cF78q");

var $dL6tn = parcelRequire("dL6tn");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af8d7fbb97348c92$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $af8d7fbb97348c92$var$s(i, t);
    return !0;
}, $af8d7fbb97348c92$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $af8d7fbb97348c92$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $af8d7fbb97348c92$var$c(t);
    }
};
function $af8d7fbb97348c92$var$h(i) {
    void 0 !== this._$AN ? ($af8d7fbb97348c92$var$o(this), this._$AM = i, $af8d7fbb97348c92$var$r(this)) : this._$AM = i;
}
function $af8d7fbb97348c92$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$af8d7fbb97348c92$var$s(r[i], !1), $af8d7fbb97348c92$var$o(r[i]);
            else null != r && ($af8d7fbb97348c92$var$s(r, !1), $af8d7fbb97348c92$var$o(r));
        } else $af8d7fbb97348c92$var$s(this, i);
    }
}
const $af8d7fbb97348c92$var$c = (i)=>{
    i.type == (0, $dL6tn.PartType).CHILD && (i._$AP ??= $af8d7fbb97348c92$var$n, i._$AQ ??= $af8d7fbb97348c92$var$h);
};
class $af8d7fbb97348c92$export$7d025501802325e extends (0, $dL6tn.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $af8d7fbb97348c92$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($af8d7fbb97348c92$var$s(this, i), $af8d7fbb97348c92$var$o(this));
    }
    setValue(t) {
        if ((0, $cF78q.isSingleExpression)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("cF78q", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", () => $937ed934c536972d$export$7f431ad0fff82fd9);

var $8AeG9 = parcelRequire("8AeG9");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $937ed934c536972d$var$t } = (0, $8AeG9._$LH), $937ed934c536972d$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $937ed934c536972d$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $937ed934c536972d$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $937ed934c536972d$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $937ed934c536972d$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $937ed934c536972d$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $937ed934c536972d$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $937ed934c536972d$var$s = ()=>document.createComment(""), $937ed934c536972d$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($937ed934c536972d$var$s(), l), c = e.insertBefore($937ed934c536972d$var$s(), l);
        n = new $937ed934c536972d$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $937ed934c536972d$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $937ed934c536972d$var$u = {}, $937ed934c536972d$export$ea70d9dd5965b1c8 = (o, t = $937ed934c536972d$var$u)=>o._$AH = t, $937ed934c536972d$export$59e9bce518cde500 = (o)=>o._$AH, $937ed934c536972d$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $937ed934c536972d$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});




parcelRegister("eqjqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8029078967ab1a3$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $a8029078967ab1a3$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  input {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    font-size: var(--wui-font-size-paragraph);
    font-weight: var(--wui-font-weight-light);
    letter-spacing: var(--wui-letter-spacing-paragraph);
    color: var(--wui-color-fg-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    caret-color: var(--wui-color-accent-100);
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
  }

  input:disabled::placeholder,
  input:disabled + wui-icon {
    color: var(--wui-color-fg-300);
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  wui-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);
  }

  wui-icon + .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px 36px;
  }

  wui-icon[data-input='sm'] {
    left: var(--wui-spacing-s);
  }

  .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);
  }

  wui-icon + .wui-size-md,
  wui-loading-spinner + .wui-size-md {
    padding: 10.5px var(--wui-spacing-3xl) 10.5px 40px;
  }

  wui-icon[data-input='md'] {
    left: var(--wui-spacing-l);
  }

  input:placeholder-shown ~ ::slotted(wui-input-element),
  input:placeholder-shown ~ ::slotted(wui-icon) {
    opacity: 0;
    pointer-events: none;
  }

  ::slotted(wui-input-element),
  ::slotted(wui-icon) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
  }

  ::slotted(wui-input-element) {
    right: var(--wui-spacing-m);
  }

  ::slotted(wui-icon) {
    right: 0px;
  }
`;

});


parcelRegister("6gBdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $49011b48a5d622f1$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $49011b48a5d622f1$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  wui-text {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }
`;

});


parcelRegister("ggPbf", function(module, exports) {

$parcel$export(module.exports, "WuiIconLink", () => $bd85d759ea6d0a23$export$5a944ba239383166);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $83hOe = parcelRequire("83hOe");
var $bd85d759ea6d0a23$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd85d759ea6d0a23$export$5a944ba239383166 = class WuiIconLink extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.icon = "copy";
        this.iconColor = "inherit";
    }
    render() {
        return (0, $8AeG9.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-icon color=${this.iconColor} size=${this.size} name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$bd85d759ea6d0a23$export$5a944ba239383166.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $hCS0p.colorStyles),
    (0, $83hOe.default)
];
$bd85d759ea6d0a23$var$__decorate([
    (0, $kRRY9.property)()
], $bd85d759ea6d0a23$export$5a944ba239383166.prototype, "size", void 0);
$bd85d759ea6d0a23$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $bd85d759ea6d0a23$export$5a944ba239383166.prototype, "disabled", void 0);
$bd85d759ea6d0a23$var$__decorate([
    (0, $kRRY9.property)()
], $bd85d759ea6d0a23$export$5a944ba239383166.prototype, "icon", void 0);
$bd85d759ea6d0a23$var$__decorate([
    (0, $kRRY9.property)()
], $bd85d759ea6d0a23$export$5a944ba239383166.prototype, "iconColor", void 0);
$bd85d759ea6d0a23$export$5a944ba239383166 = $bd85d759ea6d0a23$var$__decorate([
    (0, $33Xir.customElement)("wui-icon-link")
], $bd85d759ea6d0a23$export$5a944ba239383166);

});
parcelRegister("83hOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dcc6b163e9f83c7$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $5dcc6b163e9f83c7$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    border-radius: var(--wui-border-radius-xxs);
    color: var(--wui-color-fg-100);
    padding: var(--wui-spacing-2xs);
  }

  @media (max-width: 700px) {
    button {
      padding: var(--wui-spacing-s);
    }
  }

  button > wui-icon {
    pointer-events: none;
  }

  button:disabled > wui-icon {
    color: var(--wui-color-bg-300) !important;
  }

  button:disabled {
    background-color: transparent;
  }
`;

});


parcelRegister("7zfrA", function(module, exports) {

$parcel$export(module.exports, "WuiInputElement", () => $5827c8229fee80ce$export$673191bf93fc142c);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $4gUIN = parcelRequire("4gUIN");
var $5827c8229fee80ce$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5827c8229fee80ce$export$673191bf93fc142c = class WuiInputElement extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "copy";
    }
    render() {
        return (0, $8AeG9.html)`
      <button>
        <wui-icon color="inherit" size="xxs" name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$5827c8229fee80ce$export$673191bf93fc142c.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $4gUIN.default)
];
$5827c8229fee80ce$var$__decorate([
    (0, $kRRY9.property)()
], $5827c8229fee80ce$export$673191bf93fc142c.prototype, "icon", void 0);
$5827c8229fee80ce$export$673191bf93fc142c = $5827c8229fee80ce$var$__decorate([
    (0, $33Xir.customElement)("wui-input-element")
], $5827c8229fee80ce$export$673191bf93fc142c);

});
parcelRegister("4gUIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c4a7bd670fbddf$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $31c4a7bd670fbddf$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    background-color: var(--wui-color-fg-300);
    border-radius: var(--wui-border-radius-4xs);
    width: 16px;
    height: 16px;
  }

  button:disabled {
    background-color: var(--wui-color-bg-300);
  }

  wui-icon {
    color: var(--wui-color-bg-200) !important;
  }

  button:focus-visible {
    background-color: var(--wui-color-fg-250);
    border: 1px solid var(--wui-color-accent-100);
  }

  button:active:enabled {
    background-color: var(--wui-color-fg-225);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-fg-250);
    }
  }
`;

});


parcelRegister("lIOMa", function(module, exports) {

$parcel$export(module.exports, "WuiInputNumeric", () => $fd05181614fecff1$export$230332bec9d0029b);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $4Ddy5 = parcelRequire("4Ddy5");
var $fd05181614fecff1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fd05181614fecff1$export$230332bec9d0029b = class WuiInputNumeric extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.value = "";
    }
    render() {
        return (0, $8AeG9.html)`<input
      type="number"
      maxlength="1"
      inputmode="numeric"
      autofocus
      ?disabled=${this.disabled}
      value=${this.value}
    /> `;
    }
};
$fd05181614fecff1$export$230332bec9d0029b.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $4Ddy5.default)
];
$fd05181614fecff1$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $fd05181614fecff1$export$230332bec9d0029b.prototype, "disabled", void 0);
$fd05181614fecff1$var$__decorate([
    (0, $kRRY9.property)({
        type: String
    })
], $fd05181614fecff1$export$230332bec9d0029b.prototype, "value", void 0);
$fd05181614fecff1$export$230332bec9d0029b = $fd05181614fecff1$var$__decorate([
    (0, $33Xir.customElement)("wui-input-numeric")
], $fd05181614fecff1$export$230332bec9d0029b);

});
parcelRegister("4Ddy5", function(module, exports) {

$parcel$export(module.exports, "default", () => $35f55078bea68211$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $35f55078bea68211$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    font-family: var(--wui-font-family);
    font-size: var(--wui-font-size-large);
    font-weight: var(--wui-font-weight-regular);
    letter-spacing: var(--wui-letter-spacing-large);
    text-align: center;
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
    background: var(--wui-gray-glass-005);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }
  @media (hover: hover) and (pointer: fine) {
    input:hover:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }
`;

});


parcelRegister("hxKVm", function(module, exports) {

$parcel$export(module.exports, "WuiLink", () => $cc59eae6c869a082$export$f279fe723271abb);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $iJNoa = parcelRequire("iJNoa");
var $cc59eae6c869a082$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cc59eae6c869a082$export$f279fe723271abb = class WuiLink extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
    }
    render() {
        return (0, $8AeG9.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <slot name="iconLeft"></slot>
        <wui-text variant="small-600" color=${this.color}>
          <slot></slot>
        </wui-text>
        <slot name="iconRight"></slot>
      </button>
    `;
    }
};
$cc59eae6c869a082$export$f279fe723271abb.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $iJNoa.default)
];
$cc59eae6c869a082$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $cc59eae6c869a082$export$f279fe723271abb.prototype, "disabled", void 0);
$cc59eae6c869a082$var$__decorate([
    (0, $kRRY9.property)()
], $cc59eae6c869a082$export$f279fe723271abb.prototype, "color", void 0);
$cc59eae6c869a082$export$f279fe723271abb = $cc59eae6c869a082$var$__decorate([
    (0, $33Xir.customElement)("wui-link")
], $cc59eae6c869a082$export$f279fe723271abb);

});
parcelRegister("iJNoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $da42bd8ce8d7111e$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $da42bd8ce8d7111e$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
    border-radius: var(--wui-border-radius-3xs);
    background-color: transparent;
    color: var(--wui-color-accent-100);
  }

  button:disabled {
    background-color: transparent;
    color: var(--wui-gray-glass-015);
  }
`;

});


parcelRegister("lkWmQ", function(module, exports) {

$parcel$export(module.exports, "WuiListItem", () => $f888bdca6942121c$export$cd9b2e41f828fc8a);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("jzyqy");
parcelRequire("6GKXg");
parcelRequire("cJIBV");
parcelRequire("64e2j");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("8lemW");

var $jZ9fO = parcelRequire("jZ9fO");
var $f888bdca6942121c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f888bdca6942121c$export$cd9b2e41f828fc8a = class WuiListItem extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "icon";
        this.disabled = false;
        this.imageSrc = undefined;
        this.alt = undefined;
        this.chevron = false;
        this.loading = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <button
        ?disabled=${this.loading ? true : Boolean(this.disabled)}
        data-loading=${this.loading}
        data-iconvariant=${(0, $ljfXw.ifDefined)(this.iconVariant)}
        ontouchstart
      >
        ${this.loadingTemplate()} ${this.visualTemplate()}
        <wui-flex gap="3xs">
          <slot></slot>
        </wui-flex>
        ${this.chevronTemplate()}
      </button>
    `;
    }
    visualTemplate() {
        if (this.variant === "image" && this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "list item"}></wui-image>`;
        else if (this.iconVariant === "square" && this.icon && this.variant === "icon") return (0, $8AeG9.html)`<wui-icon name=${this.icon}></wui-icon>`;
        else if (this.variant === "icon" && this.icon && this.iconVariant) {
            const color = [
                "blue",
                "square-blue"
            ].includes(this.iconVariant) ? "accent-100" : "fg-200";
            const size = this.iconVariant === "square-blue" ? "mdl" : "md";
            const iconSize = this.iconSize ? this.iconSize : size;
            return (0, $8AeG9.html)`
        <wui-icon-box
          data-variant=${this.iconVariant}
          icon=${this.icon}
          iconSize=${iconSize}
          background="transparent"
          iconColor=${color}
          backgroundColor=${color}
          size=${size}
        ></wui-icon-box>
      `;
        }
        return null;
    }
    loadingTemplate() {
        if (this.loading) return (0, $8AeG9.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $8AeG9.html)``;
    }
    chevronTemplate() {
        if (this.chevron) return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>`;
        return null;
    }
};
$f888bdca6942121c$export$cd9b2e41f828fc8a.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $jZ9fO.default)
];
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "icon", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "iconSize", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "variant", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "iconVariant", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "disabled", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "imageSrc", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)()
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "alt", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "chevron", void 0);
$f888bdca6942121c$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $f888bdca6942121c$export$cd9b2e41f828fc8a.prototype, "loading", void 0);
$f888bdca6942121c$export$cd9b2e41f828fc8a = $f888bdca6942121c$var$__decorate([
    (0, $33Xir.customElement)("wui-list-item")
], $f888bdca6942121c$export$cd9b2e41f828fc8a);

});
parcelRegister("jZ9fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8cae4783c0bbc5e$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $e8cae4783c0bbc5e$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 11px 18px 11px var(--wui-spacing-s);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  button[data-iconvariant='square'],
  button[data-iconvariant='square-blue'] {
    padding: 6px 18px 6px 9px;
  }

  button > wui-flex {
    flex: 1;
  }

  button > wui-image {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
    border-radius: var(--wui-border-radius-3xl);
  }

  button > wui-icon {
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='blue'] {
    box-shadow: 0 0 0 2px var(--wui-accent-glass-005);
  }

  button > wui-icon-box[data-variant='overlay'] {
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='square-blue']::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-accent-glass-010);
    pointer-events: none;
  }

  button > wui-icon:last-child {
    width: 14px;
    height: 14px;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button[data-loading='true'] > wui-icon {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
  }

  wui-loading-spinner {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

});


parcelRegister("dO2t7", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItem", () => $a0d1dc1b59f93523$export$ee516ccb0af19908);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $33Xir = parcelRequire("33Xir");

var $2Ex15 = parcelRequire("2Ex15");

var $hCS0p = parcelRequire("hCS0p");
parcelRequire("64e2j");
parcelRequire("iY2T0");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");

var $Pru0F = parcelRequire("Pru0F");
var $a0d1dc1b59f93523$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a0d1dc1b59f93523$export$ee516ccb0af19908 = class WuiTransactionListItem extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "approve";
        this.onlyDirectionIcon = false;
        this.images = [];
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex>
        <wui-transaction-visual
          .status=${this.status}
          direction=${(0, $ljfXw.ifDefined)(this.direction)}
          type=${this.type}
          onlyDirectionIcon=${(0, $ljfXw.ifDefined)(this.onlyDirectionIcon)}
          .images=${this.images}
        ></wui-transaction-visual>
        <wui-flex flexDirection="column" gap="3xs">
          <wui-text variant="paragraph-600" color="fg-100">
            ${(0, $2Ex15.TransactionTypePastTense)[this.type]}
          </wui-text>
          <wui-flex class="description-container">
            ${this.templateDescription()} ${this.templateSecondDescription()}
          </wui-flex>
        </wui-flex>
        <wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>
      </wui-flex>
    `;
    }
    templateDescription() {
        const description = this.descriptions?.[0];
        return description ? (0, $8AeG9.html)`
          <wui-text variant="small-500" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
    templateSecondDescription() {
        const description = this.descriptions?.[1];
        return description ? (0, $8AeG9.html)`
          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>
          <wui-text variant="small-400" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
};
$a0d1dc1b59f93523$export$ee516ccb0af19908.styles = [
    (0, $hCS0p.resetStyles),
    (0, $Pru0F.default)
];
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)()
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "type", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "descriptions", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)()
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "date", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "onlyDirectionIcon", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)()
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "status", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)()
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "direction", void 0);
$a0d1dc1b59f93523$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $a0d1dc1b59f93523$export$ee516ccb0af19908.prototype, "images", void 0);
$a0d1dc1b59f93523$export$ee516ccb0af19908 = $a0d1dc1b59f93523$var$__decorate([
    (0, $33Xir.customElement)("wui-transaction-list-item")
], $a0d1dc1b59f93523$export$ee516ccb0af19908);

});
parcelRegister("2Ex15", function(module, exports) {

$parcel$export(module.exports, "TransactionTypePastTense", () => $1ee8ed9a7f1bb493$export$1c6b44bd2bf7f8fa);
var $1ee8ed9a7f1bb493$export$1c6b44bd2bf7f8fa;
(function(TransactionTypePastTense) {
    TransactionTypePastTense["approve"] = "approved";
    TransactionTypePastTense["bought"] = "bought";
    TransactionTypePastTense["borrow"] = "borrowed";
    TransactionTypePastTense["burn"] = "burnt";
    TransactionTypePastTense["cancel"] = "canceled";
    TransactionTypePastTense["claim"] = "claimed";
    TransactionTypePastTense["deploy"] = "deployed";
    TransactionTypePastTense["deposit"] = "deposited";
    TransactionTypePastTense["execute"] = "executed";
    TransactionTypePastTense["mint"] = "minted";
    TransactionTypePastTense["receive"] = "received";
    TransactionTypePastTense["repay"] = "repaid";
    TransactionTypePastTense["send"] = "sent";
    TransactionTypePastTense["sell"] = "sold";
    TransactionTypePastTense["stake"] = "staked";
    TransactionTypePastTense["trade"] = "swapped";
    TransactionTypePastTense["unstake"] = "unstaked";
    TransactionTypePastTense["withdraw"] = "withdrawn";
})($1ee8ed9a7f1bb493$export$1c6b44bd2bf7f8fa || ($1ee8ed9a7f1bb493$export$1c6b44bd2bf7f8fa = {}));

});

parcelRegister("iY2T0", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionVisual", () => $dcf011bb2ab65e1c$export$98664c16c41f47e3);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $33Xir = parcelRequire("33Xir");
parcelRequire("6GKXg");
parcelRequire("8lemW");

var $8ZOjA = parcelRequire("8ZOjA");
var $dcf011bb2ab65e1c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dcf011bb2ab65e1c$export$98664c16c41f47e3 = class WuiTransactionVisual extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.images = [];
        this.secondImage = {
            type: undefined,
            url: ""
        };
    }
    render() {
        const [firstImage, secondImage] = this.images;
        const isLeftNFT = firstImage?.type === "NFT";
        const isRightNFT = secondImage?.url ? secondImage.type === "NFT" : isLeftNFT;
        const leftRadius = isLeftNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        const rightRadius = isRightNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        this.style.cssText = `
    --local-left-border-radius: ${leftRadius};
    --local-right-border-radius: ${rightRadius};
    `;
        return (0, $8AeG9.html)`<wui-flex> ${this.templateVisual()} ${this.templateIcon()} </wui-flex>`;
    }
    templateVisual() {
        const [firstImage, secondImage] = this.images;
        const firstImageType = firstImage?.type;
        const haveTwoImages = this.images.length === 2;
        if (haveTwoImages && (firstImage?.url || secondImage?.url)) return (0, $8AeG9.html)`<div class="swap-images-container">
        ${firstImage?.url ? (0, $8AeG9.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>` : null}
        ${secondImage?.url ? (0, $8AeG9.html)`<wui-image src=${secondImage.url} alt="Transaction image"></wui-image>` : null}
      </div>`;
        else if (firstImage?.url) return (0, $8AeG9.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>`;
        else if (firstImageType === "NFT") return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>`;
        return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>`;
    }
    templateIcon() {
        let color = "accent-100";
        let icon = undefined;
        icon = this.getIcon();
        if (this.status) color = this.getStatusColor();
        if (!icon) return null;
        return (0, $8AeG9.html)`
      <wui-icon-box
        size="xxs"
        iconColor=${color}
        backgroundColor=${color}
        background="opaque"
        icon=${icon}
        ?border=${true}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
    `;
    }
    getDirectionIcon() {
        switch(this.direction){
            case "in":
                return "arrowBottom";
            case "out":
                return "arrowTop";
            default:
                return undefined;
        }
    }
    getIcon() {
        if (this.onlyDirectionIcon) return this.getDirectionIcon();
        if (this.type === "trade") return "swapHorizontalBold";
        else if (this.type === "approve") return "checkmark";
        else if (this.type === "cancel") return "close";
        return this.getDirectionIcon();
    }
    getStatusColor() {
        switch(this.status){
            case "confirmed":
                return "success-100";
            case "failed":
                return "error-100";
            case "pending":
                return "inverse-100";
            default:
                return "accent-100";
        }
    }
};
$dcf011bb2ab65e1c$export$98664c16c41f47e3.styles = [
    (0, $8ZOjA.default)
];
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)()
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "type", void 0);
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)()
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "status", void 0);
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)()
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "direction", void 0);
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "onlyDirectionIcon", void 0);
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "images", void 0);
$dcf011bb2ab65e1c$var$__decorate([
    (0, $kRRY9.property)({
        type: Object
    })
], $dcf011bb2ab65e1c$export$98664c16c41f47e3.prototype, "secondImage", void 0);
$dcf011bb2ab65e1c$export$98664c16c41f47e3 = $dcf011bb2ab65e1c$var$__decorate([
    (0, $33Xir.customElement)("wui-transaction-visual")
], $dcf011bb2ab65e1c$export$98664c16c41f47e3);

});
parcelRegister("8ZOjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $68cb0cb9939432e1$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $68cb0cb9939432e1$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host > wui-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-005);
  }

  :host > wui-flex wui-image {
    display: block;
    z-index: -1;
  }

  :host > wui-flex,
  :host > wui-flex wui-image,
  .swap-images-container,
  .swap-images-container.nft,
  wui-image.nft {
    border-top-left-radius: var(--local-left-border-radius);
    border-top-right-radius: var(--local-right-border-radius);
    border-bottom-left-radius: var(--local-left-border-radius);
    border-bottom-right-radius: var(--local-right-border-radius);
  }

  wui-icon {
    width: 20px;
    height: 20px;
  }

  wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }

  .swap-images-container {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .swap-images-container wui-image:first-child {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0%;
    clip-path: inset(0px calc(50% + 2px) 0px 0%);
  }

  .swap-images-container wui-image:last-child {
    clip-path: inset(0px 0px 0px calc(50% + 2px));
  }
`;

});


parcelRegister("Pru0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $09aa1517702ed6ec$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $09aa1517702ed6ec$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host > wui-flex:first-child {
    align-items: center;
    column-gap: var(--wui-spacing-s);
    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);
    width: 100%;
  }

  :host > wui-flex:first-child wui-text:nth-child(1) {
    text-transform: capitalize;
  }

  wui-transaction-visual {
    width: 40px;
    height: 40px;
  }

  wui-flex {
    flex: 1;
  }

  :host wui-flex wui-flex {
    overflow: hidden;
  }

  :host .description-container wui-text span {
    word-break: break-all;
  }

  :host .description-container wui-text {
    overflow: hidden;
  }

  :host .description-separator-icon {
    margin: 0px 6px;
  }

  :host wui-text > span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;

});


parcelRegister("iFdxB", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItemLoader", () => $d9668f4760d6ea41$export$994c2d15662c37cc);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");

var $33Xir = parcelRequire("33Xir");

var $hCS0p = parcelRequire("hCS0p");
parcelRequire("64e2j");
parcelRequire("iY2T0");

var $3Ozj7 = parcelRequire("3Ozj7");
var $d9668f4760d6ea41$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d9668f4760d6ea41$export$994c2d15662c37cc = class WuiTransactionListItemLoader extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
    }
};
$d9668f4760d6ea41$export$994c2d15662c37cc.styles = [
    (0, $hCS0p.resetStyles),
    (0, $3Ozj7.default)
];
$d9668f4760d6ea41$export$994c2d15662c37cc = $d9668f4760d6ea41$var$__decorate([
    (0, $33Xir.customElement)("wui-transaction-list-item-loader")
], $d9668f4760d6ea41$export$994c2d15662c37cc);

});
parcelRegister("3Ozj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c716de5605e9ed1$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $2c716de5605e9ed1$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host > wui-flex:first-child {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
  }

  wui-flex {
    display: flex;
    flex: 1;
  }
`;

});


parcelRegister("eZwNa", function(module, exports) {

$parcel$export(module.exports, "WuiListWallet", () => $aea032ff84e0a45e$export$fe01be9b7ff81a09);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("8lemW");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("ixPM7");
parcelRequire("5Vkr9");
parcelRequire("dTlfF");

var $kAdr1 = parcelRequire("kAdr1");
var $aea032ff84e0a45e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $aea032ff84e0a45e$export$fe01be9b7ff81a09 = class WuiListWallet extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
        this.imageSrc = "";
        this.name = "";
        this.installed = false;
        this.disabled = false;
        this.showAllWallets = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateAllWallets()} ${this.templateWalletImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
        ${this.templateStatus()}
      </button>
    `;
    }
    templateAllWallets() {
        if (this.showAllWallets && this.imageSrc) return (0, $8AeG9.html)` <wui-all-wallets-image .imageeSrc=${this.imageSrc}> </wui-all-wallets-image> `;
        else if (this.showAllWallets && this.walletIcon) return (0, $8AeG9.html)` <wui-wallet-image .walletIcon=${this.walletIcon} size="sm"> </wui-wallet-image> `;
        return null;
    }
    templateWalletImage() {
        if (!this.showAllWallets && this.imageSrc) return (0, $8AeG9.html)`<wui-wallet-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
        .installed=${this.installed}
      ></wui-wallet-image>`;
        else if (!this.showAllWallets && !this.imageSrc) return (0, $8AeG9.html)`<wui-wallet-image size="sm" name=${this.name}></wui-wallet-image>`;
        return null;
    }
    templateStatus() {
        if (this.tagLabel && this.tagVariant) return (0, $8AeG9.html)`<wui-tag variant=${this.tagVariant}>${this.tagLabel}</wui-tag>`;
        else if (this.icon) return (0, $8AeG9.html)`<wui-icon color="inherit" size="sm" name=${this.icon}></wui-icon>`;
        return null;
    }
};
$aea032ff84e0a45e$export$fe01be9b7ff81a09.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $kAdr1.default)
];
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "walletImages", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "imageSrc", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "name", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "tagLabel", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "tagVariant", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "icon", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)()
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "walletIcon", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "installed", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "disabled", void 0);
$aea032ff84e0a45e$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $aea032ff84e0a45e$export$fe01be9b7ff81a09.prototype, "showAllWallets", void 0);
$aea032ff84e0a45e$export$fe01be9b7ff81a09 = $aea032ff84e0a45e$var$__decorate([
    (0, $33Xir.customElement)("wui-list-wallet")
], $aea032ff84e0a45e$export$fe01be9b7ff81a09);

});
parcelRegister("5Vkr9", function(module, exports) {

$parcel$export(module.exports, "WuiTag", () => $450220fad6ba0dd4$export$989e5aad4666150);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $cqqE0 = parcelRequire("cqqE0");
var $450220fad6ba0dd4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $450220fad6ba0dd4$export$989e5aad4666150 = class WuiTag extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "main";
    }
    render() {
        this.dataset["variant"] = this.variant;
        return (0, $8AeG9.html)`
      <wui-text data-variant=${this.variant} variant="micro-700" color="inherit">
        <slot></slot>
      </wui-text>
    `;
    }
};
$450220fad6ba0dd4$export$989e5aad4666150.styles = [
    (0, $hCS0p.resetStyles),
    (0, $cqqE0.default)
];
$450220fad6ba0dd4$var$__decorate([
    (0, $kRRY9.property)()
], $450220fad6ba0dd4$export$989e5aad4666150.prototype, "variant", void 0);
$450220fad6ba0dd4$export$989e5aad4666150 = $450220fad6ba0dd4$var$__decorate([
    (0, $33Xir.customElement)("wui-tag")
], $450220fad6ba0dd4$export$989e5aad4666150);

});
parcelRegister("cqqE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bc94bd661c388f$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $90bc94bd661c388f$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    padding: 3.5px 5px !important;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host([data-variant='main']) {
    background-color: var(--wui-accent-glass-015);
    color: var(--wui-color-accent-100);
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  :host([data-variant='success']) {
    background-color: var(--wui-icon-box-bg-success-100);
    color: var(--wui-color-success-100);
  }

  :host([data-variant='error']) {
    background-color: var(--wui-icon-box-bg-error-100);
    color: var(--wui-color-error-100);
  }
`;

});


parcelRegister("kAdr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc197549666daac$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $efc197549666daac$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("fh2KG", function(module, exports) {

$parcel$export(module.exports, "WuiLogoSelect", () => $b1ea94093e79e795$export$aadc276ee48f1572);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("hxyvY");

var $eo21i = parcelRequire("eo21i");
var $b1ea94093e79e795$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b1ea94093e79e795$export$aadc276ee48f1572 = class WuiLogoSelect extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
        this.disabled = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
      </button>
    `;
    }
};
$b1ea94093e79e795$export$aadc276ee48f1572.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $eo21i.default)
];
$b1ea94093e79e795$var$__decorate([
    (0, $kRRY9.property)()
], $b1ea94093e79e795$export$aadc276ee48f1572.prototype, "logo", void 0);
$b1ea94093e79e795$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $b1ea94093e79e795$export$aadc276ee48f1572.prototype, "disabled", void 0);
$b1ea94093e79e795$export$aadc276ee48f1572 = $b1ea94093e79e795$var$__decorate([
    (0, $33Xir.customElement)("wui-logo-select")
], $b1ea94093e79e795$export$aadc276ee48f1572);

});
parcelRegister("hxyvY", function(module, exports) {

$parcel$export(module.exports, "WuiLogo", () => $cc504a9f9822a894$export$e515c2183ed1fdbc);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $jOCWW = parcelRequire("jOCWW");
var $cc504a9f9822a894$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cc504a9f9822a894$export$e515c2183ed1fdbc = class WuiLogo extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
    }
    render() {
        return (0, $8AeG9.html)`<wui-icon color="inherit" size="inherit" name=${this.logo}></wui-icon> `;
    }
};
$cc504a9f9822a894$export$e515c2183ed1fdbc.styles = [
    (0, $hCS0p.resetStyles),
    (0, $jOCWW.default)
];
$cc504a9f9822a894$var$__decorate([
    (0, $kRRY9.property)()
], $cc504a9f9822a894$export$e515c2183ed1fdbc.prototype, "logo", void 0);
$cc504a9f9822a894$export$e515c2183ed1fdbc = $cc504a9f9822a894$var$__decorate([
    (0, $33Xir.customElement)("wui-logo")
], $cc504a9f9822a894$export$e515c2183ed1fdbc);

});
parcelRegister("jOCWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d0e67193b4078e$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $e6d0e67193b4078e$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-010);
    overflow: hidden;
  }

  wui-icon {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("eo21i", function(module, exports) {

$parcel$export(module.exports, "default", () => $a794dfb242af88b6$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $a794dfb242af88b6$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
  }

  button {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("9Zob9", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkButton", () => $745c90fedab78187$export$bb00a3a9463dc4a7);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("6GKXg");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("8lemW");

var $eMELj = parcelRequire("eMELj");
var $745c90fedab78187$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $745c90fedab78187$export$bb00a3a9463dc4a7 = class WuiNetworkButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.disabled = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <button ?disabled=${this.disabled}>
        ${this.visualTemplate()}
        <wui-text variant="paragraph-600" color="inherit">
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    visualTemplate() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $8AeG9.html)`
      <wui-icon-box
        size="sm"
        iconColor="inverse-100"
        backgroundColor="fg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$745c90fedab78187$export$bb00a3a9463dc4a7.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $eMELj.default)
];
$745c90fedab78187$var$__decorate([
    (0, $kRRY9.property)()
], $745c90fedab78187$export$bb00a3a9463dc4a7.prototype, "imageSrc", void 0);
$745c90fedab78187$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $745c90fedab78187$export$bb00a3a9463dc4a7.prototype, "disabled", void 0);
$745c90fedab78187$export$bb00a3a9463dc4a7 = $745c90fedab78187$var$__decorate([
    (0, $33Xir.customElement)("wui-network-button")
], $745c90fedab78187$export$bb00a3a9463dc4a7);

});
parcelRegister("eMELj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac352ae1c431bd15$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ac352ae1c431bd15$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-gray-glass-005);
    color: var(--wui-color-fg-100);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-010);
    }

    button:active:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }
`;

});


parcelRegister("gcK7E", function(module, exports) {

$parcel$export(module.exports, "WuiOtp", () => $bcc18b4cefd07c05$export$443bf27d3bf7bc18);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");
parcelRequire("lIOMa");

var $32iqa = parcelRequire("32iqa");
var $bcc18b4cefd07c05$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bcc18b4cefd07c05$export$443bf27d3bf7bc18 = class WuiOtp extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.length = 6;
        this.otp = "";
        this.values = Array.from({
            length: this.length
        }).map(()=>"");
        this.numerics = [];
        this.shouldInputBeEnabled = (index)=>{
            const previousInputs = this.values.slice(0, index);
            return previousInputs.every((input)=>input !== "");
        };
        this.handleKeyDown = (e, index)=>{
            const inputElement = e.target;
            const input = this.getInputElement(inputElement);
            const keyArr = [
                "ArrowLeft",
                "ArrowRight",
                "Shift",
                "Delete"
            ];
            if (!input) return;
            if (keyArr.includes(e.key)) e.preventDefault();
            const currentCaretPos = input.selectionStart;
            switch(e.key){
                case "ArrowLeft":
                    if (currentCaretPos) input.setSelectionRange(currentCaretPos + 1, currentCaretPos + 1);
                    this.focusInputField("prev", index);
                    break;
                case "ArrowRight":
                    this.focusInputField("next", index);
                    break;
                case "Shift":
                    this.focusInputField("next", index);
                    break;
                case "Delete":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                case "Backspace":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                default:
            }
        };
        this.focusInputField = (dir, index)=>{
            if (dir === "next") {
                const nextIndex = index + 1;
                if (!this.shouldInputBeEnabled(nextIndex)) return;
                const numeric = this.numerics[nextIndex < this.length ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) {
                    input.disabled = false;
                    input.focus();
                }
            }
            if (dir === "prev") {
                const nextIndex = index - 1;
                const numeric = this.numerics[nextIndex > -1 ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) input.focus();
            }
        };
    }
    firstUpdated() {
        if (this.otp) this.values = this.otp.split("");
        const numericElements = this.shadowRoot?.querySelectorAll("wui-input-numeric");
        if (numericElements) this.numerics = Array.from(numericElements);
        this.numerics[0]?.focus();
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex gap="xxs" data-testid="wui-otp-input">
        ${Array.from({
            length: this.length
        }).map((_, index)=>(0, $8AeG9.html)`
            <wui-input-numeric
              @input=${(e)=>this.handleInput(e, index)}
              @keydown=${(e)=>this.handleKeyDown(e, index)}
              .disabled=${!this.shouldInputBeEnabled(index)}
              .value=${this.values[index] || ""}
            >
            </wui-input-numeric>
          `)}
      </wui-flex>
    `;
    }
    updateInput(element, index, value) {
        const numeric = this.numerics[index];
        const input = element || (numeric ? this.getInputElement(numeric) : undefined);
        if (input) {
            input.value = value;
            this.values = this.values.map((val, i)=>i === index ? value : val);
        }
    }
    handleInput(e, index) {
        const inputElement = e.target;
        const input = this.getInputElement(inputElement);
        if (input) {
            const inputValue = input.value;
            if (e.inputType === "insertFromPaste") this.handlePaste(input, inputValue, index);
            else {
                const isValid = (0, $8iLLL.UiHelperUtil).isNumber(inputValue);
                if (isValid && e.data) {
                    this.updateInput(input, index, e.data);
                    this.focusInputField("next", index);
                } else this.updateInput(input, index, "");
            }
        }
        this.dispatchInputChangeEvent();
    }
    handlePaste(input, inputValue, index) {
        const value = inputValue[0];
        const isValid = value && (0, $8iLLL.UiHelperUtil).isNumber(value);
        if (isValid) {
            this.updateInput(input, index, value);
            const inputString = inputValue.substring(1);
            if (index + 1 < this.length && inputString.length) {
                const nextNumeric = this.numerics[index + 1];
                const nextInput = nextNumeric ? this.getInputElement(nextNumeric) : undefined;
                if (nextInput) this.handlePaste(nextInput, inputString, index + 1);
            } else this.focusInputField("next", index);
        } else this.updateInput(input, index, "");
    }
    getInputElement(el) {
        if (el.shadowRoot?.querySelector("input")) return el.shadowRoot.querySelector("input");
        return null;
    }
    dispatchInputChangeEvent() {
        const value = this.values.join("");
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
};
$bcc18b4cefd07c05$export$443bf27d3bf7bc18.styles = [
    (0, $hCS0p.resetStyles),
    (0, $32iqa.default)
];
$bcc18b4cefd07c05$var$__decorate([
    (0, $kRRY9.property)({
        type: Number
    })
], $bcc18b4cefd07c05$export$443bf27d3bf7bc18.prototype, "length", void 0);
$bcc18b4cefd07c05$var$__decorate([
    (0, $kRRY9.property)({
        type: String
    })
], $bcc18b4cefd07c05$export$443bf27d3bf7bc18.prototype, "otp", void 0);
$bcc18b4cefd07c05$var$__decorate([
    (0, $dBBvD.state)()
], $bcc18b4cefd07c05$export$443bf27d3bf7bc18.prototype, "values", void 0);
$bcc18b4cefd07c05$export$443bf27d3bf7bc18 = $bcc18b4cefd07c05$var$__decorate([
    (0, $33Xir.customElement)("wui-otp")
], $bcc18b4cefd07c05$export$443bf27d3bf7bc18);

});
parcelRegister("32iqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $235fd9105d22e00a$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $235fd9105d22e00a$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: block;
  }
`;

});


parcelRegister("frCtt", function(module, exports) {

$parcel$export(module.exports, "WuiQrCode", () => $b3e738d96cb5655d$export$29f6e16532a663bf);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("6GKXg");

var $91HFk = parcelRequire("91HFk");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $2qECS = parcelRequire("2qECS");
var $b3e738d96cb5655d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b3e738d96cb5655d$export$29f6e16532a663bf = class WuiQrCode extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.uri = "";
        this.size = 0;
        this.theme = "dark";
        this.imageSrc = undefined;
        this.alt = undefined;
    }
    render() {
        this.dataset["theme"] = this.theme;
        this.style.cssText = `--local-size: ${this.size}px`;
        return (0, $8AeG9.html)`${this.templateVisual()} ${this.templateSvg()}`;
    }
    templateSvg() {
        const size = this.theme === "light" ? this.size : this.size - 32;
        return (0, $8AeG9.svg)`
      <svg height=${size} width=${size}>
        ${(0, $91HFk.QrCodeUtil).generate(this.uri, size, size / 4)}
      </svg>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "logo"}></wui-image>`;
        return (0, $8AeG9.html)`<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>`;
    }
};
$b3e738d96cb5655d$export$29f6e16532a663bf.styles = [
    (0, $hCS0p.resetStyles),
    (0, $2qECS.default)
];
$b3e738d96cb5655d$var$__decorate([
    (0, $kRRY9.property)()
], $b3e738d96cb5655d$export$29f6e16532a663bf.prototype, "uri", void 0);
$b3e738d96cb5655d$var$__decorate([
    (0, $kRRY9.property)({
        type: Number
    })
], $b3e738d96cb5655d$export$29f6e16532a663bf.prototype, "size", void 0);
$b3e738d96cb5655d$var$__decorate([
    (0, $kRRY9.property)()
], $b3e738d96cb5655d$export$29f6e16532a663bf.prototype, "theme", void 0);
$b3e738d96cb5655d$var$__decorate([
    (0, $kRRY9.property)()
], $b3e738d96cb5655d$export$29f6e16532a663bf.prototype, "imageSrc", void 0);
$b3e738d96cb5655d$var$__decorate([
    (0, $kRRY9.property)()
], $b3e738d96cb5655d$export$29f6e16532a663bf.prototype, "alt", void 0);
$b3e738d96cb5655d$export$29f6e16532a663bf = $b3e738d96cb5655d$var$__decorate([
    (0, $33Xir.customElement)("wui-qr-code")
], $b3e738d96cb5655d$export$29f6e16532a663bf);

});
parcelRegister("91HFk", function(module, exports) {

$parcel$export(module.exports, "QrCodeUtil", () => $6926141eaab7cfe9$export$2faef7998946735);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");

var $MPA2U = parcelRequire("MPA2U");
const $6926141eaab7cfe9$var$CONNECTING_ERROR_MARGIN = 0.1;
const $6926141eaab7cfe9$var$CIRCLE_SIZE_MODIFIER = 2.5;
const $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN = 7;
function $6926141eaab7cfe9$var$isAdjecentDots(cy, otherCy, cellSize) {
    if (cy === otherCy) return false;
    const diff = cy - otherCy < 0 ? otherCy - cy : cy - otherCy;
    return diff <= cellSize + $6926141eaab7cfe9$var$CONNECTING_ERROR_MARGIN;
}
function $6926141eaab7cfe9$var$getMatrix(value, errorCorrectionLevel) {
    const arr = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($MPA2U))).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index)=>(index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows, []);
}
const $6926141eaab7cfe9$export$2faef7998946735 = {
    generate (uri, size, logoSize) {
        const dotColor = "#141414";
        const edgeColor = "transparent";
        const strokeWidth = 5;
        const dots = [];
        const matrix = $6926141eaab7cfe9$var$getMatrix(uri, "Q");
        const cellSize = size / matrix.length;
        const qrList = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        qrList.forEach(({ x: x, y: y })=>{
            const x1 = (matrix.length - $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN) * cellSize * x;
            const y1 = (matrix.length - $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN) * cellSize * y;
            const borderRadius = 0.45;
            for(let i = 0; i < qrList.length; i += 1){
                const dotSize = cellSize * ($6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN - i * 2);
                dots.push((0, $8AeG9.svg)`
            <rect
              fill=${i === 2 ? dotColor : edgeColor}
              width=${i === 0 ? dotSize - strokeWidth : dotSize}
              rx= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              ry= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              stroke=${dotColor}
              stroke-width=${i === 0 ? strokeWidth : 0}
              height=${i === 0 ? dotSize - strokeWidth : dotSize}
              x= ${i === 0 ? y1 + cellSize * i + strokeWidth / 2 : y1 + cellSize * i}
              y= ${i === 0 ? x1 + cellSize * i + strokeWidth / 2 : x1 + cellSize * i}
            />
          `);
            }
        });
        const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
        const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        const circles = [];
        matrix.forEach((row, i)=>{
            row.forEach((_, j)=>{
                if (matrix[i][j]) {
                    if (!(i < $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN && j < $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN || i > matrix.length - ($6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN + 1) && j < $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN || i < $6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN && j > matrix.length - ($6926141eaab7cfe9$var$QRCODE_MATRIX_MARGIN + 1))) {
                        if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
                            const cx = i * cellSize + cellSize / 2;
                            const cy = j * cellSize + cellSize / 2;
                            circles.push([
                                cx,
                                cy
                            ]);
                        }
                    }
                }
            });
        });
        const circlesToConnect = {};
        circles.forEach(([cx, cy])=>{
            if (circlesToConnect[cx]) circlesToConnect[cx]?.push(cy);
            else circlesToConnect[cx] = [
                cy
            ];
        });
        Object.entries(circlesToConnect).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.every((otherCy)=>!$6926141eaab7cfe9$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).forEach(([cx, cys])=>{
            cys.forEach((cy)=>{
                dots.push((0, $8AeG9.svg)`<circle cx=${cx} cy=${cy} fill=${dotColor} r=${cellSize / $6926141eaab7cfe9$var$CIRCLE_SIZE_MODIFIER} />`);
            });
        });
        Object.entries(circlesToConnect).filter(([_, cys])=>cys.length > 1).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.some((otherCy)=>$6926141eaab7cfe9$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).map(([cx, cys])=>{
            cys.sort((a, b)=>a < b ? -1 : 1);
            const groups = [];
            for (const cy of cys){
                const group = groups.find((item)=>item.some((otherCy)=>$6926141eaab7cfe9$var$isAdjecentDots(cy, otherCy, cellSize)));
                if (group) group.push(cy);
                else groups.push([
                    cy
                ]);
            }
            return [
                cx,
                groups.map((item)=>[
                        item[0],
                        item[item.length - 1]
                    ])
            ];
        }).forEach(([cx, groups])=>{
            groups.forEach(([y1, y2])=>{
                dots.push((0, $8AeG9.svg)`
              <line
                x1=${cx}
                x2=${cx}
                y1=${y1}
                y2=${y2}
                stroke=${dotColor}
                stroke-width=${cellSize / ($6926141eaab7cfe9$var$CIRCLE_SIZE_MODIFIER / 2)}
                stroke-linecap="round"
              />
            `);
            });
        });
        return dots;
    }
};

});
parcelRegister("MPA2U", function(module, exports) {

$parcel$export(module.exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export(module.exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export(module.exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export(module.exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;

var $jLEcc = parcelRequire("jLEcc");

var $8an4w = parcelRequire("8an4w");

var $7bRLF = parcelRequire("7bRLF");

var $4dczE = parcelRequire("4dczE");
function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$jLEcc()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $8an4w.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $8an4w.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $8an4w.create;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $7bRLF.render);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $7bRLF.renderToDataURL);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $4dczE.render(data, opts);
});

});
parcelRegister("jLEcc", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("8an4w", function(module, exports) {

$parcel$export(module.exports, "create", () => $5f2127839fe01a16$export$185802fd694ee1f5, (v) => $5f2127839fe01a16$export$185802fd694ee1f5 = v);
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;

var $gAPR2 = parcelRequire("gAPR2");

var $i2Grt = parcelRequire("i2Grt");

var $2Yr7q = parcelRequire("2Yr7q");

var $59qyF = parcelRequire("59qyF");

var $gEXbH = parcelRequire("gEXbH");

var $fuRP0 = parcelRequire("fuRP0");

var $2EgxG = parcelRequire("2EgxG");

var $aWGUA = parcelRequire("aWGUA");

var $ziz9l = parcelRequire("ziz9l");

var $1ILJK = parcelRequire("1ILJK");

var $2HRKe = parcelRequire("2HRKe");

var $2UpRK = parcelRequire("2UpRK");

var $zJRcv = parcelRequire("zJRcv");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $fuRP0.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $gEXbH.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $1ILJK.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $2HRKe.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $2Yr7q();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $2UpRK.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $aWGUA.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $ziz9l(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $zJRcv.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $zJRcv.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $1ILJK.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $zJRcv.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $1ILJK.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $gAPR2.getSymbolSize(version);
    const modules = new $59qyF(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $2EgxG.getBestMask(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $2EgxG.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $i2Grt.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $i2Grt.from(options.errorCorrectionLevel, $i2Grt.M);
        version = $1ILJK.from(options.version);
        mask = $2EgxG.from(options.maskPattern);
        if (options.toSJISFunc) $gAPR2.setToSJISFunction(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("gAPR2", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", () => $c1483b5b1305278f$export$8d4a06d3facd414b, (v) => $c1483b5b1305278f$export$8d4a06d3facd414b = v);
$parcel$export(module.exports, "getSymbolTotalCodewords", () => $c1483b5b1305278f$export$b05dac13c7a35c32, (v) => $c1483b5b1305278f$export$b05dac13c7a35c32 = v);
$parcel$export(module.exports, "getBCHDigit", () => $c1483b5b1305278f$export$ed1d66da50968976, (v) => $c1483b5b1305278f$export$ed1d66da50968976 = v);
$parcel$export(module.exports, "setToSJISFunction", () => $c1483b5b1305278f$export$6733b14783f975c2, (v) => $c1483b5b1305278f$export$6733b14783f975c2 = v);
$parcel$export(module.exports, "isKanjiModeEnabled", () => $c1483b5b1305278f$export$ce5b1274f8597fa0, (v) => $c1483b5b1305278f$export$ce5b1274f8597fa0 = v);
$parcel$export(module.exports, "toSJIS", () => $c1483b5b1305278f$export$43dd553ecded716d, (v) => $c1483b5b1305278f$export$43dd553ecded716d = v);
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};

});

parcelRegister("i2Grt", function(module, exports) {

$parcel$export(module.exports, "L", () => $d22956012916b666$export$61196ced6d74a310, (v) => $d22956012916b666$export$61196ced6d74a310 = v);
$parcel$export(module.exports, "M", () => $d22956012916b666$export$3a1a48c8f6ef640e, (v) => $d22956012916b666$export$3a1a48c8f6ef640e = v);
$parcel$export(module.exports, "Q", () => $d22956012916b666$export$3722cfe417b6ed86, (v) => $d22956012916b666$export$3722cfe417b6ed86 = v);
$parcel$export(module.exports, "H", () => $d22956012916b666$export$7f8ddf7c7c20b3cd, (v) => $d22956012916b666$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "isValid", () => $d22956012916b666$export$1ea939691cdc45b8, (v) => $d22956012916b666$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $d22956012916b666$export$6788812c4e6611e6, (v) => $d22956012916b666$export$6788812c4e6611e6 = v);
var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("2Yr7q", function(module, exports) {
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $22a6389bcfc83921$var$BitBuffer;

});

parcelRegister("59qyF", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $3c0264e2c9c64d36$var$BitMatrix;

});

parcelRegister("gEXbH", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", () => $c20e4b3185223698$export$cb05537eb8e57a83, (v) => $c20e4b3185223698$export$cb05537eb8e57a83 = v);
$parcel$export(module.exports, "getPositions", () => $c20e4b3185223698$export$c39457c570f2b189, (v) => $c20e4b3185223698$export$c39457c570f2b189 = v);
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $gAPR2 = parcelRequire("gAPR2");
var $c20e4b3185223698$require$getSymbolSize = $gAPR2.getSymbolSize;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("fuRP0", function(module, exports) {

$parcel$export(module.exports, "getPositions", () => $b4836838cc492349$export$c39457c570f2b189, (v) => $b4836838cc492349$export$c39457c570f2b189 = v);
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $gAPR2 = parcelRequire("gAPR2");
var $b4836838cc492349$require$getSymbolSize = $gAPR2.getSymbolSize;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("2EgxG", function(module, exports) {

$parcel$export(module.exports, "Patterns", () => $1edc2624fba191d0$export$7ed115685df827af, (v) => $1edc2624fba191d0$export$7ed115685df827af = v);
$parcel$export(module.exports, "isValid", () => $1edc2624fba191d0$export$1ea939691cdc45b8, (v) => $1edc2624fba191d0$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $1edc2624fba191d0$export$6788812c4e6611e6, (v) => $1edc2624fba191d0$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getPenaltyN1", () => $1edc2624fba191d0$export$a5fd3a02c14d0b3e, (v) => $1edc2624fba191d0$export$a5fd3a02c14d0b3e = v);
$parcel$export(module.exports, "getPenaltyN2", () => $1edc2624fba191d0$export$9a9385107a518e46, (v) => $1edc2624fba191d0$export$9a9385107a518e46 = v);
$parcel$export(module.exports, "getPenaltyN3", () => $1edc2624fba191d0$export$ade754353f0dc75e, (v) => $1edc2624fba191d0$export$ade754353f0dc75e = v);
$parcel$export(module.exports, "getPenaltyN4", () => $1edc2624fba191d0$export$3ff6f04d40d9962b, (v) => $1edc2624fba191d0$export$3ff6f04d40d9962b = v);
$parcel$export(module.exports, "applyMask", () => $1edc2624fba191d0$export$a1c9aa9c0e8ba394, (v) => $1edc2624fba191d0$export$a1c9aa9c0e8ba394 = v);
$parcel$export(module.exports, "getBestMask", () => $1edc2624fba191d0$export$fe9625aaceb0e563, (v) => $1edc2624fba191d0$export$fe9625aaceb0e563 = v);
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("aWGUA", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", () => $7f809b8d8966b945$export$41a1fc627aca72b9, (v) => $7f809b8d8966b945$export$41a1fc627aca72b9 = v);
$parcel$export(module.exports, "getTotalCodewordsCount", () => $7f809b8d8966b945$export$683d1b3e8a1a8438, (v) => $7f809b8d8966b945$export$683d1b3e8a1a8438 = v);
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

var $i2Grt = parcelRequire("i2Grt");
const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $i2Grt.L:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $i2Grt.M:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $i2Grt.Q:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $i2Grt.H:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $i2Grt.L:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $i2Grt.M:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $i2Grt.Q:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $i2Grt.H:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("ziz9l", function(module, exports) {

var $cPckW = parcelRequire("cPckW");
function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $cPckW.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $cPckW.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $06a1abce65162dc0$var$ReedSolomonEncoder;

});
parcelRegister("cPckW", function(module, exports) {

$parcel$export(module.exports, "mul", () => $9563d144998a4c78$export$6e3a27864ab166fe, (v) => $9563d144998a4c78$export$6e3a27864ab166fe = v);
$parcel$export(module.exports, "mod", () => $9563d144998a4c78$export$842a2cf37af977e1, (v) => $9563d144998a4c78$export$842a2cf37af977e1 = v);
$parcel$export(module.exports, "generateECPolynomial", () => $9563d144998a4c78$export$7b8be06a973a9d05, (v) => $9563d144998a4c78$export$7b8be06a973a9d05 = v);
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;

var $a5KSf = parcelRequire("a5KSf");
$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $a5KSf.mul(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $a5KSf.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $a5KSf.exp(i)
    ]));
    return poly;
};

});
parcelRegister("a5KSf", function(module, exports) {

$parcel$export(module.exports, "exp", () => $758ebb328fd03b3c$export$b310ec824aaee37f, (v) => $758ebb328fd03b3c$export$b310ec824aaee37f = v);
$parcel$export(module.exports, "mul", () => $758ebb328fd03b3c$export$6e3a27864ab166fe, (v) => $758ebb328fd03b3c$export$6e3a27864ab166fe = v);
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};

});



parcelRegister("1ILJK", function(module, exports) {

$parcel$export(module.exports, "getCapacity", () => $140eee110ea3b5f9$export$55b283886ec2d3fb, (v) => $140eee110ea3b5f9$export$55b283886ec2d3fb = v);
$parcel$export(module.exports, "from", () => $140eee110ea3b5f9$export$6788812c4e6611e6, (v) => $140eee110ea3b5f9$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getBestVersionForData", () => $140eee110ea3b5f9$export$264e969aa7a8ff7e, (v) => $140eee110ea3b5f9$export$264e969aa7a8ff7e = v);
$parcel$export(module.exports, "getEncodedBits", () => $140eee110ea3b5f9$export$eee5438974ef6f0e, (v) => $140eee110ea3b5f9$export$eee5438974ef6f0e = v);
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;

var $gAPR2 = parcelRequire("gAPR2");

var $aWGUA = parcelRequire("aWGUA");

var $i2Grt = parcelRequire("i2Grt");

var $2UpRK = parcelRequire("2UpRK");

var $aUgu3 = parcelRequire("aUgu3");
// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $gAPR2.getBCHDigit($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $2UpRK.getCharCountIndicator(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $2UpRK.MIXED)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($aUgu3.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$aUgu3.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $2UpRK.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $gAPR2.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $aWGUA.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $2UpRK.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $2UpRK.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $2UpRK.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $2UpRK.KANJI:
            return Math.floor(usableBits / 13);
        case $2UpRK.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $i2Grt.from(errorCorrectionLevel, $i2Grt.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$aUgu3.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($gAPR2.getBCHDigit(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $gAPR2.getBCHDigit(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("2UpRK", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", () => $21e4e023abb588c2$export$4d318981b5a83836, (v) => $21e4e023abb588c2$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $21e4e023abb588c2$export$376a9ed239d6c1c8, (v) => $21e4e023abb588c2$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "BYTE", () => $21e4e023abb588c2$export$8f4bf8f7eb581284, (v) => $21e4e023abb588c2$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "KANJI", () => $21e4e023abb588c2$export$a4d452c2363c8e12, (v) => $21e4e023abb588c2$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "MIXED", () => $21e4e023abb588c2$export$bb410559a65d3418, (v) => $21e4e023abb588c2$export$bb410559a65d3418 = v);
$parcel$export(module.exports, "getCharCountIndicator", () => $21e4e023abb588c2$export$e79764af6ffaeb8d, (v) => $21e4e023abb588c2$export$e79764af6ffaeb8d = v);
$parcel$export(module.exports, "getBestModeForData", () => $21e4e023abb588c2$export$1bd4c93ffb42e55e, (v) => $21e4e023abb588c2$export$1bd4c93ffb42e55e = v);
$parcel$export(module.exports, "toString", () => $21e4e023abb588c2$export$f84e8e69fd4488a5, (v) => $21e4e023abb588c2$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isValid", () => $21e4e023abb588c2$export$1ea939691cdc45b8, (v) => $21e4e023abb588c2$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $21e4e023abb588c2$export$6788812c4e6611e6, (v) => $21e4e023abb588c2$export$6788812c4e6611e6 = v);
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;

var $aUgu3 = parcelRequire("aUgu3");

var $if0aV = parcelRequire("if0aV");
$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$aUgu3.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($if0aV.testNumeric(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($if0aV.testAlphanumeric(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($if0aV.testKanji(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("aUgu3", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $7f0bebb05133540b$export$1ea939691cdc45b8, (v) => $7f0bebb05133540b$export$1ea939691cdc45b8 = v);
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("if0aV", function(module, exports) {

$parcel$export(module.exports, "KANJI", () => $d479c387334094fb$export$a4d452c2363c8e12, (v) => $d479c387334094fb$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "BYTE_KANJI", () => $d479c387334094fb$export$9df7c29d562bab83, (v) => $d479c387334094fb$export$9df7c29d562bab83 = v);
$parcel$export(module.exports, "BYTE", () => $d479c387334094fb$export$8f4bf8f7eb581284, (v) => $d479c387334094fb$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "NUMERIC", () => $d479c387334094fb$export$4d318981b5a83836, (v) => $d479c387334094fb$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $d479c387334094fb$export$376a9ed239d6c1c8, (v) => $d479c387334094fb$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "testKanji", () => $d479c387334094fb$export$175f16aef75a4569, (v) => $d479c387334094fb$export$175f16aef75a4569 = v);
$parcel$export(module.exports, "testNumeric", () => $d479c387334094fb$export$50b7f9bf92c74274, (v) => $d479c387334094fb$export$50b7f9bf92c74274 = v);
$parcel$export(module.exports, "testAlphanumeric", () => $d479c387334094fb$export$4ba5f52893b4ac97, (v) => $d479c387334094fb$export$4ba5f52893b4ac97 = v);
var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("2HRKe", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", () => $1f894980312e7d2a$export$eee5438974ef6f0e, (v) => $1f894980312e7d2a$export$eee5438974ef6f0e = v);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

var $gAPR2 = parcelRequire("gAPR2");
const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $gAPR2.getBCHDigit($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($gAPR2.getBCHDigit(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $gAPR2.getBCHDigit(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};

});

parcelRegister("zJRcv", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $06b6d7424b9df2df$export$571d59b505e6bb4e, (v) => $06b6d7424b9df2df$export$571d59b505e6bb4e = v);
$parcel$export(module.exports, "fromString", () => $06b6d7424b9df2df$export$3004f64547af360e, (v) => $06b6d7424b9df2df$export$3004f64547af360e = v);
$parcel$export(module.exports, "rawSplit", () => $06b6d7424b9df2df$export$89ab1afb9839589b, (v) => $06b6d7424b9df2df$export$89ab1afb9839589b = v);
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $2UpRK = parcelRequire("2UpRK");

var $avjb5 = parcelRequire("avjb5");

var $l9d7a = parcelRequire("l9d7a");

var $6aVeG = parcelRequire("6aVeG");

var $8NLQr = parcelRequire("8NLQr");

var $if0aV = parcelRequire("if0aV");

var $gAPR2 = parcelRequire("gAPR2");

var $9hr6W = parcelRequire("9hr6W");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($if0aV.NUMERIC, $2UpRK.NUMERIC, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($if0aV.ALPHANUMERIC, $2UpRK.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($gAPR2.isKanjiModeEnabled()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($if0aV.BYTE, $2UpRK.BYTE, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($if0aV.KANJI, $2UpRK.KANJI, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($if0aV.BYTE_KANJI, $2UpRK.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $2UpRK.NUMERIC:
            return $avjb5.getBitsLength(length);
        case $2UpRK.ALPHANUMERIC:
            return $l9d7a.getBitsLength(length);
        case $2UpRK.KANJI:
            return $8NLQr.getBitsLength(length);
        case $2UpRK.BYTE:
            return $6aVeG.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $2UpRK.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $2UpRK.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $2UpRK.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $2UpRK.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $2UpRK.BYTE,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $2UpRK.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $2UpRK.getBestModeForData(data);
    mode = $2UpRK.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $2UpRK.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $2UpRK.toString(mode) + ".\n Suggested mode is: " + $2UpRK.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $2UpRK.KANJI && !$gAPR2.isKanjiModeEnabled()) mode = $2UpRK.BYTE;
    switch(mode){
        case $2UpRK.NUMERIC:
            return new $avjb5(data);
        case $2UpRK.ALPHANUMERIC:
            return new $l9d7a(data);
        case $2UpRK.KANJI:
            return new $8NLQr(data);
        case $2UpRK.BYTE:
            return new $6aVeG(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $gAPR2.isKanjiModeEnabled());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $9hr6W.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $gAPR2.isKanjiModeEnabled()));
};

});
parcelRegister("avjb5", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");
function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $2UpRK.NUMERIC;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $7a5bacf4a539441d$var$NumericData;

});

parcelRegister("l9d7a", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $2UpRK.ALPHANUMERIC;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $f6549c884fd9ace3$var$AlphanumericData;

});

parcelRegister("6aVeG", function(module, exports) {

var $fB3iO = parcelRequire("fB3iO");

var $2UpRK = parcelRequire("2UpRK");
function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $2UpRK.BYTE;
    if (typeof data === "string") data = $fB3iO(data);
    this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $47f01312d66828cb$var$ByteData;

});
parcelRegister("fB3iO", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("8NLQr", function(module, exports) {

var $2UpRK = parcelRequire("2UpRK");

var $gAPR2 = parcelRequire("gAPR2");
function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $2UpRK.KANJI;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $gAPR2.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $668803520f2d7445$var$KanjiData;

});

parcelRegister("9hr6W", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $6c1abb425b529163$var$dijkstra;

});



parcelRegister("7bRLF", function(module, exports) {

$parcel$export(module.exports, "render", () => $53c344a5283c422c$export$b3890eb0ae9dca99, (v) => $53c344a5283c422c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "renderToDataURL", () => $53c344a5283c422c$export$c3e5526bbaf70a25, (v) => $53c344a5283c422c$export$c3e5526bbaf70a25 = v);
var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;

var $hdBDw = parcelRequire("hdBDw");
function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $hdBDw.getOptions(opts);
    const size = $hdBDw.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $hdBDw.qrToImageData(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("hdBDw", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $c890d85f31194258$export$d2312e68e1f5ad00, (v) => $c890d85f31194258$export$d2312e68e1f5ad00 = v);
$parcel$export(module.exports, "getScale", () => $c890d85f31194258$export$5cdac61cf538712e, (v) => $c890d85f31194258$export$5cdac61cf538712e = v);
$parcel$export(module.exports, "getImageWidth", () => $c890d85f31194258$export$c3a1a1f268a8142b, (v) => $c890d85f31194258$export$c3a1a1f268a8142b = v);
$parcel$export(module.exports, "qrToImageData", () => $c890d85f31194258$export$83136f57c739c5f3, (v) => $c890d85f31194258$export$83136f57c739c5f3 = v);
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("4dczE", function(module, exports) {

$parcel$export(module.exports, "render", () => $3112213e4acbe245$export$b3890eb0ae9dca99, (v) => $3112213e4acbe245$export$b3890eb0ae9dca99 = v);
var $3112213e4acbe245$export$b3890eb0ae9dca99;

var $hdBDw = parcelRequire("hdBDw");
function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $hdBDw.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("2qECS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4d85f7f4140d23$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $1c4d85f7f4140d23$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    user-select: none;
    display: block;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    width: var(--local-size);
  }

  :host([data-theme='dark']) {
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);
    background-color: var(--wui-color-inverse-100);
    padding: var(--wui-spacing-l);
  }

  :host([data-theme='light']) {
    box-shadow: 0 0 0 1px var(--wui-color-bg-125);
    background-color: var(--wui-color-bg-125);
  }

  svg:first-child,
  wui-image,
  wui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  wui-image {
    width: 25%;
    height: 25%;
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon {
    width: 100%;
    height: 100%;
    color: #3396ff !important;
    transform: translateY(-50%) translateX(-50%) scale(0.25);
  }
`;

});


parcelRegister("epvAl", function(module, exports) {

$parcel$export(module.exports, "WuiSearchBar", () => $a7dbe6a340124c48$export$208b8ce22c764062);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("i6b12");
var $fUwov = parcelRequire("fUwov");
parcelRequire("7zfrA");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("lX1F6");

var $1CEAC = parcelRequire("1CEAC");
var $a7dbe6a340124c48$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a7dbe6a340124c48$export$208b8ce22c764062 = class WuiSearchBar extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.inputComponentRef = (0, $fUwov.createRef)();
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-input-text
        ${(0, $fUwov.ref)(this.inputComponentRef)}
        placeholder="Search wallet"
        icon="search"
        type="search"
        enterKeyHint="search"
        size="sm"
      >
        <wui-input-element @click=${this.clearValue} icon="close"></wui-input-element>
      </wui-input-text>
    `;
    }
    clearValue() {
        const inputComponent = this.inputComponentRef.value;
        const inputElement = inputComponent?.inputElementRef.value;
        if (inputElement) {
            inputElement.value = "";
            inputElement.focus();
            inputElement.dispatchEvent(new Event("input"));
        }
    }
};
$a7dbe6a340124c48$export$208b8ce22c764062.styles = [
    (0, $hCS0p.resetStyles),
    (0, $1CEAC.default)
];
$a7dbe6a340124c48$export$208b8ce22c764062 = $a7dbe6a340124c48$var$__decorate([
    (0, $33Xir.customElement)("wui-search-bar")
], $a7dbe6a340124c48$export$208b8ce22c764062);

});
parcelRegister("1CEAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $12e8d3503907ea65$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $12e8d3503907ea65$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;

});


parcelRegister("izma1", function(module, exports) {

$parcel$export(module.exports, "WuiSnackbar", () => $d84caf85d0686836$export$864d710a9db8f7a3);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");
parcelRequire("8lemW");

var $jurVT = parcelRequire("jurVT");
var $d84caf85d0686836$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d84caf85d0686836$export$864d710a9db8f7a3 = class WuiSnackbar extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.icon = "checkmark";
        this.message = "";
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-icon-box
        size="sm"
        iconSize="xs"
        iconColor=${this.iconColor}
        backgroundColor=${this.backgroundColor}
        icon=${this.icon}
        background="opaque"
      ></wui-icon-box>
      <wui-text variant="paragraph-500" color="fg-100">${this.message}</wui-text>
    `;
    }
};
$d84caf85d0686836$export$864d710a9db8f7a3.styles = [
    (0, $hCS0p.resetStyles),
    (0, $jurVT.default)
];
$d84caf85d0686836$var$__decorate([
    (0, $kRRY9.property)()
], $d84caf85d0686836$export$864d710a9db8f7a3.prototype, "backgroundColor", void 0);
$d84caf85d0686836$var$__decorate([
    (0, $kRRY9.property)()
], $d84caf85d0686836$export$864d710a9db8f7a3.prototype, "iconColor", void 0);
$d84caf85d0686836$var$__decorate([
    (0, $kRRY9.property)()
], $d84caf85d0686836$export$864d710a9db8f7a3.prototype, "icon", void 0);
$d84caf85d0686836$var$__decorate([
    (0, $kRRY9.property)()
], $d84caf85d0686836$export$864d710a9db8f7a3.prototype, "message", void 0);
$d84caf85d0686836$export$864d710a9db8f7a3 = $d84caf85d0686836$var$__decorate([
    (0, $33Xir.customElement)("wui-snackbar")
], $d84caf85d0686836$export$864d710a9db8f7a3);

});
parcelRegister("jurVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3067c8d0a1a8403$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $e3067c8d0a1a8403$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-xs);
    align-items: center;
    padding: var(--wui-spacing-xs) var(--wui-spacing-m) var(--wui-spacing-xs) var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-color-bg-175);
    box-shadow:
      0px 14px 64px -4px rgba(0, 0, 0, 0.15),
      0px 8px 22px -6px rgba(0, 0, 0, 0.15);
  }
`;

});


parcelRegister("1sNrH", function(module, exports) {

$parcel$export(module.exports, "WuiTabs", () => $110ec2da86d0e637$export$78c669163db53348);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $7wBgi = parcelRequire("7wBgi");
var $110ec2da86d0e637$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $110ec2da86d0e637$export$78c669163db53348 = class WuiTabs extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.onTabChange = ()=>null;
        this.buttons = [];
        this.disabled = false;
        this.activeTab = 0;
        this.localTabWidth = "100px";
        this.isDense = false;
    }
    render() {
        this.isDense = this.tabs.length > 3;
        this.style.cssText = `
      --local-tab: ${this.activeTab};
      --local-tab-width: ${this.localTabWidth};
    `;
        this.dataset["type"] = this.isDense ? "flex" : "block";
        return this.tabs.map((tab, index)=>{
            const isActive = index === this.activeTab;
            return (0, $8AeG9.html)`
        <button
          ?disabled=${this.disabled}
          @click=${()=>this.onTabClick(index)}
          data-active=${isActive}
        >
          <wui-icon size="xs" color="inherit" name=${tab.icon}></wui-icon>
          <wui-text variant="small-600" color="inherit"> ${tab.label} </wui-text>
        </button>
      `;
        });
    }
    firstUpdated() {
        if (this.shadowRoot && this.isDense) {
            this.buttons = [
                ...this.shadowRoot.querySelectorAll("button")
            ];
            setTimeout(()=>{
                this.animateTabs(0, true);
            }, 0);
        }
    }
    onTabClick(index) {
        if (this.buttons) this.animateTabs(index, false);
        this.activeTab = index;
        this.onTabChange(index);
    }
    animateTabs(index, initialAnimation) {
        const passiveBtn = this.buttons[this.activeTab];
        const activeBtn = this.buttons[index];
        const passiveBtnText = passiveBtn?.querySelector("wui-text");
        const activeBtnText = activeBtn?.querySelector("wui-text");
        const activeBtnBounds = activeBtn?.getBoundingClientRect();
        const activeBtnTextBounds = activeBtnText?.getBoundingClientRect();
        if (passiveBtn && passiveBtnText && !initialAnimation && index !== this.activeTab) {
            passiveBtnText.animate([
                {
                    opacity: 0
                }
            ], {
                duration: 50,
                easing: "ease",
                fill: "forwards"
            });
            passiveBtn.animate([
                {
                    width: `34px`
                }
            ], {
                duration: 500,
                easing: "ease",
                fill: "forwards"
            });
        }
        if (activeBtn && activeBtnBounds && activeBtnTextBounds && activeBtnText) {
            if (index !== this.activeTab || initialAnimation) {
                this.localTabWidth = `${Math.round(activeBtnBounds.width + activeBtnTextBounds.width) + 6}px`;
                activeBtn.animate([
                    {
                        width: `${activeBtnBounds.width + activeBtnTextBounds.width}px`
                    }
                ], {
                    duration: initialAnimation ? 0 : 500,
                    fill: "forwards",
                    easing: "ease"
                });
                activeBtnText.animate([
                    {
                        opacity: 1
                    }
                ], {
                    duration: initialAnimation ? 0 : 125,
                    delay: initialAnimation ? 0 : 200,
                    fill: "forwards",
                    easing: "ease"
                });
            }
        }
    }
};
$110ec2da86d0e637$export$78c669163db53348.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $7wBgi.default)
];
$110ec2da86d0e637$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $110ec2da86d0e637$export$78c669163db53348.prototype, "tabs", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $kRRY9.property)()
], $110ec2da86d0e637$export$78c669163db53348.prototype, "onTabChange", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $110ec2da86d0e637$export$78c669163db53348.prototype, "buttons", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $110ec2da86d0e637$export$78c669163db53348.prototype, "disabled", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $dBBvD.state)()
], $110ec2da86d0e637$export$78c669163db53348.prototype, "activeTab", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $dBBvD.state)()
], $110ec2da86d0e637$export$78c669163db53348.prototype, "localTabWidth", void 0);
$110ec2da86d0e637$var$__decorate([
    (0, $dBBvD.state)()
], $110ec2da86d0e637$export$78c669163db53348.prototype, "isDense", void 0);
$110ec2da86d0e637$export$78c669163db53348 = $110ec2da86d0e637$var$__decorate([
    (0, $33Xir.customElement)("wui-tabs")
], $110ec2da86d0e637$export$78c669163db53348);

});
parcelRegister("7wBgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a86cf8a3b837d7$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $57a86cf8a3b837d7$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: inline-flex;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    padding: var(--wui-spacing-3xs);
    position: relative;
    height: 36px;
    overflow: hidden;
  }

  :host::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 4px;
    left: 4px;
    display: block;
    width: var(--local-tab-width);
    height: 28px;
    border-radius: var(--wui-border-radius-3xl);
    background-color: var(--wui-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));
    transition: transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  :host([data-type='flex'])::before {
    left: 3px;
    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));
  }

  :host([data-type='flex']) {
    display: flex;
    padding: 0px 0px 0px 12px;
    gap: 4px;
  }

  :host([data-type='flex']) > button > wui-text {
    position: absolute;
    left: 18px;
    opacity: 0;
  }

  button[data-active='true'] > wui-icon,
  button[data-active='true'] > wui-text {
    color: var(--wui-color-fg-100);
  }

  button[data-active='false'] > wui-icon,
  button[data-active='false'] > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='true']:disabled,
  button[data-active='false']:disabled {
    background-color: transparent;
    opacity: 0.5;
    cursor: not-allowed;
  }

  button[data-active='true']:disabled > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='false']:disabled > wui-text {
    color: var(--wui-color-fg-300);
  }

  button > wui-icon,
  button > wui-text {
    pointer-events: none;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  button {
    width: var(--local-tab-width);
  }

  :host([data-type='flex']) > button {
    width: 34px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  button:hover:enabled,
  button:active:enabled {
    background-color: transparent !important;
  }

  button:hover:enabled > wui-icon,
  button:active:enabled > wui-icon {
    color: var(--wui-color-fg-125);
  }

  button:hover:enabled > wui-text,
  button:active:enabled > wui-text {
    color: var(--wui-color-fg-125);
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
  }
`;

});


parcelRegister("9nUds", function(module, exports) {

$parcel$export(module.exports, "WuiTooltip", () => $6d51de5bfb334bdc$export$eee74dbee7f7f64b);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $awG1y = parcelRequire("awG1y");
var $6d51de5bfb334bdc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6d51de5bfb334bdc$export$eee74dbee7f7f64b = class WuiTooltip extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.placement = "top";
        this.message = "";
    }
    render() {
        return (0, $8AeG9.html)`<wui-icon
        data-placement=${this.placement}
        color="fg-100"
        size="inherit"
        name="cursor"
      ></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>`;
    }
};
$6d51de5bfb334bdc$export$eee74dbee7f7f64b.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $awG1y.default)
];
$6d51de5bfb334bdc$var$__decorate([
    (0, $kRRY9.property)()
], $6d51de5bfb334bdc$export$eee74dbee7f7f64b.prototype, "placement", void 0);
$6d51de5bfb334bdc$var$__decorate([
    (0, $kRRY9.property)()
], $6d51de5bfb334bdc$export$eee74dbee7f7f64b.prototype, "message", void 0);
$6d51de5bfb334bdc$export$eee74dbee7f7f64b = $6d51de5bfb334bdc$var$__decorate([
    (0, $33Xir.customElement)("wui-tooltip")
], $6d51de5bfb334bdc$export$eee74dbee7f7f64b);

});
parcelRegister("awG1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a9d7da433019e53$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $7a9d7da433019e53$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    background-color: var(--wui-color-fg-100);
    color: var(--wui-color-bg-100);
    position: relative;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
  }

  wui-icon[data-placement='top'] {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;

});


parcelRegister("hcAH3", function(module, exports) {

$parcel$export(module.exports, "WuiVisualThumbnail", () => $c8600533177075bd$export$fb0fe7c7cc2031fe);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("6GKXg");
parcelRequire("jzyqy");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $2aak5 = parcelRequire("2aak5");
var $c8600533177075bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c8600533177075bd$export$fb0fe7c7cc2031fe = class WuiVisualThumbnail extends (0, $gy3vm.LitElement) {
    render() {
        this.style.cssText = `--local-border-radius: ${this.borderRadiusFull ? "1000px" : "20px"};`;
        return (0, $8AeG9.html)`${this.templateVisual()}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? ""}></wui-image>`;
        return (0, $8AeG9.html)`<wui-icon
      data-parent-size="md"
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$c8600533177075bd$export$fb0fe7c7cc2031fe.styles = [
    (0, $hCS0p.resetStyles),
    (0, $2aak5.default)
];
$c8600533177075bd$var$__decorate([
    (0, $kRRY9.property)()
], $c8600533177075bd$export$fb0fe7c7cc2031fe.prototype, "imageSrc", void 0);
$c8600533177075bd$var$__decorate([
    (0, $kRRY9.property)()
], $c8600533177075bd$export$fb0fe7c7cc2031fe.prototype, "alt", void 0);
$c8600533177075bd$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $c8600533177075bd$export$fb0fe7c7cc2031fe.prototype, "borderRadiusFull", void 0);
$c8600533177075bd$export$fb0fe7c7cc2031fe = $c8600533177075bd$var$__decorate([
    (0, $33Xir.customElement)("wui-visual-thumbnail")
], $c8600533177075bd$export$fb0fe7c7cc2031fe);

});
parcelRegister("2aak5", function(module, exports) {

$parcel$export(module.exports, "default", () => $193485e14fe7e8d2$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $193485e14fe7e8d2$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);
    border-radius: var(--local-border-radius);
    overflow: hidden;
  }

  wui-icon {
    width: 32px;
    height: 32px;
  }
`;

});


parcelRegister("8c8lB", function(module, exports) {

$parcel$export(module.exports, "WuiNoticeCard", () => $5f75eb5638c637a8$export$bdf6de60cd1210c8);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("d6bsG");
parcelRequire("64e2j");
parcelRequire("1jqc7");
parcelRequire("8lemW");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $kkwxi = parcelRequire("kkwxi");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $5f75eb5638c637a8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5f75eb5638c637a8$export$bdf6de60cd1210c8 = class WuiNoticeCard extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.description = "";
        this.icon = "wallet";
    }
    render() {
        return (0, $8AeG9.html)`
      <button>
        <wui-flex gap="m" alignItems="center" justifyContent="space-between">
          <wui-icon-box
            size="lg"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon=${this.icon}
            background="transparent"
          ></wui-icon-box>

          <wui-flex flexDirection="column" gap="3xs">
            <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
            <wui-text variant="small-400" color="fg-200">${this.description}</wui-text>
          </wui-flex>

          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>
        </wui-flex>
      </button>
    `;
    }
};
$5f75eb5638c637a8$export$bdf6de60cd1210c8.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $kkwxi.default)
];
$5f75eb5638c637a8$var$__decorate([
    (0, $kRRY9.property)()
], $5f75eb5638c637a8$export$bdf6de60cd1210c8.prototype, "label", void 0);
$5f75eb5638c637a8$var$__decorate([
    (0, $kRRY9.property)()
], $5f75eb5638c637a8$export$bdf6de60cd1210c8.prototype, "description", void 0);
$5f75eb5638c637a8$var$__decorate([
    (0, $kRRY9.property)()
], $5f75eb5638c637a8$export$bdf6de60cd1210c8.prototype, "icon", void 0);
$5f75eb5638c637a8$export$bdf6de60cd1210c8 = $5f75eb5638c637a8$var$__decorate([
    (0, $33Xir.customElement)("wui-notice-card")
], $5f75eb5638c637a8$export$bdf6de60cd1210c8);

});
parcelRegister("kkwxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $eccee9e78ca680bb$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $eccee9e78ca680bb$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
  }

  button {
    width: 100%;
    display: block;
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-2l);
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-accent-glass-015);
  }

  button:hover {
    background-color: var(--wui-accent-glass-010) !important;
  }

  button:active {
    background-color: var(--wui-accent-glass-020) !important;
  }
`;

});


parcelRegister("jvzBe", function(module, exports) {

$parcel$export(module.exports, "WuiListAccordion", () => $e33c86ea14515c65$export$f885ba019a6ba4db);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("64e2j");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $7ApuY = parcelRequire("7ApuY");
var $e33c86ea14515c65$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $e33c86ea14515c65$var$MAX_HEIGHT = 100;
let $e33c86ea14515c65$export$f885ba019a6ba4db = class WuiListAccordion extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.textTitle = "";
        this.overflowedContent = "";
        this.toggled = false;
        this.enableAccordion = false;
        this.scrollElement = undefined;
        this.scrollHeightElement = 0;
    }
    firstUpdated() {
        setTimeout(()=>{
            const heightElement = this.shadowRoot?.querySelector(".heightContent");
            if (heightElement) {
                this.scrollElement = heightElement;
                const scrollHeight = heightElement?.scrollHeight;
                if (scrollHeight && scrollHeight > $e33c86ea14515c65$var$MAX_HEIGHT) {
                    this.enableAccordion = true;
                    this.scrollHeightElement = scrollHeight;
                    this.requestUpdate();
                }
            }
        }, 0);
    }
    render() {
        return (0, $8AeG9.html)`
      <button ontouchstart @click=${()=>this.onClick()}>
        <wui-flex justifyContent="space-between" alignItems="center">
          <wui-text variant="paragraph-500" color="fg-100">${this.textTitle}</wui-text>
          ${this.chevronTemplate()}
        </wui-flex>
        <div
          data-active=${this.enableAccordion ? Boolean(this.toggled) : true}
          class="overflowedContent"
        >
          <div class="heightContent">
            <wui-text variant="paragraph-400" color="fg-200">
              <pre>${this.overflowedContent}</pre>
            </wui-text>
          </div>
        </div>
      </button>
    `;
    }
    onClick() {
        const icon = this.shadowRoot?.querySelector("wui-icon");
        if (this.enableAccordion) {
            this.toggled = !this.toggled;
            this.requestUpdate();
            if (this.scrollElement) this.scrollElement.animate([
                {
                    maxHeight: this.toggled ? `${$e33c86ea14515c65$var$MAX_HEIGHT}px` : `${this.scrollHeightElement}px`
                },
                {
                    maxHeight: this.toggled ? `${this.scrollHeightElement}px` : `${$e33c86ea14515c65$var$MAX_HEIGHT}px`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
            if (icon) icon.animate([
                {
                    transform: this.toggled ? `rotate(0deg)` : `rotate(180deg)`
                },
                {
                    transform: this.toggled ? `rotate(180deg)` : `rotate(0deg)`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    chevronTemplate() {
        if (this.enableAccordion) return (0, $8AeG9.html)` <wui-icon color="fg-100" size="sm" name="chevronBottom"></wui-icon>`;
        return null;
    }
};
$e33c86ea14515c65$export$f885ba019a6ba4db.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $7ApuY.default)
];
$e33c86ea14515c65$var$__decorate([
    (0, $kRRY9.property)()
], $e33c86ea14515c65$export$f885ba019a6ba4db.prototype, "textTitle", void 0);
$e33c86ea14515c65$var$__decorate([
    (0, $kRRY9.property)()
], $e33c86ea14515c65$export$f885ba019a6ba4db.prototype, "overflowedContent", void 0);
$e33c86ea14515c65$export$f885ba019a6ba4db = $e33c86ea14515c65$var$__decorate([
    (0, $33Xir.customElement)("wui-list-accordion")
], $e33c86ea14515c65$export$f885ba019a6ba4db);

});
parcelRegister("7ApuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $585facb4b98b87b9$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $585facb4b98b87b9$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  button {
    height: auto;
    position: relative;
    flex-direction: column;
    gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  .overflowedContent {
    width: 100%;
    overflow: hidden;
  }

  .overflowedContent[data-active='false']:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, var(--wui-color-bg-200), transparent);
    border-bottom-left-radius: var(--wui-border-radius-xs);
    border-bottom-right-radius: var(--wui-border-radius-xs);
  }

  .heightContent {
    max-height: 100px;
  }

  pre {
    text-align: left;
    white-space: pre-wrap;
    height: auto;
    overflow-x: auto;
    overflow-wrap: anywhere;
  }
`;

});


parcelRegister("30YuI", function(module, exports) {

$parcel$export(module.exports, "WuiListContent", () => $23204c21e0c142c7$export$621c7f09b7560b89);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("6GKXg");
parcelRequire("64e2j");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $ihhib = parcelRequire("ihhib");
var $23204c21e0c142c7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $23204c21e0c142c7$export$621c7f09b7560b89 = class WuiListContent extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.textTitle = "";
        this.textValue = undefined;
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color=${this.textValue ? "fg-200" : "fg-100"}>
          ${this.textTitle}
        </wui-text>
        ${this.templateContent()}
      </wui-flex>
    `;
    }
    templateContent() {
        if (this.imageSrc) return (0, $8AeG9.html)`<wui-image src=${this.imageSrc} alt=${this.textTitle}></wui-image>`;
        else if (this.textValue) return (0, $8AeG9.html)` <wui-text variant="paragraph-400" color="fg-100"> ${this.textValue} </wui-text>`;
        return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$23204c21e0c142c7$export$621c7f09b7560b89.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $ihhib.default)
];
$23204c21e0c142c7$var$__decorate([
    (0, $kRRY9.property)()
], $23204c21e0c142c7$export$621c7f09b7560b89.prototype, "imageSrc", void 0);
$23204c21e0c142c7$var$__decorate([
    (0, $kRRY9.property)()
], $23204c21e0c142c7$export$621c7f09b7560b89.prototype, "textTitle", void 0);
$23204c21e0c142c7$var$__decorate([
    (0, $kRRY9.property)()
], $23204c21e0c142c7$export$621c7f09b7560b89.prototype, "textValue", void 0);
$23204c21e0c142c7$export$621c7f09b7560b89 = $23204c21e0c142c7$var$__decorate([
    (0, $33Xir.customElement)("wui-list-content")
], $23204c21e0c142c7$export$621c7f09b7560b89);

});
parcelRegister("ihhib", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4e73a6786bccc97$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $d4e73a6786bccc97$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("gXhFf", function(module, exports) {

$parcel$export(module.exports, "WuiListWalletTransaction", () => $c57fdbcde54dba2d$export$fc79cdc2df8cc885);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("jzyqy");
parcelRequire("6GKXg");
parcelRequire("64e2j");
parcelRequire("d07io");
parcelRequire("d6bsG");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $kO45C = parcelRequire("kO45C");
var $c57fdbcde54dba2d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c57fdbcde54dba2d$export$fc79cdc2df8cc885 = class WuiListWalletTransaction extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.amount = "";
        this.networkCurreny = "";
        this.networkImageUrl = "";
        this.receiverAddress = "";
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">Sending</wui-text>
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">
            ${this.amount} ${this.networkCurreny}
          </wui-text>
          ${this.templateNetworkVisual()}
        </wui-flex>
      </wui-flex>
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">To</wui-text>
        <wui-chip
          icon="externalLink"
          variant="shadeSmall"
          href=${this.receiverAddress}
          title=${this.receiverAddress}
        ></wui-chip>
      </wui-flex>
    `;
    }
    templateNetworkVisual() {
        if (this.networkImageUrl) return (0, $8AeG9.html)`<wui-image src=${this.networkImageUrl} alt="Network Image"></wui-image>`;
        return (0, $8AeG9.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$c57fdbcde54dba2d$export$fc79cdc2df8cc885.styles = [
    (0, $hCS0p.resetStyles),
    (0, $hCS0p.elementStyles),
    (0, $kO45C.default)
];
$c57fdbcde54dba2d$var$__decorate([
    (0, $kRRY9.property)()
], $c57fdbcde54dba2d$export$fc79cdc2df8cc885.prototype, "amount", void 0);
$c57fdbcde54dba2d$var$__decorate([
    (0, $kRRY9.property)()
], $c57fdbcde54dba2d$export$fc79cdc2df8cc885.prototype, "networkCurreny", void 0);
$c57fdbcde54dba2d$var$__decorate([
    (0, $kRRY9.property)()
], $c57fdbcde54dba2d$export$fc79cdc2df8cc885.prototype, "networkImageUrl", void 0);
$c57fdbcde54dba2d$var$__decorate([
    (0, $kRRY9.property)()
], $c57fdbcde54dba2d$export$fc79cdc2df8cc885.prototype, "receiverAddress", void 0);
$c57fdbcde54dba2d$export$fc79cdc2df8cc885 = $c57fdbcde54dba2d$var$__decorate([
    (0, $33Xir.customElement)("wui-list-wallet-transaction")
], $c57fdbcde54dba2d$export$fc79cdc2df8cc885);

});
parcelRegister("kO45C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f25ba641c8fc1151$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $f25ba641c8fc1151$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--wui-spacing-l);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("2jqGy", function(module, exports) {

$parcel$export(module.exports, "WuiGrid", () => $1af20e494bed7a8a$export$834debd63a0ca469);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");

var $hCS0p = parcelRequire("hCS0p");

var $8iLLL = parcelRequire("8iLLL");

var $33Xir = parcelRequire("33Xir");

var $7Sb7C = parcelRequire("7Sb7C");
var $1af20e494bed7a8a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1af20e494bed7a8a$export$834debd63a0ca469 = class WuiGrid extends (0, $gy3vm.LitElement) {
    render() {
        this.style.cssText = `
      grid-template-rows: ${this.gridTemplateRows};
      grid-template-columns: ${this.gridTemplateColumns};
      justify-items: ${this.justifyItems};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      align-content: ${this.alignContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $8iLLL.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $8AeG9.html)`<slot></slot>`;
    }
};
$1af20e494bed7a8a$export$834debd63a0ca469.styles = [
    (0, $hCS0p.resetStyles),
    (0, $7Sb7C.default)
];
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "gridTemplateRows", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "gridTemplateColumns", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "justifyItems", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "alignItems", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "justifyContent", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "alignContent", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "columnGap", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "rowGap", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "gap", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "padding", void 0);
$1af20e494bed7a8a$var$__decorate([
    (0, $kRRY9.property)()
], $1af20e494bed7a8a$export$834debd63a0ca469.prototype, "margin", void 0);
$1af20e494bed7a8a$export$834debd63a0ca469 = $1af20e494bed7a8a$var$__decorate([
    (0, $33Xir.customElement)("wui-grid")
], $1af20e494bed7a8a$export$834debd63a0ca469);

});
parcelRegister("7Sb7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb634252df141f3$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $5bb634252df141f3$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("6AlJM", function(module, exports) {

$parcel$export(module.exports, "WuiSeparator", () => $4cb6f7794d872dda$export$987a8443516753c9);
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("64e2j");

var $hCS0p = parcelRequire("hCS0p");

var $33Xir = parcelRequire("33Xir");

var $j8394 = parcelRequire("j8394");
var $4cb6f7794d872dda$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4cb6f7794d872dda$export$987a8443516753c9 = class WuiSeparator extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $8AeG9.html)`${this.template()}`;
    }
    template() {
        if (this.text) return (0, $8AeG9.html)`<wui-text variant="small-500" color="fg-200">${this.text}</wui-text>`;
        return null;
    }
};
$4cb6f7794d872dda$export$987a8443516753c9.styles = [
    (0, $hCS0p.resetStyles),
    (0, $j8394.default)
];
$4cb6f7794d872dda$var$__decorate([
    (0, $kRRY9.property)()
], $4cb6f7794d872dda$export$987a8443516753c9.prototype, "text", void 0);
$4cb6f7794d872dda$export$987a8443516753c9 = $4cb6f7794d872dda$var$__decorate([
    (0, $33Xir.customElement)("wui-separator")
], $4cb6f7794d872dda$export$987a8443516753c9);

});
parcelRegister("j8394", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded1344731ccb5ef$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ded1344731ccb5ef$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    position: relative;
    display: flex;
    width: 100%;
    height: 1px;
    background-color: var(--wui-gray-glass-005);
    justify-content: center;
    align-items: center;
  }

  :host > wui-text {
    position: absolute;
    padding: 0px 10px;
    background-color: var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("jbpJN", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", () => $df73025f6d629c75$export$445ed8d5992cc5e0);
parcelRequire("fS82a");
var $gEtkT = parcelRequire("gEtkT");

var $8iLLL = parcelRequire("8iLLL");
const $df73025f6d629c75$var$FLOAT_FIXED_VALUE = 3;
const $df73025f6d629c75$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
const $df73025f6d629c75$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
const $df73025f6d629c75$export$445ed8d5992cc5e0 = {
    getTransactionGroupTitle (year) {
        const currentYear = (0, $gEtkT.DateUtil).getYear();
        const isCurrentYear = year === currentYear;
        const groupTitle = isCurrentYear ? "This Year" : year;
        return groupTitle;
    },
    getTransactionImages (transfers) {
        const [transfer, secondTransfer] = transfers;
        const isAllNFT = Boolean(transfer) && transfers?.every((item)=>Boolean(item.nft_info));
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransactionImage(item));
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage (transfer) {
        return {
            type: $df73025f6d629c75$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $df73025f6d629c75$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL (transfer) {
        let imageURL = null;
        const isNFT = Boolean(transfer?.nft_info);
        const isFungible = Boolean(transfer?.fungible_info);
        if (transfer && isNFT) imageURL = transfer?.nft_info?.content?.preview?.url;
        else if (transfer && isFungible) imageURL = transfer?.fungible_info?.icon?.url;
        return imageURL;
    },
    getTransactionTransferTokenType (transfer) {
        if (transfer?.fungible_info) return "FUNGIBLE";
        else if (transfer?.nft_info) return "NFT";
        return null;
    },
    getTransactionDescriptions (transaction) {
        const type = transaction.metadata?.operationType;
        const transfers = transaction.transfers;
        const haveTransfer = transaction.transfers?.length > 0;
        const haveMultipleTransfers = transaction.transfers?.length > 1;
        const isFungible = haveTransfer && transfers?.every((transfer)=>Boolean(transfer.fungible_info));
        const [firstTransfer, secondTransfer] = transfers;
        let firstDescription = this.getTransferDescription(firstTransfer);
        let secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            const isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $8iLLL.UiHelperUtil).getTruncateString({
                    string: transaction.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $8iLLL.UiHelperUtil).getTruncateString({
                    string: transaction.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransferDescription(item));
        let prefix = "";
        if ($df73025f6d629c75$var$plusTypes.includes(type)) prefix = "+";
        else if ($df73025f6d629c75$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription (transfer) {
        let description = "";
        if (!transfer) return description;
        if (transfer?.nft_info) description = transfer?.nft_info?.name || "-";
        else if (transfer?.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription (transfer) {
        if (!transfer) return null;
        const quantity = this.getQuantityFixedValue(transfer?.quantity.numeric);
        const description = [
            quantity,
            transfer?.fungible_info?.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue (value) {
        if (!value) return null;
        const parsedValue = parseFloat(value);
        return parsedValue.toFixed($df73025f6d629c75$var$FLOAT_FIXED_VALUE);
    }
};

});
parcelRegister("fS82a", function(module, exports) {

$parcel$export(module.exports, "DateUtil", () => (parcelRequire("gEtkT")).DateUtil);

var $gEtkT = parcelRequire("gEtkT");

});
parcelRegister("gEtkT", function(module, exports) {

$parcel$export(module.exports, "DateUtil", () => $c1f7234edf99fb34$export$9b575f14aa5e09a1);

var $gngdn = parcelRequire("gngdn");

var $ky4A8 = parcelRequire("ky4A8");

var $Jb9bz = parcelRequire("Jb9bz");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($Jb9bz))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($ky4A8))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).updateLocale("en", {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%s sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
});
const $c1f7234edf99fb34$export$9b575f14aa5e09a1 = {
    getYear (date = new Date().toISOString()) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).year();
    },
    getRelativeDateFromNow (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).fromNow(true);
    }
};

});
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("ky4A8", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});

parcelRegister("Jb9bz", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});





parcelRegister("8WgY8", function(module, exports) {

$parcel$export(module.exports, "W3mModal", () => $6820e7318c2792ec$export$8f54aa55129a8184);
parcelRequire("k1l85");
var $6CqNZ = parcelRequire("6CqNZ");
var $aoKpV = parcelRequire("aoKpV");
var $afSSl = parcelRequire("afSSl");
var $k7Co7 = parcelRequire("k7Co7");
var $bE42d = parcelRequire("bE42d");
var $58zho = parcelRequire("58zho");
var $eMTTW = parcelRequire("eMTTW");
var $45Xo0 = parcelRequire("45Xo0");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $8iLLL = parcelRequire("8iLLL");
var $hCS0p = parcelRequire("hCS0p");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");

var $8rB26 = parcelRequire("8rB26");
var $6820e7318c2792ec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $6820e7318c2792ec$var$SCROLL_LOCK = "scroll-lock";
let $6820e7318c2792ec$export$8f54aa55129a8184 = class W3mModal extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.abortController = undefined;
        this.open = (0, $6CqNZ.ModalController).state.open;
        this.caipAddress = (0, $aoKpV.AccountController).state.address;
        this.isSiweEnabled = (0, $afSSl.SIWEController).state.isSiweEnabled;
        this.initializeTheming();
        (0, $k7Co7.ApiController).prefetch();
        this.unsubscribe.push((0, $6CqNZ.ModalController).subscribeKey("open", (val)=>val ? this.onOpen() : this.onClose()), (0, $afSSl.SIWEController).subscribeKey("isSiweEnabled", (isEnabled)=>{
            this.isSiweEnabled = isEnabled;
        }), (0, $aoKpV.AccountController).subscribe((newAccountState)=>this.onNewAccountState(newAccountState)));
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "MODAL_LOADED"
        });
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.onRemoveKeyboardListener();
    }
    render() {
        return this.open ? (0, $8AeG9.html)`
          <wui-flex @click=${this.onOverlayClick.bind(this)}>
            <wui-card role="alertdialog" aria-modal="true" tabindex="0">
              <w3m-header></w3m-header>
              <w3m-router></w3m-router>
              <w3m-snackbar></w3m-snackbar>
            </wui-card>
          </wui-flex>
        ` : null;
    }
    async onOverlayClick(event) {
        if (event.target === event.currentTarget) await this.handleClose();
    }
    async handleClose() {
        if (this.isSiweEnabled && (0, $afSSl.SIWEController).state.status !== "success") await (0, $58zho.ConnectionController).disconnect();
        (0, $6CqNZ.ModalController).close();
    }
    initializeTheming() {
        const { themeVariables: themeVariables, themeMode: themeMode } = (0, $eMTTW.ThemeController).state;
        const defaultThemeMode = (0, $8iLLL.UiHelperUtil).getColorTheme(themeMode);
        (0, $hCS0p.initializeTheming)(themeVariables, defaultThemeMode);
    }
    async onClose() {
        this.onScrollUnlock();
        await this.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        (0, $45Xo0.SnackController).hide();
        this.open = false;
        this.onRemoveKeyboardListener();
    }
    async onOpen() {
        this.onScrollLock();
        this.open = true;
        await this.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        }).finished;
        this.onAddKeyboardListener();
    }
    onScrollLock() {
        const styleTag = document.createElement("style");
        styleTag.dataset["w3m"] = $6820e7318c2792ec$var$SCROLL_LOCK;
        styleTag.textContent = `
      html, body {
        touch-action: none;
        overflow: hidden;
        overscroll-behavior: contain;
      }
      w3m-modal {
        pointer-events: auto;
      }
    `;
        document.head.appendChild(styleTag);
    }
    onScrollUnlock() {
        const styleTag = document.head.querySelector(`style[data-w3m="${$6820e7318c2792ec$var$SCROLL_LOCK}"]`);
        if (styleTag) styleTag.remove();
    }
    onAddKeyboardListener() {
        this.abortController = new AbortController();
        const card = this.shadowRoot?.querySelector("wui-card");
        card?.focus();
        window.addEventListener("keydown", (event)=>{
            if (event.key === "Escape") this.handleClose();
            else if (event.key === "Tab") {
                const { tagName: tagName } = event.target;
                if (tagName && !tagName.includes("W3M-") && !tagName.includes("WUI-")) card?.focus();
            }
        }, this.abortController);
    }
    onRemoveKeyboardListener() {
        this.abortController?.abort();
        this.abortController = undefined;
    }
    async onNewAccountState(newState) {
        const { isConnected: isConnected, caipAddress: newCaipAddress } = newState;
        if (this.isSiweEnabled) {
            if (isConnected && !this.caipAddress) this.caipAddress = newCaipAddress;
            if (isConnected && newCaipAddress && this.caipAddress !== newCaipAddress) {
                await (0, $afSSl.SIWEController).signOut();
                this.onSiweNavigation();
                this.caipAddress = newCaipAddress;
            }
            try {
                const session = await (0, $afSSl.SIWEController).getSession();
                if (session && !isConnected) await (0, $afSSl.SIWEController).signOut();
                else if (isConnected && !session) this.onSiweNavigation();
            } catch (error) {
                if (isConnected) this.onSiweNavigation();
            }
        }
    }
    onSiweNavigation() {
        if (this.open) (0, $eMpli.RouterController).push("ConnectingSiwe");
        else (0, $6CqNZ.ModalController).open({
            view: "ConnectingSiwe"
        });
    }
};
$6820e7318c2792ec$export$8f54aa55129a8184.styles = (0, $8rB26.default);
$6820e7318c2792ec$var$__decorate([
    (0, $dBBvD.state)()
], $6820e7318c2792ec$export$8f54aa55129a8184.prototype, "open", void 0);
$6820e7318c2792ec$var$__decorate([
    (0, $dBBvD.state)()
], $6820e7318c2792ec$export$8f54aa55129a8184.prototype, "caipAddress", void 0);
$6820e7318c2792ec$var$__decorate([
    (0, $dBBvD.state)()
], $6820e7318c2792ec$export$8f54aa55129a8184.prototype, "isSiweEnabled", void 0);
$6820e7318c2792ec$export$8f54aa55129a8184 = $6820e7318c2792ec$var$__decorate([
    (0, $33Xir.customElement)("w3m-modal")
], $6820e7318c2792ec$export$8f54aa55129a8184);

});
parcelRegister("k1l85", function(module, exports) {

$parcel$export(module.exports, "ModalController", () => (parcelRequire("6CqNZ")).ModalController);
$parcel$export(module.exports, "RouterController", () => (parcelRequire("eMpli")).RouterController);
$parcel$export(module.exports, "AccountController", () => (parcelRequire("aoKpV")).AccountController);
$parcel$export(module.exports, "NetworkController", () => (parcelRequire("j0fVO")).NetworkController);
$parcel$export(module.exports, "ConnectionController", () => (parcelRequire("58zho")).ConnectionController);
$parcel$export(module.exports, "SIWEController", () => (parcelRequire("afSSl")).SIWEController);
$parcel$export(module.exports, "ConnectorController", () => (parcelRequire("8L7Gu")).ConnectorController);
$parcel$export(module.exports, "SnackController", () => (parcelRequire("45Xo0")).SnackController);
$parcel$export(module.exports, "ApiController", () => (parcelRequire("k7Co7")).ApiController);
$parcel$export(module.exports, "ThemeController", () => (parcelRequire("eMTTW")).ThemeController);
$parcel$export(module.exports, "OptionsController", () => (parcelRequire("3pfUo")).OptionsController);
$parcel$export(module.exports, "BlockchainApiController", () => (parcelRequire("cHcnO")).BlockchainApiController);
$parcel$export(module.exports, "PublicStateController", () => (parcelRequire("dTOcV")).PublicStateController);
$parcel$export(module.exports, "EventsController", () => (parcelRequire("bE42d")).EventsController);
$parcel$export(module.exports, "TransactionsController", () => (parcelRequire("6G808")).TransactionsController);
$parcel$export(module.exports, "AssetUtil", () => (parcelRequire("efzgw")).AssetUtil);
$parcel$export(module.exports, "ConstantsUtil", () => (parcelRequire("fz7Cd")).ConstantsUtil);
$parcel$export(module.exports, "CoreHelperUtil", () => (parcelRequire("bYnq1")).CoreHelperUtil);
$parcel$export(module.exports, "StorageUtil", () => (parcelRequire("jheXw")).StorageUtil);
$parcel$export(module.exports, "RouterUtil", () => (parcelRequire("ap614")).RouterUtil);

var $6CqNZ = parcelRequire("6CqNZ");

var $eMpli = parcelRequire("eMpli");

var $aoKpV = parcelRequire("aoKpV");

var $j0fVO = parcelRequire("j0fVO");

var $58zho = parcelRequire("58zho");

var $afSSl = parcelRequire("afSSl");

var $8L7Gu = parcelRequire("8L7Gu");

var $45Xo0 = parcelRequire("45Xo0");

var $k7Co7 = parcelRequire("k7Co7");

var $4bMGS = parcelRequire("4bMGS");

var $eMTTW = parcelRequire("eMTTW");

var $3pfUo = parcelRequire("3pfUo");

var $cHcnO = parcelRequire("cHcnO");

var $dTOcV = parcelRequire("dTOcV");

var $bE42d = parcelRequire("bE42d");

var $6G808 = parcelRequire("6G808");

var $efzgw = parcelRequire("efzgw");

var $fz7Cd = parcelRequire("fz7Cd");

var $bYnq1 = parcelRequire("bYnq1");

var $jheXw = parcelRequire("jheXw");

var $ap614 = parcelRequire("ap614");

});
parcelRegister("6CqNZ", function(module, exports) {

$parcel$export(module.exports, "ModalController", () => $4d1b15a71dbc170a$export$d507f25e63650365);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $aoKpV = parcelRequire("aoKpV");

var $k7Co7 = parcelRequire("k7Co7");

var $bE42d = parcelRequire("bE42d");

var $dTOcV = parcelRequire("dTOcV");

var $eMpli = parcelRequire("eMpli");
const $4d1b15a71dbc170a$var$state = (0, $lDt57.proxy)({
    loading: false,
    open: false
});
const $4d1b15a71dbc170a$export$d507f25e63650365 = {
    state: $4d1b15a71dbc170a$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($4d1b15a71dbc170a$var$state, ()=>callback($4d1b15a71dbc170a$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($4d1b15a71dbc170a$var$state, key, callback);
    },
    async open (options) {
        await (0, $k7Co7.ApiController).state.prefetchPromise;
        if (options?.view) (0, $eMpli.RouterController).reset(options.view);
        else if ((0, $aoKpV.AccountController).state.isConnected) (0, $eMpli.RouterController).reset("Account");
        else (0, $eMpli.RouterController).reset("Connect");
        $4d1b15a71dbc170a$var$state.open = true;
        (0, $dTOcV.PublicStateController).set({
            open: true
        });
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "MODAL_OPEN"
        });
    },
    close () {
        $4d1b15a71dbc170a$var$state.open = false;
        (0, $dTOcV.PublicStateController).set({
            open: false
        });
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE"
        });
    },
    setLoading (loading) {
        $4d1b15a71dbc170a$var$state.loading = loading;
    }
};

});
parcelRegister("8tzvu", function(module, exports) {
"use strict";

var $hpUpc = parcelRequire("hpUpc");

var $aXa9M = parcelRequire("aXa9M");
Object.keys($hpUpc).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $hpUpc[k];
        }
    });
});
Object.keys($aXa9M).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $aXa9M[k];
        }
    });
});

});
parcelRegister("hpUpc", function(module, exports) {

$parcel$export(module.exports, "addComputed", () => $cae0866804f4505b$export$b84fff6f79a56fa3, (v) => $cae0866804f4505b$export$b84fff6f79a56fa3 = v);
$parcel$export(module.exports, "derive", () => $cae0866804f4505b$export$78ed5b3305815fc7, (v) => $cae0866804f4505b$export$78ed5b3305815fc7 = v);
$parcel$export(module.exports, "devtools", () => $cae0866804f4505b$export$6922d3b3a607469e, (v) => $cae0866804f4505b$export$6922d3b3a607469e = v);
$parcel$export(module.exports, "proxyMap", () => $cae0866804f4505b$export$17aaac2670e0d2b9, (v) => $cae0866804f4505b$export$17aaac2670e0d2b9 = v);
$parcel$export(module.exports, "proxySet", () => $cae0866804f4505b$export$339ebc24fb22ad80, (v) => $cae0866804f4505b$export$339ebc24fb22ad80 = v);
$parcel$export(module.exports, "proxyWithComputed", () => $cae0866804f4505b$export$64a33e9109220e08, (v) => $cae0866804f4505b$export$64a33e9109220e08 = v);
$parcel$export(module.exports, "proxyWithHistory", () => $cae0866804f4505b$export$32f3091caa3ecf1e, (v) => $cae0866804f4505b$export$32f3091caa3ecf1e = v);
$parcel$export(module.exports, "subscribeKey", () => $cae0866804f4505b$export$7faad7f6b3708314, (v) => $cae0866804f4505b$export$7faad7f6b3708314 = v);
$parcel$export(module.exports, "underive", () => $cae0866804f4505b$export$992ed2abb18cb90, (v) => $cae0866804f4505b$export$992ed2abb18cb90 = v);
$parcel$export(module.exports, "unstable_deriveSubscriptions", () => $cae0866804f4505b$export$5bb85a5dcd872eb9, (v) => $cae0866804f4505b$export$5bb85a5dcd872eb9 = v);
$parcel$export(module.exports, "watch", () => $cae0866804f4505b$export$3db5d71bdb2d5499, (v) => $cae0866804f4505b$export$3db5d71bdb2d5499 = v);
var $cae0866804f4505b$export$b84fff6f79a56fa3;
var $cae0866804f4505b$export$78ed5b3305815fc7;
var $cae0866804f4505b$export$6922d3b3a607469e;
var $cae0866804f4505b$export$17aaac2670e0d2b9;
var $cae0866804f4505b$export$339ebc24fb22ad80;
var $cae0866804f4505b$export$64a33e9109220e08;
var $cae0866804f4505b$export$32f3091caa3ecf1e;
var $cae0866804f4505b$export$7faad7f6b3708314;
var $cae0866804f4505b$export$992ed2abb18cb90;
var $cae0866804f4505b$export$5bb85a5dcd872eb9;
var $cae0866804f4505b$export$3db5d71bdb2d5499;
"use strict";

var $lDt57 = parcelRequire("lDt57");
function $cae0866804f4505b$var$subscribeKey(proxyObject, key, callback, notifyInSync) {
    var prevValue = proxyObject[key];
    return $lDt57.subscribe(proxyObject, function() {
        var nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
var $cae0866804f4505b$var$currentCleanups;
function $cae0866804f4505b$var$watch(callback, options) {
    var alive = true;
    var cleanups = new Set();
    var subscriptions = new Map();
    var cleanup = function cleanup() {
        if (alive) {
            alive = false;
            cleanups.forEach(function(clean) {
                return clean();
            });
            cleanups.clear();
            subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            subscriptions.clear();
        }
    };
    var revalidate = function revalidate() {
        if (!alive) return;
        cleanups.forEach(function(clean) {
            return clean();
        });
        cleanups.clear();
        var proxiesToSubscribe = new Set();
        var parent = $cae0866804f4505b$var$currentCleanups;
        $cae0866804f4505b$var$currentCleanups = cleanups;
        try {
            var cleanupReturn = callback(function(proxyObject) {
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $cae0866804f4505b$var$currentCleanups = parent;
        }
        subscriptions.forEach(function(unsubscribe, proxyObject) {
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach(function(proxyObject) {
            var unsubscribe = $lDt57.subscribe(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($cae0866804f4505b$var$currentCleanups) $cae0866804f4505b$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
function $cae0866804f4505b$var$_defineAccessor(type, obj, key, fn) {
    var desc = {
        configurable: !0,
        enumerable: !0
    };
    return desc[type] = fn, Object.defineProperty(obj, key, desc);
}
function $cae0866804f4505b$var$_extends() {
    $cae0866804f4505b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cae0866804f4505b$var$_extends.apply(this, arguments);
}
function $cae0866804f4505b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cae0866804f4505b$var$_excluded = [
    "enabled",
    "name"
];
var $cae0866804f4505b$var$DEVTOOLS = Symbol();
function $cae0866804f4505b$var$devtools(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    var _ref = options || {}, enabled = _ref.enabled, _ref$name = _ref.name, name = _ref$name === void 0 ? "" : _ref$name, rest = $cae0866804f4505b$var$_objectWithoutPropertiesLoose(_ref, $cae0866804f4505b$var$_excluded);
    var extension;
    try {
        extension = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (_unused) {}
    if (!extension) return;
    var isTimeTraveling = false;
    var devtools = extension.connect($cae0866804f4505b$var$_extends({
        name: name
    }, rest));
    var unsub1 = $lDt57.subscribe(proxyObject, function(ops) {
        var action = ops.filter(function(_ref2) {
            _ref2[0];
            var path = _ref2[1];
            return path[0] !== $cae0866804f4505b$var$DEVTOOLS;
        }).map(function(_ref3) {
            var op = _ref3[0], path = _ref3[1];
            return op + ":" + path.map(String).join(".");
        }).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            var snapWithoutDevtools = Object.assign({}, $lDt57.snapshot(proxyObject));
            delete snapWithoutDevtools[$cae0866804f4505b$var$DEVTOOLS];
            devtools.send({
                type: action,
                updatedAt: new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    var unsub2 = devtools.subscribe(function(message) {
        var _message$payload3, _message$payload4;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            var _message$payload, _message$payload2;
            if (((_message$payload = message.payload) == null ? void 0 : _message$payload.type) === "JUMP_TO_ACTION" || ((_message$payload2 = message.payload) == null ? void 0 : _message$payload2.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                var state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$cae0866804f4505b$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_message$payload3 = message.payload) == null ? void 0 : _message$payload3.type) === "COMMIT") devtools.init($lDt57.snapshot(proxyObject));
        else if (message.type === "DISPATCH" && ((_message$payload4 = message.payload) == null ? void 0 : _message$payload4.type) === "IMPORT_STATE") {
            var _message$payload$next, _message$payload$next2;
            var actions = (_message$payload$next = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next.actionsById;
            var computedStates = ((_message$payload$next2 = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next2.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(function(_ref4, index) {
                var state = _ref4.state;
                var action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools.init($lDt57.snapshot(proxyObject));
                else devtools.send(action, $lDt57.snapshot(proxyObject));
            });
        }
    });
    devtools.init($lDt57.snapshot(proxyObject));
    return function() {
        unsub1();
        unsub2 == null || unsub2();
    };
}
var $cae0866804f4505b$var$sourceObjectMap = new WeakMap();
var $cae0866804f4505b$var$derivedObjectMap = new WeakMap();
var $cae0866804f4505b$var$markPending = function markPending(sourceObject, callback) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
var $cae0866804f4505b$var$checkPending = function checkPending(sourceObject, callback) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry != null && sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
var $cae0866804f4505b$var$unmarkPending = function unmarkPending(sourceObject) {
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach(function(callback) {
                return callback();
            });
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) unmarkPending(derivedObject);
        });
    }
};
var $cae0866804f4505b$var$addSubscription = function addSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            new Set()
        ];
        $cae0866804f4505b$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        var _subscriptions = new Set();
        var _unsubscribe = $lDt57.subscribe(sourceObject, function(ops) {
            _subscriptions.forEach(function(subscription) {
                var derivedObject = subscription.d, callback = subscription.c, notifyInSync = subscription.n, ignoreKeys = subscription.i;
                if (sourceObject === derivedObject && ops.every(function(op) {
                    return op[1].length === 1 && ignoreKeys.includes(op[1][0]);
                })) return;
                if (subscription.p) return;
                $cae0866804f4505b$var$markPending(sourceObject, callback);
                if (notifyInSync) $cae0866804f4505b$var$unmarkPending(sourceObject);
                else subscription.p = Promise.resolve().then(function() {
                    delete subscription.p;
                    $cae0866804f4505b$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            _subscriptions,
            _unsubscribe,
            0,
            new Set()
        ];
        $cae0866804f4505b$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
var $cae0866804f4505b$var$removeSubscription = function removeSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $cae0866804f4505b$var$derivedObjectMap.delete(derivedObject);
    var sourceObjectEntry = $cae0866804f4505b$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        var _subscriptions2 = sourceObjectEntry[0], _unsubscribe2 = sourceObjectEntry[1];
        _subscriptions2.delete(subscription);
        if (!_subscriptions2.size) {
            _unsubscribe2();
            $cae0866804f4505b$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
var $cae0866804f4505b$var$listSubscriptions = function listSubscriptions(derivedObject) {
    var derivedObjectEntry = $cae0866804f4505b$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
var $cae0866804f4505b$var$unstable_deriveSubscriptions = {
    add: $cae0866804f4505b$var$addSubscription,
    remove: $cae0866804f4505b$var$removeSubscription,
    list: $cae0866804f4505b$var$listSubscriptions
};
function $cae0866804f4505b$var$derive(derivedFns, options) {
    var proxyObject = (options == null ? void 0 : options.proxy) || $lDt57.proxy({});
    var notifyInSync = !!(options != null && options.sync);
    var derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        var fn = derivedFns[key];
        var lastDependencies = null;
        var evaluate = function evaluate() {
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(function(_ref) {
                    var p = _ref[0];
                    return $cae0866804f4505b$var$checkPending(p, evaluate);
                }).some(function(isPending) {
                    return isPending;
                })) return;
                if (Array.from(lastDependencies).every(function(_ref2) {
                    var p = _ref2[0], entry = _ref2[1];
                    return $lDt57.getVersion(p) === entry.v;
                })) return;
            }
            var dependencies = new Map();
            var get = function get(p) {
                dependencies.set(p, {
                    v: $lDt57.getVersion(p)
                });
                return p;
            };
            var value = fn(get);
            var subscribeToDependencies = function subscribeToDependencies() {
                var _lastDependencies2;
                dependencies.forEach(function(entry, p) {
                    var _lastDependencies;
                    var lastSubscription = (_lastDependencies = lastDependencies) == null || (_lastDependencies = _lastDependencies.get(p)) == null ? void 0 : _lastDependencies.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        var subscription = {
                            s: p,
                            d: proxyObject,
                            k: key,
                            c: evaluate,
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $cae0866804f4505b$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                (_lastDependencies2 = lastDependencies) == null || _lastDependencies2.forEach(function(entry, p) {
                    if (!dependencies.has(p) && entry.s) $cae0866804f4505b$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $cae0866804f4505b$var$underive(proxyObject, options) {
    var keysToDelete = options != null && options.delete ? new Set() : null;
    $cae0866804f4505b$var$listSubscriptions(proxyObject).forEach(function(subscription) {
        var key = subscription.k;
        if (!(options != null && options.keys) || options.keys.includes(key)) {
            $cae0866804f4505b$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach(function(key) {
        delete proxyObject[key];
    });
}
function $cae0866804f4505b$var$addComputed_DEPRECATED(proxyObject, computedFns_FAKE, targetObject) {
    if (targetObject === void 0) targetObject = proxyObject;
    var derivedFns = {};
    Object.keys(computedFns_FAKE).forEach(function(key) {
        derivedFns[key] = function(get) {
            return computedFns_FAKE[key](get(proxyObject));
        };
    });
    return $cae0866804f4505b$var$derive(derivedFns, {
        proxy: targetObject
    });
}
function $cae0866804f4505b$var$proxyWithComputed_DEPRECATED(initialObject, computedFns) {
    Object.keys(computedFns).forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        var computedFn = computedFns[key];
        var _ref = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn, get = _ref.get, set = _ref.set;
        var desc = {};
        desc.get = function() {
            return get($lDt57.snapshot(proxyObject));
        };
        if (set) desc.set = function(newValue) {
            return set(proxyObject, newValue);
        };
        Object.defineProperty(initialObject, key, desc);
    });
    var proxyObject = $lDt57.proxy(initialObject);
    return proxyObject;
}
var $cae0866804f4505b$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $cae0866804f4505b$var$refSet;
var $cae0866804f4505b$var$deepClone = function deepClone(obj) {
    if (!$cae0866804f4505b$var$refSet) $cae0866804f4505b$var$refSet = $lDt57.unstable_buildProxyFunction()[2];
    if (!$cae0866804f4505b$var$isObject(obj) || $cae0866804f4505b$var$refSet.has(obj)) return obj;
    var baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach(function(key) {
        baseObject[key] = deepClone(obj[key]);
    });
    return baseObject;
};
function $cae0866804f4505b$var$proxyWithHistory(initialValue, skipSubscribe) {
    if (skipSubscribe === void 0) skipSubscribe = false;
    var proxyObject = $lDt57.proxy({
        value: initialValue,
        history: $lDt57.ref({
            wip: undefined,
            snapshots: [],
            index: -1
        }),
        clone: $cae0866804f4505b$var$deepClone,
        canUndo: function canUndo() {
            return proxyObject.history.index > 0;
        },
        undo: function undo() {
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: function canRedo() {
            return proxyObject.history.index < proxyObject.history.snapshots.length - 1;
        },
        redo: function redo() {
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: function saveHistory() {
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push($lDt57.snapshot(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: function subscribe() {
            return $lDt57.subscribe(proxyObject, function(ops) {
                if (ops.every(function(op) {
                    return op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip);
                })) proxyObject.saveHistory();
            });
        }
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $cae0866804f4505b$var$proxySet(initialValues) {
    var _proxy;
    var set = $lDt57.proxy((_proxy = {
        data: Array.from(new Set(initialValues)),
        has: function has(value) {
            return this.data.indexOf(value) !== -1;
        },
        add: function add(value) {
            var hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf($lDt57.proxy(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete: function _delete(value) {
            var index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(value) {
                cb(value, value, _this);
            });
        }
    }, $cae0866804f4505b$var$_defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Set";
    }), _proxy.toJSON = function toJSON() {
        return new Set(this.data);
    }, _proxy[Symbol.iterator] = function() {
        return this.data[Symbol.iterator]();
    }, _proxy.values = function values() {
        return this.data.values();
    }, _proxy.keys = function keys() {
        return this.data.values();
    }, _proxy.entries = function entries() {
        return new Set(this.data).entries();
    }, _proxy));
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $cae0866804f4505b$var$proxyMap(entries) {
    var _proxy;
    var map = $lDt57.proxy((_proxy = {
        data: Array.from(entries || []),
        has: function has(key) {
            return this.data.some(function(p) {
                return p[0] === key;
            });
        },
        set: function set(key, value) {
            var record = this.data.find(function(p) {
                return p[0] === key;
            });
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get: function get(key) {
            var _this$data$find;
            return (_this$data$find = this.data.find(function(p) {
                return p[0] === key;
            })) == null ? void 0 : _this$data$find[1];
        },
        delete: function _delete(key) {
            var index = this.data.findIndex(function(p) {
                return p[0] === key;
            });
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON: function toJSON() {
            return new Map(this.data);
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(p) {
                cb(p[1], p[0], _this);
            });
        },
        keys: function keys() {
            return this.data.map(function(p) {
                return p[0];
            }).values();
        },
        values: function values() {
            return this.data.map(function(p) {
                return p[1];
            }).values();
        },
        entries: function entries() {
            return new Map(this.data).entries();
        }
    }, $cae0866804f4505b$var$_defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Map";
    }), _proxy[Symbol.iterator] = function() {
        return this.entries();
    }, _proxy));
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}
$cae0866804f4505b$export$b84fff6f79a56fa3 = $cae0866804f4505b$var$addComputed_DEPRECATED;
$cae0866804f4505b$export$78ed5b3305815fc7 = $cae0866804f4505b$var$derive;
$cae0866804f4505b$export$6922d3b3a607469e = $cae0866804f4505b$var$devtools;
$cae0866804f4505b$export$17aaac2670e0d2b9 = $cae0866804f4505b$var$proxyMap;
$cae0866804f4505b$export$339ebc24fb22ad80 = $cae0866804f4505b$var$proxySet;
$cae0866804f4505b$export$64a33e9109220e08 = $cae0866804f4505b$var$proxyWithComputed_DEPRECATED;
$cae0866804f4505b$export$32f3091caa3ecf1e = $cae0866804f4505b$var$proxyWithHistory;
$cae0866804f4505b$export$7faad7f6b3708314 = $cae0866804f4505b$var$subscribeKey;
$cae0866804f4505b$export$992ed2abb18cb90 = $cae0866804f4505b$var$underive;
$cae0866804f4505b$export$5bb85a5dcd872eb9 = $cae0866804f4505b$var$unstable_deriveSubscriptions;
$cae0866804f4505b$export$3db5d71bdb2d5499 = $cae0866804f4505b$var$watch;

});

parcelRegister("aXa9M", function(module, exports) {

$parcel$export(module.exports, "useProxy", () => $7f974afa6e0f63d4$export$4c7dc056506f1572, (v) => $7f974afa6e0f63d4$export$4c7dc056506f1572 = v);
var $7f974afa6e0f63d4$export$4c7dc056506f1572;
"use strict";

var $acw62 = parcelRequire("acw62");

var $bgh4e = parcelRequire("bgh4e");
function $7f974afa6e0f63d4$var$useProxy(proxy, options) {
    var snapshot = $bgh4e.useSnapshot(proxy, options);
    var isRendering = true;
    $acw62.useLayoutEffect(function() {
        isRendering = false;
    });
    return new Proxy(proxy, {
        get: function get(target, prop) {
            return isRendering ? snapshot[prop] : target[prop];
        }
    });
}
$7f974afa6e0f63d4$export$4c7dc056506f1572 = $7f974afa6e0f63d4$var$useProxy;

});
parcelRegister("bgh4e", function(module, exports) {

$parcel$export(module.exports, "useSnapshot", () => $832e6d8d576f38e5$export$12201ede76c4c5e1, (v) => $832e6d8d576f38e5$export$12201ede76c4c5e1 = v);
var $832e6d8d576f38e5$export$12201ede76c4c5e1;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fkrbD = parcelRequire("fkrbD");

var $hfliI = parcelRequire("hfliI");

var $lDt57 = parcelRequire("lDt57");
var $832e6d8d576f38e5$var$use = $acw62.use;
var $832e6d8d576f38e5$var$useSyncExternalStore = $hfliI.useSyncExternalStore;
var $832e6d8d576f38e5$var$useAffectedDebugValue = function useAffectedDebugValue(state, affected) {
    var pathList = $acw62.useRef();
    $acw62.useEffect(function() {
        pathList.current = $fkrbD.affectedToPathList(state, affected, true);
    });
    $acw62.useDebugValue(pathList.current);
};
var $832e6d8d576f38e5$var$targetCache = new WeakMap();
function $832e6d8d576f38e5$var$useSnapshot(proxyObject, options) {
    var notifyInSync = options == null ? void 0 : options.sync;
    var lastSnapshot = $acw62.useRef();
    var lastAffected = $acw62.useRef();
    var inRender = true;
    var currSnapshot = $832e6d8d576f38e5$var$useSyncExternalStore($acw62.useCallback(function(callback) {
        var unsub = $lDt57.subscribe(proxyObject, callback, notifyInSync);
        callback();
        return unsub;
    }, [
        proxyObject,
        notifyInSync
    ]), function() {
        var nextSnapshot = $lDt57.snapshot(proxyObject, $832e6d8d576f38e5$var$use);
        try {
            if (!inRender && lastSnapshot.current && lastAffected.current && !$fkrbD.isChanged(lastSnapshot.current, nextSnapshot, lastAffected.current, new WeakMap())) return lastSnapshot.current;
        } catch (e) {}
        return nextSnapshot;
    }, function() {
        return $lDt57.snapshot(proxyObject, $832e6d8d576f38e5$var$use);
    });
    inRender = false;
    var currAffected = new WeakMap();
    $acw62.useEffect(function() {
        lastSnapshot.current = currSnapshot;
        lastAffected.current = currAffected;
    });
    var proxyCache = $acw62.useMemo(function() {
        return new WeakMap();
    }, []);
    return $fkrbD.createProxy(currSnapshot, currAffected, proxyCache, $832e6d8d576f38e5$var$targetCache);
}
$832e6d8d576f38e5$export$12201ede76c4c5e1 = $832e6d8d576f38e5$var$useSnapshot;

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});




parcelRegister("aoKpV", function(module, exports) {

$parcel$export(module.exports, "AccountController", () => $792026c69a5bff7b$export$3a40b83c1282ee40);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $bYnq1 = parcelRequire("bYnq1");
const $792026c69a5bff7b$var$state = (0, $lDt57.proxy)({
    isConnected: false
});
const $792026c69a5bff7b$export$3a40b83c1282ee40 = {
    state: $792026c69a5bff7b$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($792026c69a5bff7b$var$state, ()=>callback($792026c69a5bff7b$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($792026c69a5bff7b$var$state, key, callback);
    },
    setIsConnected (isConnected) {
        $792026c69a5bff7b$var$state.isConnected = isConnected;
    },
    setCaipAddress (caipAddress) {
        $792026c69a5bff7b$var$state.caipAddress = caipAddress;
        $792026c69a5bff7b$var$state.address = caipAddress ? (0, $bYnq1.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
    },
    setBalance (balance, balanceSymbol) {
        $792026c69a5bff7b$var$state.balance = balance;
        $792026c69a5bff7b$var$state.balanceSymbol = balanceSymbol;
    },
    setProfileName (profileName) {
        $792026c69a5bff7b$var$state.profileName = profileName;
    },
    setProfileImage (profileImage) {
        $792026c69a5bff7b$var$state.profileImage = profileImage;
    },
    setAddressExplorerUrl (explorerUrl) {
        $792026c69a5bff7b$var$state.addressExplorerUrl = explorerUrl;
    },
    resetAccount () {
        $792026c69a5bff7b$var$state.isConnected = false;
        $792026c69a5bff7b$var$state.caipAddress = undefined;
        $792026c69a5bff7b$var$state.address = undefined;
        $792026c69a5bff7b$var$state.balance = undefined;
        $792026c69a5bff7b$var$state.balanceSymbol = undefined;
        $792026c69a5bff7b$var$state.profileName = undefined;
        $792026c69a5bff7b$var$state.profileImage = undefined;
        $792026c69a5bff7b$var$state.addressExplorerUrl = undefined;
    }
};

});
parcelRegister("bYnq1", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", () => $8b7776c7927d1407$export$d8fe68a4208d58ff);

var $fz7Cd = parcelRequire("fz7Cd");
const $8b7776c7927d1407$export$d8fe68a4208d58ff = {
    isMobile () {
        if (typeof window !== "undefined") return Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent));
        return false;
    },
    isAndroid () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $8b7776c7927d1407$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $8b7776c7927d1407$export$d8fe68a4208d58ff.isMobile() && (ua.includes("iphone") || ua.includes("ipad"));
    },
    isClient () {
        return typeof window !== "undefined";
    },
    isPairingExpired (expiry) {
        return expiry ? expiry - Date.now() <= (0, $fz7Cd.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry (lastRetry) {
        return Date.now() - lastRetry >= (0, $fz7Cd.ConstantsUtil).ONE_SEC_MS;
    },
    copyToClopboard (text) {
        navigator.clipboard.writeText(text);
    },
    getPairingExpiry () {
        return Date.now() + (0, $fz7Cd.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getPlainAddress (caipAddress) {
        return caipAddress.split(":")[2];
    },
    async wait (milliseconds) {
        return new Promise((resolve)=>{
            setTimeout(resolve, milliseconds);
        });
    },
    debounce (func, timeout = 500) {
        let timer = undefined;
        return (...args)=>{
            function next() {
                func(...args);
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl (url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl (appUrl, wcUri) {
        if ($8b7776c7927d1407$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = `${safeAppUrl}://`;
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    formatUniversalUrl (appUrl, wcUri) {
        if (!$8b7776c7927d1407$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    openHref (href, target) {
        window.open(href, target, "noreferrer noopener");
    },
    async preloadImage (src) {
        const imagePromise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.crossOrigin = "anonymous";
            image.src = src;
        });
        return Promise.race([
            imagePromise,
            $8b7776c7927d1407$export$d8fe68a4208d58ff.wait(2000)
        ]);
    },
    formatBalance (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0.000";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return formattedBalance ? `${formattedBalance} ${symbol}` : `0.000 ${symbol}`;
    },
    isRestrictedRegion () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return (0, $fz7Cd.ConstantsUtil).RESTRICTED_TIMEZONES.includes(capTimeZone);
        } catch  {
            return false;
        }
    },
    getApiUrl () {
        return $8b7776c7927d1407$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://api.web3modal.org" : "https://api.web3modal.com";
    },
    getBlockchainApiUrl () {
        return $8b7776c7927d1407$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
    },
    getAnalyticsUrl () {
        return $8b7776c7927d1407$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://pulse.walletconnect.org" : "https://pulse.walletconnect.com";
    },
    getUUID () {
        if (crypto?.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    parseError (error) {
        if (typeof error === "string") return error;
        else if (typeof error?.issues?.[0]?.message === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    }
};

});
parcelRegister("fz7Cd", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", () => $b550082a282f6e9e$export$aafe1f751f1bc52a);
const $b550082a282f6e9e$var$SECURE_SITE = "https://secure.web3modal.com";
const $b550082a282f6e9e$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $b550082a282f6e9e$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: `${$b550082a282f6e9e$var$SECURE_SITE}/dashboard`,
    SECURE_SITE_FAVICON: `${$b550082a282f6e9e$var$SECURE_SITE}/images/favicon.png`,
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet"
    }
};

});



parcelRegister("k7Co7", function(module, exports) {

$parcel$export(module.exports, "ApiController", () => $ea623d2a8ad55206$export$99411f73957952af);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $bYnq1 = parcelRequire("bYnq1");

var $4lOFi = parcelRequire("4lOFi");

var $jheXw = parcelRequire("jheXw");

var $4bMGS = parcelRequire("4bMGS");

var $8L7Gu = parcelRequire("8L7Gu");

var $j0fVO = parcelRequire("j0fVO");

var $3pfUo = parcelRequire("3pfUo");
const $ea623d2a8ad55206$var$baseUrl = (0, $bYnq1.CoreHelperUtil).getApiUrl();
const $ea623d2a8ad55206$var$api = new (0, $4lOFi.FetchUtil)({
    baseUrl: $ea623d2a8ad55206$var$baseUrl
});
const $ea623d2a8ad55206$var$entries = "40";
const $ea623d2a8ad55206$var$recommendedEntries = "4";
const $ea623d2a8ad55206$var$state = (0, $lDt57.proxy)({
    page: 1,
    count: 0,
    featured: [],
    recommended: [],
    wallets: [],
    search: []
});
const $ea623d2a8ad55206$export$99411f73957952af = {
    state: $ea623d2a8ad55206$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($ea623d2a8ad55206$var$state, key, callback);
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $3pfUo.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _fetchWalletImage (imageId) {
        const imageUrl = `${$ea623d2a8ad55206$var$api.baseUrl}/getWalletImage/${imageId}`;
        const blob = await $ea623d2a8ad55206$var$api.getBlob({
            path: imageUrl,
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders()
        });
        (0, $4bMGS.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchNetworkImage (imageId) {
        const imageUrl = `${$ea623d2a8ad55206$var$api.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $ea623d2a8ad55206$var$api.getBlob({
            path: imageUrl,
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders()
        });
        (0, $4bMGS.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchConnectorImage (imageId) {
        const imageUrl = `${$ea623d2a8ad55206$var$api.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $ea623d2a8ad55206$var$api.getBlob({
            path: imageUrl,
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders()
        });
        (0, $4bMGS.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
    },
    async fetchNetworkImages () {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $j0fVO.NetworkController).state;
        const ids = requestedCaipNetworks?.map(({ imageId: imageId })=>imageId).filter(Boolean);
        if (ids) await Promise.allSettled(ids.map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchNetworkImage(id)));
    },
    async fetchConnectorImages () {
        const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
        const ids = connectors.map(({ imageId: imageId })=>imageId).filter(Boolean);
        await Promise.allSettled(ids.map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchConnectorImage(id)));
    },
    async fetchFeaturedWallets () {
        const { featuredWalletIds: featuredWalletIds } = (0, $3pfUo.OptionsController).state;
        if (featuredWalletIds?.length) {
            const { data: data } = await $ea623d2a8ad55206$var$api.get({
                path: "/getWallets",
                headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders(),
                params: {
                    page: "1",
                    entries: featuredWalletIds?.length ? String(featuredWalletIds.length) : $ea623d2a8ad55206$var$recommendedEntries,
                    include: featuredWalletIds?.join(",")
                }
            });
            data.sort((a, b)=>featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id));
            const images = data.map((d)=>d.image_id).filter(Boolean);
            await Promise.allSettled(images.map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchWalletImage(id)));
            $ea623d2a8ad55206$var$state.featured = data;
        }
    },
    async fetchRecommendedWallets () {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $3pfUo.OptionsController).state;
        const exclude = [
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $ea623d2a8ad55206$var$api.get({
            path: "/getWallets",
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: $ea623d2a8ad55206$var$recommendedEntries,
                include: includeWalletIds?.join(","),
                exclude: exclude?.join(",")
            }
        });
        const recent = (0, $jheXw.StorageUtil).getRecentWallets();
        const recommendedImages = data.map((d)=>d.image_id).filter(Boolean);
        const recentImages = recent.map((r)=>r.image_id).filter(Boolean);
        await Promise.allSettled([
            ...recommendedImages,
            ...recentImages
        ].map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchWalletImage(id)));
        $ea623d2a8ad55206$var$state.recommended = data;
        $ea623d2a8ad55206$var$state.count = count ?? 0;
    },
    async fetchWallets ({ page: page }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $3pfUo.OptionsController).state;
        const exclude = [
            ...$ea623d2a8ad55206$var$state.recommended.map(({ id: id })=>id),
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $ea623d2a8ad55206$var$api.get({
            path: "/getWallets",
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders(),
            params: {
                page: String(page),
                entries: $ea623d2a8ad55206$var$entries,
                include: includeWalletIds?.join(","),
                exclude: exclude.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchWalletImage(id)),
            (0, $bYnq1.CoreHelperUtil).wait(300)
        ]);
        $ea623d2a8ad55206$var$state.wallets = [
            ...$ea623d2a8ad55206$var$state.wallets,
            ...data
        ];
        $ea623d2a8ad55206$var$state.count = count > $ea623d2a8ad55206$var$state.count ? count : $ea623d2a8ad55206$var$state.count;
        $ea623d2a8ad55206$var$state.page = page;
    },
    async searchWallet ({ search: search }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds } = (0, $3pfUo.OptionsController).state;
        $ea623d2a8ad55206$var$state.search = [];
        const { data: data } = await $ea623d2a8ad55206$var$api.get({
            path: "/getWallets",
            headers: $ea623d2a8ad55206$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: "100",
                search: search,
                include: includeWalletIds?.join(","),
                exclude: excludeWalletIds?.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$ea623d2a8ad55206$export$99411f73957952af._fetchWalletImage(id)),
            (0, $bYnq1.CoreHelperUtil).wait(300)
        ]);
        $ea623d2a8ad55206$var$state.search = data;
    },
    prefetch () {
        $ea623d2a8ad55206$var$state.prefetchPromise = Promise.race([
            Promise.allSettled([
                $ea623d2a8ad55206$export$99411f73957952af.fetchFeaturedWallets(),
                $ea623d2a8ad55206$export$99411f73957952af.fetchRecommendedWallets(),
                $ea623d2a8ad55206$export$99411f73957952af.fetchNetworkImages(),
                $ea623d2a8ad55206$export$99411f73957952af.fetchConnectorImages()
            ]),
            (0, $bYnq1.CoreHelperUtil).wait(3000)
        ]);
    }
};

});
parcelRegister("4lOFi", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", () => $32b06c99ea520e6c$export$ed6eff17d860976a);
class $32b06c99ea520e6c$export$ed6eff17d860976a {
    constructor({ baseUrl: baseUrl }){
        this.baseUrl = baseUrl;
    }
    async get({ headers: headers, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers
        });
        return response.json();
    }
    async getBlob({ headers: headers, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers
        });
        return response.blob();
    }
    async post({ body: body, headers: headers, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined
        });
        return response.json();
    }
    async put({ body: body, headers: headers, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "PUT",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined
        });
        return response.json();
    }
    async delete({ body: body, headers: headers, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "DELETE",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined
        });
        return response.json();
    }
    createUrl({ path: path, params: params }) {
        const url = new URL(path, this.baseUrl);
        if (params) Object.entries(params).forEach(([key, value])=>{
            if (value) url.searchParams.append(key, value);
        });
        return url;
    }
}

});

parcelRegister("jheXw", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", () => $e08b356283c40b9c$export$d4382c6359971b24);
const $e08b356283c40b9c$var$WC_DEEPLINK = "WALLETCONNECT_DEEPLINK_CHOICE";
const $e08b356283c40b9c$var$W3M_RECENT = "@w3m/recent";
const $e08b356283c40b9c$var$W3M_CONNECTED_WALLET_IMAGE_URL = "@w3m/connected_wallet_image_url";
const $e08b356283c40b9c$var$W3M_CONNECTED_CONNECTOR = "@w3m/connected_connector";
const $e08b356283c40b9c$export$d4382c6359971b24 = {
    setWalletConnectDeepLink ({ href: href, name: name }) {
        try {
            localStorage.setItem($e08b356283c40b9c$var$WC_DEEPLINK, JSON.stringify({
                href: href,
                name: name
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink () {
        try {
            const deepLink = localStorage.getItem($e08b356283c40b9c$var$WC_DEEPLINK);
            if (deepLink) return JSON.parse(deepLink);
        } catch  {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink () {
        try {
            localStorage.removeItem($e08b356283c40b9c$var$WC_DEEPLINK);
        } catch  {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setWeb3ModalRecent (wallet) {
        try {
            const recentWallets = $e08b356283c40b9c$export$d4382c6359971b24.getRecentWallets();
            const exists = recentWallets.find((w)=>w.id === wallet.id);
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                localStorage.setItem($e08b356283c40b9c$var$W3M_RECENT, JSON.stringify(recentWallets));
            }
        } catch  {
            console.info("Unable to set Web3Modal recent");
        }
    },
    getRecentWallets () {
        try {
            const recent = localStorage.getItem($e08b356283c40b9c$var$W3M_RECENT);
            return recent ? JSON.parse(recent) : [];
        } catch  {
            console.info("Unable to get Web3Modal recent");
        }
        return [];
    },
    setConnectedWalletImageUrl (imageUrl) {
        try {
            localStorage.setItem($e08b356283c40b9c$var$W3M_CONNECTED_WALLET_IMAGE_URL, imageUrl);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
    },
    getConnectedWalletImageUrl () {
        try {
            return localStorage.getItem($e08b356283c40b9c$var$W3M_CONNECTED_WALLET_IMAGE_URL);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
        return undefined;
    },
    setConnectedConnector (connectorType) {
        try {
            localStorage.setItem($e08b356283c40b9c$var$W3M_CONNECTED_CONNECTOR, connectorType);
        } catch  {
            console.info("Unable to set Connected Connector");
        }
    },
    getConnectedConnector () {
        try {
            return localStorage.getItem($e08b356283c40b9c$var$W3M_CONNECTED_CONNECTOR);
        } catch  {
            console.info("Unable to get Connected Connector");
        }
        return undefined;
    }
};

});

parcelRegister("4bMGS", function(module, exports) {

$parcel$export(module.exports, "AssetController", () => $30cdf56cf054bf31$export$4f2a98fee99335);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");
const $30cdf56cf054bf31$var$state = (0, $lDt57.proxy)({
    walletImages: {},
    networkImages: {},
    connectorImages: {},
    tokenImages: {}
});
const $30cdf56cf054bf31$export$4f2a98fee99335 = {
    state: $30cdf56cf054bf31$var$state,
    subscribeNetworkImages (callback) {
        return (0, $lDt57.subscribe)($30cdf56cf054bf31$var$state.networkImages, ()=>callback($30cdf56cf054bf31$var$state.networkImages));
    },
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($30cdf56cf054bf31$var$state, key, callback);
    },
    setWalletImage (key, value) {
        $30cdf56cf054bf31$var$state.walletImages[key] = value;
    },
    setNetworkImage (key, value) {
        $30cdf56cf054bf31$var$state.networkImages[key] = value;
    },
    setConnectorImage (key, value) {
        $30cdf56cf054bf31$var$state.connectorImages[key] = value;
    },
    setTokenImage (key, value) {
        $30cdf56cf054bf31$var$state.tokenImages[key] = value;
    }
};

});

parcelRegister("8L7Gu", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", () => $6608ac7927121210$export$c83edcb4eee2f517);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $3pfUo = parcelRequire("3pfUo");
const $6608ac7927121210$var$state = (0, $lDt57.proxy)({
    connectors: []
});
const $6608ac7927121210$export$c83edcb4eee2f517 = {
    state: $6608ac7927121210$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($6608ac7927121210$var$state, key, callback);
    },
    setConnectors (connectors) {
        $6608ac7927121210$var$state.connectors = connectors.map((c)=>(0, $lDt57.ref)(c));
    },
    addConnector (connector) {
        $6608ac7927121210$var$state.connectors.push((0, $lDt57.ref)(connector));
        if (connector.id === "w3mEmail") {
            const emailConnector = connector;
            const optionsState = (0, $lDt57.snapshot)((0, $3pfUo.OptionsController).state);
            emailConnector?.provider?.syncDappData?.({
                metadata: optionsState.metadata,
                sdkVersion: optionsState.sdkVersion,
                projectId: optionsState.projectId
            });
        }
    },
    getEmailConnector () {
        return $6608ac7927121210$var$state.connectors.find((c)=>c.type === "EMAIL");
    },
    getAnnouncedConnectorRdns () {
        return $6608ac7927121210$var$state.connectors.filter((c)=>c.type === "ANNOUNCED").map((c)=>c.info?.rdns);
    },
    getConnectors () {
        return $6608ac7927121210$var$state.connectors;
    }
};

});
parcelRegister("3pfUo", function(module, exports) {

$parcel$export(module.exports, "OptionsController", () => $27b00c01999a0bdd$export$1f4c428077fc6173);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");
const $27b00c01999a0bdd$var$state = (0, $lDt57.proxy)({
    projectId: "",
    sdkType: "w3m",
    sdkVersion: "html-wagmi-undefined"
});
const $27b00c01999a0bdd$export$1f4c428077fc6173 = {
    state: $27b00c01999a0bdd$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($27b00c01999a0bdd$var$state, key, callback);
    },
    setProjectId (projectId) {
        $27b00c01999a0bdd$var$state.projectId = projectId;
    },
    setIncludeWalletIds (includeWalletIds) {
        $27b00c01999a0bdd$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds (excludeWalletIds) {
        $27b00c01999a0bdd$var$state.excludeWalletIds = excludeWalletIds;
    },
    setFeaturedWalletIds (featuredWalletIds) {
        $27b00c01999a0bdd$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens (tokens) {
        $27b00c01999a0bdd$var$state.tokens = tokens;
    },
    setTermsConditionsUrl (termsConditionsUrl) {
        $27b00c01999a0bdd$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl (privacyPolicyUrl) {
        $27b00c01999a0bdd$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets (customWallets) {
        $27b00c01999a0bdd$var$state.customWallets = customWallets;
    },
    setEnableAnalytics (enableAnalytics) {
        $27b00c01999a0bdd$var$state.enableAnalytics = enableAnalytics;
    },
    setSdkVersion (sdkVersion) {
        $27b00c01999a0bdd$var$state.sdkVersion = sdkVersion;
    },
    setMetadata (metadata) {
        $27b00c01999a0bdd$var$state.metadata = metadata;
    }
};

});


parcelRegister("j0fVO", function(module, exports) {

$parcel$export(module.exports, "NetworkController", () => $dd5a600fe446efa7$export$c63f10f788d47d86);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $dTOcV = parcelRequire("dTOcV");
const $dd5a600fe446efa7$var$state = (0, $lDt57.proxy)({
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false
});
const $dd5a600fe446efa7$export$c63f10f788d47d86 = {
    state: $dd5a600fe446efa7$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($dd5a600fe446efa7$var$state, key, callback);
    },
    _getClient () {
        if (!$dd5a600fe446efa7$var$state._client) throw new Error("NetworkController client not set");
        return $dd5a600fe446efa7$var$state._client;
    },
    setClient (client) {
        $dd5a600fe446efa7$var$state._client = (0, $lDt57.ref)(client);
    },
    setCaipNetwork (caipNetwork) {
        $dd5a600fe446efa7$var$state.caipNetwork = caipNetwork;
        (0, $dTOcV.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
    },
    setDefaultCaipNetwork (caipNetwork) {
        $dd5a600fe446efa7$var$state.caipNetwork = caipNetwork;
        (0, $dTOcV.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
        $dd5a600fe446efa7$var$state.isDefaultCaipNetwork = true;
    },
    setRequestedCaipNetworks (requestedNetworks) {
        $dd5a600fe446efa7$var$state.requestedCaipNetworks = requestedNetworks;
    },
    async getApprovedCaipNetworksData () {
        const data = await this._getClient().getApprovedCaipNetworksData();
        $dd5a600fe446efa7$var$state.supportsAllNetworks = data.supportsAllNetworks;
        $dd5a600fe446efa7$var$state.approvedCaipNetworkIds = data.approvedCaipNetworkIds;
    },
    async switchActiveNetwork (network) {
        await this._getClient().switchCaipNetwork(network);
        $dd5a600fe446efa7$var$state.caipNetwork = network;
    },
    resetNetwork () {
        if (!$dd5a600fe446efa7$var$state.isDefaultCaipNetwork) $dd5a600fe446efa7$var$state.caipNetwork = undefined;
        $dd5a600fe446efa7$var$state.approvedCaipNetworkIds = undefined;
        $dd5a600fe446efa7$var$state.supportsAllNetworks = true;
    }
};

});
parcelRegister("dTOcV", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", () => $a1e75b972e4dd773$export$24bc8c77cb7c530);

var $lDt57 = parcelRequire("lDt57");
const $a1e75b972e4dd773$var$state = (0, $lDt57.proxy)({
    open: false,
    selectedNetworkId: undefined
});
const $a1e75b972e4dd773$export$24bc8c77cb7c530 = {
    state: $a1e75b972e4dd773$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($a1e75b972e4dd773$var$state, ()=>callback($a1e75b972e4dd773$var$state));
    },
    set (newState) {
        Object.assign($a1e75b972e4dd773$var$state, {
            ...$a1e75b972e4dd773$var$state,
            ...newState
        });
    }
};

});



parcelRegister("bE42d", function(module, exports) {

$parcel$export(module.exports, "EventsController", () => $87a68f5cc8ff1ff3$export$23ca5cb260756952);

var $lDt57 = parcelRequire("lDt57");

var $bYnq1 = parcelRequire("bYnq1");

var $4lOFi = parcelRequire("4lOFi");

var $3pfUo = parcelRequire("3pfUo");
const $87a68f5cc8ff1ff3$var$baseUrl = (0, $bYnq1.CoreHelperUtil).getAnalyticsUrl();
const $87a68f5cc8ff1ff3$var$api = new (0, $4lOFi.FetchUtil)({
    baseUrl: $87a68f5cc8ff1ff3$var$baseUrl
});
const $87a68f5cc8ff1ff3$var$excluded = [
    "MODAL_CREATED"
];
const $87a68f5cc8ff1ff3$var$state = (0, $lDt57.proxy)({
    timestamp: Date.now(),
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
const $87a68f5cc8ff1ff3$export$23ca5cb260756952 = {
    state: $87a68f5cc8ff1ff3$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($87a68f5cc8ff1ff3$var$state, ()=>callback($87a68f5cc8ff1ff3$var$state));
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $3pfUo.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _sendAnalyticsEvent (payload) {
        try {
            if ($87a68f5cc8ff1ff3$var$excluded.includes(payload.data.event) || typeof window === "undefined") return;
            await $87a68f5cc8ff1ff3$var$api.post({
                path: "/e",
                headers: $87a68f5cc8ff1ff3$export$23ca5cb260756952._getApiHeaders(),
                body: {
                    eventId: (0, $bYnq1.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: payload.timestamp,
                    props: payload.data
                }
            });
        } catch  {}
    },
    sendEvent (data) {
        $87a68f5cc8ff1ff3$var$state.timestamp = Date.now();
        $87a68f5cc8ff1ff3$var$state.data = data;
        if ((0, $3pfUo.OptionsController).state.enableAnalytics) $87a68f5cc8ff1ff3$export$23ca5cb260756952._sendAnalyticsEvent($87a68f5cc8ff1ff3$var$state);
    }
};

});

parcelRegister("eMpli", function(module, exports) {

$parcel$export(module.exports, "RouterController", () => $ac2934e3ed5cf17e$export$5ceead2526330ba8);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");
const $ac2934e3ed5cf17e$var$state = (0, $lDt57.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ]
});
const $ac2934e3ed5cf17e$export$5ceead2526330ba8 = {
    state: $ac2934e3ed5cf17e$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($ac2934e3ed5cf17e$var$state, key, callback);
    },
    push (view, data) {
        if (view !== $ac2934e3ed5cf17e$var$state.view) {
            $ac2934e3ed5cf17e$var$state.view = view;
            $ac2934e3ed5cf17e$var$state.history.push(view);
            $ac2934e3ed5cf17e$var$state.data = data;
        }
    },
    reset (view) {
        $ac2934e3ed5cf17e$var$state.view = view;
        $ac2934e3ed5cf17e$var$state.history = [
            view
        ];
    },
    replace (view, data) {
        if ($ac2934e3ed5cf17e$var$state.history.length > 1 && $ac2934e3ed5cf17e$var$state.history.at(-1) !== view) {
            $ac2934e3ed5cf17e$var$state.view = view;
            $ac2934e3ed5cf17e$var$state.history[$ac2934e3ed5cf17e$var$state.history.length - 1] = view;
            $ac2934e3ed5cf17e$var$state.data = data;
        }
    },
    goBack () {
        if ($ac2934e3ed5cf17e$var$state.history.length > 1) {
            $ac2934e3ed5cf17e$var$state.history.pop();
            const [last] = $ac2934e3ed5cf17e$var$state.history.slice(-1);
            if (last) $ac2934e3ed5cf17e$var$state.view = last;
        }
    },
    goBackToIndex (historyIndex) {
        if ($ac2934e3ed5cf17e$var$state.history.length > 1) {
            $ac2934e3ed5cf17e$var$state.history = $ac2934e3ed5cf17e$var$state.history.slice(0, historyIndex + 1);
            const [last] = $ac2934e3ed5cf17e$var$state.history.slice(-1);
            if (last) $ac2934e3ed5cf17e$var$state.view = last;
        }
    }
};

});


parcelRegister("58zho", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", () => $3bd910e8c4fd90a4$export$303deccbe6e8c782);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $bYnq1 = parcelRequire("bYnq1");

var $jheXw = parcelRequire("jheXw");

var $6G808 = parcelRequire("6G808");
const $3bd910e8c4fd90a4$var$state = (0, $lDt57.proxy)({
    wcError: false,
    buffering: false
});
const $3bd910e8c4fd90a4$export$303deccbe6e8c782 = {
    state: $3bd910e8c4fd90a4$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($3bd910e8c4fd90a4$var$state, key, callback);
    },
    _getClient () {
        if (!$3bd910e8c4fd90a4$var$state._client) throw new Error("ConnectionController client not set");
        return $3bd910e8c4fd90a4$var$state._client;
    },
    setClient (client) {
        $3bd910e8c4fd90a4$var$state._client = (0, $lDt57.ref)(client);
    },
    connectWalletConnect () {
        $3bd910e8c4fd90a4$var$state.wcPromise = this._getClient().connectWalletConnect((uri)=>{
            $3bd910e8c4fd90a4$var$state.wcUri = uri;
            $3bd910e8c4fd90a4$var$state.wcPairingExpiry = (0, $bYnq1.CoreHelperUtil).getPairingExpiry();
        });
    },
    async connectExternal (options) {
        await this._getClient().connectExternal?.(options);
        (0, $jheXw.StorageUtil).setConnectedConnector(options.type);
    },
    async signMessage (message) {
        return this._getClient().signMessage(message);
    },
    checkInstalled (ids) {
        return this._getClient().checkInstalled?.(ids);
    },
    resetWcConnection () {
        $3bd910e8c4fd90a4$var$state.wcUri = undefined;
        $3bd910e8c4fd90a4$var$state.wcPairingExpiry = undefined;
        $3bd910e8c4fd90a4$var$state.wcPromise = undefined;
        $3bd910e8c4fd90a4$var$state.wcLinking = undefined;
        $3bd910e8c4fd90a4$var$state.recentWallet = undefined;
        (0, $6G808.TransactionsController).resetTransactions();
        (0, $jheXw.StorageUtil).deleteWalletConnectDeepLink();
    },
    setWcLinking (wcLinking) {
        $3bd910e8c4fd90a4$var$state.wcLinking = wcLinking;
    },
    setWcError (wcError) {
        $3bd910e8c4fd90a4$var$state.wcError = wcError;
        $3bd910e8c4fd90a4$var$state.buffering = false;
    },
    setRecentWallet (wallet) {
        $3bd910e8c4fd90a4$var$state.recentWallet = wallet;
    },
    setBuffering (buffering) {
        $3bd910e8c4fd90a4$var$state.buffering = buffering;
    },
    async disconnect () {
        await this._getClient().disconnect();
        this.resetWcConnection();
    }
};

});
parcelRegister("6G808", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", () => $4dccdf30f6eaa8a0$export$da1e018e28e23fb0);

var $lDt57 = parcelRequire("lDt57");

var $cHcnO = parcelRequire("cHcnO");

var $3pfUo = parcelRequire("3pfUo");

var $bE42d = parcelRequire("bE42d");

var $45Xo0 = parcelRequire("45Xo0");
const $4dccdf30f6eaa8a0$var$state = (0, $lDt57.proxy)({
    transactions: [],
    transactionsByYear: {},
    loading: false,
    empty: false,
    next: undefined
});
const $4dccdf30f6eaa8a0$export$da1e018e28e23fb0 = {
    state: $4dccdf30f6eaa8a0$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($4dccdf30f6eaa8a0$var$state, ()=>callback($4dccdf30f6eaa8a0$var$state));
    },
    async fetchTransactions (accountAddress) {
        const { projectId: projectId } = (0, $3pfUo.OptionsController).state;
        if (!projectId || !accountAddress) throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
        $4dccdf30f6eaa8a0$var$state.loading = true;
        try {
            const response = await (0, $cHcnO.BlockchainApiController).fetchTransactions({
                account: accountAddress,
                projectId: projectId,
                cursor: $4dccdf30f6eaa8a0$var$state.next
            });
            const nonSpamTransactions = this.filterSpamTransactions(response.data);
            const filteredTransactions = [
                ...$4dccdf30f6eaa8a0$var$state.transactions,
                ...nonSpamTransactions
            ];
            $4dccdf30f6eaa8a0$var$state.loading = false;
            $4dccdf30f6eaa8a0$var$state.transactions = filteredTransactions;
            $4dccdf30f6eaa8a0$var$state.transactionsByYear = this.groupTransactionsByYear($4dccdf30f6eaa8a0$var$state.transactionsByYear, nonSpamTransactions);
            $4dccdf30f6eaa8a0$var$state.empty = filteredTransactions.length === 0;
            $4dccdf30f6eaa8a0$var$state.next = response.next ? response.next : undefined;
        } catch (error) {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "ERROR_FETCH_TRANSACTIONS",
                properties: {
                    address: accountAddress,
                    projectId: projectId,
                    cursor: $4dccdf30f6eaa8a0$var$state.next
                }
            });
            (0, $45Xo0.SnackController).showError("Failed to fetch transactions");
            $4dccdf30f6eaa8a0$var$state.loading = false;
            $4dccdf30f6eaa8a0$var$state.empty = true;
        }
    },
    groupTransactionsByYear (transactionsMap = {}, transactions = []) {
        const grouped = transactionsMap;
        transactions.forEach((transaction)=>{
            const year = new Date(transaction.metadata.minedAt).getFullYear();
            if (!grouped[year]) grouped[year] = [];
            grouped[year]?.push(transaction);
        });
        return grouped;
    },
    filterSpamTransactions (transactions) {
        return transactions.filter((transaction)=>{
            const isAllSpam = transaction.transfers.every((transfer)=>transfer.nft_info?.flags.is_spam === true);
            return !isAllSpam;
        });
    },
    resetTransactions () {
        $4dccdf30f6eaa8a0$var$state.transactions = [];
        $4dccdf30f6eaa8a0$var$state.transactionsByYear = {};
        $4dccdf30f6eaa8a0$var$state.loading = false;
        $4dccdf30f6eaa8a0$var$state.empty = false;
        $4dccdf30f6eaa8a0$var$state.next = undefined;
    }
};

});
parcelRegister("cHcnO", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", () => $93e31b3ac53d6052$export$9c45fcf03cadbfaa);

var $bYnq1 = parcelRequire("bYnq1");

var $4lOFi = parcelRequire("4lOFi");

var $3pfUo = parcelRequire("3pfUo");
const $93e31b3ac53d6052$var$baseUrl = (0, $bYnq1.CoreHelperUtil).getBlockchainApiUrl();
const $93e31b3ac53d6052$var$api = new (0, $4lOFi.FetchUtil)({
    baseUrl: $93e31b3ac53d6052$var$baseUrl
});
const $93e31b3ac53d6052$export$9c45fcf03cadbfaa = {
    fetchIdentity ({ caipChainId: caipChainId, address: address }) {
        return $93e31b3ac53d6052$var$api.get({
            path: `/v1/identity/${address}`,
            params: {
                chainId: caipChainId,
                projectId: (0, $3pfUo.OptionsController).state.projectId
            }
        });
    },
    fetchTransactions ({ account: account, projectId: projectId, cursor: cursor }) {
        const queryParams = cursor ? {
            cursor: cursor
        } : {};
        return $93e31b3ac53d6052$var$api.get({
            path: `/v1/account/${account}/history?projectId=${projectId}`,
            params: queryParams
        });
    }
};

});

parcelRegister("45Xo0", function(module, exports) {

$parcel$export(module.exports, "SnackController", () => $2fb5b1ef09336b9f$export$506cae4b4f746de7);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");

var $bYnq1 = parcelRequire("bYnq1");
const $2fb5b1ef09336b9f$var$state = (0, $lDt57.proxy)({
    message: "",
    variant: "success",
    open: false
});
const $2fb5b1ef09336b9f$export$506cae4b4f746de7 = {
    state: $2fb5b1ef09336b9f$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($2fb5b1ef09336b9f$var$state, key, callback);
    },
    showSuccess (message) {
        $2fb5b1ef09336b9f$var$state.message = message;
        $2fb5b1ef09336b9f$var$state.variant = "success";
        $2fb5b1ef09336b9f$var$state.open = true;
    },
    showError (message) {
        const errorMessage = (0, $bYnq1.CoreHelperUtil).parseError(message);
        $2fb5b1ef09336b9f$var$state.message = errorMessage;
        $2fb5b1ef09336b9f$var$state.variant = "error";
        $2fb5b1ef09336b9f$var$state.open = true;
    },
    hide () {
        $2fb5b1ef09336b9f$var$state.open = false;
    }
};

});



parcelRegister("afSSl", function(module, exports) {

$parcel$export(module.exports, "SIWEController", () => $7775df3d7fadc889$export$3ff5b538099e7763);

var $8tzvu = parcelRequire("8tzvu");

var $lDt57 = parcelRequire("lDt57");
const $7775df3d7fadc889$var$state = (0, $lDt57.proxy)({
    status: "uninitialized",
    isSiweEnabled: false
});
const $7775df3d7fadc889$export$3ff5b538099e7763 = {
    state: $7775df3d7fadc889$var$state,
    subscribeKey (key, callback) {
        return (0, $8tzvu.subscribeKey)($7775df3d7fadc889$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $lDt57.subscribe)($7775df3d7fadc889$var$state, ()=>callback($7775df3d7fadc889$var$state));
    },
    _getClient () {
        if (!$7775df3d7fadc889$var$state._client) throw new Error("SIWEController client not set");
        return $7775df3d7fadc889$var$state._client;
    },
    async getNonce () {
        const client = this._getClient();
        const nonce = await client.getNonce();
        this.setNonce(nonce);
        return nonce;
    },
    async getSession () {
        const client = this._getClient();
        const session = await client.getSession();
        if (session) {
            this.setSession(session);
            this.setStatus("success");
        }
        return session;
    },
    createMessage (args) {
        const client = this._getClient();
        const message = client.createMessage(args);
        this.setMessage(message);
        return message;
    },
    async verifyMessage (args) {
        const client = this._getClient();
        const isValid = await client.verifyMessage(args);
        return isValid;
    },
    async signIn () {
        const client = this._getClient();
        const session = await client.signIn();
        return session;
    },
    async signOut () {
        const client = this._getClient();
        await client.signOut();
        this.setStatus("ready");
        client.onSignOut?.();
    },
    onSignIn (args) {
        const client = this._getClient();
        client.onSignIn?.(args);
    },
    onSignOut () {
        const client = this._getClient();
        client.onSignOut?.();
    },
    setSIWEClient (client) {
        $7775df3d7fadc889$var$state._client = (0, $lDt57.ref)(client);
        $7775df3d7fadc889$var$state.status = "ready";
        $7775df3d7fadc889$var$state.isSiweEnabled = client.options.enabled;
    },
    setNonce (nonce) {
        $7775df3d7fadc889$var$state.nonce = nonce;
    },
    setStatus (status) {
        $7775df3d7fadc889$var$state.status = status;
    },
    setMessage (message) {
        $7775df3d7fadc889$var$state.message = message;
    },
    setSession (session) {
        $7775df3d7fadc889$var$state.session = session;
    }
};

});

parcelRegister("eMTTW", function(module, exports) {

$parcel$export(module.exports, "ThemeController", () => $ac40e935e83eaa8a$export$e18d4112326e72bf);

var $lDt57 = parcelRequire("lDt57");
const $ac40e935e83eaa8a$var$state = (0, $lDt57.proxy)({
    themeMode: "dark",
    themeVariables: {}
});
const $ac40e935e83eaa8a$export$e18d4112326e72bf = {
    state: $ac40e935e83eaa8a$var$state,
    subscribe (callback) {
        return (0, $lDt57.subscribe)($ac40e935e83eaa8a$var$state, ()=>callback($ac40e935e83eaa8a$var$state));
    },
    setThemeMode (themeMode) {
        $ac40e935e83eaa8a$var$state.themeMode = themeMode;
    },
    setThemeVariables (themeVariables) {
        $ac40e935e83eaa8a$var$state.themeVariables = {
            ...$ac40e935e83eaa8a$var$state.themeVariables,
            ...themeVariables
        };
    },
    getSnapshot () {
        return (0, $lDt57.snapshot)($ac40e935e83eaa8a$var$state);
    }
};

});

parcelRegister("efzgw", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", () => $a5fdd25ef81f138c$export$2a2d471f51b1e9cb);

var $4bMGS = parcelRequire("4bMGS");
const $a5fdd25ef81f138c$export$2a2d471f51b1e9cb = {
    getWalletImage (wallet) {
        if (wallet?.image_url) return wallet?.image_url;
        if (wallet?.image_id) return (0, $4bMGS.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage (network) {
        if (network?.imageUrl) return network?.imageUrl;
        if (network?.imageId) return (0, $4bMGS.AssetController).state.networkImages[network.imageId];
        return undefined;
    },
    getConnectorImage (connector) {
        if (connector?.imageUrl) return connector.imageUrl;
        if (connector?.imageId) return (0, $4bMGS.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    }
};

});

parcelRegister("ap614", function(module, exports) {

$parcel$export(module.exports, "RouterUtil", () => $7930e7e411b37591$export$12c6341a287a74e0);

var $eMpli = parcelRequire("eMpli");

var $6CqNZ = parcelRequire("6CqNZ");
const $7930e7e411b37591$export$12c6341a287a74e0 = {
    goBackOrCloseModal () {
        if ((0, $eMpli.RouterController).state.history.length > 1) (0, $eMpli.RouterController).goBack();
        else (0, $6CqNZ.ModalController).close();
    },
    navigateAfterNetworkSwitch () {
        const { history: history } = (0, $eMpli.RouterController).state;
        const networkSelectIndex = history.findIndex((name)=>name === "Networks");
        if (networkSelectIndex >= 1) (0, $eMpli.RouterController).goBackToIndex(networkSelectIndex - 1);
        else (0, $6CqNZ.ModalController).close();
    }
};

});


parcelRegister("8rB26", function(module, exports) {

$parcel$export(module.exports, "default", () => $625d9255e73e8d08$export$2e2bcd8739ae039);
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $625d9255e73e8d08$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    z-index: var(--w3m-z-index);
    display: block;
    backface-visibility: hidden;
    will-change: opacity;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    background-color: var(--wui-cover);
  }

  @keyframes zoom-in {
    0% {
      transform: scale(0.95) translateY(0);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  @keyframes slide-in {
    0% {
      transform: scale(1) translateY(50px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  wui-card {
    max-width: 360px;
    width: 100%;
    position: relative;
    animation-delay: 0.3s;
    animation-duration: 0.2s;
    animation-name: zoom-in;
    animation-fill-mode: backwards;
    animation-timing-function: var(--wui-ease-out-power-2);
    outline: none;
  }

  wui-flex {
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  @media (max-height: 700px) and (min-width: 431px) {
    wui-flex {
      align-items: flex-start;
    }

    wui-card {
      margin: var(--wui-spacing-xxl) 0px;
    }
  }

  @media (max-width: 430px) {
    wui-flex {
      align-items: flex-end;
    }

    wui-card {
      max-width: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      animation-name: slide-in;
    }
  }
`;

});


parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRegister("b2ObJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("kj0Wa"),
    $Gr8vk("fQO01")
]).then(()=>parcelRequire("3Q10N"));

});

parcelRegister("eeGmU", function(module, exports) {

$parcel$export(module.exports, "parseChainId", () => $a5d33cfc7f8e5437$export$4764229d78de4437);
$parcel$export(module.exports, "getAccountsFromNamespaces", () => $a5d33cfc7f8e5437$export$23329703ad972840);
$parcel$export(module.exports, "BASE16", () => $a5d33cfc7f8e5437$export$49eb910ab2518105);
$parcel$export(module.exports, "TYPE_1", () => $a5d33cfc7f8e5437$export$406e97c329f0f3d4);
$parcel$export(module.exports, "generateKeyPair", () => $a5d33cfc7f8e5437$export$a949d36eab55b41f);
$parcel$export(module.exports, "generateRandomBytes32", () => $a5d33cfc7f8e5437$export$d15a28e4f1821243);
$parcel$export(module.exports, "deriveSymKey", () => $a5d33cfc7f8e5437$export$f8378f68e053f5c6);
$parcel$export(module.exports, "hashKey", () => $a5d33cfc7f8e5437$export$1e87d19d4aab5805);
$parcel$export(module.exports, "hashMessage", () => $a5d33cfc7f8e5437$export$d4c241cec96564c1);
$parcel$export(module.exports, "decodeTypeByte", () => $a5d33cfc7f8e5437$export$7547a514ee29b9d4);
$parcel$export(module.exports, "encrypt", () => $a5d33cfc7f8e5437$export$5b0f6292f11d1d18);
$parcel$export(module.exports, "decrypt", () => $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3);
$parcel$export(module.exports, "deserialize", () => $a5d33cfc7f8e5437$export$efcd34ab6248d3cd);
$parcel$export(module.exports, "validateDecoding", () => $a5d33cfc7f8e5437$export$177f3e316562333d);
$parcel$export(module.exports, "validateEncoding", () => $a5d33cfc7f8e5437$export$7949f60f2444aef2);
$parcel$export(module.exports, "isTypeOneEnvelope", () => $a5d33cfc7f8e5437$export$8c165704db2d5c15);
$parcel$export(module.exports, "isNode", () => $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isReactNative", () => $a5d33cfc7f8e5437$export$f7a1e23e542d38e3);
$parcel$export(module.exports, "isBrowser", () => $a5d33cfc7f8e5437$export$4e09c449d6c407f7);
$parcel$export(module.exports, "getBundleId", () => $a5d33cfc7f8e5437$export$40a40f90174d197c);
$parcel$export(module.exports, "getAppMetadata", () => $a5d33cfc7f8e5437$export$ba31e015127122bb);
$parcel$export(module.exports, "formatRelayRpcUrl", () => $a5d33cfc7f8e5437$export$d875b3963ef774f5);
$parcel$export(module.exports, "mapToObj", () => $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9);
$parcel$export(module.exports, "objToMap", () => $a5d33cfc7f8e5437$export$ac31b37c726bc3ba);
$parcel$export(module.exports, "createDelayedPromise", () => $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb);
$parcel$export(module.exports, "createExpiringPromise", () => $a5d33cfc7f8e5437$export$3da2293b007ed708);
$parcel$export(module.exports, "formatTopicTarget", () => $a5d33cfc7f8e5437$export$43ab92477f8713b9);
$parcel$export(module.exports, "formatIdTarget", () => $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3);
$parcel$export(module.exports, "parseExpirerTarget", () => $a5d33cfc7f8e5437$export$93adeb0f16e8e51d);
$parcel$export(module.exports, "calcExpiry", () => $a5d33cfc7f8e5437$export$b136d03015bfc12);
$parcel$export(module.exports, "isExpired", () => $a5d33cfc7f8e5437$export$57947cfd429801a2);
$parcel$export(module.exports, "engineEvent", () => $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9);
$parcel$export(module.exports, "mergeArrays", () => $a5d33cfc7f8e5437$export$9826fe7ad3921016);
$parcel$export(module.exports, "handleDeeplinkRedirect", () => $a5d33cfc7f8e5437$export$694a208c8abca99a);
$parcel$export(module.exports, "getDeepLink", () => $a5d33cfc7f8e5437$export$e55bfdac47149a32);
$parcel$export(module.exports, "getRelayProtocolName", () => $a5d33cfc7f8e5437$export$cf77af25151525db);
$parcel$export(module.exports, "getRelayProtocolApi", () => $a5d33cfc7f8e5437$export$604e3deb95e1b734);
$parcel$export(module.exports, "parseUri", () => $a5d33cfc7f8e5437$export$59f58847421cfb28);
$parcel$export(module.exports, "formatUri", () => $a5d33cfc7f8e5437$export$b2786ede34fb2350);
$parcel$export(module.exports, "getRequiredNamespacesFromNamespaces", () => $a5d33cfc7f8e5437$export$a8daa26a7c60ef90);
$parcel$export(module.exports, "isValidNamespaces", () => $a5d33cfc7f8e5437$export$93f7b81dc815a714);
$parcel$export(module.exports, "normalizeNamespaces", () => $a5d33cfc7f8e5437$export$2994550cda701c96);
$parcel$export(module.exports, "isConformingNamespaces", () => $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4);
$parcel$export(module.exports, "isCaipNamespace", () => $a5d33cfc7f8e5437$export$e03e993df4723bde);
$parcel$export(module.exports, "parseNamespaceKey", () => $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8);
$parcel$export(module.exports, "isValidObject", () => $a5d33cfc7f8e5437$export$16a0268bc22b47b0);
$parcel$export(module.exports, "getInternalError", () => $a5d33cfc7f8e5437$export$500d4c4a8fafe35);
$parcel$export(module.exports, "getSdkError", () => $a5d33cfc7f8e5437$export$8203ef1531c8b5b5);
$parcel$export(module.exports, "isValidArray", () => $a5d33cfc7f8e5437$export$41dd3d480aac4a71);
$parcel$export(module.exports, "isUndefined", () => $a5d33cfc7f8e5437$export$fce6876652108ab);
$parcel$export(module.exports, "isValidString", () => $a5d33cfc7f8e5437$export$ee898ca48ab56c74);
$parcel$export(module.exports, "isSessionCompatible", () => $a5d33cfc7f8e5437$export$6fc4971bf8f326a);
$parcel$export(module.exports, "isValidUrl", () => $a5d33cfc7f8e5437$export$bef94a5618bf18bf);
$parcel$export(module.exports, "isProposalStruct", () => $a5d33cfc7f8e5437$export$f657f7976bb2769d);
$parcel$export(module.exports, "isSessionStruct", () => $a5d33cfc7f8e5437$export$c96d5113768aaf5e);
$parcel$export(module.exports, "isValidController", () => $a5d33cfc7f8e5437$export$5e1c5c89613c213f);
$parcel$export(module.exports, "isValidRequiredNamespaces", () => $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3);
$parcel$export(module.exports, "isValidRelay", () => $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b);
$parcel$export(module.exports, "isValidRelays", () => $a5d33cfc7f8e5437$export$6294c30b976bd21e);
$parcel$export(module.exports, "isValidId", () => $a5d33cfc7f8e5437$export$53551be28ad5e34d);
$parcel$export(module.exports, "isValidParams", () => $a5d33cfc7f8e5437$export$b3f5fcca1d210454);
$parcel$export(module.exports, "isValidErrorReason", () => $a5d33cfc7f8e5437$export$766fe78377d96f2a);
$parcel$export(module.exports, "isValidRequest", () => $a5d33cfc7f8e5437$export$1a2af3c017fb6d42);
$parcel$export(module.exports, "isValidResponse", () => $a5d33cfc7f8e5437$export$1ae38cf0a848f651);
$parcel$export(module.exports, "isValidEvent", () => $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11);
$parcel$export(module.exports, "isValidNamespacesChainId", () => $a5d33cfc7f8e5437$export$144fc36610eb6522);
$parcel$export(module.exports, "isValidNamespacesRequest", () => $a5d33cfc7f8e5437$export$8db4804e3a6de711);
$parcel$export(module.exports, "isValidNamespacesEvent", () => $a5d33cfc7f8e5437$export$df2c67ef8baad16b);
$parcel$export(module.exports, "isValidRequestExpiry", () => $a5d33cfc7f8e5437$export$59fba2af1ac782b);
$parcel$export(module.exports, "isOnline", () => $a5d33cfc7f8e5437$export$53c2fd0173ad2b80);
$parcel$export(module.exports, "subscribeToNetworkChange", () => $a5d33cfc7f8e5437$export$600a1ee4bc680996);
$parcel$export(module.exports, "MemoryStore", () => $a5d33cfc7f8e5437$export$b72d712fed4d036d);

var $2sz3e = parcelRequire("2sz3e");

var $kun4A = parcelRequire("kun4A");

var $9Ve5w = parcelRequire("9Ve5w");

var $8N2RK = parcelRequire("8N2RK");

var $7qMke = parcelRequire("7qMke");

var $a2jTq = parcelRequire("a2jTq");

var $6enPC = parcelRequire("6enPC");

var $aG48A = parcelRequire("aG48A");

var $dsfPE = parcelRequire("dsfPE");

var $8Wm94 = parcelRequire("8Wm94");

var $kJj3y = parcelRequire("kJj3y");
parcelRequire("9iPTB");
var $ehMqO = parcelRequire("ehMqO");

var $hPtJY = parcelRequire("hPtJY");
const $a5d33cfc7f8e5437$var$K = ":";
function $a5d33cfc7f8e5437$export$4764229d78de4437(e) {
    const [n, t] = e.split($a5d33cfc7f8e5437$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $a5d33cfc7f8e5437$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($a5d33cfc7f8e5437$var$K);
}
function $a5d33cfc7f8e5437$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($a5d33cfc7f8e5437$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $a5d33cfc7f8e5437$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($a5d33cfc7f8e5437$var$K);
}
function $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $a5d33cfc7f8e5437$export$2806d446053abd1d(e) {
    const { address: n } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return n;
}
function $a5d33cfc7f8e5437$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return $a5d33cfc7f8e5437$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $a5d33cfc7f8e5437$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $a5d33cfc7f8e5437$export$4764229d78de4437(n);
    return $a5d33cfc7f8e5437$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $a5d33cfc7f8e5437$export$aa4a6b630dfcfa83(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$2806d446053abd1d);
}
function $a5d33cfc7f8e5437$export$d5ee58c6b13696e9(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$93512919ec2ab555);
}
function $a5d33cfc7f8e5437$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $a5d33cfc7f8e5437$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $a5d33cfc7f8e5437$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$376384387cd15b27(r, o));
    }), t;
}
function $a5d33cfc7f8e5437$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $a5d33cfc7f8e5437$export$a524ae552db7912 = (e)=>e?.split(":"), $a5d33cfc7f8e5437$export$85f23c05c80b194 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[3];
}, $a5d33cfc7f8e5437$export$a8b149927aef7051 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $a5d33cfc7f8e5437$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$a5d33cfc7f8e5437$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $a5d33cfc7f8e5437$export$f7403969428298bd = "base10", $a5d33cfc7f8e5437$export$49eb910ab2518105 = "base16", $a5d33cfc7f8e5437$export$9bff723d552e6bcf = "base64pad", $a5d33cfc7f8e5437$export$9560dad2a83e4f04 = "utf8", $a5d33cfc7f8e5437$export$3425bd336a9673d8 = 0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4 = 1, $a5d33cfc7f8e5437$var$Dn = 0, $a5d33cfc7f8e5437$var$Pe = 1, $a5d33cfc7f8e5437$var$Z = 12, $a5d33cfc7f8e5437$var$X = 32;
function $a5d33cfc7f8e5437$export$a949d36eab55b41f() {
    const e = $7qMke.generateKeyPair();
    return {
        privateKey: (0, $a2jTq.toString)(e.secretKey, $a5d33cfc7f8e5437$export$49eb910ab2518105),
        publicKey: (0, $a2jTq.toString)(e.publicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)
    };
}
function $a5d33cfc7f8e5437$export$d15a28e4f1821243() {
    const e = (0, $9Ve5w.randomBytes)($a5d33cfc7f8e5437$var$X);
    return (0, $a2jTq.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$f8378f68e053f5c6(e, n) {
    const t = $7qMke.sharedKey((0, $a2jTq.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105), (0, $a2jTq.fromString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105), !0), r = new (0, $kun4A.HKDF)((0, $8N2RK.SHA256), t).expand($a5d33cfc7f8e5437$var$X);
    return (0, $a2jTq.toString)(r, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$1e87d19d4aab5805(e) {
    const n = (0, $8N2RK.hash)((0, $a2jTq.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105));
    return (0, $a2jTq.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$d4c241cec96564c1(e) {
    const n = (0, $8N2RK.hash)((0, $a2jTq.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return (0, $a2jTq.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(e) {
    return (0, $a2jTq.fromString)(`${e}`, $a5d33cfc7f8e5437$export$f7403969428298bd);
}
function $a5d33cfc7f8e5437$export$7547a514ee29b9d4(e) {
    return Number((0, $a2jTq.toString)(e, $a5d33cfc7f8e5437$export$f7403969428298bd));
}
function $a5d33cfc7f8e5437$export$5b0f6292f11d1d18(e) {
    const n = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $a5d33cfc7f8e5437$export$3425bd336a9673d8);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(n) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $a2jTq.fromString)(e.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $a2jTq.fromString)(e.iv, $a5d33cfc7f8e5437$export$49eb910ab2518105) : (0, $9Ve5w.randomBytes)($a5d33cfc7f8e5437$var$Z), o = new (0, $2sz3e.ChaCha20Poly1305)((0, $a2jTq.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)).seal(r, (0, $a2jTq.fromString)(e.message, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $2sz3e.ChaCha20Poly1305)((0, $a2jTq.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)), { sealed: t, iv: r } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $a2jTq.toString)(o, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb(e) {
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $a2jTq.toString)((0, $a2jTq.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
    }
    return (0, $a2jTq.toString)((0, $a2jTq.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
}
function $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e) {
    const n = (0, $a2jTq.fromString)(e, $a5d33cfc7f8e5437$export$9bff723d552e6bcf), t = n.slice($a5d33cfc7f8e5437$var$Dn, $a5d33cfc7f8e5437$var$Pe), r = $a5d33cfc7f8e5437$var$Pe;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(t) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        const d = r + $a5d33cfc7f8e5437$var$X, l = d + $a5d33cfc7f8e5437$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $a5d33cfc7f8e5437$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $a5d33cfc7f8e5437$export$177f3e316562333d(e, n) {
    const t = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e);
    return $a5d33cfc7f8e5437$export$7949f60f2444aef2({
        type: $a5d33cfc7f8e5437$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $a2jTq.toString)(t.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $a5d33cfc7f8e5437$export$7949f60f2444aef2(e) {
    const n = e?.type || $a5d33cfc7f8e5437$export$3425bd336a9673d8;
    if (n === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $a5d33cfc7f8e5437$export$8c165704db2d5c15(e) {
    return e.type === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $a5d33cfc7f8e5437$var$Bn = Object.defineProperty, $a5d33cfc7f8e5437$var$Ue = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Gn = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Wn = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$_e = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$Ce = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$Gn.call(n, t) && $a5d33cfc7f8e5437$var$_e(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Ue) for (var t of $a5d33cfc7f8e5437$var$Ue(n))$a5d33cfc7f8e5437$var$Wn.call(n, t) && $a5d33cfc7f8e5437$var$_e(e, t, n[t]);
    return e;
};
const $a5d33cfc7f8e5437$export$f12873d77424d47b = "ReactNative", $a5d33cfc7f8e5437$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $a5d33cfc7f8e5437$export$657dee6d5648750a = " ", $a5d33cfc7f8e5437$export$96c3628b3b9d2079 = ":", $a5d33cfc7f8e5437$export$98238152dfccf046 = "/", $a5d33cfc7f8e5437$export$7f882bb969de14a3 = 2, $a5d33cfc7f8e5437$export$77baccb4c6bd5852 = 1e3, $a5d33cfc7f8e5437$export$e08b61c98317d88c = "js";
function $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() {
    return typeof $hPtJY < "u" && typeof $hPtJY.versions < "u" && typeof $hPtJY.versions.node < "u";
}
function $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() {
    return !(0, $dsfPE.getDocument)() && !!(0, $dsfPE.getNavigator)() && navigator.product === $a5d33cfc7f8e5437$export$f12873d77424d47b;
}
function $a5d33cfc7f8e5437$export$4e09c449d6c407f7() {
    return !$a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() && !!(0, $dsfPE.getNavigator)() && !!(0, $dsfPE.getDocument)();
}
function $a5d33cfc7f8e5437$export$57570b1603cf6adb() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative : $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node : $a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser : $a5d33cfc7f8e5437$export$86b1301a63b15dd9.unknown;
}
function $a5d33cfc7f8e5437$export$40a40f90174d197c() {
    var e;
    try {
        return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $a5d33cfc7f8e5437$export$c4147c69f6845da(e, n) {
    let t = $kJj3y.parse(e);
    return t = $a5d33cfc7f8e5437$var$Ce($a5d33cfc7f8e5437$var$Ce({}, t), n), e = $kJj3y.stringify(t), e;
}
function $a5d33cfc7f8e5437$export$ba31e015127122bb() {
    return (0, $8Wm94.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $a5d33cfc7f8e5437$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $a5d33cfc7f8e5437$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $dsfPE.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6() {
    if ($a5d33cfc7f8e5437$export$57570b1603cf6adb() === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $6enPC.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $a5d33cfc7f8e5437$export$4389b0987726d52d() {
    var e;
    const n = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return n === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $dsfPE.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, t) {
    const r = $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6(), o = $a5d33cfc7f8e5437$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $a5d33cfc7f8e5437$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $a5d33cfc7f8e5437$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $a5d33cfc7f8e5437$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $a5d33cfc7f8e5437$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $a5d33cfc7f8e5437$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return $a5d33cfc7f8e5437$export$7f00885504704576(e.split($a5d33cfc7f8e5437$export$98238152dfccf046), n);
}
function $a5d33cfc7f8e5437$export$80bffd46c37a96f6(e) {
    return $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $a5d33cfc7f8e5437$export$7f00885504704576(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $a5d33cfc7f8e5437$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $a5d33cfc7f8e5437$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $a5d33cfc7f8e5437$export$85c927578394b28b = (e)=>e;
function $a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $a5d33cfc7f8e5437$export$9a00dee1beb8f576(e) {
    return e.split($a5d33cfc7f8e5437$export$657dee6d5648750a).map((n)=>$a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(n)).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb(e = (0, $aG48A.FIVE_MINUTES), n) {
    const t = (0, $aG48A.toMiliseconds)(e || (0, $aG48A.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $a5d33cfc7f8e5437$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $a5d33cfc7f8e5437$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $a5d33cfc7f8e5437$export$43ab92477f8713b9(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("topic", e);
}
function $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("id", e);
}
function $a5d33cfc7f8e5437$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $a5d33cfc7f8e5437$export$b136d03015bfc12(e, n) {
    return (0, $aG48A.fromMiliseconds)((n || Date.now()) + (0, $aG48A.toMiliseconds)(e));
}
function $a5d33cfc7f8e5437$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $aG48A.toMiliseconds)(e);
}
function $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $a5d33cfc7f8e5437$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $a5d33cfc7f8e5437$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
        i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $a5d33cfc7f8e5437$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $a5d33cfc7f8e5437$export$822d0bd1635d5360 = "irn";
function $a5d33cfc7f8e5437$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $a5d33cfc7f8e5437$export$822d0bd1635d5360
    };
}
function $a5d33cfc7f8e5437$export$604e3deb95e1b734(e) {
    const n = (0, $ehMqO.RELAY_JSONRPC)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $a5d33cfc7f8e5437$var$bt = Object.defineProperty, $a5d33cfc7f8e5437$var$qe = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Nt = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Ot = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Be = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$St = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$Nt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$qe) for (var t of $a5d33cfc7f8e5437$var$qe(n))$a5d33cfc7f8e5437$var$Ot.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    return e;
};
function $a5d33cfc7f8e5437$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $a5d33cfc7f8e5437$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $kJj3y.parse(s);
    return {
        protocol: r,
        topic: $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $a5d33cfc7f8e5437$export$3d24f408c2ac468a(i)
    };
}
function $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $a5d33cfc7f8e5437$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $kJj3y.stringify($a5d33cfc7f8e5437$var$St({
        symKey: e.symKey
    }, $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e.relay)));
}
var $a5d33cfc7f8e5437$var$Pt = Object.defineProperty, $a5d33cfc7f8e5437$var$Rt = Object.defineProperties, $a5d33cfc7f8e5437$var$Tt = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$Ye = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$At = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Ut = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Je = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$Pt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$_t = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$At.call(n, t) && $a5d33cfc7f8e5437$var$Je(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Ye) for (var t of $a5d33cfc7f8e5437$var$Ye(n))$a5d33cfc7f8e5437$var$Ut.call(n, t) && $a5d33cfc7f8e5437$var$Je(e, t, n[t]);
    return e;
}, $a5d33cfc7f8e5437$var$Ct = (e, n)=>$a5d33cfc7f8e5437$var$Rt(e, $a5d33cfc7f8e5437$var$Tt(n));
function $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $a5d33cfc7f8e5437$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$a5d33cfc7f8e5437$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $a5d33cfc7f8e5437$export$a8daa26a7c60ef90(e, n) {
    const t = $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $a5d33cfc7f8e5437$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $a5d33cfc7f8e5437$export$2994550cda701c96(n), s = $a5d33cfc7f8e5437$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : g.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : g.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : g.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const g = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((P)=>r[c].chains.includes(P)), En = r[c].methods.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.methods) == null ? void 0 : j.includes(P);
        }), bn = r[c].events.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.events) == null ? void 0 : j.includes(P);
        }), Nn = g?.map((P)=>r[c].accounts.filter((R)=>R.includes(`${P}:`))).flat();
        l[c] = {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, g),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $a5d33cfc7f8e5437$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $a5d33cfc7f8e5437$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(e) {
    return $a5d33cfc7f8e5437$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $a5d33cfc7f8e5437$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $a5d33cfc7f8e5437$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(s);
        o[u] = $a5d33cfc7f8e5437$var$Ct($a5d33cfc7f8e5437$var$_t({}, o[u]), {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $a5d33cfc7f8e5437$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $a5d33cfc7f8e5437$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $a5d33cfc7f8e5437$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $a5d33cfc7f8e5437$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $a5d33cfc7f8e5437$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $a5d33cfc7f8e5437$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(d), a = t[i];
        (!$a5d33cfc7f8e5437$export$1468a49de573f7f9($a5d33cfc7f8e5437$export$376384387cd15b27(i, a), u) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.methods, l) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $a5d33cfc7f8e5437$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$bef94a5618bf18bf(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $a5d33cfc7f8e5437$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $a5d33cfc7f8e5437$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $a5d33cfc7f8e5437$export$c12fced8176774f3(e) {
    let n = !0;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $a5d33cfc7f8e5437$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $a5d33cfc7f8e5437$export$e544b39f0a22e47a(o) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $a5d33cfc7f8e5437$export$df46c123d7e298ce(o, $a5d33cfc7f8e5437$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $a5d33cfc7f8e5437$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(r) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$b32541d63753af56(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.methods) ? $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.events) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const o = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const r = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.protocol, !0);
}
function $a5d33cfc7f8e5437$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $a5d33cfc7f8e5437$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $a5d33cfc7f8e5437$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $a5d33cfc7f8e5437$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.code, !1) || !e.message || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.message, !1));
}
function $a5d33cfc7f8e5437$export$1a2af3c017fb6d42(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.method, !1));
}
function $a5d33cfc7f8e5437$export$1ae38cf0a848f651(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || $a5d33cfc7f8e5437$export$fce6876652108ab(e.result) && $a5d33cfc7f8e5437$export$fce6876652108ab(e.error) || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.id, !1) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.name, !1));
}
function $a5d33cfc7f8e5437$export$144fc36610eb6522(e, n) {
    return !(!$a5d33cfc7f8e5437$export$e544b39f0a22e47a(n) || !$a5d33cfc7f8e5437$export$fb6db6038e742b14(e).includes(n));
}
function $a5d33cfc7f8e5437$export$8db4804e3a6de711(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$df2c67ef8baad16b(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $a5d33cfc7f8e5437$var$Qt(e), s = $a5d33cfc7f8e5437$var$Zt(n), i = Object.keys(o), d = Object.keys(s), l = $a5d33cfc7f8e5437$var$pn(Object.keys(e)), c = $a5d33cfc7f8e5437$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $a5d33cfc7f8e5437$export$1468a49de573f7f9(i, d) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $a5d33cfc7f8e5437$var$Qt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $a5d33cfc7f8e5437$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $a5d33cfc7f8e5437$var$Zt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $a5d33cfc7f8e5437$export$59fba2af1ac782b(e, n) {
    return $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $a5d33cfc7f8e5437$export$53c2fd0173ad2b80() {
    const e = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
                n($a5d33cfc7f8e5437$export$2f147c609a999e49());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
                n($a5d33cfc7f8e5437$export$1444c95b1570bd12());
                break;
            case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
                n($a5d33cfc7f8e5437$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $a5d33cfc7f8e5437$export$2f147c609a999e49() {
    return $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $a5d33cfc7f8e5437$export$1444c95b1570bd12() {
    if ($a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $a5d33cfc7f8e5437$export$aec5b2d627eec500() {
    return !0;
}
function $a5d33cfc7f8e5437$export$600a1ee4bc680996(e) {
    switch($a5d33cfc7f8e5437$export$57570b1603cf6adb()){
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser:
            $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative:
            $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e);
            break;
        case $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node:
            break;
    }
}
function $a5d33cfc7f8e5437$export$d32b24f18d96c5f2(e) {
    !$a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && $a5d33cfc7f8e5437$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $a5d33cfc7f8e5437$export$904edb1c18ec91c7(e) {
    $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $a5d33cfc7f8e5437$var$ae = {};
class $a5d33cfc7f8e5437$export$b72d712fed4d036d {
    static get(n) {
        return $a5d33cfc7f8e5437$var$ae[n];
    }
    static set(n, t) {
        $a5d33cfc7f8e5437$var$ae[n] = t;
    }
    static delete(n) {
        delete $a5d33cfc7f8e5437$var$ae[n];
    }
}

});
parcelRegister("2sz3e", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5cIeM = parcelRequire("5cIeM");

var $g9GOo = parcelRequire("g9GOo");

var $3nJ3u = parcelRequire("3nJ3u");

var $j2SFD = parcelRequire("j2SFD");

var $GIl5j = parcelRequire("GIl5j");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $1ca962bc0b1868f1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $1ca962bc0b1868f1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $5cIeM.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $5cIeM.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $3nJ3u.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $5cIeM.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$GIl5j.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $5cIeM.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $3nJ3u.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $3nJ3u.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $g9GOo.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $j2SFD.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $j2SFD.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $3nJ3u.wipe(tag);
        $3nJ3u.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $1ca962bc0b1868f1$var$ChaCha20Poly1305;

});
parcelRegister("5cIeM", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j2SFD = parcelRequire("j2SFD");

var $3nJ3u = parcelRequire("3nJ3u");
// Number of ChaCha rounds (ChaCha20).
var $3ca0635e21db662f$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $3ca0635e21db662f$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $3ca0635e21db662f$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $j2SFD.writeUint32LE(x0 + j0 | 0, out, 0);
    $j2SFD.writeUint32LE(x1 + j1 | 0, out, 4);
    $j2SFD.writeUint32LE(x2 + j2 | 0, out, 8);
    $j2SFD.writeUint32LE(x3 + j3 | 0, out, 12);
    $j2SFD.writeUint32LE(x4 + j4 | 0, out, 16);
    $j2SFD.writeUint32LE(x5 + j5 | 0, out, 20);
    $j2SFD.writeUint32LE(x6 + j6 | 0, out, 24);
    $j2SFD.writeUint32LE(x7 + j7 | 0, out, 28);
    $j2SFD.writeUint32LE(x8 + j8 | 0, out, 32);
    $j2SFD.writeUint32LE(x9 + j9 | 0, out, 36);
    $j2SFD.writeUint32LE(x10 + j10 | 0, out, 40);
    $j2SFD.writeUint32LE(x11 + j11 | 0, out, 44);
    $j2SFD.writeUint32LE(x12 + j12 | 0, out, 48);
    $j2SFD.writeUint32LE(x13 + j13 | 0, out, 52);
    $j2SFD.writeUint32LE(x14 + j14 | 0, out, 56);
    $j2SFD.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $3ca0635e21db662f$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $3ca0635e21db662f$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $3ca0635e21db662f$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $3nJ3u.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $3nJ3u.wipe(nc);
    return dst;
}
module.exports.streamXOR = $3ca0635e21db662f$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $3ca0635e21db662f$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $3nJ3u.wipe(dst);
    return $3ca0635e21db662f$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $3ca0635e21db662f$var$stream;
function $3ca0635e21db662f$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});
parcelRegister("j2SFD", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $70z8I = parcelRequire("70z8I");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $ddd89ca0ca71c6d3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $ddd89ca0ca71c6d3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $ddd89ca0ca71c6d3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $ddd89ca0ca71c6d3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
module.exports.writeInt16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
module.exports.writeInt16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $ddd89ca0ca71c6d3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $ddd89ca0ca71c6d3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $ddd89ca0ca71c6d3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $ddd89ca0ca71c6d3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
module.exports.writeInt32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
module.exports.writeInt32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $ddd89ca0ca71c6d3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $ddd89ca0ca71c6d3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $ddd89ca0ca71c6d3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $ddd89ca0ca71c6d3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
module.exports.writeInt64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32LE(value >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
module.exports.writeInt64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $ddd89ca0ca71c6d3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $ddd89ca0ca71c6d3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$70z8I.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $ddd89ca0ca71c6d3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$70z8I.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $ddd89ca0ca71c6d3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $ddd89ca0ca71c6d3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $ddd89ca0ca71c6d3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $ddd89ca0ca71c6d3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $ddd89ca0ca71c6d3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $ddd89ca0ca71c6d3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $ddd89ca0ca71c6d3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $ddd89ca0ca71c6d3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $ddd89ca0ca71c6d3$var$writeFloat64LE;

});
parcelRegister("70z8I", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $51a3ca76628cc201$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $51a3ca76628cc201$var$imulShim;
/** 32-bit integer addition.  */ function $51a3ca76628cc201$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $51a3ca76628cc201$var$add;
/**  32-bit integer subtraction.  */ function $51a3ca76628cc201$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $51a3ca76628cc201$var$sub;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $51a3ca76628cc201$var$rotl;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $51a3ca76628cc201$var$rotr;
function $51a3ca76628cc201$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $51a3ca76628cc201$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});


parcelRegister("3nJ3u", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $276678191c4bdb56$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $276678191c4bdb56$var$wipe;

});


parcelRegister("g9GOo", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $GIl5j = parcelRequire("GIl5j");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $bc2eb21e5dd3f530$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $3nJ3u.wipe(this._buffer);
        $3nJ3u.wipe(this._r);
        $3nJ3u.wipe(this._h);
        $3nJ3u.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $bc2eb21e5dd3f530$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $bc2eb21e5dd3f530$var$oneTimeAuth(key, data) {
    var h = new $bc2eb21e5dd3f530$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $bc2eb21e5dd3f530$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $bc2eb21e5dd3f530$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $GIl5j.equal(a, b);
}
module.exports.equal = $bc2eb21e5dd3f530$var$equal;

});
parcelRegister("GIl5j", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $0806512cf7f87b87$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $0806512cf7f87b87$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $0806512cf7f87b87$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $0806512cf7f87b87$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $0806512cf7f87b87$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $0806512cf7f87b87$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $0806512cf7f87b87$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $0806512cf7f87b87$var$compare(a, b) !== 0;
}
module.exports.equal = $0806512cf7f87b87$var$equal;

});



parcelRegister("kun4A", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4xAND = parcelRequire("4xAND");

var $3nJ3u = parcelRequire("3nJ3u");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $eea881cb204cba82$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $4xAND.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $4xAND.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $3nJ3u.wipe(this._buffer);
        $3nJ3u.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $eea881cb204cba82$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRegister("4xAND", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gOkKM = parcelRequire("gOkKM");

var $GIl5j = parcelRequire("GIl5j");

var $3nJ3u = parcelRequire("3nJ3u");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $34e6ca18c8d3a670$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($gOkKM.isSerializableHash(this._inner) && $gOkKM.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $3nJ3u.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$gOkKM.isSerializableHash(this._inner) || !$gOkKM.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($gOkKM.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($gOkKM.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$gOkKM.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$gOkKM.isSerializableHash(this._inner) || !$gOkKM.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$gOkKM.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $34e6ca18c8d3a670$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $34e6ca18c8d3a670$var$hmac(hash, key, data) {
    var h = new $34e6ca18c8d3a670$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $34e6ca18c8d3a670$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $GIl5j.equal;

});
parcelRegister("gOkKM", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c3d16a0ee606048e$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $c3d16a0ee606048e$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});



parcelRegister("9Ve5w", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $65Xnv = parcelRequire("65Xnv");

var $j2SFD = parcelRequire("j2SFD");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.defaultRandomSource = new $65Xnv.SystemRandomSource();
function $73945d82524e104e$var$randomBytes(length, prng = module.exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
module.exports.randomBytes = $73945d82524e104e$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $73945d82524e104e$var$randomUint32(prng = module.exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $73945d82524e104e$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $j2SFD.readUint32LE)(buf);
    // Clean the buffer.
    (0, $3nJ3u.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $73945d82524e104e$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $73945d82524e104e$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomString(length, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $73945d82524e104e$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $3nJ3u.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $73945d82524e104e$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomStringForEntropy(bits, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $73945d82524e104e$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $73945d82524e104e$var$randomStringForEntropy;

});
parcelRegister("65Xnv", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $dJAS8 = parcelRequire("dJAS8");

var $hRlSE = parcelRequire("hRlSE");
class $470144fd408ed875$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $dJAS8.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $hRlSE.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
module.exports.SystemRandomSource = $470144fd408ed875$var$SystemRandomSource;

});
parcelRegister("dJAS8", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
const $9ffc14634304d8f4$var$QUOTA = 65536;
class $9ffc14634304d8f4$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $9ffc14634304d8f4$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $9ffc14634304d8f4$var$QUOTA)));
        return out;
    }
}
module.exports.BrowserRandomSource = $9ffc14634304d8f4$var$BrowserRandomSource;

});

parcelRegister("hRlSE", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $3nJ3u = parcelRequire("3nJ3u");

class $d0085be48b1f2335$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $3nJ3u.wipe)(buffer);
        return out;
    }
}
module.exports.NodeRandomSource = $d0085be48b1f2335$var$NodeRandomSource;

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});




parcelRegister("8N2RK", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j2SFD = parcelRequire("j2SFD");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $66651f7624f8a7c0$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $3nJ3u.wipe(this._buffer);
        $3nJ3u.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $j2SFD.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $j2SFD.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$j2SFD.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $3nJ3u.wipe(savedState.state);
        if (savedState.buffer) $3nJ3u.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $66651f7624f8a7c0$var$SHA256;
// Constants
var $66651f7624f8a7c0$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $66651f7624f8a7c0$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $j2SFD.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($66651f7624f8a7c0$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $66651f7624f8a7c0$var$hash(data) {
    var h = new $66651f7624f8a7c0$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $66651f7624f8a7c0$var$hash;

});

parcelRegister("7qMke", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $9Ve5w = parcelRequire("9Ve5w");

var $3nJ3u = parcelRequire("3nJ3u");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $569072827d3d60aa$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $569072827d3d60aa$var$_9 = new Uint8Array(32);
$569072827d3d60aa$var$_9[0] = 9;
const $569072827d3d60aa$var$_121665 = $569072827d3d60aa$var$gf([
    0xdb41,
    1
]);
function $569072827d3d60aa$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $569072827d3d60aa$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $569072827d3d60aa$var$pack25519(o, n) {
    const m = $569072827d3d60aa$var$gf();
    const t = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $569072827d3d60aa$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $569072827d3d60aa$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $569072827d3d60aa$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $569072827d3d60aa$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $569072827d3d60aa$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $569072827d3d60aa$var$square(o, a) {
    $569072827d3d60aa$var$mul(o, a, a);
}
function $569072827d3d60aa$var$inv25519(o, inp) {
    const c = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $569072827d3d60aa$var$square(c, c);
        if (i !== 2 && i !== 4) $569072827d3d60aa$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $569072827d3d60aa$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $569072827d3d60aa$var$gf(), b = $569072827d3d60aa$var$gf(), c = $569072827d3d60aa$var$gf(), d = $569072827d3d60aa$var$gf(), e = $569072827d3d60aa$var$gf(), f = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $569072827d3d60aa$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$add(c, b, d);
        $569072827d3d60aa$var$sub(b, b, d);
        $569072827d3d60aa$var$square(d, e);
        $569072827d3d60aa$var$square(f, a);
        $569072827d3d60aa$var$mul(a, c, a);
        $569072827d3d60aa$var$mul(c, b, e);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$square(b, a);
        $569072827d3d60aa$var$sub(c, d, f);
        $569072827d3d60aa$var$mul(a, c, $569072827d3d60aa$var$_121665);
        $569072827d3d60aa$var$add(a, a, d);
        $569072827d3d60aa$var$mul(c, c, a);
        $569072827d3d60aa$var$mul(a, d, f);
        $569072827d3d60aa$var$mul(d, b, x);
        $569072827d3d60aa$var$square(b, e);
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $569072827d3d60aa$var$inv25519(x32, x32);
    $569072827d3d60aa$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $569072827d3d60aa$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $569072827d3d60aa$var$scalarMult;
function $569072827d3d60aa$var$scalarMultBase(n) {
    return $569072827d3d60aa$var$scalarMult(n, $569072827d3d60aa$var$_9);
}
module.exports.scalarMultBase = $569072827d3d60aa$var$scalarMultBase;
function $569072827d3d60aa$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $569072827d3d60aa$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $569072827d3d60aa$var$generateKeyPairFromSeed;
function $569072827d3d60aa$var$generateKeyPair(prng) {
    const seed = (0, $9Ve5w.randomBytes)(32, prng);
    const result = $569072827d3d60aa$var$generateKeyPairFromSeed(seed);
    (0, $3nJ3u.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $569072827d3d60aa$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $569072827d3d60aa$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $569072827d3d60aa$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $569072827d3d60aa$var$sharedKey;

});

parcelRegister("a2jTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZVv6 = parcelRequire("4ZVv6");

var $67QIB = parcelRequire("67QIB");

var $5DFrB = parcelRequire("5DFrB");

var $e9TA6 = parcelRequire("e9TA6");

var $gj7w6 = parcelRequire("gj7w6");

var $8pBj0 = parcelRequire("8pBj0");
module.exports.compare = $4ZVv6.compare;
module.exports.concat = $67QIB.concat;
module.exports.equals = $5DFrB.equals;
module.exports.fromString = $e9TA6.fromString;
module.exports.toString = $gj7w6.toString;
module.exports.xor = $8pBj0.xor;

});
parcelRegister("4ZVv6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
module.exports.compare = $3a397656998e9fe7$var$compare;

});

parcelRegister("67QIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8hIMj = parcelRequire("8hIMj");

var $akjlZ = parcelRequire("akjlZ");
function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $8hIMj.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $akjlZ.asUint8Array(output);
}
module.exports.concat = $475c4a512fd4a246$var$concat;

});
parcelRegister("8hIMj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $akjlZ = parcelRequire("akjlZ");
function $6082a548169c7b42$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $akjlZ.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $6082a548169c7b42$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $akjlZ.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
module.exports.alloc = $6082a548169c7b42$var$alloc;
module.exports.allocUnsafe = $6082a548169c7b42$var$allocUnsafe;

});
parcelRegister("akjlZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $784ac8dd0f23c14d$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
module.exports.asUint8Array = $784ac8dd0f23c14d$var$asUint8Array;

});



parcelRegister("5DFrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.equals = $41b0be3b2401ec7e$var$equals;

});

parcelRegister("e9TA6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7BbeY = parcelRequire("7BbeY");

var $akjlZ = parcelRequire("akjlZ");
function $a4ed053a1131469e$var$fromString(string, encoding = "utf8") {
    const base = $7BbeY[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $akjlZ.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports.fromString = $a4ed053a1131469e$var$fromString;

});
parcelRegister("7BbeY", function(module, exports) {
"use strict";

var $fDRtp = parcelRequire("fDRtp");

var $8hIMj = parcelRequire("8hIMj");
function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $8hIMj.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    "utf-8": $5884b53a084a924d$var$string,
    hex: $fDRtp.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$fDRtp.bases
};
module.exports = $5884b53a084a924d$var$BASES;

});
parcelRegister("fDRtp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lwvkp = parcelRequire("lwvkp");

var $5RC5t = parcelRequire("5RC5t");

var $9T9EZ = parcelRequire("9T9EZ");

var $aGHoO = parcelRequire("aGHoO");

var $6IsCN = parcelRequire("6IsCN");

var $9mHUH = parcelRequire("9mHUH");

var $388Mf = parcelRequire("388Mf");

var $g48Q7 = parcelRequire("g48Q7");

var $j3YM6 = parcelRequire("j3YM6");

var $hkEkj = parcelRequire("hkEkj");

var $lFa2r = parcelRequire("lFa2r");

var $8iBGc = parcelRequire("8iBGc");

var $04T17 = parcelRequire("04T17");

var $847dK = parcelRequire("847dK");
parcelRequire("hHwg3");

var $a3h4N = parcelRequire("a3h4N");

var $g30mz = parcelRequire("g30mz");

var $kRxmT = parcelRequire("kRxmT");

var $4mKzA = parcelRequire("4mKzA");

var $6DEzE = parcelRequire("6DEzE");
const $b633fa38a7f8a649$var$bases = {
    ...$lwvkp,
    ...$5RC5t,
    ...$9T9EZ,
    ...$aGHoO,
    ...$6IsCN,
    ...$9mHUH,
    ...$388Mf,
    ...$g48Q7,
    ...$j3YM6,
    ...$hkEkj
};
const $b633fa38a7f8a649$var$hashes = {
    ...$lFa2r,
    ...$8iBGc
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $04T17,
    json: $847dK
};
module.exports.CID = $a3h4N.CID;
module.exports.hasher = $g30mz;
module.exports.digest = $kRxmT;
module.exports.varint = $4mKzA;
module.exports.bytes = $6DEzE;
module.exports.bases = $b633fa38a7f8a649$var$bases;
module.exports.codecs = $b633fa38a7f8a649$var$codecs;
module.exports.hashes = $b633fa38a7f8a649$var$hashes;

});
parcelRegister("lwvkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");

var $6DEzE = parcelRequire("6DEzE");
const $fab4e33fc8c0336e$var$identity = $j5XlC.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$6DEzE.toString(buf),
    decode: (str)=>$6DEzE.fromString(str)
});
module.exports.identity = $fab4e33fc8c0336e$var$identity;

});
parcelRegister("j5XlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hjHF0 = parcelRequire("hjHF0");

var $6DEzE = parcelRequire("6DEzE");
class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $hjHF0(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$6DEzE.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $de6c852f920490b4$var$Codec;
module.exports.baseX = $de6c852f920490b4$var$baseX;
module.exports.from = $de6c852f920490b4$var$from;
module.exports.or = $de6c852f920490b4$var$or;
module.exports.rfc4648 = $de6c852f920490b4$var$rfc4648;

});
parcelRegister("hjHF0", function(module, exports) {
"use strict";
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
module.exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("6DEzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $4d55dbc11a5f1aec$var$coerce;
module.exports.empty = $4d55dbc11a5f1aec$var$empty;
module.exports.equals = $4d55dbc11a5f1aec$var$equals;
module.exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
module.exports.fromString = $4d55dbc11a5f1aec$var$fromString;
module.exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
module.exports.toHex = $4d55dbc11a5f1aec$var$toHex;
module.exports.toString = $4d55dbc11a5f1aec$var$toString;

});



parcelRegister("5RC5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $444f725972ab843c$var$base2 = $j5XlC.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
module.exports.base2 = $444f725972ab843c$var$base2;

});

parcelRegister("9T9EZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $7330be652d1faeae$var$base8 = $j5XlC.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
module.exports.base8 = $7330be652d1faeae$var$base8;

});

parcelRegister("aGHoO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $7c7f7dd3c1547a66$var$base10 = $j5XlC.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
module.exports.base10 = $7c7f7dd3c1547a66$var$base10;

});

parcelRegister("6IsCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $4e3d0e6f3707af45$var$base16 = $j5XlC.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $j5XlC.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
module.exports.base16 = $4e3d0e6f3707af45$var$base16;
module.exports.base16upper = $4e3d0e6f3707af45$var$base16upper;

});

parcelRegister("9mHUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $6d183b7418ac11d8$var$base32 = $j5XlC.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $j5XlC.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $j5XlC.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $j5XlC.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $j5XlC.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $j5XlC.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $j5XlC.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $j5XlC.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $j5XlC.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
module.exports.base32 = $6d183b7418ac11d8$var$base32;
module.exports.base32hex = $6d183b7418ac11d8$var$base32hex;
module.exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
module.exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
module.exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
module.exports.base32pad = $6d183b7418ac11d8$var$base32pad;
module.exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
module.exports.base32upper = $6d183b7418ac11d8$var$base32upper;
module.exports.base32z = $6d183b7418ac11d8$var$base32z;

});

parcelRegister("388Mf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $2478ed668ff199ad$var$base36 = $j5XlC.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $2478ed668ff199ad$var$base36upper = $j5XlC.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
module.exports.base36 = $2478ed668ff199ad$var$base36;
module.exports.base36upper = $2478ed668ff199ad$var$base36upper;

});

parcelRegister("g48Q7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $bb23e06a31e86f7c$var$base58btc = $j5XlC.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $bb23e06a31e86f7c$var$base58flickr = $j5XlC.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
module.exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
module.exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;

});

parcelRegister("j3YM6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $de0d70bb34ca5e4e$var$base64 = $j5XlC.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $j5XlC.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $j5XlC.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $j5XlC.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
module.exports.base64 = $de0d70bb34ca5e4e$var$base64;
module.exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
module.exports.base64url = $de0d70bb34ca5e4e$var$base64url;
module.exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;

});

parcelRegister("hkEkj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5XlC = parcelRequire("j5XlC");
const $c9e395f0a3e1277d$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $j5XlC.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
module.exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;

});

parcelRegister("lFa2r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g30mz = parcelRequire("g30mz");
const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $g30mz.from({
    name: "sha2-256",
    code: 18,
    encode: $fc5536b924e664f3$var$sha("SHA-256")
});
const $fc5536b924e664f3$var$sha512 = $g30mz.from({
    name: "sha2-512",
    code: 19,
    encode: $fc5536b924e664f3$var$sha("SHA-512")
});
module.exports.sha256 = $fc5536b924e664f3$var$sha256;
module.exports.sha512 = $fc5536b924e664f3$var$sha512;

});
parcelRegister("g30mz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kRxmT = parcelRequire("kRxmT");
const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $kRxmT.create(this.code, result) : result.then((digest$1)=>$kRxmT.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
module.exports.Hasher = $baed353b52eedd46$var$Hasher;
module.exports.from = $baed353b52eedd46$var$from;

});
parcelRegister("kRxmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");

var $4mKzA = parcelRequire("4mKzA");
const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $4mKzA.encodingLength(code);
    const digestOffset = sizeOffset + $4mKzA.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $4mKzA.encodeTo(code, bytes, 0);
    $4mKzA.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $6DEzE.coerce(multihash);
    const [code, sizeOffset] = $4mKzA.decode(bytes$1);
    const [size, digestOffset] = $4mKzA.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $6DEzE.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
module.exports.Digest = $f302a42295b946b3$var$Digest;
module.exports.create = $f302a42295b946b3$var$create;
module.exports.decode = $f302a42295b946b3$var$decode;
module.exports.equals = $f302a42295b946b3$var$equals;

});
parcelRegister("4mKzA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lsRo7 = parcelRequire("lsRo7");
const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $lsRo7.decode(data, offset);
    return [
        code,
        $lsRo7.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $lsRo7.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $lsRo7.encodingLength(int);
};
module.exports.decode = $32dd57f0aae68c66$var$decode;
module.exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
module.exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;

});
parcelRegister("lsRo7", function(module, exports) {
"use strict";
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
module.exports = $fa05a038af787ba8$var$varint$1;

});





parcelRegister("8iBGc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");

var $kRxmT = parcelRequire("kRxmT");
const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = "identity";
const $60ad3b9242aa2ade$var$encode = $6DEzE.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$kRxmT.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
module.exports.identity = $60ad3b9242aa2ade$var$identity;

});

parcelRegister("04T17", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6DEzE = parcelRequire("6DEzE");
const $00eb0d0ec1c470ae$var$name = "raw";
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$6DEzE.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$6DEzE.coerce(data);
module.exports.code = $00eb0d0ec1c470ae$var$code;
module.exports.decode = $00eb0d0ec1c470ae$var$decode;
module.exports.encode = $00eb0d0ec1c470ae$var$encode;
module.exports.name = $00eb0d0ec1c470ae$var$name;

});

parcelRegister("847dK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = "json";
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
module.exports.code = $5df44c55fa70023d$var$code;
module.exports.decode = $5df44c55fa70023d$var$decode;
module.exports.encode = $5df44c55fa70023d$var$encode;
module.exports.name = $5df44c55fa70023d$var$name;

});

parcelRegister("hHwg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a3h4N = parcelRequire("a3h4N");

var $4mKzA = parcelRequire("4mKzA");

var $6DEzE = parcelRequire("6DEzE");

var $g30mz = parcelRequire("g30mz");

var $kRxmT = parcelRequire("kRxmT");
module.exports.CID = $a3h4N.CID;
module.exports.varint = $4mKzA;
module.exports.bytes = $6DEzE;
module.exports.hasher = $g30mz;
module.exports.digest = $kRxmT;

});
parcelRegister("a3h4N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4mKzA = parcelRequire("4mKzA");

var $kRxmT = parcelRequire("kRxmT");

var $g48Q7 = parcelRequire("g48Q7");

var $9mHUH = parcelRequire("9mHUH");

var $6DEzE = parcelRequire("6DEzE");
class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $kRxmT.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $kRxmT.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $g48Q7.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $9mHUH.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $kRxmT.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $6DEzE.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $kRxmT.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $4mKzA.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $g48Q7.base58btc;
                return [
                    $g48Q7.base58btc.prefix,
                    decoder.decode(`${$g48Q7.base58btc.prefix}${source}`)
                ];
            }
        case $g48Q7.base58btc.prefix:
            {
                const decoder = base || $g48Q7.base58btc;
                return [
                    $g48Q7.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $9mHUH.base32.prefix:
            {
                const decoder = base || $9mHUH.base32;
                return [
                    $9mHUH.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $g48Q7.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $4mKzA.encodingLength(version);
    const hashOffset = codeOffset + $4mKzA.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $4mKzA.encodeTo(version, bytes, 0);
    $4mKzA.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = "0.0.0-dev";
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
module.exports.CID = $75176e30f12252bd$var$CID;

});





parcelRegister("gj7w6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7BbeY = parcelRequire("7BbeY");
function $bdf44057d833ab1f$var$toString(array, encoding = "utf8") {
    const base = $7BbeY[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
module.exports.toString = $bdf44057d833ab1f$var$toString;

});

parcelRegister("8pBj0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8hIMj = parcelRequire("8hIMj");

var $akjlZ = parcelRequire("akjlZ");
function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $8hIMj.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $akjlZ.asUint8Array(result);
}
module.exports.xor = $61fd98a3451cab50$var$xor;

});


parcelRegister("6enPC", function(module, exports) {

$parcel$export(module.exports, "detect", () => $48968958eb8b72e8$export$17b446b869dad473);

var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});

parcelRegister("aG48A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("9EePZ")), module.exports);

$7WQrb.__exportStar((parcelRequire("iD73S")), module.exports);

$7WQrb.__exportStar((parcelRequire("dTXLC")), module.exports);

$7WQrb.__exportStar((parcelRequire("2MWZl")), module.exports);

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("9EePZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("fUPCt")), module.exports);

$7WQrb.__exportStar((parcelRequire("3NXE9")), module.exports);

});
parcelRegister("fUPCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $b964208cf0e7f449$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $b964208cf0e7f449$var$delay;

});

parcelRegister("3NXE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $2MWZl = parcelRequire("2MWZl");
function $2c543746c4e25c3a$var$toMiliseconds(seconds) {
    return seconds * $2MWZl.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2c543746c4e25c3a$var$toMiliseconds;
function $2c543746c4e25c3a$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $2MWZl.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2c543746c4e25c3a$var$fromMiliseconds;

});
parcelRegister("2MWZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("lfr75")), module.exports);

$7WQrb.__exportStar((parcelRequire("1qmVT")), module.exports);

});
parcelRegister("lfr75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("1qmVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("iD73S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d90158c308dd266b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d90158c308dd266b$var$Watch;
module.exports.default = $d90158c308dd266b$var$Watch;

});

parcelRegister("dTXLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("b5rRE")), module.exports);

});
parcelRegister("b5rRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $8125c6986ecca435$var$IWatch {
}
module.exports.IWatch = $8125c6986ecca435$var$IWatch;

});



parcelRegister("dsfPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $9cba2bd26fe13e26$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $9cba2bd26fe13e26$var$getFromWindow;
function $9cba2bd26fe13e26$var$getFromWindowOrThrow(name) {
    const res = $9cba2bd26fe13e26$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $9cba2bd26fe13e26$var$getFromWindowOrThrow;
function $9cba2bd26fe13e26$var$getDocumentOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $9cba2bd26fe13e26$var$getDocumentOrThrow;
function $9cba2bd26fe13e26$var$getDocument() {
    return $9cba2bd26fe13e26$var$getFromWindow("document");
}
module.exports.getDocument = $9cba2bd26fe13e26$var$getDocument;
function $9cba2bd26fe13e26$var$getNavigatorOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $9cba2bd26fe13e26$var$getNavigatorOrThrow;
function $9cba2bd26fe13e26$var$getNavigator() {
    return $9cba2bd26fe13e26$var$getFromWindow("navigator");
}
module.exports.getNavigator = $9cba2bd26fe13e26$var$getNavigator;
function $9cba2bd26fe13e26$var$getLocationOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $9cba2bd26fe13e26$var$getLocationOrThrow;
function $9cba2bd26fe13e26$var$getLocation() {
    return $9cba2bd26fe13e26$var$getFromWindow("location");
}
module.exports.getLocation = $9cba2bd26fe13e26$var$getLocation;
function $9cba2bd26fe13e26$var$getCryptoOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $9cba2bd26fe13e26$var$getCryptoOrThrow;
function $9cba2bd26fe13e26$var$getCrypto() {
    return $9cba2bd26fe13e26$var$getFromWindow("crypto");
}
module.exports.getCrypto = $9cba2bd26fe13e26$var$getCrypto;
function $9cba2bd26fe13e26$var$getLocalStorageOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$var$getLocalStorageOrThrow;
function $9cba2bd26fe13e26$var$getLocalStorage() {
    return $9cba2bd26fe13e26$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $9cba2bd26fe13e26$var$getLocalStorage;

});

parcelRegister("8Wm94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $dsfPE = parcelRequire("dsfPE");
function $6824eb17eeee766a$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $dsfPE.getDocumentOrThrow();
        loc = $dsfPE.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $6824eb17eeee766a$var$getWindowMetadata;

});

parcelRegister("kJj3y", function(module, exports) {

$parcel$export(module.exports, "extract", () => $f176cac955b733f1$export$f9380c9a627682d3, (v) => $f176cac955b733f1$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $f176cac955b733f1$export$98e6a39c04603d36, (v) => $f176cac955b733f1$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $f176cac955b733f1$export$fac44ee5b035f737, (v) => $f176cac955b733f1$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $f176cac955b733f1$export$7a5253c0f62e0150, (v) => $f176cac955b733f1$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $f176cac955b733f1$export$a8c1621ea79325d3, (v) => $f176cac955b733f1$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $f176cac955b733f1$export$357523c63a2253b9, (v) => $f176cac955b733f1$export$357523c63a2253b9 = v);
var $f176cac955b733f1$export$f9380c9a627682d3;
var $f176cac955b733f1$export$98e6a39c04603d36;
var $f176cac955b733f1$export$fac44ee5b035f737;
var $f176cac955b733f1$export$7a5253c0f62e0150;
var $f176cac955b733f1$export$a8c1621ea79325d3;
var $f176cac955b733f1$export$357523c63a2253b9;
var $f176cac955b733f1$export$44c361b8ec72ef7f;
"use strict";

var $3sG8k = parcelRequire("3sG8k");

var $5yzCy = parcelRequire("5yzCy");

var $KvXt7 = parcelRequire("KvXt7");

var $4IJyT = parcelRequire("4IJyT");
const $f176cac955b733f1$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $f176cac955b733f1$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $f176cac955b733f1$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            "[",
                            $f176cac955b733f1$var$encode(index, options),
                            "]=",
                            $f176cac955b733f1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            "[]=",
                            $f176cac955b733f1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            ":list=",
                            $f176cac955b733f1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $f176cac955b733f1$var$encode(key, options),
                                keyValueSep,
                                $f176cac955b733f1$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $f176cac955b733f1$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f176cac955b733f1$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f176cac955b733f1$var$encode(key, options),
                            "=",
                            $f176cac955b733f1$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f176cac955b733f1$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f176cac955b733f1$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f176cac955b733f1$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f176cac955b733f1$var$decode(item, options)) : value === null ? value : $f176cac955b733f1$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $f176cac955b733f1$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$f176cac955b733f1$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $f176cac955b733f1$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f176cac955b733f1$var$encode(value, options) {
    if (options.encode) return options.strict ? $3sG8k(value) : encodeURIComponent(value);
    return value;
}
function $f176cac955b733f1$var$decode(value, options) {
    if (options.decode) return $5yzCy(value);
    return value;
}
function $f176cac955b733f1$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f176cac955b733f1$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f176cac955b733f1$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f176cac955b733f1$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f176cac955b733f1$var$extract(input) {
    input = $f176cac955b733f1$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f176cac955b733f1$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f176cac955b733f1$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $f176cac955b733f1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f176cac955b733f1$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $KvXt7(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $f176cac955b733f1$var$decode(value, options);
        formatter($f176cac955b733f1$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $f176cac955b733f1$var$parseValue(value[k], options);
        else ret[key] = $f176cac955b733f1$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $f176cac955b733f1$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$f176cac955b733f1$export$f9380c9a627682d3 = $f176cac955b733f1$var$extract;
$f176cac955b733f1$export$98e6a39c04603d36 = $f176cac955b733f1$var$parse;
$f176cac955b733f1$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $f176cac955b733f1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f176cac955b733f1$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f176cac955b733f1$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f176cac955b733f1$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $f176cac955b733f1$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $f176cac955b733f1$var$encode(key, options) + "=" + $f176cac955b733f1$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$f176cac955b733f1$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $KvXt7(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $f176cac955b733f1$var$parse($f176cac955b733f1$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $f176cac955b733f1$var$decode(hash, options)
    } : {});
};
$f176cac955b733f1$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$f176cac955b733f1$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $f176cac955b733f1$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f176cac955b733f1$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $f176cac955b733f1$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $f176cac955b733f1$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f176cac955b733f1$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$f176cac955b733f1$var$encodeFragmentIdentifier] ? $f176cac955b733f1$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$f176cac955b733f1$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$f176cac955b733f1$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $f176cac955b733f1$export$7a5253c0f62e0150(input, options);
    return $f176cac955b733f1$export$a8c1621ea79325d3({
        url: url,
        query: $4IJyT(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$f176cac955b733f1$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f176cac955b733f1$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("3sG8k", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("5yzCy", function(module, exports) {
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("KvXt7", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("4IJyT", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("9iPTB", function(module, exports) {
$parcel$export(module.exports, "RELAY_JSONRPC", () => (parcelRequire("ehMqO")).RELAY_JSONRPC);

var $aNEtK = parcelRequire("aNEtK");
parcelRequire("e5fbU");
parcelRequire("ehMqO");
parcelRequire("it9Pa");
$parcel$exportWildcard(module.exports, $aNEtK);

});
parcelRegister("aNEtK", function(module, exports) {

});

parcelRegister("e5fbU", function(module, exports) {

var $adG3D = parcelRequire("adG3D");

var $it9Pa = parcelRequire("it9Pa");
function $a40d50f3c8928009$export$abdf96c288cb375(request) {
    if (!(0, $it9Pa.isSubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $it9Pa.isSubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $adG3D.assertType)(params, "topic");
    return params;
}
function $a40d50f3c8928009$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $it9Pa.isPublishMethod)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $it9Pa.isPublishParams)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $adG3D.assertType)(params, "topic");
    (0, $adG3D.assertType)(params, "message");
    (0, $adG3D.assertType)(params, "ttl", "number");
    return params;
}
function $a40d50f3c8928009$export$78baa72f78156594(request) {
    if (!(0, $it9Pa.isUnsubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $it9Pa.isUnsubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $adG3D.assertType)(params, "id");
    return params;
}
function $a40d50f3c8928009$export$4d5822edd41f3b48(request) {
    if (!(0, $it9Pa.isSubscriptionMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $it9Pa.isSubscriptionParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $adG3D.assertType)(params, "id");
    (0, $adG3D.assertType)(params, "data");
    return params;
}

});
parcelRegister("adG3D", function(module, exports) {

$parcel$export(module.exports, "assertType", () => $770bbe0a33a0b266$export$804de46662e4ac95);
$parcel$export(module.exports, "checkParams", () => $770bbe0a33a0b266$export$19e8e281e27dafad);
$parcel$export(module.exports, "methodEndsWith", () => $770bbe0a33a0b266$export$18337b4ba58d5c33);
function $770bbe0a33a0b266$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $770bbe0a33a0b266$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $770bbe0a33a0b266$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $770bbe0a33a0b266$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, required.length) : $770bbe0a33a0b266$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $770bbe0a33a0b266$export$c538c02216fcdc03(params, required);
}
function $770bbe0a33a0b266$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}

});

parcelRegister("it9Pa", function(module, exports) {

$parcel$export(module.exports, "isSubscribeMethod", () => $d7228e581edf756b$export$f576347163de0984);
$parcel$export(module.exports, "isSubscribeParams", () => $d7228e581edf756b$export$dae2311546d43680);
$parcel$export(module.exports, "isPublishMethod", () => $d7228e581edf756b$export$71d4d33ac7f7a269);
$parcel$export(module.exports, "isPublishParams", () => $d7228e581edf756b$export$71e8d1aa48c3e86f);
$parcel$export(module.exports, "isUnsubscribeMethod", () => $d7228e581edf756b$export$568d956f39536025);
$parcel$export(module.exports, "isUnsubscribeParams", () => $d7228e581edf756b$export$cbc597c53c3b4f80);
$parcel$export(module.exports, "isSubscriptionMethod", () => $d7228e581edf756b$export$3cb4ad320e3a46a4);
$parcel$export(module.exports, "isSubscriptionParams", () => $d7228e581edf756b$export$6366ff9a39f2da4c);

var $adG3D = parcelRequire("adG3D");
function $d7228e581edf756b$export$c75580565fa025bd(request) {
    return $d7228e581edf756b$export$f576347163de0984(request.method) && $d7228e581edf756b$export$dae2311546d43680(request.params);
}
function $d7228e581edf756b$export$f576347163de0984(method) {
    return (0, $adG3D.methodEndsWith)(method, "subscribe");
}
function $d7228e581edf756b$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $adG3D.checkParams)(params, required, optional);
}
function $d7228e581edf756b$export$8fa7cf76b41caee0(request) {
    return $d7228e581edf756b$export$71d4d33ac7f7a269(request.method) && $d7228e581edf756b$export$71e8d1aa48c3e86f(request.params);
}
function $d7228e581edf756b$export$71d4d33ac7f7a269(method) {
    return (0, $adG3D.methodEndsWith)(method, "publish");
}
function $d7228e581edf756b$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $adG3D.checkParams)(params, required, optional);
}
function $d7228e581edf756b$export$83e292763180b41b(request) {
    return $d7228e581edf756b$export$568d956f39536025(request.method) && $d7228e581edf756b$export$cbc597c53c3b4f80(request.params);
}
function $d7228e581edf756b$export$568d956f39536025(method) {
    return (0, $adG3D.methodEndsWith)(method, "unsubscribe");
}
function $d7228e581edf756b$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $adG3D.checkParams)(params, required, optional);
}
function $d7228e581edf756b$export$43cf4100d6287b8e(request) {
    return $d7228e581edf756b$export$3cb4ad320e3a46a4(request.method) && $d7228e581edf756b$export$6366ff9a39f2da4c(request.params);
}
function $d7228e581edf756b$export$3cb4ad320e3a46a4(method) {
    return (0, $adG3D.methodEndsWith)(method, "subscription");
}
function $d7228e581edf756b$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $adG3D.checkParams)(params, required, optional);
}

});


parcelRegister("ehMqO", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", () => $a66838b5a814eb12$export$af490b3b9a6de00f);
const $a66838b5a814eb12$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};

});



parcelRegister("3pIh1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("kj0Wa"),
    $Gr8vk("7lqUy")
]).then(()=>parcelRequire("acRLA"));

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

var $c631c755fc42cf75$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $c631c755fc42cf75$exports = factory();
})($c631c755fc42cf75$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 1528);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Taken from klasse by mattdesl https://github.com/mattdesl/klasse
            function hasGetterOrSetter(def) {
                return !!def.get && typeof def.get === "function" || !!def.set && typeof def.set === "function";
            }
            function getProperty(definition, k, isClassDescriptor) {
                //  This may be a lightweight object, OR it might be a property that was defined previously.
                //  For simple class descriptors we can just assume its NOT previously defined.
                var def = isClassDescriptor ? definition[k] : Object.getOwnPropertyDescriptor(definition, k);
                if (!isClassDescriptor && def.value && typeof def.value === "object") def = def.value;
                //  This might be a regular property, or it may be a getter/setter the user defined in a class.
                if (def && hasGetterOrSetter(def)) {
                    if (typeof def.enumerable === "undefined") def.enumerable = true;
                    if (typeof def.configurable === "undefined") def.configurable = true;
                    return def;
                } else return false;
            }
            function hasNonConfigurable(obj, k) {
                var prop = Object.getOwnPropertyDescriptor(obj, k);
                if (!prop) return false;
                if (prop.value && typeof prop.value === "object") prop = prop.value;
                if (prop.configurable === false) return true;
                return false;
            }
            /**
 * Extends the given `myClass` object's prototype with the properties of `definition`.
 *
 * @function extend
 * @ignore
 * @param {Object} ctor The constructor object to mix into.
 * @param {Object} definition A dictionary of functions for the class.
 * @param {boolean} isClassDescriptor Is the definition a class descriptor?
 * @param {Object} [extend] The parent constructor object.
 */ function extend(ctor, definition, isClassDescriptor, extend) {
                for(var k in definition){
                    if (!definition.hasOwnProperty(k)) continue;
                    var def = getProperty(definition, k, isClassDescriptor);
                    if (def !== false) {
                        //  If Extends is used, we will check its prototype to see if the final variable exists.
                        var parent = extend || ctor;
                        if (hasNonConfigurable(parent.prototype, k)) {
                            //  Just skip the final property
                            if (Class.ignoreFinals) continue;
                            //  We cannot re-define a property that is configurable=false.
                            //  So we will consider them final and throw an error. This is by
                            //  default so it is clear to the developer what is happening.
                            //  You can set ignoreFinals to true if you need to extend a class
                            //  which has configurable=false; it will simply not re-define final properties.
                            throw new Error("cannot override final property '" + k + "', set Class.ignoreFinals = true to skip");
                        }
                        Object.defineProperty(ctor.prototype, k, def);
                    } else ctor.prototype[k] = definition[k];
                }
            }
            /**
 * Applies the given `mixins` to the prototype of `myClass`.
 *
 * @function mixin
 * @ignore
 * @param {Object} myClass The constructor object to mix into.
 * @param {Object|Array<Object>} mixins The mixins to apply to the constructor.
 */ function mixin(myClass, mixins) {
                if (!mixins) return;
                if (!Array.isArray(mixins)) mixins = [
                    mixins
                ];
                for(var i = 0; i < mixins.length; i++)extend(myClass, mixins[i].prototype || mixins[i]);
            }
            /**
 * Creates a new class with the given descriptor.
 * The constructor, defined by the name `initialize`,
 * is an optional function. If unspecified, an anonymous
 * function will be used which calls the parent class (if
 * one exists).
 *
 * You can also use `Extends` and `Mixins` to provide subclassing
 * and inheritance.
 *
 * @class Phaser.Class
 * @constructor
 * @param {Object} definition a dictionary of functions for the class
 * @example
 *
 *      var MyClass = new Phaser.Class({
 *
 *          initialize: function() {
 *              this.foo = 2.0;
 *          },
 *
 *          bar: function() {
 *              return this.foo + 5;
 *          }
 *      });
 */ function Class(definition) {
                if (!definition) definition = {};
                //  The variable name here dictates what we see in Chrome debugger
                var initialize;
                var Extends;
                if (definition.initialize) {
                    if (typeof definition.initialize !== "function") throw new Error("initialize must be a function");
                    initialize = definition.initialize;
                    //  Usually we should avoid 'delete' in V8 at all costs.
                    //  However, its unlikely to make any performance difference
                    //  here since we only call this on class creation (i.e. not object creation).
                    delete definition.initialize;
                } else if (definition.Extends) {
                    var base = definition.Extends;
                    initialize = function() {
                        base.apply(this, arguments);
                    };
                } else initialize = function() {};
                if (definition.Extends) {
                    initialize.prototype = Object.create(definition.Extends.prototype);
                    initialize.prototype.constructor = initialize;
                    //  For getOwnPropertyDescriptor to work, we need to act directly on the Extends (or Mixin)
                    Extends = definition.Extends;
                    delete definition.Extends;
                } else initialize.prototype.constructor = initialize;
                //  Grab the mixins, if they are specified...
                var mixins = null;
                if (definition.Mixins) {
                    mixins = definition.Mixins;
                    delete definition.Mixins;
                }
                //  First, mixin if we can.
                mixin(initialize, mixins);
                //  Now we grab the actual definition which defines the overrides.
                extend(initialize, definition, true, Extends);
                return initialize;
            }
            Class.extend = extend;
            Class.mixin = mixin;
            Class.ignoreFinals = false;
            module1.exports = Class;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A NOOP (No Operation) callback function.
 *
 * Used internally by Phaser when it's more expensive to determine if a callback exists
 * than it is to just invoke an empty function.
 *
 * @function Phaser.Utils.NOOP
 * @since 3.0.0
 */ var NOOP = function() {
            //  NOOP
            };
            module1.exports = NOOP;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Finds the key within the top level of the {@link source} object, or returns {@link defaultValue}
 *
 * @function Phaser.Utils.Objects.GetFastValue
 * @since 3.0.0
 *
 * @param {object} source - The object to search
 * @param {string} key - The key for the property on source. Must exist at the top level of the source object (no periods)
 * @param {*} [defaultValue] - The default value to use if the key does not exist.
 *
 * @return {*} The value if found; otherwise, defaultValue (null if none provided)
 */ var GetFastValue = function(source, key, defaultValue) {
                var t = typeof source;
                if (!source || t === "number" || t === "string") return defaultValue;
                else if (source.hasOwnProperty(key) && source[key] !== undefined) return source[key];
                else return defaultValue;
            };
            module1.exports = GetFastValue;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            var FuzzyEqual = __webpack_require__(124);
            /**
 * @classdesc
 * A representation of a vector in 2D space.
 *
 * A two-component vector.
 *
 * @class Vector2
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number|Phaser.Types.Math.Vector2Like} [x] - The x component, or an object with `x` and `y` properties.
 * @param {number} [y] - The y component.
 */ var Vector2 = new Class({
                initialize: function Vector2(x, y) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector2#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector2#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    if (typeof x === "object") {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                    } else {
                        if (y === undefined) y = x;
                        this.x = x || 0;
                        this.y = y || 0;
                    }
                },
                /**
     * Make a clone of this Vector2.
     *
     * @method Phaser.Math.Vector2#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} A clone of this Vector2.
     */ clone: function() {
                    return new Vector2(this.x, this.y);
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector2#copy
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ copy: function(src) {
                    this.x = src.x || 0;
                    this.y = src.y || 0;
                    return this;
                },
                /**
     * Set the component values of this Vector from a given Vector2Like object.
     *
     * @method Phaser.Math.Vector2#setFromObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} obj - The object containing the component values to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setFromObject: function(obj) {
                    this.x = obj.x || 0;
                    this.y = obj.y || 0;
                    return this;
                },
                /**
     * Set the `x` and `y` components of the this Vector to the given `x` and `y` values.
     *
     * @method Phaser.Math.Vector2#set
     * @since 3.0.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ set: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * This method is an alias for `Vector2.set`.
     *
     * @method Phaser.Math.Vector2#setTo
     * @since 3.4.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setTo: function(x, y) {
                    return this.set(x, y);
                },
                /**
     * Sets the `x` and `y` values of this object from a given polar coordinate.
     *
     * @method Phaser.Math.Vector2#setToPolar
     * @since 3.0.0
     *
     * @param {number} azimuth - The angular coordinate, in radians.
     * @param {number} [radius=1] - The radial coordinate (length).
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setToPolar: function(azimuth, radius) {
                    if (radius == null) radius = 1;
                    this.x = Math.cos(azimuth) * radius;
                    this.y = Math.sin(azimuth) * radius;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector2#equals
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} v - The vector to compare with this Vector.
     *
     * @return {boolean} Whether the given Vector is equal to this Vector.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y;
                },
                /**
     * Check whether this Vector is approximately equal to a given Vector.
     *
     * @method Phaser.Math.Vector2#fuzzyEquals
     * @since 3.23.0
     *
     * @param {Phaser.Types.Math.Vector2Like} v - The vector to compare with this Vector.
     * @param {number} [epsilon=0.0001] - The tolerance value.
     *
     * @return {boolean} Whether both absolute differences of the x and y components are smaller than `epsilon`.
     */ fuzzyEquals: function(v, epsilon) {
                    return FuzzyEqual(this.x, v.x, epsilon) && FuzzyEqual(this.y, v.y, epsilon);
                },
                /**
     * Calculate the angle between this Vector and the positive x-axis, in radians.
     *
     * @method Phaser.Math.Vector2#angle
     * @since 3.0.0
     *
     * @return {number} The angle between this Vector, and the positive x-axis, given in radians.
     */ angle: function() {
                    // computes the angle in radians with respect to the positive x-axis
                    var angle = Math.atan2(this.y, this.x);
                    if (angle < 0) angle += 2 * Math.PI;
                    return angle;
                },
                /**
     * Set the angle of this Vector.
     *
     * @method Phaser.Math.Vector2#setAngle
     * @since 3.23.0
     *
     * @param {number} angle - The angle, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setAngle: function(angle) {
                    return this.setToPolar(angle, this.length());
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector2#add
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ add: function(src) {
                    this.x += src.x;
                    this.y += src.y;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector2#subtract
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ subtract: function(src) {
                    this.x -= src.x;
                    this.y -= src.y;
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ multiply: function(src) {
                    this.x *= src.x;
                    this.y *= src.y;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector2#scale
     * @since 3.0.0
     *
     * @param {number} value - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ scale: function(value) {
                    if (isFinite(value)) {
                        this.x *= value;
                        this.y *= value;
                    } else {
                        this.x = 0;
                        this.y = 0;
                    }
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#divide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ divide: function(src) {
                    this.x /= src.x;
                    this.y /= src.y;
                    return this;
                },
                /**
     * Negate the `x` and `y` components of this Vector.
     *
     * @method Phaser.Math.Vector2#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#distance
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(src) {
                    var dx = src.x - this.x;
                    var dy = src.y - this.y;
                    return Math.sqrt(dx * dx + dy * dy);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector2#distanceSq
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(src) {
                    var dx = src.x - this.x;
                    var dy = src.y - this.y;
                    return dx * dx + dy * dy;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    return Math.sqrt(x * x + y * y);
                },
                /**
     * Set the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#setLength
     * @since 3.23.0
     *
     * @param {number} length
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setLength: function(length) {
                    return this.normalize().scale(length);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector2#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    return x * x + y * y;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector2#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var len = x * x + y * y;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                    }
                    return this;
                },
                /**
     * Rotate this Vector to its perpendicular, in the positive direction.
     *
     * @method Phaser.Math.Vector2#normalizeRightHand
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeRightHand: function() {
                    var x = this.x;
                    this.x = this.y * -1;
                    this.y = x;
                    return this;
                },
                /**
     * Rotate this Vector to its perpendicular, in the negative direction.
     *
     * @method Phaser.Math.Vector2#normalizeLeftHand
     * @since 3.23.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeLeftHand: function() {
                    var x = this.x;
                    this.x = this.y;
                    this.y = x * -1;
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#dot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to dot product with this Vector2.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(src) {
                    return this.x * src.x + this.y * src.y;
                },
                /**
     * Calculate the cross product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#cross
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to cross with this Vector2.
     *
     * @return {number} The cross product of this Vector and the given Vector.
     */ cross: function(src) {
                    return this.x * src.y - this.y * src.x;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector2#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} src - The Vector2 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ lerp: function(src, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    this.x = ax + t * (src.x - ax);
                    this.y = ay + t * (src.y - ay);
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat3: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var m = mat.val;
                    this.x = m[0] * x + m[3] * y + m[6];
                    this.y = m[1] * x + m[4] * y + m[7];
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[12];
                    this.y = m[1] * x + m[5] * y + m[13];
                    return this;
                },
                /**
     * Make this Vector the zero vector (0, 0).
     *
     * @method Phaser.Math.Vector2#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    return this;
                },
                /**
     * Limit the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#limit
     * @since 3.23.0
     *
     * @param {number} max - The maximum length.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ limit: function(max) {
                    var len = this.length();
                    if (len && len > max) this.scale(max / len);
                    return this;
                },
                /**
     * Reflect this Vector off a line defined by a normal.
     *
     * @method Phaser.Math.Vector2#reflect
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} normal - A vector perpendicular to the line.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reflect: function(normal) {
                    normal = normal.clone().normalize();
                    return this.subtract(normal.scale(2 * this.dot(normal)));
                },
                /**
     * Reflect this Vector across another.
     *
     * @method Phaser.Math.Vector2#mirror
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} axis - A vector to reflect across.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ mirror: function(axis) {
                    return this.reflect(axis).negate();
                },
                /**
     * Rotate this Vector by an angle amount.
     *
     * @method Phaser.Math.Vector2#rotate
     * @since 3.23.0
     *
     * @param {number} delta - The angle to rotate by, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ rotate: function(delta) {
                    var cos = Math.cos(delta);
                    var sin = Math.sin(delta);
                    return this.set(cos * this.x - sin * this.y, sin * this.x + cos * this.y);
                }
            });
            /**
 * A static zero Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ZERO
 * @type {Phaser.Math.Vector2}
 * @since 3.1.0
 */ Vector2.ZERO = new Vector2();
            /**
 * A static right Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.RIGHT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.RIGHT = new Vector2(1, 0);
            /**
 * A static left Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.LEFT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.LEFT = new Vector2(-1, 0);
            /**
 * A static up Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.UP
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.UP = new Vector2(0, -1);
            /**
 * A static down Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.DOWN
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.DOWN = new Vector2(0, 1);
            /**
 * A static one Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ONE
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.ONE = new Vector2(1, 1);
            module1.exports = Vector2;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GEOM_CONST = __webpack_require__(56);
            /**
 * @classdesc
 * Defines a Point in 2D space, with an x and y component.
 *
 * @class Point
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x coordinate of this Point.
 * @param {number} [y=x] - The y coordinate of this Point.
 */ var Point = new Class({
                initialize: function Point(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.POINT`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Point#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POINT;
                    /**
         * The x coordinate of this Point.
         *
         * @name Phaser.Geom.Point#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y coordinate of this Point.
         *
         * @name Phaser.Geom.Point#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                },
                /**
     * Set the x and y coordinates of the point to the given values.
     *
     * @method Phaser.Geom.Point#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of this Point.
     * @param {number} [y=x] - The y coordinate of this Point.
     *
     * @return {this} This Point object.
     */ setTo: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                }
            });
            module1.exports = Point;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The Game Object Factory is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and have them automatically registered with the Scene.
 *
 * Game Objects directly register themselves with the Factory and inject their own creation
 * methods into the class.
 *
 * @class GameObjectFactory
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectFactory = new Class({
                initialize: function GameObjectFactory(scene) {
                    /**
         * The Scene to which this Game Object Factory belongs.
         *
         * @name Phaser.GameObjects.GameObjectFactory#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectFactory#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectFactory#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.displayList = this.systems.displayList;
                    this.updateList = this.systems.updateList;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Adds an existing Game Object to this Scene.
     *
     * If the Game Object renders, it will be added to the Display List.
     * If it has a `preUpdate` method, it will be added to the Update List.
     *
     * @method Phaser.GameObjects.GameObjectFactory#existing
     * @since 3.0.0
     *
     * @generic {(Phaser.GameObjects.GameObject|Phaser.GameObjects.Group|Phaser.GameObjects.Layer)} G - [child,$return]
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.Group|Phaser.GameObjects.Layer)} child - The child to be added to this Scene.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that was added.
     */ existing: function(child) {
                    if (child.renderCanvas || child.renderWebGL) this.displayList.add(child);
                    //  For when custom objects have overridden `preUpdate` but don't hook into the ADDED_TO_SCENE event:
                    //  Adding to the list multiple times is safe, as it won't add duplicates into the list anyway.
                    if (child.preUpdate) this.updateList.add(child);
                    return child;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectFactory#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectFactory#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                    this.displayList = null;
                    this.updateList = null;
                }
            });
            /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can register a custom GameObject factory in the GameObjectFactory,
 * providing a name (`factoryType`) and the constructor (`factoryFunction`) in order
 * to be called when you call to Phaser.Scene.add[ factoryType ] method.
 *
 * @method Phaser.GameObjects.GameObjectFactory.register
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you will use to call to Phaser.Scene.add[ factoryType ] method.
 * @param {function} factoryFunction - The constructor function to be called when you invoke to the Phaser.Scene.add method.
 */ GameObjectFactory.register = function(factoryType, factoryFunction) {
                if (!GameObjectFactory.prototype.hasOwnProperty(factoryType)) GameObjectFactory.prototype[factoryType] = factoryFunction;
            };
            /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can remove a custom GameObject factory registered in the GameObjectFactory,
 * providing a its `factoryType`.
 *
 * @method Phaser.GameObjects.GameObjectFactory.remove
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you want to remove from the GameObjectFactory.
 */ GameObjectFactory.remove = function(factoryType) {
                if (GameObjectFactory.prototype.hasOwnProperty(factoryType)) delete GameObjectFactory.prototype[factoryType];
            };
            PluginCache.register("GameObjectFactory", GameObjectFactory, "add");
            module1.exports = GameObjectFactory;
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Source object
            //  The key as a string, or an array of keys, i.e. 'banner', or 'banner.hideBanner'
            //  The default value to use if the key doesn't exist
            /**
 * Retrieves a value from an object.
 *
 * @function Phaser.Utils.Objects.GetValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var GetValue = function(source, key, defaultValue) {
                if (!source || typeof source === "number") return defaultValue;
                else if (source.hasOwnProperty(key)) return source[key];
                else if (key.indexOf(".") !== -1) {
                    var keys = key.split(".");
                    var parent = source;
                    var value = defaultValue;
                    //  Use for loop here so we can break early
                    for(var i = 0; i < keys.length; i++)if (parent.hasOwnProperty(keys[i])) {
                        //  Yes it has a key property, let's carry on down
                        value = parent[keys[i]];
                        parent = parent[keys[i]];
                    } else {
                        //  Can't go any further, so reset to default
                        value = defaultValue;
                        break;
                    }
                    return value;
                } else return defaultValue;
            };
            module1.exports = GetValue;
        /***/ },
        /* 7 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a slightly modified version of jQuery.isPlainObject.
 * A plain object is an object whose internal class property is [object Object].
 *
 * @function Phaser.Utils.Objects.IsPlainObject
 * @since 3.0.0
 *
 * @param {object} obj - The object to inspect.
 *
 * @return {boolean} `true` if the object is plain, otherwise `false`.
 */ var IsPlainObject = function(obj) {
                // Not plain objects:
                // - Any object or value whose internal [[Class]] property is not "[object Object]"
                // - DOM nodes
                // - window
                if (typeof obj !== "object" || obj.nodeType || obj === obj.window) return false;
                // Support: Firefox <20
                // The try/catch suppresses exceptions thrown when attempting to access
                // the "constructor" property of certain host objects, ie. |window.location|
                // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
                try {
                    if (obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf")) return false;
                } catch (e) {
                    return false;
                }
                // If the function hasn't returned already, we're confident that
                // |obj| is a plain object, created by {} or constructed with new Object
                return true;
            };
            module1.exports = IsPlainObject;
        /***/ },
        /* 8 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var types = {};
            /**
 * @namespace Phaser.Loader.FileTypesManager
 */ var FileTypesManager = {
                /**
     * Static method called when a LoaderPlugin is created.
     * 
     * Loops through the local types object and injects all of them as
     * properties into the LoaderPlugin instance.
     *
     * @method Phaser.Loader.FileTypesManager.install
     * @since 3.0.0
     * 
     * @param {Phaser.Loader.LoaderPlugin} loader - The LoaderPlugin to install the types into.
     */ install: function(loader) {
                    for(var key in types)loader[key] = types[key];
                },
                /**
     * Static method called directly by the File Types.
     * 
     * The key is a reference to the function used to load the files via the Loader, i.e. `image`.
     *
     * @method Phaser.Loader.FileTypesManager.register
     * @since 3.0.0
     * 
     * @param {string} key - The key that will be used as the method name in the LoaderPlugin.
     * @param {function} factoryFunction - The function that will be called when LoaderPlugin.key is invoked.
     */ register: function(key, factoryFunction) {
                    types[key] = factoryFunction;
                },
                /**
     * Removed all associated file types.
     *
     * @method Phaser.Loader.FileTypesManager.destroy
     * @since 3.0.0
     */ destroy: function() {
                    types = {};
                }
            };
            module1.exports = FileTypesManager;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var has = Object.prototype.hasOwnProperty, prefix = "~";
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
                if (typeof fn !== "function") throw new TypeError("The listener must be a function");
                var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
                if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
                else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
                else emitter._events[evt] = [
                    emitter._events[evt],
                    listener
                ];
                return emitter;
            }
            /**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
                if (--emitter._eventsCount === 0) emitter._events = new Events();
                else delete emitter._events[evt];
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
                var evt = prefix ? prefix + event : event, handlers = this._events[evt];
                if (!handlers) return [];
                if (handlers.fn) return [
                    handlers.fn
                ];
                for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
                return ee;
            };
            /**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
                var evt = prefix ? prefix + event : event, listeners = this._events[evt];
                if (!listeners) return 0;
                if (listeners.fn) return 1;
                return listeners.length;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                return addListener(this, event, fn, context, false);
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                return addListener(this, event, fn, context, true);
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    clearEvent(this, evt);
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else clearEvent(this, evt);
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) clearEvent(this, evt);
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            module1.exports = EventEmitter;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(57);
            var GetPoint = __webpack_require__(171);
            var GetPoints = __webpack_require__(306);
            var GEOM_CONST = __webpack_require__(56);
            var Line = __webpack_require__(47);
            var Random = __webpack_require__(174);
            /**
 * @classdesc
 * Encapsulates a 2D rectangle defined by its corner point in the top-left and its extends in x (width) and y (height)
 *
 * @class Rectangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the top left corner of the Rectangle.
 * @param {number} [y=0] - The Y coordinate of the top left corner of the Rectangle.
 * @param {number} [width=0] - The width of the Rectangle.
 * @param {number} [height=0] - The height of the Rectangle.
 */ var Rectangle = new Class({
                initialize: function Rectangle(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.RECTANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Rectangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.RECTANGLE;
                    /**
         * The X coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The Y coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the Rectangle, i.e. the distance between its left side (defined by `x`) and its right side.
         *
         * @name Phaser.Geom.Rectangle#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Rectangle, i.e. the distance between its top side (defined by `y`) and its bottom side.
         *
         * @name Phaser.Geom.Rectangle#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                },
                /**
     * Checks if the given point is inside the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the point to check.
     * @param {number} y - The Y coordinate of the point to check.
     *
     * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
     * 
     * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
     * 
     * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
     *
     * @method Phaser.Geom.Rectangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
     * @param {(Phaser.Geom.Point|object)} [output] - An object to update with the `x` and `y` coordinates of the point.
     *
     * @return {(Phaser.Geom.Point|object)} The updated `output` object, or a new Point if no `output` object was given.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Returns an array of points from the perimeter of the Rectangle, each spaced out based on the quantity or step required.
     *
     * @method Phaser.Geom.Rectangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to return. Set to `false` or 0 to return an arbitrary number of points (`perimeter / stepRate`) evenly spaced around the Rectangle based on the `stepRate`.
     * @param {number} [stepRate] - If `quantity` is 0, determines the normalized distance between each returned point.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to which to append the points.
     *
     * @return {(array|Phaser.Geom.Point[])} The modified `output` array, or a new array if none was provided.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a random point within the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - The object in which to store the `x` and `y` coordinates of the point.
     *
     * @return {Phaser.Geom.Point} The updated `point`, or a new Point if none was provided.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the position, width, and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setTo
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} y - The Y coordinate of the top left corner of the Rectangle.
     * @param {number} width - The width of the Rectangle.
     * @param {number} height - The height of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setTo: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Resets the position, width, and height of the Rectangle to 0.
     *
     * @method Phaser.Geom.Rectangle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Rectangle object.
     */ setEmpty: function() {
                    return this.setTo(0, 0, 0, 0);
                },
                /**
     * Sets the position of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} [y=x] - The Y coordinate of the top left corner of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the width and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width to set the Rectangle to.
     * @param {number} [height=width] - The height to set the Rectangle to.
     *
     * @return {this} This Rectangle object.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Determines if the Rectangle is empty. A Rectangle is empty if its width or height is less than or equal to 0.
     *
     * @method Phaser.Geom.Rectangle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Rectangle is empty. A Rectangle object is empty if its width or height is less than or equal to 0.
     */ isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                /**
     * Returns a Line object that corresponds to the top of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the top of this Rectangle.
     */ getLineA: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x, this.y, this.right, this.y);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the right of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the right of this Rectangle.
     */ getLineB: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.right, this.y, this.right, this.bottom);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the bottom of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the bottom of this Rectangle.
     */ getLineC: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.right, this.bottom, this.x, this.bottom);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the left of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineD
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the left of this Rectangle.
     */ getLineD: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x, this.bottom, this.x, this.y);
                    return line;
                },
                /**
     * The x coordinate of the left of the Rectangle.
     * Changing the left property of a Rectangle object has no effect on the y and height properties. However it does affect the width property, whereas changing the x value does not affect the width property.
     *
     * @name Phaser.Geom.Rectangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x;
                    },
                    set: function(value) {
                        if (value >= this.right) this.width = 0;
                        else this.width = this.right - value;
                        this.x = value;
                    }
                },
                /**
     * The sum of the x and width properties.
     * Changing the right property of a Rectangle object has no effect on the x, y and height properties, however it does affect the width property.
     *
     * @name Phaser.Geom.Rectangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this.width;
                    },
                    set: function(value) {
                        if (value <= this.x) this.width = 0;
                        else this.width = value - this.x;
                    }
                },
                /**
     * The y coordinate of the top of the Rectangle. Changing the top property of a Rectangle object has no effect on the x and width properties.
     * However it does affect the height property, whereas changing the y value does not affect the height property.
     *
     * @name Phaser.Geom.Rectangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y;
                    },
                    set: function(value) {
                        if (value >= this.bottom) this.height = 0;
                        else this.height = this.bottom - value;
                        this.y = value;
                    }
                },
                /**
     * The sum of the y and height properties.
     * Changing the bottom property of a Rectangle object has no effect on the x, y and width properties, but does change the height property.
     *
     * @name Phaser.Geom.Rectangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this.height;
                    },
                    set: function(value) {
                        if (value <= this.y) this.height = 0;
                        else this.height = value - this.y;
                    }
                },
                /**
     * The x coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerX
     * @type {number}
     * @since 3.0.0
     */ centerX: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(value) {
                        this.x = value - this.width / 2;
                    }
                },
                /**
     * The y coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerY
     * @type {number}
     * @since 3.0.0
     */ centerY: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(value) {
                        this.y = value - this.height / 2;
                    }
                }
            });
            module1.exports = Rectangle;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Components
 */ module1.exports = {
                Alpha: __webpack_require__(607),
                AlphaSingle: __webpack_require__(303),
                BlendMode: __webpack_require__(304),
                ComputedSize: __webpack_require__(608),
                Crop: __webpack_require__(609),
                Depth: __webpack_require__(305),
                Flip: __webpack_require__(610),
                GetBounds: __webpack_require__(611),
                Mask: __webpack_require__(309),
                Origin: __webpack_require__(632),
                PathFollower: __webpack_require__(633),
                Pipeline: __webpack_require__(167),
                ScrollFactor: __webpack_require__(312),
                Size: __webpack_require__(634),
                Texture: __webpack_require__(635),
                TextureCrop: __webpack_require__(636),
                Tint: __webpack_require__(637),
                ToJSON: __webpack_require__(176),
                Transform: __webpack_require__(313),
                TransformMatrix: __webpack_require__(25),
                Visible: __webpack_require__(314)
            };
        /***/ },
        /* 12 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @author       Matthew Groves <@doormat>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate shader source to test maximum ifs.
 *
 * @private
 * @ignore
 * @param {number} maxIfs - The number of if statements to generate
 */ function GenerateSrc(maxIfs) {
                var src = "";
                for(var i = 0; i < maxIfs; ++i){
                    if (i > 0) src += "\nelse ";
                    if (i < maxIfs - 1) src += "if(test == " + i + ".0){}";
                }
                return src;
            }
            /**
 * @namespace Phaser.Renderer.WebGL.Utils
 * @since 3.0.0
 */ module1.exports = {
                /**
     * Packs four floats on a range from 0.0 to 1.0 into a single Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintFromFloats
     * @since 3.0.0
     *
     * @param {number} r - Red component in a range from 0.0 to 1.0
     * @param {number} g - Green component in a range from 0.0 to 1.0
     * @param {number} b - Blue component in a range from 0.0 to 1.0
     * @param {number} a - Alpha component in a range from 0.0 to 1.0
     *
     * @return {number} The packed RGBA values as a Uint32.
     */ getTintFromFloats: function(r, g, b, a) {
                    var ur = (r * 255 | 0) & 0xff;
                    var ug = (g * 255 | 0) & 0xff;
                    var ub = (b * 255 | 0) & 0xff;
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | ur << 16 | ug << 8 | ub) >>> 0;
                },
                /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlpha: function(rgb, a) {
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | rgb) >>> 0;
                },
                /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a
     * swizzled Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlphaAndSwap
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlphaAndSwap: function(rgb, a) {
                    var ur = (rgb >> 16 | 0) & 0xff;
                    var ug = (rgb >> 8 | 0) & 0xff;
                    var ub = (rgb | 0) & 0xff;
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | ub << 16 | ug << 8 | ur) >>> 0;
                },
                /**
     * Unpacks a Uint24 RGB into an array of floats of ranges of 0.0 and 1.0
     *
     * @function Phaser.Renderer.WebGL.Utils.getFloatsFromUintRGB
     * @since 3.0.0
     *
     * @param {number} rgb - RGB packed as a Uint24
     *
     * @return {array} Array of floats representing each component as a float
     */ getFloatsFromUintRGB: function(rgb) {
                    var ur = (rgb >> 16 | 0) & 0xff;
                    var ug = (rgb >> 8 | 0) & 0xff;
                    var ub = (rgb | 0) & 0xff;
                    return [
                        ur / 255,
                        ug / 255,
                        ub / 255
                    ];
                },
                /**
     * Check to see how many texture units the GPU supports, based on the given config value.
     * Then tests this against the maximum number of iterations GLSL can support.
     *
     * @function Phaser.Renderer.WebGL.Utils.checkShaderMax
     * @since 3.50.0
     *
     * @param {WebGLRenderingContext} gl - The WebGLContext used to create the shaders.
     * @param {number} maxTextures - The Game Config maxTextures value.
     *
     * @return {number} The number of texture units that is supported by this browser and GPU.
     */ checkShaderMax: function(gl, maxTextures) {
                    if (!maxTextures || maxTextures === -1) maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                    var shader = gl.createShader(gl.FRAGMENT_SHADER);
                    var fragTemplate = [
                        "precision mediump float;",
                        "void main(void){",
                        "float test = 0.1;",
                        "%forloop%",
                        "gl_FragColor = vec4(0.0);",
                        "}"
                    ].join("\n");
                    // eslint-disable-next-line no-constant-condition
                    while(true){
                        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, GenerateSrc(maxTextures));
                        gl.shaderSource(shader, fragmentSrc);
                        gl.compileShader(shader);
                        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxTextures = maxTextures / 2 | 0;
                        else break;
                    }
                    return maxTextures;
                },
                /**
     * Checks the given Fragment Shader Source for `%count%` and `%forloop%` declarations and
     * replaces those with GLSL code for setting `texture = texture2D(uMainSampler[i], outTexCoord)`.
     *
     * @function Phaser.Renderer.WebGL.Utils.parseFragmentShaderMaxTextures
     * @since 3.50.0
     *
     * @param {string} fragmentShaderSource - The Fragment Shader source code to operate on.
     * @param {number} maxTextures - The number of maxTextures value.
     *
     * @return {string} The modified Fragment Shader source.
     */ parseFragmentShaderMaxTextures: function(fragmentShaderSource, maxTextures) {
                    if (!fragmentShaderSource) return "";
                    var src = "";
                    for(var i = 0; i < maxTextures; i++){
                        if (i > 0) src += "\n	else ";
                        if (i < maxTextures - 1) src += "if (outTexId < " + i + ".5)";
                        src += "\n	{";
                        src += "\n		texture = texture2D(uMainSampler[" + i + "], outTexCoord);";
                        src += "\n	}";
                    }
                    fragmentShaderSource = fragmentShaderSource.replace(/%count%/gi, maxTextures.toString());
                    return fragmentShaderSource.replace(/%forloop%/gi, src);
                }
            };
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH = __webpack_require__(193);
            var GetValue = __webpack_require__(6);
            /**
 * Retrieves a value from an object. Allows for more advanced selection options, including:
 *
 * Allowed types:
 * 
 * Implicit
 * {
 *     x: 4
 * }
 *
 * From function
 * {
 *     x: function ()
 * }
 *
 * Randomly pick one element from the array
 * {
 *     x: [a, b, c, d, e, f]
 * }
 *
 * Random integer between min and max:
 * {
 *     x: { randInt: [min, max] }
 * }
 *
 * Random float between min and max:
 * {
 *     x: { randFloat: [min, max] }
 * }
 * 
 *
 * @function Phaser.Utils.Objects.GetAdvancedValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var GetAdvancedValue = function(source, key, defaultValue) {
                var value = GetValue(source, key, null);
                if (value === null) return defaultValue;
                else if (Array.isArray(value)) return MATH.RND.pick(value);
                else if (typeof value === "object") {
                    if (value.hasOwnProperty("randInt")) return MATH.RND.integerInRange(value.randInt[0], value.randInt[1]);
                    else if (value.hasOwnProperty("randFloat")) return MATH.RND.realInRange(value.randFloat[0], value.randFloat[1]);
                } else if (typeof value === "function") return value(key);
                return value;
            };
            module1.exports = GetAdvancedValue;
        /***/ },
        /* 14 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = {
                /**
     * The value of PI * 2.
     * 
     * @name Phaser.Math.PI2
     * @type {number}
     * @since 3.0.0
     */ PI2: Math.PI * 2,
                /**
     * The value of PI * 0.5.
     * 
     * @name Phaser.Math.TAU
     * @type {number}
     * @since 3.0.0
     */ TAU: Math.PI * 0.5,
                /**
     * An epsilon value (1.0e-6)
     * 
     * @name Phaser.Math.EPSILON
     * @type {number}
     * @since 3.0.0
     */ EPSILON: 1.0e-6,
                /**
     * For converting degrees to radians (PI / 180)
     * 
     * @name Phaser.Math.DEG_TO_RAD
     * @type {number}
     * @since 3.0.0
     */ DEG_TO_RAD: Math.PI / 180,
                /**
     * For converting radians to degrees (180 / PI)
     * 
     * @name Phaser.Math.RAD_TO_DEG
     * @type {number}
     * @since 3.0.0
     */ RAD_TO_DEG: 180 / Math.PI,
                /**
     * An instance of the Random Number Generator.
     * This is not set until the Game boots.
     * 
     * @name Phaser.Math.RND
     * @type {Phaser.Math.RandomDataGenerator}
     * @since 3.0.0
     */ RND: null,
                /**
     * The minimum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     * 
     * @name Phaser.Math.MIN_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER || -9007199254740991,
                /**
     * The maximum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     * 
     * @name Phaser.Math.MAX_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991
            };
            module1.exports = MATH_CONST;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ComponentsToJSON = __webpack_require__(176);
            var DataManager = __webpack_require__(101);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(75);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The base class that all Game Objects extend.
 * You don't create GameObjects directly and they cannot be added to the display list.
 * Instead, use them as the base for your own custom classes.
 *
 * @class GameObject
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {string} type - A textual representation of the type of Game Object, i.e. `sprite`.
 */ var GameObject = new Class({
                Extends: EventEmitter,
                initialize: function GameObject(scene, type) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.GameObject#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.GameObject#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                    /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.GameObject#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                    /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.GameObject#state
         * @type {(number|string)}
         * @since 3.16.0
         */ this.state = 0;
                    /**
         * The parent Container of this Game Object, if it has one.
         *
         * @name Phaser.GameObjects.GameObject#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.4.0
         */ this.parentContainer = null;
                    /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.GameObject#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = "";
                    /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.GameObject#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.GameObject#tabIndex
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.tabIndex = -1;
                    /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.GameObject#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.0.0
         */ this.data = null;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.GameObject#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.GameObject#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                    /**
         * If this Game Object is enabled for input then this property will contain an InteractiveObject instance.
         * Not usually set directly. Instead call `GameObject.setInteractive()`.
         *
         * @name Phaser.GameObjects.GameObject#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.0.0
         */ this.input = null;
                    /**
         * If this Game Object is enabled for Arcade or Matter Physics then this property will contain a reference to a Physics Body.
         *
         * @name Phaser.GameObjects.GameObject#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                    /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.GameObject#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.5.0
         */ this.ignoreDestroy = false;
                    this.on(Events.ADDED_TO_SCENE, this.addedToScene, this);
                    this.on(Events.REMOVED_FROM_SCENE, this.removedFromScene, this);
                    //  Tell the Scene to re-sort the children
                    scene.sys.queueDepthSort();
                },
                /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.GameObject#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.GameObject#setName
     * @since 3.0.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.GameObject#setState
     * @since 3.16.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                    this.state = value;
                    return this;
                },
                /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#setDataEnabled
     * @since 3.0.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                    if (!this.data) this.data = new DataManager(this);
                    return this;
                },
                /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.GameObject#setData
     * @since 3.0.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.set(key, value);
                    return this;
                },
                /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#incData
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.inc(key, value);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toggleData
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.toggle(key);
                    return this;
                },
                /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.GameObject#getData
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    return this.data.get(key);
                },
                /**
     * Pass this Game Object to the Input Manager to enable it for Input.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @example
     * sprite.setInteractive();
     *
     * @example
     * sprite.setInteractive(new Phaser.Geom.Circle(45, 46, 45), Phaser.Geom.Circle.Contains);
     *
     * @example
     * graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, 128, 128), Phaser.Geom.Rectangle.Contains);
     *
     * @method Phaser.GameObjects.GameObject#setInteractive
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not given it will try to create a Rectangle based on the texture frame.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The callback that determines if the pointer is within the Hit Area shape or not. If you provide a shape you must also provide a callback.
     * @param {boolean} [dropZone=false] - Should this Game Object be treated as a drop zone target?
     *
     * @return {this} This GameObject.
     */ setInteractive: function(hitArea, hitAreaCallback, dropZone) {
                    this.scene.sys.input.enable(this, hitArea, hitAreaCallback, dropZone);
                    return this;
                },
                /**
     * If this Game Object has previously been enabled for input, this will disable it.
     *
     * An object that is disabled for input stops processing or being considered for
     * input events, but can be turned back on again at any time by simply calling
     * `setInteractive()` with no arguments provided.
     *
     * If want to completely remove interaction from this Game Object then use `removeInteractive` instead.
     *
     * @method Phaser.GameObjects.GameObject#disableInteractive
     * @since 3.7.0
     *
     * @return {this} This GameObject.
     */ disableInteractive: function() {
                    if (this.input) this.input.enabled = false;
                    return this;
                },
                /**
     * If this Game Object has previously been enabled for input, this will queue it
     * for removal, causing it to no longer be interactive. The removal happens on
     * the next game step, it is not immediate.
     *
     * The Interactive Object that was assigned to this Game Object will be destroyed,
     * removed from the Input Manager and cleared from this Game Object.
     *
     * If you wish to re-enable this Game Object at a later date you will need to
     * re-create its InteractiveObject by calling `setInteractive` again.
     *
     * If you wish to only temporarily stop an object from receiving input then use
     * `disableInteractive` instead, as that toggles the interactive state, where-as
     * this erases it completely.
     *
     * If you wish to resize a hit area, don't remove and then set it as being
     * interactive. Instead, access the hitarea object directly and resize the shape
     * being used. I.e.: `sprite.input.hitArea.setSize(width, height)` (assuming the
     * shape is a Rectangle, which it is by default.)
     *
     * @method Phaser.GameObjects.GameObject#removeInteractive
     * @since 3.7.0
     *
     * @return {this} This GameObject.
     */ removeInteractive: function() {
                    this.scene.sys.input.clear(this);
                    this.input = undefined;
                    return this;
                },
                /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.GameObject#update
     * @since 3.0.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return ComponentsToJSON(this);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.GameObject#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.GameObject#getIndexList
     * @since 3.4.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                    // eslint-disable-next-line consistent-this
                    var child = this;
                    var parent = this.parentContainer;
                    var indexes = [];
                    while(parent){
                        indexes.unshift(parent.getIndex(child));
                        child = parent;
                        if (!parent.parentContainer) break;
                        else parent = parent.parentContainer;
                    }
                    if (this.displayList) indexes.unshift(this.displayList.getIndex(child));
                    else indexes.unshift(this.scene.sys.displayList.getIndex(child));
                    return indexes;
                },
                /**
     * Adds this Game Object to the given Display List.
     *
     * If no Display List is specified, it will default to the Display List owned by the Scene to which
     * this Game Object belongs.
     *
     * A Game Object can only exist on one Display List at any given time, but may move freely between them.
     *
     * If this Game Object is already on another Display List when this method is called, it will first
     * be removed from it, before being added to the new list.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.GameObject#displayList` property.
     *
     * If a Game Object isn't on any display list, it will not be rendered. If you just wish to temporarly
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.GameObject#addToDisplayList
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.53.0
     *
     * @param {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)} [displayList] - The Display List to add to. Defaults to the Scene Display List.
     *
     * @return {this} This Game Object.
     */ addToDisplayList: function(displayList) {
                    if (displayList === undefined) displayList = this.scene.sys.displayList;
                    if (this.displayList && this.displayList !== displayList) this.removeFromDisplayList();
                    //  Don't repeat if it's already on this list
                    if (!displayList.exists(this)) {
                        this.displayList = displayList;
                        displayList.add(this, true);
                        displayList.queueDepthSort();
                        this.emit(Events.ADDED_TO_SCENE, this, this.scene);
                        displayList.events.emit(SceneEvents.ADDED_TO_SCENE, this, this.scene);
                    }
                    return this;
                },
                /**
     * Adds this Game Object to the Update List belonging to the Scene.
     *
     * When a Game Object is added to the Update List it will have its `preUpdate` method called
     * every game frame. This method is passed two parameters: `delta` and `time`.
     *
     * If you wish to run your own logic within `preUpdate` then you should always call
     * `preUpdate.super(delta, time)` within it, or it may fail to process required operations,
     * such as Sprite animations.
     *
     * @method Phaser.GameObjects.GameObject#addToUpdateList
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ addToUpdateList: function() {
                    if (this.scene && this.preUpdate) this.scene.sys.updateList.add(this);
                    return this;
                },
                /**
     * Removes this Game Object from the Display List it is currently on.
     *
     * A Game Object can only exist on one Display List at any given time, but may move freely removed
     * and added back at a later stage.
     *
     * You can query which list it is on by looking at the `Phaser.GameObjects.GameObject#displayList` property.
     *
     * If a Game Object isn't on any Display List, it will not be rendered. If you just wish to temporarly
     * disable it from rendering, consider using the `setVisible` method, instead.
     *
     * @method Phaser.GameObjects.GameObject#removeFromDisplayList
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ removeFromDisplayList: function() {
                    var displayList = this.displayList || this.scene.sys.displayList;
                    if (displayList.exists(this)) {
                        displayList.remove(this, true);
                        displayList.queueDepthSort();
                        this.displayList = null;
                        this.emit(Events.REMOVED_FROM_SCENE, this, this.scene);
                        displayList.events.emit(SceneEvents.REMOVED_FROM_SCENE, this, this.scene);
                    }
                    return this;
                },
                /**
     * Removes this Game Object from the Scene's Update List.
     *
     * When a Game Object is on the Update List, it will have its `preUpdate` method called
     * every game frame. Calling this method will remove it from the list, preventing this.
     *
     * Removing a Game Object from the Update List will stop most internal functions working.
     * For example, removing a Sprite from the Update List will prevent it from being able to
     * run animations.
     *
     * @method Phaser.GameObjects.GameObject#removeFromUpdateList
     * @since 3.53.0
     *
     * @return {this} This Game Object.
     */ removeFromUpdateList: function() {
                    if (this.scene && this.preUpdate) this.scene.sys.updateList.remove(this);
                    return this;
                },
                /**
     * Destroys this Game Object removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also removes itself from the Input Manager and Physics Manager if previously enabled.
     *
     * Use this to remove a Game Object from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.GameObject#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.0.0
     *
     * @param {boolean} [fromScene=false] - `True` if this Game Object is being destroyed by the Scene, `false` if not.
     */ destroy: function(fromScene) {
                    //  This Game Object has already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    if (fromScene === undefined) fromScene = false;
                    if (this.preDestroy) this.preDestroy.call(this);
                    this.emit(Events.DESTROY, this, fromScene);
                    this.removeAllListeners();
                    if (this.postPipelines) this.resetPostPipeline(true);
                    this.removeFromDisplayList();
                    this.removeFromUpdateList();
                    if (this.input) {
                        this.scene.sys.input.clear(this);
                        this.input = undefined;
                    }
                    if (this.data) {
                        this.data.destroy();
                        this.data = undefined;
                    }
                    if (this.body) {
                        this.body.destroy();
                        this.body = undefined;
                    }
                    this.active = false;
                    this.visible = false;
                    this.scene = undefined;
                    this.parentContainer = undefined;
                }
            });
            /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.GameObject
 * @default
 */ GameObject.RENDER_MASK = 15;
            module1.exports = GameObject;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The Game Object Creator is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and return them. Unlike the Game Object Factory, they are not automatically
 * added to the Scene.
 *
 * Game Objects directly register themselves with the Creator and inject their own creation
 * methods into the class.
 *
 * @class GameObjectCreator
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectCreator = new Class({
                initialize: function GameObjectCreator(scene) {
                    /**
         * The Scene to which this Game Object Creator belongs.
         *
         * @name Phaser.GameObjects.GameObjectCreator#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectCreator#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectCreator#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.displayList = this.systems.displayList;
                    this.updateList = this.systems.updateList;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectCreator#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectCreator#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                    this.displayList = null;
                    this.updateList = null;
                }
            });
            /**
 * Static method called directly by the Game Object creator functions.
 * With this method you can register a custom GameObject factory in the GameObjectCreator,
 * providing a name (`factoryType`) and the constructor (`factoryFunction`) in order
 * to be called when you invoke Phaser.Scene.make[ factoryType ] method.
 *
 * @method Phaser.GameObjects.GameObjectCreator.register
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you will use to call to Phaser.Scene.make[ factoryType ] method.
 * @param {function} factoryFunction - The constructor function to be called when you invoke to the Phaser.Scene.make method.
 */ GameObjectCreator.register = function(factoryType, factoryFunction) {
                if (!GameObjectCreator.prototype.hasOwnProperty(factoryType)) GameObjectCreator.prototype[factoryType] = factoryFunction;
            };
            /**
 * Static method called directly by the Game Object Creator functions.
 *
 * With this method you can remove a custom Game Object Creator that has been previously
 * registered in the Game Object Creator. Pass in its `factoryType` in order to remove it.
 *
 * @method Phaser.GameObjects.GameObjectCreator.remove
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you want to remove from the GameObjectCreator.
 */ GameObjectCreator.remove = function(factoryType) {
                if (GameObjectCreator.prototype.hasOwnProperty(factoryType)) delete GameObjectCreator.prototype[factoryType];
            };
            PluginCache.register("GameObjectCreator", GameObjectCreator, "make");
            module1.exports = GameObjectCreator;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsPlainObject = __webpack_require__(7);
            // @param {boolean} deep - Perform a deep copy?
            // @param {object} target - The target object to copy to.
            // @return {object} The extended object.
            /**
 * This is a slightly modified version of http://api.jquery.com/jQuery.extend/
 *
 * @function Phaser.Utils.Objects.Extend
 * @since 3.0.0
 *
 * @param {...*} [args] - The objects that will be mixed.
 *
 * @return {object} The extended object.
 */ var Extend = function() {
                var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
                // Handle a deep copy situation
                if (typeof target === "boolean") {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                // extend Phaser if only one argument is passed
                if (length === i) {
                    target = this;
                    --i;
                }
                for(; i < length; i++){
                    // Only deal with non-null/undefined values
                    if ((options = arguments[i]) != null) // Extend the base object
                    for(name in options){
                        src = target[name];
                        copy = options[name];
                        // Prevent never-ending loop
                        if (target === copy) continue;
                        // Recurse if we're merging plain objects or arrays
                        if (deep && copy && (IsPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                            if (copyIsArray) {
                                copyIsArray = false;
                                clone = src && Array.isArray(src) ? src : [];
                            } else clone = src && IsPlainObject(src) ? src : {};
                            // Never move original objects, clone them
                            target[name] = Extend(deep, clone, copy);
                        // Don't bring in undefined values
                        } else if (copy !== undefined) target[name] = copy;
                    }
                }
                // Return the modified object
                return target;
            };
            module1.exports = Extend;
        /***/ },
        /* 18 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Force a value within the boundaries by clamping it to the range `min`, `max`.
 *
 * @function Phaser.Math.Clamp
 * @since 3.0.0
 *
 * @param {number} value - The value to be clamped.
 * @param {number} min - The minimum bounds.
 * @param {number} max - The maximum bounds.
 *
 * @return {number} The clamped value.
 */ var Clamp = function(value, min, max) {
                return Math.max(min, Math.min(max, value));
            };
            module1.exports = Clamp;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var result = {
                camera: tempMatrix1,
                sprite: tempMatrix2,
                calc: tempMatrix3
            };
            /**
 * Calculates the Transform Matrix of the given Game Object and Camera, factoring in
 * the parent matrix if provided.
 *
 * Note that the object this results contains _references_ to the Transform Matrices,
 * not new instances of them. Therefore, you should use their values immediately, or
 * copy them to your own matrix, as they will be replaced as soon as another Game
 * Object is rendered.
 *
 * @function Phaser.GameObjects.GetCalcMatrix
 * @memberof Phaser.GameObjects
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} src - The Game Object to calculate the transform matrix for.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera being used to render the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - The transform matrix of the parent container, if any.
 *
 * @return {Phaser.Types.GameObjects.GetCalcMatrixResults} The results object containing the updated transform matrices.
 */ var GetCalcMatrix = function(src, camera, parentMatrix) {
                var camMatrix = tempMatrix1;
                var spriteMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                spriteMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                camMatrix.copyFrom(camera.matrix);
                if (parentMatrix) {
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    spriteMatrix.e = src.x;
                    spriteMatrix.f = src.y;
                } else {
                    spriteMatrix.e -= camera.scrollX * src.scrollFactorX;
                    spriteMatrix.f -= camera.scrollY * src.scrollFactorY;
                }
                //  Multiply by the Sprite matrix, store result in calcMatrix
                camMatrix.multiply(spriteMatrix, calcMatrix);
                return result;
            };
            module1.exports = GetCalcMatrix;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scenes.Events
 */ module1.exports = {
                ADDED_TO_SCENE: __webpack_require__(656),
                BOOT: __webpack_require__(657),
                CREATE: __webpack_require__(658),
                DESTROY: __webpack_require__(659),
                PAUSE: __webpack_require__(660),
                POST_UPDATE: __webpack_require__(661),
                PRE_RENDER: __webpack_require__(662),
                PRE_UPDATE: __webpack_require__(663),
                READY: __webpack_require__(664),
                REMOVED_FROM_SCENE: __webpack_require__(665),
                RENDER: __webpack_require__(666),
                RESUME: __webpack_require__(667),
                SHUTDOWN: __webpack_require__(668),
                SLEEP: __webpack_require__(669),
                START: __webpack_require__(670),
                TRANSITION_COMPLETE: __webpack_require__(671),
                TRANSITION_INIT: __webpack_require__(672),
                TRANSITION_OUT: __webpack_require__(673),
                TRANSITION_START: __webpack_require__(674),
                TRANSITION_WAKE: __webpack_require__(675),
                UPDATE: __webpack_require__(676),
                WAKE: __webpack_require__(677)
            };
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FILE_CONST = {
                /**
     * The Loader is idle.
     * 
     * @name Phaser.Loader.LOADER_IDLE
     * @type {number}
     * @since 3.0.0
     */ LOADER_IDLE: 0,
                /**
     * The Loader is actively loading.
     * 
     * @name Phaser.Loader.LOADER_LOADING
     * @type {number}
     * @since 3.0.0
     */ LOADER_LOADING: 1,
                /**
     * The Loader is processing files is has loaded.
     * 
     * @name Phaser.Loader.LOADER_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ LOADER_PROCESSING: 2,
                /**
     * The Loader has completed loading and processing.
     * 
     * @name Phaser.Loader.LOADER_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ LOADER_COMPLETE: 3,
                /**
     * The Loader is shutting down.
     * 
     * @name Phaser.Loader.LOADER_SHUTDOWN
     * @type {number}
     * @since 3.0.0
     */ LOADER_SHUTDOWN: 4,
                /**
     * The Loader has been destroyed.
     * 
     * @name Phaser.Loader.LOADER_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ LOADER_DESTROYED: 5,
                /**
     * File is in the load queue but not yet started
     * 
     * @name Phaser.Loader.FILE_PENDING
     * @type {number}
     * @since 3.0.0
     */ FILE_PENDING: 10,
                /**
     * File has been started to load by the loader (onLoad called)
     * 
     * @name Phaser.Loader.FILE_LOADING
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADING: 11,
                /**
     * File has loaded successfully, awaiting processing    
     * 
     * @name Phaser.Loader.FILE_LOADED
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADED: 12,
                /**
     * File failed to load
     * 
     * @name Phaser.Loader.FILE_FAILED
     * @type {number}
     * @since 3.0.0
     */ FILE_FAILED: 13,
                /**
     * File is being processed (onProcess callback)
     * 
     * @name Phaser.Loader.FILE_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ FILE_PROCESSING: 14,
                /**
     * The File has errored somehow during processing.
     * 
     * @name Phaser.Loader.FILE_ERRORED
     * @type {number}
     * @since 3.0.0
     */ FILE_ERRORED: 16,
                /**
     * File has finished processing.
     * 
     * @name Phaser.Loader.FILE_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ FILE_COMPLETE: 17,
                /**
     * File has been destroyed
     * 
     * @name Phaser.Loader.FILE_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ FILE_DESTROYED: 18,
                /**
     * File was populated from local data and doesn't need an HTTP request
     * 
     * @name Phaser.Loader.FILE_POPULATED
     * @type {number}
     * @since 3.0.0
     */ FILE_POPULATED: 19
            };
            module1.exports = FILE_CONST;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core.Events
 */ module1.exports = {
                BLUR: __webpack_require__(612),
                BOOT: __webpack_require__(613),
                CONTEXT_LOST: __webpack_require__(614),
                CONTEXT_RESTORED: __webpack_require__(615),
                DESTROY: __webpack_require__(616),
                FOCUS: __webpack_require__(617),
                HIDDEN: __webpack_require__(618),
                PAUSE: __webpack_require__(619),
                POST_RENDER: __webpack_require__(620),
                POST_STEP: __webpack_require__(621),
                PRE_RENDER: __webpack_require__(622),
                PRE_STEP: __webpack_require__(623),
                READY: __webpack_require__(624),
                RESUME: __webpack_require__(625),
                STEP: __webpack_require__(626),
                VISIBLE: __webpack_require__(627)
            };
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var Events = __webpack_require__(95);
            var GetFastValue = __webpack_require__(2);
            var GetURL = __webpack_require__(155);
            var MergeXHRSettings = __webpack_require__(240);
            var XHRLoader = __webpack_require__(517);
            var XHRSettings = __webpack_require__(156);
            /**
 * @classdesc
 * The base File class used by all File Types that the Loader can support.
 * You shouldn't create an instance of a File directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class File
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {Phaser.Types.Loader.FileConfig} fileConfig - The file configuration object, as created by the file type.
 */ var File = new Class({
                initialize: function File(loader, fileConfig) {
                    /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.File#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.loader = loader;
                    /**
         * A reference to the Cache, or Texture Manager, that is going to store this file if it loads.
         *
         * @name Phaser.Loader.File#cache
         * @type {(Phaser.Cache.BaseCache|Phaser.Textures.TextureManager)}
         * @since 3.7.0
         */ this.cache = GetFastValue(fileConfig, "cache", false);
                    /**
         * The file type string (image, json, etc) for sorting within the Loader.
         *
         * @name Phaser.Loader.File#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(fileConfig, "type", false);
                    /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.File#key
         * @type {string}
         * @since 3.0.0
         */ this.key = GetFastValue(fileConfig, "key", false);
                    var loadKey = this.key;
                    if (loader.prefix && loader.prefix !== "") this.key = loader.prefix + loadKey;
                    if (!this.type || !this.key) throw new Error("Invalid Loader." + this.type + " key");
                    var url = GetFastValue(fileConfig, "url");
                    if (url === undefined) url = loader.path + loadKey + "." + GetFastValue(fileConfig, "extension", "");
                    else if (typeof url === "string" && !url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)) url = loader.path + url;
                    /**
         * The URL of the file, not including baseURL.
         *
         * Automatically has Loader.path prepended to it if a string.
         *
         * Can also be a JavaScript Object, such as the results of parsing JSON data.
         *
         * @name Phaser.Loader.File#url
         * @type {object|string}
         * @since 3.0.0
         */ this.url = url;
                    /**
         * The final URL this file will load from, including baseURL and path.
         * Set automatically when the Loader calls 'load' on this file.
         *
         * @name Phaser.Loader.File#src
         * @type {string}
         * @since 3.0.0
         */ this.src = "";
                    /**
         * The merged XHRSettings for this file.
         *
         * @name Phaser.Loader.File#xhrSettings
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhrSettings = XHRSettings(GetFastValue(fileConfig, "responseType", undefined));
                    if (GetFastValue(fileConfig, "xhrSettings", false)) this.xhrSettings = MergeXHRSettings(this.xhrSettings, GetFastValue(fileConfig, "xhrSettings", {}));
                    /**
         * The XMLHttpRequest instance (as created by XHR Loader) that is loading this File.
         *
         * @name Phaser.Loader.File#xhrLoader
         * @type {?XMLHttpRequest}
         * @since 3.0.0
         */ this.xhrLoader = null;
                    /**
         * The current state of the file. One of the FILE_CONST values.
         *
         * @name Phaser.Loader.File#state
         * @type {number}
         * @since 3.0.0
         */ this.state = typeof this.url === "function" ? CONST.FILE_POPULATED : CONST.FILE_PENDING;
                    /**
         * The total size of this file.
         * Set by onProgress and only if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bytesTotal = 0;
                    /**
         * Updated as the file loads.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesLoaded
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.bytesLoaded = -1;
                    /**
         * A percentage value between 0 and 1 indicating how much of this file has loaded.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#percentComplete
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.percentComplete = -1;
                    /**
         * For CORs based loading.
         * If this is undefined then the File will check BaseLoader.crossOrigin and use that (if set)
         *
         * @name Phaser.Loader.File#crossOrigin
         * @type {(string|undefined)}
         * @since 3.0.0
         */ this.crossOrigin = undefined;
                    /**
         * The processed file data, stored here after the file has loaded.
         *
         * @name Phaser.Loader.File#data
         * @type {*}
         * @since 3.0.0
         */ this.data = undefined;
                    /**
         * A config object that can be used by file types to store transitional data.
         *
         * @name Phaser.Loader.File#config
         * @type {*}
         * @since 3.0.0
         */ this.config = GetFastValue(fileConfig, "config", {});
                    /**
         * If this is a multipart file, i.e. an atlas and its json together, then this is a reference
         * to the parent MultiFile. Set and used internally by the Loader or specific file types.
         *
         * @name Phaser.Loader.File#multiFile
         * @type {?Phaser.Loader.MultiFile}
         * @since 3.7.0
         */ this.multiFile;
                    /**
         * Does this file have an associated linked file? Such as an image and a normal map.
         * Atlases and Bitmap Fonts use the multiFile, because those files need loading together but aren't
         * actually bound by data, where-as a linkFile is.
         *
         * @name Phaser.Loader.File#linkFile
         * @type {?Phaser.Loader.File}
         * @since 3.7.0
         */ this.linkFile;
                },
                /**
     * Links this File with another, so they depend upon each other for loading and processing.
     *
     * @method Phaser.Loader.File#setLink
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} fileB - The file to link to this one.
     */ setLink: function(fileB) {
                    this.linkFile = fileB;
                    fileB.linkFile = this;
                },
                /**
     * Resets the XHRLoader instance this file is using.
     *
     * @method Phaser.Loader.File#resetXHR
     * @since 3.0.0
     */ resetXHR: function() {
                    if (this.xhrLoader) {
                        this.xhrLoader.onload = undefined;
                        this.xhrLoader.onerror = undefined;
                        this.xhrLoader.onprogress = undefined;
                    }
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.File#load
     * @since 3.0.0
     */ load: function() {
                    if (this.state === CONST.FILE_POPULATED) //  Can happen for example in a JSONFile if they've provided a JSON object instead of a URL
                    this.loader.nextFile(this, true);
                    else {
                        this.state = CONST.FILE_LOADING;
                        this.src = GetURL(this, this.loader.baseURL);
                        if (this.src.indexOf("data:") === 0) console.warn("Local data URIs are not supported: " + this.key);
                        else //  The creation of this XHRLoader starts the load process going.
                        //  It will automatically call the following, based on the load outcome:
                        //
                        // xhr.onload = this.onLoad
                        // xhr.onerror = this.onError
                        // xhr.onprogress = this.onProgress
                        this.xhrLoader = XHRLoader(this, this.loader.xhr);
                    }
                },
                /**
     * Called when the file finishes loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onLoad
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onLoad: function(xhr, event) {
                    // On iOS, Capacitor often runs on a capacitor:// protocol, meaning local files are served from capacitor:// rather than file://
                    // See: https://github.com/photonstorm/phaser/issues/5685
                    var isLocalFile = xhr.responseURL && (xhr.responseURL.indexOf("file://") === 0 || xhr.responseURL.indexOf("capacitor://") === 0);
                    var localFileOk = isLocalFile && event.target.status === 0;
                    var success = !(event.target && event.target.status !== 200) || localFileOk;
                    //  Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
                    if (xhr.readyState === 4 && xhr.status >= 400 && xhr.status <= 599) success = false;
                    this.state = CONST.FILE_LOADED;
                    this.resetXHR();
                    this.loader.nextFile(this, success);
                },
                /**
     * Called if the file errors while loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onError
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this error.
     */ onError: function() {
                    this.resetXHR();
                    this.loader.nextFile(this, false);
                },
                /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent.
     */ onProgress: function(event) {
                    if (event.lengthComputable) {
                        this.bytesLoaded = event.loaded;
                        this.bytesTotal = event.total;
                        this.percentComplete = Math.min(this.bytesLoaded / this.bytesTotal, 1);
                        this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                    }
                },
                /**
     * Usually overridden by the FileTypes and is called by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data, for example a JSON file will parse itself during this stage.
     *
     * @method Phaser.Loader.File#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.onProcessComplete();
                },
                /**
     * Called when the File has completed processing.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessComplete
     * @since 3.7.0
     */ onProcessComplete: function() {
                    this.state = CONST.FILE_COMPLETE;
                    if (this.multiFile) this.multiFile.onFileComplete(this);
                    this.loader.fileProcessComplete(this);
                },
                /**
     * Called when the File has completed processing but it generated an error.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessError
     * @since 3.7.0
     */ onProcessError: function() {
                    this.state = CONST.FILE_ERRORED;
                    if (this.multiFile) this.multiFile.onFileFailed(this);
                    this.loader.fileProcessComplete(this);
                },
                /**
     * Checks if a key matching the one used by this file exists in the target Cache or not.
     * This is called automatically by the LoaderPlugin to decide if the file can be safely
     * loaded or will conflict.
     *
     * @method Phaser.Loader.File#hasCacheConflict
     * @since 3.7.0
     *
     * @return {boolean} `true` if adding this file will cause a conflict, otherwise `false`.
     */ hasCacheConflict: function() {
                    return this.cache && this.cache.exists(this.key);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     * This method is often overridden by specific file types.
     *
     * @method Phaser.Loader.File#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.cache) this.cache.add(this.key, this.data);
                    this.pendingDestroy();
                },
                /**
     * Called once the file has been added to its cache and is now ready for deletion from the Loader.
     * It will emit a `filecomplete` event from the LoaderPlugin.
     *
     * @method Phaser.Loader.File#pendingDestroy
     * @fires Phaser.Loader.Events#FILE_COMPLETE
     * @fires Phaser.Loader.Events#FILE_KEY_COMPLETE
     * @since 3.7.0
     */ pendingDestroy: function(data) {
                    if (data === undefined) data = this.data;
                    var key = this.key;
                    var type = this.type;
                    this.loader.emit(Events.FILE_COMPLETE, key, type, data);
                    this.loader.emit(Events.FILE_KEY_COMPLETE + type + "-" + key, key, type, data);
                    this.loader.flagForRemoval(this);
                },
                /**
     * Destroy this File and any references it holds.
     *
     * @method Phaser.Loader.File#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.loader = null;
                    this.cache = null;
                    this.xhrSettings = null;
                    this.multiFile = null;
                    this.linkFile = null;
                    this.data = null;
                }
            });
            /**
 * Static method for creating object URL using URL API and setting it as image 'src' attribute.
 * If URL API is not supported (usually on old browsers) it falls back to creating Base64 encoded url using FileReader.
 *
 * @method Phaser.Loader.File.createObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be set to object URL.
 * @param {Blob} blob - A Blob object to create an object URL for.
 * @param {string} defaultType - Default mime type used if blob type is not available.
 */ File.createObjectURL = function(image, blob, defaultType) {
                if (typeof URL === "function") image.src = URL.createObjectURL(blob);
                else {
                    var reader = new FileReader();
                    reader.onload = function() {
                        image.removeAttribute("crossOrigin");
                        image.src = "data:" + (blob.type || defaultType) + ";base64," + reader.result.split(",")[1];
                    };
                    reader.onerror = image.onerror;
                    reader.readAsDataURL(blob);
                }
            };
            /**
 * Static method for releasing an existing object URL which was previously created
 * by calling {@link File#createObjectURL} method.
 *
 * @method Phaser.Loader.File.revokeObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be revoked.
 */ File.revokeObjectURL = function(image) {
                if (typeof URL === "function") URL.revokeObjectURL(image.src);
            };
            module1.exports = File;
        /***/ },
        /* 24 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Contains the plugins that Phaser uses globally and locally.
            //  These are the source objects, not instantiated.
            var corePlugins = {};
            //  Contains the plugins that the dev has loaded into their game
            //  These are the source objects, not instantiated.
            var customPlugins = {};
            var PluginCache = {};
            /**
 * @namespace Phaser.Plugins.PluginCache
 */ /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @method Phaser.Plugins.PluginCache.register
 * @since 3.8.0
 * 
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {boolean} [custom=false] - Core Scene plugin or a Custom Scene plugin?
 */ PluginCache.register = function(key, plugin, mapping, custom) {
                if (custom === undefined) custom = false;
                corePlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    custom: custom
                };
            };
            /**
 * Stores a custom plugin in the global plugin cache.
 * The key must be unique, within the scope of the cache.
 *
 * @method Phaser.Plugins.PluginCache.registerCustom
 * @since 3.8.0
 * 
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {?any} data - A value to be passed to the plugin's `init` method.
 */ PluginCache.registerCustom = function(key, plugin, mapping, data) {
                customPlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    data: data
                };
            };
            /**
 * Checks if the given key is already being used in the core plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCore
 * @since 3.8.0
 * 
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the core cache, otherwise `false`.
 */ PluginCache.hasCore = function(key) {
                return corePlugins.hasOwnProperty(key);
            };
            /**
 * Checks if the given key is already being used in the custom plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the custom cache, otherwise `false`.
 */ PluginCache.hasCustom = function(key) {
                return customPlugins.hasOwnProperty(key);
            };
            /**
 * Returns the core plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCore
 * @since 3.8.0
 * 
 * @param {string} key - The key of the core plugin to get.
 *
 * @return {Phaser.Types.Plugins.CorePluginContainer} The core plugin object.
 */ PluginCache.getCore = function(key) {
                return corePlugins[key];
            };
            /**
 * Returns the custom plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {Phaser.Types.Plugins.CustomPluginContainer} The custom plugin object.
 */ PluginCache.getCustom = function(key) {
                return customPlugins[key];
            };
            /**
 * Returns an object from the custom cache based on the given key that can be instantiated.
 *
 * @method Phaser.Plugins.PluginCache.getCustomClass
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {function} The custom plugin object.
 */ PluginCache.getCustomClass = function(key) {
                return customPlugins.hasOwnProperty(key) ? customPlugins[key].plugin : null;
            };
            /**
 * Removes a core plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.remove
 * @since 3.8.0
 * 
 * @param {string} key - The key of the core plugin to remove.
 */ PluginCache.remove = function(key) {
                if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
            };
            /**
 * Removes a custom plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.removeCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to remove.
 */ PluginCache.removeCustom = function(key) {
                if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
            };
            /**
 * Removes all Core Plugins.
 * 
 * This includes all of the internal system plugins that Phaser needs, like the Input Plugin and Loader Plugin.
 * So be sure you only call this if you do not wish to run Phaser again.
 *
 * @method Phaser.Plugins.PluginCache.destroyCorePlugins
 * @since 3.12.0
 */ PluginCache.destroyCorePlugins = function() {
                for(var key in corePlugins)if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
            };
            /**
 * Removes all Custom Plugins.
 *
 * @method Phaser.Plugins.PluginCache.destroyCustomPlugins
 * @since 3.12.0
 */ PluginCache.destroyCustomPlugins = function() {
                for(var key in customPlugins)if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
            };
            module1.exports = PluginCache;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var MATH_CONST = __webpack_require__(14);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matrix used for display transformations for rendering.
 *
 * It is represented like so:
 *
 * ```
 * | a | c | tx |
 * | b | d | ty |
 * | 0 | 0 | 1  |
 * ```
 *
 * @class TransformMatrix
 * @memberof Phaser.GameObjects.Components
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [a=1] - The Scale X value.
 * @param {number} [b=0] - The Skew Y value.
 * @param {number} [c=0] - The Skew X value.
 * @param {number} [d=1] - The Scale Y value.
 * @param {number} [tx=0] - The Translate X value.
 * @param {number} [ty=0] - The Translate Y value.
 */ var TransformMatrix = new Class({
                initialize: function TransformMatrix(a, b, c, d, tx, ty) {
                    if (a === undefined) a = 1;
                    if (b === undefined) b = 0;
                    if (c === undefined) c = 0;
                    if (d === undefined) d = 1;
                    if (tx === undefined) tx = 0;
                    if (ty === undefined) ty = 0;
                    /**
         * The matrix values.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#matrix
         * @type {Float32Array}
         * @since 3.0.0
         */ this.matrix = new Float32Array([
                        a,
                        b,
                        c,
                        d,
                        tx,
                        ty,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The decomposed matrix.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#decomposedMatrix
         * @type {object}
         * @since 3.0.0
         */ this.decomposedMatrix = {
                        translateX: 0,
                        translateY: 0,
                        scaleX: 1,
                        scaleY: 1,
                        rotation: 0
                    };
                },
                /**
     * The Scale X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#a
     * @type {number}
     * @since 3.4.0
     */ a: {
                    get: function() {
                        return this.matrix[0];
                    },
                    set: function(value) {
                        this.matrix[0] = value;
                    }
                },
                /**
     * The Skew Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#b
     * @type {number}
     * @since 3.4.0
     */ b: {
                    get: function() {
                        return this.matrix[1];
                    },
                    set: function(value) {
                        this.matrix[1] = value;
                    }
                },
                /**
     * The Skew X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#c
     * @type {number}
     * @since 3.4.0
     */ c: {
                    get: function() {
                        return this.matrix[2];
                    },
                    set: function(value) {
                        this.matrix[2] = value;
                    }
                },
                /**
     * The Scale Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#d
     * @type {number}
     * @since 3.4.0
     */ d: {
                    get: function() {
                        return this.matrix[3];
                    },
                    set: function(value) {
                        this.matrix[3] = value;
                    }
                },
                /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#e
     * @type {number}
     * @since 3.11.0
     */ e: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(value) {
                        this.matrix[4] = value;
                    }
                },
                /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#f
     * @type {number}
     * @since 3.11.0
     */ f: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(value) {
                        this.matrix[5] = value;
                    }
                },
                /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#tx
     * @type {number}
     * @since 3.4.0
     */ tx: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(value) {
                        this.matrix[4] = value;
                    }
                },
                /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#ty
     * @type {number}
     * @since 3.4.0
     */ ty: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(value) {
                        this.matrix[5] = value;
                    }
                },
                /**
     * The rotation of the Matrix. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotation
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ rotation: {
                    get: function() {
                        return Math.acos(this.a / this.scaleX) * (Math.atan(-this.c / this.a) < 0 ? -1 : 1);
                    }
                },
                /**
     * The rotation of the Matrix, normalized to be within the Phaser right-handed
     * clockwise rotation space. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotationNormalized
     * @type {number}
     * @readonly
     * @since 3.19.0
     */ rotationNormalized: {
                    get: function() {
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        if (a || b) // var r = Math.sqrt(a * a + b * b);
                        return b > 0 ? Math.acos(a / this.scaleX) : -Math.acos(a / this.scaleX);
                        else if (c || d) // var s = Math.sqrt(c * c + d * d);
                        return MATH_CONST.TAU - (d > 0 ? Math.acos(-c / this.scaleY) : -Math.acos(c / this.scaleY));
                        else return 0;
                    }
                },
                /**
     * The decomposed horizontal scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleX
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleX: {
                    get: function() {
                        return Math.sqrt(this.a * this.a + this.b * this.b);
                    }
                },
                /**
     * The decomposed vertical scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleY
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleY: {
                    get: function() {
                        return Math.sqrt(this.c * this.c + this.d * this.d);
                    }
                },
                /**
     * Reset the Matrix to an identity matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#loadIdentity
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ loadIdentity: function() {
                    var matrix = this.matrix;
                    matrix[0] = 1;
                    matrix[1] = 0;
                    matrix[2] = 0;
                    matrix[3] = 1;
                    matrix[4] = 0;
                    matrix[5] = 0;
                    return this;
                },
                /**
     * Translate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#translate
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation value.
     * @param {number} y - The vertical translation value.
     *
     * @return {this} This TransformMatrix.
     */ translate: function(x, y) {
                    var matrix = this.matrix;
                    matrix[4] = matrix[0] * x + matrix[2] * y + matrix[4];
                    matrix[5] = matrix[1] * x + matrix[3] * y + matrix[5];
                    return this;
                },
                /**
     * Scale the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#scale
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale value.
     * @param {number} y - The vertical scale value.
     *
     * @return {this} This TransformMatrix.
     */ scale: function(x, y) {
                    var matrix = this.matrix;
                    matrix[0] *= x;
                    matrix[1] *= x;
                    matrix[2] *= y;
                    matrix[3] *= y;
                    return this;
                },
                /**
     * Rotate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#rotate
     * @since 3.0.0
     *
     * @param {number} angle - The angle of rotation in radians.
     *
     * @return {this} This TransformMatrix.
     */ rotate: function(angle) {
                    var sin = Math.sin(angle);
                    var cos = Math.cos(angle);
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    matrix[0] = a * cos + c * sin;
                    matrix[1] = b * cos + d * sin;
                    matrix[2] = a * -sin + c * cos;
                    matrix[3] = b * -sin + d * cos;
                    return this;
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * If an `out` Matrix is given then the results will be stored in it.
     * If it is not given, this matrix will be updated in place instead.
     * Use an `out` Matrix if you do not wish to mutate this matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiply
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} rhs - The Matrix to multiply by.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [out] - An optional Matrix to store the results in.
     *
     * @return {(this|Phaser.GameObjects.Components.TransformMatrix)} Either this TransformMatrix, or the `out` Matrix, if given in the arguments.
     */ multiply: function(rhs, out) {
                    var matrix = this.matrix;
                    var source = rhs.matrix;
                    var localA = matrix[0];
                    var localB = matrix[1];
                    var localC = matrix[2];
                    var localD = matrix[3];
                    var localE = matrix[4];
                    var localF = matrix[5];
                    var sourceA = source[0];
                    var sourceB = source[1];
                    var sourceC = source[2];
                    var sourceD = source[3];
                    var sourceE = source[4];
                    var sourceF = source[5];
                    var destinationMatrix = out === undefined ? this : out;
                    destinationMatrix.a = sourceA * localA + sourceB * localC;
                    destinationMatrix.b = sourceA * localB + sourceB * localD;
                    destinationMatrix.c = sourceC * localA + sourceD * localC;
                    destinationMatrix.d = sourceC * localB + sourceD * localD;
                    destinationMatrix.e = sourceE * localA + sourceF * localC + localE;
                    destinationMatrix.f = sourceE * localB + sourceF * localD + localF;
                    return destinationMatrix;
                },
                /**
     * Multiply this Matrix by the matrix given, including the offset.
     *
     * The offsetX is added to the tx value: `offsetX * a + offsetY * c + tx`.
     * The offsetY is added to the ty value: `offsetY * b + offsetY * d + ty`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiplyWithOffset
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     * @param {number} offsetX - Horizontal offset to factor in to the multiplication.
     * @param {number} offsetY - Vertical offset to factor in to the multiplication.
     *
     * @return {this} This TransformMatrix.
     */ multiplyWithOffset: function(src, offsetX, offsetY) {
                    var matrix = this.matrix;
                    var otherMatrix = src.matrix;
                    var a0 = matrix[0];
                    var b0 = matrix[1];
                    var c0 = matrix[2];
                    var d0 = matrix[3];
                    var tx0 = matrix[4];
                    var ty0 = matrix[5];
                    var pse = offsetX * a0 + offsetY * c0 + tx0;
                    var psf = offsetX * b0 + offsetY * d0 + ty0;
                    var a1 = otherMatrix[0];
                    var b1 = otherMatrix[1];
                    var c1 = otherMatrix[2];
                    var d1 = otherMatrix[3];
                    var tx1 = otherMatrix[4];
                    var ty1 = otherMatrix[5];
                    matrix[0] = a1 * a0 + b1 * c0;
                    matrix[1] = a1 * b0 + b1 * d0;
                    matrix[2] = c1 * a0 + d1 * c0;
                    matrix[3] = c1 * b0 + d1 * d0;
                    matrix[4] = tx1 * a0 + ty1 * c0 + pse;
                    matrix[5] = tx1 * b0 + ty1 * d0 + psf;
                    return this;
                },
                /**
     * Transform the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ transform: function(a, b, c, d, tx, ty) {
                    var matrix = this.matrix;
                    var a0 = matrix[0];
                    var b0 = matrix[1];
                    var c0 = matrix[2];
                    var d0 = matrix[3];
                    var tx0 = matrix[4];
                    var ty0 = matrix[5];
                    matrix[0] = a * a0 + b * c0;
                    matrix[1] = a * b0 + b * d0;
                    matrix[2] = c * a0 + d * c0;
                    matrix[3] = c * b0 + d * d0;
                    matrix[4] = tx * a0 + ty * c0 + tx0;
                    matrix[5] = tx * b0 + ty * d0 + ty0;
                    return this;
                },
                /**
     * Transform a point using this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transformPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to transform.
     * @param {number} y - The y coordinate of the point to transform.
     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - The Point object to store the transformed coordinates.
     *
     * @return {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} The Point containing the transformed coordinates.
     */ transformPoint: function(x, y, point) {
                    if (point === undefined) point = {
                        x: 0,
                        y: 0
                    };
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    point.x = x * a + y * c + tx;
                    point.y = x * b + y * d + ty;
                    return point;
                },
                /**
     * Invert the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#invert
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ invert: function() {
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    var n = a * d - b * c;
                    matrix[0] = d / n;
                    matrix[1] = -b / n;
                    matrix[2] = -c / n;
                    matrix[3] = a / n;
                    matrix[4] = (c * ty - d * tx) / n;
                    matrix[5] = -(a * ty - b * tx) / n;
                    return this;
                },
                /**
     * Set the values of this Matrix to copy those of the matrix given.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFrom
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     *
     * @return {this} This TransformMatrix.
     */ copyFrom: function(src) {
                    var matrix = this.matrix;
                    matrix[0] = src.a;
                    matrix[1] = src.b;
                    matrix[2] = src.c;
                    matrix[3] = src.d;
                    matrix[4] = src.e;
                    matrix[5] = src.f;
                    return this;
                },
                /**
     * Set the values of this Matrix to copy those of the array given.
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFromArray
     * @since 3.11.0
     *
     * @param {array} src - The array of values to set into this matrix.
     *
     * @return {this} This TransformMatrix.
     */ copyFromArray: function(src) {
                    var matrix = this.matrix;
                    matrix[0] = src[0];
                    matrix[1] = src[1];
                    matrix[2] = src[2];
                    matrix[3] = src[3];
                    matrix[4] = src[4];
                    matrix[5] = src[5];
                    return this;
                },
                /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.transform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ copyToContext: function(ctx) {
                    var matrix = this.matrix;
                    ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                    return ctx;
                },
                /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.setTransform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ setToContext: function(ctx) {
                    var matrix = this.matrix;
                    ctx.setTransform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                    return ctx;
                },
                /**
     * Copy the values in this Matrix to the array given.
     *
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToArray
     * @since 3.12.0
     *
     * @param {array} [out] - The array to copy the matrix values in to.
     *
     * @return {array} An array where elements 0 to 5 contain the values from this matrix.
     */ copyToArray: function(out) {
                    var matrix = this.matrix;
                    if (out === undefined) out = [
                        matrix[0],
                        matrix[1],
                        matrix[2],
                        matrix[3],
                        matrix[4],
                        matrix[5]
                    ];
                    else {
                        out[0] = matrix[0];
                        out[1] = matrix[1];
                        out[2] = matrix[2];
                        out[3] = matrix[3];
                        out[4] = matrix[4];
                        out[5] = matrix[5];
                    }
                    return out;
                },
                /**
     * Set the values of this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setTransform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ setTransform: function(a, b, c, d, tx, ty) {
                    var matrix = this.matrix;
                    matrix[0] = a;
                    matrix[1] = b;
                    matrix[2] = c;
                    matrix[3] = d;
                    matrix[4] = tx;
                    matrix[5] = ty;
                    return this;
                },
                /**
     * Decompose this Matrix into its translation, scale and rotation values using QR decomposition.
     *
     * The result must be applied in the following order to reproduce the current matrix:
     *
     * translate -> rotate -> scale
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#decomposeMatrix
     * @since 3.0.0
     *
     * @return {object} The decomposed Matrix.
     */ decomposeMatrix: function() {
                    var decomposedMatrix = this.decomposedMatrix;
                    var matrix = this.matrix;
                    //  a = scale X (1)
                    //  b = shear Y (0)
                    //  c = shear X (0)
                    //  d = scale Y (1)
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var determ = a * d - b * c;
                    decomposedMatrix.translateX = matrix[4];
                    decomposedMatrix.translateY = matrix[5];
                    if (a || b) {
                        var r = Math.sqrt(a * a + b * b);
                        decomposedMatrix.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
                        decomposedMatrix.scaleX = r;
                        decomposedMatrix.scaleY = determ / r;
                    } else if (c || d) {
                        var s = Math.sqrt(c * c + d * d);
                        decomposedMatrix.rotation = Math.PI * 0.5 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
                        decomposedMatrix.scaleX = determ / s;
                        decomposedMatrix.scaleY = s;
                    } else {
                        decomposedMatrix.rotation = 0;
                        decomposedMatrix.scaleX = 0;
                        decomposedMatrix.scaleY = 0;
                    }
                    return decomposedMatrix;
                },
                /**
     * Apply the identity, translate, rotate and scale operations on the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyITRS
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation.
     * @param {number} y - The vertical translation.
     * @param {number} rotation - The angle of rotation in radians.
     * @param {number} scaleX - The horizontal scale.
     * @param {number} scaleY - The vertical scale.
     *
     * @return {this} This TransformMatrix.
     */ applyITRS: function(x, y, rotation, scaleX, scaleY) {
                    var matrix = this.matrix;
                    var radianSin = Math.sin(rotation);
                    var radianCos = Math.cos(rotation);
                    // Translate
                    matrix[4] = x;
                    matrix[5] = y;
                    // Rotate and Scale
                    matrix[0] = radianCos * scaleX;
                    matrix[1] = radianSin * scaleX;
                    matrix[2] = -radianSin * scaleY;
                    matrix[3] = radianCos * scaleY;
                    return this;
                },
                /**
     * Takes the `x` and `y` values and returns a new position in the `output` vector that is the inverse of
     * the current matrix with its transformation applied.
     *
     * Can be used to translate points from world to local space.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyInverse
     * @since 3.12.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [output] - A Vector2, or point-like object, to store the results in.
     *
     * @return {Phaser.Math.Vector2} The coordinates, inverse-transformed through this matrix.
     */ applyInverse: function(x, y, output) {
                    if (output === undefined) output = new Vector2();
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    var id = 1 / (a * d + c * -b);
                    output.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
                    output.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
                    return output;
                },
                /**
     * Returns the X component of this matrix multiplied by the given values.
     * This is the same as `x * a + y * c + e`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getX
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated x value.
     */ getX: function(x, y) {
                    return x * this.a + y * this.c + this.e;
                },
                /**
     * Returns the Y component of this matrix multiplied by the given values.
     * This is the same as `x * b + y * d + f`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getY
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated y value.
     */ getY: function(x, y) {
                    return x * this.b + y * this.d + this.f;
                },
                /**
     * Returns the X component of this matrix multiplied by the given values.
     *
     * This is the same as `x * a + y * c + e`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getXRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated x value.
     */ getXRound: function(x, y, round) {
                    var v = this.getX(x, y);
                    if (round) v = Math.round(v);
                    return v;
                },
                /**
     * Returns the Y component of this matrix multiplied by the given values.
     *
     * This is the same as `x * b + y * d + f`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getYRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated y value.
     */ getYRound: function(x, y, round) {
                    var v = this.getY(x, y);
                    if (round) v = Math.round(v);
                    return v;
                },
                /**
     * Returns a string that can be used in a CSS Transform call as a `matrix` property.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getCSSMatrix
     * @since 3.12.0
     *
     * @return {string} A string containing the CSS Transform matrix values.
     */ getCSSMatrix: function() {
                    var m = this.matrix;
                    return "matrix(" + m[0] + "," + m[1] + "," + m[2] + "," + m[3] + "," + m[4] + "," + m[5] + ")";
                },
                /**
     * Destroys this Transform Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#destroy
     * @since 3.4.0
     */ destroy: function() {
                    this.matrix = null;
                    this.decomposedMatrix = null;
                }
            });
            module1.exports = TransformMatrix;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithin = function(tileX, tileY, width, height, filteringOptions, layer) {
                if (tileX === undefined) tileX = 0;
                if (tileY === undefined) tileY = 0;
                if (width === undefined) width = layer.width;
                if (height === undefined) height = layer.height;
                if (!filteringOptions) filteringOptions = {};
                var isNotEmpty = GetFastValue(filteringOptions, "isNotEmpty", false);
                var isColliding = GetFastValue(filteringOptions, "isColliding", false);
                var hasInterestingFace = GetFastValue(filteringOptions, "hasInterestingFace", false);
                // Clip x, y to top left of map, while shrinking width/height to match.
                if (tileX < 0) {
                    width += tileX;
                    tileX = 0;
                }
                if (tileY < 0) {
                    height += tileY;
                    tileY = 0;
                }
                // Clip width and height to bottom right of map.
                if (tileX + width > layer.width) width = Math.max(layer.width - tileX, 0);
                if (tileY + height > layer.height) height = Math.max(layer.height - tileY, 0);
                var results = [];
                for(var ty = tileY; ty < tileY + height; ty++)for(var tx = tileX; tx < tileX + width; tx++){
                    var tile = layer.data[ty][tx];
                    if (tile !== null) {
                        if (isNotEmpty && tile.index === -1) continue;
                        if (isColliding && !tile.collides) continue;
                        if (hasInterestingFace && !tile.hasInterestingFace) continue;
                        results.push(tile);
                    }
                }
                return results;
            };
            module1.exports = GetTilesWithin;
        /***/ },
        /* 27 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueSet(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueSet
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueSet = function(items, key, value, step, index, direction) {
                if (step === undefined) step = 0;
                if (index === undefined) index = 0;
                if (direction === undefined) direction = 1;
                var i;
                var t = 0;
                var end = items.length;
                if (direction === 1) //  Start to End
                for(i = index; i < end; i++){
                    items[i][key] = value + t * step;
                    t++;
                }
                else //  End to Start
                for(i = index; i >= 0; i--){
                    items[i][key] = value + t * step;
                    t++;
                }
                return items;
            };
            module1.exports = PropertyValueSet;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Builds a Game Object using the provided configuration object.
 *
 * @function Phaser.GameObjects.BuildGameObject
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene.
 * @param {Phaser.GameObjects.GameObject} gameObject - The initial GameObject.
 * @param {Phaser.Types.GameObjects.GameObjectConfig} config - The config to build the GameObject with.
 *
 * @return {Phaser.GameObjects.GameObject} The built Game Object.
 */ var BuildGameObject = function(scene, gameObject, config) {
                //  Position
                gameObject.x = GetAdvancedValue(config, "x", 0);
                gameObject.y = GetAdvancedValue(config, "y", 0);
                gameObject.depth = GetAdvancedValue(config, "depth", 0);
                //  Flip
                gameObject.flipX = GetAdvancedValue(config, "flipX", false);
                gameObject.flipY = GetAdvancedValue(config, "flipY", false);
                //  Scale
                //  Either: { scale: 2 } or { scale: { x: 2, y: 2 }}
                var scale = GetAdvancedValue(config, "scale", null);
                if (typeof scale === "number") gameObject.setScale(scale);
                else if (scale !== null) {
                    gameObject.scaleX = GetAdvancedValue(scale, "x", 1);
                    gameObject.scaleY = GetAdvancedValue(scale, "y", 1);
                }
                //  ScrollFactor
                //  Either: { scrollFactor: 2 } or { scrollFactor: { x: 2, y: 2 }}
                var scrollFactor = GetAdvancedValue(config, "scrollFactor", null);
                if (typeof scrollFactor === "number") gameObject.setScrollFactor(scrollFactor);
                else if (scrollFactor !== null) {
                    gameObject.scrollFactorX = GetAdvancedValue(scrollFactor, "x", 1);
                    gameObject.scrollFactorY = GetAdvancedValue(scrollFactor, "y", 1);
                }
                //  Rotation
                gameObject.rotation = GetAdvancedValue(config, "rotation", 0);
                var angle = GetAdvancedValue(config, "angle", null);
                if (angle !== null) gameObject.angle = angle;
                //  Alpha
                gameObject.alpha = GetAdvancedValue(config, "alpha", 1);
                //  Origin
                //  Either: { origin: 0.5 } or { origin: { x: 0.5, y: 0.5 }}
                var origin = GetAdvancedValue(config, "origin", null);
                if (typeof origin === "number") gameObject.setOrigin(origin);
                else if (origin !== null) {
                    var ox = GetAdvancedValue(origin, "x", 0.5);
                    var oy = GetAdvancedValue(origin, "y", 0.5);
                    gameObject.setOrigin(ox, oy);
                }
                //  BlendMode
                gameObject.blendMode = GetAdvancedValue(config, "blendMode", BlendModes.NORMAL);
                //  Visible
                gameObject.visible = GetAdvancedValue(config, "visible", true);
                //  Add to Scene
                var add = GetAdvancedValue(config, "add", true);
                if (add) scene.sys.displayList.add(gameObject);
                if (gameObject.preUpdate) scene.sys.updateList.add(gameObject);
                return gameObject;
            };
            module1.exports = BuildGameObject;
        /***/ },
        /* 29 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Tilemap constants for orientation.
 * 
 * @namespace Phaser.Tilemaps.Orientation
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ /**
 * Phaser Tilemap constants for orientation.
 * 
 * To find out what each mode does please see [Phaser.Tilemaps.Orientation]{@link Phaser.Tilemaps.Orientation}.
 * 
 * @typedef {Phaser.Tilemaps.Orientation} Phaser.Tilemaps.OrientationType
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ module1.exports = {
                /**
     * Orthogonal Tilemap orientation constant.
     * 
     * @name Phaser.Tilemaps.Orientation.ORTHOGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ ORTHOGONAL: 0,
                /**
     * Isometric Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.ISOMETRIC
     * @type {number}
     * @const
     * @since 3.50.0
     */ ISOMETRIC: 1,
                /**
     * Staggered Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.STAGGERED
     * @type {number}
     * @const
     * @since 3.50.0
     */ STAGGERED: 2,
                /**
     * Hexagonal Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.HEXAGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ HEXAGONAL: 3
            };
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Takes a reference to the Canvas Renderer, a Canvas Rendering Context, a Game Object, a Camera and a parent matrix
 * and then performs the following steps:
 *
 * 1. Checks the alpha of the source combined with the Camera alpha. If 0 or less it aborts.
 * 2. Takes the Camera and Game Object matrix and multiplies them, combined with the parent matrix if given.
 * 3. Sets the blend mode of the context to be that used by the Game Object.
 * 4. Sets the alpha value of the context to be that used by the Game Object combined with the Camera.
 * 5. Saves the context state.
 * 6. Sets the final matrix values into the context via setTransform.
 * 7. If Renderer.antialias, or the frame.source.scaleMode is set, then imageSmoothingEnabled is set.
 *
 * This function is only meant to be used internally. Most of the Canvas Renderer classes use it.
 *
 * @function Phaser.Renderer.Canvas.SetTransform
 * @since 3.12.0
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {CanvasRenderingContext2D} ctx - The canvas context to set the transform on.
 * @param {Phaser.GameObjects.GameObject} src - The Game Object being rendered. Can be any type that extends the base class.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A parent transform matrix to apply to the Game Object before rendering.
 *
 * @return {boolean} `true` if the Game Object context was set, otherwise `false`.
 */ var SetTransform = function(renderer, ctx, src, camera, parentMatrix) {
                var alpha = camera.alpha * src.alpha;
                if (alpha <= 0) //  Nothing to see, so don't waste time calculating stuff
                return false;
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                //  Blend Mode
                ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                //  Alpha
                ctx.globalAlpha = alpha;
                ctx.save();
                calcMatrix.setToContext(ctx);
                ctx.imageSmoothingEnabled = !(!renderer.antialias || src.frame && src.frame.source.scaleMode);
                return true;
            };
            module1.exports = SetTransform;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(33);
            var Smoothing = __webpack_require__(192);
            // The pool into which the canvas elements are placed.
            var pool = [];
            //  Automatically apply smoothing(false) to created Canvas elements
            var _disableContextSmoothing = false;
            /**
 * The CanvasPool is a global static object, that allows Phaser to recycle and pool 2D Context Canvas DOM elements.
 * It does not pool WebGL Contexts, because once the context options are set they cannot be modified again, 
 * which is useless for some of the Phaser pipelines / renderer.
 *
 * This singleton is instantiated as soon as Phaser loads, before a Phaser.Game instance has even been created.
 * Which means all instances of Phaser Games on the same page can share the one single pool.
 *
 * @namespace Phaser.Display.Canvas.CanvasPool
 * @since 3.0.0
 */ var CanvasPool = function() {
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     * @param {boolean} [selfParent=false] - Use the generated Canvas element as the parent?
     *
     * @return {HTMLCanvasElement} The canvas element that was created or pulled from the pool
     */ var create = function(parent, width, height, canvasType, selfParent) {
                    if (width === undefined) width = 1;
                    if (height === undefined) height = 1;
                    if (canvasType === undefined) canvasType = CONST.CANVAS;
                    if (selfParent === undefined) selfParent = false;
                    var canvas;
                    var container = first(canvasType);
                    if (container === null) {
                        container = {
                            parent: parent,
                            canvas: document.createElement("canvas"),
                            type: canvasType
                        };
                        if (canvasType === CONST.CANVAS) pool.push(container);
                        canvas = container.canvas;
                    } else {
                        container.parent = parent;
                        canvas = container.canvas;
                    }
                    if (selfParent) container.parent = canvas;
                    canvas.width = width;
                    canvas.height = height;
                    if (_disableContextSmoothing && canvasType === CONST.CANVAS) Smoothing.disable(canvas.getContext("2d"));
                    return canvas;
                };
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create2D
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created canvas.
     */ var create2D = function(parent, width, height) {
                    return create(parent, width, height, CONST.CANVAS);
                };
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.createWebGL
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created WebGL canvas.
     */ var createWebGL = function(parent, width, height) {
                    return create(parent, width, height, CONST.WEBGL);
                };
                /**
     * Gets the first free canvas index from the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.first
     * @since 3.0.0
     *
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     *
     * @return {HTMLCanvasElement} The first free canvas, or `null` if a WebGL canvas was requested or if the pool doesn't have free canvases.
     */ var first = function(canvasType) {
                    if (canvasType === undefined) canvasType = CONST.CANVAS;
                    if (canvasType === CONST.WEBGL) return null;
                    for(var i = 0; i < pool.length; i++){
                        var container = pool[i];
                        if (!container.parent && container.type === canvasType) return container;
                    }
                    return null;
                };
                /**
     * Looks up a canvas based on its parent, and if found puts it back in the pool, freeing it up for re-use.
     * The canvas has its width and height set to 1, and its parent attribute nulled.
     *
     * @function Phaser.Display.Canvas.CanvasPool.remove
     * @since 3.0.0
     *
     * @param {*} parent - The canvas or the parent of the canvas to free.
     */ var remove = function(parent) {
                    //  Check to see if the parent is a canvas object
                    var isCanvas = parent instanceof HTMLCanvasElement;
                    pool.forEach(function(container) {
                        if (isCanvas && container.canvas === parent || !isCanvas && container.parent === parent) {
                            container.parent = null;
                            container.canvas.width = 1;
                            container.canvas.height = 1;
                        }
                    });
                };
                /**
     * Gets the total number of used canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.total
     * @since 3.0.0
     *
     * @return {number} The number of used canvases.
     */ var total = function() {
                    var c = 0;
                    pool.forEach(function(container) {
                        if (container.parent) c++;
                    });
                    return c;
                };
                /**
     * Gets the total number of free canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.free
     * @since 3.0.0
     *
     * @return {number} The number of free canvases.
     */ var free = function() {
                    return pool.length - total();
                };
                /**
     * Disable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.disableSmoothing
     * @since 3.0.0
     */ var disableSmoothing = function() {
                    _disableContextSmoothing = true;
                };
                /**
     * Enable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.enableSmoothing
     * @since 3.0.0
     */ var enableSmoothing = function() {
                    _disableContextSmoothing = false;
                };
                return {
                    create2D: create2D,
                    create: create,
                    createWebGL: createWebGL,
                    disableSmoothing: disableSmoothing,
                    enableSmoothing: enableSmoothing,
                    first: first,
                    free: free,
                    pool: pool,
                    remove: remove,
                    total: total
                };
            };
            //  If we export the called function here, it'll only be invoked once (not every time it's required).
            module1.exports = CanvasPool();
        /***/ },
        /* 32 */ /***/ function(module1, exports) {
            /**
* The `Matter.Common` module contains utility functions that are common to all modules.
*
* @class Common
*/ var Common = {};
            module1.exports = Common;
            (function() {
                Common._nextId = 0;
                Common._seed = 0;
                Common._nowStartTime = +new Date();
                /**
     * Extends the object in the first argument using the object in the second argument.
     * @method extend
     * @param {} obj
     * @param {boolean} deep
     * @return {} obj extended
     */ Common.extend = function(obj, deep) {
                    var argsStart, args, deepClone;
                    if (typeof deep === "boolean") {
                        argsStart = 2;
                        deepClone = deep;
                    } else {
                        argsStart = 1;
                        deepClone = true;
                    }
                    for(var i = argsStart; i < arguments.length; i++){
                        var source = arguments[i];
                        if (source) {
                            for(var prop in source)if (deepClone && source[prop] && source[prop].constructor === Object) {
                                if (!obj[prop] || obj[prop].constructor === Object) {
                                    obj[prop] = obj[prop] || {};
                                    Common.extend(obj[prop], deepClone, source[prop]);
                                } else obj[prop] = source[prop];
                            } else obj[prop] = source[prop];
                        }
                    }
                    return obj;
                };
                /**
     * Creates a new clone of the object, if deep is true references will also be cloned.
     * @method clone
     * @param {} obj
     * @param {bool} deep
     * @return {} obj cloned
     */ Common.clone = function(obj, deep) {
                    return Common.extend({}, deep, obj);
                };
                /**
     * Returns the list of keys for the given object.
     * @method keys
     * @param {} obj
     * @return {string[]} keys
     */ Common.keys = function(obj) {
                    if (Object.keys) return Object.keys(obj);
                    // avoid hasOwnProperty for performance
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /**
     * Returns the list of values for the given object.
     * @method values
     * @param {} obj
     * @return {array} Array of the objects property values
     */ Common.values = function(obj) {
                    var values = [];
                    if (Object.keys) {
                        var keys = Object.keys(obj);
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    // avoid hasOwnProperty for performance
                    for(var key in obj)values.push(obj[key]);
                    return values;
                };
                /**
     * Gets a value from `base` relative to the `path` string.
     * @method get
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} The object at the given path
     */ Common.get = function(obj, path, begin, end) {
                    path = path.split(".").slice(begin, end);
                    for(var i = 0; i < path.length; i += 1)obj = obj[path[i]];
                    return obj;
                };
                /**
     * Sets a value on `base` relative to the given `path` string.
     * @method set
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {} val The value to set
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} Pass through `val` for chaining
     */ Common.set = function(obj, path, val, begin, end) {
                    var parts = path.split(".").slice(begin, end);
                    Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
                    return val;
                };
                /**
     * Shuffles the given array in-place.
     * The function uses a seeded random generator.
     * @method shuffle
     * @param {array} array
     * @return {array} array shuffled randomly
     */ Common.shuffle = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Common.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                /**
     * Randomly chooses a value from a list with equal probability.
     * The function uses a seeded random generator.
     * @method choose
     * @param {array} choices
     * @return {object} A random choice object from the array
     */ Common.choose = function(choices) {
                    return choices[Math.floor(Common.random() * choices.length)];
                };
                /**
     * Returns true if the object is a HTMLElement, otherwise false.
     * @method isElement
     * @param {object} obj
     * @return {boolean} True if the object is a HTMLElement, otherwise false
     */ Common.isElement = function(obj) {
                    if (typeof HTMLElement !== "undefined") return obj instanceof HTMLElement;
                    return !!(obj && obj.nodeType && obj.nodeName);
                };
                /**
     * Returns true if the object is an array.
     * @method isArray
     * @param {object} obj
     * @return {boolean} True if the object is an array, otherwise false
     */ Common.isArray = function(obj) {
                    return Object.prototype.toString.call(obj) === "[object Array]";
                };
                /**
     * Returns true if the object is a function.
     * @method isFunction
     * @param {object} obj
     * @return {boolean} True if the object is a function, otherwise false
     */ Common.isFunction = function(obj) {
                    return typeof obj === "function";
                };
                /**
     * Returns true if the object is a plain object.
     * @method isPlainObject
     * @param {object} obj
     * @return {boolean} True if the object is a plain object, otherwise false
     */ Common.isPlainObject = function(obj) {
                    return typeof obj === "object" && obj.constructor === Object;
                };
                /**
     * Returns true if the object is a string.
     * @method isString
     * @param {object} obj
     * @return {boolean} True if the object is a string, otherwise false
     */ Common.isString = function(obj) {
                    return Object.prototype.toString.call(obj) === "[object String]";
                };
                /**
     * Returns the given value clamped between a minimum and maximum value.
     * @method clamp
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number} The value clamped between min and max inclusive
     */ Common.clamp = function(value, min, max) {
                    if (value < min) return min;
                    if (value > max) return max;
                    return value;
                };
                /**
     * Returns the sign of the given value.
     * @method sign
     * @param {number} value
     * @return {number} -1 if negative, +1 if 0 or positive
     */ Common.sign = function(value) {
                    return value < 0 ? -1 : 1;
                };
                /**
     * Returns the current timestamp since the time origin (e.g. from page load).
     * The result will be high-resolution including decimal places if available.
     * @method now
     * @return {number} the current timestamp
     */ Common.now = function() {
                    if (typeof window !== "undefined" && window.performance) {
                        if (window.performance.now) return window.performance.now();
                        else if (window.performance.webkitNow) return window.performance.webkitNow();
                    }
                    return new Date() - Common._nowStartTime;
                };
                /**
     * Returns a random value between a minimum and a maximum value inclusive.
     * The function uses a seeded random generator.
     * @method random
     * @param {number} min
     * @param {number} max
     * @return {number} A random number between min and max inclusive
     */ Common.random = function(min, max) {
                    min = typeof min !== "undefined" ? min : 0;
                    max = typeof max !== "undefined" ? max : 1;
                    return min + _seededRandom() * (max - min);
                };
                var _seededRandom = function() {
                    // https://en.wikipedia.org/wiki/Linear_congruential_generator
                    Common._seed = (Common._seed * 9301 + 49297) % 233280;
                    return Common._seed / 233280;
                };
                /**
     * Converts a CSS hex colour string into an integer.
     * @method colorToNumber
     * @param {string} colorString
     * @return {number} An integer representing the CSS hex string
     */ Common.colorToNumber = function(colorString) {
                    colorString = colorString.replace("#", "");
                    if (colorString.length == 3) colorString = colorString.charAt(0) + colorString.charAt(0) + colorString.charAt(1) + colorString.charAt(1) + colorString.charAt(2) + colorString.charAt(2);
                    return parseInt(colorString, 16);
                };
                /**
     * The console logging level to use, where each level includes all levels above and excludes the levels below.
     * The default level is 'debug' which shows all console messages.  
     *
     * Possible level values are:
     * - 0 = None
     * - 1 = Debug
     * - 2 = Info
     * - 3 = Warn
     * - 4 = Error
     * @property Common.logLevel
     * @type {Number}
     * @default 1
     */ Common.logLevel = 1;
                /**
     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method log
     * @param ...objs {} The objects to log.
     */ Common.log = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.log.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method info
     * @param ...objs {} The objects to log.
     */ Common.info = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 2) console.info.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method warn
     * @param ...objs {} The objects to log.
     */ Common.warn = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.warn.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Returns the next unique sequential ID.
     * @method nextId
     * @return {Number} Unique sequential ID
     */ Common.nextId = function() {
                    return Common._nextId++;
                };
                /**
     * A cross browser compatible indexOf implementation.
     * @method indexOf
     * @param {array} haystack
     * @param {object} needle
     * @return {number} The position of needle in haystack, otherwise -1.
     */ Common.indexOf = function(haystack, needle) {
                    if (haystack.indexOf) return haystack.indexOf(needle);
                    for(var i = 0; i < haystack.length; i++){
                        if (haystack[i] === needle) return i;
                    }
                    return -1;
                };
                /**
     * A cross browser compatible array map implementation.
     * @method map
     * @param {array} list
     * @param {function} func
     * @return {array} Values from list transformed by func.
     */ Common.map = function(list, func) {
                    if (list.map) return list.map(func);
                    var mapped = [];
                    for(var i = 0; i < list.length; i += 1)mapped.push(func(list[i]));
                    return mapped;
                };
                /**
     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
     * Circular dependencies are allowed.
     * @method topologicalSort
     * @param {object} graph
     * @return {array} Partially ordered set of vertices in topological order.
     */ Common.topologicalSort = function(graph) {
                    // https://github.com/mgechev/javascript-algorithms
                    // Copyright (c) Minko Gechev (MIT license)
                    // Modifications: tidy formatting and naming
                    var result = [], visited = [], temp = [];
                    for(var node in graph)if (!visited[node] && !temp[node]) Common._topologicalSort(node, visited, temp, graph, result);
                    return result;
                };
                Common._topologicalSort = function(node, visited, temp, graph, result) {
                    var neighbors = graph[node] || [];
                    temp[node] = true;
                    for(var i = 0; i < neighbors.length; i += 1){
                        var neighbor = neighbors[i];
                        if (temp[neighbor]) continue;
                        if (!visited[neighbor]) Common._topologicalSort(neighbor, visited, temp, graph, result);
                    }
                    temp[node] = false;
                    visited[node] = true;
                    result.push(node);
                };
                /**
     * Takes _n_ functions as arguments and returns a new function that calls them in order.
     * The arguments applied when calling the new function will also be applied to every function passed.
     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
     * Therefore if a passed function does not return a value, the previously returned value is maintained.
     * After all passed functions have been called the new function returns the last returned value (if any).
     * If any of the passed functions are a chain, then the chain will be flattened.
     * @method chain
     * @param ...funcs {function} The functions to chain.
     * @return {function} A new function that calls the passed functions in order.
     */ Common.chain = function() {
                    var funcs = [];
                    for(var i = 0; i < arguments.length; i += 1){
                        var func = arguments[i];
                        if (func._chained) // flatten already chained functions
                        funcs.push.apply(funcs, func._chained);
                        else funcs.push(func);
                    }
                    var chain = function() {
                        // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
                        var lastResult, args = new Array(arguments.length);
                        for(var i = 0, l = arguments.length; i < l; i++)args[i] = arguments[i];
                        for(i = 0; i < funcs.length; i += 1){
                            var result = funcs[i].apply(lastResult, args);
                            if (typeof result !== "undefined") lastResult = result;
                        }
                        return lastResult;
                    };
                    chain._chained = funcs;
                    return chain;
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathBefore
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathBefore = function(base, path, func) {
                    return Common.set(base, path, Common.chain(func, Common.get(base, path)));
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathAfter
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathAfter = function(base, path, func) {
                    return Common.set(base, path, Common.chain(Common.get(base, path), func));
                };
            })();
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Global constants.
 *
 * @ignore
 */ var CONST = {
                /**
     * Phaser Release Version
     *
     * @name Phaser.VERSION
     * @const
     * @type {string}
     * @since 3.0.0
     */ VERSION: "3.55.2",
                BlendModes: __webpack_require__(35),
                ScaleModes: __webpack_require__(168),
                /**
     * This setting will auto-detect if the browser is capable of suppporting WebGL.
     * If it is, it will use the WebGL Renderer. If not, it will fall back to the Canvas Renderer.
     *
     * @name Phaser.AUTO
     * @const
     * @type {number}
     * @since 3.0.0
     */ AUTO: 0,
                /**
     * Forces Phaser to only use the Canvas Renderer, regardless if the browser supports
     * WebGL or not.
     *
     * @name Phaser.CANVAS
     * @const
     * @type {number}
     * @since 3.0.0
     */ CANVAS: 1,
                /**
     * Forces Phaser to use the WebGL Renderer. If the browser does not support it, there is
     * no fallback to Canvas with this setting, so you should trap it and display a suitable
     * message to the user.
     *
     * @name Phaser.WEBGL
     * @const
     * @type {number}
     * @since 3.0.0
     */ WEBGL: 2,
                /**
     * A Headless Renderer doesn't create either a Canvas or WebGL Renderer. However, it still
     * absolutely relies on the DOM being present and available. This mode is meant for unit testing,
     * not for running Phaser on the server, which is something you really shouldn't do.
     *
     * @name Phaser.HEADLESS
     * @const
     * @type {number}
     * @since 3.0.0
     */ HEADLESS: 3,
                /**
     * In Phaser the value -1 means 'forever' in lots of cases, this const allows you to use it instead
     * to help you remember what the value is doing in your code.
     *
     * @name Phaser.FOREVER
     * @const
     * @type {number}
     * @since 3.0.0
     */ FOREVER: -1,
                /**
     * Direction constant.
     *
     * @name Phaser.NONE
     * @const
     * @type {number}
     * @since 3.0.0
     */ NONE: 4,
                /**
     * Direction constant.
     *
     * @name Phaser.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 5,
                /**
     * Direction constant.
     *
     * @name Phaser.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 6,
                /**
     * Direction constant.
     *
     * @name Phaser.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 7,
                /**
     * Direction constant.
     *
     * @name Phaser.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 8
            };
            module1.exports = CONST;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var Line = __webpack_require__(47);
            /**
 * @classdesc
 * The Shape Game Object is a base class for the various different shapes, such as the Arc, Star or Polygon.
 * You cannot add a Shape directly to your Scene, it is meant as a base for your own custom Shape classes.
 *
 * @class Shape
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {string} [type] - The internal type of the Shape.
 * @param {any} [data] - The data of the source shape geometry, if any.
 */ var Shape = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible
                ],
                initialize: function Shape(scene, type, data) {
                    if (type === undefined) type = "Shape";
                    GameObject.call(this, scene, type);
                    /**
         * The source Shape data. Typically a geometry object.
         * You should not manipulate this directly.
         *
         * @name Phaser.GameObjects.Shape#geom
         * @type {any}
         * @readonly
         * @since 3.13.0
         */ this.geom = data;
                    /**
         * Holds the polygon path data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathData
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathData = [];
                    /**
         * Holds the earcut polygon path index data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathIndexes
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathIndexes = [];
                    /**
         * The fill color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillColor
         * @type {number}
         * @since 3.13.0
         */ this.fillColor = 0xffffff;
                    /**
         * The fill alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.fillAlpha = 1;
                    /**
         * The stroke color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeColor
         * @type {number}
         * @since 3.13.0
         */ this.strokeColor = 0xffffff;
                    /**
         * The stroke alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeAlpha
         * @type {number}
         * @since 3.13.0
         */ this.strokeAlpha = 1;
                    /**
         * The stroke line width used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                    /**
         * Controls if this Shape is filled or not.
         * Note that some Shapes do not support being filled (such as Line shapes)
         *
         * @name Phaser.GameObjects.Shape#isFilled
         * @type {boolean}
         * @since 3.13.0
         */ this.isFilled = false;
                    /**
         * Controls if this Shape is stroked or not.
         * Note that some Shapes do not support being stroked (such as Iso Box shapes)
         *
         * @name Phaser.GameObjects.Shape#isStroked
         * @type {boolean}
         * @since 3.13.0
         */ this.isStroked = false;
                    /**
         * Controls if this Shape path is closed during rendering when stroked.
         * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
         *
         * @name Phaser.GameObjects.Shape#closePath
         * @type {boolean}
         * @since 3.13.0
         */ this.closePath = true;
                    /**
         * Private internal value.
         * A Line used when parsing internal path data to avoid constant object re-creation.
         *
         * @name Phaser.GameObjects.Shape#_tempLine
         * @type {Phaser.Geom.Line}
         * @private
         * @since 3.13.0
         */ this._tempLine = new Line();
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayWidth` property.
         *
         * @name Phaser.GameObjects.Shape#width
         * @type {number}
         * @since 3.13.0
         */ this.width = 0;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayHeight` property.
         *
         * @name Phaser.GameObjects.Shape#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    this.initPipeline();
                },
                /**
     * Sets the fill color and alpha for this Shape.
     *
     * If you wish for the Shape to not be filled then call this method with no arguments, or just set `isFilled` to `false`.
     *
     * Note that some Shapes do not support fill colors, such as the Line shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [color] - The color used to fill this shape. If not provided the Shape will not be filled.
     * @param {number} [alpha=1] - The alpha value used when filling this shape, if a fill color is given.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    if (color === undefined) this.isFilled = false;
                    else {
                        this.fillColor = color;
                        this.fillAlpha = alpha;
                        this.isFilled = true;
                    }
                    return this;
                },
                /**
     * Sets the stroke color and alpha for this Shape.
     *
     * If you wish for the Shape to not be stroked then call this method with no arguments, or just set `isStroked` to `false`.
     *
     * Note that some Shapes do not support being stroked, such as the Iso Box shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setStrokeStyle
     * @since 3.13.0
     *
     * @param {number} [lineWidth] - The width of line to stroke with. If not provided or undefined the Shape will not be stroked.
     * @param {number} [color] - The color used to stroke this shape. If not provided the Shape will not be stroked.
     * @param {number} [alpha=1] - The alpha value used when stroking this shape, if a stroke color is given.
     *
     * @return {this} This Game Object instance.
     */ setStrokeStyle: function(lineWidth, color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    if (lineWidth === undefined) this.isStroked = false;
                    else {
                        this.lineWidth = lineWidth;
                        this.strokeColor = color;
                        this.strokeAlpha = alpha;
                        this.isStroked = true;
                    }
                    return this;
                },
                /**
     * Sets if this Shape path is closed during rendering when stroked.
     * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setClosePath
     * @since 3.13.0
     *
     * @param {boolean} value - Set to `true` if the Shape should be closed when stroked, otherwise `false`.
     *
     * @return {this} This Game Object instance.
     */ setClosePath: function(value) {
                    this.closePath = value;
                    return this;
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Shape#setSize
     * @private
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets the display size of this Shape.
     *
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Shape#setDisplaySize
     * @since 3.53.0
     *
     * @param {number} width - The display width of this Shape.
     * @param {number} height - The display height of this Shape.
     *
     * @return {this} This Shape instance.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shape#preDestroy
     * @protected
     * @since 3.13.0
     */ preDestroy: function() {
                    this.geom = null;
                    this._tempLine = null;
                    this.pathData = [];
                    this.pathIndexes = [];
                },
                /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayWidth
     * @type {number}
     * @since 3.13.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayHeight
     * @type {number}
     * @since 3.13.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                }
            });
            module1.exports = Shape;
        /***/ },
        /* 35 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes.
 * 
 * @namespace Phaser.BlendModes
 * @since 3.0.0
 */ module1.exports = {
                /**
     * Skips the Blend Mode check in the renderer.
     * 
     * @name Phaser.BlendModes.SKIP_CHECK
     * @type {number}
     * @const
     * @since 3.0.0
     */ SKIP_CHECK: -1,
                /**
     * Normal blend mode. For Canvas and WebGL.
     * This is the default setting and draws new shapes on top of the existing canvas content.
     * 
     * @name Phaser.BlendModes.NORMAL
     * @type {number}
     * @const
     * @since 3.0.0
     */ NORMAL: 0,
                /**
     * Add blend mode. For Canvas and WebGL.
     * Where both shapes overlap the color is determined by adding color values.
     * 
     * @name Phaser.BlendModes.ADD
     * @type {number}
     * @const
     * @since 3.0.0
     */ ADD: 1,
                /**
     * Multiply blend mode. For Canvas and WebGL.
     * The pixels are of the top layer are multiplied with the corresponding pixel of the bottom layer. A darker picture is the result.
     * 
     * @name Phaser.BlendModes.MULTIPLY
     * @type {number}
     * @const
     * @since 3.0.0
     */ MULTIPLY: 2,
                /**
     * Screen blend mode. For Canvas and WebGL.
     * The pixels are inverted, multiplied, and inverted again. A lighter picture is the result (opposite of multiply)
     * 
     * @name Phaser.BlendModes.SCREEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SCREEN: 3,
                /**
     * Overlay blend mode. For Canvas only.
     * A combination of multiply and screen. Dark parts on the base layer become darker, and light parts become lighter.
     * 
     * @name Phaser.BlendModes.OVERLAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ OVERLAY: 4,
                /**
     * Darken blend mode. For Canvas only.
     * Retains the darkest pixels of both layers.
     * 
     * @name Phaser.BlendModes.DARKEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DARKEN: 5,
                /**
     * Lighten blend mode. For Canvas only.
     * Retains the lightest pixels of both layers.
     * 
     * @name Phaser.BlendModes.LIGHTEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTEN: 6,
                /**
     * Color Dodge blend mode. For Canvas only.
     * Divides the bottom layer by the inverted top layer.
     * 
     * @name Phaser.BlendModes.COLOR_DODGE
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_DODGE: 7,
                /**
     * Color Burn blend mode. For Canvas only.
     * Divides the inverted bottom layer by the top layer, and then inverts the result.
     * 
     * @name Phaser.BlendModes.COLOR_BURN
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_BURN: 8,
                /**
     * Hard Light blend mode. For Canvas only.
     * A combination of multiply and screen like overlay, but with top and bottom layer swapped.
     * 
     * @name Phaser.BlendModes.HARD_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ HARD_LIGHT: 9,
                /**
     * Soft Light blend mode. For Canvas only.
     * A softer version of hard-light. Pure black or white does not result in pure black or white.
     * 
     * @name Phaser.BlendModes.SOFT_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOFT_LIGHT: 10,
                /**
     * Difference blend mode. For Canvas only.
     * Subtracts the bottom layer from the top layer or the other way round to always get a positive value.
     * 
     * @name Phaser.BlendModes.DIFFERENCE
     * @type {number}
     * @const
     * @since 3.0.0
     */ DIFFERENCE: 11,
                /**
     * Exclusion blend mode. For Canvas only.
     * Like difference, but with lower contrast.
     * 
     * @name Phaser.BlendModes.EXCLUSION
     * @type {number}
     * @const
     * @since 3.0.0
     */ EXCLUSION: 12,
                /**
     * Hue blend mode. For Canvas only.
     * Preserves the luma and chroma of the bottom layer, while adopting the hue of the top layer.
     * 
     * @name Phaser.BlendModes.HUE
     * @type {number}
     * @const
     * @since 3.0.0
     */ HUE: 13,
                /**
     * Saturation blend mode. For Canvas only.
     * Preserves the luma and hue of the bottom layer, while adopting the chroma of the top layer.
     * 
     * @name Phaser.BlendModes.SATURATION
     * @type {number}
     * @const
     * @since 3.0.0
     */ SATURATION: 14,
                /**
     * Color blend mode. For Canvas only.
     * Preserves the luma of the bottom layer, while adopting the hue and chroma of the top layer.
     * 
     * @name Phaser.BlendModes.COLOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR: 15,
                /**
     * Luminosity blend mode. For Canvas only.
     * Preserves the hue and chroma of the bottom layer, while adopting the luma of the top layer.
     * 
     * @name Phaser.BlendModes.LUMINOSITY
     * @type {number}
     * @const
     * @since 3.0.0
     */ LUMINOSITY: 16,
                /**
     * Alpha erase blend mode. For Canvas and WebGL.
     * 
     * @name Phaser.BlendModes.ERASE
     * @type {number}
     * @const
     * @since 3.0.0
     */ ERASE: 17,
                /**
     * Source-in blend mode. For Canvas only.
     * The new shape is drawn only where both the new shape and the destination canvas overlap. Everything else is made transparent.
     * 
     * @name Phaser.BlendModes.SOURCE_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_IN: 18,
                /**
     * Source-out blend mode. For Canvas only.
     * The new shape is drawn where it doesn't overlap the existing canvas content.
     * 
     * @name Phaser.BlendModes.SOURCE_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_OUT: 19,
                /**
     * Source-out blend mode. For Canvas only.
     * The new shape is only drawn where it overlaps the existing canvas content.
     * 
     * @name Phaser.BlendModes.SOURCE_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_ATOP: 20,
                /**
     * Destination-over blend mode. For Canvas only.
     * New shapes are drawn behind the existing canvas content.
     * 
     * @name Phaser.BlendModes.DESTINATION_OVER
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OVER: 21,
                /**
     * Destination-in blend mode. For Canvas only.
     * The existing canvas content is kept where both the new shape and existing canvas content overlap. Everything else is made transparent.
     * 
     * @name Phaser.BlendModes.DESTINATION_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_IN: 22,
                /**
     * Destination-out blend mode. For Canvas only.
     * The existing content is kept where it doesn't overlap the new shape.
     * 
     * @name Phaser.BlendModes.DESTINATION_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OUT: 23,
                /**
     * Destination-out blend mode. For Canvas only.
     * The existing canvas is only kept where it overlaps the new shape. The new shape is drawn behind the canvas content.
     * 
     * @name Phaser.BlendModes.DESTINATION_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_ATOP: 24,
                /**
     * Lighten blend mode. For Canvas only.
     * Where both shapes overlap the color is determined by adding color values.
     * 
     * @name Phaser.BlendModes.LIGHTER
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTER: 25,
                /**
     * Copy blend mode. For Canvas only.
     * Only the new shape is shown.
     * 
     * @name Phaser.BlendModes.COPY
     * @type {number}
     * @const
     * @since 3.0.0
     */ COPY: 26,
                /**
     * Xor blend mode. For Canvas only.
     * Shapes are made transparent where both overlap and drawn normal everywhere else.
     * 
     * @name Phaser.BlendModes.XOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ XOR: 27
            };
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Convert the given angle from degrees, to the equivalent angle in radians.
 *
 * @function Phaser.Math.DegToRad
 * @since 3.0.0
 *
 * @param {number} degrees - The angle (in degrees) to convert to radians.
 *
 * @return {number} The given angle converted to radians.
 */ var DegToRad = function(degrees) {
                return degrees * CONST.DEG_TO_RAD;
            };
            module1.exports = DegToRad;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Events
 */ module1.exports = {
                DESTROY: __webpack_require__(743),
                FADE_IN_COMPLETE: __webpack_require__(744),
                FADE_IN_START: __webpack_require__(745),
                FADE_OUT_COMPLETE: __webpack_require__(746),
                FADE_OUT_START: __webpack_require__(747),
                FLASH_COMPLETE: __webpack_require__(748),
                FLASH_START: __webpack_require__(749),
                FOLLOW_UPDATE: __webpack_require__(750),
                PAN_COMPLETE: __webpack_require__(751),
                PAN_START: __webpack_require__(752),
                POST_RENDER: __webpack_require__(753),
                PRE_RENDER: __webpack_require__(754),
                ROTATE_COMPLETE: __webpack_require__(755),
                ROTATE_START: __webpack_require__(756),
                SHAKE_COMPLETE: __webpack_require__(757),
                SHAKE_START: __webpack_require__(758),
                ZOOM_COMPLETE: __webpack_require__(759),
                ZOOM_START: __webpack_require__(760)
            };
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetColor = __webpack_require__(103);
            var GetColor32 = __webpack_require__(328);
            var HSVToRGB = __webpack_require__(188);
            var RGBToHSV = __webpack_require__(329);
            /**
 * @namespace Phaser.Display.Color
 */ /**
 * @classdesc
 * The Color class holds a single color value and allows for easy modification and reading of it.
 *
 * @class Color
 * @memberof Phaser.Display
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 255.
 * @param {number} [green=0] - The green color value. A number between 0 and 255.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 255.
 * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
 */ var Color = new Class({
                initialize: function Color(red, green, blue, alpha) {
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    if (alpha === undefined) alpha = 255;
                    /**
         * The internal red color value.
         *
         * @name Phaser.Display.Color#r
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.r = 0;
                    /**
         * The internal green color value.
         *
         * @name Phaser.Display.Color#g
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.g = 0;
                    /**
         * The internal blue color value.
         *
         * @name Phaser.Display.Color#b
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.b = 0;
                    /**
         * The internal alpha color value.
         *
         * @name Phaser.Display.Color#a
         * @type {number}
         * @private
         * @default 255
         * @since 3.0.0
         */ this.a = 255;
                    /**
         * The hue color value. A number between 0 and 1.
         * This is the base color.
         *
         * @name Phaser.Display.Color#_h
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._h = 0;
                    /**
         * The saturation color value. A number between 0 and 1.
         * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
         *
         * @name Phaser.Display.Color#_s
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._s = 0;
                    /**
         * The lightness color value. A number between 0 and 1.
         * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
         *
         * @name Phaser.Display.Color#_v
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._v = 0;
                    /**
         * Is this color update locked?
         *
         * @name Phaser.Display.Color#_locked
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._locked = false;
                    /**
         * An array containing the calculated color values for WebGL use.
         *
         * @name Phaser.Display.Color#gl
         * @type {number[]}
         * @since 3.0.0
         */ this.gl = [
                        0,
                        0,
                        0,
                        1
                    ];
                    /**
         * Pre-calculated internal color value.
         *
         * @name Phaser.Display.Color#_color
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color = 0;
                    /**
         * Pre-calculated internal color32 value.
         *
         * @name Phaser.Display.Color#_color32
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color32 = 0;
                    /**
         * Pre-calculated internal color rgb string value.
         *
         * @name Phaser.Display.Color#_rgba
         * @type {string}
         * @private
         * @default ''
         * @since 3.0.0
         */ this._rgba = "";
                    this.setTo(red, green, blue, alpha);
                },
                /**
     * Sets this color to be transparent. Sets all values to zero.
     *
     * @method Phaser.Display.Color#transparent
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ transparent: function() {
                    this._locked = true;
                    this.red = 0;
                    this.green = 0;
                    this.blue = 0;
                    this.alpha = 0;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color of this Color component.
     *
     * @method Phaser.Display.Color#setTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     * @param {boolean} [updateHSV=true] - Update the HSV values after setting the RGB values?
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setTo: function(red, green, blue, alpha, updateHSV) {
                    if (alpha === undefined) alpha = 255;
                    if (updateHSV === undefined) updateHSV = true;
                    this._locked = true;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = alpha;
                    this._locked = false;
                    return this.update(updateHSV);
                },
                /**
     * Sets the red, green, blue and alpha GL values of this Color component.
     *
     * @method Phaser.Display.Color#setGLTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 1.
     * @param {number} green - The green color value. A number between 0 and 1.
     * @param {number} blue - The blue color value. A number between 0 and 1.
     * @param {number} [alpha=1] - The alpha value. A number between 0 and 1.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setGLTo: function(red, green, blue, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this._locked = true;
                    this.redGL = red;
                    this.greenGL = green;
                    this.blueGL = blue;
                    this.alphaGL = alpha;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color based on the color object given.
     *
     * @method Phaser.Display.Color#setFromRGB
     * @since 3.0.0
     *
     * @param {Phaser.Types.Display.InputColorObject} color - An object containing `r`, `g`, `b` and optionally `a` values in the range 0 to 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromRGB: function(color) {
                    this._locked = true;
                    this.red = color.r;
                    this.green = color.g;
                    this.blue = color.b;
                    if (color.hasOwnProperty("a")) this.alpha = color.a;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color based on the hue, saturation and lightness values given.
     *
     * @method Phaser.Display.Color#setFromHSV
     * @since 3.13.0
     *
     * @param {number} h - The hue, in the range 0 - 1. This is the base color.
     * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromHSV: function(h, s, v) {
                    return HSVToRGB(h, s, v, this);
                },
                /**
     * Updates the internal cache values.
     *
     * @method Phaser.Display.Color#update
     * @private
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ update: function(updateHSV) {
                    if (updateHSV === undefined) updateHSV = false;
                    if (this._locked) return this;
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    var a = this.a;
                    this._color = GetColor(r, g, b);
                    this._color32 = GetColor32(r, g, b, a);
                    this._rgba = "rgba(" + r + "," + g + "," + b + "," + a / 255 + ")";
                    if (updateHSV) RGBToHSV(r, g, b, this);
                    return this;
                },
                /**
     * Updates the internal hsv cache values.
     *
     * @method Phaser.Display.Color#updateHSV
     * @private
     * @since 3.13.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ updateHSV: function() {
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    RGBToHSV(r, g, b, this);
                    return this;
                },
                /**
     * Returns a new Color component using the values from this one.
     *
     * @method Phaser.Display.Color#clone
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} A new Color object.
     */ clone: function() {
                    return new Color(this.r, this.g, this.b, this.a);
                },
                /**
     * Sets this Color object to be grayscaled based on the shade value given.
     *
     * @method Phaser.Display.Color#gray
     * @since 3.13.0
     * 
     * @param {number} shade - A value between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ gray: function(shade) {
                    return this.setTo(shade, shade, shade);
                },
                /**
     * Sets this Color object to be a random color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#random
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ random: function(min, max) {
                    if (min === undefined) min = 0;
                    if (max === undefined) max = 255;
                    var r = Math.floor(min + Math.random() * (max - min));
                    var g = Math.floor(min + Math.random() * (max - min));
                    var b = Math.floor(min + Math.random() * (max - min));
                    return this.setTo(r, g, b);
                },
                /**
     * Sets this Color object to be a random grayscale color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#randomGray
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ randomGray: function(min, max) {
                    if (min === undefined) min = 0;
                    if (max === undefined) max = 255;
                    var s = Math.floor(min + Math.random() * (max - min));
                    return this.setTo(s, s, s);
                },
                /**
     * Increase the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#saturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ saturate: function(amount) {
                    this.s += amount / 100;
                    return this;
                },
                /**
     * Decrease the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#desaturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ desaturate: function(amount) {
                    this.s -= amount / 100;
                    return this;
                },
                /**
     * Increase the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#lighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ lighten: function(amount) {
                    this.v += amount / 100;
                    return this;
                },
                /**
     * Decrease the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#darken
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ darken: function(amount) {
                    this.v -= amount / 100;
                    return this;
                },
                /**
     * Brighten this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#brighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ brighten: function(amount) {
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    r = Math.max(0, Math.min(255, r - Math.round(255 * -(amount / 100))));
                    g = Math.max(0, Math.min(255, g - Math.round(255 * -(amount / 100))));
                    b = Math.max(0, Math.min(255, b - Math.round(255 * -(amount / 100))));
                    return this.setTo(r, g, b);
                },
                /**
     * The color of this Color component, not including the alpha channel.
     *
     * @name Phaser.Display.Color#color
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color: {
                    get: function() {
                        return this._color;
                    }
                },
                /**
     * The color of this Color component, including the alpha channel.
     *
     * @name Phaser.Display.Color#color32
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color32: {
                    get: function() {
                        return this._color32;
                    }
                },
                /**
     * The color of this Color component as a string which can be used in CSS color values.
     *
     * @name Phaser.Display.Color#rgba
     * @type {string}
     * @readonly
     * @since 3.0.0
     */ rgba: {
                    get: function() {
                        return this._rgba;
                    }
                },
                /**
     * The red color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#redGL
     * @type {number}
     * @since 3.0.0
     */ redGL: {
                    get: function() {
                        return this.gl[0];
                    },
                    set: function(value) {
                        this.gl[0] = Math.min(Math.abs(value), 1);
                        this.r = Math.floor(this.gl[0] * 255);
                        this.update(true);
                    }
                },
                /**
     * The green color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#greenGL
     * @type {number}
     * @since 3.0.0
     */ greenGL: {
                    get: function() {
                        return this.gl[1];
                    },
                    set: function(value) {
                        this.gl[1] = Math.min(Math.abs(value), 1);
                        this.g = Math.floor(this.gl[1] * 255);
                        this.update(true);
                    }
                },
                /**
     * The blue color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#blueGL
     * @type {number}
     * @since 3.0.0
     */ blueGL: {
                    get: function() {
                        return this.gl[2];
                    },
                    set: function(value) {
                        this.gl[2] = Math.min(Math.abs(value), 1);
                        this.b = Math.floor(this.gl[2] * 255);
                        this.update(true);
                    }
                },
                /**
     * The alpha color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#alphaGL
     * @type {number}
     * @since 3.0.0
     */ alphaGL: {
                    get: function() {
                        return this.gl[3];
                    },
                    set: function(value) {
                        this.gl[3] = Math.min(Math.abs(value), 1);
                        this.a = Math.floor(this.gl[3] * 255);
                        this.update();
                    }
                },
                /**
     * The red color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#red
     * @type {number}
     * @since 3.0.0
     */ red: {
                    get: function() {
                        return this.r;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.r = Math.min(value, 255);
                        this.gl[0] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The green color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#green
     * @type {number}
     * @since 3.0.0
     */ green: {
                    get: function() {
                        return this.g;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.g = Math.min(value, 255);
                        this.gl[1] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The blue color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#blue
     * @type {number}
     * @since 3.0.0
     */ blue: {
                    get: function() {
                        return this.b;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.b = Math.min(value, 255);
                        this.gl[2] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The alpha color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this.a;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.a = Math.min(value, 255);
                        this.gl[3] = value / 255;
                        this.update();
                    }
                },
                /**
     * The hue color value. A number between 0 and 1.
     * This is the base color.
     *
     * @name Phaser.Display.Color#h
     * @type {number}
     * @since 3.13.0
     */ h: {
                    get: function() {
                        return this._h;
                    },
                    set: function(value) {
                        this._h = value;
                        HSVToRGB(value, this._s, this._v, this);
                    }
                },
                /**
     * The saturation color value. A number between 0 and 1.
     * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     *
     * @name Phaser.Display.Color#s
     * @type {number}
     * @since 3.13.0
     */ s: {
                    get: function() {
                        return this._s;
                    },
                    set: function(value) {
                        this._s = value;
                        HSVToRGB(this._h, value, this._v, this);
                    }
                },
                /**
     * The lightness color value. A number between 0 and 1.
     * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @name Phaser.Display.Color#v
     * @type {number}
     * @since 3.13.0
     */ v: {
                    get: function() {
                        return this._v;
                    },
                    set: function(value) {
                        this._v = value;
                        HSVToRGB(this._h, this._s, value, this);
                    }
                }
            });
            module1.exports = Color;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A representation of a vector in 3D space.
 *
 * A three-component vector.
 *
 * @class Vector3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Vector3 = new Class({
                initialize: function Vector3(x, y, z) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector3#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector3#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector3#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                    if (typeof x === "object") {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                    }
                },
                /**
     * Set this Vector to point up.
     *
     * Sets the y component of the vector to 1, and the others to 0.
     *
     * @method Phaser.Math.Vector3#up
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ up: function() {
                    this.x = 0;
                    this.y = 1;
                    this.z = 0;
                    return this;
                },
                /**
     * Sets the components of this Vector to be the `Math.min` result from the given vector.
     *
     * @method Phaser.Math.Vector3#min
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the minimum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ min: function(v) {
                    this.x = Math.min(this.x, v.x);
                    this.y = Math.min(this.y, v.y);
                    this.z = Math.min(this.z, v.z);
                    return this;
                },
                /**
     * Sets the components of this Vector to be the `Math.max` result from the given vector.
     *
     * @method Phaser.Math.Vector3#max
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the maximum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ max: function(v) {
                    this.x = Math.max(this.x, v.x);
                    this.y = Math.max(this.y, v.y);
                    this.z = Math.max(this.z, v.z);
                    return this;
                },
                /**
     * Make a clone of this Vector3.
     *
     * @method Phaser.Math.Vector3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} A new Vector3 object containing this Vectors values.
     */ clone: function() {
                    return new Vector3(this.x, this.y, this.z);
                },
                /**
     * Adds the two given Vector3s and sets the results into this Vector3.
     *
     * @method Phaser.Math.Vector3#addVectors
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to add.
     * @param {Phaser.Math.Vector3} b - The second Vector to add.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addVectors: function(a, b) {
                    this.x = a.x + b.x;
                    this.y = a.y + b.y;
                    this.z = a.z + b.z;
                    return this;
                },
                /**
     * Calculate the cross (vector) product of two given Vectors.
     *
     * @method Phaser.Math.Vector3#crossVectors
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to multiply.
     * @param {Phaser.Math.Vector3} b - The second Vector to multiply.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ crossVectors: function(a, b) {
                    var ax = a.x;
                    var ay = a.y;
                    var az = a.z;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    this.x = ay * bz - az * by;
                    this.y = az * bx - ax * bz;
                    this.z = ax * by - ay * bx;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector3#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to compare against.
     *
     * @return {boolean} True if the two vectors strictly match, otherwise false.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y && this.z === v.z;
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector3#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ copy: function(src) {
                    this.x = src.x;
                    this.y = src.y;
                    this.z = src.z || 0;
                    return this;
                },
                /**
     * Set the `x`, `y`, and `z` components of this Vector to the given `x`, `y`, and `z` values.
     *
     * @method Phaser.Math.Vector3#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y and z components.
     * @param {number} [y] - The y value to set for this Vector.
     * @param {number} [z] - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ set: function(x, y, z) {
                    if (typeof x === "object") {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                    }
                    return this;
                },
                /**
     * Sets the components of this Vector3 from the position of the given Matrix4.
     *
     * @method Phaser.Math.Vector3#setFromMatrixPosition
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the position from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixPosition: function(m) {
                    return this.fromArray(m.val, 12);
                },
                /**
     * Sets the components of this Vector3 from the Matrix4 column specified.
     *
     * @method Phaser.Math.Vector3#setFromMatrixColumn
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the column from.
     * @param {number} index - The column index.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixColumn: function(mat4, index) {
                    return this.fromArray(mat4.val, index * 4);
                },
                /**
     * Sets the components of this Vector3 from the given array, based on the offset.
     *
     * Vector3.x = array[offset]
     * Vector3.y = array[offset + 1]
     * Vector3.z = array[offset + 2]
     *
     * @method Phaser.Math.Vector3#fromArray
     * @since 3.50.0
     *
     * @param {number[]} array - The array of values to get this Vector from.
     * @param {number} [offset=0] - The offset index into the array.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ fromArray: function(array, offset) {
                    if (offset === undefined) offset = 0;
                    this.x = array[offset];
                    this.y = array[offset + 1];
                    this.z = array[offset + 2];
                    return this;
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ add: function(v) {
                    this.x += v.x;
                    this.y += v.y;
                    this.z += v.z || 0;
                    return this;
                },
                /**
     * Add the given value to each component of this Vector.
     *
     * @method Phaser.Math.Vector3#addScalar
     * @since 3.50.0
     *
     * @param {number} s - The amount to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScalar: function(s) {
                    this.x += s;
                    this.y += s;
                    this.z += s;
                    return this;
                },
                /**
     * Add and scale a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#addScale
     * @since 3.50.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     * @param {number} scale - The amount to scale `v` by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScale: function(v, scale) {
                    this.x += v.x * scale;
                    this.y += v.y * scale;
                    this.z += v.z * scale || 0;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector3#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ subtract: function(v) {
                    this.x -= v.x;
                    this.y -= v.y;
                    this.z -= v.z || 0;
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ multiply: function(v) {
                    this.x *= v.x;
                    this.y *= v.y;
                    this.z *= v.z || 1;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector3#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ scale: function(scale) {
                    if (isFinite(scale)) {
                        this.x *= scale;
                        this.y *= scale;
                        this.z *= scale;
                    } else {
                        this.x = 0;
                        this.y = 0;
                        this.z = 0;
                    }
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ divide: function(v) {
                    this.x /= v.x;
                    this.y /= v.y;
                    this.z /= v.z || 1;
                    return this;
                },
                /**
     * Negate the `x`, `y` and `z` components of this Vector.
     *
     * @method Phaser.Math.Vector3#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    this.z = -this.z;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    return Math.sqrt(dx * dx + dy * dy + dz * dz);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector3#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    return dx * dx + dy * dy + dz * dz;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector3#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    return Math.sqrt(x * x + y * y + z * z);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector3#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    return x * x + y * y + z * z;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector3#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var len = x * x + y * y + z * z;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                        this.z = z * len;
                    }
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to dot product with this Vector3.
     *
     * @return {number} The dot product of this Vector and `v`.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z;
                },
                /**
     * Calculate the cross (vector) product of this Vector (which will be modified) and the given Vector.
     *
     * @method Phaser.Math.Vector3#cross
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector to cross product with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ cross: function(v) {
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var bx = v.x;
                    var by = v.y;
                    var bz = v.z;
                    this.x = ay * bz - az * by;
                    this.y = az * bx - ax * bz;
                    this.z = ax * by - ay * bx;
                    return this;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector3#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    this.x = ax + t * (v.x - ax);
                    this.y = ay + t * (v.y - ay);
                    this.z = az + t * (v.z - az);
                    return this;
                },
                /**
     * Takes a Matrix3 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix3
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix3} mat3 - The Matrix3 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix3: function(mat3) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat3.val;
                    this.x = m[0] * x + m[3] * y + m[6] * z;
                    this.y = m[1] * x + m[4] * y + m[7] * z;
                    this.z = m[2] * x + m[5] * y + m[8] * z;
                    return this;
                },
                /**
     * Takes a Matrix4 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix4: function(mat4) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat4.val;
                    var w = 1 / (m[3] * x + m[7] * y + m[11] * z + m[15]);
                    this.x = (m[0] * x + m[4] * y + m[8] * z + m[12]) * w;
                    this.y = (m[1] * x + m[5] * y + m[9] * z + m[13]) * w;
                    this.z = (m[2] * x + m[6] * y + m[10] * z + m[14]) * w;
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector3#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat3: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    this.x = x * m[0] + y * m[3] + z * m[6];
                    this.y = x * m[1] + y * m[4] + z * m[7];
                    this.z = x * m[2] + y * m[5] + z * m[8];
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[8] * z + m[12];
                    this.y = m[1] * x + m[5] * y + m[9] * z + m[13];
                    this.z = m[2] * x + m[6] * y + m[10] * z + m[14];
                    return this;
                },
                /**
     * Transforms the coordinates of this Vector3 with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformCoordinates
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformCoordinates: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                    var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                    var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                    var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                    this.x = tx / tw;
                    this.y = ty / tw;
                    this.z = tz / tw;
                    return this;
                },
                /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector3#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformQuat: function(q) {
                    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var qx = q.x;
                    var qy = q.y;
                    var qz = q.z;
                    var qw = q.w;
                    // calculate quat * vec
                    var ix = qw * x + qy * z - qz * y;
                    var iy = qw * y + qz * x - qx * z;
                    var iz = qw * z + qx * y - qy * x;
                    var iw = -qx * x - qy * y - qz * z;
                    // calculate result * inverse quat
                    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                    return this;
                },
                /**
     * Multiplies this Vector3 by the specified matrix, applying a W divide. This is useful for projection,
     * e.g. unprojecting a 2D point into 3D space.
     *
     * @method Phaser.Math.Vector3#project
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to multiply this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ project: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    var a00 = m[0];
                    var a01 = m[1];
                    var a02 = m[2];
                    var a03 = m[3];
                    var a10 = m[4];
                    var a11 = m[5];
                    var a12 = m[6];
                    var a13 = m[7];
                    var a20 = m[8];
                    var a21 = m[9];
                    var a22 = m[10];
                    var a23 = m[11];
                    var a30 = m[12];
                    var a31 = m[13];
                    var a32 = m[14];
                    var a33 = m[15];
                    var lw = 1 / (x * a03 + y * a13 + z * a23 + a33);
                    this.x = (x * a00 + y * a10 + z * a20 + a30) * lw;
                    this.y = (x * a01 + y * a11 + z * a21 + a31) * lw;
                    this.z = (x * a02 + y * a12 + z * a22 + a32) * lw;
                    return this;
                },
                /**
     * Multiplies this Vector3 by the given view and projection matrices.
     *
     * @method Phaser.Math.Vector3#projectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} viewMatrix - A View Matrix.
     * @param {Phaser.Math.Matrix4} projectionMatrix - A Projection Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ projectViewMatrix: function(viewMatrix, projectionMatrix) {
                    return this.applyMatrix4(viewMatrix).applyMatrix4(projectionMatrix);
                },
                /**
     * Multiplies this Vector3 by the given inversed projection matrix and world matrix.
     *
     * @method Phaser.Math.Vector3#unprojectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} projectionMatrix - An inversed Projection Matrix.
     * @param {Phaser.Math.Matrix4} worldMatrix - A World View Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unprojectViewMatrix: function(projectionMatrix, worldMatrix) {
                    return this.applyMatrix4(projectionMatrix).applyMatrix4(worldMatrix);
                },
                /**
     * Unproject this point from 2D space to 3D space.
     * The point should have its x and y properties set to
     * 2D screen space, and the z either at 0 (near plane)
     * or 1 (far plane). The provided matrix is assumed to already
     * be combined, i.e. projection * view * model.
     *
     * After this operation, this vector's (x, y, z) components will
     * represent the unprojected 3D coordinate.
     *
     * @method Phaser.Math.Vector3#unproject
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} viewport - Screen x, y, width and height in pixels.
     * @param {Phaser.Math.Matrix4} invProjectionView - Combined projection and view matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unproject: function(viewport, invProjectionView) {
                    var viewX = viewport.x;
                    var viewY = viewport.y;
                    var viewWidth = viewport.z;
                    var viewHeight = viewport.w;
                    var x = this.x - viewX;
                    var y = viewHeight - this.y - 1 - viewY;
                    var z = this.z;
                    this.x = 2 * x / viewWidth - 1;
                    this.y = 2 * y / viewHeight - 1;
                    this.z = 2 * z - 1;
                    return this.project(invProjectionView);
                },
                /**
     * Make this Vector the zero vector (0, 0, 0).
     *
     * @method Phaser.Math.Vector3#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    this.z = 0;
                    return this;
                }
            });
            /**
 * A static zero Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ZERO
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ZERO = new Vector3();
            /**
 * A static right Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.RIGHT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.RIGHT = new Vector3(1, 0, 0);
            /**
 * A static left Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.LEFT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.LEFT = new Vector3(-1, 0, 0);
            /**
 * A static up Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.UP
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.UP = new Vector3(0, -1, 0);
            /**
 * A static down Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.DOWN
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.DOWN = new Vector3(0, 1, 0);
            /**
 * A static forward Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.FORWARD
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.FORWARD = new Vector3(0, 0, 1);
            /**
 * A static back Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.BACK
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.BACK = new Vector3(0, 0, -1);
            /**
 * A static one Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ONE
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ONE = new Vector3(1, 1, 1);
            module1.exports = Vector3;
        /***/ },
        /* 40 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Formats
 */ module1.exports = {
                /**
     * CSV Map Type
     * 
     * @name Phaser.Tilemaps.Formats.CSV
     * @type {number}
     * @since 3.0.0
     */ CSV: 0,
                /**
     * Tiled JSON Map Type
     * 
     * @name Phaser.Tilemaps.Formats.TILED_JSON
     * @type {number}
     * @since 3.0.0
     */ TILED_JSON: 1,
                /**
     * 2D Array Map Type
     * 
     * @name Phaser.Tilemaps.Formats.ARRAY_2D
     * @type {number}
     * @since 3.0.0
     */ ARRAY_2D: 2,
                /**
     * Weltmeister (Impact.js) Map Type
     * 
     * @name Phaser.Tilemaps.Formats.WELTMEISTER
     * @type {number}
     * @since 3.0.0
     */ WELTMEISTER: 3
            };
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * The `Matter.Body` module contains methods for creating and manipulating body models.
 * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
 * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
 *
 * See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
 * @class Body
 */ var Body = {};
            module1.exports = Body;
            var Vertices = __webpack_require__(64);
            var Vector = __webpack_require__(83);
            var Sleeping = __webpack_require__(165);
            var Common = __webpack_require__(32);
            var Bounds = __webpack_require__(84);
            var Axes = __webpack_require__(271);
            (function() {
                Body._inertiaScale = 4;
                Body._nextCollidingGroupId = 1;
                Body._nextNonCollidingGroupId = -1;
                Body._nextCategory = 0x0001;
                /**
     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * Vertices must be specified in clockwise order.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {body} body
     */ Body.create = function(options) {
                    var defaults = {
                        id: Common.nextId(),
                        type: "body",
                        label: "Body",
                        parts: [],
                        plugin: {},
                        angle: 0,
                        vertices: null,
                        position: {
                            x: 0,
                            y: 0
                        },
                        force: {
                            x: 0,
                            y: 0
                        },
                        torque: 0,
                        positionImpulse: {
                            x: 0,
                            y: 0
                        },
                        previousPositionImpulse: {
                            x: 0,
                            y: 0
                        },
                        constraintImpulse: {
                            x: 0,
                            y: 0,
                            angle: 0
                        },
                        totalContacts: 0,
                        speed: 0,
                        angularSpeed: 0,
                        velocity: {
                            x: 0,
                            y: 0
                        },
                        angularVelocity: 0,
                        isSensor: false,
                        isStatic: false,
                        isSleeping: false,
                        motion: 0,
                        sleepThreshold: 60,
                        density: 0.001,
                        restitution: 0,
                        friction: 0.1,
                        frictionStatic: 0.5,
                        frictionAir: 0.01,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        },
                        slop: 0.05,
                        timeScale: 1,
                        events: null,
                        bounds: null,
                        chamfer: null,
                        circleRadius: 0,
                        positionPrev: null,
                        anglePrev: 0,
                        parent: null,
                        axes: null,
                        area: 0,
                        mass: 0,
                        inverseMass: 0,
                        inertia: 0,
                        inverseInertia: 0,
                        _original: null,
                        render: {
                            visible: true,
                            opacity: 1,
                            sprite: {
                                xOffset: 0,
                                yOffset: 0
                            },
                            fillColor: null,
                            fillOpacity: null,
                            lineColor: null,
                            lineOpacity: null,
                            lineThickness: null // custom Phaser property
                        },
                        gameObject: null,
                        scale: {
                            x: 1,
                            y: 1
                        },
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        centerOffset: {
                            x: 0,
                            y: 0
                        },
                        gravityScale: {
                            x: 1,
                            y: 1
                        },
                        ignoreGravity: false,
                        ignorePointer: false,
                        onCollideCallback: null,
                        onCollideEndCallback: null,
                        onCollideActiveCallback: null,
                        onCollideWith: {} // custom Phaser property
                    };
                    if (!options.hasOwnProperty("position") && options.hasOwnProperty("vertices")) options.position = Vertices.centre(options.vertices);
                    else if (!options.hasOwnProperty("vertices")) defaults.vertices = Vertices.fromPath("L 0 0 L 40 0 L 40 40 L 0 40");
                    var body = Common.extend(defaults, options);
                    _initProperties(body, options);
                    //  Helper function
                    body.setOnCollideWith = function(body, callback) {
                        if (callback) this.onCollideWith[body.id] = callback;
                        else delete this.onCollideWith[body.id];
                        return this;
                    };
                    return body;
                };
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
     * See `body.collisionFilter` for more information.
     * @method nextGroup
     * @param {bool} [isNonColliding=false]
     * @return {Number} Unique group index
     */ Body.nextGroup = function(isNonColliding) {
                    if (isNonColliding) return Body._nextNonCollidingGroupId--;
                    return Body._nextCollidingGroupId++;
                };
                /**
     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
     * There are 32 available. See `body.collisionFilter` for more information.
     * @method nextCategory
     * @return {Number} Unique category bitfield
     */ Body.nextCategory = function() {
                    Body._nextCategory = Body._nextCategory << 1;
                    return Body._nextCategory;
                };
                /**
     * Initialises body properties.
     * @method _initProperties
     * @private
     * @param {body} body
     * @param {} [options]
     */ var _initProperties = function(body, options) {
                    options = options || {};
                    // init required properties (order is important)
                    Body.set(body, {
                        bounds: body.bounds || Bounds.create(body.vertices),
                        positionPrev: body.positionPrev || Vector.clone(body.position),
                        anglePrev: body.anglePrev || body.angle,
                        vertices: body.vertices,
                        parts: body.parts || [
                            body
                        ],
                        isStatic: body.isStatic,
                        isSleeping: body.isSleeping,
                        parent: body.parent || body
                    });
                    var bounds = body.bounds;
                    Vertices.rotate(body.vertices, body.angle, body.position);
                    Axes.rotate(body.axes, body.angle);
                    Bounds.update(bounds, body.vertices, body.velocity);
                    // allow options to override the automatically calculated properties
                    Body.set(body, {
                        axes: options.axes || body.axes,
                        area: options.area || body.area,
                        mass: options.mass || body.mass,
                        inertia: options.inertia || body.inertia
                    });
                    if (body.parts.length === 1) {
                        var centerOfMass = body.centerOfMass;
                        var centerOffset = body.centerOffset;
                        var bodyWidth = bounds.max.x - bounds.min.x;
                        var bodyHeight = bounds.max.y - bounds.min.y;
                        centerOfMass.x = -(bounds.min.x - body.position.x) / bodyWidth;
                        centerOfMass.y = -(bounds.min.y - body.position.y) / bodyHeight;
                        centerOffset.x = bodyWidth * centerOfMass.x;
                        centerOffset.y = bodyHeight * centerOfMass.y;
                    }
                };
                /**
     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
     * Prefer to use the actual setter functions in performance critical situations.
     * @method set
     * @param {body} body
     * @param {} settings A property name (or map of properties and values) to set on the body.
     * @param {} value The value to set if `settings` is a single property name.
     */ Body.set = function(body, settings, value) {
                    var property;
                    if (typeof settings === "string") {
                        property = settings;
                        settings = {};
                        settings[property] = value;
                    }
                    for(property in settings){
                        if (!Object.prototype.hasOwnProperty.call(settings, property)) continue;
                        value = settings[property];
                        switch(property){
                            case "isStatic":
                                Body.setStatic(body, value);
                                break;
                            case "isSleeping":
                                Sleeping.set(body, value);
                                break;
                            case "mass":
                                Body.setMass(body, value);
                                break;
                            case "density":
                                Body.setDensity(body, value);
                                break;
                            case "inertia":
                                Body.setInertia(body, value);
                                break;
                            case "vertices":
                                Body.setVertices(body, value);
                                break;
                            case "position":
                                Body.setPosition(body, value);
                                break;
                            case "angle":
                                Body.setAngle(body, value);
                                break;
                            case "velocity":
                                Body.setVelocity(body, value);
                                break;
                            case "angularVelocity":
                                Body.setAngularVelocity(body, value);
                                break;
                            case "parts":
                                Body.setParts(body, value);
                                break;
                            case "centre":
                                Body.setCentre(body, value);
                                break;
                            default:
                                body[property] = value;
                        }
                    }
                };
                /**
     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
     * @method setStatic
     * @param {body} body
     * @param {bool} isStatic
     */ Body.setStatic = function(body, isStatic) {
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.isStatic = isStatic;
                        if (isStatic) {
                            part._original = {
                                restitution: part.restitution,
                                friction: part.friction,
                                mass: part.mass,
                                inertia: part.inertia,
                                density: part.density,
                                inverseMass: part.inverseMass,
                                inverseInertia: part.inverseInertia
                            };
                            part.restitution = 0;
                            part.friction = 1;
                            part.mass = part.inertia = part.density = Infinity;
                            part.inverseMass = part.inverseInertia = 0;
                            part.positionPrev.x = part.position.x;
                            part.positionPrev.y = part.position.y;
                            part.anglePrev = part.angle;
                            part.angularVelocity = 0;
                            part.speed = 0;
                            part.angularSpeed = 0;
                            part.motion = 0;
                        } else if (part._original) {
                            part.restitution = part._original.restitution;
                            part.friction = part._original.friction;
                            part.mass = part._original.mass;
                            part.inertia = part._original.inertia;
                            part.density = part._original.density;
                            part.inverseMass = part._original.inverseMass;
                            part.inverseInertia = part._original.inverseInertia;
                            part._original = null;
                        }
                    }
                };
                /**
     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
     * @method setMass
     * @param {body} body
     * @param {number} mass
     */ Body.setMass = function(body, mass) {
                    var moment = body.inertia / (body.mass / 6);
                    body.inertia = moment * (mass / 6);
                    body.inverseInertia = 1 / body.inertia;
                    body.mass = mass;
                    body.inverseMass = 1 / body.mass;
                    body.density = body.mass / body.area;
                };
                /**
     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
     * @method setDensity
     * @param {body} body
     * @param {number} density
     */ Body.setDensity = function(body, density) {
                    Body.setMass(body, density * body.area);
                    body.density = density;
                };
                /**
     * Sets the moment of inertia (i.e. second moment of area) of the body. 
     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
     * @method setInertia
     * @param {body} body
     * @param {number} inertia
     */ Body.setInertia = function(body, inertia) {
                    body.inertia = inertia;
                    body.inverseInertia = 1 / body.inertia;
                };
                /**
     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
     * They are then automatically translated to world space based on `body.position`.
     *
     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
     * Vertices must form a convex hull, concave hulls are not supported.
     *
     * @method setVertices
     * @param {body} body
     * @param {vector[]} vertices
     */ Body.setVertices = function(body, vertices) {
                    // change vertices
                    if (vertices[0].body === body) body.vertices = vertices;
                    else body.vertices = Vertices.create(vertices, body);
                    // update properties
                    body.axes = Axes.fromVertices(body.vertices);
                    body.area = Vertices.area(body.vertices);
                    Body.setMass(body, body.density * body.area);
                    // orient vertices around the centre of mass at origin (0, 0)
                    var centre = Vertices.centre(body.vertices);
                    Vertices.translate(body.vertices, centre, -1);
                    // update inertia while vertices are at origin (0, 0)
                    Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
                    // update geometry
                    Vertices.translate(body.vertices, body.position);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                };
                /**
     * Sets the parts of the `body` and updates mass, inertia and centroid.
     * Each part will have its parent set to `body`.
     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
     * @method setParts
     * @param {body} body
     * @param [body] parts
     * @param {bool} [autoHull=true]
     */ Body.setParts = function(body, parts, autoHull) {
                    var i;
                    // add all the parts, ensuring that the first part is always the parent body
                    parts = parts.slice(0);
                    body.parts.length = 0;
                    body.parts.push(body);
                    body.parent = body;
                    for(i = 0; i < parts.length; i++){
                        var part = parts[i];
                        if (part !== body) {
                            part.parent = body;
                            body.parts.push(part);
                        }
                    }
                    if (body.parts.length === 1) return;
                    autoHull = typeof autoHull !== "undefined" ? autoHull : true;
                    // find the convex hull of all parts to set on the parent body
                    if (autoHull) {
                        var vertices = [];
                        for(i = 0; i < parts.length; i++)vertices = vertices.concat(parts[i].vertices);
                        Vertices.clockwiseSort(vertices);
                        var hull = Vertices.hull(vertices), hullCentre = Vertices.centre(hull);
                        Body.setVertices(body, hull);
                        Vertices.translate(body.vertices, hullCentre);
                    }
                    // sum the properties of all compound parts of the parent body
                    var total = Body._totalProperties(body);
                    //  Phaser addition
                    var cx = total.centre.x;
                    var cy = total.centre.y;
                    var bounds = body.bounds;
                    var centerOfMass = body.centerOfMass;
                    var centerOffset = body.centerOffset;
                    Bounds.update(bounds, body.vertices, body.velocity);
                    centerOfMass.x = -(bounds.min.x - cx) / (bounds.max.x - bounds.min.x);
                    centerOfMass.y = -(bounds.min.y - cy) / (bounds.max.y - bounds.min.y);
                    centerOffset.x = cx;
                    centerOffset.y = cy;
                    body.area = total.area;
                    body.parent = body;
                    body.position.x = cx;
                    body.position.y = cy;
                    body.positionPrev.x = cx;
                    body.positionPrev.y = cy;
                    Body.setMass(body, total.mass);
                    Body.setInertia(body, total.inertia);
                    Body.setPosition(body, total.centre);
                };
                /**
     * Set the centre of mass of the body. 
     * The `centre` is a vector in world-space unless `relative` is set, in which case it is a translation.
     * The centre of mass is the point the body rotates about and can be used to simulate non-uniform density.
     * This is equal to moving `body.position` but not the `body.vertices`.
     * Invalid if the `centre` falls outside the body's convex hull.
     * @method setCentre
     * @param {body} body
     * @param {vector} centre
     * @param {bool} relative
     */ Body.setCentre = function(body, centre, relative) {
                    if (!relative) {
                        body.positionPrev.x = centre.x - (body.position.x - body.positionPrev.x);
                        body.positionPrev.y = centre.y - (body.position.y - body.positionPrev.y);
                        body.position.x = centre.x;
                        body.position.y = centre.y;
                    } else {
                        body.positionPrev.x += centre.x;
                        body.positionPrev.y += centre.y;
                        body.position.x += centre.x;
                        body.position.y += centre.y;
                    }
                };
                /**
     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
     * @method setPosition
     * @param {body} body
     * @param {vector} position
     */ Body.setPosition = function(body, position) {
                    var delta = Vector.sub(position, body.position);
                    body.positionPrev.x += delta.x;
                    body.positionPrev.y += delta.y;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.position.x += delta.x;
                        part.position.y += delta.y;
                        Vertices.translate(part.vertices, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
     * @method setAngle
     * @param {body} body
     * @param {number} angle
     */ Body.setAngle = function(body, angle) {
                    var delta = angle - body.angle;
                    body.anglePrev += delta;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.angle += delta;
                        Vertices.rotate(part.vertices, delta, body.position);
                        Axes.rotate(part.axes, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                        if (i > 0) Vector.rotateAbout(part.position, delta, body.position, part.position);
                    }
                };
                /**
     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setVelocity
     * @param {body} body
     * @param {vector} velocity
     */ Body.setVelocity = function(body, velocity) {
                    body.positionPrev.x = body.position.x - velocity.x;
                    body.positionPrev.y = body.position.y - velocity.y;
                    body.velocity.x = velocity.x;
                    body.velocity.y = velocity.y;
                    body.speed = Vector.magnitude(body.velocity);
                };
                /**
     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setAngularVelocity
     * @param {body} body
     * @param {number} velocity
     */ Body.setAngularVelocity = function(body, velocity) {
                    body.anglePrev = body.angle - velocity;
                    body.angularVelocity = velocity;
                    body.angularSpeed = Math.abs(body.angularVelocity);
                };
                /**
     * Moves a body by a given vector relative to its current position, without imparting any velocity.
     * @method translate
     * @param {body} body
     * @param {vector} translation
     */ Body.translate = function(body, translation) {
                    Body.setPosition(body, Vector.add(body.position, translation));
                };
                /**
     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
     * @method rotate
     * @param {body} body
     * @param {number} rotation
     * @param {vector} [point]
     */ Body.rotate = function(body, rotation, point) {
                    if (!point) Body.setAngle(body, body.angle + rotation);
                    else {
                        var cos = Math.cos(rotation), sin = Math.sin(rotation), dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.setAngle(body, body.angle + rotation);
                    }
                };
                /**
     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
     * @method scale
     * @param {body} body
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} [point]
     */ Body.scale = function(body, scaleX, scaleY, point) {
                    var totalArea = 0, totalInertia = 0;
                    point = point || body.position;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.scale.x = scaleX;
                        part.scale.y = scaleY;
                        // scale vertices
                        Vertices.scale(part.vertices, scaleX, scaleY, point);
                        // update properties
                        part.axes = Axes.fromVertices(part.vertices);
                        part.area = Vertices.area(part.vertices);
                        Body.setMass(part, body.density * part.area);
                        // update inertia (requires vertices to be at origin)
                        Vertices.translate(part.vertices, {
                            x: -part.position.x,
                            y: -part.position.y
                        });
                        Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
                        Vertices.translate(part.vertices, {
                            x: part.position.x,
                            y: part.position.y
                        });
                        if (i > 0) {
                            totalArea += part.area;
                            totalInertia += part.inertia;
                        }
                        // scale position
                        part.position.x = point.x + (part.position.x - point.x) * scaleX;
                        part.position.y = point.y + (part.position.y - point.y) * scaleY;
                        // update bounds
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                    // handle parent body
                    if (body.parts.length > 1) {
                        body.area = totalArea;
                        if (!body.isStatic) {
                            Body.setMass(body, body.density * totalArea);
                            Body.setInertia(body, totalInertia);
                        }
                    }
                    // handle circles
                    if (body.circleRadius) {
                        if (scaleX === scaleY) body.circleRadius *= scaleX;
                        else // body is no longer a circle
                        body.circleRadius = null;
                    }
                };
                /**
     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
     * @method update
     * @param {body} body
     * @param {number} deltaTime
     * @param {number} timeScale
     * @param {number} correction
     */ Body.update = function(body, deltaTime, timeScale, correction) {
                    var deltaTimeSquared = Math.pow(deltaTime * timeScale * body.timeScale, 2);
                    // from the previous step
                    var frictionAir = 1 - body.frictionAir * timeScale * body.timeScale, velocityPrevX = body.position.x - body.positionPrev.x, velocityPrevY = body.position.y - body.positionPrev.y;
                    // update velocity with Verlet integration
                    body.velocity.x = velocityPrevX * frictionAir * correction + body.force.x / body.mass * deltaTimeSquared;
                    body.velocity.y = velocityPrevY * frictionAir * correction + body.force.y / body.mass * deltaTimeSquared;
                    body.positionPrev.x = body.position.x;
                    body.positionPrev.y = body.position.y;
                    body.position.x += body.velocity.x;
                    body.position.y += body.velocity.y;
                    // update angular velocity with Verlet integration
                    body.angularVelocity = (body.angle - body.anglePrev) * frictionAir * correction + body.torque / body.inertia * deltaTimeSquared;
                    body.anglePrev = body.angle;
                    body.angle += body.angularVelocity;
                    // track speed and acceleration
                    body.speed = Vector.magnitude(body.velocity);
                    body.angularSpeed = Math.abs(body.angularVelocity);
                    // transform the body geometry
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        Vertices.translate(part.vertices, body.velocity);
                        if (i > 0) {
                            part.position.x += body.velocity.x;
                            part.position.y += body.velocity.y;
                        }
                        if (body.angularVelocity !== 0) {
                            Vertices.rotate(part.vertices, body.angularVelocity, body.position);
                            Axes.rotate(part.axes, body.angularVelocity);
                            if (i > 0) Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
                        }
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Applies a force to a body from a given world-space position, including resulting torque.
     * @method applyForce
     * @param {body} body
     * @param {vector} position
     * @param {vector} force
     */ Body.applyForce = function(body, position, force) {
                    body.force.x += force.x;
                    body.force.y += force.y;
                    var offset = {
                        x: position.x - body.position.x,
                        y: position.y - body.position.y
                    };
                    body.torque += offset.x * force.y - offset.y * force.x;
                };
                /**
     * Returns the sums of the properties of all compound parts of the parent body.
     * @method _totalProperties
     * @private
     * @param {body} body
     * @return {}
     */ Body._totalProperties = function(body) {
                    // from equations at:
                    // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
                    // http://output.to/sideway/default.asp?qno=121100087
                    var properties = {
                        mass: 0,
                        area: 0,
                        inertia: 0,
                        centre: {
                            x: 0,
                            y: 0
                        }
                    };
                    // sum the properties of all compound parts of the parent body
                    for(var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++){
                        var part = body.parts[i], mass = part.mass !== Infinity ? part.mass : 1;
                        properties.mass += mass;
                        properties.area += part.area;
                        properties.inertia += part.inertia;
                        properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
                    }
                    properties.centre = Vector.div(properties.centre, properties.mass);
                    return properties;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a body starts sleeping (where `this` is the body).
    *
    * @event sleepStart
    * @this {body} The body that has started sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a body ends sleeping (where `this` is the body).
    *
    * @event sleepEnd
    * @this {body} The body that has ended sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "body"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Body"
     */ /**
     * An array of bodies that make up this body. 
     * The first body in the array must always be a self reference to the current body instance.
     * All bodies in the `parts` array together form a single rigid compound body.
     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
     * Parts themselves should never be added to a `World`, only the parent body should be.
     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
     *
     * @property parts
     * @type body[]
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * A self reference if the body is _not_ a part of another body.
     * Otherwise this is a reference to the body that this is a part of.
     * See `body.parts`.
     *
     * @property parent
     * @type body
     */ /**
     * A `Number` specifying the angle of the body, in radians.
     *
     * @property angle
     * @type number
     * @default 0
     */ /**
     * An array of `Vector` objects that specify the convex hull of the rigid body.
     * These should be provided about the origin `(0, 0)`. E.g.
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
     * The `Vector` objects are also augmented with additional properties required for efficient collision detection. 
     *
     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
     *
     * @property vertices
     * @type vector[]
     */ /**
     * A `Vector` that specifies the current world-space position of the body.
     *
     * @property position
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that holds the current scale values as set by `Body.setScale`.
     *
     * @property scale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
     *
     * @property force
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
     *
     * @property torque
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
     *
     * @readOnly
     * @property speed
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
     *
     * @readOnly
     * @property angularSpeed
     * @type number
     * @default 0
     */ /**
     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property velocity
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property angularVelocity
     * @type number
     * @default 0
     */ /**
     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
     *
     * @property isStatic
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
     *
     * @property isSensor
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
     *
     * @property isSleeping
     * @type boolean
     * @default false
     */ /**
     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
     *
     * @readOnly
     * @property motion
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
     *
     * @property sleepThreshold
     * @type number
     * @default 60
     */ /**
     * A `Number` that defines the density of the body, that is its mass per unit area.
     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
     *
     * @property density
     * @type number
     * @default 0.001
     */ /**
     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
     *
     * @property mass
     * @type number
     */ /**
     * A `Number` that defines the inverse mass of the body (`1 / mass`).
     * If you modify this value, you must also modify the `body.mass` property.
     *
     * @property inverseMass
     * @type number
     */ /**
     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
     *
     * @property inertia
     * @type number
     */ /**
     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
     * If you modify this value, you must also modify the `body.inertia` property.
     *
     * @property inverseInertia
     * @type number
     */ /**
     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
     *
     *     Math.max(bodyA.restitution, bodyB.restitution)
     *
     * @property restitution
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means that the body may slide indefinitely.
     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
     *
     * The effects of the value may be non-linear. 
     * High values may be unstable depending on the body.
     * The engine uses a Coulomb friction model including static and kinetic friction.
     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
     *
     *     Math.min(bodyA.friction, bodyB.friction)
     *
     * @property friction
     * @type number
     * @default 0.1
     */ /**
     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
     *
     * @property frictionStatic
     * @type number
     * @default 0.5
     */ /**
     * A `Number` that defines the air friction of the body (air resistance). 
     * A value of `0` means the body will never slow as it moves through space.
     * The higher the value, the faster a body slows when moving through space.
     * The effects of the value are non-linear. 
     *
     * @property frictionAir
     * @type number
     * @default 0.01
     */ /**
     * An `Object` that specifies the collision filtering properties of this body.
     *
     * Collisions between two bodies will obey the following rules:
     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
     *   they will always collide if the value is positive, and they will never collide
     *   if the value is negative.
     * - If the two bodies have different values of `collisionFilter.group` or if one
     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
     *
     * Each body belongs to a collision category, given by `collisionFilter.category`. This
     * value is used as a bit field and the category should have only one bit set, meaning that
     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
     * different collision categories available.
     *
     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
     * the categories it collides with (the value is the bitwise AND value of all these categories).
     *
     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
     * are both true.
     *
     * @property collisionFilter
     * @type object
     */ /**
     * An Integer `Number`, that specifies the collision group this body belongs to.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.group
     * @type object
     * @default 0
     */ /**
     * A bit field that specifies the collision category this body belongs to.
     * The category value should have only one bit set, for example `0x0001`.
     * This means there are up to 32 unique collision categories available.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.category
     * @type object
     * @default 1
     */ /**
     * A bit mask that specifies the collision categories this body may collide with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.mask
     * @type object
     * @default -1
     */ /**
     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
     *
     * @property slop
     * @type number
     * @default 0.05
     */ /**
     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
     *
     * @property timeScale
     * @type number
     * @default 1
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the body should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * Sets the opacity to use when rendering.
     *
     * @property render.opacity
     * @type number
     * @default 1
    */ /**
     * An `Object` that defines the sprite properties to use when rendering, if any.
     *
     * @property render.sprite
     * @type object
     */ /**
      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
      *
      * @property render.sprite.xOffset
      * @type number
      * @default 0
      */ /**
      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
      *
      * @property render.sprite.yOffset
      * @type number
      * @default 0
      */ /**
     * A hex color value that defines the fill color to use when rendering the body.
     *
     * @property render.fillColor
     * @type number
     */ /**
     * A value that defines the fill opacity to use when rendering the body.
     *
     * @property render.fillOpacity
     * @type number
     */ /**
     * A hex color value that defines the line color to use when rendering the body.
     *
     * @property render.lineColor
     * @type number
     */ /**
     * A value that defines the line opacity to use when rendering the body.
     *
     * @property render.lineOpacity
     * @type number
     */ /**
     * A `Number` that defines the line width to use when rendering the body outline.
     *
     * @property render.lineThickness
     * @type number
     */ /**
     * An array of unique axis vectors (edge normals) used for collision detection.
     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
     * They are constantly updated by `Body.update` during the simulation.
     *
     * @property axes
     * @type vector[]
     */ /**
     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
     *
     * @property area
     * @type string
     * @default 
     */ /**
     * A `Bounds` object that defines the AABB region for the body.
     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
     *
     * @property bounds
     * @type bounds
     */ /**
     * A reference to the Phaser Game Object this body belongs to, if any.
     *
     * @property gameObject
     * @type Phaser.GameObjects.GameObject
     */ /**
     * The center of mass of the Body.
     *
     * @property centerOfMass
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * The center of the body in pixel values.
     * Used by Phaser for texture aligment.
     *
     * @property centerOffset
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * Will this Body ignore World gravity during the Engine update?
     *
     * @property ignoreGravity
     * @type boolean
     * @default false
     */ /**
     * Scale the influence of World gravity when applied to this body.
     *
     * @property gravityScale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * Will this Body ignore Phaser Pointer input events?
     *
     * @property ignorePointer
     * @type boolean
     * @default false
     */ /**
     * A callback that is invoked when this Body starts colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked when this Body stops colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideEndCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked for the duration that this Body is colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideActiveCallback
     * @type function
     * @default null
     */ /**
     * A collision callback dictionary used by the `Body.setOnCollideWith` function.
     *
     * @property onCollideWith
     * @type object
     * @default null
     */ })();
        /***/ },
        /* 42 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the bottom coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetBottom
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The bottom coordinate of the bounds of the Game Object.
 */ var GetBottom = function(gameObject) {
                return gameObject.y + gameObject.height - gameObject.height * gameObject.originY;
            };
            module1.exports = GetBottom;
        /***/ },
        /* 43 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the left coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetLeft
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The left coordinate of the bounds of the Game Object.
 */ var GetLeft = function(gameObject) {
                return gameObject.x - gameObject.width * gameObject.originX;
            };
            module1.exports = GetLeft;
        /***/ },
        /* 44 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the right coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetRight
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The right coordinate of the bounds of the Game Object.
 */ var GetRight = function(gameObject) {
                return gameObject.x + gameObject.width - gameObject.width * gameObject.originX;
            };
            module1.exports = GetRight;
        /***/ },
        /* 45 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the top coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetTop
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The top coordinate of the bounds of the Game Object.
 */ var GetTop = function(gameObject) {
                return gameObject.y - gameObject.height * gameObject.originY;
            };
            module1.exports = GetTop;
        /***/ },
        /* 46 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then adds the given value to it.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueInc(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueInc
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to be added to the property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueInc = function(items, key, value, step, index, direction) {
                if (step === undefined) step = 0;
                if (index === undefined) index = 0;
                if (direction === undefined) direction = 1;
                var i;
                var t = 0;
                var end = items.length;
                if (direction === 1) //  Start to End
                for(i = index; i < end; i++){
                    items[i][key] += value + t * step;
                    t++;
                }
                else //  End to Start
                for(i = index; i >= 0; i--){
                    items[i][key] += value + t * step;
                    t++;
                }
                return items;
            };
            module1.exports = PropertyValueInc;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetPoint = __webpack_require__(307);
            var GetPoints = __webpack_require__(172);
            var GEOM_CONST = __webpack_require__(56);
            var Random = __webpack_require__(173);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * Defines a Line segment, a part of a line between two endpoints.
 *
 * @class Line
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - The x coordinate of the lines starting point.
 * @param {number} [y1=0] - The y coordinate of the lines starting point.
 * @param {number} [x2=0] - The x coordinate of the lines ending point.
 * @param {number} [y2=0] - The y coordinate of the lines ending point.
 */ var Line = new Class({
                initialize: function Line(x1, y1, x2, y2) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.LINE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Line#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.LINE;
                    /**
         * The x coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#x1
         * @type {number}
         * @since 3.0.0
         */ this.x1 = x1;
                    /**
         * The y coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#y1
         * @type {number}
         * @since 3.0.0
         */ this.y1 = y1;
                    /**
         * The x coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#x2
         * @type {number}
         * @since 3.0.0
         */ this.x2 = x2;
                    /**
         * The y coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#y2
         * @type {number}
         * @since 3.0.0
         */ this.y2 = y2;
                },
                /**
     * Get a point on a line that's a given percentage along its length.
     *
     * @method Phaser.Geom.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
     * @param {(Phaser.Geom.Point|object)} [output] - An optional point, or point-like object, to store the coordinates of the point on the line.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point on the line.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Get a number of points along a line's length.
     *
     * Provide a `quantity` to get an exact number of points along the line.
     *
     * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
     * providing a `stepRate`.
     *
     * @method Phaser.Geom.Line#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
     * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
     * @param {(array|Phaser.Geom.Point[])} [output] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Get a random Point on the Line.
     *
     * @method Phaser.Geom.Line#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - An instance of a Point to be modified.
     *
     * @return {Phaser.Geom.Point} A random Point on the Line.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Set new coordinates for the line endpoints.
     *
     * @method Phaser.Geom.Line#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - The x coordinate of the lines starting point.
     * @param {number} [y1=0] - The y coordinate of the lines starting point.
     * @param {number} [x2=0] - The x coordinate of the lines ending point.
     * @param {number} [y2=0] - The y coordinate of the lines ending point.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    this.x1 = x1;
                    this.y1 = y1;
                    this.x2 = x2;
                    this.y2 = y2;
                    return this;
                },
                /**
     * Returns a Vector2 object that corresponds to the start of this Line.
     *
     * @method Phaser.Geom.Line#getPointA
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the start of this Line.
     */ getPointA: function(vec2) {
                    if (vec2 === undefined) vec2 = new Vector2();
                    vec2.set(this.x1, this.y1);
                    return vec2;
                },
                /**
     * Returns a Vector2 object that corresponds to the end of this Line.
     *
     * @method Phaser.Geom.Line#getPointB
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the end of this Line.
     */ getPointB: function(vec2) {
                    if (vec2 === undefined) vec2 = new Vector2();
                    vec2.set(this.x2, this.y2);
                    return vec2;
                },
                /**
     * The left position of the Line.
     *
     * @name Phaser.Geom.Line#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return Math.min(this.x1, this.x2);
                    },
                    set: function(value) {
                        if (this.x1 <= this.x2) this.x1 = value;
                        else this.x2 = value;
                    }
                },
                /**
     * The right position of the Line.
     *
     * @name Phaser.Geom.Line#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return Math.max(this.x1, this.x2);
                    },
                    set: function(value) {
                        if (this.x1 > this.x2) this.x1 = value;
                        else this.x2 = value;
                    }
                },
                /**
     * The top position of the Line.
     *
     * @name Phaser.Geom.Line#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return Math.min(this.y1, this.y2);
                    },
                    set: function(value) {
                        if (this.y1 <= this.y2) this.y1 = value;
                        else this.y2 = value;
                    }
                },
                /**
     * The bottom position of the Line.
     *
     * @name Phaser.Geom.Line#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2);
                    },
                    set: function(value) {
                        if (this.y1 > this.y2) this.y1 = value;
                        else this.y2 = value;
                    }
                }
            });
            module1.exports = Line;
        /***/ },
        /* 48 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the fillStyle on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the fill style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the fill style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var FillStyleCanvas = function(ctx, src, altColor, altAlpha) {
                var fillColor = altColor ? altColor : src.fillColor;
                var fillAlpha = altAlpha ? altAlpha : src.fillAlpha;
                var red = (fillColor & 0xFF0000) >>> 16;
                var green = (fillColor & 0xFF00) >>> 8;
                var blue = fillColor & 0xFF;
                ctx.fillStyle = "rgba(" + red + "," + green + "," + blue + "," + fillAlpha + ")";
            };
            module1.exports = FillStyleCanvas;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A MultiFile is a special kind of parent that contains two, or more, Files as children and looks after
 * the loading and processing of them all. It is commonly extended and used as a base class for file types such as AtlasJSON or BitmapFont.
 *
 * You shouldn't create an instance of a MultiFile directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class MultiFile
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {string} type - The file type string for sorting within the Loader.
 * @param {string} key - The key of the file within the loader.
 * @param {Phaser.Loader.File[]} files - An array of Files that make-up this MultiFile.
 */ var MultiFile = new Class({
                initialize: function MultiFile(loader, type, key, files) {
                    var finalFiles = [];
                    //  Clean out any potential 'null' or 'undefined' file entries
                    files.forEach(function(file) {
                        if (file) finalFiles.push(file);
                    });
                    /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.MultiFile#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.7.0
         */ this.loader = loader;
                    /**
         * The file type string for sorting within the Loader.
         *
         * @name Phaser.Loader.MultiFile#type
         * @type {string}
         * @since 3.7.0
         */ this.type = type;
                    /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.MultiFile#key
         * @type {string}
         * @since 3.7.0
         */ this.key = key;
                    /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.MultiFile#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = loader.multiKeyIndex++;
                    /**
         * Array of files that make up this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#files
         * @type {Phaser.Loader.File[]}
         * @since 3.7.0
         */ this.files = finalFiles;
                    /**
         * The completion status of this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#complete
         * @type {boolean}
         * @default false
         * @since 3.7.0
         */ this.complete = false;
                    /**
         * The number of files to load.
         *
         * @name Phaser.Loader.MultiFile#pending
         * @type {number}
         * @since 3.7.0
         */ this.pending = finalFiles.length;
                    /**
         * The number of files that failed to load.
         *
         * @name Phaser.Loader.MultiFile#failed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.failed = 0;
                    /**
         * A storage container for transient data that the loading files need.
         *
         * @name Phaser.Loader.MultiFile#config
         * @type {any}
         * @since 3.7.0
         */ this.config = {};
                    /**
         * A reference to the Loaders baseURL at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#baseURL
         * @type {string}
         * @since 3.20.0
         */ this.baseURL = loader.baseURL;
                    /**
         * A reference to the Loaders path at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#path
         * @type {string}
         * @since 3.20.0
         */ this.path = loader.path;
                    /**
         * A reference to the Loaders prefix at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#prefix
         * @type {string}
         * @since 3.20.0
         */ this.prefix = loader.prefix;
                    //  Link the files
                    for(var i = 0; i < finalFiles.length; i++)finalFiles[i].multiFile = this;
                },
                /**
     * Checks if this MultiFile is ready to process its children or not.
     *
     * @method Phaser.Loader.MultiFile#isReadyToProcess
     * @since 3.7.0
     *
     * @return {boolean} `true` if all children of this MultiFile have loaded, otherwise `false`.
     */ isReadyToProcess: function() {
                    return this.pending === 0 && this.failed === 0 && !this.complete;
                },
                /**
     * Adds another child to this MultiFile, increases the pending count and resets the completion status.
     *
     * @method Phaser.Loader.MultiFile#addToMultiFile
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} files - The File to add to this MultiFile.
     *
     * @return {Phaser.Loader.MultiFile} This MultiFile instance.
     */ addToMultiFile: function(file) {
                    this.files.push(file);
                    file.multiFile = this;
                    this.pending++;
                    this.complete = false;
                    return this;
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.MultiFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) this.pending--;
                },
                /**
     * Called by each File that fails to load.
     *
     * @method Phaser.Loader.MultiFile#onFileFailed
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has failed to load.
     */ onFileFailed: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) this.failed++;
                }
            });
            module1.exports = MultiFile;
        /***/ },
        /* 50 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points).
 *
 * @function Phaser.Math.Distance.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var DistanceBetween = function(x1, y1, x2, y2) {
                var dx = x1 - x2;
                var dy = y1 - y2;
                return Math.sqrt(dx * dx + dy * dy);
            };
            module1.exports = DistanceBetween;
        /***/ },
        /* 51 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Events
 */ module1.exports = {
                BOOT: __webpack_require__(922),
                DESTROY: __webpack_require__(923),
                DRAG_END: __webpack_require__(924),
                DRAG_ENTER: __webpack_require__(925),
                DRAG: __webpack_require__(926),
                DRAG_LEAVE: __webpack_require__(927),
                DRAG_OVER: __webpack_require__(928),
                DRAG_START: __webpack_require__(929),
                DROP: __webpack_require__(930),
                GAME_OUT: __webpack_require__(931),
                GAME_OVER: __webpack_require__(932),
                GAMEOBJECT_DOWN: __webpack_require__(933),
                GAMEOBJECT_DRAG_END: __webpack_require__(934),
                GAMEOBJECT_DRAG_ENTER: __webpack_require__(935),
                GAMEOBJECT_DRAG: __webpack_require__(936),
                GAMEOBJECT_DRAG_LEAVE: __webpack_require__(937),
                GAMEOBJECT_DRAG_OVER: __webpack_require__(938),
                GAMEOBJECT_DRAG_START: __webpack_require__(939),
                GAMEOBJECT_DROP: __webpack_require__(940),
                GAMEOBJECT_MOVE: __webpack_require__(941),
                GAMEOBJECT_OUT: __webpack_require__(942),
                GAMEOBJECT_OVER: __webpack_require__(943),
                GAMEOBJECT_POINTER_DOWN: __webpack_require__(944),
                GAMEOBJECT_POINTER_MOVE: __webpack_require__(945),
                GAMEOBJECT_POINTER_OUT: __webpack_require__(946),
                GAMEOBJECT_POINTER_OVER: __webpack_require__(947),
                GAMEOBJECT_POINTER_UP: __webpack_require__(948),
                GAMEOBJECT_POINTER_WHEEL: __webpack_require__(949),
                GAMEOBJECT_UP: __webpack_require__(950),
                GAMEOBJECT_WHEEL: __webpack_require__(951),
                MANAGER_BOOT: __webpack_require__(952),
                MANAGER_PROCESS: __webpack_require__(953),
                MANAGER_UPDATE: __webpack_require__(954),
                POINTER_DOWN: __webpack_require__(955),
                POINTER_DOWN_OUTSIDE: __webpack_require__(956),
                POINTER_MOVE: __webpack_require__(957),
                POINTER_OUT: __webpack_require__(958),
                POINTER_OVER: __webpack_require__(959),
                POINTER_UP: __webpack_require__(960),
                POINTER_UP_OUTSIDE: __webpack_require__(961),
                POINTER_WHEEL: __webpack_require__(962),
                POINTERLOCK_CHANGE: __webpack_require__(963),
                PRE_UPDATE: __webpack_require__(964),
                SHUTDOWN: __webpack_require__(965),
                START: __webpack_require__(966),
                UPDATE: __webpack_require__(967)
            };
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetTop = function(gameObject, value) {
                gameObject.y = value + gameObject.height * gameObject.originY;
                return gameObject;
            };
            module1.exports = SetTop;
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetLeft = function(gameObject, value) {
                gameObject.x = value + gameObject.width * gameObject.originX;
                return gameObject;
            };
            module1.exports = SetLeft;
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetRight = function(gameObject, value) {
                gameObject.x = value - gameObject.width + gameObject.width * gameObject.originX;
                return gameObject;
            };
            module1.exports = SetRight;
        /***/ },
        /* 55 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the bottom of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetBottom = function(gameObject, value) {
                gameObject.y = value - gameObject.height + gameObject.height * gameObject.originY;
                return gameObject;
            };
            module1.exports = SetBottom;
        /***/ },
        /* 56 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GEOM_CONST = {
                /**
     * A Circle Geometry object type.
     * 
     * @name Phaser.Geom.CIRCLE
     * @type {number}
     * @since 3.19.0
     */ CIRCLE: 0,
                /**
     * An Ellipse Geometry object type.
     * 
     * @name Phaser.Geom.ELLIPSE
     * @type {number}
     * @since 3.19.0
     */ ELLIPSE: 1,
                /**
     * A Line Geometry object type.
     * 
     * @name Phaser.Geom.LINE
     * @type {number}
     * @since 3.19.0
     */ LINE: 2,
                /**
     * A Point Geometry object type.
     * 
     * @name Phaser.Geom.POINT
     * @type {number}
     * @since 3.19.0
     */ POINT: 3,
                /**
     * A Polygon Geometry object type.
     * 
     * @name Phaser.Geom.POLYGON
     * @type {number}
     * @since 3.19.0
     */ POLYGON: 4,
                /**
     * A Rectangle Geometry object type.
     * 
     * @name Phaser.Geom.RECTANGLE
     * @type {number}
     * @since 3.19.0
     */ RECTANGLE: 5,
                /**
     * A Triangle Geometry object type.
     * 
     * @name Phaser.Geom.TRIANGLE
     * @type {number}
     * @since 3.19.0
     */ TRIANGLE: 6
            };
            module1.exports = GEOM_CONST;
        /***/ },
        /* 57 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if a given point is inside a Rectangle's bounds.
 *
 * @function Phaser.Geom.Rectangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
 */ var Contains = function(rect, x, y) {
                if (rect.width <= 0 || rect.height <= 0) return false;
                return rect.x <= x && rect.x + rect.width >= x && rect.y <= y && rect.y + rect.height >= y;
            };
            module1.exports = Contains;
        /***/ },
        /* 58 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DeepCopy = __webpack_require__(175);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(374);
            var GetFastValue = __webpack_require__(2);
            var Matrix4 = __webpack_require__(69);
            var RendererEvents = __webpack_require__(91);
            var RenderTarget = __webpack_require__(141);
            var Utils = __webpack_require__(12);
            var WebGLShader = __webpack_require__(375);
            /**
 * @classdesc
 * The `WebGLPipeline` is a base class used by all of the core Phaser pipelines.
 *
 * It describes the way elements will be rendered in WebGL. Internally, it handles
 * compiling the shaders, creating vertex buffers, assigning primitive topology and
 * binding vertex attributes, all based on the given configuration data.
 *
 * The pipeline is configured by passing in a `WebGLPipelineConfig` object. Please
 * see the documentation for this type to fully understand the configuration options
 * available to you.
 *
 * Usually, you would not extend from this class directly, but would instead extend
 * from one of the core pipelines, such as the Multi Pipeline.
 *
 * The pipeline flow per render-step is as follows:
 *
 * 1) onPreRender - called once at the start of the render step
 * 2) onRender - call for each Scene Camera that needs to render (so can be multiple times per render step)
 * 3) Internal flow:
 * 3a)   bind (only called if a Game Object is using this pipeline and it's not currently active)
 * 3b)   onBind (called for every Game Object that uses this pipeline)
 * 3c)   flush (can be called by a Game Object, internal method or from outside by changing pipeline)
 * 4) onPostRender - called once at the end of the render step
 *
 * @class WebGLPipeline
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
 */ var WebGLPipeline = new Class({
                Extends: EventEmitter,
                initialize: function WebGLPipeline(config) {
                    EventEmitter.call(this);
                    var game = config.game;
                    var renderer = game.renderer;
                    var gl = renderer.gl;
                    /**
         * Name of the pipeline. Used for identification and setting from Game Objects.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, "name", "WebGLPipeline");
                    /**
         * The Phaser Game instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The WebGL Renderer instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.0.0
         */ this.renderer = renderer;
                    /**
         * A reference to the WebGL Pipeline Manager.
         *
         * This is initially undefined and only set when this pipeline is added
         * to the manager.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#manager
         * @type {?Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.manager;
                    /**
         * The WebGL context this WebGL Pipeline uses.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#gl
         * @type {WebGLRenderingContext}
         * @since 3.0.0
         */ this.gl = gl;
                    /**
         * The canvas which this WebGL Pipeline renders to.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#view
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.view = game.canvas;
                    /**
         * Width of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * Height of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The current number of vertices that have been added to the pipeline batch.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.vertexCount = 0;
                    /**
         * The total number of vertices that this pipeline batch can hold before it will flush.
         *
         * This defaults to `renderer batchSize * 6`, where `batchSize` is defined in the Renderer Game Config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCapacity
         * @type {number}
         * @since 3.0.0
         */ this.vertexCapacity = 0;
                    /**
         * Raw byte buffer of vertices.
         *
         * Either set via the config object `vertices` property, or generates a new Array Buffer of
         * size `vertexCapacity * vertexSize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexData
         * @type {ArrayBuffer}
         * @readonly
         * @since 3.0.0
         */ this.vertexData;
                    /**
         * The WebGLBuffer that holds the vertex data.
         *
         * Created from the `vertexData` ArrayBuffer. If `vertices` are set in the config, a `STATIC_DRAW` buffer
         * is created. If not, a `DYNAMIC_DRAW` buffer is created.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexBuffer
         * @type {WebGLBuffer}
         * @readonly
         * @since 3.0.0
         */ this.vertexBuffer;
                    /**
         * The primitive topology which the pipeline will use to submit draw calls.
         *
         * Defaults to GL_TRIANGLES if not otherwise set in the config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#topology
         * @type {GLenum}
         * @since 3.0.0
         */ this.topology = GetFastValue(config, "topology", gl.TRIANGLES);
                    /**
         * Uint8 view to the `vertexData` ArrayBuffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#bytes
         * @type {Uint8Array}
         * @since 3.0.0
         */ this.bytes;
                    /**
         * Float32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewF32
         * @type {Float32Array}
         * @since 3.0.0
         */ this.vertexViewF32;
                    /**
         * Uint32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewU32
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.vertexViewU32;
                    /**
         * Indicates if the current pipeline is active, or not.
         *
         * Toggle this property to enable or disable a pipeline from rendering anything.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = true;
                    /**
         * Holds the most recently assigned texture unit.
         *
         * Treat this value as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentUnit
         * @type {number}
         * @since 3.50.0
         */ this.currentUnit = 0;
                    /**
         * Some pipelines require the forced use of texture zero (like the light pipeline).
         *
         * This property should be set when that is the case.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#forceZero
         * @type {boolean}
         * @since 3.50.0
         */ this.forceZero = GetFastValue(config, "forceZero", false);
                    /**
         * Indicates if this pipeline has booted or not.
         *
         * A pipeline boots only when the Game instance itself, and all associated systems, is
         * fully ready.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#hasBooted
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.hasBooted = false;
                    /**
         * Indicates if this is a Post FX Pipeline, or not.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#isPostFX
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isPostFX = false;
                    /**
         * An array of RenderTarget instances that belong to this pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderTargets
         * @type {Phaser.Renderer.WebGL.RenderTarget[]}
         * @since 3.50.0
         */ this.renderTargets = [];
                    /**
         * A reference to the currently bound Render Target instance from the `WebGLPipeline.renderTargets` array.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentRenderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.currentRenderTarget;
                    /**
         * An array of all the WebGLShader instances that belong to this pipeline.
         *
         * Shaders manage their own attributes and uniforms, but share the same vertex data buffer,
         * which belongs to this pipeline.
         *
         * Shaders are set in a call to the `setShadersFromConfig` method, which happens automatically,
         * but can also be called at any point in your game. See the method documentation for details.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#shaders
         * @type {Phaser.Renderer.WebGL.WebGLShader[]}
         * @since 3.50.0
         */ this.shaders = [];
                    /**
         * A reference to the currently bound WebGLShader instance from the `WebGLPipeline.shaders` array.
         *
         * For lots of pipelines, this is the only shader, so it is a quick way to reference it without
         * an array look-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.currentShader;
                    /**
         * The Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                    /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                    /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                    /**
         * The configuration object that was used to create this pipeline.
         *
         * Treat this object as 'read only', because changing it post-creation will not
         * impact this pipeline in any way. However, it is used internally for cloning
         * and post-boot set-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#config
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig}
         * @since 3.50.0
         */ this.config = config;
                    /**
         * Has the GL Context been reset to the Phaser defaults since the last time
         * this pipeline was bound? This is set automatically when the Pipeline Manager
         * resets itself, usually after handing off to a 3rd party renderer like Spine.
         *
         * You should treat this property as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#glReset
         * @type {boolean}
         * @since 3.53.0
         */ this.glReset = false;
                },
                /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place. You can perform any final tasks that the
     * pipeline may need, that relies on game systems such as the Texture Manager being ready.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#boot
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BOOT
     * @since 3.11.0
     */ boot: function() {
                    var i;
                    var gl = this.gl;
                    var config = this.config;
                    var renderer = this.renderer;
                    if (!this.isPostFX) this.projectionMatrix = new Matrix4().identity();
                    //  Create the Render Targets
                    var renderTargets = this.renderTargets;
                    var targets = GetFastValue(config, "renderTarget", false);
                    //  If boolean, set to number = 1
                    if (typeof targets === "boolean" && targets) targets = 1;
                    var width = renderer.width;
                    var height = renderer.height;
                    if (typeof targets === "number") //  Create this many default RTs
                    for(i = 0; i < targets; i++)renderTargets.push(new RenderTarget(renderer, width, height, 1, 0, true));
                    else if (Array.isArray(targets)) for(i = 0; i < targets.length; i++){
                        var scale = GetFastValue(targets[i], "scale", 1);
                        var minFilter = GetFastValue(targets[i], "minFilter", 0);
                        var autoClear = GetFastValue(targets[i], "autoClear", 1);
                        renderTargets.push(new RenderTarget(renderer, width, height, scale, minFilter, autoClear));
                    }
                    if (renderTargets.length) //  Default to the first one in the array
                    this.currentRenderTarget = renderTargets[0];
                    //  Create the Shaders
                    this.setShadersFromConfig(config);
                    //  Which shader has the largest vertex size?
                    var shaders = this.shaders;
                    var vertexSize = 0;
                    for(i = 0; i < shaders.length; i++)if (shaders[i].vertexSize > vertexSize) vertexSize = shaders[i].vertexSize;
                    var batchSize = GetFastValue(config, "batchSize", renderer.config.batchSize);
                    //  * 6 because there are 6 vertices in a quad and 'batchSize' represents the quantity of quads in the batch
                    this.vertexCapacity = batchSize * 6;
                    var data = new ArrayBuffer(this.vertexCapacity * vertexSize);
                    this.vertexData = data;
                    this.bytes = new Uint8Array(data);
                    this.vertexViewF32 = new Float32Array(data);
                    this.vertexViewU32 = new Uint32Array(data);
                    var configVerts = GetFastValue(config, "vertices", null);
                    if (configVerts) {
                        this.vertexViewF32.set(configVerts);
                        this.vertexBuffer = renderer.createVertexBuffer(data, gl.STATIC_DRAW);
                    } else this.vertexBuffer = renderer.createVertexBuffer(data.byteLength, gl.DYNAMIC_DRAW);
                    //  Set-up shaders
                    this.setVertexBuffer();
                    for(i = shaders.length - 1; i >= 0; i--)shaders[i].rebind();
                    this.hasBooted = true;
                    renderer.on(RendererEvents.RESIZE, this.resize, this);
                    renderer.on(RendererEvents.PRE_RENDER, this.onPreRender, this);
                    renderer.on(RendererEvents.RENDER, this.onRender, this);
                    renderer.on(RendererEvents.POST_RENDER, this.onPostRender, this);
                    this.emit(Events.BOOT, this);
                    this.onBoot();
                },
                /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBoot
     * @since 3.50.0
     */ onBoot: function() {},
                /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured. It's also called if the renderer
     * changes size.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onResize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     */ onResize: function() {},
                /**
     * Sets the currently active shader within this pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShader
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} shader - The shader to set as being current.
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     *
     * @return {this} This WebGLPipeline instance.
     */ setShader: function(shader, setAttributes) {
                    var renderer = this.renderer;
                    if (shader !== this.currentShader || renderer.currentProgram !== this.currentShader.program) {
                        this.flush();
                        renderer.resetTextures();
                        var wasBound = this.setVertexBuffer();
                        if (wasBound && !setAttributes) setAttributes = true;
                        shader.bind(setAttributes, false);
                        this.currentShader = shader;
                    }
                    return this;
                },
                /**
     * Searches all shaders in this pipeline for one matching the given name, then returns it.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#getShaderByName
     * @since 3.50.0
     *
     * @param {string} name - The index of the shader to set.
     *
     * @return {Phaser.Renderer.WebGL.WebGLShader} The WebGLShader instance, if found.
     */ getShaderByName: function(name) {
                    var shaders = this.shaders;
                    for(var i = 0; i < shaders.length; i++){
                        if (shaders[i].name === name) return shaders[i];
                    }
                },
                /**
     * Destroys all shaders currently set in the `WebGLPipeline.shaders` array and then parses the given
     * `config` object, extracting the shaders from it, creating `WebGLShader` instances and finally
     * setting them into the `shaders` array of this pipeline.
     *
     * This is a destructive process. Be very careful when you call it, should you need to.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShadersFromConfig
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setShadersFromConfig: function(config) {
                    var i;
                    var shaders = this.shaders;
                    var renderer = this.renderer;
                    for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                    var vName = "vertShader";
                    var fName = "fragShader";
                    var aName = "attributes";
                    var defaultVertShader = GetFastValue(config, vName, null);
                    var defaultFragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(config, fName, null), renderer.maxTextures);
                    var defaultAttribs = GetFastValue(config, aName, null);
                    var configShaders = GetFastValue(config, "shaders", []);
                    var len = configShaders.length;
                    if (len === 0) {
                        if (defaultVertShader && defaultFragShader) this.shaders = [
                            new WebGLShader(this, "default", defaultVertShader, defaultFragShader, DeepCopy(defaultAttribs))
                        ];
                    } else {
                        var newShaders = [];
                        for(i = 0; i < len; i++){
                            var shaderEntry = configShaders[i];
                            var name = GetFastValue(shaderEntry, "name", "default");
                            var vertShader = GetFastValue(shaderEntry, vName, defaultVertShader);
                            var fragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(shaderEntry, fName, defaultFragShader), renderer.maxTextures);
                            var attributes = GetFastValue(shaderEntry, aName, defaultAttribs);
                            if (vertShader && fragShader) newShaders.push(new WebGLShader(this, name, vertShader, fragShader, DeepCopy(attributes)));
                        }
                        this.shaders = newShaders;
                    }
                    if (this.shaders.length === 0) console.warn("Pipeline: " + this.name + " - Invalid shader config");
                    else this.currentShader = this.shaders[0];
                    return this;
                },
                /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setGameObject
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                    if (frame === undefined) frame = gameObject.frame;
                    this.currentUnit = this.renderer.setTextureSource(frame.source);
                    return this.currentUnit;
                },
                /**
     * Check if the current batch of vertices is full.
     *
     * You can optionally provide an `amount` parameter. If given, it will check if the batch
     * needs to flush _if_ the `amount` is added to it. This allows you to test if you should
     * flush before populating the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#shouldFlush
     * @since 3.0.0
     *
     * @param {number} [amount=0] - Will the batch need to flush if this many vertices are added to it?
     *
     * @return {boolean} `true` if the current batch should be flushed, otherwise `false`.
     */ shouldFlush: function(amount) {
                    if (amount === undefined) amount = 0;
                    return this.vertexCount + amount > this.vertexCapacity;
                },
                /**
     * Resizes the properties used to describe the viewport.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#resize
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ resize: function(width, height) {
                    if (width !== this.width || height !== this.height) this.flush();
                    this.width = width;
                    this.height = height;
                    var targets = this.renderTargets;
                    for(var i = 0; i < targets.length; i++)targets[i].resize(width, height);
                    this.setProjectionMatrix(width, height);
                    this.emit(Events.RESIZE, width, height, this);
                    this.onResize(width, height);
                    return this;
                },
                /**
     * Adjusts this pipelines ortho Projection Matrix to use the given dimensions
     * and resets the `uProjectionMatrix` uniform on all bound shaders.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setProjectionMatrix: function(width, height) {
                    var projectionMatrix = this.projectionMatrix;
                    //  Because not all pipelines have them
                    if (!projectionMatrix) return this;
                    this.projectionWidth = width;
                    this.projectionHeight = height;
                    projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                    var shaders = this.shaders;
                    var name = "uProjectionMatrix";
                    for(var i = 0; i < shaders.length; i++){
                        var shader = shaders[i];
                        if (shader.hasUniform(name)) {
                            shader.resetUniform(name);
                            shader.setMatrix4fv(name, false, projectionMatrix.val, shader);
                        }
                    }
                    return this;
                },
                /**
     * Adjusts this pipelines ortho Projection Matrix to match that of the global
     * WebGL Renderer Projection Matrix.
     *
     * This method is called automatically by the Pipeline Manager when this
     * pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#updateProjectionMatrix
     * @since 3.50.0
     */ updateProjectionMatrix: function() {
                    if (this.projectionMatrix) {
                        var globalWidth = this.renderer.projectionWidth;
                        var globalHeight = this.renderer.projectionHeight;
                        if (this.projectionWidth !== globalWidth || this.projectionHeight !== globalHeight) this.setProjectionMatrix(globalWidth, globalHeight);
                    }
                },
                /**
     * This method is called every time the Pipeline Manager makes this pipeline the currently active one.
     *
     * It binds the resources and shader needed for this pipeline, including setting the vertex buffer
     * and attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BIND
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {this} This WebGLPipeline instance.
     */ bind: function(currentShader) {
                    if (currentShader === undefined) currentShader = this.currentShader;
                    if (this.glReset) return this.rebind(currentShader);
                    var wasBound = this.setVertexBuffer();
                    currentShader.bind(wasBound);
                    this.currentShader = currentShader;
                    this.emit(Events.BIND, this, currentShader);
                    this.onActive(currentShader);
                    return this;
                },
                /**
     * This method is called every time the Pipeline Manager rebinds this pipeline.
     *
     * It resets all shaders this pipeline uses, setting their attributes again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#rebind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#REBIND
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {this} This WebGLPipeline instance.
     */ rebind: function(currentShader) {
                    this.setVertexBuffer();
                    var shaders = this.shaders;
                    //  Loop in reverse, so the first shader in the array is left as being bound
                    for(var i = shaders.length - 1; i >= 0; i--){
                        var shader = shaders[i].rebind();
                        if (!currentShader || shader === currentShader) this.currentShader = shader;
                    }
                    this.emit(Events.REBIND, this.currentShader);
                    this.onActive(this.currentShader);
                    this.onRebind();
                    this.glReset = false;
                    return this;
                },
                /**
     * Binds the vertex buffer to be the active ARRAY_BUFFER on the WebGL context.
     *
     * It first checks to see if it's already set as the active buffer and only
     * binds itself if not.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setVertexBuffer
     * @since 3.50.0
     *
     * @return {boolean} `true` if the vertex buffer was bound, or `false` if it was already bound.
     */ setVertexBuffer: function() {
                    var gl = this.gl;
                    var buffer = this.vertexBuffer;
                    if (gl.getParameter(gl.ARRAY_BUFFER_BINDING) !== buffer) {
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        return true;
                    }
                    return false;
                },
                /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch. When this is called, the
     * renderer has just performed a flush. It will bind the current render target, if any are set
     * and finally call the `onPreBatch` hook.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#preBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ preBatch: function(gameObject) {
                    if (this.currentRenderTarget) this.currentRenderTarget.bind();
                    this.onPreBatch(gameObject);
                    return this;
                },
                /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. When this is called, the
     * renderer has just performed a flush.
     *
     * It calls the `onDraw` hook followed by the `onPostBatch` hook, which can be used to perform
     * additional Post FX Pipeline processing.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#postBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ postBatch: function(gameObject) {
                    this.onDraw(this.currentRenderTarget);
                    this.onPostBatch(gameObject);
                    return this;
                },
                /**
     * This method is only used by Post FX Pipelines and those that extend from them.
     *
     * This method is called every time the `postBatch` method is called and is passed a
     * reference to the current render target.
     *
     * At the very least a Post FX Pipeline should call `this.bindAndDraw(renderTarget)`,
     * however, you can do as much additional processing as you like in this method if
     * you override it from within your own pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} renderTarget - The Render Target.
     */ onDraw: function() {},
                /**
     * This method is called every time the Pipeline Manager deactivates this pipeline, swapping from
     * it to another one. This happens after a call to `flush` and before the new pipeline is bound.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#unbind
     * @since 3.50.0
     */ unbind: function() {
                    if (this.currentRenderTarget) this.currentRenderTarget.unbind();
                },
                /**
     * Uploads the vertex data and emits a draw call for the current batch of vertices.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#flush
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
     * @since 3.0.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     *
     * @return {this} This WebGLPipeline instance.
     */ flush: function(isPostFlush) {
                    if (isPostFlush === undefined) isPostFlush = false;
                    if (this.vertexCount > 0) {
                        this.emit(Events.BEFORE_FLUSH, this, isPostFlush);
                        this.onBeforeFlush(isPostFlush);
                        var gl = this.gl;
                        var vertexCount = this.vertexCount;
                        var vertexSize = this.currentShader.vertexSize;
                        if (this.active) {
                            this.setVertexBuffer();
                            if (vertexCount === this.vertexCapacity) gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.DYNAMIC_DRAW);
                            else gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                            gl.drawArrays(this.topology, 0, vertexCount);
                        }
                        this.vertexCount = 0;
                        this.emit(Events.AFTER_FLUSH, this, isPostFlush);
                        this.onAfterFlush(isPostFlush);
                    }
                    return this;
                },
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the Pipeline Manager makes this the active pipeline. It is called
     * at the end of the `WebGLPipeline.bind` method, after the current shader has been set. The current
     * shader is passed to this hook.
     *
     * For example, if a display list has 3 Sprites in it that all use the same pipeline, this hook will
     * only be called for the first one, as the 2nd and 3rd Sprites do not cause the pipeline to be changed.
     *
     * If you need to listen for that event instead, use the `onBind` hook.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onActive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as current.
     */ onActive: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time a **Game Object** asks the Pipeline Manager to use this pipeline,
     * even if the pipeline is already active.
     *
     * Unlike the `onActive` method, which is only called when the Pipeline Manager makes this pipeline
     * active, this hook is called for every Game Object that requests use of this pipeline, allowing you to
     * perform per-object set-up, such as loading shader uniform data.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBind
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBind: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called when the Pipeline Manager needs to rebind this pipeline. This happens after a
     * pipeline has been cleared, usually when passing control over to a 3rd party WebGL library, like Spine,
     * and then returing to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRebind
     * @since 3.50.0
     */ onRebind: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the `batchQuad` or `batchTri` methods are called. If this was
     * as a result of a Game Object, then the Game Object reference is passed to this hook too.
     *
     * This hook is called _after_ the quad (or tri) has been added to the batch, so you can safely
     * call 'flush' from within this.
     *
     * Note that Game Objects may call `batchQuad` or `batchTri` multiple times for a single draw,
     * for example the Graphics Game Object.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately before a **Game Object** is about to add itself to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPreBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after a **Game Object** has been added to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPostBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called once per frame, right before anything has been rendered, but after the canvas
     * has been cleared. If this pipeline has a render target, it will also have been cleared by this point.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreRender
     * @since 3.50.0
     */ onPreRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, by every Camera in a Scene that wants to render.
     *
     * It is called at the start of the rendering process, before anything has been drawn to the Camera.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRender
     * @since 3.50.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, after all rendering has happened and snapshots have been taken.
     *
     * It is called at the very end of the rendering process, once all Cameras, for all Scenes, have
     * been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostRender
     * @since 3.50.0
     */ onPostRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time this pipeline is asked to flush its batch.
     *
     * It is called immediately before the `gl.bufferData` and `gl.drawArrays` calls are made, so you can
     * perform any final pre-render modifications. To apply changes post-render, see `onAfterFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBeforeFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onBeforeFlush: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after this pipeline has finished flushing its batch.
     *
     * It is called after the `gl.drawArrays` call.
     *
     * You can perform additional post-render effects, but be careful not to call `flush`
     * on this pipeline from within this method, or you'll cause an infinite loop.
     *
     * To apply changes pre-render, see `onBeforeFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onAfterFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onAfterFlush: function() {},
                /**
     * Adds a single vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchTri` and `batchQuad`.
     *
     * It does not perform any batch limit checking itself, so if you need to call
     * this method directly, do so in the same way that `batchQuad` does, for example.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} u - UV u value.
     * @param {number} v - UV v value.
     * @param {number} unit - Texture unit to which the texture needs to be bound.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {number} tint - The tint color value.
     */ batchVert: function(x, y, u, v, unit, tintEffect, tint) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexViewU32 = this.vertexViewU32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewF32[++vertexOffset] = u;
                    vertexViewF32[++vertexOffset] = v;
                    vertexViewF32[++vertexOffset] = unit;
                    vertexViewF32[++vertexOffset] = tintEffect;
                    vertexViewU32[++vertexOffset] = tint;
                    this.vertexCount++;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where tx0/ty0 = 0, tx1/ty1 = 1, tx2/ty2 = 2 and tx3/ty3 = 3
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchQuad
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(gameObject, x0, y0, x1, y1, x2, y2, x3, y3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, unit) {
                    if (unit === undefined) unit = this.currentUnit;
                    var hasFlushed = false;
                    if (this.shouldFlush(6)) {
                        this.flush();
                        hasFlushed = true;
                        unit = this.setTexture2D(texture);
                    }
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x1, y1, u0, v1, unit, tintEffect, tintBL);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBR);
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBR);
                    this.batchVert(x3, y3, u1, v0, unit, tintEffect, tintTR);
                    this.onBatch(gameObject);
                    return hasFlushed;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 3 vertices in the following arrangement:
     *
     * ```
     * 0
     * |\
     * | \
     * |  \
     * |   \
     * |    \
     * 1-----2
     * ```
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchTri
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchTri: function(gameObject, x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintEffect, texture, unit) {
                    if (unit === undefined) unit = this.currentUnit;
                    var hasFlushed = false;
                    if (this.shouldFlush(3)) {
                        this.flush();
                        hasFlushed = true;
                        unit = this.setTexture2D(texture);
                    }
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x1, y1, u0, v1, unit, tintEffect, tintTR);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBL);
                    this.onBatch(gameObject);
                    return hasFlushed;
                },
                /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * The dimensions are run through `Math.floor` before the quad is generated.
     *
     * Rectangle has no transform values and isn't transformed into the local space.
     *
     * Used for directly batching untransformed rectangles, such as Camera background colors.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#drawFillRect
     * @since 3.50.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {number} color - Color of the rectangle to draw.
     * @param {number} alpha - Alpha value of the rectangle to draw.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {boolean} [flipUV=true] - Flip the vertical UV coordinates of the texture before rendering?
     */ drawFillRect: function(x, y, width, height, color, alpha, texture, flipUV) {
                    if (texture === undefined) texture = this.renderer.whiteTexture.glTexture;
                    if (flipUV === undefined) flipUV = true;
                    x = Math.floor(x);
                    y = Math.floor(y);
                    var xw = Math.floor(x + width);
                    var yh = Math.floor(y + height);
                    var unit = this.setTexture2D(texture);
                    var tint = Utils.getTintAppendFloatAlphaAndSwap(color, alpha);
                    var u0 = 0;
                    var v0 = 0;
                    var u1 = 1;
                    var v1 = 1;
                    if (flipUV) {
                        v0 = 1;
                        v1 = 0;
                    }
                    this.batchQuad(null, x, y, x, yh, xw, yh, xw, y, u0, v0, u1, v1, tint, tint, tint, tint, 0, texture, unit);
                },
                /**
     * Sets the texture to be bound to the next available texture unit and returns
     * the unit id.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTexture2D
     * @since 3.50.0
     *
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch. If not given uses `whiteTexture`.
     *
     * @return {number} The assigned texture unit.
     */ setTexture2D: function(texture) {
                    if (texture === undefined) texture = this.renderer.whiteTexture.glTexture;
                    this.currentUnit = this.renderer.setTexture2D(texture);
                    return this.currentUnit;
                },
                /**
     * Activates the given WebGL Texture and binds it to the requested texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindTexture
     * @since 3.50.0
     *
     * @param {WebGLTexture} [target] - The WebGLTexture to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindTexture: function(texture, unit) {
                    if (unit === undefined) unit = 0;
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE0 + unit);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    return this;
                },
                /**
     * Activates the given Render Target texture and binds it to the
     * requested WebGL texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindRenderTarget
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindRenderTarget: function(target, unit) {
                    return this.bindTexture(target.texture, unit);
                },
                /**
     * Sets the current duration into a 1f uniform value based on the given name.
     *
     * This can be used for mapping time uniform values, such as `iTime`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTime
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     *
     * @return {this} This WebGLPipeline instance.
     */ setTime: function(uniform) {
                    this.set1f(uniform, this.game.loop.getDuration());
                    return this;
                },
                /**
     * Sets a 1f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1f: function(name, x, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1f(name, x);
                    return this;
                },
                /**
     * Sets a 2f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2f: function(name, x, y, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2f(name, x, y);
                    return this;
                },
                /**
     * Sets a 3f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3f: function(name, x, y, z, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3f(name, x, y, z);
                    return this;
                },
                /**
     * Sets a 4f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4f: function(name, x, y, z, w, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4f(name, x, y, z, w);
                    return this;
                },
                /**
     * Sets a 1fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1fv(name, arr);
                    return this;
                },
                /**
     * Sets a 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2fv(name, arr);
                    return this;
                },
                /**
     * Sets a 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3fv(name, arr);
                    return this;
                },
                /**
     * Sets a 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4fv(name, arr);
                    return this;
                },
                /**
     * Sets a 1iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1iv(name, arr);
                    return this;
                },
                /**
     * Sets a 2iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2iv(name, arr);
                    return this;
                },
                /**
     * Sets a 3iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3iv(name, arr);
                    return this;
                },
                /**
     * Sets a 4iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4iv(name, arr);
                    return this;
                },
                /**
     * Sets a 1i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1i: function(name, x, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1i(name, x);
                    return this;
                },
                /**
     * Sets a 2i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2i: function(name, x, y, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2i(name, x, y);
                    return this;
                },
                /**
     * Sets a 3i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3i: function(name, x, y, z, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3i(name, x, y, z);
                    return this;
                },
                /**
     * Sets a 4i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform.
     * @param {number} y - Y component of the uniform.
     * @param {number} z - Z component of the uniform.
     * @param {number} w - W component of the uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4i: function(name, x, y, z, w, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4i(name, x, y, z, w);
                    return this;
                },
                /**
     * Sets a matrix 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix2fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix2fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Sets a matrix 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix3fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix3fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Sets a matrix 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Should the matrix be transpose
     * @param {Float32Array} matrix - Matrix data
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix4fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix4fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#destroy
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
     * @since 3.0.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                    this.emit(Events.DESTROY, this);
                    var i;
                    var shaders = this.shaders;
                    for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                    var targets = this.renderTargets;
                    for(i = 0; i < targets.length; i++)targets[i].destroy();
                    this.gl.deleteBuffer(this.vertexBuffer);
                    var renderer = this.renderer;
                    renderer.off(RendererEvents.RESIZE, this.resize, this);
                    renderer.off(RendererEvents.PRE_RENDER, this.onPreRender, this);
                    renderer.off(RendererEvents.RENDER, this.onRender, this);
                    renderer.off(RendererEvents.POST_RENDER, this.onPostRender, this);
                    this.removeAllListeners();
                    this.game = null;
                    this.renderer = null;
                    this.manager = null;
                    this.gl = null;
                    this.view = null;
                    this.shaders = null;
                    this.renderTargets = null;
                    this.bytes = null;
                    this.vertexViewF32 = null;
                    this.vertexViewU32 = null;
                    this.vertexData = null;
                    this.vertexBuffer = null;
                    this.currentShader = null;
                    this.currentRenderTarget = null;
                    return this;
                }
            });
            module1.exports = WebGLPipeline;
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This module implements a modified ear slicing algorithm, optimized by z-order curve hashing and extended to
 * handle holes, twisted polygons, degeneracies and self-intersections in a way that doesn't guarantee correctness
 * of triangulation, but attempts to always produce acceptable results for practical data.
 *
 * Example:
 *
 * ```javascript
 * const triangles = Phaser.Geom.Polygon.Earcut([10,0, 0,50, 60,60, 70,10]); // returns [1,0,3, 3,2,1]
 * ```
 *
 * Each group of three vertex indices in the resulting array forms a triangle.
 *
 * ```javascript
 * // triangulating a polygon with a hole
 * earcut([0,0, 100,0, 100,100, 0,100,  20,20, 80,20, 80,80, 20,80], [4]);
 * // [3,0,4, 5,4,0, 3,4,7, 5,0,1, 2,3,7, 6,5,1, 2,7,6, 6,1,2]
 *
 * // triangulating a polygon with 3d coords
 * earcut([10,0,1, 0,50,2, 60,60,3, 70,10,4], null, 3);
 * // [1,0,3, 3,2,1]
 * ```
 *
 * If you pass a single vertex as a hole, Earcut treats it as a Steiner point.
 *
 * If your input is a multi-dimensional array (e.g. GeoJSON Polygon), you can convert it to the format
 * expected by Earcut with `Phaser.Geom.Polygon.Earcut.flatten`:
 *
 * ```javascript
 * var data = earcut.flatten(geojson.geometry.coordinates);
 * var triangles = earcut(data.vertices, data.holes, data.dimensions);
 * ```
 *
 * After getting a triangulation, you can verify its correctness with `Phaser.Geom.Polygon.Earcut.deviation`:
 *
 * ```javascript
 * var deviation = earcut.deviation(vertices, holes, dimensions, triangles);
 * ```
 * Returns the relative difference between the total area of triangles and the area of the input polygon.
 * 0 means the triangulation is fully correct.
 *
 * For more information see https://github.com/mapbox/earcut
 *
 * @function Phaser.Geom.Polygon.Earcut
 * @since 3.50.0
 *
 * @param {number[]} data - A flat array of vertex coordinate, like [x0,y0, x1,y1, x2,y2, ...]
 * @param {number[]} [holeIndices] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [dimensions=2] - The number of coordinates per vertex in the input array (2 by default).
 *
 * @return {number[]} An array of triangulated data.
 */ //  Earcut 2.2.2 (January 21st 2020)
            /*
 * ISC License
 *
 * Copyright (c) 2016, Mapbox
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose
 * with or without fee is hereby granted, provided that the above copyright notice
 * and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
 * OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
 * TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
 * THIS SOFTWARE.
 */ function earcut(data, holeIndices, dim) {
                dim = dim || 2;
                var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
                if (!outerNode || outerNode.next === outerNode.prev) return triangles;
                var minX, minY, maxX, maxY, x, y, invSize;
                if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
                // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
                if (data.length > 80 * dim) {
                    minX = maxX = data[0];
                    minY = maxY = data[1];
                    for(var i = dim; i < outerLen; i += dim){
                        x = data[i];
                        y = data[i + 1];
                        if (x < minX) minX = x;
                        if (y < minY) minY = y;
                        if (x > maxX) maxX = x;
                        if (y > maxY) maxY = y;
                    }
                    // minX, minY and invSize are later used to transform coords into integers for z-order calculation
                    invSize = Math.max(maxX - minX, maxY - minY);
                    invSize = invSize !== 0 ? 1 / invSize : 0;
                }
                earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
                return triangles;
            }
            // create a circular doubly linked list from polygon points in the specified winding order
            function linkedList(data, start, end, dim, clockwise) {
                var i, last;
                if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
                else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
                if (last && equals(last, last.next)) {
                    removeNode(last);
                    last = last.next;
                }
                return last;
            }
            // eliminate colinear or duplicate points
            function filterPoints(start, end) {
                if (!start) return start;
                if (!end) end = start;
                var p = start, again;
                do {
                    again = false;
                    if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                        removeNode(p);
                        p = end = p.prev;
                        if (p === p.next) break;
                        again = true;
                    } else p = p.next;
                }while (again || p !== end);
                return end;
            }
            // main ear slicing loop which triangulates a polygon (given as a linked list)
            function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
                if (!ear) return;
                // interlink polygon nodes in z-order
                if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
                var stop = ear, prev, next;
                // iterate through ears, slicing them one by one
                while(ear.prev !== ear.next){
                    prev = ear.prev;
                    next = ear.next;
                    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                        // cut off the triangle
                        triangles.push(prev.i / dim);
                        triangles.push(ear.i / dim);
                        triangles.push(next.i / dim);
                        removeNode(ear);
                        // skipping the next vertex leads to less sliver triangles
                        ear = next.next;
                        stop = next.next;
                        continue;
                    }
                    ear = next;
                    // if we looped through the whole remaining polygon and can't find any more ears
                    if (ear === stop) {
                        // try filtering points and slicing again
                        if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
                        else if (pass === 1) {
                            ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                            earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
                        // as a last resort, try splitting the remaining polygon into two
                        } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
                        break;
                    }
                }
            }
            // check whether a polygon node forms a valid ear with adjacent nodes
            function isEar(ear) {
                var a = ear.prev, b = ear, c = ear.next;
                if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                // now make sure we don't have other points inside the potential ear
                var p = ear.next.next;
                while(p !== ear.prev){
                    if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.next;
                }
                return true;
            }
            function isEarHashed(ear, minX, minY, invSize) {
                var a = ear.prev, b = ear, c = ear.next;
                if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                // triangle bbox; min & max are calculated like this for speed
                var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
                // z-order range for the current triangle bbox;
                var minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
                var p = ear.prevZ, n = ear.nextZ;
                // look for points inside the triangle in both directions
                while(p && p.z >= minZ && n && n.z <= maxZ){
                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.prevZ;
                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                    n = n.nextZ;
                }
                // look for remaining points in decreasing z-order
                while(p && p.z >= minZ){
                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.prevZ;
                }
                // look for remaining points in increasing z-order
                while(n && n.z <= maxZ){
                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                    n = n.nextZ;
                }
                return true;
            }
            // go through all polygon nodes and cure small local self-intersections
            function cureLocalIntersections(start, triangles, dim) {
                var p = start;
                do {
                    var a = p.prev, b = p.next.next;
                    if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
                        triangles.push(a.i / dim);
                        triangles.push(p.i / dim);
                        triangles.push(b.i / dim);
                        // remove two nodes involved
                        removeNode(p);
                        removeNode(p.next);
                        p = start = b;
                    }
                    p = p.next;
                }while (p !== start);
                return filterPoints(p);
            }
            // try splitting polygon into two and triangulate them independently
            function splitEarcut(start, triangles, dim, minX, minY, invSize) {
                // look for a valid diagonal that divides the polygon into two
                var a = start;
                do {
                    var b = a.next.next;
                    while(b !== a.prev){
                        if (a.i !== b.i && isValidDiagonal(a, b)) {
                            // split the polygon in two by the diagonal
                            var c = splitPolygon(a, b);
                            // filter colinear points around the cuts
                            a = filterPoints(a, a.next);
                            c = filterPoints(c, c.next);
                            // run earcut on each half
                            earcutLinked(a, triangles, dim, minX, minY, invSize);
                            earcutLinked(c, triangles, dim, minX, minY, invSize);
                            return;
                        }
                        b = b.next;
                    }
                    a = a.next;
                }while (a !== start);
            }
            // link every hole into the outer loop, producing a single-ring polygon without holes
            function eliminateHoles(data, holeIndices, outerNode, dim) {
                var queue = [], i, len, start, end, list;
                for(i = 0, len = holeIndices.length; i < len; i++){
                    start = holeIndices[i] * dim;
                    end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                    list = linkedList(data, start, end, dim, false);
                    if (list === list.next) list.steiner = true;
                    queue.push(getLeftmost(list));
                }
                queue.sort(compareX);
                // process holes from left to right
                for(i = 0; i < queue.length; i++){
                    eliminateHole(queue[i], outerNode);
                    outerNode = filterPoints(outerNode, outerNode.next);
                }
                return outerNode;
            }
            function compareX(a, b) {
                return a.x - b.x;
            }
            // find a bridge between vertices that connects hole with an outer ring and and link it
            function eliminateHole(hole, outerNode) {
                outerNode = findHoleBridge(hole, outerNode);
                if (outerNode) {
                    var b = splitPolygon(outerNode, hole);
                    // filter collinear points around the cuts
                    filterPoints(outerNode, outerNode.next);
                    filterPoints(b, b.next);
                }
            }
            // David Eberly's algorithm for finding a bridge between hole and outer polygon
            function findHoleBridge(hole, outerNode) {
                var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
                // find a segment intersected by a ray from the hole's leftmost point to the left;
                // segment's endpoint with lesser x will be potential connection point
                do {
                    if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                        var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
                        if (x <= hx && x > qx) {
                            qx = x;
                            if (x === hx) {
                                if (hy === p.y) return p;
                                if (hy === p.next.y) return p.next;
                            }
                            m = p.x < p.next.x ? p : p.next;
                        }
                    }
                    p = p.next;
                }while (p !== outerNode);
                if (!m) return null;
                if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
                // look for points inside the triangle of hole point, segment intersection and endpoint;
                // if there are no points found, we have a valid connection;
                // otherwise choose the point of the minimum angle with the ray as connection point
                var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
                p = m;
                do {
                    if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
                        tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
                        if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                            m = p;
                            tanMin = tan;
                        }
                    }
                    p = p.next;
                }while (p !== stop);
                return m;
            }
            // whether sector in vertex m contains sector in vertex p in the same coordinates
            function sectorContainsSector(m, p) {
                return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
            }
            // interlink polygon nodes in z-order
            function indexCurve(start, minX, minY, invSize) {
                var p = start;
                do {
                    if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
                    p.prevZ = p.prev;
                    p.nextZ = p.next;
                    p = p.next;
                }while (p !== start);
                p.prevZ.nextZ = null;
                p.prevZ = null;
                sortLinked(p);
            }
            // Simon Tatham's linked list merge sort algorithm
            // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
            function sortLinked(list) {
                var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
                do {
                    p = list;
                    list = null;
                    tail = null;
                    numMerges = 0;
                    while(p){
                        numMerges++;
                        q = p;
                        pSize = 0;
                        for(i = 0; i < inSize; i++){
                            pSize++;
                            q = q.nextZ;
                            if (!q) break;
                        }
                        qSize = inSize;
                        while(pSize > 0 || qSize > 0 && q){
                            if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                                e = p;
                                p = p.nextZ;
                                pSize--;
                            } else {
                                e = q;
                                q = q.nextZ;
                                qSize--;
                            }
                            if (tail) tail.nextZ = e;
                            else list = e;
                            e.prevZ = tail;
                            tail = e;
                        }
                        p = q;
                    }
                    tail.nextZ = null;
                    inSize *= 2;
                }while (numMerges > 1);
                return list;
            }
            // z-order of a point given coords and inverse of the longer side of data bbox
            function zOrder(x, y, minX, minY, invSize) {
                // coords are transformed into non-negative 15-bit integer range
                x = 32767 * (x - minX) * invSize;
                y = 32767 * (y - minY) * invSize;
                x = (x | x << 8) & 0x00FF00FF;
                x = (x | x << 4) & 0x0F0F0F0F;
                x = (x | x << 2) & 0x33333333;
                x = (x | x << 1) & 0x55555555;
                y = (y | y << 8) & 0x00FF00FF;
                y = (y | y << 4) & 0x0F0F0F0F;
                y = (y | y << 2) & 0x33333333;
                y = (y | y << 1) & 0x55555555;
                return x | y << 1;
            }
            // find the leftmost node of a polygon ring
            function getLeftmost(start) {
                var p = start, leftmost = start;
                do {
                    if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
                    p = p.next;
                }while (p !== start);
                return leftmost;
            }
            // check if a point lies within a convex triangle
            function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
                return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
            }
            // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
            function isValidDiagonal(a, b) {
                return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
                (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
                (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
                equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
            }
            // signed area of a triangle
            function area(p, q, r) {
                return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
            }
            // check if two points are equal
            function equals(p1, p2) {
                return p1.x === p2.x && p1.y === p2.y;
            }
            // check if two segments intersect
            function intersects(p1, q1, p2, q2) {
                var o1 = sign(area(p1, q1, p2));
                var o2 = sign(area(p1, q1, q2));
                var o3 = sign(area(p2, q2, p1));
                var o4 = sign(area(p2, q2, q1));
                if (o1 !== o2 && o3 !== o4) return true; // general case
                if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
                if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
                if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
                if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
                return false;
            }
            // for collinear points p, q, r, check if point q lies on segment pr
            function onSegment(p, q, r) {
                return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
            }
            function sign(num) {
                return num > 0 ? 1 : num < 0 ? -1 : 0;
            }
            // check if a polygon diagonal intersects any polygon segments
            function intersectsPolygon(a, b) {
                var p = a;
                do {
                    if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
                    p = p.next;
                }while (p !== a);
                return false;
            }
            // check if a polygon diagonal is locally inside the polygon
            function locallyInside(a, b) {
                return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
            }
            // check if the middle point of a polygon diagonal is inside the polygon
            function middleInside(a, b) {
                var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
                do {
                    if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
                    p = p.next;
                }while (p !== a);
                return inside;
            }
            // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
            // if one belongs to the outer ring and another to a hole, it merges it into a single ring
            function splitPolygon(a, b) {
                var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
                a.next = b;
                b.prev = a;
                a2.next = an;
                an.prev = a2;
                b2.next = a2;
                a2.prev = b2;
                bp.next = b2;
                b2.prev = bp;
                return b2;
            }
            // create a node and optionally link it with previous one (in a circular doubly linked list)
            function insertNode(i, x, y, last) {
                var p = new Node(i, x, y);
                if (!last) {
                    p.prev = p;
                    p.next = p;
                } else {
                    p.next = last.next;
                    p.prev = last;
                    last.next.prev = p;
                    last.next = p;
                }
                return p;
            }
            function removeNode(p) {
                p.next.prev = p.prev;
                p.prev.next = p.next;
                if (p.prevZ) p.prevZ.nextZ = p.nextZ;
                if (p.nextZ) p.nextZ.prevZ = p.prevZ;
            }
            function Node(i, x, y) {
                // vertex index in coordinates array
                this.i = i;
                // vertex coordinates
                this.x = x;
                this.y = y;
                // previous and next vertex nodes in a polygon ring
                this.prev = null;
                this.next = null;
                // z-order curve value
                this.z = null;
                // previous and next nodes in z-order
                this.prevZ = null;
                this.nextZ = null;
                // indicates whether this is a steiner point
                this.steiner = false;
            }
            // return a percentage difference between the polygon area and its triangulation area;
            // used to verify correctness of triangulation
            earcut.deviation = function(data, holeIndices, dim, triangles) {
                var hasHoles = holeIndices && holeIndices.length;
                var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
                var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
                if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
                    var start = holeIndices[i] * dim;
                    var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                    polygonArea -= Math.abs(signedArea(data, start, end, dim));
                }
                var trianglesArea = 0;
                for(i = 0; i < triangles.length; i += 3){
                    var a = triangles[i] * dim;
                    var b = triangles[i + 1] * dim;
                    var c = triangles[i + 2] * dim;
                    trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
                }
                return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
            };
            function signedArea(data, start, end, dim) {
                var sum = 0;
                for(var i = start, j = end - dim; i < end; i += dim){
                    sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
                    j = i;
                }
                return sum;
            }
            // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
            earcut.flatten = function(data) {
                var dim = data[0][0].length, result = {
                    vertices: [],
                    holes: [],
                    dimensions: dim
                }, holeIndex = 0;
                for(var i = 0; i < data.length; i++){
                    for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
                    if (i > 0) {
                        holeIndex += data[i - 1].length;
                        result.holes.push(holeIndex);
                    }
                }
                return result;
            };
            module1.exports = earcut;
        /***/ },
        /* 60 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the strokeStyle and lineWidth on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#LineStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the stroke style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the stroke style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var LineStyleCanvas = function(ctx, src, altColor, altAlpha) {
                var strokeColor = altColor ? altColor : src.strokeColor;
                var strokeAlpha = altAlpha ? altAlpha : src.strokeAlpha;
                var red = (strokeColor & 0xFF0000) >>> 16;
                var green = (strokeColor & 0xFF00) >>> 8;
                var blue = strokeColor & 0xFF;
                ctx.strokeStyle = "rgba(" + red + "," + green + "," + blue + "," + strokeAlpha + ")";
                ctx.lineWidth = src.lineWidth;
            };
            module1.exports = LineStyleCanvas;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#json method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#json.
 *
 * @class JSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var JSONFile = new Class({
                Extends: File,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function JSONFile(loader, key, url, xhrSettings, dataKey) {
                    var extension = "json";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        dataKey = GetFastValue(config, "dataKey", dataKey);
                    }
                    var fileConfig = {
                        type: "json",
                        cache: loader.cacheManager.json,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: dataKey
                    };
                    File.call(this, loader, fileConfig);
                    if (IsPlainObject(url)) {
                        //  Object provided instead of a URL, so no need to actually load it (populate data with value)
                        if (dataKey) this.data = GetValue(url, dataKey);
                        else this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.JSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    if (this.state !== CONST.FILE_POPULATED) {
                        this.state = CONST.FILE_PROCESSING;
                        try {
                            var json = JSON.parse(this.xhrLoader.responseText);
                        } catch (e) {
                            console.warn("Invalid JSON: " + this.key);
                            this.onProcessError();
                            throw e;
                        }
                        var key = this.config;
                        if (typeof key === "string") this.data = GetValue(json, key, json);
                        else this.data = json;
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a JSON file, or array of JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.json('wavedata', 'files/AlienWaveData.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.json({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.json('wavedata', 'files/AlienWaveData.json');
 * // and later in your game ...
 * var data = this.cache.json.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#json
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("json", function(key, url, dataKey, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new JSONFile(this, key[i]));
                else this.addFile(new JSONFile(this, key, url, xhrSettings, dataKey));
                return this;
            });
            module1.exports = JSONFile;
        /***/ },
        /* 62 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Arcade Physics consts.
 *
 * @ignore
 */ var CONST = {
                /**
     * Dynamic Body.
     *
     * @name Phaser.Physics.Arcade.DYNAMIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.Group#physicsType
     */ DYNAMIC_BODY: 0,
                /**
     * Static Body.
     *
     * @name Phaser.Physics.Arcade.STATIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.StaticBody#physicsType
     */ STATIC_BODY: 1,
                /**
     * Arcade Physics Group containing Dynamic Bodies.
     *
     * @name Phaser.Physics.Arcade.GROUP
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ GROUP: 2,
                /**
     * A Tilemap Layer.
     *
     * @name Phaser.Physics.Arcade.TILEMAPLAYER
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ TILEMAPLAYER: 3,
                /**
     * Facing no direction (initial value).
     *
     * @name Phaser.Physics.Arcade.FACING_NONE
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_NONE: 10,
                /**
     * Facing up.
     *
     * @name Phaser.Physics.Arcade.FACING_UP
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_UP: 11,
                /**
     * Facing down.
     *
     * @name Phaser.Physics.Arcade.FACING_DOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_DOWN: 12,
                /**
     * Facing left.
     *
     * @name Phaser.Physics.Arcade.FACING_LEFT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_LEFT: 13,
                /**
     * Facing right.
     *
     * @name Phaser.Physics.Arcade.FACING_RIGHT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_RIGHT: 14
            };
            module1.exports = CONST;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(158);
            var GetTilesWithin = __webpack_require__(26);
            /**
 * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
 * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
 * is mostly used internally.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesWithin = function(tileX, tileY, width, height, layer) {
                var above = null;
                var below = null;
                var left = null;
                var right = null;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    if (tile) {
                        if (tile.collides) {
                            above = GetTileAt(tile.x, tile.y - 1, true, layer);
                            below = GetTileAt(tile.x, tile.y + 1, true, layer);
                            left = GetTileAt(tile.x - 1, tile.y, true, layer);
                            right = GetTileAt(tile.x + 1, tile.y, true, layer);
                            tile.faceTop = above && above.collides ? false : true;
                            tile.faceBottom = below && below.collides ? false : true;
                            tile.faceLeft = left && left.collides ? false : true;
                            tile.faceRight = right && right.collides ? false : true;
                        } else tile.resetFaces();
                    }
                }
            };
            module1.exports = CalculateFacesWithin;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vertices
*/ var Vertices = {};
            module1.exports = Vertices;
            var Vector = __webpack_require__(83);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Creates a new set of `Matter.Body` compatible vertices.
     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
     * but with some additional references required for efficient collision detection routines.
     *
     * Vertices must be specified in clockwise order.
     *
     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
     *
     * @method create
     * @param {vector[]} points
     * @param {body} body
     */ Vertices.create = function(points, body) {
                    var vertices = [];
                    for(var i = 0; i < points.length; i++){
                        var point = points[i], vertex = {
                            x: point.x,
                            y: point.y,
                            index: i,
                            body: body,
                            isInternal: false,
                            contact: null,
                            offset: null
                        };
                        vertex.contact = {
                            vertex: vertex,
                            normalImpulse: 0,
                            tangentImpulse: 0
                        };
                        vertices.push(vertex);
                    }
                    return vertices;
                };
                /**
     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
     * into a `Matter.Vertices` object for the given `Matter.Body`.
     * For parsing SVG paths, see `Svg.pathToVertices`.
     * @method fromPath
     * @param {string} path
     * @param {body} body
     * @return {vertices} vertices
     */ Vertices.fromPath = function(path, body) {
                    var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig, points = [];
                    path.replace(pathPattern, function(match, x, y) {
                        points.push({
                            x: parseFloat(x),
                            y: parseFloat(y)
                        });
                    });
                    return Vertices.create(points, body);
                };
                /**
     * Returns the centre (centroid) of the set of vertices.
     * @method centre
     * @param {vertices} vertices
     * @return {vector} The centre point
     */ Vertices.centre = function(vertices) {
                    var area = Vertices.area(vertices, true), centre = {
                        x: 0,
                        y: 0
                    }, cross, temp, j;
                    for(var i = 0; i < vertices.length; i++){
                        j = (i + 1) % vertices.length;
                        cross = Vector.cross(vertices[i], vertices[j]);
                        temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
                        centre = Vector.add(centre, temp);
                    }
                    return Vector.div(centre, 6 * area);
                };
                /**
     * Returns the average (mean) of the set of vertices.
     * @method mean
     * @param {vertices} vertices
     * @return {vector} The average point
     */ Vertices.mean = function(vertices) {
                    var average = {
                        x: 0,
                        y: 0
                    };
                    for(var i = 0; i < vertices.length; i++){
                        average.x += vertices[i].x;
                        average.y += vertices[i].y;
                    }
                    return Vector.div(average, vertices.length);
                };
                /**
     * Returns the area of the set of vertices.
     * @method area
     * @param {vertices} vertices
     * @param {bool} signed
     * @return {number} The area
     */ Vertices.area = function(vertices, signed) {
                    var area = 0, j = vertices.length - 1;
                    for(var i = 0; i < vertices.length; i++){
                        area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
                        j = i;
                    }
                    if (signed) return area / 2;
                    return Math.abs(area) / 2;
                };
                /**
     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
     * @method inertia
     * @param {vertices} vertices
     * @param {number} mass
     * @return {number} The polygon's moment of inertia
     */ Vertices.inertia = function(vertices, mass) {
                    var numerator = 0, denominator = 0, v = vertices, cross, j;
                    // find the polygon's moment of inertia, using second moment of area
                    // from equations at http://www.physicsforums.com/showthread.php?t=25293
                    for(var n = 0; n < v.length; n++){
                        j = (n + 1) % v.length;
                        cross = Math.abs(Vector.cross(v[j], v[n]));
                        numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
                        denominator += cross;
                    }
                    return mass / 6 * (numerator / denominator);
                };
                /**
     * Translates the set of vertices in-place.
     * @method translate
     * @param {vertices} vertices
     * @param {vector} vector
     * @param {number} scalar
     */ Vertices.translate = function(vertices, vector, scalar) {
                    var i;
                    if (scalar) for(i = 0; i < vertices.length; i++){
                        vertices[i].x += vector.x * scalar;
                        vertices[i].y += vector.y * scalar;
                    }
                    else for(i = 0; i < vertices.length; i++){
                        vertices[i].x += vector.x;
                        vertices[i].y += vector.y;
                    }
                    return vertices;
                };
                /**
     * Rotates the set of vertices in-place.
     * @method rotate
     * @param {vertices} vertices
     * @param {number} angle
     * @param {vector} point
     */ Vertices.rotate = function(vertices, angle, point) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < vertices.length; i++){
                        var vertice = vertices[i], dx = vertice.x - point.x, dy = vertice.y - point.y;
                        vertice.x = point.x + (dx * cos - dy * sin);
                        vertice.y = point.y + (dx * sin + dy * cos);
                    }
                    return vertices;
                };
                /**
     * Returns `true` if the `point` is inside the set of `vertices`.
     * @method contains
     * @param {vertices} vertices
     * @param {vector} point
     * @return {boolean} True if the vertices contains point, otherwise false
     */ Vertices.contains = function(vertices, point) {
                    for(var i = 0; i < vertices.length; i++){
                        var vertice = vertices[i], nextVertice = vertices[(i + 1) % vertices.length];
                        if ((point.x - vertice.x) * (nextVertice.y - vertice.y) + (point.y - vertice.y) * (vertice.x - nextVertice.x) > 0) return false;
                    }
                    return true;
                };
                /**
     * Scales the vertices from a point (default is centre) in-place.
     * @method scale
     * @param {vertices} vertices
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     */ Vertices.scale = function(vertices, scaleX, scaleY, point) {
                    if (scaleX === 1 && scaleY === 1) return vertices;
                    point = point || Vertices.centre(vertices);
                    var vertex, delta;
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        delta = Vector.sub(vertex, point);
                        vertices[i].x = point.x + delta.x * scaleX;
                        vertices[i].y = point.y + delta.y * scaleY;
                    }
                    return vertices;
                };
                /**
     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
     * The radius parameter is a single number or an array to specify the radius for each vertex.
     * @method chamfer
     * @param {vertices} vertices
     * @param {number[]} radius
     * @param {number} quality
     * @param {number} qualityMin
     * @param {number} qualityMax
     */ Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
                    if (typeof radius === "number") radius = [
                        radius
                    ];
                    else radius = radius || [
                        8
                    ];
                    // quality defaults to -1, which is auto
                    quality = typeof quality !== "undefined" ? quality : -1;
                    qualityMin = qualityMin || 2;
                    qualityMax = qualityMax || 14;
                    var newVertices = [];
                    for(var i = 0; i < vertices.length; i++){
                        var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1], vertex = vertices[i], nextVertex = vertices[(i + 1) % vertices.length], currentRadius = radius[i < radius.length ? i : radius.length - 1];
                        if (currentRadius === 0) {
                            newVertices.push(vertex);
                            continue;
                        }
                        var prevNormal = Vector.normalise({
                            x: vertex.y - prevVertex.y,
                            y: prevVertex.x - vertex.x
                        });
                        var nextNormal = Vector.normalise({
                            x: nextVertex.y - vertex.y,
                            y: vertex.x - nextVertex.x
                        });
                        var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)), radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius), midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)), scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
                        var precision = quality;
                        if (quality === -1) // automatically decide precision
                        precision = Math.pow(currentRadius, 0.32) * 1.75;
                        precision = Common.clamp(precision, qualityMin, qualityMax);
                        // use an even value for precision, more likely to reduce axes by using symmetry
                        if (precision % 2 === 1) precision += 1;
                        var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)), theta = alpha / precision;
                        for(var j = 0; j < precision; j++)newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
                    }
                    return newVertices;
                };
                /**
     * Sorts the input vertices into clockwise order in place.
     * @method clockwiseSort
     * @param {vertices} vertices
     * @return {vertices} vertices
     */ Vertices.clockwiseSort = function(vertices) {
                    var centre = Vertices.mean(vertices);
                    vertices.sort(function(vertexA, vertexB) {
                        return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
                    });
                    return vertices;
                };
                /**
     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
     * @method isConvex
     * @param {vertices} vertices
     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
     */ Vertices.isConvex = function(vertices) {
                    // http://paulbourke.net/geometry/polygonmesh/
                    // Copyright (c) Paul Bourke (use permitted)
                    var flag = 0, n = vertices.length, i, j, k, z;
                    if (n < 3) return null;
                    for(i = 0; i < n; i++){
                        j = (i + 1) % n;
                        k = (i + 2) % n;
                        z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
                        z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
                        if (z < 0) flag |= 1;
                        else if (z > 0) flag |= 2;
                        if (flag === 3) return false;
                    }
                    if (flag !== 0) return true;
                    else return null;
                };
                /**
     * Returns the convex hull of the input vertices as a new array of points.
     * @method hull
     * @param {vertices} vertices
     * @return [vertex] vertices
     */ Vertices.hull = function(vertices) {
                    // http://geomalgorithms.com/a10-_hull-1.html
                    var upper = [], lower = [], vertex, i;
                    // sort vertices on x-axis (y-axis for ties)
                    vertices = vertices.slice(0);
                    vertices.sort(function(vertexA, vertexB) {
                        var dx = vertexA.x - vertexB.x;
                        return dx !== 0 ? dx : vertexA.y - vertexB.y;
                    });
                    // build lower hull
                    for(i = 0; i < vertices.length; i += 1){
                        vertex = vertices[i];
                        while(lower.length >= 2 && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0)lower.pop();
                        lower.push(vertex);
                    }
                    // build upper hull
                    for(i = vertices.length - 1; i >= 0; i -= 1){
                        vertex = vertices[i];
                        while(upper.length >= 2 && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0)upper.pop();
                        upper.push(vertex);
                    }
                    // concatenation of the lower and upper hulls gives the convex hull
                    // omit last points because they are repeated at the beginning of the other list
                    upper.pop();
                    lower.pop();
                    return upper.concat(lower);
                };
            })();
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(66);
            var GetPoint = __webpack_require__(300);
            var GetPoints = __webpack_require__(301);
            var GEOM_CONST = __webpack_require__(56);
            var Random = __webpack_require__(170);
            /**
 * @classdesc
 * A Circle object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Circle you should look at the capabilities of the Graphics class.
 *
 * @class Circle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the circle.
 * @param {number} [y=0] - The y position of the center of the circle.
 * @param {number} [radius=0] - The radius of the circle.
 */ var Circle = new Class({
                initialize: function Circle(x, y, radius) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.CIRCLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Circle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.CIRCLE;
                    /**
         * The x position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The internal radius of the circle.
         *
         * @name Phaser.Geom.Circle#_radius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._radius = radius;
                    /**
         * The internal diameter of the circle.
         *
         * @name Phaser.Geom.Circle#_diameter
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._diameter = radius * 2;
                },
                /**
     * Check to see if the Circle contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Circle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the circle.
     * @param {number} y - The y coordinate to check within the circle.
     *
     * @return {boolean} True if the coordinates are within the circle, otherwise false.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Circle
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Circle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
     */ getPoint: function(position, point) {
                    return GetPoint(this, position, point);
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Circle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the circle.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a uniformly distributed random point from anywhere within the Circle.
     *
     * @method Phaser.Geom.Circle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the x, y and radius of this circle.
     *
     * @method Phaser.Geom.Circle#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     * @param {number} [radius=0] - The radius of the circle.
     *
     * @return {this} This Circle object.
     */ setTo: function(x, y, radius) {
                    this.x = x;
                    this.y = y;
                    this._radius = radius;
                    this._diameter = radius * 2;
                    return this;
                },
                /**
     * Sets this Circle to be empty with a radius of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Circle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Circle object.
     */ setEmpty: function() {
                    this._radius = 0;
                    this._diameter = 0;
                    return this;
                },
                /**
     * Sets the position of this Circle.
     *
     * @method Phaser.Geom.Circle#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     *
     * @return {this} This Circle object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Checks to see if the Circle is empty: has a radius of zero.
     *
     * @method Phaser.Geom.Circle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Circle is empty, otherwise false.
     */ isEmpty: function() {
                    return this._radius <= 0;
                },
                /**
     * The radius of the Circle.
     *
     * @name Phaser.Geom.Circle#radius
     * @type {number}
     * @since 3.0.0
     */ radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(value) {
                        this._radius = value;
                        this._diameter = value * 2;
                    }
                },
                /**
     * The diameter of the Circle.
     *
     * @name Phaser.Geom.Circle#diameter
     * @type {number}
     * @since 3.0.0
     */ diameter: {
                    get: function() {
                        return this._diameter;
                    },
                    set: function(value) {
                        this._diameter = value;
                        this._radius = value * 0.5;
                    }
                },
                /**
     * The left position of the Circle.
     *
     * @name Phaser.Geom.Circle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x - this._radius;
                    },
                    set: function(value) {
                        this.x = value + this._radius;
                    }
                },
                /**
     * The right position of the Circle.
     *
     * @name Phaser.Geom.Circle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this._radius;
                    },
                    set: function(value) {
                        this.x = value - this._radius;
                    }
                },
                /**
     * The top position of the Circle.
     *
     * @name Phaser.Geom.Circle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y - this._radius;
                    },
                    set: function(value) {
                        this.y = value + this._radius;
                    }
                },
                /**
     * The bottom position of the Circle.
     *
     * @name Phaser.Geom.Circle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this._radius;
                    },
                    set: function(value) {
                        this.y = value - this._radius;
                    }
                }
            });
            module1.exports = Circle;
        /***/ },
        /* 66 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Circle contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Circle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {number} x - The x coordinate to check within the circle.
 * @param {number} y - The y coordinate to check within the circle.
 *
 * @return {boolean} True if the coordinates are within the circle, otherwise false.
 */ var Contains = function(circle, x, y) {
                //  Check if x/y are within the bounds first
                if (circle.radius > 0 && x >= circle.left && x <= circle.right && y >= circle.top && y <= circle.bottom) {
                    var dx = (circle.x - x) * (circle.x - x);
                    var dy = (circle.y - y) * (circle.y - y);
                    return dx + dy <= circle.radius * circle.radius;
                } else return false;
            };
            module1.exports = Contains;
        /***/ },
        /* 67 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the length of the given line.
 *
 * @function Phaser.Geom.Line.Length
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the length of.
 *
 * @return {number} The length of the line.
 */ var Length = function(line) {
                return Math.sqrt((line.x2 - line.x1) * (line.x2 - line.x1) + (line.y2 - line.y1) * (line.y2 - line.y1));
            };
            module1.exports = Length;
        /***/ },
        /* 68 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Wrap the given `value` between `min` and `max.
 *
 * @function Phaser.Math.Wrap
 * @since 3.0.0
 *
 * @param {number} value - The value to wrap.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The wrapped value.
 */ var Wrap = function(value, min, max) {
                var range = max - min;
                return min + ((value - min) % range + range) % range;
            };
            module1.exports = Wrap;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector3 = __webpack_require__(39);
            /**
 * @ignore
 */ var EPSILON = 0.000001;
            /**
 * @classdesc
 * A four-dimensional matrix.
 *
 * Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
 * and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
 *
 * @class Matrix4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix4} [m] - Optional Matrix4 to copy values from.
 */ var Matrix4 = new Class({
                initialize: function Matrix4(m) {
                    /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix4#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(16);
                    if (m) //  Assume Matrix4 with val:
                    this.copy(m);
                    else //  Default to identity
                    this.identity();
                },
                /**
     * Make a clone of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} A clone of this Matrix4.
     */ clone: function() {
                    return new Matrix4(this);
                },
                /**
     * This method is an alias for `Matrix4.copy`.
     *
     * @method Phaser.Math.Matrix4#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {this} This Matrix4.
     */ set: function(src) {
                    return this.copy(src);
                },
                /**
     * Sets all values of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#setValues
     * @since 3.50.0
     *
     * @param {number} m00 - The m00 value.
     * @param {number} m01 - The m01 value.
     * @param {number} m02 - The m02 value.
     * @param {number} m03 - The m03 value.
     * @param {number} m10 - The m10 value.
     * @param {number} m11 - The m11 value.
     * @param {number} m12 - The m12 value.
     * @param {number} m13 - The m13 value.
     * @param {number} m20 - The m20 value.
     * @param {number} m21 - The m21 value.
     * @param {number} m22 - The m22 value.
     * @param {number} m23 - The m23 value.
     * @param {number} m30 - The m30 value.
     * @param {number} m31 - The m31 value.
     * @param {number} m32 - The m32 value.
     * @param {number} m33 - The m33 value.
     *
     * @return {this} This Matrix4 instance.
     */ setValues: function(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
                    var out = this.val;
                    out[0] = m00;
                    out[1] = m01;
                    out[2] = m02;
                    out[3] = m03;
                    out[4] = m10;
                    out[5] = m11;
                    out[6] = m12;
                    out[7] = m13;
                    out[8] = m20;
                    out[9] = m21;
                    out[10] = m22;
                    out[11] = m23;
                    out[12] = m30;
                    out[13] = m31;
                    out[14] = m32;
                    out[15] = m33;
                    return this;
                },
                /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to copy the values from.
     *
     * @return {this} This Matrix4.
     */ copy: function(src) {
                    var a = src.val;
                    return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                },
                /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix4#fromArray
     * @since 3.0.0
     *
     * @param {number[]} a - The array to copy the values from. Must have at least 16 elements.
     *
     * @return {this} This Matrix4.
     */ fromArray: function(a) {
                    return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                },
                /**
     * Reset this Matrix.
     *
     * Sets all values to `0`.
     *
     * @method Phaser.Math.Matrix4#zero
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} This Matrix4.
     */ zero: function() {
                    return this.setValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                },
                /**
     * Generates a transform matrix based on the given position, scale and rotation.
     *
     * @method Phaser.Math.Matrix4#transform
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {Phaser.Math.Vector3} scale - The scale vector.
     * @param {Phaser.Math.Quaternion} rotation - The rotation quaternion.
     *
     * @return {this} This Matrix4.
     */ transform: function(position, scale, rotation) {
                    var rotMatrix = _tempMat1.fromQuat(rotation);
                    var rm = rotMatrix.val;
                    var sx = scale.x;
                    var sy = scale.y;
                    var sz = scale.z;
                    return this.setValues(rm[0] * sx, rm[1] * sx, rm[2] * sx, 0, rm[4] * sy, rm[5] * sy, rm[6] * sy, 0, rm[8] * sz, rm[9] * sz, rm[10] * sz, 0, position.x, position.y, position.z, 1);
                },
                /**
     * Set the `x`, `y` and `z` values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#xyz
     * @since 3.0.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {number} z - The z value.
     *
     * @return {this} This Matrix4.
     */ xyz: function(x, y, z) {
                    this.identity();
                    var out = this.val;
                    out[12] = x;
                    out[13] = y;
                    out[14] = z;
                    return this;
                },
                /**
     * Set the scaling values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaling
     * @since 3.0.0
     *
     * @param {number} x - The x scaling value.
     * @param {number} y - The y scaling value.
     * @param {number} z - The z scaling value.
     *
     * @return {this} This Matrix4.
     */ scaling: function(x, y, z) {
                    this.zero();
                    var out = this.val;
                    out[0] = x;
                    out[5] = y;
                    out[10] = z;
                    out[15] = 1;
                    return this;
                },
                /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix4#identity
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ identity: function() {
                    return this.setValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                },
                /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix4#transpose
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ transpose: function() {
                    var a = this.val;
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a23 = a[11];
                    a[1] = a[4];
                    a[2] = a[8];
                    a[3] = a[12];
                    a[4] = a01;
                    a[6] = a[9];
                    a[7] = a[13];
                    a[8] = a02;
                    a[9] = a12;
                    a[11] = a[14];
                    a[12] = a03;
                    a[13] = a13;
                    a[14] = a23;
                    return this;
                },
                /**
     * Copies the given Matrix4 into this Matrix and then inverses it.
     *
     * @method Phaser.Math.Matrix4#getInverse
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to invert into this Matrix4.
     *
     * @return {this} This Matrix4.
     */ getInverse: function(m) {
                    this.copy(m);
                    return this.invert();
                },
                /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix4#invert
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ invert: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    //  Calculate the determinant
                    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    if (!det) return this;
                    det = 1 / det;
                    return this.setValues((a11 * b11 - a12 * b10 + a13 * b09) * det, (a02 * b10 - a01 * b11 - a03 * b09) * det, (a31 * b05 - a32 * b04 + a33 * b03) * det, (a22 * b04 - a21 * b05 - a23 * b03) * det, (a12 * b08 - a10 * b11 - a13 * b07) * det, (a00 * b11 - a02 * b08 + a03 * b07) * det, (a32 * b02 - a30 * b05 - a33 * b01) * det, (a20 * b05 - a22 * b02 + a23 * b01) * det, (a10 * b10 - a11 * b08 + a13 * b06) * det, (a01 * b08 - a00 * b10 - a03 * b06) * det, (a30 * b04 - a31 * b02 + a33 * b00) * det, (a21 * b02 - a20 * b04 - a23 * b00) * det, (a11 * b07 - a10 * b09 - a12 * b06) * det, (a00 * b09 - a01 * b07 + a02 * b06) * det, (a31 * b01 - a30 * b03 - a32 * b00) * det, (a20 * b03 - a21 * b01 + a22 * b00) * det);
                },
                /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix4#adjoint
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ adjoint: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    return this.setValues(a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22), -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22)), a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12), -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12)), -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22)), a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22), -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12)), a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12), a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21), -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21)), a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11), -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11)), -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21)), a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21), -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11)), a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
                },
                /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix4#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    // Calculate the determinant
                    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix4#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to multiply this Matrix by.
     *
     * @return {this} This Matrix4.
     */ multiply: function(src) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b = src.val;
                    // Cache only the current line of the second matrix
                    var b0 = b[0];
                    var b1 = b[1];
                    var b2 = b[2];
                    var b3 = b[3];
                    a[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[4];
                    b1 = b[5];
                    b2 = b[6];
                    b3 = b[7];
                    a[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[8];
                    b1 = b[9];
                    b2 = b[10];
                    b3 = b[11];
                    a[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[12];
                    b1 = b[13];
                    b2 = b[14];
                    b3 = b[15];
                    a[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    return this;
                },
                /**
     * Multiply the values of this Matrix4 by those given in the `src` argument.
     *
     * @method Phaser.Math.Matrix4#multiplyLocal
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The source Matrix4 that this Matrix4 is multiplied by.
     *
     * @return {this} This Matrix4.
     */ multiplyLocal: function(src) {
                    var a = this.val;
                    var b = src.val;
                    return this.setValues(a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12], a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13], a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14], a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15], a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12], a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13], a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14], a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15], a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12], a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13], a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14], a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15], a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12], a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13], a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14], a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15]);
                },
                /**
     * Multiplies the given Matrix4 object with this Matrix.
     *
     * This is the same as calling `multiplyMatrices(m, this)`.
     *
     * @method Phaser.Math.Matrix4#premultiply
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to multiply with this one.
     *
     * @return {this} This Matrix4.
     */ premultiply: function(m) {
                    return this.multiplyMatrices(m, this);
                },
                /**
     * Multiplies the two given Matrix4 objects and stores the results in this Matrix.
     *
     * @method Phaser.Math.Matrix4#multiplyMatrices
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} a - The first Matrix4 to multiply.
     * @param {Phaser.Math.Matrix4} b - The second Matrix4 to multiply.
     *
     * @return {this} This Matrix4.
     */ multiplyMatrices: function(a, b) {
                    var am = a.val;
                    var bm = b.val;
                    var a11 = am[0];
                    var a12 = am[4];
                    var a13 = am[8];
                    var a14 = am[12];
                    var a21 = am[1];
                    var a22 = am[5];
                    var a23 = am[9];
                    var a24 = am[13];
                    var a31 = am[2];
                    var a32 = am[6];
                    var a33 = am[10];
                    var a34 = am[14];
                    var a41 = am[3];
                    var a42 = am[7];
                    var a43 = am[11];
                    var a44 = am[15];
                    var b11 = bm[0];
                    var b12 = bm[4];
                    var b13 = bm[8];
                    var b14 = bm[12];
                    var b21 = bm[1];
                    var b22 = bm[5];
                    var b23 = bm[9];
                    var b24 = bm[13];
                    var b31 = bm[2];
                    var b32 = bm[6];
                    var b33 = bm[10];
                    var b34 = bm[14];
                    var b41 = bm[3];
                    var b42 = bm[7];
                    var b43 = bm[11];
                    var b44 = bm[15];
                    return this.setValues(a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41, a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41, a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41, a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41, a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42, a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42, a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42, a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42, a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43, a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43, a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43, a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43, a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44, a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44, a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44, a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44);
                },
                /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix4#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {this} This Matrix4.
     */ translate: function(v) {
                    return this.translateXYZ(v.x, v.y, v.z);
                },
                /**
     * Translate this Matrix using the given values.
     *
     * @method Phaser.Math.Matrix4#translateXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ translateXYZ: function(x, y, z) {
                    var a = this.val;
                    a[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
                    a[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
                    a[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
                    a[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
                    return this;
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x`, `y` and `z` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix4#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {this} This Matrix4.
     */ scale: function(v) {
                    return this.scaleXYZ(v.x, v.y, v.z);
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaleXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ scaleXYZ: function(x, y, z) {
                    var a = this.val;
                    a[0] = a[0] * x;
                    a[1] = a[1] * x;
                    a[2] = a[2] * x;
                    a[3] = a[3] * x;
                    a[4] = a[4] * y;
                    a[5] = a[5] * y;
                    a[6] = a[6] * y;
                    a[7] = a[7] * y;
                    a[8] = a[8] * z;
                    a[9] = a[9] * z;
                    a[10] = a[10] * z;
                    a[11] = a[11] * z;
                    return this;
                },
                /**
     * Derive a rotation matrix around the given axis.
     *
     * @method Phaser.Math.Matrix4#makeRotationAxis
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} axis - The rotation axis.
     * @param {number} angle - The rotation angle in radians.
     *
     * @return {this} This Matrix4.
     */ makeRotationAxis: function(axis, angle) {
                    // Based on http://www.gamedev.net/reference/articles/article1199.asp
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var t = 1 - c;
                    var x = axis.x;
                    var y = axis.y;
                    var z = axis.z;
                    var tx = t * x;
                    var ty = t * y;
                    return this.setValues(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                },
                /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     * @param {Phaser.Math.Vector3} axis - The axis to rotate upon.
     *
     * @return {this} This Matrix4.
     */ rotate: function(rad, axis) {
                    var a = this.val;
                    var x = axis.x;
                    var y = axis.y;
                    var z = axis.z;
                    var len = Math.sqrt(x * x + y * y + z * z);
                    if (Math.abs(len) < EPSILON) return this;
                    len = 1 / len;
                    x *= len;
                    y *= len;
                    z *= len;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var t = 1 - c;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    //  Construct the elements of the rotation matrix
                    var b00 = x * x * t + c;
                    var b01 = y * x * t + z * s;
                    var b02 = z * x * t - y * s;
                    var b10 = x * y * t - z * s;
                    var b11 = y * y * t + c;
                    var b12 = z * y * t + x * s;
                    var b20 = x * z * t + y * s;
                    var b21 = y * z * t - x * s;
                    var b22 = z * z * t + c;
                    //  Perform rotation-specific matrix multiplication
                    return this.setValues(a00 * b00 + a10 * b01 + a20 * b02, a01 * b00 + a11 * b01 + a21 * b02, a02 * b00 + a12 * b01 + a22 * b02, a03 * b00 + a13 * b01 + a23 * b02, a00 * b10 + a10 * b11 + a20 * b12, a01 * b10 + a11 * b11 + a21 * b12, a02 * b10 + a12 * b11 + a22 * b12, a03 * b10 + a13 * b11 + a23 * b12, a00 * b20 + a10 * b21 + a20 * b22, a01 * b20 + a11 * b21 + a21 * b22, a02 * b20 + a12 * b21 + a22 * b22, a03 * b20 + a13 * b21 + a23 * b22, a30, a31, a32, a33);
                },
                /**
     * Rotate this matrix on its X axis.
     *
     * @method Phaser.Math.Matrix4#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {this} This Matrix4.
     */ rotateX: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    //  Perform axis-specific matrix multiplication
                    a[4] = a10 * c + a20 * s;
                    a[5] = a11 * c + a21 * s;
                    a[6] = a12 * c + a22 * s;
                    a[7] = a13 * c + a23 * s;
                    a[8] = a20 * c - a10 * s;
                    a[9] = a21 * c - a11 * s;
                    a[10] = a22 * c - a12 * s;
                    a[11] = a23 * c - a13 * s;
                    return this;
                },
                /**
     * Rotate this matrix on its Y axis.
     *
     * @method Phaser.Math.Matrix4#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateY: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    //  Perform axis-specific matrix multiplication
                    a[0] = a00 * c - a20 * s;
                    a[1] = a01 * c - a21 * s;
                    a[2] = a02 * c - a22 * s;
                    a[3] = a03 * c - a23 * s;
                    a[8] = a00 * s + a20 * c;
                    a[9] = a01 * s + a21 * c;
                    a[10] = a02 * s + a22 * c;
                    a[11] = a03 * s + a23 * c;
                    return this;
                },
                /**
     * Rotate this matrix on its Z axis.
     *
     * @method Phaser.Math.Matrix4#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateZ: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    //  Perform axis-specific matrix multiplication
                    a[0] = a00 * c + a10 * s;
                    a[1] = a01 * c + a11 * s;
                    a[2] = a02 * c + a12 * s;
                    a[3] = a03 * c + a13 * s;
                    a[4] = a10 * c - a00 * s;
                    a[5] = a11 * c - a01 * s;
                    a[6] = a12 * c - a02 * s;
                    a[7] = a13 * c - a03 * s;
                    return this;
                },
                /**
     * Set the values of this Matrix from the given rotation Quaternion and translation Vector.
     *
     * @method Phaser.Math.Matrix4#fromRotationTranslation
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set rotation from.
     * @param {Phaser.Math.Vector3} v - The Vector to set translation from.
     *
     * @return {this} This Matrix4.
     */ fromRotationTranslation: function(q, v) {
                    //  Quaternion math
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, v.x, v.y, v.z, 1);
                },
                /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix4#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {this} This Matrix4.
     */ fromQuat: function(q) {
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, 0, 0, 0, 1);
                },
                /**
     * Generate a frustum matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#frustum
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ frustum: function(left, right, bottom, top, near, far) {
                    var rl = 1 / (right - left);
                    var tb = 1 / (top - bottom);
                    var nf = 1 / (near - far);
                    return this.setValues(near * 2 * rl, 0, 0, 0, 0, near * 2 * tb, 0, 0, (right + left) * rl, (top + bottom) * tb, (far + near) * nf, -1, 0, 0, far * near * 2 * nf, 0);
                },
                /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspective
     * @since 3.0.0
     *
     * @param {number} fovy - Vertical field of view in radians
     * @param {number} aspect - Aspect ratio. Typically viewport width  /height.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspective: function(fovy, aspect, near, far) {
                    var f = 1.0 / Math.tan(fovy / 2);
                    var nf = 1 / (near - far);
                    return this.setValues(f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (far + near) * nf, -1, 0, 0, 2 * far * near * nf, 0);
                },
                /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspectiveLH
     * @since 3.0.0
     *
     * @param {number} width - The width of the frustum.
     * @param {number} height - The height of the frustum.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspectiveLH: function(width, height, near, far) {
                    return this.setValues(2 * near / width, 0, 0, 0, 0, 2 * near / height, 0, 0, 0, 0, -far / (near - far), 1, 0, 0, near * far / (near - far), 0);
                },
                /**
     * Generate an orthogonal projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#ortho
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ ortho: function(left, right, bottom, top, near, far) {
                    var lr = left - right;
                    var bt = bottom - top;
                    var nf = near - far;
                    //  Avoid division by zero
                    lr = lr === 0 ? lr : 1 / lr;
                    bt = bt === 0 ? bt : 1 / bt;
                    nf = nf === 0 ? nf : 1 / nf;
                    return this.setValues(-2 * lr, 0, 0, 0, 0, -2 * bt, 0, 0, 0, 0, 2 * nf, 0, (left + right) * lr, (top + bottom) * bt, (far + near) * nf, 1);
                },
                /**
     * Generate a right-handed look-at matrix with the given eye position, target and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAtRH
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer.
     * @param {Phaser.Math.Vector3} target - Point the viewer is looking at.
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAtRH: function(eye, target, up) {
                    var m = this.val;
                    _z.subVectors(eye, target);
                    if (_z.getLengthSquared() === 0) // eye and target are in the same position
                    _z.z = 1;
                    _z.normalize();
                    _x.crossVectors(up, _z);
                    if (_x.getLengthSquared() === 0) {
                        // up and z are parallel
                        if (Math.abs(up.z) === 1) _z.x += 0.0001;
                        else _z.z += 0.0001;
                        _z.normalize();
                        _x.crossVectors(up, _z);
                    }
                    _x.normalize();
                    _y.crossVectors(_z, _x);
                    m[0] = _x.x;
                    m[1] = _x.y;
                    m[2] = _x.z;
                    m[4] = _y.x;
                    m[5] = _y.y;
                    m[6] = _y.z;
                    m[8] = _z.x;
                    m[9] = _z.y;
                    m[10] = _z.z;
                    return this;
                },
                /**
     * Generate a look-at matrix with the given eye position, focal point, and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAt
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer
     * @param {Phaser.Math.Vector3} center - Point the viewer is looking at
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAt: function(eye, center, up) {
                    var eyex = eye.x;
                    var eyey = eye.y;
                    var eyez = eye.z;
                    var upx = up.x;
                    var upy = up.y;
                    var upz = up.z;
                    var centerx = center.x;
                    var centery = center.y;
                    var centerz = center.z;
                    if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) return this.identity();
                    var z0 = eyex - centerx;
                    var z1 = eyey - centery;
                    var z2 = eyez - centerz;
                    var len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
                    z0 *= len;
                    z1 *= len;
                    z2 *= len;
                    var x0 = upy * z2 - upz * z1;
                    var x1 = upz * z0 - upx * z2;
                    var x2 = upx * z1 - upy * z0;
                    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
                    if (!len) {
                        x0 = 0;
                        x1 = 0;
                        x2 = 0;
                    } else {
                        len = 1 / len;
                        x0 *= len;
                        x1 *= len;
                        x2 *= len;
                    }
                    var y0 = z1 * x2 - z2 * x1;
                    var y1 = z2 * x0 - z0 * x2;
                    var y2 = z0 * x1 - z1 * x0;
                    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
                    if (!len) {
                        y0 = 0;
                        y1 = 0;
                        y2 = 0;
                    } else {
                        len = 1 / len;
                        y0 *= len;
                        y1 *= len;
                        y2 *= len;
                    }
                    return this.setValues(x0, y0, z0, 0, x1, y1, z1, 0, x2, y2, z2, 0, -(x0 * eyex + x1 * eyey + x2 * eyez), -(y0 * eyex + y1 * eyey + y2 * eyez), -(z0 * eyex + z1 * eyey + z2 * eyez), 1);
                },
                /**
     * Set the values of this matrix from the given `yaw`, `pitch` and `roll` values.
     *
     * @method Phaser.Math.Matrix4#yawPitchRoll
     * @since 3.0.0
     *
     * @param {number} yaw - The yaw value.
     * @param {number} pitch - The pitch value.
     * @param {number} roll - The roll value.
     *
     * @return {this} This Matrix4.
     */ yawPitchRoll: function(yaw, pitch, roll) {
                    this.zero();
                    _tempMat1.zero();
                    _tempMat2.zero();
                    var m0 = this.val;
                    var m1 = _tempMat1.val;
                    var m2 = _tempMat2.val;
                    //  Rotate Z
                    var s = Math.sin(roll);
                    var c = Math.cos(roll);
                    m0[10] = 1;
                    m0[15] = 1;
                    m0[0] = c;
                    m0[1] = s;
                    m0[4] = -s;
                    m0[5] = c;
                    //  Rotate X
                    s = Math.sin(pitch);
                    c = Math.cos(pitch);
                    m1[0] = 1;
                    m1[15] = 1;
                    m1[5] = c;
                    m1[10] = c;
                    m1[9] = -s;
                    m1[6] = s;
                    //  Rotate Y
                    s = Math.sin(yaw);
                    c = Math.cos(yaw);
                    m2[5] = 1;
                    m2[15] = 1;
                    m2[0] = c;
                    m2[2] = -s;
                    m2[8] = s;
                    m2[10] = c;
                    this.multiplyLocal(_tempMat1);
                    this.multiplyLocal(_tempMat2);
                    return this;
                },
                /**
     * Generate a world matrix from the given rotation, position, scale, view matrix and projection matrix.
     *
     * @method Phaser.Math.Matrix4#setWorldMatrix
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation of the world matrix.
     * @param {Phaser.Math.Vector3} position - The position of the world matrix.
     * @param {Phaser.Math.Vector3} scale - The scale of the world matrix.
     * @param {Phaser.Math.Matrix4} [viewMatrix] - The view matrix.
     * @param {Phaser.Math.Matrix4} [projectionMatrix] - The projection matrix.
     *
     * @return {this} This Matrix4.
     */ setWorldMatrix: function(rotation, position, scale, viewMatrix, projectionMatrix) {
                    this.yawPitchRoll(rotation.y, rotation.x, rotation.z);
                    _tempMat1.scaling(scale.x, scale.y, scale.z);
                    _tempMat2.xyz(position.x, position.y, position.z);
                    this.multiplyLocal(_tempMat1);
                    this.multiplyLocal(_tempMat2);
                    if (viewMatrix) this.multiplyLocal(viewMatrix);
                    if (projectionMatrix) this.multiplyLocal(projectionMatrix);
                    return this;
                },
                /**
     * Multiplies this Matrix4 by the given `src` Matrix4 and stores the results in the `out` Matrix4.
     *
     * @method Phaser.Math.Matrix4#multiplyToMat4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix4 to multiply with this one.
     * @param {Phaser.Math.Matrix4} out - The receiving Matrix.
     *
     * @return {Phaser.Math.Matrix4} This `out` Matrix4.
     */ multiplyToMat4: function(src, out) {
                    var a = this.val;
                    var b = src.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = b[0];
                    var b01 = b[1];
                    var b02 = b[2];
                    var b03 = b[3];
                    var b10 = b[4];
                    var b11 = b[5];
                    var b12 = b[6];
                    var b13 = b[7];
                    var b20 = b[8];
                    var b21 = b[9];
                    var b22 = b[10];
                    var b23 = b[11];
                    var b30 = b[12];
                    var b31 = b[13];
                    var b32 = b[14];
                    var b33 = b[15];
                    return out.setValues(b00 * a00 + b01 * a10 + b02 * a20 + b03 * a30, b01 * a01 + b01 * a11 + b02 * a21 + b03 * a31, b02 * a02 + b01 * a12 + b02 * a22 + b03 * a32, b03 * a03 + b01 * a13 + b02 * a23 + b03 * a33, b10 * a00 + b11 * a10 + b12 * a20 + b13 * a30, b10 * a01 + b11 * a11 + b12 * a21 + b13 * a31, b10 * a02 + b11 * a12 + b12 * a22 + b13 * a32, b10 * a03 + b11 * a13 + b12 * a23 + b13 * a33, b20 * a00 + b21 * a10 + b22 * a20 + b23 * a30, b20 * a01 + b21 * a11 + b22 * a21 + b23 * a31, b20 * a02 + b21 * a12 + b22 * a22 + b23 * a32, b20 * a03 + b21 * a13 + b22 * a23 + b23 * a33, b30 * a00 + b31 * a10 + b32 * a20 + b33 * a30, b30 * a01 + b31 * a11 + b32 * a21 + b33 * a31, b30 * a02 + b31 * a12 + b32 * a22 + b33 * a32, b30 * a03 + b31 * a13 + b32 * a23 + b33 * a33);
                },
                /**
     * Takes the rotation and position vectors and builds this Matrix4 from them.
     *
     * @method Phaser.Math.Matrix4#fromRotationXYTranslation
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation vector.
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {boolean} translateFirst - Should the operation translate then rotate (`true`), or rotate then translate? (`false`)
     *
     * @return {this} This Matrix4.
     */ fromRotationXYTranslation: function(rotation, position, translateFirst) {
                    var x = position.x;
                    var y = position.y;
                    var z = position.z;
                    var sx = Math.sin(rotation.x);
                    var cx = Math.cos(rotation.x);
                    var sy = Math.sin(rotation.y);
                    var cy = Math.cos(rotation.y);
                    var a30 = x;
                    var a31 = y;
                    var a32 = z;
                    //  Rotate X
                    var b21 = -sx;
                    //  Rotate Y
                    var c01 = 0 - b21 * sy;
                    var c02 = 0 - cx * sy;
                    var c21 = b21 * cy;
                    var c22 = cx * cy;
                    //  Translate
                    if (!translateFirst) {
                        // a30 = cy * x + 0 * y + sy * z;
                        a30 = cy * x + sy * z;
                        a31 = c01 * x + cx * y + c21 * z;
                        a32 = c02 * x + sx * y + c22 * z;
                    }
                    return this.setValues(cy, c01, c02, 0, 0, cx, sx, 0, sy, c21, c22, 0, a30, a31, a32, 1);
                },
                /**
     * Returns the maximum axis scale from this Matrix4.
     *
     * @method Phaser.Math.Matrix4#getMaxScaleOnAxis
     * @since 3.50.0
     *
     * @return {number} The maximum axis scale.
     */ getMaxScaleOnAxis: function() {
                    var m = this.val;
                    var scaleXSq = m[0] * m[0] + m[1] * m[1] + m[2] * m[2];
                    var scaleYSq = m[4] * m[4] + m[5] * m[5] + m[6] * m[6];
                    var scaleZSq = m[8] * m[8] + m[9] * m[9] + m[10] * m[10];
                    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
                }
            });
            /**
 * @ignore
 */ var _tempMat1 = new Matrix4();
            /**
 * @ignore
 */ var _tempMat2 = new Matrix4();
            /**
 * @ignore
 */ var _x = new Vector3();
            /**
 * @ignore
 */ var _y = new Vector3();
            /**
 * @ignore
 */ var _z = new Vector3();
            module1.exports = Matrix4;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound.Events
 */ module1.exports = {
                COMPLETE: __webpack_require__(987),
                DECODED: __webpack_require__(988),
                DECODED_ALL: __webpack_require__(989),
                DESTROY: __webpack_require__(990),
                DETUNE: __webpack_require__(991),
                GLOBAL_DETUNE: __webpack_require__(992),
                GLOBAL_MUTE: __webpack_require__(993),
                GLOBAL_RATE: __webpack_require__(994),
                GLOBAL_VOLUME: __webpack_require__(995),
                LOOP: __webpack_require__(996),
                LOOPED: __webpack_require__(997),
                MUTE: __webpack_require__(998),
                PAN: __webpack_require__(999),
                PAUSE_ALL: __webpack_require__(1000),
                PAUSE: __webpack_require__(1001),
                PLAY: __webpack_require__(1002),
                RATE: __webpack_require__(1003),
                RESUME_ALL: __webpack_require__(1004),
                RESUME: __webpack_require__(1005),
                SEEK: __webpack_require__(1006),
                STOP_ALL: __webpack_require__(1007),
                STOP: __webpack_require__(1008),
                UNLOCKED: __webpack_require__(1009),
                VOLUME: __webpack_require__(1010)
            };
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#image method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#image.
 *
 * @class ImageFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. Only provided for, and used by, Sprite Sheets.
 */ var ImageFile = new Class({
                Extends: File,
                initialize: function ImageFile(loader, key, url, xhrSettings, frameConfig) {
                    var extension = "png";
                    var normalMapURL;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        normalMapURL = GetFastValue(config, "normalMap");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        frameConfig = GetFastValue(config, "frameConfig");
                    }
                    if (Array.isArray(url)) {
                        normalMapURL = url[1];
                        url = url[0];
                    }
                    var fileConfig = {
                        type: "image",
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: "blob",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: frameConfig
                    };
                    File.call(this, loader, fileConfig);
                    //  Do we have a normal map to load as well?
                    if (normalMapURL) {
                        var normalMap = new ImageFile(loader, this.key, normalMapURL, xhrSettings, frameConfig);
                        normalMap.type = "normalMap";
                        this.setLink(normalMap);
                        loader.addFile(normalMap);
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    var _this = this;
                    this.data.onload = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(this.data, this.xhrLoader.response, "image/png");
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture;
                    var linkFile = this.linkFile;
                    if (linkFile && linkFile.state === CONST.FILE_COMPLETE) {
                        if (this.type === "image") texture = this.cache.addImage(this.key, this.data, linkFile.data);
                        else texture = this.cache.addImage(linkFile.key, linkFile.data, this.data);
                        this.pendingDestroy(texture);
                        linkFile.pendingDestroy(texture);
                    } else if (!linkFile) {
                        texture = this.cache.addImage(this.key, this.data);
                        this.pendingDestroy(texture);
                    }
                }
            });
            /**
 * Adds an Image, or array of Images, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.image('logo', 'images/phaserLogo.png');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ImageFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.image('logo', 'images/AtariLogo.png');
 * // and later in your game ...
 * this.add.image(x, y, 'logo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.image('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ]);
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Image File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#image
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig|Phaser.Types.Loader.FileTypes.ImageFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("image", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ImageFile(this, key[i]));
                else this.addFile(new ImageFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = ImageFile;
        /***/ },
        /* 72 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to set the colliding state of a tile. This does not recalculate
 * interesting faces.
 *
 * @function Phaser.Tilemaps.Components.SetTileCollision
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to set the collision on.
 * @param {boolean} [collides=true] - Should the tile index collide or not?
 */ var SetTileCollision = function(tile, collides) {
                if (collides) tile.setCollision(true, true, true, true, false);
                else tile.resetCollision(false);
            };
            module1.exports = SetTileCollision;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(164);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var SpriteRender = __webpack_require__(1065);
            /**
 * @classdesc
 * A Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Sprite = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    SpriteRender
                ],
                initialize: function Sprite(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, "Sprite");
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Animation State component of this Sprite.
         *
         * This component provides features to apply animations to this Sprite.
         * It is responsible for playing, loading, queuing animations for later playback,
         * mixing between animations and setting the current animation frame to this Sprite.
         *
         * @name Phaser.GameObjects.Sprite#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.0.0
         */ this.anims = new AnimationState(this);
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.setOriginFromFrame();
                    this.initPipeline();
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Update this Sprite's animations.
     *
     * @method Phaser.GameObjects.Sprite#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    this.anims.update(time, delta);
                },
                /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying) {
                    return this.anims.play(key, ignoreIfPlaying);
                },
                /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ playReverse: function(key, ignoreIfPlaying) {
                    return this.anims.playReverse(key, ignoreIfPlaying);
                },
                /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay'.
     *
     * @method Phaser.GameObjects.Sprite#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {this} This Game Object.
     */ playAfterDelay: function(key, delay) {
                    return this.anims.playAfterDelay(key, delay);
                },
                /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {this} This Game Object.
     */ playAfterRepeat: function(key, repeatCount) {
                    return this.anims.playAfterRepeat(key, repeatCount);
                },
                /**
     * Sets an animation, or an array of animations, to be played immediately after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have the `stop` method called directly on it.
     *
     * An animation set to repeat forever will never enter a completed state.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it,
     * or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained
     * animations without impacting the animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#chain
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {this} This Game Object.
     */ chain: function(key) {
                    return this.anims.chain(key);
                },
                /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` events.
     *
     * If no animation is playing, no event will be dispatched.
     *
     * If there is another animation queued (via the `chain` method) then it will start playing immediately.
     *
     * @method Phaser.GameObjects.Sprite#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @return {this} This Game Object.
     */ stop: function() {
                    return this.anims.stop();
                },
                /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopAfterDelay: function(delay) {
                    return this.anims.stopAfterDelay(delay);
                },
                /**
     * Stops the current animation from playing after the given number of repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {this} This Game Object.
     */ stopAfterRepeat: function(repeatCount) {
                    return this.anims.stopAfterRepeat(repeatCount);
                },
                /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopOnFrame: function(frame) {
                    return this.anims.stopOnFrame(frame);
                },
                /**
     * Build a JSON representation of this Sprite.
     *
     * @method Phaser.GameObjects.Sprite#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return Components.ToJSON(this);
                },
                /**
     * Handles the pre-destroy step for the Sprite, which removes the Animation component.
     *
     * @method Phaser.GameObjects.Sprite#preDestroy
     * @private
     * @since 3.14.0
     */ preDestroy: function() {
                    this.anims.destroy();
                    this.anims = undefined;
                }
            });
            module1.exports = Sprite;
        /***/ },
        /* 74 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Removes a single item from an array and returns it without creating gc, like the native splice does.
 * Based on code by Mike Reinstein.
 *
 * @function Phaser.Utils.Array.SpliceOne
 * @since 3.0.0
 *
 * @param {array} array - The array to splice from.
 * @param {number} index - The index of the item which should be spliced.
 *
 * @return {*} The item which was spliced (removed).
 */ var SpliceOne = function(array, index) {
                if (index >= array.length) return;
                var len = array.length - 1;
                var item = array[index];
                for(var i = index; i < len; i++)array[i] = array[i + 1];
                array.length = len;
                return item;
            };
            module1.exports = SpliceOne;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Events
 */ module1.exports = {
                ADDED_TO_SCENE: __webpack_require__(643),
                DESTROY: __webpack_require__(644),
                REMOVED_FROM_SCENE: __webpack_require__(645),
                VIDEO_COMPLETE: __webpack_require__(646),
                VIDEO_CREATED: __webpack_require__(647),
                VIDEO_ERROR: __webpack_require__(648),
                VIDEO_LOOP: __webpack_require__(649),
                VIDEO_PLAY: __webpack_require__(650),
                VIDEO_SEEKED: __webpack_require__(651),
                VIDEO_SEEKING: __webpack_require__(652),
                VIDEO_STOP: __webpack_require__(653),
                VIDEO_TIMEOUT: __webpack_require__(654),
                VIDEO_UNLOCKED: __webpack_require__(655)
            };
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using floor.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10`.
 * As will `14` snap to `10`... but `16` will snap to `15`.
 *
 * @function Phaser.Math.Snap.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapFloor = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.floor(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapFloor;
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shallow Object Clone. Will not clone nested objects.
 *
 * @function Phaser.Utils.Objects.Clone
 * @since 3.0.0
 *
 * @param {object} obj - The object to clone.
 *
 * @return {object} A new object with the same properties as the input object.
 */ var Clone = function(obj) {
                var clone = {};
                for(var key in obj)if (Array.isArray(obj[key])) clone[key] = obj[key].slice(0);
                else clone[key] = obj[key];
                return clone;
            };
            module1.exports = Clone;
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if the start and end indexes are a safe range for the given array.
 * 
 * @function Phaser.Utils.Array.SafeRange
 * @since 3.4.0
 *
 * @param {array} array - The array to check.
 * @param {number} startIndex - The start index.
 * @param {number} endIndex - The end index.
 * @param {boolean} [throwError=true] - Throw an error if the range is out of bounds.
 *
 * @return {boolean} True if the range is safe, otherwise false.
 */ var SafeRange = function(array, startIndex, endIndex, throwError) {
                var len = array.length;
                if (startIndex < 0 || startIndex > len || startIndex >= endIndex || endIndex > len || startIndex + endIndex > len) {
                    if (throwError) throw new Error("Range Error: Values outside acceptable range");
                    return false;
                } else return true;
            };
            module1.exports = SafeRange;
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Angry Bytes (and contributors)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The comparator function.
 *
 * @ignore
 *
 * @param {*} a - The first item to test.
 * @param {*} b - The second itemt to test.
 *
 * @return {boolean} True if they localCompare, otherwise false.
 */ function Compare(a, b) {
                return String(a).localeCompare(b);
            }
            /**
 * Process the array contents.
 *
 * @ignore
 *
 * @param {array} array - The array to process.
 * @param {function} compare - The comparison function.
 *
 * @return {array} - The processed array.
 */ function Process(array, compare) {
                // Short-circuit when there's nothing to sort.
                var len = array.length;
                if (len <= 1) return array;
                // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
                // Chunks are the size of the left or right hand in merge sort.
                // Stop when the left-hand covers all of the array.
                var buffer = new Array(len);
                for(var chk = 1; chk < len; chk *= 2){
                    RunPass(array, compare, chk, buffer);
                    var tmp = array;
                    array = buffer;
                    buffer = tmp;
                }
                return array;
            }
            /**
 * Run a single pass with the given chunk size.
 *
 * @ignore
 *
 * @param {array} arr - The array to run the pass on.
 * @param {function} comp - The comparison function.
 * @param {number} chk - The number of iterations.
 * @param {array} result - The array to store the result in.
 */ function RunPass(arr, comp, chk, result) {
                var len = arr.length;
                var i = 0;
                // Step size / double chunk size.
                var dbl = chk * 2;
                // Bounds of the left and right chunks.
                var l, r, e;
                // Iterators over the left and right chunk.
                var li, ri;
                // Iterate over pairs of chunks.
                for(l = 0; l < len; l += dbl){
                    r = l + chk;
                    e = r + chk;
                    if (r > len) r = len;
                    if (e > len) e = len;
                    // Iterate both chunks in parallel.
                    li = l;
                    ri = r;
                    while(true){
                        // Compare the chunks.
                        if (li < r && ri < e) {
                            // This works for a regular `sort()` compatible comparator,
                            // but also for a simple comparator like: `a > b`
                            if (comp(arr[li], arr[ri]) <= 0) result[i++] = arr[li++];
                            else result[i++] = arr[ri++];
                        } else if (li < r) // Nothing to compare, just flush what's left.
                        result[i++] = arr[li++];
                        else if (ri < e) result[i++] = arr[ri++];
                        else break;
                    }
                }
            }
            /**
 * An in-place stable array sort, because `Array#sort()` is not guaranteed stable.
 *
 * This is an implementation of merge sort, without recursion.
 *
 * Function based on the Two-Screen/stable sort 0.1.8 from https://github.com/Two-Screen/stable
 *
 * @function Phaser.Utils.Array.StableSort
 * @since 3.0.0
 *
 * @param {array} array - The input array to be sorted.
 * @param {function} [compare] - The comparison function.
 *
 * @return {array} The sorted result.
 */ var StableSort = function(array, compare) {
                if (compare === undefined) compare = Compare;
                var result = Process(array, compare);
                // This simply copies back if the result isn't in the original array, which happens on an odd number of passes.
                if (result !== array) RunPass(result, null, array.length, array);
                return array;
            };
            module1.exports = StableSort;
        /***/ },
        /* 80 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EaseMap = __webpack_require__(134);
            var UppercaseFirst = __webpack_require__(205);
            /**
 * This internal function is used to return the correct ease function for a Tween.
 * 
 * It can take a variety of input, including an EaseMap based string, or a custom function.
 *
 * @function Phaser.Tweens.Builders.GetEaseFunction
 * @since 3.0.0
 *
 * @param {(string|function)} ease - The ease to find. This can be either a string from the EaseMap, or a custom function.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {function} The ease function.
 */ var GetEaseFunction = function(ease, easeParams) {
                //  Default ease function
                var easeFunction = EaseMap.Power0;
                //  Prepare ease function
                if (typeof ease === "string") {
                    //  String based look-up
                    //  1) They specified it correctly
                    if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                    else {
                        //  Do some string manipulation to try and find it
                        var direction = "";
                        if (ease.indexOf(".")) {
                            //  quad.in = Quad.easeIn
                            //  quad.out = Quad.easeOut
                            //  quad.inout = Quad.easeInOut
                            direction = ease.substr(ease.indexOf(".") + 1);
                            if (direction.toLowerCase() === "in") direction = "easeIn";
                            else if (direction.toLowerCase() === "out") direction = "easeOut";
                            else if (direction.toLowerCase() === "inout") direction = "easeInOut";
                        }
                        ease = UppercaseFirst(ease.substr(0, ease.indexOf(".") + 1) + direction);
                        if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                    }
                } else if (typeof ease === "function") //  Custom function
                easeFunction = ease;
                else Array.isArray(ease) && ease.length;
                //  No custom ease parameters?
                if (!easeParams) //  Return ease function
                return easeFunction;
                var cloneParams = easeParams.slice(0);
                cloneParams.unshift(0);
                //  Return ease function with custom ease parameters
                return function(v) {
                    cloneParams[0] = v;
                    return easeFunction.apply(this, cloneParams);
                };
            };
            module1.exports = GetEaseFunction;
        /***/ },
        /* 81 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders a stroke outline around the given Shape.
 *
 * @method Phaser.GameObjects.Shape#StrokePathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var StrokePathWebGL = function(pipeline, src, alpha, dx, dy) {
                var strokeTint = pipeline.strokeTint;
                var strokeTintColor = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                strokeTint.TL = strokeTintColor;
                strokeTint.TR = strokeTintColor;
                strokeTint.BL = strokeTintColor;
                strokeTint.BR = strokeTintColor;
                var path = src.pathData;
                var pathLength = path.length - 1;
                var lineWidth = src.lineWidth;
                var halfLineWidth = lineWidth / 2;
                var px1 = path[0] - dx;
                var py1 = path[1] - dy;
                if (!src.closePath) pathLength -= 2;
                for(var i = 2; i < pathLength; i += 2){
                    var px2 = path[i] - dx;
                    var py2 = path[i + 1] - dy;
                    pipeline.batchLine(px1, py1, px2, py2, halfLineWidth, halfLineWidth, lineWidth, i - 2, src.closePath ? i === pathLength - 1 : false);
                    px1 = px2;
                    py1 = py2;
                }
            };
            module1.exports = StrokePathWebGL;
        /***/ },
        /* 82 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(115);
            var GetPoint = __webpack_require__(476);
            var GetPoints = __webpack_require__(477);
            var GEOM_CONST = __webpack_require__(56);
            var Line = __webpack_require__(47);
            var Random = __webpack_require__(181);
            /**
 * @classdesc
 * A triangle is a plane created by connecting three points.
 * The first two arguments specify the first point, the middle two arguments
 * specify the second point, and the last two arguments specify the third point.
 *
 * @class Triangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - `x` coordinate of the first point.
 * @param {number} [y1=0] - `y` coordinate of the first point.
 * @param {number} [x2=0] - `x` coordinate of the second point.
 * @param {number} [y2=0] - `y` coordinate of the second point.
 * @param {number} [x3=0] - `x` coordinate of the third point.
 * @param {number} [y3=0] - `y` coordinate of the third point.
 */ var Triangle = new Class({
                initialize: function Triangle(x1, y1, x2, y2, x3, y3) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 0;
                    if (y3 === undefined) y3 = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.TRIANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Triangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.TRIANGLE;
                    /**
         * `x` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#x1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x1 = x1;
                    /**
         * `y` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#y1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y1 = y1;
                    /**
         * `x` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#x2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x2 = x2;
                    /**
         * `y` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#y2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y2 = y2;
                    /**
         * `x` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#x3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x3 = x3;
                    /**
         * `y` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#y3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y3 = y3;
                },
                /**
     * Checks whether a given points lies within the triangle.
     *
     * @method Phaser.Geom.Triangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to check.
     * @param {number} y - The y coordinate of the point to check.
     *
     * @return {boolean} `true` if the coordinate pair is within the triangle, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a specific point  on the triangle.
     *
     * @method Phaser.Geom.Triangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - Position as float within `0` and `1`. `0` equals the first point.
     * @param {(Phaser.Geom.Point|object)} [output] - Optional Point, or point-like object, that the calculated point will be written to.
     *
     * @return {(Phaser.Geom.Point|object)} Calculated `Point` that represents the requested position. It is the same as `output` when this parameter has been given.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Calculates a list of evenly distributed points on the triangle. It is either possible to pass an amount of points to be generated (`quantity`) or the distance between two points (`stepRate`).
     *
     * @method Phaser.Geom.Triangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - Number of points to be generated. Can be falsey when `stepRate` should be used. All points have the same distance along the triangle.
     * @param {number} [stepRate] - Distance between two points. Will only be used when `quantity` is falsey.
     * @param {(array|Phaser.Geom.Point[])} [output] - Optional Array for writing the calculated points into. Otherwise a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} Returns a list of calculated `Point` instances or the filled array passed as parameter `output`.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a random point along the triangle.
     *
     * @method Phaser.Geom.Triangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - Optional `Point` that should be modified. Otherwise a new one will be created.
     *
     * @return {Phaser.Geom.Point} Random `Point`. When parameter `point` has been provided it will be returned.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets all three points of the triangle. Leaving out any coordinate sets it to be `0`.
     *
     * @method Phaser.Geom.Triangle#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - `x` coordinate of the first point.
     * @param {number} [y1=0] - `y` coordinate of the first point.
     * @param {number} [x2=0] - `x` coordinate of the second point.
     * @param {number} [y2=0] - `y` coordinate of the second point.
     * @param {number} [x3=0] - `x` coordinate of the third point.
     * @param {number} [y3=0] - `y` coordinate of the third point.
     *
     * @return {this} This Triangle object.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 0;
                    if (y3 === undefined) y3 = 0;
                    this.x1 = x1;
                    this.y1 = y1;
                    this.x2 = x2;
                    this.y2 = y2;
                    this.x3 = x3;
                    this.y3 = y3;
                    return this;
                },
                /**
     * Returns a Line object that corresponds to Line A of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line A of this Triangle.
     */ getLineA: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x1, this.y1, this.x2, this.y2);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to Line B of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line B of this Triangle.
     */ getLineB: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x2, this.y2, this.x3, this.y3);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to Line C of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line C of this Triangle.
     */ getLineC: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x3, this.y3, this.x1, this.y1);
                    return line;
                },
                /**
     * Left most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return Math.min(this.x1, this.x2, this.x3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.x1 <= this.x2 && this.x1 <= this.x3) diff = this.x1 - value;
                        else if (this.x2 <= this.x1 && this.x2 <= this.x3) diff = this.x2 - value;
                        else diff = this.x3 - value;
                        this.x1 -= diff;
                        this.x2 -= diff;
                        this.x3 -= diff;
                    }
                },
                /**
     * Right most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return Math.max(this.x1, this.x2, this.x3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.x1 >= this.x2 && this.x1 >= this.x3) diff = this.x1 - value;
                        else if (this.x2 >= this.x1 && this.x2 >= this.x3) diff = this.x2 - value;
                        else diff = this.x3 - value;
                        this.x1 -= diff;
                        this.x2 -= diff;
                        this.x3 -= diff;
                    }
                },
                /**
     * Top most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return Math.min(this.y1, this.y2, this.y3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.y1 <= this.y2 && this.y1 <= this.y3) diff = this.y1 - value;
                        else if (this.y2 <= this.y1 && this.y2 <= this.y3) diff = this.y2 - value;
                        else diff = this.y3 - value;
                        this.y1 -= diff;
                        this.y2 -= diff;
                        this.y3 -= diff;
                    }
                },
                /**
     * Bottom most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2, this.y3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.y1 >= this.y2 && this.y1 >= this.y3) diff = this.y1 - value;
                        else if (this.y2 >= this.y1 && this.y2 >= this.y3) diff = this.y2 - value;
                        else diff = this.y3 - value;
                        this.y1 -= diff;
                        this.y2 -= diff;
                        this.y3 -= diff;
                    }
                }
            });
            module1.exports = Triangle;
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            /**
* The `Matter.Vector` module contains methods for creating and manipulating vectors.
* Vectors are the basis of all the geometry related operations in the engine.
* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vector
*/ // TODO: consider params for reusing vector objects
            var Vector = {};
            module1.exports = Vector;
            (function() {
                /**
     * Creates a new vector.
     * @method create
     * @param {number} x
     * @param {number} y
     * @return {vector} A new vector
     */ Vector.create = function(x, y) {
                    return {
                        x: x || 0,
                        y: y || 0
                    };
                };
                /**
     * Returns a new vector with `x` and `y` copied from the given `vector`.
     * @method clone
     * @param {vector} vector
     * @return {vector} A new cloned vector
     */ Vector.clone = function(vector) {
                    return {
                        x: vector.x,
                        y: vector.y
                    };
                };
                /**
     * Returns the magnitude (length) of a vector.
     * @method magnitude
     * @param {vector} vector
     * @return {number} The magnitude of the vector
     */ Vector.magnitude = function(vector) {
                    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
                };
                /**
     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
     * @method magnitudeSquared
     * @param {vector} vector
     * @return {number} The squared magnitude of the vector
     */ Vector.magnitudeSquared = function(vector) {
                    return vector.x * vector.x + vector.y * vector.y;
                };
                /**
     * Rotates the vector about (0, 0) by specified angle.
     * @method rotate
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} [output]
     * @return {vector} The vector rotated about (0, 0)
     */ Vector.rotate = function(vector, angle, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = vector.x * cos - vector.y * sin;
                    output.y = vector.x * sin + vector.y * cos;
                    output.x = x;
                    return output;
                };
                /**
     * Rotates the vector about a specified point by specified angle.
     * @method rotateAbout
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} point
     * @param {vector} [output]
     * @return {vector} A new vector rotated about the point
     */ Vector.rotateAbout = function(vector, angle, point, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
                    output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
                    output.x = x;
                    return output;
                };
                /**
     * Normalises a vector (such that its magnitude is `1`).
     * @method normalise
     * @param {vector} vector
     * @return {vector} A new vector normalised
     */ Vector.normalise = function(vector) {
                    var magnitude = Vector.magnitude(vector);
                    if (magnitude === 0) return {
                        x: 0,
                        y: 0
                    };
                    return {
                        x: vector.x / magnitude,
                        y: vector.y / magnitude
                    };
                };
                /**
     * Returns the dot-product of two vectors.
     * @method dot
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The dot product of the two vectors
     */ Vector.dot = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.x + vectorA.y * vectorB.y;
                };
                /**
     * Returns the cross-product of two vectors.
     * @method cross
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The cross product of the two vectors
     */ Vector.cross = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.y - vectorA.y * vectorB.x;
                };
                /**
     * Returns the cross-product of three vectors.
     * @method cross3
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} vectorC
     * @return {number} The cross product of the three vectors
     */ Vector.cross3 = function(vectorA, vectorB, vectorC) {
                    return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
                };
                /**
     * Adds the two vectors.
     * @method add
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB added
     */ Vector.add = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x + vectorB.x;
                    output.y = vectorA.y + vectorB.y;
                    return output;
                };
                /**
     * Subtracts the two vectors.
     * @method sub
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB subtracted
     */ Vector.sub = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x - vectorB.x;
                    output.y = vectorA.y - vectorB.y;
                    return output;
                };
                /**
     * Multiplies a vector and a scalar.
     * @method mult
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector multiplied by scalar
     */ Vector.mult = function(vector, scalar) {
                    return {
                        x: vector.x * scalar,
                        y: vector.y * scalar
                    };
                };
                /**
     * Divides a vector and a scalar.
     * @method div
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector divided by scalar
     */ Vector.div = function(vector, scalar) {
                    return {
                        x: vector.x / scalar,
                        y: vector.y / scalar
                    };
                };
                /**
     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
     * @method perp
     * @param {vector} vector
     * @param {bool} [negate=false]
     * @return {vector} The perpendicular vector
     */ Vector.perp = function(vector, negate) {
                    negate = negate === true ? -1 : 1;
                    return {
                        x: negate * -vector.y,
                        y: negate * vector.x
                    };
                };
                /**
     * Negates both components of a vector such that it points in the opposite direction.
     * @method neg
     * @param {vector} vector
     * @return {vector} The negated vector
     */ Vector.neg = function(vector) {
                    return {
                        x: -vector.x,
                        y: -vector.y
                    };
                };
                /**
     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
     * @method angle
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The angle in radians
     */ Vector.angle = function(vectorA, vectorB) {
                    return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
                };
                /**
     * Temporary vector pool (not thread-safe).
     * @property _temp
     * @type {vector[]}
     * @private
     */ Vector._temp = [
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create()
                ];
            })();
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            /**
* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
*
* @class Bounds
*/ var Bounds = {};
            module1.exports = Bounds;
            (function() {
                /**
     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
     * @method create
     * @param {vertices} vertices
     * @return {bounds} A new bounds object
     */ Bounds.create = function(vertices) {
                    var bounds = {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: 0,
                            y: 0
                        }
                    };
                    if (vertices) Bounds.update(bounds, vertices);
                    return bounds;
                };
                /**
     * Updates bounds using the given vertices and extends the bounds given a velocity.
     * @method update
     * @param {bounds} bounds
     * @param {vertices} vertices
     * @param {vector} velocity
     */ Bounds.update = function(bounds, vertices, velocity) {
                    bounds.min.x = Infinity;
                    bounds.max.x = -Infinity;
                    bounds.min.y = Infinity;
                    bounds.max.y = -Infinity;
                    for(var i = 0; i < vertices.length; i++){
                        var vertex = vertices[i];
                        if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
                        if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
                        if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
                        if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
                    }
                    if (velocity) {
                        if (velocity.x > 0) bounds.max.x += velocity.x;
                        else bounds.min.x += velocity.x;
                        if (velocity.y > 0) bounds.max.y += velocity.y;
                        else bounds.min.y += velocity.y;
                    }
                };
                /**
     * Returns true if the bounds contains the given point.
     * @method contains
     * @param {bounds} bounds
     * @param {vector} point
     * @return {boolean} True if the bounds contain the point, otherwise false
     */ Bounds.contains = function(bounds, point) {
                    return point.x >= bounds.min.x && point.x <= bounds.max.x && point.y >= bounds.min.y && point.y <= bounds.max.y;
                };
                /**
     * Returns true if the two bounds intersect.
     * @method overlaps
     * @param {bounds} boundsA
     * @param {bounds} boundsB
     * @return {boolean} True if the bounds overlap, otherwise false
     */ Bounds.overlaps = function(boundsA, boundsB) {
                    return boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y;
                };
                /**
     * Translates the bounds by the given vector.
     * @method translate
     * @param {bounds} bounds
     * @param {vector} vector
     */ Bounds.translate = function(bounds, vector) {
                    bounds.min.x += vector.x;
                    bounds.max.x += vector.x;
                    bounds.min.y += vector.y;
                    bounds.max.y += vector.y;
                };
                /**
     * Shifts the bounds to the given position.
     * @method shift
     * @param {bounds} bounds
     * @param {vector} position
     */ Bounds.shift = function(bounds, position) {
                    var deltaX = bounds.max.x - bounds.min.x, deltaY = bounds.max.y - bounds.min.y;
                    bounds.min.x = position.x;
                    bounds.max.x = position.x + deltaX;
                    bounds.min.y = position.y;
                    bounds.max.y = position.y + deltaY;
                };
            })();
        /***/ },
        /* 85 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Rectangle = __webpack_require__(502);
            /**
 * @classdesc
 * A Tile is a representation of a single tile within the Tilemap. This is a lightweight data
 * representation, so its position information is stored without factoring in scroll, layer
 * scale or layer position.
 *
 * @class Tile
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The LayerData object in the Tilemap that this tile belongs to.
 * @param {number} index - The unique index of this tile within the map.
 * @param {number} x - The x coordinate of this tile in tile coordinates.
 * @param {number} y - The y coordinate of this tile in tile coordinates.
 * @param {number} width - Width of the tile in pixels.
 * @param {number} height - Height of the tile in pixels.
 * @param {number} baseWidth - The base width a tile in the map (in pixels). Tiled maps support
 * multiple tileset sizes within one map, but they are still placed at intervals of the base
 * tile width.
 * @param {number} baseHeight - The base height of the tile in pixels (in pixels). Tiled maps
 * support multiple tileset sizes within one map, but they are still placed at intervals of the
 * base tile height.
 */ var Tile = new Class({
                Mixins: [
                    Components.Alpha,
                    Components.Flip,
                    Components.Visible
                ],
                initialize: function Tile(layer, index, x, y, width, height, baseWidth, baseHeight) {
                    /**
         * The LayerData in the Tilemap data that this tile belongs to.
         *
         * @name Phaser.Tilemaps.Tile#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.0.0
         */ this.layer = layer;
                    /**
         * The index of this tile within the map data corresponding to the tileset, or -1 if this
         * represents a blank tile.
         *
         * @name Phaser.Tilemaps.Tile#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * The x map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The right of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#right
         * @type {number}
         * @since 3.50.0
         */ this.right;
                    /**
         * The bottom of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#bottom
         * @type {number}
         * @since 3.50.0
         */ this.bottom;
                    /**
         * The maps base width of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseWidth = baseWidth !== undefined ? baseWidth : width;
                    /**
         * The maps base height of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseHeight = baseHeight !== undefined ? baseHeight : height;
                    /**
         * The x coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelX
         * @type {number}
         * @since 3.0.0
         */ this.pixelX = 0;
                    /**
         * The y coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelY
         * @type {number}
         * @since 3.0.0
         */ this.pixelY = 0;
                    this.updatePixelXY();
                    /**
         * Tile specific properties. These usually come from Tiled.
         *
         * @name Phaser.Tilemaps.Tile#properties
         * @type {any}
         * @since 3.0.0
         */ this.properties = {};
                    /**
         * The rotation angle of this tile.
         *
         * @name Phaser.Tilemaps.Tile#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = 0;
                    /**
         * Whether the tile should collide with any object on the left side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.collideLeft = false;
                    /**
         * Whether the tile should collide with any object on the right side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideRight
         * @type {boolean}
         * @since 3.0.0
         */ this.collideRight = false;
                    /**
         * Whether the tile should collide with any object on the top side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideUp
         * @type {boolean}
         * @since 3.0.0
         */ this.collideUp = false;
                    /**
         * Whether the tile should collide with any object on the bottom side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideDown
         * @type {boolean}
         * @since 3.0.0
         */ this.collideDown = false;
                    /**
         * Whether the tiles left edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.faceLeft = false;
                    /**
         * Whether the tiles right edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceRight
         * @type {boolean}
         * @since 3.0.0
         */ this.faceRight = false;
                    /**
         * Whether the tiles top edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceTop
         * @type {boolean}
         * @since 3.0.0
         */ this.faceTop = false;
                    /**
         * Whether the tiles bottom edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceBottom
         * @type {boolean}
         * @since 3.0.0
         */ this.faceBottom = false;
                    /**
         * Tile collision callback.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallback
         * @type {function}
         * @since 3.0.0
         */ this.collisionCallback = undefined;
                    /**
         * The context in which the collision callback will be called.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallbackContext
         * @type {object}
         * @since 3.0.0
         */ this.collisionCallbackContext = this;
                    /**
         * The tint to apply to this tile. Note: tint is currently a single color value instead of
         * the 4 corner tint component on other GameObjects.
         *
         * @name Phaser.Tilemaps.Tile#tint
         * @type {number}
         * @default
         * @since 3.0.0
         */ this.tint = 0xffffff;
                    /**
         * An empty object where physics-engine specific information (e.g. bodies) may be stored.
         *
         * @name Phaser.Tilemaps.Tile#physics
         * @type {object}
         * @since 3.0.0
         */ this.physics = {};
                },
                /**
     * Check if the given x and y world coordinates are within this Tile. This does not factor in
     * camera scroll, layer scale or layer position.
     *
     * @method Phaser.Tilemaps.Tile#containsPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to test.
     * @param {number} y - The y coordinate to test.
     *
     * @return {boolean} True if the coordinates are within this Tile, otherwise false.
     */ containsPoint: function(x, y) {
                    return !(x < this.pixelX || y < this.pixelY || x > this.right || y > this.bottom);
                },
                /**
     * Copies the tile data & properties from the given tile to this tile. This copies everything
     * except for position and interesting faces.
     *
     * @method Phaser.Tilemaps.Tile#copy
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The tile to copy from.
     *
     * @return {this} This Tile object instance.
     */ copy: function(tile) {
                    this.index = tile.index;
                    this.alpha = tile.alpha;
                    this.properties = tile.properties;
                    this.visible = tile.visible;
                    this.setFlip(tile.flipX, tile.flipY);
                    this.tint = tile.tint;
                    this.rotation = tile.rotation;
                    this.collideUp = tile.collideUp;
                    this.collideDown = tile.collideDown;
                    this.collideLeft = tile.collideLeft;
                    this.collideRight = tile.collideRight;
                    this.collisionCallback = tile.collisionCallback;
                    this.collisionCallbackContext = tile.collisionCallbackContext;
                    return this;
                },
                /**
     * The collision group for this Tile, defined within the Tileset. This returns a reference to
     * the collision group stored within the Tileset, so any modification of the returned object
     * will impact all tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getCollisionGroup
     * @since 3.0.0
     *
     * @return {?object} The collision group for this Tile, as defined in the Tileset, or `null` if no group was defined.
     */ getCollisionGroup: function() {
                    return this.tileset ? this.tileset.getTileCollisionGroup(this.index) : null;
                },
                /**
     * The tile data for this Tile, defined within the Tileset. This typically contains Tiled
     * collision data, tile animations and terrain information. This returns a reference to the tile
     * data stored within the Tileset, so any modification of the returned object will impact all
     * tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getTileData
     * @since 3.0.0
     *
     * @return {?object} The tile data for this Tile, as defined in the Tileset, or `null` if no data was defined.
     */ getTileData: function() {
                    return this.tileset ? this.tileset.getTileData(this.index) : null;
                },
                /**
     * Gets the world X position of the left side of the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getLeft
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The left (x) value of this tile.
     */ getLeft: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? tilemapLayer.tileToWorldX(this.x, camera) : this.x * this.baseWidth;
                },
                /**
     * Gets the world X position of the right side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getRight
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The right (x) value of this tile.
     */ getRight: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? this.getLeft(camera) + this.width * tilemapLayer.scaleX : this.getLeft(camera) + this.width;
                },
                /**
     * Gets the world Y position of the top side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getTop
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The top (y) value of this tile.
     */ getTop: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    // Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile in grid
                    // units is the bottom left, so the y coordinate needs to be adjusted by the difference
                    // between the base size and this tile's size.
                    return tilemapLayer ? tilemapLayer.tileToWorldY(this.y, camera) - (this.height - this.baseHeight) * tilemapLayer.scaleY : this.y * this.baseHeight - (this.height - this.baseHeight);
                },
                /**
     * Gets the world Y position of the bottom side of the tile, factoring in the layer's position,
     * scale and scroll.

     * @method Phaser.Tilemaps.Tile#getBottom
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The bottom (y) value of this tile.
     */ getBottom: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? this.getTop(camera) + this.height * tilemapLayer.scaleY : this.getTop(camera) + this.height;
                },
                /**
     * Gets the world rectangle bounding box for the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object to store the results in.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The bounds of this Tile.
     */ getBounds: function(camera, output) {
                    if (output === undefined) output = new Rectangle();
                    output.x = this.getLeft();
                    output.y = this.getTop();
                    output.width = this.getRight() - output.x;
                    output.height = this.getBottom() - output.y;
                    return output;
                },
                /**
     * Gets the world X position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterX
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center x position of this Tile.
     */ getCenterX: function(camera) {
                    return (this.getLeft(camera) + this.getRight(camera)) / 2;
                },
                /**
     * Gets the world Y position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterY
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center y position of this Tile.
     */ getCenterY: function(camera) {
                    return (this.getTop(camera) + this.getBottom(camera)) / 2;
                },
                /**
     * Check for intersection with this tile. This does not factor in camera scroll, layer scale or
     * layer position.
     *
     * @method Phaser.Tilemaps.Tile#intersects
     * @since 3.0.0
     *
     * @param {number} x - The x axis in pixels.
     * @param {number} y - The y axis in pixels.
     * @param {number} right - The right point.
     * @param {number} bottom - The bottom point.
     *
     * @return {boolean} `true` if the Tile intersects with the given dimensions, otherwise `false`.
     */ intersects: function(x, y, right, bottom) {
                    return !(right <= this.pixelX || bottom <= this.pixelY || x >= this.right || y >= this.bottom);
                },
                /**
     * Checks if the tile is interesting.
     *
     * @method Phaser.Tilemaps.Tile#isInteresting
     * @since 3.0.0
     *
     * @param {boolean} collides - If true, will consider the tile interesting if it collides on any side.
     * @param {boolean} faces - If true, will consider the tile interesting if it has an interesting face.
     *
     * @return {boolean} True if the Tile is interesting, otherwise false.
     */ isInteresting: function(collides, faces) {
                    if (collides && faces) return this.canCollide || this.hasInterestingFace;
                    else if (collides) return this.collides;
                    else if (faces) return this.hasInterestingFace;
                    return false;
                },
                /**
     * Reset collision status flags.
     *
     * @method Phaser.Tilemaps.Tile#resetCollision
     * @since 3.0.0
     *
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ resetCollision: function(recalculateFaces) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    this.collideLeft = false;
                    this.collideRight = false;
                    this.collideUp = false;
                    this.collideDown = false;
                    this.faceTop = false;
                    this.faceBottom = false;
                    this.faceLeft = false;
                    this.faceRight = false;
                    if (recalculateFaces) {
                        var tilemapLayer = this.tilemapLayer;
                        if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                    }
                    return this;
                },
                /**
     * Reset faces.
     *
     * @method Phaser.Tilemaps.Tile#resetFaces
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ resetFaces: function() {
                    this.faceTop = false;
                    this.faceBottom = false;
                    this.faceLeft = false;
                    this.faceRight = false;
                    return this;
                },
                /**
     * Sets the collision flags for each side of this tile and updates the interesting faces list.
     *
     * @method Phaser.Tilemaps.Tile#setCollision
     * @since 3.0.0
     *
     * @param {boolean} left - Indicating collide with any object on the left.
     * @param {boolean} [right] - Indicating collide with any object on the right.
     * @param {boolean} [up] - Indicating collide with any object on the top.
     * @param {boolean} [down] - Indicating collide with any object on the bottom.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ setCollision: function(left, right, up, down, recalculateFaces) {
                    if (right === undefined) right = left;
                    if (up === undefined) up = left;
                    if (down === undefined) down = left;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    this.collideLeft = left;
                    this.collideRight = right;
                    this.collideUp = up;
                    this.collideDown = down;
                    this.faceLeft = left;
                    this.faceRight = right;
                    this.faceTop = up;
                    this.faceBottom = down;
                    if (recalculateFaces) {
                        var tilemapLayer = this.tilemapLayer;
                        if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                    }
                    return this;
                },
                /**
     * Set a callback to be called when this tile is hit by an object. The callback must true for
     * collision processing to take place.
     *
     * @method Phaser.Tilemaps.Tile#setCollisionCallback
     * @since 3.0.0
     *
     * @param {function} callback - Callback function.
     * @param {object} context - Callback will be called within this context.
     *
     * @return {this} This Tile object instance.
     */ setCollisionCallback: function(callback, context) {
                    if (callback === null) {
                        this.collisionCallback = undefined;
                        this.collisionCallbackContext = undefined;
                    } else {
                        this.collisionCallback = callback;
                        this.collisionCallbackContext = context;
                    }
                    return this;
                },
                /**
     * Sets the size of the tile and updates its pixelX and pixelY.
     *
     * @method Phaser.Tilemaps.Tile#setSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tile in pixels.
     * @param {number} tileHeight - The height of the tile in pixels.
     * @param {number} baseWidth - The base width a tile in the map (in pixels).
     * @param {number} baseHeight - The base height of the tile in pixels (in pixels).
     *
     * @return {this} This Tile object instance.
     */ setSize: function(tileWidth, tileHeight, baseWidth, baseHeight) {
                    if (tileWidth !== undefined) this.width = tileWidth;
                    if (tileHeight !== undefined) this.height = tileHeight;
                    if (baseWidth !== undefined) this.baseWidth = baseWidth;
                    if (baseHeight !== undefined) this.baseHeight = baseHeight;
                    this.updatePixelXY();
                    return this;
                },
                /**
     * Used internally. Updates the tiles world XY position based on the current tile size.
     *
     * @method Phaser.Tilemaps.Tile#updatePixelXY
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ updatePixelXY: function() {
                    var orientation = this.layer.orientation;
                    if (orientation === CONST.ORTHOGONAL) {
                        //  In orthogonal mode, Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile is the
                        //  bottom left, while the Phaser renderer assumes the origin is the top left. The y
                        //  coordinate needs to be adjusted by the difference.
                        this.pixelX = this.x * this.baseWidth;
                        this.pixelY = this.y * this.baseHeight;
                    } else if (orientation === CONST.ISOMETRIC) {
                        //  Reminder: For the tilemap to be centered we have to move the image to the right with the camera!
                        //  This is crucial for wordtotile, tiletoworld to work.
                        this.pixelX = (this.x - this.y) * this.baseWidth * 0.5;
                        this.pixelY = (this.x + this.y) * this.baseHeight * 0.5;
                    } else if (orientation === CONST.STAGGERED) {
                        this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                        this.pixelY = this.y * (this.baseHeight / 2);
                    } else if (orientation === CONST.HEXAGONAL) {
                        var len = this.layer.hexSideLength;
                        var rowHeight = (this.baseHeight - len) / 2 + len;
                        this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                        this.pixelY = this.y * rowHeight;
                    }
                    this.right = this.pixelX + this.baseWidth;
                    this.bottom = this.pixelY + this.baseHeight;
                    return this;
                },
                /**
     * Clean up memory.
     *
     * @method Phaser.Tilemaps.Tile#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.collisionCallback = undefined;
                    this.collisionCallbackContext = undefined;
                    this.properties = undefined;
                },
                /**
     * True if this tile can collide on any of its faces or has a collision callback set.
     *
     * @name Phaser.Tilemaps.Tile#canCollide
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ canCollide: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.collisionCallback !== undefined;
                    }
                },
                /**
     * True if this tile can collide on any of its faces.
     *
     * @name Phaser.Tilemaps.Tile#collides
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ collides: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown;
                    }
                },
                /**
     * True if this tile has any interesting faces.
     *
     * @name Phaser.Tilemaps.Tile#hasInterestingFace
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ hasInterestingFace: {
                    get: function() {
                        return this.faceTop || this.faceBottom || this.faceLeft || this.faceRight;
                    }
                },
                /**
     * The tileset that contains this Tile. This is null if accessed from a LayerData instance
     * before the tile is placed in a TilemapLayer, or if the tile has an index that doesn't correspond
     * to any of the maps tilesets.
     *
     * @name Phaser.Tilemaps.Tile#tileset
     * @type {?Phaser.Tilemaps.Tileset}
     * @readonly
     * @since 3.0.0
     */ tileset: {
                    get: function() {
                        var tilemapLayer = this.layer.tilemapLayer;
                        if (tilemapLayer) {
                            var tileset = tilemapLayer.gidMap[this.index];
                            if (tileset) return tileset;
                        }
                        return null;
                    }
                },
                /**
     * The tilemap layer that contains this Tile. This will only return null if accessed from a
     * LayerData instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemapLayer
     * @type {?Phaser.Tilemaps.TilemapLayer}
     * @readonly
     * @since 3.0.0
     */ tilemapLayer: {
                    get: function() {
                        return this.layer.tilemapLayer;
                    }
                },
                /**
     * The tilemap that contains this Tile. This will only return null if accessed from a LayerData
     * instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemap
     * @type {?Phaser.Tilemaps.Tilemap}
     * @readonly
     * @since 3.0.0
     */ tilemap: {
                    get: function() {
                        var tilemapLayer = this.tilemapLayer;
                        return tilemapLayer ? tilemapLayer.tilemap : null;
                    }
                }
            });
            module1.exports = Tile;
        /***/ },
        /* 86 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Bodies` module contains factory methods for creating rigid body models 
* with commonly used body configurations (such as rectangles, circles and other polygons).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Bodies
*/ // TODO: true circle bodies
            var Bodies = {};
            module1.exports = Bodies;
            var Vertices = __webpack_require__(64);
            var Common = __webpack_require__(32);
            var Body = __webpack_require__(41);
            var Bounds = __webpack_require__(84);
            var Vector = __webpack_require__(83);
            var decomp = __webpack_require__(1393);
            (function() {
                /**
     * Creates a new rigid body model with a rectangle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method rectangle
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {object} [options]
     * @return {body} A new rectangle body
     */ Bodies.rectangle = function(x, y, width, height, options) {
                    options = options || {};
                    var rectangle = {
                        label: "Rectangle Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath("L 0 0 L " + width + " 0 L " + width + " " + height + " L 0 " + height)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, rectangle, options));
                };
                /**
     * Creates a new rigid body model with a trapezoid hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method trapezoid
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} slope
     * @param {object} [options]
     * @return {body} A new trapezoid body
     */ Bodies.trapezoid = function(x, y, width, height, slope, options) {
                    options = options || {};
                    slope *= 0.5;
                    var roof = (1 - slope * 2) * width;
                    var x1 = width * slope, x2 = x1 + roof, x3 = x2 + x1, verticesPath;
                    if (slope < 0.5) verticesPath = "L 0 0 L " + x1 + " " + -height + " L " + x2 + " " + -height + " L " + x3 + " 0";
                    else verticesPath = "L 0 0 L " + x2 + " " + -height + " L " + x3 + " 0";
                    var trapezoid = {
                        label: "Trapezoid Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(verticesPath)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, trapezoid, options));
                };
                /**
     * Creates a new rigid body model with a circle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {object} [options]
     * @param {number} [maxSides]
     * @return {body} A new circle body
     */ Bodies.circle = function(x, y, radius, options, maxSides) {
                    options = options || {};
                    var circle = {
                        label: "Circle Body",
                        circleRadius: radius
                    };
                    // approximate circles with polygons until true circles implemented in SAT
                    maxSides = maxSides || 25;
                    var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
                    // optimisation: always use even number of sides (half the number of unique axes)
                    if (sides % 2 === 1) sides += 1;
                    return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
                };
                /**
     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method polygon
     * @param {number} x
     * @param {number} y
     * @param {number} sides
     * @param {number} radius
     * @param {object} [options]
     * @return {body} A new regular polygon body
     */ Bodies.polygon = function(x, y, sides, radius, options) {
                    options = options || {};
                    if (sides < 3) return Bodies.circle(x, y, radius, options);
                    var theta = 2 * Math.PI / sides, path = "", offset = theta * 0.5;
                    for(var i = 0; i < sides; i += 1){
                        var angle = offset + i * theta, xx = Math.cos(angle) * radius, yy = Math.sin(angle) * radius;
                        path += "L " + xx.toFixed(3) + " " + yy.toFixed(3) + " ";
                    }
                    var polygon = {
                        label: "Polygon Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(path)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, polygon, options));
                };
                /**
     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices).
     * If the vertices are convex, they will pass through as supplied.
     * Otherwise if the vertices are concave, they will be decomposed if [poly-decomp.js](https://github.com/schteppe/poly-decomp.js) is available.
     * Note that this process is not guaranteed to support complex sets of vertices (e.g. those with holes may fail).
     * By default the decomposition will discard collinear edges (to improve performance).
     * It can also optionally discard any parts that have an area less than `minimumArea`.
     * If the vertices can not be decomposed, the result will fall back to using the convex hull.
     * The options parameter is an object that specifies any `Matter.Body` properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method fromVertices
     * @param {number} x
     * @param {number} y
     * @param [[vector]] vertexSets
     * @param {object} [options]
     * @param {bool} [flagInternal=false]
     * @param {number} [removeCollinear=0.01]
     * @param {number} [minimumArea=10]
     * @return {body}
     */ Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
                    var body, parts, isConvex, vertices, i, j, k, v, z;
                    options = options || {};
                    parts = [];
                    flagInternal = typeof flagInternal !== "undefined" ? flagInternal : false;
                    removeCollinear = typeof removeCollinear !== "undefined" ? removeCollinear : 0.01;
                    minimumArea = typeof minimumArea !== "undefined" ? minimumArea : 10;
                    if (!decomp) Common.warn("Bodies.fromVertices: poly-decomp.js required. Could not decompose vertices. Fallback to convex hull.");
                    // ensure vertexSets is an array of arrays
                    if (!Common.isArray(vertexSets[0])) vertexSets = [
                        vertexSets
                    ];
                    for(v = 0; v < vertexSets.length; v += 1){
                        vertices = vertexSets[v];
                        isConvex = Vertices.isConvex(vertices);
                        if (isConvex || !decomp) {
                            if (isConvex) vertices = Vertices.clockwiseSort(vertices);
                            else // fallback to convex hull when decomposition is not possible
                            vertices = Vertices.hull(vertices);
                            parts.push({
                                position: {
                                    x: x,
                                    y: y
                                },
                                vertices: vertices
                            });
                        } else {
                            // initialise a decomposition
                            var concave = vertices.map(function(vertex) {
                                return [
                                    vertex.x,
                                    vertex.y
                                ];
                            });
                            // vertices are concave and simple, we can decompose into parts
                            decomp.makeCCW(concave);
                            if (removeCollinear !== false) decomp.removeCollinearPoints(concave, removeCollinear);
                            // use the quick decomposition algorithm (Bayazit)
                            var decomposed = decomp.quickDecomp(concave);
                            // for each decomposed chunk
                            for(i = 0; i < decomposed.length; i++){
                                var chunk = decomposed[i];
                                // convert vertices into the correct structure
                                var chunkVertices = chunk.map(function(vertices) {
                                    return {
                                        x: vertices[0],
                                        y: vertices[1]
                                    };
                                });
                                // skip small chunks
                                if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea) continue;
                                // create a compound part
                                parts.push({
                                    position: Vertices.centre(chunkVertices),
                                    vertices: chunkVertices
                                });
                            }
                        }
                    }
                    // create body parts
                    for(i = 0; i < parts.length; i++)parts[i] = Body.create(Common.extend(parts[i], options));
                    if (flagInternal) Bodies.flagCoincidentParts(parts, 5);
                    if (parts.length > 1) {
                        // create the parent body to be returned, that contains generated compound parts
                        body = Body.create(Common.extend({
                            parts: parts.slice(0)
                        }, options));
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    } else return parts[0];
                };
                /**
     * Takes an array of Body objects and flags all internal edges (coincident parts) based on the maxDistance
     * value. The array is changed in-place and returned, so you can pass this function a `Body.parts` property.
     * 
     * @method flagCoincidentParts
     * @param {body[]} parts - The Body parts, or array of bodies, to flag.
     * @param {number} [maxDistance=5]
     * @return {body[]} The modified `parts` parameter.
     */ Bodies.flagCoincidentParts = function(parts, maxDistance) {
                    if (maxDistance === undefined) maxDistance = 5;
                    for(var i = 0; i < parts.length; i++){
                        var partA = parts[i];
                        for(var j = i + 1; j < parts.length; j++){
                            var partB = parts[j];
                            if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                var pav = partA.vertices;
                                var pbv = partB.vertices;
                                // iterate vertices of both parts
                                for(var k = 0; k < partA.vertices.length; k++)for(var z = 0; z < partB.vertices.length; z++){
                                    // find distances between the vertices
                                    var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z]));
                                    var db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                    // if both vertices are very close, consider the edge concident (internal)
                                    if (da < maxDistance && db < maxDistance) {
                                        pav[k].isInternal = true;
                                        pbv[z].isInternal = true;
                                    }
                                }
                            }
                        }
                    }
                    return parts;
                };
            })();
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center x coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center x coordinate of the bounds of the Game Object.
 */ var GetCenterX = function(gameObject) {
                return gameObject.x - gameObject.width * gameObject.originX + gameObject.width * 0.5;
            };
            module1.exports = GetCenterX;
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterX = function(gameObject, x) {
                var offsetX = gameObject.width * gameObject.originX;
                gameObject.x = x + offsetX - gameObject.width * 0.5;
                return gameObject;
            };
            module1.exports = SetCenterX;
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center y coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center y coordinate of the bounds of the Game Object.
 */ var GetCenterY = function(gameObject) {
                return gameObject.y - gameObject.height * gameObject.originY + gameObject.height * 0.5;
            };
            module1.exports = GetCenterY;
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} y - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterY = function(gameObject, y) {
                var offsetY = gameObject.height * gameObject.originY;
                gameObject.y = y + offsetY - gameObject.height * 0.5;
                return gameObject;
            };
            module1.exports = SetCenterY;
        /***/ },
        /* 91 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Events
 */ module1.exports = {
                POST_RENDER: __webpack_require__(628),
                PRE_RENDER: __webpack_require__(629),
                RENDER: __webpack_require__(630),
                RESIZE: __webpack_require__(631)
            };
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PIPELINE_CONST = {
                /**
     * The Bitmap Mask Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.BITMAPMASK_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ BITMAPMASK_PIPELINE: "BitmapMaskPipeline",
                /**
     * The Light 2D Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.LIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ LIGHT_PIPELINE: "Light2D",
                /**
     * The Point Light Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POINTLIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POINTLIGHT_PIPELINE: "PointLightPipeline",
                /**
     * The Single Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.SINGLE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ SINGLE_PIPELINE: "SinglePipeline",
                /**
     * The Multi Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.MULTI_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ MULTI_PIPELINE: "MultiPipeline",
                /**
     * The Rope Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.ROPE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ ROPE_PIPELINE: "RopePipeline",
                /**
     * The Graphics and Shapes Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.GRAPHICS_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ GRAPHICS_PIPELINE: "GraphicsPipeline",
                /**
     * The Post FX Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POSTFX_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POSTFX_PIPELINE: "PostFXPipeline",
                /**
     * The Utility Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.UTILITY_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ UTILITY_PIPELINE: "UtilityPipeline"
            };
            module1.exports = PIPELINE_CONST;
        /***/ },
        /* 93 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes the given item, or array of items, from the array.
 *
 * The array is modified in-place.
 *
 * You can optionally specify a callback to be invoked for each item successfully removed from the array.
 *
 * @function Phaser.Utils.Array.Remove
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {*|Array.<*>} item - The item, or array of items, to be removed from the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*|Array.<*>} The item, or array of items, that were successfully removed from the array.
 */ var Remove = function(array, item, callback, context) {
                if (context === undefined) context = array;
                var index;
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    index = array.indexOf(item);
                    if (index !== -1) {
                        SpliceOne(array, index);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to remove
                var itemLength = item.length - 1;
                var removed = [];
                while(itemLength >= 0){
                    var entry = item[itemLength];
                    index = array.indexOf(entry);
                    if (index !== -1) {
                        SpliceOne(array, index);
                        removed.push(entry);
                        if (callback) callback.call(context, entry);
                    }
                    itemLength--;
                }
                return removed;
            };
            module1.exports = Remove;
        /***/ },
        /* 94 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FromPoints = __webpack_require__(199);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Base Curve class, which all other curve types extend.
 *
 * Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
 *
 * @class Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {string} type - The curve type.
 */ var Curve = new Class({
                initialize: function Curve(type) {
                    /**
         * String based identifier for the type of curve.
         *
         * @name Phaser.Curves.Curve#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                    /**
         * The default number of divisions within the curve.
         *
         * @name Phaser.Curves.Curve#defaultDivisions
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.defaultDivisions = 5;
                    /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Curve#arcLengthDivisions
         * @type {number}
         * @default 100
         * @since 3.0.0
         */ this.arcLengthDivisions = 100;
                    /**
         * An array of cached arc length values.
         *
         * @name Phaser.Curves.Curve#cacheArcLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheArcLengths = [];
                    /**
         * Does the data of this curve need updating?
         *
         * @name Phaser.Curves.Curve#needsUpdate
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.needsUpdate = true;
                    /**
         * For a curve on a Path, `false` means the Path will ignore this curve.
         *
         * @name Phaser.Curves.Curve#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                    /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                },
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Curve#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     * @param {number} [pointsTotal=32] - The resolution of the curve. The higher the value the smoother it will render, at the cost of rendering performance.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    //  So you can chain graphics calls
                    return graphics.strokePoints(this.getPoints(pointsTotal));
                },
                /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * You can control the accuracy of the bounds. The value given is used to work out how many points
     * to plot across the curve. Higher values are more accurate at the cost of calculation speed.
     *
     * @method Phaser.Curves.Curve#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in. If falsey a new object will be created.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out, accuracy) {
                    if (!out) out = new Rectangle();
                    if (accuracy === undefined) accuracy = 16;
                    var len = this.getLength();
                    if (accuracy > len) accuracy = len / 2;
                    //  The length of the curve in pixels
                    //  So we'll have 1 spaced point per 'accuracy' pixels
                    var spaced = Math.max(1, Math.round(len / accuracy));
                    return FromPoints(this.getSpacedPoints(spaced), out);
                },
                /**
     * Returns an array of points, spaced out X distance pixels apart.
     * The smaller the distance, the larger the array will be.
     *
     * @method Phaser.Curves.Curve#getDistancePoints
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels, between each point along the curve.
     *
     * @return {Phaser.Geom.Point[]} An Array of Point objects.
     */ getDistancePoints: function(distance) {
                    var len = this.getLength();
                    var spaced = Math.max(1, len / distance);
                    return this.getSpacedPoints(spaced);
                },
                /**
     * Get a point at the end of the curve.
     *
     * @method Phaser.Curves.Curve#getEndPoint
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} [out] - Optional Vector object to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector2 containing the coordinates of the curves end point.
     */ getEndPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPointAt(1, out);
                },
                /**
     * Get total curve arc length
     *
     * @method Phaser.Curves.Curve#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the curve.
     */ getLength: function() {
                    var lengths = this.getLengths();
                    return lengths[lengths.length - 1];
                },
                /**
     * Get a list of cumulative segment lengths.
     *
     * These lengths are
     *
     * - [0] 0
     * - [1] The first segment
     * - [2] The first and second segment
     * - ...
     * - [divisions] All segments
     *
     * @method Phaser.Curves.Curve#getLengths
     * @since 3.0.0
     *
     * @param {number} [divisions] - The number of divisions or segments.
     *
     * @return {number[]} An array of cumulative lengths.
     */ getLengths: function(divisions) {
                    if (divisions === undefined) divisions = this.arcLengthDivisions;
                    if (this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                    this.needsUpdate = false;
                    var cache = [];
                    var current;
                    var last = this.getPoint(0, this._tmpVec2A);
                    var sum = 0;
                    cache.push(0);
                    for(var p = 1; p <= divisions; p++){
                        current = this.getPoint(p / divisions, this._tmpVec2B);
                        sum += current.distance(last);
                        cache.push(sum);
                        last.copy(current);
                    }
                    this.cacheArcLengths = cache;
                    return cache; // { sums: cache, sum:sum }; Sum is in the last element.
                },
                // Get point at relative position in curve according to arc length
                // - u [0 .. 1]
                /**
     * Get a point at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getPointAt: function(u, out) {
                    var t = this.getUtoTmapping(u);
                    return this.getPoint(t, out);
                },
                // Get sequence of points using getPoint( t )
                /**
     * Get a sequence of evenly spaced points from the curve.
     *
     * You can pass `divisions`, `stepRate`, or neither.
     *
     * The number of divisions will be
     *
     * 1. `divisions`, if `divisions` > 0; or
     * 2. `this.getLength / stepRate`, if `stepRate` > 0; or
     * 3. `this.defaultDivisions`
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2[]} O - [out,$return]
     *
     * @param {number} [divisions] - The number of divisions to make.
     * @param {number} [stepRate] - The curve distance between points, implying `divisions`.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {(array|Phaser.Math.Vector2[])} An array of Points from the curve.
     */ getPoints: function(divisions, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!divisions) {
                        if (!stepRate) divisions = this.defaultDivisions;
                        else divisions = this.getLength() / stepRate;
                    }
                    for(var d = 0; d <= divisions; d++)out.push(this.getPoint(d / divisions));
                    return out;
                },
                /**
     * Get a random point from the curve.
     *
     * @method Phaser.Curves.Curve#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point object to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getRandomPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(Math.random(), out);
                },
                // Get sequence of points using getPointAt( u )
                /**
     * Get a sequence of equally spaced points (by arc distance) from the curve.
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=this.defaultDivisions] - The number of divisions to make.
     * @param {number} [stepRate] - Step between points. Used to calculate the number of points to return when divisions is falsy. Ignored if divisions is positive.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {Phaser.Math.Vector2[]} An array of points.
     */ getSpacedPoints: function(divisions, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!divisions) {
                        if (!stepRate) divisions = this.defaultDivisions;
                        else divisions = this.getLength() / stepRate;
                    }
                    for(var d = 0; d <= divisions; d++){
                        var t = this.getUtoTmapping(d / divisions, null, divisions);
                        out.push(this.getPoint(t));
                    }
                    return out;
                },
                /**
     * Get a point at the start of the curve.
     *
     * @method Phaser.Curves.Curve#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPointAt(0, out);
                },
                /**
     * Get a unit vector tangent at a relative position on the curve.
     * In case any sub curve does not implement its tangent derivation,
     * 2 points a small delta apart will be used to find its gradient
     * which seems to give a reasonable approximation
     *
     * @method Phaser.Curves.Curve#getTangent
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var delta = 0.0001;
                    var t1 = t - delta;
                    var t2 = t + delta;
                    // Capping in case of danger
                    if (t1 < 0) t1 = 0;
                    if (t2 > 1) t2 = 1;
                    this.getPoint(t1, this._tmpVec2A);
                    this.getPoint(t2, out);
                    return out.subtract(this._tmpVec2A).normalize();
                },
                /**
     * Get a unit vector tangent at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getTangentAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangentAt: function(u, out) {
                    var t = this.getUtoTmapping(u);
                    return this.getTangent(t, out);
                },
                /**
     * Given a distance in pixels, get a t to find p.
     *
     * @method Phaser.Curves.Curve#getTFromDistance
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The distance.
     */ getTFromDistance: function(distance, divisions) {
                    if (distance <= 0) return 0;
                    return this.getUtoTmapping(0, distance, divisions);
                },
                /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Curve#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                    var arcLengths = this.getLengths(divisions);
                    var i = 0;
                    var il = arcLengths.length;
                    var targetArcLength; // The targeted u distance value to get
                    if (distance) //  Cannot overshoot the curve
                    targetArcLength = Math.min(distance, arcLengths[il - 1]);
                    else targetArcLength = u * arcLengths[il - 1];
                    // binary search for the index with largest value smaller than target u distance
                    var low = 0;
                    var high = il - 1;
                    var comparison;
                    while(low <= high){
                        i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                        comparison = arcLengths[i] - targetArcLength;
                        if (comparison < 0) low = i + 1;
                        else if (comparison > 0) high = i - 1;
                        else {
                            high = i;
                            break;
                        }
                    }
                    i = high;
                    if (arcLengths[i] === targetArcLength) return i / (il - 1);
                    // we could get finer grain at lengths, or use simple interpolation between two points
                    var lengthBefore = arcLengths[i];
                    var lengthAfter = arcLengths[i + 1];
                    var segmentLength = lengthAfter - lengthBefore;
                    // determine where we are between the 'before' and 'after' points
                    var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                    // add that fractional amount to t
                    return (i + segmentFraction) / (il - 1);
                },
                /**
     * Calculate and cache the arc lengths.
     *
     * @method Phaser.Curves.Curve#updateArcLengths
     * @since 3.0.0
     *
     * @see Phaser.Curves.Curve#getLengths()
     */ updateArcLengths: function() {
                    this.needsUpdate = true;
                    this.getLengths();
                }
            });
            module1.exports = Curve;
        /***/ },
        /* 95 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.Events
 */ module1.exports = {
                ADD: __webpack_require__(968),
                COMPLETE: __webpack_require__(969),
                FILE_COMPLETE: __webpack_require__(970),
                FILE_KEY_COMPLETE: __webpack_require__(971),
                FILE_LOAD_ERROR: __webpack_require__(972),
                FILE_LOAD: __webpack_require__(973),
                FILE_PROGRESS: __webpack_require__(974),
                POST_PROCESS: __webpack_require__(975),
                PROGRESS: __webpack_require__(976),
                START: __webpack_require__(977)
            };
        /***/ },
        /* 96 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            //  This is based off an explanation and expanded math presented by Paul Bourke:
            //  See http:'local.wasp.uwa.edu.au/~pbourke/geometry/lineline2d/
            /**
 * Checks if two Lines intersect. If the Lines are identical, they will be treated as parallel and thus non-intersecting.
 *
 * @function Phaser.Geom.Intersects.LineToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line1 - The first Line to check.
 * @param {Phaser.Geom.Line} line2 - The second Line to check.
 * @param {Phaser.Geom.Point} [out] - A Point in which to optionally store the point of intersection.
 *
 * @return {boolean} `true` if the two Lines intersect, and the `out` object will be populated, if given. Otherwise, `false`.
 */ var LineToLine = function(line1, line2, out) {
                if (out === undefined) out = new Point();
                var x1 = line1.x1;
                var y1 = line1.y1;
                var x2 = line1.x2;
                var y2 = line1.y2;
                var x3 = line2.x1;
                var y3 = line2.y1;
                var x4 = line2.x2;
                var y4 = line2.y2;
                var numA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
                var numB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
                var deNom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
                //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                if (deNom === 0) return false;
                //  Calculate the intermediate fractional point that the lines potentially intersect.
                var uA = numA / deNom;
                var uB = numB / deNom;
                //  The fractional point will be between 0 and 1 inclusive if the lines intersect.
                //  If the fractional calculation is larger than 1 or smaller than 0 the lines would need to be longer to intersect.
                if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
                    out.x = x1 + uA * (x2 - x1);
                    out.y = y1 + uA * (y2 - y1);
                    return true;
                }
                return false;
            };
            module1.exports = LineToLine;
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the angle of the line in radians.
 *
 * @function Phaser.Geom.Line.Angle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of.
 *
 * @return {number} The angle of the line, in radians.
 */ var Angle = function(line) {
                return Math.atan2(line.y2 - line.y1, line.x2 - line.x1);
            };
            module1.exports = Angle;
        /***/ },
        /* 98 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            /**
 * Return a value based on the range between `min` and `max` and the percentage given.
 *
 * @function Phaser.Math.FromPercent
 * @since 3.0.0
 *
 * @param {number} percent - A value between 0 and 1 representing the percentage.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 *
 * @return {number} The value that is `percent` percent between `min` and `max`.
 */ var FromPercent = function(percent, min, max) {
                percent = Clamp(percent, 0, 1);
                return (max - min) * percent + min;
            };
            module1.exports = FromPercent;
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Retrieves the value of the given key from an object.
 *
 * @function Phaser.Tweens.Builders.GetBoolean
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The key to look for in the `source` object.
 * @param {*} defaultValue - The default value to return if the `key` doesn't exist or if no `source` object is provided.
 *
 * @return {*} The retrieved value.
 */ var GetBoolean = function(source, key, defaultValue) {
                if (!source) return defaultValue;
                else if (source.hasOwnProperty(key)) return source[key];
                else return defaultValue;
            };
            module1.exports = GetBoolean;
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TWEEN_CONST = {
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.CREATED
     * @type {number}
     * @since 3.0.0
     */ CREATED: 0,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.INIT
     * @type {number}
     * @since 3.0.0
     */ INIT: 1,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.DELAY
     * @type {number}
     * @since 3.0.0
     */ DELAY: 2,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.OFFSET_DELAY
     * @type {number}
     * @since 3.0.0
     */ OFFSET_DELAY: 3,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PENDING_RENDER
     * @type {number}
     * @since 3.0.0
     */ PENDING_RENDER: 4,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PLAYING_FORWARD
     * @type {number}
     * @since 3.0.0
     */ PLAYING_FORWARD: 5,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PLAYING_BACKWARD
     * @type {number}
     * @since 3.0.0
     */ PLAYING_BACKWARD: 6,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.HOLD_DELAY
     * @type {number}
     * @since 3.0.0
     */ HOLD_DELAY: 7,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.REPEAT_DELAY
     * @type {number}
     * @since 3.0.0
     */ REPEAT_DELAY: 8,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.COMPLETE
     * @type {number}
     * @since 3.0.0
     */ COMPLETE: 9,
                //  Tween specific (starts from 20 to cleanly allow extra TweenData consts in the future)
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PENDING_ADD
     * @type {number}
     * @since 3.0.0
     */ PENDING_ADD: 20,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PAUSED
     * @type {number}
     * @since 3.0.0
     */ PAUSED: 21,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.LOOP_DELAY
     * @type {number}
     * @since 3.0.0
     */ LOOP_DELAY: 22,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.ACTIVE
     * @type {number}
     * @since 3.0.0
     */ ACTIVE: 23,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.COMPLETE_DELAY
     * @type {number}
     * @since 3.0.0
     */ COMPLETE_DELAY: 24,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PENDING_REMOVE
     * @type {number}
     * @since 3.0.0
     */ PENDING_REMOVE: 25,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.REMOVED
     * @type {number}
     * @since 3.0.0
     */ REMOVED: 26
            };
            module1.exports = TWEEN_CONST;
        /***/ },
        /* 101 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(315);
            /**
 * @callback DataEachCallback
 *
 * @param {*} parent - The parent object of the DataManager.
 * @param {string} key - The key of the value.
 * @param {*} value - The value.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
 */ /**
 * @classdesc
 * The Data Manager Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {object} parent - The object that this DataManager belongs to.
 * @param {Phaser.Events.EventEmitter} [eventEmitter] - The DataManager's event emitter.
 */ var DataManager = new Class({
                initialize: function DataManager(parent, eventEmitter) {
                    /**
         * The object that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManager#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * The DataManager's event emitter.
         *
         * @name Phaser.Data.DataManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = eventEmitter;
                    if (!eventEmitter) this.events = parent.events ? parent.events : parent;
                    /**
         * The data list.
         *
         * @name Phaser.Data.DataManager#list
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                    /**
         * The public values list. You can use this to access anything you have stored
         * in this Data Manager. For example, if you set a value called `gold` you can
         * access it via:
         *
         * ```javascript
         * this.data.values.gold;
         * ```
         *
         * You can also modify it directly:
         *
         * ```javascript
         * this.data.values.gold += 1000;
         * ```
         *
         * Doing so will emit a `setdata` event from the parent of this Data Manager.
         *
         * Do not modify this object directly. Adding properties directly to this object will not
         * emit any events. Always use `DataManager.set` to create new items the first time around.
         *
         * @name Phaser.Data.DataManager#values
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.10.0
         */ this.values = {};
                    /**
         * Whether setting data is frozen for this DataManager.
         *
         * @name Phaser.Data.DataManager#_frozen
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._frozen = false;
                    if (!parent.hasOwnProperty("sys") && this.events) this.events.once(Events.DESTROY, this.destroy, this);
                },
                /**
     * Retrieves the value for the given key, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * this.data.get('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * this.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * this.data.get([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.Data.DataManager#get
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ get: function(key) {
                    var list = this.list;
                    if (Array.isArray(key)) {
                        var output = [];
                        for(var i = 0; i < key.length; i++)output.push(list[key[i]]);
                        return output;
                    } else return list[key];
                },
                /**
     * Retrieves all data values in a new object.
     *
     * @method Phaser.Data.DataManager#getAll
     * @since 3.0.0
     *
     * @return {Object.<string, *>} All data values.
     */ getAll: function() {
                    var results = {};
                    for(var key in this.list)if (this.list.hasOwnProperty(key)) results[key] = this.list[key];
                    return results;
                },
                /**
     * Queries the DataManager for the values of keys matching the given regular expression.
     *
     * @method Phaser.Data.DataManager#query
     * @since 3.0.0
     *
     * @param {RegExp} search - A regular expression object. If a non-RegExp object obj is passed, it is implicitly converted to a RegExp by using new RegExp(obj).
     *
     * @return {Object.<string, *>} The values of the keys matching the search string.
     */ query: function(search) {
                    var results = {};
                    for(var key in this.list)if (this.list.hasOwnProperty(key) && key.match(search)) results[key] = this.list[key];
                    return results;
                },
                /**
     * Sets a value for the given key. If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * data.set('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * data.set({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `get`:
     *
     * ```javascript
     * data.get('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#set
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object or key value pairs. If an object the `data` argument is ignored.
     * @param {*} data - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This DataManager object.
     */ set: function(key, data) {
                    if (this._frozen) return this;
                    if (typeof key === "string") return this.setValue(key, data);
                    else for(var entry in key)this.setValue(entry, key[entry]);
                    return this;
                },
                /**
     * Increase a value for the given key. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#inc
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {Phaser.Data.DataManager} This DataManager object.
     */ inc: function(key, data) {
                    if (this._frozen) return this;
                    if (data === undefined) data = 1;
                    var value = this.get(key);
                    if (value === undefined) value = 0;
                    this.set(key, value + data);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#toggle
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {Phaser.Data.DataManager} This DataManager object.
     */ toggle: function(key) {
                    if (this._frozen) return this;
                    this.set(key, !this.get(key));
                    return this;
                },
                /**
     * Internal value setter, called automatically by the `set` method.
     *
     * @method Phaser.Data.DataManager#setValue
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @private
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     * @param {*} data - The value to set.
     *
     * @return {this} This DataManager object.
     */ setValue: function(key, data) {
                    if (this._frozen) return this;
                    if (this.has(key)) //  Hit the key getter, which will in turn emit the events.
                    this.values[key] = data;
                    else {
                        var _this = this;
                        var list = this.list;
                        var events = this.events;
                        var parent = this.parent;
                        Object.defineProperty(this.values, key, {
                            enumerable: true,
                            configurable: true,
                            get: function() {
                                return list[key];
                            },
                            set: function(value) {
                                if (!_this._frozen) {
                                    var previousValue = list[key];
                                    list[key] = value;
                                    events.emit(Events.CHANGE_DATA, parent, key, value, previousValue);
                                    events.emit(Events.CHANGE_DATA_KEY + key, parent, value, previousValue);
                                }
                            }
                        });
                        list[key] = data;
                        events.emit(Events.SET_DATA, parent, key, data);
                    }
                    return this;
                },
                /**
     * Passes all data entries to the given callback.
     *
     * @method Phaser.Data.DataManager#each
     * @since 3.0.0
     *
     * @param {DataEachCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
     *
     * @return {this} This DataManager object.
     */ each: function(callback, context) {
                    var args = [
                        this.parent,
                        null,
                        undefined
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var key in this.list){
                        args[1] = key;
                        args[2] = this.list[key];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Merge the given object of key value pairs into this DataManager.
     *
     * Any newly created values will emit a `setdata` event. Any updated values (see the `overwrite` argument)
     * will emit a `changedata` event.
     *
     * @method Phaser.Data.DataManager#merge
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @param {Object.<string, *>} data - The data to merge.
     * @param {boolean} [overwrite=true] - Whether to overwrite existing data. Defaults to true.
     *
     * @return {this} This DataManager object.
     */ merge: function(data, overwrite) {
                    if (overwrite === undefined) overwrite = true;
                    //  Merge data from another component into this one
                    for(var key in data)if (data.hasOwnProperty(key) && (overwrite || !overwrite && !this.has(key))) this.setValue(key, data[key]);
                    return this;
                },
                /**
     * Remove the value for the given key.
     *
     * If the key is found in this Data Manager it is removed from the internal lists and a
     * `removedata` event is emitted.
     *
     * You can also pass in an array of keys, in which case all keys in the array will be removed:
     *
     * ```javascript
     * this.data.remove([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * @method Phaser.Data.DataManager#remove
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key to remove, or an array of keys to remove.
     *
     * @return {this} This DataManager object.
     */ remove: function(key) {
                    if (this._frozen) return this;
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.removeValue(key[i]);
                    else return this.removeValue(key);
                    return this;
                },
                /**
     * Internal value remover, called automatically by the `remove` method.
     *
     * @method Phaser.Data.DataManager#removeValue
     * @private
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     *
     * @return {this} This DataManager object.
     */ removeValue: function(key) {
                    if (this.has(key)) {
                        var data = this.list[key];
                        delete this.list[key];
                        delete this.values[key];
                        this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                    }
                    return this;
                },
                /**
     * Retrieves the data associated with the given 'key', deletes it from this Data Manager, then returns it.
     *
     * @method Phaser.Data.DataManager#pop
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {string} key - The key of the value to retrieve and delete.
     *
     * @return {*} The value of the given key.
     */ pop: function(key) {
                    var data = undefined;
                    if (!this._frozen && this.has(key)) {
                        data = this.list[key];
                        delete this.list[key];
                        delete this.values[key];
                        this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                    }
                    return data;
                },
                /**
     * Determines whether the given key is set in this Data Manager.
     *
     * Please note that the keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#has
     * @since 3.0.0
     *
     * @param {string} key - The key to check.
     *
     * @return {boolean} Returns `true` if the key exists, otherwise `false`.
     */ has: function(key) {
                    return this.list.hasOwnProperty(key);
                },
                /**
     * Freeze or unfreeze this Data Manager. A frozen Data Manager will block all attempts
     * to create new values or update existing ones.
     *
     * @method Phaser.Data.DataManager#setFreeze
     * @since 3.0.0
     *
     * @param {boolean} value - Whether to freeze or unfreeze the Data Manager.
     *
     * @return {this} This DataManager object.
     */ setFreeze: function(value) {
                    this._frozen = value;
                    return this;
                },
                /**
     * Delete all data in this Data Manager and unfreeze it.
     *
     * @method Phaser.Data.DataManager#reset
     * @since 3.0.0
     *
     * @return {this} This DataManager object.
     */ reset: function() {
                    for(var key in this.list){
                        delete this.list[key];
                        delete this.values[key];
                    }
                    this._frozen = false;
                    return this;
                },
                /**
     * Destroy this data manager.
     *
     * @method Phaser.Data.DataManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.reset();
                    this.events.off(Events.CHANGE_DATA);
                    this.events.off(Events.SET_DATA);
                    this.events.off(Events.REMOVE_DATA);
                    this.parent = null;
                },
                /**
     * Gets or sets the frozen state of this Data Manager.
     * A frozen Data Manager will block all attempts to create new values or update existing ones.
     *
     * @name Phaser.Data.DataManager#freeze
     * @type {boolean}
     * @since 3.0.0
     */ freeze: {
                    get: function() {
                        return this._frozen;
                    },
                    set: function(value) {
                        this._frozen = value ? true : false;
                    }
                },
                /**
     * Return the total number of entries in this Data Manager.
     *
     * @name Phaser.Data.DataManager#count
     * @type {number}
     * @since 3.0.0
     */ count: {
                    get: function() {
                        var i = 0;
                        for(var key in this.list)if (this.list[key] !== undefined) i++;
                        return i;
                    }
                }
            });
            module1.exports = DataManager;
        /***/ },
        /* 102 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @callback EachMapCallback<E>
 *
 * @param {string} key - The key of the Map entry.
 * @param {E} entry - The value of the Map entry.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * The keys of a Map can be arbitrary values.
 *
 * ```javascript
 * var map = new Map([
 *    [ 1, 'one' ],
 *    [ 2, 'two' ],
 *    [ 3, 'three' ]
 * ]);
 * ```
 *
 * @class Map
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic K
 * @generic V
 * @genericUse {V[]} - [elements]
 *
 * @param {Array.<*>} elements - An optional array of key-value pairs to populate this Map with.
 */ var Map = new Class({
                initialize: function Map(elements) {
                    /**
         * The entries in this Map.
         *
         * @genericUse {Object.<string, V>} - [$type]
         *
         * @name Phaser.Structs.Map#entries
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.entries = {};
                    /**
         * The number of key / value pairs in this Map.
         *
         * @name Phaser.Structs.Map#size
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.size = 0;
                    if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i][0], elements[i][1]);
                },
                /**
     * Adds an element with a specified `key` and `value` to this Map.
     * If the `key` already exists, the value will be replaced.
     *
     * @method Phaser.Structs.Map#set
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [value]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to be added to this Map.
     * @param {*} value - The value of the element to be added to this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ set: function(key, value) {
                    if (!this.has(key)) this.size++;
                    this.entries[key] = value;
                    return this;
                },
                /**
     * Returns the value associated to the `key`, or `undefined` if there is none.
     *
     * @method Phaser.Structs.Map#get
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [$return]
     *
     * @param {string} key - The key of the element to return from the `Map` object.
     *
     * @return {*} The element associated with the specified key or `undefined` if the key can't be found in this Map object.
     */ get: function(key) {
                    if (this.has(key)) return this.entries[key];
                },
                /**
     * Returns an `Array` of all the values stored in this Map.
     *
     * @method Phaser.Structs.Map#getArray
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An array of the values stored in this Map.
     */ getArray: function() {
                    var output = [];
                    var entries = this.entries;
                    for(var key in entries)output.push(entries[key]);
                    return output;
                },
                /**
     * Returns a boolean indicating whether an element with the specified key exists or not.
     *
     * @method Phaser.Structs.Map#has
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     *
     * @param {string} key - The key of the element to test for presence of in this Map.
     *
     * @return {boolean} Returns `true` if an element with the specified key exists in this Map, otherwise `false`.
     */ has: function(key) {
                    return this.entries.hasOwnProperty(key);
                },
                /**
     * Delete the specified element from this Map.
     *
     * @method Phaser.Structs.Map#delete
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to delete from this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ delete: function(key) {
                    if (this.has(key)) {
                        delete this.entries[key];
                        this.size--;
                    }
                    return this;
                },
                /**
     * Delete all entries from this Map.
     *
     * @method Phaser.Structs.Map#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ clear: function() {
                    Object.keys(this.entries).forEach(function(prop) {
                        delete this.entries[prop];
                    }, this);
                    this.size = 0;
                    return this;
                },
                /**
     * Returns all entries keys in this Map.
     *
     * @method Phaser.Structs.Map#keys
     * @since 3.0.0
     *
     * @genericUse {K[]} - [$return]
     *
     * @return {string[]} Array containing entries' keys.
     */ keys: function() {
                    return Object.keys(this.entries);
                },
                /**
     * Returns an `Array` of all entries.
     *
     * @method Phaser.Structs.Map#values
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An `Array` of entries.
     */ values: function() {
                    var output = [];
                    var entries = this.entries;
                    for(var key in entries)output.push(entries[key]);
                    return output;
                },
                /**
     * Dumps the contents of this Map to the console via `console.group`.
     *
     * @method Phaser.Structs.Map#dump
     * @since 3.0.0
     */ dump: function() {
                    var entries = this.entries;
                    // eslint-disable-next-line no-console
                    console.group("Map");
                    for(var key in entries)console.log(key, entries[key]);
                    // eslint-disable-next-line no-console
                    console.groupEnd();
                },
                /**
     * Iterates through all entries in this Map, passing each one to the given callback.
     *
     * If the callback returns `false`, the iteration will break.
     *
     * @method Phaser.Structs.Map#each
     * @since 3.0.0
     *
     * @genericUse {EachMapCallback.<V>} - [callback]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {EachMapCallback} callback - The callback which will receive the keys and entries held in this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ each: function(callback) {
                    var entries = this.entries;
                    for(var key in entries){
                        if (callback(key, entries[key]) === false) break;
                    }
                    return this;
                },
                /**
     * Returns `true` if the value exists within this Map. Otherwise, returns `false`.
     *
     * @method Phaser.Structs.Map#contains
     * @since 3.0.0
     *
     * @genericUse {V} - [value]
     *
     * @param {*} value - The value to search for.
     *
     * @return {boolean} `true` if the value is found, otherwise `false`.
     */ contains: function(value) {
                    var entries = this.entries;
                    for(var key in entries){
                        if (entries[key] === value) return true;
                    }
                    return false;
                },
                /**
     * Merges all new keys from the given Map into this one.
     * If it encounters a key that already exists it will be skipped unless override is set to `true`.
     *
     * @method Phaser.Structs.Map#merge
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [map,$return]
     *
     * @param {Phaser.Structs.Map} map - The Map to merge in to this Map.
     * @param {boolean} [override=false] - Set to `true` to replace values in this Map with those from the source map, or `false` to skip them.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ merge: function(map, override) {
                    if (override === undefined) override = false;
                    var local = this.entries;
                    var source = map.entries;
                    for(var key in source)if (local.hasOwnProperty(key) && override) local[key] = source[key];
                    else this.set(key, source[key]);
                    return this;
                }
            });
            module1.exports = Map;
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given 3 separate color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor = function(red, green, blue) {
                return red << 16 | green << 8 | blue;
            };
            module1.exports = GetColor;
        /***/ },
        /* 104 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scale.Events
 */ module1.exports = {
                ENTER_FULLSCREEN: __webpack_require__(800),
                FULLSCREEN_FAILED: __webpack_require__(801),
                FULLSCREEN_UNSUPPORTED: __webpack_require__(802),
                LEAVE_FULLSCREEN: __webpack_require__(803),
                ORIENTATION_CHANGE: __webpack_require__(804),
                RESIZE: __webpack_require__(805)
            };
        /***/ },
        /* 105 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(process) {
                /**
 * Determines the operating system of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.os` from within any Scene.
 *
 * @typedef {object} Phaser.Device.OS
 * @since 3.0.0
 *
 * @property {boolean} android - Is running on android?
 * @property {boolean} chromeOS - Is running on chromeOS?
 * @property {boolean} cordova - Is the game running under Apache Cordova?
 * @property {boolean} crosswalk - Is the game running under the Intel Crosswalk XDK?
 * @property {boolean} desktop - Is running on a desktop?
 * @property {boolean} ejecta - Is the game running under Ejecta?
 * @property {boolean} electron - Is the game running under GitHub Electron?
 * @property {boolean} iOS - Is running on iOS?
 * @property {boolean} iPad - Is running on iPad?
 * @property {boolean} iPhone - Is running on iPhone?
 * @property {boolean} kindle - Is running on an Amazon Kindle?
 * @property {boolean} linux - Is running on linux?
 * @property {boolean} macOS - Is running on macOS?
 * @property {boolean} node - Is the game running under Node.js?
 * @property {boolean} nodeWebkit - Is the game running under Node-Webkit?
 * @property {boolean} webApp - Set to true if running as a WebApp, i.e. within a WebView
 * @property {boolean} windows - Is running on windows?
 * @property {boolean} windowsPhone - Is running on a Windows Phone?
 * @property {number} iOSVersion - If running in iOS this will contain the major version number.
 * @property {number} pixelRatio - PixelRatio of the host device?
 */ var OS = {
                    android: false,
                    chromeOS: false,
                    cordova: false,
                    crosswalk: false,
                    desktop: false,
                    ejecta: false,
                    electron: false,
                    iOS: false,
                    iOSVersion: 0,
                    iPad: false,
                    iPhone: false,
                    kindle: false,
                    linux: false,
                    macOS: false,
                    node: false,
                    nodeWebkit: false,
                    pixelRatio: 1,
                    webApp: false,
                    windows: false,
                    windowsPhone: false
                };
                function init() {
                    if (typeof importScripts === "function") return OS;
                    var ua = navigator.userAgent;
                    if (/Windows/.test(ua)) OS.windows = true;
                    else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
                        //  Because iOS 13 identifies as Mac OS:
                        if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                            OS.iOS = true;
                            OS.iPad = true;
                            navigator.appVersion.match(/Version\/(\d+)/);
                            OS.iOSVersion = parseInt(RegExp.$1, 10);
                        } else OS.macOS = true;
                    } else if (/Android/.test(ua)) OS.android = true;
                    else if (/Linux/.test(ua)) OS.linux = true;
                    else if (/iP[ao]d|iPhone/i.test(ua)) {
                        OS.iOS = true;
                        navigator.appVersion.match(/OS (\d+)/);
                        OS.iOSVersion = parseInt(RegExp.$1, 10);
                        OS.iPhone = ua.toLowerCase().indexOf("iphone") !== -1;
                        OS.iPad = ua.toLowerCase().indexOf("ipad") !== -1;
                    } else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) OS.kindle = true;
                    else if (/CrOS/.test(ua)) OS.chromeOS = true;
                    if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
                        OS.android = false;
                        OS.iOS = false;
                        OS.macOS = false;
                        OS.windows = true;
                        OS.windowsPhone = true;
                    }
                    var silk = /Silk/.test(ua);
                    if (OS.windows || OS.macOS || OS.linux && !silk || OS.chromeOS) OS.desktop = true;
                    //  Windows Phone / Table reset
                    if (OS.windowsPhone || /Windows NT/i.test(ua) && /Touch/i.test(ua)) OS.desktop = false;
                    //  WebApp mode in iOS
                    if (navigator.standalone) OS.webApp = true;
                    if (typeof importScripts !== "function") {
                        if (window.cordova !== undefined) OS.cordova = true;
                        if (window.ejecta !== undefined) OS.ejecta = true;
                    }
                    if (typeof process !== "undefined" && process.versions && process.versions.node) OS.node = true;
                    if (OS.node && typeof process.versions === "object") {
                        OS.nodeWebkit = !!process.versions["node-webkit"];
                        OS.electron = !!process.versions.electron;
                    }
                    if (/Crosswalk/.test(ua)) OS.crosswalk = true;
                    OS.pixelRatio = window["devicePixelRatio"] || 1;
                    return OS;
                }
                module1.exports = init();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(807));
        /***/ },
        /* 106 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Events
 */ module1.exports = {
                ADD: __webpack_require__(861),
                ERROR: __webpack_require__(862),
                LOAD: __webpack_require__(863),
                READY: __webpack_require__(864),
                REMOVE: __webpack_require__(865)
            };
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = {
                /**
     * 	8-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ BYTE: {
                    enum: 0x1400,
                    size: 1
                },
                /**
     * 8-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_BYTE: {
                    enum: 0x1401,
                    size: 1
                },
                /**
     * 16-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ SHORT: {
                    enum: 0x1402,
                    size: 2
                },
                /**
     * 16-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_SHORT: {
                    enum: 0x1403,
                    size: 2
                },
                /**
     * 32-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ INT: {
                    enum: 0x1404,
                    size: 4
                },
                /**
     * 32-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_INT: {
                    enum: 0x1405,
                    size: 4
                },
                /**
     * 32-bit IEEE floating point number.
     *
     * @name Phaser.Renderer.WebGL.FLOAT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ FLOAT: {
                    enum: 0x1406,
                    size: 4
                }
            };
            module1.exports = WEBGL_CONST;
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(59);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(878);
            var ShaderSourceVS = __webpack_require__(879);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var WEBGL_CONST = __webpack_require__(107);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Multi Pipeline is the core 2D texture rendering pipeline used by Phaser in WebGL.
 * Virtually all Game Objects use this pipeline by default, including Sprites, Graphics
 * and Tilemaps. It handles the batching of quads and tris, as well as methods for
 * drawing and batching geometry data.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintPipeline`.
 *
 * In previous versions of Phaser only one single texture unit was supported at any one time.
 * The Multi Pipeline is an evolution of the old Texture Tint Pipeline, updated to support
 * multi-textures for increased performance.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D array)
 *
 * If you wish to create a custom pipeline extending from this one, you can use two string
 * declarations in your fragment shader source: `%count%` and `%forloop%`, where `count` is
 * used to set the number of `sampler2Ds` available, and `forloop` is a block of GLSL code
 * that will get the currently bound texture unit.
 *
 * This pipeline will automatically inject that code for you, should those values exist
 * in your shader source. If you wish to handle this yourself, you can also use the
 * function `Utils.parseFragmentShaderMaxTextures`.
 *
 * If you wish to create a pipeline that works from a single texture, or that doesn't have
 * internal texture iteration, please see the `SinglePipeline` instead.
 *
 * @class MultiPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var MultiPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function MultiPipeline(config) {
                    var renderer = config.game.renderer;
                    var fragmentShaderSource = GetFastValue(config, "fragShader", ShaderSourceFS);
                    config.fragShader = Utils.parseFragmentShaderMaxTextures(fragmentShaderSource, renderer.maxTextures);
                    config.vertShader = GetFastValue(config, "vertShader", ShaderSourceVS);
                    config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        },
                        {
                            name: "inTexId"
                        },
                        {
                            name: "inTintEffect"
                        },
                        {
                            name: "inTint",
                            size: 4,
                            type: WEBGL_CONST.UNSIGNED_BYTE,
                            normalized: true
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching by the
         * Shape Game Objects.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#calcMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.55.0
         */ this.calcMatrix = new TransformMatrix();
                    /**
         * Used internally to draw stroked triangles.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#tempTriangle
         * @type {array}
         * @private
         * @since 3.55.0
         */ this.tempTriangle = [
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        }
                    ];
                    /**
         * Cached stroke tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#strokeTint
         * @type {object}
         * @private
         * @since 3.55.0
         */ this.strokeTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Cached fill tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#fillTint
         * @type {object}
         * @private
         * @since 3.55.0
         */ this.fillTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Internal texture frame reference.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#currentFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.55.0
         */ this.currentFrame = {
                        u0: 0,
                        v0: 0,
                        u1: 1,
                        v1: 1
                    };
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#firstQuad
         * @type {number[]}
         * @private
         * @since 3.55.0
         */ this.firstQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#prevQuad
         * @type {number[]}
         * @private
         * @since 3.55.0
         */ this.prevQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Used internally for triangulating a polygon.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#polygonCache
         * @type {array}
         * @private
         * @since 3.55.0
         */ this.polygonCache = [];
                },
                /**
     * Called every time the pipeline is bound by the renderer.
     * Sets the shader program, vertex buffer and other resources.
     * Should only be called when changing pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#bind
     * @since 3.50.0
     *
     * @return {this} This WebGLPipeline instance.
     */ boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.currentShader.set1iv("uMainSampler", this.renderer.textureIndexes);
                },
                /**
     * Takes a Sprite Game Object, or any object that extends it, and adds it to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchSprite
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.Image|Phaser.GameObjects.Sprite)} gameObject - The texture based Game Object to add to the batch.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(gameObject, camera, parentTransformMatrix) {
                    this.manager.set(this, gameObject);
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var calcMatrix = this._tempMatrix3;
                    var frame = gameObject.frame;
                    var texture = frame.glTexture;
                    var u0 = frame.u0;
                    var v0 = frame.v0;
                    var u1 = frame.u1;
                    var v1 = frame.v1;
                    var frameX = frame.x;
                    var frameY = frame.y;
                    var frameWidth = frame.cutWidth;
                    var frameHeight = frame.cutHeight;
                    var customPivot = frame.customPivot;
                    var displayOriginX = gameObject.displayOriginX;
                    var displayOriginY = gameObject.displayOriginY;
                    var x = -displayOriginX + frameX;
                    var y = -displayOriginY + frameY;
                    if (gameObject.isCropped) {
                        var crop = gameObject._crop;
                        if (crop.flipX !== gameObject.flipX || crop.flipY !== gameObject.flipY) frame.updateCropUVs(crop, gameObject.flipX, gameObject.flipY);
                        u0 = crop.u0;
                        v0 = crop.v0;
                        u1 = crop.u1;
                        v1 = crop.v1;
                        frameWidth = crop.width;
                        frameHeight = crop.height;
                        frameX = crop.x;
                        frameY = crop.y;
                        x = -displayOriginX + frameX;
                        y = -displayOriginY + frameY;
                    }
                    var flipX = 1;
                    var flipY = 1;
                    if (gameObject.flipX) {
                        if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                        flipX = -1;
                    }
                    //  Auto-invert the flipY if this is coming from a GLTexture
                    if (gameObject.flipY || frame.source.isGLTexture && !texture.flipY) {
                        if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                        flipY = -1;
                    }
                    spriteMatrix.applyITRS(gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX * flipX, gameObject.scaleY * flipY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * gameObject.scrollFactorX, -camera.scrollY * gameObject.scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = gameObject.x;
                        spriteMatrix.f = gameObject.y;
                    } else {
                        spriteMatrix.e -= camera.scrollX * gameObject.scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * gameObject.scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(spriteMatrix, calcMatrix);
                    var xw = x + frameWidth;
                    var yh = y + frameHeight;
                    var roundPixels = camera.roundPixels;
                    var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                    var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                    var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                    var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                    var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                    var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                    var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                    var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var cameraAlpha = camera.alpha;
                    var tintTL = getTint(gameObject.tintTopLeft, cameraAlpha * gameObject._alphaTL);
                    var tintTR = getTint(gameObject.tintTopRight, cameraAlpha * gameObject._alphaTR);
                    var tintBL = getTint(gameObject.tintBottomLeft, cameraAlpha * gameObject._alphaBL);
                    var tintBR = getTint(gameObject.tintBottomRight, cameraAlpha * gameObject._alphaBR);
                    if (this.shouldFlush(6)) this.flush();
                    var unit = this.setGameObject(gameObject, frame);
                    this.manager.preBatch(gameObject);
                    this.batchQuad(gameObject, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, gameObject.tintFill, texture, unit);
                    this.manager.postBatch(gameObject);
                },
                /**
     * Generic function for batching a textured quad using argument values instead of a Game Object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject.
     * @param {WebGLTexture} texture - Raw WebGLTexture associated with the quad.
     * @param {number} textureWidth - Real texture width.
     * @param {number} textureHeight - Real texture height.
     * @param {number} srcX - X coordinate of the quad.
     * @param {number} srcY - Y coordinate of the quad.
     * @param {number} srcWidth - Width of the quad.
     * @param {number} srcHeight - Height of the quad.
     * @param {number} scaleX - X component of scale.
     * @param {number} scaleY - Y component of scale.
     * @param {number} rotation - Rotation of the quad.
     * @param {boolean} flipX - Indicates if the quad is horizontally flipped.
     * @param {boolean} flipY - Indicates if the quad is vertically flipped.
     * @param {number} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll.
     * @param {number} scrollFactorY - By which factor is the quad effected by the camera vertical scroll.
     * @param {number} displayOriginX - Horizontal origin in pixels.
     * @param {number} displayOriginY - Vertical origin in pixels.
     * @param {number} frameX - X coordinate of the texture frame.
     * @param {number} frameY - Y coordinate of the texture frame.
     * @param {number} frameWidth - Width of the texture frame.
     * @param {number} frameHeight - Height of the texture frame.
     * @param {number} tintTL - Tint for top left.
     * @param {number} tintTR - Tint for top right.
     * @param {number} tintBL - Tint for bottom left.
     * @param {number} tintBR - Tint for bottom right.
     * @param {number} tintEffect - The tint effect.
     * @param {number} uOffset - Horizontal offset on texture coordinate.
     * @param {number} vOffset - Vertical offset on texture coordinate.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container.
     * @param {boolean} [skipFlip=false] - Skip the renderTexture check.
     * @param {number} [textureUnit] - Use the currently bound texture unit?
     */ batchTexture: function(gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit) {
                    this.manager.set(this, gameObject);
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var calcMatrix = this._tempMatrix3;
                    var u0 = frameX / textureWidth + uOffset;
                    var v0 = frameY / textureHeight + vOffset;
                    var u1 = (frameX + frameWidth) / textureWidth + uOffset;
                    var v1 = (frameY + frameHeight) / textureHeight + vOffset;
                    var width = srcWidth;
                    var height = srcHeight;
                    var x = -displayOriginX;
                    var y = -displayOriginY;
                    if (gameObject.isCropped) {
                        var crop = gameObject._crop;
                        var cropWidth = crop.width;
                        var cropHeight = crop.height;
                        width = cropWidth;
                        height = cropHeight;
                        srcWidth = cropWidth;
                        srcHeight = cropHeight;
                        frameX = crop.x;
                        frameY = crop.y;
                        var ox = frameX;
                        var oy = frameY;
                        if (flipX) ox = frameWidth - crop.x - cropWidth;
                        if (flipY) oy = frameHeight - crop.y - cropHeight;
                        u0 = ox / textureWidth + uOffset;
                        v0 = oy / textureHeight + vOffset;
                        u1 = (ox + cropWidth) / textureWidth + uOffset;
                        v1 = (oy + cropHeight) / textureHeight + vOffset;
                        x = -displayOriginX + frameX;
                        y = -displayOriginY + frameY;
                    }
                    //  Invert the flipY if this is a RenderTexture
                    flipY = flipY ^ (!skipFlip && texture.isRenderTexture ? 1 : 0);
                    if (flipX) {
                        width *= -1;
                        x += srcWidth;
                    }
                    if (flipY) {
                        height *= -1;
                        y += srcHeight;
                    }
                    var xw = x + width;
                    var yh = y + height;
                    spriteMatrix.applyITRS(srcX, srcY, rotation, scaleX, scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = srcX;
                        spriteMatrix.f = srcY;
                    } else {
                        spriteMatrix.e -= camera.scrollX * scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(spriteMatrix, calcMatrix);
                    var roundPixels = camera.roundPixels;
                    var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                    var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                    var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                    var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                    var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                    var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                    var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                    var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                    if (textureUnit === undefined) textureUnit = this.renderer.setTexture2D(texture);
                    if (gameObject) this.manager.preBatch(gameObject);
                    this.batchQuad(gameObject, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                    if (gameObject) this.manager.postBatch(gameObject);
                },
                /**
     * Adds a Texture Frame into the batch for rendering.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTextureFrame
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} frame - The Texture Frame to be rendered.
     * @param {number} x - The horizontal position to render the texture at.
     * @param {number} y - The vertical position to render the texture at.
     * @param {number} tint - The tint color.
     * @param {number} alpha - The alpha value.
     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - The Transform Matrix to use for the texture.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - A parent Transform Matrix.
     */ batchTextureFrame: function(frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix) {
                    this.manager.set(this);
                    var spriteMatrix = this._tempMatrix1.copyFrom(transformMatrix);
                    var calcMatrix = this._tempMatrix2;
                    var xw = x + frame.width;
                    var yh = y + frame.height;
                    if (parentTransformMatrix) spriteMatrix.multiply(parentTransformMatrix, calcMatrix);
                    else calcMatrix = spriteMatrix;
                    var tx0 = calcMatrix.getX(x, y);
                    var ty0 = calcMatrix.getY(x, y);
                    var tx1 = calcMatrix.getX(x, yh);
                    var ty1 = calcMatrix.getY(x, yh);
                    var tx2 = calcMatrix.getX(xw, yh);
                    var ty2 = calcMatrix.getY(xw, yh);
                    var tx3 = calcMatrix.getX(xw, y);
                    var ty3 = calcMatrix.getY(xw, y);
                    var unit = this.renderer.setTextureSource(frame.source);
                    tint = Utils.getTintAppendFloatAlpha(tint, alpha);
                    this.batchQuad(null, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, 0, frame.glTexture, unit);
                },
                /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * Rectangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillRect
     * @since 3.55.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillRect: function(x, y, width, height, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var xw = x + width;
                    var yh = y + height;
                    var x0 = calcMatrix.getX(x, y);
                    var y0 = calcMatrix.getY(x, y);
                    var x1 = calcMatrix.getX(x, yh);
                    var y1 = calcMatrix.getY(x, yh);
                    var x2 = calcMatrix.getX(xw, yh);
                    var y2 = calcMatrix.getY(xw, yh);
                    var x3 = calcMatrix.getX(xw, y);
                    var y3 = calcMatrix.getY(xw, y);
                    var tint = this.fillTint;
                    this.batchQuad(null, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint.TL, tint.TR, tint.BL, tint.BR, 2);
                },
                /**
     * Pushes a filled triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillTriangle
     * @since 3.55.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillTriangle: function(x0, y0, x1, y1, x2, y2, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var tx0 = calcMatrix.getX(x0, y0);
                    var ty0 = calcMatrix.getY(x0, y0);
                    var tx1 = calcMatrix.getX(x1, y1);
                    var ty1 = calcMatrix.getY(x1, y1);
                    var tx2 = calcMatrix.getX(x2, y2);
                    var ty2 = calcMatrix.getY(x2, y2);
                    var tint = this.fillTint;
                    this.batchTri(null, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, tint.TL, tint.TR, tint.BL, 2);
                },
                /**
     * Pushes a stroked triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * The triangle is created from 3 lines and drawn using the `batchStrokePath` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchStrokeTriangle
     * @since 3.55.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {number} lineWidth - The width of the line in pixels.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokeTriangle: function(x0, y0, x1, y1, x2, y2, lineWidth, currentMatrix, parentMatrix) {
                    var tempTriangle = this.tempTriangle;
                    tempTriangle[0].x = x0;
                    tempTriangle[0].y = y0;
                    tempTriangle[0].width = lineWidth;
                    tempTriangle[1].x = x1;
                    tempTriangle[1].y = y1;
                    tempTriangle[1].width = lineWidth;
                    tempTriangle[2].x = x2;
                    tempTriangle[2].y = y2;
                    tempTriangle[2].width = lineWidth;
                    tempTriangle[3].x = x0;
                    tempTriangle[3].y = y0;
                    tempTriangle[3].width = lineWidth;
                    this.batchStrokePath(tempTriangle, lineWidth, false, currentMatrix, parentMatrix);
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and then passing it through Earcut, which
     * creates a list of polygons. Each polygon is then added to the batch.
     *
     * The path is always automatically closed because it's filled.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchFillPath
     * @since 3.55.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillPath: function(path, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var length = path.length;
                    var polygonCache = this.polygonCache;
                    var polygonIndexArray;
                    var point;
                    var tintTL = this.fillTint.TL;
                    var tintTR = this.fillTint.TR;
                    var tintBL = this.fillTint.BL;
                    for(var pathIndex = 0; pathIndex < length; ++pathIndex){
                        point = path[pathIndex];
                        polygonCache.push(point.x, point.y);
                    }
                    polygonIndexArray = Earcut(polygonCache);
                    length = polygonIndexArray.length;
                    for(var index = 0; index < length; index += 3){
                        var p0 = polygonIndexArray[index + 0] * 2;
                        var p1 = polygonIndexArray[index + 1] * 2;
                        var p2 = polygonIndexArray[index + 2] * 2;
                        var x0 = polygonCache[p0 + 0];
                        var y0 = polygonCache[p0 + 1];
                        var x1 = polygonCache[p1 + 0];
                        var y1 = polygonCache[p1 + 1];
                        var x2 = polygonCache[p2 + 0];
                        var y2 = polygonCache[p2 + 1];
                        var tx0 = calcMatrix.getX(x0, y0);
                        var ty0 = calcMatrix.getY(x0, y0);
                        var tx1 = calcMatrix.getX(x1, y1);
                        var ty1 = calcMatrix.getY(x1, y1);
                        var tx2 = calcMatrix.getX(x2, y2);
                        var ty2 = calcMatrix.getY(x2, y2);
                        this.batchTri(null, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, tintTL, tintTR, tintBL, 2);
                    }
                    polygonCache.length = 0;
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and calling `batchLine` for each section
     * of the path.
     *
     * The path is optionally closed at the end.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchStrokePath
     * @since 3.55.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {number} lineWidth - The width of the line segments in pixels.
     * @param {boolean} pathOpen - Indicates if the path should be closed or left open.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokePath: function(path, lineWidth, pathOpen, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    //  Reset the closePath booleans
                    this.prevQuad[4] = 0;
                    this.firstQuad[4] = 0;
                    var pathLength = path.length - 1;
                    for(var pathIndex = 0; pathIndex < pathLength; pathIndex++){
                        var point0 = path[pathIndex];
                        var point1 = path[pathIndex + 1];
                        this.batchLine(point0.x, point0.y, point1.x, point1.y, point0.width / 2, point1.width / 2, lineWidth, pathIndex, !pathOpen && pathIndex === pathLength - 1, currentMatrix, parentMatrix);
                    }
                },
                /**
     * Creates a line out of 4 quads and adds it to the vertex batch based on the given line values.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchLine
     * @since 3.55.0
     *
     * @param {number} ax - x coordinate of the start of the line.
     * @param {number} ay - y coordinate of the start of the line.
     * @param {number} bx - x coordinate of the end of the line.
     * @param {number} by - y coordinate of the end of the line.
     * @param {number} aLineWidth - Width of the start of the line.
     * @param {number} bLineWidth - Width of the end of the line.
     * @param {number} index - If this line is part of a multi-line draw, the index of the line in the draw.
     * @param {boolean} closePath - Does this line close a multi-line path?
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchLine: function(ax, ay, bx, by, aLineWidth, bLineWidth, lineWidth, index, closePath, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var dx = bx - ax;
                    var dy = by - ay;
                    var len = Math.sqrt(dx * dx + dy * dy);
                    var al0 = aLineWidth * (by - ay) / len;
                    var al1 = aLineWidth * (ax - bx) / len;
                    var bl0 = bLineWidth * (by - ay) / len;
                    var bl1 = bLineWidth * (ax - bx) / len;
                    var lx0 = bx - bl0;
                    var ly0 = by - bl1;
                    var lx1 = ax - al0;
                    var ly1 = ay - al1;
                    var lx2 = bx + bl0;
                    var ly2 = by + bl1;
                    var lx3 = ax + al0;
                    var ly3 = ay + al1;
                    //  tx0 = bottom right
                    var brX = calcMatrix.getX(lx0, ly0);
                    var brY = calcMatrix.getY(lx0, ly0);
                    //  tx1 = bottom left
                    var blX = calcMatrix.getX(lx1, ly1);
                    var blY = calcMatrix.getY(lx1, ly1);
                    //  tx2 = top right
                    var trX = calcMatrix.getX(lx2, ly2);
                    var trY = calcMatrix.getY(lx2, ly2);
                    //  tx3 = top left
                    var tlX = calcMatrix.getX(lx3, ly3);
                    var tlY = calcMatrix.getY(lx3, ly3);
                    var tint = this.strokeTint;
                    var tintTL = tint.TL;
                    var tintTR = tint.TR;
                    var tintBL = tint.BL;
                    var tintBR = tint.BR;
                    //  TL, BL, BR, TR
                    this.batchQuad(null, tlX, tlY, blX, blY, brX, brY, trX, trY, 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                    if (lineWidth <= 2) //  No point doing a linejoin if the line isn't thick enough
                    return;
                    var prev = this.prevQuad;
                    var first = this.firstQuad;
                    if (index > 0 && prev[4]) this.batchQuad(null, tlX, tlY, blX, blY, prev[0], prev[1], prev[2], prev[3], 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                    else {
                        first[0] = tlX;
                        first[1] = tlY;
                        first[2] = blX;
                        first[3] = blY;
                        first[4] = 1;
                    }
                    if (closePath && first[4]) //  Add a join for the final path segment
                    this.batchQuad(null, brX, brY, trX, trY, first[0], first[1], first[2], first[3], 0, 0, 1, 1, tintTL, tintTR, tintBL, tintBR, 2);
                    else {
                        //  Store it
                        prev[0] = brX;
                        prev[1] = brY;
                        prev[2] = trX;
                        prev[3] = trY;
                        prev[4] = 1;
                    }
                }
            });
            module1.exports = MultiPipeline;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Extend = __webpack_require__(17);
            /**
 * @classdesc
 * A Frame is a section of a Texture.
 *
 * @class Frame
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this Frame is a part of.
 * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
 * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
 * @param {number} x - The x coordinate of the top-left of this Frame.
 * @param {number} y - The y coordinate of the top-left of this Frame.
 * @param {number} width - The width of this Frame.
 * @param {number} height - The height of this Frame.
 */ var Frame = new Class({
                initialize: function Frame(texture, name, sourceIndex, x, y, width, height) {
                    /**
         * The Texture this Frame is a part of.
         *
         * @name Phaser.Textures.Frame#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                    /**
         * The name of this Frame.
         * The name is unique within the Texture.
         *
         * @name Phaser.Textures.Frame#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                    /**
         * The TextureSource this Frame is part of.
         *
         * @name Phaser.Textures.Frame#source
         * @type {Phaser.Textures.TextureSource}
         * @since 3.0.0
         */ this.source = texture.source[sourceIndex];
                    /**
         * The index of the TextureSource in the Texture sources array.
         *
         * @name Phaser.Textures.Frame#sourceIndex
         * @type {number}
         * @since 3.0.0
         */ this.sourceIndex = sourceIndex;
                    /**
         * A reference to the Texture Source WebGL Texture that this Frame is using.
         *
         * @name Phaser.Textures.Frame#glTexture
         * @type {?WebGLTexture}
         * @default null
         * @since 3.11.0
         */ this.glTexture = this.source.glTexture;
                    /**
         * X position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutX
         * @type {number}
         * @since 3.0.0
         */ this.cutX;
                    /**
         * Y position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutY
         * @type {number}
         * @since 3.0.0
         */ this.cutY;
                    /**
         * The width of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutWidth
         * @type {number}
         * @since 3.0.0
         */ this.cutWidth;
                    /**
         * The height of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutHeight
         * @type {number}
         * @since 3.0.0
         */ this.cutHeight;
                    /**
         * The X rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The Y rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The rendering width of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#width
         * @type {number}
         * @since 3.0.0
         */ this.width;
                    /**
         * The rendering height of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#height
         * @type {number}
         * @since 3.0.0
         */ this.height;
                    /**
         * Half the width, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth;
                    /**
         * Half the height, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight;
                    /**
         * The x center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerX
         * @type {number}
         * @since 3.0.0
         */ this.centerX;
                    /**
         * The y center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerY
         * @type {number}
         * @since 3.0.0
         */ this.centerY;
                    /**
         * The horizontal pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotX = 0;
                    /**
         * The vertical pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotY = 0;
                    /**
         * Does this Frame have a custom pivot point?
         *
         * @name Phaser.Textures.Frame#customPivot
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customPivot = false;
                    /**
         * **CURRENTLY UNSUPPORTED**
         *
         * Is this frame is rotated or not in the Texture?
         * Rotation allows you to use rotated frames in texture atlas packing.
         * It has nothing to do with Sprite rotation.
         *
         * @name Phaser.Textures.Frame#rotated
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rotated = false;
                    /**
         * Over-rides the Renderer setting.
         * -1 = use Renderer Setting
         * 0 = No rounding
         * 1 = Round
         *
         * @name Phaser.Textures.Frame#autoRound
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.autoRound = -1;
                    /**
         * Any Frame specific custom data can be stored here.
         *
         * @name Phaser.Textures.Frame#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                    /**
         * WebGL UV u0 value.
         *
         * @name Phaser.Textures.Frame#u0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u0 = 0;
                    /**
         * WebGL UV v0 value.
         *
         * @name Phaser.Textures.Frame#v0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v0 = 0;
                    /**
         * WebGL UV u1 value.
         *
         * @name Phaser.Textures.Frame#u1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u1 = 0;
                    /**
         * WebGL UV v1 value.
         *
         * @name Phaser.Textures.Frame#v1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v1 = 0;
                    /**
         * The un-modified source frame, trim and UV data.
         *
         * @name Phaser.Textures.Frame#data
         * @type {object}
         * @private
         * @since 3.0.0
         */ this.data = {
                        cut: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        trim: false,
                        sourceSize: {
                            w: 0,
                            h: 0
                        },
                        spriteSourceSize: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        radius: 0,
                        drawImage: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        }
                    };
                    this.setSize(width, height, x, y);
                },
                /**
     * Sets the width, height, x and y of this Frame.
     *
     * This is called automatically by the constructor
     * and should rarely be changed on-the-fly.
     *
     * @method Phaser.Textures.Frame#setSize
     * @since 3.7.0
     *
     * @param {number} width - The width of the frame before being trimmed.
     * @param {number} height - The height of the frame before being trimmed.
     * @param {number} [x=0] - The x coordinate of the top-left of this Frame.
     * @param {number} [y=0] - The y coordinate of the top-left of this Frame.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setSize: function(width, height, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    this.cutX = x;
                    this.cutY = y;
                    this.cutWidth = width;
                    this.cutHeight = height;
                    this.width = width;
                    this.height = height;
                    this.halfWidth = Math.floor(width * 0.5);
                    this.halfHeight = Math.floor(height * 0.5);
                    this.centerX = Math.floor(width / 2);
                    this.centerY = Math.floor(height / 2);
                    var data = this.data;
                    var cut = data.cut;
                    cut.x = x;
                    cut.y = y;
                    cut.w = width;
                    cut.h = height;
                    cut.r = x + width;
                    cut.b = y + height;
                    data.sourceSize.w = width;
                    data.sourceSize.h = height;
                    data.spriteSourceSize.w = width;
                    data.spriteSourceSize.h = height;
                    data.radius = 0.5 * Math.sqrt(width * width + height * height);
                    var drawImage = data.drawImage;
                    drawImage.x = x;
                    drawImage.y = y;
                    drawImage.width = width;
                    drawImage.height = height;
                    return this.updateUVs();
                },
                /**
     * If the frame was trimmed when added to the Texture Atlas, this records the trim and source data.
     *
     * @method Phaser.Textures.Frame#setTrim
     * @since 3.0.0
     *
     * @param {number} actualWidth - The width of the frame before being trimmed.
     * @param {number} actualHeight - The height of the frame before being trimmed.
     * @param {number} destX - The destination X position of the trimmed frame for display.
     * @param {number} destY - The destination Y position of the trimmed frame for display.
     * @param {number} destWidth - The destination width of the trimmed frame for display.
     * @param {number} destHeight - The destination height of the trimmed frame for display.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setTrim: function(actualWidth, actualHeight, destX, destY, destWidth, destHeight) {
                    var data = this.data;
                    var ss = data.spriteSourceSize;
                    //  Store actual values
                    data.trim = true;
                    data.sourceSize.w = actualWidth;
                    data.sourceSize.h = actualHeight;
                    ss.x = destX;
                    ss.y = destY;
                    ss.w = destWidth;
                    ss.h = destHeight;
                    ss.r = destX + destWidth;
                    ss.b = destY + destHeight;
                    //  Adjust properties
                    this.x = destX;
                    this.y = destY;
                    this.width = destWidth;
                    this.height = destHeight;
                    this.halfWidth = destWidth * 0.5;
                    this.halfHeight = destHeight * 0.5;
                    this.centerX = Math.floor(destWidth / 2);
                    this.centerY = Math.floor(destHeight / 2);
                    return this.updateUVs();
                },
                /**
     * Takes a crop data object and, based on the rectangular region given, calculates the
     * required UV coordinates in order to crop this Frame for WebGL and Canvas rendering.
     *
     * This is called directly by the Game Object Texture Components `setCrop` method.
     * Please use that method to crop a Game Object.
     *
     * @method Phaser.Textures.Frame#setCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {number} x - The x coordinate to start the crop from. Cannot be negative or exceed the Frame width.
     * @param {number} y - The y coordinate to start the crop from. Cannot be negative or exceed the Frame height.
     * @param {number} width - The width of the crop rectangle. Cannot exceed the Frame width.
     * @param {number} height - The height of the crop rectangle. Cannot exceed the Frame height.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ setCropUVs: function(crop, x, y, width, height, flipX, flipY) {
                    //  Clamp the input values
                    var cx = this.cutX;
                    var cy = this.cutY;
                    var cw = this.cutWidth;
                    var ch = this.cutHeight;
                    var rw = this.realWidth;
                    var rh = this.realHeight;
                    x = Clamp(x, 0, rw);
                    y = Clamp(y, 0, rh);
                    width = Clamp(width, 0, rw - x);
                    height = Clamp(height, 0, rh - y);
                    var ox = cx + x;
                    var oy = cy + y;
                    var ow = width;
                    var oh = height;
                    var data = this.data;
                    if (data.trim) {
                        var ss = data.spriteSourceSize;
                        //  Need to check for intersection between the cut area and the crop area
                        //  If there is none, we set UV to be empty, otherwise set it to be the intersection area
                        width = Clamp(width, 0, cw - x);
                        height = Clamp(height, 0, ch - y);
                        var cropRight = x + width;
                        var cropBottom = y + height;
                        var intersects = !(ss.r < x || ss.b < y || ss.x > cropRight || ss.y > cropBottom);
                        if (intersects) {
                            var ix = Math.max(ss.x, x);
                            var iy = Math.max(ss.y, y);
                            var iw = Math.min(ss.r, cropRight) - ix;
                            var ih = Math.min(ss.b, cropBottom) - iy;
                            ow = iw;
                            oh = ih;
                            if (flipX) ox = cx + (cw - (ix - ss.x) - iw);
                            else ox = cx + (ix - ss.x);
                            if (flipY) oy = cy + (ch - (iy - ss.y) - ih);
                            else oy = cy + (iy - ss.y);
                            x = ix;
                            y = iy;
                            width = iw;
                            height = ih;
                        } else {
                            ox = 0;
                            oy = 0;
                            ow = 0;
                            oh = 0;
                        }
                    } else {
                        if (flipX) ox = cx + (cw - x - width);
                        if (flipY) oy = cy + (ch - y - height);
                    }
                    var tw = this.source.width;
                    var th = this.source.height;
                    //  Map the given coordinates into UV space, clamping to the 0-1 range.
                    crop.u0 = Math.max(0, ox / tw);
                    crop.v0 = Math.max(0, oy / th);
                    crop.u1 = Math.min(1, (ox + ow) / tw);
                    crop.v1 = Math.min(1, (oy + oh) / th);
                    crop.x = x;
                    crop.y = y;
                    crop.cx = ox;
                    crop.cy = oy;
                    crop.cw = ow;
                    crop.ch = oh;
                    crop.width = width;
                    crop.height = height;
                    crop.flipX = flipX;
                    crop.flipY = flipY;
                    return crop;
                },
                /**
     * Takes a crop data object and recalculates the UVs based on the dimensions inside the crop object.
     * Called automatically by `setFrame`.
     *
     * @method Phaser.Textures.Frame#updateCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ updateCropUVs: function(crop, flipX, flipY) {
                    return this.setCropUVs(crop, crop.x, crop.y, crop.width, crop.height, flipX, flipY);
                },
                /**
     * Directly sets the canvas and WebGL UV data for this frame.
     *
     * Use this if you need to override the values that are generated automatically
     * when the Frame is created.
     *
     * @method Phaser.Textures.Frame#setUVs
     * @since 3.50.0
     *
     * @param {number} width - Width of this frame for the Canvas data.
     * @param {number} height - Height of this frame for the Canvas data.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setUVs: function(width, height, u0, v0, u1, v1) {
                    //  Canvas data
                    var cd = this.data.drawImage;
                    cd.width = width;
                    cd.height = height;
                    //  WebGL data
                    this.u0 = u0;
                    this.v0 = v0;
                    this.u1 = u1;
                    this.v1 = v1;
                    return this;
                },
                /**
     * Updates the internal WebGL UV cache and the drawImage cache.
     *
     * @method Phaser.Textures.Frame#updateUVs
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ updateUVs: function() {
                    var cx = this.cutX;
                    var cy = this.cutY;
                    var cw = this.cutWidth;
                    var ch = this.cutHeight;
                    //  Canvas data
                    var cd = this.data.drawImage;
                    cd.width = cw;
                    cd.height = ch;
                    //  WebGL data
                    var tw = this.source.width;
                    var th = this.source.height;
                    this.u0 = cx / tw;
                    this.v0 = cy / th;
                    this.u1 = (cx + cw) / tw;
                    this.v1 = (cy + ch) / th;
                    return this;
                },
                /**
     * Updates the internal WebGL UV cache.
     *
     * @method Phaser.Textures.Frame#updateUVsInverted
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ updateUVsInverted: function() {
                    var tw = this.source.width;
                    var th = this.source.height;
                    this.u0 = (this.cutX + this.cutHeight) / tw;
                    this.v0 = this.cutY / th;
                    this.u1 = this.cutX / tw;
                    this.v1 = (this.cutY + this.cutWidth) / th;
                    return this;
                },
                /**
     * Clones this Frame into a new Frame object.
     *
     * @method Phaser.Textures.Frame#clone
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} A clone of this Frame.
     */ clone: function() {
                    var clone = new Frame(this.texture, this.name, this.sourceIndex);
                    clone.cutX = this.cutX;
                    clone.cutY = this.cutY;
                    clone.cutWidth = this.cutWidth;
                    clone.cutHeight = this.cutHeight;
                    clone.x = this.x;
                    clone.y = this.y;
                    clone.width = this.width;
                    clone.height = this.height;
                    clone.halfWidth = this.halfWidth;
                    clone.halfHeight = this.halfHeight;
                    clone.centerX = this.centerX;
                    clone.centerY = this.centerY;
                    clone.rotated = this.rotated;
                    clone.data = Extend(true, clone.data, this.data);
                    clone.updateUVs();
                    return clone;
                },
                /**
     * Destroys this Frame by nulling its reference to the parent Texture and and data objects.
     *
     * @method Phaser.Textures.Frame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.source = null;
                    this.texture = null;
                    this.glTexture = null;
                    this.customData = null;
                    this.data = null;
                },
                /**
     * The width of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realWidth
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realWidth: {
                    get: function() {
                        return this.data.sourceSize.w;
                    }
                },
                /**
     * The height of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realHeight
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realHeight: {
                    get: function() {
                        return this.data.sourceSize.h;
                    }
                },
                /**
     * The radius of the Frame (derived from sqrt(w * w + h * h) / 2)
     *
     * @name Phaser.Textures.Frame#radius
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ radius: {
                    get: function() {
                        return this.data.radius;
                    }
                },
                /**
     * Is the Frame trimmed or not?
     *
     * @name Phaser.Textures.Frame#trimmed
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ trimmed: {
                    get: function() {
                        return this.data.trim;
                    }
                },
                /**
     * The Canvas drawImage data object.
     *
     * @name Phaser.Textures.Frame#canvasData
     * @type {object}
     * @readonly
     * @since 3.0.0
     */ canvasData: {
                    get: function() {
                        return this.data.drawImage;
                    }
                }
            });
            module1.exports = Frame;
        /***/ },
        /* 110 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(208);
            var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            var StableSort = __webpack_require__(79);
            /**
 * @callback EachListCallback<I>
 *
 * @param {I} item - The item which is currently being processed.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * List is a generic implementation of an ordered list which contains utility methods for retrieving, manipulating, and iterating items.
 *
 * @class List
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 *
 * @param {*} parent - The parent of this list.
 */ var List = new Class({
                initialize: function List(parent) {
                    /**
         * The parent of this list.
         *
         * @name Phaser.Structs.List#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * The objects that belong to this collection.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.List#list
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.list = [];
                    /**
         * The index of the current element.
         *
         * This is used internally when iterating through the list with the {@link #first}, {@link #last}, {@link #get}, and {@link #previous} properties.
         *
         * @name Phaser.Structs.List#position
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.position = 0;
                    /**
         * A callback that is invoked every time a child is added to this list.
         *
         * @name Phaser.Structs.List#addCallback
         * @type {function}
         * @since 3.4.0
         */ this.addCallback = NOOP;
                    /**
         * A callback that is invoked every time a child is removed from this list.
         *
         * @name Phaser.Structs.List#removeCallback
         * @type {function}
         * @since 3.4.0
         */ this.removeCallback = NOOP;
                    /**
         * The property key to sort by.
         *
         * @name Phaser.Structs.List#_sortKey
         * @type {string}
         * @since 3.4.0
         */ this._sortKey = "";
                },
                /**
     * Adds the given item to the end of the list. Each item must be unique.
     *
     * @method Phaser.Structs.List#add
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*|Array.<*>} child - The item, or array of items, to add to the list.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The list's underlying array.
     */ add: function(child, skipCallback) {
                    if (skipCallback) return ArrayUtils.Add(this.list, child);
                    else return ArrayUtils.Add(this.list, child, 0, this.addCallback, this);
                },
                /**
     * Adds an item to list, starting at a specified index. Each item must be unique within the list.
     *
     * @method Phaser.Structs.List#addAt
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item, or array of items, to add to the list.
     * @param {number} [index=0] - The index in the list at which the element(s) will be inserted.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The List's underlying array.
     */ addAt: function(child, index, skipCallback) {
                    if (skipCallback) return ArrayUtils.AddAt(this.list, child, index);
                    else return ArrayUtils.AddAt(this.list, child, index, 0, this.addCallback, this);
                },
                /**
     * Retrieves the item at a given position inside the List.
     *
     * @method Phaser.Structs.List#getAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The index of the item.
     *
     * @return {*} The retrieved item, or `undefined` if it's outside the List's bounds.
     */ getAt: function(index) {
                    return this.list[index];
                },
                /**
     * Locates an item within the List and returns its index.
     *
     * @method Phaser.Structs.List#getIndex
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to locate.
     *
     * @return {number} The index of the item within the List, or -1 if it's not in the List.
     */ getIndex: function(child) {
                    //  Return -1 if given child isn't a child of this display list
                    return this.list.indexOf(child);
                },
                /**
     * Sort the contents of this List so the items are in order based on the given property.
     * For example, `sort('alpha')` would sort the List contents based on the value of their `alpha` property.
     *
     * @method Phaser.Structs.List#sort
     * @since 3.0.0
     *
     * @genericUse {T[]} - [children,$return]
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {Phaser.Structs.List} This List object.
     */ sort: function(property, handler) {
                    if (!property) return this;
                    if (handler === undefined) handler = function(childA, childB) {
                        return childA[property] - childB[property];
                    };
                    StableSort(this.list, handler);
                    return this;
                },
                /**
     * Searches for the first instance of a child with its `name`
     * property matching the given argument. Should more than one child have
     * the same name only the first is returned.
     *
     * @method Phaser.Structs.List#getByName
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} name - The name to search for.
     *
     * @return {?*} The first child with a matching name, or null if none were found.
     */ getByName: function(name) {
                    return ArrayUtils.GetFirst(this.list, "name", name);
                },
                /**
     * Returns a random child from the group.
     *
     * @method Phaser.Structs.List#getRandom
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {number} [startIndex=0] - Offset from the front of the group (lowest child).
     * @param {number} [length=(to top)] - Restriction on the number of values you want to randomly select from.
     *
     * @return {?*} A random child of this Group.
     */ getRandom: function(startIndex, length) {
                    return ArrayUtils.GetRandom(this.list, startIndex, length);
                },
                /**
     * Returns the first element in a given part of the List which matches a specific criterion.
     *
     * @method Phaser.Structs.List#getFirst
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} property - The name of the property to test or a falsey value to have no criterion.
     * @param {*} value - The value to test the `property` against, or `undefined` to allow any value and only check for existence.
     * @param {number} [startIndex=0] - The position in the List to start the search at.
     * @param {number} [endIndex] - The position in the List to optionally stop the search at. It won't be checked.
     *
     * @return {?*} The first item which matches the given criterion, or `null` if no such item exists.
     */ getFirst: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns all children in this List.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('parent')` would return only children that have a property called `parent`.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only children that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this List had 100 children,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 children in the List.
     *
     * @method Phaser.Structs.List#getAll
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {T[]} - [$return]
     *
     * @param {string} [property] - An optional property to test against the value argument.
     * @param {*} [value] - If property is set then Child.property must strictly equal this value to be included in the results.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     *
     * @return {Array.<*>} All items of the List which match the given criterion, if any.
     */ getAll: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns the total number of items in the List which have a property matching the given value.
     *
     * @method Phaser.Structs.List#count
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The property to test on each item.
     * @param {*} value - The value to test the property against.
     *
     * @return {number} The total number of matching elements.
     */ count: function(property, value) {
                    return ArrayUtils.CountAllMatching(this.list, property, value);
                },
                /**
     * Swaps the positions of two items in the list.
     *
     * @method Phaser.Structs.List#swap
     * @since 3.0.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The first item to swap.
     * @param {*} child2 - The second item to swap.
     */ swap: function(child1, child2) {
                    ArrayUtils.Swap(this.list, child1, child2);
                },
                /**
     * Moves an item in the List to a new position.
     *
     * @method Phaser.Structs.List#moveTo
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move.
     * @param {number} index - Moves an item in the List to a new position.
     *
     * @return {*} The item that was moved.
     */ moveTo: function(child, index) {
                    return ArrayUtils.MoveTo(this.list, child, index);
                },
                /**
     * Moves the given array element above another one in the array.
     *
     * @method Phaser.Structs.List#moveAbove
     * @since 3.55.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The element to move above base element.
     * @param {*} child2 - The base element.
     */ moveAbove: function(child1, child2) {
                    return ArrayUtils.MoveAbove(this.list, child1, child2);
                },
                /**
     * Moves the given array element below another one in the array.
     *
     * @method Phaser.Structs.List#moveBelow
     * @since 3.55.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The element to move below base element.
     * @param {*} child2 - The base element.
     */ moveBelow: function(child1, child2) {
                    return ArrayUtils.MoveBelow(this.list, child1, child2);
                },
                /**
     * Removes one or many items from the List.
     *
     * @method Phaser.Structs.List#remove
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item, or array of items, to remove.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item, or array of items, which were successfully removed from the List.
     */ remove: function(child, skipCallback) {
                    if (skipCallback) return ArrayUtils.Remove(this.list, child);
                    else return ArrayUtils.Remove(this.list, child, this.removeCallback, this);
                },
                /**
     * Removes the item at the given position in the List.
     *
     * @method Phaser.Structs.List#removeAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The position to remove the item from.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item that was removed.
     */ removeAt: function(index, skipCallback) {
                    if (skipCallback) return ArrayUtils.RemoveAt(this.list, index);
                    else return ArrayUtils.RemoveAt(this.list, index, this.removeCallback, this);
                },
                /**
     * Removes the items within the given range in the List.
     *
     * @method Phaser.Structs.List#removeBetween
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @param {number} [startIndex=0] - The index to start removing from.
     * @param {number} [endIndex] - The position to stop removing at. The item at this position won't be removed.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {Array.<*>} An array of the items which were removed.
     */ removeBetween: function(startIndex, endIndex, skipCallback) {
                    if (skipCallback) return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex);
                    else return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeCallback, this);
                },
                /**
     * Removes all the items.
     *
     * @method Phaser.Structs.List#removeAll
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {Phaser.Structs.List} This List object.
     */ removeAll: function(skipCallback) {
                    var i = this.list.length;
                    while(i--)this.remove(this.list[i], skipCallback);
                    return this;
                },
                /**
     * Brings the given child to the top of this List.
     *
     * @method Phaser.Structs.List#bringToTop
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to bring to the top of the List.
     *
     * @return {*} The item which was moved.
     */ bringToTop: function(child) {
                    return ArrayUtils.BringToTop(this.list, child);
                },
                /**
     * Sends the given child to the bottom of this List.
     *
     * @method Phaser.Structs.List#sendToBack
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to send to the back of the list.
     *
     * @return {*} The item which was moved.
     */ sendToBack: function(child) {
                    return ArrayUtils.SendToBack(this.list, child);
                },
                /**
     * Moves the given child up one place in this group unless it's already at the top.
     *
     * @method Phaser.Structs.List#moveUp
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move up.
     *
     * @return {*} The item which was moved.
     */ moveUp: function(child) {
                    ArrayUtils.MoveUp(this.list, child);
                    return child;
                },
                /**
     * Moves the given child down one place in this group unless it's already at the bottom.
     *
     * @method Phaser.Structs.List#moveDown
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move down.
     *
     * @return {*} The item which was moved.
     */ moveDown: function(child) {
                    ArrayUtils.MoveDown(this.list, child);
                    return child;
                },
                /**
     * Reverses the order of all children in this List.
     *
     * @method Phaser.Structs.List#reverse
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ reverse: function() {
                    this.list.reverse();
                    return this;
                },
                /**
     * Shuffles the items in the list.
     *
     * @method Phaser.Structs.List#shuffle
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ shuffle: function() {
                    ArrayUtils.Shuffle(this.list);
                    return this;
                },
                /**
     * Replaces a child of this List with the given newChild. The newChild cannot be a member of this List.
     *
     * @method Phaser.Structs.List#replace
     * @since 3.0.0
     *
     * @genericUse {T} - [oldChild,newChild,$return]
     *
     * @param {*} oldChild - The child in this List that will be replaced.
     * @param {*} newChild - The child to be inserted into this List.
     *
     * @return {*} Returns the oldChild that was replaced within this group.
     */ replace: function(oldChild, newChild) {
                    return ArrayUtils.Replace(this.list, oldChild, newChild);
                },
                /**
     * Checks if an item exists within the List.
     *
     * @method Phaser.Structs.List#exists
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to check for the existence of.
     *
     * @return {boolean} `true` if the item is found in the list, otherwise `false`.
     */ exists: function(child) {
                    return this.list.indexOf(child) > -1;
                },
                /**
     * Sets the property `key` to the given value on all members of this List.
     *
     * @method Phaser.Structs.List#setAll
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The name of the property to set.
     * @param {*} value - The value to set the property to.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     */ setAll: function(property, value, startIndex, endIndex) {
                    ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                    return this;
                },
                /**
     * Passes all children to the given callback.
     *
     * @method Phaser.Structs.List#each
     * @since 3.0.0
     *
     * @genericUse {EachListCallback.<T>} - [callback]
     *
     * @param {EachListCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, context) {
                    var args = [
                        null
                    ];
                    for(var i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < this.list.length; i++){
                        args[0] = this.list[i];
                        callback.apply(context, args);
                    }
                },
                /**
     * Clears the List and recreates its internal array.
     *
     * @method Phaser.Structs.List#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.removeAll();
                    this.list = [];
                },
                /**
     * Destroys this List.
     *
     * @method Phaser.Structs.List#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAll();
                    this.parent = null;
                    this.addCallback = null;
                    this.removeCallback = null;
                },
                /**
     * The number of items inside the List.
     *
     * @name Phaser.Structs.List#length
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                /**
     * The first item in the List or `null` for an empty List.
     *
     * @name Phaser.Structs.List#first
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ first: {
                    get: function() {
                        this.position = 0;
                        if (this.list.length > 0) return this.list[0];
                        else return null;
                    }
                },
                /**
     * The last item in the List, or `null` for an empty List.
     *
     * @name Phaser.Structs.List#last
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ last: {
                    get: function() {
                        if (this.list.length > 0) {
                            this.position = this.list.length - 1;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * The next item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #first} or manually setting the {@link #position} to iterate the List.
     *
     * @name Phaser.Structs.List#next
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ next: {
                    get: function() {
                        if (this.position < this.list.length) {
                            this.position++;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * The previous item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #last} or manually setting the {@link #position} to iterate the List backwards.
     *
     * @name Phaser.Structs.List#previous
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ previous: {
                    get: function() {
                        if (this.position > 0) {
                            this.position--;
                            return this.list[this.position];
                        } else return null;
                    }
                }
            });
            module1.exports = List;
        /***/ },
        /* 111 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(112);
            var GetPoint = __webpack_require__(445);
            var GetPoints = __webpack_require__(446);
            var GEOM_CONST = __webpack_require__(56);
            var Random = __webpack_require__(180);
            /**
 * @classdesc
 * An Ellipse object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render an Ellipse you should look at the capabilities of the Graphics class.
 *
 * @class Ellipse
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the ellipse.
 * @param {number} [y=0] - The y position of the center of the ellipse.
 * @param {number} [width=0] - The width of the ellipse.
 * @param {number} [height=0] - The height of the ellipse.
 */ var Ellipse = new Class({
                initialize: function Ellipse(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.ELLIPSE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Ellipse#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.ELLIPSE;
                    /**
         * The x position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                },
                /**
     * Check to see if the Ellipse contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Ellipse#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the ellipse.
     * @param {number} y - The y coordinate to check within the ellipse.
     *
     * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
     */ getPoint: function(position, point) {
                    return GetPoint(this, position, point);
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Ellipse#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a uniformly distributed random point from anywhere within the given Ellipse.
     *
     * @method Phaser.Geom.Ellipse#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the x, y, width and height of this ellipse.
     *
     * @method Phaser.Geom.Ellipse#setTo
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setTo: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets this Ellipse to be empty with a width and height of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Ellipse object.
     */ setEmpty: function() {
                    this.width = 0;
                    this.height = 0;
                    return this;
                },
                /**
     * Sets the position of this Ellipse.
     *
     * @method Phaser.Geom.Ellipse#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the size of this Ellipse.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the ellipse.
     * @param {number} [height=width] - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Checks to see if the Ellipse is empty: has a width or height equal to zero.
     *
     * @method Phaser.Geom.Ellipse#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Ellipse is empty, otherwise false.
     */ isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                /**
     * Returns the minor radius of the ellipse. Also known as the Semi Minor Axis.
     *
     * @method Phaser.Geom.Ellipse#getMinorRadius
     * @since 3.0.0
     *
     * @return {number} The minor radius.
     */ getMinorRadius: function() {
                    return Math.min(this.width, this.height) / 2;
                },
                /**
     * Returns the major radius of the ellipse. Also known as the Semi Major Axis.
     *
     * @method Phaser.Geom.Ellipse#getMajorRadius
     * @since 3.0.0
     *
     * @return {number} The major radius.
     */ getMajorRadius: function() {
                    return Math.max(this.width, this.height) / 2;
                },
                /**
     * The left position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x - this.width / 2;
                    },
                    set: function(value) {
                        this.x = value + this.width / 2;
                    }
                },
                /**
     * The right position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(value) {
                        this.x = value - this.width / 2;
                    }
                },
                /**
     * The top position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y - this.height / 2;
                    },
                    set: function(value) {
                        this.y = value + this.height / 2;
                    }
                },
                /**
     * The bottom position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(value) {
                        this.y = value - this.height / 2;
                    }
                }
            });
            module1.exports = Ellipse;
        /***/ },
        /* 112 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Ellipse contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Ellipse.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {number} x - The x coordinate to check within the ellipse.
 * @param {number} y - The y coordinate to check within the ellipse.
 *
 * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
 */ var Contains = function(ellipse, x, y) {
                if (ellipse.width <= 0 || ellipse.height <= 0) return false;
                //  Normalize the coords to an ellipse with center 0,0 and a radius of 0.5
                var normx = (x - ellipse.x) / ellipse.width;
                var normy = (y - ellipse.y) / ellipse.height;
                normx *= normx;
                normy *= normy;
                return normx + normy < 0.25;
            };
            module1.exports = Contains;
        /***/ },
        /* 113 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Actions = __webpack_require__(275);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(75);
            var EventEmitter = __webpack_require__(9);
            var GetAll = __webpack_require__(207);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            var Range = __webpack_require__(437);
            var Set = __webpack_require__(149);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * A Group is a way for you to create, manipulate, or recycle similar Game Objects.
 *
 * Group membership is non-exclusive. A Game Object can belong to several groups, one group, or none.
 *
 * Groups themselves aren't displayable, and can't be positioned, rotated, scaled, or hidden.
 *
 * @class Group
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group. If `key` is set, Phaser.GameObjects.Group#createMultiple is also called with these settings.
 *
 * @see Phaser.Physics.Arcade.Group
 * @see Phaser.Physics.Arcade.StaticGroup
 */ var Group = new Class({
                Extends: EventEmitter,
                initialize: function Group(scene, children, config) {
                    EventEmitter.call(this);
                    //  They can pass in any of the following as the first argument:
                    //  1) A single child
                    //  2) An array of children
                    //  3) A config object
                    //  4) An array of config objects
                    //  Or they can pass in a child, or array of children AND a config object
                    if (config) //  config has been set, are the children an array?
                    {
                        if (children && !Array.isArray(children)) children = [
                            children
                        ];
                    } else if (Array.isArray(children)) //  No config, so let's check the children argument
                    {
                        if (IsPlainObject(children[0])) {
                            //  It's an array of plain config objects
                            config = children;
                            children = null;
                        }
                    } else if (IsPlainObject(children)) {
                        //  Children isn't an array. Is it a config object though?
                        config = children;
                        children = null;
                    }
                    /**
         * This scene this group belongs to.
         *
         * @name Phaser.GameObjects.Group#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Members of this group.
         *
         * @name Phaser.GameObjects.Group#children
         * @type {Phaser.Structs.Set.<Phaser.GameObjects.GameObject>}
         * @since 3.0.0
         */ this.children = new Set();
                    /**
         * A flag identifying this object as a group.
         *
         * @name Phaser.GameObjects.Group#isParent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isParent = true;
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Group#type
         * @type {string}
         * @default 'Group'
         * @since 3.21.0
         */ this.type = "Group";
                    /**
         * The class to create new group members from.
         *
         * @name Phaser.GameObjects.Group#classType
         * @type {Function}
         * @since 3.0.0
         * @default Phaser.GameObjects.Sprite
         */ this.classType = GetFastValue(config, "classType", Sprite);
                    /**
         * The name of this group.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Group#name
         * @type {string}
         * @default ''
         * @since 3.18.0
         */ this.name = GetFastValue(config, "name", "");
                    /**
         * Whether this group runs its {@link Phaser.GameObjects.Group#preUpdate} method (which may update any members).
         *
         * @name Phaser.GameObjects.Group#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = GetFastValue(config, "active", true);
                    /**
         * The maximum size of this group, if used as a pool. -1 is no limit.
         *
         * @name Phaser.GameObjects.Group#maxSize
         * @type {number}
         * @since 3.0.0
         * @default -1
         */ this.maxSize = GetFastValue(config, "maxSize", -1);
                    /**
         * A default texture key to use when creating new group members.
         *
         * This is used in {@link Phaser.GameObjects.Group#create}
         * but not in {@link Phaser.GameObjects.Group#createMultiple}.
         *
         * @name Phaser.GameObjects.Group#defaultKey
         * @type {string}
         * @since 3.0.0
         */ this.defaultKey = GetFastValue(config, "defaultKey", null);
                    /**
         * A default texture frame to use when creating new group members.
         *
         * @name Phaser.GameObjects.Group#defaultFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.defaultFrame = GetFastValue(config, "defaultFrame", null);
                    /**
         * Whether to call the update method of any members.
         *
         * @name Phaser.GameObjects.Group#runChildUpdate
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Group#preUpdate
         */ this.runChildUpdate = GetFastValue(config, "runChildUpdate", false);
                    /**
         * A function to be called when adding or creating group members.
         *
         * @name Phaser.GameObjects.Group#createCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.createCallback = GetFastValue(config, "createCallback", null);
                    /**
         * A function to be called when removing group members.
         *
         * @name Phaser.GameObjects.Group#removeCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.removeCallback = GetFastValue(config, "removeCallback", null);
                    /**
         * A function to be called when creating several group members at once.
         *
         * @name Phaser.GameObjects.Group#createMultipleCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupMultipleCreateCallback}
         * @since 3.0.0
         */ this.createMultipleCallback = GetFastValue(config, "createMultipleCallback", null);
                    /**
         * A function to be called when adding or creating group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalCreateCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalCreateCallback = GetFastValue(config, "internalCreateCallback", null);
                    /**
         * A function to be called when removing group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalRemoveCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalRemoveCallback = GetFastValue(config, "internalRemoveCallback", null);
                    if (children) this.addMultiple(children);
                    if (config) this.createMultiple(config);
                    this.on(Events.ADDED_TO_SCENE, this.addedToScene, this);
                    this.on(Events.REMOVED_FROM_SCENE, this.removedFromScene, this);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Creates a new Game Object and adds it to this group, unless the group {@link Phaser.GameObjects.Group#isFull is full}.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#create
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the new Game Object in the world.
     * @param {number} [y=0] - The vertical position of the new Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key of the new Game Object.
     * @param {(string|number)} [frame=defaultFrame] - The texture frame of the new Game Object.
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of the new Game Object.
     * @param {boolean} [active=true] - The {@link Phaser.GameObjects.GameObject#active} state of the new Game Object.
     *
     * @return {any} The new Game Object (usually a Sprite, etc.).
     */ create: function(x, y, key, frame, visible, active) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (key === undefined) key = this.defaultKey;
                    if (frame === undefined) frame = this.defaultFrame;
                    if (visible === undefined) visible = true;
                    if (active === undefined) active = true;
                    //  Pool?
                    if (this.isFull()) return null;
                    var child = new this.classType(this.scene, x, y, key, frame);
                    child.addToDisplayList(this.scene.sys.displayList);
                    child.addToUpdateList();
                    child.visible = visible;
                    child.setActive(active);
                    this.add(child);
                    return child;
                },
                /**
     * Creates several Game Objects and adds them to this group.
     *
     * If the group becomes {@link Phaser.GameObjects.Group#isFull}, no further Game Objects are created.
     *
     * Calls {@link Phaser.GameObjects.Group#createMultipleCallback} and {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#createMultiple
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig[]} config - Creation settings. This can be a single configuration object or an array of such objects, which will be applied in turn.
     *
     * @return {any[]} The newly created Game Objects.
     */ createMultiple: function(config) {
                    if (this.isFull()) return [];
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var output = [];
                    if (config[0].key) for(var i = 0; i < config.length; i++){
                        var entries = this.createFromConfig(config[i]);
                        output = output.concat(entries);
                    }
                    return output;
                },
                /**
     * A helper for {@link Phaser.GameObjects.Group#createMultiple}.
     *
     * @method Phaser.GameObjects.Group#createFromConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig} options - Creation settings.
     *
     * @return {any[]} The newly created Game Objects.
     */ createFromConfig: function(options) {
                    if (this.isFull()) return [];
                    this.classType = GetFastValue(options, "classType", this.classType);
                    var key = GetFastValue(options, "key", undefined);
                    var frame = GetFastValue(options, "frame", null);
                    var visible = GetFastValue(options, "visible", true);
                    var active = GetFastValue(options, "active", true);
                    var entries = [];
                    //  Can't do anything without at least a key
                    if (key === undefined) return entries;
                    else {
                        if (!Array.isArray(key)) key = [
                            key
                        ];
                        if (!Array.isArray(frame)) frame = [
                            frame
                        ];
                    }
                    //  Build an array of key frame pairs to loop through
                    var repeat = GetFastValue(options, "repeat", 0);
                    var randomKey = GetFastValue(options, "randomKey", false);
                    var randomFrame = GetFastValue(options, "randomFrame", false);
                    var yoyo = GetFastValue(options, "yoyo", false);
                    var quantity = GetFastValue(options, "quantity", false);
                    var frameQuantity = GetFastValue(options, "frameQuantity", 1);
                    var max = GetFastValue(options, "max", 0);
                    //  If a quantity value is set we use that to override the frameQuantity
                    var range = Range(key, frame, {
                        max: max,
                        qty: quantity ? quantity : frameQuantity,
                        random: randomKey,
                        randomB: randomFrame,
                        repeat: repeat,
                        yoyo: yoyo
                    });
                    if (options.createCallback) this.createCallback = options.createCallback;
                    if (options.removeCallback) this.removeCallback = options.removeCallback;
                    for(var c = 0; c < range.length; c++){
                        var created = this.create(0, 0, range[c].a, range[c].b, visible, active);
                        if (!created) break;
                        entries.push(created);
                    }
                    //  Post-creation options (applied only to those items created in this call):
                    var x = GetValue(options, "setXY.x", 0);
                    var y = GetValue(options, "setXY.y", 0);
                    var stepX = GetValue(options, "setXY.stepX", 0);
                    var stepY = GetValue(options, "setXY.stepY", 0);
                    Actions.SetXY(entries, x, y, stepX, stepY);
                    var rotation = GetValue(options, "setRotation.value", 0);
                    var stepRotation = GetValue(options, "setRotation.step", 0);
                    Actions.SetRotation(entries, rotation, stepRotation);
                    var scaleX = GetValue(options, "setScale.x", 1);
                    var scaleY = GetValue(options, "setScale.y", scaleX);
                    var stepScaleX = GetValue(options, "setScale.stepX", 0);
                    var stepScaleY = GetValue(options, "setScale.stepY", 0);
                    Actions.SetScale(entries, scaleX, scaleY, stepScaleX, stepScaleY);
                    var originX = GetValue(options, "setOrigin.x", 0.5);
                    var originY = GetValue(options, "setOrigin.y", originX);
                    var stepOriginX = GetValue(options, "setOrigin.stepX", 0);
                    var stepOriginY = GetValue(options, "setOrigin.stepY", 0);
                    Actions.SetOrigin(entries, originX, originY, stepOriginX, stepOriginY);
                    var alpha = GetValue(options, "setAlpha.value", 1);
                    var stepAlpha = GetValue(options, "setAlpha.step", 0);
                    Actions.SetAlpha(entries, alpha, stepAlpha);
                    var depth = GetValue(options, "setDepth.value", 0);
                    var stepDepth = GetValue(options, "setDepth.step", 0);
                    Actions.SetDepth(entries, depth, stepDepth);
                    var scrollFactorX = GetValue(options, "setScrollFactor.x", 1);
                    var scrollFactorY = GetValue(options, "setScrollFactor.y", scrollFactorX);
                    var stepScrollFactorX = GetValue(options, "setScrollFactor.stepX", 0);
                    var stepScrollFactorY = GetValue(options, "setScrollFactor.stepY", 0);
                    Actions.SetScrollFactor(entries, scrollFactorX, scrollFactorY, stepScrollFactorX, stepScrollFactorY);
                    var hitArea = GetFastValue(options, "hitArea", null);
                    var hitAreaCallback = GetFastValue(options, "hitAreaCallback", null);
                    if (hitArea) Actions.SetHitArea(entries, hitArea, hitAreaCallback);
                    var grid = GetFastValue(options, "gridAlign", false);
                    if (grid) Actions.GridAlign(entries, grid);
                    if (this.createMultipleCallback) this.createMultipleCallback.call(this, entries);
                    return entries;
                },
                /**
     * Updates any group members, if {@link Phaser.GameObjects.Group#runChildUpdate} is enabled.
     *
     * @method Phaser.GameObjects.Group#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    if (!this.runChildUpdate || this.children.size === 0) return;
                    //  Because a Group child may mess with the length of the Group during its update
                    var temp = this.children.entries.slice();
                    for(var i = 0; i < temp.length; i++){
                        var item = temp[i];
                        if (item.active) item.update(time, delta);
                    }
                },
                /**
     * Adds a Game Object to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#add
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     * @param {boolean} [addToScene=false] - Also add the Game Object to the scene.
     *
     * @return {this} This Group object.
     */ add: function(child, addToScene) {
                    if (addToScene === undefined) addToScene = false;
                    if (this.isFull()) return this;
                    this.children.set(child);
                    if (this.internalCreateCallback) this.internalCreateCallback.call(this, child);
                    if (this.createCallback) this.createCallback.call(this, child);
                    if (addToScene) {
                        child.addToDisplayList(this.scene.sys.displayList);
                        child.addToUpdateList();
                    }
                    child.on(Events.DESTROY, this.remove, this);
                    return this;
                },
                /**
     * Adds several Game Objects to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#addMultiple
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - The Game Objects to add.
     * @param {boolean} [addToScene=false] - Also add the Game Objects to the scene.
     *
     * @return {this} This group.
     */ addMultiple: function(children, addToScene) {
                    if (addToScene === undefined) addToScene = false;
                    if (Array.isArray(children)) for(var i = 0; i < children.length; i++)this.add(children[i], addToScene);
                    return this;
                },
                /**
     * Removes a member of this Group and optionally removes it from the Scene and / or destroys it.
     *
     * Calls {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#remove
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     * @param {boolean} [removeFromScene=false] - Optionally remove the Group member from the Scene it belongs to.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group member.
     *
     * @return {this} This Group object.
     */ remove: function(child, removeFromScene, destroyChild) {
                    if (removeFromScene === undefined) removeFromScene = false;
                    if (destroyChild === undefined) destroyChild = false;
                    if (!this.children.contains(child)) return this;
                    this.children.delete(child);
                    if (this.internalRemoveCallback) this.internalRemoveCallback.call(this, child);
                    if (this.removeCallback) this.removeCallback.call(this, child);
                    child.off(Events.DESTROY, this.remove, this);
                    if (destroyChild) child.destroy();
                    else if (removeFromScene) {
                        child.removeFromDisplayList();
                        child.removeFromUpdateList();
                    }
                    return this;
                },
                /**
     * Removes all members of this Group and optionally removes them from the Scene and / or destroys them.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#clear
     * @since 3.0.0
     *
     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group members.
     *
     * @return {this} This group.
     */ clear: function(removeFromScene, destroyChild) {
                    if (removeFromScene === undefined) removeFromScene = false;
                    if (destroyChild === undefined) destroyChild = false;
                    var children = this.children;
                    for(var i = 0; i < children.size; i++){
                        var gameObject = children.entries[i];
                        gameObject.off(Events.DESTROY, this.remove, this);
                        if (destroyChild) gameObject.destroy();
                        else if (removeFromScene) {
                            gameObject.removeFromDisplayList();
                            gameObject.removeFromUpdateList();
                        }
                    }
                    this.children.clear();
                    return this;
                },
                /**
     * Tests if a Game Object is a member of this group.
     *
     * @method Phaser.GameObjects.Group#contains
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - A Game Object.
     *
     * @return {boolean} True if the Game Object is a member of this group.
     */ contains: function(child) {
                    return this.children.contains(child);
                },
                /**
     * All members of the group.
     *
     * @method Phaser.GameObjects.Group#getChildren
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.children.entries;
                },
                /**
     * The number of members of the group.
     *
     * @method Phaser.GameObjects.Group#getLength
     * @since 3.0.0
     *
     * @return {number}
     */ getLength: function() {
                    return this.children.size;
                },
                /**
     * Returns all children in this Group that match the given criteria based on the `property` and `value` arguments.
     *
     * For example: `getMatching('visible', true)` would return only children that have their `visible` property set.
     *
     * Optionally, you can specify a start and end index. For example if the Group has 100 elements,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50.
     *
     * @method Phaser.GameObjects.Group#getMatching
     * @since 3.50.0
     *
     * @param {string} [property] - The property to test on each array element.
     * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex] - An optional start index to search from.
     * @param {number} [endIndex] - An optional end index to search to.
     *
     * @return {any[]} An array of matching Group members. The array will be empty if nothing matched.
     */ getMatching: function(property, value, startIndex, endIndex) {
                    return GetAll(this.children.entries, property, value, startIndex, endIndex);
                },
                /**
     * Scans the Group, from top to bottom, for the first member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirst
     * @since 3.0.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirst: function(state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(true, 1, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group, from top to bottom, for the nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirstNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(true, nth, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLast
     * @since 3.6.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLast: function(state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(false, 1, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group for the last nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLastNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLastNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(false, nth, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getHandler
     * @private
     * @since 3.6.0
     *
     * @param {boolean} forwards - Search front to back or back to front?
     * @param {number} nth - Stop matching after nth successful matches.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getHandler: function(forwards, nth, state, createIfNull, x, y, key, frame, visible) {
                    if (state === undefined) state = false;
                    if (createIfNull === undefined) createIfNull = false;
                    var gameObject;
                    var i;
                    var total = 0;
                    var children = this.children.entries;
                    if (forwards) for(i = 0; i < children.length; i++){
                        gameObject = children[i];
                        if (gameObject.active === state) {
                            total++;
                            if (total === nth) break;
                        } else gameObject = null;
                    }
                    else for(i = children.length - 1; i >= 0; i--){
                        gameObject = children[i];
                        if (gameObject.active === state) {
                            total++;
                            if (total === nth) break;
                        } else gameObject = null;
                    }
                    if (gameObject) {
                        if (typeof x === "number") gameObject.x = x;
                        if (typeof y === "number") gameObject.y = y;
                        return gameObject;
                    }
                    //  Got this far? We need to create or bail
                    if (createIfNull) return this.create(x, y, key, frame, visible);
                    else return null;
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have its active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#get
     * @since 3.0.0
     *
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first inactive group member, or a newly created member, or null.
     */ get: function(x, y, key, frame, visible) {
                    return this.getFirst(false, true, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `true`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no active member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstAlive
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first active group member, or a newly created member, or null.
     */ getFirstAlive: function(createIfNull, x, y, key, frame, visible) {
                    return this.getFirst(true, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have an active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstDead
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first inactive group member, or a newly created member, or null.
     */ getFirstDead: function(createIfNull, x, y, key, frame, visible) {
                    return this.getFirst(false, createIfNull, x, y, key, frame, visible);
                },
                /**
     * {@link Phaser.GameObjects.Components.Animation#play Plays} an animation for all members of this group.
     *
     * @method Phaser.GameObjects.Group#playAnimation
     * @since 3.0.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {string} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Group object.
     */ playAnimation: function(key, startFrame) {
                    Actions.PlayAnimation(this.children.entries, key, startFrame);
                    return this;
                },
                /**
     * Whether this group's size at its {@link Phaser.GameObjects.Group#maxSize maximum}.
     *
     * @method Phaser.GameObjects.Group#isFull
     * @since 3.0.0
     *
     * @return {boolean} True if the number of members equals {@link Phaser.GameObjects.Group#maxSize}.
     */ isFull: function() {
                    if (this.maxSize === -1) return false;
                    else return this.children.size >= this.maxSize;
                },
                /**
     * Counts the number of active (or inactive) group members.
     *
     * @method Phaser.GameObjects.Group#countActive
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Count active (true) or inactive (false) group members.
     *
     * @return {number} The number of group members with an active state matching the `active` argument.
     */ countActive: function(value) {
                    if (value === undefined) value = true;
                    var total = 0;
                    for(var i = 0; i < this.children.size; i++)if (this.children.entries[i].active === value) total++;
                    return total;
                },
                /**
     * Counts the number of in-use (active) group members.
     *
     * @method Phaser.GameObjects.Group#getTotalUsed
     * @since 3.0.0
     *
     * @return {number} The number of group members with an active state of true.
     */ getTotalUsed: function() {
                    return this.countActive();
                },
                /**
     * The difference of {@link Phaser.GameObjects.Group#maxSize} and the number of active group members.
     *
     * This represents the number of group members that could be created or reactivated before reaching the size limit.
     *
     * @method Phaser.GameObjects.Group#getTotalFree
     * @since 3.0.0
     *
     * @return {number} maxSize minus the number of active group numbers; or a large number (if maxSize is -1).
     */ getTotalFree: function() {
                    var used = this.getTotalUsed();
                    var capacity = this.maxSize === -1 ? 999999999999 : this.maxSize;
                    return capacity - used;
                },
                /**
     * Sets the `active` property of this Group.
     * When active, this Group runs its `preUpdate` method.
     *
     * @method Phaser.GameObjects.Group#setActive
     * @since 3.24.0
     *
     * @param {boolean} value - True if this Group should be set as active, false if not.
     *
     * @return {this} This Group object.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Group.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Group#setName
     * @since 3.24.0
     *
     * @param {string} value - The name to be given to this Group.
     *
     * @return {this} This Group object.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the property as defined in `key` of each group member to the given value.
     *
     * @method Phaser.GameObjects.Group#propertyValueSet
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueSet: function(key, value, step, index, direction) {
                    Actions.PropertyValueSet(this.children.entries, key, value, step, index, direction);
                    return this;
                },
                /**
     * Adds the given value to the property as defined in `key` of each group member.
     *
     * @method Phaser.GameObjects.Group#propertyValueInc
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueInc: function(key, value, step, index, direction) {
                    Actions.PropertyValueInc(this.children.entries, key, value, step, index, direction);
                    return this;
                },
                /**
     * Sets the x of each group member.
     *
     * @method Phaser.GameObjects.Group#setX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setX: function(value, step) {
                    Actions.SetX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the y of each group member.
     *
     * @method Phaser.GameObjects.Group#setY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setY: function(value, step) {
                    Actions.SetY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#setXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to set the `x` property to.
     * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setXY: function(x, y, stepX, stepY) {
                    Actions.SetXY(this.children.entries, x, y, stepX, stepY);
                    return this;
                },
                /**
     * Adds the given value to the x of each group member.
     *
     * @method Phaser.GameObjects.Group#incX
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `x` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incX: function(value, step) {
                    Actions.IncX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Adds the given value to the y of each group member.
     *
     * @method Phaser.GameObjects.Group#incY
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `y` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incY: function(value, step) {
                    Actions.IncY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Adds the given value to the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#incXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to be added to the `x` property.
     * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incXY: function(x, y, stepX, stepY) {
                    Actions.IncXY(this.children.entries, x, y, stepX, stepY);
                    return this;
                },
                /**
     * Iterate through the group members changing the position of each element to be that of the element that came before
     * it in the array (or after it if direction = 1)
     *
     * The first group member position is set to x/y.
     *
     * @method Phaser.GameObjects.Group#shiftPosition
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate to place the first item in the array at.
     * @param {number} y - The y coordinate to place the first item in the array at.
     * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
     *
     * @return {this} This Group object.
     */ shiftPosition: function(x, y, direction) {
                    Actions.ShiftPosition(this.children.entries, x, y, direction);
                    return this;
                },
                /**
     * Sets the angle of each group member.
     *
     * @method Phaser.GameObjects.Group#angle
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the angle to, in degrees.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ angle: function(value, step) {
                    Actions.Angle(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the rotation of each group member.
     *
     * @method Phaser.GameObjects.Group#rotate
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the rotation to, in radians.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ rotate: function(value, step) {
                    Actions.Rotate(this.children.entries, value, step);
                    return this;
                },
                /**
     * Rotates each group member around the given point by the given angle.
     *
     * @method Phaser.GameObjects.Group#rotateAround
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     *
     * @return {this} This Group object.
     */ rotateAround: function(point, angle) {
                    Actions.RotateAround(this.children.entries, point, angle);
                    return this;
                },
                /**
     * Rotates each group member around the given point by the given angle and distance.
     *
     * @method Phaser.GameObjects.Group#rotateAroundDistance
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     * @param {number} distance - The distance from the point of rotation in pixels.
     *
     * @return {this} This Group object.
     */ rotateAroundDistance: function(point, angle, distance) {
                    Actions.RotateAroundDistance(this.children.entries, point, angle, distance);
                    return this;
                },
                /**
     * Sets the alpha of each group member.
     *
     * @method Phaser.GameObjects.Group#setAlpha
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the alpha to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setAlpha: function(value, step) {
                    Actions.SetAlpha(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the tint of each group member.
     *
     * @method Phaser.GameObjects.Group#setTint
     * @since 3.21.0
     *
     * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
     * @param {number} [topRight] - The tint to be applied to top-right corner of item.
     * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
     * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
     *
     * @return {this} This Group object.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                    Actions.SetTint(this.children.entries, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Sets the originX, originY of each group member.
     *
     * @method Phaser.GameObjects.Group#setOrigin
     * @since 3.21.0
     *
     * @param {number} originX - The amount to set the `originX` property to.
     * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
     * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setOrigin: function(originX, originY, stepX, stepY) {
                    Actions.SetOrigin(this.children.entries, originX, originY, stepX, stepY);
                    return this;
                },
                /**
     * Sets the scaleX of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleX: function(value, step) {
                    Actions.ScaleX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleY: function(value, step) {
                    Actions.ScaleY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the scaleX, scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleXY
     * @since 3.21.0
     *
     * @param {number} scaleX - The amount to be added to the `scaleX` property.
     * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
     * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleXY: function(scaleX, scaleY, stepX, stepY) {
                    Actions.ScaleXY(this.children.entries, scaleX, scaleY, stepX, stepY);
                    return this;
                },
                /**
     * Sets the depth of each group member.
     *
     * @method Phaser.GameObjects.Group#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setDepth: function(value, step) {
                    Actions.SetDepth(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the blendMode of each group member.
     *
     * @method Phaser.GameObjects.Group#setBlendMode
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     *
     * @return {this} This Group object.
     */ setBlendMode: function(value) {
                    Actions.SetBlendMode(this.children.entries, value);
                    return this;
                },
                /**
     * Passes all group members to the Input Manager to enable them for input with identical areas and callbacks.
     *
     * @method Phaser.GameObjects.Group#setHitArea
     * @since 3.21.0
     *
     * @param {*} hitArea - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
     *
     * @return {this} This Group object.
     */ setHitArea: function(hitArea, hitAreaCallback) {
                    Actions.SetHitArea(this.children.entries, hitArea, hitAreaCallback);
                    return this;
                },
                /**
     * Shuffles the group members in place.
     *
     * @method Phaser.GameObjects.Group#shuffle
     * @since 3.21.0
     *
     * @return {this} This Group object.
     */ shuffle: function() {
                    Actions.Shuffle(this.children.entries);
                    return this;
                },
                /**
     * Deactivates a member of this group.
     *
     * @method Phaser.GameObjects.Group#kill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ kill: function(gameObject) {
                    if (this.children.contains(gameObject)) gameObject.setActive(false);
                },
                /**
     * Deactivates and hides a member of this group.
     *
     * @method Phaser.GameObjects.Group#killAndHide
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ killAndHide: function(gameObject) {
                    if (this.children.contains(gameObject)) {
                        gameObject.setActive(false);
                        gameObject.setVisible(false);
                    }
                },
                /**
     * Sets the visible of each group member.
     *
     * @method Phaser.GameObjects.Group#setVisible
     * @since 3.21.0
     *
     * @param {boolean} value - The value to set the property to.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ setVisible: function(value, index, direction) {
                    Actions.SetVisible(this.children.entries, value, index, direction);
                    return this;
                },
                /**
     * Toggles (flips) the visible state of each member of this group.
     *
     * @method Phaser.GameObjects.Group#toggleVisible
     * @since 3.0.0
     *
     * @return {this} This Group object.
     */ toggleVisible: function() {
                    Actions.ToggleVisible(this.children.entries);
                    return this;
                },
                /**
     * Empties this Group of all children and removes it from the Scene.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * Children of this Group will _not_ be removed from the Scene by calling this method
     * unless you specify the `removeFromScene` parameter.
     *
     * Children of this Group will also _not_ be destroyed by calling this method
     * unless you specify the `destroyChildren` parameter.
     *
     * @method Phaser.GameObjects.Group#destroy
     * @since 3.0.0
     *
     * @param {boolean} [destroyChildren=false] - Also {@link Phaser.GameObjects.GameObject#destroy} each Group member.
     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
     */ destroy: function(destroyChildren, removeFromScene) {
                    if (destroyChildren === undefined) destroyChildren = false;
                    if (removeFromScene === undefined) removeFromScene = false;
                    //  This Game Object had already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    this.emit(Events.DESTROY, this);
                    this.removeAllListeners();
                    this.scene.sys.updateList.remove(this);
                    this.clear(removeFromScene, destroyChildren);
                    this.scene = undefined;
                    this.children = undefined;
                }
            });
            module1.exports = Group;
        /***/ },
        /* 114 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders a filled path for the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillPathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix used to get the position values.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var FillPathWebGL = function(pipeline, calcMatrix, src, alpha, dx, dy) {
                var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                var path = src.pathData;
                var pathIndexes = src.pathIndexes;
                for(var i = 0; i < pathIndexes.length; i += 3){
                    var p0 = pathIndexes[i] * 2;
                    var p1 = pathIndexes[i + 1] * 2;
                    var p2 = pathIndexes[i + 2] * 2;
                    var x0 = path[p0 + 0] - dx;
                    var y0 = path[p0 + 1] - dy;
                    var x1 = path[p1 + 0] - dx;
                    var y1 = path[p1 + 1] - dy;
                    var x2 = path[p2 + 0] - dx;
                    var y2 = path[p2 + 1] - dy;
                    var tx0 = calcMatrix.getX(x0, y0);
                    var ty0 = calcMatrix.getY(x0, y0);
                    var tx1 = calcMatrix.getX(x1, y1);
                    var ty1 = calcMatrix.getY(x1, y1);
                    var tx2 = calcMatrix.getX(x2, y2);
                    var ty2 = calcMatrix.getY(x2, y2);
                    pipeline.batchTri(src, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, fillTintColor, fillTintColor, fillTintColor, 2);
                }
            };
            module1.exports = FillPathWebGL;
        /***/ },
        /* 115 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
            /**
 * Checks if a point (as a pair of coordinates) is inside a Triangle's bounds.
 *
 * @function Phaser.Geom.Triangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is inside the Triangle, otherwise `false`.
 */ var Contains = function(triangle, x, y) {
                var v0x = triangle.x3 - triangle.x1;
                var v0y = triangle.y3 - triangle.y1;
                var v1x = triangle.x2 - triangle.x1;
                var v1y = triangle.y2 - triangle.y1;
                var v2x = x - triangle.x1;
                var v2y = y - triangle.y1;
                var dot00 = v0x * v0x + v0y * v0y;
                var dot01 = v0x * v1x + v0y * v1y;
                var dot02 = v0x * v2x + v0y * v2y;
                var dot11 = v1x * v1x + v1y * v1y;
                var dot12 = v1x * v2x + v1y * v2y;
                // Compute barycentric coordinates
                var b = dot00 * dot11 - dot01 * dot01;
                var inv = b === 0 ? 0 : 1 / b;
                var u = (dot11 * dot02 - dot01 * dot12) * inv;
                var v = (dot00 * dot12 - dot01 * dot02) * inv;
                return u >= 0 && v >= 0 && u + v < 1;
            };
            module1.exports = Contains;
        /***/ },
        /* 116 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * Returns the length of the line.
 *
 * @ignore
 * @private
 *
 * @param {number} x1 - The x1 coordinate.
 * @param {number} y1 - The y1 coordinate.
 * @param {number} x2 - The x2 coordinate.
 * @param {number} y2 - The y2 coordinate.
 *
 * @return {number} The length of the line.
 */ function GetLength(x1, y1, x2, y2) {
                var x = x1 - x2;
                var y = y1 - y2;
                var magnitude = x * x + y * y;
                return Math.sqrt(magnitude);
            }
            /**
 * @classdesc
 * A Face Geometry Object.
 *
 * A Face is used by the Mesh Game Object. A Mesh consists of one, or more, faces that are
 * used to render the Mesh Game Objects in WebGL.
 *
 * A Face consists of 3 Vertex instances, for the 3 corners of the face and methods to help
 * you modify and test them.
 *
 * @class Face
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
 */ var Face = new Class({
                initialize: function Face(vertex1, vertex2, vertex3) {
                    /**
         * The first vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex1
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex1 = vertex1;
                    /**
         * The second vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex2
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex2 = vertex2;
                    /**
         * The third vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex3
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex3 = vertex3;
                    /**
         * The bounds of this Face.
         *
         * Be sure to call the `Face.updateBounds` method _before_ using this property.
         *
         * @name Phaser.Geom.Mesh.Face#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.50.0
         */ this.bounds = new Rectangle();
                    /**
         * The face inCenter. Do not access directly, instead use the `getInCenter` method.
         *
         * @name Phaser.Geom.Mesh.Face#_inCenter
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.50.0
         */ this._inCenter = new Vector2();
                },
                /**
     * Calculates and returns the in-center position of this Face.
     *
     * @method Phaser.Geom.Mesh.Face#getInCenter
     * @since 3.50.0
     *
     * @param {boolean} [local=true] Return the in center from the un-transformed vertex positions (`true`), or transformed? (`false`)
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the in center position of this Face.
     */ getInCenter: function(local) {
                    if (local === undefined) local = true;
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var v1x;
                    var v1y;
                    var v2x;
                    var v2y;
                    var v3x;
                    var v3y;
                    if (local) {
                        v1x = v1.x;
                        v1y = v1.y;
                        v2x = v2.x;
                        v2y = v2.y;
                        v3x = v3.x;
                        v3y = v3.y;
                    } else {
                        v1x = v1.vx;
                        v1y = v1.vy;
                        v2x = v2.vx;
                        v2y = v2.vy;
                        v3x = v3.vx;
                        v3y = v3.vy;
                    }
                    var d1 = GetLength(v3x, v3y, v2x, v2y);
                    var d2 = GetLength(v1x, v1y, v3x, v3y);
                    var d3 = GetLength(v2x, v2y, v1x, v1y);
                    var p = d1 + d2 + d3;
                    return this._inCenter.set((v1x * d1 + v2x * d2 + v3x * d3) / p, (v1y * d1 + v2y * d2 + v3y * d3) / p);
                },
                /**
     * Checks if the given coordinates are within this Face.
     *
     * You can optionally provide a transform matrix. If given, the Face vertices
     * will be transformed first, before being checked against the coordinates.
     *
     * @method Phaser.Geom.Mesh.Face#contains
     * @since 3.50.0
     *
     * @param {number} x - The horizontal position to check.
     * @param {number} y - The vertical position to check.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [calcMatrix] - Optional transform matrix to apply to the vertices before comparison.
     *
     * @return {boolean} `true` if the coordinates lay within this Face, otherwise `false`.
     */ contains: function(x, y, calcMatrix) {
                    var vertex1 = this.vertex1;
                    var vertex2 = this.vertex2;
                    var vertex3 = this.vertex3;
                    var v1x = vertex1.vx;
                    var v1y = vertex1.vy;
                    var v2x = vertex2.vx;
                    var v2y = vertex2.vy;
                    var v3x = vertex3.vx;
                    var v3y = vertex3.vy;
                    if (calcMatrix) {
                        var a = calcMatrix.a;
                        var b = calcMatrix.b;
                        var c = calcMatrix.c;
                        var d = calcMatrix.d;
                        var e = calcMatrix.e;
                        var f = calcMatrix.f;
                        v1x = vertex1.vx * a + vertex1.vy * c + e;
                        v1y = vertex1.vx * b + vertex1.vy * d + f;
                        v2x = vertex2.vx * a + vertex2.vy * c + e;
                        v2y = vertex2.vx * b + vertex2.vy * d + f;
                        v3x = vertex3.vx * a + vertex3.vy * c + e;
                        v3y = vertex3.vx * b + vertex3.vy * d + f;
                    }
                    var t0x = v3x - v1x;
                    var t0y = v3y - v1y;
                    var t1x = v2x - v1x;
                    var t1y = v2y - v1y;
                    var t2x = x - v1x;
                    var t2y = y - v1y;
                    var dot00 = t0x * t0x + t0y * t0y;
                    var dot01 = t0x * t1x + t0y * t1y;
                    var dot02 = t0x * t2x + t0y * t2y;
                    var dot11 = t1x * t1x + t1y * t1y;
                    var dot12 = t1x * t2x + t1y * t2y;
                    //  Compute barycentric coordinates
                    var bc = dot00 * dot11 - dot01 * dot01;
                    var inv = bc === 0 ? 0 : 1 / bc;
                    var u = (dot11 * dot02 - dot01 * dot12) * inv;
                    var v = (dot00 * dot12 - dot01 * dot02) * inv;
                    return u >= 0 && v >= 0 && u + v < 1;
                },
                /**
     * Checks if the vertices in this Face are orientated counter-clockwise, or not.
     *
     * It checks the transformed position of the vertices, not the local one.
     *
     * @method Phaser.Geom.Mesh.Face#isCounterClockwise
     * @since 3.50.0
     *
     * @param {number} z - The z-axis value to test against. Typically the `Mesh.modelPosition.z`.
     *
     * @return {boolean} `true` if the vertices in this Face run counter-clockwise, otherwise `false`.
     */ isCounterClockwise: function(z) {
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var d = (v2.vx - v1.vx) * (v3.vy - v1.vy) - (v2.vy - v1.vy) * (v3.vx - v1.vx);
                    return z <= 0 ? d >= 0 : d < 0;
                },
                /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Face#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     * @param {number} tintEffect - The tint effect to use.
     *
     * @return {number} The new vertex index array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                    offset = this.vertex1.load(F32, U32, offset, textureUnit, tintEffect);
                    offset = this.vertex2.load(F32, U32, offset, textureUnit, tintEffect);
                    offset = this.vertex3.load(F32, U32, offset, textureUnit, tintEffect);
                    return offset;
                },
                /**
     * Transforms all Face vertices by the given matrix, storing the results in their `vx`, `vy` and `vz` properties.
     *
     * @method Phaser.Geom.Mesh.Face#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     *
     * @return {this} This Face instance.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                    this.vertex1.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    this.vertex2.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    this.vertex3.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    return this;
                },
                /**
     * Updates the bounds of this Face, based on the translated values of the vertices.
     *
     * Call this method prior to accessing the `Face.bounds` property.
     *
     * @method Phaser.Geom.Mesh.Face#updateBounds
     * @since 3.50.0
     *
     * @return {this} This Face instance.
     */ updateBounds: function() {
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var bounds = this.bounds;
                    bounds.x = Math.min(v1.vx, v2.vx, v3.vx);
                    bounds.y = Math.min(v1.vy, v2.vy, v3.vy);
                    bounds.width = Math.max(v1.vx, v2.vx, v3.vx) - bounds.x;
                    bounds.height = Math.max(v1.vy, v2.vy, v3.vy) - bounds.y;
                    return this;
                },
                /**
     * Checks if this Face is within the view of the given Camera.
     *
     * This method is called in the `MeshWebGLRenderer` function. It performs the following tasks:
     *
     * First, the `Vertex.update` method is called on each of the vertices. This populates them
     * with the new translated values, updating their `tx`, `ty` and `ta` properties.
     *
     * Then it tests to see if this face is visible due to the alpha values, if not, it returns.
     *
     * After this, if `hideCCW` is set, it calls `isCounterClockwise` and returns if not.
     *
     * Finally, it will update the `Face.bounds` based on the newly translated vertex values
     * and return the results of an intersection test between the bounds and the camera world view
     * rectangle.
     *
     * @method Phaser.Geom.Mesh.Face#isInView
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against.
     * @param {boolean} hideCCW - Test the counter-clockwise orientation of the verts?
     * @param {number} z - The Cameras z position, used in the CCW test.
     * @param {number} alpha - The alpha of the parent object.
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     *
     * @return {boolean} `true` if this Face can be seen by the Camera.
     */ isInView: function(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels) {
                    var v1 = this.vertex1.update(a, b, c, d, e, f, roundPixels, alpha);
                    var v2 = this.vertex2.update(a, b, c, d, e, f, roundPixels, alpha);
                    var v3 = this.vertex3.update(a, b, c, d, e, f, roundPixels, alpha);
                    //  Alpha check first
                    if (v1.ta <= 0 && v2.ta <= 0 && v3.ta <= 0) return false;
                    //  CCW check
                    if (hideCCW && !this.isCounterClockwise(z)) return false;
                    //  Bounds check
                    var bounds = this.bounds;
                    bounds.x = Math.min(v1.tx, v2.tx, v3.tx);
                    bounds.y = Math.min(v1.ty, v2.ty, v3.ty);
                    bounds.width = Math.max(v1.tx, v2.tx, v3.tx) - bounds.x;
                    bounds.height = Math.max(v1.ty, v2.ty, v3.ty) - bounds.y;
                    var cr = camera.x + camera.width;
                    var cb = camera.y + camera.height;
                    if (bounds.width <= 0 || bounds.height <= 0 || camera.width <= 0 || camera.height <= 0) return false;
                    return !(bounds.right < camera.x || bounds.bottom < camera.y || bounds.x > cr || bounds.y > cb);
                },
                /**
     * Translates the vertices of this Face by the given amounts.
     *
     * The actual vertex positions are adjusted, not their transformed position.
     *
     * Therefore, this updates the vertex data directly.
     *
     * @method Phaser.Geom.Mesh.Face#translate
     * @since 3.50.0
     *
     * @param {number} x - The amount to horizontally translate by.
     * @param {number} [y=0] - The amount to vertically translate by.
     *
     * @return {this} This Face instance.
     */ translate: function(x, y) {
                    if (y === undefined) y = 0;
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    v1.x += x;
                    v1.y += y;
                    v2.x += x;
                    v2.y += y;
                    v3.x += x;
                    v3.y += y;
                    return this;
                },
                /**
     * The x coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#x
     * @type {number}
     * @since 3.50.0
     */ x: {
                    get: function() {
                        return this.getInCenter().x;
                    },
                    set: function(value) {
                        var current = this.getInCenter();
                        this.translate(value - current.x, 0);
                    }
                },
                /**
     * The y coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#y
     * @type {number}
     * @since 3.50.0
     */ y: {
                    get: function() {
                        return this.getInCenter().y;
                    },
                    set: function(value) {
                        var current = this.getInCenter();
                        this.translate(0, value - current.y);
                    }
                },
                /**
     * Set the alpha value of this Face.
     *
     * Each vertex is given the same value. If you need to adjust the alpha on a per-vertex basis
     * then use the `Vertex.alpha` property instead.
     *
     * When getting the alpha of this Face, it will return an average of the alpha
     * component of all three vertices.
     *
     * @name Phaser.Geom.Mesh.Face#alpha
     * @type {number}
     * @since 3.50.0
     */ alpha: {
                    get: function() {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        return (v1.alpha + v2.alpha + v3.alpha) / 3;
                    },
                    set: function(value) {
                        this.vertex1.alpha = value;
                        this.vertex2.alpha = value;
                        this.vertex3.alpha = value;
                    }
                },
                /**
     * The depth of this Face, which is an average of the z component of all three vertices.
     *
     * The depth is calculated based on the transformed z value, not the local one.
     *
     * @name Phaser.Geom.Mesh.Face#depth
     * @type {number}
     * @readonly
     * @since 3.50.0
     */ depth: {
                    get: function() {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        return (v1.vz + v2.vz + v3.vz) / 3;
                    }
                },
                /**
     * Destroys this Face and nulls the references to the vertices.
     *
     * @method Phaser.Geom.Mesh.Face#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.vertex1 = null;
                    this.vertex2 = null;
                    this.vertex3 = null;
                }
            });
            module1.exports = Face;
        /***/ },
        /* 117 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Utils = __webpack_require__(12);
            var Vector3 = __webpack_require__(39);
            /**
 * @classdesc
 * A Vertex Geometry Object.
 *
 * This class consists of all the information required for a single vertex within a Face Geometry Object.
 *
 * Faces, and thus Vertex objects, are used by the Mesh Game Object in order to render objects in WebGL.
 *
 * @class Vertex
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @extends Phaser.Math.Vector3
 * @since 3.50.0
 *
 * @param {number} x - The x position of the vertex.
 * @param {number} y - The y position of the vertex.
 * @param {number} z - The z position of the vertex.
 * @param {number} u - The UV u coordinate of the vertex.
 * @param {number} v - The UV v coordinate of the vertex.
 * @param {number} [color=0xffffff] - The color value of the vertex.
 * @param {number} [alpha=1] - The alpha value of the vertex.
 * @param {number} [nx=0] - The x normal value of the vertex.
 * @param {number} [ny=0] - The y normal value of the vertex.
 * @param {number} [nz=0] - The z normal value of the vertex.
 */ var Vertex = new Class({
                Extends: Vector3,
                initialize: function Vertex(x, y, z, u, v, color, alpha, nx, ny, nz) {
                    if (color === undefined) color = 0xffffff;
                    if (alpha === undefined) alpha = 1;
                    if (nx === undefined) nx = 0;
                    if (ny === undefined) ny = 0;
                    if (nz === undefined) nz = 0;
                    Vector3.call(this, x, y, z);
                    /**
         * The projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vx
         * @type {number}
         * @since 3.50.0
         */ this.vx = 0;
                    /**
         * The projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vy
         * @type {number}
         * @since 3.50.0
         */ this.vy = 0;
                    /**
         * The projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vz
         * @type {number}
         * @since 3.50.0
         */ this.vz = 0;
                    /**
         * The projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nx
         * @type {number}
         * @since 3.50.0
         */ this.nx = nx;
                    /**
         * The projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ny
         * @type {number}
         * @since 3.50.0
         */ this.ny = ny;
                    /**
         * The projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nz
         * @type {number}
         * @since 3.50.0
         */ this.nz = nz;
                    /**
         * UV u coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#u
         * @type {number}
         * @since 3.50.0
         */ this.u = u;
                    /**
         * UV v coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#v
         * @type {number}
         * @since 3.50.0
         */ this.v = v;
                    /**
         * The color value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#color
         * @type {number}
         * @since 3.50.0
         */ this.color = color;
                    /**
         * The alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = alpha;
                    /**
         * The translated x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#tx
         * @type {number}
         * @since 3.50.0
         */ this.tx = 0;
                    /**
         * The translated y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ty
         * @type {number}
         * @since 3.50.0
         */ this.ty = 0;
                    /**
         * The translated alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ta
         * @type {number}
         * @since 3.50.0
         */ this.ta = 0;
                },
                /**
     * Sets the U and V properties.
     *
     * @method Phaser.Geom.Mesh.Vertex#setUVs
     * @since 3.50.0
     *
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     *
     * @return {this} This Vertex.
     */ setUVs: function(u, v) {
                    this.u = u;
                    this.v = v;
                    return this;
                },
                /**
     * Transforms this vertex by the given matrix, storing the results in `vx`, `vy` and `vz`.
     *
     * @method Phaser.Geom.Mesh.Vertex#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = transformMatrix.val;
                    var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                    var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                    var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                    var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                    this.vx = tx / tw * width;
                    this.vy = -(ty / tw) * height;
                    if (cameraZ <= 0) this.vz = tz / tw;
                    else this.vz = -(tz / tw);
                },
                /**
     * Updates this Vertex based on the given transform.
     *
     * @method Phaser.Geom.Mesh.Vertex#update
     * @since 3.50.0
     *
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     * @param {number} alpha - The alpha of the parent object.
     *
     * @return {this} This Vertex.
     */ update: function(a, b, c, d, e, f, roundPixels, alpha) {
                    var tx = this.vx * a + this.vy * c + e;
                    var ty = this.vx * b + this.vy * d + f;
                    if (roundPixels) {
                        tx = Math.round(tx);
                        ty = Math.round(ty);
                    }
                    this.tx = tx;
                    this.ty = ty;
                    this.ta = this.alpha * alpha;
                    return this;
                },
                /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Vertex#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     * @param {number} tintEffect - The tint effect to use.
     *
     * @return {number} The new array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                    F32[++offset] = this.tx;
                    F32[++offset] = this.ty;
                    F32[++offset] = this.u;
                    F32[++offset] = this.v;
                    F32[++offset] = textureUnit;
                    F32[++offset] = tintEffect;
                    U32[++offset] = Utils.getTintAppendFloatAlpha(this.color, this.ta);
                    return offset;
                }
            });
            module1.exports = Vertex;
        /***/ },
        /* 118 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
* A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
* It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
* Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composite
*/ var Composite = {};
            module1.exports = Composite;
            var Events = __webpack_require__(166);
            var Common = __webpack_require__(32);
            var Bounds = __webpack_require__(84);
            var Body = __webpack_require__(41);
            (function() {
                /**
     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properites section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} [options]
     * @return {composite} A new composite
     */ Composite.create = function(options) {
                    return Common.extend({
                        id: Common.nextId(),
                        type: "composite",
                        parent: null,
                        isModified: false,
                        bodies: [],
                        constraints: [],
                        composites: [],
                        label: "Composite",
                        plugin: {}
                    }, options);
                };
                /**
     * Sets the composite's `isModified` flag. 
     * If `updateParents` is true, all parents will be set (default: false).
     * If `updateChildren` is true, all children will be set (default: false).
     * @method setModified
     * @param {composite} composite
     * @param {boolean} isModified
     * @param {boolean} [updateParents=false]
     * @param {boolean} [updateChildren=false]
     */ Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
                    Events.trigger(composite, "compositeModified", composite);
                    composite.isModified = isModified;
                    if (updateParents && composite.parent) Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
                    if (updateChildren) for(var i = 0; i < composite.composites.length; i++){
                        var childComposite = composite.composites[i];
                        Composite.setModified(childComposite, isModified, updateParents, updateChildren);
                    }
                };
                /**
     * Generic add function. Adds one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
     * @method add
     * @param {composite} composite
     * @param {} object
     * @return {composite} The original composite with the objects added
     */ Composite.add = function(composite, object) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeAdd", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                // skip adding compound parts
                                if (obj.parent !== obj) {
                                    Common.warn("Composite.add: skipped adding a compound body part (you must add its parent instead)");
                                    break;
                                }
                                Composite.addBody(composite, obj);
                                break;
                            case "constraint":
                                Composite.addConstraint(composite, obj);
                                break;
                            case "composite":
                                Composite.addComposite(composite, obj);
                                break;
                            case "mouseConstraint":
                                Composite.addConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterAdd", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Optionally searching its children recursively.
     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
     * @method remove
     * @param {composite} composite
     * @param {} object
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the objects removed
     */ Composite.remove = function(composite, object, deep) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeRemove", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                Composite.removeBody(composite, obj, deep);
                                break;
                            case "constraint":
                                Composite.removeConstraint(composite, obj, deep);
                                break;
                            case "composite":
                                Composite.removeComposite(composite, obj, deep);
                                break;
                            case "mouseConstraint":
                                Composite.removeConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterRemove", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Adds a composite to the given composite.
     * @private
     * @method addComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @return {composite} The original compositeA with the objects from compositeB added
     */ Composite.addComposite = function(compositeA, compositeB) {
                    compositeA.composites.push(compositeB);
                    compositeB.parent = compositeA;
                    Composite.setModified(compositeA, true, true, false);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @param {boolean} [deep=false]
     * @return {composite} The original compositeA with the composite removed
     */ Composite.removeComposite = function(compositeA, compositeB, deep) {
                    var position = compositeA.composites.indexOf(compositeB);
                    if (position !== -1) {
                        Composite.removeCompositeAt(compositeA, position);
                        Composite.setModified(compositeA, true, true, false);
                    }
                    if (deep) for(var i = 0; i < compositeA.composites.length; i++)Composite.removeComposite(compositeA.composites[i], compositeB, true);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite.
     * @private
     * @method removeCompositeAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the composite removed
     */ Composite.removeCompositeAt = function(composite, position) {
                    composite.composites.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a body to the given composite.
     * @private
     * @method addBody
     * @param {composite} composite
     * @param {body} body
     * @return {composite} The original composite with the body added
     */ Composite.addBody = function(composite, body) {
                    composite.bodies.push(body);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a body from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeBody
     * @param {composite} composite
     * @param {body} body
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the body removed
     */ Composite.removeBody = function(composite, body, deep) {
                    var position = composite.bodies.indexOf(body);
                    if (position !== -1) {
                        Composite.removeBodyAt(composite, position);
                        Composite.setModified(composite, true, true, false);
                    }
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeBody(composite.composites[i], body, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeBodyAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the body removed
     */ Composite.removeBodyAt = function(composite, position) {
                    composite.bodies.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a constraint to the given composite.
     * @private
     * @method addConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @return {composite} The original composite with the constraint added
     */ Composite.addConstraint = function(composite, constraint) {
                    composite.constraints.push(constraint);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a constraint from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraint = function(composite, constraint, deep) {
                    var position = composite.constraints.indexOf(constraint);
                    if (position !== -1) Composite.removeConstraintAt(composite, position);
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeConstraint(composite.composites[i], constraint, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeConstraintAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraintAt = function(composite, position) {
                    composite.constraints.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes all bodies, constraints and composites from the given composite.
     * Optionally clearing its children recursively.
     * @method clear
     * @param {composite} composite
     * @param {boolean} keepStatic
     * @param {boolean} [deep=false]
     */ Composite.clear = function(composite, keepStatic, deep) {
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.clear(composite.composites[i], keepStatic, true);
                    if (keepStatic) composite.bodies = composite.bodies.filter(function(body) {
                        return body.isStatic;
                    });
                    else composite.bodies.length = 0;
                    composite.constraints.length = 0;
                    composite.composites.length = 0;
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns all bodies in the given composite, including all bodies in its children, recursively.
     * @method allBodies
     * @param {composite} composite
     * @return {body[]} All the bodies
     */ Composite.allBodies = function(composite) {
                    var bodies = [].concat(composite.bodies);
                    for(var i = 0; i < composite.composites.length; i++)bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
                    return bodies;
                };
                /**
     * Returns all constraints in the given composite, including all constraints in its children, recursively.
     * @method allConstraints
     * @param {composite} composite
     * @return {constraint[]} All the constraints
     */ Composite.allConstraints = function(composite) {
                    var constraints = [].concat(composite.constraints);
                    for(var i = 0; i < composite.composites.length; i++)constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
                    return constraints;
                };
                /**
     * Returns all composites in the given composite, including all composites in its children, recursively.
     * @method allComposites
     * @param {composite} composite
     * @return {composite[]} All the composites
     */ Composite.allComposites = function(composite) {
                    var composites = [].concat(composite.composites);
                    for(var i = 0; i < composite.composites.length; i++)composites = composites.concat(Composite.allComposites(composite.composites[i]));
                    return composites;
                };
                /**
     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
     * @method get
     * @param {composite} composite
     * @param {number} id
     * @param {string} type
     * @return {object} The requested object, if found
     */ Composite.get = function(composite, id, type) {
                    var objects, object;
                    switch(type){
                        case "body":
                            objects = Composite.allBodies(composite);
                            break;
                        case "constraint":
                            objects = Composite.allConstraints(composite);
                            break;
                        case "composite":
                            objects = Composite.allComposites(composite).concat(composite);
                            break;
                    }
                    if (!objects) return null;
                    object = objects.filter(function(object) {
                        return object.id.toString() === id.toString();
                    });
                    return object.length === 0 ? null : object[0];
                };
                /**
     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
     * @method move
     * @param {compositeA} compositeA
     * @param {object[]} objects
     * @param {compositeB} compositeB
     * @return {composite} Returns compositeA
     */ Composite.move = function(compositeA, objects, compositeB) {
                    Composite.remove(compositeA, objects);
                    Composite.add(compositeB, objects);
                    return compositeA;
                };
                /**
     * Assigns new ids for all objects in the composite, recursively.
     * @method rebase
     * @param {composite} composite
     * @return {composite} Returns composite
     */ Composite.rebase = function(composite) {
                    var objects = Composite.allBodies(composite).concat(Composite.allConstraints(composite)).concat(Composite.allComposites(composite));
                    for(var i = 0; i < objects.length; i++)objects[i].id = Common.nextId();
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Translates all children in the composite by a given vector relative to their current positions, 
     * without imparting any velocity.
     * @method translate
     * @param {composite} composite
     * @param {vector} translation
     * @param {bool} [recursive=true]
     */ Composite.translate = function(composite, translation, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++)Body.translate(bodies[i], translation);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
     * @method rotate
     * @param {composite} composite
     * @param {number} rotation
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.rotate = function(composite, rotation, point, recursive) {
                    var cos = Math.cos(rotation), sin = Math.sin(rotation), bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.rotate(body, rotation);
                    }
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
     * @method scale
     * @param {composite} composite
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + dx * scaleX,
                            y: point.y + dy * scaleY
                        });
                        Body.scale(body, scaleX, scaleY);
                    }
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns the union of the bounds of all of the composite's bodies.
     * @method bounds
     * @param {composite} composite The composite.
     * @returns {bounds} The composite bounds.
     */ Composite.bounds = function(composite) {
                    var bodies = Composite.allBodies(composite), vertices = [];
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i];
                        vertices.push(body.bounds.min, body.bounds.max);
                    }
                    return Bounds.create(vertices);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a call to `Composite.add` is made, before objects have been added.
    *
    * @event beforeAdd
    * @param {} event An event object
    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.add` is made, after objects have been added.
    *
    * @event afterAdd
    * @param {} event An event object
    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, before objects have been removed.
    *
    * @event beforeRemove
    * @param {} event An event object
    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, after objects have been removed.
    *
    * @event afterRemove
    * @param {} event An event object
    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "composite"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage composites.
     *
     * @property label
     * @type string
     * @default "Composite"
     */ /**
     * A flag that specifies whether the composite has been modified during the current step.
     * Most `Matter.Composite` methods will automatically set this flag to `true` to inform the engine of changes to be handled.
     * If you need to change it manually, you should use the `Composite.setModified` method.
     *
     * @property isModified
     * @type boolean
     * @default false
     */ /**
     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
     *
     * @property parent
     * @type composite
     * @default null
     */ /**
     * An array of `Body` that are _direct_ children of this composite.
     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
     *
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * An array of `Constraint` that are _direct_ children of this composite.
     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
     *
     * @property constraints
     * @type constraint[]
     * @default []
     */ /**
     * An array of `Composite` that are _direct_ children of this composite.
     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
     *
     * @property composites
     * @type composite[]
     * @default []
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 119 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given tile coordinates are within the bounds of the layer.
 *
 * @function Phaser.Tilemaps.Components.IsInLayerBounds
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {boolean} `true` if the tile coordinates are within the bounds of the layer, otherwise `false`.
 */ var IsInLayerBounds = function(tileX, tileY, layer) {
                return tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height;
            };
            module1.exports = IsInLayerBounds;
        /***/ },
        /* 120 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(29);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing data about about a layer in a map. Maps are parsed from CSV, Tiled,
 * etc. into this format. Tilemap and TilemapLayer objects have a reference
 * to this data and use it to look up and perform operations on tiles.
 *
 * @class LayerData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.LayerDataConfig} [config] - The Layer Data configuration object.
 */ var LayerData = new Class({
                initialize: function LayerData(config) {
                    if (config === undefined) config = {};
                    /**
         * The name of the layer, if specified in Tiled.
         *
         * @name Phaser.Tilemaps.LayerData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, "name", "layer");
                    /**
         * The x offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#x
         * @type {number}
         * @since 3.0.0
         */ this.x = GetFastValue(config, "x", 0);
                    /**
         * The y offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#y
         * @type {number}
         * @since 3.0.0
         */ this.y = GetFastValue(config, "y", 0);
                    /**
         * The width of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, "width", 0);
                    /**
         * The height of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, "height", 0);
                    /**
         * The pixel width of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, "tileWidth", 0);
                    /**
         * The pixel height of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, "tileHeight", 0);
                    /**
         * The base tile width.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseTileWidth = GetFastValue(config, "baseTileWidth", this.tileWidth);
                    /**
         * The base tile height.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseTileHeight = GetFastValue(config, "baseTileHeight", this.tileHeight);
                    /**
         * The layers orientation, necessary to be able to determine a tiles pixelX and pixelY as well as the layers width and height.
         *
         * @name Phaser.Tilemaps.LayerData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, "orientation", CONST.ORTHOGONAL);
                    /**
         * The width in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, "widthInPixels", this.width * this.baseTileWidth);
                    /**
         * The height in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, "heightInPixels", this.height * this.baseTileHeight);
                    /**
         * The alpha value of the layer.
         *
         * @name Phaser.Tilemaps.LayerData#alpha
         * @type {number}
         * @since 3.0.0
         */ this.alpha = GetFastValue(config, "alpha", 1);
                    /**
         * Is the layer visible or not?
         *
         * @name Phaser.Tilemaps.LayerData#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, "visible", true);
                    /**
         * Layer specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.LayerData#properties
         * @type {object[]}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, "properties", []);
                    /**
         * Tile ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#indexes
         * @type {array}
         * @since 3.0.0
         */ this.indexes = GetFastValue(config, "indexes", []);
                    /**
         * Tile Collision ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#collideIndexes
         * @type {array}
         * @since 3.0.0
         */ this.collideIndexes = GetFastValue(config, "collideIndexes", []);
                    /**
         * An array of callbacks.
         *
         * @name Phaser.Tilemaps.LayerData#callbacks
         * @type {array}
         * @since 3.0.0
         */ this.callbacks = GetFastValue(config, "callbacks", []);
                    /**
         * An array of physics bodies.
         *
         * @name Phaser.Tilemaps.LayerData#bodies
         * @type {array}
         * @since 3.0.0
         */ this.bodies = GetFastValue(config, "bodies", []);
                    /**
         * An array of the tile data indexes.
         *
         * @name Phaser.Tilemaps.LayerData#data
         * @type {Phaser.Tilemaps.Tile[][]}
         * @since 3.0.0
         */ this.data = GetFastValue(config, "data", []);
                    /**
         * A reference to the Tilemap layer that owns this data.
         *
         * @name Phaser.Tilemaps.LayerData#tilemapLayer
         * @type {Phaser.Tilemaps.TilemapLayer}
         * @since 3.0.0
         */ this.tilemapLayer = GetFastValue(config, "tilemapLayer", null);
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.LayerData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, "hexSideLength", 0);
                }
            });
            module1.exports = LayerData;
        /***/ },
        /* 121 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(29);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing data about a map. Maps are parsed from CSV, Tiled, etc. into this
 * format. A Tilemap object get a copy of this data and then unpacks the needed properties into
 * itself.
 *
 * @class MapData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.MapDataConfig} [config] - The Map configuration object.
 */ var MapData = new Class({
                initialize: function MapData(config) {
                    if (config === undefined) config = {};
                    /**
         * The key in the Phaser cache that corresponds to the loaded tilemap data.
         *
         * @name Phaser.Tilemaps.MapData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, "name", "map");
                    /**
         * The width of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, "width", 0);
                    /**
         * The height of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, "height", 0);
                    /**
         * If the map is infinite or not.
         *
         * @name Phaser.Tilemaps.MapData#infinite
         * @type {boolean}
         * @since 3.17.0
         */ this.infinite = GetFastValue(config, "infinite", false);
                    /**
         * The width of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, "tileWidth", 0);
                    /**
         * The height of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, "tileHeight", 0);
                    /**
         * The width in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, "widthInPixels", this.width * this.tileWidth);
                    /**
         * The height in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, "heightInPixels", this.height * this.tileHeight);
                    /**
         * The format of the map data.
         *
         * @name Phaser.Tilemaps.MapData#format
         * @type {number}
         * @since 3.0.0
         */ this.format = GetFastValue(config, "format", null);
                    /**
         * The orientation of the map data (i.e. orthogonal, isometric, hexagonal), default 'orthogonal'.
         *
         * @name Phaser.Tilemaps.MapData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, "orientation", CONST.ORTHOGONAL);
                    /**
         * Determines the draw order of tilemap. Default is right-down
         *
         * 0, or 'right-down'
         * 1, or 'left-down'
         * 2, or 'right-up'
         * 3, or 'left-up'
         *
         * @name Phaser.Tilemaps.MapData#renderOrder
         * @type {string}
         * @since 3.12.0
         */ this.renderOrder = GetFastValue(config, "renderOrder", "right-down");
                    /**
         * The version of the map data (as specified in Tiled).
         *
         * @name Phaser.Tilemaps.MapData#version
         * @type {string}
         * @since 3.0.0
         */ this.version = GetFastValue(config, "version", "1");
                    /**
         * Map specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, "properties", {});
                    /**
         * An array with all the layers configured to the MapData.
         *
         * @name Phaser.Tilemaps.MapData#layers
         * @type {(Phaser.Tilemaps.LayerData[]|Phaser.Tilemaps.ObjectLayer)}
         * @since 3.0.0
         */ this.layers = GetFastValue(config, "layers", []);
                    /**
         * An array of Tiled Image Layers.
         *
         * @name Phaser.Tilemaps.MapData#images
         * @type {array}
         * @since 3.0.0
         */ this.images = GetFastValue(config, "images", []);
                    /**
         * An object of Tiled Object Layers.
         *
         * @name Phaser.Tilemaps.MapData#objects
         * @type {object}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, "objects", {});
                    /**
          * An object of collision data. Must be created as physics object or will return undefined.
         *
         * @name Phaser.Tilemaps.MapData#collision
         * @type {object}
         * @since 3.0.0
         */ this.collision = GetFastValue(config, "collision", {});
                    /**
         * An array of Tilesets.
         *
         * @name Phaser.Tilemaps.MapData#tilesets
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.0.0
         */ this.tilesets = GetFastValue(config, "tilesets", []);
                    /**
         * The collection of images the map uses(specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#imageCollections
         * @type {array}
         * @since 3.0.0
         */ this.imageCollections = GetFastValue(config, "imageCollections", []);
                    /**
         * An array of tile instances.
         *
         * @name Phaser.Tilemaps.MapData#tiles
         * @type {array}
         * @since 3.0.0
         */ this.tiles = GetFastValue(config, "tiles", []);
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.MapData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, "hexSideLength", 0);
                }
            });
            module1.exports = MapData;
        /***/ },
        /* 122 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Tileset is a combination of an image containing the tiles and a container for data about
 * each tile.
 *
 * @class Tileset
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {string} name - The name of the tileset in the map data.
 * @param {number} firstgid - The first tile index this tileset contains.
 * @param {number} [tileWidth=32] - Width of each tile (in pixels).
 * @param {number} [tileHeight=32] - Height of each tile (in pixels).
 * @param {number} [tileMargin=0] - The margin around all tiles in the sheet (in pixels).
 * @param {number} [tileSpacing=0] - The spacing between each tile in the sheet (in pixels).
 * @param {object} [tileProperties={}] - Custom properties defined per tile in the Tileset.
 * These typically are custom properties created in Tiled when editing a tileset.
 * @param {object} [tileData={}] - Data stored per tile. These typically are created in Tiled
 * when editing a tileset, e.g. from Tiled's tile collision editor or terrain editor.
 */ var Tileset = new Class({
                initialize: function Tileset(name, firstgid, tileWidth, tileHeight, tileMargin, tileSpacing, tileProperties, tileData) {
                    if (tileWidth === undefined || tileWidth <= 0) tileWidth = 32;
                    if (tileHeight === undefined || tileHeight <= 0) tileHeight = 32;
                    if (tileMargin === undefined) tileMargin = 0;
                    if (tileSpacing === undefined) tileSpacing = 0;
                    if (tileProperties === undefined) tileProperties = {};
                    if (tileData === undefined) tileData = {};
                    /**
         * The name of the Tileset.
         *
         * @name Phaser.Tilemaps.Tileset#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                    /**
         * The starting index of the first tile index this Tileset contains.
         *
         * @name Phaser.Tilemaps.Tileset#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid;
                    /**
         * The width of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileWidth = tileWidth;
                    /**
         * The height of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileHeight = tileHeight;
                    /**
         * The margin around the tiles in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileMargin
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileMargin = tileMargin;
                    /**
         * The spacing between each the tile in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileSpacing = tileSpacing;
                    /**
         * Tileset-specific properties per tile that are typically defined in the Tiled editor in the
         * Tileset editor.
         *
         * @name Phaser.Tilemaps.Tileset#tileProperties
         * @type {object}
         * @since 3.0.0
         */ this.tileProperties = tileProperties;
                    /**
         * Tileset-specific data per tile that are typically defined in the Tiled editor, e.g. within
         * the Tileset collision editor. This is where collision objects and terrain are stored.
         *
         * @name Phaser.Tilemaps.Tileset#tileData
         * @type {object}
         * @since 3.0.0
         */ this.tileData = tileData;
                    /**
         * The cached image that contains the individual tiles. Use setImage to set.
         *
         * @name Phaser.Tilemaps.Tileset#image
         * @type {?Phaser.Textures.Texture}
         * @readonly
         * @since 3.0.0
         */ this.image = null;
                    /**
         * The gl texture used by the WebGL renderer.
         *
         * @name Phaser.Tilemaps.Tileset#glTexture
         * @type {?WebGLTexture}
         * @readonly
         * @since 3.11.0
         */ this.glTexture = null;
                    /**
         * The number of tile rows in the the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#rows
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.rows = 0;
                    /**
         * The number of tile columns in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#columns
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.columns = 0;
                    /**
         * The total number of tiles in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                    /**
         * The look-up table to specific tile image texture coordinates (UV in pixels). Each element
         * contains the coordinates for a tile in an object of the form {x, y}.
         *
         * @name Phaser.Tilemaps.Tileset#texCoordinates
         * @type {object[]}
         * @readonly
         * @since 3.0.0
        */ this.texCoordinates = [];
                },
                /**
     * Get a tiles properties that are stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined in Tiled under the Tileset editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileProperties
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?(object|undefined)}
     */ getTileProperties: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.tileProperties[tileIndex - this.firstgid];
                },
                /**
     * Get a tile's data that is stored in the Tileset. Returns null if tile index is not contained
     * in this Tileset. This is typically defined in Tiled and will contain both Tileset collision
     * info and terrain mapping.
     *
     * @method Phaser.Tilemaps.Tileset#getTileData
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object|undefined}
     */ getTileData: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.tileData[tileIndex - this.firstgid];
                },
                /**
     * Get a tile's collision group that is stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined within Tiled's tileset collision editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileCollisionGroup
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object}
     */ getTileCollisionGroup: function(tileIndex) {
                    var data = this.getTileData(tileIndex);
                    return data && data.objectgroup ? data.objectgroup : null;
                },
                /**
     * Returns true if and only if this Tileset contains the given tile index.
     *
     * @method Phaser.Tilemaps.Tileset#containsTileIndex
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {boolean}
     */ containsTileIndex: function(tileIndex) {
                    return tileIndex >= this.firstgid && tileIndex < this.firstgid + this.total;
                },
                /**
     * Returns the texture coordinates (UV in pixels) in the Tileset image for the given tile index.
     * Returns null if tile index is not contained in this Tileset.
     *
     * @method Phaser.Tilemaps.Tileset#getTileTextureCoordinates
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object} Object in the form { x, y } representing the top-left UV coordinate
     * within the Tileset image.
     */ getTileTextureCoordinates: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.texCoordinates[tileIndex - this.firstgid];
                },
                /**
     * Sets the image associated with this Tileset and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setImage
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Texture} texture - The image that contains the tiles.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setImage: function(texture) {
                    this.image = texture;
                    this.glTexture = texture.get().source.glTexture;
                    this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Sets the tile width & height and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setTileSize
     * @since 3.0.0
     *
     * @param {number} [tileWidth] - The width of a tile in pixels.
     * @param {number} [tileHeight] - The height of a tile in pixels.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setTileSize: function(tileWidth, tileHeight) {
                    if (tileWidth !== undefined) this.tileWidth = tileWidth;
                    if (tileHeight !== undefined) this.tileHeight = tileHeight;
                    if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Sets the tile margin & spacing and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setSpacing
     * @since 3.0.0
     *
     * @param {number} [margin] - The margin around the tiles in the sheet (in pixels).
     * @param {number} [spacing] - The spacing between the tiles in the sheet (in pixels).
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setSpacing: function(margin, spacing) {
                    if (margin !== undefined) this.tileMargin = margin;
                    if (spacing !== undefined) this.tileSpacing = spacing;
                    if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Updates tile texture coordinates and tileset data.
     *
     * @method Phaser.Tilemaps.Tileset#updateTileData
     * @since 3.0.0
     *
     * @param {number} imageWidth - The (expected) width of the image to slice.
     * @param {number} imageHeight - The (expected) height of the image to slice.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ updateTileData: function(imageWidth, imageHeight) {
                    var rowCount = (imageHeight - this.tileMargin * 2 + this.tileSpacing) / (this.tileHeight + this.tileSpacing);
                    var colCount = (imageWidth - this.tileMargin * 2 + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
                    if (rowCount % 1 !== 0 || colCount % 1 !== 0) console.warn("Image tile area not tile size multiple in: " + this.name);
                    // In Tiled a tileset image that is not an even multiple of the tile dimensions is truncated
                    // - hence the floor when calculating the rows/columns.
                    rowCount = Math.floor(rowCount);
                    colCount = Math.floor(colCount);
                    this.rows = rowCount;
                    this.columns = colCount;
                    // In Tiled, "empty" spaces in a tileset count as tiles and hence count towards the gid
                    this.total = rowCount * colCount;
                    this.texCoordinates.length = 0;
                    var tx = this.tileMargin;
                    var ty = this.tileMargin;
                    for(var y = 0; y < this.rows; y++){
                        for(var x = 0; x < this.columns; x++){
                            this.texCoordinates.push({
                                x: tx,
                                y: ty
                            });
                            tx += this.tileWidth + this.tileSpacing;
                        }
                        tx = this.tileMargin;
                        ty += this.tileHeight + this.tileSpacing;
                    }
                    return this;
                }
            });
            module1.exports = Tileset;
        /***/ },
        /* 123 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = {
                /**
    * A constant representing a top-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_LEFT
    * @since 3.0.0
    * @type {number}
    */ TOP_LEFT: 0,
                /**
    * A constant representing a top-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_CENTER
    * @since 3.0.0
    * @type {number}
    */ TOP_CENTER: 1,
                /**
    * A constant representing a top-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_RIGHT
    * @since 3.0.0
    * @type {number}
    */ TOP_RIGHT: 2,
                /**
    * A constant representing a left-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_TOP
    * @since 3.0.0
    * @type {number}
    */ LEFT_TOP: 3,
                /**
    * A constant representing a left-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_CENTER
    * @since 3.0.0
    * @type {number}
    */ LEFT_CENTER: 4,
                /**
    * A constant representing a left-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ LEFT_BOTTOM: 5,
                /**
    * A constant representing a center alignment or position.
    * @constant
    * @name Phaser.Display.Align.CENTER
    * @since 3.0.0
    * @type {number}
    */ CENTER: 6,
                /**
    * A constant representing a right-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_TOP
    * @since 3.0.0
    * @type {number}
    */ RIGHT_TOP: 7,
                /**
    * A constant representing a right-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_CENTER
    * @since 3.0.0
    * @type {number}
    */ RIGHT_CENTER: 8,
                /**
    * A constant representing a right-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ RIGHT_BOTTOM: 9,
                /**
    * A constant representing a bottom-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_LEFT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_LEFT: 10,
                /**
    * A constant representing a bottom-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_CENTER
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_CENTER: 11,
                /**
    * A constant representing a bottom-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_RIGHT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_RIGHT: 12
            };
            module1.exports = ALIGN_CONST;
        /***/ },
        /* 124 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether the given values are fuzzily equal.
 *
 * Two numbers are fuzzily equal if their difference is less than `epsilon`.
 *
 * @function Phaser.Math.Fuzzy.Equal
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if the values are fuzzily equal, otherwise `false`.
 */ var Equal = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.abs(a - b) < epsilon;
            };
            module1.exports = Equal;
        /***/ },
        /* 125 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var ImageRender = __webpack_require__(1068);
            /**
 * @classdesc
 * An Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Image1 = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    ImageRender
                ],
                initialize: function Image1(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, "Image");
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Image#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.setOriginFromFrame();
                    this.initPipeline();
                }
            });
            module1.exports = Image1;
        /***/ },
        /* 126 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determine whether the source object has a property with the specified key.
 *
 * @function Phaser.Utils.Objects.HasValue
 * @since 3.0.0
 *
 * @param {object} source - The source object to be checked.
 * @param {string} key - The property to check for within the object
 *
 * @return {boolean} `true` if the provided `key` exists on the `source` object, otherwise `false`.
 */ var HasValue = function(source, key) {
                return source.hasOwnProperty(key);
            };
            module1.exports = HasValue;
        /***/ },
        /* 127 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Creates a new Object using all values from obj1 and obj2.
 * If a value exists in both obj1 and obj2, the value in obj1 is used.
 * 
 * This is only a shallow copy. Deeply nested objects are not cloned, so be sure to only use this
 * function on shallow objects.
 *
 * @function Phaser.Utils.Objects.Merge
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object.
 * @param {object} obj2 - The second object.
 *
 * @return {object} A new object containing the union of obj1's and obj2's properties.
 */ var Merge = function(obj1, obj2) {
                var clone = Clone(obj1);
                for(var key in obj2)if (!clone.hasOwnProperty(key)) clone[key] = obj2[key];
                return clone;
            };
            module1.exports = Merge;
        /***/ },
        /* 128 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
* The stiffness of constraints can be modified to create springs or elastic.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Constraint
*/ var Constraint = {};
            module1.exports = Constraint;
            var Vertices = __webpack_require__(64);
            var Vector = __webpack_require__(83);
            var Sleeping = __webpack_require__(165);
            var Bounds = __webpack_require__(84);
            var Axes = __webpack_require__(271);
            var Common = __webpack_require__(32);
            (function() {
                Constraint._warming = 0.4;
                Constraint._torqueDampen = 1;
                Constraint._minLength = 0.000001;
                /**
     * Creates a new constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {constraint} constraint
     */ Constraint.create = function(options) {
                    var constraint = options;
                    // if bodies defined but no points, use body centre
                    if (constraint.bodyA && !constraint.pointA) constraint.pointA = {
                        x: 0,
                        y: 0
                    };
                    if (constraint.bodyB && !constraint.pointB) constraint.pointB = {
                        x: 0,
                        y: 0
                    };
                    // calculate static length using initial world space points
                    var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA, initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB, length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
                    constraint.length = typeof constraint.length !== "undefined" ? constraint.length : length;
                    // option defaults
                    constraint.id = constraint.id || Common.nextId();
                    constraint.label = constraint.label || "Constraint";
                    constraint.type = "constraint";
                    constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
                    constraint.damping = constraint.damping || 0;
                    constraint.angularStiffness = constraint.angularStiffness || 0;
                    constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
                    constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
                    constraint.plugin = {};
                    // render
                    var render = {
                        visible: true,
                        type: "line",
                        anchors: true,
                        lineColor: null,
                        lineOpacity: null,
                        lineThickness: null,
                        pinSize: null,
                        anchorColor: null,
                        anchorSize: null // custom Phaser property
                    };
                    if (constraint.length === 0 && constraint.stiffness > 0.1) {
                        render.type = "pin";
                        render.anchors = false;
                    } else if (constraint.stiffness < 0.9) render.type = "spring";
                    constraint.render = Common.extend(render, constraint.render);
                    return constraint;
                };
                /**
     * Prepares for solving by constraint warming.
     * @private
     * @method preSolveAll
     * @param {body[]} bodies
     */ Constraint.preSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        body.position.x += impulse.x;
                        body.position.y += impulse.y;
                        body.angle += impulse.angle;
                    }
                };
                /**
     * Solves all constraints in a list of collisions.
     * @private
     * @method solveAll
     * @param {constraint[]} constraints
     * @param {number} timeScale
     */ Constraint.solveAll = function(constraints, timeScale) {
                    // Solve fixed constraints first.
                    for(var i = 0; i < constraints.length; i += 1){
                        var constraint = constraints[i], fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic, fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (fixedA || fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                    // Solve free constraints last.
                    for(i = 0; i < constraints.length; i += 1){
                        constraint = constraints[i];
                        fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic;
                        fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (!fixedA && !fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                };
                /**
     * Solves a distance constraint with Gauss-Siedel method.
     * @private
     * @method solve
     * @param {constraint} constraint
     * @param {number} timeScale
     */ Constraint.solve = function(constraint, timeScale) {
                    var bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointA = constraint.pointA, pointB = constraint.pointB;
                    if (!bodyA && !bodyB) return;
                    // update reference angle
                    if (bodyA && !bodyA.isStatic) {
                        Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
                        constraint.angleA = bodyA.angle;
                    }
                    // update reference angle
                    if (bodyB && !bodyB.isStatic) {
                        Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
                        constraint.angleB = bodyB.angle;
                    }
                    var pointAWorld = pointA, pointBWorld = pointB;
                    if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
                    if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
                    if (!pointAWorld || !pointBWorld) return;
                    var delta = Vector.sub(pointAWorld, pointBWorld), currentLength = Vector.magnitude(delta);
                    // prevent singularity
                    if (currentLength < Constraint._minLength) currentLength = Constraint._minLength;
                    // solve distance constraint with Gauss-Siedel method
                    var difference = (currentLength - constraint.length) / currentLength, stiffness = constraint.stiffness < 1 ? constraint.stiffness * timeScale : constraint.stiffness, force = Vector.mult(delta, difference * stiffness), massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0), inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0), resistanceTotal = massTotal + inertiaTotal, torque, share, normal, normalVelocity, relativeVelocity;
                    if (constraint.damping) {
                        var zero = Vector.create();
                        normal = Vector.div(delta, currentLength);
                        relativeVelocity = Vector.sub(bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero, bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero);
                        normalVelocity = Vector.dot(normal, relativeVelocity);
                    }
                    if (bodyA && !bodyA.isStatic) {
                        share = bodyA.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyA.constraintImpulse.x -= force.x * share;
                        bodyA.constraintImpulse.y -= force.y * share;
                        // apply forces
                        bodyA.position.x -= force.x * share;
                        bodyA.position.y -= force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyA.positionPrev.x -= constraint.damping * normal.x * normalVelocity * share;
                            bodyA.positionPrev.y -= constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointA, force) / resistanceTotal * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
                        bodyA.constraintImpulse.angle -= torque;
                        bodyA.angle -= torque;
                    }
                    if (bodyB && !bodyB.isStatic) {
                        share = bodyB.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyB.constraintImpulse.x += force.x * share;
                        bodyB.constraintImpulse.y += force.y * share;
                        // apply forces
                        bodyB.position.x += force.x * share;
                        bodyB.position.y += force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyB.positionPrev.x += constraint.damping * normal.x * normalVelocity * share;
                            bodyB.positionPrev.y += constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointB, force) / resistanceTotal * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
                        bodyB.constraintImpulse.angle += torque;
                        bodyB.angle += torque;
                    }
                };
                /**
     * Performs body updates required after solving constraints.
     * @private
     * @method postSolveAll
     * @param {body[]} bodies
     */ Constraint.postSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        Sleeping.set(body, false);
                        // update geometry and reset
                        for(var j = 0; j < body.parts.length; j++){
                            var part = body.parts[j];
                            Vertices.translate(part.vertices, impulse);
                            if (j > 0) {
                                part.position.x += impulse.x;
                                part.position.y += impulse.y;
                            }
                            if (impulse.angle !== 0) {
                                Vertices.rotate(part.vertices, impulse.angle, body.position);
                                Axes.rotate(part.axes, impulse.angle);
                                if (j > 0) Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
                            }
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                        // dampen the cached impulse for warming next step
                        impulse.angle *= Constraint._warming;
                        impulse.x *= Constraint._warming;
                        impulse.y *= Constraint._warming;
                    }
                };
                /**
     * Returns the world-space position of `constraint.pointA`, accounting for `constraint.bodyA`.
     * @method pointAWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointAWorld = function(constraint) {
                    return {
                        x: (constraint.bodyA ? constraint.bodyA.position.x : 0) + constraint.pointA.x,
                        y: (constraint.bodyA ? constraint.bodyA.position.y : 0) + constraint.pointA.y
                    };
                };
                /**
     * Returns the world-space position of `constraint.pointB`, accounting for `constraint.bodyB`.
     * @method pointBWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointBWorld = function(constraint) {
                    return {
                        x: (constraint.bodyB ? constraint.bodyB.position.x : 0) + constraint.pointB.x,
                        y: (constraint.bodyB ? constraint.bodyB.position.y : 0) + constraint.pointB.y
                    };
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Constraint"
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the constraint should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * A `Number` that defines the line width to use when rendering the constraint outline.
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 2
     */ /**
     * A `String` that defines the stroke style to use when rendering the constraint outline.
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the constraint rendering type. 
     * The possible values are 'line', 'pin', 'spring'.
     * An appropriate render type will be automatically chosen unless one is given in options.
     *
     * @property render.type
     * @type string
     * @default 'line'
     */ /**
     * A `Boolean` that defines if the constraint's anchor points should be rendered.
     *
     * @property render.anchors
     * @type boolean
     * @default true
     */ /**
     * The first possible `Body` that this constraint is attached to.
     *
     * @property bodyA
     * @type body
     * @default null
     */ /**
     * The second possible `Body` that this constraint is attached to.
     *
     * @property bodyB
     * @type body
     * @default null
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
     *
     * @property pointA
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
     *
     * @property pointB
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
     * A value of `1` means the constraint should be very stiff.
     * A value of `0.2` means the constraint acts like a soft spring.
     *
     * @property stiffness
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the damping of the constraint, 
     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
     * Damping will only be apparent when the constraint also has a very low `stiffness`.
     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
     * A value of `0` means the constraint will apply no damping.
     *
     * @property damping
     * @type number
     * @default 0
     */ /**
     * A `Number` that specifies the target resting length of the constraint. 
     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     *
     * @property length
     * @type number
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 129 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            var Circle = __webpack_require__(65);
            var CircleContains = __webpack_require__(66);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(57);
            /**
 * @classdesc
 * A Zone Game Object.
 *
 * A Zone is a non-rendering rectangular Game Object that has a position and size.
 * It has no texture and never displays, but does live on the display list and
 * can be moved, scaled and rotated like any other Game Object.
 *
 * Its primary use is for creating Drop Zones and Input Hit Areas and it has a couple of helper methods
 * specifically for this. It is also useful for object overlap checks, or as a base for your own
 * non-displaying Game Objects.

 * The default origin is 0.5, the center of the Zone, the same as with Game Objects.
 *
 * @class Zone
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=1] - The width of the Game Object.
 * @param {number} [height=1] - The height of the Game Object.
 */ var Zone = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Depth,
                    Components.GetBounds,
                    Components.Origin,
                    Components.Transform,
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function Zone(scene, x, y, width, height) {
                    if (width === undefined) width = 1;
                    if (height === undefined) height = width;
                    GameObject.call(this, scene, "Zone");
                    this.setPosition(x, y);
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The Blend Mode of the Game Object.
         * Although a Zone never renders, it still has a blend mode to allow it to fit seamlessly into
         * display lists without causing a batch flush.
         *
         * @name Phaser.GameObjects.Zone#blendMode
         * @type {number}
         * @since 3.0.0
         */ this.blendMode = BlendModes.NORMAL;
                    this.updateDisplayOrigin();
                },
                /**
     * The displayed width of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                },
                /**
     * Sets the size of this Game Object.
     *
     * @method Phaser.GameObjects.Zone#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * @param {boolean} [resizeInput=true] - If this Zone has a Rectangle for a hit area this argument will resize the hit area as well.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, resizeInput) {
                    if (resizeInput === undefined) resizeInput = true;
                    this.width = width;
                    this.height = height;
                    this.updateDisplayOrigin();
                    var input = this.input;
                    if (resizeInput && input && !input.customHitArea) {
                        input.hitArea.width = width;
                        input.hitArea.height = height;
                    }
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Zone#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                },
                /**
     * Sets this Zone to be a Circular Drop Zone.
     * The circle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setCircleDropZone
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Circle that will form the Drop Zone.
     *
     * @return {this} This Game Object.
     */ setCircleDropZone: function(radius) {
                    return this.setDropZone(new Circle(0, 0, radius), CircleContains);
                },
                /**
     * Sets this Zone to be a Rectangle Drop Zone.
     * The rectangle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setRectangleDropZone
     * @since 3.0.0
     *
     * @param {number} width - The width of the rectangle drop zone.
     * @param {number} height - The height of the rectangle drop zone.
     *
     * @return {this} This Game Object.
     */ setRectangleDropZone: function(width, height) {
                    return this.setDropZone(new Rectangle(0, 0, width, height), RectangleContains);
                },
                /**
     * Allows you to define your own Geometry shape to be used as a Drop Zone.
     *
     * @method Phaser.GameObjects.Zone#setDropZone
     * @since 3.0.0
     *
     * @param {object} hitArea - A Geometry shape instance, such as Phaser.Geom.Ellipse, or your own custom shape.
     * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A function that will return `true` if the given x/y coords it is sent are within the shape.
     *
     * @return {this} This Game Object.
     */ setDropZone: function(hitArea, hitAreaCallback) {
                    if (hitArea === undefined) this.setRectangleDropZone(this.width, this.height);
                    else if (!this.input) this.setInteractive(hitArea, hitAreaCallback, true);
                    return this;
                },
                /**
     * A NOOP method so you can pass a Zone to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setAlpha
     * @private
     * @since 3.11.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass a Zone to a Container in Canvas.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setBlendMode
     * @private
     * @since 3.16.2
     */ setBlendMode: function() {},
                /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderCanvas
     * @private
     * @since 3.53.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
     * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
     */ renderCanvas: function(renderer, src, camera) {
                    camera.addToRenderList(src);
                },
                /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderWebGL
     * @private
     * @since 3.53.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
     * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
     */ renderWebGL: function(renderer, src, camera) {
                    camera.addToRenderList(src);
                }
            });
            module1.exports = Zone;
        /***/ },
        /* 130 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the perimeter of a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to use.
 *
 * @return {number} The perimeter of the Rectangle, equal to `(width * 2) + (height * 2)`.
 */ var Perimeter = function(rect) {
                return 2 * (rect.width + rect.height);
            };
            module1.exports = Perimeter;
        /***/ },
        /* 131 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shuffles the contents of the given array using the Fisher-Yates implementation.
 *
 * The original array is modified directly and returned.
 *
 * @function Phaser.Utils.Array.Shuffle
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [array,$return]
 *
 * @param {T[]} array - The array to shuffle. This array is modified in place.
 *
 * @return {T[]} The shuffled array.
 */ var Shuffle = function(array) {
                for(var i = array.length - 1; i > 0; i--){
                    var j = Math.floor(Math.random() * (i + 1));
                    var temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                }
                return array;
            };
            module1.exports = Shuffle;
        /***/ },
        /* 132 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations.Events
 */ module1.exports = {
                ADD_ANIMATION: __webpack_require__(724),
                ANIMATION_COMPLETE: __webpack_require__(725),
                ANIMATION_COMPLETE_KEY: __webpack_require__(726),
                ANIMATION_REPEAT: __webpack_require__(727),
                ANIMATION_RESTART: __webpack_require__(728),
                ANIMATION_START: __webpack_require__(729),
                ANIMATION_STOP: __webpack_require__(730),
                ANIMATION_UPDATE: __webpack_require__(731),
                PAUSE_ALL: __webpack_require__(732),
                REMOVE_ANIMATION: __webpack_require__(733),
                RESUME_ALL: __webpack_require__(734)
            };
        /***/ },
        /* 133 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DegToRad = __webpack_require__(36);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(37);
            var Rectangle = __webpack_require__(10);
            var TransformMatrix = __webpack_require__(25);
            var ValueToColor = __webpack_require__(187);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Base Camera class.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * The Base Camera is extended by the Camera class, which adds in special effects including Fade,
 * Flash and Camera Shake, as well as the ability to follow Game Objects.
 *
 * The Base Camera was introduced in Phaser 3.12. It was split off from the Camera class, to allow
 * you to isolate special effects as needed. Therefore the 'since' values for properties of this class relate
 * to when they were added to the Camera class.
 *
 * @class BaseCamera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.12.0
 *
 * @extends Phaser.Events.EventEmitter
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var BaseCamera = new Class({
                Extends: EventEmitter,
                Mixins: [
                    Components.Alpha,
                    Components.Visible
                ],
                initialize: function BaseCamera(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene this camera belongs to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene;
                    /**
         * A reference to the Game Scene Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.12.0
         */ this.sceneManager;
                    /**
         * A reference to the Game Scale Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                    /**
         * A reference to the Scene's Camera Manager to which this Camera belongs.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#cameraManager
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.17.0
         */ this.cameraManager;
                    /**
         * The Camera ID. Assigned by the Camera Manager and used to handle camera exclusion.
         * This value is a bitmask.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#id
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.id = 0;
                    /**
         * The name of the Camera. This is left empty for your own use.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = "";
                    /**
         * Should this camera round its pixel values to integers?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#roundPixels
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.roundPixels = false;
                    /**
         * Is this Camera visible or not?
         *
         * A visible camera will render and perform input tests.
         * An invisible camera will not render anything and will skip input tests.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#visible
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ /**
         * Is this Camera using a bounds to restrict scrolling movement?
         *
         * Set this property along with the bounds via `Camera.setBounds`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#useBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useBounds = false;
                    /**
         * The World View is a Rectangle that defines the area of the 'world' the Camera is currently looking at.
         * This factors in the Camera viewport size, zoom and scroll position and is updated in the Camera preRender step.
         * If you have enabled Camera bounds the worldview will be clamped to those bounds accordingly.
         * You can use it for culling or intersection checks.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#worldView
         * @type {Phaser.Geom.Rectangle}
         * @readonly
         * @since 3.11.0
         */ this.worldView = new Rectangle();
                    /**
         * Is this Camera dirty?
         *
         * A dirty Camera has had either its viewport size, bounds, scroll, rotation or zoom levels changed since the last frame.
         *
         * This flag is cleared during the `postRenderCamera` method of the renderer.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#dirty
         * @type {boolean}
         * @default true
         * @since 3.11.0
         */ this.dirty = true;
                    /**
         * The x position of the Camera viewport, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_x
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._x = x;
                    /**
         * The y position of the Camera, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_y
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._y = y;
                    /**
         * The width of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_width
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._width = width;
                    /**
         * The height of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_height
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._height = height;
                    /**
         * The bounds the camera is restrained to during scrolling.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                    /**
         * The horizontal scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollX
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollX = 0;
                    /**
         * The vertical scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollY
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollY = 0;
                    /**
         * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomX
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomX = 1;
                    /**
         * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomY
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomY = 1;
                    /**
         * The rotation of the Camera in radians.
         *
         * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
         * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
         *
         * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
         * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_rotation
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._rotation = 0;
                    /**
         * A local transform matrix used for internal calculations.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#matrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.0.0
         */ this.matrix = new TransformMatrix();
                    /**
         * Does this Camera have a transparent background?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#transparent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.transparent = true;
                    /**
         * The background color of this Camera. Only used if `transparent` is `false`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#backgroundColor
         * @type {Phaser.Display.Color}
         * @since 3.0.0
         */ this.backgroundColor = ValueToColor("rgba(0,0,0,0)");
                    /**
         * The Camera alpha value. Setting this property impacts every single object that this Camera
         * renders. You can either set the property directly, i.e. via a Tween, to fade a Camera in or out,
         * or via the chainable `setAlpha` method instead.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#alpha
         * @type {number}
         * @default 1
         * @since 3.11.0
         */ /**
         * Should the camera cull Game Objects before checking them for input hit tests?
         * In some special cases it may be beneficial to disable this.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#disableCull
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.disableCull = false;
                    /**
         * A temporary array of culled objects.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#culledObjects
         * @type {Phaser.GameObjects.GameObject[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.culledObjects = [];
                    /**
         * The mid-point of the Camera in 'world' coordinates.
         *
         * Use it to obtain exactly where in the world the center of the camera is currently looking.
         *
         * This value is updated in the preRender method, after the scroll values and follower
         * have been processed.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#midPoint
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.midPoint = new Vector2(width / 2, height / 2);
                    /**
         * The horizontal origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originX
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originX = 0.5;
                    /**
         * The vertical origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originY
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originY = 0.5;
                    /**
         * Does this Camera have a custom viewport?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_customViewport
         * @type {boolean}
         * @private
         * @default false
         * @since 3.12.0
         */ this._customViewport = false;
                    /**
         * The Mask this Camera is using during render.
         * Set the mask using the `setMask` method. Remove the mask using the `clearMask` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#mask
         * @type {?(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)}
         * @since 3.17.0
         */ this.mask = null;
                    /**
         * The Camera that this Camera uses for translation during masking.
         *
         * If the mask is fixed in position this will be a reference to
         * the CameraManager.default instance. Otherwise, it'll be a reference
         * to itself.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_maskCamera
         * @type {?Phaser.Cameras.Scene2D.BaseCamera}
         * @private
         * @since 3.17.0
         */ this._maskCamera = null;
                    /**
         * This array is populated with all of the Game Objects that this Camera has rendered
         * in the previous (or current, depending on when you inspect it) frame.
         *
         * It is cleared at the start of `Camera.preUpdate`, or if the Camera is destroyed.
         *
         * You should not modify this array as it is used internally by the input system,
         * however you can read it as required. Note that Game Objects may appear in this
         * list multiple times if they belong to multiple non-exclusive Containers.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#renderList
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.52.0
         */ this.renderList = [];
                },
                /**
     * Adds the given Game Object to this cameras render list.
     *
     * This is invoked during the rendering stage. Only objects that are actually rendered
     * will appear in the render list.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#addToRenderList
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add to the render list.
     */ addToRenderList: function(child) {
                    this.renderList.push(child);
                },
                /**
     * Set the Alpha level of this Camera. The alpha controls the opacity of the Camera as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAlpha
     * @since 3.11.0
     *
     * @param {number} [value=1] - The Camera alpha value.
     *
     * @return {this} This Camera instance.
     */ /**
     * Sets the rotation origin of this Camera.
     *
     * The values are given in the range 0 to 1 and are only used when calculating Camera rotation.
     *
     * By default the camera rotates around the center of the viewport.
     *
     * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
     * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setOrigin
     * @since 3.11.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Camera instance.
     */ setOrigin: function(x, y) {
                    if (x === undefined) x = 0.5;
                    if (y === undefined) y = x;
                    this.originX = x;
                    this.originY = y;
                    return this;
                },
                /**
     * Calculates what the Camera.scrollX and scrollY values would need to be in order to move
     * the Camera so it is centered on the given x and y coordinates, without actually moving
     * the Camera there. The results are clamped based on the Camera bounds, if set.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getScroll
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 to store the values in. If not given a new Vector2 is created.
     *
     * @return {Phaser.Math.Vector2} The scroll coordinates stored in the `x` and `y` properties.
     */ getScroll: function(x, y, out) {
                    if (out === undefined) out = new Vector2();
                    var originX = this.width * 0.5;
                    var originY = this.height * 0.5;
                    out.x = x - originX;
                    out.y = y - originY;
                    if (this.useBounds) {
                        out.x = this.clampX(out.x);
                        out.y = this.clampY(out.y);
                    }
                    return out;
                },
                /**
     * Moves the Camera horizontally so that it is centered on the given x coordinate, bounds allowing.
     * Calling this does not change the scrollY value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnX
     * @since 3.16.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnX: function(x) {
                    var originX = this.width * 0.5;
                    this.midPoint.x = x;
                    this.scrollX = x - originX;
                    if (this.useBounds) this.scrollX = this.clampX(this.scrollX);
                    return this;
                },
                /**
     * Moves the Camera vertically so that it is centered on the given y coordinate, bounds allowing.
     * Calling this does not change the scrollX value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnY
     * @since 3.16.0
     *
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnY: function(y) {
                    var originY = this.height * 0.5;
                    this.midPoint.y = y;
                    this.scrollY = y - originY;
                    if (this.useBounds) this.scrollY = this.clampY(this.scrollY);
                    return this;
                },
                /**
     * Moves the Camera so that it is centered on the given coordinates, bounds allowing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOn
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOn: function(x, y) {
                    this.centerOnX(x);
                    this.centerOnY(y);
                    return this;
                },
                /**
     * Moves the Camera so that it is looking at the center of the Camera Bounds, if enabled.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToBounds: function() {
                    if (this.useBounds) {
                        var bounds = this._bounds;
                        var originX = this.width * 0.5;
                        var originY = this.height * 0.5;
                        this.midPoint.set(bounds.centerX, bounds.centerY);
                        this.scrollX = bounds.centerX - originX;
                        this.scrollY = bounds.centerY - originY;
                    }
                    return this;
                },
                /**
     * Moves the Camera so that it is re-centered based on its viewport size.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToSize
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToSize: function() {
                    this.scrollX = this.width * 0.5;
                    this.scrollY = this.height * 0.5;
                    return this;
                },
                /**
     * Takes an array of Game Objects and returns a new array featuring only those objects
     * visible by this camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#cull
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [renderableObjects,$return]
     *
     * @param {Phaser.GameObjects.GameObject[]} renderableObjects - An array of Game Objects to cull.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of Game Objects visible to this Camera.
     */ cull: function(renderableObjects) {
                    if (this.disableCull) return renderableObjects;
                    var cameraMatrix = this.matrix.matrix;
                    var mva = cameraMatrix[0];
                    var mvb = cameraMatrix[1];
                    var mvc = cameraMatrix[2];
                    var mvd = cameraMatrix[3];
                    /* First Invert Matrix */ var determinant = mva * mvd - mvb * mvc;
                    if (!determinant) return renderableObjects;
                    var mve = cameraMatrix[4];
                    var mvf = cameraMatrix[5];
                    var scrollX = this.scrollX;
                    var scrollY = this.scrollY;
                    var cameraW = this.width;
                    var cameraH = this.height;
                    var cullTop = this.y;
                    var cullBottom = cullTop + cameraH;
                    var cullLeft = this.x;
                    var cullRight = cullLeft + cameraW;
                    var culledObjects = this.culledObjects;
                    var length = renderableObjects.length;
                    determinant = 1 / determinant;
                    culledObjects.length = 0;
                    for(var index = 0; index < length; ++index){
                        var object = renderableObjects[index];
                        if (!object.hasOwnProperty("width") || object.parentContainer) {
                            culledObjects.push(object);
                            continue;
                        }
                        var objectW = object.width;
                        var objectH = object.height;
                        var objectX = object.x - scrollX * object.scrollFactorX - objectW * object.originX;
                        var objectY = object.y - scrollY * object.scrollFactorY - objectH * object.originY;
                        var tx = objectX * mva + objectY * mvc + mve;
                        var ty = objectX * mvb + objectY * mvd + mvf;
                        var tw = (objectX + objectW) * mva + (objectY + objectH) * mvc + mve;
                        var th = (objectX + objectW) * mvb + (objectY + objectH) * mvd + mvf;
                        if (tw > cullLeft && tx < cullRight && th > cullTop && ty < cullBottom) culledObjects.push(object);
                    }
                    return culledObjects;
                },
                /**
     * Converts the given `x` and `y` coordinates into World space, based on this Cameras transform.
     * You can optionally provide a Vector2, or similar object, to store the results in.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getWorldPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {number} x - The x position to convert to world space.
     * @param {number} y - The y position to convert to world space.
     * @param {(object|Phaser.Math.Vector2)} [output] - An optional object to store the results in. If not provided a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} An object holding the converted values in its `x` and `y` properties.
     */ getWorldPoint: function(x, y, output) {
                    if (output === undefined) output = new Vector2();
                    var cameraMatrix = this.matrix.matrix;
                    var mva = cameraMatrix[0];
                    var mvb = cameraMatrix[1];
                    var mvc = cameraMatrix[2];
                    var mvd = cameraMatrix[3];
                    var mve = cameraMatrix[4];
                    var mvf = cameraMatrix[5];
                    //  Invert Matrix
                    var determinant = mva * mvd - mvb * mvc;
                    if (!determinant) {
                        output.x = x;
                        output.y = y;
                        return output;
                    }
                    determinant = 1 / determinant;
                    var ima = mvd * determinant;
                    var imb = -mvb * determinant;
                    var imc = -mvc * determinant;
                    var imd = mva * determinant;
                    var ime = (mvc * mvf - mvd * mve) * determinant;
                    var imf = (mvb * mve - mva * mvf) * determinant;
                    var c = Math.cos(this.rotation);
                    var s = Math.sin(this.rotation);
                    var zoomX = this.zoomX;
                    var zoomY = this.zoomY;
                    var scrollX = this.scrollX;
                    var scrollY = this.scrollY;
                    var sx = x + (scrollX * c - scrollY * s) * zoomX;
                    var sy = y + (scrollX * s + scrollY * c) * zoomY;
                    //  Apply transform to point
                    output.x = sx * ima + sy * imc + ime;
                    output.y = sx * imb + sy * imd + imf;
                    return output;
                },
                /**
     * Given a Game Object, or an array of Game Objects, it will update all of their camera filter settings
     * so that they are ignored by this Camera. This means they will not be rendered by this Camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#ignore
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group)} entries - The Game Object, or array of Game Objects, to be ignored by this Camera.
     *
     * @return {this} This Camera instance.
     */ ignore: function(entries) {
                    var id = this.id;
                    if (!Array.isArray(entries)) entries = [
                        entries
                    ];
                    for(var i = 0; i < entries.length; i++){
                        var entry = entries[i];
                        if (Array.isArray(entry)) this.ignore(entry);
                        else if (entry.isParent) this.ignore(entry.getChildren());
                        else entry.cameraFilter |= id;
                    }
                    return this;
                },
                /**
     * Internal preRender step.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#preRender
     * @protected
     * @since 3.0.0
     */ preRender: function() {
                    this.renderList.length = 0;
                    var width = this.width;
                    var height = this.height;
                    var halfWidth = width * 0.5;
                    var halfHeight = height * 0.5;
                    var zoomX = this.zoomX;
                    var zoomY = this.zoomY;
                    var matrix = this.matrix;
                    var originX = width * this.originX;
                    var originY = height * this.originY;
                    var sx = this.scrollX;
                    var sy = this.scrollY;
                    if (this.useBounds) {
                        sx = this.clampX(sx);
                        sy = this.clampY(sy);
                    }
                    if (this.roundPixels) {
                        originX = Math.round(originX);
                        originY = Math.round(originY);
                    }
                    //  Values are in pixels and not impacted by zooming the Camera
                    this.scrollX = sx;
                    this.scrollY = sy;
                    var midX = sx + halfWidth;
                    var midY = sy + halfHeight;
                    //  The center of the camera, in world space, so taking zoom into account
                    //  Basically the pixel value of what it's looking at in the middle of the cam
                    this.midPoint.set(midX, midY);
                    var displayWidth = width / zoomX;
                    var displayHeight = height / zoomY;
                    this.worldView.setTo(midX - displayWidth / 2, midY - displayHeight / 2, displayWidth, displayHeight);
                    matrix.applyITRS(this.x + originX, this.y + originY, this.rotation, zoomX, zoomY);
                    matrix.translate(-originX, -originY);
                },
                /**
     * Takes an x value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampX
     * @since 3.11.0
     *
     * @param {number} x - The value to horizontally scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollX.
     */ clampX: function(x) {
                    var bounds = this._bounds;
                    var dw = this.displayWidth;
                    var bx = bounds.x + (dw - this.width) / 2;
                    var bw = Math.max(bx, bx + bounds.width - dw);
                    if (x < bx) x = bx;
                    else if (x > bw) x = bw;
                    return x;
                },
                /**
     * Takes a y value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampY
     * @since 3.11.0
     *
     * @param {number} y - The value to vertically scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollY.
     */ clampY: function(y) {
                    var bounds = this._bounds;
                    var dh = this.displayHeight;
                    var by = bounds.y + (dh - this.height) / 2;
                    var bh = Math.max(by, by + bounds.height - dh);
                    if (y < by) y = by;
                    else if (y > bh) y = bh;
                    return y;
                },
                /*
        var gap = this._zoomInversed;
        return gap * Math.round((src.x - this.scrollX * src.scrollFactorX) / gap);
    */ /**
     * If this Camera has previously had movement bounds set on it, this will remove them.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#removeBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ removeBounds: function() {
                    this.useBounds = false;
                    this.dirty = true;
                    this._bounds.setEmpty();
                    return this;
                },
                /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAngle
     * @since 3.0.0
     *
     * @param {number} [value=0] - The cameras angle of rotation, given in degrees.
     *
     * @return {this} This Camera instance.
     */ setAngle: function(value) {
                    if (value === undefined) value = 0;
                    this.rotation = DegToRad(value);
                    return this;
                },
                /**
     * Sets the background color for this Camera.
     *
     * By default a Camera has a transparent background but it can be given a solid color, with any level
     * of transparency, via this method.
     *
     * The color value can be specified using CSS color notation, hex or numbers.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBackgroundColor
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Types.Display.InputColorObject)} [color='rgba(0,0,0,0)'] - The color value. In CSS, hex or numeric color notation.
     *
     * @return {this} This Camera instance.
     */ setBackgroundColor: function(color) {
                    if (color === undefined) color = "rgba(0,0,0,0)";
                    this.backgroundColor = ValueToColor(color);
                    this.transparent = this.backgroundColor.alpha === 0;
                    return this;
                },
                /**
     * Set the bounds of the Camera. The bounds are an axis-aligned rectangle.
     *
     * The Camera bounds controls where the Camera can scroll to, stopping it from scrolling off the
     * edges and into blank space. It does not limit the placement of Game Objects, or where
     * the Camera viewport can be positioned.
     *
     * Temporarily disable the bounds by changing the boolean `Camera.useBounds`.
     *
     * Clear the bounds entirely by calling `Camera.removeBounds`.
     *
     * If you set bounds that are smaller than the viewport it will stop the Camera from being
     * able to scroll. The bounds can be positioned where-ever you wish. By default they are from
     * 0x0 to the canvas width x height. This means that the coordinate 0x0 is the top left of
     * the Camera bounds. However, you can position them anywhere. So if you wanted a game world
     * that was 2048x2048 in size, with 0x0 being the center of it, you can set the bounds x/y
     * to be -1024, -1024, with a width and height of 2048. Depending on your game you may find
     * it easier for 0x0 to be the top-left of the bounds, or you may wish 0x0 to be the middle.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the bounds.
     * @param {number} y - The top-left y coordinate of the bounds.
     * @param {number} width - The width of the bounds, in pixels.
     * @param {number} height - The height of the bounds, in pixels.
     * @param {boolean} [centerOn=false] - If `true` the Camera will automatically be centered on the new bounds.
     *
     * @return {this} This Camera instance.
     */ setBounds: function(x, y, width, height, centerOn) {
                    if (centerOn === undefined) centerOn = false;
                    this._bounds.setTo(x, y, width, height);
                    this.dirty = true;
                    this.useBounds = true;
                    if (centerOn) this.centerToBounds();
                    else {
                        this.scrollX = this.clampX(this.scrollX);
                        this.scrollY = this.clampY(this.scrollY);
                    }
                    return this;
                },
                /**
     * Returns a rectangle containing the bounds of the Camera.
     *
     * If the Camera does not have any bounds the rectangle will be empty.
     *
     * The rectangle is a copy of the bounds, so is safe to modify.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getBounds
     * @since 3.16.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - An optional Rectangle to store the bounds in. If not given, a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A rectangle containing the bounds of this Camera.
     */ getBounds: function(out) {
                    if (out === undefined) out = new Rectangle();
                    var source = this._bounds;
                    out.setTo(source.x, source.y, source.width, source.height);
                    return out;
                },
                /**
     * Sets the name of this Camera.
     * This value is for your own use and isn't used internally.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setName
     * @since 3.0.0
     *
     * @param {string} [value=''] - The name of the Camera.
     *
     * @return {this} This Camera instance.
     */ setName: function(value) {
                    if (value === undefined) value = "";
                    this.name = value;
                    return this;
                },
                /**
     * Set the position of the Camera viewport within the game.
     *
     * This does not change where the camera is 'looking'. See `setScroll` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} [y=x] - The top-left y coordinate of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRotation
     * @since 3.0.0
     *
     * @param {number} [value=0] - The rotation of the Camera, in radians.
     *
     * @return {this} This Camera instance.
     */ setRotation: function(value) {
                    if (value === undefined) value = 0;
                    this.rotation = value;
                    return this;
                },
                /**
     * Should the Camera round pixel values to whole integers when rendering Game Objects?
     *
     * In some types of game, especially with pixel art, this is required to prevent sub-pixel aliasing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRoundPixels
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to round Camera pixels, `false` to not.
     *
     * @return {this} This Camera instance.
     */ setRoundPixels: function(value) {
                    this.roundPixels = value;
                    return this;
                },
                /**
     * Sets the Scene the Camera is bound to.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScene
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene the camera is bound to.
     *
     * @return {this} This Camera instance.
     */ setScene: function(scene) {
                    if (this.scene && this._customViewport) this.sceneManager.customViewports--;
                    this.scene = scene;
                    var sys = scene.sys;
                    this.sceneManager = sys.game.scene;
                    this.scaleManager = sys.scale;
                    this.cameraManager = sys.cameras;
                    this.updateSystem();
                    return this;
                },
                /**
     * Set the position of where the Camera is looking within the game.
     * You can also modify the properties `Camera.scrollX` and `Camera.scrollY` directly.
     * Use this method, or the scroll properties, to move your camera around the game world.
     *
     * This does not change where the camera viewport is placed. See `setPosition` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScroll
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the Camera in the game world.
     * @param {number} [y=x] - The y coordinate of the Camera in the game world.
     *
     * @return {this} This Camera instance.
     */ setScroll: function(x, y) {
                    if (y === undefined) y = x;
                    this.scrollX = x;
                    this.scrollY = y;
                    return this;
                },
                /**
     * Set the size of the Camera viewport.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * This method sets the position and size of the Camera viewport in a single call.
     *
     * If you're trying to change where the Camera is looking at in your game, then see
     * the method `Camera.setScroll` instead. This method is for changing the viewport
     * itself, not what the camera can see.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setViewport
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} y - The top-left y coordinate of the Camera viewport.
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setViewport: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Set the zoom value of the Camera.
     *
     * Changing to a smaller value, such as 0.5, will cause the camera to 'zoom out'.
     * Changing to a larger value, such as 2, will cause the camera to 'zoom in'.
     *
     * A value of 1 means 'no zoom' and is the default.
     *
     * Changing the zoom does not impact the Camera viewport in any way, it is only applied during rendering.
     *
     * As of Phaser 3.50 you can now set the horizontal and vertical zoom values independently.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setZoom
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal zoom value of the Camera. The minimum it can be is 0.001.
     * @param {number} [y=x] - The vertical zoom value of the Camera. The minimum it can be is 0.001.
     *
     * @return {this} This Camera instance.
     */ setZoom: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    if (x === 0) x = 0.001;
                    if (y === 0) y = 0.001;
                    this.zoomX = x;
                    this.zoomY = y;
                    return this;
                },
                /**
     * Sets the mask to be applied to this Camera during rendering.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     *
     * Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Camera it will be immediately replaced.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setMask
     * @since 3.17.0
     *
     * @param {(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)} mask - The mask this Camera will use when rendering.
     * @param {boolean} [fixedPosition=true] - Should the mask translate along with the Camera, or be fixed in place and not impacted by the Cameras transform?
     *
     * @return {this} This Camera instance.
     */ setMask: function(mask, fixedPosition) {
                    if (fixedPosition === undefined) fixedPosition = true;
                    this.mask = mask;
                    this._maskCamera = fixedPosition ? this.cameraManager.default : this;
                    return this;
                },
                /**
     * Clears the mask that this Camera was using.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clearMask
     * @since 3.17.0
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Camera instance.
     */ clearMask: function(destroyMask) {
                    if (destroyMask === undefined) destroyMask = false;
                    if (destroyMask && this.mask) this.mask.destroy();
                    this.mask = null;
                    return this;
                },
                /**
     * Sets the visibility of this Camera.
     *
     * An invisible Camera will skip rendering and input tests of everything it can see.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setVisible
     * @since 3.10.0
     *
     * @param {boolean} value - The visible state of the Camera.
     *
     * @return {this} This Camera instance.
     */ /**
     * Returns an Object suitable for JSON storage containing all of the Camera viewport and rendering properties.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Cameras.Scene2D.JSONCamera} A well-formed object suitable for conversion to JSON.
     */ toJSON: function() {
                    var output = {
                        name: this.name,
                        x: this.x,
                        y: this.y,
                        width: this.width,
                        height: this.height,
                        zoom: this.zoom,
                        rotation: this.rotation,
                        roundPixels: this.roundPixels,
                        scrollX: this.scrollX,
                        scrollY: this.scrollY,
                        backgroundColor: this.backgroundColor.rgba
                    };
                    if (this.useBounds) output["bounds"] = {
                        x: this._bounds.x,
                        y: this._bounds.y,
                        width: this._bounds.width,
                        height: this._bounds.height
                    };
                    return output;
                },
                /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function() {
                //  NOOP
                },
                /**
     * Internal method called automatically when the viewport changes.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#updateSystem
     * @private
     * @since 3.12.0
     */ updateSystem: function() {
                    if (!this.scaleManager) return;
                    var custom = this._x !== 0 || this._y !== 0 || this.scaleManager.width !== this._width || this.scaleManager.height !== this._height;
                    var sceneManager = this.sceneManager;
                    if (custom && !this._customViewport) //  We need a custom viewport for this Camera
                    sceneManager.customViewports++;
                    else if (!custom && this._customViewport) //  We're turning off a custom viewport for this Camera
                    sceneManager.customViewports--;
                    this.dirty = true;
                    this._customViewport = custom;
                },
                /**
     * Destroys this Camera instance and its internal properties and references.
     * Once destroyed you cannot use this Camera again, even if re-added to a Camera Manager.
     *
     * This method is called automatically by `CameraManager.remove` if that methods `runDestroy` argument is `true`, which is the default.
     *
     * Unless you have a specific reason otherwise, always use `CameraManager.remove` and allow it to handle the camera destruction,
     * rather than calling this method directly.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    this.emit(Events.DESTROY, this);
                    this.removeAllListeners();
                    this.matrix.destroy();
                    this.culledObjects = [];
                    if (this._customViewport) //  We're turning off a custom viewport for this Camera
                    this.sceneManager.customViewports--;
                    this.renderList = [];
                    this._bounds = null;
                    this.scene = null;
                    this.scaleManager = null;
                    this.sceneManager = null;
                    this.cameraManager = null;
                },
                /**
     * The x position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.updateSystem();
                    }
                },
                /**
     * The y position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.updateSystem();
                    }
                },
                /**
     * The width of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#width
     * @type {number}
     * @since 3.0.0
     */ width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(value) {
                        this._width = value;
                        this.updateSystem();
                    }
                },
                /**
     * The height of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#height
     * @type {number}
     * @since 3.0.0
     */ height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(value) {
                        this._height = value;
                        this.updateSystem();
                    }
                },
                /**
     * The horizontal scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollX: {
                    get: function() {
                        return this._scrollX;
                    },
                    set: function(value) {
                        this._scrollX = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollY: {
                    get: function() {
                        return this._scrollY;
                    },
                    set: function(value) {
                        this._scrollY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoom
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ zoom: {
                    get: function() {
                        return (this._zoomX + this._zoomY) / 2;
                    },
                    set: function(value) {
                        this._zoomX = value;
                        this._zoomY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomX
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomX: {
                    get: function() {
                        return this._zoomX;
                    },
                    set: function(value) {
                        this._zoomX = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomY
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomY: {
                    get: function() {
                        return this._zoomY;
                    },
                    set: function(value) {
                        this._zoomY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The rotation of the Camera in radians.
     *
     * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
     * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
     *
     * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
     * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.11.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        this._rotation = value;
                        this.dirty = true;
                    }
                },
                /**
     * The horizontal position of the center of the Camera's viewport, relative to the left of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerX
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerX: {
                    get: function() {
                        return this.x + 0.5 * this.width;
                    }
                },
                /**
     * The vertical position of the center of the Camera's viewport, relative to the top of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerY
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerY: {
                    get: function() {
                        return this.y + 0.5 * this.height;
                    }
                },
                /**
     * The displayed width of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport width of 800 and a zoom of 0.5 then its display width
     * would be 1600, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a width of 800 and zoom of 2 would have a display width
     * of 400 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayWidth
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayWidth: {
                    get: function() {
                        return this.width / this.zoomX;
                    }
                },
                /**
     * The displayed height of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport height of 600 and a zoom of 0.5 then its display height
     * would be 1200, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a height of 600 and zoom of 2 would have a display height
     * of 300 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayHeight
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayHeight: {
                    get: function() {
                        return this.height / this.zoomY;
                    }
                }
            });
            module1.exports = BaseCamera;
        /***/ },
        /* 134 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Back = __webpack_require__(334);
            var Bounce = __webpack_require__(335);
            var Circular = __webpack_require__(336);
            var Cubic = __webpack_require__(337);
            var Elastic = __webpack_require__(338);
            var Expo = __webpack_require__(339);
            var Linear = __webpack_require__(340);
            var Quadratic = __webpack_require__(341);
            var Quartic = __webpack_require__(342);
            var Quintic = __webpack_require__(343);
            var Sine = __webpack_require__(344);
            var Stepped = __webpack_require__(345);
            //  EaseMap
            module1.exports = {
                Power0: Linear,
                Power1: Quadratic.Out,
                Power2: Cubic.Out,
                Power3: Quartic.Out,
                Power4: Quintic.Out,
                Linear: Linear,
                Quad: Quadratic.Out,
                Cubic: Cubic.Out,
                Quart: Quartic.Out,
                Quint: Quintic.Out,
                Sine: Sine.Out,
                Expo: Expo.Out,
                Circ: Circular.Out,
                Elastic: Elastic.Out,
                Back: Back.Out,
                Bounce: Bounce.Out,
                Stepped: Stepped,
                "Quad.easeIn": Quadratic.In,
                "Cubic.easeIn": Cubic.In,
                "Quart.easeIn": Quartic.In,
                "Quint.easeIn": Quintic.In,
                "Sine.easeIn": Sine.In,
                "Expo.easeIn": Expo.In,
                "Circ.easeIn": Circular.In,
                "Elastic.easeIn": Elastic.In,
                "Back.easeIn": Back.In,
                "Bounce.easeIn": Bounce.In,
                "Quad.easeOut": Quadratic.Out,
                "Cubic.easeOut": Cubic.Out,
                "Quart.easeOut": Quartic.Out,
                "Quint.easeOut": Quintic.Out,
                "Sine.easeOut": Sine.Out,
                "Expo.easeOut": Expo.Out,
                "Circ.easeOut": Circular.Out,
                "Elastic.easeOut": Elastic.Out,
                "Back.easeOut": Back.Out,
                "Bounce.easeOut": Bounce.Out,
                "Quad.easeInOut": Quadratic.InOut,
                "Cubic.easeInOut": Cubic.InOut,
                "Quart.easeInOut": Quartic.InOut,
                "Quint.easeInOut": Quintic.InOut,
                "Sine.easeInOut": Sine.InOut,
                "Expo.easeInOut": Expo.InOut,
                "Circ.easeInOut": Circular.InOut,
                "Elastic.easeInOut": Elastic.InOut,
                "Back.easeInOut": Back.InOut,
                "Bounce.easeInOut": Bounce.InOut
            };
        /***/ },
        /* 135 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a linear (interpolation) value over t.
 *
 * @function Phaser.Math.Linear
 * @since 3.0.0
 *
 * @param {number} p0 - The first point.
 * @param {number} p1 - The second point.
 * @param {number} t - The percentage between p0 and p1 to return, represented as a number between 0 and 1.
 *
 * @return {number} The step t% of the way between p0 and p1.
 */ var Linear = function(p0, p1, t) {
                return (p1 - p0) * t + p0;
            };
            module1.exports = Linear;
        /***/ },
        /* 136 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(105);
            /**
 * Determines the browser type and version running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.browser` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.Browser
 * @since 3.0.0
 * 
 * @property {boolean} chrome - Set to true if running in Chrome.
 * @property {boolean} edge - Set to true if running in Microsoft Edge browser.
 * @property {boolean} firefox - Set to true if running in Firefox.
 * @property {boolean} ie - Set to true if running in Internet Explorer 11 or less (not Edge).
 * @property {boolean} mobileSafari - Set to true if running in Mobile Safari.
 * @property {boolean} opera - Set to true if running in Opera.
 * @property {boolean} safari - Set to true if running in Safari.
 * @property {boolean} silk - Set to true if running in the Silk browser (as used on the Amazon Kindle)
 * @property {boolean} trident - Set to true if running a Trident version of Internet Explorer (IE11+)
 * @property {number} chromeVersion - If running in Chrome this will contain the major version number.
 * @property {number} firefoxVersion - If running in Firefox this will contain the major version number.
 * @property {number} ieVersion - If running in Internet Explorer this will contain the major version number. Beyond IE10 you should use Browser.trident and Browser.tridentVersion.
 * @property {number} safariVersion - If running in Safari this will contain the major version number.
 * @property {number} tridentVersion - If running in Internet Explorer 11 this will contain the major version number. See {@link http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx}
 */ var Browser = {
                chrome: false,
                chromeVersion: 0,
                edge: false,
                firefox: false,
                firefoxVersion: 0,
                ie: false,
                ieVersion: 0,
                mobileSafari: false,
                opera: false,
                safari: false,
                safariVersion: 0,
                silk: false,
                trident: false,
                tridentVersion: 0
            };
            function init() {
                var ua = navigator.userAgent;
                if (/Edge\/\d+/.test(ua)) Browser.edge = true;
                else if (/Chrome\/(\d+)/.test(ua) && !OS.windowsPhone) {
                    Browser.chrome = true;
                    Browser.chromeVersion = parseInt(RegExp.$1, 10);
                } else if (/Firefox\D+(\d+)/.test(ua)) {
                    Browser.firefox = true;
                    Browser.firefoxVersion = parseInt(RegExp.$1, 10);
                } else if (/AppleWebKit/.test(ua) && OS.iOS) Browser.mobileSafari = true;
                else if (/MSIE (\d+\.\d+);/.test(ua)) {
                    Browser.ie = true;
                    Browser.ieVersion = parseInt(RegExp.$1, 10);
                } else if (/Opera/.test(ua)) Browser.opera = true;
                else if (/Safari/.test(ua) && !OS.windowsPhone) Browser.safari = true;
                else if (/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(ua)) {
                    Browser.ie = true;
                    Browser.trident = true;
                    Browser.tridentVersion = parseInt(RegExp.$1, 10);
                    Browser.ieVersion = parseInt(RegExp.$3, 10);
                }
                //  Silk gets its own if clause because its ua also contains 'Safari'
                if (/Silk/.test(ua)) Browser.silk = true;
                return Browser;
            }
            module1.exports = init();
        /***/ },
        /* 137 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a random floating point number between the two given bounds, minimum inclusive, maximum exclusive.
 *
 * @function Phaser.Math.FloatBetween
 * @since 3.0.0
 *
 * @param {number} min - The lower bound for the float, inclusive.
 * @param {number} max - The upper bound for the float exclusive.
 *
 * @return {number} A random float within the given range.
 */ var FloatBetween = function(min, max) {
                return Math.random() * (max - min) + min;
            };
            module1.exports = FloatBetween;
        /***/ },
        /* 138 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given `width` and `height` are a power of two.
 * Useful for checking texture dimensions.
 *
 * @function Phaser.Math.Pow2.IsSize
 * @since 3.0.0
 *
 * @param {number} width - The width.
 * @param {number} height - The height.
 *
 * @return {boolean} `true` if `width` and `height` are a power of two, otherwise `false`.
 */ var IsSizePowerOfTwo = function(width, height) {
                return width > 0 && (width & width - 1) === 0 && height > 0 && (height & height - 1) === 0;
            };
            module1.exports = IsSizePowerOfTwo;
        /***/ },
        /* 139 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using ceil.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `15`.
 * As will `14` snap to `15`... but `16` will snap to `20`.
 *
 * @function Phaser.Math.Snap.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapCeil = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.ceil(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapCeil;
        /***/ },
        /* 140 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A representation of a vector in 4D space.
 *
 * A four-component vector.
 *
 * @class Vector4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 * @param {number} [w] - The w component.
 */ var Vector4 = new Class({
                initialize: function Vector4(x, y, z, w) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector4#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector4#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector4#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                    /**
         * The w component of this Vector.
         *
         * @name Phaser.Math.Vector4#w
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.w = 0;
                    if (typeof x === "object") {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                        this.w = x.w || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                        this.w = w || 0;
                    }
                },
                /**
     * Make a clone of this Vector4.
     *
     * @method Phaser.Math.Vector4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} A clone of this Vector4.
     */ clone: function() {
                    return new Vector4(this.x, this.y, this.z, this.w);
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ copy: function(src) {
                    this.x = src.x;
                    this.y = src.y;
                    this.z = src.z || 0;
                    this.w = src.w || 0;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict quality check against each Vector's components.
     *
     * @method Phaser.Math.Vector4#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The vector to check equality with.
     *
     * @return {boolean} A boolean indicating whether the two Vectors are equal or not.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y && this.z === v.z && this.w === v.w;
                },
                /**
     * Set the `x`, `y`, `z` and `w` components of the this Vector to the given `x`, `y`, `z` and `w` values.
     *
     * @method Phaser.Math.Vector4#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y, z and w components.
     * @param {number} y - The y value to set for this Vector.
     * @param {number} z - The z value to set for this Vector.
     * @param {number} w - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ set: function(x, y, z, w) {
                    if (typeof x === "object") {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                        this.w = x.w || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                        this.w = w || 0;
                    }
                    return this;
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector4#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ add: function(v) {
                    this.x += v.x;
                    this.y += v.y;
                    this.z += v.z || 0;
                    this.w += v.w || 0;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector4#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ subtract: function(v) {
                    this.x -= v.x;
                    this.y -= v.y;
                    this.z -= v.z || 0;
                    this.w -= v.w || 0;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector4#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ scale: function(scale) {
                    this.x *= scale;
                    this.y *= scale;
                    this.z *= scale;
                    this.w *= scale;
                    return this;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector4#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return Math.sqrt(x * x + y * y + z * z + w * w);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector4#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return x * x + y * y + z * z + w * w;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector4#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var len = x * x + y * y + z * z + w * w;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                        this.z = z * len;
                        this.w = w * len;
                    }
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to dot product with this Vector4.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector4#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    this.x = ax + t * (v.x - ax);
                    this.y = ay + t * (v.y - ay);
                    this.z = az + t * (v.z - az);
                    this.w = aw + t * (v.w - aw);
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ multiply: function(v) {
                    this.x *= v.x;
                    this.y *= v.y;
                    this.z *= v.z || 1;
                    this.w *= v.w || 1;
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ divide: function(v) {
                    this.x /= v.x;
                    this.y /= v.y;
                    this.z /= v.z || 1;
                    this.w /= v.w || 1;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    var dw = v.w - this.w || 0;
                    return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector4#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    var dw = v.w - this.w || 0;
                    return dx * dx + dy * dy + dz * dz + dw * dw;
                },
                /**
     * Negate the `x`, `y`, `z` and `w` components of this Vector.
     *
     * @method Phaser.Math.Vector4#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    this.z = -this.z;
                    this.w = -this.w;
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector4#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector4 with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
                    this.y = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
                    this.z = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
                    this.w = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
                    return this;
                },
                /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector4#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformQuat: function(q) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var qx = q.x;
                    var qy = q.y;
                    var qz = q.z;
                    var qw = q.w;
                    // calculate quat * vec
                    var ix = qw * x + qy * z - qz * y;
                    var iy = qw * y + qz * x - qx * z;
                    var iz = qw * z + qx * y - qy * x;
                    var iw = -qx * x - qy * y - qz * z;
                    // calculate result * inverse quat
                    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                    return this;
                },
                /**
     * Make this Vector the zero vector (0, 0, 0, 0).
     *
     * @method Phaser.Math.Vector4#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    this.z = 0;
                    this.w = 0;
                    return this;
                }
            });
            Vector4.prototype.sub = Vector4.prototype.subtract;
            Vector4.prototype.mul = Vector4.prototype.multiply;
            Vector4.prototype.div = Vector4.prototype.divide;
            Vector4.prototype.dist = Vector4.prototype.distance;
            Vector4.prototype.distSq = Vector4.prototype.distanceSq;
            Vector4.prototype.len = Vector4.prototype.length;
            Vector4.prototype.lenSq = Vector4.prototype.lengthSq;
            module1.exports = Vector4;
        /***/ },
        /* 141 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(91);
            /**
 * @classdesc
 * A Render Target encapsulates a WebGL framebuffer and the WebGL Texture that displays it.
 *
 * Instances of this class are typically created by, and belong to WebGL Pipelines, however
 * other Game Objects and classes can take advantage of Render Targets as well.
 *
 * @class RenderTarget
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGLRenderer.
 * @param {number} width - The width of this Render Target.
 * @param {number} height - The height of this Render Target.
 * @param {number} [scale=1] - A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
 * @param {number} [minFilter=0] - The minFilter mode of the texture when created. 0 is `LINEAR`, 1 is `NEAREST`.
 * @param {boolean} [autoClear=true] - Automatically clear this framebuffer when bound?
 * @param {boolean} [autoResize=false] - Automatically resize this Render Target if the WebGL Renderer resizes?
 */ var RenderTarget = new Class({
                initialize: function RenderTarget(renderer, width, height, scale, minFilter, autoClear, autoResize) {
                    if (scale === undefined) scale = 1;
                    if (minFilter === undefined) minFilter = 0;
                    if (autoClear === undefined) autoClear = true;
                    if (autoResize === undefined) autoResize = false;
                    /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                    /**
         * The WebGLFramebuffer of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#framebuffer
         * @type {WebGLFramebuffer}
         * @since 3.50.0
         */ this.framebuffer = null;
                    /**
         * The WebGLTexture of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#texture
         * @type {WebGLTexture}
         * @since 3.50.0
         */ this.texture = null;
                    /**
         * The width of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#width
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.width = 0;
                    /**
         * The height of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#height
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.height = 0;
                    /**
         * A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
         *
         * A value of 1 matches it. 0.5 makes the Render Target half the size of the renderer, etc.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#scale
         * @type {number}
         * @since 3.50.0
         */ this.scale = scale;
                    /**
         * The minFilter mode of the texture. 0 is `LINEAR`, 1 is `NEAREST`.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#minFilter
         * @type {number}
         * @since 3.50.0
         */ this.minFilter = minFilter;
                    /**
         * Controls if this Render Target is automatically cleared (via `gl.COLOR_BUFFER_BIT`)
         * during the `RenderTarget.bind` method.
         *
         * If you need more control over how, or if, the target is cleared, you can disable
         * this via the config on creation, or even toggle it directly at runtime.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoClear
         * @type {boolean}
         * @since 3.50.0
         */ this.autoClear = autoClear;
                    /**
         * Does this Render Target automatically resize when the WebGL Renderer does?
         *
         * Modify this property via the `setAutoResize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoResize
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.autoResize = false;
                    this.resize(width, height);
                    if (autoResize) this.setAutoResize(true);
                },
                /**
     * Sets if this Render Target should automatically resize when the WebGL Renderer
     * emits a resize event.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#setAutoResize
     * @since 3.50.0
     *
     * @param {boolean} autoResize - Automatically resize this Render Target when the WebGL Renderer resizes?
     *
     * @return {this} This RenderTarget instance.
     */ setAutoResize: function(autoResize) {
                    if (autoResize && !this.autoResize) {
                        this.renderer.on(Events.RESIZE, this.resize, this);
                        this.autoResize = true;
                    } else if (!autoResize && this.autoResize) {
                        this.renderer.off(Events.RESIZE, this.resize, this);
                        this.autoResize = false;
                    }
                    return this;
                },
                /**
     * Resizes this Render Target.
     *
     * Deletes both the frame buffer and texture, if they exist and then re-creates
     * them using the new sizes.
     *
     * This method is called automatically by the pipeline during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#resize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this Render Target.
     * @param {number} height - The new height of this Render Target.
     *
     * @return {this} This RenderTarget instance.
     */ resize: function(width, height) {
                    var scaledWidth = width * this.scale;
                    var scaledHeight = height * this.scale;
                    if (scaledWidth !== this.width || scaledHeight !== this.height) {
                        var renderer = this.renderer;
                        renderer.deleteFramebuffer(this.framebuffer);
                        renderer.deleteTexture(this.texture);
                        width *= this.scale;
                        height *= this.scale;
                        width = Math.round(width);
                        height = Math.round(height);
                        if (width <= 0) width = 1;
                        if (height <= 0) height = 1;
                        this.texture = renderer.createTextureFromSource(null, width, height, this.minFilter);
                        this.framebuffer = renderer.createFramebuffer(width, height, this.texture, false);
                        this.width = width;
                        this.height = height;
                    }
                    return this;
                },
                /**
     * Pushes this Render Target as the current frame buffer of the renderer.
     *
     * If `autoClear` is set, then clears the texture.
     *
     * If `adjustViewport` is `true` then it will flush the renderer and then adjust the GL viewport.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#bind
     * @since 3.50.0
     *
     * @param {boolean} [adjustViewport=false] - Adjust the GL viewport by calling `RenderTarget.adjustViewport` ?
     * @param {number} [width] - Optional new width of this Render Target.
     * @param {number} [height] - Optional new height of this Render Target.
     */ bind: function(adjustViewport, width, height) {
                    if (adjustViewport === undefined) adjustViewport = false;
                    if (adjustViewport) this.renderer.flush();
                    if (width && height) this.resize(width, height);
                    this.renderer.pushFramebuffer(this.framebuffer, false, false, false);
                    if (adjustViewport) this.adjustViewport();
                    if (this.autoClear) {
                        var gl = this.renderer.gl;
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                },
                /**
     * Adjusts the GL viewport to match the width and height of this Render Target.
     *
     * Also disables `SCISSOR_TEST`.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#adjustViewport
     * @since 3.50.0
     */ adjustViewport: function() {
                    var gl = this.renderer.gl;
                    gl.viewport(0, 0, this.width, this.height);
                    gl.disable(gl.SCISSOR_TEST);
                },
                /**
     * Clears this Render Target.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#clear
     * @since 3.50.0
     */ clear: function() {
                    var renderer = this.renderer;
                    var gl = renderer.gl;
                    renderer.pushFramebuffer(this.framebuffer);
                    gl.disable(gl.SCISSOR_TEST);
                    gl.clearColor(0, 0, 0, 0);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    renderer.popFramebuffer();
                    renderer.resetScissor();
                },
                /**
     * Unbinds this Render Target and optionally flushes the WebGL Renderer first.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#unbind
     * @since 3.50.0
     *
     * @param {boolean} [flush=false] - Flush the WebGL Renderer before unbinding?
     *
     * @return {WebGLFramebuffer} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ unbind: function(flush) {
                    if (flush === undefined) flush = false;
                    var renderer = this.renderer;
                    if (flush) renderer.flush();
                    return renderer.popFramebuffer();
                },
                /**
     * Removes all external references from this class and deletes the
     * WebGL framebuffer and texture instances.
     *
     * Does not remove this Render Target from the parent pipeline.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#destroy
     * @since 3.50.0
     */ destroy: function() {
                    var renderer = this.renderer;
                    renderer.deleteFramebuffer(this.framebuffer);
                    renderer.deleteTexture(this.texture);
                    renderer.off(Events.RESIZE, this.resize, this);
                    this.renderer = null;
                    this.framebuffer = null;
                    this.texture = null;
                }
            });
            module1.exports = RenderTarget;
        /***/ },
        /* 142 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given element to the DOM. If a parent is provided the element is added as a child of the parent, providing it was able to access it.
 * If no parent was given it falls back to using `document.body`.
 *
 * @function Phaser.DOM.AddToDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The element to be added to the DOM. Usually a Canvas object.
 * @param {(string|HTMLElement)} [parent] - The parent in which to add the element. Can be a string which is passed to `getElementById` or an actual DOM object.
 *
 * @return {HTMLElement} The element that was added to the DOM.
 */ var AddToDOM = function(element, parent) {
                var target;
                if (parent) {
                    if (typeof parent === "string") //  Hopefully an element ID
                    target = document.getElementById(parent);
                    else if (typeof parent === "object" && parent.nodeType === 1) //  Quick test for a HTMLElement
                    target = parent;
                } else if (element.parentElement || parent === null) return element;
                //  Fallback, covers an invalid ID and a non HTMLElement object
                if (!target) target = document.body;
                target.appendChild(element);
                return element;
            };
            module1.exports = AddToDOM;
        /***/ },
        /* 143 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Keyboard Codes.
 *
 * @namespace Phaser.Input.Keyboard.KeyCodes
 * @memberof Phaser.Input.Keyboard
 * @since 3.0.0
 */ var KeyCodes = {
                /**
     * The BACKSPACE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACKSPACE
     * @type {number}
     * @since 3.0.0
     */ BACKSPACE: 8,
                /**
     * The TAB key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.TAB
     * @type {number}
     * @since 3.0.0
     */ TAB: 9,
                /**
     * The ENTER key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ENTER
     * @type {number}
     * @since 3.0.0
     */ ENTER: 13,
                /**
     * The SHIFT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SHIFT
     * @type {number}
     * @since 3.0.0
     */ SHIFT: 16,
                /**
     * The CTRL key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CTRL
     * @type {number}
     * @since 3.0.0
     */ CTRL: 17,
                /**
     * The ALT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ALT
     * @type {number}
     * @since 3.0.0
     */ ALT: 18,
                /**
     * The PAUSE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAUSE
     * @type {number}
     * @since 3.0.0
     */ PAUSE: 19,
                /**
     * The CAPS_LOCK key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CAPS_LOCK
     * @type {number}
     * @since 3.0.0
     */ CAPS_LOCK: 20,
                /**
     * The ESC key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ESC
     * @type {number}
     * @since 3.0.0
     */ ESC: 27,
                /**
     * The SPACE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SPACE
     * @type {number}
     * @since 3.0.0
     */ SPACE: 32,
                /**
     * The PAGE_UP key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_UP
     * @type {number}
     * @since 3.0.0
     */ PAGE_UP: 33,
                /**
     * The PAGE_DOWN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_DOWN
     * @type {number}
     * @since 3.0.0
     */ PAGE_DOWN: 34,
                /**
     * The END key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.END
     * @type {number}
     * @since 3.0.0
     */ END: 35,
                /**
     * The HOME key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.HOME
     * @type {number}
     * @since 3.0.0
     */ HOME: 36,
                /**
     * The LEFT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.LEFT
     * @type {number}
     * @since 3.0.0
     */ LEFT: 37,
                /**
     * The UP key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.UP
     * @type {number}
     * @since 3.0.0
     */ UP: 38,
                /**
     * The RIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.RIGHT
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 39,
                /**
     * The DOWN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.DOWN
     * @type {number}
     * @since 3.0.0
     */ DOWN: 40,
                /**
     * The PRINT_SCREEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PRINT_SCREEN
     * @type {number}
     * @since 3.0.0
     */ PRINT_SCREEN: 42,
                /**
     * The INSERT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.INSERT
     * @type {number}
     * @since 3.0.0
     */ INSERT: 45,
                /**
     * The DELETE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.DELETE
     * @type {number}
     * @since 3.0.0
     */ DELETE: 46,
                /**
     * The ZERO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ZERO
     * @type {number}
     * @since 3.0.0
     */ ZERO: 48,
                /**
     * The ONE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ONE
     * @type {number}
     * @since 3.0.0
     */ ONE: 49,
                /**
     * The TWO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.TWO
     * @type {number}
     * @since 3.0.0
     */ TWO: 50,
                /**
     * The THREE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.THREE
     * @type {number}
     * @since 3.0.0
     */ THREE: 51,
                /**
     * The FOUR key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FOUR
     * @type {number}
     * @since 3.0.0
     */ FOUR: 52,
                /**
     * The FIVE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FIVE
     * @type {number}
     * @since 3.0.0
     */ FIVE: 53,
                /**
     * The SIX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SIX
     * @type {number}
     * @since 3.0.0
     */ SIX: 54,
                /**
     * The SEVEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEVEN
     * @type {number}
     * @since 3.0.0
     */ SEVEN: 55,
                /**
     * The EIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.EIGHT
     * @type {number}
     * @since 3.0.0
     */ EIGHT: 56,
                /**
     * The NINE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NINE
     * @type {number}
     * @since 3.0.0
     */ NINE: 57,
                /**
     * The NUMPAD_ZERO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ZERO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ZERO: 96,
                /**
     * The NUMPAD_ONE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ONE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ONE: 97,
                /**
     * The NUMPAD_TWO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_TWO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_TWO: 98,
                /**
     * The NUMPAD_THREE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_THREE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_THREE: 99,
                /**
     * The NUMPAD_FOUR key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FOUR
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FOUR: 100,
                /**
     * The NUMPAD_FIVE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FIVE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FIVE: 101,
                /**
     * The NUMPAD_SIX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SIX
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SIX: 102,
                /**
     * The NUMPAD_SEVEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SEVEN
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SEVEN: 103,
                /**
     * The NUMPAD_EIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_EIGHT
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_EIGHT: 104,
                /**
     * The NUMPAD_NINE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_NINE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_NINE: 105,
                /**
     * The Numpad Addition (+) key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ADD
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_ADD: 107,
                /**
     * The Numpad Subtraction (-) key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SUBTRACT
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_SUBTRACT: 109,
                /**
     * The A key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.A
     * @type {number}
     * @since 3.0.0
     */ A: 65,
                /**
     * The B key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.B
     * @type {number}
     * @since 3.0.0
     */ B: 66,
                /**
     * The C key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.C
     * @type {number}
     * @since 3.0.0
     */ C: 67,
                /**
     * The D key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.D
     * @type {number}
     * @since 3.0.0
     */ D: 68,
                /**
     * The E key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.E
     * @type {number}
     * @since 3.0.0
     */ E: 69,
                /**
     * The F key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F
     * @type {number}
     * @since 3.0.0
     */ F: 70,
                /**
     * The G key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.G
     * @type {number}
     * @since 3.0.0
     */ G: 71,
                /**
     * The H key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.H
     * @type {number}
     * @since 3.0.0
     */ H: 72,
                /**
     * The I key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.I
     * @type {number}
     * @since 3.0.0
     */ I: 73,
                /**
     * The J key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.J
     * @type {number}
     * @since 3.0.0
     */ J: 74,
                /**
     * The K key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.K
     * @type {number}
     * @since 3.0.0
     */ K: 75,
                /**
     * The L key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.L
     * @type {number}
     * @since 3.0.0
     */ L: 76,
                /**
     * The M key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.M
     * @type {number}
     * @since 3.0.0
     */ M: 77,
                /**
     * The N key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.N
     * @type {number}
     * @since 3.0.0
     */ N: 78,
                /**
     * The O key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.O
     * @type {number}
     * @since 3.0.0
     */ O: 79,
                /**
     * The P key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.P
     * @type {number}
     * @since 3.0.0
     */ P: 80,
                /**
     * The Q key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Q
     * @type {number}
     * @since 3.0.0
     */ Q: 81,
                /**
     * The R key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.R
     * @type {number}
     * @since 3.0.0
     */ R: 82,
                /**
     * The S key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.S
     * @type {number}
     * @since 3.0.0
     */ S: 83,
                /**
     * The T key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.T
     * @type {number}
     * @since 3.0.0
     */ T: 84,
                /**
     * The U key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.U
     * @type {number}
     * @since 3.0.0
     */ U: 85,
                /**
     * The V key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.V
     * @type {number}
     * @since 3.0.0
     */ V: 86,
                /**
     * The W key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.W
     * @type {number}
     * @since 3.0.0
     */ W: 87,
                /**
     * The X key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.X
     * @type {number}
     * @since 3.0.0
     */ X: 88,
                /**
     * The Y key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Y
     * @type {number}
     * @since 3.0.0
     */ Y: 89,
                /**
     * The Z key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Z
     * @type {number}
     * @since 3.0.0
     */ Z: 90,
                /**
     * The F1 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F1
     * @type {number}
     * @since 3.0.0
     */ F1: 112,
                /**
     * The F2 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F2
     * @type {number}
     * @since 3.0.0
     */ F2: 113,
                /**
     * The F3 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F3
     * @type {number}
     * @since 3.0.0
     */ F3: 114,
                /**
     * The F4 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F4
     * @type {number}
     * @since 3.0.0
     */ F4: 115,
                /**
     * The F5 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F5
     * @type {number}
     * @since 3.0.0
     */ F5: 116,
                /**
     * The F6 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F6
     * @type {number}
     * @since 3.0.0
     */ F6: 117,
                /**
     * The F7 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F7
     * @type {number}
     * @since 3.0.0
     */ F7: 118,
                /**
     * The F8 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F8
     * @type {number}
     * @since 3.0.0
     */ F8: 119,
                /**
     * The F9 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F9
     * @type {number}
     * @since 3.0.0
     */ F9: 120,
                /**
     * The F10 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F10
     * @type {number}
     * @since 3.0.0
     */ F10: 121,
                /**
     * The F11 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F11
     * @type {number}
     * @since 3.0.0
     */ F11: 122,
                /**
     * The F12 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F12
     * @type {number}
     * @since 3.0.0
     */ F12: 123,
                /**
     * The SEMICOLON key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON: 186,
                /**
     * The PLUS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PLUS
     * @type {number}
     * @since 3.0.0
     */ PLUS: 187,
                /**
     * The COMMA key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA
     * @type {number}
     * @since 3.0.0
     */ COMMA: 188,
                /**
     * The MINUS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.MINUS
     * @type {number}
     * @since 3.0.0
     */ MINUS: 189,
                /**
     * The PERIOD key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PERIOD
     * @type {number}
     * @since 3.0.0
     */ PERIOD: 190,
                /**
     * The FORWARD_SLASH key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FORWARD_SLASH
     * @type {number}
     * @since 3.0.0
     */ FORWARD_SLASH: 191,
                /**
     * The BACK_SLASH key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACK_SLASH
     * @type {number}
     * @since 3.0.0
     */ BACK_SLASH: 220,
                /**
     * The QUOTES key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.QUOTES
     * @type {number}
     * @since 3.0.0
     */ QUOTES: 222,
                /**
     * The BACKTICK key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACKTICK
     * @type {number}
     * @since 3.0.0
     */ BACKTICK: 192,
                /**
     * The OPEN_BRACKET key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.OPEN_BRACKET
     * @type {number}
     * @since 3.0.0
     */ OPEN_BRACKET: 219,
                /**
     * The CLOSED_BRACKET key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CLOSED_BRACKET
     * @type {number}
     * @since 3.0.0
     */ CLOSED_BRACKET: 221,
                /**
     * The SEMICOLON_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON_FIREFOX: 59,
                /**
     * The COLON key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COLON
     * @type {number}
     * @since 3.0.0
     */ COLON: 58,
                /**
     * The COMMA_FIREFOX_WINDOWS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX_WINDOWS
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX_WINDOWS: 60,
                /**
     * The COMMA_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX: 62,
                /**
     * The BRACKET_RIGHT_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_RIGHT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_RIGHT_FIREFOX: 174,
                /**
     * The BRACKET_LEFT_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_LEFT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_LEFT_FIREFOX: 175
            };
            module1.exports = KeyCodes;
        /***/ },
        /* 144 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Scene consts.
 * 
 * @ignore
 */ var CONST = {
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.PENDING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PENDING: 0,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.INIT
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ INIT: 1,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.START
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ START: 2,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.LOADING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ LOADING: 3,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.CREATING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ CREATING: 4,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.RUNNING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ RUNNING: 5,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.PAUSED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PAUSED: 6,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.SLEEPING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SLEEPING: 7,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.SHUTDOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SHUTDOWN: 8,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.DESTROYED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ DESTROYED: 9
            };
            module1.exports = CONST;
        /***/ },
        /* 145 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clone = __webpack_require__(77);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(70);
            var GameEvents = __webpack_require__(22);
            var NOOP = __webpack_require__(1);
            var GetAll = __webpack_require__(207);
            var GetFirst = __webpack_require__(428);
            /**
 * @classdesc
 * Base class for other Sound Manager classes.
 *
 * @class BaseSoundManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @see Phaser.Sound.HTML5AudioSoundManager
 * @see Phaser.Sound.NoAudioSoundManager
 * @see Phaser.Sound.WebAudioSoundManager
 */ var BaseSoundManager = new Class({
                Extends: EventEmitter,
                initialize: function BaseSoundManager(game) {
                    EventEmitter.call(this);
                    /**
         * Local reference to game.
         *
         * @name Phaser.Sound.BaseSoundManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * Local reference to the JSON Cache, as used by Audio Sprites.
         *
         * @name Phaser.Sound.BaseSoundManager#jsonCache
         * @type {Phaser.Cache.BaseCache}
         * @readonly
         * @since 3.7.0
         */ this.jsonCache = game.cache.json;
                    /**
         * An array containing all added sounds.
         *
         * @name Phaser.Sound.BaseSoundManager#sounds
         * @type {Phaser.Sound.BaseSound[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.sounds = [];
                    /**
         * Global mute setting.
         *
         * @name Phaser.Sound.BaseSoundManager#mute
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.mute = false;
                    /**
         * Global volume setting.
         *
         * @name Phaser.Sound.BaseSoundManager#volume
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.volume = 1;
                    /**
         * Flag indicating if sounds should be paused when game looses focus,
         * for instance when user switches to another tab/program/app.
         *
         * @name Phaser.Sound.BaseSoundManager#pauseOnBlur
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.pauseOnBlur = true;
                    /**
         * Property that actually holds the value of global playback rate.
         *
         * @name Phaser.Sound.BaseSoundManager#_rate
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._rate = 1;
                    /**
         * Property that actually holds the value of global detune.
         *
         * @name Phaser.Sound.BaseSoundManager#_detune
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._detune = 0;
                    /**
         * Mobile devices require sounds to be triggered from an explicit user action,
         * such as a tap, before any sound can be loaded/played on a web page.
         * Set to true if the audio system is currently locked awaiting user interaction.
         *
         * @name Phaser.Sound.BaseSoundManager#locked
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.locked = this.locked || false;
                    /**
         * Flag used internally for handling when the audio system
         * has been unlocked, if there ever was a need for it.
         *
         * @name Phaser.Sound.BaseSoundManager#unlocked
         * @type {boolean}
         * @default false
         * @private
         * @since 3.0.0
         */ this.unlocked = false;
                    game.events.on(GameEvents.BLUR, this.onGameBlur, this);
                    game.events.on(GameEvents.FOCUS, this.onGameFocus, this);
                    game.events.on(GameEvents.PRE_STEP, this.update, this);
                    game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.BaseSoundManager#add
     * @override
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.BaseSound} The new sound instance.
     */ add: NOOP,
                /**
     * Adds a new audio sprite sound into the sound manager.
     * Audio Sprites are a combination of audio files and a JSON configuration.
     * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
     *
     * @method Phaser.Sound.BaseSoundManager#addAudioSprite
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {(Phaser.Sound.HTML5AudioSound|Phaser.Sound.WebAudioSound)} The new audio sprite sound instance.
     */ addAudioSprite: function(key, config) {
                    if (config === undefined) config = {};
                    var sound = this.add(key, config);
                    sound.spritemap = this.jsonCache.get(key).spritemap;
                    for(var markerName in sound.spritemap){
                        if (!sound.spritemap.hasOwnProperty(markerName)) continue;
                        var markerConfig = Clone(config);
                        var marker = sound.spritemap[markerName];
                        markerConfig.loop = marker.hasOwnProperty("loop") ? marker.loop : false;
                        sound.addMarker({
                            name: markerName,
                            start: marker.start,
                            duration: marker.end - marker.start,
                            config: markerConfig
                        });
                    }
                    return sound;
                },
                /**
     * Gets the first sound in the manager matching the given key, if any.
     *
     * @method Phaser.Sound.BaseSoundManager#get
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {?Phaser.Sound.BaseSound} - The sound, or null.
     */ get: function(key) {
                    return GetFirst(this.sounds, "key", key);
                },
                /**
     * Gets any sounds in the manager matching the given key.
     *
     * @method Phaser.Sound.BaseSoundManager#getAll
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {Phaser.Sound.BaseSound[]} - The sounds, or an empty array.
     */ getAll: function(key) {
                    return GetAll(this.sounds, "key", key);
                },
                /**
     * Adds a new sound to the sound manager and plays it.
     * The sound will be automatically removed (destroyed) once playback ends.
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#play
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {(Phaser.Types.Sound.SoundConfig|Phaser.Types.Sound.SoundMarker)} [extra] - An optional additional object containing settings to be applied to the sound. It could be either config or marker object.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(key, extra) {
                    var sound = this.add(key);
                    sound.once(Events.COMPLETE, sound.destroy, sound);
                    if (extra) {
                        if (extra.name) {
                            sound.addMarker(extra);
                            return sound.play(extra.name);
                        } else return sound.play(extra);
                    } else return sound.play();
                },
                /**
     * Adds a new audio sprite sound to the sound manager and plays it.
     * The sprite will be automatically removed (destroyed) once playback ends.
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#playAudioSprite
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {string} spriteName - The name of the sound sprite to play.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {boolean} Whether the audio sprite sound started playing successfully.
     */ playAudioSprite: function(key, spriteName, config) {
                    var sound = this.addAudioSprite(key);
                    sound.once(Events.COMPLETE, sound.destroy, sound);
                    return sound.play(spriteName, config);
                },
                /**
     * Removes a sound from the sound manager.
     * The removed sound is destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#remove
     * @since 3.0.0
     *
     * @param {Phaser.Sound.BaseSound} sound - The sound object to remove.
     *
     * @return {boolean} True if the sound was removed successfully, otherwise false.
     */ remove: function(sound) {
                    var index = this.sounds.indexOf(sound);
                    if (index !== -1) {
                        sound.destroy();
                        this.sounds.splice(index, 1);
                        return true;
                    }
                    return false;
                },
                /**
     * Removes all sounds from the manager, destroying the sounds.
     *
     * @method Phaser.Sound.BaseSoundManager#removeAll
     * @since 3.23.0
     */ removeAll: function() {
                    this.sounds.forEach(function(sound) {
                        sound.destroy();
                    });
                    this.sounds.length = 0;
                },
                /**
     * Removes all sounds from the sound manager that have an asset key matching the given value.
     * The removed sounds are destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#removeByKey
     * @since 3.0.0
     *
     * @param {string} key - The key to match when removing sound objects.
     *
     * @return {number} The number of matching sound objects that were removed.
     */ removeByKey: function(key) {
                    var removed = 0;
                    for(var i = this.sounds.length - 1; i >= 0; i--){
                        var sound = this.sounds[i];
                        if (sound.key === key) {
                            sound.destroy();
                            this.sounds.splice(i, 1);
                            removed++;
                        }
                    }
                    return removed;
                },
                /**
     * Pauses all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#pauseAll
     * @fires Phaser.Sound.Events#PAUSE_ALL
     * @since 3.0.0
     */ pauseAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.pause();
                    });
                    this.emit(Events.PAUSE_ALL, this);
                },
                /**
     * Resumes all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#resumeAll
     * @fires Phaser.Sound.Events#RESUME_ALL
     * @since 3.0.0
     */ resumeAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.resume();
                    });
                    this.emit(Events.RESUME_ALL, this);
                },
                /**
     * Stops all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#stopAll
     * @fires Phaser.Sound.Events#STOP_ALL
     * @since 3.0.0
     */ stopAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.stop();
                    });
                    this.emit(Events.STOP_ALL, this);
                },
                /**
     * Stops any sounds matching the given key.
     *
     * @method Phaser.Sound.BaseSoundManager#stopByKey
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {number} - How many sounds were stopped.
     */ stopByKey: function(key) {
                    var stopped = 0;
                    this.getAll(key).forEach(function(sound) {
                        if (sound.stop()) stopped++;
                    });
                    return stopped;
                },
                /**
     * Method used internally for unlocking audio playback on devices that
     * require user interaction before any sound can be played on a web page.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.BaseSoundManager#unlock
     * @override
     * @protected
     * @since 3.0.0
     */ unlock: NOOP,
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onBlur
     * @override
     * @protected
     * @since 3.0.0
     */ onBlur: NOOP,
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onFocus
     * @override
     * @protected
     * @since 3.0.0
     */ onFocus: NOOP,
                /**
     * Internal handler for Phaser.Core.Events#BLUR.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameBlur
     * @private
     * @since 3.23.0
     */ onGameBlur: function() {
                    if (this.pauseOnBlur) this.onBlur();
                },
                /**
     * Internal handler for Phaser.Core.Events#FOCUS.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameFocus
     * @private
     * @since 3.23.0
     */ onGameFocus: function() {
                    if (this.pauseOnBlur) this.onFocus();
                },
                /**
     * Update method called on every game step.
     * Removes destroyed sounds and updates every active sound in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#update
     * @protected
     * @fires Phaser.Sound.Events#UNLOCKED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.unlocked) {
                        this.unlocked = false;
                        this.locked = false;
                        this.emit(Events.UNLOCKED, this);
                    }
                    for(var i = this.sounds.length - 1; i >= 0; i--)if (this.sounds[i].pendingRemove) this.sounds.splice(i, 1);
                    this.sounds.forEach(function(sound) {
                        sound.update(time, delta);
                    });
                },
                /**
     * Destroys all the sounds in the game and all associated events.
     *
     * @method Phaser.Sound.BaseSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.game.events.off(GameEvents.BLUR, this.onGameBlur, this);
                    this.game.events.off(GameEvents.FOCUS, this.onGameFocus, this);
                    this.game.events.off(GameEvents.PRE_STEP, this.update, this);
                    this.removeAllListeners();
                    this.removeAll();
                    this.sounds.length = 0;
                    this.sounds = null;
                    this.game = null;
                },
                /**
     * Method used internally for iterating only over active sounds and skipping sounds that are marked for removal.
     *
     * @method Phaser.Sound.BaseSoundManager#forEachActiveSound
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.EachActiveSoundCallback} callback - Callback function. (manager: Phaser.Sound.BaseSoundManager, sound: Phaser.Sound.BaseSound, index: number, sounds: Phaser.Manager.BaseSound[]) => void
     * @param {*} [scope] - Callback context.
     */ forEachActiveSound: function(callback, scope) {
                    var _this = this;
                    this.sounds.forEach(function(sound, index) {
                        if (sound && !sound.pendingRemove) callback.call(scope || _this, sound, index, _this.sounds);
                    });
                },
                /**
     * Sets the global playback rate at which all the sounds will be played.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.BaseSoundManager#setRate
     * @fires Phaser.Sound.Events#GLOBAL_RATE
     * @since 3.3.0
     *
     * @param {number} value - Global playback rate at which all the sounds will be played.
     *
     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * Global playback rate at which all the sounds will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audio's playback speed.
     *
     * @name Phaser.Sound.BaseSoundManager#rate
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this._rate;
                    },
                    set: function(value) {
                        this._rate = value;
                        this.forEachActiveSound(function(sound) {
                            sound.calculateRate();
                        });
                        this.emit(Events.GLOBAL_RATE, this, value);
                    }
                },
                /**
     * Sets the global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.BaseSoundManager#setDetune
     * @fires Phaser.Sound.Events#GLOBAL_DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.BaseSoundManager#detune
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this._detune;
                    },
                    set: function(value) {
                        this._detune = value;
                        this.forEachActiveSound(function(sound) {
                            sound.calculateRate();
                        });
                        this.emit(Events.GLOBAL_DETUNE, this, value);
                    }
                }
            });
            module1.exports = BaseSoundManager;
        /***/ },
        /* 146 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(70);
            var Extend = __webpack_require__(17);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * Class containing all the shared state and behavior of a sound object, independent of the implementation.
 *
 * @class BaseSound
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
 */ var BaseSound = new Class({
                Extends: EventEmitter,
                initialize: function BaseSound(manager, key, config) {
                    EventEmitter.call(this);
                    /**
         * Local reference to the sound manager.
         *
         * @name Phaser.Sound.BaseSound#manager
         * @type {Phaser.Sound.BaseSoundManager}
         * @private
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * Asset key for the sound.
         *
         * @name Phaser.Sound.BaseSound#key
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.key = key;
                    /**
         * Flag indicating if sound is currently playing.
         *
         * @name Phaser.Sound.BaseSound#isPlaying
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPlaying = false;
                    /**
         * Flag indicating if sound is currently paused.
         *
         * @name Phaser.Sound.BaseSound#isPaused
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPaused = false;
                    /**
         * A property that holds the value of sound's actual playback rate,
         * after its rate and detune values has been combined with global
         * rate and detune values.
         *
         * @name Phaser.Sound.BaseSound#totalRate
         * @type {number}
         * @default 1
         * @readonly
         * @since 3.0.0
         */ this.totalRate = 1;
                    /**
         * A value representing the duration, in seconds.
         * It could be total sound duration or a marker duration.
         *
         * @name Phaser.Sound.BaseSound#duration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.duration = this.duration || 0;
                    /**
         * The total duration of the sound in seconds.
         *
         * @name Phaser.Sound.BaseSound#totalDuration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.totalDuration = this.totalDuration || 0;
                    /**
         * A config object used to store default sound settings' values.
         * Default values will be set by properties' setters.
         *
         * @name Phaser.Sound.BaseSound#config
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.config = {
                        mute: false,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: false,
                        delay: 0,
                        pan: 0
                    };
                    /**
         * Reference to the currently used config.
         * It could be default config or marker config.
         *
         * @name Phaser.Sound.BaseSound#currentConfig
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.currentConfig = this.config;
                    this.config = Extend(this.config, config);
                    /**
         * Object containing markers definitions.
         *
         * @name Phaser.Sound.BaseSound#markers
         * @type {Object.<string, Phaser.Types.Sound.SoundMarker>}
         * @default {}
         * @readonly
         * @since 3.0.0
         */ this.markers = {};
                    /**
         * Currently playing marker.
         * 'null' if whole sound is playing.
         *
         * @name Phaser.Sound.BaseSound#currentMarker
         * @type {Phaser.Types.Sound.SoundMarker}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.currentMarker = null;
                    /**
         * Flag indicating if destroy method was called on this sound.
         *
         * @name Phaser.Sound.BaseSound#pendingRemove
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this.pendingRemove = false;
                },
                /**
     * Adds a marker into the current sound. A marker is represented by name, start time, duration, and optionally config object.
     * This allows you to bundle multiple sounds together into a single audio file and use markers to jump between them for playback.
     *
     * @method Phaser.Sound.BaseSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} Whether the marker was added successfully.
     */ addMarker: function(marker) {
                    if (!marker || !marker.name || typeof marker.name !== "string") return false;
                    if (this.markers[marker.name]) {
                        // eslint-disable-next-line no-console
                        console.error("addMarker " + marker.name + " already exists in Sound");
                        return false;
                    }
                    marker = Extend(true, {
                        name: "",
                        start: 0,
                        duration: this.totalDuration - (marker.start || 0),
                        config: {
                            mute: false,
                            volume: 1,
                            rate: 1,
                            detune: 0,
                            seek: 0,
                            loop: false,
                            delay: 0,
                            pan: 0
                        }
                    }, marker);
                    this.markers[marker.name] = marker;
                    return true;
                },
                /**
     * Updates previously added marker.
     *
     * @method Phaser.Sound.BaseSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} Whether the marker was updated successfully.
     */ updateMarker: function(marker) {
                    if (!marker || !marker.name || typeof marker.name !== "string") return false;
                    if (!this.markers[marker.name]) {
                        // eslint-disable-next-line no-console
                        console.warn("Audio Marker: " + marker.name + " missing in Sound: " + this.key);
                        return false;
                    }
                    this.markers[marker.name] = Extend(true, this.markers[marker.name], marker);
                    return true;
                },
                /**
     * Removes a marker from the sound.
     *
     * @method Phaser.Sound.BaseSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {?Phaser.Types.Sound.SoundMarker} Removed marker object or 'null' if there was no marker with provided name.
     */ removeMarker: function(markerName) {
                    var marker = this.markers[markerName];
                    if (!marker) return null;
                    this.markers[markerName] = null;
                    return marker;
                },
                /**
     * Play this sound, or a marked section of it.
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.BaseSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (markerName === undefined) markerName = "";
                    if (typeof markerName === "object") {
                        config = markerName;
                        markerName = "";
                    }
                    if (typeof markerName !== "string") return false;
                    if (!markerName) {
                        this.currentMarker = null;
                        this.currentConfig = this.config;
                        this.duration = this.totalDuration;
                    } else {
                        if (!this.markers[markerName]) {
                            // eslint-disable-next-line no-console
                            console.warn("Marker: " + markerName + " missing in Sound: " + this.key);
                            return false;
                        }
                        this.currentMarker = this.markers[markerName];
                        this.currentConfig = this.currentMarker.config;
                        this.duration = this.currentMarker.duration;
                    }
                    this.resetConfig();
                    this.currentConfig = Extend(this.currentConfig, config);
                    this.isPlaying = true;
                    this.isPaused = false;
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.BaseSound#pause
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.isPaused || !this.isPlaying) return false;
                    this.isPlaying = false;
                    this.isPaused = true;
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.BaseSound#resume
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (!this.isPaused || this.isPlaying) return false;
                    this.isPlaying = true;
                    this.isPaused = false;
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.BaseSound#stop
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (!this.isPaused && !this.isPlaying) return false;
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.resetConfig();
                    return true;
                },
                /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.BaseSound#applyConfig
     * @protected
     * @since 3.0.0
     */ applyConfig: function() {
                    this.mute = this.currentConfig.mute;
                    this.volume = this.currentConfig.volume;
                    this.rate = this.currentConfig.rate;
                    this.detune = this.currentConfig.detune;
                    this.loop = this.currentConfig.loop;
                    this.pan = this.currentConfig.pan;
                },
                /**
     * Method used internally for resetting values of some of the config properties.
     *
     * @method Phaser.Sound.BaseSound#resetConfig
     * @protected
     * @since 3.0.0
     */ resetConfig: function() {
                    this.currentConfig.seek = 0;
                    this.currentConfig.delay = 0;
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.BaseSound#update
     * @override
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: NOOP,
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.BaseSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    var cent = 1.0005777895065548; // Math.pow(2, 1/1200);
                    var totalDetune = this.currentConfig.detune + this.manager.detune;
                    var detuneRate = Math.pow(cent, totalDetune);
                    this.totalRate = this.currentConfig.rate * this.manager.rate * detuneRate;
                },
                /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.BaseSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    if (this.pendingRemove) return;
                    this.emit(Events.DESTROY, this);
                    this.pendingRemove = true;
                    this.manager = null;
                    this.key = "";
                    this.removeAllListeners();
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.config = null;
                    this.currentConfig = null;
                    this.markers = null;
                    this.currentMarker = null;
                }
            });
            module1.exports = BaseSound;
        /***/ },
        /* 147 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckMatrix = __webpack_require__(209);
            var TransposeMatrix = __webpack_require__(435);
            /**
 * Rotates the array matrix based on the given rotation value.
 *
 * The value can be given in degrees: 90, -90, 270, -270 or 180,
 * or a string command: `rotateLeft`, `rotateRight` or `rotate180`.
 *
 * Based on the routine from {@link http://jsfiddle.net/MrPolywhirl/NH42z/}.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 * @param {(number|string)} [direction=90] - The amount to rotate the matrix by.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateMatrix = function(matrix, direction) {
                if (direction === undefined) direction = 90;
                if (!CheckMatrix(matrix)) return null;
                if (typeof direction !== "string") direction = (direction % 360 + 360) % 360;
                if (direction === 90 || direction === -270 || direction === "rotateLeft") {
                    matrix = TransposeMatrix(matrix);
                    matrix.reverse();
                } else if (direction === -90 || direction === 270 || direction === "rotateRight") {
                    matrix.reverse();
                    matrix = TransposeMatrix(matrix);
                } else if (Math.abs(direction) === 180 || direction === "rotate180") {
                    for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                    matrix.reverse();
                }
                return matrix;
            };
            module1.exports = RotateMatrix;
        /***/ },
        /* 148 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GetBitmapTextSize = __webpack_require__(1043);
            var ParseFromAtlas = __webpack_require__(1044);
            var ParseXMLBitmapFont = __webpack_require__(212);
            var Rectangle = __webpack_require__(10);
            var Render = __webpack_require__(1045);
            /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Littera (Web-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class BitmapText
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var BitmapText = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Texture,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function BitmapText(scene, x, y, font, text, size, align) {
                    if (text === undefined) text = "";
                    if (align === undefined) align = 0;
                    GameObject.call(this, scene, "BitmapText");
                    /**
         * The key of the Bitmap Font used by this Bitmap Text.
         * To change the font after creation please use `setFont`.
         *
         * @name Phaser.GameObjects.BitmapText#font
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.font = font;
                    var entry = this.scene.sys.cache.bitmapFont.get(font);
                    if (!entry) console.warn("Invalid BitmapText key: " + font);
                    /**
         * The data of the Bitmap Font used by this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#fontData
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapFontData}
         * @readonly
         * @since 3.0.0
         */ this.fontData = entry.data;
                    /**
         * The text that this Bitmap Text object displays.
         *
         * @name Phaser.GameObjects.BitmapText#_text
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._text = "";
                    /**
         * The font size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_fontSize
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._fontSize = size || this.fontData.size;
                    /**
         * Adds / Removes spacing between characters.
         *
         * Can be a negative or positive number.
         *
         * @name Phaser.GameObjects.BitmapText#_letterSpacing
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._letterSpacing = 0;
                    /**
         * Controls the alignment of each line of text in this BitmapText object.
         * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
         * Has no effect with single-lines of text.
         *
         * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
         *
         * 0 = Left aligned (default)
         * 1 = Middle aligned
         * 2 = Right aligned
         *
         * The alignment position is based on the longest line of text.
         *
         * @name Phaser.GameObjects.BitmapText#_align
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._align = align;
                    /**
         * An object that describes the size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_bounds
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapTextSize}
         * @private
         * @since 3.0.0
         */ this._bounds = GetBitmapTextSize();
                    /**
         * An internal dirty flag for bounds calculation.
         *
         * @name Phaser.GameObjects.BitmapText#_dirty
         * @type {boolean}
         * @private
         * @since 3.11.0
         */ this._dirty = true;
                    /**
         * Internal cache var holding the maxWidth.
         *
         * @name Phaser.GameObjects.BitmapText#_maxWidth
         * @type {number}
         * @private
         * @since 3.21.0
         */ this._maxWidth = 0;
                    /**
         * The character code used to detect for word wrapping.
         * Defaults to 32 (a space character).
         *
         * @name Phaser.GameObjects.BitmapText#wordWrapCharCode
         * @type {number}
         * @since 3.21.0
         */ this.wordWrapCharCode = 32;
                    /**
         * Internal array holding the character tint color data.
         *
         * @name Phaser.GameObjects.BitmapText#charColors
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.charColors = [];
                    /**
         * The horizontal offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowX
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowX = 0;
                    /**
         * The vertical offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowY
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowY = 0;
                    /**
         * The color of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowColor
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowColor = 0x000000;
                    /**
         * The alpha value of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowAlpha
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowAlpha = 0.5;
                    /**
         * Indicates whether the font texture is from an atlas or not.
         *
         * @name Phaser.GameObjects.BitmapText#fromAtlas
         * @type {boolean}
         * @since 3.54.0
         * @readonly
         */ this.fromAtlas = entry.fromAtlas;
                    this.setTexture(entry.texture, entry.frame);
                    this.setPosition(x, y);
                    this.setOrigin(0, 0);
                    this.initPipeline();
                    this.setText(text);
                },
                /**
     * Set the lines of text in this BitmapText to be left-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setLeftAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setLeftAlign: function() {
                    this._align = BitmapText.ALIGN_LEFT;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the lines of text in this BitmapText to be center-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setCenterAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setCenterAlign: function() {
                    this._align = BitmapText.ALIGN_CENTER;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the lines of text in this BitmapText to be right-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setRightAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setRightAlign: function() {
                    this._align = BitmapText.ALIGN_RIGHT;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the font size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#setFontSize
     * @since 3.0.0
     *
     * @param {number} size - The font size to set.
     *
     * @return {this} This BitmapText Object.
     */ setFontSize: function(size) {
                    this._fontSize = size;
                    this._dirty = true;
                    return this;
                },
                /**
     * Sets the letter spacing between each character of this Bitmap Text.
     * Can be a positive value to increase the space, or negative to reduce it.
     * Spacing is applied after the kerning values have been set.
     *
     * @method Phaser.GameObjects.BitmapText#setLetterSpacing
     * @since 3.4.0
     *
     * @param {number} [spacing=0] - The amount of horizontal space to add between each character.
     *
     * @return {this} This BitmapText Object.
     */ setLetterSpacing: function(spacing) {
                    if (spacing === undefined) spacing = 0;
                    this._letterSpacing = spacing;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the textual content of this BitmapText.
     *
     * An array of strings will be converted into multi-line text. Use the align methods to change multi-line alignment.
     *
     * @method Phaser.GameObjects.BitmapText#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this BitmapText.
     *
     * @return {this} This BitmapText Object.
     */ setText: function(value) {
                    if (!value && value !== 0) value = "";
                    if (Array.isArray(value)) value = value.join("\n");
                    if (value !== this.text) {
                        this._text = value.toString();
                        this._dirty = true;
                        this.updateDisplayOrigin();
                    }
                    return this;
                },
                /**
     * Sets a drop shadow effect on this Bitmap Text.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * You can set the vertical and horizontal offset of the shadow, as well as the color and alpha.
     *
     * Once a shadow has been enabled you can modify the `dropShadowX` and `dropShadowY` properties of this
     * Bitmap Text directly to adjust the position of the shadow in real-time.
     *
     * If you wish to clear the shadow, call this method with no parameters specified.
     *
     * @method Phaser.GameObjects.BitmapText#setDropShadow
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [x=0] - The horizontal offset of the drop shadow.
     * @param {number} [y=0] - The vertical offset of the drop shadow.
     * @param {number} [color=0x000000] - The color of the drop shadow, given as a hex value, i.e. `0x000000` for black.
     * @param {number} [alpha=0.5] - The alpha of the drop shadow, given as a float between 0 and 1. This is combined with the Bitmap Text alpha as well.
     *
     * @return {this} This BitmapText Object.
     */ setDropShadow: function(x, y, color, alpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (color === undefined) color = 0x000000;
                    if (alpha === undefined) alpha = 0.5;
                    this.dropShadowX = x;
                    this.dropShadowY = y;
                    this.dropShadowColor = color;
                    this.dropShadowAlpha = alpha;
                    return this;
                },
                /**
     * Sets a tint on a range of characters in this Bitmap Text, starting from the `start` parameter index
     * and running for `length` quantity of characters.
     *
     * The `start` parameter can be negative. In this case, it starts at the end of the text and counts
     * backwards `start` places.
     *
     * You can also pass in -1 as the `length` and it will tint all characters from `start`
     * up until the end of the string.

     * Remember that spaces and punctuation count as characters.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setWordTint` can override tints set by this function, and vice versa.
     *
     * To remove a tint call this method with just the `start`, and optionally, the `length` parameters defined.
     *
     * @method Phaser.GameObjects.BitmapText#setCharacterTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [start=0] - The starting character to begin the tint at. If negative, it counts back from the end of the text.
     * @param {number} [length=1] - The number of characters to tint. Remember that spaces count as a character too. Pass -1 to tint all characters from `start` onwards.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the character. If not other values are given this value is applied evenly, tinting the whole character.
     * @param {number} [topRight] - The tint being applied to the top-right of the character.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the character.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the character.
     *
     * @return {this} This BitmapText Object.
     */ setCharacterTint: function(start, length, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                    if (start === undefined) start = 0;
                    if (length === undefined) length = 1;
                    if (tintFill === undefined) tintFill = false;
                    if (topLeft === undefined) topLeft = -1;
                    if (topRight === undefined) {
                        topRight = topLeft;
                        bottomLeft = topLeft;
                        bottomRight = topLeft;
                    }
                    var len = this.text.length;
                    if (length === -1) length = len;
                    if (start < 0) start = len + start;
                    start = Clamp(start, 0, len - 1);
                    var end = Clamp(start + length, start, len);
                    var charColors = this.charColors;
                    for(var i = start; i < end; i++){
                        var color = charColors[i];
                        if (topLeft === -1) charColors[i] = null;
                        else {
                            var tintEffect = tintFill ? 1 : 0;
                            if (color) {
                                color.tintEffect = tintEffect;
                                color.tintTL = topLeft;
                                color.tintTR = topRight;
                                color.tintBL = bottomLeft;
                                color.tintBR = bottomRight;
                            } else charColors[i] = {
                                tintEffect: tintEffect,
                                tintTL: topLeft,
                                tintTR: topRight,
                                tintBL: bottomLeft,
                                tintBR: bottomRight
                            };
                        }
                    }
                    return this;
                },
                /**
     * Sets a tint on a matching word within this Bitmap Text.
     *
     * The `word` parameter can be either a string or a number.
     *
     * If a string, it will run a string comparison against the text contents, and if matching,
     * it will tint the whole word.
     *
     * If a number, if till that word, based on its offset within the text contents.
     *
     * The `count` parameter controls how many words are replaced. Pass in -1 to replace them all.
     *
     * This parameter is ignored if you pass a number as the `word` to be searched for.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setCharacterTint` can override tints set by this function, and vice versa.
     *
     * @method Phaser.GameObjects.BitmapText#setWordTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|number)} word - The word to search for. Either a string, or an index of the word in the words array.
     * @param {number} [count=1] - The number of matching words to tint. Pass -1 to tint all matching words.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the word. If not other values are given this value is applied evenly, tinting the whole word.
     * @param {number} [topRight] - The tint being applied to the top-right of the word.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the word.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the word.
     *
     * @return {this} This BitmapText Object.
     */ setWordTint: function(word, count, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                    if (count === undefined) count = 1;
                    var bounds = this.getTextBounds();
                    var words = bounds.words;
                    var wordIsNumber = typeof word === "number";
                    var total = 0;
                    for(var i = 0; i < words.length; i++){
                        var lineword = words[i];
                        if (wordIsNumber && i === word || !wordIsNumber && lineword.word === word) {
                            this.setCharacterTint(lineword.i, lineword.word.length, tintFill, topLeft, topRight, bottomLeft, bottomRight);
                            total++;
                            if (total === count) return this;
                        }
                    }
                    return this;
                },
                /**
     * Calculate the bounds of this Bitmap Text.
     *
     * An object is returned that contains the position, width and height of the Bitmap Text in local and global
     * contexts.
     *
     * Local size is based on just the font size and a [0, 0] position.
     *
     * Global size takes into account the Game Object's scale, world position and display origin.
     *
     * Also in the object is data regarding the length of each line, should this be a multi-line BitmapText.
     *
     * @method Phaser.GameObjects.BitmapText#getTextBounds
     * @since 3.0.0
     *
     * @param {boolean} [round=false] - Whether to round the results up to the nearest integer.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} An object that describes the size of this Bitmap Text.
     */ getTextBounds: function(round) {
                    //  local = The BitmapText based on fontSize and 0x0 coords
                    //  global = The BitmapText, taking into account scale and world position
                    //  lines = The BitmapText line data
                    var bounds = this._bounds;
                    if (this._dirty || round || this.scaleX !== bounds.scaleX || this.scaleY !== bounds.scaleY) {
                        GetBitmapTextSize(this, round, true, bounds);
                        this._dirty = false;
                    }
                    return bounds;
                },
                /**
     * Gets the character located at the given x/y coordinate within this Bitmap Text.
     *
     * The coordinates you pass in are translated into the local space of the
     * Bitmap Text, however, it is up to you to first translate the input coordinates to world space.
     *
     * If you wish to use this in combination with an input event, be sure
     * to pass in `Pointer.worldX` and `worldY` so they are in world space.
     *
     * In some cases, based on kerning, characters can overlap. When this happens,
     * the first character in the word is returned.
     *
     * Note that this does not work for DynamicBitmapText if you have changed the
     * character positions during render. It will only scan characters in their un-translated state.
     *
     * @method Phaser.GameObjects.BitmapText#getCharacterAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check.
     * @param {number} y - The y position to check.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} The character object at the given position, or `null`.
     */ getCharacterAt: function(x, y, camera) {
                    var point = this.getLocalPoint(x, y, null, camera);
                    var bounds = this.getTextBounds();
                    var chars = bounds.characters;
                    var tempRect = new Rectangle();
                    for(var i = 0; i < chars.length; i++){
                        var char = chars[i];
                        tempRect.setTo(char.x, char.t, char.r - char.x, char.b);
                        if (tempRect.contains(point.x, point.y)) return char;
                    }
                    return null;
                },
                /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.BitmapText#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                    this._dirty = true;
                    this.getTextBounds(false);
                    return this;
                },
                /**
     * Changes the font this BitmapText is using to render.
     *
     * The new texture is loaded and applied to the BitmapText. The existing test, size and alignment are preserved,
     * unless overridden via the arguments.
     *
     * @method Phaser.GameObjects.BitmapText#setFont
     * @since 3.11.0
     *
     * @param {string} font - The key of the font to use from the Bitmap Font cache.
     * @param {number} [size] - The font size of this Bitmap Text. If not specified the current size will be used.
     * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object. If not specified the current alignment will be used.
     *
     * @return {this} This BitmapText Object.
     */ setFont: function(key, size, align) {
                    if (size === undefined) size = this._fontSize;
                    if (align === undefined) align = this._align;
                    if (key !== this.font) {
                        var entry = this.scene.sys.cache.bitmapFont.get(key);
                        if (entry) {
                            this.font = key;
                            this.fontData = entry.data;
                            this._fontSize = size;
                            this._align = align;
                            this.fromAtlas = entry.fromAtlas === true;
                            this.setTexture(entry.texture, entry.frame);
                            GetBitmapTextSize(this, false, true, this._bounds);
                        }
                    }
                    return this;
                },
                /**
     * Sets the maximum display width of this BitmapText in pixels.
     *
     * If `BitmapText.text` is longer than `maxWidth` then the lines will be automatically wrapped
     * based on the previous whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the `maxWidth` value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * You can set the whitespace character to be searched for by setting the `wordWrapCharCode` parameter or property.
     *
     * @method Phaser.GameObjects.BitmapText#setMaxWidth
     * @since 3.21.0
     *
     * @param {number} value - The maximum display width of this BitmapText in pixels. Set to zero to disable.
     * @param {number} [wordWrapCharCode] - The character code to check for when word wrapping. Defaults to 32 (the space character).
     *
     * @return {this} This BitmapText Object.
     */ setMaxWidth: function(value, wordWrapCharCode) {
                    this._maxWidth = value;
                    this._dirty = true;
                    if (wordWrapCharCode !== undefined) this.wordWrapCharCode = wordWrapCharCode;
                    return this;
                },
                /**
     * Controls the alignment of each line of text in this BitmapText object.
     *
     * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
     * Has no effect with single-lines of text.
     *
     * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
     *
     * 0 = Left aligned (default)
     * 1 = Middle aligned
     * 2 = Right aligned
     *
     * The alignment position is based on the longest line of text.
     *
     * @name Phaser.GameObjects.BitmapText#align
     * @type {number}
     * @since 3.11.0
     */ align: {
                    set: function(value) {
                        this._align = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._align;
                    }
                },
                /**
     * The text that this Bitmap Text object displays.
     *
     * You can also use the method `setText` if you want a chainable way to change the text content.
     *
     * @name Phaser.GameObjects.BitmapText#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                    set: function(value) {
                        this.setText(value);
                    },
                    get: function() {
                        return this._text;
                    }
                },
                /**
     * The font size of this Bitmap Text.
     *
     * You can also use the method `setFontSize` if you want a chainable way to change the font size.
     *
     * @name Phaser.GameObjects.BitmapText#fontSize
     * @type {number}
     * @since 3.0.0
     */ fontSize: {
                    set: function(value) {
                        this._fontSize = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._fontSize;
                    }
                },
                /**
     * Adds / Removes spacing between characters.
     *
     * Can be a negative or positive number.
     *
     * You can also use the method `setLetterSpacing` if you want a chainable way to change the letter spacing.
     *
     * @name Phaser.GameObjects.BitmapText#letterSpacing
     * @type {number}
     * @since 3.0.0
     */ letterSpacing: {
                    set: function(value) {
                        this._letterSpacing = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._letterSpacing;
                    }
                },
                /**
     * The maximum display width of this BitmapText in pixels.
     *
     * If BitmapText.text is longer than maxWidth then the lines will be automatically wrapped
     * based on the last whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the maxWidth value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * @name Phaser.GameObjects.BitmapText#maxWidth
     * @type {number}
     * @since 3.21.0
     */ maxWidth: {
                    set: function(value) {
                        this._maxWidth = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._maxWidth;
                    }
                },
                /**
     * The width of this Bitmap Text.
     *
     * @name Phaser.GameObjects.BitmapText#width
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ width: {
                    get: function() {
                        this.getTextBounds(false);
                        return this._bounds.global.width;
                    }
                },
                /**
     * The height of this bitmap text.
     *
     * @name Phaser.GameObjects.BitmapText#height
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ height: {
                    get: function() {
                        this.getTextBounds(false);
                        return this._bounds.global.height;
                    }
                },
                /**
     * Build a JSON representation of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.BitmapText.JSONBitmapText} A JSON representation of this Bitmap Text.
     */ toJSON: function() {
                    var out = Components.ToJSON(this);
                    //  Extra data is added here
                    var data = {
                        font: this.font,
                        text: this.text,
                        fontSize: this.fontSize,
                        letterSpacing: this.letterSpacing,
                        align: this.align
                    };
                    out.data = data;
                    return out;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.BitmapText#preDestroy
     * @protected
     * @since 3.50.0
     */ preDestroy: function() {
                    this.charColors.length = 0;
                    this._bounds = null;
                    this.fontData = null;
                }
            });
            /**
 * Left align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_LEFT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_LEFT = 0;
            /**
 * Center align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_CENTER
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_CENTER = 1;
            /**
 * Right align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_RIGHT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_RIGHT = 2;
            /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @method Phaser.GameObjects.BitmapText.ParseFromAtlas
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ BitmapText.ParseFromAtlas = ParseFromAtlas;
            /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @method Phaser.GameObjects.BitmapText.ParseXMLBitmapFont
 * @since 3.17.0
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ BitmapText.ParseXMLBitmapFont = ParseXMLBitmapFont;
            module1.exports = BitmapText;
        /***/ },
        /* 149 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @callback EachSetCallback<E>
 *
 * @param {E} entry - The Set entry.
 * @param {number} index - The index of the entry within the Set.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * A Set is a collection of unique elements.
 *
 * @class Set
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [elements]
 *
 * @param {Array.<*>} [elements] - An optional array of elements to insert into this Set.
 */ var Set = new Class({
                initialize: function Set(elements) {
                    /**
         * The entries of this Set. Stored internally as an array.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.Set#entries
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.entries = [];
                    if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i]);
                },
                /**
     * Inserts the provided value into this Set. If the value is already contained in this Set this method will have no effect.
     *
     * @method Phaser.Structs.Set#set
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to insert into this Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ set: function(value) {
                    if (this.entries.indexOf(value) === -1) this.entries.push(value);
                    return this;
                },
                /**
     * Get an element of this Set which has a property of the specified name, if that property is equal to the specified value.
     * If no elements of this Set satisfy the condition then this method will return `null`.
     *
     * @method Phaser.Structs.Set#get
     * @since 3.0.0
     *
     * @genericUse {T} - [value,$return]
     *
     * @param {string} property - The property name to check on the elements of this Set.
     * @param {*} value - The value to check for.
     *
     * @return {*} The first element of this Set that meets the required condition, or `null` if this Set contains no elements that meet the condition.
     */ get: function(property, value) {
                    for(var i = 0; i < this.entries.length; i++){
                        var entry = this.entries[i];
                        if (entry[property] === value) return entry;
                    }
                },
                /**
     * Returns an array containing all the values in this Set.
     *
     * @method Phaser.Structs.Set#getArray
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} An array containing all the values in this Set.
     */ getArray: function() {
                    return this.entries.slice(0);
                },
                /**
     * Removes the given value from this Set if this Set contains that value.
     *
     * @method Phaser.Structs.Set#delete
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to remove from the Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ delete: function(value) {
                    var index = this.entries.indexOf(value);
                    if (index > -1) this.entries.splice(index, 1);
                    return this;
                },
                /**
     * Dumps the contents of this Set to the console via `console.group`.
     *
     * @method Phaser.Structs.Set#dump
     * @since 3.0.0
     */ dump: function() {
                    // eslint-disable-next-line no-console
                    console.group("Set");
                    for(var i = 0; i < this.entries.length; i++){
                        var entry = this.entries[i];
                        console.log(entry);
                    }
                    // eslint-disable-next-line no-console
                    console.groupEnd();
                },
                /**
     * Passes each value in this Set to the given callback.
     * Use this function when you know this Set will be modified during the iteration, otherwise use `iterate`.
     *
     * @method Phaser.Structs.Set#each
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ each: function(callback, callbackScope) {
                    var i;
                    var temp = this.entries.slice();
                    var len = temp.length;
                    if (callbackScope) for(i = 0; i < len; i++){
                        if (callback.call(callbackScope, temp[i], i) === false) break;
                    }
                    else for(i = 0; i < len; i++){
                        if (callback(temp[i], i) === false) break;
                    }
                    return this;
                },
                /**
     * Passes each value in this Set to the given callback.
     * For when you absolutely know this Set won't be modified during the iteration.
     *
     * @method Phaser.Structs.Set#iterate
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterate: function(callback, callbackScope) {
                    var i;
                    var len = this.entries.length;
                    if (callbackScope) for(i = 0; i < len; i++){
                        if (callback.call(callbackScope, this.entries[i], i) === false) break;
                    }
                    else for(i = 0; i < len; i++){
                        if (callback(this.entries[i], i) === false) break;
                    }
                    return this;
                },
                /**
     * Goes through each entry in this Set and invokes the given function on them, passing in the arguments.
     *
     * @method Phaser.Structs.Set#iterateLocal
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {string} callbackKey - The key of the function to be invoked on each Set entry.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterateLocal: function(callbackKey) {
                    var i;
                    var args = [];
                    for(i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var len = this.entries.length;
                    for(i = 0; i < len; i++){
                        var entry = this.entries[i];
                        entry[callbackKey].apply(entry, args);
                    }
                    return this;
                },
                /**
     * Clears this Set so that it no longer contains any values.
     *
     * @method Phaser.Structs.Set#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ clear: function() {
                    this.entries.length = 0;
                    return this;
                },
                /**
     * Returns `true` if this Set contains the given value, otherwise returns `false`.
     *
     * @method Phaser.Structs.Set#contains
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {*} value - The value to check for in this Set.
     *
     * @return {boolean} `true` if the given value was found in this Set, otherwise `false`.
     */ contains: function(value) {
                    return this.entries.indexOf(value) > -1;
                },
                /**
     * Returns a new Set containing all values that are either in this Set or in the Set provided as an argument.
     *
     * @method Phaser.Structs.Set#union
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the union with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set and the Set provided as an argument.
     */ union: function(set) {
                    var newSet = new Set();
                    set.entries.forEach(function(value) {
                        newSet.set(value);
                    });
                    this.entries.forEach(function(value) {
                        newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * Returns a new Set that contains only the values which are in this Set and that are also in the given Set.
     *
     * @method Phaser.Structs.Set#intersect
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to intersect this set with.
     *
     * @return {Phaser.Structs.Set} The result of the intersection, as a new Set.
     */ intersect: function(set) {
                    var newSet = new Set();
                    this.entries.forEach(function(value) {
                        if (set.contains(value)) newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * Returns a new Set containing all the values in this Set which are *not* also in the given Set.
     *
     * @method Phaser.Structs.Set#difference
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the difference with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set that are not also in the Set provided as an argument to this method.
     */ difference: function(set) {
                    var newSet = new Set();
                    this.entries.forEach(function(value) {
                        if (!set.contains(value)) newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * The size of this Set. This is the number of entries within it.
     * Changing the size will truncate the Set if the given value is smaller than the current size.
     * Increasing the size larger than the current size has no effect.
     *
     * @name Phaser.Structs.Set#size
     * @type {number}
     * @since 3.0.0
     */ size: {
                    get: function() {
                        return this.entries.length;
                    },
                    set: function(value) {
                        if (value < this.entries.length) return this.entries.length = value;
                        else return this.entries.length;
                    }
                }
            });
            module1.exports = Set;
        /***/ },
        /* 150 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var IntegerToColor = __webpack_require__(189);
            var PIPELINES_CONST = __webpack_require__(92);
            var Render = __webpack_require__(1182);
            /**
 * @classdesc
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the dislay list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @class PointLight
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Point Light belongs. A Point Light can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or colr blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 */ var PointLight = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function PointLight(scene, x, y, color, radius, intensity, attenuation) {
                    if (color === undefined) color = 0xffffff;
                    if (radius === undefined) radius = 128;
                    if (intensity === undefined) intensity = 1;
                    if (attenuation === undefined) attenuation = 0.1;
                    GameObject.call(this, scene, "PointLight");
                    this.initPipeline(PIPELINES_CONST.POINTLIGHT_PIPELINE);
                    this.setPosition(x, y);
                    /**
         * The color of this Point Light. This property is an instance of a
         * Color object, so you can use the methods within it, such as `setTo(r, g, b)`
         * to change the color value.
         *
         * @name Phaser.GameObjects.PointLight#color
         * @type {Phaser.Display.Color}
         * @since 3.50.0
         */ this.color = IntegerToColor(color);
                    /**
         * The intensity of the Point Light.
         *
         * The colors of the light are multiplied by this value during rendering.
         *
         * @name Phaser.GameObjects.PointLight#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                    /**
         * The attenuation of the Point Light.
         *
         * This value controls the force with which the light falls-off from the center of the light.
         *
         * Use small float-based values, i.e. 0.1.
         *
         * @name Phaser.GameObjects.PointLight#attenuation
         * @type {number}
         * @since 3.50.0
         */ this.attenuation = attenuation;
                    //  read only:
                    this.width = radius * 2;
                    this.height = radius * 2;
                    this._radius = radius;
                },
                /**
     * The radius of the Point Light.
     *
     * @name Phaser.GameObjects.PointLight#radius
     * @type {number}
     * @since 3.50.0
     */ radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(value) {
                        this._radius = value;
                        this.width = value * 2;
                        this.height = value * 2;
                    }
                },
                originX: {
                    get: function() {
                        return 0.5;
                    }
                },
                originY: {
                    get: function() {
                        return 0.5;
                    }
                },
                displayOriginX: {
                    get: function() {
                        return this._radius;
                    }
                },
                displayOriginY: {
                    get: function() {
                        return this._radius;
                    }
                }
            });
            module1.exports = PointLight;
        /***/ },
        /* 151 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between a circle and a rectangle.
 *
 * @function Phaser.Geom.Intersects.CircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var CircleToRectangle = function(circle, rect) {
                var halfWidth = rect.width / 2;
                var halfHeight = rect.height / 2;
                var cx = Math.abs(circle.x - rect.x - halfWidth);
                var cy = Math.abs(circle.y - rect.y - halfHeight);
                var xDist = halfWidth + circle.radius;
                var yDist = halfHeight + circle.radius;
                if (cx > xDist || cy > yDist) return false;
                else if (cx <= halfWidth || cy <= halfHeight) return true;
                else {
                    var xCornerDist = cx - halfWidth;
                    var yCornerDist = cy - halfHeight;
                    var xCornerDistSq = xCornerDist * xCornerDist;
                    var yCornerDistSq = yCornerDist * yCornerDist;
                    var maxCornerDistSq = circle.radius * circle.radius;
                    return xCornerDistSq + yCornerDistSq <= maxCornerDistSq;
                }
            };
            module1.exports = CircleToRectangle;
        /***/ },
        /* 152 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles intersect.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds.
 * As such, the two Rectangles are considered "solid".
 * A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.RectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the two Rectangles intersect, otherwise `false`.
 */ var RectangleToRectangle = function(rectA, rectB) {
                if (rectA.width <= 0 || rectA.height <= 0 || rectB.width <= 0 || rectB.height <= 0) return false;
                return !(rectA.right < rectB.x || rectA.bottom < rectB.y || rectA.x > rectB.right || rectA.y > rectB.bottom);
            };
            module1.exports = RectangleToRectangle;
        /***/ },
        /* 153 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            //  Contains the plugins that Phaser uses globally and locally.
            //  These are the source objects, not instantiated.
            var inputPlugins = {};
            /**
 * @namespace Phaser.Input.InputPluginCache
 */ var InputPluginCache = {};
            /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @function Phaser.Input.InputPluginCache.register
 * @static
 * @since 3.10.0
 *
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Input Plugin, this is the property key used.
 * @param {string} settingsKey - The key in the Scene Settings to check to see if this plugin should install or not.
 * @param {string} configKey - The key in the Game Config to check to see if this plugin should install or not.
 */ InputPluginCache.register = function(key, plugin, mapping, settingsKey, configKey) {
                inputPlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    settingsKey: settingsKey,
                    configKey: configKey
                };
            };
            /**
 * Returns the input plugin object from the cache based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.getPlugin
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to get.
 *
 * @return {Phaser.Types.Input.InputPluginContainer} The input plugin object.
 */ InputPluginCache.getPlugin = function(key) {
                return inputPlugins[key];
            };
            /**
 * Installs all of the registered Input Plugins into the given target.
 *
 * @function Phaser.Input.InputPluginCache.install
 * @static
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} target - The target InputPlugin to install the plugins into.
 */ InputPluginCache.install = function(target) {
                var sys = target.scene.sys;
                var settings = sys.settings.input;
                var config = sys.game.config;
                for(var key in inputPlugins){
                    var source = inputPlugins[key].plugin;
                    var mapping = inputPlugins[key].mapping;
                    var settingsKey = inputPlugins[key].settingsKey;
                    var configKey = inputPlugins[key].configKey;
                    if (GetValue(settings, settingsKey, config[configKey])) target[mapping] = new source(target);
                }
            };
            /**
 * Removes an input plugin based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.remove
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to remove.
 */ InputPluginCache.remove = function(key) {
                if (inputPlugins.hasOwnProperty(key)) delete inputPlugins[key];
            };
            module1.exports = InputPluginCache;
        /***/ },
        /* 154 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard.Events
 */ module1.exports = {
                ANY_KEY_DOWN: __webpack_require__(1323),
                ANY_KEY_UP: __webpack_require__(1324),
                COMBO_MATCH: __webpack_require__(1325),
                DOWN: __webpack_require__(1326),
                KEY_DOWN: __webpack_require__(1327),
                KEY_UP: __webpack_require__(1328),
                UP: __webpack_require__(1329)
            };
        /***/ },
        /* 155 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given a File and a baseURL value this returns the URL the File will use to download from.
 *
 * @function Phaser.Loader.GetURL
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File object.
 * @param {string} baseURL - A default base URL.
 *
 * @return {string} The URL the File will use.
 */ var GetURL = function(file, baseURL) {
                if (!file.url) return false;
                if (file.url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)) return file.url;
                else return baseURL + file.url;
            };
            module1.exports = GetURL;
        /***/ },
        /* 156 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates an XHRSettings Object with default values.
 *
 * @function Phaser.Loader.XHRSettings
 * @since 3.0.0
 *
 * @param {XMLHttpRequestResponseType} [responseType=''] - The responseType, such as 'text'.
 * @param {boolean} [async=true] - Should the XHR request use async or not?
 * @param {string} [user=''] - Optional username for the XHR request.
 * @param {string} [password=''] - Optional password for the XHR request.
 * @param {number} [timeout=0] - Optional XHR timeout value.
 * @param {boolean} [withCredentials=false] - Optional XHR withCredentials value.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} The XHRSettings object as used by the Loader.
 */ var XHRSettings = function(responseType, async, user, password, timeout, withCredentials) {
                if (responseType === undefined) responseType = "";
                if (async === undefined) async = true;
                if (user === undefined) user = "";
                if (password === undefined) password = "";
                if (timeout === undefined) timeout = 0;
                if (withCredentials === undefined) withCredentials = false;
                // Before sending a request, set the xhr.responseType to "text",
                // "arraybuffer", "blob", or "document", depending on your data needs.
                // Note, setting xhr.responseType = '' (or omitting) will default the response to "text".
                return {
                    //  Ignored by the Loader, only used by File.
                    responseType: responseType,
                    async: async,
                    //  credentials
                    user: user,
                    password: password,
                    //  timeout in ms (0 = no timeout)
                    timeout: timeout,
                    //  setRequestHeader
                    headers: undefined,
                    header: undefined,
                    headerValue: undefined,
                    requestedWith: false,
                    //  overrideMimeType
                    overrideMimeType: undefined,
                    //  withCredentials
                    withCredentials: withCredentials
                };
            };
            module1.exports = XHRSettings;
        /***/ },
        /* 157 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(243);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * An Arcade Physics Sprite is a Sprite with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Sprite and an Arcade Image is that you cannot animate an Arcade Image.
 * If you do not require animation then you can safely use Arcade Images instead of Arcade Sprites.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeSprite = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.Acceleration,
                    Components.Angular,
                    Components.Bounce,
                    Components.Debug,
                    Components.Drag,
                    Components.Enable,
                    Components.Friction,
                    Components.Gravity,
                    Components.Immovable,
                    Components.Mass,
                    Components.Pushable,
                    Components.Size,
                    Components.Velocity
                ],
                initialize: function ArcadeSprite(scene, x, y, texture, frame) {
                    Sprite.call(this, scene, x, y, texture, frame);
                    /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Sprite#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                }
            });
            module1.exports = ArcadeSprite;
        /***/ },
        /* 158 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(119);
            /**
 * Gets a tile at the given tile coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {boolean} nonNull - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAt = function(tileX, tileY, nonNull, layer) {
                if (nonNull === undefined) nonNull = false;
                if (IsInLayerBounds(tileX, tileY, layer)) {
                    var tile = layer.data[tileY][tileX] || null;
                    if (!tile) return null;
                    else if (tile.index === -1) return nonNull ? tile : null;
                    else return tile;
                } else return null;
            };
            module1.exports = GetTileAt;
        /***/ },
        /* 159 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.RunCull
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {object} bounds - An object containing the `left`, `right`, `top` and `bottom` bounds.
 * @param {number} renderOrder - The rendering order constant.
 * @param {array} outputArray - The array to store the Tile objects within.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var RunCull = function(layer, bounds, renderOrder, outputArray) {
                var mapData = layer.data;
                var mapWidth = layer.width;
                var mapHeight = layer.height;
                var tilemapLayer = layer.tilemapLayer;
                var drawLeft = Math.max(0, bounds.left);
                var drawRight = Math.min(mapWidth, bounds.right);
                var drawTop = Math.max(0, bounds.top);
                var drawBottom = Math.min(mapHeight, bounds.bottom);
                var x;
                var y;
                var tile;
                if (renderOrder === 0) {
                    //  right-down
                    for(y = drawTop; y < drawBottom; y++)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 1) {
                    //  left-down
                    for(y = drawTop; y < drawBottom; y++)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 2) {
                    //  right-up
                    for(y = drawBottom; y >= drawTop; y--)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 3) {
                    //  left-up
                    for(y = drawBottom; y >= drawTop; y--)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                }
                tilemapLayer.tilesDrawn = outputArray.length;
                tilemapLayer.tilesTotal = mapWidth * mapHeight;
                return outputArray;
            };
            module1.exports = RunCull;
        /***/ },
        /* 160 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to keep track of the tile indexes that collide within a layer. This
 * updates LayerData.collideIndexes to either contain or not contain the given `tileIndex`.
 *
 * @function Phaser.Tilemaps.Components.SetLayerCollisionIndex
 * @since 3.0.0
 *
 * @param {number} tileIndex - The tile index to set the collision boolean for.
 * @param {boolean} collides - Should the tile index collide or not?
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetLayerCollisionIndex = function(tileIndex, collides, layer) {
                var loc = layer.collideIndexes.indexOf(tileIndex);
                if (collides && loc === -1) layer.collideIndexes.push(tileIndex);
                else if (!collides && loc !== -1) layer.collideIndexes.splice(loc, 1);
            };
            module1.exports = SetLayerCollisionIndex;
        /***/ },
        /* 161 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Seth Berrier <berriers@uwstout.edu>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parse a Tiled group layer and create a state object for inheriting.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.CreateGroupLayer
 * @since 3.21.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {object} [currentl] - The current group layer from the Tiled JSON file.
 * @param {object} [parentstate] - The state of the parent group (if any).
 *
 * @return {object} A group state object with proper values for updating children layers.
 */ var CreateGroupLayer = function(json, groupl, parentstate) {
                if (!groupl) // Return a default group state object
                return {
                    i: 0,
                    layers: json.layers,
                    // Values inherited from parent group
                    name: "",
                    opacity: 1,
                    visible: true,
                    x: 0,
                    y: 0
                };
                // Compute group layer x, y
                var layerX = groupl.x + GetFastValue(groupl, "startx", 0) * json.tilewidth + GetFastValue(groupl, "offsetx", 0);
                var layerY = groupl.y + GetFastValue(groupl, "starty", 0) * json.tileheight + GetFastValue(groupl, "offsety", 0);
                // Compute next state inherited from group
                return {
                    i: 0,
                    layers: groupl.layers,
                    name: parentstate.name + groupl.name + "/",
                    opacity: parentstate.opacity * groupl.opacity,
                    visible: parentstate.visible && groupl.visible,
                    x: parentstate.x + layerX,
                    y: parentstate.y + layerY
                };
            };
            module1.exports = CreateGroupLayer;
        /***/ },
        /* 162 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function used by the Tween Builder to create a function that will return
 * the given value from the source.
 *
 * @function Phaser.Tweens.Builders.GetNewValue
 * @since 3.0.0
 *
 * @param {any} source - The source object to get the value from.
 * @param {string} key - The property to get from the source.
 * @param {any} defaultValue - A default value to return should the source not have the property set.
 *
 * @return {function} A function which when called will return the property value from the source.
 */ var GetNewValue = function(source, key, defaultValue) {
                var valueCallback;
                if (source.hasOwnProperty(key)) {
                    var t = typeof source[key];
                    if (t === "function") valueCallback = function(target, targetKey, value, targetIndex, totalTargets, tween) {
                        return source[key](target, targetKey, value, targetIndex, totalTargets, tween);
                    };
                    else valueCallback = function() {
                        return source[key];
                    };
                } else if (typeof defaultValue === "function") valueCallback = defaultValue;
                else valueCallback = function() {
                    return defaultValue;
                };
                return valueCallback;
            };
            module1.exports = GetNewValue;
        /***/ },
        /* 163 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Defaults = __webpack_require__(265);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(99);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(162);
            var GetProps = __webpack_require__(583);
            var GetTargets = __webpack_require__(263);
            var GetValue = __webpack_require__(6);
            var GetValueOp = __webpack_require__(264);
            var Tween = __webpack_require__(266);
            var TweenData = __webpack_require__(268);
            /**
 * Creates a new Tween.
 *
 * @function Phaser.Tweens.Builders.TweenBuilder
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var TweenBuilder = function(parent, config, defaults) {
                if (defaults === undefined) defaults = Defaults;
                //  Create arrays of the Targets and the Properties
                var targets = defaults.targets ? defaults.targets : GetTargets(config);
                // var props = (defaults.props) ? defaults.props : GetProps(config);
                var props = GetProps(config);
                //  Default Tween values
                var delay = GetNewValue(config, "delay", defaults.delay);
                var duration = GetNewValue(config, "duration", defaults.duration);
                var easeParams = GetValue(config, "easeParams", defaults.easeParams);
                var ease = GetEaseFunction(GetValue(config, "ease", defaults.ease), easeParams);
                var hold = GetNewValue(config, "hold", defaults.hold);
                var repeat = GetNewValue(config, "repeat", defaults.repeat);
                var repeatDelay = GetNewValue(config, "repeatDelay", defaults.repeatDelay);
                var yoyo = GetBoolean(config, "yoyo", defaults.yoyo);
                var flipX = GetBoolean(config, "flipX", defaults.flipX);
                var flipY = GetBoolean(config, "flipY", defaults.flipY);
                var data = [];
                //  Loop through every property defined in the Tween, i.e.: props { x, y, alpha }
                for(var p = 0; p < props.length; p++){
                    var key = props[p].key;
                    var value = props[p].value;
                    //  Create 1 TweenData per target, per property
                    for(var t = 0; t < targets.length; t++){
                        var ops = GetValueOp(key, value);
                        var tweenData = TweenData(targets[t], t, key, ops.getEnd, ops.getStart, ops.getActive, GetEaseFunction(GetValue(value, "ease", ease), GetValue(value, "easeParams", easeParams)), GetNewValue(value, "delay", delay), GetNewValue(value, "duration", duration), GetBoolean(value, "yoyo", yoyo), GetNewValue(value, "hold", hold), GetNewValue(value, "repeat", repeat), GetNewValue(value, "repeatDelay", repeatDelay), GetBoolean(value, "flipX", flipX), GetBoolean(value, "flipY", flipY));
                        data.push(tweenData);
                    }
                }
                var tween = new Tween(parent, data, targets);
                tween.offset = GetAdvancedValue(config, "offset", null);
                tween.completeDelay = GetAdvancedValue(config, "completeDelay", 0);
                tween.loop = Math.round(GetAdvancedValue(config, "loop", 0));
                tween.loopDelay = Math.round(GetAdvancedValue(config, "loopDelay", 0));
                tween.paused = GetBoolean(config, "paused", false);
                tween.useFrames = GetBoolean(config, "useFrames", false);
                //  Set the Callbacks
                var scope = GetValue(config, "callbackScope", tween);
                //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
                var tweenArray = [
                    tween,
                    null
                ];
                var callbacks = Tween.TYPES;
                for(var i = 0; i < callbacks.length; i++){
                    var type = callbacks[i];
                    var callback = GetValue(config, type, false);
                    if (callback) {
                        var callbackScope = GetValue(config, type + "Scope", scope);
                        var callbackParams = GetValue(config, type + "Params", []);
                        //  The null is reset to be the Tween target
                        tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
                    }
                }
                return tween;
            };
            module1.exports = TweenBuilder;
        /***/ },
        /* 164 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(102);
            var GetFastValue = __webpack_require__(2);
            var Events = __webpack_require__(132);
            var Animation = __webpack_require__(185);
            /**
 * @classdesc
 * The Animation State Component.
 *
 * This component provides features to apply animations to Game Objects. It is responsible for
 * loading, queuing animations for later playback, mixing between animations and setting
 * the current animation frame to the Game Object that owns this component.
 *
 * This component lives as an instance within any Game Object that has it defined, such as Sprites.
 *
 * You can access its properties and methods via the `anims` property, i.e. `Sprite.anims`.
 *
 * As well as playing animations stored in the global Animation Manager, this component
 * can also create animations that are stored locally within it. See the `create` method
 * for more details.
 *
 * Prior to Phaser 3.50 this component was called just `Animation` and lived in the
 * `Phaser.GameObjects.Components` namespace. It was renamed to `AnimationState`
 * in 3.50 to help better identify its true purpose when browsing the documentation.
 *
 * @class AnimationState
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} parent - The Game Object to which this animation component belongs.
 */ var AnimationState = new Class({
                initialize: function AnimationState(parent) {
                    /**
         * The Game Object to which this animation component belongs.
         *
         * You can typically access this component from the Game Object
         * via the `this.anims` property.
         *
         * @name Phaser.Animations.AnimationState#parent
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.AnimationState#animationManager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.animationManager = parent.scene.sys.anims;
                    this.animationManager.on(Events.REMOVE_ANIMATION, this.globalRemove, this);
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationState#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.50.0
         */ this.textureManager = this.animationManager.textureManager;
                    /**
         * The Animations stored locally in this Animation component.
         *
         * Do not modify the contents of this Map directly, instead use the
         * `add`, `create` and `remove` methods of this class instead.
         *
         * @name Phaser.Animations.AnimationState#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.50.0
         */ this.anims = null;
                    /**
         * Is an animation currently playing or not?
         *
         * @name Phaser.Animations.AnimationState#isPlaying
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPlaying = false;
                    /**
         * Has the current animation started playing, or is it waiting for a delay to expire?
         *
         * @name Phaser.Animations.AnimationState#hasStarted
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.hasStarted = false;
                    /**
         * The current Animation loaded into this Animation component.
         *
         * Will by `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentAnim
         * @type {?Phaser.Animations.Animation}
         * @default null
         * @since 3.0.0
         */ this.currentAnim = null;
                    /**
         * The current AnimationFrame being displayed by this Animation component.
         *
         * Will by `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @since 3.0.0
         */ this.currentFrame = null;
                    /**
         * The key, instance, or config of the next Animation to be loaded into this Animation component
         * when the current animation completes.
         *
         * Will by `null` if no animation has been queued.
         *
         * @name Phaser.Animations.AnimationState#nextAnim
         * @type {?(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)}
         * @default null
         * @since 3.16.0
         */ this.nextAnim = null;
                    /**
         * A queue of Animations to be loaded into this Animation component when the current animation completes.
         *
         * Populate this queue via the `chain` method.
         *
         * @name Phaser.Animations.AnimationState#nextAnimsQueue
         * @type {array}
         * @since 3.24.0
         */ this.nextAnimsQueue = [];
                    /**
         * The Time Scale factor.
         *
         * You can adjust this value to modify the passage of time for the animation that is currently
         * playing. For example, setting it to 2 will make the animation play twice as fast. Or setting
         * it to 0.5 will slow the animation down.
         *
         * You can change this value at run-time, or set it via the `PlayAnimationConfig`.
         *
         * Prior to Phaser 3.50 this property was private and called `_timeScale`.
         *
         * @name Phaser.Animations.AnimationState#timeScale
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.timeScale = 1;
                    /**
         * The frame rate of playback, of the current animation, in frames per second.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the frame rate, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#frameRate
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameRate = 0;
                    /**
         * The duration of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the duration, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * The number of milliseconds per frame, not including frame specific modifiers that may be present in the
         * Animation data.
         *
         * This value is calculated when a new animation is loaded into this component and should
         * be treated as read-only. Changing it will not alter playback speed.
         *
         * @name Phaser.Animations.AnimationState#msPerFrame
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.msPerFrame = 0;
                    /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.AnimationState#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = true;
                    /**
         * The delay before starting playback of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the delay, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_delay`.
         *
         * @name Phaser.Animations.AnimationState#delay
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delay = 0;
                    /**
         * The number of times to repeat playback of the current animation.
         *
         * If -1, it means the animation will repeat forever.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the number of repeats, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeat`.
         *
         * @name Phaser.Animations.AnimationState#repeat
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.repeat = 0;
                    /**
         * The number of milliseconds to wait before starting the repeat playback of the current animation.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the repeat delay by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeatDelay`.
         *
         * @name Phaser.Animations.AnimationState#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = 0;
                    /**
         * Should the current animation yoyo? An animation that yoyos will play in reverse, from the end
         * to the start, before then repeating or completing. An animation that does not yoyo will just
         * play from the start to the end.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the yoyo by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_yoyo`.
         *
         * @name Phaser.Animations.AnimationState#yoyo
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.yoyo = false;
                    /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * This will happen _after_ any delay that may have been set.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is currently delayed.
         *
         * @name Phaser.Animations.AnimationState#showOnStart
         * @type {boolean}
         * @since 3.50.0
         */ this.showOnStart = false;
                    /**
         * Should the GameObject's `visible` property be set to `false` when the animation completes?
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is still actively playing.
         *
         * @name Phaser.Animations.AnimationState#hideOnComplete
         * @type {boolean}
         * @since 3.50.0
         */ this.hideOnComplete = false;
                    /**
         * Is the playhead moving forwards (`true`) or in reverse (`false`) ?
         *
         * @name Phaser.Animations.AnimationState#forward
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.forward = true;
                    /**
         * An internal trigger that tells the component if it should plays the animation
         * in reverse mode ('true') or not ('false'). This is used because `forward` can
         * be changed by the `yoyo` feature.
         *
         * Prior to Phaser 3.50 this property was private and called `_reverse`.
         *
         * @name Phaser.Animations.AnimationState#inReverse
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.inReverse = false;
                    /**
         * Internal time overflow accumulator.
         *
         * This has the `delta` time added to it as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#accumulator
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accumulator = 0;
                    /**
         * The time point at which the next animation frame will change.
         *
         * This value is compared against the `accumulator` as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#nextTick
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.nextTick = 0;
                    /**
         * A counter keeping track of how much delay time, in milliseconds, is left before playback begins.
         *
         * This is set via the `playAfterDelay` method, although it can be modified at run-time
         * if required, as long as the animation has not already started playing.
         *
         * @name Phaser.Animations.AnimationState#delayCounter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delayCounter = 0;
                    /**
         * A counter that keeps track of how many repeats are left to run.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * @name Phaser.Animations.AnimationState#repeatCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCounter = 0;
                    /**
         * An internal flag keeping track of pending repeats.
         *
         * @name Phaser.Animations.AnimationState#pendingRepeat
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pendingRepeat = false;
                    /**
         * Is the Animation paused?
         *
         * @name Phaser.Animations.AnimationState#_paused
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._paused = false;
                    /**
         * Was the animation previously playing before being paused?
         *
         * @name Phaser.Animations.AnimationState#_wasPlaying
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._wasPlaying = false;
                    /**
         * Internal property tracking if this Animation is waiting to stop.
         *
         * 0 = No
         * 1 = Waiting for ms to pass
         * 2 = Waiting for repeat
         * 3 = Waiting for specific frame
         *
         * @name Phaser.Animations.AnimationState#_pendingStop
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._pendingStop = 0;
                    /**
         * Internal property used by _pendingStop.
         *
         * @name Phaser.Animations.AnimationState#_pendingStopValue
         * @type {any}
         * @private
         * @since 3.4.0
         */ this._pendingStopValue;
                },
                /**
     * Sets an animation, or an array of animations, to be played in the future, after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have one of the `stop` methods called.
     *
     * An animation set to repeat forever will never enter a completed state unless stopped.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it, or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained animations without impacting the global animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * @method Phaser.Animations.AnimationState#chain
     * @since 3.16.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ chain: function(key) {
                    var parent = this.parent;
                    if (key === undefined) {
                        this.nextAnimsQueue.length = 0;
                        this.nextAnim = null;
                        return parent;
                    }
                    if (!Array.isArray(key)) key = [
                        key
                    ];
                    for(var i = 0; i < key.length; i++){
                        var anim = key[i];
                        if (this.nextAnim === null) this.nextAnim = anim;
                        else this.nextAnimsQueue.push(anim);
                    }
                    return this.parent;
                },
                /**
     * Returns the key of the animation currently loaded into this component.
     *
     * Prior to Phaser 3.50 this method was called `getCurrentKey`.
     *
     * @method Phaser.Animations.AnimationState#getName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation currently loaded into this component, or an empty string if none loaded.
     */ getName: function() {
                    return this.currentAnim ? this.currentAnim.key : "";
                },
                /**
     * Returns the key of the animation frame currently displayed by this component.
     *
     * @method Phaser.Animations.AnimationState#getFrameName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation Frame currently displayed by this component, or an empty string if no animation has been loaded.
     */ getFrameName: function() {
                    return this.currentFrame ? this.currentFrame.textureFrame : "";
                },
                /**
     * Internal method used to load an animation into this component.
     *
     * @method Phaser.Animations.AnimationState#load
     * @protected
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ load: function(key) {
                    if (this.isPlaying) this.stop();
                    var manager = this.animationManager;
                    var animKey = typeof key === "string" ? key : GetFastValue(key, "key", null);
                    //  Get the animation, first from the local map and, if not found, from the Animation Manager
                    var anim = this.exists(animKey) ? this.get(animKey) : manager.get(animKey);
                    if (!anim) console.warn("Missing animation: " + animKey);
                    else {
                        this.currentAnim = anim;
                        //  And now override the animation values, if set in the config.
                        var totalFrames = anim.getTotalFrames();
                        var frameRate = GetFastValue(key, "frameRate", anim.frameRate);
                        var duration = GetFastValue(key, "duration", anim.duration);
                        anim.calculateDuration(this, totalFrames, duration, frameRate);
                        this.delay = GetFastValue(key, "delay", anim.delay);
                        this.repeat = GetFastValue(key, "repeat", anim.repeat);
                        this.repeatDelay = GetFastValue(key, "repeatDelay", anim.repeatDelay);
                        this.yoyo = GetFastValue(key, "yoyo", anim.yoyo);
                        this.showOnStart = GetFastValue(key, "showOnStart", anim.showOnStart);
                        this.hideOnComplete = GetFastValue(key, "hideOnComplete", anim.hideOnComplete);
                        this.skipMissedFrames = GetFastValue(key, "skipMissedFrames", anim.skipMissedFrames);
                        this.timeScale = GetFastValue(key, "timeScale", this.timeScale);
                        var startFrame = GetFastValue(key, "startFrame", 0);
                        if (startFrame > anim.getTotalFrames()) startFrame = 0;
                        var frame = anim.frames[startFrame];
                        if (startFrame === 0 && !this.forward) frame = anim.getLastFrame();
                        this.currentFrame = frame;
                    }
                    return this.parent;
                },
                /**
     * Pause the current animation and set the `isPlaying` property to `false`.
     * You can optionally pause it at a specific frame.
     *
     * @method Phaser.Animations.AnimationState#pause
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [atFrame] - An optional frame to set after pausing the animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ pause: function(atFrame) {
                    if (!this._paused) {
                        this._paused = true;
                        this._wasPlaying = this.isPlaying;
                        this.isPlaying = false;
                    }
                    if (atFrame !== undefined) this.setCurrentFrame(atFrame);
                    return this.parent;
                },
                /**
     * Resumes playback of a paused animation and sets the `isPlaying` property to `true`.
     * You can optionally tell it to start playback from a specific frame.
     *
     * @method Phaser.Animations.AnimationState#resume
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [fromFrame] - An optional frame to set before restarting playback.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ resume: function(fromFrame) {
                    if (this._paused) {
                        this._paused = false;
                        this.isPlaying = this._wasPlaying;
                    }
                    if (fromFrame !== undefined) this.setCurrentFrame(fromFrame);
                    return this.parent;
                },
                /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay' and the parameters were in the reverse order.
     *
     * @method Phaser.Animations.AnimationState#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterDelay: function(key, delay) {
                    if (!this.isPlaying) {
                        this.delayCounter = delay;
                        this.play(key, true);
                    } else {
                        //  If we've got a nextAnim, move it to the queue
                        var nextAnim = this.nextAnim;
                        var queue = this.nextAnimsQueue;
                        if (nextAnim) queue.unshift(nextAnim);
                        this.nextAnim = key;
                        this._pendingStop = 1;
                        this._pendingStopValue = delay;
                    }
                    return this.parent;
                },
                /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * @method Phaser.Animations.AnimationState#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterRepeat: function(key, repeatCount) {
                    if (repeatCount === undefined) repeatCount = 1;
                    if (!this.isPlaying) this.play(key);
                    else {
                        //  If we've got a nextAnim, move it to the queue
                        var nextAnim = this.nextAnim;
                        var queue = this.nextAnimsQueue;
                        if (nextAnim) queue.unshift(nextAnim);
                        if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                        this.nextAnim = key;
                        this._pendingStop = 2;
                        this._pendingStopValue = repeatCount;
                    }
                    return this.parent;
                },
                /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If this animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ play: function(key, ignoreIfPlaying) {
                    if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                    var currentAnim = this.currentAnim;
                    var parent = this.parent;
                    //  Must be either an Animation instance, or a PlayAnimationConfig object
                    var animKey = typeof key === "string" ? key : key.key;
                    if (ignoreIfPlaying && this.isPlaying && currentAnim.key === animKey) return parent;
                    //  Are we mixing?
                    if (currentAnim && this.isPlaying) {
                        var mix = this.animationManager.getMix(currentAnim.key, key);
                        if (mix > 0) return this.playAfterDelay(key, mix);
                    }
                    this.forward = true;
                    this.inReverse = false;
                    this._paused = false;
                    this._wasPlaying = true;
                    return this.startAnimation(key);
                },
                /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.12.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playReverse: function(key, ignoreIfPlaying) {
                    if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                    //  Must be either an Animation instance, or a PlayAnimationConfig object
                    var animKey = typeof key === "string" ? key : key.key;
                    if (ignoreIfPlaying && this.isPlaying && this.currentAnim.key === animKey) return this.parent;
                    this.forward = false;
                    this.inReverse = true;
                    this._paused = false;
                    this._wasPlaying = true;
                    return this.startAnimation(key);
                },
                /**
     * Load the animation based on the key and set-up all of the internal values
     * needed for playback to start. If there is no delay, it will also fire the start events.
     *
     * @method Phaser.Animations.AnimationState#startAnimation
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ startAnimation: function(key) {
                    this.load(key);
                    var anim = this.currentAnim;
                    var gameObject = this.parent;
                    if (!anim) return gameObject;
                    //  Should give us 9,007,199,254,740,991 safe repeats
                    this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                    anim.getFirstTick(this);
                    this.isPlaying = true;
                    this.pendingRepeat = false;
                    this.hasStarted = false;
                    this._pendingStop = 0;
                    this._pendingStopValue = 0;
                    this._paused = false;
                    //  Add any delay the animation itself may have had as well
                    this.delayCounter += this.delay;
                    if (this.delayCounter === 0) this.handleStart();
                    return gameObject;
                },
                /**
     * Handles the start of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStart
     * @private
     * @since 3.50.0
     */ handleStart: function() {
                    if (this.showOnStart) this.parent.setVisible(true);
                    this.setCurrentFrame(this.currentFrame);
                    this.hasStarted = true;
                    this.emitEvents(Events.ANIMATION_START);
                },
                /**
     * Handles the repeat of an animation.
     *
     * @method Phaser.Animations.AnimationState#handleRepeat
     * @private
     * @since 3.50.0
     */ handleRepeat: function() {
                    this.pendingRepeat = false;
                    this.emitEvents(Events.ANIMATION_REPEAT);
                },
                /**
     * Handles the stop of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStop
     * @private
     * @since 3.50.0
     */ handleStop: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    this.emitEvents(Events.ANIMATION_STOP);
                },
                /**
     * Handles the completion of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleComplete
     * @private
     * @since 3.50.0
     */ handleComplete: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.hideOnComplete) this.parent.setVisible(false);
                    this.emitEvents(Events.ANIMATION_COMPLETE, Events.ANIMATION_COMPLETE_KEY);
                },
                /**
     * Fires the given animation event.
     *
     * @method Phaser.Animations.AnimationState#emitEvents
     * @private
     * @since 3.50.0
     *
     * @param {string} event - The Animation Event to dispatch.
     */ emitEvents: function(event, keyEvent) {
                    var anim = this.currentAnim;
                    var frame = this.currentFrame;
                    var gameObject = this.parent;
                    var frameKey = frame.textureFrame;
                    gameObject.emit(event, anim, frame, gameObject, frameKey);
                    if (keyEvent) gameObject.emit(keyEvent + anim.key, anim, frame, gameObject, frameKey);
                },
                /**
     * Reverse the Animation that is already playing on the Game Object.
     *
     * @method Phaser.Animations.AnimationState#reverse
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ reverse: function() {
                    if (this.isPlaying) {
                        this.inReverse = !this.inReverse;
                        this.forward = !this.forward;
                    }
                    return this.parent;
                },
                /**
     * Returns a value between 0 and 1 indicating how far this animation is through, ignoring repeats and yoyos.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#getProgress
     * @since 3.4.0
     *
     * @return {number} The progress of the current animation in frames, between 0 and 1.
     */ getProgress: function() {
                    var frame = this.currentFrame;
                    if (!frame) return 0;
                    var p = frame.progress;
                    if (this.inReverse) p *= -1;
                    return p;
                },
                /**
     * Takes a value between 0 and 1 and uses it to set how far this animation is through playback.
     *
     * Does not factor in repeats or yoyos, but does handle playing forwards or backwards.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#setProgress
     * @since 3.4.0
     *
     * @param {number} [value=0] - The progress value, between 0 and 1.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setProgress: function(value) {
                    if (!this.forward) value = 1 - value;
                    this.setCurrentFrame(this.currentAnim.getFrameByProgress(value));
                    return this.parent;
                },
                /**
     * Sets the number of times that the animation should repeat after its first play through.
     * For example, if repeat is 1, the animation will play a total of twice: the initial play plus 1 repeat.
     *
     * To repeat indefinitely, use -1.
     * The value should always be an integer.
     *
     * Calling this method only works if the animation is already running. Otherwise, any
     * value specified here will be overwritten when the next animation loads in. To avoid this,
     * use the `repeat` property of the `PlayAnimationConfig` object instead.
     *
     * @method Phaser.Animations.AnimationState#setRepeat
     * @since 3.4.0
     *
     * @param {number} value - The number of times that the animation should repeat.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setRepeat: function(value) {
                    this.repeatCounter = value === -1 ? Number.MAX_VALUE : value;
                    return this.parent;
                },
                /**
     * Handle the removal of an animation from the Animation Manager.
     *
     * @method Phaser.Animations.AnimationState#globalRemove
     * @since 3.50.0
     *
     * @param {string} [key] - The key of the removed Animation.
     * @param {Phaser.Animations.Animation} [animation] - The removed Animation.
     */ globalRemove: function(key, animation) {
                    if (animation === undefined) animation = this.currentAnim;
                    if (this.isPlaying && animation.key === this.currentAnim.key) {
                        this.stop();
                        this.setCurrentFrame(this.currentAnim.frames[0]);
                    }
                },
                /**
     * Restarts the current animation from its beginning.
     *
     * You can optionally reset the delay and repeat counters as well.
     *
     * Calling this will fire the `ANIMATION_RESTART` event immediately.
     *
     * If you `includeDelay` then it will also fire the `ANIMATION_START` event once
     * the delay has expired, otherwise, playback will just begin immediately.
     *
     * @method Phaser.Animations.AnimationState#restart
     * @fires Phaser.Animations.Events#ANIMATION_RESTART
     * @since 3.0.0
     *
     * @param {boolean} [includeDelay=false] - Whether to include the delay value of the animation when restarting.
     * @param {boolean} [resetRepeats=false] - Whether to reset the repeat counter or not?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ restart: function(includeDelay, resetRepeats) {
                    if (includeDelay === undefined) includeDelay = false;
                    if (resetRepeats === undefined) resetRepeats = false;
                    var anim = this.currentAnim;
                    var gameObject = this.parent;
                    if (!anim) return gameObject;
                    if (resetRepeats) this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                    anim.getFirstTick(this);
                    this.emitEvents(Events.ANIMATION_RESTART);
                    this.isPlaying = true;
                    this.pendingRepeat = false;
                    //  Set this to `true` if there is no delay to include, so it skips the `hasStarted` check in `update`.
                    this.hasStarted = !includeDelay;
                    this._pendingStop = 0;
                    this._pendingStopValue = 0;
                    this._paused = false;
                    this.setCurrentFrame(anim.frames[0]);
                    return this.parent;
                },
                /**
     * The current animation has completed. This dispatches the `ANIMATION_COMPLETE` event.
     *
     * This method is called by the Animation instance and should not usually be invoked directly.
     *
     * If no animation is loaded, no events will be dispatched.
     *
     * If another animation has been queued for playback, it will be started after the events fire.
     *
     * @method Phaser.Animations.AnimationState#complete
     * @fires Phaser.Animations.Events#ANIMATION_COMPLETE
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ complete: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.currentAnim) this.handleComplete();
                    if (this.nextAnim) {
                        var key = this.nextAnim;
                        this.nextAnim = this.nextAnimsQueue.length > 0 ? this.nextAnimsQueue.shift() : null;
                        this.play(key);
                    }
                    return this.parent;
                },
                /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing.
     *
     * @method Phaser.Animations.AnimationState#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stop: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.currentAnim) this.handleStop();
                    if (this.nextAnim) {
                        var key = this.nextAnim;
                        this.nextAnim = this.nextAnimsQueue.shift();
                        this.play(key);
                    }
                    return this.parent;
                },
                /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterDelay: function(delay) {
                    this._pendingStop = 1;
                    this._pendingStopValue = delay;
                    return this.parent;
                },
                /**
     * Stops the current animation from playing when it next repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * Prior to Phaser 3.50 this method was called `stopOnRepeat` and had no parameters.
     *
     * @method Phaser.Animations.AnimationState#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterRepeat: function(repeatCount) {
                    if (repeatCount === undefined) repeatCount = 1;
                    if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                    this._pendingStop = 2;
                    this._pendingStopValue = repeatCount;
                    return this.parent;
                },
                /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopOnFrame: function(frame) {
                    this._pendingStop = 3;
                    this._pendingStopValue = frame;
                    return this.parent;
                },
                /**
     * Returns the total number of frames in this animation, or returns zero if no
     * animation has been loaded.
     *
     * @method Phaser.Animations.AnimationState#getTotalFrames
     * @since 3.4.0
     *
     * @return {number} The total number of frames in the current animation, or zero if no animation has been loaded.
     */ getTotalFrames: function() {
                    return this.currentAnim ? this.currentAnim.getTotalFrames() : 0;
                },
                /**
     * The internal update loop for the AnimationState Component.
     *
     * This is called automatically by the `Sprite.preUpdate` method.
     *
     * @method Phaser.Animations.AnimationState#update
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    var anim = this.currentAnim;
                    if (!this.isPlaying || !anim || anim.paused) return;
                    this.accumulator += delta * this.timeScale;
                    if (this._pendingStop === 1) {
                        this._pendingStopValue -= delta;
                        if (this._pendingStopValue <= 0) return this.stop();
                    }
                    if (!this.hasStarted) {
                        if (this.accumulator >= this.delayCounter) {
                            this.accumulator -= this.delayCounter;
                            this.handleStart();
                        }
                    } else if (this.accumulator >= this.nextTick) {
                        //  Process one frame advance as standard
                        if (this.forward) anim.nextFrame(this);
                        else anim.previousFrame(this);
                        //  And only do more if we're skipping frames and have time left
                        if (this.isPlaying && this._pendingStop === 0 && this.skipMissedFrames && this.accumulator > this.nextTick) {
                            var safetyNet = 0;
                            do {
                                if (this.forward) anim.nextFrame(this);
                                else anim.previousFrame(this);
                                safetyNet++;
                            }while (this.isPlaying && this.accumulator > this.nextTick && safetyNet < 60);
                        }
                    }
                },
                /**
     * Sets the given Animation Frame as being the current frame
     * and applies it to the parent Game Object, adjusting size and origin as needed.
     *
     * @method Phaser.Animations.AnimationState#setCurrentFrame
     * @fires Phaser.Animations.Events#ANIMATION_UPDATE
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} animationFrame - The animation frame to change to.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ setCurrentFrame: function(animationFrame) {
                    var gameObject = this.parent;
                    this.currentFrame = animationFrame;
                    gameObject.texture = animationFrame.frame.texture;
                    gameObject.frame = animationFrame.frame;
                    if (gameObject.isCropped) gameObject.frame.updateCropUVs(gameObject._crop, gameObject.flipX, gameObject.flipY);
                    if (animationFrame.setAlpha) gameObject.alpha = animationFrame.alpha;
                    gameObject.setSizeToFrame();
                    if (gameObject._originComponent) {
                        if (animationFrame.frame.customPivot) gameObject.setOrigin(animationFrame.frame.pivotX, animationFrame.frame.pivotY);
                        else gameObject.updateDisplayOrigin();
                    }
                    if (this.isPlaying && this.hasStarted) {
                        this.emitEvents(Events.ANIMATION_UPDATE);
                        if (this._pendingStop === 3 && this._pendingStopValue === animationFrame) this.stop();
                    }
                    return gameObject;
                },
                /**
     * Advances the animation to the next frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in reverse, calling this method doesn't then change the direction to forwards.
     *
     * @method Phaser.Animations.AnimationState#nextFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ nextFrame: function() {
                    if (this.currentAnim) this.currentAnim.nextFrame(this);
                    return this.parent;
                },
                /**
     * Advances the animation to the previous frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in forwards, calling this method doesn't then change the direction to backwards.
     *
     * @method Phaser.Animations.AnimationState#previousFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ previousFrame: function() {
                    if (this.currentAnim) this.currentAnim.previousFrame(this);
                    return this.parent;
                },
                /**
     * Get an Animation instance that has been created locally on this Sprite.
     *
     * See the `create` method for more details.
     *
     * @method Phaser.Animations.AnimationState#get
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation, or `null` if the key is invalid.
     */ get: function(key) {
                    return this.anims ? this.anims.get(key) : null;
                },
                /**
     * Checks to see if the given key is already used locally within the animations stored on this Sprite.
     *
     * @method Phaser.Animations.AnimationState#exists
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation exists locally, or `false` if the key is available, or there are no local animations.
     */ exists: function(key) {
                    return this.anims ? this.anims.has(key) : false;
                },
                /**
     * Creates a new Animation that is local specifically to this Sprite.
     *
     * When a Sprite owns an animation, it is kept out of the global Animation Manager, which means
     * you're free to use keys that may be already defined there. Unless you specifically need a Sprite
     * to have a unique animation, you should favor using global animations instead, as they allow for
     * the same animation to be used across multiple Sprites, saving on memory. However, if this Sprite
     * is the only one to use this animation, it's sensible to create it here.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists locally, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use by this Sprite.
     *
     * If you wish to re-use an existing key, call the `remove` method first, then this method.
     *
     * @method Phaser.Animations.AnimationState#create
     * @since 3.50.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                    var key = config.key;
                    var anim = false;
                    if (key) {
                        anim = this.get(key);
                        if (!anim) {
                            anim = new Animation(this, key, config);
                            if (!this.anims) this.anims = new CustomMap();
                            this.anims.set(key, anim);
                        }
                    }
                    return anim;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to look for 6 frames, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNames
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                    return this.animationManager.generateFrameNames(key, config);
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 12 })`.
     *
     * The `end` value tells it to stop after 12 frames. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNames('explosion', {
     *     start: 0,
     *     end: 12
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNumbers
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} config - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                    return this.animationManager.generateFrameNumbers(key, config);
                },
                /**
     * Removes a locally created Animation from this Sprite, based on the given key.
     *
     * Once an Animation has been removed, this Sprite cannot play it again without re-creating it.
     *
     * @method Phaser.Animations.AnimationState#remove
     * @since 3.50.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from this Sprite, if the key was valid.
     */ remove: function(key) {
                    var anim = this.get(key);
                    if (anim) {
                        if (this.currentAnim === anim) this.stop();
                        this.anims.delete(key);
                    }
                    return anim;
                },
                /**
     * Destroy this Animation component.
     *
     * Unregisters event listeners and cleans up its references.
     *
     * @method Phaser.Animations.AnimationState#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.animationManager.off(Events.REMOVE_ANIMATION, this.globalRemove, this);
                    if (this.anims) this.anims.clear();
                    this.animationManager = null;
                    this.parent = null;
                    this.nextAnim = null;
                    this.nextAnimsQueue.length = 0;
                    this.currentAnim = null;
                    this.currentFrame = null;
                },
                /**
     * `true` if the current animation is paused, otherwise `false`.
     *
     * @name Phaser.Animations.AnimationState#isPaused
     * @readonly
     * @type {boolean}
     * @since 3.4.0
     */ isPaused: {
                    get: function() {
                        return this._paused;
                    }
                }
            });
            module1.exports = AnimationState;
        /***/ },
        /* 165 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
*
* @class Sleeping
*/ var Sleeping = {};
            module1.exports = Sleeping;
            var Events = __webpack_require__(166);
            (function() {
                Sleeping._motionWakeThreshold = 0.18;
                Sleeping._motionSleepThreshold = 0.08;
                Sleeping._minBias = 0.9;
                /**
     * Puts bodies to sleep or wakes them up depending on their motion.
     * @method update
     * @param {body[]} bodies
     * @param {number} timeScale
     */ Sleeping.update = function(bodies, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // update bodies sleeping status
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], motion = body.speed * body.speed + body.angularSpeed * body.angularSpeed;
                        // wake up bodies if they have a force applied
                        if (body.force.x !== 0 || body.force.y !== 0) {
                            Sleeping.set(body, false);
                            continue;
                        }
                        var minMotion = Math.min(body.motion, motion), maxMotion = Math.max(body.motion, motion);
                        // biased average motion estimation between frames
                        body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
                        if (body.sleepThreshold > 0 && body.motion < Sleeping._motionSleepThreshold * timeFactor) {
                            body.sleepCounter += 1;
                            if (body.sleepCounter >= body.sleepThreshold) Sleeping.set(body, true);
                        } else if (body.sleepCounter > 0) body.sleepCounter -= 1;
                    }
                };
                /**
     * Given a set of colliding pairs, wakes the sleeping bodies involved.
     * @method afterCollisions
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Sleeping.afterCollisions = function(pairs, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // wake up bodies involved in collisions
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        // don't wake inactive pairs
                        if (!pair.isActive) continue;
                        var collision = pair.collision, bodyA = collision.bodyA.parent, bodyB = collision.bodyB.parent;
                        // don't wake if at least one body is static
                        if (bodyA.isSleeping && bodyB.isSleeping || bodyA.isStatic || bodyB.isStatic) continue;
                        if (bodyA.isSleeping || bodyB.isSleeping) {
                            var sleepingBody = bodyA.isSleeping && !bodyA.isStatic ? bodyA : bodyB, movingBody = sleepingBody === bodyA ? bodyB : bodyA;
                            if (!sleepingBody.isStatic && movingBody.motion > Sleeping._motionWakeThreshold * timeFactor) Sleeping.set(sleepingBody, false);
                        }
                    }
                };
                /**
     * Set a body as sleeping or awake.
     * @method set
     * @param {body} body
     * @param {boolean} isSleeping
     */ Sleeping.set = function(body, isSleeping) {
                    var wasSleeping = body.isSleeping;
                    if (isSleeping) {
                        body.isSleeping = true;
                        body.sleepCounter = body.sleepThreshold;
                        body.positionImpulse.x = 0;
                        body.positionImpulse.y = 0;
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.anglePrev = body.angle;
                        body.speed = 0;
                        body.angularSpeed = 0;
                        body.motion = 0;
                        if (!wasSleeping) Events.trigger(body, "sleepStart");
                    } else {
                        body.isSleeping = false;
                        body.sleepCounter = 0;
                        if (wasSleeping) Events.trigger(body, "sleepEnd");
                    }
                };
            })();
        /***/ },
        /* 166 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Events` module contains methods to fire and listen to events on other objects.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Events
*/ var Events = {};
            module1.exports = Events;
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Subscribes a callback function to the given object's `eventName`.
     * @method on
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.on = function(object, eventNames, callback) {
                    var names = eventNames.split(" "), name;
                    for(var i = 0; i < names.length; i++){
                        name = names[i];
                        object.events = object.events || {};
                        object.events[name] = object.events[name] || [];
                        object.events[name].push(callback);
                    }
                    return callback;
                };
                /**
     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
     * @method off
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.off = function(object, eventNames, callback) {
                    if (!eventNames) {
                        object.events = {};
                        return;
                    }
                    // handle Events.off(object, callback)
                    if (typeof eventNames === "function") {
                        callback = eventNames;
                        eventNames = Common.keys(object.events).join(" ");
                    }
                    var names = eventNames.split(" ");
                    for(var i = 0; i < names.length; i++){
                        var callbacks = object.events[names[i]], newCallbacks = [];
                        if (callback && callbacks) {
                            for(var j = 0; j < callbacks.length; j++)if (callbacks[j] !== callback) newCallbacks.push(callbacks[j]);
                        }
                        object.events[names[i]] = newCallbacks;
                    }
                };
                /**
     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
     * @method trigger
     * @param {} object
     * @param {string} eventNames
     * @param {} event
     */ Events.trigger = function(object, eventNames, event) {
                    var names, name, callbacks, eventClone;
                    var events = object.events;
                    if (events && Common.keys(events).length > 0) {
                        if (!event) event = {};
                        names = eventNames.split(" ");
                        for(var i = 0; i < names.length; i++){
                            name = names[i];
                            callbacks = events[name];
                            if (callbacks) {
                                eventClone = Common.clone(event, false);
                                eventClone.name = name;
                                eventClone.source = object;
                                for(var j = 0; j < callbacks.length; j++)callbacks[j].apply(object, [
                                    eventClone
                                ]);
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 167 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DeepCopy = __webpack_require__(175);
            var PIPELINE_CONST = __webpack_require__(92);
            var SpliceOne = __webpack_require__(74);
            /**
 * Provides methods used for setting the WebGL rendering pipeline of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Pipeline
 * @webglOnly
 * @since 3.0.0
 */ var Pipeline = {
                /**
     * The initial WebGL pipeline of this Game Object.
     *
     * If you call `resetPipeline` on this Game Object, the pipeline is reset to this default.
     *
     * @name Phaser.GameObjects.Components.Pipeline#defaultPipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ defaultPipeline: null,
                /**
     * The current WebGL pipeline of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ pipeline: null,
                /**
     * Does this Game Object have any Post Pipelines set?
     *
     * @name Phaser.GameObjects.Components.Pipeline#hasPostPipeline
     * @type {boolean}
     * @webglOnly
     * @since 3.50.0
     */ hasPostPipeline: false,
                /**
     * The WebGL Post FX Pipelines this Game Object uses for post-render effects.
     *
     * The pipelines are processed in the order in which they appear in this array.
     *
     * If you modify this array directly, be sure to set the
     * `hasPostPipeline` property accordingly.
     *
     * @name Phaser.GameObjects.Components.Pipeline#postPipelines
     * @type {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[]}
     * @webglOnly
     * @since 3.50.0
     */ postPipelines: null,
                /**
     * An object to store pipeline specific data in, to be read by the pipelines this Game Object uses.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipelineData
     * @type {object}
     * @webglOnly
     * @since 3.50.0
     */ pipelineData: null,
                /**
     * Sets the initial WebGL Pipeline of this Game Object.
     *
     * This should only be called during the instantiation of the Game Object. After that, use `setPipeline`.
     *
     * @method Phaser.GameObjects.Components.Pipeline#initPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline, or a pipeline instance to set.
     *
     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
     */ initPipeline: function(pipeline) {
                    if (pipeline === undefined) pipeline = PIPELINE_CONST.MULTI_PIPELINE;
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return false;
                    var pipelines = renderer.pipelines;
                    this.postPipelines = [];
                    this.pipelineData = {};
                    if (pipelines) {
                        var instance = pipelines.get(pipeline);
                        if (instance) {
                            this.defaultPipeline = instance;
                            this.pipeline = instance;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Sets the main WebGL Pipeline of this Game Object.
     *
     * Also sets the `pipelineData` property, if the parameter is given.
     *
     * Both the pipeline and post pipelines share the same pipeline data object.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline, or a pipeline instance to set.
     * @param {object} [pipelineData] - Optional pipeline data object that is _deep copied_ into the `pipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `pipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPipeline: function(pipeline, pipelineData, copyData) {
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return this;
                    var pipelines = renderer.pipelines;
                    if (pipelines) {
                        var instance = pipelines.get(pipeline);
                        if (instance) this.pipeline = instance;
                        if (pipelineData) this.pipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                    }
                    return this;
                },
                /**
     * Sets one, or more, Post Pipelines on this Game Object.
     *
     * Post Pipelines are invoked after this Game Object has rendered to its target and
     * are commonly used for post-fx.
     *
     * The post pipelines are appended to the `postPipelines` array belonging to this
     * Game Object. When the renderer processes this Game Object, it iterates through the post
     * pipelines in the order in which they appear in the array. If you are stacking together
     * multiple effects, be aware that the order is important.
     *
     * If you call this method multiple times, the new pipelines will be appended to any existing
     * post pipelines already set. Use the `resetPostPipeline` method to clear them first, if required.
     *
     * You can optionally also sets the `pipelineData` property, if the parameter is given.
     *
     * Both the pipeline and post pipelines share the pipeline data object together.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|string[]|function|function[]|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} pipelines - Either the string-based name of the pipeline, or a pipeline instance, or class, or an array of them.
     * @param {object} [pipelineData] - Optional pipeline data object that is _deep copied_ into the `pipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `pipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPostPipeline: function(pipelines, pipelineData, copyData) {
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return this;
                    var pipelineManager = renderer.pipelines;
                    if (pipelineManager) {
                        if (!Array.isArray(pipelines)) pipelines = [
                            pipelines
                        ];
                        for(var i = 0; i < pipelines.length; i++){
                            var instance = pipelineManager.getPostPipeline(pipelines[i], this);
                            if (instance) this.postPipelines.push(instance);
                        }
                        if (pipelineData) this.pipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                    }
                    this.hasPostPipeline = this.postPipelines.length > 0;
                    return this;
                },
                /**
     * Adds an entry to the `pipelineData` object belonging to this Game Object.
     *
     * If the 'key' already exists, its value is updated. If it doesn't exist, it is created.
     *
     * If `value` is undefined, and `key` exists, `key` is removed from the data object.
     *
     * Both the pipeline and post pipelines share the pipeline data object together.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipelineData
     * @webglOnly
     * @since 3.50.0
     *
     * @param {string} key - The key of the pipeline data to set, update, or delete.
     * @param {any} [value] - The value to be set with the key. If `undefined` then `key` will be deleted from the object.
     *
     * @return {this} This Game Object instance.
     */ setPipelineData: function(key, value) {
                    var data = this.pipelineData;
                    if (value === undefined) delete data[key];
                    else data[key] = value;
                    return this;
                },
                /**
     * Gets a Post Pipeline instance from this Game Object, based on the given name, and returns it.
     *
     * @method Phaser.GameObjects.Components.Pipeline#getPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {(Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} The Post Pipeline/s matching the name, or undefined if no match. If more than one match they are returned in an array.
     */ getPostPipeline: function(pipeline) {
                    var pipelines = this.postPipelines;
                    var results = [];
                    for(var i = 0; i < pipelines.length; i++){
                        var instance = pipelines[i];
                        if (typeof pipeline === "string" && instance.name === pipeline || instance instanceof pipeline) results.push(instance);
                    }
                    return results.length === 1 ? results[0] : results;
                },
                /**
     * Resets the WebGL Pipeline of this Game Object back to the default it was created with.
     *
     * @method Phaser.GameObjects.Components.Pipeline#resetPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {boolean} [resetPostPipelines=false] - Reset all of the post pipelines?
     * @param {boolean} [resetData=false] - Reset the `pipelineData` object to being an empty object?
     *
     * @return {boolean} `true` if the pipeline was reset successfully, otherwise `false`.
     */ resetPipeline: function(resetPostPipelines, resetData) {
                    if (resetPostPipelines === undefined) resetPostPipelines = false;
                    if (resetData === undefined) resetData = false;
                    this.pipeline = this.defaultPipeline;
                    if (resetPostPipelines) {
                        this.postPipelines = [];
                        this.hasPostPipeline = false;
                    }
                    if (resetData) this.pipelineData = {};
                    return this.pipeline !== null;
                },
                /**
     * Resets the WebGL Post Pipelines of this Game Object. It does this by calling
     * the `destroy` method on each post pipeline and then clearing the local array.
     *
     * @method Phaser.GameObjects.Components.Pipeline#resetPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {boolean} [resetData=false] - Reset the `pipelineData` object to being an empty object?
     */ resetPostPipeline: function(resetData) {
                    if (resetData === undefined) resetData = false;
                    var pipelines = this.postPipelines;
                    for(var i = 0; i < pipelines.length; i++)pipelines[i].destroy();
                    this.postPipelines = [];
                    this.hasPostPipeline = false;
                    if (resetData) this.pipelineData = {};
                },
                /**
     * Removes a type of Post Pipeline instances from this Game Object, based on the given name, and destroys them.
     *
     * If you wish to remove all Post Pipelines use the `resetPostPipeline` method instead.
     *
     * @method Phaser.GameObjects.Components.Pipeline#removePostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {string|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {this} This Game Object.
     */ removePostPipeline: function(pipeline) {
                    var pipelines = this.postPipelines;
                    for(var i = pipelines.length - 1; i >= 0; i--){
                        var instance = pipelines[i];
                        if (typeof pipeline === "string" && instance.name === pipeline || typeof pipeline !== "string" && instance instanceof pipeline) {
                            instance.destroy();
                            SpliceOne(pipelines, i);
                        }
                    }
                    this.hasPostPipeline = this.postPipelines.length > 0;
                    return this;
                },
                /**
     * Gets the name of the WebGL Pipeline this Game Object is currently using.
     *
     * @method Phaser.GameObjects.Components.Pipeline#getPipelineName
     * @webglOnly
     * @since 3.0.0
     *
     * @return {string} The string-based name of the pipeline being used by this Game Object.
     */ getPipelineName: function() {
                    return this.pipeline.name;
                }
            };
            module1.exports = Pipeline;
        /***/ },
        /* 168 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Modes.
 * 
 * @namespace Phaser.ScaleModes
 * @since 3.0.0
 */ var ScaleModes = {
                /**
     * Default Scale Mode (Linear).
     * 
     * @name Phaser.ScaleModes.DEFAULT
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ DEFAULT: 0,
                /**
     * Linear Scale Mode.
     * 
     * @name Phaser.ScaleModes.LINEAR
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ LINEAR: 0,
                /**
     * Nearest Scale Mode.
     * 
     * @name Phaser.ScaleModes.NEAREST
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ NEAREST: 1
            };
            module1.exports = ScaleModes;
        /***/ },
        /* 169 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
 *
 * @function Phaser.Geom.Circle.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} angle - The angle from the center of the Circle to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(circle, angle, out) {
                if (out === undefined) out = new Point();
                out.x = circle.x + circle.radius * Math.cos(angle);
                out.y = circle.y + circle.radius * Math.sin(angle);
                return out;
            };
            module1.exports = CircumferencePoint;
        /***/ },
        /* 170 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a uniformly distributed random point from anywhere within the given Circle.
 *
 * @function Phaser.Geom.Circle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(circle, out) {
                if (out === undefined) out = new Point();
                var t = 2 * Math.PI * Math.random();
                var u = Math.random() + Math.random();
                var r = u > 1 ? 2 - u : u;
                var x = r * Math.cos(t);
                var y = r * Math.sin(t);
                out.x = circle.x + x * circle.radius;
                out.y = circle.y + y * circle.radius;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 171 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(130);
            var Point = __webpack_require__(4);
            /**
 * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
 * 
 * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
 * 
 * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
 *
 * @function Phaser.Geom.Rectangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to update with the `x` and `y` coordinates of the point.
 *
 * @return {Phaser.Geom.Point} The updated `output` object, or a new Point if no `output` object was given.
 */ var GetPoint = function(rectangle, position, out) {
                if (out === undefined) out = new Point();
                if (position <= 0 || position >= 1) {
                    out.x = rectangle.x;
                    out.y = rectangle.y;
                    return out;
                }
                var p = Perimeter(rectangle) * position;
                if (position > 0.5) {
                    p -= rectangle.width + rectangle.height;
                    if (p <= rectangle.width) {
                        //  Face 3
                        out.x = rectangle.right - p;
                        out.y = rectangle.bottom;
                    } else {
                        //  Face 4
                        out.x = rectangle.x;
                        out.y = rectangle.bottom - (p - rectangle.width);
                    }
                } else if (p <= rectangle.width) {
                    //  Face 1
                    out.x = rectangle.x + p;
                    out.y = rectangle.y;
                } else {
                    //  Face 2
                    out.x = rectangle.right;
                    out.y = rectangle.y + (p - rectangle.width);
                }
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 172 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            var Point = __webpack_require__(4);
            /**
 * Get a number of points along a line's length.
 *
 * Provide a `quantity` to get an exact number of points along the line.
 *
 * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
 * providing a `stepRate`.
 *
 * @function Phaser.Geom.Line.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
 * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
 */ var GetPoints = function(line, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Length(line) / stepRate;
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                for(var i = 0; i < quantity; i++){
                    var position = i / quantity;
                    var x = x1 + (x2 - x1) * position;
                    var y = y1 + (y2 - y1) * position;
                    out.push(new Point(x, y));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 173 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random point on a given Line.
 *
 * @function Phaser.Geom.Line.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line to calculate the random Point on.
 * @param {(Phaser.Geom.Point|object)} [out] - An instance of a Point to be modified.
 *
 * @return {(Phaser.Geom.Point|object)} A random Point on the Line.
 */ var Random = function(line, out) {
                if (out === undefined) out = new Point();
                var t = Math.random();
                out.x = line.x1 + t * (line.x2 - line.x1);
                out.y = line.y1 + t * (line.y2 - line.y1);
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 174 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random point within a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to return a point from.
 * @param {Phaser.Geom.Point} out - The object to update with the point's coordinates.
 *
 * @return {Phaser.Geom.Point} The modified `out` object, or a new Point if none was provided.
 */ var Random = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.x + Math.random() * rect.width;
                out.y = rect.y + Math.random() * rect.height;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 175 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Deep Copy the given object or array.
 *
 * @function Phaser.Utils.Objects.DeepCopy
 * @since 3.50.0
 *
 * @param {object} obj - The object to deep copy.
 *
 * @return {object} A deep copy of the original object.
 */ var DeepCopy = function(inObject) {
                var outObject;
                var value;
                var key;
                if (typeof inObject !== "object" || inObject === null) //  inObject is not an object
                return inObject;
                //  Create an array or object to hold the values
                outObject = Array.isArray(inObject) ? [] : {};
                for(key in inObject){
                    value = inObject[key];
                    //  Recursively (deep) copy for nested objects, including arrays
                    outObject[key] = DeepCopy(value);
                }
                return outObject;
            };
            module1.exports = DeepCopy;
        /***/ },
        /* 176 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Build a JSON representation of the given Game Object.
 *
 * This is typically extended further by Game Object specific implementations.
 *
 * @method Phaser.GameObjects.Components.ToJSON
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to export as JSON.
 *
 * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
 */ var ToJSON = function(gameObject) {
                var out = {
                    name: gameObject.name,
                    type: gameObject.type,
                    x: gameObject.x,
                    y: gameObject.y,
                    depth: gameObject.depth,
                    scale: {
                        x: gameObject.scaleX,
                        y: gameObject.scaleY
                    },
                    origin: {
                        x: gameObject.originX,
                        y: gameObject.originY
                    },
                    flipX: gameObject.flipX,
                    flipY: gameObject.flipY,
                    rotation: gameObject.rotation,
                    alpha: gameObject.alpha,
                    visible: gameObject.visible,
                    blendMode: gameObject.blendMode,
                    textureKey: "",
                    frameKey: "",
                    data: {}
                };
                if (gameObject.texture) {
                    out.textureKey = gameObject.texture.key;
                    out.frameKey = gameObject.frame.name;
                }
                return out;
            };
            module1.exports = ToJSON;
        /***/ },
        /* 177 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Takes the `x` and `y` coordinates and transforms them into the same space as
 * defined by the position, rotation and scale values.
 *
 * @function Phaser.Math.TransformXY
 * @since 3.0.0
 *
 * @param {number} x - The x coordinate to be transformed.
 * @param {number} y - The y coordinate to be transformed.
 * @param {number} positionX - Horizontal position of the transform point.
 * @param {number} positionY - Vertical position of the transform point.
 * @param {number} rotation - Rotation of the transform point, in radians.
 * @param {number} scaleX - Horizontal scale of the transform point.
 * @param {number} scaleY - Vertical scale of the transform point.
 * @param {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} [output] - The output vector, point or object for the translated coordinates.
 *
 * @return {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} The translated point.
 */ var TransformXY = function(x, y, positionX, positionY, rotation, scaleX, scaleY, output) {
                if (output === undefined) output = new Vector2();
                var radianSin = Math.sin(rotation);
                var radianCos = Math.cos(rotation);
                // Rotate and Scale
                var a = radianCos * scaleX;
                var b = radianSin * scaleX;
                var c = -radianSin * scaleY;
                var d = radianCos * scaleY;
                //  Invert
                var id = 1 / (a * d + c * -b);
                output.x = d * id * x + -c * id * y + (positionY * c - positionX * d) * id;
                output.y = a * id * y + -b * id * x + (-positionY * a + positionX * b) * id;
                return output;
            };
            module1.exports = TransformXY;
        /***/ },
        /* 178 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the start of the array to the end, shifting all items in the process.
 * The "rotation" happens to the left.
 *
 * @function Phaser.Utils.Array.RotateLeft
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the left. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateLeft = function(array, total) {
                if (total === undefined) total = 1;
                var element = null;
                for(var i = 0; i < total; i++){
                    element = array.shift();
                    array.push(element);
                }
                return element;
            };
            module1.exports = RotateLeft;
        /***/ },
        /* 179 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the end of the array to the start, shifting all items in the process.
 * The "rotation" happens to the right.
 *
 * @function Phaser.Utils.Array.RotateRight
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the right. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateRight = function(array, total) {
                if (total === undefined) total = 1;
                var element = null;
                for(var i = 0; i < total; i++){
                    element = array.pop();
                    array.unshift(element);
                }
                return element;
            };
            module1.exports = RotateRight;
        /***/ },
        /* 180 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a uniformly distributed random point from anywhere within the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(ellipse, out) {
                if (out === undefined) out = new Point();
                var p = Math.random() * Math.PI * 2;
                var s = Math.sqrt(Math.random());
                out.x = ellipse.x + s * Math.cos(p) * ellipse.width / 2;
                out.y = ellipse.y + s * Math.sin(p) * ellipse.height / 2;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 181 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random Point from within the area of the given Triangle.
 *
 * @function Phaser.Geom.Triangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get a random point from.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of a random position within the Triangle.
 */ var Random = function(triangle, out) {
                if (out === undefined) out = new Point();
                //  Basis vectors
                var ux = triangle.x2 - triangle.x1;
                var uy = triangle.y2 - triangle.y1;
                var vx = triangle.x3 - triangle.x1;
                var vy = triangle.y3 - triangle.y1;
                //  Random point within the unit square
                var r = Math.random();
                var s = Math.random();
                //  Point outside the triangle? Remap it.
                if (r + s >= 1) {
                    r = 1 - r;
                    s = 1 - s;
                }
                out.x = triangle.x1 + (ux * r + vx * s);
                out.y = triangle.y1 + (uy * r + vy * s);
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 182 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` by the given `angle` and `distance`.
 *
 * In polar notation, this maps a point from (r, t) to (distance, t + angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAroundDistance = function(point, x, y, angle, distance) {
                var t = angle + Math.atan2(point.y - y, point.x - x);
                point.x = x + distance * Math.cos(t);
                point.y = y + distance * Math.sin(t);
                return point;
            };
            module1.exports = RotateAroundDistance;
        /***/ },
        /* 183 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smoother interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * Produces an even smoother interpolation than {@link Phaser.Math.SmoothStep}.
 *
 * @function Phaser.Math.SmootherStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmootherStep = function(x, min, max) {
                x = Math.max(0, Math.min(1, (x - min) / (max - min)));
                return x * x * x * (x * (x * 6 - 15) + 10);
            };
            module1.exports = SmootherStep;
        /***/ },
        /* 184 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smooth interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * @function Phaser.Math.SmoothStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmoothStep = function(x, min, max) {
                if (x <= min) return 0;
                if (x >= max) return 1;
                x = (x - min) / (max - min);
                return x * x * (3 - 2 * x);
            };
            module1.exports = SmoothStep;
        /***/ },
        /* 185 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(132);
            var FindClosestInSorted = __webpack_require__(318);
            var Frame = __webpack_require__(319);
            var GetValue = __webpack_require__(6);
            var SortByDigits = __webpack_require__(320);
            /**
 * @classdesc
 * A Frame based Animation.
 *
 * Animations in Phaser consist of a sequence of `AnimationFrame` objects, which are managed by
 * this class, along with properties that impact playback, such as the animations frame rate
 * or delay.
 *
 * This class contains all of the properties and methods needed to handle playback of the animation
 * directly to an `AnimationState` instance, which is owned by a Sprite, or similar Game Object.
 *
 * You don't typically create an instance of this class directly, but instead go via
 * either the `AnimationManager` or the `AnimationState` and use their `create` methods,
 * depending on if you need a global animation, or local to a specific Sprite.
 *
 * @class Animation
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Animations.AnimationManager} manager - A reference to the global Animation Manager
 * @param {string} key - The unique identifying string for this animation.
 * @param {Phaser.Types.Animations.Animation} config - The Animation configuration.
 */ var Animation = new Class({
                initialize: function Animation(manager, key, config) {
                    /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.Animation#manager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The unique identifying string for this animation.
         *
         * @name Phaser.Animations.Animation#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                    /**
         * A frame based animation (as opposed to a bone based animation)
         *
         * @name Phaser.Animations.Animation#type
         * @type {string}
         * @default frame
         * @since 3.0.0
         */ this.type = "frame";
                    /**
         * Extract all the frame data into the frames array.
         *
         * @name Phaser.Animations.Animation#frames
         * @type {Phaser.Animations.AnimationFrame[]}
         * @since 3.0.0
         */ this.frames = this.getFrames(manager.textureManager, GetValue(config, "frames", []), GetValue(config, "defaultTextureKey", null), GetValue(config, "sortFrames", true));
                    /**
         * The frame rate of playback in frames per second (default 24 if duration is null)
         *
         * @name Phaser.Animations.Animation#frameRate
         * @type {number}
         * @default 24
         * @since 3.0.0
         */ this.frameRate = GetValue(config, "frameRate", null);
                    /**
         * How long the animation should play for, in milliseconds.
         * If the `frameRate` property has been set then it overrides this value,
         * otherwise the `frameRate` is derived from `duration`.
         *
         * @name Phaser.Animations.Animation#duration
         * @type {number}
         * @since 3.0.0
         */ this.duration = GetValue(config, "duration", null);
                    /**
         * How many ms per frame, not including frame specific modifiers.
         *
         * @name Phaser.Animations.Animation#msPerFrame
         * @type {number}
         * @since 3.0.0
         */ this.msPerFrame;
                    /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.Animation#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = GetValue(config, "skipMissedFrames", true);
                    /**
         * The delay in ms before the playback will begin.
         *
         * @name Phaser.Animations.Animation#delay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delay = GetValue(config, "delay", 0);
                    /**
         * Number of times to repeat the animation. Set to -1 to repeat forever.
         *
         * @name Phaser.Animations.Animation#repeat
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeat = GetValue(config, "repeat", 0);
                    /**
         * The delay in ms before the a repeat play starts.
         *
         * @name Phaser.Animations.Animation#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = GetValue(config, "repeatDelay", 0);
                    /**
         * Should the animation yoyo (reverse back down to the start) before repeating?
         *
         * @name Phaser.Animations.Animation#yoyo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.yoyo = GetValue(config, "yoyo", false);
                    /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * @name Phaser.Animations.Animation#showOnStart
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.showOnStart = GetValue(config, "showOnStart", false);
                    /**
         * Should the GameObject's `visible` property be set to `false` when the animation finishes?
         *
         * @name Phaser.Animations.Animation#hideOnComplete
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hideOnComplete = GetValue(config, "hideOnComplete", false);
                    /**
         * Global pause. All Game Objects using this Animation instance are impacted by this property.
         *
         * @name Phaser.Animations.Animation#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    this.calculateDuration(this, this.getTotalFrames(), this.duration, this.frameRate);
                    if (this.manager.on) {
                        this.manager.on(Events.PAUSE_ALL, this.pause, this);
                        this.manager.on(Events.RESUME_ALL, this.resume, this);
                    }
                },
                /**
     * Gets the total number of frames in this animation.
     *
     * @method Phaser.Animations.Animation#getTotalFrames
     * @since 3.50.0
     *
     * @return {number} The total number of frames in this animation.
     */ getTotalFrames: function() {
                    return this.frames.length;
                },
                /**
     * Calculates the duration, frame rate and msPerFrame values.
     *
     * @method Phaser.Animations.Animation#calculateDuration
     * @since 3.50.0
     *
     * @param {Phaser.Animations.Animation} target - The target to set the values on.
     * @param {number} totalFrames - The total number of frames in the animation.
     * @param {number} duration - The duration to calculate the frame rate from.
     * @param {number} frameRate - The frame ate to calculate the duration from.
     */ calculateDuration: function(target, totalFrames, duration, frameRate) {
                    if (duration === null && frameRate === null) {
                        //  No duration or frameRate given, use default frameRate of 24fps
                        target.frameRate = 24;
                        target.duration = 24 / totalFrames * 1000;
                    } else if (duration && frameRate === null) {
                        //  Duration given but no frameRate, so set the frameRate based on duration
                        //  I.e. 12 frames in the animation, duration = 4000 ms
                        //  So frameRate is 12 / (4000 / 1000) = 3 fps
                        target.duration = duration;
                        target.frameRate = totalFrames / (duration / 1000);
                    } else {
                        //  frameRate given, derive duration from it (even if duration also specified)
                        //  I.e. 15 frames in the animation, frameRate = 30 fps
                        //  So duration is 15 / 30 = 0.5 * 1000 (half a second, or 500ms)
                        target.frameRate = frameRate;
                        target.duration = totalFrames / frameRate * 1000;
                    }
                    target.msPerFrame = 1000 / target.frameRate;
                },
                /**
     * Add frames to the end of the animation.
     *
     * @method Phaser.Animations.Animation#addFrame
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrame: function(config) {
                    return this.addFrameAt(this.frames.length, config);
                },
                /**
     * Add frame/s into the animation.
     *
     * @method Phaser.Animations.Animation#addFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index to insert the frame at within the animation.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrameAt: function(index, config) {
                    var newFrames = this.getFrames(this.manager.textureManager, config);
                    if (newFrames.length > 0) {
                        if (index === 0) this.frames = newFrames.concat(this.frames);
                        else if (index === this.frames.length) this.frames = this.frames.concat(newFrames);
                        else {
                            var pre = this.frames.slice(0, index);
                            var post = this.frames.slice(index);
                            this.frames = pre.concat(newFrames, post);
                        }
                        this.updateFrameSequence();
                    }
                    return this;
                },
                /**
     * Check if the given frame index is valid.
     *
     * @method Phaser.Animations.Animation#checkFrame
     * @since 3.0.0
     *
     * @param {number} index - The index to be checked.
     *
     * @return {boolean} `true` if the index is valid, otherwise `false`.
     */ checkFrame: function(index) {
                    return index >= 0 && index < this.frames.length;
                },
                /**
     * Called internally when this Animation first starts to play.
     * Sets the accumulator and nextTick properties.
     *
     * @method Phaser.Animations.Animation#getFirstTick
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getFirstTick: function(state) {
                    //  When is the first update due?
                    state.accumulator = 0;
                    state.nextTick = state.msPerFrame + state.currentFrame.duration;
                },
                /**
     * Returns the AnimationFrame at the provided index
     *
     * @method Phaser.Animations.Animation#getFrameAt
     * @protected
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {Phaser.Animations.AnimationFrame} The frame at the index provided from the animation sequence
     */ getFrameAt: function(index) {
                    return this.frames[index];
                },
                /**
     * Creates AnimationFrame instances based on the given frame data.
     *
     * @method Phaser.Animations.Animation#getFrames
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureManager} textureManager - A reference to the global Texture Manager.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} frames - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     * @param {string} [defaultTextureKey] - The key to use if no key is set in the frame configuration object.
     *
     * @return {Phaser.Animations.AnimationFrame[]} An array of newly created AnimationFrame instances.
     */ getFrames: function(textureManager, frames, defaultTextureKey, sortFrames) {
                    if (sortFrames === undefined) sortFrames = true;
                    var out = [];
                    var prev;
                    var animationFrame;
                    var index = 1;
                    var i;
                    var textureKey;
                    //  if frames is a string, we'll get all the frames from the texture manager as if it's a sprite sheet
                    if (typeof frames === "string") {
                        textureKey = frames;
                        var texture = textureManager.get(textureKey);
                        var frameKeys = texture.getFrameNames();
                        if (sortFrames) SortByDigits(frameKeys);
                        frames = [];
                        frameKeys.forEach(function(value) {
                            frames.push({
                                key: textureKey,
                                frame: value
                            });
                        });
                    }
                    if (!Array.isArray(frames) || frames.length === 0) return out;
                    for(i = 0; i < frames.length; i++){
                        var item = frames[i];
                        var key = GetValue(item, "key", defaultTextureKey);
                        if (!key) continue;
                        //  Could be an integer or a string
                        var frame = GetValue(item, "frame", 0);
                        //  The actual texture frame
                        var textureFrame = textureManager.getFrame(key, frame);
                        animationFrame = new Frame(key, frame, index, textureFrame);
                        animationFrame.duration = GetValue(item, "duration", 0);
                        animationFrame.isFirst = !prev;
                        //  The previously created animationFrame
                        if (prev) {
                            prev.nextFrame = animationFrame;
                            animationFrame.prevFrame = prev;
                        }
                        out.push(animationFrame);
                        prev = animationFrame;
                        index++;
                    }
                    if (out.length > 0) {
                        animationFrame.isLast = true;
                        //  Link them end-to-end, so they loop
                        animationFrame.nextFrame = out[0];
                        out[0].prevFrame = animationFrame;
                        //  Generate the progress data
                        var slice = 1 / (out.length - 1);
                        for(i = 0; i < out.length; i++)out[i].progress = i * slice;
                    }
                    return out;
                },
                /**
     * Called internally. Sets the accumulator and nextTick values of the current Animation.
     *
     * @method Phaser.Animations.Animation#getNextTick
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getNextTick: function(state) {
                    state.accumulator -= state.nextTick;
                    state.nextTick = state.msPerFrame + state.currentFrame.duration;
                },
                /**
     * Returns the frame closest to the given progress value between 0 and 1.
     *
     * @method Phaser.Animations.Animation#getFrameByProgress
     * @since 3.4.0
     *
     * @param {number} value - A value between 0 and 1.
     *
     * @return {Phaser.Animations.AnimationFrame} The frame closest to the given progress value.
     */ getFrameByProgress: function(value) {
                    value = Clamp(value, 0, 1);
                    return FindClosestInSorted(value, this.frames, "progress");
                },
                /**
     * Advance the animation frame.
     *
     * @method Phaser.Animations.Animation#nextFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     */ nextFrame: function(state) {
                    var frame = state.currentFrame;
                    if (frame.isLast) {
                        //  We're at the end of the animation
                        //  Yoyo? (happens before repeat)
                        if (state.yoyo) this.handleYoyoFrame(state, false);
                        else if (state.repeatCounter > 0) {
                            //  Repeat (happens before complete)
                            if (state.inReverse && state.forward) state.forward = false;
                            else this.repeatAnimation(state);
                        } else state.complete();
                    } else this.updateAndGetNextTick(state, frame.nextFrame);
                },
                /**
     * Handle the yoyo functionality in nextFrame and previousFrame methods.
     *
     * @method Phaser.Animations.Animation#handleYoyoFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     * @param {boolean} isReverse - Is animation in reverse mode? (Default: false)
     */ handleYoyoFrame: function(state, isReverse) {
                    if (!isReverse) isReverse = false;
                    if (state.inReverse === !isReverse && state.repeatCounter > 0) {
                        if (state.repeatDelay === 0 || state.pendingRepeat) state.forward = isReverse;
                        this.repeatAnimation(state);
                        return;
                    }
                    if (state.inReverse !== isReverse && state.repeatCounter === 0) {
                        state.complete();
                        return;
                    }
                    state.forward = isReverse;
                    var frame = isReverse ? state.currentFrame.nextFrame : state.currentFrame.prevFrame;
                    this.updateAndGetNextTick(state, frame);
                },
                /**
     * Returns the animation last frame.
     *
     * @method Phaser.Animations.Animation#getLastFrame
     * @since 3.12.0
     *
     * @return {Phaser.Animations.AnimationFrame} The last Animation Frame.
     */ getLastFrame: function() {
                    return this.frames[this.frames.length - 1];
                },
                /**
     * Called internally when the Animation is playing backwards.
     * Sets the previous frame, causing a yoyo, repeat, complete or update, accordingly.
     *
     * @method Phaser.Animations.Animation#previousFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ previousFrame: function(state) {
                    var frame = state.currentFrame;
                    if (frame.isFirst) {
                        //  We're at the start of the animation
                        if (state.yoyo) this.handleYoyoFrame(state, true);
                        else if (state.repeatCounter > 0) {
                            if (state.inReverse && !state.forward) this.repeatAnimation(state);
                            else {
                                //  Repeat (happens before complete)
                                state.forward = true;
                                this.repeatAnimation(state);
                            }
                        } else state.complete();
                    } else this.updateAndGetNextTick(state, frame.prevFrame);
                },
                /**
     * Update Frame and Wait next tick.
     *
     * @method Phaser.Animations.Animation#updateAndGetNextTick
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State.
     * @param {Phaser.Animations.AnimationFrame} frame - An Animation frame.
     */ updateAndGetNextTick: function(state, frame) {
                    state.setCurrentFrame(frame);
                    this.getNextTick(state);
                },
                /**
     * Removes the given AnimationFrame from this Animation instance.
     * This is a global action. Any Game Object using this Animation will be impacted by this change.
     *
     * @method Phaser.Animations.Animation#removeFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The AnimationFrame to be removed.
     *
     * @return {this} This Animation object.
     */ removeFrame: function(frame) {
                    var index = this.frames.indexOf(frame);
                    if (index !== -1) this.removeFrameAt(index);
                    return this;
                },
                /**
     * Removes a frame from the AnimationFrame array at the provided index
     * and updates the animation accordingly.
     *
     * @method Phaser.Animations.Animation#removeFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {this} This Animation object.
     */ removeFrameAt: function(index) {
                    this.frames.splice(index, 1);
                    this.updateFrameSequence();
                    return this;
                },
                /**
     * Called internally during playback. Forces the animation to repeat, providing there are enough counts left
     * in the repeat counter.
     *
     * @method Phaser.Animations.Animation#repeatAnimation
     * @fires Phaser.Animations.Events#ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_KEY_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ repeatAnimation: function(state) {
                    if (state._pendingStop === 2) {
                        if (state._pendingStopValue === 0) return state.stop();
                        else state._pendingStopValue--;
                    }
                    if (state.repeatDelay > 0 && !state.pendingRepeat) {
                        state.pendingRepeat = true;
                        state.accumulator -= state.nextTick;
                        state.nextTick += state.repeatDelay;
                    } else {
                        state.repeatCounter--;
                        if (state.forward) state.setCurrentFrame(state.currentFrame.nextFrame);
                        else state.setCurrentFrame(state.currentFrame.prevFrame);
                        if (state.isPlaying) {
                            this.getNextTick(state);
                            state.handleRepeat();
                        }
                    }
                },
                /**
     * Converts the animation data to JSON.
     *
     * @method Phaser.Animations.Animation#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimation} The resulting JSONAnimation formatted object.
     */ toJSON: function() {
                    var output = {
                        key: this.key,
                        type: this.type,
                        frames: [],
                        frameRate: this.frameRate,
                        duration: this.duration,
                        skipMissedFrames: this.skipMissedFrames,
                        delay: this.delay,
                        repeat: this.repeat,
                        repeatDelay: this.repeatDelay,
                        yoyo: this.yoyo,
                        showOnStart: this.showOnStart,
                        hideOnComplete: this.hideOnComplete
                    };
                    this.frames.forEach(function(frame) {
                        output.frames.push(frame.toJSON());
                    });
                    return output;
                },
                /**
     * Called internally whenever frames are added to, or removed from, this Animation.
     *
     * @method Phaser.Animations.Animation#updateFrameSequence
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ updateFrameSequence: function() {
                    var len = this.frames.length;
                    var slice = 1 / (len - 1);
                    var frame;
                    for(var i = 0; i < len; i++){
                        frame = this.frames[i];
                        frame.index = i + 1;
                        frame.isFirst = false;
                        frame.isLast = false;
                        frame.progress = i * slice;
                        if (i === 0) {
                            frame.isFirst = true;
                            if (len === 1) {
                                frame.isLast = true;
                                frame.nextFrame = frame;
                                frame.prevFrame = frame;
                            } else {
                                frame.isLast = false;
                                frame.prevFrame = this.frames[len - 1];
                                frame.nextFrame = this.frames[i + 1];
                            }
                        } else if (i === len - 1 && len > 1) {
                            frame.isLast = true;
                            frame.prevFrame = this.frames[len - 2];
                            frame.nextFrame = this.frames[0];
                        } else if (len > 1) {
                            frame.prevFrame = this.frames[i - 1];
                            frame.nextFrame = this.frames[i + 1];
                        }
                    }
                    return this;
                },
                /**
     * Pauses playback of this Animation. The paused state is set immediately.
     *
     * @method Phaser.Animations.Animation#pause
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ pause: function() {
                    this.paused = true;
                    return this;
                },
                /**
     * Resumes playback of this Animation. The paused state is reset immediately.
     *
     * @method Phaser.Animations.Animation#resume
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ resume: function() {
                    this.paused = false;
                    return this;
                },
                /**
     * Destroys this Animation instance. It will remove all event listeners,
     * remove this animation and its key from the global Animation Manager,
     * and then destroy all Animation Frames in turn.
     *
     * @method Phaser.Animations.Animation#destroy
     * @since 3.0.0
     */ destroy: function() {
                    if (this.manager.off) {
                        this.manager.off(Events.PAUSE_ALL, this.pause, this);
                        this.manager.off(Events.RESUME_ALL, this.resume, this);
                    }
                    this.manager.remove(this.key);
                    for(var i = 0; i < this.frames.length; i++)this.frames[i].destroy();
                    this.frames = [];
                    this.manager = null;
                }
            });
            module1.exports = Animation;
        /***/ },
        /* 186 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and pads it out, to the length required, using the character
 * specified. For example if you need a string to be 6 characters long, you can call:
 *
 * `pad('bob', 6, '-', 2)`
 *
 * This would return: `bob---` as it has padded it out to 6 characters, using the `-` on the right.
 *
 * You can also use it to pad numbers (they are always returned as strings):
 * 
 * `pad(512, 6, '0', 1)`
 *
 * Would return: `000512` with the string padded to the left.
 *
 * If you don't specify a direction it'll pad to both sides:
 * 
 * `pad('c64', 7, '*')`
 *
 * Would return: `**c64**`
 *
 * @function Phaser.Utils.String.Pad
 * @since 3.0.0
 *
 * @param {string|number|object} str - The target string. `toString()` will be called on the string, which means you can also pass in common data types like numbers.
 * @param {number} [len=0] - The number of characters to be added.
 * @param {string} [pad=" "] - The string to pad it out with (defaults to a space).
 * @param {number} [dir=3] - The direction dir = 1 (left), 2 (right), 3 (both).
 * 
 * @return {string} The padded string.
 */ var Pad = function(str, len, pad, dir) {
                if (len === undefined) len = 0;
                if (pad === undefined) pad = " ";
                if (dir === undefined) dir = 3;
                str = str.toString();
                var padlen = 0;
                if (len + 1 >= str.length) switch(dir){
                    case 1:
                        str = new Array(len + 1 - str.length).join(pad) + str;
                        break;
                    case 3:
                        var right = Math.ceil((padlen = len - str.length) / 2);
                        var left = padlen - right;
                        str = new Array(left + 1).join(pad) + str + new Array(right + 1).join(pad);
                        break;
                    default:
                        str = str + new Array(len + 1 - str.length).join(pad);
                        break;
                }
                return str;
            };
            module1.exports = Pad;
        /***/ },
        /* 187 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HexStringToColor = __webpack_require__(327);
            var IntegerToColor = __webpack_require__(189);
            var ObjectToColor = __webpack_require__(331);
            var RGBStringToColor = __webpack_require__(332);
            /**
 * Converts the given source color value into an instance of a Color class.
 * The value can be either a string, prefixed with `rgb` or a hex string, a number or an Object.
 *
 * @function Phaser.Display.Color.ValueToColor
 * @since 3.0.0
 *
 * @param {(string|number|Phaser.Types.Display.InputColorObject)} input - The source color value to convert.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ValueToColor = function(input) {
                var t = typeof input;
                switch(t){
                    case "string":
                        if (input.substr(0, 3).toLowerCase() === "rgb") return RGBStringToColor(input);
                        else return HexStringToColor(input);
                    case "number":
                        return IntegerToColor(input);
                    case "object":
                        return ObjectToColor(input);
                }
            };
            module1.exports = ValueToColor;
        /***/ },
        /* 188 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(103);
            /**
 * RGB space conversion.
 *
 * @ignore
 *
 * @param {number} n - The value to convert.
 * @param {number} h - The h value.
 * @param {number} s - The s value.
 * @param {number} v - The v value.
 *
 * @return {number} The converted value.
 */ function ConvertValue(n, h, s, v) {
                var k = (n + h * 6) % 6;
                var min = Math.min(k, 4 - k, 1);
                return Math.round(255 * (v - v * s * Math.max(0, min)));
            }
            /**
 * Converts a HSV (hue, saturation and value) color set to RGB.
 *
 * Conversion formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * Assumes HSV values are contained in the set [0, 1].
 *
 * @function Phaser.Display.Color.HSVToRGB
 * @since 3.0.0
 *
 * @param {number} h - The hue, in the range 0 - 1. This is the base color.
 * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
 * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
 * @param {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} [out] - A Color object to store the results in. If not given a new ColorObject will be created.
 *
 * @return {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} An object with the red, green and blue values set in the r, g and b properties.
 */ var HSVToRGB = function(h, s, v, out) {
                if (s === undefined) s = 1;
                if (v === undefined) v = 1;
                var r = ConvertValue(5, h, s, v);
                var g = ConvertValue(3, h, s, v);
                var b = ConvertValue(1, h, s, v);
                if (!out) return {
                    r: r,
                    g: g,
                    b: b,
                    color: GetColor(r, g, b)
                };
                else if (out.setTo) return out.setTo(r, g, b, out.alpha, false);
                else {
                    out.r = r;
                    out.g = g;
                    out.b = b;
                    out.color = GetColor(r, g, b);
                    return out;
                }
            };
            module1.exports = HSVToRGB;
        /***/ },
        /* 189 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            var IntegerToRGB = __webpack_require__(330);
            /**
 * Converts the given color value into an instance of a Color object.
 *
 * @function Phaser.Display.Color.IntegerToColor
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var IntegerToColor = function(input) {
                var rgb = IntegerToRGB(input);
                return new Color(rgb.r, rgb.g, rgb.b, rgb.a);
            };
            module1.exports = IntegerToColor;
        /***/ },
        /* 190 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Centers this Rectangle so that the center coordinates match the given x and y values.
            /**
 * Moves the top-left corner of a Rectangle so that its center is at the given coordinates.
 *
 * @function Phaser.Geom.Rectangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to be centered.
 * @param {number} x - The X coordinate of the Rectangle's center.
 * @param {number} y - The Y coordinate of the Rectangle's center.
 *
 * @return {Phaser.Geom.Rectangle} The centered rectangle.
 */ var CenterOn = function(rect, x, y) {
                rect.x = x - rect.width / 2;
                rect.y = y - rect.height / 2;
                return rect;
            };
            module1.exports = CenterOn;
        /***/ },
        /* 191 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(105);
            var Browser = __webpack_require__(136);
            var CanvasPool = __webpack_require__(31);
            /**
 * Determines the features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.features` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Features
 * @since 3.0.0
 *
 * @property {?boolean} canvasBitBltShift - True if canvas supports a 'copy' bitblt onto itself when the source and destination regions overlap.
 * @property {boolean} canvas - Is canvas available?
 * @property {boolean} file - Is file available?
 * @property {boolean} fileSystem - Is fileSystem available?
 * @property {boolean} getUserMedia - Does the device support the getUserMedia API?
 * @property {boolean} littleEndian - Is the device big or little endian? (only detected if the browser supports TypedArrays)
 * @property {boolean} localStorage - Is localStorage available?
 * @property {boolean} pointerLock - Is Pointer Lock available?
 * @property {boolean} support32bit - Does the device context support 32bit pixel manipulation using array buffer views?
 * @property {boolean} vibration - Does the device support the Vibration API?
 * @property {boolean} webGL - Is webGL available?
 * @property {boolean} worker - Is worker available?
 */ var Features = {
                canvas: false,
                canvasBitBltShift: null,
                file: false,
                fileSystem: false,
                getUserMedia: true,
                littleEndian: false,
                localStorage: false,
                pointerLock: false,
                support32bit: false,
                vibration: false,
                webGL: false,
                worker: false
            };
            // Check Little or Big Endian system.
            // @author Matt DesLauriers (@mattdesl)
            function checkIsLittleEndian() {
                var a = new ArrayBuffer(4);
                var b = new Uint8Array(a);
                var c = new Uint32Array(a);
                b[0] = 0xa1;
                b[1] = 0xb2;
                b[2] = 0xc3;
                b[3] = 0xd4;
                if (c[0] === 0xd4c3b2a1) return true;
                if (c[0] === 0xa1b2c3d4) return false;
                else //  Could not determine endianness
                return null;
            }
            function init() {
                if (typeof importScripts === "function") return Features;
                Features.canvas = !!window["CanvasRenderingContext2D"];
                try {
                    Features.localStorage = !!localStorage.getItem;
                } catch (error) {
                    Features.localStorage = false;
                }
                Features.file = !!window["File"] && !!window["FileReader"] && !!window["FileList"] && !!window["Blob"];
                Features.fileSystem = !!window["requestFileSystem"];
                var isUint8 = false;
                var testWebGL = function() {
                    if (window["WebGLRenderingContext"]) try {
                        var canvas = CanvasPool.createWebGL(this);
                        var ctx = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
                        var canvas2D = CanvasPool.create2D(this);
                        var ctx2D = canvas2D.getContext("2d");
                        //  Can't be done on a webgl context
                        var image = ctx2D.createImageData(1, 1);
                        //  Test to see if ImageData uses CanvasPixelArray or Uint8ClampedArray.
                        //  @author Matt DesLauriers (@mattdesl)
                        isUint8 = image.data instanceof Uint8ClampedArray;
                        CanvasPool.remove(canvas);
                        CanvasPool.remove(canvas2D);
                        return !!ctx;
                    } catch (e) {
                        return false;
                    }
                    return false;
                };
                Features.webGL = testWebGL();
                Features.worker = !!window["Worker"];
                Features.pointerLock = "pointerLockElement" in document || "mozPointerLockElement" in document || "webkitPointerLockElement" in document;
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
                window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
                Features.getUserMedia = Features.getUserMedia && !!navigator.getUserMedia && !!window.URL;
                // Older versions of firefox (< 21) apparently claim support but user media does not actually work
                if (Browser.firefox && Browser.firefoxVersion < 21) Features.getUserMedia = false;
                // Excludes iOS versions as they generally wrap UIWebView (eg. Safari WebKit) and it
                // is safer to not try and use the fast copy-over method.
                if (!OS.iOS && (Browser.ie || Browser.firefox || Browser.chrome)) Features.canvasBitBltShift = true;
                // Known not to work
                if (Browser.safari || Browser.mobileSafari) Features.canvasBitBltShift = false;
                navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
                if (navigator.vibrate) Features.vibration = true;
                if (typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint32Array !== "undefined") Features.littleEndian = checkIsLittleEndian();
                Features.support32bit = typeof ArrayBuffer !== "undefined" && typeof Uint8ClampedArray !== "undefined" && typeof Int32Array !== "undefined" && Features.littleEndian !== null && isUint8;
                return Features;
            }
            module1.exports = init();
        /***/ },
        /* 192 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Browser specific prefix, so not going to change between contexts, only between browsers
            var prefix = "";
            /**
 * @namespace Phaser.Display.Canvas.Smoothing
 * @since 3.0.0
 */ var Smoothing = function() {
                /**
     * Gets the Smoothing Enabled vendor prefix being used on the given context, or null if not set.
     *
     * @function Phaser.Display.Canvas.Smoothing.getPrefix
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The canvas context to check.
     *
     * @return {string} The name of the property on the context which controls image smoothing (either `imageSmoothingEnabled` or a vendor-prefixed version thereof), or `null` if not supported.
     */ var getPrefix = function(context) {
                    var vendors = [
                        "i",
                        "webkitI",
                        "msI",
                        "mozI",
                        "oI"
                    ];
                    for(var i = 0; i < vendors.length; i++){
                        var s = vendors[i] + "mageSmoothingEnabled";
                        if (s in context) return s;
                    }
                    return null;
                };
                /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.enable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to enable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var enable = function(context) {
                    if (prefix === "") prefix = getPrefix(context);
                    if (prefix) context[prefix] = true;
                    return context;
                };
                /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.disable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to disable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var disable = function(context) {
                    if (prefix === "") prefix = getPrefix(context);
                    if (prefix) context[prefix] = false;
                    return context;
                };
                /**
     * Returns `true` if the given context has image smoothing enabled, otherwise returns `false`.
     * Returns null if no smoothing prefix is available.
     *
     * @function Phaser.Display.Canvas.Smoothing.isEnabled
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context to check.
     *
     * @return {?boolean} `true` if smoothing is enabled on the context, otherwise `false`. `null` if not supported.
     */ var isEnabled = function(context) {
                    return prefix !== null ? context[prefix] : null;
                };
                return {
                    disable: disable,
                    enable: enable,
                    getPrefix: getPrefix,
                    isEnabled: isEnabled
                };
            };
            module1.exports = Smoothing();
        /***/ },
        /* 193 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Math
 */ var PhaserMath = {
                //  Collections of functions
                Angle: __webpack_require__(812),
                Distance: __webpack_require__(821),
                Easing: __webpack_require__(826),
                Fuzzy: __webpack_require__(827),
                Interpolation: __webpack_require__(830),
                Pow2: __webpack_require__(835),
                Snap: __webpack_require__(837),
                //  Expose the RNG Class
                RandomDataGenerator: __webpack_require__(839),
                //  Single functions
                Average: __webpack_require__(840),
                Bernstein: __webpack_require__(356),
                Between: __webpack_require__(195),
                CatmullRom: __webpack_require__(194),
                CeilTo: __webpack_require__(841),
                Clamp: __webpack_require__(18),
                DegToRad: __webpack_require__(36),
                Difference: __webpack_require__(842),
                Euler: __webpack_require__(843),
                Factorial: __webpack_require__(357),
                FloatBetween: __webpack_require__(137),
                FloorTo: __webpack_require__(844),
                FromPercent: __webpack_require__(98),
                GetSpeed: __webpack_require__(845),
                IsEven: __webpack_require__(846),
                IsEvenStrict: __webpack_require__(847),
                Linear: __webpack_require__(135),
                MaxAdd: __webpack_require__(848),
                Median: __webpack_require__(849),
                MinSub: __webpack_require__(850),
                Percent: __webpack_require__(851),
                RadToDeg: __webpack_require__(196),
                RandomXY: __webpack_require__(852),
                RandomXYZ: __webpack_require__(853),
                RandomXYZW: __webpack_require__(854),
                Rotate: __webpack_require__(362),
                RotateAround: __webpack_require__(308),
                RotateAroundDistance: __webpack_require__(182),
                RotateTo: __webpack_require__(855),
                RoundAwayFromZero: __webpack_require__(363),
                RoundTo: __webpack_require__(856),
                SinCosTableGenerator: __webpack_require__(857),
                SmootherStep: __webpack_require__(183),
                SmoothStep: __webpack_require__(184),
                ToXY: __webpack_require__(858),
                TransformXY: __webpack_require__(177),
                Within: __webpack_require__(859),
                Wrap: __webpack_require__(68),
                //  Vector classes
                Vector2: __webpack_require__(3),
                Vector3: __webpack_require__(39),
                Vector4: __webpack_require__(140),
                Matrix3: __webpack_require__(364),
                Matrix4: __webpack_require__(69),
                Quaternion: __webpack_require__(365),
                RotateVec3: __webpack_require__(860)
            };
            //   Merge in the consts
            PhaserMath = Extend(false, PhaserMath, CONST);
            //  Export it
            module1.exports = PhaserMath;
        /***/ },
        /* 194 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a Catmull-Rom value from the given points, based on an alpha of 0.5.
 *
 * @function Phaser.Math.CatmullRom
 * @since 3.0.0
 *
 * @param {number} t - The amount to interpolate by.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 *
 * @return {number} The Catmull-Rom value.
 */ var CatmullRom = function(t, p0, p1, p2, p3) {
                var v0 = (p2 - p0) * 0.5;
                var v1 = (p3 - p1) * 0.5;
                var t2 = t * t;
                var t3 = t * t2;
                return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
            };
            module1.exports = CatmullRom;
        /***/ },
        /* 195 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random integer between the `min` and `max` values, inclusive.
 *
 * @function Phaser.Math.Between
 * @since 3.0.0
 *
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The random integer.
 */ var Between = function(min, max) {
                return Math.floor(Math.random() * (max - min + 1) + min);
            };
            module1.exports = Between;
        /***/ },
        /* 196 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Convert the given angle in radians, to the equivalent angle in degrees.
 *
 * @function Phaser.Math.RadToDeg
 * @since 3.0.0
 *
 * @param {number} radians - The angle in radians to convert ot degrees.
 *
 * @return {number} The given angle converted to degrees.
 */ var RadToDeg = function(radians) {
                return radians * CONST.RAD_TO_DEG;
            };
            module1.exports = RadToDeg;
        /***/ },
        /* 197 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Default Plugins.
 * 
 * @namespace Phaser.Plugins.DefaultPlugins
 * @memberof Phaser.Plugins
 * @since 3.0.0
 */ var DefaultPlugins = {
                /**
     * These are the Global Managers that are created by the Phaser.Game instance.
     * They are referenced from Scene.Systems so that plugins can use them.
     *
     * @name Phaser.Plugins.DefaultPlugins.Global
     * @type {array}
     * @since 3.0.0
     */ Global: [
                    "game",
                    "anims",
                    "cache",
                    "plugins",
                    "registry",
                    "scale",
                    "sound",
                    "textures",
                    "renderer"
                ],
                /**
     * These are the core plugins that are installed into every Scene.Systems instance, no matter what.
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are created in the order in which they appear in this array and EventEmitter is always first.
     *
     * @name Phaser.Plugins.DefaultPlugins.CoreScene
     * @type {array}
     * @since 3.0.0
     */ CoreScene: [
                    "EventEmitter",
                    "CameraManager",
                    "GameObjectCreator",
                    "GameObjectFactory",
                    "ScenePlugin",
                    "DisplayList",
                    "UpdateList"
                ],
                /**
     * These plugins are created in Scene.Systems in addition to the CoreScenePlugins.
     *
     * You can elect not to have these plugins by either creating a DefaultPlugins object as part
     * of the Game Config, by creating a Plugins object as part of a Scene Config, or by modifying this array
     * and building your own bundle.
     *
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are always created in the order in which they appear in the array.
     *
     * @name Phaser.Plugins.DefaultPlugins.DefaultScene
     * @type {array}
     * @since 3.0.0
     */ DefaultScene: [
                    "Clock",
                    "DataManagerPlugin",
                    "InputPlugin",
                    "Loader",
                    "TweenManager",
                    "LightsPlugin"
                ]
            };
            module1.exports = DefaultPlugins;
        /***/ },
        /* 198 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * The ColorMatrix class creates a 5x4 matrix that can be used in shaders and graphics
 * operations. It provides methods required to modify the color values, such as adjusting
 * the brightness, setting a sepia tone, hue rotation and more.
 *
 * Use the method `getData` to return a Float32Array containing the current color values.
 *
 * @class ColorMatrix
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 */ var ColorMatrix = new Class({
                initialize: function ColorMatrix() {
                    /**
         * Internal ColorMatrix array.
         *
         * @name Phaser.Display.ColorMatrix#_matrix
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this._matrix = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ];
                    /**
         * The value that determines how much of the original color is used
         * when mixing the colors. A value between 0 (all original) and 1 (all final)
         *
         * @name Phaser.Display.ColorMatrix#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = 1;
                    /**
         * Is the ColorMatrix array dirty?
         *
         * @name Phaser.Display.ColorMatrix#_dirty
         * @type {boolean}
         * @private
         * @since 3.50.0
         */ this._dirty = true;
                    /**
         * The matrix data as a Float32Array.
         *
         * Returned by the `getData` method.
         *
         * @name Phaser.Display.ColorMatrix#data
         * @type {Float32Array}
         * @private
         * @since 3.50.0
         */ this._data;
                },
                /**
     * Sets this ColorMatrix from the given array of color values.
     *
     * @method Phaser.Display.ColorMatrix#set
     * @since 3.50.0
     *
     * @param {number[]} value - The ColorMatrix values to set.
     *
     * @return {this} This ColorMatrix instance.
     */ set: function(value) {
                    this._matrix = value;
                    this._dirty = true;
                    return this;
                },
                /**
     * Resets the ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#reset
     * @since 3.50.0
     *
     * @return {this} This ColorMatrix instance.
     */ reset: function() {
                    //  Long-winded, but saves on gc, which happens a lot in Post FX Shaders
                    //  that reset the ColorMatrix every frame.
                    var m = this._matrix;
                    m[0] = 1;
                    m[1] = 0;
                    m[2] = 0;
                    m[3] = 0;
                    m[4] = 0;
                    m[5] = 0;
                    m[6] = 1;
                    m[7] = 0;
                    m[8] = 0;
                    m[9] = 0;
                    m[10] = 0;
                    m[11] = 0;
                    m[12] = 1;
                    m[13] = 0;
                    m[14] = 0;
                    m[15] = 0;
                    m[16] = 0;
                    m[17] = 0;
                    m[18] = 1;
                    m[19] = 0;
                    this._dirty = true;
                    return this;
                },
                /**
     * Gets the ColorMatrix as a Float32Array.
     *
     * Can be used directly as a 1fv shader uniform value.
     *
     * @method Phaser.Display.ColorMatrix#getData
     * @since 3.50.0
     *
     * @return {Float32Array} The ColorMatrix as a Float32Array.
     */ getData: function() {
                    if (this._dirty) {
                        var f32 = new Float32Array(this._matrix);
                        f32[4] /= 255;
                        f32[9] /= 255;
                        f32[14] /= 255;
                        f32[19] /= 255;
                        this._data = f32;
                        this._dirty = false;
                    }
                    return this._data;
                },
                /**
     * Changes the brightness of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#brightness
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of brightness to apply to this ColorMatrix. Between 0 (black) and 1.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brightness: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var b = value;
                    return this.multiply([
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Changes the saturation of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#saturate
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of saturation to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ saturate: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var x = value * 2 / 3 + 1;
                    var y = (x - 1) * -0.5;
                    return this.multiply([
                        x,
                        y,
                        y,
                        0,
                        0,
                        y,
                        x,
                        y,
                        0,
                        0,
                        y,
                        y,
                        x,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Desaturates this ColorMatrix (removes color from it).
     *
     * @method Phaser.Display.ColorMatrix#saturation
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturate: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.saturate(-1, multiply);
                },
                /**
     * Rotates the hues of this ColorMatrix by the value given.
     *
     * @method Phaser.Display.ColorMatrix#hue
     * @since 3.50.0
     *
     * @param {number} [rotation=0] - The amount of hue rotation to apply to this ColorMatrix, in degrees.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ hue: function(rotation, multiply) {
                    if (rotation === undefined) rotation = 0;
                    if (multiply === undefined) multiply = false;
                    rotation = rotation / 180 * Math.PI;
                    var cos = Math.cos(rotation);
                    var sin = Math.sin(rotation);
                    var lumR = 0.213;
                    var lumG = 0.715;
                    var lumB = 0.072;
                    return this.multiply([
                        lumR + cos * (1 - lumR) + sin * -lumR,
                        lumG + cos * -lumG + sin * -lumG,
                        lumB + cos * -lumB + sin * (1 - lumB),
                        0,
                        0,
                        lumR + cos * -lumR + sin * 0.143,
                        lumG + cos * (1 - lumG) + sin * 0.140,
                        lumB + cos * -lumB + sin * -0.283,
                        0,
                        0,
                        lumR + cos * -lumR + sin * -(1 - lumR),
                        lumG + cos * -lumG + sin * lumG,
                        lumB + cos * (1 - lumB) + sin * lumB,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Sets this ColorMatrix to be grayscale.
     *
     * @method Phaser.Display.ColorMatrix#grayscale
     * @since 3.50.0
     *
     * @param {number} [value=1] - The grayscale scale (0 is black).
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ grayscale: function(value, multiply) {
                    if (value === undefined) value = 1;
                    if (multiply === undefined) multiply = false;
                    return this.saturate(-value, multiply);
                },
                /**
     * Sets this ColorMatrix to be black and white.
     *
     * @method Phaser.Display.ColorMatrix#blackWhite
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ blackWhite: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Change the contrast of this ColorMatrix by the amount given.
     *
     * @method Phaser.Display.ColorMatrix#contrast
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of contrast to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ contrast: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var v = value + 1;
                    var o = -0.5 * (v - 1);
                    return this.multiply([
                        v,
                        0,
                        0,
                        0,
                        o,
                        0,
                        v,
                        0,
                        0,
                        o,
                        0,
                        0,
                        v,
                        0,
                        o,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Converts this ColorMatrix to have negative values.
     *
     * @method Phaser.Display.ColorMatrix#negative
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ negative: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0,
                        -1,
                        0,
                        1,
                        0,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Apply a desaturated luminance to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#desaturateLuminance
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturateLuminance: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a sepia tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#sepia
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ sepia: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.393,
                        0.7689999,
                        0.18899999,
                        0,
                        0,
                        0.349,
                        0.6859999,
                        0.16799999,
                        0,
                        0,
                        0.272,
                        0.5339999,
                        0.13099999,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a night vision tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#night
     * @since 3.50.0
     *
     * @param {number} [intensity=0.1] - The intensity of this effect.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ night: function(intensity, multiply) {
                    if (intensity === undefined) intensity = 0.1;
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        intensity * -2,
                        -intensity,
                        0,
                        0,
                        0,
                        -intensity,
                        0,
                        intensity,
                        0,
                        0,
                        0,
                        intensity,
                        intensity * 2.0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a trippy color tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#lsd
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ lsd: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        2,
                        -0.4,
                        0.5,
                        0,
                        0,
                        -0.5,
                        2,
                        -0.4,
                        0,
                        0,
                        -0.4,
                        -0.5,
                        3,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a brown tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#brown
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brown: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.5997023498159715,
                        0.34553243048391263,
                        -0.2708298674538042,
                        0,
                        47.43192855600873,
                        -0.037703249837783157,
                        0.8609577587992641,
                        0.15059552388459913,
                        0,
                        -36.96841498319127,
                        0.24113635128153335,
                        -0.07441037908422492,
                        0.44972182064877153,
                        0,
                        -7.562075277591283,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a vintage pinhole color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#vintagePinhole
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ vintagePinhole: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.6279345635605994,
                        0.3202183420819367,
                        -0.03965408211312453,
                        0,
                        9.651285835294123,
                        0.02578397704808868,
                        0.6441188644374771,
                        0.03259127616149294,
                        0,
                        7.462829176470591,
                        0.0466055556782719,
                        -0.0851232987247891,
                        0.5241648018700465,
                        0,
                        5.159190588235296,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a kodachrome color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#kodachrome
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ kodachrome: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.1285582396593525,
                        -0.3967382283601348,
                        -0.03992559172921793,
                        0,
                        63.72958762196502,
                        -0.16404339962244616,
                        1.0835251566291304,
                        -0.05498805115633132,
                        0,
                        24.732407896706203,
                        -0.16786010706155763,
                        -0.5603416277695248,
                        1.6014850761964943,
                        0,
                        35.62982807460946,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a technicolor color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#technicolor
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ technicolor: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.9125277891456083,
                        -0.8545344976951645,
                        -0.09155508482755585,
                        0,
                        11.793603434377337,
                        -0.3087833385928097,
                        1.7658908555458428,
                        -0.10601743074722245,
                        0,
                        -70.35205161461398,
                        -0.231103377548616,
                        -0.7501899197440212,
                        1.847597816108189,
                        0,
                        30.950940869491138,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a polaroid color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#polaroid
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ polaroid: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.438,
                        -0.062,
                        -0.062,
                        0,
                        0,
                        -0.122,
                        1.378,
                        -0.122,
                        0,
                        0,
                        -0.016,
                        -0.016,
                        1.483,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Shifts the values of this ColorMatrix into BGR order.
     *
     * @method Phaser.Display.ColorMatrix#shiftToBGR
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ shiftToBGR: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Multiplies the two given matrices.
     *
     * @method Phaser.Display.ColorMatrix#multiply
     * @since 3.50.0
     *
     * @param {number[]} a - The 5x4 array to multiply with ColorMatrix._matrix.
     *
     * @return {this} This ColorMatrix instance.
     */ multiply: function(a, multiply) {
                    //  Duplicate _matrix into c
                    if (!multiply) this.reset();
                    var m = this._matrix;
                    var c = [];
                    for(var i = 0; i < 20; i++)c[i] = m[i];
                    //  R
                    m[0] = c[0] * a[0] + c[1] * a[5] + c[2] * a[10] + c[3] * a[15];
                    m[1] = c[0] * a[1] + c[1] * a[6] + c[2] * a[11] + c[3] * a[16];
                    m[2] = c[0] * a[2] + c[1] * a[7] + c[2] * a[12] + c[3] * a[17];
                    m[3] = c[0] * a[3] + c[1] * a[8] + c[2] * a[13] + c[3] * a[18];
                    m[4] = c[0] * a[4] + c[1] * a[9] + c[2] * a[14] + c[3] * a[19] + c[4];
                    //  G
                    m[5] = c[5] * a[0] + c[6] * a[5] + c[7] * a[10] + c[8] * a[15];
                    m[6] = c[5] * a[1] + c[6] * a[6] + c[7] * a[11] + c[8] * a[16];
                    m[7] = c[5] * a[2] + c[6] * a[7] + c[7] * a[12] + c[8] * a[17];
                    m[8] = c[5] * a[3] + c[6] * a[8] + c[7] * a[13] + c[8] * a[18];
                    m[9] = c[5] * a[4] + c[6] * a[9] + c[7] * a[14] + c[8] * a[19] + c[9];
                    //  B
                    m[10] = c[10] * a[0] + c[11] * a[5] + c[12] * a[10] + c[13] * a[15];
                    m[11] = c[10] * a[1] + c[11] * a[6] + c[12] * a[11] + c[13] * a[16];
                    m[12] = c[10] * a[2] + c[11] * a[7] + c[12] * a[12] + c[13] * a[17];
                    m[13] = c[10] * a[3] + c[11] * a[8] + c[12] * a[13] + c[13] * a[18];
                    m[14] = c[10] * a[4] + c[11] * a[9] + c[12] * a[14] + c[13] * a[19] + c[14];
                    //  A
                    m[15] = c[15] * a[0] + c[16] * a[5] + c[17] * a[10] + c[18] * a[15];
                    m[16] = c[15] * a[1] + c[16] * a[6] + c[17] * a[11] + c[18] * a[16];
                    m[17] = c[15] * a[2] + c[16] * a[7] + c[17] * a[12] + c[18] * a[17];
                    m[18] = c[15] * a[3] + c[16] * a[8] + c[17] * a[13] + c[18] * a[18];
                    m[19] = c[15] * a[4] + c[16] * a[9] + c[17] * a[14] + c[18] * a[19] + c[19];
                    this._dirty = true;
                    return this;
                }
            });
            module1.exports = ColorMatrix;
        /***/ },
        /* 199 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var MATH_CONST = __webpack_require__(14);
            //  points is an array of Point-like objects,
            //  either 2 dimensional arrays, or objects with public x/y properties:
            //  var points = [
            //      [100, 200],
            //      [200, 400],
            //      { x: 30, y: 60 }
            //  ]
            /**
 * Constructs new Rectangle or repositions and resizes an existing Rectangle so that all of the given points are on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.FromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {array} points - An array of points (either arrays with two elements corresponding to the X and Y coordinate or an object with public `x` and `y` properties) which should be surrounded by the Rectangle.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromPoints = function(points, out) {
                if (out === undefined) out = new Rectangle();
                if (points.length === 0) return out;
                var minX = Number.MAX_VALUE;
                var minY = Number.MAX_VALUE;
                var maxX = MATH_CONST.MIN_SAFE_INTEGER;
                var maxY = MATH_CONST.MIN_SAFE_INTEGER;
                var p;
                var px;
                var py;
                for(var i = 0; i < points.length; i++){
                    p = points[i];
                    if (Array.isArray(p)) {
                        px = p[0];
                        py = p[1];
                    } else {
                        px = p.x;
                        py = p.y;
                    }
                    minX = Math.min(minX, px);
                    minY = Math.min(minY, py);
                    maxX = Math.max(maxX, px);
                    maxY = Math.max(maxY, py);
                }
                out.x = minX;
                out.y = minY;
                out.width = maxX - minX;
                out.height = maxY - minY;
                return out;
            };
            module1.exports = FromPoints;
        /***/ },
        /* 200 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * The RGB class holds a single color value and allows for easy modification and reading of it,
 * with optional on-change callback notification and a dirty flag.
 *
 * @class RGB
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 1.
 * @param {number} [green=0] - The green color value. A number between 0 and 1.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
 */ var RGB = new Class({
                initialize: function RGB(red, green, blue) {
                    /**
         * Cached RGB values.
         *
         * @name Phaser.Display.RGB#_rgb
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this._rgb = [
                        0,
                        0,
                        0
                    ];
                    /**
         * This callback will be invoked each time one of the RGB color values change.
         *
         * The callback is sent the new color values as the parameters.
         *
         * @name Phaser.Display.RGB#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                    /**
         * Is this color dirty?
         *
         * @name Phaser.Display.RGB#dirty
         * @type {boolean}
         * @since 3.50.0
         */ this.dirty = false;
                    this.set(red, green, blue);
                },
                /**
     * Sets the red, green and blue values of this RGB object, flags it as being
     * dirty and then invokes the `onChangeCallback`, if set.
     *
     * @method Phaser.Display.RGB#set
     * @since 3.50.0
     *
     * @param {number} [red=0] - The red color value. A number between 0 and 1.
     * @param {number} [green=0] - The green color value. A number between 0 and 1.
     * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
     *
     * @return {this} This RGB instance.
     */ set: function(red, green, blue) {
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    this._rgb = [
                        red,
                        green,
                        blue
                    ];
                    this.onChange();
                    return this;
                },
                /**
     * Compares the given rgb parameters with those in this object and returns
     * a boolean `true` value if they are equal, otherwise it returns `false`.
     *
     * @method Phaser.Display.RGB#equals
     * @since 3.50.0
     *
     * @param {number} red - The red value to compare with this object.
     * @param {number} green - The green value to compare with this object.
     * @param {number} blue - The blue value to compare with this object.
     *
     * @return {boolean} `true` if the given values match those in this object, otherwise `false`.
     */ equals: function(red, green, blue) {
                    var rgb = this._rgb;
                    return rgb.r === red && rgb.g === green && rgb.b === blue;
                },
                /**
     * Internal on change handler. Sets this object as being dirty and
     * then invokes the `onChangeCallback`, if set, passing in the
     * new RGB values.
     *
     * @method Phaser.Display.RGB#onChange
     * @since 3.50.0
     */ onChange: function() {
                    this.dirty = true;
                    var rgb = this._rgb;
                    this.onChangeCallback.call(this, rgb[0], rgb[1], rgb[2]);
                },
                /**
     * The red color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#r
     * @type {number}
     * @since 3.50.0
     */ r: {
                    get: function() {
                        return this._rgb[0];
                    },
                    set: function(value) {
                        this._rgb[0] = value;
                        this.onChange();
                    }
                },
                /**
     * The green color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#g
     * @type {number}
     * @since 3.50.0
     */ g: {
                    get: function() {
                        return this._rgb[1];
                    },
                    set: function(value) {
                        this._rgb[1] = value;
                        this.onChange();
                    }
                },
                /**
     * The blue color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#b
     * @type {number}
     * @since 3.50.0
     */ b: {
                    get: function() {
                        return this._rgb[2];
                    },
                    set: function(value) {
                        this._rgb[2] = value;
                        this.onChange();
                    }
                },
                /**
     * Nulls any external references this object contains.
     *
     * @method Phaser.Display.RGB#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.onChangeCallback = null;
                }
            });
            module1.exports = RGB;
        /***/ },
        /* 201 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                CENTER: __webpack_require__(403),
                ORIENTATION: __webpack_require__(404),
                SCALE_MODE: __webpack_require__(405),
                ZOOM: __webpack_require__(406)
            };
            module1.exports = CONST;
        /***/ },
        /* 202 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to remove the element from its parentNode in the DOM.
 *
 * @function Phaser.DOM.RemoveFromDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The DOM element to remove from its parent node.
 */ var RemoveFromDOM = function(element) {
                if (element.parentNode) element.parentNode.removeChild(element);
            };
            module1.exports = RemoveFromDOM;
        /***/ },
        /* 203 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var INPUT_CONST = {
                /**
     * The mouse pointer is being held down.
     * 
     * @name Phaser.Input.MOUSE_DOWN
     * @type {number}
     * @since 3.10.0
     */ MOUSE_DOWN: 0,
                /**
     * The mouse pointer is being moved.
     * 
     * @name Phaser.Input.MOUSE_MOVE
     * @type {number}
     * @since 3.10.0
     */ MOUSE_MOVE: 1,
                /**
     * The mouse pointer is released.
     * 
     * @name Phaser.Input.MOUSE_UP
     * @type {number}
     * @since 3.10.0
     */ MOUSE_UP: 2,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_START
     * @type {number}
     * @since 3.10.0
     */ TOUCH_START: 3,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_MOVE
     * @type {number}
     * @since 3.10.0
     */ TOUCH_MOVE: 4,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_END
     * @type {number}
     * @since 3.10.0
     */ TOUCH_END: 5,
                /**
     * The pointer lock has changed.
     * 
     * @name Phaser.Input.POINTER_LOCK_CHANGE
     * @type {number}
     * @since 3.10.0
     */ POINTER_LOCK_CHANGE: 6,
                /**
     * A touch pointer has been been cancelled by the browser.
     * 
     * @name Phaser.Input.TOUCH_CANCEL
     * @type {number}
     * @since 3.15.0
     */ TOUCH_CANCEL: 7,
                /**
     * The mouse wheel changes.
     * 
     * @name Phaser.Input.MOUSE_WHEEL
     * @type {number}
     * @since 3.18.0
     */ MOUSE_WHEEL: 8
            };
            module1.exports = INPUT_CONST;
        /***/ },
        /* 204 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(144);
            var DefaultPlugins = __webpack_require__(197);
            var Events = __webpack_require__(20);
            var GetPhysicsPlugins = __webpack_require__(419);
            var GetScenePlugins = __webpack_require__(420);
            var GLOBAL_CONST = __webpack_require__(33);
            var NOOP = __webpack_require__(1);
            var Settings = __webpack_require__(421);
            /**
 * @classdesc
 * The Scene Systems class.
 *
 * This class is available from within a Scene under the property `sys`.
 * It is responsible for managing all of the plugins a Scene has running, including the display list, and
 * handling the update step and renderer. It also contains references to global systems belonging to Game.
 *
 * @class Systems
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns this Systems instance.
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - Scene specific configuration settings.
 */ var Systems = new Class({
                initialize: function Systems(scene, config) {
                    /**
         * A reference to the Scene that these Systems belong to.
         *
         * @name Phaser.Scenes.Systems#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Phaser Game instance.
         *
         * @name Phaser.Scenes.Systems#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Scenes.Systems#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer;
                    /**
         * The Scene Configuration object, as passed in when creating the Scene.
         *
         * @name Phaser.Scenes.Systems#config
         * @type {(string|Phaser.Types.Scenes.SettingsConfig)}
         * @since 3.0.0
         */ this.config = config;
                    /**
         * The Scene Settings. This is the parsed output based on the Scene configuration.
         *
         * @name Phaser.Scenes.Systems#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = Settings.create(config);
                    /**
         * A handy reference to the Scene canvas / context.
         *
         * @name Phaser.Scenes.Systems#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                    /**
         * A reference to the Canvas Rendering Context being used by the renderer.
         *
         * @name Phaser.Scenes.Systems#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context;
                    //  Global Systems - these are single-instance global managers that belong to Game
                    /**
         * A reference to the global Animations Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.anims` property.
         *
         * @name Phaser.Scenes.Systems#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                    /**
         * A reference to the global Cache. The Cache stores all files bought in to Phaser via
         * the Loader, with the exception of images. Images are stored in the Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.cache` property.
         *
         * @name Phaser.Scenes.Systems#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                    /**
         * A reference to the global Plugins Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.plugins` property.
         *
         * @name Phaser.Scenes.Systems#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                    /**
         * A reference to the global registry. This is a game-wide instance of the Data Manager, allowing
         * you to exchange data between Scenes via a universal and shared point.
         *
         * In the default set-up you can access this from within a Scene via the `this.registry` property.
         *
         * @name Phaser.Scenes.Systems#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                    /**
         * A reference to the global Scale Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.scale` property.
         *
         * @name Phaser.Scenes.Systems#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.15.0
         */ this.scale;
                    /**
         * A reference to the global Sound Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.sound` property.
         *
         * @name Phaser.Scenes.Systems#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound;
                    /**
         * A reference to the global Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.textures` property.
         *
         * @name Phaser.Scenes.Systems#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                    //  Core Plugins - these are non-optional Scene plugins, needed by lots of the other systems
                    /**
         * A reference to the Scene's Game Object Factory.
         *
         * Use this to quickly and easily create new Game Object's.
         *
         * In the default set-up you can access this from within a Scene via the `this.add` property.
         *
         * @name Phaser.Scenes.Systems#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                    /**
         * A reference to the Scene's Camera Manager.
         *
         * Use this to manipulate and create Cameras for this specific Scene.
         *
         * In the default set-up you can access this from within a Scene via the `this.cameras` property.
         *
         * @name Phaser.Scenes.Systems#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    /**
         * A reference to the Scene's Display List.
         *
         * Use this to organize the children contained in the display list.
         *
         * In the default set-up you can access this from within a Scene via the `this.children` property.
         *
         * @name Phaser.Scenes.Systems#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene's Event Manager.
         *
         * Use this to listen for Scene specific events, such as `pause` and `shutdown`.
         *
         * In the default set-up you can access this from within a Scene via the `this.events` property.
         *
         * @name Phaser.Scenes.Systems#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                    /**
         * A reference to the Scene's Game Object Creator.
         *
         * Use this to quickly and easily create new Game Object's. The difference between this and the
         * Game Object Factory, is that the Creator just creates and returns Game Object instances, it
         * doesn't then add them to the Display List or Update List.
         *
         * In the default set-up you can access this from within a Scene via the `this.make` property.
         *
         * @name Phaser.Scenes.Systems#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                    /**
         * A reference to the Scene Manager Plugin.
         *
         * Use this to manipulate both this and other Scene's in your game, for example to launch a parallel Scene,
         * or pause or resume a Scene, or switch from this Scene to another.
         *
         * In the default set-up you can access this from within a Scene via the `this.scene` property.
         *
         * @name Phaser.Scenes.Systems#scenePlugin
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scenePlugin;
                    /**
         * A reference to the Scene's Update List.
         *
         * Use this to organize the children contained in the update list.
         *
         * The Update List is responsible for managing children that need their `preUpdate` methods called,
         * in order to process so internal components, such as Sprites with Animations.
         *
         * In the default set-up there is no reference to this from within the Scene itself.
         *
         * @name Phaser.Scenes.Systems#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @since 3.0.0
         */ this.updateList;
                    /**
         * The Scene Update function.
         *
         * This starts out as NOOP during init, preload and create, and at the end of create
         * it swaps to be whatever the Scene.update function is.
         *
         * @name Phaser.Scenes.Systems#sceneUpdate
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.sceneUpdate = NOOP;
                },
                /**
     * This method is called only once by the Scene Manager when the Scene is instantiated.
     * It is responsible for setting up all of the Scene plugins and references.
     * It should never be called directly.
     *
     * @method Phaser.Scenes.Systems#init
     * @protected
     * @fires Phaser.Scenes.Events#BOOT
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                    this.settings.status = CONST.INIT;
                    //  This will get replaced by the SceneManager with the actual update function, if it exists, once create is over.
                    this.sceneUpdate = NOOP;
                    this.game = game;
                    this.renderer = game.renderer;
                    this.canvas = game.canvas;
                    this.context = game.context;
                    var pluginManager = game.plugins;
                    this.plugins = pluginManager;
                    pluginManager.addToScene(this, DefaultPlugins.Global, [
                        DefaultPlugins.CoreScene,
                        GetScenePlugins(this),
                        GetPhysicsPlugins(this)
                    ]);
                    this.events.emit(Events.BOOT, this);
                    this.settings.isBooted = true;
                },
                /**
     * A single game step. Called automatically by the Scene Manager as a result of a Request Animation
     * Frame or Set Timeout call to the main Game instance.
     *
     * @method Phaser.Scenes.Systems#step
     * @fires Phaser.Scenes.Events#PRE_UPDATE
     * @fires Phaser.Scenes.Events#UPDATE
     * @fires Phaser.Scenes.Events#POST_UPDATE
     * @since 3.0.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                    var events = this.events;
                    events.emit(Events.PRE_UPDATE, time, delta);
                    events.emit(Events.UPDATE, time, delta);
                    this.sceneUpdate.call(this.scene, time, delta);
                    events.emit(Events.POST_UPDATE, time, delta);
                },
                /**
     * Called automatically by the Scene Manager.
     * Instructs the Scene to render itself via its Camera Manager to the renderer given.
     *
     * @method Phaser.Scenes.Systems#render
     * @fires Phaser.Scenes.Events#PRE_RENDER
     * @fires Phaser.Scenes.Events#RENDER
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that invoked the render call.
     */ render: function(renderer) {
                    var displayList = this.displayList;
                    displayList.depthSort();
                    this.events.emit(Events.PRE_RENDER, renderer);
                    this.cameras.render(renderer, displayList);
                    this.events.emit(Events.RENDER, renderer);
                },
                /**
     * Force a sort of the display list on the next render.
     *
     * @method Phaser.Scenes.Systems#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                    this.displayList.queueDepthSort();
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.Scenes.Systems#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                    this.displayList.depthSort();
                },
                /**
     * Pause this Scene.
     * A paused Scene still renders, it just doesn't run ANY of its update handlers or systems.
     *
     * @method Phaser.Scenes.Systems#pause
     * @fires Phaser.Scenes.Events#PAUSE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'pause' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ pause: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (this.settings.active) {
                        settings.status = CONST.PAUSED;
                        settings.active = false;
                        events.emit(Events.PAUSE, this, data);
                    }
                    return this;
                },
                /**
     * Resume this Scene from a paused state.
     *
     * @method Phaser.Scenes.Systems#resume
     * @fires Phaser.Scenes.Events#RESUME
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'resume' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ resume: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (!this.settings.active) {
                        settings.status = CONST.RUNNING;
                        settings.active = true;
                        events.emit(Events.RESUME, this, data);
                    }
                    return this;
                },
                /**
     * Send this Scene to sleep.
     *
     * A sleeping Scene doesn't run its update step or render anything, but it also isn't shut down
     * or has any of its systems or children removed, meaning it can be re-activated at any point and
     * will carry on from where it left off. It also keeps everything in memory and events and callbacks
     * from other Scenes may still invoke changes within it, so be careful what is left active.
     *
     * @method Phaser.Scenes.Systems#sleep
     * @fires Phaser.Scenes.Events#SLEEP
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'sleep' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ sleep: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.SLEEPING;
                    settings.active = false;
                    settings.visible = false;
                    events.emit(Events.SLEEP, this, data);
                    return this;
                },
                /**
     * Wake-up this Scene if it was previously asleep.
     *
     * @method Phaser.Scenes.Systems#wake
     * @fires Phaser.Scenes.Events#WAKE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'wake' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ wake: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.RUNNING;
                    settings.active = true;
                    settings.visible = true;
                    events.emit(Events.WAKE, this, data);
                    if (settings.isTransition) events.emit(Events.TRANSITION_WAKE, settings.transitionFrom, settings.transitionDuration);
                    return this;
                },
                /**
     * Returns any data that was sent to this Scene by another Scene.
     *
     * The data is also passed to `Scene.init` and in various Scene events, but
     * you can access it at any point via this method.
     *
     * @method Phaser.Scenes.Systems#getData
     * @since 3.22.0
     *
     * @return {any}
     */ getData: function() {
                    return this.settings.data;
                },
                /**
     * Is this Scene sleeping?
     *
     * @method Phaser.Scenes.Systems#isSleeping
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is asleep, otherwise `false`.
     */ isSleeping: function() {
                    return this.settings.status === CONST.SLEEPING;
                },
                /**
     * Is this Scene running?
     *
     * @method Phaser.Scenes.Systems#isActive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is running, otherwise `false`.
     */ isActive: function() {
                    return this.settings.status === CONST.RUNNING;
                },
                /**
     * Is this Scene paused?
     *
     * @method Phaser.Scenes.Systems#isPaused
     * @since 3.13.0
     *
     * @return {boolean} `true` if this Scene is paused, otherwise `false`.
     */ isPaused: function() {
                    return this.settings.status === CONST.PAUSED;
                },
                /**
     * Is this Scene currently transitioning out to, or in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitioning
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is currently transitioning, otherwise `false`.
     */ isTransitioning: function() {
                    return this.settings.isTransition || this.scenePlugin._target !== null;
                },
                /**
     * Is this Scene currently transitioning out from itself to another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionOut
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is in transition to another Scene, otherwise `false`.
     */ isTransitionOut: function() {
                    return this.scenePlugin._target !== null && this.scenePlugin._duration > 0;
                },
                /**
     * Is this Scene currently transitioning in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionIn
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is transitioning in from another Scene, otherwise `false`.
     */ isTransitionIn: function() {
                    return this.settings.isTransition;
                },
                /**
     * Is this Scene visible and rendering?
     *
     * @method Phaser.Scenes.Systems#isVisible
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is visible, otherwise `false`.
     */ isVisible: function() {
                    return this.settings.visible;
                },
                /**
     * Sets the visible state of this Scene.
     * An invisible Scene will not render, but will still process updates.
     *
     * @method Phaser.Scenes.Systems#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to render this Scene, otherwise `false`.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setVisible: function(value) {
                    this.settings.visible = value;
                    return this;
                },
                /**
     * Set the active state of this Scene.
     *
     * An active Scene will run its core update loop.
     *
     * @method Phaser.Scenes.Systems#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - If `true` the Scene will be resumed, if previously paused. If `false` it will be paused.
     * @param {object} [data] - A data object that will be passed in the 'resume' or 'pause' events.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setActive: function(value, data) {
                    if (value) return this.resume(data);
                    else return this.pause(data);
                },
                /**
     * Start this Scene running and rendering.
     * Called automatically by the SceneManager.
     *
     * @method Phaser.Scenes.Systems#start
     * @fires Phaser.Scenes.Events#START
     * @fires Phaser.Scenes.Events#READY
     * @since 3.0.0
     *
     * @param {object} data - Optional data object that may have been passed to this Scene from another.
     */ start: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (data) settings.data = data;
                    settings.status = CONST.START;
                    settings.active = true;
                    settings.visible = true;
                    //  For plugins to listen out for
                    events.emit(Events.START, this);
                    //  For user-land code to listen out for
                    events.emit(Events.READY, this, data);
                },
                /**
     * Shutdown this Scene and send a shutdown event to all of its systems.
     * A Scene that has been shutdown will not run its update loop or render, but it does
     * not destroy any of its plugins or references. It is put into hibernation for later use.
     * If you don't ever plan to use this Scene again, then it should be destroyed instead
     * to free-up resources.
     *
     * @method Phaser.Scenes.Systems#shutdown
     * @fires Phaser.Scenes.Events#SHUTDOWN
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'shutdown' event.
     */ shutdown: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    events.off(Events.TRANSITION_INIT);
                    events.off(Events.TRANSITION_START);
                    events.off(Events.TRANSITION_COMPLETE);
                    events.off(Events.TRANSITION_OUT);
                    settings.status = CONST.SHUTDOWN;
                    settings.active = false;
                    settings.visible = false;
                    if (this.renderer === GLOBAL_CONST.WEBGL) this.renderer.resetTextures(true);
                    events.emit(Events.SHUTDOWN, this, data);
                },
                /**
     * Destroy this Scene and send a destroy event all of its systems.
     * A destroyed Scene cannot be restarted.
     * You should not call this directly, instead use `SceneManager.remove`.
     *
     * @method Phaser.Scenes.Systems#destroy
     * @private
     * @fires Phaser.Scenes.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.DESTROYED;
                    settings.active = false;
                    settings.visible = false;
                    events.emit(Events.DESTROY, this);
                    events.removeAllListeners();
                    var props = [
                        "scene",
                        "game",
                        "anims",
                        "cache",
                        "plugins",
                        "registry",
                        "sound",
                        "textures",
                        "add",
                        "camera",
                        "displayList",
                        "events",
                        "make",
                        "scenePlugin",
                        "updateList"
                    ];
                    for(var i = 0; i < props.length; i++)this[props[i]] = null;
                }
            });
            module1.exports = Systems;
        /***/ },
        /* 205 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Capitalizes the first letter of a string if there is one.
 * @example
 * UppercaseFirst('abc');
 * // returns 'Abc'
 * @example
 * UppercaseFirst('the happy family');
 * // returns 'The happy family'
 * @example
 * UppercaseFirst('');
 * // returns ''
 *
 * @function Phaser.Utils.String.UppercaseFirst
 * @since 3.0.0
 *
 * @param {string} str - The string to capitalize.
 *
 * @return {string} A new string, same as the first, but with the first letter capitalized.
 */ var UppercaseFirst = function(str) {
                return str && str[0].toUpperCase() + str.slice(1);
            };
            module1.exports = UppercaseFirst;
        /***/ },
        /* 206 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(33);
            var Class = __webpack_require__(0);
            var Frame = __webpack_require__(109);
            var TextureSource = __webpack_require__(424);
            var TEXTURE_MISSING_ERROR = "Texture.frame missing: ";
            /**
 * @classdesc
 * A Texture consists of a source, usually an Image from the Cache, and a collection of Frames.
 * The Frames represent the different areas of the Texture. For example a texture atlas
 * may have many Frames, one for each element within the atlas. Where-as a single image would have
 * just one frame, that encompasses the whole image.
 *
 * Every Texture, no matter where it comes from, always has at least 1 frame called the `__BASE` frame.
 * This frame represents the entirety of the source image.
 *
 * Textures are managed by the global TextureManager. This is a singleton class that is
 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
 *
 * Sprites and other Game Objects get the texture data they need from the TextureManager.
 *
 * @class Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[])} source - An array of sources that are used to create the texture. Usually Images, but can also be a Canvas.
 * @param {number} [width] - The width of the Texture. This is optional and automatically derived from the source images.
 * @param {number} [height] - The height of the Texture. This is optional and automatically derived from the source images.
 */ var Texture = new Class({
                initialize: function Texture(manager, key, source, width, height) {
                    if (!Array.isArray(source)) source = [
                        source
                    ];
                    /**
         * A reference to the Texture Manager this Texture belongs to.
         *
         * @name Phaser.Textures.Texture#manager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The unique string-based key of this Texture.
         *
         * @name Phaser.Textures.Texture#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                    /**
         * An array of TextureSource instances.
         * These are unique to this Texture and contain the actual Image (or Canvas) data.
         *
         * @name Phaser.Textures.Texture#source
         * @type {Phaser.Textures.TextureSource[]}
         * @since 3.0.0
         */ this.source = [];
                    /**
         * An array of TextureSource data instances.
         * Used to store additional data images, such as normal maps or specular maps.
         *
         * @name Phaser.Textures.Texture#dataSource
         * @type {array}
         * @since 3.0.0
         */ this.dataSource = [];
                    /**
         * A key-value object pair associating the unique Frame keys with the Frames objects.
         *
         * @name Phaser.Textures.Texture#frames
         * @type {object}
         * @since 3.0.0
         */ this.frames = {};
                    /**
         * Any additional data that was set in the source JSON (if any),
         * or any extra data you'd like to store relating to this texture
         *
         * @name Phaser.Textures.Texture#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                    /**
         * The name of the first frame of the Texture.
         *
         * @name Phaser.Textures.Texture#firstFrame
         * @type {string}
         * @since 3.0.0
         */ this.firstFrame = "__BASE";
                    /**
         * The total number of Frames in this Texture, including the `__BASE` frame.
         *
         * A Texture will always contain at least 1 frame because every Texture contains a `__BASE` frame by default,
         * in addition to any extra frames that have been added to it, such as when parsing a Sprite Sheet or Texture Atlas.
         *
         * @name Phaser.Textures.Texture#frameTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameTotal = 0;
                    //  Load the Sources
                    for(var i = 0; i < source.length; i++)this.source.push(new TextureSource(this, source[i], width, height));
                },
                /**
     * Adds a new Frame to this Texture.
     *
     * A Frame is a rectangular region of a TextureSource with a unique index or string-based key.
     *
     * The name given must be unique within this Texture. If it already exists, this method will return `null`.
     *
     * @method Phaser.Textures.Texture#add
     * @since 3.0.0
     *
     * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
     * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
     * @param {number} x - The x coordinate of the top-left of this Frame.
     * @param {number} y - The y coordinate of the top-left of this Frame.
     * @param {number} width - The width of this Frame.
     * @param {number} height - The height of this Frame.
     *
     * @return {?Phaser.Textures.Frame} The Frame that was added to this Texture, or `null` if the given name already exists.
     */ add: function(name, sourceIndex, x, y, width, height) {
                    if (this.has(name)) return null;
                    var frame = new Frame(this, name, sourceIndex, x, y, width, height);
                    this.frames[name] = frame;
                    //  Set the first frame of the Texture (other than __BASE)
                    //  This is used to ensure we don't spam the display with entire
                    //  atlases of sprite sheets, but instead just the first frame of them
                    //  should the dev incorrectly specify the frame index
                    if (this.firstFrame === "__BASE") this.firstFrame = name;
                    this.frameTotal++;
                    return frame;
                },
                /**
     * Removes the given Frame from this Texture. The Frame is destroyed immediately.
     *
     * Any Game Objects using this Frame should stop using it _before_ you remove it,
     * as it does not happen automatically.
     *
     * @method Phaser.Textures.Texture#remove
     * @since 3.19.0
     *
     * @param {string} name - The key of the Frame to remove.
     *
     * @return {boolean} True if a Frame with the matching key was removed from this Texture.
     */ remove: function(name) {
                    if (this.has(name)) {
                        var frame = this.get(name);
                        frame.destroy();
                        delete this.frames[name];
                        return true;
                    }
                    return false;
                },
                /**
     * Checks to see if a Frame matching the given key exists within this Texture.
     *
     * @method Phaser.Textures.Texture#has
     * @since 3.0.0
     *
     * @param {string} name - The key of the Frame to check for.
     *
     * @return {boolean} True if a Frame with the matching key exists in this Texture.
     */ has: function(name) {
                    return this.frames[name];
                },
                /**
     * Gets a Frame from this Texture based on either the key or the index of the Frame.
     *
     * In a Texture Atlas Frames are typically referenced by a key.
     * In a Sprite Sheet Frames are referenced by an index.
     * Passing no value for the name returns the base texture.
     *
     * @method Phaser.Textures.Texture#get
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {Phaser.Textures.Frame} The Texture Frame.
     */ get: function(name) {
                    //  null, undefined, empty string, zero
                    if (!name) name = this.firstFrame;
                    var frame = this.frames[name];
                    if (!frame) {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        frame = this.frames[this.firstFrame];
                    }
                    return frame;
                },
                /**
     * Takes the given TextureSource and returns the index of it within this Texture.
     * If it's not in this Texture, it returns -1.
     * Unless this Texture has multiple TextureSources, such as with a multi-atlas, this
     * method will always return zero or -1.
     *
     * @method Phaser.Textures.Texture#getTextureSourceIndex
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureSource} source - The TextureSource to check.
     *
     * @return {number} The index of the TextureSource within this Texture, or -1 if not in this Texture.
     */ getTextureSourceIndex: function(source) {
                    for(var i = 0; i < this.source.length; i++){
                        if (this.source[i] === source) return i;
                    }
                    return -1;
                },
                /**
     * Returns an array of all the Frames in the given TextureSource.
     *
     * @method Phaser.Textures.Texture#getFramesFromTextureSource
     * @since 3.0.0
     *
     * @param {number} sourceIndex - The index of the TextureSource to get the Frames from.
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {Phaser.Textures.Frame[]} An array of Texture Frames.
     */ getFramesFromTextureSource: function(sourceIndex, includeBase) {
                    if (includeBase === undefined) includeBase = false;
                    var out = [];
                    for(var frameName in this.frames){
                        if (frameName === "__BASE" && !includeBase) continue;
                        var frame = this.frames[frameName];
                        if (frame.sourceIndex === sourceIndex) out.push(frame);
                    }
                    return out;
                },
                /**
     * Returns an array with all of the names of the Frames in this Texture.
     *
     * Useful if you want to randomly assign a Frame to a Game Object, as you can
     * pick a random element from the returned array.
     *
     * @method Phaser.Textures.Texture#getFrameNames
     * @since 3.0.0
     *
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {string[]} An array of all Frame names in this Texture.
     */ getFrameNames: function(includeBase) {
                    if (includeBase === undefined) includeBase = false;
                    var out = Object.keys(this.frames);
                    if (!includeBase) {
                        var idx = out.indexOf("__BASE");
                        if (idx !== -1) out.splice(idx, 1);
                    }
                    return out;
                },
                /**
     * Given a Frame name, return the source image it uses to render with.
     *
     * This will return the actual DOM Image or Canvas element.
     *
     * @method Phaser.Textures.Texture#getSourceImage
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement|Phaser.GameObjects.RenderTexture)} The DOM Image, Canvas Element or Render Texture.
     */ getSourceImage: function(name) {
                    if (name === undefined || name === null || this.frameTotal === 1) name = "__BASE";
                    var frame = this.frames[name];
                    if (frame) return frame.source.image;
                    else {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        return this.frames["__BASE"].source.image;
                    }
                },
                /**
     * Given a Frame name, return the data source image it uses to render with.
     * You can use this to get the normal map for an image for example.
     *
     * This will return the actual DOM Image.
     *
     * @method Phaser.Textures.Texture#getDataSourceImage
     * @since 3.7.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement)} The DOM Image or Canvas Element.
     */ getDataSourceImage: function(name) {
                    if (name === undefined || name === null || this.frameTotal === 1) name = "__BASE";
                    var frame = this.frames[name];
                    var idx;
                    if (!frame) {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        idx = this.frames["__BASE"].sourceIndex;
                    } else idx = frame.sourceIndex;
                    return this.dataSource[idx].image;
                },
                /**
     * Adds a data source image to this Texture.
     *
     * An example of a data source image would be a normal map, where all of the Frames for this Texture
     * equally apply to the normal map.
     *
     * @method Phaser.Textures.Texture#setDataSource
     * @since 3.0.0
     *
     * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[])} data - The source image.
     */ setDataSource: function(data) {
                    if (!Array.isArray(data)) data = [
                        data
                    ];
                    for(var i = 0; i < data.length; i++){
                        var source = this.source[i];
                        this.dataSource.push(new TextureSource(this, data[i], source.width, source.height));
                    }
                },
                /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * The mode applies to the entire Texture, not just a specific Frame of it.
     *
     * @method Phaser.Textures.Texture#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                    var i;
                    for(i = 0; i < this.source.length; i++)this.source[i].setFilter(filterMode);
                    for(i = 0; i < this.dataSource.length; i++)this.dataSource[i].setFilter(filterMode);
                },
                /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.Texture#destroy
     * @since 3.0.0
     */ destroy: function() {
                    var i;
                    for(i = 0; i < this.source.length; i++)this.source[i].destroy();
                    for(i = 0; i < this.dataSource.length; i++)this.dataSource[i].destroy();
                    for(var frameName in this.frames){
                        var frame = this.frames[frameName];
                        frame.destroy();
                    }
                    this.source = [];
                    this.dataSource = [];
                    this.frames = {};
                    this.manager.removeKey(this.key);
                    var renderer = this.manager.game.renderer;
                    if (renderer && renderer.type === CONST.WEBGL) renderer.resetTextures(true);
                    this.manager = null;
                }
            });
            module1.exports = Texture;
        /***/ },
        /* 207 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns all elements in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return only elements that have their visible property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
 * the first 50 elements.
 *
 * @function Phaser.Utils.Array.GetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} All matching elements from the array.
 */ var GetAll = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                var output = [];
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) output.push(child);
                }
                return output;
            };
            module1.exports = GetAll;
        /***/ },
        /* 208 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array
 */ module1.exports = {
                Matrix: __webpack_require__(1013),
                Add: __webpack_require__(1021),
                AddAt: __webpack_require__(1022),
                BringToTop: __webpack_require__(1023),
                CountAllMatching: __webpack_require__(1024),
                Each: __webpack_require__(1025),
                EachInRange: __webpack_require__(1026),
                FindClosestInSorted: __webpack_require__(318),
                GetAll: __webpack_require__(207),
                GetFirst: __webpack_require__(428),
                GetRandom: __webpack_require__(210),
                MoveDown: __webpack_require__(1027),
                MoveTo: __webpack_require__(1028),
                MoveUp: __webpack_require__(1029),
                MoveAbove: __webpack_require__(1030),
                MoveBelow: __webpack_require__(1031),
                NumberArray: __webpack_require__(322),
                NumberArrayStep: __webpack_require__(1032),
                QuickSelect: __webpack_require__(436),
                Range: __webpack_require__(437),
                Remove: __webpack_require__(93),
                RemoveAt: __webpack_require__(1033),
                RemoveBetween: __webpack_require__(1034),
                RemoveRandomElement: __webpack_require__(1035),
                Replace: __webpack_require__(1036),
                RotateLeft: __webpack_require__(178),
                RotateRight: __webpack_require__(179),
                SafeRange: __webpack_require__(78),
                SendToBack: __webpack_require__(1037),
                SetAll: __webpack_require__(1038),
                Shuffle: __webpack_require__(131),
                SortByDigits: __webpack_require__(320),
                SpliceOne: __webpack_require__(74),
                StableSort: __webpack_require__(79),
                Swap: __webpack_require__(1039)
            };
        /***/ },
        /* 209 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if an array can be used as a matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.CheckMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - The array to check.
 *
 * @return {boolean} `true` if the given `matrix` array is a valid matrix.
 */ var CheckMatrix = function(matrix) {
                if (!Array.isArray(matrix) || matrix.length < 2 || !Array.isArray(matrix[0])) return false;
                //  How long is the first row?
                var size = matrix[0].length;
                //  Validate the rest of the rows are the same length
                for(var i = 1; i < matrix.length; i++){
                    if (matrix[i].length !== size) return false;
                }
                return true;
            };
            module1.exports = CheckMatrix;
        /***/ },
        /* 210 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a Random element from the array.
 *
 * @function Phaser.Utils.Array.GetRandom
 * @since 3.0.0
 *
 * @param {array} array - The array to select the random entry from.
 * @param {number} [startIndex=0] - An optional start index.
 * @param {number} [length=array.length] - An optional length, the total number of elements (from the startIndex) to choose from.
 *
 * @return {*} A random element from the array, or `null` if no element could be found in the range given.
 */ var GetRandom = function(array, startIndex, length) {
                if (startIndex === undefined) startIndex = 0;
                if (length === undefined) length = array.length;
                var randomIndex = startIndex + Math.floor(Math.random() * length);
                return array[randomIndex] === undefined ? null : array[randomIndex];
            };
            module1.exports = GetRandom;
        /***/ },
        /* 211 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(438);
            /**
 * @classdesc
 * A Process Queue maintains three internal lists.
 *
 * The `pending` list is a selection of items which are due to be made 'active' in the next update.
 * The `active` list is a selection of items which are considered active and should be updated.
 * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
 *
 * When new items are added to a Process Queue they are put in the pending list, rather than being added
 * immediately the active list. Equally, items that are removed are put into the destroy list, rather than
 * being destroyed immediately. This allows the Process Queue to carefully process each item at a specific, fixed
 * time, rather than at the time of the request from the API.
 *
 * @class ProcessQueue
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 */ var ProcessQueue = new Class({
                Extends: EventEmitter,
                initialize: function ProcessQueue() {
                    EventEmitter.call(this);
                    /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                    /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._destroy = [];
                    /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.Structs.ProcessQueue#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._toProcess = 0;
                    /**
         * If `true` only unique objects will be allowed in the queue.
         *
         * @name Phaser.Structs.ProcessQueue#checkQueue
         * @type {boolean}
         * @since 3.50.0
         */ this.checkQueue = false;
                },
                /**
     * Adds a new item to the Process Queue.
     *
     * The item is added to the pending list and made active in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#add
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to add to the queue.
     *
     * @return {*} The item that was added.
     */ add: function(item) {
                    this._pending.push(item);
                    this._toProcess++;
                    return item;
                },
                /**
     * Removes an item from the Process Queue.
     *
     * The item is added to the pending destroy and fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#remove
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to be removed from the queue.
     *
     * @return {*} The item that was removed.
     */ remove: function(item) {
                    this._destroy.push(item);
                    this._toProcess++;
                    return item;
                },
                /**
     * Removes all active items from this Process Queue.
     *
     * All the items are marked as 'pending destroy' and fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#removeAll
     * @since 3.20.0
     *
     * @return {this} This Process Queue object.
     */ removeAll: function() {
                    var list = this._active;
                    var destroy = this._destroy;
                    var i = list.length;
                    while(i--){
                        destroy.push(list[i]);
                        this._toProcess++;
                    }
                    return this;
                },
                /**
     * Update this queue. First it will process any items awaiting destruction, and remove them.
     *
     * Then it will check to see if there are any items pending insertion, and move them to an
     * active state. Finally, it will return a list of active items for further processing.
     *
     * @method Phaser.Structs.ProcessQueue#update
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ update: function() {
                    if (this._toProcess === 0) //  Quick bail
                    return this._active;
                    var list = this._destroy;
                    var active = this._active;
                    var i;
                    var item;
                    //  Clear the 'destroy' list
                    for(i = 0; i < list.length; i++){
                        item = list[i];
                        //  Remove from the 'active' array
                        var idx = active.indexOf(item);
                        if (idx !== -1) {
                            active.splice(idx, 1);
                            this.emit(Events.PROCESS_QUEUE_REMOVE, item);
                        }
                    }
                    list.length = 0;
                    //  Process the pending addition list
                    //  This stops callbacks and out of sync events from populating the active array mid-way during an update
                    list = this._pending;
                    for(i = 0; i < list.length; i++){
                        item = list[i];
                        if (!this.checkQueue || this.checkQueue && active.indexOf(item) === -1) {
                            active.push(item);
                            this.emit(Events.PROCESS_QUEUE_ADD, item);
                        }
                    }
                    list.length = 0;
                    this._toProcess = 0;
                    //  The owner of this queue can now safely do whatever it needs to with the active list
                    return active;
                },
                /**
     * Returns the current list of active items.
     *
     * This method returns a reference to the active list array, not a copy of it.
     * Therefore, be careful to not modify this array outside of the ProcessQueue.
     *
     * @method Phaser.Structs.ProcessQueue#getActive
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ getActive: function() {
                    return this._active;
                },
                /**
     * The number of entries in the active list.
     *
     * @name Phaser.Structs.ProcessQueue#length
     * @type {number}
     * @readonly
     * @since 3.20.0
     */ length: {
                    get: function() {
                        return this._active.length;
                    }
                },
                /**
     * Immediately destroys this process queue, clearing all of its internal arrays and resetting the process totals.
     *
     * @method Phaser.Structs.ProcessQueue#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this._toProcess = 0;
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                }
            });
            module1.exports = ProcessQueue;
        /***/ },
        /* 212 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Read an integer value from an XML Node.
 *
 * @function getValue
 * @since 3.0.0
 * @private
 *
 * @param {Node} node - The XML Node.
 * @param {string} attribute - The attribute to read.
 *
 * @return {number} The parsed value.
 */ function getValue(node, attribute) {
                return parseInt(node.getAttribute(attribute), 10);
            }
            /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @function ParseXMLBitmapFont
 * @since 3.0.0
 * @private
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 * @param {Phaser.Textures.Texture} [texture] - If provided, each glyph in the Bitmap Font will be added to this texture as a frame.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ var ParseXMLBitmapFont = function(xml, frame, xSpacing, ySpacing, texture) {
                if (xSpacing === undefined) xSpacing = 0;
                if (ySpacing === undefined) ySpacing = 0;
                var textureX = frame.cutX;
                var textureY = frame.cutY;
                var textureWidth = frame.source.width;
                var textureHeight = frame.source.height;
                var sourceIndex = frame.sourceIndex;
                var data = {};
                var info = xml.getElementsByTagName("info")[0];
                var common = xml.getElementsByTagName("common")[0];
                data.font = info.getAttribute("face");
                data.size = getValue(info, "size");
                data.lineHeight = getValue(common, "lineHeight") + ySpacing;
                data.chars = {};
                var letters = xml.getElementsByTagName("char");
                var adjustForTrim = frame !== undefined && frame.trimmed;
                if (adjustForTrim) {
                    var top = frame.height;
                    var left = frame.width;
                }
                for(var i = 0; i < letters.length; i++){
                    var node = letters[i];
                    var charCode = getValue(node, "id");
                    var letter = String.fromCharCode(charCode);
                    var gx = getValue(node, "x");
                    var gy = getValue(node, "y");
                    var gw = getValue(node, "width");
                    var gh = getValue(node, "height");
                    //  Handle frame trim issues
                    if (adjustForTrim) {
                        if (gx < left) left = gx;
                        if (gy < top) top = gy;
                    }
                    if (adjustForTrim && top !== 0 && left !== 0) {
                        //  Now we know the top and left coordinates of the glyphs in the original data
                        //  so we can work out how much to adjust the glyphs by
                        gx -= frame.x;
                        gy -= frame.y;
                    }
                    var u0 = (textureX + gx) / textureWidth;
                    var v0 = (textureY + gy) / textureHeight;
                    var u1 = (textureX + gx + gw) / textureWidth;
                    var v1 = (textureY + gy + gh) / textureHeight;
                    data.chars[charCode] = {
                        x: gx,
                        y: gy,
                        width: gw,
                        height: gh,
                        centerX: Math.floor(gw / 2),
                        centerY: Math.floor(gh / 2),
                        xOffset: getValue(node, "xoffset"),
                        yOffset: getValue(node, "yoffset"),
                        xAdvance: getValue(node, "xadvance") + xSpacing,
                        data: {},
                        kerning: {},
                        u0: u0,
                        v0: v0,
                        u1: u1,
                        v1: v1
                    };
                    if (texture && gw !== 0 && gh !== 0) {
                        var charFrame = texture.add(letter, sourceIndex, gx, gy, gw, gh);
                        if (charFrame) charFrame.setUVs(gw, gh, u0, v0, u1, v1);
                    }
                }
                var kernings = xml.getElementsByTagName("kerning");
                for(i = 0; i < kernings.length; i++){
                    var kern = kernings[i];
                    var first = getValue(kern, "first");
                    var second = getValue(kern, "second");
                    var amount = getValue(kern, "amount");
                    data.chars[second].kerning[first] = amount;
                }
                return data;
            };
            module1.exports = ParseXMLBitmapFont;
        /***/ },
        /* 213 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlitterRender = __webpack_require__(1049);
            var Bob = __webpack_require__(440);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Frame = __webpack_require__(109);
            var GameObject = __webpack_require__(15);
            var List = __webpack_require__(110);
            /**
 * @callback CreateCallback
 *
 * @param {Phaser.GameObjects.Bob} bob - The Bob that was created by the Blitter.
 * @param {number} index - The position of the Bob within the Blitter display list.
 */ /**
 * @classdesc
 * A Blitter Game Object.
 *
 * The Blitter Game Object is a special kind of container that creates, updates and manages Bob objects.
 * Bobs are designed for rendering speed rather than flexibility. They consist of a texture, or frame from a texture,
 * a position and an alpha value. You cannot scale or rotate them. They use a batched drawing method for speed
 * during rendering.
 *
 * A Blitter Game Object has one texture bound to it. Bobs created by the Blitter can use any Frame from this
 * Texture to render with, but they cannot use any other Texture. It is this single texture-bind that allows
 * them their speed.
 *
 * If you have a need to blast a large volume of frames around the screen then Blitter objects are well worth
 * investigating. They are especially useful for using as a base for your own special effects systems.
 *
 * @class Blitter
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} [x=0] - The x coordinate of this Game Object in world space.
 * @param {number} [y=0] - The y coordinate of this Game Object in world space.
 * @param {string} [texture='__DEFAULT'] - The key of the texture this Game Object will use for rendering. The Texture must already exist in the Texture Manager.
 * @param {(string|number)} [frame=0] - The Frame of the Texture that this Game Object will use. Only set if the Texture has multiple frames, such as a Texture Atlas or Sprite Sheet.
 */ var Blitter = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    BlitterRender
                ],
                initialize: function Blitter(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, "Blitter");
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.initPipeline();
                    /**
         * The children of this Blitter.
         * This List contains all of the Bob objects created by the Blitter.
         *
         * @name Phaser.GameObjects.Blitter#children
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Bob>}
         * @since 3.0.0
         */ this.children = new List();
                    /**
         * A transient array that holds all of the Bobs that will be rendered this frame.
         * The array is re-populated whenever the dirty flag is set.
         *
         * @name Phaser.GameObjects.Blitter#renderList
         * @type {Phaser.GameObjects.Bob[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.renderList = [];
                    /**
         * Is the Blitter considered dirty?
         * A 'dirty' Blitter has had its child count changed since the last frame.
         *
         * @name Phaser.GameObjects.Blitter#dirty
         * @type {boolean}
         * @since 3.0.0
         */ this.dirty = false;
                },
                /**
     * Creates a new Bob in this Blitter.
     *
     * The Bob is created at the given coordinates, relative to the Blitter and uses the given frame.
     * A Bob can use any frame belonging to the texture bound to the Blitter.
     *
     * @method Phaser.GameObjects.Blitter#create
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     * @param {number} [index] - The position in the Blitters Display List to add the new Bob at. Defaults to the top of the list.
     *
     * @return {Phaser.GameObjects.Bob} The newly created Bob object.
     */ create: function(x, y, frame, visible, index) {
                    if (visible === undefined) visible = true;
                    if (index === undefined) index = this.children.length;
                    if (frame === undefined) frame = this.frame;
                    else if (!(frame instanceof Frame)) frame = this.texture.get(frame);
                    var bob = new Bob(this, x, y, frame, visible);
                    this.children.addAt(bob, index, false);
                    this.dirty = true;
                    return bob;
                },
                /**
     * Creates multiple Bob objects within this Blitter and then passes each of them to the specified callback.
     *
     * @method Phaser.GameObjects.Blitter#createFromCallback
     * @since 3.0.0
     *
     * @param {CreateCallback} callback - The callback to invoke after creating a bob. It will be sent two arguments: The Bob and the index of the Bob.
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createFromCallback: function(callback, quantity, frame, visible) {
                    var bobs = this.createMultiple(quantity, frame, visible);
                    for(var i = 0; i < bobs.length; i++){
                        var bob = bobs[i];
                        callback.call(this, bob, i);
                    }
                    return bobs;
                },
                /**
     * Creates multiple Bobs in one call.
     *
     * The amount created is controlled by a combination of the `quantity` argument and the number of frames provided.
     *
     * If the quantity is set to 10 and you provide 2 frames, then 20 Bobs will be created. 10 with the first
     * frame and 10 with the second.
     *
     * @method Phaser.GameObjects.Blitter#createMultiple
     * @since 3.0.0
     *
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createMultiple: function(quantity, frame, visible) {
                    if (frame === undefined) frame = this.frame.name;
                    if (visible === undefined) visible = true;
                    if (!Array.isArray(frame)) frame = [
                        frame
                    ];
                    var bobs = [];
                    var _this = this;
                    frame.forEach(function(singleFrame) {
                        for(var i = 0; i < quantity; i++)bobs.push(_this.create(0, 0, singleFrame, visible));
                    });
                    return bobs;
                },
                /**
     * Checks if the given child can render or not, by checking its `visible` and `alpha` values.
     *
     * @method Phaser.GameObjects.Blitter#childCanRender
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Bob} child - The Bob to check for rendering.
     *
     * @return {boolean} Returns `true` if the given child can render, otherwise `false`.
     */ childCanRender: function(child) {
                    return child.visible && child.alpha > 0;
                },
                /**
     * Returns an array of Bobs to be rendered.
     * If the Blitter is dirty then a new list is generated and stored in `renderList`.
     *
     * @method Phaser.GameObjects.Blitter#getRenderList
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that will be rendered this frame.
     */ getRenderList: function() {
                    if (this.dirty) {
                        this.renderList = this.children.list.filter(this.childCanRender, this);
                        this.dirty = false;
                    }
                    return this.renderList;
                },
                /**
     * Removes all Bobs from the children List and clears the dirty flag.
     *
     * @method Phaser.GameObjects.Blitter#clear
     * @since 3.0.0
     */ clear: function() {
                    this.children.removeAll();
                    this.dirty = true;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Blitter#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.children.destroy();
                    this.renderList = [];
                }
            });
            module1.exports = Blitter;
        /***/ },
        /* 214 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(208);
            var BlendModes = __webpack_require__(35);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Events = __webpack_require__(75);
            var GameObject = __webpack_require__(15);
            var Rectangle = __webpack_require__(10);
            var Render = __webpack_require__(1052);
            var Union = __webpack_require__(441);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Container Game Object.
 *
 * A Container, as the name implies, can 'contain' other types of Game Object.
 * When a Game Object is added to a Container, the Container becomes responsible for the rendering of it.
 * By default it will be removed from the Display List and instead added to the Containers own internal list.
 *
 * The position of the Game Object automatically becomes relative to the position of the Container.
 *
 * The transform point of a Container is 0x0 (in local space) and that cannot be changed. The children you add to the
 * Container should be positioned with this value in mind. I.e. you should treat 0x0 as being the center of
 * the Container, and position children positively and negative around it as required.
 *
 * When the Container is rendered, all of its children are rendered as well, in the order in which they exist
 * within the Container. Container children can be repositioned using methods such as `MoveUp`, `MoveDown` and `SendToBack`.
 *
 * If you modify a transform property of the Container, such as `Container.x` or `Container.rotation` then it will
 * automatically influence all children as well.
 *
 * Containers can include other Containers for deeply nested transforms.
 *
 * Containers can have masks set on them and can be used as a mask too. However, Container children cannot be masked.
 * The masks do not 'stack up'. Only a Container on the root of the display list will use its mask.
 *
 * Containers can be enabled for input. Because they do not have a texture you need to provide a shape for them
 * to use as their hit area. Container children can also be enabled for input, independent of the Container.
 *
 * If input enabling a _child_ you should not set both the `origin` and a **negative** scale factor on the child,
 * or the input area will become misaligned.
 *
 * Containers can be given a physics body for either Arcade Physics, Impact Physics or Matter Physics. However,
 * if Container _children_ are enabled for physics you may get unexpected results, such as offset bodies,
 * if the Container itself, or any of its ancestors, is positioned anywhere other than at 0 x 0. Container children
 * with physics do not factor in the Container due to the excessive extra calculations needed. Please structure
 * your game to work around this.
 *
 * It's important to understand the impact of using Containers. They add additional processing overhead into
 * every one of their children. The deeper you nest them, the more the cost escalates. This is especially true
 * for input events. You also loose the ability to set the display depth of Container children in the same
 * flexible manner as those not within them. In short, don't use them for the sake of it. You pay a small cost
 * every time you create one, try to structure your game around avoiding that where possible.
 *
 * @class Container
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.4.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 */ var Container = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function Container(scene, x, y, children) {
                    GameObject.call(this, scene, "Container");
                    /**
         * An array holding the children of this Container.
         *
         * @name Phaser.GameObjects.Container#list
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.4.0
         */ this.list = [];
                    /**
         * Does this Container exclusively manage its children?
         *
         * The default is `true` which means a child added to this Container cannot
         * belong in another Container, which includes the Scene display list.
         *
         * If you disable this then this Container will no longer exclusively manage its children.
         * This allows you to create all kinds of interesting graphical effects, such as replicating
         * Game Objects without reparenting them all over the Scene.
         * However, doing so will prevent children from receiving any kind of input event or have
         * their physics bodies work by default, as they're no longer a single entity on the
         * display list, but are being replicated where-ever this Container is.
         *
         * @name Phaser.GameObjects.Container#exclusive
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.exclusive = true;
                    /**
         * Containers can have an optional maximum size. If set to anything above 0 it
         * will constrict the addition of new Game Objects into the Container, capping off
         * the maximum limit the Container can grow in size to.
         *
         * @name Phaser.GameObjects.Container#maxSize
         * @type {number}
         * @default -1
         * @since 3.4.0
         */ this.maxSize = -1;
                    /**
         * The cursor position.
         *
         * @name Phaser.GameObjects.Container#position
         * @type {number}
         * @since 3.4.0
         */ this.position = 0;
                    /**
         * Internal Transform Matrix used for local space conversion.
         *
         * @name Phaser.GameObjects.Container#localTransform
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.4.0
         */ this.localTransform = new Components.TransformMatrix();
                    /**
         * Internal temporary Transform Matrix used to avoid object creation.
         *
         * @name Phaser.GameObjects.Container#tempTransformMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.4.0
         */ this.tempTransformMatrix = new Components.TransformMatrix();
                    /**
         * The property key to sort by.
         *
         * @name Phaser.GameObjects.Container#_sortKey
         * @type {string}
         * @private
         * @since 3.4.0
         */ this._sortKey = "";
                    /**
         * A reference to the Scene Systems Event Emitter.
         *
         * @name Phaser.GameObjects.Container#_sysEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.9.0
         */ this._sysEvents = scene.sys.events;
                    /**
         * The horizontal scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorX
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorX = 1;
                    /**
         * The vertical scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorY
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorY = 1;
                    this.initPipeline();
                    this.setPosition(x, y);
                    this.clearAlpha();
                    this.setBlendMode(BlendModes.SKIP_CHECK);
                    if (children) this.add(children);
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originX: {
                    get: function() {
                        return 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originY: {
                    get: function() {
                        return 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginX: {
                    get: function() {
                        return this.width * 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginY: {
                    get: function() {
                        return this.height * 0.5;
                    }
                },
                /**
     * Does this Container exclusively manage its children?
     *
     * The default is `true` which means a child added to this Container cannot
     * belong in another Container, which includes the Scene display list.
     *
     * If you disable this then this Container will no longer exclusively manage its children.
     * This allows you to create all kinds of interesting graphical effects, such as replicating
     * Game Objects without reparenting them all over the Scene.
     * However, doing so will prevent children from receiving any kind of input event or have
     * their physics bodies work by default, as they're no longer a single entity on the
     * display list, but are being replicated where-ever this Container is.
     *
     * @method Phaser.GameObjects.Container#setExclusive
     * @since 3.4.0
     *
     * @param {boolean} [value=true] - The exclusive state of this Container.
     *
     * @return {this} This Container.
     */ setExclusive: function(value) {
                    if (value === undefined) value = true;
                    this.exclusive = value;
                    return this;
                },
                /**
     * Gets the bounds of this Container. It works by iterating all children of the Container,
     * getting their respective bounds, and then working out a min-max rectangle from that.
     * It does not factor in if the children render or not, all are included.
     *
     * Some children are unable to return their bounds, such as Graphics objects, in which case
     * they are skipped.
     *
     * Depending on the quantity of children in this Container it could be a really expensive call,
     * so cache it and only poll it as needed.
     *
     * The values are stored and returned in a Rectangle object.
     *
     * @method Phaser.GameObjects.Container#getBounds
     * @since 3.4.0
     *
     * @param {Phaser.Geom.Rectangle} [output] - A Geom.Rectangle object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} The values stored in the output object.
     */ getBounds: function(output) {
                    if (output === undefined) output = new Rectangle();
                    output.setTo(this.x, this.y, 0, 0);
                    if (this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        var transformedPosition = parentMatrix.transformPoint(this.x, this.y);
                        output.setTo(transformedPosition.x, transformedPosition.y, 0, 0);
                    }
                    if (this.list.length > 0) {
                        var children = this.list;
                        var tempRect = new Rectangle();
                        var hasSetFirst = false;
                        output.setEmpty();
                        for(var i = 0; i < children.length; i++){
                            var entry = children[i];
                            if (entry.getBounds) {
                                entry.getBounds(tempRect);
                                if (!hasSetFirst) {
                                    output.setTo(tempRect.x, tempRect.y, tempRect.width, tempRect.height);
                                    hasSetFirst = true;
                                } else Union(tempRect, output, output);
                            }
                        }
                    }
                    return output;
                },
                /**
     * Internal add handler.
     *
     * @method Phaser.GameObjects.Container#addHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to this Container.
     */ addHandler: function(gameObject) {
                    gameObject.once(Events.DESTROY, this.remove, this);
                    if (this.exclusive) {
                        if (gameObject.parentContainer) gameObject.parentContainer.remove(gameObject);
                        gameObject.removeFromDisplayList();
                        gameObject.parentContainer = this;
                    }
                },
                /**
     * Internal remove handler.
     *
     * @method Phaser.GameObjects.Container#removeHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just removed from this Container.
     */ removeHandler: function(gameObject) {
                    gameObject.off(Events.DESTROY, this.remove);
                    if (this.exclusive) {
                        gameObject.parentContainer = null;
                        gameObject.addToDisplayList();
                    }
                },
                /**
     * Takes a Point-like object, such as a Vector2, Geom.Point or object with public x and y properties,
     * and transforms it into the space of this Container, then returns it in the output object.
     *
     * @method Phaser.GameObjects.Container#pointToContainer
     * @since 3.4.0
     *
     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} source - The Source Point to be transformed.
     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} [output] - A destination object to store the transformed point in. If none given a Vector2 will be created and returned.
     *
     * @return {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} The transformed point.
     */ pointToContainer: function(source, output) {
                    if (output === undefined) output = new Vector2();
                    if (this.parentContainer) this.parentContainer.pointToContainer(source, output);
                    else output = new Vector2(source.x, source.y);
                    var tempMatrix = this.tempTransformMatrix;
                    //  No need to loadIdentity because applyITRS overwrites every value anyway
                    tempMatrix.applyITRS(this.x, this.y, this.rotation, this.scaleX, this.scaleY);
                    tempMatrix.invert();
                    tempMatrix.transformPoint(source.x, source.y, output);
                    return output;
                },
                /**
     * Returns the world transform matrix as used for Bounds checks.
     *
     * The returned matrix is temporal and shouldn't be stored.
     *
     * @method Phaser.GameObjects.Container#getBoundsTransformMatrix
     * @since 3.4.0
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The world transform matrix.
     */ getBoundsTransformMatrix: function() {
                    return this.getWorldTransformMatrix(this.tempTransformMatrix, this.localTransform);
                },
                /**
     * Adds the given Game Object, or array of Game Objects, to this Container.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#add
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     *
     * @return {this} This Container instance.
     */ add: function(child) {
                    ArrayUtils.Add(this.list, child, this.maxSize, this.addHandler, this);
                    return this;
                },
                /**
     * Adds the given Game Object, or array of Game Objects, to this Container at the specified position.
     *
     * Existing Game Objects in the Container are shifted up.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#addAt
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     * @param {number} [index=0] - The position to insert the Game Object/s at.
     *
     * @return {this} This Container instance.
     */ addAt: function(child, index) {
                    ArrayUtils.AddAt(this.list, child, index, this.maxSize, this.addHandler, this);
                    return this;
                },
                /**
     * Returns the Game Object at the given position in this Container.
     *
     * @method Phaser.GameObjects.Container#getAt
     * @since 3.4.0
     *
     * @param {number} index - The position to get the Game Object from.
     *
     * @return {?Phaser.GameObjects.GameObject} The Game Object at the specified index, or `null` if none found.
     */ getAt: function(index) {
                    return this.list[index];
                },
                /**
     * Returns the index of the given Game Object in this Container.
     *
     * @method Phaser.GameObjects.Container#getIndex
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to search for in this Container.
     *
     * @return {number} The index of the Game Object in this Container, or -1 if not found.
     */ getIndex: function(child) {
                    return this.list.indexOf(child);
                },
                /**
     * Sort the contents of this Container so the items are in order based on the given property.
     * For example: `sort('alpha')` would sort the elements based on the value of their `alpha` property.
     *
     * @method Phaser.GameObjects.Container#sort
     * @since 3.4.0
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {this} This Container instance.
     */ sort: function(property, handler) {
                    if (!property) return this;
                    if (handler === undefined) handler = function(childA, childB) {
                        return childA[property] - childB[property];
                    };
                    ArrayUtils.StableSort(this.list, handler);
                    return this;
                },
                /**
     * Searches for the first instance of a child with its `name` property matching the given argument.
     * Should more than one child have the same name only the first is returned.
     *
     * @method Phaser.GameObjects.Container#getByName
     * @since 3.4.0
     *
     * @param {string} name - The name to search for.
     *
     * @return {?Phaser.GameObjects.GameObject} The first child with a matching name, or `null` if none were found.
     */ getByName: function(name) {
                    return ArrayUtils.GetFirst(this.list, "name", name);
                },
                /**
     * Returns a random Game Object from this Container.
     *
     * @method Phaser.GameObjects.Container#getRandom
     * @since 3.4.0
     *
     * @param {number} [startIndex=0] - An optional start index.
     * @param {number} [length] - An optional length, the total number of elements (from the startIndex) to choose from.
     *
     * @return {?Phaser.GameObjects.GameObject} A random child from the Container, or `null` if the Container is empty.
     */ getRandom: function(startIndex, length) {
                    return ArrayUtils.GetRandom(this.list, startIndex, length);
                },
                /**
     * Gets the first Game Object in this Container.
     *
     * You can also specify a property and value to search for, in which case it will return the first
     * Game Object in this Container with a matching property and / or value.
     *
     * For example: `getFirst('visible', true)` would return the first Game Object that had its `visible` property set.
     *
     * You can limit the search to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#getFirst
     * @since 3.4.0
     *
     * @param {string} property - The property to test on each Game Object in the Container.
     * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {?Phaser.GameObjects.GameObject} The first matching Game Object, or `null` if none was found.
     */ getFirst: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns all Game Objects in this Container.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('body')` would return only Game Objects that have a body property.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only Game Objects that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#getAll
     * @since 3.4.0
     *
     * @param {string} [property] - The property to test on each Game Object in the Container.
     * @param {any} [value] - If property is set then the `property` must strictly equal this value to be included in the results.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of matching Game Objects from this Container.
     */ getAll: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns the total number of Game Objects in this Container that have a property
     * matching the given value.
     *
     * For example: `count('visible', true)` would count all the elements that have their visible property set.
     *
     * You can optionally limit the operation to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#count
     * @since 3.4.0
     *
     * @param {string} property - The property to check.
     * @param {any} value - The value to check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {number} The total number of Game Objects in this Container with a property matching the given value.
     */ count: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.CountAllMatching(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Swaps the position of two Game Objects in this Container.
     * Both Game Objects must belong to this Container.
     *
     * @method Phaser.GameObjects.Container#swap
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The first Game Object to swap.
     * @param {Phaser.GameObjects.GameObject} child2 - The second Game Object to swap.
     *
     * @return {this} This Container instance.
     */ swap: function(child1, child2) {
                    ArrayUtils.Swap(this.list, child1, child2);
                    return this;
                },
                /**
     * Moves a Game Object to a new position within this Container.
     *
     * The Game Object must already be a child of this Container.
     *
     * The Game Object is removed from its old position and inserted into the new one.
     * Therefore the Container size does not change. Other children will change position accordingly.
     *
     * @method Phaser.GameObjects.Container#moveTo
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to move.
     * @param {number} index - The new position of the Game Object in this Container.
     *
     * @return {this} This Container instance.
     */ moveTo: function(child, index) {
                    ArrayUtils.MoveTo(this.list, child, index);
                    return this;
                },
                /**
     * Moves a Game Object above another one within this Container.
     *
     * These 2 Game Objects must already be children of this Container.
     *
     * @method Phaser.GameObjects.Container#moveAbove
     * @since 3.55.0
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The Game Object to move above base Game Object.
     * @param {Phaser.GameObjects.GameObject} child2 - The base Game Object.
     *
     * @return {this} This Container instance.
     */ moveAbove: function(child1, child2) {
                    ArrayUtils.MoveAbove(this.list, child1, child2);
                    return this;
                },
                /**
     * Moves a Game Object below another one within this Container.
     *
     * These 2 Game Objects must already be children of this Container.
     *
     * @method Phaser.GameObjects.Container#moveBelow
     * @since 3.55.0
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The Game Object to move below base Game Object.
     * @param {Phaser.GameObjects.GameObject} child2 - The base Game Object.
     *
     * @return {this} This Container instance.
     */ moveBelow: function(child1, child2) {
                    ArrayUtils.MoveBelow(this.list, child1, child2);
                    return this;
                },
                /**
     * Removes the given Game Object, or array of Game Objects, from this Container.
     *
     * The Game Objects must already be children of this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#remove
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to be removed from the Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each child successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ remove: function(child, destroyChild) {
                    var removed = ArrayUtils.Remove(this.list, child, this.removeHandler, this);
                    if (destroyChild && removed) {
                        if (!Array.isArray(removed)) removed = [
                            removed
                        ];
                        for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    }
                    return this;
                },
                /**
     * Removes the Game Object at the given position in this Container.
     *
     * You can also optionally call `destroy` on the Game Object, if one is found.
     *
     * @method Phaser.GameObjects.Container#removeAt
     * @since 3.4.0
     *
     * @param {number} index - The index of the Game Object to be removed.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAt: function(index, destroyChild) {
                    var removed = ArrayUtils.RemoveAt(this.list, index, this.removeHandler, this);
                    if (destroyChild && removed) removed.destroy();
                    return this;
                },
                /**
     * Removes the Game Objects between the given positions in this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeBetween
     * @since 3.4.0
     *
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeBetween: function(startIndex, endIndex, destroyChild) {
                    var removed = ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeHandler, this);
                    if (destroyChild) for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    return this;
                },
                /**
     * Removes all Game Objects from this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeAll
     * @since 3.4.0
     *
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAll: function(destroyChild) {
                    var removed = ArrayUtils.RemoveBetween(this.list, 0, this.list.length, this.removeHandler, this);
                    if (destroyChild) for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    return this;
                },
                /**
     * Brings the given Game Object to the top of this Container.
     * This will cause it to render on-top of any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#bringToTop
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to bring to the top of the Container.
     *
     * @return {this} This Container instance.
     */ bringToTop: function(child) {
                    ArrayUtils.BringToTop(this.list, child);
                    return this;
                },
                /**
     * Sends the given Game Object to the bottom of this Container.
     * This will cause it to render below any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#sendToBack
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to send to the bottom of the Container.
     *
     * @return {this} This Container instance.
     */ sendToBack: function(child) {
                    ArrayUtils.SendToBack(this.list, child);
                    return this;
                },
                /**
     * Moves the given Game Object up one place in this Container, unless it's already at the top.
     *
     * @method Phaser.GameObjects.Container#moveUp
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveUp: function(child) {
                    ArrayUtils.MoveUp(this.list, child);
                    return this;
                },
                /**
     * Moves the given Game Object down one place in this Container, unless it's already at the bottom.
     *
     * @method Phaser.GameObjects.Container#moveDown
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveDown: function(child) {
                    ArrayUtils.MoveDown(this.list, child);
                    return this;
                },
                /**
     * Reverses the order of all Game Objects in this Container.
     *
     * @method Phaser.GameObjects.Container#reverse
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ reverse: function() {
                    this.list.reverse();
                    return this;
                },
                /**
     * Shuffles the all Game Objects in this Container using the Fisher-Yates implementation.
     *
     * @method Phaser.GameObjects.Container#shuffle
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ shuffle: function() {
                    ArrayUtils.Shuffle(this.list);
                    return this;
                },
                /**
     * Replaces a Game Object in this Container with the new Game Object.
     * The new Game Object cannot already be a child of this Container.
     *
     * @method Phaser.GameObjects.Container#replace
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} oldChild - The Game Object in this Container that will be replaced.
     * @param {Phaser.GameObjects.GameObject} newChild - The Game Object to be added to this Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ replace: function(oldChild, newChild, destroyChild) {
                    var moved = ArrayUtils.Replace(this.list, oldChild, newChild);
                    if (moved) {
                        this.addHandler(newChild);
                        this.removeHandler(oldChild);
                        if (destroyChild) oldChild.destroy();
                    }
                    return this;
                },
                /**
     * Returns `true` if the given Game Object is a direct child of this Container.
     *
     * This check does not scan nested Containers.
     *
     * @method Phaser.GameObjects.Container#exists
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to check for within this Container.
     *
     * @return {boolean} True if the Game Object is an immediate child of this Container, otherwise false.
     */ exists: function(child) {
                    return this.list.indexOf(child) > -1;
                },
                /**
     * Sets the property to the given value on all Game Objects in this Container.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#setAll
     * @since 3.4.0
     *
     * @param {string} property - The property that must exist on the Game Object.
     * @param {any} value - The value to get the property to.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {this} This Container instance.
     */ setAll: function(property, value, startIndex, endIndex) {
                    ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                    return this;
                },
                /**
     * @callback EachContainerCallback
     * @generic I - [item]
     *
     * @param {*} item - The child Game Object of the Container.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * A copy of the Container is made before passing each entry to your callback.
     * This protects against the callback itself modifying the Container.
     *
     * If you know for sure that the callback will not change the size of this Container
     * then you can use the more performant `Container.iterate` method instead.
     *
     * @method Phaser.GameObjects.Container#each
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ each: function(callback, context) {
                    var args = [
                        null
                    ];
                    var i;
                    var temp = this.list.slice();
                    var len = temp.length;
                    for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < len; i++){
                        args[0] = temp[i];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * Only use this method when you absolutely know that the Container will not be modified during
     * the iteration, i.e. by removing or adding to its contents.
     *
     * @method Phaser.GameObjects.Container#iterate
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ iterate: function(callback, context) {
                    var args = [
                        null
                    ];
                    var i;
                    for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < this.list.length; i++){
                        args[0] = this.list[i];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Sets the scroll factor of this Container and optionally all of its children.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Container#setScrollFactor
     * @since 3.4.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     * @param {boolean} [updateChildren=false] - Apply this scrollFactor to all Container children as well?
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y, updateChildren) {
                    if (y === undefined) y = x;
                    if (updateChildren === undefined) updateChildren = false;
                    this.scrollFactorX = x;
                    this.scrollFactorY = y;
                    if (updateChildren) {
                        ArrayUtils.SetAll(this.list, "scrollFactorX", x);
                        ArrayUtils.SetAll(this.list, "scrollFactorY", y);
                    }
                    return this;
                },
                /**
     * The number of Game Objects inside this Container.
     *
     * @name Phaser.GameObjects.Container#length
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                /**
     * Returns the first Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#first
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ first: {
                    get: function() {
                        this.position = 0;
                        if (this.list.length > 0) return this.list[0];
                        else return null;
                    }
                },
                /**
     * Returns the last Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#last
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ last: {
                    get: function() {
                        if (this.list.length > 0) {
                            this.position = this.list.length - 1;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Returns the next Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#next
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ next: {
                    get: function() {
                        if (this.position < this.list.length) {
                            this.position++;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Returns the previous Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#previous
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ previous: {
                    get: function() {
                        if (this.position > 0) {
                            this.position--;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Container#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.removeAll(!!this.exclusive);
                    this.localTransform.destroy();
                    this.tempTransformMatrix.destroy();
                    this.list = [];
                }
            });
            module1.exports = Container;
        /***/ },
        /* 215 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(148);
            var Class = __webpack_require__(0);
            var Render = __webpack_require__(1057);
            /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Littera (Web-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class DynamicBitmapText
 * @extends Phaser.GameObjects.BitmapText
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var DynamicBitmapText = new Class({
                Extends: BitmapText,
                Mixins: [
                    Render
                ],
                initialize: function DynamicBitmapText(scene, x, y, font, text, size, align) {
                    BitmapText.call(this, scene, x, y, font, text, size, align);
                    this.type = "DynamicBitmapText";
                    /**
         * The horizontal scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollX = 0;
                    /**
         * The vertical scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollY = 0;
                    /**
         * The crop width of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropWidth = 0;
                    /**
         * The crop height of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropHeight = 0;
                    /**
         * A callback that alters how each character of the Bitmap Text is rendered.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#displayCallback
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallback}
         * @since 3.0.0
         */ this.displayCallback;
                    /**
         * The data object that is populated during rendering, then passed to the displayCallback.
         * You should modify this object then return it back from the callback. It's updated values
         * will be used to render the specific glyph.
         *
         * Please note that if you need a reference to this object locally in your game code then you
         * should shallow copy it, as it's updated and re-used for every glyph in the text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#callbackData
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig}
         * @since 3.11.0
         */ this.callbackData = {
                        parent: this,
                        color: 0,
                        tint: {
                            topLeft: 0,
                            topRight: 0,
                            bottomLeft: 0,
                            bottomRight: 0
                        },
                        index: 0,
                        charCode: 0,
                        x: 0,
                        y: 0,
                        scale: 0,
                        rotation: 0,
                        data: 0
                    };
                },
                /**
     * Set the crop size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the crop.
     * @param {number} height - The height of the crop.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height) {
                    this.cropWidth = width;
                    this.cropHeight = height;
                    return this;
                },
                /**
     * Set a callback that alters how each character of the Bitmap Text is rendered.
     *
     * The callback receives a {@link Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig} object that contains information about the character that's
     * about to be rendered.
     *
     * It should return an object with `x`, `y`, `scale` and `rotation` properties that will be used instead of the
     * usual values when rendering.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setDisplayCallback
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.BitmapText.DisplayCallback} callback - The display callback to set.
     *
     * @return {this} This Game Object.
     */ setDisplayCallback: function(callback) {
                    this.displayCallback = callback;
                    return this;
                },
                /**
     * Set the horizontal scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollX: function(value) {
                    this.scrollX = value;
                    return this;
                },
                /**
     * Set the vertical scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollY
     * @since 3.0.0
     *
     * @param {number} value - The vertical scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollY: function(value) {
                    this.scrollY = value;
                    return this;
                }
            });
            module1.exports = DynamicBitmapText;
        /***/ },
        /* 216 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(133);
            var Class = __webpack_require__(0);
            var Commands = __webpack_require__(217);
            var ComponentsAlpha = __webpack_require__(303);
            var ComponentsBlendMode = __webpack_require__(304);
            var ComponentsDepth = __webpack_require__(305);
            var ComponentsMask = __webpack_require__(309);
            var ComponentsPipeline = __webpack_require__(167);
            var ComponentsScrollFactor = __webpack_require__(312);
            var ComponentsTransform = __webpack_require__(313);
            var ComponentsVisible = __webpack_require__(314);
            var Ellipse = __webpack_require__(111);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            var Render = __webpack_require__(1063);
            /**
 * @classdesc
 * A Graphics object is a way to draw primitive shapes to your game. Primitives include forms of geometry, such as
 * Rectangles, Circles, and Polygons. They also include lines, arcs and curves. When you initially create a Graphics
 * object it will be empty.
 *
 * To draw to it you must first specify a line style or fill style (or both), draw shapes using paths, and finally
 * fill or stroke them. For example:
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.beginPath();
 * graphics.moveTo(100, 100);
 * graphics.lineTo(200, 200);
 * graphics.closePath();
 * graphics.strokePath();
 * ```
 *
 * There are also many helpful methods that draw and fill/stroke common shapes for you.
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.fillStyle(0xFFFFFF, 1.0);
 * graphics.fillRect(50, 50, 400, 200);
 * graphics.strokeRect(50, 50, 400, 200);
 * ```
 *
 * When a Graphics object is rendered it will render differently based on if the game is running under Canvas or WebGL.
 * Under Canvas it will use the HTML Canvas context drawing operations to draw the path.
 * Under WebGL the graphics data is decomposed into polygons. Both of these are expensive processes, especially with
 * complex shapes.
 *
 * If your Graphics object doesn't change much (or at all) once you've drawn your shape to it, then you will help
 * performance by calling {@link Phaser.GameObjects.Graphics#generateTexture}. This will 'bake' the Graphics object into
 * a Texture, and return it. You can then use this Texture for Sprites or other display objects. If your Graphics object
 * updates frequently then you should avoid doing this, as it will constantly generate new textures, which will consume
 * memory.
 *
 * As you can tell, Graphics objects are a bit of a trade-off. While they are extremely useful, you need to be careful
 * in their complexity and quantity of them in your game.
 *
 * @class Graphics
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Graphics object belongs.
 * @param {Phaser.Types.GameObjects.Graphics.Options} [options] - Options that set the position and default style of this Graphics object.
 */ var Graphics = new Class({
                Extends: GameObject,
                Mixins: [
                    ComponentsAlpha,
                    ComponentsBlendMode,
                    ComponentsDepth,
                    ComponentsMask,
                    ComponentsPipeline,
                    ComponentsTransform,
                    ComponentsVisible,
                    ComponentsScrollFactor,
                    Render
                ],
                initialize: function Graphics(scene, options) {
                    var x = GetValue(options, "x", 0);
                    var y = GetValue(options, "y", 0);
                    GameObject.call(this, scene, "Graphics");
                    this.setPosition(x, y);
                    this.initPipeline();
                    /**
         * The horizontal display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginX = 0;
                    /**
         * The vertical display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginY = 0;
                    /**
         * The array of commands used to render the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#commandBuffer
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.commandBuffer = [];
                    /**
         * The default fill color for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillColor
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.defaultFillColor = -1;
                    /**
         * The default fill alpha for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillAlpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultFillAlpha = 1;
                    /**
         * The default stroke width for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeWidth
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeWidth = 1;
                    /**
         * The default stroke color for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeColor
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.defaultStrokeColor = -1;
                    /**
         * The default stroke alpha for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeAlpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeAlpha = 1;
                    /**
         * Internal property that keeps track of the line width style setting.
         *
         * @name Phaser.GameObjects.Graphics#_lineWidth
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._lineWidth = 1.0;
                    this.setDefaultStyles(options);
                },
                /**
     * Set the default style settings for this Graphics object.
     *
     * @method Phaser.GameObjects.Graphics#setDefaultStyles
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Graphics.Styles} options - The styles to set as defaults.
     *
     * @return {this} This Game Object.
     */ setDefaultStyles: function(options) {
                    if (GetValue(options, "lineStyle", null)) {
                        this.defaultStrokeWidth = GetValue(options, "lineStyle.width", 1);
                        this.defaultStrokeColor = GetValue(options, "lineStyle.color", 0xffffff);
                        this.defaultStrokeAlpha = GetValue(options, "lineStyle.alpha", 1);
                        this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                    }
                    if (GetValue(options, "fillStyle", null)) {
                        this.defaultFillColor = GetValue(options, "fillStyle.color", 0xffffff);
                        this.defaultFillAlpha = GetValue(options, "fillStyle.alpha", 1);
                        this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                    }
                    return this;
                },
                /**
     * Set the current line style.
     *
     * @method Phaser.GameObjects.Graphics#lineStyle
     * @since 3.0.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} color - The stroke color.
     * @param {number} [alpha=1] - The stroke alpha.
     *
     * @return {this} This Game Object.
     */ lineStyle: function(lineWidth, color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.LINE_STYLE, lineWidth, color, alpha);
                    this._lineWidth = lineWidth;
                    return this;
                },
                /**
     * Set the current fill style.
     *
     * @method Phaser.GameObjects.Graphics#fillStyle
     * @since 3.0.0
     *
     * @param {number} color - The fill color.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ fillStyle: function(color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.FILL_STYLE, color, alpha);
                    return this;
                },
                /**
     * Sets a gradient fill style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all filled shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `fillStyle` and provide a new single fill color.
     *
     * When filling a triangle only the first 3 color values provided are used for the 3 points of a triangle.
     *
     * This feature is best used only on rectangles and triangles. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient fill a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#fillGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} topLeft - The top left fill color.
     * @param {number} topRight - The top right fill color.
     * @param {number} bottomLeft - The bottom left fill color.
     * @param {number} bottomRight - The bottom right fill color. Not used when filling triangles.
     * @param {number} [alphaTopLeft=1] - The top left alpha value. If you give only this value, it's used for all corners.
     * @param {number} [alphaTopRight=1] - The top right alpha value.
     * @param {number} [alphaBottomLeft=1] - The bottom left alpha value.
     * @param {number} [alphaBottomRight=1] - The bottom right alpha value.
     *
     * @return {this} This Game Object.
     */ fillGradientStyle: function(topLeft, topRight, bottomLeft, bottomRight, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight) {
                    if (alphaTopLeft === undefined) alphaTopLeft = 1;
                    if (alphaTopRight === undefined) alphaTopRight = alphaTopLeft;
                    if (alphaBottomLeft === undefined) alphaBottomLeft = alphaTopLeft;
                    if (alphaBottomRight === undefined) alphaBottomRight = alphaTopLeft;
                    this.commandBuffer.push(Commands.GRADIENT_FILL_STYLE, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Sets a gradient line style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all stroked shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `lineStyle` and provide a new single line color.
     *
     * This feature is best used only on single lines. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient stroke a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#lineGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} topLeft - The tint being applied to the top-left of the Game Object.
     * @param {number} topRight - The tint being applied to the top-right of the Game Object.
     * @param {number} bottomLeft - The tint being applied to the bottom-left of the Game Object.
     * @param {number} bottomRight - The tint being applied to the bottom-right of the Game Object.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ lineGradientStyle: function(lineWidth, topLeft, topRight, bottomLeft, bottomRight, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.GRADIENT_LINE_STYLE, lineWidth, alpha, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Start a new shape path.
     *
     * @method Phaser.GameObjects.Graphics#beginPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ beginPath: function() {
                    this.commandBuffer.push(Commands.BEGIN_PATH);
                    return this;
                },
                /**
     * Close the current path.
     *
     * @method Phaser.GameObjects.Graphics#closePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ closePath: function() {
                    this.commandBuffer.push(Commands.CLOSE_PATH);
                    return this;
                },
                /**
     * Fill the current path.
     *
     * @method Phaser.GameObjects.Graphics#fillPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ fillPath: function() {
                    this.commandBuffer.push(Commands.FILL_PATH);
                    return this;
                },
                /**
     * Fill the current path.
     *
     * This is an alias for `Graphics.fillPath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#fill
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ fill: function() {
                    this.commandBuffer.push(Commands.FILL_PATH);
                    return this;
                },
                /**
     * Stroke the current path.
     *
     * @method Phaser.GameObjects.Graphics#strokePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ strokePath: function() {
                    this.commandBuffer.push(Commands.STROKE_PATH);
                    return this;
                },
                /**
     * Stroke the current path.
     *
     * This is an alias for `Graphics.strokePath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#stroke
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ stroke: function() {
                    this.commandBuffer.push(Commands.STROKE_PATH);
                    return this;
                },
                /**
     * Fill the given circle.
     *
     * @method Phaser.GameObjects.Graphics#fillCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to fill.
     *
     * @return {this} This Game Object.
     */ fillCircleShape: function(circle) {
                    return this.fillCircle(circle.x, circle.y, circle.radius);
                },
                /**
     * Stroke the given circle.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeCircleShape: function(circle) {
                    return this.strokeCircle(circle.x, circle.y, circle.radius);
                },
                /**
     * Fill a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ fillCircle: function(x, y, radius) {
                    this.beginPath();
                    this.arc(x, y, radius, 0, MATH_CONST.PI2);
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ strokeCircle: function(x, y, radius) {
                    this.beginPath();
                    this.arc(x, y, radius, 0, MATH_CONST.PI2);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#fillRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to fill.
     *
     * @return {this} This Game Object.
     */ fillRectShape: function(rect) {
                    return this.fillRect(rect.x, rect.y, rect.width, rect.height);
                },
                /**
     * Stroke the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeRectShape: function(rect) {
                    return this.strokeRect(rect.x, rect.y, rect.width, rect.height);
                },
                /**
     * Fill a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ fillRect: function(x, y, width, height) {
                    this.commandBuffer.push(Commands.FILL_RECT, x, y, width, height);
                    return this;
                },
                /**
     * Stroke a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ strokeRect: function(x, y, width, height) {
                    var lineWidthHalf = this._lineWidth / 2;
                    var minx = x - lineWidthHalf;
                    var maxx = x + lineWidthHalf;
                    this.beginPath();
                    this.moveTo(x, y);
                    this.lineTo(x, y + height);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(x + width, y);
                    this.lineTo(x + width, y + height);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(minx, y);
                    this.lineTo(maxx + width, y);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(minx, y + height);
                    this.lineTo(maxx + width, y + height);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radii for corners.
     *
     * @return {this} This Game Object.
     */ fillRoundedRect: function(x, y, width, height, radius) {
                    if (radius === undefined) radius = 20;
                    var tl = radius;
                    var tr = radius;
                    var bl = radius;
                    var br = radius;
                    if (typeof radius !== "number") {
                        tl = GetFastValue(radius, "tl", 20);
                        tr = GetFastValue(radius, "tr", 20);
                        bl = GetFastValue(radius, "bl", 20);
                        br = GetFastValue(radius, "br", 20);
                    }
                    this.beginPath();
                    this.moveTo(x + tl, y);
                    this.lineTo(x + width - tr, y);
                    this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                    this.lineTo(x + width, y + height - br);
                    this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                    this.lineTo(x + bl, y + height);
                    this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                    this.lineTo(x, y + tl);
                    this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radii for corners.
     *
     * @return {this} This Game Object.
     */ strokeRoundedRect: function(x, y, width, height, radius) {
                    if (radius === undefined) radius = 20;
                    var tl = radius;
                    var tr = radius;
                    var bl = radius;
                    var br = radius;
                    if (typeof radius !== "number") {
                        tl = GetFastValue(radius, "tl", 20);
                        tr = GetFastValue(radius, "tr", 20);
                        bl = GetFastValue(radius, "bl", 20);
                        br = GetFastValue(radius, "br", 20);
                    }
                    this.beginPath();
                    this.moveTo(x + tl, y);
                    this.lineTo(x + width - tr, y);
                    this.moveTo(x + width - tr, y);
                    this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                    this.lineTo(x + width, y + height - br);
                    this.moveTo(x + width, y + height - br);
                    this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                    this.lineTo(x + bl, y + height);
                    this.moveTo(x + bl, y + height);
                    this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                    this.lineTo(x, y + tl);
                    this.moveTo(x, y + tl);
                    this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the given point.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPointShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - The point to fill.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPointShape: function(point, size) {
                    return this.fillPoint(point.x, point.y, size);
                },
                /**
     * Fill a point at the given position.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point.
     * @param {number} y - The y coordinate of the point.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPoint: function(x, y, size) {
                    if (!size || size < 1) size = 1;
                    else {
                        x -= size / 2;
                        y -= size / 2;
                    }
                    this.commandBuffer.push(Commands.FILL_RECT, x, y, size, size);
                    return this;
                },
                /**
     * Fill the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to fill.
     *
     * @return {this} This Game Object.
     */ fillTriangleShape: function(triangle) {
                    return this.fillTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                },
                /**
     * Stroke the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeTriangleShape: function(triangle) {
                    return this.strokeTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                },
                /**
     * Fill a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ fillTriangle: function(x0, y0, x1, y1, x2, y2) {
                    this.commandBuffer.push(Commands.FILL_TRIANGLE, x0, y0, x1, y1, x2, y2);
                    return this;
                },
                /**
     * Stroke a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ strokeTriangle: function(x0, y0, x1, y1, x2, y2) {
                    this.commandBuffer.push(Commands.STROKE_TRIANGLE, x0, y0, x1, y1, x2, y2);
                    return this;
                },
                /**
     * Draw the given line.
     *
     * @method Phaser.GameObjects.Graphics#strokeLineShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Line} line - The line to stroke.
     *
     * @return {this} This Game Object.
     */ strokeLineShape: function(line) {
                    return this.lineBetween(line.x1, line.y1, line.x2, line.y2);
                },
                /**
     * Draw a line between the given points.
     *
     * @method Phaser.GameObjects.Graphics#lineBetween
     * @since 3.0.0
     *
     * @param {number} x1 - The x coordinate of the start point of the line.
     * @param {number} y1 - The y coordinate of the start point of the line.
     * @param {number} x2 - The x coordinate of the end point of the line.
     * @param {number} y2 - The y coordinate of the end point of the line.
     *
     * @return {this} This Game Object.
     */ lineBetween: function(x1, y1, x2, y2) {
                    this.beginPath();
                    this.moveTo(x1, y1);
                    this.lineTo(x2, y2);
                    this.strokePath();
                    return this;
                },
                /**
     * Draw a line from the current drawing position to the given position.
     *
     * Moves the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#lineTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to draw the line to.
     * @param {number} y - The y coordinate to draw the line to.
     *
     * @return {this} This Game Object.
     */ lineTo: function(x, y) {
                    this.commandBuffer.push(Commands.LINE_TO, x, y);
                    return this;
                },
                /**
     * Move the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#moveTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to move to.
     * @param {number} y - The y coordinate to move to.
     *
     * @return {this} This Game Object.
     */ moveTo: function(x, y) {
                    this.commandBuffer.push(Commands.MOVE_TO, x, y);
                    return this;
                },
                /**
     * Stroke the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is stroked.
     *
     * @method Phaser.GameObjects.Graphics#strokePoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to stroke.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop drawing at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ strokePoints: function(points, closeShape, closePath, endIndex) {
                    if (closeShape === undefined) closeShape = false;
                    if (closePath === undefined) closePath = false;
                    if (endIndex === undefined) endIndex = points.length;
                    this.beginPath();
                    this.moveTo(points[0].x, points[0].y);
                    for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                    if (closeShape) this.lineTo(points[0].x, points[0].y);
                    if (closePath) this.closePath();
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is filled.
     *
     * @method Phaser.GameObjects.Graphics#fillPoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to fill.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ fillPoints: function(points, closeShape, closePath, endIndex) {
                    if (closeShape === undefined) closeShape = false;
                    if (closePath === undefined) closePath = false;
                    if (endIndex === undefined) endIndex = points.length;
                    this.beginPath();
                    this.moveTo(points[0].x, points[0].y);
                    for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                    if (closeShape) this.lineTo(points[0].x, points[0].y);
                    if (closePath) this.closePath();
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to stroke.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipseShape: function(ellipse, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var points = ellipse.getPoints(smoothness);
                    return this.strokePoints(points, true);
                },
                /**
     * Stroke an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipse: function(x, y, width, height, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var ellipse = new Ellipse(x, y, width, height);
                    var points = ellipse.getPoints(smoothness);
                    return this.strokePoints(points, true);
                },
                /**
     * Fill the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to fill.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipseShape: function(ellipse, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var points = ellipse.getPoints(smoothness);
                    return this.fillPoints(points, true);
                },
                /**
     * Fill an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipse: function(x, y, width, height, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var ellipse = new Ellipse(x, y, width, height);
                    var points = ellipse.getPoints(smoothness);
                    return this.fillPoints(points, true);
                },
                /**
     * Draw an arc.
     *
     * This method can be used to create circles, or parts of circles.
     *
     * Make sure you call `beginPath` before starting the arc unless you wish for the arc to automatically
     * close when filled or stroked.
     *
     * Use the optional `overshoot` argument increase the number of iterations that take place when
     * the arc is rendered in WebGL. This is useful if you're drawing an arc with an especially thick line,
     * as it will allow the arc to fully join-up. Try small values at first, i.e. 0.01.
     *
     * Call {@link Phaser.GameObjects.Graphics#fillPath} or {@link Phaser.GameObjects.Graphics#strokePath} after calling
     * this method to draw the arc.
     *
     * @method Phaser.GameObjects.Graphics#arc
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {number} startAngle - The starting angle, in radians.
     * @param {number} endAngle - The ending angle, in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to increase the segment iterations in WebGL rendering. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly. Use small numbers such as 0.01 to start with and increase as needed.
     *
     * @return {this} This Game Object.
     */ arc: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                    if (anticlockwise === undefined) anticlockwise = false;
                    if (overshoot === undefined) overshoot = 0;
                    this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                    return this;
                },
                /**
     * Creates a pie-chart slice shape centered at `x`, `y` with the given radius.
     * You must define the start and end angle of the slice.
     *
     * Setting the `anticlockwise` argument to `true` creates a shape similar to Pacman.
     * Setting it to `false` creates a shape like a slice of pie.
     *
     * This method will begin a new path and close the path at the end of it.
     * To display the actual slice you need to call either `strokePath` or `fillPath` after it.
     *
     * @method Phaser.GameObjects.Graphics#slice
     * @since 3.4.0
     *
     * @param {number} x - The horizontal center of the slice.
     * @param {number} y - The vertical center of the slice.
     * @param {number} radius - The radius of the slice.
     * @param {number} startAngle - The start angle of the slice, given in radians.
     * @param {number} endAngle - The end angle of the slice, given in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to overshoot the endAngle by this amount. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly.
     *
     * @return {this} This Game Object.
     */ slice: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                    if (anticlockwise === undefined) anticlockwise = false;
                    if (overshoot === undefined) overshoot = 0;
                    this.commandBuffer.push(Commands.BEGIN_PATH);
                    this.commandBuffer.push(Commands.MOVE_TO, x, y);
                    this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                    this.commandBuffer.push(Commands.CLOSE_PATH);
                    return this;
                },
                /**
     * Saves the state of the Graphics by pushing the current state onto a stack.
     *
     * The most recently saved state can then be restored with {@link Phaser.GameObjects.Graphics#restore}.
     *
     * @method Phaser.GameObjects.Graphics#save
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ save: function() {
                    this.commandBuffer.push(Commands.SAVE);
                    return this;
                },
                /**
     * Restores the most recently saved state of the Graphics by popping from the state stack.
     *
     * Use {@link Phaser.GameObjects.Graphics#save} to save the current state, and call this afterwards to restore that state.
     *
     * If there is no saved state, this command does nothing.
     *
     * @method Phaser.GameObjects.Graphics#restore
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ restore: function() {
                    this.commandBuffer.push(Commands.RESTORE);
                    return this;
                },
                /**
     * Inserts a translation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be translated
     * by the given amount.
     *
     * This does not change the position of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#translateCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation to apply.
     * @param {number} y - The vertical translation to apply.
     *
     * @return {this} This Game Object.
     */ translateCanvas: function(x, y) {
                    this.commandBuffer.push(Commands.TRANSLATE, x, y);
                    return this;
                },
                /**
     * Inserts a scale command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be scaled
     * by the given amount.
     *
     * This does not change the scale of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#scaleCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale to apply.
     * @param {number} y - The vertical scale to apply.
     *
     * @return {this} This Game Object.
     */ scaleCanvas: function(x, y) {
                    this.commandBuffer.push(Commands.SCALE, x, y);
                    return this;
                },
                /**
     * Inserts a rotation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be rotated
     * by the given amount.
     *
     * This does not change the rotation of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#rotateCanvas
     * @since 3.0.0
     *
     * @param {number} radians - The rotation angle, in radians.
     *
     * @return {this} This Game Object.
     */ rotateCanvas: function(radians) {
                    this.commandBuffer.push(Commands.ROTATE, radians);
                    return this;
                },
                /**
     * Clear the command buffer and reset the fill style and line style to their defaults.
     *
     * @method Phaser.GameObjects.Graphics#clear
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ clear: function() {
                    this.commandBuffer.length = 0;
                    if (this.defaultFillColor > -1) this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                    if (this.defaultStrokeColor > -1) this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                    return this;
                },
                /**
     * Generate a texture from this Graphics object.
     *
     * If `key` is a string it'll generate a new texture using it and add it into the
     * Texture Manager (assuming no key conflict happens).
     *
     * If `key` is a Canvas it will draw the texture to that canvas context. Note that it will NOT
     * automatically upload it to the GPU in WebGL mode.
     *
     * Please understand that the texture is created via the Canvas API of the browser, therefore some
     * Graphics features, such as `fillGradientStyle`, will not appear on the resulting texture,
     * as they're unsupported by the Canvas API.
     *
     * @method Phaser.GameObjects.Graphics#generateTexture
     * @since 3.0.0
     *
     * @param {(string|HTMLCanvasElement)} key - The key to store the texture with in the Texture Manager, or a Canvas to draw to.
     * @param {number} [width] - The width of the graphics to generate.
     * @param {number} [height] - The height of the graphics to generate.
     *
     * @return {this} This Game Object.
     */ generateTexture: function(key, width, height) {
                    var sys = this.scene.sys;
                    var renderer = sys.game.renderer;
                    if (width === undefined) width = sys.scale.width;
                    if (height === undefined) height = sys.scale.height;
                    Graphics.TargetCamera.setScene(this.scene);
                    Graphics.TargetCamera.setViewport(0, 0, width, height);
                    Graphics.TargetCamera.scrollX = this.x;
                    Graphics.TargetCamera.scrollY = this.y;
                    var texture;
                    var ctx;
                    if (typeof key === "string") {
                        if (sys.textures.exists(key)) {
                            //  Key is a string, it DOES exist in the Texture Manager AND is a canvas, so draw to it
                            texture = sys.textures.get(key);
                            var src = texture.getSourceImage();
                            if (src instanceof HTMLCanvasElement) ctx = src.getContext("2d");
                        } else {
                            //  Key is a string and doesn't exist in the Texture Manager, so generate and save it
                            texture = sys.textures.createCanvas(key, width, height);
                            ctx = texture.getSourceImage().getContext("2d");
                        }
                    } else if (key instanceof HTMLCanvasElement) //  Key is a Canvas, so draw to it
                    ctx = key.getContext("2d");
                    if (ctx) {
                        // var GraphicsCanvasRenderer = function (renderer, src, camera, parentMatrix, renderTargetCtx, allowClip)
                        this.renderCanvas(renderer, this, Graphics.TargetCamera, null, ctx, false);
                        if (texture) texture.refresh();
                    }
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Graphics#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.commandBuffer = [];
                }
            });
            /**
 * A Camera used specifically by the Graphics system for rendering to textures.
 *
 * @name Phaser.GameObjects.Graphics.TargetCamera
 * @type {Phaser.Cameras.Scene2D.Camera}
 * @since 3.1.0
 */ Graphics.TargetCamera = new BaseCamera();
            module1.exports = Graphics;
        /***/ },
        /* 217 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = {
                ARC: 0,
                BEGIN_PATH: 1,
                CLOSE_PATH: 2,
                FILL_RECT: 3,
                LINE_TO: 4,
                MOVE_TO: 5,
                LINE_STYLE: 6,
                FILL_STYLE: 7,
                FILL_PATH: 8,
                STROKE_PATH: 9,
                FILL_TRIANGLE: 10,
                STROKE_TRIANGLE: 11,
                SAVE: 14,
                RESTORE: 15,
                TRANSLATE: 16,
                SCALE: 17,
                ROTATE: 18,
                GRADIENT_FILL_STYLE: 21,
                GRADIENT_LINE_STYLE: 22
            };
        /***/ },
        /* 218 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse based on the given angle.
 *
 * @function Phaser.Geom.Ellipse.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} angle - The angle from the center of the Ellipse to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(ellipse, angle, out) {
                if (out === undefined) out = new Point();
                var halfWidth = ellipse.width / 2;
                var halfHeight = ellipse.height / 2;
                out.x = ellipse.x + halfWidth * Math.cos(angle);
                out.y = ellipse.y + halfHeight * Math.sin(angle);
                return out;
            };
            module1.exports = CircumferencePoint;
        /***/ },
        /* 219 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var ComponentsToJSON = __webpack_require__(176);
            var DataManager = __webpack_require__(101);
            var EventEmitter = __webpack_require__(9);
            var GameObjectEvents = __webpack_require__(75);
            var List = __webpack_require__(110);
            var Render = __webpack_require__(1071);
            var SceneEvents = __webpack_require__(20);
            var StableSort = __webpack_require__(79);
            /**
 * @classdesc
 * A Layer Game Object.
 *
 * A Layer is a special type of Game Object that acts as a Display List. You can add any type of Game Object
 * to a Layer, just as you would to a Scene. Layers can be used to visually group together 'layers' of Game
 * Objects:
 *
 * ```javascript
 * const spaceman = this.add.sprite(150, 300, 'spaceman');
 * const bunny = this.add.sprite(400, 300, 'bunny');
 * const elephant = this.add.sprite(650, 300, 'elephant');
 *
 * const layer = this.add.layer();
 *
 * layer.add([ spaceman, bunny, elephant ]);
 * ```
 *
 * The 3 sprites in the example above will now be managed by the Layer they were added to. Therefore,
 * if you then set `layer.setVisible(false)` they would all vanish from the display.
 *
 * You can also control the depth of the Game Objects within the Layer. For example, calling the
 * `setDepth` method of a child of a Layer will allow you to adjust the depth of that child _within the
 * Layer itself_, rather than the whole Scene. The Layer, too, can have its depth set as well.
 *
 * The Layer class also offers many different methods for manipulating the list, such as the
 * methods `moveUp`, `moveDown`, `sendToBack`, `bringToTop` and so on. These allow you to change the
 * display list position of the Layers children, causing it to adjust the order in which they are
 * rendered. Using `setDepth` on a child allows you to override this.
 *
 * Layers can have Post FX Pipelines set, which allows you to easily enable a post pipeline across
 * a whole range of children, which, depending on the effect, can often be far more efficient that doing so
 * on a per-child basis.
 *
 * Layers have no position or size within the Scene. This means you cannot enable a Layer for
 * physics or input, or change the position, rotation or scale of a Layer. They also have no scroll
 * factor, texture, tint, origin, crop or bounds.
 *
 * If you need those kind of features then you should use a Container instead. Containers can be added
 * to Layers, but Layers cannot be added to Containers.
 *
 * However, you can set the Alpha, Blend Mode, Depth, Mask and Visible state of a Layer. These settings
 * will impact all children being rendered by the Layer.
 *
 * @class Layer
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 */ var Layer = new Class({
                Extends: List,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Visible,
                    EventEmitter,
                    Render
                ],
                initialize: function Layer(scene, children) {
                    List.call(this, scene);
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.Layer#scene
         * @type {Phaser.Scene}
         * @since 3.50.0
         */ this.scene = scene;
                    /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.Layer#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                    /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Layer#type
         * @type {string}
         * @since 3.50.0
         */ this.type = "Layer";
                    /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.Layer#state
         * @type {(number|string)}
         * @since 3.50.0
         */ this.state = 0;
                    /**
         * A Layer cannot be placed inside a Container.
         *
         * This property is kept purely so a Layer has the same
         * shape as a Game Object.
         *
         * @name Phaser.GameObjects.Layer#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.51.0
         */ this.parentContainer = null;
                    /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Layer#name
         * @type {string}
         * @default ''
         * @since 3.50.0
         */ this.name = "";
                    /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.Layer#active
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.active = true;
                    /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.Layer#tabIndex
         * @type {number}
         * @default -1
         * @since 3.51.0
         */ this.tabIndex = -1;
                    /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.Layer#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.50.0
         */ this.data = null;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.Layer#renderFlags
         * @type {number}
         * @default 15
         * @since 3.50.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.Layer#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.cameraFilter = 0;
                    /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot input enable a Layer.
         *
         * @name Phaser.GameObjects.Layer#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.51.0
         */ this.input = null;
                    /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot give a Layer a physics body.
         *
         * @name Phaser.GameObjects.Layer#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.51.0
         */ this.body = null;
                    /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.Layer#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.ignoreDestroy = false;
                    /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.GameObjects.Layer#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.50.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.Layer#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.Layer#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.sortChildrenFlag = false;
                    //  Set the List callbacks
                    this.addCallback = this.addChildCallback;
                    this.removeCallback = this.removeChildCallback;
                    this.initPipeline();
                    this.clearAlpha();
                    this.setBlendMode(BlendModes.SKIP_CHECK);
                    if (children) this.add(children);
                    //  Tell the Scene to re-sort the children
                    scene.sys.queueDepthSort();
                },
                /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.Layer#setActive
     * @since 3.50.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Layer#setName
     * @since 3.50.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.Layer#setState
     * @since 3.50.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                    this.state = value;
                    return this;
                },
                /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.Layer#setDataEnabled
     * @since 3.50.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                    if (!this.data) this.data = new DataManager(this);
                    return this;
                },
                /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.Layer#setData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.set(key, value);
                    return this;
                },
                /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#incData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.inc(key, value);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#toggleData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.toggle(key);
                    return this;
                },
                /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.Layer#getData
     * @since 3.50.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    return this.data.get(key);
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#setInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ setInteractive: function() {
                    return this;
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#disableInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ disableInteractive: function() {
                    return this;
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#removeInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ removeInteractive: function() {
                    return this;
                },
                /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.Layer#update
     * @since 3.50.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.Layer#toJSON
     * @since 3.50.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return ComponentsToJSON(this);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Layer#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(this.renderFlags !== 15 || this.list.length === 0 || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.Layer#getIndexList
     * @since 3.51.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                    // eslint-disable-next-line consistent-this
                    var child = this;
                    var parent = this.parentContainer;
                    var indexes = [];
                    while(parent){
                        indexes.unshift(parent.getIndex(child));
                        child = parent;
                        if (!parent.parentContainer) break;
                        else parent = parent.parentContainer;
                    }
                    indexes.unshift(this.displayList.getIndex(child));
                    return indexes;
                },
                /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.Layer#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                    if (gameObject.displayList && gameObject.displayList !== this) gameObject.removeFromDisplayList();
                    if (!gameObject.displayList) {
                        this.queueDepthSort();
                        gameObject.displayList = this;
                        gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                        this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                    }
                },
                /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.Layer#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                    this.queueDepthSort();
                    gameObject.displayList = null;
                    gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                },
                /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.Layer#queueDepthSort
     * @since 3.50.0
     */ queueDepthSort: function() {
                    this.sortChildrenFlag = true;
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.Layer#depthSort
     * @since 3.50.0
     */ depthSort: function() {
                    if (this.sortChildrenFlag) {
                        StableSort(this.list, this.sortByDepth);
                        this.sortChildrenFlag = false;
                    }
                },
                /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.Layer#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                    return childA._depth - childB._depth;
                },
                /**
     * Returns an array which contains all Game Objects within this Layer.
     *
     * This is a reference to the main list array, not a copy of it, so be careful not to modify it.
     *
     * @method Phaser.GameObjects.Layer#getChildren
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.list;
                },
                /**
     * Destroys this Layer removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also destroys all children of this Layer. If you do not wish for the
     * children to be destroyed, you should move them from this Layer first.
     *
     * Use this to remove this Layer from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.Layer#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.50.0
     */ destroy: function() {
                    //  This Game Object has already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    this.emit(GameObjectEvents.DESTROY, this);
                    var i = this.list.length;
                    while(i--)this.list[i].destroy();
                    this.removeAllListeners();
                    this.resetPostPipeline(true);
                    if (this.displayList) {
                        this.displayList.remove(this, true);
                        this.displayList.queueDepthSort();
                    }
                    if (this.data) {
                        this.data.destroy();
                        this.data = undefined;
                    }
                    this.active = false;
                    this.visible = false;
                    this.list = undefined;
                    this.scene = undefined;
                    this.displayList = undefined;
                    this.systems = undefined;
                    this.events = undefined;
                }
            });
            module1.exports = Layer;
        /***/ },
        /* 220 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GravityWell = __webpack_require__(450);
            var List = __webpack_require__(110);
            var ParticleEmitter = __webpack_require__(452);
            var Render = __webpack_require__(1075);
            /**
 * @classdesc
 * A Particle Emitter Manager creates and controls {@link Phaser.GameObjects.Particles.ParticleEmitter Particle Emitters} and {@link Phaser.GameObjects.Particles.GravityWell Gravity Wells}.
 *
 * @class ParticleEmitterManager
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Emitter Manager belongs.
 * @param {string} texture - The key of the Texture this Emitter Manager will use to render particles, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Emitter Manager will use to render particles.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterConfig[]} [emitters] - Configuration settings for one or more emitters to create.
 */ var ParticleEmitterManager = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: //  frame is optional and can contain the emitters array or object if skipped
                function ParticleEmitterManager(scene, texture, frame, emitters) {
                    GameObject.call(this, scene, "ParticleEmitterManager");
                    /**
         * The blend mode applied to all emitters and particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#blendMode
         * @type {number}
         * @default -1
         * @private
         * @since 3.0.0
         */ this.blendMode = -1;
                    /**
         * The time scale applied to all emitters and particles, affecting flow rate, lifespan, and movement.
         * Values larger than 1 are faster than normal.
         * This is multiplied with any timeScale set on each individual emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * The texture used to render this Emitter Manager's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#texture
         * @type {Phaser.Textures.Texture}
         * @default null
         * @since 3.0.0
         */ this.texture = null;
                    /**
         * The texture frame used to render this Emitter Manager's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frame
         * @type {Phaser.Textures.Frame}
         * @default null
         * @since 3.0.0
         */ this.frame = null;
                    /**
         * Names of this Emitter Manager's texture frames.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frameNames
         * @type {string[]}
         * @since 3.0.0
         */ this.frameNames = [];
                    //  frame is optional and can contain the emitters array or object if skipped
                    if (frame !== null && (typeof frame === "object" || Array.isArray(frame))) {
                        emitters = frame;
                        frame = null;
                    }
                    this.setTexture(texture, frame);
                    this.initPipeline();
                    /**
         * A list of Emitters being managed by this Emitter Manager.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#emitters
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.ParticleEmitter>}
         * @since 3.0.0
         */ this.emitters = new List(this);
                    /**
         * A list of Gravity Wells being managed by this Emitter Manager.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#wells
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.GravityWell>}
         * @since 3.0.0
         */ this.wells = new List(this);
                    if (emitters) {
                        //  An array of emitter configs?
                        if (!Array.isArray(emitters)) emitters = [
                            emitters
                        ];
                        for(var i = 0; i < emitters.length; i++)this.createEmitter(emitters[i]);
                    }
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Sets the texture and frame this Emitter Manager will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Emitter Manager.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Emitter Manager will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Emitter Manager.
     */ setFrame: function(frame) {
                    this.frame = this.texture.get(frame);
                    var frames = this.texture.getFramesFromTextureSource(this.frame.sourceIndex);
                    var names = [];
                    frames.forEach(function(sourceFrame) {
                        names.push(sourceFrame.name);
                    });
                    this.frameNames = names;
                    this.defaultFrame = this.frame;
                    return this;
                },
                /**
     * Assigns texture frames to an emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setEmitterFrames
     * @since 3.0.0
     *
     * @param {(Phaser.Textures.Frame|Phaser.Textures.Frame[])} frames - The texture frames.
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The particle emitter to modify.
     *
     * @return {this} This Emitter Manager.
     */ setEmitterFrames: function(frames, emitter) {
                    if (!Array.isArray(frames)) frames = [
                        frames
                    ];
                    var out = emitter.frames;
                    out.length = 0;
                    for(var i = 0; i < frames.length; i++){
                        var frame = frames[i];
                        if (this.frameNames.indexOf(frame) !== -1) out.push(this.texture.get(frame));
                    }
                    if (out.length > 0) emitter.defaultFrame = out[0];
                    else emitter.defaultFrame = this.defaultFrame;
                    return this;
                },
                /**
     * Adds an existing Particle Emitter to this Emitter Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addEmitter
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Particle Emitter to add to this Emitter Manager.
     *
     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was added to this Emitter Manager.
     */ addEmitter: function(emitter) {
                    return this.emitters.add(emitter);
                },
                /**
     * Creates a new Particle Emitter object, adds it to this Emitter Manager and returns a reference to it.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createEmitter
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Configuration settings for the Particle Emitter to create.
     *
     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was created.
     */ createEmitter: function(config) {
                    return this.addEmitter(new ParticleEmitter(this, config));
                },
                /**
     * Removes a Particle Emitter from this Emitter Manager, if the Emitter belongs to this Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#removeEmitter
     * @since 3.22.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter
     *
     * @return {?Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter if it was removed or null if it was not.
     */ removeEmitter: function(emitter) {
                    return this.emitters.remove(emitter, true);
                },
                /**
     * Adds an existing Gravity Well object to this Emitter Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addGravityWell
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.GravityWell} well - The Gravity Well to add to this Emitter Manager.
     *
     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was added to this Emitter Manager.
     */ addGravityWell: function(well) {
                    return this.wells.add(well);
                },
                /**
     * Creates a new Gravity Well, adds it to this Emitter Manager and returns a reference to it.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createGravityWell
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.GravityWellConfig} config - Configuration settings for the Gravity Well to create.
     *
     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was created.
     */ createGravityWell: function(config) {
                    return this.addGravityWell(new GravityWell(config));
                },
                /**
     * Emits particles from each active emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticle
     * @since 3.0.0
     *
     * @param {number} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     * @param {number} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
     * @param {number} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
     *
     * @return {this} This Emitter Manager.
     */ emitParticle: function(count, x, y) {
                    var emitters = this.emitters.list;
                    for(var i = 0; i < emitters.length; i++){
                        var emitter = emitters[i];
                        if (emitter.active) emitter.emitParticle(count, x, y);
                    }
                    return this;
                },
                /**
     * Emits particles from each active emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticleAt
     * @since 3.0.0
     *
     * @param {number} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
     * @param {number} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
     * @param {number} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     *
     * @return {this} This Emitter Manager.
     */ emitParticleAt: function(x, y, count) {
                    return this.emitParticle(count, x, y);
                },
                /**
     * Pauses this Emitter Manager.
     *
     * This has the effect of pausing all emitters, and all particles of those emitters, currently under its control.
     *
     * The particles will still render, but they will not have any of their logic updated.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#pause
     * @since 3.0.0
     *
     * @return {this} This Emitter Manager.
     */ pause: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Resumes this Emitter Manager, should it have been previously paused.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#resume
     * @since 3.0.0
     *
     * @return {this} This Emitter Manager.
     */ resume: function() {
                    this.active = true;
                    return this;
                },
                /**
     * Gets all active particle processors (gravity wells).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#getProcessors
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Particles.GravityWell[]} - The active gravity wells.
     */ getProcessors: function() {
                    return this.wells.getAll("active", true);
                },
                /**
     * Updates all active emitters.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    //  Scale the delta
                    delta *= this.timeScale;
                    var emitters = this.emitters.list;
                    for(var i = 0; i < emitters.length; i++){
                        var emitter = emitters[i];
                        if (emitter.active) emitter.preUpdate(time, delta);
                    }
                },
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setAlpha
     * @private
     * @since 3.10.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setScrollFactor
     * @private
     * @since 3.10.0
     */ setScrollFactor: function() {},
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setBlendMode
     * @private
     * @since 3.15.0
     */ setBlendMode: function() {}
            });
            module1.exports = ParticleEmitterManager;
        /***/ },
        /* 221 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            var Camera = __webpack_require__(133);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var CONST = __webpack_require__(33);
            var Frame = __webpack_require__(109);
            var GameObject = __webpack_require__(15);
            var NOOP = __webpack_require__(1);
            var PIPELINE_CONST = __webpack_require__(92);
            var Render = __webpack_require__(1079);
            var RenderTarget = __webpack_require__(141);
            var Utils = __webpack_require__(12);
            var UUID = __webpack_require__(222);
            /**
 * @classdesc
 * A Render Texture.
 *
 * A Render Texture is a special texture that allows any number of Game Objects to be drawn to it. You can take many complex objects and
 * draw them all to this one texture, which can they be used as the texture for other Game Object's. It's a way to generate dynamic
 * textures at run-time that are WebGL friendly and don't invoke expensive GPU uploads.
 *
 * Note that under WebGL a FrameBuffer, which is what the Render Texture uses internally, cannot be anti-aliased. This means
 * that when drawing objects such as Shapes to a Render Texture they will appear to be drawn with no aliasing, however this
 * is a technical limitation of WebGL. To get around it, create your shape as a texture in an art package, then draw that
 * to the Render Texture.
 *
 * @class RenderTexture
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.2.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 * @param {string} [key] - The texture key to make the RenderTexture from.
 * @param {string} [frame] - The frame to make the RenderTexture from.
 */ var RenderTexture = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function RenderTexture(scene, x, y, width, height, key, frame) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 32;
                    if (height === undefined) height = 32;
                    GameObject.call(this, scene, "RenderTexture");
                    /**
         * A reference to either the Canvas or WebGL Renderer that the Game instance is using.
         *
         * @name Phaser.GameObjects.RenderTexture#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.2.0
         */ this.renderer = scene.sys.renderer;
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.GameObjects.RenderTexture#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.12.0
         */ this.textureManager = scene.sys.textures;
                    /**
         * The tint of the Render Texture when rendered.
         *
         * @name Phaser.GameObjects.RenderTexture#globalTint
         * @type {number}
         * @default 0xffffff
         * @since 3.2.0
         */ this.globalTint = 0xffffff;
                    /**
         * The alpha of the Render Texture when rendered.
         *
         * @name Phaser.GameObjects.RenderTexture#globalAlpha
         * @type {number}
         * @default 1
         * @since 3.2.0
         */ this.globalAlpha = 1;
                    /**
         * The HTML Canvas Element that the Render Texture is drawing to when using the Canvas Renderer.
         *
         * @name Phaser.GameObjects.RenderTexture#canvas
         * @type {HTMLCanvasElement}
         * @since 3.2.0
         */ this.canvas = null;
                    /**
         * Is this Render Texture dirty or not? If not it won't spend time clearing or filling itself.
         *
         * @name Phaser.GameObjects.RenderTexture#dirty
         * @type {boolean}
         * @since 3.12.0
         */ this.dirty = false;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.RenderTexture#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Texture corresponding to this Render Texture.
         *
         * @name Phaser.GameObjects.RenderTexture#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.12.0
         */ this.texture = null;
                    /**
         * The Frame corresponding to this Render Texture.
         *
         * @name Phaser.GameObjects.RenderTexture#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.12.0
         */ this.frame = null;
                    /**
         * Internal saved texture flag.
         *
         * @name Phaser.GameObjects.RenderTexture#_saved
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this._saved = false;
                    if (key === undefined) {
                        this.canvas = CanvasPool.create2D(this, width, height);
                        //  Create a new Texture for this RenderTexture object
                        this.texture = scene.sys.textures.addCanvas(UUID(), this.canvas);
                        //  Get the frame
                        this.frame = this.texture.get();
                    } else {
                        this.texture = scene.sys.textures.get(key);
                        //  Get the frame
                        this.frame = this.texture.get(frame);
                        this.canvas = this.frame.source.image;
                        this._saved = true;
                        this.dirty = true;
                        this.width = this.frame.cutWidth;
                        this.height = this.frame.cutHeight;
                    }
                    /**
         * A reference to the Rendering Context belonging to the Canvas Element this Render Texture is drawing to.
         *
         * @name Phaser.GameObjects.RenderTexture#context
         * @type {CanvasRenderingContext2D}
         * @since 3.2.0
         */ this.context = this.canvas.getContext("2d");
                    /**
         * Internal erase mode flag.
         *
         * @name Phaser.GameObjects.RenderTexture#_eraseMode
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._eraseMode = false;
                    /**
         * An internal Camera that can be used to move around the Render Texture.
         * Control it just like you would any Scene Camera. The difference is that it only impacts the placement of what
         * is drawn to the Render Texture. You can scroll, zoom and rotate this Camera.
         *
         * @name Phaser.GameObjects.RenderTexture#camera
         * @type {Phaser.Cameras.Scene2D.BaseCamera}
         * @since 3.12.0
         */ this.camera = new Camera(0, 0, width, height);
                    /**
         * The Render Target that belongs to this Render Texture.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * This property remains `null` under Canvas.
         *
         * @name Phaser.GameObjects.RenderTexture#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.renderTarget = null;
                    var renderer = this.renderer;
                    if (!renderer) this.drawGameObject = NOOP;
                    else if (renderer.type === CONST.WEBGL) {
                        this.drawGameObject = this.batchGameObjectWebGL;
                        this.renderTarget = new RenderTarget(renderer, width, height, 1, 0, false);
                    } else if (renderer.type === CONST.CANVAS) this.drawGameObject = this.batchGameObjectCanvas;
                    this.camera.setScene(scene);
                    this.setPosition(x, y);
                    if (key === undefined) this.setSize(width, height);
                    this.setOrigin(0, 0);
                    this.initPipeline(PIPELINE_CONST.SINGLE_PIPELINE);
                },
                /**
     * Sets the size of this Game Object.
     *
     * @method Phaser.GameObjects.RenderTexture#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    return this.resize(width, height);
                },
                /**
     * Resizes the Render Texture to the new dimensions given.
     *
     * If Render Texture was created from specific frame, only the size of the frame will be changed. The size of the source
     * texture will not change.
     *
     * If Render Texture was not created from specific frame, the following will happen:
     *
     * In WebGL it will destroy and then re-create the frame buffer being used by the Render Texture.
     * In Canvas it will resize the underlying canvas element.
     *
     * Both approaches will erase everything currently drawn to the Render Texture.
     *
     * If the dimensions given are the same as those already being used, calling this method will do nothing.
     *
     * @method Phaser.GameObjects.RenderTexture#resize
     * @since 3.10.0
     *
     * @param {number} width - The new width of the Render Texture.
     * @param {number} [height=width] - The new height of the Render Texture. If not specified, will be set the same as the `width`.
     *
     * @return {this} This Render Texture.
     */ resize: function(width, height) {
                    if (height === undefined) height = width;
                    var frame = this.frame;
                    if (width !== this.width || height !== this.height) {
                        if (frame.name === "__BASE") {
                            //  Resize the texture
                            this.canvas.width = width;
                            this.canvas.height = height;
                            this.texture.width = width;
                            this.texture.height = height;
                            var renderTarget = this.renderTarget;
                            if (renderTarget) {
                                renderTarget.resize(width, height);
                                frame.glTexture = renderTarget.texture;
                                frame.source.isRenderTexture = true;
                                frame.source.isGLTexture = true;
                                frame.source.glTexture = renderTarget.texture;
                            }
                            this.camera.setSize(width, height);
                            frame.source.width = width;
                            frame.source.height = height;
                            frame.setSize(width, height);
                            this.width = width;
                            this.height = height;
                        }
                    } else {
                        //  Resize the frame
                        var baseFrame = this.texture.getSourceImage();
                        if (frame.cutX + width > baseFrame.width) width = baseFrame.width - frame.cutX;
                        if (frame.cutY + height > baseFrame.height) height = baseFrame.height - frame.cutY;
                        frame.setSize(width, height, frame.cutX, frame.cutY);
                    }
                    this.updateDisplayOrigin();
                    var input = this.input;
                    if (input && !input.customHitArea) {
                        input.hitArea.width = width;
                        input.hitArea.height = height;
                    }
                    return this;
                },
                /**
     * Set the tint to use when rendering this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#setGlobalTint
     * @since 3.2.0
     *
     * @param {number} tint - The tint value.
     *
     * @return {this} This Render Texture.
     */ setGlobalTint: function(tint) {
                    this.globalTint = tint;
                    return this;
                },
                /**
     * Set the alpha to use when rendering this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#setGlobalAlpha
     * @since 3.2.0
     *
     * @param {number} alpha - The alpha value.
     *
     * @return {this} This Render Texture.
     */ setGlobalAlpha: function(alpha) {
                    this.globalAlpha = alpha;
                    return this;
                },
                /**
     * Stores a copy of this Render Texture in the Texture Manager using the given key.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of this
     * Render Texture by using the texture key:
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 128, 128);
     *
     * // Draw something to the Render Texture
     *
     * rt.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of this Render Texture will automatically update _any_ Game Object
     * that is using it as a texture. Calling `saveTexture` again will not save another copy
     * of the same texture, it will just rename the key of the existing copy.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * If you destroy this Render Texture, any Game Object using it via the Texture Manager will
     * stop rendering. Ensure you remove the texture from the Texture Manager and any Game Objects
     * using it first, before destroying this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#saveTexture
     * @since 3.12.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.Texture} The Texture that was saved.
     */ saveTexture: function(key) {
                    this.textureManager.renameTexture(this.texture.key, key);
                    this._saved = true;
                    return this.texture;
                },
                /**
     * Fills the Render Texture with the given color.
     *
     * @method Phaser.GameObjects.RenderTexture#fill
     * @since 3.2.0
     *
     * @param {number} rgb - The color to fill the Render Texture with.
     * @param {number} [alpha=1] - The alpha value used by the fill.
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.frame.cutWidth] - The width of the fill rectangle.
     * @param {number} [height=this.frame.cutHeight] - The height of the fill rectangle.
     *
     * @return {this} This Render Texture instance.
     */ fill: function(rgb, alpha, x, y, width, height) {
                    var frame = this.frame;
                    var camera = this.camera;
                    var renderer = this.renderer;
                    if (alpha === undefined) alpha = 1;
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = frame.cutWidth;
                    if (height === undefined) height = frame.cutHeight;
                    var r = (rgb >> 16 & 0xFF) / 255;
                    var g = (rgb >> 8 & 0xFF) / 255;
                    var b = (rgb & 0xFF) / 255;
                    var renderTarget = this.renderTarget;
                    camera.preRender();
                    if (renderTarget) {
                        renderTarget.bind(true);
                        var pipeline = this.pipeline;
                        pipeline.manager.set(pipeline);
                        var tw = renderTarget.width;
                        var th = renderTarget.height;
                        var rw = renderer.width;
                        var rh = renderer.height;
                        var sx = rw / tw;
                        var sy = rh / th;
                        pipeline.drawFillRect(x * sx, y * sy, width * sx, height * sy, Utils.getTintFromFloats(b, g, r, 1), alpha);
                        renderTarget.unbind(true);
                    } else {
                        var ctx = this.context;
                        renderer.setContext(ctx);
                        ctx.fillStyle = "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
                        ctx.fillRect(x + frame.cutX, y + frame.cutY, width, height);
                        renderer.setContext();
                    }
                    this.dirty = true;
                    return this;
                },
                /**
     * Clears the Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#clear
     * @since 3.2.0
     *
     * @return {this} This Render Texture instance.
     */ clear: function() {
                    if (this.dirty) {
                        var renderTarget = this.renderTarget;
                        if (renderTarget) renderTarget.clear();
                        else {
                            var ctx = this.context;
                            ctx.save();
                            ctx.setTransform(1, 0, 0, 1, 0, 0);
                            ctx.clearRect(this.frame.cutX, this.frame.cutY, this.frame.cutWidth, this.frame.cutHeight);
                            ctx.restore();
                        }
                        this.dirty = false;
                    }
                    return this;
                },
                /**
     * Draws the given object, or an array of objects, to this Render Texture using a blend mode of ERASE.
     * This has the effect of erasing any filled pixels in the objects from this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot erase a Render Texture from itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#erase
     * @since 3.16.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     *
     * @return {this} This Render Texture instance.
     */ erase: function(entries, x, y) {
                    this._eraseMode = true;
                    this.draw(entries, x, y, 1, 16777215);
                    this._eraseMode = false;
                    return this;
                },
                /**
     * Draws the given object, or an array of objects, to this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Render Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#draw
     * @since 3.2.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha] -  The alpha value. Only used for Texture Frames and if not specified defaults to the `globalAlpha` property. Game Objects use their own current alpha value.
     * @param {number} [tint] -  WebGL only. The tint color value. Only used for Texture Frames and if not specified defaults to the `globalTint` property. Game Objects use their own current tint value.
     *
     * @return {this} This Render Texture instance.
     */ draw: function(entries, x, y, alpha, tint) {
                    this.beginDraw();
                    this.batchDraw(entries, x, y, alpha, tint);
                    this.endDraw();
                    return this;
                },
                /**
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * @method Phaser.GameObjects.RenderTexture#drawFrame
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - WebGL only. The tint color to use. If not specified it uses the `globalTint` property.
     *
     * @return {this} This Render Texture instance.
     */ drawFrame: function(key, frame, x, y, alpha, tint) {
                    this.beginDraw();
                    this.batchDrawFrame(key, frame, x, y, alpha, tint);
                    this.endDraw();
                    return this;
                },
                /**
     * Use this method if you need to batch draw a large number of Game Objects to
     * this Render Texture in a single go, or on a frequent basis.
     *
     * This method starts the beginning of a batched draw.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * @method Phaser.GameObjects.RenderTexture#beginDraw
     * @since 3.50.0
     *
     * @return {this} This Render Texture instance.
     */ beginDraw: function() {
                    var camera = this.camera;
                    var renderer = this.renderer;
                    var renderTarget = this.renderTarget;
                    camera.preRender();
                    if (renderTarget) renderer.beginCapture(renderTarget.width, renderTarget.height);
                    else renderer.setContext(this.context);
                    return this;
                },
                /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of objects to this Render Texture.
     *
     * This method batches the drawing of the given objects to this Render Texture,
     * without causing a bind or batch flush.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * Draws the given object, or an array of objects, to this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Render Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDraw
     * @since 3.50.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha] -  The alpha value. Only used for Texture Frames and if not specified defaults to the `globalAlpha` property. Game Objects use their own current alpha value.
     * @param {number} [tint] -  WebGL only. The tint color value. Only used for Texture Frames and if not specified defaults to the `globalTint` property. Game Objects use their own current tint value.
     *
     * @return {this} This Render Texture instance.
     */ batchDraw: function(entries, x, y, alpha, tint) {
                    if (alpha === undefined) alpha = this.globalAlpha;
                    if (tint === undefined) tint = (this.globalTint >> 16) + (this.globalTint & 0xff00) + ((this.globalTint & 0xff) << 16);
                    else tint = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16);
                    if (!Array.isArray(entries)) entries = [
                        entries
                    ];
                    this.batchList(entries, x, y, alpha, tint);
                    return this;
                },
                /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of texture frames to this Render Texture.
     *
     * This method batches the drawing of the given frames to this Render Texture,
     * without causing a bind or batch flush.
     *
     * It is faster than calling `drawFrame`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of frames it's much safer and easier to use the `drawFrame` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDrawFrame
     * @since 3.50.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - WebGL only. The tint color to use. If not specified it uses the `globalTint` property.
     *
     * @return {this} This Render Texture instance.
     */ batchDrawFrame: function(key, frame, x, y, alpha, tint) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (alpha === undefined) alpha = this.globalAlpha;
                    if (tint === undefined) tint = (this.globalTint >> 16) + (this.globalTint & 0xff00) + ((this.globalTint & 0xff) << 16);
                    else tint = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16);
                    var textureFrame = this.textureManager.getFrame(key, frame);
                    if (textureFrame) {
                        if (this.renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, this.camera.matrix, null);
                        else this.batchTextureFrame(textureFrame, x + this.frame.cutX, y + this.frame.cutY, alpha, tint);
                    }
                    return this;
                },
                /**
     * Use this method to finish batch drawing to this Render Texture.
     *
     * Never call this method without first calling `beginDraw`.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * @method Phaser.GameObjects.RenderTexture#endDraw
     * @since 3.50.0
     *
     * @param {boolean} [erase=false] - Draws all objects in this batch using a blend mode of ERASE. This has the effect of erasing any filled pixels in the objects being drawn.
     *
     * @return {this} This Render Texture instance.
     */ endDraw: function(erase) {
                    if (erase === undefined) erase = this._eraseMode;
                    var renderer = this.renderer;
                    var renderTarget = this.renderTarget;
                    if (renderTarget) {
                        var canvasTarget = renderer.endCapture();
                        var util = renderer.pipelines.setUtility();
                        util.blitFrame(canvasTarget, renderTarget, 1, false, false, erase);
                        renderer.resetScissor();
                        renderer.resetViewport();
                    } else renderer.setContext();
                    this.dirty = true;
                    return this;
                },
                /**
     * Internal method that handles the drawing of an array of children.
     *
     * @method Phaser.GameObjects.RenderTexture#batchList
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects to draw.
     * @param {number} [x] - The x position to offset the Game Object by.
     * @param {number} [y] - The y position to offset the Game Object by.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - The tint color to use. If not specified it uses the `globalTint` property.
     */ batchList: function(children, x, y, alpha, tint) {
                    for(var i = 0; i < children.length; i++){
                        var entry = children[i];
                        if (!entry || entry === this) continue;
                        if (entry.renderWebGL || entry.renderCanvas) //  Game Objects
                        this.drawGameObject(entry, x, y);
                        else if (entry.isParent || entry.list) //  Groups / Display Lists
                        this.batchGroup(entry.getChildren(), x, y);
                        else if (typeof entry === "string") //  Texture key
                        this.batchTextureFrameKey(entry, null, x, y, alpha, tint);
                        else if (entry instanceof Frame) //  Texture Frame instance
                        this.batchTextureFrame(entry, x, y, alpha, tint);
                        else if (Array.isArray(entry)) //  Another Array
                        this.batchList(entry, x, y, alpha, tint);
                    }
                },
                /**
     * Internal method that handles drawing a Phaser Group contents.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGroup
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects to draw.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     */ batchGroup: function(children, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    x += this.frame.cutX;
                    y += this.frame.cutY;
                    for(var i = 0; i < children.length; i++){
                        var entry = children[i];
                        if (entry.willRender(this.camera)) {
                            var tx = entry.x + x;
                            var ty = entry.y + y;
                            this.drawGameObject(entry, tx, ty);
                        }
                    }
                },
                /**
     * Internal method that handles drawing a single Phaser Game Object to this Render Texture using WebGL.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGameObjectWebGL
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to draw.
     * @param {number} [x] - The x position to draw the Game Object at.
     * @param {number} [y] - The y position to draw the Game Object at.
     */ batchGameObjectWebGL: function(gameObject, x, y) {
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    var prevX = gameObject.x;
                    var prevY = gameObject.y;
                    gameObject.setPosition(x + this.frame.cutX, y + this.frame.cutY);
                    if (gameObject.renderDirect) gameObject.renderDirect(this.renderer, gameObject, this.camera);
                    else gameObject.renderWebGL(this.renderer, gameObject, this.camera);
                    gameObject.setPosition(prevX, prevY);
                },
                /**
     * Internal method that handles drawing a single Phaser Game Object to this Render Texture using Canvas.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGameObjectCanvas
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to draw.
     * @param {number} [x] - The x position to draw the Game Object at.
     * @param {number} [y] - The y position to draw the Game Object at.
     */ batchGameObjectCanvas: function(gameObject, x, y) {
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    var prevX = gameObject.x;
                    var prevY = gameObject.y;
                    if (this._eraseMode) {
                        var blendMode = gameObject.blendMode;
                        gameObject.blendMode = BlendModes.ERASE;
                    }
                    gameObject.setPosition(x + this.frame.cutX, y + this.frame.cutY);
                    gameObject.renderCanvas(this.renderer, gameObject, this.camera, null);
                    gameObject.setPosition(prevX, prevY);
                    if (this._eraseMode) gameObject.blendMode = blendMode;
                },
                /**
     * Internal method that handles the drawing of an array of children.
     *
     * @method Phaser.GameObjects.RenderTexture#batchTextureFrameKey
     * @private
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - The tint color to use. If not specified it uses the `globalTint` property.
     */ batchTextureFrameKey: function(key, frame, x, y, alpha, tint) {
                    var textureFrame = this.textureManager.getFrame(key, frame);
                    if (textureFrame) this.batchTextureFrame(textureFrame, x, y, alpha, tint);
                },
                /**
     * Internal method that handles the drawing of a Texture Frame to this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#batchTextureFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} textureFrame - The Texture Frame to draw.
     * @param {number} [x=0] - The x position to draw the Frame at.
     * @param {number} [y=0] - The y position to draw the Frame at.
     * @param {number} [tint] - A tint color to be applied to the frame drawn to the Render Texture.
     */ batchTextureFrame: function(textureFrame, x, y, alpha, tint) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    x += this.frame.cutX;
                    y += this.frame.cutY;
                    var renderTarget = this.renderTarget;
                    if (renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, this.camera.matrix, null);
                    else {
                        var ctx = this.context;
                        var cd = textureFrame.canvasData;
                        var source = textureFrame.source.image;
                        var matrix = this.camera.matrix;
                        ctx.save();
                        ctx.globalCompositeOperation = this._eraseMode ? "destination-out" : "source-over";
                        ctx.globalAlpha = alpha;
                        matrix.setToContext(ctx);
                        ctx.drawImage(source, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                        ctx.restore();
                    }
                },
                /**
     * Takes a snapshot of the given area of this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture the whole Render Texture see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotArea
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, false, x, y, width, height, type, encoderOptions);
                    else this.renderer.snapshotCanvas(this.canvas, callback, false, x, y, width, height, type, encoderOptions);
                    return this;
                },
                /**
     * Takes a snapshot of the whole of this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture just a portion of the Render Texture see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshot
     * @since 3.19.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshot: function(callback, type, encoderOptions) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, false, 0, 0, this.width, this.height, type, encoderOptions);
                    else this.renderer.snapshotCanvas(this.canvas, callback, false, 0, 0, this.width, this.height, type, encoderOptions);
                    return this;
                },
                /**
     * Takes a snapshot of the given pixel from this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture the whole Render Texture see the `snapshot` method. To capture a specific portion, see `snapshotArea`.
     *
     * Unlike the other two snapshot methods, this one will send your callback a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory, than the other snapshot methods.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotPixel
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This Render Texture instance.
     */ snapshotPixel: function(x, y, callback) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, true, x, y);
                    else this.renderer.snapshotCanvas(this.canvas, callback, true, x, y);
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.RenderTexture#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    if (!this._saved) {
                        CanvasPool.remove(this.canvas);
                        if (this.renderTarget) this.renderTarget.destroy();
                        this.texture.destroy();
                        this.camera.destroy();
                        this.canvas = null;
                        this.context = null;
                        this.texture = null;
                    }
                }
            });
            module1.exports = RenderTexture;
        /***/ },
        /* 222 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates and returns an RFC4122 version 4 compliant UUID.
 * 
 * The string is in the form: `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx` where each `x` is replaced with a random
 * hexadecimal digit from 0 to f, and `y` is replaced with a random hexadecimal digit from 8 to b.
 *
 * @function Phaser.Utils.String.UUID
 * @since 3.12.0
 *
 * @return {string} The UUID string.
 */ var UUID = function() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0;
                    var v = c === "x" ? r : r & 0x3 | 0x8;
                    return v.toString(16);
                });
            };
            module1.exports = UUID;
        /***/ },
        /* 223 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(164);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var PIPELINE_CONST = __webpack_require__(92);
            var RopeRender = __webpack_require__(1085);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Rope Game Object.
 *
 * The Rope object is WebGL only and does not have a Canvas counterpart.
 *
 * A Rope is a special kind of Game Object that has a texture that repeats along its entire length.
 * Unlike a Sprite, it isn't restricted to using just a quad and can have as many vertices as you define
 * when creating it. The vertices can be arranged in a horizontal or vertical strip and have their own
 * color and alpha values as well.
 *
 * A Ropes origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Rope
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.23.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {string} [texture] - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager. If not given, `__DEFAULT` is used.
 * @param {(string|number|null)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created. See `setPoints` to set this post-creation.
 * @param {boolean} [horizontal=true] - Should the vertices of this Rope be aligned horizontally (`true`), or vertically (`false`)?
 * @param {number[]} [colors] - An optional array containing the color data for this Rope. You should provide one color value per pair of vertices.
 * @param {number[]} [alphas] - An optional array containing the alpha data for this Rope. You should provide one alpha value per pair of vertices.
 */ var Rope = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    RopeRender
                ],
                initialize: function Rope(scene, x, y, texture, frame, points, horizontal, colors, alphas) {
                    if (texture === undefined) texture = "__DEFAULT";
                    if (points === undefined) points = 2;
                    if (horizontal === undefined) horizontal = true;
                    GameObject.call(this, scene, "Rope");
                    /**
         * The Animation State of this Rope.
         *
         * @name Phaser.GameObjects.Rope#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.23.0
         */ this.anims = new AnimationState(this);
                    /**
         * An array containing the points data for this Rope.
         *
         * Each point should be given as a Vector2Like object (i.e. a Vector2, Geom.Point or object with public x/y properties).
         *
         * The point coordinates are given in local space, where 0 x 0 is the start of the Rope strip.
         *
         * You can modify the contents of this array directly in real-time to create interesting effects.
         * If you do so, be sure to call `setDirty` _after_ modifying this array, so that the vertices data is
         * updated before the next render. Alternatively, you can use the `setPoints` method instead.
         *
         * Should you need to change the _size_ of this array, then you should always use the `setPoints` method.
         *
         * @name Phaser.GameObjects.Rope#points
         * @type {Phaser.Types.Math.Vector2Like[]}
         * @since 3.23.0
         */ this.points = points;
                    /**
         * An array containing the vertices data for this Rope.
         *
         * This data is calculated automatically in the `updateVertices` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#vertices
         * @type {Float32Array}
         * @since 3.23.0
         */ this.vertices;
                    /**
         * An array containing the uv data for this Rope.
         *
         * This data is calculated automatically in the `setPoints` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#uv
         * @type {Float32Array}
         * @since 3.23.0
         */ this.uv;
                    /**
         * An array containing the color data for this Rope.
         *
         * Colors should be given as numeric RGB values, such as 0xff0000.
         * You should provide _two_ color values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setColors` method instead.
         *
         * @name Phaser.GameObjects.Rope#colors
         * @type {Uint32Array}
         * @since 3.23.0
         */ this.colors;
                    /**
         * An array containing the alpha data for this Rope.
         *
         * Alphas should be given as float values, such as 0.5.
         * You should provide _two_ alpha values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setAlphas` method instead.
         *
         * @name Phaser.GameObjects.Rope#alphas
         * @type {Float32Array}
         * @since 3.23.0
         */ this.alphas;
                    /**
         * The tint fill mode.
         *
        * `false` = An additive tint (the default), where vertices colors are blended with the texture.
        * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Rope#tintFill
         * @type {boolean}
         * @since 3.23.0
         */ this.tintFill = texture === "__DEFAULT" ? true : false;
                    /**
         * If the Rope is marked as `dirty` it will automatically recalculate its vertices
         * the next time it renders. You can also force this by calling `updateVertices`.
         *
         * @name Phaser.GameObjects.Rope#dirty
         * @type {boolean}
         * @since 3.23.0
         */ this.dirty = false;
                    /**
         * Are the Rope vertices aligned horizontally, in a strip, or vertically, in a column?
         *
         * This property is set during instantiation and cannot be changed directly.
         * See the `setVertical` and `setHorizontal` methods.
         *
         * @name Phaser.GameObjects.Rope#horizontal
         * @type {boolean}
         * @readonly
         * @since 3.23.0
         */ this.horizontal = horizontal;
                    /**
         * The horizontally flipped state of the Game Object.
         *
         * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipX
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipX = false;
                    /**
         * The vertically flipped state of the Game Object.
         *
         * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipY
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipY = false;
                    /**
         * Internal Vector2 used for vertices updates.
         *
         * @name Phaser.GameObjects.Rope#_perp
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.23.0
         */ this._perp = new Vector2();
                    /**
         * You can optionally choose to render the vertices of this Rope to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Rope.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Rope instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * @name Phaser.GameObjects.Rope#debugCallback
         * @type {function}
         * @since 3.23.0
         */ this.debugCallback = null;
                    /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Rope#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.23.0
         */ this.debugGraphic = null;
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.initPipeline(PIPELINE_CONST.ROPE_PIPELINE);
                    if (Array.isArray(points)) this.resizeArrays(points.length);
                    this.setPoints(points, colors, alphas);
                    this.updateVertices();
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * The Rope update loop.
     *
     * @method Phaser.GameObjects.Rope#preUpdate
     * @protected
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    var prevFrame = this.anims.currentFrame;
                    this.anims.update(time, delta);
                    if (this.anims.currentFrame !== prevFrame) {
                        this.updateUVs();
                        this.updateVertices();
                    }
                },
                /**
     * Start playing the given animation.
     *
     * @method Phaser.GameObjects.Rope#play
     * @since 3.23.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     * @param {number} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying, startFrame) {
                    this.anims.play(key, ignoreIfPlaying, startFrame);
                    return this;
                },
                /**
     * Flags this Rope as being dirty. A dirty rope will recalculate all of its vertices data
     * the _next_ time it renders. You should set this rope as dirty if you update the points
     * array directly.
     *
     * @method Phaser.GameObjects.Rope#setDirty
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ setDirty: function() {
                    this.dirty = true;
                    return this;
                },
                /**
     * Sets the alignment of the points in this Rope to be horizontal, in a strip format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setHorizontal
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setHorizontal: function(points, colors, alphas) {
                    if (points === undefined) points = this.points.length;
                    if (this.horizontal) return this;
                    this.horizontal = true;
                    return this.setPoints(points, colors, alphas);
                },
                /**
     * Sets the alignment of the points in this Rope to be vertical, in a column format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setVertical
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setVertical: function(points, colors, alphas) {
                    if (points === undefined) points = this.points.length;
                    if (!this.horizontal) return this;
                    this.horizontal = false;
                    return this.setPoints(points, colors, alphas);
                },
                /**
     * Sets the tint fill mode.
     *
     * Mode 0 (`false`) is an additive tint, the default, which blends the vertices colors with the texture.
     * This mode respects the texture alpha.
     *
     * Mode 1 (`true`) is a fill tint. Unlike an additive tint, a fill-tint literally replaces the pixel colors
     * from the texture with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. This mode respects the texture alpha.
     *
     * See the `setColors` method for details of how to color each of the vertices.
     *
     * @method Phaser.GameObjects.Rope#setTintFill
     * @webglOnly
     * @since 3.23.0
     *
     * @param {boolean} [value=false] - Set to `false` for an Additive tint or `true` fill tint with alpha.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(value) {
                    if (value === undefined) value = false;
                    this.tintFill = value;
                    return this;
                },
                /**
     * Set the alpha values used by the Rope during rendering.
     *
     * You can provide the values in a number of ways:
     *
     * 1) One single numeric value: `setAlphas(0.5)` - This will set a single alpha for the whole Rope.
     * 2) Two numeric value: `setAlphas(1, 0.5)` - This will set a 'top' and 'bottom' alpha value across the whole Rope.
     * 3) An array of values: `setAlphas([ 1, 0.5, 0.2 ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each alpha value per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the alpha values at all
     * vertices in the Rope.
     *
     * Note this method is called `setAlphas` (plural) and not `setAlpha`.
     *
     * @method Phaser.GameObjects.Rope#setAlphas
     * @since 3.23.0
     *
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values. If nothing is provided alpha is reset to 1.
     * @param {number} [bottomAlpha] - An optional bottom alpha value. See the method description for details.
     *
     * @return {this} This Game Object instance.
     */ setAlphas: function(alphas, bottomAlpha) {
                    var total = this.points.length;
                    if (total < 1) return this;
                    var currentAlphas = this.alphas;
                    if (alphas === undefined) alphas = [
                        1
                    ];
                    else if (!Array.isArray(alphas) && bottomAlpha === undefined) alphas = [
                        alphas
                    ];
                    var i;
                    var index = 0;
                    if (bottomAlpha !== undefined) //  Top / Bottom alpha pair
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentAlphas[index] = alphas;
                        currentAlphas[index + 1] = bottomAlpha;
                    }
                    else if (alphas.length === total) //  If there are exactly the same number of alphas as points, we'll combine the alphas
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentAlphas[index] = alphas[i];
                        currentAlphas[index + 1] = alphas[i];
                    }
                    else {
                        var prevAlpha = alphas[0];
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            if (alphas.length > index) prevAlpha = alphas[index];
                            currentAlphas[index] = prevAlpha;
                            if (alphas.length > index + 1) prevAlpha = alphas[index + 1];
                            currentAlphas[index + 1] = prevAlpha;
                        }
                    }
                    return this;
                },
                /**
     * Set the color values used by the Rope during rendering.
     *
     * Colors are used to control the level of tint applied across the Rope texture.
     *
     * You can provide the values in a number of ways:
     *
     * * One single numeric value: `setColors(0xff0000)` - This will set a single color tint for the whole Rope.
     * * An array of values: `setColors([ 0xff0000, 0x00ff00, 0x0000ff ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each color per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the color values at all
     * vertices in the Rope.
     *
     * @method Phaser.GameObjects.Rope#setColors
     * @since 3.23.0
     *
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values. If nothing is provided color is reset to 0xffffff.
     *
     * @return {this} This Game Object instance.
     */ setColors: function(colors) {
                    var total = this.points.length;
                    if (total < 1) return this;
                    var currentColors = this.colors;
                    if (colors === undefined) colors = [
                        0xffffff
                    ];
                    else if (!Array.isArray(colors)) colors = [
                        colors
                    ];
                    var i;
                    var index = 0;
                    if (colors.length === total) //  If there are exactly the same number of colors as points, we'll combine the colors
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentColors[index] = colors[i];
                        currentColors[index + 1] = colors[i];
                    }
                    else {
                        var prevColor = colors[0];
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            if (colors.length > index) prevColor = colors[index];
                            currentColors[index] = prevColor;
                            if (colors.length > index + 1) prevColor = colors[index + 1];
                            currentColors[index + 1] = prevColor;
                        }
                    }
                    return this;
                },
                /**
     * Sets the points used by this Rope.
     *
     * The points should be provided as an array of Vector2, or vector2-like objects (i.e. those with public x/y properties).
     *
     * Each point corresponds to one segment of the Rope. The more points in the array, the more segments the rope has.
     *
     * Point coordinates are given in local-space, not world-space, and are directly related to the size of the texture
     * this Rope object is using.
     *
     * For example, a Rope using a 512 px wide texture, split into 4 segments (128px each) would use the following points:
     *
     * ```javascript
     * rope.setPoints([
     *   { x: 0, y: 0 },
     *   { x: 128, y: 0 },
     *   { x: 256, y: 0 },
     *   { x: 384, y: 0 }
     * ]);
     * ```
     *
     * Or, you can provide an integer to do the same thing:
     *
     * ```javascript
     * rope.setPoints(4);
     * ```
     *
     * Which will divide the Rope into 4 equally sized segments based on the frame width.
     *
     * Note that calling this method with a different number of points than the Rope has currently will
     * _reset_ the color and alpha values, unless you provide them as arguments to this method.
     *
     * @method Phaser.GameObjects.Rope#setPoints
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(points, colors, alphas) {
                    if (points === undefined) points = 2;
                    if (typeof points === "number") {
                        //  Generate an array based on the points
                        var segments = points;
                        if (segments < 2) segments = 2;
                        points = [];
                        var s;
                        var frameSegment;
                        var offset;
                        if (this.horizontal) {
                            offset = -this.frame.halfWidth;
                            frameSegment = this.frame.width / (segments - 1);
                            for(s = 0; s < segments; s++)points.push({
                                x: offset + s * frameSegment,
                                y: 0
                            });
                        } else {
                            offset = -this.frame.halfHeight;
                            frameSegment = this.frame.height / (segments - 1);
                            for(s = 0; s < segments; s++)points.push({
                                x: 0,
                                y: offset + s * frameSegment
                            });
                        }
                    }
                    var total = points.length;
                    var currentTotal = this.points.length;
                    if (total < 1) {
                        console.warn("Rope: Not enough points given");
                        return this;
                    } else if (total === 1) {
                        points.unshift({
                            x: 0,
                            y: 0
                        });
                        total++;
                    }
                    if (currentTotal !== total) this.resizeArrays(total);
                    this.points = points;
                    this.updateUVs();
                    if (colors !== undefined && colors !== null) this.setColors(colors);
                    if (alphas !== undefined && alphas !== null) this.setAlphas(alphas);
                    return this;
                },
                /**
     * Updates all of the UVs based on the Rope.points and `flipX` and `flipY` settings.
     *
     * @method Phaser.GameObjects.Rope#updateUVs
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateUVs: function() {
                    var currentUVs = this.uv;
                    var total = this.points.length;
                    var u0 = this.frame.u0;
                    var v0 = this.frame.v0;
                    var u1 = this.frame.u1;
                    var v1 = this.frame.v1;
                    var partH = (u1 - u0) / (total - 1);
                    var partV = (v1 - v0) / (total - 1);
                    for(var i = 0; i < total; i++){
                        var index = i * 4;
                        var uv0;
                        var uv1;
                        var uv2;
                        var uv3;
                        if (this.horizontal) {
                            if (this._flipX) {
                                uv0 = u1 - i * partH;
                                uv2 = u1 - i * partH;
                            } else {
                                uv0 = u0 + i * partH;
                                uv2 = u0 + i * partH;
                            }
                            if (this._flipY) {
                                uv1 = v1;
                                uv3 = v0;
                            } else {
                                uv1 = v0;
                                uv3 = v1;
                            }
                        } else {
                            if (this._flipX) {
                                uv0 = u0;
                                uv2 = u1;
                            } else {
                                uv0 = u1;
                                uv2 = u0;
                            }
                            if (this._flipY) {
                                uv1 = v1 - i * partV;
                                uv3 = v1 - i * partV;
                            } else {
                                uv1 = v0 + i * partV;
                                uv3 = v0 + i * partV;
                            }
                        }
                        currentUVs[index + 0] = uv0;
                        currentUVs[index + 1] = uv1;
                        currentUVs[index + 2] = uv2;
                        currentUVs[index + 3] = uv3;
                    }
                    return this;
                },
                /**
     * Resizes all of the internal arrays: `vertices`, `uv`, `colors` and `alphas` to the new
     * given Rope segment total.
     *
     * @method Phaser.GameObjects.Rope#resizeArrays
     * @since 3.23.0
     *
     * @param {number} newSize - The amount of segments to split the Rope in to.
     *
     * @return {this} This Game Object instance.
     */ resizeArrays: function(newSize) {
                    var colors = this.colors;
                    var alphas = this.alphas;
                    this.vertices = new Float32Array(newSize * 4);
                    this.uv = new Float32Array(newSize * 4);
                    colors = new Uint32Array(newSize * 2);
                    alphas = new Float32Array(newSize * 2);
                    for(var i = 0; i < newSize * 2; i++){
                        colors[i] = 0xffffff;
                        alphas[i] = 1;
                    }
                    this.colors = colors;
                    this.alphas = alphas;
                    //  updateVertices during next render
                    this.dirty = true;
                    return this;
                },
                /**
     * Updates the vertices based on the Rope points.
     *
     * This method is called automatically during rendering if `Rope.dirty` is `true`, which is set
     * by the `setPoints` and `setDirty` methods. You should flag the Rope as being dirty if you modify
     * the Rope points directly.
     *
     * @method Phaser.GameObjects.Rope#updateVertices
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateVertices: function() {
                    var perp = this._perp;
                    var points = this.points;
                    var vertices = this.vertices;
                    var total = points.length;
                    this.dirty = false;
                    if (total < 1) return;
                    var nextPoint;
                    var lastPoint = points[0];
                    var frameSize = this.horizontal ? this.frame.halfHeight : this.frame.halfWidth;
                    for(var i = 0; i < total; i++){
                        var point = points[i];
                        var index = i * 4;
                        if (i < total - 1) nextPoint = points[i + 1];
                        else nextPoint = point;
                        perp.x = nextPoint.y - lastPoint.y;
                        perp.y = -(nextPoint.x - lastPoint.x);
                        var perpLength = perp.length();
                        perp.x /= perpLength;
                        perp.y /= perpLength;
                        perp.x *= frameSize;
                        perp.y *= frameSize;
                        vertices[index] = point.x + perp.x;
                        vertices[index + 1] = point.y + perp.y;
                        vertices[index + 2] = point.x - perp.x;
                        vertices[index + 3] = point.y - perp.y;
                        lastPoint = point;
                    }
                    return this;
                },
                /**
     * This method enables rendering of the Rope vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Rope objects to a single Graphics instance.
     *
     * The Rope class has a built-in debug rendering callback `Rope.renderDebugVerts`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, meshLength, verts)`
     *
     * `src` is the Rope instance being debugged.
     * `meshLength` is the number of mesh vertices in total.
     * `verts` is an array of the translated vertex coordinates.
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Rope#setDebug
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                    this.debugGraphic = graphic;
                    if (!graphic && !callback) this.debugCallback = null;
                    else if (!callback) this.debugCallback = this.renderDebugVerts;
                    else this.debugCallback = callback;
                    return this;
                },
                /**
     * The built-in Rope vertices debug rendering method.
     *
     * See `Rope.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Rope#renderDebugVerts
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Rope} src - The Rope object being rendered.
     * @param {number} meshLength - The number of vertices in the mesh.
     * @param {number[]} verts - An array of translated vertex coordinates.
     */ renderDebugVerts: function(src, meshLength, verts) {
                    var graphic = src.debugGraphic;
                    var px0 = verts[0];
                    var py0 = verts[1];
                    var px1 = verts[2];
                    var py1 = verts[3];
                    graphic.lineBetween(px0, py0, px1, py1);
                    for(var i = 4; i < meshLength; i += 4){
                        var x0 = verts[i + 0];
                        var y0 = verts[i + 1];
                        var x1 = verts[i + 2];
                        var y1 = verts[i + 3];
                        graphic.lineBetween(px0, py0, x0, y0);
                        graphic.lineBetween(px1, py1, x1, y1);
                        graphic.lineBetween(px1, py1, x0, y0);
                        graphic.lineBetween(x0, y0, x1, y1);
                        px0 = x0;
                        py0 = y0;
                        px1 = x1;
                        py1 = y1;
                    }
                },
                /**
     * Handles the pre-destroy step for the Rope, which removes the Animation component and typed arrays.
     *
     * @method Phaser.GameObjects.Rope#preDestroy
     * @private
     * @since 3.23.0
     */ preDestroy: function() {
                    this.anims.destroy();
                    this.anims = undefined;
                    this.points = null;
                    this.vertices = null;
                    this.uv = null;
                    this.colors = null;
                    this.alphas = null;
                    this.debugCallback = null;
                    this.debugGraphic = null;
                },
                /**
     * The horizontally flipped state of the Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipX
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipX: {
                    get: function() {
                        return this._flipX;
                    },
                    set: function(value) {
                        this._flipX = value;
                        return this.updateUVs();
                    }
                },
                /**
     * The vertically flipped state of the Game Object.
     *
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipY
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipY: {
                    get: function() {
                        return this._flipY;
                    },
                    set: function(value) {
                        this._flipY = value;
                        return this.updateUVs();
                    }
                }
            });
            module1.exports = Rope;
        /***/ },
        /* 224 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(142);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameEvents = __webpack_require__(22);
            var GameObject = __webpack_require__(15);
            var GetTextSize = __webpack_require__(458);
            var GetValue = __webpack_require__(6);
            var RemoveFromDOM = __webpack_require__(202);
            var TextRender = __webpack_require__(1088);
            var TextStyle = __webpack_require__(459);
            /**
 * @classdesc
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * **Important:** The font name must be quoted if it contains certain combinations of digits or
 * special characters, either when creating the Text object, or when setting the font via `setFont`
 * or `setFontFamily`, e.g.:
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif' });
 * ```
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { font: '"Press Start 2P"' });
 * ```
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do ths for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * @class Text
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The text style configuration object.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
 */ var Text = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    TextRender
                ],
                initialize: function Text(scene, x, y, text, style) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    GameObject.call(this, scene, "Text");
                    /**
         * The renderer in use by this Text object.
         *
         * @name Phaser.GameObjects.Text#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.12.0
         */ this.renderer = scene.sys.renderer;
                    this.setPosition(x, y);
                    this.setOrigin(0, 0);
                    this.initPipeline();
                    /**
         * The canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = CanvasPool.create(this);
                    /**
         * The context of the canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context = this.canvas.getContext("2d");
                    /**
         * The Text Style object.
         *
         * Manages the style of this Text object.
         *
         * @name Phaser.GameObjects.Text#style
         * @type {Phaser.GameObjects.TextStyle}
         * @since 3.0.0
         */ this.style = new TextStyle(this, style);
                    /**
         * Whether to automatically round line positions.
         *
         * @name Phaser.GameObjects.Text#autoRound
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.autoRound = true;
                    /**
         * The Regular Expression that is used to split the text up into lines, in
         * multi-line text. By default this is `/(?:\r\n|\r|\n)/`.
         * You can change this RegExp to be anything else that you may need.
         *
         * @name Phaser.GameObjects.Text#splitRegExp
         * @type {object}
         * @since 3.0.0
         */ this.splitRegExp = /(?:\r\n|\r|\n)/;
                    /**
         * The text to display.
         *
         * @name Phaser.GameObjects.Text#_text
         * @type {string}
         * @private
         * @since 3.12.0
         */ this._text = undefined;
                    /**
         * Specify a padding value which is added to the line width and height when calculating the Text size.
         * Allows you to add extra spacing if the browser is unable to accurately determine the true font dimensions.
         *
         * @name Phaser.GameObjects.Text#padding
         * @type {Phaser.Types.GameObjects.Text.TextPadding}
         * @since 3.0.0
         */ this.padding = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    };
                    /**
         * The width of this Text object.
         *
         * @name Phaser.GameObjects.Text#width
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.width = 1;
                    /**
         * The height of this Text object.
         *
         * @name Phaser.GameObjects.Text#height
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.height = 1;
                    /**
         * The line spacing value.
         * This value is added to the font height to calculate the overall line height.
         * Only has an effect if this Text object contains multiple lines of text.
         *
         * If you update this property directly, instead of using the `setLineSpacing` method, then
         * be sure to call `updateText` after, or you won't see the change reflected in the Text object.
         *
         * @name Phaser.GameObjects.Text#lineSpacing
         * @type {number}
         * @since 3.13.0
         */ this.lineSpacing = 0;
                    /**
         * Whether the text or its settings have changed and need updating.
         *
         * @name Phaser.GameObjects.Text#dirty
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.dirty = false;
                    //  If resolution wasn't set, force it to 1
                    if (this.style.resolution === 0) this.style.resolution = 1;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Text#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    //  Create a Texture for this Text object
                    this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
                    //  Get the frame
                    this.frame = this.texture.get();
                    //  Set the resolution
                    this.frame.source.resolution = this.style.resolution;
                    if (this.renderer && this.renderer.gl) {
                        //  Clear the default 1x1 glTexture, as we override it later
                        this.renderer.deleteTexture(this.frame.source.glTexture);
                        this.frame.source.glTexture = null;
                    }
                    this.initRTL();
                    this.setText(text);
                    if (style && style.padding) this.setPadding(style.padding);
                    if (style && style.lineSpacing) this.setLineSpacing(style.lineSpacing);
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, function() {
                        this.dirty = true;
                    }, this);
                },
                /**
     * Initialize right to left text.
     *
     * @method Phaser.GameObjects.Text#initRTL
     * @since 3.0.0
     */ initRTL: function() {
                    if (!this.style.rtl) return;
                    //  Here is where the crazy starts.
                    //
                    //  Due to browser implementation issues, you cannot fillText BiDi text to a canvas
                    //  that is not part of the DOM. It just completely ignores the direction property.
                    this.canvas.dir = "rtl";
                    //  Experimental atm, but one day ...
                    this.context.direction = "rtl";
                    //  Add it to the DOM, but hidden within the parent canvas.
                    this.canvas.style.display = "none";
                    AddToDOM(this.canvas, this.scene.sys.canvas);
                    //  And finally we set the x origin
                    this.originX = 1;
                },
                /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds.
     *
     * @method Phaser.GameObjects.Text#runWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     *
     * @return {string} The text after wrapping has been applied.
     */ runWordWrap: function(text) {
                    var style = this.style;
                    if (style.wordWrapCallback) {
                        var wrappedLines = style.wordWrapCallback.call(style.wordWrapCallbackScope, text, this);
                        if (Array.isArray(wrappedLines)) wrappedLines = wrappedLines.join("\n");
                        return wrappedLines;
                    } else if (style.wordWrapWidth) {
                        if (style.wordWrapUseAdvanced) return this.advancedWordWrap(text, this.context, this.style.wordWrapWidth);
                        else return this.basicWordWrap(text, this.context, this.style.wordWrapWidth);
                    } else return text;
                },
                /**
     * Advanced wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Consecutive spaces will be collapsed and replaced with a single space. Lines will be
     * trimmed of white space before processing. Throws an error if wordWrapWidth is less than a
     * single character.
     *
     * @method Phaser.GameObjects.Text#advancedWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ advancedWordWrap: function(text, context, wordWrapWidth) {
                    var output = "";
                    // Condense consecutive spaces and split into lines
                    var lines = text.replace(/ +/gi, " ").split(this.splitRegExp);
                    var linesCount = lines.length;
                    for(var i = 0; i < linesCount; i++){
                        var line = lines[i];
                        var out = "";
                        // Trim whitespace
                        line = line.replace(/^ *|\s*$/gi, "");
                        // If entire line is less than wordWrapWidth append the entire line and exit early
                        var lineWidth = context.measureText(line).width;
                        if (lineWidth < wordWrapWidth) {
                            output += line + "\n";
                            continue;
                        }
                        // Otherwise, calculate new lines
                        var currentLineWidth = wordWrapWidth;
                        // Split into words
                        var words = line.split(" ");
                        for(var j = 0; j < words.length; j++){
                            var word = words[j];
                            var wordWithSpace = word + " ";
                            var wordWidth = context.measureText(wordWithSpace).width;
                            if (wordWidth > currentLineWidth) {
                                // Break word
                                if (j === 0) {
                                    // Shave off letters from word until it's small enough
                                    var newWord = wordWithSpace;
                                    while(newWord.length){
                                        newWord = newWord.slice(0, -1);
                                        wordWidth = context.measureText(newWord).width;
                                        if (wordWidth <= currentLineWidth) break;
                                    }
                                    // If wordWrapWidth is too small for even a single letter, shame user
                                    // failure with a fatal error
                                    if (!newWord.length) throw new Error("This text's wordWrapWidth setting is less than a single character!");
                                    // Replace current word in array with remainder
                                    var secondPart = word.substr(newWord.length);
                                    words[j] = secondPart;
                                    // Append first piece to output
                                    out += newWord;
                                }
                                // If existing word length is 0, don't include it
                                var offset = words[j].length ? j : j + 1;
                                // Collapse rest of sentence and remove any trailing white space
                                var remainder = words.slice(offset).join(" ").replace(/[ \n]*$/gi, "");
                                // Prepend remainder to next line
                                lines[i + 1] = remainder + " " + (lines[i + 1] || "");
                                linesCount = lines.length;
                                break; // Processing on this line
                            // Append word with space to output
                            } else {
                                out += wordWithSpace;
                                currentLineWidth -= wordWidth;
                            }
                        }
                        // Append processed line to output
                        output += out.replace(/[ \n]*$/gi, "") + "\n";
                    }
                    // Trim the end of the string
                    output = output.replace(/[\s|\n]*$/gi, "");
                    return output;
                },
                /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Spaces are not collapsed and whitespace is not trimmed.
     *
     * @method Phaser.GameObjects.Text#basicWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ basicWordWrap: function(text, context, wordWrapWidth) {
                    var result = "";
                    var lines = text.split(this.splitRegExp);
                    var lastLineIndex = lines.length - 1;
                    var whiteSpaceWidth = context.measureText(" ").width;
                    for(var i = 0; i <= lastLineIndex; i++){
                        var spaceLeft = wordWrapWidth;
                        var words = lines[i].split(" ");
                        var lastWordIndex = words.length - 1;
                        for(var j = 0; j <= lastWordIndex; j++){
                            var word = words[j];
                            var wordWidth = context.measureText(word).width;
                            var wordWidthWithSpace = wordWidth;
                            if (j < lastWordIndex) wordWidthWithSpace += whiteSpaceWidth;
                            if (wordWidthWithSpace > spaceLeft) // Skip printing the newline if it's the first word of the line that is greater
                            // than the word wrap width.
                            {
                                if (j > 0) {
                                    result += "\n";
                                    spaceLeft = wordWrapWidth;
                                }
                            }
                            result += word;
                            if (j < lastWordIndex) {
                                result += " ";
                                spaceLeft -= wordWidthWithSpace;
                            } else spaceLeft -= wordWidth;
                        }
                        if (i < lastLineIndex) result += "\n";
                    }
                    return result;
                },
                /**
     * Runs the given text through this Text objects word wrapping and returns the results as an
     * array, where each element of the array corresponds to a wrapped line of text.
     *
     * @method Phaser.GameObjects.Text#getWrappedText
     * @since 3.0.0
     *
     * @param {string} text - The text for which the wrapping will be calculated. If unspecified, the Text objects current text will be used.
     *
     * @return {string[]} An array of strings with the pieces of wrapped text.
     */ getWrappedText: function(text) {
                    if (text === undefined) text = this._text;
                    this.style.syncFont(this.canvas, this.context);
                    var wrappedLines = this.runWordWrap(text);
                    return wrappedLines.split(this.splitRegExp);
                },
                /**
     * Set the text to display.
     *
     * An array of strings will be joined with `\n` line breaks.
     *
     * @method Phaser.GameObjects.Text#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this Text object.
     *
     * @return {this} This Text object.
     */ setText: function(value) {
                    if (!value && value !== 0) value = "";
                    if (Array.isArray(value)) value = value.join("\n");
                    if (value !== this._text) {
                        this._text = value.toString();
                        this.updateText();
                    }
                    return this;
                },
                /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.Text#setStyle
     * @since 3.0.0
     *
     * @param {object} style - The style settings to set.
     *
     * @return {this} This Text object.
     */ setStyle: function(style) {
                    return this.style.setStyle(style);
                },
                /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFont
     * @since 3.0.0
     *
     * @param {string} font - The font family or font settings to set.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFont: function(font) {
                    return this.style.setFont(font);
                },
                /**
     * Set the font family.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFontFamily: function(family) {
                    return this.style.setFontFamily(family);
                },
                /**
     * Set the font size.
     *
     * @method Phaser.GameObjects.Text#setFontSize
     * @since 3.0.0
     *
     * @param {number} size - The font size.
     *
     * @return {this} This Text object.
     */ setFontSize: function(size) {
                    return this.style.setFontSize(size);
                },
                /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.Text#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {this} This Text object.
     */ setFontStyle: function(style) {
                    return this.style.setFontStyle(style);
                },
                /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.Text#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set. `0` disables fixed width.
     * @param {number} height - The fixed height to set. `0` disables fixed height.
     *
     * @return {this} This Text object.
     */ setFixedSize: function(width, height) {
                    return this.style.setFixedSize(width, height);
                },
                /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.Text#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {this} This Text object.
     */ setBackgroundColor: function(color) {
                    return this.style.setBackgroundColor(color);
                },
                /**
     * Set the fill style to be used by the Text object.
     *
     * This can be any valid CanvasRenderingContext2D fillStyle value, such as
     * a color (in hex, rgb, rgba, hsl or named values), a gradient or a pattern.
     *
     * See the [MDN fillStyle docs](https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle) for more details.
     *
     * @method Phaser.GameObjects.Text#setFill
     * @since 3.0.0
     *
     * @param {(string|any)} color - The text fill style. Can be any valid CanvasRenderingContext `fillStyle` value.
     *
     * @return {this} This Text object.
     */ setFill: function(fillStyle) {
                    return this.style.setFill(fillStyle);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.Text#setColor
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {this} This Text object.
     */ setColor: function(color) {
                    return this.style.setColor(color);
                },
                /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.Text#setStroke
     * @since 3.0.0
     *
     * @param {string} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {this} This Text object.
     */ setStroke: function(color, thickness) {
                    return this.style.setStroke(color, thickness);
                },
                /**
     * Set the shadow settings.
     *
     * @method Phaser.GameObjects.Text#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {this} This Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                    return this.style.setShadow(x, y, color, blur, shadowStroke, shadowFill);
                },
                /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.Text#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal shadow offset.
     * @param {number} y - The vertical shadow offset.
     *
     * @return {this} This Text object.
     */ setShadowOffset: function(x, y) {
                    return this.style.setShadowOffset(x, y);
                },
                /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.Text#setShadowColor
     * @since 3.0.0
     *
     * @param {string} color - The shadow color.
     *
     * @return {this} This Text object.
     */ setShadowColor: function(color) {
                    return this.style.setShadowColor(color);
                },
                /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.Text#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} blur - The shadow blur radius.
     *
     * @return {this} This Text object.
     */ setShadowBlur: function(blur) {
                    return this.style.setShadowBlur(blur);
                },
                /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.Text#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowStroke: function(enabled) {
                    return this.style.setShadowStroke(enabled);
                },
                /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.Text#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowFill: function(enabled) {
                    return this.style.setShadowFill(enabled);
                },
                /**
     * Set the width (in pixels) to use for wrapping lines. Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.Text#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {?number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {this} This Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                    return this.style.setWordWrapWidth(width, useAdvancedWrap);
                },
                /**
     * Set a custom callback for wrapping lines. Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.Text#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {this} This Text object.
     */ setWordWrapCallback: function(callback, scope) {
                    return this.style.setWordWrapCallback(callback, scope);
                },
                /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.Text#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {this} This Text object.
     */ setAlign: function(align) {
                    return this.style.setAlign(align);
                },
                /**
     * Set the resolution used by this Text object.
     *
     * By default it will be set to match the resolution set in the Game Config,
     * but you can override it via this method, or by specifying it in the Text style configuration object.
     *
     * It allows for much clearer text on High DPI devices, at the cost of memory because it uses larger
     * internal Canvas textures for the Text.
     *
     * Therefore, please use with caution, as the more high res Text you have, the more memory it uses.
     *
     * @method Phaser.GameObjects.Text#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {this} This Text object.
     */ setResolution: function(value) {
                    return this.style.setResolution(value);
                },
                /**
     * Sets the line spacing value.
     *
     * This value is _added_ to the height of the font when calculating the overall line height.
     * This only has an effect if this Text object consists of multiple lines of text.
     *
     * @method Phaser.GameObjects.Text#setLineSpacing
     * @since 3.13.0
     *
     * @param {number} value - The amount to add to the font height to achieve the overall line height.
     *
     * @return {this} This Text object.
     */ setLineSpacing: function(value) {
                    this.lineSpacing = value;
                    return this.updateText();
                },
                /**
     * Set the text padding.
     *
     * 'left' can be an object.
     *
     * If only 'left' and 'top' are given they are treated as 'x' and 'y'.
     *
     * @method Phaser.GameObjects.Text#setPadding
     * @since 3.0.0
     *
     * @param {(number|Phaser.Types.GameObjects.Text.TextPadding)} left - The left padding value, or a padding config object.
     * @param {number} [top] - The top padding value.
     * @param {number} [right] - The right padding value.
     * @param {number} [bottom] - The bottom padding value.
     *
     * @return {this} This Text object.
     */ setPadding: function(left, top, right, bottom) {
                    if (typeof left === "object") {
                        var config = left;
                        //  If they specify x and/or y this applies to all
                        var x = GetValue(config, "x", null);
                        if (x !== null) {
                            left = x;
                            right = x;
                        } else {
                            left = GetValue(config, "left", 0);
                            right = GetValue(config, "right", left);
                        }
                        var y = GetValue(config, "y", null);
                        if (y !== null) {
                            top = y;
                            bottom = y;
                        } else {
                            top = GetValue(config, "top", 0);
                            bottom = GetValue(config, "bottom", top);
                        }
                    } else {
                        if (left === undefined) left = 0;
                        if (top === undefined) top = left;
                        if (right === undefined) right = left;
                        if (bottom === undefined) bottom = top;
                    }
                    this.padding.left = left;
                    this.padding.top = top;
                    this.padding.right = right;
                    this.padding.bottom = bottom;
                    return this.updateText();
                },
                /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.Text#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {this} This Text object.
     */ setMaxLines: function(max) {
                    return this.style.setMaxLines(max);
                },
                /**
     * Update the displayed text.
     *
     * @method Phaser.GameObjects.Text#updateText
     * @since 3.0.0
     *
     * @return {this} This Text object.
     */ updateText: function() {
                    var canvas = this.canvas;
                    var context = this.context;
                    var style = this.style;
                    var resolution = style.resolution;
                    var size = style.metrics;
                    style.syncFont(canvas, context);
                    var outputText = this._text;
                    if (style.wordWrapWidth || style.wordWrapCallback) outputText = this.runWordWrap(this._text);
                    //  Split text into lines
                    var lines = outputText.split(this.splitRegExp);
                    var textSize = GetTextSize(this, size, lines);
                    var padding = this.padding;
                    var textWidth;
                    if (style.fixedWidth === 0) {
                        this.width = textSize.width + padding.left + padding.right;
                        textWidth = textSize.width;
                    } else {
                        this.width = style.fixedWidth;
                        textWidth = this.width - padding.left - padding.right;
                        if (textWidth < textSize.width) textWidth = textSize.width;
                    }
                    if (style.fixedHeight === 0) this.height = textSize.height + padding.top + padding.bottom;
                    else this.height = style.fixedHeight;
                    var w = this.width;
                    var h = this.height;
                    this.updateDisplayOrigin();
                    w *= resolution;
                    h *= resolution;
                    w = Math.max(w, 1);
                    h = Math.max(h, 1);
                    if (canvas.width !== w || canvas.height !== h) {
                        canvas.width = w;
                        canvas.height = h;
                        this.frame.setSize(w, h);
                        //  Because resizing the canvas resets the context
                        style.syncFont(canvas, context);
                    } else context.clearRect(0, 0, w, h);
                    context.save();
                    context.scale(resolution, resolution);
                    if (style.backgroundColor) {
                        context.fillStyle = style.backgroundColor;
                        context.fillRect(0, 0, w, h);
                    }
                    style.syncStyle(canvas, context);
                    context.textBaseline = "alphabetic";
                    //  Apply padding
                    context.translate(padding.left, padding.top);
                    var linePositionX;
                    var linePositionY;
                    //  Draw text line by line
                    for(var i = 0; i < textSize.lines; i++){
                        linePositionX = style.strokeThickness / 2;
                        linePositionY = style.strokeThickness / 2 + i * textSize.lineHeight + size.ascent;
                        if (i > 0) linePositionY += textSize.lineSpacing * i;
                        if (style.rtl) linePositionX = w - linePositionX;
                        else if (style.align === "right") linePositionX += textWidth - textSize.lineWidths[i];
                        else if (style.align === "center") linePositionX += (textWidth - textSize.lineWidths[i]) / 2;
                        else if (style.align === "justify") {
                            //  To justify text line its width must be no less than 85% of defined width
                            var minimumLengthToApplyJustification = 0.85;
                            if (textSize.lineWidths[i] / textSize.width >= minimumLengthToApplyJustification) {
                                var extraSpace = textSize.width - textSize.lineWidths[i];
                                var spaceSize = context.measureText(" ").width;
                                var trimmedLine = lines[i].trim();
                                var array = trimmedLine.split(" ");
                                extraSpace += (lines[i].length - trimmedLine.length) * spaceSize;
                                var extraSpaceCharacters = Math.floor(extraSpace / spaceSize);
                                var idx = 0;
                                while(extraSpaceCharacters > 0){
                                    array[idx] += " ";
                                    idx = (idx + 1) % (array.length - 1 || 1);
                                    --extraSpaceCharacters;
                                }
                                lines[i] = array.join(" ");
                            }
                        }
                        if (this.autoRound) {
                            linePositionX = Math.round(linePositionX);
                            linePositionY = Math.round(linePositionY);
                        }
                        if (style.strokeThickness) {
                            this.style.syncShadow(context, style.shadowStroke);
                            context.strokeText(lines[i], linePositionX, linePositionY);
                        }
                        if (style.color) {
                            this.style.syncShadow(context, style.shadowFill);
                            context.fillText(lines[i], linePositionX, linePositionY);
                        }
                    }
                    context.restore();
                    if (this.renderer && this.renderer.gl) {
                        this.frame.source.glTexture = this.renderer.canvasToTexture(canvas, this.frame.source.glTexture, true);
                        this.frame.glTexture = this.frame.source.glTexture;
                    }
                    this.dirty = true;
                    var input = this.input;
                    if (input && !input.customHitArea) {
                        input.hitArea.width = this.width;
                        input.hitArea.height = this.height;
                    }
                    return this;
                },
                /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.Text#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                    return this.style.getTextMetrics();
                },
                /**
     * The text string being rendered by this Text Game Object.
     *
     * @name Phaser.GameObjects.Text#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                    get: function() {
                        return this._text;
                    },
                    set: function(value) {
                        this.setText(value);
                    }
                },
                /**
     * Build a JSON representation of the Text object.
     *
     * @method Phaser.GameObjects.Text#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Text object.
     */ toJSON: function() {
                    var out = Components.ToJSON(this);
                    //  Extra Text data is added here
                    var data = {
                        autoRound: this.autoRound,
                        text: this._text,
                        style: this.style.toJSON(),
                        padding: {
                            left: this.padding.left,
                            right: this.padding.right,
                            top: this.padding.top,
                            bottom: this.padding.bottom
                        }
                    };
                    out.data = data;
                    return out;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Text#preDestroy
     * @protected
     * @since 3.0.0
     */ preDestroy: function() {
                    if (this.style.rtl) RemoveFromDOM(this.canvas);
                    CanvasPool.remove(this.canvas);
                    this.texture.destroy();
                }
            });
            module1.exports = Text;
        /***/ },
        /* 225 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameEvents = __webpack_require__(22);
            var GameObject = __webpack_require__(15);
            var GetPowerOfTwo = __webpack_require__(361);
            var Smoothing = __webpack_require__(192);
            var TileSpriteRender = __webpack_require__(1091);
            var Vector2 = __webpack_require__(3);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * @classdesc
 * A TileSprite is a Sprite that has a repeating texture.
 *
 * The texture can be scrolled and scaled independently of the TileSprite itself. Textures will automatically wrap and
 * are designed so that you can create game backdrops using seamless textures as a source.
 *
 * You shouldn't ever create a TileSprite any larger than your actual canvas size. If you want to create a large repeating background
 * that scrolls across the whole map of your game, then you create a TileSprite that fits the canvas size and then use the `tilePosition`
 * property to scroll the texture as the player moves. If you create a TileSprite that is thousands of pixels in size then it will
 * consume huge amounts of memory and cause performance issues. Remember: use `tilePosition` to scroll your texture and `tileScale` to
 * adjust the scale of the texture - don't resize the sprite itself or make it larger than it needs.
 *
 * An important note about Tile Sprites and NPOT textures: Internally, TileSprite textures use GL_REPEAT to provide
 * seamless repeating of the textures. This, combined with the way in which the textures are handled in WebGL, means
 * they need to be POT (power-of-two) sizes in order to wrap. If you provide a NPOT (non power-of-two) texture to a
 * TileSprite it will generate a POT sized canvas and draw your texture to it, scaled up to the POT size. It's then
 * scaled back down again during rendering to the original dimensions. While this works, in that it allows you to use
 * any size texture for a Tile Sprite, it does mean that NPOT textures are going to appear anti-aliased when rendered,
 * due to the interpolation that took place when it was resized into a POT texture. This is especially visible in
 * pixel art graphics. If you notice it and it becomes an issue, the only way to avoid it is to ensure that you
 * provide POT textures for Tile Sprites.
 *
 * @class TileSprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {string} textureKey - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frameKey] - An optional frame from the Texture this Game Object is rendering with.
 */ var TileSprite = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    TileSpriteRender
                ],
                initialize: function TileSprite(scene, x, y, width, height, textureKey, frameKey) {
                    var renderer = scene.sys.renderer;
                    GameObject.call(this, scene, "TileSprite");
                    var displayTexture = scene.sys.textures.get(textureKey);
                    var displayFrame = displayTexture.get(frameKey);
                    if (!width || !height) {
                        width = displayFrame.width;
                        height = displayFrame.height;
                    } else {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    /**
         * Internal tile position vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tilePosition
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tilePosition = new Vector2();
                    /**
         * Internal tile scale vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tileScale
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tileScale = new Vector2(1, 1);
                    /**
         * Whether the Tile Sprite has changed in some way, requiring an re-render of its tile texture.
         *
         * Such changes include the texture frame and scroll position of the Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#dirty
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.dirty = false;
                    /**
         * The renderer in use by this Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = renderer;
                    /**
         * The Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#canvas
         * @type {?HTMLCanvasElement}
         * @since 3.12.0
         */ this.canvas = CanvasPool.create(this, width, height);
                    /**
         * The Context of the Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#context
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.context = this.canvas.getContext("2d");
                    /**
         * The Texture the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayTexture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @private
         * @since 3.12.0
         */ this.displayTexture = displayTexture;
                    /**
         * The Frame the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.12.0
         */ this.displayFrame = displayFrame;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.TileSprite#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Texture this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#texture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @since 3.0.0
         */ this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
                    /**
         * The Texture Frame this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = this.texture.get();
                    /**
         * The next power of two value from the width of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potWidth
         * @type {number}
         * @since 3.0.0
         */ this.potWidth = GetPowerOfTwo(displayFrame.width);
                    /**
         * The next power of two value from the height of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potHeight
         * @type {number}
         * @since 3.0.0
         */ this.potHeight = GetPowerOfTwo(displayFrame.height);
                    /**
         * The Canvas that the TileSprites texture is rendered to.
         * This is used to create a WebGL texture from.
         *
         * @name Phaser.GameObjects.TileSprite#fillCanvas
         * @type {HTMLCanvasElement}
         * @since 3.12.0
         */ this.fillCanvas = CanvasPool.create2D(this, this.potWidth, this.potHeight);
                    /**
         * The Canvas Context used to render the TileSprites texture.
         *
         * @name Phaser.GameObjects.TileSprite#fillContext
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.fillContext = this.fillCanvas.getContext("2d");
                    /**
         * The texture that the Tile Sprite is rendered to, which is then rendered to a Scene.
         * In WebGL this is a WebGLTexture. In Canvas it's a Canvas Fill Pattern.
         *
         * @name Phaser.GameObjects.TileSprite#fillPattern
         * @type {?(WebGLTexture|CanvasPattern)}
         * @since 3.12.0
         */ this.fillPattern = null;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setFrame(frameKey);
                    this.setOriginFromFrame();
                    this.initPipeline();
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, function(renderer) {
                        if (!renderer) return;
                        var gl = renderer.gl;
                        this.dirty = true;
                        this.fillPattern = null;
                        this.fillPattern = renderer.createTexture2D(0, gl.LINEAR, gl.LINEAR, gl.REPEAT, gl.REPEAT, gl.RGBA, this.fillCanvas, this.potWidth, this.potHeight);
                    }, this);
                },
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.TileSprite#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.displayTexture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * @method Phaser.GameObjects.TileSprite#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame) {
                    var newFrame = this.displayTexture.get(frame);
                    this.potWidth = GetPowerOfTwo(newFrame.width);
                    this.potHeight = GetPowerOfTwo(newFrame.height);
                    //  So updateCanvas is triggered
                    this.canvas.width = 0;
                    if (!newFrame.cutWidth || !newFrame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    this.displayFrame = newFrame;
                    this.dirty = true;
                    this.updateTileTexture();
                    return this;
                },
                /**
     * Sets {@link Phaser.GameObjects.TileSprite#tilePositionX} and {@link Phaser.GameObjects.TileSprite#tilePositionY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTilePosition
     * @since 3.3.0
     *
     * @param {number} [x] - The x position of this sprite's tiling texture.
     * @param {number} [y] - The y position of this sprite's tiling texture.
     *
     * @return {this} This Tile Sprite instance.
     */ setTilePosition: function(x, y) {
                    if (x !== undefined) this.tilePositionX = x;
                    if (y !== undefined) this.tilePositionY = y;
                    return this;
                },
                /**
     * Sets {@link Phaser.GameObjects.TileSprite#tileScaleX} and {@link Phaser.GameObjects.TileSprite#tileScaleY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTileScale
     * @since 3.12.0
     *
     * @param {number} [x] - The horizontal scale of the tiling texture. If not given it will use the current `tileScaleX` value.
     * @param {number} [y=x] - The vertical scale of the tiling texture. If not given it will use the `x` value.
     *
     * @return {this} This Tile Sprite instance.
     */ setTileScale: function(x, y) {
                    if (x === undefined) x = this.tileScaleX;
                    if (y === undefined) y = x;
                    this.tileScaleX = x;
                    this.tileScaleY = y;
                    return this;
                },
                /**
     * Render the tile texture if it is dirty, or if the frame has changed.
     *
     * @method Phaser.GameObjects.TileSprite#updateTileTexture
     * @private
     * @since 3.0.0
     */ updateTileTexture: function() {
                    if (!this.dirty || !this.renderer) return;
                    //  Draw the displayTexture to our fillCanvas
                    var frame = this.displayFrame;
                    if (frame.source.isRenderTexture || frame.source.isGLTexture) {
                        console.warn("TileSprites can only use Image or Canvas based textures");
                        this.dirty = false;
                        return;
                    }
                    var ctx = this.fillContext;
                    var canvas = this.fillCanvas;
                    var fw = this.potWidth;
                    var fh = this.potHeight;
                    if (!this.renderer || !this.renderer.gl) {
                        fw = frame.cutWidth;
                        fh = frame.cutHeight;
                    }
                    ctx.clearRect(0, 0, fw, fh);
                    canvas.width = fw;
                    canvas.height = fh;
                    ctx.drawImage(frame.source.image, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, 0, 0, fw, fh);
                    if (this.renderer && this.renderer.gl) this.fillPattern = this.renderer.canvasToTexture(canvas, this.fillPattern);
                    else this.fillPattern = ctx.createPattern(canvas, "repeat");
                    this.updateCanvas();
                    this.dirty = false;
                },
                /**
     * Draw the fill pattern to the internal canvas.
     *
     * @method Phaser.GameObjects.TileSprite#updateCanvas
     * @private
     * @since 3.12.0
     */ updateCanvas: function() {
                    var canvas = this.canvas;
                    if (canvas.width !== this.width || canvas.height !== this.height) {
                        canvas.width = this.width;
                        canvas.height = this.height;
                        this.frame.setSize(this.width, this.height);
                        this.updateDisplayOrigin();
                        this.dirty = true;
                    }
                    if (!this.dirty || this.renderer && this.renderer.gl) {
                        this.dirty = false;
                        return;
                    }
                    var ctx = this.context;
                    if (!this.scene.sys.game.config.antialias) Smoothing.disable(ctx);
                    var scaleX = this._tileScale.x;
                    var scaleY = this._tileScale.y;
                    var positionX = this._tilePosition.x;
                    var positionY = this._tilePosition.y;
                    ctx.clearRect(0, 0, this.width, this.height);
                    ctx.save();
                    ctx.scale(scaleX, scaleY);
                    ctx.translate(-positionX, -positionY);
                    ctx.fillStyle = this.fillPattern;
                    ctx.fillRect(positionX, positionY, this.width / scaleX, this.height / scaleY);
                    ctx.restore();
                    this.dirty = false;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.TileSprite#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    if (this.renderer && this.renderer.gl) this.renderer.deleteTexture(this.fillPattern);
                    CanvasPool.remove(this.canvas);
                    CanvasPool.remove(this.fillCanvas);
                    this.fillPattern = null;
                    this.fillContext = null;
                    this.fillCanvas = null;
                    this.displayTexture = null;
                    this.displayFrame = null;
                    this.texture.destroy();
                    this.renderer = null;
                },
                /**
     * The horizontal scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionX: {
                    get: function() {
                        return this._tilePosition.x;
                    },
                    set: function(value) {
                        this._tilePosition.x = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionY: {
                    get: function() {
                        return this._tilePosition.y;
                    },
                    set: function(value) {
                        this._tilePosition.y = value;
                        this.dirty = true;
                    }
                },
                /**
     * The horizontal scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleX
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleX: {
                    get: function() {
                        return this._tileScale.x;
                    },
                    set: function(value) {
                        this._tileScale.x = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleY
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleY: {
                    get: function() {
                        return this._tileScale.y;
                    },
                    set: function(value) {
                        this._tileScale.y = value;
                        this.dirty = true;
                    }
                }
            });
            module1.exports = TileSprite;
        /***/ },
        /* 226 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Components = __webpack_require__(11);
            var Events = __webpack_require__(75);
            var GameEvents = __webpack_require__(22);
            var InputEvents = __webpack_require__(51);
            var GameObject = __webpack_require__(15);
            var SoundEvents = __webpack_require__(70);
            var UUID = __webpack_require__(222);
            var VideoRender = __webpack_require__(1094);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Video Game Object.
 *
 * This Game Object is capable of handling playback of a previously loaded video from the Phaser Video Cache,
 * or playing a video based on a given URL. Videos can be either local, or streamed.
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4');
 * }
 *
 * create () {
 *   this.add.video(400, 300, 'pixar');
 * }
 * ```
 *
 * To all intents and purposes, a video is a standard Game Object, just like a Sprite. And as such, you can do
 * all the usual things to it, such as scaling, rotating, cropping, tinting, making interactive, giving a
 * physics body, etc.
 *
 * Transparent videos are also possible via the WebM file format. Providing the video file has was encoded with
 * an alpha channel, and providing the browser supports WebM playback (not all of them do), then it will render
 * in-game with full transparency.
 *
 * ### Autoplaying Videos
 *
 * Videos can only autoplay if the browser has been unlocked with an interaction, or satisfies the MEI settings.
 * The policies that control autoplaying are vast and vary between browser.
 * You can, and should, read more about it here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
 *
 * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is _loaded_,
 * and it will often allow the video to play immediately:
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4', 'loadeddata', false, true);
 * }
 * ```
 *
 * The 5th parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
 * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
 * the browsers MEI settings. See the MDN Autoplay Guide for further details.
 *
 * Note that due to a bug in IE11 you cannot play a video texture to a Sprite in WebGL. For IE11 force Canvas mode.
 *
 * More details about video playback and the supported media formats can be found on MDN:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats
 *
 * @class Video
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.20.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 */ var Video = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    VideoRender
                ],
                initialize: function Video(scene, x, y, key) {
                    GameObject.call(this, scene, "Video");
                    /**
         * A reference to the HTML Video Element this Video Game Object is playing.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#video
         * @type {?HTMLVideoElement}
         * @since 3.20.0
         */ this.video = null;
                    /**
         * The Phaser Texture this Game Object is using to render the video to.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTexture
         * @type {?Phaser.Textures.Texture}
         * @since 3.20.0
         */ this.videoTexture = null;
                    /**
         * A reference to the TextureSource belong to the `videoTexture` Texture object.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTextureSource
         * @type {?Phaser.Textures.TextureSource}
         * @since 3.20.0
         */ this.videoTextureSource = null;
                    /**
         * A Phaser CanvasTexture instance that holds the most recent snapshot taken from the video.
         * This will only be set if `snapshot` or `snapshotArea` have been called, and will be `null` until that point.
         *
         * @name Phaser.GameObjects.Video#snapshotTexture
         * @type {?Phaser.Textures.CanvasTexture}
         * @since 3.20.0
         */ this.snapshotTexture = null;
                    /**
         * If you have saved this video to a texture via the `saveTexture` method, this controls if the video
         * is rendered with `flipY` in WebGL or not. You often need to set this if you wish to use the video texture
         * as the input source for a shader. If you find your video is appearing upside down within a shader or
         * custom pipeline, flip this property.
         *
         * @name Phaser.GameObjects.Video#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = false;
                    /**
         * The key used by the texture as stored in the Texture Manager.
         *
         * @name Phaser.GameObjects.Video#_key
         * @type {string}
         * @private
         * @since 3.20.0
         */ this._key = UUID();
                    /**
         * An internal flag holding the current state of the video lock, should document interaction be required
         * before playback can begin.
         *
         * @name Phaser.GameObjects.Video#touchLocked
         * @type {boolean}
         * @since 3.20.0
         */ this.touchLocked = true;
                    /**
         * Should the video auto play when document interaction is required and happens?
         *
         * @name Phaser.GameObjects.Video#playWhenUnlocked
         * @type {boolean}
         * @since 3.20.0
         */ this.playWhenUnlocked = false;
                    /**
         * When starting playback of a video Phaser will monitor its `readyState` using a `setTimeout` call.
         * The `setTimeout` happens once every `Video.retryInterval` ms. It will carry on monitoring the video
         * state in this manner until the `retryLimit` is reached and then abort.
         *
         * @name Phaser.GameObjects.Video#retryLimit
         * @type {number}
         * @since 3.20.0
         */ this.retryLimit = 20;
                    /**
         * The current retry attempt.
         *
         * @name Phaser.GameObjects.Video#retry
         * @type {number}
         * @since 3.20.0
         */ this.retry = 0;
                    /**
         * The number of ms between each retry while monitoring the ready state of a downloading video.
         *
         * @name Phaser.GameObjects.Video#retryInterval
         * @type {number}
         * @since 3.20.0
         */ this.retryInterval = 500;
                    /**
         * The setTimeout callback ID.
         *
         * @name Phaser.GameObjects.Video#_retryID
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._retryID = null;
                    /**
         * The video was muted due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemMuted = false;
                    /**
         * The video was muted due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codeMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codeMuted = false;
                    /**
         * The video was paused due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemPaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemPaused = false;
                    /**
         * The video was paused due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codePaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codePaused = false;
                    /**
         * The locally bound event callback handlers.
         *
         * @name Phaser.GameObjects.Video#_callbacks
         * @type {any}
         * @private
         * @since 3.20.0
         */ this._callbacks = {
                        play: this.playHandler.bind(this),
                        error: this.loadErrorHandler.bind(this),
                        end: this.completeHandler.bind(this),
                        time: this.timeUpdateHandler.bind(this),
                        seeking: this.seekingHandler.bind(this),
                        seeked: this.seekedHandler.bind(this)
                    };
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Video#_crop
         * @type {object}
         * @private
         * @since 3.20.0
         */ this._crop = this.resetCropObject();
                    /**
         * An object containing in and out markers for sequence playback.
         *
         * @name Phaser.GameObjects.Video#markers
         * @type {any}
         * @since 3.20.0
         */ this.markers = {};
                    /**
         * The in marker.
         *
         * @name Phaser.GameObjects.Video#_markerIn
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerIn = -1;
                    /**
         * The out marker.
         *
         * @name Phaser.GameObjects.Video#_markerOut
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerOut = MATH_CONST.MAX_SAFE_INTEGER;
                    /**
         * The last time the TextureSource was updated.
         *
         * @name Phaser.GameObjects.Video#_lastUpdate
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._lastUpdate = 0;
                    /**
         * The key of the video being played from the Video cache, if any.
         *
         * @name Phaser.GameObjects.Video#_cacheKey
         * @type {string}
         * @private
         * @since 3.20.0
         */ this._cacheKey = "";
                    /**
         * Is the video currently seeking?
         *
         * @name Phaser.GameObjects.Video#_isSeeking
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._isSeeking = false;
                    /**
         * Should the Video element that this Video is using, be removed from the DOM
         * when this Video is destroyed?
         *
         * @name Phaser.GameObjects.Video#removeVideoElementOnDestroy
         * @type {boolean}
         * @since 3.21.0
         */ this.removeVideoElementOnDestroy = false;
                    this.setPosition(x, y);
                    this.initPipeline();
                    if (key) this.changeSource(key, false);
                    var game = scene.sys.game.events;
                    game.on(GameEvents.PAUSE, this.globalPause, this);
                    game.on(GameEvents.RESUME, this.globalResume, this);
                    var sound = scene.sys.sound;
                    if (sound) sound.on(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Starts this video playing.
     *
     * If the video is already playing, or has been queued to play with `changeSource` then this method just returns.
     *
     * Videos can only autoplay if the browser has been unlocked. This happens if you have interacted with the browser, i.e.
     * by clicking on it or pressing a key, or due to server settings. The policies that control autoplaying are vast and
     * vary between browser. You can read more here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
     *
     * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is loaded,
     * and it will often allow the video to play immediately:
     *
     * ```javascript
     * preload () {
     *   this.load.video('pixar', 'nemo.mp4', 'loadeddata', false, true);
     * }
     * ```
     *
     * The 5th parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
     * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
     * the browsers MEI settings. See the MDN Autoplay Guide for details.
     *
     * If you need audio in your videos, then you'll have to consider the fact that the video cannot start playing until the
     * user has interacted with the browser, into your game flow.
     *
     * @method Phaser.GameObjects.Video#play
     * @since 3.20.0
     *
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ play: function(loop, markerIn, markerOut) {
                    if (this.touchLocked && this.playWhenUnlocked || this.isPlaying()) return this;
                    var video = this.video;
                    if (!video) {
                        console.warn("Video not loaded");
                        return this;
                    }
                    if (loop === undefined) loop = video.loop;
                    var sound = this.scene.sys.sound;
                    if (sound && sound.mute) //  Mute will be set based on the global mute state of the Sound Manager (if there is one)
                    this.setMute(true);
                    if (!isNaN(markerIn)) this._markerIn = markerIn;
                    if (!isNaN(markerOut) && markerOut > markerIn) this._markerOut = markerOut;
                    video.loop = loop;
                    var callbacks = this._callbacks;
                    var playPromise = video.play();
                    if (playPromise !== undefined) playPromise.then(this.playPromiseSuccessHandler.bind(this)).catch(this.playPromiseErrorHandler.bind(this));
                    else {
                        //  Old-school browsers with no Promises
                        video.addEventListener("playing", callbacks.play, true);
                        //  If video hasn't downloaded properly yet ...
                        if (video.readyState < 2) {
                            this.retry = this.retryLimit;
                            this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval);
                        }
                    }
                    //  Set these _after_ calling `play` or they don't fire (useful, thanks browsers)
                    video.addEventListener("ended", callbacks.end, true);
                    video.addEventListener("timeupdate", callbacks.time, true);
                    video.addEventListener("seeking", callbacks.seeking, true);
                    video.addEventListener("seeked", callbacks.seeked, true);
                    return this;
                },
                /**
     * This method allows you to change the source of the current video element. It works by first stopping the
     * current video, if playing. Then deleting the video texture, if one has been created. Finally, it makes a
     * new video texture and starts playback of the new source through the existing video element.
     *
     * The reason you may wish to do this is because videos that require interaction to unlock, remain in an unlocked
     * state, even if you change the source of the video. By changing the source to a new video you avoid having to
     * go through the unlock process again.
     *
     * @method Phaser.GameObjects.Video#changeSource
     * @since 3.20.0
     *
     * @param {string} key - The key of the Video this Game Object will swap to playing, as stored in the Video Cache.
     * @param {boolean} [autoplay=true] - Should the video start playing immediately, once the swap is complete?
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ changeSource: function(key, autoplay, loop, markerIn, markerOut) {
                    if (autoplay === undefined) autoplay = true;
                    var currentVideo = this.video;
                    if (currentVideo) this.stop();
                    var newVideo = this.scene.sys.cache.video.get(key);
                    if (newVideo) {
                        this.video = newVideo;
                        this._cacheKey = key;
                        this._codePaused = newVideo.paused;
                        this._codeMuted = newVideo.muted;
                        if (this.videoTexture) {
                            this.scene.sys.textures.remove(this._key);
                            this.videoTexture = this.scene.sys.textures.create(this._key, newVideo, newVideo.videoWidth, newVideo.videoHeight);
                            this.videoTextureSource = this.videoTexture.source[0];
                            this.videoTexture.add("__BASE", 0, 0, 0, newVideo.videoWidth, newVideo.videoHeight);
                            this.setTexture(this.videoTexture);
                            this.setSizeToFrame();
                            this.updateDisplayOrigin();
                            this.emit(Events.VIDEO_CREATED, this, newVideo.videoWidth, newVideo.videoHeight);
                        } else this.updateTexture();
                        newVideo.currentTime = 0;
                        this._lastUpdate = 0;
                        if (autoplay) this.play(loop, markerIn, markerOut);
                    } else this.video = null;
                    return this;
                },
                /**
     * Adds a sequence marker to this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds.
     *
     * You can then play back specific markers via the `playMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#addMarker
     * @since 3.20.0
     *
     * @param {string} key - A unique name to give this marker.
     * @param {number} markerIn - The time, in seconds, representing the start of this marker.
     * @param {number} markerOut - The time, in seconds, representing the end of this marker.
     *
     * @return {this} This Video Game Object for method chaining.
     */ addMarker: function(key, markerIn, markerOut) {
                    if (!isNaN(markerIn) && markerIn >= 0 && !isNaN(markerOut)) this.markers[key] = [
                        markerIn,
                        markerOut
                    ];
                    return this;
                },
                /**
     * Plays a pre-defined sequence in this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds and
     * specified via the `addMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#playMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker sequence to play.
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @return {this} This Video Game Object for method chaining.
     */ playMarker: function(key, loop) {
                    var marker = this.markers[key];
                    if (marker) this.play(loop, marker[0], marker[1]);
                    return this;
                },
                /**
     * Removes a previously set marker from this video.
     *
     * If the marker is currently playing it will _not_ stop playback.
     *
     * @method Phaser.GameObjects.Video#removeMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker to remove.
     *
     * @return {this} This Video Game Object for method chaining.
     */ removeMarker: function(key) {
                    delete this.markers[key];
                    return this;
                },
                /**
     * Takes a snapshot of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a width and height.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshot
     * @since 3.20.0
     *
     * @param {number} [width] - The width of the resulting CanvasTexture.
     * @param {number} [height] - The height of the resulting CanvasTexture.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshot: function(width, height) {
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    return this.snapshotArea(0, 0, this.width, this.height, width, height);
                },
                /**
     * Takes a snapshot of the specified area of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a different `destWidth` and `destHeight`.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshotArea
     * @since 3.20.0
     *
     * @param {number} [x=0] - The horizontal location of the top-left of the area to grab from.
     * @param {number} [y=0] - The vertical location of the top-left of the area to grab from.
     * @param {number} [srcWidth] - The width of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [srcHeight] - The height of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [destWidth] - The destination width of the grab, allowing you to resize it.
     * @param {number} [destHeight] - The destination height of the grab, allowing you to resize it.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshotArea: function(x, y, srcWidth, srcHeight, destWidth, destHeight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (srcWidth === undefined) srcWidth = this.width;
                    if (srcHeight === undefined) srcHeight = this.height;
                    if (destWidth === undefined) destWidth = srcWidth;
                    if (destHeight === undefined) destHeight = srcHeight;
                    var video = this.video;
                    var snap = this.snapshotTexture;
                    if (!snap) {
                        snap = this.scene.sys.textures.createCanvas(UUID(), destWidth, destHeight);
                        this.snapshotTexture = snap;
                        if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                    } else {
                        snap.setSize(destWidth, destHeight);
                        if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                    }
                    return snap.update();
                },
                /**
     * Stores a copy of this Videos `snapshotTexture` in the Texture Manager using the given key.
     *
     * This texture is created when the `snapshot` or `snapshotArea` methods are called.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of the
     * snapshot by using the texture key:
     *
     * ```javascript
     * var vid = this.add.video(0, 0, 'intro');
     *
     * vid.snapshot();
     *
     * vid.saveSnapshotTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of the `snapshotTexture`, for example by calling `snapshot` again,
     * will automatically update _any_ Game Object that is using it as a texture.
     * Calling `saveSnapshotTexture` again will not save another copy of the same texture,
     * it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * @method Phaser.GameObjects.Video#saveSnapshotTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.CanvasTexture} The Texture that was saved.
     */ saveSnapshotTexture: function(key) {
                    if (this.snapshotTexture) this.scene.sys.textures.renameTexture(this.snapshotTexture.key, key);
                    else this.snapshotTexture = this.scene.sys.textures.createCanvas(key, this.width, this.height);
                    return this.snapshotTexture;
                },
                /**
     * Loads a Video from the given URL, ready for playback with the `Video.play` method.
     *
     * You can control at what point the browser determines the video as being ready for playback via
     * the `loadEvent` parameter. See https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
     * for more details.
     *
     * @method Phaser.GameObjects.Video#loadURL
     * @since 3.20.0
     *
     * @param {string} url - The URL of the video to load or be streamed.
     * @param {string} [loadEvent='loadeddata'] - The load event to listen for. Either `loadeddata`, `canplay` or `canplaythrough`.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadURL: function(url, loadEvent, noAudio) {
                    if (loadEvent === undefined) loadEvent = "loadeddata";
                    if (noAudio === undefined) noAudio = false;
                    if (this.video) this.stop();
                    if (this.videoTexture) this.scene.sys.textures.remove(this._key);
                    var video = document.createElement("video");
                    video.controls = false;
                    if (noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute("autoplay", "autoplay");
                    }
                    video.setAttribute("playsinline", "playsinline");
                    video.setAttribute("preload", "auto");
                    video.addEventListener("error", this._callbacks.error, true);
                    video.src = url;
                    video.load();
                    this.video = video;
                    return this;
                },
                /**
     * Loads a Video from the given MediaStream object, ready for playback with the `Video.play` method.
     *
     * You can control at what point the browser determines the video as being ready for playback via
     * the `loadEvent` parameter. See https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
     * for more details.
     *
     * @method Phaser.GameObjects.Video#loadMediaStream
     * @since 3.50.0
     *
     * @param {string} stream - The MediaStream object.
     * @param {string} [loadEvent='loadeddata'] - The load event to listen for. Either `loadeddata`, `canplay` or `canplaythrough`.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadMediaStream: function(stream, loadEvent, noAudio) {
                    if (loadEvent === undefined) loadEvent = "loadeddata";
                    if (noAudio === undefined) noAudio = false;
                    if (this.video) this.stop();
                    if (this.videoTexture) this.scene.sys.textures.remove(this._key);
                    var video = document.createElement("video");
                    video.controls = false;
                    if (noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute("autoplay", "autoplay");
                    }
                    video.setAttribute("playsinline", "playsinline");
                    video.setAttribute("preload", "auto");
                    video.addEventListener("error", this._callbacks.error, true);
                    try {
                        video.srcObject = stream;
                    } catch (error) {
                        video.src = window.URL.createObjectURL(stream);
                    }
                    video.load();
                    this.video = video;
                    return this;
                },
                /**
     * This internal method is called automatically if the playback Promise resolves successfully.
     *
     * @method Phaser.GameObjects.Video#playPromiseSuccessHandler
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @private
     * @since 3.20.0
     */ playPromiseSuccessHandler: function() {
                    this._codePaused = false;
                    this.touchLocked = false;
                    this.emit(Events.VIDEO_PLAY, this);
                    if (this._markerIn > -1) this.video.currentTime = this._markerIn;
                },
                /**
     * This internal method is called automatically if the playback Promise fails to resolve.
     *
     * @method Phaser.GameObjects.Video#playPromiseErrorHandler
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @private
     * @since 3.20.0
     *
     * @param {any} error - The Promise resolution error.
     */ playPromiseErrorHandler: function(error) {
                    this.scene.sys.input.once(InputEvents.POINTER_DOWN, this.unlockHandler, this);
                    this.touchLocked = true;
                    this.playWhenUnlocked = true;
                    this.emit(Events.VIDEO_ERROR, this, error);
                },
                /**
     * Called when the video emits a `playing` event during load.
     *
     * This is only listened for if the browser doesn't support Promises.
     *
     * @method Phaser.GameObjects.Video#playHandler
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @since 3.20.0
     */ playHandler: function() {
                    this._codePaused = false;
                    this.touchLocked = false;
                    this.emit(Events.VIDEO_PLAY, this);
                    this.video.removeEventListener("playing", this._callbacks.play, true);
                },
                /**
     * This internal method is called automatically if the video fails to load.
     *
     * @method Phaser.GameObjects.Video#loadErrorHandler
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @private
     * @since 3.20.0
     *
     * @param {Event} event - The error Event.
     */ loadErrorHandler: function(event) {
                    this.stop();
                    this.emit(Events.VIDEO_ERROR, this, event);
                },
                /**
     * This internal method is called if the video couldn't be played because it was interaction locked
     * by the browser, but an input event has since been received.
     *
     * @method Phaser.GameObjects.Video#unlockHandler
     * @fires Phaser.GameObjects.Events#VIDEO_UNLOCKED
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @private
     * @since 3.20.0
     *
     * @param {any} error - The Promise resolution error.
     */ unlockHandler: function() {
                    this.touchLocked = false;
                    this.playWhenUnlocked = false;
                    this.emit(Events.VIDEO_UNLOCKED, this);
                    if (this._markerIn > -1) this.video.currentTime = this._markerIn;
                    this.video.play();
                    this.emit(Events.VIDEO_PLAY, this);
                },
                /**
     * Called when the video completes playback, i.e. reaches an `ended` state.
     *
     * This will never happen if the video is coming from a live stream, where the duration is `Infinity`.
     *
     * @method Phaser.GameObjects.Video#completeHandler
     * @fires Phaser.GameObjects.Events#VIDEO_COMPLETE
     * @since 3.20.0
     */ completeHandler: function() {
                    this.emit(Events.VIDEO_COMPLETE, this);
                },
                /**
     * Called when the video emits a `timeUpdate` event during playback.
     *
     * This event is too slow and irregular to be used for actual video timing or texture updating,
     * but we can use it to determine if a video has looped.
     *
     * @method Phaser.GameObjects.Video#timeUpdateHandler
     * @fires Phaser.GameObjects.Events#VIDEO_LOOP
     * @since 3.20.0
     */ timeUpdateHandler: function() {
                    if (this.video && this.video.currentTime < this._lastUpdate) {
                        this.emit(Events.VIDEO_LOOP, this);
                        this._lastUpdate = 0;
                    }
                },
                /**
     * The internal update step.
     *
     * @method Phaser.GameObjects.Video#preUpdate
     * @private
     * @since 3.20.0
     */ preUpdate: function() {
                    var video = this.video;
                    if (video) {
                        var currentTime = video.currentTime;
                        //  Don't render a new frame unless the video has actually changed time
                        if (currentTime !== this._lastUpdate) {
                            this._lastUpdate = currentTime;
                            this.updateTexture();
                            if (currentTime >= this._markerOut) {
                                if (video.loop) {
                                    video.currentTime = this._markerIn;
                                    this.updateTexture();
                                    this._lastUpdate = currentTime;
                                    this.emit(Events.VIDEO_LOOP, this);
                                } else {
                                    this.emit(Events.VIDEO_COMPLETE, this);
                                    this.stop();
                                }
                            }
                        }
                    }
                },
                /**
     * Internal callback that monitors the download progress of a video after changing its source.
     *
     * @method Phaser.GameObjects.Video#checkVideoProgress
     * @fires Phaser.GameObjects.Events#VIDEO_TIMEOUT
     * @private
     * @since 3.20.0
     */ checkVideoProgress: function() {
                    if (this.video.readyState >= 2) //  We've got enough data to update the texture for playback
                    this.updateTexture();
                    else {
                        this.retry--;
                        if (this.retry > 0) this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval);
                        else this.emit(Events.VIDEO_TIMEOUT, this);
                    }
                },
                /**
     * Internal method that is called when enough video data has been received in order to create a texture
     * from it. The texture is assigned to the `Video.videoTexture` property and given a base frame that
     * encompases the whole video size.
     *
     * @method Phaser.GameObjects.Video#updateTexture
     * @since 3.20.0
     */ updateTexture: function() {
                    var video = this.video;
                    var width = video.videoWidth;
                    var height = video.videoHeight;
                    if (!this.videoTexture) {
                        this.videoTexture = this.scene.sys.textures.create(this._key, video, width, height);
                        this.videoTextureSource = this.videoTexture.source[0];
                        this.videoTexture.add("__BASE", 0, 0, 0, width, height);
                        this.setTexture(this.videoTexture);
                        this.setSizeToFrame();
                        this.updateDisplayOrigin();
                        this.emit(Events.VIDEO_CREATED, this, width, height);
                    } else {
                        var textureSource = this.videoTextureSource;
                        if (textureSource.source !== video) {
                            textureSource.source = video;
                            textureSource.width = width;
                            textureSource.height = height;
                        }
                        textureSource.update();
                    }
                },
                /**
     * Returns the key of the currently played video, as stored in the Video Cache.
     * If the video did not come from the cache this will return an empty string.
     *
     * @method Phaser.GameObjects.Video#getVideoKey
     * @since 3.20.0
     *
     * @return {string} The key of the video being played from the Video Cache, if any.
     */ getVideoKey: function() {
                    return this._cacheKey;
                },
                /**
     * Seeks to a given point in the video. The value is given as a float between 0 and 1,
     * where 0 represents the start of the video and 1 represents the end.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * If you wish to seek based on time instead, use the `Video.setCurrentTime` method.
     *
     * @method Phaser.GameObjects.Video#seekTo
     * @since 3.20.0
     *
     * @param {number} value - The point in the video to seek to. A value between 0 and 1.
     *
     * @return {this} This Video Game Object for method chaining.
     */ seekTo: function(value) {
                    var video = this.video;
                    if (video) {
                        var duration = video.duration;
                        if (duration !== Infinity && !isNaN(duration)) {
                            var seekTime = duration * value;
                            this.setCurrentTime(seekTime);
                        }
                    }
                    return this;
                },
                /**
     * A double-precision floating-point value indicating the current playback time in seconds.
     * If the media has not started to play and has not been seeked, this value is the media's initial playback time.
     *
     * @method Phaser.GameObjects.Video#getCurrentTime
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the current playback time in seconds.
     */ getCurrentTime: function() {
                    return this.video ? this.video.currentTime : 0;
                },
                /**
     * Seeks to a given playback time in the video. The value is given in _seconds_ or as a string.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * You can provide a string prefixed with either a `+` or a `-`, such as `+2.5` or `-2.5`.
     * In this case it will seek to +/- the value given, relative to the _current time_.
     *
     * If you wish to seek based on a duration percentage instead, use the `Video.seekTo` method.
     *
     * @method Phaser.GameObjects.Video#setCurrentTime
     * @since 3.20.0
     *
     * @param {(string|number)} value - The playback time to seek to in seconds. Can be expressed as a string, such as `+2` to seek 2 seconds ahead from the current time.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setCurrentTime: function(value) {
                    var video = this.video;
                    if (video) {
                        if (typeof value === "string") {
                            var op = value[0];
                            var num = parseFloat(value.substr(1));
                            if (op === "+") value = video.currentTime + num;
                            else if (op === "-") value = video.currentTime - num;
                        }
                        video.currentTime = value;
                        this._lastUpdate = value;
                    }
                    return this;
                },
                /**
     * Returns a boolean indicating if this Video is currently seeking, or not.
     *
     * @method Phaser.GameObjects.Video#isSeeking
     * @since 3.20.0
     *
     * @return {boolean} A boolean indicating if this Video is currently seeking, or not.
     */ isSeeking: function() {
                    return this._isSeeking;
                },
                /**
     * Internal seeking handler.
     *
     * @method Phaser.GameObjects.Video#seekingHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKING
     * @private
     * @since 3.20.0
     */ seekingHandler: function() {
                    this._isSeeking = true;
                    this.emit(Events.VIDEO_SEEKING, this);
                },
                /**
     * Internal seeked handler.
     *
     * @method Phaser.GameObjects.Video#seekedHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKED
     * @private
     * @since 3.20.0
     */ seekedHandler: function() {
                    this._isSeeking = false;
                    this.emit(Events.VIDEO_SEEKED, this);
                    var video = this.video;
                    if (video) this.updateTexture();
                },
                /**
     * Returns the current progress of the video. Progress is defined as a value between 0 (the start)
     * and 1 (the end).
     *
     * Progress can only be returned if the video has a duration, otherwise it will always return zero.
     *
     * @method Phaser.GameObjects.Video#getProgress
     * @since 3.20.0
     *
     * @return {number} The current progress of playback. If the video has no duration, will always return zero.
     */ getProgress: function() {
                    var video = this.video;
                    if (video) {
                        var now = video.currentTime;
                        var duration = video.duration;
                        if (duration !== Infinity && !isNaN(duration)) return now / duration;
                    }
                    return 0;
                },
                /**
     * A double-precision floating-point value which indicates the duration (total length) of the media in seconds,
     * on the media's timeline. If no media is present on the element, or the media is not valid, the returned value is NaN.
     *
     * If the media has no known end (such as for live streams of unknown duration, web radio, media incoming from WebRTC,
     * and so forth), this value is +Infinity.
     *
     * @method Phaser.GameObjects.Video#getDuration
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the duration of the media in seconds.
     */ getDuration: function() {
                    return this.video ? this.video.duration : 0;
                },
                /**
     * Sets the muted state of the currently playing video, if one is loaded.
     *
     * @method Phaser.GameObjects.Video#setMute
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The mute value. `true` if the video should be muted, otherwise `false`.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setMute: function(value) {
                    if (value === undefined) value = true;
                    this._codeMuted = value;
                    var video = this.video;
                    if (video) video.muted = this._systemMuted ? true : value;
                    return this;
                },
                /**
     * Returns a boolean indicating if this Video is currently muted.
     *
     * @method Phaser.GameObjects.Video#isMuted
     * @since 3.20.0
     *
     * @return {boolean} A boolean indicating if this Video is currently muted, or not.
     */ isMuted: function() {
                    return this._codeMuted;
                },
                /**
     * Internal global mute handler. Will mute the video, if playing, if the global sound system mutes.
     *
     * @method Phaser.GameObjects.Video#globalMute
     * @private
     * @since 3.20.0
     *
     * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
     * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
     */ globalMute: function(soundManager, value) {
                    this._systemMuted = value;
                    var video = this.video;
                    if (video) video.muted = this._codeMuted ? true : value;
                },
                /**
     * Internal global pause handler. Will pause the video if the Game itself pauses.
     *
     * @method Phaser.GameObjects.Video#globalPause
     * @private
     * @since 3.20.0
     */ globalPause: function() {
                    this._systemPaused = true;
                    if (this.video) this.video.pause();
                },
                /**
     * Internal global resume handler. Will resume a paused video if the Game itself resumes.
     *
     * @method Phaser.GameObjects.Video#globalResume
     * @private
     * @since 3.20.0
     */ globalResume: function() {
                    this._systemPaused = false;
                    if (this.video && !this._codePaused) this.video.play();
                },
                /**
     * Sets the paused state of the currently loaded video.
     *
     * If the video is playing, calling this method with `true` will pause playback.
     * If the video is paused, calling this method with `false` will resume playback.
     *
     * If no video is loaded, this method does nothing.
     *
     * @method Phaser.GameObjects.Video#setPaused
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The paused value. `true` if the video should be paused, `false` to resume it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPaused: function(value) {
                    if (value === undefined) value = true;
                    var video = this.video;
                    this._codePaused = value;
                    if (video) {
                        if (value) {
                            if (!video.paused) video.pause();
                        } else if (!value) {
                            if (video.paused && !this._systemPaused) video.play();
                        }
                    }
                    return this;
                },
                /**
     * Returns a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#getVolume
     * @since 3.20.0
     *
     * @return {number} A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     */ getVolume: function() {
                    return this.video ? this.video.volume : 1;
                },
                /**
     * Sets the volume of the currently playing video.
     *
     * The value given is a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#setVolume
     * @since 3.20.0
     *
     * @param {number} [value=1] - A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @return {this} This Video Game Object for method chaining.
     */ setVolume: function(value) {
                    if (value === undefined) value = 1;
                    if (this.video) this.video.volume = Clamp(value, 0, 1);
                    return this;
                },
                /**
     * Returns a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#getPlaybackRate
     * @since 3.20.0
     *
     * @return {number} A double that indicates the rate at which the media is being played back.
     */ getPlaybackRate: function() {
                    return this.video ? this.video.playbackRate : 1;
                },
                /**
     * Sets the playback rate of the current video.
     *
     * The value given is a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#setPlaybackRate
     * @since 3.20.0
     *
     * @param {number} [rate] - A double that indicates the rate at which the media is being played back.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPlaybackRate: function(rate) {
                    if (this.video) this.video.playbackRate = rate;
                    return this;
                },
                /**
     * Returns a boolean which indicates whether the media element should start over when it reaches the end.
     *
     * @method Phaser.GameObjects.Video#getLoop
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the media element will start over when it reaches the end.
     */ getLoop: function() {
                    return this.video ? this.video.loop : false;
                },
                /**
     * Sets the loop state of the current video.
     *
     * The value given is a boolean which indicates whether the media element will start over when it reaches the end.
     *
     * Not all videos can loop, for example live streams.
     *
     * Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @method Phaser.GameObjects.Video#setLoop
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - A boolean which indicates whether the media element will start over when it reaches the end.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setLoop: function(value) {
                    if (value === undefined) value = true;
                    if (this.video) this.video.loop = value;
                    return this;
                },
                /**
     * Returns a boolean which indicates whether the video is currently playing.
     *
     * @method Phaser.GameObjects.Video#isPlaying
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is playing, or not.
     */ isPlaying: function() {
                    return this.video ? !(this.video.paused || this.video.ended) : false;
                },
                /**
     * Returns a boolean which indicates whether the video is currently paused.
     *
     * @method Phaser.GameObjects.Video#isPaused
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is paused, or not.
     */ isPaused: function() {
                    return this.video && this.video.paused || this._codePaused || this._systemPaused;
                },
                /**
     * Stores this Video in the Texture Manager using the given key as a dynamic texture,
     * which any texture-based Game Object, such as a Sprite, can use as its texture:
     *
     * ```javascript
     * var vid = this.add.video(0, 0, 'intro');
     *
     * vid.play();
     *
     * vid.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * The saved texture is automatically updated as the video plays. If you pause this video,
     * or change its source, then the saved texture updates instantly.
     *
     * Calling `saveTexture` again will not save another copy of the same texture, it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * If you intend to save the texture so you can use it as the input for a Shader, you may need to set the
     * `flipY` parameter to `true` if you find the video renders upside down in your shader.
     *
     * @method Phaser.GameObjects.Video#saveTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y` during upload?
     *
     * @return {Phaser.Textures.Texture} The Texture that was saved.
     */ saveTexture: function(key, flipY) {
                    if (flipY === undefined) flipY = false;
                    if (this.videoTexture) this.scene.sys.textures.renameTexture(this._key, key);
                    this._key = key;
                    this.flipY = flipY;
                    if (this.videoTextureSource) this.videoTextureSource.setFlipY(flipY);
                    return this.videoTexture;
                },
                /**
     * Stops the video playing and clears all internal event listeners.
     *
     * If you only wish to pause playback of the video, and resume it a later time, use the `Video.pause` method instead.
     *
     * If the video hasn't finished downloading, calling this method will not abort the download. To do that you need to
     * call `destroy` instead.
     *
     * @method Phaser.GameObjects.Video#stop
     * @fires Phaser.GameObjects.Events#VIDEO_STOP
     * @since 3.20.0
     *
     * @return {this} This Video Game Object for method chaining.
     */ stop: function() {
                    var video = this.video;
                    if (video) {
                        var callbacks = this._callbacks;
                        for(var callback in callbacks)video.removeEventListener(callback, callbacks[callback], true);
                        video.pause();
                    }
                    if (this._retryID) window.clearTimeout(this._retryID);
                    this.emit(Events.VIDEO_STOP, this);
                    return this;
                },
                /**
     * Removes the Video element from the DOM by calling parentNode.removeChild on itself.
     *
     * Also removes the autoplay and src attributes and nulls the Video reference.
     *
     * You should not call this method if you were playing a video from the Video Cache that
     * you wish to play again in your game, or if another Video object is also using the same
     * video.
     *
     * If you loaded an external video via `Video.loadURL` then you should call this function
     * to clear up once you are done with the instance.
     *
     * @method Phaser.GameObjects.Video#removeVideoElement
     * @since 3.20.0
     */ removeVideoElement: function() {
                    var video = this.video;
                    if (!video) return;
                    if (video.parentNode) video.parentNode.removeChild(video);
                    while(video.hasChildNodes())video.removeChild(video.firstChild);
                    video.removeAttribute("autoplay");
                    video.removeAttribute("src");
                    this.video = null;
                },
                /**
     * Handles the pre-destroy step for the Video object.
     *
     * This calls `Video.stop` and optionally `Video.removeVideoElement`.
     *
     * If any Sprites are using this Video as their texture it is up to you to manage those.
     *
     * @method Phaser.GameObjects.Video#preDestroy
     * @private
     * @since 3.21.0
     */ preDestroy: function() {
                    this.stop();
                    if (this.removeVideoElementOnDestroy) this.removeVideoElement();
                    var game = this.scene.sys.game.events;
                    game.off(GameEvents.PAUSE, this.globalPause, this);
                    game.off(GameEvents.RESUME, this.globalResume, this);
                    var sound = this.scene.sys.sound;
                    if (sound) sound.off(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                    if (this._retryID) window.clearTimeout(this._retryID);
                }
            });
            module1.exports = Video;
        /***/ },
        /* 227 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(228);
            var GetPoints = __webpack_require__(470);
            var GEOM_CONST = __webpack_require__(56);
            /**
 * @classdesc
 * A Polygon object
 *
 * The polygon is a closed shape consists of a series of connected straight lines defined by list of ordered points.
 * Several formats are supported to define the list of points, check the setTo method for details.
 * This is a geometry object allowing you to define and inspect the shape.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Polygon you should look at the capabilities of the Graphics class.
 *
 * @class Polygon
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - List of points defining the perimeter of this Polygon. Several formats are supported:
 * - A string containing paired x y values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
 * - An array of objects with public x y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 */ var Polygon = new Class({
                initialize: function Polygon(points) {
                    /**
         * The geometry constant type of this object: `GEOM_CONST.POLYGON`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Polygon#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POLYGON;
                    /**
         * The area of this Polygon.
         *
         * @name Phaser.Geom.Polygon#area
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.area = 0;
                    /**
         * An array of number pair objects that make up this polygon. I.e. [ {x,y}, {x,y}, {x,y} ]
         *
         * @name Phaser.Geom.Polygon#points
         * @type {Phaser.Geom.Point[]}
         * @since 3.0.0
         */ this.points = [];
                    if (points) this.setTo(points);
                },
                /**
     * Check to see if the Polygon contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Polygon#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the polygon.
     * @param {number} y - The y coordinate to check within the polygon.
     *
     * @return {boolean} `true` if the coordinates are within the polygon, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Sets this Polygon to the given points.
     *
     * The points can be set from a variety of formats:
     *
     * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
     *
     * `setTo` may also be called without any arguments to remove all points.
     *
     * @method Phaser.Geom.Polygon#setTo
     * @since 3.0.0
     *
     * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - Points defining the perimeter of this polygon. Please check function description above for the different supported formats.
     *
     * @return {this} This Polygon object.
     */ setTo: function(points) {
                    this.area = 0;
                    this.points = [];
                    if (typeof points === "string") points = points.split(" ");
                    if (!Array.isArray(points)) return this;
                    var p;
                    var y0 = Number.MAX_VALUE;
                    //  The points argument is an array, so iterate through it
                    for(var i = 0; i < points.length; i++){
                        p = {
                            x: 0,
                            y: 0
                        };
                        if (typeof points[i] === "number" || typeof points[i] === "string") {
                            p.x = parseFloat(points[i]);
                            p.y = parseFloat(points[i + 1]);
                            i++;
                        } else if (Array.isArray(points[i])) {
                            //  An array of arrays?
                            p.x = points[i][0];
                            p.y = points[i][1];
                        } else {
                            p.x = points[i].x;
                            p.y = points[i].y;
                        }
                        this.points.push(p);
                        //  Lowest boundary
                        if (p.y < y0) y0 = p.y;
                    }
                    this.calculateArea(y0);
                    return this;
                },
                /**
     * Calculates the area of the Polygon. This is available in the property Polygon.area
     *
     * @method Phaser.Geom.Polygon#calculateArea
     * @since 3.0.0
     *
     * @return {number} The area of the polygon.
     */ calculateArea: function() {
                    if (this.points.length < 3) {
                        this.area = 0;
                        return this.area;
                    }
                    var sum = 0;
                    var p1;
                    var p2;
                    for(var i = 0; i < this.points.length - 1; i++){
                        p1 = this.points[i];
                        p2 = this.points[i + 1];
                        sum += (p2.x - p1.x) * (p1.y + p2.y);
                    }
                    p1 = this.points[0];
                    p2 = this.points[this.points.length - 1];
                    sum += (p1.x - p2.x) * (p2.y + p1.y);
                    this.area = -sum * 0.5;
                    return this.area;
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Polygon#getPoints
     * @since 3.12.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the perimeter of the Polygon.
     */ getPoints: function(quantity, step, output) {
                    return GetPoints(this, quantity, step, output);
                }
            });
            module1.exports = Polygon;
        /***/ },
        /* 228 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Checks whether the x and y coordinates are contained within this polygon.
            //  Adapted from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html by Jonas Raoni Soares Silva
            /**
 * Checks if a point is within the bounds of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check against.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the bounds of the Polygon, otherwise `false`.
 */ var Contains = function(polygon, x, y) {
                var inside = false;
                for(var i = -1, j = polygon.points.length - 1; ++i < polygon.points.length; j = i){
                    var ix = polygon.points[i].x;
                    var iy = polygon.points[i].y;
                    var jx = polygon.points[j].x;
                    var jy = polygon.points[j].y;
                    if ((iy <= y && y < jy || jy <= y && y < iy) && x < (jx - ix) * (y - iy) / (jy - iy) + ix) inside = !inside;
                }
                return inside;
            };
            module1.exports = Contains;
        /***/ },
        /* 229 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Extend = __webpack_require__(17);
            var SetValue = __webpack_require__(478);
            var ShaderRender = __webpack_require__(1176);
            var TransformMatrix = __webpack_require__(25);
            /**
 * @classdesc
 * A Shader Game Object.
 *
 * This Game Object allows you to easily add a quad with its own shader into the display list, and manipulate it
 * as you would any other Game Object, including scaling, rotating, positioning and adding to Containers. Shaders
 * can be masked with either Bitmap or Geometry masks and can also be used as a Bitmap Mask for a Camera or other
 * Game Object. They can also be made interactive and used for input events.
 *
 * It works by taking a reference to a `Phaser.Display.BaseShader` instance, as found in the Shader Cache. These can
 * be created dynamically at runtime, or loaded in via the GLSL File Loader:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('fire', 'shaders/fire.glsl.js');
 * }
 *
 * function create ()
 * {
 *     this.add.shader('fire', 400, 300, 512, 512);
 * }
 * ```
 *
 * Please see the Phaser 3 Examples GitHub repo for examples of loading and creating shaders dynamically.
 *
 * Due to the way in which they work, you cannot directly change the alpha or blend mode of a Shader. This should
 * be handled via exposed uniforms in the shader code itself.
 *
 * By default a Shader will be created with a standard set of uniforms. These were added to match those
 * found on sites such as ShaderToy or GLSLSandbox, and provide common functionality a shader may need,
 * such as the timestamp, resolution or pointer position. You can replace them by specifying your own uniforms
 * in the Base Shader.
 *
 * These Shaders work by halting the current pipeline during rendering, creating a viewport matched to the
 * size of this Game Object and then renders a quad using the bound shader. At the end, the pipeline is restored.
 *
 * Because it blocks the pipeline it means it will interrupt any batching that is currently going on, so you should
 * use these Game Objects sparingly. If you need to have a fully batched custom shader, then please look at using
 * a custom pipeline instead. However, for background or special masking effects, they are extremely effective.
 *
 * @class Shader
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the Game Object.
 * @param {number} [height=128] - The height of the Game Object.
 * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
 * @param {any} [textureData] - Additional texture data if you want to create shader with none NPOT textures.
 */ var Shader = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.ComputedSize,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    ShaderRender
                ],
                initialize: function Shader(scene, key, x, y, width, height, textures, textureData) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    GameObject.call(this, scene, "Shader");
                    /**
         * This Game Object cannot have a blend mode, so skip all checks.
         *
         * @name Phaser.GameObjects.Shader#blendMode
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.blendMode = -1;
                    /**
         * The underlying shader object being used.
         * Empty by default and set during a call to the `setShader` method.
         *
         * @name Phaser.GameObjects.Shader#shader
         * @type {Phaser.Display.BaseShader}
         * @since 3.17.0
         */ this.shader;
                    var renderer = scene.sys.renderer;
                    /**
         * A reference to the current renderer.
         * Shaders only work with the WebGL Renderer.
         *
         * @name Phaser.GameObjects.Shader#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer = renderer;
                    /**
         * The WebGL context belonging to the renderer.
         *
         * @name Phaser.GameObjects.Shader#gl
         * @type {WebGLRenderingContext}
         * @since 3.17.0
         */ this.gl = renderer.gl;
                    /**
         * Raw byte buffer of vertices this Shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexData
         * @type {ArrayBuffer}
         * @since 3.17.0
         */ this.vertexData = new ArrayBuffer(6 * (Float32Array.BYTES_PER_ELEMENT * 2));
                    /**
         * The WebGL vertex buffer object this shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexBuffer
         * @type {WebGLBuffer}
         * @since 3.17.0
         */ this.vertexBuffer = renderer.createVertexBuffer(this.vertexData.byteLength, this.gl.STREAM_DRAW);
                    /**
         * The WebGL shader program this shader uses.
         *
         * @name Phaser.GameObjects.Shader#program
         * @type {WebGLProgram}
         * @since 3.17.0
         */ this.program = null;
                    /**
         * Uint8 view to the vertex raw buffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.GameObjects.Shader#bytes
         * @type {Uint8Array}
         * @since 3.17.0
         */ this.bytes = new Uint8Array(this.vertexData);
                    /**
         * Float32 view of the array buffer containing the shaders vertices.
         *
         * @name Phaser.GameObjects.Shader#vertexViewF32
         * @type {Float32Array}
         * @since 3.17.0
         */ this.vertexViewF32 = new Float32Array(this.vertexData);
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix3 = new TransformMatrix();
                    /**
         * The view matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#viewMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.viewMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The projection matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#projectionMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.projectionMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The default uniform mappings. These can be added to (or replaced) by specifying your own uniforms when
         * creating this shader game object. The uniforms are updated automatically during the render step.
         *
         * The defaults are:
         *
         * `resolution` (2f) - Set to the size of this shader.
         * `time` (1f) - The elapsed game time, in seconds.
         * `mouse` (2f) - If a pointer has been bound (with `setPointer`), this uniform contains its position each frame.
         * `date` (4fv) - A vec4 containing the year, month, day and time in seconds.
         * `sampleRate` (1f) - Sound sample rate. 44100 by default.
         * `iChannel0...3` (sampler2D) - Input channels 0 to 3. `null` by default.
         *
         * @name Phaser.GameObjects.Shader#uniforms
         * @type {any}
         * @since 3.17.0
         */ this.uniforms = {};
                    /**
         * The pointer bound to this shader, if any.
         * Set via the chainable `setPointer` method, or by modifying this property directly.
         *
         * @name Phaser.GameObjects.Shader#pointer
         * @type {Phaser.Input.Pointer}
         * @since 3.17.0
         */ this.pointer = null;
                    /**
         * The cached width of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererWidth
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererWidth = renderer.width;
                    /**
         * The cached height of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererHeight
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererHeight = renderer.height;
                    /**
         * Internal texture count tracker.
         *
         * @name Phaser.GameObjects.Shader#_textureCount
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._textureCount = 0;
                    /**
         * A reference to the GL Frame Buffer this Shader is drawing to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#framebuffer
         * @type {?WebGLFramebuffer}
         * @since 3.19.0
         */ this.framebuffer = null;
                    /**
         * A reference to the WebGLTexture this Shader is rendering to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#glTexture
         * @type {?WebGLTexture}
         * @since 3.19.0
         */ this.glTexture = null;
                    /**
         * A flag that indicates if this Shader has been set to render to a texture instead of the display list.
         *
         * This property is `true` if you have called `Shader.setRenderToTexture`, otherwise it's `false`.
         *
         * A Shader that is rendering to a texture _does not_ appear on the display list.
         *
         * @name Phaser.GameObjects.Shader#renderToTexture
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.renderToTexture = false;
                    /**
         * A reference to the Phaser.Textures.Texture that has been stored in the Texture Manager for this Shader.
         *
         * This property is only set if you have called `Shader.setRenderToTexture`, otherwise it is `null`.
         *
         * @name Phaser.GameObjects.Shader#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.19.0
         */ this.texture = null;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setOrigin(0.5, 0.5);
                    this.setShader(key, textures, textureData);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Shader#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    if (this.renderToTexture) return true;
                    else return !(GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Changes this Shader so instead of rendering to the display list it renders to a
     * WebGL Framebuffer and WebGL Texture instead. This allows you to use the output
     * of this shader as an input for another shader, by mapping a sampler2D uniform
     * to it.
     *
     * After calling this method the `Shader.framebuffer` and `Shader.glTexture` properties
     * are populated.
     *
     * Additionally, you can provide a key to this method. Doing so will create a Phaser Texture
     * from this Shader and save it into the Texture Manager, allowing you to then use it for
     * any texture-based Game Object, such as a Sprite or Image:
     *
     * ```javascript
     * var shader = this.add.shader('myShader', x, y, width, height);
     *
     * shader.setRenderToTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Note that it stores an active reference to this Shader. That means as this shader updates,
     * so does the texture and any object using it to render with. Also, if you destroy this
     * shader, be sure to clear any objects that may have been using it as a texture too.
     *
     * You can access the Phaser Texture that is created via the `Shader.texture` property.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * @method Phaser.GameObjects.Shader#setRenderToTexture
     * @since 3.19.0
     *
     * @param {string} [key] - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Does this texture need vertically flipping before rendering? This should usually be set to `true` if being fed from a buffer.
     *
     * @return {this} This Shader instance.
     */ setRenderToTexture: function(key, flipY) {
                    if (flipY === undefined) flipY = false;
                    if (!this.renderToTexture) {
                        var width = this.width;
                        var height = this.height;
                        var renderer = this.renderer;
                        this.glTexture = renderer.createTextureFromSource(null, width, height, 0);
                        this.glTexture.flipY = flipY;
                        this.framebuffer = renderer.createFramebuffer(width, height, this.glTexture, false);
                        this._rendererWidth = width;
                        this._rendererHeight = height;
                        this.renderToTexture = true;
                        this.projOrtho(0, this.width, this.height, 0);
                        if (key) this.texture = this.scene.sys.textures.addGLTexture(key, this.glTexture, width, height);
                    }
                    //  And now render at least once, so our texture isn't blank on the first update
                    if (this.shader) {
                        renderer.pipelines.clear();
                        this.load();
                        this.flush();
                        renderer.pipelines.rebind();
                    }
                    return this;
                },
                /**
     * Sets the fragment and, optionally, the vertex shader source code that this Shader will use.
     * This will immediately delete the active shader program, if set, and then create a new one
     * with the given source. Finally, the shader uniforms are initialized.
     *
     * @method Phaser.GameObjects.Shader#setShader
     * @since 3.17.0
     *
     * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
     * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setShader: function(key, textures, textureData) {
                    if (textures === undefined) textures = [];
                    if (typeof key === "string") {
                        var cache = this.scene.sys.cache.shader;
                        if (!cache.has(key)) {
                            console.warn("Shader missing: " + key);
                            return this;
                        }
                        this.shader = cache.get(key);
                    } else this.shader = key;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    if (this.program) gl.deleteProgram(this.program);
                    var program = renderer.createProgram(this.shader.vertexSrc, this.shader.fragmentSrc);
                    //  The default uniforms available within the vertex shader
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, "uViewMatrix"), false, this.viewMatrix);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, "uProjectionMatrix"), false, this.projectionMatrix);
                    gl.uniform2f(gl.getUniformLocation(program, "uResolution"), this.width, this.height);
                    this.program = program;
                    var d = new Date();
                    //  The default uniforms available within the fragment shader
                    var defaultUniforms = {
                        resolution: {
                            type: "2f",
                            value: {
                                x: this.width,
                                y: this.height
                            }
                        },
                        time: {
                            type: "1f",
                            value: 0
                        },
                        mouse: {
                            type: "2f",
                            value: {
                                x: this.width / 2,
                                y: this.height / 2
                            }
                        },
                        date: {
                            type: "4fv",
                            value: [
                                d.getFullYear(),
                                d.getMonth(),
                                d.getDate(),
                                d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds()
                            ]
                        },
                        sampleRate: {
                            type: "1f",
                            value: 44100.0
                        },
                        iChannel0: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel1: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel2: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel3: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        }
                    };
                    if (this.shader.uniforms) this.uniforms = Extend(true, {}, this.shader.uniforms, defaultUniforms);
                    else this.uniforms = defaultUniforms;
                    for(var i = 0; i < 4; i++)if (textures[i]) this.setSampler2D("iChannel" + i, textures[i], i, textureData);
                    this.initUniforms();
                    this.projOrtho(0, this._rendererWidth, this._rendererHeight, 0);
                    return this;
                },
                /**
     * Binds a Phaser Pointer object to this Shader.
     *
     * The screen position of the pointer will be set in to the shaders `mouse` uniform
     * automatically every frame. Call this method with no arguments to unbind the pointer.
     *
     * @method Phaser.GameObjects.Shader#setPointer
     * @since 3.17.0
     *
     * @param {Phaser.Input.Pointer} [pointer] - The Pointer to bind to this shader.
     *
     * @return {this} This Shader instance.
     */ setPointer: function(pointer) {
                    this.pointer = pointer;
                    return this;
                },
                /**
     * Sets this shader to use an orthographic projection matrix.
     * This matrix is stored locally in the `projectionMatrix` property,
     * as well as being bound to the `uProjectionMatrix` uniform.
     *
     * @method Phaser.GameObjects.Shader#projOrtho
     * @since 3.17.0
     *
     * @param {number} left - The left value.
     * @param {number} right - The right value.
     * @param {number} bottom - The bottom value.
     * @param {number} top - The top value.
     */ projOrtho: function(left, right, bottom, top) {
                    var near = -1000;
                    var far = 1000;
                    var leftRight = 1 / (left - right);
                    var bottomTop = 1 / (bottom - top);
                    var nearFar = 1 / (near - far);
                    var pm = this.projectionMatrix;
                    pm[0] = -2 * leftRight;
                    pm[5] = -2 * bottomTop;
                    pm[10] = 2 * nearFar;
                    pm[12] = (left + right) * leftRight;
                    pm[13] = (top + bottom) * bottomTop;
                    pm[14] = (far + near) * nearFar;
                    var program = this.program;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    renderer.setProgram(program);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, "uProjectionMatrix"), false, this.projectionMatrix);
                    this._rendererWidth = right;
                    this._rendererHeight = bottom;
                },
                // Uniforms are specified in the GLSL_ES Specification: http://www.khronos.org/registry/webgl/specs/latest/1.0/
                // http://www.khronos.org/registry/gles/specs/2.0/GLSL_ES_Specification_1.0.17.pdf
                /**
     * Initializes all of the uniforms this shader uses.
     *
     * @method Phaser.GameObjects.Shader#initUniforms
     * @private
     * @since 3.17.0
     */ initUniforms: function() {
                    var gl = this.gl;
                    var map = this.renderer.glFuncMap;
                    var program = this.program;
                    this._textureCount = 0;
                    for(var key in this.uniforms){
                        var uniform = this.uniforms[key];
                        var type = uniform.type;
                        var data = map[type];
                        uniform.uniformLocation = gl.getUniformLocation(program, key);
                        if (type !== "sampler2D") {
                            uniform.glMatrix = data.matrix;
                            uniform.glValueLength = data.length;
                            uniform.glFunc = data.func;
                        }
                    }
                },
                /**
     * Sets a sampler2D uniform on this shader where the source texture is a WebGLTexture.
     *
     * This allows you to feed the output from one Shader into another:
     *
     * ```javascript
     * let shader1 = this.add.shader(baseShader1, 0, 0, 512, 512).setRenderToTexture();
     * let shader2 = this.add.shader(baseShader2, 0, 0, 512, 512).setRenderToTexture('output');
     *
     * shader1.setSampler2DBuffer('iChannel0', shader2.glTexture, 512, 512);
     * shader2.setSampler2DBuffer('iChannel0', shader1.glTexture, 512, 512);
     * ```
     *
     * In the above code, the result of baseShader1 is fed into Shader2 as the `iChannel0` sampler2D uniform.
     * The result of baseShader2 is then fed back into shader1 again, creating a feedback loop.
     *
     * If you wish to use an image from the Texture Manager as a sampler2D input for this shader,
     * see the `Shader.setSampler2D` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2DBuffer
     * @since 3.19.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {WebGLTexture} texture - A WebGLTexture reference.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2DBuffer: function(uniformKey, texture, width, height, textureIndex, textureData) {
                    if (textureIndex === undefined) textureIndex = 0;
                    if (textureData === undefined) textureData = {};
                    var uniform = this.uniforms[uniformKey];
                    uniform.value = texture;
                    textureData.width = width;
                    textureData.height = height;
                    uniform.textureData = textureData;
                    this._textureCount = textureIndex;
                    this.initSampler2D(uniform);
                    return this;
                },
                /**
     * Sets a sampler2D uniform on this shader.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * If you wish to use another Shader as a sampler2D input for this shader, see the `Shader.setSampler2DBuffer` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2D
     * @since 3.17.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2D: function(uniformKey, textureKey, textureIndex, textureData) {
                    if (textureIndex === undefined) textureIndex = 0;
                    var textureManager = this.scene.sys.textures;
                    if (textureManager.exists(textureKey)) {
                        var frame = textureManager.getFrame(textureKey);
                        if (frame.glTexture && frame.glTexture.isRenderTexture) return this.setSampler2DBuffer(uniformKey, frame.glTexture, frame.width, frame.height, textureIndex, textureData);
                        var uniform = this.uniforms[uniformKey];
                        var source = frame.source;
                        uniform.textureKey = textureKey;
                        uniform.source = source.image;
                        uniform.value = frame.glTexture;
                        if (source.isGLTexture) {
                            if (!textureData) textureData = {};
                            textureData.width = source.width;
                            textureData.height = source.height;
                        }
                        if (textureData) uniform.textureData = textureData;
                        this._textureCount = textureIndex;
                        this.initSampler2D(uniform);
                    }
                    return this;
                },
                /**
     * Sets a property of a uniform already present on this shader.
     *
     * To modify the value of a uniform such as a 1f or 1i use the `value` property directly:
     *
     * ```javascript
     * shader.setUniform('size.value', 16);
     * ```
     *
     * You can use dot notation to access deeper values, for example:
     *
     * ```javascript
     * shader.setUniform('resolution.value.x', 512);
     * ```
     *
     * The change to the uniform will take effect the next time the shader is rendered.
     *
     * @method Phaser.GameObjects.Shader#setUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to modify. Use dots for deep properties, i.e. `resolution.value.x`.
     * @param {any} value - The value to set into the uniform.
     *
     * @return {this} This Shader instance.
     */ setUniform: function(key, value) {
                    SetValue(this.uniforms, key, value);
                    return this;
                },
                /**
     * Returns the uniform object for the given key, or `null` if the uniform couldn't be found.
     *
     * @method Phaser.GameObjects.Shader#getUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to return the value for.
     *
     * @return {any} A reference to the uniform object. This is not a copy, so modifying it will update the original object also.
     */ getUniform: function(key) {
                    return GetFastValue(this.uniforms, key, null);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel0` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel0
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel0: function(textureKey, textureData) {
                    return this.setSampler2D("iChannel0", textureKey, 0, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel1` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel1
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel1: function(textureKey, textureData) {
                    return this.setSampler2D("iChannel1", textureKey, 1, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel2` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel2
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel2: function(textureKey, textureData) {
                    return this.setSampler2D("iChannel2", textureKey, 2, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel3` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel3
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel3: function(textureKey, textureData) {
                    return this.setSampler2D("iChannel3", textureKey, 3, textureData);
                },
                /**
     * Internal method that takes a sampler2D uniform and prepares it for use by setting the
     * gl texture parameters.
     *
     * @method Phaser.GameObjects.Shader#initSampler2D
     * @private
     * @since 3.17.0
     *
     * @param {any} uniform - The sampler2D uniform to process.
     */ initSampler2D: function(uniform) {
                    if (!uniform.value) return;
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE0 + this._textureCount);
                    gl.bindTexture(gl.TEXTURE_2D, uniform.value);
                    //  Extended texture data
                    var data = uniform.textureData;
                    if (data && !uniform.value.isRenderTexture) {
                        // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texImage2D
                        //  mag / minFilter can be: gl.LINEAR, gl.LINEAR_MIPMAP_LINEAR or gl.NEAREST
                        //  wrapS/T can be: gl.CLAMP_TO_EDGE or gl.REPEAT
                        //  format can be: gl.LUMINANCE or gl.RGBA
                        var magFilter = gl[GetFastValue(data, "magFilter", "linear").toUpperCase()];
                        var minFilter = gl[GetFastValue(data, "minFilter", "linear").toUpperCase()];
                        var wrapS = gl[GetFastValue(data, "wrapS", "repeat").toUpperCase()];
                        var wrapT = gl[GetFastValue(data, "wrapT", "repeat").toUpperCase()];
                        var format = gl[GetFastValue(data, "format", "rgba").toUpperCase()];
                        if (data.repeat) {
                            wrapS = gl.REPEAT;
                            wrapT = gl.REPEAT;
                        }
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, !!data.flipY);
                        if (data.width) {
                            var width = GetFastValue(data, "width", 512);
                            var height = GetFastValue(data, "height", 2);
                            var border = GetFastValue(data, "border", 0);
                            //  texImage2D(GLenum target, GLint level, GLenum internalformat, GLsizei width, GLsizei height, GLint border, GLenum format, GLenum type, ArrayBufferView? pixels)
                            gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, border, format, gl.UNSIGNED_BYTE, null);
                        } else //  texImage2D(GLenum target, GLint level, GLenum internalformat, GLenum format, GLenum type, ImageData? pixels)
                        gl.texImage2D(gl.TEXTURE_2D, 0, format, gl.RGBA, gl.UNSIGNED_BYTE, uniform.source);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
                    }
                    this.renderer.setProgram(this.program);
                    gl.uniform1i(uniform.uniformLocation, this._textureCount);
                    this._textureCount++;
                },
                /**
     * Synchronizes all of the uniforms this shader uses.
     * Each uniforms gl function is called in turn.
     *
     * @method Phaser.GameObjects.Shader#syncUniforms
     * @private
     * @since 3.17.0
     */ syncUniforms: function() {
                    var gl = this.gl;
                    var uniforms = this.uniforms;
                    var uniform;
                    var length;
                    var glFunc;
                    var location;
                    var value;
                    var textureCount = 0;
                    for(var key in uniforms){
                        uniform = uniforms[key];
                        glFunc = uniform.glFunc;
                        length = uniform.glValueLength;
                        location = uniform.uniformLocation;
                        value = uniform.value;
                        if (value === null) continue;
                        if (length === 1) {
                            if (uniform.glMatrix) glFunc.call(gl, location, uniform.transpose, value);
                            else glFunc.call(gl, location, value);
                        } else if (length === 2) glFunc.call(gl, location, value.x, value.y);
                        else if (length === 3) glFunc.call(gl, location, value.x, value.y, value.z);
                        else if (length === 4) glFunc.call(gl, location, value.x, value.y, value.z, value.w);
                        else if (uniform.type === "sampler2D") {
                            gl.activeTexture(gl.TEXTURE0 + textureCount);
                            gl.bindTexture(gl.TEXTURE_2D, value);
                            gl.uniform1i(location, textureCount);
                            textureCount++;
                        }
                    }
                },
                /**
     * Called automatically during render.
     *
     * This method performs matrix ITRS and then stores the resulting value in the `uViewMatrix` uniform.
     * It then sets up the vertex buffer and shader, updates and syncs the uniforms ready
     * for flush to be called.
     *
     * @method Phaser.GameObjects.Shader#load
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [matrix2D] - The transform matrix to use during rendering.
     */ load: function(matrix2D) {
                    //  ITRS
                    var gl = this.gl;
                    var width = this.width;
                    var height = this.height;
                    var renderer = this.renderer;
                    var program = this.program;
                    var vm = this.viewMatrix;
                    if (!this.renderToTexture) {
                        var x = -this._displayOriginX;
                        var y = -this._displayOriginY;
                        vm[0] = matrix2D[0];
                        vm[1] = matrix2D[1];
                        vm[4] = matrix2D[2];
                        vm[5] = matrix2D[3];
                        vm[8] = matrix2D[4];
                        vm[9] = matrix2D[5];
                        vm[12] = vm[0] * x + vm[4] * y;
                        vm[13] = vm[1] * x + vm[5] * y;
                    }
                    //  Update vertex shader uniforms
                    gl.useProgram(program);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, "uViewMatrix"), false, vm);
                    gl.uniform2f(gl.getUniformLocation(program, "uResolution"), this.width, this.height);
                    //  Update fragment shader uniforms
                    var uniforms = this.uniforms;
                    var res = uniforms.resolution;
                    res.value.x = width;
                    res.value.y = height;
                    uniforms.time.value = renderer.game.loop.getDuration();
                    var pointer = this.pointer;
                    if (pointer) {
                        var mouse = uniforms.mouse;
                        var px = pointer.x / width;
                        var py = 1 - pointer.y / height;
                        mouse.value.x = px.toFixed(2);
                        mouse.value.y = py.toFixed(2);
                    }
                    this.syncUniforms();
                },
                /**
     * Called automatically during render.
     *
     * Sets the active shader, loads the vertex buffer and then draws.
     *
     * @method Phaser.GameObjects.Shader#flush
     * @since 3.17.0
     */ flush: function() {
                    //  Bind
                    var width = this.width;
                    var height = this.height;
                    var program = this.program;
                    var gl = this.gl;
                    var vertexBuffer = this.vertexBuffer;
                    var renderer = this.renderer;
                    var vertexSize = Float32Array.BYTES_PER_ELEMENT * 2;
                    if (this.renderToTexture) {
                        renderer.setFramebuffer(this.framebuffer);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
                    var location = gl.getAttribLocation(program, "inPosition");
                    if (location !== -1) {
                        gl.enableVertexAttribArray(location);
                        gl.vertexAttribPointer(location, 2, gl.FLOAT, false, vertexSize, 0);
                    }
                    //  Draw
                    var vf = this.vertexViewF32;
                    vf[3] = height;
                    vf[4] = width;
                    vf[5] = height;
                    vf[8] = width;
                    vf[9] = height;
                    vf[10] = width;
                    //  Flush
                    var vertexCount = 6;
                    gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                    gl.drawArrays(gl.TRIANGLES, 0, vertexCount);
                    if (this.renderToTexture) renderer.setFramebuffer(null, false);
                },
                /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setAlpha
     * @private
     * @since 3.17.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setBlendMode
     * @private
     * @since 3.17.0
     */ setBlendMode: function() {},
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shader#preDestroy
     * @protected
     * @since 3.17.0
     */ preDestroy: function() {
                    var gl = this.gl;
                    gl.deleteProgram(this.program);
                    gl.deleteBuffer(this.vertexBuffer);
                    if (this.renderToTexture) {
                        this.renderer.deleteFramebuffer(this.framebuffer);
                        this.texture.destroy();
                        this.framebuffer = null;
                        this.glTexture = null;
                        this.texture = null;
                    }
                }
            });
            module1.exports = Shader;
        /***/ },
        /* 230 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DegToRad = __webpack_require__(36);
            var Face = __webpack_require__(116);
            var GameObject = __webpack_require__(15);
            var GenerateVerts = __webpack_require__(479);
            var GenerateObjVerts = __webpack_require__(480);
            var GetCalcMatrix = __webpack_require__(19);
            var Matrix4 = __webpack_require__(69);
            var MeshRender = __webpack_require__(1179);
            var StableSort = __webpack_require__(79);
            var Vector3 = __webpack_require__(39);
            var Vertex = __webpack_require__(117);
            /**
 * @classdesc
 * A Mesh Game Object.
 *
 * The Mesh Game Object allows you to render a group of textured vertices and manipulate
 * the view of those vertices, such as rotation, translation or scaling.
 *
 * Support for generating mesh data from grids, model data or Wavefront OBJ Files is included.
 *
 * Although you can use this to render 3D objects, its primary use is for displaying more complex
 * Sprites, or Sprites where you need fine-grained control over the vertex positions in order to
 * achieve special effects in your games. Note that rendering still takes place using Phaser's
 * orthographic camera (after being transformed via `projectionMesh`, see `setPerspective`,
 * `setOrtho`, and `panZ` methods). As a result, all depth and face tests are done in an eventually
 * orthographic space.
 *
 * The rendering process will iterate through the faces of this Mesh and render out each face
 * that is considered as being in view of the camera. No depth buffer is used, and because of this,
 * you should be careful not to use model data with too many vertices, or overlapping geometry,
 * or you'll probably encounter z-depth fighting. The Mesh was designed to allow for more advanced
 * 2D layouts, rather than displaying 3D objects, even though it can do this to a degree.
 *
 * In short, if you want to remake Crysis, use a 3D engine, not a Mesh. However, if you want
 * to easily add some small fun 3D elements into your game, or create some special effects involving
 * vertex warping, this is the right object for you. Mesh data becomes part of the WebGL batch,
 * just like standard Sprites, so doesn't introduce any additional shader overhead. Because
 * the Mesh just generates vertices into the WebGL batch, like any other Sprite, you can use all of
 * the common Game Object components on a Mesh too, such as a custom pipeline, mask, blend mode
 * or texture.
 *
 * Note that the Mesh object is WebGL only and does not have a Canvas counterpart.
 *
 * The Mesh origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Mesh
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x] - The horizontal position of this Game Object in the world.
 * @param {number} [y] - The vertical position of this Game Object in the world.
 * @param {string|Phaser.Textures.Texture} [texture] - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {string|number} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {number[]} [vertices] - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true` (but see note).
 * @param {number[]} [uvs] - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? Note: If not, it will be assumed `z=0`, see method `panZ` or `setOrtho`.
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 */ var Mesh = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    MeshRender
                ],
                initialize: function Mesh(scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (texture === undefined) texture = "__WHITE";
                    GameObject.call(this, scene, "Mesh");
                    /**
         * An array containing the Face instances belonging to this Mesh.
         *
         * A Face consists of 3 Vertex objects.
         *
         * This array is populated during calls such as `addVertices` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#faces
         * @type {Phaser.Geom.Mesh.Face[]}
         * @since 3.50.0
         */ this.faces = [];
                    /**
         * An array containing Vertex instances. One instance per vertex in this Mesh.
         *
         * This array is populated during calls such as `addVertex` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#vertices
         * @type {Phaser.Geom.Mesh.Vertex[]}
         * @since 3.50.0
         */ this.vertices = [];
                    /**
         * The tint fill mode.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertex colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Mesh#tintFill
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.tintFill = false;
                    /**
         * You can optionally choose to render the vertices of this Mesh to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Mesh.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Mesh instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * Please note that high vertex count Meshes will struggle to debug properly.
         *
         * @name Phaser.GameObjects.Mesh#debugCallback
         * @type {function}
         * @since 3.50.0
         */ this.debugCallback = null;
                    /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Mesh#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.50.0
         */ this.debugGraphic = null;
                    /**
         * When rendering, skip any Face that isn't counter clockwise?
         *
         * Enable this to hide backward-facing Faces during rendering.
         *
         * Disable it to render all Faces.
         *
         * @name Phaser.GameObjects.Mesh#hideCCW
         * @type {boolean}
         * @since 3.50.0
         */ this.hideCCW = true;
                    /**
         * A Vector3 containing the 3D position of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to reposition where
         * the vertices are rendered within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * You can also adjust the 'view' by using the `pan` methods.
         *
         * @name Phaser.GameObjects.Mesh#modelPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelPosition = new Vector3();
                    /**
         * A Vector3 containing the 3D scale of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to scale
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelScale
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelScale = new Vector3(1, 1, 1);
                    /**
         * A Vector3 containing the 3D rotation of the vertices in this Mesh.
         *
         * The values should be given in radians, i.e. to rotate the vertices by 90
         * degrees you can use `modelRotation.x = Phaser.Math.DegToRad(90)`.
         *
         * Modifying the components of this property will allow you to rotate
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelRotation
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelRotation = new Vector3();
                    /**
         * An internal cache, used to compare position, rotation, scale and face data
         * each frame, to avoid math calculations in `preUpdate`.
         *
         * Cache structure = position xyz | rotation xyz | scale xyz | face count | view | ortho
         *
         * @name Phaser.GameObjects.Mesh#dirtyCache
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.dirtyCache = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * The transformation matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#transformMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.transformMatrix = new Matrix4();
                    /**
         * The view position for this Mesh.
         *
         * Use the methods`panX`, `panY` and `panZ` to adjust the view.
         *
         * @name Phaser.GameObjects.Mesh#viewPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.viewPosition = new Vector3();
                    /**
         * The view matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#viewMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.viewMatrix = new Matrix4();
                    /**
         * The projection matrix for this Mesh.
         *
         * Update it with the `setPerspective` or `setOrtho` methods.
         *
         * @name Phaser.GameObjects.Mesh#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix = new Matrix4();
                    /**
         * How many faces were rendered by this Mesh Game Object in the last
         * draw? This is reset in the `preUpdate` method and then incremented
         * each time a face is drawn. Note that in multi-camera Scenes this
         * value may exceed that found in `Mesh.getFaceCount` due to
         * cameras drawing the same faces more than once.
         *
         * @name Phaser.GameObjects.Mesh#totalRendered
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.totalRendered = 0;
                    /**
         * Internal cache var for the total number of faces rendered this frame.
         *
         * See `totalRendered` instead for the actual value.
         *
         * @name Phaser.GameObjects.Mesh#totalFrame
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.totalFrame = 0;
                    /**
         * By default, the Mesh will check to see if its model or view transform has
         * changed each frame and only recalculate the vertex positions if they have.
         *
         * This avoids lots of additional math in the `preUpdate` step when not required.
         *
         * However, if you are performing per-Face or per-Vertex manipulation on this Mesh,
         * such as tweening a Face, or moving it without moving the rest of the Mesh,
         * then you may need to disable the dirty cache in order for the Mesh to re-render
         * correctly. You can toggle this property to do that. Please note that leaving
         * this set to `true` will cause the Mesh to recalculate the position of every single
         * vertex in it, every single frame. So only really do this if you know you
         * need it.
         *
         * @name Phaser.GameObjects.Mesh#ignoreDirtyCache
         * @type {boolean}
         * @since 3.50.0
         */ this.ignoreDirtyCache = false;
                    var renderer = scene.sys.renderer;
                    this.setPosition(x, y);
                    this.setTexture(texture, frame);
                    this.setSize(renderer.width, renderer.height);
                    this.initPipeline();
                    this.setPerspective(renderer.width, renderer.height);
                    if (vertices) this.addVertices(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Translates the view position of this Mesh on the x axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panX
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panX: function(v) {
                    this.viewPosition.addScale(Vector3.LEFT, v);
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Translates the view position of this Mesh on the y axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panY
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panY: function(v) {
                    this.viewPosition.y += Vector3.DOWN.y * v;
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Translates the view position of this Mesh on the z axis by the given amount.
     *
     * As the default `panZ` value is 0, vertices with `z=0` (the default) need special care or else they will not display as they are behind the camera.
     * Consider using `mesh.panZ(mesh.height / (2 * Math.tan(Math.PI / 16)))`, which will interpret vertex geometry 1:1 with pixel geometry (or see `setOrtho`).
     *
     * @method Phaser.GameObjects.Mesh#panZ
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panZ: function(amount) {
                    this.viewPosition.z += amount;
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Builds a new perspective projection matrix from the given values.
     *
     * These are also the initial projection matrix & parameters for `Mesh` (and see `panZ` for more discussion).
     *
     * See also `setOrtho`.
     *
     * @method Phaser.GameObjects.Mesh#setPerspective
     * @since 3.50.0
     *
     * @param {number} width - The width of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} height - The height of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} [fov=45] - The field of view, in degrees.
     * @param {number} [near=0.01] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setPerspective: function(width, height, fov, near, far) {
                    if (fov === undefined) fov = 45;
                    if (near === undefined) near = 0.01;
                    if (far === undefined) far = 1000;
                    this.projectionMatrix.perspective(DegToRad(fov), width / height, near, far);
                    this.dirtyCache[10] = 1;
                    this.dirtyCache[11] = 0;
                    return this;
                },
                /**
     * Builds a new orthographic projection matrix from the given values.
     *
     * If using this mode you will often need to set `Mesh.hideCCW` to `false` as well.
     *
     * By default, calling this method with no parameters will set the scaleX value to
     * match the renderer's aspect ratio. If you would like to render vertex positions 1:1
     * to pixel positions, consider calling as `mesh.setOrtho(mesh.width, mesh.height)`.
     *
     * See also `setPerspective`.
     *
     * @method Phaser.GameObjects.Mesh#setOrtho
     * @since 3.50.0
     *
     * @param {number} [scaleX=1] - The default horizontal scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [scaleY=1] - The default vertical scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [near=-1000] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setOrtho: function(scaleX, scaleY, near, far) {
                    if (scaleX === undefined) scaleX = this.scene.sys.renderer.getAspectRatio();
                    if (scaleY === undefined) scaleY = 1;
                    if (near === undefined) near = -1000;
                    if (far === undefined) far = 1000;
                    this.projectionMatrix.ortho(-scaleX, scaleX, -scaleY, scaleY, near, far);
                    this.dirtyCache[10] = 1;
                    this.dirtyCache[11] = 1;
                    return this;
                },
                /**
     * Iterates and destroys all current Faces in this Mesh, then resets the
     * `faces` and `vertices` arrays.
     *
     * @method Phaser.GameObjects.Mesh#clear
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ clear: function() {
                    this.faces.forEach(function(face) {
                        face.destroy();
                    });
                    this.faces = [];
                    this.vertices = [];
                    return this;
                },
                /**
     * This method will add the data from a triangulated Wavefront OBJ model file to this Mesh.
     *
     * The data should have been loaded via the OBJFile:
     *
     * ```javascript
     * this.load.obj(key, url);
     * ```
     *
     * Then use the same `key` as the first parameter to this method.
     *
     * Multiple Mesh Game Objects can use the same model data without impacting on each other.
     *
     * Make sure your 3D package has triangulated the model data prior to exporting it.
     *
     * You can add multiple models to a single Mesh, although they will act as one when
     * moved or rotated. You can scale the model data, should it be too small, or too large, to see.
     * You can also offset the vertices of the model via the `x`, `y` and `z` parameters.
     *
     * @method Phaser.GameObjects.Mesh#addVerticesFromObj
     * @since 3.50.0
     *
     * @param {string} key - The key of the model data in the OBJ Cache to add to this Mesh.
     * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
     * @param {number} [x=0] - Translate the model x position by this amount.
     * @param {number} [y=0] - Translate the model y position by this amount.
     * @param {number} [z=0] - Translate the model z position by this amount.
     * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
     * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
     * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
     * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
     *
     * @return {this} This Mesh Game Object.
     */ addVerticesFromObj: function(key, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                    var data = this.scene.sys.cache.obj.get(key);
                    if (data) GenerateObjVerts(data, this, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp);
                    return this;
                },
                /**
     * Compare the depth of two Faces.
     *
     * @method Phaser.GameObjects.Mesh#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Face} faceA - The first Face.
     * @param {Phaser.Geom.Mesh.Face} faceB - The second Face.
     *
     * @return {number} The difference between the depths of each Face.
     */ sortByDepth: function(faceA, faceB) {
                    return faceA.depth - faceB.depth;
                },
                /**
     * Runs a depth sort across all Faces in this Mesh, comparing their averaged depth.
     *
     * This is called automatically if you use any of the `rotate` methods, but you can
     * also invoke it to sort the Faces should you manually position them.
     *
     * @method Phaser.GameObjects.Mesh#depthSort
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ depthSort: function() {
                    StableSort(this.faces, this.sortByDepth);
                    return this;
                },
                /**
     * Adds a new Vertex into the vertices array of this Mesh.
     *
     * Just adding a vertex isn't enough to render it. You need to also
     * make it part of a Face, with 3 Vertex instances per Face.
     *
     * @method Phaser.GameObjects.Mesh#addVertex
     * @since 3.50.0
     *
     * @param {number} x - The x position of the vertex.
     * @param {number} y - The y position of the vertex.
     * @param {number} z - The z position of the vertex.
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     * @param {number} [color=0xffffff] - The color value of the vertex.
     * @param {number} [alpha=1] - The alpha value of the vertex.
     *
     * @return {this} This Mesh Game Object.
     */ addVertex: function(x, y, z, u, v, color, alpha) {
                    var vert = new Vertex(x, y, z, u, v, color, alpha);
                    this.vertices.push(vert);
                    return vert;
                },
                /**
     * Adds a new Face into the faces array of this Mesh.
     *
     * A Face consists of references to 3 Vertex instances, which must be provided.
     *
     * @method Phaser.GameObjects.Mesh#addFace
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
     *
     * @return {this} This Mesh Game Object.
     */ addFace: function(vertex1, vertex2, vertex3) {
                    var face = new Face(vertex1, vertex2, vertex3);
                    this.faces.push(face);
                    this.dirtyCache[9] = -1;
                    return face;
                },
                /**
     * Adds new vertices to this Mesh by parsing the given data.
     *
     * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
     *
     * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default, and will result in `z=0` for each vertex).
     *
     * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
     *
     * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
     *
     * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
     *
     * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
     *
     * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
     *
     * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
     *
     * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
     *
     * The following example will create a 256 x 256 sized quad using an index array:
     *
     * ```javascript
     * let mesh = new Mesh(this);  // Assuming `this` is a scene!
     * const vertices = [
     *   -128, 128,
     *   128, 128,
     *   -128, -128,
     *   128, -128
     * ];
     *
     * const uvs = [
     *   0, 1,
     *   1, 1,
     *   0, 0,
     *   1, 0
     * ];
     *
     * const indices = [ 0, 2, 1, 2, 3, 1 ];
     *
     * mesh.addVertices(vertices, uvs, indicies);
     * // Note: Otherwise the added points will be "behind" the camera! This value will project vertex `x` & `y` values 1:1 to pixel values.
     * mesh.hideCCW = false;
     * mesh.setOrtho(mesh.width, mesh.height);
     * ```
     *
     * If the data is not indexed, it's assumed that the arrays all contain sequential data.
     *
     * @method Phaser.GameObjects.Mesh#addVertices
     * @since 3.50.0
     *
     * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
     * @param {number[]} uvs - The UVs pairs array.
     * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
     * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? If not, it will be assumed `z=0`, see methods `panZ` or `setOrtho`.
     * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
     * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
     * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
     *
     * @return {this} This Mesh Game Object.
     */ addVertices: function(vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                    var result = GenerateVerts(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                    if (result) {
                        this.faces = this.faces.concat(result.faces);
                        this.vertices = this.vertices.concat(result.vertices);
                    }
                    this.dirtyCache[9] = -1;
                    return this;
                },
                /**
     * Returns the total number of Faces in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFaceCount
     * @since 3.50.0
     *
     * @return {number} The number of Faces in this Mesh Game Object.
     */ getFaceCount: function() {
                    return this.faces.length;
                },
                /**
     * Returns the total number of Vertices in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getVertexCount
     * @since 3.50.0
     *
     * @return {number} The number of Vertices in this Mesh Game Object.
     */ getVertexCount: function() {
                    return this.vertices.length;
                },
                /**
     * Returns the Face at the given index in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFace
     * @since 3.50.0
     *
     * @param {number} index - The index of the Face to get.
     *
     * @return {Phaser.Geom.Mesh.Face} The Face at the given index, or `undefined` if index out of range.
     */ getFace: function(index) {
                    return this.faces[index];
                },
                /**
     * Return an array of Face objects from this Mesh that intersect with the given coordinates.
     *
     * The given position is translated through the matrix of this Mesh and the given Camera,
     * before being compared against the vertices.
     *
     * If more than one Face intersects, they will all be returned in the array, but the array will
     * be depth sorted first, so the first element will always be that closest to the camera.
     *
     * @method Phaser.GameObjects.Mesh#getFaceAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check against.
     * @param {number} y - The y position to check against.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The camera to pass the coordinates through. If not give, the default Scene Camera is used.
     *
     * @return {Phaser.Geom.Mesh.Face[]} An array of Face objects that intersect with the given point, ordered by depth.
     */ getFaceAt: function(x, y, camera) {
                    if (camera === undefined) camera = this.scene.sys.cameras.main;
                    var calcMatrix = GetCalcMatrix(this, camera).calc;
                    var faces = this.faces;
                    var results = [];
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        if (face.contains(x, y, calcMatrix)) results.push(face);
                    }
                    return StableSort(results, this.sortByDepth);
                },
                /**
     * This method enables rendering of the Mesh vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Mesh objects to a single Graphics instance.
     *
     * The Mesh class has a built-in debug rendering callback `Mesh.renderDebug`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, faces)`
     *
     * `src` is the Mesh instance being debugged.
     * `faces` is an array of the Faces that were rendered.
     *
     * You can get the final drawn vertex position from a Face object like this:
     *
     * ```javascript
     * let face = faces[i];
     *
     * let x0 = face.vertex1.tx;
     * let y0 = face.vertex1.ty;
     * let x1 = face.vertex2.tx;
     * let y1 = face.vertex2.ty;
     * let x2 = face.vertex3.tx;
     * let y2 = face.vertex3.ty;
     *
     * graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
     * ```
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Mesh#setDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                    this.debugGraphic = graphic;
                    if (!graphic && !callback) this.debugCallback = null;
                    else if (!callback) this.debugCallback = this.renderDebug;
                    else this.debugCallback = callback;
                    return this;
                },
                /**
     * Checks if the transformation data in this mesh is dirty.
     *
     * This is used internally by the `preUpdate` step to determine if the vertices should
     * be recalculated or not.
     *
     * @method Phaser.GameObjects.Mesh#isDirty
     * @since 3.50.0
     *
     * @return {boolean} Returns `true` if the data of this mesh is dirty, otherwise `false`.
     */ isDirty: function() {
                    var position = this.modelPosition;
                    var rotation = this.modelRotation;
                    var scale = this.modelScale;
                    var dirtyCache = this.dirtyCache;
                    var px = position.x;
                    var py = position.y;
                    var pz = position.z;
                    var rx = rotation.x;
                    var ry = rotation.y;
                    var rz = rotation.z;
                    var sx = scale.x;
                    var sy = scale.y;
                    var sz = scale.z;
                    var faces = this.getFaceCount();
                    var pxCached = dirtyCache[0];
                    var pyCached = dirtyCache[1];
                    var pzCached = dirtyCache[2];
                    var rxCached = dirtyCache[3];
                    var ryCached = dirtyCache[4];
                    var rzCached = dirtyCache[5];
                    var sxCached = dirtyCache[6];
                    var syCached = dirtyCache[7];
                    var szCached = dirtyCache[8];
                    var fCached = dirtyCache[9];
                    dirtyCache[0] = px;
                    dirtyCache[1] = py;
                    dirtyCache[2] = pz;
                    dirtyCache[3] = rx;
                    dirtyCache[4] = ry;
                    dirtyCache[5] = rz;
                    dirtyCache[6] = sx;
                    dirtyCache[7] = sy;
                    dirtyCache[8] = sz;
                    dirtyCache[9] = faces;
                    return pxCached !== px || pyCached !== py || pzCached !== pz || rxCached !== rx || ryCached !== ry || rzCached !== rz || sxCached !== sx || syCached !== sy || szCached !== sz || fCached !== faces;
                },
                /**
     * The Mesh update loop. The following takes place in this method:
     *
     * First, the `totalRendered` and `totalFrame` properties are set.
     *
     * If the view matrix of this Mesh isn't dirty, and the model position, rotate or scale properties are
     * all clean, then the method returns at this point.
     *
     * Otherwise, if the viewPosition is dirty (i.e. from calling a method like `panZ`), then it will
     * refresh the viewMatrix.
     *
     * After this, a new transformMatrix is built and it then iterates through all Faces in this
     * Mesh, calling `transformCoordinatesLocal` on all of them. Internally, this updates every
     * vertex, calculating its new transformed position, based on the new transform matrix.
     *
     * Finally, the faces are depth sorted.
     *
     * @method Phaser.GameObjects.Mesh#preUpdate
     * @protected
     * @since 3.50.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function() {
                    this.totalRendered = this.totalFrame;
                    this.totalFrame = 0;
                    var dirty = this.dirtyCache;
                    if (!this.ignoreDirtyCache && !dirty[10] && !this.isDirty()) //  If neither the view or the mesh is dirty we can bail out and save lots of math
                    return;
                    var width = this.width;
                    var height = this.height;
                    var viewMatrix = this.viewMatrix;
                    var viewPosition = this.viewPosition;
                    if (dirty[10]) {
                        viewMatrix.identity();
                        viewMatrix.translate(viewPosition);
                        viewMatrix.invert();
                        dirty[10] = 0;
                    }
                    var transformMatrix = this.transformMatrix;
                    transformMatrix.setWorldMatrix(this.modelRotation, this.modelPosition, this.modelScale, this.viewMatrix, this.projectionMatrix);
                    var z = viewPosition.z;
                    var faces = this.faces;
                    for(var i = 0; i < faces.length; i++)faces[i].transformCoordinatesLocal(transformMatrix, width, height, z);
                    this.depthSort();
                },
                /**
     * The built-in Mesh debug rendering method.
     *
     * See `Mesh.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Mesh#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Mesh} src - The Mesh object being rendered.
     * @param {Phaser.Geom.Mesh.Face[]} faces - An array of Faces.
     */ renderDebug: function(src, faces) {
                    var graphic = src.debugGraphic;
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        var x0 = face.vertex1.tx;
                        var y0 = face.vertex1.ty;
                        var x1 = face.vertex2.tx;
                        var y1 = face.vertex2.ty;
                        var x2 = face.vertex3.tx;
                        var y2 = face.vertex3.ty;
                        graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
                    }
                },
                /**
     * Handles the pre-destroy step for the Mesh, which removes the Animation component and typed arrays.
     *
     * @method Phaser.GameObjects.Mesh#preDestroy
     * @private
     * @since 3.50.0
     */ preDestroy: function() {
                    this.clear();
                    this.debugCallback = null;
                    this.debugGraphic = null;
                }
            });
            module1.exports = Mesh;
        /***/ },
        /* 231 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetween = __webpack_require__(50);
            /**
 * Checks if two Circles intersect.
 *
 * @function Phaser.Geom.Intersects.CircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 *
 * @return {boolean} `true` if the two Circles intersect, otherwise `false`.
 */ var CircleToCircle = function(circleA, circleB) {
                return DistanceBetween(circleA.x, circleA.y, circleB.x, circleB.y) <= circleA.radius + circleB.radius;
            };
            module1.exports = CircleToCircle;
        /***/ },
        /* 232 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var LineToCircle = __webpack_require__(233);
            /**
 * Checks for intersection between the line segment and circle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToCircle = function(line, circle, out) {
                if (out === undefined) out = [];
                if (LineToCircle(line, circle)) {
                    var lx1 = line.x1;
                    var ly1 = line.y1;
                    var lx2 = line.x2;
                    var ly2 = line.y2;
                    var cx = circle.x;
                    var cy = circle.y;
                    var cr = circle.radius;
                    var lDirX = lx2 - lx1;
                    var lDirY = ly2 - ly1;
                    var oDirX = lx1 - cx;
                    var oDirY = ly1 - cy;
                    var coefficientA = lDirX * lDirX + lDirY * lDirY;
                    var coefficientB = 2 * (lDirX * oDirX + lDirY * oDirY);
                    var coefficientC = oDirX * oDirX + oDirY * oDirY - cr * cr;
                    var lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                    var x, y;
                    if (lambda === 0) {
                        var root = -coefficientB / (2 * coefficientA);
                        x = lx1 + root * lDirX;
                        y = ly1 + root * lDirY;
                        if (root >= 0 && root <= 1) out.push(new Point(x, y));
                    } else if (lambda > 0) {
                        var root1 = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                        x = lx1 + root1 * lDirX;
                        y = ly1 + root1 * lDirY;
                        if (root1 >= 0 && root1 <= 1) out.push(new Point(x, y));
                        var root2 = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                        x = lx1 + root2 * lDirX;
                        y = ly1 + root2 * lDirY;
                        if (root2 >= 0 && root2 <= 1) out.push(new Point(x, y));
                    }
                }
                return out;
            };
            module1.exports = GetLineToCircle;
        /***/ },
        /* 233 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(66);
            var Point = __webpack_require__(4);
            var tmp = new Point();
            /**
 * Checks for intersection between the line segment and circle.
 *
 * Based on code by [Matt DesLauriers](https://github.com/mattdesl/line-circle-collision/blob/master/LICENSE.md).
 *
 * @function Phaser.Geom.Intersects.LineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {(Phaser.Geom.Point|any)} [nearest] - An optional Point-like object. If given the closest point on the Line where the circle intersects will be stored in this object.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var LineToCircle = function(line, circle, nearest) {
                if (nearest === undefined) nearest = tmp;
                if (Contains(circle, line.x1, line.y1)) {
                    nearest.x = line.x1;
                    nearest.y = line.y1;
                    return true;
                }
                if (Contains(circle, line.x2, line.y2)) {
                    nearest.x = line.x2;
                    nearest.y = line.y2;
                    return true;
                }
                var dx = line.x2 - line.x1;
                var dy = line.y2 - line.y1;
                var lcx = circle.x - line.x1;
                var lcy = circle.y - line.y1;
                //  project lc onto d, resulting in vector p
                var dLen2 = dx * dx + dy * dy;
                var px = dx;
                var py = dy;
                if (dLen2 > 0) {
                    var dp = (lcx * dx + lcy * dy) / dLen2;
                    px *= dp;
                    py *= dp;
                }
                nearest.x = line.x1 + px;
                nearest.y = line.y1 + py;
                //  len2 of p
                var pLen2 = px * px + py * py;
                return pLen2 <= dLen2 && px * dx + py * dy >= 0 && Contains(circle, nearest.x, nearest.y);
            };
            module1.exports = LineToCircle;
        /***/ },
        /* 234 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var LineToLine = __webpack_require__(96);
            var LineToRectangle = __webpack_require__(488);
            /**
 * Checks for intersection between the Line and a Rectangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToRectangle = function(line, rect, out) {
                if (out === undefined) out = [];
                if (LineToRectangle(line, rect)) {
                    var lineA = rect.getLineA();
                    var lineB = rect.getLineB();
                    var lineC = rect.getLineC();
                    var lineD = rect.getLineD();
                    var output = [
                        new Point(),
                        new Point(),
                        new Point(),
                        new Point()
                    ];
                    var result = [
                        LineToLine(lineA, line, output[0]),
                        LineToLine(lineB, line, output[1]),
                        LineToLine(lineC, line, output[2]),
                        LineToLine(lineD, line, output[3])
                    ];
                    for(var i = 0; i < 4; i++)if (result[i]) out.push(output[i]);
                }
                return out;
            };
            module1.exports = GetLineToRectangle;
        /***/ },
        /* 235 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
            //  points is an array of Point-like objects with public x/y properties
            //  returns an array containing all points that are within the triangle, or an empty array if none
            //  if 'returnFirst' is true it will return after the first point within the triangle is found
            /**
 * Filters an array of point-like objects to only those contained within a triangle.
 * If `returnFirst` is true, will return an array containing only the first point in the provided array that is within the triangle (or an empty array if there are no such points).
 *
 * @function Phaser.Geom.Triangle.ContainsArray
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle that the points are being checked in.
 * @param {Phaser.Geom.Point[]} points - An array of point-like objects (objects that have an `x` and `y` property)
 * @param {boolean} [returnFirst=false] - If `true`, return an array containing only the first point found that is within the triangle.
 * @param {array} [out] - If provided, the points that are within the triangle will be appended to this array instead of being added to a new array. If `returnFirst` is true, only the first point found within the triangle will be appended. This array will also be returned by this function.
 *
 * @return {Phaser.Geom.Point[]} An array containing all the points from `points` that are within the triangle, if an array was provided as `out`, points will be appended to that array and it will also be returned here.
 */ var ContainsArray = function(triangle, points, returnFirst, out) {
                if (returnFirst === undefined) returnFirst = false;
                if (out === undefined) out = [];
                var v0x = triangle.x3 - triangle.x1;
                var v0y = triangle.y3 - triangle.y1;
                var v1x = triangle.x2 - triangle.x1;
                var v1y = triangle.y2 - triangle.y1;
                var dot00 = v0x * v0x + v0y * v0y;
                var dot01 = v0x * v1x + v0y * v1y;
                var dot11 = v1x * v1x + v1y * v1y;
                // Compute barycentric coordinates
                var b = dot00 * dot11 - dot01 * dot01;
                var inv = b === 0 ? 0 : 1 / b;
                var u;
                var v;
                var v2x;
                var v2y;
                var dot02;
                var dot12;
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                for(var i = 0; i < points.length; i++){
                    v2x = points[i].x - x1;
                    v2y = points[i].y - y1;
                    dot02 = v0x * v2x + v0y * v2y;
                    dot12 = v1x * v2x + v1y * v2y;
                    u = (dot11 * dot02 - dot01 * dot12) * inv;
                    v = (dot00 * dot12 - dot01 * dot02) * inv;
                    if (u >= 0 && v >= 0 && u + v < 1) {
                        out.push({
                            x: points[i].x,
                            y: points[i].y
                        });
                        if (returnFirst) break;
                    }
                }
                return out;
            };
            module1.exports = ContainsArray;
        /***/ },
        /* 236 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a line around the given coordinates by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} x - The horizontal coordinate to rotate the line around.
 * @param {number} y - The vertical coordinate to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundXY = function(line, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = line.x1 - x;
                var ty = line.y1 - y;
                line.x1 = tx * c - ty * s + x;
                line.y1 = tx * s + ty * c + y;
                tx = line.x2 - x;
                ty = line.y2 - y;
                line.x2 = tx * c - ty * s + x;
                line.y2 = tx * s + ty * c + y;
                return line;
            };
            module1.exports = RotateAroundXY;
        /***/ },
        /* 237 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the width/height ratio of a rectangle.
 *
 * @function Phaser.Geom.Rectangle.GetAspectRatio
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
 *
 * @return {number} The width/height ratio of the rectangle.
 */ var GetAspectRatio = function(rect) {
                return rect.height === 0 ? NaN : rect.width / rect.height;
            };
            module1.exports = GetAspectRatio;
        /***/ },
        /* 238 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates an entire Triangle at a given angle about a specific point.
 *
 * @function Phaser.Geom.Triangle.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} x - The X coordinate of the point to rotate the Triangle about.
 * @param {number} y - The Y coordinate of the point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundXY = function(triangle, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = triangle.x1 - x;
                var ty = triangle.y1 - y;
                triangle.x1 = tx * c - ty * s + x;
                triangle.y1 = tx * s + ty * c + y;
                tx = triangle.x2 - x;
                ty = triangle.y2 - y;
                triangle.x2 = tx * c - ty * s + x;
                triangle.y2 = tx * s + ty * c + y;
                tx = triangle.x3 - x;
                ty = triangle.y3 - y;
                triangle.x3 = tx * c - ty * s + x;
                triangle.y3 = tx * s + ty * c + y;
                return triangle;
            };
            module1.exports = RotateAroundXY;
        /***/ },
        /* 239 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Events
 */ module1.exports = {
                BUTTON_DOWN: __webpack_require__(1310),
                BUTTON_UP: __webpack_require__(1311),
                CONNECTED: __webpack_require__(1312),
                DISCONNECTED: __webpack_require__(1313),
                GAMEPAD_BUTTON_DOWN: __webpack_require__(1314),
                GAMEPAD_BUTTON_UP: __webpack_require__(1315)
            };
        /***/ },
        /* 240 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var XHRSettings = __webpack_require__(156);
            /**
 * Takes two XHRSettings Objects and creates a new XHRSettings object from them.
 *
 * The new object is seeded by the values given in the global settings, but any setting in
 * the local object overrides the global ones.
 *
 * @function Phaser.Loader.MergeXHRSettings
 * @since 3.0.0
 *
 * @param {Phaser.Types.Loader.XHRSettingsObject} global - The global XHRSettings object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} local - The local XHRSettings object.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} A newly formed XHRSettings object.
 */ var MergeXHRSettings = function(global, local) {
                var output = global === undefined ? XHRSettings() : Extend({}, global);
                if (local) {
                    for(var setting in local)if (local[setting] !== undefined) output[setting] = local[setting];
                }
                return output;
            };
            module1.exports = MergeXHRSettings;
        /***/ },
        /* 241 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var ParseXML = __webpack_require__(408);
            /**
 * @classdesc
 * A single XML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#xml method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#xml.
 *
 * @class XMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var XMLFile = new Class({
                Extends: File,
                initialize: function XMLFile(loader, key, url, xhrSettings) {
                    var extension = "xml";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "xml",
                        cache: loader.cacheManager.xml,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.XMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = ParseXML(this.xhrLoader.responseText);
                    if (this.data) this.onProcessComplete();
                    else {
                        console.warn("Invalid XMLFile: " + this.key);
                        this.onProcessError();
                    }
                }
            });
            /**
 * Adds an XML file, or array of XML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 * 
 * ```javascript
 * function preload ()
 * {
 *     this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 * 
 * The key must be a unique String. It is used to add the file to the global XML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the XML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the XML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 * 
 * ```javascript
 * this.load.xml({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.XMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 * 
 * ```javascript
 * this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * // and later in your game ...
 * var data = this.cache.xml.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the XML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.xml". It will always add `.xml` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#xml
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig|Phaser.Types.Loader.FileTypes.XMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("xml", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new XMLFile(this, key[i]));
                else this.addFile(new XMLFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = XMLFile;
        /***/ },
        /* 242 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Text File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#text method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#text.
 *
 * @class TextFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TextFile = new Class({
                Extends: File,
                initialize: function TextFile(loader, key, url, xhrSettings) {
                    var type = "text";
                    var extension = "txt";
                    var cache = loader.cacheManager.text;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        type = GetFastValue(config, "type", type);
                        cache = GetFastValue(config, "cache", cache);
                    }
                    var fileConfig = {
                        type: type,
                        cache: cache,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TextFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Text file, or array of Text files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.text('story', 'files/IntroStory.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Text Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Text Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.text({
 *     key: 'story',
 *     url: 'files/IntroStory.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TextFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.text('story', 'files/IntroStory.txt');
 * // and later in your game ...
 * var data = this.cache.text.get('story');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Text Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.txt". It will always add `.txt` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Text File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#text
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig|Phaser.Types.Loader.FileTypes.TextFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("text", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TextFile(this, key[i]));
                else this.addFile(new TextFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TextFile;
        /***/ },
        /* 243 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Components
 */ module1.exports = {
                Acceleration: __webpack_require__(1368),
                Angular: __webpack_require__(1369),
                Bounce: __webpack_require__(1370),
                Debug: __webpack_require__(1371),
                Drag: __webpack_require__(1372),
                Enable: __webpack_require__(1373),
                Friction: __webpack_require__(1374),
                Gravity: __webpack_require__(1375),
                Immovable: __webpack_require__(1376),
                Mass: __webpack_require__(1377),
                OverlapCirc: __webpack_require__(523),
                OverlapRect: __webpack_require__(244),
                Pushable: __webpack_require__(1378),
                Size: __webpack_require__(1379),
                Velocity: __webpack_require__(1380)
            };
        /***/ },
        /* 244 */ /***/ function(module1, exports) {
            /**
 * This method will search the given rectangular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 * 
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 * 
 * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapRect
 * @since 3.17.0
 *
 * @param {number} x - The top-left x coordinate of the area to search within.
 * @param {number} y - The top-left y coordinate of the area to search within.
 * @param {number} width - The width of the area to search within.
 * @param {number} height - The height of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapRect = function(world, x, y, width, height, includeDynamic, includeStatic) {
                if (includeDynamic === undefined) includeDynamic = true;
                if (includeStatic === undefined) includeStatic = false;
                var dynamicBodies = [];
                var staticBodies = [];
                var minMax = world.treeMinMax;
                minMax.minX = x;
                minMax.minY = y;
                minMax.maxX = x + width;
                minMax.maxY = y + height;
                if (includeStatic) staticBodies = world.staticTree.search(minMax);
                if (includeDynamic && world.useTree) dynamicBodies = world.tree.search(minMax);
                else if (includeDynamic) {
                    var bodies = world.bodies;
                    var fakeBody = {
                        position: {
                            x: x,
                            y: y
                        },
                        left: x,
                        top: y,
                        right: x + width,
                        bottom: y + height,
                        isCircle: false
                    };
                    var intersects = world.intersects;
                    bodies.iterate(function(target) {
                        if (intersects(target, fakeBody)) dynamicBodies.push(target);
                    });
                }
                return staticBodies.concat(dynamicBodies);
            };
            module1.exports = OverlapRect;
        /***/ },
        /* 245 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Events
 */ module1.exports = {
                COLLIDE: __webpack_require__(1381),
                OVERLAP: __webpack_require__(1382),
                PAUSE: __webpack_require__(1383),
                RESUME: __webpack_require__(1384),
                TILE_COLLIDE: __webpack_require__(1385),
                TILE_OVERLAP: __webpack_require__(1386),
                WORLD_BOUNDS: __webpack_require__(1387),
                WORLD_STEP: __webpack_require__(1388)
            };
        /***/ },
        /* 246 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(62);
            /**
 * Calculates and returns the horizontal overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.left`, `touching.right`, `touching.none` and `overlapX'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapX = function(body1, body2, overlapOnly, bias) {
                var overlap = 0;
                var maxOverlap = body1.deltaAbsX() + body2.deltaAbsX() + bias;
                if (body1._dx === 0 && body2._dx === 0) {
                    //  They overlap but neither of them are moving
                    body1.embedded = true;
                    body2.embedded = true;
                } else if (body1._dx > body2._dx) {
                    //  Body1 is moving right and / or Body2 is moving left
                    overlap = body1.right - body2.x;
                    if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.right === false || body2.checkCollision.left === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.right = true;
                        body2.touching.none = false;
                        body2.touching.left = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.right = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.left = true;
                        }
                    }
                } else if (body1._dx < body2._dx) {
                    //  Body1 is moving left and/or Body2 is moving right
                    overlap = body1.x - body2.width - body2.x;
                    if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.left === false || body2.checkCollision.right === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.left = true;
                        body2.touching.none = false;
                        body2.touching.right = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.left = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.right = true;
                        }
                    }
                }
                //  Resets the overlapX to zero if there is no overlap, or to the actual pixel value if there is
                body1.overlapX = overlap;
                body2.overlapX = overlap;
                return overlap;
            };
            module1.exports = GetOverlapX;
        /***/ },
        /* 247 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(62);
            /**
 * Calculates and returns the vertical overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.up`, `touching.down`, `touching.none` and `overlapY'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapY = function(body1, body2, overlapOnly, bias) {
                var overlap = 0;
                var maxOverlap = body1.deltaAbsY() + body2.deltaAbsY() + bias;
                if (body1._dy === 0 && body2._dy === 0) {
                    //  They overlap but neither of them are moving
                    body1.embedded = true;
                    body2.embedded = true;
                } else if (body1._dy > body2._dy) {
                    //  Body1 is moving down and/or Body2 is moving up
                    overlap = body1.bottom - body2.y;
                    if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.down === false || body2.checkCollision.up === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.down = true;
                        body2.touching.none = false;
                        body2.touching.up = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.down = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.up = true;
                        }
                    }
                } else if (body1._dy < body2._dy) {
                    //  Body1 is moving up and/or Body2 is moving down
                    overlap = body1.y - body2.bottom;
                    if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.up === false || body2.checkCollision.down === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.up = true;
                        body2.touching.none = false;
                        body2.touching.down = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.up = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.down = true;
                        }
                    }
                }
                //  Resets the overlapY to zero if there is no overlap, or to the actual pixel value if there is
                body1.overlapY = overlap;
                body2.overlapY = overlap;
                return overlap;
            };
            module1.exports = GetOverlapY;
        /***/ },
        /* 248 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the given tile rectangle-like object and an Arcade Physics body.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileIntersectsBody
 * @since 3.0.0
 *
 * @param {{ left: number, right: number, top: number, bottom: number }} tileWorldRect - A rectangle object that defines the tile placement in the world.
 * @param {Phaser.Physics.Arcade.Body} body - The body to check for intersection against.
 *
 * @return {boolean} Returns `true` of the tile intersects with the body, otherwise `false`.
 */ var TileIntersectsBody = function(tileWorldRect, body) {
                // Currently, all bodies are treated as rectangles when colliding with a Tile.
                return !(body.right <= tileWorldRect.left || body.bottom <= tileWorldRect.top || body.position.x >= tileWorldRect.right || body.position.y >= tileWorldRect.bottom);
            };
            module1.exports = TileIntersectsBody;
        /***/ },
        /* 249 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Components
 */ module1.exports = {
                Bounce: __webpack_require__(1495),
                Collision: __webpack_require__(1496),
                Force: __webpack_require__(1497),
                Friction: __webpack_require__(1498),
                Gravity: __webpack_require__(1499),
                Mass: __webpack_require__(1500),
                Sensor: __webpack_require__(1501),
                SetBody: __webpack_require__(1502),
                Sleep: __webpack_require__(1503),
                Static: __webpack_require__(1520),
                Transform: __webpack_require__(1521),
                Velocity: __webpack_require__(1522)
            };
        /***/ },
        /* 250 */ /***/ function(module1, exports) {
            /**
* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
*
* @class Pair
*/ var Pair = {};
            module1.exports = Pair;
            (function() {
                /**
     * Creates a pair.
     * @method create
     * @param {collision} collision
     * @param {number} timestamp
     * @return {pair} A new pair
     */ Pair.create = function(collision, timestamp) {
                    var bodyA = collision.bodyA, bodyB = collision.bodyB;
                    var pair = {
                        id: Pair.id(bodyA, bodyB),
                        bodyA: bodyA,
                        bodyB: bodyB,
                        activeContacts: [],
                        separation: 0,
                        isActive: true,
                        confirmedActive: true,
                        isSensor: bodyA.isSensor || bodyB.isSensor,
                        timeCreated: timestamp,
                        timeUpdated: timestamp,
                        collision: null,
                        inverseMass: 0,
                        friction: 0,
                        frictionStatic: 0,
                        restitution: 0,
                        slop: 0
                    };
                    Pair.update(pair, collision, timestamp);
                    return pair;
                };
                /**
     * Updates a pair given a collision.
     * @method update
     * @param {pair} pair
     * @param {collision} collision
     * @param {number} timestamp
     */ Pair.update = function(pair, collision, timestamp) {
                    pair.collision = collision;
                    if (collision.collided) {
                        var supports = collision.supports, activeContacts = pair.activeContacts, parentA = collision.parentA, parentB = collision.parentB;
                        pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
                        pair.friction = Math.min(parentA.friction, parentB.friction);
                        pair.frictionStatic = Math.max(parentA.frictionStatic, parentB.frictionStatic);
                        pair.restitution = Math.max(parentA.restitution, parentB.restitution);
                        pair.slop = Math.max(parentA.slop, parentB.slop);
                        for(var i = 0; i < supports.length; i++)activeContacts[i] = supports[i].contact;
                        // optimise array size
                        var supportCount = supports.length;
                        if (supportCount < activeContacts.length) activeContacts.length = supportCount;
                        pair.separation = collision.depth;
                        Pair.setActive(pair, true, timestamp);
                    } else if (pair.isActive === true) Pair.setActive(pair, false, timestamp);
                };
                /**
     * Set a pair as active or inactive.
     * @method setActive
     * @param {pair} pair
     * @param {bool} isActive
     * @param {number} timestamp
     */ Pair.setActive = function(pair, isActive, timestamp) {
                    if (isActive) {
                        pair.isActive = true;
                        pair.timeUpdated = timestamp;
                    } else {
                        pair.isActive = false;
                        pair.activeContacts.length = 0;
                    }
                };
                /**
     * Get the id for the given pair.
     * @method id
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {string} Unique pairId
     */ Pair.id = function(bodyA, bodyB) {
                    if (bodyA.id < bodyB.id) return "A" + bodyA.id + "B" + bodyB.id;
                    else return "A" + bodyB.id + "B" + bodyA.id;
                };
            })();
        /***/ },
        /* 251 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Components
 */ module1.exports = {
                CalculateFacesAt: __webpack_require__(252),
                CalculateFacesWithin: __webpack_require__(63),
                CheckIsoBounds: __webpack_require__(541),
                Copy: __webpack_require__(1420),
                CreateFromTiles: __webpack_require__(1421),
                CullBounds: __webpack_require__(543),
                CullTiles: __webpack_require__(544),
                Fill: __webpack_require__(1422),
                FilterTiles: __webpack_require__(1423),
                FindByIndex: __webpack_require__(1424),
                FindTile: __webpack_require__(1425),
                ForEachTile: __webpack_require__(1426),
                GetCullTilesFunction: __webpack_require__(1427),
                GetTileAt: __webpack_require__(158),
                GetTileAtWorldXY: __webpack_require__(1428),
                GetTilesWithin: __webpack_require__(26),
                GetTilesWithinShape: __webpack_require__(1429),
                GetTilesWithinWorldXY: __webpack_require__(529),
                GetTileToWorldXFunction: __webpack_require__(1430),
                GetTileToWorldXYFunction: __webpack_require__(1431),
                GetTileToWorldYFunction: __webpack_require__(1432),
                GetWorldToTileXFunction: __webpack_require__(1433),
                GetWorldToTileXYFunction: __webpack_require__(1434),
                GetWorldToTileYFunction: __webpack_require__(1435),
                HasTileAt: __webpack_require__(562),
                HasTileAtWorldXY: __webpack_require__(1436),
                HexagonalCullBounds: __webpack_require__(546),
                HexagonalCullTiles: __webpack_require__(545),
                HexagonalTileToWorldXY: __webpack_require__(550),
                HexagonalTileToWorldY: __webpack_require__(554),
                HexagonalWorldToTileXY: __webpack_require__(556),
                HexagonalWorldToTileY: __webpack_require__(560),
                IsInLayerBounds: __webpack_require__(119),
                IsometricCullTiles: __webpack_require__(547),
                IsometricTileToWorldXY: __webpack_require__(551),
                IsometricWorldToTileXY: __webpack_require__(557),
                PutTileAt: __webpack_require__(257),
                PutTileAtWorldXY: __webpack_require__(1437),
                PutTilesAt: __webpack_require__(1438),
                Randomize: __webpack_require__(1439),
                RemoveTileAt: __webpack_require__(563),
                RemoveTileAtWorldXY: __webpack_require__(1440),
                RenderDebug: __webpack_require__(1441),
                ReplaceByIndex: __webpack_require__(542),
                RunCull: __webpack_require__(159),
                SetCollision: __webpack_require__(1442),
                SetCollisionBetween: __webpack_require__(1443),
                SetCollisionByExclusion: __webpack_require__(1444),
                SetCollisionByProperty: __webpack_require__(1445),
                SetCollisionFromCollisionGroup: __webpack_require__(1446),
                SetLayerCollisionIndex: __webpack_require__(160),
                SetTileCollision: __webpack_require__(72),
                SetTileIndexCallback: __webpack_require__(1447),
                SetTileLocationCallback: __webpack_require__(1448),
                Shuffle: __webpack_require__(1449),
                StaggeredCullBounds: __webpack_require__(549),
                StaggeredCullTiles: __webpack_require__(548),
                StaggeredTileToWorldXY: __webpack_require__(552),
                StaggeredTileToWorldY: __webpack_require__(555),
                StaggeredWorldToTileXY: __webpack_require__(558),
                StaggeredWorldToTileY: __webpack_require__(561),
                SwapByIndex: __webpack_require__(1450),
                TileToWorldX: __webpack_require__(253),
                TileToWorldXY: __webpack_require__(553),
                TileToWorldY: __webpack_require__(254),
                WeightedRandomize: __webpack_require__(1451),
                WorldToTileX: __webpack_require__(255),
                WorldToTileXY: __webpack_require__(559),
                WorldToTileY: __webpack_require__(256)
            };
        /***/ },
        /* 252 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(158);
            /**
 * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
 * faces are used internally for optimizing collisions against tiles. This method is mostly used
 * internally to optimize recalculating faces when only one tile has been changed.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesAt = function(tileX, tileY, layer) {
                var tile = GetTileAt(tileX, tileY, true, layer);
                var above = GetTileAt(tileX, tileY - 1, true, layer);
                var below = GetTileAt(tileX, tileY + 1, true, layer);
                var left = GetTileAt(tileX - 1, tileY, true, layer);
                var right = GetTileAt(tileX + 1, tileY, true, layer);
                var tileCollides = tile && tile.collides;
                // Assume the changed tile has all interesting edges
                if (tileCollides) {
                    tile.faceTop = true;
                    tile.faceBottom = true;
                    tile.faceLeft = true;
                    tile.faceRight = true;
                }
                // Reset edges that are shared between tile and its neighbors
                if (above && above.collides) {
                    if (tileCollides) tile.faceTop = false;
                    above.faceBottom = !tileCollides;
                }
                if (below && below.collides) {
                    if (tileCollides) tile.faceBottom = false;
                    below.faceTop = !tileCollides;
                }
                if (left && left.collides) {
                    if (tileCollides) tile.faceLeft = false;
                    left.faceRight = !tileCollides;
                }
                if (right && right.collides) {
                    if (tileCollides) tile.faceRight = false;
                    right.faceLeft = !tileCollides;
                }
                if (tile && !tile.collides) tile.resetFaces();
                return tile;
            };
            module1.exports = CalculateFacesAt;
        /***/ },
        /* 253 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldX
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number}
 */ var TileToWorldX = function(tileX, camera, layer) {
                var tileWidth = layer.baseTileWidth;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                }
                return layerWorldX + tileX * tileWidth;
            };
            module1.exports = TileToWorldX;
        /***/ },
        /* 254 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldY
 * @since 3.0.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var TileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                return layerWorldY + tileY * tileHeight;
            };
            module1.exports = TileToWorldY;
        /***/ },
        /* 255 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileX
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The X location in tile units.
 */ var WorldToTileX = function(worldX, snapToFloor, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                var tileWidth = layer.baseTileWidth;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                return snapToFloor ? Math.floor(worldX / tileWidth) : worldX / tileWidth;
            };
            module1.exports = WorldToTileX;
        /***/ },
        /* 256 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileY
 * @since 3.0.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var WorldToTileY = function(worldY, snapToFloor, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                return snapToFloor ? Math.floor(worldY / tileHeight) : worldY / tileHeight;
            };
            module1.exports = WorldToTileY;
        /***/ },
        /* 257 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(85);
            var IsInLayerBounds = __webpack_require__(119);
            var CalculateFacesAt = __webpack_require__(252);
            var SetTileCollision = __webpack_require__(72);
            /**
 * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
 * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
 * location. If you pass in an index, only the index at the specified location will be changed.
 * Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAt
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAt = function(tile, tileX, tileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                var oldTile = layer.data[tileY][tileX];
                var oldTileCollides = oldTile && oldTile.collides;
                if (tile instanceof Tile) {
                    if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, tile.index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                    layer.data[tileY][tileX].copy(tile);
                } else {
                    var index = tile;
                    if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                    else layer.data[tileY][tileX].index = index;
                }
                // Updating colliding flag on the new tile
                var newTile = layer.data[tileY][tileX];
                var collides = layer.collideIndexes.indexOf(newTile.index) !== -1;
                SetTileCollision(newTile, collides);
                // Recalculate faces only if the colliding flag at (tileX, tileY) has changed
                if (recalculateFaces && oldTileCollides !== newTile.collides) CalculateFacesAt(tileX, tileY, layer);
                return newTile;
            };
            module1.exports = PutTileAt;
        /***/ },
        /* 258 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            /**
 * Get the Tilemap orientation from the given string.
 *
 * @function Phaser.Tilemaps.Parsers.FromOrientationString
 * @since 3.50.0
 *
 * @param {string} [orientation] - The orientation type as a string.
 *
 * @return {Phaser.Tilemaps.OrientationType} The Tilemap Orientation type.
 */ var FromOrientationString = function(orientation) {
                orientation = orientation.toLowerCase();
                if (orientation === "isometric") return CONST.ISOMETRIC;
                else if (orientation === "staggered") return CONST.STAGGERED;
                else if (orientation === "hexagonal") return CONST.HEXAGONAL;
                else return CONST.ORTHOGONAL;
            };
            module1.exports = FromOrientationString;
        /***/ },
        /* 259 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(40);
            var LayerData = __webpack_require__(120);
            var MapData = __webpack_require__(121);
            var Tile = __webpack_require__(85);
            /**
 * Parses a 2D array of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.Parse2DArray
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number[][]} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The MapData object.
 */ var Parse2DArray = function(name, data, tileWidth, tileHeight, insertNull) {
                var layerData = new LayerData({
                    tileWidth: tileWidth,
                    tileHeight: tileHeight
                });
                var mapData = new MapData({
                    name: name,
                    tileWidth: tileWidth,
                    tileHeight: tileHeight,
                    format: Formats.ARRAY_2D,
                    layers: [
                        layerData
                    ]
                });
                var tiles = [];
                var height = data.length;
                var width = 0;
                for(var y = 0; y < data.length; y++){
                    tiles[y] = [];
                    var row = data[y];
                    for(var x = 0; x < row.length; x++){
                        var tileIndex = parseInt(row[x], 10);
                        if (isNaN(tileIndex) || tileIndex === -1) tiles[y][x] = insertNull ? null : new Tile(layerData, -1, x, y, tileWidth, tileHeight);
                        else tiles[y][x] = new Tile(layerData, tileIndex, x, y, tileWidth, tileHeight);
                    }
                    if (width === 0) width = row.length;
                }
                mapData.width = layerData.width = width;
                mapData.height = layerData.height = height;
                mapData.widthInPixels = layerData.widthInPixels = width * tileWidth;
                mapData.heightInPixels = layerData.heightInPixels = height * tileHeight;
                layerData.data = tiles;
                return mapData;
            };
            module1.exports = Parse2DArray;
        /***/ },
        /* 260 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pick = __webpack_require__(571);
            var ParseGID = __webpack_require__(261);
            var copyPoints = function(p) {
                return {
                    x: p.x,
                    y: p.y
                };
            };
            var commonObjectProps = [
                "id",
                "name",
                "type",
                "rotation",
                "properties",
                "visible",
                "x",
                "y",
                "width",
                "height"
            ];
            /**
 * Convert a Tiled object to an internal parsed object normalising and copying properties over, while applying optional x and y offsets. The parsed object will always have the properties `id`, `name`, `type`, `rotation`, `properties`, `visible`, `x`, `y`, `width` and `height`. Other properties will be added according to the object type (such as text, polyline, gid etc.)
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObject
 * @since 3.0.0
 *
 * @param {object} tiledObject - Tiled object to convert to an internal parsed object normalising and copying properties over.
 * @param {number} [offsetX=0] - Optional additional offset to apply to the object's x property. Defaults to 0.
 * @param {number} [offsetY=0] - Optional additional offset to apply to the object's y property. Defaults to 0.
 *
 * @return {object} The parsed object containing properties read from the Tiled object according to it's type with x and y values updated according to the given offsets.
 */ var ParseObject = function(tiledObject, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                var parsedObject = Pick(tiledObject, commonObjectProps);
                parsedObject.x += offsetX;
                parsedObject.y += offsetY;
                if (tiledObject.gid) {
                    //  Object tiles
                    var gidInfo = ParseGID(tiledObject.gid);
                    parsedObject.gid = gidInfo.gid;
                    parsedObject.flippedHorizontal = gidInfo.flippedHorizontal;
                    parsedObject.flippedVertical = gidInfo.flippedVertical;
                    parsedObject.flippedAntiDiagonal = gidInfo.flippedAntiDiagonal;
                } else if (tiledObject.polyline) parsedObject.polyline = tiledObject.polyline.map(copyPoints);
                else if (tiledObject.polygon) parsedObject.polygon = tiledObject.polygon.map(copyPoints);
                else if (tiledObject.ellipse) parsedObject.ellipse = tiledObject.ellipse;
                else if (tiledObject.text) parsedObject.text = tiledObject.text;
                else if (tiledObject.point) parsedObject.point = true;
                else // Otherwise, assume it is a rectangle
                parsedObject.rectangle = true;
                return parsedObject;
            };
            module1.exports = ParseObject;
        /***/ },
        /* 261 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FLIPPED_HORIZONTAL = 0x80000000;
            var FLIPPED_VERTICAL = 0x40000000;
            var FLIPPED_ANTI_DIAGONAL = 0x20000000; // Top-right is swapped with bottom-left corners
            /**
 * See Tiled documentation on tile flipping:
 * http://docs.mapeditor.org/en/latest/reference/tmx-map-format/
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseGID
 * @since 3.0.0
 *
 * @param {number} gid - A Tiled GID.
 *
 * @return {Phaser.Types.Tilemaps.GIDData} The GID Data.
 */ var ParseGID = function(gid) {
                var flippedHorizontal = Boolean(gid & FLIPPED_HORIZONTAL);
                var flippedVertical = Boolean(gid & FLIPPED_VERTICAL);
                var flippedAntiDiagonal = Boolean(gid & FLIPPED_ANTI_DIAGONAL);
                gid = gid & ~(FLIPPED_HORIZONTAL | FLIPPED_VERTICAL | FLIPPED_ANTI_DIAGONAL);
                // Parse the flip flags into something Phaser can use
                var rotation = 0;
                var flipped = false;
                if (flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                    rotation = Math.PI / 2;
                    flipped = true;
                } else if (flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                    rotation = Math.PI;
                    flipped = false;
                } else if (flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                    rotation = Math.PI / 2;
                    flipped = false;
                } else if (flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                    rotation = 0;
                    flipped = true;
                } else if (!flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                    rotation = 3 * Math.PI / 2;
                    flipped = false;
                } else if (!flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                    rotation = Math.PI;
                    flipped = true;
                } else if (!flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                    rotation = 3 * Math.PI / 2;
                    flipped = true;
                } else if (!flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                    rotation = 0;
                    flipped = false;
                }
                return {
                    gid: gid,
                    flippedHorizontal: flippedHorizontal,
                    flippedVertical: flippedVertical,
                    flippedAntiDiagonal: flippedAntiDiagonal,
                    rotation: rotation,
                    flipped: flipped
                };
            };
            module1.exports = ParseGID;
        /***/ },
        /* 262 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(40);
            var MapData = __webpack_require__(121);
            var Parse = __webpack_require__(564);
            var Tilemap = __webpack_require__(580);
            /**
 * Create a Tilemap from the given key or data. If neither is given, make a blank Tilemap. When
 * loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing from
 * a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map data. For
 * an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @function Phaser.Tilemaps.ParseToTilemap
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels.
 * @param {number} [tileHeight=32] - The height of a tile in pixels.
 * @param {number} [width=10] - The width of the map in tiles.
 * @param {number} [height=10] - The height of the map in tiles.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.Tilemap}
 */ var ParseToTilemap = function(scene, key, tileWidth, tileHeight, width, height, data, insertNull) {
                if (tileWidth === undefined) tileWidth = 32;
                if (tileHeight === undefined) tileHeight = 32;
                if (width === undefined) width = 10;
                if (height === undefined) height = 10;
                if (insertNull === undefined) insertNull = false;
                var mapData = null;
                if (Array.isArray(data)) {
                    var name = key !== undefined ? key : "map";
                    mapData = Parse(name, Formats.ARRAY_2D, data, tileWidth, tileHeight, insertNull);
                } else if (key !== undefined) {
                    var tilemapData = scene.cache.tilemap.get(key);
                    if (!tilemapData) console.warn("No map data found for key " + key);
                    else mapData = Parse(key, tilemapData.format, tilemapData.data, tileWidth, tileHeight, insertNull);
                }
                if (mapData === null) mapData = new MapData({
                    tileWidth: tileWidth,
                    tileHeight: tileHeight,
                    width: width,
                    height: height
                });
                return new Tilemap(scene, mapData);
            };
            module1.exports = ParseToTilemap;
        /***/ },
        /* 263 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Extracts an array of targets from a Tween configuration object.
 *
 * The targets will be looked for in a `targets` property. If it's a function, its return value will be used as the result.
 *
 * @function Phaser.Tweens.Builders.GetTargets
 * @since 3.0.0
 *
 * @param {object} config - The configuration object to use.
 *
 * @return {array} An array of targets (may contain only one element), or `null` if no targets were specified.
 */ var GetTargets = function(config) {
                var targets = GetValue(config, "targets", null);
                if (targets === null) return targets;
                if (typeof targets === "function") targets = targets.call();
                if (!Array.isArray(targets)) targets = [
                    targets
                ];
                return targets;
            };
            module1.exports = GetTargets;
        /***/ },
        /* 264 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function hasGetActive(def) {
                return !!def.getActive && typeof def.getActive === "function";
            }
            /**
 * @ignore
 */ function hasGetStart(def) {
                return !!def.getStart && typeof def.getStart === "function";
            }
            /**
 * @ignore
 */ function hasGetEnd(def) {
                return !!def.getEnd && typeof def.getEnd === "function";
            }
            /**
 * @ignore
 */ function hasGetters(def) {
                return hasGetStart(def) || hasGetEnd(def) || hasGetActive(def);
            }
            /**
 * Returns `getActive`, `getStart` and `getEnd` functions for a TweenData based on a target property and end value.
 * 
 * `getActive` if not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * `getEnd` is invoked once any start delays have expired and returns what the value should tween to.
 * `getStart` is invoked when the tween reaches the end and needs to either repeat or yoyo, it returns the value to go back to.
 *
 * If the end value is a number, it will be treated as an absolute value and the property will be tweened to it.
 * A string can be provided to specify a relative end value which consists of an operation
 * (`+=` to add to the current value, `-=` to subtract from the current value, `*=` to multiply the current
 * value, or `/=` to divide the current value) followed by its operand.
 * 
 * A function can be provided to allow greater control over the end value; it will receive the target
 * object being tweened, the name of the property being tweened, and the current value of the property
 * as its arguments.
 * 
 * If both the starting and the ending values need to be controlled, an object with `getStart` and `getEnd`
 * callbacks, which will receive the same arguments, can be provided instead. If an object with a `value`
 * property is provided, the property will be used as the effective value under the same rules described here.
 *
 * @function Phaser.Tweens.Builders.GetValueOp
 * @since 3.0.0
 *
 * @param {string} key - The name of the property to modify.
 * @param {*} propertyValue - The ending value of the property, as described above.
 *
 * @return {function} An array of functions, `getActive`, `getStart` and `getEnd`, which return the starting and the ending value of the property based on the provided value.
 */ var GetValueOp = function(key, propertyValue) {
                var callbacks;
                //  The returned value sets what the property will be at the END of the Tween (usually called at the start of the Tween)
                var getEnd = function(target, key, value) {
                    return value;
                };
                //  The returned value sets what the property will be at the START of the Tween (usually called at the end of the Tween)
                var getStart = function(target, key, value) {
                    return value;
                };
                //  What to set the property to the moment the TweenData is invoked
                var getActive = null;
                var t = typeof propertyValue;
                if (t === "number") // props: {
                //     x: 400,
                //     y: 300
                // }
                getEnd = function() {
                    return propertyValue;
                };
                else if (t === "string") {
                    // props: {
                    //     x: '+=400',
                    //     y: '-=300',
                    //     z: '*=2',
                    //     w: '/=2'
                    // }
                    var op = propertyValue[0];
                    var num = parseFloat(propertyValue.substr(2));
                    switch(op){
                        case "+":
                            getEnd = function(target, key, value) {
                                return value + num;
                            };
                            break;
                        case "-":
                            getEnd = function(target, key, value) {
                                return value - num;
                            };
                            break;
                        case "*":
                            getEnd = function(target, key, value) {
                                return value * num;
                            };
                            break;
                        case "/":
                            getEnd = function(target, key, value) {
                                return value / num;
                            };
                            break;
                        default:
                            getEnd = function() {
                                return parseFloat(propertyValue);
                            };
                    }
                } else if (t === "function") //  The same as setting just the getEnd function and no getStart
                // props: {
                //     x: function (target, key, value, targetIndex, totalTargets, tween) { return value + 50); },
                // }
                getEnd = propertyValue;
                else if (t === "object") {
                    if (hasGetters(propertyValue)) {
                        /*
            x: {
                //  Called the moment Tween is active. The returned value sets the property on the target immediately.
                getActive: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                },

                //  Called at the start of the Tween. The returned value sets what the property will be at the END of the Tween.
                getEnd: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                },

                //  Called at the end of the Tween. The returned value sets what the property will be at the START of the Tween.
                getStart: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                }
            }
            */ if (hasGetActive(propertyValue)) getActive = propertyValue.getActive;
                        if (hasGetEnd(propertyValue)) getEnd = propertyValue.getEnd;
                        if (hasGetStart(propertyValue)) getStart = propertyValue.getStart;
                    } else if (propertyValue.hasOwnProperty("value")) //  'value' may still be a string, function or a number
                    // props: {
                    //     x: { value: 400, ... },
                    //     y: { value: 300, ... }
                    // }
                    callbacks = GetValueOp(key, propertyValue.value);
                    else {
                        //  'from' and 'to' may still be a string, function or a number
                        // props: {
                        //     x: { from: 400, to: 600 },
                        //     y: { from: 300, to: 500 }
                        // }
                        //  Same as above, but the 'start' value is set immediately on the target
                        // props: {
                        //     x: { start: 400, to: 600 },
                        //     y: { start: 300, to: 500 }
                        // }
                        //  'start' value is set immediately, then it goes 'from' to 'to' during the tween
                        // props: {
                        //     x: { start: 200, from: 400, to: 600 },
                        //     y: { start: 300, from: 300, to: 500 }
                        // }
                        var hasTo = propertyValue.hasOwnProperty("to");
                        var hasFrom = propertyValue.hasOwnProperty("from");
                        var hasStart = propertyValue.hasOwnProperty("start");
                        if (hasTo && (hasFrom || hasStart)) {
                            callbacks = GetValueOp(key, propertyValue.to);
                            if (hasStart) {
                                var startCallbacks = GetValueOp(key, propertyValue.start);
                                callbacks.getActive = startCallbacks.getEnd;
                            }
                            if (hasFrom) {
                                var fromCallbacks = GetValueOp(key, propertyValue.from);
                                callbacks.getStart = fromCallbacks.getEnd;
                            }
                        }
                    }
                }
                //  If callback not set by the else if block above then set it here and return it
                if (!callbacks) callbacks = {
                    getActive: getActive,
                    getEnd: getEnd,
                    getStart: getStart
                };
                return callbacks;
            };
            module1.exports = GetValueOp;
        /***/ },
        /* 265 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Types.Tweens.TweenConfigDefaults
 * @since 3.0.0
 * 
 * @property {(object|object[])} targets - The object, or an array of objects, to run the tween on.
 * @property {number} [delay=0] - The number of milliseconds to delay before the tween will start.
 * @property {number} [duration=1000] - The duration of the tween in milliseconds.
 * @property {string} [ease='Power0'] - The easing equation to use for the tween.
 * @property {array} [easeParams] - Optional easing parameters.
 * @property {number} [hold=0] - The number of milliseconds to hold the tween for before yoyo'ing.
 * @property {number} [repeat=0] - The number of times to repeat the tween.
 * @property {number} [repeatDelay=0] - The number of milliseconds to pause before a tween will repeat.
 * @property {boolean} [yoyo=false] - Should the tween complete, then reverse the values incrementally to get back to the starting tween values? The reverse tweening will also take `duration` milliseconds to complete.
 * @property {boolean} [flipX=false] - Horizontally flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipX` property.
 * @property {boolean} [flipY=false] - Vertically flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipY` property.
 */ var TWEEN_DEFAULTS = {
                targets: null,
                delay: 0,
                duration: 1000,
                ease: "Power0",
                easeParams: null,
                hold: 0,
                repeat: 0,
                repeatDelay: 0,
                yoyo: false,
                flipX: false,
                flipY: false
            };
            module1.exports = TWEEN_DEFAULTS;
        /***/ },
        /* 266 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(267);
            var GameObjectCreator = __webpack_require__(16);
            var GameObjectFactory = __webpack_require__(5);
            var TWEEN_CONST = __webpack_require__(100);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Tween is able to manipulate the properties of one or more objects to any given value, based
 * on a duration and type of ease. They are rarely instantiated directly and instead should be
 * created via the TweenManager.
 *
 * @class Tween
 * @memberof Phaser.Tweens
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - A reference to the parent of this Tween. Either the Tween Manager or a Tween Timeline instance.
 * @param {Phaser.Types.Tweens.TweenDataConfig[]} data - An array of TweenData objects, each containing a unique property to be tweened.
 * @param {array} targets - An array of targets to be tweened.
 */ var Tween = new Class({
                Extends: EventEmitter,
                initialize: function Tween(parent, data, targets) {
                    EventEmitter.call(this);
                    /**
         * A reference to the parent of this Tween.
         * Either the Tween Manager or a Tween Timeline instance.
         *
         * @name Phaser.Tweens.Tween#parent
         * @type {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * Is the parent of this Tween a Timeline?
         *
         * @name Phaser.Tweens.Tween#parentIsTimeline
         * @type {boolean}
         * @since 3.0.0
         */ this.parentIsTimeline = parent.hasOwnProperty("isTimeline");
                    /**
         * An array of TweenData objects, each containing a unique property and target being tweened.
         *
         * @name Phaser.Tweens.Tween#data
         * @type {Phaser.Types.Tweens.TweenDataConfig[]}
         * @since 3.0.0
         */ this.data = data;
                    /**
         * The cached length of the data array.
         *
         * @name Phaser.Tweens.Tween#totalData
         * @type {number}
         * @since 3.0.0
         */ this.totalData = data.length;
                    /**
         * An array of references to the target/s this Tween is operating on.
         *
         * @name Phaser.Tweens.Tween#targets
         * @type {object[]}
         * @since 3.0.0
         */ this.targets = targets;
                    /**
         * Cached target total (not necessarily the same as the data total)
         *
         * @name Phaser.Tweens.Tween#totalTargets
         * @type {number}
         * @since 3.0.0
         */ this.totalTargets = targets.length;
                    /**
         * If `true` then duration, delay, etc values are all frame totals.
         *
         * @name Phaser.Tweens.Tween#useFrames
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useFrames = false;
                    /**
         * Scales the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
         * Value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
         *
         * @name Phaser.Tweens.Tween#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Loop this tween? Can be -1 for an infinite loop, or an integer.
         * When enabled it will play through ALL TweenDatas again. Use TweenData.repeat to loop a single element.
         *
         * @name Phaser.Tweens.Tween#loop
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loop = 0;
                    /**
         * Time in ms/frames before the tween loops.
         *
         * @name Phaser.Tweens.Tween#loopDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopDelay = 0;
                    /**
         * How many loops are left to run?
         *
         * @name Phaser.Tweens.Tween#loopCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopCounter = 0;
                    /**
         * Time in ms/frames before the 'onStart' event fires.
         * This is the shortest `delay` value across all of the TweenDatas of this Tween.
         *
         * @name Phaser.Tweens.Tween#startDelay
         * @type {number}
         * @default 0
         * @since 3.19.0
         */ this.startDelay = 0;
                    /**
         * Has this Tween started playback yet?
         * This boolean is toggled when the Tween leaves the 'delayed' state and starts running.
         *
         * @name Phaser.Tweens.Tween#hasStarted
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.hasStarted = false;
                    /**
         * Is this Tween currently seeking?
         * This boolean is toggled in the `Tween.seek` method.
         * When a tween is seeking it will not dispatch any events or callbacks.
         *
         * @name Phaser.Tweens.Tween#isSeeking
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.isSeeking = false;
                    /**
         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = -1 (as it never completes)
         *
         * @name Phaser.Tweens.Tween#completeDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.completeDelay = 0;
                    /**
         * Countdown timer (used by timeline offset, loopDelay and completeDelay)
         *
         * @name Phaser.Tweens.Tween#countdown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.countdown = 0;
                    /**
         * Set only if this Tween is part of a Timeline.
         *
         * @name Phaser.Tweens.Tween#offset
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.offset = 0;
                    /**
         * Set only if this Tween is part of a Timeline. The calculated offset amount.
         *
         * @name Phaser.Tweens.Tween#calculatedOffset
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.calculatedOffset = 0;
                    /**
         * The current state of the tween
         *
         * @name Phaser.Tweens.Tween#state
         * @type {number}
         * @since 3.0.0
         */ this.state = TWEEN_CONST.PENDING_ADD;
                    /**
         * The state of the tween when it was paused (used by Resume)
         *
         * @name Phaser.Tweens.Tween#_pausedState
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._pausedState = TWEEN_CONST.INIT;
                    /**
         * Does the Tween start off paused? (if so it needs to be started with Tween.play)
         *
         * @name Phaser.Tweens.Tween#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Elapsed time in ms/frames of this run through the Tween.
         *
         * @name Phaser.Tweens.Tween#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Total elapsed time in ms/frames of the entire Tween, including looping.
         *
         * @name Phaser.Tweens.Tween#totalElapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalElapsed = 0;
                    /**
         * Time in ms/frames for the whole Tween to play through once, excluding loop amounts and loop delays.
         *
         * @name Phaser.Tweens.Tween#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * Value between 0 and 1. The amount through the Tween, excluding loops.
         *
         * @name Phaser.Tweens.Tween#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Time in ms/frames for the Tween to complete (including looping)
         *
         * @name Phaser.Tweens.Tween#totalDuration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalDuration = 0;
                    /**
         * Value between 0 and 1. The amount through the entire Tween, including looping.
         *
         * @name Phaser.Tweens.Tween#totalProgress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalProgress = 0;
                    /**
         * An object containing the different Tween callback functions.
         *
         * You can either set these in the Tween config, or by calling the `Tween.setCallback` method.
         *
         * `onActive` When the Tween is moved from the pending to the active list in the Tween Manager, even if playback paused.
         * `onStart` When the Tween starts playing after a delayed state. Will happen at the same time as `onActive` if it has no delay.
         * `onYoyo` When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
         * `onRepeat` When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
         * `onComplete` When the Tween finishes playback fully. Never invoked if tween is set to repeat infinitely.
         * `onUpdate` When a TweenData updates a property on a source target during playback.
         * `onLoop` When a Tween loops. This happens _after_ the `loopDelay` expires, if set.
         *
         * @name Phaser.Tweens.Tween#callbacks
         * @type {object}
         * @since 3.0.0
         */ this.callbacks = {
                        onActive: null,
                        onComplete: null,
                        onLoop: null,
                        onRepeat: null,
                        onStart: null,
                        onStop: null,
                        onUpdate: null,
                        onYoyo: null
                    };
                    /**
         * The context in which all callbacks are invoked.
         *
         * @name Phaser.Tweens.Tween#callbackScope
         * @type {any}
         * @since 3.0.0
         */ this.callbackScope;
                },
                /**
     * Returns the current value of the specified Tween Data.
     *
     * @method Phaser.Tweens.Tween#getValue
     * @since 3.0.0
     *
     * @param {number} [index=0] - The Tween Data to return the value from.
     *
     * @return {number} The value of the requested Tween Data.
     */ getValue: function(index) {
                    if (index === undefined) index = 0;
                    return this.data[index].current;
                },
                /**
     * Set the scale the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
     *
     * @method Phaser.Tweens.Tween#setTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The scale factor for timescale.
     *
     * @return {this} - This Tween instance.
     */ setTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * Returns the scale of the time applied to this Tween.
     *
     * @method Phaser.Tweens.Tween#getTimeScale
     * @since 3.0.0
     *
     * @return {number} The timescale of this tween (between 0 and 1)
     */ getTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Checks if the Tween is currently active.
     *
     * @method Phaser.Tweens.Tween#isPlaying
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Tween is active, otherwise `false`.
     */ isPlaying: function() {
                    return this.state === TWEEN_CONST.ACTIVE;
                },
                /**
     * Checks if the Tween is currently paused.
     *
     * @method Phaser.Tweens.Tween#isPaused
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Tween is paused, otherwise `false`.
     */ isPaused: function() {
                    return this.state === TWEEN_CONST.PAUSED;
                },
                /**
     * See if this Tween is currently acting upon the given target.
     *
     * @method Phaser.Tweens.Tween#hasTarget
     * @since 3.0.0
     *
     * @param {object} target - The target to check against this Tween.
     *
     * @return {boolean} `true` if the given target is a target of this Tween, otherwise `false`.
     */ hasTarget: function(target) {
                    return this.targets.indexOf(target) !== -1;
                },
                /**
     * Updates the 'end' value of the given property across all matching targets.
     *
     * Calling this does not adjust the duration of the tween, or the current progress.
     *
     * You can optionally tell it to set the 'start' value to be the current value (before the change).
     *
     * @method Phaser.Tweens.Tween#updateTo
     * @since 3.0.0
     *
     * @param {string} key - The property to set the new value for.
     * @param {*} value - The new value of the property.
     * @param {boolean} [startToCurrent=false] - Should this change set the start value to be the current value?
     *
     * @return {this} - This Tween instance.
     */ updateTo: function(key, value, startToCurrent) {
                    if (startToCurrent === undefined) startToCurrent = false;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = this.data[i];
                        if (tweenData.key === key) {
                            tweenData.end = value;
                            if (startToCurrent) tweenData.start = tweenData.current;
                        }
                    }
                    return this;
                },
                /**
     * Restarts the tween from the beginning.
     *
     * @method Phaser.Tweens.Tween#restart
     * @since 3.0.0
     *
     * @return {this} This Tween instance.
     */ restart: function() {
                    //  Reset these so they're ready for the next update
                    this.elapsed = 0;
                    this.progress = 0;
                    this.totalElapsed = 0;
                    this.totalProgress = 0;
                    if (this.state === TWEEN_CONST.ACTIVE) return this.seek(0);
                    else if (this.state === TWEEN_CONST.REMOVED) {
                        this.seek(0);
                        this.parent.makeActive(this);
                        return this;
                    } else if (this.state === TWEEN_CONST.PENDING_ADD) return this;
                    else return this.play();
                },
                /**
     * Internal method that calculates the overall duration of the Tween.
     *
     * @method Phaser.Tweens.Tween#calcDuration
     * @since 3.0.0
     */ calcDuration: function() {
                    var maxDuration = 0;
                    var minDelay = MATH_CONST.MAX_SAFE_INTEGER;
                    var data = this.data;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        //  Set t1 (duration + hold + yoyo)
                        tweenData.t1 = tweenData.duration + tweenData.hold;
                        if (tweenData.yoyo) tweenData.t1 += tweenData.duration;
                        //  Set t2 (repeatDelay + duration + hold + yoyo)
                        tweenData.t2 = tweenData.t1 + tweenData.repeatDelay;
                        //  Total Duration
                        tweenData.totalDuration = tweenData.delay + tweenData.t1;
                        if (tweenData.repeat === -1) tweenData.totalDuration += tweenData.t2 * 999999999999;
                        else if (tweenData.repeat > 0) tweenData.totalDuration += tweenData.t2 * tweenData.repeat;
                        if (tweenData.totalDuration > maxDuration) //  Get the longest TweenData from the Tween, used to calculate the Tween TD
                        maxDuration = tweenData.totalDuration;
                        if (tweenData.delay < minDelay) minDelay = tweenData.delay;
                    }
                    //  Excludes loop values
                    //  If duration has been set to 0 then we give it a super-low value so that it always
                    //  renders at least 1 frame, but no more, without causing divided by zero errors elsewhere.
                    this.duration = Math.max(maxDuration, 0.001);
                    this.loopCounter = this.loop === -1 ? 999999999999 : this.loop;
                    if (this.loopCounter > 0) this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter;
                    else this.totalDuration = this.duration + this.completeDelay;
                    //  How long before this Tween starts playback?
                    this.startDelay = minDelay;
                },
                /**
     * Called by TweenManager.preUpdate as part of its loop to check pending and active tweens.
     * Should not be called directly.
     *
     * @method Phaser.Tweens.Tween#init
     * @since 3.0.0
     *
     * @return {boolean} Returns `true` if this Tween should be moved from the pending list to the active list by the Tween Manager.
     */ init: function() {
                    //  You can't have a paused Tween if it's part of a Timeline
                    if (this.paused && !this.parentIsTimeline) {
                        this.state = TWEEN_CONST.PENDING_ADD;
                        this._pausedState = TWEEN_CONST.INIT;
                        return false;
                    }
                    var data = this.data;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var gen = tweenData.gen;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        //  Old function signature: i, totalTargets, target
                        //  New function signature: target, key, value, index, total, tween
                        tweenData.delay = gen.delay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.duration = Math.max(gen.duration(target, key, 0, targetIndex, totalTargets, this), 0.001);
                        tweenData.hold = gen.hold(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeat = gen.repeat(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeatDelay = gen.repeatDelay(target, key, 0, targetIndex, totalTargets, this);
                    }
                    this.calcDuration();
                    this.progress = 0;
                    this.totalProgress = 0;
                    this.elapsed = 0;
                    this.totalElapsed = 0;
                    this.state = TWEEN_CONST.INIT;
                    return true;
                },
                /**
     * Internal method that makes this Tween active within the TweenManager
     * and emits the onActive event and callback.
     *
     * @method Phaser.Tweens.Tween#makeActive
     * @fires Phaser.Tweens.Events#TWEEN_ACTIVE
     * @since 3.19.0
     */ makeActive: function() {
                    this.parent.makeActive(this);
                    this.dispatchTweenEvent(Events.TWEEN_ACTIVE, this.callbacks.onActive);
                },
                /**
     * Internal method that advances to the next state of the Tween during playback.
     *
     * @method Phaser.Tweens.Tween#nextState
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @since 3.0.0
     */ nextState: function() {
                    if (this.loopCounter > 0) {
                        this.elapsed = 0;
                        this.progress = 0;
                        this.loopCounter--;
                        this.resetTweenData(true);
                        if (this.loopDelay > 0) {
                            this.countdown = this.loopDelay;
                            this.state = TWEEN_CONST.LOOP_DELAY;
                        } else {
                            this.state = TWEEN_CONST.ACTIVE;
                            this.dispatchTweenEvent(Events.TWEEN_LOOP, this.callbacks.onLoop);
                        }
                    } else if (this.completeDelay > 0) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = this.completeDelay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                    }
                },
                /**
     * Pauses the Tween immediately. Use `resume` to continue playback.
     *
     * @method Phaser.Tweens.Tween#pause
     * @since 3.0.0
     *
     * @return {this} - This Tween instance.
     */ pause: function() {
                    if (this.state === TWEEN_CONST.PAUSED) return this;
                    this.paused = true;
                    this._pausedState = this.state;
                    this.state = TWEEN_CONST.PAUSED;
                    return this;
                },
                /**
     * Starts a Tween playing.
     *
     * You only need to call this method if you have configured the tween to be paused on creation.
     *
     * If the Tween is already playing, calling this method again will have no effect. If you wish to
     * restart the Tween, use `Tween.restart` instead.
     *
     * Calling this method after the Tween has completed will start the Tween playing again from the start.
     * This is the same as calling `Tween.seek(0)` and then `Tween.play()`.
     *
     * @method Phaser.Tweens.Tween#play
     * @since 3.0.0
     *
     * @param {boolean} [resetFromTimeline=false] - Is this Tween being played as part of a Timeline?
     *
     * @return {this} This Tween instance.
     */ play: function(resetFromTimeline) {
                    if (resetFromTimeline === undefined) resetFromTimeline = false;
                    var state = this.state;
                    if (state === TWEEN_CONST.INIT && !this.parentIsTimeline) {
                        this.resetTweenData(false);
                        this.state = TWEEN_CONST.ACTIVE;
                        return this;
                    } else if (state === TWEEN_CONST.ACTIVE || state === TWEEN_CONST.PENDING_ADD && this._pausedState === TWEEN_CONST.PENDING_ADD) return this;
                    else if (!this.parentIsTimeline && (state === TWEEN_CONST.PENDING_REMOVE || state === TWEEN_CONST.REMOVED)) {
                        this.seek(0);
                        this.parent.makeActive(this);
                        return this;
                    }
                    if (this.parentIsTimeline) {
                        this.resetTweenData(resetFromTimeline);
                        if (this.calculatedOffset === 0) this.state = TWEEN_CONST.ACTIVE;
                        else {
                            this.countdown = this.calculatedOffset;
                            this.state = TWEEN_CONST.OFFSET_DELAY;
                        }
                    } else if (this.paused) {
                        this.paused = false;
                        this.makeActive();
                    } else {
                        this.resetTweenData(resetFromTimeline);
                        this.state = TWEEN_CONST.ACTIVE;
                        this.makeActive();
                    }
                    return this;
                },
                /**
     * Internal method that resets all of the Tween Data, including the progress and elapsed values.
     *
     * @method Phaser.Tweens.Tween#resetTweenData
     * @since 3.0.0
     *
     * @param {boolean} resetFromLoop - Has this method been called as part of a loop?
     */ resetTweenData: function(resetFromLoop) {
                    var data = this.data;
                    var total = this.totalData;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < total; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        tweenData.progress = 0;
                        tweenData.elapsed = 0;
                        tweenData.repeatCounter = tweenData.repeat === -1 ? 999999999999 : tweenData.repeat;
                        if (resetFromLoop) {
                            tweenData.start = tweenData.getStartValue(target, key, tweenData.start, targetIndex, totalTargets, this);
                            tweenData.end = tweenData.getEndValue(target, key, tweenData.end, targetIndex, totalTargets, this);
                            tweenData.current = tweenData.start;
                            tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                        } else tweenData.state = TWEEN_CONST.PENDING_RENDER;
                        if (tweenData.delay > 0) {
                            tweenData.elapsed = tweenData.delay;
                            tweenData.state = TWEEN_CONST.DELAY;
                        }
                        if (tweenData.getActiveValue) target[key] = tweenData.getActiveValue(tweenData.target, tweenData.key, tweenData.start);
                    }
                },
                /**
     * Resumes the playback of a previously paused Tween.
     *
     * @method Phaser.Tweens.Tween#resume
     * @since 3.0.0
     *
     * @return {this} - This Tween instance.
     */ resume: function() {
                    if (this.state === TWEEN_CONST.PAUSED) {
                        this.paused = false;
                        this.state = this._pausedState;
                    } else this.play();
                    return this;
                },
                /**
     * Seeks to a specific point in the Tween.
     *
     * **Note:** Be careful when seeking a Tween that repeats or loops forever,
     * or that has an unusually long total duration, as it's possible to hang the browser.
     *
     * The given position is a value between 0 and 1 which represents how far through the Tween to seek to.
     * A value of 0.5 would seek to half-way through the Tween, where-as a value of zero would seek to the start.
     *
     * Note that the seek takes the entire duration of the Tween into account, including delays, loops and repeats.
     * For example, a Tween that lasts for 2 seconds, but that loops 3 times, would have a total duration of 6 seconds,
     * so seeking to 0.5 would seek to 3 seconds into the Tween, as that's half-way through its _entire_ duration.
     *
     * Seeking works by resetting the Tween to its initial values and then iterating through the Tween at `delta`
     * jumps per step. The longer the Tween, the longer this can take.
     *
     * @method Phaser.Tweens.Tween#seek
     * @since 3.0.0
     *
     * @param {number} toPosition - A value between 0 and 1 which represents the progress point to seek to.
     * @param {number} [delta=16.6] - The size of each step when seeking through the Tween. A higher value completes faster but at a cost of less precision.
     *
     * @return {this} This Tween instance.
     */ seek: function(toPosition, delta) {
                    if (delta === undefined) delta = 16.6;
                    if (this.state === TWEEN_CONST.REMOVED) this.makeActive();
                    this.elapsed = 0;
                    this.progress = 0;
                    this.totalElapsed = 0;
                    this.totalProgress = 0;
                    var data = this.data;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var gen = tweenData.gen;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        tweenData.progress = 0;
                        tweenData.elapsed = 0;
                        tweenData.repeatCounter = tweenData.repeat === -1 ? 999999999999 : tweenData.repeat;
                        //  Old function signature: i, totalTargets, target
                        //  New function signature: target, key, value, index, total, tween
                        tweenData.delay = gen.delay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.duration = Math.max(gen.duration(target, key, 0, targetIndex, totalTargets, this), 0.001);
                        tweenData.hold = gen.hold(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeat = gen.repeat(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeatDelay = gen.repeatDelay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.current = tweenData.start;
                        tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                        this.updateTweenData(this, tweenData, 0, targetIndex, totalTargets);
                        if (tweenData.delay > 0) {
                            tweenData.elapsed = tweenData.delay;
                            tweenData.state = TWEEN_CONST.DELAY;
                        }
                    }
                    this.calcDuration();
                    var wasPaused = false;
                    if (this.state === TWEEN_CONST.PAUSED) {
                        wasPaused = true;
                        this.state = TWEEN_CONST.ACTIVE;
                    }
                    this.isSeeking = true;
                    do this.update(0, delta);
                    while (this.totalProgress < toPosition);
                    this.isSeeking = false;
                    if (wasPaused) this.state = TWEEN_CONST.PAUSED;
                    return this;
                },
                /**
     * Sets an event based callback to be invoked during playback.
     *
     * Calling this method will replace a previously set callback for the given type, if any exists.
     *
     * The types available are:
     *
     * `onActive` When the Tween is moved from the pending to the active list in the Tween Manager, even if playback paused.
     * `onStart` When the Tween starts playing after a delayed state. Will happen at the same time as `onActive` if it has no delay.
     * `onYoyo` When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
     * `onRepeat` When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
     * `onComplete` When the Tween finishes playback fully or `Tween.stop` is called. Never invoked if tween is set to repeat infinitely.
     * `onUpdate` When a TweenData updates a property on a source target during playback.
     * `onLoop` When a Tween loops. This happens _after_ the `loopDelay` expires, if set.
     *
     * @method Phaser.Tweens.Tween#setCallback
     * @since 3.0.0
     *
     * @param {string} type - Type of the callback to set.
     * @param {function} callback - The function to invoke when this callback happens.
     * @param {array} [params] - An array of parameters for specified callbacks types.
     * @param {any} [scope] - The context the callback will be invoked in.
     *
     * @return {this} This Tween instance.
     */ setCallback: function(type, callback, params, scope) {
                    this.callbacks[type] = {
                        func: callback,
                        scope: scope,
                        params: params
                    };
                    return this;
                },
                /**
     * Flags the Tween as being complete, whatever stage of progress it is at.
     *
     * If an onComplete callback has been defined it will automatically invoke it, unless a `delay`
     * argument is provided, in which case the Tween will delay for that period of time before calling the callback.
     *
     * If you don't need a delay, or have an onComplete callback, then call `Tween.stop` instead.
     *
     * @method Phaser.Tweens.Tween#complete
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @since 3.2.0
     *
     * @param {number} [delay=0] - The time to wait before invoking the complete callback. If zero it will fire immediately.
     *
     * @return {this} This Tween instance.
     */ complete: function(delay) {
                    if (delay === undefined) delay = 0;
                    if (delay) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = delay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                    }
                    return this;
                },
                /**
     * Immediately removes this Tween from the TweenManager and all of its internal arrays,
     * no matter what stage it as it. Then sets the tween state to `REMOVED`.
     *
     * You should dispose of your reference to this tween after calling this method, to
     * free it from memory.
     *
     * @method Phaser.Tweens.Tween#remove
     * @since 3.17.0
     *
     * @return {this} This Tween instance.
     */ remove: function() {
                    this.parent.remove(this);
                    return this;
                },
                /**
     * Stops the Tween immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Tween#stop
     * @since 3.0.0
     *
     * @param {number} [resetTo] - If you want to seek the tween, provide a value between 0 and 1.
     *
     * @return {this} This Tween instance.
     */ stop: function(resetTo) {
                    if (this.state === TWEEN_CONST.ACTIVE) {
                        if (resetTo !== undefined) this.seek(resetTo);
                    }
                    if (this.state !== TWEEN_CONST.REMOVED) {
                        if (this.state === TWEEN_CONST.PAUSED || this.state === TWEEN_CONST.PENDING_ADD) {
                            if (this.parentIsTimeline) {
                                this.parent.manager._destroy.push(this);
                                this.parent.manager._toProcess++;
                            } else {
                                this.parent._destroy.push(this);
                                this.parent._toProcess++;
                            }
                        }
                        this.dispatchTweenEvent(Events.TWEEN_STOP, this.callbacks.onStop);
                        this.removeAllListeners();
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                    }
                    return this;
                },
                /**
     * Internal method that advances the Tween based on the time values.
     *
     * @method Phaser.Tweens.Tween#update
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @fires Phaser.Tweens.Events#TWEEN_START
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this Tween has finished and should be removed from the Tween Manager, otherwise returns `false`.
     */ update: function(timestamp, delta) {
                    if (this.state === TWEEN_CONST.PAUSED) return false;
                    if (this.useFrames) delta = 1 * this.parent.timeScale;
                    delta *= this.timeScale;
                    this.elapsed += delta;
                    this.progress = Math.min(this.elapsed / this.duration, 1);
                    this.totalElapsed += delta;
                    this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
                    switch(this.state){
                        case TWEEN_CONST.ACTIVE:
                            if (!this.hasStarted && !this.isSeeking) {
                                this.startDelay -= delta;
                                if (this.startDelay <= 0) {
                                    this.hasStarted = true;
                                    this.dispatchTweenEvent(Events.TWEEN_START, this.callbacks.onStart);
                                }
                            }
                            var stillRunning = false;
                            for(var i = 0; i < this.totalData; i++){
                                var tweenData = this.data[i];
                                if (this.updateTweenData(this, tweenData, delta)) stillRunning = true;
                            }
                            //  Anything still running? If not, we're done
                            if (!stillRunning) this.nextState();
                            break;
                        case TWEEN_CONST.LOOP_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.ACTIVE;
                                this.dispatchTweenEvent(Events.TWEEN_LOOP, this.callbacks.onLoop);
                            }
                            break;
                        case TWEEN_CONST.OFFSET_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) this.state = TWEEN_CONST.ACTIVE;
                            break;
                        case TWEEN_CONST.COMPLETE_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.PENDING_REMOVE;
                                this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                            }
                            break;
                    }
                    return this.state === TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Internal method that will emit a TweenData based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Tween#dispatchTweenDataEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData object that caused this event.
     */ dispatchTweenDataEvent: function(event, callback, tweenData) {
                    if (!this.isSeeking) {
                        this.emit(event, this, tweenData.key, tweenData.target, tweenData.current, tweenData.previous);
                        if (callback) {
                            callback.params[1] = tweenData.target;
                            callback.func.apply(callback.scope, callback.params);
                        }
                    }
                },
                /**
     * Internal method that will emit a Tween based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Tween#dispatchTweenEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchTweenEvent: function(event, callback) {
                    if (!this.isSeeking) {
                        this.emit(event, this, this.targets);
                        if (callback) {
                            callback.params[1] = this.targets;
                            callback.func.apply(callback.scope, callback.params);
                        }
                    }
                },
                /**
     * Internal method used as part of the playback process that sets a tween to play in reverse.
     *
     * @method Phaser.Tweens.Tween#setStateFromEnd
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @fires Phaser.Tweens.Events#TWEEN_YOYO
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     *
     * @return {number} The state of this Tween.
     */ setStateFromEnd: function(tween, tweenData, diff) {
                    if (tweenData.yoyo) {
                        //  We've hit the end of a Playing Forward TweenData and we have a yoyo
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        this.dispatchTweenDataEvent(Events.TWEEN_YOYO, tween.callbacks.onYoyo, tweenData);
                        tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        return TWEEN_CONST.PLAYING_BACKWARD;
                    } else if (tweenData.repeatCounter > 0) {
                        //  We've hit the end of a Playing Forward TweenData and we have a Repeat.
                        //  So we're going to go right back to the start to repeat it again.
                        tweenData.repeatCounter--;
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        //  Delay?
                        if (tweenData.repeatDelay > 0) {
                            tweenData.elapsed = tweenData.repeatDelay - diff;
                            tweenData.current = tweenData.start;
                            tweenData.target[tweenData.key] = tweenData.current;
                            return TWEEN_CONST.REPEAT_DELAY;
                        } else {
                            this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            return TWEEN_CONST.PLAYING_FORWARD;
                        }
                    }
                    return TWEEN_CONST.COMPLETE;
                },
                /**
     * Internal method used as part of the playback process that sets a tween to play from the start.
     *
     * @method Phaser.Tweens.Tween#setStateFromStart
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     *
     * @return {number} The state of this Tween.
     */ setStateFromStart: function(tween, tweenData, diff) {
                    if (tweenData.repeatCounter > 0) {
                        tweenData.repeatCounter--;
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        //  Delay?
                        if (tweenData.repeatDelay > 0) {
                            tweenData.elapsed = tweenData.repeatDelay - diff;
                            tweenData.current = tweenData.start;
                            tweenData.target[tweenData.key] = tweenData.current;
                            return TWEEN_CONST.REPEAT_DELAY;
                        } else {
                            this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            return TWEEN_CONST.PLAYING_FORWARD;
                        }
                    }
                    return TWEEN_CONST.COMPLETE;
                },
                /**
     * Internal method that advances the TweenData based on the time value given.
     *
     * @method Phaser.Tweens.Tween#updateTweenData
     * @fires Phaser.Tweens.Events#TWEEN_UPDATE
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} delta - Either a value in ms, or 1 if Tween.useFrames is true.
     *
     * @return {boolean} True if the tween is not complete (e.g., playing), or false if the tween is complete.
     */ updateTweenData: function(tween, tweenData, delta) {
                    var target = tweenData.target;
                    switch(tweenData.state){
                        case TWEEN_CONST.PLAYING_FORWARD:
                        case TWEEN_CONST.PLAYING_BACKWARD:
                            if (!target) {
                                tweenData.state = TWEEN_CONST.COMPLETE;
                                break;
                            }
                            var elapsed = tweenData.elapsed;
                            var duration = tweenData.duration;
                            var diff = 0;
                            elapsed += delta;
                            if (elapsed > duration) {
                                diff = elapsed - duration;
                                elapsed = duration;
                            }
                            var forward = tweenData.state === TWEEN_CONST.PLAYING_FORWARD;
                            var progress = elapsed / duration;
                            tweenData.elapsed = elapsed;
                            tweenData.progress = progress;
                            tweenData.previous = tweenData.current;
                            if (progress === 1) {
                                if (forward) {
                                    tweenData.current = tweenData.end;
                                    target[tweenData.key] = tweenData.end;
                                    if (tweenData.hold > 0) {
                                        tweenData.elapsed = tweenData.hold - diff;
                                        tweenData.state = TWEEN_CONST.HOLD_DELAY;
                                    } else tweenData.state = this.setStateFromEnd(tween, tweenData, diff);
                                } else {
                                    tweenData.current = tweenData.start;
                                    target[tweenData.key] = tweenData.start;
                                    tweenData.state = this.setStateFromStart(tween, tweenData, diff);
                                }
                            } else {
                                var v = forward ? tweenData.ease(progress) : tweenData.ease(1 - progress);
                                tweenData.current = tweenData.start + (tweenData.end - tweenData.start) * v;
                                target[tweenData.key] = tweenData.current;
                            }
                            this.dispatchTweenDataEvent(Events.TWEEN_UPDATE, tween.callbacks.onUpdate, tweenData);
                            break;
                        case TWEEN_CONST.DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) {
                                tweenData.elapsed = Math.abs(tweenData.elapsed);
                                tweenData.state = TWEEN_CONST.PENDING_RENDER;
                            }
                            break;
                        case TWEEN_CONST.REPEAT_DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) {
                                tweenData.elapsed = Math.abs(tweenData.elapsed);
                                tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                                this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            }
                            break;
                        case TWEEN_CONST.HOLD_DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) tweenData.state = this.setStateFromEnd(tween, tweenData, Math.abs(tweenData.elapsed));
                            break;
                        case TWEEN_CONST.PENDING_RENDER:
                            if (target) {
                                tweenData.start = tweenData.getStartValue(target, tweenData.key, target[tweenData.key], tweenData.index, tween.totalTargets, tween);
                                tweenData.end = tweenData.getEndValue(target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                                tweenData.current = tweenData.start;
                                target[tweenData.key] = tweenData.start;
                                tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                            } else tweenData.state = TWEEN_CONST.COMPLETE;
                            break;
                    }
                    //  Return TRUE if this TweenData still playing, otherwise return FALSE
                    return tweenData.state !== TWEEN_CONST.COMPLETE;
                }
            });
            //  onActive = 'active' event = When the Tween is moved from the pending to the active list in the manager, even if playback delayed
            //  onStart = 'start' event = When the Tween starts playing from a delayed state (will happen same time as onActive if no delay)
            //  onStop = 'stop' event = When the Tween is stopped
            //  onYoyo = 'yoyo' event = When the Tween starts a yoyo
            //  onRepeat = 'repeat' event = When a TweenData repeats playback (if any)
            //  onComplete = 'complete' event = When the Tween finishes all playback (can sometimes never happen if repeat -1), also when 'stop' called
            //  onUpdate = 'update' event = When the Tween updates a TweenData during playback (expensive!)
            //  onLoop = 'loop' event = Used to loop ALL TweenDatas in a Tween
            Tween.TYPES = [
                "onActive",
                "onComplete",
                "onLoop",
                "onRepeat",
                "onStart",
                "onStop",
                "onUpdate",
                "onYoyo"
            ];
            /**
 * Creates a new Tween object.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The Tween configuration.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectFactory.register("tween", function(config) {
                return this.scene.sys.tweens.add(config);
            });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /**
 * Creates a new Tween object and returns it.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The Tween configuration.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectCreator.register("tween", function(config) {
                return this.scene.sys.tweens.create(config);
            });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            module1.exports = Tween;
        /***/ },
        /* 267 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Events
 */ module1.exports = {
                TIMELINE_COMPLETE: __webpack_require__(1466),
                TIMELINE_LOOP: __webpack_require__(1467),
                TIMELINE_PAUSE: __webpack_require__(1468),
                TIMELINE_RESUME: __webpack_require__(1469),
                TIMELINE_START: __webpack_require__(1470),
                TIMELINE_UPDATE: __webpack_require__(1471),
                TWEEN_ACTIVE: __webpack_require__(1472),
                TWEEN_COMPLETE: __webpack_require__(1473),
                TWEEN_LOOP: __webpack_require__(1474),
                TWEEN_REPEAT: __webpack_require__(1475),
                TWEEN_START: __webpack_require__(1476),
                TWEEN_STOP: __webpack_require__(1477),
                TWEEN_UPDATE: __webpack_require__(1478),
                TWEEN_YOYO: __webpack_require__(1479)
            };
        /***/ },
        /* 268 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a TweenDataConfig object that describes the tween data for a unique property of a unique target.
 * A single Tween consists of multiple TweenDatas, depending on how many properties are being changed by the Tween.
 *
 * This is an internal function used by the TweenBuilder and should not be accessed directly, instead,
 * Tweens should be created using the GameObjectFactory or GameObjectCreator.
 *
 * @function Phaser.Tweens.TweenData
 * @since 3.0.0
 *
 * @param {any} target - The target to tween.
 * @param {number} index - The target index within the Tween targets array.
 * @param {string} key - The property of the target to tween.
 * @param {function} getEnd - What the property will be at the END of the Tween.
 * @param {function} getStart - What the property will be at the START of the Tween.
 * @param {?function} getActive - If not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * @param {function} ease - The ease function this tween uses.
 * @param {number} delay - Time in ms/frames before tween will start.
 * @param {number} duration - Duration of the tween in ms/frames.
 * @param {boolean} yoyo - Determines whether the tween should return back to its start value after hold has expired.
 * @param {number} hold - Time in ms/frames the tween will pause before repeating or returning to its starting value if yoyo is set to true.
 * @param {number} repeat - Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
 * @param {number} repeatDelay - Time in ms/frames before the repeat will start.
 * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
 * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
 *
 * @return {Phaser.Types.Tweens.TweenDataConfig} The config object describing this TweenData.
 */ var TweenData = function(target, index, key, getEnd, getStart, getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY) {
                return {
                    //  The target to tween
                    target: target,
                    //  The index of the target within the tween targets array
                    index: index,
                    //  The property of the target to tween
                    key: key,
                    //  What to set the property to the moment the TweenData is invoked.
                    getActiveValue: getActive,
                    //  The returned value sets what the property will be at the END of the Tween.
                    getEndValue: getEnd,
                    //  The returned value sets what the property will be at the START of the Tween.
                    getStartValue: getStart,
                    //  The ease function this tween uses.
                    ease: ease,
                    //  Duration of the tween in ms/frames, excludes time for yoyo or repeats.
                    duration: 0,
                    //  The total calculated duration of this TweenData (based on duration, repeat, delay and yoyo)
                    totalDuration: 0,
                    //  Time in ms/frames before tween will start.
                    delay: 0,
                    //  Cause the tween to return back to its start value after hold has expired.
                    yoyo: yoyo,
                    //  Time in ms/frames the tween will pause before running the yoyo or starting a repeat.
                    hold: 0,
                    //  Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
                    repeat: 0,
                    //  Time in ms/frames before the repeat will start.
                    repeatDelay: 0,
                    //  Automatically call toggleFlipX when the TweenData yoyos or repeats
                    flipX: flipX,
                    //  Automatically call toggleFlipY when the TweenData yoyos or repeats
                    flipY: flipY,
                    //  Between 0 and 1 showing completion of this TweenData.
                    progress: 0,
                    //  Delta counter.
                    elapsed: 0,
                    //  How many repeats are left to run?
                    repeatCounter: 0,
                    //  Ease Value Data:
                    start: 0,
                    previous: 0,
                    current: 0,
                    end: 0,
                    //  Time Durations
                    t1: 0,
                    t2: 0,
                    //  LoadValue generation functions
                    gen: {
                        delay: delay,
                        duration: duration,
                        hold: hold,
                        repeat: repeat,
                        repeatDelay: repeatDelay
                    },
                    //  TWEEN_CONST.CREATED
                    state: 0
                };
            };
            module1.exports = TweenData;
        /***/ },
        /* 269 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathWrap = __webpack_require__(68);
            /**
 * Wrap an angle.
 *
 * Wraps the angle to a value in the range of -PI to PI.
 *
 * @function Phaser.Math.Angle.Wrap
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in radians.
 *
 * @return {number} The wrapped angle, in radians.
 */ var Wrap = function(angle) {
                return MathWrap(angle, -Math.PI, Math.PI);
            };
            module1.exports = Wrap;
        /***/ },
        /* 270 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(68);
            /**
 * Wrap an angle in degrees.
 *
 * Wraps the angle to a value in the range of -180 to 180.
 *
 * @function Phaser.Math.Angle.WrapDegrees
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in degrees.
 *
 * @return {number} The wrapped angle, in degrees.
 */ var WrapDegrees = function(angle) {
                return Wrap(angle, -180, 180);
            };
            module1.exports = WrapDegrees;
        /***/ },
        /* 271 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
*
* @class Axes
*/ var Axes = {};
            module1.exports = Axes;
            var Vector = __webpack_require__(83);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Creates a new set of axes from the given vertices.
     * @method fromVertices
     * @param {vertices} vertices
     * @return {axes} A new axes from the given vertices
     */ Axes.fromVertices = function(vertices) {
                    var axes = {};
                    // find the unique axes, using edge normal gradients
                    for(var i = 0; i < vertices.length; i++){
                        var j = (i + 1) % vertices.length, normal = Vector.normalise({
                            x: vertices[j].y - vertices[i].y,
                            y: vertices[i].x - vertices[j].x
                        }), gradient = normal.y === 0 ? Infinity : normal.x / normal.y;
                        // limit precision
                        gradient = gradient.toFixed(3).toString();
                        axes[gradient] = normal;
                    }
                    return Common.values(axes);
                };
                /**
     * Rotates a set of axes by the given angle.
     * @method rotate
     * @param {axes} axes
     * @param {number} angle
     */ Axes.rotate = function(axes, angle) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < axes.length; i++){
                        var axis = axes[i], xx;
                        xx = axis.x * cos - axis.y * sin;
                        axis.y = axis.x * sin + axis.y * cos;
                        axis.x = xx;
                    }
                };
            })();
        /***/ },
        /* 272 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Events
 */ module1.exports = {
                AFTER_ADD: __webpack_require__(1504),
                AFTER_REMOVE: __webpack_require__(1505),
                AFTER_UPDATE: __webpack_require__(1506),
                BEFORE_ADD: __webpack_require__(1507),
                BEFORE_REMOVE: __webpack_require__(1508),
                BEFORE_UPDATE: __webpack_require__(1509),
                COLLISION_ACTIVE: __webpack_require__(1510),
                COLLISION_END: __webpack_require__(1511),
                COLLISION_START: __webpack_require__(1512),
                DRAG_END: __webpack_require__(1513),
                DRAG: __webpack_require__(1514),
                DRAG_START: __webpack_require__(1515),
                PAUSE: __webpack_require__(1516),
                RESUME: __webpack_require__(1517),
                SLEEP_END: __webpack_require__(1518),
                SLEEP_START: __webpack_require__(1519)
            };
        /***/ },
        /* 273 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
*
* @class Detector
*/ // TODO: speculative contacts
            var Detector = {};
            module1.exports = Detector;
            var SAT = __webpack_require__(274);
            var Pair = __webpack_require__(250);
            var Bounds = __webpack_require__(84);
            (function() {
                /**
     * Finds all collisions given a list of pairs.
     * @method collisions
     * @param {pair[]} broadphasePairs
     * @param {engine} engine
     * @return {array} collisions
     */ Detector.collisions = function(broadphasePairs, engine) {
                    var collisions = [], pairsTable = engine.pairs.table;
                    // @if DEBUG
                    var metrics = engine.metrics;
                    // @endif
                    for(var i = 0; i < broadphasePairs.length; i++){
                        var bodyA = broadphasePairs[i][0], bodyB = broadphasePairs[i][1];
                        if ((bodyA.isStatic || bodyA.isSleeping) && (bodyB.isStatic || bodyB.isSleeping)) continue;
                        if (!Detector.canCollide(bodyA.collisionFilter, bodyB.collisionFilter)) continue;
                        // @if DEBUG
                        metrics.midphaseTests += 1;
                        // @endif
                        // mid phase
                        if (Bounds.overlaps(bodyA.bounds, bodyB.bounds)) for(var j = bodyA.parts.length > 1 ? 1 : 0; j < bodyA.parts.length; j++){
                            var partA = bodyA.parts[j];
                            for(var k = bodyB.parts.length > 1 ? 1 : 0; k < bodyB.parts.length; k++){
                                var partB = bodyB.parts[k];
                                if (partA === bodyA && partB === bodyB || Bounds.overlaps(partA.bounds, partB.bounds)) {
                                    // find a previous collision we could reuse
                                    var pairId = Pair.id(partA, partB), pair = pairsTable[pairId], previousCollision;
                                    if (pair && pair.isActive) previousCollision = pair.collision;
                                    else previousCollision = null;
                                    // narrow phase
                                    var collision = SAT.collides(partA, partB, previousCollision);
                                    // @if DEBUG
                                    metrics.narrowphaseTests += 1;
                                    if (collision.reused) metrics.narrowReuseCount += 1;
                                    // @endif
                                    if (collision.collided) {
                                        collisions.push(collision);
                                        // @if DEBUG
                                        metrics.narrowDetections += 1;
                                    // @endif
                                    }
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Returns `true` if both supplied collision filters will allow a collision to occur.
     * See `body.collisionFilter` for more information.
     * @method canCollide
     * @param {} filterA
     * @param {} filterB
     * @return {bool} `true` if collision can occur
     */ Detector.canCollide = function(filterA, filterB) {
                    if (filterA.group === filterB.group && filterA.group !== 0) return filterA.group > 0;
                    return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
                };
            })();
        /***/ },
        /* 274 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
*
* @class SAT
*/ // TODO: true circles and curves
            var SAT = {};
            module1.exports = SAT;
            var Vertices = __webpack_require__(64);
            var Vector = __webpack_require__(83);
            (function() {
                /**
     * Detect collision between two bodies using the Separating Axis Theorem.
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {collision} previousCollision
     * @return {collision} collision
     */ SAT.collides = function(bodyA, bodyB, previousCollision) {
                    var overlapAB, overlapBA, minOverlap, collision, canReusePrevCol = false;
                    if (previousCollision) {
                        // estimate total motion
                        var parentA = bodyA.parent, parentB = bodyB.parent, motion = parentA.speed * parentA.speed + parentA.angularSpeed * parentA.angularSpeed + parentB.speed * parentB.speed + parentB.angularSpeed * parentB.angularSpeed;
                        // we may be able to (partially) reuse collision result 
                        // but only safe if collision was resting
                        canReusePrevCol = previousCollision && previousCollision.collided && motion < 0.2;
                        // reuse collision object
                        collision = previousCollision;
                    } else collision = {
                        collided: false,
                        bodyA: bodyA,
                        bodyB: bodyB
                    };
                    if (previousCollision && canReusePrevCol) {
                        // if we can reuse the collision result
                        // we only need to test the previously found axis
                        var axisBodyA = collision.axisBody, axisBodyB = axisBodyA === bodyA ? bodyB : bodyA, axes = [
                            axisBodyA.axes[previousCollision.axisNumber]
                        ];
                        minOverlap = SAT._overlapAxes(axisBodyA.vertices, axisBodyB.vertices, axes);
                        collision.reused = true;
                        if (minOverlap.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                    } else {
                        // if we can't reuse a result, perform a full SAT test
                        overlapAB = SAT._overlapAxes(bodyA.vertices, bodyB.vertices, bodyA.axes);
                        if (overlapAB.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                        overlapBA = SAT._overlapAxes(bodyB.vertices, bodyA.vertices, bodyB.axes);
                        if (overlapBA.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                        if (overlapAB.overlap < overlapBA.overlap) {
                            minOverlap = overlapAB;
                            collision.axisBody = bodyA;
                        } else {
                            minOverlap = overlapBA;
                            collision.axisBody = bodyB;
                        }
                        // important for reuse later
                        collision.axisNumber = minOverlap.axisNumber;
                    }
                    collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
                    collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
                    collision.collided = true;
                    collision.depth = minOverlap.overlap;
                    collision.parentA = collision.bodyA.parent;
                    collision.parentB = collision.bodyB.parent;
                    bodyA = collision.bodyA;
                    bodyB = collision.bodyB;
                    // ensure normal is facing away from bodyA
                    if (Vector.dot(minOverlap.axis, Vector.sub(bodyB.position, bodyA.position)) < 0) collision.normal = {
                        x: minOverlap.axis.x,
                        y: minOverlap.axis.y
                    };
                    else collision.normal = {
                        x: -minOverlap.axis.x,
                        y: -minOverlap.axis.y
                    };
                    collision.tangent = Vector.perp(collision.normal);
                    collision.penetration = collision.penetration || {};
                    collision.penetration.x = collision.normal.x * collision.depth;
                    collision.penetration.y = collision.normal.y * collision.depth;
                    // find support points, there is always either exactly one or two
                    var verticesB = SAT._findSupports(bodyA, bodyB, collision.normal), supports = [];
                    // find the supports from bodyB that are inside bodyA
                    if (Vertices.contains(bodyA.vertices, verticesB[0])) supports.push(verticesB[0]);
                    if (Vertices.contains(bodyA.vertices, verticesB[1])) supports.push(verticesB[1]);
                    // find the supports from bodyA that are inside bodyB
                    if (supports.length < 2) {
                        var verticesA = SAT._findSupports(bodyB, bodyA, Vector.neg(collision.normal));
                        if (Vertices.contains(bodyB.vertices, verticesA[0])) supports.push(verticesA[0]);
                        if (supports.length < 2 && Vertices.contains(bodyB.vertices, verticesA[1])) supports.push(verticesA[1]);
                    }
                    // account for the edge case of overlapping but no vertex containment
                    if (supports.length < 1) supports = [
                        verticesB[0]
                    ];
                    collision.supports = supports;
                    return collision;
                };
                /**
     * Find the overlap between two sets of vertices.
     * @method _overlapAxes
     * @private
     * @param {} verticesA
     * @param {} verticesB
     * @param {} axes
     * @return result
     */ SAT._overlapAxes = function(verticesA, verticesB, axes) {
                    var projectionA = Vector._temp[0], projectionB = Vector._temp[1], result = {
                        overlap: Number.MAX_VALUE
                    }, overlap, axis;
                    for(var i = 0; i < axes.length; i++){
                        axis = axes[i];
                        SAT._projectToAxis(projectionA, verticesA, axis);
                        SAT._projectToAxis(projectionB, verticesB, axis);
                        overlap = Math.min(projectionA.max - projectionB.min, projectionB.max - projectionA.min);
                        if (overlap <= 0) {
                            result.overlap = overlap;
                            return result;
                        }
                        if (overlap < result.overlap) {
                            result.overlap = overlap;
                            result.axis = axis;
                            result.axisNumber = i;
                        }
                    }
                    return result;
                };
                /**
     * Projects vertices on an axis and returns an interval.
     * @method _projectToAxis
     * @private
     * @param {} projection
     * @param {} vertices
     * @param {} axis
     */ SAT._projectToAxis = function(projection, vertices, axis) {
                    var min = Vector.dot(vertices[0], axis), max = min;
                    for(var i = 1; i < vertices.length; i += 1){
                        var dot = Vector.dot(vertices[i], axis);
                        if (dot > max) max = dot;
                        else if (dot < min) min = dot;
                    }
                    projection.min = min;
                    projection.max = max;
                };
                /**
     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
     * @method _findSupports
     * @private
     * @param {} bodyA
     * @param {} bodyB
     * @param {} normal
     * @return [vector]
     */ SAT._findSupports = function(bodyA, bodyB, normal) {
                    var nearestDistance = Number.MAX_VALUE, vertexToBody = Vector._temp[0], vertices = bodyB.vertices, bodyAPosition = bodyA.position, distance, vertex, vertexA, vertexB;
                    // find closest vertex on bodyB
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        vertexToBody.x = vertex.x - bodyAPosition.x;
                        vertexToBody.y = vertex.y - bodyAPosition.y;
                        distance = -Vector.dot(normal, vertexToBody);
                        if (distance < nearestDistance) {
                            nearestDistance = distance;
                            vertexA = vertex;
                        }
                    }
                    // find next closest vertex using the two connected to it
                    var prevIndex = vertexA.index - 1 >= 0 ? vertexA.index - 1 : vertices.length - 1;
                    vertex = vertices[prevIndex];
                    vertexToBody.x = vertex.x - bodyAPosition.x;
                    vertexToBody.y = vertex.y - bodyAPosition.y;
                    nearestDistance = -Vector.dot(normal, vertexToBody);
                    vertexB = vertex;
                    var nextIndex = (vertexA.index + 1) % vertices.length;
                    vertex = vertices[nextIndex];
                    vertexToBody.x = vertex.x - bodyAPosition.x;
                    vertexToBody.y = vertex.y - bodyAPosition.y;
                    distance = -Vector.dot(normal, vertexToBody);
                    if (distance < nearestDistance) vertexB = vertex;
                    return [
                        vertexA,
                        vertexB
                    ];
                };
            })();
        /***/ },
        /* 275 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Actions
 */ module1.exports = {
                AlignTo: __webpack_require__(601),
                Angle: __webpack_require__(602),
                Call: __webpack_require__(603),
                GetFirst: __webpack_require__(604),
                GetLast: __webpack_require__(605),
                GridAlign: __webpack_require__(606),
                IncAlpha: __webpack_require__(678),
                IncX: __webpack_require__(679),
                IncXY: __webpack_require__(680),
                IncY: __webpack_require__(681),
                PlaceOnCircle: __webpack_require__(682),
                PlaceOnEllipse: __webpack_require__(683),
                PlaceOnLine: __webpack_require__(684),
                PlaceOnRectangle: __webpack_require__(685),
                PlaceOnTriangle: __webpack_require__(686),
                PlayAnimation: __webpack_require__(687),
                PropertyValueInc: __webpack_require__(46),
                PropertyValueSet: __webpack_require__(27),
                RandomCircle: __webpack_require__(688),
                RandomEllipse: __webpack_require__(689),
                RandomLine: __webpack_require__(690),
                RandomRectangle: __webpack_require__(691),
                RandomTriangle: __webpack_require__(692),
                Rotate: __webpack_require__(693),
                RotateAround: __webpack_require__(694),
                RotateAroundDistance: __webpack_require__(695),
                ScaleX: __webpack_require__(696),
                ScaleXY: __webpack_require__(697),
                ScaleY: __webpack_require__(698),
                SetAlpha: __webpack_require__(699),
                SetBlendMode: __webpack_require__(700),
                SetDepth: __webpack_require__(701),
                SetHitArea: __webpack_require__(702),
                SetOrigin: __webpack_require__(703),
                SetRotation: __webpack_require__(704),
                SetScale: __webpack_require__(705),
                SetScaleX: __webpack_require__(706),
                SetScaleY: __webpack_require__(707),
                SetScrollFactor: __webpack_require__(708),
                SetScrollFactorX: __webpack_require__(709),
                SetScrollFactorY: __webpack_require__(710),
                SetTint: __webpack_require__(711),
                SetVisible: __webpack_require__(712),
                SetX: __webpack_require__(713),
                SetXY: __webpack_require__(714),
                SetY: __webpack_require__(715),
                ShiftPosition: __webpack_require__(716),
                Shuffle: __webpack_require__(717),
                SmootherStep: __webpack_require__(718),
                SmoothStep: __webpack_require__(719),
                Spread: __webpack_require__(720),
                ToggleVisible: __webpack_require__(721),
                WrapInRectangle: __webpack_require__(722)
            };
        /***/ },
        /* 276 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(123);
            var AlignToMap = [];
            AlignToMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(277);
            AlignToMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(278);
            AlignToMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(279);
            AlignToMap[ALIGN_CONST.LEFT_BOTTOM] = __webpack_require__(280);
            AlignToMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(281);
            AlignToMap[ALIGN_CONST.LEFT_TOP] = __webpack_require__(282);
            AlignToMap[ALIGN_CONST.RIGHT_BOTTOM] = __webpack_require__(283);
            AlignToMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(284);
            AlignToMap[ALIGN_CONST.RIGHT_TOP] = __webpack_require__(285);
            AlignToMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(286);
            AlignToMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(287);
            AlignToMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(288);
            /**
 * Takes a Game Object and aligns it next to another, at the given position.
 * The alignment used is based on the `position` argument, which is a `Phaser.Display.Align` property such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.To.QuickSet
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignTo, position, offsetX, offsetY) {
                return AlignToMap[position](child, alignTo, offsetX, offsetY);
            };
            module1.exports = QuickSet;
        /***/ },
        /* 277 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetCenterX = __webpack_require__(87);
            var SetCenterX = __webpack_require__(88);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom center position of the other.
 *
 * @function Phaser.Display.Align.To.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomCenter;
        /***/ },
        /* 278 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetLeft = __webpack_require__(43);
            var SetLeft = __webpack_require__(53);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom left position of the other.
 *
 * @function Phaser.Display.Align.To.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomLeft;
        /***/ },
        /* 279 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetRight = __webpack_require__(44);
            var SetRight = __webpack_require__(54);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom right position of the other.
 *
 * @function Phaser.Display.Align.To.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignTo) + offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomRight;
        /***/ },
        /* 280 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetLeft = __webpack_require__(43);
            var SetBottom = __webpack_require__(55);
            var SetRight = __webpack_require__(54);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left bottom position of the other.
 *
 * @function Phaser.Display.Align.To.LeftBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftBottom = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = LeftBottom;
        /***/ },
        /* 281 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(89);
            var GetLeft = __webpack_require__(43);
            var SetCenterY = __webpack_require__(90);
            var SetRight = __webpack_require__(54);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left center position of the other.
 *
 * @function Phaser.Display.Align.To.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = LeftCenter;
        /***/ },
        /* 282 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(43);
            var GetTop = __webpack_require__(45);
            var SetRight = __webpack_require__(54);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left top position of the other.
 *
 * @function Phaser.Display.Align.To.LeftTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftTop = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetTop(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = LeftTop;
        /***/ },
        /* 283 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetRight = __webpack_require__(44);
            var SetBottom = __webpack_require__(55);
            var SetLeft = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right bottom position of the other.
 *
 * @function Phaser.Display.Align.To.RightBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightBottom = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = RightBottom;
        /***/ },
        /* 284 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(89);
            var GetRight = __webpack_require__(44);
            var SetCenterY = __webpack_require__(90);
            var SetLeft = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right center position of the other.
 *
 * @function Phaser.Display.Align.To.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = RightCenter;
        /***/ },
        /* 285 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(44);
            var GetTop = __webpack_require__(45);
            var SetLeft = __webpack_require__(53);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right top position of the other.
 *
 * @function Phaser.Display.Align.To.RightTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightTop = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetTop(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = RightTop;
        /***/ },
        /* 286 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(87);
            var GetTop = __webpack_require__(45);
            var SetBottom = __webpack_require__(55);
            var SetCenterX = __webpack_require__(88);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top center position of the other.
 *
 * @function Phaser.Display.Align.To.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopCenter;
        /***/ },
        /* 287 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(43);
            var GetTop = __webpack_require__(45);
            var SetBottom = __webpack_require__(55);
            var SetLeft = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top left position of the other.
 *
 * @function Phaser.Display.Align.To.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopLeft;
        /***/ },
        /* 288 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(44);
            var GetTop = __webpack_require__(45);
            var SetBottom = __webpack_require__(55);
            var SetRight = __webpack_require__(54);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top right position of the other.
 *
 * @function Phaser.Display.Align.To.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignTo) + offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopRight;
        /***/ },
        /* 289 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(123);
            var AlignInMap = [];
            AlignInMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(290);
            AlignInMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(291);
            AlignInMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(292);
            AlignInMap[ALIGN_CONST.CENTER] = __webpack_require__(293);
            AlignInMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(295);
            AlignInMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(296);
            AlignInMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(297);
            AlignInMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(298);
            AlignInMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(299);
            AlignInMap[ALIGN_CONST.LEFT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_LEFT];
            AlignInMap[ALIGN_CONST.LEFT_TOP] = AlignInMap[ALIGN_CONST.TOP_LEFT];
            AlignInMap[ALIGN_CONST.RIGHT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_RIGHT];
            AlignInMap[ALIGN_CONST.RIGHT_TOP] = AlignInMap[ALIGN_CONST.TOP_RIGHT];
            /**
 * Takes given Game Object and aligns it so that it is positioned relative to the other.
 * The alignment used is based on the `position` argument, which is an `ALIGN_CONST` value, such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.In.QuickSet
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `ALIGN_CONST.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignIn, position, offsetX, offsetY) {
                return AlignInMap[position](child, alignIn, offsetX, offsetY);
            };
            module1.exports = QuickSet;
        /***/ },
        /* 290 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetCenterX = __webpack_require__(87);
            var SetBottom = __webpack_require__(55);
            var SetCenterX = __webpack_require__(88);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom center of the other.
 *
 * @function Phaser.Display.Align.In.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomCenter;
        /***/ },
        /* 291 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetLeft = __webpack_require__(43);
            var SetBottom = __webpack_require__(55);
            var SetLeft = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom left of the other.
 *
 * @function Phaser.Display.Align.In.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomLeft;
        /***/ },
        /* 292 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetRight = __webpack_require__(44);
            var SetBottom = __webpack_require__(55);
            var SetRight = __webpack_require__(54);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom right of the other.
 *
 * @function Phaser.Display.Align.In.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomRight;
        /***/ },
        /* 293 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(294);
            var GetCenterX = __webpack_require__(87);
            var GetCenterY = __webpack_require__(89);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the center of the other.
 *
 * @function Phaser.Display.Align.In.Center
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var Center = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                CenterOn(gameObject, GetCenterX(alignIn) + offsetX, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = Center;
        /***/ },
        /* 294 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetCenterX = __webpack_require__(88);
            var SetCenterY = __webpack_require__(90);
            /**
 * Positions the Game Object so that it is centered on the given coordinates.
 *
 * @function Phaser.Display.Bounds.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The horizontal coordinate to position the Game Object on.
 * @param {number} y - The vertical coordinate to position the Game Object on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var CenterOn = function(gameObject, x, y) {
                SetCenterX(gameObject, x);
                return SetCenterY(gameObject, y);
            };
            module1.exports = CenterOn;
        /***/ },
        /* 295 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(89);
            var GetLeft = __webpack_require__(43);
            var SetCenterY = __webpack_require__(90);
            var SetLeft = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the left center of the other.
 *
 * @function Phaser.Display.Align.In.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = LeftCenter;
        /***/ },
        /* 296 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(89);
            var GetRight = __webpack_require__(44);
            var SetCenterY = __webpack_require__(90);
            var SetRight = __webpack_require__(54);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the right center of the other.
 *
 * @function Phaser.Display.Align.In.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = RightCenter;
        /***/ },
        /* 297 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(87);
            var GetTop = __webpack_require__(45);
            var SetCenterX = __webpack_require__(88);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top center of the other.
 *
 * @function Phaser.Display.Align.In.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopCenter;
        /***/ },
        /* 298 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(43);
            var GetTop = __webpack_require__(45);
            var SetLeft = __webpack_require__(53);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top left of the other.
 *
 * @function Phaser.Display.Align.In.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopLeft;
        /***/ },
        /* 299 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(44);
            var GetTop = __webpack_require__(45);
            var SetRight = __webpack_require__(54);
            var SetTop = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top right of the other.
 *
 * @function Phaser.Display.Align.In.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopRight;
        /***/ },
        /* 300 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(169);
            var FromPercent = __webpack_require__(98);
            var MATH_CONST = __webpack_require__(14);
            var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Circle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
 */ var GetPoint = function(circle, position, out) {
                if (out === undefined) out = new Point();
                var angle = FromPercent(position, 0, MATH_CONST.PI2);
                return CircumferencePoint(circle, angle, out);
            };
            module1.exports = GetPoint;
        /***/ },
        /* 301 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(302);
            var CircumferencePoint = __webpack_require__(169);
            var FromPercent = __webpack_require__(98);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Circle.GetPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the circumference of the circle.
 */ var GetPoints = function(circle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Circumference(circle) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                    out.push(CircumferencePoint(circle, angle));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 302 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Circle.
 *
 * @function Phaser.Geom.Circle.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference of.
 *
 * @return {number} The circumference of the Circle.
 */ var Circumference = function(circle) {
                return 2 * (Math.PI * circle.radius);
            };
            module1.exports = Circumference;
        /***/ },
        /* 303 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 2; // 0010
            /**
 * Provides methods used for setting the alpha property of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.AlphaSingle
 * @since 3.22.0
 */ var AlphaSingle = {
                /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                    return this.setAlpha(1);
                },
                /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#setAlpha
     * @since 3.0.0
     *
     * @param {number} [value=1] - The alpha value applied across the whole Game Object.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(value) {
                    if (value === undefined) value = 1;
                    this.alpha = value;
                    return this;
                },
                /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alpha = v;
                        if (v === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                }
            };
            module1.exports = AlphaSingle;
        /***/ },
        /* 304 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            /**
 * Provides methods used for setting the blend mode of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.BlendMode
 * @since 3.0.0
 */ var BlendMode = {
                /**
     * Private internal value. Holds the current blend mode.
     * 
     * @name Phaser.GameObjects.Components.BlendMode#_blendMode
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _blendMode: BlendModes.NORMAL,
                /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency of which blend modes
     * are used.
     *
     * @name Phaser.GameObjects.Components.BlendMode#blendMode
     * @type {(Phaser.BlendModes|string)}
     * @since 3.0.0
     */ blendMode: {
                    get: function() {
                        return this._blendMode;
                    },
                    set: function(value) {
                        if (typeof value === "string") value = BlendModes[value];
                        value |= 0;
                        if (value >= -1) this._blendMode = value;
                    }
                },
                /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE (only works when rendering to a framebuffer, like a Render Texture)
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency in which blend modes
     * are used.
     *
     * @method Phaser.GameObjects.Components.BlendMode#setBlendMode
     * @since 3.0.0
     *
     * @param {(string|Phaser.BlendModes)} value - The BlendMode value. Either a string or a CONST.
     *
     * @return {this} This Game Object instance.
     */ setBlendMode: function(value) {
                    this.blendMode = value;
                    return this;
                }
            };
            module1.exports = BlendMode;
        /***/ },
        /* 305 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the depth of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Depth
 * @since 3.0.0
 */ var Depth = {
                /**
     * Private internal value. Holds the depth of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Depth#_depth
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _depth: 0,
                /**
     * The depth of this Game Object within the Scene.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @name Phaser.GameObjects.Components.Depth#depth
     * @type {number}
     * @since 3.0.0
     */ depth: {
                    get: function() {
                        return this._depth;
                    },
                    set: function(value) {
                        if (this.displayList) this.displayList.queueDepthSort();
                        this._depth = value;
                    }
                },
                /**
     * The depth of this Game Object within the Scene.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @method Phaser.GameObjects.Components.Depth#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The depth of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setDepth: function(value) {
                    if (value === undefined) value = 0;
                    this.depth = value;
                    return this;
                }
            };
            module1.exports = Depth;
        /***/ },
        /* 306 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoint = __webpack_require__(171);
            var Perimeter = __webpack_require__(130);
            //  Return an array of points from the perimeter of the rectangle
            //  each spaced out based on the quantity or step required
            /**
 * Return an array of points from the perimeter of the rectangle, each spaced out based on the quantity or step required.
 *
 * @function Phaser.Geom.Rectangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle object to get the points from.
 * @param {number} step - Step between points. Used to calculate the number of points to return when quantity is falsey. Ignored if quantity is positive.
 * @param {number} quantity - The number of evenly spaced points from the rectangles perimeter to return. If falsey, step param will be used to calculate the number of points.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array to store the points in.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points from the perimeter of the rectangle.
 */ var GetPoints = function(rectangle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Perimeter(rectangle) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var position = i / quantity;
                    out.push(GetPoint(rectangle, position));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 307 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get a point on a line that's a given percentage along its length.
 *
 * @function Phaser.Geom.Line.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The point on the line.
 */ var GetPoint = function(line, position, out) {
                if (out === undefined) out = new Point();
                out.x = line.x1 + (line.x2 - line.x1) * position;
                out.y = line.y1 + (line.y2 - line.y1) * position;
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 308 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` to the given `angle`, at the same distance.
 *
 * In polar notation, this maps a point from (r, t) to (r, angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAround
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAround = function(point, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = point.x - x;
                var ty = point.y - y;
                point.x = tx * c - ty * s + x;
                point.y = tx * s + ty * c + y;
                return point;
            };
            module1.exports = RotateAround;
        /***/ },
        /* 309 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapMask = __webpack_require__(310);
            var GeometryMask = __webpack_require__(311);
            /**
 * Provides methods used for getting and setting the mask of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Mask
 * @since 3.0.0
 */ var Mask = {
                /**
     * The Mask this Game Object is using during render.
     *
     * @name Phaser.GameObjects.Components.Mask#mask
     * @type {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask}
     * @since 3.0.0
     */ mask: null,
                /**
     * Sets the mask that this Game Object will use to render with.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Game Object it will be immediately replaced.
     *
     * Masks are positioned in global space and are not relative to the Game Object to which they
     * are applied. The reason for this is that multiple Game Objects can all share the same mask.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.GameObjects.Components.Mask#setMask
     * @since 3.6.2
     *
     * @param {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask} mask - The mask this Game Object will use when rendering.
     *
     * @return {this} This Game Object instance.
     */ setMask: function(mask) {
                    this.mask = mask;
                    return this;
                },
                /**
     * Clears the mask that this Game Object was using.
     *
     * @method Phaser.GameObjects.Components.Mask#clearMask
     * @since 3.6.2
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Game Object instance.
     */ clearMask: function(destroyMask) {
                    if (destroyMask === undefined) destroyMask = false;
                    if (destroyMask && this.mask) this.mask.destroy();
                    this.mask = null;
                    return this;
                },
                /**
     * Creates and returns a Bitmap Mask. This mask can be used by any Game Object,
     * including this one.
     *
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * To create the mask you need to pass in a reference to a renderable Game Object.
     * A renderable Game Object is one that uses a texture to render with, such as an
     * Image, Sprite, Render Texture or BitmapText.
     *
     * If you do not provide a renderable object, and this Game Object has a texture,
     * it will use itself as the object. This means you can call this method to create
     * a Bitmap Mask from any renderable Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createBitmapMask
     * @since 3.6.2
     *
     * @param {Phaser.GameObjects.GameObject} [renderable] - A renderable Game Object that uses a texture, such as a Sprite.
     *
     * @return {Phaser.Display.Masks.BitmapMask} This Bitmap Mask that was created.
     */ createBitmapMask: function(renderable) {
                    if (renderable === undefined && (this.texture || this.shader)) // eslint-disable-next-line consistent-this
                    renderable = this;
                    return new BitmapMask(this.scene, renderable);
                },
                /**
     * Creates and returns a Geometry Mask. This mask can be used by any Game Object,
     * including this one.
     *
     * To create the mask you need to pass in a reference to a Graphics Game Object.
     *
     * If you do not provide a graphics object, and this Game Object is an instance
     * of a Graphics object, then it will use itself to create the mask.
     *
     * This means you can call this method to create a Geometry Mask from any Graphics Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createGeometryMask
     * @since 3.6.2
     *
     * @param {Phaser.GameObjects.Graphics} [graphics] - A Graphics Game Object. The geometry within it will be used as the mask.
     *
     * @return {Phaser.Display.Masks.GeometryMask} This Geometry Mask that was created.
     */ createGeometryMask: function(graphics) {
                    if (graphics === undefined && this.type === "Graphics") // eslint-disable-next-line consistent-this
                    graphics = this;
                    return new GeometryMask(this.scene, graphics);
                }
            };
            module1.exports = Mask;
        /***/ },
        /* 310 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var RenderEvents = __webpack_require__(91);
            /**
 * @classdesc
 * A Bitmap Mask combines the alpha (opacity) of a masked pixel with the alpha of another pixel.
 * Unlike the Geometry Mask, which is a clipping path, a Bitmap Mask behaves like an alpha mask,
 * not a clipping path. It is only available when using the WebGL Renderer.
 *
 * A Bitmap Mask can use any Game Object to determine the alpha of each pixel of the masked Game Object(s).
 * For any given point of a masked Game Object's texture, the pixel's alpha will be multiplied by the alpha
 * of the pixel at the same position in the Bitmap Mask's Game Object. The color of the pixel from the
 * Bitmap Mask doesn't matter.
 *
 * For example, if a pure blue pixel with an alpha of 0.95 is masked with a pure red pixel with an
 * alpha of 0.5, the resulting pixel will be pure blue with an alpha of 0.475. Naturally, this means
 * that a pixel in the mask with an alpha of 0 will hide the corresponding pixel in all masked Game Objects
 *  A pixel with an alpha of 1 in the masked Game Object will receive the same alpha as the
 * corresponding pixel in the mask.
 *
 * Note: You cannot combine Bitmap Masks and Blend Modes on the same Game Object. You can, however,
 * combine Geometry Masks and Blend Modes together.
 *
 * The Bitmap Mask's location matches the location of its Game Object, not the location of the
 * masked objects. Moving or transforming the underlying Game Object will change the mask
 * (and affect the visibility of any masked objects), whereas moving or transforming a masked object
 * will not affect the mask.
 *
 * The Bitmap Mask will not render its Game Object by itself. If the Game Object is not in a
 * Scene's display list, it will only be used for the mask and its full texture will not be directly
 * visible. Adding the underlying Game Object to a Scene will not cause any problems - it will
 * render as a normal Game Object and will also serve as a mask.
 *
 * @class BitmapMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which this Bitmap Mask will be used in.
 * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
 */ var BitmapMask = new Class({
                initialize: function BitmapMask(scene, renderable) {
                    var renderer = scene.sys.renderer;
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Mask is using.
         *
         * @name Phaser.Display.Masks.BitmapMask#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.11.0
         */ this.renderer = renderer;
                    /**
         * A renderable Game Object that uses a texture, such as a Sprite.
         *
         * @name Phaser.Display.Masks.BitmapMask#bitmapMask
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.bitmapMask = renderable;
                    /**
         * The texture used for the masks framebuffer.
         *
         * @name Phaser.Display.Masks.BitmapMask#maskTexture
         * @type {WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.maskTexture = null;
                    /**
         * The texture used for the main framebuffer.
         *
         * @name Phaser.Display.Masks.BitmapMask#mainTexture
         * @type {WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.mainTexture = null;
                    /**
         * Whether the Bitmap Mask is dirty and needs to be updated.
         *
         * @name Phaser.Display.Masks.BitmapMask#dirty
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.dirty = true;
                    /**
         * The framebuffer to which a masked Game Object is rendered.
         *
         * @name Phaser.Display.Masks.BitmapMask#mainFramebuffer
         * @type {WebGLFramebuffer}
         * @since 3.0.0
         */ this.mainFramebuffer = null;
                    /**
         * The framebuffer to which the Bitmap Mask's masking Game Object is rendered.
         *
         * @name Phaser.Display.Masks.BitmapMask#maskFramebuffer
         * @type {WebGLFramebuffer}
         * @since 3.0.0
         */ this.maskFramebuffer = null;
                    /**
         * Whether to invert the masks alpha.
         *
         * If `true`, the alpha of the masking pixel will be inverted before it's multiplied with the masked pixel.
         * Essentially, this means that a masked area will be visible only if the corresponding area in the mask is invisible.
         *
         * @name Phaser.Display.Masks.BitmapMask#invertAlpha
         * @type {boolean}
         * @since 3.1.2
         */ this.invertAlpha = false;
                    /**
         * Is this mask a stencil mask?
         *
         * @name Phaser.Display.Masks.BitmapMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = false;
                    this.createMask();
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, this.createMask, this);
                    if (renderer) renderer.on(RenderEvents.RESIZE, this.createMask, this);
                },
                /**
     * Creates the WebGL Texture2D objects and Framebuffers required for this
     * mask. If this mask has already been created, then `clearMask` is called first.
     *
     * @method Phaser.Display.Masks.BitmapMask#createMask
     * @since 3.50.0
     */ createMask: function() {
                    var renderer = this.renderer;
                    if (!renderer || !renderer.gl) return;
                    if (this.mainTexture) this.clearMask();
                    var width = renderer.width;
                    var height = renderer.height;
                    var pot = (width & width - 1) === 0 && (height & height - 1) === 0;
                    var gl = renderer.gl;
                    var wrap = pot ? gl.REPEAT : gl.CLAMP_TO_EDGE;
                    var filter = gl.LINEAR;
                    this.mainTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
                    this.maskTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
                    this.mainFramebuffer = renderer.createFramebuffer(width, height, this.mainTexture, true);
                    this.maskFramebuffer = renderer.createFramebuffer(width, height, this.maskTexture, true);
                },
                /**
     * Deletes the `mainTexture` and `maskTexture` WebGL Textures and deletes
     * the `mainFramebuffer` and `maskFramebuffer` too, nulling all references.
     *
     * This is called when this mask is destroyed, or if you try to creat a new
     * mask from this object when one is already set.
     *
     * @method Phaser.Display.Masks.BitmapMask#clearMask
     * @since 3.50.0
     */ clearMask: function() {
                    var renderer = this.renderer;
                    if (!renderer || !renderer.gl || !this.mainTexture) return;
                    renderer.deleteTexture(this.mainTexture);
                    renderer.deleteTexture(this.maskTexture);
                    renderer.deleteFramebuffer(this.mainFramebuffer);
                    renderer.deleteFramebuffer(this.maskFramebuffer);
                    this.mainTexture = null;
                    this.maskTexture = null;
                    this.mainFramebuffer = null;
                    this.maskFramebuffer = null;
                },
                /**
     * Sets a new masking Game Object for the Bitmap Mask.
     *
     * @method Phaser.Display.Masks.BitmapMask#setBitmap
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
     */ setBitmap: function(renderable) {
                    this.bitmapMask = renderable;
                },
                /**
     * Prepares the WebGL Renderer to render a Game Object with this mask applied.
     *
     * This renders the masking Game Object to the mask framebuffer and switches to the main framebuffer so that the masked Game Object will be rendered to it instead of being rendered directly to the frame.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to prepare.
     * @param {Phaser.GameObjects.GameObject} maskedObject - The masked Game Object which will be drawn.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderWebGL: function(renderer, maskedObject, camera) {
                    renderer.pipelines.BITMAPMASK_PIPELINE.beginMask(this, maskedObject, camera);
                },
                /**
     * Finalizes rendering of a masked Game Object.
     *
     * This resets the previously bound framebuffer and switches the WebGL Renderer to the Bitmap Mask Pipeline, which uses a special fragment shader to apply the masking effect.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to clean up.
     */ postRenderWebGL: function(renderer, camera) {
                    renderer.pipelines.BITMAPMASK_PIPELINE.endMask(this, camera);
                },
                /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     * @param {Phaser.GameObjects.GameObject} mask - The masked Game Object which would be rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderCanvas: function() {
                // NOOP
                },
                /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     */ postRenderCanvas: function() {
                // NOOP
                },
                /**
     * Destroys this BitmapMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.BitmapMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.clearMask();
                    if (this.renderer) this.renderer.off(RenderEvents.RESIZE, this.createMask, this);
                    this.bitmapMask = null;
                    this.prevFramebuffer = null;
                    this.renderer = null;
                }
            });
            module1.exports = BitmapMask;
        /***/ },
        /* 311 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Geometry Mask can be applied to a Game Object to hide any pixels of it which don't intersect
 * a visible pixel from the geometry mask. The mask is essentially a clipping path which can only
 * make a masked pixel fully visible or fully invisible without changing its alpha (opacity).
 *
 * A Geometry Mask uses a Graphics Game Object to determine which pixels of the masked Game Object(s)
 * should be clipped. For any given point of a masked Game Object's texture, the pixel will only be displayed
 * if the Graphics Game Object of the Geometry Mask has a visible pixel at the same position. The color and
 * alpha of the pixel from the Geometry Mask do not matter.
 *
 * The Geometry Mask's location matches the location of its Graphics object, not the location of the masked objects.
 * Moving or transforming the underlying Graphics object will change the mask (and affect the visibility
 * of any masked objects), whereas moving or transforming a masked object will not affect the mask.
 * You can think of the Geometry Mask (or rather, of its Graphics object) as an invisible curtain placed
 * in front of all masked objects which has its own visual properties and, naturally, respects the camera's
 * visual properties, but isn't affected by and doesn't follow the masked objects by itself.
 *
 * @class GeometryMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - This parameter is not used.
 * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics Game Object to use for the Geometry Mask. Doesn't have to be in the Display List.
 */ var GeometryMask = new Class({
                initialize: function GeometryMask(scene, graphicsGeometry) {
                    /**
         * The Graphics object which describes the Geometry Mask.
         *
         * @name Phaser.Display.Masks.GeometryMask#geometryMask
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.geometryMask = graphicsGeometry;
                    /**
         * Similar to the BitmapMasks invertAlpha setting this to true will then hide all pixels
         * drawn to the Geometry Mask.
         *
         * This is a WebGL only feature.
         *
         * @name Phaser.Display.Masks.GeometryMask#invertAlpha
         * @type {boolean}
         * @since 3.16.0
         */ this.invertAlpha = false;
                    /**
         * Is this mask a stencil mask?
         *
         * @name Phaser.Display.Masks.GeometryMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = true;
                    /**
         * The current stencil level.
         *
         * @name Phaser.Display.Masks.GeometryMask#level
         * @type {boolean}
         * @private
         * @since 3.17.0
         */ this.level = 0;
                },
                /**
     * Sets a new Graphics object for the Geometry Mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#setShape
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics object which will be used for the Geometry Mask.
     *
     * @return {this} This Geometry Mask
     */ setShape: function(graphicsGeometry) {
                    this.geometryMask = graphicsGeometry;
                    return this;
                },
                /**
     * Sets the `invertAlpha` property of this Geometry Mask.
     *
     * Inverting the alpha essentially flips the way the mask works.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.Display.Masks.GeometryMask#setInvertAlpha
     * @since 3.17.0
     *
     * @param {boolean} [value=true] - Invert the alpha of this mask?
     *
     * @return {this} This Geometry Mask
     */ setInvertAlpha: function(value) {
                    if (value === undefined) value = true;
                    this.invertAlpha = value;
                    return this;
                },
                /**
     * Renders the Geometry Mask's underlying Graphics object to the OpenGL stencil buffer and enables the stencil test, which clips rendered pixels according to the mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderWebGL: function(renderer, child, camera) {
                    var gl = renderer.gl;
                    //  Force flushing before drawing to stencil buffer
                    renderer.flush();
                    if (renderer.maskStack.length === 0) {
                        gl.enable(gl.STENCIL_TEST);
                        gl.clear(gl.STENCIL_BUFFER_BIT);
                        renderer.maskCount = 0;
                    }
                    if (renderer.currentCameraMask.mask !== this) renderer.currentMask.mask = this;
                    renderer.maskStack.push({
                        mask: this,
                        camera: camera
                    });
                    this.applyStencil(renderer, camera, true);
                    renderer.maskCount++;
                },
                /**
     * Applies the current stencil mask to the renderer.
     *
     * @method Phaser.Display.Masks.GeometryMask#applyStencil
     * @since 3.17.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     * @param {boolean} inc - Is this an INCR stencil or a DECR stencil?
     */ applyStencil: function(renderer, camera, inc) {
                    var gl = renderer.gl;
                    var geometryMask = this.geometryMask;
                    var level = renderer.maskCount;
                    gl.colorMask(false, false, false, false);
                    if (inc) {
                        gl.stencilFunc(gl.EQUAL, level, 0xFF);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
                    } else {
                        gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
                    }
                    //  Write stencil buffer
                    geometryMask.renderWebGL(renderer, geometryMask, camera);
                    renderer.flush();
                    gl.colorMask(true, true, true, true);
                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
                    if (inc) {
                        if (this.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, level + 1, 0xFF);
                        else gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
                    } else if (this.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, level, 0xFF);
                    else gl.stencilFunc(gl.EQUAL, level, 0xFF);
                },
                /**
     * Flushes all rendered pixels and disables the stencil test of a WebGL context, thus disabling the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw flush.
     */ postRenderWebGL: function(renderer) {
                    var gl = renderer.gl;
                    renderer.maskStack.pop();
                    renderer.maskCount--;
                    //  Force flush before disabling stencil test
                    renderer.flush();
                    var current = renderer.currentMask;
                    if (renderer.maskStack.length === 0) {
                        //  If this is the only mask in the stack, flush and disable
                        current.mask = null;
                        gl.disable(gl.STENCIL_TEST);
                    } else {
                        var prev = renderer.maskStack[renderer.maskStack.length - 1];
                        prev.mask.applyStencil(renderer, prev.camera, false);
                        if (renderer.currentCameraMask.mask !== prev.mask) {
                            current.mask = prev.mask;
                            current.camera = prev.camera;
                        } else current.mask = null;
                    }
                },
                /**
     * Sets the clipping path of a 2D canvas context to the Geometry Mask's underlying Graphics object.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance to set the clipping path on.
     * @param {Phaser.GameObjects.GameObject} mask - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderCanvas: function(renderer, mask, camera) {
                    var geometryMask = this.geometryMask;
                    renderer.currentContext.save();
                    geometryMask.renderCanvas(renderer, geometryMask, camera, null, null, true);
                    renderer.currentContext.clip();
                },
                /**
     * Restore the canvas context's previous clipping path, thus turning off the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance being restored.
     */ postRenderCanvas: function(renderer) {
                    renderer.currentContext.restore();
                },
                /**
     * Destroys this GeometryMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.GeometryMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.geometryMask = null;
                }
            });
            module1.exports = GeometryMask;
        /***/ },
        /* 312 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the Scroll Factor of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.ScrollFactor
 * @since 3.0.0
 */ var ScrollFactor = {
                /**
     * The horizontal scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorX: 1,
                /**
     * The vertical scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorY: 1,
                /**
     * Sets the scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Components.ScrollFactor#setScrollFactor
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y) {
                    if (y === undefined) y = x;
                    this.scrollFactorX = x;
                    this.scrollFactorY = y;
                    return this;
                }
            };
            module1.exports = ScrollFactor;
        /***/ },
        /* 313 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var TransformMatrix = __webpack_require__(25);
            var TransformXY = __webpack_require__(177);
            var WrapAngle = __webpack_require__(269);
            var WrapAngleDegrees = __webpack_require__(270);
            var Vector2 = __webpack_require__(3);
            //  global bitmask flag for GameObject.renderMask (used by Scale)
            var _FLAG = 4; // 0100
            /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                /**
     * Private internal value. Holds the horizontal scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleX
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleX: 1,
                /**
     * Private internal value. Holds the vertical scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleY
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleY: 1,
                /**
     * Private internal value. Holds the rotation value in radians.
     *
     * @name Phaser.GameObjects.Components.Transform#_rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _rotation: 0,
                /**
     * The x position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: 0,
                /**
     * The y position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: 0,
                /**
     * The z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#depth} instead.
     *
     * @name Phaser.GameObjects.Components.Transform#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: 0,
                /**
     * The w position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: 0,
                /**
     * This is a special setter that allows you to set both the horizontal and vertical scale of this Game Object
     * to the same value, at the same time. When reading this value the result returned is `(scaleX + scaleY) / 2`.
     *
     * Use of this property implies you wish the horizontal and vertical scales to be equal to each other. If this
     * isn't the case, use the `scaleX` or `scaleY` properties instead.
     *
     * @name Phaser.GameObjects.Components.Transform#scale
     * @type {number}
     * @default 1
     * @since 3.18.0
     */ scale: {
                    get: function() {
                        return (this._scaleX + this._scaleY) / 2;
                    },
                    set: function(value) {
                        this._scaleX = value;
                        this._scaleY = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(value) {
                        this._scaleX = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(value) {
                        this._scaleY = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The angle of this Game Object as expressed in degrees.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, 90 is down, 180/-180 is left
     * and -90 is up.
     *
     * If you prefer to work in radians, see the `rotation` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#angle
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ angle: {
                    get: function() {
                        return WrapAngleDegrees(this._rotation * MATH_CONST.RAD_TO_DEG);
                    },
                    set: function(value) {
                        //  value is in degrees
                        this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                    }
                },
                /**
     * The angle of this Game Object in radians.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, PI/2 is down, +-PI is left
     * and -PI/2 is up.
     *
     * If you prefer to work in degrees, see the `angle` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#rotation
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        //  value is in radians
                        this._rotation = WrapAngle(value);
                    }
                },
                /**
     * Sets the position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of this Game Object.
     * @param {number} [y=x] - The y position of this Game Object. If not set it will use the `x` value.
     * @param {number} [z=0] - The z position of this Game Object.
     * @param {number} [w=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setPosition: function(x, y, z, w) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    if (z === undefined) z = 0;
                    if (w === undefined) w = 0;
                    this.x = x;
                    this.y = y;
                    this.z = z;
                    this.w = w;
                    return this;
                },
                /**
     * Copies an object's coordinates to this Game Object's position.
     *
     * @method Phaser.GameObjects.Components.Transform#copyPosition
     * @since 3.50.0
     *
     * @param {(Phaser.Types.Math.Vector2Like|Phaser.Types.Math.Vector3Like|Phaser.Types.Math.Vector4Like)} source - An object with numeric 'x', 'y', 'z', or 'w' properties. Undefined values are not copied.
     *
     * @return {this} This Game Object instance.
     */ copyPosition: function(source) {
                    if (source.x !== undefined) this.x = source.x;
                    if (source.y !== undefined) this.y = source.y;
                    if (source.z !== undefined) this.z = source.z;
                    if (source.w !== undefined) this.w = source.w;
                    return this;
                },
                /**
     * Sets the position of this Game Object to be a random position within the confines of
     * the given area.
     *
     * If no area is specified a random position between 0 x 0 and the game width x height is used instead.
     *
     * The position does not factor in the size of this Game Object, meaning that only the origin is
     * guaranteed to be within the area.
     *
     * @method Phaser.GameObjects.Components.Transform#setRandomPosition
     * @since 3.8.0
     *
     * @param {number} [x=0] - The x position of the top-left of the random area.
     * @param {number} [y=0] - The y position of the top-left of the random area.
     * @param {number} [width] - The width of the random area.
     * @param {number} [height] - The height of the random area.
     *
     * @return {this} This Game Object instance.
     */ setRandomPosition: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    this.x = x + Math.random() * width;
                    this.y = y + Math.random() * height;
                    return this;
                },
                /**
     * Sets the rotation of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The rotation of this Game Object, in radians.
     *
     * @return {this} This Game Object instance.
     */ setRotation: function(radians) {
                    if (radians === undefined) radians = 0;
                    this.rotation = radians;
                    return this;
                },
                /**
     * Sets the angle of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The rotation of this Game Object, in degrees.
     *
     * @return {this} This Game Object instance.
     */ setAngle: function(degrees) {
                    if (degrees === undefined) degrees = 0;
                    this.angle = degrees;
                    return this;
                },
                /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScale: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    this.scaleX = x;
                    this.scaleY = y;
                    return this;
                },
                /**
     * Sets the x position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setX
     * @since 3.0.0
     *
     * @param {number} [value=0] - The x position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setX: function(value) {
                    if (value === undefined) value = 0;
                    this.x = value;
                    return this;
                },
                /**
     * Sets the y position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setY
     * @since 3.0.0
     *
     * @param {number} [value=0] - The y position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setY: function(value) {
                    if (value === undefined) value = 0;
                    this.y = value;
                    return this;
                },
                /**
     * Sets the z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#setDepth} instead.
     *
     * @method Phaser.GameObjects.Components.Transform#setZ
     * @since 3.0.0
     *
     * @param {number} [value=0] - The z position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setZ: function(value) {
                    if (value === undefined) value = 0;
                    this.z = value;
                    return this;
                },
                /**
     * Sets the w position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setW
     * @since 3.0.0
     *
     * @param {number} [value=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setW: function(value) {
                    if (value === undefined) value = 0;
                    this.w = value;
                    return this;
                },
                /**
     * Gets the local transform matrix for this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getLocalTransformMatrix: function(tempMatrix) {
                    if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                    return tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                },
                /**
     * Gets the world transform matrix for this Game Object, factoring in any parent Containers.
     *
     * @method Phaser.GameObjects.Components.Transform#getWorldTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A temporary matrix to hold parent values during the calculations.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getWorldTransformMatrix: function(tempMatrix, parentMatrix) {
                    if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                    if (parentMatrix === undefined) parentMatrix = new TransformMatrix();
                    var parent = this.parentContainer;
                    if (!parent) return this.getLocalTransformMatrix(tempMatrix);
                    tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                    while(parent){
                        parentMatrix.applyITRS(parent.x, parent.y, parent._rotation, parent._scaleX, parent._scaleY);
                        parentMatrix.multiply(tempMatrix, tempMatrix);
                        parent = parent.parentContainer;
                    }
                    return tempMatrix;
                },
                /**
     * Takes the given `x` and `y` coordinates and converts them into local space for this
     * Game Object, taking into account parent and local transforms, and the Display Origin.
     *
     * The returned Vector2 contains the translated point in its properties.
     *
     * A Camera needs to be provided in order to handle modified scroll factors. If no
     * camera is specified, it will use the `main` camera from the Scene to which this
     * Game Object belongs.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalPoint
     * @since 3.50.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [point] - A Vector2, or point-like object, to store the results in.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Math.Vector2} The translated point.
     */ getLocalPoint: function(x, y, point, camera) {
                    if (!point) point = new Vector2();
                    if (!camera) camera = this.scene.sys.cameras.main;
                    var csx = camera.scrollX;
                    var csy = camera.scrollY;
                    var px = x + csx * this.scrollFactorX - csx;
                    var py = y + csy * this.scrollFactorY - csy;
                    if (this.parentContainer) this.getWorldTransformMatrix().applyInverse(px, py, point);
                    else TransformXY(px, py, this.x, this.y, this.rotation, this.scaleX, this.scaleY, point);
                    //  Normalize origin
                    if (this._originComponent) {
                        point.x += this._displayOriginX;
                        point.y += this._displayOriginY;
                    }
                    return point;
                },
                /**
     * Gets the sum total rotation of all of this Game Objects parent Containers.
     *
     * The returned value is in radians and will be zero if this Game Object has no parent container.
     *
     * @method Phaser.GameObjects.Components.Transform#getParentRotation
     * @since 3.18.0
     *
     * @return {number} The sum total rotation, in radians, of all parent containers of this Game Object.
     */ getParentRotation: function() {
                    var rotation = 0;
                    var parent = this.parentContainer;
                    while(parent){
                        rotation += parent.rotation;
                        parent = parent.parentContainer;
                    }
                    return rotation;
                }
            };
            module1.exports = Transform;
        /***/ },
        /* 314 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 1; // 0001
            /**
 * Provides methods used for setting the visibility of a Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.Visible
 * @since 3.0.0
 */ var Visible = {
                /**
     * Private internal value. Holds the visible value.
     * 
     * @name Phaser.GameObjects.Components.Visible#_visible
     * @type {boolean}
     * @private
     * @default true
     * @since 3.0.0
     */ _visible: true,
                /**
     * The visible state of the Game Object.
     * 
     * An invisible Game Object will skip rendering, but will still process update logic.
     * 
     * @name Phaser.GameObjects.Components.Visible#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(value) {
                        if (value) {
                            this._visible = true;
                            this.renderFlags |= _FLAG;
                        } else {
                            this._visible = false;
                            this.renderFlags &= ~_FLAG;
                        }
                    }
                },
                /**
     * Sets the visibility of this Game Object.
     * 
     * An invisible Game Object will skip rendering, but will still process update logic.
     *
     * @method Phaser.GameObjects.Components.Visible#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setVisible: function(value) {
                    this.visible = value;
                    return this;
                }
            };
            module1.exports = Visible;
        /***/ },
        /* 315 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data.Events
 */ module1.exports = {
                CHANGE_DATA: __webpack_require__(638),
                CHANGE_DATA_KEY: __webpack_require__(639),
                DESTROY: __webpack_require__(640),
                REMOVE_DATA: __webpack_require__(641),
                SET_DATA: __webpack_require__(642)
            };
        /***/ },
        /* 316 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(130);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of points from the perimeter of the Rectangle, where each point is spaced out based
 * on either the `step` value, or the `quantity`.
 *
 * @function Phaser.Geom.Rectangle.MarchingAnts
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the perimeter points from.
 * @param {number} [step] - The distance between each point of the perimeter. Set to `null` if you wish to use the `quantity` parameter instead.
 * @param {number} [quantity] - The total number of points to return. The step is then calculated based on the length of the Rectangle, divided by this value.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array in which the perimeter points will be stored. If not given, a new array instance is created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array containing the perimeter points from the Rectangle.
 */ var MarchingAnts = function(rect, step, quantity, out) {
                if (out === undefined) out = [];
                if (!step && !quantity) //  Bail out
                return out;
                //  If step is a falsey value (false, null, 0, undefined, etc) then we calculate
                //  it based on the quantity instead, otherwise we always use the step value
                if (!step) step = Perimeter(rect) / quantity;
                else quantity = Math.round(Perimeter(rect) / step);
                var x = rect.x;
                var y = rect.y;
                var face = 0;
                //  Loop across each face of the rectangle
                for(var i = 0; i < quantity; i++){
                    out.push(new Point(x, y));
                    switch(face){
                        //  Top face
                        case 0:
                            x += step;
                            if (x >= rect.right) {
                                face = 1;
                                y += x - rect.right;
                                x = rect.right;
                            }
                            break;
                        //  Right face
                        case 1:
                            y += step;
                            if (y >= rect.bottom) {
                                face = 2;
                                x -= y - rect.bottom;
                                y = rect.bottom;
                            }
                            break;
                        //  Bottom face
                        case 2:
                            x -= step;
                            if (x <= rect.left) {
                                face = 3;
                                y -= rect.left - x;
                                x = rect.left;
                            }
                            break;
                        //  Left face
                        case 3:
                            y -= step;
                            if (y <= rect.top) {
                                face = 0;
                                y = rect.top;
                            }
                            break;
                    }
                }
                return out;
            };
            module1.exports = MarchingAnts;
        /***/ },
        /* 317 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Using Bresenham's line algorithm this will return an array of all coordinates on this line.
 *
 * The `start` and `end` points are rounded before this runs as the algorithm works on integers.
 *
 * @function Phaser.Geom.Line.BresenhamPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} [stepRate=1] - The optional step rate for the points on the line.
 * @param {Phaser.Types.Math.Vector2Like[]} [results] - An optional array to push the resulting coordinates into.
 *
 * @return {Phaser.Types.Math.Vector2Like[]} The array of coordinates on the line.
 */ var BresenhamPoints = function(line, stepRate, results) {
                if (stepRate === undefined) stepRate = 1;
                if (results === undefined) results = [];
                var x1 = Math.round(line.x1);
                var y1 = Math.round(line.y1);
                var x2 = Math.round(line.x2);
                var y2 = Math.round(line.y2);
                var dx = Math.abs(x2 - x1);
                var dy = Math.abs(y2 - y1);
                var sx = x1 < x2 ? 1 : -1;
                var sy = y1 < y2 ? 1 : -1;
                var err = dx - dy;
                results.push({
                    x: x1,
                    y: y1
                });
                var i = 1;
                while(!(x1 === x2 && y1 === y2)){
                    var e2 = err << 1;
                    if (e2 > -dy) {
                        err -= dy;
                        x1 += sx;
                    }
                    if (e2 < dx) {
                        err += dx;
                        y1 += sy;
                    }
                    if (i % stepRate === 0) results.push({
                        x: x1,
                        y: y1
                    });
                    i++;
                }
                return results;
            };
            module1.exports = BresenhamPoints;
        /***/ },
        /* 318 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches a pre-sorted array for the closet value to the given number.
 *
 * If the `key` argument is given it will assume the array contains objects that all have the required `key` property name,
 * and will check for the closest value of those to the given number.
 *
 * @function Phaser.Utils.Array.FindClosestInSorted
 * @since 3.0.0
 *
 * @param {number} value - The value to search for in the array.
 * @param {array} array - The array to search, which must be sorted.
 * @param {string} [key] - An optional property key. If specified the array elements property will be checked against value.
 *
 * @return {(number|any)} The nearest value found in the array, or if a `key` was given, the nearest object with the matching property value.
 */ var FindClosestInSorted = function(value, array, key) {
                if (!array.length) return NaN;
                else if (array.length === 1) return array[0];
                var i = 1;
                var low;
                var high;
                if (key) {
                    if (value < array[0][key]) return array[0];
                    while(array[i][key] < value)i++;
                } else while(array[i] < value)i++;
                if (i > array.length) i = array.length;
                if (key) {
                    low = array[i - 1][key];
                    high = array[i][key];
                    return high - value <= value - low ? array[i] : array[i - 1];
                } else {
                    low = array[i - 1];
                    high = array[i];
                    return high - value <= value - low ? high : low;
                }
            };
            module1.exports = FindClosestInSorted;
        /***/ },
        /* 319 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A single frame in an Animation sequence.
 *
 * An AnimationFrame consists of a reference to the Texture it uses for rendering, references to other
 * frames in the animation, and index data. It also has the ability to modify the animation timing.
 *
 * AnimationFrames are generated automatically by the Animation class.
 *
 * @class AnimationFrame
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {string} textureKey - The key of the Texture this AnimationFrame uses.
 * @param {(string|number)} textureFrame - The key of the Frame within the Texture that this AnimationFrame uses.
 * @param {number} index - The index of this AnimationFrame within the Animation sequence.
 * @param {Phaser.Textures.Frame} frame - A reference to the Texture Frame this AnimationFrame uses for rendering.
 * @param {boolean} [isKeyFrame=false] - Is this Frame a Keyframe within the Animation?
 */ var AnimationFrame = new Class({
                initialize: function AnimationFrame(textureKey, textureFrame, index, frame, isKeyFrame) {
                    if (isKeyFrame === undefined) isKeyFrame = false;
                    /**
         * The key of the Texture this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureKey
         * @type {string}
         * @since 3.0.0
         */ this.textureKey = textureKey;
                    /**
         * The key of the Frame within the Texture that this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.textureFrame = textureFrame;
                    /**
         * The index of this AnimationFrame within the Animation sequence.
         *
         * @name Phaser.Animations.AnimationFrame#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * A reference to the Texture Frame this AnimationFrame uses for rendering.
         *
         * @name Phaser.Animations.AnimationFrame#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = frame;
                    /**
         * Is this the first frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isFirst
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isFirst = false;
                    /**
         * Is this the last frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isLast
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isLast = false;
                    /**
         * A reference to the AnimationFrame that comes before this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#prevFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.prevFrame = null;
                    /**
         * A reference to the AnimationFrame that comes after this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#nextFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.nextFrame = null;
                    /**
         * Additional time (in ms) that this frame should appear for during playback.
         * The value is added onto the msPerFrame set by the animation.
         *
         * @name Phaser.Animations.AnimationFrame#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * What % through the animation does this frame come?
         * This value is generated when the animation is created and cached here.
         *
         * @name Phaser.Animations.AnimationFrame#progress
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Is this Frame a KeyFrame within the Animation?
         *
         * @name Phaser.Animations.AnimationFrame#isKeyFrame
         * @type {boolean}
         * @since 3.50.0
         */ this.isKeyFrame = isKeyFrame;
                },
                /**
     * Generates a JavaScript object suitable for converting to JSON.
     *
     * @method Phaser.Animations.AnimationFrame#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimationFrame} The AnimationFrame data.
     */ toJSON: function() {
                    return {
                        key: this.textureKey,
                        frame: this.textureFrame,
                        duration: this.duration,
                        keyframe: this.isKeyFrame
                    };
                },
                /**
     * Destroys this object by removing references to external resources and callbacks.
     *
     * @method Phaser.Animations.AnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.frame = undefined;
                }
            });
            module1.exports = AnimationFrame;
        /***/ },
        /* 320 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given array and runs a numeric sort on it, ignoring any non-digits that
 * may be in the entries.
 *
 * You should only run this on arrays containing strings.
 *
 * @function Phaser.Utils.Array.SortByDigits
 * @since 3.50.0
 *
 * @param {string[]} array - The input array of strings.
 *
 * @return {string[]} The sorted input array.
 */ var SortByDigits = function(array) {
                var re = /\D/g;
                array.sort(function(a, b) {
                    return parseInt(a.replace(re, ""), 10) - parseInt(b.replace(re, ""), 10);
                });
                return array;
            };
            module1.exports = SortByDigits;
        /***/ },
        /* 321 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Animation = __webpack_require__(185);
            var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(102);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(132);
            var GameEvents = __webpack_require__(22);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var Pad = __webpack_require__(186);
            var NumberArray = __webpack_require__(322);
            /**
 * @classdesc
 * The Animation Manager.
 *
 * Animations are managed by the global Animation Manager. This is a singleton class that is
 * responsible for creating and delivering animations and their corresponding data to all Game Objects.
 * Unlike plugins it is owned by the Game instance, not the Scene.
 *
 * Sprites and other Game Objects get the data they need from the AnimationManager.
 *
 * @class AnimationManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var AnimationManager = new Class({
                Extends: EventEmitter,
                initialize: function AnimationManager(game) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Animations.AnimationManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationManager#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.0.0
         */ this.textureManager = null;
                    /**
         * The global time scale of the Animation Manager.
         *
         * This scales the time delta between two frames, thus influencing the speed of time for the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#globalTimeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.globalTimeScale = 1;
                    /**
         * The Animations registered in the Animation Manager.
         *
         * This map should be modified with the {@link #add} and {@link #create} methods of the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.0.0
         */ this.anims = new CustomMap();
                    /**
         * A list of animation mix times.
         *
         * See the {@link #setMix} method for more details.
         *
         * @name Phaser.Animations.AnimationManager#mixes
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @since 3.50.0
         */ this.mixes = new CustomMap();
                    /**
         * Whether the Animation Manager is paused along with all of its Animations.
         *
         * @name Phaser.Animations.AnimationManager#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * The name of this Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#name
         * @type {string}
         * @since 3.0.0
         */ this.name = "AnimationManager";
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * Registers event listeners after the Game boots.
     *
     * @method Phaser.Animations.AnimationManager#boot
     * @listens Phaser.Core.Events#DESTROY
     * @since 3.0.0
     */ boot: function() {
                    this.textureManager = this.game.textures;
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Adds a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * When playing Animation A on a Game Object, if you then play Animation B, and a
     * mix exists, it will wait for the specified delay to be over before playing Animation B.
     *
     * This allows you to customise smoothing between different types of animation, such
     * as blending between an idle and a walk state, or a running and a firing state.
     *
     * Note that mixing is only applied if you use the `Sprite.play` method. If you opt to use
     * `playAfterRepeat` or `playAfterDelay` instead, those will take priority and the mix
     * delay will not be used.
     *
     * To update an existing mix, just call this method with the new delay.
     *
     * To remove a mix pairing, see the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#addMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     * @param {number} delay - The delay, in milliseconds, to wait when transitioning from Animation A to B.
     *
     * @return {this} This Animation Manager.
     */ addMix: function(animA, animB, delay) {
                    var anims = this.anims;
                    var mixes = this.mixes;
                    var keyA = typeof animA === "string" ? animA : animA.key;
                    var keyB = typeof animB === "string" ? animB : animB.key;
                    if (anims.has(keyA) && anims.has(keyB)) {
                        var mixObj = mixes.get(keyA);
                        if (!mixObj) mixObj = {};
                        mixObj[keyB] = delay;
                        mixes.set(keyA, mixObj);
                    }
                    return this;
                },
                /**
     * Removes a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * Calling this method lets you remove those pairings. You can either remove
     * it between `animA` and `animB`, or if you do not provide the `animB` parameter,
     * it will remove all `animA` mixes.
     *
     * If you wish to update an existing mix instead, call the `addMix` method with the
     * new delay.
     *
     * @method Phaser.Animations.AnimationManager#removeMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} [animB] - The string-based key, or instance of, Animation B. If not given, all mixes for Animation A will be removed.
     *
     * @return {this} This Animation Manager.
     */ removeMix: function(animA, animB) {
                    var mixes = this.mixes;
                    var keyA = typeof animA === "string" ? animA : animA.key;
                    var mixObj = mixes.get(keyA);
                    if (mixObj) {
                        if (animB) {
                            var keyB = typeof animB === "string" ? animB : animB.key;
                            if (mixObj.hasOwnProperty(keyB)) //  Remove just this pairing
                            delete mixObj[keyB];
                        } else if (!animB) //  Remove everything for animA
                        mixes.delete(keyA);
                    }
                    return this;
                },
                /**
     * Returns the mix delay between two animations.
     *
     * If no mix has been set-up, this method will return zero.
     *
     * If you wish to create, or update, a new mix, call the `addMix` method.
     * If you wish to remove a mix, call the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#getMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     *
     * @return {number} The mix duration, or zero if no mix exists.
     */ getMix: function(animA, animB) {
                    var mixes = this.mixes;
                    var keyA = typeof animA === "string" ? animA : animA.key;
                    var keyB = typeof animB === "string" ? animB : animB.key;
                    var mixObj = mixes.get(keyA);
                    if (mixObj && mixObj.hasOwnProperty(keyB)) return mixObj[keyB];
                    else return 0;
                },
                /**
     * Adds an existing Animation to the Animation Manager.
     *
     * @method Phaser.Animations.AnimationManager#add
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key under which the Animation should be added. The Animation will be updated with it. Must be unique.
     * @param {Phaser.Animations.Animation} animation - The Animation which should be added to the Animation Manager.
     *
     * @return {this} This Animation Manager.
     */ add: function(key, animation) {
                    if (this.anims.has(key)) {
                        console.warn("Animation key exists: " + key);
                        return this;
                    }
                    animation.key = key;
                    this.anims.set(key, animation);
                    this.emit(Events.ADD_ANIMATION, key, animation);
                    return this;
                },
                /**
     * Checks to see if the given key is already in use within the Animation Manager or not.
     *
     * Animations are global. Keys created in one scene can be used from any other Scene in your game. They are not Scene specific.
     *
     * @method Phaser.Animations.AnimationManager#exists
     * @since 3.16.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation already exists in the Animation Manager, or `false` if the key is available.
     */ exists: function(key) {
                    return this.anims.has(key);
                },
                /**
     * Create one, or more animations from a loaded Aseprite JSON file.
     *
     * Aseprite is a powerful animated sprite editor and pixel art tool.
     *
     * You can find more details at https://www.aseprite.org/
     *
     * To export a compatible JSON file in Aseprite, please do the following:
     *
     * 1. Go to "File - Export Sprite Sheet"
     *
     * 2. On the **Layout** tab:
     * 2a. Set the "Sheet type" to "Packed"
     * 2b. Set the "Constraints" to "None"
     * 2c. Check the "Merge Duplicates" checkbox
     *
     * 3. On the **Sprite** tab:
     * 3a. Set "Layers" to "Visible layers"
     * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
     *
     * 4. On the **Borders** tab:
     * 4a. Check the "Trim Sprite" and "Trim Cells" options
     * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
     *
     * 5. On the **Output** tab:
     * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
     * 5b. Check "JSON Data" and give your json file a name
     * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
     * 5d. Make sure "Tags" is checked in the Meta options
     * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
     *
     * 6. Click export
     *
     * This was tested with Aseprite 1.2.25.
     *
     * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
     *
     * ```javascript
     * function preload ()
     * {
     *     this.load.path = 'assets/animations/aseprite/';
     *     this.load.aseprite('paladin', 'paladin.png', 'paladin.json');
     * }
     * ```
     *
     * Once loaded, you can call this method from within a Scene with the 'atlas' key:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin');
     * ```
     *
     * Any animations defined in the JSON will now be available to use in Phaser and you play them
     * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
     * you can play it in Phaser using that Tag name:
     *
     * ```javascript
     * this.add.sprite(400, 300).play('War Cry');
     * ```
     *
     * When calling this method you can optionally provide an array of tag names, and only those animations
     * will be created. For example:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
     * ```
     *
     * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
     *
     * @method Phaser.Animations.AnimationManager#createFromAseprite
     * @since 3.50.0
     *
     * @param {string} key - The key of the loaded Aseprite atlas. It must have been loaded prior to calling this method.
     * @param {string[]} [tags] - An array of Tag names. If provided, only animations found in this array will be created.
     *
     * @return {Phaser.Animations.Animation[]} An array of Animation instances that were successfully created.
     */ createFromAseprite: function(key, tags) {
                    var output = [];
                    var data = this.game.cache.json.get(key);
                    if (!data) return output;
                    var _this = this;
                    var meta = GetValue(data, "meta", null);
                    var frames = GetValue(data, "frames", null);
                    if (meta && frames) {
                        var frameTags = GetValue(meta, "frameTags", []);
                        frameTags.forEach(function(tag) {
                            var animFrames = [];
                            var name = GetFastValue(tag, "name", null);
                            var from = GetFastValue(tag, "from", 0);
                            var to = GetFastValue(tag, "to", 0);
                            var direction = GetFastValue(tag, "direction", "forward");
                            if (!name) //  Skip if no name
                            return;
                            if (!tags || tags && tags.indexOf(name) > -1) {
                                //  Get all the frames for this tag
                                var tempFrames = [];
                                var minDuration = Number.MAX_SAFE_INTEGER;
                                for(var i = from; i <= to; i++){
                                    var frameKey = i.toString();
                                    var frame = frames[frameKey];
                                    if (frame) {
                                        var frameDuration = GetFastValue(frame, "duration", Number.MAX_SAFE_INTEGER);
                                        if (frameDuration < minDuration) minDuration = frameDuration;
                                        tempFrames.push({
                                            frame: frameKey,
                                            duration: frameDuration
                                        });
                                    }
                                }
                                tempFrames.forEach(function(entry) {
                                    animFrames.push({
                                        key: key,
                                        frame: entry.frame,
                                        duration: minDuration - entry.duration
                                    });
                                });
                                var totalDuration = minDuration * animFrames.length;
                                if (direction === "reverse") animFrames = animFrames.reverse();
                                //  Create the animation
                                var createConfig = {
                                    key: name,
                                    frames: animFrames,
                                    duration: totalDuration,
                                    yoyo: direction === "pingpong"
                                };
                                var result = _this.create(createConfig);
                                if (result) output.push(result);
                            }
                        });
                    }
                    return output;
                },
                /**
     * Creates a new Animation and adds it to the Animation Manager.
     *
     * Animations are global. Once created, you can use them in any Scene in your game. They are not Scene specific.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists in the Animation Manager, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use.
     *
     * If you wish to re-use an existing key, call `AnimationManager.remove` first, then this method.
     *
     * @method Phaser.Animations.AnimationManager#create
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                    var key = config.key;
                    var anim = false;
                    if (key) {
                        anim = this.get(key);
                        if (!anim) {
                            anim = new Animation(this, key, config);
                            this.anims.set(key, anim);
                            this.emit(Events.ADD_ANIMATION, key, anim);
                        }
                    }
                    return anim;
                },
                /**
     * Loads this Animation Manager's Animations and settings from a JSON object.
     *
     * @method Phaser.Animations.AnimationManager#fromJSON
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.JSONAnimations|Phaser.Types.Animations.JSONAnimation)} data - The JSON object to parse.
     * @param {boolean} [clearCurrentAnimations=false] - If set to `true`, the current animations will be removed (`anims.clear()`). If set to `false` (default), the animations in `data` will be added.
     *
     * @return {Phaser.Animations.Animation[]} An array containing all of the Animation objects that were created as a result of this call.
     */ fromJSON: function(data, clearCurrentAnimations) {
                    if (clearCurrentAnimations === undefined) clearCurrentAnimations = false;
                    if (clearCurrentAnimations) this.anims.clear();
                    //  Do we have a String (i.e. from JSON, or an Object?)
                    if (typeof data === "string") data = JSON.parse(data);
                    var output = [];
                    //  Array of animations, or a single animation?
                    if (data.hasOwnProperty("anims") && Array.isArray(data.anims)) {
                        for(var i = 0; i < data.anims.length; i++)output.push(this.create(data.anims[i]));
                        if (data.hasOwnProperty("globalTimeScale")) this.globalTimeScale = data.globalTimeScale;
                    } else if (data.hasOwnProperty("key") && data.type === "frame") output.push(this.create(data));
                    return output;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to look for 6 frames, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNames
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                    var prefix = GetValue(config, "prefix", "");
                    var start = GetValue(config, "start", 0);
                    var end = GetValue(config, "end", 0);
                    var suffix = GetValue(config, "suffix", "");
                    var zeroPad = GetValue(config, "zeroPad", 0);
                    var out = GetValue(config, "outputArray", []);
                    var frames = GetValue(config, "frames", false);
                    var texture = this.textureManager.get(key);
                    if (!texture) return out;
                    var i;
                    if (!config) {
                        //  Use every frame in the atlas
                        frames = texture.getFrameNames();
                        for(i = 0; i < frames.length; i++)out.push({
                            key: key,
                            frame: frames[i]
                        });
                    } else {
                        if (!frames) frames = NumberArray(start, end);
                        for(i = 0; i < frames.length; i++){
                            var frame = prefix + Pad(frames[i], zeroPad, "0", 1) + suffix;
                            if (texture.has(frame)) out.push({
                                key: key,
                                frame: frame
                            });
                            else console.warn("generateFrameNames: Frame missing: " + frame + " from texture: " + key);
                        }
                    }
                    return out;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     *
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 11 })`.
     *
     * The `end` value of 11 tells it to stop after the 12th frame has been added, because it started at zero.
     *
     * To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNames('explosion', {
     *     start: 0,
     *     end: 11
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNumbers
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} config - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                    var start = GetValue(config, "start", 0);
                    var end = GetValue(config, "end", -1);
                    var first = GetValue(config, "first", false);
                    var out = GetValue(config, "outputArray", []);
                    var frames = GetValue(config, "frames", false);
                    var texture = this.textureManager.get(key);
                    if (!texture) return out;
                    if (first && texture.has(first)) out.push({
                        key: key,
                        frame: first
                    });
                    //  No 'frames' array? Then generate one automatically
                    if (!frames) {
                        if (end === -1) //  -1 because of __BASE, which we don't want in our results
                        //  and -1 because frames are zero based
                        end = texture.frameTotal - 2;
                        frames = NumberArray(start, end);
                    }
                    for(var i = 0; i < frames.length; i++)if (texture.has(frames[i])) out.push({
                        key: key,
                        frame: frames[i]
                    });
                    else console.warn("generateFrameNumbers: Frame " + i + " missing from texture: " + key);
                    return out;
                },
                /**
     * Get an Animation.
     *
     * @method Phaser.Animations.AnimationManager#get
     * @since 3.0.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation.
     */ get: function(key) {
                    return this.anims.get(key);
                },
                /**
     * Pause all animations.
     *
     * @method Phaser.Animations.AnimationManager#pauseAll
     * @fires Phaser.Animations.Events#PAUSE_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ pauseAll: function() {
                    if (!this.paused) {
                        this.paused = true;
                        this.emit(Events.PAUSE_ALL);
                    }
                    return this;
                },
                /**
     * Play an animation on the given Game Objects that have an Animation Component.
     *
     * @method Phaser.Animations.AnimationManager#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     *
     * @return {this} This Animation Manager.
     */ play: function(key, children) {
                    if (!Array.isArray(children)) children = [
                        children
                    ];
                    for(var i = 0; i < children.length; i++)children[i].anims.play(key);
                    return this;
                },
                /**
     * Takes an array of Game Objects that have an Animation Component and then
     * starts the given animation playing on them. The start time of each Game Object
     * is offset, incrementally, by the `stagger` amount.
     *
     * For example, if you pass an array with 4 children and a stagger time of 1000,
     * the delays will be:
     *
     * child 1: 1000ms delay
     * child 2: 2000ms delay
     * child 3: 3000ms delay
     * child 4: 4000ms delay
     *
     * If you set the `staggerFirst` parameter to `false` they would be:
     *
     * child 1: 0ms delay
     * child 2: 1000ms delay
     * child 3: 2000ms delay
     * child 4: 3000ms delay
     *
     * You can also set `stagger` to be a negative value. If it was -1000, the above would be:
     *
     * child 1: 3000ms delay
     * child 2: 2000ms delay
     * child 3: 1000ms delay
     * child 4: 0ms delay
     *
     * @method Phaser.Animations.AnimationManager#staggerPlay
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     * @param {number} stagger - The amount of time, in milliseconds, to offset each play time by. If a negative value is given, it's applied to the children in reverse order.
     * @param {boolean} [staggerFirst=true] -Should the first child be staggered as well?
     *
     * @return {this} This Animation Manager.
     */ staggerPlay: function(key, children, stagger, staggerFirst) {
                    if (stagger === undefined) stagger = 0;
                    if (staggerFirst === undefined) staggerFirst = true;
                    if (!Array.isArray(children)) children = [
                        children
                    ];
                    var len = children.length;
                    if (!staggerFirst) len--;
                    for(var i = 0; i < children.length; i++){
                        var time = stagger < 0 ? Math.abs(stagger) * (len - i) : stagger * i;
                        children[i].anims.playAfterDelay(key, time);
                    }
                    return this;
                },
                /**
     * Removes an Animation from this Animation Manager, based on the given key.
     *
     * This is a global action. Once an Animation has been removed, no Game Objects
     * can carry on using it.
     *
     * @method Phaser.Animations.AnimationManager#remove
     * @fires Phaser.Animations.Events#REMOVE_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from the Animation Manager.
     */ remove: function(key) {
                    var anim = this.get(key);
                    if (anim) {
                        this.emit(Events.REMOVE_ANIMATION, key, anim);
                        this.anims.delete(key);
                        this.removeMix(key);
                    }
                    return anim;
                },
                /**
     * Resume all paused animations.
     *
     * @method Phaser.Animations.AnimationManager#resumeAll
     * @fires Phaser.Animations.Events#RESUME_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ resumeAll: function() {
                    if (this.paused) {
                        this.paused = false;
                        this.emit(Events.RESUME_ALL);
                    }
                    return this;
                },
                /**
     * Returns the Animation data as JavaScript object based on the given key.
     * Or, if not key is defined, it will return the data of all animations as array of objects.
     *
     * @method Phaser.Animations.AnimationManager#toJSON
     * @since 3.0.0
     *
     * @param {string} [key] - The animation to get the JSONAnimation data from. If not provided, all animations are returned as an array.
     *
     * @return {Phaser.Types.Animations.JSONAnimations} The resulting JSONAnimations formatted object.
     */ toJSON: function(key) {
                    var output = {
                        anims: [],
                        globalTimeScale: this.globalTimeScale
                    };
                    if (key !== undefined && key !== "") output.anims.push(this.anims.get(key).toJSON());
                    else this.anims.each(function(animationKey, animation) {
                        output.anims.push(animation.toJSON());
                    });
                    return output;
                },
                /**
     * Destroy this Animation Manager and clean up animation definitions and references to other objects.
     * This method should not be called directly. It will be called automatically as a response to a `destroy` event from the Phaser.Game instance.
     *
     * @method Phaser.Animations.AnimationManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.anims.clear();
                    this.mixes.clear();
                    this.textureManager = null;
                    this.game = null;
                }
            });
            module1.exports = AnimationManager;
        /***/ },
        /* 322 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array representing the range of numbers (usually integers), between, and inclusive of,
 * the given `start` and `end` arguments. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(2, 4); // array = [2, 3, 4]`
 * `var array = Phaser.Utils.Array.NumberArray(0, 9); // array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]`
 * `var array = Phaser.Utils.Array.NumberArray(8, 2); // array = [8, 7, 6, 5, 4, 3, 2]`
 *
 * This is equivalent to `Phaser.Utils.Array.NumberArrayStep(start, end, 1)`.
 *
 * You can optionally provide a prefix and / or suffix string. If given the array will contain
 * strings, not integers. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(1, 4, 'Level '); // array = ["Level 1", "Level 2", "Level 3", "Level 4"]`
 * `var array = Phaser.Utils.Array.NumberArray(5, 7, 'HD-', '.png'); // array = ["HD-5.png", "HD-6.png", "HD-7.png"]`
 *
 * @function Phaser.Utils.Array.NumberArray
 * @since 3.0.0
 *
 * @param {number} start - The minimum value the array starts with.
 * @param {number} end - The maximum value the array contains.
 * @param {string} [prefix] - Optional prefix to place before the number. If provided the array will contain strings, not integers.
 * @param {string} [suffix] - Optional suffix to place after the number. If provided the array will contain strings, not integers.
 *
 * @return {(number[]|string[])} The array of number values, or strings if a prefix or suffix was provided.
 */ var NumberArray = function(start, end, prefix, suffix) {
                var result = [];
                var i;
                var asString = false;
                if (prefix || suffix) {
                    asString = true;
                    if (!prefix) prefix = "";
                    if (!suffix) suffix = "";
                }
                if (end < start) {
                    for(i = start; i >= end; i--)if (asString) result.push(prefix + i.toString() + suffix);
                    else result.push(i);
                } else {
                    for(i = start; i <= end; i++)if (asString) result.push(prefix + i.toString() + suffix);
                    else result.push(i);
                }
                return result;
            };
            module1.exports = NumberArray;
        /***/ },
        /* 323 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(102);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(324);
            /**
 * @classdesc
 * The BaseCache is a base Cache class that can be used for storing references to any kind of data.
 *
 * Data can be added, retrieved and removed based on the given keys.
 *
 * Keys are string-based.
 *
 * @class BaseCache
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 */ var BaseCache = new Class({
                initialize: function BaseCache() {
                    /**
         * The Map in which the cache objects are stored.
         *
         * You can query the Map directly or use the BaseCache methods.
         *
         * @name Phaser.Cache.BaseCache#entries
         * @type {Phaser.Structs.Map.<String, *>}
         * @since 3.0.0
         */ this.entries = new CustomMap();
                    /**
         * An instance of EventEmitter used by the cache to emit related events.
         *
         * @name Phaser.Cache.BaseCache#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                },
                /**
     * Adds an item to this cache. The item is referenced by a unique string, which you are responsible
     * for setting and keeping track of. The item can only be retrieved by using this string.
     *
     * @method Phaser.Cache.BaseCache#add
     * @fires Phaser.Cache.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique key by which the data added to the cache will be referenced.
     * @param {*} data - The data to be stored in the cache.
     *
     * @return {this} This BaseCache object.
     */ add: function(key, data) {
                    this.entries.set(key, data);
                    this.events.emit(Events.ADD, this, key, data);
                    return this;
                },
                /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.exists`.
     *
     * @method Phaser.Cache.BaseCache#has
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ has: function(key) {
                    return this.entries.has(key);
                },
                /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.has` and is called directly by the Loader.
     *
     * @method Phaser.Cache.BaseCache#exists
     * @since 3.7.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ exists: function(key) {
                    return this.entries.has(key);
                },
                /**
     * Gets an item from this cache based on the given key.
     *
     * @method Phaser.Cache.BaseCache#get
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be retrieved from this cache.
     *
     * @return {*} The item in the cache, or `null` if no item matching the given key was found.
     */ get: function(key) {
                    return this.entries.get(key);
                },
                /**
     * Removes and item from this cache based on the given key.
     *
     * If an entry matching the key is found it is removed from the cache and a `remove` event emitted.
     * No additional checks are done on the item removed. If other systems or parts of your game code
     * are relying on this item, it is up to you to sever those relationships prior to removing the item.
     *
     * @method Phaser.Cache.BaseCache#remove
     * @fires Phaser.Cache.Events#REMOVE
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to remove from the cache.
     *
     * @return {this} This BaseCache object.
     */ remove: function(key) {
                    var entry = this.get(key);
                    if (entry) {
                        this.entries.delete(key);
                        this.events.emit(Events.REMOVE, this, key, entry.data);
                    }
                    return this;
                },
                /**
     * Returns all keys in use in this cache.
     *
     * @method Phaser.Cache.BaseCache#getKeys
     * @since 3.17.0
     *
     * @return {string[]} Array containing all the keys.
     */ getKeys: function() {
                    return this.entries.keys();
                },
                /**
     * Destroys this cache and all items within it.
     *
     * @method Phaser.Cache.BaseCache#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.entries.clear();
                    this.events.removeAllListeners();
                    this.entries = null;
                    this.events = null;
                }
            });
            module1.exports = BaseCache;
        /***/ },
        /* 324 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache.Events
 */ module1.exports = {
                ADD: __webpack_require__(736),
                REMOVE: __webpack_require__(737)
            };
        /***/ },
        /* 325 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCache = __webpack_require__(323);
            var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            /**
 * @classdesc
 * The Cache Manager is the global cache owned and maintained by the Game instance.
 *
 * Various systems, such as the file Loader, rely on this cache in order to store the files
 * it has loaded. The manager itself doesn't store any files, but instead owns multiple BaseCache
 * instances, one per type of file. You can also add your own custom caches.
 *
 * @class CacheManager
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this CacheManager.
 */ var CacheManager = new Class({
                initialize: function CacheManager(game) {
                    /**
         * A reference to the Phaser.Game instance that owns this CacheManager.
         *
         * @name Phaser.Cache.CacheManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A Cache storing all binary files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#binary
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.binary = new BaseCache();
                    /**
         * A Cache storing all bitmap font data files, typically added via the Loader.
         * Only the font data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#bitmapFont
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.bitmapFont = new BaseCache();
                    /**
         * A Cache storing all JSON data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#json
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.json = new BaseCache();
                    /**
         * A Cache storing all physics data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#physics
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.physics = new BaseCache();
                    /**
         * A Cache storing all shader source files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#shader
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.shader = new BaseCache();
                    /**
         * A Cache storing all non-streaming audio files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#audio
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.audio = new BaseCache();
                    /**
         * A Cache storing all non-streaming video files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#video
         * @type {Phaser.Cache.BaseCache}
         * @since 3.20.0
         */ this.video = new BaseCache();
                    /**
         * A Cache storing all text files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#text
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.text = new BaseCache();
                    /**
         * A Cache storing all html files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#html
         * @type {Phaser.Cache.BaseCache}
         * @since 3.12.0
         */ this.html = new BaseCache();
                    /**
         * A Cache storing all WaveFront OBJ files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#obj
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.obj = new BaseCache();
                    /**
         * A Cache storing all tilemap data files, typically added via the Loader.
         * Only the data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#tilemap
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.tilemap = new BaseCache();
                    /**
         * A Cache storing all xml data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#xml
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.xml = new BaseCache();
                    /**
         * An object that contains your own custom BaseCache entries.
         * Add to this via the `addCustom` method.
         *
         * @name Phaser.Cache.CacheManager#custom
         * @type {Object.<Phaser.Cache.BaseCache>}
         * @since 3.0.0
         */ this.custom = {};
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Add your own custom Cache for storing your own files.
     * The cache will be available under `Cache.custom.key`.
     * The cache will only be created if the key is not already in use.
     *
     * @method Phaser.Cache.CacheManager#addCustom
     * @since 3.0.0
     *
     * @param {string} key - The unique key of your custom cache.
     *
     * @return {Phaser.Cache.BaseCache} A reference to the BaseCache that was created. If the key was already in use, a reference to the existing cache is returned instead.
     */ addCustom: function(key) {
                    if (!this.custom.hasOwnProperty(key)) this.custom[key] = new BaseCache();
                    return this.custom[key];
                },
                /**
     * Removes all entries from all BaseCaches and destroys all custom caches.
     *
     * @method Phaser.Cache.CacheManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    var keys = [
                        "binary",
                        "bitmapFont",
                        "json",
                        "physics",
                        "shader",
                        "audio",
                        "video",
                        "text",
                        "html",
                        "obj",
                        "tilemap",
                        "xml"
                    ];
                    for(var i = 0; i < keys.length; i++){
                        this[keys[i]].destroy();
                        this[keys[i]] = null;
                    }
                    for(var key in this.custom)this.custom[key].destroy();
                    this.custom = null;
                    this.game = null;
                }
            });
            module1.exports = CacheManager;
        /***/ },
        /* 326 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(133);
            var CenterOn = __webpack_require__(190);
            var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Effects = __webpack_require__(333);
            var Events = __webpack_require__(37);
            var Linear = __webpack_require__(135);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * A Camera also has built-in special effects including Fade, Flash and Camera Shake.
 *
 * @class Camera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Cameras.Scene2D.BaseCamera
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Pipeline
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var Camera = new Class({
                Extends: BaseCamera,
                Mixins: [
                    Components.Flip,
                    Components.Tint,
                    Components.Pipeline
                ],
                initialize: function Camera(x, y, width, height) {
                    BaseCamera.call(this, x, y, width, height);
                    this.postPipelines = [];
                    this.pipelineData = {};
                    /**
         * Does this Camera allow the Game Objects it renders to receive input events?
         *
         * @name Phaser.Cameras.Scene2D.Camera#inputEnabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.inputEnabled = true;
                    /**
         * The Camera Fade effect handler.
         * To fade this camera see the `Camera.fade` methods.
         *
         * @name Phaser.Cameras.Scene2D.Camera#fadeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Fade}
         * @since 3.5.0
         */ this.fadeEffect = new Effects.Fade(this);
                    /**
         * The Camera Flash effect handler.
         * To flash this camera see the `Camera.flash` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#flashEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Flash}
         * @since 3.5.0
         */ this.flashEffect = new Effects.Flash(this);
                    /**
         * The Camera Shake effect handler.
         * To shake this camera see the `Camera.shake` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#shakeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Shake}
         * @since 3.5.0
         */ this.shakeEffect = new Effects.Shake(this);
                    /**
         * The Camera Pan effect handler.
         * To pan this camera see the `Camera.pan` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#panEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Pan}
         * @since 3.11.0
         */ this.panEffect = new Effects.Pan(this);
                    /**
         * The Camera Rotate To effect handler.
         * To rotate this camera see the `Camera.rotateTo` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#rotateToEffect
         * @type {Phaser.Cameras.Scene2D.Effects.RotateTo}
         * @since 3.23.0
         */ this.rotateToEffect = new Effects.RotateTo(this);
                    /**
         * The Camera Zoom effect handler.
         * To zoom this camera see the `Camera.zoom` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#zoomEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Zoom}
         * @since 3.11.0
         */ this.zoomEffect = new Effects.Zoom(this);
                    /**
         * The linear interpolation value to use when following a target.
         *
         * Can also be set via `setLerp` or as part of the `startFollow` call.
         *
         * The default values of 1 means the camera will instantly snap to the target coordinates.
         * A lower value, such as 0.1 means the camera will more slowly track the target, giving
         * a smooth transition. You can set the horizontal and vertical values independently, and also
         * adjust this value in real-time during your game.
         *
         * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
         *
         * @name Phaser.Cameras.Scene2D.Camera#lerp
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.lerp = new Vector2(1, 1);
                    /**
         * The values stored in this property are subtracted from the Camera targets position, allowing you to
         * offset the camera from the actual target x/y coordinates by this amount.
         * Can also be set via `setFollowOffset` or as part of the `startFollow` call.
         *
         * @name Phaser.Cameras.Scene2D.Camera#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.followOffset = new Vector2();
                    /**
         * The Camera dead zone.
         *
         * The deadzone is only used when the camera is following a target.
         *
         * It defines a rectangular region within which if the target is present, the camera will not scroll.
         * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
         *
         * The `lerp` values that you can set for a follower target also apply when using a deadzone.
         *
         * You can directly set this property to be an instance of a Rectangle. Or, you can use the
         * `setDeadzone` method for a chainable approach.
         *
         * The rectangle you provide can have its dimensions adjusted dynamically, however, please
         * note that its position is updated every frame, as it is constantly re-centered on the cameras mid point.
         *
         * Calling `setDeadzone` with no arguments will reset an active deadzone, as will setting this property
         * to `null`.
         *
         * @name Phaser.Cameras.Scene2D.Camera#deadzone
         * @type {?Phaser.Geom.Rectangle}
         * @since 3.11.0
         */ this.deadzone = null;
                    /**
         * Internal follow target reference.
         *
         * @name Phaser.Cameras.Scene2D.Camera#_follow
         * @type {?any}
         * @private
         * @default null
         * @since 3.0.0
         */ this._follow = null;
                },
                /**
     * Sets the Camera dead zone.
     *
     * The deadzone is only used when the camera is following a target.
     *
     * It defines a rectangular region within which if the target is present, the camera will not scroll.
     * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
     *
     * The deadzone rectangle is re-positioned every frame so that it is centered on the mid-point
     * of the camera. This allows you to use the object for additional game related checks, such as
     * testing if an object is within it or not via a Rectangle.contains call.
     *
     * The `lerp` values that you can set for a follower target also apply when using a deadzone.
     *
     * Calling this method with no arguments will reset an active deadzone.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setDeadzone
     * @since 3.11.0
     *
     * @param {number} [width] - The width of the deadzone rectangle in pixels. If not specified the deadzone is removed.
     * @param {number} [height] - The height of the deadzone rectangle in pixels.
     *
     * @return {this} This Camera instance.
     */ setDeadzone: function(width, height) {
                    if (width === undefined) this.deadzone = null;
                    else {
                        if (this.deadzone) {
                            this.deadzone.width = width;
                            this.deadzone.height = height;
                        } else this.deadzone = new Rectangle(0, 0, width, height);
                        if (this._follow) {
                            var originX = this.width / 2;
                            var originY = this.height / 2;
                            var fx = this._follow.x - this.followOffset.x;
                            var fy = this._follow.y - this.followOffset.y;
                            this.midPoint.set(fx, fy);
                            this.scrollX = fx - originX;
                            this.scrollY = fy - originY;
                        }
                        CenterOn(this.deadzone, this.midPoint.x, this.midPoint.y);
                    }
                    return this;
                },
                /**
     * Fades the Camera in from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeIn
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeIn: function(duration, red, green, blue, callback, context) {
                    return this.fadeEffect.start(false, duration, red, green, blue, true, callback, context);
                },
                /**
     * Fades the Camera out to the given color over the duration specified.
     * This is an alias for Camera.fade that forces the fade to start, regardless of existing fades.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeOut
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeOut: function(duration, red, green, blue, callback, context) {
                    return this.fadeEffect.start(true, duration, red, green, blue, true, callback, context);
                },
                /**
     * Fades the Camera from the given color to transparent over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeFrom
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeFrom: function(duration, red, green, blue, force, callback, context) {
                    return this.fadeEffect.start(false, duration, red, green, blue, force, callback, context);
                },
                /**
     * Fades the Camera from transparent to the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fade
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fade: function(duration, red, green, blue, force, callback, context) {
                    return this.fadeEffect.start(true, duration, red, green, blue, force, callback, context);
                },
                /**
     * Flashes the Camera by setting it to the given color immediately and then fading it away again quickly over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#flash
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ flash: function(duration, red, green, blue, force, callback, context) {
                    return this.flashEffect.start(duration, red, green, blue, force, callback, context);
                },
                /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#shake
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ shake: function(duration, intensity, force, callback, context) {
                    return this.shakeEffect.start(duration, intensity, force, callback, context);
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#pan
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ pan: function(x, y, duration, ease, force, callback, context) {
                    return this.panEffect.start(x, y, duration, ease, force, callback, context);
                },
                /**
     * This effect will rotate the Camera so that the viewport finishes at the given angle in radians,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#rotateTo
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the rotation. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera rotation angle in radians.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
     */ rotateTo: function(radians, shortestPath, duration, ease, force, callback, context) {
                    return this.rotateToEffect.start(radians, shortestPath, duration, ease, force, callback, context);
                },
                /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#zoomTo
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ zoomTo: function(zoom, duration, ease, force, callback, context) {
                    return this.zoomEffect.start(zoom, duration, ease, force, callback, context);
                },
                /**
     * Internal preRender step.
     *
     * @method Phaser.Cameras.Scene2D.Camera#preRender
     * @protected
     * @since 3.0.0
     */ preRender: function() {
                    this.renderList.length = 0;
                    var width = this.width;
                    var height = this.height;
                    var halfWidth = width * 0.5;
                    var halfHeight = height * 0.5;
                    var zoom = this.zoom;
                    var matrix = this.matrix;
                    var originX = width * this.originX;
                    var originY = height * this.originY;
                    var follow = this._follow;
                    var deadzone = this.deadzone;
                    var sx = this.scrollX;
                    var sy = this.scrollY;
                    if (deadzone) CenterOn(deadzone, this.midPoint.x, this.midPoint.y);
                    var emitFollowEvent = false;
                    if (follow && !this.panEffect.isRunning) {
                        var fx = follow.x - this.followOffset.x;
                        var fy = follow.y - this.followOffset.y;
                        if (deadzone) {
                            if (fx < deadzone.x) sx = Linear(sx, sx - (deadzone.x - fx), this.lerp.x);
                            else if (fx > deadzone.right) sx = Linear(sx, sx + (fx - deadzone.right), this.lerp.x);
                            if (fy < deadzone.y) sy = Linear(sy, sy - (deadzone.y - fy), this.lerp.y);
                            else if (fy > deadzone.bottom) sy = Linear(sy, sy + (fy - deadzone.bottom), this.lerp.y);
                        } else {
                            sx = Linear(sx, fx - originX, this.lerp.x);
                            sy = Linear(sy, fy - originY, this.lerp.y);
                        }
                        emitFollowEvent = true;
                    }
                    if (this.useBounds) {
                        sx = this.clampX(sx);
                        sy = this.clampY(sy);
                    }
                    if (this.roundPixels) {
                        originX = Math.round(originX);
                        originY = Math.round(originY);
                        sx = Math.round(sx);
                        sy = Math.round(sy);
                    }
                    //  Values are in pixels and not impacted by zooming the Camera
                    this.scrollX = sx;
                    this.scrollY = sy;
                    var midX = sx + halfWidth;
                    var midY = sy + halfHeight;
                    //  The center of the camera, in world space, so taking zoom into account
                    //  Basically the pixel value of what it's looking at in the middle of the cam
                    this.midPoint.set(midX, midY);
                    var displayWidth = width / zoom;
                    var displayHeight = height / zoom;
                    var vwx = midX - displayWidth / 2;
                    var vwy = midY - displayHeight / 2;
                    if (this.roundPixels) {
                        vwx = Math.round(vwx);
                        vwy = Math.round(vwy);
                    }
                    this.worldView.setTo(vwx, vwy, displayWidth, displayHeight);
                    matrix.applyITRS(this.x + originX, this.y + originY, this.rotation, zoom, zoom);
                    matrix.translate(-originX, -originY);
                    this.shakeEffect.preRender();
                    if (emitFollowEvent) this.emit(Events.FOLLOW_UPDATE, this, follow);
                },
                /**
     * Sets the linear interpolation value to use when following a target.
     *
     * The default values of 1 means the camera will instantly snap to the target coordinates.
     * A lower value, such as 0.1 means the camera will more slowly track the target, giving
     * a smooth transition. You can set the horizontal and vertical values independently, and also
     * adjust this value in real-time during your game.
     *
     * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setLerp
     * @since 3.9.0
     *
     * @param {number} [x=1] - The amount added to the horizontal linear interpolation of the follow target.
     * @param {number} [y=1] - The amount added to the vertical linear interpolation of the follow target.
     *
     * @return {this} This Camera instance.
     */ setLerp: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    this.lerp.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal and vertical offset of the camera from its follow target.
     * The values are subtracted from the targets position during the Cameras update step.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setFollowOffset
     * @since 3.9.0
     *
     * @param {number} [x=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [y=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ setFollowOffset: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    this.followOffset.set(x, y);
                    return this;
                },
                /**
     * Sets the Camera to follow a Game Object.
     *
     * When enabled the Camera will automatically adjust its scroll position to keep the target Game Object
     * in its center.
     *
     * You can set the linear interpolation value used in the follow code.
     * Use low lerp values (such as 0.1) to automatically smooth the camera motion.
     *
     * If you find you're getting a slight "jitter" effect when following an object it's probably to do with sub-pixel
     * rendering of the targets position. This can be rounded by setting the `roundPixels` argument to `true` to
     * force full pixel rounding rendering. Note that this can still be broken if you have specified a non-integer zoom
     * value on the camera. So be sure to keep the camera zoom to integers.
     *
     * @method Phaser.Cameras.Scene2D.Camera#startFollow
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|object)} target - The target for the Camera to follow.
     * @param {boolean} [roundPixels=false] - Round the camera position to whole integers to avoid sub-pixel rendering?
     * @param {number} [lerpX=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when horizontally tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [lerpY=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when vertically tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [offsetX=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [offsetY=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ startFollow: function(target, roundPixels, lerpX, lerpY, offsetX, offsetY) {
                    if (roundPixels === undefined) roundPixels = false;
                    if (lerpX === undefined) lerpX = 1;
                    if (lerpY === undefined) lerpY = lerpX;
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = offsetX;
                    this._follow = target;
                    this.roundPixels = roundPixels;
                    lerpX = Clamp(lerpX, 0, 1);
                    lerpY = Clamp(lerpY, 0, 1);
                    this.lerp.set(lerpX, lerpY);
                    this.followOffset.set(offsetX, offsetY);
                    var originX = this.width / 2;
                    var originY = this.height / 2;
                    var fx = target.x - offsetX;
                    var fy = target.y - offsetY;
                    this.midPoint.set(fx, fy);
                    this.scrollX = fx - originX;
                    this.scrollY = fy - originY;
                    if (this.useBounds) {
                        this.scrollX = this.clampX(this.scrollX);
                        this.scrollY = this.clampY(this.scrollY);
                    }
                    return this;
                },
                /**
     * Stops a Camera from following a Game Object, if previously set via `Camera.startFollow`.
     *
     * @method Phaser.Cameras.Scene2D.Camera#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ stopFollow: function() {
                    this._follow = null;
                    return this;
                },
                /**
     * Resets any active FX, such as a fade, flash or shake. Useful to call after a fade in order to
     * remove the fade.
     *
     * @method Phaser.Cameras.Scene2D.Camera#resetFX
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ resetFX: function() {
                    this.rotateToEffect.reset();
                    this.panEffect.reset();
                    this.shakeEffect.reset();
                    this.flashEffect.reset();
                    this.fadeEffect.reset();
                    return this;
                },
                /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.Camera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.visible) {
                        this.rotateToEffect.update(time, delta);
                        this.panEffect.update(time, delta);
                        this.zoomEffect.update(time, delta);
                        this.shakeEffect.update(time, delta);
                        this.flashEffect.update(time, delta);
                        this.fadeEffect.update(time, delta);
                    }
                },
                /**
     * Destroys this Camera instance. You rarely need to call this directly.
     *
     * Called by the Camera Manager. If you wish to destroy a Camera please use `CameraManager.remove` as
     * cameras are stored in a pool, ready for recycling later, and calling this directly will prevent that.
     *
     * @method Phaser.Cameras.Scene2D.Camera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    this.resetFX();
                    BaseCamera.prototype.destroy.call(this);
                    this._follow = null;
                    this.deadzone = null;
                }
            });
            module1.exports = Camera;
        /***/ },
        /* 327 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            /**
 * Converts a hex string into a Phaser Color object.
 * 
 * The hex string can supplied as `'#0033ff'` or the short-hand format of `'#03f'`; it can begin with an optional "#" or "0x", or be unprefixed.
 *
 * An alpha channel is _not_ supported.
 *
 * @function Phaser.Display.Color.HexStringToColor
 * @since 3.0.0
 *
 * @param {string} hex - The hex color value to convert, such as `#0033ff` or the short-hand format: `#03f`.
 *
 * @return {Phaser.Display.Color} A Color object populated by the values of the given string.
 */ var HexStringToColor = function(hex) {
                var color = new Color();
                // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
                hex = hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
                    return r + r + g + g + b + b;
                });
                var result = /^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                if (result) {
                    var r = parseInt(result[1], 16);
                    var g = parseInt(result[2], 16);
                    var b = parseInt(result[3], 16);
                    color.setTo(r, g, b);
                }
                return color;
            };
            module1.exports = HexStringToColor;
        /***/ },
        /* 328 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given an alpha and 3 color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor32
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 * @param {number} alpha - The alpha color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor32 = function(red, green, blue, alpha) {
                return alpha << 24 | red << 16 | green << 8 | blue;
            };
            module1.exports = GetColor32;
        /***/ },
        /* 329 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts an RGB color value to HSV (hue, saturation and value).
 * Conversion formula from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes RGB values are contained in the set [0, 255] and returns h, s and v in the set [0, 1].
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.RGBToHSV
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} [out] - An object to store the color values in. If not given an HSV Color Object will be created.
 *
 * @return {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} An object with the properties `h`, `s` and `v` set.
 */ var RGBToHSV = function(r, g, b, out) {
                if (out === undefined) out = {
                    h: 0,
                    s: 0,
                    v: 0
                };
                r /= 255;
                g /= 255;
                b /= 255;
                var min = Math.min(r, g, b);
                var max = Math.max(r, g, b);
                var d = max - min;
                // achromatic by default
                var h = 0;
                var s = max === 0 ? 0 : d / max;
                var v = max;
                if (max !== min) {
                    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
                    else if (max === g) h = (b - r) / d + 2;
                    else if (max === b) h = (r - g) / d + 4;
                    h /= 6;
                }
                if (out.hasOwnProperty("_h")) {
                    out._h = h;
                    out._s = s;
                    out._v = v;
                } else {
                    out.h = h;
                    out.s = s;
                    out.v = v;
                }
                return out;
            };
            module1.exports = RGBToHSV;
        /***/ },
        /* 330 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Return the component parts of a color as an Object with the properties alpha, red, green, blue.
 *
 * Alpha will only be set if it exists in the given color (0xAARRGGBB)
 *
 * @function Phaser.Display.Color.IntegerToRGB
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Types.Display.ColorObject} An object with the red, green and blue values set in the r, g and b properties.
 */ var IntegerToRGB = function(color) {
                if (color > 16777215) //  The color value has an alpha component
                return {
                    a: color >>> 24,
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF
                };
                else return {
                    a: 255,
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF
                };
            };
            module1.exports = IntegerToRGB;
        /***/ },
        /* 331 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            /**
 * Converts an object containing `r`, `g`, `b` and `a` properties into a Color class instance.
 *
 * @function Phaser.Display.Color.ObjectToColor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Display.InputColorObject} input - An object containing `r`, `g`, `b` and `a` properties in the range 0 to 255.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ObjectToColor = function(input) {
                return new Color(input.r, input.g, input.b, input.a);
            };
            module1.exports = ObjectToColor;
        /***/ },
        /* 332 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            /**
 * Converts a CSS 'web' string into a Phaser Color object.
 * 
 * The web string can be in the format `'rgb(r,g,b)'` or `'rgba(r,g,b,a)'` where r/g/b are in the range [0..255] and a is in the range [0..1].
 *
 * @function Phaser.Display.Color.RGBStringToColor
 * @since 3.0.0
 *
 * @param {string} rgb - The CSS format color string, using the `rgb` or `rgba` format.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RGBStringToColor = function(rgb) {
                var color = new Color();
                var result = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(rgb.toLowerCase());
                if (result) {
                    var r = parseInt(result[1], 10);
                    var g = parseInt(result[2], 10);
                    var b = parseInt(result[3], 10);
                    var a = result[4] !== undefined ? parseFloat(result[4]) : 1;
                    color.setTo(r, g, b, a * 255);
                }
                return color;
            };
            module1.exports = RGBStringToColor;
        /***/ },
        /* 333 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Effects
 */ module1.exports = {
                Fade: __webpack_require__(761),
                Flash: __webpack_require__(762),
                Pan: __webpack_require__(763),
                Shake: __webpack_require__(796),
                RotateTo: __webpack_require__(797),
                Zoom: __webpack_require__(798)
            };
        /***/ },
        /* 334 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Back
 */ module1.exports = {
                In: __webpack_require__(764),
                Out: __webpack_require__(765),
                InOut: __webpack_require__(766)
            };
        /***/ },
        /* 335 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Bounce
 */ module1.exports = {
                In: __webpack_require__(767),
                Out: __webpack_require__(768),
                InOut: __webpack_require__(769)
            };
        /***/ },
        /* 336 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Circular
 */ module1.exports = {
                In: __webpack_require__(770),
                Out: __webpack_require__(771),
                InOut: __webpack_require__(772)
            };
        /***/ },
        /* 337 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Cubic
 */ module1.exports = {
                In: __webpack_require__(773),
                Out: __webpack_require__(774),
                InOut: __webpack_require__(775)
            };
        /***/ },
        /* 338 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Elastic
 */ module1.exports = {
                In: __webpack_require__(776),
                Out: __webpack_require__(777),
                InOut: __webpack_require__(778)
            };
        /***/ },
        /* 339 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Expo
 */ module1.exports = {
                In: __webpack_require__(779),
                Out: __webpack_require__(780),
                InOut: __webpack_require__(781)
            };
        /***/ },
        /* 340 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = __webpack_require__(782);
        /***/ },
        /* 341 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quadratic
 */ module1.exports = {
                In: __webpack_require__(783),
                Out: __webpack_require__(784),
                InOut: __webpack_require__(785)
            };
        /***/ },
        /* 342 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quartic
 */ module1.exports = {
                In: __webpack_require__(786),
                Out: __webpack_require__(787),
                InOut: __webpack_require__(788)
            };
        /***/ },
        /* 343 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quintic
 */ module1.exports = {
                In: __webpack_require__(789),
                Out: __webpack_require__(790),
                InOut: __webpack_require__(791)
            };
        /***/ },
        /* 344 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Sine
 */ module1.exports = {
                In: __webpack_require__(792),
                Out: __webpack_require__(793),
                InOut: __webpack_require__(794)
            };
        /***/ },
        /* 345 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Stepped
 */ module1.exports = __webpack_require__(795);
        /***/ },
        /* 346 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(33);
            var Device = __webpack_require__(347);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            var PhaserMath = __webpack_require__(193);
            var NOOP = __webpack_require__(1);
            var DefaultPlugins = __webpack_require__(197);
            var ValueToColor = __webpack_require__(187);
            /**
 * @classdesc
 * The active game configuration settings, parsed from a {@link Phaser.Types.Core.GameConfig} object.
 *
 * @class Config
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 *
 * @see Phaser.Game#config
 */ var Config = new Class({
                initialize: function Config(config) {
                    if (config === undefined) config = {};
                    var defaultBannerColor = [
                        "#ff0000",
                        "#ffff00",
                        "#00ff00",
                        "#00ffff",
                        "#000000"
                    ];
                    var defaultBannerTextColor = "#ffffff";
                    /**
         * @const {(number|string)} Phaser.Core.Config#width - The width of the underlying canvas, in pixels.
         */ this.width = GetValue(config, "width", 1024);
                    /**
         * @const {(number|string)} Phaser.Core.Config#height - The height of the underlying canvas, in pixels.
         */ this.height = GetValue(config, "height", 768);
                    /**
         * @const {(Phaser.Scale.ZoomType|number)} Phaser.Core.Config#zoom - The zoom factor, as used by the Scale Manager.
         */ this.zoom = GetValue(config, "zoom", 1);
                    /**
         * @const {?*} Phaser.Core.Config#parent - A parent DOM element into which the canvas created by the renderer will be injected.
         */ this.parent = GetValue(config, "parent", undefined);
                    /**
         * @const {Phaser.Scale.ScaleModeType} Phaser.Core.Config#scaleMode - The scale mode as used by the Scale Manager. The default is zero, which is no scaling.
         */ this.scaleMode = GetValue(config, "scaleMode", 0);
                    /**
         * @const {boolean} Phaser.Core.Config#expandParent - Is the Scale Manager allowed to adjust the CSS height property of the parent to be 100%?
         */ this.expandParent = GetValue(config, "expandParent", true);
                    /**
         * @const {boolean} Phaser.Core.Config#autoRound - Automatically round the display and style sizes of the canvas. This can help with performance in lower-powered devices.
         */ this.autoRound = GetValue(config, "autoRound", false);
                    /**
         * @const {Phaser.Scale.CenterType} Phaser.Core.Config#autoCenter - Automatically center the canvas within the parent?
         */ this.autoCenter = GetValue(config, "autoCenter", 0);
                    /**
         * @const {number} Phaser.Core.Config#resizeInterval - How many ms should elapse before checking if the browser size has changed?
         */ this.resizeInterval = GetValue(config, "resizeInterval", 500);
                    /**
         * @const {?(HTMLElement|string)} Phaser.Core.Config#fullscreenTarget - The DOM element that will be sent into full screen mode, or its `id`. If undefined Phaser will create its own div and insert the canvas into it when entering fullscreen mode.
         */ this.fullscreenTarget = GetValue(config, "fullscreenTarget", null);
                    /**
         * @const {number} Phaser.Core.Config#minWidth - The minimum width, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minWidth = GetValue(config, "minWidth", 0);
                    /**
         * @const {number} Phaser.Core.Config#maxWidth - The maximum width, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxWidth = GetValue(config, "maxWidth", 0);
                    /**
         * @const {number} Phaser.Core.Config#minHeight - The minimum height, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minHeight = GetValue(config, "minHeight", 0);
                    /**
         * @const {number} Phaser.Core.Config#maxHeight - The maximum height, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxHeight = GetValue(config, "maxHeight", 0);
                    //  Scale Manager - Anything set in here over-rides anything set above
                    var scaleConfig = GetValue(config, "scale", null);
                    if (scaleConfig) {
                        this.width = GetValue(scaleConfig, "width", this.width);
                        this.height = GetValue(scaleConfig, "height", this.height);
                        this.zoom = GetValue(scaleConfig, "zoom", this.zoom);
                        this.parent = GetValue(scaleConfig, "parent", this.parent);
                        this.scaleMode = GetValue(scaleConfig, "mode", this.scaleMode);
                        this.expandParent = GetValue(scaleConfig, "expandParent", this.expandParent);
                        this.autoRound = GetValue(scaleConfig, "autoRound", this.autoRound);
                        this.autoCenter = GetValue(scaleConfig, "autoCenter", this.autoCenter);
                        this.resizeInterval = GetValue(scaleConfig, "resizeInterval", this.resizeInterval);
                        this.fullscreenTarget = GetValue(scaleConfig, "fullscreenTarget", this.fullscreenTarget);
                        this.minWidth = GetValue(scaleConfig, "min.width", this.minWidth);
                        this.maxWidth = GetValue(scaleConfig, "max.width", this.maxWidth);
                        this.minHeight = GetValue(scaleConfig, "min.height", this.minHeight);
                        this.maxHeight = GetValue(scaleConfig, "max.height", this.maxHeight);
                    }
                    /**
         * @const {number} Phaser.Core.Config#renderType - Force Phaser to use a specific renderer. Can be `CONST.CANVAS`, `CONST.WEBGL`, `CONST.HEADLESS` or `CONST.AUTO` (default)
         */ this.renderType = GetValue(config, "type", CONST.AUTO);
                    /**
         * @const {?HTMLCanvasElement} Phaser.Core.Config#canvas - Force Phaser to use your own Canvas element instead of creating one.
         */ this.canvas = GetValue(config, "canvas", null);
                    /**
         * @const {?(CanvasRenderingContext2D|WebGLRenderingContext)} Phaser.Core.Config#context - Force Phaser to use your own Canvas context instead of creating one.
         */ this.context = GetValue(config, "context", null);
                    /**
         * @const {?string} Phaser.Core.Config#canvasStyle - Optional CSS attributes to be set on the canvas object created by the renderer.
         */ this.canvasStyle = GetValue(config, "canvasStyle", null);
                    /**
         * @const {boolean} Phaser.Core.Config#customEnvironment - Is Phaser running under a custom (non-native web) environment? If so, set this to `true` to skip internal Feature detection. If `true` the `renderType` cannot be left as `AUTO`.
         */ this.customEnvironment = GetValue(config, "customEnvironment", false);
                    /**
         * @const {?object} Phaser.Core.Config#sceneConfig - The default Scene configuration object.
         */ this.sceneConfig = GetValue(config, "scene", null);
                    /**
         * @const {string[]} Phaser.Core.Config#seed - A seed which the Random Data Generator will use. If not given, a dynamic seed based on the time is used.
         */ this.seed = GetValue(config, "seed", [
                        (Date.now() * Math.random()).toString()
                    ]);
                    PhaserMath.RND = new PhaserMath.RandomDataGenerator(this.seed);
                    /**
         * @const {string} Phaser.Core.Config#gameTitle - The title of the game.
         */ this.gameTitle = GetValue(config, "title", "");
                    /**
         * @const {string} Phaser.Core.Config#gameURL - The URL of the game.
         */ this.gameURL = GetValue(config, "url", "https://phaser.io");
                    /**
         * @const {string} Phaser.Core.Config#gameVersion - The version of the game.
         */ this.gameVersion = GetValue(config, "version", "");
                    /**
         * @const {boolean} Phaser.Core.Config#autoFocus - If `true` the window will automatically be given focus immediately and on any future mousedown event.
         */ this.autoFocus = GetValue(config, "autoFocus", true);
                    //  DOM Element Container
                    /**
         * @const {?boolean} Phaser.Core.Config#domCreateContainer - Should the game create a div element to act as a DOM Container? Only enable if you're using DOM Element objects. You must provide a parent object if you use this feature.
         */ this.domCreateContainer = GetValue(config, "dom.createContainer", false);
                    /**
         * @const {?boolean} Phaser.Core.Config#domBehindCanvas - Should the DOM Container that is created (if `dom.createContainer` is true) be positioned behind (true) or over the top (false, the default) of the game canvas?
         */ this.domBehindCanvas = GetValue(config, "dom.behindCanvas", false);
                    /**
         * @const {?string} Phaser.Core.Config#domPointerEvents - The default `pointerEvents` attribute set on the DOM Container.
         */ this.domPointerEvents = GetValue(config, "dom.pointerEvents", "none");
                    //  Input
                    /**
         * @const {boolean} Phaser.Core.Config#inputKeyboard - Enable the Keyboard Plugin. This can be disabled in games that don't need keyboard input.
         */ this.inputKeyboard = GetValue(config, "input.keyboard", true);
                    /**
         * @const {*} Phaser.Core.Config#inputKeyboardEventTarget - The DOM Target to listen for keyboard events on. Defaults to `window` if not specified.
         */ this.inputKeyboardEventTarget = GetValue(config, "input.keyboard.target", window);
                    /**
         * @const {?number[]} Phaser.Core.Config#inputKeyboardCapture - `preventDefault` will be called on every non-modified key which has a key code in this array. By default, it is empty.
         */ this.inputKeyboardCapture = GetValue(config, "input.keyboard.capture", []);
                    /**
         * @const {(boolean|object)} Phaser.Core.Config#inputMouse - Enable the Mouse Plugin. This can be disabled in games that don't need mouse input.
         */ this.inputMouse = GetValue(config, "input.mouse", true);
                    /**
         * @const {?*} Phaser.Core.Config#inputMouseEventTarget - The DOM Target to listen for mouse events on. Defaults to the game canvas if not specified.
         */ this.inputMouseEventTarget = GetValue(config, "input.mouse.target", null);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultDown - Should `mousedown` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultDown = GetValue(config, "input.mouse.preventDefaultDown", true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultUp - Should `mouseup` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultUp = GetValue(config, "input.mouse.preventDefaultUp", true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultMove - Should `mousemove` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultMove = GetValue(config, "input.mouse.preventDefaultMove", true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultWheel - Should `wheel` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultWheel = GetValue(config, "input.mouse.preventDefaultWheel", true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputTouch - Enable the Touch Plugin. This can be disabled in games that don't need touch input.
         */ this.inputTouch = GetValue(config, "input.touch", Device.input.touch);
                    /**
         * @const {?*} Phaser.Core.Config#inputTouchEventTarget - The DOM Target to listen for touch events on. Defaults to the game canvas if not specified.
         */ this.inputTouchEventTarget = GetValue(config, "input.touch.target", null);
                    /**
         * @const {boolean} Phaser.Core.Config#inputTouchCapture - Should touch events be captured? I.e. have prevent default called on them.
         */ this.inputTouchCapture = GetValue(config, "input.touch.capture", true);
                    /**
         * @const {number} Phaser.Core.Config#inputActivePointers - The number of Pointer objects created by default. In a mouse-only, or non-multi touch game, you can leave this as 1.
         */ this.inputActivePointers = GetValue(config, "input.activePointers", 1);
                    /**
         * @const {number} Phaser.Core.Config#inputSmoothFactor - The smoothing factor to apply during Pointer movement. See {@link Phaser.Input.Pointer#smoothFactor}.
         */ this.inputSmoothFactor = GetValue(config, "input.smoothFactor", 0);
                    /**
         * @const {boolean} Phaser.Core.Config#inputWindowEvents - Should Phaser listen for input events on the Window? If you disable this, events like 'POINTER_UP_OUTSIDE' will no longer fire.
         */ this.inputWindowEvents = GetValue(config, "input.windowEvents", true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputGamepad - Enable the Gamepad Plugin. This can be disabled in games that don't need gamepad input.
         */ this.inputGamepad = GetValue(config, "input.gamepad", false);
                    /**
         * @const {*} Phaser.Core.Config#inputGamepadEventTarget - The DOM Target to listen for gamepad events on. Defaults to `window` if not specified.
         */ this.inputGamepadEventTarget = GetValue(config, "input.gamepad.target", window);
                    /**
         * @const {boolean} Phaser.Core.Config#disableContextMenu - Set to `true` to disable the right-click context menu.
         */ this.disableContextMenu = GetValue(config, "disableContextMenu", false);
                    /**
         * @const {Phaser.Types.Core.AudioConfig} Phaser.Core.Config#audio - The Audio Configuration object.
         */ this.audio = GetValue(config, "audio", {});
                    //  If you do: { banner: false } it won't display any banner at all
                    /**
         * @const {boolean} Phaser.Core.Config#hideBanner - Don't write the banner line to the console.log.
         */ this.hideBanner = GetValue(config, "banner", null) === false;
                    /**
         * @const {boolean} Phaser.Core.Config#hidePhaser - Omit Phaser's name and version from the banner.
         */ this.hidePhaser = GetValue(config, "banner.hidePhaser", false);
                    /**
         * @const {string} Phaser.Core.Config#bannerTextColor - The color of the banner text.
         */ this.bannerTextColor = GetValue(config, "banner.text", defaultBannerTextColor);
                    /**
         * @const {string[]} Phaser.Core.Config#bannerBackgroundColor - The background colors of the banner.
         */ this.bannerBackgroundColor = GetValue(config, "banner.background", defaultBannerColor);
                    if (this.gameTitle === "" && this.hidePhaser) this.hideBanner = true;
                    /**
         * @const {Phaser.Types.Core.FPSConfig} Phaser.Core.Config#fps - The Frame Rate Configuration object, as parsed by the Timestep class.
         */ this.fps = GetValue(config, "fps", null);
                    //  Renderer Settings
                    //  These can either be in a `render` object within the Config, or specified on their own
                    var renderConfig = GetValue(config, "render", config);
                    /**
         * @const {Phaser.Types.Core.PipelineConfig} Phaser.Core.Config#pipeline - An object mapping WebGL names to WebGLPipeline classes. These should be class constructors, not instances.
         */ this.pipeline = GetValue(renderConfig, "pipeline", null);
                    /**
         * @const {boolean} Phaser.Core.Config#antialias - When set to `true`, WebGL uses linear interpolation to draw scaled or rotated textures, giving a smooth appearance. When set to `false`, WebGL uses nearest-neighbor interpolation, giving a crisper appearance. `false` also disables antialiasing of the game canvas itself, if the browser supports it, when the game canvas is scaled.
         */ this.antialias = GetValue(renderConfig, "antialias", true);
                    /**
         * @const {boolean} Phaser.Core.Config#antialiasGL - Sets the `antialias` property when the WebGL context is created. Setting this value does not impact any subsequent textures that are created, or the canvas style attributes.
         */ this.antialiasGL = GetValue(renderConfig, "antialiasGL", true);
                    /**
         * @const {string} Phaser.Core.Config#mipmapFilter - Sets the `mipmapFilter` property when the WebGL renderer is created.
         */ this.mipmapFilter = GetValue(renderConfig, "mipmapFilter", "LINEAR");
                    /**
         * @const {boolean} Phaser.Core.Config#desynchronized - When set to `true` it will create a desynchronized context for both 2D and WebGL. See https://developers.google.com/web/updates/2019/05/desynchronized for details.
         */ this.desynchronized = GetValue(renderConfig, "desynchronized", false);
                    /**
         * @const {boolean} Phaser.Core.Config#roundPixels - Draw texture-based Game Objects at only whole-integer positions. Game Objects without textures, like Graphics, ignore this property.
         */ this.roundPixels = GetValue(renderConfig, "roundPixels", false);
                    /**
         * @const {boolean} Phaser.Core.Config#pixelArt - Prevent pixel art from becoming blurred when scaled. It will remain crisp (tells the WebGL renderer to automatically create textures using a linear filter mode).
         */ this.pixelArt = GetValue(renderConfig, "pixelArt", this.zoom !== 1);
                    if (this.pixelArt) {
                        this.antialias = false;
                        this.antialiasGL = false;
                        this.roundPixels = true;
                    }
                    /**
         * @const {boolean} Phaser.Core.Config#transparent - Whether the game canvas will have a transparent background.
         */ this.transparent = GetValue(renderConfig, "transparent", false);
                    /**
         * @const {boolean} Phaser.Core.Config#clearBeforeRender - Whether the game canvas will be cleared between each rendering frame. You can disable this if you have a full-screen background image or game object.
         */ this.clearBeforeRender = GetValue(renderConfig, "clearBeforeRender", true);
                    /**
         * @const {boolean} Phaser.Core.Config#preserveDrawingBuffer - If the value is true the WebGL buffers will not be cleared and will preserve their values until cleared or overwritten by the author.
         */ this.preserveDrawingBuffer = GetValue(renderConfig, "preserveDrawingBuffer", false);
                    /**
         * @const {boolean} Phaser.Core.Config#premultipliedAlpha - In WebGL mode, sets the drawing buffer to contain colors with pre-multiplied alpha.
         */ this.premultipliedAlpha = GetValue(renderConfig, "premultipliedAlpha", true);
                    /**
         * @const {boolean} Phaser.Core.Config#failIfMajorPerformanceCaveat - Let the browser abort creating a WebGL context if it judges performance would be unacceptable.
         */ this.failIfMajorPerformanceCaveat = GetValue(renderConfig, "failIfMajorPerformanceCaveat", false);
                    /**
         * @const {string} Phaser.Core.Config#powerPreference - "high-performance", "low-power" or "default". A hint to the browser on how much device power the game might use.
         */ this.powerPreference = GetValue(renderConfig, "powerPreference", "default");
                    /**
         * @const {number} Phaser.Core.Config#batchSize - The default WebGL Batch size. Represents the number of _quads_ that can be added to a single batch.
         */ this.batchSize = GetValue(renderConfig, "batchSize", 4096);
                    /**
         * @const {number} Phaser.Core.Config#maxTextures - When in WebGL mode, this sets the maximum number of GPU Textures to use. The default, -1, will use all available units. The WebGL1 spec says all browsers should provide a minimum of 8.
         */ this.maxTextures = GetValue(renderConfig, "maxTextures", -1);
                    /**
         * @const {number} Phaser.Core.Config#maxLights - The maximum number of lights allowed to be visible within range of a single Camera in the LightManager.
         */ this.maxLights = GetValue(renderConfig, "maxLights", 10);
                    var bgc = GetValue(config, "backgroundColor", 0);
                    /**
         * @const {Phaser.Display.Color} Phaser.Core.Config#backgroundColor - The background color of the game canvas. The default is black. This value is ignored if `transparent` is set to `true`.
         */ this.backgroundColor = ValueToColor(bgc);
                    if (this.transparent) {
                        this.backgroundColor = ValueToColor(0x000000);
                        this.backgroundColor.alpha = 0;
                    }
                    /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#preBoot - Called before Phaser boots. Useful for initializing anything not related to Phaser that Phaser may require while booting.
         */ this.preBoot = GetValue(config, "callbacks.preBoot", NOOP);
                    /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#postBoot - A function to run at the end of the boot sequence. At this point, all the game systems have started and plugins have been loaded.
         */ this.postBoot = GetValue(config, "callbacks.postBoot", NOOP);
                    /**
         * @const {Phaser.Types.Core.PhysicsConfig} Phaser.Core.Config#physics - The Physics Configuration object.
         */ this.physics = GetValue(config, "physics", {});
                    /**
         * @const {(boolean|string)} Phaser.Core.Config#defaultPhysicsSystem - The default physics system. It will be started for each scene. Either 'arcade', 'impact' or 'matter'.
         */ this.defaultPhysicsSystem = GetValue(this.physics, "default", false);
                    /**
         * @const {string} Phaser.Core.Config#loaderBaseURL - A URL used to resolve paths given to the loader. Example: 'http://labs.phaser.io/assets/'.
         */ this.loaderBaseURL = GetValue(config, "loader.baseURL", "");
                    /**
         * @const {string} Phaser.Core.Config#loaderPath - A URL path used to resolve relative paths given to the loader. Example: 'images/sprites/'.
         */ this.loaderPath = GetValue(config, "loader.path", "");
                    /**
         * @const {number} Phaser.Core.Config#loaderMaxParallelDownloads - Maximum parallel downloads allowed for resources (Default to 32).
         */ var defaultParallel = Device.os.android ? 6 : 32;
                    this.loaderMaxParallelDownloads = GetValue(config, "loader.maxParallelDownloads", defaultParallel);
                    /**
         * @const {(string|undefined)} Phaser.Core.Config#loaderCrossOrigin - 'anonymous', 'use-credentials', or `undefined`. If you're not making cross-origin requests, leave this as `undefined`. See {@link https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes}.
         */ this.loaderCrossOrigin = GetValue(config, "loader.crossOrigin", undefined);
                    /**
         * @const {string} Phaser.Core.Config#loaderResponseType - The response type of the XHR request, e.g. `blob`, `text`, etc.
         */ this.loaderResponseType = GetValue(config, "loader.responseType", "");
                    /**
         * @const {boolean} Phaser.Core.Config#loaderAsync - Should the XHR request use async or not?
         */ this.loaderAsync = GetValue(config, "loader.async", true);
                    /**
         * @const {string} Phaser.Core.Config#loaderUser - Optional username for all XHR requests.
         */ this.loaderUser = GetValue(config, "loader.user", "");
                    /**
         * @const {string} Phaser.Core.Config#loaderPassword - Optional password for all XHR requests.
         */ this.loaderPassword = GetValue(config, "loader.password", "");
                    /**
         * @const {number} Phaser.Core.Config#loaderTimeout - Optional XHR timeout value, in ms.
         */ this.loaderTimeout = GetValue(config, "loader.timeout", 0);
                    /**
         * @const {boolean} Phaser.Core.Config#loaderWithCredentials - Optional XHR withCredentials value.
         */ this.loaderWithCredentials = GetValue(config, "loader.withCredentials", false);
                    /*
         * Allows `plugins` property to either be an array, in which case it just replaces
         * the default plugins like previously, or a config object.
         *
         * plugins: {
         *    global: [
         *        { key: 'TestPlugin', plugin: TestPlugin, start: true, data: { msg: 'The plugin is alive' } },
         *    ],
         *    scene: [
         *        { key: 'WireFramePlugin', plugin: WireFramePlugin, systemKey: 'wireFramePlugin', sceneKey: 'wireframe' }
         *    ],
         *    default: [], OR
         *    defaultMerge: [
         *        'ModPlayer'
         *    ]
         * }
         */ /**
         * @const {any} Phaser.Core.Config#installGlobalPlugins - An array of global plugins to be installed.
         */ this.installGlobalPlugins = [];
                    /**
         * @const {any} Phaser.Core.Config#installScenePlugins - An array of Scene level plugins to be installed.
         */ this.installScenePlugins = [];
                    var plugins = GetValue(config, "plugins", null);
                    var defaultPlugins = DefaultPlugins.DefaultScene;
                    if (plugins) {
                        //  Old 3.7 array format?
                        if (Array.isArray(plugins)) this.defaultPlugins = plugins;
                        else if (IsPlainObject(plugins)) {
                            this.installGlobalPlugins = GetFastValue(plugins, "global", []);
                            this.installScenePlugins = GetFastValue(plugins, "scene", []);
                            if (Array.isArray(plugins.default)) defaultPlugins = plugins.default;
                            else if (Array.isArray(plugins.defaultMerge)) defaultPlugins = defaultPlugins.concat(plugins.defaultMerge);
                        }
                    }
                    /**
         * @const {any} Phaser.Core.Config#defaultPlugins - The plugins installed into every Scene (in addition to CoreScene and Global).
         */ this.defaultPlugins = defaultPlugins;
                    //  Default / Missing Images
                    var pngPrefix = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAg";
                    /**
         * @const {string} Phaser.Core.Config#defaultImage - A base64 encoded PNG that will be used as the default blank texture.
         */ this.defaultImage = GetValue(config, "images.default", pngPrefix + "AQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==");
                    /**
         * @const {string} Phaser.Core.Config#missingImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is missing or not loaded.
         */ this.missingImage = GetValue(config, "images.missing", pngPrefix + "CAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==");
                    /**
         * @const {string} Phaser.Core.Config#whiteImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is white or not loaded.
         */ this.whiteImage = GetValue(config, "images.white", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABdJREFUeNpi/P//PwMMMDEgAdwcgAADAJZuAwXJYZOzAAAAAElFTkSuQmCC");
                    if (window) {
                        if (window.FORCE_WEBGL) this.renderType = CONST.WEBGL;
                        else if (window.FORCE_CANVAS) this.renderType = CONST.CANVAS;
                    }
                }
            });
            module1.exports = Config;
        /***/ },
        /* 347 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  This singleton is instantiated as soon as Phaser loads,
            //  before a Phaser.Game instance has even been created.
            //  Which means all instances of Phaser Games can share it,
            //  without having to re-poll the device all over again
            /**
 * @namespace Phaser.Device
 * @since 3.0.0
 */ /**
 * @typedef {object} Phaser.DeviceConf
 *
 * @property {Phaser.Device.OS} os - The OS Device functions.
 * @property {Phaser.Device.Browser} browser - The Browser Device functions.
 * @property {Phaser.Device.Features} features - The Features Device functions.
 * @property {Phaser.Device.Input} input - The Input Device functions.
 * @property {Phaser.Device.Audio} audio - The Audio Device functions.
 * @property {Phaser.Device.Video} video - The Video Device functions.
 * @property {Phaser.Device.Fullscreen} fullscreen - The Fullscreen Device functions.
 * @property {Phaser.Device.CanvasFeatures} canvasFeatures - The Canvas Device functions.
 */ module1.exports = {
                os: __webpack_require__(105),
                browser: __webpack_require__(136),
                features: __webpack_require__(191),
                input: __webpack_require__(808),
                audio: __webpack_require__(809),
                video: __webpack_require__(810),
                fullscreen: __webpack_require__(811),
                canvasFeatures: __webpack_require__(348)
            };
        /***/ },
        /* 348 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            /**
 * Determines the canvas features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.canvasFeatures` from within any Scene.
 *
 * @typedef {object} Phaser.Device.CanvasFeatures
 * @since 3.0.0
 *
 * @property {boolean} supportInverseAlpha - Set to true if the browser supports inversed alpha.
 * @property {boolean} supportNewBlendModes - Set to true if the browser supports new canvas blend modes.
 */ var CanvasFeatures = {
                supportInverseAlpha: false,
                supportNewBlendModes: false
            };
            function checkBlendMode() {
                var pngHead = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/";
                var pngEnd = "AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==";
                var magenta = new Image();
                magenta.onload = function() {
                    var yellow = new Image();
                    yellow.onload = function() {
                        var canvas = CanvasPool.create(yellow, 6, 1);
                        var context = canvas.getContext("2d");
                        context.globalCompositeOperation = "multiply";
                        context.drawImage(magenta, 0, 0);
                        context.drawImage(yellow, 2, 0);
                        if (!context.getImageData(2, 0, 1, 1)) return false;
                        var data = context.getImageData(2, 0, 1, 1).data;
                        CanvasPool.remove(yellow);
                        CanvasFeatures.supportNewBlendModes = data[0] === 255 && data[1] === 0 && data[2] === 0;
                    };
                    yellow.src = pngHead + "/wCKxvRF" + pngEnd;
                };
                magenta.src = pngHead + "AP804Oa6" + pngEnd;
                return false;
            }
            function checkInverseAlpha() {
                var canvas = CanvasPool.create(this, 2, 1);
                var context = canvas.getContext("2d");
                context.fillStyle = "rgba(10, 20, 30, 0.5)";
                //  Draw a single pixel
                context.fillRect(0, 0, 1, 1);
                //  Get the color values
                var s1 = context.getImageData(0, 0, 1, 1);
                if (s1 === null) return false;
                //  Plot them to x2
                context.putImageData(s1, 1, 0);
                //  Get those values
                var s2 = context.getImageData(1, 0, 1, 1);
                //  Compare and return
                return s2.data[0] === s1.data[0] && s2.data[1] === s1.data[1] && s2.data[2] === s1.data[2] && s2.data[3] === s1.data[3];
            }
            function init() {
                if (typeof importScripts !== "function" && document !== undefined) {
                    CanvasFeatures.supportNewBlendModes = checkBlendMode();
                    CanvasFeatures.supportInverseAlpha = checkInverseAlpha();
                }
                return CanvasFeatures;
            }
            module1.exports = init();
        /***/ },
        /* 349 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * @function Phaser.Math.Angle.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var Between = function(x1, y1, x2, y2) {
                return Math.atan2(y2 - y1, x2 - x1);
            };
            module1.exports = Between;
        /***/ },
        /* 350 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * Calculates the angle of the vector from the first point to the second point.
 *
 * @function Phaser.Math.Angle.BetweenPoints
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPoints = function(point1, point2) {
                return Math.atan2(point2.y - point1.y, point2.x - point1.x);
            };
            module1.exports = BetweenPoints;
        /***/ },
        /* 351 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Normalize an angle to the [0, 2pi] range.
 *
 * @function Phaser.Math.Angle.Normalize
 * @since 3.0.0
 *
 * @param {number} angle - The angle to normalize, in radians.
 *
 * @return {number} The normalized angle, in radians.
 */ var Normalize = function(angle) {
                angle = angle % (2 * Math.PI);
                if (angle >= 0) return angle;
                else return angle + 2 * Math.PI;
            };
            module1.exports = Normalize;
        /***/ },
        /* 352 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPoints
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The distance between the points.
 */ var DistanceBetweenPoints = function(a, b) {
                var dx = a.x - b.x;
                var dy = a.y - b.y;
                return Math.sqrt(dx * dx + dy * dy);
            };
            module1.exports = DistanceBetweenPoints;
        /***/ },
        /* 353 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points), squared.
 *
 * @function Phaser.Math.Distance.Squared
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point, squared.
 */ var DistanceSquared = function(x1, y1, x2, y2) {
                var dx = x1 - x2;
                var dy = y1 - y2;
                return dx * dx + dy * dy;
            };
            module1.exports = DistanceSquared;
        /***/ },
        /* 354 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily greater than `b`.
 *
 * `a` is fuzzily greater than `b` if it is more than `b - epsilon`.
 *
 * @function Phaser.Math.Fuzzy.GreaterThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily greater than than `b`, otherwise `false`.
 */ var GreaterThan = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return a > b - epsilon;
            };
            module1.exports = GreaterThan;
        /***/ },
        /* 355 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily less than `b`.
 *
 * `a` is fuzzily less than `b` if it is less than `b + epsilon`.
 *
 * @function Phaser.Math.Fuzzy.LessThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily less than `b`, otherwise `false`.
 */ var LessThan = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return a < b + epsilon;
            };
            module1.exports = LessThan;
        /***/ },
        /* 356 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Factorial = __webpack_require__(357);
            /**
 * Calculates the Bernstein basis from the three factorial coefficients.
 *
 * @function Phaser.Math.Bernstein
 * @since 3.0.0
 *
 * @param {number} n - The first value.
 * @param {number} i - The second value.
 *
 * @return {number} The Bernstein basis of Factorial(n) / Factorial(i) / Factorial(n - i)
 */ var Bernstein = function(n, i) {
                return Factorial(n) / Factorial(i) / Factorial(n - i);
            };
            module1.exports = Bernstein;
        /***/ },
        /* 357 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the factorial of a given number for integer values greater than 0.
 *
 * @function Phaser.Math.Factorial
 * @since 3.0.0
 *
 * @param {number} value - A positive integer to calculate the factorial of.
 *
 * @return {number} The factorial of the given number.
 */ var Factorial = function(value) {
                if (value === 0) return 1;
                var res = value;
                while(--value)res *= value;
                return res;
            };
            module1.exports = Factorial;
        /***/ },
        /* 358 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                var k = 1 - t;
                return k * k * k * p;
            }
            /**
 * @ignore
 */ function P1(t, p) {
                var k = 1 - t;
                return 3 * k * k * t * p;
            }
            /**
 * @ignore
 */ function P2(t, p) {
                return 3 * (1 - t) * t * t * p;
            }
            /**
 * @ignore
 */ function P3(t, p) {
                return t * t * t * p;
            }
            /**
 * A cubic bezier interpolation method.
 *
 * https://medium.com/@adrian_cooney/bezier-interpolation-13b68563313a
 *
 * @function Phaser.Math.Interpolation.CubicBezier
 * @since 3.0.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The first control point.
 * @param {number} p2 - The second control point.
 * @param {number} p3 - The end point.
 *
 * @return {number} The interpolated value.
 */ var CubicBezierInterpolation = function(t, p0, p1, p2, p3) {
                return P0(t, p0) + P1(t, p1) + P2(t, p2) + P3(t, p3);
            };
            module1.exports = CubicBezierInterpolation;
        /***/ },
        /* 359 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                var k = 1 - t;
                return k * k * p;
            }
            /**
 * @ignore
 */ function P1(t, p) {
                return 2 * (1 - t) * t * p;
            }
            /**
 * @ignore
 */ function P2(t, p) {
                return t * t * p;
            }
            // https://github.com/mrdoob/three.js/blob/master/src/extras/core/Interpolations.js
            /**
 * A quadratic bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.QuadraticBezier
 * @since 3.2.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The control point.
 * @param {number} p2 - The end point.
 *
 * @return {number} The interpolated value.
 */ var QuadraticBezierInterpolation = function(t, p0, p1, p2) {
                return P0(t, p0) + P1(t, p1) + P2(t, p2);
            };
            module1.exports = QuadraticBezierInterpolation;
        /***/ },
        /* 360 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmoothStep = __webpack_require__(184);
            /**
 * A Smooth Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmoothStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmoothStepInterpolation = function(t, min, max) {
                return min + (max - min) * SmoothStep(t, 0, 1);
            };
            module1.exports = SmoothStepInterpolation;
        /***/ },
        /* 361 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the nearest power of 2 to the given `value`.
 *
 * @function Phaser.Math.Pow2.GetNext
 * @since 3.0.0
 *
 * @param {number} value - The value.
 *
 * @return {number} The nearest power of 2 to `value`.
 */ var GetPowerOfTwo = function(value) {
                var index = Math.log(value) / 0.6931471805599453;
                return 1 << Math.ceil(index);
            };
            module1.exports = GetPowerOfTwo;
        /***/ },
        /* 362 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a given point by a given angle around the origin (0, 0), in an anti-clockwise direction.
 *
 * @function Phaser.Math.Rotate
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} angle - The angle to be rotated by in an anticlockwise direction.
 *
 * @return {Phaser.Geom.Point} The given point, rotated by the given angle in an anticlockwise direction.
 */ var Rotate = function(point, angle) {
                var x = point.x;
                var y = point.y;
                point.x = x * Math.cos(angle) - y * Math.sin(angle);
                point.y = x * Math.sin(angle) + y * Math.cos(angle);
                return point;
            };
            module1.exports = Rotate;
        /***/ },
        /* 363 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a given number so it is further away from zero. That is, positive numbers are rounded up, and negative numbers are rounded down.
 *
 * @function Phaser.Math.RoundAwayFromZero
 * @since 3.0.0
 *
 * @param {number} value - The number to round.
 *
 * @return {number} The rounded number, rounded away from zero.
 */ var RoundAwayFromZero = function(value) {
                // "Opposite" of truncate.
                return value > 0 ? Math.ceil(value) : Math.floor(value);
            };
            module1.exports = RoundAwayFromZero;
        /***/ },
        /* 364 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A three-dimensional matrix.
 *
 * Defaults to the identity matrix when instantiated.
 *
 * @class Matrix3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix3} [m] - Optional Matrix3 to copy values from.
 */ var Matrix3 = new Class({
                initialize: function Matrix3(m) {
                    /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix3#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(9);
                    if (m) //  Assume Matrix3 with val:
                    this.copy(m);
                    else //  Default to identity
                    this.identity();
                },
                /**
     * Make a clone of this Matrix3.
     *
     * @method Phaser.Math.Matrix3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} A clone of this Matrix3.
     */ clone: function() {
                    return new Matrix3(this);
                },
                /**
     * This method is an alias for `Matrix3.copy`.
     *
     * @method Phaser.Math.Matrix3#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ set: function(src) {
                    return this.copy(src);
                },
                /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix3#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ copy: function(src) {
                    var out = this.val;
                    var a = src.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[3];
                    out[4] = a[4];
                    out[5] = a[5];
                    out[6] = a[6];
                    out[7] = a[7];
                    out[8] = a[8];
                    return this;
                },
                /**
     * Copy the values of a given Matrix4 into this Matrix3.
     *
     * @method Phaser.Math.Matrix3#fromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromMat4: function(m) {
                    var a = m.val;
                    var out = this.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[4];
                    out[4] = a[5];
                    out[5] = a[6];
                    out[6] = a[8];
                    out[7] = a[9];
                    out[8] = a[10];
                    return this;
                },
                /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix3#fromArray
     * @since 3.0.0
     *
     * @param {array} a - The array to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromArray: function(a) {
                    var out = this.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[3];
                    out[4] = a[4];
                    out[5] = a[5];
                    out[6] = a[6];
                    out[7] = a[7];
                    out[8] = a[8];
                    return this;
                },
                /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix3#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ identity: function() {
                    var out = this.val;
                    out[0] = 1;
                    out[1] = 0;
                    out[2] = 0;
                    out[3] = 0;
                    out[4] = 1;
                    out[5] = 0;
                    out[6] = 0;
                    out[7] = 0;
                    out[8] = 1;
                    return this;
                },
                /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix3#transpose
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ transpose: function() {
                    var a = this.val;
                    var a01 = a[1];
                    var a02 = a[2];
                    var a12 = a[5];
                    a[1] = a[3];
                    a[2] = a[6];
                    a[3] = a01;
                    a[5] = a[7];
                    a[6] = a02;
                    a[7] = a12;
                    return this;
                },
                /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix3#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ invert: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    var b01 = a22 * a11 - a12 * a21;
                    var b11 = -a22 * a10 + a12 * a20;
                    var b21 = a21 * a10 - a11 * a20;
                    // Calculate the determinant
                    var det = a00 * b01 + a01 * b11 + a02 * b21;
                    if (!det) return null;
                    det = 1 / det;
                    a[0] = b01 * det;
                    a[1] = (-a22 * a01 + a02 * a21) * det;
                    a[2] = (a12 * a01 - a02 * a11) * det;
                    a[3] = b11 * det;
                    a[4] = (a22 * a00 - a02 * a20) * det;
                    a[5] = (-a12 * a00 + a02 * a10) * det;
                    a[6] = b21 * det;
                    a[7] = (-a21 * a00 + a01 * a20) * det;
                    a[8] = (a11 * a00 - a01 * a10) * det;
                    return this;
                },
                /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix3#adjoint
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ adjoint: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    a[0] = a11 * a22 - a12 * a21;
                    a[1] = a02 * a21 - a01 * a22;
                    a[2] = a01 * a12 - a02 * a11;
                    a[3] = a12 * a20 - a10 * a22;
                    a[4] = a00 * a22 - a02 * a20;
                    a[5] = a02 * a10 - a00 * a12;
                    a[6] = a10 * a21 - a11 * a20;
                    a[7] = a01 * a20 - a00 * a21;
                    a[8] = a00 * a11 - a01 * a10;
                    return this;
                },
                /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix3#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix3#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to multiply this Matrix by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ multiply: function(src) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    var b = src.val;
                    var b00 = b[0];
                    var b01 = b[1];
                    var b02 = b[2];
                    var b10 = b[3];
                    var b11 = b[4];
                    var b12 = b[5];
                    var b20 = b[6];
                    var b21 = b[7];
                    var b22 = b[8];
                    a[0] = b00 * a00 + b01 * a10 + b02 * a20;
                    a[1] = b00 * a01 + b01 * a11 + b02 * a21;
                    a[2] = b00 * a02 + b01 * a12 + b02 * a22;
                    a[3] = b10 * a00 + b11 * a10 + b12 * a20;
                    a[4] = b10 * a01 + b11 * a11 + b12 * a21;
                    a[5] = b10 * a02 + b11 * a12 + b12 * a22;
                    a[6] = b20 * a00 + b21 * a10 + b22 * a20;
                    a[7] = b20 * a01 + b21 * a11 + b22 * a21;
                    a[8] = b20 * a02 + b21 * a12 + b22 * a22;
                    return this;
                },
                /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix3#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ translate: function(v) {
                    var a = this.val;
                    var x = v.x;
                    var y = v.y;
                    a[6] = x * a[0] + y * a[3] + a[6];
                    a[7] = x * a[1] + y * a[4] + a[7];
                    a[8] = x * a[2] + y * a[5] + a[8];
                    return this;
                },
                /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix3#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ rotate: function(rad) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    a[0] = c * a00 + s * a10;
                    a[1] = c * a01 + s * a11;
                    a[2] = c * a02 + s * a12;
                    a[3] = c * a10 - s * a00;
                    a[4] = c * a11 - s * a01;
                    a[5] = c * a12 - s * a02;
                    return this;
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x` and `y` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix3#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ scale: function(v) {
                    var a = this.val;
                    var x = v.x;
                    var y = v.y;
                    a[0] = x * a[0];
                    a[1] = x * a[1];
                    a[2] = x * a[2];
                    a[3] = y * a[3];
                    a[4] = y * a[4];
                    a[5] = y * a[5];
                    return this;
                },
                /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix3#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromQuat: function(q) {
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    var out = this.val;
                    out[0] = 1 - (yy + zz);
                    out[3] = xy + wz;
                    out[6] = xz - wy;
                    out[1] = xy - wz;
                    out[4] = 1 - (xx + zz);
                    out[7] = yz + wx;
                    out[2] = xz + wy;
                    out[5] = yz - wx;
                    out[8] = 1 - (xx + yy);
                    return this;
                },
                /**
     * Set the values of this Matrix3 to be normalized from the given Matrix4.
     *
     * @method Phaser.Math.Matrix3#normalFromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to normalize the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ normalFromMat4: function(m) {
                    var a = m.val;
                    var out = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    // Calculate the determinant
                    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    if (!det) return null;
                    det = 1 / det;
                    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
                    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
                    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
                    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
                    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
                    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
                    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
                    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
                    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
                    return this;
                }
            });
            module1.exports = Matrix3;
        /***/ },
        /* 365 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            var Matrix3 = __webpack_require__(364);
            var NOOP = __webpack_require__(1);
            var Vector3 = __webpack_require__(39);
            var EPSILON = 0.000001;
            //  Some shared 'private' arrays
            var siNext = new Int8Array([
                1,
                2,
                0
            ]);
            var tmp = new Float32Array([
                0,
                0,
                0
            ]);
            var xUnitVec3 = new Vector3(1, 0, 0);
            var yUnitVec3 = new Vector3(0, 1, 0);
            var tmpvec = new Vector3();
            var tmpMat3 = new Matrix3();
            /**
 * @classdesc
 * A quaternion.
 *
 * @class Quaternion
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x component.
 * @param {number} [y=0] - The y component.
 * @param {number} [z=0] - The z component.
 * @param {number} [w=1] - The w component.
 */ var Quaternion = new Class({
                initialize: function Quaternion(x, y, z, w) {
                    /**
         * The x component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_x
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The y component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_y
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The z component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_z
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The w component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_w
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * This callback is invoked, if set, each time a value in this quaternion is changed.
         * The callback is passed one argument, a reference to this quaternion.
         *
         * @name Phaser.Math.Quaternion#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                    this.set(x, y, z, w);
                },
                /**
     * The x component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The y component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The z component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(value) {
                        this._z = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The w component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: {
                    get: function() {
                        return this._w;
                    },
                    set: function(value) {
                        this._w = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * Copy the components of a given Quaternion or Vector into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} src - The Quaternion or Vector to copy the components from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ copy: function(src) {
                    return this.set(src);
                },
                /**
     * Set the components of this Quaternion and optionally call the `onChangeCallback`.
     *
     * @method Phaser.Math.Quaternion#set
     * @since 3.0.0
     *
     * @param {(number|object)} [x=0] - The x component, or an object containing x, y, z, and w components.
     * @param {number} [y=0] - The y component.
     * @param {number} [z=0] - The z component.
     * @param {number} [w=0] - The w component.
     * @param {boolean} [update=true] - Call the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ set: function(x, y, z, w, update) {
                    if (update === undefined) update = true;
                    if (typeof x === "object") {
                        this._x = x.x || 0;
                        this._y = x.y || 0;
                        this._z = x.z || 0;
                        this._w = x.w || 0;
                    } else {
                        this._x = x || 0;
                        this._y = y || 0;
                        this._z = z || 0;
                        this._w = w || 0;
                    }
                    if (update) this.onChangeCallback(this);
                    return this;
                },
                /**
     * Add a given Quaternion or Vector to this Quaternion. Addition is component-wise.
     *
     * @method Phaser.Math.Quaternion#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to add to this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ add: function(v) {
                    this._x += v.x;
                    this._y += v.y;
                    this._z += v.z;
                    this._w += v.w;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Subtract a given Quaternion or Vector from this Quaternion. Subtraction is component-wise.
     *
     * @method Phaser.Math.Quaternion#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to subtract from this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ subtract: function(v) {
                    this._x -= v.x;
                    this._y -= v.y;
                    this._z -= v.z;
                    this._w -= v.w;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Scale this Quaternion by the given value.
     *
     * @method Phaser.Math.Quaternion#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ scale: function(scale) {
                    this._x *= scale;
                    this._y *= scale;
                    this._z *= scale;
                    this._w *= scale;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Calculate the length of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#length
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return Math.sqrt(x * x + y * y + z * z + w * w);
                },
                /**
     * Calculate the length of this Quaternion squared.
     *
     * @method Phaser.Math.Quaternion#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return x * x + y * y + z * z + w * w;
                },
                /**
     * Normalize this Quaternion.
     *
     * @method Phaser.Math.Quaternion#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var len = x * x + y * y + z * z + w * w;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this._x = x * len;
                        this._y = y * len;
                        this._z = z * len;
                        this._w = w * len;
                    }
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Calculate the dot product of this Quaternion and the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#dot
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to dot product with this Quaternion.
     *
     * @return {number} The dot product of this Quaternion and the given Quaternion or Vector.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                },
                /**
     * Linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#lerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to interpolate towards.
     * @param {number} [t=0] - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    return this.set(ax + t * (v.x - ax), ay + t * (v.y - ay), az + t * (v.z - az), aw + t * (v.w - aw));
                },
                /**
     * Rotates this Quaternion based on the two given vectors.
     *
     * @method Phaser.Math.Quaternion#rotationTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The transform rotation vector.
     * @param {Phaser.Math.Vector3} b - The target rotation vector.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotationTo: function(a, b) {
                    var dot = a.x * b.x + a.y * b.y + a.z * b.z;
                    if (dot < -0.999999) {
                        if (tmpvec.copy(xUnitVec3).cross(a).length() < EPSILON) tmpvec.copy(yUnitVec3).cross(a);
                        tmpvec.normalize();
                        return this.setAxisAngle(tmpvec, Math.PI);
                    } else if (dot > 0.999999) return this.set(0, 0, 0, 1);
                    else {
                        tmpvec.copy(a).cross(b);
                        this._x = tmpvec.x;
                        this._y = tmpvec.y;
                        this._z = tmpvec.z;
                        this._w = 1 + dot;
                        return this.normalize();
                    }
                },
                /**
     * Set the axes of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxes
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} view - The view axis.
     * @param {Phaser.Math.Vector3} right - The right axis.
     * @param {Phaser.Math.Vector3} up - The upwards axis.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxes: function(view, right, up) {
                    var m = tmpMat3.val;
                    m[0] = right.x;
                    m[3] = right.y;
                    m[6] = right.z;
                    m[1] = up.x;
                    m[4] = up.y;
                    m[7] = up.z;
                    m[2] = -view.x;
                    m[5] = -view.y;
                    m[8] = -view.z;
                    return this.fromMat3(tmpMat3).normalize();
                },
                /**
     * Reset this Matrix to an identity (default) Quaternion.
     *
     * @method Phaser.Math.Quaternion#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ identity: function() {
                    return this.set(0, 0, 0, 1);
                },
                /**
     * Set the axis angle of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxisAngle
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} axis - The axis.
     * @param {number} rad - The angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxisAngle: function(axis, rad) {
                    rad = rad * 0.5;
                    var s = Math.sin(rad);
                    return this.set(s * axis.x, s * axis.y, s * axis.z, Math.cos(rad));
                },
                /**
     * Multiply this Quaternion by the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to multiply this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ multiply: function(b) {
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    var bw = b.w;
                    return this.set(ax * bw + aw * bx + ay * bz - az * by, ay * bw + aw * by + az * bx - ax * bz, az * bw + aw * bz + ax * by - ay * bx, aw * bw - ax * bx - ay * by - az * bz);
                },
                /**
     * Smoothly linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#slerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to interpolate towards.
     * @param {number} t - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ slerp: function(b, t) {
                    // benchmarks: http://jsperf.com/quaternion-slerp-implementations
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    var bw = b.w;
                    // calc cosine
                    var cosom = ax * bx + ay * by + az * bz + aw * bw;
                    // adjust signs (if necessary)
                    if (cosom < 0) {
                        cosom = -cosom;
                        bx = -bx;
                        by = -by;
                        bz = -bz;
                        bw = -bw;
                    }
                    // "from" and "to" quaternions are very close
                    //  ... so we can do a linear interpolation
                    var scale0 = 1 - t;
                    var scale1 = t;
                    // calculate coefficients
                    if (1 - cosom > EPSILON) {
                        // standard case (slerp)
                        var omega = Math.acos(cosom);
                        var sinom = Math.sin(omega);
                        scale0 = Math.sin((1.0 - t) * omega) / sinom;
                        scale1 = Math.sin(t * omega) / sinom;
                    }
                    // calculate final values
                    return this.set(scale0 * ax + scale1 * bx, scale0 * ay + scale1 * by, scale0 * az + scale1 * bz, scale0 * aw + scale1 * bw);
                },
                /**
     * Invert this Quaternion.
     *
     * @method Phaser.Math.Quaternion#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ invert: function() {
                    var a0 = this.x;
                    var a1 = this.y;
                    var a2 = this.z;
                    var a3 = this.w;
                    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
                    var invDot = dot ? 1 / dot : 0;
                    return this.set(-a0 * invDot, -a1 * invDot, -a2 * invDot, a3 * invDot);
                },
                /**
     * Convert this Quaternion into its conjugate.
     *
     * Sets the x, y and z components.
     *
     * @method Phaser.Math.Quaternion#conjugate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ conjugate: function() {
                    this._x = -this.x;
                    this._y = -this.y;
                    this._z = -this.z;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Rotate this Quaternion on the X axis.
     *
     * @method Phaser.Math.Quaternion#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateX: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw + aw * bx, ay * bw + az * bx, az * bw - ay * bx, aw * bw - ax * bx);
                },
                /**
     * Rotate this Quaternion on the Y axis.
     *
     * @method Phaser.Math.Quaternion#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateY: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var by = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw - az * by, ay * bw + aw * by, az * bw + ax * by, aw * bw - ay * by);
                },
                /**
     * Rotate this Quaternion on the Z axis.
     *
     * @method Phaser.Math.Quaternion#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateZ: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bz = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw + ay * bz, ay * bw - ax * bz, az * bw + aw * bz, aw * bw - az * bz);
                },
                /**
     * Create a unit (or rotation) Quaternion from its x, y, and z components.
     *
     * Sets the w component.
     *
     * @method Phaser.Math.Quaternion#calculateW
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ calculateW: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    this.w = -Math.sqrt(1.0 - x * x - y * y - z * z);
                    return this;
                },
                /**
     * Set this Quaternion from the given Euler, based on Euler order.
     *
     * @method Phaser.Math.Quaternion#setFromEuler
     * @since 3.50.0
     *
     * @param {Phaser.Math.Euler} euler - The Euler to convert from.
     * @param {boolean} [update=true] - Run the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromEuler: function(euler, update) {
                    var x = euler.x / 2;
                    var y = euler.y / 2;
                    var z = euler.z / 2;
                    var c1 = Math.cos(x);
                    var c2 = Math.cos(y);
                    var c3 = Math.cos(z);
                    var s1 = Math.sin(x);
                    var s2 = Math.sin(y);
                    var s3 = Math.sin(z);
                    switch(euler.order){
                        case "XYZ":
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case "YXZ":
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                        case "ZXY":
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case "ZYX":
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                        case "YZX":
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case "XZY":
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                    }
                    return this;
                },
                /**
     * Sets the rotation of this Quaternion from the given Matrix4.
     *
     * @method Phaser.Math.Quaternion#setFromRotationMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to set the rotation from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromRotationMatrix: function(mat4) {
                    var m = mat4.val;
                    var m11 = m[0];
                    var m12 = m[4];
                    var m13 = m[8];
                    var m21 = m[1];
                    var m22 = m[5];
                    var m23 = m[9];
                    var m31 = m[2];
                    var m32 = m[6];
                    var m33 = m[10];
                    var trace = m11 + m22 + m33;
                    var s;
                    if (trace > 0) {
                        s = 0.5 / Math.sqrt(trace + 1.0);
                        this.set((m32 - m23) * s, (m13 - m31) * s, (m21 - m12) * s, 0.25 / s);
                    } else if (m11 > m22 && m11 > m33) {
                        s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                        this.set(0.25 * s, (m12 + m21) / s, (m13 + m31) / s, (m32 - m23) / s);
                    } else if (m22 > m33) {
                        s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                        this.set((m12 + m21) / s, 0.25 * s, (m23 + m32) / s, (m13 - m31) / s);
                    } else {
                        s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                        this.set((m13 + m31) / s, (m23 + m32) / s, 0.25 * s, (m21 - m12) / s);
                    }
                    return this;
                },
                /**
     * Convert the given Matrix into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#fromMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix to convert from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ fromMat3: function(mat) {
                    // benchmarks:
                    //    http://jsperf.com/typed-array-access-speed
                    //    http://jsperf.com/conversion-of-3x3-matrix-to-quaternion
                    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
                    // article "Quaternion Calculus and Fast Animation".
                    var m = mat.val;
                    var fTrace = m[0] + m[4] + m[8];
                    var fRoot;
                    if (fTrace > 0) {
                        // |w| > 1/2, may as well choose w > 1/2
                        fRoot = Math.sqrt(fTrace + 1.0); // 2w
                        this.w = 0.5 * fRoot;
                        fRoot = 0.5 / fRoot; // 1/(4w)
                        this._x = (m[7] - m[5]) * fRoot;
                        this._y = (m[2] - m[6]) * fRoot;
                        this._z = (m[3] - m[1]) * fRoot;
                    } else {
                        // |w| <= 1/2
                        var i = 0;
                        if (m[4] > m[0]) i = 1;
                        if (m[8] > m[i * 3 + i]) i = 2;
                        var j = siNext[i];
                        var k = siNext[j];
                        //  This isn't quite as clean without array access
                        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1);
                        tmp[i] = 0.5 * fRoot;
                        fRoot = 0.5 / fRoot;
                        tmp[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
                        tmp[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
                        this._x = tmp[0];
                        this._y = tmp[1];
                        this._z = tmp[2];
                        this._w = (m[k * 3 + j] - m[j * 3 + k]) * fRoot;
                    }
                    this.onChangeCallback(this);
                    return this;
                }
            });
            module1.exports = Quaternion;
        /***/ },
        /* 366 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasInterpolation = __webpack_require__(367);
            var CanvasPool = __webpack_require__(31);
            var CONST = __webpack_require__(33);
            var Features = __webpack_require__(191);
            /**
 * Called automatically by Phaser.Game and responsible for creating the renderer it will use.
 *
 * Relies upon two webpack global flags to be defined: `WEBGL_RENDERER` and `CANVAS_RENDERER` during build time, but not at run-time.
 *
 * @function Phaser.Core.CreateRenderer
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance on which the renderer will be set.
 */ var CreateRenderer = function(game) {
                var config = game.config;
                if ((config.customEnvironment || config.canvas) && config.renderType === CONST.AUTO) throw new Error("Must set explicit renderType in custom environment");
                //  Not a custom environment, didn't provide their own canvas and not headless, so determine the renderer:
                if (!config.customEnvironment && !config.canvas && config.renderType !== CONST.HEADLESS) {
                    if (config.renderType === CONST.CANVAS || config.renderType !== CONST.CANVAS && !Features.webGL) {
                        if (Features.canvas) //  They requested Canvas and their browser supports it
                        config.renderType = CONST.CANVAS;
                        else throw new Error("Cannot create Canvas or WebGL context, aborting.");
                    } else //  Game requested WebGL and browser says it supports it
                    config.renderType = CONST.WEBGL;
                }
                //  Pixel Art mode?
                if (!config.antialias) CanvasPool.disableSmoothing();
                var baseSize = game.scale.baseSize;
                var width = baseSize.width;
                var height = baseSize.height;
                //  Does the game config provide its own canvas element to use?
                if (config.canvas) {
                    game.canvas = config.canvas;
                    game.canvas.width = width;
                    game.canvas.height = height;
                } else game.canvas = CanvasPool.create(game, width, height, config.renderType);
                //  Does the game config provide some canvas css styles to use?
                if (config.canvasStyle) game.canvas.style = config.canvasStyle;
                //  Pixel Art mode?
                if (!config.antialias) CanvasInterpolation.setCrisp(game.canvas);
                if (config.renderType === CONST.HEADLESS) //  Nothing more to do here
                return;
                var CanvasRenderer;
                var WebGLRenderer;
                CanvasRenderer = __webpack_require__(368);
                WebGLRenderer = __webpack_require__(371);
                //  Let the config pick the renderer type, as both are included
                if (config.renderType === CONST.WEBGL) game.renderer = new WebGLRenderer(game);
                else {
                    game.renderer = new CanvasRenderer(game);
                    game.context = game.renderer.gameContext;
                }
            };
            module1.exports = CreateRenderer;
        /***/ },
        /* 367 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas.CanvasInterpolation
 * @since 3.0.0
 */ var CanvasInterpolation = {
                /**
     * Sets the CSS image-rendering property on the given canvas to be 'crisp' (aka 'optimize contrast' on webkit).
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setCrisp
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setCrisp: function(canvas) {
                    var types = [
                        "optimizeSpeed",
                        "-moz-crisp-edges",
                        "-o-crisp-edges",
                        "-webkit-optimize-contrast",
                        "optimize-contrast",
                        "crisp-edges",
                        "pixelated"
                    ];
                    types.forEach(function(type) {
                        canvas.style["image-rendering"] = type;
                    });
                    canvas.style.msInterpolationMode = "nearest-neighbor";
                    return canvas;
                },
                /**
     * Sets the CSS image-rendering property on the given canvas to be 'bicubic' (aka 'auto').
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setBicubic
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setBicubic: function(canvas) {
                    canvas.style["image-rendering"] = "auto";
                    canvas.style.msInterpolationMode = "bicubic";
                    return canvas;
                }
            };
            module1.exports = CanvasInterpolation;
        /***/ },
        /* 368 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CameraEvents = __webpack_require__(37);
            var CanvasSnapshot = __webpack_require__(369);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(33);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(91);
            var GetBlendModes = __webpack_require__(370);
            var ScaleEvents = __webpack_require__(104);
            var TextureEvents = __webpack_require__(106);
            var TransformMatrix = __webpack_require__(25);
            /**
 * @classdesc
 * The Canvas Renderer is responsible for managing 2D canvas rendering contexts,
 * including the one used by the Games canvas. It tracks the internal state of a
 * given context and can renderer textured Game Objects to it, taking into
 * account alpha, blending, and scaling.
 *
 * @class CanvasRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.Canvas
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser Game instance that owns this renderer.
 */ var CanvasRenderer = new Class({
                Extends: EventEmitter,
                initialize: function CanvasRenderer(game) {
                    EventEmitter.call(this);
                    var gameConfig = game.config;
                    /**
         * The local configuration settings of the CanvasRenderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                        clearBeforeRender: gameConfig.clearBeforeRender,
                        backgroundColor: gameConfig.backgroundColor,
                        antialias: gameConfig.antialias,
                        roundPixels: gameConfig.roundPixels
                    };
                    /**
         * The Phaser Game instance that owns this renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A constant which allows the renderer to be easily identified as a Canvas Renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.CANVAS;
                    /**
         * The total number of Game Objects which were rendered in a frame.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#drawCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.drawCount = 0;
                    /**
         * The width of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * The height of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The canvas element which the Game uses.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameCanvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.gameCanvas = game.canvas;
                    var contextOptions = {
                        alpha: game.config.transparent,
                        desynchronized: game.config.desynchronized
                    };
                    /**
         * The canvas context used to render all Cameras in all Scenes during the game loop.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.gameContext = gameConfig.context ? gameConfig.context : this.gameCanvas.getContext("2d", contextOptions);
                    /**
         * The canvas context currently used by the CanvasRenderer for all rendering operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.currentContext = this.gameContext;
                    /**
         * Should the Canvas use Image Smoothing or not when drawing Sprites?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#antialias
         * @type {boolean}
         * @since 3.20.0
         */ this.antialias = game.config.antialias;
                    /**
         * The blend modes supported by the Canvas Renderer.
         *
         * This object maps the {@link Phaser.BlendModes} to canvas compositing operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#blendModes
         * @type {array}
         * @since 3.0.0
         */ this.blendModes = GetBlendModes();
                    /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.16.0
         */ this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: false,
                        callback: null,
                        type: "image/png",
                        encoder: 0.92
                    };
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                    /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                    this.init();
                },
                /**
     * Prepares the game canvas for rendering.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#init
     * @since 3.0.0
     */ init: function() {
                    this.game.textures.once(TextureEvents.READY, this.boot, this);
                },
                /**
     * Internal boot handler.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#boot
     * @private
     * @since 3.50.0
     */ boot: function() {
                    var game = this.game;
                    var baseSize = game.scale.baseSize;
                    this.width = baseSize.width;
                    this.height = baseSize.height;
                    this.isBooted = true;
                    game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.resize(baseSize.width, baseSize.height);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions multiplied by the resolution. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                    //  Has the underlying canvas size changed?
                    if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                },
                /**
     * Resize the main game canvas.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     */ resize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.emit(Events.RESIZE, width, height);
                },
                /**
     * Resets the transformation matrix of the current context to the identity matrix, thus resetting any transformation.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resetTransform
     * @since 3.0.0
     */ resetTransform: function() {
                    this.currentContext.setTransform(1, 0, 0, 1, 0, 0);
                },
                /**
     * Sets the blend mode (compositing operation) of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {string} blendMode - The new blend mode which should be used.
     *
     * @return {this} This CanvasRenderer object.
     */ setBlendMode: function(blendMode) {
                    this.currentContext.globalCompositeOperation = blendMode;
                    return this;
                },
                /**
     * Changes the Canvas Rendering Context that all draw operations are performed against.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setContext
     * @since 3.12.0
     *
     * @param {?CanvasRenderingContext2D} [ctx] - The new Canvas Rendering Context to draw everything to. Leave empty to reset to the Game Canvas.
     *
     * @return {this} The Canvas Renderer instance.
     */ setContext: function(ctx) {
                    this.currentContext = ctx ? ctx : this.gameContext;
                    return this;
                },
                /**
     * Sets the global alpha of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setAlpha
     * @since 3.0.0
     *
     * @param {number} alpha - The new alpha to use, where 0 is fully transparent and 1 is fully opaque.
     *
     * @return {this} This CanvasRenderer object.
     */ setAlpha: function(alpha) {
                    this.currentContext.globalAlpha = alpha;
                    return this;
                },
                /**
     * Called at the start of the render loop.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                    var ctx = this.gameContext;
                    var config = this.config;
                    var width = this.width;
                    var height = this.height;
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    if (config.clearBeforeRender) {
                        ctx.clearRect(0, 0, width, height);
                        if (!config.transparent) {
                            ctx.fillStyle = config.backgroundColor.rgba;
                            ctx.fillRect(0, 0, width, height);
                        }
                    }
                    ctx.save();
                    this.drawCount = 0;
                    this.emit(Events.PRE_RENDER);
                },
                /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                    var childCount = children.length;
                    this.emit(Events.RENDER, scene, camera);
                    var cx = camera.x;
                    var cy = camera.y;
                    var cw = camera.width;
                    var ch = camera.height;
                    var ctx = camera.renderToTexture ? camera.context : scene.sys.context;
                    //  Save context pre-clip
                    ctx.save();
                    if (this.game.scene.customViewports) {
                        ctx.beginPath();
                        ctx.rect(cx, cy, cw, ch);
                        ctx.clip();
                    }
                    this.currentContext = ctx;
                    var mask = camera.mask;
                    if (mask) mask.preRenderCanvas(this, null, camera._maskCamera);
                    if (!camera.transparent) {
                        ctx.fillStyle = camera.backgroundColor.rgba;
                        ctx.fillRect(cx, cy, cw, ch);
                    }
                    ctx.globalAlpha = camera.alpha;
                    ctx.globalCompositeOperation = "source-over";
                    this.drawCount += childCount;
                    if (camera.renderToTexture) camera.emit(CameraEvents.PRE_RENDER, camera);
                    camera.matrix.copyToContext(ctx);
                    for(var i = 0; i < childCount; i++){
                        var child = children[i];
                        if (child.mask) child.mask.preRenderCanvas(this, child, camera);
                        child.renderCanvas(this, child, camera);
                        if (child.mask) child.mask.postRenderCanvas(this, child, camera);
                    }
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.globalCompositeOperation = "source-over";
                    ctx.globalAlpha = 1;
                    camera.flashEffect.postRenderCanvas(ctx);
                    camera.fadeEffect.postRenderCanvas(ctx);
                    camera.dirty = false;
                    if (mask) mask.postRenderCanvas(this);
                    //  Restore pre-clip context
                    ctx.restore();
                    if (camera.renderToTexture) {
                        camera.emit(CameraEvents.POST_RENDER, camera);
                        if (camera.renderToGame) scene.sys.context.drawImage(camera.canvas, cx, cy);
                    }
                },
                /**
     * Restores the game context's global settings and takes a snapshot if one is scheduled.
     *
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                    var ctx = this.gameContext;
                    ctx.restore();
                    this.emit(Events.POST_RENDER);
                    var state = this.snapshotState;
                    if (state.callback) {
                        CanvasSnapshot(this.gameCanvas, state);
                        state.callback = null;
                    }
                },
                /**
     * Takes a snapshot of the given area of the given canvas.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotCanvas
     * @since 3.19.0
     *
     * @param {HTMLCanvasElement} canvas - The canvas to grab from.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from.
     * @param {number} [y=0] - The y coordinate to grab from.
     * @param {number} [width=canvas.width] - The width of the area to grab.
     * @param {number} [height=canvas.height] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Canvas Renderer.
     */ snapshotCanvas: function(canvas, callback, getPixel, x, y, width, height, type, encoderOptions) {
                    if (getPixel === undefined) getPixel = false;
                    this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                    var state = this.snapshotState;
                    state.getPixel = getPixel;
                    CanvasSnapshot(this.canvas, state);
                    state.callback = null;
                    return this;
                },
                /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                    return this.snapshotArea(0, 0, this.gameCanvas.width, this.gameCanvas.height, callback, type, encoderOptions);
                },
                /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    var state = this.snapshotState;
                    state.callback = callback;
                    state.type = type;
                    state.encoder = encoderOptions;
                    state.getPixel = false;
                    state.x = x;
                    state.y = y;
                    state.width = Math.min(width, this.gameCanvas.width);
                    state.height = Math.min(height, this.gameCanvas.height);
                    return this;
                },
                /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                    this.snapshotArea(x, y, 1, 1, callback);
                    this.snapshotState.getPixel = true;
                    return this;
                },
                /**
     * Takes a Sprite Game Object, or any object that extends it, and draws it to the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#batchSprite
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The texture based Game Object to draw.
     * @param {Phaser.Textures.Frame} frame - The frame to draw, doesn't have to be that owned by the Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(sprite, frame, camera, parentTransformMatrix) {
                    var alpha = camera.alpha * sprite.alpha;
                    if (alpha === 0) //  Nothing to see, so abort early
                    return;
                    var ctx = this.currentContext;
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var cd = frame.canvasData;
                    var frameX = cd.x;
                    var frameY = cd.y;
                    var frameWidth = frame.cutWidth;
                    var frameHeight = frame.cutHeight;
                    var customPivot = frame.customPivot;
                    var res = frame.source.resolution;
                    var displayOriginX = sprite.displayOriginX;
                    var displayOriginY = sprite.displayOriginY;
                    var x = -displayOriginX + frame.x;
                    var y = -displayOriginY + frame.y;
                    if (sprite.isCropped) {
                        var crop = sprite._crop;
                        if (crop.flipX !== sprite.flipX || crop.flipY !== sprite.flipY) frame.updateCropUVs(crop, sprite.flipX, sprite.flipY);
                        frameWidth = crop.cw;
                        frameHeight = crop.ch;
                        frameX = crop.cx;
                        frameY = crop.cy;
                        x = -displayOriginX + crop.x;
                        y = -displayOriginY + crop.y;
                        if (sprite.flipX) {
                            if (x >= 0) x = -(x + frameWidth);
                            else if (x < 0) x = Math.abs(x) - frameWidth;
                        }
                        if (sprite.flipY) {
                            if (y >= 0) y = -(y + frameHeight);
                            else if (y < 0) y = Math.abs(y) - frameHeight;
                        }
                    }
                    var flipX = 1;
                    var flipY = 1;
                    if (sprite.flipX) {
                        if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                        flipX = -1;
                    }
                    //  Auto-invert the flipY if this is coming from a GLTexture
                    if (sprite.flipY) {
                        if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                        flipY = -1;
                    }
                    spriteMatrix.applyITRS(sprite.x, sprite.y, sprite.rotation, sprite.scaleX * flipX, sprite.scaleY * flipY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * sprite.scrollFactorX, -camera.scrollY * sprite.scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = sprite.x;
                        spriteMatrix.f = sprite.y;
                    } else {
                        spriteMatrix.e -= camera.scrollX * sprite.scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * sprite.scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix
                    camMatrix.multiply(spriteMatrix);
                    ctx.save();
                    camMatrix.setToContext(ctx);
                    ctx.globalCompositeOperation = this.blendModes[sprite.blendMode];
                    ctx.globalAlpha = alpha;
                    ctx.imageSmoothingEnabled = !(!this.antialias || frame.source.scaleMode);
                    if (sprite.mask) sprite.mask.preRenderCanvas(this, sprite, camera);
                    ctx.drawImage(frame.source.image, frameX, frameY, frameWidth, frameHeight, x, y, frameWidth / res, frameHeight / res);
                    if (sprite.mask) sprite.mask.postRenderCanvas(this, sprite, camera);
                    ctx.restore();
                },
                /**
     * Destroys all object references in the Canvas Renderer.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.game = null;
                    this.gameCanvas = null;
                    this.gameContext = null;
                }
            });
            module1.exports = CanvasRenderer;
        /***/ },
        /* 369 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Color = __webpack_require__(38);
            var GetFastValue = __webpack_require__(2);
            /**
 * Takes a snapshot of an area from the current frame displayed by a canvas.
 * 
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.Canvas
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} sourceCanvas - The canvas to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var CanvasSnapshot = function(canvas, config) {
                var callback = GetFastValue(config, "callback");
                var type = GetFastValue(config, "type", "image/png");
                var encoderOptions = GetFastValue(config, "encoder", 0.92);
                var x = Math.abs(Math.round(GetFastValue(config, "x", 0)));
                var y = Math.abs(Math.round(GetFastValue(config, "y", 0)));
                var width = GetFastValue(config, "width", canvas.width);
                var height = GetFastValue(config, "height", canvas.height);
                var getPixel = GetFastValue(config, "getPixel", false);
                if (getPixel) {
                    var context = canvas.getContext("2d");
                    var imageData = context.getImageData(x, y, 1, 1);
                    var data = imageData.data;
                    callback.call(null, new Color(data[0], data[1], data[2], data[3] / 255));
                } else if (x !== 0 || y !== 0 || width !== canvas.width || height !== canvas.height) {
                    //  Area Grab
                    var copyCanvas = CanvasPool.createWebGL(this, width, height);
                    var ctx = copyCanvas.getContext("2d");
                    ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
                    var image1 = new Image();
                    image1.onerror = function() {
                        callback.call(null);
                        CanvasPool.remove(copyCanvas);
                    };
                    image1.onload = function() {
                        callback.call(null, image1);
                        CanvasPool.remove(copyCanvas);
                    };
                    image1.src = copyCanvas.toDataURL(type, encoderOptions);
                } else {
                    //  Full Grab
                    var image2 = new Image();
                    image2.onerror = function() {
                        callback.call(null);
                    };
                    image2.onload = function() {
                        callback.call(null, image2);
                    };
                    image2.src = canvas.toDataURL(type, encoderOptions);
                }
            };
            module1.exports = CanvasSnapshot;
        /***/ },
        /* 370 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var modes = __webpack_require__(35);
            var CanvasFeatures = __webpack_require__(348);
            /**
 * Returns an array which maps the default blend modes to supported Canvas blend modes.
 *
 * If the browser doesn't support a blend mode, it will default to the normal `source-over` blend mode.
 *
 * @function Phaser.Renderer.Canvas.GetBlendModes
 * @since 3.0.0
 *
 * @return {array} Which Canvas blend mode corresponds to which default Phaser blend mode.
 */ var GetBlendModes = function() {
                var output = [];
                var useNew = CanvasFeatures.supportNewBlendModes;
                var so = "source-over";
                output[modes.NORMAL] = so;
                output[modes.ADD] = "lighter";
                output[modes.MULTIPLY] = useNew ? "multiply" : so;
                output[modes.SCREEN] = useNew ? "screen" : so;
                output[modes.OVERLAY] = useNew ? "overlay" : so;
                output[modes.DARKEN] = useNew ? "darken" : so;
                output[modes.LIGHTEN] = useNew ? "lighten" : so;
                output[modes.COLOR_DODGE] = useNew ? "color-dodge" : so;
                output[modes.COLOR_BURN] = useNew ? "color-burn" : so;
                output[modes.HARD_LIGHT] = useNew ? "hard-light" : so;
                output[modes.SOFT_LIGHT] = useNew ? "soft-light" : so;
                output[modes.DIFFERENCE] = useNew ? "difference" : so;
                output[modes.EXCLUSION] = useNew ? "exclusion" : so;
                output[modes.HUE] = useNew ? "hue" : so;
                output[modes.SATURATION] = useNew ? "saturation" : so;
                output[modes.COLOR] = useNew ? "color" : so;
                output[modes.LUMINOSITY] = useNew ? "luminosity" : so;
                output[modes.ERASE] = "destination-out";
                output[modes.SOURCE_IN] = "source-in";
                output[modes.SOURCE_OUT] = "source-out";
                output[modes.SOURCE_ATOP] = "source-atop";
                output[modes.DESTINATION_OVER] = "destination-over";
                output[modes.DESTINATION_IN] = "destination-in";
                output[modes.DESTINATION_OUT] = "destination-out";
                output[modes.DESTINATION_ATOP] = "destination-atop";
                output[modes.LIGHTER] = "lighter";
                output[modes.COPY] = "copy";
                output[modes.XOR] = "xor";
                return output;
            };
            module1.exports = GetBlendModes;
        /***/ },
        /* 371 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(93);
            var CameraEvents = __webpack_require__(37);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(33);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(91);
            var GameEvents = __webpack_require__(22);
            var IsSizePowerOfTwo = __webpack_require__(138);
            var Matrix4 = __webpack_require__(69);
            var NOOP = __webpack_require__(1);
            var PipelineManager = __webpack_require__(372);
            var RenderTarget = __webpack_require__(141);
            var ScaleEvents = __webpack_require__(104);
            var TextureEvents = __webpack_require__(106);
            var Utils = __webpack_require__(12);
            var WebGLSnapshot = __webpack_require__(383);
            /**
 * @callback WebGLContextCallback
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer which owns the context.
 */ /**
 * @classdesc
 * WebGLRenderer is a class that contains the needed functionality to keep the
 * WebGLRenderingContext state clean. The main idea of the WebGLRenderer is to keep track of
 * any context change that happens for WebGL rendering inside of Phaser. This means
 * if raw webgl functions are called outside the WebGLRenderer of the Phaser WebGL
 * rendering ecosystem they might pollute the current WebGLRenderingContext state producing
 * unexpected behavior. It's recommended that WebGL interaction is done through
 * WebGLRenderer and/or WebGLPipeline.
 *
 * @class WebGLRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance which owns this WebGL Renderer.
 */ var WebGLRenderer = new Class({
                Extends: EventEmitter,
                initialize: function WebGLRenderer(game) {
                    EventEmitter.call(this);
                    var gameConfig = game.config;
                    var contextCreationConfig = {
                        alpha: gameConfig.transparent,
                        desynchronized: gameConfig.desynchronized,
                        depth: false,
                        antialias: gameConfig.antialiasGL,
                        premultipliedAlpha: gameConfig.premultipliedAlpha,
                        stencil: true,
                        failIfMajorPerformanceCaveat: gameConfig.failIfMajorPerformanceCaveat,
                        powerPreference: gameConfig.powerPreference,
                        preserveDrawingBuffer: gameConfig.preserveDrawingBuffer
                    };
                    /**
         * The local configuration settings of this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                        clearBeforeRender: gameConfig.clearBeforeRender,
                        antialias: gameConfig.antialias,
                        backgroundColor: gameConfig.backgroundColor,
                        contextCreation: contextCreationConfig,
                        roundPixels: gameConfig.roundPixels,
                        maxTextures: gameConfig.maxTextures,
                        maxTextureSize: gameConfig.maxTextureSize,
                        batchSize: gameConfig.batchSize,
                        maxLights: gameConfig.maxLights,
                        mipmapFilter: gameConfig.mipmapFilter
                    };
                    /**
         * The Game instance which owns this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A constant which allows the renderer to be easily identified as a WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.WEBGL;
                    /**
         * An instance of the Pipeline Manager class, that handles all WebGL Pipelines.
         *
         * Use this to manage all of your interactions with pipelines, such as adding, getting,
         * setting and rendering them.
         *
         * The Pipeline Manager class is created in the `init` method and then populated
         * with pipelines during the `boot` method.
         *
         * Prior to Phaser v3.50.0 this was just a plain JavaScript object, not a class.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#pipelines
         * @type {Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.pipelines = null;
                    /**
         * The width of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * The height of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The canvas which this WebGL Renderer draws to.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = game.canvas;
                    /**
         * An array of blend modes supported by the WebGL Renderer.
         *
         * This array includes the default blend modes as well as any custom blend modes added through {@link #addBlendMode}.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blendModes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.blendModes = [];
                    /**
         * This property is set to `true` if the WebGL context of the renderer is lost.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLost
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.contextLost = false;
                    /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.0.0
         */ this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: false,
                        callback: null,
                        type: "image/png",
                        encoder: 0.92,
                        isFramebuffer: false,
                        bufferWidth: 0,
                        bufferHeight: 0
                    };
                    /**
         * Cached value for the last texture unit that was used.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentActiveTexture
         * @type {number}
         * @since 3.1.0
         */ this.currentActiveTexture = 0;
                    /**
         * Contains the current starting active texture unit.
         * This value is constantly updated and should be treated as read-only by your code.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#startActiveTexture
         * @type {number}
         * @since 3.50.0
         */ this.startActiveTexture = 0;
                    /**
         * The maximum number of textures the GPU can handle. The minimum under the WebGL1 spec is 8.
         * This is set via the Game Config `maxTextures` property and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maxTextures
         * @type {number}
         * @since 3.50.0
         */ this.maxTextures = 0;
                    /**
         * An array of the available WebGL texture units, used to populate the uSampler uniforms.
         *
         * This array is populated during the init phase and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureIndexes
         * @type {array}
         * @since 3.50.0
         */ this.textureIndexes;
                    /**
         * An array of default temporary WebGL Textures.
         *
         * This array is populated during the init phase and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#tempTextures
         * @type {array}
         * @since 3.50.0
         */ this.tempTextures;
                    /**
         * The currently bound texture at texture unit zero, if any.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureZero
         * @type {?WebGLTexture}
         * @since 3.50.0
         */ this.textureZero;
                    /**
         * The currently bound normal map texture at texture unit one, if any.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#normalTexture
         * @type {?WebGLTexture}
         * @since 3.50.0
         */ this.normalTexture;
                    /**
         * The currently bound framebuffer in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentFramebuffer
         * @type {WebGLFramebuffer}
         * @default null
         * @since 3.0.0
         */ this.currentFramebuffer = null;
                    /**
         * A stack into which the frame buffer objects are pushed and popped.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#fboStack
         * @type {WebGLFramebuffer[]}
         * @since 3.50.0
         */ this.fboStack = [];
                    /**
         * Current WebGLProgram in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentProgram
         * @type {WebGLProgram}
         * @default null
         * @since 3.0.0
         */ this.currentProgram = null;
                    /**
         * Current blend mode in use
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentBlendMode
         * @type {number}
         * @since 3.0.0
         */ this.currentBlendMode = Infinity;
                    /**
         * Indicates if the the scissor state is enabled in WebGLRenderingContext
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissorEnabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.currentScissorEnabled = false;
                    /**
         * Stores the current scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissor
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.currentScissor = null;
                    /**
         * Stack of scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#scissorStack
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.scissorStack = [];
                    /**
         * The handler to invoke when the context is lost.
         * This should not be changed and is set in the boot method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLostHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextLostHandler = NOOP;
                    /**
         * The handler to invoke when the context is restored.
         * This should not be changed and is set in the boot method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextRestoredHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextRestoredHandler = NOOP;
                    /**
         * The underlying WebGL context of the renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#gl
         * @type {WebGLRenderingContext}
         * @default null
         * @since 3.0.0
         */ this.gl = null;
                    /**
         * Array of strings that indicate which WebGL extensions are supported by the browser.
         * This is populated in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#supportedExtensions
         * @type {string[]}
         * @default null
         * @since 3.0.0
         */ this.supportedExtensions = null;
                    /**
         * If the browser supports the `ANGLE_instanced_arrays` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#instancedArraysExtension
         * @type {ANGLE_instanced_arrays}
         * @default null
         * @since 3.50.0
         */ this.instancedArraysExtension = null;
                    /**
         * If the browser supports the `OES_vertex_array_object` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#vaoExtension
         * @type {OES_vertex_array_object}
         * @default null
         * @since 3.50.0
         */ this.vaoExtension = null;
                    /**
         * The WebGL Extensions loaded into the current context.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#extensions
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.extensions = {};
                    /**
         * Stores the current WebGL component formats for further use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFormats
         * @type {array}
         * @default []
         * @since 3.2.0
         */ this.glFormats = [];
                    /**
         * Stores the supported WebGL texture compression formats.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#compression
         * @type {Phaser.Types.Renderer.WebGL.WebGLTextureCompression}
         * @since 3.8.0
         */ this.compression = {
                        ETC1: false,
                        PVRTC: false,
                        S3TC: false
                    };
                    /**
         * Cached drawing buffer height to reduce gl calls.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#drawingBufferHeight
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.drawingBufferHeight = 0;
                    /**
         * A blank 32x32 transparent texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blankTexture
         * @type {WebGLTexture}
         * @readonly
         * @since 3.12.0
         */ this.blankTexture = null;
                    /**
         * A pure white 4x4 texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#whiteTexture
         * @type {WebGLTexture}
         * @readonly
         * @since 3.50.0
         */ this.whiteTexture = null;
                    /**
         * The total number of masks currently stacked.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskCount
         * @type {number}
         * @since 3.17.0
         */ this.maskCount = 0;
                    /**
         * The mask stack.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskStack
         * @type {Phaser.Display.Masks.GeometryMask[]}
         * @since 3.17.0
         */ this.maskStack = [];
                    /**
         * Internal property that tracks the currently set mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentMask
         * @type {any}
         * @since 3.17.0
         */ this.currentMask = {
                        mask: null,
                        camera: null
                    };
                    /**
         * Internal property that tracks the currently set camera mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentCameraMask
         * @type {any}
         * @since 3.17.0
         */ this.currentCameraMask = {
                        mask: null,
                        camera: null
                    };
                    /**
         * Internal gl function mapping for uniform look-up.
         * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/uniform
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFuncMap
         * @type {any}
         * @since 3.17.0
         */ this.glFuncMap = null;
                    /**
         * The `type` of the Game Object being currently rendered.
         * This can be used by advanced render functions for batching look-ahead.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentType
         * @type {string}
         * @since 3.19.0
         */ this.currentType = "";
                    /**
         * Is the `type` of the Game Object being currently rendered different than the
         * type of the object before it in the display list? I.e. it's a 'new' type.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#newType
         * @type {boolean}
         * @since 3.19.0
         */ this.newType = false;
                    /**
         * Does the `type` of the next Game Object in the display list match that
         * of the object being currently rendered?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#nextTypeMatch
         * @type {boolean}
         * @since 3.19.0
         */ this.nextTypeMatch = false;
                    /**
         * Is the Game Object being currently rendered the final one in the list?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#finalType
         * @type {boolean}
         * @since 3.50.0
         */ this.finalType = false;
                    /**
         * The mipmap magFilter to be used when creating textures.
         *
         * You can specify this as a string in the game config, i.e.:
         *
         * `renderer: { mipmapFilter: 'NEAREST_MIPMAP_LINEAR' }`
         *
         * The 6 options for WebGL1 are, in order from least to most computationally expensive:
         *
         * NEAREST (for pixel art)
         * LINEAR (the default)
         * NEAREST_MIPMAP_NEAREST
         * LINEAR_MIPMAP_NEAREST
         * NEAREST_MIPMAP_LINEAR
         * LINEAR_MIPMAP_LINEAR
         *
         * Mipmaps only work with textures that are fully power-of-two in size.
         *
         * For more details see https://webglfundamentals.org/webgl/lessons/webgl-3d-textures.html
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#mipmapFilter
         * @type {GLenum}
         * @since 3.21.0
         */ this.mipmapFilter = null;
                    /**
         * The number of times the renderer had to flush this frame, due to running out of texture units.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureFlush
         * @type {number}
         * @since 3.50.0
         */ this.textureFlush = 0;
                    /**
         * Are the WebGL Textures in their default state?
         *
         * Used to avoid constant gl binds.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#isTextureClean
         * @type {boolean}
         * @since 3.51.0
         */ this.isTextureClean = false;
                    /**
         * The default scissor, set during `preRender` and modified during `resize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#defaultScissor
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.defaultScissor = [
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                    /**
         * A Render Target you can use to capture the current state of the Renderer.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.renderTarget = null;
                    /**
         * The global game Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                    /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                    /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                    this.init(this.config);
                },
                /**
     * Creates a new WebGLRenderingContext and initializes all internal state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#init
     * @since 3.0.0
     *
     * @param {object} config - The configuration object for the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ init: function(config) {
                    var gl;
                    var game = this.game;
                    var canvas = this.canvas;
                    var clearColor = config.backgroundColor;
                    //  Did they provide their own context?
                    if (game.config.context) gl = game.config.context;
                    else gl = canvas.getContext("webgl", config.contextCreation) || canvas.getContext("experimental-webgl", config.contextCreation);
                    if (!gl || gl.isContextLost()) {
                        this.contextLost = true;
                        throw new Error("WebGL unsupported");
                    }
                    this.gl = gl;
                    var _this = this;
                    this.contextLostHandler = function(event) {
                        _this.contextLost = true;
                        _this.game.events.emit(GameEvents.CONTEXT_LOST, _this);
                        event.preventDefault();
                    };
                    this.contextRestoredHandler = function() {
                        _this.contextLost = false;
                        _this.init(_this.config);
                        _this.game.events.emit(GameEvents.CONTEXT_RESTORED, _this);
                    };
                    canvas.addEventListener("webglcontextlost", this.contextLostHandler, false);
                    canvas.addEventListener("webglcontextrestored", this.contextRestoredHandler, false);
                    //  Set it back into the Game, so developers can access it from there too
                    game.context = gl;
                    for(var i = 0; i <= 27; i++)this.blendModes.push({
                        func: [
                            gl.ONE,
                            gl.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: gl.FUNC_ADD
                    });
                    //  ADD
                    this.blendModes[1].func = [
                        gl.ONE,
                        gl.DST_ALPHA
                    ];
                    //  MULTIPLY
                    this.blendModes[2].func = [
                        gl.DST_COLOR,
                        gl.ONE_MINUS_SRC_ALPHA
                    ];
                    //  SCREEN
                    this.blendModes[3].func = [
                        gl.ONE,
                        gl.ONE_MINUS_SRC_COLOR
                    ];
                    //  ERASE
                    this.blendModes[17] = {
                        func: [
                            gl.ZERO,
                            gl.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: gl.FUNC_REVERSE_SUBTRACT
                    };
                    this.glFormats[0] = gl.BYTE;
                    this.glFormats[1] = gl.SHORT;
                    this.glFormats[2] = gl.UNSIGNED_BYTE;
                    this.glFormats[3] = gl.UNSIGNED_SHORT;
                    this.glFormats[4] = gl.FLOAT;
                    //  Set the gl function map
                    this.glFuncMap = {
                        mat2: {
                            func: gl.uniformMatrix2fv,
                            length: 1,
                            matrix: true
                        },
                        mat3: {
                            func: gl.uniformMatrix3fv,
                            length: 1,
                            matrix: true
                        },
                        mat4: {
                            func: gl.uniformMatrix4fv,
                            length: 1,
                            matrix: true
                        },
                        "1f": {
                            func: gl.uniform1f,
                            length: 1
                        },
                        "1fv": {
                            func: gl.uniform1fv,
                            length: 1
                        },
                        "1i": {
                            func: gl.uniform1i,
                            length: 1
                        },
                        "1iv": {
                            func: gl.uniform1iv,
                            length: 1
                        },
                        "2f": {
                            func: gl.uniform2f,
                            length: 2
                        },
                        "2fv": {
                            func: gl.uniform2fv,
                            length: 1
                        },
                        "2i": {
                            func: gl.uniform2i,
                            length: 2
                        },
                        "2iv": {
                            func: gl.uniform2iv,
                            length: 1
                        },
                        "3f": {
                            func: gl.uniform3f,
                            length: 3
                        },
                        "3fv": {
                            func: gl.uniform3fv,
                            length: 1
                        },
                        "3i": {
                            func: gl.uniform3i,
                            length: 3
                        },
                        "3iv": {
                            func: gl.uniform3iv,
                            length: 1
                        },
                        "4f": {
                            func: gl.uniform4f,
                            length: 4
                        },
                        "4fv": {
                            func: gl.uniform4fv,
                            length: 1
                        },
                        "4i": {
                            func: gl.uniform4i,
                            length: 4
                        },
                        "4iv": {
                            func: gl.uniform4iv,
                            length: 1
                        }
                    };
                    //  Load supported extensions
                    var exts = gl.getSupportedExtensions();
                    if (!config.maxTextures || config.maxTextures === -1) config.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                    if (!config.maxTextureSize) config.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                    var extString = "WEBGL_compressed_texture_";
                    var wkExtString = "WEBKIT_" + extString;
                    this.compression.ETC1 = gl.getExtension(extString + "etc1") || gl.getExtension(wkExtString + "etc1");
                    this.compression.PVRTC = gl.getExtension(extString + "pvrtc") || gl.getExtension(wkExtString + "pvrtc");
                    this.compression.S3TC = gl.getExtension(extString + "s3tc") || gl.getExtension(wkExtString + "s3tc");
                    this.supportedExtensions = exts;
                    var angleString = "ANGLE_instanced_arrays";
                    this.instancedArraysExtension = exts.indexOf(angleString) > -1 ? gl.getExtension(angleString) : null;
                    var vaoString = "OES_vertex_array_object";
                    this.vaoExtension = exts.indexOf(vaoString) > -1 ? gl.getExtension(vaoString) : null;
                    //  Setup initial WebGL state
                    gl.disable(gl.DEPTH_TEST);
                    gl.disable(gl.CULL_FACE);
                    gl.enable(gl.BLEND);
                    gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                    //  Mipmaps
                    this.mipmapFilter = gl[config.mipmapFilter];
                    //  Check maximum supported textures
                    this.maxTextures = Utils.checkShaderMax(gl, config.maxTextures);
                    this.textureIndexes = [];
                    //  Create temporary WebGL textures
                    var tempTextures = this.tempTextures;
                    if (Array.isArray(tempTextures)) for(var t = 0; i < this.maxTextures; t++)gl.deleteTexture(tempTextures[t]);
                    else tempTextures = new Array(this.maxTextures);
                    //  Create temp textures to stop WebGL errors on mac os
                    for(var index = 0; index < this.maxTextures; index++){
                        var tempTexture = gl.createTexture();
                        gl.activeTexture(gl.TEXTURE0 + index);
                        gl.bindTexture(gl.TEXTURE_2D, tempTexture);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([
                            0,
                            0,
                            255,
                            255
                        ]));
                        tempTextures[index] = tempTexture;
                        this.textureIndexes.push(index);
                    }
                    this.tempTextures = tempTextures;
                    //  Reset to texture 1 (texture zero is reserved for framebuffers)
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    gl.activeTexture(gl.TEXTURE1);
                    this.pipelines = new PipelineManager(this);
                    this.setBlendMode(CONST.BlendModes.NORMAL);
                    this.projectionMatrix = new Matrix4().identity();
                    game.textures.once(TextureEvents.READY, this.boot, this);
                    return this;
                },
                /**
     * Internal boot handler. Calls 'boot' on each pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#boot
     * @private
     * @since 3.11.0
     */ boot: function() {
                    var game = this.game;
                    var pipelineManager = this.pipelines;
                    var baseSize = game.scale.baseSize;
                    this.width = baseSize.width;
                    this.height = baseSize.height;
                    this.isBooted = true;
                    this.renderTarget = new RenderTarget(this, this.width, this.height, 1, 0, true, true);
                    //  Set-up pipelines
                    pipelineManager.boot(game.config.pipeline);
                    //  Set-up default textures, fbo and scissor
                    this.blankTexture = game.textures.getFrame("__DEFAULT");
                    this.whiteTexture = game.textures.getFrame("__WHITE");
                    var gl = this.gl;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.enable(gl.SCISSOR_TEST);
                    game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.resize(baseSize.width, baseSize.height);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                    //  Has the underlying canvas size changed?
                    if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                },
                /**
     * Binds the WebGL Renderers Render Target, so all drawn content is now redirected to it.
     *
     * Make sure to call `endCapture` when you are finished.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#beginCapture
     * @since 3.50.0
     *
     * @param {number} [width] - Optional new width of the Render Target.
     * @param {number} [height] - Optional new height of the Render Target.
     */ beginCapture: function(width, height) {
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    this.renderTarget.bind(true, width, height);
                    this.setProjectionMatrix(width, height);
                    this.resetTextures();
                },
                /**
     * Unbinds the WebGL Renderers Render Target and returns it, stopping any further content being drawn to it.
     *
     * If the viewport or scissors were modified during the capture, you should reset them by calling
     * `resetViewport` and `resetScissor` accordingly.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#endCapture
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} A reference to the WebGL Renderer Render Target.
     */ endCapture: function() {
                    this.renderTarget.unbind(true);
                    this.resetProjectionMatrix();
                    return this.renderTarget;
                },
                /**
     * Resizes the drawing buffer to match that required by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ resize: function(width, height) {
                    var gl = this.gl;
                    this.width = width;
                    this.height = height;
                    this.setProjectionMatrix(width, height);
                    gl.viewport(0, 0, width, height);
                    this.drawingBufferHeight = gl.drawingBufferHeight;
                    gl.scissor(0, gl.drawingBufferHeight - height, width, height);
                    this.defaultScissor[2] = width;
                    this.defaultScissor[3] = height;
                    this.emit(Events.RESIZE, width, height);
                    return this;
                },
                /**
     * Gets the aspect ratio of the WebGLRenderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getAspectRatio
     * @since 3.50.0
     *
     * @return {number} The aspect ratio of the WebGLRenderer dimensions.
     */ getAspectRatio: function() {
                    return this.width / this.height;
                },
                /**
     * Sets the Projection Matrix of this renderer to the given dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of the Projection Matrix.
     * @param {number} height - The new height of the Projection Matrix.
     *
     * @return {this} This WebGLRenderer instance.
     */ setProjectionMatrix: function(width, height) {
                    if (width !== this.projectionWidth || height !== this.projectionHeight) {
                        this.projectionWidth = width;
                        this.projectionHeight = height;
                        this.projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                    }
                    return this;
                },
                /**
     * Resets the Projection Matrix back to this renderers width and height.
     *
     * This is called during `endCapture`, should the matrix have been changed
     * as a result of the capture process.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProjectionMatrix
     * @since 3.50.0
     */ resetProjectionMatrix: function() {
                    this.projectionWidth = this.width;
                    this.projectionHeight = this.height;
                    this.projectionMatrix.ortho(0, this.width, this.height, 0, -1000, 1000);
                },
                /**
     * Checks if a WebGL extension is supported
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - Name of the WebGL extension
     *
     * @return {boolean} `true` if the extension is supported, otherwise `false`.
     */ hasExtension: function(extensionName) {
                    return this.supportedExtensions ? this.supportedExtensions.indexOf(extensionName) : false;
                },
                /**
     * Loads a WebGL extension
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - The name of the extension to load.
     *
     * @return {object} WebGL extension if the extension is supported
     */ getExtension: function(extensionName) {
                    if (!this.hasExtension(extensionName)) return null;
                    if (!(extensionName in this.extensions)) this.extensions[extensionName] = this.gl.getExtension(extensionName);
                    return this.extensions[extensionName];
                },
                /**
     * Flushes the current pipeline if the pipeline is bound
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#flush
     * @since 3.0.0
     */ flush: function() {
                    this.pipelines.flush();
                },
                /**
     * Pushes a new scissor state. This is used to set nested scissor states.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     *
     * @return {number[]} An array containing the scissor values.
     */ pushScissor: function(x, y, width, height, drawingBufferHeight) {
                    if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                    var scissorStack = this.scissorStack;
                    var scissor = [
                        x,
                        y,
                        width,
                        height
                    ];
                    scissorStack.push(scissor);
                    this.setScissor(x, y, width, height, drawingBufferHeight);
                    this.currentScissor = scissor;
                    return scissor;
                },
                /**
     * Sets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     */ setScissor: function(x, y, width, height, drawingBufferHeight) {
                    if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                    var gl = this.gl;
                    var current = this.currentScissor;
                    var setScissor = width > 0 && height > 0;
                    if (current && setScissor) {
                        var cx = current[0];
                        var cy = current[1];
                        var cw = current[2];
                        var ch = current[3];
                        setScissor = cx !== x || cy !== y || cw !== width || ch !== height;
                    }
                    if (setScissor) {
                        this.flush();
                        // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/scissor
                        gl.scissor(x, drawingBufferHeight - y - height, width, height);
                    }
                },
                /**
     * Resets the gl scissor state to be whatever the current scissor is, if there is one, without
     * modifying the scissor stack.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetScissor
     * @since 3.50.0
     */ resetScissor: function() {
                    var gl = this.gl;
                    gl.enable(gl.SCISSOR_TEST);
                    var current = this.currentScissor;
                    if (current) {
                        var x = current[0];
                        var y = current[1];
                        var width = current[2];
                        var height = current[3];
                        if (width > 0 && height > 0) gl.scissor(x, this.drawingBufferHeight - y - height, width, height);
                    }
                },
                /**
     * Pops the last scissor state and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popScissor
     * @since 3.0.0
     */ popScissor: function() {
                    var scissorStack = this.scissorStack;
                    //  Remove the current scissor
                    scissorStack.pop();
                    //  Reset the previous scissor
                    var scissor = scissorStack[scissorStack.length - 1];
                    if (scissor) this.setScissor(scissor[0], scissor[1], scissor[2], scissor[3]);
                    this.currentScissor = scissor;
                },
                /**
     * Is there an active stencil mask?
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasActiveStencilMask
     * @since 3.17.0
     *
     * @return {boolean} `true` if there is an active stencil mask, otherwise `false`.
     */ hasActiveStencilMask: function() {
                    var mask = this.currentMask.mask;
                    var camMask = this.currentCameraMask.mask;
                    return mask && mask.isStencil || camMask && camMask.isStencil;
                },
                /**
     * Resets the gl viewport to the current renderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetViewport
     * @since 3.50.0
     */ resetViewport: function() {
                    var gl = this.gl;
                    gl.viewport(0, 0, this.width, this.height);
                    this.drawingBufferHeight = gl.drawingBufferHeight;
                },
                /**
     * Sets the blend mode to the value given.
     *
     * If the current blend mode is different from the one given, the pipeline is flushed and the new
     * blend mode is enabled.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {number} blendModeId - The blend mode to be set. Can be a `BlendModes` const or an integer value.
     * @param {boolean} [force=false] - Force the blend mode to be set, regardless of the currently set blend mode.
     *
     * @return {boolean} `true` if the blend mode was changed as a result of this call, forcing a flush, otherwise `false`.
     */ setBlendMode: function(blendModeId, force) {
                    if (force === undefined) force = false;
                    var gl = this.gl;
                    var blendMode = this.blendModes[blendModeId];
                    if (force || blendModeId !== CONST.BlendModes.SKIP_CHECK && this.currentBlendMode !== blendModeId) {
                        this.flush();
                        gl.enable(gl.BLEND);
                        gl.blendEquation(blendMode.equation);
                        if (blendMode.func.length > 2) gl.blendFuncSeparate(blendMode.func[0], blendMode.func[1], blendMode.func[2], blendMode.func[3]);
                        else gl.blendFunc(blendMode.func[0], blendMode.func[1]);
                        this.currentBlendMode = blendModeId;
                        return true;
                    }
                    return false;
                },
                /**
     * Creates a new custom blend mode for the renderer.
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants#Blending_modes
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#addBlendMode
     * @since 3.0.0
     *
     * @param {GLenum[]} func - An array containing the WebGL functions to use for the source and the destination blending factors, respectively. See the possible constants for {@link WebGLRenderingContext#blendFunc()}.
     * @param {GLenum} equation - The equation to use for combining the RGB and alpha components of a new pixel with a rendered one. See the possible constants for {@link WebGLRenderingContext#blendEquation()}.
     *
     * @return {number} The index of the new blend mode, used for referencing it in the future.
     */ addBlendMode: function(func, equation) {
                    var index = this.blendModes.push({
                        func: func,
                        equation: equation
                    });
                    return index - 1;
                },
                /**
     * Updates the function bound to a given custom blend mode.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode.
     * @param {function} func - The function to use for the blend mode.
     * @param {function} equation - The equation to use for the blend mode.
     *
     * @return {this} This WebGLRenderer instance.
     */ updateBlendMode: function(index, func, equation) {
                    if (this.blendModes[index]) {
                        this.blendModes[index].func = func;
                        if (equation) this.blendModes[index].equation = equation;
                    }
                    return this;
                },
                /**
     * Removes a custom blend mode from the renderer.
     * Any Game Objects still using this blend mode will error, so be sure to clear them first.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#removeBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode to be removed.
     *
     * @return {this} This WebGLRenderer instance.
     */ removeBlendMode: function(index) {
                    if (index > 17 && this.blendModes[index]) this.blendModes.splice(index, 1);
                    return this;
                },
                /**
     * Sets the current active texture for texture unit zero to be a blank texture.
     * This only happens if there isn't a texture already in use by texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlankTexture
     * @private
     * @since 3.12.0
     */ setBlankTexture: function() {
                    this.setTexture2D(this.blankTexture.glTexture);
                },
                /**
     * Activates the Texture Source and assigns it the next available texture unit.
     * If none are available, it will flush the current pipeline first.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureSource
     * @since 3.50.0
     *
     * @param {Phaser.Textures.TextureSource} textureSource - The Texture Source to be assigned the texture unit.
     *
     * @return {number} The texture unit that was assigned to the Texture Source.
     */ setTextureSource: function(textureSource) {
                    if (this.pipelines.forceZero()) {
                        this.setTextureZero(textureSource.glTexture, true);
                        return 0;
                    }
                    var gl = this.gl;
                    var currentActiveTexture = this.currentActiveTexture;
                    if (textureSource.glIndexCounter < this.startActiveTexture) {
                        textureSource.glIndexCounter = this.startActiveTexture;
                        if (currentActiveTexture < this.maxTextures) {
                            textureSource.glIndex = currentActiveTexture;
                            gl.activeTexture(gl.TEXTURE0 + currentActiveTexture);
                            gl.bindTexture(gl.TEXTURE_2D, textureSource.glTexture);
                            this.currentActiveTexture++;
                        } else {
                            //  We're out of textures, so flush the batch and reset back to 0
                            this.flush();
                            this.startActiveTexture++;
                            this.textureFlush++;
                            textureSource.glIndexCounter = this.startActiveTexture;
                            textureSource.glIndex = 1;
                            gl.activeTexture(gl.TEXTURE1);
                            gl.bindTexture(gl.TEXTURE_2D, textureSource.glTexture);
                            this.currentActiveTexture = 2;
                        }
                    }
                    this.isTextureClean = false;
                    return textureSource.glIndex;
                },
                /**
     * Checks to see if the given diffuse and normal map textures are already bound, or not.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#isNewNormalMap
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL diffuse texture.
     * @param {WebGLTexture} normalMap - The WebGL normal map texture.
     *
     * @return {boolean} Returns `false` if this combination is already set, or `true` if it's a new combination.
     */ isNewNormalMap: function(texture, normalMap) {
                    return this.textureZero !== texture || this.normalTexture !== normalMap;
                },
                /**
     * Binds a texture directly to texture unit zero then activates it.
     * If the texture is already at unit zero, it skips the bind.
     * Make sure to call `clearTextureZero` after using this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureZero
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     * @param {boolean} [flush=false] - Flush the pipeline if the texture is different?
     */ setTextureZero: function(texture, flush) {
                    if (this.textureZero !== texture) {
                        if (flush) this.flush();
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        this.textureZero = texture;
                    }
                },
                /**
     * Clears the texture that was directly bound to texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#clearTextureZero
     * @since 3.50.0
     */ clearTextureZero: function() {
                    this.textureZero = null;
                },
                /**
     * Binds a texture directly to texture unit one then activates it.
     * If the texture is already at unit one, it skips the bind.
     * Make sure to call `clearNormalMap` after using this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setNormalMap
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     */ setNormalMap: function(texture) {
                    if (this.normalTexture !== texture) {
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        this.normalTexture = texture;
                        if (this.currentActiveTexture === 1) this.currentActiveTexture = 2;
                    }
                },
                /**
     * Clears the texture that was directly bound to texture unit one and
     * increases the start active texture counter.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#clearNormalMap
     * @since 3.50.0
     */ clearNormalMap: function() {
                    this.normalTexture = null;
                    this.startActiveTexture++;
                    this.currentActiveTexture = 1;
                    this.textureFlush++;
                },
                /**
     * Activates each texture, in turn, then binds them all to `null`.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#unbindTextures
     * @since 3.50.0
     *
     * @param {boolean} [all=false] - Reset all textures, or just the first two?
     */ unbindTextures: function() {
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    for(var i = 0; i < temp.length; i++){
                        gl.activeTexture(gl.TEXTURE0 + i);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    }
                    this.normalTexture = null;
                    this.textureZero = null;
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    this.textureFlush++;
                },
                /**
     * Flushes the current pipeline, then resets the first two textures
     * back to the default temporary textures, resets the start active
     * counter and sets texture unit 1 as being active.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetTextures
     * @since 3.50.0
     *
     * @param {boolean} [all=false] - Reset all textures, or just the first two?
     */ resetTextures: function(all) {
                    if (all === undefined) all = false;
                    if (this.isTextureClean) //  No need to do this if the textures are already clean
                    return;
                    this.flush();
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    if (all) {
                        for(var i = 0; i < temp.length; i++){
                            gl.activeTexture(gl.TEXTURE0 + i);
                            gl.bindTexture(gl.TEXTURE_2D, temp[i]);
                        }
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, temp[1]);
                        this.isTextureClean = true;
                    } else {
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, temp[0]);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, temp[1]);
                    }
                    this.normalTexture = null;
                    this.textureZero = null;
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    this.textureFlush++;
                },
                /**
     * Binds a texture at a texture unit. If a texture is already
     * bound to that unit it will force a flush on the current pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTexture2D
     * @since 3.0.0
     * @version 2.0 - Updated in 3.50.0 to remove the `textureUnit` and `flush` parameters.
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     *
     * @return {number} The texture unit that was assigned to the Texture Source.
     */ setTexture2D: function(texture) {
                    if (this.pipelines.forceZero()) {
                        this.setTextureZero(texture, true);
                        return 0;
                    }
                    var gl = this.gl;
                    var currentActiveTexture = this.currentActiveTexture;
                    if (texture.glIndexCounter < this.startActiveTexture) {
                        texture.glIndexCounter = this.startActiveTexture;
                        if (currentActiveTexture < this.maxTextures) {
                            texture.glIndex = currentActiveTexture;
                            gl.activeTexture(gl.TEXTURE0 + currentActiveTexture);
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            this.currentActiveTexture++;
                        } else {
                            //  We're out of textures, so flush the batch and reset back to 1 (0 is reserved for fbos)
                            this.flush();
                            this.startActiveTexture++;
                            this.textureFlush++;
                            texture.glIndexCounter = this.startActiveTexture;
                            texture.glIndex = 1;
                            gl.activeTexture(gl.TEXTURE1);
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            this.currentActiveTexture = 2;
                        }
                    }
                    this.isTextureClean = false;
                    return texture.glIndex;
                },
                /**
     * Pushes a new framebuffer onto the FBO stack and makes it the currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Call `popFramebuffer` to remove it again.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushFramebuffer
     * @since 3.50.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer that needs to be bound.
     * @param {boolean} [updateScissor=false] - Set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {this} This WebGLRenderer instance.
     */ pushFramebuffer: function(framebuffer, updateScissor, resetTextures, setViewport) {
                    if (framebuffer === this.currentFramebuffer) return this;
                    this.fboStack.push(framebuffer);
                    return this.setFramebuffer(framebuffer, updateScissor, resetTextures, setViewport);
                },
                /**
     * Sets the given framebuffer as the active and currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Typically, you should call `pushFramebuffer` instead of this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFramebuffer
     * @since 3.0.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer that needs to be bound.
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {this} This WebGLRenderer instance.
     */ setFramebuffer: function(framebuffer, updateScissor, resetTextures, setViewport) {
                    if (updateScissor === undefined) updateScissor = false;
                    if (resetTextures === undefined) resetTextures = false;
                    if (setViewport === undefined) setViewport = true;
                    if (framebuffer === this.currentFramebuffer) return this;
                    var gl = this.gl;
                    var width = this.width;
                    var height = this.height;
                    if (framebuffer && framebuffer.renderTexture && setViewport) {
                        width = framebuffer.renderTexture.width;
                        height = framebuffer.renderTexture.height;
                    } else this.flush();
                    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                    if (setViewport) gl.viewport(0, 0, width, height);
                    if (updateScissor) {
                        if (framebuffer) {
                            this.drawingBufferHeight = height;
                            this.pushScissor(0, 0, width, height);
                        } else {
                            this.drawingBufferHeight = this.height;
                            this.popScissor();
                        }
                    }
                    this.currentFramebuffer = framebuffer;
                    if (resetTextures) this.resetTextures();
                    return this;
                },
                /**
     * Pops the previous framebuffer from the fbo stack and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popFramebuffer
     * @since 3.50.0
     *
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {WebGLFramebuffer} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ popFramebuffer: function(updateScissor, resetTextures, setViewport) {
                    if (updateScissor === undefined) updateScissor = false;
                    if (resetTextures === undefined) resetTextures = false;
                    if (setViewport === undefined) setViewport = true;
                    var fboStack = this.fboStack;
                    //  Remove the current fbo
                    fboStack.pop();
                    //  Reset the previous framebuffer
                    var framebuffer = fboStack[fboStack.length - 1];
                    if (!framebuffer) framebuffer = null;
                    this.setFramebuffer(framebuffer, updateScissor, resetTextures, setViewport);
                    return framebuffer;
                },
                /**
     * Binds a shader program.
     *
     * If there was a different program already bound it will force a pipeline flush first.
     *
     * If the same program given to this method is already set as the current program, no change
     * will take place and this method will return `false`.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProgram
     * @since 3.0.0
     *
     * @param {WebGLProgram} program - The program that needs to be bound.
     *
     * @return {boolean} `true` if the given program was bound, otherwise `false`.
     */ setProgram: function(program) {
                    if (program !== this.currentProgram) {
                        this.flush();
                        this.gl.useProgram(program);
                        this.currentProgram = program;
                        return true;
                    }
                    return false;
                },
                /**
     * Rebinds whatever program `WebGLRenderer.currentProgram` is set as, without
     * changing anything, or flushing.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProgram
     * @since 3.50.0
     *
     * @return {this} This WebGLRenderer instance.
     */ resetProgram: function() {
                    this.gl.useProgram(this.currentProgram);
                    return this;
                },
                /**
     * Creates a texture from an image source. If the source is not valid it creates an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTextureFromSource
     * @since 3.0.0
     *
     * @param {object} source - The source of the texture.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} scaleMode - The scale mode to be used by the texture.
     *
     * @return {?WebGLTexture} The WebGL Texture that was created, or `null` if it couldn't be created.
     */ createTextureFromSource: function(source, width, height, scaleMode) {
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var wrap = gl.CLAMP_TO_EDGE;
                    var texture = null;
                    width = source ? source.width : width;
                    height = source ? source.height : height;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (pow) wrap = gl.REPEAT;
                    if (scaleMode === CONST.ScaleModes.LINEAR && this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    if (!source && typeof width === "number" && typeof height === "number") texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, null, width, height);
                    else texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, source);
                    return texture;
                },
                /**
     * A wrapper for creating a WebGLTexture. If no pixel data is passed it will create an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTexture2D
     * @since 3.0.0
     *
     * @param {number} mipLevel - Mip level of the texture.
     * @param {number} minFilter - Filtering of the texture.
     * @param {number} magFilter - Filtering of the texture.
     * @param {number} wrapT - Wrapping mode of the texture.
     * @param {number} wrapS - Wrapping mode of the texture.
     * @param {number} format - Which format does the texture use.
     * @param {?object} pixels - pixel data.
     * @param {number} width - Width of the texture in pixels.
     * @param {number} height - Height of the texture in pixels.
     * @param {boolean} [pma=true] - Does the texture have premultiplied alpha?
     * @param {boolean} [forceSize=false] - If `true` it will use the width and height passed to this method, regardless of the pixels dimension.
     * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
     *
     * @return {WebGLTexture} The WebGLTexture that was created.
     */ createTexture2D: function(mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma, forceSize, flipY) {
                    pma = pma === undefined || pma === null ? true : pma;
                    if (forceSize === undefined) forceSize = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var texture = gl.createTexture();
                    gl.activeTexture(gl.TEXTURE0);
                    var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
                    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, pma);
                    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                    if (pixels === null || pixels === undefined) gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, width, height, 0, format, gl.UNSIGNED_BYTE, null);
                    else {
                        if (!forceSize) {
                            width = pixels.width;
                            height = pixels.height;
                        }
                        gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, format, gl.UNSIGNED_BYTE, pixels);
                    }
                    if (IsSizePowerOfTwo(width, height)) gl.generateMipmap(gl.TEXTURE_2D);
                    if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    texture.isAlphaPremultiplied = pma;
                    texture.isRenderTexture = false;
                    texture.width = width;
                    texture.height = height;
                    texture.glIndex = 0;
                    texture.glIndexCounter = -1;
                    return texture;
                },
                /**
     * Creates a WebGL Framebuffer object and optionally binds a depth stencil render buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createFramebuffer
     * @since 3.0.0
     *
     * @param {number} width - If `addDepthStencilBuffer` is true, this controls the width of the depth stencil.
     * @param {number} height - If `addDepthStencilBuffer` is true, this controls the height of the depth stencil.
     * @param {WebGLTexture} renderTexture - The color texture where the color pixels are written.
     * @param {boolean} [addDepthStencilBuffer=false] - Create a Renderbuffer for the depth stencil?
     *
     * @return {WebGLFramebuffer} Raw WebGLFramebuffer
     */ createFramebuffer: function(width, height, renderTexture, addDepthStencilBuffer) {
                    var gl = this.gl;
                    var framebuffer = gl.createFramebuffer();
                    var complete = 0;
                    this.setFramebuffer(framebuffer);
                    if (addDepthStencilBuffer) {
                        var depthStencilBuffer = gl.createRenderbuffer();
                        gl.bindRenderbuffer(gl.RENDERBUFFER, depthStencilBuffer);
                        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, depthStencilBuffer);
                    }
                    renderTexture.isRenderTexture = true;
                    renderTexture.isAlphaPremultiplied = false;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, renderTexture, 0);
                    complete = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
                    if (complete !== gl.FRAMEBUFFER_COMPLETE) {
                        var errors = {
                            36054: "Incomplete Attachment",
                            36055: "Missing Attachment",
                            36057: "Incomplete Dimensions",
                            36061: "Framebuffer Unsupported"
                        };
                        throw new Error("Framebuffer status: " + errors[complete]);
                    }
                    framebuffer.renderTexture = renderTexture;
                    this.setFramebuffer(null);
                    this.resetTextures();
                    return framebuffer;
                },
                /**
     * Creates a WebGLProgram instance based on the given vertex and fragment shader source.
     *
     * Then compiles, attaches and links the program before returning it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createProgram
     * @since 3.0.0
     *
     * @param {string} vertexShader - The vertex shader source code as a single string.
     * @param {string} fragmentShader - The fragment shader source code as a single string.
     *
     * @return {WebGLProgram} The linked WebGLProgram created from the given shader source.
     */ createProgram: function(vertexShader, fragmentShader) {
                    var gl = this.gl;
                    var program = gl.createProgram();
                    var vs = gl.createShader(gl.VERTEX_SHADER);
                    var fs = gl.createShader(gl.FRAGMENT_SHADER);
                    gl.shaderSource(vs, vertexShader);
                    gl.shaderSource(fs, fragmentShader);
                    gl.compileShader(vs);
                    gl.compileShader(fs);
                    if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) throw new Error("Vertex Shader failed:\n" + gl.getShaderInfoLog(vs));
                    if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) throw new Error("Fragment Shader failed:\n" + gl.getShaderInfoLog(fs));
                    gl.attachShader(program, vs);
                    gl.attachShader(program, fs);
                    gl.linkProgram(program);
                    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error("Link Program failed:\n" + gl.getProgramInfoLog(program));
                    gl.useProgram(program);
                    return program;
                },
                /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVertexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - It's either ArrayBuffer or an integer indicating the size of the vbo
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW
     *
     * @return {WebGLBuffer} Raw vertex buffer
     */ createVertexBuffer: function(initialDataOrSize, bufferUsage) {
                    var gl = this.gl;
                    var vertexBuffer = gl.createBuffer();
                    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, initialDataOrSize, bufferUsage);
                    gl.bindBuffer(gl.ARRAY_BUFFER, null);
                    return vertexBuffer;
                },
                /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createIndexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - Either ArrayBuffer or an integer indicating the size of the vbo.
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW.
     *
     * @return {WebGLBuffer} Raw index buffer
     */ createIndexBuffer: function(initialDataOrSize, bufferUsage) {
                    var gl = this.gl;
                    var indexBuffer = gl.createBuffer();
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
                    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, initialDataOrSize, bufferUsage);
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
                    return indexBuffer;
                },
                /**
     * Calls `GL.deleteTexture` on the given WebGLTexture and also optionally
     * resets the currently defined textures.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteTexture
     * @since 3.0.0
     *
     * @param {WebGLTexture} texture - The WebGL Texture to be deleted.
     * @param {boolean} [reset=false] - Call the `resetTextures` method after deleting this texture?
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteTexture: function(texture, reset) {
                    if (reset) this.resetTextures(true);
                    if (texture) this.gl.deleteTexture(texture);
                    return this;
                },
                /**
     * Deletes a WebGLFramebuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteFramebuffer
     * @since 3.0.0
     *
     * @param {WebGLFramebuffer} framebuffer - The Framebuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteFramebuffer: function(framebuffer) {
                    if (framebuffer) {
                        this.gl.deleteFramebuffer(framebuffer);
                        ArrayRemove(this.fboStack, framebuffer);
                        if (this.currentFramebuffer === framebuffer) this.currentFramebuffer = null;
                    }
                    return this;
                },
                /**
     * Deletes a WebGLProgram from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteProgram
     * @since 3.0.0
     *
     * @param {WebGLProgram} program - The shader program to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteProgram: function(program) {
                    if (program) this.gl.deleteProgram(program);
                    return this;
                },
                /**
     * Deletes a WebGLBuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteBuffer
     * @since 3.0.0
     *
     * @param {WebGLBuffer} vertexBuffer - The WebGLBuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteBuffer: function(buffer) {
                    this.gl.deleteBuffer(buffer);
                    return this;
                },
                /**
     * Controls the pre-render operations for the given camera.
     * Handles any clipping needed by the camera and renders the background color if a color is visible.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to pre-render.
     */ preRenderCamera: function(camera) {
                    var cx = camera.x;
                    var cy = camera.y;
                    var cw = camera.width;
                    var ch = camera.height;
                    var color = camera.backgroundColor;
                    camera.emit(CameraEvents.PRE_RENDER, camera);
                    this.pipelines.preBatchCamera(camera);
                    this.pushScissor(cx, cy, cw, ch);
                    if (camera.mask) {
                        this.currentCameraMask.mask = camera.mask;
                        this.currentCameraMask.camera = camera._maskCamera;
                        camera.mask.preRenderWebGL(this, camera, camera._maskCamera);
                    }
                    if (color.alphaGL > 0) {
                        var pipeline = this.pipelines.setMulti();
                        pipeline.drawFillRect(cx, cy, cw, ch, Utils.getTintFromFloats(color.blueGL, color.greenGL, color.redGL, 1), color.alphaGL);
                    }
                },
                /**
     * Return the current stencil mask.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getCurrentStencilMask
     * @private
     * @since 3.50.0
     */ getCurrentStencilMask: function() {
                    var prev = null;
                    var stack = this.maskStack;
                    var cameraMask = this.currentCameraMask;
                    if (stack.length > 0) prev = stack[stack.length - 1];
                    else if (cameraMask.mask && cameraMask.mask.isStencil) prev = cameraMask;
                    return prev;
                },
                /**
     * Controls the post-render operations for the given camera.
     *
     * Renders the foreground camera effects like flash and fading, then resets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to post-render.
     */ postRenderCamera: function(camera) {
                    var flashEffect = camera.flashEffect;
                    var fadeEffect = camera.fadeEffect;
                    if (flashEffect.isRunning || fadeEffect.isRunning || fadeEffect.isComplete) {
                        var pipeline = this.pipelines.setMulti();
                        flashEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                        fadeEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                    }
                    camera.dirty = false;
                    this.popScissor();
                    if (camera.mask) {
                        this.currentCameraMask.mask = null;
                        camera.mask.postRenderWebGL(this, camera._maskCamera);
                    }
                    this.pipelines.postBatchCamera(camera);
                    camera.emit(CameraEvents.POST_RENDER, camera);
                },
                /**
     * Clears the current vertex buffer and updates pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                    if (this.contextLost) return;
                    var gl = this.gl;
                    //  Make sure we are bound to the main frame buffer
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    if (this.config.clearBeforeRender) {
                        var clearColor = this.config.backgroundColor;
                        gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                    }
                    gl.enable(gl.SCISSOR_TEST);
                    this.currentScissor = this.defaultScissor;
                    this.scissorStack.length = 0;
                    this.scissorStack.push(this.currentScissor);
                    if (this.game.scene.customViewports) gl.scissor(0, this.drawingBufferHeight - this.height, this.width, this.height);
                    this.currentMask.mask = null;
                    this.currentCameraMask.mask = null;
                    this.maskStack.length = 0;
                    this.textureFlush = 0;
                    this.emit(Events.PRE_RENDER);
                },
                /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                    if (this.contextLost) return;
                    var childCount = children.length;
                    this.emit(Events.RENDER, scene, camera);
                    //   Apply scissor for cam region + render background color, if not transparent
                    this.preRenderCamera(camera);
                    //  Nothing to render, so bail out
                    if (childCount === 0) {
                        this.setBlendMode(CONST.BlendModes.NORMAL);
                        //  Applies camera effects and pops the scissor, if set
                        this.postRenderCamera(camera);
                        return;
                    }
                    //  Reset the current type
                    this.currentType = "";
                    var current = this.currentMask;
                    for(var i = 0; i < childCount; i++){
                        this.finalType = i === childCount - 1;
                        var child = children[i];
                        var mask = child.mask;
                        current = this.currentMask;
                        if (current.mask && current.mask !== mask) //  Render out the previously set mask
                        current.mask.postRenderWebGL(this, current.camera);
                        if (mask && current.mask !== mask) mask.preRenderWebGL(this, child, camera);
                        if (child.blendMode !== this.currentBlendMode) this.setBlendMode(child.blendMode);
                        var type = child.type;
                        if (type !== this.currentType) {
                            this.newType = true;
                            this.currentType = type;
                        }
                        if (!this.finalType) this.nextTypeMatch = children[i + 1].type === this.currentType;
                        else this.nextTypeMatch = false;
                        child.renderWebGL(this, child, camera);
                        this.newType = false;
                    }
                    current = this.currentMask;
                    if (current.mask) //  Render out the previously set mask, if it was the last item in the display list
                    current.mask.postRenderWebGL(this, current.camera);
                    this.setBlendMode(CONST.BlendModes.NORMAL);
                    //  Applies camera effects and pops the scissor, if set
                    this.postRenderCamera(camera);
                },
                /**
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                    if (this.contextLost) return;
                    this.flush();
                    this.emit(Events.POST_RENDER);
                    var state = this.snapshotState;
                    if (state.callback) {
                        WebGLSnapshot(this.canvas, state);
                        state.callback = null;
                    }
                    if (this.textureFlush > 0) {
                        this.startActiveTexture++;
                        this.currentActiveTexture = 1;
                    }
                },
                /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                    return this.snapshotArea(0, 0, this.gl.drawingBufferWidth, this.gl.drawingBufferHeight, callback, type, encoderOptions);
                },
                /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    var state = this.snapshotState;
                    state.callback = callback;
                    state.type = type;
                    state.encoder = encoderOptions;
                    state.getPixel = false;
                    state.x = x;
                    state.y = y;
                    state.width = Math.min(width, this.gl.drawingBufferWidth);
                    state.height = Math.min(height, this.gl.drawingBufferHeight);
                    return this;
                },
                /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                    this.snapshotArea(x, y, 1, 1, callback);
                    this.snapshotState.getPixel = true;
                    return this;
                },
                /**
     * Takes a snapshot of the given area of the given frame buffer.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotFramebuffer
     * @since 3.19.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer to grab from.
     * @param {number} bufferWidth - The width of the framebuffer.
     * @param {number} bufferHeight - The height of the framebuffer.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from.
     * @param {number} [y=0] - The y coordinate to grab from.
     * @param {number} [width=bufferWidth] - The width of the area to grab.
     * @param {number} [height=bufferHeight] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotFramebuffer: function(framebuffer, bufferWidth, bufferHeight, callback, getPixel, x, y, width, height, type, encoderOptions) {
                    if (getPixel === undefined) getPixel = false;
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = bufferWidth;
                    if (height === undefined) height = bufferHeight;
                    var currentFramebuffer = this.currentFramebuffer;
                    this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                    var state = this.snapshotState;
                    state.getPixel = getPixel;
                    state.isFramebuffer = true;
                    state.bufferWidth = bufferWidth;
                    state.bufferHeight = bufferHeight;
                    this.setFramebuffer(framebuffer);
                    WebGLSnapshot(this.canvas, state);
                    this.setFramebuffer(currentFramebuffer);
                    state.callback = null;
                    state.isFramebuffer = false;
                    return this;
                },
                /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * If the `dstTexture` parameter is given, the WebGL Texture is updated, rather than created fresh.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#canvasToTexture
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from
     * @param {WebGLTexture} [dstTexture] - The destination WebGL Texture to set.
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created, or updated, WebGL Texture.
     */ canvasToTexture: function(srcCanvas, dstTexture, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    if (!dstTexture) return this.createCanvasTexture(srcCanvas, noRepeat, flipY);
                    else return this.updateCanvasTexture(srcCanvas, dstTexture, flipY);
                },
                /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created WebGL Texture.
     */ createCanvasTexture: function(srcCanvas, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var width = srcCanvas.width;
                    var height = srcCanvas.height;
                    var wrapping = gl.CLAMP_TO_EDGE;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (!noRepeat && pow) wrapping = gl.REPEAT;
                    if (this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcCanvas, width, height, true, false, flipY);
                },
                /**
     * Updates a WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to update the WebGL Texture from.
     * @param {WebGLTexture} dstTexture - The destination WebGL Texture to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The updated WebGL Texture.
     */ updateCanvasTexture: function(srcCanvas, dstTexture, flipY) {
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var width = srcCanvas.width;
                    var height = srcCanvas.height;
                    if (width > 0 && height > 0) {
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, dstTexture);
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcCanvas);
                        dstTexture.width = width;
                        dstTexture.height = height;
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    }
                    return dstTexture;
                },
                /**
     * Creates a new WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to create the WebGL Texture from
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT`?
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created WebGL Texture.
     */ createVideoTexture: function(srcVideo, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var width = srcVideo.videoWidth;
                    var height = srcVideo.videoHeight;
                    var wrapping = gl.CLAMP_TO_EDGE;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (!noRepeat && pow) wrapping = gl.REPEAT;
                    if (this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcVideo, width, height, true, true, flipY);
                },
                /**
     * Updates a WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to update the WebGL Texture with.
     * @param {WebGLTexture} dstTexture - The destination WebGL Texture to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The updated WebGL Texture.
     */ updateVideoTexture: function(srcVideo, dstTexture, flipY) {
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var width = srcVideo.videoWidth;
                    var height = srcVideo.videoHeight;
                    if (width > 0 && height > 0) {
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, dstTexture);
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcVideo);
                        dstTexture.width = width;
                        dstTexture.height = height;
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    }
                    return dstTexture;
                },
                /**
     * Sets the minification and magnification filter for a texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureFilter
     * @since 3.0.0
     *
     * @param {number} texture - The texture to set the filter for.
     * @param {number} filter - The filter to set. 0 for linear filtering, 1 for nearest neighbor (blocky) filtering.
     *
     * @return {this} This WebGL Renderer instance.
     */ setTextureFilter: function(texture, filter) {
                    var gl = this.gl;
                    var glFilter = [
                        gl.LINEAR,
                        gl.NEAREST
                    ][filter];
                    gl.activeTexture(gl.TEXTURE0);
                    var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, glFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, glFilter);
                    if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    return this;
                },
                /**
     * Returns the largest texture size (either width or height) that can be created.
     * Note that VRAM may not allow a texture of any given size, it just expresses
     * hardware / driver support for a given size.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getMaxTextureSize
     * @since 3.8.0
     *
     * @return {number} The maximum supported texture size.
     */ getMaxTextureSize: function() {
                    return this.config.maxTextureSize;
                },
                /**
     * Destroy this WebGLRenderer, cleaning up all related resources such as pipelines, native textures, etc.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.canvas.removeEventListener("webglcontextlost", this.contextLostHandler, false);
                    this.canvas.removeEventListener("webglcontextrestored", this.contextRestoredHandler, false);
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    for(var i = 0; i < temp.length; i++)gl.deleteTexture(temp[i]);
                    this.pipelines.destroy();
                    this.removeAllListeners();
                    this.fboStack = [];
                    this.maskStack = [];
                    this.extensions = {};
                    this.textureIndexes = [];
                    this.gl = null;
                    this.game = null;
                    this.canvas = null;
                    this.contextLost = true;
                    this.currentMask = null;
                    this.currentCameraMask = null;
                }
            });
            module1.exports = WebGLRenderer;
        /***/ },
        /* 372 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(92);
            var CustomMap = __webpack_require__(102);
            //  Default Phaser 3 Pipelines
            var BitmapMaskPipeline = __webpack_require__(373);
            var GraphicsPipeline = __webpack_require__(376);
            var LightPipeline = __webpack_require__(377);
            var MultiPipeline = __webpack_require__(108);
            var PointLightPipeline = __webpack_require__(378);
            var RopePipeline = __webpack_require__(379);
            var SinglePipeline = __webpack_require__(380);
            var UtilityPipeline = __webpack_require__(381);
            /**
 * @classdesc
 * The Pipeline Manager is responsible for the creation, activation, running and destruction
 * of WebGL Pipelines and Post FX Pipelines in Phaser 3.
 *
 * The `WebGLRenderer` owns a single instance of the Pipeline Manager, which you can access
 * via the `WebGLRenderer.pipelines` property.
 *
 * By default, there are 8 pipelines installed into the Pipeline Manager when Phaser boots:
 *
 * 1. The Multi Pipeline. Responsible for all multi-texture rendering, i.e. Sprites and Tilemaps.
 * 2. The Graphics Pipeline. Responsible for rendering Graphics and Shape objects.
 * 3. The Rope Pipeline. Responsible for rendering the Rope Game Object.
 * 4. The Light Pipeline. Responsible for rendering the Light Game Object.
 * 5. The Point Light Pipeline. Responsible for rendering the Point Light Game Object.
 * 6. The Single Pipeline. Responsible for rendering Game Objects that explicitly require one bound texture.
 * 7. The Bitmap Mask Pipeline. Responsible for Bitmap Mask rendering.
 * 8. The Utility Pipeline. Responsible for providing lots of handy texture manipulation functions.
 *
 * You can add your own custom pipeline via the `PipelineManager.add` method. Pipelines are
 * identified by unique string-based keys.
 *
 * @class PipelineManager
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGL Renderer that owns this Pipeline Manager.
 */ var PipelineManager = new Class({
                initialize: function PipelineManager(renderer) {
                    /**
         * A reference to the Game instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#game
         * @type {Phaser.Game}
         * @since 3.50.0
         */ this.game = renderer.game;
                    /**
         * A reference to the WebGL Renderer instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                    /**
         * This map stores all pipeline classes available in this manager.
         *
         * The Utility Class must always come first.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#classes
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.classes = new CustomMap([
                        [
                            CONST.UTILITY_PIPELINE,
                            UtilityPipeline
                        ],
                        [
                            CONST.MULTI_PIPELINE,
                            MultiPipeline
                        ],
                        [
                            CONST.BITMAPMASK_PIPELINE,
                            BitmapMaskPipeline
                        ],
                        [
                            CONST.SINGLE_PIPELINE,
                            SinglePipeline
                        ],
                        [
                            CONST.ROPE_PIPELINE,
                            RopePipeline
                        ],
                        [
                            CONST.LIGHT_PIPELINE,
                            LightPipeline
                        ],
                        [
                            CONST.POINTLIGHT_PIPELINE,
                            PointLightPipeline
                        ],
                        [
                            CONST.GRAPHICS_PIPELINE,
                            GraphicsPipeline
                        ]
                    ]);
                    /**
         * This map stores all Post FX Pipeline classes available in this manager.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#postPipelineClasses
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.postPipelineClasses = new CustomMap();
                    /**
         * This map stores all pipeline instances in this manager.
         *
         * This is populated with the default pipelines in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#pipelines
         * @type {Phaser.Structs.Map.<string, Phaser.Renderer.WebGL.WebGLPipeline>}
         * @since 3.50.0
         */ this.pipelines = new CustomMap();
                    /**
         * Current pipeline in use by the WebGLRenderer.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#current
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.current = null;
                    /**
         * The previous WebGLPipeline that was in use.
         *
         * This is set when `clearPipeline` is called and restored in `rebindPipeline` if none is given.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#previous
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.previous = null;
                    /**
         * A constant-style reference to the Multi Pipeline Instance.
         *
         * This is the default Phaser 3 pipeline and is used by the WebGL Renderer to manage
         * camera effects and more. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#MULTI_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.MultiPipeline}
         * @default null
         * @since 3.50.0
         */ this.MULTI_PIPELINE = null;
                    /**
         * A constant-style reference to the Bitmap Mask Pipeline Instance.
         *
         * This is the default Phaser 3 mask pipeline and is used Game Objects using
         * a Bitmap Mask. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#BITMAPMASK_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline}
         * @default null
         * @since 3.50.0
         */ this.BITMAPMASK_PIPELINE = null;
                    /**
         * A constant-style reference to the Utility Pipeline Instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#UTILITY_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline}
         * @default null
         * @since 3.50.0
         */ this.UTILITY_PIPELINE = null;
                    /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                },
                /**
     * Internal boot handler, called by the WebGLRenderer durings its boot process.
     *
     * Adds all of the default pipelines, based on the game config, and then calls
     * the `boot` method on each one of them.
     *
     * Finally, the default pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#boot
     * @since 3.50.0
     *
     * @param {Phaser.Types.Core.PipelineConfig} [pipelineConfig] - The pipeline configuration object as set in the Game Config.
     */ boot: function(pipelineConfig) {
                    //  Install each of the default pipelines
                    var instance;
                    var pipelineName;
                    var _this = this;
                    var game = this.game;
                    this.classes.each(function(pipelineName, pipeline) {
                        instance = _this.add(pipelineName, new pipeline({
                            game: game
                        }));
                        if (pipelineName === CONST.UTILITY_PIPELINE) {
                            _this.UTILITY_PIPELINE = instance;
                            //  FBO references
                            _this.fullFrame1 = instance.fullFrame1;
                            _this.fullFrame2 = instance.fullFrame2;
                            _this.halfFrame1 = instance.halfFrame1;
                            _this.halfFrame2 = instance.halfFrame2;
                        }
                    });
                    //  Our const-like references
                    this.MULTI_PIPELINE = this.get(CONST.MULTI_PIPELINE);
                    this.BITMAPMASK_PIPELINE = this.get(CONST.BITMAPMASK_PIPELINE);
                    //  And now the ones in the config, if any
                    if (pipelineConfig) for(pipelineName in pipelineConfig){
                        var pipelineClass = pipelineConfig[pipelineName];
                        instance = new pipelineClass(game);
                        if (instance.isPostFX) this.postPipelineClasses.set(pipelineName, pipelineClass);
                        else if (!this.has(pipelineName)) {
                            this.classes.set(pipelineName, pipelineClass);
                            this.add(pipelineName, instance);
                        }
                    }
                },
                /**
     * Adds a pipeline instance to this Pipeline Manager.
     *
     * The name of the instance must be unique within this manager.
     *
     * Make sure to pass an instance to this method, not a base class.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.add('yourName', new CustomPipeline());`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.add('yourName', CustomPipeline);`
     * ```
     *
     * To add a **Post Pipeline**, see `addPostPipeline` instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#add
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - A pipeline _instance_ which must extend `WebGLPipeline`.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance that was passed.
     */ add: function(name, pipeline) {
                    if (pipeline.isPostFX) {
                        console.warn(name + " is a Post Pipeline. Use `addPostPipeline` instead");
                        return;
                    }
                    var pipelines = this.pipelines;
                    var renderer = this.renderer;
                    if (!pipelines.has(name)) {
                        pipeline.name = name;
                        pipeline.manager = this;
                        pipelines.set(name, pipeline);
                    } else console.warn("Pipeline exists: " + name);
                    if (!pipeline.hasBooted) pipeline.boot();
                    if (renderer.width !== 0 && renderer.height !== 0) pipeline.resize(renderer.width, renderer.height);
                    return pipeline;
                },
                /**
     * Adds a Post Pipeline to this Pipeline Manager.
     *
     * Make sure to pass a base class to this method, not an instance.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', CustomPipeline);`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', new CustomPipeline());`
     * ```
     *
     * To add a regular pipeline, see the `add` method instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#addPostPipeline
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {function} pipeline - A pipeline class which must extend `PostFXPipeline`.
     *
     * @return {this} This Pipeline Manager.
     */ addPostPipeline: function(name, pipeline) {
                    if (!this.postPipelineClasses.has(name)) this.postPipelineClasses.set(name, pipeline);
                },
                /**
     * Flushes the current pipeline, if one is bound.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#flush
     * @since 3.50.0
     */ flush: function() {
                    if (this.current) this.current.flush();
                },
                /**
     * Checks if a pipeline is present in this Pipeline Manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#has
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {boolean} `true` if the given pipeline is loaded, otherwise `false`.
     */ has: function(pipeline) {
                    var pipelines = this.pipelines;
                    if (typeof pipeline === "string") return pipelines.has(pipeline);
                    else if (pipelines.contains(pipeline)) return true;
                    return false;
                },
                /**
     * Returns the pipeline instance based on the given name, or instance.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#get
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance, or `undefined` if not found.
     */ get: function(pipeline) {
                    var pipelines = this.pipelines;
                    if (typeof pipeline === "string") return pipelines.get(pipeline);
                    else if (pipelines.contains(pipeline)) return pipeline;
                },
                /**
     * Returns a _new instance_ of the post pipeline based on the given name, or class.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getPostPipeline
     * @since 3.50.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance, or class to look-up.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - If this post pipeline is being installed into a Game Object or Camera, this is a reference to it.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} The pipeline instance, or `undefined` if not found.
     */ getPostPipeline: function(pipeline, gameObject) {
                    var pipelineClasses = this.postPipelineClasses;
                    var instance;
                    if (typeof pipeline === "string") instance = pipelineClasses.get(pipeline);
                    else if (typeof pipeline === "function") //  A class
                    {
                        if (pipelineClasses.contains(pipeline)) instance = pipeline;
                    } else if (typeof pipeline === "object") //  Instance
                    instance = pipelineClasses.get(pipeline.name);
                    if (instance) {
                        var newPipeline = new instance(this.game);
                        if (gameObject) newPipeline.gameObject = gameObject;
                        return newPipeline;
                    }
                },
                /**
     * Removes a pipeline instance based on the given name.
     *
     * If no pipeline matches the name, this method does nothing.
     *
     * Note that the pipeline will not be flushed or destroyed, it's simply removed from
     * this manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#remove
     * @since 3.50.0
     *
     * @param {string} name - The name of the pipeline to be removed.
     * @param {boolean} [removeClass=true] - Remove the pipeline class as well as the instance?
     * @param {boolean} [removePostPipelineClass=true] - Remove the post pipeline class as well as the instance?
     */ remove: function(name, removeClass, removePostPipelineClass) {
                    if (removeClass === undefined) removeClass = true;
                    if (removePostPipelineClass === undefined) removePostPipelineClass = true;
                    this.pipelines.delete(name);
                    if (removeClass) this.classes.delete(name);
                    if (removePostPipelineClass) this.postPipelineClasses.delete(name);
                },
                /**
     * Sets the current pipeline to be used by the `WebGLRenderer`.
     *
     * This method accepts a pipeline instance as its parameter, not the name.
     *
     * If the pipeline isn't already the current one it will call `WebGLPipeline.bind` and then `onBind`.
     *
     * You cannot set Post FX Pipelines using this method. To use a Post FX Pipeline, you should
     * apply it to either a Camera, Container or other supporting Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#set
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be set as current.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline that was set, or undefined if it couldn't be set.
     */ set: function(pipeline, gameObject, currentShader) {
                    if (pipeline.isPostFX) return;
                    if (!this.isCurrent(pipeline, currentShader)) {
                        this.flush();
                        if (this.current) this.current.unbind();
                        this.current = pipeline;
                        pipeline.bind(currentShader);
                    }
                    pipeline.updateProjectionMatrix();
                    pipeline.onBind(gameObject);
                    return pipeline;
                },
                /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch. It causes a batch
     * flush, then calls the `preBatch` method on the post-fx pipelines belonging to the
     * Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object about to be batched.
     */ preBatch: function(gameObject) {
                    if (gameObject.hasPostPipeline) {
                        this.flush();
                        var pipelines = gameObject.postPipelines;
                        //  Iterate in reverse because we need them stacked in the order they're in the array
                        for(var i = pipelines.length - 1; i >= 0; i--){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.preBatch(gameObject);
                        }
                    }
                },
                /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. It causes a batch
     * flush, then calls the `postBatch` method on the post-fx pipelines belonging to the
     * Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to the batch.
     */ postBatch: function(gameObject) {
                    if (gameObject.hasPostPipeline) {
                        this.flush();
                        var pipelines = gameObject.postPipelines;
                        for(var i = 0; i < pipelines.length; i++){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.postBatch(gameObject);
                        }
                    }
                },
                /**
     * Called at the start of the `WebGLRenderer.preRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `preBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera about to be rendered.
     */ preBatchCamera: function(camera) {
                    if (camera.hasPostPipeline) {
                        this.flush();
                        var pipelines = camera.postPipelines;
                        //  Iterate in reverse because we need them stacked in the order they're in the array
                        for(var i = pipelines.length - 1; i >= 0; i--){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.preBatch(camera);
                        }
                    }
                },
                /**
     * Called at the end of the `WebGLRenderer.postRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `postBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that was just rendered.
     */ postBatchCamera: function(camera) {
                    if (camera.hasPostPipeline) {
                        this.flush();
                        var pipelines = camera.postPipelines;
                        for(var i = 0; i < pipelines.length; i++){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.postBatch(camera);
                        }
                    }
                },
                /**
     * Checks to see if the given pipeline is already the active pipeline, both within this
     * Pipeline Manager and also has the same shader set in the Renderer.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#isCurrent
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be checked.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {boolean} `true` if the given pipeline is already the current pipeline, otherwise `false`.
     */ isCurrent: function(pipeline, currentShader) {
                    var renderer = this.renderer;
                    var current = this.current;
                    if (current && !currentShader) currentShader = current.currentShader;
                    return !(current !== pipeline || currentShader.program !== renderer.currentProgram);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).copyFrame(source, target, brightness, clear, clearAlpha);
                    return this;
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).copyToGame(source);
                    return this;
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     *
     * @return {this} This Pipeline Manager instance.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                    this.setUtility(this.UTILITY_PIPELINE.colorMatrixShader).drawFrame(source, target, clearAlpha, colorMatrix);
                    return this;
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.linearShader).blendFrames(source1, source2, target, strength, clearAlpha);
                    return this;
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.addShader).blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                    return this;
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ clearFrame: function(target, clearAlpha) {
                    this.UTILITY_PIPELINE.clearFrame(target, clearAlpha);
                    return this;
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     *
     * @return {this} This Pipeline Manager instance.
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                    return this;
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    this.UTILITY_PIPELINE.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                    return this;
                },
                /**
     * Returns `true` if the current pipeline is forced to use texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#forceZero
     * @since 3.50.0
     *
     * @return {boolean} `true` if the current pipeline is forced to use texture unit zero.
     */ forceZero: function() {
                    return this.current && this.current.forceZero;
                },
                /**
     * Sets the Multi Pipeline to be the currently bound pipeline.
     *
     * This is the default Phaser 3 rendering pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setMulti
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} The Multi Pipeline instance.
     */ setMulti: function() {
                    return this.set(this.MULTI_PIPELINE);
                },
                /**
     * Sets the Utility Pipeline to be the currently bound pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setUtility
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline} The Utility Pipeline instance.
     */ setUtility: function(currentShader) {
                    return this.UTILITY_PIPELINE.bind(currentShader);
                },
                /**
     * Use this to reset the gl context to the state that Phaser requires to continue rendering.
     *
     * Calling this will:
     *
     * * Disable `DEPTH_TEST`, `CULL_FACE` and `STENCIL_TEST`.
     * * Clear the depth buffer and stencil buffers.
     * * Reset the viewport size.
     * * Reset the blend mode.
     * * Bind a blank texture as the active texture on texture unit zero.
     * * Rebinds the given pipeline instance.
     *
     * You should call this if you have previously called `clear`, and then wish to return
     * rendering control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#rebind
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} [pipeline] - The pipeline instance to be rebound. If not given, the previous pipeline will be bound.
     */ rebind: function(pipeline) {
                    if (pipeline === undefined && this.previous) pipeline = this.previous;
                    var renderer = this.renderer;
                    var gl = renderer.gl;
                    gl.disable(gl.DEPTH_TEST);
                    gl.disable(gl.CULL_FACE);
                    if (renderer.hasActiveStencilMask()) gl.clear(gl.DEPTH_BUFFER_BIT);
                    else {
                        //  If there wasn't a stencil mask set before this call, we can disable it safely
                        gl.disable(gl.STENCIL_TEST);
                        gl.clear(gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                    }
                    gl.viewport(0, 0, renderer.width, renderer.height);
                    renderer.currentProgram = null;
                    renderer.setBlendMode(0, true);
                    var entries = this.pipelines.entries;
                    for(var key in entries)entries[key].glReset = true;
                    if (pipeline) {
                        this.current = pipeline;
                        pipeline.rebind();
                    }
                    renderer.resetTextures();
                },
                /**
     * Flushes the current pipeline being used and then clears it, along with the
     * the current shader program and vertex buffer from the `WebGLRenderer`.
     *
     * Then resets the blend mode to NORMAL.
     *
     * Call this before jumping to your own gl context handler, and then call `rebind` when
     * you wish to return control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clear
     * @since 3.50.0
     */ clear: function() {
                    var renderer = this.renderer;
                    this.flush();
                    if (this.current) {
                        this.current.unbind();
                        this.previous = this.current;
                        this.current = null;
                    } else this.previous = null;
                    renderer.currentProgram = null;
                    renderer.setBlendMode(0, true);
                },
                /**
     * Destroy the Pipeline Manager, cleaning up all related resources and references.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.flush();
                    this.classes.clear();
                    this.postPipelineClasses.clear();
                    this.pipelines.clear();
                    this.renderer = null;
                    this.game = null;
                    this.classes = null;
                    this.postPipelineClasses = null;
                    this.pipelines = null;
                    this.current = null;
                    this.previous = null;
                }
            });
            module1.exports = PipelineManager;
        /***/ },
        /* 373 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(866);
            var ShaderSourceVS = __webpack_require__(867);
            var WEBGL_CONST = __webpack_require__(107);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Bitmap Mask Pipeline handles all of the bitmap mask rendering in WebGL for applying
 * alpha masks to Game Objects. It works by sampling two texture on the fragment shader and
 * using the fragments alpha to clip the region.
 *
 * The fragment shader it uses can be found in `shaders/src/BitmapMask.frag`.
 * The vertex shader it uses can be found in `shaders/src/BitmapMask.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D)
 * `uMaskSampler` (sampler2D)
 * `uInvertMaskAlpha` (bool)
 *
 * @class BitmapMaskPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var BitmapMaskPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function BitmapMaskPipeline(config) {
                    config.fragShader = GetFastValue(config, "fragShader", ShaderSourceFS), config.vertShader = GetFastValue(config, "vertShader", ShaderSourceVS), config.batchSize = GetFastValue(config, "batchSize", 1), config.vertices = GetFastValue(config, "vertices", [
                        -1,
                        1,
                        -1,
                        -7,
                        7,
                        1
                    ]), config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2,
                            type: WEBGL_CONST.FLOAT
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.set1i("uMainSampler", 0);
                    this.set1i("uMaskSampler", 1);
                },
                resize: function(width, height) {
                    WebGLPipeline.prototype.resize.call(this, width, height);
                    this.set2f("uResolution", width, height);
                },
                /**
     * Binds necessary resources and renders the mask to a separated framebuffer.
     * The framebuffer for the masked object is also bound for further use.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#beginMask
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as mask.
     * @param {Phaser.GameObjects.GameObject} maskedObject - GameObject masked by the mask GameObject.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the current mask.
     */ beginMask: function(mask, maskedObject, camera) {
                    var gl = this.gl;
                    //  The renderable Game Object that is being used for the bitmap mask
                    if (mask.bitmapMask && gl) {
                        var renderer = this.renderer;
                        renderer.flush();
                        renderer.pushFramebuffer(mask.mainFramebuffer);
                        gl.disable(gl.STENCIL_TEST);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        if (renderer.currentCameraMask.mask !== mask) {
                            renderer.currentMask.mask = mask;
                            renderer.currentMask.camera = camera;
                        }
                    }
                },
                /**
     * The masked game objects framebuffer is unbound and its texture
     * is bound together with the mask texture and the mask shader and
     * a draw call with a single quad is processed. Here is where the
     * masking effect is applied.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#endMask
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as a mask.
     */ endMask: function(mask, camera) {
                    var gl = this.gl;
                    var renderer = this.renderer;
                    //  The renderable Game Object that is being used for the bitmap mask
                    var bitmapMask = mask.bitmapMask;
                    if (bitmapMask && gl) {
                        //  mask.mainFramebuffer should now contain all the Game Objects we want masked
                        renderer.flush();
                        //  Swap to the mask framebuffer (push, in case the bitmapMask GO has a post-pipeline)
                        renderer.pushFramebuffer(mask.maskFramebuffer);
                        //  Clear it and draw the Game Object that is acting as a mask to it
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        renderer.setBlendMode(0, true);
                        bitmapMask.renderWebGL(renderer, bitmapMask, camera);
                        renderer.flush();
                        //  Clear the mask framebuffer + main framebuffer
                        renderer.popFramebuffer();
                        renderer.popFramebuffer();
                        //  Is there a stencil further up the stack?
                        var prev = renderer.getCurrentStencilMask();
                        if (prev) {
                            gl.enable(gl.STENCIL_TEST);
                            prev.mask.applyStencil(renderer, prev.camera, true);
                        } else renderer.currentMask.mask = null;
                        //  Bind this pipeline and draw
                        renderer.pipelines.set(this);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, mask.maskTexture);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, mask.mainTexture);
                        this.set1i("uInvertMaskAlpha", mask.invertAlpha);
                        //  Finally, draw a triangle filling the whole screen
                        gl.drawArrays(this.topology, 0, 3);
                        renderer.resetTextures();
                    }
                }
            });
            module1.exports = BitmapMaskPipeline;
        /***/ },
        /* 374 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Pipelines.Events
 */ module1.exports = {
                AFTER_FLUSH: __webpack_require__(868),
                BEFORE_FLUSH: __webpack_require__(869),
                BIND: __webpack_require__(870),
                BOOT: __webpack_require__(871),
                DESTROY: __webpack_require__(872),
                REBIND: __webpack_require__(873),
                RESIZE: __webpack_require__(874)
            };
        /***/ },
        /* 375 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var WEBGL_CONST = __webpack_require__(107);
            /**
 * @classdesc
 * Instances of the WebGLShader class belong to the WebGL Pipeline classes. When the pipeline is
 * created it will create an instance of this class for each one of its shaders, as defined in
 * the pipeline configuration.
 *
 * This class encapsulates everything needed to manage a shader in a pipeline, including the
 * shader attributes and uniforms, as well as lots of handy methods such as `set2f`, for setting
 * uniform values on this shader.
 *
 * Typically, you do not create an instance of this class directly, as it works in unison with
 * the pipeline to which it belongs. You can gain access to this class via a pipeline's `shaders`
 * array, post-creation.
 *
 * @class WebGLShader
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline to which this Shader belongs.
 * @param {string} name - The name of this Shader.
 * @param {string} vertexShader - The vertex shader source code as a single string.
 * @param {string} fragmentShader - The fragment shader source code as a single string.
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributeConfig[]} attributes - An array of attributes.
 */ var WebGLShader = new Class({
                initialize: function WebGLShader(pipeline, name, vertexShader, fragmentShader, attributes) {
                    /**
         * A reference to the WebGLPipeline that owns this Shader.
         *
         * A Shader class can only belong to a single pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#pipeline
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @since 3.50.0
         */ this.pipeline = pipeline;
                    /**
         * The name of this shader.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#name
         * @type {string}
         * @since 3.50.0
         */ this.name = name;
                    /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = pipeline.renderer;
                    /**
         * A reference to the WebGL Rendering Context the WebGL Renderer is using.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#gl
         * @type {WebGLRenderingContext}
         * @since 3.50.0
         */ this.gl = this.renderer.gl;
                    /**
         * The WebGLProgram created from the vertex and fragment shaders.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#program
         * @type {WebGLProgram}
         * @since 3.50.0
         */ this.program = this.renderer.createProgram(vertexShader, fragmentShader);
                    /**
         * Array of objects that describe the vertex attributes.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#attributes
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineAttribute[]}
         * @since 3.50.0
         */ this.attributes;
                    /**
         * The amount of vertex attribute components of 32 bit length.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexComponentCount
         * @type {number}
         * @since 3.50.0
         */ this.vertexComponentCount = 0;
                    /**
         * The size, in bytes, of a single vertex.
         *
         * This is derived by adding together all of the vertex attributes.
         *
         * For example, the Multi Pipeline has the following attributes:
         *
         * inPosition - (size 2 x gl.FLOAT) = 8
         * inTexCoord - (size 2 x gl.FLOAT) = 8
         * inTexId - (size 1 x gl.FLOAT) = 4
         * inTintEffect - (size 1 x gl.FLOAT) = 4
         * inTint - (size 4 x gl.UNSIGNED_BYTE) = 4
         *
         * The total, in this case, is 8 + 8 + 4 + 4 + 4 = 28.
         *
         * This is calculated automatically during the `createAttributes` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexSize
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.vertexSize = 0;
                    /**
         * The active uniforms that this shader has.
         *
         * This is an object that maps the uniform names to their WebGL location and cached values.
         *
         * It is populated automatically via the `createUniforms` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#uniforms
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineUniformsConfig}
         * @since 3.50.0
         */ this.uniforms = {};
                    this.createAttributes(attributes);
                    this.createUniforms();
                },
                /**
     * Takes the vertex attributes config and parses it, creating the resulting array that is stored
     * in this shaders `attributes` property, calculating the offset, normalization and location
     * in the process.
     *
     * Calling this method resets `WebGLShader.attributes`, `WebGLShader.vertexSize` and
     * `WebGLShader.vertexComponentCount`.
     *
     * It is called automatically when this class is created, but can be called manually if required.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createAttributes
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributeConfig[]} attributes - An array of attributes configs.
     */ createAttributes: function(attributes) {
                    var count = 0;
                    var offset = 0;
                    var result = [];
                    this.vertexComponentCount = 0;
                    for(var i = 0; i < attributes.length; i++){
                        var element = attributes[i];
                        var name = element.name;
                        var size = GetFastValue(element, "size", 1); // i.e. 1 for a float, 2 for a vec2, 4 for a vec4, etc
                        var glType = GetFastValue(element, "type", WEBGL_CONST.FLOAT);
                        var type = glType.enum; // The GLenum
                        var typeSize = glType.size; // The size in bytes of the type
                        var normalized = element.normalized ? true : false;
                        result.push({
                            name: name,
                            size: size,
                            type: type,
                            normalized: normalized,
                            offset: offset,
                            enabled: false,
                            location: -1
                        });
                        if (typeSize === 4) count += size;
                        else count++;
                        offset += size * typeSize;
                    }
                    this.vertexSize = offset;
                    this.vertexComponentCount = count;
                    this.attributes = result;
                },
                /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * This method is called every time the parent pipeline is made the current active pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#bind
     * @since 3.50.0
     *
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     * @param {boolean} [flush=false] - Flush the pipeline before binding this shader?
     *
     * @return {this} This WebGLShader instance.
     */ bind: function(setAttributes, flush) {
                    if (setAttributes === undefined) setAttributes = false;
                    if (flush === undefined) flush = false;
                    if (flush) this.pipeline.flush();
                    this.renderer.setProgram(this.program);
                    if (setAttributes) this.setAttribPointers();
                    return this;
                },
                /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * Then resets all of the attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#rebind
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ rebind: function() {
                    this.renderer.setProgram(this.program);
                    this.setAttribPointers(true);
                    return this;
                },
                /**
     * Sets the vertex attribute pointers.
     *
     * This should only be called after the vertex buffer has been bound.
     *
     * It is called automatically during the `bind` method.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setAttribPointers
     * @since 3.50.0
     *
     * @param {boolean} [reset=false] - Reset the vertex attribute locations?
     *
     * @return {this} This WebGLShader instance.
     */ setAttribPointers: function(reset) {
                    if (reset === undefined) reset = false;
                    var gl = this.gl;
                    var vertexSize = this.vertexSize;
                    var attributes = this.attributes;
                    var program = this.program;
                    for(var i = 0; i < attributes.length; i++){
                        var element = attributes[i];
                        var size = element.size;
                        var type = element.type;
                        var offset = element.offset;
                        var enabled = element.enabled;
                        var location = element.location;
                        var normalized = element.normalized ? true : false;
                        if (reset) {
                            var attribLocation = gl.getAttribLocation(program, element.name);
                            if (attribLocation >= 0) {
                                gl.enableVertexAttribArray(attribLocation);
                                gl.vertexAttribPointer(attribLocation, size, type, normalized, vertexSize, offset);
                                element.enabled = true;
                                element.location = attribLocation;
                            } else if (attribLocation !== -1) gl.disableVertexAttribArray(attribLocation);
                        } else if (enabled) gl.vertexAttribPointer(location, size, type, normalized, vertexSize, offset);
                        else if (!enabled && location > -1) {
                            gl.disableVertexAttribArray(location);
                            element.location = -1;
                        }
                    }
                    return this;
                },
                /**
     * Sets up the `WebGLShader.uniforms` object, populating it with the names
     * and locations of the shader uniforms this shader requires.
     *
     * It works by first calling `gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS)` to
     * find out how many active uniforms this shader has. It then iterates through them,
     * calling `gl.getActiveUniform` to get the WebGL Active Info from each one. Finally,
     * the name and location are stored in the local array.
     *
     * This method is called automatically when this class is created.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createUniforms
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ createUniforms: function() {
                    var gl = this.gl;
                    var program = this.program;
                    var uniforms = this.uniforms;
                    var i;
                    var name;
                    var location;
                    //  Look-up all active uniforms
                    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
                    for(i = 0; i < totalUniforms; i++){
                        var info = gl.getActiveUniform(program, i);
                        if (info) {
                            name = info.name;
                            location = gl.getUniformLocation(program, name);
                            if (location !== null) uniforms[name] = {
                                name: name,
                                location: location,
                                value1: null,
                                value2: null,
                                value3: null,
                                value4: null
                            };
                            //  If the uniform name contains [] for an array struct,
                            //  we'll add an entry for the non-struct name as well.
                            //  Such as uMainSampler[12] = uMainSampler
                            var struct = name.indexOf("[");
                            if (struct > 0) {
                                name = name.substr(0, struct);
                                if (!uniforms.hasOwnProperty(name)) {
                                    location = gl.getUniformLocation(program, name);
                                    if (location !== null) uniforms[name] = {
                                        name: name,
                                        location: location,
                                        value1: null,
                                        value2: null,
                                        value3: null,
                                        value4: null
                                    };
                                }
                            }
                        }
                    }
                    return this;
                },
                /**
     * Checks to see if the given uniform name exists and is active in this shader.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#hasUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to check for.
     *
     * @return {boolean} `true` if the uniform exists, otherwise `false`.
     */ hasUniform: function(name) {
                    return this.uniforms.hasOwnProperty(name);
                },
                /**
     * Resets the cached values of the given uniform.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#resetUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to reset.
     *
     * @return {this} This WebGLShader instance.
     */ resetUniform: function(name) {
                    var uniform = this.uniforms[name];
                    if (uniform) {
                        uniform.value1 = null;
                        uniform.value2 = null;
                        uniform.value3 = null;
                        uniform.value4 = null;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform1
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform1: function(setter, name, value1, skipCheck) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (skipCheck || uniform.value1 !== value1) {
                        uniform.value1 = value1;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform2
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform2: function(setter, name, value1, value2, skipCheck) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform3
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform3: function(setter, name, value1, value2, value3, skipCheck) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        uniform.value3 = value3;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2, value3);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform4
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value4 - The new value of the uniform.
     * @param {boolean} [skipCheck=false] - Skip the value comparison?
     *
     * @return {this} This WebGLShader instance.
     */ setUniform4: function(setter, name, value1, value2, value3, value4, skipCheck) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (skipCheck || uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3 || uniform.value4 !== value4) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        uniform.value3 = value3;
                        uniform.value4 = value4;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2, value3, value4);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets a 1f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1f: function(name, x) {
                    return this.setUniform1(this.gl.uniform1f, name, x);
                },
                /**
     * Sets a 2f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2f: function(name, x, y) {
                    return this.setUniform2(this.gl.uniform2f, name, x, y);
                },
                /**
     * Sets a 3f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3f: function(name, x, y, z) {
                    return this.setUniform3(this.gl.uniform3f, name, x, y, z);
                },
                /**
     * Sets a 4f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4f: function(name, x, y, z, w) {
                    return this.setUniform4(this.gl.uniform4f, name, x, y, z, w);
                },
                /**
     * Sets a 1fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform1fv, name, arr, true);
                },
                /**
     * Sets a 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform2fv, name, arr, true);
                },
                /**
     * Sets a 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform3fv, name, arr, true);
                },
                /**
     * Sets a 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform4fv, name, arr, true);
                },
                /**
     * Sets a 1iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform1iv, name, arr, true);
                },
                /**
     * Sets a 2iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform2iv, name, arr, true);
                },
                /**
     * Sets a 3iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform3iv, name, arr, true);
                },
                /**
     * Sets a 4iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform4iv, name, arr, true);
                },
                /**
     * Sets a 1i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1i: function(name, x) {
                    return this.setUniform1(this.gl.uniform1i, name, x);
                },
                /**
     * Sets a 2i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2i: function(name, x, y) {
                    return this.setUniform2(this.gl.uniform2i, name, x, y);
                },
                /**
     * Sets a 3i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3i: function(name, x, y, z) {
                    return this.setUniform3(this.gl.uniform3i, name, x, y, z);
                },
                /**
     * Sets a 4i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4i: function(name, x, y, z, w) {
                    return this.setUniform4(this.gl.uniform4i, name, x, y, z, w);
                },
                /**
     * Sets a matrix 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix2fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix2fv, name, transpose, matrix, true);
                },
                /**
     * Sets a matrix 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix3fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix3fv, name, transpose, matrix, true);
                },
                /**
     * Sets a matrix 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Should the matrix be transpose
     * @param {Float32Array} matrix - Matrix data
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix4fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix4fv, name, transpose, matrix, true);
                },
                /**
     * Removes all external references from this class and deletes the WebGL program from the WebGL context.
     *
     * Does not remove this shader from the parent pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.gl.deleteProgram(this.program);
                    this.pipeline = null;
                    this.renderer = null;
                    this.gl = null;
                    this.program = null;
                    this.attributes = null;
                    this.uniforms = null;
                }
            });
            module1.exports = WebGLShader;
        /***/ },
        /* 376 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(59);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(875);
            var ShaderSourceVS = __webpack_require__(876);
            var TransformMatrix = __webpack_require__(25);
            var WEBGL_CONST = __webpack_require__(107);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Graphics Pipeline is the rendering pipeline used by Phaser in WebGL when drawing
 * primitive geometry objects, such as the Graphics Game Object, or the Shape Game Objects
 * such as Arc, Line, Rectangle and Star. It handles the preperation and batching of related vertices.
 *
 * Prior to Phaser v3.50 the functions of this pipeline were merged with the `TextureTintPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Graphics.frag`.
 * The vertex shader it uses can be found in `shaders/src/Graphics.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2)
 * `inColor` (vec4, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 *
 * @class GraphicsPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var GraphicsPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function GraphicsPipeline(config) {
                    config.fragShader = GetFastValue(config, "fragShader", ShaderSourceFS);
                    config.vertShader = GetFastValue(config, "vertShader", ShaderSourceVS);
                    config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inColor",
                            size: 4,
                            type: WEBGL_CONST.UNSIGNED_BYTE,
                            normalized: true
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                    /**
         * A temporary Transform Matrix, re-used internally during batching by the
         * Shape Game Objects.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#calcMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.50.0
         */ this.calcMatrix = new TransformMatrix();
                    /**
         * Used internally to draw stroked triangles.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#tempTriangle
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.tempTriangle = [
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        }
                    ];
                    /**
         * Cached stroke tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#strokeTint
         * @type {object}
         * @private
         * @since 3.50.0
         */ this.strokeTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Cached fill tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#fillTint
         * @type {object}
         * @private
         * @since 3.50.0
         */ this.fillTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Internal texture frame reference.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#currentFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.50.0
         */ this.currentFrame = {
                        u0: 0,
                        v0: 0,
                        u1: 1,
                        v1: 1
                    };
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#firstQuad
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.firstQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#prevQuad
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.prevQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Used internally for triangulating a polygon.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#polygonCache
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.polygonCache = [];
                },
                /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * Rectangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillRect
     * @since 3.50.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillRect: function(x, y, width, height, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var xw = x + width;
                    var yh = y + height;
                    var x0 = calcMatrix.getX(x, y);
                    var y0 = calcMatrix.getY(x, y);
                    var x1 = calcMatrix.getX(x, yh);
                    var y1 = calcMatrix.getY(x, yh);
                    var x2 = calcMatrix.getX(xw, yh);
                    var y2 = calcMatrix.getY(xw, yh);
                    var x3 = calcMatrix.getX(xw, y);
                    var y3 = calcMatrix.getY(xw, y);
                    var tint = this.fillTint;
                    this.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint.TL, tint.TR, tint.BL, tint.BR);
                },
                /**
     * Pushes a filled triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillTriangle
     * @since 3.50.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillTriangle: function(x0, y0, x1, y1, x2, y2, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var tx0 = calcMatrix.getX(x0, y0);
                    var ty0 = calcMatrix.getY(x0, y0);
                    var tx1 = calcMatrix.getX(x1, y1);
                    var ty1 = calcMatrix.getY(x1, y1);
                    var tx2 = calcMatrix.getX(x2, y2);
                    var ty2 = calcMatrix.getY(x2, y2);
                    var tint = this.fillTint;
                    this.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, tint.TL, tint.TR, tint.BL);
                },
                /**
     * Pushes a stroked triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * The triangle is created from 3 lines and drawn using the `batchStrokePath` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchStrokeTriangle
     * @since 3.50.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {number} lineWidth - The width of the line in pixels.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokeTriangle: function(x0, y0, x1, y1, x2, y2, lineWidth, currentMatrix, parentMatrix) {
                    var tempTriangle = this.tempTriangle;
                    tempTriangle[0].x = x0;
                    tempTriangle[0].y = y0;
                    tempTriangle[0].width = lineWidth;
                    tempTriangle[1].x = x1;
                    tempTriangle[1].y = y1;
                    tempTriangle[1].width = lineWidth;
                    tempTriangle[2].x = x2;
                    tempTriangle[2].y = y2;
                    tempTriangle[2].width = lineWidth;
                    tempTriangle[3].x = x0;
                    tempTriangle[3].y = y0;
                    tempTriangle[3].width = lineWidth;
                    this.batchStrokePath(tempTriangle, lineWidth, false, currentMatrix, parentMatrix);
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and then passing it through Earcut, which
     * creates a list of polygons. Each polygon is then added to the batch.
     *
     * The path is always automatically closed because it's filled.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillPath
     * @since 3.50.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillPath: function(path, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var length = path.length;
                    var polygonCache = this.polygonCache;
                    var polygonIndexArray;
                    var point;
                    var tintTL = this.fillTint.TL;
                    var tintTR = this.fillTint.TR;
                    var tintBL = this.fillTint.BL;
                    for(var pathIndex = 0; pathIndex < length; ++pathIndex){
                        point = path[pathIndex];
                        polygonCache.push(point.x, point.y);
                    }
                    polygonIndexArray = Earcut(polygonCache);
                    length = polygonIndexArray.length;
                    for(var index = 0; index < length; index += 3){
                        var p0 = polygonIndexArray[index + 0] * 2;
                        var p1 = polygonIndexArray[index + 1] * 2;
                        var p2 = polygonIndexArray[index + 2] * 2;
                        var x0 = polygonCache[p0 + 0];
                        var y0 = polygonCache[p0 + 1];
                        var x1 = polygonCache[p1 + 0];
                        var y1 = polygonCache[p1 + 1];
                        var x2 = polygonCache[p2 + 0];
                        var y2 = polygonCache[p2 + 1];
                        var tx0 = calcMatrix.getX(x0, y0);
                        var ty0 = calcMatrix.getY(x0, y0);
                        var tx1 = calcMatrix.getX(x1, y1);
                        var ty1 = calcMatrix.getY(x1, y1);
                        var tx2 = calcMatrix.getX(x2, y2);
                        var ty2 = calcMatrix.getY(x2, y2);
                        this.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, tintTL, tintTR, tintBL);
                    }
                    polygonCache.length = 0;
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and calling `batchLine` for each section
     * of the path.
     *
     * The path is optionally closed at the end.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchStrokePath
     * @since 3.50.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {number} lineWidth - The width of the line segments in pixels.
     * @param {boolean} pathOpen - Indicates if the path should be closed or left open.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokePath: function(path, lineWidth, pathOpen, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    //  Reset the closePath booleans
                    this.prevQuad[4] = 0;
                    this.firstQuad[4] = 0;
                    var pathLength = path.length - 1;
                    for(var pathIndex = 0; pathIndex < pathLength; pathIndex++){
                        var point0 = path[pathIndex];
                        var point1 = path[pathIndex + 1];
                        this.batchLine(point0.x, point0.y, point1.x, point1.y, point0.width / 2, point1.width / 2, lineWidth, pathIndex, !pathOpen && pathIndex === pathLength - 1, currentMatrix, parentMatrix);
                    }
                },
                /**
     * Creates a line out of 4 quads and adds it to the vertex batch based on the given line values.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchLine
     * @since 3.50.0
     *
     * @param {number} ax - x coordinate of the start of the line.
     * @param {number} ay - y coordinate of the start of the line.
     * @param {number} bx - x coordinate of the end of the line.
     * @param {number} by - y coordinate of the end of the line.
     * @param {number} aLineWidth - Width of the start of the line.
     * @param {number} bLineWidth - Width of the end of the line.
     * @param {number} index - If this line is part of a multi-line draw, the index of the line in the draw.
     * @param {boolean} closePath - Does this line close a multi-line path?
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchLine: function(ax, ay, bx, by, aLineWidth, bLineWidth, lineWidth, index, closePath, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var dx = bx - ax;
                    var dy = by - ay;
                    var len = Math.sqrt(dx * dx + dy * dy);
                    var al0 = aLineWidth * (by - ay) / len;
                    var al1 = aLineWidth * (ax - bx) / len;
                    var bl0 = bLineWidth * (by - ay) / len;
                    var bl1 = bLineWidth * (ax - bx) / len;
                    var lx0 = bx - bl0;
                    var ly0 = by - bl1;
                    var lx1 = ax - al0;
                    var ly1 = ay - al1;
                    var lx2 = bx + bl0;
                    var ly2 = by + bl1;
                    var lx3 = ax + al0;
                    var ly3 = ay + al1;
                    //  tx0 = bottom right
                    var brX = calcMatrix.getX(lx0, ly0);
                    var brY = calcMatrix.getY(lx0, ly0);
                    //  tx1 = bottom left
                    var blX = calcMatrix.getX(lx1, ly1);
                    var blY = calcMatrix.getY(lx1, ly1);
                    //  tx2 = top right
                    var trX = calcMatrix.getX(lx2, ly2);
                    var trY = calcMatrix.getY(lx2, ly2);
                    //  tx3 = top left
                    var tlX = calcMatrix.getX(lx3, ly3);
                    var tlY = calcMatrix.getY(lx3, ly3);
                    var tint = this.strokeTint;
                    var tintTL = tint.TL;
                    var tintTR = tint.TR;
                    var tintBL = tint.BL;
                    var tintBR = tint.BR;
                    //  TL, BL, BR, TR
                    this.batchQuad(tlX, tlY, blX, blY, brX, brY, trX, trY, tintTL, tintTR, tintBL, tintBR);
                    if (lineWidth <= 2) //  No point doing a linejoin if the line isn't thick enough
                    return;
                    var prev = this.prevQuad;
                    var first = this.firstQuad;
                    if (index > 0 && prev[4]) this.batchQuad(tlX, tlY, blX, blY, prev[0], prev[1], prev[2], prev[3], tintTL, tintTR, tintBL, tintBR);
                    else {
                        first[0] = tlX;
                        first[1] = tlY;
                        first[2] = blX;
                        first[3] = blY;
                        first[4] = 1;
                    }
                    if (closePath && first[4]) //  Add a join for the final path segment
                    this.batchQuad(brX, brY, trX, trY, first[0], first[1], first[2], first[3], tintTL, tintTR, tintBL, tintBR);
                    else {
                        //  Store it
                        prev[0] = brX;
                        prev[1] = brY;
                        prev[2] = trX;
                        prev[3] = trY;
                        prev[4] = 1;
                    }
                },
                /**
     * Adds a single vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchTri` and `batchQuad`.
     *
     * It does not perform any batch limit checking itself, so if you need to call
     * this method directly, do so in the same way that `batchQuad` does, for example.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} tint - The tint color value.
     */ batchVert: function(x, y, tint) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexViewU32 = this.vertexViewU32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewU32[++vertexOffset] = tint;
                    this.vertexCount++;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where tx0/ty0 = 0, tx1/ty1 = 1, tx2/ty2 = 2 and tx3/ty3 = 3
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchQuad
     * @override
     * @since 3.50.0
     *
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(x0, y0, x1, y1, x2, y2, x3, y3, tintTL, tintTR, tintBL, tintBR) {
                    var hasFlushed = false;
                    if (this.shouldFlush(6)) {
                        this.flush();
                        hasFlushed = true;
                    }
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x1, y1, tintBL);
                    this.batchVert(x2, y2, tintBR);
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x2, y2, tintBR);
                    this.batchVert(x3, y3, tintTR);
                    return hasFlushed;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 3 vertices in the following arrangement:
     *
     * ```
     * 0
     * |\
     * | \
     * |  \
     * |   \
     * |    \
     * 1-----2
     * ```
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchTri
     * @override
     * @since 3.50.0
     *
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchTri: function(x0, y0, x1, y1, x2, y2, tintTL, tintTR, tintBL) {
                    var hasFlushed = false;
                    if (this.shouldFlush(3)) {
                        this.flush();
                        hasFlushed = true;
                    }
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x1, y1, tintTR);
                    this.batchVert(x2, y2, tintBL);
                    return hasFlushed;
                },
                /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#destroy
     * @since 3.50.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                    WebGLPipeline.prototype.destroy.call(this);
                    this.polygonCache = null;
                    return this;
                }
            });
            module1.exports = GraphicsPipeline;
        /***/ },
        /* 377 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var LightShaderSourceFS = __webpack_require__(877);
            var MultiPipeline = __webpack_require__(108);
            var Vec2 = __webpack_require__(3);
            var WebGLPipeline = __webpack_require__(58);
            var LIGHT_COUNT = 10;
            var tempVec2 = new Vec2();
            /**
 * @classdesc
 * The Light Pipeline is an extension of the Multi Pipeline and uses a custom shader
 * designed to handle forward diffused rendering of 2D lights in a Scene.
 *
 * The shader works in tandem with Light Game Objects, and optionally texture normal maps,
 * to provide an ambient illumination effect.
 *
 * If you wish to provide your own shader, you can use the `%LIGHT_COUNT%` declaration in the source,
 * and it will be automatically replaced at run-time with the total number of configured lights.
 *
 * The maximum number of lights can be set in the Render Config `maxLights` property and defaults to 10.
 *
 * Prior to Phaser v3.50 this pipeline was called the `ForwardDiffuseLightPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Light.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are those from the Multi Pipeline, plus:
 *
 * `uMainSampler` (sampler2D)
 * `uNormSampler` (sampler2D)
 * `uCamera` (vec4)
 * `uResolution` (vec2)
 * `uAmbientLightColor` (vec3)
 * `uInverseRotationMatrix` (mat3)
 * `uLights` (Light struct)
 *
 * @class LightPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var LightPipeline = new Class({
                Extends: MultiPipeline,
                initialize: function LightPipeline(config) {
                    LIGHT_COUNT = config.game.renderer.config.maxLights;
                    var fragShader = GetFastValue(config, "fragShader", LightShaderSourceFS);
                    var shaders = [];
                    for(var i = 1; i <= LIGHT_COUNT; i++)shaders.push({
                        name: "lights" + i,
                        fragShader: fragShader.replace("%LIGHT_COUNT%", i.toString())
                    });
                    config.shaders = shaders;
                    MultiPipeline.call(this, config);
                    /**
         * Inverse rotation matrix for normal map rotations.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#inverseRotationMatrix
         * @type {Float32Array}
         * @private
         * @since 3.16.0
         */ this.inverseRotationMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * Stores a default normal map, which is an object with a `glTexture` property that
         * maps to a 1x1 texture of the color #7f7fff created in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#defaultNormalMap
         * @type {object}
         * @since 3.50.0
         */ this.defaultNormalMap;
                    /**
         * A boolean that is set automatically during `onRender` that determines
         * if the Scene LightManager is active, or not.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#lightsActive
         * @type {boolean}
         * @readonly
         * @since 3.53.0
         */ this.lightsActive = true;
                },
                /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place and you can perform any final
     * tasks that the pipeline may need that relied on game systems such as the Texture Manager.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#boot
     * @since 3.11.0
     */ boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var gl = this.gl;
                    var tempTexture = gl.createTexture();
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, tempTexture);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([
                        127,
                        127,
                        255,
                        255
                    ]));
                    this.defaultNormalMap = {
                        glTexture: tempTexture
                    };
                    //  Set the lights shaders
                    for(var i = 0; i < this.shaders.length; i++)this["lightShader" + (i + 1)] = this.shaders[i];
                },
                /**
     * This function sets all the needed resources for each camera pass.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#onRender
     * @ignore
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function(scene, camera) {
                    var lightManager = scene.sys.lights;
                    this.lightsActive = false;
                    if (!lightManager || !lightManager.active) return;
                    var lights = lightManager.getLights(camera);
                    var lightsCount = lights.length;
                    if (lightsCount === 0) return;
                    //  Ok, we're good to go ...
                    this.lightsActive = true;
                    this.setShader(this["lightShader" + lightsCount], true);
                    var i;
                    var renderer = this.renderer;
                    var height = renderer.height;
                    var cameraMatrix = camera.matrix;
                    this.set1i("uMainSampler", 0);
                    this.set1i("uNormSampler", 1);
                    this.set2f("uResolution", this.width / 2, this.height / 2);
                    this.set4f("uCamera", camera.x, camera.y, camera.rotation, camera.zoom);
                    this.set3f("uAmbientLightColor", lightManager.ambientColor.r, lightManager.ambientColor.g, lightManager.ambientColor.b);
                    for(i = 0; i < lightsCount; i++){
                        var light = lights[i].light;
                        var color = light.color;
                        var lightName = "uLights[" + i + "].";
                        cameraMatrix.transformPoint(light.x, light.y, tempVec2);
                        this.set2f(lightName + "position", tempVec2.x - camera.scrollX * light.scrollFactorX * camera.zoom, height - (tempVec2.y - camera.scrollY * light.scrollFactorY * camera.zoom));
                        this.set3f(lightName + "color", color.r, color.g, color.b);
                        this.set1f(lightName + "intensity", light.intensity);
                        this.set1f(lightName + "radius", light.radius);
                    }
                    this.currentNormalMapRotation = null;
                },
                /**
     * Rotates the normal map vectors inversely by the given angle.
     * Only works in 2D space.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setNormalMapRotation
     * @since 3.16.0
     *
     * @param {number} rotation - The angle of rotation in radians.
     */ setNormalMapRotation: function(rotation) {
                    if (rotation !== this.currentNormalMapRotation || this.vertexCount === 0) {
                        if (this.vertexCount > 0) this.flush();
                        var inverseRotationMatrix = this.inverseRotationMatrix;
                        if (rotation) {
                            var rot = -rotation;
                            var c = Math.cos(rot);
                            var s = Math.sin(rot);
                            inverseRotationMatrix[1] = s;
                            inverseRotationMatrix[3] = -s;
                            inverseRotationMatrix[0] = inverseRotationMatrix[4] = c;
                        } else {
                            inverseRotationMatrix[0] = inverseRotationMatrix[4] = 1;
                            inverseRotationMatrix[1] = inverseRotationMatrix[3] = 0;
                        }
                        this.setMatrix3fv("uInverseRotationMatrix", false, inverseRotationMatrix);
                        this.currentNormalMapRotation = rotation;
                    }
                },
                /**
     * Assigns a texture to the current batch. If a different texture is already set it creates a new batch object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setTexture2D
     * @ignore
     * @since 3.50.0
     *
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch. If not given uses blankTexture.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object being rendered or added to the batch.
     */ setTexture2D: function(texture, gameObject) {
                    var renderer = this.renderer;
                    if (texture === undefined) texture = renderer.tempTextures[0];
                    var normalTexture = this.getNormalMap(gameObject);
                    if (renderer.isNewNormalMap(texture, normalTexture)) {
                        this.flush();
                        renderer.setTextureZero(texture);
                        renderer.setNormalMap(normalTexture);
                    }
                    var rotation = gameObject ? gameObject.rotation : 0;
                    this.setNormalMapRotation(rotation);
                    this.currentUnit = 0;
                    return 0;
                },
                /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setGameObject
     * @ignore
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                    if (frame === undefined) frame = gameObject.frame;
                    var renderer = this.renderer;
                    var texture = frame.glTexture;
                    var normalTexture = this.getNormalMap(gameObject);
                    if (renderer.isNewNormalMap()) {
                        this.flush();
                        renderer.setTextureZero(texture);
                        renderer.setNormalMap(normalTexture);
                    }
                    this.setNormalMapRotation(gameObject.rotation);
                    this.currentUnit = 0;
                    return 0;
                },
                /**
     * Returns the normal map WebGLTexture from the given Game Object.
     * If the Game Object doesn't have one, it returns the default normal map from this pipeline instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#getNormalMap
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object to get the normal map from.
     *
     * @return {WebGLTexture} The normal map texture.
     */ getNormalMap: function(gameObject) {
                    var normalTexture;
                    if (!gameObject) normalTexture = this.defaultNormalMap;
                    else if (gameObject.displayTexture) normalTexture = gameObject.displayTexture.dataSource[gameObject.displayFrame.sourceIndex];
                    else if (gameObject.texture) normalTexture = gameObject.texture.dataSource[gameObject.frame.sourceIndex];
                    else if (gameObject.tileset) {
                        if (Array.isArray(gameObject.tileset)) normalTexture = gameObject.tileset[0].image.dataSource[0];
                        else normalTexture = gameObject.tileset.image.dataSource[0];
                    }
                    if (!normalTexture) normalTexture = this.defaultNormalMap;
                    return normalTexture.glTexture;
                },
                /**
     * Takes a Sprite Game Object, or any object that extends it, and adds it to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchSprite
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.Image|Phaser.GameObjects.Sprite)} gameObject - The texture based Game Object to add to the batch.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(gameObject, camera, parentTransformMatrix) {
                    if (this.lightsActive) MultiPipeline.prototype.batchSprite.call(this, gameObject, camera, parentTransformMatrix);
                },
                /**
     * Generic function for batching a textured quad using argument values instead of a Game Object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchTexture
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject.
     * @param {WebGLTexture} texture - Raw WebGLTexture associated with the quad.
     * @param {number} textureWidth - Real texture width.
     * @param {number} textureHeight - Real texture height.
     * @param {number} srcX - X coordinate of the quad.
     * @param {number} srcY - Y coordinate of the quad.
     * @param {number} srcWidth - Width of the quad.
     * @param {number} srcHeight - Height of the quad.
     * @param {number} scaleX - X component of scale.
     * @param {number} scaleY - Y component of scale.
     * @param {number} rotation - Rotation of the quad.
     * @param {boolean} flipX - Indicates if the quad is horizontally flipped.
     * @param {boolean} flipY - Indicates if the quad is vertically flipped.
     * @param {number} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll.
     * @param {number} scrollFactorY - By which factor is the quad effected by the camera vertical scroll.
     * @param {number} displayOriginX - Horizontal origin in pixels.
     * @param {number} displayOriginY - Vertical origin in pixels.
     * @param {number} frameX - X coordinate of the texture frame.
     * @param {number} frameY - Y coordinate of the texture frame.
     * @param {number} frameWidth - Width of the texture frame.
     * @param {number} frameHeight - Height of the texture frame.
     * @param {number} tintTL - Tint for top left.
     * @param {number} tintTR - Tint for top right.
     * @param {number} tintBL - Tint for bottom left.
     * @param {number} tintBR - Tint for bottom right.
     * @param {number} tintEffect - The tint effect.
     * @param {number} uOffset - Horizontal offset on texture coordinate.
     * @param {number} vOffset - Vertical offset on texture coordinate.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container.
     * @param {boolean} [skipFlip=false] - Skip the renderTexture check.
     * @param {number} [textureUnit] - Use the currently bound texture unit?
     */ batchTexture: function(gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit) {
                    if (this.lightsActive) MultiPipeline.prototype.batchTexture.call(this, gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit);
                },
                /**
     * Adds a Texture Frame into the batch for rendering.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#batchTextureFrame
     * @since 3.50.0
     *
     * @param {Phaser.Textures.Frame} frame - The Texture Frame to be rendered.
     * @param {number} x - The horizontal position to render the texture at.
     * @param {number} y - The vertical position to render the texture at.
     * @param {number} tint - The tint color.
     * @param {number} alpha - The alpha value.
     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - The Transform Matrix to use for the texture.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - A parent Transform Matrix.
     */ batchTextureFrame: function(frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix) {
                    if (this.lightsActive) MultiPipeline.prototype.batchTextureFrame.call(this, frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix);
                }
            });
            LightPipeline.LIGHT_COUNT = LIGHT_COUNT;
            module1.exports = LightPipeline;
        /***/ },
        /* 378 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var PointLightShaderSourceFS = __webpack_require__(880);
            var PointLightShaderSourceVS = __webpack_require__(881);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Point Light Pipeline handles rendering the Point Light Game Objects in WebGL.
 *
 * The fragment shader it uses can be found in `shaders/src/PointLight.frag`.
 * The vertex shader it uses can be found in `shaders/src/PointLight.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2)
 * `inLightPosition` (vec2)
 * `inLightRadius` (float)
 * `inLightAttenuation` (float)
 * `inLightColor` (vec4)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uCameraZoom` (sampler2D)
 *
 * @class PointLightPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PointLightPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function PointLightPipeline(config) {
                    config.vertShader = GetFastValue(config, "vertShader", PointLightShaderSourceVS);
                    config.fragShader = GetFastValue(config, "fragShader", PointLightShaderSourceFS);
                    config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inLightPosition",
                            size: 2
                        },
                        {
                            name: "inLightRadius"
                        },
                        {
                            name: "inLightAttenuation"
                        },
                        {
                            name: "inLightColor",
                            size: 4
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                },
                onRender: function(scene, camera) {
                    this.set2f("uResolution", this.width, this.height);
                    this.set1f("uCameraZoom", camera.zoom);
                },
                /**
     * Adds a Point Light Game Object to the batch, flushing if required.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchPointLight
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.PointLight} light - The Point Light Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the Point Light.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     */ batchPointLight: function(light, camera, x0, y0, x1, y1, x2, y2, x3, y3, lightX, lightY) {
                    var color = light.color;
                    var intensity = light.intensity;
                    var radius = light.radius;
                    var attenuation = light.attenuation;
                    var r = color.r * intensity;
                    var g = color.g * intensity;
                    var b = color.b * intensity;
                    var a = camera.alpha * light.alpha;
                    if (this.shouldFlush(6)) this.flush();
                    this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x1, y1, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x3, y3, lightX, lightY, radius, attenuation, r, g, b, a);
                },
                /**
     * Adds a single Point Light vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchPointLight`.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchLightVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     * @param {number} radius - The radius of the light.
     * @param {number} attenuation - The attenuation of the light.
     * @param {number} r - The red color channel of the light.
     * @param {number} g - The green color channel of the light.
     * @param {number} b - The blue color channel of the light.
     * @param {number} a - The alpha color channel of the light.
     */ batchLightVert: function(x, y, lightX, lightY, radius, attenuation, r, g, b, a) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewF32[++vertexOffset] = lightX;
                    vertexViewF32[++vertexOffset] = lightY;
                    vertexViewF32[++vertexOffset] = radius;
                    vertexViewF32[++vertexOffset] = attenuation;
                    vertexViewF32[++vertexOffset] = r;
                    vertexViewF32[++vertexOffset] = g;
                    vertexViewF32[++vertexOffset] = b;
                    vertexViewF32[++vertexOffset] = a;
                    this.vertexCount++;
                }
            });
            module1.exports = PointLightPipeline;
        /***/ },
        /* 379 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var MultiPipeline = __webpack_require__(108);
            /**
 * @classdesc
 * The Rope Pipeline is a variation of the Multi Pipeline that uses a `TRIANGLE_STRIP` for
 * its topology, instead of TRIANGLES. This is primarily used by the Rope Game Object,
 * or anything that extends it.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintStripPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D array)
 *
 * The pipeline is structurally identical to the Multi Pipeline and should be treated as such.
 *
 * @class RopePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var RopePipeline = new Class({
                Extends: MultiPipeline,
                initialize: function RopePipeline(config) {
                    //  GLenum 5 = TRIANGLE_STRIP
                    config.topology = 5;
                    config.batchSize = GetFastValue(config, "batchSize", 256);
                    MultiPipeline.call(this, config);
                }
            });
            module1.exports = RopePipeline;
        /***/ },
        /* 380 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var MultiPipeline = __webpack_require__(108);
            var ShaderSourceFS = __webpack_require__(882);
            var ShaderSourceVS = __webpack_require__(883);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Single Pipeline is a special version of the Multi Pipeline that only ever
 * uses one texture, bound to texture unit zero. Although not as efficient as the
 * Multi Pipeline, it provides an easier way to create custom pipelines that only require
 * a single bound texture.
 *
 * Prior to Phaser v3.50 this pipeline didn't exist, but could be compared to the old `TextureTintPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Single.frag`.
 * The vertex shader it uses can be found in `shaders/src/Single.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16) - this value is always zero in the Single Pipeline
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D)
 *
 * @class SinglePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var SinglePipeline = new Class({
                Extends: MultiPipeline,
                initialize: function SinglePipeline(config) {
                    config.fragShader = GetFastValue(config, "fragShader", ShaderSourceFS), config.vertShader = GetFastValue(config, "vertShader", ShaderSourceVS), config.forceZero = true;
                    MultiPipeline.call(this, config);
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.set1i("uMainSampler", 0);
                }
            });
            module1.exports = SinglePipeline;
        /***/ },
        /* 381 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddBlendFS = __webpack_require__(884);
            var BlendModes = __webpack_require__(35);
            var Class = __webpack_require__(0);
            var ColorMatrix = __webpack_require__(198);
            var ColorMatrixFS = __webpack_require__(885);
            var CopyFS = __webpack_require__(886);
            var GetFastValue = __webpack_require__(2);
            var LinearBlendFS = __webpack_require__(887);
            var QuadVS = __webpack_require__(382);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Utility Pipeline is a special-use pipeline that belongs to the Pipeline Manager.
 *
 * It provides 4 shaders and handy associated methods:
 *
 * 1) Copy Shader. A fast texture to texture copy shader with optional brightness setting.
 * 2) Additive Blend Mode Shader. Blends two textures using an additive blend mode.
 * 3) Linear Blend Mode Shader. Blends two textures using a linear blend mode.
 * 4) Color Matrix Copy Shader. Draws a texture to a target using a Color Matrix.
 *
 * You do not extend this pipeline, but instead get a reference to it from the Pipeline
 * Manager via the `setUtility` method. You can also access methods such as `copyFrame`
 * directly from the Pipeline Manager.
 *
 * This pipeline provides methods for manipulating framebuffer backed textures, such as
 * copying or blending one texture to another, copying a portion of a texture, additively
 * blending two textures, flipping textures and more.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * This pipeline has a hard-coded batch size of 1 and a hard coded set of vertices.
 *
 * @class UtilityPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var UtilityPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function UtilityPipeline(config) {
                    config.renderTarget = GetFastValue(config, "renderTarget", [
                        {
                            scale: 1
                        },
                        {
                            scale: 1
                        },
                        {
                            scale: 0.5
                        },
                        {
                            scale: 0.5
                        }
                    ]);
                    config.vertShader = GetFastValue(config, "vertShader", QuadVS);
                    config.shaders = GetFastValue(config, "shaders", [
                        {
                            name: "Copy",
                            fragShader: CopyFS
                        },
                        {
                            name: "AddBlend",
                            fragShader: AddBlendFS
                        },
                        {
                            name: "LinearBlend",
                            fragShader: LinearBlendFS
                        },
                        {
                            name: "ColorMatrix",
                            fragShader: ColorMatrixFS
                        }
                    ]);
                    config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        }
                    ]);
                    config.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ];
                    config.batchSize = 1;
                    WebGLPipeline.call(this, config);
                    /**
         * A default Color Matrix, used by the Color Matrix Shader when one
         * isn't provided.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                    /**
         * A reference to the Copy Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.50.0
         */ this.copyShader;
                    /**
         * A reference to the Additive Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#addShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.addShader;
                    /**
         * A reference to the Linear Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#linearShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.linearShader;
                    /**
         * A reference to the Color Matrix Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrixShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.colorMatrixShader;
                    /**
         * A reference to the Full Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame2;
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var shaders = this.shaders;
                    var targets = this.renderTargets;
                    this.copyShader = shaders[0];
                    this.addShader = shaders[1];
                    this.linearShader = shaders[2];
                    this.colorMatrixShader = shaders[3];
                    this.fullFrame1 = targets[0];
                    this.fullFrame2 = targets[1];
                    this.halfFrame1 = targets[2];
                    this.halfFrame2 = targets[3];
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    if (brightness === undefined) brightness = 1;
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i("uMainSampler", 0);
                    this.set1f("uBrightness", brightness);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    } else gl.viewport(0, 0, source.width, source.height);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    if (brightness === undefined) brightness = 1;
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (eraseMode === undefined) eraseMode = false;
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i("uMainSampler", 0);
                    this.set1f("uBrightness", brightness);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (source.height > target.height) {
                        gl.viewport(0, 0, source.width, source.height);
                        this.setTargetUVs(source, target);
                    } else {
                        var diff = target.height - source.height;
                        gl.viewport(0, diff, source.width, source.height);
                    }
                    gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    if (eraseMode) {
                        var blendMode = this.renderer.currentBlendMode;
                        this.renderer.setBlendMode(BlendModes.ERASE);
                    }
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    if (eraseMode) this.renderer.setBlendMode(blendMode);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                    this.resetUVs();
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, source.framebuffer);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, source.texture, 0);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, target.texture);
                    gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, y, width, height);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i("uMainSampler", 0);
                    this.set1f("uBrightness", 1);
                    this.renderer.popFramebuffer();
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    this.renderer.resetTextures();
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (colorMatrix === undefined) colorMatrix = this.colorMatrix;
                    var gl = this.gl;
                    this.setShader(this.colorMatrixShader);
                    this.set1i("uMainSampler", 0);
                    this.set1fv("uColorMatrix", colorMatrix.getData());
                    this.set1f("uAlpha", colorMatrix.alpha);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    } else gl.viewport(0, 0, source.width, source.height);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [blendShader] - The shader to use during the blend copy.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha, blendShader) {
                    if (strength === undefined) strength = 1;
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (blendShader === undefined) blendShader = this.linearShader;
                    var gl = this.gl;
                    this.setShader(blendShader);
                    this.set1i("uMainSampler1", 0);
                    this.set1i("uMainSampler2", 1);
                    this.set1f("uStrength", strength);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source1.texture);
                    gl.activeTexture(gl.TEXTURE1);
                    gl.bindTexture(gl.TEXTURE_2D, source2.texture);
                    if (target) {
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                        gl.viewport(0, 0, target.width, target.height);
                    } else gl.viewport(0, 0, source1.width, source1.height);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.blendFrames(source1, source2, target, strength, clearAlpha, this.addShader);
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    gl.viewport(0, 0, target.width, target.height);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    var fbo = this.renderer.currentFramebuffer;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
                },
                /**
     * Set the UV values for the 6 vertices that make up the quad used by the shaders
     * in the Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setUVs
     * @since 3.50.0
     *
     * @param {number} uA - The u value of vertex A.
     * @param {number} vA - The v value of vertex A.
     * @param {number} uB - The u value of vertex B.
     * @param {number} vB - The v value of vertex B.
     * @param {number} uC - The u value of vertex C.
     * @param {number} vC - The v value of vertex C.
     * @param {number} uD - The u value of vertex D.
     * @param {number} vD - The v value of vertex D.
     */ setUVs: function(uA, vA, uB, vB, uC, vC, uD, vD) {
                    var vertexViewF32 = this.vertexViewF32;
                    vertexViewF32[2] = uA;
                    vertexViewF32[3] = vA;
                    vertexViewF32[6] = uB;
                    vertexViewF32[7] = vB;
                    vertexViewF32[10] = uC;
                    vertexViewF32[11] = vC;
                    vertexViewF32[14] = uA;
                    vertexViewF32[15] = vA;
                    vertexViewF32[18] = uC;
                    vertexViewF32[19] = vC;
                    vertexViewF32[22] = uD;
                    vertexViewF32[23] = vD;
                },
                /**
     * Sets the vertex UV coordinates of the quad used by the shaders in the Utility Pipeline
     * so that they correctly adjust the texture coordinates for a blit frame effect.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setTargetUVs
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ setTargetUVs: function(source, target) {
                    var diff = target.height / source.height;
                    if (diff > 0.5) diff = 0.5 - (diff - 0.5);
                    else diff = 0.5 + (0.5 - diff);
                    this.setUVs(0, diff, 0, 1 + diff, 1, 1 + diff, 1, diff);
                },
                /**
     * Horizontally flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipX
     * @since 3.50.0
     */ flipX: function() {
                    this.setUVs(1, 0, 1, 1, 0, 1, 0, 0);
                },
                /**
     * Vertically flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipY
     * @since 3.50.0
     */ flipY: function() {
                    this.setUVs(0, 1, 0, 0, 1, 0, 1, 1);
                },
                /**
     * Resets the quad vertice UV values to their default settings.
     *
     * The quad is used by all shaders of the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#resetUVs
     * @since 3.50.0
     */ resetUVs: function() {
                    this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                }
            });
            module1.exports = UtilityPipeline;
        /***/ },
        /* 382 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_QUAD_VS",
                "",
                "precision mediump float;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "",
                "varying vec2 outFragCoord;",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    outFragCoord = inPosition.xy * 0.5 + 0.5;",
                "    outTexCoord = inTexCoord;",
                "",
                "    gl_Position = vec4(inPosition, 0, 1);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 383 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Color = __webpack_require__(38);
            var GetFastValue = __webpack_require__(2);
            /**
 * Takes a snapshot of an area from the current frame displayed by a WebGL canvas.
 *
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.WebGL
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} sourceCanvas - The canvas to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var WebGLSnapshot = function(sourceCanvas, config) {
                var gl = sourceCanvas.getContext("experimental-webgl");
                var callback = GetFastValue(config, "callback");
                var type = GetFastValue(config, "type", "image/png");
                var encoderOptions = GetFastValue(config, "encoder", 0.92);
                var x = GetFastValue(config, "x", 0);
                var y = GetFastValue(config, "y", 0);
                var getPixel = GetFastValue(config, "getPixel", false);
                var isFramebuffer = GetFastValue(config, "isFramebuffer", false);
                var bufferWidth = isFramebuffer ? GetFastValue(config, "bufferWidth", 1) : gl.drawingBufferWidth;
                var bufferHeight = isFramebuffer ? GetFastValue(config, "bufferHeight", 1) : gl.drawingBufferHeight;
                if (getPixel) {
                    var pixel = new Uint8Array(4);
                    var destY = isFramebuffer ? y : bufferHeight - y;
                    gl.readPixels(x, destY, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
                    callback.call(null, new Color(pixel[0], pixel[1], pixel[2], pixel[3] / 255));
                } else {
                    var width = GetFastValue(config, "width", bufferWidth);
                    var height = GetFastValue(config, "height", bufferHeight);
                    var total = width * height * 4;
                    var pixels = new Uint8Array(total);
                    gl.readPixels(x, bufferHeight - y - height, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
                    var canvas = CanvasPool.createWebGL(this, width, height);
                    var ctx = canvas.getContext("2d");
                    var imageData = ctx.getImageData(0, 0, width, height);
                    var data = imageData.data;
                    // var destIndex = (isFramebuffer) ? total - ((py * width + (width - px)) * 4) : (py * width + px) * 4;
                    for(var py = 0; py < height; py++)for(var px = 0; px < width; px++){
                        var sourceIndex = ((height - py - 1) * width + px) * 4;
                        var destIndex = (py * width + px) * 4;
                        data[destIndex + 0] = pixels[sourceIndex + 0];
                        data[destIndex + 1] = pixels[sourceIndex + 1];
                        data[destIndex + 2] = pixels[sourceIndex + 2];
                        data[destIndex + 3] = pixels[sourceIndex + 3];
                    }
                    ctx.putImageData(imageData, 0, 0);
                    var image = new Image();
                    image.onerror = function() {
                        callback.call(null);
                        CanvasPool.remove(canvas);
                    };
                    image.onload = function() {
                        callback.call(null, image);
                        CanvasPool.remove(canvas);
                    };
                    image.src = canvas.toDataURL(type, encoderOptions);
                }
            };
            module1.exports = WebGLSnapshot;
        /***/ },
        /* 384 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(33);
            /**
 * Called automatically by Phaser.Game and responsible for creating the console.log debug header.
 *
 * You can customize or disable the header via the Game Config object.
 *
 * @function Phaser.Core.DebugHeader
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance which will output this debug header.
 */ var DebugHeader = function(game) {
                var config = game.config;
                if (config.hideBanner) return;
                var renderType = "WebGL";
                if (config.renderType === CONST.CANVAS) renderType = "Canvas";
                else if (config.renderType === CONST.HEADLESS) renderType = "Headless";
                var audioConfig = config.audio;
                var deviceAudio = game.device.audio;
                var audioType;
                if (deviceAudio.webAudio && !audioConfig.disableWebAudio) audioType = "Web Audio";
                else if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) audioType = "No Audio";
                else audioType = "HTML5 Audio";
                if (!game.device.browser.ie) {
                    var c = "";
                    var args = [
                        c
                    ];
                    if (Array.isArray(config.bannerBackgroundColor)) {
                        var lastColor;
                        config.bannerBackgroundColor.forEach(function(color) {
                            c = c.concat("%c ");
                            args.push("background: " + color);
                            lastColor = color;
                        });
                        //  inject the text color
                        args[args.length - 1] = "color: " + config.bannerTextColor + "; background: " + lastColor;
                    } else {
                        c = c.concat("%c ");
                        args.push("color: " + config.bannerTextColor + "; background: " + config.bannerBackgroundColor);
                    }
                    //  URL link background color (always transparent to support different browser themes)
                    args.push("background: transparent");
                    if (config.gameTitle) {
                        c = c.concat(config.gameTitle);
                        if (config.gameVersion) c = c.concat(" v" + config.gameVersion);
                        if (!config.hidePhaser) c = c.concat(" / ");
                    }
                    var fb = "";
                    if (!config.hidePhaser) c = c.concat("Phaser v" + CONST.VERSION + fb + " (" + renderType + " | " + audioType + ")");
                    c = c.concat(" %c " + config.gameURL);
                    //  Inject the new string back into the args array
                    args[0] = c;
                    console.log.apply(console, args);
                } else if (window["console"]) console.log("Phaser v" + CONST.VERSION + " / https://phaser.io");
            };
            module1.exports = DebugHeader;
        /***/ },
        /* 385 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            var NOOP = __webpack_require__(1);
            var RequestAnimationFrame = __webpack_require__(386);
            // http://www.testufo.com/#test=animation-time-graph
            /**
 * @classdesc
 * The core runner class that Phaser uses to handle the game loop. It can use either Request Animation Frame,
 * or SetTimeout, based on browser support and config settings, to create a continuous loop within the browser.
 * 
 * Each time the loop fires, `TimeStep.step` is called and this is then passed onto the core Game update loop,
 * it is the core heartbeat of your game. It will fire as often as Request Animation Frame is capable of handling
 * on the target device.
 * 
 * Note that there are lots of situations where a browser will stop updating your game. Such as if the player
 * switches tabs, or covers up the browser window with another application. In these cases, the 'heartbeat'
 * of your game will pause, and only resume when focus is returned to it by the player. There is no way to avoid
 * this situation, all you can do is use the visibility events the browser, and Phaser, provide to detect when
 * it has happened and then gracefully recover.
 *
 * @class TimeStep
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this Time Step.
 * @param {Phaser.Types.Core.FPSConfig} config
 */ var TimeStep = new Class({
                initialize: function TimeStep(game, config) {
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Core.TimeStep#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The Request Animation Frame DOM Event handler.
         *
         * @name Phaser.Core.TimeStep#raf
         * @type {Phaser.DOM.RequestAnimationFrame}
         * @readonly
         * @since 3.0.0
         */ this.raf = new RequestAnimationFrame();
                    /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         *
         * @name Phaser.Core.TimeStep#started
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.started = false;
                    /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         * The difference between this value and `started` is that `running` is toggled when
         * the TimeStep is sent to sleep, where-as `started` remains `true`, only changing if
         * the TimeStep is actually stopped, not just paused.
         *
         * @name Phaser.Core.TimeStep#running
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.running = false;
                    /**
         * The minimum fps rate you want the Time Step to run at.
         *
         * @name Phaser.Core.TimeStep#minFps
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.minFps = GetValue(config, "min", 5);
                    /**
         * The target fps rate for the Time Step to run at.
         *
         * Setting this value will not actually change the speed at which the browser runs, that is beyond
         * the control of Phaser. Instead, it allows you to determine performance issues and if the Time Step
         * is spiraling out of control.
         *
         * @name Phaser.Core.TimeStep#targetFps
         * @type {number}
         * @default 60
         * @since 3.0.0
         */ this.targetFps = GetValue(config, "target", 60);
                    /**
         * The minFps value in ms.
         * Defaults to 200ms between frames (i.e. super slow!)
         *
         * @name Phaser.Core.TimeStep#_min
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._min = 1000 / this.minFps;
                    /**
         * The targetFps value in ms.
         * Defaults to 16.66ms between frames (i.e. normal)
         *
         * @name Phaser.Core.TimeStep#_target
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._target = 1000 / this.targetFps;
                    /**
         * An exponential moving average of the frames per second.
         *
         * @name Phaser.Core.TimeStep#actualFps
         * @type {number}
         * @readonly
         * @default 60
         * @since 3.0.0
         */ this.actualFps = this.targetFps;
                    /**
         * The time at which the next fps rate update will take place.
         * When an fps update happens, the `framesThisSecond` value is reset.
         *
         * @name Phaser.Core.TimeStep#nextFpsUpdate
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.nextFpsUpdate = 0;
                    /**
         * The number of frames processed this second.
         *
         * @name Phaser.Core.TimeStep#framesThisSecond
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.framesThisSecond = 0;
                    /**
         * A callback to be invoked each time the Time Step steps.
         *
         * @name Phaser.Core.TimeStep#callback
         * @type {Phaser.Types.Core.TimeStepCallback}
         * @default NOOP
         * @since 3.0.0
         */ this.callback = NOOP;
                    /**
         * You can force the Time Step to use Set Timeout instead of Request Animation Frame by setting
         * the `forceSetTimeOut` property to `true` in the Game Configuration object. It cannot be changed at run-time.
         *
         * @name Phaser.Core.TimeStep#forceSetTimeOut
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.forceSetTimeOut = GetValue(config, "forceSetTimeOut", false);
                    /**
         * The time, calculated at the start of the current step, as smoothed by the delta value.
         *
         * @name Phaser.Core.TimeStep#time
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.time = 0;
                    /**
         * The time at which the game started running. This value is adjusted if the game is then
         * paused and resumes.
         *
         * @name Phaser.Core.TimeStep#startTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * The time, as returned by `performance.now` of the previous step.
         *
         * @name Phaser.Core.TimeStep#lastTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lastTime = 0;
                    /**
         * The current frame the game is on. This counter is incremented once every game step, regardless of how much
         * time has passed and is unaffected by delta smoothing.
         *
         * @name Phaser.Core.TimeStep#frame
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.frame = 0;
                    /**
         * Is the browser currently considered in focus by the Page Visibility API?
         * This value is set in the `blur` method, which is called automatically by the Game instance.
         *
         * @name Phaser.Core.TimeStep#inFocus
         * @type {boolean}
         * @readonly
         * @default true
         * @since 3.0.0
         */ this.inFocus = true;
                    /**
         * The timestamp at which the game became paused, as determined by the Page Visibility API.
         *
         * @name Phaser.Core.TimeStep#_pauseTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pauseTime = 0;
                    /**
         * An internal counter to allow for the browser 'cooling down' after coming back into focus.
         *
         * @name Phaser.Core.TimeStep#_coolDown
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._coolDown = 0;
                    /**
         * The delta time, in ms, since the last game step. This is a clamped and smoothed average value.
         *
         * @name Phaser.Core.TimeStep#delta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delta = 0;
                    /**
         * Internal index of the delta history position.
         *
         * @name Phaser.Core.TimeStep#deltaIndex
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.deltaIndex = 0;
                    /**
         * Internal array holding the previous delta values, used for delta smoothing.
         *
         * @name Phaser.Core.TimeStep#deltaHistory
         * @type {number[]}
         * @since 3.0.0
         */ this.deltaHistory = [];
                    /**
         * The maximum number of delta values that are retained in order to calculate a smoothed moving average.
         * 
         * This can be changed in the Game Config via the `fps.deltaHistory` property. The default is 10.
         *
         * @name Phaser.Core.TimeStep#deltaSmoothingMax
         * @type {number}
         * @default 10
         * @since 3.0.0
         */ this.deltaSmoothingMax = GetValue(config, "deltaHistory", 10);
                    /**
         * The number of frames that the cooldown is set to after the browser panics over the FPS rate, usually
         * as a result of switching tabs and regaining focus.
         * 
         * This can be changed in the Game Config via the `fps.panicMax` property. The default is 120.
         *
         * @name Phaser.Core.TimeStep#panicMax
         * @type {number}
         * @default 120
         * @since 3.0.0
         */ this.panicMax = GetValue(config, "panicMax", 120);
                    /**
         * The actual elapsed time in ms between one update and the next.
         * 
         * Unlike with `delta`, no smoothing, capping, or averaging is applied to this value.
         * So please be careful when using this value in math calculations.
         *
         * @name Phaser.Core.TimeStep#rawDelta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rawDelta = 0;
                    /**
         * The time, as returned by `performance.now` at the very start of the current step.
         * This can differ from the `time` value in that it isn't calculated based on the delta value.
         *
         * @name Phaser.Core.TimeStep#now
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.now = 0;
                    /**
         * Apply smoothing to the delta value used within Phasers internal calculations?
         * 
         * This can be changed in the Game Config via the `fps.smoothStep` property. The default is `true`.
         * 
         * Smoothing helps settle down the delta values after browser tab switches, or other situations
         * which could cause significant delta spikes or dips. By default it has been enabled in Phaser 3
         * since the first version, but is now exposed under this property (and the corresponding game config
         * `smoothStep` value), to allow you to easily disable it, should you require.
         *
         * @name Phaser.Core.TimeStep#smoothStep
         * @type {boolean}
         * @since 3.22.0
         */ this.smoothStep = GetValue(config, "smoothStep", true);
                },
                /**
     * Called by the Game instance when the DOM window.onBlur event triggers.
     *
     * @method Phaser.Core.TimeStep#blur
     * @since 3.0.0
     */ blur: function() {
                    this.inFocus = false;
                },
                /**
     * Called by the Game instance when the DOM window.onFocus event triggers.
     *
     * @method Phaser.Core.TimeStep#focus
     * @since 3.0.0
     */ focus: function() {
                    this.inFocus = true;
                    this.resetDelta();
                },
                /**
     * Called when the visibility API says the game is 'hidden' (tab switch out of view, etc)
     *
     * @method Phaser.Core.TimeStep#pause
     * @since 3.0.0
     */ pause: function() {
                    this._pauseTime = window.performance.now();
                },
                /**
     * Called when the visibility API says the game is 'visible' again (tab switch back into view, etc)
     *
     * @method Phaser.Core.TimeStep#resume
     * @since 3.0.0
     */ resume: function() {
                    this.resetDelta();
                    this.startTime += this.time - this._pauseTime;
                },
                /**
     * Resets the time, lastTime, fps averages and delta history.
     * Called automatically when a browser sleeps them resumes.
     *
     * @method Phaser.Core.TimeStep#resetDelta
     * @since 3.0.0
     */ resetDelta: function() {
                    var now = window.performance.now();
                    this.time = now;
                    this.lastTime = now;
                    this.nextFpsUpdate = now + 1000;
                    this.framesThisSecond = 0;
                    //  Pre-populate smoothing array
                    for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = Math.min(this._target, this.deltaHistory[i]);
                    this.delta = 0;
                    this.deltaIndex = 0;
                    this._coolDown = this.panicMax;
                },
                /**
     * Starts the Time Step running, if it is not already doing so.
     * Called automatically by the Game Boot process.
     *
     * @method Phaser.Core.TimeStep#start
     * @since 3.0.0
     *
     * @param {Phaser.Types.Core.TimeStepCallback} callback - The callback to be invoked each time the Time Step steps.
     */ start: function(callback) {
                    if (this.started) return this;
                    this.started = true;
                    this.running = true;
                    for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = this._target;
                    this.resetDelta();
                    this.startTime = window.performance.now();
                    this.callback = callback;
                    this.raf.start(this.step.bind(this), this.forceSetTimeOut, this._target);
                },
                /**
     * The main step method. This is called each time the browser updates, either by Request Animation Frame,
     * or by Set Timeout. It is responsible for calculating the delta values, frame totals, cool down history and more.
     * You generally should never call this method directly.
     *
     * @method Phaser.Core.TimeStep#step
     * @since 3.0.0
     */ step: function() {
                    //  Because the timestamp passed in from raf represents the beginning of the main thread frame that we’re currently in,
                    //  not the actual time now, and as we want to compare this time value against Event timeStamps and the like, we need a
                    //  more accurate one:
                    var time = window.performance.now();
                    this.now = time;
                    var before = time - this.lastTime;
                    if (before < 0) //  Because, Chrome.
                    before = 0;
                    this.rawDelta = before;
                    var idx = this.deltaIndex;
                    var history = this.deltaHistory;
                    var max = this.deltaSmoothingMax;
                    //  delta time (time is in ms)
                    var dt = before;
                    //  Delta Average
                    var avg = before;
                    //  When a browser switches tab, then comes back again, it takes around 10 frames before
                    //  the delta time settles down so we employ a 'cooling down' period before we start
                    //  trusting the delta values again, to avoid spikes flooding through our delta average
                    if (this.smoothStep) {
                        if (this._coolDown > 0 || !this.inFocus) {
                            this._coolDown--;
                            dt = Math.min(dt, this._target);
                        }
                        if (dt > this._min) {
                            //  Probably super bad start time or browser tab context loss,
                            //  so use the last 'sane' dt value
                            dt = history[idx];
                            //  Clamp delta to min (in case history has become corrupted somehow)
                            dt = Math.min(dt, this._min);
                        }
                        //  Smooth out the delta over the previous X frames
                        //  add the delta to the smoothing array
                        history[idx] = dt;
                        //  adjusts the delta history array index based on the smoothing count
                        //  this stops the array growing beyond the size of deltaSmoothingMax
                        this.deltaIndex++;
                        if (this.deltaIndex > max) this.deltaIndex = 0;
                        //  Loop the history array, adding the delta values together
                        avg = 0;
                        for(var i = 0; i < max; i++)avg += history[i];
                        //  Then divide by the array length to get the average delta
                        avg /= max;
                    }
                    //  Set as the world delta value
                    this.delta = avg;
                    //  Real-world timer advance
                    this.time += this.rawDelta;
                    // Update the estimate of the frame rate, `fps`. Every second, the number
                    // of frames that occurred in that second are included in an exponential
                    // moving average of all frames per second, with an alpha of 0.25. This
                    // means that more recent seconds affect the estimated frame rate more than
                    // older seconds.
                    //
                    // When a browser window is NOT minimized, but is covered up (i.e. you're using
                    // another app which has spawned a window over the top of the browser), then it
                    // will start to throttle the raf callback time. It waits for a while, and then
                    // starts to drop the frame rate at 1 frame per second until it's down to just over 1fps.
                    // So if the game was running at 60fps, and the player opens a new window, then
                    // after 60 seconds (+ the 'buffer time') it'll be down to 1fps, so rafin'g at 1Hz.
                    //
                    // When they make the game visible again, the frame rate is increased at a rate of
                    // approx. 8fps, back up to 60fps (or the max it can obtain)
                    //
                    // There is no easy way to determine if this drop in frame rate is because the
                    // browser is throttling raf, or because the game is struggling with performance
                    // because you're asking it to do too much on the device.
                    if (time > this.nextFpsUpdate) {
                        //  Compute the new exponential moving average with an alpha of 0.25.
                        this.actualFps = 0.25 * this.framesThisSecond + 0.75 * this.actualFps;
                        this.nextFpsUpdate = time + 1000;
                        this.framesThisSecond = 0;
                    }
                    this.framesThisSecond++;
                    //  Interpolation - how far between what is expected and where we are?
                    var interpolation = avg / this._target;
                    this.callback(time, avg, interpolation);
                    //  Shift time value over
                    this.lastTime = time;
                    this.frame++;
                },
                /**
     * Manually calls `TimeStep.step`.
     *
     * @method Phaser.Core.TimeStep#tick
     * @since 3.0.0
     */ tick: function() {
                    this.step();
                },
                /**
     * Sends the TimeStep to sleep, stopping Request Animation Frame (or SetTimeout) and toggling the `running` flag to false.
     *
     * @method Phaser.Core.TimeStep#sleep
     * @since 3.0.0
     */ sleep: function() {
                    if (this.running) {
                        this.raf.stop();
                        this.running = false;
                    }
                },
                /**
     * Wakes-up the TimeStep, restarting Request Animation Frame (or SetTimeout) and toggling the `running` flag to true.
     * The `seamless` argument controls if the wake-up should adjust the start time or not.
     *
     * @method Phaser.Core.TimeStep#wake
     * @since 3.0.0
     *
     * @param {boolean} [seamless=false] - Adjust the startTime based on the lastTime values.
     */ wake: function(seamless) {
                    if (this.running) return;
                    else if (seamless) this.startTime += -this.lastTime + (this.lastTime + window.performance.now());
                    this.raf.start(this.step.bind(this), this.useRAF);
                    this.running = true;
                    this.step();
                },
                /**
     * Gets the duration which the game has been running, in seconds.
     *
     * @method Phaser.Core.TimeStep#getDuration
     * @since 3.17.0
     *
     * @return {number} The duration in seconds.
     */ getDuration: function() {
                    return Math.round(this.lastTime - this.startTime) / 1000;
                },
                /**
     * Gets the duration which the game has been running, in ms.
     *
     * @method Phaser.Core.TimeStep#getDurationMS
     * @since 3.17.0
     *
     * @return {number} The duration in ms.
     */ getDurationMS: function() {
                    return Math.round(this.lastTime - this.startTime);
                },
                /**
     * Stops the TimeStep running.
     *
     * @method Phaser.Core.TimeStep#stop
     * @since 3.0.0
     *
     * @return {this} The TimeStep object.
     */ stop: function() {
                    this.running = false;
                    this.started = false;
                    this.raf.stop();
                    return this;
                },
                /**
     * Destroys the TimeStep. This will stop Request Animation Frame, stop the step, clear the callbacks and null
     * any objects.
     *
     * @method Phaser.Core.TimeStep#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stop();
                    this.callback = NOOP;
                    this.raf = null;
                    this.game = null;
                }
            });
            module1.exports = TimeStep;
        /***/ },
        /* 386 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * Abstracts away the use of RAF or setTimeOut for the core game update loop.
 * This is invoked automatically by the Phaser.Game instance.
 *
 * @class RequestAnimationFrame
 * @memberof Phaser.DOM
 * @constructor
 * @since 3.0.0
 */ var RequestAnimationFrame = new Class({
                initialize: function RequestAnimationFrame() {
                    /**
         * True if RequestAnimationFrame is running, otherwise false.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isRunning
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isRunning = false;
                    /**
         * The callback to be invoked each step.
         *
         * @name Phaser.DOM.RequestAnimationFrame#callback
         * @type {FrameRequestCallback}
         * @since 3.0.0
         */ this.callback = NOOP;
                    /**
         * The most recent timestamp. Either a DOMHighResTimeStamp under RAF or `Date.now` under SetTimeout.
         *
         * @name Phaser.DOM.RequestAnimationFrame#tick
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.tick = 0;
                    /**
         * True if the step is using setTimeout instead of RAF.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isSetTimeOut
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isSetTimeOut = false;
                    /**
         * The setTimeout or RAF callback ID used when canceling them.
         *
         * @name Phaser.DOM.RequestAnimationFrame#timeOutID
         * @type {?number}
         * @default null
         * @since 3.0.0
         */ this.timeOutID = null;
                    /**
         * The previous time the step was called.
         *
         * @name Phaser.DOM.RequestAnimationFrame#lastTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lastTime = 0;
                    /**
         * The target FPS rate in ms.
         * Only used when setTimeout is used instead of RAF.
         *
         * @name Phaser.DOM.RequestAnimationFrame#target
         * @type {number}
         * @default 0
         * @since 3.21.0
         */ this.target = 0;
                    var _this = this;
                    /**
         * The RAF step function.
         * Updates the local tick value, invokes the callback and schedules another call to requestAnimationFrame.
         *
         * @name Phaser.DOM.RequestAnimationFrame#step
         * @type {FrameRequestCallback}
         * @since 3.0.0
         */ this.step = function step() {
                        //  Because we cannot trust the time passed to this callback from the browser and need it kept in sync with event times
                        var timestamp = window.performance.now();
                        //  DOMHighResTimeStamp
                        _this.lastTime = _this.tick;
                        _this.tick = timestamp;
                        _this.callback(timestamp);
                        _this.timeOutID = window.requestAnimationFrame(step);
                    };
                    /**
         * The SetTimeout step function.
         * Updates the local tick value, invokes the callback and schedules another call to setTimeout.
         *
         * @name Phaser.DOM.RequestAnimationFrame#stepTimeout
         * @type {function}
         * @since 3.0.0
         */ this.stepTimeout = function stepTimeout() {
                        var d = Date.now();
                        var delay = Math.min(Math.max(_this.target * 2 + _this.tick - d, 0), _this.target);
                        _this.lastTime = _this.tick;
                        _this.tick = d;
                        _this.callback(d);
                        _this.timeOutID = window.setTimeout(stepTimeout, delay);
                    };
                },
                /**
     * Starts the requestAnimationFrame or setTimeout process running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#start
     * @since 3.0.0
     *
     * @param {FrameRequestCallback} callback - The callback to invoke each step.
     * @param {boolean} forceSetTimeOut - Should it use SetTimeout, even if RAF is available?
     * @param {number} targetFPS - The target fps rate (in ms). Only used when setTimeout is used.
     */ start: function(callback, forceSetTimeOut, targetFPS) {
                    if (this.isRunning) return;
                    this.callback = callback;
                    this.isSetTimeOut = forceSetTimeOut;
                    this.target = targetFPS;
                    this.isRunning = true;
                    this.timeOutID = forceSetTimeOut ? window.setTimeout(this.stepTimeout, 0) : window.requestAnimationFrame(this.step);
                },
                /**
     * Stops the requestAnimationFrame or setTimeout from running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#stop
     * @since 3.0.0
     */ stop: function() {
                    this.isRunning = false;
                    if (this.isSetTimeOut) clearTimeout(this.timeOutID);
                    else window.cancelAnimationFrame(this.timeOutID);
                },
                /**
     * Stops the step from running and clears the callback reference.
     *
     * @method Phaser.DOM.RequestAnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stop();
                    this.callback = NOOP;
                }
            });
            module1.exports = RequestAnimationFrame;
        /***/ },
        /* 387 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(22);
            /**
 * The Visibility Handler is responsible for listening out for document level visibility change events.
 * This includes `visibilitychange` if the browser supports it, and blur and focus events. It then uses
 * the provided Event Emitter and fires the related events.
 *
 * @function Phaser.Core.VisibilityHandler
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance this Visibility Handler is working on.
 */ var VisibilityHandler = function(game) {
                var hiddenVar;
                var eventEmitter = game.events;
                if (document.hidden !== undefined) hiddenVar = "visibilitychange";
                else {
                    var vendors = [
                        "webkit",
                        "moz",
                        "ms"
                    ];
                    vendors.forEach(function(prefix) {
                        if (document[prefix + "Hidden"] !== undefined) {
                            document.hidden = function() {
                                return document[prefix + "Hidden"];
                            };
                            hiddenVar = prefix + "visibilitychange";
                        }
                    });
                }
                var onChange = function(event) {
                    if (document.hidden || event.type === "pause") eventEmitter.emit(Events.HIDDEN);
                    else eventEmitter.emit(Events.VISIBLE);
                };
                if (hiddenVar) document.addEventListener(hiddenVar, onChange, false);
                window.onblur = function() {
                    eventEmitter.emit(Events.BLUR);
                };
                window.onfocus = function() {
                    eventEmitter.emit(Events.FOCUS);
                };
                //  Automatically give the window focus unless config says otherwise
                if (window.focus && game.config.autoFocus) window.focus();
            };
            module1.exports = VisibilityHandler;
        /***/ },
        /* 388 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arne16 = __webpack_require__(389);
            var CanvasPool = __webpack_require__(31);
            var GetValue = __webpack_require__(6);
            /**
 * Generates a texture based on the given Create configuration object.
 * 
 * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
 * data cells map to a single color. For example, if the texture config looked like this:
 *
 * ```javascript
 * var star = [
 *   '.....828.....',
 *   '....72227....',
 *   '....82228....',
 *   '...7222227...',
 *   '2222222222222',
 *   '8222222222228',
 *   '.72222222227.',
 *   '..787777787..',
 *   '..877777778..',
 *   '.78778887787.',
 *   '.27887.78872.',
 *   '.787.....787.'
 * ];
 * 
 * this.textures.generate('star', { data: star, pixelWidth: 4 });
 * ```
 * 
 * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
 * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
 * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
 * 
 * The default palette is Arne16, but you can specify your own using the `palette` property.
 *
 * @function Phaser.Create.GenerateTexture
 * @since 3.0.0
 *
 * @param {Phaser.Types.Create.GenerateTextureConfig} config - The Generate Texture Configuration object.
 *
 * @return {HTMLCanvasElement} An HTMLCanvasElement which contains the generated texture drawn to it.
 */ var GenerateTexture = function(config) {
                var data = GetValue(config, "data", []);
                var canvas = GetValue(config, "canvas", null);
                var palette = GetValue(config, "palette", Arne16);
                var pixelWidth = GetValue(config, "pixelWidth", 1);
                var pixelHeight = GetValue(config, "pixelHeight", pixelWidth);
                var resizeCanvas = GetValue(config, "resizeCanvas", true);
                var clearCanvas = GetValue(config, "clearCanvas", true);
                var preRender = GetValue(config, "preRender", null);
                var postRender = GetValue(config, "postRender", null);
                var width = Math.floor(Math.abs(data[0].length * pixelWidth));
                var height = Math.floor(Math.abs(data.length * pixelHeight));
                if (!canvas) {
                    canvas = CanvasPool.create2D(this, width, height);
                    resizeCanvas = false;
                    clearCanvas = false;
                }
                if (resizeCanvas) {
                    canvas.width = width;
                    canvas.height = height;
                }
                var ctx = canvas.getContext("2d");
                if (clearCanvas) ctx.clearRect(0, 0, width, height);
                //  preRender Callback?
                if (preRender) preRender(canvas, ctx);
                //  Draw it
                for(var y = 0; y < data.length; y++){
                    var row = data[y];
                    for(var x = 0; x < row.length; x++){
                        var d = row[x];
                        if (d !== "." && d !== " ") {
                            ctx.fillStyle = palette[d];
                            ctx.fillRect(x * pixelWidth, y * pixelHeight, pixelWidth, pixelHeight);
                        }
                    }
                }
                //  postRender Callback?
                if (postRender) postRender(canvas, ctx);
                return canvas;
            };
            module1.exports = GenerateTexture;
        /***/ },
        /* 389 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.ARNE16
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: "#000",
                1: "#9D9D9D",
                2: "#FFF",
                3: "#BE2633",
                4: "#E06F8B",
                5: "#493C2B",
                6: "#A46422",
                7: "#EB8931",
                8: "#F7E26B",
                9: "#2F484E",
                A: "#44891A",
                B: "#A3CE27",
                C: "#1B2632",
                D: "#005784",
                E: "#31A2F2",
                F: "#B2DCEF"
            };
        /***/ },
        /* 390 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var CubicBezier = __webpack_require__(358);
            var Curve = __webpack_require__(94);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A higher-order Bézier curve constructed of four points.
 *
 * @class CubicBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|Phaser.Math.Vector2[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 * @param {Phaser.Math.Vector2} p3 - End Point.
 */ var CubicBezierCurve = new Class({
                Extends: Curve,
                initialize: function CubicBezierCurve(p0, p1, p2, p3) {
                    Curve.call(this, "CubicBezierCurve");
                    if (Array.isArray(p0)) {
                        p3 = new Vector2(p0[6], p0[7]);
                        p2 = new Vector2(p0[4], p0[5]);
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The start point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                    /**
         * The first control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                    /**
         * The second control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p2 = p2;
                    /**
         * The end point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p3
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p3 = p3;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.CubicBezier#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Returns the resolution of this curve.
     *
     * @method Phaser.Curves.CubicBezier#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - The amount of divisions used by this curve.
     *
     * @return {number} The resolution of the curve.
     */ getResolution: function(divisions) {
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.CubicBezier#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var p0 = this.p0;
                    var p1 = this.p1;
                    var p2 = this.p2;
                    var p3 = this.p3;
                    return out.set(CubicBezier(t, p0.x, p1.x, p2.x, p3.x), CubicBezier(t, p0.y, p1.y, p2.y, p3.y));
                },
                /**
     * Draws this curve to the specified graphics object.
     *
     * @method Phaser.Curves.CubicBezier#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The graphics object this curve should be drawn to.
     * @param {number} [pointsTotal=32] - The number of intermediary points that make up this curve. A higher number of points will result in a smoother curve.
     *
     * @return {Phaser.GameObjects.Graphics} The graphics object this curve was drawn to. Useful for method chaining.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    var points = this.getPoints(pointsTotal);
                    graphics.beginPath();
                    graphics.moveTo(this.p0.x, this.p0.y);
                    for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                    graphics.strokePath();
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Returns a JSON object that describes this curve.
     *
     * @method Phaser.Curves.CubicBezier#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y,
                            this.p3.x,
                            this.p3.y
                        ]
                    };
                }
            });
            /**
 * Generates a curve from a JSON object.
 *
 * @function Phaser.Curves.CubicBezier.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.CubicBezier} The curve generated from the JSON object.
 */ CubicBezierCurve.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                var p2 = new Vector2(points[4], points[5]);
                var p3 = new Vector2(points[6], points[7]);
                return new CubicBezierCurve(p0, p1, p2, p3);
            };
            module1.exports = CubicBezierCurve;
        /***/ },
        /* 391 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(94);
            var DegToRad = __webpack_require__(36);
            var GetValue = __webpack_require__(6);
            var RadToDeg = __webpack_require__(196);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * An Elliptical Curve derived from the Base Curve class.
 * 
 * See https://en.wikipedia.org/wiki/Elliptic_curve for more details.
 *
 * @class Ellipse
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.Curves.EllipseCurveConfig)} [x=0] - The x coordinate of the ellipse, or an Ellipse Curve configuration object.
 * @param {number} [y=0] - The y coordinate of the ellipse.
 * @param {number} [xRadius=0] - The horizontal radius of ellipse.
 * @param {number} [yRadius=0] - The vertical radius of ellipse.
 * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
 * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
 * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
 * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
 */ var EllipseCurve = new Class({
                Extends: Curve,
                initialize: function EllipseCurve(x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                    if (typeof x === "object") {
                        var config = x;
                        x = GetValue(config, "x", 0);
                        y = GetValue(config, "y", 0);
                        xRadius = GetValue(config, "xRadius", 0);
                        yRadius = GetValue(config, "yRadius", xRadius);
                        startAngle = GetValue(config, "startAngle", 0);
                        endAngle = GetValue(config, "endAngle", 360);
                        clockwise = GetValue(config, "clockwise", false);
                        rotation = GetValue(config, "rotation", 0);
                    } else {
                        if (yRadius === undefined) yRadius = xRadius;
                        if (startAngle === undefined) startAngle = 0;
                        if (endAngle === undefined) endAngle = 360;
                        if (clockwise === undefined) clockwise = false;
                        if (rotation === undefined) rotation = 0;
                    }
                    Curve.call(this, "EllipseCurve");
                    //  Center point
                    /**
         * The center point of the ellipse. Used for calculating rotation.
         *
         * @name Phaser.Curves.Ellipse#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                    /**
         * The horizontal radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_xRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._xRadius = xRadius;
                    /**
         * The vertical radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_yRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._yRadius = yRadius;
                    //  Radians
                    /**
         * The starting angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_startAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._startAngle = DegToRad(startAngle);
                    /**
         * The end angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_endAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._endAngle = DegToRad(endAngle);
                    /**
         * Anti-clockwise direction.
         *
         * @name Phaser.Curves.Ellipse#_clockwise
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._clockwise = clockwise;
                    /**
         * The rotation of the arc.
         *
         * @name Phaser.Curves.Ellipse#_rotation
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._rotation = DegToRad(rotation);
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Ellipse#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(0, out);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Ellipse#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions * 2;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var twoPi = Math.PI * 2;
                    var deltaAngle = this._endAngle - this._startAngle;
                    var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                    // ensures that deltaAngle is 0 .. 2 PI
                    while(deltaAngle < 0)deltaAngle += twoPi;
                    while(deltaAngle > twoPi)deltaAngle -= twoPi;
                    if (deltaAngle < Number.EPSILON) {
                        if (samePoints) deltaAngle = 0;
                        else deltaAngle = twoPi;
                    }
                    if (this._clockwise && !samePoints) {
                        if (deltaAngle === twoPi) deltaAngle = -twoPi;
                        else deltaAngle = deltaAngle - twoPi;
                    }
                    var angle = this._startAngle + t * deltaAngle;
                    var x = this.p0.x + this._xRadius * Math.cos(angle);
                    var y = this.p0.y + this._yRadius * Math.sin(angle);
                    if (this._rotation !== 0) {
                        var cos = Math.cos(this._rotation);
                        var sin = Math.sin(this._rotation);
                        var tx = x - this.p0.x;
                        var ty = y - this.p0.y;
                        // Rotate the point about the center of the ellipse.
                        x = tx * cos - ty * sin + this.p0.x;
                        y = tx * sin + ty * cos + this.p0.y;
                    }
                    return out.set(x, y);
                },
                /**
     * Sets the horizontal radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setXRadius
     * @since 3.0.0
     *
     * @param {number} value - The horizontal radius of this curve.
     *
     * @return {this} This curve object.
     */ setXRadius: function(value) {
                    this.xRadius = value;
                    return this;
                },
                /**
     * Sets the vertical radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setYRadius
     * @since 3.0.0
     *
     * @param {number} value - The vertical radius of this curve.
     *
     * @return {this} This curve object.
     */ setYRadius: function(value) {
                    this.yRadius = value;
                    return this;
                },
                /**
     * Sets the width of this curve.
     *
     * @method Phaser.Curves.Ellipse#setWidth
     * @since 3.0.0
     *
     * @param {number} value - The width of this curve.
     *
     * @return {this} This curve object.
     */ setWidth: function(value) {
                    this.xRadius = value / 2;
                    return this;
                },
                /**
     * Sets the height of this curve.
     *
     * @method Phaser.Curves.Ellipse#setHeight
     * @since 3.0.0
     *
     * @param {number} value - The height of this curve.
     *
     * @return {this} This curve object.
     */ setHeight: function(value) {
                    this.yRadius = value / 2;
                    return this;
                },
                /**
     * Sets the start angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setStartAngle
     * @since 3.0.0
     *
     * @param {number} value - The start angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setStartAngle: function(value) {
                    this.startAngle = value;
                    return this;
                },
                /**
     * Sets the end angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setEndAngle
     * @since 3.0.0
     *
     * @param {number} value - The end angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setEndAngle: function(value) {
                    this.endAngle = value;
                    return this;
                },
                /**
     * Sets if this curve extends clockwise or anti-clockwise.
     *
     * @method Phaser.Curves.Ellipse#setClockwise
     * @since 3.0.0
     *
     * @param {boolean} value - The clockwise state of this curve.
     *
     * @return {this} This curve object.
     */ setClockwise: function(value) {
                    this.clockwise = value;
                    return this;
                },
                /**
     * Sets the rotation of this curve.
     *
     * @method Phaser.Curves.Ellipse#setRotation
     * @since 3.0.0
     *
     * @param {number} value - The rotation of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setRotation: function(value) {
                    this.rotation = value;
                    return this;
                },
                /**
     * The x coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.p0.x;
                    },
                    set: function(value) {
                        this.p0.x = value;
                    }
                },
                /**
     * The y coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.p0.y;
                    },
                    set: function(value) {
                        this.p0.y = value;
                    }
                },
                /**
     * The horizontal radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#xRadius
     * @type {number}
     * @since 3.0.0
     */ xRadius: {
                    get: function() {
                        return this._xRadius;
                    },
                    set: function(value) {
                        this._xRadius = value;
                    }
                },
                /**
     * The vertical radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#yRadius
     * @type {number}
     * @since 3.0.0
     */ yRadius: {
                    get: function() {
                        return this._yRadius;
                    },
                    set: function(value) {
                        this._yRadius = value;
                    }
                },
                /**
     * The start angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#startAngle
     * @type {number}
     * @since 3.0.0
     */ startAngle: {
                    get: function() {
                        return RadToDeg(this._startAngle);
                    },
                    set: function(value) {
                        this._startAngle = DegToRad(value);
                    }
                },
                /**
     * The end angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#endAngle
     * @type {number}
     * @since 3.0.0
     */ endAngle: {
                    get: function() {
                        return RadToDeg(this._endAngle);
                    },
                    set: function(value) {
                        this._endAngle = DegToRad(value);
                    }
                },
                /**
     * `true` if the ellipse rotation is clockwise or `false` if anti-clockwise.
     *
     * @name Phaser.Curves.Ellipse#clockwise
     * @type {boolean}
     * @since 3.0.0
     */ clockwise: {
                    get: function() {
                        return this._clockwise;
                    },
                    set: function(value) {
                        this._clockwise = value;
                    }
                },
                /**
     * The rotation of the ellipse, relative to the center, in degrees.
     *
     * @name Phaser.Curves.Ellipse#angle
     * @type {number}
     * @since 3.14.0
     */ angle: {
                    get: function() {
                        return RadToDeg(this._rotation);
                    },
                    set: function(value) {
                        this._rotation = DegToRad(value);
                    }
                },
                /**
     * The rotation of the ellipse, relative to the center, in radians.
     *
     * @name Phaser.Curves.Ellipse#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        this._rotation = value;
                    }
                },
                /**
     * JSON serialization of the curve.
     *
     * @method Phaser.Curves.Ellipse#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONEllipseCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        x: this.p0.x,
                        y: this.p0.y,
                        xRadius: this._xRadius,
                        yRadius: this._yRadius,
                        startAngle: RadToDeg(this._startAngle),
                        endAngle: RadToDeg(this._endAngle),
                        clockwise: this._clockwise,
                        rotation: RadToDeg(this._rotation)
                    };
                }
            });
            /**
 * Creates a curve from the provided Ellipse Curve Configuration object.
 *
 * @function Phaser.Curves.Ellipse.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONEllipseCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Ellipse} The ellipse curve constructed from the configuration object.
 */ EllipseCurve.fromJSON = function(data) {
                return new EllipseCurve(data);
            };
            module1.exports = EllipseCurve;
        /***/ },
        /* 392 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(94);
            var FromPoints = __webpack_require__(199);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A LineCurve is a "curve" comprising exactly two points (a line segment).
 *
 * @class Line
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - The first endpoint.
 * @param {Phaser.Math.Vector2} [p1] - The second endpoint.
 */ var LineCurve = new Class({
                Extends: Curve,
                initialize: //  vec2s or array
                function LineCurve(p0, p1) {
                    Curve.call(this, "LineCurve");
                    if (Array.isArray(p0)) {
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The first endpoint.
         *
         * @name Phaser.Curves.Line#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                    /**
         * The second endpoint.
         *
         * @name Phaser.Curves.Line#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                    //  Override default Curve.arcLengthDivisions
                    /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Line#arcLengthDivisions
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.arcLengthDivisions = 1;
                },
                /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * @method Phaser.Curves.Line#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the bounds in. If not given a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out) {
                    if (out === undefined) out = new Rectangle();
                    return FromPoints([
                        this.p0,
                        this.p1
                    ], out);
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Line#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Gets the resolution of the line.
     *
     * @method Phaser.Curves.Line#getResolution
     * @since 3.0.0
     *
     * @param {number} [divisions=1] - The number of divisions to consider.
     *
     * @return {number} The resolution. Equal to the number of divisions.
     */ getResolution: function(divisions) {
                    if (divisions === undefined) divisions = 1;
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    if (t === 1) return out.copy(this.p1);
                    out.copy(this.p1).subtract(this.p0).scale(t).add(this.p0);
                    return out;
                },
                // Line curve is linear, so we can overwrite default getPointAt
                /**
     * Gets a point at a given position on the line.
     *
     * @method Phaser.Curves.Line#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPointAt: function(u, out) {
                    return this.getPoint(u, out);
                },
                /**
     * Gets the slope of the line as a unit vector.
     *
     * @method Phaser.Curves.Line#getTangent
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} [t] - The relative position on the line, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangent: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    out.copy(this.p1).subtract(this.p0).normalize();
                    return out;
                },
                /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Line#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                    var t;
                    if (distance) {
                        var arcLengths = this.getLengths(divisions);
                        var lineLength = arcLengths[arcLengths.length - 1];
                        //  Cannot overshoot the curve
                        var targetLineLength = Math.min(distance, lineLength);
                        t = targetLineLength / lineLength;
                    } else t = u;
                    return t;
                },
                //  Override default Curve.draw because this is better than calling getPoints on a line!
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.lineBetween` so will be drawn at whatever the present Graphics line color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Line#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics) {
                    graphics.lineBetween(this.p0.x, this.p0.y, this.p1.x, this.p1.y);
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Gets a JSON representation of the line.
     *
     * @method Phaser.Curves.Line#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y
                        ]
                    };
                }
            });
            /**
 * Configures this line from a JSON representation.
 *
 * @function Phaser.Curves.Line.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Line} A new LineCurve object.
 */ LineCurve.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                return new LineCurve(p0, p1);
            };
            module1.exports = LineCurve;
        /***/ },
        /* 393 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A MoveTo Curve is a very simple curve consisting of only a single point.
 * Its intended use is to move the ending point in a Path.
 *
 * @class MoveTo
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - `x` pixel coordinate.
 * @param {number} [y=0] - `y` pixel coordinate.
 */ var MoveTo = new Class({
                initialize: function MoveTo(x, y) {
                    /**
         * Denotes that this Curve does not influence the bounds, points, and drawing of its parent Path. Must be `false` or some methods in the parent Path will throw errors.
         *
         * @name Phaser.Curves.MoveTo#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                    /**
         * The lone point which this curve consists of.
         *
         * @name Phaser.Curves.MoveTo#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.MoveTo#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Retrieves the point at given position in the curve. This will always return this curve's only point.
     *
     * @method Phaser.Curves.MoveTo#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position in the path to retrieve, between 0 and 1. Not used.
     * @param {Phaser.Math.Vector2} [out] - An optional vector in which to store the point.
     *
     * @return {Phaser.Math.Vector2} The modified `out` vector, or a new `Vector2` if none was provided.
     */ getPointAt: function(u, out) {
                    return this.getPoint(u, out);
                },
                /**
     * Gets the resolution of this curve.
     *
     * @method Phaser.Curves.MoveTo#getResolution
     * @since 3.0.0
     *
     * @return {number} The resolution of this curve. For a MoveTo the value is always 1.
     */ getResolution: function() {
                    return 1;
                },
                /**
     * Gets the length of this curve.
     *
     * @method Phaser.Curves.MoveTo#getLength
     * @since 3.0.0
     *
     * @return {number} The length of this curve. For a MoveTo the value is always 0.
     */ getLength: function() {
                    return 0;
                },
                /**
     * Converts this curve into a JSON-serializable object.
     *
     * @method Phaser.Curves.MoveTo#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} A primitive object with the curve's type and only point.
     */ toJSON: function() {
                    return {
                        type: "MoveTo",
                        points: [
                            this.p0.x,
                            this.p0.y
                        ]
                    };
                }
            });
            module1.exports = MoveTo;
        /***/ },
        /* 394 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Curve = __webpack_require__(94);
            var QuadraticBezierInterpolation = __webpack_require__(359);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A quadratic Bézier curve constructed from two control points.
 *
 * @class QuadraticBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.2.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 */ var QuadraticBezier = new Class({
                Extends: Curve,
                initialize: function QuadraticBezier(p0, p1, p2) {
                    Curve.call(this, "QuadraticBezier");
                    if (Array.isArray(p0)) {
                        p2 = new Vector2(p0[4], p0[5]);
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The start point.
         *
         * @name Phaser.Curves.QuadraticBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p0 = p0;
                    /**
         * The first control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p1 = p1;
                    /**
         * The second control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p2 = p2;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getStartPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getResolution
     * @since 3.2.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.QuadraticBezier#getPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var p0 = this.p0;
                    var p1 = this.p1;
                    var p2 = this.p2;
                    return out.set(QuadraticBezierInterpolation(t, p0.x, p1.x, p2.x), QuadraticBezierInterpolation(t, p0.y, p1.y, p2.y));
                },
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.QuadraticBezier#draw
     * @since 3.2.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - `Graphics` object to draw onto.
     * @param {number} [pointsTotal=32] - Number of points to be used for drawing the curve. Higher numbers result in smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} `Graphics` object that was drawn to.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    var points = this.getPoints(pointsTotal);
                    graphics.beginPath();
                    graphics.moveTo(this.p0.x, this.p0.y);
                    for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                    graphics.strokePath();
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Converts the curve into a JSON compatible object.
     *
     * @method Phaser.Curves.QuadraticBezier#toJSON
     * @since 3.2.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y
                        ]
                    };
                }
            });
            /**
 * Creates a curve from a JSON object, e. g. created by `toJSON`.
 *
 * @function Phaser.Curves.QuadraticBezier.fromJSON
 * @since 3.2.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.QuadraticBezier} The created curve instance.
 */ QuadraticBezier.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                var p2 = new Vector2(points[4], points[5]);
                return new QuadraticBezier(p0, p1, p2);
            };
            module1.exports = QuadraticBezier;
        /***/ },
        /* 395 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var CatmullRom = __webpack_require__(194);
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(94);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * Create a smooth 2d spline curve from a series of points.
 *
 * @class Spline
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2[]|number[]|number[][])} [points] - The points that configure the curve.
 */ var SplineCurve = new Class({
                Extends: Curve,
                initialize: function SplineCurve(points) {
                    if (points === undefined) points = [];
                    Curve.call(this, "SplineCurve");
                    /**
         * The Vector2 points that configure the curve.
         *
         * @name Phaser.Curves.Spline#points
         * @type {Phaser.Math.Vector2[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                    this.addPoints(points);
                },
                /**
     * Add a list of points to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoints
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2[]|number[]|number[][])} points - The points that configure the curve.
     *
     * @return {this} This curve object.
     */ addPoints: function(points) {
                    for(var i = 0; i < points.length; i++){
                        var p = new Vector2();
                        if (typeof points[i] === "number") {
                            p.x = points[i];
                            p.y = points[i + 1];
                            i++;
                        } else if (Array.isArray(points[i])) {
                            //  An array of arrays?
                            p.x = points[i][0];
                            p.y = points[i][1];
                        } else {
                            p.x = points[i].x;
                            p.y = points[i].y;
                        }
                        this.points.push(p);
                    }
                    return this;
                },
                /**
     * Add a point to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of this curve
     * @param {number} y - The y coordinate of this curve
     *
     * @return {Phaser.Math.Vector2} The new Vector2 added to the curve
     */ addPoint: function(x, y) {
                    var vec = new Vector2(x, y);
                    this.points.push(vec);
                    return vec;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Spline#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.points[0]);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Spline#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions * this.points.length;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Spline#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var points = this.points;
                    var point = (points.length - 1) * t;
                    var intPoint = Math.floor(point);
                    var weight = point - intPoint;
                    var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                    var p1 = points[intPoint];
                    var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                    var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                    return out.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                },
                /**
     * Exports a JSON object containing this curve data.
     *
     * @method Phaser.Curves.Spline#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    var points = [];
                    for(var i = 0; i < this.points.length; i++){
                        points.push(this.points[i].x);
                        points.push(this.points[i].y);
                    }
                    return {
                        type: this.type,
                        points: points
                    };
                }
            });
            /**
 * Imports a JSON object containing this curve data.
 *
 * @function Phaser.Curves.Spline.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Spline} The spline curve created.
 */ SplineCurve.fromJSON = function(data) {
                return new SplineCurve(data.points);
            };
            module1.exports = SplineCurve;
        /***/ },
        /* 396 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A BaseShader is a small resource class that contains the data required for a WebGL Shader to be created.
 *
 * It contains the raw source code to the fragment and vertex shader, as well as an object that defines
 * the uniforms the shader requires, if any.
 *
 * BaseShaders are stored in the Shader Cache, available in a Scene via `this.cache.shaders` and are referenced
 * by a unique key-based string. Retrieve them via `this.cache.shaders.get(key)`.
 *
 * BaseShaders are created automatically by the GLSL File Loader when loading an external shader resource.
 * They can also be created at runtime, allowing you to use dynamically generated shader source code.
 *
 * Default fragment and vertex source is used if not provided in the constructor, setting-up a basic shader,
 * suitable for debug rendering.
 *
 * @class BaseShader
 * @memberof Phaser.Display
 * @constructor
 * @since 3.17.0
 *
 * @param {string} key - The key of this shader. Must be unique within the shader cache.
 * @param {string} [fragmentSrc] - The fragment source for the shader.
 * @param {string} [vertexSrc] - The vertex source for the shader.
 * @param {any} [uniforms] - Optional object defining the uniforms the shader uses.
 */ var BaseShader = new Class({
                initialize: function BaseShader(key, fragmentSrc, vertexSrc, uniforms) {
                    if (!fragmentSrc || fragmentSrc === "") fragmentSrc = [
                        "precision mediump float;",
                        "uniform vec2 resolution;",
                        "varying vec2 fragCoord;",
                        "void main () {",
                        "    vec2 uv = fragCoord / resolution.xy;",
                        "    gl_FragColor = vec4(uv.xyx, 1.0);",
                        "}"
                    ].join("\n");
                    if (!vertexSrc || vertexSrc === "") vertexSrc = [
                        "precision mediump float;",
                        "uniform mat4 uProjectionMatrix;",
                        "uniform mat4 uViewMatrix;",
                        "uniform vec2 uResolution;",
                        "attribute vec2 inPosition;",
                        "varying vec2 fragCoord;",
                        "varying vec2 outTexCoord;",
                        "void main () {",
                        "   gl_Position = uProjectionMatrix * uViewMatrix * vec4(inPosition, 1.0, 1.0);",
                        "   fragCoord = vec2(inPosition.x, uResolution.y - inPosition.y);",
                        "   outTexCoord = vec2(inPosition.x / uResolution.x, fragCoord.y / uResolution.y);",
                        "}"
                    ].join("\n");
                    if (uniforms === undefined) uniforms = null;
                    /**
         * The key of this shader, unique within the shader cache of this Phaser game instance.
         *
         * @name Phaser.Display.BaseShader#key
         * @type {string}
         * @since 3.17.0
         */ this.key = key;
                    /**
         * The source code, as a string, of the fragment shader being used.
         *
         * @name Phaser.Display.BaseShader#fragmentSrc
         * @type {string}
         * @since 3.17.0
         */ this.fragmentSrc = fragmentSrc;
                    /**
         * The source code, as a string, of the vertex shader being used.
         *
         * @name Phaser.Display.BaseShader#vertexSrc
         * @type {string}
         * @since 3.17.0
         */ this.vertexSrc = vertexSrc;
                    /**
         * The default uniforms for this shader.
         *
         * @name Phaser.Display.BaseShader#uniforms
         * @type {?any}
         * @since 3.17.0
         */ this.uniforms = uniforms;
                }
            });
            module1.exports = BaseShader;
        /***/ },
        /* 397 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            Color.ColorSpectrum = __webpack_require__(909);
            Color.ColorToRGBA = __webpack_require__(910);
            Color.ComponentToHex = __webpack_require__(398);
            Color.GetColor = __webpack_require__(103);
            Color.GetColor32 = __webpack_require__(328);
            Color.HexStringToColor = __webpack_require__(327);
            Color.HSLToColor = __webpack_require__(911);
            Color.HSVColorWheel = __webpack_require__(912);
            Color.HSVToRGB = __webpack_require__(188);
            Color.HueToComponent = __webpack_require__(399);
            Color.IntegerToColor = __webpack_require__(189);
            Color.IntegerToRGB = __webpack_require__(330);
            Color.Interpolate = __webpack_require__(913);
            Color.ObjectToColor = __webpack_require__(331);
            Color.RandomRGB = __webpack_require__(914);
            Color.RGBStringToColor = __webpack_require__(332);
            Color.RGBToHSV = __webpack_require__(329);
            Color.RGBToString = __webpack_require__(915);
            Color.ValueToColor = __webpack_require__(187);
            module1.exports = Color;
        /***/ },
        /* 398 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a string containing a hex representation of the given color component.
 *
 * @function Phaser.Display.Color.ComponentToHex
 * @since 3.0.0
 *
 * @param {number} color - The color channel to get the hex value for, must be a value between 0 and 255.
 *
 * @return {string} A string of length 2 characters, i.e. 255 = ff, 100 = 64.
 */ var ComponentToHex = function(color) {
                var hex = color.toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            };
            module1.exports = ComponentToHex;
        /***/ },
        /* 399 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts a hue to an RGB color.
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.HueToComponent
 * @since 3.0.0
 *
 * @param {number} p
 * @param {number} q
 * @param {number} t
 *
 * @return {number} The combined color value.
 */ var HueToComponent = function(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            module1.exports = HueToComponent;
        /***/ },
        /* 400 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(105);
            /**
 * @callback ContentLoadedCallback
 */ /**
 * Inspects the readyState of the document. If the document is already complete then it invokes the given callback.
 * If not complete it sets up several event listeners such as `deviceready`, and once those fire, it invokes the callback.
 * Called automatically by the Phaser.Game instance. Should not usually be accessed directly.
 *
 * @function Phaser.DOM.DOMContentLoaded
 * @since 3.0.0
 *
 * @param {ContentLoadedCallback} callback - The callback to be invoked when the device is ready and the DOM content is loaded.
 */ var DOMContentLoaded = function(callback) {
                if (document.readyState === "complete" || document.readyState === "interactive") {
                    callback();
                    return;
                }
                var check = function() {
                    document.removeEventListener("deviceready", check, true);
                    document.removeEventListener("DOMContentLoaded", check, true);
                    window.removeEventListener("load", check, true);
                    callback();
                };
                if (!document.body) window.setTimeout(check, 20);
                else if (OS.cordova) //  Ref. http://docs.phonegap.com/en/3.5.0/cordova_events_events.md.html#deviceready
                document.addEventListener("deviceready", check, false);
                else {
                    document.addEventListener("DOMContentLoaded", check, true);
                    window.addEventListener("load", check, true);
                }
            };
            module1.exports = DOMContentLoaded;
        /***/ },
        /* 401 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to determine the document inner height across iOS and standard devices.
 * Based on code by @tylerjpeterson
 *
 * @function Phaser.DOM.GetInnerHeight
 * @since 3.16.0
 *
 * @param {boolean} iOS - Is this running on iOS?
 *
 * @return {number} The inner height value.
 */ var GetInnerHeight = function(iOS) {
                if (!iOS) return window.innerHeight;
                var axis = Math.abs(window.orientation);
                var size = {
                    w: 0,
                    h: 0
                };
                var ruler = document.createElement("div");
                ruler.setAttribute("style", "position: fixed; height: 100vh; width: 0; top: 0");
                document.documentElement.appendChild(ruler);
                size.w = axis === 90 ? ruler.offsetHeight : window.innerWidth;
                size.h = axis === 90 ? window.innerWidth : ruler.offsetHeight;
                document.documentElement.removeChild(ruler);
                ruler = null;
                if (Math.abs(window.orientation) !== 90) return size.h;
                else return size.w;
            };
            module1.exports = GetInnerHeight;
        /***/ },
        /* 402 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(201);
            /**
 * Attempts to determine the screen orientation using the Orientation API.
 *
 * @function Phaser.DOM.GetScreenOrientation
 * @since 3.16.0
 *
 * @param {number} width - The width of the viewport.
 * @param {number} height - The height of the viewport.
 *
 * @return {string} The orientation.
 */ var GetScreenOrientation = function(width, height) {
                var screen1 = window.screen;
                var orientation = screen1 ? screen1.orientation || screen1.mozOrientation || screen1.msOrientation : false;
                if (orientation && typeof orientation.type === "string") //  Screen Orientation API specification
                return orientation.type;
                else if (typeof orientation === "string") //  moz / ms-orientation are strings
                return orientation;
                if (typeof window.orientation === "number") //  Do this check first, as iOS supports this, but also has an incomplete window.screen implementation
                //  This may change by device based on "natural" orientation.
                return window.orientation === 0 || window.orientation === 180 ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
                else if (window.matchMedia) {
                    if (window.matchMedia("(orientation: portrait)").matches) return CONST.ORIENTATION.PORTRAIT;
                    else if (window.matchMedia("(orientation: landscape)").matches) return CONST.ORIENTATION.LANDSCAPE;
                } else return height > width ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
            };
            module1.exports = GetScreenOrientation;
        /***/ },
        /* 403 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 * 
 * @namespace Phaser.Scale.Center
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 * 
 * To find out what each mode does please see [Phaser.Scale.Center]{@link Phaser.Scale.Center}.
 * 
 * @typedef {Phaser.Scale.Center} Phaser.Scale.CenterType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * The game canvas is not centered within the parent by Phaser.
     * You can still center it yourself via CSS.
     * 
     * @name Phaser.Scale.Center.NO_CENTER
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_CENTER: 0,
                /**
     * The game canvas is centered both horizontally and vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_BOTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_BOTH: 1,
                /**
     * The game canvas is centered horizontally within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_HORIZONTALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_HORIZONTALLY: 2,
                /**
     * The game canvas is centered both vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_VERTICALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_VERTICALLY: 3
            };
        /***/ },
        /* 404 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for orientation.
 * 
 * @namespace Phaser.Scale.Orientation
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for orientation.
 * 
 * To find out what each mode does please see [Phaser.Scale.Orientation]{@link Phaser.Scale.Orientation}.
 * 
 * @typedef {Phaser.Scale.Orientation} Phaser.Scale.OrientationType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * A landscape orientation.
     * 
     * @name Phaser.Scale.Orientation.LANDSCAPE
     * @type {string}
     * @const
     * @since 3.16.0
     */ LANDSCAPE: "landscape-primary",
                /**
     * A portrait orientation.
     * 
     * @name Phaser.Scale.Orientation.PORTRAIT
     * @type {string}
     * @const
     * @since 3.16.0
     */ PORTRAIT: "portrait-primary"
            };
        /***/ },
        /* 405 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 * 
 * @namespace Phaser.Scale.ScaleModes
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 * 
 * To find out what each mode does please see [Phaser.Scale.ScaleModes]{@link Phaser.Scale.ScaleModes}.
 * 
 * @typedef {Phaser.Scale.ScaleModes} Phaser.Scale.ScaleModeType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * No scaling happens at all. The canvas is set to the size given in the game config and Phaser doesn't change it
     * again from that point on. If you change the canvas size, either via CSS, or directly via code, then you need
     * to call the Scale Managers `resize` method to give the new dimensions, or input events will stop working.
     * 
     * @name Phaser.Scale.ScaleModes.NONE
     * @type {number}
     * @const
     * @since 3.16.0
     */ NONE: 0,
                /**
     * The height is automatically adjusted based on the width.
     * 
     * @name Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT
     * @type {number}
     * @const
     * @since 3.16.0
     */ WIDTH_CONTROLS_HEIGHT: 1,
                /**
     * The width is automatically adjusted based on the height.
     * 
     * @name Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ HEIGHT_CONTROLS_WIDTH: 2,
                /**
     * The width and height are automatically adjusted to fit inside the given target area,
     * while keeping the aspect ratio. Depending on the aspect ratio there may be some space
     * inside the area which is not covered.
     * 
     * @name Phaser.Scale.ScaleModes.FIT
     * @type {number}
     * @const
     * @since 3.16.0
     */ FIT: 3,
                /**
     * The width and height are automatically adjusted to make the size cover the entire target
     * area while keeping the aspect ratio. This may extend further out than the target size.
     * 
     * @name Phaser.Scale.ScaleModes.ENVELOP
     * @type {number}
     * @const
     * @since 3.16.0
     */ ENVELOP: 4,
                /**
     * The Canvas is resized to fit all available _parent_ space, regardless of aspect ratio.
     * 
     * @name Phaser.Scale.ScaleModes.RESIZE
     * @type {number}
     * @const
     * @since 3.16.0
     */ RESIZE: 5
            };
        /***/ },
        /* 406 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 * 
 * @namespace Phaser.Scale.Zoom
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 * 
 * To find out what each mode does please see [Phaser.Scale.Zoom]{@link Phaser.Scale.Zoom}.
 * 
 * @typedef {Phaser.Scale.Zoom} Phaser.Scale.ZoomType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * The game canvas will not be zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.NO_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_ZOOM: 1,
                /**
     * The game canvas will be 2x zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.ZOOM_2X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_2X: 2,
                /**
     * The game canvas will be 4x zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.ZOOM_4X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_4X: 4,
                /**
     * Calculate the zoom value based on the maximum multiplied game size that will
     * fit into the parent, or browser window if no parent is set.
     * 
     * @name Phaser.Scale.Zoom.MAX_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ MAX_ZOOM: -1
            };
        /***/ },
        /* 407 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to get the target DOM element based on the given value, which can be either
 * a string, in which case it will be looked-up by ID, or an element node. If nothing
 * can be found it will return a reference to the document.body.
 *
 * @function Phaser.DOM.GetTarget
 * @since 3.16.0
 *
 * @param {HTMLElement} element - The DOM element to look-up.
 */ var GetTarget = function(element) {
                var target;
                if (element !== "") {
                    if (typeof element === "string") //  Hopefully an element ID
                    target = document.getElementById(element);
                    else if (element && element.nodeType === 1) //  Quick test for a HTMLElement
                    target = element;
                }
                //  Fallback to the document body. Covers an invalid ID and a non HTMLElement object.
                if (!target) //  Use the full window
                target = document.body;
                return target;
            };
            module1.exports = GetTarget;
        /***/ },
        /* 408 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given data string and parses it as XML.
 * First tries to use the window.DOMParser and reverts to the Microsoft.XMLDOM if that fails.
 * The parsed XML object is returned, or `null` if there was an error while parsing the data.
 *
 * @function Phaser.DOM.ParseXML
 * @since 3.0.0
 *
 * @param {string} data - The XML source stored in a string.
 *
 * @return {?(DOMParser|ActiveXObject)} The parsed XML data, or `null` if the data could not be parsed.
 */ var ParseXML = function(data) {
                var xml = "";
                try {
                    if (window["DOMParser"]) {
                        var domparser = new DOMParser();
                        xml = domparser.parseFromString(data, "text/xml");
                    } else {
                        xml = new ActiveXObject("Microsoft.XMLDOM");
                        xml.loadXML(data);
                    }
                } catch (e) {
                    xml = null;
                }
                if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) return null;
                else return xml;
            };
            module1.exports = ParseXML;
        /***/ },
        /* 409 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(203);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(51);
            var GameEvents = __webpack_require__(22);
            var Keyboard = __webpack_require__(410);
            var Mouse = __webpack_require__(411);
            var Pointer = __webpack_require__(412);
            var Touch = __webpack_require__(413);
            var TransformMatrix = __webpack_require__(25);
            var TransformXY = __webpack_require__(177);
            /**
 * @classdesc
 * The Input Manager is responsible for handling the pointer related systems in a single Phaser Game instance.
 *
 * Based on the Game Config it will create handlers for mouse and touch support.
 *
 * Keyboard and Gamepad are plugins, handled directly by the InputPlugin class.
 *
 * It then manages the events, pointer creation and general hit test related operations.
 *
 * You rarely need to interact with the Input Manager directly, and as such, all of its properties and methods
 * should be considered private. Instead, you should use the Input Plugin, which is a Scene level system, responsible
 * for dealing with all input events for a Scene.
 *
 * @class InputManager
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance that owns the Input Manager.
 * @param {object} config - The Input Configuration object, as set in the Game Config.
 */ var InputManager = new Class({
                initialize: function InputManager(game, config) {
                    /**
         * The Game instance that owns the Input Manager.
         * A Game only maintains on instance of the Input Manager at any time.
         *
         * @name Phaser.Input.InputManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A reference to the global Game Scale Manager.
         * Used for all bounds checks and pointer scaling.
         *
         * @name Phaser.Input.InputManager#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                    /**
         * The Canvas that is used for all DOM event input listeners.
         *
         * @name Phaser.Input.InputManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                    /**
         * The Game Configuration object, as set during the game boot.
         *
         * @name Phaser.Input.InputManager#config
         * @type {Phaser.Core.Config}
         * @since 3.0.0
         */ this.config = config;
                    /**
         * If set, the Input Manager will run its update loop every frame.
         *
         * @name Phaser.Input.InputManager#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * The Event Emitter instance that the Input Manager uses to emit events from.
         *
         * @name Phaser.Input.InputManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                    /**
         * Are any mouse or touch pointers currently over the game canvas?
         * This is updated automatically by the canvas over and out handlers.
         *
         * @name Phaser.Input.InputManager#isOver
         * @type {boolean}
         * @readonly
         * @since 3.16.0
         */ this.isOver = true;
                    /**
         * The default CSS cursor to be used when interacting with your game.
         *
         * See the `setDefaultCursor` method for more details.
         *
         * @name Phaser.Input.InputManager#defaultCursor
         * @type {string}
         * @since 3.10.0
         */ this.defaultCursor = "";
                    /**
         * A reference to the Keyboard Manager class, if enabled via the `input.keyboard` Game Config property.
         *
         * @name Phaser.Input.InputManager#keyboard
         * @type {?Phaser.Input.Keyboard.KeyboardManager}
         * @since 3.16.0
         */ this.keyboard = config.inputKeyboard ? new Keyboard(this) : null;
                    /**
         * A reference to the Mouse Manager class, if enabled via the `input.mouse` Game Config property.
         *
         * @name Phaser.Input.InputManager#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = config.inputMouse ? new Mouse(this) : null;
                    /**
         * A reference to the Touch Manager class, if enabled via the `input.touch` Game Config property.
         *
         * @name Phaser.Input.InputManager#touch
         * @type {Phaser.Input.Touch.TouchManager}
         * @since 3.0.0
         */ this.touch = config.inputTouch ? new Touch(this) : null;
                    /**
         * An array of Pointers that have been added to the game.
         * The first entry is reserved for the Mouse Pointer, the rest are Touch Pointers.
         *
         * By default there is 1 touch pointer enabled. If you need more use the `addPointer` method to start them,
         * or set the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointers
         * @type {Phaser.Input.Pointer[]}
         * @since 3.10.0
         */ this.pointers = [];
                    /**
         * The number of touch objects activated and being processed each update.
         *
         * You can change this by either calling `addPointer` at run-time, or by
         * setting the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointersTotal
         * @type {number}
         * @readonly
         * @since 3.10.0
         */ this.pointersTotal = config.inputActivePointers;
                    if (config.inputTouch && this.pointersTotal === 1) this.pointersTotal = 2;
                    for(var i = 0; i <= this.pointersTotal; i++){
                        var pointer = new Pointer(this, i);
                        pointer.smoothFactor = config.inputSmoothFactor;
                        this.pointers.push(pointer);
                    }
                    /**
         * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
         * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
         * which will always map to the most recently interacted pointer.
         *
         * @name Phaser.Input.InputManager#mousePointer
         * @type {?Phaser.Input.Pointer}
         * @since 3.10.0
         */ this.mousePointer = config.inputMouse ? this.pointers[0] : null;
                    /**
         * The most recently active Pointer object.
         *
         * If you've only 1 Pointer in your game then this will accurately be either the first finger touched, or the mouse.
         *
         * If your game doesn't need to support multi-touch then you can safely use this property in all of your game
         * code and it will adapt to be either the mouse or the touch, based on device.
         *
         * @name Phaser.Input.InputManager#activePointer
         * @type {Phaser.Input.Pointer}
         * @since 3.0.0
         */ this.activePointer = this.pointers[0];
                    /**
         * If the top-most Scene in the Scene List receives an input it will stop input from
         * propagating any lower down the scene list, i.e. if you have a UI Scene at the top
         * and click something on it, that click will not then be passed down to any other
         * Scene below. Disable this to have input events passed through all Scenes, all the time.
         *
         * @name Phaser.Input.InputManager#globalTopOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.globalTopOnly = true;
                    /**
         * The time this Input Manager was last updated.
         * This value is populated by the Game Step each frame.
         *
         * @name Phaser.Input.InputManager#time
         * @type {number}
         * @readonly
         * @since 3.16.2
         */ this.time = 0;
                    /**
         * A re-cycled point-like object to store hit test values in.
         *
         * @name Phaser.Input.InputManager#_tempPoint
         * @type {{x:number, y:number}}
         * @private
         * @since 3.0.0
         */ this._tempPoint = {
                        x: 0,
                        y: 0
                    };
                    /**
         * A re-cycled array to store hit results in.
         *
         * @name Phaser.Input.InputManager#_tempHitTest
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempHitTest = [];
                    /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.4.0
         */ this._tempMatrix = new TransformMatrix();
                    /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * An internal private var that records Scenes aborting event processing.
         *
         * @name Phaser.Input.InputManager#_tempSkip
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._tempSkip = false;
                    /**
         * An internal private array that avoids needing to create a new array on every DOM mouse event.
         *
         * @name Phaser.Input.InputManager#mousePointerContainer
         * @type {Phaser.Input.Pointer[]}
         * @private
         * @since 3.18.0
         */ this.mousePointerContainer = [
                        this.mousePointer
                    ];
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now.
     *
     * @method Phaser.Input.InputManager#boot
     * @protected
     * @fires Phaser.Input.Events#MANAGER_BOOT
     * @since 3.0.0
     */ boot: function() {
                    this.canvas = this.game.canvas;
                    this.scaleManager = this.game.scale;
                    this.events.emit(Events.MANAGER_BOOT);
                    this.game.events.on(GameEvents.PRE_RENDER, this.preRender, this);
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOver: function(event) {
                    this.isOver = true;
                    this.events.emit(Events.GAME_OVER, event);
                },
                /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOut: function(event) {
                    this.isOver = false;
                    this.events.emit(Events.GAME_OUT, event);
                },
                /**
     * Internal update, called automatically by the Game Step right at the start.
     *
     * @method Phaser.Input.InputManager#preRender
     * @private
     * @since 3.18.0
     */ preRender: function() {
                    var time = this.game.loop.now;
                    var delta = this.game.loop.delta;
                    var scenes = this.game.scene.getScenes(true, true);
                    this.time = time;
                    this.events.emit(Events.MANAGER_UPDATE);
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene.sys.input && scene.sys.input.updatePoll(time, delta) && this.globalTopOnly) //  If the Scene returns true, it means it captured some input that no other Scene should get, so we bail out
                        return;
                    }
                },
                /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputManager#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     */ setDefaultCursor: function(cursor) {
                    this.defaultCursor = cursor;
                    if (this.canvas.style.cursor !== cursor) this.canvas.style.cursor = cursor;
                },
                /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to set a custom cursor during its postUpdate step.
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     *
     * @method Phaser.Input.InputManager#setCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method.
     */ setCursor: function(interactiveObject) {
                    if (interactiveObject.cursor) this.canvas.style.cursor = interactiveObject.cursor;
                },
                /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to clear the hand cursor, if set, during its postUpdate step.
     *
     * @method Phaser.Input.InputManager#resetCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method.
     */ resetCursor: function(interactiveObject) {
                    if (interactiveObject.cursor && this.canvas) this.canvas.style.cursor = this.defaultCursor;
                },
                /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputManager#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                    if (quantity === undefined) quantity = 1;
                    var output = [];
                    if (this.pointersTotal + quantity > 10) quantity = 10 - this.pointersTotal;
                    for(var i = 0; i < quantity; i++){
                        var id = this.pointers.length;
                        var pointer = new Pointer(this, id);
                        pointer.smoothFactor = this.config.inputSmoothFactor;
                        this.pointers.push(pointer);
                        this.pointersTotal++;
                        output.push(pointer);
                    }
                    return output;
                },
                /**
     * Internal method that gets a list of all the active Input Plugins in the game
     * and updates each of them in turn, in reverse order (top to bottom), to allow
     * for DOM top-level event handling simulation.
     *
     * @method Phaser.Input.InputManager#updateInputPlugins
     * @since 3.16.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     */ updateInputPlugins: function(type, pointers) {
                    var scenes = this.game.scene.getScenes(true, true);
                    this._tempSkip = false;
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene.sys.input) {
                            var capture = scene.sys.input.update(type, pointers);
                            if (capture && this.globalTopOnly || this._tempSkip) //  If the Scene returns true, or called stopPropagation, it means it captured some input that no other Scene should get, so we bail out
                            return;
                        }
                    }
                },
                //  event.targetTouches = list of all touches on the TARGET ELEMENT (i.e. game dom element)
                //  event.touches = list of all touches on the ENTIRE DOCUMENT, not just the target element
                //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                /**
     * Processes a touch start event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchStart
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchStart: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (!pointer.active) {
                                pointer.touchstart(changedTouch, event);
                                this.activePointer = pointer;
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_START, changed);
                },
                /**
     * Processes a touch move event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchMove
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchMove: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchmove(changedTouch, event);
                                this.activePointer = pointer;
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_MOVE, changed);
                },
                //  For touch end its a list of the touch points that have been removed from the surface
                //  https://developer.mozilla.org/en-US/docs/DOM/TouchList
                //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                /**
     * Processes a touch end event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchEnd
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchEnd: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchend(changedTouch, event);
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_END, changed);
                },
                /**
     * Processes a touch cancel event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchCancel
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchCancel: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchcancel(changedTouch, event);
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_CANCEL, changed);
                },
                /**
     * Processes a mouse down event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseDown
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseDown: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.down(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_DOWN, this.mousePointerContainer);
                },
                /**
     * Processes a mouse move event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseMove
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseMove: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.move(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_MOVE, this.mousePointerContainer);
                },
                /**
     * Processes a mouse up event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseUp
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseUp: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.up(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_UP, this.mousePointerContainer);
                },
                /**
     * Processes a mouse wheel event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseWheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The native DOM Wheel event.
     */ onMouseWheel: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.wheel(event);
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_WHEEL, this.mousePointerContainer);
                },
                /**
     * Processes a pointer lock change event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onPointerLockChange
     * @fires Phaser.Input.Events#POINTERLOCK_CHANGE
     * @private
     * @since 3.19.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onPointerLockChange: function(event) {
                    var isLocked = this.mouse.locked;
                    this.mousePointer.locked = isLocked;
                    this.events.emit(Events.POINTERLOCK_CHANGE, event, isLocked);
                },
                /**
     * Checks if the given Game Object should be considered as a candidate for input or not.
     *
     * Checks if the Game Object has an input component that is enabled, that it will render,
     * and finally, if it has a parent, that the parent parent, or any ancestor, is visible or not.
     *
     * @method Phaser.Input.InputManager#inputCandidate
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to test.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {boolean} `true` if the Game Object should be considered for input, otherwise `false`.
     */ inputCandidate: function(gameObject, camera) {
                    var input = gameObject.input;
                    if (!input || !input.enabled || !input.alwaysEnabled && !gameObject.willRender(camera)) return false;
                    var visible = true;
                    var parent = gameObject.parentContainer;
                    if (parent) do {
                        if (!parent.willRender(camera)) {
                            visible = false;
                            break;
                        }
                        parent = parent.parentContainer;
                    }while (parent);
                    return visible;
                },
                /**
     * Performs a hit test using the given Pointer and camera, against an array of interactive Game Objects.
     *
     * The Game Objects are culled against the camera, and then the coordinates are translated into the local camera space
     * and used to determine if they fall within the remaining Game Objects hit areas or not.
     *
     * If nothing is matched an empty array is returned.
     *
     * This method is called automatically by InputPlugin.hitTestPointer and doesn't usually need to be invoked directly.
     *
     * @method Phaser.Input.InputManager#hitTest
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to test against.
     * @param {array} gameObjects - An array of interactive Game Objects to check.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     * @param {array} [output] - An array to store the results in. If not given, a new empty array is created.
     *
     * @return {array} An array of the Game Objects that were hit during this hit test.
     */ hitTest: function(pointer, gameObjects, camera, output) {
                    if (output === undefined) output = this._tempHitTest;
                    var tempPoint = this._tempPoint;
                    var csx = camera.scrollX;
                    var csy = camera.scrollY;
                    output.length = 0;
                    var x = pointer.x;
                    var y = pointer.y;
                    //  Stores the world point inside of tempPoint
                    camera.getWorldPoint(x, y, tempPoint);
                    pointer.worldX = tempPoint.x;
                    pointer.worldY = tempPoint.y;
                    var point = {
                        x: 0,
                        y: 0
                    };
                    var matrix = this._tempMatrix;
                    var parentMatrix = this._tempMatrix2;
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        //  Checks if the Game Object can receive input (isn't being ignored by the camera, invisible, etc)
                        //  and also checks all of its parents, if any
                        if (!this.inputCandidate(gameObject, camera)) continue;
                        var px = tempPoint.x + csx * gameObject.scrollFactorX - csx;
                        var py = tempPoint.y + csy * gameObject.scrollFactorY - csy;
                        if (gameObject.parentContainer) {
                            gameObject.getWorldTransformMatrix(matrix, parentMatrix);
                            matrix.applyInverse(px, py, point);
                        } else TransformXY(px, py, gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY, point);
                        if (this.pointWithinHitArea(gameObject, point.x, point.y)) output.push(gameObject);
                    }
                    return output;
                },
                /**
     * Checks if the given x and y coordinate are within the hit area of the Game Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Game Object.
     *
     * If the coordinates are within the hit area they are set into the Game Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinHitArea
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinHitArea: function(gameObject, x, y) {
                    //  Normalize the origin
                    x += gameObject.displayOriginX;
                    y += gameObject.displayOriginY;
                    var input = gameObject.input;
                    if (input && input.hitAreaCallback(input.hitArea, x, y, gameObject)) {
                        input.localX = x;
                        input.localY = y;
                        return true;
                    } else return false;
                },
                /**
     * Checks if the given x and y coordinate are within the hit area of the Interactive Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Interactive Object.
     *
     * If the coordinates are within the hit area they are set into the Interactive Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinInteractiveObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} object - The Interactive Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinInteractiveObject: function(object, x, y) {
                    if (!object.hitArea) return false;
                    //  Normalize the origin
                    x += object.gameObject.displayOriginX;
                    y += object.gameObject.displayOriginY;
                    object.localX = x;
                    object.localY = y;
                    return object.hitAreaCallback(object.hitArea, x, y, object);
                },
                /**
     * Transforms the pageX and pageY values of a Pointer into the scaled coordinate space of the Input Manager.
     *
     * @method Phaser.Input.InputManager#transformPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to transform the values for.
     * @param {number} pageX - The Page X value.
     * @param {number} pageY - The Page Y value.
     * @param {boolean} wasMove - Are we transforming the Pointer from a move event, or an up / down event?
     */ transformPointer: function(pointer, pageX, pageY, wasMove) {
                    var p0 = pointer.position;
                    var p1 = pointer.prevPosition;
                    //  Store previous position
                    p1.x = p0.x;
                    p1.y = p0.y;
                    //  Translate coordinates
                    var x = this.scaleManager.transformX(pageX);
                    var y = this.scaleManager.transformY(pageY);
                    var a = pointer.smoothFactor;
                    if (!wasMove || a === 0) {
                        //  Set immediately
                        p0.x = x;
                        p0.y = y;
                    } else {
                        //  Apply smoothing
                        p0.x = x * a + p1.x * (1 - a);
                        p0.y = y * a + p1.y * (1 - a);
                    }
                },
                /**
     * Destroys the Input Manager and all of its systems.
     *
     * There is no way to recover from doing this.
     *
     * @method Phaser.Input.InputManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.events.removeAllListeners();
                    this.game.events.off(GameEvents.PRE_RENDER);
                    if (this.keyboard) this.keyboard.destroy();
                    if (this.mouse) this.mouse.destroy();
                    if (this.touch) this.touch.destroy();
                    for(var i = 0; i < this.pointers.length; i++)this.pointers[i].destroy();
                    this.pointers = [];
                    this._tempHitTest = [];
                    this._tempMatrix.destroy();
                    this.canvas = null;
                    this.game = null;
                }
            });
            module1.exports = InputManager;
        /***/ },
        /* 410 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(93);
            var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var InputEvents = __webpack_require__(51);
            var KeyCodes = __webpack_require__(143);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * The Keyboard Manager is a helper class that belongs to the global Input Manager.
 *
 * Its role is to listen for native DOM Keyboard Events and then store them for further processing by the Keyboard Plugin.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically if keyboard
 * input has been enabled in the Game Config.
 *
 * @class KeyboardManager
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var KeyboardManager = new Class({
                initialize: function KeyboardManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.16.0
         */ this.manager = inputManager;
                    /**
         * An internal event queue.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#queue
         * @type {KeyboardEvent[]}
         * @private
         * @since 3.16.0
         */ this.queue = [];
                    /**
         * A flag that controls if the non-modified keys, matching those stored in the `captures` array,
         * have `preventDefault` called on them or not.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle this property at run-time.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#preventDefault
         * @type {boolean}
         * @since 3.16.0
         */ this.preventDefault = true;
                    /**
         * An array of Key Code values that will automatically have `preventDefault` called on them,
         * as long as the `KeyboardManager.preventDefault` boolean is set to `true`.
         *
         * By default the array is empty.
         *
         * The key must be non-modified when pressed in order to be captured.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle the `KeyboardManager.preventDefault` boolean at run-time.
         *
         * If you need more specific control, you can create Key objects and set the flag on each of those instead.
         *
         * This array can be populated via the Game Config by setting the `input.keyboard.capture` array, or you
         * can call the `addCapture` method. See also `removeCapture` and `clearCaptures`.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#captures
         * @type {number[]}
         * @since 3.16.0
         */ this.captures = [];
                    /**
         * A boolean that controls if the Keyboard Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.enabled = false;
                    /**
         * The Keyboard Event target, as defined in the Game Config.
         * Typically the window in which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#target
         * @type {any}
         * @since 3.16.0
         */ this.target;
                    /**
         * The Key Down Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyDown
         * @type {function}
         * @since 3.16.00
         */ this.onKeyDown = NOOP;
                    /**
         * The Key Up Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyUp
         * @type {function}
         * @since 3.16.00
         */ this.onKeyUp = NOOP;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Keyboard Manager boot process.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#boot
     * @private
     * @since 3.16.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputKeyboard;
                    this.target = config.inputKeyboardEventTarget;
                    this.addCapture(config.inputKeyboardCapture);
                    if (!this.target && window) this.target = window;
                    if (this.enabled && this.target) this.startListeners();
                    this.manager.game.events.on(GameEvents.POST_STEP, this.postUpdate, this);
                },
                /**
     * Starts the Keyboard Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                    var _this = this;
                    this.onKeyDown = function(event) {
                        if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                        return;
                        _this.queue.push(event);
                        _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                        var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                        if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                    };
                    this.onKeyUp = function(event) {
                        if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                        return;
                        _this.queue.push(event);
                        _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                        var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                        if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                    };
                    var target = this.target;
                    if (target) {
                        target.addEventListener("keydown", this.onKeyDown, false);
                        target.addEventListener("keyup", this.onKeyUp, false);
                        this.enabled = true;
                    }
                },
                /**
     * Stops the Key Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener("keydown", this.onKeyDown, false);
                    target.removeEventListener("keyup", this.onKeyUp, false);
                    this.enabled = false;
                },
                /**
     * Clears the event queue.
     * Called automatically by the Input Manager.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#postUpdate
     * @private
     * @since 3.16.0
     */ postUpdate: function() {
                    this.queue = [];
                },
                /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard event for specific keys so it doesn't bubble up to the the browser
     * and cause the default browser behavior.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are active captures after calling this method, the `preventDefault` property is set to `true`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable capture for, preventing them reaching the browser.
     */ addCapture: function(keycode) {
                    if (typeof keycode === "string") keycode = keycode.split(",");
                    if (!Array.isArray(keycode)) keycode = [
                        keycode
                    ];
                    var captures = this.captures;
                    for(var i = 0; i < keycode.length; i++){
                        var code = keycode[i];
                        if (typeof code === "string") code = KeyCodes[code.trim().toUpperCase()];
                        if (captures.indexOf(code) === -1) captures.push(code);
                    }
                    this.preventDefault = captures.length > 0;
                },
                /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are no captures left after calling this method, the `preventDefault` property is set to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable capture for, allowing them reaching the browser again.
     */ removeCapture: function(keycode) {
                    if (typeof keycode === "string") keycode = keycode.split(",");
                    if (!Array.isArray(keycode)) keycode = [
                        keycode
                    ];
                    var captures = this.captures;
                    for(var i = 0; i < keycode.length; i++){
                        var code = keycode[i];
                        if (typeof code === "string") code = KeyCodes[code.toUpperCase()];
                        ArrayRemove(captures, code);
                    }
                    this.preventDefault = captures.length > 0;
                },
                /**
     * Removes all keyboard captures and sets the `preventDefault` property to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#clearCaptures
     * @since 3.16.0
     */ clearCaptures: function() {
                    this.captures = [];
                    this.preventDefault = false;
                },
                /**
     * Destroys this Keyboard Manager instance.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.stopListeners();
                    this.clearCaptures();
                    this.queue = [];
                    this.manager.game.events.off(GameEvents.POST_RENDER, this.postUpdate, this);
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = KeyboardManager;
        /***/ },
        /* 411 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Features = __webpack_require__(191);
            var InputEvents = __webpack_require__(51);
            var NOOP = __webpack_require__(1);
            //  https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
            //  https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
            /**
 * @classdesc
 * The Mouse Manager is a helper class that belongs to the Input Manager.
 *
 * Its role is to listen for native DOM Mouse Events and then pass them onto the Input Manager for further processing.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class MouseManager
 * @memberof Phaser.Input.Mouse
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var MouseManager = new Class({
                initialize: function MouseManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Mouse.MouseManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                    /**
         * If `true` the DOM `mousedown` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultDown
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultDown = true;
                    /**
         * If `true` the DOM `mouseup` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultUp
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultUp = true;
                    /**
         * If `true` the DOM `mousemove` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultMove
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultMove = true;
                    /**
         * If `true` the DOM `wheel` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultWheel
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultWheel = false;
                    /**
         * A boolean that controls if the Mouse Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Mouse.MouseManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                    /**
         * The Mouse target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Mouse.MouseManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                    /**
         * If the mouse has been pointer locked successfully this will be set to true.
         *
         * @name Phaser.Input.Mouse.MouseManager#locked
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.locked = false;
                    /**
         * The Mouse Move Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseMove
         * @type {function}
         * @since 3.10.0
         */ this.onMouseMove = NOOP;
                    /**
         * The Mouse Down Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDown
         * @type {function}
         * @since 3.10.0
         */ this.onMouseDown = NOOP;
                    /**
         * The Mouse Up Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUp
         * @type {function}
         * @since 3.10.0
         */ this.onMouseUp = NOOP;
                    /**
         * The Mouse Down Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDownWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseDownWindow = NOOP;
                    /**
         * The Mouse Up Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUpWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseUpWindow = NOOP;
                    /**
         * The Mouse Over Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOver
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOver = NOOP;
                    /**
         * The Mouse Out Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOut
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOut = NOOP;
                    /**
         * The Mouse Wheel Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseWheel
         * @type {function}
         * @since 3.18.0
         */ this.onMouseWheel = NOOP;
                    /**
         * Internal pointerLockChange handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#pointerLockChange
         * @type {function}
         * @since 3.0.0
         */ this.pointerLockChange = NOOP;
                    /**
         * Are the event listeners hooked into `window.top` or `window`?
         *
         * This is set during the `boot` sequence. If the browser does not have access to `window.top`,
         * such as in cross-origin iframe environments, this property gets set to `false` and the events
         * are hooked into `window` instead.
         *
         * @name Phaser.Input.Mouse.MouseManager#isTop
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTop = true;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Mouse.MouseManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputMouse;
                    this.target = config.inputMouseEventTarget;
                    this.passive = config.inputMousePassive;
                    this.preventDefaultDown = config.inputMousePreventDefaultDown;
                    this.preventDefaultUp = config.inputMousePreventDefaultUp;
                    this.preventDefaultMove = config.inputMousePreventDefaultMove;
                    this.preventDefaultWheel = config.inputMousePreventDefaultWheel;
                    if (!this.target) this.target = this.manager.game.canvas;
                    else if (typeof this.target === "string") this.target = document.getElementById(this.target);
                    if (config.disableContextMenu) this.disableContextMenu();
                    if (this.enabled && this.target) this.startListeners();
                },
                /**
     * Attempts to disable the context menu from appearing if you right-click on the browser.
     *
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     *
     * Use this if you need to enable right-button mouse support in your game, and the browser
     * menu keeps getting in the way.
     *
     * @method Phaser.Input.Mouse.MouseManager#disableContextMenu
     * @since 3.0.0
     *
     * @return {this} This Mouse Manager instance.
     */ disableContextMenu: function() {
                    document.body.addEventListener("contextmenu", function(event) {
                        event.preventDefault();
                        return false;
                    });
                    return this;
                },
                /**
     * If the browser supports it, you can request that the pointer be locked to the browser window.
     *
     * This is classically known as 'FPS controls', where the pointer can't leave the browser until
     * the user presses an exit key.
     *
     * If the browser successfully enters a locked state, a `POINTER_LOCK_CHANGE_EVENT` will be dispatched,
     * from the games Input Manager, with an `isPointerLocked` property.
     *
     * It is important to note that pointer lock can only be enabled after an 'engagement gesture',
     * see: https://w3c.github.io/pointerlock/#dfn-engagement-gesture.
     *
     * Note for Firefox: There is a bug in certain Firefox releases that cause native DOM events like
     * `mousemove` to fire continuously when in pointer lock mode. You can get around this by setting
     * `this.preventDefaultMove` to `false` in this class. You may also need to do the same for
     * `preventDefaultDown` and/or `preventDefaultUp`. Please test combinations of these if you encounter
     * the error.
     *
     * @method Phaser.Input.Mouse.MouseManager#requestPointerLock
     * @since 3.0.0
     */ requestPointerLock: function() {
                    if (Features.pointerLock) {
                        var element = this.target;
                        element.requestPointerLock = element.requestPointerLock || element.mozRequestPointerLock || element.webkitRequestPointerLock;
                        element.requestPointerLock();
                    }
                },
                /**
     * If the browser supports pointer lock, this will request that the pointer lock is released. If
     * the browser successfully enters a locked state, a 'POINTER_LOCK_CHANGE_EVENT' will be
     * dispatched - from the game's input manager - with an `isPointerLocked` property.
     *
     * @method Phaser.Input.Mouse.MouseManager#releasePointerLock
     * @since 3.0.0
     */ releasePointerLock: function() {
                    if (Features.pointerLock) {
                        document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock;
                        document.exitPointerLock();
                    }
                },
                /**
     * Starts the Mouse Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                    var target = this.target;
                    if (!target) return;
                    var _this = this;
                    var manager = this.manager;
                    var canvas = manager.canvas;
                    var autoFocus = window && window.focus && manager.game.config.autoFocus;
                    this.onMouseMove = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseMove(event);
                            if (_this.preventDefaultMove) event.preventDefault();
                        }
                    };
                    this.onMouseDown = function(event) {
                        if (autoFocus) window.focus();
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseDown(event);
                            if (_this.preventDefaultDown && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onMouseDownWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        manager.onMouseDown(event);
                    };
                    this.onMouseUp = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseUp(event);
                            if (_this.preventDefaultUp && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onMouseUpWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        manager.onMouseUp(event);
                    };
                    this.onMouseOver = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOver(event);
                    };
                    this.onMouseOut = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOut(event);
                    };
                    this.onMouseWheel = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.onMouseWheel(event);
                        if (_this.preventDefaultWheel && event.target === canvas) event.preventDefault();
                    };
                    var passive = {
                        passive: true
                    };
                    target.addEventListener("mousemove", this.onMouseMove);
                    target.addEventListener("mousedown", this.onMouseDown);
                    target.addEventListener("mouseup", this.onMouseUp);
                    target.addEventListener("mouseover", this.onMouseOver, passive);
                    target.addEventListener("mouseout", this.onMouseOut, passive);
                    if (this.preventDefaultWheel) target.addEventListener("wheel", this.onMouseWheel, {
                        passive: false
                    });
                    else target.addEventListener("wheel", this.onMouseWheel, passive);
                    if (window && manager.game.config.inputWindowEvents) try {
                        window.top.addEventListener("mousedown", this.onMouseDownWindow, passive);
                        window.top.addEventListener("mouseup", this.onMouseUpWindow, passive);
                    } catch (exception) {
                        window.addEventListener("mousedown", this.onMouseDownWindow, passive);
                        window.addEventListener("mouseup", this.onMouseUpWindow, passive);
                        this.isTop = false;
                    }
                    if (Features.pointerLock) {
                        this.pointerLockChange = function(event) {
                            var element = _this.target;
                            _this.locked = document.pointerLockElement === element || document.mozPointerLockElement === element || document.webkitPointerLockElement === element ? true : false;
                            manager.onPointerLockChange(event);
                        };
                        document.addEventListener("pointerlockchange", this.pointerLockChange, true);
                        document.addEventListener("mozpointerlockchange", this.pointerLockChange, true);
                        document.addEventListener("webkitpointerlockchange", this.pointerLockChange, true);
                    }
                    this.enabled = true;
                },
                /**
     * Stops the Mouse Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener("mousemove", this.onMouseMove);
                    target.removeEventListener("mousedown", this.onMouseDown);
                    target.removeEventListener("mouseup", this.onMouseUp);
                    target.removeEventListener("mouseover", this.onMouseOver);
                    target.removeEventListener("mouseout", this.onMouseOut);
                    if (window) {
                        target = this.isTop ? window.top : window;
                        target.removeEventListener("mousedown", this.onMouseDownWindow);
                        target.removeEventListener("mouseup", this.onMouseUpWindow);
                    }
                    if (Features.pointerLock) {
                        document.removeEventListener("pointerlockchange", this.pointerLockChange, true);
                        document.removeEventListener("mozpointerlockchange", this.pointerLockChange, true);
                        document.removeEventListener("webkitpointerlockchange", this.pointerLockChange, true);
                    }
                },
                /**
     * Destroys this Mouse Manager instance.
     *
     * @method Phaser.Input.Mouse.MouseManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stopListeners();
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = MouseManager;
        /***/ },
        /* 412 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(349);
            var Class = __webpack_require__(0);
            var Distance = __webpack_require__(50);
            var FuzzyEqual = __webpack_require__(124);
            var SmoothStepInterpolation = __webpack_require__(360);
            var Vector2 = __webpack_require__(3);
            var OS = __webpack_require__(105);
            /**
 * @classdesc
 * A Pointer object encapsulates both mouse and touch input within Phaser.
 *
 * By default, Phaser will create 2 pointers for your game to use. If you require more, i.e. for a multi-touch
 * game, then use the `InputPlugin.addPointer` method to do so, rather than instantiating this class directly,
 * otherwise it won't be managed by the input system.
 *
 * You can reference the current active pointer via `InputPlugin.activePointer`. You can also use the properties
 * `InputPlugin.pointer1` through to `pointer10`, for each pointer you have enabled in your game.
 *
 * The properties of this object are set by the Input Plugin during processing. This object is then sent in all
 * input related events that the Input Plugin emits, so you can reference properties from it directly in your
 * callbacks.
 *
 * @class Pointer
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} manager - A reference to the Input Manager.
 * @param {number} id - The internal ID of this Pointer.
 */ var Pointer = new Class({
                initialize: function Pointer(manager, id) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Pointer#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The internal ID of this Pointer.
         *
         * @name Phaser.Input.Pointer#id
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.id = id;
                    /**
         * The most recent native DOM Event this Pointer has processed.
         *
         * @name Phaser.Input.Pointer#event
         * @type {(TouchEvent|MouseEvent|WheelEvent)}
         * @since 3.0.0
         */ this.event;
                    /**
         * The DOM element the Pointer was pressed down on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#downElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.downElement;
                    /**
         * The DOM element the Pointer was released on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#upElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.upElement;
                    /**
         * The camera the Pointer interacted with during its last update.
         *
         * A Pointer can only ever interact with one camera at once, which will be the top-most camera
         * in the list should multiple cameras be positioned on-top of each other.
         *
         * @name Phaser.Input.Pointer#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = null;
                    /**
         * A read-only property that indicates which button was pressed, or released, on the pointer
         * during the most recent event. It is only set during `up` and `down` events.
         *
         * On Touch devices the value is always 0.
         *
         * Users may change the configuration of buttons on their pointing device so that if an event's button property
         * is zero, it may not have been caused by the button that is physically left–most on the pointing device;
         * however, it should behave as if the left button was clicked in the standard button layout.
         *
         * @name Phaser.Input.Pointer#button
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.18.0
         */ this.button = 0;
                    /**
         * 0: No button or un-initialized
         * 1: Left button
         * 2: Right button
         * 4: Wheel button or middle button
         * 8: 4th button (typically the "Browser Back" button)
         * 16: 5th button (typically the "Browser Forward" button)
         *
         * For a mouse configured for left-handed use, the button actions are reversed.
         * In this case, the values are read from right to left.
         *
         * @name Phaser.Input.Pointer#buttons
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.buttons = 0;
                    /**
         * The position of the Pointer in screen space.
         *
         * @name Phaser.Input.Pointer#position
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.position = new Vector2();
                    /**
         * The previous position of the Pointer in screen space.
         *
         * The old x and y values are stored in here during the InputManager.transformPointer call.
         *
         * Use the properties `velocity`, `angle` and `distance` to create your own gesture recognition.
         *
         * @name Phaser.Input.Pointer#prevPosition
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.prevPosition = new Vector2();
                    /**
         * An internal vector used for calculations of the pointer speed and angle.
         *
         * @name Phaser.Input.Pointer#midPoint
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.16.0
         */ this.midPoint = new Vector2(-1, -1);
                    /**
         * The current velocity of the Pointer, based on its current and previous positions.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.velocity = new Vector2();
                    /**
         * The current angle the Pointer is moving, in radians, based on its previous and current position.
         *
         * The angle is based on the old position facing to the current position.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#angle
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.angle = 0;
                    /**
         * The distance the Pointer has moved, based on its previous and current position.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * If you need the total distance travelled since the primary buttons was pressed down,
         * then use the `Pointer.getDistance` method.
         *
         * @name Phaser.Input.Pointer#distance
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.distance = 0;
                    /**
         * The smoothing factor to apply to the Pointer position.
         *
         * Due to their nature, pointer positions are inherently noisy. While this is fine for lots of games, if you need cleaner positions
         * then you can set this value to apply an automatic smoothing to the positions as they are recorded.
         *
         * The default value of zero means 'no smoothing'.
         * Set to a small value, such as 0.2, to apply an average level of smoothing between positions. You can do this by changing this
         * value directly, or by setting the `input.smoothFactor` property in the Game Config.
         *
         * Positions are only smoothed when the pointer moves. If the primary button on this Pointer enters an Up or Down state, then the position
         * is always precise, and not smoothed.
         *
         * @name Phaser.Input.Pointer#smoothFactor
         * @type {number}
         * @default 0
         * @since 3.16.0
         */ this.smoothFactor = 0;
                    /**
         * The factor applied to the motion smoothing each frame.
         *
         * This value is passed to the Smooth Step Interpolation that is used to calculate the velocity,
         * angle and distance of the Pointer. It's applied every frame, until the midPoint reaches the current
         * position of the Pointer. 0.2 provides a good average but can be increased if you need a
         * quicker update and are working in a high performance environment. Never set this value to
         * zero.
         *
         * @name Phaser.Input.Pointer#motionFactor
         * @type {number}
         * @default 0.2
         * @since 3.16.0
         */ this.motionFactor = 0.2;
                    /**
         * The x position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldX
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldX = 0;
                    /**
         * The y position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldY
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldY = 0;
                    /**
         * Time when this Pointer was most recently moved (regardless of the state of its buttons, if any)
         *
         * @name Phaser.Input.Pointer#moveTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.moveTime = 0;
                    /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downX = 0;
                    /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downY = 0;
                    /**
         * The Event timestamp when the first button, or Touch input, was pressed. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downTime = 0;
                    /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upX = 0;
                    /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upY = 0;
                    /**
         * The Event timestamp when the final button, or Touch input, was released. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upTime = 0;
                    /**
         * Is the primary button down? (usually button 0, the left mouse button)
         *
         * @name Phaser.Input.Pointer#primaryDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.primaryDown = false;
                    /**
         * Is _any_ button on this pointer considered as being down?
         *
         * @name Phaser.Input.Pointer#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                    /**
         * Did the previous input event come from a Touch input (true) or Mouse? (false)
         *
         * @name Phaser.Input.Pointer#wasTouch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.wasTouch = false;
                    /**
         * Did this Pointer get canceled by a touchcancel event?
         *
         * Note: "canceled" is the American-English spelling of "cancelled". Please don't submit PRs correcting it!
         *
         * @name Phaser.Input.Pointer#wasCanceled
         * @type {boolean}
         * @default false
         * @since 3.15.0
         */ this.wasCanceled = false;
                    /**
         * If the mouse is locked, the horizontal relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementX = 0;
                    /**
         * If the mouse is locked, the vertical relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementY = 0;
                    /**
         * The identifier property of the Pointer as set by the DOM event when this Pointer is started.
         *
         * @name Phaser.Input.Pointer#identifier
         * @type {number}
         * @since 3.10.0
         */ this.identifier = 0;
                    /**
         * The pointerId property of the Pointer as set by the DOM event when this Pointer is started.
         * The browser can and will recycle this value.
         *
         * @name Phaser.Input.Pointer#pointerId
         * @type {number}
         * @since 3.10.0
         */ this.pointerId = null;
                    /**
         * An active Pointer is one that is currently pressed down on the display.
         * A Mouse is always considered as active.
         *
         * @name Phaser.Input.Pointer#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = id === 0 ? true : false;
                    /**
         * Is this pointer Pointer Locked?
         *
         * Only a mouse pointer can be locked and it only becomes locked when requested via
         * the browsers Pointer Lock API.
         *
         * You can request this by calling the `this.input.mouse.requestPointerLock()` method from
         * a `pointerdown` or `pointerup` event handler.
         *
         * @name Phaser.Input.Pointer#locked
         * @readonly
         * @type {boolean}
         * @since 3.19.0
         */ this.locked = false;
                    /**
         * The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaX
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaX = 0;
                    /**
         * The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         * This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
         *
         * @name Phaser.Input.Pointer#deltaY
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaY = 0;
                    /**
         * The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaZ
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaZ = 0;
                },
                /**
     * Takes a Camera and updates this Pointer's `worldX` and `worldY` values so they are
     * the result of a translation through the given Camera.
     *
     * Note that the values will be automatically replaced the moment the Pointer is
     * updated by an input event, such as a mouse move, so should be used immediately.
     *
     * @method Phaser.Input.Pointer#updateWorldPoint
     * @since 3.19.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {this} This Pointer object.
     */ updateWorldPoint: function(camera) {
                    //  Stores the world point inside of tempPoint
                    var temp = camera.getWorldPoint(this.x, this.y);
                    this.worldX = temp.x;
                    this.worldY = temp.y;
                    return this;
                },
                /**
     * Takes a Camera and returns a Vector2 containing the translated position of this Pointer
     * within that Camera. This can be used to convert this Pointers position into camera space.
     *
     * @method Phaser.Input.Pointer#positionToCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the translation.
     * @param {(Phaser.Math.Vector2|object)} [output] - A Vector2-like object in which to store the translated position.
     *
     * @return {(Phaser.Math.Vector2|object)} A Vector2 containing the translated coordinates of this Pointer, based on the given camera.
     */ positionToCamera: function(camera, output) {
                    return camera.getWorldPoint(this.x, this.y, output);
                },
                /**
     * Calculates the motion of this Pointer, including its velocity and angle of movement.
     * This method is called automatically each frame by the Input Manager.
     *
     * @method Phaser.Input.Pointer#updateMotion
     * @private
     * @since 3.16.0
     */ updateMotion: function() {
                    var cx = this.position.x;
                    var cy = this.position.y;
                    var mx = this.midPoint.x;
                    var my = this.midPoint.y;
                    if (cx === mx && cy === my) //  Nothing to do here
                    return;
                    //  Moving towards our goal ...
                    var vx = SmoothStepInterpolation(this.motionFactor, mx, cx);
                    var vy = SmoothStepInterpolation(this.motionFactor, my, cy);
                    if (FuzzyEqual(vx, cx, 0.1)) vx = cx;
                    if (FuzzyEqual(vy, cy, 0.1)) vy = cy;
                    this.midPoint.set(vx, vy);
                    var dx = cx - vx;
                    var dy = cy - vy;
                    this.velocity.set(dx, dy);
                    this.angle = Angle(vx, vy, cx, cy);
                    this.distance = Math.sqrt(dx * dx + dy * dy);
                },
                /**
     * Internal method to handle a Mouse Up Event.
     *
     * @method Phaser.Input.Pointer#up
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ up: function(event) {
                    if ("buttons" in event) this.buttons = event.buttons;
                    this.event = event;
                    this.button = event.button;
                    this.upElement = event.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    //  0: Main button pressed, usually the left button or the un-initialized state
                    if (event.button === 0) {
                        this.primaryDown = false;
                        this.upX = this.x;
                        this.upY = this.y;
                    }
                    if (this.buttons === 0) {
                        //  No more buttons are still down
                        this.isDown = false;
                        this.upTime = event.timeStamp;
                        this.wasTouch = false;
                    }
                },
                /**
     * Internal method to handle a Mouse Down Event.
     *
     * @method Phaser.Input.Pointer#down
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ down: function(event) {
                    if ("buttons" in event) this.buttons = event.buttons;
                    this.event = event;
                    this.button = event.button;
                    this.downElement = event.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    //  0: Main button pressed, usually the left button or the un-initialized state
                    if (event.button === 0) {
                        this.primaryDown = true;
                        this.downX = this.x;
                        this.downY = this.y;
                    }
                    if (OS.macOS && event.ctrlKey) {
                        //  Override button settings on macOS
                        this.buttons = 2;
                        this.primaryDown = false;
                    }
                    if (!this.isDown) {
                        this.isDown = true;
                        this.downTime = event.timeStamp;
                    }
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Mouse Move Event.
     *
     * @method Phaser.Input.Pointer#move
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ move: function(event) {
                    if ("buttons" in event) this.buttons = event.buttons;
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, true);
                    if (this.locked) {
                        //  Multiple DOM events may occur within one frame, but only one Phaser event will fire
                        this.movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
                        this.movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
                    }
                    this.moveTime = event.timeStamp;
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Mouse Wheel Event.
     *
     * @method Phaser.Input.Pointer#wheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The Wheel Event to process.
     */ wheel: function(event) {
                    if ("buttons" in event) this.buttons = event.buttons;
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    this.deltaX = event.deltaX;
                    this.deltaY = event.deltaY;
                    this.deltaZ = event.deltaZ;
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Touch Start Event.
     *
     * @method Phaser.Input.Pointer#touchstart
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchstart: function(touch, event) {
                    if (touch["pointerId"]) this.pointerId = touch.pointerId;
                    this.identifier = touch.identifier;
                    this.target = touch.target;
                    this.active = true;
                    this.buttons = 1;
                    this.event = event;
                    this.downElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = true;
                    this.downX = this.x;
                    this.downY = this.y;
                    this.downTime = event.timeStamp;
                    this.isDown = true;
                    this.wasTouch = true;
                    this.wasCanceled = false;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch Move Event.
     *
     * @method Phaser.Input.Pointer#touchmove
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchmove: function(touch, event) {
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, true);
                    this.moveTime = event.timeStamp;
                    this.wasTouch = true;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch End Event.
     *
     * @method Phaser.Input.Pointer#touchend
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchend: function(touch, event) {
                    this.buttons = 0;
                    this.event = event;
                    this.upElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = false;
                    this.upX = this.x;
                    this.upY = this.y;
                    this.upTime = event.timeStamp;
                    this.isDown = false;
                    this.wasTouch = true;
                    this.wasCanceled = false;
                    this.active = false;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch Cancel Event.
     *
     * @method Phaser.Input.Pointer#touchcancel
     * @private
     * @since 3.15.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchcancel: function(touch, event) {
                    this.buttons = 0;
                    this.event = event;
                    this.upElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = false;
                    this.upX = this.x;
                    this.upY = this.y;
                    this.upTime = event.timeStamp;
                    this.isDown = false;
                    this.wasTouch = true;
                    this.wasCanceled = true;
                    this.active = false;
                },
                /**
     * Checks to see if any buttons are being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#noButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if no buttons are being held down.
     */ noButtonDown: function() {
                    return this.buttons === 0;
                },
                /**
     * Checks to see if the left button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the left button is being held down.
     */ leftButtonDown: function() {
                    return this.buttons & 1 ? true : false;
                },
                /**
     * Checks to see if the right button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the right button is being held down.
     */ rightButtonDown: function() {
                    return this.buttons & 2 ? true : false;
                },
                /**
     * Checks to see if the middle button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the middle button is being held down.
     */ middleButtonDown: function() {
                    return this.buttons & 4 ? true : false;
                },
                /**
     * Checks to see if the back button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the back button is being held down.
     */ backButtonDown: function() {
                    return this.buttons & 8 ? true : false;
                },
                /**
     * Checks to see if the forward button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the forward button is being held down.
     */ forwardButtonDown: function() {
                    return this.buttons & 16 ? true : false;
                },
                /**
     * Checks to see if the left button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the left button was just released.
     */ leftButtonReleased: function() {
                    return this.button === 0 && !this.isDown;
                },
                /**
     * Checks to see if the right button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the right button was just released.
     */ rightButtonReleased: function() {
                    return this.button === 2 && !this.isDown;
                },
                /**
     * Checks to see if the middle button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the middle button was just released.
     */ middleButtonReleased: function() {
                    return this.button === 1 && !this.isDown;
                },
                /**
     * Checks to see if the back button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the back button was just released.
     */ backButtonReleased: function() {
                    return this.button === 3 && !this.isDown;
                },
                /**
     * Checks to see if the forward button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the forward button was just released.
     */ forwardButtonReleased: function() {
                    return this.button === 4 && !this.isDown;
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded distance, based on where
     * the Pointer was when the button was released.
     *
     * If you wish to get the distance being travelled currently, based on the velocity of the Pointer,
     * then see the `Pointer.distance` property.
     *
     * @method Phaser.Input.Pointer#getDistance
     * @since 3.13.0
     *
     * @return {number} The distance the Pointer moved.
     */ getDistance: function() {
                    if (this.isDown) return Distance(this.downX, this.downY, this.x, this.y);
                    else return Distance(this.downX, this.downY, this.upX, this.upY);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * horizontal distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded horizontal distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceX
     * @since 3.16.0
     *
     * @return {number} The horizontal distance the Pointer moved.
     */ getDistanceX: function() {
                    if (this.isDown) return Math.abs(this.downX - this.x);
                    else return Math.abs(this.downX - this.upX);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * vertical distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded vertical distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceY
     * @since 3.16.0
     *
     * @return {number} The vertical distance the Pointer moved.
     */ getDistanceY: function() {
                    if (this.isDown) return Math.abs(this.downY - this.y);
                    else return Math.abs(this.downY - this.upY);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * duration since the button was pressed down.
     *
     * If no button is held down, it will return the last recorded duration, based on the time
     * the last button on the Pointer was released.
     *
     * @method Phaser.Input.Pointer#getDuration
     * @since 3.16.0
     *
     * @return {number} The duration the Pointer was held down for in milliseconds.
     */ getDuration: function() {
                    if (this.isDown) return this.manager.time - this.downTime;
                    else return this.upTime - this.downTime;
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * angle between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded angle, based on where
     * the Pointer was when the button was released.
     *
     * The angle is based on the old position facing to the current position.
     *
     * If you wish to get the current angle, based on the velocity of the Pointer, then
     * see the `Pointer.angle` property.
     *
     * @method Phaser.Input.Pointer#getAngle
     * @since 3.16.0
     *
     * @return {number} The angle between the Pointer's coordinates in radians.
     */ getAngle: function() {
                    if (this.isDown) return Angle(this.downX, this.downY, this.x, this.y);
                    else return Angle(this.downX, this.downY, this.upX, this.upY);
                },
                /**
     * Takes the previous and current Pointer positions and then generates an array of interpolated values between
     * the two. The array will be populated up to the size of the `steps` argument.
     *
     * ```javaScript
     * var points = pointer.getInterpolatedPosition(4);
     *
     * // points[0] = { x: 0, y: 0 }
     * // points[1] = { x: 2, y: 1 }
     * // points[2] = { x: 3, y: 2 }
     * // points[3] = { x: 6, y: 3 }
     * ```
     *
     * Use this if you need to get smoothed values between the previous and current pointer positions. DOM pointer
     * events can often fire faster than the main browser loop, and this will help you avoid janky movement
     * especially if you have an object following a Pointer.
     *
     * Note that if you provide an output array it will only be populated up to the number of steps provided.
     * It will not clear any previous data that may have existed beyond the range of the steps count.
     *
     * Internally it uses the Smooth Step interpolation calculation.
     *
     * @method Phaser.Input.Pointer#getInterpolatedPosition
     * @since 3.11.0
     *
     * @param {number} [steps=10] - The number of interpolation steps to use.
     * @param {array} [out] - An array to store the results in. If not provided a new one will be created.
     *
     * @return {array} An array of interpolated values.
     */ getInterpolatedPosition: function(steps, out) {
                    if (steps === undefined) steps = 10;
                    if (out === undefined) out = [];
                    var prevX = this.prevPosition.x;
                    var prevY = this.prevPosition.y;
                    var curX = this.position.x;
                    var curY = this.position.y;
                    for(var i = 0; i < steps; i++){
                        var t = 1 / steps * i;
                        out[i] = {
                            x: SmoothStepInterpolation(t, prevX, curX),
                            y: SmoothStepInterpolation(t, prevY, curY)
                        };
                    }
                    return out;
                },
                /**
     * Destroys this Pointer instance and resets its external references.
     *
     * @method Phaser.Input.Pointer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.manager = null;
                    this.position = null;
                },
                /**
     * The x position of this Pointer.
     * The value is in screen space.
     * See `worldX` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.position.x = value;
                    }
                },
                /**
     * The y position of this Pointer.
     * The value is in screen space.
     * See `worldY` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.position.y = value;
                    }
                },
                /**
     * Time when this Pointer was most recently updated by a DOM Event.
     * This comes directly from the `event.timeStamp` property.
     * If no event has yet taken place, it will return zero.
     *
     * @name Phaser.Input.Pointer#time
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ time: {
                    get: function() {
                        return this.event ? this.event.timeStamp : 0;
                    }
                }
            });
            module1.exports = Pointer;
        /***/ },
        /* 413 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var InputEvents = __webpack_require__(51);
            var NOOP = __webpack_require__(1);
            // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
            // https://patrickhlauke.github.io/touch/tests/results/
            // https://www.html5rocks.com/en/mobile/touch/
            /**
 * @classdesc
 * The Touch Manager is a helper class that belongs to the Input Manager.
 * 
 * Its role is to listen for native DOM Touch Events and then pass them onto the Input Manager for further processing.
 * 
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class TouchManager
 * @memberof Phaser.Input.Touch
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var TouchManager = new Class({
                initialize: function TouchManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Touch.TouchManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                    /**
         * If true the DOM events will have event.preventDefault applied to them, if false they will propagate fully.
         *
         * @name Phaser.Input.Touch.TouchManager#capture
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.capture = true;
                    /**
         * A boolean that controls if the Touch Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Touch.TouchManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                    /**
         * The Touch Event target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Touch.TouchManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                    /**
         * The Touch Start event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStart
         * @type {function}
         * @since 3.0.0
         */ this.onTouchStart = NOOP;
                    /**
         * The Touch Start event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStartWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchStartWindow = NOOP;
                    /**
         * The Touch Move event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchMove
         * @type {function}
         * @since 3.0.0
         */ this.onTouchMove = NOOP;
                    /**
         * The Touch End event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEnd
         * @type {function}
         * @since 3.0.0
         */ this.onTouchEnd = NOOP;
                    /**
         * The Touch End event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEndWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchEndWindow = NOOP;
                    /**
         * The Touch Cancel event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancel
         * @type {function}
         * @since 3.15.0
         */ this.onTouchCancel = NOOP;
                    /**
         * The Touch Cancel event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancelWindow
         * @type {function}
         * @since 3.18.0
         */ this.onTouchCancelWindow = NOOP;
                    /**
         * The Touch Over event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchOver
         * @type {function}
         * @since 3.16.0
         */ this.onTouchOver = NOOP;
                    /**
         * The Touch Out event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchOut
         * @type {function}
         * @since 3.16.0
         */ this.onTouchOut = NOOP;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Touch.TouchManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputTouch;
                    this.target = config.inputTouchEventTarget;
                    this.capture = config.inputTouchCapture;
                    if (!this.target) this.target = this.manager.game.canvas;
                    if (config.disableContextMenu) this.disableContextMenu();
                    if (this.enabled && this.target) this.startListeners();
                },
                /**
     * Attempts to disable the context menu from appearing if you touch-hold on the browser.
     * 
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     * 
     * Use this if you need to disable the OS context menu on mobile.
     *
     * @method Phaser.Input.Touch.TouchManager#disableContextMenu
     * @since 3.20.0
     *
     * @return {this} This Touch Manager instance.
     */ disableContextMenu: function() {
                    document.body.addEventListener("contextmenu", function(event) {
                        event.preventDefault();
                        return false;
                    });
                    return this;
                },
                /**
     * Starts the Touch Event listeners running as long as an input target is set.
     * 
     * This method is called automatically if Touch Input is enabled in the game config,
     * which it is by default. However, you can call it manually should you need to
     * delay input capturing until later in the game.
     *
     * @method Phaser.Input.Touch.TouchManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                    var _this = this;
                    var canvas = this.manager.canvas;
                    var autoFocus = window && window.focus && this.manager.game.config.autoFocus;
                    this.onTouchStart = function(event) {
                        if (autoFocus) window.focus();
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchStart(event);
                            if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onTouchStartWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        _this.manager.onTouchStart(event);
                    };
                    this.onTouchMove = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchMove(event);
                            if (_this.capture && event.cancelable) event.preventDefault();
                        }
                    };
                    this.onTouchEnd = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchEnd(event);
                            if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onTouchEndWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        _this.manager.onTouchEnd(event);
                    };
                    this.onTouchCancel = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchCancel(event);
                            if (_this.capture) event.preventDefault();
                        }
                    };
                    this.onTouchCancelWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.onTouchCancel(event);
                    };
                    this.onTouchOver = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.setCanvasOver(event);
                    };
                    this.onTouchOut = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.setCanvasOut(event);
                    };
                    var target = this.target;
                    if (!target) return;
                    var passive = {
                        passive: true
                    };
                    var nonPassive = {
                        passive: false
                    };
                    target.addEventListener("touchstart", this.onTouchStart, this.capture ? nonPassive : passive);
                    target.addEventListener("touchmove", this.onTouchMove, this.capture ? nonPassive : passive);
                    target.addEventListener("touchend", this.onTouchEnd, this.capture ? nonPassive : passive);
                    target.addEventListener("touchcancel", this.onTouchCancel, this.capture ? nonPassive : passive);
                    target.addEventListener("touchover", this.onTouchOver, this.capture ? nonPassive : passive);
                    target.addEventListener("touchout", this.onTouchOut, this.capture ? nonPassive : passive);
                    if (window && this.manager.game.config.inputWindowEvents) {
                        window.addEventListener("touchstart", this.onTouchStartWindow, nonPassive);
                        window.addEventListener("touchend", this.onTouchEndWindow, nonPassive);
                        window.addEventListener("touchcancel", this.onTouchCancelWindow, nonPassive);
                    }
                    this.enabled = true;
                },
                /**
     * Stops the Touch Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Touch.TouchManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener("touchstart", this.onTouchStart);
                    target.removeEventListener("touchmove", this.onTouchMove);
                    target.removeEventListener("touchend", this.onTouchEnd);
                    target.removeEventListener("touchcancel", this.onTouchCancel);
                    target.removeEventListener("touchover", this.onTouchOver);
                    target.removeEventListener("touchout", this.onTouchOut);
                    if (window) {
                        window.removeEventListener("touchstart", this.onTouchStartWindow);
                        window.removeEventListener("touchend", this.onTouchEndWindow);
                    }
                },
                /**
     * Destroys this Touch Manager instance.
     *
     * @method Phaser.Input.Touch.TouchManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stopListeners();
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = TouchManager;
        /***/ },
        /* 414 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var EventEmitter = __webpack_require__(9);
            var FileTypesManager = __webpack_require__(8);
            var GameObjectCreator = __webpack_require__(16);
            var GameObjectFactory = __webpack_require__(5);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var Remove = __webpack_require__(93);
            /**
 * @classdesc
 * The PluginManager is responsible for installing and adding plugins to Phaser.
 *
 * It is a global system and therefore belongs to the Game instance, not a specific Scene.
 *
 * It works in conjunction with the PluginCache. Core internal plugins automatically register themselves
 * with the Cache, but it's the Plugin Manager that is responsible for injecting them into the Scenes.
 *
 * There are two types of plugin:
 *
 * 1. A Global Plugin
 * 2. A Scene Plugin
 *
 * A Global Plugin is a plugin that lives within the Plugin Manager rather than a Scene. You can get
 * access to it by calling `PluginManager.get` and providing a key. Any Scene that requests a plugin in
 * this way will all get access to the same plugin instance, allowing you to use a single plugin across
 * multiple Scenes.
 *
 * A Scene Plugin is a plugin dedicated to running within a Scene. These are different to Global Plugins
 * in that their instances do not live within the Plugin Manager, but within the Scene Systems class instead.
 * And that every Scene created is given its own unique instance of a Scene Plugin. Examples of core Scene
 * Plugins include the Input Plugin, the Tween Plugin and the physics Plugins.
 *
 * You can add a plugin to Phaser in three different ways:
 *
 * 1. Preload it
 * 2. Include it in your source code and install it via the Game Config
 * 3. Include it in your source code and install it within a Scene
 *
 * For examples of all of these approaches please see the Phaser 3 Examples Repo `plugins` folder.
 *
 * For information on creating your own plugin please see the Phaser 3 Plugin Template.
 *
 * @class PluginManager
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The game instance that owns this Plugin Manager.
 */ var PluginManager = new Class({
                Extends: EventEmitter,
                initialize: function PluginManager(game) {
                    EventEmitter.call(this);
                    /**
         * The game instance that owns this Plugin Manager.
         *
         * @name Phaser.Plugins.PluginManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The global plugins currently running and managed by this Plugin Manager.
         * A plugin must have been started at least once in order to appear in this list.
         *
         * @name Phaser.Plugins.PluginManager#plugins
         * @type {Phaser.Types.Plugins.GlobalPlugin[]}
         * @since 3.8.0
         */ this.plugins = [];
                    /**
         * A list of plugin keys that should be installed into Scenes as well as the Core Plugins.
         *
         * @name Phaser.Plugins.PluginManager#scenePlugins
         * @type {string[]}
         * @since 3.8.0
         */ this.scenePlugins = [];
                    /**
         * A temporary list of plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingGlobal
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingGlobal = [];
                    /**
         * A temporary list of scene plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingScene
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingScene = [];
                    if (game.isBooted) this.boot();
                    else game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * Run once the game has booted and installs all of the plugins configured in the Game Config.
     *
     * @method Phaser.Plugins.PluginManager#boot
     * @protected
     * @since 3.0.0
     */ boot: function() {
                    var i;
                    var entry;
                    var key;
                    var plugin;
                    var start;
                    var mapping;
                    var data;
                    var config = this.game.config;
                    //  Any plugins to install?
                    var list = config.installGlobalPlugins;
                    //  Any plugins added outside of the game config, but before the game booted?
                    list = list.concat(this._pendingGlobal);
                    for(i = 0; i < list.length; i++){
                        entry = list[i];
                        // { key: 'TestPlugin', plugin: TestPlugin, start: true, mapping: 'test', data: { msg: 'The plugin is alive' } }
                        key = GetFastValue(entry, "key", null);
                        plugin = GetFastValue(entry, "plugin", null);
                        start = GetFastValue(entry, "start", false);
                        mapping = GetFastValue(entry, "mapping", null);
                        data = GetFastValue(entry, "data", null);
                        if (key) {
                            if (plugin) this.install(key, plugin, start, mapping, data);
                            else console.warn("Missing `plugin` for key: " + key);
                        }
                    }
                    //  Any scene plugins to install?
                    list = config.installScenePlugins;
                    //  Any plugins added outside of the game config, but before the game booted?
                    list = list.concat(this._pendingScene);
                    for(i = 0; i < list.length; i++){
                        entry = list[i];
                        // { key: 'moveSpritePlugin', plugin: MoveSpritePlugin, , mapping: 'move' }
                        key = GetFastValue(entry, "key", null);
                        plugin = GetFastValue(entry, "plugin", null);
                        mapping = GetFastValue(entry, "mapping", null);
                        if (key) {
                            if (plugin) this.installScenePlugin(key, plugin, mapping);
                            else console.warn("Missing `plugin` for key: " + key);
                        }
                    }
                    this._pendingGlobal = [];
                    this._pendingScene = [];
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Called by the Scene Systems class. Tells the plugin manager to install all Scene plugins into it.
     *
     * First it will install global references, i.e. references from the Game systems into the Scene Systems (and Scene if mapped.)
     * Then it will install Core Scene Plugins followed by Scene Plugins registered with the PluginManager.
     * Finally it will install any references to Global Plugins that have a Scene mapping property into the Scene itself.
     *
     * @method Phaser.Plugins.PluginManager#addToScene
     * @protected
     * @since 3.8.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems class to install all the plugins in to.
     * @param {array} globalPlugins - An array of global plugins to install.
     * @param {array} scenePlugins - An array of scene plugins to install.
     */ addToScene: function(sys, globalPlugins, scenePlugins) {
                    var i;
                    var pluginKey;
                    var pluginList;
                    var game = this.game;
                    var scene = sys.scene;
                    var map = sys.settings.map;
                    var isBooted = sys.settings.isBooted;
                    //  Reference the GlobalPlugins from Game into Scene.Systems
                    for(i = 0; i < globalPlugins.length; i++){
                        pluginKey = globalPlugins[i];
                        if (game[pluginKey]) {
                            sys[pluginKey] = game[pluginKey];
                            //  Scene level injection
                            if (map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = sys[pluginKey];
                        } else if (pluginKey === "game" && map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = game;
                    }
                    for(var s = 0; s < scenePlugins.length; s++){
                        pluginList = scenePlugins[s];
                        for(i = 0; i < pluginList.length; i++){
                            pluginKey = pluginList[i];
                            if (!PluginCache.hasCore(pluginKey)) continue;
                            var source = PluginCache.getCore(pluginKey);
                            var mapKey = source.mapping;
                            var plugin = new source.plugin(scene, this, mapKey);
                            sys[mapKey] = plugin;
                            //  Scene level injection
                            if (source.custom) scene[mapKey] = plugin;
                            else if (map.hasOwnProperty(mapKey)) scene[map[mapKey]] = plugin;
                            //  Scene is already booted, usually because this method is being called at run-time, so boot the plugin
                            if (isBooted) plugin.boot();
                        }
                    }
                    //  And finally, inject any 'global scene plugins'
                    pluginList = this.plugins;
                    for(i = 0; i < pluginList.length; i++){
                        var entry = pluginList[i];
                        if (entry.mapping) scene[entry.mapping] = entry.plugin;
                    }
                },
                /**
     * Called by the Scene Systems class. Returns a list of plugins to be installed.
     *
     * @method Phaser.Plugins.PluginManager#getDefaultScenePlugins
     * @protected
     * @since 3.8.0
     *
     * @return {string[]} A list keys of all the Scene Plugins to install.
     */ getDefaultScenePlugins: function() {
                    var list = this.game.config.defaultPlugins;
                    //  Merge in custom Scene plugins
                    list = list.concat(this.scenePlugins);
                    return list;
                },
                /**
     * Installs a new Scene Plugin into the Plugin Manager and optionally adds it
     * to the given Scene as well. A Scene Plugin added to the manager in this way
     * will be automatically installed into all new Scenes using the key and mapping given.
     *
     * The `key` property is what the plugin is injected into Scene.Systems as.
     * The `mapping` property is optional, and if specified is what the plugin is installed into
     * the Scene as. For example:
     *
     * ```javascript
     * this.plugins.installScenePlugin('powerupsPlugin', pluginCode, 'powerups');
     *
     * // and from within the scene:
     * this.sys.powerupsPlugin; // key value
     * this.powerups; // mapping value
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * @method Phaser.Plugins.PluginManager#installScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The property key that will be used to add this plugin to Scene.Systems.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {Phaser.Scene} [addToScene] - Optionally automatically add this plugin to the given Scene.
     * @param {boolean} [fromLoader=false] - Is this being called by the Loader?
     */ installScenePlugin: function(key, plugin, mapping, addToScene, fromLoader) {
                    if (fromLoader === undefined) fromLoader = false;
                    if (typeof plugin !== "function") {
                        console.warn("Invalid Scene Plugin: " + key);
                        return;
                    }
                    if (!PluginCache.hasCore(key)) {
                        //  Plugin is freshly loaded
                        PluginCache.register(key, plugin, mapping, true);
                        this.scenePlugins.push(key);
                    } else if (!fromLoader && PluginCache.hasCore(key)) {
                        //  Plugin wasn't from the loader but already exists
                        console.warn("Scene Plugin key in use: " + key);
                        return;
                    }
                    if (addToScene) {
                        var instance = new plugin(addToScene, this, key);
                        addToScene.sys[key] = instance;
                        if (mapping && mapping !== "") addToScene[mapping] = instance;
                        instance.boot();
                    }
                },
                /**
     * Installs a new Global Plugin into the Plugin Manager and optionally starts it running.
     * A global plugin belongs to the Plugin Manager, rather than a specific Scene, and can be accessed
     * and used by all Scenes in your game.
     *
     * The `key` property is what you use to access this plugin from the Plugin Manager.
     *
     * ```javascript
     * this.plugins.install('powerupsPlugin', pluginCode);
     *
     * // and from within the scene:
     * this.plugins.get('powerupsPlugin');
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * The same plugin can be installed multiple times into the Plugin Manager by simply giving each
     * instance its own unique key.
     *
     * @method Phaser.Plugins.PluginManager#install
     * @since 3.8.0
     *
     * @param {string} key - The unique handle given to this plugin within the Plugin Manager.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {boolean} [start=false] - Automatically start the plugin running? This is always `true` if you provide a mapping value.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {any} [data] - A value passed to the plugin's `init` method.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if `start` was false, or game isn't yet booted.
     */ install: function(key, plugin, start, mapping, data) {
                    if (start === undefined) start = false;
                    if (mapping === undefined) mapping = null;
                    if (data === undefined) data = null;
                    if (typeof plugin !== "function") {
                        console.warn("Invalid Plugin: " + key);
                        return null;
                    }
                    if (PluginCache.hasCustom(key)) {
                        console.warn("Plugin key in use: " + key);
                        return null;
                    }
                    if (mapping !== null) start = true;
                    if (!this.game.isBooted) this._pendingGlobal.push({
                        key: key,
                        plugin: plugin,
                        start: start,
                        mapping: mapping,
                        data: data
                    });
                    else {
                        //  Add it to the plugin store
                        PluginCache.registerCustom(key, plugin, mapping, data);
                        if (start) return this.start(key);
                    }
                    return null;
                },
                /**
     * Gets an index of a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getIndex
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {number} The index of the plugin within the plugins array.
     */ getIndex: function(key) {
                    var list = this.plugins;
                    for(var i = 0; i < list.length; i++){
                        var entry = list[i];
                        if (entry.key === key) return i;
                    }
                    return -1;
                },
                /**
     * Gets a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getEntry
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {Phaser.Types.Plugins.GlobalPlugin} The plugin entry.
     */ getEntry: function(key) {
                    var idx = this.getIndex(key);
                    if (idx !== -1) return this.plugins[idx];
                },
                /**
     * Checks if the given global plugin, based on its key, is active or not.
     *
     * @method Phaser.Plugins.PluginManager#isActive
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {boolean} `true` if the plugin is active, otherwise `false`.
     */ isActive: function(key) {
                    var entry = this.getEntry(key);
                    return entry && entry.active;
                },
                /**
     * Starts a global plugin running.
     *
     * If the plugin was previously active then calling `start` will reset it to an active state and then
     * call its `start` method.
     *
     * If the plugin has never been run before a new instance of it will be created within the Plugin Manager,
     * its active state set and then both of its `init` and `start` methods called, in that order.
     *
     * If the plugin is already running under the given key then nothing happens.
     *
     * @method Phaser.Plugins.PluginManager#start
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to start.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given or plugin is already stopped.
     */ start: function(key, runAs) {
                    if (runAs === undefined) runAs = key;
                    var entry = this.getEntry(runAs);
                    //  Plugin already running under this key?
                    if (entry && !entry.active) {
                        //  It exists, we just need to start it up again
                        entry.active = true;
                        entry.plugin.start();
                    } else if (!entry) entry = this.createEntry(key, runAs);
                    return entry ? entry.plugin : null;
                },
                /**
     * Creates a new instance of a global plugin, adds an entry into the plugins array and returns it.
     *
     * @method Phaser.Plugins.PluginManager#createEntry
     * @private
     * @since 3.9.0
     *
     * @param {string} key - The key of the plugin to create an instance of.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given.
     */ createEntry: function(key, runAs) {
                    var entry = PluginCache.getCustom(key);
                    if (entry) {
                        var instance = new entry.plugin(this);
                        entry = {
                            key: runAs,
                            plugin: instance,
                            active: true,
                            mapping: entry.mapping,
                            data: entry.data
                        };
                        this.plugins.push(entry);
                        instance.init(entry.data);
                        instance.start();
                    }
                    return entry;
                },
                /**
     * Stops a global plugin from running.
     *
     * If the plugin is active then its active state will be set to false and the plugins `stop` method
     * will be called.
     *
     * If the plugin is not already running, nothing will happen.
     *
     * @method Phaser.Plugins.PluginManager#stop
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to stop.
     *
     * @return {this} The Plugin Manager.
     */ stop: function(key) {
                    var entry = this.getEntry(key);
                    if (entry && entry.active) {
                        entry.active = false;
                        entry.plugin.stop();
                    }
                    return this;
                },
                /**
     * Gets a global plugin from the Plugin Manager based on the given key and returns it.
     *
     * If it cannot find an active plugin based on the key, but there is one in the Plugin Cache with the same key,
     * then it will create a new instance of the cached plugin and return that.
     *
     * @method Phaser.Plugins.PluginManager#get
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     * @param {boolean} [autoStart=true] - Automatically start a new instance of the plugin if found in the cache, but not actively running.
     *
     * @return {?(Phaser.Plugins.BasePlugin|function)} The plugin, or `null` if no plugin was found matching the key.
     */ get: function(key, autoStart) {
                    if (autoStart === undefined) autoStart = true;
                    var entry = this.getEntry(key);
                    if (entry) return entry.plugin;
                    else {
                        var plugin = this.getClass(key);
                        if (plugin && autoStart) {
                            entry = this.createEntry(key, key);
                            return entry ? entry.plugin : null;
                        } else if (plugin) return plugin;
                    }
                    return null;
                },
                /**
     * Returns the plugin class from the cache.
     * Used internally by the Plugin Manager.
     *
     * @method Phaser.Plugins.PluginManager#getClass
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     *
     * @return {Phaser.Plugins.BasePlugin} A Plugin object
     */ getClass: function(key) {
                    return PluginCache.getCustomClass(key);
                },
                /**
     * Removes a global plugin from the Plugin Manager and Plugin Cache.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeGlobalPlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeGlobalPlugin: function(key) {
                    var entry = this.getEntry(key);
                    if (entry) Remove(this.plugins, entry);
                    PluginCache.removeCustom(key);
                },
                /**
     * Removes a scene plugin from the Plugin Manager and Plugin Cache.
     *
     * This will not remove the plugin from any active Scenes that are already using it.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeScenePlugin: function(key) {
                    Remove(this.scenePlugins, key);
                    PluginCache.remove(key);
                },
                /**
     * Registers a new type of Game Object with the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new Game Objects.
     *
     * The key is the property that will be injected into the factories and used to create the
     * Game Object. For example:
     *
     * ```javascript
     * this.plugins.registerGameObject('clown', clownFactoryCallback, clownCreatorCallback);
     * // later in your game code:
     * this.add.clown();
     * this.make.clown();
     * ```
     *
     * The callbacks are what are called when the factories try to create a Game Object
     * matching the given key. It's important to understand that the callbacks are invoked within
     * the context of the GameObjectFactory. In this context there are several properties available
     * to use:
     *
     * this.scene - A reference to the Scene that owns the GameObjectFactory.
     * this.displayList - A reference to the Display List the Scene owns.
     * this.updateList - A reference to the Update List the Scene owns.
     *
     * See the GameObjectFactory and GameObjectCreator classes for more details.
     * Any public property or method listed is available from your callbacks under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerGameObject
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} [factoryCallback] - The callback to invoke when the Game Object Factory is called.
     * @param {function} [creatorCallback] - The callback to invoke when the Game Object Creator is called.
     */ registerGameObject: function(key, factoryCallback, creatorCallback) {
                    if (factoryCallback) GameObjectFactory.register(key, factoryCallback);
                    if (creatorCallback) GameObjectCreator.register(key, creatorCallback);
                    return this;
                },
                /**
     * Removes a previously registered Game Object from the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin destruction code to help clean-up after your plugin has been removed.
     *
     * @method Phaser.Plugins.PluginManager#removeGameObject
     * @since 3.19.0
     *
     * @param {string} key - The key of the Game Object to be removed from the factories.
     * @param {boolean} [removeFromFactory=true] - Should the Game Object be removed from the Game Object Factory?
     * @param {boolean} [removeFromCreator=true] - Should the Game Object be removed from the Game Object Creator?
     */ removeGameObject: function(key, removeFromFactory, removeFromCreator) {
                    if (removeFromFactory === undefined) removeFromFactory = true;
                    if (removeFromCreator === undefined) removeFromCreator = true;
                    if (removeFromFactory) GameObjectFactory.remove(key);
                    if (removeFromCreator) GameObjectCreator.remove(key);
                    return this;
                },
                /**
     * Registers a new file type with the global File Types Manager, making it available to all Loader
     * Plugins created after this.
     *
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new loader file types.
     *
     * The key is the property that will be injected into the Loader Plugin and used to load the
     * files. For example:
     *
     * ```javascript
     * this.plugins.registerFileType('wad', doomWadLoaderCallback);
     * // later in your preload code:
     * this.load.wad();
     * ```
     *
     * The callback is what is called when the loader tries to load a file  matching the given key.
     * It's important to understand that the callback is invoked within
     * the context of the LoaderPlugin. In this context there are several properties / methods available
     * to use:
     *
     * this.addFile - A method to add the new file to the load queue.
     * this.scene - The Scene that owns the Loader Plugin instance.
     *
     * See the LoaderPlugin class for more details. Any public property or method listed is available from
     * your callback under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerFileType
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} callback - The callback to invoke when the Game Object Factory is called.
     * @param {Phaser.Scene} [addToScene] - Optionally add this file type into the Loader Plugin owned by the given Scene.
     */ registerFileType: function(key, callback, addToScene) {
                    FileTypesManager.register(key, callback);
                    if (addToScene && addToScene.sys.load) addToScene.sys.load[key] = callback;
                },
                /**
     * Destroys this Plugin Manager and all associated plugins.
     * It will iterate all plugins found and call their `destroy` methods.
     *
     * The PluginCache will remove all custom plugins.
     *
     * @method Phaser.Plugins.PluginManager#destroy
     * @since 3.8.0
     */ destroy: function() {
                    for(var i = 0; i < this.plugins.length; i++)this.plugins[i].plugin.destroy();
                    PluginCache.destroyCustomPlugins();
                    if (this.game.noReturn) PluginCache.destroyCorePlugins();
                    this.game = null;
                    this.plugins = [];
                    this.scenePlugins = [];
                }
            });
            /*
 * "Sometimes, the elegant implementation is just a function.
 * Not a method. Not a class. Not a framework. Just a function."
 *  -- John Carmack
 */ module1.exports = PluginManager;
        /***/ },
        /* 415 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(201);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(104);
            var GameEvents = __webpack_require__(22);
            var GetInnerHeight = __webpack_require__(401);
            var GetTarget = __webpack_require__(407);
            var GetScreenOrientation = __webpack_require__(402);
            var NOOP = __webpack_require__(1);
            var Rectangle = __webpack_require__(10);
            var Size = __webpack_require__(416);
            var SnapFloor = __webpack_require__(76);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * The Scale Manager handles the scaling, resizing and alignment of the game canvas.
 *
 * The way scaling is handled is by setting the game canvas to a fixed size, which is defined in the
 * game configuration. You also define the parent container in the game config. If no parent is given,
 * it will default to using the document body. The Scale Manager will then look at the available space
 * within the _parent_ and scale the canvas accordingly. Scaling is handled by setting the canvas CSS
 * width and height properties, leaving the width and height of the canvas element itself untouched.
 * Scaling is therefore achieved by keeping the core canvas the same size and 'stretching'
 * it via its CSS properties. This gives the same result and speed as using the `transform-scale` CSS
 * property, without the need for browser prefix handling.
 *
 * The calculations for the scale are heavily influenced by the bounding parent size, which is the computed
 * dimensions of the canvas's parent. The CSS rules of the parent element play an important role in the
 * operation of the Scale Manager. For example, if the parent has no defined width or height, then actions
 * like auto-centering will fail to achieve the required result. The Scale Manager works in tandem with the
 * CSS you set-up on the page hosting your game, rather than taking control of it.
 *
 * #### Parent and Display canvas containment guidelines:
 *
 * - Style the Parent element (of the game canvas) to control the Parent size and thus the games size and layout.
 *
 * - The Parent element's CSS styles should _effectively_ apply maximum (and minimum) bounding behavior.
 *
 * - The Parent element should _not_ apply a padding as this is not accounted for.
 *   If a padding is required apply it to the Parent's parent or apply a margin to the Parent.
 *   If you need to add a border, margin or any other CSS around your game container, then use a parent element and
 *   apply the CSS to this instead, otherwise you'll be constantly resizing the shape of the game container.
 *
 * - The Display canvas layout CSS styles (i.e. margins, size) should not be altered / specified as
 *   they may be updated by the Scale Manager.
 *
 * #### Scale Modes
 *
 * The way the scaling is handled is determined by the `scaleMode` property. The default is `NONE`,
 * which prevents Phaser from scaling or touching the canvas, or its parent, at all. In this mode, you are
 * responsible for all scaling. The other scaling modes afford you automatic scaling.
 *
 * If you wish to scale your game so that it always fits into the available space within the parent, you
 * should use the scale mode `FIT`. Look at the documentation for other scale modes to see what options are
 * available. Here is a basic config showing how to set this scale mode:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     mode: Phaser.Scale.FIT,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * Place the `scale` config object within your game config.
 *
 * If you wish for the canvas to be resized directly, so that the canvas itself fills the available space
 * (i.e. it isn't scaled, it's resized) then use the `RESIZE` scale mode. This will give you a 1:1 mapping
 * of canvas pixels to game size. In this mode CSS isn't used to scale the canvas, it's literally adjusted
 * to fill all available space within the parent. You should be extremely careful about the size of the
 * canvas you're creating when doing this, as the larger the area, the more work the GPU has to do and it's
 * very easy to hit fill-rate limits quickly.
 *
 * For complex, custom-scaling requirements, you should probably consider using the `RESIZE` scale mode,
 * with your own limitations in place re: canvas dimensions and managing the scaling with the game scenes
 * yourself. For the vast majority of games, however, the `FIT` mode is likely to be the most used.
 *
 * Please appreciate that the Scale Manager cannot perform miracles. All it does is scale your game canvas
 * as best it can, based on what it can infer from its surrounding area. There are all kinds of environments
 * where it's up to you to guide and help the canvas position itself, especially when built into rendering
 * frameworks like React and Vue. If your page requires meta tags to prevent user scaling gestures, or such
 * like, then it's up to you to ensure they are present in the html.
 *
 * #### Centering
 *
 * You can also have the game canvas automatically centered. Again, this relies heavily on the parent being
 * properly configured and styled, as the centering offsets are based entirely on the available space
 * within the parent element. Centering is disabled by default, or can be applied horizontally, vertically,
 * or both. Here's an example:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     autoCenter: Phaser.Scale.CENTER_BOTH,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * #### Fullscreen API
 *
 * If the browser supports it, you can send your game into fullscreen mode. In this mode, the game will fill
 * the entire display, removing all browser UI and anything else present on the screen. It will remain in this
 * mode until your game either disables it, or until the user tabs out or presses ESCape if on desktop. It's a
 * great way to achieve a desktop-game like experience from the browser, but it does require a modern browser
 * to handle it. Some mobile browsers also support this.
 *
 * @class ScaleManager
 * @memberof Phaser.Scale
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var ScaleManager = new Class({
                Extends: EventEmitter,
                initialize: function ScaleManager(game) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Scale.ScaleManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.15.0
         */ this.game = game;
                    /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         *
         * @name Phaser.Scale.ScaleManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.16.0
         */ this.canvas;
                    /**
         * The DOM bounds of the canvas element.
         *
         * @name Phaser.Scale.ScaleManager#canvasBounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.16.0
         */ this.canvasBounds = new Rectangle();
                    /**
         * The parent object of the Canvas. Often a div, or the browser window, or nothing in non-browser environments.
         *
         * This is set in the Game Config as the `parent` property. If undefined (or just not present), it will default
         * to use the document body. If specifically set to `null` Phaser will ignore all parent operations.
         *
         * @name Phaser.Scale.ScaleManager#parent
         * @type {?any}
         * @since 3.16.0
         */ this.parent = null;
                    /**
         * Is the parent element the browser window?
         *
         * @name Phaser.Scale.ScaleManager#parentIsWindow
         * @type {boolean}
         * @since 3.16.0
         */ this.parentIsWindow = false;
                    /**
         * The Parent Size component.
         *
         * @name Phaser.Scale.ScaleManager#parentSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.parentSize = new Size();
                    /**
         * The Game Size component.
         *
         * The un-modified game size, as requested in the game config (the raw width / height),
         * as used for world bounds, cameras, etc
         *
         * @name Phaser.Scale.ScaleManager#gameSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.gameSize = new Size();
                    /**
         * The Base Size component.
         *
         * The modified game size, which is the auto-rounded gameSize, used to set the canvas width and height
         * (but not the CSS style)
         *
         * @name Phaser.Scale.ScaleManager#baseSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.baseSize = new Size();
                    /**
         * The Display Size component.
         *
         * The size used for the canvas style, factoring in the scale mode, parent and other values.
         *
         * @name Phaser.Scale.ScaleManager#displaySize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.displaySize = new Size();
                    /**
         * The game scale mode.
         *
         * @name Phaser.Scale.ScaleManager#scaleMode
         * @type {Phaser.Scale.ScaleModeType}
         * @since 3.16.0
         */ this.scaleMode = CONST.SCALE_MODE.NONE;
                    /**
         * The game zoom factor.
         *
         * This value allows you to multiply your games base size by the given zoom factor.
         * This is then used when calculating the display size, even in `NONE` situations.
         * If you don't want Phaser to touch the canvas style at all, this value should be 1.
         *
         * Can also be set to `MAX_ZOOM` in which case the zoom value will be derived based
         * on the game size and available space within the parent.
         *
         * @name Phaser.Scale.ScaleManager#zoom
         * @type {number}
         * @since 3.16.0
         */ this.zoom = 1;
                    /**
         * Internal flag set when the game zoom factor is modified.
         *
         * @name Phaser.Scale.ScaleManager#_resetZoom
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this._resetZoom = false;
                    /**
         * The scale factor between the baseSize and the canvasBounds.
         *
         * @name Phaser.Scale.ScaleManager#displayScale
         * @type {Phaser.Math.Vector2}
         * @since 3.16.0
         */ this.displayScale = new Vector2(1, 1);
                    /**
         * If set, the canvas sizes will be automatically passed through Math.floor.
         * This results in rounded pixel display values, which is important for performance on legacy
         * and low powered devices, but at the cost of not achieving a 'perfect' fit in some browser windows.
         *
         * @name Phaser.Scale.ScaleManager#autoRound
         * @type {boolean}
         * @since 3.16.0
         */ this.autoRound = false;
                    /**
         * Automatically center the canvas within the parent? The different centering modes are:
         *
         * 1. No centering.
         * 2. Center both horizontally and vertically.
         * 3. Center horizontally.
         * 4. Center vertically.
         *
         * Please be aware that in order to center the game canvas, you must have specified a parent
         * that has a size set, or the canvas parent is the document.body.
         *
         * @name Phaser.Scale.ScaleManager#autoCenter
         * @type {Phaser.Scale.CenterType}
         * @since 3.16.0
         */ this.autoCenter = CONST.CENTER.NO_CENTER;
                    /**
         * The current device orientation.
         *
         * Orientation events are dispatched via the Device Orientation API, typically only on mobile browsers.
         *
         * @name Phaser.Scale.ScaleManager#orientation
         * @type {Phaser.Scale.OrientationType}
         * @since 3.16.0
         */ this.orientation = CONST.ORIENTATION.LANDSCAPE;
                    /**
         * A reference to the Device.Fullscreen object.
         *
         * @name Phaser.Scale.ScaleManager#fullscreen
         * @type {Phaser.Device.Fullscreen}
         * @since 3.16.0
         */ this.fullscreen;
                    /**
         * The DOM Element which is sent into fullscreen mode.
         *
         * @name Phaser.Scale.ScaleManager#fullscreenTarget
         * @type {?any}
         * @since 3.16.0
         */ this.fullscreenTarget = null;
                    /**
         * Did Phaser create the fullscreen target div, or was it provided in the game config?
         *
         * @name Phaser.Scale.ScaleManager#_createdFullscreenTarget
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._createdFullscreenTarget = false;
                    /**
         * The dirty state of the Scale Manager.
         * Set if there is a change between the parent size and the current size.
         *
         * @name Phaser.Scale.ScaleManager#dirty
         * @type {boolean}
         * @since 3.16.0
         */ this.dirty = false;
                    /**
         * How many milliseconds should elapse before checking if the browser size has changed?
         *
         * Most modern browsers dispatch a 'resize' event, which the Scale Manager will listen for.
         * However, older browsers fail to do this, or do it consistently, so we fall back to a
         * more traditional 'size check' based on a time interval. You can control how often it is
         * checked here.
         *
         * @name Phaser.Scale.ScaleManager#resizeInterval
         * @type {number}
         * @since 3.16.0
         */ this.resizeInterval = 500;
                    /**
         * Internal size interval tracker.
         *
         * @name Phaser.Scale.ScaleManager#_lastCheck
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._lastCheck = 0;
                    /**
         * Internal flag to check orientation state.
         *
         * @name Phaser.Scale.ScaleManager#_checkOrientation
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._checkOrientation = false;
                    /**
         * Internal object containing our defined event listeners.
         *
         * @name Phaser.Scale.ScaleManager#listeners
         * @type {object}
         * @private
         * @since 3.16.0
         */ this.listeners = {
                        orientationChange: NOOP,
                        windowResize: NOOP,
                        fullScreenChange: NOOP,
                        fullScreenError: NOOP
                    };
                },
                /**
     * Called _before_ the canvas object is created and added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#preBoot
     * @protected
     * @listens Phaser.Core.Events#BOOT
     * @since 3.16.0
     */ preBoot: function() {
                    //  Parse the config to get the scaling values we need
                    this.parseConfig(this.game.config);
                    this.game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now and the canvas has been added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#boot
     * @protected
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     */ boot: function() {
                    var game = this.game;
                    this.canvas = game.canvas;
                    this.fullscreen = game.device.fullscreen;
                    if (this.scaleMode !== CONST.SCALE_MODE.RESIZE) this.displaySize.setAspectMode(this.scaleMode);
                    if (this.scaleMode === CONST.SCALE_MODE.NONE) this.resize(this.width, this.height);
                    else {
                        this.getParentBounds();
                        //  Only set the parent bounds if the parent has an actual size
                        if (this.parentSize.width > 0 && this.parentSize.height > 0) this.displaySize.setParent(this.parentSize);
                        this.refresh();
                    }
                    game.events.on(GameEvents.PRE_STEP, this.step, this);
                    game.events.once(GameEvents.READY, this.refresh, this);
                    game.events.once(GameEvents.DESTROY, this.destroy, this);
                    this.startListeners();
                },
                /**
     * Parses the game configuration to set-up the scale defaults.
     *
     * @method Phaser.Scale.ScaleManager#parseConfig
     * @protected
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ parseConfig: function(config) {
                    //  Get the parent element, if any
                    this.getParent(config);
                    //  Get the size of the parent element
                    //  This can often set a height of zero (especially for un-styled divs)
                    this.getParentBounds();
                    var width = config.width;
                    var height = config.height;
                    var scaleMode = config.scaleMode;
                    var zoom = config.zoom;
                    var autoRound = config.autoRound;
                    //  If width = '100%', or similar value
                    if (typeof width === "string") {
                        //  If we have a parent with a height, we'll work it out from that
                        var parentWidth = this.parentSize.width;
                        if (parentWidth === 0) parentWidth = window.innerWidth;
                        var parentScaleX = parseInt(width, 10) / 100;
                        width = Math.floor(parentWidth * parentScaleX);
                    }
                    //  If height = '100%', or similar value
                    if (typeof height === "string") {
                        //  If we have a parent with a height, we'll work it out from that
                        var parentHeight = this.parentSize.height;
                        if (parentHeight === 0) parentHeight = window.innerHeight;
                        var parentScaleY = parseInt(height, 10) / 100;
                        height = Math.floor(parentHeight * parentScaleY);
                    }
                    this.scaleMode = scaleMode;
                    this.autoRound = autoRound;
                    this.autoCenter = config.autoCenter;
                    this.resizeInterval = config.resizeInterval;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.setSize(width, height);
                    if (zoom === CONST.ZOOM.MAX_ZOOM) zoom = this.getMaxZoom();
                    this.zoom = zoom;
                    if (zoom !== 1) this._resetZoom = true;
                    //  The modified game size
                    this.baseSize.setSize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    if (config.minWidth > 0) this.displaySize.setMin(config.minWidth * zoom, config.minHeight * zoom);
                    if (config.maxWidth > 0) this.displaySize.setMax(config.maxWidth * zoom, config.maxHeight * zoom);
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                    this.displaySize.setSize(width, height);
                    this.orientation = GetScreenOrientation(width, height);
                },
                /**
     * Determines the parent element of the game canvas, if any, based on the game configuration.
     *
     * @method Phaser.Scale.ScaleManager#getParent
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ getParent: function(config) {
                    var parent = config.parent;
                    if (parent === null) //  User is responsible for managing the parent
                    return;
                    this.parent = GetTarget(parent);
                    this.parentIsWindow = this.parent === document.body;
                    if (config.expandParent && config.scaleMode !== CONST.SCALE_MODE.NONE) {
                        var DOMRect = this.parent.getBoundingClientRect();
                        if (this.parentIsWindow || DOMRect.height === 0) {
                            document.documentElement.style.height = "100%";
                            document.body.style.height = "100%";
                            DOMRect = this.parent.getBoundingClientRect();
                            //  The parent STILL has no height, clearly no CSS
                            //  has been set on it even though we fixed the body :(
                            if (!this.parentIsWindow && DOMRect.height === 0) {
                                this.parent.style.overflow = "hidden";
                                this.parent.style.width = "100%";
                                this.parent.style.height = "100%";
                            }
                        }
                    }
                    //  And now get the fullscreenTarget
                    if (config.fullscreenTarget && !this.fullscreenTarget) this.fullscreenTarget = GetTarget(config.fullscreenTarget);
                },
                /**
     * Calculates the size of the parent bounds and updates the `parentSize` component, if the canvas has a dom parent.
     *
     * @method Phaser.Scale.ScaleManager#getParentBounds
     * @since 3.16.0
     *
     * @return {boolean} `true` if the parent bounds have changed size, otherwise `false`.
     */ getParentBounds: function() {
                    if (!this.parent) return false;
                    var parentSize = this.parentSize;
                    // Ref. http://msdn.microsoft.com/en-us/library/hh781509(v=vs.85).aspx for getBoundingClientRect
                    var DOMRect = this.parent.getBoundingClientRect();
                    if (this.parentIsWindow && this.game.device.os.iOS) DOMRect.height = GetInnerHeight(true);
                    var newWidth = DOMRect.width;
                    var newHeight = DOMRect.height;
                    if (parentSize.width !== newWidth || parentSize.height !== newHeight) {
                        parentSize.setSize(newWidth, newHeight);
                        return true;
                    } else return false;
                },
                /**
     * Attempts to lock the orientation of the web browser using the Screen Orientation API.
     *
     * This API is only available on modern mobile browsers.
     * See https://developer.mozilla.org/en-US/docs/Web/API/Screen/lockOrientation for details.
     *
     * @method Phaser.Scale.ScaleManager#lockOrientation
     * @since 3.16.0
     *
     * @param {string} orientation - The orientation you'd like to lock the browser in. Should be an API string such as 'landscape', 'landscape-primary', 'portrait', etc.
     *
     * @return {boolean} `true` if the orientation was successfully locked, otherwise `false`.
     */ lockOrientation: function(orientation) {
                    var lock = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation;
                    if (lock) return lock.call(screen, orientation);
                    return false;
                },
                /**
     * This method will set the size of the Parent Size component, which is used in scaling
     * and centering calculations. You only need to call this method if you have explicitly
     * disabled the use of a parent in your game config, but still wish to take advantage of
     * other Scale Manager features.
     *
     * @method Phaser.Scale.ScaleManager#setParentSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the parent.
     * @param {number} height - The new height of the parent.
     *
     * @return {this} The Scale Manager instance.
     */ setParentSize: function(width, height) {
                    this.parentSize.setSize(width, height);
                    return this.refresh();
                },
                /**
     * This method will set a new size for your game.
     *
     * It should only be used if you're looking to change the base size of your game and are using
     * one of the Scale Manager scaling modes, i.e. `FIT`. If you're using `NONE` and wish to
     * change the game and canvas size directly, then please use the `resize` method instead.
     *
     * @method Phaser.Scale.ScaleManager#setGameSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setGameSize: function(width, height) {
                    var autoRound = this.autoRound;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    var previousWidth = this.width;
                    var previousHeight = this.height;
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.resize(width, height);
                    //  The modified game size
                    this.baseSize.resize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  Update the aspect ratio
                    this.displaySize.setAspectRatio(width / height);
                    this.canvas.width = this.baseSize.width;
                    this.canvas.height = this.baseSize.height;
                    return this.refresh(previousWidth, previousHeight);
                },
                /**
     * Call this to modify the size of the Phaser canvas element directly.
     * You should only use this if you are using the `NONE` scale mode,
     * it will update all internal components completely.
     *
     * If all you want to do is change the size of the parent, see the `setParentSize` method.
     *
     * If all you want is to change the base size of the game, but still have the Scale Manager
     * manage all the scaling (i.e. you're **not** using `NONE`), then see the `setGameSize` method.
     *
     * This method will set the `gameSize`, `baseSize` and `displaySize` components to the given
     * dimensions. It will then resize the canvas width and height to the values given, by
     * directly setting the properties. Finally, if you have set the Scale Manager zoom value
     * to anything other than 1 (the default), it will set the canvas CSS width and height to
     * be the given size multiplied by the zoom factor (the canvas pixel size remains untouched).
     *
     * If you have enabled `autoCenter`, it is then passed to the `updateCenter` method and
     * the margins are set, allowing the canvas to be centered based on its parent element
     * alone. Finally, the `displayScale` is adjusted and the RESIZE event dispatched.
     *
     * @method Phaser.Scale.ScaleManager#resize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ resize: function(width, height) {
                    var zoom = this.zoom;
                    var autoRound = this.autoRound;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    var previousWidth = this.width;
                    var previousHeight = this.height;
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.resize(width, height);
                    //  The modified game size
                    this.baseSize.resize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                    this.displaySize.setSize(width * zoom, height * zoom);
                    this.canvas.width = this.baseSize.width;
                    this.canvas.height = this.baseSize.height;
                    var style = this.canvas.style;
                    var styleWidth = width * zoom;
                    var styleHeight = height * zoom;
                    if (autoRound) {
                        styleWidth = Math.floor(styleWidth);
                        styleHeight = Math.floor(styleHeight);
                    }
                    if (styleWidth !== width || styleHeight !== height) {
                        style.width = styleWidth + "px";
                        style.height = styleHeight + "px";
                    }
                    return this.refresh(previousWidth, previousHeight);
                },
                /**
     * Sets the zoom value of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#setZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} value - The new zoom value of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setZoom: function(value) {
                    this.zoom = value;
                    this._resetZoom = true;
                    return this.refresh();
                },
                /**
     * Sets the zoom to be the maximum possible based on the _current_ parent size.
     *
     * @method Phaser.Scale.ScaleManager#setMaxZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @return {this} The Scale Manager instance.
     */ setMaxZoom: function() {
                    this.zoom = this.getMaxZoom();
                    this._resetZoom = true;
                    return this.refresh();
                },
                /**
     * Refreshes the internal scale values, bounds sizes and orientation checks.
     *
     * Once finished, dispatches the resize event.
     *
     * This is called automatically by the Scale Manager when the browser window size changes,
     * as long as it is using a Scale Mode other than 'NONE'.
     *
     * @method Phaser.Scale.ScaleManager#refresh
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} [previousWidth] - The previous width of the game. Only set if the gameSize has changed.
     * @param {number} [previousHeight] - The previous height of the game. Only set if the gameSize has changed.
     *
     * @return {this} The Scale Manager instance.
     */ refresh: function(previousWidth, previousHeight) {
                    if (previousWidth === undefined) previousWidth = this.width;
                    if (previousHeight === undefined) previousHeight = this.height;
                    this.updateScale();
                    this.updateBounds();
                    this.updateOrientation();
                    this.displayScale.set(this.baseSize.width / this.canvasBounds.width, this.baseSize.height / this.canvasBounds.height);
                    var domContainer = this.game.domContainer;
                    if (domContainer) {
                        this.baseSize.setCSS(domContainer);
                        var canvasStyle = this.canvas.style;
                        var domStyle = domContainer.style;
                        domStyle.transform = "scale(" + this.displaySize.width / this.baseSize.width + "," + this.displaySize.height / this.baseSize.height + ")";
                        domStyle.marginLeft = canvasStyle.marginLeft;
                        domStyle.marginTop = canvasStyle.marginTop;
                    }
                    this.emit(Events.RESIZE, this.gameSize, this.baseSize, this.displaySize, previousWidth, previousHeight);
                    return this;
                },
                /**
     * Internal method that checks the current screen orientation, only if the internal check flag is set.
     *
     * If the orientation has changed it updates the orientation property and then dispatches the orientation change event.
     *
     * @method Phaser.Scale.ScaleManager#updateOrientation
     * @fires Phaser.Scale.Events#ORIENTATION_CHANGE
     * @since 3.16.0
     */ updateOrientation: function() {
                    if (this._checkOrientation) {
                        this._checkOrientation = false;
                        var newOrientation = GetScreenOrientation(this.width, this.height);
                        if (newOrientation !== this.orientation) {
                            this.orientation = newOrientation;
                            this.emit(Events.ORIENTATION_CHANGE, newOrientation);
                        }
                    }
                },
                /**
     * Internal method that manages updating the size components based on the scale mode.
     *
     * @method Phaser.Scale.ScaleManager#updateScale
     * @since 3.16.0
     */ updateScale: function() {
                    var style = this.canvas.style;
                    var width = this.gameSize.width;
                    var height = this.gameSize.height;
                    var styleWidth;
                    var styleHeight;
                    var zoom = this.zoom;
                    var autoRound = this.autoRound;
                    if (this.scaleMode === CONST.SCALE_MODE.NONE) {
                        //  No scale
                        this.displaySize.setSize(width * zoom, height * zoom);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        if (this._resetZoom) {
                            style.width = styleWidth + "px";
                            style.height = styleHeight + "px";
                            this._resetZoom = false;
                        }
                    } else if (this.scaleMode === CONST.SCALE_MODE.RESIZE) {
                        //  Resize to match parent
                        //  This will constrain using min/max
                        this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                        this.gameSize.setSize(this.displaySize.width, this.displaySize.height);
                        this.baseSize.setSize(this.displaySize.width, this.displaySize.height);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        this.canvas.width = styleWidth;
                        this.canvas.height = styleHeight;
                    } else {
                        //  All other scale modes
                        this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        style.width = styleWidth + "px";
                        style.height = styleHeight + "px";
                    }
                    //  Update the parentSize in case the canvas / style change modified it
                    this.getParentBounds();
                    //  Finally, update the centering
                    this.updateCenter();
                },
                /**
     * Calculates and returns the largest possible zoom factor, based on the current
     * parent and game sizes. If the parent has no dimensions (i.e. an unstyled div),
     * or is smaller than the un-zoomed game, then this will return a value of 1 (no zoom)
     *
     * @method Phaser.Scale.ScaleManager#getMaxZoom
     * @since 3.16.0
     *
     * @return {number} The maximum possible zoom factor. At a minimum this value is always at least 1.
     */ getMaxZoom: function() {
                    var zoomH = SnapFloor(this.parentSize.width, this.gameSize.width, 0, true);
                    var zoomV = SnapFloor(this.parentSize.height, this.gameSize.height, 0, true);
                    return Math.max(Math.min(zoomH, zoomV), 1);
                },
                /**
     * Calculates and updates the canvas CSS style in order to center it within the
     * bounds of its parent. If you have explicitly set parent to be `null` in your
     * game config then this method will likely give incorrect results unless you have called the
     * `setParentSize` method first.
     *
     * It works by modifying the canvas CSS `marginLeft` and `marginTop` properties.
     *
     * If they have already been set by your own style sheet, or code, this will overwrite them.
     *
     * To prevent the Scale Manager from centering the canvas, either do not set the
     * `autoCenter` property in your game config, or make sure it is set to `NO_CENTER`.
     *
     * @method Phaser.Scale.ScaleManager#updateCenter
     * @since 3.16.0
     */ updateCenter: function() {
                    var autoCenter = this.autoCenter;
                    if (autoCenter === CONST.CENTER.NO_CENTER) return;
                    var canvas = this.canvas;
                    var style = canvas.style;
                    var bounds = canvas.getBoundingClientRect();
                    // var width = parseInt(canvas.style.width, 10) || canvas.width;
                    // var height = parseInt(canvas.style.height, 10) || canvas.height;
                    var width = bounds.width;
                    var height = bounds.height;
                    var offsetX = Math.floor((this.parentSize.width - width) / 2);
                    var offsetY = Math.floor((this.parentSize.height - height) / 2);
                    if (autoCenter === CONST.CENTER.CENTER_HORIZONTALLY) offsetY = 0;
                    else if (autoCenter === CONST.CENTER.CENTER_VERTICALLY) offsetX = 0;
                    style.marginLeft = offsetX + "px";
                    style.marginTop = offsetY + "px";
                },
                /**
     * Updates the `canvasBounds` rectangle to match the bounding client rectangle of the
     * canvas element being used to track input events.
     *
     * @method Phaser.Scale.ScaleManager#updateBounds
     * @since 3.16.0
     */ updateBounds: function() {
                    var bounds = this.canvasBounds;
                    var clientRect = this.canvas.getBoundingClientRect();
                    bounds.x = clientRect.left + (window.pageXOffset || 0) - (document.documentElement.clientLeft || 0);
                    bounds.y = clientRect.top + (window.pageYOffset || 0) - (document.documentElement.clientTop || 0);
                    bounds.width = clientRect.width;
                    bounds.height = clientRect.height;
                },
                /**
     * Transforms the pageX value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformX
     * @since 3.16.0
     *
     * @param {number} pageX - The DOM pageX value.
     *
     * @return {number} The translated value.
     */ transformX: function(pageX) {
                    return (pageX - this.canvasBounds.left) * this.displayScale.x;
                },
                /**
     * Transforms the pageY value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformY
     * @since 3.16.0
     *
     * @param {number} pageY - The DOM pageY value.
     *
     * @return {number} The translated value.
     */ transformY: function(pageY) {
                    return (pageY - this.canvasBounds.top) * this.displayScale.y;
                },
                /**
     * Sends a request to the browser to ask it to go in to full screen mode, using the {@link https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API Fullscreen API}.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a `pointerup` user-input gesture (**not** `pointerdown`). You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * On touch devices, such as Android and iOS Safari, you should always use `pointerup` and NOT `pointerdown`,
     * otherwise the request will fail unless the document in which your game is embedded has already received
     * some form of touch input, which you cannot guarantee. Activating fullscreen via `pointerup` circumvents
     * this issue.
     *
     * Performing an action that navigates to another page, or opens another tab, will automatically cancel
     * fullscreen mode, as will the user pressing the ESC key. To cancel fullscreen mode directly from your game,
     * i.e. by clicking an icon, call the `stopFullscreen` method.
     *
     * A browser can only send one DOM element into fullscreen. You can control which element this is by
     * setting the `fullscreenTarget` property in your game config, or changing the property in the Scale Manager.
     * Note that the game canvas _must_ be a child of the target. If you do not give a target, Phaser will
     * automatically create a blank `<div>` element and move the canvas into it, before going fullscreen.
     * When it leaves fullscreen, the div will be removed.
     *
     * @method Phaser.Scale.ScaleManager#startFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ startFullscreen: function(fullscreenOptions) {
                    if (fullscreenOptions === undefined) fullscreenOptions = {
                        navigationUI: "hide"
                    };
                    var fullscreen = this.fullscreen;
                    if (!fullscreen.available) {
                        this.emit(Events.FULLSCREEN_UNSUPPORTED);
                        return;
                    }
                    if (!fullscreen.active) {
                        var fsTarget = this.getFullscreenTarget();
                        if (fullscreen.keyboard) fsTarget[fullscreen.request](Element.ALLOW_KEYBOARD_INPUT);
                        else fsTarget[fullscreen.request](fullscreenOptions);
                    }
                },
                /**
     * The browser has successfully entered fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenSuccessHandler
     * @private
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     */ fullscreenSuccessHandler: function() {
                    this.getParentBounds();
                    this.refresh();
                    this.emit(Events.ENTER_FULLSCREEN);
                },
                /**
     * The browser failed to enter fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenErrorHandler
     * @private
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     *
     * @param {any} error - The DOM error event.
     */ fullscreenErrorHandler: function(error) {
                    this.removeFullscreenTarget();
                    this.emit(Events.FULLSCREEN_FAILED, error);
                },
                /**
     * An internal method that gets the target element that is used when entering fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#getFullscreenTarget
     * @since 3.16.0
     *
     * @return {object} The fullscreen target element.
     */ getFullscreenTarget: function() {
                    if (!this.fullscreenTarget) {
                        var fsTarget = document.createElement("div");
                        fsTarget.style.margin = "0";
                        fsTarget.style.padding = "0";
                        fsTarget.style.width = "100%";
                        fsTarget.style.height = "100%";
                        this.fullscreenTarget = fsTarget;
                        this._createdFullscreenTarget = true;
                    }
                    if (this._createdFullscreenTarget) {
                        var canvasParent = this.canvas.parentNode;
                        canvasParent.insertBefore(this.fullscreenTarget, this.canvas);
                        this.fullscreenTarget.appendChild(this.canvas);
                    }
                    return this.fullscreenTarget;
                },
                /**
     * Removes the fullscreen target that was added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#removeFullscreenTarget
     * @since 3.17.0
     */ removeFullscreenTarget: function() {
                    if (this._createdFullscreenTarget) {
                        var fsTarget = this.fullscreenTarget;
                        if (fsTarget && fsTarget.parentNode) {
                            var parent = fsTarget.parentNode;
                            parent.insertBefore(this.canvas, fsTarget);
                            parent.removeChild(fsTarget);
                        }
                    }
                },
                /**
     * Calling this method will cancel fullscreen mode, if the browser has entered it.
     *
     * @method Phaser.Scale.ScaleManager#stopFullscreen
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @since 3.16.0
     */ stopFullscreen: function() {
                    var fullscreen = this.fullscreen;
                    if (!fullscreen.available) {
                        this.emit(Events.FULLSCREEN_UNSUPPORTED);
                        return false;
                    }
                    if (fullscreen.active) document[fullscreen.cancel]();
                    this.removeFullscreenTarget();
                    //  Get the parent size again as it will have changed
                    this.getParentBounds();
                    this.emit(Events.LEAVE_FULLSCREEN);
                    this.refresh();
                },
                /**
     * Toggles the fullscreen mode. If already in fullscreen, calling this will cancel it.
     * If not in fullscreen, this will request the browser to enter fullscreen mode.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a user-input gesture, such as `pointerdown`. You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * @method Phaser.Scale.ScaleManager#toggleFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ toggleFullscreen: function(fullscreenOptions) {
                    if (this.fullscreen.active) this.stopFullscreen();
                    else this.startFullscreen(fullscreenOptions);
                },
                /**
     * An internal method that starts the different DOM event listeners running.
     *
     * @method Phaser.Scale.ScaleManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                    var _this = this;
                    var listeners = this.listeners;
                    listeners.orientationChange = function() {
                        _this.updateBounds();
                        _this._checkOrientation = true;
                        _this.dirty = true;
                    };
                    listeners.windowResize = function() {
                        _this.updateBounds();
                        _this.dirty = true;
                    };
                    //  Only dispatched on mobile devices
                    window.addEventListener("orientationchange", listeners.orientationChange, false);
                    window.addEventListener("resize", listeners.windowResize, false);
                    if (this.fullscreen.available) {
                        listeners.fullScreenChange = function(event) {
                            return _this.onFullScreenChange(event);
                        };
                        listeners.fullScreenError = function(event) {
                            return _this.onFullScreenError(event);
                        };
                        var vendors = [
                            "webkit",
                            "moz",
                            ""
                        ];
                        vendors.forEach(function(prefix) {
                            document.addEventListener(prefix + "fullscreenchange", listeners.fullScreenChange, false);
                            document.addEventListener(prefix + "fullscreenerror", listeners.fullScreenError, false);
                        });
                        //  MS Specific
                        document.addEventListener("MSFullscreenChange", listeners.fullScreenChange, false);
                        document.addEventListener("MSFullscreenError", listeners.fullScreenError, false);
                    }
                },
                /**
     * Triggered when a fullscreenchange event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenChange
     * @protected
     * @since 3.16.0
     */ onFullScreenChange: function() {
                    if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreenElement) this.fullscreenSuccessHandler();
                    else //  They pressed ESC while in fullscreen mode
                    this.stopFullscreen();
                },
                /**
     * Triggered when a fullscreenerror event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenError
     * @since 3.16.0
     */ onFullScreenError: function() {
                    this.removeFullscreenTarget();
                },
                /**
     * Internal method, called automatically by the game step.
     * Monitors the elapsed time and resize interval to see if a parent bounds check needs to take place.
     *
     * @method Phaser.Scale.ScaleManager#step
     * @since 3.16.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                    if (!this.parent) return;
                    this._lastCheck += delta;
                    if (this.dirty || this._lastCheck > this.resizeInterval) {
                        //  Returns true if the parent bounds have changed size
                        if (this.getParentBounds()) this.refresh();
                        this.dirty = false;
                        this._lastCheck = 0;
                    }
                },
                /**
     * Stops all DOM event listeners.
     *
     * @method Phaser.Scale.ScaleManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                    var listeners = this.listeners;
                    window.removeEventListener("orientationchange", listeners.orientationChange, false);
                    window.removeEventListener("resize", listeners.windowResize, false);
                    var vendors = [
                        "webkit",
                        "moz",
                        ""
                    ];
                    vendors.forEach(function(prefix) {
                        document.removeEventListener(prefix + "fullscreenchange", listeners.fullScreenChange, false);
                        document.removeEventListener(prefix + "fullscreenerror", listeners.fullScreenError, false);
                    });
                    //  MS Specific
                    document.removeEventListener("MSFullscreenChange", listeners.fullScreenChange, false);
                    document.removeEventListener("MSFullscreenError", listeners.fullScreenError, false);
                },
                /**
     * Destroys this Scale Manager, releasing all references to external resources.
     * Once destroyed, the Scale Manager cannot be used again.
     *
     * @method Phaser.Scale.ScaleManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.stopListeners();
                    this.game = null;
                    this.canvas = null;
                    this.canvasBounds = null;
                    this.parent = null;
                    this.fullscreenTarget = null;
                    this.parentSize.destroy();
                    this.gameSize.destroy();
                    this.baseSize.destroy();
                    this.displaySize.destroy();
                },
                /**
     * Is the browser currently in fullscreen mode or not?
     *
     * @name Phaser.Scale.ScaleManager#isFullscreen
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isFullscreen: {
                    get: function() {
                        return this.fullscreen.active;
                    }
                },
                /**
     * The game width.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#width
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ width: {
                    get: function() {
                        return this.gameSize.width;
                    }
                },
                /**
     * The game height.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#height
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ height: {
                    get: function() {
                        return this.gameSize.height;
                    }
                },
                /**
     * Is the device in a portrait orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isPortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isPortrait: {
                    get: function() {
                        return this.orientation === CONST.ORIENTATION.PORTRAIT;
                    }
                },
                /**
     * Is the device in a landscape orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isLandscape: {
                    get: function() {
                        return this.orientation === CONST.ORIENTATION.LANDSCAPE;
                    }
                },
                /**
     * Are the game dimensions portrait? (i.e. taller than they are wide)
     *
     * This is different to the device itself being in a portrait orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGamePortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGamePortrait: {
                    get: function() {
                        return this.height > this.width;
                    }
                },
                /**
     * Are the game dimensions landscape? (i.e. wider than they are tall)
     *
     * This is different to the device itself being in a landscape orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGameLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGameLandscape: {
                    get: function() {
                        return this.width > this.height;
                    }
                }
            });
            module1.exports = ScaleManager;
        /***/ },
        /* 416 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var SnapFloor = __webpack_require__(76);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * The Size component allows you to set `width` and `height` properties and define the relationship between them.
 * 
 * The component can automatically maintain the aspect ratios between the two values, and clamp them
 * to a defined min-max range. You can also control the dominant axis. When dimensions are given to the Size component
 * that would cause it to exceed its min-max range, the dimensions are adjusted based on the dominant axis.
 *
 * @class Size
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.16.0
 *
 * @param {number} [width=0] - The width of the Size component.
 * @param {number} [height=width] - The height of the Size component. If not given, it will use the `width`.
 * @param {number} [aspectMode=0] - The aspect mode of the Size component. Defaults to 0, no mode.
 * @param {any} [parent=null] - The parent of this Size component. Can be any object with public `width` and `height` properties. Dimensions are clamped to keep them within the parent bounds where possible.
 */ var Size = new Class({
                initialize: function Size(width, height, aspectMode, parent) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    if (aspectMode === undefined) aspectMode = 0;
                    if (parent === undefined) parent = null;
                    /**
         * Internal width value.
         *
         * @name Phaser.Structs.Size#_width
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._width = width;
                    /**
         * Internal height value.
         *
         * @name Phaser.Structs.Size#_height
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._height = height;
                    /**
         * Internal parent reference.
         *
         * @name Phaser.Structs.Size#_parent
         * @type {any}
         * @private
         * @since 3.16.0
         */ this._parent = parent;
                    /**
         * The aspect mode this Size component will use when calculating its dimensions.
         * This property is read-only. To change it use the `setAspectMode` method.
         *
         * @name Phaser.Structs.Size#aspectMode
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectMode = aspectMode;
                    /**
         * The proportional relationship between the width and height.
         * 
         * This property is read-only and is updated automatically when either the `width` or `height` properties are changed,
         * depending on the aspect mode.
         *
         * @name Phaser.Structs.Size#aspectRatio
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectRatio = height === 0 ? 1 : width / height;
                    /**
         * The minimum allowed width.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minWidth = 0;
                    /**
         * The minimum allowed height.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minHeight = 0;
                    /**
         * The maximum allowed width.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxWidth = Number.MAX_VALUE;
                    /**
         * The maximum allowed height.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxHeight = Number.MAX_VALUE;
                    /**
         * A Vector2 containing the horizontal and vertical snap values, which the width and height are snapped to during resizing.
         * 
         * By default this is disabled.
         * 
         * This property is read-only. To change it see the `setSnap` method.
         *
         * @name Phaser.Structs.Size#snapTo
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.snapTo = new Vector2();
                },
                /**
     * Sets the aspect mode of this Size component.
     * 
     * The aspect mode controls what happens when you modify the `width` or `height` properties, or call `setSize`.
     * 
     * It can be a number from 0 to 4, or a Size constant:
     * 
     * 0. NONE = Do not make the size fit the aspect ratio. Change the ratio when the size changes.
     * 1. WIDTH_CONTROLS_HEIGHT = The height is automatically adjusted based on the width.
     * 2. HEIGHT_CONTROLS_WIDTH = The width is automatically adjusted based on the height.
     * 3. FIT = The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
     * 4. ENVELOP = The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
     * 
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     * 
     * @method Phaser.Structs.Size#setAspectMode
     * @since 3.16.0
     *
     * @param {number} [value=0] - The aspect mode value.
     *
     * @return {this} This Size component instance.
     */ setAspectMode: function(value) {
                    if (value === undefined) value = 0;
                    this.aspectMode = value;
                    return this.setSize(this._width, this._height);
                },
                /**
     * By setting a Snap To value when this Size component is modified its dimensions will automatically
     * by snapped to the nearest grid slice, using floor. For example, if you have snap value of 16,
     * and the width changes to 68, then it will snap down to 64 (the closest multiple of 16 when floored)
     * 
     * Note that snapping takes place before adjustments by the parent, or the min / max settings. If these
     * values are not multiples of the given snap values, then this can result in un-snapped dimensions.
     * 
     * Call this method with no arguments to reset the snap values.
     * 
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     * 
     * @method Phaser.Structs.Size#setSnap
     * @since 3.16.0
     *
     * @param {number} [snapWidth=0] - The amount to snap the width to. If you don't want to snap the width, pass a value of zero.
     * @param {number} [snapHeight=snapWidth] - The amount to snap the height to. If not provided it will use the `snapWidth` value. If you don't want to snap the height, pass a value of zero.
     *
     * @return {this} This Size component instance.
     */ setSnap: function(snapWidth, snapHeight) {
                    if (snapWidth === undefined) snapWidth = 0;
                    if (snapHeight === undefined) snapHeight = snapWidth;
                    this.snapTo.set(snapWidth, snapHeight);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets, or clears, the parent of this Size component.
     * 
     * To clear the parent call this method with no arguments.
     * 
     * The parent influences the maximum extents to which this Size component can expand,
     * based on the aspect mode:
     * 
     * NONE - The parent clamps both the width and height.
     * WIDTH_CONTROLS_HEIGHT - The parent clamps just the width.
     * HEIGHT_CONTROLS_WIDTH - The parent clamps just the height.
     * FIT - The parent clamps whichever axis is required to ensure the size fits within it.
     * ENVELOP - The parent is used to ensure the size fully envelops the parent.
     * 
     * Calling this method automatically calls `setSize`.
     *
     * @method Phaser.Structs.Size#setParent
     * @since 3.16.0
     *
     * @param {any} [parent] - Sets the parent of this Size component. Don't provide a value to clear an existing parent.
     *
     * @return {this} This Size component instance.
     */ setParent: function(parent) {
                    this._parent = parent;
                    return this.setSize(this._width, this._height);
                },
                /**
     * Set the minimum width and height values this Size component will allow.
     * 
     * The minimum values can never be below zero, or greater than the maximum values.
     * 
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     * 
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the minimums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMin
     * @since 3.16.0
     *
     * @param {number} [width=0] - The minimum allowed width of the Size component.
     * @param {number} [height=width] - The minimum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMin: function(width, height) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    this.minWidth = Clamp(width, 0, this.maxWidth);
                    this.minHeight = Clamp(height, 0, this.maxHeight);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Set the maximum width and height values this Size component will allow.
     * 
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     * 
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the maximums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMax
     * @since 3.16.0
     *
     * @param {number} [width=Number.MAX_VALUE] - The maximum allowed width of the Size component.
     * @param {number} [height=width] - The maximum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMax: function(width, height) {
                    if (width === undefined) width = Number.MAX_VALUE;
                    if (height === undefined) height = width;
                    this.maxWidth = Clamp(width, this.minWidth, Number.MAX_VALUE);
                    this.maxHeight = Clamp(height, this.minHeight, Number.MAX_VALUE);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets the width and height of this Size component based on the aspect mode.
     * 
     * If the aspect mode is 'none' then calling this method will change the aspect ratio, otherwise the current
     * aspect ratio is honored across all other modes.
     * 
     * If snapTo values have been set then the given width and height are snapped first, prior to any further
     * adjustment via min/max values, or a parent.
     * 
     * If minimum and/or maximum dimensions have been specified, the values given to this method will be clamped into
     * that range prior to adjustment, but may still exceed them depending on the aspect mode.
     * 
     * If this Size component has a parent set, and the aspect mode is `fit` or `envelop`, then the given sizes will
     * be clamped to the range specified by the parent.
     *
     * @method Phaser.Structs.Size#setSize
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setSize: function(width, height) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    switch(this.aspectMode){
                        case Size.NONE:
                            this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                            this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                            this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                            break;
                        case Size.WIDTH_CONTROLS_HEIGHT:
                            this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                            this._height = this.getNewHeight(this._width * (1 / this.aspectRatio), false);
                            break;
                        case Size.HEIGHT_CONTROLS_WIDTH:
                            this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                            this._width = this.getNewWidth(this._height * this.aspectRatio, false);
                            break;
                        case Size.FIT:
                            this.constrain(width, height, true);
                            break;
                        case Size.ENVELOP:
                            this.constrain(width, height, false);
                            break;
                    }
                    return this;
                },
                /**
     * Sets a new aspect ratio, overriding what was there previously.
     * 
     * It then calls `setSize` immediately using the current dimensions.
     *
     * @method Phaser.Structs.Size#setAspectRatio
     * @since 3.16.0
     *
     * @param {number} ratio - The new aspect ratio.
     *
     * @return {this} This Size component instance.
     */ setAspectRatio: function(ratio) {
                    this.aspectRatio = ratio;
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets a new width and height for this Size component and updates the aspect ratio based on them.
     * 
     * It _doesn't_ change the `aspectMode` and still factors in size limits such as the min max and parent bounds.
     *
     * @method Phaser.Structs.Size#resize
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ resize: function(width, height) {
                    this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                    this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                    this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                    return this;
                },
                /**
     * Takes a new width and passes it through the min/max clamp and then checks it doesn't exceed the parent width.
     *
     * @method Phaser.Structs.Size#getNewWidth
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified width value.
     */ getNewWidth: function(value, checkParent) {
                    if (checkParent === undefined) checkParent = true;
                    value = Clamp(value, this.minWidth, this.maxWidth);
                    if (checkParent && this._parent && value > this._parent.width) value = Math.max(this.minWidth, this._parent.width);
                    return value;
                },
                /**
     * Takes a new height and passes it through the min/max clamp and then checks it doesn't exceed the parent height.
     *
     * @method Phaser.Structs.Size#getNewHeight
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified height value.
     */ getNewHeight: function(value, checkParent) {
                    if (checkParent === undefined) checkParent = true;
                    value = Clamp(value, this.minHeight, this.maxHeight);
                    if (checkParent && this._parent && value > this._parent.height) value = Math.max(this.minHeight, this._parent.height);
                    return value;
                },
                /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     * 
     * If `fit` is true there may be some space inside the target area which is not covered if its aspect ratio differs.
     * If `fit` is false the size may extend further out than the target area if the aspect ratios differ.
     * 
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#constrain
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     * @param {boolean} [fit=true] - Perform a `fit` (true) constraint, or an `envelop` (false) constraint.
     *
     * @return {this} This Size component instance.
     */ constrain: function(width, height, fit) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    if (fit === undefined) fit = true;
                    width = this.getNewWidth(width);
                    height = this.getNewHeight(height);
                    var snap = this.snapTo;
                    var newRatio = height === 0 ? 1 : width / height;
                    if (fit && this.aspectRatio > newRatio || !fit && this.aspectRatio < newRatio) {
                        //  We need to change the height to fit the width
                        width = SnapFloor(width, snap.x);
                        height = width / this.aspectRatio;
                        if (snap.y > 0) {
                            height = SnapFloor(height, snap.y);
                            //  Reduce the width accordingly
                            width = height * this.aspectRatio;
                        }
                    } else if (fit && this.aspectRatio < newRatio || !fit && this.aspectRatio > newRatio) {
                        //  We need to change the width to fit the height
                        height = SnapFloor(height, snap.y);
                        width = height * this.aspectRatio;
                        if (snap.x > 0) {
                            width = SnapFloor(width, snap.x);
                            //  Reduce the height accordingly
                            height = width * (1 / this.aspectRatio);
                        }
                    }
                    this._width = width;
                    this._height = height;
                    return this;
                },
                /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     * 
     * There may be some space inside the target area which is not covered if its aspect ratio differs.
     * 
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#fitTo
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ fitTo: function(width, height) {
                    return this.constrain(width, height, true);
                },
                /**
     * The current `width` and `height` are adjusted so that they fully envelope the given dimensions, while keeping the aspect ratio.
     * 
     * The size may extend further out than the target area if the aspect ratios differ.
     * 
     * If this Size component has a parent set, then the values are clamped so that it never exceeds the parent
     * on the longest axis.
     *
     * @method Phaser.Structs.Size#envelop
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ envelop: function(width, height) {
                    return this.constrain(width, height, false);
                },
                /**
     * Sets the width of this Size component.
     * 
     * Depending on the aspect mode, changing the width may also update the height and aspect ratio.
     *
     * @method Phaser.Structs.Size#setWidth
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     *
     * @return {this} This Size component instance.
     */ setWidth: function(value) {
                    return this.setSize(value, this._height);
                },
                /**
     * Sets the height of this Size component.
     * 
     * Depending on the aspect mode, changing the height may also update the width and aspect ratio.
     *
     * @method Phaser.Structs.Size#setHeight
     * @since 3.16.0
     *
     * @param {number} height - The new height of the Size component.
     *
     * @return {this} This Size component instance.
     */ setHeight: function(value) {
                    return this.setSize(this._width, value);
                },
                /**
     * Returns a string representation of this Size component.
     *
     * @method Phaser.Structs.Size#toString
     * @since 3.16.0
     *
     * @return {string} A string representation of this Size component.
     */ toString: function() {
                    return "[{ Size (width=" + this._width + " height=" + this._height + " aspectRatio=" + this.aspectRatio + " aspectMode=" + this.aspectMode + ") }]";
                },
                /**
     * Sets the values of this Size component to the `element.style.width` and `height`
     * properties of the given DOM Element. The properties are set as `px` values.
     *
     * @method Phaser.Structs.Size#setCSS
     * @since 3.17.0
     *
     * @param {HTMLElement} element - The DOM Element to set the CSS style on.
     */ setCSS: function(element) {
                    if (element && element.style) {
                        element.style.width = this._width + "px";
                        element.style.height = this._height + "px";
                    }
                },
                /**
     * Copies the aspect mode, aspect ratio, width and height from this Size component
     * to the given Size component. Note that the parent, if set, is not copied across.
     *
     * @method Phaser.Structs.Size#copy
     * @since 3.16.0
     * 
     * @param {Phaser.Structs.Size} destination - The Size component to copy the values to.
     *
     * @return {Phaser.Structs.Size} The updated destination Size component.
     */ copy: function(destination) {
                    destination.setAspectMode(this.aspectMode);
                    destination.aspectRatio = this.aspectRatio;
                    return destination.setSize(this.width, this.height);
                },
                /**
     * Destroys this Size component.
     * 
     * This clears the local properties and any parent object, if set.
     * 
     * A destroyed Size component cannot be re-used.
     *
     * @method Phaser.Structs.Size#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this._parent = null;
                    this.snapTo = null;
                },
                /**
     * The width of this Size component.
     * 
     * This value is clamped to the range specified by `minWidth` and `maxWidth`, if enabled.
     * 
     * A width can never be less than zero.
     * 
     * Changing this value will automatically update the `height` if the aspect ratio lock is enabled.
     * You can also use the `setWidth` and `getWidth` methods.
     *
     * @name Phaser.Structs.Size#width
     * @type {number}
     * @since 3.16.0
     */ width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(value) {
                        this.setSize(value, this._height);
                    }
                },
                /**
     * The height of this Size component.
     * 
     * This value is clamped to the range specified by `minHeight` and `maxHeight`, if enabled.
     * 
     * A height can never be less than zero.
     * 
     * Changing this value will automatically update the `width` if the aspect ratio lock is enabled.
     * You can also use the `setHeight` and `getHeight` methods.
     *
     * @name Phaser.Structs.Size#height
     * @type {number}
     * @since 3.16.0
     */ height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(value) {
                        this.setSize(this._width, value);
                    }
                }
            });
            /**
 * Do not make the size fit the aspect ratio. Change the ratio when the size changes.
 * 
 * @name Phaser.Structs.Size.NONE
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.NONE = 0;
            /**
 * The height is automatically adjusted based on the width.
 * 
 * @name Phaser.Structs.Size.WIDTH_CONTROLS_HEIGHT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.WIDTH_CONTROLS_HEIGHT = 1;
            /**
 * The width is automatically adjusted based on the height.
 * 
 * @name Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.HEIGHT_CONTROLS_WIDTH = 2;
            /**
 * The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
 * 
 * @name Phaser.Structs.Size.FIT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.FIT = 3;
            /**
 * The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
 * 
 * @name Phaser.Structs.Size.ENVELOP
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.ENVELOP = 4;
            module1.exports = Size;
        /***/ },
        /* 417 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(144);
            var Events = __webpack_require__(20);
            var GameEvents = __webpack_require__(22);
            var GetValue = __webpack_require__(6);
            var LoaderEvents = __webpack_require__(95);
            var NOOP = __webpack_require__(1);
            var Scene = __webpack_require__(418);
            var Systems = __webpack_require__(204);
            /**
 * @classdesc
 * The Scene Manager.
 *
 * The Scene Manager is a Game level system, responsible for creating, processing and updating all of the
 * Scenes in a Game instance.
 *
 * You should not usually interact directly with the Scene Manager at all. Instead, you should use
 * the Scene Plugin, which is available from every Scene in your game via the `this.scene` property.
 *
 * Using methods in this Scene Manager directly will break queued operations and can cause runtime
 * errors. Instead, go via the Scene Plugin. Every feature this Scene Manager provides is also
 * available via the Scene Plugin.
 *
 * @class SceneManager
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Scene Manager belongs to.
 * @param {object} sceneConfig - Scene specific configuration settings.
 */ var SceneManager = new Class({
                initialize: function SceneManager(game, sceneConfig) {
                    /**
         * The Game that this SceneManager belongs to.
         *
         * @name Phaser.Scenes.SceneManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * An object that maps the keys to the scene so we can quickly get a scene from a key without iteration.
         *
         * @name Phaser.Scenes.SceneManager#keys
         * @type {Record<string, Phaser.Scene>}
         * @since 3.0.0
         */ this.keys = {};
                    /**
         * The array in which all of the scenes are kept.
         *
         * @name Phaser.Scenes.SceneManager#scenes
         * @type {Phaser.Scene[]}
         * @since 3.0.0
         */ this.scenes = [];
                    /**
         * Scenes pending to be added are stored in here until the manager has time to add it.
         *
         * @name Phaser.Scenes.SceneManager#_pending
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * An array of scenes waiting to be started once the game has booted.
         *
         * @name Phaser.Scenes.SceneManager#_start
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._start = [];
                    /**
         * An operations queue, because we don't manipulate the scenes array during processing.
         *
         * @name Phaser.Scenes.SceneManager#_queue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._queue = [];
                    /**
         * Boot time data to merge.
         *
         * @name Phaser.Scenes.SceneManager#_data
         * @type {object}
         * @private
         * @since 3.4.0
         */ this._data = {};
                    /**
         * Is the Scene Manager actively processing the Scenes list?
         *
         * @name Phaser.Scenes.SceneManager#isProcessing
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isProcessing = false;
                    /**
         * Has the Scene Manager properly started?
         *
         * @name Phaser.Scenes.SceneManager#isBooted
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.4.0
         */ this.isBooted = false;
                    /**
         * Do any of the Cameras in any of the Scenes require a custom viewport?
         * If not we can skip scissor tests.
         *
         * @name Phaser.Scenes.SceneManager#customViewports
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.customViewports = 0;
                    if (sceneConfig) {
                        if (!Array.isArray(sceneConfig)) sceneConfig = [
                            sceneConfig
                        ];
                        for(var i = 0; i < sceneConfig.length; i++)//  The i === 0 part just autostarts the first Scene given (unless it says otherwise in its config)
                        this._pending.push({
                            key: "default",
                            scene: sceneConfig[i],
                            autoStart: i === 0,
                            data: {}
                        });
                    }
                    game.events.once(GameEvents.READY, this.bootQueue, this);
                },
                /**
     * Internal first-time Scene boot handler.
     *
     * @method Phaser.Scenes.SceneManager#bootQueue
     * @private
     * @since 3.2.0
     */ bootQueue: function() {
                    if (this.isBooted) return;
                    var i;
                    var entry;
                    var key;
                    var sceneConfig;
                    for(i = 0; i < this._pending.length; i++){
                        entry = this._pending[i];
                        key = entry.key;
                        sceneConfig = entry.scene;
                        var newScene;
                        if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                        else if (typeof sceneConfig === "object") newScene = this.createSceneFromObject(key, sceneConfig);
                        else if (typeof sceneConfig === "function") newScene = this.createSceneFromFunction(key, sceneConfig);
                        //  Replace key in case the scene changed it
                        key = newScene.sys.settings.key;
                        this.keys[key] = newScene;
                        this.scenes.push(newScene);
                        //  Any data to inject?
                        if (this._data[key]) {
                            newScene.sys.settings.data = this._data[key].data;
                            if (this._data[key].autoStart) entry.autoStart = true;
                        }
                        if (entry.autoStart || newScene.sys.settings.active) this._start.push(key);
                    }
                    //  Clear the pending lists
                    this._pending.length = 0;
                    this._data = {};
                    this.isBooted = true;
                    //  _start might have been populated by the above
                    for(i = 0; i < this._start.length; i++){
                        entry = this._start[i];
                        this.start(entry);
                    }
                    this._start.length = 0;
                },
                /**
     * Process the Scene operations queue.
     *
     * @method Phaser.Scenes.SceneManager#processQueue
     * @since 3.0.0
     */ processQueue: function() {
                    var pendingLength = this._pending.length;
                    var queueLength = this._queue.length;
                    if (pendingLength === 0 && queueLength === 0) return;
                    var i;
                    var entry;
                    if (pendingLength) {
                        for(i = 0; i < pendingLength; i++){
                            entry = this._pending[i];
                            this.add(entry.key, entry.scene, entry.autoStart, entry.data);
                        }
                        //  _start might have been populated by this.add
                        for(i = 0; i < this._start.length; i++){
                            entry = this._start[i];
                            this.start(entry);
                        }
                        //  Clear the pending lists
                        this._start.length = 0;
                        this._pending.length = 0;
                        return;
                    }
                    for(i = 0; i < this._queue.length; i++){
                        entry = this._queue[i];
                        this[entry.op](entry.keyA, entry.keyB);
                    }
                    this._queue.length = 0;
                },
                /**
     * Adds a new Scene into the SceneManager.
     * You must give each Scene a unique key by which you'll identify it.
     *
     * The `sceneConfig` can be:
     *
     * * A `Phaser.Scene` object, or an object that extends it.
     * * A plain JavaScript object
     * * A JavaScript ES6 Class that extends `Phaser.Scene`
     * * A JavaScript ES5 prototype based Class
     * * A JavaScript function
     *
     * If a function is given then a new Scene will be created by calling it.
     *
     * @method Phaser.Scenes.SceneManager#add
     * @since 3.0.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig|function)} sceneConfig - The config for the Scene
     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
     * @param {object} [data] - Optional data object. This will be set as `Scene.settings.data` and passed to `Scene.init`, and `Scene.create`.
     *
     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
     */ add: function(key, sceneConfig, autoStart, data) {
                    if (autoStart === undefined) autoStart = false;
                    if (data === undefined) data = {};
                    //  If processing or not booted then put scene into a holding pattern
                    if (this.isProcessing || !this.isBooted) {
                        this._pending.push({
                            key: key,
                            scene: sceneConfig,
                            autoStart: autoStart,
                            data: data
                        });
                        if (!this.isBooted) this._data[key] = {
                            data: data
                        };
                        return null;
                    }
                    key = this.getKey(key, sceneConfig);
                    var newScene;
                    if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                    else if (typeof sceneConfig === "object") {
                        sceneConfig.key = key;
                        newScene = this.createSceneFromObject(key, sceneConfig);
                    } else if (typeof sceneConfig === "function") newScene = this.createSceneFromFunction(key, sceneConfig);
                    //  Any data to inject?
                    newScene.sys.settings.data = data;
                    //  Replace key in case the scene changed it
                    key = newScene.sys.settings.key;
                    this.keys[key] = newScene;
                    this.scenes.push(newScene);
                    if (autoStart || newScene.sys.settings.active) {
                        if (this._pending.length) this._start.push(key);
                        else this.start(key);
                    }
                    return newScene;
                },
                /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.SceneManager#remove
     * @since 3.2.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     *
     * @return {this} This Scene Manager instance.
     */ remove: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: "remove",
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var sceneToRemove = this.getScene(key);
                        if (!sceneToRemove || sceneToRemove.sys.isTransitioning()) return this;
                        var index = this.scenes.indexOf(sceneToRemove);
                        var sceneKey = sceneToRemove.sys.settings.key;
                        if (index > -1) {
                            delete this.keys[sceneKey];
                            this.scenes.splice(index, 1);
                            if (this._start.indexOf(sceneKey) > -1) {
                                index = this._start.indexOf(sceneKey);
                                this._start.splice(index, 1);
                            }
                            sceneToRemove.sys.destroy();
                        }
                    }
                    return this;
                },
                /**
     * Boot the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#bootScene
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to boot.
     */ bootScene: function(scene) {
                    var sys = scene.sys;
                    var settings = sys.settings;
                    sys.sceneUpdate = NOOP;
                    if (scene.init) {
                        scene.init.call(scene, settings.data);
                        settings.status = CONST.INIT;
                        if (settings.isTransition) sys.events.emit(Events.TRANSITION_INIT, settings.transitionFrom, settings.transitionDuration);
                    }
                    var loader;
                    if (sys.load) {
                        loader = sys.load;
                        loader.reset();
                    }
                    if (loader && scene.preload) {
                        scene.preload.call(scene);
                        //  Is the loader empty?
                        if (loader.list.size === 0) this.create(scene);
                        else {
                            settings.status = CONST.LOADING;
                            //  Start the loader going as we have something in the queue
                            loader.once(LoaderEvents.COMPLETE, this.loadComplete, this);
                            loader.start();
                        }
                    } else //  No preload? Then there was nothing to load either
                    this.create(scene);
                },
                /**
     * Handles load completion for a Scene's Loader.
     *
     * Starts the Scene that the Loader belongs to.
     *
     * @method Phaser.Scenes.SceneManager#loadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading.
     */ loadComplete: function(loader) {
                    this.create(loader.scene);
                },
                /**
     * Handle payload completion for a Scene.
     *
     * @method Phaser.Scenes.SceneManager#payloadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading its Scene's payload.
     */ payloadComplete: function(loader) {
                    this.bootScene(loader.scene);
                },
                /**
     * Updates the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#update
     * @since 3.0.0
     *
     * @param {number} time - Time elapsed.
     * @param {number} delta - Delta time from the last update.
     */ update: function(time, delta) {
                    this.processQueue();
                    this.isProcessing = true;
                    //  Loop through the active scenes in reverse order
                    for(var i = this.scenes.length - 1; i >= 0; i--){
                        var sys = this.scenes[i].sys;
                        if (sys.settings.status > CONST.START && sys.settings.status <= CONST.RUNNING) sys.step(time, delta);
                    }
                },
                /**
     * Renders the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#render
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer to use.
     */ render: function(renderer) {
                    //  Loop through the scenes in forward order
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        if (sys.settings.visible && sys.settings.status >= CONST.LOADING && sys.settings.status < CONST.SLEEPING) sys.render(renderer);
                    }
                    this.isProcessing = false;
                },
                /**
     * Calls the given Scene's {@link Phaser.Scene#create} method and updates its status.
     *
     * @method Phaser.Scenes.SceneManager#create
     * @private
     * @fires Phaser.Scenes.Events#CREATE
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to create.
     */ create: function(scene) {
                    var sys = scene.sys;
                    var settings = sys.settings;
                    if (scene.create) {
                        settings.status = CONST.CREATING;
                        scene.create.call(scene, settings.data);
                        if (settings.status === CONST.DESTROYED) return;
                    }
                    if (settings.isTransition) sys.events.emit(Events.TRANSITION_START, settings.transitionFrom, settings.transitionDuration);
                    //  If the Scene has an update function we'll set it now, otherwise it'll remain as NOOP
                    if (scene.update) sys.sceneUpdate = scene.update;
                    settings.status = CONST.RUNNING;
                    sys.events.emit(Events.CREATE, scene);
                },
                /**
     * Creates and initializes a Scene from a function.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromFunction
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {function} scene - The function to create the Scene from.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromFunction: function(key, scene) {
                    var newScene = new scene();
                    if (newScene instanceof Scene) {
                        var configKey = newScene.sys.settings.key;
                        if (configKey !== "") key = configKey;
                        if (this.keys.hasOwnProperty(key)) throw new Error("Cannot add a Scene with duplicate key: " + key);
                        return this.createSceneFromInstance(key, newScene);
                    } else {
                        newScene.sys = new Systems(newScene);
                        newScene.sys.settings.key = key;
                        newScene.sys.init(this.game);
                        return newScene;
                    }
                },
                /**
     * Creates and initializes a Scene instance.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromInstance
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {Phaser.Scene} newScene - The Scene instance.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromInstance: function(key, newScene) {
                    var configKey = newScene.sys.settings.key;
                    if (configKey === "") newScene.sys.settings.key = key;
                    newScene.sys.init(this.game);
                    return newScene;
                },
                /**
     * Creates and initializes a Scene from an Object definition.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromObject
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {(string|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig)} sceneConfig - The Scene config.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromObject: function(key, sceneConfig) {
                    var newScene = new Scene(sceneConfig);
                    var configKey = newScene.sys.settings.key;
                    if (configKey !== "") key = configKey;
                    else newScene.sys.settings.key = key;
                    newScene.sys.init(this.game);
                    //  Extract callbacks
                    var defaults = [
                        "init",
                        "preload",
                        "create",
                        "update",
                        "render"
                    ];
                    for(var i = 0; i < defaults.length; i++){
                        var sceneCallback = GetValue(sceneConfig, defaults[i], null);
                        if (sceneCallback) newScene[defaults[i]] = sceneCallback;
                    }
                    //  Now let's move across any other functions or properties that may exist in the extend object:
                    /*
        scene: {
            preload: preload,
            create: create,
            extend: {
                hello: 1,
                test: 'atari',
                addImage: addImage
            }
        }
        */ if (sceneConfig.hasOwnProperty("extend")) for(var propertyKey in sceneConfig.extend){
                        if (!sceneConfig.extend.hasOwnProperty(propertyKey)) continue;
                        var value = sceneConfig.extend[propertyKey];
                        if (propertyKey === "data" && newScene.hasOwnProperty("data") && typeof value === "object") //  Populate the DataManager
                        newScene.data.merge(value);
                        else if (propertyKey !== "sys") newScene[propertyKey] = value;
                    }
                    return newScene;
                },
                /**
     * Retrieves the key of a Scene from a Scene config.
     *
     * @method Phaser.Scenes.SceneManager#getKey
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key to check in the Scene config.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|function)} sceneConfig - The Scene config.
     *
     * @return {string} The Scene key.
     */ getKey: function(key, sceneConfig) {
                    if (!key) key = "default";
                    if (typeof sceneConfig === "function") return key;
                    else if (sceneConfig instanceof Scene) key = sceneConfig.sys.settings.key;
                    else if (typeof sceneConfig === "object" && sceneConfig.hasOwnProperty("key")) key = sceneConfig.key;
                    //  By this point it's either 'default' or extracted from the Scene
                    if (this.keys.hasOwnProperty(key)) throw new Error("Cannot add a Scene with duplicate key: " + key);
                    else return key;
                },
                /**
     * Returns an array of all the current Scenes being managed by this Scene Manager.
     *
     * You can filter the output by the active state of the Scene and choose to have
     * the array returned in normal or reversed order.
     *
     * @method Phaser.Scenes.SceneManager#getScenes
     * @since 3.16.0
     *
     * @param {boolean} [isActive=true] - Only include Scene's that are currently active?
     * @param {boolean} [inReverse=false] - Return the array of Scenes in reverse?
     *
     * @return {Phaser.Scene[]} An array containing all of the Scenes in the Scene Manager.
     */ getScenes: function(isActive, inReverse) {
                    if (isActive === undefined) isActive = true;
                    if (inReverse === undefined) inReverse = false;
                    var out = [];
                    var scenes = this.scenes;
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene && (!isActive || isActive && scene.sys.isActive())) out.push(scene);
                    }
                    return inReverse ? out.reverse() : out;
                },
                /**
     * Retrieves a Scene.
     *
     * @method Phaser.Scenes.SceneManager#getScene
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to retrieve.
     *
     * @return {?Phaser.Scene} The Scene.
     */ getScene: function(key) {
                    if (typeof key === "string") {
                        if (this.keys[key]) return this.keys[key];
                    } else for(var i = 0; i < this.scenes.length; i++){
                        if (key === this.scenes[i]) return key;
                    }
                    return null;
                },
                /**
     * Determines whether a Scene is running.
     *
     * @method Phaser.Scenes.SceneManager#isActive
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running, or `null` if no matching Scene was found.
     */ isActive: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isActive();
                    return null;
                },
                /**
     * Determines whether a Scene is paused.
     *
     * @method Phaser.Scenes.SceneManager#isPaused
     * @since 3.17.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused, or `null` if no matching Scene was found.
     */ isPaused: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isPaused();
                    return null;
                },
                /**
     * Determines whether a Scene is visible.
     *
     * @method Phaser.Scenes.SceneManager#isVisible
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible, or `null` if no matching Scene was found.
     */ isVisible: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isVisible();
                    return null;
                },
                /**
     * Determines whether a Scene is sleeping.
     *
     * @method Phaser.Scenes.SceneManager#isSleeping
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping, or `null` if no matching Scene was found.
     */ isSleeping: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isSleeping();
                    return null;
                },
                /**
     * Pauses the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#pause
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its pause event.
     *
     * @return {this} This Scene Manager instance.
     */ pause: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.pause(data);
                    return this;
                },
                /**
     * Resumes the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#resume
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its resume event.
     *
     * @return {this} This Scene Manager instance.
     */ resume: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.resume(data);
                    return this;
                },
                /**
     * Puts the given Scene to sleep.
     *
     * @method Phaser.Scenes.SceneManager#sleep
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its sleep event.
     *
     * @return {this} This Scene Manager instance.
     */ sleep: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene && !scene.sys.isTransitioning()) scene.sys.sleep(data);
                    return this;
                },
                /**
     * Awakens the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#wake
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its wake event.
     *
     * @return {this} This Scene Manager instance.
     */ wake: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.wake(data);
                    return this;
                },
                /**
     * Runs the given Scene.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.SceneManager#run
     * @since 3.10.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene on start, wake, or resume.
     *
     * @return {this} This Scene Manager instance.
     */ run: function(key, data) {
                    var scene = this.getScene(key);
                    if (!scene) {
                        for(var i = 0; i < this._pending.length; i++)if (this._pending[i].key === key) {
                            this.queueOp("start", key, data);
                            break;
                        }
                        return this;
                    }
                    if (scene.sys.isSleeping()) //  Sleeping?
                    scene.sys.wake(data);
                    else if (scene.sys.isPaused()) //  Paused?
                    scene.sys.resume(data);
                    else //  Not actually running?
                    this.start(key, data);
                },
                /**
     * Starts the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#start
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to start.
     * @param {object} [data] - Optional data object to pass to `Scene.Settings` and `Scene.init`, and `Scene.create`.
     *
     * @return {this} This Scene Manager instance.
     */ start: function(key, data) {
                    //  If the Scene Manager is not running, then put the Scene into a holding pattern
                    if (!this.isBooted) {
                        this._data[key] = {
                            autoStart: true,
                            data: data
                        };
                        return this;
                    }
                    var scene = this.getScene(key);
                    if (scene) {
                        var sys = scene.sys;
                        //  If the Scene is already running (perhaps they called start from a launched sub-Scene?)
                        //  then we close it down before starting it again.
                        if (sys.isActive() || sys.isPaused()) {
                            sys.shutdown();
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                        } else {
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                            var loader;
                            if (sys.load) loader = sys.load;
                            //  Files payload?
                            if (loader && sys.settings.hasOwnProperty("pack")) {
                                loader.reset();
                                if (loader.addPack({
                                    payload: sys.settings.pack
                                })) {
                                    sys.settings.status = CONST.LOADING;
                                    loader.once(LoaderEvents.COMPLETE, this.payloadComplete, this);
                                    loader.start();
                                    return this;
                                }
                            }
                        }
                        this.bootScene(scene);
                    }
                    return this;
                },
                /**
     * Stops the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#stop
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to stop.
     * @param {object} [data] - Optional data object to pass to Scene.shutdown.
     *
     * @return {this} This Scene Manager instance.
     */ stop: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene && !scene.sys.isTransitioning()) scene.sys.shutdown(data);
                    return this;
                },
                /**
     * Sleeps one one Scene and starts the other.
     *
     * @method Phaser.Scenes.SceneManager#switch
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} from - The Scene to sleep.
     * @param {(string|Phaser.Scene)} to - The Scene to start.
     *
     * @return {this} This Scene Manager instance.
     */ switch: function(from, to) {
                    var sceneA = this.getScene(from);
                    var sceneB = this.getScene(to);
                    if (sceneA && sceneB && sceneA !== sceneB) {
                        this.sleep(from);
                        if (this.isSleeping(to)) this.wake(to);
                        else this.start(to);
                    }
                    return this;
                },
                /**
     * Retrieves a Scene by numeric index.
     *
     * @method Phaser.Scenes.SceneManager#getAt
     * @since 3.0.0
     *
     * @param {number} index - The index of the Scene to retrieve.
     *
     * @return {(Phaser.Scene|undefined)} The Scene.
     */ getAt: function(index) {
                    return this.scenes[index];
                },
                /**
     * Retrieves the numeric index of a Scene.
     *
     * @method Phaser.Scenes.SceneManager#getIndex
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The key of the Scene.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                    var scene = this.getScene(key);
                    return this.scenes.indexOf(scene);
                },
                /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#bringToTop
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ bringToTop: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: "bringToTop",
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var index = this.getIndex(key);
                        if (index !== -1 && index < this.scenes.length) {
                            var scene = this.getScene(key);
                            this.scenes.splice(index, 1);
                            this.scenes.push(scene);
                        }
                    }
                    return this;
                },
                /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#sendToBack
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ sendToBack: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: "sendToBack",
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var index = this.getIndex(key);
                        if (index !== -1 && index > 0) {
                            var scene = this.getScene(key);
                            this.scenes.splice(index, 1);
                            this.scenes.unshift(scene);
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveDown
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ moveDown: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: "moveDown",
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var indexA = this.getIndex(key);
                        if (indexA > 0) {
                            var indexB = indexA - 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveUp
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {this} This Scene Manager instance.
     */ moveUp: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: "moveUp",
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var indexA = this.getIndex(key);
                        if (indexA < this.scenes.length - 1) {
                            var indexB = indexA + 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene so it is immediately above another Scene in the Scenes list.
     *
     * This means it will render over the top of the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveAbove
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {this} This Scene Manager instance.
     */ moveAbove: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: "moveAbove",
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            //  Add in new location
                            this.scenes.splice(indexA + 1, 0, tempScene);
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene so it is immediately below another Scene in the Scenes list.
     *
     * This means it will render behind the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveBelow
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {this} This Scene Manager instance.
     */ moveBelow: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: "moveBelow",
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            if (indexA === 0) this.scenes.unshift(tempScene);
                            else //  Add in new location
                            this.scenes.splice(indexA, 0, tempScene);
                        }
                    }
                    return this;
                },
                /**
     * Queue a Scene operation for the next update.
     *
     * @method Phaser.Scenes.SceneManager#queueOp
     * @private
     * @since 3.0.0
     *
     * @param {string} op - The operation to perform.
     * @param {(string|Phaser.Scene)} keyA - Scene A.
     * @param {(any|string|Phaser.Scene)} [keyB] - Scene B, or a data object.
     *
     * @return {this} This Scene Manager instance.
     */ queueOp: function(op, keyA, keyB) {
                    this._queue.push({
                        op: op,
                        keyA: keyA,
                        keyB: keyB
                    });
                    return this;
                },
                /**
     * Swaps the positions of two Scenes in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#swapPosition
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
     * @param {(string|Phaser.Scene)} keyB - The second Scene to swap.
     *
     * @return {this} This Scene Manager instance.
     */ swapPosition: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: "swapPosition",
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== indexB && indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexA);
                            this.scenes[indexA] = this.scenes[indexB];
                            this.scenes[indexB] = tempScene;
                        }
                    }
                    return this;
                },
                /**
     * Dumps debug information about each Scene to the developer console.
     *
     * @method Phaser.Scenes.SceneManager#dump
     * @since 3.2.0
     */ dump: function() {
                    var out = [];
                    var map = [
                        "pending",
                        "init",
                        "start",
                        "loading",
                        "creating",
                        "running",
                        "paused",
                        "sleeping",
                        "shutdown",
                        "destroyed"
                    ];
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        var key = sys.settings.visible && (sys.settings.status === CONST.RUNNING || sys.settings.status === CONST.PAUSED) ? "[*] " : "[-] ";
                        key += sys.settings.key + " (" + map[sys.settings.status] + ")";
                        out.push(key);
                    }
                    console.log(out.join("\n"));
                },
                /**
     * Destroy this Scene Manager and all of its systems.
     *
     * This process cannot be reversed.
     *
     * This method is called automatically when a Phaser Game instance is destroyed.
     *
     * @method Phaser.Scenes.SceneManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        sys.destroy();
                    }
                    this.update = NOOP;
                    this.scenes = [];
                    this._pending = [];
                    this._start = [];
                    this._queue = [];
                    this.game = null;
                }
            });
            module1.exports = SceneManager;
        /***/ },
        /* 418 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Systems = __webpack_require__(204);
            /**
 * @classdesc
 * A base Phaser.Scene class which can be extended for your own use.
 *
 * You can also define the optional methods {@link Phaser.Types.Scenes.SceneInitCallback init()}, {@link Phaser.Types.Scenes.ScenePreloadCallback preload()}, and {@link Phaser.Types.Scenes.SceneCreateCallback create()}.
 *
 * @class Scene
 * @memberof Phaser
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - Scene specific configuration settings.
 */ var Scene = new Class({
                initialize: function Scene(config) {
                    /**
         * The Scene Systems. You must never overwrite this property, or all hell will break lose.
         *
         * @name Phaser.Scene#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = new Systems(this, config);
                    /**
         * A reference to the Phaser.Game instance.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                    /**
         * A reference to the global Animation Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                    /**
         * A reference to the global Cache.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                    /**
         * A reference to the global Data Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                    /**
         * A reference to the Sound Manager.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound;
                    /**
         * A reference to the Texture Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                    /**
         * A Scene specific Event Emitter.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                    /**
         * The Scene Camera Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    /**
         * The Scene Game Object Factory.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                    /**
         * The Scene Game Object Creator.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                    /**
         * A reference to the Scene Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scene
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scene;
                    /**
         * The Game Object Display List belonging to this Scene.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#children
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.children;
                    /**
         * The Scene Lights Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#lights
         * @type {Phaser.GameObjects.LightsManager}
         * @since 3.0.0
         */ this.lights;
                    /**
         * A Scene specific Data Manager Plugin.
         *
         * See the `registry` property for the global Data Manager.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#data
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.data;
                    /**
         * The Scene Input Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#input
         * @type {Phaser.Input.InputPlugin}
         * @since 3.0.0
         */ this.input;
                    /**
         * The Scene Loader Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#load
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.load;
                    /**
         * The Scene Time and Clock Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#time
         * @type {Phaser.Time.Clock}
         * @since 3.0.0
         */ this.time;
                    /**
         * The Scene Tween Manager Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#tweens
         * @type {Phaser.Tweens.TweenManager}
         * @since 3.0.0
         */ this.tweens;
                    /**
         * The Scene Arcade Physics Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#physics
         * @type {Phaser.Physics.Arcade.ArcadePhysics}
         * @since 3.0.0
         */ this.physics;
                    /**
         * The Scene Matter Physics Plugin.
         *
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#matter
         * @type {Phaser.Physics.Matter.MatterPhysics}
         * @since 3.0.0
         */ this.matter;
                    /**
         * A reference to the global Scale Manager.
         *
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.2
         */ this.scale;
                    /**
         * A reference to the global Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Scene#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                    /**
         * A reference to the renderer instance Phaser is using, either Canvas Renderer or WebGL Renderer.
         *
         * @name Phaser.Scene#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.50.0
         */ this.renderer;
                },
                /**
     * This method should be overridden by your own Scenes.
     *
     * This method is called once per game step while the scene is running.
     *
     * @method Phaser.Scene#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function() {}
            });
            module1.exports = Scene;
        /***/ },
        /* 419 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var UppercaseFirst = __webpack_require__(205);
            /**
 * Builds an array of which physics plugins should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetPhysicsPlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The scene system to get the physics systems of.
 *
 * @return {array} An array of Physics systems to start for this Scene.
 */ var GetPhysicsPlugins = function(sys) {
                var defaultSystem = sys.game.config.defaultPhysicsSystem;
                var sceneSystems = GetFastValue(sys.settings, "physics", false);
                if (!defaultSystem && !sceneSystems) //  No default physics system or systems in this scene
                return;
                //  Let's build the systems array
                var output = [];
                if (defaultSystem) output.push(UppercaseFirst(defaultSystem + "Physics"));
                if (sceneSystems) for(var key in sceneSystems){
                    key = UppercaseFirst(key.concat("Physics"));
                    if (output.indexOf(key) === -1) output.push(key);
                }
                //  An array of Physics systems to start for this Scene
                return output;
            };
            module1.exports = GetPhysicsPlugins;
        /***/ },
        /* 420 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Builds an array of which plugins (not including physics plugins) should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetScenePlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The Scene Systems object to check for plugins.
 *
 * @return {array} An array of all plugins which should be activated, either the default ones or the ones configured in the Scene Systems object.
 */ var GetScenePlugins = function(sys) {
                var defaultPlugins = sys.plugins.getDefaultScenePlugins();
                var scenePlugins = GetFastValue(sys.settings, "plugins", false);
                //  Scene Plugins always override Default Plugins
                if (Array.isArray(scenePlugins)) return scenePlugins;
                else if (defaultPlugins) return defaultPlugins;
                else //  No default plugins or plugins in this scene
                return [];
            };
            module1.exports = GetScenePlugins;
        /***/ },
        /* 421 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(144);
            var GetValue = __webpack_require__(6);
            var Merge = __webpack_require__(127);
            var InjectionMap = __webpack_require__(978);
            /**
 * @namespace Phaser.Scenes.Settings
 */ var Settings = {
                /**
     * Takes a Scene configuration object and returns a fully formed System Settings object.
     *
     * @function Phaser.Scenes.Settings.create
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - The Scene configuration object used to create this Scene Settings.
     *
     * @return {Phaser.Types.Scenes.SettingsObject} The Scene Settings object created as a result of the config and default settings.
     */ create: function(config) {
                    if (typeof config === "string") config = {
                        key: config
                    };
                    else if (config === undefined) //  Pass the 'hasOwnProperty' checks
                    config = {};
                    return {
                        status: CONST.PENDING,
                        key: GetValue(config, "key", ""),
                        active: GetValue(config, "active", false),
                        visible: GetValue(config, "visible", true),
                        isBooted: false,
                        isTransition: false,
                        transitionFrom: null,
                        transitionDuration: 0,
                        transitionAllowInput: true,
                        //  Loader payload array
                        data: {},
                        pack: GetValue(config, "pack", false),
                        //  Cameras
                        cameras: GetValue(config, "cameras", null),
                        //  Scene Property Injection Map
                        map: GetValue(config, "map", Merge(InjectionMap, GetValue(config, "mapAdd", {}))),
                        //  Physics
                        physics: GetValue(config, "physics", {}),
                        //  Loader
                        loader: GetValue(config, "loader", {}),
                        //  Plugins
                        plugins: GetValue(config, "plugins", false),
                        //  Input
                        input: GetValue(config, "input", {})
                    };
                }
            };
            module1.exports = Settings;
        /***/ },
        /* 422 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var CanvasTexture = __webpack_require__(423);
            var Class = __webpack_require__(0);
            var Color = __webpack_require__(38);
            var CONST = __webpack_require__(33);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(106);
            var GameEvents = __webpack_require__(22);
            var GenerateTexture = __webpack_require__(388);
            var GetValue = __webpack_require__(6);
            var Parser = __webpack_require__(425);
            var Texture = __webpack_require__(206);
            /**
 * @callback EachTextureCallback
 *
 * @param {Phaser.Textures.Texture} texture - Each texture in Texture Manager.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * Textures are managed by the global TextureManager. This is a singleton class that is
 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
 *
 * Sprites and other Game Objects get the texture data they need from the TextureManager.
 *
 * Access it via `scene.textures`.
 *
 * @class TextureManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Texture Manager belongs to.
 */ var TextureManager = new Class({
                Extends: EventEmitter,
                initialize: function TextureManager(game) {
                    EventEmitter.call(this);
                    /**
         * The Game that this TextureManager belongs to.
         *
         * @name Phaser.Textures.TextureManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The name of this manager.
         *
         * @name Phaser.Textures.TextureManager#name
         * @type {string}
         * @since 3.0.0
         */ this.name = "TextureManager";
                    /**
         * An object that has all of textures that Texture Manager creates.
         * Textures are assigned to keys so we can access to any texture that this object has directly by key value without iteration.
         *
         * @name Phaser.Textures.TextureManager#list
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                    /**
         * The temporary canvas element to save an pixel data of an arbitrary texture in getPixel() and getPixelAlpha() method.
         *
         * @name Phaser.Textures.TextureManager#_tempCanvas
         * @type {HTMLCanvasElement}
         * @private
         * @since 3.0.0
         */ this._tempCanvas = CanvasPool.create2D(this, 1, 1);
                    /**
         * The context of the temporary canvas element made to save an pixel data in getPixel() and getPixelAlpha() method.
         *
         * @name Phaser.Textures.TextureManager#_tempContext
         * @type {CanvasRenderingContext2D}
         * @private
         * @since 3.0.0
         */ this._tempContext = this._tempCanvas.getContext("2d");
                    /**
         * An counting value used for emitting 'ready' event after all of managers in game is loaded.
         *
         * @name Phaser.Textures.TextureManager#_pending
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pending = 0;
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot Handler called by Phaser.Game when it first starts up.
     *
     * @method Phaser.Textures.TextureManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    this._pending = 3;
                    this.on(Events.LOAD, this.updatePending, this);
                    this.on(Events.ERROR, this.updatePending, this);
                    var config = this.game.config;
                    this.addBase64("__DEFAULT", config.defaultImage);
                    this.addBase64("__MISSING", config.missingImage);
                    this.addBase64("__WHITE", config.whiteImage);
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * After 'onload' or 'onerror' invoked twice, emit 'ready' event.
     *
     * @method Phaser.Textures.TextureManager#updatePending
     * @private
     * @since 3.0.0
     */ updatePending: function() {
                    this._pending--;
                    if (this._pending === 0) {
                        this.off(Events.LOAD);
                        this.off(Events.ERROR);
                        this.emit(Events.READY);
                    }
                },
                /**
     * Checks the given texture key and throws a console.warn if the key is already in use, then returns false.
     * If you wish to avoid the console.warn then use `TextureManager.exists` instead.
     *
     * @method Phaser.Textures.TextureManager#checkKey
     * @since 3.7.0
     *
     * @param {string} key - The texture key to check.
     *
     * @return {boolean} `true` if it's safe to use the texture key, otherwise `false`.
     */ checkKey: function(key) {
                    if (this.exists(key)) {
                        // eslint-disable-next-line no-console
                        console.error("Texture key already in use: " + key);
                        return false;
                    }
                    return true;
                },
                /**
     * Removes a Texture from the Texture Manager and destroys it. This will immediately
     * clear all references to it from the Texture Manager, and if it has one, destroy its
     * WebGLTexture. This will emit a `removetexture` event.
     *
     * Note: If you have any Game Objects still using this texture they will start throwing
     * errors the next time they try to render. Make sure that removing the texture is the final
     * step when clearing down to avoid this.
     *
     * @method Phaser.Textures.TextureManager#remove
     * @fires Phaser.Textures.Events#REMOVE
     * @since 3.7.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the Texture to remove, or a reference to it.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ remove: function(key) {
                    if (typeof key === "string") {
                        if (this.exists(key)) key = this.get(key);
                        else {
                            console.warn("No texture found matching key: " + key);
                            return this;
                        }
                    }
                    //  By this point key should be a Texture, if not, the following fails anyway
                    if (this.list.hasOwnProperty(key.key)) {
                        key.destroy();
                        this.emit(Events.REMOVE, key.key);
                    }
                    return this;
                },
                /**
     * Removes a key from the Texture Manager but does not destroy the Texture that was using the key.
     *
     * @method Phaser.Textures.TextureManager#removeKey
     * @since 3.17.0
     *
     * @param {string} key - The key to remove from the texture list.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ removeKey: function(key) {
                    if (this.list.hasOwnProperty(key)) delete this.list[key];
                    return this;
                },
                /**
     * Adds a new Texture to the Texture Manager created from the given Base64 encoded data.
     *
     * It works by creating an `Image` DOM object, then setting the `src` attribute to
     * the given base64 encoded data. As a result, the process is asynchronous by its nature,
     * so be sure to listen for the events this method dispatches before using the texture.
     *
     * @method Phaser.Textures.TextureManager#addBase64
     * @fires Phaser.Textures.Events#ADD
     * @fires Phaser.Textures.Events#ERROR
     * @fires Phaser.Textures.Events#LOAD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {*} data - The Base64 encoded data.
     *
     * @return {this} This Texture Manager instance.
     */ addBase64: function(key, data) {
                    if (this.checkKey(key)) {
                        var _this = this;
                        var image = new Image();
                        image.onerror = function() {
                            _this.emit(Events.ERROR, key);
                        };
                        image.onload = function() {
                            var texture = _this.create(key, image);
                            Parser.Image(texture, 0);
                            _this.emit(Events.ADD, key, texture);
                            _this.emit(Events.LOAD, key, texture);
                        };
                        image.src = data;
                    }
                    return this;
                },
                /**
     * Gets an existing texture frame and converts it into a base64 encoded image and returns the base64 data.
     *
     * You can also provide the image type and encoder options.
     *
     * This will only work with bitmap based texture frames, such as those created from Texture Atlases.
     * It will not work with GL Texture objects, such as Shaders, or Render Textures. For those please
     * see the WebGL Snapshot function instead.
     *
     * @method Phaser.Textures.TextureManager#getBase64
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {string} [type='image/png'] - A DOMString indicating the image format. The default format type is image/png.
     * @param {number} [encoderOptions=0.92] - A Number between 0 and 1 indicating the image quality to use for image formats that use lossy compression such as image/jpeg and image/webp. If this argument is anything else, the default value for image quality is used. The default value is 0.92. Other arguments are ignored.
     *
     * @return {string} The base64 encoded data, or an empty string if the texture frame could not be found.
     */ getBase64: function(key, frame, type, encoderOptions) {
                    if (type === undefined) type = "image/png";
                    if (encoderOptions === undefined) encoderOptions = 0.92;
                    var data = "";
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame && (textureFrame.source.isRenderTexture || textureFrame.source.isGLTexture)) console.warn("Cannot getBase64 from WebGL Texture");
                    else if (textureFrame) {
                        var cd = textureFrame.canvasData;
                        var canvas = CanvasPool.create2D(this, cd.width, cd.height);
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(textureFrame.source.image, cd.x, cd.y, cd.width, cd.height, 0, 0, cd.width, cd.height);
                        data = canvas.toDataURL(type, encoderOptions);
                        CanvasPool.remove(canvas);
                    }
                    return data;
                },
                /**
     * Adds a new Texture to the Texture Manager created from the given Image element.
     *
     * @method Phaser.Textures.TextureManager#addImage
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {HTMLImageElement|HTMLCanvasElement} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addImage: function(key, source, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.Image(texture, 0);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Takes a WebGL Texture and creates a Phaser Texture from it, which is added to the Texture Manager using the given key.
     *
     * This allows you to then use the Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * If the `width` and `height` arguments are omitted, but the WebGL Texture was created by Phaser's WebGL Renderer
     * and has `glTexture.width` and `glTexture.height` properties, these values will be used instead.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.Textures.TextureManager#addGLTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.19.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {WebGLTexture} glTexture - The source Render Texture.
     * @param {number} [width] - The new width of the Texture. Read from `glTexture.width` if omitted.
     * @param {number} [height] - The new height of the Texture. Read from `glTexture.height` if omitted.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addGLTexture: function(key, glTexture, width, height) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        if (width === undefined) width = glTexture.width;
                        if (height === undefined) height = glTexture.height;
                        texture = this.create(key, glTexture, width, height);
                        texture.add("__BASE", 0, 0, 0, width, height);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Render Texture to the Texture Manager using the given key.
     * This allows you to then use the Render Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * @method Phaser.Textures.TextureManager#addRenderTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.GameObjects.RenderTexture} renderTexture - The source Render Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addRenderTexture: function(key, renderTexture) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, renderTexture);
                        texture.add("__BASE", 0, 0, 0, renderTexture.width, renderTexture.height);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Creates a new Texture using the given config values.
     *
     * Generated textures consist of a Canvas element to which the texture data is drawn.
     *
     * Generates a texture based on the given Create configuration object.
     *
     * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
     * data cells map to a single color. For example, if the texture config looked like this:
     *
     * ```javascript
     * var star = [
     *   '.....828.....',
     *   '....72227....',
     *   '....82228....',
     *   '...7222227...',
     *   '2222222222222',
     *   '8222222222228',
     *   '.72222222227.',
     *   '..787777787..',
     *   '..877777778..',
     *   '.78778887787.',
     *   '.27887.78872.',
     *   '.787.....787.'
     * ];
     *
     * this.textures.generate('star', { data: star, pixelWidth: 4 });
     * ```
     *
     * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
     * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
     * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
     *
     * The default palette is Arne16, but you can specify your own using the `palette` property.
     *
     * @method Phaser.Textures.TextureManager#generate
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Create.GenerateTextureConfig} config - The configuration object needed to generate the texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ generate: function(key, config) {
                    if (this.checkKey(key)) {
                        var canvas = CanvasPool.create(this, 1, 1);
                        config.canvas = canvas;
                        GenerateTexture(config);
                        return this.addCanvas(key, canvas);
                    } else return null;
                },
                /**
     * Creates a new Texture using a blank Canvas element of the size given.
     *
     * Canvas elements are automatically pooled and calling this method will
     * extract a free canvas from the CanvasPool, or create one if none are available.
     *
     * @method Phaser.Textures.TextureManager#createCanvas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {number} [width=256] - The width of the Canvas element.
     * @param {number} [height=256] - The height of the Canvas element.
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ createCanvas: function(key, width, height) {
                    if (width === undefined) width = 256;
                    if (height === undefined) height = 256;
                    if (this.checkKey(key)) {
                        var canvas = CanvasPool.create(this, width, height, CONST.CANVAS, true);
                        return this.addCanvas(key, canvas);
                    }
                    return null;
                },
                /**
     * Creates a new Canvas Texture object from an existing Canvas element
     * and adds it to this Texture Manager, unless `skipCache` is true.
     *
     * @method Phaser.Textures.TextureManager#addCanvas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLCanvasElement} source - The Canvas element to form the base of the new Texture.
     * @param {boolean} [skipCache=false] - Skip adding this Texture into the Cache?
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ addCanvas: function(key, source, skipCache) {
                    if (skipCache === undefined) skipCache = false;
                    var texture = null;
                    if (skipCache) texture = new CanvasTexture(this, key, source, source.width, source.height);
                    else if (this.checkKey(key)) {
                        texture = new CanvasTexture(this, key, source, source.width, source.height);
                        this.list[key] = texture;
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a new Texture Atlas to this Texture Manager.
     * It can accept either JSON Array or JSON Hash formats, as exported by Texture Packer and similar software.
     *
     * @method Phaser.Textures.TextureManager#addAtlas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlas: function(key, source, data, dataSource) {
                    //  New Texture Packer format?
                    if (Array.isArray(data.textures) || Array.isArray(data.frames)) return this.addAtlasJSONArray(key, source, data, dataSource);
                    else return this.addAtlasJSONHash(key, source, data, dataSource);
                },
                /**
     * Adds a Texture Atlas to this Texture Manager.
     * The frame data of the atlas must be stored in an Array within the JSON.
     * This is known as a JSON Array in software such as Texture Packer.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONArray
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLImageElement[])} source - The source Image element/s.
     * @param {(object|object[])} data - The Texture Atlas data/s.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONArray: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        //  Multi-Atlas?
                        if (Array.isArray(data)) {
                            var singleAtlasFile = data.length === 1; // multi-pack with one atlas file for all images
                            //  !! Assumes the textures are in the same order in the source array as in the json data !!
                            for(var i = 0; i < texture.source.length; i++){
                                var atlasData = singleAtlasFile ? data[0] : data[i];
                                Parser.JSONArray(texture, i, atlasData);
                            }
                        } else Parser.JSONArray(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Texture Atlas to this Texture Manager.
     * The frame data of the atlas must be stored in an Object within the JSON.
     * This is known as a JSON Hash in software such as Texture Packer.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONHash
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONHash: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)Parser.JSONHash(texture, i, data[i]);
                        else Parser.JSONHash(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Texture Atlas to this Texture Manager, where the atlas data is given
     * in the XML format.
     *
     * @method Phaser.Textures.TextureManager#addAtlasXML
     * @fires Phaser.Textures.Events#ADD
     * @since 3.7.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas XML data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasXML: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.AtlasXML(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Unity Texture Atlas to this Texture Manager.
     * The data must be in the form of a Unity YAML file.
     *
     * @method Phaser.Textures.TextureManager#addUnityAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addUnityAtlas: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.UnityYAML(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Sprite Sheet to this Texture Manager.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheet
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {Phaser.Types.Textures.SpriteSheetConfig} config - The configuration object for this Sprite Sheet.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addSpriteSheet: function(key, source, config) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        var width = texture.source[0].width;
                        var height = texture.source[0].height;
                        Parser.SpriteSheet(texture, 0, 0, 0, width, height, config);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Sprite Sheet to this Texture Manager, where the Sprite Sheet exists as a Frame within a Texture Atlas.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheetFromAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Textures.SpriteSheetFromAtlasConfig} config - The configuration object for this Sprite Sheet.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addSpriteSheetFromAtlas: function(key, config) {
                    if (!this.checkKey(key)) return null;
                    var atlasKey = GetValue(config, "atlas", null);
                    var atlasFrame = GetValue(config, "frame", null);
                    if (!atlasKey || !atlasFrame) return;
                    var atlas = this.get(atlasKey);
                    var sheet = atlas.get(atlasFrame);
                    if (sheet) {
                        var texture = this.create(key, sheet.source.image);
                        if (sheet.trimmed) //  If trimmed we need to help the parser adjust
                        Parser.SpriteSheetFromAtlas(texture, sheet, config);
                        else Parser.SpriteSheet(texture, 0, sheet.cutX, sheet.cutY, sheet.cutWidth, sheet.cutHeight, config);
                        this.emit(Events.ADD, key, texture);
                        return texture;
                    }
                },
                /**
     * Creates a new Texture using the given source and dimensions.
     *
     * @method Phaser.Textures.TextureManager#create
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {number} width - The width of the Texture.
     * @param {number} height - The height of the Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ create: function(key, source, width, height) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = new Texture(this, key, source, width, height);
                        this.list[key] = texture;
                    }
                    return texture;
                },
                /**
     * Checks the given key to see if a Texture using it exists within this Texture Manager.
     *
     * @method Phaser.Textures.TextureManager#exists
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     *
     * @return {boolean} Returns `true` if a Texture matching the given key exists in this Texture Manager.
     */ exists: function(key) {
                    return this.list.hasOwnProperty(key);
                },
                /**
     * Returns a Texture from the Texture Manager that matches the given key.
     *
     * If the key is `undefined` it will return the `__DEFAULT` Texture.
     *
     * If the key is an instance of a Texture, it will return the key directly.
     *
     * Finally. if the key is given, but not found and not a Texture instance, it will return the `__MISSING` Texture.
     *
     * @method Phaser.Textures.TextureManager#get
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The unique string-based key of the Texture, or a Texture instance.
     *
     * @return {Phaser.Textures.Texture} The Texture that was created.
     */ get: function(key) {
                    if (key === undefined) key = "__DEFAULT";
                    if (this.list[key]) return this.list[key];
                    else if (key instanceof Texture) return key;
                    else return this.list["__MISSING"];
                },
                /**
     * Takes a Texture key and Frame name and returns a clone of that Frame if found.
     *
     * @method Phaser.Textures.TextureManager#cloneFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} frame - The string or index of the Frame to be cloned.
     *
     * @return {Phaser.Textures.Frame} A Clone of the given Frame.
     */ cloneFrame: function(key, frame) {
                    if (this.list[key]) return this.list[key].get(frame).clone();
                },
                /**
     * Takes a Texture key and Frame name and returns a reference to that Frame, if found.
     *
     * @method Phaser.Textures.TextureManager#getFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     *
     * @return {Phaser.Textures.Frame} A Texture Frame object.
     */ getFrame: function(key, frame) {
                    if (this.list[key]) return this.list[key].get(frame);
                },
                /**
     * Returns an array with all of the keys of all Textures in this Texture Manager.
     * The output array will exclude the `__DEFAULT` and `__MISSING` keys.
     *
     * @method Phaser.Textures.TextureManager#getTextureKeys
     * @since 3.0.0
     *
     * @return {string[]} An array containing all of the Texture keys stored in this Texture Manager.
     */ getTextureKeys: function() {
                    var output = [];
                    for(var key in this.list)if (key !== "__DEFAULT" && key !== "__MISSING") output.push(key);
                    return output;
                },
                /**
     * Given a Texture and an `x` and `y` coordinate this method will return a new
     * Color object that has been populated with the color and alpha values of the pixel
     * at that location in the Texture.
     *
     * @method Phaser.Textures.TextureManager#getPixel
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {?Phaser.Display.Color} A Color object populated with the color values of the requested pixel,
     * or `null` if the coordinates were out of bounds.
     */ getPixel: function(x, y, key, frame) {
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame) {
                        //  Adjust for trim (if not trimmed x and y are just zero)
                        x -= textureFrame.x;
                        y -= textureFrame.y;
                        var data = textureFrame.data.cut;
                        x += data.x;
                        y += data.y;
                        if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                            var ctx = this._tempContext;
                            ctx.clearRect(0, 0, 1, 1);
                            ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                            var rgb = ctx.getImageData(0, 0, 1, 1);
                            return new Color(rgb.data[0], rgb.data[1], rgb.data[2], rgb.data[3]);
                        }
                    }
                    return null;
                },
                /**
     * Given a Texture and an `x` and `y` coordinate this method will return a value between 0 and 255
     * corresponding to the alpha value of the pixel at that location in the Texture. If the coordinate
     * is out of bounds it will return null.
     *
     * @method Phaser.Textures.TextureManager#getPixelAlpha
     * @since 3.10.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {number} A value between 0 and 255, or `null` if the coordinates were out of bounds.
     */ getPixelAlpha: function(x, y, key, frame) {
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame) {
                        //  Adjust for trim (if not trimmed x and y are just zero)
                        x -= textureFrame.x;
                        y -= textureFrame.y;
                        var data = textureFrame.data.cut;
                        x += data.x;
                        y += data.y;
                        if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                            var ctx = this._tempContext;
                            ctx.clearRect(0, 0, 1, 1);
                            ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                            var rgb = ctx.getImageData(0, 0, 1, 1);
                            return rgb.data[3];
                        }
                    }
                    return null;
                },
                /**
     * Sets the given Game Objects `texture` and `frame` properties so that it uses
     * the Texture and Frame specified in the `key` and `frame` arguments to this method.
     *
     * @method Phaser.Textures.TextureManager#setTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the texture would be set on.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object the texture was set on.
     */ setTexture: function(gameObject, key, frame) {
                    if (this.list[key]) {
                        gameObject.texture = this.list[key];
                        gameObject.frame = gameObject.texture.get(frame);
                    }
                    return gameObject;
                },
                /**
     * Changes the key being used by a Texture to the new key provided.
     *
     * The old key is removed, allowing it to be re-used.
     *
     * Game Objects are linked to Textures by a reference to the Texture object, so
     * all existing references will be retained.
     *
     * @method Phaser.Textures.TextureManager#renameTexture
     * @since 3.12.0
     *
     * @param {string} currentKey - The current string-based key of the Texture you wish to rename.
     * @param {string} newKey - The new unique string-based key to use for the Texture.
     *
     * @return {boolean} `true` if the Texture key was successfully renamed, otherwise `false`.
     */ renameTexture: function(currentKey, newKey) {
                    var texture = this.get(currentKey);
                    if (texture && currentKey !== newKey) {
                        texture.key = newKey;
                        this.list[newKey] = texture;
                        delete this.list[currentKey];
                        return true;
                    }
                    return false;
                },
                /**
     * Passes all Textures to the given callback.
     *
     * @method Phaser.Textures.TextureManager#each
     * @since 3.0.0
     *
     * @param {EachTextureCallback} callback - The callback function to be sent the Textures.
     * @param {object} scope - The value to use as `this` when executing the callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, scope) {
                    var args = [
                        null
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var texture in this.list){
                        args[0] = this.list[texture];
                        callback.apply(scope, args);
                    }
                },
                /**
     * Destroys the Texture Manager and all Textures stored within it.
     *
     * @method Phaser.Textures.TextureManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var texture in this.list)this.list[texture].destroy();
                    this.list = {};
                    this.game = null;
                    CanvasPool.remove(this._tempCanvas);
                }
            });
            module1.exports = TextureManager;
        /***/ },
        /* 423 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Color = __webpack_require__(38);
            var CONST = __webpack_require__(33);
            var IsSizePowerOfTwo = __webpack_require__(138);
            var Texture = __webpack_require__(206);
            /**
 * @classdesc
 * A Canvas Texture is a special kind of Texture that is backed by an HTML Canvas Element as its source.
 *
 * You can use the properties of this texture to draw to the canvas element directly, using all of the standard
 * canvas operations available in the browser. Any Game Object can be given this texture and will render with it.
 *
 * Note: When running under WebGL the Canvas Texture needs to re-generate its base WebGLTexture and reupload it to
 * the GPU every time you modify it, otherwise the changes you make to this texture will not be visible. To do this
 * you should call `CanvasTexture.refresh()` once you are finished with your changes to the canvas. Try and keep
 * this to a minimum, especially on large canvas sizes, or you may inadvertently thrash the GPU by constantly uploading
 * texture data to it. This restriction does not apply if using the Canvas Renderer.
 *
 * It starts with only one frame that covers the whole of the canvas. You can add further frames, that specify
 * sections of the canvas using the `add` method.
 *
 * Should you need to resize the canvas use the `setSize` method so that it accurately updates all of the underlying
 * texture data as well. Forgetting to do this (i.e. by changing the canvas size directly from your code) could cause
 * graphical errors.
 *
 * @class CanvasTexture
 * @extends Phaser.Textures.Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {HTMLCanvasElement} source - The canvas element that is used as the base of this texture.
 * @param {number} width - The width of the canvas.
 * @param {number} height - The height of the canvas.
 */ var CanvasTexture = new Class({
                Extends: Texture,
                initialize: function CanvasTexture(manager, key, source, width, height) {
                    Texture.call(this, manager, key, source, width, height);
                    this.add("__BASE", 0, 0, 0, width, height);
                    /**
         * A reference to the Texture Source of this Canvas.
         *
         * @name Phaser.Textures.CanvasTexture#_source
         * @type {Phaser.Textures.TextureSource}
         * @private
         * @since 3.7.0
         */ this._source = this.frames["__BASE"].source;
                    /**
         * The source Canvas Element.
         *
         * @name Phaser.Textures.CanvasTexture#canvas
         * @readonly
         * @type {HTMLCanvasElement}
         * @since 3.7.0
         */ this.canvas = this._source.image;
                    /**
         * The 2D Canvas Rendering Context.
         *
         * @name Phaser.Textures.CanvasTexture#context
         * @readonly
         * @type {CanvasRenderingContext2D}
         * @since 3.7.0
         */ this.context = this.canvas.getContext("2d");
                    /**
         * The width of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#width
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.width = width;
                    /**
         * The height of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#height
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.height = height;
                    /**
         * The context image data.
         * Use the `update` method to populate this when the canvas changes.
         *
         * @name Phaser.Textures.CanvasTexture#imageData
         * @type {ImageData}
         * @since 3.13.0
         */ this.imageData = this.context.getImageData(0, 0, width, height);
                    /**
         * A Uint8ClampedArray view into the `buffer`.
         * Use the `update` method to populate this when the canvas changes.
         * Note that this is unavailable in some browsers, such as Epic Browser, due to their security restrictions.
         *
         * @name Phaser.Textures.CanvasTexture#data
         * @type {Uint8ClampedArray}
         * @since 3.13.0
         */ this.data = null;
                    if (this.imageData) this.data = this.imageData.data;
                    /**
         * An Uint32Array view into the `buffer`.
         *
         * @name Phaser.Textures.CanvasTexture#pixels
         * @type {Uint32Array}
         * @since 3.13.0
         */ this.pixels = null;
                    /**
         * An ArrayBuffer the same size as the context ImageData.
         *
         * @name Phaser.Textures.CanvasTexture#buffer
         * @type {ArrayBuffer}
         * @since 3.13.0
         */ this.buffer;
                    if (this.data) {
                        if (this.imageData.data.buffer) {
                            this.buffer = this.imageData.data.buffer;
                            this.pixels = new Uint32Array(this.buffer);
                        } else if (window.ArrayBuffer) {
                            this.buffer = new ArrayBuffer(this.imageData.data.length);
                            this.pixels = new Uint32Array(this.buffer);
                        } else this.pixels = this.imageData.data;
                    }
                },
                /**
     * This re-creates the `imageData` from the current context.
     * It then re-builds the ArrayBuffer, the `data` Uint8ClampedArray reference and the `pixels` Int32Array.
     *
     * Warning: This is a very expensive operation, so use it sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#update
     * @since 3.13.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ update: function() {
                    this.imageData = this.context.getImageData(0, 0, this.width, this.height);
                    this.data = this.imageData.data;
                    if (this.imageData.data.buffer) {
                        this.buffer = this.imageData.data.buffer;
                        this.pixels = new Uint32Array(this.buffer);
                    } else if (window.ArrayBuffer) {
                        this.buffer = new ArrayBuffer(this.imageData.data.length);
                        this.pixels = new Uint32Array(this.buffer);
                    } else this.pixels = this.imageData.data;
                    if (this.manager.game.config.renderType === CONST.WEBGL) this.refresh();
                    return this;
                },
                /**
     * Draws the given Image or Canvas element to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#draw
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate to draw the source at.
     * @param {number} y - The y coordinate to draw the source at.
     * @param {(HTMLImageElement|HTMLCanvasElement)} source - The element to draw to this canvas.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ draw: function(x, y, source) {
                    this.context.drawImage(source, x, y);
                    return this.update();
                },
                /**
     * Draws the given texture frame to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#drawFrame
     * @since 3.16.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {number} [x=0] - The x coordinate to draw the source at.
     * @param {number} [y=0] - The y coordinate to draw the source at.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ drawFrame: function(key, frame, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    var textureFrame = this.manager.getFrame(key, frame);
                    if (textureFrame) {
                        var cd = textureFrame.canvasData;
                        var width = textureFrame.cutWidth;
                        var height = textureFrame.cutHeight;
                        var res = textureFrame.source.resolution;
                        this.context.drawImage(textureFrame.source.image, cd.x, cd.y, width, height, x, y, width / res, height / res);
                        return this.update();
                    } else return this;
                },
                /**
     * Sets a pixel in the CanvasTexture to the given color and alpha values.
     *
     * This is an expensive operation to run in large quantities, so use sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#setPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     *
     * @return {this} This CanvasTexture.
     */ setPixel: function(x, y, red, green, blue, alpha) {
                    if (alpha === undefined) alpha = 255;
                    x = Math.abs(Math.floor(x));
                    y = Math.abs(Math.floor(y));
                    var index = this.getIndex(x, y);
                    if (index > -1) {
                        var imageData = this.context.getImageData(x, y, 1, 1);
                        imageData.data[0] = red;
                        imageData.data[1] = green;
                        imageData.data[2] = blue;
                        imageData.data[3] = alpha;
                        this.context.putImageData(imageData, x, y);
                    }
                    return this;
                },
                /**
     * Puts the ImageData into the context of this CanvasTexture at the given coordinates.
     *
     * @method Phaser.Textures.CanvasTexture#putData
     * @since 3.16.0
     *
     * @param {ImageData} imageData - The ImageData to put at the given location.
     * @param {number} x - The x coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [dirtyX=0] - Horizontal position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyY=0] - Vertical position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyWidth] - Width of the rectangle to be painted. Defaults to the width of the image data.
     * @param {number} [dirtyHeight] - Height of the rectangle to be painted. Defaults to the height of the image data.
     *
     * @return {this} This CanvasTexture.
     */ putData: function(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight) {
                    if (dirtyX === undefined) dirtyX = 0;
                    if (dirtyY === undefined) dirtyY = 0;
                    if (dirtyWidth === undefined) dirtyWidth = imageData.width;
                    if (dirtyHeight === undefined) dirtyHeight = imageData.height;
                    this.context.putImageData(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight);
                    return this;
                },
                /**
     * Gets an ImageData region from this CanvasTexture from the position and size specified.
     * You can write this back using `CanvasTexture.putData`, or manipulate it.
     *
     * @method Phaser.Textures.CanvasTexture#getData
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} width - The width of the rectangle from which the ImageData will be extracted. Positive values are to the right, and negative to the left.
     * @param {number} height - The height of the rectangle from which the ImageData will be extracted. Positive values are down, and negative are up.
     *
     * @return {ImageData} The ImageData extracted from this CanvasTexture.
     */ getData: function(x, y, width, height) {
                    x = Clamp(Math.floor(x), 0, this.width - 1);
                    y = Clamp(Math.floor(y), 0, this.height - 1);
                    width = Clamp(width, 1, this.width - x);
                    height = Clamp(height, 1, this.height - y);
                    var imageData = this.context.getImageData(x, y, width, height);
                    return imageData;
                },
                /**
     * Get the color of a specific pixel from this texture and store it in a Color object.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixel
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {Phaser.Display.Color} [out] - A Color object to store the pixel values in. If not provided a new Color object will be created.
     *
     * @return {Phaser.Display.Color} An object with the red, green, blue and alpha values set in the r, g, b and a properties.
     */ getPixel: function(x, y, out) {
                    if (!out) out = new Color();
                    var index = this.getIndex(x, y);
                    if (index > -1) {
                        var data = this.data;
                        var r = data[index + 0];
                        var g = data[index + 1];
                        var b = data[index + 2];
                        var a = data[index + 3];
                        out.setTo(r, g, b, a);
                    }
                    return out;
                },
                /**
     * Returns an array containing all of the pixels in the given region.
     *
     * If the requested region extends outside the bounds of this CanvasTexture,
     * the region is truncated to fit.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixels
     * @since 3.16.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [y=0] - The y coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [width] - The width of the region to get. Must be an integer. Defaults to the canvas width if not given.
     * @param {number} [height] - The height of the region to get. Must be an integer. If not given will be set to the `width`.
     *
     * @return {Phaser.Types.Textures.PixelConfig[][]} A 2d array of Pixel objects.
     */ getPixels: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = width;
                    x = Math.abs(Math.round(x));
                    y = Math.abs(Math.round(y));
                    var left = Clamp(x, 0, this.width);
                    var right = Clamp(x + width, 0, this.width);
                    var top = Clamp(y, 0, this.height);
                    var bottom = Clamp(y + height, 0, this.height);
                    var pixel = new Color();
                    var out = [];
                    for(var py = top; py < bottom; py++){
                        var row = [];
                        for(var px = left; px < right; px++){
                            pixel = this.getPixel(px, py, pixel);
                            row.push({
                                x: px,
                                y: py,
                                color: pixel.color,
                                alpha: pixel.alphaGL
                            });
                        }
                        out.push(row);
                    }
                    return out;
                },
                /**
     * Returns the Image Data index for the given pixel in this CanvasTexture.
     *
     * The index can be used to read directly from the `this.data` array.
     *
     * The index points to the red value in the array. The subsequent 3 indexes
     * point to green, blue and alpha respectively.
     *
     * @method Phaser.Textures.CanvasTexture#getIndex
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     *
     * @return {number}
     */ getIndex: function(x, y) {
                    x = Math.abs(Math.round(x));
                    y = Math.abs(Math.round(y));
                    if (x < this.width && y < this.height) return (x + y * this.width) * 4;
                    else return -1;
                },
                /**
     * This should be called manually if you are running under WebGL.
     * It will refresh the WebGLTexture from the Canvas source. Only call this if you know that the
     * canvas has changed, as there is a significant GPU texture allocation cost involved in doing so.
     *
     * @method Phaser.Textures.CanvasTexture#refresh
     * @since 3.7.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ refresh: function() {
                    this._source.update();
                    return this;
                },
                /**
     * Gets the Canvas Element.
     *
     * @method Phaser.Textures.CanvasTexture#getCanvas
     * @since 3.7.0
     *
     * @return {HTMLCanvasElement} The Canvas DOM element this texture is using.
     */ getCanvas: function() {
                    return this.canvas;
                },
                /**
     * Gets the 2D Canvas Rendering Context.
     *
     * @method Phaser.Textures.CanvasTexture#getContext
     * @since 3.7.0
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context this texture is using.
     */ getContext: function() {
                    return this.context;
                },
                /**
     * Clears the given region of this Canvas Texture, resetting it back to transparent.
     * If no region is given, the whole Canvas Texture is cleared.
     *
     * @method Phaser.Textures.CanvasTexture#clear
     * @since 3.7.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region to clear.
     * @param {number} [y=0] - The y coordinate of the top-left of the region to clear.
     * @param {number} [width] - The width of the region.
     * @param {number} [height] - The height of the region.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ clear: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    this.context.clearRect(x, y, width, height);
                    return this.update();
                },
                /**
     * Changes the size of this Canvas Texture.
     *
     * @method Phaser.Textures.CanvasTexture#setSize
     * @since 3.7.0
     *
     * @param {number} width - The new width of the Canvas.
     * @param {number} [height] - The new height of the Canvas. If not given it will use the width as the height.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    if (width !== this.width || height !== this.height) {
                        //  Update the Canvas
                        this.canvas.width = width;
                        this.canvas.height = height;
                        //  Update the Texture Source
                        this._source.width = width;
                        this._source.height = height;
                        this._source.isPowerOf2 = IsSizePowerOfTwo(width, height);
                        //  Update the Frame
                        this.frames["__BASE"].setSize(width, height, 0, 0);
                        //  Update this
                        this.width = width;
                        this.height = height;
                        this.refresh();
                    }
                    return this;
                },
                /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.CanvasTexture#destroy
     * @since 3.16.0
     */ destroy: function() {
                    Texture.prototype.destroy.call(this);
                    this._source = null;
                    this.canvas = null;
                    this.context = null;
                    this.imageData = null;
                    this.data = null;
                    this.pixels = null;
                    this.buffer = null;
                }
            });
            module1.exports = CanvasTexture;
        /***/ },
        /* 424 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var IsSizePowerOfTwo = __webpack_require__(138);
            var ScaleModes = __webpack_require__(168);
            /**
 * @classdesc
 * A Texture Source is the encapsulation of the actual source data for a Texture.
 *
 * This is typically an Image Element, loaded from the file system or network, a Canvas Element or a Video Element.
 *
 * A Texture can contain multiple Texture Sources, which only happens when a multi-atlas is loaded.
 *
 * @class TextureSource
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this TextureSource belongs to.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|WebGLTexture)} source - The source image data.
 * @param {number} [width] - Optional width of the source image. If not given it's derived from the source itself.
 * @param {number} [height] - Optional height of the source image. If not given it's derived from the source itself.
 * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
 */ var TextureSource = new Class({
                initialize: function TextureSource(texture, source, width, height, flipY) {
                    if (flipY === undefined) flipY = false;
                    var game = texture.manager.game;
                    /**
         * The Texture this TextureSource belongs to.
         *
         * @name Phaser.Textures.TextureSource#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.7.0
         */ this.renderer = game.renderer;
                    /**
         * The Texture this TextureSource belongs to.
         *
         * @name Phaser.Textures.TextureSource#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                    /**
         * The source of the image data.
         *
         * This is either an Image Element, a Canvas Element, a Video Element, a RenderTexture or a WebGLTexture.
         *
         * @name Phaser.Textures.TextureSource#source
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|WebGLTexture)}
         * @since 3.12.0
         */ this.source = source;
                    /**
         * The image data.
         *
         * This is either an Image element, Canvas element or a Video Element.
         *
         * @name Phaser.Textures.TextureSource#image
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement)}
         * @since 3.0.0
         */ this.image = source;
                    /**
         * Currently un-used.
         *
         * @name Phaser.Textures.TextureSource#compressionAlgorithm
         * @type {number}
         * @default null
         * @since 3.0.0
         */ this.compressionAlgorithm = null;
                    /**
         * The resolution of the source image.
         *
         * @name Phaser.Textures.TextureSource#resolution
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.resolution = 1;
                    /**
         * The width of the source image. If not specified in the constructor it will check
         * the `naturalWidth` and then `width` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width || source.naturalWidth || source.videoWidth || source.width || 0;
                    /**
         * The height of the source image. If not specified in the constructor it will check
         * the `naturalHeight` and then `height` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height || source.naturalHeight || source.videoHeight || source.height || 0;
                    /**
         * The Scale Mode the image will use when rendering.
         * Either Linear or Nearest.
         *
         * @name Phaser.Textures.TextureSource#scaleMode
         * @type {number}
         * @since 3.0.0
         */ this.scaleMode = ScaleModes.DEFAULT;
                    /**
         * Is the source image a Canvas Element?
         *
         * @name Phaser.Textures.TextureSource#isCanvas
         * @type {boolean}
         * @since 3.0.0
         */ this.isCanvas = source instanceof HTMLCanvasElement;
                    /**
         * Is the source image a Video Element?
         *
         * @name Phaser.Textures.TextureSource#isVideo
         * @type {boolean}
         * @since 3.20.0
         */ this.isVideo = window.hasOwnProperty("HTMLVideoElement") && source instanceof HTMLVideoElement;
                    /**
         * Is the source image a Render Texture?
         *
         * @name Phaser.Textures.TextureSource#isRenderTexture
         * @type {boolean}
         * @since 3.12.0
         */ this.isRenderTexture = source.type === "RenderTexture";
                    /**
         * Is the source image a WebGLTexture?
         *
         * @name Phaser.Textures.TextureSource#isGLTexture
         * @type {boolean}
         * @since 3.19.0
         */ this.isGLTexture = window.hasOwnProperty("WebGLTexture") && source instanceof WebGLTexture;
                    /**
         * Are the source image dimensions a power of two?
         *
         * @name Phaser.Textures.TextureSource#isPowerOf2
         * @type {boolean}
         * @since 3.0.0
         */ this.isPowerOf2 = IsSizePowerOfTwo(this.width, this.height);
                    /**
         * The WebGL Texture of the source image. If this TextureSource is driven from a WebGLTexture
         * already, then this is a reference to that WebGLTexture.
         *
         * @name Phaser.Textures.TextureSource#glTexture
         * @type {?WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.glTexture = null;
                    /**
         * The current texture unit index as assigned by the WebGL Renderer.
         * Un-used in canvas. Should be treated as read-only.
         *
         * @name Phaser.Textures.TextureSource#glIndex
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.glIndex = 0;
                    /**
         * The counter value when this texture was last assigned an index by the WebGL Renderer.
         * Un-used in canvas. Should be treated as read-only.
         *
         * @name Phaser.Textures.TextureSource#glIndexCounter
         * @type {number}
         * @default -1
         * @since 3.50.0
         */ this.glIndexCounter = -1;
                    /**
         * Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
         *
         * @name Phaser.Textures.TextureSource#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = flipY;
                    this.init(game);
                },
                /**
     * Creates a WebGL Texture, if required, and sets the Texture filter mode.
     *
     * @method Phaser.Textures.TextureSource#init
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                    var renderer = this.renderer;
                    if (renderer) {
                        if (renderer.gl) {
                            if (this.isCanvas) this.glTexture = renderer.createCanvasTexture(this.image, false, this.flipY);
                            else if (this.isVideo) this.glTexture = renderer.createVideoTexture(this.image, false, this.flipY);
                            else if (this.isRenderTexture) {
                                this.image = this.source.canvas;
                                this.glTexture = renderer.createTextureFromSource(null, this.width, this.height, this.scaleMode);
                            } else if (this.isGLTexture) this.glTexture = this.source;
                            else this.glTexture = renderer.createTextureFromSource(this.image, this.width, this.height, this.scaleMode);
                        } else if (this.isRenderTexture) this.image = this.source.canvas;
                    }
                    if (!game.config.antialias) this.setFilter(1);
                },
                /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * @method Phaser.Textures.TextureSource#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                    if (this.renderer.gl) this.renderer.setTextureFilter(this.glTexture, filterMode);
                    this.scaleMode = filterMode;
                },
                /**
     * Sets the `UNPACK_FLIP_Y_WEBGL` flag for the WebGL Texture during texture upload.
     *
     * @method Phaser.Textures.TextureSource#setFlipY
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - Should the WebGL Texture be flipped on the Y axis on texture upload or not?
     */ setFlipY: function(value) {
                    if (value === undefined) value = true;
                    this.flipY = value;
                    return this;
                },
                /**
     * If this TextureSource is backed by a Canvas and is running under WebGL,
     * it updates the WebGLTexture using the canvas data.
     *
     * @method Phaser.Textures.TextureSource#update
     * @since 3.7.0
     */ update: function() {
                    var gl = this.renderer.gl;
                    if (gl && this.isCanvas) this.glTexture = this.renderer.updateCanvasTexture(this.image, this.glTexture, this.flipY);
                    else if (gl && this.isVideo) this.glTexture = this.renderer.updateVideoTexture(this.image, this.glTexture, this.flipY);
                },
                /**
     * Destroys this Texture Source and nulls the references.
     *
     * @method Phaser.Textures.TextureSource#destroy
     * @since 3.0.0
     */ destroy: function() {
                    if (this.glTexture) this.renderer.deleteTexture(this.glTexture, true);
                    if (this.isCanvas) CanvasPool.remove(this.image);
                    this.renderer = null;
                    this.texture = null;
                    this.source = null;
                    this.image = null;
                    this.glTexture = null;
                }
            });
            module1.exports = TextureSource;
        /***/ },
        /* 425 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Parsers
 */ module1.exports = {
                AtlasXML: __webpack_require__(979),
                Canvas: __webpack_require__(980),
                Image: __webpack_require__(981),
                JSONArray: __webpack_require__(982),
                JSONHash: __webpack_require__(983),
                SpriteSheet: __webpack_require__(984),
                SpriteSheetFromAtlas: __webpack_require__(985),
                UnityYAML: __webpack_require__(986)
            };
        /***/ },
        /* 426 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HTML5AudioSoundManager = __webpack_require__(427);
            var NoAudioSoundManager = __webpack_require__(430);
            var WebAudioSoundManager = __webpack_require__(432);
            /**
 * Creates a Web Audio, HTML5 Audio or No Audio Sound Manager based on config and device settings.
 *
 * Be aware of https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
 *
 * @function Phaser.Sound.SoundManagerCreator
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @return {(Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager|Phaser.Sound.NoAudioSoundManager)} The Sound Manager instance that was created.
 */ var SoundManagerCreator = {
                create: function(game) {
                    var audioConfig = game.config.audio;
                    var deviceAudio = game.device.audio;
                    if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) return new NoAudioSoundManager(game);
                    if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new WebAudioSoundManager(game);
                    return new HTML5AudioSoundManager(game);
                }
            };
            module1.exports = SoundManagerCreator;
        /***/ },
        /* 427 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(70);
            var HTML5AudioSound = __webpack_require__(429);
            /**
 * HTML5 Audio implementation of the Sound Manager.
 *
 * To play multiple instances of the same HTML5 Audio sound, you need to provide an `instances` value when
 * loading the sound with the Loader:
 *
 * ```javascript
 * this.load.audio('explosion', 'explosion.mp3', {
 *     instances: 2
 * });
 * ```
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class HTML5AudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var HTML5AudioSoundManager = new Class({
                Extends: BaseSoundManager,
                initialize: function HTML5AudioSoundManager(game) {
                    /**
         * Flag indicating whether if there are no idle instances of HTML5 Audio tag,
         * for any particular sound, if one of the used tags should be hijacked and used
         * for succeeding playback or if succeeding Phaser.Sound.HTML5AudioSound#play
         * call should be ignored.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#override
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.override = true;
                    /**
         * Value representing time difference, in seconds, between calling
         * play method on an audio tag and when it actually starts playing.
         * It is used to achieve more accurate delayed sound playback.
         *
         * You might need to tweak this value to get the desired results
         * since audio play delay varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#audioPlayDelay
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.audioPlayDelay = 0.1;
                    /**
         * A value by which we should offset the loop end marker of the
         * looping sound to compensate for lag, caused by changing audio
         * tag playback position, in order to achieve gapless looping.
         *
         * You might need to tweak this value to get the desired results
         * since loop lag varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#loopEndOffset
         * @type {number}
         * @default 0.05
         * @since 3.0.0
         */ this.loopEndOffset = 0.05;
                    /**
         * An array for keeping track of all the sounds
         * that were paused when game lost focus.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#onBlurPausedSounds
         * @type {Phaser.Sound.HTML5AudioSound[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this.onBlurPausedSounds = [];
                    this.locked = "ontouchstart" in window;
                    /**
         * A queue of all actions performed on sound objects while audio was locked.
         * Once the audio gets unlocked, after an explicit user interaction,
         * all actions will be performed in chronological order.
         * Array of object types: { sound: Phaser.Sound.HTML5AudioSound, name: string, value?: * }
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#lockedActionsQueue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this.lockedActionsQueue = this.locked ? [] : null;
                    /**
         * Property that actually holds the value of global mute
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_mute
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._mute = false;
                    /**
         * Property that actually holds the value of global volume
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_volume
         * @type {boolean}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._volume = 1;
                    BaseSoundManager.call(this, game);
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.HTML5AudioSound} The new sound instance.
     */ add: function(key, config) {
                    var sound = new HTML5AudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                /**
     * Unlocks HTML5 Audio loading and playback on mobile
     * devices on the initial explicit user interaction.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                    this.locked = false;
                    var _this = this;
                    this.game.cache.audio.entries.each(function(key, tags) {
                        for(var i = 0; i < tags.length; i++)if (tags[i].dataset.locked === "true") {
                            _this.locked = true;
                            return false;
                        }
                        return true;
                    });
                    if (!this.locked) return;
                    var moved = false;
                    var detectMove = function() {
                        moved = true;
                    };
                    var unlock = function() {
                        if (moved) {
                            moved = false;
                            return;
                        }
                        document.body.removeEventListener("touchmove", detectMove);
                        document.body.removeEventListener("touchend", unlock);
                        var lockedTags = [];
                        _this.game.cache.audio.entries.each(function(key, tags) {
                            for(var i = 0; i < tags.length; i++){
                                var tag = tags[i];
                                if (tag.dataset.locked === "true") lockedTags.push(tag);
                            }
                            return true;
                        });
                        if (lockedTags.length === 0) return;
                        var lastTag = lockedTags[lockedTags.length - 1];
                        lastTag.oncanplaythrough = function() {
                            lastTag.oncanplaythrough = null;
                            lockedTags.forEach(function(tag) {
                                tag.dataset.locked = "false";
                            });
                            _this.unlocked = true;
                        };
                        lockedTags.forEach(function(tag) {
                            tag.load();
                        });
                    };
                    this.once(Events.UNLOCKED, function() {
                        this.forEachActiveSound(function(sound) {
                            if (sound.currentMarker === null && sound.duration === 0) sound.duration = sound.tags[0].duration;
                            sound.totalDuration = sound.tags[0].duration;
                        });
                        while(this.lockedActionsQueue.length){
                            var lockedAction = this.lockedActionsQueue.shift();
                            if (lockedAction.sound[lockedAction.prop].apply) lockedAction.sound[lockedAction.prop].apply(lockedAction.sound, lockedAction.value || []);
                            else lockedAction.sound[lockedAction.prop] = lockedAction.value;
                        }
                    }, this);
                    document.body.addEventListener("touchmove", detectMove, false);
                    document.body.addEventListener("touchend", unlock, false);
                },
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    this.forEachActiveSound(function(sound) {
                        if (sound.isPlaying) {
                            this.onBlurPausedSounds.push(sound);
                            sound.onBlur();
                        }
                    });
                },
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    this.onBlurPausedSounds.forEach(function(sound) {
                        sound.onFocus();
                    });
                    this.onBlurPausedSounds.length = 0;
                },
                /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSoundManager.prototype.destroy.call(this);
                    this.onBlurPausedSounds.length = 0;
                    this.onBlurPausedSounds = null;
                },
                /**
     * Method used internally by Phaser.Sound.HTML5AudioSound class methods and property setters
     * to check if sound manager is locked and then either perform action immediately or queue it
     * to be performed once the sound manager gets unlocked.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#isLocked
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Sound.HTML5AudioSound} sound - Sound object on which to perform queued action.
     * @param {string} prop - Name of the method to be called or property to be assigned a value to.
     * @param {*} [value] - An optional parameter that either holds an array of arguments to be passed to the method call or value to be set to the property.
     *
     * @return {boolean} Whether the sound manager is locked.
     */ isLocked: function(sound, prop, value) {
                    if (sound.tags[0].dataset.locked === "true") {
                        this.lockedActionsQueue.push({
                            sound: sound,
                            prop: prop,
                            value: value
                        });
                        return true;
                    }
                    return false;
                },
                /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.HTML5AudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this._mute;
                    },
                    set: function(value) {
                        this._mute = value;
                        this.forEachActiveSound(function(sound) {
                            sound.updateMute();
                        });
                        this.emit(Events.GLOBAL_MUTE, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.HTML5AudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        this.forEachActiveSound(function(sound) {
                            sound.updateVolume();
                        });
                        this.emit(Events.GLOBAL_VOLUME, this, value);
                    }
                }
            });
            module1.exports = HTML5AudioSoundManager;
        /***/ },
        /* 428 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns the first element in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return the first element that had its `visible` property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would search only the first 50 elements.
 *
 * @function Phaser.Utils.Array.GetFirst
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex=0] - An optional start index to search from.
 * @param {number} [endIndex=array.length] - An optional end index to search up to (but not included)
 *
 * @return {object} The first matching element from the array, or `null` if no element could be found in the range given.
 */ var GetFirst = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) return child;
                }
                return null;
            };
            module1.exports = GetFirst;
        /***/ },
        /* 429 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(146);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(70);
            var Clamp = __webpack_require__(18);
            /**
 * @classdesc
 * HTML5 Audio implementation of the sound.
 *
 * @class HTML5AudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.HTML5AudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var HTML5AudioSound = new Class({
                Extends: BaseSound,
                initialize: function HTML5AudioSound(manager, key, config) {
                    if (config === undefined) config = {};
                    /**
         * An array containing all HTML5 Audio tags that could be used for individual
         * sound's playback. Number of instances depends on the config value passed
         * to the Loader#audio method call, default is 1.
         *
         * @name Phaser.Sound.HTML5AudioSound#tags
         * @type {HTMLAudioElement[]}
         * @private
         * @since 3.0.0
         */ this.tags = manager.game.cache.audio.get(key);
                    if (!this.tags) throw new Error('There is no audio asset with key "' + key + '" in the audio cache');
                    /**
         * Reference to an HTML5 Audio tag used for playing sound.
         *
         * @name Phaser.Sound.HTML5AudioSound#audio
         * @type {HTMLAudioElement}
         * @private
         * @default null
         * @since 3.0.0
         */ this.audio = null;
                    /**
         * Timestamp as generated by the Request Animation Frame or SetTimeout
         * representing the time at which the delayed sound playback should start.
         * Set to 0 if sound playback is not delayed.
         *
         * @name Phaser.Sound.HTML5AudioSound#startTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * Audio tag's playback position recorded on previous
         * update method call. Set to 0 if sound is not playing.
         *
         * @name Phaser.Sound.HTML5AudioSound#previousTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.previousTime = 0;
                    this.duration = this.tags[0].duration;
                    this.totalDuration = this.tags[0].duration;
                    BaseSound.call(this, manager, key, config);
                },
                /**
     * Play this sound, or a marked section of it.
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.HTML5AudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (this.manager.isLocked(this, "play", [
                        markerName,
                        config
                    ])) return false;
                    if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    if (!this.pickAndPlayAudioTag()) return false;
                    this.emit(Events.PLAY, this);
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.manager.isLocked(this, "pause")) return false;
                    if (this.startTime > 0) return false;
                    if (!BaseSound.prototype.pause.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                    this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                    this.stopAndReleaseAudioTag();
                    this.emit(Events.PAUSE, this);
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (this.manager.isLocked(this, "resume")) return false;
                    if (this.startTime > 0) return false;
                    if (!BaseSound.prototype.resume.call(this)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    if (!this.pickAndPlayAudioTag()) return false;
                    this.emit(Events.RESUME, this);
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (this.manager.isLocked(this, "stop")) return false;
                    if (!BaseSound.prototype.stop.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                    this.stopAndReleaseAudioTag();
                    this.emit(Events.STOP, this);
                    return true;
                },
                /**
     * Used internally to do what the name says.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAndPlayAudioTag
     * @private
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAndPlayAudioTag: function() {
                    if (!this.pickAudioTag()) {
                        this.reset();
                        return false;
                    }
                    var seek = this.currentConfig.seek;
                    var delay = this.currentConfig.delay;
                    var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                    this.previousTime = offset;
                    this.audio.currentTime = offset;
                    this.applyConfig();
                    if (delay === 0) {
                        this.startTime = 0;
                        if (this.audio.paused) this.playCatchPromise();
                    } else {
                        this.startTime = window.performance.now() + delay * 1000;
                        if (!this.audio.paused) this.audio.pause();
                    }
                    this.resetConfig();
                    return true;
                },
                /**
     * This method performs the audio tag pooling logic. It first looks for
     * unused audio tag to assign to this sound object. If there are no unused
     * audio tags, based on HTML5AudioSoundManager#override property value, it
     * looks for sound with most advanced playback and hijacks its audio tag or
     * does nothing.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAudioTag
     * @private
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAudioTag: function() {
                    if (this.audio) return true;
                    for(var i = 0; i < this.tags.length; i++){
                        var audio = this.tags[i];
                        if (audio.dataset.used === "false") {
                            audio.dataset.used = "true";
                            this.audio = audio;
                            return true;
                        }
                    }
                    if (!this.manager.override) return false;
                    var otherSounds = [];
                    this.manager.forEachActiveSound(function(sound) {
                        if (sound.key === this.key && sound.audio) otherSounds.push(sound);
                    }, this);
                    otherSounds.sort(function(a1, a2) {
                        if (a1.loop === a2.loop) // sort by progress
                        return a2.seek / a2.duration - a1.seek / a1.duration;
                        return a1.loop ? 1 : -1;
                    });
                    var selectedSound = otherSounds[0];
                    this.audio = selectedSound.audio;
                    selectedSound.reset();
                    selectedSound.audio = null;
                    selectedSound.startTime = 0;
                    selectedSound.previousTime = 0;
                    return true;
                },
                /**
     * Method used for playing audio tag and catching possible exceptions
     * thrown from rejected Promise returned from play method call.
     *
     * @method Phaser.Sound.HTML5AudioSound#playCatchPromise
     * @private
     * @since 3.0.0
     */ playCatchPromise: function() {
                    var playPromise = this.audio.play();
                    if (playPromise) // eslint-disable-next-line no-unused-vars
                    playPromise.catch(function(reason) {
                        console.warn(reason);
                    });
                },
                /**
     * Used internally to do what the name says.
     *
     * @method Phaser.Sound.HTML5AudioSound#stopAndReleaseAudioTag
     * @private
     * @since 3.0.0
     */ stopAndReleaseAudioTag: function() {
                    this.startTime = 0;
                    this.previousTime = 0;
                    if (this.audio) {
                        this.audio.pause();
                        this.audio.dataset.used = "false";
                        this.audio = null;
                    }
                },
                /**
     * Method used internally to reset sound state, usually when stopping sound
     * or when hijacking audio tag from another sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#reset
     * @private
     * @since 3.0.0
     */ reset: function() {
                    BaseSound.prototype.stop.call(this);
                },
                /**
     * Method used internally by sound manager for pausing sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
     * @private
     * @since 3.0.0
     */ onBlur: function() {
                    this.isPlaying = false;
                    this.isPaused = true;
                    this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                    this.currentConfig.delay = Math.max(0, (this.startTime - window.performance.now()) / 1000);
                    this.stopAndReleaseAudioTag();
                },
                /**
     * Method used internally by sound manager for resuming sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSound#onFocus
     * @private
     * @since 3.0.0
     */ onFocus: function() {
                    this.isPlaying = true;
                    this.isPaused = false;
                    this.pickAndPlayAudioTag();
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.HTML5AudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     */ update: function(time) {
                    if (!this.isPlaying) return;
                    // handling delayed playback
                    if (this.startTime > 0) {
                        if (this.startTime < time - this.manager.audioPlayDelay) {
                            this.audio.currentTime += Math.max(0, time - this.startTime) / 1000;
                            this.startTime = 0;
                            this.previousTime = this.audio.currentTime;
                            this.playCatchPromise();
                        }
                        return;
                    }
                    // handle looping and ending
                    var startTime = this.currentMarker ? this.currentMarker.start : 0;
                    var endTime = startTime + this.duration;
                    var currentTime = this.audio.currentTime;
                    if (this.currentConfig.loop) {
                        if (currentTime >= endTime - this.manager.loopEndOffset) {
                            this.audio.currentTime = startTime + Math.max(0, currentTime - endTime);
                            currentTime = this.audio.currentTime;
                        } else if (currentTime < startTime) {
                            this.audio.currentTime += startTime;
                            currentTime = this.audio.currentTime;
                        }
                        if (currentTime < this.previousTime) this.emit(Events.LOOPED, this);
                    } else if (currentTime >= endTime) {
                        this.reset();
                        this.stopAndReleaseAudioTag();
                        this.emit(Events.COMPLETE, this);
                        return;
                    }
                    this.previousTime = currentTime;
                },
                /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                    this.tags = null;
                    if (this.audio) this.stopAndReleaseAudioTag();
                },
                /**
     * Method used internally to determine mute setting of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateMute
     * @private
     * @since 3.0.0
     */ updateMute: function() {
                    if (this.audio) this.audio.muted = this.currentConfig.mute || this.manager.mute;
                },
                /**
     * Method used internally to calculate total volume of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateVolume
     * @private
     * @since 3.0.0
     */ updateVolume: function() {
                    if (this.audio) this.audio.volume = Clamp(this.currentConfig.volume * this.manager.volume, 0, 1);
                },
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    BaseSound.prototype.calculateRate.call(this);
                    if (this.audio) this.audio.playbackRate = this.totalRate;
                },
                /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.HTML5AudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.currentConfig.mute;
                    },
                    set: function(value) {
                        this.currentConfig.mute = value;
                        if (this.manager.isLocked(this, "mute", value)) return;
                        this.updateMute();
                        this.emit(Events.MUTE, this, value);
                    }
                },
                /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.HTML5AudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.currentConfig.volume;
                    },
                    set: function(value) {
                        this.currentConfig.volume = value;
                        if (this.manager.isLocked(this, "volume", value)) return;
                        this.updateVolume();
                        this.emit(Events.VOLUME, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.HTML5AudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(value) {
                        this.currentConfig.rate = value;
                        if (this.manager.isLocked(this, Events.RATE, value)) return;
                        else {
                            this.calculateRate();
                            this.emit(Events.RATE, this, value);
                        }
                    }
                },
                /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.HTML5AudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.HTML5AudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(value) {
                        this.currentConfig.detune = value;
                        if (this.manager.isLocked(this, Events.DETUNE, value)) return;
                        else {
                            this.calculateRate();
                            this.emit(Events.DETUNE, this, value);
                        }
                    }
                },
                /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.HTML5AudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.HTML5AudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                    get: function() {
                        if (this.isPlaying) return this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                        else if (this.isPaused) return this.currentConfig.seek;
                        else return 0;
                    },
                    set: function(value) {
                        if (this.manager.isLocked(this, "seek", value)) return;
                        if (this.startTime > 0) return;
                        if (this.isPlaying || this.isPaused) {
                            value = Math.min(Math.max(0, value), this.duration);
                            if (this.isPlaying) {
                                this.previousTime = value;
                                this.audio.currentTime = value;
                            } else if (this.isPaused) this.currentConfig.seek = value;
                            this.emit(Events.SEEK, this, value);
                        }
                    }
                },
                /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                    this.seek = value;
                    return this;
                },
                /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.HTML5AudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(value) {
                        this.currentConfig.loop = value;
                        if (this.manager.isLocked(this, "loop", value)) return;
                        if (this.audio) this.audio.loop = value;
                        this.emit(Events.LOOP, this, value);
                    }
                },
                /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
     */ setLoop: function(value) {
                    this.loop = value;
                    return this;
                },
                /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @name Phaser.Sound.HTML5AudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                    get: function() {
                        return this.currentConfig.pan;
                    },
                    set: function(value) {
                        this.currentConfig.pan = value;
                        this.emit(Events.PAN, this, value);
                    }
                },
                /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @method Phaser.Sound.HTML5AudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                    this.pan = value;
                    return this;
                }
            });
            module1.exports = HTML5AudioSound;
        /***/ },
        /* 430 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var NoAudioSound = __webpack_require__(431);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * No-audio implementation of the Sound Manager. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of Sound Manager logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var NoAudioSoundManager = new Class({
                Extends: EventEmitter,
                initialize: function NoAudioSoundManager(game) {
                    EventEmitter.call(this);
                    this.game = game;
                    this.sounds = [];
                    this.mute = false;
                    this.volume = 1;
                    this.rate = 1;
                    this.detune = 0;
                    this.pauseOnBlur = true;
                    this.locked = false;
                },
                add: function(key, config) {
                    var sound = new NoAudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                addAudioSprite: function(key, config) {
                    var sound = this.add(key, config);
                    sound.spritemap = {};
                    return sound;
                },
                // eslint-disable-next-line no-unused-vars
                play: function(key, extra) {
                    return false;
                },
                // eslint-disable-next-line no-unused-vars
                playAudioSprite: function(key, spriteName, config) {
                    return false;
                },
                remove: function(sound) {
                    return BaseSoundManager.prototype.remove.call(this, sound);
                },
                removeByKey: function(key) {
                    return BaseSoundManager.prototype.removeByKey.call(this, key);
                },
                pauseAll: NOOP,
                resumeAll: NOOP,
                stopAll: NOOP,
                update: NOOP,
                setRate: NOOP,
                setDetune: NOOP,
                setMute: NOOP,
                setVolume: NOOP,
                forEachActiveSound: function(callbackfn, scope) {
                    BaseSoundManager.prototype.forEachActiveSound.call(this, callbackfn, scope);
                },
                destroy: function() {
                    BaseSoundManager.prototype.destroy.call(this);
                }
            });
            module1.exports = NoAudioSoundManager;
        /***/ },
        /* 431 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(146);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Extend = __webpack_require__(17);
            var returnFalse = function() {
                return false;
            };
            var returnNull = function() {
                return null;
            };
            var returnThis = function() {
                return this;
            };
            /**
 * @classdesc
 * No audio implementation of the sound. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of sound logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.NoAudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var NoAudioSound = new Class({
                Extends: EventEmitter,
                initialize: function NoAudioSound(manager, key, config) {
                    if (config === void 0) config = {};
                    EventEmitter.call(this);
                    this.manager = manager;
                    this.key = key;
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.totalRate = 1;
                    this.duration = 0;
                    this.totalDuration = 0;
                    this.config = Extend({
                        mute: false,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: false,
                        delay: 0,
                        pan: 0
                    }, config);
                    this.currentConfig = this.config;
                    this.mute = false;
                    this.volume = 1;
                    this.rate = 1;
                    this.detune = 0;
                    this.seek = 0;
                    this.loop = false;
                    this.pan = 0;
                    this.markers = {};
                    this.currentMarker = null;
                    this.pendingRemove = false;
                },
                /**
     * @method Phaser.Sound.NoAudioSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} false
     */ addMarker: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} false
     */ updateMarker: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {null} null
     */ removeMarker: returnNull,
                /**
     * @method Phaser.Sound.NoAudioSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} false
     */ play: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#pause
     * @since 3.0.0
     *
     * @return {boolean} false
     */ pause: returnFalse,
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.NoAudioSound#resume
     * @since 3.0.0
     *
     * @return {boolean} false
     */ resume: returnFalse,
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.NoAudioSound#stop
     * @since 3.0.0
     *
     * @return {boolean} false
     */ stop: returnFalse,
                /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.NoAudioSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                },
                setMute: returnThis,
                setVolume: returnThis,
                setRate: returnThis,
                setDetune: returnThis,
                setSeek: returnThis,
                setLoop: returnThis,
                setPan: returnThis
            });
            module1.exports = NoAudioSound;
        /***/ },
        /* 432 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64ToArrayBuffer = __webpack_require__(433);
            var BaseSoundManager = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(70);
            var GameEvents = __webpack_require__(22);
            var WebAudioSound = __webpack_require__(434);
            /**
 * @classdesc
 * Web Audio API implementation of the Sound Manager.
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class WebAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var WebAudioSoundManager = new Class({
                Extends: BaseSoundManager,
                initialize: function WebAudioSoundManager(game) {
                    /**
         * The AudioContext being used for playback.
         *
         * @name Phaser.Sound.WebAudioSoundManager#context
         * @type {AudioContext}
         * @since 3.0.0
         */ this.context = this.createAudioContext(game);
                    /**
         * Gain node responsible for controlling global muting.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterMuteNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.masterMuteNode = this.context.createGain();
                    /**
         * Gain node responsible for controlling global volume.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterVolumeNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.masterVolumeNode = this.context.createGain();
                    this.masterMuteNode.connect(this.masterVolumeNode);
                    this.masterVolumeNode.connect(this.context.destination);
                    /**
         * Destination node for connecting individual sounds to.
         *
         * @name Phaser.Sound.WebAudioSoundManager#destination
         * @type {AudioNode}
         * @since 3.0.0
         */ this.destination = this.masterMuteNode;
                    this.locked = this.context.state === "suspended" && ("ontouchstart" in window || "onclick" in window);
                    BaseSoundManager.call(this, game);
                    if (this.locked && game.isBooted) this.unlock();
                    else game.events.once(GameEvents.BOOT, this.unlock, this);
                },
                /**
     * Method responsible for instantiating and returning AudioContext instance.
     * If an instance of an AudioContext class was provided through the game config,
     * that instance will be returned instead. This can come in handy if you are reloading
     * a Phaser game on a page that never properly refreshes (such as in an SPA project)
     * and you want to reuse already instantiated AudioContext.
     *
     * @method Phaser.Sound.WebAudioSoundManager#createAudioContext
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - Reference to the current game instance.
     *
     * @return {AudioContext} The AudioContext instance to be used for playback.
     */ createAudioContext: function(game) {
                    var audioConfig = game.config.audio;
                    if (audioConfig.context) {
                        audioConfig.context.resume();
                        return audioConfig.context;
                    }
                    if (window.hasOwnProperty("AudioContext")) return new AudioContext();
                    else if (window.hasOwnProperty("webkitAudioContext")) return new window.webkitAudioContext();
                },
                /**
     * This method takes a new AudioContext reference and then sets
     * this Sound Manager to use that context for all playback.
     *
     * As part of this call it also disconnects the master mute and volume
     * nodes and then re-creates them on the new given context.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setAudioContext
     * @since 3.21.0
     *
     * @param {AudioContext} context - Reference to an already created AudioContext instance.
     *
     * @return {this} The WebAudioSoundManager instance.
     */ setAudioContext: function(context) {
                    if (this.context) this.context.close();
                    if (this.masterMuteNode) this.masterMuteNode.disconnect();
                    if (this.masterVolumeNode) this.masterVolumeNode.disconnect();
                    this.context = context;
                    this.masterMuteNode = context.createGain();
                    this.masterVolumeNode = context.createGain();
                    this.masterMuteNode.connect(this.masterVolumeNode);
                    this.masterVolumeNode.connect(context.destination);
                    this.destination = this.masterMuteNode;
                    return this;
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.WebAudioSound} The new sound instance.
     */ add: function(key, config) {
                    var sound = new WebAudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                /**
     * Decode audio data into a format ready for playback via Web Audio.
     *
     * The audio data can be a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     *
     * The `audioKey` is the key that will be used to save the decoded audio to the audio cache.
     *
     * Instead of passing a single entry you can instead pass an array of `Phaser.Types.Sound.DecodeAudioConfig`
     * objects as the first and only argument.
     *
     * Decoding is an async process, so be sure to listen for the events to know when decoding has completed.
     *
     * Once the audio has decoded it can be added to the Sound Manager or played via its key.
     *
     * @method Phaser.Sound.WebAudioSoundManager#decodeAudio
     * @fires Phaser.Sound.Events#DECODED
     * @fires Phaser.Sound.Events#DECODED_ALL
     * @since 3.18.0
     *
     * @param {(Phaser.Types.Sound.DecodeAudioConfig[]|string)} [audioKey] - The string-based key to be used to reference the decoded audio in the audio cache, or an array of audio config objects.
     * @param {(ArrayBuffer|string)} [audioData] - The audio data, either a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     */ decodeAudio: function(audioKey, audioData) {
                    var audioFiles;
                    if (!Array.isArray(audioKey)) audioFiles = [
                        {
                            key: audioKey,
                            data: audioData
                        }
                    ];
                    else audioFiles = audioKey;
                    var cache = this.game.cache.audio;
                    var remaining = audioFiles.length;
                    for(var i = 0; i < audioFiles.length; i++){
                        var entry = audioFiles[i];
                        var key = entry.key;
                        var data = entry.data;
                        if (typeof data === "string") data = Base64ToArrayBuffer(data);
                        var success = (function(key, audioBuffer) {
                            cache.add(key, audioBuffer);
                            this.emit(Events.DECODED, key);
                            remaining--;
                            if (remaining === 0) this.emit(Events.DECODED_ALL);
                        }).bind(this, key);
                        var failure = (function(key, error) {
                            //  eslint-disable-next-line no-console
                            console.error("Error decoding audio: " + key + " - ", error ? error.message : "");
                            remaining--;
                            if (remaining === 0) this.emit(Events.DECODED_ALL);
                        }).bind(this, key);
                        this.context.decodeAudioData(data, success, failure);
                    }
                },
                /**
     * Unlocks Web Audio API on the initial input event.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.WebAudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                    var _this = this;
                    var body = document.body;
                    var unlockHandler = function unlockHandler() {
                        if (_this.context && body) {
                            var bodyRemove = body.removeEventListener;
                            _this.context.resume().then(function() {
                                bodyRemove("touchstart", unlockHandler);
                                bodyRemove("touchend", unlockHandler);
                                bodyRemove("click", unlockHandler);
                                bodyRemove("keydown", unlockHandler);
                                _this.unlocked = true;
                            }, function() {
                                bodyRemove("touchstart", unlockHandler);
                                bodyRemove("touchend", unlockHandler);
                                bodyRemove("click", unlockHandler);
                                bodyRemove("keydown", unlockHandler);
                            });
                        }
                    };
                    if (body) {
                        body.addEventListener("touchstart", unlockHandler, false);
                        body.addEventListener("touchend", unlockHandler, false);
                        body.addEventListener("click", unlockHandler, false);
                        body.addEventListener("keydown", unlockHandler, false);
                    }
                },
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    if (!this.locked) this.context.suspend();
                },
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    var context = this.context;
                    if ((context.state === "suspended" || context.state === "interrupted") && !this.locked) context.resume();
                },
                /**
     * Update method called on every game step.
     * Removes destroyed sounds and updates every active sound in the game.
     *
     * @method Phaser.Sound.WebAudioSoundManager#update
     * @protected
     * @fires Phaser.Sound.Events#UNLOCKED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: function(time, delta) {
                    BaseSoundManager.prototype.update.call(this, time, delta);
                    var context = this.context;
                    //  Resume interrupted audio on iOS
                    if (context && context.state === "interrupted") context.resume();
                },
                /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.destination = null;
                    this.masterVolumeNode.disconnect();
                    this.masterVolumeNode = null;
                    this.masterMuteNode.disconnect();
                    this.masterMuteNode = null;
                    if (this.game.config.audio.context) this.context.suspend();
                    else {
                        var _this = this;
                        this.context.close().then(function() {
                            _this.context = null;
                        });
                    }
                    BaseSoundManager.prototype.destroy.call(this);
                },
                /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.WebAudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.masterMuteNode.gain.value === 0;
                    },
                    set: function(value) {
                        this.masterMuteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                        this.emit(Events.GLOBAL_MUTE, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.WebAudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.masterVolumeNode.gain.value;
                    },
                    set: function(value) {
                        this.masterVolumeNode.gain.setValueAtTime(value, 0);
                        this.emit(Events.GLOBAL_VOLUME, this, value);
                    }
                }
            });
            module1.exports = WebAudioSoundManager;
        /***/ },
        /* 433 */ /***/ function(module1, exports) {
            /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            //  Use a lookup table to find the index.
            var lookup = new Uint8Array(256);
            for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
            /**
 * Converts a base64 string, either with or without a data uri, into an Array Buffer.
 *
 * @function Phaser.Utils.Base64.Base64ToArrayBuffer
 * @since 3.18.0
 * 
 * @param {string} base64 - The base64 string to be decoded. Can optionally contain a data URI header, which will be stripped out prior to decoding.
 * 
 * @return {ArrayBuffer} An ArrayBuffer decoded from the base64 data.
 */ var Base64ToArrayBuffer = function(base64) {
                //  Is it a data uri? if so, strip the header away
                base64 = base64.substr(base64.indexOf(",") + 1);
                var len = base64.length;
                var bufferLength = len * 0.75;
                var p = 0;
                var encoded1;
                var encoded2;
                var encoded3;
                var encoded4;
                if (base64[len - 1] === "=") {
                    bufferLength--;
                    if (base64[len - 2] === "=") bufferLength--;
                }
                var arrayBuffer = new ArrayBuffer(bufferLength);
                var bytes = new Uint8Array(arrayBuffer);
                for(var i = 0; i < len; i += 4){
                    encoded1 = lookup[base64.charCodeAt(i)];
                    encoded2 = lookup[base64.charCodeAt(i + 1)];
                    encoded3 = lookup[base64.charCodeAt(i + 2)];
                    encoded4 = lookup[base64.charCodeAt(i + 3)];
                    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                }
                return arrayBuffer;
            };
            module1.exports = Base64ToArrayBuffer;
        /***/ },
        /* 434 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(146);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(70);
            /**
 * @classdesc
 * Web Audio API implementation of the sound.
 *
 * @class WebAudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.WebAudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var WebAudioSound = new Class({
                Extends: BaseSound,
                initialize: function WebAudioSound(manager, key, config) {
                    if (config === undefined) config = {};
                    /**
         * Audio buffer containing decoded data of the audio asset to be played.
         *
         * @name Phaser.Sound.WebAudioSound#audioBuffer
         * @type {AudioBuffer}
         * @since 3.0.0
         */ this.audioBuffer = manager.game.cache.audio.get(key);
                    if (!this.audioBuffer) throw new Error('Audio key "' + key + '" missing from cache');
                    /**
         * A reference to an audio source node used for playing back audio from
         * audio data stored in Phaser.Sound.WebAudioSound#audioBuffer.
         *
         * @name Phaser.Sound.WebAudioSound#source
         * @type {AudioBufferSourceNode}
         * @default null
         * @since 3.0.0
         */ this.source = null;
                    /**
         * A reference to a second audio source used for gapless looped playback.
         *
         * @name Phaser.Sound.WebAudioSound#loopSource
         * @type {AudioBufferSourceNode}
         * @default null
         * @since 3.0.0
         */ this.loopSource = null;
                    /**
         * Gain node responsible for controlling this sound's muting.
         *
         * @name Phaser.Sound.WebAudioSound#muteNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.muteNode = manager.context.createGain();
                    /**
         * Gain node responsible for controlling this sound's volume.
         *
         * @name Phaser.Sound.WebAudioSound#volumeNode
         * @type {GainNode}
         * @since 3.0.0
         */ this.volumeNode = manager.context.createGain();
                    /**
         * Panner node responsible for controlling this sound's pan.
         *
         * Doesn't work on iOS / Safari.
         *
         * @name Phaser.Sound.WebAudioSound#pannerNode
         * @type {StereoPannerNode}
         * @since 3.50.0
         */ this.pannerNode = null;
                    /**
         * The time at which the sound should have started playback from the beginning.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#playTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.playTime = 0;
                    /**
         * The time at which the sound source should have actually started playback.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#startTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * The time at which the sound loop source should actually start playback.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#loopTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.loopTime = 0;
                    /**
         * An array where we keep track of all rate updates during playback.
         * Array of object types: { time: number, rate: number }
         *
         * @name Phaser.Sound.WebAudioSound#rateUpdates
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this.rateUpdates = [];
                    /**
         * Used for keeping track when sound source playback has ended
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasEnded
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.hasEnded = false;
                    /**
         * Used for keeping track when sound source has looped
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasLooped
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.hasLooped = false;
                    this.muteNode.connect(this.volumeNode);
                    if (manager.context.createStereoPanner) {
                        this.pannerNode = manager.context.createStereoPanner();
                        this.volumeNode.connect(this.pannerNode);
                        this.pannerNode.connect(manager.destination);
                    } else this.volumeNode.connect(manager.destination);
                    this.duration = this.audioBuffer.duration;
                    this.totalDuration = this.audioBuffer.duration;
                    BaseSound.call(this, manager, key, config);
                },
                /**
     * Play this sound, or a marked section of it.
     *
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.WebAudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    this.stopAndRemoveBufferSource();
                    this.createAndStartBufferSource();
                    this.emit(Events.PLAY, this);
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.WebAudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.manager.context.currentTime < this.startTime) return false;
                    if (!BaseSound.prototype.pause.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                    this.currentConfig.seek = this.getCurrentTime(); // Equivalent to setting paused time
                    this.stopAndRemoveBufferSource();
                    this.emit(Events.PAUSE, this);
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.WebAudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (this.manager.context.currentTime < this.startTime) return false;
                    if (!BaseSound.prototype.resume.call(this)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    this.createAndStartBufferSource();
                    this.emit(Events.RESUME, this);
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.WebAudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (!BaseSound.prototype.stop.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                    this.stopAndRemoveBufferSource();
                    this.emit(Events.STOP, this);
                    return true;
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartBufferSource
     * @private
     * @since 3.0.0
     */ createAndStartBufferSource: function() {
                    var seek = this.currentConfig.seek;
                    var delay = this.currentConfig.delay;
                    var when = this.manager.context.currentTime + delay;
                    var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                    var duration = this.duration - seek;
                    this.playTime = when - seek;
                    this.startTime = when;
                    this.source = this.createBufferSource();
                    this.applyConfig();
                    this.source.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                    this.resetConfig();
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartLoopBufferSource
     * @private
     * @since 3.0.0
     */ createAndStartLoopBufferSource: function() {
                    var when = this.getLoopTime();
                    var offset = this.currentMarker ? this.currentMarker.start : 0;
                    var duration = this.duration;
                    this.loopTime = when;
                    this.loopSource = this.createBufferSource();
                    this.loopSource.playbackRate.setValueAtTime(this.totalRate, 0);
                    this.loopSource.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createBufferSource
     * @private
     * @since 3.0.0
     *
     * @return {AudioBufferSourceNode}
     */ createBufferSource: function() {
                    var _this = this;
                    var source = this.manager.context.createBufferSource();
                    source.buffer = this.audioBuffer;
                    source.connect(this.muteNode);
                    source.onended = function(ev) {
                        if (ev.target === _this.source) {
                            // sound ended
                            if (_this.currentConfig.loop) _this.hasLooped = true;
                            else _this.hasEnded = true;
                        }
                    // else was stopped
                    };
                    return source;
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveBufferSource
     * @private
     * @since 3.0.0
     */ stopAndRemoveBufferSource: function() {
                    if (this.source) {
                        this.source.stop();
                        this.source.disconnect();
                        this.source = null;
                    }
                    this.playTime = 0;
                    this.startTime = 0;
                    this.stopAndRemoveLoopBufferSource();
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveLoopBufferSource
     * @private
     * @since 3.0.0
     */ stopAndRemoveLoopBufferSource: function() {
                    if (this.loopSource) {
                        this.loopSource.stop();
                        this.loopSource.disconnect();
                        this.loopSource = null;
                    }
                    this.loopTime = 0;
                },
                /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.WebAudioSound#applyConfig
     * @protected
     * @since 3.0.0
     */ applyConfig: function() {
                    this.rateUpdates.length = 0;
                    this.rateUpdates.push({
                        time: 0,
                        rate: 1
                    });
                    BaseSound.prototype.applyConfig.call(this);
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.WebAudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @protected
     * @since 3.0.0
     */ update: function() {
                    if (this.hasEnded) {
                        this.hasEnded = false;
                        BaseSound.prototype.stop.call(this);
                        this.stopAndRemoveBufferSource();
                        this.emit(Events.COMPLETE, this);
                    } else if (this.hasLooped) {
                        this.hasLooped = false;
                        this.source = this.loopSource;
                        this.loopSource = null;
                        this.playTime = this.startTime = this.loopTime;
                        this.rateUpdates.length = 0;
                        this.rateUpdates.push({
                            time: 0,
                            rate: this.totalRate
                        });
                        this.createAndStartLoopBufferSource();
                        this.emit(Events.LOOPED, this);
                    }
                },
                /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                    this.audioBuffer = null;
                    this.stopAndRemoveBufferSource();
                    this.muteNode.disconnect();
                    this.muteNode = null;
                    this.volumeNode.disconnect();
                    this.volumeNode = null;
                    if (this.pannerNode) {
                        this.pannerNode.disconnect();
                        this.pannerNode = null;
                    }
                    this.rateUpdates.length = 0;
                    this.rateUpdates = null;
                },
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.WebAudioSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    BaseSound.prototype.calculateRate.call(this);
                    var now = this.manager.context.currentTime;
                    if (this.source && typeof this.totalRate === "number") this.source.playbackRate.setValueAtTime(this.totalRate, now);
                    if (this.isPlaying) {
                        this.rateUpdates.push({
                            time: Math.max(this.startTime, now) - this.playTime,
                            rate: this.totalRate
                        });
                        if (this.loopSource) {
                            this.stopAndRemoveLoopBufferSource();
                            this.createAndStartLoopBufferSource();
                        }
                    }
                },
                /**
     * Method used internally for calculating current playback time of a playing sound.
     *
     * @method Phaser.Sound.WebAudioSound#getCurrentTime
     * @private
     * @since 3.0.0
     */ getCurrentTime: function() {
                    var currentTime = 0;
                    for(var i = 0; i < this.rateUpdates.length; i++){
                        var nextTime = 0;
                        if (i < this.rateUpdates.length - 1) nextTime = this.rateUpdates[i + 1].time;
                        else nextTime = this.manager.context.currentTime - this.playTime;
                        currentTime += (nextTime - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                    }
                    return currentTime;
                },
                /**
     * Method used internally for calculating the time
     * at witch the loop source should start playing.
     *
     * @method Phaser.Sound.WebAudioSound#getLoopTime
     * @private
     * @since 3.0.0
     */ getLoopTime: function() {
                    var lastRateUpdateCurrentTime = 0;
                    for(var i = 0; i < this.rateUpdates.length - 1; i++)lastRateUpdateCurrentTime += (this.rateUpdates[i + 1].time - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                    var lastRateUpdate = this.rateUpdates[this.rateUpdates.length - 1];
                    return this.playTime + lastRateUpdate.time + (this.duration - lastRateUpdateCurrentTime) / lastRateUpdate.rate;
                },
                /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.WebAudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(value) {
                        this.currentConfig.rate = value;
                        this.calculateRate();
                        this.emit(Events.RATE, this, value);
                    }
                },
                /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.WebAudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.WebAudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(value) {
                        this.currentConfig.detune = value;
                        this.calculateRate();
                        this.emit(Events.DETUNE, this, value);
                    }
                },
                /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.WebAudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.WebAudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.muteNode.gain.value === 0;
                    },
                    set: function(value) {
                        this.currentConfig.mute = value;
                        this.muteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                        this.emit(Events.MUTE, this, value);
                    }
                },
                /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.WebAudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.volumeNode.gain.value;
                    },
                    set: function(value) {
                        this.currentConfig.volume = value;
                        this.volumeNode.gain.setValueAtTime(value, 0);
                        this.emit(Events.VOLUME, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.WebAudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                    get: function() {
                        if (this.isPlaying) {
                            if (this.manager.context.currentTime < this.startTime) return this.startTime - this.playTime;
                            return this.getCurrentTime();
                        } else if (this.isPaused) return this.currentConfig.seek;
                        else return 0;
                    },
                    set: function(value) {
                        if (this.manager.context.currentTime < this.startTime) return;
                        if (this.isPlaying || this.isPaused) {
                            value = Math.min(Math.max(0, value), this.duration);
                            this.currentConfig.seek = value;
                            if (this.isPlaying) {
                                this.stopAndRemoveBufferSource();
                                this.createAndStartBufferSource();
                            }
                            this.emit(Events.SEEK, this, value);
                        }
                    }
                },
                /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.WebAudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                    this.seek = value;
                    return this;
                },
                /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.WebAudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(value) {
                        this.currentConfig.loop = value;
                        if (this.isPlaying) {
                            this.stopAndRemoveLoopBufferSource();
                            if (value) this.createAndStartLoopBufferSource();
                        }
                        this.emit(Events.LOOP, this, value);
                    }
                },
                /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {this} This Sound instance.
     */ setLoop: function(value) {
                    this.loop = value;
                    return this;
                },
                /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Always returns zero on iOS / Safari as it doesn't support the stereo panner node.
     *
     * @name Phaser.Sound.WebAudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                    get: function() {
                        if (this.pannerNode) return this.pannerNode.pan.value;
                        else return 0;
                    },
                    set: function(value) {
                        this.currentConfig.pan = value;
                        if (this.pannerNode) this.pannerNode.pan.setValueAtTime(value, this.manager.context.currentTime);
                        this.emit(Events.PAN, this, value);
                    }
                },
                /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Note: iOS / Safari doesn't support the stereo panner node.
     *
     * @method Phaser.Sound.WebAudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                    this.pan = value;
                    return this;
                }
            });
            module1.exports = WebAudioSound;
        /***/ },
        /* 435 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Transposes the elements of the given matrix (array of arrays).
 *
 * The transpose of a matrix is a new matrix whose rows are the columns of the original.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.TransposeMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [array,$return]
 *
 * @param {T[][]} [array] - The array matrix to transpose.
 *
 * @return {T[][]} A new array matrix which is a transposed version of the given array.
 */ var TransposeMatrix = function(array) {
                var sourceRowCount = array.length;
                var sourceColCount = array[0].length;
                var result = new Array(sourceColCount);
                for(var i = 0; i < sourceColCount; i++){
                    result[i] = new Array(sourceRowCount);
                    for(var j = sourceRowCount - 1; j > -1; j--)result[i][j] = array[j][i];
                }
                return result;
            };
            module1.exports = TransposeMatrix;
        /***/ },
        /* 436 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function swap(arr, i, j) {
                var tmp = arr[i];
                arr[i] = arr[j];
                arr[j] = tmp;
            }
            /**
 * @ignore
 */ function defaultCompare(a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
            }
            /**
 * A [Floyd-Rivest](https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm) quick selection algorithm.
 *
 * Rearranges the array items so that all items in the [left, k] range are smaller than all items in [k, right];
 * The k-th element will have the (k - left + 1)th smallest value in [left, right].
 *
 * The array is modified in-place.
 *
 * Based on code by [Vladimir Agafonkin](https://www.npmjs.com/~mourner)
 *
 * @function Phaser.Utils.Array.QuickSelect
 * @since 3.0.0
 *
 * @param {array} arr - The array to sort.
 * @param {number} k - The k-th element index.
 * @param {number} [left=0] - The index of the left part of the range.
 * @param {number} [right] - The index of the right part of the range.
 * @param {function} [compare] - An optional comparison function. Is passed two elements and should return 0, 1 or -1.
 */ var QuickSelect = function(arr, k, left, right, compare) {
                if (left === undefined) left = 0;
                if (right === undefined) right = arr.length - 1;
                if (compare === undefined) compare = defaultCompare;
                while(right > left){
                    if (right - left > 600) {
                        var n = right - left + 1;
                        var m = k - left + 1;
                        var z = Math.log(n);
                        var s = 0.5 * Math.exp(2 * z / 3);
                        var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                        var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                        var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                        QuickSelect(arr, k, newLeft, newRight, compare);
                    }
                    var t = arr[k];
                    var i = left;
                    var j = right;
                    swap(arr, left, k);
                    if (compare(arr[right], t) > 0) swap(arr, left, right);
                    while(i < j){
                        swap(arr, i, j);
                        i++;
                        j--;
                        while(compare(arr[i], t) < 0)i++;
                        while(compare(arr[j], t) > 0)j--;
                    }
                    if (compare(arr[left], t) === 0) swap(arr, left, j);
                    else {
                        j++;
                        swap(arr, j, right);
                    }
                    if (j <= k) left = j + 1;
                    if (k <= j) right = j - 1;
                }
            };
            module1.exports = QuickSelect;
        /***/ },
        /* 437 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            var Shuffle = __webpack_require__(131);
            var BuildChunk = function(a, b, qty) {
                var out = [];
                for(var aIndex = 0; aIndex < a.length; aIndex++){
                    for(var bIndex = 0; bIndex < b.length; bIndex++)for(var i = 0; i < qty; i++)out.push({
                        a: a[aIndex],
                        b: b[bIndex]
                    });
                }
                return out;
            };
            /**
 * Creates an array populated with a range of values, based on the given arguments and configuration object.
 *
 * Range ([a,b,c], [1,2,3]) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3
 * 
 * Range ([a,b], [1,2,3], qty = 3) =
 * a1, a1, a1, a2, a2, a2, a3, a3, a3, b1, b1, b1, b2, b2, b2, b3, b3, b3
 * 
 * Range ([a,b,c], [1,2,3], repeat x1) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3, a1, a2, a3, b1, b2, b3, c1, c2, c3
 * 
 * Range ([a,b], [1,2], repeat -1 = endless, max = 14) =
 * Maybe if max is set then repeat goes to -1 automatically?
 * a1, a2, b1, b2, a1, a2, b1, b2, a1, a2, b1, b2, a1, a2 (capped at 14 elements)
 * 
 * Range ([a], [1,2,3,4,5], random = true) =
 * a4, a1, a5, a2, a3
 * 
 * Range ([a, b], [1,2,3], random = true) =
 * b3, a2, a1, b1, a3, b2
 * 
 * Range ([a, b, c], [1,2,3], randomB = true) =
 * a3, a1, a2, b2, b3, b1, c1, c3, c2
 * 
 * Range ([a], [1,2,3,4,5], yoyo = true) =
 * a1, a2, a3, a4, a5, a5, a4, a3, a2, a1
 * 
 * Range ([a, b], [1,2,3], yoyo = true) =
 * a1, a2, a3, b1, b2, b3, b3, b2, b1, a3, a2, a1
 *
 * @function Phaser.Utils.Array.Range
 * @since 3.0.0
 *
 * @param {array} a - The first array of range elements.
 * @param {array} b - The second array of range elements.
 * @param {object} [options] - A range configuration object. Can contain: repeat, random, randomB, yoyo, max, qty.
 *
 * @return {array} An array of arranged elements.
 */ var Range = function(a, b, options) {
                var max = GetValue(options, "max", 0);
                var qty = GetValue(options, "qty", 1);
                var random = GetValue(options, "random", false);
                var randomB = GetValue(options, "randomB", false);
                var repeat = GetValue(options, "repeat", 0);
                var yoyo = GetValue(options, "yoyo", false);
                var out = [];
                if (randomB) Shuffle(b);
                //  Endless repeat, so limit by max
                if (repeat === -1) {
                    if (max === 0) repeat = 0;
                    else {
                        //  Work out how many repeats we need
                        var total = a.length * b.length * qty;
                        if (yoyo) total *= 2;
                        repeat = Math.ceil(max / total);
                    }
                }
                for(var i = 0; i <= repeat; i++){
                    var chunk = BuildChunk(a, b, qty);
                    if (random) Shuffle(chunk);
                    out = out.concat(chunk);
                    if (yoyo) {
                        chunk.reverse();
                        out = out.concat(chunk);
                    }
                }
                if (max) out.splice(max);
                return out;
            };
            module1.exports = Range;
        /***/ },
        /* 438 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs.Events
 */ module1.exports = {
                PROCESS_QUEUE_ADD: __webpack_require__(1041),
                PROCESS_QUEUE_REMOVE: __webpack_require__(1042)
            };
        /***/ },
        /* 439 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAdvancedValue = __webpack_require__(13);
            /**
 * Adds an Animation component to a Sprite and populates it based on the given config.
 *
 * @function Phaser.GameObjects.BuildGameObjectAnimation
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Sprite} sprite - The sprite to add an Animation component to.
 * @param {object} config - The animation config.
 *
 * @return {Phaser.GameObjects.Sprite} The updated Sprite.
 */ var BuildGameObjectAnimation = function(sprite, config) {
                var animConfig = GetAdvancedValue(config, "anims", null);
                if (animConfig === null) return sprite;
                if (typeof animConfig === "string") //  { anims: 'key' }
                sprite.anims.play(animConfig);
                else if (typeof animConfig === "object") {
                    //  { anims: {
                    //              key: string
                    //              startFrame: [string|number]
                    //              delay: [float]
                    //              repeat: [integer]
                    //              repeatDelay: [float]
                    //              yoyo: [boolean]
                    //              play: [boolean]
                    //              delayedPlay: [boolean]
                    //           }
                    //  }
                    var anims = sprite.anims;
                    var key = GetAdvancedValue(animConfig, "key", undefined);
                    if (key) {
                        var startFrame = GetAdvancedValue(animConfig, "startFrame", undefined);
                        var delay = GetAdvancedValue(animConfig, "delay", 0);
                        var repeat = GetAdvancedValue(animConfig, "repeat", 0);
                        var repeatDelay = GetAdvancedValue(animConfig, "repeatDelay", 0);
                        var yoyo = GetAdvancedValue(animConfig, "yoyo", false);
                        var play = GetAdvancedValue(animConfig, "play", false);
                        var delayedPlay = GetAdvancedValue(animConfig, "delayedPlay", 0);
                        var playConfig = {
                            key: key,
                            delay: delay,
                            repeat: repeat,
                            repeatDelay: repeatDelay,
                            yoyo: yoyo,
                            startFrame: startFrame
                        };
                        if (play) anims.play(playConfig);
                        else if (delayedPlay > 0) anims.playAfterDelay(playConfig, delayedPlay);
                        else anims.load(playConfig);
                    }
                }
                return sprite;
            };
            module1.exports = BuildGameObjectAnimation;
        /***/ },
        /* 440 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Frame = __webpack_require__(109);
            /**
 * @classdesc
 * A Bob Game Object.
 *
 * A Bob belongs to a Blitter Game Object. The Blitter is responsible for managing and rendering this object.
 *
 * A Bob has a position, alpha value and a frame from a texture that it uses to render with. You can also toggle
 * the flipped and visible state of the Bob. The Frame the Bob uses to render can be changed dynamically, but it
 * must be a Frame within the Texture used by the parent Blitter.
 *
 * Bob positions are relative to the Blitter parent. So if you move the Blitter parent, all Bob children will
 * have their positions impacted by this change as well.
 *
 * You can manipulate Bob objects directly from your game code, but the creation and destruction of them should be
 * handled via the Blitter parent.
 *
 * @class Bob
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Blitter} blitter - The parent Blitter object is responsible for updating this Bob.
 * @param {number} x - The horizontal position of this Game Object in the world, relative to the parent Blitter position.
 * @param {number} y - The vertical position of this Game Object in the world, relative to the parent Blitter position.
 * @param {(string|number)} frame - The Frame this Bob will render with, as defined in the Texture the parent Blitter is using.
 * @param {boolean} visible - Should the Bob render visible or not to start with?
 */ var Bob = new Class({
                initialize: function Bob(blitter, x, y, frame, visible) {
                    /**
         * The Blitter object that this Bob belongs to.
         *
         * @name Phaser.GameObjects.Bob#parent
         * @type {Phaser.GameObjects.Blitter}
         * @since 3.0.0
         */ this.parent = blitter;
                    /**
         * The x position of this Bob, relative to the x position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of this Bob, relative to the y position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The frame that the Bob uses to render with.
         * To change the frame use the `Bob.setFrame` method.
         *
         * @name Phaser.GameObjects.Bob#frame
         * @type {Phaser.Textures.Frame}
         * @protected
         * @since 3.0.0
         */ this.frame = frame;
                    /**
         * A blank object which can be used to store data related to this Bob in.
         *
         * @name Phaser.GameObjects.Bob#data
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.data = {};
                    /**
         * The tint value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#tint
         * @type {number}
         * @default 0xffffff
         * @since 3.20.0
         */ this.tint = 0xffffff;
                    /**
         * The visible state of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_visible
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._visible = visible;
                    /**
         * The alpha value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_alpha
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._alpha = 1;
                    /**
         * The horizontally flipped state of the Bob.
         * A Bob that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipX
         * @type {boolean}
         * @since 3.0.0
         */ this.flipX = false;
                    /**
         * The vertically flipped state of the Bob.
         * A Bob that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipY
         * @type {boolean}
         * @since 3.0.0
         */ this.flipY = false;
                },
                /**
     * Changes the Texture Frame being used by this Bob.
     * The frame must be part of the Texture the parent Blitter is using.
     * If no value is given it will use the default frame of the Blitter parent.
     *
     * @method Phaser.GameObjects.Bob#setFrame
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The frame to be used during rendering.
     *
     * @return {this} This Bob Game Object.
     */ setFrame: function(frame) {
                    if (frame === undefined) this.frame = this.parent.frame;
                    else if (frame instanceof Frame && frame.texture === this.parent.texture) this.frame = frame;
                    else this.frame = this.parent.texture.get(frame);
                    return this;
                },
                /**
     * Resets the horizontal and vertical flipped state of this Bob back to their default un-flipped state.
     *
     * @method Phaser.GameObjects.Bob#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Bob Game Object.
     */ resetFlip: function() {
                    this.flipX = false;
                    this.flipY = false;
                    return this;
                },
                /**
     * Resets this Bob.
     *
     * Changes the position to the values given, and optionally changes the frame.
     *
     * Also resets the flipX and flipY values, sets alpha back to 1 and visible to true.
     *
     * @method Phaser.GameObjects.Bob#reset
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     *
     * @return {this} This Bob Game Object.
     */ reset: function(x, y, frame) {
                    this.x = x;
                    this.y = y;
                    this.flipX = false;
                    this.flipY = false;
                    this._alpha = 1;
                    this._visible = true;
                    this.parent.dirty = true;
                    if (frame) this.setFrame(frame);
                    return this;
                },
                /**
     * Changes the position of this Bob to the values given.
     *
     * @method Phaser.GameObjects.Bob#setPosition
     * @since 3.20.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     *
     * @return {this} This Bob Game Object.
     */ setPosition: function(x, y) {
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the horizontal flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipX: function(value) {
                    this.flipX = value;
                    return this;
                },
                /**
     * Sets the vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipY: function(value) {
                    this.flipY = value;
                    return this;
                },
                /**
     * Sets the horizontal and vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlip: function(x, y) {
                    this.flipX = x;
                    this.flipY = y;
                    return this;
                },
                /**
     * Sets the visibility of this Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     *
     * @return {this} This Bob Game Object.
     */ setVisible: function(value) {
                    this.visible = value;
                    return this;
                },
                /**
     * Set the Alpha level of this Bob. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setAlpha
     * @since 3.0.0
     *
     * @param {number} value - The alpha value used for this Bob. Between 0 and 1.
     *
     * @return {this} This Bob Game Object.
     */ setAlpha: function(value) {
                    this.alpha = value;
                    return this;
                },
                /**
     * Sets the tint of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setTint
     * @since 3.20.0
     *
     * @param {number} value - The tint value used for this Bob. Between 0 and 0xffffff.
     *
     * @return {this} This Bob Game Object.
     */ setTint: function(value) {
                    this.tint = value;
                    return this;
                },
                /**
     * Destroys this Bob instance.
     * Removes itself from the Blitter and clears the parent, frame and data properties.
     *
     * @method Phaser.GameObjects.Bob#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.parent.dirty = true;
                    this.parent.children.remove(this);
                    this.parent = undefined;
                    this.frame = undefined;
                    this.data = undefined;
                },
                /**
     * The visible state of the Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(value) {
                        this.parent.dirty |= this._visible !== value;
                        this._visible = value;
                    }
                },
                /**
     * The alpha value of the Bob, between 0 and 1.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        this.parent.dirty |= this._alpha > 0 !== value > 0;
                        this._alpha = value;
                    }
                }
            });
            module1.exports = Bob;
        /***/ },
        /* 441 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Creates a new Rectangle or repositions and/or resizes an existing Rectangle so that it encompasses the two given Rectangles, i.e. calculates their union.
 *
 * @function Phaser.Geom.Rectangle.Union
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to use.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to use.
 * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the union in.
 *
 * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
 */ var Union = function(rectA, rectB, out) {
                if (out === undefined) out = new Rectangle();
                //  Cache vars so we can use one of the input rects as the output rect
                var x = Math.min(rectA.x, rectB.x);
                var y = Math.min(rectA.y, rectB.y);
                var w = Math.max(rectA.right, rectB.right) - x;
                var h = Math.max(rectA.bottom, rectB.bottom) - y;
                return out.setTo(x, y, w, h);
            };
            module1.exports = Union;
        /***/ },
        /* 442 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DOMElementRender = __webpack_require__(1055);
            var GameObject = __webpack_require__(15);
            var IsPlainObject = __webpack_require__(7);
            var RemoveFromDOM = __webpack_require__(202);
            var SCENE_EVENTS = __webpack_require__(20);
            var Vector4 = __webpack_require__(140);
            /**
 * @classdesc
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * When this is added, Phaser will automatically create a DOM Container div that is positioned over the top
 * of the game canvas. This div is sized to match the canvas, and if the canvas size changes, as a result of
 * settings within the Scale Manager, the dom container is resized accordingly.
 *
 * If you have not already done so, you have to provide a `parent` in the Game Configuration, or the DOM
 * Container will fail to be created.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * Note that you should only have DOM Elements in a Scene with a _single_ Camera. If you require multiple cameras,
 * use parallel scenes to achieve this.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * @class DOMElement
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this DOM Element in the world.
 * @param {number} [y=0] - The vertical position of this DOM Element in the world.
 * @param {(Element|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 */ var DOMElement = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    DOMElementRender
                ],
                initialize: function DOMElement(scene, x, y, element, style, innerText) {
                    GameObject.call(this, scene, "DOMElement");
                    /**
         * A reference to the parent DOM Container that the Game instance created when it started.
         *
         * @name Phaser.GameObjects.DOMElement#parent
         * @type {Element}
         * @since 3.17.0
         */ this.parent = scene.sys.game.domContainer;
                    /**
         * A reference to the HTML Cache.
         *
         * @name Phaser.GameObjects.DOMElement#cache
         * @type {Phaser.Cache.BaseCache}
         * @since 3.17.0
         */ this.cache = scene.sys.cache.html;
                    /**
         * The actual DOM Element that this Game Object is bound to. For example, if you've created a `<div>`
         * then this property is a direct reference to that element within the dom.
         *
         * @name Phaser.GameObjects.DOMElement#node
         * @type {Element}
         * @since 3.17.0
         */ this.node;
                    /**
         * By default a DOM Element will have its transform, display, opacity, zIndex and blend mode properties
         * updated when its rendered. If, for some reason, you don't want any of these changed other than the
         * CSS transform, then set this flag to `true`. When `true` only the CSS Transform is applied and it's
         * up to you to keep track of and set the other properties as required.
         *
         * This can be handy if, for example, you've a nested DOM Element and you don't want the opacity to be
         * picked-up by any of its children.
         *
         * @name Phaser.GameObjects.DOMElement#transformOnly
         * @type {boolean}
         * @since 3.17.0
         */ this.transformOnly = false;
                    /**
         * The angle, in radians, by which to skew the DOM Element on the horizontal axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewX
         * @type {number}
         * @since 3.17.0
         */ this.skewX = 0;
                    /**
         * The angle, in radians, by which to skew the DOM Element on the vertical axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewY
         * @type {number}
         * @since 3.17.0
         */ this.skewY = 0;
                    /**
         * A Vector4 that contains the 3D rotation of this DOM Element around a fixed axis in 3D space.
         *
         * All values in the Vector4 are treated as degrees, unless the `rotate3dAngle` property is changed.
         *
         * For more details see the following MDN page:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3d
         * @type {Phaser.Math.Vector4}
         * @since 3.17.0
         */ this.rotate3d = new Vector4();
                    /**
         * The unit that represents the 3D rotation values. By default this is `deg` for degrees, but can
         * be changed to any supported unit. See this page for further details:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3dAngle
         * @type {string}
         * @since 3.17.0
         */ this.rotate3dAngle = "deg";
                    /**
         * Sets the CSS `pointerEvents` attribute on the DOM Element during rendering.
         *
         * This is 'auto' by default. Changing it may have unintended side-effects with
         * internal Phaser input handling, such as dragging, so only change this if you
         * understand the implications.
         *
         * @name Phaser.GameObjects.DOMElement#pointerEvents
         * @type {string}
         * @since 3.55.0
         */ this.pointerEvents = "auto";
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayWidth` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#width
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.width = 0;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayHeight` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#height
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.height = 0;
                    /**
         * The computed display width of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `width` holds the un-scaled width of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayWidth
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayWidth = 0;
                    /**
         * The computed display height of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `height` holds the un-scaled height of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayHeight
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayHeight = 0;
                    /**
         * Internal native event handler.
         *
         * @name Phaser.GameObjects.DOMElement#handler
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.handler = this.dispatchNativeEvent.bind(this);
                    this.setPosition(x, y);
                    if (typeof element === "string") {
                        //  hash?
                        if (element[0] === "#") this.setElement(element.substr(1), style, innerText);
                        else this.createElement(element, style, innerText);
                    } else if (element) this.setElement(element, style, innerText);
                    scene.sys.events.on(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                    scene.sys.events.on(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Handles a Scene Sleep and Wake event.
     *
     * @method Phaser.GameObjects.DOMElement#handleSceneEvent
     * @private
     * @since 3.22.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems.
     */ handleSceneEvent: function(sys) {
                    var node = this.node;
                    var style = node.style;
                    if (node) style.display = sys.settings.visible ? "block" : "none";
                },
                /**
     * Sets the horizontal and vertical skew values of this DOM Element.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/transform
     *
     * @method Phaser.GameObjects.DOMElement#setSkew
     * @since 3.17.0
     *
     * @param {number} [x=0] - The angle, in radians, by which to skew the DOM Element on the horizontal axis.
     * @param {number} [y=x] - The angle, in radians, by which to skew the DOM Element on the vertical axis.
     *
     * @return {this} This DOM Element instance.
     */ setSkew: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.skewX = x;
                    this.skewY = y;
                    return this;
                },
                /**
     * Sets the perspective CSS property of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @method Phaser.GameObjects.DOMElement#setPerspective
     * @since 3.17.0
     *
     * @param {number} value - The perspective value, in pixels, that determines the distance between the z plane and the user.
     *
     * @return {this} This DOM Element instance.
     */ setPerspective: function(value) {
                    this.parent.style.perspective = value + "px";
                    return this;
                },
                /**
     * The perspective CSS property value of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @name Phaser.GameObjects.DOMElement#perspective
     * @type {number}
     * @since 3.17.0
     */ perspective: {
                    get: function() {
                        return parseFloat(this.parent.style.perspective);
                    },
                    set: function(value) {
                        this.parent.style.perspective = value + "px";
                    }
                },
                /**
     * Adds one or more native DOM event listeners onto the underlying Element of this Game Object.
     * The event is then dispatched via this Game Objects standard event emitter.
     *
     * For example:
     *
     * ```javascript
     * var div = this.add.dom(x, y, element);
     *
     * div.addListener('click');
     *
     * div.on('click', handler);
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#addListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to listen for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ addListener: function(events) {
                    if (this.node) {
                        events = events.split(" ");
                        for(var i = 0; i < events.length; i++)this.node.addEventListener(events[i], this.handler, false);
                    }
                    return this;
                },
                /**
     * Removes one or more native DOM event listeners from the underlying Element of this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#removeListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to stop listening for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ removeListener: function(events) {
                    if (this.node) {
                        events = events.split(" ");
                        for(var i = 0; i < events.length; i++)this.node.removeEventListener(events[i], this.handler);
                    }
                    return this;
                },
                /**
     * Internal event proxy to dispatch native DOM Events via this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#dispatchNativeEvent
     * @private
     * @since 3.17.0
     *
     * @param {any} event - The native DOM event.
     */ dispatchNativeEvent: function(event) {
                    this.emit(event.type, event);
                },
                /**
     * Creates a native DOM Element, adds it to the parent DOM Container and then binds it to this Game Object,
     * so you can control it. The `tagName` should be a string and is passed to `document.createElement`:
     *
     * ```javascript
     * this.add.dom().createElement('div');
     * ```
     *
     * For more details on acceptable tag names see: https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().createElement('div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().createElement('div', style, 'Phaser');
     * ```
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createElement
     * @since 3.17.0
     *
     * @param {string} tagName - A string that specifies the type of element to be created. The nodeName of the created element is initialized with the value of tagName. Don't use qualified names (like "html:a") with this method.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ createElement: function(tagName, style, innerText) {
                    return this.setElement(document.createElement(tagName), style, innerText);
                },
                /**
     * Binds a new DOM Element to this Game Object. If this Game Object already has an Element it is removed from the DOM
     * entirely first. Any event listeners you may have previously created will need to be re-created on the new element.
     *
     * The `element` argument you pass to this method can be either a string tagName:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * this.add.dom().setElement('heading');
     * ```
     *
     * Or a reference to an Element instance:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * var h1 = document.getElementById('heading');
     *
     * this.add.dom().setElement(h1);
     * ```
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().setElement(h1, 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().setElement(h1, style, 'Phaser');
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#setElement
     * @since 3.17.0
     *
     * @param {(string|Element)} element - If a string it is passed to `getElementById()`, or it should be a reference to an existing Element.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ setElement: function(element, style, innerText) {
                    //  Already got an element? Remove it first
                    this.removeElement();
                    var target;
                    if (typeof element === "string") {
                        //  hash?
                        if (element[0] === "#") element = element.substr(1);
                        target = document.getElementById(element);
                    } else if (typeof element === "object" && element.nodeType === 1) target = element;
                    if (!target) return this;
                    this.node = target;
                    //  style can be empty, a string or a plain object
                    if (style && IsPlainObject(style)) for(var key in style)target.style[key] = style[key];
                    else if (typeof style === "string") target.style = style;
                    //  Add / Override the values we need
                    target.style.zIndex = "0";
                    target.style.display = "inline";
                    target.style.position = "absolute";
                    //  Node handler
                    target.phaser = this;
                    if (this.parent) this.parent.appendChild(target);
                    //  InnerText
                    if (innerText) target.innerText = innerText;
                    return this.updateSize();
                },
                /**
     * Takes a block of html from the HTML Cache, that has previously been preloaded into the game, and then
     * creates a DOM Element from it. The loaded HTML is set as the `innerHTML` property of the created
     * element.
     *
     * Assume the following html is stored in a file called `loginform.html`:
     *
     * ```html
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * ```
     *
     * Which is loaded into your game using the cache key 'login':
     *
     * ```javascript
     * this.load.html('login', 'assets/loginform.html');
     * ```
     *
     * You can create a DOM Element from it using the cache key:
     *
     * ```javascript
     * this.add.dom().createFromCache('login');
     * ```
     *
     * The optional `elementType` argument controls the container that is created, into which the loaded html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromCache
     * @since 3.17.0
     *
     * @param {string} The key of the html cache entry to use for this DOM Element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the loaded html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromCache: function(key, tagName) {
                    var html = this.cache.get(key);
                    if (html) this.createFromHTML(html, tagName);
                    return this;
                },
                /**
     * Takes a string of html and then creates a DOM Element from it. The HTML is set as the `innerHTML`
     * property of the created element.
     *
     * ```javascript
     * let form = `
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * `;
     * ```
     *
     * You can create a DOM Element from it using the string:
     *
     * ```javascript
     * this.add.dom().createFromHTML(form);
     * ```
     *
     * The optional `elementType` argument controls the type of container that is created, into which the html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromHTML
     * @since 3.17.0
     *
     * @param {string} html - A string of html to be set as the `innerHTML` property of the created element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromHTML: function(html, tagName) {
                    if (tagName === undefined) tagName = "div";
                    //  Already got an element? Remove it first
                    this.removeElement();
                    var element = document.createElement(tagName);
                    this.node = element;
                    element.style.zIndex = "0";
                    element.style.display = "inline";
                    element.style.position = "absolute";
                    //  Node handler
                    element.phaser = this;
                    if (this.parent) this.parent.appendChild(element);
                    element.innerHTML = html;
                    return this.updateSize();
                },
                /**
     * Removes the current DOM Element bound to this Game Object from the DOM entirely and resets the
     * `node` property of this Game Object to be `null`.
     *
     * @method Phaser.GameObjects.DOMElement#removeElement
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ removeElement: function() {
                    if (this.node) {
                        RemoveFromDOM(this.node);
                        this.node = null;
                    }
                    return this;
                },
                /**
     * Internal method that calls `getBoundingClientRect` on the `node` and then sets the bounds width
     * and height into the `displayWidth` and `displayHeight` properties, and the `clientWidth` and `clientHeight`
     * values into the `width` and `height` properties respectively.
     *
     * This is called automatically whenever a new element is created or set.
     *
     * @method Phaser.GameObjects.DOMElement#updateSize
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ updateSize: function() {
                    var node = this.node;
                    var nodeBounds = node.getBoundingClientRect();
                    this.width = node.clientWidth;
                    this.height = node.clientHeight;
                    this.displayWidth = nodeBounds.width || 0;
                    this.displayHeight = nodeBounds.height || 0;
                    return this;
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a property matching the given key and value. It then returns this child
     * if found, or `null` if not.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByProperty
     * @since 3.17.0
     *
     * @param {string} property - The property to search the children for.
     * @param {string} value - The value the property must strictly equal.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByProperty: function(property, value) {
                    if (this.node) {
                        var children = this.node.querySelectorAll("*");
                        for(var i = 0; i < children.length; i++){
                            if (children[i][property] === value) return children[i];
                        }
                    }
                    return null;
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching id. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByID
     * @since 3.17.0
     *
     * @param {string} id - The id to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByID: function(id) {
                    return this.getChildByProperty("id", id);
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching name. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByName
     * @since 3.17.0
     *
     * @param {string} name - The name to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByName: function(name) {
                    return this.getChildByProperty("name", name);
                },
                /**
     * Sets the `className` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setClassName
     * @since 3.17.0
     *
     * @param {string} className - A string representing the class or space-separated classes of the element.
     *
     * @return {this} This DOM Element instance.
     */ setClassName: function(className) {
                    if (this.node) {
                        this.node.className = className;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Sets the `innerText` property of the DOM Element node and updates the internal sizes.
     *
     * Note that only certain types of Elements can have `innerText` set on them.
     *
     * @method Phaser.GameObjects.DOMElement#setText
     * @since 3.17.0
     *
     * @param {string} text - A DOMString representing the rendered text content of the element.
     *
     * @return {this} This DOM Element instance.
     */ setText: function(text) {
                    if (this.node) {
                        this.node.innerText = text;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Sets the `innerHTML` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setHTML
     * @since 3.17.0
     *
     * @param {string} html - A DOMString of html to be set as the `innerHTML` property of the element.
     *
     * @return {this} This DOM Element instance.
     */ setHTML: function(html) {
                    if (this.node) {
                        this.node.innerHTML = html;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Runs internal update tasks.
     *
     * @method Phaser.GameObjects.DOMElement#preUpdate
     * @private
     * @since 3.17.0
     */ preUpdate: function() {
                    var parent = this.parentContainer;
                    var node = this.node;
                    if (node && parent && !parent.willRender()) node.style.display = "none";
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     *
     * DOMElements always return `true` as they need to still set values during the render pass, even if not visible.
     *
     * @method Phaser.GameObjects.DOMElement#willRender
     * @since 3.17.0
     *
     * @return {boolean} `true` if the Game Object should be rendered, otherwise `false`.
     */ willRender: function() {
                    return true;
                },
                /**
     * Handles the pre-destroy step for the DOM Element, which removes the underlying node from the DOM.
     *
     * @method Phaser.GameObjects.DOMElement#preDestroy
     * @private
     * @since 3.17.0
     */ preDestroy: function() {
                    this.removeElement();
                    this.scene.sys.events.off(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                    this.scene.sys.events.off(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                }
            });
            module1.exports = DOMElement;
        /***/ },
        /* 443 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CSSBlendModes = __webpack_require__(1056);
            var GameObject = __webpack_require__(15);
            var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DOMElement#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active renderer.
 * @param {Phaser.GameObjects.DOMElement} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DOMElementCSSRenderer = function(renderer, src, camera, parentMatrix) {
                if (!src.node) return;
                var style = src.node.style;
                var settings = src.scene.sys.settings;
                if (!style || !settings.visible || GameObject.RENDER_MASK !== src.renderFlags || src.cameraFilter !== 0 && src.cameraFilter & camera.id || src.parentContainer && !src.parentContainer.willRender()) {
                    style.display = "none";
                    return;
                }
                var parent = src.parentContainer;
                var alpha = camera.alpha * src.alpha;
                if (parent) alpha *= parent.alpha;
                var camMatrix = tempMatrix1;
                var srcMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                var dx = 0;
                var dy = 0;
                var tx = "0%";
                var ty = "0%";
                if (parentMatrix) {
                    dx = src.width * src.scaleX * src.originX;
                    dy = src.height * src.scaleY * src.originY;
                    srcMatrix.applyITRS(src.x - dx, src.y - dy, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    srcMatrix.e = src.x - dx;
                    srcMatrix.f = src.y - dy;
                    //  Multiply by the src matrix, store result in calcMatrix
                    camMatrix.multiply(srcMatrix, calcMatrix);
                } else {
                    dx = src.width * src.originX;
                    dy = src.height * src.originY;
                    srcMatrix.applyITRS(src.x - dx, src.y - dy, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    tx = 100 * src.originX + "%";
                    ty = 100 * src.originY + "%";
                    srcMatrix.e -= camera.scrollX * src.scrollFactorX;
                    srcMatrix.f -= camera.scrollY * src.scrollFactorY;
                    //  Multiply by the src matrix, store result in calcMatrix
                    camMatrix.multiply(srcMatrix, calcMatrix);
                }
                if (!src.transformOnly) {
                    style.display = "block";
                    style.opacity = alpha;
                    style.zIndex = src._depth;
                    style.pointerEvents = src.pointerEvents;
                    style.mixBlendMode = CSSBlendModes[src._blendMode];
                }
                // https://developer.mozilla.org/en-US/docs/Web/CSS/transform
                style.transform = calcMatrix.getCSSMatrix() + " skew(" + src.skewX + "rad, " + src.skewY + "rad)" + " rotate3d(" + src.rotate3d.x + "," + src.rotate3d.y + "," + src.rotate3d.z + "," + src.rotate3d.w + src.rotate3dAngle + ")";
                style.transformOrigin = tx + " " + ty;
            };
            module1.exports = DOMElementCSSRenderer;
        /***/ },
        /* 444 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var ExternRender = __webpack_require__(1060);
            /**
 * @classdesc
 * An Extern Game Object is a special type of Game Object that allows you to pass
 * rendering off to a 3rd party.
 *
 * When you create an Extern and place it in the display list of a Scene, the renderer will
 * process the list as usual. When it finds an Extern it will flush the current batch,
 * clear down the pipeline and prepare a transform matrix which your render function can
 * take advantage of, if required.
 *
 * The WebGL context is then left in a 'clean' state, ready for you to bind your own shaders,
 * or draw to it, whatever you wish to do. This should all take place in the `render` method.
 * The correct way to deploy an Extern object is to create a class that extends it, then
 * override the `render` (and optionally `preUpdate`) methods and pass off control to your
 * 3rd party libraries or custom WebGL code there.
 *
 * Once you've finished, you should free-up any of your resources.
 * The Extern will then rebind the Phaser pipeline and carry on rendering the display list.
 *
 * Although this object has lots of properties such as Alpha, Blend Mode and Tint, none of
 * them are used during rendering unless you take advantage of them in your own render code.
 *
 * @class Extern
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.16.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 */ var Extern = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.Texture,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    ExternRender
                ],
                initialize: function Extern(scene) {
                    GameObject.call(this, scene, "Extern");
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                preUpdate: function() {
                //  override this!
                //  Arguments: time, delta
                },
                render: function() {
                //  override this!
                //  Arguments: renderer, camera, calcMatrix
                }
            });
            module1.exports = Extern;
        /***/ },
        /* 445 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(218);
            var FromPercent = __webpack_require__(98);
            var MATH_CONST = __webpack_require__(14);
            var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Ellipse.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
 */ var GetPoint = function(ellipse, position, out) {
                if (out === undefined) out = new Point();
                var angle = FromPercent(position, 0, MATH_CONST.PI2);
                return CircumferencePoint(ellipse, angle, out);
            };
            module1.exports = GetPoint;
        /***/ },
        /* 446 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(447);
            var CircumferencePoint = __webpack_require__(218);
            var FromPercent = __webpack_require__(98);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Ellipse.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
 */ var GetPoints = function(ellipse, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Circumference(ellipse) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                    out.push(CircumferencePoint(ellipse, angle));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 447 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference of.
 *
 * @return {number} The circumference of th Ellipse.
 */ var Circumference = function(ellipse) {
                var rx = ellipse.width / 2;
                var ry = ellipse.height / 2;
                var h = Math.pow(rx - ry, 2) / Math.pow(rx + ry, 2);
                return Math.PI * (rx + ry) * (1 + 3 * h / (10 + Math.sqrt(4 - 3 * h)));
            };
            module1.exports = Circumference;
        /***/ },
        /* 448 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(217);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 * @param {CanvasRenderingContext2D} [renderTargetCtx] - The target rendering context.
 * @param {boolean} allowClip - If `true` then path operations will be used instead of fill operations.
 */ var GraphicsCanvasRenderer = function(renderer, src, camera, parentMatrix, renderTargetCtx, allowClip) {
                var commandBuffer = src.commandBuffer;
                var commandBufferLength = commandBuffer.length;
                var ctx = renderTargetCtx || renderer.currentContext;
                if (commandBufferLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var lineAlpha = 1;
                var fillAlpha = 1;
                var lineColor = 0;
                var fillColor = 0;
                var lineWidth = 1;
                var red = 0;
                var green = 0;
                var blue = 0;
                //  Reset any currently active paths
                ctx.beginPath();
                for(var index = 0; index < commandBufferLength; ++index){
                    var commandID = commandBuffer[index];
                    switch(commandID){
                        case Commands.ARC:
                            ctx.arc(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4], commandBuffer[index + 5], commandBuffer[index + 6]);
                            //  +7 because overshoot is the 7th value, not used in Canvas
                            index += 7;
                            break;
                        case Commands.LINE_STYLE:
                            lineWidth = commandBuffer[index + 1];
                            lineColor = commandBuffer[index + 2];
                            lineAlpha = commandBuffer[index + 3];
                            red = (lineColor & 0xFF0000) >>> 16;
                            green = (lineColor & 0xFF00) >>> 8;
                            blue = lineColor & 0xFF;
                            ctx.strokeStyle = "rgba(" + red + "," + green + "," + blue + "," + lineAlpha + ")";
                            ctx.lineWidth = lineWidth;
                            index += 3;
                            break;
                        case Commands.FILL_STYLE:
                            fillColor = commandBuffer[index + 1];
                            fillAlpha = commandBuffer[index + 2];
                            red = (fillColor & 0xFF0000) >>> 16;
                            green = (fillColor & 0xFF00) >>> 8;
                            blue = fillColor & 0xFF;
                            ctx.fillStyle = "rgba(" + red + "," + green + "," + blue + "," + fillAlpha + ")";
                            index += 2;
                            break;
                        case Commands.BEGIN_PATH:
                            ctx.beginPath();
                            break;
                        case Commands.CLOSE_PATH:
                            ctx.closePath();
                            break;
                        case Commands.FILL_PATH:
                            if (!allowClip) ctx.fill();
                            break;
                        case Commands.STROKE_PATH:
                            if (!allowClip) ctx.stroke();
                            break;
                        case Commands.FILL_RECT:
                            if (!allowClip) ctx.fillRect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                            else ctx.rect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                            index += 4;
                            break;
                        case Commands.FILL_TRIANGLE:
                            ctx.beginPath();
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                            ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                            ctx.closePath();
                            if (!allowClip) ctx.fill();
                            index += 6;
                            break;
                        case Commands.STROKE_TRIANGLE:
                            ctx.beginPath();
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                            ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                            ctx.closePath();
                            if (!allowClip) ctx.stroke();
                            index += 6;
                            break;
                        case Commands.LINE_TO:
                            ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.MOVE_TO:
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.LINE_FX_TO:
                            ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 5;
                            break;
                        case Commands.MOVE_FX_TO:
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 5;
                            break;
                        case Commands.SAVE:
                            ctx.save();
                            break;
                        case Commands.RESTORE:
                            ctx.restore();
                            break;
                        case Commands.TRANSLATE:
                            ctx.translate(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.SCALE:
                            ctx.scale(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.ROTATE:
                            ctx.rotate(commandBuffer[index + 1]);
                            index += 1;
                            break;
                        case Commands.GRADIENT_FILL_STYLE:
                            index += 5;
                            break;
                        case Commands.GRADIENT_LINE_STYLE:
                            index += 6;
                            break;
                    }
                }
                //  Restore the context saved in SetTransform
                ctx.restore();
            };
            module1.exports = GraphicsCanvasRenderer;
        /***/ },
        /* 449 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FloatBetween = __webpack_require__(137);
            var GetEaseFunction = __webpack_require__(80);
            var GetFastValue = __webpack_require__(2);
            var Wrap = __webpack_require__(68);
            /**
 * @classdesc
 * A Particle Emitter property.
 *
 * Facilitates changing Particle properties as they are emitted and throughout their lifetime.
 *
 * @class EmitterOp
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for the Particle Emitter that owns this property.
 * @param {string} key - The name of the property.
 * @param {number} defaultValue - The default value of the property.
 * @param {boolean} [emitOnly=false] - Whether the property can only be modified when a Particle is emitted.
 */ var EmitterOp = new Class({
                initialize: function EmitterOp(config, key, defaultValue, emitOnly) {
                    if (emitOnly === undefined) emitOnly = false;
                    /**
         * The name of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyKey
         * @type {string}
         * @since 3.0.0
         */ this.propertyKey = key;
                    /**
         * The value of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyValue
         * @type {number}
         * @since 3.0.0
         */ this.propertyValue = defaultValue;
                    /**
         * The default value of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#defaultValue
         * @type {number}
         * @since 3.0.0
         */ this.defaultValue = defaultValue;
                    /**
         * The number of steps for stepped easing between {@link Phaser.GameObjects.Particles.EmitterOp#start} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#end} values, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#steps
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.steps = 0;
                    /**
         * The step counter for stepped easing, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#counter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.counter = 0;
                    /**
         * The start value for this property to ease between.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#start
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.start = 0;
                    /**
         * The end value for this property to ease between.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#end
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.end = 0;
                    /**
         * The easing function to use for updating this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#ease
         * @type {?function}
         * @since 3.0.0
         */ this.ease;
                    /**
         * Whether this property can only be modified when a Particle is emitted.
         *
         * Set to `true` to allow only {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} callbacks to be set and
         * affect this property.
         *
         * Set to `false` to allow both {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks to be set and affect this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#emitOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.emitOnly = emitOnly;
                    /**
         * The callback to run for Particles when they are emitted from the Particle Emitter.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onEmit
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitCallback}
         * @since 3.0.0
         */ this.onEmit = this.defaultEmit;
                    /**
         * The callback to run for Particles when they are updated.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onUpdate
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateCallback}
         * @since 3.0.0
         */ this.onUpdate = this.defaultUpdate;
                    this.loadConfig(config);
                },
                /**
     * Load the property from a Particle Emitter configuration object.
     *
     * Optionally accepts a new property key to use, replacing the current one.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#loadConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} [config] - Settings for the Particle Emitter that owns this property.
     * @param {string} [newKey] - The new key to use for this property, if any.
     */ loadConfig: function(config, newKey) {
                    if (config === undefined) config = {};
                    if (newKey) this.propertyKey = newKey;
                    this.propertyValue = GetFastValue(config, this.propertyKey, this.defaultValue);
                    this.setMethods();
                    if (this.emitOnly) //  Reset it back again
                    this.onUpdate = this.defaultUpdate;
                },
                /**
     * Build a JSON representation of this Particle Emitter property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Particle Emitter property.
     */ toJSON: function() {
                    return this.propertyValue;
                },
                /**
     * Change the current value of the property and update its callback methods.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#onChange
     * @since 3.0.0
     *
     * @param {number} value - The value of the property.
     *
     * @return {this} This Emitter Op object.
     */ onChange: function(value) {
                    this.propertyValue = value;
                    return this.setMethods();
                },
                /**
     * Update the {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks based on the type of the current
     * {@link Phaser.GameObjects.Particles.EmitterOp#propertyValue}.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#setMethods
     * @since 3.0.0
     *
     * @return {this} This Emitter Op object.
     */ setMethods: function() {
                    var value = this.propertyValue;
                    var t = typeof value;
                    //  Reset them in case they're not changed below
                    this.onEmit = this.defaultEmit;
                    this.onUpdate = this.defaultUpdate;
                    if (t === "number") {
                        //  Explicit static value:
                        //  x: 400
                        this.onEmit = this.staticValueEmit;
                        this.onUpdate = this.staticValueUpdate; // How?
                    } else if (Array.isArray(value)) //  Picks a random element from the array:
                    //  x: [ 100, 200, 300, 400 ]
                    this.onEmit = this.randomStaticValueEmit;
                    else if (t === "function") {
                        //  The same as setting just the onUpdate function and no onEmit (unless this op is an emitOnly one)
                        //  Custom callback, must return a value:
                        /*
            x: function (particle, key, t, value)
               {
                   return value + 50;
               }
            */ if (this.emitOnly) this.onEmit = value;
                        else this.onUpdate = value;
                    } else if (t === "object" && this.hasBoth(value, "start", "end")) {
                        this.start = value.start;
                        this.end = value.end;
                        //  x: { start: 100, end: 400, random: true } (random optional) = eases between start and end
                        var isRandom = this.has(value, "random");
                        if (isRandom) this.onEmit = this.randomRangedValueEmit;
                        if (this.has(value, "steps")) {
                            //  A stepped (per emit) range
                            //  x: { start: 100, end: 400, steps: 64 }
                            //  Increments a value stored in the emitter
                            this.steps = value.steps;
                            this.counter = this.start;
                            this.onEmit = this.steppedEmit;
                        } else {
                            //  An eased range (defaults to Linear if not specified)
                            //  x: { start: 100, end: 400, [ ease: 'Linear' ] }
                            var easeType = this.has(value, "ease") ? value.ease : "Linear";
                            this.ease = GetEaseFunction(easeType, value.easeParams);
                            if (!isRandom) this.onEmit = this.easedValueEmit;
                            this.onUpdate = this.easeValueUpdate;
                        }
                    } else if (t === "object" && this.hasBoth(value, "min", "max")) {
                        //  { min: 100, max: 400 } = pick a random number between min and max
                        this.start = value.min;
                        this.end = value.max;
                        this.onEmit = this.randomRangedValueEmit;
                    } else if (t === "object" && this.has(value, "random")) {
                        //  { random: [ 100, 400 ] } = pick a random number between the two elements of the array
                        var rnd = value.random;
                        if (Array.isArray(rnd)) {
                            this.start = rnd[0];
                            this.end = rnd[1];
                        }
                        this.onEmit = this.randomRangedValueEmit;
                    } else if (t === "object" && this.hasEither(value, "onEmit", "onUpdate")) {
                        //  Custom onEmit and onUpdate callbacks
                        /*
            x: {
                //  Called at the start of the particles life, when it is being created
                onEmit: function (particle, key, t, value)
                {
                    return value;
                },

                //  Called during the particles life on each update
                onUpdate: function (particle, key, t, value)
                {
                    return value;
                }
            }
            */ if (this.has(value, "onEmit")) this.onEmit = value.onEmit;
                        if (this.has(value, "onUpdate")) this.onUpdate = value.onUpdate;
                    }
                    return this;
                },
                /**
     * Check whether an object has the given property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#has
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key - The key of the property to look for in the object.
     *
     * @return {boolean} `true` if the property exists in the object, `false` otherwise.
     */ has: function(object, key) {
                    return object.hasOwnProperty(key);
                },
                /**
     * Check whether an object has both of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasBoth
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if both properties exist in the object, `false` otherwise.
     */ hasBoth: function(object, key1, key2) {
                    return object.hasOwnProperty(key1) && object.hasOwnProperty(key2);
                },
                /**
     * Check whether an object has at least one of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasEither
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if at least one of the properties exists in the object, `false` if neither exist.
     */ hasEither: function(object, key1, key2) {
                    return object.hasOwnProperty(key1) || object.hasOwnProperty(key2);
                },
                /**
     * The returned value sets what the property will be at the START of the particles life, on emit.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} [value] - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ defaultEmit: function(particle, key, value) {
                    return value;
                },
                /**
     * The returned value updates the property for the duration of the particles life.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The T value (between 0 and 1)
     * @param {number} value - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ defaultUpdate: function(particle, key, t, value) {
                    return value;
                },
                /**
     * An `onEmit` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueEmit
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueEmit: function() {
                    return this.propertyValue;
                },
                /**
     * An `onUpdate` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueUpdate
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueUpdate: function() {
                    return this.propertyValue;
                },
                /**
     * An `onEmit` callback that returns a random value from the current value array.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomStaticValueEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ randomStaticValueEmit: function() {
                    var randomIndex = Math.floor(Math.random() * this.propertyValue.length);
                    return this.propertyValue[randomIndex];
                },
                /**
     * An `onEmit` callback that returns a value between the {@link Phaser.GameObjects.Particles.EmitterOp#start} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#end} range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomRangedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The key of the property.
     *
     * @return {number} The new value of the property.
     */ randomRangedValueEmit: function(particle, key) {
                    var value = FloatBetween(this.start, this.end);
                    if (particle && particle.data[key]) particle.data[key].min = value;
                    return value;
                },
                /**
     * An `onEmit` callback that returns a stepped value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#steppedEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ steppedEmit: function() {
                    var current = this.counter;
                    var next = this.counter + (this.end - this.start) / this.steps;
                    this.counter = Wrap(next, this.start, this.end);
                    return current;
                },
                /**
     * An `onEmit` callback for an eased property.
     *
     * It prepares the particle for easing by {@link Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate}.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     *
     * @return {number} {@link Phaser.GameObjects.Particles.EmitterOp#start}, as the new value of the property.
     */ easedValueEmit: function(particle, key) {
                    if (particle && particle.data[key]) {
                        var data = particle.data[key];
                        data.min = this.start;
                        data.max = this.end;
                    }
                    return this.start;
                },
                /**
     * An `onUpdate` callback that returns an eased value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The T value (between 0 and 1)
     *
     * @return {number} The new value of the property.
     */ easeValueUpdate: function(particle, key, t) {
                    var data = particle.data[key];
                    return (data.max - data.min) * this.ease(t) + data.min;
                }
            });
            module1.exports = EmitterOp;
        /***/ },
        /* 450 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * The GravityWell action applies a force on the particle to draw it towards, or repel it from, a single point.
 * 
 * The force applied is inversely proportional to the square of the distance from the particle to the point, in accordance with Newton's law of gravity.
 * 
 * This simulates the effect of gravity over large distances (as between planets, for example).
 *
 * @class GravityWell
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.GameObjects.Particles.GravityWellConfig)} [x=0] - The x coordinate of the Gravity Well, in world space.
 * @param {number} [y=0] - The y coordinate of the Gravity Well, in world space.
 * @param {number} [power=0] - The strength of the gravity force - larger numbers produce a stronger force.
 * @param {number} [epsilon=100] - The minimum distance for which the gravity force is calculated.
 * @param {number} [gravity=50] - The gravitational force of this Gravity Well.
 */ var GravityWell = new Class({
                initialize: function GravityWell(x, y, power, epsilon, gravity) {
                    if (typeof x === "object") {
                        var config = x;
                        x = GetFastValue(config, "x", 0);
                        y = GetFastValue(config, "y", 0);
                        power = GetFastValue(config, "power", 0);
                        epsilon = GetFastValue(config, "epsilon", 100);
                        gravity = GetFastValue(config, "gravity", 50);
                    } else {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (power === undefined) power = 0;
                        if (epsilon === undefined) epsilon = 100;
                        if (gravity === undefined) gravity = 50;
                    }
                    /**
         * The x coordinate of the Gravity Well, in world space.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y coordinate of the Gravity Well, in world space.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The active state of the Gravity Well. An inactive Gravity Well will not influence any particles.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Internal gravity value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_gravity
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._gravity = gravity;
                    /**
         * Internal power value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_power
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._power = 0;
                    /**
         * Internal epsilon value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_epsilon
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._epsilon = 0;
                    /**
         * The strength of the gravity force - larger numbers produce a stronger force.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#power
         * @type {number}
         * @since 3.0.0
         */ this.power = power;
                    /**
         * The minimum distance for which the gravity force is calculated.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#epsilon
         * @type {number}
         * @since 3.0.0
         */ this.epsilon = epsilon;
                },
                /**
     * Takes a Particle and updates it based on the properties of this Gravity Well.
     *
     * @method Phaser.GameObjects.Particles.GravityWell#update
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     */ update: function(particle, delta) {
                    var x = this.x - particle.x;
                    var y = this.y - particle.y;
                    var dSq = x * x + y * y;
                    if (dSq === 0) return;
                    var d = Math.sqrt(dSq);
                    if (dSq < this._epsilon) dSq = this._epsilon;
                    var factor = this._power * delta / (dSq * d) * 100;
                    particle.velocityX += x * factor;
                    particle.velocityY += y * factor;
                },
                epsilon: {
                    get: function() {
                        return Math.sqrt(this._epsilon);
                    },
                    set: function(value) {
                        this._epsilon = value * value;
                    }
                },
                power: {
                    get: function() {
                        return this._power / this._gravity;
                    },
                    set: function(value) {
                        this._power = value * this._gravity;
                    }
                },
                gravity: {
                    get: function() {
                        return this._gravity;
                    },
                    set: function(value) {
                        var pwr = this.power;
                        this._gravity = value;
                        this.power = pwr;
                    }
                }
            });
            module1.exports = GravityWell;
        /***/ },
        /* 451 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(36);
            var DistanceBetween = __webpack_require__(50);
            /**
 * @classdesc
 * A Particle is a simple Game Object controlled by a Particle Emitter and Manager, and rendered by the Manager.
 * It uses its own lightweight physics system, and can interact only with its Emitter's bounds and zones.
 *
 * @class Particle
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to which this Particle belongs.
 */ var Particle = new Class({
                initialize: function Particle(emitter) {
                    /**
         * The Emitter to which this Particle belongs.
         *
         * A Particle can only belong to a single Emitter and is created, updated and destroyed via it.
         *
         * @name Phaser.GameObjects.Particles.Particle#emitter
         * @type {Phaser.GameObjects.Particles.ParticleEmitter}
         * @since 3.0.0
         */ this.emitter = emitter;
                    /**
         * The texture frame used to render this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#frame
         * @type {Phaser.Textures.Frame}
         * @default null
         * @since 3.0.0
         */ this.frame = null;
                    /**
         * The x coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The x velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityX = 0;
                    /**
         * The y velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityY = 0;
                    /**
         * The x acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationX = 0;
                    /**
         * The y acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationY = 0;
                    /**
         * The maximum horizontal velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityX
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityX = 10000;
                    /**
         * The maximum vertical velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityY
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityY = 10000;
                    /**
         * The bounciness, or restitution, of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#bounce
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bounce = 0;
                    /**
         * The horizontal scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleX
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleX = 1;
                    /**
         * The vertical scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleY
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleY = 1;
                    /**
         * The alpha value of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#alpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.alpha = 1;
                    /**
         * The angle of this Particle in degrees.
         *
         * @name Phaser.GameObjects.Particles.Particle#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                    /**
         * The angle of this Particle in radians.
         *
         * @name Phaser.GameObjects.Particles.Particle#rotation
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rotation = 0;
                    /**
         * The tint applied to this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#tint
         * @type {number}
         * @webglOnly
         * @since 3.0.0
         */ this.tint = 0xffffff;
                    /**
         * The lifespan of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#life
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.life = 1000;
                    /**
         * The current life of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeCurrent
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.lifeCurrent = 1000;
                    /**
         * The delay applied to this Particle upon emission, in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#delayCurrent
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delayCurrent = 0;
                    /**
         * The normalized lifespan T value, where 0 is the start and 1 is the end.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeT
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lifeT = 0;
                    /**
         * The data used by the ease equation.
         *
         * @name Phaser.GameObjects.Particles.Particle#data
         * @type {object}
         * @since 3.0.0
         */ this.data = {
                        tint: {
                            min: 0xffffff,
                            max: 0xffffff,
                            current: 0xffffff
                        },
                        alpha: {
                            min: 1,
                            max: 1
                        },
                        rotate: {
                            min: 0,
                            max: 0
                        },
                        scaleX: {
                            min: 1,
                            max: 1
                        },
                        scaleY: {
                            min: 1,
                            max: 1
                        }
                    };
                },
                /**
     * Checks to see if this Particle is alive and updating.
     *
     * @method Phaser.GameObjects.Particles.Particle#isAlive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Particle is alive and updating, otherwise `false`.
     */ isAlive: function() {
                    return this.lifeCurrent > 0;
                },
                /**
     * Resets the position of this particle back to zero.
     *
     * @method Phaser.GameObjects.Particles.Particle#resetPosition
     * @since 3.16.0
     */ resetPosition: function() {
                    this.x = 0;
                    this.y = 0;
                },
                /**
     * Starts this Particle from the given coordinates.
     *
     * @method Phaser.GameObjects.Particles.Particle#fire
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to launch this Particle from.
     * @param {number} y - The y coordinate to launch this Particle from.
     */ fire: function(x, y) {
                    var emitter = this.emitter;
                    this.frame = emitter.getFrame();
                    if (emitter.emitZone) //  Updates particle.x and particle.y during this call
                    emitter.emitZone.getPoint(this);
                    if (x === undefined) this.x += emitter.x.onEmit(this, "x");
                    else this.x += x;
                    if (y === undefined) this.y += emitter.y.onEmit(this, "y");
                    else this.y += y;
                    this.life = emitter.lifespan.onEmit(this, "lifespan");
                    this.lifeCurrent = this.life;
                    this.lifeT = 0;
                    var sx = emitter.speedX.onEmit(this, "speedX");
                    var sy = emitter.speedY ? emitter.speedY.onEmit(this, "speedY") : sx;
                    if (emitter.radial) {
                        var rad = DegToRad(emitter.angle.onEmit(this, "angle"));
                        this.velocityX = Math.cos(rad) * Math.abs(sx);
                        this.velocityY = Math.sin(rad) * Math.abs(sy);
                    } else if (emitter.moveTo) {
                        var mx = emitter.moveToX.onEmit(this, "moveToX");
                        var my = emitter.moveToY ? emitter.moveToY.onEmit(this, "moveToY") : mx;
                        var angle = Math.atan2(my - this.y, mx - this.x);
                        var speed = DistanceBetween(this.x, this.y, mx, my) / (this.life / 1000);
                        //  We know how many pixels we need to move, but how fast?
                        // var speed = this.distanceToXY(displayObject, x, y) / (maxTime / 1000);
                        this.velocityX = Math.cos(angle) * speed;
                        this.velocityY = Math.sin(angle) * speed;
                    } else {
                        this.velocityX = sx;
                        this.velocityY = sy;
                    }
                    if (emitter.acceleration) {
                        this.accelerationX = emitter.accelerationX.onEmit(this, "accelerationX");
                        this.accelerationY = emitter.accelerationY.onEmit(this, "accelerationY");
                    }
                    this.maxVelocityX = emitter.maxVelocityX.onEmit(this, "maxVelocityX");
                    this.maxVelocityY = emitter.maxVelocityY.onEmit(this, "maxVelocityY");
                    this.delayCurrent = emitter.delay.onEmit(this, "delay");
                    this.scaleX = emitter.scaleX.onEmit(this, "scaleX");
                    this.scaleY = emitter.scaleY ? emitter.scaleY.onEmit(this, "scaleY") : this.scaleX;
                    this.angle = emitter.rotate.onEmit(this, "rotate");
                    this.rotation = DegToRad(this.angle);
                    this.bounce = emitter.bounce.onEmit(this, "bounce");
                    this.alpha = emitter.alpha.onEmit(this, "alpha");
                    this.tint = emitter.tint.onEmit(this, "tint");
                },
                /**
     * An internal method that calculates the velocity of the Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter that is updating this Particle.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {array} processors - Particle processors (gravity wells).
     */ computeVelocity: function(emitter, delta, step, processors) {
                    var vx = this.velocityX;
                    var vy = this.velocityY;
                    var ax = this.accelerationX;
                    var ay = this.accelerationY;
                    var mx = this.maxVelocityX;
                    var my = this.maxVelocityY;
                    vx += emitter.gravityX * step;
                    vy += emitter.gravityY * step;
                    if (ax) vx += ax * step;
                    if (ay) vy += ay * step;
                    if (vx > mx) vx = mx;
                    else if (vx < -mx) vx = -mx;
                    if (vy > my) vy = my;
                    else if (vy < -my) vy = -my;
                    this.velocityX = vx;
                    this.velocityY = vy;
                    //  Apply any additional processors
                    for(var i = 0; i < processors.length; i++)processors[i].update(this, delta, step);
                },
                /**
     * Checks if this Particle is still within the bounds defined by the given Emitter.
     *
     * If not, and depending on the Emitter collision flags, the Particle may either stop or rebound.
     *
     * @method Phaser.GameObjects.Particles.Particle#checkBounds
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to check the bounds against.
     */ checkBounds: function(emitter) {
                    var bounds = emitter.bounds;
                    var bounce = -this.bounce;
                    if (this.x < bounds.x && emitter.collideLeft) {
                        this.x = bounds.x;
                        this.velocityX *= bounce;
                    } else if (this.x > bounds.right && emitter.collideRight) {
                        this.x = bounds.right;
                        this.velocityX *= bounce;
                    }
                    if (this.y < bounds.y && emitter.collideTop) {
                        this.y = bounds.y;
                        this.velocityY *= bounce;
                    } else if (this.y > bounds.bottom && emitter.collideBottom) {
                        this.y = bounds.bottom;
                        this.velocityY *= bounce;
                    }
                },
                /**
     * The main update method for this Particle.
     *
     * Updates its life values, computes the velocity and repositions the Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {array} processors - An optional array of update processors.
     *
     * @return {boolean} Returns `true` if this Particle has now expired and should be removed, otherwise `false` if still active.
     */ update: function(delta, step, processors) {
                    if (this.delayCurrent > 0) {
                        this.delayCurrent -= delta;
                        return false;
                    }
                    var emitter = this.emitter;
                    //  How far along in life is this particle? (t = 0 to 1)
                    var t = 1 - this.lifeCurrent / this.life;
                    this.lifeT = t;
                    this.computeVelocity(emitter, delta, step, processors);
                    this.x += this.velocityX * step;
                    this.y += this.velocityY * step;
                    if (emitter.bounds) this.checkBounds(emitter);
                    if (emitter.deathZone && emitter.deathZone.willKill(this)) {
                        this.lifeCurrent = 0;
                        //  No need to go any further, particle has been killed
                        return true;
                    }
                    this.scaleX = emitter.scaleX.onUpdate(this, "scaleX", t, this.scaleX);
                    if (emitter.scaleY) this.scaleY = emitter.scaleY.onUpdate(this, "scaleY", t, this.scaleY);
                    else this.scaleY = this.scaleX;
                    this.angle = emitter.rotate.onUpdate(this, "rotate", t, this.angle);
                    this.rotation = DegToRad(this.angle);
                    this.alpha = emitter.alpha.onUpdate(this, "alpha", t, this.alpha);
                    this.tint = emitter.tint.onUpdate(this, "tint", t, this.tint);
                    this.lifeCurrent -= delta;
                    return this.lifeCurrent <= 0;
                }
            });
            module1.exports = Particle;
        /***/ },
        /* 452 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(35);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DeathZone = __webpack_require__(453);
            var EdgeZone = __webpack_require__(454);
            var EmitterOp = __webpack_require__(449);
            var GetFastValue = __webpack_require__(2);
            var GetRandom = __webpack_require__(210);
            var HasAny = __webpack_require__(455);
            var HasValue = __webpack_require__(126);
            var Particle = __webpack_require__(451);
            var RandomZone = __webpack_require__(456);
            var Rectangle = __webpack_require__(10);
            var StableSort = __webpack_require__(79);
            var Vector2 = __webpack_require__(3);
            var Wrap = __webpack_require__(68);
            /**
 * @classdesc
 * A particle emitter represents a single particle stream.
 * It controls a pool of {@link Phaser.GameObjects.Particles.Particle Particles} and is controlled by a {@link Phaser.GameObjects.Particles.ParticleEmitterManager Particle Emitter Manager}.
 *
 * @class ParticleEmitter
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} manager - The Emitter Manager this Emitter belongs to.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
 */ var ParticleEmitter = new Class({
                Mixins: [
                    Components.BlendMode,
                    Components.Mask,
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function ParticleEmitter(manager, config) {
                    /**
         * The Emitter Manager this Emitter belongs to.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#manager
         * @type {Phaser.GameObjects.Particles.ParticleEmitterManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The texture assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = manager.texture;
                    /**
         * The texture frames assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frames
         * @type {Phaser.Textures.Frame[]}
         * @since 3.0.0
         */ this.frames = [
                        manager.defaultFrame
                    ];
                    /**
         * The default texture frame assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#defaultFrame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.defaultFrame = manager.defaultFrame;
                    /**
         * Names of simple configuration properties.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#configFastMap
         * @type {object}
         * @since 3.0.0
         */ this.configFastMap = [
                        "active",
                        "blendMode",
                        "collideBottom",
                        "collideLeft",
                        "collideRight",
                        "collideTop",
                        "deathCallback",
                        "deathCallbackScope",
                        "emitCallback",
                        "emitCallbackScope",
                        "follow",
                        "frequency",
                        "gravityX",
                        "gravityY",
                        "maxParticles",
                        "name",
                        "on",
                        "particleBringToTop",
                        "particleClass",
                        "radial",
                        "timeScale",
                        "trackVisible",
                        "visible"
                    ];
                    /**
         * Names of complex configuration properties.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#configOpMap
         * @type {object}
         * @since 3.0.0
         */ this.configOpMap = [
                        "accelerationX",
                        "accelerationY",
                        "angle",
                        "alpha",
                        "bounce",
                        "delay",
                        "lifespan",
                        "maxVelocityX",
                        "maxVelocityY",
                        "moveToX",
                        "moveToY",
                        "quantity",
                        "rotate",
                        "scaleX",
                        "scaleY",
                        "speedX",
                        "speedY",
                        "tint",
                        "x",
                        "y"
                    ];
                    /**
         * The name of this Particle Emitter.
         *
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = "";
                    /**
         * The Particle Class which will be emitted by this Emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleClass
         * @type {Phaser.GameObjects.Particles.Particle}
         * @default Phaser.GameObjects.Particles.Particle
         * @since 3.0.0
         */ this.particleClass = Particle;
                    /**
         * The x-coordinate of the particle origin (where particles will be emitted).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#x
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
         */ this.x = new EmitterOp(config, "x", 0, true);
                    /**
         * The y-coordinate of the particle origin (where particles will be emitted).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#y
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
         */ this.y = new EmitterOp(config, "y", 0, true);
                    /**
         * A radial emitter will emit particles in all directions between angle min and max,
         * using {@link Phaser.GameObjects.Particles.ParticleEmitter#speed} as the value. If set to false then this acts as a point Emitter.
         * A point emitter will emit particles only in the direction derived from the speedX and speedY values.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#radial
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setRadial
         */ this.radial = true;
                    /**
         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityX = 0;
                    /**
         * Vertical acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityY = 0;
                    /**
         * Whether accelerationX and accelerationY are non-zero. Set automatically during configuration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#acceleration
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.acceleration = false;
                    /**
         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.accelerationX = new EmitterOp(config, "accelerationX", 0, true);
                    /**
         * Vertical acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.accelerationY = new EmitterOp(config, "accelerationY", 0, true);
                    /**
         * The maximum horizontal velocity of emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityX = new EmitterOp(config, "maxVelocityX", 10000, true);
                    /**
         * The maximum vertical velocity of emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityY = new EmitterOp(config, "maxVelocityY", 10000, true);
                    /**
         * The initial horizontal speed of emitted particles, in pixels per second.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
         */ this.speedX = new EmitterOp(config, "speedX", 0, true);
                    /**
         * The initial vertical speed of emitted particles, in pixels per second.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
         */ this.speedY = new EmitterOp(config, "speedY", 0, true);
                    /**
         * Whether moveToX and moveToY are nonzero. Set automatically during configuration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveTo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.moveTo = false;
                    /**
         * The x-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.moveToX = new EmitterOp(config, "moveToX", 0, true);
                    /**
         * The y-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.moveToY = new EmitterOp(config, "moveToY", 0, true);
                    /**
         * Whether particles will rebound when they meet the emitter bounds.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounce
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.bounce = new EmitterOp(config, "bounce", 0, true);
                    /**
         * The horizontal scale of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
         */ this.scaleX = new EmitterOp(config, "scaleX", 1);
                    /**
         * The vertical scale of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
         */ this.scaleY = new EmitterOp(config, "scaleY", 1);
                    /**
         * Color tint applied to emitted particles. Value must not include the alpha channel.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#tint
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0xffffff
         * @since 3.0.0
         */ this.tint = new EmitterOp(config, "tint", 0xffffff);
                    /**
         * The alpha (transparency) of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#alpha
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
         */ this.alpha = new EmitterOp(config, "alpha", 1);
                    /**
         * The lifespan of emitted particles, in ms.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#lifespan
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1000
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
         */ this.lifespan = new EmitterOp(config, "lifespan", 1000, true);
                    /**
         * The angle of the initial velocity of emitted particles, in degrees.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#angle
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default { min: 0, max: 360 }
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAngle
         */ this.angle = new EmitterOp(config, "angle", {
                        min: 0,
                        max: 360
                    }, true);
                    /**
         * The rotation of emitted particles, in degrees.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#rotate
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.rotate = new EmitterOp(config, "rotate", 0);
                    /**
         * A function to call when a particle is emitted.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleEmitterCallback}
         * @default null
         * @since 3.0.0
         */ this.emitCallback = null;
                    /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.emitCallbackScope = null;
                    /**
         * A function to call when a particle dies.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleDeathCallback}
         * @default null
         * @since 3.0.0
         */ this.deathCallback = null;
                    /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.deathCallbackScope = null;
                    /**
         * Set to hard limit the amount of particle objects this emitter is allowed to create.
         * 0 means unlimited.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxParticles
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxParticles = 0;
                    /**
         * How many particles are emitted each time particles are emitted (one explosion or one flow cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#quantity
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
         */ this.quantity = new EmitterOp(config, "quantity", 1, true);
                    /**
         * How many ms to wait after emission before the particles start updating.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#delay
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.delay = new EmitterOp(config, "delay", 0, true);
                    /**
         * For a flow emitter, the time interval (>= 0) between particle flow cycles in ms.
         * A value of 0 means there is one particle flow cycle for each logic update (the maximum flow frequency). This is the default setting.
         * For an exploding emitter, this value will be -1.
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} also puts the emitter in flow mode (frequency >= 0).
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} also puts the emitter in explode mode (frequency = -1).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frequency
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
         */ this.frequency = 0;
                    /**
         * Controls if the emitter is currently emitting a particle flow (when frequency >= 0).
         * Already alive particles will continue to update until they expire.
         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#start} and {@link Phaser.GameObjects.Particles.ParticleEmitter#stop}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#on
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.on = true;
                    /**
         * Newly emitted particles are added to the top of the particle list, i.e. rendered above those already alive.
         * Set to false to send them to the back.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleBringToTop
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.particleBringToTop = true;
                    /**
         * The time rate applied to active particles, affecting lifespan, movement, and tweens. Values larger than 1 are faster than normal.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * An object describing a shape to emit particles from.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitZone
         * @type {?Phaser.GameObjects.Particles.Zones.EdgeZone|Phaser.GameObjects.Particles.Zones.RandomZone}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
         */ this.emitZone = null;
                    /**
         * An object describing a shape that deactivates particles when they interact with it.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathZone
         * @type {?Phaser.GameObjects.Particles.Zones.DeathZone}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
         */ this.deathZone = null;
                    /**
         * A rectangular boundary constraining particle movement.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounds
         * @type {?Phaser.Geom.Rectangle}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBounds
         */ this.bounds = null;
                    /**
         * Whether particles interact with the left edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideLeft
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideLeft = true;
                    /**
         * Whether particles interact with the right edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideRight
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideRight = true;
                    /**
         * Whether particles interact with the top edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideTop
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideTop = true;
                    /**
         * Whether particles interact with the bottom edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideBottom
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideBottom = true;
                    /**
         * Whether this emitter updates itself and its particles.
         *
         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#pause}
         * and {@link Phaser.GameObjects.Particles.ParticleEmitter#resume}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Set this to false to hide any active particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#visible
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setVisible
         */ this.visible = true;
                    /**
         * The blend mode of this emitter's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#blendMode
         * @type {number}
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBlendMode
         */ this.blendMode = BlendModes.NORMAL;
                    /**
         * A Game Object whose position is used as the particle origin.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#follow
         * @type {?Phaser.GameObjects.GameObject}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         * @see Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
         */ this.follow = null;
                    /**
         * The offset of the particle origin from the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.followOffset = new Vector2();
                    /**
         * Whether the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#visible} state will track
         * the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target's visibility state.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#trackVisible
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.trackVisible = false;
                    /**
         * The current texture frame, as an index of {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#currentFrame
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.currentFrame = 0;
                    /**
         * Whether texture {@link Phaser.GameObjects.Particles.ParticleEmitter#frames} are selected at random.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#randomFrame
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.randomFrame = true;
                    /**
         * The number of consecutive particles that receive a single texture frame (per frame cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity
         * @type {number}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.frameQuantity = 1;
                    /**
         * Inactive particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#dead
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.dead = [];
                    /**
         * Active particles
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#alive
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.alive = [];
                    /**
         * The time until the next flow cycle.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#_counter
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._counter = 0;
                    /**
         * Counts up to {@link Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#_frameCounter
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._frameCounter = 0;
                    if (config) this.fromJSON(config);
                },
                /**
     * Merges configuration settings into the emitter's current settings.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#fromJSON
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
     *
     * @return {this} This Particle Emitter.
     */ fromJSON: function(config) {
                    if (!config) return this;
                    //  Only update properties from their current state if they exist in the given config
                    var i = 0;
                    var key = "";
                    for(i = 0; i < this.configFastMap.length; i++){
                        key = this.configFastMap[i];
                        if (HasValue(config, key)) this[key] = GetFastValue(config, key);
                    }
                    for(i = 0; i < this.configOpMap.length; i++){
                        key = this.configOpMap[i];
                        if (HasValue(config, key)) this[key].loadConfig(config);
                    }
                    this.acceleration = this.accelerationX.propertyValue !== 0 || this.accelerationY.propertyValue !== 0;
                    this.moveTo = this.moveToX.propertyValue !== 0 || this.moveToY.propertyValue !== 0;
                    //  Special 'speed' override
                    if (HasValue(config, "speed")) {
                        this.speedX.loadConfig(config, "speed");
                        this.speedY = null;
                    }
                    //  If you specify speedX, speedY or moveTo then it changes the emitter from radial to a point emitter
                    if (HasAny(config, [
                        "speedX",
                        "speedY"
                    ]) || this.moveTo) this.radial = false;
                    //  Special 'scale' override
                    if (HasValue(config, "scale")) {
                        this.scaleX.loadConfig(config, "scale");
                        this.scaleY = null;
                    }
                    if (HasValue(config, "callbackScope")) {
                        var callbackScope = GetFastValue(config, "callbackScope", null);
                        this.emitCallbackScope = callbackScope;
                        this.deathCallbackScope = callbackScope;
                    }
                    if (HasValue(config, "emitZone")) this.setEmitZone(config.emitZone);
                    if (HasValue(config, "deathZone")) this.setDeathZone(config.deathZone);
                    if (HasValue(config, "bounds")) this.setBounds(config.bounds);
                    if (HasValue(config, "followOffset")) this.followOffset.setFromObject(GetFastValue(config, "followOffset", 0));
                    if (HasValue(config, "frame")) this.setFrame(config.frame);
                    if (HasValue(config, "reserve")) this.reserve(config.reserve);
                    return this;
                },
                /**
     * Creates a description of this emitter suitable for JSON serialization.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#toJSON
     * @since 3.0.0
     *
     * @param {object} [output] - An object to copy output into.
     *
     * @return {object} - The output object.
     */ toJSON: function(output) {
                    if (output === undefined) output = {};
                    var i = 0;
                    var key = "";
                    for(i = 0; i < this.configFastMap.length; i++){
                        key = this.configFastMap[i];
                        output[key] = this[key];
                    }
                    for(i = 0; i < this.configOpMap.length; i++){
                        key = this.configOpMap[i];
                        if (this[key]) output[key] = this[key].toJSON();
                    }
                    //  special handlers
                    if (!this.speedY) {
                        delete output.speedX;
                        output.speed = this.speedX.toJSON();
                    }
                    if (!this.scaleY) {
                        delete output.scaleX;
                        output.scale = this.scaleX.toJSON();
                    }
                    return output;
                },
                /**
     * Continuously moves the particle origin to follow a Game Object's position.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#startFollow
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} target - The Game Object to follow.
     * @param {number} [offsetX=0] - Horizontal offset of the particle origin from the Game Object.
     * @param {number} [offsetY=0] - Vertical offset of the particle origin from the Game Object.
     * @param {boolean} [trackVisible=false] - Whether the emitter's visible state will track the target's visible state.
     *
     * @return {this} This Particle Emitter.
     */ startFollow: function(target, offsetX, offsetY, trackVisible) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    if (trackVisible === undefined) trackVisible = false;
                    this.follow = target;
                    this.followOffset.set(offsetX, offsetY);
                    this.trackVisible = trackVisible;
                    return this;
                },
                /**
     * Stops following a Game Object.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ stopFollow: function() {
                    this.follow = null;
                    this.followOffset.set(0, 0);
                    this.trackVisible = false;
                    return this;
                },
                /**
     * Chooses a texture frame from {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getFrame
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} The texture frame.
     */ getFrame: function() {
                    if (this.frames.length === 1) return this.defaultFrame;
                    else if (this.randomFrame) return GetRandom(this.frames);
                    else {
                        var frame = this.frames[this.currentFrame];
                        this._frameCounter++;
                        if (this._frameCounter === this.frameQuantity) {
                            this._frameCounter = 0;
                            this.currentFrame = Wrap(this.currentFrame + 1, 0, this._frameLength);
                        }
                        return frame;
                    }
                },
                // frame: 0
                // frame: 'red'
                // frame: [ 0, 1, 2, 3 ]
                // frame: [ 'red', 'green', 'blue', 'pink', 'white' ]
                // frame: { frames: [ 'red', 'green', 'blue', 'pink', 'white' ], [cycle: bool], [quantity: int] }
                /**
     * Sets a pattern for assigning texture frames to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrame
     * @since 3.0.0
     *
     * @param {(array|string|number|Phaser.Types.GameObjects.Particles.ParticleEmitterFrameConfig)} frames - One or more texture frames, or a configuration object.
     * @param {boolean} [pickRandom=true] - Whether frames should be assigned at random from `frames`.
     * @param {number} [quantity=1] - The number of consecutive particles that will receive each frame.
     *
     * @return {this} This Particle Emitter.
     */ setFrame: function(frames, pickRandom, quantity) {
                    if (pickRandom === undefined) pickRandom = true;
                    if (quantity === undefined) quantity = 1;
                    this.randomFrame = pickRandom;
                    this.frameQuantity = quantity;
                    this.currentFrame = 0;
                    this._frameCounter = 0;
                    var t = typeof frames;
                    if (Array.isArray(frames) || t === "string" || t === "number") this.manager.setEmitterFrames(frames, this);
                    else if (t === "object") {
                        var frameConfig = frames;
                        frames = GetFastValue(frameConfig, "frames", null);
                        if (frames) this.manager.setEmitterFrames(frames, this);
                        var isCycle = GetFastValue(frameConfig, "cycle", false);
                        this.randomFrame = isCycle ? false : true;
                        this.frameQuantity = GetFastValue(frameConfig, "quantity", quantity);
                    }
                    this._frameLength = this.frames.length;
                    if (this._frameLength === 1) {
                        this.frameQuantity = 1;
                        this.randomFrame = false;
                    }
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle movement on or off.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setRadial
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Radial mode (true) or point mode (true).
     *
     * @return {this} This Particle Emitter.
     */ setRadial: function(value) {
                    if (value === undefined) value = true;
                    this.radial = value;
                    return this;
                },
                /**
     * Sets the position of the emitter's particle origin.
     * New particles will be emitted here.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setPosition
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} x - The x-coordinate of the particle origin.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} y - The y-coordinate of the particle origin.
     *
     * @return {this} This Particle Emitter.
     */ setPosition: function(x, y) {
                    this.x.onChange(x);
                    this.y.onChange(y);
                    return this;
                },
                /**
     * Sets or modifies a rectangular boundary constraining the particles.
     *
     * To remove the boundary, set {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds} to null.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setBounds
     * @since 3.0.0
     *
     * @param {(number|Phaser.Types.GameObjects.Particles.ParticleEmitterBounds|Phaser.Types.GameObjects.Particles.ParticleEmitterBoundsAlt)} x - The x-coordinate of the left edge of the boundary, or an object representing a rectangle.
     * @param {number} y - The y-coordinate of the top edge of the boundary.
     * @param {number} width - The width of the boundary.
     * @param {number} height - The height of the boundary.
     *
     * @return {this} This Particle Emitter.
     */ setBounds: function(x, y, width, height) {
                    if (typeof x === "object") {
                        var obj = x;
                        x = obj.x;
                        y = obj.y;
                        width = HasValue(obj, "w") ? obj.w : obj.width;
                        height = HasValue(obj, "h") ? obj.h : obj.height;
                    }
                    if (this.bounds) this.bounds.setTo(x, y, width, height);
                    else this.bounds = new Rectangle(x, y, width, height);
                    return this;
                },
                /**
     * Sets the initial horizontal speed of emitted particles.
     * Changes the emitter to point mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeedX: function(value) {
                    this.speedX.onChange(value);
                    //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                    this.radial = false;
                    return this;
                },
                /**
     * Sets the initial vertical speed of emitted particles.
     * Changes the emitter to point mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeedY: function(value) {
                    if (this.speedY) {
                        this.speedY.onChange(value);
                        //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                        this.radial = false;
                    }
                    return this;
                },
                /**
     * Sets the initial radial speed of emitted particles.
     * Changes the emitter to radial mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeed
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeed: function(value) {
                    this.speedX.onChange(value);
                    this.speedY = null;
                    //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                    this.radial = true;
                    return this;
                },
                /**
     * Sets the horizontal scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScaleX: function(value) {
                    this.scaleX.onChange(value);
                    return this;
                },
                /**
     * Sets the vertical scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScaleY: function(value) {
                    this.scaleY.onChange(value);
                    return this;
                },
                /**
     * Sets the scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScale
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScale: function(value) {
                    this.scaleX.onChange(value);
                    this.scaleY = null;
                    return this;
                },
                /**
     * Sets the horizontal gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityX
     * @since 3.0.0
     *
     * @param {number} value - Acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravityX: function(value) {
                    this.gravityX = value;
                    return this;
                },
                /**
     * Sets the vertical gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityY
     * @since 3.0.0
     *
     * @param {number} value - Acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravityY: function(value) {
                    this.gravityY = value;
                    return this;
                },
                /**
     * Sets the gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravity
     * @since 3.0.0
     *
     * @param {number} x - Horizontal acceleration due to gravity, in pixels per second squared.
     * @param {number} y - Vertical acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravity: function(x, y) {
                    this.gravityX = x;
                    this.gravityY = y;
                    return this;
                },
                /**
     * Sets the opacity of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 (transparent) and 1 (opaque).
     *
     * @return {this} This Particle Emitter.
     */ setAlpha: function(value) {
                    this.alpha.onChange(value);
                    return this;
                },
                /**
     * Sets the color tint of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setTint
     * @since 3.22.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 and 0xffffff.
     *
     * @return {this} This Particle Emitter.
     */ setTint: function(value) {
                    this.tint.onChange(value);
                    return this;
                },
                /**
     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitterAngle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The angle of the initial velocity of emitted particles.
     *
     * @return {this} This Particle Emitter.
     */ setEmitterAngle: function(value) {
                    this.angle.onChange(value);
                    return this;
                },
                /**
     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAngle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The angle of the initial velocity of emitted particles.
     *
     * @return {this} This Particle Emitter.
     */ setAngle: function(value) {
                    this.angle.onChange(value);
                    return this;
                },
                /**
     * Sets the lifespan of newly emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The particle lifespan, in ms.
     *
     * @return {this} This Particle Emitter.
     */ setLifespan: function(value) {
                    this.lifespan.onChange(value);
                    return this;
                },
                /**
     * Sets the number of particles released at each flow cycle or explosion.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} quantity - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setQuantity: function(quantity) {
                    this.quantity.onChange(quantity);
                    return this;
                },
                /**
     * Sets the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#frequency}
     * and {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms; or -1 to put the emitter in explosion mode.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [quantity] - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setFrequency: function(frequency, quantity) {
                    this.frequency = frequency;
                    this._counter = 0;
                    if (quantity) this.quantity.onChange(quantity);
                    return this;
                },
                /**
     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#emitZone}.
     *
     * An {@link Phaser.Types.GameObjects.Particles.ParticleEmitterEdgeZoneConfig EdgeZone} places particles on its edges. Its {@link Phaser.Types.GameObjects.Particles.EdgeZoneSource source} can be a Curve, Path, Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link Phaser.Types.GameObjects.Particles.EdgeZoneSourceCallback getPoints} method.
     *
     * A {@link Phaser.Types.GameObjects.Particles.ParticleEmitterRandomZoneConfig RandomZone} places randomly within its interior. Its {@link RandomZoneSource source} can be a Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link Phaser.Types.GameObjects.Particles.RandomZoneSourceCallback getRandomPoint} method.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterEdgeZoneConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterRandomZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current emit zone.
     *
     * @return {this} This Particle Emitter.
     */ setEmitZone: function(zoneConfig) {
                    if (zoneConfig === undefined) this.emitZone = null;
                    else {
                        //  Where source = Geom like Circle, or a Path or Curve
                        //  emitZone: { type: 'random', source: X }
                        //  emitZone: { type: 'edge', source: X, quantity: 32, [stepRate=0], [yoyo=false], [seamless=true] }
                        var type = GetFastValue(zoneConfig, "type", "random");
                        var source = GetFastValue(zoneConfig, "source", null);
                        switch(type){
                            case "random":
                                this.emitZone = new RandomZone(source);
                                break;
                            case "edge":
                                var quantity = GetFastValue(zoneConfig, "quantity", 1);
                                var stepRate = GetFastValue(zoneConfig, "stepRate", 0);
                                var yoyo = GetFastValue(zoneConfig, "yoyo", false);
                                var seamless = GetFastValue(zoneConfig, "seamless", true);
                                this.emitZone = new EdgeZone(source, quantity, stepRate, yoyo, seamless);
                                break;
                        }
                    }
                    return this;
                },
                /**
     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#deathZone}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterDeathZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current death zone.
     *
     * @return {this} This Particle Emitter.
     */ setDeathZone: function(zoneConfig) {
                    if (zoneConfig === undefined) this.deathZone = null;
                    else {
                        //  Where source = Geom like Circle or Rect that supports a 'contains' function
                        //  deathZone: { type: 'onEnter', source: X }
                        //  deathZone: { type: 'onLeave', source: X }
                        var type = GetFastValue(zoneConfig, "type", "onEnter");
                        var source = GetFastValue(zoneConfig, "source", null);
                        if (source && typeof source.contains === "function") {
                            var killOnEnter = type === "onEnter" ? true : false;
                            this.deathZone = new DeathZone(source, killOnEnter);
                        }
                    }
                    return this;
                },
                /**
     * Creates inactive particles and adds them to this emitter's pool.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#reserve
     * @since 3.0.0
     *
     * @param {number} particleCount - The number of particles to create.
     *
     * @return {this} This Particle Emitter.
     */ reserve: function(particleCount) {
                    var dead = this.dead;
                    for(var i = 0; i < particleCount; i++)dead.push(new this.particleClass(this));
                    return this;
                },
                /**
     * Gets the number of active (in-use) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getAliveParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=true`.
     */ getAliveParticleCount: function() {
                    return this.alive.length;
                },
                /**
     * Gets the number of inactive (available) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getDeadParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=false`.
     */ getDeadParticleCount: function() {
                    return this.dead.length;
                },
                /**
     * Gets the total number of particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles, including both alive and dead.
     */ getParticleCount: function() {
                    return this.getAliveParticleCount() + this.getDeadParticleCount();
                },
                /**
     * Whether this emitter is at its limit (if set).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#atLimit
     * @since 3.0.0
     *
     * @return {boolean} Returns `true` if this Emitter is at its limit, or `false` if no limit, or below the `maxParticles` level.
     */ atLimit: function() {
                    return this.maxParticles > 0 && this.getParticleCount() === this.maxParticles;
                },
                /**
     * Sets a function to call for each newly emitted particle.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleEmit
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} [context] - The calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleEmit: function(callback, context) {
                    if (callback === undefined) {
                        //  Clear any previously set callback
                        this.emitCallback = null;
                        this.emitCallbackScope = null;
                    } else if (typeof callback === "function") {
                        this.emitCallback = callback;
                        if (context) this.emitCallbackScope = context;
                    }
                    return this;
                },
                /**
     * Sets a function to call for each particle death.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleDeath
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleDeathCallback} callback - The function.
     * @param {*} [context] - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleDeath: function(callback, context) {
                    if (callback === undefined) {
                        //  Clear any previously set callback
                        this.deathCallback = null;
                        this.deathCallbackScope = null;
                    } else if (typeof callback === "function") {
                        this.deathCallback = callback;
                        if (context) this.deathCallbackScope = context;
                    }
                    return this;
                },
                /**
     * Deactivates every particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#killAll
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ killAll: function() {
                    var dead = this.dead;
                    var alive = this.alive;
                    while(alive.length > 0)dead.push(alive.pop());
                    return this;
                },
                /**
     * Calls a function for each active particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachAlive
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachAlive: function(callback, context) {
                    var alive = this.alive;
                    var length = alive.length;
                    for(var index = 0; index < length; ++index)//  Sends the Particle and the Emitter
                    callback.call(context, alive[index], this);
                    return this;
                },
                /**
     * Calls a function for each inactive particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachDead
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachDead: function(callback, context) {
                    var dead = this.dead;
                    var length = dead.length;
                    for(var index = 0; index < length; ++index)//  Sends the Particle and the Emitter
                    callback.call(context, dead[index], this);
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on} the emitter and resets the flow counter.
     *
     * If this emitter is in flow mode (frequency >= 0; the default), the particle flow will start (or restart).
     *
     * If this emitter is in explode mode (frequency = -1), nothing will happen.
     * Use {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} or {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#start
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ start: function() {
                    this.on = true;
                    this._counter = 0;
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on off} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stop
     * @since 3.11.0
     *
     * @return {this} This Particle Emitter.
     */ stop: function() {
                    this.on = false;
                    return this;
                },
                /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Deactivates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#pause
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ pause: function() {
                    this.active = false;
                    return this;
                },
                /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Activates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#resume
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ resume: function() {
                    this.active = true;
                    return this;
                },
                /**
     * Removes the emitter from its manager and the scene.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#remove
     * @since 3.22.0
     *
     * @return {this} This Particle Emitter.
     */ remove: function() {
                    this.manager.removeEmitter(this);
                    return this;
                },
                /**
     * Sorts active particles with {@link Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSort
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ depthSort: function() {
                    StableSort(this.alive, this.depthSortCallback);
                    return this;
                },
                /**
     * Puts the emitter in flow mode (frequency >= 0) and starts (or restarts) a particle flow.
     *
     * To resume a flow at the current frequency and quantity, use {@link Phaser.GameObjects.Particles.ParticleEmitter#start} instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#flow
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [count=1] - The number of particles to emit at each flow cycle.
     *
     * @return {this} This Particle Emitter.
     */ flow: function(frequency, count) {
                    if (count === undefined) count = 1;
                    this.frequency = frequency;
                    this.quantity.onChange(count);
                    return this.start();
                },
                /**
     * Puts the emitter in explode mode (frequency = -1), stopping any current particle flow, and emits several particles all at once.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#explode
     * @since 3.0.0
     *
     * @param {number} count - The amount of Particles to emit.
     * @param {number} x - The x coordinate to emit the Particles from.
     * @param {number} y - The y coordinate to emit the Particles from.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     */ explode: function(count, x, y) {
                    this.frequency = -1;
                    return this.emitParticle(count, x, y);
                },
                /**
     * Emits particles at a given position (or the emitter's current position).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticleAt
     * @since 3.0.0
     *
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     */ emitParticleAt: function(x, y, count) {
                    return this.emitParticle(count, x, y);
                },
                /**
     * Emits particles at a given position (or the emitter's current position).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticle
     * @since 3.0.0
     *
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     *
     * @see Phaser.GameObjects.Particles.Particle#fire
     */ emitParticle: function(count, x, y) {
                    if (this.atLimit()) return;
                    if (count === undefined) count = this.quantity.onEmit();
                    var dead = this.dead;
                    var followX = this.follow ? this.follow.x + this.followOffset.x : x;
                    var followY = this.follow ? this.follow.y + this.followOffset.y : y;
                    for(var i = 0; i < count; i++){
                        var particle = dead.pop();
                        if (!particle) particle = new this.particleClass(this);
                        particle.fire(followX, followY);
                        if (this.particleBringToTop) this.alive.push(particle);
                        else this.alive.unshift(particle);
                        if (this.emitCallback) this.emitCallback.call(this.emitCallbackScope, particle, this);
                        if (this.atLimit()) break;
                    }
                    return particle;
                },
                /**
     * Updates this emitter and its particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    //  Scale the delta
                    delta *= this.timeScale;
                    var step = delta / 1000;
                    if (this.trackVisible) this.visible = this.follow.visible;
                    //  Any particle processors?
                    var processors = this.manager.getProcessors();
                    var particles = this.alive;
                    var dead = this.dead;
                    var i = 0;
                    var rip = [];
                    var length = particles.length;
                    for(i = 0; i < length; i++){
                        var particle = particles[i];
                        //  update returns `true` if the particle is now dead (lifeCurrent <= 0)
                        if (particle.update(delta, step, processors)) rip.push({
                            index: i,
                            particle: particle
                        });
                    }
                    //  Move dead particles to the dead array
                    length = rip.length;
                    if (length > 0) {
                        var deathCallback = this.deathCallback;
                        var deathCallbackScope = this.deathCallbackScope;
                        for(i = length - 1; i >= 0; i--){
                            var entry = rip[i];
                            //  Remove from particles array
                            particles.splice(entry.index, 1);
                            //  Add to dead array
                            dead.push(entry.particle);
                            //  Callback
                            if (deathCallback) deathCallback.call(deathCallbackScope, entry.particle);
                            entry.particle.resetPosition();
                        }
                    }
                    if (!this.on) return;
                    if (this.frequency === 0) this.emitParticle();
                    else if (this.frequency > 0) {
                        this._counter -= delta;
                        if (this._counter <= 0) {
                            this.emitParticle();
                            //  counter = frequency - remained from previous delta
                            this._counter = this.frequency - Math.abs(this._counter);
                        }
                    }
                },
                /**
     * Calculates the difference of two particles, for sorting them by depth.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback
     * @since 3.0.0
     *
     * @param {object} a - The first particle.
     * @param {object} b - The second particle.
     *
     * @return {number} The difference of a and b's y coordinates.
     */ depthSortCallback: function(a, b) {
                    return a.y - b.y;
                }
            });
            module1.exports = ParticleEmitter;
        /***/ },
        /* 453 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Death Zone.
 *
 * A Death Zone is a special type of zone that will kill a Particle as soon as it either enters, or leaves, the zone.
 *
 * The zone consists of a `source` which could be a Geometric shape, such as a Rectangle or Ellipse, or your own
 * object as long as it includes a `contains` method for which the Particles can be tested against.
 *
 * @class DeathZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.DeathZoneSource} source - An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
 * @param {boolean} killOnEnter - Should the Particle be killed when it enters the zone? `true` or leaves it? `false`
 */ var DeathZone = new Class({
                initialize: function DeathZone(source, killOnEnter) {
                    /**
         * An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
         * This could be a Geometry shape, such as `Phaser.Geom.Circle`, or your own custom object.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#source
         * @type {Phaser.Types.GameObjects.Particles.DeathZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * Set to `true` if the Particle should be killed if it enters this zone.
         * Set to `false` to kill the Particle if it leaves this zone.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#killOnEnter
         * @type {boolean}
         * @since 3.0.0
         */ this.killOnEnter = killOnEnter;
                },
                /**
     * Checks if the given Particle will be killed or not by this zone.
     *
     * @method Phaser.GameObjects.Particles.Zones.DeathZone#willKill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to be checked against this zone.
     *
     * @return {boolean} Return `true` if the Particle is to be killed, otherwise return `false`.
     */ willKill: function(particle) {
                    var withinZone = this.source.contains(particle.x, particle.y);
                    return withinZone && this.killOnEnter || !withinZone && !this.killOnEnter;
                }
            });
            module1.exports = DeathZone;
        /***/ },
        /* 454 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A zone that places particles on a shape's edges.
 *
 * @class EdgeZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
 * @param {number} quantity - The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
 * @param {number} stepRate - The distance between each particle. When set, `quantity` is implied and should be set to 0.
 * @param {boolean} [yoyo=false] - Whether particles are placed from start to end and then end to start.
 * @param {boolean} [seamless=true] - Whether one endpoint will be removed if it's identical to the other.
 */ var EdgeZone = new Class({
                initialize: function EdgeZone(source, quantity, stepRate, yoyo, seamless) {
                    if (yoyo === undefined) yoyo = false;
                    if (seamless === undefined) seamless = true;
                    /**
         * An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#source
         * @type {Phaser.Types.GameObjects.Particles.EdgeZoneSource|Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * The points placed on the source edge.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#points
         * @type {Phaser.Geom.Point[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                    /**
         * The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#quantity
         * @type {number}
         * @since 3.0.0
         */ this.quantity = quantity;
                    /**
         * The distance between each particle. When set, `quantity` is implied and should be set to 0.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#stepRate
         * @type {number}
         * @since 3.0.0
         */ this.stepRate = stepRate;
                    /**
         * Whether particles are placed from start to end and then end to start.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#yoyo
         * @type {boolean}
         * @since 3.0.0
         */ this.yoyo = yoyo;
                    /**
         * The counter used for iterating the EdgeZone's points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#counter
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.counter = -1;
                    /**
         * Whether one endpoint will be removed if it's identical to the other.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#seamless
         * @type {boolean}
         * @since 3.0.0
         */ this.seamless = seamless;
                    /**
         * An internal count of the points belonging to this EdgeZone.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_length
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._length = 0;
                    /**
         * An internal value used to keep track of the current iteration direction for the EdgeZone's points.
         *
         * 0 = forwards, 1 = backwards
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_direction
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._direction = 0;
                    this.updateSource();
                },
                /**
     * Update the {@link Phaser.GameObjects.Particles.Zones.EdgeZone#points} from the EdgeZone's
     * {@link Phaser.GameObjects.Particles.Zones.EdgeZone#source}.
     *
     * Also updates internal properties.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#updateSource
     * @since 3.0.0
     *
     * @return {this} This Edge Zone.
     */ updateSource: function() {
                    this.points = this.source.getPoints(this.quantity, this.stepRate);
                    //  Remove ends?
                    if (this.seamless) {
                        var a = this.points[0];
                        var b = this.points[this.points.length - 1];
                        if (a.x === b.x && a.y === b.y) this.points.pop();
                    }
                    var oldLength = this._length;
                    this._length = this.points.length;
                    //  Adjust counter if we now have less points than before
                    if (this._length < oldLength && this.counter > this._length) this.counter = this._length - 1;
                    return this;
                },
                /**
     * Change the source of the EdgeZone.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#changeSource
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
     *
     * @return {this} This Edge Zone.
     */ changeSource: function(source) {
                    this.source = source;
                    return this.updateSource();
                },
                /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                    if (this._direction === 0) {
                        this.counter++;
                        if (this.counter >= this._length) {
                            if (this.yoyo) {
                                this._direction = 1;
                                this.counter = this._length - 1;
                            } else this.counter = 0;
                        }
                    } else {
                        this.counter--;
                        if (this.counter === -1) {
                            if (this.yoyo) {
                                this._direction = 0;
                                this.counter = 0;
                            } else this.counter = this._length - 1;
                        }
                    }
                    var point = this.points[this.counter];
                    if (point) {
                        particle.x = point.x;
                        particle.y = point.y;
                    }
                }
            });
            module1.exports = EdgeZone;
        /***/ },
        /* 455 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains at least one of the requested keys
 *
 * @function Phaser.Utils.Objects.HasAny
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to search the object for
 *
 * @return {boolean} true if the source object contains at least one of the keys, false otherwise
 */ var HasAny = function(source, keys) {
                for(var i = 0; i < keys.length; i++){
                    if (source.hasOwnProperty(keys[i])) return true;
                }
                return false;
            };
            module1.exports = HasAny;
        /***/ },
        /* 456 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A zone that places particles randomly within a shapes area.
 *
 * @class RandomZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.RandomZoneSource} source - An object instance with a `getRandomPoint(point)` method.
 */ var RandomZone = new Class({
                initialize: function RandomZone(source) {
                    /**
         * An object instance with a `getRandomPoint(point)` method.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#source
         * @type {Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * Internal calculation vector.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#_tempVec
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec = new Vector2();
                },
                /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.RandomZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                    var vec = this._tempVec;
                    this.source.getRandomPoint(vec);
                    particle.x = vec.x;
                    particle.y = vec.y;
                }
            });
            module1.exports = RandomZone;
        /***/ },
        /* 457 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * A PathFollower Game Object.
 *
 * A PathFollower is a Sprite Game Object with some extra helpers to allow it to follow a Path automatically.
 *
 * Anything you can do with a standard Sprite can be done with this PathFollower, such as animate it, tint it,
 * scale it and so on.
 *
 * PathFollowers are bound to a single Path at any one time and can traverse the length of the Path, from start
 * to finish, forwards or backwards, or from any given point on the Path to its end. They can optionally rotate
 * to face the direction of the path, be offset from the path coordinates or rotate independently of the Path.
 *
 * @class PathFollower
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.PathFollower
 *
 * @param {Phaser.Scene} scene - The Scene to which this PathFollower belongs.
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var PathFollower = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.PathFollower
                ],
                initialize: function PathFollower(scene, path, x, y, texture, frame) {
                    Sprite.call(this, scene, x, y, texture, frame);
                    this.path = path;
                },
                /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.PathFollower#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    this.anims.update(time, delta);
                    this.pathUpdate(time);
                }
            });
            module1.exports = PathFollower;
        /***/ },
        /* 458 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns an object containing dimensions of the Text object.
 *
 * @function Phaser.GameObjects.GetTextSize
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object to calculate the size from.
 * @param {Phaser.Types.GameObjects.Text.TextMetrics} size - The Text metrics to use when calculating the size.
 * @param {string[]} lines - The lines of text to calculate the size from.
 *
 * @return {Phaser.Types.GameObjects.Text.GetTextSizeObject} An object containing dimensions of the Text object.
 */ var GetTextSize = function(text, size, lines) {
                var canvas = text.canvas;
                var context = text.context;
                var style = text.style;
                var lineWidths = [];
                var maxLineWidth = 0;
                var drawnLines = lines.length;
                if (style.maxLines > 0 && style.maxLines < lines.length) drawnLines = style.maxLines;
                style.syncFont(canvas, context);
                //  Text Width
                for(var i = 0; i < drawnLines; i++){
                    var lineWidth = style.strokeThickness;
                    lineWidth += context.measureText(lines[i]).width;
                    // Adjust for wrapped text
                    if (style.wordWrap) lineWidth -= context.measureText(" ").width;
                    lineWidths[i] = Math.ceil(lineWidth);
                    maxLineWidth = Math.max(maxLineWidth, lineWidths[i]);
                }
                //  Text Height
                var lineHeight = size.fontSize + style.strokeThickness;
                var height = lineHeight * drawnLines;
                var lineSpacing = text.lineSpacing;
                //  Adjust for line spacing
                if (drawnLines > 1) height += lineSpacing * (drawnLines - 1);
                return {
                    width: maxLineWidth,
                    height: height,
                    lines: drawnLines,
                    lineWidths: lineWidths,
                    lineSpacing: lineSpacing,
                    lineHeight: lineHeight
                };
            };
            module1.exports = GetTextSize;
        /***/ },
        /* 459 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var MeasureText = __webpack_require__(460);
            //  Key: [ Object Key, Default Value ]
            var propertyMap = {
                fontFamily: [
                    "fontFamily",
                    "Courier"
                ],
                fontSize: [
                    "fontSize",
                    "16px"
                ],
                fontStyle: [
                    "fontStyle",
                    ""
                ],
                backgroundColor: [
                    "backgroundColor",
                    null
                ],
                color: [
                    "color",
                    "#fff"
                ],
                stroke: [
                    "stroke",
                    "#fff"
                ],
                strokeThickness: [
                    "strokeThickness",
                    0
                ],
                shadowOffsetX: [
                    "shadow.offsetX",
                    0
                ],
                shadowOffsetY: [
                    "shadow.offsetY",
                    0
                ],
                shadowColor: [
                    "shadow.color",
                    "#000"
                ],
                shadowBlur: [
                    "shadow.blur",
                    0
                ],
                shadowStroke: [
                    "shadow.stroke",
                    false
                ],
                shadowFill: [
                    "shadow.fill",
                    false
                ],
                align: [
                    "align",
                    "left"
                ],
                maxLines: [
                    "maxLines",
                    0
                ],
                fixedWidth: [
                    "fixedWidth",
                    0
                ],
                fixedHeight: [
                    "fixedHeight",
                    0
                ],
                resolution: [
                    "resolution",
                    0
                ],
                rtl: [
                    "rtl",
                    false
                ],
                testString: [
                    "testString",
                    "|M\xc3\u2030qgy"
                ],
                baselineX: [
                    "baselineX",
                    1.2
                ],
                baselineY: [
                    "baselineY",
                    1.4
                ],
                wordWrapWidth: [
                    "wordWrap.width",
                    null
                ],
                wordWrapCallback: [
                    "wordWrap.callback",
                    null
                ],
                wordWrapCallbackScope: [
                    "wordWrap.callbackScope",
                    null
                ],
                wordWrapUseAdvanced: [
                    "wordWrap.useAdvancedWrap",
                    false
                ]
            };
            /**
 * @classdesc
 * A TextStyle class manages all of the style settings for a Text object.
 *
 * Text Game Objects create a TextStyle instance automatically, which is
 * accessed via the `Text.style` property. You do not normally need to
 * instantiate one yourself.
 *
 * @class TextStyle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object that this TextStyle is styling.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
 */ var TextStyle = new Class({
                initialize: function TextStyle(text, style) {
                    /**
         * The Text object that this TextStyle is styling.
         *
         * @name Phaser.GameObjects.TextStyle#parent
         * @type {Phaser.GameObjects.Text}
         * @since 3.0.0
         */ this.parent = text;
                    /**
         * The font family.
         *
         * @name Phaser.GameObjects.TextStyle#fontFamily
         * @type {string}
         * @default 'Courier'
         * @since 3.0.0
         */ this.fontFamily;
                    /**
         * The font size.
         *
         * @name Phaser.GameObjects.TextStyle#fontSize
         * @type {string}
         * @default '16px'
         * @since 3.0.0
         */ this.fontSize;
                    /**
         * The font style.
         *
         * @name Phaser.GameObjects.TextStyle#fontStyle
         * @type {string}
         * @since 3.0.0
         */ this.fontStyle;
                    /**
         * The background color.
         *
         * @name Phaser.GameObjects.TextStyle#backgroundColor
         * @type {string}
         * @since 3.0.0
         */ this.backgroundColor;
                    /**
         * The text fill color.
         *
         * @name Phaser.GameObjects.TextStyle#color
         * @type {string}
         * @default '#fff'
         * @since 3.0.0
         */ this.color;
                    /**
         * The text stroke color.
         *
         * @name Phaser.GameObjects.TextStyle#stroke
         * @type {string}
         * @default '#fff'
         * @since 3.0.0
         */ this.stroke;
                    /**
         * The text stroke thickness.
         *
         * @name Phaser.GameObjects.TextStyle#strokeThickness
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.strokeThickness;
                    /**
         * The horizontal shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetX;
                    /**
         * The vertical shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetY;
                    /**
         * The shadow color.
         *
         * @name Phaser.GameObjects.TextStyle#shadowColor
         * @type {string}
         * @default '#000'
         * @since 3.0.0
         */ this.shadowColor;
                    /**
         * The shadow blur radius.
         *
         * @name Phaser.GameObjects.TextStyle#shadowBlur
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowBlur;
                    /**
         * Whether shadow stroke is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowStroke
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowStroke;
                    /**
         * Whether shadow fill is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowFill
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowFill;
                    /**
         * The text alignment.
         *
         * @name Phaser.GameObjects.TextStyle#align
         * @type {string}
         * @default 'left'
         * @since 3.0.0
         */ this.align;
                    /**
         * The maximum number of lines to draw.
         *
         * @name Phaser.GameObjects.TextStyle#maxLines
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxLines;
                    /**
         * The fixed width of the text.
         *
         * `0` means no fixed with.
         *
         * @name Phaser.GameObjects.TextStyle#fixedWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedWidth;
                    /**
         * The fixed height of the text.
         *
         * `0` means no fixed height.
         *
         * @name Phaser.GameObjects.TextStyle#fixedHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedHeight;
                    /**
         * The resolution the text is rendered to its internal canvas at.
         * The default is 0, which means it will use the resolution set in the Game Config.
         *
         * @name Phaser.GameObjects.TextStyle#resolution
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.resolution;
                    /**
         * Whether the text should render right to left.
         *
         * @name Phaser.GameObjects.TextStyle#rtl
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rtl;
                    /**
         * The test string to use when measuring the font.
         *
         * @name Phaser.GameObjects.TextStyle#testString
         * @type {string}
         * @default '|MÉqgy'
         * @since 3.0.0
         */ this.testString;
                    /**
         * The amount of horizontal padding added to the width of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineX
         * @type {number}
         * @default 1.2
         * @since 3.3.0
         */ this.baselineX;
                    /**
         * The amount of vertical padding added to the height of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineY
         * @type {number}
         * @default 1.4
         * @since 3.3.0
         */ this.baselineY;
                    /**
         * The maximum width of a line of text in pixels. Null means no line wrapping. Setting this
         * property directly will not re-run the word wrapping algorithm. To change the width and
         * re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapWidth
         * @type {number | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapWidth;
                    /**
         * A custom function that will be responsible for wrapping the text. It will receive two
         * arguments: text (the string to wrap), textObject (this Text instance). It should return
         * the wrapped lines either as an array of lines or as a string with newline characters in
         * place to indicate where breaks should happen. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallback
         * @type {TextStyleWordWrapCallback | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallback;
                    /**
         * The scope that will be applied when the wordWrapCallback is invoked. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallbackScope
         * @type {object | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallbackScope;
                    /**
         * Whether or not to use the advanced wrapping algorithm. If true, spaces are collapsed and
         * whitespace is trimmed from lines. If false, spaces and whitespace are left as is. Setting
         * this property directly will not re-run the word wrapping algorithm. To change the
         * advanced setting and re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapUseAdvanced
         * @type {boolean}
         * @default false
         * @since 3.24.0
         */ this.wordWrapUseAdvanced;
                    /**
         * The font style, size and family.
         *
         * @name Phaser.GameObjects.TextStyle#_font
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._font;
                    //  Set to defaults + user style
                    this.setStyle(style, false, true);
                    var metrics = GetValue(style, "metrics", false);
                    //  Provide optional TextMetrics in the style object to avoid the canvas look-up / scanning
                    //  Doing this is reset if you then change the font of this TextStyle after creation
                    if (metrics) this.metrics = {
                        ascent: GetValue(metrics, "ascent", 0),
                        descent: GetValue(metrics, "descent", 0),
                        fontSize: GetValue(metrics, "fontSize", 0)
                    };
                    else this.metrics = MeasureText(this);
                },
                /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.TextStyle#setStyle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     * @param {boolean} [setDefaults=false] - Use the default values is not set, or the local values.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStyle: function(style, updateText, setDefaults) {
                    if (updateText === undefined) updateText = true;
                    if (setDefaults === undefined) setDefaults = false;
                    //  Avoid type mutation
                    // eslint-disable-next-line no-prototype-builtins
                    if (style && style.hasOwnProperty("fontSize") && typeof style.fontSize === "number") style.fontSize = style.fontSize.toString() + "px";
                    for(var key in propertyMap){
                        var value = setDefaults ? propertyMap[key][1] : this[key];
                        if (key === "wordWrapCallback" || key === "wordWrapCallbackScope") // Callback & scope should be set without processing the values
                        this[key] = GetValue(style, propertyMap[key][0], value);
                        else this[key] = GetAdvancedValue(style, propertyMap[key][0], value);
                    }
                    //  Allow for 'font' override
                    var font = GetValue(style, "font", null);
                    if (font !== null) this.setFont(font, false);
                    this._font = [
                        this.fontStyle,
                        this.fontSize,
                        this.fontFamily
                    ].join(" ").trim();
                    //  Allow for 'fill' to be used in place of 'color'
                    var fill = GetValue(style, "fill", null);
                    if (fill !== null) this.color = fill;
                    if (updateText) return this.update(true);
                    else return this.parent;
                },
                /**
     * Synchronize the font settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncFont
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncFont: function(canvas, context) {
                    context.font = this._font;
                },
                /**
     * Synchronize the text style settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncStyle
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncStyle: function(canvas, context) {
                    context.textBaseline = "alphabetic";
                    context.fillStyle = this.color;
                    context.strokeStyle = this.stroke;
                    context.lineWidth = this.strokeThickness;
                    context.lineCap = "round";
                    context.lineJoin = "round";
                },
                /**
     * Synchronize the shadow settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncShadow
     * @since 3.0.0
     *
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {boolean} enabled - Whether shadows are enabled or not.
     */ syncShadow: function(context, enabled) {
                    if (enabled) {
                        context.shadowOffsetX = this.shadowOffsetX;
                        context.shadowOffsetY = this.shadowOffsetY;
                        context.shadowColor = this.shadowColor;
                        context.shadowBlur = this.shadowBlur;
                    } else {
                        context.shadowOffsetX = 0;
                        context.shadowOffsetY = 0;
                        context.shadowColor = 0;
                        context.shadowBlur = 0;
                    }
                },
                /**
     * Update the style settings for the parent Text object.
     *
     * @method Phaser.GameObjects.TextStyle#update
     * @since 3.0.0
     *
     * @param {boolean} recalculateMetrics - Whether to recalculate font and text metrics.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ update: function(recalculateMetrics) {
                    if (recalculateMetrics) {
                        this._font = [
                            this.fontStyle,
                            this.fontSize,
                            this.fontFamily
                        ].join(" ").trim();
                        this.metrics = MeasureText(this);
                    }
                    return this.parent.updateText();
                },
                /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * @method Phaser.GameObjects.TextStyle#setFont
     * @since 3.0.0
     *
     * @param {(string|object)} font - The font family or font settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFont: function(font, updateText) {
                    if (updateText === undefined) updateText = true;
                    var fontFamily = font;
                    var fontSize = "";
                    var fontStyle = "";
                    if (typeof font !== "string") {
                        fontFamily = GetValue(font, "fontFamily", "Courier");
                        fontSize = GetValue(font, "fontSize", "16px");
                        fontStyle = GetValue(font, "fontStyle", "");
                    } else {
                        var fontSplit = font.split(" ");
                        var i = 0;
                        fontStyle = fontSplit.length > 2 ? fontSplit[i++] : "";
                        fontSize = fontSplit[i++] || "16px";
                        fontFamily = fontSplit[i++] || "Courier";
                    }
                    if (fontFamily !== this.fontFamily || fontSize !== this.fontSize || fontStyle !== this.fontStyle) {
                        this.fontFamily = fontFamily;
                        this.fontSize = fontSize;
                        this.fontStyle = fontStyle;
                        if (updateText) this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font family.
     *
     * @method Phaser.GameObjects.TextStyle#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontFamily: function(family) {
                    if (this.fontFamily !== family) {
                        this.fontFamily = family;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.TextStyle#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontStyle: function(style) {
                    if (this.fontStyle !== style) {
                        this.fontStyle = style;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font size.
     *
     * @method Phaser.GameObjects.TextStyle#setFontSize
     * @since 3.0.0
     *
     * @param {(number|string)} size - The font size.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontSize: function(size) {
                    if (typeof size === "number") size = size.toString() + "px";
                    if (this.fontSize !== size) {
                        this.fontSize = size;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the test string to use when measuring the font.
     *
     * @method Phaser.GameObjects.TextStyle#setTestString
     * @since 3.0.0
     *
     * @param {string} string - The test string to use when measuring the font.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setTestString: function(string) {
                    this.testString = string;
                    return this.update(true);
                },
                /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.TextStyle#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set.
     * @param {number} height - The fixed height to set.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFixedSize: function(width, height) {
                    this.fixedWidth = width;
                    this.fixedHeight = height;
                    if (width) this.parent.width = width;
                    if (height) this.parent.height = height;
                    return this.update(false);
                },
                /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.TextStyle#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setBackgroundColor: function(color) {
                    this.backgroundColor = color;
                    return this.update(false);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setFill
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFill: function(color) {
                    this.color = color;
                    return this.update(false);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setColor
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setColor: function(color) {
                    this.color = color;
                    return this.update(false);
                },
                /**
     * Set the resolution used by the Text object.
     *
     * By default it will be set to match the resolution set in the Game Config,
     * but you can override it via this method. It allows for much clearer text on High DPI devices,
     * at the cost of memory because it uses larger internal Canvas textures for the Text.
     *
     * Please use with caution, as the more high res Text you have, the more memory it uses up.
     *
     * @method Phaser.GameObjects.TextStyle#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setResolution: function(value) {
                    this.resolution = value;
                    return this.update(false);
                },
                /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.TextStyle#setStroke
     * @since 3.0.0
     *
     * @param {string} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStroke: function(color, thickness) {
                    if (thickness === undefined) thickness = this.strokeThickness;
                    if (color === undefined && this.strokeThickness !== 0) {
                        //  Reset the stroke to zero (disabling it)
                        this.strokeThickness = 0;
                        this.update(true);
                    } else if (this.stroke !== color || this.strokeThickness !== thickness) {
                        this.stroke = color;
                        this.strokeThickness = thickness;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the shadow settings.
     *
     * Calling this method always re-measures the parent Text object,
     * so only call it when you actually change the shadow settings.
     *
     * @method Phaser.GameObjects.TextStyle#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (color === undefined) color = "#000";
                    if (blur === undefined) blur = 0;
                    if (shadowStroke === undefined) shadowStroke = false;
                    if (shadowFill === undefined) shadowFill = true;
                    this.shadowOffsetX = x;
                    this.shadowOffsetY = y;
                    this.shadowColor = color;
                    this.shadowBlur = blur;
                    this.shadowStroke = shadowStroke;
                    this.shadowFill = shadowFill;
                    return this.update(false);
                },
                /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowOffset: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.shadowOffsetX = x;
                    this.shadowOffsetY = y;
                    return this.update(false);
                },
                /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowColor
     * @since 3.0.0
     *
     * @param {string} [color='#000'] - The shadow color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowColor: function(color) {
                    if (color === undefined) color = "#000";
                    this.shadowColor = color;
                    return this.update(false);
                },
                /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} [blur=0] - The shadow blur radius.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowBlur: function(blur) {
                    if (blur === undefined) blur = 0;
                    this.shadowBlur = blur;
                    return this.update(false);
                },
                /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowStroke: function(enabled) {
                    this.shadowStroke = enabled;
                    return this.update(false);
                },
                /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowFill: function(enabled) {
                    this.shadowFill = enabled;
                    return this.update(false);
                },
                /**
     * Set the width (in pixels) to use for wrapping lines.
     *
     * Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                    if (useAdvancedWrap === undefined) useAdvancedWrap = false;
                    this.wordWrapWidth = width;
                    this.wordWrapUseAdvanced = useAdvancedWrap;
                    return this.update(false);
                },
                /**
     * Set a custom callback for wrapping lines.
     *
     * Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapCallback: function(callback, scope) {
                    if (scope === undefined) scope = null;
                    this.wordWrapCallback = callback;
                    this.wordWrapCallbackScope = scope;
                    return this.update(false);
                },
                /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.TextStyle#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setAlign: function(align) {
                    if (align === undefined) align = "left";
                    this.align = align;
                    return this.update(false);
                },
                /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.TextStyle#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setMaxLines: function(max) {
                    if (max === undefined) max = 0;
                    this.maxLines = max;
                    return this.update(false);
                },
                /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.TextStyle#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                    var metrics = this.metrics;
                    return {
                        ascent: metrics.ascent,
                        descent: metrics.descent,
                        fontSize: metrics.fontSize
                    };
                },
                /**
     * Build a JSON representation of this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Text Style.
     */ toJSON: function() {
                    var output = {};
                    for(var key in propertyMap)output[key] = this[key];
                    output.metrics = this.getTextMetrics();
                    return output;
                },
                /**
     * Destroy this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.parent = undefined;
                }
            });
            module1.exports = TextStyle;
        /***/ },
        /* 460 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            /**
 * Calculates the ascent, descent and fontSize of a given font style.
 *
 * @function Phaser.GameObjects.MeasureText
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.TextStyle} textStyle - The TextStyle object to measure.
 *
 * @return {Phaser.Types.GameObjects.Text.TextMetrics} An object containing the ascent, descent and fontSize of the TextStyle.
 */ var MeasureText = function(textStyle) {
                var canvas = CanvasPool.create(this);
                var context = canvas.getContext("2d");
                textStyle.syncFont(canvas, context);
                var metrics = context.measureText(textStyle.testString);
                if ("actualBoundingBoxAscent" in metrics) {
                    var ascent = metrics.actualBoundingBoxAscent;
                    var descent = metrics.actualBoundingBoxDescent;
                    CanvasPool.remove(canvas);
                    return {
                        ascent: ascent,
                        descent: descent,
                        fontSize: ascent + descent
                    };
                }
                var width = Math.ceil(metrics.width * textStyle.baselineX);
                var baseline = width;
                var height = 2 * baseline;
                baseline = baseline * textStyle.baselineY | 0;
                canvas.width = width;
                canvas.height = height;
                context.fillStyle = "#f00";
                context.fillRect(0, 0, width, height);
                context.font = textStyle._font;
                context.textBaseline = "alphabetic";
                context.fillStyle = "#000";
                context.fillText(textStyle.testString, 0, baseline);
                var output = {
                    ascent: 0,
                    descent: 0,
                    fontSize: 0
                };
                var imagedata = context.getImageData(0, 0, width, height);
                if (!imagedata) {
                    output.ascent = baseline;
                    output.descent = baseline + 6;
                    output.fontSize = output.ascent + output.descent;
                    CanvasPool.remove(canvas);
                    return output;
                }
                var pixels = imagedata.data;
                var numPixels = pixels.length;
                var line = width * 4;
                var i;
                var j;
                var idx = 0;
                var stop = false;
                // ascent. scan from top to bottom until we find a non red pixel
                for(i = 0; i < baseline; i++){
                    for(j = 0; j < line; j += 4)if (pixels[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx += line;
                    else break;
                }
                output.ascent = baseline - i;
                idx = numPixels - line;
                stop = false;
                // descent. scan from bottom to top until we find a non red pixel
                for(i = height; i > baseline; i--){
                    for(j = 0; j < line; j += 4)if (pixels[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx -= line;
                    else break;
                }
                output.descent = i - baseline;
                output.fontSize = output.ascent + output.descent;
                CanvasPool.remove(canvas);
                return output;
            };
            module1.exports = MeasureText;
        /***/ },
        /* 461 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcRender = __webpack_require__(1097);
            var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(36);
            var Earcut = __webpack_require__(59);
            var GeomCircle = __webpack_require__(65);
            var MATH_CONST = __webpack_require__(14);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 * 
 * Arcs also have an `iterations` property and corresponding `setIterations` method. This allows
 * you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction.
 *
 * @class Arc
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Arc = new Class({
                Extends: Shape,
                Mixins: [
                    ArcRender
                ],
                initialize: function Arc(scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 128;
                    if (startAngle === undefined) startAngle = 0;
                    if (endAngle === undefined) endAngle = 360;
                    if (anticlockwise === undefined) anticlockwise = false;
                    Shape.call(this, scene, "Arc", new GeomCircle(0, 0, radius));
                    /**
         * Private internal value. Holds the start angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_startAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startAngle = startAngle;
                    /**
         * Private internal value. Holds the end angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_endAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endAngle = endAngle;
                    /**
         * Private internal value. Holds the winding order of the start and end angles.
         *
         * @name Phaser.GameObjects.Arc#_anticlockwise
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._anticlockwise = anticlockwise;
                    /**
         * Private internal value. Holds the number of iterations used when drawing the arc.
         *
         * @name Phaser.GameObjects.Arc#_iterations
         * @type {number}
         * @default 0.01
         * @private
         * @since 3.13.0
         */ this._iterations = 0.01;
                    this.setPosition(x, y);
                    var diameter = this.geom.radius * 2;
                    this.setSize(diameter, diameter);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * The number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     *
     * @name Phaser.GameObjects.Arc#iterations
     * @type {number}
     * @default 0.01
     * @since 3.13.0
     */ iterations: {
                    get: function() {
                        return this._iterations;
                    },
                    set: function(value) {
                        this._iterations = value;
                        this.updateData();
                    }
                },
                /**
     * The radius of the arc.
     *
     * @name Phaser.GameObjects.Arc#radius
     * @type {number}
     * @since 3.13.0
     */ radius: {
                    get: function() {
                        return this.geom.radius;
                    },
                    set: function(value) {
                        this.geom.radius = value;
                        var diameter = value * 2;
                        this.setSize(diameter, diameter);
                        this.updateDisplayOrigin();
                        this.updateData();
                    }
                },
                /**
     * The start angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#startAngle
     * @type {number}
     * @since 3.13.0
     */ startAngle: {
                    get: function() {
                        return this._startAngle;
                    },
                    set: function(value) {
                        this._startAngle = value;
                        this.updateData();
                    }
                },
                /**
     * The end angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#endAngle
     * @type {number}
     * @since 3.13.0
     */ endAngle: {
                    get: function() {
                        return this._endAngle;
                    },
                    set: function(value) {
                        this._endAngle = value;
                        this.updateData();
                    }
                },
                /**
     * The winding order of the start and end angles.
     *
     * @name Phaser.GameObjects.Arc#anticlockwise
     * @type {boolean}
     * @since 3.13.0
     */ anticlockwise: {
                    get: function() {
                        return this._anticlockwise;
                    },
                    set: function(value) {
                        this._anticlockwise = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the radius of the arc.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setRadius
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the radius to.
     *
     * @return {this} This Game Object instance.
     */ setRadius: function(value) {
                    this.radius = value;
                    return this;
                },
                /**
     * Sets the number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setIterations
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the iterations to.
     *
     * @return {this} This Game Object instance.
     */ setIterations: function(value) {
                    if (value === undefined) value = 0.01;
                    this.iterations = value;
                    return this;
                },
                /**
     * Sets the starting angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setStartAngle
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the starting angle to.
     *
     * @return {this} This Game Object instance.
     */ setStartAngle: function(angle, anticlockwise) {
                    this._startAngle = angle;
                    if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                    return this.updateData();
                },
                /**
     * Sets the ending angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setEndAngle
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the ending angle to.
     *
     * @return {this} This Game Object instance.
     */ setEndAngle: function(angle, anticlockwise) {
                    this._endAngle = angle;
                    if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Arc#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var step = this._iterations;
                    var iteration = step;
                    var radius = this.geom.radius;
                    var startAngle = DegToRad(this._startAngle);
                    var endAngle = DegToRad(this._endAngle);
                    var anticlockwise = this._anticlockwise;
                    var x = radius;
                    var y = radius;
                    endAngle -= startAngle;
                    if (anticlockwise) {
                        if (endAngle < -MATH_CONST.PI2) endAngle = -MATH_CONST.PI2;
                        else if (endAngle > 0) endAngle = -MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                    } else if (endAngle > MATH_CONST.PI2) endAngle = MATH_CONST.PI2;
                    else if (endAngle < 0) endAngle = MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                    var path = [
                        x + Math.cos(startAngle) * radius,
                        y + Math.sin(startAngle) * radius
                    ];
                    var ta;
                    while(iteration < 1){
                        ta = endAngle * iteration + startAngle;
                        path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                        iteration += step;
                    }
                    ta = endAngle + startAngle;
                    path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                    path.push(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Arc;
        /***/ },
        /* 462 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CurveRender = __webpack_require__(1100);
            var Earcut = __webpack_require__(59);
            var Rectangle = __webpack_require__(10);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 * 
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Curve
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Curve = new Class({
                Extends: Shape,
                Mixins: [
                    CurveRender
                ],
                initialize: function Curve(scene, x, y, curve, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    Shape.call(this, scene, "Curve", curve);
                    /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Curve#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 32;
                    /**
         * Private internal value.
         * The Curve bounds rectangle.
         *
         * @name Phaser.GameObjects.Curve#_curveBounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.13.0
         */ this._curveBounds = new Rectangle();
                    this.closePath = false;
                    this.setPosition(x, y);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateData();
                },
                /**
     * The smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Curve#smoothness
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(value) {
                        this._smoothness = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Curve#setSmoothness
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                    this._smoothness = value;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Curve#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var bounds = this._curveBounds;
                    var smoothness = this._smoothness;
                    //  Update the bounds in case the underlying data has changed
                    this.geom.getBounds(bounds, smoothness);
                    this.setSize(bounds.width, bounds.height);
                    this.updateDisplayOrigin();
                    var path = [];
                    var points = this.geom.getPoints(smoothness);
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Curve;
        /***/ },
        /* 463 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(59);
            var EllipseRender = __webpack_require__(1103);
            var GeomEllipse = __webpack_require__(111);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 * 
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Ellipse
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Ellipse = new Class({
                Extends: Shape,
                Mixins: [
                    EllipseRender
                ],
                initialize: function Ellipse(scene, x, y, width, height, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    Shape.call(this, scene, "Ellipse", new GeomEllipse(width / 2, height / 2, width, height));
                    /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Ellipse#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 64;
                    this.setPosition(x, y);
                    this.width = width;
                    this.height = height;
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * The smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Ellipse#smoothness
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(value) {
                        this._smoothness = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the size of the ellipse by changing the underlying geometry data, rather than scaling the object.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSize
     * @since 3.13.0
     * 
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.geom.setPosition(width / 2, height / 2);
                    this.geom.setSize(width, height);
                    return this.updateData();
                },
                /**
     * Sets the smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSmoothness
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                    this._smoothness = value;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Ellipse#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this.geom.getPoints(this._smoothness);
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Ellipse;
        /***/ },
        /* 464 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(34);
            var GridRender = __webpack_require__(1106);
            /**
 * @classdesc
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @class Grid
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells. See the `setOutline` method.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 */ var Grid = new Class({
                Extends: Shape,
                Mixins: [
                    GridRender
                ],
                initialize: function Grid(scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    if (cellWidth === undefined) cellWidth = 32;
                    if (cellHeight === undefined) cellHeight = 32;
                    Shape.call(this, scene, "Grid", null);
                    /**
         * The width of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellWidth
         * @type {number}
         * @since 3.13.0
         */ this.cellWidth = cellWidth;
                    /**
         * The height of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellHeight
         * @type {number}
         * @since 3.13.0
         */ this.cellHeight = cellHeight;
                    /**
         * Will the grid render its cells in the `fillColor`?
         *
         * @name Phaser.GameObjects.Grid#showCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showCells = true;
                    /**
         * The color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillColor
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillColor = 0;
                    /**
         * The alpha value for the color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillAlpha = 0;
                    /**
         * Will the grid display the lines between each cell when it renders?
         *
         * @name Phaser.GameObjects.Grid#showOutline
         * @type {boolean}
         * @since 3.13.0
         */ this.showOutline = true;
                    /**
         * Will the grid render the alternating cells in the `altFillColor`?
         *
         * @name Phaser.GameObjects.Grid#showAltCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showAltCells = false;
                    /**
         * The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
         *
         * @name Phaser.GameObjects.Grid#altFillColor
         * @type {number}
         * @since 3.13.0
         */ this.altFillColor;
                    /**
         * The alpha the alternating grid cells will be filled with.
         * You can also set the alpha of the overall Shape using its `alpha` property.
         *
         * @name Phaser.GameObjects.Grid#altFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.altFillAlpha;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setFillStyle(fillColor, fillAlpha);
                    if (outlineFillColor !== undefined) this.setOutlineStyle(outlineFillColor, outlineFillAlpha);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the fill color and alpha level the grid cells will use when rendering.
     *
     * If this method is called with no values then the grid cells will not be rendered,
     * however the grid lines and alternating cells may still be.
     *
     * Also see the `setOutlineStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showCells = false;
                    else {
                        this.fillColor = fillColor;
                        this.fillAlpha = fillAlpha;
                        this.showCells = true;
                    }
                    return this;
                },
                /**
     * Sets the fill color and alpha level that the alternating grid cells will use.
     *
     * If this method is called with no values then alternating grid cells will not be rendered in a different color.
     *
     * Also see the `setOutlineStyle` and `setFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setAltFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the alternating grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setAltFillStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showAltCells = false;
                    else {
                        this.altFillColor = fillColor;
                        this.altFillAlpha = fillAlpha;
                        this.showAltCells = true;
                    }
                    return this;
                },
                /**
     * Sets the fill color and alpha level that the lines between each grid cell will use.
     *
     * If this method is called with no values then the grid lines will not be rendered at all, however
     * the cells themselves may still be if they have colors set.
     *
     * Also see the `setFillStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setOutlineStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the lines between the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the lines between the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setOutlineStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showOutline = false;
                    else {
                        this.outlineFillColor = fillColor;
                        this.outlineFillAlpha = fillAlpha;
                        this.showOutline = true;
                    }
                    return this;
                }
            });
            module1.exports = Grid;
        /***/ },
        /* 465 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsoBoxRender = __webpack_require__(1109);
            var Class = __webpack_require__(0);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @class IsoBox
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 */ var IsoBox = new Class({
                Extends: Shape,
                Mixins: [
                    IsoBoxRender
                ],
                initialize: function IsoBox(scene, x, y, size, height, fillTop, fillLeft, fillRight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (size === undefined) size = 48;
                    if (height === undefined) height = 32;
                    if (fillTop === undefined) fillTop = 0xeeeeee;
                    if (fillLeft === undefined) fillLeft = 0x999999;
                    if (fillRight === undefined) fillRight = 0xcccccc;
                    Shape.call(this, scene, "IsoBox", null);
                    /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoBox#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                    /**
         * The color used to fill in the top of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                    /**
         * The color used to fill in the left-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                    /**
         * The color used to fill in the right-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                    /**
         * Controls if the top-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                    /**
         * Controls if the left-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                    /**
         * Controls if the right-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                    this.isFilled = true;
                    this.setPosition(x, y);
                    this.setSize(size, height);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setProjection
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                    this.projection = value;
                    return this;
                },
                /**
     * Sets which faces of the iso box will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFaces
     * @since 3.13.0
     * 
     * @param {boolean} [showTop=true] - Show the top-face of the iso box.
     * @param {boolean} [showLeft=true] - Show the left-face of the iso box.
     * @param {boolean} [showRight=true] - Show the right-face of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                    if (showTop === undefined) showTop = true;
                    if (showLeft === undefined) showLeft = true;
                    if (showRight === undefined) showRight = true;
                    this.showTop = showTop;
                    this.showLeft = showLeft;
                    this.showRight = showRight;
                    return this;
                },
                /**
     * Sets the fill colors for each face of the iso box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFillStyle
     * @since 3.13.0
     * 
     * @param {number} [fillTop] - The color used to fill the top of the iso box.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso box.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                    this.fillTop = fillTop;
                    this.fillLeft = fillLeft;
                    this.fillRight = fillRight;
                    this.isFilled = true;
                    return this;
                }
            });
            module1.exports = IsoBox;
        /***/ },
        /* 466 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var IsoTriangleRender = __webpack_require__(1112);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @class IsoTriangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 */ var IsoTriangle = new Class({
                Extends: Shape,
                Mixins: [
                    IsoTriangleRender
                ],
                initialize: function IsoTriangle(scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (size === undefined) size = 48;
                    if (height === undefined) height = 32;
                    if (reversed === undefined) reversed = false;
                    if (fillTop === undefined) fillTop = 0xeeeeee;
                    if (fillLeft === undefined) fillLeft = 0x999999;
                    if (fillRight === undefined) fillRight = 0xcccccc;
                    Shape.call(this, scene, "IsoTriangle", null);
                    /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoTriangle#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                    /**
         * The color used to fill in the top of the iso triangle. This is only used if the triangle is reversed.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                    /**
         * The color used to fill in the left-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                    /**
         * The color used to fill in the right-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                    /**
         * Controls if the top-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                    /**
         * Controls if the left-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                    /**
         * Controls if the right-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                    /**
         * Sets if the iso triangle will be rendered upside down or not.
         *
         * @name Phaser.GameObjects.IsoTriangle#isReversed
         * @type {boolean}
         * @default false
         * @since 3.13.0
         */ this.isReversed = reversed;
                    this.isFilled = true;
                    this.setPosition(x, y);
                    this.setSize(size, height);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the projection level of the iso triangle. Change this to change the 'angle' at which you are looking at the pyramid.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setProjection
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                    this.projection = value;
                    return this;
                },
                /**
     * Sets if the iso triangle will be rendered upside down or not.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setReversed
     * @since 3.13.0
     * 
     * @param {boolean} reversed - Sets if the iso triangle will be rendered upside down or not.
     *
     * @return {this} This Game Object instance.
     */ setReversed: function(reversed) {
                    this.isReversed = reversed;
                    return this;
                },
                /**
     * Sets which faces of the iso triangle will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFaces
     * @since 3.13.0
     * 
     * @param {boolean} [showTop=true] - Show the top-face of the iso triangle (only if `reversed` is true)
     * @param {boolean} [showLeft=true] - Show the left-face of the iso triangle.
     * @param {boolean} [showRight=true] - Show the right-face of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                    if (showTop === undefined) showTop = true;
                    if (showLeft === undefined) showLeft = true;
                    if (showRight === undefined) showRight = true;
                    this.showTop = showTop;
                    this.showLeft = showLeft;
                    this.showRight = showRight;
                    return this;
                },
                /**
     * Sets the fill colors for each face of the iso triangle.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFillStyle
     * @since 3.13.0
     * 
     * @param {number} [fillTop] - The color used to fill the top of the iso triangle.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso triangle.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                    this.fillTop = fillTop;
                    this.fillLeft = fillLeft;
                    this.fillRight = fillRight;
                    this.isFilled = true;
                    return this;
                }
            });
            module1.exports = IsoTriangle;
        /***/ },
        /* 467 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(34);
            var GeomLine = __webpack_require__(47);
            var LineRender = __webpack_require__(1115);
            /**
 * @classdesc
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only stroke colors and cannot be filled.
 *
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 *
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * Be aware that as with all Game Objects the default origin is 0.5. If you need to draw a Line
 * between two points and want the x1/y1 values to match the x/y values, then set the origin to 0.
 *
 * @class Line
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Line = new Class({
                Extends: Shape,
                Mixins: [
                    LineRender
                ],
                initialize: function Line(scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 128;
                    if (y2 === undefined) y2 = 0;
                    Shape.call(this, scene, "Line", new GeomLine(x1, y1, x2, y2));
                    var width = Math.max(1, this.geom.right - this.geom.left);
                    var height = Math.max(1, this.geom.bottom - this.geom.top);
                    /**
         * The width (or thickness) of the line.
         * See the setLineWidth method for extra details on changing this on WebGL.
         *
         * @name Phaser.GameObjects.Line#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                    /**
         * Private internal value. Holds the start width of the line.
         *
         * @name Phaser.GameObjects.Line#_startWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startWidth = 1;
                    /**
         * Private internal value. Holds the end width of the line.
         *
         * @name Phaser.GameObjects.Line#_endWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endWidth = 1;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (strokeColor !== undefined) this.setStrokeStyle(1, strokeColor, strokeAlpha);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the width of the line.
     *
     * When using the WebGL renderer you can have different start and end widths.
     * When using the Canvas renderer only the `startWidth` value is used. The `endWidth` is ignored.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Line#setLineWidth
     * @since 3.13.0
     *
     * @param {number} startWidth - The start width of the line.
     * @param {number} [endWidth] - The end width of the line. Only used in WebGL.
     *
     * @return {this} This Game Object instance.
     */ setLineWidth: function(startWidth, endWidth) {
                    if (endWidth === undefined) endWidth = startWidth;
                    this._startWidth = startWidth;
                    this._endWidth = endWidth;
                    this.lineWidth = startWidth;
                    return this;
                },
                /**
     * Sets the start and end coordinates of this Line.
     *
     * @method Phaser.GameObjects.Line#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the start of the line.
     * @param {number} [y1=0] - The vertical position of the start of the line.
     * @param {number} [x2=0] - The horizontal position of the end of the line.
     * @param {number} [y2=0] - The vertical position of the end of the line.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                    this.geom.setTo(x1, y1, x2, y2);
                    return this;
                }
            });
            module1.exports = Line;
        /***/ },
        /* 468 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PolygonRender = __webpack_require__(1118);
            var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(59);
            var GetAABB = __webpack_require__(469);
            var GeomPolygon = __webpack_require__(227);
            var Shape = __webpack_require__(34);
            var Smooth = __webpack_require__(472);
            /**
 * @classdesc
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 * 
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * @class Polygon
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Polygon = new Class({
                Extends: Shape,
                Mixins: [
                    PolygonRender
                ],
                initialize: function Polygon(scene, x, y, points, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    Shape.call(this, scene, "Polygon", new GeomPolygon(points));
                    var bounds = GetAABB(this.geom);
                    this.setPosition(x, y);
                    this.setSize(bounds.width, bounds.height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Smooths the polygon over the number of iterations specified.
     * The base polygon data will be updated and replaced with the smoothed values.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Polygon#smooth
     * @since 3.13.0
     * 
     * @param {number} [iterations=1] - The number of times to apply the polygon smoothing.
     *
     * @return {this} This Game Object instance.
     */ smooth: function(iterations) {
                    if (iterations === undefined) iterations = 1;
                    for(var i = 0; i < iterations; i++)Smooth(this.geom);
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Polygon#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this.geom.points;
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Polygon;
        /***/ },
        /* 469 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Calculates the bounding AABB rectangle of a polygon.
 *
 * @function Phaser.Geom.Polygon.GetAABB
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon that should be calculated.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - The rectangle or object that has x, y, width, and height properties to store the result. Optional.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The resulting rectangle or object that is passed in with position and dimensions of the polygon's AABB.
 */ var GetAABB = function(polygon, out) {
                if (out === undefined) out = new Rectangle();
                var minX = Infinity;
                var minY = Infinity;
                var maxX = -minX;
                var maxY = -minY;
                var p;
                for(var i = 0; i < polygon.points.length; i++){
                    p = polygon.points[i];
                    minX = Math.min(minX, p.x);
                    minY = Math.min(minY, p.y);
                    maxX = Math.max(maxX, p.x);
                    maxY = Math.max(maxY, p.y);
                }
                out.x = minX;
                out.y = minY;
                out.width = maxX - minX;
                out.height = maxY - minY;
                return out;
            };
            module1.exports = GetAABB;
        /***/ },
        /* 470 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            var Line = __webpack_require__(47);
            var Perimeter = __webpack_require__(471);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Polygon.GetPoints
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the perimeter of the Polygon.
 */ var GetPoints = function(polygon, quantity, stepRate, out) {
                if (out === undefined) out = [];
                var points = polygon.points;
                var perimeter = Perimeter(polygon);
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                for(var i = 0; i < quantity; i++){
                    var position = perimeter * (i / quantity);
                    var accumulatedPerimeter = 0;
                    for(var j = 0; j < points.length; j++){
                        var pointA = points[j];
                        var pointB = points[(j + 1) % points.length];
                        var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                        var length = Length(line);
                        if (position < accumulatedPerimeter || position > accumulatedPerimeter + length) {
                            accumulatedPerimeter += length;
                            continue;
                        }
                        var point = line.getPoint((position - accumulatedPerimeter) / length);
                        out.push(point);
                        break;
                    }
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 471 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            var Line = __webpack_require__(47);
            /**
 * Returns the perimeter of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Perimeter
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the perimeter of.
 *
 * @return {number} The perimeter of the Polygon.
 */ var Perimeter = function(polygon) {
                var points = polygon.points;
                var perimeter = 0;
                for(var i = 0; i < points.length; i++){
                    var pointA = points[i];
                    var pointB = points[(i + 1) % points.length];
                    var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                    perimeter += Length(line);
                }
                return perimeter;
            };
            module1.exports = Perimeter;
        /***/ },
        /* 472 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Igor Ognichenko <ognichenko.igor@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ var copy = function(out, a) {
                out[0] = a[0];
                out[1] = a[1];
                return out;
            };
            /**
 * Takes a Polygon object and applies Chaikin's smoothing algorithm on its points.
 *
 * @function Phaser.Geom.Polygon.Smooth
 * @since 3.13.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be smoothed. The polygon will be modified in-place and returned.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Smooth = function(polygon) {
                var i;
                var points = [];
                var data = polygon.points;
                for(i = 0; i < data.length; i++)points.push([
                    data[i].x,
                    data[i].y
                ]);
                var output = [];
                if (points.length > 0) output.push(copy([
                    0,
                    0
                ], points[0]));
                for(i = 0; i < points.length - 1; i++){
                    var p0 = points[i];
                    var p1 = points[i + 1];
                    var p0x = p0[0];
                    var p0y = p0[1];
                    var p1x = p1[0];
                    var p1y = p1[1];
                    output.push([
                        0.85 * p0x + 0.15 * p1x,
                        0.85 * p0y + 0.15 * p1y
                    ]);
                    output.push([
                        0.15 * p0x + 0.85 * p1x,
                        0.15 * p0y + 0.85 * p1y
                    ]);
                }
                if (points.length > 1) output.push(copy([
                    0,
                    0
                ], points[points.length - 1]));
                return polygon.setTo(output);
            };
            module1.exports = Smooth;
        /***/ },
        /* 473 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GeomRectangle = __webpack_require__(10);
            var Shape = __webpack_require__(34);
            var RectangleRender = __webpack_require__(1121);
            /**
 * @classdesc
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @class Rectangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Rectangle = new Class({
                Extends: Shape,
                Mixins: [
                    RectangleRender
                ],
                initialize: function Rectangle(scene, x, y, width, height, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    Shape.call(this, scene, "Rectangle", new GeomRectangle(0, 0, width, height));
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Rectangle#setSize
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.geom.setSize(width, height);
                    this.updateData();
                    return this;
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Rectangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var rect = this.geom;
                    var line = this._tempLine;
                    rect.getLineA(line);
                    path.push(line.x1, line.y1, line.x2, line.y2);
                    rect.getLineB(line);
                    path.push(line.x2, line.y2);
                    rect.getLineC(line);
                    path.push(line.x2, line.y2);
                    rect.getLineD(line);
                    path.push(line.x2, line.y2);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Rectangle;
        /***/ },
        /* 474 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var StarRender = __webpack_require__(1124);
            var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(59);
            var Shape = __webpack_require__(34);
            /**
 * @classdesc
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 * 
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @class Star
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Star = new Class({
                Extends: Shape,
                Mixins: [
                    StarRender
                ],
                initialize: function Star(scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (points === undefined) points = 5;
                    if (innerRadius === undefined) innerRadius = 32;
                    if (outerRadius === undefined) outerRadius = 64;
                    Shape.call(this, scene, "Star", null);
                    /**
         * Private internal value.
         * The number of points in the star.
         *
         * @name Phaser.GameObjects.Star#_points
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._points = points;
                    /**
         * Private internal value.
         * The inner radius of the star.
         *
         * @name Phaser.GameObjects.Star#_innerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._innerRadius = innerRadius;
                    /**
         * Private internal value.
         * The outer radius of the star.
         *
         * @name Phaser.GameObjects.Star#_outerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._outerRadius = outerRadius;
                    this.setPosition(x, y);
                    this.setSize(outerRadius * 2, outerRadius * 2);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the number of points that make up the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setPoints
     * @since 3.13.0
     * 
     * @param {number} value - The amount of points the Star will have.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(value) {
                    this._points = value;
                    return this.updateData();
                },
                /**
     * Sets the inner radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setInnerRadius
     * @since 3.13.0
     * 
     * @param {number} value - The amount to set the inner radius to.
     *
     * @return {this} This Game Object instance.
     */ setInnerRadius: function(value) {
                    this._innerRadius = value;
                    return this.updateData();
                },
                /**
     * Sets the outer radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setOuterRadius
     * @since 3.13.0
     * 
     * @param {number} value - The amount to set the outer radius to.
     *
     * @return {this} This Game Object instance.
     */ setOuterRadius: function(value) {
                    this._outerRadius = value;
                    return this.updateData();
                },
                /**
     * The number of points that make up the Star shape.
     *
     * @name Phaser.GameObjects.Star#points
     * @type {number}
     * @default 5
     * @since 3.13.0
     */ points: {
                    get: function() {
                        return this._points;
                    },
                    set: function(value) {
                        this._points = value;
                        this.updateData();
                    }
                },
                /**
     * The inner radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#innerRadius
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ innerRadius: {
                    get: function() {
                        return this._innerRadius;
                    },
                    set: function(value) {
                        this._innerRadius = value;
                        this.updateData();
                    }
                },
                /**
     * The outer radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#outerRadius
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ outerRadius: {
                    get: function() {
                        return this._outerRadius;
                    },
                    set: function(value) {
                        this._outerRadius = value;
                        this.updateData();
                    }
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Star#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this._points;
                    var innerRadius = this._innerRadius;
                    var outerRadius = this._outerRadius;
                    var rot = Math.PI / 2 * 3;
                    var step = Math.PI / points;
                    //  So origin 0.5 = the center of the star
                    var x = outerRadius;
                    var y = outerRadius;
                    path.push(x, y + -outerRadius);
                    for(var i = 0; i < points; i++){
                        path.push(x + Math.cos(rot) * outerRadius, y + Math.sin(rot) * outerRadius);
                        rot += step;
                        path.push(x + Math.cos(rot) * innerRadius, y + Math.sin(rot) * innerRadius);
                        rot += step;
                    }
                    path.push(x, y + -outerRadius);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Star;
        /***/ },
        /* 475 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(34);
            var GeomTriangle = __webpack_require__(82);
            var TriangleRender = __webpack_require__(1127);
            /**
 * @classdesc
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @class Triangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Triangle = new Class({
                Extends: Shape,
                Mixins: [
                    TriangleRender
                ],
                initialize: function Triangle(scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 128;
                    if (x2 === undefined) x2 = 64;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 128;
                    if (y3 === undefined) y3 = 128;
                    Shape.call(this, scene, "Triangle", new GeomTriangle(x1, y1, x2, y2, x3, y3));
                    var width = this.geom.right - this.geom.left;
                    var height = this.geom.bottom - this.geom.top;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the data for the lines that make up this Triangle shape.
     *
     * @method Phaser.GameObjects.Triangle#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
     * @param {number} [y1=0] - The vertical position of the first point in the triangle.
     * @param {number} [x2=0] - The horizontal position of the second point in the triangle.
     * @param {number} [y2=0] - The vertical position of the second point in the triangle.
     * @param {number} [x3=0] - The horizontal position of the third point in the triangle.
     * @param {number} [y3=0] - The vertical position of the third point in the triangle.
     *
     * @return {this} This Game Object instance.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                    this.geom.setTo(x1, y1, x2, y2, x3, y3);
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Triangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var tri = this.geom;
                    var line = this._tempLine;
                    tri.getLineA(line);
                    path.push(line.x1, line.y1, line.x2, line.y2);
                    tri.getLineB(line);
                    path.push(line.x2, line.y2);
                    tri.getLineC(line);
                    path.push(line.x2, line.y2);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Triangle;
        /***/ },
        /* 476 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var Length = __webpack_require__(67);
            /**
 * Returns a Point from around the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the point on its perimeter from.
 * @param {number} position - The position along the perimeter of the triangle. A value between 0 and 1.
 * @param {(Phaser.Geom.Point|object)} [out] - An option Point, or Point-like object to store the value in. If not given a new Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object containing the given position from the perimeter of the triangle.
 */ var GetPoint = function(triangle, position, out) {
                if (out === undefined) out = new Point();
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                if (position <= 0 || position >= 1) {
                    out.x = line1.x1;
                    out.y = line1.y1;
                    return out;
                }
                var length1 = Length(line1);
                var length2 = Length(line2);
                var length3 = Length(line3);
                var perimeter = length1 + length2 + length3;
                var p = perimeter * position;
                var localPosition = 0;
                //  Which line is it on?
                if (p < length1) {
                    //  Line 1
                    localPosition = p / length1;
                    out.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                    out.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                } else if (p > length1 + length2) {
                    //  Line 3
                    p -= length1 + length2;
                    localPosition = p / length3;
                    out.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                    out.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                } else {
                    //  Line 2
                    p -= length1;
                    localPosition = p / length2;
                    out.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                    out.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                }
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 477 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of evenly spaced points on the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the points from.
 * @param {number} quantity - The number of evenly spaced points to return. Set to 0 to return an arbitrary number of points based on the `stepRate`.
 * @param {number} stepRate - If `quantity` is 0, the distance between each returned point.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to which the points should be appended.
 *
 * @return {(array|Phaser.Geom.Point[])} The modified `out` array, or a new array if none was provided.
 */ var GetPoints = function(triangle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                var length1 = Length(line1);
                var length2 = Length(line2);
                var length3 = Length(line3);
                var perimeter = length1 + length2 + length3;
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                for(var i = 0; i < quantity; i++){
                    var p = perimeter * (i / quantity);
                    var localPosition = 0;
                    var point = new Point();
                    //  Which line is it on?
                    if (p < length1) {
                        //  Line 1
                        localPosition = p / length1;
                        point.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                        point.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                    } else if (p > length1 + length2) {
                        //  Line 3
                        p -= length1 + length2;
                        localPosition = p / length3;
                        point.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                        point.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                    } else {
                        //  Line 2
                        p -= length1;
                        localPosition = p / length2;
                        point.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                        point.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                    }
                    out.push(point);
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 478 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a value in an object, allowing for dot notation to control the depth of the property.
 * 
 * For example:
 * 
 * ```javascript
 * var data = {
 *   world: {
 *     position: {
 *       x: 200,
 *       y: 100
 *     }
 *   }
 * };
 * 
 * SetValue(data, 'world.position.y', 300);
 * 
 * console.log(data.world.position.y); // 300
 * ```
 *
 * @function Phaser.Utils.Objects.SetValue
 * @since 3.17.0
 *
 * @param {object} source - The object to set the value in.
 * @param {string} key - The name of the property in the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`)
 * @param {any} value - The value to set into the property, if found in the source object.
 *
 * @return {boolean} `true` if the property key was valid and the value was set, otherwise `false`.
 */ var SetValue = function(source, key, value) {
                if (!source || typeof source === "number") return false;
                else if (source.hasOwnProperty(key)) {
                    source[key] = value;
                    return true;
                } else if (key.indexOf(".") !== -1) {
                    var keys = key.split(".");
                    var parent = source;
                    var prev = source;
                    //  Use for loop here so we can break early
                    for(var i = 0; i < keys.length; i++){
                        if (parent.hasOwnProperty(keys[i])) {
                            //  Yes it has a key property, let's carry on down
                            prev = parent;
                            parent = parent[keys[i]];
                        } else return false;
                    }
                    prev[keys[keys.length - 1]] = value;
                    return true;
                }
                return false;
            };
            module1.exports = SetValue;
        /***/ },
        /* 479 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(116);
            var Vertex = __webpack_require__(117);
            /**
 * Generates a set of Face and Vertex objects by parsing the given data.
 *
 * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
 *
 * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default)
 *
 * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
 *
 * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
 *
 * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
 *
 * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
 *
 * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
 *
 * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
 *
 * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
 *
 * The following example will create a 256 x 256 sized quad using an index array:
 *
 * ```javascript
 * const vertices = [
 *   -128, 128,
 *   128, 128,
 *   -128, -128,
 *   128, -128
 * ];
 *
 * const uvs = [
 *   0, 1,
 *   1, 1,
 *   0, 0,
 *   1, 0
 * ];
 *
 * const indices = [ 0, 2, 1, 2, 3, 1 ];
 *
 * GenerateVerts(vertices, uvs, indicies);
 * ```
 *
 * If the data is not indexed, it's assumed that the arrays all contain sequential data.
 *
 * @function Phaser.Geom.Mesh.GenerateVerts
 * @since 3.50.0
 *
 * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
 * @param {number[]} uvs - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component?
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateVerts = function(vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                if (containsZ === undefined) containsZ = false;
                if (colors === undefined) colors = 0xffffff;
                if (alphas === undefined) alphas = 1;
                if (vertices.length !== uvs.length) {
                    console.warn("GenerateVerts: vertices and uvs count not equal");
                    return;
                }
                var result = {
                    faces: [],
                    vertices: []
                };
                var i;
                var x;
                var y;
                var z;
                var u;
                var v;
                var color;
                var alpha;
                var normalX;
                var normalY;
                var normalZ;
                var iInc = containsZ ? 3 : 2;
                var isColorArray = Array.isArray(colors);
                var isAlphaArray = Array.isArray(alphas);
                if (Array.isArray(indicies) && indicies.length > 0) for(i = 0; i < indicies.length; i++){
                    var index1 = indicies[i];
                    var index2 = indicies[i] * 2;
                    var index3 = indicies[i] * iInc;
                    x = vertices[index3];
                    y = vertices[index3 + 1];
                    z = containsZ ? vertices[index3 + 2] : 0;
                    u = uvs[index2];
                    v = uvs[index2 + 1];
                    color = isColorArray ? colors[index1] : colors;
                    alpha = isAlphaArray ? alphas[index1] : alphas;
                    normalX = 0;
                    normalY = 0;
                    normalZ = 0;
                    if (normals) {
                        normalX = normals[index3];
                        normalY = normals[index3 + 1];
                        normalZ = containsZ ? normals[index3 + 2] : 0;
                    }
                    result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                }
                else {
                    var uvIndex = 0;
                    var colorIndex = 0;
                    for(i = 0; i < vertices.length; i += iInc){
                        x = vertices[i];
                        y = vertices[i + 1];
                        z = containsZ ? vertices[i + 2] : 0;
                        u = uvs[uvIndex];
                        v = uvs[uvIndex + 1];
                        color = isColorArray ? colors[colorIndex] : colors;
                        alpha = isAlphaArray ? alphas[colorIndex] : alphas;
                        normalX = 0;
                        normalY = 0;
                        normalZ = 0;
                        if (normals) {
                            normalX = normals[i];
                            normalY = normals[i + 1];
                            normalZ = containsZ ? normals[i + 2] : 0;
                        }
                        result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                        uvIndex += 2;
                        colorIndex++;
                    }
                }
                for(i = 0; i < result.vertices.length; i += 3){
                    var vert1 = result.vertices[i];
                    var vert2 = result.vertices[i + 1];
                    var vert3 = result.vertices[i + 2];
                    result.faces.push(new Face(vert1, vert2, vert3));
                }
                return result;
            };
            module1.exports = GenerateVerts;
        /***/ },
        /* 480 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(116);
            var Matrix4 = __webpack_require__(69);
            var Vector3 = __webpack_require__(39);
            var Vertex = __webpack_require__(117);
            var tempPosition = new Vector3();
            var tempRotation = new Vector3();
            var tempMatrix = new Matrix4();
            /**
 * This method will return an object containing Face and Vertex instances, generated
 * from the parsed triangulated OBJ Model data given to this function.
 *
 * The obj data should have been parsed in advance via the ParseObj function:
 *
 * ```javascript
 * var data = Phaser.Geom.Mesh.ParseObj(rawData, flipUV);
 *
 * var results = GenerateObjVerts(data);
 * ```
 *
 * Alternatively, you can parse obj files loaded via the OBJFile loader:
 *
 * ```javascript
 * preload ()
 * {
 *   this.load.obj('alien', 'assets/3d/alien.obj);
 * }
 *
 * var results = GenerateObjVerts(this.cache.obj.get('alien));
 * ```
 *
 * Make sure your 3D package has triangulated the model data prior to exporting it.
 *
 * You can use the data returned by this function to populate the vertices of a Mesh Game Object.
 *
 * You may add multiple models to a single Mesh, although they will act as one when
 * moved or rotated. You can scale the model data, should it be too small (or large) to visualize.
 * You can also offset the model via the `x`, `y` and `z` parameters.
 *
 * @function Phaser.Geom.Mesh.GenerateObjVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.OBJData} data - The parsed OBJ model data.
 * @param {Phaser.GameObjects.Mesh} [mesh] - An optional Mesh Game Object. If given, the generated Faces will be automatically added to this Mesh. Set to `null` to skip.
 * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
 * @param {number} [x=0] - Translate the model x position by this amount.
 * @param {number} [y=0] - Translate the model y position by this amount.
 * @param {number} [z=0] - Translate the model z position by this amount.
 * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
 * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
 * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
 * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateObjVerts = function(data, mesh, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                if (scale === undefined) scale = 1;
                if (x === undefined) x = 0;
                if (y === undefined) y = 0;
                if (z === undefined) z = 0;
                if (rotateX === undefined) rotateX = 0;
                if (rotateY === undefined) rotateY = 0;
                if (rotateZ === undefined) rotateZ = 0;
                if (zIsUp === undefined) zIsUp = true;
                var result = {
                    faces: [],
                    verts: []
                };
                var materials = data.materials;
                tempPosition.set(x, y, z);
                tempRotation.set(rotateX, rotateY, rotateZ);
                tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                for(var m = 0; m < data.models.length; m++){
                    var model = data.models[m];
                    var vertices = model.vertices;
                    var textureCoords = model.textureCoords;
                    var faces = model.faces;
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        var v1 = face.vertices[0];
                        var v2 = face.vertices[1];
                        var v3 = face.vertices[2];
                        var m1 = vertices[v1.vertexIndex];
                        var m2 = vertices[v2.vertexIndex];
                        var m3 = vertices[v3.vertexIndex];
                        var t1 = v1.textureCoordsIndex;
                        var t2 = v2.textureCoordsIndex;
                        var t3 = v3.textureCoordsIndex;
                        var uv1 = t1 === -1 ? {
                            u: 0,
                            v: 1
                        } : textureCoords[t1];
                        var uv2 = t2 === -1 ? {
                            u: 0,
                            v: 0
                        } : textureCoords[t2];
                        var uv3 = t3 === -1 ? {
                            u: 1,
                            v: 1
                        } : textureCoords[t3];
                        var color = 0xffffff;
                        if (face.material !== "" && materials[face.material]) color = materials[face.material];
                        var vert1 = new Vertex(m1.x * scale, m1.y * scale, m1.z * scale, uv1.u, uv1.v, color).transformMat4(tempMatrix);
                        var vert2 = new Vertex(m2.x * scale, m2.y * scale, m2.z * scale, uv2.u, uv2.v, color).transformMat4(tempMatrix);
                        var vert3 = new Vertex(m3.x * scale, m3.y * scale, m3.z * scale, uv3.u, uv3.v, color).transformMat4(tempMatrix);
                        result.verts.push(vert1, vert2, vert3);
                        result.faces.push(new Face(vert1, vert2, vert3));
                    }
                }
                if (mesh) {
                    mesh.faces = mesh.faces.concat(result.faces);
                    mesh.vertices = mesh.vertices.concat(result.verts);
                }
                return result;
            };
            module1.exports = GenerateObjVerts;
        /***/ },
        /* 481 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(65);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var RGB = __webpack_require__(200);
            var Utils = __webpack_require__(12);
            /**
 * @classdesc
 * A 2D point light.
 *
 * These are typically created by a {@link Phaser.GameObjects.LightsManager}, available from within a scene via `this.lights`.
 *
 * Any Game Objects using the Light2D pipeline will then be affected by these Lights as long as they have a normal map.
 *
 * They can also simply be used to represent a point light for your own purposes.
 *
 * @class Light
 * @extends Phaser.Geom.Circle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The horizontal position of the light.
 * @param {number} y - The vertical position of the light.
 * @param {number} radius - The radius of the light.
 * @param {number} r - The red color of the light. A value between 0 and 1.
 * @param {number} g - The green color of the light. A value between 0 and 1.
 * @param {number} b - The blue color of the light. A value between 0 and 1.
 * @param {number} intensity - The intensity of the light.
 */ var Light = new Class({
                Extends: Circle,
                Mixins: [
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function Light(x, y, radius, r, g, b, intensity) {
                    Circle.call(this, x, y, radius);
                    /**
         * The color of the light.
         *
         * @name Phaser.GameObjects.Light#color
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.color = new RGB(r, g, b);
                    /**
         * The intensity of the light.
         *
         * @name Phaser.GameObjects.Light#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.GameObject#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.GameObject#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                    this.setScrollFactor(1, 1);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Light#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(Light.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Set the color of the light from a single integer RGB value.
     *
     * @method Phaser.GameObjects.Light#setColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the light.
     *
     * @return {this} This Light object.
     */ setColor: function(rgb) {
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    this.color.set(color[0], color[1], color[2]);
                    return this;
                },
                /**
     * Set the intensity of the light.
     *
     * @method Phaser.GameObjects.Light#setIntensity
     * @since 3.0.0
     *
     * @param {number} intensity - The intensity of the light.
     *
     * @return {this} This Light object.
     */ setIntensity: function(intensity) {
                    this.intensity = intensity;
                    return this;
                },
                /**
     * Set the radius of the light.
     *
     * @method Phaser.GameObjects.Light#setRadius
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the light.
     *
     * @return {this} This Light object.
     */ setRadius: function(radius) {
                    this.radius = radius;
                    return this;
                }
            });
            /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.Light
 * @default
 */ Light.RENDER_MASK = 15;
            module1.exports = Light;
        /***/ },
        /* 482 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleToRectangle = __webpack_require__(151);
            var Class = __webpack_require__(0);
            var DistanceBetween = __webpack_require__(50);
            var Light = __webpack_require__(481);
            var PointLight = __webpack_require__(150);
            var RGB = __webpack_require__(200);
            var SpliceOne = __webpack_require__(74);
            var StableSort = __webpack_require__(79);
            var Utils = __webpack_require__(12);
            /**
 * @callback LightForEach
 *
 * @param {Phaser.GameObjects.Light} light - The Light.
 */ /**
 * @classdesc
 * Manages Lights for a Scene.
 *
 * Affects the rendering of Game Objects using the `Light2D` pipeline.
 *
 * @class LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 */ var LightsManager = new Class({
                initialize: function LightsManager() {
                    /**
         * The Lights in the Scene.
         *
         * @name Phaser.GameObjects.LightsManager#lights
         * @type {Phaser.GameObjects.Light[]}
         * @default []
         * @since 3.0.0
         */ this.lights = [];
                    /**
         * The ambient color.
         *
         * @name Phaser.GameObjects.LightsManager#ambientColor
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.ambientColor = new RGB(0.1, 0.1, 0.1);
                    /**
         * Whether the Lights Manager is enabled.
         *
         * @name Phaser.GameObjects.LightsManager#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                    /**
         * The maximum number of lights that a single Camera and the lights shader can process.
         * Change this via the `maxLights` property in your game config, as it cannot be changed at runtime.
         *
         * @name Phaser.GameObjects.LightsManager#maxLights
         * @type {number}
         * @readonly
         * @since 3.15.0
         */ this.maxLights = -1;
                    /**
         * The number of lights that the LightPipeline processed in the _previous_ frame.
         *
         * @name Phaser.GameObjects.LightsManager#visibleLights
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.visibleLights = 0;
                },
                /**
     * Creates a new Point Light Game Object and adds it to the Scene.
     *
     * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
     *
     * The Point Light Game Object provides a way to add a point light effect into your game,
     * without the expensive shader processing requirements of the traditional Light Game Object.
     *
     * The difference is that the Point Light renders using a custom shader, designed to give the
     * impression of a point light source, of variable radius, intensity and color, in your game.
     * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
     * normal maps for calcuations. This makes them extremely fast to render compared to Lights
     * and perfect for special effects, such as flickering torches or muzzle flashes.
     *
     * For maximum performance you should batch Point Light Game Objects together. This means
     * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
     * Game Object and then add just Point Lights to it, so that it can batch together the rendering
     * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
     * your game then it's perfectly safe to mix them into the dislay list as normal. However, if
     * you're using a large number of them, please consider how they are mixed into the display list.
     *
     * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
     * with the Camera will be skipped in the rendering list. This happens automatically and the
     * culled state is refreshed every frame, for every camera.
     *
     * The origin of a Point Light is always 0.5 and it cannot be changed.
     *
     * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
     *
     * @method Phaser.GameObjects.LightsManager#addPointLight
     * @since 3.50.0
     *
     * @param {number} x - The horizontal position of this Point Light in the world.
     * @param {number} y - The vertical position of this Point Light in the world.
     * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
     * @param {number} [radius=128] - The radius of the Point Light.
     * @param {number} [intensity=1] - The intensity, or colr blend, of the Point Light.
     * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
     *
     * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
     */ addPointLight: function(x, y, color, radius, intensity, attenuation) {
                    return this.systems.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity, attenuation));
                },
                /**
     * Enable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#enable
     * @since 3.0.0
     *
     * @return {this} This Lights Manager instance.
     */ enable: function() {
                    if (this.maxLights === -1) this.maxLights = this.systems.renderer.config.maxLights;
                    this.active = true;
                    return this;
                },
                /**
     * Disable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#disable
     * @since 3.0.0
     *
     * @return {this} This Lights Manager instance.
     */ disable: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Get all lights that can be seen by the given Camera.
     *
     * It will automatically cull lights that are outside the world view of the Camera.
     *
     * If more lights are returned than supported by the pipeline, the lights are then culled
     * based on the distance from the center of the camera. Only those closest are rendered.
     *
     * @method Phaser.GameObjects.LightsManager#getLights
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to cull Lights for.
     *
     * @return {Phaser.GameObjects.Light[]} The culled Lights.
     */ getLights: function(camera) {
                    var lights = this.lights;
                    var worldView = camera.worldView;
                    var visibleLights = [];
                    for(var i = 0; i < lights.length; i++){
                        var light = lights[i];
                        if (light.willRender(camera) && CircleToRectangle(light, worldView)) visibleLights.push({
                            light: light,
                            distance: DistanceBetween(light.x, light.y, worldView.centerX, worldView.centerY)
                        });
                    }
                    if (visibleLights.length > this.maxLights) {
                        //  We've got too many lights, so sort by distance from camera and cull those far away
                        //  This isn't ideal because it doesn't factor in the radius of the lights, but it'll do for now
                        //  and is significantly better than we had before!
                        StableSort(visibleLights, this.sortByDistance);
                        visibleLights = visibleLights.slice(0, this.maxLights);
                    }
                    this.visibleLights = visibleLights.length;
                    return visibleLights;
                },
                sortByDistance: function(a, b) {
                    return a.distance >= b.distance;
                },
                /**
     * Set the ambient light color.
     *
     * @method Phaser.GameObjects.LightsManager#setAmbientColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the ambient light.
     *
     * @return {this} This Lights Manager instance.
     */ setAmbientColor: function(rgb) {
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    this.ambientColor.set(color[0], color[1], color[2]);
                    return this;
                },
                /**
     * Returns the maximum number of Lights allowed to appear at once.
     *
     * @method Phaser.GameObjects.LightsManager#getMaxVisibleLights
     * @since 3.0.0
     *
     * @return {number} The maximum number of Lights allowed to appear at once.
     */ getMaxVisibleLights: function() {
                    return this.maxLights;
                },
                /**
     * Get the number of Lights managed by this Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#getLightCount
     * @since 3.0.0
     *
     * @return {number} The number of Lights managed by this Lights Manager.
     */ getLightCount: function() {
                    return this.lights.length;
                },
                /**
     * Add a Light.
     *
     * @method Phaser.GameObjects.LightsManager#addLight
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Light.
     * @param {number} [y=0] - The vertical position of the Light.
     * @param {number} [radius=128] - The radius of the Light.
     * @param {number} [rgb=0xffffff] - The integer RGB color of the light.
     * @param {number} [intensity=1] - The intensity of the Light.
     *
     * @return {Phaser.GameObjects.Light} The Light that was added.
     */ addLight: function(x, y, radius, rgb, intensity) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 128;
                    if (rgb === undefined) rgb = 0xffffff;
                    if (intensity === undefined) intensity = 1;
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    var light = new Light(x, y, radius, color[0], color[1], color[2], intensity);
                    this.lights.push(light);
                    return light;
                },
                /**
     * Remove a Light.
     *
     * @method Phaser.GameObjects.LightsManager#removeLight
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Light} light - The Light to remove.
     *
     * @return {this} This Lights Manager instance.
     */ removeLight: function(light) {
                    var index = this.lights.indexOf(light);
                    if (index >= 0) SpliceOne(this.lights, index);
                    return this;
                },
                /**
     * Shut down the Lights Manager.
     *
     * Recycles all active Lights into the Light pool, resets ambient light color and clears the lists of Lights and
     * culled Lights.
     *
     * @method Phaser.GameObjects.LightsManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.lights.length = 0;
                },
                /**
     * Destroy the Lights Manager.
     *
     * Cleans up all references by calling {@link Phaser.GameObjects.LightsManager#shutdown}.
     *
     * @method Phaser.GameObjects.LightsManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                }
            });
            module1.exports = LightsManager;
        /***/ },
        /* 483 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(56);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Geom
 */ var Geom = {
                Circle: __webpack_require__(1191),
                Ellipse: __webpack_require__(1201),
                Intersects: __webpack_require__(484),
                Line: __webpack_require__(1221),
                Mesh: __webpack_require__(1243),
                Point: __webpack_require__(1246),
                Polygon: __webpack_require__(1260),
                Rectangle: __webpack_require__(502),
                Triangle: __webpack_require__(1293)
            };
            //   Merge in the consts
            Geom = Extend(false, Geom, CONST);
            module1.exports = Geom;
        /***/ },
        /* 484 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Intersects
 */ module1.exports = {
                CircleToCircle: __webpack_require__(231),
                CircleToRectangle: __webpack_require__(151),
                GetCircleToCircle: __webpack_require__(1211),
                GetCircleToRectangle: __webpack_require__(1212),
                GetLineToCircle: __webpack_require__(232),
                GetLineToLine: __webpack_require__(485),
                GetLineToPoints: __webpack_require__(486),
                GetLineToPolygon: __webpack_require__(487),
                GetLineToRectangle: __webpack_require__(234),
                GetRaysFromPointToPolygon: __webpack_require__(1213),
                GetRectangleIntersection: __webpack_require__(1214),
                GetRectangleToRectangle: __webpack_require__(1215),
                GetRectangleToTriangle: __webpack_require__(1216),
                GetTriangleToCircle: __webpack_require__(1217),
                GetTriangleToLine: __webpack_require__(492),
                GetTriangleToTriangle: __webpack_require__(1218),
                LineToCircle: __webpack_require__(233),
                LineToLine: __webpack_require__(96),
                LineToRectangle: __webpack_require__(488),
                PointToLine: __webpack_require__(496),
                PointToLineSegment: __webpack_require__(1219),
                RectangleToRectangle: __webpack_require__(152),
                RectangleToTriangle: __webpack_require__(489),
                RectangleToValues: __webpack_require__(1220),
                TriangleToCircle: __webpack_require__(491),
                TriangleToLine: __webpack_require__(493),
                TriangleToTriangle: __webpack_require__(494)
            };
        /***/ },
        /* 485 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(39);
            /**
 * Checks for intersection between the two line segments and returns the intersection point as a Vector3,
 * or `null` if the lines are parallel, or do not intersect.
 *
 * The `z` property of the Vector3 contains the intersection distance, which can be used to find
 * the closest intersecting point from a group of line segments.
 *
 * @function Phaser.Geom.Intersects.GetLineToLine
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line1 - The first line segment to check.
 * @param {Phaser.Geom.Line} line2 - The second line segment to check.
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToLine = function(line1, line2, out) {
                var x1 = line1.x1;
                var y1 = line1.y1;
                var x2 = line1.x2;
                var y2 = line1.y2;
                var x3 = line2.x1;
                var y3 = line2.y1;
                var x4 = line2.x2;
                var y4 = line2.y2;
                var dx1 = x2 - x1;
                var dy1 = y2 - y1;
                var dx2 = x4 - x3;
                var dy2 = y4 - y3;
                var denom = dy2 * dx1 - dx2 * dy1;
                //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                if (dx1 === 0 || denom === 0) return false;
                var T2 = (dx1 * (y3 - y1) + dy1 * (x1 - x3)) / (dx2 * dy1 - dy2 * dx1);
                var T1 = (x3 + dx2 * T2 - x1) / dx1;
                //  Intersects?
                if (T1 < 0 || T2 < 0 || T2 > 1) return null;
                if (out === undefined) out = new Vector3();
                return out.set(x1 + dx1 * T1, y1 + dy1 * T1, T1);
            };
            module1.exports = GetLineToLine;
        /***/ },
        /* 486 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(39);
            var GetLineToLine = __webpack_require__(485);
            var Line = __webpack_require__(47);
            //  Temp calculation segment
            var segment = new Line();
            //  Temp vec3
            var tempIntersect = new Vector3();
            /**
 * Checks for the closest point of intersection between a line segment and an array of points, where each pair
 * of points are converted to line segments for the intersection tests.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector3 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 *
 * @function Phaser.Geom.Intersects.GetLineToPoints
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Math.Vector2[] | Phaser.Geom.Point[]} points - An array of points to check.
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToPoints = function(line, points, out) {
                if (out === undefined) out = new Vector3();
                var closestIntersect = false;
                //  Reset our vec3s
                out.set();
                tempIntersect.set();
                var prev = points[0];
                for(var i = 1; i < points.length; i++){
                    var current = points[i];
                    segment.setTo(prev.x, prev.y, current.x, current.y);
                    prev = current;
                    if (GetLineToLine(line, segment, tempIntersect)) {
                        if (!closestIntersect || tempIntersect.z < out.z) {
                            out.copy(tempIntersect);
                            closestIntersect = true;
                        }
                    }
                }
                return closestIntersect ? out : null;
            };
            module1.exports = GetLineToPoints;
        /***/ },
        /* 487 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(39);
            var Vector4 = __webpack_require__(140);
            var GetLineToPoints = __webpack_require__(486);
            //  Temp vec3
            var tempIntersect = new Vector3();
            /**
 * Checks for the closest point of intersection between a line segment and an array of polygons.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector4 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetLineToPolygon
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check.
 * @param {Phaser.Math.Vector4} [out] - A Vector4 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector4} A Vector4 containing the intersection results, or `null`.
 */ var GetLineToPolygon = function(line, polygons, out) {
                if (out === undefined) out = new Vector4();
                if (!Array.isArray(polygons)) polygons = [
                    polygons
                ];
                var closestIntersect = false;
                //  Reset our vec4s
                out.set();
                tempIntersect.set();
                for(var i = 0; i < polygons.length; i++){
                    if (GetLineToPoints(line, polygons[i].points, tempIntersect)) {
                        if (!closestIntersect || tempIntersect.z < out.z) {
                            out.set(tempIntersect.x, tempIntersect.y, tempIntersect.z, i);
                            closestIntersect = true;
                        }
                    }
                }
                return closestIntersect ? out : null;
            };
            module1.exports = GetLineToPolygon;
        /***/ },
        /* 488 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the Line and a Rectangle shape, or a rectangle-like
 * object, with public `x`, `y`, `right` and `bottom` properties, such as a Sprite or Body.
 *
 * An intersection is considered valid if:
 *
 * The line starts within, or ends within, the Rectangle.
 * The line segment intersects one of the 4 rectangle edges.
 *
 * The for the purposes of this function rectangles are considered 'solid'.
 *
 * @function Phaser.Geom.Intersects.LineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the Line and the Rectangle intersect, `false` otherwise.
 */ var LineToRectangle = function(line, rect) {
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var bx1 = rect.x;
                var by1 = rect.y;
                var bx2 = rect.right;
                var by2 = rect.bottom;
                var t = 0;
                //  If the start or end of the line is inside the rect then we assume
                //  collision, as rects are solid for our use-case.
                if (x1 >= bx1 && x1 <= bx2 && y1 >= by1 && y1 <= by2 || x2 >= bx1 && x2 <= bx2 && y2 >= by1 && y2 <= by2) return true;
                if (x1 < bx1 && x2 >= bx1) {
                    //  Left edge
                    t = y1 + (y2 - y1) * (bx1 - x1) / (x2 - x1);
                    if (t > by1 && t <= by2) return true;
                } else if (x1 > bx2 && x2 <= bx2) {
                    //  Right edge
                    t = y1 + (y2 - y1) * (bx2 - x1) / (x2 - x1);
                    if (t >= by1 && t <= by2) return true;
                }
                if (y1 < by1 && y2 >= by1) {
                    //  Top edge
                    t = x1 + (x2 - x1) * (by1 - y1) / (y2 - y1);
                    if (t >= bx1 && t <= bx2) return true;
                } else if (y1 > by2 && y2 <= by2) {
                    //  Bottom edge
                    t = x1 + (x2 - x1) * (by2 - y1) / (y2 - y1);
                    if (t >= bx1 && t <= bx2) return true;
                }
                return false;
            };
            module1.exports = LineToRectangle;
        /***/ },
        /* 489 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(96);
            var Contains = __webpack_require__(57);
            var ContainsArray = __webpack_require__(235);
            var Decompose = __webpack_require__(490);
            /**
 * Checks for intersection between Rectangle shape and Triangle shape.
 *
 * @function Phaser.Geom.Intersects.RectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 *
 * @return {boolean} A value of `true` if objects intersect; otherwise `false`.
 */ var RectangleToTriangle = function(rect, triangle) {
                //  First the cheapest ones:
                if (triangle.left > rect.right || triangle.right < rect.left || triangle.top > rect.bottom || triangle.bottom < rect.top) return false;
                var triA = triangle.getLineA();
                var triB = triangle.getLineB();
                var triC = triangle.getLineC();
                //  Are any of the triangle points within the rectangle?
                if (Contains(rect, triA.x1, triA.y1) || Contains(rect, triA.x2, triA.y2)) return true;
                if (Contains(rect, triB.x1, triB.y1) || Contains(rect, triB.x2, triB.y2)) return true;
                if (Contains(rect, triC.x1, triC.y1) || Contains(rect, triC.x2, triC.y2)) return true;
                //  Cheap tests over, now to see if any of the lines intersect ...
                var rectA = rect.getLineA();
                var rectB = rect.getLineB();
                var rectC = rect.getLineC();
                var rectD = rect.getLineD();
                if (LineToLine(triA, rectA) || LineToLine(triA, rectB) || LineToLine(triA, rectC) || LineToLine(triA, rectD)) return true;
                if (LineToLine(triB, rectA) || LineToLine(triB, rectB) || LineToLine(triB, rectC) || LineToLine(triB, rectD)) return true;
                if (LineToLine(triC, rectA) || LineToLine(triC, rectB) || LineToLine(triC, rectC) || LineToLine(triC, rectD)) return true;
                //  None of the lines intersect, so are any rectangle points within the triangle?
                var points = Decompose(rect);
                var within = ContainsArray(triangle, points, true);
                return within.length > 0;
            };
            module1.exports = RectangleToTriangle;
        /***/ },
        /* 490 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array of points for each corner of a Rectangle
 * If an array is specified, each point object will be added to the end of the array, otherwise a new array will be created.
 *
 * @function Phaser.Geom.Rectangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object to be decomposed.
 * @param {array} [out] - If provided, each point will be added to this array.
 *
 * @return {array} Will return the array you specified or a new array containing the points of the Rectangle.
 */ var Decompose = function(rect, out) {
                if (out === undefined) out = [];
                out.push({
                    x: rect.x,
                    y: rect.y
                });
                out.push({
                    x: rect.right,
                    y: rect.y
                });
                out.push({
                    x: rect.right,
                    y: rect.bottom
                });
                out.push({
                    x: rect.x,
                    y: rect.bottom
                });
                return out;
            };
            module1.exports = Decompose;
        /***/ },
        /* 491 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToCircle = __webpack_require__(233);
            var Contains = __webpack_require__(115);
            /**
 * Checks if a Triangle and a Circle intersect.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.TriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 *
 * @return {boolean} `true` if the Triangle and the `Circle` intersect, otherwise `false`.
 */ var TriangleToCircle = function(triangle, circle) {
                //  First the cheapest ones:
                if (triangle.left > circle.right || triangle.right < circle.left || triangle.top > circle.bottom || triangle.bottom < circle.top) return false;
                if (Contains(triangle, circle.x, circle.y)) return true;
                if (LineToCircle(triangle.getLineA(), circle)) return true;
                if (LineToCircle(triangle.getLineB(), circle)) return true;
                if (LineToCircle(triangle.getLineC(), circle)) return true;
                return false;
            };
            module1.exports = TriangleToCircle;
        /***/ },
        /* 492 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var TriangleToLine = __webpack_require__(493);
            var LineToLine = __webpack_require__(96);
            /**
 * Checks if a Triangle and a Line intersect, and returns the intersection points as a Point object array.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToLine = function(triangle, line, out) {
                if (out === undefined) out = [];
                if (TriangleToLine(triangle, line)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    var output = [
                        new Point(),
                        new Point(),
                        new Point()
                    ];
                    var result = [
                        LineToLine(lineA, line, output[0]),
                        LineToLine(lineB, line, output[1]),
                        LineToLine(lineC, line, output[2])
                    ];
                    for(var i = 0; i < 3; i++)if (result[i]) out.push(output[i]);
                }
                return out;
            };
            module1.exports = GetTriangleToLine;
        /***/ },
        /* 493 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(96);
            /**
 * Checks if a Triangle and a Line intersect.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 *
 * @return {boolean} `true` if the Triangle and the Line intersect, otherwise `false`.
 */ var TriangleToLine = function(triangle, line) {
                //  If the Triangle contains either the start or end point of the line, it intersects
                if (triangle.contains(line.x1, line.y1) || triangle.contains(line.x2, line.y2)) return true;
                //  Now check the line against each line of the Triangle
                if (LineToLine(triangle.getLineA(), line)) return true;
                if (LineToLine(triangle.getLineB(), line)) return true;
                if (LineToLine(triangle.getLineC(), line)) return true;
                return false;
            };
            module1.exports = TriangleToLine;
        /***/ },
        /* 494 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ContainsArray = __webpack_require__(235);
            var Decompose = __webpack_require__(495);
            var LineToLine = __webpack_require__(96);
            /**
 * Checks if two Triangles intersect.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 *
 * @return {boolean} `true` if the Triangles intersect, otherwise `false`.
 */ var TriangleToTriangle = function(triangleA, triangleB) {
                //  First the cheapest ones:
                if (triangleA.left > triangleB.right || triangleA.right < triangleB.left || triangleA.top > triangleB.bottom || triangleA.bottom < triangleB.top) return false;
                var lineAA = triangleA.getLineA();
                var lineAB = triangleA.getLineB();
                var lineAC = triangleA.getLineC();
                var lineBA = triangleB.getLineA();
                var lineBB = triangleB.getLineB();
                var lineBC = triangleB.getLineC();
                //  Now check the lines against each line of TriangleB
                if (LineToLine(lineAA, lineBA) || LineToLine(lineAA, lineBB) || LineToLine(lineAA, lineBC)) return true;
                if (LineToLine(lineAB, lineBA) || LineToLine(lineAB, lineBB) || LineToLine(lineAB, lineBC)) return true;
                if (LineToLine(lineAC, lineBA) || LineToLine(lineAC, lineBB) || LineToLine(lineAC, lineBC)) return true;
                //  Nope, so check to see if any of the points of triangleA are within triangleB
                var points = Decompose(triangleA);
                var within = ContainsArray(triangleB, points, true);
                if (within.length > 0) return true;
                //  Finally check to see if any of the points of triangleB are within triangleA
                points = Decompose(triangleB);
                within = ContainsArray(triangleA, points, true);
                if (within.length > 0) return true;
                return false;
            };
            module1.exports = TriangleToTriangle;
        /***/ },
        /* 495 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decomposes a Triangle into an array of its points.
 *
 * @function Phaser.Geom.Triangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to decompose.
 * @param {array} [out] - An array to store the points into.
 *
 * @return {array} The provided `out` array, or a new array if none was provided, with three objects with `x` and `y` properties representing each point of the Triangle appended to it.
 */ var Decompose = function(triangle, out) {
                if (out === undefined) out = [];
                out.push({
                    x: triangle.x1,
                    y: triangle.y1
                });
                out.push({
                    x: triangle.x2,
                    y: triangle.y2
                });
                out.push({
                    x: triangle.x3,
                    y: triangle.y3
                });
                return out;
            };
            module1.exports = Decompose;
        /***/ },
        /* 496 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the a Point falls between the two end-points of a Line, based on the given line thickness.
 * 
 * Assumes that the line end points are circular, not square.
 *
 * @function Phaser.Geom.Intersects.PointToLine
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|any)} point - The point, or point-like object to check.
 * @param {Phaser.Geom.Line} line - The line segment to test for intersection on.
 * @param {number} [lineThickness=1] - The line thickness. Assumes that the line end points are circular.
 *
 * @return {boolean} `true` if the Point falls on the Line, otherwise `false`.
 */ var PointToLine = function(point, line, lineThickness) {
                if (lineThickness === undefined) lineThickness = 1;
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var px = point.x;
                var py = point.y;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return false;
                var r = ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / L2;
                //  Assume line thickness is circular
                if (r < 0) //  Outside line1
                return Math.sqrt((x1 - px) * (x1 - px) + (y1 - py) * (y1 - py)) <= lineThickness;
                else if (r >= 0 && r <= 1) {
                    //  On the line segment
                    var s = ((y1 - py) * (x2 - x1) - (x1 - px) * (y2 - y1)) / L2;
                    return Math.abs(s) * Math.sqrt(L2) <= lineThickness;
                } else //  Outside line2
                return Math.sqrt((x2 - px) * (x2 - px) + (y2 - py) * (y2 - py)) <= lineThickness;
            };
            module1.exports = PointToLine;
        /***/ },
        /* 497 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Wrap = __webpack_require__(68);
            var Angle = __webpack_require__(97);
            /**
 * Get the angle of the normal of the given line in radians.
 *
 * @function Phaser.Geom.Line.NormalAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of the normal of.
 *
 * @return {number} The angle of the normal of the line in radians.
 */ var NormalAngle = function(line) {
                var angle = Angle(line) - MATH_CONST.TAU;
                return Wrap(angle, -Math.PI, Math.PI);
            };
            module1.exports = NormalAngle;
        /***/ },
        /* 498 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var flip = true;
            var defaultModelName = "untitled";
            var currentGroup = "";
            var currentMaterial = "";
            /**
 * @ignore
 */ function stripComments(line) {
                var idx = line.indexOf("#");
                return idx > -1 ? line.substring(0, idx) : line;
            }
            /**
 * @ignore
 */ function currentModel(result) {
                if (result.models.length === 0) result.models.push({
                    faces: [],
                    name: defaultModelName,
                    textureCoords: [],
                    vertexNormals: [],
                    vertices: []
                });
                currentGroup = "";
                return result.models[result.models.length - 1];
            }
            /**
 * @ignore
 */ function parseObject(lineItems, result) {
                var modelName = lineItems.length >= 2 ? lineItems[1] : defaultModelName;
                result.models.push({
                    faces: [],
                    name: modelName,
                    textureCoords: [],
                    vertexNormals: [],
                    vertices: []
                });
                currentGroup = "";
            }
            /**
 * @ignore
 */ function parseGroup(lineItems) {
                if (lineItems.length === 2) currentGroup = lineItems[1];
            }
            /**
 * @ignore
 */ function parseVertexCoords(lineItems, result) {
                var len = lineItems.length;
                var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                currentModel(result).vertices.push({
                    x: x,
                    y: y,
                    z: z
                });
            }
            /**
 * @ignore
 */ function parseTextureCoords(lineItems, result) {
                var len = lineItems.length;
                var u = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var v = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var w = len >= 4 ? parseFloat(lineItems[3]) : 0;
                if (isNaN(u)) u = 0;
                if (isNaN(v)) v = 0;
                if (isNaN(w)) w = 0;
                if (flip) v = 1 - v;
                currentModel(result).textureCoords.push({
                    u: u,
                    v: v,
                    w: w
                });
            }
            /**
 * @ignore
 */ function parseVertexNormal(lineItems, result) {
                var len = lineItems.length;
                var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                currentModel(result).vertexNormals.push({
                    x: x,
                    y: y,
                    z: z
                });
            }
            /**
 * @ignore
 */ function parsePolygon(lineItems, result) {
                var totalVertices = lineItems.length - 1;
                if (totalVertices < 3) return;
                var face = {
                    group: currentGroup,
                    material: currentMaterial,
                    vertices: []
                };
                for(var i = 0; i < totalVertices; i++){
                    var vertexString = lineItems[i + 1];
                    var vertexValues = vertexString.split("/");
                    var vvLen = vertexValues.length;
                    if (vvLen < 1 || vvLen > 3) continue;
                    var vertexIndex = 0;
                    var textureCoordsIndex = 0;
                    var vertexNormalIndex = 0;
                    vertexIndex = parseInt(vertexValues[0], 10);
                    if (vvLen > 1 && vertexValues[1] !== "") textureCoordsIndex = parseInt(vertexValues[1], 10);
                    if (vvLen > 2) vertexNormalIndex = parseInt(vertexValues[2], 10);
                    if (vertexIndex !== 0) {
                        // Negative vertex indices refer to the nth last defined vertex
                        // convert these to postive indices for simplicity
                        if (vertexIndex < 0) vertexIndex = currentModel(result).vertices.length + 1 + vertexIndex;
                        textureCoordsIndex -= 1;
                        vertexIndex -= 1;
                        vertexNormalIndex -= 1;
                        face.vertices.push({
                            textureCoordsIndex: textureCoordsIndex,
                            vertexIndex: vertexIndex,
                            vertexNormalIndex: vertexNormalIndex
                        });
                    }
                }
                currentModel(result).faces.push(face);
            }
            /**
 * @ignore
 */ function parseMtlLib(lineItems, result) {
                if (lineItems.length >= 2) result.materialLibraries.push(lineItems[1]);
            }
            /**
 * @ignore
 */ function parseUseMtl(lineItems) {
                if (lineItems.length >= 2) currentMaterial = lineItems[1];
            }
            /**
 * Parses a Wavefront OBJ File, extracting the models from it and returning them in an array.
 *
 * The model data *must* be triangulated for a Mesh Game Object to be able to render it.
 *
 * @function Phaser.Geom.Mesh.ParseObj
 * @since 3.50.0
 *
 * @param {string} data - The OBJ File data as a raw string.
 * @param {boolean} [flipUV=true] - Flip the UV coordinates?
 *
 * @return {Phaser.Types.Geom.Mesh.OBJData} The parsed model and material data.
 */ var ParseObj = function(data, flipUV) {
                if (flipUV === undefined) flipUV = true;
                flip = flipUV;
                //  Store results in here
                var result = {
                    materials: {},
                    materialLibraries: [],
                    models: []
                };
                currentGroup = "";
                currentMaterial = "";
                var lines = data.split("\n");
                for(var i = 0; i < lines.length; i++){
                    var line = stripComments(lines[i]);
                    var lineItems = line.replace(/\s\s+/g, " ").trim().split(" ");
                    switch(lineItems[0].toLowerCase()){
                        case "o":
                            // Start A New Model
                            parseObject(lineItems, result);
                            break;
                        case "g":
                            // Start a new polygon group
                            parseGroup(lineItems);
                            break;
                        case "v":
                            // Define a vertex for the current model
                            parseVertexCoords(lineItems, result);
                            break;
                        case "vt":
                            // Texture Coords
                            parseTextureCoords(lineItems, result);
                            break;
                        case "vn":
                            // Define a vertex normal for the current model
                            parseVertexNormal(lineItems, result);
                            break;
                        case "f":
                            // Define a Face/Polygon
                            parsePolygon(lineItems, result);
                            break;
                        case "mtllib":
                            // Reference to a material library file (.mtl)
                            parseMtlLib(lineItems, result);
                            break;
                        case "usemtl":
                            // Sets the current material to be applied to polygons defined from this point forward
                            parseUseMtl(lineItems);
                            break;
                    }
                }
                return result;
            };
            module1.exports = ParseObj;
        /***/ },
        /* 499 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(103);
            /**
 * Takes a Wavefront Material file and extracts the diffuse reflectivity of the named
 * materials, converts them to integer color values and returns them.
 *
 * This is used internally by the `addOBJ` and `addModel` methods, but is exposed for
 * public consumption as well.
 *
 * Note this only works with diffuse values, specified in the `Kd r g b` format, where
 * `g` and `b` are optional, but `r` is required. It does not support spectral rfl files,
 * or any other material statement (such as `Ka` or `Ks`)
 *
 * @method Phaser.Geom.Mesh.ParseObjMaterial
 * @since 3.50.0
 *
 * @param {string} mtl - The OBJ MTL file as a raw string, i.e. loaded via `this.load.text`.
 *
 * @return {object} The parsed material colors, where each property of the object matches the material name.
 */ var ParseObjMaterial = function(mtl) {
                var output = {};
                var lines = mtl.split("\n");
                var currentMaterial = "";
                for(var i = 0; i < lines.length; i++){
                    var line = lines[i].trim();
                    if (line.indexOf("#") === 0 || line === "") continue;
                    var lineItems = line.replace(/\s\s+/g, " ").trim().split(" ");
                    switch(lineItems[0].toLowerCase()){
                        case "newmtl":
                            currentMaterial = lineItems[1];
                            break;
                        //  The diffuse reflectivity of the current material
                        //  Support r, [g], [b] format, where g and b are optional
                        case "kd":
                            var r = Math.floor(lineItems[1] * 255);
                            var g = lineItems.length >= 2 ? Math.floor(lineItems[2] * 255) : r;
                            var b = lineItems.length >= 3 ? Math.floor(lineItems[3] * 255) : r;
                            output[currentMaterial] = GetColor(r, g, b);
                            break;
                    }
                }
                return output;
            };
            module1.exports = ParseObjMaterial;
        /***/ },
        /* 500 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the magnitude of the point, which equivalent to the length of the line from the origin to this point.
 *
 * @function Phaser.Geom.Point.GetMagnitude
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The point to calculate the magnitude for
 *
 * @return {number} The resulting magnitude
 */ var GetMagnitude = function(point) {
                return Math.sqrt(point.x * point.x + point.y * point.y);
            };
            module1.exports = GetMagnitude;
        /***/ },
        /* 501 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the square of magnitude of given point.(Can be used for fast magnitude calculation of point)
 *
 * @function Phaser.Geom.Point.GetMagnitudeSq
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - Returns square of the magnitude/length of given point.
 *
 * @return {number} Returns square of the magnitude of given point.
 */ var GetMagnitudeSq = function(point) {
                return point.x * point.x + point.y * point.y;
            };
            module1.exports = GetMagnitudeSq;
        /***/ },
        /* 502 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            Rectangle.Area = __webpack_require__(1267);
            Rectangle.Ceil = __webpack_require__(1268);
            Rectangle.CeilAll = __webpack_require__(1269);
            Rectangle.CenterOn = __webpack_require__(190);
            Rectangle.Clone = __webpack_require__(1270);
            Rectangle.Contains = __webpack_require__(57);
            Rectangle.ContainsPoint = __webpack_require__(1271);
            Rectangle.ContainsRect = __webpack_require__(503);
            Rectangle.CopyFrom = __webpack_require__(1272);
            Rectangle.Decompose = __webpack_require__(490);
            Rectangle.Equals = __webpack_require__(1273);
            Rectangle.FitInside = __webpack_require__(1274);
            Rectangle.FitOutside = __webpack_require__(1275);
            Rectangle.Floor = __webpack_require__(1276);
            Rectangle.FloorAll = __webpack_require__(1277);
            Rectangle.FromPoints = __webpack_require__(199);
            Rectangle.FromXY = __webpack_require__(1278);
            Rectangle.GetAspectRatio = __webpack_require__(237);
            Rectangle.GetCenter = __webpack_require__(1279);
            Rectangle.GetPoint = __webpack_require__(171);
            Rectangle.GetPoints = __webpack_require__(306);
            Rectangle.GetSize = __webpack_require__(1280);
            Rectangle.Inflate = __webpack_require__(1281);
            Rectangle.Intersection = __webpack_require__(1282);
            Rectangle.MarchingAnts = __webpack_require__(316);
            Rectangle.MergePoints = __webpack_require__(1283);
            Rectangle.MergeRect = __webpack_require__(1284);
            Rectangle.MergeXY = __webpack_require__(1285);
            Rectangle.Offset = __webpack_require__(1286);
            Rectangle.OffsetPoint = __webpack_require__(1287);
            Rectangle.Overlaps = __webpack_require__(1288);
            Rectangle.Perimeter = __webpack_require__(130);
            Rectangle.PerimeterPoint = __webpack_require__(1289);
            Rectangle.Random = __webpack_require__(174);
            Rectangle.RandomOutside = __webpack_require__(1290);
            Rectangle.SameDimensions = __webpack_require__(1291);
            Rectangle.Scale = __webpack_require__(1292);
            Rectangle.Union = __webpack_require__(441);
            module1.exports = Rectangle;
        /***/ },
        /* 503 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if one rectangle fully contains another.
 *
 * @function Phaser.Geom.Rectangle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first rectangle.
 * @param {Phaser.Geom.Rectangle} rectB - The second rectangle.
 *
 * @return {boolean} True only if rectA fully contains rectB.
 */ var ContainsRect = function(rectA, rectB) {
                //  Volume check (if rectB volume > rectA then rectA cannot contain it)
                if (rectB.width * rectB.height > rectA.width * rectA.height) return false;
                return rectB.x > rectA.x && rectB.x < rectA.right && rectB.right > rectA.x && rectB.right < rectA.right && rectB.y > rectA.y && rectB.y < rectA.bottom && rectB.bottom > rectA.y && rectB.bottom < rectA.bottom;
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 504 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            //  The three medians (the lines drawn from the vertices to the bisectors of the opposite sides)
            //  meet in the centroid or center of mass (center of gravity).
            //  The centroid divides each median in a ratio of 2:1
            /**
 * Calculates the position of a Triangle's centroid, which is also its center of mass (center of gravity).
 *
 * The centroid is the point in a Triangle at which its three medians (the lines drawn from the vertices to the bisectors of the opposite sides) meet. It divides each one in a 2:1 ratio.
 *
 * @function Phaser.Geom.Triangle.Centroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the coordinates in.
 *
 * @return {(Phaser.Geom.Point|object)} The `out` object with modified `x` and `y` properties, or a new Point if none was provided.
 */ var Centroid = function(triangle, out) {
                if (out === undefined) out = new Point();
                out.x = (triangle.x1 + triangle.x2 + triangle.x3) / 3;
                out.y = (triangle.y1 + triangle.y2 + triangle.y3) / 3;
                return out;
            };
            module1.exports = Centroid;
        /***/ },
        /* 505 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves each point (vertex) of a Triangle by a given offset, thus moving the entire Triangle by that offset.
 *
 * @function Phaser.Geom.Triangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to move.
 * @param {number} x - The horizontal offset (distance) by which to move each point. Can be positive or negative.
 * @param {number} y - The vertical offset (distance) by which to move each point. Can be positive or negative.
 *
 * @return {Phaser.Geom.Triangle} The modified Triangle.
 */ var Offset = function(triangle, x, y) {
                triangle.x1 += x;
                triangle.y1 += y;
                triangle.x2 += x;
                triangle.y2 += y;
                triangle.x3 += x;
                triangle.y3 += y;
                return triangle;
            };
            module1.exports = Offset;
        /***/ },
        /* 506 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            // The three angle bisectors of a triangle meet in one point called the incenter.
            // It is the center of the incircle, the circle inscribed in the triangle.
            function getLength(x1, y1, x2, y2) {
                var x = x1 - x2;
                var y = y1 - y2;
                var magnitude = x * x + y * y;
                return Math.sqrt(magnitude);
            }
            /**
 * Calculates the position of the incenter of a Triangle object. This is the point where its three angle bisectors meet and it's also the center of the incircle, which is the circle inscribed in the triangle.
 *
 * @function Phaser.Geom.Triangle.InCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to find the incenter of.
 * @param {Phaser.Geom.Point} [out] - An optional Point in which to store the coordinates.
 *
 * @return {Phaser.Geom.Point} Point (x, y) of the center pixel of the triangle.
 */ var InCenter = function(triangle, out) {
                if (out === undefined) out = new Point();
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                var d1 = getLength(x3, y3, x2, y2);
                var d2 = getLength(x1, y1, x3, y3);
                var d3 = getLength(x2, y2, x1, y1);
                var p = d1 + d2 + d3;
                out.x = (x1 * d1 + x2 * d2 + x3 * d3) / p;
                out.y = (y1 * d1 + y2 * d2 + y3 * d3) / p;
                return out;
            };
            module1.exports = InCenter;
        /***/ },
        /* 507 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Pixel Perfect Handler function.
 *
 * Access via `InputPlugin.makePixelPerfect` rather than calling it directly.
 *
 * @function Phaser.Input.CreatePixelPerfectHandler
 * @since 3.10.0
 *
 * @param {Phaser.Textures.TextureManager} textureManager - A reference to the Texture Manager.
 * @param {number} alphaTolerance - The alpha level that the pixel should be above to be included as a successful interaction.
 *
 * @return {function} The new Pixel Perfect Handler function.
 */ var CreatePixelPerfectHandler = function(textureManager, alphaTolerance) {
                return function(hitArea, x, y, gameObject) {
                    var alpha = textureManager.getPixelAlpha(x, y, gameObject.texture.key, gameObject.frame.name);
                    return alpha && alpha >= alphaTolerance;
                };
            };
            module1.exports = CreatePixelPerfectHandler;
        /***/ },
        /* 508 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Interactive Object.
 * 
 * This is called automatically by the Input Manager when you enable a Game Object for input.
 *
 * The resulting Interactive Object is mapped to the Game Object's `input` property.
 *
 * @function Phaser.Input.CreateInteractiveObject
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to which this Interactive Object is bound.
 * @param {any} hitArea - The hit area for this Interactive Object. Typically a geometry shape, like a Rectangle or Circle.
 * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - The 'contains' check callback that the hit area shape will use for all hit tests.
 *
 * @return {Phaser.Types.Input.InteractiveObject} The new Interactive Object.
 */ var CreateInteractiveObject = function(gameObject, hitArea, hitAreaCallback) {
                return {
                    gameObject: gameObject,
                    enabled: true,
                    alwaysEnabled: false,
                    draggable: false,
                    dropZone: false,
                    cursor: false,
                    target: null,
                    camera: null,
                    hitArea: hitArea,
                    hitAreaCallback: hitAreaCallback,
                    hitAreaDebug: null,
                    //  Has the dev specified their own shape, or is this bound to the texture size?
                    customHitArea: false,
                    localX: 0,
                    localY: 0,
                    //  0 = Not being dragged
                    //  1 = Being checked for dragging
                    //  2 = Being dragged
                    dragState: 0,
                    dragStartX: 0,
                    dragStartY: 0,
                    dragStartXGlobal: 0,
                    dragStartYGlobal: 0,
                    dragX: 0,
                    dragY: 0
                };
            };
            module1.exports = CreateInteractiveObject;
        /***/ },
        /* 509 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * Contains information about a specific Gamepad Axis.
 * Axis objects are created automatically by the Gamepad as they are needed.
 *
 * @class Axis
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Axis belongs to.
 * @param {number} index - The index of this Axis.
 */ var Axis = new Class({
                initialize: function Axis(pad, index) {
                    /**
         * A reference to the Gamepad that this Axis belongs to.
         *
         * @name Phaser.Input.Gamepad.Axis#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                    /**
         * An event emitter to use to emit the axis events.
         *
         * @name Phaser.Input.Gamepad.Axis#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.events;
                    /**
         * The index of this Axis.
         *
         * @name Phaser.Input.Gamepad.Axis#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * The raw axis value, between -1 and 1 with 0 being dead center.
         * Use the method `getValue` to get a normalized value with the threshold applied.
         *
         * @name Phaser.Input.Gamepad.Axis#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                    /**
         * Movement tolerance threshold below which axis values are ignored in `getValue`.
         *
         * @name Phaser.Input.Gamepad.Axis#threshold
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.threshold = 0.1;
                },
                /**
     * Internal update handler for this Axis.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Axis#update
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the axis movement.
     */ update: function(value) {
                    this.value = value;
                },
                /**
     * Applies the `threshold` value to the axis and returns it.
     *
     * @method Phaser.Input.Gamepad.Axis#getValue
     * @since 3.0.0
     *
     * @return {number} The axis value, adjusted for the movement threshold.
     */ getValue: function() {
                    return Math.abs(this.value) < this.threshold ? 0 : this.value;
                },
                /**
     * Destroys this Axis instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Axis#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.pad = null;
                    this.events = null;
                }
            });
            module1.exports = Axis;
        /***/ },
        /* 510 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(239);
            /**
 * @classdesc
 * Contains information about a specific button on a Gamepad.
 * Button objects are created automatically by the Gamepad as they are needed.
 *
 * @class Button
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Button belongs to.
 * @param {number} index - The index of this Button.
 */ var Button = new Class({
                initialize: function Button(pad, index) {
                    /**
         * A reference to the Gamepad that this Button belongs to.
         *
         * @name Phaser.Input.Gamepad.Button#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                    /**
         * An event emitter to use to emit the button events.
         *
         * @name Phaser.Input.Gamepad.Button#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.manager;
                    /**
         * The index of this Button.
         *
         * @name Phaser.Input.Gamepad.Button#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * Between 0 and 1.
         *
         * @name Phaser.Input.Gamepad.Button#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                    /**
         * Can be set for analogue buttons to enable a 'pressure' threshold,
         * before a button is considered as being 'pressed'.
         *
         * @name Phaser.Input.Gamepad.Button#threshold
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.threshold = 1;
                    /**
         * Is the Button being pressed down or not?
         *
         * @name Phaser.Input.Gamepad.Button#pressed
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pressed = false;
                },
                /**
     * Internal update handler for this Button.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Button#update
     * @fires Phaser.Input.Gamepad.Events#BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#BUTTON_UP
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the button. Between 0 and 1.
     */ update: function(value) {
                    this.value = value;
                    var pad = this.pad;
                    var index = this.index;
                    if (value >= this.threshold) {
                        if (!this.pressed) {
                            this.pressed = true;
                            this.events.emit(Events.BUTTON_DOWN, pad, this, value);
                            this.pad.emit(Events.GAMEPAD_BUTTON_DOWN, index, value, this);
                        }
                    } else if (this.pressed) {
                        this.pressed = false;
                        this.events.emit(Events.BUTTON_UP, pad, this, value);
                        this.pad.emit(Events.GAMEPAD_BUTTON_UP, index, value, this);
                    }
                },
                /**
     * Destroys this Button instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Button#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.pad = null;
                    this.events = null;
                }
            });
            module1.exports = Button;
        /***/ },
        /* 511 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Axis = __webpack_require__(509);
            var Button = __webpack_require__(510);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A single Gamepad.
 *
 * These are created, updated and managed by the Gamepad Plugin.
 *
 * @class Gamepad
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.GamepadPlugin} manager - A reference to the Gamepad Plugin.
 * @param {Phaser.Types.Input.Gamepad.Pad} pad - The Gamepad object, as extracted from GamepadEvent.
 */ var Gamepad = new Class({
                Extends: EventEmitter,
                initialize: function Gamepad(manager, pad) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Gamepad Plugin.
         *
         * @name Phaser.Input.Gamepad.Gamepad#manager
         * @type {Phaser.Input.Gamepad.GamepadPlugin}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * A reference to the native Gamepad object that is connected to the browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#pad
         * @type {any}
         * @since 3.10.0
         */ this.pad = pad;
                    /**
         * A string containing some information about the controller.
         *
         * This is not strictly specified, but in Firefox it will contain three pieces of information
         * separated by dashes (-): two 4-digit hexadecimal strings containing the USB vendor and
         * product id of the controller, and the name of the controller as provided by the driver.
         * In Chrome it will contain the name of the controller as provided by the driver,
         * followed by vendor and product 4-digit hexadecimal strings.
         *
         * @name Phaser.Input.Gamepad.Gamepad#id
         * @type {string}
         * @since 3.0.0
         */ this.id = pad.id;
                    /**
         * An integer that is unique for each Gamepad currently connected to the system.
         * This can be used to distinguish multiple controllers.
         * Note that disconnecting a device and then connecting a new device may reuse the previous index.
         *
         * @name Phaser.Input.Gamepad.Gamepad#index
         * @type {number}
         * @since 3.0.0
         */ this.index = pad.index;
                    var buttons = [];
                    for(var i = 0; i < pad.buttons.length; i++)buttons.push(new Button(this, i));
                    /**
         * An array of Gamepad Button objects, corresponding to the different buttons available on the Gamepad.
         *
         * @name Phaser.Input.Gamepad.Gamepad#buttons
         * @type {Phaser.Input.Gamepad.Button[]}
         * @since 3.0.0
         */ this.buttons = buttons;
                    var axes = [];
                    for(i = 0; i < pad.axes.length; i++)axes.push(new Axis(this, i));
                    /**
         * An array of Gamepad Axis objects, corresponding to the different axes available on the Gamepad, if any.
         *
         * @name Phaser.Input.Gamepad.Gamepad#axes
         * @type {Phaser.Input.Gamepad.Axis[]}
         * @since 3.0.0
         */ this.axes = axes;
                    /**
         * The Gamepad's Haptic Actuator (Vibration / Rumble support).
         * This is highly experimental and only set if both present on the device,
         * and exposed by both the hardware and browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#vibration
         * @type {GamepadHapticActuator}
         * @since 3.10.0
         */ this.vibration = pad.vibrationActuator;
                    // https://w3c.github.io/gamepad/#remapping
                    var _noButton = {
                        value: 0,
                        pressed: false
                    };
                    /**
         * A reference to the Left Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCLeft = buttons[14] ? buttons[14] : _noButton;
                    /**
         * A reference to the Right Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCRight = buttons[15] ? buttons[15] : _noButton;
                    /**
         * A reference to the Top Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCTop = buttons[12] ? buttons[12] : _noButton;
                    /**
         * A reference to the Bottom Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCBottom = buttons[13] ? buttons[13] : _noButton;
                    /**
         * A reference to the Left Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCLeft = buttons[2] ? buttons[2] : _noButton;
                    /**
         * A reference to the Right Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCRight = buttons[1] ? buttons[1] : _noButton;
                    /**
         * A reference to the Top Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCTop = buttons[3] ? buttons[3] : _noButton;
                    /**
         * A reference to the Bottom Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCBottom = buttons[0] ? buttons[0] : _noButton;
                    /**
         * A reference to the Top Left Front Button (L1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftTop = buttons[4] ? buttons[4] : _noButton;
                    /**
         * A reference to the Bottom Left Front Button (L2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftBottom = buttons[6] ? buttons[6] : _noButton;
                    /**
         * A reference to the Top Right Front Button (R1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightTop = buttons[5] ? buttons[5] : _noButton;
                    /**
         * A reference to the Bottom Right Front Button (R2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightBottom = buttons[7] ? buttons[7] : _noButton;
                    var _noAxis = {
                        value: 0
                    };
                    /**
         * A reference to the Horizontal Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisLeft = axes[0] ? axes[0] : _noAxis;
                    /**
         * A reference to the Vertical Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisLeft = axes[1] ? axes[1] : _noAxis;
                    /**
         * A reference to the Horizontal Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisRight = axes[2] ? axes[2] : _noAxis;
                    /**
         * A reference to the Vertical Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisRight = axes[3] ? axes[3] : _noAxis;
                    /**
         * A Vector2 containing the most recent values from the Gamepad's left axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a left axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#leftStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.leftStick = new Vector2();
                    /**
         * A Vector2 containing the most recent values from the Gamepad's right axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a right axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#rightStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.rightStick = new Vector2();
                    /**
         * When was this Gamepad created? Used to avoid duplicate event spamming in the update loop.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_created
         * @type {number}
         * @private
         * @since 3.50.0
         */ this._created = performance.now();
                },
                /**
     * Gets the total number of axis this Gamepad claims to support.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisTotal
     * @since 3.10.0
     *
     * @return {number} The total number of axes this Gamepad claims to support.
     */ getAxisTotal: function() {
                    return this.axes.length;
                },
                /**
     * Gets the value of an axis based on the given index.
     * The index must be valid within the range of axes supported by this Gamepad.
     * The return value will be a float between 0 and 1.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the axes to get the value for.
     *
     * @return {number} The value of the axis, between 0 and 1.
     */ getAxisValue: function(index) {
                    return this.axes[index].getValue();
                },
                /**
     * Sets the threshold value of all axis on this Gamepad.
     * The value is a float between 0 and 1 and is the amount below which the axis is considered as not having been moved.
     *
     * @method Phaser.Input.Gamepad.Gamepad#setAxisThreshold
     * @since 3.10.0
     *
     * @param {number} value - A value between 0 and 1.
     */ setAxisThreshold: function(value) {
                    for(var i = 0; i < this.axes.length; i++)this.axes[i].threshold = value;
                },
                /**
     * Gets the total number of buttons this Gamepad claims to have.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonTotal
     * @since 3.10.0
     *
     * @return {number} The total number of buttons this Gamepad claims to have.
     */ getButtonTotal: function() {
                    return this.buttons.length;
                },
                /**
     * Gets the value of a button based on the given index.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * The return value will be either 0 or 1 for an analogue button, or a float between 0 and 1
     * for a pressure-sensitive digital button, such as the shoulder buttons on a Dual Shock.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {number} The value of the button, between 0 and 1.
     */ getButtonValue: function(index) {
                    return this.buttons[index].value;
                },
                /**
     * Returns if the button is pressed down or not.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * @method Phaser.Input.Gamepad.Gamepad#isButtonDown
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {boolean} `true` if the button is considered as being pressed down, otherwise `false`.
     */ isButtonDown: function(index) {
                    return this.buttons[index].pressed;
                },
                /**
     * Internal update handler for this Gamepad.
     * Called automatically by the Gamepad Manager as part of its update.
     *
     * @method Phaser.Input.Gamepad.Gamepad#update
     * @private
     * @since 3.0.0
     */ update: function(pad) {
                    if (pad.timestamp < this._created) return;
                    var i;
                    //  Sync the button values
                    var localButtons = this.buttons;
                    var gamepadButtons = pad.buttons;
                    var len = localButtons.length;
                    for(i = 0; i < len; i++)localButtons[i].update(gamepadButtons[i].value);
                    //  Sync the axis values
                    var localAxes = this.axes;
                    var gamepadAxes = pad.axes;
                    len = localAxes.length;
                    for(i = 0; i < len; i++)localAxes[i].update(gamepadAxes[i]);
                    if (len >= 2) {
                        this.leftStick.set(localAxes[0].getValue(), localAxes[1].getValue());
                        if (len >= 4) this.rightStick.set(localAxes[2].getValue(), localAxes[3].getValue());
                    }
                },
                /**
     * Destroys this Gamepad instance, its buttons and axes, and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Gamepad#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.manager = null;
                    this.pad = null;
                    var i;
                    for(i = 0; i < this.buttons.length; i++)this.buttons[i].destroy();
                    for(i = 0; i < this.axes.length; i++)this.axes[i].destroy();
                    this.buttons = [];
                    this.axes = [];
                },
                /**
     * Is this Gamepad currently connected or not?
     *
     * @name Phaser.Input.Gamepad.Gamepad#connected
     * @type {boolean}
     * @default true
     * @since 3.0.0
     */ connected: {
                    get: function() {
                        return this.pad.connected;
                    }
                },
                /**
     * A timestamp containing the most recent time this Gamepad was updated.
     *
     * @name Phaser.Input.Gamepad.Gamepad#timestamp
     * @type {number}
     * @since 3.0.0
     */ timestamp: {
                    get: function() {
                        return this.pad.timestamp;
                    }
                },
                /**
     * Is the Gamepad's Left button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad left button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#left
     * @type {boolean}
     * @since 3.10.0
     */ left: {
                    get: function() {
                        return this._LCLeft.pressed;
                    }
                },
                /**
     * Is the Gamepad's Right button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad right button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#right
     * @type {boolean}
     * @since 3.10.0
     */ right: {
                    get: function() {
                        return this._LCRight.pressed;
                    }
                },
                /**
     * Is the Gamepad's Up button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad up button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#up
     * @type {boolean}
     * @since 3.10.0
     */ up: {
                    get: function() {
                        return this._LCTop.pressed;
                    }
                },
                /**
     * Is the Gamepad's Down button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad down button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#down
     * @type {boolean}
     * @since 3.10.0
     */ down: {
                    get: function() {
                        return this._LCBottom.pressed;
                    }
                },
                /**
     * Is the Gamepad's bottom button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the X button.
     * On an XBox controller it's the A button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#A
     * @type {boolean}
     * @since 3.10.0
     */ A: {
                    get: function() {
                        return this._RCBottom.pressed;
                    }
                },
                /**
     * Is the Gamepad's top button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Triangle button.
     * On an XBox controller it's the Y button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#Y
     * @type {boolean}
     * @since 3.10.0
     */ Y: {
                    get: function() {
                        return this._RCTop.pressed;
                    }
                },
                /**
     * Is the Gamepad's left button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Square button.
     * On an XBox controller it's the X button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#X
     * @type {boolean}
     * @since 3.10.0
     */ X: {
                    get: function() {
                        return this._RCLeft.pressed;
                    }
                },
                /**
     * Is the Gamepad's right button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Circle button.
     * On an XBox controller it's the B button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#B
     * @type {boolean}
     * @since 3.10.0
     */ B: {
                    get: function() {
                        return this._RCRight.pressed;
                    }
                },
                /**
     * Returns the value of the Gamepad's top left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L1 button.
     * On an XBox controller it's the LB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L1
     * @type {number}
     * @since 3.10.0
     */ L1: {
                    get: function() {
                        return this._FBLeftTop.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's bottom left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L2 button.
     * On an XBox controller it's the LT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L2
     * @type {number}
     * @since 3.10.0
     */ L2: {
                    get: function() {
                        return this._FBLeftBottom.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's top right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R1 button.
     * On an XBox controller it's the RB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R1
     * @type {number}
     * @since 3.10.0
     */ R1: {
                    get: function() {
                        return this._FBRightTop.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's bottom right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R2 button.
     * On an XBox controller it's the RT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R2
     * @type {number}
     * @since 3.10.0
     */ R2: {
                    get: function() {
                        return this._FBRightBottom.value;
                    }
                }
            });
            module1.exports = Gamepad;
        /***/ },
        /* 512 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(154);
            /**
 * @classdesc
 * A generic Key object which can be passed to the Process functions (and so on)
 * keycode must be an integer
 *
 * @class Key
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} plugin - The Keyboard Plugin instance that owns this Key object.
 * @param {number} keyCode - The keycode of this key.
 */ var Key = new Class({
                Extends: EventEmitter,
                initialize: function Key(plugin, keyCode) {
                    EventEmitter.call(this);
                    /**
         * The Keyboard Plugin instance that owns this Key object.
         *
         * @name Phaser.Input.Keyboard.Key#plugin
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.17.0
         */ this.plugin = plugin;
                    /**
         * The keycode of this key.
         *
         * @name Phaser.Input.Keyboard.Key#keyCode
         * @type {number}
         * @since 3.0.0
         */ this.keyCode = keyCode;
                    /**
         * The original DOM event.
         *
         * @name Phaser.Input.Keyboard.Key#originalEvent
         * @type {KeyboardEvent}
         * @since 3.0.0
         */ this.originalEvent = undefined;
                    /**
         * Can this Key be processed?
         *
         * @name Phaser.Input.Keyboard.Key#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * The "down" state of the key. This will remain `true` for as long as the keyboard thinks this key is held down.
         *
         * @name Phaser.Input.Keyboard.Key#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                    /**
         * The "up" state of the key. This will remain `true` for as long as the keyboard thinks this key is up.
         *
         * @name Phaser.Input.Keyboard.Key#isUp
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isUp = true;
                    /**
         * The down state of the ALT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#altKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.altKey = false;
                    /**
         * The down state of the CTRL key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#ctrlKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.ctrlKey = false;
                    /**
         * The down state of the SHIFT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#shiftKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shiftKey = false;
                    /**
         * The down state of the Meta key, if pressed at the same time as this key.
         * On a Mac the Meta Key is the Command key. On Windows keyboards, it's the Windows key.
         *
         * @name Phaser.Input.Keyboard.Key#metaKey
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.metaKey = false;
                    /**
         * The location of the modifier key. 0 for standard (or unknown), 1 for left, 2 for right, 3 for numpad.
         *
         * @name Phaser.Input.Keyboard.Key#location
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.location = 0;
                    /**
         * The timestamp when the key was last pressed down.
         *
         * @name Phaser.Input.Keyboard.Key#timeDown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeDown = 0;
                    /**
         * The number of milliseconds this key was held down for in the previous down - up sequence.
         * This value isn't updated every game step, only when the Key changes state.
         * To get the current duration use the `getDuration` method.
         *
         * @name Phaser.Input.Keyboard.Key#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * The timestamp when the key was last released.
         *
         * @name Phaser.Input.Keyboard.Key#timeUp
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeUp = 0;
                    /**
         * When a key is held down should it continuously fire the `down` event each time it repeats?
         * 
         * By default it will emit the `down` event just once, but if you wish to receive the event
         * for each repeat as well, enable this property.
         *
         * @name Phaser.Input.Keyboard.Key#emitOnRepeat
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.emitOnRepeat = false;
                    /**
         * If a key is held down this holds down the number of times the key has 'repeated'.
         *
         * @name Phaser.Input.Keyboard.Key#repeats
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeats = 0;
                    /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justDown
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justDown = false;
                    /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justUp
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justUp = false;
                    /**
         * Internal tick counter.
         *
         * @name Phaser.Input.Keyboard.Key#_tick
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._tick = -1;
                },
                /**
     * Controls if this Key will continuously emit a `down` event while being held down (true),
     * or emit the event just once, on first press, and then skip future events (false).
     *
     * @method Phaser.Input.Keyboard.Key#setEmitOnRepeat
     * @since 3.16.0
     * 
     * @param {boolean} value - Emit `down` events on repeated key down actions, or just once?
     * 
     * @return {this} This Key instance.
     */ setEmitOnRepeat: function(value) {
                    this.emitOnRepeat = value;
                    return this;
                },
                /**
     * Processes the Key Down action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onDown
     * @fires Phaser.Input.Keyboard.Events#DOWN
     * @since 3.16.0
     * 
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onDown: function(event) {
                    this.originalEvent = event;
                    if (!this.enabled) return;
                    this.altKey = event.altKey;
                    this.ctrlKey = event.ctrlKey;
                    this.shiftKey = event.shiftKey;
                    this.metaKey = event.metaKey;
                    this.location = event.location;
                    this.repeats++;
                    if (!this.isDown) {
                        this.isDown = true;
                        this.isUp = false;
                        this.timeDown = event.timeStamp;
                        this.duration = 0;
                        this._justDown = true;
                        this._justUp = false;
                        this.emit(Events.DOWN, this, event);
                    } else if (this.emitOnRepeat) this.emit(Events.DOWN, this, event);
                },
                /**
     * Processes the Key Up action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onUp
     * @fires Phaser.Input.Keyboard.Events#UP
     * @since 3.16.0
     * 
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onUp: function(event) {
                    this.originalEvent = event;
                    if (!this.enabled) return;
                    this.isDown = false;
                    this.isUp = true;
                    this.timeUp = event.timeStamp;
                    this.duration = this.timeUp - this.timeDown;
                    this.repeats = 0;
                    this._justDown = false;
                    this._justUp = true;
                    this._tick = -1;
                    this.emit(Events.UP, this, event);
                },
                /**
     * Resets this Key object back to its default un-pressed state.
     *
     * @method Phaser.Input.Keyboard.Key#reset
     * @since 3.6.0
     * 
     * @return {this} This Key instance.
     */ reset: function() {
                    this.preventDefault = true;
                    this.enabled = true;
                    this.isDown = false;
                    this.isUp = true;
                    this.altKey = false;
                    this.ctrlKey = false;
                    this.shiftKey = false;
                    this.metaKey = false;
                    this.timeDown = 0;
                    this.duration = 0;
                    this.timeUp = 0;
                    this.repeats = 0;
                    this._justDown = false;
                    this._justUp = false;
                    this._tick = -1;
                    return this;
                },
                /**
     * Returns the duration, in ms, that the Key has been held down for.
     * 
     * If the key is not currently down it will return zero.
     * 
     * The get the duration the Key was held down for in the previous up-down cycle,
     * use the `Key.duration` property value instead.
     *
     * @method Phaser.Input.Keyboard.Key#getDuration
     * @since 3.17.0
     * 
     * @return {number} The duration, in ms, that the Key has been held down for if currently down.
     */ getDuration: function() {
                    if (this.isDown) return this.plugin.game.loop.time - this.timeDown;
                    else return 0;
                },
                /**
     * Removes any bound event handlers and removes local references.
     *
     * @method Phaser.Input.Keyboard.Key#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.originalEvent = null;
                    this.plugin = null;
                }
            });
            module1.exports = Key;
        /***/ },
        /* 513 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(154);
            var GetFastValue = __webpack_require__(2);
            var ProcessKeyCombo = __webpack_require__(514);
            var ResetKeyCombo = __webpack_require__(516);
            /**
 * @classdesc
 * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
 * it will emit a `keycombomatch` event from the Keyboard Manager.
 *
 * The keys to be listened for can be defined as:
 *
 * A string (i.e. 'ATARI')
 * An array of either integers (key codes) or strings, or a mixture of both
 * An array of objects (such as Key objects) with a public 'keyCode' property
 *
 * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
 * you could pass the following array of key codes:
 *
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * Or, to listen for the user entering the word PHASER:
 *
 * ```javascript
 * this.input.keyboard.createCombo('PHASER');
 * ```
 *
 * @class KeyCombo
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @listens Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} keyboardPlugin - A reference to the Keyboard Plugin.
 * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
 * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
 */ var KeyCombo = new Class({
                initialize: function KeyCombo(keyboardPlugin, keys, config) {
                    if (config === undefined) config = {};
                    //  Can't have a zero or single length combo (string or array based)
                    if (keys.length < 2) return false;
                    /**
         * A reference to the Keyboard Manager
         *
         * @name Phaser.Input.Keyboard.KeyCombo#manager
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.0.0
         */ this.manager = keyboardPlugin;
                    /**
         * A flag that controls if this Key Combo is actively processing keys or not.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * An array of the keycodes that comprise this combo.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#keyCodes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.keyCodes = [];
                    //  if 'keys' is a string we need to get the keycode of each character in it
                    for(var i = 0; i < keys.length; i++){
                        var char = keys[i];
                        if (typeof char === "string") this.keyCodes.push(char.toUpperCase().charCodeAt(0));
                        else if (typeof char === "number") this.keyCodes.push(char);
                        else if (char.hasOwnProperty("keyCode")) this.keyCodes.push(char.keyCode);
                    }
                    /**
         * The current keyCode the combo is waiting for.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#current
         * @type {number}
         * @since 3.0.0
         */ this.current = this.keyCodes[0];
                    /**
         * The current index of the key being waited for in the 'keys' string.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#index
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.index = 0;
                    /**
         * The length of this combo (in keycodes)
         *
         * @name Phaser.Input.Keyboard.KeyCombo#size
         * @type {number}
         * @since 3.0.0
         */ this.size = this.keyCodes.length;
                    /**
         * The time the previous key in the combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeLastMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeLastMatched = 0;
                    /**
         * Has this Key Combo been matched yet?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#matched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.matched = false;
                    /**
         * The time the entire combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeMatched = 0;
                    /**
         * If they press the wrong key do we reset the combo?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnWrongKey
         * @type {boolean}
         * @default 0
         * @since 3.0.0
         */ this.resetOnWrongKey = GetFastValue(config, "resetOnWrongKey", true);
                    /**
         * The max delay in ms between each key press. Above this the combo is reset. 0 means disabled.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#maxKeyDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxKeyDelay = GetFastValue(config, "maxKeyDelay", 0);
                    /**
         * If previously matched and they press the first key of the combo again, will it reset?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.resetOnMatch = GetFastValue(config, "resetOnMatch", false);
                    /**
         * If the combo matches, will it delete itself?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#deleteOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.deleteOnMatch = GetFastValue(config, "deleteOnMatch", false);
                    var _this = this;
                    var onKeyDownHandler = function(event) {
                        if (_this.matched || !_this.enabled) return;
                        var matched = ProcessKeyCombo(event, _this);
                        if (matched) {
                            _this.manager.emit(Events.COMBO_MATCH, _this, event);
                            if (_this.resetOnMatch) ResetKeyCombo(_this);
                            else if (_this.deleteOnMatch) _this.destroy();
                        }
                    };
                    /**
         * The internal Key Down handler.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#onKeyDown
         * @private
         * @type {KeyboardKeydownCallback}
         * @fires Phaser.Input.Keyboard.Events#COMBO_MATCH
         * @since 3.0.0
         */ this.onKeyDown = onKeyDownHandler;
                    this.manager.on(Events.ANY_KEY_DOWN, this.onKeyDown);
                },
                /**
     * How far complete is this combo? A value between 0 and 1.
     *
     * @name Phaser.Input.Keyboard.KeyCombo#progress
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ progress: {
                    get: function() {
                        return this.index / this.size;
                    }
                },
                /**
     * Destroys this Key Combo and all of its references.
     *
     * @method Phaser.Input.Keyboard.KeyCombo#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enabled = false;
                    this.keyCodes = [];
                    this.manager.off(Events.ANY_KEY_DOWN, this.onKeyDown);
                    this.manager = null;
                }
            });
            module1.exports = KeyCombo;
        /***/ },
        /* 514 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AdvanceKeyCombo = __webpack_require__(515);
            /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ProcessKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to be processed.
 *
 * @return {boolean} `true` if the combo was matched, otherwise `false`.
 */ var ProcessKeyCombo = function(event, combo) {
                if (combo.matched) return true;
                var comboMatched = false;
                var keyMatched = false;
                if (event.keyCode === combo.current) {
                    //  Key was correct
                    if (combo.index > 0 && combo.maxKeyDelay > 0) {
                        //  We have to check to see if the delay between
                        //  the new key and the old one was too long (if enabled)
                        var timeLimit = combo.timeLastMatched + combo.maxKeyDelay;
                        //  Check if they pressed it in time or not
                        if (event.timeStamp <= timeLimit) {
                            keyMatched = true;
                            comboMatched = AdvanceKeyCombo(event, combo);
                        }
                    } else {
                        keyMatched = true;
                        //  We don't check the time for the first key pressed, so just advance it
                        comboMatched = AdvanceKeyCombo(event, combo);
                    }
                }
                if (!keyMatched && combo.resetOnWrongKey) {
                    //  Wrong key was pressed
                    combo.index = 0;
                    combo.current = combo.keyCodes[0];
                }
                if (comboMatched) {
                    combo.timeLastMatched = event.timeStamp;
                    combo.matched = true;
                    combo.timeMatched = event.timeStamp;
                }
                return comboMatched;
            };
            module1.exports = ProcessKeyCombo;
        /***/ },
        /* 515 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 * Return `true` if it reached the end of the combo, `false` if not.
 *
 * @function Phaser.Input.Keyboard.AdvanceKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to advance.
 *
 * @return {boolean} `true` if it reached the end of the combo, `false` if not.
 */ var AdvanceKeyCombo = function(event, combo) {
                combo.timeLastMatched = event.timeStamp;
                combo.index++;
                if (combo.index === combo.size) return true;
                else {
                    combo.current = combo.keyCodes[combo.index];
                    return false;
                }
            };
            module1.exports = AdvanceKeyCombo;
        /***/ },
        /* 516 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ResetKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo to reset.
 *
 * @return {Phaser.Input.Keyboard.KeyCombo} The KeyCombo.
 */ var ResetKeyCombo = function(combo) {
                combo.current = combo.keyCodes[0];
                combo.index = 0;
                combo.timeLastMatched = 0;
                combo.matched = false;
                combo.timeMatched = 0;
                return combo;
            };
            module1.exports = ResetKeyCombo;
        /***/ },
        /* 517 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MergeXHRSettings = __webpack_require__(240);
            /**
 * Creates a new XMLHttpRequest (xhr) object based on the given File and XHRSettings
 * and starts the download of it. It uses the Files own XHRSettings and merges them
 * with the global XHRSettings object to set the xhr values before download.
 *
 * @function Phaser.Loader.XHRLoader
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File to download.
 * @param {Phaser.Types.Loader.XHRSettingsObject} globalXHRSettings - The global XHRSettings object.
 *
 * @return {XMLHttpRequest} The XHR object.
 */ var XHRLoader = function(file, globalXHRSettings) {
                var config = MergeXHRSettings(globalXHRSettings, file.xhrSettings);
                var xhr = new XMLHttpRequest();
                xhr.open("GET", file.src, config.async, config.user, config.password);
                xhr.responseType = file.xhrSettings.responseType;
                xhr.timeout = config.timeout;
                if (config.headers) for(var key in config.headers)xhr.setRequestHeader(key, config.headers[key]);
                if (config.header && config.headerValue) xhr.setRequestHeader(config.header, config.headerValue);
                if (config.requestedWith) xhr.setRequestHeader("X-Requested-With", config.requestedWith);
                if (config.overrideMimeType) xhr.overrideMimeType(config.overrideMimeType);
                if (config.withCredentials) xhr.withCredentials = true;
                // After a successful request, the xhr.response property will contain the requested data as a DOMString, ArrayBuffer, Blob, or Document (depending on what was set for responseType.)
                xhr.onload = file.onLoad.bind(file, xhr);
                xhr.onerror = file.onError.bind(file, xhr);
                xhr.onprogress = file.onProgress.bind(file);
                //  This is the only standard method, the ones above are browser additions (maybe not universal?)
                // xhr.onreadystatechange
                xhr.send();
                return xhr;
            };
            module1.exports = XHRLoader;
        /***/ },
        /* 518 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var HTML5AudioFile = __webpack_require__(519);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {any} [urlConfig] - The absolute or relative URL to load this file from in a config object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {AudioContext} [audioContext] - The AudioContext this file will use to process itself.
 */ var AudioFile = new Class({
                Extends: File,
                initialize: //  URL is an object created by AudioFile.findAudioURL
                function AudioFile(loader, key, urlConfig, xhrSettings, audioContext) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        audioContext = GetFastValue(config, "context", audioContext);
                    }
                    var fileConfig = {
                        type: "audio",
                        cache: loader.cacheManager.audio,
                        extension: urlConfig.type,
                        responseType: "arraybuffer",
                        key: key,
                        url: urlConfig.url,
                        xhrSettings: xhrSettings,
                        config: {
                            context: audioContext
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AudioFile#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var _this = this;
                    // interesting read https://github.com/WebAudio/web-audio-api/issues/1305
                    this.config.context.decodeAudioData(this.xhrLoader.response, function(audioBuffer) {
                        _this.data = audioBuffer;
                        _this.onProcessComplete();
                    }, function(e) {
                        // eslint-disable-next-line no-console
                        console.error("Error decoding audio: " + _this.key + " - ", e ? e.message : null);
                        _this.onProcessError();
                    });
                    this.config.context = null;
                }
            });
            AudioFile.create = function(loader, key, urls, config, xhrSettings) {
                var game = loader.systems.game;
                var audioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                //  url may be inside key, which may be an object
                if (IsPlainObject(key)) {
                    urls = GetFastValue(key, "url", []);
                    config = GetFastValue(key, "config", {});
                }
                var urlConfig = AudioFile.getAudioURL(game, urls);
                if (!urlConfig) return null;
                // https://developers.google.com/web/updates/2012/02/HTML5-audio-and-the-Web-Audio-API-are-BFFs
                // var stream = GetFastValue(config, 'stream', false);
                if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new AudioFile(loader, key, urlConfig, xhrSettings, game.sound.context);
                else return new HTML5AudioFile(loader, key, urlConfig, config);
            };
            AudioFile.getAudioURL = function(game, urls) {
                if (!Array.isArray(urls)) urls = [
                    urls
                ];
                for(var i = 0; i < urls.length; i++){
                    var url = GetFastValue(urls[i], "url", urls[i]);
                    if (url.indexOf("blob:") === 0 || url.indexOf("data:") === 0) return {
                        url: url,
                        type: ""
                    };
                    var audioType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                    audioType = GetFastValue(urls[i], "type", audioType ? audioType[1] : "").toLowerCase();
                    if (game.device.audio[audioType]) return {
                        url: url,
                        type: audioType
                    };
                }
                return null;
            };
            /**
 * Adds an Audio or HTML5Audio file, or array of audio files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audio('title', [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audio({
 *     key: 'title',
 *     url: [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audio
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig|Phaser.Types.Loader.FileTypes.AudioFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[])} [urls] - The absolute or relative URL to load the audio files from.
 * @param {any} [config] - An object containing an `instances` property for HTML5Audio. Defaults to 1.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("audio", function(key, urls, config, xhrSettings) {
                var game = this.systems.game;
                var audioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                return this;
                var audioFile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    audioFile = AudioFile.create(this, key[i]);
                    if (audioFile) this.addFile(audioFile);
                }
                else {
                    audioFile = AudioFile.create(this, key, urls, config, xhrSettings);
                    if (audioFile) this.addFile(audioFile);
                }
                return this;
            });
            module1.exports = AudioFile;
        /***/ },
        /* 519 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(95);
            var File = __webpack_require__(23);
            var GetFastValue = __webpack_require__(2);
            var GetURL = __webpack_require__(155);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class HTML5AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [urlConfig] - The absolute or relative URL to load this file from.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTML5AudioFile = new Class({
                Extends: File,
                initialize: function HTML5AudioFile(loader, key, urlConfig, audioConfig) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        audioConfig = GetFastValue(config, "config", audioConfig);
                    }
                    var fileConfig = {
                        type: "audio",
                        cache: loader.cacheManager.audio,
                        extension: urlConfig.type,
                        key: key,
                        url: urlConfig.url,
                        config: audioConfig
                    };
                    File.call(this, loader, fileConfig);
                    //  New properties specific to this class
                    this.locked = "ontouchstart" in window;
                    this.loaded = false;
                    this.filesLoaded = 0;
                    this.filesTotal = 0;
                },
                /**
     * Called when the file finishes loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onLoad
     * @since 3.0.0
     */ onLoad: function() {
                    if (this.loaded) return;
                    this.loaded = true;
                    this.loader.nextFile(this, true);
                },
                /**
     * Called if the file errors while loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onError
     * @since 3.0.0
     */ onError: function() {
                    for(var i = 0; i < this.data.length; i++){
                        var audio = this.data[i];
                        audio.oncanplaythrough = null;
                        audio.onerror = null;
                    }
                    this.loader.nextFile(this, false);
                },
                /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     */ onProgress: function(event) {
                    var audio = event.target;
                    audio.oncanplaythrough = null;
                    audio.onerror = null;
                    this.filesLoaded++;
                    this.percentComplete = Math.min(this.filesLoaded / this.filesTotal, 1);
                    this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                    if (this.filesLoaded === this.filesTotal) this.onLoad();
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#load
     * @since 3.0.0
     */ load: function() {
                    this.data = [];
                    var instances = this.config && this.config.instances || 1;
                    this.filesTotal = instances;
                    this.filesLoaded = 0;
                    this.percentComplete = 0;
                    for(var i = 0; i < instances; i++){
                        var audio = new Audio();
                        if (!audio.dataset) audio.dataset = {};
                        audio.dataset.name = this.key + ("0" + i).slice(-2);
                        audio.dataset.used = "false";
                        if (this.locked) audio.dataset.locked = "true";
                        else {
                            audio.dataset.locked = "false";
                            audio.preload = "auto";
                            audio.oncanplaythrough = this.onProgress.bind(this);
                            audio.onerror = this.onError.bind(this);
                        }
                        this.data.push(audio);
                    }
                    for(i = 0; i < this.data.length; i++){
                        audio = this.data[i];
                        audio.src = GetURL(this, this.loader.baseURL);
                        if (!this.locked) audio.load();
                    }
                    if (this.locked) //  This is super-dangerous but works. Race condition potential high.
                    //  Is there another way?
                    setTimeout(this.onLoad.bind(this));
                }
            });
            module1.exports = HTML5AudioFile;
        /***/ },
        /* 520 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#script method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#script.
 *
 * @class ScriptFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScriptFile = new Class({
                Extends: File,
                initialize: function ScriptFile(loader, key, url, xhrSettings) {
                    var extension = "js";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "script",
                        cache: false,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScriptFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = document.createElement("script");
                    this.data.language = "javascript";
                    this.data.type = "text/javascript";
                    this.data.defer = false;
                    this.data.text = this.xhrLoader.responseText;
                    document.head.appendChild(this.data);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Script file, or array of Script files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.script('aliens', 'lib/aliens.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.script({
 *     key: 'aliens',
 *     url: 'lib/aliens.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScriptFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#script
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig|Phaser.Types.Loader.FileTypes.ScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("script", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ScriptFile(this, key[i]));
                else this.addFile(new ScriptFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = ScriptFile;
        /***/ },
        /* 521 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeImage = __webpack_require__(522);
            var ArcadeSprite = __webpack_require__(157);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(62);
            var PhysicsGroup = __webpack_require__(524);
            var StaticPhysicsGroup = __webpack_require__(525);
            /**
 * @classdesc
 * The Arcade Physics Factory allows you to easily create Arcade Physics enabled Game Objects.
 * Objects that are created by this Factory are automatically added to the physics world.
 *
 * @class Factory
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics World instance.
 */ var Factory = new Class({
                initialize: function Factory(world) {
                    /**
         * A reference to the Arcade Physics World.
         *
         * @name Phaser.Physics.Arcade.Factory#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * A reference to the Scene this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                    /**
         * A reference to the Scene.Systems this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                },
                /**
     * Creates a new Arcade Physics Collider object.
     *
     * @method Phaser.Physics.Arcade.Factory#collider
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object1 - The first object to check for collision.
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ collider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    return this.world.addCollider(object1, object2, collideCallback, processCallback, callbackContext);
                },
                /**
     * Creates a new Arcade Physics Collider Overlap object.
     *
     * @method Phaser.Physics.Arcade.Factory#overlap
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object1 - The first object to check for overlap.
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object2 - The second object to check for overlap.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ overlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    return this.world.addOverlap(object1, object2, collideCallback, processCallback, callbackContext);
                },
                /**
     * Adds an Arcade Physics Body to the given Game Object.
     *
     * @method Phaser.Physics.Arcade.Factory#existing
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A Game Object.
     * @param {boolean} [isStatic=false] - Create a Static body (true) or Dynamic body (false).
     *
     * @return {Phaser.Types.Physics.Arcade.GameObjectWithBody} The Game Object.
     */ existing: function(gameObject, isStatic) {
                    var type = isStatic ? CONST.STATIC_BODY : CONST.DYNAMIC_BODY;
                    this.world.enableBody(gameObject, type);
                    return gameObject;
                },
                /**
     * Creates a new Arcade Image object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticImage
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithStaticBody} The Image object that was created.
     */ staticImage: function(x, y, key, frame) {
                    var image = new ArcadeImage(this.scene, x, y, key, frame);
                    this.sys.displayList.add(image);
                    this.world.enableBody(image, CONST.STATIC_BODY);
                    return image;
                },
                /**
     * Creates a new Arcade Image object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithDynamicBody} The Image object that was created.
     */ image: function(x, y, key, frame) {
                    var image = new ArcadeImage(this.scene, x, y, key, frame);
                    this.sys.displayList.add(image);
                    this.world.enableBody(image, CONST.DYNAMIC_BODY);
                    return image;
                },
                /**
     * Creates a new Arcade Sprite object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticSprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithStaticBody} The Sprite object that was created.
     */ staticSprite: function(x, y, key, frame) {
                    var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    this.world.enableBody(sprite, CONST.STATIC_BODY);
                    return sprite;
                },
                /**
     * Creates a new Arcade Sprite object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody} The Sprite object that was created.
     */ sprite: function(x, y, key, frame) {
                    var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    this.world.enableBody(sprite, CONST.DYNAMIC_BODY);
                    return sprite;
                },
                /**
     * Creates a Static Physics Group object.
     * All Game Objects created by this Group will automatically be static Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#staticGroup
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} The Static Group object that was created.
     */ staticGroup: function(children, config) {
                    return this.sys.updateList.add(new StaticPhysicsGroup(this.world, this.world.scene, children, config));
                },
                /**
     * Creates a Physics Group object.
     * All Game Objects created by this Group will automatically be dynamic Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#group
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.Group} The Group object that was created.
     */ group: function(children, config) {
                    return this.sys.updateList.add(new PhysicsGroup(this.world, this.world.scene, children, config));
                },
                /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Arcade.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.world = null;
                    this.scene = null;
                    this.sys = null;
                }
            });
            module1.exports = Factory;
        /***/ },
        /* 522 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(243);
            var Image1 = __webpack_require__(125);
            /**
 * @classdesc
 * An Arcade Physics Image is an Image with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Image and an Arcade Sprite is that you cannot animate an Arcade Image.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeImage = new Class({
                Extends: Image1,
                Mixins: [
                    Components.Acceleration,
                    Components.Angular,
                    Components.Bounce,
                    Components.Debug,
                    Components.Drag,
                    Components.Enable,
                    Components.Friction,
                    Components.Gravity,
                    Components.Immovable,
                    Components.Mass,
                    Components.Pushable,
                    Components.Size,
                    Components.Velocity
                ],
                initialize: function ArcadeImage(scene, x, y, texture, frame) {
                    Image1.call(this, scene, x, y, texture, frame);
                    /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Image#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                }
            });
            module1.exports = ArcadeImage;
        /***/ },
        /* 523 */ /***/ function(module1, exports, __webpack_require__) {
            var OverlapRect = __webpack_require__(244);
            var Circle = __webpack_require__(65);
            var CircleToCircle = __webpack_require__(231);
            var CircleToRectangle = __webpack_require__(151);
            /**
 * This method will search the given circular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 *
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 *
 * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapCirc
 * @since 3.21.0
 *
 * @param {number} x - The x coordinate of the center of the area to search within.
 * @param {number} y - The y coordinate of the center of the area to search within.
 * @param {number} radius - The radius of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapCirc = function(world, x, y, radius, includeDynamic, includeStatic) {
                var bodiesInRect = OverlapRect(world, x - radius, y - radius, 2 * radius, 2 * radius, includeDynamic, includeStatic);
                if (bodiesInRect.length === 0) return bodiesInRect;
                var area = new Circle(x, y, radius);
                var circFromBody = new Circle();
                var bodiesInArea = [];
                for(var i = 0; i < bodiesInRect.length; i++){
                    var body = bodiesInRect[i];
                    if (body.isCircle) {
                        circFromBody.setTo(body.center.x, body.center.y, body.halfWidth);
                        if (CircleToCircle(area, circFromBody)) bodiesInArea.push(body);
                    } else if (CircleToRectangle(area, body)) bodiesInArea.push(body);
                }
                return bodiesInArea;
            };
            module1.exports = OverlapCirc;
        /***/ },
        /* 524 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(157);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(62);
            var GetFastValue = __webpack_require__(2);
            var Group = __webpack_require__(113);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An Arcade Physics Group object.
 *
 * The primary use of a Physics Group is a way to collect together physics enable objects
 * that share the same intrinsic structure into a single pool. They can they be easily
 * compared against other Groups, or Game Objects.
 *
 * All Game Objects created by, or added to this Group will automatically be given **dynamic**
 * Arcade Physics bodies (if they have no body already) and the bodies will receive the
 * Groups {@link Phaser.Physics.Arcade.Group#defaults default values}.
 *
 * You should not pass objects into this Group that should not receive a body. For example,
 * do not add basic Geometry or Tilemap Layers into a Group, as they will not behave in the
 * way you may expect. Groups should all ideally have objects of the same type in them.
 *
 * If you wish to create a Group filled with Static Bodies, please see {@link Phaser.Physics.Arcade.StaticGroup}.
 *
 * @class Group
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var PhysicsGroup = new Class({
                Extends: Group,
                initialize: function PhysicsGroup(world, scene, children, config) {
                    if (!children && !config) config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    else if (IsPlainObject(children)) {
                        //  children is a plain object, so swizzle them:
                        config = children;
                        children = null;
                        config.internalCreateCallback = this.createCallbackHandler;
                        config.internalRemoveCallback = this.removeCallbackHandler;
                    } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                        //  children is an array of plain objects (i.e., configs)
                        config = children[0];
                        var _this = this;
                        children.forEach(function(singleConfig) {
                            singleConfig.internalCreateCallback = _this.createCallbackHandler;
                            singleConfig.internalRemoveCallback = _this.removeCallbackHandler;
                        });
                        children = null;
                    } else // config is not defined and children is not a plain object nor an array of plain objects
                    config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.Group#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The class to create new Group members from.
         *
         * This should be either `Phaser.Physics.Arcade.Image`, `Phaser.Physics.Arcade.Sprite`, or a class extending one of those.
         *
         * @name Phaser.Physics.Arcade.Group#classType
         * @type {Function}
         * @default ArcadeSprite
         * @since 3.0.0
         */ config.classType = GetFastValue(config, "classType", ArcadeSprite);
                    /**
         * The physics type of the Group's members.
         *
         * @name Phaser.Physics.Arcade.Group#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                    /**
         * Default physics properties applied to Game Objects added to the Group or created by the Group. Derived from the `config` argument.
         *
         * You can remove the default values by setting this property to `{}`.
         *
         * @name Phaser.Physics.Arcade.Group#defaults
         * @type {Phaser.Types.Physics.Arcade.PhysicsGroupDefaults}
         * @since 3.0.0
         */ this.defaults = {
                        setCollideWorldBounds: GetFastValue(config, "collideWorldBounds", false),
                        setBoundsRectangle: GetFastValue(config, "customBoundsRectangle", null),
                        setAccelerationX: GetFastValue(config, "accelerationX", 0),
                        setAccelerationY: GetFastValue(config, "accelerationY", 0),
                        setAllowDrag: GetFastValue(config, "allowDrag", true),
                        setAllowGravity: GetFastValue(config, "allowGravity", true),
                        setAllowRotation: GetFastValue(config, "allowRotation", true),
                        setBounceX: GetFastValue(config, "bounceX", 0),
                        setBounceY: GetFastValue(config, "bounceY", 0),
                        setDragX: GetFastValue(config, "dragX", 0),
                        setDragY: GetFastValue(config, "dragY", 0),
                        setEnable: GetFastValue(config, "enable", true),
                        setGravityX: GetFastValue(config, "gravityX", 0),
                        setGravityY: GetFastValue(config, "gravityY", 0),
                        setFrictionX: GetFastValue(config, "frictionX", 0),
                        setFrictionY: GetFastValue(config, "frictionY", 0),
                        setMaxVelocityX: GetFastValue(config, "maxVelocityX", 10000),
                        setMaxVelocityY: GetFastValue(config, "maxVelocityY", 10000),
                        setVelocityX: GetFastValue(config, "velocityX", 0),
                        setVelocityY: GetFastValue(config, "velocityY", 0),
                        setAngularVelocity: GetFastValue(config, "angularVelocity", 0),
                        setAngularAcceleration: GetFastValue(config, "angularAcceleration", 0),
                        setAngularDrag: GetFastValue(config, "angularDrag", 0),
                        setMass: GetFastValue(config, "mass", 1),
                        setImmovable: GetFastValue(config, "immovable", false)
                    };
                    Group.call(this, scene, children, config);
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.Group#type
         * @type {string}
         * @default 'PhysicsGroup'
         * @since 3.21.0
         */ this.type = "PhysicsGroup";
                },
                /**
     * Enables a Game Object's Body and assigns `defaults`. Called when a Group member is added or created.
     *
     * @method Phaser.Physics.Arcade.Group#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being added.
     */ createCallbackHandler: function(child) {
                    if (!child.body) this.world.enableBody(child, CONST.DYNAMIC_BODY);
                    var body = child.body;
                    for(var key in this.defaults)body[key](this.defaults[key]);
                },
                /**
     * Disables a Game Object's Body. Called when a Group member is removed.
     *
     * @method Phaser.Physics.Arcade.Group#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being removed.
     */ removeCallbackHandler: function(child) {
                    if (child.body) this.world.disableBody(child);
                },
                /**
     * Sets the velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity.
     * @param {number} y - The vertical velocity.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x, y), the second (x + step, y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocity: function(x, y, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.set(x + i * step, y + i * step);
                    return this;
                },
                /**
     * Sets the horizontal velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x), the second (x + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityX: function(value, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.x = value + i * step;
                    return this;
                },
                /**
     * Sets the vertical velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (y), the second (y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityY: function(value, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.y = value + i * step;
                    return this;
                }
            });
            module1.exports = PhysicsGroup;
        /***/ },
        /* 525 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(157);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(62);
            var GetFastValue = __webpack_require__(2);
            var Group = __webpack_require__(113);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An Arcade Physics Static Group object.
 *
 * All Game Objects created by or added to this Group will automatically be given static Arcade Physics bodies, if they have no body.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Group}.
 *
 * @class StaticGroup
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var StaticPhysicsGroup = new Class({
                Extends: Group,
                initialize: function StaticPhysicsGroup(world, scene, children, config) {
                    if (!children && !config) config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler,
                        createMultipleCallback: this.createMultipleCallbackHandler,
                        classType: ArcadeSprite
                    };
                    else if (IsPlainObject(children)) {
                        //  children is a plain object, so swizzle them:
                        config = children;
                        children = null;
                        config.internalCreateCallback = this.createCallbackHandler;
                        config.internalRemoveCallback = this.removeCallbackHandler;
                        config.createMultipleCallback = this.createMultipleCallbackHandler;
                        config.classType = GetFastValue(config, "classType", ArcadeSprite);
                    } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                        //  children is an array of plain objects
                        config = children;
                        children = null;
                        config.forEach(function(singleConfig) {
                            singleConfig.internalCreateCallback = this.createCallbackHandler;
                            singleConfig.internalRemoveCallback = this.removeCallbackHandler;
                            singleConfig.createMultipleCallback = this.createMultipleCallbackHandler;
                            singleConfig.classType = GetFastValue(singleConfig, "classType", ArcadeSprite);
                        });
                    } else // config is not defined and children is not a plain object nor an array of plain objects
                    config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The scene this group belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                    Group.call(this, scene, children, config);
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#type
         * @type {string}
         * @default 'StaticPhysicsGroup'
         * @since 3.21.0
         */ this.type = "StaticPhysicsGroup";
                },
                /**
     * Adds a static physics body to the new group member (if it lacks one) and adds it to the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The new group member.
     *
     * @see Phaser.Physics.Arcade.World#enableBody
     */ createCallbackHandler: function(child) {
                    if (!child.body) this.world.enableBody(child, CONST.STATIC_BODY);
                },
                /**
     * Disables the group member's physics body, removing it from the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The group member being removed.
     *
     * @see Phaser.Physics.Arcade.World#disableBody
     */ removeCallbackHandler: function(child) {
                    if (child.body) this.world.disableBody(child);
                },
                /**
     * Refreshes the group.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createMultipleCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} entries - The newly created group members.
     *
     * @see Phaser.Physics.Arcade.StaticGroup#refresh
     */ createMultipleCallbackHandler: function() {
                    this.refresh();
                },
                /**
     * Resets each Body to the position of its parent Game Object.
     * Body sizes aren't changed (use {@link Phaser.Physics.Arcade.Components.Enable#refreshBody} for that).
     *
     * @method Phaser.Physics.Arcade.StaticGroup#refresh
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} This group.
     *
     * @see Phaser.Physics.Arcade.StaticBody#reset
     */ refresh: function() {
                    var children = this.children.entries;
                    for(var i = 0; i < children.length; i++)children[i].body.reset();
                    return this;
                }
            });
            module1.exports = StaticPhysicsGroup;
        /***/ },
        /* 526 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AngleBetweenPoints = __webpack_require__(350);
            var Body = __webpack_require__(527);
            var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Collider = __webpack_require__(528);
            var CONST = __webpack_require__(62);
            var DistanceBetween = __webpack_require__(50);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(245);
            var FuzzyEqual = __webpack_require__(124);
            var FuzzyGreaterThan = __webpack_require__(354);
            var FuzzyLessThan = __webpack_require__(355);
            var GetOverlapX = __webpack_require__(246);
            var GetOverlapY = __webpack_require__(247);
            var GetTilesWithinWorldXY = __webpack_require__(529);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            var ProcessQueue = __webpack_require__(211);
            var ProcessTileCallbacks = __webpack_require__(530);
            var Rectangle = __webpack_require__(10);
            var RTree = __webpack_require__(531);
            var SeparateTile = __webpack_require__(532);
            var SeparateX = __webpack_require__(537);
            var SeparateY = __webpack_require__(538);
            var Set = __webpack_require__(149);
            var StaticBody = __webpack_require__(539);
            var TileIntersectsBody = __webpack_require__(248);
            var TransformMatrix = __webpack_require__(25);
            var Vector2 = __webpack_require__(3);
            var Wrap = __webpack_require__(68);
            /**
 * @classdesc
 * The Arcade Physics World.
 *
 * The World is responsible for creating, managing, colliding and updating all of the bodies within it.
 *
 * An instance of the World belongs to a Phaser.Scene and is accessed via the property `physics.world`.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this World instance belongs.
 * @param {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} config - An Arcade Physics Configuration object.
 */ var World = new Class({
                Extends: EventEmitter,
                initialize: function World(scene, config) {
                    EventEmitter.call(this);
                    /**
         * The Scene this simulation belongs to.
         *
         * @name Phaser.Physics.Arcade.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Dynamic Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#bodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.Body>}
         * @since 3.0.0
         */ this.bodies = new Set();
                    /**
         * Static Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#staticBodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.StaticBody>}
         * @since 3.0.0
         */ this.staticBodies = new Set();
                    /**
         * Static Bodies marked for deletion.
         *
         * @name Phaser.Physics.Arcade.World#pendingDestroy
         * @type {Phaser.Structs.Set.<(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)>}
         * @since 3.1.0
         */ this.pendingDestroy = new Set();
                    /**
         * This simulation's collision processors.
         *
         * @name Phaser.Physics.Arcade.World#colliders
         * @type {Phaser.Structs.ProcessQueue.<Phaser.Physics.Arcade.Collider>}
         * @since 3.0.0
         */ this.colliders = new ProcessQueue();
                    /**
         * Acceleration of Bodies due to gravity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.World#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.gravity = new Vector2(GetValue(config, "gravity.x", 0), GetValue(config, "gravity.y", 0));
                    /**
         * A boundary constraining Bodies.
         *
         * @name Phaser.Physics.Arcade.World#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.0.0
         */ this.bounds = new Rectangle(GetValue(config, "x", 0), GetValue(config, "y", 0), GetValue(config, "width", scene.sys.scale.width), GetValue(config, "height", scene.sys.scale.height));
                    /**
         * The boundary edges that Bodies can collide with.
         *
         * @name Phaser.Physics.Arcade.World#checkCollision
         * @type {Phaser.Types.Physics.Arcade.CheckCollisionObject}
         * @since 3.0.0
         */ this.checkCollision = {
                        up: GetValue(config, "checkCollision.up", true),
                        down: GetValue(config, "checkCollision.down", true),
                        left: GetValue(config, "checkCollision.left", true),
                        right: GetValue(config, "checkCollision.right", true)
                    };
                    /**
         * The number of physics steps to be taken per second.
         *
         * This property is read-only. Use the `setFPS` method to modify it at run-time.
         *
         * @name Phaser.Physics.Arcade.World#fps
         * @readonly
         * @type {number}
         * @default 60
         * @since 3.10.0
         */ this.fps = GetValue(config, "fps", 60);
                    /**
         * Should Physics use a fixed update time-step (true) or sync to the render fps (false)?.
         * False value of this property disables fps and timeScale properties.
         *
         * @name Phaser.Physics.Arcade.World#fixedStep
         * @type {boolean}
         * @default true
         * @since 3.23.0
         */ this.fixedStep = GetValue(config, "fixedStep", true);
                    /**
         * The amount of elapsed ms since the last frame.
         *
         * @name Phaser.Physics.Arcade.World#_elapsed
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._elapsed = 0;
                    /**
         * Internal frame time value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTime
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTime = 1 / this.fps;
                    /**
         * Internal frame time ms value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTimeMS
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTimeMS = 1000 * this._frameTime;
                    /**
         * The number of steps that took place in the last frame.
         *
         * @name Phaser.Physics.Arcade.World#stepsLastFrame
         * @readonly
         * @type {number}
         * @since 3.10.0
         */ this.stepsLastFrame = 0;
                    /**
         * Scaling factor applied to the frame rate.
         *
         * - 1.0 = normal speed
         * - 2.0 = half speed
         * - 0.5 = double speed
         *
         * @name Phaser.Physics.Arcade.World#timeScale
         * @type {number}
         * @default 1
         * @since 3.10.0
         */ this.timeScale = GetValue(config, "timeScale", 1);
                    /**
         * The maximum absolute difference of a Body's per-step velocity and its overlap with another Body that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         *
         * @name Phaser.Physics.Arcade.World#OVERLAP_BIAS
         * @type {number}
         * @default 4
         * @since 3.0.0
         */ this.OVERLAP_BIAS = GetValue(config, "overlapBias", 4);
                    /**
         * The maximum absolute value of a Body's overlap with a tile that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         * The optimum value may be similar to the tile size.
         *
         * @name Phaser.Physics.Arcade.World#TILE_BIAS
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.TILE_BIAS = GetValue(config, "tileBias", 16);
                    /**
         * Always separate overlapping Bodies horizontally before vertically.
         * False (the default) means Bodies are first separated on the axis of greater gravity, or the vertical axis if neither is greater.
         *
         * @name Phaser.Physics.Arcade.World#forceX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.forceX = GetValue(config, "forceX", false);
                    /**
         * Whether the simulation advances with the game loop.
         *
         * @name Phaser.Physics.Arcade.World#isPaused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPaused = GetValue(config, "isPaused", false);
                    /**
         * Temporary total of colliding Bodies.
         *
         * @name Phaser.Physics.Arcade.World#_total
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._total = 0;
                    /**
         * Enables the debug display.
         *
         * @name Phaser.Physics.Arcade.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = GetValue(config, "debug", false);
                    /**
         * The graphics object drawing the debug display.
         *
         * @name Phaser.Physics.Arcade.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                    /**
         * Default debug display settings for new Bodies.
         *
         * @name Phaser.Physics.Arcade.World#defaults
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldDefaults}
         * @since 3.0.0
         */ this.defaults = {
                        debugShowBody: GetValue(config, "debugShowBody", true),
                        debugShowStaticBody: GetValue(config, "debugShowStaticBody", true),
                        debugShowVelocity: GetValue(config, "debugShowVelocity", true),
                        bodyDebugColor: GetValue(config, "debugBodyColor", 0xff00ff),
                        staticBodyDebugColor: GetValue(config, "debugStaticBodyColor", 0x0000ff),
                        velocityDebugColor: GetValue(config, "debugVelocityColor", 0x00ff00)
                    };
                    /**
         * The maximum number of items per node on the RTree.
         *
         * This is ignored if `useTree` is `false`. If you have a large number of bodies in
         * your world then you may find search performance improves by increasing this value,
         * to allow more items per node and less node division.
         *
         * @name Phaser.Physics.Arcade.World#maxEntries
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.maxEntries = GetValue(config, "maxEntries", 16);
                    /**
         * Should this Arcade Physics World use an RTree for Dynamic bodies?
         *
         * An RTree is a fast way of spatially sorting of all the bodies in the world.
         * However, at certain limits, the cost of clearing and inserting the bodies into the
         * tree every frame becomes more expensive than the search speed gains it provides.
         *
         * If you have a large number of dynamic bodies in your world then it may be best to
         * disable the use of the RTree by setting this property to `false` in the physics config.
         *
         * The number it can cope with depends on browser and device, but a conservative estimate
         * of around 5,000 bodies should be considered the max before disabling it.
         *
         * This only applies to dynamic bodies. Static bodies are always kept in an RTree,
         * because they don't have to be cleared every frame, so you benefit from the
         * massive search speeds all the time.
         *
         * @name Phaser.Physics.Arcade.World#useTree
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.useTree = GetValue(config, "useTree", true);
                    /**
         * The spatial index of Dynamic Bodies.
         *
         * @name Phaser.Physics.Arcade.World#tree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.tree = new RTree(this.maxEntries);
                    /**
         * The spatial index of Static Bodies.
         *
         * @name Phaser.Physics.Arcade.World#staticTree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.staticTree = new RTree(this.maxEntries);
                    /**
         * Recycled input for tree searches.
         *
         * @name Phaser.Physics.Arcade.World#treeMinMax
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldTreeMinMax}
         * @since 3.0.0
         */ this.treeMinMax = {
                        minX: 0,
                        minY: 0,
                        maxX: 0,
                        maxY: 0
                    };
                    /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix = new TransformMatrix();
                    /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                    if (this.drawDebug) this.createDebugGraphic();
                },
                /**
     * Adds an Arcade Physics Body to a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `enableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * You can specify if the bodies are to be Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to create the bodies.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     */ enable: function(object, bodyType) {
                    if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entry = object[i];
                        if (entry.isParent) {
                            var children = entry.getChildren();
                            for(var c = 0; c < children.length; c++){
                                var child = children[c];
                                if (child.isParent) //  Handle Groups nested inside of Groups
                                this.enable(child, bodyType);
                                else this.enableBody(child, bodyType);
                            }
                        } else this.enableBody(entry, bodyType);
                    }
                },
                /**
     * Creates an Arcade Physics Body on a single Game Object.
     *
     * If the Game Object already has a body, this method will simply add it back into the simulation.
     *
     * You can specify if the body is Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enableBody
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} object - The Game Object on which to create the body.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object on which the body was created.
     */ enableBody: function(object, bodyType) {
                    if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                    if (!object.body) {
                        if (bodyType === CONST.DYNAMIC_BODY) object.body = new Body(this, object);
                        else if (bodyType === CONST.STATIC_BODY) object.body = new StaticBody(this, object);
                    }
                    this.add(object.body);
                    return object;
                },
                /**
     * Adds an existing Arcade Physics Body or StaticBody to the simulation.
     *
     * The body is enabled and added to the local search trees.
     *
     * @method Phaser.Physics.Arcade.World#add
     * @since 3.10.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be added to the simulation.
     *
     * @return {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} The Body that was added to the simulation.
     */ add: function(body) {
                    if (body.physicsType === CONST.DYNAMIC_BODY) this.bodies.set(body);
                    else if (body.physicsType === CONST.STATIC_BODY) {
                        this.staticBodies.set(body);
                        this.staticTree.insert(body);
                    }
                    body.enable = true;
                    return body;
                },
                /**
     * Disables the Arcade Physics Body of a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `disableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to disable the bodies.
     */ disable: function(object) {
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entry = object[i];
                        if (entry.isParent) {
                            var children = entry.getChildren();
                            for(var c = 0; c < children.length; c++){
                                var child = children[c];
                                if (child.isParent) //  Handle Groups nested inside of Groups
                                this.disable(child);
                                else this.disableBody(child.body);
                            }
                        } else this.disableBody(entry.body);
                    }
                },
                /**
     * Disables an existing Arcade Physics Body or StaticBody and removes it from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disableBody
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be disabled.
     */ disableBody: function(body) {
                    this.remove(body);
                    body.enable = false;
                },
                /**
     * Removes an existing Arcade Physics Body or StaticBody from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enabled` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `enable` or `add`.
     *
     * @method Phaser.Physics.Arcade.World#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The body to be removed from the simulation.
     */ remove: function(body) {
                    if (body.physicsType === CONST.DYNAMIC_BODY) {
                        this.tree.remove(body);
                        this.bodies.delete(body);
                    } else if (body.physicsType === CONST.STATIC_BODY) {
                        this.staticBodies.delete(body);
                        this.staticTree.remove(body);
                    }
                },
                /**
     * Creates a Graphics Game Object that the world will use to render the debug display to.
     *
     * This is called automatically when the World is instantiated if the `debug` config property
     * was set to `true`. However, you can call it at any point should you need to display the
     * debug Graphic from a fixed point.
     *
     * You can control which objects are drawn to the Graphics object, and the colors they use,
     * by setting the debug properties in the physics config.
     *
     * You should not typically use this in a production game. Use it to aid during debugging.
     *
     * @method Phaser.Physics.Arcade.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object that was created for use by the World.
     */ createDebugGraphic: function() {
                    var graphic = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    graphic.setDepth(Number.MAX_VALUE);
                    this.debugGraphic = graphic;
                    this.drawDebug = true;
                    return graphic;
                },
                /**
     * Sets the position, size and properties of the World boundary.
     *
     * The World boundary is an invisible rectangle that defines the edges of the World.
     * If a Body is set to collide with the world bounds then it will automatically stop
     * when it reaches any of the edges. You can optionally set which edges of the boundary
     * should be checked against.
     *
     * @method Phaser.Physics.Arcade.World#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the boundary.
     * @param {number} y - The top-left y coordinate of the boundary.
     * @param {number} width - The width of the boundary.
     * @param {number} height - The height of the boundary.
     * @param {boolean} [checkLeft] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [checkRight] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [checkUp] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [checkDown] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBounds: function(x, y, width, height, checkLeft, checkRight, checkUp, checkDown) {
                    this.bounds.setTo(x, y, width, height);
                    if (checkLeft !== undefined) this.setBoundsCollision(checkLeft, checkRight, checkUp, checkDown);
                    return this;
                },
                /**
     * Enables or disables collisions on each edge of the World boundary.
     *
     * @method Phaser.Physics.Arcade.World#setBoundsCollision
     * @since 3.0.0
     *
     * @param {boolean} [left=true] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [right=true] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [up=true] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [down=true] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBoundsCollision: function(left, right, up, down) {
                    if (left === undefined) left = true;
                    if (right === undefined) right = true;
                    if (up === undefined) up = true;
                    if (down === undefined) down = true;
                    this.checkCollision.left = left;
                    this.checkCollision.right = right;
                    this.checkCollision.up = up;
                    this.checkCollision.down = down;
                    return this;
                },
                /**
     * Pauses the simulation.
     *
     * A paused simulation does not update any existing bodies, or run any Colliders.
     *
     * However, you can still enable and disable bodies within it, or manually run collide or overlap
     * checks.
     *
     * @method Phaser.Physics.Arcade.World#pause
     * @fires Phaser.Physics.Arcade.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ pause: function() {
                    this.isPaused = true;
                    this.emit(Events.PAUSE);
                    return this;
                },
                /**
     * Resumes the simulation, if paused.
     *
     * @method Phaser.Physics.Arcade.World#resume
     * @fires Phaser.Physics.Arcade.Events#RESUME
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ resume: function() {
                    this.isPaused = false;
                    this.emit(Events.RESUME);
                    return this;
                },
                /**
     * Creates a new Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform collision checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.collide` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addCollider
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.World#collide
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addCollider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    var collider = new Collider(this, false, object1, object2, collideCallback, processCallback, callbackContext);
                    this.colliders.add(collider);
                    return collider;
                },
                /**
     * Creates a new Overlap Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform overlap checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.overlap` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addOverlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for overlap.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects overlap. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addOverlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    var collider = new Collider(this, true, object1, object2, collideCallback, processCallback, callbackContext);
                    this.colliders.add(collider);
                    return collider;
                },
                /**
     * Removes a Collider from the simulation so it is no longer processed.
     *
     * This method does not destroy the Collider. If you wish to add it back at a later stage you can call
     * `World.colliders.add(Collider)`.
     *
     * If you no longer need the Collider you can call the `Collider.destroy` method instead, which will
     * automatically clear all of its references and then remove it from the World. If you call destroy on
     * a Collider you _don't_ need to pass it to this method too.
     *
     * @method Phaser.Physics.Arcade.World#removeCollider
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Collider} collider - The Collider to remove from the simulation.
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ removeCollider: function(collider) {
                    this.colliders.remove(collider);
                    return this;
                },
                /**
     * Sets the frame rate to run the simulation at.
     *
     * The frame rate value is used to simulate a fixed update time step. This fixed
     * time step allows for a straightforward implementation of a deterministic game state.
     *
     * This frame rate is independent of the frequency at which the game is rendering. The
     * higher you set the fps, the more physics simulation steps will occur per game step.
     * Conversely, the lower you set it, the less will take place.
     *
     * You can optionally advance the simulation directly yourself by calling the `step` method.
     *
     * @method Phaser.Physics.Arcade.World#setFPS
     * @since 3.10.0
     *
     * @param {number} framerate - The frame rate to advance the simulation at.
     *
     * @return {this} This World object.
     */ setFPS: function(framerate) {
                    this.fps = framerate;
                    this._frameTime = 1 / this.fps;
                    this._frameTimeMS = 1000 * this._frameTime;
                    return this;
                },
                /**
     * Advances the simulation based on the elapsed time and fps rate.
     *
     * This is called automatically by your Scene and does not need to be invoked directly.
     *
     * @method Phaser.Physics.Arcade.World#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.isPaused || this.bodies.size === 0) return;
                    var i;
                    var fixedDelta = this._frameTime;
                    var msPerFrame = this._frameTimeMS * this.timeScale;
                    this._elapsed += delta;
                    //  Update all active bodies
                    var body;
                    var bodies = this.bodies.entries;
                    //  Will a step happen this frame?
                    var willStep = this._elapsed >= msPerFrame;
                    if (!this.fixedStep) {
                        fixedDelta = delta * 0.001;
                        willStep = true;
                        this._elapsed = 0;
                    }
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (body.enable) body.preUpdate(willStep, fixedDelta);
                    }
                    //  We know that a step will happen this frame, so let's bundle it all together to save branching and iteration costs
                    if (willStep) {
                        this._elapsed -= msPerFrame;
                        this.stepsLastFrame = 1;
                        //  Optionally populate our dynamic collision tree
                        if (this.useTree) {
                            this.tree.clear();
                            this.tree.load(bodies);
                        }
                        //  Process any colliders
                        var colliders = this.colliders.update();
                        for(i = 0; i < colliders.length; i++){
                            var collider = colliders[i];
                            if (collider.active) collider.update();
                        }
                        this.emit(Events.WORLD_STEP, fixedDelta);
                    }
                    //  Process any additional steps this frame
                    while(this._elapsed >= msPerFrame){
                        this._elapsed -= msPerFrame;
                        this.step(fixedDelta);
                    }
                },
                /**
     * Advances the simulation by a time increment.
     *
     * @method Phaser.Physics.Arcade.World#step
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.10.0
     *
     * @param {number} delta - The delta time amount, in seconds, by which to advance the simulation.
     */ step: function(delta) {
                    //  Update all active bodies
                    var i;
                    var body;
                    var bodies = this.bodies.entries;
                    var len = bodies.length;
                    for(i = 0; i < len; i++){
                        body = bodies[i];
                        if (body.enable) body.update(delta);
                    }
                    //  Optionally populate our dynamic collision tree
                    if (this.useTree) {
                        this.tree.clear();
                        this.tree.load(bodies);
                    }
                    //  Process any colliders
                    var colliders = this.colliders.update();
                    for(i = 0; i < colliders.length; i++){
                        var collider = colliders[i];
                        if (collider.active) collider.update();
                    }
                    this.emit(Events.WORLD_STEP, delta);
                    this.stepsLastFrame++;
                },
                /**
     * Updates bodies, draws the debug display, and handles pending queue operations.
     *
     * @method Phaser.Physics.Arcade.World#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                    var i;
                    var body;
                    var bodies = this.bodies.entries;
                    var len = bodies.length;
                    var dynamic = this.bodies;
                    var staticBodies = this.staticBodies;
                    //  We don't need to postUpdate if there wasn't a step this frame
                    if (this.stepsLastFrame) {
                        this.stepsLastFrame = 0;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.enable) body.postUpdate();
                        }
                    }
                    if (this.drawDebug) {
                        var graphics = this.debugGraphic;
                        graphics.clear();
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.willDrawDebug()) body.drawDebug(graphics);
                        }
                        bodies = staticBodies.entries;
                        len = bodies.length;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.willDrawDebug()) body.drawDebug(graphics);
                        }
                    }
                    var pending = this.pendingDestroy;
                    if (pending.size > 0) {
                        var dynamicTree = this.tree;
                        var staticTree = this.staticTree;
                        bodies = pending.entries;
                        len = bodies.length;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.physicsType === CONST.DYNAMIC_BODY) {
                                dynamicTree.remove(body);
                                dynamic.delete(body);
                            } else if (body.physicsType === CONST.STATIC_BODY) {
                                staticTree.remove(body);
                                staticBodies.delete(body);
                            }
                            body.world = undefined;
                            body.gameObject = undefined;
                        }
                        pending.clear();
                    }
                },
                /**
     * Calculates a Body's velocity and updates its position.
     *
     * @method Phaser.Physics.Arcade.World#updateMotion
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to be updated.
     * @param {number} delta - The delta value to be used in the motion calculations, in seconds.
     */ updateMotion: function(body, delta) {
                    if (body.allowRotation) this.computeAngularVelocity(body, delta);
                    this.computeVelocity(body, delta);
                },
                /**
     * Calculates a Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeAngularVelocity
     * @since 3.10.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeAngularVelocity: function(body, delta) {
                    var velocity = body.angularVelocity;
                    var acceleration = body.angularAcceleration;
                    var drag = body.angularDrag;
                    var max = body.maxAngular;
                    if (acceleration) velocity += acceleration * delta;
                    else if (body.allowDrag && drag) {
                        drag *= delta;
                        if (FuzzyGreaterThan(velocity - drag, 0, 0.1)) velocity -= drag;
                        else if (FuzzyLessThan(velocity + drag, 0, 0.1)) velocity += drag;
                        else velocity = 0;
                    }
                    velocity = Clamp(velocity, -max, max);
                    var velocityDelta = velocity - body.angularVelocity;
                    body.angularVelocity += velocityDelta;
                    body.rotation += body.angularVelocity * delta;
                },
                /**
     * Calculates a Body's per-axis velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeVelocity: function(body, delta) {
                    var velocityX = body.velocity.x;
                    var accelerationX = body.acceleration.x;
                    var dragX = body.drag.x;
                    var maxX = body.maxVelocity.x;
                    var velocityY = body.velocity.y;
                    var accelerationY = body.acceleration.y;
                    var dragY = body.drag.y;
                    var maxY = body.maxVelocity.y;
                    var speed = body.speed;
                    var maxSpeed = body.maxSpeed;
                    var allowDrag = body.allowDrag;
                    var useDamping = body.useDamping;
                    if (body.allowGravity) {
                        velocityX += (this.gravity.x + body.gravity.x) * delta;
                        velocityY += (this.gravity.y + body.gravity.y) * delta;
                    }
                    if (accelerationX) velocityX += accelerationX * delta;
                    else if (allowDrag && dragX) {
                        if (useDamping) {
                            //  Damping based deceleration
                            dragX = Math.pow(dragX, delta);
                            velocityX *= dragX;
                            speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                            if (FuzzyEqual(speed, 0, 0.001)) velocityX = 0;
                        } else {
                            //  Linear deceleration
                            dragX *= delta;
                            if (FuzzyGreaterThan(velocityX - dragX, 0, 0.01)) velocityX -= dragX;
                            else if (FuzzyLessThan(velocityX + dragX, 0, 0.01)) velocityX += dragX;
                            else velocityX = 0;
                        }
                    }
                    if (accelerationY) velocityY += accelerationY * delta;
                    else if (allowDrag && dragY) {
                        if (useDamping) {
                            //  Damping based deceleration
                            dragY = Math.pow(dragY, delta);
                            velocityY *= dragY;
                            speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                            if (FuzzyEqual(speed, 0, 0.001)) velocityY = 0;
                        } else {
                            //  Linear deceleration
                            dragY *= delta;
                            if (FuzzyGreaterThan(velocityY - dragY, 0, 0.01)) velocityY -= dragY;
                            else if (FuzzyLessThan(velocityY + dragY, 0, 0.01)) velocityY += dragY;
                            else velocityY = 0;
                        }
                    }
                    velocityX = Clamp(velocityX, -maxX, maxX);
                    velocityY = Clamp(velocityY, -maxY, maxY);
                    body.velocity.set(velocityX, velocityY);
                    if (maxSpeed > -1 && speed > maxSpeed) {
                        body.velocity.normalize().scale(maxSpeed);
                        speed = maxSpeed;
                    }
                    body.speed = speed;
                },
                /**
     * Separates two Bodies.
     *
     * @method Phaser.Physics.Arcade.World#separate
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {ArcadePhysicsCallback} [processCallback] - The process callback.
     * @param {*} [callbackContext] - The context in which to invoke the callback.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     * @param {boolean} [intersects] - Assert that the bodies intersect and should not be tested before separation.
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separate: function(body1, body2, processCallback, callbackContext, overlapOnly, intersects) {
                    if (!intersects && !body1.enable || !body2.enable || body1.checkCollision.none || body2.checkCollision.none || !this.intersects(body1, body2)) return false;
                    //  They overlap. Is there a custom process callback? If it returns true then we can carry on, otherwise we should abort.
                    if (processCallback && processCallback.call(callbackContext, body1.gameObject, body2.gameObject) === false) return false;
                    //  Circle vs. Circle quick bail out
                    if (body1.isCircle && body2.isCircle) return this.separateCircle(body1, body2, overlapOnly);
                    // We define the behavior of bodies in a collision circle and rectangle
                    // If a collision occurs in the corner points of the rectangle, the body behave like circles
                    //  Either body1 or body2 is a circle
                    if (body1.isCircle !== body2.isCircle) {
                        var bodyRect = body1.isCircle ? body2 : body1;
                        var bodyCircle = body1.isCircle ? body1 : body2;
                        var rect = {
                            x: bodyRect.x,
                            y: bodyRect.y,
                            right: bodyRect.right,
                            bottom: bodyRect.bottom
                        };
                        var circle = bodyCircle.center;
                        if (circle.y < rect.y || circle.y > rect.bottom) {
                            if (circle.x < rect.x || circle.x > rect.right) return this.separateCircle(body1, body2, overlapOnly);
                        }
                    }
                    var resultX = false;
                    var resultY = false;
                    //  Do we separate on x first or y first or both?
                    if (overlapOnly) {
                        //  No separation but we need to calculate overlapX, overlapY, etc.
                        resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    } else if (this.forceX || Math.abs(this.gravity.y + body1.gravity.y) < Math.abs(this.gravity.x + body1.gravity.x)) {
                        resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        //  Are they still intersecting? Let's do the other axis then
                        if (this.intersects(body1, body2)) resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    } else {
                        resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        //  Are they still intersecting? Let's do the other axis then
                        if (this.intersects(body1, body2)) resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    }
                    var result = resultX || resultY;
                    if (result) {
                        if (overlapOnly) {
                            if (body1.onOverlap || body2.onOverlap) this.emit(Events.OVERLAP, body1.gameObject, body2.gameObject, body1, body2);
                        } else if (body1.onCollide || body2.onCollide) this.emit(Events.COLLIDE, body1.gameObject, body2.gameObject, body1, body2);
                    }
                    return result;
                },
                /**
     * Separates two Bodies, when both are circular.
     *
     * @method Phaser.Physics.Arcade.World#separateCircle
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     * @param {number} [bias] - A small value added to the calculations.
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separateCircle: function(body1, body2, overlapOnly, bias) {
                    //  Set the bounding box overlap values into the bodies themselves (hence we don't use the return values here)
                    GetOverlapX(body1, body2, false, bias);
                    GetOverlapY(body1, body2, false, bias);
                    var overlap = 0;
                    if (body1.isCircle !== body2.isCircle) {
                        var rect = {
                            x: body2.isCircle ? body1.position.x : body2.position.x,
                            y: body2.isCircle ? body1.position.y : body2.position.y,
                            right: body2.isCircle ? body1.right : body2.right,
                            bottom: body2.isCircle ? body1.bottom : body2.bottom
                        };
                        var circle = {
                            x: body1.isCircle ? body1.center.x : body2.center.x,
                            y: body1.isCircle ? body1.center.y : body2.center.y,
                            radius: body1.isCircle ? body1.halfWidth : body2.halfWidth
                        };
                        if (circle.y < rect.y) {
                            if (circle.x < rect.x) overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.y) - circle.radius;
                            else if (circle.x > rect.right) overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.y) - circle.radius;
                        } else if (circle.y > rect.bottom) {
                            if (circle.x < rect.x) overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.bottom) - circle.radius;
                            else if (circle.x > rect.right) overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.bottom) - circle.radius;
                        }
                        overlap *= -1;
                    } else overlap = body1.halfWidth + body2.halfWidth - DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y);
                    body1.overlapR = overlap;
                    body2.overlapR = overlap;
                    //  Can't separate two immovable bodies, or a body with its own custom separation logic
                    if (overlapOnly || overlap === 0 || body1.immovable && body2.immovable || body1.customSeparateX || body2.customSeparateX) {
                        if (overlap !== 0 && (body1.onOverlap || body2.onOverlap)) this.emit(Events.OVERLAP, body1.gameObject, body2.gameObject, body1, body2);
                        //  return true if there was some overlap, otherwise false
                        return overlap !== 0;
                    }
                    var dx = body1.center.x - body2.center.x;
                    var dy = body1.center.y - body2.center.y;
                    var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    var nx = (body2.center.x - body1.center.x) / d || 0;
                    var ny = (body2.center.y - body1.center.y) / d || 0;
                    var p = 2 * (body1.velocity.x * nx + body1.velocity.y * ny - body2.velocity.x * nx - body2.velocity.y * ny) / (body1.mass + body2.mass);
                    if (body1.immovable || body2.immovable) p *= 2;
                    if (!body1.immovable) {
                        body1.velocity.x = body1.velocity.x - p / body1.mass * nx;
                        body1.velocity.y = body1.velocity.y - p / body1.mass * ny;
                    }
                    if (!body2.immovable) {
                        body2.velocity.x = body2.velocity.x + p / body2.mass * nx;
                        body2.velocity.y = body2.velocity.y + p / body2.mass * ny;
                    }
                    if (!body1.immovable && !body2.immovable) overlap /= 2;
                    // Note: This is inadequate for circle-rectangle separation
                    var angle = AngleBetweenPoints(body1.center, body2.center);
                    var overlapX = (overlap + MATH_CONST.EPSILON) * Math.cos(angle);
                    var overlapY = (overlap + MATH_CONST.EPSILON) * Math.sin(angle);
                    if (!body1.immovable) {
                        body1.x -= overlapX;
                        body1.y -= overlapY;
                        body1.updateCenter();
                    }
                    if (!body2.immovable) {
                        body2.x += overlapX;
                        body2.y += overlapY;
                        body2.updateCenter();
                    }
                    body1.velocity.x *= body1.bounce.x;
                    body1.velocity.y *= body1.bounce.y;
                    body2.velocity.x *= body2.bounce.x;
                    body2.velocity.y *= body2.bounce.y;
                    if (body1.onCollide || body2.onCollide) this.emit(Events.COLLIDE, body1.gameObject, body2.gameObject, body1, body2);
                    return true;
                },
                /**
     * Checks to see if two Bodies intersect at all.
     *
     * @method Phaser.Physics.Arcade.World#intersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first body to check.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second body to check.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ intersects: function(body1, body2) {
                    if (body1 === body2) return false;
                    if (!body1.isCircle && !body2.isCircle) //  Rect vs. Rect
                    return !(body1.right <= body2.position.x || body1.bottom <= body2.position.y || body1.position.x >= body2.right || body1.position.y >= body2.bottom);
                    else if (body1.isCircle) {
                        if (body2.isCircle) //  Circle vs. Circle
                        return DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y) <= body1.halfWidth + body2.halfWidth;
                        else //  Circle vs. Rect
                        return this.circleBodyIntersects(body1, body2);
                    } else //  Rect vs. Circle
                    return this.circleBodyIntersects(body2, body1);
                },
                /**
     * Tests if a circular Body intersects with another Body.
     *
     * @method Phaser.Physics.Arcade.World#circleBodyIntersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} circle - The circular body to test.
     * @param {Phaser.Physics.Arcade.Body} body - The rectangular body to test.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ circleBodyIntersects: function(circle, body) {
                    var x = Clamp(circle.center.x, body.left, body.right);
                    var y = Clamp(circle.center.y, body.top, body.bottom);
                    var dx = (circle.center.x - x) * (circle.center.x - x);
                    var dy = (circle.center.y - y) * (circle.center.y - y);
                    return dx + dy <= circle.halfWidth * circle.halfWidth;
                },
                /**
     * Tests if Game Objects overlap.
     *
     * See details in {@link Phaser.Physics.Arcade.World#collide}.
     *
     * @method Phaser.Physics.Arcade.World#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `overlapCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    return this.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                },
                /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link Phaser.Physics.Arcade.World#overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided; they receive the colliding game objects as arguments.
     * If an overlap is detected, the `processCallback` is called first. It can cancel the collision by returning false.
     * Next the objects are separated and `collideCallback` is invoked.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.World#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} `true` if any overlapping Game Objects were separated, otherwise `false`.
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    return this.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                },
                /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideObjects
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideObjects: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var i;
                    var j;
                    if (object1.isParent && object1.physicsType === undefined) object1 = object1.children.entries;
                    if (object2 && object2.isParent && object2.physicsType === undefined) object2 = object2.children.entries;
                    var object1isArray = Array.isArray(object1);
                    var object2isArray = Array.isArray(object2);
                    this._total = 0;
                    if (!object1isArray && !object2isArray) //  Neither of them are arrays - do this first as it's the most common use-case
                    this.collideHandler(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    else if (!object1isArray && object2isArray) //  Object 2 is an Array
                    for(i = 0; i < object2.length; i++)this.collideHandler(object1, object2[i], collideCallback, processCallback, callbackContext, overlapOnly);
                    else if (object1isArray && !object2isArray) {
                        //  Object 1 is an Array
                        if (!object2) //  Special case for array vs. self
                        for(i = 0; i < object1.length; i++){
                            var child = object1[i];
                            for(j = i + 1; j < object1.length; j++){
                                if (i === j) continue;
                                this.collideHandler(child, object1[j], collideCallback, processCallback, callbackContext, overlapOnly);
                            }
                        }
                        else for(i = 0; i < object1.length; i++)this.collideHandler(object1[i], object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else {
                        //  They're both arrays
                        for(i = 0; i < object1.length; i++)for(j = 0; j < object2.length; j++)this.collideHandler(object1[i], object2[j], collideCallback, processCallback, callbackContext, overlapOnly);
                    }
                    return this._total > 0;
                },
                /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide and Phaser.Physics.Arcade.World#overlap instead.
     *
     * @method Phaser.Physics.Arcade.World#collideHandler
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideHandler: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    //  Collide Group with Self
                    //  Only collide valid objects
                    if (object2 === undefined && object1.isParent) return this.collideGroupVsGroup(object1, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                    //  If neither of the objects are set then bail out
                    if (!object1 || !object2) return false;
                    //  A Body
                    if (object1.body) {
                        if (object2.body) return this.collideSpriteVsSprite(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideSpriteVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isTilemap) return this.collideSpriteVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else if (object1.isParent) {
                        if (object2.body) return this.collideSpriteVsGroup(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideGroupVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isTilemap) return this.collideGroupVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else if (object1.isTilemap) {
                        if (object2.body) return this.collideSpriteVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideGroupVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                    }
                },
                /**
     * Internal handler for Sprite vs. Sprite collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsSprite
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite1 - The first object to check for collision.
     * @param {Phaser.GameObjects.GameObject} sprite2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsSprite: function(sprite1, sprite2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    if (!sprite1.body || !sprite2.body) return false;
                    if (this.separate(sprite1.body, sprite2.body, processCallback, callbackContext, overlapOnly)) {
                        if (collideCallback) collideCallback.call(callbackContext, sprite1, sprite2);
                        this._total++;
                    }
                    return true;
                },
                /**
     * Internal handler for Sprite vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} `true` if the Sprite collided with the given Group, otherwise `false`.
     */ collideSpriteVsGroup: function(sprite, group, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var bodyA = sprite.body;
                    if (group.length === 0 || !bodyA || !bodyA.enable || bodyA.checkCollision.none) return;
                    //  Does sprite collide with anything?
                    var i;
                    var len;
                    var bodyB;
                    if (this.useTree || group.physicsType === CONST.STATIC_BODY) {
                        var minMax = this.treeMinMax;
                        minMax.minX = bodyA.left;
                        minMax.minY = bodyA.top;
                        minMax.maxX = bodyA.right;
                        minMax.maxY = bodyA.bottom;
                        var results = group.physicsType === CONST.DYNAMIC_BODY ? this.tree.search(minMax) : this.staticTree.search(minMax);
                        len = results.length;
                        for(i = 0; i < len; i++){
                            bodyB = results[i];
                            if (bodyA === bodyB || !bodyB.enable || bodyB.checkCollision.none || !group.contains(bodyB.gameObject)) continue;
                            if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly, true)) {
                                if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                this._total++;
                            }
                        }
                    } else {
                        var children = group.getChildren();
                        var skipIndex = group.children.entries.indexOf(sprite);
                        len = children.length;
                        for(i = 0; i < len; i++){
                            bodyB = children[i].body;
                            if (!bodyB || i === skipIndex || !bodyB.enable) continue;
                            if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly)) {
                                if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                this._total++;
                            }
                        }
                    }
                },
                /**
     * Internal handler for Group vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsTilemapLayer
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsTilemapLayer: function(group, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var children = group.getChildren();
                    if (children.length === 0) return false;
                    var didCollide = false;
                    for(var i = 0; i < children.length; i++){
                        if (children[i].body) {
                            if (this.collideSpriteVsTilemapLayer(children[i], tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly)) didCollide = true;
                        }
                    }
                    return didCollide;
                },
                /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * @method Phaser.Physics.Arcade.World#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    if (!sprite.body.enable || tiles.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, false, false);
                },
                /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * @method Phaser.Physics.Arcade.World#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    if (!sprite.body.enable || tiles.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, true, false);
                },
                /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilemapLayer
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilemapLayer: function(sprite, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var body = sprite.body;
                    if (!body.enable || body.checkCollision.none) return false;
                    var x = body.position.x;
                    var y = body.position.y;
                    var w = body.width;
                    var h = body.height;
                    var layerData = tilemapLayer.layer;
                    if (layerData.tileWidth > layerData.baseTileWidth) {
                        // The x origin of a tile is the left side, so x and width need to be adjusted.
                        var xDiff = (layerData.tileWidth - layerData.baseTileWidth) * tilemapLayer.scaleX;
                        x -= xDiff;
                        w += xDiff;
                    }
                    if (layerData.tileHeight > layerData.baseTileHeight) {
                        // The y origin of a tile is the bottom side, so just the height needs to be adjusted.
                        var yDiff = (layerData.tileHeight - layerData.baseTileHeight) * tilemapLayer.scaleY;
                        h += yDiff;
                    }
                    var mapData = GetTilesWithinWorldXY(x, y, w, h, null, tilemapLayer.scene.cameras.main, tilemapLayer.layer);
                    if (mapData.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, mapData, collideCallback, processCallback, callbackContext, overlapOnly, true);
                },
                /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilesHandler
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @private
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     * @param {boolean} [isLayer] - Is this check coming from a TilemapLayer or an array of tiles?
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilesHandler: function(sprite, tiles, collideCallback, processCallback, callbackContext, overlapOnly, isLayer) {
                    var body = sprite.body;
                    var tile;
                    var tileWorldRect = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    };
                    var tilemapLayer;
                    var collision = false;
                    for(var i = 0; i < tiles.length; i++){
                        tile = tiles[i];
                        tilemapLayer = tile.tilemapLayer;
                        var point = tilemapLayer.tileToWorldXY(tile.x, tile.y);
                        tileWorldRect.left = point.x;
                        tileWorldRect.top = point.y;
                        //  If the maps base tile size differs from the layer tile size, only the top of the rect
                        //  needs to be adjusted since its origin is (0, 1).
                        if (tile.baseHeight !== tile.height) tileWorldRect.top -= (tile.height - tile.baseHeight) * tilemapLayer.scaleY;
                        tileWorldRect.right = tileWorldRect.left + tile.width * tilemapLayer.scaleX;
                        tileWorldRect.bottom = tileWorldRect.top + tile.height * tilemapLayer.scaleY;
                        if (TileIntersectsBody(tileWorldRect, body) && (!processCallback || processCallback.call(callbackContext, sprite, tile)) && ProcessTileCallbacks(tile, sprite) && (overlapOnly || SeparateTile(i, body, tile, tileWorldRect, tilemapLayer, this.TILE_BIAS, isLayer))) {
                            this._total++;
                            collision = true;
                            if (collideCallback) collideCallback.call(callbackContext, sprite, tile);
                            if (overlapOnly && body.onOverlap) this.emit(Events.TILE_OVERLAP, sprite, tile, body);
                            else if (body.onCollide) this.emit(Events.TILE_COLLIDE, sprite, tile, body);
                        }
                    }
                    return collision;
                },
                /**
     * Internal helper for Group vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group1 - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsGroup: function(group1, group2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    if (group1.length === 0 || group2.length === 0) return;
                    var children = group1.getChildren();
                    for(var i = 0; i < children.length; i++)this.collideSpriteVsGroup(children[i], group2, collideCallback, processCallback, callbackContext, overlapOnly);
                },
                /**
     * Wrap an object's coordinates (or several objects' coordinates) within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * If the object is outside any boundary edge (left, top, right, bottom), it will be moved to the same offset from the opposite edge (the interior).
     *
     * @method Phaser.Physics.Arcade.World#wrap
     * @since 3.3.0
     *
     * @param {any} object - A Game Object, a Group, an object with `x` and `y` coordinates, or an array of such objects.
     * @param {number} [padding=0] - An amount added to each boundary edge during the operation.
     */ wrap: function(object, padding) {
                    if (object.body) this.wrapObject(object, padding);
                    else if (object.getChildren) this.wrapArray(object.getChildren(), padding);
                    else if (Array.isArray(object)) this.wrapArray(object, padding);
                    else this.wrapObject(object, padding);
                },
                /**
     * Wrap each object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapArray
     * @since 3.3.0
     *
     * @param {Array.<*>} objects - An array of objects to be wrapped.
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapArray: function(objects, padding) {
                    for(var i = 0; i < objects.length; i++)this.wrapObject(objects[i], padding);
                },
                /**
     * Wrap an object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapObject
     * @since 3.3.0
     *
     * @param {*} object - A Game Object, a Physics Body, or any object with `x` and `y` coordinates
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapObject: function(object, padding) {
                    if (padding === undefined) padding = 0;
                    object.x = Wrap(object.x, this.bounds.left - padding, this.bounds.right + padding);
                    object.y = Wrap(object.y, this.bounds.top - padding, this.bounds.bottom + padding);
                },
                /**
     * Shuts down the simulation, clearing physics data and removing listeners.
     *
     * @method Phaser.Physics.Arcade.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.tree.clear();
                    this.staticTree.clear();
                    this.bodies.clear();
                    this.staticBodies.clear();
                    this.colliders.destroy();
                    this.removeAllListeners();
                },
                /**
     * Shuts down the simulation and disconnects it from the current scene.
     *
     * @method Phaser.Physics.Arcade.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene = null;
                }
            });
            module1.exports = World;
        /***/ },
        /* 527 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(62);
            var Events = __webpack_require__(245);
            var RadToDeg = __webpack_require__(196);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(57);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Dynamic Arcade Body.
 *
 * Its static counterpart is {@link Phaser.Physics.Arcade.StaticBody}.
 *
 * @class Body
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Body belongs to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object this Body belongs to.
 */ var Body = new Class({
                initialize: function Body(world, gameObject) {
                    var width = gameObject.displayWidth ? gameObject.displayWidth : 64;
                    var height = gameObject.displayHeight ? gameObject.displayHeight : 64;
                    /**
         * The Arcade Physics simulation this Body belongs to.
         *
         * @name Phaser.Physics.Arcade.Body#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Game Object this Body belongs to.
         *
         * @name Phaser.Physics.Arcade.Body#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = gameObject;
                    /**
         * Transformations applied to this Body.
         *
         * @name Phaser.Physics.Arcade.Body#transform
         * @type {object}
         * @since 3.4.0
         */ this.transform = {
                        x: gameObject.x,
                        y: gameObject.y,
                        rotation: gameObject.angle,
                        scaleX: gameObject.scaleX,
                        scaleY: gameObject.scaleY,
                        displayOriginX: gameObject.displayOriginX,
                        displayOriginY: gameObject.displayOriginY
                    };
                    /**
         * Whether the Body is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowBody;
                    /**
         * Whether the Body's velocity is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowVelocity
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowVelocity = world.defaults.debugShowVelocity;
                    /**
         * The color of this Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.bodyDebugColor;
                    /**
         * Whether this Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.Body#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                    /**
         * Whether this Body is circular (true) or rectangular (false).
         *
         * @name Phaser.Physics.Arcade.Body#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.isCircle = false;
                    /**
         * If this Body is circular, this is the unscaled radius of the Body, as set by setCircle(), in source pixels.
         * The true radius is equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.Body#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.radius = 0;
                    /**
         * The offset of this Body's position from its Game Object's position, in source pixels.
         *
         * @name Phaser.Physics.Arcade.Body#offset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setOffset
         */ this.offset = new Vector2();
                    /**
         * The position of this Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.Body#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - gameObject.scaleX * gameObject.displayOriginX, gameObject.y - gameObject.scaleY * gameObject.displayOriginY);
                    /**
         * The position of this Body during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#prev
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.prev = this.position.clone();
                    /**
         * The position of this Body during the previous frame.
         *
         * @name Phaser.Physics.Arcade.Body#prevFrame
         * @type {Phaser.Math.Vector2}
         * @since 3.20.0
         */ this.prevFrame = this.position.clone();
                    /**
         * Whether this Body's `rotation` is affected by its angular acceleration and angular velocity.
         *
         * @name Phaser.Physics.Arcade.Body#allowRotation
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowRotation = true;
                    /**
         * This body's rotation, in degrees, based on its angular acceleration and angular velocity.
         * The Body's rotation controls the `angle` of its Game Object.
         * It doesn't rotate the Body's own geometry, which is always an axis-aligned rectangle or a circle.
         *
         * @name Phaser.Physics.Arcade.Body#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = gameObject.angle;
                    /**
         * The Body rotation, in degrees, during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#preRotation
         * @type {number}
         * @since 3.0.0
         */ this.preRotation = gameObject.angle;
                    /**
         * The width of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the width use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#width
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the height use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#height
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The unscaled width of the Body, in source pixels, as set by setSize().
         * The default is the width of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceWidth
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceWidth = width;
                    /**
         * The unscaled height of the Body, in source pixels, as set by setSize().
         * The default is the height of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceHeight
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceHeight = height;
                    if (gameObject.frame) {
                        this.sourceWidth = gameObject.frame.realWidth;
                        this.sourceHeight = gameObject.frame.realHeight;
                    }
                    /**
         * Half the Body's width, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(width / 2);
                    /**
         * Half the Body's height, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(height / 2);
                    /**
         * The center of the Body.
         * The midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.Body#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    /**
         * The Body's velocity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.Body#velocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.velocity = new Vector2();
                    /**
         * The Body's change in position (due to velocity) at the last step, in pixels.
         *
         * The size of this value depends on the simulation's step rate.
         *
         * @name Phaser.Physics.Arcade.Body#newVelocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.newVelocity = new Vector2();
                    /**
         * The Body's absolute maximum change in position, in pixels per step.
         *
         * @name Phaser.Physics.Arcade.Body#deltaMax
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.deltaMax = new Vector2();
                    /**
         * The Body's change in velocity, in pixels per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#acceleration
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.acceleration = new Vector2();
                    /**
         * Whether this Body's velocity is affected by its `drag`.
         *
         * @name Phaser.Physics.Arcade.Body#allowDrag
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowDrag = true;
                    /**
         * When `useDamping` is false (the default), this is absolute loss of velocity due to movement, in pixels per second squared.
         *
         * When `useDamping` is true, this is a damping multiplier between 0 and 1.
         * A value of 0 means the Body stops instantly.
         * A value of 0.01 mean the Body keeps 1% of its velocity per second, losing 99%.
         * A value of 0.1 means the Body keeps 10% of its velocity per second, losing 90%.
         * A value of 1 means the Body loses no velocity.
         * You can use very small values (e.g., 0.001) to stop the Body quickly.
         *
         * The x and y components are applied separately.
         *
         * Drag is applied only when `acceleration` is zero.
         *
         * @name Phaser.Physics.Arcade.Body#drag
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.drag = new Vector2();
                    /**
         * Whether this Body's position is affected by gravity (local or world).
         *
         * @name Phaser.Physics.Arcade.Body#allowGravity
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#gravity
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.allowGravity = true;
                    /**
         * Acceleration due to gravity (specific to this Body), in pixels per second squared.
         * Total gravity is the sum of this vector and the simulation's `gravity`.
         *
         * @name Phaser.Physics.Arcade.Body#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.gravity = new Vector2();
                    /**
         * Rebound following a collision, relative to 1.
         *
         * @name Phaser.Physics.Arcade.Body#bounce
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.bounce = new Vector2();
                    /**
         * Rebound following a collision with the world boundary, relative to 1.
         * If null, `bounce` is used instead.
         *
         * @name Phaser.Physics.Arcade.Body#worldBounce
         * @type {?Phaser.Math.Vector2}
         * @default null
         * @since 3.0.0
         */ this.worldBounce = null;
                    /**
         * The rectangle used for world boundary collisions.
         *
         * By default it is set to the world boundary rectangle. Or, if this Body was
         * created by a Physics Group, then whatever rectangle that Group defined.
         *
         * You can also change it by using the `Body.setBoundsRectangle` method.
         *
         * @name Phaser.Physics.Arcade.Body#customBoundsRectangle
         * @type {Phaser.Geom.Rectangle}
         * @since 3.20
         */ this.customBoundsRectangle = world.bounds;
                    //  If true this Body will dispatch events
                    /**
         * Whether the simulation emits a `worldbounds` event when this Body collides with the world boundary (and `collideWorldBounds` is also true).
         *
         * @name Phaser.Physics.Arcade.Body#onWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#WORLD_BOUNDS
         */ this.onWorldBounds = false;
                    /**
         * Whether the simulation emits a `collide` event when this Body collides with another.
         *
         * @name Phaser.Physics.Arcade.Body#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#COLLIDE
         */ this.onCollide = false;
                    /**
         * Whether the simulation emits an `overlap` event when this Body overlaps with another.
         *
         * @name Phaser.Physics.Arcade.Body#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#OVERLAP
         */ this.onOverlap = false;
                    /**
         * The Body's absolute maximum velocity, in pixels per second.
         * The horizontal and vertical components are applied separately.
         *
         * @name Phaser.Physics.Arcade.Body#maxVelocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.maxVelocity = new Vector2(10000, 10000);
                    /**
         * The maximum speed this Body is allowed to reach, in pixels per second.
         *
         * If not negative it limits the scalar value of speed.
         *
         * Any negative value means no maximum is being applied (the default).
         *
         * @name Phaser.Physics.Arcade.Body#maxSpeed
         * @type {number}
         * @default -1
         * @since 3.16.0
         */ this.maxSpeed = -1;
                    /**
         * If this Body is `immovable` and in motion, `friction` is the proportion of this Body's motion received by the riding Body on each axis, relative to 1.
         * The horizontal component (x) is applied only when two colliding Bodies are separated vertically.
         * The vertical component (y) is applied only when two colliding Bodies are separated horizontally.
         * The default value (1, 0) moves the riding Body horizontally in equal proportion to this Body and vertically not at all.
         *
         * @name Phaser.Physics.Arcade.Body#friction
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.friction = new Vector2(1, 0);
                    /**
         * If this Body is using `drag` for deceleration this property controls how the drag is applied.
         * If set to `true` drag will use a damping effect rather than a linear approach. If you are
         * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
         * the game Asteroids) then you will get a far smoother and more visually correct deceleration
         * by using damping, avoiding the axis-drift that is prone with linear deceleration.
         *
         * If you enable this property then you should use far smaller `drag` values than with linear, as
         * they are used as a multiplier on the velocity. Values such as 0.05 will give a nice slow
         * deceleration.
         *
         * @name Phaser.Physics.Arcade.Body#useDamping
         * @type {boolean}
         * @default false
         * @since 3.10.0
         */ this.useDamping = false;
                    /**
         * The rate of change of this Body's `rotation`, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#angularVelocity
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularVelocity = 0;
                    /**
         * The Body's angular acceleration (change in angular velocity), in degrees per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#angularAcceleration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularAcceleration = 0;
                    /**
         * Loss of angular velocity due to angular movement, in degrees per second.
         *
         * Angular drag is applied only when angular acceleration is zero.
         *
         * @name Phaser.Physics.Arcade.Body#angularDrag
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularDrag = 0;
                    /**
         * The Body's maximum angular velocity, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#maxAngular
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.maxAngular = 1000;
                    /**
         * The Body's inertia, relative to a default unit (1).
         * With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.Body#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                    /**
         * The calculated angle of this Body's velocity vector, in radians, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                    /**
         * The calculated magnitude of the Body's velocity, in pixels per second, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#speed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speed = 0;
                    /**
         * The direction of the Body's velocity, as calculated during the last step.
         * This is a numeric constant value (FACING_UP, FACING_DOWN, FACING_LEFT, FACING_RIGHT).
         * If the Body is moving on both axes, this describes motion on the vertical axis only.
         *
         * @name Phaser.Physics.Arcade.Body#facing
         * @type {number}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.FACING_UP
         * @see Phaser.Physics.Arcade.FACING_DOWN
         * @see Phaser.Physics.Arcade.FACING_LEFT
         * @see Phaser.Physics.Arcade.FACING_RIGHT
         */ this.facing = CONST.FACING_NONE;
                    /**
         * Whether this Body can be moved by collisions with another Body.
         *
         * @name Phaser.Physics.Arcade.Body#immovable
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.immovable = false;
                    /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Dynamic Bodies are always pushable.
         *
         * @name Phaser.Physics.Arcade.Body#pushable
         * @type {boolean}
         * @default true
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = true;
                    /**
         * Whether the Body's position and rotation are affected by its velocity, acceleration, drag, and gravity.
         *
         * @name Phaser.Physics.Arcade.Body#moves
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.moves = true;
                    /**
         * A flag disabling the default horizontal separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                    /**
         * A flag disabling the default vertical separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                    /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                    /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                    /**
         * The amount of overlap (before separation), if this Body is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.Body#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                    /**
         * Whether this Body is overlapped with another and both are not moving, on at least one axis.
         *
         * @name Phaser.Physics.Arcade.Body#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                    /**
         * Whether this Body interacts with the world boundary.
         *
         * @name Phaser.Physics.Arcade.Body#collideWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                    /**
         * Whether this Body is checked for collisions and for which directions.
         * You can set `checkCollision.none = true` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.Body#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = {
                        none: false,
                        up: true,
                        down: true,
                        left: true,
                        right: true
                    };
                    /**
         * Whether this Body is colliding with a Body or Static Body and in which direction.
         * In a collision where both bodies have zero velocity, `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#blocked
         * @see Phaser.Physics.Arcade.Body#embedded
         */ this.touching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This Body's `touching` value during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.wasTouching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * Whether this Body is colliding with a Static Body, a tile, or the world boundary.
         * In a collision with a Static Body, if this Body has zero velocity then `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#embedded
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.blocked = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * Whether to automatically synchronize this Body's dimensions to the dimensions of its Game Object's visual bounds.
         *
         * @name Phaser.Physics.Arcade.Body#syncBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Components.GetBounds#getBounds
         */ this.syncBounds = false;
                    /**
         * The Body's physics type (dynamic or static).
         *
         * @name Phaser.Physics.Arcade.Body#physicsType
         * @type {number}
         * @readonly
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                    /**
         * Cached horizontal scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sx
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sx = gameObject.scaleX;
                    /**
         * Cached vertical scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sy
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sy = gameObject.scaleY;
                    /**
         * The calculated change in the Body's horizontal position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dx = 0;
                    /**
         * The calculated change in the Body's vertical position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dy = 0;
                    /**
         * The final calculated change in the Body's horizontal position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_tx
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._tx = 0;
                    /**
         * The final calculated change in the Body's vertical position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_ty
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._ty = 0;
                    /**
         * Stores the Game Object's bounds.
         *
         * @name Phaser.Physics.Arcade.Body#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                },
                /**
     * Updates the Body's `transform`, `width`, `height`, and `center` from its Game Object.
     * The Body's `position` isn't changed.
     *
     * @method Phaser.Physics.Arcade.Body#updateBounds
     * @since 3.0.0
     */ updateBounds: function() {
                    var sprite = this.gameObject;
                    //  Container?
                    var transform = this.transform;
                    if (sprite.parentContainer) {
                        var matrix = sprite.getWorldTransformMatrix(this.world._tempMatrix, this.world._tempMatrix2);
                        transform.x = matrix.tx;
                        transform.y = matrix.ty;
                        transform.rotation = RadToDeg(matrix.rotation);
                        transform.scaleX = matrix.scaleX;
                        transform.scaleY = matrix.scaleY;
                        transform.displayOriginX = sprite.displayOriginX;
                        transform.displayOriginY = sprite.displayOriginY;
                    } else {
                        transform.x = sprite.x;
                        transform.y = sprite.y;
                        transform.rotation = sprite.angle;
                        transform.scaleX = sprite.scaleX;
                        transform.scaleY = sprite.scaleY;
                        transform.displayOriginX = sprite.displayOriginX;
                        transform.displayOriginY = sprite.displayOriginY;
                    }
                    var recalc = false;
                    if (this.syncBounds) {
                        var b = sprite.getBounds(this._bounds);
                        this.width = b.width;
                        this.height = b.height;
                        recalc = true;
                    } else {
                        var asx = Math.abs(transform.scaleX);
                        var asy = Math.abs(transform.scaleY);
                        if (this._sx !== asx || this._sy !== asy) {
                            this.width = this.sourceWidth * asx;
                            this.height = this.sourceHeight * asy;
                            this._sx = asx;
                            this._sy = asy;
                            recalc = true;
                        }
                    }
                    if (recalc) {
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.updateCenter();
                    }
                },
                /**
     * Updates the Body's `center` from its `position`, `width`, and `height`.
     *
     * @method Phaser.Physics.Arcade.Body#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                /**
     * Updates the Body's `position`, `width`, `height`, and `center` from its Game Object and `offset`.
     *
     * You don't need to call this for Dynamic Bodies, as it happens automatically during the physics step.
     * But you could use it if you have modified the Body offset or Game Object transform and need to immediately
     * read the Body's new `position` or `center`.
     *
     * To resynchronize the Body with its Game Object, use `reset()` instead.
     *
     * @method Phaser.Physics.Arcade.Body#updateFromGameObject
     * @since 3.24.0
     */ updateFromGameObject: function() {
                    this.updateBounds();
                    var transform = this.transform;
                    this.position.x = transform.x + transform.scaleX * (this.offset.x - transform.displayOriginX);
                    this.position.y = transform.y + transform.scaleY * (this.offset.y - transform.displayOriginY);
                    this.updateCenter();
                },
                /**
     * Prepares the Body for a physics step by resetting the `wasTouching`, `touching` and `blocked` states.
     *
     * This method is only called if the physics world is going to run a step this frame.
     *
     * @method Phaser.Physics.Arcade.Body#resetFlags
     * @since 3.18.0
     *
     * @param {boolean} [clear=false] - Set the `wasTouching` values to their defaults.
     */ resetFlags: function(clear) {
                    if (clear === undefined) clear = false;
                    //  Store and reset collision flags
                    var wasTouching = this.wasTouching;
                    var touching = this.touching;
                    var blocked = this.blocked;
                    if (clear) {
                        wasTouching.none = true;
                        wasTouching.up = false;
                        wasTouching.down = false;
                        wasTouching.left = false;
                        wasTouching.right = false;
                    } else {
                        wasTouching.none = touching.none;
                        wasTouching.up = touching.up;
                        wasTouching.down = touching.down;
                        wasTouching.left = touching.left;
                        wasTouching.right = touching.right;
                    }
                    touching.none = true;
                    touching.up = false;
                    touching.down = false;
                    touching.left = false;
                    touching.right = false;
                    blocked.none = true;
                    blocked.up = false;
                    blocked.down = false;
                    blocked.left = false;
                    blocked.right = false;
                    this.overlapR = 0;
                    this.overlapX = 0;
                    this.overlapY = 0;
                    this.embedded = false;
                },
                /**
     * Syncs the position body position with the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#preUpdate
     * @since 3.17.0
     *
     * @param {boolean} willStep - Will this Body run an update as well?
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ preUpdate: function(willStep, delta) {
                    if (willStep) this.resetFlags();
                    this.updateFromGameObject();
                    this.rotation = this.transform.rotation;
                    this.preRotation = this.rotation;
                    if (this.moves) {
                        this.prev.x = this.position.x;
                        this.prev.y = this.position.y;
                        this.prevFrame.x = this.position.x;
                        this.prevFrame.y = this.position.y;
                    }
                    if (willStep) this.update(delta);
                },
                /**
     * Performs a single physics step and updates the body velocity, angle, speed and other properties.
     *
     * This method can be called multiple times per game frame, depending on the physics step rate.
     *
     * The results are synced back to the Game Object in `postUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_BOUNDS
     * @since 3.0.0
     *
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ update: function(delta) {
                    this.prev.x = this.position.x;
                    this.prev.y = this.position.y;
                    if (this.moves) {
                        this.world.updateMotion(this, delta);
                        var vx = this.velocity.x;
                        var vy = this.velocity.y;
                        this.newVelocity.set(vx * delta, vy * delta);
                        this.position.add(this.newVelocity);
                        this.updateCenter();
                        this.angle = Math.atan2(vy, vx);
                        this.speed = Math.sqrt(vx * vx + vy * vy);
                        //  Now the update will throw collision checks at the Body
                        //  And finally we'll integrate the new position back to the Sprite in postUpdate
                        if (this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds) this.world.emit(Events.WORLD_BOUNDS, this, this.blocked.up, this.blocked.down, this.blocked.left, this.blocked.right);
                    }
                    this._dx = this.position.x - this.prev.x;
                    this._dy = this.position.y - this.prev.y;
                },
                /**
     * Feeds the Body results back into the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                    var dx = this.position.x - this.prevFrame.x;
                    var dy = this.position.y - this.prevFrame.y;
                    if (this.moves) {
                        var mx = this.deltaMax.x;
                        var my = this.deltaMax.y;
                        if (mx !== 0 && dx !== 0) {
                            if (dx < 0 && dx < -mx) dx = -mx;
                            else if (dx > 0 && dx > mx) dx = mx;
                        }
                        if (my !== 0 && dy !== 0) {
                            if (dy < 0 && dy < -my) dy = -my;
                            else if (dy > 0 && dy > my) dy = my;
                        }
                        this.gameObject.x += dx;
                        this.gameObject.y += dy;
                    }
                    if (dx < 0) this.facing = CONST.FACING_LEFT;
                    else if (dx > 0) this.facing = CONST.FACING_RIGHT;
                    if (dy < 0) this.facing = CONST.FACING_UP;
                    else if (dy > 0) this.facing = CONST.FACING_DOWN;
                    if (this.allowRotation) this.gameObject.angle += this.deltaZ();
                    this._tx = dx;
                    this._ty = dy;
                },
                /**
     * Sets a custom collision boundary rectangle. Use if you want to have a custom
     * boundary instead of the world boundaries.
     *
     * @method Phaser.Physics.Arcade.Body#setBoundsRectangle
     * @since 3.20
     *
     * @param {?Phaser.Geom.Rectangle} [bounds] - The new boundary rectangle. Pass `null` to use the World bounds.
     *
     * @return {this} This Body object.
     */ setBoundsRectangle: function(bounds) {
                    this.customBoundsRectangle = !bounds ? this.world.bounds : bounds;
                    return this;
                },
                /**
     * Checks for collisions between this Body and the world boundary and separates them.
     *
     * @method Phaser.Physics.Arcade.Body#checkWorldBounds
     * @since 3.0.0
     *
     * @return {boolean} True if this Body is colliding with the world boundary.
     */ checkWorldBounds: function() {
                    var pos = this.position;
                    var bounds = this.customBoundsRectangle;
                    var check = this.world.checkCollision;
                    var bx = this.worldBounce ? -this.worldBounce.x : -this.bounce.x;
                    var by = this.worldBounce ? -this.worldBounce.y : -this.bounce.y;
                    var wasSet = false;
                    if (pos.x < bounds.x && check.left) {
                        pos.x = bounds.x;
                        this.velocity.x *= bx;
                        this.blocked.left = true;
                        wasSet = true;
                    } else if (this.right > bounds.right && check.right) {
                        pos.x = bounds.right - this.width;
                        this.velocity.x *= bx;
                        this.blocked.right = true;
                        wasSet = true;
                    }
                    if (pos.y < bounds.y && check.up) {
                        pos.y = bounds.y;
                        this.velocity.y *= by;
                        this.blocked.up = true;
                        wasSet = true;
                    } else if (this.bottom > bounds.bottom && check.down) {
                        pos.y = bounds.bottom - this.height;
                        this.velocity.y *= by;
                        this.blocked.down = true;
                        wasSet = true;
                    }
                    if (wasSet) {
                        this.blocked.none = false;
                        this.updateCenter();
                    }
                    return wasSet;
                },
                /**
     * Sets the offset of the Body's position from its Game Object's position.
     * The Body's `position` isn't changed until the next `preUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal offset, in source pixels.
     * @param {number} [y=x] - The vertical offset, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setOffset: function(x, y) {
                    if (y === undefined) y = x;
                    this.offset.set(x, y);
                    return this;
                },
                /**
     * Sizes and positions this Body, as a rectangle.
     * Modifies the Body `offset` if `center` is true (the default).
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.Body#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Modify the Body's `offset`, placing the Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setSize: function(width, height, center) {
                    if (center === undefined) center = true;
                    var gameObject = this.gameObject;
                    if (!width && gameObject.frame) width = gameObject.frame.realWidth;
                    if (!height && gameObject.frame) height = gameObject.frame.realHeight;
                    this.sourceWidth = width;
                    this.sourceHeight = height;
                    this.width = this.sourceWidth * this._sx;
                    this.height = this.sourceHeight * this._sy;
                    this.halfWidth = Math.floor(this.width / 2);
                    this.halfHeight = Math.floor(this.height / 2);
                    this.updateCenter();
                    if (center && gameObject.getCenter) {
                        var ox = (gameObject.width - width) / 2;
                        var oy = (gameObject.height - height) / 2;
                        this.offset.set(ox, oy);
                    }
                    this.isCircle = false;
                    this.radius = 0;
                    return this;
                },
                /**
     * Sizes and positions this Body, as a circle.
     *
     * @method Phaser.Physics.Arcade.Body#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Body, in source pixels.
     * @param {number} [offsetX] - The horizontal offset of the Body from its Game Object, in source pixels.
     * @param {number} [offsetY] - The vertical offset of the Body from its Game Object, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = this.offset.x;
                    if (offsetY === undefined) offsetY = this.offset.y;
                    if (radius > 0) {
                        this.isCircle = true;
                        this.radius = radius;
                        this.sourceWidth = radius * 2;
                        this.sourceHeight = radius * 2;
                        this.width = this.sourceWidth * this._sx;
                        this.height = this.sourceHeight * this._sy;
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.offset.set(offsetX, offsetY);
                        this.updateCenter();
                    } else this.isCircle = false;
                    return this;
                },
                /**
     * Sets this Body's parent Game Object to the given coordinates and resets this Body at the new coordinates.
     * If the Body had any velocity or acceleration it is lost as a result of calling this.
     *
     * @method Phaser.Physics.Arcade.Body#reset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position to place the Game Object.
     * @param {number} y - The vertical position to place the Game Object.
     */ reset: function(x, y) {
                    this.stop();
                    var gameObject = this.gameObject;
                    gameObject.setPosition(x, y);
                    if (gameObject.getTopLeft) gameObject.getTopLeft(this.position);
                    else this.position.set(x, y);
                    this.prev.copy(this.position);
                    this.prevFrame.copy(this.position);
                    this.rotation = gameObject.angle;
                    this.preRotation = gameObject.angle;
                    this.updateBounds();
                    this.updateCenter();
                    this.resetFlags(true);
                },
                /**
     * Sets acceleration, velocity, and speed to zero.
     *
     * @method Phaser.Physics.Arcade.Body#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ stop: function() {
                    this.velocity.set(0);
                    this.acceleration.set(0);
                    this.speed = 0;
                    this.angularVelocity = 0;
                    this.angularAcceleration = 0;
                    return this;
                },
                /**
     * Copies the coordinates of this Body's edges into an object.
     *
     * @method Phaser.Physics.Arcade.Body#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - An object to copy the values into.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} - An object with {x, y, right, bottom}.
     */ getBounds: function(obj) {
                    obj.x = this.x;
                    obj.y = this.y;
                    obj.right = this.right;
                    obj.bottom = this.bottom;
                    return obj;
                },
                /**
     * Tests if the coordinates are within this Body.
     *
     * @method Phaser.Physics.Arcade.Body#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The horizontal coordinate.
     * @param {number} y - The vertical coordinate.
     *
     * @return {boolean} True if (x, y) is within this Body.
     */ hitTest: function(x, y) {
                    if (!this.isCircle) return RectangleContains(this, x, y);
                    //  Check if x/y are within the bounds first
                    if (this.radius > 0 && x >= this.left && x <= this.right && y >= this.top && y <= this.bottom) {
                        var dx = (this.center.x - x) * (this.center.x - x);
                        var dy = (this.center.y - y) * (this.center.y - y);
                        return dx + dy <= this.radius * this.radius;
                    }
                    return false;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving down.
     *
     * @method Phaser.Physics.Arcade.Body#onFloor
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onFloor: function() {
                    return this.blocked.down;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving up.
     *
     * @method Phaser.Physics.Arcade.Body#onCeiling
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onCeiling: function() {
                    return this.blocked.up;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving left or right.
     *
     * @method Phaser.Physics.Arcade.Body#onWall
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onWall: function() {
                    return this.blocked.left || this.blocked.right;
                },
                /**
     * The absolute (non-negative) change in this Body's horizontal position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsX: function() {
                    return this._dx > 0 ? this._dx : -this._dx;
                },
                /**
     * The absolute (non-negative) change in this Body's vertical position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsY: function() {
                    return this._dy > 0 ? this._dy : -this._dy;
                },
                /**
     * The change in this Body's horizontal position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaXFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaX: function() {
                    return this._dx;
                },
                /**
     * The change in this Body's vertical position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaYFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaY: function() {
                    return this._dy;
                },
                /**
     * The change in this Body's horizontal position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaXFinal
     * @since 3.22.0
     *
     * @return {number} The final delta x value.
     */ deltaXFinal: function() {
                    return this._tx;
                },
                /**
     * The change in this Body's vertical position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaYFinal
     * @since 3.22.0
     *
     * @return {number} The final delta y value.
     */ deltaYFinal: function() {
                    return this._ty;
                },
                /**
     * The change in this Body's rotation from the previous step, in degrees.
     *
     * @method Phaser.Physics.Arcade.Body#deltaZ
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaZ: function() {
                    return this.rotation - this.preRotation;
                },
                /**
     * Disables this Body and marks it for deletion by the simulation.
     *
     * @method Phaser.Physics.Arcade.Body#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enable = false;
                    if (this.world) this.world.pendingDestroy.set(this);
                },
                /**
     * Draws this Body and its velocity, if enabled.
     *
     * @method Phaser.Physics.Arcade.Body#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to draw on.
     */ drawDebug: function(graphic) {
                    var pos = this.position;
                    var x = pos.x + this.halfWidth;
                    var y = pos.y + this.halfHeight;
                    if (this.debugShowBody) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor);
                        if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                        else {
                            //  Only draw the sides where checkCollision is true, similar to debugger in layer
                            if (this.checkCollision.up) graphic.lineBetween(pos.x, pos.y, pos.x + this.width, pos.y);
                            if (this.checkCollision.right) graphic.lineBetween(pos.x + this.width, pos.y, pos.x + this.width, pos.y + this.height);
                            if (this.checkCollision.down) graphic.lineBetween(pos.x, pos.y + this.height, pos.x + this.width, pos.y + this.height);
                            if (this.checkCollision.left) graphic.lineBetween(pos.x, pos.y, pos.x, pos.y + this.height);
                        }
                    }
                    if (this.debugShowVelocity) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.world.defaults.velocityDebugColor, 1);
                        graphic.lineBetween(x, y, x + this.velocity.x / 2, y + this.velocity.y / 2);
                    }
                },
                /**
     * Whether this Body will be drawn to the debug display.
     *
     * @method Phaser.Physics.Arcade.Body#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} True if either `debugShowBody` or `debugShowVelocity` are enabled.
     */ willDrawDebug: function() {
                    return this.debugShowBody || this.debugShowVelocity;
                },
                /**
     * Sets whether this Body collides with the world boundary.
     *
     * Optionally also sets the World Bounce and `onWorldBounds` values.
     *
     * @method Phaser.Physics.Arcade.Body#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if the Body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this replaces the Body's `worldBounce.x` value.
     * @param {number} [bounceY] - If given this replaces the Body's `worldBounce.y` value.
     * @param {boolean} [onWorldBounds] - If given this replaces the Body's `onWorldBounds` value.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY, onWorldBounds) {
                    if (value === undefined) value = true;
                    this.collideWorldBounds = value;
                    var setBounceX = bounceX !== undefined;
                    var setBounceY = bounceY !== undefined;
                    if (setBounceX || setBounceY) {
                        if (!this.worldBounce) this.worldBounce = new Vector2();
                        if (setBounceX) this.worldBounce.x = bounceX;
                        if (setBounceY) this.worldBounce.y = bounceY;
                    }
                    if (onWorldBounds !== undefined) this.onWorldBounds = onWorldBounds;
                    return this;
                },
                /**
     * Sets the Body's velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocity: function(x, y) {
                    this.velocity.set(x, y);
                    x = this.velocity.x;
                    y = this.velocity.y;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityX: function(value) {
                    this.velocity.x = value;
                    var x = value;
                    var y = this.velocity.y;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityY: function(value) {
                    this.velocity.y = value;
                    var x = this.velocity.x;
                    var y = value;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's maximum velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocity
     * @since 3.10.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocity: function(x, y) {
                    this.maxVelocity.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's maximum horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityX
     * @since 3.50.0
     *
     * @param {number} value - The maximum horizontal velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityX: function(value) {
                    this.maxVelocity.x = value;
                    return this;
                },
                /**
     * Sets the Body's maximum vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityY
     * @since 3.50.0
     *
     * @param {number} value - The maximum vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityY: function(value) {
                    this.maxVelocity.y = value;
                    return this;
                },
                /**
     * Sets the maximum speed the Body can move.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxSpeed
     * @since 3.16.0
     *
     * @param {number} value - The maximum speed value, in pixels per second. Set to a negative value to disable.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxSpeed: function(value) {
                    this.maxSpeed = value;
                    return this;
                },
                /**
     * Sets the Body's bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The horizontal bounce, relative to 1.
     * @param {number} y - The vertical bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounce: function(x, y) {
                    this.bounce.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceX: function(value) {
                    this.bounce.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceY: function(value) {
                    this.bounce.y = value;
                    return this;
                },
                /**
     * Sets the Body's acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAcceleration: function(x, y) {
                    this.acceleration.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationX: function(value) {
                    this.acceleration.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationY: function(value) {
                    this.acceleration.y = value;
                    return this;
                },
                /**
     * Enables or disables drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowDrag
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowDrag
     *
     * @param {boolean} [value=true] - `true` to allow drag on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowDrag: function(value) {
                    if (value === undefined) value = true;
                    this.allowDrag = value;
                    return this;
                },
                /**
     * Enables or disables gravity's effect on this Body.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowGravity
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowGravity
     *
     * @param {boolean} [value=true] - `true` to allow gravity on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowGravity: function(value) {
                    if (value === undefined) value = true;
                    this.allowGravity = value;
                    return this;
                },
                /**
     * Enables or disables rotation.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowRotation
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowRotation
     *
     * @param {boolean} [value=true] - `true` to allow rotation on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowRotation: function(value) {
                    if (value === undefined) value = true;
                    this.allowRotation = value;
                    return this;
                },
                /**
     * Sets the Body's drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDrag: function(x, y) {
                    this.drag.set(x, y);
                    return this;
                },
                /**
     * If this Body is using `drag` for deceleration this property controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Body#setDamping
     * @since 3.50.0
     *
     * @param {boolean} value - `true` to use damping, or `false` to use drag.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDamping: function(value) {
                    this.useDamping = value;
                    return this;
                },
                /**
     * Sets the Body's horizontal drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragX: function(value) {
                    this.drag.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragY: function(value) {
                    this.drag.y = value;
                    return this;
                },
                /**
     * Sets the Body's gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravity: function(x, y) {
                    this.gravity.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityX
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityX: function(value) {
                    this.gravity.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityY
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityY: function(value) {
                    this.gravity.y = value;
                    return this;
                },
                /**
     * Sets the Body's friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, relative to 1.
     * @param {number} y - The vertical component, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFriction: function(x, y) {
                    this.friction.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionX
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionX: function(value) {
                    this.friction.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionY
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionY: function(value) {
                    this.friction.y = value;
                    return this;
                },
                /**
     * Sets the Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in degrees per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularVelocity: function(value) {
                    this.angularVelocity = value;
                    return this;
                },
                /**
     * Sets the Body's angular acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularAcceleration: function(value) {
                    this.angularAcceleration = value;
                    return this;
                },
                /**
     * Sets the Body's angular drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The drag, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularDrag: function(value) {
                    this.angularDrag = value;
                    return this;
                },
                /**
     * Sets the Body's mass.
     *
     * @method Phaser.Physics.Arcade.Body#setMass
     * @since 3.0.0
     *
     * @param {number} value - The mass value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMass: function(value) {
                    this.mass = value;
                    return this;
                },
                /**
     * Sets the Body's `immovable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - The value to assign to `immovable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setImmovable: function(value) {
                    if (value === undefined) value = true;
                    this.immovable = value;
                    return this;
                },
                /**
     * Sets the Body's `enable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setEnable
     * @since 3.15.0
     *
     * @param {boolean} [value=true] - The value to assign to `enable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setEnable: function(value) {
                    if (value === undefined) value = true;
                    this.enable = value;
                    return this;
                },
                /**
     * This is an internal handler, called by the `ProcessX` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processX
     * @since 3.50.0
     *
     * @param {number} x - The amount to add to the Body position.
     * @param {number} [vx] - The amount to add to the Body velocity.
     * @param {boolean} [left] - Set the blocked.left value?
     * @param {boolean} [right] - Set the blocked.right value?
     */ processX: function(x, vx, left, right) {
                    this.x += x;
                    this.updateCenter();
                    if (vx !== null) this.velocity.x = vx;
                    var blocked = this.blocked;
                    if (left) blocked.left = true;
                    if (right) blocked.right = true;
                },
                /**
     * This is an internal handler, called by the `ProcessY` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processY
     * @since 3.50.0
     *
     * @param {number} y - The amount to add to the Body position.
     * @param {number} [vy] - The amount to add to the Body velocity.
     * @param {boolean} [up] - Set the blocked.up value?
     * @param {boolean} [down] - Set the blocked.down value?
     */ processY: function(y, vy, up, down) {
                    this.y += y;
                    this.updateCenter();
                    if (vy !== null) this.velocity.y = vy;
                    var blocked = this.blocked;
                    if (up) blocked.up = true;
                    if (down) blocked.down = true;
                },
                /**
     * The Bodys horizontal position (left edge).
     *
     * @name Phaser.Physics.Arcade.Body#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.position.x = value;
                    }
                },
                /**
     * The Bodys vertical position (top edge).
     *
     * @name Phaser.Physics.Arcade.Body#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.position.y = value;
                    }
                },
                /**
     * The left edge of the Body. Identical to x.
     *
     * @name Phaser.Physics.Arcade.Body#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                /**
     * The right edge of the Body.
     *
     * @name Phaser.Physics.Arcade.Body#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                /**
     * The top edge of the Body. Identical to y.
     *
     * @name Phaser.Physics.Arcade.Body#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                /**
     * The bottom edge of this Body.
     *
     * @name Phaser.Physics.Arcade.Body#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            module1.exports = Body;
        /***/ },
        /* 528 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * An Arcade Physics Collider will automatically check for collision, or overlaps, between two objects
 * every step. If a collision, or overlap, occurs it will invoke the given callbacks.
 *
 * @class Collider
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade physics World that will manage the collisions.
 * @param {boolean} overlapOnly - Whether to check for collisions or overlap.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
 * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
 * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
 * @param {any} callbackContext - The scope in which to call the callbacks.
 */ var Collider = new Class({
                initialize: function Collider(world, overlapOnly, object1, object2, collideCallback, processCallback, callbackContext) {
                    /**
         * The world in which the bodies will collide.
         *
         * @name Phaser.Physics.Arcade.Collider#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The name of the collider (unused by Phaser).
         *
         * @name Phaser.Physics.Arcade.Collider#name
         * @type {string}
         * @since 3.1.0
         */ this.name = "";
                    /**
         * Whether the collider is active.
         *
         * @name Phaser.Physics.Arcade.Collider#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Whether to check for collisions or overlaps.
         *
         * @name Phaser.Physics.Arcade.Collider#overlapOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.overlapOnly = overlapOnly;
                    /**
         * The first object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object1
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object1 = object1;
                    /**
         * The second object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object2
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object2 = object2;
                    /**
         * The callback to invoke when the two objects collide.
         *
         * @name Phaser.Physics.Arcade.Collider#collideCallback
         * @type {ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.collideCallback = collideCallback;
                    /**
         * If a processCallback exists it must return true or collision checking will be skipped.
         *
         * @name Phaser.Physics.Arcade.Collider#processCallback
         * @type {ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.processCallback = processCallback;
                    /**
         * The context the collideCallback and processCallback will run in.
         *
         * @name Phaser.Physics.Arcade.Collider#callbackContext
         * @type {object}
         * @since 3.0.0
         */ this.callbackContext = callbackContext;
                },
                /**
     * A name for the Collider.
     *
     * Phaser does not use this value, it's for your own reference.
     *
     * @method Phaser.Physics.Arcade.Collider#setName
     * @since 3.1.0
     *
     * @param {string} name - The name to assign to the Collider.
     *
     * @return {Phaser.Physics.Arcade.Collider} This Collider instance.
     */ setName: function(name) {
                    this.name = name;
                    return this;
                },
                /**
     * Called by World as part of its step processing, initial operation of collision checking.
     *
     * @method Phaser.Physics.Arcade.Collider#update
     * @since 3.0.0
     */ update: function() {
                    this.world.collideObjects(this.object1, this.object2, this.collideCallback, this.processCallback, this.callbackContext, this.overlapOnly);
                },
                /**
     * Removes Collider from World and disposes of its resources.
     *
     * @method Phaser.Physics.Arcade.Collider#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.world.removeCollider(this);
                    this.active = false;
                    this.world = null;
                    this.object1 = null;
                    this.object2 = null;
                    this.collideCallback = null;
                    this.processCallback = null;
                    this.callbackContext = null;
                }
            });
            module1.exports = Collider;
        /***/ },
        /* 529 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var Vector2 = __webpack_require__(3);
            var pointStart = new Vector2();
            var pointEnd = new Vector2();
            /**
 * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The world x coordinate for the top-left of the area.
 * @param {number} worldY - The world y coordinate for the top-left of the area.
 * @param {number} width - The width of the area.
 * @param {number} height - The height of the area.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinWorldXY = function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                var worldToTileXY = layer.tilemapLayer.tilemap._convert.WorldToTileXY;
                //  Top left corner of the rect, rounded down to include partial tiles
                worldToTileXY(worldX, worldY, true, pointStart, camera, layer);
                var xStart = pointStart.x;
                var yStart = pointStart.y;
                //  Bottom right corner of the rect, rounded up to include partial tiles
                worldToTileXY(worldX + width, worldY + height, false, pointEnd, camera, layer);
                var xEnd = Math.ceil(pointEnd.x);
                var yEnd = Math.ceil(pointEnd.y);
                return GetTilesWithin(xStart, yStart, xEnd - xStart, yEnd - yStart, filteringOptions, layer);
            };
            module1.exports = GetTilesWithinWorldXY;
        /***/ },
        /* 530 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A function to process the collision callbacks between a single tile and an Arcade Physics enabled Game Object.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileCallbacks
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to process.
 * @param {Phaser.GameObjects.Sprite} sprite - The Game Object to process with the Tile.
 *
 * @return {boolean} The result of the callback, `true` for further processing, or `false` to skip this pair.
 */ var ProcessTileCallbacks = function(tile, sprite) {
                //  Tile callbacks take priority over layer level callbacks
                if (tile.collisionCallback) return !tile.collisionCallback.call(tile.collisionCallbackContext, sprite, tile);
                else if (tile.layer.callbacks[tile.index]) return !tile.layer.callbacks[tile.index].callback.call(tile.layer.callbacks[tile.index].callbackContext, sprite, tile);
                return true;
            };
            module1.exports = ProcessTileCallbacks;
        /***/ },
        /* 531 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Vladimir Agafonkin
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var quickselect = __webpack_require__(436);
            /**
 * @classdesc
 * RBush is a high-performance JavaScript library for 2D spatial indexing of points and rectangles.
 * It's based on an optimized R-tree data structure with bulk insertion support.
 *
 * Spatial index is a special data structure for points and rectangles that allows you to perform queries like
 * "all items within this bounding box" very efficiently (e.g. hundreds of times faster than looping over all items).
 *
 * This version of RBush uses a fixed min/max accessor structure of `[ '.left', '.top', '.right', '.bottom' ]`.
 * This is to avoid the eval like function creation that the original library used, which caused CSP policy violations.
 * 
 * rbush is forked from https://github.com/mourner/rbush by Vladimir Agafonkin
 *
 * @class RTree
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 */ function rbush(maxEntries) {
                var format = [
                    ".left",
                    ".top",
                    ".right",
                    ".bottom"
                ];
                if (!(this instanceof rbush)) return new rbush(maxEntries, format);
                // max entries in a node is 9 by default; min node fill is 40% for best performance
                this._maxEntries = Math.max(4, maxEntries || 9);
                this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
                this.clear();
            }
            rbush.prototype = {
                all: function() {
                    return this._all(this.data, []);
                },
                search: function(bbox) {
                    var node = this.data, result = [], toBBox = this.toBBox;
                    if (!intersects(bbox, node)) return result;
                    var nodesToSearch = [], i, len, child, childBBox;
                    while(node){
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            childBBox = node.leaf ? toBBox(child) : child;
                            if (intersects(bbox, childBBox)) {
                                if (node.leaf) result.push(child);
                                else if (contains(bbox, childBBox)) this._all(child, result);
                                else nodesToSearch.push(child);
                            }
                        }
                        node = nodesToSearch.pop();
                    }
                    return result;
                },
                collides: function(bbox) {
                    var node = this.data, toBBox = this.toBBox;
                    if (!intersects(bbox, node)) return false;
                    var nodesToSearch = [], i, len, child, childBBox;
                    while(node){
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            childBBox = node.leaf ? toBBox(child) : child;
                            if (intersects(bbox, childBBox)) {
                                if (node.leaf || contains(bbox, childBBox)) return true;
                                nodesToSearch.push(child);
                            }
                        }
                        node = nodesToSearch.pop();
                    }
                    return false;
                },
                load: function(data) {
                    if (!(data && data.length)) return this;
                    if (data.length < this._minEntries) {
                        for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
                        return this;
                    }
                    // recursively build the tree with the given data from scratch using OMT algorithm
                    var node = this._build(data.slice(), 0, data.length - 1, 0);
                    if (!this.data.children.length) // save as is if tree is empty
                    this.data = node;
                    else if (this.data.height === node.height) // split root if trees have the same height
                    this._splitRoot(this.data, node);
                    else {
                        if (this.data.height < node.height) {
                            // swap trees if inserted one is bigger
                            var tmpNode = this.data;
                            this.data = node;
                            node = tmpNode;
                        }
                        // insert the small tree into the large tree at appropriate level
                        this._insert(node, this.data.height - node.height - 1, true);
                    }
                    return this;
                },
                insert: function(item) {
                    if (item) this._insert(item, this.data.height - 1);
                    return this;
                },
                clear: function() {
                    this.data = createNode([]);
                    return this;
                },
                remove: function(item, equalsFn) {
                    if (!item) return this;
                    var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
                    // depth-first iterative tree traversal
                    while(node || path.length){
                        if (!node) {
                            node = path.pop();
                            parent = path[path.length - 1];
                            i = indexes.pop();
                            goingUp = true;
                        }
                        if (node.leaf) {
                            index = findItem(item, node.children, equalsFn);
                            if (index !== -1) {
                                // item found, remove the item and condense tree upwards
                                node.children.splice(index, 1);
                                path.push(node);
                                this._condense(path);
                                return this;
                            }
                        }
                        if (!goingUp && !node.leaf && contains(node, bbox)) {
                            path.push(node);
                            indexes.push(i);
                            i = 0;
                            parent = node;
                            node = node.children[0];
                        } else if (parent) {
                            i++;
                            node = parent.children[i];
                            goingUp = false;
                        } else node = null; // nothing found
                    }
                    return this;
                },
                toBBox: function(item) {
                    return item;
                },
                compareMinX: compareNodeMinX,
                compareMinY: compareNodeMinY,
                toJSON: function() {
                    return this.data;
                },
                fromJSON: function(data) {
                    this.data = data;
                    return this;
                },
                _all: function(node, result) {
                    var nodesToSearch = [];
                    while(node){
                        if (node.leaf) result.push.apply(result, node.children);
                        else nodesToSearch.push.apply(nodesToSearch, node.children);
                        node = nodesToSearch.pop();
                    }
                    return result;
                },
                _build: function(items, left, right, height) {
                    var N = right - left + 1, M = this._maxEntries, node;
                    if (N <= M) {
                        // reached leaf level; return leaf
                        node = createNode(items.slice(left, right + 1));
                        calcBBox(node, this.toBBox);
                        return node;
                    }
                    if (!height) {
                        // target height of the bulk-loaded tree
                        height = Math.ceil(Math.log(N) / Math.log(M));
                        // target number of root entries to maximize storage utilization
                        M = Math.ceil(N / Math.pow(M, height - 1));
                    }
                    node = createNode([]);
                    node.leaf = false;
                    node.height = height;
                    // split the items into M mostly square tiles
                    var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
                    multiSelect(items, left, right, N1, this.compareMinX);
                    for(i = left; i <= right; i += N1){
                        right2 = Math.min(i + N1 - 1, right);
                        multiSelect(items, i, right2, N2, this.compareMinY);
                        for(j = i; j <= right2; j += N2){
                            right3 = Math.min(j + N2 - 1, right2);
                            // pack each entry recursively
                            node.children.push(this._build(items, j, right3, height - 1));
                        }
                    }
                    calcBBox(node, this.toBBox);
                    return node;
                },
                _chooseSubtree: function(bbox, node, level, path) {
                    var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
                    while(true){
                        path.push(node);
                        if (node.leaf || path.length - 1 === level) break;
                        minArea = minEnlargement = Infinity;
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            area = bboxArea(child);
                            enlargement = enlargedArea(bbox, child) - area;
                            // choose entry with the least area enlargement
                            if (enlargement < minEnlargement) {
                                minEnlargement = enlargement;
                                minArea = area < minArea ? area : minArea;
                                targetNode = child;
                            } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                            {
                                if (area < minArea) {
                                    minArea = area;
                                    targetNode = child;
                                }
                            }
                        }
                        node = targetNode || node.children[0];
                    }
                    return node;
                },
                _insert: function(item, level, isNode) {
                    var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
                    // find the best node for accommodating the item, saving all nodes along the path too
                    var node = this._chooseSubtree(bbox, this.data, level, insertPath);
                    // put the item into the node
                    node.children.push(item);
                    extend(node, bbox);
                    // split on node overflow; propagate upwards if necessary
                    while(level >= 0){
                        if (insertPath[level].children.length > this._maxEntries) {
                            this._split(insertPath, level);
                            level--;
                        } else break;
                    }
                    // adjust bboxes along the insertion path
                    this._adjustParentBBoxes(bbox, insertPath, level);
                },
                // split overflowed node into two
                _split: function(insertPath, level) {
                    var node = insertPath[level], M = node.children.length, m = this._minEntries;
                    this._chooseSplitAxis(node, m, M);
                    var splitIndex = this._chooseSplitIndex(node, m, M);
                    var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
                    newNode.height = node.height;
                    newNode.leaf = node.leaf;
                    calcBBox(node, this.toBBox);
                    calcBBox(newNode, this.toBBox);
                    if (level) insertPath[level - 1].children.push(newNode);
                    else this._splitRoot(node, newNode);
                },
                _splitRoot: function(node, newNode) {
                    // split root node
                    this.data = createNode([
                        node,
                        newNode
                    ]);
                    this.data.height = node.height + 1;
                    this.data.leaf = false;
                    calcBBox(this.data, this.toBBox);
                },
                _chooseSplitIndex: function(node, m, M) {
                    var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
                    minOverlap = minArea = Infinity;
                    for(i = m; i <= M - m; i++){
                        bbox1 = distBBox(node, 0, i, this.toBBox);
                        bbox2 = distBBox(node, i, M, this.toBBox);
                        overlap = intersectionArea(bbox1, bbox2);
                        area = bboxArea(bbox1) + bboxArea(bbox2);
                        // choose distribution with minimum overlap
                        if (overlap < minOverlap) {
                            minOverlap = overlap;
                            index = i;
                            minArea = area < minArea ? area : minArea;
                        } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
                        {
                            if (area < minArea) {
                                minArea = area;
                                index = i;
                            }
                        }
                    }
                    return index;
                },
                // sorts node children by the best axis for split
                _chooseSplitAxis: function(node, m, M) {
                    var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
                    // if total distributions margin value is minimal for x, sort by minX,
                    // otherwise it's already sorted by minY
                    if (xMargin < yMargin) node.children.sort(compareMinX);
                },
                // total margin of all possible split distributions where each node is at least m full
                _allDistMargin: function(node, m, M, compare) {
                    node.children.sort(compare);
                    var toBBox = this.toBBox, leftBBox = distBBox(node, 0, m, toBBox), rightBBox = distBBox(node, M - m, M, toBBox), margin = bboxMargin(leftBBox) + bboxMargin(rightBBox), i, child;
                    for(i = m; i < M - m; i++){
                        child = node.children[i];
                        extend(leftBBox, node.leaf ? toBBox(child) : child);
                        margin += bboxMargin(leftBBox);
                    }
                    for(i = M - m - 1; i >= m; i--){
                        child = node.children[i];
                        extend(rightBBox, node.leaf ? toBBox(child) : child);
                        margin += bboxMargin(rightBBox);
                    }
                    return margin;
                },
                _adjustParentBBoxes: function(bbox, path, level) {
                    // adjust bboxes along the given tree path
                    for(var i = level; i >= 0; i--)extend(path[i], bbox);
                },
                _condense: function(path) {
                    // go through the path, removing empty nodes and updating bboxes
                    for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
                        if (i > 0) {
                            siblings = path[i - 1].children;
                            siblings.splice(siblings.indexOf(path[i]), 1);
                        } else this.clear();
                    } else calcBBox(path[i], this.toBBox);
                },
                compareMinX: function(a, b) {
                    return a.left - b.left;
                },
                compareMinY: function(a, b) {
                    return a.top - b.top;
                },
                toBBox: function(a) {
                    return {
                        minX: a.left,
                        minY: a.top,
                        maxX: a.right,
                        maxY: a.bottom
                    };
                }
            };
            function findItem(item, items, equalsFn) {
                if (!equalsFn) return items.indexOf(item);
                for(var i = 0; i < items.length; i++){
                    if (equalsFn(item, items[i])) return i;
                }
                return -1;
            }
            // calculate node's bbox from bboxes of its children
            function calcBBox(node, toBBox) {
                distBBox(node, 0, node.children.length, toBBox, node);
            }
            // min bounding rectangle of node children from k to p-1
            function distBBox(node, k, p, toBBox, destNode) {
                if (!destNode) destNode = createNode(null);
                destNode.minX = Infinity;
                destNode.minY = Infinity;
                destNode.maxX = -Infinity;
                destNode.maxY = -Infinity;
                for(var i = k, child; i < p; i++){
                    child = node.children[i];
                    extend(destNode, node.leaf ? toBBox(child) : child);
                }
                return destNode;
            }
            function extend(a, b) {
                a.minX = Math.min(a.minX, b.minX);
                a.minY = Math.min(a.minY, b.minY);
                a.maxX = Math.max(a.maxX, b.maxX);
                a.maxY = Math.max(a.maxY, b.maxY);
                return a;
            }
            function compareNodeMinX(a, b) {
                return a.minX - b.minX;
            }
            function compareNodeMinY(a, b) {
                return a.minY - b.minY;
            }
            function bboxArea(a) {
                return (a.maxX - a.minX) * (a.maxY - a.minY);
            }
            function bboxMargin(a) {
                return a.maxX - a.minX + (a.maxY - a.minY);
            }
            function enlargedArea(a, b) {
                return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
            }
            function intersectionArea(a, b) {
                var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
                return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
            }
            function contains(a, b) {
                return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
            }
            function intersects(a, b) {
                return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
            }
            function createNode(children) {
                return {
                    children: children,
                    height: 1,
                    leaf: true,
                    minX: Infinity,
                    minY: Infinity,
                    maxX: -Infinity,
                    maxY: -Infinity
                };
            }
            // sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
            // combines selection algorithm with binary divide & conquer approach
            function multiSelect(arr, left, right, n, compare) {
                var stack = [
                    left,
                    right
                ], mid;
                while(stack.length){
                    right = stack.pop();
                    left = stack.pop();
                    if (right - left <= n) continue;
                    mid = left + Math.ceil((right - left) / n / 2) * n;
                    quickselect(arr, mid, left, right, compare);
                    stack.push(left, mid, mid, right);
                }
            }
            module1.exports = rbush;
        /***/ },
        /* 532 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileCheckX = __webpack_require__(533);
            var TileCheckY = __webpack_require__(535);
            var TileIntersectsBody = __webpack_require__(248);
            /**
 * The core separation function to separate a physics body and a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.SeparateTile
 * @since 3.0.0
 *
 * @param {number} i - The index of the tile within the map data.
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to collide against.
 * @param {Phaser.Geom.Rectangle} tileWorldRect - A rectangle-like object defining the dimensions of the tile.
 * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {boolean} `true` if the body was separated, otherwise `false`.
 */ var SeparateTile = function(i, body, tile, tileWorldRect, tilemapLayer, tileBias, isLayer) {
                var tileLeft = tileWorldRect.left;
                var tileTop = tileWorldRect.top;
                var tileRight = tileWorldRect.right;
                var tileBottom = tileWorldRect.bottom;
                var faceHorizontal = tile.faceLeft || tile.faceRight;
                var faceVertical = tile.faceTop || tile.faceBottom;
                if (!isLayer) {
                    faceHorizontal = true;
                    faceVertical = true;
                }
                //  We don't need to go any further if this tile doesn't actually have any colliding faces. This
                //  could happen if the tile was meant to be collided with re: a callback, but otherwise isn't
                //  needed for separation.
                if (!faceHorizontal && !faceVertical) return false;
                var ox = 0;
                var oy = 0;
                var minX = 0;
                var minY = 1;
                if (body.deltaAbsX() > body.deltaAbsY()) //  Moving faster horizontally, check X axis first
                minX = -1;
                else if (body.deltaAbsX() < body.deltaAbsY()) //  Moving faster vertically, check Y axis first
                minY = -1;
                if (body.deltaX() !== 0 && body.deltaY() !== 0 && faceHorizontal && faceVertical) {
                    //  We only need do this if both axes have colliding faces AND we're moving in both
                    //  directions
                    minX = Math.min(Math.abs(body.position.x - tileRight), Math.abs(body.right - tileLeft));
                    minY = Math.min(Math.abs(body.position.y - tileBottom), Math.abs(body.bottom - tileTop));
                }
                if (minX < minY) {
                    if (faceHorizontal) {
                        ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                        //  That's horizontal done, check if we still intersects? If not then we can return now
                        if (ox !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                    }
                    if (faceVertical) oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                } else {
                    if (faceVertical) {
                        oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                        //  That's vertical done, check if we still intersects? If not then we can return now
                        if (oy !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                    }
                    if (faceHorizontal) ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                }
                return ox !== 0 || oy !== 0;
            };
            module1.exports = SeparateTile;
        /***/ },
        /* 533 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationX = __webpack_require__(534);
            /**
 * Check the body against the given tile on the X axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileLeft - The left position of the tile within the tile world.
 * @param {number} tileRight - The right position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckX = function(body, tile, tileLeft, tileRight, tileBias, isLayer) {
                var ox = 0;
                var faceLeft = tile.faceLeft;
                var faceRight = tile.faceRight;
                var collideLeft = tile.collideLeft;
                var collideRight = tile.collideRight;
                if (!isLayer) {
                    faceLeft = true;
                    faceRight = true;
                    collideLeft = true;
                    collideRight = true;
                }
                if (body.deltaX() < 0 && collideRight && body.checkCollision.left) //  Body is moving LEFT
                {
                    if (faceRight && body.x < tileRight) {
                        ox = body.x - tileRight;
                        if (ox < -tileBias) ox = 0;
                    }
                } else if (body.deltaX() > 0 && collideLeft && body.checkCollision.right) //  Body is moving RIGHT
                {
                    if (faceLeft && body.right > tileLeft) {
                        ox = body.right - tileLeft;
                        if (ox > tileBias) ox = 0;
                    }
                }
                if (ox !== 0) {
                    if (body.customSeparateX) body.overlapX = ox;
                    else ProcessTileSeparationX(body, ox);
                }
                return ox;
            };
            module1.exports = TileCheckX;
        /***/ },
        /* 534 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} x - The x separation amount.
 */ var ProcessTileSeparationX = function(body, x) {
                if (x < 0) {
                    body.blocked.none = false;
                    body.blocked.left = true;
                } else if (x > 0) {
                    body.blocked.none = false;
                    body.blocked.right = true;
                }
                body.position.x -= x;
                if (body.bounce.x === 0) body.velocity.x = 0;
                else body.velocity.x = -body.velocity.x * body.bounce.x;
            };
            module1.exports = ProcessTileSeparationX;
        /***/ },
        /* 535 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationY = __webpack_require__(536);
            /**
 * Check the body against the given tile on the Y axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileTop - The top position of the tile within the tile world.
 * @param {number} tileBottom - The bottom position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckY = function(body, tile, tileTop, tileBottom, tileBias, isLayer) {
                var oy = 0;
                var faceTop = tile.faceTop;
                var faceBottom = tile.faceBottom;
                var collideUp = tile.collideUp;
                var collideDown = tile.collideDown;
                if (!isLayer) {
                    faceTop = true;
                    faceBottom = true;
                    collideUp = true;
                    collideDown = true;
                }
                if (body.deltaY() < 0 && collideDown && body.checkCollision.up) //  Body is moving UP
                {
                    if (faceBottom && body.y < tileBottom) {
                        oy = body.y - tileBottom;
                        if (oy < -tileBias) oy = 0;
                    }
                } else if (body.deltaY() > 0 && collideUp && body.checkCollision.down) //  Body is moving DOWN
                {
                    if (faceTop && body.bottom > tileTop) {
                        oy = body.bottom - tileTop;
                        if (oy > tileBias) oy = 0;
                    }
                }
                if (oy !== 0) {
                    if (body.customSeparateY) body.overlapY = oy;
                    else ProcessTileSeparationY(body, oy);
                }
                return oy;
            };
            module1.exports = TileCheckY;
        /***/ },
        /* 536 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} y - The y separation amount.
 */ var ProcessTileSeparationY = function(body, y) {
                if (y < 0) {
                    body.blocked.none = false;
                    body.blocked.up = true;
                } else if (y > 0) {
                    body.blocked.none = false;
                    body.blocked.down = true;
                }
                body.position.y -= y;
                if (body.bounce.y === 0) body.velocity.y = 0;
                else body.velocity.y = -body.velocity.y * body.bounce.y;
            };
            module1.exports = ProcessTileSeparationY;
        /***/ },
        /* 537 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapX = __webpack_require__(246);
            var ProcessX = __webpack_require__(1389);
            /**
 * Separates two overlapping bodies on the X-axis (horizontally).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no horizontal overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateX = function(body1, body2, overlapOnly, bias) {
                var overlap = GetOverlapX(body1, body2, overlapOnly, bias);
                var body1Immovable = body1.immovable;
                var body2Immovable = body2.immovable;
                //  Can't separate two immovable bodies, or a body with its own custom separation logic
                if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateX || body2.customSeparateX) //  return true if there was some overlap, otherwise false
                return overlap !== 0 || body1.embedded && body2.embedded;
                var blockedState = ProcessX.Set(body1, body2, overlap);
                if (!body1Immovable && !body2Immovable) {
                    if (blockedState > 0) return true;
                    return ProcessX.Check();
                } else if (body1Immovable) ProcessX.RunImmovableBody1(blockedState);
                else if (body2Immovable) ProcessX.RunImmovableBody2(blockedState);
                //  If we got this far then there WAS overlap, and separation is complete, so return true
                return true;
            };
            module1.exports = SeparateX;
        /***/ },
        /* 538 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapY = __webpack_require__(247);
            var ProcessY = __webpack_require__(1390);
            /**
 * Separates two overlapping bodies on the Y-axis (vertically).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no vertical overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateY = function(body1, body2, overlapOnly, bias) {
                var overlap = GetOverlapY(body1, body2, overlapOnly, bias);
                var body1Immovable = body1.immovable;
                var body2Immovable = body2.immovable;
                //  Can't separate two immovable bodies, or a body with its own custom separation logic
                if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateY || body2.customSeparateY) //  return true if there was some overlap, otherwise false
                return overlap !== 0 || body1.embedded && body2.embedded;
                var blockedState = ProcessY.Set(body1, body2, overlap);
                if (!body1Immovable && !body2Immovable) {
                    if (blockedState > 0) return true;
                    return ProcessY.Check();
                } else if (body1Immovable) ProcessY.RunImmovableBody1(blockedState);
                else if (body2Immovable) ProcessY.RunImmovableBody2(blockedState);
                //  If we got this far then there WAS overlap, and separation is complete, so return true
                return true;
            };
            module1.exports = SeparateY;
        /***/ },
        /* 539 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleContains = __webpack_require__(66);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(62);
            var RectangleContains = __webpack_require__(57);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Static Arcade Physics Body.
 *
 * A Static Body never moves, and isn't automatically synchronized with its parent Game Object.
 * That means if you make any change to the parent's origin, position, or scale after creating or adding the body, you'll need to update the Static Body manually.
 *
 * A Static Body can collide with other Bodies, but is never moved by collisions.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Body}.
 *
 * @class StaticBody
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Static Body belongs to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object this Static Body belongs to.
 */ var StaticBody = new Class({
                initialize: function StaticBody(world, gameObject) {
                    var width = gameObject.displayWidth ? gameObject.displayWidth : 64;
                    var height = gameObject.displayHeight ? gameObject.displayHeight : 64;
                    /**
         * The Arcade Physics simulation this Static Body belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticBody#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Game Object this Static Body belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = gameObject;
                    /**
         * Whether the Static Body's boundary is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowStaticBody;
                    /**
         * The color of this Static Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.staticBodyDebugColor;
                    /**
         * Whether this Static Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                    /**
         * Whether this Static Body's boundary is circular (`true`) or rectangular (`false`).
         *
         * @name Phaser.Physics.Arcade.StaticBody#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isCircle = false;
                    /**
         * If this Static Body is circular, this is the radius of the boundary, as set by {@link Phaser.Physics.Arcade.StaticBody#setCircle}, in pixels.
         * Equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.StaticBody#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.radius = 0;
                    /**
         * The offset set by {@link Phaser.Physics.Arcade.StaticBody#setCircle} or {@link Phaser.Physics.Arcade.StaticBody#setSize}.
         *
         * This doesn't affect the Static Body's position, because a Static Body does not follow its Game Object.
         *
         * @name Phaser.Physics.Arcade.StaticBody#offset
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.offset = new Vector2();
                    /**
         * The position of this Static Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - width * gameObject.originX, gameObject.y - height * gameObject.originY);
                    /**
         * The width of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * Half the Static Body's width, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(this.width / 2);
                    /**
         * Half the Static Body's height, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(this.height / 2);
                    /**
         * The center of the Static Body's boundary.
         * This is the midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.StaticBody#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    /**
         * A constant zero velocity used by the Arcade Physics simulation for calculations.
         *
         * @name Phaser.Physics.Arcade.StaticBody#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.velocity = Vector2.ZERO;
                    /**
         * A constant `false` value expected by the Arcade Physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#allowGravity
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.allowGravity = false;
                    /**
         * Gravitational force applied specifically to this Body. Values are in pixels per second squared. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gravity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.gravity = Vector2.ZERO;
                    /**
         * Rebound, or restitution, following a collision, relative to 1. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#bounce
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.bounce = Vector2.ZERO;
                    //  If true this Body will dispatch events
                    /**
         * Whether the simulation emits a `worldbounds` event when this StaticBody collides with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary and never trigger a `worldbounds` event.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#onWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.onWorldBounds = false;
                    /**
         * Whether the simulation emits a `collide` event when this StaticBody collides with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onCollide = false;
                    /**
         * Whether the simulation emits an `overlap` event when this StaticBody overlaps with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onOverlap = false;
                    /**
         * The StaticBody's inertia, relative to a default unit (1). With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.StaticBody#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                    /**
         * Whether this object can be moved by collisions with another body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#immovable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.immovable = true;
                    /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Static Bodies are not pushable.
         *
         * @name Phaser.Physics.Arcade.StaticBody#pushable
         * @type {boolean}
         * @default false
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = false;
                    /**
         * A flag disabling the default horizontal separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                    /**
         * A flag disabling the default vertical separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                    /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                    /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                    /**
         * The amount of overlap (before separation), if this StaticBody is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                    /**
         * Whether this StaticBody has ever overlapped with another while both were not moving.
         *
         * @name Phaser.Physics.Arcade.StaticBody#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                    /**
         * Whether this StaticBody interacts with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#collideWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                    /**
         * Whether this StaticBody is checked for collisions and for which directions. You can set `checkCollision.none = false` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.StaticBody#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = {
                        none: false,
                        up: true,
                        down: true,
                        left: true,
                        right: true
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.touching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         * The values are always false for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.wasTouching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.blocked = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * The StaticBody's physics type (static by default).
         *
         * @name Phaser.Physics.Arcade.StaticBody#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                    /**
         * The calculated change in the Static Body's horizontal position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dx = 0;
                    /**
         * The calculated change in the Static Body's vertical position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dy = 0;
                },
                /**
     * Changes the Game Object this Body is bound to.
     * First it removes its reference from the old Game Object, then sets the new one.
     * You can optionally update the position and dimensions of this Body to reflect that of the new Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setGameObject
     * @since 3.1.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The new Game Object that will own this Body.
     * @param {boolean} [update=true] - Reposition and resize this Body to match the new Game Object?
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ setGameObject: function(gameObject, update) {
                    if (gameObject && gameObject !== this.gameObject) {
                        //  Remove this body from the old game object
                        this.gameObject.body = null;
                        gameObject.body = this;
                        //  Update our reference
                        this.gameObject = gameObject;
                    }
                    if (update) this.updateFromGameObject();
                    return this;
                },
                /**
     * Syncs the Static Body's position and size with its parent Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     * @since 3.1.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ updateFromGameObject: function() {
                    this.world.staticTree.remove(this);
                    var gameObject = this.gameObject;
                    gameObject.getTopLeft(this.position);
                    this.width = gameObject.displayWidth;
                    this.height = gameObject.displayHeight;
                    this.halfWidth = Math.abs(this.width / 2);
                    this.halfHeight = Math.abs(this.height / 2);
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Positions the Static Body at an offset from its Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setOffset
     * @since 3.4.0
     *
     * @param {number} x - The horizontal offset of the Static Body from the Game Object's `x`.
     * @param {number} y - The vertical offset of the Static Body from the Game Object's `y`.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setOffset: function(x, y) {
                    if (y === undefined) y = x;
                    this.world.staticTree.remove(this);
                    this.position.x -= this.offset.x;
                    this.position.y -= this.offset.y;
                    this.offset.set(x, y);
                    this.position.x += this.offset.x;
                    this.position.y += this.offset.y;
                    this.updateCenter();
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Sets the size of the Static Body.
     * When `center` is true, also repositions it.
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Place the Static Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setSize: function(width, height, center) {
                    if (center === undefined) center = true;
                    var gameObject = this.gameObject;
                    if (!width && gameObject.frame) width = gameObject.frame.realWidth;
                    if (!height && gameObject.frame) height = gameObject.frame.realHeight;
                    this.world.staticTree.remove(this);
                    this.width = width;
                    this.height = height;
                    this.halfWidth = Math.floor(width / 2);
                    this.halfHeight = Math.floor(height / 2);
                    if (center && gameObject.getCenter) {
                        var ox = gameObject.displayWidth / 2;
                        var oy = gameObject.displayHeight / 2;
                        this.position.x -= this.offset.x;
                        this.position.y -= this.offset.y;
                        this.offset.set(ox - this.halfWidth, oy - this.halfHeight);
                        this.position.x += this.offset.x;
                        this.position.y += this.offset.y;
                    }
                    this.updateCenter();
                    this.isCircle = false;
                    this.radius = 0;
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Sets this Static Body to have a circular body and sets its size and position.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the StaticBody, in pixels.
     * @param {number} [offsetX] - The horizontal offset of the StaticBody from its Game Object, in pixels.
     * @param {number} [offsetY] - The vertical offset of the StaticBody from its Game Object, in pixels.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = this.offset.x;
                    if (offsetY === undefined) offsetY = this.offset.y;
                    if (radius > 0) {
                        this.world.staticTree.remove(this);
                        this.isCircle = true;
                        this.radius = radius;
                        this.width = radius * 2;
                        this.height = radius * 2;
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.offset.set(offsetX, offsetY);
                        this.updateCenter();
                        this.world.staticTree.insert(this);
                    } else this.isCircle = false;
                    return this;
                },
                /**
     * Updates the StaticBody's `center` from its `position` and dimensions.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                /**
     * Resets this Body to the given coordinates. Also positions its parent Game Object to the same coordinates.
     *
     * @method Phaser.Physics.Arcade.StaticBody#reset
     * @since 3.0.0
     *
     * @param {number} [x] - The x coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     * @param {number} [y] - The y coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     */ reset: function(x, y) {
                    var gameObject = this.gameObject;
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    this.world.staticTree.remove(this);
                    gameObject.setPosition(x, y);
                    gameObject.getTopLeft(this.position);
                    this.updateCenter();
                    this.world.staticTree.insert(this);
                },
                /**
     * NOOP function. A Static Body cannot be stopped.
     *
     * @method Phaser.Physics.Arcade.StaticBody#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ stop: function() {
                    return this;
                },
                /**
     * Returns the x and y coordinates of the top left and bottom right points of the StaticBody.
     *
     * @method Phaser.Physics.Arcade.StaticBody#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - The object which will hold the coordinates of the bounds.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} The same object that was passed with `x`, `y`, `right` and `bottom` values matching the respective values of the StaticBody.
     */ getBounds: function(obj) {
                    obj.x = this.x;
                    obj.y = this.y;
                    obj.right = this.right;
                    obj.bottom = this.bottom;
                    return obj;
                },
                /**
     * Checks to see if a given x,y coordinate is colliding with this Static Body.
     *
     * @method Phaser.Physics.Arcade.StaticBody#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check against this body.
     * @param {number} y - The y coordinate to check against this body.
     *
     * @return {boolean} `true` if the given coordinate lies within this body, otherwise `false`.
     */ hitTest: function(x, y) {
                    return this.isCircle ? CircleContains(this, x, y) : RectangleContains(this, x, y);
                },
                /**
     * NOOP
     *
     * @method Phaser.Physics.Arcade.StaticBody#postUpdate
     * @since 3.12.0
     */ postUpdate: function() {},
                /**
     * The absolute (non-negative) change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsX: function() {
                    return 0;
                },
                /**
     * The absolute (non-negative) change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsY: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaX
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaX: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaY
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaY: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's rotation from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaZ
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's rotation from the previous step. Always zero.
     */ deltaZ: function() {
                    return 0;
                },
                /**
     * Disables this Body and marks it for destruction during the next step.
     *
     * @method Phaser.Physics.Arcade.StaticBody#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enable = false;
                    this.world.pendingDestroy.set(this);
                },
                /**
     * Draws a graphical representation of the StaticBody for visual debugging purposes.
     *
     * @method Phaser.Physics.Arcade.StaticBody#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to use for the debug drawing of the StaticBody.
     */ drawDebug: function(graphic) {
                    var pos = this.position;
                    var x = pos.x + this.halfWidth;
                    var y = pos.y + this.halfHeight;
                    if (this.debugShowBody) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor, 1);
                        if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                        else graphic.strokeRect(pos.x, pos.y, this.width, this.height);
                    }
                },
                /**
     * Indicates whether the StaticBody is going to be showing a debug visualization during postUpdate.
     *
     * @method Phaser.Physics.Arcade.StaticBody#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} Whether or not the StaticBody is going to show the debug visualization during postUpdate.
     */ willDrawDebug: function() {
                    return this.debugShowBody;
                },
                /**
     * Sets the Mass of the StaticBody. Will set the Mass to 0.1 if the value passed is less than or equal to zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setMass
     * @since 3.0.0
     *
     * @param {number} value - The value to set the Mass to. Values of zero or less are changed to 0.1.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setMass: function(value) {
                    if (value <= 0) //  Causes havoc otherwise
                    value = 0.1;
                    this.mass = value;
                    return this;
                },
                /**
     * The x coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.world.staticTree.remove(this);
                        this.position.x = value;
                        this.world.staticTree.insert(this);
                    }
                },
                /**
     * The y coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.world.staticTree.remove(this);
                        this.position.y = value;
                        this.world.staticTree.insert(this);
                    }
                },
                /**
     * Returns the left-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                /**
     * The right-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                /**
     * The highest y coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                /**
     * The lowest y coordinate of the area of the StaticBody. (y + height)
     *
     * @name Phaser.Physics.Arcade.StaticBody#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            module1.exports = StaticBody;
        /***/ },
        /* 540 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* @author       Richard Davey <rich@photonstorm.com>
* @copyright    2020 Photon Storm Ltd.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Global Plugin is installed just once into the Game owned Plugin Manager.
 * It can listen for Game events and respond to them.
 *
 * @class BasePlugin
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 */ var BasePlugin = new Class({
                initialize: function BasePlugin(pluginManager) {
                    /**
         * A handy reference to the Plugin Manager that is responsible for this plugin.
         * Can be used as a route to gain access to game systems and  events.
         *
         * @name Phaser.Plugins.BasePlugin#pluginManager
         * @type {Phaser.Plugins.PluginManager}
         * @protected
         * @since 3.8.0
         */ this.pluginManager = pluginManager;
                    /**
         * A reference to the Game instance this plugin is running under.
         *
         * @name Phaser.Plugins.BasePlugin#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.8.0
         */ this.game = pluginManager.game;
                },
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is first instantiated.
     * It will never be called again on this instance.
     * In here you can set-up whatever you need for this plugin to run.
     * If a plugin is set to automatically start then `BasePlugin.start` will be called immediately after this.
     * On a Scene Plugin, this method is never called. Use {@link Phaser.Plugins.ScenePlugin#boot} instead.
     *
     * @method Phaser.Plugins.BasePlugin#init
     * @since 3.8.0
     *
     * @param {?any} [data] - A value specified by the user, if any, from the `data` property of the plugin's configuration object (if started at game boot) or passed in the PluginManager's `install` method (if started manually).
     */ init: function() {},
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is started.
     * If a plugin is stopped, and then started again, this will get called again.
     * Typically called immediately after `BasePlugin.init`.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#start
     * @since 3.8.0
     */ start: function() {
                //  Here are the game-level events you can listen to.
                //  At the very least you should offer a destroy handler for when the game closes down.
                // var eventEmitter = this.game.events;
                // eventEmitter.once('destroy', this.gameDestroy, this);
                // eventEmitter.on('pause', this.gamePause, this);
                // eventEmitter.on('resume', this.gameResume, this);
                // eventEmitter.on('resize', this.gameResize, this);
                // eventEmitter.on('prestep', this.gamePreStep, this);
                // eventEmitter.on('step', this.gameStep, this);
                // eventEmitter.on('poststep', this.gamePostStep, this);
                // eventEmitter.on('prerender', this.gamePreRender, this);
                // eventEmitter.on('postrender', this.gamePostRender, this);
                },
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is stopped.
     * The game code has requested that your plugin stop doing whatever it does.
     * It is now considered as 'inactive' by the PluginManager.
     * Handle that process here (i.e. stop listening for events, etc)
     * If the plugin is started again then `BasePlugin.start` will be called again.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#stop
     * @since 3.8.0
     */ stop: function() {},
                /**
     * Game instance has been destroyed.
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.BasePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                    this.pluginManager = null;
                    this.game = null;
                    this.scene = null;
                    this.systems = null;
                }
            });
            module1.exports = BasePlugin;
        /***/ },
        /* 541 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Checks if the given tile coordinate is within the isometric layer bounds, or not.
 *
 * @function Phaser.Tilemaps.Components.CheckIsoBounds
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to check against.
 * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
 *
 * @return {boolean} Returns `true` if the coordinates are within the iso bounds.
 */ var CheckIsoBounds = function(tileX, tileY, layer, camera) {
                var tilemapLayer = layer.tilemapLayer;
                var cullPaddingX = tilemapLayer.cullPaddingX;
                var cullPaddingY = tilemapLayer.cullPaddingY;
                var pos = tilemapLayer.tilemap.tileToWorldXY(tileX, tileY, point, camera, tilemapLayer);
                // we always subtract 1/2 of the tile's height/width to make the culling distance start from the center of the tiles.
                return pos.x > camera.worldView.x + tilemapLayer.scaleX * layer.tileWidth * (-cullPaddingX - 0.5) && pos.x < camera.worldView.right + tilemapLayer.scaleX * layer.tileWidth * (cullPaddingX - 0.5) && pos.y > camera.worldView.y + tilemapLayer.scaleY * layer.tileHeight * (-cullPaddingY - 1.0) && pos.y < camera.worldView.bottom + tilemapLayer.scaleY * layer.tileHeight * (cullPaddingY - 0.5);
            };
            module1.exports = CheckIsoBounds;
        /***/ },
        /* 542 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
 * not change collision information.
 *
 * @function Phaser.Tilemaps.Components.ReplaceByIndex
 * @since 3.0.0
 *
 * @param {number} findIndex - The index of the tile to search for.
 * @param {number} newIndex - The index of the tile to replace it with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ReplaceByIndex = function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)if (tiles[i] && tiles[i].index === findIndex) tiles[i].index = newIndex;
            };
            module1.exports = ReplaceByIndex;
        /***/ },
        /* 543 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var SnapCeil = __webpack_require__(139);
            var SnapFloor = __webpack_require__(76);
            var bounds = new Rectangle();
            /**
 * Returns the bounds in the given orthogonal layer that are within the cameras viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.CullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle containing the culled bounds. If you wish to retain this object, clone it, as it's recycled internally.
 */ var CullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH, 0, true) + tilemapLayer.cullPaddingY;
                return bounds.setTo(boundsLeft, boundsTop, boundsRight - boundsLeft, boundsBottom - boundsTop);
            };
            module1.exports = CullBounds;
        /***/ },
        /* 544 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(543);
            var RunCull = __webpack_require__(159);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.CullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var CullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                //  Camera world view bounds, snapped for scaled tile size
                //  Cull Padding values are given in tiles, not pixels
                var bounds = CullBounds(layer, camera);
                if (tilemapLayer.skipCull || tilemapLayer.scrollFactorX !== 1 || tilemapLayer.scrollFactorY !== 1) {
                    bounds.left = 0;
                    bounds.right = layer.width;
                    bounds.top = 0;
                    bounds.bottom = layer.height;
                }
                RunCull(layer, bounds, renderOrder, outputArray);
                return outputArray;
            };
            module1.exports = CullTiles;
        /***/ },
        /* 545 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(546);
            var RunCull = __webpack_require__(159);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var HexagonalCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                if (!tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    RunCull(layer, bounds, renderOrder, outputArray);
                }
                return outputArray;
            };
            module1.exports = HexagonalCullTiles;
        /***/ },
        /* 546 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(139);
            var SnapFloor = __webpack_require__(76);
            /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var HexagonalCullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var len = layer.hexSideLength;
                var rowH = (tileH - len) / 2 + len;
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, rowH, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, rowH, 0, true) + tilemapLayer.cullPaddingY;
                return {
                    left: boundsLeft,
                    right: boundsRight,
                    top: boundsTop,
                    bottom: boundsBottom
                };
            };
            module1.exports = HexagonalCullBounds;
        /***/ },
        /* 547 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckIsoBounds = __webpack_require__(541);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.IsometricCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var IsometricCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                var mapData = layer.data;
                var mapWidth = layer.width;
                var mapHeight = layer.height;
                var drawLeft = 0;
                var drawRight = mapWidth;
                var drawTop = 0;
                var drawBottom = mapHeight;
                if (!tilemapLayer.skipCull) {
                    var x;
                    var y;
                    var tile;
                    if (renderOrder === 0) //  right-down
                    for(y = drawTop; y < drawBottom; y++){
                        for(x = drawLeft; mapData[y] && x < drawRight; x++)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 1) //  left-down
                    for(y = drawTop; y < drawBottom; y++){
                        for(x = drawRight; mapData[y] && x >= drawLeft; x--)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 2) //  right-up
                    for(y = drawBottom; y >= drawTop; y--){
                        for(x = drawLeft; mapData[y] && x < drawRight; x++)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 3) //  left-up
                    for(y = drawBottom; y >= drawTop; y--){
                        for(x = drawRight; mapData[y] && x >= drawLeft; x--)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                }
                tilemapLayer.tilesDrawn = outputArray.length;
                tilemapLayer.tilesTotal = mapWidth * mapHeight;
                return outputArray;
            };
            module1.exports = IsometricCullTiles;
        /***/ },
        /* 548 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(549);
            var RunCull = __webpack_require__(159);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var StaggeredCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                if (!tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    RunCull(layer, bounds, renderOrder, outputArray);
                }
                return outputArray;
            };
            module1.exports = StaggeredCullTiles;
        /***/ },
        /* 549 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(139);
            var SnapFloor = __webpack_require__(76);
            /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var StaggeredCullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH / 2, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH / 2, 0, true) + tilemapLayer.cullPaddingY;
                return {
                    left: boundsLeft,
                    right: boundsRight,
                    top: boundsTop,
                    bottom: boundsBottom
                };
            };
            module1.exports = StaggeredCullBounds;
        /***/ },
        /* 550 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from hexagonal tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var HexagonalTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                // similar to staggered, because Tiled uses the oddr representation.
                var x = layerWorldX + tileX * tileWidth + tileY % 2 * (tileWidth / 2);
                var y = layerWorldY + tileY * rowHeight;
                return point.set(x, y);
            };
            module1.exports = HexagonalTileToWorldXY;
        /***/ },
        /* 551 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from isometric tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var IsometricTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var x = layerWorldX + (tileX - tileY) * (tileWidth / 2);
                var y = layerWorldY + (tileX + tileY) * (tileHeight / 2);
                return point.set(x, y);
            };
            module1.exports = IsometricTileToWorldXY;
        /***/ },
        /* 552 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from staggered tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var StaggeredTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var x = layerWorldX + tileX * tileWidth + tileY % 2 * (tileWidth / 2);
                var y = layerWorldY + tileY * (tileHeight / 2);
                return point.set(x, y);
            };
            module1.exports = StaggeredTileToWorldXY;
        /***/ },
        /* 553 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileToWorldX = __webpack_require__(253);
            var TileToWorldY = __webpack_require__(254);
            var Vector2 = __webpack_require__(3);
            /**
 * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldXY
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var TileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2(0, 0);
                point.x = TileToWorldX(tileX, camera, layer);
                point.y = TileToWorldY(tileY, camera, layer);
                return point;
            };
            module1.exports = TileToWorldXY;
        /***/ },
        /* 554 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from hexagonal tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.HexagonalTileToWorldY
 * @since 3.50.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var HexagonalTileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (camera === undefined) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = tilemapLayer.tilemap.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                return layerWorldY + tileY * rowHeight;
            };
            module1.exports = HexagonalTileToWorldY;
        /***/ },
        /* 555 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from staggered tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldY
 * @since 3.50.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var StaggeredTileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (camera === undefined) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                return layerWorldY + tileY * (tileHeight / 2);
            };
            module1.exports = StaggeredTileToWorldY;
        /***/ },
        /* 556 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to hexagonal tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinates down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var HexagonalWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                // similar to staggered, because Tiled uses the oddr representation.
                var y = snapToFloor ? Math.floor(worldY / rowHeight) : worldY / rowHeight;
                var x = snapToFloor ? Math.floor((worldX - y % 2 * 0.5 * tileWidth) / tileWidth) : (worldX - y % 2 * 0.5 * tileWidth) / tileWidth;
                return point.set(x, y);
            };
            module1.exports = HexagonalWorldToTileXY;
        /***/ },
        /* 557 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to isometric tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var IsometricWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                var x = snapToFloor ? Math.floor((worldX / (tileWidth / 2) + worldY / (tileHeight / 2)) / 2) : (worldX / (tileWidth / 2) + worldY / (tileHeight / 2)) / 2;
                var y = snapToFloor ? Math.floor((worldY / (tileHeight / 2) - worldX / (tileWidth / 2)) / 2) : (worldY / (tileHeight / 2) - worldX / (tileWidth / 2)) / 2;
                return point.set(x, y);
            };
            module1.exports = IsometricWorldToTileXY;
        /***/ },
        /* 558 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to staggered tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var StaggeredWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                var y = snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
                var x = snapToFloor ? Math.floor((worldX + y % 2 * 0.5 * tileWidth) / tileWidth) : (worldX + y % 2 * 0.5 * tileWidth) / tileWidth;
                return point.set(x, y);
            };
            module1.exports = StaggeredWorldToTileXY;
        /***/ },
        /* 559 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WorldToTileX = __webpack_require__(255);
            var WorldToTileY = __webpack_require__(256);
            var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var WorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                if (!point) point = new Vector2(0, 0);
                point.x = WorldToTileX(worldX, snapToFloor, camera, layer);
                point.y = WorldToTileY(worldY, snapToFloor, camera, layer);
                return point;
            };
            module1.exports = WorldToTileXY;
        /***/ },
        /* 560 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to hexagonal tile Y coordinates (tile units), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.HexagonalWorldToTileY
 * @since 3.50.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var HexagonalWorldToTileY = function(worldY, snapToFloor, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    //  Find the world position relative to the static or dynamic layer's top left origin,
                    //  factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                return snapToFloor ? Math.floor(worldY / rowHeight) : worldY / rowHeight;
            };
            module1.exports = HexagonalWorldToTileY;
        /***/ },
        /* 561 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to staggered tile Y coordinates (tile units), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileY
 * @since 3.50.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var StaggeredWorldToTileY = function(worldY, snapToFloor, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    //  Find the world position relative to the static or dynamic layer's top left origin,
                    //  factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                return snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
            };
            module1.exports = StaggeredWorldToTileY;
        /***/ },
        /* 562 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(119);
            /**
 * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAt = function(tileX, tileY, layer) {
                if (IsInLayerBounds(tileX, tileY, layer)) {
                    var tile = layer.data[tileY][tileX];
                    return tile !== null && tile.index > -1;
                } else return false;
            };
            module1.exports = HasTileAt;
        /***/ },
        /* 563 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(85);
            var IsInLayerBounds = __webpack_require__(119);
            var CalculateFacesAt = __webpack_require__(252);
            /**
 * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAt = function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                if (replaceWithNull === undefined) replaceWithNull = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                var tile = layer.data[tileY][tileX];
                if (!tile) return null;
                else layer.data[tileY][tileX] = replaceWithNull ? null : new Tile(layer, -1, tileX, tileY, layer.tileWidth, layer.tileHeight);
                //  Recalculate faces only if the removed tile was a colliding tile
                if (recalculateFaces && tile && tile.collides) CalculateFacesAt(tileX, tileY, layer);
                return tile;
            };
            module1.exports = RemoveTileAt;
        /***/ },
        /* 564 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(40);
            var Parse2DArray = __webpack_require__(259);
            var ParseCSV = __webpack_require__(565);
            var ParseJSONTiled = __webpack_require__(566);
            var ParseWeltmeister = __webpack_require__(577);
            /**
 * Parses raw data of a given Tilemap format into a new MapData object. If no recognized data format
 * is found, returns `null`. When loading from CSV or a 2D array, you should specify the tileWidth &
 * tileHeight. When parsing from a map from Tiled, the tileWidth & tileHeight will be pulled from
 * the map data.
 *
 * @function Phaser.Tilemaps.Parsers.Parse
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number} mapFormat - See ../Formats.js.
 * @param {(number[][]|string|object)} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {number} tileHeight - The height of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The created `MapData` object.
 */ var Parse = function(name, mapFormat, data, tileWidth, tileHeight, insertNull) {
                var newMap;
                switch(mapFormat){
                    case Formats.ARRAY_2D:
                        newMap = Parse2DArray(name, data, tileWidth, tileHeight, insertNull);
                        break;
                    case Formats.CSV:
                        newMap = ParseCSV(name, data, tileWidth, tileHeight, insertNull);
                        break;
                    case Formats.TILED_JSON:
                        newMap = ParseJSONTiled(name, data, insertNull);
                        break;
                    case Formats.WELTMEISTER:
                        newMap = ParseWeltmeister(name, data, insertNull);
                        break;
                    default:
                        console.warn("Unrecognized tilemap data format: " + mapFormat);
                        newMap = null;
                }
                return newMap;
            };
            module1.exports = Parse;
        /***/ },
        /* 565 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(40);
            var Parse2DArray = __webpack_require__(259);
            /**
 * Parses a CSV string of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.ParseCSV
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {string} data - CSV string of tile indexes.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The resulting MapData object.
 */ var ParseCSV = function(name, data, tileWidth, tileHeight, insertNull) {
                var array2D = data.trim().split("\n").map(function(row) {
                    return row.split(",");
                });
                var map = Parse2DArray(name, array2D, tileWidth, tileHeight, insertNull);
                map.format = Formats.CSV;
                return map;
            };
            module1.exports = ParseCSV;
        /***/ },
        /* 566 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AssignTileProperties = __webpack_require__(567);
            var BuildTilesetIndex = __webpack_require__(568);
            var CONST = __webpack_require__(29);
            var Formats = __webpack_require__(40);
            var FromOrientationString = __webpack_require__(258);
            var MapData = __webpack_require__(121);
            var ParseImageLayers = __webpack_require__(569);
            var ParseObjectLayers = __webpack_require__(570);
            var ParseTileLayers = __webpack_require__(573);
            var ParseTilesets = __webpack_require__(575);
            /**
 * Parses a Tiled JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} json - The Tiled JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseJSONTiled = function(name, json, insertNull) {
                //  Map data will consist of: layers, objects, images, tilesets, sizes
                var mapData = new MapData({
                    width: json.width,
                    height: json.height,
                    name: name,
                    tileWidth: json.tilewidth,
                    tileHeight: json.tileheight,
                    orientation: FromOrientationString(json.orientation),
                    format: Formats.TILED_JSON,
                    version: json.version,
                    properties: json.properties,
                    renderOrder: json.renderorder,
                    infinite: json.infinite
                });
                if (mapData.orientation === CONST.HEXAGONAL) mapData.hexSideLength = json.hexsidelength;
                mapData.layers = ParseTileLayers(json, insertNull);
                mapData.images = ParseImageLayers(json);
                var sets = ParseTilesets(json);
                mapData.tilesets = sets.tilesets;
                mapData.imageCollections = sets.imageCollections;
                mapData.objects = ParseObjectLayers(json);
                mapData.tiles = BuildTilesetIndex(mapData);
                AssignTileProperties(mapData);
                return mapData;
            };
            module1.exports = ParseJSONTiled;
        /***/ },
        /* 567 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            /**
 * Copy properties from tileset to tiles.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.AssignTileProperties
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.MapData} mapData - The Map Data object.
 */ var AssignTileProperties = function(mapData) {
                var layerData;
                var tile;
                var sid;
                var set;
                var row;
                // go through each of the map data layers
                for(var i = 0; i < mapData.layers.length; i++){
                    layerData = mapData.layers[i];
                    set = null;
                    // rows of tiles
                    for(var j = 0; j < layerData.data.length; j++){
                        row = layerData.data[j];
                        // individual tiles
                        for(var k = 0; k < row.length; k++){
                            tile = row[k];
                            if (tile === null || tile.index < 0) continue;
                            // find the relevant tileset
                            sid = mapData.tiles[tile.index][2];
                            set = mapData.tilesets[sid];
                            // Ensure that a tile's size matches its tileset
                            tile.width = set.tileWidth;
                            tile.height = set.tileHeight;
                            // if that tile type has any properties, add them to the tile object
                            if (set.tileProperties && set.tileProperties[tile.index - set.firstgid]) tile.properties = Extend(tile.properties, set.tileProperties[tile.index - set.firstgid]);
                        }
                    }
                }
            };
            module1.exports = AssignTileProperties;
        /***/ },
        /* 568 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(122);
            /**
 * Master list of tiles -> x, y, index in tileset.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.BuildTilesetIndex
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.MapData} mapData - The Map Data object.
 *
 * @return {array} An array of Tileset objects.
 */ var BuildTilesetIndex = function(mapData) {
                var i;
                var set;
                var tiles = [];
                for(i = 0; i < mapData.imageCollections.length; i++){
                    var collection = mapData.imageCollections[i];
                    var images = collection.images;
                    for(var j = 0; j < images.length; j++){
                        var image = images[j];
                        set = new Tileset(image.image, image.gid, collection.imageWidth, collection.imageHeight, 0, 0);
                        set.updateTileData(collection.imageWidth, collection.imageHeight);
                        mapData.tilesets.push(set);
                    }
                }
                for(i = 0; i < mapData.tilesets.length; i++){
                    set = mapData.tilesets[i];
                    var x = set.tileMargin;
                    var y = set.tileMargin;
                    var count = 0;
                    var countX = 0;
                    var countY = 0;
                    for(var t = set.firstgid; t < set.firstgid + set.total; t++){
                        //  Can add extra properties here as needed
                        tiles[t] = [
                            x,
                            y,
                            i
                        ];
                        x += set.tileWidth + set.tileSpacing;
                        count++;
                        if (count === set.total) break;
                        countX++;
                        if (countX === set.columns) {
                            x = set.tileMargin;
                            y += set.tileHeight + set.tileSpacing;
                            countX = 0;
                            countY++;
                            if (countY === set.rows) break;
                        }
                    }
                }
                return tiles;
            };
            module1.exports = BuildTilesetIndex;
        /***/ },
        /* 569 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var CreateGroupLayer = __webpack_require__(161);
            /**
 * Parses a Tiled JSON object into an array of objects with details about the image layers.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseImageLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} Array of objects that include critical info about the map's image layers
 */ var ParseImageLayers = function(json) {
                var images = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    // Get current layer and advance iterator
                    var curi = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    if (curi.type !== "imagelayer") {
                        if (curi.type === "group") {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curi, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    var layerOffsetX = GetFastValue(curi, "offsetx", 0) + GetFastValue(curi, "startx", 0);
                    var layerOffsetY = GetFastValue(curi, "offsety", 0) + GetFastValue(curi, "starty", 0);
                    images.push({
                        name: curGroupState.name + curi.name,
                        image: curi.image,
                        x: curGroupState.x + layerOffsetX + curi.x,
                        y: curGroupState.y + layerOffsetY + curi.y,
                        alpha: curGroupState.opacity * curi.opacity,
                        visible: curGroupState.visible && curi.visible,
                        properties: GetFastValue(curi, "properties", {})
                    });
                }
                return images;
            };
            module1.exports = ParseImageLayers;
        /***/ },
        /* 570 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var ParseObject = __webpack_require__(260);
            var ObjectLayer = __webpack_require__(572);
            var CreateGroupLayer = __webpack_require__(161);
            /**
 * Parses a Tiled JSON object into an array of ObjectLayer objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObjectLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} An array of all object layers in the tilemap as `ObjectLayer`s.
 */ var ParseObjectLayers = function(json) {
                var objectLayers = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    // Get current layer and advance iterator
                    var curo = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    // Modify inherited properties
                    curo.opacity *= curGroupState.opacity;
                    curo.visible = curGroupState.visible && curo.visible;
                    if (curo.type !== "objectgroup") {
                        if (curo.type === "group") {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curo, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    curo.name = curGroupState.name + curo.name;
                    var offsetX = curGroupState.x + GetFastValue(curo, "startx", 0) + GetFastValue(curo, "offsetx", 0);
                    var offsetY = curGroupState.y + GetFastValue(curo, "starty", 0) + GetFastValue(curo, "offsety", 0);
                    var objects = [];
                    for(var j = 0; j < curo.objects.length; j++){
                        var parsedObject = ParseObject(curo.objects[j], offsetX, offsetY);
                        objects.push(parsedObject);
                    }
                    var objectLayer = new ObjectLayer(curo);
                    objectLayer.objects = objects;
                    objectLayers.push(objectLayer);
                }
                return objectLayers;
            };
            module1.exports = ParseObjectLayers;
        /***/ },
        /* 571 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasValue = __webpack_require__(126);
            /**
 * Returns a new object that only contains the `keys` that were found on the object provided.
 * If no `keys` are found, an empty object is returned.
 *
 * @function Phaser.Utils.Objects.Pick
 * @since 3.18.0
 *
 * @param {object} object - The object to pick the provided keys from.
 * @param {array} keys - An array of properties to retrieve from the provided object.
 *
 * @return {object} A new object that only contains the `keys` that were found on the provided object. If no `keys` were found, an empty object will be returned.
 */ var Pick = function(object, keys) {
                var obj = {};
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i];
                    if (HasValue(object, key)) obj[key] = object[key];
                }
                return obj;
            };
            module1.exports = Pick;
        /***/ },
        /* 572 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing a Tiled object layer in a map. This mirrors the structure of a Tiled
 * object layer, except:
 *  - "x" & "y" properties are ignored since these cannot be changed in Tiled.
 *  - "offsetx" & "offsety" are applied to the individual object coordinates directly, so they
 *    are ignored as well.
 *  - "draworder" is ignored.
 *
 * @class ObjectLayer
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.ObjectLayerConfig} [config] - The data for the layer from the Tiled JSON object.
 */ var ObjectLayer = new Class({
                initialize: function ObjectLayer(config) {
                    if (config === undefined) config = {};
                    /**
         * The name of the Object Layer.
         *
         * @name Phaser.Tilemaps.ObjectLayer#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, "name", "object layer");
                    /**
         * The opacity of the layer, between 0 and 1.
         *
         * @name Phaser.Tilemaps.ObjectLayer#opacity
         * @type {number}
         * @since 3.0.0
         */ this.opacity = GetFastValue(config, "opacity", 1);
                    /**
         * The custom properties defined on the Object Layer, keyed by their name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, "properties", {});
                    /**
         * The type of each custom property defined on the Object Layer, keyed by its name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#propertyTypes
         * @type {object}
         * @since 3.0.0
         */ this.propertyTypes = GetFastValue(config, "propertytypes", {});
                    /**
         * The type of the layer, which should be `objectgroup`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(config, "type", "objectgroup");
                    /**
         * Whether the layer is shown (`true`) or hidden (`false`).
         *
         * @name Phaser.Tilemaps.ObjectLayer#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, "visible", true);
                    /**
         * An array of all objects on this Object Layer.
         *
         * Each Tiled object corresponds to a JavaScript object in this array. It has an `id` (unique),
         * `name` (as assigned in Tiled), `type` (as assigned in Tiled), `rotation` (in clockwise degrees),
         * `properties` (if any), `visible` state (`true` if visible, `false` otherwise),
         * `x` and `y` coordinates (in pixels, relative to the tilemap), and a `width` and `height` (in pixels).
         *
         * An object tile has a `gid` property (GID of the represented tile), a `flippedHorizontal` property,
         * a `flippedVertical` property, and `flippedAntiDiagonal` property.
         * The {@link http://docs.mapeditor.org/en/latest/reference/tmx-map-format/|Tiled documentation} contains
         * information on flipping and rotation.
         *
         * Polylines have a `polyline` property, which is an array of objects corresponding to points,
         * where each point has an `x` property and a `y` property. Polygons have an identically structured
         * array in their `polygon` property. Text objects have a `text` property with the text's properties.
         *
         * Rectangles and ellipses have a `rectangle` or `ellipse` property set to `true`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#objects
         * @type {Phaser.Types.Tilemaps.TiledObject[]}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, "objects", []);
                }
            });
            module1.exports = ObjectLayer;
        /***/ },
        /* 573 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64Decode = __webpack_require__(574);
            var CONST = __webpack_require__(29);
            var CreateGroupLayer = __webpack_require__(161);
            var FromOrientationString = __webpack_require__(258);
            var GetFastValue = __webpack_require__(2);
            var LayerData = __webpack_require__(120);
            var ParseGID = __webpack_require__(261);
            var Tile = __webpack_require__(85);
            /**
 * Parses all tilemap layers in a Tiled JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                var infiniteMap = GetFastValue(json, "infinite", false);
                var tileLayers = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    var curl = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    if (curl.type !== "tilelayer") {
                        if (curl.type === "group") {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curl, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    // Base64 decode data if necessary. NOTE: uncompressed base64 only.
                    if (curl.compression) {
                        console.warn("TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer '" + curl.name + "'");
                        continue;
                    } else if (curl.encoding && curl.encoding === "base64") {
                        // Chunks for an infinite map
                        if (curl.chunks) for(var i = 0; i < curl.chunks.length; i++)curl.chunks[i].data = Base64Decode(curl.chunks[i].data);
                        // Non-infinite map data
                        if (curl.data) curl.data = Base64Decode(curl.data);
                        delete curl.encoding; // Allow the same map to be parsed multiple times
                    }
                    //  This is an array containing the tile indexes, one after the other. -1 = no tile,
                    //  everything else = the tile index (starting at 1 for Tiled, 0 for CSV) If the map
                    //  contains multiple tilesets then the indexes are relative to that which the set starts
                    //  from. Need to set which tileset in the cache = which tileset in the JSON, if you do this
                    //  manually it means you can use the same map data but a new tileset.
                    var layerData;
                    var gidInfo;
                    var tile;
                    var blankTile;
                    var output = [];
                    var x = 0;
                    if (infiniteMap) {
                        var layerOffsetX = GetFastValue(curl, "startx", 0) + curl.x;
                        var layerOffsetY = GetFastValue(curl, "starty", 0) + curl.y;
                        layerData = new LayerData({
                            name: curGroupState.name + curl.name,
                            x: curGroupState.x + GetFastValue(curl, "offsetx", 0) + layerOffsetX * json.tilewidth,
                            y: curGroupState.y + GetFastValue(curl, "offsety", 0) + layerOffsetY * json.tileheight,
                            width: curl.width,
                            height: curl.height,
                            tileWidth: json.tilewidth,
                            tileHeight: json.tileheight,
                            alpha: curGroupState.opacity * curl.opacity,
                            visible: curGroupState.visible && curl.visible,
                            properties: GetFastValue(curl, "properties", []),
                            orientation: FromOrientationString(json.orientation)
                        });
                        if (layerData.orientation === CONST.HEXAGONAL) layerData.hexSideLength = json.hexsidelength;
                        for(var c = 0; c < curl.height; c++){
                            output.push([
                                null
                            ]);
                            for(var j = 0; j < curl.width; j++)output[c][j] = null;
                        }
                        for(c = 0, len = curl.chunks.length; c < len; c++){
                            var chunk = curl.chunks[c];
                            var offsetX = chunk.x - layerOffsetX;
                            var offsetY = chunk.y - layerOffsetY;
                            var y = 0;
                            for(var t = 0, len2 = chunk.data.length; t < len2; t++){
                                var newOffsetX = x + offsetX;
                                var newOffsetY = y + offsetY;
                                gidInfo = ParseGID(chunk.data[t]);
                                //  index, x, y, width, height
                                if (gidInfo.gid > 0) {
                                    tile = new Tile(layerData, gidInfo.gid, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                    // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                    // propeties into flipX, flipY and rotation
                                    tile.rotation = gidInfo.rotation;
                                    tile.flipX = gidInfo.flipped;
                                    output[newOffsetY][newOffsetX] = tile;
                                } else {
                                    blankTile = insertNull ? null : new Tile(layerData, -1, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                    output[newOffsetY][newOffsetX] = blankTile;
                                }
                                x++;
                                if (x === chunk.width) {
                                    y++;
                                    x = 0;
                                }
                            }
                        }
                    } else {
                        layerData = new LayerData({
                            name: curGroupState.name + curl.name,
                            x: curGroupState.x + GetFastValue(curl, "offsetx", 0) + curl.x,
                            y: curGroupState.y + GetFastValue(curl, "offsety", 0) + curl.y,
                            width: curl.width,
                            height: curl.height,
                            tileWidth: json.tilewidth,
                            tileHeight: json.tileheight,
                            alpha: curGroupState.opacity * curl.opacity,
                            visible: curGroupState.visible && curl.visible,
                            properties: GetFastValue(curl, "properties", []),
                            orientation: FromOrientationString(json.orientation)
                        });
                        if (layerData.orientation === CONST.HEXAGONAL) layerData.hexSideLength = json.hexsidelength;
                        var row = [];
                        //  Loop through the data field in the JSON.
                        for(var k = 0, len = curl.data.length; k < len; k++){
                            gidInfo = ParseGID(curl.data[k]);
                            //  index, x, y, width, height
                            if (gidInfo.gid > 0) {
                                tile = new Tile(layerData, gidInfo.gid, x, output.length, json.tilewidth, json.tileheight);
                                // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                // propeties into flipX, flipY and rotation
                                tile.rotation = gidInfo.rotation;
                                tile.flipX = gidInfo.flipped;
                                row.push(tile);
                            } else {
                                blankTile = insertNull ? null : new Tile(layerData, -1, x, output.length, json.tilewidth, json.tileheight);
                                row.push(blankTile);
                            }
                            x++;
                            if (x === curl.width) {
                                output.push(row);
                                x = 0;
                                row = [];
                            }
                        }
                    }
                    layerData.data = output;
                    tileLayers.push(layerData);
                }
                return tileLayers;
            };
            module1.exports = ParseTileLayers;
        /***/ },
        /* 574 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decode base-64 encoded data, for example as exported by Tiled.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.Base64Decode
 * @since 3.0.0
 *
 * @param {object} data - Base-64 encoded data to decode.
 *
 * @return {array} Array containing the decoded bytes.
 */ var Base64Decode = function(data) {
                var binaryString = window.atob(data);
                var len = binaryString.length;
                var bytes = new Array(len / 4);
                // Interpret binaryString as an array of bytes representing little-endian encoded uint32 values.
                for(var i = 0; i < len; i += 4)bytes[i / 4] = (binaryString.charCodeAt(i) | binaryString.charCodeAt(i + 1) << 8 | binaryString.charCodeAt(i + 2) << 16 | binaryString.charCodeAt(i + 3) << 24) >>> 0;
                return bytes;
            };
            module1.exports = Base64Decode;
        /***/ },
        /* 575 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(122);
            var ImageCollection = __webpack_require__(576);
            var ParseObject = __webpack_require__(260);
            var ParseWangsets = __webpack_require__(1453);
            /**
 * Tilesets and Image Collections.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON data.
 *
 * @return {object} An object containing the tileset and image collection data.
 */ var ParseTilesets = function(json) {
                var tilesets = [];
                var imageCollections = [];
                var lastSet = null;
                var stringID;
                for(var i = 0; i < json.tilesets.length; i++){
                    //  name, firstgid, width, height, margin, spacing, properties
                    var set = json.tilesets[i];
                    if (set.source) console.warn("External tilesets unsupported. Use Embed Tileset and re-export");
                    else if (set.image) {
                        var newSet = new Tileset(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing);
                        if (json.version > 1) {
                            var datas = undefined;
                            var props = undefined;
                            if (Array.isArray(set.tiles)) {
                                datas = datas || {};
                                props = props || {};
                                // Tiled 1.2+
                                for(var t = 0; t < set.tiles.length; t++){
                                    var tile = set.tiles[t];
                                    //  Convert tileproperties.
                                    if (tile.properties) {
                                        var newPropData = {};
                                        tile.properties.forEach(function(propData) {
                                            newPropData[propData["name"]] = propData["value"];
                                        });
                                        props[tile.id] = newPropData;
                                    }
                                    //  Convert objectgroup
                                    if (tile.objectgroup) {
                                        (datas[tile.id] || (datas[tile.id] = {})).objectgroup = tile.objectgroup;
                                        if (tile.objectgroup.objects) {
                                            var parsedObjects2 = tile.objectgroup.objects.map(function(obj) {
                                                return ParseObject(obj);
                                            });
                                            datas[tile.id].objectgroup.objects = parsedObjects2;
                                        }
                                    }
                                    // Copy animation data
                                    if (tile.animation) (datas[tile.id] || (datas[tile.id] = {})).animation = tile.animation;
                                    // Copy tile `type` field
                                    // (see https://doc.mapeditor.org/en/latest/manual/custom-properties/#typed-tiles).
                                    if (tile.type) (datas[tile.id] || (datas[tile.id] = {})).type = tile.type;
                                }
                            }
                            if (Array.isArray(set.wangsets)) {
                                datas = datas || {};
                                props = props || {};
                                ParseWangsets(set.wangsets, datas);
                            }
                            if (datas) {
                                newSet.tileData = datas;
                                newSet.tileProperties = props;
                            }
                        } else {
                            // Tiled 1
                            // Properties stored per-tile in object with string indexes starting at "0"
                            if (set.tileproperties) newSet.tileProperties = set.tileproperties;
                            // Object & terrain shapes stored per-tile in object with string indexes starting at "0"
                            if (set.tiles) {
                                newSet.tileData = set.tiles;
                                // Parse the objects into Phaser format to match handling of other Tiled objects
                                for(stringID in newSet.tileData){
                                    var objectGroup = newSet.tileData[stringID].objectgroup;
                                    if (objectGroup && objectGroup.objects) {
                                        var parsedObjects1 = objectGroup.objects.map(function(obj) {
                                            return ParseObject(obj);
                                        });
                                        newSet.tileData[stringID].objectgroup.objects = parsedObjects1;
                                    }
                                }
                            }
                        }
                        // For a normal sliced tileset the row/count/size information is computed when updated.
                        // This is done (again) after the image is set.
                        newSet.updateTileData(set.imagewidth, set.imageheight);
                        tilesets.push(newSet);
                    } else {
                        var newCollection = new ImageCollection(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing, set.properties);
                        var maxId = 0;
                        for(t = 0; t < set.tiles.length; t++){
                            tile = set.tiles[t];
                            var image = tile.image;
                            var tileId = parseInt(tile.id, 10);
                            var gid = set.firstgid + tileId;
                            newCollection.addImage(gid, image);
                            maxId = Math.max(tileId, maxId);
                        }
                        newCollection.maxId = maxId;
                        imageCollections.push(newCollection);
                    }
                    //  We've got a new Tileset, so set the lastgid into the previous one
                    if (lastSet) lastSet.lastgid = set.firstgid - 1;
                    lastSet = set;
                }
                return {
                    tilesets: tilesets,
                    imageCollections: imageCollections
                };
            };
            module1.exports = ParseTilesets;
        /***/ },
        /* 576 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * An Image Collection is a special Tile Set containing multiple images, with no slicing into each image.
 *
 * Image Collections are normally created automatically when Tiled data is loaded.
 *
 * @class ImageCollection
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 * 
 * @param {string} name - The name of the image collection in the map data.
 * @param {number} firstgid - The first image index this image collection contains.
 * @param {number} [width=32] - Width of widest image (in pixels).
 * @param {number} [height=32] - Height of tallest image (in pixels).
 * @param {number} [margin=0] - The margin around all images in the collection (in pixels).
 * @param {number} [spacing=0] - The spacing between each image in the collection (in pixels).
 * @param {object} [properties={}] - Custom Image Collection properties.
 */ var ImageCollection = new Class({
                initialize: function ImageCollection(name, firstgid, width, height, margin, spacing, properties) {
                    if (width === undefined || width <= 0) width = 32;
                    if (height === undefined || height <= 0) height = 32;
                    if (margin === undefined) margin = 0;
                    if (spacing === undefined) spacing = 0;
                    /**
         * The name of the Image Collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#name
         * @type {string}
         * @since 3.0.0
        */ this.name = name;
                    /**
         * The Tiled firstgid value.
         * This is the starting index of the first image index this Image Collection contains.
         * 
         * @name Phaser.Tilemaps.ImageCollection#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid | 0;
                    /**
         * The width of the widest image (in pixels).
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageWidth = width | 0;
                    /**
         * The height of the tallest image (in pixels).
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageHeight = height | 0;
                    /**
         * The margin around the images in the collection (in pixels).
         * Use `setSpacing` to change.
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageMarge
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageMargin = margin | 0;
                    /**
         * The spacing between each image in the collection (in pixels).
         * Use `setSpacing` to change.
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageSpacing = spacing | 0;
                    /**
         * Image Collection-specific properties that are typically defined in the Tiled editor.
         * 
         * @name Phaser.Tilemaps.ImageCollection#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = properties || {};
                    /**
         * The cached images that are a part of this collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#images
         * @type {array}
         * @readonly
         * @since 3.0.0
         */ this.images = [];
                    /**
         * The total number of images in the image collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                },
                /**
     * Returns true if and only if this image collection contains the given image index.
     *
     * @method Phaser.Tilemaps.ImageCollection#containsImageIndex
     * @since 3.0.0
     * 
     * @param {number} imageIndex - The image index to search for.
     * 
     * @return {boolean} True if this Image Collection contains the given index.
     */ containsImageIndex: function(imageIndex) {
                    return imageIndex >= this.firstgid && imageIndex < this.firstgid + this.total;
                },
                /**
     * Add an image to this Image Collection.
     *
     * @method Phaser.Tilemaps.ImageCollection#addImage
     * @since 3.0.0
     * 
     * @param {number} gid - The gid of the image in the Image Collection.
     * @param {string} image - The the key of the image in the Image Collection and in the cache.
     *
     * @return {Phaser.Tilemaps.ImageCollection} This ImageCollection object.
     */ addImage: function(gid, image) {
                    this.images.push({
                        gid: gid,
                        image: image
                    });
                    this.total++;
                    return this;
                }
            });
            module1.exports = ImageCollection;
        /***/ },
        /* 577 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(40);
            var MapData = __webpack_require__(121);
            var ParseTileLayers = __webpack_require__(578);
            var ParseTilesets = __webpack_require__(579);
            /**
 * Parses a Weltmeister JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseWeltmeister
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} json - The Weltmeister JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseWeltmeister = function(name, json, insertNull) {
                if (json.layer.length === 0) {
                    console.warn("No layers found in the Weltmeister map: " + name);
                    return null;
                }
                var width = 0;
                var height = 0;
                for(var i = 0; i < json.layer.length; i++){
                    if (json.layer[i].width > width) width = json.layer[i].width;
                    if (json.layer[i].height > height) height = json.layer[i].height;
                }
                var mapData = new MapData({
                    width: width,
                    height: height,
                    name: name,
                    tileWidth: json.layer[0].tilesize,
                    tileHeight: json.layer[0].tilesize,
                    format: Formats.WELTMEISTER
                });
                mapData.layers = ParseTileLayers(json, insertNull);
                mapData.tilesets = ParseTilesets(json);
                return mapData;
            };
            module1.exports = ParseWeltmeister;
        /***/ },
        /* 578 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LayerData = __webpack_require__(120);
            var Tile = __webpack_require__(85);
            /**
 * Parses all tilemap layers in an Impact JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                var tileLayers = [];
                for(var i = 0; i < json.layer.length; i++){
                    var layer = json.layer[i];
                    var layerData = new LayerData({
                        name: layer.name,
                        width: layer.width,
                        height: layer.height,
                        tileWidth: layer.tilesize,
                        tileHeight: layer.tilesize,
                        visible: layer.visible === 1
                    });
                    var row = [];
                    var tileGrid = [];
                    //  Loop through the data field in the JSON. This is a 2D array containing the tile indexes,
                    //  one after the other. The indexes are relative to the tileset that contains the tile.
                    for(var y = 0; y < layer.data.length; y++){
                        for(var x = 0; x < layer.data[y].length; x++){
                            // In Weltmeister, 0 = no tile, but the Tilemap API expects -1 = no tile.
                            var index = layer.data[y][x] - 1;
                            var tile;
                            if (index > -1) tile = new Tile(layerData, index, x, y, layer.tilesize, layer.tilesize);
                            else tile = insertNull ? null : new Tile(layerData, -1, x, y, layer.tilesize, layer.tilesize);
                            row.push(tile);
                        }
                        tileGrid.push(row);
                        row = [];
                    }
                    layerData.data = tileGrid;
                    tileLayers.push(layerData);
                }
                return tileLayers;
            };
            module1.exports = ParseTileLayers;
        /***/ },
        /* 579 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(122);
            /**
 * Tilesets and Image Collections
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON data.
 *
 * @return {array} An array of Tilesets.
 */ var ParseTilesets = function(json) {
                var tilesets = [];
                var tilesetsNames = [];
                for(var i = 0; i < json.layer.length; i++){
                    var layer = json.layer[i];
                    // A relative filepath to the source image (within Weltmeister) is used for the name
                    var tilesetName = layer.tilesetName;
                    // Only add unique tilesets that have a valid name. Collision layers will have a blank name.
                    if (tilesetName !== "" && tilesetsNames.indexOf(tilesetName) === -1) {
                        tilesetsNames.push(tilesetName);
                        // Tiles are stored with an ID relative to the tileset, rather than a globally unique ID
                        // across all tilesets. Also, tilesets in Weltmeister have no margin or padding.
                        tilesets.push(new Tileset(tilesetName, 0, layer.tilesize, layer.tilesize, 0, 0));
                    }
                }
                return tilesets;
            };
            module1.exports = ParseTilesets;
        /***/ },
        /* 580 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(36);
            var Formats = __webpack_require__(40);
            var GetFastValue = __webpack_require__(2);
            var LayerData = __webpack_require__(120);
            var ORIENTATION = __webpack_require__(29);
            var Rotate = __webpack_require__(362);
            var SpliceOne = __webpack_require__(74);
            var Sprite = __webpack_require__(73);
            var Tile = __webpack_require__(85);
            var TilemapComponents = __webpack_require__(251);
            var TilemapLayer = __webpack_require__(581);
            var Tileset = __webpack_require__(122);
            /**
 * @callback TilemapFilterCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found in the filtered area.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {Phaser.GameObjects.GameObject} The object.
 */ /**
 * @callback TilemapFindCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {boolean} `true` if the callback should be invoked, otherwise `false`.
 */ /**
 * @classdesc
 * A Tilemap is a container for Tilemap data. This isn't a display object, rather, it holds data
 * about the map and allows you to add tilesets and tilemap layers to it. A map can have one or
 * more tilemap layers, which are the display objects that actually render the tiles.
 *
 * The Tilemap data can be parsed from a Tiled JSON file, a CSV file or a 2D array. Tiled is a free
 * software package specifically for creating tile maps, and is available from:
 * http://www.mapeditor.org
 *
 * As of Phaser 3.50.0 the Tilemap API now supports the following types of map:
 *
 * 1) Orthogonal
 * 2) Isometric
 * 3) Hexagonal
 * 4) Staggered
 *
 * Prior to this release, only orthogonal maps were supported.
 *
 * Another large change in 3.50 was the consolidation of Tilemap Layers. Previously, you created
 * either a Static or Dynamic Tilemap Layer. However, as of 3.50 the features of both have been
 * merged and the API simplified, so now there is just the single `TilemapLayer` class.
 *
 * A Tilemap has handy methods for getting and manipulating the tiles within a layer, allowing
 * you to build or modify the tilemap data at runtime.
 *
 * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a
 * TilemapLayer may have its own unique tile size that overrides this.
 *
 * As of Phaser 3.21.0, if your tilemap includes layer groups (a feature of Tiled 1.2.0+) these
 * will be traversed and the following properties will impact children:
 *
 * - Opacity (blended with parent) and visibility (parent overrides child)
 * - Vertical and horizontal offset
 *
 * The grouping hierarchy is not preserved and all layers will be flattened into a single array.
 *
 * Group layers are parsed during Tilemap construction but are discarded after parsing so dynamic
 * layers will NOT continue to be affected by a parent.
 *
 * To avoid duplicate layer names, a layer that is a child of a group layer will have its parent
 * group name prepended with a '/'.  For example, consider a group called 'ParentGroup' with a
 * child called 'Layer 1'. In the Tilemap object, 'Layer 1' will have the name
 * 'ParentGroup/Layer 1'.
 *
 * @class Tilemap
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {Phaser.Tilemaps.MapData} mapData - A MapData instance containing Tilemap data.
 */ var Tilemap = new Class({
                initialize: function Tilemap(scene, mapData) {
                    /**
         * @name Phaser.Tilemaps.Tilemap#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The base width of a tile in pixels. Note that individual layers may have a different tile
         * width.
         *
         * @name Phaser.Tilemaps.Tilemap#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = mapData.tileWidth;
                    /**
         * The base height of a tile in pixels. Note that individual layers may have a different
         * tile height.
         *
         * @name Phaser.Tilemaps.Tilemap#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = mapData.tileHeight;
                    /**
         * The width of the map (in tiles).
         *
         * @name Phaser.Tilemaps.Tilemap#width
         * @type {number}
         * @since 3.0.0
         */ this.width = mapData.width;
                    /**
         * The height of the map (in tiles).
         *
         * @name Phaser.Tilemaps.Tilemap#height
         * @type {number}
         * @since 3.0.0
         */ this.height = mapData.height;
                    /**
         * The orientation of the map data (as specified in Tiled), usually 'orthogonal'.
         *
         * @name Phaser.Tilemaps.Tilemap#orientation
         * @type {string}
         * @since 3.0.0
         */ this.orientation = mapData.orientation;
                    /**
         * The render (draw) order of the map data (as specified in Tiled), usually 'right-down'.
         *
         * The draw orders are:
         *
         * right-down
         * left-down
         * right-up
         * left-up
         *
         * This can be changed via the `setRenderOrder` method.
         *
         * @name Phaser.Tilemaps.Tilemap#renderOrder
         * @type {string}
         * @since 3.12.0
         */ this.renderOrder = mapData.renderOrder;
                    /**
         * The format of the map data.
         *
         * @name Phaser.Tilemaps.Tilemap#format
         * @type {number}
         * @since 3.0.0
         */ this.format = mapData.format;
                    /**
         * The version of the map data (as specified in Tiled, usually 1).
         *
         * @name Phaser.Tilemaps.Tilemap#version
         * @type {number}
         * @since 3.0.0
         */ this.version = mapData.version;
                    /**
         * Map specific properties as specified in Tiled.
         *
         * @name Phaser.Tilemaps.Tilemap#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = mapData.properties;
                    /**
         * The width of the map in pixels based on width * tileWidth.
         *
         * @name Phaser.Tilemaps.Tilemap#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = mapData.widthInPixels;
                    /**
         * The height of the map in pixels based on height * tileHeight.
         *
         * @name Phaser.Tilemaps.Tilemap#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = mapData.heightInPixels;
                    /**
         * A collection of Images, as parsed from Tiled map data.
         *
         * @name Phaser.Tilemaps.Tilemap#imageCollections
         * @type {Phaser.Tilemaps.ImageCollection[]}
         * @since 3.0.0
         */ this.imageCollections = mapData.imageCollections;
                    /**
         * An array of Tiled Image Layers.
         *
         * @name Phaser.Tilemaps.Tilemap#images
         * @type {array}
         * @since 3.0.0
         */ this.images = mapData.images;
                    /**
         * An array of Tilemap layer data.
         *
         * @name Phaser.Tilemaps.Tilemap#layers
         * @type {Phaser.Tilemaps.LayerData[]}
         * @since 3.0.0
         */ this.layers = mapData.layers;
                    /**
         * An array of Tilesets used in the map.
         *
         * @name Phaser.Tilemaps.Tilemap#tilesets
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.0.0
         */ this.tilesets = mapData.tilesets;
                    /**
         * An array of ObjectLayer instances parsed from Tiled object layers.
         *
         * @name Phaser.Tilemaps.Tilemap#objects
         * @type {Phaser.Tilemaps.ObjectLayer[]}
         * @since 3.0.0
         */ this.objects = mapData.objects;
                    /**
         * The index of the currently selected LayerData object.
         *
         * @name Phaser.Tilemaps.Tilemap#currentLayerIndex
         * @type {number}
         * @since 3.0.0
         */ this.currentLayerIndex = 0;
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.Tilemap#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = mapData.hexSideLength;
                    var orientation = this.orientation;
                    /**
         * Functions used to handle world to tile, and tile to world, conversion.
         * Cached here for internal use by public methods such as `worldToTileXY`, etc.
         *
         * @name Phaser.Tilemaps.Tilemap#_convert
         * @private
         * @type {object}
         * @since 3.50.0
         */ this._convert = {
                        WorldToTileXY: TilemapComponents.GetWorldToTileXYFunction(orientation),
                        WorldToTileX: TilemapComponents.GetWorldToTileXFunction(orientation),
                        WorldToTileY: TilemapComponents.GetWorldToTileYFunction(orientation),
                        TileToWorldXY: TilemapComponents.GetTileToWorldXYFunction(orientation),
                        TileToWorldX: TilemapComponents.GetTileToWorldXFunction(orientation),
                        TileToWorldY: TilemapComponents.GetTileToWorldYFunction(orientation)
                    };
                },
                /**
     * @ignore
     */ createBlankDynamicLayer: function(name, tileset, x, y, width, height, tileWidth, tileHeight) {
                    console.warn("createBlankDynamicLayer is deprecated. Use createBlankLayer");
                    return this.createBlankLayer(name, tileset, x, y, width, height, tileWidth, tileHeight);
                },
                /**
     * @ignore
     */ createDynamicLayer: function(layerID, tileset, x, y) {
                    console.warn("createDynamicLayer is deprecated. Use createLayer");
                    return this.createLayer(layerID, tileset, x, y);
                },
                /**
     * @ignore
     */ createStaticLayer: function(layerID, tileset, x, y) {
                    console.warn("createStaticLayer is deprecated. Use createLayer");
                    return this.createLayer(layerID, tileset, x, y);
                },
                /**
     * Sets the rendering (draw) order of the tiles in this map.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * Calling this method _after_ creating Tilemap Layers will **not** automatically
     * update them to use the new render order. If you call this method after creating layers, use their
     * own `setRenderOrder` methods to change them as needed.
     *
     * @method Phaser.Tilemaps.Tilemap#setRenderOrder
     * @since 3.12.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap object.
     */ setRenderOrder: function(renderOrder) {
                    var orders = [
                        "right-down",
                        "left-down",
                        "right-up",
                        "left-up"
                    ];
                    if (typeof renderOrder === "number") renderOrder = orders[renderOrder];
                    if (orders.indexOf(renderOrder) > -1) this.renderOrder = renderOrder;
                    return this;
                },
                /**
     * Adds an image to the map to be used as a tileset. A single map may use multiple tilesets.
     * Note that the tileset name can be found in the JSON file exported from Tiled, or in the Tiled
     * editor.
     *
     * @method Phaser.Tilemaps.Tilemap#addTilesetImage
     * @since 3.0.0
     *
     * @param {string} tilesetName - The name of the tileset as specified in the map data.
     * @param {string} [key] - The key of the Phaser.Cache image used for this tileset. If
     * `undefined` or `null` it will look for an image with a key matching the tilesetName parameter.
     * @param {number} [tileWidth] - The width of the tile (in pixels) in the Tileset Image. If not
     * given it will default to the map's tileWidth value, or the tileWidth specified in the Tiled
     * JSON file.
     * @param {number} [tileHeight] - The height of the tiles (in pixels) in the Tileset Image. If
     * not given it will default to the map's tileHeight value, or the tileHeight specified in the
     * Tiled JSON file.
     * @param {number} [tileMargin] - The margin around the tiles in the sheet (in pixels). If not
     * specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [tileSpacing] - The spacing between each the tile in the sheet (in pixels).
     * If not specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [gid=0] - If adding multiple tilesets to a blank map, specify the starting
     * GID this set will use here.
     *
     * @return {?Phaser.Tilemaps.Tileset} Returns the Tileset object that was created or updated, or null if it
     * failed.
     */ addTilesetImage: function(tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid) {
                    if (tilesetName === undefined) return null;
                    if (key === undefined || key === null) key = tilesetName;
                    if (!this.scene.sys.textures.exists(key)) {
                        console.warn("Invalid Tileset Image: " + key);
                        return null;
                    }
                    var texture = this.scene.sys.textures.get(key);
                    var index = this.getTilesetIndex(tilesetName);
                    if (index === null && this.format === Formats.TILED_JSON) {
                        console.warn("No data found for Tileset: " + tilesetName);
                        return null;
                    }
                    var tileset = this.tilesets[index];
                    if (tileset) {
                        tileset.setTileSize(tileWidth, tileHeight);
                        tileset.setSpacing(tileMargin, tileSpacing);
                        tileset.setImage(texture);
                        return tileset;
                    }
                    if (tileWidth === undefined) tileWidth = this.tileWidth;
                    if (tileHeight === undefined) tileHeight = this.tileHeight;
                    if (tileMargin === undefined) tileMargin = 0;
                    if (tileSpacing === undefined) tileSpacing = 0;
                    if (gid === undefined) gid = 0;
                    tileset = new Tileset(tilesetName, gid, tileWidth, tileHeight, tileMargin, tileSpacing);
                    tileset.setImage(texture);
                    this.tilesets.push(tileset);
                    return tileset;
                },
                /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * If no layer specified, the map's current layer is used. This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#copy
     * @since 3.0.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                    layer = this.getLayer(layer);
                    if (layer !== null) {
                        TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer);
                        return this;
                    } else return null;
                },
                /**
     * Creates a new and empty Tilemap Layer. The currently selected layer in the map is set to this new layer.
     *
     * Prior to v3.50.0 this method was called `createBlankDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createBlankLayer
     * @since 3.0.0
     *
     * @param {string} name - The name of this layer. Must be unique within the map.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
     * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
     * @param {number} [width] - The width of the layer in tiles. If not specified, it will default to the map's width.
     * @param {number} [height] - The height of the layer in tiles. If not specified, it will default to the map's height.
     * @param {number} [tileWidth] - The width of the tiles the layer uses for calculations. If not specified, it will default to the map's tileWidth.
     * @param {number} [tileHeight] - The height of the tiles the layer uses for calculations. If not specified, it will default to the map's tileHeight.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer that was created, or `null` if it failed.
     */ createBlankLayer: function(name, tileset, x, y, width, height, tileWidth, tileHeight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    if (tileWidth === undefined) tileWidth = this.tileWidth;
                    if (tileHeight === undefined) tileHeight = this.tileHeight;
                    var index = this.getLayerIndex(name);
                    if (index !== null) {
                        console.warn("Invalid Tilemap Layer ID: " + name);
                        return null;
                    }
                    var layerData = new LayerData({
                        name: name,
                        tileWidth: tileWidth,
                        tileHeight: tileHeight,
                        width: width,
                        height: height,
                        orientation: this.orientation
                    });
                    var row;
                    for(var tileY = 0; tileY < height; tileY++){
                        row = [];
                        for(var tileX = 0; tileX < width; tileX++)row.push(new Tile(layerData, -1, tileX, tileY, tileWidth, tileHeight, this.tileWidth, this.tileHeight));
                        layerData.data.push(row);
                    }
                    this.layers.push(layerData);
                    this.currentLayerIndex = this.layers.length - 1;
                    var layer = new TilemapLayer(this.scene, this, this.currentLayerIndex, tileset, x, y);
                    layer.setRenderOrder(this.renderOrder);
                    this.scene.sys.displayList.add(layer);
                    return layer;
                },
                /**
     * Creates a new Tilemap Layer that renders the LayerData associated with the given
     * `layerID`. The currently selected layer in the map is set to this new layer.
     *
     * The `layerID` is important. If you've created your map in Tiled then you can get this by
     * looking in Tiled and looking at the layer name. Or you can open the JSON file it exports and
     * look at the layers[].name value. Either way it must match.
     *
     * Prior to v3.50.0 this method was called `createDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createLayer
     * @since 3.0.0
     *
     * @param {(number|string)} layerID - The layer array index value, or if a string is given, the layer name from Tiled.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The x position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     * @param {number} [y=0] - The y position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer was created, or null if it failed.
     */ createLayer: function(layerID, tileset, x, y) {
                    var index = this.getLayerIndex(layerID);
                    if (index === null) {
                        console.warn("Invalid Tilemap Layer ID: " + layerID);
                        if (typeof layerID === "string") console.warn("Valid tilelayer names:\n	" + this.getTileLayerNames().join(",\n	"));
                        return null;
                    }
                    var layerData = this.layers[index];
                    // Check for an associated static or dynamic tilemap layer
                    if (layerData.tilemapLayer) {
                        console.warn("Tilemap Layer ID already exists:" + layerID);
                        return null;
                    }
                    this.currentLayerIndex = index;
                    //  Default the x/y position to match Tiled layer offset, if it exists.
                    if (x === undefined) x = layerData.x;
                    if (y === undefined) y = layerData.y;
                    var layer = new TilemapLayer(this.scene, this, index, tileset, x, y);
                    layer.setRenderOrder(this.renderOrder);
                    this.scene.sys.displayList.add(layer);
                    return layer;
                },
                /**
     * This method will iterate through all of the objects defined in a Tiled Object Layer and then
     * convert the matching results into Phaser Game Objects (by default, Sprites)
     *
     * Objects are matched on one of 3 criteria: The Object ID, the Object GID or the Object Name.
     *
     * Within Tiled, Object IDs are unique per Object. Object GIDs, however, are shared by all objects
     * using the same image. Finally, Object Names are strings and the same name can be used on multiple
     * Objects in Tiled, they do not have to be unique.
     *
     * You set the configuration parameter accordingly, based on which type of criteria you wish
     * to match against. For example, to convert all items on an Object Layer with a `gid` of 26:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26
     * });
     * ```
     *
     * Or, to convert objects with the name 'bonus':
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   name: 'bonus'
     * });
     * ```
     *
     * Or, to convert an object with a specific id:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   id: 9
     * });
     * ```
     *
     * You should only specify either `id`, `gid`, `name`, or none of them. Do not add more than
     * one criteria to your config. If you do not specify any criteria, then _all_ objects in the
     * Object Layer will be converted.
     *
     * By default this method will convert objects into `Sprite` instances, but you can override
     * this by providing your own class type:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26,
     *   classType: Coin
     * });
     * ```
     *
     * This will convert all Objects with a gid of 26 into your custom `Coin` class. You can pass
     * any class type here, but it _must_ extend `Phaser.GameObjects.GameObject` as its base class.
     * Your class will always be passed 1 parameter: `scene`, which is a reference to either the Scene
     * specified in the config object or, if not given, the Scene to which this Tilemap belongs.
     *
     * All properties from object are copied into the Game Object, so you can use this as an easy
     * way to configure properties from within the map editor. For example giving an object a
     * property of `alpha: 0.5` in Tiled will be reflected in the Game Object that is created.
     *
     * Custom object properties that do not exist as a Game Object property are set in the
     * Game Objects {@link Phaser.GameObjects.GameObject#data data store}.
     *
     * You can use set a `container` property in the config. If given, the class will be added to
     * the Container instance instead of the Scene.
     *
     * Finally, you can provide an array of config objects, to convert multiple types of object in
     * a single call:
     *
     * ```javascript
     * createFromObjects(layerName, [
     *   {
     *     gid: 26,
     *     classType: Coin
     *   },
     *   {
     *     id: 9,
     *     classType: BossMonster
     *   },
     *   {
     *     name: 'lava',
     *     classType: LavaTile
     *   }
     * ]);
     * ```
     *
     * The signature of this method changed significantly in v3.50.0. Prior to this, it did not take config objects.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromObjects
     * @since 3.0.0
     *
     * @param {string} objectLayerName - The name of the Tiled object layer to create the Game Objects from.
     * @param {Phaser.Types.Tilemaps.CreateFromObjectLayerConfig|Phaser.Types.Tilemaps.CreateFromObjectLayerConfig[]} config - A CreateFromObjects configuration object, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array containing the Game Objects that were created. Empty if invalid object layer, or no matching id/gid/name was found.
     */ createFromObjects: function(objectLayerName, config) {
                    var results = [];
                    var objectLayer = this.getObjectLayer(objectLayerName);
                    if (!objectLayer) {
                        console.warn("createFromObjects: Invalid objectLayerName given: " + objectLayerName);
                        return results;
                    }
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var objects = objectLayer.objects;
                    for(var c = 0; c < config.length; c++){
                        var singleConfig = config[c];
                        var id = GetFastValue(singleConfig, "id", null);
                        var gid = GetFastValue(singleConfig, "gid", null);
                        var name = GetFastValue(singleConfig, "name", null);
                        var obj;
                        var toConvert = [];
                        //  Sweep to get all the objects we want to convert in this pass
                        for(var s = 0; s < objects.length; s++){
                            obj = objects[s];
                            if (id === null && gid === null && name === null || id !== null && obj.id === id || gid !== null && obj.gid === gid || name !== null && obj.name === name) toConvert.push(obj);
                        }
                        //  Now let's convert them ...
                        var classType = GetFastValue(singleConfig, "classType", Sprite);
                        var scene = GetFastValue(singleConfig, "scene", this.scene);
                        var container = GetFastValue(singleConfig, "container", null);
                        var texture = GetFastValue(singleConfig, "key", null);
                        var frame = GetFastValue(singleConfig, "frame", null);
                        for(var i = 0; i < toConvert.length; i++){
                            obj = toConvert[i];
                            var sprite = new classType(scene);
                            sprite.setName(obj.name);
                            sprite.setPosition(obj.x, obj.y);
                            sprite.setTexture(texture, frame);
                            if (obj.width) sprite.displayWidth = obj.width;
                            if (obj.height) sprite.displayHeight = obj.height;
                            //  Origin is (0, 1) in Tiled, so find the offset that matches the Sprites origin.
                            //  Do not offset objects with zero dimensions (e.g. points).
                            var offset = {
                                x: sprite.originX * obj.width,
                                y: (sprite.originY - 1) * obj.height
                            };
                            //  If the object is rotated, then the origin offset also needs to be rotated.
                            if (obj.rotation) {
                                var angle = DegToRad(obj.rotation);
                                Rotate(offset, angle);
                                sprite.rotation = angle;
                            }
                            sprite.x += offset.x;
                            sprite.y += offset.y;
                            if (obj.flippedHorizontal !== undefined || obj.flippedVertical !== undefined) sprite.setFlip(obj.flippedHorizontal, obj.flippedVertical);
                            if (!obj.visible) sprite.visible = false;
                            //  Set properties the class may have, or setData those it doesn't
                            if (Array.isArray(obj.properties)) // Tiled objects custom properties format
                            obj.properties.forEach(function(propData) {
                                var key = propData["name"];
                                if (sprite[key] !== undefined) sprite[key] = propData["value"];
                                else sprite.setData(key, propData["value"]);
                            });
                            else {
                                for(var key in obj.properties)if (sprite[key] !== undefined) sprite[key] = obj.properties[key];
                                else sprite.setData(key, obj.properties[key]);
                            }
                            if (container) container.add(sprite);
                            else scene.add.existing(sprite);
                            results.push(sprite);
                        }
                    }
                    return results;
                },
                /**
     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromTiles
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} spriteConfig - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.GameObjects.Sprite[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, layer);
                },
                /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * If no layer specified, the map's current layer is used.
     * This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#fill
     * @since 3.0.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, layer);
                    return this;
                },
                /**
     * For each object in the given object layer, run the given filter callback function. Any
     * objects that pass the filter test (i.e. where the callback returns true) will returned as a
     * new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#filterObjects
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFilterCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject[]} An array of object that match the search, or null if the objectLayer given was invalid.
     */ filterObjects: function(objectLayer, callback, context) {
                    if (typeof objectLayer === "string") {
                        var name = objectLayer;
                        objectLayer = this.getObjectLayer(objectLayer);
                        if (!objectLayer) {
                            console.warn("No object layer found with the name: " + name);
                            return null;
                        }
                    }
                    return objectLayer.objects.filter(callback, context);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#filterTiles
     * @since 3.0.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findByIndex
     * @since 3.0.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findByIndex: function(findIndex, skip, reverse, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FindByIndex(findIndex, skip, reverse, layer);
                },
                /**
     * Find the first object in the given object layer that satisfies the provided testing function.
     * I.e. finds the first object for which `callback` returns true. Similar to
     * Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#findObject
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFindCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject} An object that matches the search, or null if no object found.
     */ findObject: function(objectLayer, callback, context) {
                    if (typeof objectLayer === "string") {
                        var name = objectLayer;
                        objectLayer = this.getObjectLayer(objectLayer);
                        if (!objectLayer) {
                            console.warn("No object layer found with the name: " + name);
                            return null;
                        }
                    }
                    return objectLayer.objects.find(callback, context) || null;
                },
                /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     * If no layer specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findTile
     * @since 3.0.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#forEachTile
     * @since 3.0.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                    return this;
                },
                /**
     * Gets the image layer index based on its name.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the image to get.
     *
     * @return {number} The index of the image in this tilemap, or null if not found.
     */ getImageIndex: function(name) {
                    return this.getIndex(this.images, name);
                },
                /**
     * Return a list of all valid imagelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid imagelayer names / IDs loaded into this Tilemap.
     */ getImageLayerNames: function() {
                    if (!this.images || !Array.isArray(this.images)) return [];
                    return this.images.map(function(image) {
                        return image.name;
                    });
                },
                /**
     * Internally used. Returns the index of the object in one of the Tilemaps arrays whose name
     * property matches the given `name`.
     *
     * @method Phaser.Tilemaps.Tilemap#getIndex
     * @since 3.0.0
     *
     * @param {array} location - The Tilemap array to search.
     * @param {string} name - The name of the array element to get.
     *
     * @return {number} The index of the element in the array, or null if not found.
     */ getIndex: function(location, name) {
                    for(var i = 0; i < location.length; i++){
                        if (location[i].name === name) return i;
                    }
                    return null;
                },
                /**
     * Gets the LayerData from `this.layers` that is associated with the given `layer`, or null if the layer is invalid.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or Tilemap Layer. If not given will default to the maps current layer index.
     *
     * @return {Phaser.Tilemaps.LayerData} The corresponding LayerData within this.layers.
     */ getLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    return index !== null ? this.layers[index] : null;
                },
                /**
     * Gets the ObjectLayer from `this.objects` that has the given `name`, or null if no ObjectLayer is found with that name.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayer
     * @since 3.0.0
     *
     * @param {string} [name] - The name of the object layer from Tiled.
     *
     * @return {?Phaser.Tilemaps.ObjectLayer} The corresponding `ObjectLayer` within `this.objects`, or null.
     */ getObjectLayer: function(name) {
                    var index = this.getIndex(this.objects, name);
                    return index !== null ? this.objects[index] : null;
                },
                /**
     * Return a list of all valid objectgroup names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid objectgroup names / IDs loaded into this Tilemap.
     */ getObjectLayerNames: function() {
                    if (!this.objects || !Array.isArray(this.objects)) return [];
                    return this.objects.map(function(object) {
                        return object.name;
                    });
                },
                /**
     * Gets the LayerData index of the given `layer` within this.layers, or null if an invalid
     * `layer` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndex
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a Tilemap Layer. If not given will default to the map's current layer index.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndex: function(layer) {
                    if (layer === undefined) return this.currentLayerIndex;
                    else if (typeof layer === "string") return this.getLayerIndexByName(layer);
                    else if (typeof layer === "number" && layer < this.layers.length) return layer;
                    else if (layer instanceof TilemapLayer) return layer.layerIndex;
                    else return null;
                },
                /**
     * Gets the index of the LayerData within this.layers that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndexByName
     * @since 3.0.0
     *
     * @param {string} name - The name of the layer to get.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndexByName: function(name) {
                    return this.getIndex(this.layers, name);
                },
                /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAt: function(tileX, tileY, nonNull, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTileAt(tileX, tileY, nonNull, layer);
                },
                /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull] - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, layer);
                },
                /**
     * Return a list of all valid tilelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid tilelayer names / IDs loaded into this Tilemap.
     */ getTileLayerNames: function() {
                    if (!this.layers || !Array.isArray(this.layers)) return [];
                    return this.layers.map(function(layer) {
                        return layer.name;
                    });
                },
                /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinShape: function(shape, filteringOptions, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, layer);
                },
                /**
     * Gets the Tileset that has the given `name`, or null if an invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileset
     * @since 3.14.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {?Phaser.Tilemaps.Tileset} The Tileset, or `null` if no matching named tileset was found.
     */ getTileset: function(name) {
                    var index = this.getIndex(this.tilesets, name);
                    return index !== null ? this.tilesets[index] : null;
                },
                /**
     * Gets the index of the Tileset within this.tilesets that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesetIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {number} The Tileset index within this.tilesets.
     */ getTilesetIndex: function(name) {
                    return this.getIndex(this.tilesets, name);
                },
                /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAt: function(tileX, tileY, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.HasTileAt(tileX, tileY, layer);
                },
                /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAtWorldXY: function(worldX, worldY, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, layer);
                },
                /**
     * The LayerData object that is currently selected in the map. You can set this property using
     * any type supported by setLayer.
     *
     * @name Phaser.Tilemaps.Tilemap#layer
     * @type {Phaser.Tilemaps.LayerData}
     * @since 3.0.0
     */ layer: {
                    get: function() {
                        return this.layers[this.currentLayerIndex];
                    },
                    set: function(layer) {
                        this.setLayer(layer);
                    }
                },
                /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAt
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid or the coordinates were out of bounds.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, layer);
                },
                /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAtWorldXY
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, layer);
                },
                /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTilesAt
     * @since 3.0.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, layer);
                    return this;
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#randomize
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ randomize: function(tileX, tileY, width, height, indexes, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Randomize(tileX, tileY, width, height, indexes, layer);
                    return this;
                },
                /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesAt: function(tileX, tileY, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.CalculateFacesAt(tileX, tileY, layer);
                    return this;
                },
                /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesWithin: function(tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Removes the given TilemapLayer from this Tilemap without destroying it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be removed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ removeLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) {
                        SpliceOne(this.layers, index);
                        for(var i = index; i < this.layers.length; i++)if (this.layers[i].tilemapLayer) this.layers[i].tilemapLayer.layerIndex--;
                        if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                        return this;
                    } else return null;
                },
                /**
     * Destroys the given TilemapLayer and removes it from this Tilemap.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#destroyLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be destroyed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ destroyLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) {
                        layer = this.layers[index];
                        layer.destroy();
                        SpliceOne(this.layers, index);
                        if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                        return this;
                    } else return null;
                },
                /**
     * Removes all Tilemap Layers from this Tilemap and calls `destroy` on each of them.
     *
     * @method Phaser.Tilemaps.Tilemap#removeAllLayers
     * @since 3.0.0
     *
     * @return {this} This Tilemap object.
     */ removeAllLayers: function() {
                    var layers = this.layers;
                    for(var i = 0; i < layers.length; i++)if (layers[i].tilemapLayer) layers[i].tilemapLayer.destroy(false);
                    layers.length = 0;
                    this.currentLayerIndex = 0;
                    return this;
                },
                /**
     * Removes the given Tile, or an array of Tiles, from the layer to which they belong,
     * and optionally recalculates the collision information.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTile
     * @since 3.17.0
     *
     * @param {(Phaser.Tilemaps.Tile|Phaser.Tilemaps.Tile[])} tiles - The Tile to remove, or an array of Tiles.
     * @param {number} [replaceIndex=-1] - After removing the Tile, insert a brand new Tile into its location with the given index. Leave as -1 to just remove the tile.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile[]} Returns an array of Tiles that were removed.
     */ removeTile: function(tiles, replaceIndex, recalculateFaces) {
                    if (replaceIndex === undefined) replaceIndex = -1;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    var removed = [];
                    if (!Array.isArray(tiles)) tiles = [
                        tiles
                    ];
                    for(var i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        removed.push(this.removeTileAt(tile.x, tile.y, true, recalculateFaces, tile.tilemapLayer));
                        if (replaceIndex > -1) this.putTileAt(replaceIndex, tile.x, tile.y, recalculateFaces, tile.tilemapLayer);
                    }
                    return removed;
                },
                /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns the Tile that was removed, or null if the layer given was invalid.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                    if (replaceWithNull === undefined) replaceWithNull = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, layer);
                },
                /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                    if (replaceWithNull === undefined) replaceWithNull = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer);
                },
                /**
     * Draws a debug representation of the layer to the given Graphics object. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * **Note:** This method currently only works with orthogonal tilemap layers.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ renderDebug: function(graphics, styleConfig, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    if (this.orientation === ORIENTATION.ORTHOGONAL) TilemapComponents.RenderDebug(graphics, styleConfig, layer);
                    return this;
                },
                /**
     * Draws a debug representation of all layers within this Tilemap to the given Graphics object.
     *
     * This is helpful when you want to get a quick idea of which of your tiles are colliding and which
     * have interesting faces. The tiles are drawn starting at (0, 0) in the Graphics, allowing you to
     * place the debug representation wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebugFull
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap instance.
     */ renderDebugFull: function(graphics, styleConfig) {
                    var layers = this.layers;
                    for(var i = 0; i < layers.length; i++)TilemapComponents.RenderDebug(graphics, styleConfig, layers[i]);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#replaceByIndex
     * @since 3.0.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollision
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollision: function(indexes, collides, recalculateFaces, layer, updateLayer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (updateLayer === undefined) updateLayer = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollision(indexes, collides, recalculateFaces, layer, updateLayer);
                    return this;
                },
                /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionBetween
     * @since 3.0.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByProperty
     * @since 3.0.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByExclusion
     * @since 3.0.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tiles colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionFromCollisionGroup
     * @since 3.0.0
     *
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see `setTileLocationCallback`.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileIndexCallback
     * @since 3.0.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for. All values should be integers.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileIndexCallback: function(indexes, callback, callbackContext, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, layer);
                    return this;
                },
                /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileLocationCallback
     * @since 3.0.0
     *
     * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} width - How many tiles wide from the `tileX` index the area will be.
     * @param {number} height - How many tiles tall from the `tileY` index the area will be.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, layer);
                    return this;
                },
                /**
     * Sets the current layer to the LayerData associated with `layer`.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) this.currentLayerIndex = index;
                    return this;
                },
                /**
     * Sets the base tile size for the map. Note: this does not necessarily match the tileWidth and
     * tileHeight for all layers. This also updates the base size on all tiles across all layers.
     *
     * @method Phaser.Tilemaps.Tilemap#setBaseTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles the map uses for calculations.
     * @param {number} tileHeight - The height of the tiles the map uses for calculations.
     *
     * @return {this} This Tilemap object.
     */ setBaseTileSize: function(tileWidth, tileHeight) {
                    this.tileWidth = tileWidth;
                    this.tileHeight = tileHeight;
                    this.widthInPixels = this.width * tileWidth;
                    this.heightInPixels = this.height * tileHeight;
                    //  Update the base tile size on all layers & tiles
                    for(var i = 0; i < this.layers.length; i++){
                        this.layers[i].baseTileWidth = tileWidth;
                        this.layers[i].baseTileHeight = tileHeight;
                        var mapData = this.layers[i].data;
                        var mapWidth = this.layers[i].width;
                        var mapHeight = this.layers[i].height;
                        for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                            var tile = mapData[row][col];
                            if (tile !== null) tile.setSize(undefined, undefined, tileWidth, tileHeight);
                        }
                    }
                    return this;
                },
                /**
     * Sets the tile size for a specific `layer`. Note: this does not necessarily match the maps
     * tileWidth and tileHeight for all layers. This will set the tile size for the layer and any
     * tiles the layer has.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayerTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles (in pixels) in the layer.
     * @param {number} tileHeight - The height of the tiles (in pixels) in the layer.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayerTileSize: function(tileWidth, tileHeight, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return this;
                    layer.tileWidth = tileWidth;
                    layer.tileHeight = tileHeight;
                    var mapData = layer.data;
                    var mapWidth = layer.width;
                    var mapHeight = layer.height;
                    for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                        var tile = mapData[row][col];
                        if (tile !== null) tile.setSize(tileWidth, tileHeight);
                    }
                    return this;
                },
                /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#shuffle
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ shuffle: function(tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Shuffle(tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#swapByIndex
     * @since 3.0.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldX
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldX: function(tileX, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldX(tileX, camera, layer);
                },
                /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldY
     * @since 3.0.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldY: function(tileX, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldY(tileX, camera, layer);
                },
                /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldXY
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a Vector2, or null if the layer given was invalid.
     */ tileToWorldXY: function(tileX, tileY, vec2, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldXY(tileX, tileY, vec2, camera, layer);
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being picked is (the indexs weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#weightedRandomize
     * @since 3.0.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, layer);
                    return this;
                },
                /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileX
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileX: function(worldX, snapToFloor, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileX(worldX, snapToFloor, camera, layer);
                },
                /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileY
     * @since 3.0.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileY: function(worldY, snapToFloor, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileY(worldY, snapToFloor, camera, layer);
                },
                /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a vec2, or null if the layer given was invalid.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, vec2, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileXY(worldX, worldY, snapToFloor, vec2, camera, layer);
                },
                /**
     * Removes all layer data from this Tilemap and nulls the scene reference. This will destroy any
     * TilemapLayers that have been created.
     *
     * @method Phaser.Tilemaps.Tilemap#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllLayers();
                    this.tilesets.length = 0;
                    this.objects.length = 0;
                    this.scene = null;
                }
            });
            module1.exports = Tilemap;
        /***/ },
        /* 581 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var TilemapComponents = __webpack_require__(251);
            var TilemapLayerRender = __webpack_require__(1456);
            /**
 * @classdesc
 * A Tilemap Layer is a Game Object that renders LayerData from a Tilemap when used in combination
 * with one, or more, Tilesets.
 *
 * @class TilemapLayer
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {Phaser.Tilemaps.Tilemap} tilemap - The Tilemap this layer is a part of.
 * @param {number} layerIndex - The index of the LayerData associated with this layer.
 * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
 * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
 * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
 */ var TilemapLayer = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Origin,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    TilemapLayerRender
                ],
                initialize: function TilemapLayer(scene, tilemap, layerIndex, tileset, x, y) {
                    GameObject.call(this, scene, "TilemapLayer");
                    /**
         * Used internally by physics system to perform fast type checks.
         *
         * @name Phaser.Tilemaps.TilemapLayer#isTilemap
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTilemap = true;
                    /**
         * The Tilemap that this layer is a part of.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilemap
         * @type {Phaser.Tilemaps.Tilemap}
         * @since 3.50.0
         */ this.tilemap = tilemap;
                    /**
         * The index of the LayerData associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layerIndex
         * @type {number}
         * @since 3.50.0
         */ this.layerIndex = layerIndex;
                    /**
         * The LayerData associated with this layer. LayerData can only be associated with one
         * tilemap layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.50.0
         */ this.layer = tilemap.layers[layerIndex];
                    // Link the LayerData with this static tilemap layer
                    this.layer.tilemapLayer = this;
                    /**
         * An array of `Tileset` objects associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tileset
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.tileset = [];
                    /**
         * The total number of tiles drawn by the renderer in the last frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesDrawn
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesDrawn = 0;
                    /**
         * The total number of tiles in this layer. Updated every frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesTotal
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesTotal = this.layer.width * this.layer.height;
                    /**
         * Used internally during rendering. This holds the tiles that are visible within the Camera.
         *
         * @name Phaser.Tilemaps.TilemapLayer#culledTiles
         * @type {Phaser.Tilemaps.Tile[]}
         * @since 3.50.0
         */ this.culledTiles = [];
                    /**
         * You can control if the camera should cull tiles on this layer before rendering them or not.
         *
         * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
         *
         * However, there are some instances when you may wish to disable this, and toggling this flag allows
         * you to do so. Also see `setSkipCull` for a chainable method that does the same thing.
         *
         * @name Phaser.Tilemaps.TilemapLayer#skipCull
         * @type {boolean}
         * @since 3.50.0
         */ this.skipCull = false;
                    /**
         * The amount of extra tiles to add into the cull rectangle when calculating its horizontal size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingX
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingX = 1;
                    /**
         * The amount of extra tiles to add into the cull rectangle when calculating its vertical size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingY
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingY = 1;
                    /**
         * The callback that is invoked when the tiles are culled.
         *
         * It will call a different function based on the map orientation:
         *
         * Orthogonal (the default) is `TilemapComponents.CullTiles`
         * Isometric is `TilemapComponents.IsometricCullTiles`
         * Hexagonal is `TilemapComponents.HexagonalCullTiles`
         * Staggered is `TilemapComponents.StaggeredCullTiles`
         *
         * However, you can override this to call any function you like.
         *
         * It will be sent 4 arguments:
         *
         * 1. The Phaser.Tilemaps.LayerData object for this Layer
         * 2. The Camera that is culling the layer. You can check its `dirty` property to see if it has changed since the last cull.
         * 3. A reference to the `culledTiles` array, which should be used to store the tiles you want rendered.
         * 4. The Render Order constant.
         *
         * See the `TilemapComponents.CullTiles` source code for details on implementing your own culling system.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullCallback
         * @type {function}
         * @since 3.50.0
         */ this.cullCallback = TilemapComponents.GetCullTilesFunction(this.layer.orientation);
                    /**
         * The rendering (draw) order of the tiles in this layer.
         *
         * The default is 0 which is 'right-down', meaning it will draw the tiles starting from the top-left,
         * drawing to the right and then moving down to the next row.
         *
         * The draw orders are:
         *
         * 0 = right-down
         * 1 = left-down
         * 2 = right-up
         * 3 = left-up
         *
         * This can be changed via the `setRenderOrder` method.
         *
         * @name Phaser.Tilemaps.TilemapLayer#_renderOrder
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ this._renderOrder = 0;
                    /**
         * An array holding the mapping between the tile indexes and the tileset they belong to.
         *
         * @name Phaser.Tilemaps.TilemapLayer#gidMap
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.gidMap = [];
                    this.setTilesets(tileset);
                    this.setAlpha(this.layer.alpha);
                    this.setPosition(x, y);
                    this.setOrigin();
                    this.setSize(tilemap.tileWidth * this.layer.width, tilemap.tileHeight * this.layer.height);
                    this.initPipeline();
                },
                /**
     * Populates the internal `tileset` array with the Tileset references this Layer requires for rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTilesets
     * @private
     * @since 3.50.0
     *
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     */ setTilesets: function(tilesets) {
                    var gidMap = [];
                    var setList = [];
                    var map = this.tilemap;
                    if (!Array.isArray(tilesets)) tilesets = [
                        tilesets
                    ];
                    for(var i = 0; i < tilesets.length; i++){
                        var tileset = tilesets[i];
                        if (typeof tileset === "string") tileset = map.getTileset(tileset);
                        if (tileset) {
                            setList.push(tileset);
                            var s = tileset.firstgid;
                            for(var t = 0; t < tileset.total; t++)gidMap[s + t] = tileset;
                        }
                    }
                    this.gidMap = gidMap;
                    this.tileset = setList;
                },
                /**
     * Sets the rendering (draw) order of the tiles in this layer.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setRenderOrder
     * @since 3.50.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap Layer object.
     */ setRenderOrder: function(renderOrder) {
                    var orders = [
                        "right-down",
                        "left-down",
                        "right-up",
                        "left-up"
                    ];
                    if (typeof renderOrder === "string") renderOrder = orders.indexOf(renderOrder);
                    if (renderOrder >= 0 && renderOrder < 4) this._renderOrder = renderOrder;
                    return this;
                },
                /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate.
     * @param {number} tileY - The y coordinate.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesAt: function(tileX, tileY) {
                    TilemapComponents.CalculateFacesAt(tileX, tileY, this.layer);
                    return this;
                },
                /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesWithin: function(tileX, tileY, width, height) {
                    TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * @method Phaser.Tilemaps.TilemapLayer#createFromTiles
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} [spriteConfig] - The config object to pass into the Sprite creator (i.e.
     * scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when determining the world XY
     *
     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera) {
                    return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, this.layer);
                },
                /**
     * Returns the tiles in the given layer that are within the cameras viewport.
     * This is used internally during rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#cull
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects to render.
     */ cull: function(camera) {
                    return this.cullCallback(this.layer, camera, this.culledTiles, this._renderOrder);
                },
                /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * @method Phaser.Tilemaps.TilemapLayer#copy
     * @since 3.50.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces) {
                    TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#fill
     * @since 3.50.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces) {
                    TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#filterTiles
     * @since 3.50.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findByIndex
     * @since 3.50.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     *
     * @return {Phaser.Tilemaps.Tile} The first matching Tile object.
     */ findByIndex: function(findIndex, skip, reverse) {
                    return TilemapComponents.FindByIndex(findIndex, skip, reverse, this.layer);
                },
                /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findTile
     * @since 3.50.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {?Phaser.Tilemaps.Tile} The first Tile found at the given location.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#forEachTile
     * @since 3.50.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context, or scope, under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {this} This Tilemap Layer object.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                    return this;
                },
                /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAt: function(tileX, tileY, nonNull) {
                    return TilemapComponents.GetTileAt(tileX, tileY, nonNull, this.layer);
                },
                /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera) {
                    return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, this.layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinShape
     * @since 3.50.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the shape.
     */ getTilesWithinShape: function(shape, filteringOptions, camera) {
                    return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, this.layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera) {
                    return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, this.layer);
                },
                /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAt: function(tileX, tileY) {
                    return TilemapComponents.HasTileAt(tileX, tileY, this.layer);
                },
                /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAtWorldXY: function(worldX, worldY, camera) {
                    return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, this.layer);
                },
                /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAt
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces) {
                    return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, this.layer);
                },
                /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAtWorldXY
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera) {
                    return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, this.layer);
                },
                /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTilesAt
     * @since 3.50.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces) {
                    TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#randomize
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     *
     * @return {this} This Tilemap Layer object.
     */ randomize: function(tileX, tileY, width, height, indexes) {
                    TilemapComponents.Randomize(tileX, tileY, width, height, indexes, this.layer);
                    return this;
                },
                /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} A Tile object.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces) {
                    return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, this.layer);
                },
                /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was removed from the given location.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera) {
                    return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, this.layer);
                },
                /**
     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.TilemapLayer#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap Layer object.
     */ renderDebug: function(graphics, styleConfig) {
                    TilemapComponents.RenderDebug(graphics, styleConfig, this.layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#replaceByIndex
     * @since 3.50.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height) {
                    TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * You can control if the Cameras should cull tiles before rendering them or not.
     *
     * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
     *
     * However, there are some instances when you may wish to disable this.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setSkipCull
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Set to `true` to stop culling tiles. Set to `false` to enable culling again.
     *
     * @return {this} This Tilemap Layer object.
     */ setSkipCull: function(value) {
                    if (value === undefined) value = true;
                    this.skipCull = value;
                    return this;
                },
                /**
     * When a Camera culls the tiles in this layer it does so using its view into the world, building up a
     * rectangle inside which the tiles must exist or they will be culled. Sometimes you may need to expand the size
     * of this 'cull rectangle', especially if you plan on rotating the Camera viewing the layer. Do so
     * by providing the padding values. The values given are in tiles, not pixels. So if the tile width was 32px
     * and you set `paddingX` to be 4, it would add 32px x 4 to the cull rectangle (adjusted for scale)
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCullPadding
     * @since 3.50.0
     *
     * @param {number} [paddingX=1] - The amount of extra horizontal tiles to add to the cull check padding.
     * @param {number} [paddingY=1] - The amount of extra vertical tiles to add to the cull check padding.
     *
     * @return {this} This Tilemap Layer object.
     */ setCullPadding: function(paddingX, paddingY) {
                    if (paddingX === undefined) paddingX = 1;
                    if (paddingY === undefined) paddingY = 1;
                    this.cullPaddingX = paddingX;
                    this.cullPaddingY = paddingY;
                    return this;
                },
                /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollision
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollision: function(indexes, collides, recalculateFaces, updateLayer) {
                    TilemapComponents.SetCollision(indexes, collides, recalculateFaces, this.layer, updateLayer);
                    return this;
                },
                /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionBetween
     * @since 3.50.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByProperty
     * @since 3.50.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByExclusion
     * @since 3.50.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tile's colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionFromCollisionGroup
     * @since 3.50.0
     *
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces) {
                    TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see setTileLocationCallback.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileIndexCallback
     * @since 3.50.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileIndexCallback: function(indexes, callback, callbackContext) {
                    TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, this.layer);
                    return this;
                },
                /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileLocationCallback
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {function} [callback] - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context, or scope, under which the callback is invoked.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext) {
                    TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, this.layer);
                    return this;
                },
                /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#shuffle
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ shuffle: function(tileX, tileY, width, height) {
                    TilemapComponents.Shuffle(tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#swapByIndex
     * @since 3.50.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height) {
                    TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldX
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile X coordinate converted to pixels.
     */ tileToWorldX: function(tileX, camera) {
                    return this.tilemap.tileToWorldX(tileX, camera, this);
                },
                /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldY
     * @since 3.50.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile Y coordinate converted to pixels.
     */ tileToWorldY: function(tileY, camera) {
                    return this.tilemap.tileToWorldY(tileY, camera, this);
                },
                /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldXY
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the world coordinates of the Tile.
     */ tileToWorldXY: function(tileX, tileY, point, camera) {
                    return this.tilemap.tileToWorldXY(tileX, tileY, point, camera, this);
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being choose is (the index's weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#weightedRandomize
     * @since 3.50.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height) {
                    TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, this.layer);
                    return this;
                },
                /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileX
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile X coordinate based on the world value.
     */ worldToTileX: function(worldX, snapToFloor, camera) {
                    return this.tilemap.worldToTileX(worldX, snapToFloor, camera, this);
                },
                /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileY
     * @since 3.50.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile Y coordinate based on the world value.
     */ worldToTileY: function(worldY, snapToFloor, camera) {
                    return this.tilemap.worldToTileY(worldY, snapToFloor, camera, this);
                },
                /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the tile coordinates of the world values.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, point, camera) {
                    return this.tilemap.worldToTileXY(worldX, worldY, snapToFloor, point, camera, this);
                },
                /**
     * Destroys this TilemapLayer and removes its link to the associated LayerData.
     *
     * @method Phaser.Tilemaps.TilemapLayer#destroy
     * @since 3.50.0
     *
     * @param {boolean} [removeFromTilemap=true] - Remove this layer from the parent Tilemap?
     */ destroy: function(removeFromTilemap) {
                    if (removeFromTilemap === undefined) removeFromTilemap = true;
                    if (!this.tilemap) //  Abort, we've already been destroyed
                    return;
                    //  Uninstall this layer only if it is still installed on the LayerData object
                    if (this.layer.tilemapLayer === this) this.layer.tilemapLayer = undefined;
                    if (removeFromTilemap) this.tilemap.removeLayer(this);
                    this.tilemap = undefined;
                    this.layer = undefined;
                    this.culledTiles.length = 0;
                    this.cullCallback = null;
                    this.gidMap = [];
                    this.tileset = [];
                    GameObject.prototype.destroy.call(this);
                }
            });
            module1.exports = TilemapLayer;
        /***/ },
        /* 582 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A Timer Event represents a delayed function call. It's managed by a Scene's {@link Clock} and will call its function after a set amount of time has passed. The Timer Event can optionally repeat - i.e. call its function multiple times before finishing, or loop indefinitely.
 *
 * Because it's managed by a Clock, a Timer Event is based on game time, will be affected by its Clock's time scale, and will pause if its Clock pauses.
 *
 * @class TimerEvent
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Time.TimerEventConfig} config - The configuration for the Timer Event, including its delay and callback.
 */ var TimerEvent = new Class({
                initialize: function TimerEvent(config) {
                    /**
         * The delay in ms at which this TimerEvent fires.
         *
         * @name Phaser.Time.TimerEvent#delay
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.delay = 0;
                    /**
         * The total number of times this TimerEvent will repeat before finishing.
         *
         * @name Phaser.Time.TimerEvent#repeat
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.repeat = 0;
                    /**
         * If repeating this contains the current repeat count.
         *
         * @name Phaser.Time.TimerEvent#repeatCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCount = 0;
                    /**
         * True if this TimerEvent loops, otherwise false.
         *
         * @name Phaser.Time.TimerEvent#loop
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.loop = false;
                    /**
         * The callback that will be called when the TimerEvent occurs.
         *
         * @name Phaser.Time.TimerEvent#callback
         * @type {function}
         * @since 3.0.0
         */ this.callback;
                    /**
         * The scope in which the callback will be called.
         *
         * @name Phaser.Time.TimerEvent#callbackScope
         * @type {object}
         * @since 3.0.0
         */ this.callbackScope;
                    /**
         * Additional arguments to be passed to the callback.
         *
         * @name Phaser.Time.TimerEvent#args
         * @type {array}
         * @since 3.0.0
         */ this.args;
                    /**
         * Scale the time causing this TimerEvent to update.
         *
         * @name Phaser.Time.TimerEvent#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Start this many MS into the elapsed (useful if you want a long duration with repeat, but for the first loop to fire quickly)
         *
         * @name Phaser.Time.TimerEvent#startAt
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startAt = 0;
                    /**
         * The time in milliseconds which has elapsed since the Timer Event's creation.
         *
         * This value is local for the Timer Event and is relative to its Clock. As such, it's influenced by the Clock's time scale and paused state, the Timer Event's initial {@link #startAt} property, and the Timer Event's {@link #timeScale} and {@link #paused} state.
         *
         * @name Phaser.Time.TimerEvent#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Whether or not this timer is paused.
         *
         * @name Phaser.Time.TimerEvent#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Whether the Timer Event's function has been called.
         *
         * When the Timer Event fires, this property will be set to `true` before the callback function is invoked and will be reset immediately afterward if the Timer Event should repeat. The value of this property does not directly influence whether the Timer Event will be removed from its Clock, but can prevent it from firing.
         *
         * @name Phaser.Time.TimerEvent#hasDispatched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hasDispatched = false;
                    this.reset(config);
                },
                /**
     * Completely reinitializes the Timer Event, regardless of its current state, according to a configuration object.
     *
     * @method Phaser.Time.TimerEvent#reset
     * @since 3.0.0
     *
     * @param {Phaser.Types.Time.TimerEventConfig} config - The new state for the Timer Event.
     *
     * @return {Phaser.Time.TimerEvent} This TimerEvent object.
     */ reset: function(config) {
                    this.delay = GetFastValue(config, "delay", 0);
                    //  Can also be set to -1 for an infinite loop (same as setting loop: true)
                    this.repeat = GetFastValue(config, "repeat", 0);
                    this.loop = GetFastValue(config, "loop", false);
                    this.callback = GetFastValue(config, "callback", undefined);
                    this.callbackScope = GetFastValue(config, "callbackScope", this.callback);
                    this.args = GetFastValue(config, "args", []);
                    this.timeScale = GetFastValue(config, "timeScale", 1);
                    this.startAt = GetFastValue(config, "startAt", 0);
                    this.paused = GetFastValue(config, "paused", false);
                    this.elapsed = this.startAt;
                    this.hasDispatched = false;
                    this.repeatCount = this.repeat === -1 || this.loop ? 999999999999 : this.repeat;
                    return this;
                },
                /**
     * Gets the progress of the current iteration, not factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getProgress
     * @since 3.0.0
     *
     * @return {number} A number between 0 and 1 representing the current progress.
     */ getProgress: function() {
                    return this.elapsed / this.delay;
                },
                /**
     * Gets the progress of the timer overall, factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getOverallProgress
     * @since 3.0.0
     *
     * @return {number} The overall progress of the Timer Event, between 0 and 1.
     */ getOverallProgress: function() {
                    if (this.repeat > 0) {
                        var totalDuration = this.delay + this.delay * this.repeat;
                        var totalElapsed = this.elapsed + this.delay * (this.repeat - this.repeatCount);
                        return totalElapsed / totalDuration;
                    } else return this.getProgress();
                },
                /**
     * Returns the number of times this Timer Event will repeat before finishing.
     *
     * This should not be confused with the number of times the Timer Event will fire before finishing. A return value of 0 doesn't indicate that the Timer Event has finished running - it indicates that it will not repeat after the next time it fires.
     *
     * @method Phaser.Time.TimerEvent#getRepeatCount
     * @since 3.0.0
     *
     * @return {number} How many times the Timer Event will repeat.
     */ getRepeatCount: function() {
                    return this.repeatCount;
                },
                /**
     * Returns the local elapsed time for the current iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getElapsed
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in milliseconds.
     */ getElapsed: function() {
                    return this.elapsed;
                },
                /**
     * Returns the local elapsed time for the current iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getElapsedSeconds
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in seconds.
     */ getElapsedSeconds: function() {
                    return this.elapsed * 0.001;
                },
                /**
     * Returns the time interval until the next iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getRemaining: function() {
                    return this.delay - this.elapsed;
                },
                /**
     * Returns the time interval until the next iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getRemainingSeconds: function() {
                    return this.getRemaining() * 0.001;
                },
                /**
     * Returns the time interval until the last iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getOverallRemaining: function() {
                    return this.delay * (1 + this.repeatCount) - this.elapsed;
                },
                /**
     * Returns the time interval until the last iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getOverallRemainingSeconds: function() {
                    return this.getOverallRemaining() * 0.001;
                },
                /**
     * Forces the Timer Event to immediately expire, thus scheduling its removal in the next frame.
     *
     * @method Phaser.Time.TimerEvent#remove
     * @since 3.0.0
     *
     * @param {boolean} [dispatchCallback=false] - If `true`, the function of the Timer Event will be called before its removal.
     */ remove: function(dispatchCallback) {
                    if (dispatchCallback === undefined) dispatchCallback = false;
                    this.elapsed = this.delay;
                    this.hasDispatched = !dispatchCallback;
                    this.repeatCount = 0;
                },
                /**
     * Destroys all object references in the Timer Event, i.e. its callback, scope, and arguments.
     *
     * Normally, this method is only called by the Clock when it shuts down. As such, it doesn't stop the Timer Event. If called manually, the Timer Event will still be updated by the Clock, but it won't do anything when it fires.
     *
     * @method Phaser.Time.TimerEvent#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.callback = undefined;
                    this.callbackScope = undefined;
                    this.args = [];
                }
            });
            module1.exports = TimerEvent;
        /***/ },
        /* 583 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RESERVED = __webpack_require__(1465);
            /**
 * Internal function used by the Tween Builder to return an array of properties
 * that the Tween will be operating on. It takes a tween configuration object
 * and then checks that none of the `props` entries start with an underscore, or that
 * none of the direct properties are on the Reserved list.
 *
 * @function Phaser.Tweens.Builders.GetProps
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig} config - The configuration object of the Tween to get the properties from.
 *
 * @return {string[]} An array of all the properties the tween will operate on.
 */ var GetProps = function(config) {
                var key;
                var keys = [];
                //  First see if we have a props object
                if (config.hasOwnProperty("props")) {
                    for(key in config.props)//  Skip any property that starts with an underscore
                    if (key.substr(0, 1) !== "_") keys.push({
                        key: key,
                        value: config.props[key]
                    });
                } else {
                    for(key in config)//  Skip any property that is in the ReservedProps list or that starts with an underscore
                    if (RESERVED.indexOf(key) === -1 && key.substr(0, 1) !== "_") keys.push({
                        key: key,
                        value: config[key]
                    });
                }
                return keys;
            };
            module1.exports = GetProps;
        /***/ },
        /* 584 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Internal function used by the Timeline Builder.
 * 
 * It returns an array of all tweens in the given timeline config.
 *
 * @function Phaser.Tweens.Builders.GetTweens
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TimelineBuilderConfig} config - The configuration object for the Timeline.
 *
 * @return {Phaser.Tweens.Tween[]} An array of Tween instances that the Timeline will manage.
 */ var GetTweens = function(config) {
                var tweens = GetValue(config, "tweens", null);
                if (tweens === null) return [];
                else if (typeof tweens === "function") tweens = tweens.call();
                if (!Array.isArray(tweens)) tweens = [
                    tweens
                ];
                return tweens;
            };
            module1.exports = GetTweens;
        /***/ },
        /* 585 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Defaults = __webpack_require__(265);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(99);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(162);
            var GetValue = __webpack_require__(6);
            var GetValueOp = __webpack_require__(264);
            var Tween = __webpack_require__(266);
            var TweenData = __webpack_require__(268);
            /**
 * Creates a new Number Tween.
 *
 * @function Phaser.Tweens.Builders.NumberTweenBuilder
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var NumberTweenBuilder = function(parent, config, defaults) {
                if (defaults === undefined) defaults = Defaults;
                //  var tween = this.tweens.addCounter({
                //      from: 100,
                //      to: 200,
                //      ... (normal tween properties)
                //  })
                //
                //  Then use it in your game via:
                //
                //  tween.getValue()
                var from = GetValue(config, "from", 0);
                var to = GetValue(config, "to", 1);
                var targets = [
                    {
                        value: from
                    }
                ];
                var delay = GetNewValue(config, "delay", defaults.delay);
                var duration = GetNewValue(config, "duration", defaults.duration);
                var easeParams = GetValue(config, "easeParams", defaults.easeParams);
                var ease = GetEaseFunction(GetValue(config, "ease", defaults.ease), easeParams);
                var hold = GetNewValue(config, "hold", defaults.hold);
                var repeat = GetNewValue(config, "repeat", defaults.repeat);
                var repeatDelay = GetNewValue(config, "repeatDelay", defaults.repeatDelay);
                var yoyo = GetBoolean(config, "yoyo", defaults.yoyo);
                var data = [];
                var ops = GetValueOp("value", to);
                var tweenData = TweenData(targets[0], 0, "value", ops.getEnd, ops.getStart, ops.getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, false, false);
                tweenData.start = from;
                tweenData.current = from;
                tweenData.to = to;
                data.push(tweenData);
                var tween = new Tween(parent, data, targets);
                tween.offset = GetAdvancedValue(config, "offset", null);
                tween.completeDelay = GetAdvancedValue(config, "completeDelay", 0);
                tween.loop = Math.round(GetAdvancedValue(config, "loop", 0));
                tween.loopDelay = Math.round(GetAdvancedValue(config, "loopDelay", 0));
                tween.paused = GetBoolean(config, "paused", false);
                tween.useFrames = GetBoolean(config, "useFrames", false);
                //  Set the Callbacks
                var scope = GetValue(config, "callbackScope", tween);
                //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
                var tweenArray = [
                    tween,
                    null
                ];
                var callbacks = Tween.TYPES;
                for(var i = 0; i < callbacks.length; i++){
                    var type = callbacks[i];
                    var callback = GetValue(config, type, false);
                    if (callback) {
                        var callbackScope = GetValue(config, type + "Scope", scope);
                        var callbackParams = GetValue(config, type + "Params", []);
                        //  The null is reset to be the Tween target
                        tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
                    }
                }
                return tween;
            };
            module1.exports = NumberTweenBuilder;
        /***/ },
        /* 586 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetEaseFunction = __webpack_require__(80);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Creates a Stagger function to be used by a Tween property.
 * 
 * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
 * 
 * This is only worth using if the tween has multiple targets.
 * 
 * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
 * over the duration specified:
 * 
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(100)
 * });
 * ```
 * 
 * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
 * from the center out, using a cubic ease.
 * 
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
 * });
 * ```
 *
 * @function Phaser.Tweens.Builders.StaggerBuilder
 * @since 3.19.0
 *
 * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
 * @param {Phaser.Types.Tweens.StaggerConfig} [config] - A Stagger Configuration object.
 *
 * @return {function} The stagger function.
 */ var StaggerBuilder = function(value, options) {
                if (options === undefined) options = {};
                var result;
                var start = GetValue(options, "start", 0);
                var ease = GetValue(options, "ease", null);
                var grid = GetValue(options, "grid", null);
                var from = GetValue(options, "from", 0);
                var fromFirst = from === "first";
                var fromCenter = from === "center";
                var fromLast = from === "last";
                var fromValue = typeof from === "number";
                var isRange = Array.isArray(value);
                var value1 = isRange ? parseFloat(value[0]) : parseFloat(value);
                var value2 = isRange ? parseFloat(value[1]) : 0;
                var maxValue = Math.max(value1, value2);
                if (isRange) start += value1;
                if (grid) {
                    //  Pre-calc the grid to save doing it for ever tweendata update
                    var gridWidth = grid[0];
                    var gridHeight = grid[1];
                    var fromX = 0;
                    var fromY = 0;
                    var distanceX = 0;
                    var distanceY = 0;
                    var gridValues = [];
                    if (fromLast) {
                        fromX = gridWidth - 1;
                        fromY = gridHeight - 1;
                    } else if (fromValue) {
                        fromX = from % gridWidth;
                        fromY = Math.floor(from / gridWidth);
                    } else if (fromCenter) {
                        fromX = (gridWidth - 1) / 2;
                        fromY = (gridHeight - 1) / 2;
                    }
                    var gridMax = MATH_CONST.MIN_SAFE_INTEGER;
                    for(var toY = 0; toY < gridHeight; toY++){
                        gridValues[toY] = [];
                        for(var toX = 0; toX < gridWidth; toX++){
                            distanceX = fromX - toX;
                            distanceY = fromY - toY;
                            var dist = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                            if (dist > gridMax) gridMax = dist;
                            gridValues[toY][toX] = dist;
                        }
                    }
                }
                var easeFunction = ease ? GetEaseFunction(ease) : null;
                if (grid) result = function(target, key, value, index) {
                    var gridSpace = 0;
                    var toX = index % gridWidth;
                    var toY = Math.floor(index / gridWidth);
                    if (toX >= 0 && toX < gridWidth && toY >= 0 && toY < gridHeight) gridSpace = gridValues[toY][toX];
                    var output;
                    if (isRange) {
                        var diff = value2 - value1;
                        if (easeFunction) output = gridSpace / gridMax * diff * easeFunction(gridSpace / gridMax);
                        else output = gridSpace / gridMax * diff;
                    } else if (easeFunction) output = gridSpace * value1 * easeFunction(gridSpace / gridMax);
                    else output = gridSpace * value1;
                    return output + start;
                };
                else result = function(target, key, value, index, total) {
                    //  zero offset
                    total--;
                    var fromIndex;
                    if (fromFirst) fromIndex = index;
                    else if (fromCenter) fromIndex = Math.abs(total / 2 - index);
                    else if (fromLast) fromIndex = total - index;
                    else if (fromValue) fromIndex = Math.abs(from - index);
                    var output;
                    if (isRange) {
                        var spacing;
                        if (fromCenter) spacing = (value2 - value1) / total * (fromIndex * 2);
                        else spacing = (value2 - value1) / total * fromIndex;
                        if (easeFunction) output = spacing * easeFunction(fromIndex / total);
                        else output = spacing;
                    } else if (easeFunction) output = total * maxValue * easeFunction(fromIndex / total);
                    else output = fromIndex * value1;
                    return output + start;
                };
                return result;
            };
            module1.exports = StaggerBuilder;
        /***/ },
        /* 587 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            var Defaults = __webpack_require__(265);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(99);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(162);
            var GetTargets = __webpack_require__(263);
            var GetTweens = __webpack_require__(584);
            var GetValue = __webpack_require__(6);
            var Timeline = __webpack_require__(588);
            var TweenBuilder = __webpack_require__(163);
            /**
 * Builds a Timeline of Tweens based on a configuration object.
 *
 * @function Phaser.Tweens.Builders.TimelineBuilder
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} manager - The Tween Manager to which the Timeline will belong.
 * @param {Phaser.Types.Tweens.TimelineBuilderConfig} config - The configuration object for the Timeline.
 *
 * @return {Phaser.Tweens.Timeline} The created Timeline.
 */ var TimelineBuilder = function(manager, config) {
                var timeline = new Timeline(manager);
                timeline.completeDelay = GetAdvancedValue(config, "completeDelay", 0);
                timeline.loop = Math.round(GetAdvancedValue(config, "loop", 0));
                timeline.loopDelay = Math.round(GetAdvancedValue(config, "loopDelay", 0));
                timeline.paused = GetBoolean(config, "paused", false);
                timeline.useFrames = GetBoolean(config, "useFrames", false);
                //  Callbacks
                var scope = GetValue(config, "callbackScope", timeline);
                var timelineArray = [
                    timeline
                ];
                var onStart = GetValue(config, "onStart", false);
                //  The Start of the Timeline
                if (onStart) {
                    var onStartScope = GetValue(config, "onStartScope", scope);
                    var onStartParams = GetValue(config, "onStartParams", []);
                    timeline.setCallback("onStart", onStart, timelineArray.concat(onStartParams), onStartScope);
                }
                var onUpdate = GetValue(config, "onUpdate", false);
                //  Every time the Timeline updates (regardless which Tweens are running)
                if (onUpdate) {
                    var onUpdateScope = GetValue(config, "onUpdateScope", scope);
                    var onUpdateParams = GetValue(config, "onUpdateParams", []);
                    timeline.setCallback("onUpdate", onUpdate, timelineArray.concat(onUpdateParams), onUpdateScope);
                }
                var onLoop = GetValue(config, "onLoop", false);
                //  Called when the whole Timeline loops
                if (onLoop) {
                    var onLoopScope = GetValue(config, "onLoopScope", scope);
                    var onLoopParams = GetValue(config, "onLoopParams", []);
                    timeline.setCallback("onLoop", onLoop, timelineArray.concat(onLoopParams), onLoopScope);
                }
                var onYoyo = GetValue(config, "onYoyo", false);
                //  Called when a Timeline yoyos
                if (onYoyo) {
                    var onYoyoScope = GetValue(config, "onYoyoScope", scope);
                    var onYoyoParams = GetValue(config, "onYoyoParams", []);
                    timeline.setCallback("onYoyo", onYoyo, timelineArray.concat(null, onYoyoParams), onYoyoScope);
                }
                var onComplete = GetValue(config, "onComplete", false);
                //  Called when the Timeline completes, after the completeDelay, etc.
                if (onComplete) {
                    var onCompleteScope = GetValue(config, "onCompleteScope", scope);
                    var onCompleteParams = GetValue(config, "onCompleteParams", []);
                    timeline.setCallback("onComplete", onComplete, timelineArray.concat(onCompleteParams), onCompleteScope);
                }
                // Tweens
                var tweens = GetTweens(config);
                if (tweens.length === 0) {
                    timeline.paused = true;
                    return timeline;
                }
                var defaults = Clone(Defaults);
                defaults.targets = GetTargets(config);
                //  totalDuration: If specified each tween in the Timeline is given an equal portion of the totalDuration
                var totalDuration = GetAdvancedValue(config, "totalDuration", 0);
                if (totalDuration > 0) defaults.duration = Math.floor(totalDuration / tweens.length);
                else defaults.duration = GetNewValue(config, "duration", defaults.duration);
                defaults.delay = GetNewValue(config, "delay", defaults.delay);
                defaults.easeParams = GetValue(config, "easeParams", defaults.easeParams);
                defaults.ease = GetEaseFunction(GetValue(config, "ease", defaults.ease), defaults.easeParams);
                defaults.hold = GetNewValue(config, "hold", defaults.hold);
                defaults.repeat = GetNewValue(config, "repeat", defaults.repeat);
                defaults.repeatDelay = GetNewValue(config, "repeatDelay", defaults.repeatDelay);
                defaults.yoyo = GetBoolean(config, "yoyo", defaults.yoyo);
                defaults.flipX = GetBoolean(config, "flipX", defaults.flipX);
                defaults.flipY = GetBoolean(config, "flipY", defaults.flipY);
                //  Create the Tweens
                for(var i = 0; i < tweens.length; i++)timeline.queue(TweenBuilder(timeline, tweens[i], defaults));
                return timeline;
            };
            module1.exports = TimelineBuilder;
        /***/ },
        /* 588 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(267);
            var TweenBuilder = __webpack_require__(163);
            var TWEEN_CONST = __webpack_require__(100);
            /**
 * @classdesc
 * A Timeline combines multiple Tweens into one. Its overall behavior is otherwise similar to a single Tween.
 *
 * The Timeline updates all of its Tweens simultaneously. Its methods allow you to easily build a sequence
 * of Tweens (each one starting after the previous one) or run multiple Tweens at once during given parts of the Timeline.
 *
 * @class Timeline
 * @memberof Phaser.Tweens
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} manager - The Tween Manager which owns this Timeline.
 */ var Timeline = new Class({
                Extends: EventEmitter,
                initialize: function Timeline(manager) {
                    EventEmitter.call(this);
                    /**
         * The Tween Manager which owns this Timeline.
         *
         * @name Phaser.Tweens.Timeline#manager
         * @type {Phaser.Tweens.TweenManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * A constant value which allows this Timeline to be easily identified as one.
         *
         * @name Phaser.Tweens.Timeline#isTimeline
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isTimeline = true;
                    /**
         * An array of Tween objects, each containing a unique property and target being tweened.
         *
         * @name Phaser.Tweens.Timeline#data
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.data = [];
                    /**
         * The cached size of the data array.
         *
         * @name Phaser.Tweens.Timeline#totalData
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalData = 0;
                    /**
         * If true then duration, delay, etc values are all frame totals, rather than ms.
         *
         * @name Phaser.Tweens.Timeline#useFrames
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useFrames = false;
                    /**
         * Scales the time applied to this Timeline. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
         * Value isn't used when calculating total duration of the Timeline, it's a run-time delta adjustment only.
         *
         * @name Phaser.Tweens.Timeline#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Loop this Timeline? Can be -1 for an infinite loop, or an integer.
         * When enabled it will play through ALL Tweens again (use Tween.repeat to loop a single tween)
         *
         * @name Phaser.Tweens.Timeline#loop
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loop = 0;
                    /**
         * Time in ms/frames before this Timeline loops.
         *
         * @name Phaser.Tweens.Timeline#loopDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopDelay = 0;
                    /**
         * How many loops are left to run?
         *
         * @name Phaser.Tweens.Timeline#loopCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopCounter = 0;
                    /**
         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = true (as it never completes)
         *
         * @name Phaser.Tweens.Timeline#completeDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.completeDelay = 0;
                    /**
         * Countdown timer value, as used by `loopDelay` and `completeDelay`.
         *
         * @name Phaser.Tweens.Timeline#countdown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.countdown = 0;
                    /**
         * The current state of the Timeline.
         *
         * @name Phaser.Tweens.Timeline#state
         * @type {number}
         * @since 3.0.0
         */ this.state = TWEEN_CONST.PENDING_ADD;
                    /**
         * The state of the Timeline when it was paused (used by Resume)
         *
         * @name Phaser.Tweens.Timeline#_pausedState
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._pausedState = TWEEN_CONST.PENDING_ADD;
                    /**
         * Does the Timeline start off paused? (if so it needs to be started with Timeline.play)
         *
         * @name Phaser.Tweens.Timeline#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Elapsed time in ms/frames of this run through of the Timeline.
         *
         * @name Phaser.Tweens.Timeline#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Total elapsed time in ms/frames of the entire Timeline, including looping.
         *
         * @name Phaser.Tweens.Timeline#totalElapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalElapsed = 0;
                    /**
         * Time in ms/frames for the whole Timeline to play through once, excluding loop amounts and loop delays.
         *
         * @name Phaser.Tweens.Timeline#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * Value between 0 and 1. The amount of progress through the Timeline, _excluding loops_.
         *
         * @name Phaser.Tweens.Timeline#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Time in ms/frames for all Tweens in this Timeline to complete (including looping)
         *
         * @name Phaser.Tweens.Timeline#totalDuration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalDuration = 0;
                    /**
         * Value between 0 and 1. The amount through the entire Timeline, including looping.
         *
         * @name Phaser.Tweens.Timeline#totalProgress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalProgress = 0;
                    /**
         * An object containing the different Tween callback functions.
         * 
         * You can either set these in the Tween config, or by calling the `Tween.setCallback` method.
         * 
         * `onComplete` When the Timeline finishes playback fully or `Timeline.stop` is called. Never invoked if timeline is set to repeat infinitely.
         * `onLoop` When a Timeline loops.
         * `onStart` When the Timeline starts playing.
         * `onUpdate` When a Timeline updates a child Tween.
         * `onYoyo` When a Timeline starts a yoyo.
         *
         * @name Phaser.Tweens.Timeline#callbacks
         * @type {object}
         * @since 3.0.0
         */ this.callbacks = {
                        onComplete: null,
                        onLoop: null,
                        onStart: null,
                        onUpdate: null,
                        onYoyo: null
                    };
                    /**
         * The context in which all callbacks are invoked.
         *
         * @name Phaser.Tweens.Timeline#callbackScope
         * @type {any}
         * @since 3.0.0
         */ this.callbackScope;
                },
                /**
     * Internal method that will emit a Timeline based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Timeline#dispatchTimelineEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchTimelineEvent: function(event, callback) {
                    this.emit(event, this);
                    if (callback) callback.func.apply(callback.scope, callback.params);
                },
                /**
     * Sets the value of the time scale applied to this Timeline. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     * 
     * The value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
     *
     * @method Phaser.Tweens.Timeline#setTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The time scale value to set.
     *
     * @return {this} This Timeline object.
     */ setTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * Gets the value of the time scale applied to this Timeline. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     *
     * @method Phaser.Tweens.Timeline#getTimeScale
     * @since 3.0.0
     *
     * @return {number} The value of the time scale applied to this Timeline.
     */ getTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Check whether or not the Timeline is playing.
     *
     * @method Phaser.Tweens.Timeline#isPlaying
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Timeline is active, otherwise `false`.
     */ isPlaying: function() {
                    return this.state === TWEEN_CONST.ACTIVE;
                },
                /**
     * Creates a new Tween, based on the given Tween Config, and adds it to this Timeline.
     *
     * @method Phaser.Tweens.Timeline#add
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Tweens.TweenBuilderConfig|object)} config - The configuration object for the Tween.
     *
     * @return {this} This Timeline object.
     */ add: function(config) {
                    return this.queue(TweenBuilder(this, config));
                },
                /**
     * Adds an existing Tween to this Timeline.
     *
     * @method Phaser.Tweens.Timeline#queue
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be added to this Timeline.
     *
     * @return {this} This Timeline object.
     */ queue: function(tween) {
                    if (!this.isPlaying()) {
                        tween.parent = this;
                        tween.parentIsTimeline = true;
                        this.data.push(tween);
                        this.totalData = this.data.length;
                    }
                    return this;
                },
                /**
     * Checks whether a Tween has an offset value.
     *
     * @method Phaser.Tweens.Timeline#hasOffset
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {boolean} `true` if the tween has a non-null offset.
     */ hasOffset: function(tween) {
                    return tween.offset !== null;
                },
                /**
     * Checks whether the offset value is a number or a directive that is relative to previous tweens.
     *
     * @method Phaser.Tweens.Timeline#isOffsetAbsolute
     * @since 3.0.0
     *
     * @param {number} value - The offset value to be evaluated.
     *
     * @return {boolean} `true` if the result is a number, `false` if it is a directive like " -= 1000".
     */ isOffsetAbsolute: function(value) {
                    return typeof value === "number";
                },
                /**
     * Checks if the offset is a relative value rather than an absolute one.
     * If the value is just a number, this returns false.
     *
     * @method Phaser.Tweens.Timeline#isOffsetRelative
     * @since 3.0.0
     *
     * @param {string} value - The offset value to be evaluated.
     *
     * @return {boolean} `true` if the value is relative, i.e " -= 1000". If `false`, the offset is absolute.
     */ isOffsetRelative: function(value) {
                    var t = typeof value;
                    if (t === "string") {
                        var op = value[0];
                        if (op === "-" || op === "+") return true;
                    }
                    return false;
                },
                /**
     * Parses the relative offset value, returning a positive or negative number.
     *
     * @method Phaser.Tweens.Timeline#getRelativeOffset
     * @since 3.0.0
     *
     * @param {string} value - The relative offset, in the format of '-=500', for example. The first character determines whether it will be a positive or negative number. Spacing matters here.
     * @param {number} base - The value to use as the offset.
     *
     * @return {number} The parsed offset value.
     */ getRelativeOffset: function(value, base) {
                    var op = value[0];
                    var num = parseFloat(value.substr(2));
                    var result = base;
                    switch(op){
                        case "+":
                            result += num;
                            break;
                        case "-":
                            result -= num;
                            break;
                    }
                    //  Cannot ever be < 0
                    return Math.max(0, result);
                },
                /**
     * Calculates the total duration of the timeline.
     * 
     * Computes all tween durations and returns the full duration of the timeline.
     * 
     * The resulting number is stored in the timeline, not as a return value.
     *
     * @method Phaser.Tweens.Timeline#calcDuration
     * @since 3.0.0
     */ calcDuration: function() {
                    var prevEnd = 0;
                    var totalDuration = 0;
                    var offsetDuration = 0;
                    for(var i = 0; i < this.totalData; i++){
                        var tween = this.data[i];
                        tween.init();
                        if (this.hasOffset(tween)) {
                            if (this.isOffsetAbsolute(tween.offset)) {
                                //  An actual number, so it defines the start point from the beginning of the timeline
                                tween.calculatedOffset = tween.offset;
                                if (tween.offset === 0) offsetDuration = 0;
                            } else if (this.isOffsetRelative(tween.offset)) //  A relative offset (i.e. '-=1000', so starts at 'offset' ms relative to the PREVIOUS Tweens ending time)
                            tween.calculatedOffset = this.getRelativeOffset(tween.offset, prevEnd);
                        } else //  Sequential
                        tween.calculatedOffset = offsetDuration;
                        prevEnd = tween.totalDuration + tween.calculatedOffset;
                        totalDuration += tween.totalDuration;
                        offsetDuration += tween.totalDuration;
                    }
                    //  Excludes loop values
                    this.duration = totalDuration;
                    this.loopCounter = this.loop === -1 ? 999999999999 : this.loop;
                    if (this.loopCounter > 0) this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter;
                    else this.totalDuration = this.duration + this.completeDelay;
                },
                /**
     * Initializes the timeline, which means all Tweens get their init() called, and the total duration will be computed.
     * Returns a boolean indicating whether the timeline is auto-started or not.
     *
     * @method Phaser.Tweens.Timeline#init
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Timeline is started. `false` if it is paused.
     */ init: function() {
                    this.calcDuration();
                    this.progress = 0;
                    this.totalProgress = 0;
                    if (this.paused) {
                        this.state = TWEEN_CONST.PAUSED;
                        return false;
                    } else return true;
                },
                /**
     * Resets all of the timeline's tweens back to their initial states.
     * The boolean parameter indicates whether tweens that are looping should reset as well, or not.
     *
     * @method Phaser.Tweens.Timeline#resetTweens
     * @since 3.0.0
     *
     * @param {boolean} resetFromLoop - If `true`, resets all looping tweens to their initial values.
     */ resetTweens: function(resetFromLoop) {
                    for(var i = 0; i < this.totalData; i++){
                        var tween = this.data[i];
                        tween.play(resetFromLoop);
                    }
                },
                /**
     * Sets a callback for the Timeline.
     *
     * @method Phaser.Tweens.Timeline#setCallback
     * @since 3.0.0
     *
     * @param {string} type - The internal type of callback to set.
     * @param {function} callback - Timeline allows multiple tweens to be linked together to create a streaming sequence.
     * @param {array} [params] - The parameters to pass to the callback.
     * @param {object} [scope] - The context scope of the callback.
     *
     * @return {this} This Timeline object.
     */ setCallback: function(type, callback, params, scope) {
                    if (Timeline.TYPES.indexOf(type) !== -1) this.callbacks[type] = {
                        func: callback,
                        scope: scope,
                        params: params
                    };
                    return this;
                },
                /**
     * Passed a Tween to the Tween Manager and requests it be made active.
     *
     * @method Phaser.Tweens.Timeline#makeActive
     * @since 3.3.0
     *
     * @param {Phaser.Tweens.Tween} tween - The tween object to make active.
     *
     * @return {Phaser.Tweens.TweenManager} The Timeline's Tween Manager reference.
     */ makeActive: function(tween) {
                    return this.manager.makeActive(tween);
                },
                /**
     * Starts playing the Timeline.
     *
     * @method Phaser.Tweens.Timeline#play
     * @fires Phaser.Tweens.Events#TIMELINE_START
     * @since 3.0.0
     */ play: function() {
                    if (this.state === TWEEN_CONST.ACTIVE) return;
                    if (this.paused) {
                        this.paused = false;
                        this.manager.makeActive(this);
                        return;
                    } else {
                        this.resetTweens(false);
                        this.state = TWEEN_CONST.ACTIVE;
                    }
                    this.dispatchTimelineEvent(Events.TIMELINE_START, this.callbacks.onStart);
                },
                /**
     * Updates the Timeline's `state` and fires callbacks and events.
     *
     * @method Phaser.Tweens.Timeline#nextState
     * @fires Phaser.Tweens.Events#TIMELINE_COMPLETE
     * @fires Phaser.Tweens.Events#TIMELINE_LOOP
     * @since 3.0.0
     *
     * @see Phaser.Tweens.Timeline#update
     */ nextState: function() {
                    if (this.loopCounter > 0) {
                        //  Reset the elapsed time
                        this.elapsed = 0;
                        this.progress = 0;
                        this.loopCounter--;
                        this.resetTweens(true);
                        if (this.loopDelay > 0) {
                            this.countdown = this.loopDelay;
                            this.state = TWEEN_CONST.LOOP_DELAY;
                        } else {
                            this.state = TWEEN_CONST.ACTIVE;
                            this.dispatchTimelineEvent(Events.TIMELINE_LOOP, this.callbacks.onLoop);
                        }
                    } else if (this.completeDelay > 0) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = this.completeDelay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTimelineEvent(Events.TIMELINE_COMPLETE, this.callbacks.onComplete);
                    }
                },
                /**
     * Returns 'true' if this Timeline has finished and should be removed from the Tween Manager.
     * Otherwise, returns false.
     *
     * @method Phaser.Tweens.Timeline#update
     * @fires Phaser.Tweens.Events#TIMELINE_COMPLETE
     * @fires Phaser.Tweens.Events#TIMELINE_UPDATE
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this Timeline has finished and should be removed from the Tween Manager.
     */ update: function(timestamp, delta) {
                    if (this.state === TWEEN_CONST.PAUSED) return;
                    if (this.useFrames) delta = 1 * this.manager.timeScale;
                    delta *= this.timeScale;
                    this.elapsed += delta;
                    this.progress = Math.min(this.elapsed / this.duration, 1);
                    this.totalElapsed += delta;
                    this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
                    switch(this.state){
                        case TWEEN_CONST.ACTIVE:
                            var stillRunning = this.totalData;
                            for(var i = 0; i < this.totalData; i++){
                                var tween = this.data[i];
                                if (tween.update(timestamp, delta)) stillRunning--;
                            }
                            this.dispatchTimelineEvent(Events.TIMELINE_UPDATE, this.callbacks.onUpdate);
                            //  Anything still running? If not, we're done
                            if (stillRunning === 0) this.nextState();
                            break;
                        case TWEEN_CONST.LOOP_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.ACTIVE;
                                this.dispatchTimelineEvent(Events.TIMELINE_LOOP, this.callbacks.onLoop);
                            }
                            break;
                        case TWEEN_CONST.COMPLETE_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.PENDING_REMOVE;
                                this.dispatchTimelineEvent(Events.TIMELINE_COMPLETE, this.callbacks.onComplete);
                            }
                            break;
                    }
                    return this.state === TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Stops the Timeline immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Timeline#stop
     * @since 3.0.0
     */ stop: function() {
                    this.state = TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Pauses the Timeline, retaining its internal state.
     * 
     * Calling this on a Timeline that is already paused has no effect and fires no event.
     *
     * @method Phaser.Tweens.Timeline#pause
     * @fires Phaser.Tweens.Events#TIMELINE_PAUSE
     * @since 3.0.0
     *
     * @return {this} This Timeline object.
     */ pause: function() {
                    if (this.state === TWEEN_CONST.PAUSED) return;
                    this.paused = true;
                    this._pausedState = this.state;
                    this.state = TWEEN_CONST.PAUSED;
                    this.emit(Events.TIMELINE_PAUSE, this);
                    return this;
                },
                /**
     * Resumes a paused Timeline from where it was when it was paused.
     * 
     * Calling this on a Timeline that isn't paused has no effect and fires no event.
     *
     * @method Phaser.Tweens.Timeline#resume
     * @fires Phaser.Tweens.Events#TIMELINE_RESUME
     * @since 3.0.0
     *
     * @return {this} This Timeline object.
     */ resume: function() {
                    if (this.state === TWEEN_CONST.PAUSED) {
                        this.paused = false;
                        this.state = this._pausedState;
                        this.emit(Events.TIMELINE_RESUME, this);
                    }
                    return this;
                },
                /**
     * Checks if any of the Tweens in this Timeline as operating on the target object.
     * 
     * Returns `false` if no Tweens operate on the target object.
     *
     * @method Phaser.Tweens.Timeline#hasTarget
     * @since 3.0.0
     *
     * @param {object} target - The target to check all Tweens against.
     *
     * @return {boolean} `true` if there is at least a single Tween that operates on the target object, otherwise `false`.
     */ hasTarget: function(target) {
                    for(var i = 0; i < this.data.length; i++){
                        if (this.data[i].hasTarget(target)) return true;
                    }
                    return false;
                },
                /**
     * Stops all the Tweens in the Timeline immediately, whatever stage of progress they are at and flags
     * them for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Timeline#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var i = 0; i < this.data.length; i++)this.data[i].stop();
                }
            });
            Timeline.TYPES = [
                "onStart",
                "onUpdate",
                "onLoop",
                "onComplete",
                "onYoyo"
            ];
            module1.exports = Timeline;
        /***/ },
        /* 589 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Joachim Grill <joachim@codeandweb.com>
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 CodeAndWeb GmbH
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            var Common = __webpack_require__(32);
            var GetFastValue = __webpack_require__(2);
            var Vertices = __webpack_require__(64);
            /**
 * Use PhysicsEditorParser.parseBody() to build a Matter body object, based on a physics data file
 * created and exported with PhysicsEditor (https://www.codeandweb.com/physicseditor).
 *
 * @namespace Phaser.Physics.Matter.PhysicsEditorParser
 * @since 3.10.0
 */ var PhysicsEditorParser = {
                /**
     * Parses a body element exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseBody
     * @since 3.10.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration and fixture (child body) definitions, as exported by PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType} A compound Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                    if (options === undefined) options = {};
                    var fixtureConfigs = GetFastValue(config, "fixtures", []);
                    var fixtures = [];
                    for(var fc = 0; fc < fixtureConfigs.length; fc++){
                        var fixtureParts = this.parseFixture(fixtureConfigs[fc]);
                        for(var i = 0; i < fixtureParts.length; i++)fixtures.push(fixtureParts[i]);
                    }
                    var matterConfig = Common.clone(config, true);
                    Common.extend(matterConfig, options, true);
                    delete matterConfig.fixtures;
                    delete matterConfig.type;
                    var body = Body.create(matterConfig);
                    Body.setParts(body, fixtures);
                    Body.setPosition(body, {
                        x: x,
                        y: y
                    });
                    return body;
                },
                /**
     * Parses an element of the "fixtures" list exported by PhysicsEditor
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseFixture
     * @since 3.10.0
     *
     * @param {object} fixtureConfig - The fixture object to parse.
     * 
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseFixture: function(fixtureConfig) {
                    var matterConfig = Common.extend({}, false, fixtureConfig);
                    delete matterConfig.circle;
                    delete matterConfig.vertices;
                    var fixtures;
                    if (fixtureConfig.circle) {
                        var x = GetFastValue(fixtureConfig.circle, "x");
                        var y = GetFastValue(fixtureConfig.circle, "y");
                        var r = GetFastValue(fixtureConfig.circle, "radius");
                        fixtures = [
                            Bodies.circle(x, y, r, matterConfig)
                        ];
                    } else if (fixtureConfig.vertices) fixtures = this.parseVertices(fixtureConfig.vertices, matterConfig);
                    return fixtures;
                },
                /**
     * Parses the "vertices" lists exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseVertices
     * @since 3.10.0
     *
     * @param {array} vertexSets - The vertex lists to parse.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseVertices: function(vertexSets, options) {
                    if (options === undefined) options = {};
                    var parts = [];
                    for(var v = 0; v < vertexSets.length; v++){
                        Vertices.clockwiseSort(vertexSets[v]);
                        parts.push(Body.create(Common.extend({
                            position: Vertices.centre(vertexSets[v]),
                            vertices: vertexSets[v]
                        }, options)));
                    }
                    // flag coincident part edges
                    return Bodies.flagCoincidentParts(parts);
                }
            };
            module1.exports = PhysicsEditorParser;
        /***/ },
        /* 590 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            /**
 * Creates a body using the supplied physics data, as provided by a JSON file.
 * 
 * The data file should be loaded as JSON:
 * 
 * ```javascript
 * preload ()
 * {
 *   this.load.json('ninjas', 'assets/ninjas.json);
 * }
 * 
 * create ()
 * {
 *   const ninjaShapes = this.cache.json.get('ninjas');
 * 
 *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
 * }
 * ```
 * 
 * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
 * 
 * If you pas in an `options` object, any settings in there will override those in the config object.
 * 
 * The structure of the JSON file is as follows:
 * 
 * ```text
 * {
 *   'generator_info': // The name of the application that created the JSON data
 *   'shapeName': {
 *     'type': // The type of body
 *     'label': // Optional body label
 *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
 *   }
 * }
 * ```
 * 
 * At the time of writing, only the Phaser Physics Tracer App exports in this format.
 *
 * @namespace Phaser.Physics.Matter.PhysicsJSONParser
 * @since 3.22.0
 */ var PhysicsJSONParser = {
                /**
     * Parses a body element from the given JSON data.
     *
     * @function Phaser.Physics.Matter.PhysicsJSONParser.parseBody
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                    if (options === undefined) options = {};
                    var body;
                    var vertexSets = config.vertices;
                    if (vertexSets.length === 1) {
                        //  Just a single Body
                        options.vertices = vertexSets[0];
                        body = Body.create(options);
                        Bodies.flagCoincidentParts(body.parts);
                    } else {
                        var parts = [];
                        for(var i = 0; i < vertexSets.length; i++){
                            var part = Body.create({
                                vertices: vertexSets[i]
                            });
                            parts.push(part);
                        }
                        Bodies.flagCoincidentParts(parts);
                        options.parts = parts;
                        body = Body.create(options);
                    }
                    body.label = config.label;
                    Body.setPosition(body, {
                        x: x,
                        y: y
                    });
                    return body;
                }
            };
            module1.exports = PhysicsJSONParser;
        /***/ },
        /* 591 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composites` module contains factory methods for creating composite bodies
* with commonly used configurations (such as stacks and chains).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composites
*/ var Composites = {};
            module1.exports = Composites;
            var Composite = __webpack_require__(118);
            var Constraint = __webpack_require__(128);
            var Common = __webpack_require__(32);
            var Body = __webpack_require__(41);
            var Bodies = __webpack_require__(86);
            (function() {
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method stack
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.stack = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composite.create({
                        label: "Stack"
                    }), x = xx, y = yy, lastBody, i = 0;
                    for(var row = 0; row < rows; row++){
                        var maxHeight = 0;
                        for(var column = 0; column < columns; column++){
                            var body = callback(x, y, column, row, lastBody, i);
                            if (body) {
                                var bodyHeight = body.bounds.max.y - body.bounds.min.y, bodyWidth = body.bounds.max.x - body.bounds.min.x;
                                if (bodyHeight > maxHeight) maxHeight = bodyHeight;
                                Body.translate(body, {
                                    x: bodyWidth * 0.5,
                                    y: bodyHeight * 0.5
                                });
                                x = body.bounds.max.x + columnGap;
                                Composite.addBody(stack, body);
                                lastBody = body;
                                i += 1;
                            } else x += columnGap;
                        }
                        y += maxHeight + rowGap;
                        x = xx;
                    }
                    return stack;
                };
                /**
     * Chains all bodies in the given composite together using constraints.
     * @method chain
     * @param {composite} composite
     * @param {number} xOffsetA
     * @param {number} yOffsetA
     * @param {number} xOffsetB
     * @param {number} yOffsetB
     * @param {object} options
     * @return {composite} A new composite containing objects chained together with constraints
     */ Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    var bodies = composite.bodies;
                    for(var i = 1; i < bodies.length; i++){
                        var bodyA = bodies[i - 1], bodyB = bodies[i], bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y, bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y, bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
                        var defaults = {
                            bodyA: bodyA,
                            pointA: {
                                x: bodyAWidth * xOffsetA,
                                y: bodyAHeight * yOffsetA
                            },
                            bodyB: bodyB,
                            pointB: {
                                x: bodyBWidth * xOffsetB,
                                y: bodyBHeight * yOffsetB
                            }
                        };
                        var constraint = Common.extend(defaults, options);
                        Composite.addConstraint(composite, Constraint.create(constraint));
                    }
                    composite.label += " Chain";
                    return composite;
                };
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     * @method mesh
     * @param {composite} composite
     * @param {number} columns
     * @param {number} rows
     * @param {boolean} crossBrace
     * @param {object} options
     * @return {composite} The composite containing objects meshed together with constraints
     */ Composites.mesh = function(composite, columns, rows, crossBrace, options) {
                    var bodies = composite.bodies, row, col, bodyA, bodyB, bodyC;
                    for(row = 0; row < rows; row++){
                        for(col = 1; col < columns; col++){
                            bodyA = bodies[col - 1 + row * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                        }
                        if (row > 0) for(col = 0; col < columns; col++){
                            bodyA = bodies[col + (row - 1) * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                            if (crossBrace && col > 0) {
                                bodyC = bodies[col - 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                            if (crossBrace && col < columns - 1) {
                                bodyC = bodies[col + 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                        }
                    }
                    composite.label += " Mesh";
                    return composite;
                };
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method pyramid
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.pyramid = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    return Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y, column, row, lastBody, i) {
                        var actualRows = Math.min(rows, Math.ceil(columns / 2)), lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
                        if (row > actualRows) return;
                        // reverse row order
                        row = actualRows - row;
                        var start = row, end = columns - 1 - row;
                        if (column < start || column > end) return;
                        // retroactively fix the first body's position, since width was unknown
                        if (i === 1) Body.translate(lastBody, {
                            x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth,
                            y: 0
                        });
                        var xOffset = lastBody ? column * lastBodyWidth : 0;
                        return callback(xx + xOffset + column * columnGap, y, column, row, lastBody, i);
                    });
                };
                /**
     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
     * @method newtonsCradle
     * @param {number} xx
     * @param {number} yy
     * @param {number} number
     * @param {number} size
     * @param {number} length
     * @return {composite} A new composite newtonsCradle body
     */ Composites.newtonsCradle = function(xx, yy, number, size, length) {
                    var newtonsCradle = Composite.create({
                        label: "Newtons Cradle"
                    });
                    for(var i = 0; i < number; i++){
                        var separation = 1.9, circle = Bodies.circle(xx + i * (size * separation), yy + length, size, {
                            inertia: Infinity,
                            restitution: 1,
                            friction: 0,
                            frictionAir: 0.0001,
                            slop: 1
                        }), constraint = Constraint.create({
                            pointA: {
                                x: xx + i * (size * separation),
                                y: yy
                            },
                            bodyB: circle
                        });
                        Composite.addBody(newtonsCradle, circle);
                        Composite.addConstraint(newtonsCradle, constraint);
                    }
                    return newtonsCradle;
                };
                /**
     * Creates a composite with simple car setup of bodies and constraints.
     * @method car
     * @param {number} xx
     * @param {number} yy
     * @param {number} width
     * @param {number} height
     * @param {number} wheelSize
     * @return {composite} A new composite car body
     */ Composites.car = function(xx, yy, width, height, wheelSize) {
                    var group = Body.nextGroup(true), wheelBase = 20, wheelAOffset = -width * 0.5 + wheelBase, wheelBOffset = width * 0.5 - wheelBase, wheelYOffset = 0;
                    var car = Composite.create({
                        label: "Car"
                    }), body = Bodies.rectangle(xx, yy, width, height, {
                        collisionFilter: {
                            group: group
                        },
                        chamfer: {
                            radius: height * 0.5
                        },
                        density: 0.0002
                    });
                    var wheelA = Bodies.circle(xx + wheelAOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var wheelB = Bodies.circle(xx + wheelBOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var axelA = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelAOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelA,
                        stiffness: 1,
                        length: 0
                    });
                    var axelB = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelBOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelB,
                        stiffness: 1,
                        length: 0
                    });
                    Composite.addBody(car, body);
                    Composite.addBody(car, wheelA);
                    Composite.addBody(car, wheelB);
                    Composite.addConstraint(car, axelA);
                    Composite.addConstraint(car, axelB);
                    return car;
                };
                /**
     * Creates a simple soft body like object.
     * @method softBody
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {boolean} crossBrace
     * @param {number} particleRadius
     * @param {} particleOptions
     * @param {} constraintOptions
     * @return {composite} A new composite softBody
     */ Composites.softBody = function(xx, yy, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    particleOptions = Common.extend({
                        inertia: Infinity
                    }, particleOptions);
                    constraintOptions = Common.extend({
                        stiffness: 0.2,
                        render: {
                            type: "line",
                            anchors: false
                        }
                    }, constraintOptions);
                    var softBody = Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y) {
                        return Bodies.circle(x, y, particleRadius, particleOptions);
                    });
                    Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
                    softBody.label = "Soft Body";
                    return softBody;
                };
            })();
        /***/ },
        /* 592 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
*
* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Svg
*/ var Svg = {};
            module1.exports = Svg;
            var Bounds = __webpack_require__(84);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Converts an SVG path into an array of vector points.
     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
     * See `Bodies.fromVertices` which provides support for this.
     * Note that this function is not guaranteed to support complex paths (such as those with holes).
     * You must load the `pathseg.js` polyfill on newer browsers.
     * @method pathToVertices
     * @param {SVGPathElement} path
     * @param {Number} [sampleLength=15]
     * @return {Vector[]} points
     */ Svg.pathToVertices = function(path, sampleLength) {
                    if (typeof window !== "undefined" && !("SVGPathSeg" in window)) Common.warn("Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.");
                    // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
                    var i, il, total, point, segment, segments, segmentsQueue, lastSegment, lastPoint, segmentIndex, points = [], lx, ly, length = 0, x = 0, y = 0;
                    sampleLength = sampleLength || 15;
                    var addPoint = function(px, py, pathSegType) {
                        // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
                        var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
                        // when the last point doesn't equal the current point add the current point
                        if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
                            if (lastPoint && isRelative) {
                                lx = lastPoint.x;
                                ly = lastPoint.y;
                            } else {
                                lx = 0;
                                ly = 0;
                            }
                            var point = {
                                x: lx + px,
                                y: ly + py
                            };
                            // set last point
                            if (isRelative || !lastPoint) lastPoint = point;
                            points.push(point);
                            x = lx + px;
                            y = ly + py;
                        }
                    };
                    var addSegmentPoint = function(segment) {
                        var segType = segment.pathSegTypeAsLetter.toUpperCase();
                        // skip path ends
                        if (segType === "Z") return;
                        // map segment to x and y
                        switch(segType){
                            case "M":
                            case "L":
                            case "T":
                            case "C":
                            case "S":
                            case "Q":
                                x = segment.x;
                                y = segment.y;
                                break;
                            case "H":
                                x = segment.x;
                                break;
                            case "V":
                                y = segment.y;
                                break;
                        }
                        addPoint(x, y, segment.pathSegType);
                    };
                    // ensure path is absolute
                    Svg._svgPathToAbsolute(path);
                    // get total length
                    total = path.getTotalLength();
                    // queue segments
                    segments = [];
                    for(i = 0; i < path.pathSegList.numberOfItems; i += 1)segments.push(path.pathSegList.getItem(i));
                    segmentsQueue = segments.concat();
                    // sample through path
                    while(length < total){
                        // get segment at position
                        segmentIndex = path.getPathSegAtLength(length);
                        segment = segments[segmentIndex];
                        // new segment
                        if (segment != lastSegment) {
                            while(segmentsQueue.length && segmentsQueue[0] != segment)addSegmentPoint(segmentsQueue.shift());
                            lastSegment = segment;
                        }
                        // add points in between when curving
                        // TODO: adaptive sampling
                        switch(segment.pathSegTypeAsLetter.toUpperCase()){
                            case "C":
                            case "T":
                            case "S":
                            case "Q":
                            case "A":
                                point = path.getPointAtLength(length);
                                addPoint(point.x, point.y, 0);
                                break;
                        }
                        // increment by sample value
                        length += sampleLength;
                    }
                    // add remaining segments not passed by sampling
                    for(i = 0, il = segmentsQueue.length; i < il; ++i)addSegmentPoint(segmentsQueue[i]);
                    return points;
                };
                Svg._svgPathToAbsolute = function(path) {
                    // http://phrogz.net/convert-svg-path-to-all-absolute-commands
                    // Copyright (c) Gavin Kistner
                    // http://phrogz.net/js/_ReuseLicense.txt
                    // Modifications: tidy formatting and naming
                    var x0, y0, x1, y1, x2, y2, segs = path.pathSegList, x = 0, y = 0, len = segs.numberOfItems;
                    for(var i = 0; i < len; ++i){
                        var seg = segs.getItem(i), segType = seg.pathSegTypeAsLetter;
                        if (/[MLHVCSQTA]/.test(segType)) {
                            if ("x" in seg) x = seg.x;
                            if ("y" in seg) y = seg.y;
                        } else {
                            if ("x1" in seg) x1 = x + seg.x1;
                            if ("x2" in seg) x2 = x + seg.x2;
                            if ("y1" in seg) y1 = y + seg.y1;
                            if ("y2" in seg) y2 = y + seg.y2;
                            if ("x" in seg) x += seg.x;
                            if ("y" in seg) y += seg.y;
                            switch(segType){
                                case "m":
                                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
                                    break;
                                case "l":
                                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
                                    break;
                                case "h":
                                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
                                    break;
                                case "v":
                                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
                                    break;
                                case "c":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
                                    break;
                                case "s":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
                                    break;
                                case "q":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
                                    break;
                                case "t":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
                                    break;
                                case "a":
                                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
                                    break;
                                case "z":
                                case "Z":
                                    x = x0;
                                    y = y0;
                                    break;
                            }
                        }
                        if (segType == "M" || segType == "m") {
                            x0 = x;
                            y0 = y;
                        }
                    }
                };
            })();
        /***/ },
        /* 593 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(249);
            var EventEmitter = __webpack_require__(9);
            var GetFastValue = __webpack_require__(2);
            var HasValue = __webpack_require__(126);
            var Vertices = __webpack_require__(64);
            /**
 * @classdesc
 * A wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
 * have one Matter body associated with it. You can either pass in an existing Matter body for
 * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
 * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
 * tile's rectangle bounding box will be used.
 *
 * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
 *
 * Note: not all Tiled collision shapes are supported. See
 * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
 *
 * @class TileBody
 * @memberof Phaser.Physics.Matter
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world instance this body belongs to.
 * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
 * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
 */ var MatterTileBody = new Class({
                Extends: EventEmitter,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.Sleep,
                    Components.Static
                ],
                initialize: function MatterTileBody(world, tile, options) {
                    EventEmitter.call(this);
                    /**
         * The tile object the body is associated with.
         *
         * @name Phaser.Physics.Matter.TileBody#tile
         * @type {Phaser.Tilemaps.Tile}
         * @since 3.0.0
         */ this.tile = tile;
                    /**
         * The Matter world the body exists within.
         *
         * @name Phaser.Physics.Matter.TileBody#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    // Install a reference to 'this' on the tile and ensure there can only be one matter body
                    // associated with the tile
                    if (tile.physics.matterBody) tile.physics.matterBody.destroy();
                    tile.physics.matterBody = this;
                    // Set the body either from an existing body (if provided), the shapes in the tileset
                    // collision layer (if it exists) or a rectangle matching the tile.
                    var body = GetFastValue(options, "body", null);
                    var addToWorld = GetFastValue(options, "addToWorld", true);
                    if (!body) {
                        var collisionGroup = tile.getCollisionGroup();
                        var collisionObjects = GetFastValue(collisionGroup, "objects", []);
                        if (collisionObjects.length > 0) this.setFromTileCollision(options);
                        else this.setFromTileRectangle(options);
                    } else this.setBody(body, addToWorld);
                },
                /**
     * Sets the current body to a rectangle that matches the bounds of the tile.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileRectangle
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileRectangle: function(options) {
                    if (options === undefined) options = {};
                    if (!HasValue(options, "isStatic")) options.isStatic = true;
                    if (!HasValue(options, "addToWorld")) options.addToWorld = true;
                    var bounds = this.tile.getBounds();
                    var cx = bounds.x + bounds.width / 2;
                    var cy = bounds.y + bounds.height / 2;
                    var body = Bodies.rectangle(cx, cy, bounds.width, bounds.height, options);
                    this.setBody(body, options.addToWorld);
                    return this;
                },
                /**
     * Sets the current body from the collision group associated with the Tile. This is typically
     * set up in Tiled's collision editor.
     *
     * Note: Matter doesn't support all shapes from Tiled. Rectangles and polygons are directly
     * supported. Ellipses are converted into circle bodies. Polylines are treated as if they are
     * closed polygons. If a tile has multiple shapes, a multi-part body will be created. Concave
     * shapes are supported if poly-decomp library is included. Decomposition is not guaranteed to
     * work for complex shapes (e.g. holes), so it's often best to manually decompose a concave
     * polygon into multiple convex polygons yourself.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileCollision
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileCollision: function(options) {
                    if (options === undefined) options = {};
                    if (!HasValue(options, "isStatic")) options.isStatic = true;
                    if (!HasValue(options, "addToWorld")) options.addToWorld = true;
                    var sx = this.tile.tilemapLayer.scaleX;
                    var sy = this.tile.tilemapLayer.scaleY;
                    var tileX = this.tile.getLeft();
                    var tileY = this.tile.getTop();
                    var collisionGroup = this.tile.getCollisionGroup();
                    var collisionObjects = GetFastValue(collisionGroup, "objects", []);
                    var parts = [];
                    for(var i = 0; i < collisionObjects.length; i++){
                        var object = collisionObjects[i];
                        var ox = tileX + object.x * sx;
                        var oy = tileY + object.y * sy;
                        var ow = object.width * sx;
                        var oh = object.height * sy;
                        var body = null;
                        if (object.rectangle) body = Bodies.rectangle(ox + ow / 2, oy + oh / 2, ow, oh, options);
                        else if (object.ellipse) body = Bodies.circle(ox + ow / 2, oy + oh / 2, ow / 2, options);
                        else if (object.polygon || object.polyline) {
                            // Polygons and polylines are both treated as closed polygons
                            var originalPoints = object.polygon ? object.polygon : object.polyline;
                            var points = originalPoints.map(function(p) {
                                return {
                                    x: p.x * sx,
                                    y: p.y * sy
                                };
                            });
                            var vertices = Vertices.create(points);
                            // Points are relative to the object's origin (first point placed in Tiled), but
                            // matter expects points to be relative to the center of mass. This only applies to
                            // convex shapes. When a concave shape is decomposed, multiple parts are created and
                            // the individual parts are positioned relative to (ox, oy).
                            //
                            //  Update: 8th January 2019 - the latest version of Matter needs the Vertices adjusted,
                            //  regardless if convex or concave.
                            var center = Vertices.centre(vertices);
                            ox += center.x;
                            oy += center.y;
                            body = Bodies.fromVertices(ox, oy, vertices, options);
                        }
                        if (body) parts.push(body);
                    }
                    if (parts.length === 1) this.setBody(parts[0], options.addToWorld);
                    else if (parts.length > 1) {
                        options.parts = parts;
                        this.setBody(Body.create(options), options.addToWorld);
                    }
                    return this;
                },
                /**
     * Sets the current body to the given body. This will remove the previous body, if one already
     * exists.
     *
     * @method Phaser.Physics.Matter.TileBody#setBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The new Matter body to use.
     * @param {boolean} [addToWorld=true] - Whether or not to add the body to the Matter world.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setBody: function(body, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    if (this.body) this.removeBody();
                    this.body = body;
                    this.body.gameObject = this;
                    if (addToWorld) this.world.add(this.body);
                    return this;
                },
                /**
     * Removes the current body from the TileBody and from the Matter world
     *
     * @method Phaser.Physics.Matter.TileBody#removeBody
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ removeBody: function() {
                    if (this.body) {
                        this.world.remove(this.body);
                        this.body.gameObject = undefined;
                        this.body = undefined;
                    }
                    return this;
                },
                /**
     * Removes the current body from the tile and the world.
     *
     * @method Phaser.Physics.Matter.TileBody#destroy
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ destroy: function() {
                    this.removeBody();
                    this.tile.physics.matterBody = undefined;
                    this.removeAllListeners();
                }
            });
            module1.exports = MatterTileBody;
        /***/ },
        /* 594 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Matter
 */ var Matter = __webpack_require__(1399);
            Matter.Body = __webpack_require__(41);
            Matter.Composite = __webpack_require__(118);
            Matter.World = __webpack_require__(596);
            Matter.Detector = __webpack_require__(273);
            Matter.Grid = __webpack_require__(597);
            Matter.Pairs = __webpack_require__(598);
            Matter.Pair = __webpack_require__(250);
            Matter.Query = __webpack_require__(1400);
            Matter.Resolver = __webpack_require__(599);
            Matter.SAT = __webpack_require__(274);
            Matter.Constraint = __webpack_require__(128);
            Matter.Common = __webpack_require__(32);
            Matter.Engine = __webpack_require__(1401);
            Matter.Events = __webpack_require__(166);
            Matter.Sleeping = __webpack_require__(165);
            Matter.Plugin = __webpack_require__(595);
            Matter.Bodies = __webpack_require__(86);
            Matter.Composites = __webpack_require__(591);
            Matter.Axes = __webpack_require__(271);
            Matter.Bounds = __webpack_require__(84);
            Matter.Svg = __webpack_require__(592);
            Matter.Vector = __webpack_require__(83);
            Matter.Vertices = __webpack_require__(64);
            // aliases
            Matter.World.add = Matter.Composite.add;
            Matter.World.remove = Matter.Composite.remove;
            Matter.World.addComposite = Matter.Composite.addComposite;
            Matter.World.addBody = Matter.Composite.addBody;
            Matter.World.addConstraint = Matter.Composite.addConstraint;
            Matter.World.clear = Matter.Composite.clear;
            module1.exports = Matter;
        /***/ },
        /* 595 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
*
* @class Plugin
*/ var Plugin = {};
            module1.exports = Plugin;
            var Common = __webpack_require__(32);
            (function() {
                Plugin._registry = {};
                /**
     * Registers a plugin object so it can be resolved later by name.
     * @method register
     * @param plugin {} The plugin to register.
     * @return {object} The plugin.
     */ Plugin.register = function(plugin) {
                    if (!Plugin.isPlugin(plugin)) Common.warn("Plugin.register:", Plugin.toString(plugin), "does not implement all required fields.");
                    if (plugin.name in Plugin._registry) {
                        var registered = Plugin._registry[plugin.name], pluginVersion = Plugin.versionParse(plugin.version).number, registeredVersion = Plugin.versionParse(registered.version).number;
                        if (pluginVersion > registeredVersion) {
                            Common.warn("Plugin.register:", Plugin.toString(registered), "was upgraded to", Plugin.toString(plugin));
                            Plugin._registry[plugin.name] = plugin;
                        } else if (pluginVersion < registeredVersion) Common.warn("Plugin.register:", Plugin.toString(registered), "can not be downgraded to", Plugin.toString(plugin));
                        else if (plugin !== registered) Common.warn("Plugin.register:", Plugin.toString(plugin), "is already registered to different plugin object");
                    } else Plugin._registry[plugin.name] = plugin;
                    return plugin;
                };
                /**
     * Resolves a dependency to a plugin object from the registry if it exists. 
     * The `dependency` may contain a version, but only the name matters when resolving.
     * @method resolve
     * @param dependency {string} The dependency.
     * @return {object} The plugin if resolved, otherwise `undefined`.
     */ Plugin.resolve = function(dependency) {
                    return Plugin._registry[Plugin.dependencyParse(dependency).name];
                };
                /**
     * Returns a pretty printed plugin name and version.
     * @method toString
     * @param plugin {} The plugin.
     * @return {string} Pretty printed plugin name and version.
     */ Plugin.toString = function(plugin) {
                    return typeof plugin === "string" ? plugin : (plugin.name || "anonymous") + "@" + (plugin.version || plugin.range || "0.0.0");
                };
                /**
     * Returns `true` if the object meets the minimum standard to be considered a plugin.
     * This means it must define the following properties:
     * - `name`
     * - `version`
     * - `install`
     * @method isPlugin
     * @param obj {} The obj to test.
     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
     */ Plugin.isPlugin = function(obj) {
                    return obj && obj.name && obj.version && obj.install;
                };
                /**
     * Returns `true` if a plugin with the given `name` been installed on `module`.
     * @method isUsed
     * @param module {} The module.
     * @param name {string} The plugin name.
     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
     */ Plugin.isUsed = function(module1, name) {
                    return module1.used.indexOf(name) > -1;
                };
                /**
     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
     * If `plugin.for` is not specified then it is assumed to be applicable.
     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
     * @method isFor
     * @param plugin {} The plugin.
     * @param module {} The module.
     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
     */ Plugin.isFor = function(plugin, module1) {
                    var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
                    return !plugin.for || module1.name === parsed.name && Plugin.versionSatisfies(module1.version, parsed.range);
                };
                /**
     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
     * For installing plugins on `Matter` see the convenience function `Matter.use`.
     * Plugins may be specified either by their name or a reference to the plugin object.
     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
     * Order is important, a topological sort is performed to find the best resulting order of installation.
     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
     * This function logs the resulting status of each dependency in the console, along with any warnings.
     * - A green tick ✅ indicates a dependency was resolved and installed.
     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
     * - A red cross ❌ indicates a dependency could not be resolved.
     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
     * @method use
     * @param module {} The module install plugins on.
     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
     */ Plugin.use = function(module1, plugins) {
                    module1.uses = (module1.uses || []).concat(plugins || []);
                    if (module1.uses.length === 0) {
                        Common.warn("Plugin.use:", Plugin.toString(module1), "does not specify any dependencies to install.");
                        return;
                    }
                    var dependencies = Plugin.dependencies(module1), sortedDependencies = Common.topologicalSort(dependencies), status = [];
                    for(var i = 0; i < sortedDependencies.length; i += 1){
                        if (sortedDependencies[i] === module1.name) continue;
                        var plugin = Plugin.resolve(sortedDependencies[i]);
                        if (!plugin) {
                            status.push("\u274C " + sortedDependencies[i]);
                            continue;
                        }
                        if (Plugin.isUsed(module1, plugin.name)) continue;
                        if (!Plugin.isFor(plugin, module1)) {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "is for", plugin.for, "but installed on", Plugin.toString(module1) + ".");
                            plugin._warned = true;
                        }
                        if (plugin.install) plugin.install(module1);
                        else {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "does not specify an install function.");
                            plugin._warned = true;
                        }
                        if (plugin._warned) {
                            status.push("\uD83D\uDD36 " + Plugin.toString(plugin));
                            delete plugin._warned;
                        } else status.push("\u2705 " + Plugin.toString(plugin));
                        module1.used.push(plugin.name);
                    }
                    if (status.length > 0 && !plugin.silent) Common.info(status.join("  "));
                };
                /**
     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
     * @method dependencies
     * @param module {} The module.
     * @return {object} A dependency graph.
     */ Plugin.dependencies = function(module1, tracked) {
                    var parsedBase = Plugin.dependencyParse(module1), name = parsedBase.name;
                    tracked = tracked || {};
                    if (name in tracked) return;
                    module1 = Plugin.resolve(module1) || module1;
                    tracked[name] = Common.map(module1.uses || [], function(dependency) {
                        if (Plugin.isPlugin(dependency)) Plugin.register(dependency);
                        var parsed = Plugin.dependencyParse(dependency), resolved = Plugin.resolve(dependency);
                        if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(resolved), "does not satisfy", Plugin.toString(parsed), "used by", Plugin.toString(parsedBase) + ".");
                            resolved._warned = true;
                            module1._warned = true;
                        } else if (!resolved) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(dependency), "used by", Plugin.toString(parsedBase), "could not be resolved.");
                            module1._warned = true;
                        }
                        return parsed.name;
                    });
                    for(var i = 0; i < tracked[name].length; i += 1)Plugin.dependencies(tracked[name][i], tracked);
                    return tracked;
                };
                /**
     * Parses a dependency string into its components.
     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * This function can also handle dependencies that are already resolved (e.g. a module object).
     * @method dependencyParse
     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
     * @return {object} The dependency parsed into its components.
     */ Plugin.dependencyParse = function(dependency) {
                    if (Common.isString(dependency)) {
                        var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?))?$/;
                        if (!pattern.test(dependency)) Common.warn("Plugin.dependencyParse:", dependency, "is not a valid dependency string.");
                        return {
                            name: dependency.split("@")[0],
                            range: dependency.split("@")[1] || "*"
                        };
                    }
                    return {
                        name: dependency.name,
                        range: dependency.range || dependency.version
                    };
                };
                /**
     * Parses a version string into its components.  
     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
     * Only the following range types are supported:
     * - Tilde ranges e.g. `~1.2.3`
     * - Caret ranges e.g. `^1.2.3`
     * - Exact version e.g. `1.2.3`
     * - Any version `*`
     * @method versionParse
     * @param range {string} The version string.
     * @return {object} The version range parsed into its components.
     */ Plugin.versionParse = function(range) {
                    var pattern = /^\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?$/;
                    if (!pattern.test(range)) Common.warn("Plugin.versionParse:", range, "is not a valid version or range.");
                    var identifiers = range.split("-");
                    range = identifiers[0];
                    var isRange = isNaN(Number(range[0])), version = isRange ? range.substr(1) : range, parts = Common.map(version.split("."), function(part) {
                        return Number(part);
                    });
                    return {
                        isRange: isRange,
                        version: version,
                        range: range,
                        operator: isRange ? range[0] : "",
                        parts: parts,
                        prerelease: identifiers[1],
                        number: parts[0] * 1e8 + parts[1] * 1e4 + parts[2]
                    };
                };
                /**
     * Returns `true` if `version` satisfies the given `range`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
     * @method versionSatisfies
     * @param version {string} The version string.
     * @param range {string} The range string.
     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
     */ Plugin.versionSatisfies = function(version, range) {
                    range = range || "*";
                    var rangeParsed = Plugin.versionParse(range), rangeParts = rangeParsed.parts, versionParsed = Plugin.versionParse(version), versionParts = versionParsed.parts;
                    if (rangeParsed.isRange) {
                        if (rangeParsed.operator === "*" || version === "*") return true;
                        if (rangeParsed.operator === "~") return versionParts[0] === rangeParts[0] && versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
                        if (rangeParsed.operator === "^") {
                            if (rangeParts[0] > 0) return versionParts[0] === rangeParts[0] && versionParsed.number >= rangeParsed.number;
                            if (rangeParts[1] > 0) return versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
                            return versionParts[2] === rangeParts[2];
                        }
                    }
                    return version === range || version === "*";
                };
            })();
        /***/ },
        /* 596 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.World` module contains methods for creating and manipulating the world composite.
* A `Matter.World` is a `Matter.Composite` body, which is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`.
* A `Matter.World` has a few additional properties including `gravity` and `bounds`.
* It is important to use the functions in the `Matter.Composite` module to modify the world composite, rather than directly modifying its properties.
* There are also a few methods here that alias those in `Matter.Composite` for easier readability.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class World
* @extends Composite
*/ var World = {};
            module1.exports = World;
            var Composite = __webpack_require__(118);
            var Constraint = __webpack_require__(128);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Creates a new world composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @constructor
     * @param {} options
     * @return {world} A new world
     */ World.create = function(options) {
                    var composite = Composite.create();
                    var defaults = {
                        label: "World",
                        gravity: {
                            x: 0,
                            y: 1,
                            scale: 0.001
                        },
                        bounds: {
                            min: {
                                x: -Infinity,
                                y: -Infinity
                            },
                            max: {
                                x: Infinity,
                                y: Infinity
                            }
                        }
                    };
                    return Common.extend(composite, defaults, options);
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * The gravity to apply on the world.
     *
     * @property gravity
     * @type object
     */ /**
     * The gravity x component.
     *
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravity y component.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The gravity scale factor.
     *
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ /**
     * A `Bounds` object that defines the world bounds for collision detection.
     *
     * @property bounds
     * @type bounds
     * @default { min: { x: -Infinity, y: -Infinity }, max: { x: Infinity, y: Infinity } }
     */ // World is a Composite body
            // see src/module/Outro.js for these aliases:
            /**
     * An alias for Composite.add
     * @method add
     * @param {world} world
     * @param {} object
     * @return {composite} The original world with the objects added
     */ /**
     * An alias for Composite.remove
     * @method remove
     * @param {world} world
     * @param {} object
     * @param {boolean} [deep=false]
     * @return {composite} The original world with the objects removed
     */ /**
     * An alias for Composite.clear
     * @method clear
     * @param {world} world
     * @param {boolean} keepStatic
     */ /**
     * An alias for Composite.addComposite
     * @method addComposite
     * @param {world} world
     * @param {composite} composite
     * @return {world} The original world with the objects from composite added
     */ /**
      * An alias for Composite.addBody
      * @method addBody
      * @param {world} world
      * @param {body} body
      * @return {world} The original world with the body added
      */ /**
      * An alias for Composite.addConstraint
      * @method addConstraint
      * @param {world} world
      * @param {constraint} constraint
      * @return {world} The original world with the constraint added
      */ })();
        /***/ },
        /* 597 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
*
* @class Grid
*/ var Grid = {};
            module1.exports = Grid;
            var Pair = __webpack_require__(250);
            var Detector = __webpack_require__(273);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Creates a new grid.
     * @method create
     * @param {} options
     * @return {grid} A new grid
     */ Grid.create = function(options) {
                    var defaults = {
                        controller: Grid,
                        detector: Detector.collisions,
                        buckets: {},
                        pairs: {},
                        pairsList: [],
                        bucketWidth: 48,
                        bucketHeight: 48
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * The width of a single grid bucket.
     *
     * @property bucketWidth
     * @type number
     * @default 48
     */ /**
     * The height of a single grid bucket.
     *
     * @property bucketHeight
     * @type number
     * @default 48
     */ /**
     * Updates the grid.
     * @method update
     * @param {grid} grid
     * @param {body[]} bodies
     * @param {engine} engine
     * @param {boolean} forceUpdate
     */ Grid.update = function(grid, bodies, engine, forceUpdate) {
                    var i, col, row, world = engine.world, buckets = grid.buckets, bucket, bucketId, gridChanged = false;
                    // @if DEBUG
                    var metrics = engine.metrics;
                    metrics.broadphaseTests = 0;
                    // @endif
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isSleeping && !forceUpdate) continue;
                        // don't update out of world bodies
                        if (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y) continue;
                        var newRegion = Grid._getRegion(grid, body);
                        // if the body has changed grid region
                        if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
                            // @if DEBUG
                            metrics.broadphaseTests += 1;
                            // @endif
                            if (!body.region || forceUpdate) body.region = newRegion;
                            var union = Grid._regionUnion(newRegion, body.region);
                            // update grid buckets affected by region change
                            // iterate over the union of both regions
                            for(col = union.startCol; col <= union.endCol; col++)for(row = union.startRow; row <= union.endRow; row++){
                                bucketId = Grid._getBucketId(col, row);
                                bucket = buckets[bucketId];
                                var isInsideNewRegion = col >= newRegion.startCol && col <= newRegion.endCol && row >= newRegion.startRow && row <= newRegion.endRow;
                                var isInsideOldRegion = col >= body.region.startCol && col <= body.region.endCol && row >= body.region.startRow && row <= body.region.endRow;
                                // remove from old region buckets
                                if (!isInsideNewRegion && isInsideOldRegion) {
                                    if (isInsideOldRegion) {
                                        if (bucket) Grid._bucketRemoveBody(grid, bucket, body);
                                    }
                                }
                                // add to new region buckets
                                if (body.region === newRegion || isInsideNewRegion && !isInsideOldRegion || forceUpdate) {
                                    if (!bucket) bucket = Grid._createBucket(buckets, bucketId);
                                    Grid._bucketAddBody(grid, bucket, body);
                                }
                            }
                            // set the new region
                            body.region = newRegion;
                            // flag changes so we can update pairs
                            gridChanged = true;
                        }
                    }
                    // update pairs list only if pairs changed (i.e. a body changed region)
                    if (gridChanged) grid.pairsList = Grid._createActivePairsList(grid);
                };
                /**
     * Clears the grid.
     * @method clear
     * @param {grid} grid
     */ Grid.clear = function(grid) {
                    grid.buckets = {};
                    grid.pairs = {};
                    grid.pairsList = [];
                };
                /**
     * Finds the union of two regions.
     * @method _regionUnion
     * @private
     * @param {} regionA
     * @param {} regionB
     * @return {} region
     */ Grid._regionUnion = function(regionA, regionB) {
                    var startCol = Math.min(regionA.startCol, regionB.startCol), endCol = Math.max(regionA.endCol, regionB.endCol), startRow = Math.min(regionA.startRow, regionB.startRow), endRow = Math.max(regionA.endRow, regionB.endRow);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Gets the region a given body falls in for a given grid.
     * @method _getRegion
     * @private
     * @param {} grid
     * @param {} body
     * @return {} region
     */ Grid._getRegion = function(grid, body) {
                    var bounds = body.bounds, startCol = Math.floor(bounds.min.x / grid.bucketWidth), endCol = Math.floor(bounds.max.x / grid.bucketWidth), startRow = Math.floor(bounds.min.y / grid.bucketHeight), endRow = Math.floor(bounds.max.y / grid.bucketHeight);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Creates a region.
     * @method _createRegion
     * @private
     * @param {} startCol
     * @param {} endCol
     * @param {} startRow
     * @param {} endRow
     * @return {} region
     */ Grid._createRegion = function(startCol, endCol, startRow, endRow) {
                    return {
                        id: startCol + "," + endCol + "," + startRow + "," + endRow,
                        startCol: startCol,
                        endCol: endCol,
                        startRow: startRow,
                        endRow: endRow
                    };
                };
                /**
     * Gets the bucket id at the given position.
     * @method _getBucketId
     * @private
     * @param {} column
     * @param {} row
     * @return {string} bucket id
     */ Grid._getBucketId = function(column, row) {
                    return "C" + column + "R" + row;
                };
                /**
     * Creates a bucket.
     * @method _createBucket
     * @private
     * @param {} buckets
     * @param {} bucketId
     * @return {} bucket
     */ Grid._createBucket = function(buckets, bucketId) {
                    var bucket = buckets[bucketId] = [];
                    return bucket;
                };
                /**
     * Adds a body to a bucket.
     * @method _bucketAddBody
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketAddBody = function(grid, bucket, body) {
                    // add new pairs
                    for(var i = 0; i < bucket.length; i++){
                        var bodyB = bucket[i];
                        if (body.id === bodyB.id || body.isStatic && bodyB.isStatic) continue;
                        // keep track of the number of buckets the pair exists in
                        // important for Grid.update to work
                        var pairId = Pair.id(body, bodyB), pair = grid.pairs[pairId];
                        if (pair) pair[2] += 1;
                        else grid.pairs[pairId] = [
                            body,
                            bodyB,
                            1
                        ];
                    }
                    // add to bodies (after pairs, otherwise pairs with self)
                    bucket.push(body);
                };
                /**
     * Removes a body from a bucket.
     * @method _bucketRemoveBody
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketRemoveBody = function(grid, bucket, body) {
                    // remove from bucket
                    bucket.splice(bucket.indexOf(body), 1);
                    // update pair counts
                    for(var i = 0; i < bucket.length; i++){
                        // keep track of the number of buckets the pair exists in
                        // important for _createActivePairsList to work
                        var bodyB = bucket[i], pairId = Pair.id(body, bodyB), pair = grid.pairs[pairId];
                        if (pair) pair[2] -= 1;
                    }
                };
                /**
     * Generates a list of the active pairs in the grid.
     * @method _createActivePairsList
     * @private
     * @param {} grid
     * @return [] pairs
     */ Grid._createActivePairsList = function(grid) {
                    var pairKeys, pair, pairs = [];
                    // grid.pairs is used as a hashmap
                    pairKeys = Common.keys(grid.pairs);
                    // iterate over grid.pairs
                    for(var k = 0; k < pairKeys.length; k++){
                        pair = grid.pairs[pairKeys[k]];
                        // if pair exists in at least one bucket
                        // it is a pair that needs further collision testing so push it
                        if (pair[2] > 0) pairs.push(pair);
                        else delete grid.pairs[pairKeys[k]];
                    }
                    return pairs;
                };
            })();
        /***/ },
        /* 598 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
*
* @class Pairs
*/ var Pairs = {};
            module1.exports = Pairs;
            var Pair = __webpack_require__(250);
            var Common = __webpack_require__(32);
            (function() {
                Pairs._pairMaxIdleLife = 1000;
                /**
     * Creates a new pairs structure.
     * @method create
     * @param {object} options
     * @return {pairs} A new pairs structure
     */ Pairs.create = function(options) {
                    return Common.extend({
                        table: {},
                        list: [],
                        collisionStart: [],
                        collisionActive: [],
                        collisionEnd: []
                    }, options);
                };
                /**
     * Updates pairs given a list of collisions.
     * @method update
     * @param {object} pairs
     * @param {collision[]} collisions
     * @param {number} timestamp
     */ Pairs.update = function(pairs, collisions, timestamp) {
                    var pairsList = pairs.list, pairsTable = pairs.table, collisionStart = pairs.collisionStart, collisionEnd = pairs.collisionEnd, collisionActive = pairs.collisionActive, collision, pairId, pair, i;
                    // clear collision state arrays, but maintain old reference
                    collisionStart.length = 0;
                    collisionEnd.length = 0;
                    collisionActive.length = 0;
                    for(i = 0; i < pairsList.length; i++)pairsList[i].confirmedActive = false;
                    for(i = 0; i < collisions.length; i++){
                        collision = collisions[i];
                        if (collision.collided) {
                            pairId = Pair.id(collision.bodyA, collision.bodyB);
                            pair = pairsTable[pairId];
                            if (pair) {
                                // pair already exists (but may or may not be active)
                                if (pair.isActive) // pair exists and is active
                                collisionActive.push(pair);
                                else // pair exists but was inactive, so a collision has just started again
                                collisionStart.push(pair);
                                // update the pair
                                Pair.update(pair, collision, timestamp);
                                pair.confirmedActive = true;
                            } else {
                                // pair did not exist, create a new pair
                                pair = Pair.create(collision, timestamp);
                                pairsTable[pairId] = pair;
                                // push the new pair
                                collisionStart.push(pair);
                                pairsList.push(pair);
                            }
                        }
                    }
                    // deactivate previously active pairs that are now inactive
                    for(i = 0; i < pairsList.length; i++){
                        pair = pairsList[i];
                        if (pair.isActive && !pair.confirmedActive) {
                            Pair.setActive(pair, false, timestamp);
                            collisionEnd.push(pair);
                        }
                    }
                };
                /**
     * Finds and removes pairs that have been inactive for a set amount of time.
     * @method removeOld
     * @param {object} pairs
     * @param {number} timestamp
     */ Pairs.removeOld = function(pairs, timestamp) {
                    var pairsList = pairs.list, pairsTable = pairs.table, indexesToRemove = [], pair, collision, pairIndex, i;
                    for(i = 0; i < pairsList.length; i++){
                        pair = pairsList[i];
                        collision = pair.collision;
                        // never remove sleeping pairs
                        if (collision.bodyA.isSleeping || collision.bodyB.isSleeping) {
                            pair.timeUpdated = timestamp;
                            continue;
                        }
                        // if pair is inactive for too long, mark it to be removed
                        if (timestamp - pair.timeUpdated > Pairs._pairMaxIdleLife) indexesToRemove.push(i);
                    }
                    // remove marked pairs
                    for(i = 0; i < indexesToRemove.length; i++){
                        pairIndex = indexesToRemove[i] - i;
                        pair = pairsList[pairIndex];
                        delete pairsTable[pair.id];
                        pairsList.splice(pairIndex, 1);
                    }
                };
                /**
     * Clears the given pairs structure.
     * @method clear
     * @param {pairs} pairs
     * @return {pairs} pairs
     */ Pairs.clear = function(pairs) {
                    pairs.table = {};
                    pairs.list.length = 0;
                    pairs.collisionStart.length = 0;
                    pairs.collisionActive.length = 0;
                    pairs.collisionEnd.length = 0;
                    return pairs;
                };
            })();
        /***/ },
        /* 599 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Resolver` module contains methods for resolving collision pairs.
*
* @class Resolver
*/ var Resolver = {};
            module1.exports = Resolver;
            var Vertices = __webpack_require__(64);
            var Vector = __webpack_require__(83);
            var Common = __webpack_require__(32);
            var Bounds = __webpack_require__(84);
            (function() {
                Resolver._restingThresh = 4;
                Resolver._restingThreshTangent = 6;
                Resolver._positionDampen = 0.9;
                Resolver._positionWarming = 0.8;
                Resolver._frictionNormalMultiplier = 5;
                /**
     * Prepare pairs for position solving.
     * @method preSolvePosition
     * @param {pair[]} pairs
     */ Resolver.preSolvePosition = function(pairs) {
                    var i, pair, activeCount;
                    // find total contacts on each body
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        activeCount = pair.activeContacts.length;
                        pair.collision.parentA.totalContacts += activeCount;
                        pair.collision.parentB.totalContacts += activeCount;
                    }
                };
                /**
     * Find a solution for pair positions.
     * @method solvePosition
     * @param {pair[]} pairs
     * @param {body[]} bodies
     * @param {number} timeScale
     */ Resolver.solvePosition = function(pairs, bodies, timeScale) {
                    var i, normalX, normalY, pair, collision, bodyA, bodyB, normal, separation, penetration, positionImpulseA, positionImpulseB, contactShare, bodyBtoAX, bodyBtoAY, positionImpulse, impulseCoefficient = timeScale * Resolver._positionDampen;
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        body.previousPositionImpulse.x = body.positionImpulse.x;
                        body.previousPositionImpulse.y = body.positionImpulse.y;
                    }
                    // find impulses required to resolve penetration
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        positionImpulseA = bodyA.previousPositionImpulse;
                        positionImpulseB = bodyB.previousPositionImpulse;
                        penetration = collision.penetration;
                        bodyBtoAX = positionImpulseB.x - positionImpulseA.x + penetration.x;
                        bodyBtoAY = positionImpulseB.y - positionImpulseA.y + penetration.y;
                        normalX = normal.x;
                        normalY = normal.y;
                        separation = normalX * bodyBtoAX + normalY * bodyBtoAY;
                        pair.separation = separation;
                        positionImpulse = (separation - pair.slop) * impulseCoefficient;
                        if (bodyA.isStatic || bodyB.isStatic) positionImpulse *= 2;
                        if (!(bodyA.isStatic || bodyA.isSleeping)) {
                            contactShare = positionImpulse / bodyA.totalContacts;
                            bodyA.positionImpulse.x += normalX * contactShare;
                            bodyA.positionImpulse.y += normalY * contactShare;
                        }
                        if (!(bodyB.isStatic || bodyB.isSleeping)) {
                            contactShare = positionImpulse / bodyB.totalContacts;
                            bodyB.positionImpulse.x -= normalX * contactShare;
                            bodyB.positionImpulse.y -= normalY * contactShare;
                        }
                    }
                };
                /**
     * Apply position resolution.
     * @method postSolvePosition
     * @param {body[]} bodies
     */ Resolver.postSolvePosition = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        // reset contact count
                        body.totalContacts = 0;
                        if (body.positionImpulse.x !== 0 || body.positionImpulse.y !== 0) {
                            // update body geometry
                            for(var j = 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                Vertices.translate(part.vertices, body.positionImpulse);
                                Bounds.update(part.bounds, part.vertices, body.velocity);
                                part.position.x += body.positionImpulse.x;
                                part.position.y += body.positionImpulse.y;
                            }
                            // move the body without changing velocity
                            body.positionPrev.x += body.positionImpulse.x;
                            body.positionPrev.y += body.positionImpulse.y;
                            if (Vector.dot(body.positionImpulse, body.velocity) < 0) {
                                // reset cached impulse if the body has velocity along it
                                body.positionImpulse.x = 0;
                                body.positionImpulse.y = 0;
                            } else {
                                // warm the next iteration
                                body.positionImpulse.x *= Resolver._positionWarming;
                                body.positionImpulse.y *= Resolver._positionWarming;
                            }
                        }
                    }
                };
                /**
     * Prepare pairs for velocity solving.
     * @method preSolveVelocity
     * @param {pair[]} pairs
     */ Resolver.preSolveVelocity = function(pairs) {
                    var i, j, pair, contacts, collision, bodyA, bodyB, normal, tangent, contact, contactVertex, normalImpulse, tangentImpulse, offset, impulse = Vector._temp[0], tempA = Vector._temp[1];
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        contacts = pair.activeContacts;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        tangent = collision.tangent;
                        // resolve each contact
                        for(j = 0; j < contacts.length; j++){
                            contact = contacts[j];
                            contactVertex = contact.vertex;
                            normalImpulse = contact.normalImpulse;
                            tangentImpulse = contact.tangentImpulse;
                            if (normalImpulse !== 0 || tangentImpulse !== 0) {
                                // total impulse from contact
                                impulse.x = normal.x * normalImpulse + tangent.x * tangentImpulse;
                                impulse.y = normal.y * normalImpulse + tangent.y * tangentImpulse;
                                // apply impulse from contact
                                if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                    offset = Vector.sub(contactVertex, bodyA.position, tempA);
                                    bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
                                    bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
                                    bodyA.anglePrev += Vector.cross(offset, impulse) * bodyA.inverseInertia;
                                }
                                if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                    offset = Vector.sub(contactVertex, bodyB.position, tempA);
                                    bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
                                    bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
                                    bodyB.anglePrev -= Vector.cross(offset, impulse) * bodyB.inverseInertia;
                                }
                            }
                        }
                    }
                };
                /**
     * Find a solution for pair velocities.
     * @method solveVelocity
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Resolver.solveVelocity = function(pairs, timeScale) {
                    var timeScaleSquared = timeScale * timeScale, impulse = Vector._temp[0], tempA = Vector._temp[1], tempB = Vector._temp[2], tempC = Vector._temp[3], tempD = Vector._temp[4], tempE = Vector._temp[5];
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normal = collision.normal, tangent = collision.tangent, contacts = pair.activeContacts, contactShare = 1 / contacts.length;
                        // update body velocities
                        bodyA.velocity.x = bodyA.position.x - bodyA.positionPrev.x;
                        bodyA.velocity.y = bodyA.position.y - bodyA.positionPrev.y;
                        bodyB.velocity.x = bodyB.position.x - bodyB.positionPrev.x;
                        bodyB.velocity.y = bodyB.position.y - bodyB.positionPrev.y;
                        bodyA.angularVelocity = bodyA.angle - bodyA.anglePrev;
                        bodyB.angularVelocity = bodyB.angle - bodyB.anglePrev;
                        // resolve each contact
                        for(var j = 0; j < contacts.length; j++){
                            var contact = contacts[j], contactVertex = contact.vertex, offsetA = Vector.sub(contactVertex, bodyA.position, tempA), offsetB = Vector.sub(contactVertex, bodyB.position, tempB), velocityPointA = Vector.add(bodyA.velocity, Vector.mult(Vector.perp(offsetA), bodyA.angularVelocity), tempC), velocityPointB = Vector.add(bodyB.velocity, Vector.mult(Vector.perp(offsetB), bodyB.angularVelocity), tempD), relativeVelocity = Vector.sub(velocityPointA, velocityPointB, tempE), normalVelocity = Vector.dot(normal, relativeVelocity);
                            var tangentVelocity = Vector.dot(tangent, relativeVelocity), tangentSpeed = Math.abs(tangentVelocity), tangentVelocityDirection = Common.sign(tangentVelocity);
                            // raw impulses
                            var normalImpulse = (1 + pair.restitution) * normalVelocity, normalForce = Common.clamp(pair.separation + normalVelocity, 0, 1) * Resolver._frictionNormalMultiplier;
                            // coulomb friction
                            var tangentImpulse = tangentVelocity, maxFriction = Infinity;
                            if (tangentSpeed > pair.friction * pair.frictionStatic * normalForce * timeScaleSquared) {
                                maxFriction = tangentSpeed;
                                tangentImpulse = Common.clamp(pair.friction * tangentVelocityDirection * timeScaleSquared, -maxFriction, maxFriction);
                            }
                            // modify impulses accounting for mass, inertia and offset
                            var oAcN = Vector.cross(offsetA, normal), oBcN = Vector.cross(offsetB, normal), share = contactShare / (bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * oAcN * oAcN + bodyB.inverseInertia * oBcN * oBcN);
                            normalImpulse *= share;
                            tangentImpulse *= share;
                            // handle high velocity and resting collisions separately
                            if (normalVelocity < 0 && normalVelocity * normalVelocity > Resolver._restingThresh * timeScaleSquared) // high normal velocity so clear cached contact normal impulse
                            contact.normalImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // impulse constraint tends to 0
                                var contactNormalImpulse = contact.normalImpulse;
                                contact.normalImpulse = Math.min(contact.normalImpulse + normalImpulse, 0);
                                normalImpulse = contact.normalImpulse - contactNormalImpulse;
                            }
                            // handle high velocity and resting collisions separately
                            if (tangentVelocity * tangentVelocity > Resolver._restingThreshTangent * timeScaleSquared) // high tangent velocity so clear cached contact tangent impulse
                            contact.tangentImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // tangent impulse tends to -tangentSpeed or +tangentSpeed
                                var contactTangentImpulse = contact.tangentImpulse;
                                contact.tangentImpulse = Common.clamp(contact.tangentImpulse + tangentImpulse, -maxFriction, maxFriction);
                                tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
                            }
                            // total impulse from contact
                            impulse.x = normal.x * normalImpulse + tangent.x * tangentImpulse;
                            impulse.y = normal.y * normalImpulse + tangent.y * tangentImpulse;
                            // apply impulse from contact
                            if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
                                bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
                                bodyA.anglePrev += Vector.cross(offsetA, impulse) * bodyA.inverseInertia;
                            }
                            if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
                                bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
                                bodyB.anglePrev -= Vector.cross(offsetB, impulse) * bodyB.inverseInertia;
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 600 */ /***/ function(module1, exports) {
            var g;
            // This works in non-strict mode
            g = function() {
                return this;
            }();
            try {
                // This works if eval is allowed (see CSP)
                g = g || new Function("return this")();
            } catch (e) {
                // This works if the window reference is available
                if (typeof window === "object") g = window;
            }
            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}
            module1.exports = g;
        /***/ },
        /* 601 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var QuickSet = __webpack_require__(276);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties, and aligns them next to each other.
 *
 * The first item isn't moved. The second item is aligned next to the first, then the third next to the second, and so on.
 *
 * @function Phaser.Actions.AlignTo
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} position - The position to align the items with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var AlignTo = function(items, position, offsetX, offsetY) {
                var target = items[0];
                for(var i = 1; i < items.length; i++){
                    var item = items[i];
                    QuickSet(item, target, position, offsetX, offsetY);
                    target = item;
                }
                return items;
            };
            module1.exports = AlignTo;
        /***/ },
        /* 602 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `angle` property,
 * and then adds the given value to each of their `angle` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Angle(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Angle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `angle` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Angle = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "angle", value, step, index, direction);
            };
            module1.exports = Angle;
        /***/ },
        /* 603 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and passes each of them to the given callback.
 *
 * @function Phaser.Actions.Call
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.CallCallback} callback - The callback to be invoked. It will be passed just one argument: the item from the array.
 * @param {*} context - The scope in which the callback will be invoked.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that was passed to this Action.
 */ var Call = function(items, callback, context) {
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    callback.call(context, item);
                }
                return items;
            };
            module1.exports = Call;
        /***/ },
        /* 604 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the first element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the first item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetFirst(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetFirst
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The first object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetFirst = function(items, compare, index) {
                if (index === undefined) index = 0;
                for(var i = index; i < items.length; i++){
                    var item = items[i];
                    var match = true;
                    for(var property in compare)if (item[property] !== compare[property]) match = false;
                    if (match) return item;
                }
                return null;
            };
            module1.exports = GetFirst;
        /***/ },
        /* 605 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the last element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the last item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetLast(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetLast
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The last object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetLast = function(items, compare, index) {
                if (index === undefined) index = 0;
                for(var i = index; i < items.length; i++){
                    var item = items[i];
                    var match = true;
                    for(var property in compare)if (item[property] !== compare[property]) match = false;
                    if (match) return item;
                }
                return null;
            };
            module1.exports = GetLast;
        /***/ },
        /* 606 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AlignIn = __webpack_require__(289);
            var CONST = __webpack_require__(123);
            var GetFastValue = __webpack_require__(2);
            var NOOP = __webpack_require__(1);
            var Zone = __webpack_require__(129);
            var tempZone = new Zone({
                sys: {
                    queueDepthSort: NOOP,
                    events: {
                        once: NOOP
                    }
                }
            }, 0, 0, 1, 1);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then aligns them based on the grid configuration given to this action.
 *
 * @function Phaser.Actions.GridAlign
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.GridAlignConfig} options - The GridAlign Configuration object.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var GridAlign = function(items, options) {
                if (options === undefined) options = {};
                var widthSet = options.hasOwnProperty("width");
                var heightSet = options.hasOwnProperty("height");
                var width = GetFastValue(options, "width", -1);
                var height = GetFastValue(options, "height", -1);
                var cellWidth = GetFastValue(options, "cellWidth", 1);
                var cellHeight = GetFastValue(options, "cellHeight", cellWidth);
                var position = GetFastValue(options, "position", CONST.TOP_LEFT);
                var x = GetFastValue(options, "x", 0);
                var y = GetFastValue(options, "y", 0);
                var cx = 0;
                var cy = 0;
                var w = width * cellWidth;
                var h = height * cellHeight;
                tempZone.setPosition(x, y);
                tempZone.setSize(cellWidth, cellHeight);
                for(var i = 0; i < items.length; i++){
                    AlignIn(items[i], tempZone, position);
                    if (widthSet && width === -1) //  We keep laying them out horizontally until we've done them all
                    tempZone.x += cellWidth;
                    else if (heightSet && height === -1) //  We keep laying them out vertically until we've done them all
                    tempZone.y += cellHeight;
                    else if (heightSet && !widthSet) {
                        //  We keep laying them out until we hit the column limit
                        cy += cellHeight;
                        tempZone.y += cellHeight;
                        if (cy === h) {
                            cy = 0;
                            cx += cellWidth;
                            tempZone.y = y;
                            tempZone.x += cellWidth;
                            if (cx === w) break;
                        }
                    } else {
                        //  We keep laying them out until we hit the column limit
                        cx += cellWidth;
                        tempZone.x += cellWidth;
                        if (cx === w) {
                            cx = 0;
                            cy += cellHeight;
                            tempZone.x = x;
                            tempZone.y += cellHeight;
                            if (cy === h) break;
                        }
                    }
                }
                return items;
            };
            module1.exports = GridAlign;
        /***/ },
        /* 607 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 2; // 0010
            /**
 * Provides methods used for setting the alpha properties of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Alpha
 * @since 3.0.0
 */ var Alpha = {
                /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                /**
     * Private internal value. Holds the top-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTL: 1,
                /**
     * Private internal value. Holds the top-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTR: 1,
                /**
     * Private internal value. Holds the bottom-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBL: 1,
                /**
     * Private internal value. Holds the bottom-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBR: 1,
                /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.Alpha#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                    return this.setAlpha(1);
                },
                /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * If your game is running under WebGL you can optionally specify four different alpha values, each of which
     * correspond to the four corners of the Game Object. Under Canvas only the `topLeft` value given is used.
     *
     * @method Phaser.GameObjects.Components.Alpha#setAlpha
     * @since 3.0.0
     *
     * @param {number} [topLeft=1] - The alpha value used for the top-left of the Game Object. If this is the only value given it's applied across the whole Game Object.
     * @param {number} [topRight] - The alpha value used for the top-right of the Game Object. WebGL only.
     * @param {number} [bottomLeft] - The alpha value used for the bottom-left of the Game Object. WebGL only.
     * @param {number} [bottomRight] - The alpha value used for the bottom-right of the Game Object. WebGL only.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(topLeft, topRight, bottomLeft, bottomRight) {
                    if (topLeft === undefined) topLeft = 1;
                    //  Treat as if there is only one alpha value for the whole Game Object
                    if (topRight === undefined) this.alpha = topLeft;
                    else {
                        this._alphaTL = Clamp(topLeft, 0, 1);
                        this._alphaTR = Clamp(topRight, 0, 1);
                        this._alphaBL = Clamp(bottomLeft, 0, 1);
                        this._alphaBR = Clamp(bottomRight, 0, 1);
                    }
                    return this;
                },
                /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.Alpha#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alpha = v;
                        this._alphaTL = v;
                        this._alphaTR = v;
                        this._alphaBL = v;
                        this._alphaBR = v;
                        if (v === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the top-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopLeft: {
                    get: function() {
                        return this._alphaTL;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaTL = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the top-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopRight: {
                    get: function() {
                        return this._alphaTR;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaTR = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the bottom-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomLeft: {
                    get: function() {
                        return this._alphaBL;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaBL = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the bottom-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomRight: {
                    get: function() {
                        return this._alphaBR;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaBR = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                }
            };
            module1.exports = Alpha;
        /***/ },
        /* 608 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for calculating and setting the size of a non-Frame based Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.ComputedSize
 * @since 3.0.0
 */ var ComputedSize = {
                /**
     * The native (un-scaled) width of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                /**
     * The native (un-scaled) height of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                /**
     * The displayed width of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.ComputedSize#setSize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * 
     * Calling this will adjust the scale.
     * 
     * @method Phaser.GameObjects.Components.ComputedSize#setDisplaySize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                }
            };
            module1.exports = ComputedSize;
        /***/ },
        /* 609 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Crop
 * @since 3.12.0
 */ var Crop = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.Crop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     * 
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     * 
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     * 
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     * 
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     * 
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rect of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     * 
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     * 
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     * 
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.Crop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from.
     * @param {number} [width] - The width of the crop rectangle in pixels.
     * @param {number} [height] - The height of the crop rectangle in pixels.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                    if (x === undefined) this.isCropped = false;
                    else if (this.frame) {
                        if (typeof x === "number") this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                        else {
                            var rect = x;
                            this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                        }
                        this.isCropped = true;
                    }
                    return this;
                },
                /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.Crop#resetCropObject
     * @private
     * @since 3.12.0
     * 
     * @return {object} The crop object.
     */ resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: false,
                        flipY: false,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            module1.exports = Crop;
        /***/ },
        /* 610 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for visually flipping a Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.Flip
 * @since 3.0.0
 */ var Flip = {
                /**
     * The horizontally flipped state of the Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @name Phaser.GameObjects.Components.Flip#flipX
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipX: false,
                /**
     * The vertically flipped state of the Game Object.
     * 
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @name Phaser.GameObjects.Components.Flip#flipY
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipY: false,
                /**
     * Toggles the horizontal flipped state of this Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#toggleFlipX
     * @since 3.0.0
     * 
     * @return {this} This Game Object instance.
     */ toggleFlipX: function() {
                    this.flipX = !this.flipX;
                    return this;
                },
                /**
     * Toggles the vertical flipped state of this Game Object.
     * 
     * @method Phaser.GameObjects.Components.Flip#toggleFlipY
     * @since 3.0.0
     * 
     * @return {this} This Game Object instance.
     */ toggleFlipY: function() {
                    this.flipY = !this.flipY;
                    return this;
                },
                /**
     * Sets the horizontal flipped state of this Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlipX: function(value) {
                    this.flipX = value;
                    return this;
                },
                /**
     * Sets the vertical flipped state of this Game Object.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlipY: function(value) {
                    this.flipY = value;
                    return this;
                },
                /**
     * Sets the horizontal and vertical flipped state of this Game Object.
     * 
     * A Game Object that is flipped will render inversed on the flipped axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlip: function(x, y) {
                    this.flipX = x;
                    this.flipY = y;
                    return this;
                },
                /**
     * Resets the horizontal and vertical flipped state of this Game Object back to their default un-flipped state.
     * 
     * @method Phaser.GameObjects.Components.Flip#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ resetFlip: function() {
                    this.flipX = false;
                    this.flipY = false;
                    return this;
                }
            };
            module1.exports = Flip;
        /***/ },
        /* 611 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var RotateAround = __webpack_require__(308);
            var Vector2 = __webpack_require__(3);
            /**
 * Provides methods used for obtaining the bounds of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.GetBounds
 * @since 3.0.0
 */ var GetBounds = {
                /**
     * Processes the bounds output vector before returning it.
     *
     * @method Phaser.GameObjects.Components.GetBounds#prepareBoundsOutput
     * @private
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} output - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ prepareBoundsOutput: function(output, includeParent) {
                    if (includeParent === undefined) includeParent = false;
                    if (this.rotation !== 0) RotateAround(output, this.x, this.y, this.rotation);
                    if (includeParent && this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        parentMatrix.transformPoint(output.x, output.y, output);
                    }
                    return output;
                },
                /**
     * Gets the center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getCenter
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getCenter: function(output) {
                    if (output === undefined) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return output;
                },
                /**
     * Gets the top-left corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopLeft: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the top-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the top-right corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopRight
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopRight: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the left-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getLeftCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getLeftCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the right-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getRightCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getRightCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-left corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomLeft: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-right corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomRight
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomRight: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bounds of this Game Object, regardless of origin.
     * The values are stored and returned in a Rectangle, or Rectangle-like, object.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [output,$return]
     *
     * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The values stored in the output object.
     */ getBounds: function(output) {
                    if (output === undefined) output = new Rectangle();
                    //  We can use the output object to temporarily store the x/y coords in:
                    var TLx, TLy, TRx, TRy, BLx, BLy, BRx, BRy;
                    // Instead of doing a check if parent container is 
                    // defined per corner we only do it once.
                    if (this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        this.getTopLeft(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        TLx = output.x;
                        TLy = output.y;
                        this.getTopRight(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        TRx = output.x;
                        TRy = output.y;
                        this.getBottomLeft(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        BLx = output.x;
                        BLy = output.y;
                        this.getBottomRight(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        BRx = output.x;
                        BRy = output.y;
                    } else {
                        this.getTopLeft(output);
                        TLx = output.x;
                        TLy = output.y;
                        this.getTopRight(output);
                        TRx = output.x;
                        TRy = output.y;
                        this.getBottomLeft(output);
                        BLx = output.x;
                        BLy = output.y;
                        this.getBottomRight(output);
                        BRx = output.x;
                        BRy = output.y;
                    }
                    output.x = Math.min(TLx, TRx, BLx, BRx);
                    output.y = Math.min(TLy, TRy, BLy, BRy);
                    output.width = Math.max(TLx, TRx, BLx, BRx) - output.x;
                    output.height = Math.max(TLy, TRy, BLy, BRy) - output.y;
                    return output;
                }
            };
            module1.exports = GetBounds;
        /***/ },
        /* 612 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Blur Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a blurred state. The blur event is raised when the window loses focus. This can happen if a user swaps
 * tab, or if they simply remove focus from the browser to another app.
 *
 * @event Phaser.Core.Events#BLUR
 * @since 3.0.0
 */ module1.exports = "blur";
        /***/ },
        /* 613 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Boot Event.
 * 
 * This event is dispatched when the Phaser Game instance has finished booting, but before it is ready to start running.
 * The global systems use this event to know when to set themselves up, dispatching their own `ready` events as required.
 *
 * @event Phaser.Core.Events#BOOT
 * @since 3.0.0
 */ module1.exports = "boot";
        /***/ },
        /* 614 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Context Lost Event.
 * 
 * This event is dispatched by the Game if the WebGL Renderer it is using encounters a WebGL Context Lost event from the browser.
 * 
 * The partner event is `CONTEXT_RESTORED`.
 *
 * @event Phaser.Core.Events#CONTEXT_LOST
 * @since 3.19.0
 */ module1.exports = "contextlost";
        /***/ },
        /* 615 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Context Restored Event.
 * 
 * This event is dispatched by the Game if the WebGL Renderer it is using encounters a WebGL Context Restored event from the browser.
 * 
 * The partner event is `CONTEXT_LOST`.
 *
 * @event Phaser.Core.Events#CONTEXT_RESTORED
 * @since 3.19.0
 */ module1.exports = "contextrestored";
        /***/ },
        /* 616 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Destroy Event.
 * 
 * This event is dispatched when the game instance has been told to destroy itself.
 * Lots of internal systems listen to this event in order to clear themselves out.
 * Custom plugins and game code should also do the same.
 *
 * @event Phaser.Core.Events#DESTROY
 * @since 3.0.0
 */ module1.exports = "destroy";
        /***/ },
        /* 617 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Focus Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a focused state. The focus event is raised when the window re-gains focus, having previously lost it.
 *
 * @event Phaser.Core.Events#FOCUS
 * @since 3.0.0
 */ module1.exports = "focus";
        /***/ },
        /* 618 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Hidden Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a hidden state. Only browsers that support the Visibility API will cause this event to be emitted.
 * 
 * In most modern browsers, when the document enters a hidden state, the Request Animation Frame and setTimeout, which
 * control the main game loop, will automatically pause. There is no way to stop this from happening. It is something
 * your game should account for in its own code, should the pause be an issue (i.e. for multiplayer games)
 *
 * @event Phaser.Core.Events#HIDDEN
 * @since 3.0.0
 */ module1.exports = "hidden";
        /***/ },
        /* 619 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pause Event.
 * 
 * This event is dispatched when the Game loop enters a paused state, usually as a result of the Visibility Handler.
 *
 * @event Phaser.Core.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = "pause";
        /***/ },
        /* 620 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Render Event.
 * 
 * This event is dispatched right at the end of the render process.
 * 
 * Every Scene will have rendered and been drawn to the canvas by the time this event is fired.
 * Use it for any last minute post-processing before the next game step begins.
 *
 * @event Phaser.Core.Events#POST_RENDER
 * @since 3.0.0
 * 
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = "postrender";
        /***/ },
        /* 621 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Step Event.
 * 
 * This event is dispatched after the Scene Manager has updated.
 * Hook into it from plugins or systems that need to do things before the render starts.
 *
 * @event Phaser.Core.Events#POST_STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "poststep";
        /***/ },
        /* 622 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Render Event.
 * 
 * This event is dispatched immediately before any of the Scenes have started to render.
 * 
 * The renderer will already have been initialized this frame, clearing itself and preparing to receive the Scenes for rendering, but it won't have actually drawn anything yet.
 *
 * @event Phaser.Core.Events#PRE_RENDER
 * @since 3.0.0
 * 
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = "prerender";
        /***/ },
        /* 623 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Step Event.
 * 
 * This event is dispatched before the main Game Step starts. By this point in the game cycle none of the Scene updates have yet happened.
 * Hook into it from plugins or systems that need to update before the Scene Manager does.
 *
 * @event Phaser.Core.Events#PRE_STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "prestep";
        /***/ },
        /* 624 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Ready Event.
 * 
 * This event is dispatched when the Phaser Game instance has finished booting, the Texture Manager is fully ready,
 * and all local systems are now able to start.
 *
 * @event Phaser.Core.Events#READY
 * @since 3.0.0
 */ module1.exports = "ready";
        /***/ },
        /* 625 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Resume Event.
 * 
 * This event is dispatched when the game loop leaves a paused state and resumes running.
 *
 * @event Phaser.Core.Events#RESUME
 * @since 3.0.0
 */ module1.exports = "resume";
        /***/ },
        /* 626 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Step Event.
 * 
 * This event is dispatched after the Game Pre-Step and before the Scene Manager steps.
 * Hook into it from plugins or systems that need to update before the Scene Manager does, but after the core Systems have.
 *
 * @event Phaser.Core.Events#STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "step";
        /***/ },
        /* 627 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Visible Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a visible state, previously having been hidden.
 * 
 * Only browsers that support the Visibility API will cause this event to be emitted.
 *
 * @event Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 */ module1.exports = "visible";
        /***/ },
        /* 628 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Post-Render Event.
 *
 * This event is dispatched by the Renderer when all rendering, for all cameras in all Scenes,
 * has completed, but before any pending snap shots have been taken.
 *
 * @event Phaser.Renderer.Events#POST_RENDER
 * @since 3.50.0
 */ module1.exports = "postrender";
        /***/ },
        /* 629 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pre-Render Event.
 *
 * This event is dispatched by the Phaser Renderer. This happens right at the start of the render
 * process, after the context has been cleared, the scissors enabled (WebGL only) and everything has been
 * reset ready for the render.
 *
 * @event Phaser.Renderer.Events#PRE_RENDER
 * @since 3.50.0
 */ module1.exports = "prerender";
        /***/ },
        /* 630 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Render Event.
 *
 * This event is dispatched by the Phaser Renderer for every camera in every Scene.
 *
 * It is dispatched before any of the children in the Scene have been rendered.
 *
 * @event Phaser.Renderer.Events#RENDER
 * @since 3.50.0
 *
 * @param {Phaser.Scene} scene - The Scene being rendered.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered.
 */ module1.exports = "render";
        /***/ },
        /* 631 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Renderer Resize Event.
 *
 * This event is dispatched by the Phaser Renderer when it is resized, usually as a result
 * of the Scale Manager resizing.
 *
 * @event Phaser.Renderer.Events#RESIZE
 * @since 3.50.0
 *
 * @param {number} width - The new width of the renderer.
 * @param {number} height - The new height of the renderer.
 */ module1.exports = "resize";
        /***/ },
        /* 632 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the origin of a Game Object.
 * Values are normalized, given in the range 0 to 1.
 * Display values contain the calculated pixel values.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Origin
 * @since 3.0.0
 */ var Origin = {
                /**
     * A property indicating that a Game Object has this component.
     *
     * @name Phaser.GameObjects.Components.Origin#_originComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _originComponent: true,
                /**
     * The horizontal origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the left of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Origin#originX
     * @type {number}
     * @default 0.5
     * @since 3.0.0
     */ originX: 0.5,
                /**
     * The vertical origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the top of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Origin#originY
     * @type {number}
     * @default 0.5
     * @since 3.0.0
     */ originY: 0.5,
                //  private + read only
                _displayOriginX: 0,
                _displayOriginY: 0,
                /**
     * The horizontal display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginX
     * @type {number}
     * @since 3.0.0
     */ displayOriginX: {
                    get: function() {
                        return this._displayOriginX;
                    },
                    set: function(value) {
                        this._displayOriginX = value;
                        this.originX = value / this.width;
                    }
                },
                /**
     * The vertical display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginY
     * @type {number}
     * @since 3.0.0
     */ displayOriginY: {
                    get: function() {
                        return this._displayOriginY;
                    },
                    set: function(value) {
                        this._displayOriginY = value;
                        this.originY = value / this.height;
                    }
                },
                /**
     * Sets the origin of this Game Object.
     *
     * The values are given in the range 0 to 1.
     *
     * @method Phaser.GameObjects.Components.Origin#setOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setOrigin: function(x, y) {
                    if (x === undefined) x = 0.5;
                    if (y === undefined) y = x;
                    this.originX = x;
                    this.originY = y;
                    return this.updateDisplayOrigin();
                },
                /**
     * Sets the origin of this Game Object based on the Pivot values in its Frame.
     *
     * @method Phaser.GameObjects.Components.Origin#setOriginFromFrame
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ setOriginFromFrame: function() {
                    if (!this.frame || !this.frame.customPivot) return this.setOrigin();
                    else {
                        this.originX = this.frame.pivotX;
                        this.originY = this.frame.pivotY;
                    }
                    return this.updateDisplayOrigin();
                },
                /**
     * Sets the display origin of this Game Object.
     * The difference between this and setting the origin is that you can use pixel values for setting the display origin.
     *
     * @method Phaser.GameObjects.Components.Origin#setDisplayOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal display origin value.
     * @param {number} [y=x] - The vertical display origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setDisplayOrigin: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.displayOriginX = x;
                    this.displayOriginY = y;
                    return this;
                },
                /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.Components.Origin#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                    this._displayOriginX = this.originX * this.width;
                    this._displayOriginY = this.originY * this.height;
                    return this;
                }
            };
            module1.exports = Origin;
        /***/ },
        /* 633 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(36);
            var GetBoolean = __webpack_require__(99);
            var GetValue = __webpack_require__(6);
            var TWEEN_CONST = __webpack_require__(100);
            var Vector2 = __webpack_require__(3);
            /**
 * Provides methods used for managing a Game Object following a Path.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.PathFollower
 * @since 3.17.0
 */ var PathFollower = {
                /**
     * The Path this PathFollower is following. It can only follow one Path at a time.
     *
     * @name Phaser.GameObjects.Components.PathFollower#path
     * @type {Phaser.Curves.Path}
     * @since 3.0.0
     */ path: null,
                /**
     * Should the PathFollower automatically rotate to point in the direction of the Path?
     *
     * @name Phaser.GameObjects.Components.PathFollower#rotateToPath
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ rotateToPath: false,
                /**
     * If the PathFollower is rotating to match the Path (@see Phaser.GameObjects.PathFollower#rotateToPath)
     * this value is added to the rotation value. This allows you to rotate objects to a path but control
     * the angle of the rotation as well.
     *
     * @name Phaser.GameObjects.PathFollower#pathRotationOffset
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ pathRotationOffset: 0,
                /**
     * An additional vector to add to the PathFollowers position, allowing you to offset it from the
     * Path coordinates.
     *
     * @name Phaser.GameObjects.PathFollower#pathOffset
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathOffset: null,
                /**
     * A Vector2 that stores the current point of the path the follower is on.
     *
     * @name Phaser.GameObjects.PathFollower#pathVector
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathVector: null,
                /**
     * The distance the follower has traveled from the previous point to the current one, at the last update.
     *
     * @name Phaser.GameObjects.PathFollower#pathDelta
     * @type {Phaser.Math.Vector2}
     * @since 3.23.0
     */ pathDelta: null,
                /**
     * The Tween used for following the Path.
     *
     * @name Phaser.GameObjects.PathFollower#pathTween
     * @type {Phaser.Tweens.Tween}
     * @since 3.0.0
     */ pathTween: null,
                /**
     * Settings for the PathFollower.
     *
     * @name Phaser.GameObjects.PathFollower#pathConfig
     * @type {?Phaser.Types.GameObjects.PathFollower.PathConfig}
     * @default null
     * @since 3.0.0
     */ pathConfig: null,
                /**
     * Records the direction of the follower so it can change direction.
     *
     * @name Phaser.GameObjects.PathFollower#_prevDirection
     * @type {number}
     * @private
     * @since 3.0.0
     */ _prevDirection: TWEEN_CONST.PLAYING_FORWARD,
                /**
     * Set the Path that this PathFollower should follow.
     *
     * Optionally accepts {@link Phaser.Types.GameObjects.PathFollower.PathConfig} settings.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setPath
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config] - Settings for the PathFollower.
     *
     * @return {this} This Game Object.
     */ setPath: function(path, config) {
                    if (config === undefined) config = this.pathConfig;
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    this.path = path;
                    if (config) this.startFollow(config);
                    return this;
                },
                /**
     * Set whether the PathFollower should automatically rotate to point in the direction of the Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setRotateToPath
     * @since 3.0.0
     *
     * @param {boolean} value - Whether the PathFollower should automatically rotate to point in the direction of the Path.
     * @param {number} [offset=0] - Rotation offset in degrees.
     *
     * @return {this} This Game Object.
     */ setRotateToPath: function(value, offset) {
                    if (offset === undefined) offset = 0;
                    this.rotateToPath = value;
                    this.pathRotationOffset = offset;
                    return this;
                },
                /**
     * Is this PathFollower actively following a Path or not?
     *
     * To be considered as `isFollowing` it must be currently moving on a Path, and not paused.
     *
     * @method Phaser.GameObjects.Components.PathFollower#isFollowing
     * @since 3.0.0
     *
     * @return {boolean} `true` is this PathFollower is actively following a Path, otherwise `false`.
     */ isFollowing: function() {
                    var tween = this.pathTween;
                    return tween && tween.isPlaying();
                },
                /**
     * Starts this PathFollower following its given Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#startFollow
     * @since 3.3.0
     *
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config={}] - The duration of the follow, or a PathFollower config object.
     * @param {number} [startAt=0] - Optional start position of the follow, between 0 and 1.
     *
     * @return {this} This Game Object.
     */ startFollow: function(config, startAt) {
                    if (config === undefined) config = {};
                    if (startAt === undefined) startAt = 0;
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    if (typeof config === "number") config = {
                        duration: config
                    };
                    //  Override in case they've been specified in the config
                    config.from = GetValue(config, "from", 0);
                    config.to = GetValue(config, "to", 1);
                    var positionOnPath = GetBoolean(config, "positionOnPath", false);
                    this.rotateToPath = GetBoolean(config, "rotateToPath", false);
                    this.pathRotationOffset = GetValue(config, "rotationOffset", 0);
                    //  This works, but it's not an ideal way of doing it as the follower jumps position
                    var seek = GetValue(config, "startAt", startAt);
                    if (seek) config.onStart = function(tween) {
                        var tweenData = tween.data[0];
                        tweenData.progress = seek;
                        tweenData.elapsed = tweenData.duration * seek;
                        var v = tweenData.ease(tweenData.progress);
                        tweenData.current = tweenData.start + (tweenData.end - tweenData.start) * v;
                        tweenData.target[tweenData.key] = tweenData.current;
                    };
                    if (!this.pathOffset) this.pathOffset = new Vector2(this.x, this.y);
                    if (!this.pathVector) this.pathVector = new Vector2();
                    if (!this.pathDelta) this.pathDelta = new Vector2();
                    this.pathDelta.reset();
                    this.pathTween = this.scene.sys.tweens.addCounter(config);
                    //  The starting point of the path, relative to this follower
                    this.path.getStartPoint(this.pathOffset);
                    if (positionOnPath) {
                        this.x = this.pathOffset.x;
                        this.y = this.pathOffset.y;
                    }
                    this.pathOffset.x = this.x - this.pathOffset.x;
                    this.pathOffset.y = this.y - this.pathOffset.y;
                    this._prevDirection = TWEEN_CONST.PLAYING_FORWARD;
                    if (this.rotateToPath) {
                        //  Set the rotation now (in case the tween has a delay on it, etc)
                        var nextPoint = this.path.getPoint(0.1);
                        this.rotation = Math.atan2(nextPoint.y - this.y, nextPoint.x - this.x) + DegToRad(this.pathRotationOffset);
                    }
                    this.pathConfig = config;
                    return this;
                },
                /**
     * Pauses this PathFollower. It will still continue to render, but it will remain motionless at the
     * point on the Path at which you paused it.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pauseFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ pauseFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.pause();
                    return this;
                },
                /**
     * Resumes a previously paused PathFollower.
     *
     * If the PathFollower was not paused this has no effect.
     *
     * @method Phaser.GameObjects.Components.PathFollower#resumeFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ resumeFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPaused()) tween.resume();
                    return this;
                },
                /**
     * Stops this PathFollower from following the path any longer.
     *
     * This will invoke any 'stop' conditions that may exist on the Path, or for the follower.
     *
     * @method Phaser.GameObjects.Components.PathFollower#stopFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ stopFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    return this;
                },
                /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pathUpdate
     * @since 3.17.0
     */ pathUpdate: function() {
                    var tween = this.pathTween;
                    if (tween) {
                        var tweenData = tween.data[0];
                        var pathDelta = this.pathDelta;
                        var pathVector = this.pathVector;
                        pathDelta.copy(pathVector).negate();
                        if (tweenData.state === TWEEN_CONST.COMPLETE) {
                            this.path.getPoint(1, pathVector);
                            pathDelta.add(pathVector);
                            pathVector.add(this.pathOffset);
                            this.setPosition(pathVector.x, pathVector.y);
                            return;
                        } else if (tweenData.state !== TWEEN_CONST.PLAYING_FORWARD && tweenData.state !== TWEEN_CONST.PLAYING_BACKWARD) //  If delayed, etc then bail out
                        return;
                        this.path.getPoint(tween.getValue(), pathVector);
                        pathDelta.add(pathVector);
                        pathVector.add(this.pathOffset);
                        var oldX = this.x;
                        var oldY = this.y;
                        this.setPosition(pathVector.x, pathVector.y);
                        var speedX = this.x - oldX;
                        var speedY = this.y - oldY;
                        if (speedX === 0 && speedY === 0) //  Bail out early
                        return;
                        if (tweenData.state !== this._prevDirection) {
                            //  We've changed direction, so don't do a rotate this frame
                            this._prevDirection = tweenData.state;
                            return;
                        }
                        if (this.rotateToPath) this.rotation = Math.atan2(speedY, speedX) + DegToRad(this.pathRotationOffset);
                    }
                }
            };
            module1.exports = PathFollower;
        /***/ },
        /* 634 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the size of a Game Object.
 * 
 * @namespace Phaser.GameObjects.Components.Size
 * @since 3.0.0
 */ var Size = {
                /**
     * A property indicating that a Game Object has this component.
     * 
     * @name Phaser.GameObjects.Components.Size#_sizeComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _sizeComponent: true,
                /**
     * The native (un-scaled) width of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     * 
     * @name Phaser.GameObjects.Components.Size#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                /**
     * The native (un-scaled) height of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     * 
     * @name Phaser.GameObjects.Components.Size#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                /**
     * The displayed width of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.Size#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return Math.abs(this.scaleX * this.frame.realWidth);
                    },
                    set: function(value) {
                        this.scaleX = value / this.frame.realWidth;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.Size#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return Math.abs(this.scaleY * this.frame.realHeight);
                    },
                    set: function(value) {
                        this.scaleY = value / this.frame.realHeight;
                    }
                },
                /**
     * Sets the size of this Game Object to be that of the given Frame.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.Size#setSizeToFrame
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Frame} frame - The frame to base the size of this Game Object on.
     * 
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function(frame) {
                    if (frame === undefined) frame = this.frame;
                    this.width = frame.realWidth;
                    this.height = frame.realHeight;
                    return this;
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.Size#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * 
     * Calling this will adjust the scale.
     * 
     * @method Phaser.GameObjects.Components.Size#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                }
            };
            module1.exports = Size;
        /***/ },
        /* 635 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Texture
 * @since 3.0.0
 */ var Texture = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * Internal flag. Not to be set by this Game Object.
     *
     * @name Phaser.GameObjects.Components.Texture#isCropped
     * @type {boolean}
     * @private
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Components.Texture#setTexture
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the texture to be used, as stored in the Texture Manager, or a Texture instance.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.Texture#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                    if (updateSize === undefined) updateSize = true;
                    if (updateOrigin === undefined) updateOrigin = true;
                    this.frame = this.texture.get(frame);
                    if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    if (this._sizeComponent && updateSize) this.setSizeToFrame();
                    if (this._originComponent && updateOrigin) {
                        if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                        else this.updateDisplayOrigin();
                    }
                    return this;
                }
            };
            module1.exports = Texture;
        /***/ },
        /* 636 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.TextureCrop
 * @since 3.0.0
 */ var TextureCrop = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     *
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     *
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     *
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     *
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     *
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rect of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     *
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     *
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     *
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from.
     * @param {number} [width] - The width of the crop rectangle in pixels.
     * @param {number} [height] - The height of the crop rectangle in pixels.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                    if (x === undefined) this.isCropped = false;
                    else if (this.frame) {
                        if (typeof x === "number") this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                        else {
                            var rect = x;
                            this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                        }
                        this.isCropped = true;
                    }
                    return this;
                },
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                    if (updateSize === undefined) updateSize = true;
                    if (updateOrigin === undefined) updateOrigin = true;
                    this.frame = this.texture.get(frame);
                    if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    if (this._sizeComponent && updateSize) this.setSizeToFrame();
                    if (this._originComponent && updateOrigin) {
                        if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                        else this.updateDisplayOrigin();
                    }
                    if (this.isCropped) this.frame.updateCropUVs(this._crop, this.flipX, this.flipY);
                    return this;
                },
                /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#resetCropObject
     * @private
     * @since 3.12.0
     *
     * @return {object} The crop object.
     */ resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: false,
                        flipY: false,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            module1.exports = TextureCrop;
        /***/ },
        /* 637 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the tint of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Tint
 * @webglOnly
 * @since 3.0.0
 */ var Tint = {
                /**
     * The tint value being applied to the top-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopLeft: 0xffffff,
                /**
     * The tint value being applied to the top-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopRight: 0xffffff,
                /**
     * The tint value being applied to the bottom-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomLeft: 0xffffff,
                /**
     * The tint value being applied to the bottom-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomRight: 0xffffff,
                /**
     * The tint fill mode.
     *
     * `false` = An additive tint (the default), where vertices colors are blended with the texture.
     * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
     *
     * @name Phaser.GameObjects.Components.Tint#tintFill
     * @type {boolean}
     * @default false
     * @since 3.11.0
     */ tintFill: false,
                /**
     * Clears all tint values associated with this Game Object.
     *
     * Immediately sets the color values back to 0xffffff and the tint type to 'additive',
     * which results in no visible change to the texture.
     *
     * @method Phaser.GameObjects.Components.Tint#clearTint
     * @webglOnly
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearTint: function() {
                    this.setTint(0xffffff);
                    return this;
                },
                /**
     * Sets an additive tint on this Game Object.
     *
     * The tint works by taking the pixel color values from the Game Objects texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole Game Object will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being an additive tint to a fill based tint set the property `tintFill` to `true`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTint
     * @webglOnly
     * @since 3.0.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If no other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                    if (topLeft === undefined) topLeft = 0xffffff;
                    if (topRight === undefined) {
                        topRight = topLeft;
                        bottomLeft = topLeft;
                        bottomRight = topLeft;
                    }
                    this.tintTopLeft = topLeft;
                    this.tintTopRight = topRight;
                    this.tintBottomLeft = bottomLeft;
                    this.tintBottomRight = bottomRight;
                    this.tintFill = false;
                    return this;
                },
                /**
     * Sets a fill-based tint on this Game Object.
     *
     * Unlike an additive tint, a fill-tint literally replaces the pixel colors from the texture
     * with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. You can provide either one color value, in which case the whole
     * Game Object will be rendered in that color. Or you can provide a color per corner. The colors
     * are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being a fill-tint to an additive tint set the property `tintFill` to `false`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTintFill
     * @webglOnly
     * @since 3.11.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If not other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(topLeft, topRight, bottomLeft, bottomRight) {
                    this.setTint(topLeft, topRight, bottomLeft, bottomRight);
                    this.tintFill = true;
                    return this;
                },
                /**
     * The tint value being applied to the whole of the Game Object.
     * This property is a setter-only. Use the properties `tintTopLeft` etc to read the current tint value.
     *
     * @name Phaser.GameObjects.Components.Tint#tint
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ tint: {
                    set: function(value) {
                        this.setTint(value, value, value, value);
                    }
                },
                /**
     * Does this Game Object have a tint applied?
     *
     * It checks to see if the 4 tint properties are set to the value 0xffffff
     * and that the `tintFill` property is `false`. This indicates that a Game Object isn't tinted.
     *
     * @name Phaser.GameObjects.Components.Tint#isTinted
     * @type {boolean}
     * @webglOnly
     * @readonly
     * @since 3.11.0
     */ isTinted: {
                    get: function() {
                        var white = 0xffffff;
                        return this.tintFill || this.tintTopLeft !== white || this.tintTopRight !== white || this.tintBottomLeft !== white || this.tintBottomRight !== white;
                    }
                }
            };
            module1.exports = Tint;
        /***/ },
        /* 638 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Event.
 * 
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * a change data event from a Game Object you would use: `sprite.data.on('changedata', listener)`.
 * 
 * This event is dispatched for all items that change in the Data Manager.
 * To listen for the change of a specific item, use the `CHANGE_DATA_KEY_EVENT` event.
 *
 * @event Phaser.Data.Events#CHANGE_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that the Data Manager responsible for this event belongs to.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} value - The new value of the item in the Data Manager.
 * @param {any} previousValue - The previous value of the item in the Data Manager.
 */ module1.exports = "changedata";
        /***/ },
        /* 639 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Key Event.
 * 
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the change of a specific data item from a Game Object you would use: `sprite.data.on('changedata-key', listener)`,
 * where `key` is the unique string key of the data item. For example, if you have a data item stored called `gold`
 * then you can listen for `sprite.data.on('changedata-gold')`.
 *
 * @event Phaser.Data.Events#CHANGE_DATA_KEY
 * @since 3.16.1
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {any} value - The item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 * @param {any} previousValue - The previous item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = "changedata-";
        /***/ },
        /* 640 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Data Manager Destroy Event.
 *
 * The Data Manager will listen for the destroy event from its parent, and then close itself down.
 *
 * @event Phaser.Data.Events#DESTROY
 * @since 3.50.0
 */ module1.exports = "destroy";
        /***/ },
        /* 641 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Data Event.
 * 
 * This event is dispatched by a Data Manager when an item is removed from it.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the removal of a data item on a Game Object you would use: `sprite.data.on('removedata', listener)`.
 *
 * @event Phaser.Data.Events#REMOVE_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was removed from the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = "removedata";
        /***/ },
        /* 642 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Set Data Event.
 * 
 * This event is dispatched by a Data Manager when a new item is added to the data store.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the addition of a new data item on a Game Object you would use: `sprite.data.on('setdata', listener)`.
 *
 * @event Phaser.Data.Events#SET_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was added to the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = "setdata";
        /***/ },
        /* 643 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('addedtoscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#ADDED_TO_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = "addedtoscene";
        /***/ },
        /* 644 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Destroy Event.
 *
 * This event is dispatched when a Game Object instance is being destroyed.
 *
 * Listen for it on a Game Object instance using `GameObject.on('destroy', listener)`.
 *
 * @event Phaser.GameObjects.Events#DESTROY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object which is being destroyed.
 * @param {boolean} fromScene - `True` if this Game Object is being destroyed by the Scene, `false` if not.
 */ module1.exports = "destroy";
        /***/ },
        /* 645 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('removedfromscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#REMOVED_FROM_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = "removedfromscene";
        /***/ },
        /* 646 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Complete Event.
 * 
 * This event is dispatched when a Video finishes playback by reaching the end of its duration. It
 * is also dispatched if a video marker sequence is being played and reaches the end.
 * 
 * Note that not all videos can fire this event. Live streams, for example, have no fixed duration,
 * so never technically 'complete'.
 * 
 * If a video is stopped from playback, via the `Video.stop` method, it will emit the
 * `VIDEO_STOP` event instead of this one.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('complete', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_COMPLETE
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed playback.
 */ module1.exports = "complete";
        /***/ },
        /* 647 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Created Event.
 * 
 * This event is dispatched when the texture for a Video has been created. This happens
 * when enough of the video source has been loaded that the browser is able to render a
 * frame from it.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('created', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_CREATED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 * @param {number} width - The width of the video.
 * @param {number} height - The height of the video.
 */ module1.exports = "created";
        /***/ },
        /* 648 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Error Event.
 * 
 * This event is dispatched when a Video tries to play a source that does not exist, or is the wrong file type.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('error', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_ERROR
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which threw the error.
 * @param {Event} event - The native DOM event the browser raised during playback.
 */ module1.exports = "error";
        /***/ },
        /* 649 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Loop Event.
 * 
 * This event is dispatched when a Video that is currently playing has looped. This only
 * happens if the `loop` parameter was specified, or the `setLoop` method was called,
 * and if the video has a fixed duration. Video streams, for example, cannot loop, as
 * they have no duration.
 * 
 * Looping is based on the result of the Video `timeupdate` event. This event is not
 * frame-accurate, due to the way browsers work, so please do not rely on this loop
 * event to be time or frame precise.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('loop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_LOOP
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which has looped.
 */ module1.exports = "loop";
        /***/ },
        /* 650 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Play Event.
 * 
 * This event is dispatched when a Video begins playback. For videos that do not require
 * interaction unlocking, this is usually as soon as the `Video.play` method is called.
 * However, for videos that require unlocking, it is fired once playback begins after
 * they've been unlocked.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('play', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_PLAY
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started playback.
 */ module1.exports = "play";
        /***/ },
        /* 651 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeked Event.
 * 
 * This event is dispatched when a Video completes seeking to a new point in its timeline.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('seeked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed seeking.
 */ module1.exports = "seeked";
        /***/ },
        /* 652 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeking Event.
 * 
 * This event is dispatched when a Video _begins_ seeking to a new point in its timeline.
 * When the seek is complete, it will dispatch the `VIDEO_SEEKED` event to conclude.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('seeking', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKING
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started seeking.
 */ module1.exports = "seeking";
        /***/ },
        /* 653 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Stopped Event.
 * 
 * This event is dispatched when a Video is stopped from playback via a call to the `Video.stop` method,
 * either directly via game code, or indirectly as the result of changing a video source or destroying it.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('stop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_STOP
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which stopped playback.
 */ module1.exports = "stop";
        /***/ },
        /* 654 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Timeout Event.
 * 
 * This event is dispatched when a Video has exhausted its allocated time while trying to connect to a video
 * source to start playback.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('timeout', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_TIMEOUT
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which timed out.
 */ module1.exports = "timeout";
        /***/ },
        /* 655 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Unlocked Event.
 * 
 * This event is dispatched when a Video that was prevented from playback due to the browsers
 * Media Engagement Interaction policy, is unlocked by a user gesture.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('unlocked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_UNLOCKED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 */ module1.exports = "unlocked";
        /***/ },
        /* 656 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it from a Scene using `this.events.on('addedtoscene', listener)`.
 *
 * @event Phaser.Scenes.Events#ADDED_TO_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = "addedtoscene";
        /***/ },
        /* 657 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Boot Event.
 *
 * This event is dispatched by a Scene during the Scene Systems boot process. Primarily used by Scene Plugins.
 *
 * Listen to it from a Scene using `this.events.on('boot', listener)`.
 *
 * @event Phaser.Scenes.Events#BOOT
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = "boot";
        /***/ },
        /* 658 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Create Event.
 *
 * This event is dispatched by a Scene after it has been created by the Scene Manager.
 *
 * If a Scene has a `create` method then this event is emitted _after_ that has run.
 *
 * If there is a transition, this event will be fired after the `TRANSITION_START` event.
 *
 * Listen to it from a Scene using `this.events.on('create', listener)`.
 *
 * @event Phaser.Scenes.Events#CREATE
 * @since 3.17.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that emitted this event.
 */ module1.exports = "create";
        /***/ },
        /* 659 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Destroy Event.
 *
 * This event is dispatched by a Scene during the Scene Systems destroy process.
 *
 * Listen to it from a Scene using `this.events.on('destroy', listener)`.
 *
 * You should destroy any resources that may be in use by your Scene in this event handler.
 *
 * @event Phaser.Scenes.Events#DESTROY
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = "destroy";
        /***/ },
        /* 660 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pause Event.
 *
 * This event is dispatched by a Scene when it is paused, either directly via the `pause` method, or as an
 * action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('pause', listener)`.
 *
 * @event Phaser.Scenes.Events#PAUSE
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was paused.
 */ module1.exports = "pause";
        /***/ },
        /* 661 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Post Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('postupdate', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#POST_UPDATE
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "postupdate";
        /***/ },
        /* 662 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2021 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pre-Render Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to this event from a Scene using `this.events.on('prerender', listener)`.
 *
 * A Scene will only render if it is visible.
 *
 * This event is dispatched after the Scene Display List is sorted and before the Scene is rendered.
 *
 * @event Phaser.Scenes.Events#PRE_RENDER
 * @since 3.53.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that rendered the Scene.
 */ module1.exports = "prerender";
        /***/ },
        /* 663 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pre Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('preupdate', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#PRE_UPDATE
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "preupdate";
        /***/ },
        /* 664 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Ready Event.
 *
 * This event is dispatched by a Scene during the Scene Systems start process.
 * By this point in the process the Scene is now fully active and rendering.
 * This event is meant for your game code to use, as all plugins have responded to the earlier 'start' event.
 *
 * Listen to it from a Scene using `this.events.on('ready', listener)`.
 *
 * @event Phaser.Scenes.Events#READY
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was started.
 */ module1.exports = "ready";
        /***/ },
        /* 665 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it from a Scene using `this.events.on('removedfromscene', listener)`.
 *
 * @event Phaser.Scenes.Events#REMOVED_FROM_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = "removedfromscene";
        /***/ },
        /* 666 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Render Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('render', listener)`.
 *
 * A Scene will only render if it is visible.
 *
 * By the time this event is dispatched, the Scene will have already been rendered.
 *
 * @event Phaser.Scenes.Events#RENDER
 * @since 3.0.0
 *
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that rendered the Scene.
 */ module1.exports = "render";
        /***/ },
        /* 667 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Resume Event.
 *
 * This event is dispatched by a Scene when it is resumed from a paused state, either directly via the `resume` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('resume', listener)`.
 *
 * @event Phaser.Scenes.Events#RESUME
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was resumed.
 */ module1.exports = "resume";
        /***/ },
        /* 668 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Shutdown Event.
 *
 * This event is dispatched by a Scene during the Scene Systems shutdown process.
 *
 * Listen to it from a Scene using `this.events.on('shutdown', listener)`.
 *
 * You should free-up any resources that may be in use by your Scene in this event handler, on the understanding
 * that the Scene may, at any time, become active again. A shutdown Scene is not 'destroyed', it's simply not
 * currently active. Use the [DESTROY]{@linkcode Phaser.Scenes.Events#event:DESTROY} event to completely clear resources.
 *
 * @event Phaser.Scenes.Events#SHUTDOWN
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was shutdown.
 */ module1.exports = "shutdown";
        /***/ },
        /* 669 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Sleep Event.
 *
 * This event is dispatched by a Scene when it is sent to sleep, either directly via the `sleep` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('sleep', listener)`.
 *
 * @event Phaser.Scenes.Events#SLEEP
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was sent to sleep.
 */ module1.exports = "sleep";
        /***/ },
        /* 670 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Start Event.
 *
 * This event is dispatched by a Scene during the Scene Systems start process. Primarily used by Scene Plugins.
 *
 * Listen to it from a Scene using `this.events.on('start', listener)`.
 *
 * @event Phaser.Scenes.Events#START
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = "start";
        /***/ },
        /* 671 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Complete Event.
 *
 * This event is dispatched by the Target Scene of a transition.
 *
 * It happens when the transition process has completed. This occurs when the duration timer equals or exceeds the duration
 * of the transition.
 *
 * Listen to it from a Scene using `this.events.on('transitioncomplete', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_COMPLETE
 * @since 3.5.0
 *
 * @param {Phaser.Scene} scene -The Scene on which the transitioned completed.
 */ module1.exports = "transitioncomplete";
        /***/ },
        /* 672 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Init Event.
 *
 * This event is dispatched by the Target Scene of a transition.
 *
 * It happens immediately after the `Scene.init` method is called. If the Scene does not have an `init` method,
 * this event is not dispatched.
 *
 * Listen to it from a Scene using `this.events.on('transitioninit', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_INIT
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = "transitioninit";
        /***/ },
        /* 673 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Out Event.
 *
 * This event is dispatched by a Scene when it initiates a transition to another Scene.
 *
 * Listen to it from a Scene using `this.events.on('transitionout', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_OUT
 * @since 3.5.0
 *
 * @param {Phaser.Scene} target - A reference to the Scene that is being transitioned to.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = "transitionout";
        /***/ },
        /* 674 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Start Event.
 *
 * This event is dispatched by the Target Scene of a transition, only if that Scene was not asleep.
 *
 * It happens immediately after the `Scene.create` method is called. If the Scene does not have a `create` method,
 * this event is dispatched anyway.
 *
 * If the Target Scene was sleeping then the [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} event is
 * dispatched instead of this event.
 *
 * Listen to it from a Scene using `this.events.on('transitionstart', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_START
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = "transitionstart";
        /***/ },
        /* 675 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Wake Event.
 *
 * This event is dispatched by the Target Scene of a transition, only if that Scene was asleep before
 * the transition began. If the Scene was not asleep the [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} event is dispatched instead.
 *
 * Listen to it from a Scene using `this.events.on('transitionwake', listener)`.
 *
 * The Scene Transition event flow is as follows:
 *
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 *
 * @event Phaser.Scenes.Events#TRANSITION_WAKE
 * @since 3.5.0
 *
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = "transitionwake";
        /***/ },
        /* 676 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Update Event.
 *
 * This event is dispatched by a Scene during the main game loop step.
 *
 * The event flow for a single step of a Scene is as follows:
 *
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [PRE_RENDER]{@linkcode Phaser.Scenes.Events#event:PRE_RENDER}
 * 6. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 *
 * Listen to it from a Scene using `this.events.on('update', listener)`.
 *
 * A Scene will only run its step if it is active.
 *
 * @event Phaser.Scenes.Events#UPDATE
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "update";
        /***/ },
        /* 677 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Wake Event.
 *
 * This event is dispatched by a Scene when it is woken from sleep, either directly via the `wake` method,
 * or as an action from another Scene.
 *
 * Listen to it from a Scene using `this.events.on('wake', listener)`.
 *
 * @event Phaser.Scenes.Events#WAKE
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was woken up.
 */ module1.exports = "wake";
        /***/ },
        /* 678 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `alpha` property,
 * and then adds the given value to each of their `alpha` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `alpha` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncAlpha = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "alpha", value, step, index, direction);
            };
            module1.exports = IncAlpha;
        /***/ },
        /* 679 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `x` property,
 * and then adds the given value to each of their `x` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `x` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncX = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "x", value, step, index, direction);
            };
            module1.exports = IncX;
        /***/ },
        /* 680 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.IncXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to be added to the `x` property.
 * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncXY = function(items, x, y, stepX, stepY, index, direction) {
                if (y === undefined || y === null) y = x;
                PropertyValueInc(items, "x", x, stepX, index, direction);
                return PropertyValueInc(items, "y", y, stepY, index, direction);
            };
            module1.exports = IncXY;
        /***/ },
        /* 681 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `y` property,
 * and then adds the given value to each of their `y` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `y` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncY = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "y", value, step, index, direction);
            };
            module1.exports = IncY;
        /***/ },
        /* 682 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Circle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnCircle = function(items, circle, startAngle, endAngle) {
                if (startAngle === undefined) startAngle = 0;
                if (endAngle === undefined) endAngle = 6.28;
                var angle = startAngle;
                var angleStep = (endAngle - startAngle) / items.length;
                for(var i = 0; i < items.length; i++){
                    items[i].x = circle.x + circle.radius * Math.cos(angle);
                    items[i].y = circle.y + circle.radius * Math.sin(angle);
                    angle += angleStep;
                }
                return items;
            };
            module1.exports = PlaceOnCircle;
        /***/ },
        /* 683 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of an Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnEllipse = function(items, ellipse, startAngle, endAngle) {
                if (startAngle === undefined) startAngle = 0;
                if (endAngle === undefined) endAngle = 6.28;
                var angle = startAngle;
                var angleStep = (endAngle - startAngle) / items.length;
                var a = ellipse.width / 2;
                var b = ellipse.height / 2;
                for(var i = 0; i < items.length; i++){
                    items[i].x = ellipse.x + a * Math.cos(angle);
                    items[i].y = ellipse.y + b * Math.sin(angle);
                    angle += angleStep;
                }
                return items;
            };
            module1.exports = PlaceOnEllipse;
        /***/ },
        /* 684 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoints = __webpack_require__(172);
            /**
 * Positions an array of Game Objects on evenly spaced points of a Line.
 *
 * @function Phaser.Actions.PlaceOnLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects on.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnLine = function(items, line) {
                var points = GetPoints(line, items.length);
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    var point = points[i];
                    item.x = point.x;
                    item.y = point.y;
                }
                return items;
            };
            module1.exports = PlaceOnLine;
        /***/ },
        /* 685 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MarchingAnts = __webpack_require__(316);
            var RotateLeft = __webpack_require__(178);
            var RotateRight = __webpack_require__(179);
            /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Rectangle.
 * 
 * Placement starts from the top-left of the rectangle, and proceeds in a clockwise direction.
 * If the `shift` parameter is given you can offset where placement begins.
 *
 * @function Phaser.Actions.PlaceOnRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects on.
 * @param {number} [shift=0] - An optional positional offset.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnRectangle = function(items, rect, shift) {
                if (shift === undefined) shift = 0;
                var points = MarchingAnts(rect, false, items.length);
                if (shift > 0) RotateLeft(points, shift);
                else if (shift < 0) RotateRight(points, Math.abs(shift));
                for(var i = 0; i < items.length; i++){
                    items[i].x = points[i].x;
                    items[i].y = points[i].y;
                }
                return items;
            };
            module1.exports = PlaceOnRectangle;
        /***/ },
        /* 686 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BresenhamPoints = __webpack_require__(317);
            /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the edges of a Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects on.
 * @param {number} [stepRate=1] - An optional step rate, to increase or decrease the packing of the Game Objects on the lines.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnTriangle = function(items, triangle, stepRate) {
                var p1 = BresenhamPoints({
                    x1: triangle.x1,
                    y1: triangle.y1,
                    x2: triangle.x2,
                    y2: triangle.y2
                }, stepRate);
                var p2 = BresenhamPoints({
                    x1: triangle.x2,
                    y1: triangle.y2,
                    x2: triangle.x3,
                    y2: triangle.y3
                }, stepRate);
                var p3 = BresenhamPoints({
                    x1: triangle.x3,
                    y1: triangle.y3,
                    x2: triangle.x1,
                    y2: triangle.y1
                }, stepRate);
                //  Remove overlaps
                p1.pop();
                p2.pop();
                p3.pop();
                p1 = p1.concat(p2, p3);
                var step = p1.length / items.length;
                var p = 0;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    var point = p1[Math.floor(p)];
                    item.x = point.x;
                    item.y = point.y;
                    p += step;
                }
                return items;
            };
            module1.exports = PlaceOnTriangle;
        /***/ },
        /* 687 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Play an animation on all Game Objects in the array that have an Animation component.
 *
 * You can pass either an animation key, or an animation configuration object for more control over the playback.
 *
 * @function Phaser.Actions.PlayAnimation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
 * @param {boolean} [ignoreIfPlaying=false] - If this animation is already playing then ignore this call.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlayAnimation = function(items, key, ignoreIfPlaying) {
                for(var i = 0; i < items.length; i++){
                    var gameObject = items[i];
                    if (gameObject.anims) gameObject.anims.play(key, ignoreIfPlaying);
                }
                return items;
            };
            module1.exports = PlayAnimation;
        /***/ },
        /* 688 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(170);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Circle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomCircle = function(items, circle) {
                for(var i = 0; i < items.length; i++)Random(circle, items[i]);
                return items;
            };
            module1.exports = RandomCircle;
        /***/ },
        /* 689 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(180);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomEllipse = function(items, ellipse) {
                for(var i = 0; i < items.length; i++)Random(ellipse, items[i]);
                return items;
            };
            module1.exports = RandomEllipse;
        /***/ },
        /* 690 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(173);
            /**
 * Takes an array of Game Objects and positions them at random locations on the Line.
 * 
 * If you wish to pass a `Phaser.GameObjects.Line` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects randomly on.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomLine = function(items, line) {
                for(var i = 0; i < items.length; i++)Random(line, items[i]);
                return items;
            };
            module1.exports = RandomLine;
        /***/ },
        /* 691 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(174);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Rectangle.
 *
 * @function Phaser.Actions.RandomRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomRectangle = function(items, rect) {
                for(var i = 0; i < items.length; i++)Random(rect, items[i]);
                return items;
            };
            module1.exports = RandomRectangle;
        /***/ },
        /* 692 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(181);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomTriangle = function(items, triangle) {
                for(var i = 0; i < items.length; i++)Random(triangle, items[i]);
                return items;
            };
            module1.exports = RandomTriangle;
        /***/ },
        /* 693 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `rotation` property,
 * and then adds the given value to each of their `rotation` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Rotate(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `rotation` property (in radians).
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Rotate = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "rotation", value, step, index, direction);
            };
            module1.exports = Rotate;
        /***/ },
        /* 694 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundDistance = __webpack_require__(182);
            var DistanceBetween = __webpack_require__(50);
            /**
 * Rotates each item around the given point by the given angle.
 *
 * @function Phaser.Actions.RotateAround
 * @since 3.0.0
 * @see Phaser.Math.RotateAroundDistance
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAround = function(items, point, angle) {
                var x = point.x;
                var y = point.y;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    RotateAroundDistance(item, x, y, angle, Math.max(1, DistanceBetween(item.x, item.y, x, y)));
                }
                return items;
            };
            module1.exports = RotateAround;
        /***/ },
        /* 695 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathRotateAroundDistance = __webpack_require__(182);
            /**
 * Rotates an array of Game Objects around a point by the given angle and distance.
 *
 * @function Phaser.Actions.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 * @param {number} distance - The distance from the point of rotation in pixels.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAroundDistance = function(items, point, angle, distance) {
                var x = point.x;
                var y = point.y;
                //  There's nothing to do
                if (distance === 0) return items;
                for(var i = 0; i < items.length; i++)MathRotateAroundDistance(items[i], x, y, angle, distance);
                return items;
            };
            module1.exports = RotateAroundDistance;
        /***/ },
        /* 696 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `scaleX` property,
 * and then adds the given value to each of their `scaleX` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleX` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleX = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "scaleX", value, step, index, direction);
            };
            module1.exports = ScaleX;
        /***/ },
        /* 697 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have public `scaleX` and `scaleY` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleXY(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.ScaleXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to be added to the `scaleX` property.
 * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleXY = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                PropertyValueInc(items, "scaleX", scaleX, stepX, index, direction);
                return PropertyValueInc(items, "scaleY", scaleY, stepY, index, direction);
            };
            module1.exports = ScaleXY;
        /***/ },
        /* 698 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(46);
            /**
 * Takes an array of Game Objects, or any objects that have a public `scaleY` property,
 * and then adds the given value to each of their `scaleY` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleY` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleY = function(items, value, step, index, direction) {
                return PropertyValueInc(items, "scaleY", value, step, index, direction);
            };
            module1.exports = ScaleY;
        /***/ },
        /* 699 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `alpha`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetAlpha = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "alpha", value, step, index, direction);
            };
            module1.exports = SetAlpha;
        /***/ },
        /* 700 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `blendMode`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetBlendMode(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetBlendMode
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetBlendMode = function(items, value, index, direction) {
                return PropertyValueSet(items, "blendMode", value, 0, index, direction);
            };
            module1.exports = SetBlendMode;
        /***/ },
        /* 701 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `depth`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetDepth(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetDepth
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetDepth = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "depth", value, step, index, direction);
            };
            module1.exports = SetDepth;
        /***/ },
        /* 702 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes all provided Game Objects to the Input Manager to enable them for input with identical areas and callbacks.
 * 
 * @see {@link Phaser.GameObjects.GameObject#setInteractive}
 *
 * @function Phaser.Actions.SetHitArea
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {*} hitArea - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
 * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetHitArea = function(items, hitArea, hitAreaCallback) {
                for(var i = 0; i < items.length; i++)items[i].setInteractive(hitArea, hitAreaCallback);
                return items;
            };
            module1.exports = SetHitArea;
        /***/ },
        /* 703 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `originX` and `originY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetOrigin(group.getChildren(), originX, originY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetOrigin
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} originX - The amount to set the `originX` property to.
 * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
 * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetOrigin = function(items, originX, originY, stepX, stepY, index, direction) {
                if (originY === undefined || originY === null) originY = originX;
                PropertyValueSet(items, "originX", originX, stepX, index, direction);
                PropertyValueSet(items, "originY", originY, stepY, index, direction);
                items.forEach(function(item) {
                    item.updateDisplayOrigin();
                });
                return items;
            };
            module1.exports = SetOrigin;
        /***/ },
        /* 704 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `rotation`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetRotation(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetRotation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetRotation = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "rotation", value, step, index, direction);
            };
            module1.exports = SetRotation;
        /***/ },
        /* 705 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `scaleX` and `scaleY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScale(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScale
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to set the `scaleX` property to.
 * @param {number} [scaleY] - The amount to set the `scaleY` property to. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScale = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                PropertyValueSet(items, "scaleX", scaleX, stepX, index, direction);
                return PropertyValueSet(items, "scaleY", scaleY, stepY, index, direction);
            };
            module1.exports = SetScale;
        /***/ },
        /* 706 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "scaleX", value, step, index, direction);
            };
            module1.exports = SetScaleX;
        /***/ },
        /* 707 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "scaleY", value, step, index, direction);
            };
            module1.exports = SetScaleY;
        /***/ },
        /* 708 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `scrollFactorX` and `scrollFactorY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactor(group.getChildren(), scrollFactorX, scrollFactorY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScrollFactor
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scrollFactorX - The amount to set the `scrollFactorX` property to.
 * @param {number} [scrollFactorY] - The amount to set the `scrollFactorY` property to. If `undefined` or `null` it uses the `scrollFactorX` value.
 * @param {number} [stepX=0] - This is added to the `scrollFactorX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scrollFactorY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactor = function(items, scrollFactorX, scrollFactorY, stepX, stepY, index, direction) {
                if (scrollFactorY === undefined || scrollFactorY === null) scrollFactorY = scrollFactorX;
                PropertyValueSet(items, "scrollFactorX", scrollFactorX, stepX, index, direction);
                return PropertyValueSet(items, "scrollFactorY", scrollFactorY, stepY, index, direction);
            };
            module1.exports = SetScrollFactor;
        /***/ },
        /* 709 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorX
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "scrollFactorX", value, step, index, direction);
            };
            module1.exports = SetScrollFactorX;
        /***/ },
        /* 710 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorY
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "scrollFactorY", value, step, index, direction);
            };
            module1.exports = SetScrollFactorY;
        /***/ },
        /* 711 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have the public method setTint() and then updates it to the given value(s). You can specify tint color per corner or provide only one color value for `topLeft` parameter, in which case whole item will be tinted with that color.
 *
 * @function Phaser.Actions.SetTint
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
 * @param {number} [topRight] - The tint to be applied to top-right corner of item.
 * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
 * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetTint = function(items, topLeft, topRight, bottomLeft, bottomRight) {
                for(var i = 0; i < items.length; i++)items[i].setTint(topLeft, topRight, bottomLeft, bottomRight);
                return items;
            };
            module1.exports = SetTint;
        /***/ },
        /* 712 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `visible`
 * and then sets it to the given value.
 *
 * To use this with a Group: `SetVisible(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {boolean} value - The value to set the property to.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetVisible = function(items, value, index, direction) {
                return PropertyValueSet(items, "visible", value, 0, index, direction);
            };
            module1.exports = SetVisible;
        /***/ },
        /* 713 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `x`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "x", value, step, index, direction);
            };
            module1.exports = SetX;
        /***/ },
        /* 714 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `x` and `y`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.SetXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to set the `x` property to.
 * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetXY = function(items, x, y, stepX, stepY, index, direction) {
                if (y === undefined || y === null) y = x;
                PropertyValueSet(items, "x", x, stepX, index, direction);
                return PropertyValueSet(items, "y", y, stepY, index, direction);
            };
            module1.exports = SetXY;
        /***/ },
        /* 715 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `y`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, "y", value, step, index, direction);
            };
            module1.exports = SetY;
        /***/ },
        /* 716 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Iterate through the items array changing the position of each element to be that of the element that came before
 * it in the array (or after it if direction = 1)
 * 
 * The first items position is set to x/y.
 * 
 * The final x/y coords are returned
 *
 * @function Phaser.Actions.ShiftPosition
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 * @generic {Phaser.Math.Vector2} O - [output,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {number} x - The x coordinate to place the first item in the array at.
 * @param {number} y - The y coordinate to place the first item in the array at.
 * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
 * @param {(Phaser.Math.Vector2|object)} [output] - An optional objec to store the final objects position in.
 *
 * @return {Phaser.Math.Vector2} The output vector.
 */ var ShiftPosition = function(items, x, y, direction, output) {
                if (direction === undefined) direction = 0;
                if (output === undefined) output = new Vector2();
                var px;
                var py;
                if (items.length > 1) {
                    var i;
                    var cx;
                    var cy;
                    var cur;
                    if (direction === 0) {
                        //  Bottom to Top
                        var len = items.length - 1;
                        px = items[len].x;
                        py = items[len].y;
                        for(i = len - 1; i >= 0; i--){
                            //  Current item
                            cur = items[i];
                            //  Get current item x/y, to be passed to the next item in the list
                            cx = cur.x;
                            cy = cur.y;
                            //  Set current item to the previous items x/y
                            cur.x = px;
                            cur.y = py;
                            //  Set current as previous
                            px = cx;
                            py = cy;
                        }
                        //  Update the head item to the new x/y coordinates
                        items[len].x = x;
                        items[len].y = y;
                    } else {
                        //  Top to Bottom
                        px = items[0].x;
                        py = items[0].y;
                        for(i = 1; i < items.length; i++){
                            //  Current item
                            cur = items[i];
                            //  Get current item x/y, to be passed to the next item in the list
                            cx = cur.x;
                            cy = cur.y;
                            //  Set current item to the previous items x/y
                            cur.x = px;
                            cur.y = py;
                            //  Set current as previous
                            px = cx;
                            py = cy;
                        }
                        //  Update the head item to the new x/y coordinates
                        items[0].x = x;
                        items[0].y = y;
                    }
                } else {
                    px = items[0].x;
                    py = items[0].y;
                    items[0].x = x;
                    items[0].y = y;
                }
                //  Return the final set of coordinates as they're effectively lost from the shift and may be needed
                output.x = px;
                output.y = py;
                return output;
            };
            module1.exports = ShiftPosition;
        /***/ },
        /* 717 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayShuffle = __webpack_require__(131);
            /**
 * Shuffles the array in place. The shuffled array is both modified and returned.
 *
 * @function Phaser.Actions.Shuffle
 * @since 3.0.0
 * @see Phaser.Utils.Array.Shuffle
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var Shuffle = function(items) {
                return ArrayShuffle(items);
            };
            module1.exports = Shuffle;
        /***/ },
        /* 718 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmootherStep = __webpack_require__(183);
            /**
 * Smootherstep is a sigmoid-like interpolation and clamping function.
 * 
 * The function depends on three parameters, the input x, the "left edge" and the "right edge", with the left edge being assumed smaller than the right edge. The function receives a real number x as an argument and returns 0 if x is less than or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the smoothstep function is zero at both edges. This is convenient for creating a sequence of transitions using smoothstep to interpolate each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmootherStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmootherStep = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmootherStep(i * step, min, max);
                else for(i = 0; i < items.length; i++)items[i][property] = MathSmootherStep(i * step, min, max);
                return items;
            };
            module1.exports = SmootherStep;
        /***/ },
        /* 719 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmoothStep = __webpack_require__(184);
            /**
 * Smoothstep is a sigmoid-like interpolation and clamping function.
 * 
 * The function depends on three parameters, the input x, the "left edge" and the "right edge", with the left edge being assumed smaller than the right edge. The function receives a real number x as an argument and returns 0 if x is less than or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the smoothstep function is zero at both edges. This is convenient for creating a sequence of transitions using smoothstep to interpolate each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmoothStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmoothStep = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmoothStep(i * step, min, max);
                else for(i = 0; i < items.length; i++)items[i][property] = MathSmoothStep(i * step, min, max);
                return items;
            };
            module1.exports = SmoothStep;
        /***/ },
        /* 720 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and then modifies their `property` so the value equals, or is incremented, by the
 * calculated spread value.
 * 
 * The spread value is derived from the given `min` and `max` values and the total number of items in the array.
 * 
 * For example, to cause an array of Sprites to change in alpha from 0 to 1 you could call:
 * 
 * ```javascript
 * Phaser.Actions.Spread(itemsArray, 'alpha', 0, 1);
 * ```
 *
 * @function Phaser.Actions.Spread
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to spread.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that were passed to this Action.
 */ var Spread = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += i * step + min;
                else for(i = 0; i < items.length; i++)items[i][property] = i * step + min;
                return items;
            };
            module1.exports = Spread;
        /***/ },
        /* 721 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and toggles the visibility of each one.
 * Those previously `visible = false` will become `visible = true`, and vice versa.
 *
 * @function Phaser.Actions.ToggleVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var ToggleVisible = function(items) {
                for(var i = 0; i < items.length; i++)items[i].visible = !items[i].visible;
                return items;
            };
            module1.exports = ToggleVisible;
        /***/ },
        /* 722 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       samme <samme.npm@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(68);
            /**
 * Wrap each item's coordinates within a rectangle's area.
 *
 * @function Phaser.Actions.WrapInRectangle
 * @since 3.0.0
 * @see Phaser.Math.Wrap
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
 * @param {number} [padding=0] - An amount added to each side of the rectangle during the operation.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var WrapInRectangle = function(items, rect, padding) {
                if (padding === undefined) padding = 0;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    item.x = Wrap(item.x, rect.left - padding, rect.right + padding);
                    item.y = Wrap(item.y, rect.top - padding, rect.bottom + padding);
                }
                return items;
            };
            module1.exports = WrapInRectangle;
        /***/ },
        /* 723 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations
 */ module1.exports = {
                Animation: __webpack_require__(185),
                AnimationFrame: __webpack_require__(319),
                AnimationManager: __webpack_require__(321),
                AnimationState: __webpack_require__(164),
                Events: __webpack_require__(132)
            };
        /***/ },
        /* 724 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Add Animation Event.
 * 
 * This event is dispatched when a new animation is added to the global Animation Manager.
 * 
 * This can happen either as a result of an animation instance being added to the Animation Manager,
 * or the Animation Manager creating a new animation directly.
 *
 * @event Phaser.Animations.Events#ADD_ANIMATION
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Animation that was added to the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the newly created Animation.
 */ module1.exports = "add";
        /***/ },
        /* 725 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * Listen for it on the Sprite using `sprite.on('animationcomplete', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationcomplete";
        /***/ },
        /* 726 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Dynamic Key Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * The difference between this and the `ANIMATION_COMPLETE` event is that this one has a
 * dynamic event name that contains the name of the animation within it. For example,
 * if you had an animation called `explode` you could listen for the completion of that
 * specific animation by using: `sprite.on('animationcomplete-explode', listener)`. Or, if you
 * wish to use types: `sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'explode', listener)`.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE_KEY
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationcomplete-";
        /***/ },
        /* 727 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Repeat Event.
 *
 * This event is dispatched by a Sprite when an animation repeats playing on it.
 * This happens if the animation was created, or played, with a `repeat` value specified.
 *
 * An animation will repeat when it reaches the end of its sequence.
 *
 * Listen for it on the Sprite using `sprite.on('animationrepeat', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_REPEAT
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has repeated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation repeated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationrepeat";
        /***/ },
        /* 728 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Restart Event.
 *
 * This event is dispatched by a Sprite when an animation restarts playing on it.
 * This only happens when the `Sprite.anims.restart` method is called.
 *
 * Listen for it on the Sprite using `sprite.on('animationrestart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_RESTART
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has restarted.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation restarted.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationrestart";
        /***/ },
        /* 729 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Start Event.
 *
 * This event is dispatched by a Sprite when an animation starts playing on it.
 * This happens when the animation is played, factoring in any delay that may have been specified.
 * This event happens after the delay has expired and prior to the first update event.
 *
 * Listen for it on the Sprite using `sprite.on('animationstart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_START
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has started.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation started.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationstart";
        /***/ },
        /* 730 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Stop Event.
 *
 * This event is dispatched by a Sprite when an animation is stopped on it. An animation
 * will only be stopeed if a method such as `Sprite.stop` or `Sprite.anims.stopAfterDelay`
 * is called. It can also be emitted if a new animation is started before the current one completes.
 *
 * Listen for it on the Sprite using `sprite.on('animationstop', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_STOP
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has stopped.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation stopped.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationstop";
        /***/ },
        /* 731 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Update Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it updates. This happens when the animation changes frame.
 * An animation will change frame based on the frme rate and other factors like `timeScale` and `delay`. It can also change
 * frame when stopped or restarted.
 *
 * Listen for it on the Sprite using `sprite.on('animationupdate', listener)`
 *
 * If an animation is playing faster than the game frame-rate can handle, it's entirely possible for it to emit several
 * update events in a single game frame, so please be aware of this in your code. The **final** event received that frame
 * is the one that is rendered to the game.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_UPDATE
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has updated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = "animationupdate";
        /***/ },
        /* 732 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Animations Event.
 * 
 * This event is dispatched when the global Animation Manager is told to pause.
 * 
 * When this happens all current animations will stop updating, although it doesn't necessarily mean
 * that the game has paused as well.
 *
 * @event Phaser.Animations.Events#PAUSE_ALL
 * @since 3.0.0
 */ module1.exports = "pauseall";
        /***/ },
        /* 733 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Animation Event.
 * 
 * This event is dispatched when an animation is removed from the global Animation Manager.
 *
 * @event Phaser.Animations.Events#REMOVE_ANIMATION
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Animation that was removed from the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the removed Animation.
 */ module1.exports = "remove";
        /***/ },
        /* 734 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Animations Event.
 * 
 * This event is dispatched when the global Animation Manager resumes, having been previously paused.
 * 
 * When this happens all current animations will continue updating again.
 *
 * @event Phaser.Animations.Events#RESUME_ALL
 * @since 3.0.0
 */ module1.exports = "resumeall";
        /***/ },
        /* 735 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache
 */ module1.exports = {
                BaseCache: __webpack_require__(323),
                CacheManager: __webpack_require__(325),
                Events: __webpack_require__(324)
            };
        /***/ },
        /* 736 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Add Event.
 * 
 * This event is dispatched by any Cache that extends the BaseCache each time a new object is added to it.
 *
 * @event Phaser.Cache.Events#ADD
 * @since 3.0.0
 * 
 * @param {Phaser.Cache.BaseCache} cache - The cache to which the object was added.
 * @param {string} key - The key of the object added to the cache.
 * @param {*} object - A reference to the object that was added to the cache.
 */ module1.exports = "add";
        /***/ },
        /* 737 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Remove Event.
 * 
 * This event is dispatched by any Cache that extends the BaseCache each time an object is removed from it.
 *
 * @event Phaser.Cache.Events#REMOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Cache.BaseCache} cache - The cache from which the object was removed.
 * @param {string} key - The key of the object removed from the cache.
 * @param {*} object - A reference to the object that was removed from the cache.
 */ module1.exports = "remove";
        /***/ },
        /* 738 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras
 */ /**
 * @namespace Phaser.Types.Cameras
 */ module1.exports = {
                Controls: __webpack_require__(739),
                Scene2D: __webpack_require__(742)
            };
        /***/ },
        /* 739 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Controls
 */ module1.exports = {
                FixedKeyControl: __webpack_require__(740),
                SmoothedKeyControl: __webpack_require__(741)
            };
        /***/ },
        /* 740 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            /**
 * @classdesc
 * A Fixed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 *
 * ```javascript
 * var camControl = new FixedKeyControl({
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     speed: float OR { x: 0, y: 0 }
 * });
 * ```
 *
 * Movement is precise and has no 'smoothing' applied to it.
 *
 * You must call the `update` method of this controller every frame.
 *
 * @class FixedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.FixedKeyControlConfig} config - The Fixed Key Control configuration object.
 */ var FixedKeyControl = new Class({
                initialize: function FixedKeyControl(config) {
                    /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, "camera", null);
                    /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, "left", null);
                    /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, "right", null);
                    /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, "up", null);
                    /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, "down", null);
                    /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, "zoomIn", null);
                    /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, "zoomOut", null);
                    /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, "zoomSpeed", 0.01);
                    /**
         * The smallest zoom value the camera will reach when zoomed out.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#minZoom
         * @type {number}
         * @default 0.001
         * @since 3.53.0
         */ this.minZoom = GetValue(config, "minZoom", 0.001);
                    /**
         * The largest zoom value the camera will reach when zoomed in.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#maxZoom
         * @type {number}
         * @default 1000
         * @since 3.53.0
         */ this.maxZoom = GetValue(config, "maxZoom", 1000);
                    /**
         * The horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedX = 0;
                    /**
         * The vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedY = 0;
                    var speed = GetValue(config, "speed", null);
                    if (typeof speed === "number") {
                        this.speedX = speed;
                        this.speedY = speed;
                    } else {
                        this.speedX = GetValue(config, "speed.x", 0);
                        this.speedY = GetValue(config, "speed.y", 0);
                    }
                    /**
         * Internal property to track the current zoom level.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                    /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                },
                /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                    this.active = this.camera !== null;
                    return this;
                },
                /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                    this.camera = camera;
                    return this;
                },
                /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                    if (!this.active) return;
                    if (delta === undefined) delta = 1;
                    var cam = this.camera;
                    if (this.up && this.up.isDown) cam.scrollY -= this.speedY * delta | 0;
                    else if (this.down && this.down.isDown) cam.scrollY += this.speedY * delta | 0;
                    if (this.left && this.left.isDown) cam.scrollX -= this.speedX * delta | 0;
                    else if (this.right && this.right.isDown) cam.scrollX += this.speedX * delta | 0;
                    //  Camera zoom
                    if (this.zoomIn && this.zoomIn.isDown) {
                        cam.zoom -= this.zoomSpeed;
                        if (cam.zoom < this.minZoom) cam.zoom = this.minZoom;
                    } else if (this.zoomOut && this.zoomOut.isDown) {
                        cam.zoom += this.zoomSpeed;
                        if (cam.zoom > this.maxZoom) cam.zoom = this.maxZoom;
                    }
                },
                /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.left = null;
                    this.right = null;
                    this.up = null;
                    this.down = null;
                    this.zoomIn = null;
                    this.zoomOut = null;
                }
            });
            module1.exports = FixedKeyControl;
        /***/ },
        /* 741 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            /**
 * @classdesc
 * A Smoothed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 * Unlike the Fixed Camera Control you can also provide physics values for acceleration, drag and maxSpeed for smoothing effects.
 *
 * ```javascript
 * var controlConfig = {
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     up: cursors.up,
 *     down: cursors.down,
 *     zoomIn: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Q),
 *     zoomOut: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.E),
 *     zoomSpeed: 0.02,
 *     acceleration: 0.06,
 *     drag: 0.0005,
 *     maxSpeed: 1.0
 * };
 * ```
 *
 * You must call the `update` method of this controller every frame.
 *
 * @class SmoothedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.SmoothedKeyControlConfig} config - The Smoothed Key Control configuration object.
 */ var SmoothedKeyControl = new Class({
                initialize: function SmoothedKeyControl(config) {
                    /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, "camera", null);
                    /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, "left", null);
                    /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, "right", null);
                    /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, "up", null);
                    /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, "down", null);
                    /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, "zoomIn", null);
                    /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, "zoomOut", null);
                    /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, "zoomSpeed", 0.01);
                    /**
         * The smallest zoom value the camera will reach when zoomed out.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#minZoom
         * @type {number}
         * @default 0.001
         * @since 3.53.0
         */ this.minZoom = GetValue(config, "minZoom", 0.001);
                    /**
         * The largest zoom value the camera will reach when zoomed in.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxZoom
         * @type {number}
         * @default 1000
         * @since 3.53.0
         */ this.maxZoom = GetValue(config, "maxZoom", 1000);
                    /**
         * The horizontal acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelX = 0;
                    /**
         * The vertical acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelY = 0;
                    var accel = GetValue(config, "acceleration", null);
                    if (typeof accel === "number") {
                        this.accelX = accel;
                        this.accelY = accel;
                    } else {
                        this.accelX = GetValue(config, "acceleration.x", 0);
                        this.accelY = GetValue(config, "acceleration.y", 0);
                    }
                    /**
         * The horizontal drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragX = 0;
                    /**
         * The vertical drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragY = 0;
                    var drag = GetValue(config, "drag", null);
                    if (typeof drag === "number") {
                        this.dragX = drag;
                        this.dragY = drag;
                    } else {
                        this.dragX = GetValue(config, "drag.x", 0);
                        this.dragY = GetValue(config, "drag.y", 0);
                    }
                    /**
         * The maximum horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedX = 0;
                    /**
         * The maximum vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedY = 0;
                    var maxSpeed = GetValue(config, "maxSpeed", null);
                    if (typeof maxSpeed === "number") {
                        this.maxSpeedX = maxSpeed;
                        this.maxSpeedY = maxSpeed;
                    } else {
                        this.maxSpeedX = GetValue(config, "maxSpeed.x", 0);
                        this.maxSpeedY = GetValue(config, "maxSpeed.y", 0);
                    }
                    /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedX = 0;
                    /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedY = 0;
                    /**
         * Internal property to track the zoom of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                    /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                },
                /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                    this.active = this.camera !== null;
                    return this;
                },
                /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                    this.camera = camera;
                    return this;
                },
                /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                    if (!this.active) return;
                    if (delta === undefined) delta = 1;
                    var cam = this.camera;
                    //  Apply Deceleration
                    if (this._speedX > 0) {
                        this._speedX -= this.dragX * delta;
                        if (this._speedX < 0) this._speedX = 0;
                    } else if (this._speedX < 0) {
                        this._speedX += this.dragX * delta;
                        if (this._speedX > 0) this._speedX = 0;
                    }
                    if (this._speedY > 0) {
                        this._speedY -= this.dragY * delta;
                        if (this._speedY < 0) this._speedY = 0;
                    } else if (this._speedY < 0) {
                        this._speedY += this.dragY * delta;
                        if (this._speedY > 0) this._speedY = 0;
                    }
                    //  Check for keys
                    if (this.up && this.up.isDown) {
                        this._speedY += this.accelY;
                        if (this._speedY > this.maxSpeedY) this._speedY = this.maxSpeedY;
                    } else if (this.down && this.down.isDown) {
                        this._speedY -= this.accelY;
                        if (this._speedY < -this.maxSpeedY) this._speedY = -this.maxSpeedY;
                    }
                    if (this.left && this.left.isDown) {
                        this._speedX += this.accelX;
                        if (this._speedX > this.maxSpeedX) this._speedX = this.maxSpeedX;
                    } else if (this.right && this.right.isDown) {
                        this._speedX -= this.accelX;
                        if (this._speedX < -this.maxSpeedX) this._speedX = -this.maxSpeedX;
                    }
                    //  Camera zoom
                    if (this.zoomIn && this.zoomIn.isDown) this._zoom = -this.zoomSpeed;
                    else if (this.zoomOut && this.zoomOut.isDown) this._zoom = this.zoomSpeed;
                    else this._zoom = 0;
                    //  Apply to Camera
                    if (this._speedX !== 0) cam.scrollX -= this._speedX * delta | 0;
                    if (this._speedY !== 0) cam.scrollY -= this._speedY * delta | 0;
                    if (this._zoom !== 0) {
                        cam.zoom += this._zoom;
                        if (cam.zoom < this.minZoom) cam.zoom = this.minZoom;
                        else if (cam.zoom > this.maxZoom) cam.zoom = this.maxZoom;
                    }
                },
                /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.left = null;
                    this.right = null;
                    this.up = null;
                    this.down = null;
                    this.zoomIn = null;
                    this.zoomOut = null;
                }
            });
            module1.exports = SmoothedKeyControl;
        /***/ },
        /* 742 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D
 */ module1.exports = {
                Camera: __webpack_require__(326),
                BaseCamera: __webpack_require__(133),
                CameraManager: __webpack_require__(799),
                Effects: __webpack_require__(333),
                Events: __webpack_require__(37)
            };
        /***/ },
        /* 743 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Destroy Camera Event.
 * 
 * This event is dispatched by a Camera instance when it is destroyed by the Camera Manager.
 *
 * @event Phaser.Cameras.Scene2D.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that was destroyed.
 */ module1.exports = "cameradestroy";
        /***/ },
        /* 744 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Fade In Effect completes.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeincomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = "camerafadeincomplete";
        /***/ },
        /* 745 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Start Event.
 * 
 * This event is dispatched by a Camera instance when the Fade In Effect starts.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeinstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = "camerafadeinstart";
        /***/ },
        /* 746 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Fade Out Effect completes.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutcomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = "camerafadeoutcomplete";
        /***/ },
        /* 747 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Start Event.
 * 
 * This event is dispatched by a Camera instance when the Fade Out Effect starts.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = "camerafadeoutstart";
        /***/ },
        /* 748 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Flash Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 */ module1.exports = "cameraflashcomplete";
        /***/ },
        /* 749 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Start Event.
 * 
 * This event is dispatched by a Camera instance when the Flash Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = "cameraflashstart";
        /***/ },
        /* 750 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Follower Update Event.
 *
 * This event is dispatched by a Camera instance when it is following a
 * Game Object and the Camera position has been updated as a result of
 * that following.
 *
 * Listen to it from a Camera instance using: `camera.on('followupdate', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FOLLOW_UPDATE
 * @since 3.50.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that emitted the event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the camera is following.
 */ module1.exports = "followupdate";
        /***/ },
        /* 751 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Pan Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 */ module1.exports = "camerapancomplete";
        /***/ },
        /* 752 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Start Event.
 * 
 * This event is dispatched by a Camera instance when the Pan Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} x - The destination scroll x coordinate.
 * @param {number} y - The destination scroll y coordinate.
 */ module1.exports = "camerapanstart";
        /***/ },
        /* 753 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Post-Render Event.
 * 
 * This event is dispatched by a Camera instance after is has finished rendering.
 * It is only dispatched if the Camera is rendering to a texture.
 * 
 * Listen to it from a Camera instance using: `camera.on('postrender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#POST_RENDER
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that has finished rendering to a texture.
 */ module1.exports = "postrender";
        /***/ },
        /* 754 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pre-Render Event.
 * 
 * This event is dispatched by a Camera instance when it is about to render.
 * It is only dispatched if the Camera is rendering to a texture.
 * 
 * Listen to it from a Camera instance using: `camera.on('prerender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#PRE_RENDER
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that is about to render to a texture.
 */ module1.exports = "prerender";
        /***/ },
        /* 755 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Rotate Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
 * @since 3.23.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 */ module1.exports = "camerarotatecomplete";
        /***/ },
        /* 756 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Start Event.
 * 
 * This event is dispatched by a Camera instance when the Rotate Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_START
 * @since 3.23.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} destination - The destination value.
 */ module1.exports = "camerarotatestart";
        /***/ },
        /* 757 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Shake Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 */ module1.exports = "camerashakecomplete";
        /***/ },
        /* 758 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Start Event.
 * 
 * This event is dispatched by a Camera instance when the Shake Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} intensity - The intensity of the effect.
 */ module1.exports = "camerashakestart";
        /***/ },
        /* 759 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Zoom Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 */ module1.exports = "camerazoomcomplete";
        /***/ },
        /* 760 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Start Event.
 * 
 * This event is dispatched by a Camera instance when the Zoom Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} zoom - The destination zoom value.
 */ module1.exports = "camerazoomstart";
        /***/ },
        /* 761 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(37);
            /**
 * @classdesc
 * A Camera Fade effect.
 *
 * This effect will fade the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is faded. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Fade
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Fade = new Class({
                initialize: function Fade(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * Has this effect finished running?
         *
         * This is different from `isRunning` because it remains set to `true` when the effect is over,
         * until the effect is either reset or started again.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isComplete
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isComplete = false;
                    /**
         * The direction of the fade.
         * `true` = fade out (transparent to color), `false` = fade in (color to transparent)
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#direction
         * @type {boolean}
         * @readonly
         * @since 3.5.0
         */ this.direction = true;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The value of the red color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                    /**
         * The value of the green color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                    /**
         * The value of the blue color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                    /**
         * The value of the alpha channel used during the fade effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#alpha
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.alpha = 0;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFadeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Fades the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#start
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @since 3.5.0
     *
     * @param {boolean} [direction=true] - The direction of the fade. `true` = fade out (transparent to color), `false` = fade in (color to transparent)
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFadeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(direction, duration, red, green, blue, force, callback, context) {
                    if (direction === undefined) direction = true;
                    if (duration === undefined) duration = 1000;
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.isComplete = false;
                    this.duration = duration;
                    this.direction = direction;
                    this.progress = 0;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = direction ? Number.MIN_VALUE : 1;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    var eventName = direction ? Events.FADE_OUT_START : Events.FADE_IN_START;
                    this.camera.emit(eventName, this.camera, this, duration, red, green, blue);
                    return this.camera;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) this.alpha = this.direction ? this.progress : 1 - this.progress;
                    else {
                        this.alpha = this.direction ? 1 : 0;
                        this.effectComplete();
                    }
                },
                /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                    if (!this.isRunning && !this.isComplete) return false;
                    var camera = this.camera;
                    ctx.fillStyle = "rgba(" + this.red + "," + this.green + "," + this.blue + "," + this.alpha + ")";
                    ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                    return true;
                },
                /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                    if (!this.isRunning && !this.isComplete) return false;
                    var camera = this.camera;
                    var red = this.red / 255;
                    var green = this.green / 255;
                    var blue = this.blue / 255;
                    pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                    return true;
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.isComplete = true;
                    var eventName = this.direction ? Events.FADE_OUT_COMPLETE : Events.FADE_IN_COMPLETE;
                    this.camera.emit(eventName, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this.isComplete = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Fade;
        /***/ },
        /* 762 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(37);
            /**
 * @classdesc
 * A Camera Flash effect.
 *
 * This effect will flash the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is flashed. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Flash
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Flash = new Class({
                initialize: function Flash(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The value of the red color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                    /**
         * The value of the green color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                    /**
         * The value of the blue color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                    /**
         * The value of the alpha channel used during the flash effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#alpha
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.alpha = 0;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFlashCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Flashes the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#start
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to flash the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to flash the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to flash the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFlashCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, red, green, blue, force, callback, context) {
                    if (duration === undefined) duration = 250;
                    if (red === undefined) red = 255;
                    if (green === undefined) green = 255;
                    if (blue === undefined) blue = 255;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = 1;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.FLASH_START, this.camera, this, duration, red, green, blue);
                    return this.camera;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) this.alpha = 1 - this.progress;
                    else this.effectComplete();
                },
                /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                    if (!this.isRunning) return false;
                    var camera = this.camera;
                    ctx.fillStyle = "rgba(" + this.red + "," + this.green + "," + this.blue + "," + this.alpha + ")";
                    ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                    return true;
                },
                /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                    if (!this.isRunning) return false;
                    var camera = this.camera;
                    var red = this.red / 255;
                    var green = this.green / 255;
                    var blue = this.blue / 255;
                    pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                    return true;
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.FLASH_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Flash;
        /***/ },
        /* 763 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var EaseMap = __webpack_require__(134);
            var Events = __webpack_require__(37);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera Pan effect.
 *
 * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
 * over the duration and with the ease specified.
 *
 * Only the camera scroll is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Pan
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Pan = new Class({
                initialize: function Pan(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                    /**
         * The starting scroll coordinates to pan the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#source
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.source = new Vector2();
                    /**
         * The constantly updated value based on zoom.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#current
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.current = new Vector2();
                    /**
         * The destination scroll coordinates to pan the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#destination
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.destination = new Vector2();
                    /**
         * The ease function to use during the pan.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraPanCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#start
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(x, y, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source.set(cam.scrollX, cam.scrollY);
                    //  Destination
                    this.destination.set(x, y);
                    //  Zoom factored version
                    cam.getScroll(x, y, this.current);
                    //  Using this ease
                    if (typeof ease === "string" && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === "function") this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.PAN_START, this.camera, this, duration, x, y);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    var progress = Clamp(this._elapsed / this.duration, 0, 1);
                    this.progress = progress;
                    var cam = this.camera;
                    if (this._elapsed < this.duration) {
                        var v = this.ease(progress);
                        cam.getScroll(this.destination.x, this.destination.y, this.current);
                        var x = this.source.x + (this.current.x - this.source.x) * v;
                        var y = this.source.y + (this.current.y - this.source.y) * v;
                        cam.setScroll(x, y);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, x, y);
                    } else {
                        cam.centerOn(this.destination.x, this.destination.y);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, cam.scrollX, cam.scrollY);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.PAN_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#reset
     * @since 3.11.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#destroy
     * @since 3.11.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.source = null;
                    this.destination = null;
                }
            });
            module1.exports = Pan;
        /***/ },
        /* 764 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in.
 *
 * @function Phaser.Math.Easing.Back.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var In = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                return v * v * ((overshoot + 1) * v - overshoot);
            };
            module1.exports = In;
        /***/ },
        /* 765 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-out.
 *
 * @function Phaser.Math.Easing.Back.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                return --v * v * ((overshoot + 1) * v + overshoot) + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 766 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in/out.
 *
 * @function Phaser.Math.Easing.Back.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                var s = overshoot * 1.525;
                if ((v *= 2) < 1) return 0.5 * (v * v * ((s + 1) * v - s));
                else return 0.5 * ((v -= 2) * v * ((s + 1) * v + s) + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 767 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in.
 *
 * @function Phaser.Math.Easing.Bounce.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                v = 1 - v;
                if (v < 1 / 2.75) return 1 - 7.5625 * v * v;
                else if (v < 2 / 2.75) return 1 - (7.5625 * (v -= 1.5 / 2.75) * v + 0.75);
                else if (v < 2.5 / 2.75) return 1 - (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375);
                else return 1 - (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375);
            };
            module1.exports = In;
        /***/ },
        /* 768 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-out.
 *
 * @function Phaser.Math.Easing.Bounce.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                if (v < 1 / 2.75) return 7.5625 * v * v;
                else if (v < 2 / 2.75) return 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                else if (v < 2.5 / 2.75) return 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                else return 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
            };
            module1.exports = Out;
        /***/ },
        /* 769 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in/out.
 *
 * @function Phaser.Math.Easing.Bounce.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                var reverse = false;
                if (v < 0.5) {
                    v = 1 - v * 2;
                    reverse = true;
                } else v = v * 2 - 1;
                if (v < 1 / 2.75) v = 7.5625 * v * v;
                else if (v < 2 / 2.75) v = 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                else if (v < 2.5 / 2.75) v = 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                else v = 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
                if (reverse) return (1 - v) * 0.5;
                else return v * 0.5 + 0.5;
            };
            module1.exports = InOut;
        /***/ },
        /* 770 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in.
 *
 * @function Phaser.Math.Easing.Circular.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return 1 - Math.sqrt(1 - v * v);
            };
            module1.exports = In;
        /***/ },
        /* 771 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-out.
 *
 * @function Phaser.Math.Easing.Circular.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return Math.sqrt(1 - --v * v);
            };
            module1.exports = Out;
        /***/ },
        /* 772 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in/out.
 *
 * @function Phaser.Math.Easing.Circular.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return -0.5 * (Math.sqrt(1 - v * v) - 1);
                else return 0.5 * (Math.sqrt(1 - (v -= 2) * v) + 1);
            };
            module1.exports = InOut;
        /***/ },
        /* 773 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in.
 *
 * @function Phaser.Math.Easing.Cubic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 774 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-out.
 *
 * @function Phaser.Math.Easing.Cubic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return --v * v * v + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 775 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in/out.
 *
 * @function Phaser.Math.Easing.Cubic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v;
                else return 0.5 * ((v -= 2) * v * v + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 776 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in.
 *
 * @function Phaser.Math.Easing.Elastic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var In = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    return -(amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                }
            };
            module1.exports = In;
        /***/ },
        /* 777 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-out.
 *
 * @function Phaser.Math.Easing.Elastic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    return amplitude * Math.pow(2, -10 * v) * Math.sin((v - s) * (2 * Math.PI) / period) + 1;
                }
            };
            module1.exports = Out;
        /***/ },
        /* 778 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in/out.
 *
 * @function Phaser.Math.Easing.Elastic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    if ((v *= 2) < 1) return -0.5 * (amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                    else return amplitude * Math.pow(2, -10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period) * 0.5 + 1;
                }
            };
            module1.exports = InOut;
        /***/ },
        /* 779 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in.
 *
 * @function Phaser.Math.Easing.Expo.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return Math.pow(2, 10 * (v - 1)) - 0.001;
            };
            module1.exports = In;
        /***/ },
        /* 780 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-out.
 *
 * @function Phaser.Math.Easing.Expo.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return 1 - Math.pow(2, -10 * v);
            };
            module1.exports = Out;
        /***/ },
        /* 781 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in/out.
 *
 * @function Phaser.Math.Easing.Expo.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * Math.pow(2, 10 * (v - 1));
                else return 0.5 * (2 - Math.pow(2, -10 * (v - 1)));
            };
            module1.exports = InOut;
        /***/ },
        /* 782 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Linear easing (no variation).
 *
 * @function Phaser.Math.Easing.Linear
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Linear = function(v) {
                return v;
            };
            module1.exports = Linear;
        /***/ },
        /* 783 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in.
 *
 * @function Phaser.Math.Easing.Quadratic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v;
            };
            module1.exports = In;
        /***/ },
        /* 784 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-out.
 *
 * @function Phaser.Math.Easing.Quadratic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return v * (2 - v);
            };
            module1.exports = Out;
        /***/ },
        /* 785 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quadratic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v;
                else return -0.5 * (--v * (v - 2) - 1);
            };
            module1.exports = InOut;
        /***/ },
        /* 786 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in.
 *
 * @function Phaser.Math.Easing.Quartic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 787 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-out.
 *
 * @function Phaser.Math.Easing.Quartic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return 1 - --v * v * v * v;
            };
            module1.exports = Out;
        /***/ },
        /* 788 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quartic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v * v;
                else return -0.5 * ((v -= 2) * v * v * v - 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 789 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in.
 *
 * @function Phaser.Math.Easing.Quintic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 790 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-out.
 *
 * @function Phaser.Math.Easing.Quintic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return --v * v * v * v * v + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 791 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quintic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v * v * v;
                else return 0.5 * ((v -= 2) * v * v * v * v + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 792 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in.
 *
 * @function Phaser.Math.Easing.Sine.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return 1 - Math.cos(v * Math.PI / 2);
            };
            module1.exports = In;
        /***/ },
        /* 793 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-out.
 *
 * @function Phaser.Math.Easing.Sine.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return Math.sin(v * Math.PI / 2);
            };
            module1.exports = Out;
        /***/ },
        /* 794 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in/out.
 *
 * @function Phaser.Math.Easing.Sine.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return 0.5 * (1 - Math.cos(Math.PI * v));
            };
            module1.exports = InOut;
        /***/ },
        /* 795 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Stepped easing.
 *
 * @function Phaser.Math.Easing.Stepped
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [steps=1] - The number of steps in the ease.
 *
 * @return {number} The tweened value.
 */ var Stepped = function(v, steps) {
                if (steps === undefined) steps = 1;
                if (v <= 0) return 0;
                else if (v >= 1) return 1;
                else return ((steps * v | 0) + 1) * (1 / steps);
            };
            module1.exports = Stepped;
        /***/ },
        /* 796 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(37);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera Shake effect.
 *
 * This effect will shake the camera viewport by a random amount, bounded by the specified intensity, each frame.
 *
 * Only the camera viewport is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Shake
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Shake = new Class({
                initialize: function Shake(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The intensity of the effect. Use small float values. The default when the effect starts is 0.05.
         * This is a Vector2 object, allowing you to control the shake intensity independently across x and y.
         * You can modify this value while the effect is active to create more varied shake effects.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#intensity
         * @type {Phaser.Math.Vector2}
         * @since 3.5.0
         */ this.intensity = new Vector2();
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * How much to offset the camera by horizontally.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetX = 0;
                    /**
         * How much to offset the camera by vertically.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetY = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraShakeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#start
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraShakeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, intensity, force, callback, context) {
                    if (duration === undefined) duration = 100;
                    if (intensity === undefined) intensity = 0.05;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    if (typeof intensity === "number") this.intensity.set(intensity);
                    else this.intensity.set(intensity.x, intensity.y);
                    this._elapsed = 0;
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.SHAKE_START, this.camera, this, duration, intensity);
                    return this.camera;
                },
                /**
     * The pre-render step for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#preRender
     * @since 3.5.0
     */ preRender: function() {
                    if (this.isRunning) this.camera.matrix.translate(this._offsetX, this._offsetY);
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) {
                        var intensity = this.intensity;
                        var width = this.camera.width;
                        var height = this.camera.height;
                        var zoom = this.camera.zoom;
                        this._offsetX = (Math.random() * intensity.x * width * 2 - intensity.x * width) * zoom;
                        this._offsetY = (Math.random() * intensity.y * height * 2 - intensity.y * height) * zoom;
                        if (this.camera.roundPixels) {
                            this._offsetX = Math.round(this._offsetX);
                            this._offsetY = Math.round(this._offsetY);
                        }
                    } else this.effectComplete();
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.SHAKE_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.intensity = null;
                }
            });
            module1.exports = Shake;
        /***/ },
        /* 797 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Jason Nicholls <nicholls.jason@gmail.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(37);
            var EaseMap = __webpack_require__(134);
            /**
 * @classdesc
 * A Camera Rotate effect.
 *
 * This effect will rotate the Camera so that the its viewport finishes at the given angle in radians,
 * over the duration and with the ease specified.
 * 
 * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
 * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
 *
 * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
 * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
 *
 * Only the camera is rotates. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class RotateTo
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.23.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var RotateTo = new Class({
                initialize: function RotateTo(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.23.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.23.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.23.0
         */ this.duration = 0;
                    /**
         * The starting angle to rotate the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#source
         * @type {number}
         * @since 3.23.0
         */ this.source = 0;
                    /**
         * The constantly updated value based on the force.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#current
         * @type {number}
         * @since 3.23.0
         */ this.current = 0;
                    /**
         * The destination angle in radians to rotate the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#destination
         * @type {number}
         * @since 3.23.0
         */ this.destination = 0;
                    /**
         * The ease function to use during the Rotate.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#ease
         * @type {function}
         * @since 3.23.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#progress
         * @type {number}
         * @since 3.23.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_elapsed
         * @type {number}
         * @private
         * @since 3.23.0
         */ this._elapsed = 0;
                    /**
         * @callback CameraRotateCallback
         *
         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
         * @param {number} progress - The progress of the effect. A value between 0 and 1.
         * @param {number} angle - The Camera's new angle in radians.
         */ /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdate
         * @type {?CameraRotateCallback}
         * @private
         * @default null
         * @since 3.23.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.23.0
         */ this._onUpdateScope;
                    /**
         * The direction of the rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#clockwise
         * @type {boolean}
         * @since 3.23.0
         */ this.clockwise = true;
                    /**
         * The shortest direction to the target rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#shortestPath
         * @type {boolean}
         * @since 3.23.0
         */ this.shortestPath = false;
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given angle,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#start
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_START
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Rotate. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(radians, shortestPath, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (shortestPath === undefined) shortestPath = false;
                    this.shortestPath = shortestPath;
                    var tmpDestination = radians;
                    if (radians < 0) {
                        tmpDestination = -1 * radians;
                        this.clockwise = false;
                    } else this.clockwise = true;
                    var maxRad = 360 * Math.PI / 180;
                    tmpDestination = tmpDestination - Math.floor(tmpDestination / maxRad) * maxRad;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source = cam.rotation;
                    //  Destination
                    this.destination = tmpDestination;
                    //  Using this ease
                    if (typeof ease === "string" && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === "function") this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    if (this.shortestPath) {
                        // The shortest path is true so calculate the quickest direction
                        var cwDist = 0;
                        var acwDist = 0;
                        if (this.destination > this.source) cwDist = Math.abs(this.destination - this.source);
                        else cwDist = Math.abs(this.destination + maxRad) - this.source;
                        if (this.source > this.destination) acwDist = Math.abs(this.source - this.destination);
                        else acwDist = Math.abs(this.source + maxRad) - this.destination;
                        if (cwDist < acwDist) this.clockwise = true;
                        else if (cwDist > acwDist) this.clockwise = false;
                    }
                    this.camera.emit(Events.ROTATE_START, this.camera, this, duration, tmpDestination);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#update
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    var progress = Clamp(this._elapsed / this.duration, 0, 1);
                    this.progress = progress;
                    var cam = this.camera;
                    if (this._elapsed < this.duration) {
                        var v = this.ease(progress);
                        this.current = cam.rotation;
                        var distance = 0;
                        var maxRad = 360 * Math.PI / 180;
                        var target = this.destination;
                        var current = this.current;
                        if (this.clockwise === false) {
                            target = this.current;
                            current = this.destination;
                        }
                        if (target >= current) distance = Math.abs(target - current);
                        else distance = Math.abs(target + maxRad) - current;
                        var r = 0;
                        if (this.clockwise) r = cam.rotation + distance * v;
                        else r = cam.rotation - distance * v;
                        cam.rotation = r;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, r);
                    } else {
                        cam.rotation = this.destination;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, this.destination);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#effectComplete
     * @since 3.23.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.ROTATE_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#reset
     * @since 3.23.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#destroy
     * @since 3.23.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.source = null;
                    this.destination = null;
                }
            });
            module1.exports = RotateTo;
        /***/ },
        /* 798 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var EaseMap = __webpack_require__(134);
            var Events = __webpack_require__(37);
            /**
 * @classdesc
 * A Camera Zoom effect.
 *
 * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Zoom
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Zoom = new Class({
                initialize: function Zoom(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                    /**
         * The starting zoom value;
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#source
         * @type {number}
         * @since 3.11.0
         */ this.source = 1;
                    /**
         * The destination zoom value.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#destination
         * @type {number}
         * @since 3.11.0
         */ this.destination = 1;
                    /**
         * The ease function to use during the zoom.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraZoomCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                },
                /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#start
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Zoom. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the zoom effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraZoomCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent three arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * and the current camera zoom value.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(zoom, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source = cam.zoom;
                    //  Zooming to
                    this.destination = zoom;
                    //  Using this ease
                    if (typeof ease === "string" && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === "function") this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.ZOOM_START, this.camera, this, duration, zoom);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._elapsed < this.duration) {
                        this.camera.zoom = this.source + (this.destination - this.source) * this.ease(this.progress);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.camera.zoom);
                    } else {
                        this.camera.zoom = this.destination;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.destination);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.ZOOM_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#reset
     * @since 3.11.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#destroy
     * @since 3.11.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Zoom;
        /***/ },
        /* 799 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Camera = __webpack_require__(326);
            var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var RectangleContains = __webpack_require__(57);
            var ScaleEvents = __webpack_require__(104);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The Camera Manager is a plugin that belongs to a Scene and is responsible for managing all of the Scene Cameras.
 *
 * By default you can access the Camera Manager from within a Scene using `this.cameras`, although this can be changed
 * in your game config.
 *
 * Create new Cameras using the `add` method. Or extend the Camera class with your own addition code and then add
 * the new Camera in using the `addExisting` method.
 *
 * Cameras provide a view into your game world, and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis. The Camera Manager can manage up to 31 unique
 * 'Game Object ignore capable' Cameras. Any Cameras beyond 31 that you create will all be given a Camera ID of
 * zero, meaning that they cannot be used for Game Object exclusion. This means if you need your Camera to ignore
 * Game Objects, make sure it's one of the first 31 created.
 *
 * A Camera also has built-in special effects including Fade, Flash, Camera Shake, Pan and Zoom.
 *
 * @class CameraManager
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns the Camera Manager plugin.
 */ var CameraManager = new Class({
                initialize: function CameraManager(scene) {
                    /**
         * The Scene that owns the Camera Manager plugin.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems handler for the Scene that owns the Camera Manager.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * All Cameras created by, or added to, this Camera Manager, will have their `roundPixels`
         * property set to match this value. By default it is set to match the value set in the
         * game configuration, but can be changed at any point. Equally, individual cameras can
         * also be changed as needed.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#roundPixels
         * @type {boolean}
         * @since 3.11.0
         */ this.roundPixels = scene.sys.game.config.roundPixels;
                    /**
         * An Array of the Camera objects being managed by this Camera Manager.
         * The Cameras are updated and rendered in the same order in which they appear in this array.
         * Do not directly add or remove entries to this array. However, you can move the contents
         * around the array should you wish to adjust the display order.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#cameras
         * @type {Phaser.Cameras.Scene2D.Camera[]}
         * @since 3.0.0
         */ this.cameras = [];
                    /**
         * A handy reference to the 'main' camera. By default this is the first Camera the
         * Camera Manager creates. You can also set it directly, or use the `makeMain` argument
         * in the `add` and `addExisting` methods. It allows you to access it from your game:
         *
         * ```javascript
         * var cam = this.cameras.main;
         * ```
         *
         * Also see the properties `camera1`, `camera2` and so on.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#main
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.main;
                    /**
         * A default un-transformed Camera that doesn't exist on the camera list and doesn't
         * count towards the total number of cameras being managed. It exists for other
         * systems, as well as your own code, should they require a basic un-transformed
         * camera instance from which to calculate a view matrix.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#default
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.17.0
         */ this.default;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#boot
     * @private
     * @listens Phaser.Scenes.Events#DESTROY
     * @since 3.5.1
     */ boot: function() {
                    var sys = this.systems;
                    if (sys.settings.cameras) //  We have cameras to create
                    this.fromJSON(sys.settings.cameras);
                    else //  Make one
                    this.add();
                    this.main = this.cameras[0];
                    //  Create a default camera
                    this.default = new Camera(0, 0, sys.scale.width, sys.scale.height).setScene(this.scene);
                    sys.game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#start
     * @private
     * @listens Phaser.Scenes.Events#UPDATE
     * @listens Phaser.Scenes.Events#SHUTDOWN
     * @since 3.5.0
     */ start: function() {
                    if (!this.main) {
                        var sys = this.systems;
                        if (sys.settings.cameras) //  We have cameras to create
                        this.fromJSON(sys.settings.cameras);
                        else //  Make one
                        this.add();
                        this.main = this.cameras[0];
                    }
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Adds a new Camera into the Camera Manager. The Camera Manager can support up to 31 different Cameras.
     *
     * Each Camera has its own viewport, which controls the size of the Camera and its position within the canvas.
     *
     * Use the `Camera.scrollX` and `Camera.scrollY` properties to change where the Camera is looking, or the
     * Camera methods such as `centerOn`. Cameras also have built in special effects, such as fade, flash, shake,
     * pan and zoom.
     *
     * By default Cameras are transparent and will render anything that they can see based on their `scrollX`
     * and `scrollY` values. Game Objects can be set to be ignored by a Camera by using the `Camera.ignore` method.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after creation if required.
     *
     * See the Camera class documentation for more details.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#add
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Camera viewport.
     * @param {number} [y=0] - The vertical position of the Camera viewport.
     * @param {number} [width] - The width of the Camera viewport. If not given it'll be the game config size.
     * @param {number} [height] - The height of the Camera viewport. If not given it'll be the game config size.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     * @param {string} [name=''] - The name of the Camera.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The newly created Camera.
     */ add: function(x, y, width, height, makeMain, name) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    if (makeMain === undefined) makeMain = false;
                    if (name === undefined) name = "";
                    var camera = new Camera(x, y, width, height);
                    camera.setName(name);
                    camera.setScene(this.scene);
                    camera.setRoundPixels(this.roundPixels);
                    camera.id = this.getNextID();
                    this.cameras.push(camera);
                    if (makeMain) this.main = camera;
                    return camera;
                },
                /**
     * Adds an existing Camera into the Camera Manager.
     *
     * The Camera should either be a `Phaser.Cameras.Scene2D.Camera` instance, or a class that extends from it.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after addition if required.
     *
     * The Camera will be assigned an ID, which is used for Game Object exclusion and then added to the
     * manager. As long as it doesn't already exist in the manager it will be added then returned.
     *
     * If this method returns `null` then the Camera already exists in this Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#addExisting
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to be added to the Camera Manager.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The Camera that was added to the Camera Manager, or `null` if it couldn't be added.
     */ addExisting: function(camera, makeMain) {
                    if (makeMain === undefined) makeMain = false;
                    var index = this.cameras.indexOf(camera);
                    if (index === -1) {
                        camera.id = this.getNextID();
                        camera.setRoundPixels(this.roundPixels);
                        this.cameras.push(camera);
                        if (makeMain) this.main = camera;
                        return camera;
                    }
                    return null;
                },
                /**
     * Gets the next available Camera ID number.
     *
     * The Camera Manager supports up to 31 unique cameras, after which the ID returned will always be zero.
     * You can create additional cameras beyond 31, but they cannot be used for Game Object exclusion.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getNextID
     * @private
     * @since 3.11.0
     *
     * @return {number} The next available Camera ID, or 0 if they're all already in use.
     */ getNextID: function() {
                    var cameras = this.cameras;
                    var testID = 1;
                    //  Find the first free camera ID we can use
                    for(var t = 0; t < 32; t++){
                        var found = false;
                        for(var i = 0; i < cameras.length; i++){
                            var camera = cameras[i];
                            if (camera && camera.id === testID) {
                                found = true;
                                continue;
                            }
                        }
                        if (found) testID = testID << 1;
                        else return testID;
                    }
                    return 0;
                },
                /**
     * Gets the total number of Cameras in this Camera Manager.
     *
     * If the optional `isVisible` argument is set it will only count Cameras that are currently visible.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getTotal
     * @since 3.11.0
     *
     * @param {boolean} [isVisible=false] - Set the `true` to only include visible Cameras in the total.
     *
     * @return {number} The total number of Cameras in this Camera Manager.
     */ getTotal: function(isVisible) {
                    if (isVisible === undefined) isVisible = false;
                    var total = 0;
                    var cameras = this.cameras;
                    for(var i = 0; i < cameras.length; i++){
                        var camera = cameras[i];
                        if (!isVisible || isVisible && camera.visible) total++;
                    }
                    return total;
                },
                /**
     * Populates this Camera Manager based on the given configuration object, or an array of config objects.
     *
     * See the `Phaser.Types.Cameras.Scene2D.CameraConfig` documentation for details of the object structure.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#fromJSON
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Cameras.Scene2D.CameraConfig|Phaser.Types.Cameras.Scene2D.CameraConfig[])} config - A Camera configuration object, or an array of them, to be added to this Camera Manager.
     *
     * @return {this} This Camera Manager instance.
     */ fromJSON: function(config) {
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var gameWidth = this.scene.sys.scale.width;
                    var gameHeight = this.scene.sys.scale.height;
                    for(var i = 0; i < config.length; i++){
                        var cameraConfig = config[i];
                        var x = GetFastValue(cameraConfig, "x", 0);
                        var y = GetFastValue(cameraConfig, "y", 0);
                        var width = GetFastValue(cameraConfig, "width", gameWidth);
                        var height = GetFastValue(cameraConfig, "height", gameHeight);
                        var camera = this.add(x, y, width, height);
                        //  Direct properties
                        camera.name = GetFastValue(cameraConfig, "name", "");
                        camera.zoom = GetFastValue(cameraConfig, "zoom", 1);
                        camera.rotation = GetFastValue(cameraConfig, "rotation", 0);
                        camera.scrollX = GetFastValue(cameraConfig, "scrollX", 0);
                        camera.scrollY = GetFastValue(cameraConfig, "scrollY", 0);
                        camera.roundPixels = GetFastValue(cameraConfig, "roundPixels", false);
                        camera.visible = GetFastValue(cameraConfig, "visible", true);
                        // Background Color
                        var backgroundColor = GetFastValue(cameraConfig, "backgroundColor", false);
                        if (backgroundColor) camera.setBackgroundColor(backgroundColor);
                        //  Bounds
                        var boundsConfig = GetFastValue(cameraConfig, "bounds", null);
                        if (boundsConfig) {
                            var bx = GetFastValue(boundsConfig, "x", 0);
                            var by = GetFastValue(boundsConfig, "y", 0);
                            var bwidth = GetFastValue(boundsConfig, "width", gameWidth);
                            var bheight = GetFastValue(boundsConfig, "height", gameHeight);
                            camera.setBounds(bx, by, bwidth, bheight);
                        }
                    }
                    return this;
                },
                /**
     * Gets a Camera based on its name.
     *
     * Camera names are optional and don't have to be set, so this method is only of any use if you
     * have given your Cameras unique names.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamera
     * @since 3.0.0
     *
     * @param {string} name - The name of the Camera.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The first Camera with a name matching the given string, otherwise `null`.
     */ getCamera: function(name) {
                    var cameras = this.cameras;
                    for(var i = 0; i < cameras.length; i++){
                        if (cameras[i].name === name) return cameras[i];
                    }
                    return null;
                },
                /**
     * Returns an array of all cameras below the given Pointer.
     *
     * The first camera in the array is the top-most camera in the camera list.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamerasBelowPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against.
     *
     * @return {Phaser.Cameras.Scene2D.Camera[]} An array of cameras below the Pointer.
     */ getCamerasBelowPointer: function(pointer) {
                    var cameras = this.cameras;
                    var x = pointer.x;
                    var y = pointer.y;
                    var output = [];
                    for(var i = 0; i < cameras.length; i++){
                        var camera = cameras[i];
                        if (camera.visible && camera.inputEnabled && RectangleContains(camera, x, y)) //  So the top-most camera is at the top of the search array
                        output.unshift(camera);
                    }
                    return output;
                },
                /**
     * Removes the given Camera, or an array of Cameras, from this Camera Manager.
     *
     * If found in the Camera Manager it will be immediately removed from the local cameras array.
     * If also currently the 'main' camera, 'main' will be reset to be camera 0.
     *
     * The removed Cameras are automatically destroyed if the `runDestroy` argument is `true`, which is the default.
     * If you wish to re-use the cameras then set this to `false`, but know that they will retain their references
     * and internal data until destroyed or re-added to a Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Cameras.Scene2D.Camera|Phaser.Cameras.Scene2D.Camera[])} camera - The Camera, or an array of Cameras, to be removed from this Camera Manager.
     * @param {boolean} [runDestroy=true] - Automatically call `Camera.destroy` on each Camera removed from this Camera Manager.
     *
     * @return {number} The total number of Cameras removed.
     */ remove: function(camera, runDestroy) {
                    if (runDestroy === undefined) runDestroy = true;
                    if (!Array.isArray(camera)) camera = [
                        camera
                    ];
                    var total = 0;
                    var cameras = this.cameras;
                    for(var i = 0; i < camera.length; i++){
                        var index = cameras.indexOf(camera[i]);
                        if (index !== -1) {
                            if (runDestroy) cameras[index].destroy();
                            else cameras[index].renderList = [];
                            cameras.splice(index, 1);
                            total++;
                        }
                    }
                    if (!this.main && cameras[0]) this.main = cameras[0];
                    return total;
                },
                /**
     * The internal render method. This is called automatically by the Scene and should not be invoked directly.
     *
     * It will iterate through all local cameras and render them in turn, as long as they're visible and have
     * an alpha level > 0.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#render
     * @protected
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Renderer that will render the children to this camera.
     * @param {Phaser.GameObjects.DisplayList} displayList - The Display List for the Scene.
     */ render: function(renderer, displayList) {
                    var scene = this.scene;
                    var cameras = this.cameras;
                    for(var i = 0; i < this.cameras.length; i++){
                        var camera = cameras[i];
                        if (camera.visible && camera.alpha > 0) {
                            camera.preRender();
                            var visibleChildren = this.getVisibleChildren(displayList.getChildren(), camera);
                            renderer.render(scene, visibleChildren, camera);
                        }
                    }
                },
                /**
     * Takes an array of Game Objects and a Camera and returns a new array
     * containing only those Game Objects that pass the `willRender` test
     * against the given Camera.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getVisibleChildren
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - An array of Game Objects to be checked against the camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to filte the Game Objects against.
     *
     * @return {Phaser.GameObjects.GameObject[]} A filtered list of only Game Objects within the Scene that will render against the given Camera.
     */ getVisibleChildren: function(children, camera) {
                    var visible = [];
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        if (child.willRender(camera)) visible.push(child);
                    }
                    return visible;
                },
                /**
     * Resets this Camera Manager.
     *
     * This will iterate through all current Cameras, destroying them all, then it will reset the
     * cameras array, reset the ID counter and create 1 new single camera using the default values.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resetAll
     * @since 3.0.0
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The freshly created main Camera.
     */ resetAll: function() {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                    this.cameras = [];
                    this.main = this.add();
                    return this.main;
                },
                /**
     * The main update loop. Called automatically when the Scene steps.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].update(time, delta);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#onResize
     * @since 3.18.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize, displaySize, previousWidth, previousHeight) {
                    for(var i = 0; i < this.cameras.length; i++){
                        var cam = this.cameras[i];
                        //  if camera is at 0x0 and was the size of the previous game size, then we can safely assume it
                        //  should be updated to match the new game size too
                        if (cam._x === 0 && cam._y === 0 && cam._width === previousWidth && cam._height === previousHeight) cam.setSize(baseSize.width, baseSize.height);
                    }
                },
                /**
     * Resizes all cameras to the given dimensions.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resize
     * @since 3.2.0
     *
     * @param {number} width - The new width of the camera.
     * @param {number} height - The new height of the camera.
     */ resize: function(width, height) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].setSize(width, height);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.main = undefined;
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                    this.cameras = [];
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.default.destroy();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("CameraManager", CameraManager, "cameras");
            module1.exports = CameraManager;
        /***/ },
        /* 800 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager has successfully entered fullscreen mode.
 *
 * @event Phaser.Scale.Events#ENTER_FULLSCREEN
 * @since 3.16.1
 */ module1.exports = "enterfullscreen";
        /***/ },
        /* 801 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode but failed.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_FAILED
 * @since 3.17.0
 */ module1.exports = "fullscreenfailed";
        /***/ },
        /* 802 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode, but it is unsupported by the browser.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
 * @since 3.16.1
 */ module1.exports = "fullscreenunsupported";
        /***/ },
        /* 803 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager was in fullscreen mode, but has since left, either directly via game code,
 * or via a user gestured, such as pressing the ESC key.
 *
 * @event Phaser.Scale.Events#LEAVE_FULLSCREEN
 * @since 3.16.1
 */ module1.exports = "leavefullscreen";
        /***/ },
        /* 804 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Orientation Change Event.
 *
 * This event is dispatched whenever the Scale Manager detects an orientation change event from the browser.
 *
 * @event Phaser.Scale.Events#ORIENTATION_CHANGE
 * @since 3.16.1
 *
 * @param {string} orientation - The new orientation value. Either `Phaser.Scale.Orientation.LANDSCAPE` or `Phaser.Scale.Orientation.PORTRAIT`.
 */ module1.exports = "orientationchange";
        /***/ },
        /* 805 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Resize Event.
 *
 * This event is dispatched whenever the Scale Manager detects a resize event from the browser.
 * It sends three parameters to the callback, each of them being Size components. You can read
 * the `width`, `height`, `aspectRatio` and other properties of these components to help with
 * scaling your own game content.
 *
 * @event Phaser.Scale.Events#RESIZE
 * @since 3.16.1
 *
 * @param {Phaser.Structs.Size} gameSize - A reference to the Game Size component. This is the un-scaled size of your game canvas.
 * @param {Phaser.Structs.Size} baseSize - A reference to the Base Size component. This is the game size.
 * @param {Phaser.Structs.Size} displaySize - A reference to the Display Size component. This is the scaled canvas size, after applying zoom and scale mode.
 * @param {number} previousWidth - If the `gameSize` has changed, this value contains its previous width, otherwise it contains the current width.
 * @param {number} previousHeight - If the `gameSize` has changed, this value contains its previous height, otherwise it contains the current height.
 */ module1.exports = "resize";
        /***/ },
        /* 806 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core
 */ module1.exports = {
                Config: __webpack_require__(346),
                CreateRenderer: __webpack_require__(366),
                DebugHeader: __webpack_require__(384),
                Events: __webpack_require__(22),
                TimeStep: __webpack_require__(385),
                VisibilityHandler: __webpack_require__(387)
            };
        /***/ },
        /* 807 */ /***/ function(module1, exports) {
            // shim for using process in browser
            var process = module1.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error("setTimeout has not been defined");
            }
            function defaultClearTimeout() {
                throw new Error("clearTimeout has not been defined");
            }
            (function() {
                try {
                    if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = "browser";
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ""; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
            process.listeners = function(name) {
                return [];
            };
            process.binding = function(name) {
                throw new Error("process.binding is not supported");
            };
            process.cwd = function() {
                return "/";
            };
            process.chdir = function(dir) {
                throw new Error("process.chdir is not supported");
            };
            process.umask = function() {
                return 0;
            };
        /***/ },
        /* 808 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(136);
            /**
 * Determines the input support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.input` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Input
 * @since 3.0.0
 *
 * @property {?string} wheelType - The newest type of Wheel/Scroll event supported: 'wheel', 'mousewheel', 'DOMMouseScroll'
 * @property {boolean} gamepads - Is navigator.getGamepads available?
 * @property {boolean} mspointer - Is mspointer available?
 * @property {boolean} touch - Is touch available?
 */ var Input = {
                gamepads: false,
                mspointer: false,
                touch: false,
                wheelEvent: null
            };
            function init() {
                if (typeof importScripts === "function") return Input;
                if ("ontouchstart" in document.documentElement || navigator.maxTouchPoints && navigator.maxTouchPoints >= 1) Input.touch = true;
                if (navigator.msPointerEnabled || navigator.pointerEnabled) Input.mspointer = true;
                if (navigator.getGamepads) Input.gamepads = true;
                // See https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                if ("onwheel" in window || Browser.ie && "WheelEvent" in window) // DOM3 Wheel Event: FF 17+, IE 9+, Chrome 31+, Safari 7+
                Input.wheelEvent = "wheel";
                else if ("onmousewheel" in window) // Non-FF legacy: IE 6-9, Chrome 1-31, Safari 5-7.
                Input.wheelEvent = "mousewheel";
                else if (Browser.firefox && "MouseScrollEvent" in window) // FF prior to 17. This should probably be scrubbed.
                Input.wheelEvent = "DOMMouseScroll";
                return Input;
            }
            module1.exports = init();
        /***/ },
        /* 809 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(136);
            /**
 * Determines the audio playback capabilities of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.audio` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Audio
 * @since 3.0.0
 *
 * @property {boolean} audioData - Can this device play HTML Audio tags?
 * @property {boolean} dolby - Can this device play EC-3 Dolby Digital Plus files?
 * @property {boolean} m4a - Can this device can play m4a files.
 * @property {boolean} mp3 - Can this device play mp3 files?
 * @property {boolean} ogg - Can this device play ogg files?
 * @property {boolean} opus - Can this device play opus files?
 * @property {boolean} wav - Can this device play wav files?
 * @property {boolean} webAudio - Does this device have the Web Audio API?
 * @property {boolean} webm - Can this device play webm files?
 */ var Audio1 = {
                audioData: false,
                dolby: false,
                m4a: false,
                mp3: false,
                ogg: false,
                opus: false,
                wav: false,
                webAudio: false,
                webm: false
            };
            function init() {
                if (typeof importScripts === "function") return Audio1;
                Audio1.audioData = !!window["Audio"];
                Audio1.webAudio = !!(window["AudioContext"] || window["webkitAudioContext"]);
                var audioElement = document.createElement("audio");
                var result = !!audioElement.canPlayType;
                try {
                    if (result) {
                        if (audioElement.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "")) Audio1.ogg = true;
                        if (audioElement.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, "") || audioElement.canPlayType("audio/opus;").replace(/^no$/, "")) Audio1.opus = true;
                        if (audioElement.canPlayType("audio/mpeg;").replace(/^no$/, "")) Audio1.mp3 = true;
                        //  Mimetypes accepted:
                        //  developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                        if (audioElement.canPlayType("audio/wav").replace(/^no$/, "")) Audio1.wav = true;
                        if (audioElement.canPlayType("audio/x-m4a;") || audioElement.canPlayType("audio/aac;").replace(/^no$/, "")) Audio1.m4a = true;
                        if (audioElement.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")) Audio1.webm = true;
                        if (audioElement.canPlayType('audio/mp4;codecs="ec-3"') !== "") {
                            if (Browser.edge) Audio1.dolby = true;
                            else if (Browser.safari && Browser.safariVersion >= 9) {
                                if (/Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)) {
                                    var major = parseInt(RegExp.$1, 10);
                                    var minor = parseInt(RegExp.$2, 10);
                                    if (major === 10 && minor >= 11 || major > 10) Audio1.dolby = true;
                                }
                            }
                        }
                    }
                } catch (e) {
                //  Nothing to do here
                }
                return Audio1;
            }
            module1.exports = init();
        /***/ },
        /* 810 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the video support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.video` from within any Scene.
 *
 * In Phaser 3.20 the properties were renamed to drop the 'Video' suffix.
 *
 * @typedef {object} Phaser.Device.Video
 * @since 3.0.0
 *
 * @property {boolean} h264 - Can this device play h264 mp4 video files?
 * @property {boolean} hls - Can this device play hls video files?
 * @property {boolean} mp4 - Can this device play h264 mp4 video files?
 * @property {boolean} ogg - Can this device play ogg video files?
 * @property {boolean} vp9 - Can this device play vp9 video files?
 * @property {boolean} webm - Can this device play webm video files?
 */ var Video = {
                h264: false,
                hls: false,
                mp4: false,
                ogg: false,
                vp9: false,
                webm: false
            };
            function init() {
                if (typeof importScripts === "function") return Video;
                var videoElement = document.createElement("video");
                var result = !!videoElement.canPlayType;
                try {
                    if (result) {
                        if (videoElement.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, "")) Video.ogg = true;
                        if (videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, "")) {
                            // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
                            Video.h264 = true;
                            Video.mp4 = true;
                        }
                        if (videoElement.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, "")) Video.webm = true;
                        if (videoElement.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, "")) Video.vp9 = true;
                        if (videoElement.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, "")) Video.hls = true;
                    }
                } catch (e) {
                //  Nothing to do
                }
                return Video;
            }
            module1.exports = init();
        /***/ },
        /* 811 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the full screen support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.fullscreen` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Fullscreen
 * @since 3.0.0
 *
 * @property {boolean} available - Does the browser support the Full Screen API?
 * @property {boolean} keyboard - Does the browser support access to the Keyboard during Full Screen mode?
 * @property {string} cancel - If the browser supports the Full Screen API this holds the call you need to use to cancel it.
 * @property {string} request - If the browser supports the Full Screen API this holds the call you need to use to activate it.
 */ var Fullscreen = {
                available: false,
                cancel: "",
                keyboard: false,
                request: ""
            };
            /**
* Checks for support of the Full Screen API.
*
* @ignore
*/ function init() {
                if (typeof importScripts === "function") return Fullscreen;
                var i;
                var suffix1 = "Fullscreen";
                var suffix2 = "FullScreen";
                var fs = [
                    "request" + suffix1,
                    "request" + suffix2,
                    "webkitRequest" + suffix1,
                    "webkitRequest" + suffix2,
                    "msRequest" + suffix1,
                    "msRequest" + suffix2,
                    "mozRequest" + suffix2,
                    "mozRequest" + suffix1
                ];
                for(i = 0; i < fs.length; i++)if (document.documentElement[fs[i]]) {
                    Fullscreen.available = true;
                    Fullscreen.request = fs[i];
                    break;
                }
                var cfs = [
                    "cancel" + suffix2,
                    "exit" + suffix1,
                    "webkitCancel" + suffix2,
                    "webkitExit" + suffix1,
                    "msCancel" + suffix2,
                    "msExit" + suffix1,
                    "mozCancel" + suffix2,
                    "mozExit" + suffix1
                ];
                if (Fullscreen.available) {
                    for(i = 0; i < cfs.length; i++)if (document[cfs[i]]) {
                        Fullscreen.cancel = cfs[i];
                        break;
                    }
                }
                //  Keyboard Input?
                //  Safari 5.1 says it supports fullscreen keyboard, but is lying.
                if (window["Element"] && Element["ALLOW_KEYBOARD_INPUT"] && !/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) Fullscreen.keyboard = true;
                Object.defineProperty(Fullscreen, "active", {
                    get: function() {
                        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
                    }
                });
                return Fullscreen;
            }
            module1.exports = init();
        /***/ },
        /* 812 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Angle
 */ module1.exports = {
                Between: __webpack_require__(349),
                BetweenPoints: __webpack_require__(350),
                BetweenPointsY: __webpack_require__(813),
                BetweenY: __webpack_require__(814),
                CounterClockwise: __webpack_require__(815),
                Normalize: __webpack_require__(351),
                Random: __webpack_require__(816),
                RandomDegrees: __webpack_require__(817),
                Reverse: __webpack_require__(818),
                RotateTo: __webpack_require__(819),
                ShortestBetween: __webpack_require__(820),
                Wrap: __webpack_require__(269),
                WrapDegrees: __webpack_require__(270)
            };
        /***/ },
        /* 813 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * The difference between this method and {@link Phaser.Math.Angle.BetweenPoints} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenPointsY
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPointsY = function(point1, point2) {
                return Math.atan2(point2.x - point1.x, point2.y - point1.y);
            };
            module1.exports = BetweenPointsY;
        /***/ },
        /* 814 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * The difference between this method and {@link Phaser.Math.Angle.Between} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenY
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenY = function(x1, y1, x2, y2) {
                return Math.atan2(x2 - x1, y2 - y1);
            };
            module1.exports = BetweenY;
        /***/ },
        /* 815 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Takes an angle in Phasers default clockwise format and converts it so that
 * 0 is North, 90 is West, 180 is South and 270 is East,
 * therefore running counter-clockwise instead of clockwise.
 * 
 * You can pass in the angle from a Game Object using:
 * 
 * ```javascript
 * var converted = CounterClockwise(gameobject.rotation);
 * ```
 * 
 * All values for this function are in radians.
 *
 * @function Phaser.Math.Angle.CounterClockwise
 * @since 3.16.0
 *
 * @param {number} angle - The angle to convert, in radians.
 *
 * @return {number} The converted angle, in radians.
 */ var CounterClockwise = function(angle) {
                if (angle > Math.PI) angle -= CONST.PI2;
                return Math.abs(((angle + CONST.TAU) % CONST.PI2 - CONST.PI2) % CONST.PI2);
            };
            module1.exports = CounterClockwise;
        /***/ },
        /* 816 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       @samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(137);
            /**
 * Returns a random angle in the range [-pi, pi].
 *
 * @function Phaser.Math.Angle.Random
 * @since 3.23.0
 *
 * @return {number} The angle, in radians.
 */ var Random = function() {
                return FloatBetween(-Math.PI, Math.PI);
            };
            module1.exports = Random;
        /***/ },
        /* 817 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       @samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(137);
            /**
 * Returns a random angle in the range [-180, 180].
 *
 * @function Phaser.Math.Angle.RandomDegrees
 * @since 3.23.0
 *
 * @return {number} The angle, in degrees.
 */ var RandomDegrees = function() {
                return FloatBetween(-180, 180);
            };
            module1.exports = RandomDegrees;
        /***/ },
        /* 818 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Normalize = __webpack_require__(351);
            /**
 * Reverse the given angle.
 *
 * @function Phaser.Math.Angle.Reverse
 * @since 3.0.0
 *
 * @param {number} angle - The angle to reverse, in radians.
 *
 * @return {number} The reversed angle, in radians.
 */ var Reverse = function(angle) {
                return Normalize(angle + Math.PI);
            };
            module1.exports = Reverse;
        /***/ },
        /* 819 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            /**
 * Rotates `currentAngle` towards `targetAngle`, taking the shortest rotation distance. The `lerp` argument is the amount to rotate by in this call.
 *
 * @function Phaser.Math.Angle.RotateTo
 * @since 3.0.0
 *
 * @param {number} currentAngle - The current angle, in radians.
 * @param {number} targetAngle - The target angle to rotate to, in radians.
 * @param {number} [lerp=0.05] - The lerp value to add to the current angle.
 *
 * @return {number} The adjusted angle.
 */ var RotateTo = function(currentAngle, targetAngle, lerp) {
                if (lerp === undefined) lerp = 0.05;
                if (currentAngle === targetAngle) return currentAngle;
                if (Math.abs(targetAngle - currentAngle) <= lerp || Math.abs(targetAngle - currentAngle) >= MATH_CONST.PI2 - lerp) currentAngle = targetAngle;
                else {
                    if (Math.abs(targetAngle - currentAngle) > Math.PI) {
                        if (targetAngle < currentAngle) targetAngle += MATH_CONST.PI2;
                        else targetAngle -= MATH_CONST.PI2;
                    }
                    if (targetAngle > currentAngle) currentAngle += lerp;
                    else if (targetAngle < currentAngle) currentAngle -= lerp;
                }
                return currentAngle;
            };
            module1.exports = RotateTo;
        /***/ },
        /* 820 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Gets the shortest angle between `angle1` and `angle2`.
 *
 * Both angles must be in the range -180 to 180, which is the same clamped
 * range that `sprite.angle` uses, so you can pass in two sprite angles to
 * this method and get the shortest angle back between the two of them.
 *
 * The angle returned will be in the same range. If the returned angle is
 * greater than 0 then it's a counter-clockwise rotation, if < 0 then it's
 * a clockwise rotation.
 *
 * @function Phaser.Math.Angle.ShortestBetween
 * @since 3.0.0
 *
 * @param {number} angle1 - The first angle in the range -180 to 180.
 * @param {number} angle2 - The second angle in the range -180 to 180.
 *
 * @return {number} The shortest angle, in degrees. If greater than zero it's a counter-clockwise rotation.
 */ var ShortestBetween = function(angle1, angle2) {
                var difference = angle2 - angle1;
                if (difference === 0) return 0;
                var times = Math.floor((difference - -180) / 360);
                return difference - times * 360;
            };
            module1.exports = ShortestBetween;
        /***/ },
        /* 821 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Distance
 */ module1.exports = {
                Between: __webpack_require__(50),
                BetweenPoints: __webpack_require__(352),
                BetweenPointsSquared: __webpack_require__(822),
                Chebyshev: __webpack_require__(823),
                Power: __webpack_require__(824),
                Snake: __webpack_require__(825),
                Squared: __webpack_require__(353)
            };
        /***/ },
        /* 822 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the squared distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPointsSquared
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The squared distance between the points.
 */ var DistanceBetweenPointsSquared = function(a, b) {
                var dx = a.x - b.x;
                var dy = a.y - b.y;
                return dx * dx + dy * dy;
            };
            module1.exports = DistanceBetweenPointsSquared;
        /***/ },
        /* 823 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the Chebyshev distance between two sets of coordinates (points).
 *
 * Chebyshev distance (or chessboard distance) is the maximum of the horizontal and vertical distances.
 * It's the effective distance when movement can be horizontal, vertical, or diagonal.
 *
 * @function Phaser.Math.Distance.Chebyshev
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var ChebyshevDistance = function(x1, y1, x2, y2) {
                return Math.max(Math.abs(x1 - x2), Math.abs(y1 - y2));
            };
            module1.exports = ChebyshevDistance;
        /***/ },
        /* 824 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points) to the power of `pow`.
 *
 * @function Phaser.Math.Distance.Power
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 * @param {number} pow - The exponent.
 *
 * @return {number} The distance between each point.
 */ var DistancePower = function(x1, y1, x2, y2, pow) {
                if (pow === undefined) pow = 2;
                return Math.sqrt(Math.pow(x2 - x1, pow) + Math.pow(y2 - y1, pow));
            };
            module1.exports = DistancePower;
        /***/ },
        /* 825 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the snake distance between two sets of coordinates (points).
 *
 * Snake distance (rectilinear distance, Manhattan distance) is the sum of the horizontal and vertical distances.
 * It's the effective distance when movement is allowed only horizontally or vertically (but not both).
 *
 * @function Phaser.Math.Distance.Snake
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var SnakeDistance = function(x1, y1, x2, y2) {
                return Math.abs(x1 - x2) + Math.abs(y1 - y2);
            };
            module1.exports = SnakeDistance;
        /***/ },
        /* 826 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing
 */ module1.exports = {
                Back: __webpack_require__(334),
                Bounce: __webpack_require__(335),
                Circular: __webpack_require__(336),
                Cubic: __webpack_require__(337),
                Elastic: __webpack_require__(338),
                Expo: __webpack_require__(339),
                Linear: __webpack_require__(340),
                Quadratic: __webpack_require__(341),
                Quartic: __webpack_require__(342),
                Quintic: __webpack_require__(343),
                Sine: __webpack_require__(344),
                Stepped: __webpack_require__(345)
            };
        /***/ },
        /* 827 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Fuzzy
 */ module1.exports = {
                Ceil: __webpack_require__(828),
                Equal: __webpack_require__(124),
                Floor: __webpack_require__(829),
                GreaterThan: __webpack_require__(354),
                LessThan: __webpack_require__(355)
            };
        /***/ },
        /* 828 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy ceiling of the given value.
 *
 * @function Phaser.Math.Fuzzy.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The fuzzy ceiling of the value.
 */ var Ceil = function(value, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.ceil(value - epsilon);
            };
            module1.exports = Ceil;
        /***/ },
        /* 829 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy floor of the given value.
 *
 * @function Phaser.Math.Fuzzy.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The floor of the value.
 */ var Floor = function(value, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.floor(value + epsilon);
            };
            module1.exports = Floor;
        /***/ },
        /* 830 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Interpolation
 */ module1.exports = {
                Bezier: __webpack_require__(831),
                CatmullRom: __webpack_require__(832),
                CubicBezier: __webpack_require__(358),
                Linear: __webpack_require__(833),
                QuadraticBezier: __webpack_require__(359),
                SmoothStep: __webpack_require__(360),
                SmootherStep: __webpack_require__(834)
            };
        /***/ },
        /* 831 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bernstein = __webpack_require__(356);
            /**
 * A bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.Bezier
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var BezierInterpolation = function(v, k) {
                var b = 0;
                var n = v.length - 1;
                for(var i = 0; i <= n; i++)b += Math.pow(1 - k, n - i) * Math.pow(k, i) * v[i] * Bernstein(n, i);
                return b;
            };
            module1.exports = BezierInterpolation;
        /***/ },
        /* 832 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CatmullRom = __webpack_require__(194);
            /**
 * A Catmull-Rom interpolation method.
 *
 * @function Phaser.Math.Interpolation.CatmullRom
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var CatmullRomInterpolation = function(v, k) {
                var m = v.length - 1;
                var f = m * k;
                var i = Math.floor(f);
                if (v[0] === v[m]) {
                    if (k < 0) i = Math.floor(f = m * (1 + k));
                    return CatmullRom(f - i, v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m]);
                } else {
                    if (k < 0) return v[0] - (CatmullRom(-f, v[0], v[0], v[1], v[1]) - v[0]);
                    if (k > 1) return v[m] - (CatmullRom(f - m, v[m], v[m], v[m - 1], v[m - 1]) - v[m]);
                    return CatmullRom(f - i, v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2]);
                }
            };
            module1.exports = CatmullRomInterpolation;
        /***/ },
        /* 833 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(135);
            /**
 * A linear interpolation method.
 *
 * @function Phaser.Math.Interpolation.Linear
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Linear_interpolation}
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {!number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {!number} The interpolated value.
 */ var LinearInterpolation = function(v, k) {
                var m = v.length - 1;
                var f = m * k;
                var i = Math.floor(f);
                if (k < 0) return Linear(v[0], v[1], f);
                else if (k > 1) return Linear(v[m], v[m - 1], m - f);
                else return Linear(v[i], v[i + 1 > m ? m : i + 1], f - i);
            };
            module1.exports = LinearInterpolation;
        /***/ },
        /* 834 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmootherStep = __webpack_require__(183);
            /**
 * A Smoother Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmootherStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmootherStepInterpolation = function(t, min, max) {
                return min + (max - min) * SmootherStep(t, 0, 1);
            };
            module1.exports = SmootherStepInterpolation;
        /***/ },
        /* 835 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Pow2
 */ module1.exports = {
                GetNext: __webpack_require__(361),
                IsSize: __webpack_require__(138),
                IsValue: __webpack_require__(836)
            };
        /***/ },
        /* 836 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests the value and returns `true` if it is a power of two.
 *
 * @function Phaser.Math.Pow2.IsValue
 * @since 3.0.0
 *
 * @param {number} value - The value to check if it's a power of two.
 *
 * @return {boolean} Returns `true` if `value` is a power of two, otherwise `false`.
 */ var IsValuePowerOfTwo = function(value) {
                return value > 0 && (value & value - 1) === 0;
            };
            module1.exports = IsValuePowerOfTwo;
        /***/ },
        /* 837 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Snap
 */ module1.exports = {
                Ceil: __webpack_require__(139),
                Floor: __webpack_require__(76),
                To: __webpack_require__(838)
            };
        /***/ },
        /* 838 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using rounding.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10` whereas `14` will snap to `15`.
 *
 * @function Phaser.Math.Snap.To
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapTo = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.round(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapTo;
        /***/ },
        /* 839 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A seeded Random Data Generator.
 * 
 * Access via `Phaser.Math.RND` which is an instance of this class pre-defined
 * by Phaser. Or, create your own instance to use as you require.
 * 
 * The `Math.RND` generator is seeded by the Game Config property value `seed`.
 * If no such config property exists, a random number is used.
 * 
 * If you create your own instance of this class you should provide a seed for it.
 * If no seed is given it will use a 'random' one based on Date.now.
 *
 * @class RandomDataGenerator
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|string[])} [seeds] - The seeds to use for the random number generator.
 */ var RandomDataGenerator = new Class({
                initialize: function RandomDataGenerator(seeds) {
                    if (seeds === undefined) seeds = [
                        (Date.now() * Math.random()).toString()
                    ];
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#c
         * @type {number}
         * @default 1
         * @private
         * @since 3.0.0
         */ this.c = 1;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s0
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s0 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s1
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s1 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s2
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s2 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#n
         * @type {number}
         * @default 0
         * @private
         * @since 3.2.0
         */ this.n = 0;
                    /**
         * Signs to choose from.
         *
         * @name Phaser.Math.RandomDataGenerator#signs
         * @type {number[]}
         * @since 3.0.0
         */ this.signs = [
                        -1,
                        1
                    ];
                    if (seeds) this.init(seeds);
                },
                /**
     * Private random helper.
     *
     * @method Phaser.Math.RandomDataGenerator#rnd
     * @since 3.0.0
     * @private
     *
     * @return {number} A random number.
     */ rnd: function() {
                    var t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
                    this.c = t | 0;
                    this.s0 = this.s1;
                    this.s1 = this.s2;
                    this.s2 = t - this.c;
                    return this.s2;
                },
                /**
     * Internal method that creates a seed hash.
     *
     * @method Phaser.Math.RandomDataGenerator#hash
     * @since 3.0.0
     * @private
     *
     * @param {string} data - The value to hash.
     *
     * @return {number} The hashed value.
     */ hash: function(data) {
                    var h;
                    var n = this.n;
                    data = data.toString();
                    for(var i = 0; i < data.length; i++){
                        n += data.charCodeAt(i);
                        h = 0.02519603282416938 * n;
                        n = h >>> 0;
                        h -= n;
                        h *= n;
                        n = h >>> 0;
                        h -= n;
                        n += h * 0x100000000; // 2^32
                    }
                    this.n = n;
                    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
                },
                /**
     * Initialize the state of the random data generator.
     *
     * @method Phaser.Math.RandomDataGenerator#init
     * @since 3.0.0
     *
     * @param {(string|string[])} seeds - The seeds to initialize the random data generator with.
     */ init: function(seeds) {
                    if (typeof seeds === "string") this.state(seeds);
                    else this.sow(seeds);
                },
                /**
     * Reset the seed of the random data generator.
     *
     * _Note_: the seed array is only processed up to the first `undefined` (or `null`) value, should such be present.
     *
     * @method Phaser.Math.RandomDataGenerator#sow
     * @since 3.0.0
     *
     * @param {string[]} seeds - The array of seeds: the `toString()` of each value is used.
     */ sow: function(seeds) {
                    // Always reset to default seed
                    this.n = 0xefc8249d;
                    this.s0 = this.hash(" ");
                    this.s1 = this.hash(" ");
                    this.s2 = this.hash(" ");
                    this.c = 1;
                    if (!seeds) return;
                    // Apply any seeds
                    for(var i = 0; i < seeds.length && seeds[i] != null; i++){
                        var seed = seeds[i];
                        this.s0 -= this.hash(seed);
                        this.s0 += ~~(this.s0 < 0);
                        this.s1 -= this.hash(seed);
                        this.s1 += ~~(this.s1 < 0);
                        this.s2 -= this.hash(seed);
                        this.s2 += ~~(this.s2 < 0);
                    }
                },
                /**
     * Returns a random integer between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#integer
     * @since 3.0.0
     *
     * @return {number} A random integer between 0 and 2^32.
     */ integer: function() {
                    // 2^32
                    return this.rnd() * 0x100000000;
                },
                /**
     * Returns a random real number between 0 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#frac
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 1.
     */ frac: function() {
                    // 2^-53
                    return this.rnd() + (this.rnd() * 0x200000 | 0) * 1.1102230246251565e-16;
                },
                /**
     * Returns a random real number between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#real
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 2^32.
     */ real: function() {
                    return this.integer() + this.frac();
                },
                /**
     * Returns a random integer between and including min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#integerInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ integerInRange: function(min, max) {
                    return Math.floor(this.realInRange(0, max - min + 1) + min);
                },
                /**
     * Returns a random integer between and including min and max.
     * This method is an alias for RandomDataGenerator.integerInRange.
     *
     * @method Phaser.Math.RandomDataGenerator#between
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ between: function(min, max) {
                    return Math.floor(this.realInRange(0, max - min + 1) + min);
                },
                /**
     * Returns a random real number between min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#realInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ realInRange: function(min, max) {
                    return this.frac() * (max - min) + min;
                },
                /**
     * Returns a random real number between -1 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#normal
     * @since 3.0.0
     *
     * @return {number} A random real number between -1 and 1.
     */ normal: function() {
                    return 1 - 2 * this.frac();
                },
                /**
     * Returns a valid RFC4122 version4 ID hex string from https://gist.github.com/1308368
     *
     * @method Phaser.Math.RandomDataGenerator#uuid
     * @since 3.0.0
     *
     * @return {string} A valid RFC4122 version4 ID hex string
     */ uuid: function() {
                    var a = "";
                    var b = "";
                    for(b = a = ""; a++ < 36; b += ~a % 5 | a * 3 & 4 ? (a ^ 15 ? 8 ^ this.frac() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-");
                    return b;
                },
                /**
     * Returns a random element from within the given array.
     *
     * @method Phaser.Math.RandomDataGenerator#pick
     * @since 3.0.0
     * 
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ pick: function(array) {
                    return array[this.integerInRange(0, array.length - 1)];
                },
                /**
     * Returns a sign to be used with multiplication operator.
     *
     * @method Phaser.Math.RandomDataGenerator#sign
     * @since 3.0.0
     *
     * @return {number} -1 or +1.
     */ sign: function() {
                    return this.pick(this.signs);
                },
                /**
     * Returns a random element from within the given array, favoring the earlier entries.
     *
     * @method Phaser.Math.RandomDataGenerator#weightedPick
     * @since 3.0.0
     *
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ weightedPick: function(array) {
                    return array[~~(Math.pow(this.frac(), 2) * (array.length - 1) + 0.5)];
                },
                /**
     * Returns a random timestamp between min and max, or between the beginning of 2000 and the end of 2020 if min and max aren't specified.
     *
     * @method Phaser.Math.RandomDataGenerator#timestamp
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random timestamp between min and max.
     */ timestamp: function(min, max) {
                    return this.realInRange(min || 946684800000, max || 1577862000000);
                },
                /**
     * Returns a random angle between -180 and 180.
     *
     * @method Phaser.Math.RandomDataGenerator#angle
     * @since 3.0.0
     *
     * @return {number} A random number between -180 and 180.
     */ angle: function() {
                    return this.integerInRange(-180, 180);
                },
                /**
     * Returns a random rotation in radians, between -3.141 and 3.141
     *
     * @method Phaser.Math.RandomDataGenerator#rotation
     * @since 3.0.0
     *
     * @return {number} A random number between -3.141 and 3.141
     */ rotation: function() {
                    return this.realInRange(-3.1415926, 3.1415926);
                },
                /**
     * Gets or Sets the state of the generator. This allows you to retain the values
     * that the generator is using between games, i.e. in a game save file.
     *
     * To seed this generator with a previously saved state you can pass it as the
     * `seed` value in your game config, or call this method directly after Phaser has booted.
     *
     * Call this method with no parameters to return the current state.
     *
     * If providing a state it should match the same format that this method
     * returns, which is a string with a header `!rnd` followed by the `c`,
     * `s0`, `s1` and `s2` values respectively, each comma-delimited.
     *
     * @method Phaser.Math.RandomDataGenerator#state
     * @since 3.0.0
     *
     * @param {string} [state] - Generator state to be set.
     *
     * @return {string} The current state of the generator.
     */ state: function(state) {
                    if (typeof state === "string" && state.match(/^!rnd/)) {
                        state = state.split(",");
                        this.c = parseFloat(state[1]);
                        this.s0 = parseFloat(state[2]);
                        this.s1 = parseFloat(state[3]);
                        this.s2 = parseFloat(state[4]);
                    }
                    return [
                        "!rnd",
                        this.c,
                        this.s0,
                        this.s1,
                        this.s2
                    ].join(",");
                },
                /**
     * Shuffles the given array, using the current seed.
     *
     * @method Phaser.Math.RandomDataGenerator#shuffle
     * @since 3.7.0
     *
     * @generic T
     * @genericUse {T[]} - [array,$return]
     *
     * @param {T[]} [array] - The array to be shuffled.
     *
     * @return {T[]} The shuffled array.
     */ shuffle: function(array) {
                    var len = array.length - 1;
                    for(var i = len; i > 0; i--){
                        var randomIndex = Math.floor(this.frac() * (i + 1));
                        var itemAtIndex = array[randomIndex];
                        array[randomIndex] = array[i];
                        array[i] = itemAtIndex;
                    }
                    return array;
                }
            });
            module1.exports = RandomDataGenerator;
        /***/ },
        /* 840 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the mean average of the given values.
 *
 * @function Phaser.Math.Average
 * @since 3.0.0
 *
 * @param {number[]} values - The values to average.
 *
 * @return {number} The average value.
 */ var Average = function(values) {
                var sum = 0;
                for(var i = 0; i < values.length; i++)sum += +values[i];
                return sum / values.length;
            };
            module1.exports = Average;
        /***/ },
        /* 841 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Ceils to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.CeilTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var CeilTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.ceil(value * p) / p;
            };
            module1.exports = CeilTo;
        /***/ },
        /* 842 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the positive difference of two given numbers.
 *
 * @function Phaser.Math.Difference
 * @since 3.0.0
 *
 * @param {number} a - The first number in the calculation.
 * @param {number} b - The second number in the calculation.
 *
 * @return {number} The positive difference of the two given numbers.
 */ var Difference = function(a, b) {
                return Math.abs(a - b);
            };
            module1.exports = Difference;
        /***/ },
        /* 843 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Matrix4 = __webpack_require__(69);
            var NOOP = __webpack_require__(1);
            var tempMatrix = new Matrix4();
            /**
 * @classdesc
 *
 * @class Euler
 * @memberof Phaser.Math
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Euler = new Class({
                initialize: function Euler(x, y, z, order) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (z === undefined) z = 0;
                    if (order === undefined) order = Euler.DefaultOrder;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    this.onChangeCallback = NOOP;
                },
                x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.onChangeCallback(this);
                    }
                },
                y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.onChangeCallback(this);
                    }
                },
                z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(value) {
                        this._z = value;
                        this.onChangeCallback(this);
                    }
                },
                order: {
                    get: function() {
                        return this._order;
                    },
                    set: function(value) {
                        this._order = value;
                        this.onChangeCallback(this);
                    }
                },
                set: function(x, y, z, order) {
                    if (order === undefined) order = this._order;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    this.onChangeCallback(this);
                    return this;
                },
                copy: function(euler) {
                    return this.set(euler.x, euler.y, euler.z, euler.order);
                },
                setFromQuaternion: function(quaternion, order, update) {
                    if (order === undefined) order = this._order;
                    if (update === undefined) update = false;
                    tempMatrix.fromQuat(quaternion);
                    return this.setFromRotationMatrix(tempMatrix, order, update);
                },
                setFromRotationMatrix: function(matrix, order, update) {
                    if (order === undefined) order = this._order;
                    if (update === undefined) update = false;
                    var elements = matrix.val;
                    //  Upper 3x3 of matrix is un-scaled rotation matrix
                    var m11 = elements[0];
                    var m12 = elements[4];
                    var m13 = elements[8];
                    var m21 = elements[1];
                    var m22 = elements[5];
                    var m23 = elements[9];
                    var m31 = elements[2];
                    var m32 = elements[6];
                    var m33 = elements[10];
                    var x = 0;
                    var y = 0;
                    var z = 0;
                    var epsilon = 0.99999;
                    switch(order){
                        case "XYZ":
                            y = Math.asin(Clamp(m13, -1, 1));
                            if (Math.abs(m13) < epsilon) {
                                x = Math.atan2(-m23, m33);
                                z = Math.atan2(-m12, m11);
                            } else x = Math.atan2(m32, m22);
                            break;
                        case "YXZ":
                            x = Math.asin(-Clamp(m23, -1, 1));
                            if (Math.abs(m23) < epsilon) {
                                y = Math.atan2(m13, m33);
                                z = Math.atan2(m21, m22);
                            } else y = Math.atan2(-m31, m11);
                            break;
                        case "ZXY":
                            x = Math.asin(Clamp(m32, -1, 1));
                            if (Math.abs(m32) < epsilon) {
                                y = Math.atan2(-m31, m33);
                                z = Math.atan2(-m12, m22);
                            } else z = Math.atan2(m21, m11);
                            break;
                        case "ZYX":
                            y = Math.asin(-Clamp(m31, -1, 1));
                            if (Math.abs(m31) < epsilon) {
                                x = Math.atan2(m32, m33);
                                z = Math.atan2(m21, m11);
                            } else z = Math.atan2(-m12, m22);
                            break;
                        case "YZX":
                            z = Math.asin(Clamp(m21, -1, 1));
                            if (Math.abs(m21) < epsilon) {
                                x = Math.atan2(-m23, m22);
                                y = Math.atan2(-m31, m11);
                            } else y = Math.atan2(m13, m33);
                            break;
                        case "XZY":
                            z = Math.asin(-Clamp(m12, -1, 1));
                            if (Math.abs(m12) < epsilon) {
                                x = Math.atan2(m32, m22);
                                y = Math.atan2(m13, m11);
                            } else x = Math.atan2(-m23, m33);
                            break;
                    }
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    if (update) this.onChangeCallback(this);
                    return this;
                }
            });
            Euler.RotationOrders = [
                "XYZ",
                "YXZ",
                "ZXY",
                "ZYX",
                "YZX",
                "XZY"
            ];
            Euler.DefaultOrder = "XYZ";
            module1.exports = Euler;
        /***/ },
        /* 844 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Floors to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.FloorTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var FloorTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.floor(value * p) / p;
            };
            module1.exports = FloorTo;
        /***/ },
        /* 845 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a per-ms speed from a distance and time (given in seconds).
 *
 * @function Phaser.Math.GetSpeed
 * @since 3.0.0
 *
 * @param {number} distance - The distance.
 * @param {number} time - The time, in seconds.
 *
 * @return {number} The speed, in distance per ms.
 *
 * @example
 * // 400px over 1 second is 0.4 px/ms
 * Phaser.Math.GetSpeed(400, 1) // -> 0.4
 */ var GetSpeed = function(distance, time) {
                return distance / time / 1000;
            };
            module1.exports = GetSpeed;
        /***/ },
        /* 846 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number.
 *
 * @function Phaser.Math.IsEven
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEven = function(value) {
                // Use abstract equality == for "is number" test
                // eslint-disable-next-line eqeqeq
                return value == parseFloat(value) ? !(value % 2) : void 0;
            };
            module1.exports = IsEven;
        /***/ },
        /* 847 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number using a strict type check.
 *
 * @function Phaser.Math.IsEvenStrict
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEvenStrict = function(value) {
                // Use strict equality === for "is number" test
                return value === parseFloat(value) ? !(value % 2) : void 0;
            };
            module1.exports = IsEvenStrict;
        /***/ },
        /* 848 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Add an `amount` to a `value`, limiting the maximum result to `max`.
 *
 * @function Phaser.Math.MaxAdd
 * @since 3.0.0
 *
 * @param {number} value - The value to add to.
 * @param {number} amount - The amount to add.
 * @param {number} max - The maximum value to return.
 *
 * @return {number} The resulting value.
 */ var MaxAdd = function(value, amount, max) {
                return Math.min(value + amount, max);
            };
            module1.exports = MaxAdd;
        /***/ },
        /* 849 */ /***/ function(module1, exports) {
            /**
 * @author       Vladislav Forsh <vlad@robowhale.com>
 * @copyright    2021 RoboWhale
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the median of the given values. The values are sorted and the middle value is returned.
 * In case of an even number of values, the average of the two middle values is returned.
 *
 * @function Phaser.Math.Median
 * @since 3.54.0
 *
 * @param {number[]} values - The values to average.
 *
 * @return {number} The median value.
 */ var Median = function(values) {
                var valuesNum = values.length;
                if (valuesNum === 0) return 0;
                values.sort(function(a, b) {
                    return a - b;
                });
                var halfIndex = Math.floor(valuesNum / 2);
                return valuesNum % 2 === 0 ? (values[halfIndex] + values[halfIndex - 1]) / 2 : values[halfIndex];
            };
            module1.exports = Median;
        /***/ },
        /* 850 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Subtract an `amount` from `value`, limiting the minimum result to `min`.
 *
 * @function Phaser.Math.MinSub
 * @since 3.0.0
 *
 * @param {number} value - The value to subtract from.
 * @param {number} amount - The amount to subtract.
 * @param {number} min - The minimum value to return.
 *
 * @return {number} The resulting value.
 */ var MinSub = function(value, amount, min) {
                return Math.max(value - amount, min);
            };
            module1.exports = MinSub;
        /***/ },
        /* 851 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Work out what percentage `value` is of the range between `min` and `max`.
 * If `max` isn't given then it will return the percentage of `value` to `min`.
 *
 * You can optionally specify an `upperMax` value, which is a mid-way point in the range that represents 100%, after which the % starts to go down to zero again.
 *
 * @function Phaser.Math.Percent
 * @since 3.0.0
 *
 * @param {number} value - The value to determine the percentage of.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 * @param {number} [upperMax] - The mid-way point in the range that represents 100%.
 *
 * @return {number} A value between 0 and 1 representing the percentage.
 */ var Percent = function(value, min, max, upperMax) {
                if (max === undefined) max = min + 1;
                var percentage = (value - min) / (max - min);
                if (percentage > 1) {
                    if (upperMax !== undefined) {
                        percentage = (upperMax - value) / (upperMax - max);
                        if (percentage < 0) percentage = 0;
                    } else percentage = 1;
                } else if (percentage < 0) percentage = 0;
                return percentage;
            };
            module1.exports = Percent;
        /***/ },
        /* 852 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random unit vector.
 *
 * Computes random values for the given vector between -1 and 1 that can be used to represent a direction.
 *
 * Optionally accepts a scale value to scale the resulting vector by.
 *
 * @function Phaser.Math.RandomXY
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector2} vector - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector2} The given Vector.
 */ var RandomXY = function(vector, scale) {
                if (scale === undefined) scale = 1;
                var r = Math.random() * 2 * Math.PI;
                vector.x = Math.cos(r) * scale;
                vector.y = Math.sin(r) * scale;
                return vector;
            };
            module1.exports = RandomXY;
        /***/ },
        /* 853 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random position vector in a spherical area, optionally defined by the given radius.
 *
 * @function Phaser.Math.RandomXYZ
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec3 - The Vector to compute random values for.
 * @param {number} [radius=1] - The radius.
 *
 * @return {Phaser.Math.Vector3} The given Vector.
 */ var RandomXYZ = function(vec3, radius) {
                if (radius === undefined) radius = 1;
                var r = Math.random() * 2 * Math.PI;
                var z = Math.random() * 2 - 1;
                var zScale = Math.sqrt(1 - z * z) * radius;
                vec3.x = Math.cos(r) * zScale;
                vec3.y = Math.sin(r) * zScale;
                vec3.z = z * radius;
                return vec3;
            };
            module1.exports = RandomXYZ;
        /***/ },
        /* 854 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random four-dimensional vector.
 *
 * @function Phaser.Math.RandomXYZW
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector4} vec4 - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector4} The given Vector.
 */ var RandomXYZW = function(vec4, scale) {
                if (scale === undefined) scale = 1;
                vec4.x = (Math.random() * 2 - 1) * scale;
                vec4.y = (Math.random() * 2 - 1) * scale;
                vec4.z = (Math.random() * 2 - 1) * scale;
                vec4.w = (Math.random() * 2 - 1) * scale;
                return vec4;
            };
            module1.exports = RandomXYZW;
        /***/ },
        /* 855 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Position a `point` at the given `angle` and `distance` to (`x`, `y`).
 *
 * @function Phaser.Math.RotateTo
 * @since 3.24.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like} point - The point to be positioned.
 * @param {number} x - The horizontal coordinate to position from.
 * @param {number} y - The vertical coordinate to position from.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateTo = function(point, x, y, angle, distance) {
                point.x = x + distance * Math.cos(angle);
                point.y = y + distance * Math.sin(angle);
                return point;
            };
            module1.exports = RotateTo;
        /***/ },
        /* 856 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a value to the given precision.
 * 
 * For example:
 * 
 * ```javascript
 * RoundTo(123.456, 0) = 123
 * RoundTo(123.456, 1) = 120
 * RoundTo(123.456, 2) = 100
 * ```
 * 
 * To round the decimal, i.e. to round to precision, pass in a negative `place`:
 * 
 * ```javascript
 * RoundTo(123.456789, 0) = 123
 * RoundTo(123.456789, -1) = 123.5
 * RoundTo(123.456789, -2) = 123.46
 * RoundTo(123.456789, -3) = 123.457
 * ```
 *
 * @function Phaser.Math.RoundTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to. Positive to round the units, negative to round the decimal.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var RoundTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.round(value * p) / p;
            };
            module1.exports = RoundTo;
        /***/ },
        /* 857 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a series of sine and cosine values.
 *
 * @function Phaser.Math.SinCosTableGenerator
 * @since 3.0.0
 *
 * @param {number} length - The number of values to generate.
 * @param {number} [sinAmp=1] - The sine value amplitude.
 * @param {number} [cosAmp=1] - The cosine value amplitude.
 * @param {number} [frequency=1] - The frequency of the values.
 *
 * @return {Phaser.Types.Math.SinCosTable} The generated values.
 */ var SinCosTableGenerator = function(length, sinAmp, cosAmp, frequency) {
                if (sinAmp === undefined) sinAmp = 1;
                if (cosAmp === undefined) cosAmp = 1;
                if (frequency === undefined) frequency = 1;
                frequency *= Math.PI / length;
                var cos = [];
                var sin = [];
                for(var c = 0; c < length; c++){
                    cosAmp -= sinAmp * frequency;
                    sinAmp += cosAmp * frequency;
                    cos[c] = cosAmp;
                    sin[c] = sinAmp;
                }
                return {
                    sin: sin,
                    cos: cos,
                    length: length
                };
            };
            module1.exports = SinCosTableGenerator;
        /***/ },
        /* 858 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Returns a Vector2 containing the x and y position of the given index in a `width` x `height` sized grid.
 * 
 * For example, in a 6 x 4 grid, index 16 would equal x: 4 y: 2.
 * 
 * If the given index is out of range an empty Vector2 is returned.
 *
 * @function Phaser.Math.ToXY
 * @since 3.19.0
 *
 * @param {number} index - The position within the grid to get the x/y value for.
 * @param {number} width - The width of the grid.
 * @param {number} height - The height of the grid.
 * @param {Phaser.Math.Vector2} [out] - An optional Vector2 to store the result in. If not given, a new Vector2 instance will be created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 where the x and y properties contain the given grid index.
 */ var ToXY = function(index, width, height, out) {
                if (out === undefined) out = new Vector2();
                var x = 0;
                var y = 0;
                var total = width * height;
                if (index > 0 && index <= total) {
                    if (index > width - 1) {
                        y = Math.floor(index / width);
                        x = index - y * width;
                    } else x = index;
                }
                return out.set(x, y);
            };
            module1.exports = ToXY;
        /***/ },
        /* 859 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the two values are within the given `tolerance` of each other.
 *
 * @function Phaser.Math.Within
 * @since 3.0.0
 *
 * @param {number} a - The first value to use in the calculation.
 * @param {number} b - The second value to use in the calculation.
 * @param {number} tolerance - The tolerance. Anything equal to or less than this value is considered as being within range.
 *
 * @return {boolean} Returns `true` if `a` is less than or equal to the tolerance of `b`.
 */ var Within = function(a, b, tolerance) {
                return Math.abs(a - b) <= tolerance;
            };
            module1.exports = Within;
        /***/ },
        /* 860 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(39);
            var Matrix4 = __webpack_require__(69);
            var Quaternion = __webpack_require__(365);
            var tmpMat4 = new Matrix4();
            var tmpQuat = new Quaternion();
            var tmpVec3 = new Vector3();
            /**
 * Rotates a vector in place by axis angle.
 *
 * This is the same as transforming a point by an
 * axis-angle quaternion, but it has higher precision.
 *
 * @function Phaser.Math.RotateVec3
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec - The vector to be rotated.
 * @param {Phaser.Math.Vector3} axis - The axis to rotate around.
 * @param {number} radians - The angle of rotation in radians.
 *
 * @return {Phaser.Math.Vector3} The given vector.
 */ var RotateVec3 = function(vec, axis, radians) {
                //  Set the quaternion to our axis angle
                tmpQuat.setAxisAngle(axis, radians);
                //  Create a rotation matrix from the axis angle
                tmpMat4.fromRotationTranslation(tmpQuat, tmpVec3.set(0, 0, 0));
                //  Multiply our vector by the rotation matrix
                return vec.transformMat4(tmpMat4);
            };
            module1.exports = RotateVec3;
        /***/ },
        /* 861 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Add Event.
 * 
 * This event is dispatched by the Texture Manager when a texture is added to it.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('addtexture', listener)`.
 *
 * @event Phaser.Textures.Events#ADD
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was added to the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was added to the Texture Manager.
 */ module1.exports = "addtexture";
        /***/ },
        /* 862 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Error Event.
 * 
 * This event is dispatched by the Texture Manager when a texture it requested to load failed.
 * This only happens when base64 encoded textures fail. All other texture types are loaded via the Loader Plugin.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('onerror', listener)`.
 *
 * @event Phaser.Textures.Events#ERROR
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that failed to load into the Texture Manager.
 */ module1.exports = "onerror";
        /***/ },
        /* 863 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Event.
 * 
 * This event is dispatched by the Texture Manager when a texture has finished loading on it.
 * This only happens for base64 encoded textures. All other texture types are loaded via the Loader Plugin.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('onload', listener)`.
 * 
 * This event is dispatched after the [ADD]{@linkcode Phaser.Textures.Events#event:ADD} event.
 *
 * @event Phaser.Textures.Events#LOAD
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was loaded by the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was loaded by the Texture Manager.
 */ module1.exports = "onload";
        /***/ },
        /* 864 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This internal event signifies that the Texture Manager is now ready and the Game can continue booting.
 * 
 * When a Phaser Game instance is booting for the first time, the Texture Manager has to wait on a couple of non-blocking
 * async events before it's fully ready to carry on. When those complete the Texture Manager emits this event via the Game
 * instance, which tells the Game to carry on booting.
 *
 * @event Phaser.Textures.Events#READY
 * @since 3.16.1
 */ module1.exports = "ready";
        /***/ },
        /* 865 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Remove Event.
 * 
 * This event is dispatched by the Texture Manager when a texture is removed from it.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('removetexture', listener)`.
 * 
 * If you have any Game Objects still using the removed texture, they will start throwing
 * errors the next time they try to render. Be sure to clear all use of the texture in this event handler.
 *
 * @event Phaser.Textures.Events#REMOVE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was removed from the Texture Manager.
 */ module1.exports = "removetexture";
        /***/ },
        /* 866 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_BITMAP_MASK_FS",
                "",
                "precision mediump float;",
                "",
                "uniform vec2 uResolution;",
                "uniform sampler2D uMainSampler;",
                "uniform sampler2D uMaskSampler;",
                "uniform bool uInvertMaskAlpha;",
                "",
                "void main ()",
                "{",
                "    vec2 uv = gl_FragCoord.xy / uResolution;",
                "    vec4 mainColor = texture2D(uMainSampler, uv);",
                "    vec4 maskColor = texture2D(uMaskSampler, uv);",
                "    float alpha = mainColor.a;",
                "",
                "    if (!uInvertMaskAlpha)",
                "    {",
                "        alpha *= (maskColor.a);",
                "    }",
                "    else",
                "    {",
                "        alpha *= (1.0 - maskColor.a);",
                "    }",
                "",
                "    gl_FragColor = vec4(mainColor.rgb * alpha, alpha);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 867 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_BITMAP_MASK_VS",
                "",
                "precision mediump float;",
                "",
                "attribute vec2 inPosition;",
                "",
                "void main ()",
                "{",
                "    gl_Position = vec4(inPosition, 0.0, 1.0);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 868 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline After Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right after it has issued a drawArrays command
 * and cleared its vertex count.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = "pipelineafterflush";
        /***/ },
        /* 869 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Before Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right before it is about to
 * flush and issue a bufferData and drawArrays command.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that is about to flush.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = "pipelinebeforeflush";
        /***/ },
        /* 870 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Bind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was bound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = "pipelinebind";
        /***/ },
        /* 871 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Boot Event.
 *
 * This event is dispatched by a WebGLPipeline when it has completed its `boot` phase.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BOOT
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that booted.
 */ module1.exports = "pipelineboot";
        /***/ },
        /* 872 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Destroy Event.
 *
 * This event is dispatched by a WebGLPipeline when it is starting its destroy process.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 */ module1.exports = "pipelinedestroy";
        /***/ },
        /* 873 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline ReBind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is re-bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#REBIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was rebound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = "pipelinerebind";
        /***/ },
        /* 874 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Resize Event.
 *
 * This event is dispatched by a WebGLPipeline when it is resized, usually as a result
 * of the Renderer resizing.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
 * @since 3.50.0
 *
 * @param {number} width - The new width of the pipeline.
 * @param {number} height - The new height of the pipeline.
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was resized.
 */ module1.exports = "pipelineresize";
        /***/ },
        /* 875 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_GRAPHICS_FS",
                "",
                "precision mediump float;",
                "",
                "varying vec4 outColor;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = vec4(outColor.bgr * outColor.a, outColor.a);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 876 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_GRAPHICS_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec4 inColor;",
                "",
                "varying vec4 outColor;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outColor = inColor;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 877 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_LIGHT_FS",
                "",
                "precision mediump float;",
                "",
                "struct Light",
                "{",
                "    vec2 position;",
                "    vec3 color;",
                "    float intensity;",
                "    float radius;",
                "};",
                "",
                "const int kMaxLights = %LIGHT_COUNT%;",
                "",
                "uniform vec4 uCamera; /* x, y, rotation, zoom */",
                "uniform vec2 uResolution;",
                "uniform sampler2D uMainSampler;",
                "uniform sampler2D uNormSampler;",
                "uniform vec3 uAmbientLightColor;",
                "uniform Light uLights[kMaxLights];",
                "uniform mat3 uInverseRotationMatrix;",
                "",
                "varying vec2 outTexCoord;",
                "varying vec4 outTint;",
                "",
                "void main()",
                "{",
                "    vec3 finalColor = vec3(0.0, 0.0, 0.0);",
                "    vec4 color = texture2D(uMainSampler, outTexCoord) * vec4(outTint.bgr * outTint.a, outTint.a);",
                "    vec3 normalMap = texture2D(uNormSampler, outTexCoord).rgb;",
                "    vec3 normal = normalize(uInverseRotationMatrix * vec3(normalMap * 2.0 - 1.0));",
                "    vec2 res = vec2(min(uResolution.x, uResolution.y)) * uCamera.w;",
                "",
                "    for (int index = 0; index < kMaxLights; ++index)",
                "    {",
                "        Light light = uLights[index];",
                "        vec3 lightDir = vec3((light.position.xy / res) - (gl_FragCoord.xy / res), 0.1);",
                "        vec3 lightNormal = normalize(lightDir);",
                "        float distToSurf = length(lightDir) * uCamera.w;",
                "        float diffuseFactor = max(dot(normal, lightNormal), 0.0);",
                "        float radius = (light.radius / res.x * uCamera.w) * uCamera.w;",
                "        float attenuation = clamp(1.0 - distToSurf * distToSurf / (radius * radius), 0.0, 1.0);",
                "        vec3 diffuse = light.color * diffuseFactor;",
                "        finalColor += (attenuation * diffuse) * light.intensity;",
                "    }",
                "",
                "    vec4 colorOutput = vec4(uAmbientLightColor + finalColor, 1.0);",
                "",
                "    gl_FragColor = color * vec4(colorOutput.rgb * colorOutput.a, colorOutput.a);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 878 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_MULTI_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler[%count%];",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTexId;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    vec4 texture;",
                "",
                "    %forloop%",
                "",
                "    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);",
                "",
                "    //  Multiply texture tint",
                "    vec4 color = texture * texel;",
                "",
                "    if (outTintEffect == 1.0)",
                "    {",
                "        //  Solid color + texture alpha",
                "        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);",
                "    }",
                "    else if (outTintEffect == 2.0)",
                "    {",
                "        //  Solid color, no texture",
                "        color = texel;",
                "    }",
                "",
                "    gl_FragColor = color;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 879 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_MULTI_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "attribute float inTexId;",
                "attribute float inTintEffect;",
                "attribute vec4 inTint;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTexId;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outTexCoord = inTexCoord;",
                "    outTexId = inTexId;",
                "    outTint = inTint;",
                "    outTintEffect = inTintEffect;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 880 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_POINTLIGHT_FS",
                "",
                "precision mediump float;",
                "",
                "uniform vec2 uResolution;",
                "uniform float uCameraZoom;",
                "",
                "varying vec4 lightPosition;",
                "varying vec4 lightColor;",
                "varying float lightRadius;",
                "varying float lightAttenuation;",
                "",
                "void main ()",
                "{",
                "    vec2 center = (lightPosition.xy + 1.0) * (uResolution.xy * 0.5);",
                "",
                "    float distToSurf = length(center - gl_FragCoord.xy);",
                "",
                "    float radius = 1.0 - distToSurf / (lightRadius * uCameraZoom);",
                "",
                "    float intensity = smoothstep(0.0, 1.0, radius * lightAttenuation);",
                "",
                "    vec4 color = vec4(intensity, intensity, intensity, 0.0) * lightColor;",
                "",
                "    gl_FragColor = vec4(color.rgb * lightColor.a, color.a);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 881 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_POINTLIGHT_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inLightPosition;",
                "attribute vec4 inLightColor;",
                "attribute float inLightRadius;",
                "attribute float inLightAttenuation;",
                "",
                "varying vec4 lightPosition;",
                "varying vec4 lightColor;",
                "varying float lightRadius;",
                "varying float lightAttenuation;",
                "",
                "void main ()",
                "{",
                "    lightColor = inLightColor;",
                "    lightRadius = inLightRadius;",
                "    lightAttenuation = inLightAttenuation;",
                "    lightPosition = uProjectionMatrix * vec4(inLightPosition, 1.0, 1.0);",
                "",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 882 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_SINGLE_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    vec4 texture = texture2D(uMainSampler, outTexCoord);",
                "    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);",
                "",
                "    //  Multiply texture tint",
                "    vec4 color = texture * texel;",
                "",
                "    if (outTintEffect == 1.0)",
                "    {",
                "        //  Solid color + texture alpha",
                "        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);",
                "    }",
                "    else if (outTintEffect == 2.0)",
                "    {",
                "        //  Solid color, no texture",
                "        color = texel;",
                "    }",
                "",
                "    gl_FragColor = color;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 883 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_SINGLE_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "attribute float inTexId;",
                "attribute float inTintEffect;",
                "attribute vec4 inTint;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outTexCoord = inTexCoord;",
                "    outTint = inTint;",
                "    outTintEffect = inTintEffect;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 884 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_ADD_BLEND_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler1;",
                "uniform sampler2D uMainSampler2;",
                "uniform float uStrength;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);",
                "    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);",
                "",
                "    gl_FragColor = frame1 + frame2 * uStrength;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 885 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_COLORMATRIX_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "uniform float uColorMatrix[20];",
                "uniform float uAlpha;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 c = texture2D(uMainSampler, outTexCoord);",
                "",
                "    if (uAlpha == 0.0)",
                "    {",
                "        gl_FragColor = c;",
                "",
                "        return;",
                "    }",
                "",
                "    if (c.a > 0.0)",
                "    {",
                "        c.rgb /= c.a;",
                "    }",
                "",
                "    vec4 result;",
                "",
                "    result.r = (uColorMatrix[0] * c.r) + (uColorMatrix[1] * c.g) + (uColorMatrix[2] * c.b) + (uColorMatrix[3] * c.a) + uColorMatrix[4];",
                "    result.g = (uColorMatrix[5] * c.r) + (uColorMatrix[6] * c.g) + (uColorMatrix[7] * c.b) + (uColorMatrix[8] * c.a) + uColorMatrix[9];",
                "    result.b = (uColorMatrix[10] * c.r) + (uColorMatrix[11] * c.g) + (uColorMatrix[12] * c.b) + (uColorMatrix[13] * c.a) + uColorMatrix[14];",
                "    result.a = (uColorMatrix[15] * c.r) + (uColorMatrix[16] * c.g) + (uColorMatrix[17] * c.b) + (uColorMatrix[18] * c.a) + uColorMatrix[19];",
                "",
                "    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);",
                "",
                "    rgb *= result.a;",
                "",
                "    gl_FragColor = vec4(rgb, result.a);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 886 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_COPY_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "uniform float uBrightness;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = texture2D(uMainSampler, outTexCoord) * uBrightness;",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 887 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_LINEAR_BLEND_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler1;",
                "uniform sampler2D uMainSampler2;",
                "uniform float uStrength;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);",
                "    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);",
                "",
                "    gl_FragColor = mix(frame1, frame2 * uStrength, 0.5);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 888 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create
 */ module1.exports = {
                GenerateTexture: __webpack_require__(388),
                Palettes: __webpack_require__(889)
            };
        /***/ },
        /* 889 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create.Palettes
 */ module1.exports = {
                ARNE16: __webpack_require__(389),
                C64: __webpack_require__(890),
                CGA: __webpack_require__(891),
                JMP: __webpack_require__(892),
                MSX: __webpack_require__(893)
            };
        /***/ },
        /* 890 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by the Commodore 64.
 *
 * @name Phaser.Create.Palettes.C64
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: "#000",
                1: "#fff",
                2: "#8b4131",
                3: "#7bbdc5",
                4: "#8b41ac",
                5: "#6aac41",
                6: "#3931a4",
                7: "#d5de73",
                8: "#945a20",
                9: "#5a4100",
                A: "#bd736a",
                B: "#525252",
                C: "#838383",
                D: "#acee8b",
                E: "#7b73de",
                F: "#acacac"
            };
        /***/ },
        /* 891 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color CGA inspired palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.CGA
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: "#000",
                1: "#2234d1",
                2: "#0c7e45",
                3: "#44aacc",
                4: "#8a3622",
                5: "#5c2e78",
                6: "#aa5c3d",
                7: "#b5b5b5",
                8: "#5e606e",
                9: "#4c81fb",
                A: "#6cd947",
                B: "#7be2f9",
                C: "#eb8a60",
                D: "#e23d69",
                E: "#ffd93f",
                F: "#fff"
            };
        /***/ },
        /* 892 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color JMP palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.JMP
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: "#000",
                1: "#191028",
                2: "#46af45",
                3: "#a1d685",
                4: "#453e78",
                5: "#7664fe",
                6: "#833129",
                7: "#9ec2e8",
                8: "#dc534b",
                9: "#e18d79",
                A: "#d6b97b",
                B: "#e9d8a1",
                C: "#216c4b",
                D: "#d365c8",
                E: "#afaab9",
                F: "#f5f4eb"
            };
        /***/ },
        /* 893 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by Japanese computers like the MSX.
 *
 * @name Phaser.Create.Palettes.MSX
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: "#000",
                1: "#191028",
                2: "#46af45",
                3: "#a1d685",
                4: "#453e78",
                5: "#7664fe",
                6: "#833129",
                7: "#9ec2e8",
                8: "#dc534b",
                9: "#e18d79",
                A: "#d6b97b",
                B: "#e9d8a1",
                C: "#216c4b",
                D: "#d365c8",
                E: "#afaab9",
                F: "#fff"
            };
        /***/ },
        /* 894 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Curves
 */ module1.exports = {
                Path: __webpack_require__(895),
                MoveTo: __webpack_require__(393),
                CubicBezier: __webpack_require__(390),
                Curve: __webpack_require__(94),
                Ellipse: __webpack_require__(391),
                Line: __webpack_require__(392),
                QuadraticBezier: __webpack_require__(394),
                Spline: __webpack_require__(395)
            };
        /***/ },
        /* 895 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var CubicBezierCurve = __webpack_require__(390);
            var EllipseCurve = __webpack_require__(391);
            var GameObjectFactory = __webpack_require__(5);
            var LineCurve = __webpack_require__(392);
            var MovePathTo = __webpack_require__(393);
            var QuadraticBezierCurve = __webpack_require__(394);
            var Rectangle = __webpack_require__(10);
            var SplineCurve = __webpack_require__(395);
            var Vector2 = __webpack_require__(3);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Path combines multiple Curves into one continuous compound curve.
 * It does not matter how many Curves are in the Path or what type they are.
 *
 * A Curve in a Path does not have to start where the previous Curve ends - that is to say, a Path does not
 * have to be an uninterrupted curve. Only the order of the Curves influences the actual points on the Path.
 *
 * @class Path
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the Path's starting point or a {@link Phaser.Types.Curves.JSONPath}.
 * @param {number} [y=0] - The Y coordinate of the Path's starting point.
 */ var Path = new Class({
                initialize: function Path(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    /**
         * The name of this Path.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.Curves.Path#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = "";
                    /**
         * The list of Curves which make up this Path.
         *
         * @name Phaser.Curves.Path#curves
         * @type {Phaser.Curves.Curve[]}
         * @default []
         * @since 3.0.0
         */ this.curves = [];
                    /**
         * The cached length of each Curve in the Path.
         *
         * Used internally by {@link #getCurveLengths}.
         *
         * @name Phaser.Curves.Path#cacheLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheLengths = [];
                    /**
         * Automatically closes the path.
         *
         * @name Phaser.Curves.Path#autoClose
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.autoClose = false;
                    /**
         * The starting point of the Path.
         *
         * This is not necessarily equivalent to the starting point of the first Curve in the Path. In an empty Path, it's also treated as the ending point.
         *
         * @name Phaser.Curves.Path#startPoint
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.startPoint = new Vector2();
                    /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                    /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                    if (typeof x === "object") this.fromJSON(x);
                    else this.startPoint.set(x, y);
                },
                /**
     * Appends a Curve to the end of the Path.
     *
     * The Curve does not have to start where the Path ends or, for an empty Path, at its defined starting point.
     *
     * @method Phaser.Curves.Path#add
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Curve} curve - The Curve to append.
     *
     * @return {this} This Path object.
     */ add: function(curve) {
                    this.curves.push(curve);
                    return this;
                },
                /**
     * Creates a circular Ellipse Curve positioned at the end of the Path.
     *
     * @method Phaser.Curves.Path#circleTo
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {boolean} [clockwise=false] - `true` to create a clockwise circle as opposed to a counter-clockwise circle.
     * @param {number} [rotation=0] - The rotation of the circle in degrees.
     *
     * @return {this} This Path object.
     */ circleTo: function(radius, clockwise, rotation) {
                    if (clockwise === undefined) clockwise = false;
                    return this.ellipseTo(radius, radius, 0, 360, clockwise, rotation);
                },
                /**
     * Ensures that the Path is closed.
     *
     * A closed Path starts and ends at the same point. If the Path is not closed, a straight Line Curve will be created from the ending point directly to the starting point. During the check, the actual starting point of the Path, i.e. the starting point of the first Curve, will be used as opposed to the Path's defined {@link startPoint}, which could differ.
     *
     * Calling this method on an empty Path will result in an error.
     *
     * @method Phaser.Curves.Path#closePath
     * @since 3.0.0
     *
     * @return {this} This Path object.
     */ closePath: function() {
                    // Add a line curve if start and end of lines are not connected
                    var startPoint = this.curves[0].getPoint(0);
                    var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                    if (!startPoint.equals(endPoint)) //  This will copy a reference to the vectors, which probably isn't sensible
                    this.curves.push(new LineCurve(endPoint, startPoint));
                    return this;
                },
                /**
     * Creates a cubic bezier curve starting at the previous end point and ending at p3, using p1 and p2 as control points.
     *
     * @method Phaser.Curves.Path#cubicBezierTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The x coordinate of the end point. Or, if a Vector2, the p1 value.
     * @param {(number|Phaser.Math.Vector2)} y - The y coordinate of the end point. Or, if a Vector2, the p2 value.
     * @param {(number|Phaser.Math.Vector2)} control1X - The x coordinate of the first control point. Or, if a Vector2, the p3 value.
     * @param {number} [control1Y] - The y coordinate of the first control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2X] - The x coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2Y] - The y coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     *
     * @return {this} This Path object.
     */ cubicBezierTo: function(x, y, control1X, control1Y, control2X, control2Y) {
                    var p0 = this.getEndPoint();
                    var p1;
                    var p2;
                    var p3;
                    //  Assume they're all Vector2s
                    if (x instanceof Vector2) {
                        p1 = x;
                        p2 = y;
                        p3 = control1X;
                    } else {
                        p1 = new Vector2(control1X, control1Y);
                        p2 = new Vector2(control2X, control2Y);
                        p3 = new Vector2(x, y);
                    }
                    return this.add(new CubicBezierCurve(p0, p1, p2, p3));
                },
                //  Creates a quadratic bezier curve starting at the previous end point and ending at p2, using p1 as a control point
                /**
     * Creates a Quadratic Bezier Curve starting at the ending point of the Path.
     *
     * @method Phaser.Curves.Path#quadraticBezierTo
     * @since 3.2.0
     *
     * @param {(number|Phaser.Math.Vector2[])} x - The X coordinate of the second control point or, if it's a `Vector2`, the first control point.
     * @param {number} [y] - The Y coordinate of the second control point or, if `x` is a `Vector2`, the second control point.
     * @param {number} [controlX] - If `x` is not a `Vector2`, the X coordinate of the first control point.
     * @param {number} [controlY] - If `x` is not a `Vector2`, the Y coordinate of the first control point.
     *
     * @return {this} This Path object.
     */ quadraticBezierTo: function(x, y, controlX, controlY) {
                    var p0 = this.getEndPoint();
                    var p1;
                    var p2;
                    //  Assume they're all Vector2s
                    if (x instanceof Vector2) {
                        p1 = x;
                        p2 = y;
                    } else {
                        p1 = new Vector2(controlX, controlY);
                        p2 = new Vector2(x, y);
                    }
                    return this.add(new QuadraticBezierCurve(p0, p1, p2));
                },
                /**
     * Draws all Curves in the Path to a Graphics Game Object.
     *
     * @method Phaser.Curves.Path#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [out,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics Game Object to draw to.
     * @param {number} [pointsTotal=32] - The number of points to draw for each Curve. Higher numbers result in a smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object which was drawn to.
     */ draw: function(graphics, pointsTotal) {
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        curve.draw(graphics, pointsTotal);
                    }
                    return graphics;
                },
                /**
     * Creates an ellipse curve positioned at the previous end point, using the given parameters.
     *
     * @method Phaser.Curves.Path#ellipseTo
     * @since 3.0.0
     *
     * @param {number} [xRadius=0] - The horizontal radius of ellipse.
     * @param {number} [yRadius=0] - The vertical radius of ellipse.
     * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
     * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
     * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
     * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
     *
     * @return {this} This Path object.
     */ ellipseTo: function(xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                    var ellipse = new EllipseCurve(0, 0, xRadius, yRadius, startAngle, endAngle, clockwise, rotation);
                    var end = this.getEndPoint(this._tmpVec2A);
                    //  Calculate where to center the ellipse
                    var start = ellipse.getStartPoint(this._tmpVec2B);
                    end.subtract(start);
                    ellipse.x = end.x;
                    ellipse.y = end.y;
                    return this.add(ellipse);
                },
                /**
     * Creates a Path from a Path Configuration object.
     *
     * The provided object should be a {@link Phaser.Types.Curves.JSONPath}, as returned by {@link #toJSON}. Providing a malformed object may cause errors.
     *
     * @method Phaser.Curves.Path#fromJSON
     * @since 3.0.0
     *
     * @param {Phaser.Types.Curves.JSONPath} data - The JSON object containing the Path data.
     *
     * @return {this} This Path object.
     */ fromJSON: function(data) {
                    //  data should be an object matching the Path.toJSON object structure.
                    this.curves = [];
                    this.cacheLengths = [];
                    this.startPoint.set(data.x, data.y);
                    this.autoClose = data.autoClose;
                    for(var i = 0; i < data.curves.length; i++){
                        var curve = data.curves[i];
                        switch(curve.type){
                            case "LineCurve":
                                this.add(LineCurve.fromJSON(curve));
                                break;
                            case "EllipseCurve":
                                this.add(EllipseCurve.fromJSON(curve));
                                break;
                            case "SplineCurve":
                                this.add(SplineCurve.fromJSON(curve));
                                break;
                            case "CubicBezierCurve":
                                this.add(CubicBezierCurve.fromJSON(curve));
                                break;
                            case "QuadraticBezierCurve":
                                this.add(QuadraticBezierCurve.fromJSON(curve));
                                break;
                        }
                    }
                    return this;
                },
                /**
     * Returns a Rectangle with a position and size matching the bounds of this Path.
     *
     * @method Phaser.Curves.Path#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations. Higher values are more accurate at the cost of calculation speed.
     *
     * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
     */ getBounds: function(out, accuracy) {
                    if (out === undefined) out = new Rectangle();
                    if (accuracy === undefined) accuracy = 16;
                    out.x = Number.MAX_VALUE;
                    out.y = Number.MAX_VALUE;
                    var bounds = new Rectangle();
                    var maxRight = MATH_CONST.MIN_SAFE_INTEGER;
                    var maxBottom = MATH_CONST.MIN_SAFE_INTEGER;
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        curve.getBounds(bounds, accuracy);
                        out.x = Math.min(out.x, bounds.x);
                        out.y = Math.min(out.y, bounds.y);
                        maxRight = Math.max(maxRight, bounds.right);
                        maxBottom = Math.max(maxBottom, bounds.bottom);
                    }
                    out.right = maxRight;
                    out.bottom = maxBottom;
                    return out;
                },
                /**
     * Returns an array containing the length of the Path at the end of each Curve.
     *
     * The result of this method will be cached to avoid recalculating it in subsequent calls. The cache is only invalidated when the {@link #curves} array changes in length, leading to potential inaccuracies if a Curve in the Path is changed, or if a Curve is removed and another is added in its place.
     *
     * @method Phaser.Curves.Path#getCurveLengths
     * @since 3.0.0
     *
     * @return {number[]} An array containing the length of the Path at the end of each one of its Curves.
     */ getCurveLengths: function() {
                    // We use cache values if curves and cache array are same length
                    if (this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                    // Get length of sub-curve
                    // Push sums into cached array
                    var lengths = [];
                    var sums = 0;
                    for(var i = 0; i < this.curves.length; i++){
                        sums += this.curves[i].getLength();
                        lengths.push(sums);
                    }
                    this.cacheLengths = lengths;
                    return lengths;
                },
                /**
     * Returns the ending point of the Path.
     *
     * A Path's ending point is equivalent to the ending point of the last Curve in the Path. For an empty Path, the ending point is at the Path's defined {@link #startPoint}.
     *
     * @method Phaser.Curves.Path#getEndPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - The object to store the point in.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getEndPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    if (this.curves.length > 0) this.curves[this.curves.length - 1].getPoint(1, out);
                    else out.copy(this.startPoint);
                    return out;
                },
                /**
     * Returns the total length of the Path.
     *
     * @see {@link #getCurveLengths}
     *
     * @method Phaser.Curves.Path#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the Path.
     */ getLength: function() {
                    var lens = this.getCurveLengths();
                    return lens[lens.length - 1];
                },
                // To get accurate point with reference to
                // entire path distance at time t,
                // following has to be done:
                // 1. Length of each sub path have to be known
                // 2. Locate and identify type of curve
                // 3. Get t for the curve
                // 4. Return curve.getPointAt(t')
                /**
     * Calculates the coordinates of the point at the given normalized location (between 0 and 1) on the Path.
     *
     * The location is relative to the entire Path, not to an individual Curve. A location of 0.5 is always in the middle of the Path and is thus an equal distance away from both its starting and ending points. In a Path with one Curve, it would be in the middle of the Curve; in a Path with two Curves, it could be anywhere on either one of them depending on their lengths.
     *
     * @method Phaser.Curves.Path#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The location of the point to return, between 0 and 1.
     * @param {Phaser.Math.Vector2} [out] - The object in which to store the calculated point.
     *
     * @return {?Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var d = t * this.getLength();
                    var curveLengths = this.getCurveLengths();
                    var i = 0;
                    while(i < curveLengths.length){
                        if (curveLengths[i] >= d) {
                            var diff = curveLengths[i] - d;
                            var curve = this.curves[i];
                            var segmentLength = curve.getLength();
                            var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                            return curve.getPointAt(u, out);
                        }
                        i++;
                    }
                    // loop where sum != 0, sum > d , sum+1 <d
                    return null;
                },
                /**
     * Get a sequence of points on the path.
     *
     * @method Phaser.Curves.Path#getPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=12] - The number of divisions per resolution per curve.
     *
     * @return {Phaser.Math.Vector2[]} An array of Vector2 objects that containing the points along the Path.
     */ getPoints: function(divisions) {
                    if (divisions === undefined) divisions = 12;
                    var points = [];
                    var last;
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        var resolution = curve.getResolution(divisions);
                        var pts = curve.getPoints(resolution);
                        for(var j = 0; j < pts.length; j++){
                            var point = pts[j];
                            if (last && last.equals(point)) continue;
                            points.push(point);
                            last = point;
                        }
                    }
                    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                    return points;
                },
                /**
     * Returns a randomly chosen point anywhere on the path. This follows the same rules as `getPoint` in that it may return a point on any Curve inside this path.
     *
     * When calling this method multiple times, the points are not guaranteed to be equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getRandomPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(Math.random(), out);
                },
                /**
     * Divides this Path into a set of equally spaced points,
     *
     * The resulting points are equally spaced with respect to the points' position on the path, but not necessarily equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=40] - The amount of points to divide this Path into.
     *
     * @return {Phaser.Math.Vector2[]} A list of the points this path was subdivided into.
     */ getSpacedPoints: function(divisions) {
                    if (divisions === undefined) divisions = 40;
                    var points = [];
                    for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                    if (this.autoClose) points.push(points[0]);
                    return points;
                },
                /**
     * Returns the starting point of the Path.
     *
     * @method Phaser.Curves.Path#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.startPoint);
                },
                /**
     * Gets a unit vector tangent at a relative position on the path.
     *
     * @method Phaser.Curves.Path#getTangent
     * @since 3.23.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the path, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var d = t * this.getLength();
                    var curveLengths = this.getCurveLengths();
                    var i = 0;
                    while(i < curveLengths.length){
                        if (curveLengths[i] >= d) {
                            var diff = curveLengths[i] - d;
                            var curve = this.curves[i];
                            var segmentLength = curve.getLength();
                            var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                            return curve.getTangentAt(u, out);
                        }
                        i++;
                    }
                    return null;
                },
                /**
     * Creates a line curve from the previous end point to x/y.
     *
     * @method Phaser.Curves.Path#lineTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The X coordinate of the line's end point, or a `Vector2` containing the entire end point.
     * @param {number} [y] - The Y coordinate of the line's end point, if a number was passed as the X parameter.
     *
     * @return {this} This Path object.
     */ lineTo: function(x, y) {
                    if (x instanceof Vector2) this._tmpVec2B.copy(x);
                    else this._tmpVec2B.set(x, y);
                    var end = this.getEndPoint(this._tmpVec2A);
                    return this.add(new LineCurve([
                        end.x,
                        end.y,
                        this._tmpVec2B.x,
                        this._tmpVec2B.y
                    ]));
                },
                /**
     * Creates a spline curve starting at the previous end point, using the given points on the curve.
     *
     * @method Phaser.Curves.Path#splineTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2[]} points - The points the newly created spline curve should consist of.
     *
     * @return {this} This Path object.
     */ splineTo: function(points) {
                    points.unshift(this.getEndPoint());
                    return this.add(new SplineCurve(points));
                },
                /**
     * Creates a "gap" in this path from the path's current end point to the given coordinates.
     *
     * After calling this function, this Path's end point will be equal to the given coordinates
     *
     * @method Phaser.Curves.Path#moveTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The X coordinate of the position to move the path's end point to, or a `Vector2` containing the entire new end point.
     * @param {number} [y] - The Y coordinate of the position to move the path's end point to, if a number was passed as the X coordinate.
     *
     * @return {this} This Path object.
     */ moveTo: function(x, y) {
                    if (x instanceof Vector2) return this.add(new MovePathTo(x.x, x.y));
                    else return this.add(new MovePathTo(x, y));
                },
                /**
     * Converts this Path to a JSON object containing the path information and its constituent curves.
     *
     * @method Phaser.Curves.Path#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONPath} The JSON object containing this path's data.
     */ toJSON: function() {
                    var out = [];
                    for(var i = 0; i < this.curves.length; i++)out.push(this.curves[i].toJSON());
                    return {
                        type: "Path",
                        x: this.startPoint.x,
                        y: this.startPoint.y,
                        autoClose: this.autoClose,
                        curves: out
                    };
                },
                /**
     * cacheLengths must be recalculated.
     *
     * @method Phaser.Curves.Path#updateArcLengths
     * @since 3.0.0
     */ updateArcLengths: function() {
                    this.cacheLengths = [];
                    this.getCurveLengths();
                },
                /**
     * Disposes of this Path, clearing its internal references to objects so they can be garbage-collected.
     *
     * @method Phaser.Curves.Path#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.curves.length = 0;
                    this.cacheLengths.length = 0;
                    this.startPoint = undefined;
                }
            });
            /**
 * Creates a new Path Object.
 *
 * @method Phaser.GameObjects.GameObjectFactory#path
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Path.
 * @param {number} y - The vertical position of this Path.
 *
 * @return {Phaser.Curves.Path} The Path Object that was created.
 */ GameObjectFactory.register("path", function(x, y) {
                return new Path(x, y);
            });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            module1.exports = Path;
        /***/ },
        /* 896 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data
 */ module1.exports = {
                DataManager: __webpack_require__(101),
                DataManagerPlugin: __webpack_require__(897),
                Events: __webpack_require__(315)
            };
        /***/ },
        /* 897 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DataManager = __webpack_require__(101);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The Data Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManagerPlugin
 * @extends Phaser.Data.DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this DataManager belongs to.
 */ var DataManagerPlugin = new Class({
                Extends: DataManager,
                initialize: function DataManagerPlugin(scene) {
                    DataManager.call(this, scene, scene.sys.events);
                    /**
         * A reference to the Scene that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManagerPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene's Systems.
         *
         * @name Phaser.Data.DataManagerPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.events = this.systems.events;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Data.DataManagerPlugin#shutdown
     * @private
     * @since 3.5.0
     */ shutdown: function() {
                    this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Data.DataManagerPlugin#destroy
     * @since 3.5.0
     */ destroy: function() {
                    DataManager.prototype.destroy.call(this);
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("DataManagerPlugin", DataManagerPlugin, "data");
            module1.exports = DataManagerPlugin;
        /***/ },
        /* 898 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display
 */ module1.exports = {
                Align: __webpack_require__(899),
                BaseShader: __webpack_require__(396),
                Bounds: __webpack_require__(902),
                Canvas: __webpack_require__(906),
                Color: __webpack_require__(397),
                ColorMatrix: __webpack_require__(198),
                Masks: __webpack_require__(916),
                RGB: __webpack_require__(200)
            };
        /***/ },
        /* 899 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(123);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Display.Align
 */ var Align = {
                In: __webpack_require__(900),
                To: __webpack_require__(901)
            };
            //   Merge in the consts
            Align = Extend(false, Align, CONST);
            module1.exports = Align;
        /***/ },
        /* 900 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.In
 */ module1.exports = {
                BottomCenter: __webpack_require__(290),
                BottomLeft: __webpack_require__(291),
                BottomRight: __webpack_require__(292),
                Center: __webpack_require__(293),
                LeftCenter: __webpack_require__(295),
                QuickSet: __webpack_require__(289),
                RightCenter: __webpack_require__(296),
                TopCenter: __webpack_require__(297),
                TopLeft: __webpack_require__(298),
                TopRight: __webpack_require__(299)
            };
        /***/ },
        /* 901 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.To
 */ module1.exports = {
                BottomCenter: __webpack_require__(277),
                BottomLeft: __webpack_require__(278),
                BottomRight: __webpack_require__(279),
                LeftBottom: __webpack_require__(280),
                LeftCenter: __webpack_require__(281),
                LeftTop: __webpack_require__(282),
                QuickSet: __webpack_require__(276),
                RightBottom: __webpack_require__(283),
                RightCenter: __webpack_require__(284),
                RightTop: __webpack_require__(285),
                TopCenter: __webpack_require__(286),
                TopLeft: __webpack_require__(287),
                TopRight: __webpack_require__(288)
            };
        /***/ },
        /* 902 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Bounds
 */ module1.exports = {
                CenterOn: __webpack_require__(294),
                GetBottom: __webpack_require__(42),
                GetBounds: __webpack_require__(903),
                GetCenterX: __webpack_require__(87),
                GetCenterY: __webpack_require__(89),
                GetLeft: __webpack_require__(43),
                GetOffsetX: __webpack_require__(904),
                GetOffsetY: __webpack_require__(905),
                GetRight: __webpack_require__(44),
                GetTop: __webpack_require__(45),
                SetBottom: __webpack_require__(55),
                SetCenterX: __webpack_require__(88),
                SetCenterY: __webpack_require__(90),
                SetLeft: __webpack_require__(53),
                SetRight: __webpack_require__(54),
                SetTop: __webpack_require__(52)
            };
        /***/ },
        /* 903 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(42);
            var GetLeft = __webpack_require__(43);
            var GetRight = __webpack_require__(44);
            var GetTop = __webpack_require__(45);
            /**
 * Returns the unrotated bounds of the Game Object as a rectangle.
 *
 * @function Phaser.Display.Bounds.GetBounds
 * @since 3.24.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in.
 *
 * @return {(Phaser.Geom.Rectangle|object)} - The bounds of the Game Object.
 */ var GetBounds = function(gameObject, output) {
                if (output === undefined) output = {};
                var left = GetLeft(gameObject);
                var top = GetTop(gameObject);
                output.x = left;
                output.y = top;
                output.width = GetRight(gameObject) - left;
                output.height = GetBottom(gameObject) - top;
                return output;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 904 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its x coordinate.
 * This is the same as `width * origin.x`.
 * This value will only be > 0 if `origin.x` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The horizontal offset of the Game Object.
 */ var GetOffsetX = function(gameObject) {
                return gameObject.width * gameObject.originX;
            };
            module1.exports = GetOffsetX;
        /***/ },
        /* 905 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its y coordinate.
 * This is the same as `width * origin.y`.
 * This value will only be > 0 if `origin.y` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The vertical offset of the Game Object.
 */ var GetOffsetY = function(gameObject) {
                return gameObject.height * gameObject.originY;
            };
            module1.exports = GetOffsetY;
        /***/ },
        /* 906 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas
 */ module1.exports = {
                CanvasInterpolation: __webpack_require__(367),
                CanvasPool: __webpack_require__(31),
                Smoothing: __webpack_require__(192),
                TouchAction: __webpack_require__(907),
                UserSelect: __webpack_require__(908)
            };
        /***/ },
        /* 907 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the touch-action property on the canvas style. Can be used to disable default browser touch actions.
 *
 * @function Phaser.Display.Canvas.TouchAction
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch action value to set on the canvas. Set to `none` to disable touch actions.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var TouchAction = function(canvas, value) {
                if (value === undefined) value = "none";
                canvas.style["msTouchAction"] = value;
                canvas.style["ms-touch-action"] = value;
                canvas.style["touch-action"] = value;
                return canvas;
            };
            module1.exports = TouchAction;
        /***/ },
        /* 908 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the user-select property on the canvas style. Can be used to disable default browser selection actions.
 *
 * @function Phaser.Display.Canvas.UserSelect
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch callout value to set on the canvas. Set to `none` to disable touch callouts.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var UserSelect = function(canvas, value) {
                if (value === undefined) value = "none";
                var vendors = [
                    "-webkit-",
                    "-khtml-",
                    "-moz-",
                    "-ms-",
                    ""
                ];
                vendors.forEach(function(vendor) {
                    canvas.style[vendor + "user-select"] = value;
                });
                canvas.style["-webkit-touch-callout"] = value;
                canvas.style["-webkit-tap-highlight-color"] = "rgba(0, 0, 0, 0)";
                return canvas;
            };
            module1.exports = UserSelect;
        /***/ },
        /* 909 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(103);
            /**
 * Return an array of Colors in a Color Spectrum.
 *
 * The spectrum colors flow in the order: red, yellow, green, blue.
 *
 * By default this function will return an array with 1024 elements in.
 *
 * However, you can reduce this to a smaller quantity if needed, by specitying the `limit` parameter.
 *
 * @function Phaser.Display.Color.ColorSpectrum
 * @since 3.50.0
 *
 * @param {number} [limit=1024] - How many colors should be returned? The maximum is 1024 but you can set a smaller quantity if required.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing `limit` parameter number of elements, where each contains a Color Object.
 */ var ColorSpectrum = function(limit) {
                if (limit === undefined) limit = 1024;
                var colors = [];
                var range = 255;
                var i;
                var r = 255;
                var g = 0;
                var b = 0;
                //  Red to Yellow
                for(i = 0; i <= range; i++)colors.push({
                    r: r,
                    g: i,
                    b: b,
                    color: GetColor(r, i, b)
                });
                g = 255;
                //  Yellow to Green
                for(i = range; i >= 0; i--)colors.push({
                    r: i,
                    g: g,
                    b: b,
                    color: GetColor(i, g, b)
                });
                r = 0;
                //  Green to Blue
                for(i = 0; i <= range; i++, g--)colors.push({
                    r: r,
                    g: g,
                    b: i,
                    color: GetColor(r, g, i)
                });
                g = 0;
                b = 255;
                //  Blue to Red
                for(i = 0; i <= range; i++, b--, r++)colors.push({
                    r: r,
                    g: g,
                    b: b,
                    color: GetColor(r, g, b)
                });
                if (limit === 1024) return colors;
                else {
                    var out = [];
                    var t = 0;
                    var inc = 1024 / limit;
                    for(i = 0; i < limit; i++){
                        out.push(colors[Math.floor(t)]);
                        t += inc;
                    }
                    return out;
                }
            };
            module1.exports = ColorSpectrum;
        /***/ },
        /* 910 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts the given color value into an Object containing r,g,b and a properties.
 *
 * @function Phaser.Display.Color.ColorToRGBA
 * @since 3.0.0
 *
 * @param {number} color - A color value, optionally including the alpha value.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the parsed color values.
 */ var ColorToRGBA = function(color) {
                var output = {
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF,
                    a: 255
                };
                if (color > 16777215) output.a = color >>> 24;
                return output;
            };
            module1.exports = ColorToRGBA;
        /***/ },
        /* 911 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(38);
            var HueToComponent = __webpack_require__(399);
            /**
 * Converts HSL (hue, saturation and lightness) values to a Phaser Color object.
 *
 * @function Phaser.Display.Color.HSLToColor
 * @since 3.0.0
 *
 * @param {number} h - The hue value in the range 0 to 1.
 * @param {number} s - The saturation value in the range 0 to 1.
 * @param {number} l - The lightness value in the range 0 to 1.
 *
 * @return {Phaser.Display.Color} A Color object created from the results of the h, s and l values.
 */ var HSLToColor = function(h, s, l) {
                // achromatic by default
                var r = l;
                var g = l;
                var b = l;
                if (s !== 0) {
                    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    var p = 2 * l - q;
                    r = HueToComponent(p, q, h + 1 / 3);
                    g = HueToComponent(p, q, h);
                    b = HueToComponent(p, q, h - 1 / 3);
                }
                var color = new Color();
                return color.setGLTo(r, g, b, 1);
            };
            module1.exports = HSLToColor;
        /***/ },
        /* 912 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HSVToRGB = __webpack_require__(188);
            /**
 * Get HSV color wheel values in an array which will be 360 elements in size.
 *
 * @function Phaser.Display.Color.HSVColorWheel
 * @since 3.0.0
 *
 * @param {number} [s=1] - The saturation, in the range 0 - 1.
 * @param {number} [v=1] - The value, in the range 0 - 1.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing 360 elements, where each contains a single numeric value corresponding to the color at that point in the HSV color wheel.
 */ var HSVColorWheel = function(s, v) {
                if (s === undefined) s = 1;
                if (v === undefined) v = 1;
                var colors = [];
                for(var c = 0; c <= 359; c++)colors.push(HSVToRGB(c / 359, s, v));
                return colors;
            };
            module1.exports = HSVColorWheel;
        /***/ },
        /* 913 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(135);
            /**
 * @namespace Phaser.Display.Color.Interpolate
 * @memberof Phaser.Display.Color
 * @since 3.0.0
 */ /**
 * Interpolates between the two given color ranges over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.RGBWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {number} r1 - Red value.
 * @param {number} g1 - Blue value.
 * @param {number} b1 - Green value.
 * @param {number} r2 - Red value.
 * @param {number} g2 - Blue value.
 * @param {number} b2 - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var RGBWithRGB = function(r1, g1, b1, r2, g2, b2, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                var t = index / length;
                return {
                    r: Linear(r1, r2, t),
                    g: Linear(g1, g2, t),
                    b: Linear(b1, b2, t)
                };
            };
            /**
 * Interpolates between the two given color objects over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithColor
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {Phaser.Display.Color} color2 - The second Color object.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithColor = function(color1, color2, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                return RGBWithRGB(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b, length, index);
            };
            /**
 * Interpolates between the Color object and color values over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {number} r - Red value.
 * @param {number} g - Blue value.
 * @param {number} b - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithRGB = function(color, r, g, b, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                return RGBWithRGB(color.r, color.g, color.b, r, g, b, length, index);
            };
            module1.exports = {
                RGBWithRGB: RGBWithRGB,
                ColorWithRGB: ColorWithRGB,
                ColorWithColor: ColorWithColor
            };
        /***/ },
        /* 914 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(195);
            var Color = __webpack_require__(38);
            /**
 * Creates a new Color object where the r, g, and b values have been set to random values
 * based on the given min max values.
 *
 * @function Phaser.Display.Color.RandomRGB
 * @since 3.0.0
 *
 * @param {number} [min=0] - The minimum value to set the random range from (between 0 and 255)
 * @param {number} [max=255] - The maximum value to set the random range from (between 0 and 255)
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RandomRGB = function(min, max) {
                if (min === undefined) min = 0;
                if (max === undefined) max = 255;
                return new Color(Between(min, max), Between(min, max), Between(min, max));
            };
            module1.exports = RandomRGB;
        /***/ },
        /* 915 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ComponentToHex = __webpack_require__(398);
            /**
 * Converts the color values into an HTML compatible color string, prefixed with either `#` or `0x`.
 *
 * @function Phaser.Display.Color.RGBToString
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {number} [a=255] - The alpha value. A number between 0 and 255.
 * @param {string} [prefix=#] - The prefix of the string. Either `#` or `0x`.
 *
 * @return {string} A string-based representation of the color values.
 */ var RGBToString = function(r, g, b, a, prefix) {
                if (a === undefined) a = 255;
                if (prefix === undefined) prefix = "#";
                if (prefix === "#") return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1, 7);
                else return "0x" + ComponentToHex(a) + ComponentToHex(r) + ComponentToHex(g) + ComponentToHex(b);
            };
            module1.exports = RGBToString;
        /***/ },
        /* 916 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Masks
 */ module1.exports = {
                BitmapMask: __webpack_require__(310),
                GeometryMask: __webpack_require__(311)
            };
        /***/ },
        /* 917 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.DOM
 */ var Dom = {
                AddToDOM: __webpack_require__(142),
                DOMContentLoaded: __webpack_require__(400),
                GetInnerHeight: __webpack_require__(401),
                GetScreenOrientation: __webpack_require__(402),
                GetTarget: __webpack_require__(407),
                ParseXML: __webpack_require__(408),
                RemoveFromDOM: __webpack_require__(202),
                RequestAnimationFrame: __webpack_require__(386)
            };
            module1.exports = Dom;
        /***/ },
        /* 918 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Events
 */ module1.exports = {
                EventEmitter: __webpack_require__(919)
            };
        /***/ },
        /* 919 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EE = __webpack_require__(9);
            var PluginCache = __webpack_require__(24);
            /**
 * @classdesc
 * EventEmitter is a Scene Systems plugin compatible version of eventemitter3.
 *
 * @class EventEmitter
 * @memberof Phaser.Events
 * @constructor
 * @since 3.0.0
 */ var EventEmitter = new Class({
                Extends: EE,
                initialize: function EventEmitter() {
                    EE.call(this);
                },
                /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.removeAllListeners();
                },
                /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllListeners();
                }
            });
            /**
 * Return an array listing the events for which the emitter has registered listeners.
 *
 * @method Phaser.Events.EventEmitter#eventNames
 * @since 3.0.0
 *
 * @return {Array.<string|symbol>}
 */ /**
 * Return the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#listeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {Function[]} The registered listeners.
 */ /**
 * Return the number of listeners listening to a given event.
 *
 * @method Phaser.Events.EventEmitter#listenerCount
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {number} The number of listeners.
 */ /**
 * Calls each of the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#emit
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {...*} [args] - Additional arguments that will be passed to the event handler.
 *
 * @return {boolean} `true` if the event had listeners, else `false`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#on
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#addListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a one-time listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#once
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#removeListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#off
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove all listeners, or those of the specified event.
 *
 * @method Phaser.Events.EventEmitter#removeAllListeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} [event] - The event name.
 *
 * @return {this} `this`.
 */ PluginCache.register("EventEmitter", EventEmitter, "events");
            module1.exports = EventEmitter;
        /***/ },
        /* 920 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(142);
            var AnimationManager = __webpack_require__(321);
            var CacheManager = __webpack_require__(325);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Config = __webpack_require__(346);
            var CreateDOMContainer = __webpack_require__(921);
            var CreateRenderer = __webpack_require__(366);
            var DataManager = __webpack_require__(101);
            var DebugHeader = __webpack_require__(384);
            var Device = __webpack_require__(347);
            var DOMContentLoaded = __webpack_require__(400);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(22);
            var InputManager = __webpack_require__(409);
            var PluginCache = __webpack_require__(24);
            var PluginManager = __webpack_require__(414);
            var ScaleManager = __webpack_require__(415);
            var SceneManager = __webpack_require__(417);
            var TextureEvents = __webpack_require__(106);
            var TextureManager = __webpack_require__(422);
            var TimeStep = __webpack_require__(385);
            var VisibilityHandler = __webpack_require__(387);
            var SoundManagerCreator = __webpack_require__(426);
            var FacebookInstantGamesPlugin;
            /**
 * @classdesc
 * The Phaser.Game instance is the main controller for the entire Phaser game. It is responsible
 * for handling the boot process, parsing the configuration values, creating the renderer,
 * and setting-up all of the global Phaser systems, such as sound and input.
 * Once that is complete it will start the Scene Manager and then begin the main game loop.
 *
 * You should generally avoid accessing any of the systems created by Game, and instead use those
 * made available to you via the Phaser.Scene Systems class instead.
 *
 * @class Game
 * @memberof Phaser
 * @constructor
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 */ var Game = new Class({
                initialize: function Game(config) {
                    /**
         * The parsed Game Configuration object.
         *
         * The values stored within this object are read-only and should not be changed at run-time.
         *
         * @name Phaser.Game#config
         * @type {Phaser.Core.Config}
         * @readonly
         * @since 3.0.0
         */ this.config = new Config(config);
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Game#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = null;
                    /**
         * A reference to an HTML Div Element used as the DOM Element Container.
         *
         * Only set if `createDOMContainer` is `true` in the game config (by default it is `false`) and
         * if you provide a parent element to insert the Phaser Game inside.
         *
         * See the DOM Element Game Object for more details.
         *
         * @name Phaser.Game#domContainer
         * @type {HTMLDivElement}
         * @since 3.17.0
         */ this.domContainer = null;
                    /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         * This is created automatically by Phaser unless you provide a `canvas` property
         * in your Game Config.
         *
         * @name Phaser.Game#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = null;
                    /**
         * A reference to the Rendering Context belonging to the Canvas Element this game is rendering to.
         * If the game is running under Canvas it will be a 2d Canvas Rendering Context.
         * If the game is running under WebGL it will be a WebGL Rendering Context.
         * This context is created automatically by Phaser unless you provide a `context` property
         * in your Game Config.
         *
         * @name Phaser.Game#context
         * @type {(CanvasRenderingContext2D|WebGLRenderingContext)}
         * @since 3.0.0
         */ this.context = null;
                    /**
         * A flag indicating when this Game instance has finished its boot process.
         *
         * @name Phaser.Game#isBooted
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isBooted = false;
                    /**
         * A flag indicating if this Game is currently running its game step or not.
         *
         * @name Phaser.Game#isRunning
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isRunning = false;
                    /**
         * An Event Emitter which is used to broadcast game-level events from the global systems.
         *
         * @name Phaser.Game#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                    /**
         * An instance of the Animation Manager.
         *
         * The Animation Manager is a global system responsible for managing all animations used within your game.
         *
         * @name Phaser.Game#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims = new AnimationManager(this);
                    /**
         * An instance of the Texture Manager.
         *
         * The Texture Manager is a global system responsible for managing all textures being used by your game.
         *
         * @name Phaser.Game#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures = new TextureManager(this);
                    /**
         * An instance of the Cache Manager.
         *
         * The Cache Manager is a global system responsible for caching, accessing and releasing external game assets.
         *
         * @name Phaser.Game#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache = new CacheManager(this);
                    /**
         * An instance of the Data Manager
         *
         * @name Phaser.Game#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry = new DataManager(this);
                    /**
         * An instance of the Input Manager.
         *
         * The Input Manager is a global system responsible for the capture of browser-level input events.
         *
         * @name Phaser.Game#input
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.input = new InputManager(this, this.config);
                    /**
         * An instance of the Scene Manager.
         *
         * The Scene Manager is a global system responsible for creating, modifying and updating the Scenes in your game.
         *
         * @name Phaser.Game#scene
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.scene = new SceneManager(this, this.config.sceneConfig);
                    /**
         * A reference to the Device inspector.
         *
         * Contains information about the device running this game, such as OS, browser vendor and feature support.
         * Used by various systems to determine capabilities and code paths.
         *
         * @name Phaser.Game#device
         * @type {Phaser.DeviceConf}
         * @since 3.0.0
         */ this.device = Device;
                    /**
         * An instance of the Scale Manager.
         *
         * The Scale Manager is a global system responsible for handling scaling of the game canvas.
         *
         * @name Phaser.Game#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scale = new ScaleManager(this, this.config);
                    /**
         * An instance of the base Sound Manager.
         *
         * The Sound Manager is a global system responsible for the playback and updating of all audio in your game.
         *
         * You can disable the inclusion of the Sound Manager in your build by toggling the webpack `FEATURE_SOUND` flag.
         *
         * @name Phaser.Game#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound = null;
                    this.sound = SoundManagerCreator.create(this);
                    /**
         * An instance of the Time Step.
         *
         * The Time Step is a global system responsible for setting-up and responding to the browser frame events, processing
         * them and calculating delta values. It then automatically calls the game step.
         *
         * @name Phaser.Game#loop
         * @type {Phaser.Core.TimeStep}
         * @since 3.0.0
         */ this.loop = new TimeStep(this, this.config.fps);
                    /**
         * An instance of the Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Game#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins = new PluginManager(this, this.config);
                    /**
         * Is this Game pending destruction at the start of the next frame?
         *
         * @name Phaser.Game#pendingDestroy
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.pendingDestroy = false;
                    /**
         * Remove the Canvas once the destroy is over?
         *
         * @name Phaser.Game#removeCanvas
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.removeCanvas = false;
                    /**
         * Remove everything when the game is destroyed.
         * You cannot create a new Phaser instance on the same web page after doing this.
         *
         * @name Phaser.Game#noReturn
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this.noReturn = false;
                    /**
         * Does the window the game is running in currently have focus or not?
         * This is modified by the VisibilityHandler.
         *
         * @name Phaser.Game#hasFocus
         * @type {boolean}
         * @readonly
         * @since 3.9.0
         */ this.hasFocus = false;
                    //  Wait for the DOM Ready event, then call boot.
                    DOMContentLoaded(this.boot.bind(this));
                },
                /**
     * This method is called automatically when the DOM is ready. It is responsible for creating the renderer,
     * displaying the Debug Header, adding the game canvas to the DOM and emitting the 'boot' event.
     * It listens for a 'ready' event from the base systems and once received it will call `Game.start`.
     *
     * @method Phaser.Game#boot
     * @protected
     * @fires Phaser.Core.Events#BOOT
     * @listens Phaser.Textures.Events#READY
     * @since 3.0.0
     */ boot: function() {
                    if (!PluginCache.hasCore("EventEmitter")) {
                        console.warn("Aborting. Core Plugins missing.");
                        return;
                    }
                    this.isBooted = true;
                    this.config.preBoot(this);
                    this.scale.preBoot();
                    CreateRenderer(this);
                    CreateDOMContainer(this);
                    DebugHeader(this);
                    AddToDOM(this.canvas, this.config.parent);
                    //  The Texture Manager has to wait on a couple of non-blocking events before it's fully ready.
                    //  So it will emit this internal event when done:
                    this.textures.once(TextureEvents.READY, this.texturesReady, this);
                    this.events.emit(Events.BOOT);
                },
                /**
     * Called automatically when the Texture Manager has finished setting up and preparing the
     * default textures.
     *
     * @method Phaser.Game#texturesReady
     * @private
     * @fires Phaser.Game#READY
     * @since 3.12.0
     */ texturesReady: function() {
                    //  Start all the other systems
                    this.events.emit(Events.READY);
                    this.start();
                },
                /**
     * Called automatically by Game.boot once all of the global systems have finished setting themselves up.
     * By this point the Game is now ready to start the main loop running.
     * It will also enable the Visibility Handler.
     *
     * @method Phaser.Game#start
     * @protected
     * @since 3.0.0
     */ start: function() {
                    this.isRunning = true;
                    this.config.postBoot(this);
                    if (this.renderer) this.loop.start(this.step.bind(this));
                    else this.loop.start(this.headlessStep.bind(this));
                    VisibilityHandler(this);
                    var eventEmitter = this.events;
                    eventEmitter.on(Events.HIDDEN, this.onHidden, this);
                    eventEmitter.on(Events.VISIBLE, this.onVisible, this);
                    eventEmitter.on(Events.BLUR, this.onBlur, this);
                    eventEmitter.on(Events.FOCUS, this.onFocus, this);
                },
                /**
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * It will then render each Scene in turn, via the Renderer. This process emits `prerender` and `postrender` events.
     *
     * @method Phaser.Game#step
     * @fires Phaser.Core.Events#PRE_STEP
     * @fires Phaser.Core.Events#STEP
     * @fires Phaser.Core.Events#POST_STEP
     * @fires Phaser.Core.Events#PRE_RENDER
     * @fires Phaser.Core.Events#POST_RENDER
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var eventEmitter = this.events;
                    //  Global Managers like Input and Sound update in the prestep
                    eventEmitter.emit(Events.PRE_STEP, time, delta);
                    //  This is mostly meant for user-land code and plugins
                    eventEmitter.emit(Events.STEP, time, delta);
                    //  Update the Scene Manager and all active Scenes
                    this.scene.update(time, delta);
                    //  Our final event before rendering starts
                    eventEmitter.emit(Events.POST_STEP, time, delta);
                    var renderer = this.renderer;
                    //  Run the Pre-render (clearing the canvas, setting background colors, etc)
                    renderer.preRender();
                    eventEmitter.emit(Events.PRE_RENDER, renderer, time, delta);
                    //  The main render loop. Iterates all Scenes and all Cameras in those scenes, rendering to the renderer instance.
                    this.scene.render(renderer);
                    //  The Post-Render call. Tidies up loose end, takes snapshots, etc.
                    renderer.postRender();
                    //  The final event before the step repeats. Your last chance to do anything to the canvas before it all starts again.
                    eventEmitter.emit(Events.POST_RENDER, renderer, time, delta);
                },
                /**
     * A special version of the Game Step for the HEADLESS renderer only.
     *
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * This process emits `prerender` and `postrender` events, even though nothing actually displays.
     *
     * @method Phaser.Game#headlessStep
     * @fires Phaser.Game#PRE_RENDER
     * @fires Phaser.Game#POST_RENDER
     * @since 3.2.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ headlessStep: function(time, delta) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var eventEmitter = this.events;
                    //  Global Managers
                    eventEmitter.emit(Events.PRE_STEP, time, delta);
                    eventEmitter.emit(Events.STEP, time, delta);
                    //  Scenes
                    this.scene.update(time, delta);
                    eventEmitter.emit(Events.POST_STEP, time, delta);
                    //  Render
                    eventEmitter.emit(Events.PRE_RENDER);
                    eventEmitter.emit(Events.POST_RENDER);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will pause the main loop and then emit a pause event.
     *
     * @method Phaser.Game#onHidden
     * @protected
     * @fires Phaser.Core.Events#PAUSE
     * @since 3.0.0
     */ onHidden: function() {
                    this.loop.pause();
                    this.events.emit(Events.PAUSE);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will resume the main loop and then emit a resume event.
     *
     * @method Phaser.Game#onVisible
     * @protected
     * @fires Phaser.Core.Events#RESUME
     * @since 3.0.0
     */ onVisible: function() {
                    this.loop.resume();
                    this.events.emit(Events.RESUME);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'blurred' state, which pauses it.
     *
     * @method Phaser.Game#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    this.hasFocus = false;
                    this.loop.blur();
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'focused' state, which resumes it.
     *
     * @method Phaser.Game#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    this.hasFocus = true;
                    this.loop.focus();
                },
                /**
     * Returns the current game frame.
     *
     * When the game starts running, the frame is incremented every time Request Animation Frame, or Set Timeout, fires.
     *
     * @method Phaser.Game#getFrame
     * @since 3.16.0
     *
     * @return {number} The current game frame.
     */ getFrame: function() {
                    return this.loop.frame;
                },
                /**
     * Returns the time that the current game step started at, as based on `performance.now`.
     *
     * @method Phaser.Game#getTime
     * @since 3.16.0
     *
     * @return {number} The current game timestamp.
     */ getTime: function() {
                    return this.loop.now;
                },
                /**
     * Flags this Game instance as needing to be destroyed on the _next frame_, making this an asynchronous operation.
     *
     * It will wait until the current frame has completed and then call `runDestroy` internally.
     *
     * If you need to react to the games eventual destruction, listen for the `DESTROY` event.
     *
     * If you **do not** need to run Phaser again on the same web page you can set the `noReturn` argument to `true` and it will free-up
     * memory being held by the core Phaser plugins. If you do need to create another game instance on the same page, leave this as `false`.
     *
     * @method Phaser.Game#destroy
     * @fires Phaser.Core.Events#DESTROY
     * @since 3.0.0
     *
     * @param {boolean} removeCanvas - Set to `true` if you would like the parent canvas element removed from the DOM, or `false` to leave it in place.
     * @param {boolean} [noReturn=false] - If `true` all the core Phaser plugins are destroyed. You cannot create another instance of Phaser on the same web page if you do this.
     */ destroy: function(removeCanvas, noReturn) {
                    if (noReturn === undefined) noReturn = false;
                    this.pendingDestroy = true;
                    this.removeCanvas = removeCanvas;
                    this.noReturn = noReturn;
                },
                /**
     * Destroys this Phaser.Game instance, all global systems, all sub-systems and all Scenes.
     *
     * @method Phaser.Game#runDestroy
     * @private
     * @since 3.5.0
     */ runDestroy: function() {
                    this.scene.destroy();
                    this.events.emit(Events.DESTROY);
                    this.events.removeAllListeners();
                    if (this.renderer) this.renderer.destroy();
                    if (this.removeCanvas && this.canvas) {
                        CanvasPool.remove(this.canvas);
                        if (this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
                    }
                    if (this.domContainer) this.domContainer.parentNode.removeChild(this.domContainer);
                    this.loop.destroy();
                    this.pendingDestroy = false;
                }
            });
            module1.exports = Game;
        /**
 * "Computers are good at following instructions, but not at reading your mind." - Donald Knuth
 */ /***/ },
        /* 921 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(142);
            var CreateDOMContainer = function(game) {
                var config = game.config;
                if (!config.parent || !config.domCreateContainer) return;
                //  DOM Element Container
                var div = document.createElement("div");
                div.style.cssText = [
                    "display: block;",
                    "width: " + game.scale.width + "px;",
                    "height: " + game.scale.height + "px;",
                    "padding: 0; margin: 0;",
                    "position: absolute;",
                    "overflow: hidden;",
                    "pointer-events: " + config.domPointerEvents + ";",
                    "transform: scale(1);",
                    "transform-origin: left top;"
                ].join(" ");
                game.domContainer = div;
                AddToDOM(div, config.parent);
            };
            module1.exports = CreateDOMContainer;
        /***/ },
        /* 922 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Boot Event.
 * 
 * This internal event is dispatched by the Input Plugin when it boots, signalling to all of its systems to create themselves.
 *
 * @event Phaser.Input.Events#BOOT
 * @since 3.0.0
 */ module1.exports = "boot";
        /***/ },
        /* 923 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Destroy Event.
 * 
 * This internal event is dispatched by the Input Plugin when it is destroyed, signalling to all of its systems to destroy themselves.
 *
 * @event Phaser.Input.Events#DESTROY
 * @since 3.0.0
 */ module1.exports = "destroy";
        /***/ },
        /* 924 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag End Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer stops dragging a Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragend', listener)`.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_END]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_END} event instead.
 *
 * @event Phaser.Input.Events#DRAG_END
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer stopped dragging.
 */ module1.exports = "dragend";
        /***/ },
        /* 925 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Enter Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object into a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragenter', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_ENTER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_ENTER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_ENTER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = "dragenter";
        /***/ },
        /* 926 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves while dragging a Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('drag', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG} event instead.
 *
 * @event Phaser.Input.Events#DRAG
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = "drag";
        /***/ },
        /* 927 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Leave Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object out of a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragleave', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_LEAVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_LEAVE} event instead.
 *
 * @event Phaser.Input.Events#DRAG_LEAVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = "dragleave";
        /***/ },
        /* 928 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object over a Drag Target.
 * 
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragover', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_OVER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = "dragover";
        /***/ },
        /* 929 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Start Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer starts to drag any Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragstart', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_START]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_START} event instead.
 *
 * @event Phaser.Input.Events#DRAG_START
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 */ module1.exports = "dragstart";
        /***/ },
        /* 930 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drop Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drops a Game Object on a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('drop', listener)`.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DROP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DROP} event instead.
 *
 * @event Phaser.Input.Events#DROP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer was dragging.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = "drop";
        /***/ },
        /* 931 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Out Event.
 * 
 * This event is dispatched by the Input Plugin if the active pointer leaves the game canvas and is now
 * outside of it, elsewhere on the web page.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameout', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OUT
 * @since 3.16.1
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas out.
 */ module1.exports = "gameout";
        /***/ },
        /* 932 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Over Event.
 * 
 * This event is dispatched by the Input Plugin if the active pointer enters the game canvas and is now
 * over of it, having previously been elsewhere on the web page.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameover', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OVER
 * @since 3.16.1
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas over.
 */ module1.exports = "gameover";
        /***/ },
        /* 933 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Down Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down on _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectdown', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was pressed down on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectdown";
        /***/ },
        /* 934 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag End Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer stops dragging it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragend', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive](Phaser.GameObjects.GameObject#setInteractive) for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_END
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer stopped dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer stopped dragging the Game Object, in world space.
 */ module1.exports = "dragend";
        /***/ },
        /* 935 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Enter Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it into a drag target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragenter', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = "dragenter";
        /***/ },
        /* 936 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves while dragging it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('drag', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = "drag";
        /***/ },
        /* 937 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Leave Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it out of a drag target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragleave', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = "dragleave";
        /***/ },
        /* 938 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Over Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it over a drag target.
 * 
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = "dragover";
        /***/ },
        /* 939 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Start Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer starts to drag it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragstart', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * There are lots of useful drag related properties that are set within the Game Object when dragging occurs.
 * For example, `gameObject.input.dragStartX`, `dragStartY` and so on.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_START
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = "dragstart";
        /***/ },
        /* 940 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drop Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drops it on a Drag Target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('drop', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DROP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = "drop";
        /***/ },
        /* 941 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Move Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved across _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectmove', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was moved on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectmove";
        /***/ },
        /* 942 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Out Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectout', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved out of.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectout";
        /***/ },
        /* 943 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectover', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved over.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectover";
        /***/ },
        /* 944 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Down Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is pressed down on it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerdown', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "pointerdown";
        /***/ },
        /* 945 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Move Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is moved while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointermove', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "pointermove";
        /***/ },
        /* 946 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Out Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves out of it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerout', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "pointerout";
        /***/ },
        /* 947 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Over Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "pointerover";
        /***/ },
        /* 948 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Up Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is released while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerup', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "pointerup";
        /***/ },
        /* 949 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Wheel Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer has its wheel moved while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('wheel', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "wheel";
        /***/ },
        /* 950 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Up Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released while over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectup', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when released.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectup";
        /***/ },
        /* 951 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Wheel Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel moved while over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectwheel', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when the wheel changed.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = "gameobjectwheel";
        /***/ },
        /* 952 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Boot Event.
 * 
 * This internal event is dispatched by the Input Manager when it boots.
 *
 * @event Phaser.Input.Events#MANAGER_BOOT
 * @since 3.0.0
 */ module1.exports = "boot";
        /***/ },
        /* 953 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Process Event.
 * 
 * This internal event is dispatched by the Input Manager when not using the legacy queue system,
 * and it wants the Input Plugins to update themselves.
 *
 * @event Phaser.Input.Events#MANAGER_PROCESS
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "process";
        /***/ },
        /* 954 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Update Event.
 * 
 * This internal event is dispatched by the Input Manager as part of its update step.
 *
 * @event Phaser.Input.Events#MANAGER_UPDATE
 * @since 3.0.0
 */ module1.exports = "update";
        /***/ },
        /* 955 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerdown', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = "pointerdown";
        /***/ },
        /* 956 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Outside Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere outside of the game canvas.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerdownoutside', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN_OUTSIDE
 * @since 3.16.1
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = "pointerdownoutside";
        /***/ },
        /* 957 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Move Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointermove', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = "pointermove";
        /***/ },
        /* 958 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Out Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of any interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerout', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOut - An array containing all interactive Game Objects that the pointer moved out of when the event was created.
 */ module1.exports = "pointerout";
        /***/ },
        /* 959 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over any interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerover', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOver - An array containing all interactive Game Objects that the pointer moved over when the event was created.
 */ module1.exports = "pointerover";
        /***/ },
        /* 960 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerup', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = "pointerup";
        /***/ },
        /* 961 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Outside Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere outside of the game canvas.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerupoutside', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP_OUTSIDE
 * @since 3.16.1
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = "pointerupoutside";
        /***/ },
        /* 962 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Wheel Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel updated.
 * 
 * Listen to this event from within a Scene using: `this.input.on('wheel', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 */ module1.exports = "wheel";
        /***/ },
        /* 963 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Pointer Lock Change Event.
 * 
 * This event is dispatched by the Input Manager when it is processing a native Pointer Lock Change DOM Event.
 *
 * @event Phaser.Input.Events#POINTERLOCK_CHANGE
 * @since 3.0.0
 * 
 * @param {Event} event - The native DOM Event.
 * @param {boolean} locked - The locked state of the Mouse Pointer.
 */ module1.exports = "pointerlockchange";
        /***/ },
        /* 964 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Pre-Update Event.
 * 
 * This internal event is dispatched by the Input Plugin at the start of its `preUpdate` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#PRE_UPDATE
 * @since 3.0.0
 */ module1.exports = "preupdate";
        /***/ },
        /* 965 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Shutdown Event.
 * 
 * This internal event is dispatched by the Input Plugin when it shuts down, signalling to all of its systems to shut themselves down.
 *
 * @event Phaser.Input.Events#SHUTDOWN
 * @since 3.0.0
 */ module1.exports = "shutdown";
        /***/ },
        /* 966 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Start Event.
 * 
 * This internal event is dispatched by the Input Plugin when it has finished setting-up,
 * signalling to all of its internal systems to start.
 *
 * @event Phaser.Input.Events#START
 * @since 3.0.0
 */ module1.exports = "start";
        /***/ },
        /* 967 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Update Event.
 * 
 * This internal event is dispatched by the Input Plugin at the start of its `update` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#UPDATE
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = "update";
        /***/ },
        /* 968 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Add File Event.
 * 
 * This event is dispatched when a new file is successfully added to the Loader and placed into the load queue.
 * 
 * Listen to it from a Scene using: `this.load.on('addfile', listener)`.
 * 
 * If you add lots of files to a Loader from a `preload` method, it will dispatch this event for each one of them.
 *
 * @event Phaser.Loader.Events#ADD
 * @since 3.0.0
 * 
 * @param {string} key - The unique key of the file that was added to the Loader.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} string of the file that was added to the Loader, i.e. `image`.
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {Phaser.Loader.File} file - A reference to the File which was added to the Loader.
 */ module1.exports = "addfile";
        /***/ },
        /* 969 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Complete Event.
 * 
 * This event is dispatched when the Loader has fully processed everything in the load queue.
 * By this point every loaded file will now be in its associated cache and ready for use.
 * 
 * Listen to it from a Scene using: `this.load.on('complete', listener)`.
 *
 * @event Phaser.Loader.Events#COMPLETE
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {number} totalComplete - The total number of files that successfully loaded.
 * @param {number} totalFailed - The total number of files that failed to load.
 */ module1.exports = "complete";
        /***/ },
        /* 970 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 * 
 * This event is dispatched by the Loader Plugin when any file in the queue finishes loading.
 * 
 * Listen to it from a Scene using: `this.load.on('filecomplete', listener)`.
 * 
 * You can also listen for the completion of a specific file. See the [FILE_KEY_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_KEY_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_COMPLETE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} data - The raw data the file contained.
 */ module1.exports = "filecomplete";
        /***/ },
        /* 971 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 * 
 * This event is dispatched by the Loader Plugin when any file in the queue finishes loading.
 * 
 * It uses a special dynamic event name constructed from the key and type of the file.
 * 
 * For example, if you have loaded an `image` with a key of `monster`, you can listen for it
 * using the following:
 *
 * ```javascript
 * this.load.on('filecomplete-image-monster', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 *
 * Or, if you have loaded a texture `atlas` with a key of `Level1`:
 * 
 * ```javascript
 * this.load.on('filecomplete-atlas-Level1', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 * 
 * Or, if you have loaded a sprite sheet with a key of `Explosion` and a prefix of `GAMEOVER`:
 * 
 * ```javascript
 * this.load.on('filecomplete-spritesheet-GAMEOVERExplosion', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 * 
 * You can also listen for the generic completion of files. See the [FILE_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_KEY_COMPLETE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} data - The raw data the file contained.
 */ module1.exports = "filecomplete-";
        /***/ },
        /* 972 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Error Event.
 * 
 * This event is dispatched by the Loader Plugin when a file fails to load.
 * 
 * Listen to it from a Scene using: `this.load.on('loaderror', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD_ERROR
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 */ module1.exports = "loaderror";
        /***/ },
        /* 973 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Event.
 * 
 * This event is dispatched by the Loader Plugin when a file finishes loading,
 * but _before_ it is processed and added to the internal Phaser caches.
 * 
 * Listen to it from a Scene using: `this.load.on('load', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which just finished loading.
 */ module1.exports = "load";
        /***/ },
        /* 974 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Progress Event.
 * 
 * This event is dispatched by the Loader Plugin during the load of a file, if the browser receives a DOM ProgressEvent and
 * the `lengthComputable` event property is true. Depending on the size of the file and browser in use, this may, or may not happen.
 * 
 * Listen to it from a Scene using: `this.load.on('fileprogress', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_PROGRESS
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 * @param {number} percentComplete - A value between 0 and 1 indicating how 'complete' this file is.
 */ module1.exports = "fileprogress";
        /***/ },
        /* 975 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Post Process Event.
 * 
 * This event is dispatched by the Loader Plugin when the Loader has finished loading everything in the load queue.
 * It is dispatched before the internal lists are cleared and each File is destroyed.
 * 
 * Use this hook to perform any last minute processing of files that can only happen once the
 * Loader has completed, but prior to it emitting the `complete` event.
 * 
 * Listen to it from a Scene using: `this.load.on('postprocess', listener)`.
 *
 * @event Phaser.Loader.Events#POST_PROCESS
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = "postprocess";
        /***/ },
        /* 976 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Progress Event.
 * 
 * This event is dispatched when the Loader updates its load progress, typically as a result of a file having completed loading.
 * 
 * Listen to it from a Scene using: `this.load.on('progress', listener)`.
 *
 * @event Phaser.Loader.Events#PROGRESS
 * @since 3.0.0
 * 
 * @param {number} progress - The current progress of the load. A value between 0 and 1.
 */ module1.exports = "progress";
        /***/ },
        /* 977 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Start Event.
 * 
 * This event is dispatched when the Loader starts running. At this point load progress is zero.
 * 
 * This event is dispatched even if there aren't any files in the load queue.
 * 
 * Listen to it from a Scene using: `this.load.on('start', listener)`.
 *
 * @event Phaser.Loader.Events#START
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = "start";
        /***/ },
        /* 978 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  These properties get injected into the Scene and map to local systems
            //  The map value is the property that is injected into the Scene, the key is the Scene.Systems reference.
            //  These defaults can be modified via the Scene config object
            //          var config = {
            //            map: {
            //                add: 'makeStuff',
            //                load: 'loader'
            //            }
            //        };
            var InjectionMap = {
                game: "game",
                renderer: "renderer",
                anims: "anims",
                cache: "cache",
                plugins: "plugins",
                registry: "registry",
                scale: "scale",
                sound: "sound",
                textures: "textures",
                events: "events",
                cameras: "cameras",
                add: "add",
                make: "make",
                scenePlugin: "scene",
                displayList: "children",
                lights: "lights",
                data: "data",
                input: "input",
                load: "load",
                time: "time",
                tweens: "tweens",
                arcadePhysics: "physics",
                impactPhysics: "impact",
                matterPhysics: "matter"
            };
            module1.exports = InjectionMap;
        /***/ },
        /* 979 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses an XML Texture Atlas object and adds all the Frames into a Texture.
 *
 * @function Phaser.Textures.Parsers.AtlasXML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.7.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {*} xml - The XML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var AtlasXML = function(texture, sourceIndex, xml) {
                //  Malformed?
                if (!xml.getElementsByTagName("TextureAtlas")) {
                    console.warn("Invalid Texture Atlas XML given");
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed array
                var frames = xml.getElementsByTagName("SubTexture");
                var newFrame;
                for(var i = 0; i < frames.length; i++){
                    var frame = frames[i].attributes;
                    var name = frame.name.value;
                    var x = parseInt(frame.x.value, 10);
                    var y = parseInt(frame.y.value, 10);
                    var width = parseInt(frame.width.value, 10);
                    var height = parseInt(frame.height.value, 10);
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(name, sourceIndex, x, y, width, height);
                    //  These are the original (non-trimmed) sprite values
                    if (frame.frameX) {
                        var frameX = Math.abs(parseInt(frame.frameX.value, 10));
                        var frameY = Math.abs(parseInt(frame.frameY.value, 10));
                        var frameWidth = parseInt(frame.frameWidth.value, 10);
                        var frameHeight = parseInt(frame.frameHeight.value, 10);
                        newFrame.setTrim(width, height, frameX, frameY, frameWidth, frameHeight);
                    }
                }
                return texture;
            };
            module1.exports = AtlasXML;
        /***/ },
        /* 980 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds a Canvas Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Canvas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Canvas = function(texture, sourceIndex) {
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                return texture;
            };
            module1.exports = Canvas;
        /***/ },
        /* 981 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds an Image Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Image
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Image1 = function(texture, sourceIndex) {
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                return texture;
            };
            module1.exports = Image1;
        /***/ },
        /* 982 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Parses a Texture Atlas JSON Array and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an array of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONArray
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONArray = function(texture, sourceIndex, json) {
                //  Malformed?
                if (!json["frames"] && !json["textures"]) {
                    console.warn("Invalid Texture Atlas JSON Array");
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed array
                var frames = Array.isArray(json.textures) ? json.textures[sourceIndex].frames : json.frames;
                var newFrame;
                for(var i = 0; i < frames.length; i++){
                    var src = frames[i];
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(src.filename, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                    //  These are the original (non-trimmed) sprite values
                    if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                    if (src.rotated) {
                        newFrame.rotated = true;
                        newFrame.updateUVsInverted();
                    }
                    var pivot = src.anchor || src.pivot;
                    if (pivot) {
                        newFrame.customPivot = true;
                        newFrame.pivotX = pivot.x;
                        newFrame.pivotY = pivot.y;
                    }
                    //  Copy over any extra data
                    newFrame.customData = Clone(src);
                }
                //  Copy over any additional data that was in the JSON to Texture.customData
                for(var dataKey in json){
                    if (dataKey === "frames") continue;
                    if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                    else texture.customData[dataKey] = json[dataKey];
                }
                return texture;
            };
            module1.exports = JSONArray;
        /***/ },
        /* 983 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Parses a Texture Atlas JSON Hash and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an object of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONHash
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONHash = function(texture, sourceIndex, json) {
                //  Malformed?
                if (!json["frames"]) {
                    console.warn("Invalid Texture Atlas JSON Hash given, missing 'frames' Object");
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed Object
                var frames = json.frames;
                var newFrame;
                for(var key in frames){
                    if (!frames.hasOwnProperty(key)) continue;
                    var src = frames[key];
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(key, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                    //  These are the original (non-trimmed) sprite values
                    if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                    if (src.rotated) {
                        newFrame.rotated = true;
                        newFrame.updateUVsInverted();
                    }
                    var pivot = src.anchor || src.pivot;
                    if (pivot) {
                        newFrame.customPivot = true;
                        newFrame.pivotX = pivot.x;
                        newFrame.pivotY = pivot.y;
                    }
                    //  Copy over any extra data
                    newFrame.customData = Clone(src);
                }
                //  Copy over any additional data that was in the JSON to Texture.customData
                for(var dataKey in json){
                    if (dataKey === "frames") continue;
                    if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                    else texture.customData[dataKey] = json[dataKey];
                }
                return texture;
            };
            module1.exports = JSONHash;
        /***/ },
        /* 984 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parses a Sprite Sheet and adds the Frames to the Texture.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheet
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {number} x - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} y - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} width - The width of the source image.
 * @param {number} height - The height of the source image.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - The frame to start extracting from. Defaults to zero.
 * @param {number} [config.endFrame=-1] - The frame to finish extracting at. Defaults to -1, which means 'all frames'.
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheet = function(texture, sourceIndex, x, y, width, height, config) {
                var frameWidth = GetFastValue(config, "frameWidth", null);
                var frameHeight = GetFastValue(config, "frameHeight", frameWidth);
                //  If missing we can't proceed
                if (frameWidth === null) throw new Error("TextureManager.SpriteSheet: Invalid frameWidth given.");
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                var startFrame = GetFastValue(config, "startFrame", 0);
                var endFrame = GetFastValue(config, "endFrame", -1);
                var margin = GetFastValue(config, "margin", 0);
                var spacing = GetFastValue(config, "spacing", 0);
                var row = Math.floor((width - margin + spacing) / (frameWidth + spacing));
                var column = Math.floor((height - margin + spacing) / (frameHeight + spacing));
                var total = row * column;
                if (total === 0) console.warn("SpriteSheet frame dimensions will result in zero frames for texture:", texture.key);
                if (startFrame > total || startFrame < -total) startFrame = 0;
                if (startFrame < 0) //  Allow negative skipframes.
                startFrame = total + startFrame;
                if (endFrame !== -1) total = startFrame + (endFrame + 1);
                var fx = margin;
                var fy = margin;
                var ax = 0;
                var ay = 0;
                for(var i = 0; i < total; i++){
                    ax = 0;
                    ay = 0;
                    var w = fx + frameWidth;
                    var h = fy + frameHeight;
                    if (w > width) ax = w - width;
                    if (h > height) ay = h - height;
                    texture.add(i, sourceIndex, x + fx, y + fy, frameWidth - ax, frameHeight - ay);
                    fx += frameWidth + spacing;
                    if (fx + frameWidth > width) {
                        fx = margin;
                        fy += frameHeight + spacing;
                    }
                }
                return texture;
            };
            module1.exports = SpriteSheet;
        /***/ },
        /* 985 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parses a Sprite Sheet and adds the Frames to the Texture, where the Sprite Sheet is stored as a frame within an Atlas.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheetFromAtlas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {Phaser.Textures.Frame} frame - The Frame that contains the Sprite Sheet.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - Index of the start frame in the sprite sheet
 * @param {number} [config.endFrame=-1] - Index of the end frame in the sprite sheet. -1 mean all the rest of the frames
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheetFromAtlas = function(texture, frame, config) {
                var frameWidth = GetFastValue(config, "frameWidth", null);
                var frameHeight = GetFastValue(config, "frameHeight", frameWidth);
                //  If missing we can't proceed
                if (!frameWidth) throw new Error("TextureManager.SpriteSheetFromAtlas: Invalid frameWidth given.");
                //  Add in a __BASE entry (for the entire atlas frame)
                var source = texture.source[0];
                texture.add("__BASE", 0, 0, 0, source.width, source.height);
                var startFrame = GetFastValue(config, "startFrame", 0);
                var endFrame = GetFastValue(config, "endFrame", -1);
                var margin = GetFastValue(config, "margin", 0);
                var spacing = GetFastValue(config, "spacing", 0);
                var x = frame.cutX;
                var y = frame.cutY;
                var cutWidth = frame.cutWidth;
                var cutHeight = frame.cutHeight;
                var sheetWidth = frame.realWidth;
                var sheetHeight = frame.realHeight;
                var row = Math.floor((sheetWidth - margin + spacing) / (frameWidth + spacing));
                var column = Math.floor((sheetHeight - margin + spacing) / (frameHeight + spacing));
                var total = row * column;
                //  trim offsets
                var leftPad = frame.x;
                var leftWidth = frameWidth - leftPad;
                var rightWidth = frameWidth - (sheetWidth - cutWidth - leftPad);
                var topPad = frame.y;
                var topHeight = frameHeight - topPad;
                var bottomHeight = frameHeight - (sheetHeight - cutHeight - topPad);
                if (startFrame > total || startFrame < -total) startFrame = 0;
                if (startFrame < 0) //  Allow negative skipframes.
                startFrame = total + startFrame;
                if (endFrame !== -1) total = startFrame + (endFrame + 1);
                var sheetFrame;
                var frameX = margin;
                var frameY = margin;
                var frameIndex = 0;
                var sourceIndex = frame.sourceIndex;
                for(var sheetY = 0; sheetY < column; sheetY++){
                    var topRow = sheetY === 0;
                    var bottomRow = sheetY === column - 1;
                    for(var sheetX = 0; sheetX < row; sheetX++){
                        var leftRow = sheetX === 0;
                        var rightRow = sheetX === row - 1;
                        sheetFrame = texture.add(frameIndex, sourceIndex, x + frameX, y + frameY, frameWidth, frameHeight);
                        if (leftRow || topRow || rightRow || bottomRow) {
                            var destX = leftRow ? leftPad : 0;
                            var destY = topRow ? topPad : 0;
                            var trimWidth = 0;
                            var trimHeight = 0;
                            if (leftRow) trimWidth += frameWidth - leftWidth;
                            if (rightRow) trimWidth += frameWidth - rightWidth;
                            if (topRow) trimHeight += frameHeight - topHeight;
                            if (bottomRow) trimHeight += frameHeight - bottomHeight;
                            var destWidth = frameWidth - trimWidth;
                            var destHeight = frameHeight - trimHeight;
                            sheetFrame.cutWidth = destWidth;
                            sheetFrame.cutHeight = destHeight;
                            sheetFrame.setTrim(frameWidth, frameHeight, destX, destY, destWidth, destHeight);
                        }
                        frameX += spacing;
                        if (leftRow) frameX += leftWidth;
                        else if (rightRow) frameX += rightWidth;
                        else frameX += frameWidth;
                        frameIndex++;
                    }
                    frameX = margin;
                    frameY += spacing;
                    if (topRow) frameY += topHeight;
                    else if (bottomRow) frameY += bottomHeight;
                    else frameY += frameHeight;
                }
                return texture;
            };
            module1.exports = SpriteSheetFromAtlas;
        /***/ },
        /* 986 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var imageHeight = 0;
            /**
 * @function addFrame
 * @private
 * @since 3.0.0
 */ var addFrame = function(texture, sourceIndex, name, frame) {
                //  The frame values are the exact coordinates to cut the frame out of the atlas from
                var y = imageHeight - frame.y - frame.height;
                texture.add(name, sourceIndex, frame.x, y, frame.width, frame.height);
            //  These are the original (non-trimmed) sprite values
            /*
    if (src.trimmed)
    {
        newFrame.setTrim(
            src.sourceSize.w,
            src.sourceSize.h,
            src.spriteSourceSize.x,
            src.spriteSourceSize.y,
            src.spriteSourceSize.w,
            src.spriteSourceSize.h
        );
    }
    */ };
            /**
 * Parses a Unity YAML File and creates Frames in the Texture.
 * For more details about Sprite Meta Data see https://docs.unity3d.com/ScriptReference/SpriteMetaData.html
 *
 * @function Phaser.Textures.Parsers.UnityYAML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} yaml - The YAML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var UnityYAML = function(texture, sourceIndex, yaml) {
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add("__BASE", sourceIndex, 0, 0, source.width, source.height);
                imageHeight = source.height;
                var data = yaml.split("\n");
                var lineRegExp = /^[ ]*(- )*(\w+)+[: ]+(.*)/;
                var prevSprite = "";
                var currentSprite = "";
                var rect = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                // var pivot = { x: 0, y: 0 };
                // var border = { x: 0, y: 0, z: 0, w: 0 };
                for(var i = 0; i < data.length; i++){
                    var results = data[i].match(lineRegExp);
                    if (!results) continue;
                    var isList = results[1] === "- ";
                    var key = results[2];
                    var value = results[3];
                    if (isList) {
                        if (currentSprite !== prevSprite) {
                            addFrame(texture, sourceIndex, currentSprite, rect);
                            prevSprite = currentSprite;
                        }
                        rect = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                    }
                    if (key === "name") {
                        //  Start new list
                        currentSprite = value;
                        continue;
                    }
                    switch(key){
                        case "x":
                        case "y":
                        case "width":
                        case "height":
                            rect[key] = parseInt(value, 10);
                            break;
                    }
                }
                if (currentSprite !== prevSprite) addFrame(texture, sourceIndex, currentSprite, rect);
                return texture;
            };
            module1.exports = UnityYAML;
        /*
Example data:

TextureImporter:
  spritePivot: {x: .5, y: .5}
  spriteBorder: {x: 0, y: 0, z: 0, w: 0}
  spritePixelsToUnits: 100
  spriteSheet:
    sprites:
    - name: asteroids_0
      rect:
        serializedVersion: 2
        x: 5
        y: 328
        width: 65
        height: 82
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
    - name: asteroids_1
      rect:
        serializedVersion: 2
        x: 80
        y: 322
        width: 53
        height: 88
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
  spritePackingTag: Asteroids
*/ /***/ },
        /* 987 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Complete Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they complete playback.
 * 
 * Listen to it from a Sound instance using `Sound.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('complete', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#COMPLETE
 * @since 3.16.1
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "complete";
        /***/ },
        /* 988 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded Event.
 * 
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method.
 * 
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decoded', listener)`, i.e.:
 * 
 * ```javascript
 * this.sound.on('decoded', handler);
 * this.sound.decodeAudio(key, audioData);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED
 * @since 3.18.0
 * 
 * @param {string} key - The key of the audio file that was decoded and added to the audio cache.
 */ module1.exports = "decoded";
        /***/ },
        /* 989 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded All Event.
 * 
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method,
 * once all files passed to the method have been decoded (or errored).
 * 
 * Use `Phaser.Sound.Events#DECODED` to listen for single sounds being decoded, and `DECODED_ALL` to
 * listen for them all completing.
 * 
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decodedall', listener)`, i.e.:
 * 
 * ```javascript
 * this.sound.once('decodedall', handler);
 * this.sound.decodeAudio([ audioFiles ]);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED_ALL
 * @since 3.18.0
 */ module1.exports = "decodedall";
        /***/ },
        /* 990 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Destroy Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are destroyed, either
 * directly or via a Sound Manager.
 * 
 * Listen to it from a Sound instance using `Sound.on('destroy', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('destroy', listener);
 * music.destroy();
 * ```
 *
 * @event Phaser.Sound.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "destroy";
        /***/ },
        /* 991 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Detune Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their detune value changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('detune', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('detune', listener);
 * music.play();
 * music.setDetune(200);
 * ```
 *
 * @event Phaser.Sound.Events#DETUNE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = "detune";
        /***/ },
        /* 992 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Detune Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `detune` property of the Sound Manager is changed, which globally
 * adjusts the detuning of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_DETUNE
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} detune - The updated detune value.
 */ module1.exports = "detune";
        /***/ },
        /* 993 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Mute Event.
 * 
 * This event is dispatched by the Sound Manager when its `mute` property is changed, either directly
 * or via the `setMute` method. This changes the mute state of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('mute', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_MUTE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
 */ module1.exports = "mute";
        /***/ },
        /* 994 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Rate Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `rate` property of the Sound Manager is changed, which globally
 * adjusts the playback rate of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_RATE
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} rate - The updated rate value.
 */ module1.exports = "rate";
        /***/ },
        /* 995 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Volume Event.
 * 
 * This event is dispatched by the Sound Manager when its `volume` property is changed, either directly
 * or via the `setVolume` method. This changes the volume of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('volume', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_VOLUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} volume - The new global volume of the Sound Manager.
 */ module1.exports = "volume";
        /***/ },
        /* 996 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Loop Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their loop state is changed.
 * 
 * Listen to it from a Sound instance using `Sound.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('loop', listener);
 * music.setLoop(true);
 * ```
 * 
 * This is not to be confused with the [LOOPED]{@linkcode Phaser.Sound.Events#event:LOOPED} event, which emits each time a Sound loops during playback.
 *
 * @event Phaser.Sound.Events#LOOP
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} loop - The new loop value. `true` if the Sound will loop, otherwise `false`.
 */ module1.exports = "loop";
        /***/ },
        /* 997 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Looped Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they loop during playback.
 * 
 * Listen to it from a Sound instance using `Sound.on('looped', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('looped', listener);
 * music.setLoop(true);
 * music.play();
 * ```
 * 
 * This is not to be confused with the [LOOP]{@linkcode Phaser.Sound.Events#event:LOOP} event, which only emits when the loop state of a Sound is changed.
 *
 * @event Phaser.Sound.Events#LOOPED
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "looped";
        /***/ },
        /* 998 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Mute Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their mute state changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('mute', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('mute', listener);
 * music.play();
 * music.setMute(true);
 * ```
 *
 * @event Phaser.Sound.Events#MUTE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound is now muted, otherwise `false`.
 */ module1.exports = "mute";
        /***/ },
        /* 999 */ /***/ function(module1, exports) {
            /**
 * @author       pi-kei
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pan Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their pan changes.
 *
 * Listen to it from a Sound instance using `Sound.on('pan', listener)`, i.e.:
 *
 * ```javascript
 * var sound = this.sound.add('key');
 * sound.on('pan', listener);
 * sound.play();
 * sound.setPan(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#PAN
 * @since 3.50.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} pan - The new pan of the Sound.
 */ module1.exports = "pan";
        /***/ },
        /* 1000 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `pauseAll` method is invoked and after all current Sounds
 * have been paused.
 * 
 * Listen to it from a Scene using: `this.sound.on('pauseall', listener)`.
 *
 * @event Phaser.Sound.Events#PAUSE_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = "pauseall";
        /***/ },
        /* 1001 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pause Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are paused.
 * 
 * Listen to it from a Sound instance using `Sound.on('pause', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('pause', listener);
 * music.play();
 * music.pause();
 * ```
 *
 * @event Phaser.Sound.Events#PAUSE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "pause";
        /***/ },
        /* 1002 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Play Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are played.
 * 
 * Listen to it from a Sound instance using `Sound.on('play', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('play', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#PLAY
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "play";
        /***/ },
        /* 1003 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Rate Change Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their rate changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('rate', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('rate', listener);
 * music.play();
 * music.setRate(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#RATE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} rate - The new rate of the Sound.
 */ module1.exports = "rate";
        /***/ },
        /* 1004 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `resumeAll` method is invoked and after all current Sounds
 * have been resumed.
 * 
 * Listen to it from a Scene using: `this.sound.on('resumeall', listener)`.
 *
 * @event Phaser.Sound.Events#RESUME_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = "resumeall";
        /***/ },
        /* 1005 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Resume Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are resumed from a paused state.
 * 
 * Listen to it from a Sound instance using `Sound.on('resume', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('resume', listener);
 * music.play();
 * music.pause();
 * music.resume();
 * ```
 *
 * @event Phaser.Sound.Events#RESUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "resume";
        /***/ },
        /* 1006 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Seek Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are seeked to a new position.
 * 
 * Listen to it from a Sound instance using `Sound.on('seek', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('seek', listener);
 * music.play();
 * music.setSeek(5000);
 * ```
 *
 * @event Phaser.Sound.Events#SEEK
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = "seek";
        /***/ },
        /* 1007 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Stop All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `stopAll` method is invoked and after all current Sounds
 * have been stopped.
 * 
 * Listen to it from a Scene using: `this.sound.on('stopall', listener)`.
 *
 * @event Phaser.Sound.Events#STOP_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = "stopall";
        /***/ },
        /* 1008 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Stop Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are stopped.
 * 
 * Listen to it from a Sound instance using `Sound.on('stop', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('stop', listener);
 * music.play();
 * music.stop();
 * ```
 *
 * @event Phaser.Sound.Events#STOP
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = "stop";
        /***/ },
        /* 1009 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Unlocked Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched during the update loop when the Sound Manager becomes unlocked. For
 * Web Audio this is on the first user gesture on the page.
 * 
 * Listen to it from a Scene using: `this.sound.on('unlocked', listener)`.
 *
 * @event Phaser.Sound.Events#UNLOCKED
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = "unlocked";
        /***/ },
        /* 1010 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Volume Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their volume changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('volume', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('volume', listener);
 * music.play();
 * music.setVolume(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#VOLUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} volume - The new volume of the Sound.
 */ module1.exports = "volume";
        /***/ },
        /* 1011 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects
 */ var GameObjects = {
                Events: __webpack_require__(75),
                DisplayList: __webpack_require__(1012),
                GameObjectCreator: __webpack_require__(16),
                GameObjectFactory: __webpack_require__(5),
                UpdateList: __webpack_require__(1040),
                Components: __webpack_require__(11),
                GetCalcMatrix: __webpack_require__(19),
                BuildGameObject: __webpack_require__(28),
                BuildGameObjectAnimation: __webpack_require__(439),
                GameObject: __webpack_require__(15),
                BitmapText: __webpack_require__(148),
                Blitter: __webpack_require__(213),
                Bob: __webpack_require__(440),
                Container: __webpack_require__(214),
                DOMElement: __webpack_require__(442),
                DynamicBitmapText: __webpack_require__(215),
                Extern: __webpack_require__(444),
                Graphics: __webpack_require__(216),
                Group: __webpack_require__(113),
                Image: __webpack_require__(125),
                Layer: __webpack_require__(219),
                Particles: __webpack_require__(1074),
                PathFollower: __webpack_require__(457),
                RenderTexture: __webpack_require__(221),
                RetroFont: __webpack_require__(1082),
                Rope: __webpack_require__(223),
                Sprite: __webpack_require__(73),
                Text: __webpack_require__(224),
                GetTextSize: __webpack_require__(458),
                MeasureText: __webpack_require__(460),
                TextStyle: __webpack_require__(459),
                TileSprite: __webpack_require__(225),
                Zone: __webpack_require__(129),
                Video: __webpack_require__(226),
                //  Shapes
                Shape: __webpack_require__(34),
                Arc: __webpack_require__(461),
                Curve: __webpack_require__(462),
                Ellipse: __webpack_require__(463),
                Grid: __webpack_require__(464),
                IsoBox: __webpack_require__(465),
                IsoTriangle: __webpack_require__(466),
                Line: __webpack_require__(467),
                Polygon: __webpack_require__(468),
                Rectangle: __webpack_require__(473),
                Star: __webpack_require__(474),
                Triangle: __webpack_require__(475),
                //  Game Object Factories
                Factories: {
                    Blitter: __webpack_require__(1130),
                    Container: __webpack_require__(1131),
                    DOMElement: __webpack_require__(1132),
                    DynamicBitmapText: __webpack_require__(1133),
                    Extern: __webpack_require__(1134),
                    Graphics: __webpack_require__(1135),
                    Group: __webpack_require__(1136),
                    Image: __webpack_require__(1137),
                    Layer: __webpack_require__(1138),
                    Particles: __webpack_require__(1139),
                    PathFollower: __webpack_require__(1140),
                    RenderTexture: __webpack_require__(1141),
                    Rope: __webpack_require__(1142),
                    Sprite: __webpack_require__(1143),
                    StaticBitmapText: __webpack_require__(1144),
                    Text: __webpack_require__(1145),
                    TileSprite: __webpack_require__(1146),
                    Zone: __webpack_require__(1147),
                    Video: __webpack_require__(1148),
                    //  Shapes
                    Arc: __webpack_require__(1149),
                    Curve: __webpack_require__(1150),
                    Ellipse: __webpack_require__(1151),
                    Grid: __webpack_require__(1152),
                    IsoBox: __webpack_require__(1153),
                    IsoTriangle: __webpack_require__(1154),
                    Line: __webpack_require__(1155),
                    Polygon: __webpack_require__(1156),
                    Rectangle: __webpack_require__(1157),
                    Star: __webpack_require__(1158),
                    Triangle: __webpack_require__(1159)
                },
                Creators: {
                    Blitter: __webpack_require__(1160),
                    Container: __webpack_require__(1161),
                    DynamicBitmapText: __webpack_require__(1162),
                    Graphics: __webpack_require__(1163),
                    Group: __webpack_require__(1164),
                    Image: __webpack_require__(1165),
                    Layer: __webpack_require__(1166),
                    Particles: __webpack_require__(1167),
                    RenderTexture: __webpack_require__(1168),
                    Rope: __webpack_require__(1169),
                    Sprite: __webpack_require__(1170),
                    StaticBitmapText: __webpack_require__(1171),
                    Text: __webpack_require__(1172),
                    TileSprite: __webpack_require__(1173),
                    Zone: __webpack_require__(1174),
                    Video: __webpack_require__(1175)
                }
            };
            GameObjects.Shader = __webpack_require__(229);
            GameObjects.Mesh = __webpack_require__(230);
            GameObjects.PointLight = __webpack_require__(150);
            GameObjects.Factories.Shader = __webpack_require__(1184);
            GameObjects.Factories.Mesh = __webpack_require__(1185);
            GameObjects.Factories.PointLight = __webpack_require__(1186);
            GameObjects.Creators.Shader = __webpack_require__(1187);
            GameObjects.Creators.Mesh = __webpack_require__(1188);
            GameObjects.Creators.PointLight = __webpack_require__(1189);
            GameObjects.Light = __webpack_require__(481);
            GameObjects.LightsManager = __webpack_require__(482);
            GameObjects.LightsPlugin = __webpack_require__(1190);
            module1.exports = GameObjects;
        /***/ },
        /* 1012 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var List = __webpack_require__(110);
            var PluginCache = __webpack_require__(24);
            var GameObjectEvents = __webpack_require__(75);
            var SceneEvents = __webpack_require__(20);
            var StableSort = __webpack_require__(79);
            /**
 * @classdesc
 * The Display List plugin.
 *
 * Display Lists belong to a Scene and maintain the list of Game Objects to render every frame.
 *
 * Some of these Game Objects may also be part of the Scene's [Update List]{@link Phaser.GameObjects.UpdateList}, for updating.
 *
 * @class DisplayList
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Display List belongs to.
 */ var DisplayList = new Class({
                Extends: List,
                initialize: function DisplayList(scene) {
                    List.call(this, scene);
                    /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.DisplayList#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.sortChildrenFlag = false;
                    /**
         * The Scene that this Display List belongs to.
         *
         * @name Phaser.GameObjects.DisplayList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.DisplayList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The Scene's Event Emitter.
         *
         * @name Phaser.GameObjects.DisplayList#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    //  Set the List callbacks
                    this.addCallback = this.addChildCallback;
                    this.removeCallback = this.removeChildCallback;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                    if (gameObject.displayList && gameObject.displayList !== this) gameObject.removeFromDisplayList();
                    if (!gameObject.displayList) {
                        this.queueDepthSort();
                        gameObject.displayList = this;
                        gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                        this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                    }
                },
                /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                    this.queueDepthSort();
                    gameObject.displayList = null;
                    gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.DisplayList#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                    this.sortChildrenFlag = true;
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.DisplayList#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                    if (this.sortChildrenFlag) {
                        StableSort(this.list, this.sortByDepth);
                        this.sortChildrenFlag = false;
                    }
                },
                /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.DisplayList#sortByDepth
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                    return childA._depth - childB._depth;
                },
                /**
     * Returns an array which contains all objects currently on the Display List.
     * This is a reference to the main list array, not a copy of it, so be careful not to modify it.
     *
     * @method Phaser.GameObjects.DisplayList#getChildren
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.list;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.DisplayList#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var list = this.list;
                    var i = list.length;
                    while(i--)list[i].destroy(true);
                    list.length = 0;
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.DisplayList#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                }
            });
            PluginCache.register("DisplayList", DisplayList, "displayList");
            module1.exports = DisplayList;
        /***/ },
        /* 1013 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array.Matrix
 */ module1.exports = {
                CheckMatrix: __webpack_require__(209),
                MatrixToString: __webpack_require__(1014),
                ReverseColumns: __webpack_require__(1015),
                ReverseRows: __webpack_require__(1016),
                Rotate180: __webpack_require__(1017),
                RotateLeft: __webpack_require__(1018),
                RotateMatrix: __webpack_require__(147),
                RotateRight: __webpack_require__(1019),
                Translate: __webpack_require__(1020),
                TransposeMatrix: __webpack_require__(435)
            };
        /***/ },
        /* 1014 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pad = __webpack_require__(186);
            var CheckMatrix = __webpack_require__(209);
            /**
 * Generates a string (which you can pass to console.log) from the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.MatrixToString
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - A 2-dimensional array.
 *
 * @return {string} A string representing the matrix.
 */ var MatrixToString = function(matrix) {
                var str = "";
                if (!CheckMatrix(matrix)) return str;
                for(var r = 0; r < matrix.length; r++){
                    for(var c = 0; c < matrix[r].length; c++){
                        var cell = matrix[r][c].toString();
                        if (cell !== "undefined") str += Pad(cell, 2);
                        else str += "?";
                        if (c < matrix[r].length - 1) str += " |";
                    }
                    if (r < matrix.length - 1) {
                        str += "\n";
                        for(var i = 0; i < matrix[r].length; i++){
                            str += "---";
                            if (i < matrix[r].length - 1) str += "+";
                        }
                        str += "\n";
                    }
                }
                return str;
            };
            module1.exports = MatrixToString;
        /***/ },
        /* 1015 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the columns in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseColumns
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the columns for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseColumns = function(matrix) {
                return matrix.reverse();
            };
            module1.exports = ReverseColumns;
        /***/ },
        /* 1016 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the rows in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseRows
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the rows for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseRows = function(matrix) {
                for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                return matrix;
            };
            module1.exports = ReverseRows;
        /***/ },
        /* 1017 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(147);
            /**
 * Rotates the array matrix 180 degrees.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Rotate180
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var Rotate180 = function(matrix) {
                return RotateMatrix(matrix, 180);
            };
            module1.exports = Rotate180;
        /***/ },
        /* 1018 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(147);
            /**
 * Rotates the array matrix to the left (or 90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateLeft
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateLeft = function(matrix) {
                return RotateMatrix(matrix, 90);
            };
            module1.exports = RotateLeft;
        /***/ },
        /* 1019 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(147);
            /**
 * Rotates the array matrix to the left (or -90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateRight
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateRight = function(matrix) {
                return RotateMatrix(matrix, -90);
            };
            module1.exports = RotateRight;
        /***/ },
        /* 1020 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateLeft = __webpack_require__(178);
            var RotateRight = __webpack_require__(179);
            /**
 * Translates the given Array Matrix by shifting each column and row the
 * amount specified.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Translate
 * @since 3.50.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to translate.
 * @param {number} [x=0] - The amount to horizontally translate the matrix by.
 * @param {number} [y=0] - The amount to vertically translate the matrix by.
 *
 * @return {T[][]} The translated matrix.
 */ var TranslateMatrix = function(matrix, x, y) {
                if (x === undefined) x = 0;
                if (y === undefined) y = 0;
                //  Vertical translation
                if (y !== 0) {
                    if (y < 0) //  Shift Up
                    RotateLeft(matrix, Math.abs(y));
                    else //  Shift Down
                    RotateRight(matrix, y);
                }
                //  Horizontal translation
                if (x !== 0) for(var i = 0; i < matrix.length; i++){
                    var row = matrix[i];
                    if (x < 0) RotateLeft(row, Math.abs(x));
                    else RotateRight(row, x);
                }
                return matrix;
            };
            module1.exports = TranslateMatrix;
        /***/ },
        /* 1021 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array.
 *
 * Each item must be unique within the array.
 *
 * The array is modified in-place and returned.
 *
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 *
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.Add
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array. Each item must be unique within the array.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var Add = function(array, item, limit, callback, context) {
                if (context === undefined) context = array;
                if (limit > 0) {
                    var remaining = limit - array.length;
                    //  There's nothing more we can do here, the array is full
                    if (remaining <= 0) return null;
                }
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    if (array.indexOf(item) === -1) {
                        array.push(item);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to insert
                //  Ensure all the items are unique
                var itemLength = item.length - 1;
                while(itemLength >= 0){
                    if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                    item.splice(itemLength, 1);
                    itemLength--;
                }
                //  Anything left?
                itemLength = item.length;
                if (itemLength === 0) return null;
                if (limit > 0 && itemLength > remaining) {
                    item.splice(remaining);
                    itemLength = remaining;
                }
                for(var i = 0; i < itemLength; i++){
                    var entry = item[i];
                    array.push(entry);
                    if (callback) callback.call(context, entry);
                }
                return item;
            };
            module1.exports = Add;
        /***/ },
        /* 1022 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array starting at the index specified.
 * 
 * Each item must be unique within the array.
 * 
 * Existing elements in the array are shifted up.
 * 
 * The array is modified in-place and returned.
 * 
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 * 
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.AddAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array.
 * @param {number} [index=0] - The index in the array where the item will be inserted.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var AddAt = function(array, item, index, limit, callback, context) {
                if (index === undefined) index = 0;
                if (context === undefined) context = array;
                if (limit > 0) {
                    var remaining = limit - array.length;
                    //  There's nothing more we can do here, the array is full
                    if (remaining <= 0) return null;
                }
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    if (array.indexOf(item) === -1) {
                        array.splice(index, 0, item);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to insert
                //  Ensure all the items are unique
                var itemLength = item.length - 1;
                while(itemLength >= 0){
                    if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                    item.pop();
                    itemLength--;
                }
                //  Anything left?
                itemLength = item.length;
                if (itemLength === 0) return null;
                //  Truncate to the limit
                if (limit > 0 && itemLength > remaining) {
                    item.splice(remaining);
                    itemLength = remaining;
                }
                for(var i = itemLength - 1; i >= 0; i--){
                    var entry = item[i];
                    array.splice(index, 0, entry);
                    if (callback) callback.call(context, entry);
                }
                return item;
            };
            module1.exports = AddAt;
        /***/ },
        /* 1023 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the top of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.BringToTop
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var BringToTop = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex < array.length) {
                    array.splice(currentIndex, 1);
                    array.push(item);
                }
                return item;
            };
            module1.exports = BringToTop;
        /***/ },
        /* 1024 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns the total number of elements in the array which have a property matching the given value.
 *
 * @function Phaser.Utils.Array.CountAllMatching
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test on each array element.
 * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {number} The total number of elements with properties matching the given value.
 */ var CountAllMatching = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                var total = 0;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (child[property] === value) total++;
                }
                return total;
            };
            module1.exports = CountAllMatching;
        /***/ },
        /* 1025 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes each element in the array to the given callback.
 *
 * @function Phaser.Utils.Array.Each
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the current array item.
 *
 * @return {array} The input array.
 */ var Each = function(array, callback, context) {
                var i;
                var args = [
                    null
                ];
                for(i = 3; i < arguments.length; i++)args.push(arguments[i]);
                for(i = 0; i < array.length; i++){
                    args[0] = array[i];
                    callback.apply(context, args);
                }
                return array;
            };
            module1.exports = Each;
        /***/ },
        /* 1026 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Passes each element in the array, between the start and end indexes, to the given callback.
 *
 * @function Phaser.Utils.Array.EachInRange
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {number} startIndex - The start index to search from.
 * @param {number} endIndex - The end index to search to.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 *
 * @return {array} The input array.
 */ var EachInRange = function(array, callback, context, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) {
                    var i;
                    var args = [
                        null
                    ];
                    for(i = 5; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = startIndex; i < endIndex; i++){
                        args[0] = array[i];
                        callback.apply(context, args);
                    }
                }
                return array;
            };
            module1.exports = EachInRange;
        /***/ },
        /* 1027 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element down one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveDown
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move down the array.
 *
 * @return {array} The input array.
 */ var MoveDown = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex > 0) {
                    var item2 = array[currentIndex - 1];
                    var index2 = array.indexOf(item2);
                    array[currentIndex] = item2;
                    array[index2] = item;
                }
                return array;
            };
            module1.exports = MoveDown;
        /***/ },
        /* 1028 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves an element in an array to a new position within the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveTo
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 * @param {number} index - The new index that the element will be moved to.
 *
 * @return {*} The element that was moved.
 */ var MoveTo = function(array, item, index) {
                var currentIndex = array.indexOf(item);
                if (currentIndex === -1 || index < 0 || index >= array.length) throw new Error("Supplied index out of bounds");
                if (currentIndex !== index) {
                    //  Remove
                    array.splice(currentIndex, 1);
                    //  Add in new location
                    array.splice(index, 0, item);
                }
                return item;
            };
            module1.exports = MoveTo;
        /***/ },
        /* 1029 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element up one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveUp
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move up the array.
 *
 * @return {array} The input array.
 */ var MoveUp = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex < array.length - 1) {
                    //  The element one above `item` in the array
                    var item2 = array[currentIndex + 1];
                    var index2 = array.indexOf(item2);
                    array[currentIndex] = item2;
                    array[index2] = item;
                }
                return array;
            };
            module1.exports = MoveUp;
        /***/ },
        /* 1030 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element above another one in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveAbove
 * @since 3.55.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The element to move above base element.
 * @param {*} item2 - The base element.
 * 
 *
 * @return {array} The input array.
 */ var MoveAbove = function(array, item1, item2) {
                if (item1 === item2) return array;
                var currentIndex = array.indexOf(item1);
                var baseIndex = array.indexOf(item2);
                if (currentIndex < 0 || baseIndex < 0) throw new Error("Supplied items must be elements of the same array");
                if (currentIndex > baseIndex) // item1 is already above item2
                return array;
                //  Remove
                array.splice(currentIndex, 1);
                //  Add in new location
                if (baseIndex === array.length - 1) array.push(item1);
                else array.splice(baseIndex, 0, item1);
                return array;
            };
            module1.exports = MoveAbove;
        /***/ },
        /* 1031 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element below another one in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveBelow
 * @since 3.55.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The element to move below base element.
 * @param {*} item2 - The base element.
 * 
 *
 * @return {array} The input array.
 */ var MoveBelow = function(array, item1, item2) {
                if (item1 === item2) return array;
                var currentIndex = array.indexOf(item1);
                var baseIndex = array.indexOf(item2);
                if (currentIndex < 0 || baseIndex < 0) throw new Error("Supplied items must be elements of the same array");
                if (currentIndex < baseIndex) // item1 is already below item2
                return array;
                //  Remove
                array.splice(currentIndex, 1);
                //  Add in new location
                if (baseIndex === 0) array.unshift(item1);
                else array.splice(baseIndex, 0, item1);
                return array;
            };
            module1.exports = MoveBelow;
        /***/ },
        /* 1032 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RoundAwayFromZero = __webpack_require__(363);
            /**
 * Create an array of numbers (positive and/or negative) progressing from `start`
 * up to but not including `end` by advancing by `step`.
 *
 * If `start` is less than `end` a zero-length range is created unless a negative `step` is specified.
 *
 * Certain values for `start` and `end` (eg. NaN/undefined/null) are currently coerced to 0;
 * for forward compatibility make sure to pass in actual numbers.
 * 
 * @example
 * NumberArrayStep(4);
 * // => [0, 1, 2, 3]
 *
 * NumberArrayStep(1, 5);
 * // => [1, 2, 3, 4]
 *
 * NumberArrayStep(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * NumberArrayStep(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * NumberArrayStep(1, 4, 0);
 * // => [1, 1, 1]
 *
 * NumberArrayStep(0);
 * // => []
 *
 * @function Phaser.Utils.Array.NumberArrayStep
 * @since 3.0.0
 *
 * @param {number} [start=0] - The start of the range.
 * @param {number} [end=null] - The end of the range.
 * @param {number} [step=1] - The value to increment or decrement by.
 *
 * @return {number[]} The array of number values.
 */ var NumberArrayStep = function(start, end, step) {
                if (start === undefined) start = 0;
                if (end === undefined) end = null;
                if (step === undefined) step = 1;
                if (end === null) {
                    end = start;
                    start = 0;
                }
                var result = [];
                var total = Math.max(RoundAwayFromZero((end - start) / (step || 1)), 0);
                for(var i = 0; i < total; i++){
                    result.push(start);
                    start += step;
                }
                return result;
            };
            module1.exports = NumberArrayStep;
        /***/ },
        /* 1033 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes the item from the given position in the array.
 * 
 * The array is modified in-place.
 * 
 * You can optionally specify a callback to be invoked for the item if it is successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} index - The array index to remove the item from. The index must be in bounds or it will throw an error.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*} The item that was removed.
 */ var RemoveAt = function(array, index, callback, context) {
                if (context === undefined) context = array;
                if (index < 0 || index > array.length - 1) throw new Error("Index out of bounds");
                var item = SpliceOne(array, index);
                if (callback) callback.call(context, item);
                return item;
            };
            module1.exports = RemoveAt;
        /***/ },
        /* 1034 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Removes the item within the given range in the array.
 * 
 * The array is modified in-place.
 * 
 * You can optionally specify a callback to be invoked for the item/s successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveBetween
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} startIndex - The start index to remove from.
 * @param {number} endIndex - The end index to remove to.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {Array.<*>} An array of items that were removed.
 */ var RemoveBetween = function(array, startIndex, endIndex, callback, context) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (context === undefined) context = array;
                if (SafeRange(array, startIndex, endIndex)) {
                    var size = endIndex - startIndex;
                    var removed = array.splice(startIndex, size);
                    if (callback) for(var i = 0; i < removed.length; i++){
                        var entry = removed[i];
                        callback.call(context, entry);
                    }
                    return removed;
                } else return [];
            };
            module1.exports = RemoveBetween;
        /***/ },
        /* 1035 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes a random object from the given array and returns it.
 * Will return null if there are no array items that fall within the specified range or if there is no item for the randomly chosen index.
 *
 * @function Phaser.Utils.Array.RemoveRandomElement
 * @since 3.0.0
 *
 * @param {array} array - The array to removed a random element from.
 * @param {number} [start=0] - The array index to start the search from.
 * @param {number} [length=array.length] - Optional restriction on the number of elements to randomly select from.
 *
 * @return {object} The random element that was removed, or `null` if there were no array elements that fell within the given range.
 */ var RemoveRandomElement = function(array, start, length) {
                if (start === undefined) start = 0;
                if (length === undefined) length = array.length;
                var randomIndex = start + Math.floor(Math.random() * length);
                return SpliceOne(array, randomIndex);
            };
            module1.exports = RemoveRandomElement;
        /***/ },
        /* 1036 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Replaces an element of the array with the new element.
 * The new element cannot already be a member of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Replace
 * @since 3.4.0
 *
 * @param {array} array - The array to search within.
 * @param {*} oldChild - The element in the array that will be replaced.
 * @param {*} newChild - The element to be inserted into the array at the position of `oldChild`.
 *
 * @return {boolean} Returns true if the oldChild was successfully replaced, otherwise returns false.
 */ var Replace = function(array, oldChild, newChild) {
                var index1 = array.indexOf(oldChild);
                var index2 = array.indexOf(newChild);
                if (index1 !== -1 && index2 === -1) {
                    array[index1] = newChild;
                    return true;
                } else return false;
            };
            module1.exports = Replace;
        /***/ },
        /* 1037 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the bottom of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.SendToBack
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var SendToBack = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex > 0) {
                    array.splice(currentIndex, 1);
                    array.unshift(item);
                }
                return item;
            };
            module1.exports = SendToBack;
        /***/ },
        /* 1038 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Scans the array for elements with the given property. If found, the property is set to the `value`.
 *
 * For example: `SetAll('visible', true)` would set all elements that have a `visible` property to `false`.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would update only the first 50 elements.
 *
 * @function Phaser.Utils.Array.SetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test for on each array element.
 * @param {*} value - The value to set the property to.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} The input array.
 */ var SetAll = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var entry = array[i];
                    if (entry.hasOwnProperty(property)) entry[property] = value;
                }
                return array;
            };
            module1.exports = SetAll;
        /***/ },
        /* 1039 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the position of two elements in the given array.
 * The elements must exist in the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Swap
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The first element to swap.
 * @param {*} item2 - The second element to swap.
 *
 * @return {array} The input array.
 */ var Swap = function(array, item1, item2) {
                if (item1 === item2) return array;
                var index1 = array.indexOf(item1);
                var index2 = array.indexOf(item2);
                if (index1 < 0 || index2 < 0) throw new Error("Supplied items must be elements of the same array");
                array[index1] = item2;
                array[index2] = item1;
                return array;
            };
            module1.exports = Swap;
        /***/ },
        /* 1040 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ProcessQueue = __webpack_require__(211);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * The Update List plugin.
 *
 * Update Lists belong to a Scene and maintain the list Game Objects to be updated every frame.
 *
 * Some or all of these Game Objects may also be part of the Scene's [Display List]{@link Phaser.GameObjects.DisplayList}, for Rendering.
 *
 * @class UpdateList
 * @extends Phaser.Structs.ProcessQueue.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that the Update List belongs to.
 */ var UpdateList = new Class({
                Extends: ProcessQueue,
                initialize: function UpdateList(scene) {
                    ProcessQueue.call(this);
                    //  No duplicates in this list
                    this.checkQueue = true;
                    /**
         * The Scene that the Update List belongs to.
         *
         * @name Phaser.GameObjects.UpdateList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.UpdateList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @name Phaser.GameObjects.UpdateList#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.GameObjects.UpdateList#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.update, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.sceneUpdate, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The update step.
     *
     * Pre-updates every active Game Object in the list.
     *
     * @method Phaser.GameObjects.UpdateList#sceneUpdate
     * @since 3.20.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ sceneUpdate: function(time, delta) {
                    var list = this._active;
                    var length = list.length;
                    for(var i = 0; i < length; i++){
                        var gameObject = list[i];
                        if (gameObject.active) gameObject.preUpdate.call(gameObject, time, delta);
                    }
                },
                /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.UpdateList#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    var i = this._active.length;
                    while(i--)this._active[i].destroy(true);
                    i = this._pending.length;
                    while(i--)this._pending[i].destroy(true);
                    i = this._destroy.length;
                    while(i--)this._destroy[i].destroy(true);
                    this._toProcess = 0;
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                    this.removeAllListeners();
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.sceneUpdate, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     *
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.UpdateList#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.systems.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("UpdateList", UpdateList, "updateList");
            module1.exports = UpdateList;
        /***/ },
        /* 1041 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Add Event.
 * 
 * This event is dispatched by a Process Queue when a new item is successfully moved to its active list.
 * 
 * You will most commonly see this used by a Scene's Update List when a new Game Object has been added.
 * 
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('add', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_ADD
 * @since 3.20.0
 * 
 * @param {*} item - The item that was added to the Process Queue.
 */ module1.exports = "add";
        /***/ },
        /* 1042 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Remove Event.
 * 
 * This event is dispatched by a Process Queue when a new item is successfully removed from its active list.
 * 
 * You will most commonly see this used by a Scene's Update List when a Game Object has been removed.
 * 
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('remove', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_REMOVE
 * @since 3.20.0
 * 
 * @param {*} item - The item that was removed from the Process Queue.
 */ module1.exports = "remove";
        /***/ },
        /* 1043 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the full bounds, in local and world space, of a BitmapText Game Object.
 *
 * Returns a BitmapTextSize object that contains global and local variants of the Game Objects x and y coordinates and
 * its width and height. Also includes an array of the line lengths and all word positions.
 *
 * The global position and size take into account the Game Object's position and scale.
 *
 * The local position and size just takes into account the font data.
 *
 * @function GetBitmapTextSize
 * @since 3.0.0
 * @private
 *
 * @param {(Phaser.GameObjects.DynamicBitmapText|Phaser.GameObjects.BitmapText)} src - The BitmapText to calculate the bounds values for.
 * @param {boolean} [round=false] - Whether to round the positions to the nearest integer.
 * @param {boolean} [updateOrigin=false] - Whether to update the origin of the BitmapText after bounds calculations?
 * @param {object} [out] - Object to store the results in, to save constant object creation. If not provided an empty object is returned.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} The calculated bounds values of the BitmapText.
 */ var GetBitmapTextSize = function(src, round, updateOrigin, out) {
                if (updateOrigin === undefined) updateOrigin = false;
                if (out === undefined) {
                    out = {
                        local: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        },
                        global: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        },
                        lines: {
                            shortest: 0,
                            longest: 0,
                            lengths: null,
                            height: 0
                        },
                        wrappedText: "",
                        words: [],
                        characters: [],
                        scaleX: 0,
                        scaleY: 0
                    };
                    return out;
                }
                var text = src.text;
                var textLength = text.length;
                var maxWidth = src.maxWidth;
                var wordWrapCharCode = src.wordWrapCharCode;
                var bx = Number.MAX_VALUE;
                var by = Number.MAX_VALUE;
                var bw = 0;
                var bh = 0;
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src.letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var align = src._align;
                var x = 0;
                var y = 0;
                var scale = src.fontSize / src.fontData.size;
                var sx = scale * src.scaleX;
                var sy = scale * src.scaleY;
                var lastGlyph = null;
                var lastCharCode = 0;
                var lineWidths = [];
                var shortestLine = Number.MAX_VALUE;
                var longestLine = 0;
                var currentLine = 0;
                var currentLineWidth = 0;
                var i;
                var words = [];
                var characters = [];
                var current = null;
                //  Scan for breach of maxWidth and insert carriage-returns
                if (maxWidth > 0) {
                    for(i = 0; i < textLength; i++){
                        charCode = text.charCodeAt(i);
                        if (charCode === 10) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy,
                                    cr: true
                                });
                                current = null;
                            }
                            xAdvance = 0;
                            yAdvance += lineHeight;
                            lastGlyph = null;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        if (lastGlyph !== null) var glyphKerningOffset = glyph.kerning[lastCharCode];
                        if (charCode === wordWrapCharCode) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy,
                                    cr: false
                                });
                                current = null;
                            }
                        } else {
                            if (current === null) //  We're starting a new word, recording the starting index, etc
                            current = {
                                word: "",
                                i: i,
                                x: xAdvance,
                                y: yAdvance,
                                w: 0,
                                h: lineHeight,
                                cr: false
                            };
                            current.word = current.word.concat(text[i]);
                            current.w += glyph.xOffset + glyph.xAdvance + (glyphKerningOffset !== undefined ? glyphKerningOffset : 0);
                        }
                        xAdvance += glyph.xAdvance + letterSpacing;
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                    }
                    //  Last word
                    if (current !== null) words.push({
                        word: current.word,
                        i: current.i,
                        x: current.x * sx,
                        y: current.y * sy,
                        w: current.w * sx,
                        h: current.h * sy,
                        cr: false
                    });
                    //  Reset for the next loop
                    xAdvance = 0;
                    yAdvance = 0;
                    lastGlyph = null;
                    lastCharCode = 0;
                    //  Loop through the words array and see if we've got any > maxWidth
                    var prev;
                    var offset = 0;
                    var crs = [];
                    for(i = 0; i < words.length; i++){
                        var entry = words[i];
                        var left = entry.x;
                        var right = entry.x + entry.w;
                        if (prev) {
                            var diff = left - (prev.x + prev.w);
                            offset = left - (diff + prev.w);
                            prev = null;
                        }
                        var checkLeft = left - offset;
                        var checkRight = right - offset;
                        if (checkLeft > maxWidth || checkRight > maxWidth) {
                            crs.push(entry.i - 1);
                            if (entry.cr) {
                                crs.push(entry.i + entry.word.length);
                                offset = 0;
                                prev = null;
                            } else prev = entry;
                        } else if (entry.cr) {
                            crs.push(entry.i + entry.word.length);
                            offset = 0;
                            prev = null;
                        }
                    }
                    var stringInsert = function(str, index, value) {
                        return str.substr(0, index) + value + str.substr(index + 1);
                    };
                    for(i = crs.length - 1; i >= 0; i--)// eslint-disable-next-line quotes
                    text = stringInsert(text, crs[i], "\n");
                    out.wrappedText = text;
                    textLength = text.length;
                    //  Recalculated in the next loop
                    words = [];
                    current = null;
                }
                var charIndex = 0;
                for(i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        if (current !== null) {
                            words.push({
                                word: current.word,
                                i: current.i,
                                x: current.x * sx,
                                y: current.y * sy,
                                w: current.w * sx,
                                h: current.h * sy
                            });
                            current = null;
                        }
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        lineWidths[currentLine] = currentLineWidth;
                        if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                        if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                        currentLine++;
                        currentLineWidth = 0;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    x = xAdvance;
                    y = yAdvance;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    if (bx > x) bx = x;
                    if (by > y) by = y;
                    var gw = x + glyph.xAdvance;
                    var gh = y + lineHeight;
                    if (bw < gw) bw = gw;
                    if (bh < gh) bh = gh;
                    var charWidth = glyph.xOffset + glyph.xAdvance + (kerningOffset !== undefined ? kerningOffset : 0);
                    if (charCode === wordWrapCharCode) {
                        if (current !== null) {
                            words.push({
                                word: current.word,
                                i: current.i,
                                x: current.x * sx,
                                y: current.y * sy,
                                w: current.w * sx,
                                h: current.h * sy
                            });
                            current = null;
                        }
                    } else {
                        if (current === null) //  We're starting a new word, recording the starting index, etc
                        current = {
                            word: "",
                            i: charIndex,
                            x: xAdvance,
                            y: yAdvance,
                            w: 0,
                            h: lineHeight
                        };
                        current.word = current.word.concat(text[i]);
                        current.w += charWidth;
                    }
                    characters.push({
                        i: charIndex,
                        char: text[i],
                        code: charCode,
                        x: (glyph.xOffset + xAdvance) * scale,
                        y: (glyph.yOffset + yAdvance) * scale,
                        w: glyph.width * scale,
                        h: glyph.height * scale,
                        t: yAdvance * scale,
                        r: gw * scale,
                        b: lineHeight * scale,
                        line: currentLine,
                        glyph: glyph
                    });
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    currentLineWidth = gw * scale;
                    charIndex++;
                }
                //  Last word
                if (current !== null) words.push({
                    word: current.word,
                    i: current.i,
                    x: current.x * sx,
                    y: current.y * sy,
                    w: current.w * sx,
                    h: current.h * sy
                });
                lineWidths[currentLine] = currentLineWidth;
                if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                //  Adjust all of the character positions based on alignment
                if (align > 0) for(var c = 0; c < characters.length; c++){
                    var currentChar = characters[c];
                    if (align === 1) {
                        var ax1 = (longestLine - lineWidths[currentChar.line]) / 2;
                        currentChar.x += ax1;
                        currentChar.r += ax1;
                    } else if (align === 2) {
                        var ax2 = longestLine - lineWidths[currentChar.line];
                        currentChar.x += ax2;
                        currentChar.r += ax2;
                    }
                }
                var local = out.local;
                var global = out.global;
                var lines = out.lines;
                local.x = bx * scale;
                local.y = by * scale;
                local.width = bw * scale;
                local.height = bh * scale;
                global.x = src.x - src._displayOriginX + bx * sx;
                global.y = src.y - src._displayOriginY + by * sy;
                global.width = bw * sx;
                global.height = bh * sy;
                lines.shortest = shortestLine;
                lines.longest = longestLine;
                lines.lengths = lineWidths;
                if (round) {
                    local.x = Math.ceil(local.x);
                    local.y = Math.ceil(local.y);
                    local.width = Math.ceil(local.width);
                    local.height = Math.ceil(local.height);
                    global.x = Math.ceil(global.x);
                    global.y = Math.ceil(global.y);
                    global.width = Math.ceil(global.width);
                    global.height = Math.ceil(global.height);
                    lines.shortest = Math.ceil(shortestLine);
                    lines.longest = Math.ceil(longestLine);
                }
                if (updateOrigin) {
                    src._displayOriginX = src.originX * local.width;
                    src._displayOriginY = src.originY * local.height;
                    global.x = src.x - src._displayOriginX * src.scaleX;
                    global.y = src.y - src._displayOriginY * src.scaleY;
                    if (round) {
                        global.x = Math.ceil(global.x);
                        global.y = Math.ceil(global.y);
                    }
                }
                out.words = words;
                out.characters = characters;
                out.lines.height = lineHeight;
                out.scale = scale;
                out.scaleX = src.scaleX;
                out.scaleY = src.scaleY;
                return out;
            };
            module1.exports = GetBitmapTextSize;
        /***/ },
        /* 1044 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ParseXMLBitmapFont = __webpack_require__(212);
            /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @function ParseFromAtlas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ var ParseFromAtlas = function(scene, fontName, textureKey, frameKey, xmlKey, xSpacing, ySpacing) {
                var texture = scene.sys.textures.get(textureKey);
                var frame = texture.get(frameKey);
                var xml = scene.sys.cache.xml.get(xmlKey);
                if (frame && xml) {
                    var data = ParseXMLBitmapFont(xml, frame, xSpacing, ySpacing, texture);
                    scene.sys.cache.bitmapFont.add(fontName, {
                        data: data,
                        texture: textureKey,
                        frame: frameKey,
                        fromAtlas: true
                    });
                    return true;
                } else return false;
            };
            module1.exports = ParseFromAtlas;
        /***/ },
        /* 1045 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1046);
            renderCanvas = __webpack_require__(1048);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1046 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BatchChar = __webpack_require__(1047);
            var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                if (textLength === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var roundPixels = camera.roundPixels;
                var cameraAlpha = camera.alpha;
                var charColors = src.charColors;
                var tintEffect = src.tintFill;
                var getTint = Utils.getTintAppendFloatAlpha;
                var tintTL = getTint(src.tintTopLeft, cameraAlpha * src._alphaTL);
                var tintTR = getTint(src.tintTopRight, cameraAlpha * src._alphaTR);
                var tintBL = getTint(src.tintBottomLeft, cameraAlpha * src._alphaBL);
                var tintBR = getTint(src.tintBottomRight, cameraAlpha * src._alphaBR);
                var texture = src.frame.glTexture;
                var textureUnit = pipeline.setGameObject(src);
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                var i;
                var char;
                var glyph;
                var characters = bounds.characters;
                var dropShadowX = src.dropShadowX;
                var dropShadowY = src.dropShadowY;
                var dropShadow = dropShadowX !== 0 || dropShadowY !== 0;
                renderer.pipelines.preBatch(src);
                if (dropShadow) {
                    var srcShadowColor = src.dropShadowColor;
                    var srcShadowAlpha = src.dropShadowAlpha;
                    var shadowTL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTL);
                    var shadowTR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTR);
                    var shadowBL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBL);
                    var shadowBR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBR);
                    for(i = 0; i < characters.length; i++){
                        char = characters[i];
                        glyph = char.glyph;
                        if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                        BatchChar(pipeline, src, char, glyph, dropShadowX, dropShadowY, calcMatrix, roundPixels, shadowTL, shadowTR, shadowBL, shadowBR, 1, texture, textureUnit);
                    }
                }
                for(i = 0; i < characters.length; i++){
                    char = characters[i];
                    glyph = char.glyph;
                    if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                    if (charColors[char.i]) {
                        var color = charColors[char.i];
                        var charTintEffect = color.tintEffect;
                        var charTintTL = getTint(color.tintTL, cameraAlpha * src._alphaTL);
                        var charTintTR = getTint(color.tintTR, cameraAlpha * src._alphaTR);
                        var charTintBL = getTint(color.tintBL, cameraAlpha * src._alphaBL);
                        var charTintBR = getTint(color.tintBR, cameraAlpha * src._alphaBR);
                        BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, charTintTL, charTintTR, charTintBL, charTintBR, charTintEffect, texture, textureUnit);
                    } else BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                //  Debug test if the characters are in the correct place when rendered:
                // pipeline.drawFillRect(tx0, ty0, tx2 - tx0, ty2 - ty0, 0x00ff00, 0.5);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = BitmapTextWebGLRenderer;
        /***/ },
        /* 1047 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders one character of the Bitmap Text to the WebGL Pipeline.
 *
 * @function BatchChar
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline. Must have a `batchQuad` method.
 * @param {Phaser.GameObjects.BitmapText} src - The BitmapText Game Object.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} char - The character to render.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapFontCharacterData} glyph - The character glyph.
 * @param {number} offsetX - The x offset.
 * @param {number} offsetY - The y offset.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix.
 * @param {boolean} roundPixels - Round the transform values or not?
 * @param {number} tintTL - Top-left tint value.
 * @param {number} tintTR - Top-right tint value.
 * @param {number} tintBL - Bottom-left tint value.
 * @param {number} tintBR - Bottom-right tint value.
 * @param {number} tintEffect - The tint effect mode.
 * @param {WebGLTexture} texture - The WebGL texture.
 * @param {number} textureUnit - The texture unit.
 */ var BatchChar = function(pipeline, src, char, glyph, offsetX, offsetY, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit) {
                var x = char.x - src.displayOriginX + offsetX;
                var y = char.y - src.displayOriginY + offsetY;
                var xw = x + char.w;
                var yh = y + char.h;
                var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, glyph.u0, glyph.v0, glyph.u1, glyph.v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
            };
            module1.exports = BatchChar;
        /***/ },
        /* 1048 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                var ctx = renderer.currentContext;
                if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var textureFrame = src.fromAtlas ? src.frame : src.texture.frames["__BASE"];
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src._letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var glyphX = 0;
                var glyphY = 0;
                var glyphW = 0;
                var glyphH = 0;
                var x = 0;
                var y = 0;
                var lastGlyph = null;
                var lastCharCode = 0;
                var image = textureFrame.source.image;
                var textureX = textureFrame.cutX;
                var textureY = textureFrame.cutY;
                var scale = src._fontSize / src.fontData.size;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                //  In case the method above changed it (word wrapping)
                if (src.maxWidth > 0) {
                    text = bounds.wrappedText;
                    textLength = text.length;
                }
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                ctx.translate(-src.displayOriginX, -src.displayOriginY);
                var roundPixels = camera.roundPixels;
                for(var i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphX = textureX + glyph.x;
                    glyphY = textureY + glyph.y;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    x = glyph.xOffset + xAdvance;
                    y = glyph.yOffset + yAdvance;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    x *= scale;
                    y *= scale;
                    x += lineOffsetX;
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    if (roundPixels) {
                        x = Math.round(x);
                        y = Math.round(y);
                    }
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.scale(scale, scale);
                    ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = BitmapTextCanvasRenderer;
        /***/ },
        /* 1049 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1050);
            renderCanvas = __webpack_require__(1051);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1050 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var list = src.getRenderList();
                if (list.length === 0) return;
                var alpha = camera.alpha * src.alpha;
                if (alpha === 0) //  Nothing to see, so abort early
                return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(this.pipeline, src);
                var cameraScrollX = camera.scrollX * src.scrollFactorX;
                var cameraScrollY = camera.scrollY * src.scrollFactorY;
                var calcMatrix = tempMatrix.copyFrom(camera.matrix);
                if (parentMatrix) {
                    calcMatrix.multiplyWithOffset(parentMatrix, -cameraScrollX, -cameraScrollY);
                    cameraScrollX = 0;
                    cameraScrollY = 0;
                }
                var blitterX = src.x - cameraScrollX;
                var blitterY = src.y - cameraScrollY;
                var prevTextureSourceIndex = -1;
                var tintEffect = false;
                var roundPixels = camera.roundPixels;
                renderer.pipelines.preBatch(src);
                for(var index = 0; index < list.length; index++){
                    var bob = list[index];
                    var frame = bob.frame;
                    var bobAlpha = bob.alpha * alpha;
                    if (bobAlpha === 0) continue;
                    var width = frame.width;
                    var height = frame.height;
                    var x = blitterX + bob.x + frame.x;
                    var y = blitterY + bob.y + frame.y;
                    if (bob.flipX) {
                        width *= -1;
                        x += frame.width;
                    }
                    if (bob.flipY) {
                        height *= -1;
                        y += frame.height;
                    }
                    var xw = x + width;
                    var yh = y + height;
                    var tx0 = calcMatrix.getX(x, y);
                    var ty0 = calcMatrix.getY(x, y);
                    var tx1 = calcMatrix.getX(xw, yh);
                    var ty1 = calcMatrix.getY(xw, yh);
                    var tint = Utils.getTintAppendFloatAlpha(bob.tint, bobAlpha);
                    //  Bind texture only if the Texture Source is different from before
                    if (frame.sourceIndex !== prevTextureSourceIndex) {
                        var textureUnit = pipeline.setGameObject(src, frame);
                        prevTextureSourceIndex = frame.sourceIndex;
                    }
                    if (roundPixels) {
                        tx0 = Math.round(tx0);
                        ty0 = Math.round(ty0);
                        tx1 = Math.round(tx1);
                        ty1 = Math.round(ty1);
                    }
                    //  TL x/y, BL x/y, BR x/y, TR x/y
                    if (pipeline.batchQuad(src, tx0, ty0, tx0, ty1, tx1, ty1, tx1, ty0, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, frame.glTexture, textureUnit)) prevTextureSourceIndex = -1;
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = BlitterWebGLRenderer;
        /***/ },
        /* 1051 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var list = src.getRenderList();
                if (list.length === 0) return;
                var ctx = renderer.currentContext;
                var alpha = camera.alpha * src.alpha;
                if (alpha === 0) //  Nothing to see, so abort early
                return;
                camera.addToRenderList(src);
                //  Blend Mode + Scale Mode
                ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                ctx.imageSmoothingEnabled = !(!renderer.antialias || src.frame.source.scaleMode);
                var cameraScrollX = src.x - camera.scrollX * src.scrollFactorX;
                var cameraScrollY = src.y - camera.scrollY * src.scrollFactorY;
                ctx.save();
                if (parentMatrix) parentMatrix.copyToContext(ctx);
                var roundPixels = camera.roundPixels;
                //  Render bobs
                for(var i = 0; i < list.length; i++){
                    var bob = list[i];
                    var flip = bob.flipX || bob.flipY;
                    var frame = bob.frame;
                    var cd = frame.canvasData;
                    var dx = frame.x;
                    var dy = frame.y;
                    var fx = 1;
                    var fy = 1;
                    var bobAlpha = bob.alpha * alpha;
                    if (bobAlpha === 0) continue;
                    ctx.globalAlpha = bobAlpha;
                    if (!flip) {
                        if (roundPixels) {
                            dx = Math.round(dx);
                            dy = Math.round(dy);
                        }
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx + bob.x + cameraScrollX, dy + bob.y + cameraScrollY, cd.width, cd.height);
                    } else {
                        if (bob.flipX) {
                            fx = -1;
                            dx -= cd.width;
                        }
                        if (bob.flipY) {
                            fy = -1;
                            dy -= cd.height;
                        }
                        ctx.save();
                        ctx.translate(bob.x + cameraScrollX, bob.y + cameraScrollY);
                        ctx.scale(fx, fy);
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx, dy, cd.width, cd.height);
                        ctx.restore();
                    }
                }
                ctx.restore();
            };
            module1.exports = BlitterCanvasRenderer;
        /***/ },
        /* 1052 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1053);
            renderCanvas = __webpack_require__(1054);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1053 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderWebGL
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerWebGLRenderer = function(renderer, container, camera, parentMatrix) {
                camera.addToRenderList(container);
                var children = container.list;
                var childCount = children.length;
                if (childCount === 0) return;
                var transformMatrix = container.localTransform;
                if (parentMatrix) {
                    transformMatrix.loadIdentity();
                    transformMatrix.multiply(parentMatrix);
                    transformMatrix.translate(container.x, container.y);
                    transformMatrix.rotate(container.rotation);
                    transformMatrix.scale(container.scaleX, container.scaleY);
                } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                renderer.pipelines.preBatch(container);
                var containerHasBlendMode = container.blendMode !== -1;
                if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = container.alpha;
                var scrollFactorX = container.scrollFactorX;
                var scrollFactorY = container.scrollFactorY;
                for(var i = 0; i < childCount; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlphaTopLeft;
                    var childAlphaTopRight;
                    var childAlphaBottomLeft;
                    var childAlphaBottomRight;
                    if (child.alphaTopLeft !== undefined) {
                        childAlphaTopLeft = child.alphaTopLeft;
                        childAlphaTopRight = child.alphaTopRight;
                        childAlphaBottomLeft = child.alphaBottomLeft;
                        childAlphaBottomRight = child.alphaBottomRight;
                    } else {
                        var childAlpha = child.alpha;
                        childAlphaTopLeft = childAlpha;
                        childAlphaTopRight = childAlpha;
                        childAlphaBottomLeft = childAlpha;
                        childAlphaBottomRight = childAlpha;
                    }
                    var childScrollFactorX = child.scrollFactorX;
                    var childScrollFactorY = child.scrollFactorY;
                    if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    var mask = child.mask;
                    if (mask) mask.preRenderWebGL(renderer, child, camera);
                    var type = child.type;
                    if (type !== renderer.currentType) {
                        renderer.newType = true;
                        renderer.currentType = type;
                    }
                    renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                    //  Set parent values
                    child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                    child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                    //  Render
                    child.renderWebGL(renderer, child, camera, transformMatrix);
                    //  Restore original values
                    child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                    child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                    if (mask) mask.postRenderWebGL(renderer, camera);
                    renderer.newType = false;
                }
                renderer.pipelines.postBatch(container);
            };
            module1.exports = ContainerWebGLRenderer;
        /***/ },
        /* 1054 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderCanvas
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerCanvasRenderer = function(renderer, container, camera, parentMatrix) {
                camera.addToRenderList(container);
                var children = container.list;
                if (children.length === 0) return;
                var transformMatrix = container.localTransform;
                if (parentMatrix) {
                    transformMatrix.loadIdentity();
                    transformMatrix.multiply(parentMatrix);
                    transformMatrix.translate(container.x, container.y);
                    transformMatrix.rotate(container.rotation);
                    transformMatrix.scale(container.scaleX, container.scaleY);
                } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                var containerHasBlendMode = container.blendMode !== -1;
                if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = container._alpha;
                var scrollFactorX = container.scrollFactorX;
                var scrollFactorY = container.scrollFactorY;
                if (container.mask) container.mask.preRenderCanvas(renderer, null, camera);
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlpha = child.alpha;
                    var childScrollFactorX = child.scrollFactorX;
                    var childScrollFactorY = child.scrollFactorY;
                    if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    //  Set parent values
                    child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                    child.setAlpha(childAlpha * alpha);
                    //  Render
                    child.renderCanvas(renderer, child, camera, transformMatrix);
                    //  Restore original values
                    child.setAlpha(childAlpha);
                    child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                }
                if (container.mask) container.mask.postRenderCanvas(renderer);
            };
            module1.exports = ContainerCanvasRenderer;
        /***/ },
        /* 1055 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(443);
            renderCanvas = __webpack_require__(443);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1056 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes to CSS Blend Modes Map.
 *
 * @name Phaser.CSSBlendModes
 * @ignore
 * @enum {string}
 * @memberof Phaser
 * @readonly
 * @since 3.12.0
 */ module1.exports = [
                "normal",
                "multiply",
                "multiply",
                "screen",
                "overlay",
                "darken",
                "lighten",
                "color-dodge",
                "color-burn",
                "hard-light",
                "soft-light",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
            ];
        /***/ },
        /* 1057 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1058);
            renderCanvas = __webpack_require__(1059);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1058 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src.text;
                var textLength = text.length;
                if (textLength === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var spriteMatrix = result.sprite;
                var calcMatrix = result.calc;
                var fontMatrix = tempMatrix;
                var crop = src.cropWidth > 0 || src.cropHeight > 0;
                if (crop) {
                    pipeline.flush();
                    renderer.pushScissor(calcMatrix.tx, calcMatrix.ty, src.cropWidth * calcMatrix.scaleX, src.cropHeight * calcMatrix.scaleY);
                }
                var frame = src.frame;
                var texture = frame.glTexture;
                var tintEffect = src.tintFill;
                var tintTL = Utils.getTintAppendFloatAlpha(src.tintTopLeft, camera.alpha * src._alphaTL);
                var tintTR = Utils.getTintAppendFloatAlpha(src.tintTopRight, camera.alpha * src._alphaTR);
                var tintBL = Utils.getTintAppendFloatAlpha(src.tintBottomLeft, camera.alpha * src._alphaBL);
                var tintBR = Utils.getTintAppendFloatAlpha(src.tintBottomRight, camera.alpha * src._alphaBR);
                var textureUnit = pipeline.setGameObject(src);
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var lastCharCode = 0;
                var letterSpacing = src.letterSpacing;
                var glyph;
                var glyphW = 0;
                var glyphH = 0;
                var lastGlyph;
                var scrollX = src.scrollX;
                var scrollY = src.scrollY;
                var fontData = src.fontData;
                var chars = fontData.chars;
                var lineHeight = fontData.lineHeight;
                var scale = src.fontSize / fontData.size;
                var rotation = 0;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                //  In case the method above changed it (word wrapping)
                if (src.maxWidth > 0) {
                    text = bounds.wrappedText;
                    textLength = text.length;
                }
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                var roundPixels = camera.roundPixels;
                var displayCallback = src.displayCallback;
                var callbackData = src.callbackData;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    //  Carriage-return
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    var x = glyph.xOffset + xAdvance - scrollX;
                    var y = glyph.yOffset + yAdvance - scrollY;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    scale = src.fontSize / src.fontData.size;
                    rotation = 0;
                    if (displayCallback) {
                        callbackData.color = 0;
                        callbackData.tint.topLeft = tintTL;
                        callbackData.tint.topRight = tintTR;
                        callbackData.tint.bottomLeft = tintBL;
                        callbackData.tint.bottomRight = tintBR;
                        callbackData.index = i;
                        callbackData.charCode = charCode;
                        callbackData.x = x;
                        callbackData.y = y;
                        callbackData.scale = scale;
                        callbackData.rotation = rotation;
                        callbackData.data = glyph.data;
                        var output = displayCallback(callbackData);
                        x = output.x;
                        y = output.y;
                        scale = output.scale;
                        rotation = output.rotation;
                        if (output.color) {
                            tintTL = output.color;
                            tintTR = output.color;
                            tintBL = output.color;
                            tintBR = output.color;
                        } else {
                            tintTL = output.tint.topLeft;
                            tintTR = output.tint.topRight;
                            tintBL = output.tint.bottomLeft;
                            tintBR = output.tint.bottomRight;
                        }
                        tintTL = Utils.getTintAppendFloatAlpha(tintTL, camera.alpha * src._alphaTL);
                        tintTR = Utils.getTintAppendFloatAlpha(tintTR, camera.alpha * src._alphaTR);
                        tintBL = Utils.getTintAppendFloatAlpha(tintBL, camera.alpha * src._alphaBL);
                        tintBR = Utils.getTintAppendFloatAlpha(tintBR, camera.alpha * src._alphaBR);
                    }
                    x *= scale;
                    y *= scale;
                    x -= src.displayOriginX;
                    y -= src.displayOriginY;
                    x += lineOffsetX;
                    fontMatrix.applyITRS(x, y, rotation, scale, scale);
                    calcMatrix.multiply(fontMatrix, spriteMatrix);
                    var u0 = glyph.u0;
                    var v0 = glyph.v0;
                    var u1 = glyph.u1;
                    var v1 = glyph.v1;
                    var xw = glyphW;
                    var yh = glyphH;
                    var tx0 = spriteMatrix.e;
                    var ty0 = spriteMatrix.f;
                    var tx1 = yh * spriteMatrix.c + spriteMatrix.e;
                    var ty1 = yh * spriteMatrix.d + spriteMatrix.f;
                    var tx2 = xw * spriteMatrix.a + yh * spriteMatrix.c + spriteMatrix.e;
                    var ty2 = xw * spriteMatrix.b + yh * spriteMatrix.d + spriteMatrix.f;
                    var tx3 = xw * spriteMatrix.a + spriteMatrix.e;
                    var ty3 = xw * spriteMatrix.b + spriteMatrix.f;
                    if (roundPixels) {
                        tx0 = Math.round(tx0);
                        ty0 = Math.round(ty0);
                        tx1 = Math.round(tx1);
                        ty1 = Math.round(ty1);
                        tx2 = Math.round(tx2);
                        ty2 = Math.round(ty2);
                        tx3 = Math.round(tx3);
                        ty3 = Math.round(ty3);
                    }
                    pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                }
                if (crop) {
                    pipeline.flush();
                    renderer.popScissor();
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = DynamicBitmapTextWebGLRenderer;
        /***/ },
        /* 1059 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                var ctx = renderer.currentContext;
                if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var textureFrame = src.fromAtlas ? src.frame : src.texture.frames["__BASE"];
                var displayCallback = src.displayCallback;
                var callbackData = src.callbackData;
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src._letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var glyphX = 0;
                var glyphY = 0;
                var glyphW = 0;
                var glyphH = 0;
                var x = 0;
                var y = 0;
                var lastGlyph = null;
                var lastCharCode = 0;
                var image = src.frame.source.image;
                var textureX = textureFrame.cutX;
                var textureY = textureFrame.cutY;
                var rotation = 0;
                var scale = 0;
                var baseScale = src._fontSize / src.fontData.size;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                src.getTextBounds(false);
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                ctx.translate(-src.displayOriginX, -src.displayOriginY);
                var roundPixels = camera.roundPixels;
                if (src.cropWidth > 0 && src.cropHeight > 0) {
                    ctx.beginPath();
                    ctx.rect(0, 0, src.cropWidth, src.cropHeight);
                    ctx.clip();
                }
                for(var i = 0; i < textLength; i++){
                    //  Reset the scale (in case the callback changed it)
                    scale = baseScale;
                    rotation = 0;
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphX = textureX + glyph.x;
                    glyphY = textureY + glyph.y;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    x = glyph.xOffset + xAdvance - src.scrollX;
                    y = glyph.yOffset + yAdvance - src.scrollY;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    if (displayCallback) {
                        callbackData.index = i;
                        callbackData.charCode = charCode;
                        callbackData.x = x;
                        callbackData.y = y;
                        callbackData.scale = scale;
                        callbackData.rotation = rotation;
                        callbackData.data = glyph.data;
                        var output = displayCallback(callbackData);
                        x = output.x;
                        y = output.y;
                        scale = output.scale;
                        rotation = output.rotation;
                    }
                    x *= scale;
                    y *= scale;
                    x += lineOffsetX;
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    if (roundPixels) {
                        x = Math.round(x);
                        y = Math.round(y);
                    }
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rotation);
                    ctx.scale(scale, scale);
                    ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = DynamicBitmapTextCanvasRenderer;
        /***/ },
        /* 1060 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1061);
            renderCanvas = __webpack_require__(1062);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1061 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Extern#renderWebGL
 * @since 3.16.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Extern} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ExternWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                renderer.pipelines.clear();
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                src.render.call(src, renderer, camera, calcMatrix);
                renderer.pipelines.rebind();
            };
            module1.exports = ExternWebGLRenderer;
        /***/ },
        /* 1062 */ /***/ function(module1, exports) {
        /***/ },
        /* 1063 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1064);
            //  Needed for Graphics.generateTexture
            renderCanvas = __webpack_require__(448);
            renderCanvas = __webpack_require__(448);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1064 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(217);
            var GetCalcMatrix = __webpack_require__(19);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var Point = function(x, y, width) {
                this.x = x;
                this.y = y;
                this.width = width;
            };
            var Path = function(x, y, width) {
                this.points = [];
                this.pointsLength = 1;
                this.points[0] = new Point(x, y, width);
            };
            var matrixStack = [];
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GraphicsWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.commandBuffer.length === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                renderer.pipelines.preBatch(src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var currentMatrix = tempMatrix.loadIdentity();
                var commands = src.commandBuffer;
                var alpha = camera.alpha * src.alpha;
                var lineWidth = 1;
                var fillTint = pipeline.fillTint;
                var strokeTint = pipeline.strokeTint;
                var tx = 0;
                var ty = 0;
                var ta = 0;
                var iterStep = 0.01;
                var PI2 = Math.PI * 2;
                var cmd;
                var path = [];
                var pathIndex = 0;
                var pathOpen = true;
                var lastPath = null;
                var getTint = Utils.getTintAppendFloatAlpha;
                for(var cmdIndex = 0; cmdIndex < commands.length; cmdIndex++){
                    cmd = commands[cmdIndex];
                    switch(cmd){
                        case Commands.BEGIN_PATH:
                            path.length = 0;
                            lastPath = null;
                            pathOpen = true;
                            break;
                        case Commands.CLOSE_PATH:
                            pathOpen = false;
                            if (lastPath && lastPath.points.length) lastPath.points.push(lastPath.points[0]);
                            break;
                        case Commands.FILL_PATH:
                            for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchFillPath(path[pathIndex].points, currentMatrix, calcMatrix);
                            break;
                        case Commands.STROKE_PATH:
                            for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchStrokePath(path[pathIndex].points, lineWidth, pathOpen, currentMatrix, calcMatrix);
                            break;
                        case Commands.LINE_STYLE:
                            lineWidth = commands[++cmdIndex];
                            var strokeColor = commands[++cmdIndex];
                            var strokeAlpha = commands[++cmdIndex] * alpha;
                            var strokeTintColor = getTint(strokeColor, strokeAlpha);
                            strokeTint.TL = strokeTintColor;
                            strokeTint.TR = strokeTintColor;
                            strokeTint.BL = strokeTintColor;
                            strokeTint.BR = strokeTintColor;
                            break;
                        case Commands.FILL_STYLE:
                            var fillColor = commands[++cmdIndex];
                            var fillAlpha = commands[++cmdIndex] * alpha;
                            var fillTintColor = getTint(fillColor, fillAlpha);
                            fillTint.TL = fillTintColor;
                            fillTint.TR = fillTintColor;
                            fillTint.BL = fillTintColor;
                            fillTint.BR = fillTintColor;
                            break;
                        case Commands.GRADIENT_FILL_STYLE:
                            var alphaTL = commands[++cmdIndex] * alpha;
                            var alphaTR = commands[++cmdIndex] * alpha;
                            var alphaBL = commands[++cmdIndex] * alpha;
                            var alphaBR = commands[++cmdIndex] * alpha;
                            fillTint.TL = getTint(commands[++cmdIndex], alphaTL);
                            fillTint.TR = getTint(commands[++cmdIndex], alphaTR);
                            fillTint.BL = getTint(commands[++cmdIndex], alphaBL);
                            fillTint.BR = getTint(commands[++cmdIndex], alphaBR);
                            break;
                        case Commands.GRADIENT_LINE_STYLE:
                            lineWidth = commands[++cmdIndex];
                            var gradientLineAlpha = commands[++cmdIndex] * alpha;
                            strokeTint.TL = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.TR = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.BL = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.BR = getTint(commands[++cmdIndex], gradientLineAlpha);
                            break;
                        case Commands.ARC:
                            var iteration = 0;
                            var x = commands[++cmdIndex];
                            var y = commands[++cmdIndex];
                            var radius = commands[++cmdIndex];
                            var startAngle = commands[++cmdIndex];
                            var endAngle = commands[++cmdIndex];
                            var anticlockwise = commands[++cmdIndex];
                            var overshoot = commands[++cmdIndex];
                            endAngle -= startAngle;
                            if (anticlockwise) {
                                if (endAngle < -PI2) endAngle = -PI2;
                                else if (endAngle > 0) endAngle = -PI2 + endAngle % PI2;
                            } else if (endAngle > PI2) endAngle = PI2;
                            else if (endAngle < 0) endAngle = PI2 + endAngle % PI2;
                            if (lastPath === null) {
                                lastPath = new Path(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius, lineWidth);
                                path.push(lastPath);
                                iteration += iterStep;
                            }
                            while(iteration < 1 + overshoot){
                                ta = endAngle * iteration + startAngle;
                                tx = x + Math.cos(ta) * radius;
                                ty = y + Math.sin(ta) * radius;
                                lastPath.points.push(new Point(tx, ty, lineWidth));
                                iteration += iterStep;
                            }
                            ta = endAngle + startAngle;
                            tx = x + Math.cos(ta) * radius;
                            ty = y + Math.sin(ta) * radius;
                            lastPath.points.push(new Point(tx, ty, lineWidth));
                            break;
                        case Commands.FILL_RECT:
                            pipeline.batchFillRect(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                            break;
                        case Commands.FILL_TRIANGLE:
                            pipeline.batchFillTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                            break;
                        case Commands.STROKE_TRIANGLE:
                            pipeline.batchStrokeTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], lineWidth, currentMatrix, calcMatrix);
                            break;
                        case Commands.LINE_TO:
                            if (lastPath !== null) lastPath.points.push(new Point(commands[++cmdIndex], commands[++cmdIndex], lineWidth));
                            else {
                                lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                                path.push(lastPath);
                            }
                            break;
                        case Commands.MOVE_TO:
                            lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                            path.push(lastPath);
                            break;
                        case Commands.SAVE:
                            matrixStack.push(currentMatrix.copyToArray());
                            break;
                        case Commands.RESTORE:
                            currentMatrix.copyFromArray(matrixStack.pop());
                            break;
                        case Commands.TRANSLATE:
                            x = commands[++cmdIndex];
                            y = commands[++cmdIndex];
                            currentMatrix.translate(x, y);
                            break;
                        case Commands.SCALE:
                            x = commands[++cmdIndex];
                            y = commands[++cmdIndex];
                            currentMatrix.scale(x, y);
                            break;
                        case Commands.ROTATE:
                            currentMatrix.rotate(commands[++cmdIndex]);
                            break;
                    }
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = GraphicsWebGLRenderer;
        /***/ },
        /* 1065 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1066);
            renderCanvas = __webpack_require__(1067);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1066 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                src.pipeline.batchSprite(src, camera, parentMatrix);
            };
            module1.exports = SpriteWebGLRenderer;
        /***/ },
        /* 1067 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = SpriteCanvasRenderer;
        /***/ },
        /* 1068 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1069);
            renderCanvas = __webpack_require__(1070);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1069 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                this.pipeline.batchSprite(src, camera, parentMatrix);
            };
            module1.exports = ImageWebGLRenderer;
        /***/ },
        /* 1070 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = ImageCanvasRenderer;
        /***/ },
        /* 1071 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1072);
            renderCanvas = __webpack_require__(1073);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1072 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var LayerWebGLRenderer = function(renderer, layer, camera) {
                var children = layer.list;
                var childCount = children.length;
                if (childCount === 0) return;
                layer.depthSort();
                renderer.pipelines.preBatch(layer);
                var layerHasBlendMode = layer.blendMode !== -1;
                if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = layer.alpha;
                for(var i = 0; i < childCount; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlphaTopLeft;
                    var childAlphaTopRight;
                    var childAlphaBottomLeft;
                    var childAlphaBottomRight;
                    if (child.alphaTopLeft !== undefined) {
                        childAlphaTopLeft = child.alphaTopLeft;
                        childAlphaTopRight = child.alphaTopRight;
                        childAlphaBottomLeft = child.alphaBottomLeft;
                        childAlphaBottomRight = child.alphaBottomRight;
                    } else {
                        var childAlpha = child.alpha;
                        childAlphaTopLeft = childAlpha;
                        childAlphaTopRight = childAlpha;
                        childAlphaBottomLeft = childAlpha;
                        childAlphaBottomRight = childAlpha;
                    }
                    if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    var mask = child.mask;
                    if (mask) mask.preRenderWebGL(renderer, child, camera);
                    var type = child.type;
                    if (type !== renderer.currentType) {
                        renderer.newType = true;
                        renderer.currentType = type;
                    }
                    renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                    child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                    //  Render
                    child.renderWebGL(renderer, child, camera);
                    //  Restore original values
                    child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                    if (mask) mask.postRenderWebGL(renderer, camera);
                    renderer.newType = false;
                }
                renderer.pipelines.postBatch(layer);
            };
            module1.exports = LayerWebGLRenderer;
        /***/ },
        /* 1073 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LayerCanvasRenderer = function(renderer, layer, camera) {
                var children = layer.list;
                if (children.length === 0) return;
                layer.depthSort();
                var layerHasBlendMode = layer.blendMode !== -1;
                if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = layer._alpha;
                if (layer.mask) layer.mask.preRenderCanvas(renderer, null, camera);
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlpha = child.alpha;
                    if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    //  Set parent values
                    child.setAlpha(childAlpha * alpha);
                    //  Render
                    child.renderCanvas(renderer, child, camera);
                    //  Restore original values
                    child.setAlpha(childAlpha);
                }
                if (layer.mask) layer.mask.postRenderCanvas(renderer);
            };
            module1.exports = LayerCanvasRenderer;
        /***/ },
        /* 1074 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles
 */ module1.exports = {
                EmitterOp: __webpack_require__(449),
                GravityWell: __webpack_require__(450),
                Particle: __webpack_require__(451),
                ParticleEmitter: __webpack_require__(452),
                ParticleEmitterManager: __webpack_require__(220),
                Zones: __webpack_require__(1078)
            };
        /***/ },
        /* 1075 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1076);
            renderCanvas = __webpack_require__(1077);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1076 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var tempMatrix4 = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.EmitterManager#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleManagerWebGLRenderer = function(renderer, emitterManager, camera, parentMatrix) {
                var emitters = emitterManager.emitters.list;
                var emittersLength = emitters.length;
                if (emittersLength === 0) return;
                var pipeline = renderer.pipelines.set(emitterManager.pipeline);
                var camMatrix = tempMatrix1;
                var calcMatrix = tempMatrix2;
                var particleMatrix = tempMatrix3;
                var managerMatrix = tempMatrix4;
                if (parentMatrix) {
                    managerMatrix.loadIdentity();
                    managerMatrix.multiply(parentMatrix);
                    managerMatrix.translate(emitterManager.x, emitterManager.y);
                    managerMatrix.rotate(emitterManager.rotation);
                    managerMatrix.scale(emitterManager.scaleX, emitterManager.scaleY);
                } else managerMatrix.applyITRS(emitterManager.x, emitterManager.y, emitterManager.rotation, emitterManager.scaleX, emitterManager.scaleY);
                var roundPixels = camera.roundPixels;
                var texture = emitterManager.defaultFrame.glTexture;
                var getTint = Utils.getTintAppendFloatAlpha;
                var textureUnit = pipeline.setGameObject(emitterManager, emitterManager.defaultFrame);
                renderer.pipelines.preBatch(emitterManager);
                for(var e = 0; e < emittersLength; e++){
                    var emitter = emitters[e];
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    if (!emitter.visible || particleCount === 0) continue;
                    camera.addToRenderList(emitter);
                    var scrollFactorX = emitter.scrollFactorX;
                    var scrollFactorY = emitter.scrollFactorY;
                    renderer.setBlendMode(emitter.blendMode);
                    if (emitter.mask) {
                        emitter.mask.preRenderWebGL(renderer, emitter, camera);
                        renderer.pipelines.set(emitterManager.pipeline);
                    }
                    var tintEffect = 0;
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * camera.alpha;
                        if (alpha <= 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        camMatrix.multiplyWithOffset(managerMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        var x = -frame.halfWidth;
                        var y = -frame.halfHeight;
                        var xw = x + frame.width;
                        var yh = y + frame.height;
                        var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                        var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                        var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                        var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                        var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                        var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                        var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                        var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                        var tint = getTint(particle.tint, alpha);
                        pipeline.batchQuad(emitter, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, texture, textureUnit);
                    }
                    if (emitter.mask) emitter.mask.postRenderWebGL(renderer, camera);
                }
                renderer.pipelines.postBatch(emitterManager);
            };
            module1.exports = ParticleManagerWebGLRenderer;
        /***/ },
        /* 1077 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var tempMatrix4 = new TransformMatrix();
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.EmitterManager#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleManagerCanvasRenderer = function(renderer, emitterManager, camera, parentMatrix) {
                var emitters = emitterManager.emitters.list;
                var emittersLength = emitters.length;
                if (emittersLength === 0) return;
                var camMatrix = tempMatrix1.copyFrom(camera.matrix);
                var calcMatrix = tempMatrix2;
                var particleMatrix = tempMatrix3;
                var managerMatrix = tempMatrix4;
                if (parentMatrix) {
                    managerMatrix.loadIdentity();
                    managerMatrix.multiply(parentMatrix);
                    managerMatrix.translate(emitterManager.x, emitterManager.y);
                    managerMatrix.rotate(emitterManager.rotation);
                    managerMatrix.scale(emitterManager.scaleX, emitterManager.scaleY);
                } else managerMatrix.applyITRS(emitterManager.x, emitterManager.y, emitterManager.rotation, emitterManager.scaleX, emitterManager.scaleY);
                var ctx = renderer.currentContext;
                var roundPixels = camera.roundPixels;
                for(var e = 0; e < emittersLength; e++){
                    var emitter = emitters[e];
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    if (!emitter.visible || particleCount === 0) continue;
                    camera.addToRenderList(emitter);
                    var scrollFactorX = emitter.scrollFactorX;
                    var scrollFactorY = emitter.scrollFactorY;
                    ctx.save();
                    ctx.globalCompositeOperation = renderer.blendModes[emitter.blendMode];
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * camera.alpha;
                        if (alpha <= 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        camMatrix.multiplyWithOffset(managerMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        var cd = frame.canvasData;
                        var x = -frame.halfWidth;
                        var y = -frame.halfHeight;
                        ctx.globalAlpha = alpha;
                        ctx.save();
                        calcMatrix.setToContext(ctx);
                        if (roundPixels) {
                            x = Math.round(x);
                            y = Math.round(y);
                        }
                        ctx.imageSmoothingEnabled = !(!renderer.antialias || frame.source.scaleMode);
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                        ctx.restore();
                    }
                    ctx.restore();
                }
            };
            module1.exports = ParticleManagerCanvasRenderer;
        /***/ },
        /* 1078 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles.Zones
 */ module1.exports = {
                DeathZone: __webpack_require__(453),
                EdgeZone: __webpack_require__(454),
                RandomZone: __webpack_require__(456)
            };
        /***/ },
        /* 1079 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1080);
            renderCanvas = __webpack_require__(1081);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1080 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.RenderTexture#renderWebGL
 * @since 3.2.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.RenderTexture} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RenderTextureWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var cameraAlpha = camera.alpha;
                var renderTarget = src.renderTarget;
                var width = renderTarget.width;
                var height = renderTarget.height;
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline);
                var textureUnit = pipeline.setTexture2D(renderTarget.texture);
                renderer.pipelines.preBatch(src);
                pipeline.batchTexture(src, renderTarget.texture, width, height, src.x, src.y, width, height, src.scaleX, src.scaleY, src.rotation, src.flipX, !src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, cameraAlpha * src._alphaTL), getTint(src.tintTopRight, cameraAlpha * src._alphaTR), getTint(src.tintBottomLeft, cameraAlpha * src._alphaBL), getTint(src.tintBottomRight, cameraAlpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, true, textureUnit);
                renderer.resetTextures();
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RenderTextureWebGLRenderer;
        /***/ },
        /* 1081 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.RenderTexture#renderCanvas
 * @since 3.2.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.RenderTexture} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RenderTextureCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = RenderTextureCanvasRenderer;
        /***/ },
        /* 1082 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = __webpack_require__(1083);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.GameObjects.RetroFont
 * @since 3.6.0
 */ var RetroFont = {
                Parse: __webpack_require__(1084)
            };
            //   Merge in the consts
            RetroFont = Extend(false, RetroFont, RETRO_FONT_CONST);
            module1.exports = RetroFont;
        /***/ },
        /* 1083 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = {
                /**
     * Text Set 1 =  !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET1
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET1: " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~",
                /**
     * Text Set 2 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET2
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET2: " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                /**
     * Text Set 3 = ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET3
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET3: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ",
                /**
     * Text Set 4 = ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET4
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET4: "ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789",
                /**
     * Text Set 5 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET5
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET5: "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789",
                /**
     * Text Set 6 = ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.' 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET6
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET6: "ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789\"(),-.' ",
                /**
     * Text Set 7 = AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-'39
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET7
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET7: "AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW\")28FLRX-'39",
                /**
     * Text Set 8 = 0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET8
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET8: "0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                /**
     * Text Set 9 = ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'"?!
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET9
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET9: "ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'\"?!",
                /**
     * Text Set 10 = ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET10
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET10: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                /**
     * Text Set 11 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()':;0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET11
     * @since 3.6.0
     * @type {string}
     */ TEXT_SET11: "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,\"-+!?()':;0123456789"
            };
            module1.exports = RETRO_FONT_CONST;
        /***/ },
        /* 1084 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Parses a Retro Font configuration object so you can pass it to the BitmapText constructor
 * and create a BitmapText object using a fixed-width retro font.
 *
 * @function Phaser.GameObjects.RetroFont.Parse
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Phaser Scene.
 * @param {Phaser.Types.GameObjects.BitmapText.RetroFontConfig} config - The font configuration object.
 *
 * @return {object} A parsed Bitmap Font data entry for the Bitmap Font cache.
 */ var ParseRetroFont = function(scene, config) {
                var w = config.width;
                var h = config.height;
                var cx = Math.floor(w / 2);
                var cy = Math.floor(h / 2);
                var letters = GetValue(config, "chars", "");
                if (letters === "") return;
                var key = GetValue(config, "image", "");
                var frame = scene.sys.textures.getFrame(key);
                var textureX = frame.cutX;
                var textureY = frame.cutY;
                var textureWidth = frame.source.width;
                var textureHeight = frame.source.height;
                var offsetX = GetValue(config, "offset.x", 0);
                var offsetY = GetValue(config, "offset.y", 0);
                var spacingX = GetValue(config, "spacing.x", 0);
                var spacingY = GetValue(config, "spacing.y", 0);
                var lineSpacing = GetValue(config, "lineSpacing", 0);
                var charsPerRow = GetValue(config, "charsPerRow", null);
                if (charsPerRow === null) {
                    charsPerRow = textureWidth / w;
                    if (charsPerRow > letters.length) charsPerRow = letters.length;
                }
                var x = offsetX;
                var y = offsetY;
                var data = {
                    retroFont: true,
                    font: key,
                    size: w,
                    lineHeight: h + lineSpacing,
                    chars: {}
                };
                var r = 0;
                for(var i = 0; i < letters.length; i++){
                    var charCode = letters.charCodeAt(i);
                    var u0 = (textureX + x) / textureWidth;
                    var v0 = (textureY + y) / textureHeight;
                    var u1 = (textureX + x + w) / textureWidth;
                    var v1 = (textureY + y + h) / textureHeight;
                    data.chars[charCode] = {
                        x: x,
                        y: y,
                        width: w,
                        height: h,
                        centerX: cx,
                        centerY: cy,
                        xOffset: 0,
                        yOffset: 0,
                        xAdvance: w,
                        data: {},
                        kerning: {},
                        u0: u0,
                        v0: v0,
                        u1: u1,
                        v1: v1
                    };
                    r++;
                    if (r === charsPerRow) {
                        r = 0;
                        x = offsetX;
                        y += h + spacingY;
                    } else x += w + spacingX;
                }
                var entry = {
                    data: data,
                    frame: null,
                    texture: key
                };
                return entry;
            };
            module1.exports = ParseRetroFont;
        /***/ },
        /* 1085 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1086);
            renderCanvas = __webpack_require__(1087);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1086 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rope#renderWebGL
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RopeWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var vertices = src.vertices;
                var uvs = src.uv;
                var colors = src.colors;
                var alphas = src.alphas;
                var alpha = src.alpha;
                var getTint = Utils.getTintAppendFloatAlpha;
                var roundPixels = camera.roundPixels;
                var meshVerticesLength = vertices.length;
                var vertexCount = Math.floor(meshVerticesLength * 0.5);
                //  Because it's a triangle strip and we don't want lots of degenerate triangles joining things up
                pipeline.flush();
                renderer.pipelines.preBatch(src);
                var textureUnit = pipeline.setGameObject(src);
                var vertexViewF32 = pipeline.vertexViewF32;
                var vertexViewU32 = pipeline.vertexViewU32;
                var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                var colorIndex = 0;
                var tintEffect = src.tintFill;
                if (src.dirty) src.updateVertices();
                var debugCallback = src.debugCallback;
                var debugVerts = [];
                for(var i = 0; i < meshVerticesLength; i += 2){
                    var x = vertices[i + 0];
                    var y = vertices[i + 1];
                    var tx = x * calcMatrix.a + y * calcMatrix.c + calcMatrix.e;
                    var ty = x * calcMatrix.b + y * calcMatrix.d + calcMatrix.f;
                    if (roundPixels) {
                        tx = Math.round(tx);
                        ty = Math.round(ty);
                    }
                    vertexViewF32[++vertexOffset] = tx;
                    vertexViewF32[++vertexOffset] = ty;
                    vertexViewF32[++vertexOffset] = uvs[i + 0];
                    vertexViewF32[++vertexOffset] = uvs[i + 1];
                    vertexViewF32[++vertexOffset] = textureUnit;
                    vertexViewF32[++vertexOffset] = tintEffect;
                    vertexViewU32[++vertexOffset] = getTint(colors[colorIndex], camera.alpha * (alphas[colorIndex] * alpha));
                    colorIndex++;
                    if (debugCallback) {
                        debugVerts[i + 0] = tx;
                        debugVerts[i + 1] = ty;
                    }
                }
                if (debugCallback) debugCallback.call(src, src, meshVerticesLength, debugVerts);
                pipeline.vertexCount += vertexCount;
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RopeWebGLRenderer;
        /***/ },
        /* 1087 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Rope.Render. There is no Canvas renderer for Rope objects.
 *
 * @method Phaser.GameObjects.Rope#renderCanvas
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var RopeCanvasRenderer = function() {};
            module1.exports = RopeCanvasRenderer;
        /***/ },
        /* 1088 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1089);
            renderCanvas = __webpack_require__(1090);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1089 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.width === 0 || src.height === 0) return;
                camera.addToRenderList(src);
                var frame = src.frame;
                var width = frame.width;
                var height = frame.height;
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var textureUnit = pipeline.setTexture2D(frame.glTexture, src);
                renderer.pipelines.preBatch(src);
                pipeline.batchTexture(src, frame.glTexture, width, height, src.x, src.y, width / src.style.resolution, height / src.style.resolution, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, false, textureUnit);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TextWebGLRenderer;
        /***/ },
        /* 1090 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.width === 0 || src.height === 0) return;
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = TextCanvasRenderer;
        /***/ },
        /* 1091 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1092);
            renderCanvas = __webpack_require__(1093);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1092 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                src.updateCanvas();
                var width = src.width;
                var height = src.height;
                if (width === 0 || height === 0) return;
                camera.addToRenderList(src);
                renderer.pipelines.preBatch(src);
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var textureUnit = pipeline.setTexture2D(src.fillPattern, src);
                pipeline.batchTexture(src, src.fillPattern, src.displayFrame.width * src.tileScaleX, src.displayFrame.height * src.tileScaleY, src.x, src.y, width, height, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.originX * width, src.originY * height, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, src.tilePositionX % src.displayFrame.width / src.displayFrame.width, src.tilePositionY % src.displayFrame.height / src.displayFrame.height, camera, parentMatrix, false, textureUnit);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TileSpriteWebGLRenderer;
        /***/ },
        /* 1093 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                src.updateCanvas();
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = TileSpriteCanvasRenderer;
        /***/ },
        /* 1094 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1095);
            renderCanvas = __webpack_require__(1096);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1095 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderWebGL
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.videoTexture) {
                    camera.addToRenderList(src);
                    src.pipeline.batchSprite(src, camera, parentMatrix);
                }
            };
            module1.exports = VideoWebGLRenderer;
        /***/ },
        /* 1096 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderCanvas
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.videoTexture) {
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                }
            };
            module1.exports = VideoCanvasRenderer;
        /***/ },
        /* 1097 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1098);
            renderCanvas = __webpack_require__(1099);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1098 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var FillPathWebGL = __webpack_require__(114);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = ArcWebGLRenderer;
        /***/ },
        /* 1099 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(36);
            var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var radius = src.radius;
                    ctx.beginPath();
                    ctx.arc(radius - src.originX * (radius * 2), radius - src.originY * (radius * 2), radius, DegToRad(src._startAngle), DegToRad(src._endAngle), src.anticlockwise);
                    if (src.closePath) ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = ArcCanvasRenderer;
        /***/ },
        /* 1100 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1101);
            renderCanvas = __webpack_require__(1102);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1101 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(114);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX + src._curveBounds.x;
                var dy = src._displayOriginY + src._curveBounds.y;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = CurveWebGLRenderer;
        /***/ },
        /* 1102 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX + src._curveBounds.x;
                    var dy = src._displayOriginY + src._curveBounds.y;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    if (src.closePath) ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = CurveCanvasRenderer;
        /***/ },
        /* 1103 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1104);
            renderCanvas = __webpack_require__(1105);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1104 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(114);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = EllipseWebGLRenderer;
        /***/ },
        /* 1105 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = EllipseCanvasRenderer;
        /***/ },
        /* 1106 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1107);
            renderCanvas = __webpack_require__(1108);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1107 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                calcMatrix.translate(-src._displayOriginX, -src._displayOriginY);
                var alpha = camera.alpha * src.alpha;
                //  Work out the grid size
                var width = src.width;
                var height = src.height;
                var cellWidth = src.cellWidth;
                var cellHeight = src.cellHeight;
                var gridWidth = Math.ceil(width / cellWidth);
                var gridHeight = Math.ceil(height / cellHeight);
                var cellWidthA = cellWidth;
                var cellHeightA = cellHeight;
                var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                var fillTint;
                var fillTintColor;
                var showCells = src.showCells;
                var showAltCells = src.showAltCells;
                var showOutline = src.showOutline;
                var x = 0;
                var y = 0;
                var r = 0;
                var cw = 0;
                var ch = 0;
                if (showOutline) {
                    //  To make room for the grid lines (in case alpha < 1)
                    cellWidthA--;
                    cellHeightA--;
                    if (cellWidthB === cellWidth) cellWidthB--;
                    if (cellHeightB === cellHeight) cellHeightB--;
                }
                renderer.pipelines.preBatch(src);
                if (showCells && src.fillAlpha > 0) {
                    fillTint = pipeline.fillTint;
                    fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    for(y = 0; y < gridHeight; y++){
                        if (showAltCells) r = y % 2;
                        for(x = 0; x < gridWidth; x++){
                            if (showAltCells && r) {
                                r = 0;
                                continue;
                            }
                            r++;
                            cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                            ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                            pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                        }
                    }
                }
                if (showAltCells && src.altFillAlpha > 0) {
                    fillTint = pipeline.fillTint;
                    fillTintColor = Utils.getTintAppendFloatAlpha(src.altFillColor, src.altFillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    for(y = 0; y < gridHeight; y++){
                        if (showAltCells) r = y % 2;
                        for(x = 0; x < gridWidth; x++){
                            if (showAltCells && !r) {
                                r = 1;
                                continue;
                            }
                            r = 0;
                            cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                            ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                            pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                        }
                    }
                }
                if (showOutline && src.outlineFillAlpha > 0) {
                    var strokeTint = pipeline.strokeTint;
                    var color = Utils.getTintAppendFloatAlpha(src.outlineFillColor, src.outlineFillAlpha * alpha);
                    strokeTint.TL = color;
                    strokeTint.TR = color;
                    strokeTint.BL = color;
                    strokeTint.BR = color;
                    for(x = 1; x < gridWidth; x++){
                        var x1 = x * cellWidth;
                        pipeline.batchLine(x1, 0, x1, height, 1, 1, 1, 0, false);
                    }
                    for(y = 1; y < gridHeight; y++){
                        var y1 = y * cellHeight;
                        pipeline.batchLine(0, y1, width, y1, 1, 1, 1, 0, false);
                    }
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = GridWebGLRenderer;
        /***/ },
        /* 1108 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = -src._displayOriginX;
                    var dy = -src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    //  Work out the grid size
                    var width = src.width;
                    var height = src.height;
                    var cellWidth = src.cellWidth;
                    var cellHeight = src.cellHeight;
                    var gridWidth = Math.ceil(width / cellWidth);
                    var gridHeight = Math.ceil(height / cellHeight);
                    var cellWidthA = cellWidth;
                    var cellHeightA = cellHeight;
                    var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                    var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                    var showCells = src.showCells;
                    var showAltCells = src.showAltCells;
                    var showOutline = src.showOutline;
                    var x = 0;
                    var y = 0;
                    var r = 0;
                    var cw = 0;
                    var ch = 0;
                    if (showOutline) {
                        //  To make room for the grid lines (in case alpha < 1)
                        cellWidthA--;
                        cellHeightA--;
                        if (cellWidthB === cellWidth) cellWidthB--;
                        if (cellHeightB === cellHeight) cellHeightB--;
                    }
                    if (showCells && src.fillAlpha > 0) {
                        FillStyleCanvas(ctx, src);
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && r) {
                                    r = 0;
                                    continue;
                                }
                                r++;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showAltCells && src.altFillAlpha > 0) {
                        FillStyleCanvas(ctx, src, src.altFillColor, src.altFillAlpha * alpha);
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && !r) {
                                    r = 1;
                                    continue;
                                }
                                r = 0;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showOutline && src.outlineFillAlpha > 0) {
                        LineStyleCanvas(ctx, src, src.outlineFillColor, src.outlineFillAlpha * alpha);
                        for(x = 1; x < gridWidth; x++){
                            var x1 = x * cellWidth;
                            ctx.beginPath();
                            ctx.moveTo(x1 + dx, dy);
                            ctx.lineTo(x1 + dx, height + dy);
                            ctx.stroke();
                        }
                        for(y = 1; y < gridHeight; y++){
                            var y1 = y * cellHeight;
                            ctx.beginPath();
                            ctx.moveTo(dx, y1 + dy);
                            ctx.lineTo(dx + width, y1 + dy);
                            ctx.stroke();
                        }
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = GridCanvasRenderer;
        /***/ },
        /* 1109 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1110);
            renderCanvas = __webpack_require__(1111);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1110 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var size = src.width;
                var height = src.height;
                var sizeA = size / 2;
                var sizeB = size / src.projection;
                var alpha = camera.alpha * src.alpha;
                if (!src.isFilled) return;
                var tint;
                var x0;
                var y0;
                var x1;
                var y1;
                var x2;
                var y2;
                var x3;
                var y3;
                renderer.pipelines.preBatch(src);
                //  Top Face
                if (src.showTop) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                    x0 = calcMatrix.getX(-sizeA, -height);
                    y0 = calcMatrix.getY(-sizeA, -height);
                    x1 = calcMatrix.getX(0, -sizeB - height);
                    y1 = calcMatrix.getY(0, -sizeB - height);
                    x2 = calcMatrix.getX(sizeA, -height);
                    y2 = calcMatrix.getY(sizeA, -height);
                    x3 = calcMatrix.getX(0, sizeB - height);
                    y3 = calcMatrix.getY(0, sizeB - height);
                    pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                }
                //  Left Face
                if (src.showLeft) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                    x0 = calcMatrix.getX(-sizeA, 0);
                    y0 = calcMatrix.getY(-sizeA, 0);
                    x1 = calcMatrix.getX(0, sizeB);
                    y1 = calcMatrix.getY(0, sizeB);
                    x2 = calcMatrix.getX(0, sizeB - height);
                    y2 = calcMatrix.getY(0, sizeB - height);
                    x3 = calcMatrix.getX(-sizeA, -height);
                    y3 = calcMatrix.getY(-sizeA, -height);
                    pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                }
                //  Right Face
                if (src.showRight) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                    x0 = calcMatrix.getX(sizeA, 0);
                    y0 = calcMatrix.getY(sizeA, 0);
                    x1 = calcMatrix.getX(0, sizeB);
                    y1 = calcMatrix.getY(0, sizeB);
                    x2 = calcMatrix.getX(0, sizeB - height);
                    y2 = calcMatrix.getY(0, sizeB - height);
                    x3 = calcMatrix.getX(sizeA, -height);
                    y3 = calcMatrix.getY(sizeA, -height);
                    pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = IsoBoxWebGLRenderer;
        /***/ },
        /* 1111 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    //  Top Face
                    if (src.showTop) {
                        FillStyleCanvas(ctx, src, src.fillTop);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, -height);
                        ctx.lineTo(0, -sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(sizeA, -1);
                        ctx.lineTo(0, sizeB - 1);
                        ctx.lineTo(-sizeA, -1);
                        ctx.lineTo(-sizeA, -height);
                        ctx.fill();
                    }
                    //  Left Face
                    if (src.showLeft) {
                        FillStyleCanvas(ctx, src, src.fillLeft);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, 0);
                        ctx.lineTo(0, sizeB);
                        ctx.lineTo(0, sizeB - height);
                        ctx.lineTo(-sizeA, -height);
                        ctx.lineTo(-sizeA, 0);
                        ctx.fill();
                    }
                    //  Right Face
                    if (src.showRight) {
                        FillStyleCanvas(ctx, src, src.fillRight);
                        ctx.beginPath();
                        ctx.moveTo(sizeA, 0);
                        ctx.lineTo(0, sizeB);
                        ctx.lineTo(0, sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(sizeA, 0);
                        ctx.fill();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = IsoBoxCanvasRenderer;
        /***/ },
        /* 1112 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1113);
            renderCanvas = __webpack_require__(1114);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1113 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var size = src.width;
                var height = src.height;
                var sizeA = size / 2;
                var sizeB = size / src.projection;
                var reversed = src.isReversed;
                var alpha = camera.alpha * src.alpha;
                if (!src.isFilled) return;
                renderer.pipelines.preBatch(src);
                var tint;
                var x0;
                var y0;
                var x1;
                var y1;
                var x2;
                var y2;
                //  Top Face
                if (src.showTop && reversed) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                    x0 = calcMatrix.getX(-sizeA, -height);
                    y0 = calcMatrix.getY(-sizeA, -height);
                    x1 = calcMatrix.getX(0, -sizeB - height);
                    y1 = calcMatrix.getY(0, -sizeB - height);
                    x2 = calcMatrix.getX(sizeA, -height);
                    y2 = calcMatrix.getY(sizeA, -height);
                    var x3 = calcMatrix.getX(0, sizeB - height);
                    var y3 = calcMatrix.getY(0, sizeB - height);
                    pipeline.batchQuad(src, x0, y0, x1, y1, x2, y2, x3, y3, 0, 0, 1, 1, tint, tint, tint, tint, 2);
                }
                //  Left Face
                if (src.showLeft) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                    if (reversed) {
                        x0 = calcMatrix.getX(-sizeA, -height);
                        y0 = calcMatrix.getY(-sizeA, -height);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    } else {
                        x0 = calcMatrix.getX(-sizeA, 0);
                        y0 = calcMatrix.getY(-sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    }
                    pipeline.batchTri(src, x0, y0, x1, y1, x2, y2, 0, 0, 1, 1, tint, tint, tint, 2);
                }
                //  Right Face
                if (src.showRight) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                    if (reversed) {
                        x0 = calcMatrix.getX(sizeA, -height);
                        y0 = calcMatrix.getY(sizeA, -height);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    } else {
                        x0 = calcMatrix.getX(sizeA, 0);
                        y0 = calcMatrix.getY(sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    }
                    pipeline.batchTri(src, x0, y0, x1, y1, x2, y2, 0, 0, 1, 1, tint, tint, tint, 2);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = IsoTriangleWebGLRenderer;
        /***/ },
        /* 1114 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    var reversed = src.isReversed;
                    //  Top Face
                    if (src.showTop && reversed) {
                        FillStyleCanvas(ctx, src, src.fillTop);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, -height);
                        ctx.lineTo(0, -sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(0, sizeB - height);
                        ctx.fill();
                    }
                    //  Left Face
                    if (src.showLeft) {
                        FillStyleCanvas(ctx, src, src.fillLeft);
                        ctx.beginPath();
                        if (reversed) {
                            ctx.moveTo(-sizeA, -height);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        } else {
                            ctx.moveTo(-sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        }
                        ctx.fill();
                    }
                    //  Right Face
                    if (src.showRight) {
                        FillStyleCanvas(ctx, src, src.fillRight);
                        ctx.beginPath();
                        if (reversed) {
                            ctx.moveTo(sizeA, -height);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        } else {
                            ctx.moveTo(sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        }
                        ctx.fill();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = IsoTriangleCanvasRenderer;
        /***/ },
        /* 1115 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1116);
            renderCanvas = __webpack_require__(1117);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1116 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isStroked) {
                    var strokeTint = pipeline.strokeTint;
                    var color = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                    strokeTint.TL = color;
                    strokeTint.TR = color;
                    strokeTint.BL = color;
                    strokeTint.BR = color;
                    var startWidth = src._startWidth;
                    var endWidth = src._endWidth;
                    pipeline.batchLine(src.geom.x1 - dx, src.geom.y1 - dy, src.geom.x2 - dx, src.geom.y2 - dy, startWidth, endWidth, 1, 0, false, result.sprite, result.camera);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = LineWebGLRenderer;
        /***/ },
        /* 1117 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.beginPath();
                        ctx.moveTo(src.geom.x1 - dx, src.geom.y1 - dy);
                        ctx.lineTo(src.geom.x2 - dx, src.geom.y2 - dy);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = LineCanvasRenderer;
        /***/ },
        /* 1118 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1119);
            renderCanvas = __webpack_require__(1120);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1119 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(114);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = PolygonWebGLRenderer;
        /***/ },
        /* 1120 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = PolygonCanvasRenderer;
        /***/ },
        /* 1121 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1122);
            renderCanvas = __webpack_require__(1123);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1122 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) {
                    var fillTint = pipeline.fillTint;
                    var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    pipeline.batchFillRect(-dx, -dy, src.width, src.height);
                }
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RectangleWebGLRenderer;
        /***/ },
        /* 1123 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fillRect(-dx, -dy, src.width, src.height);
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.beginPath();
                        ctx.rect(-dx, -dy, src.width, src.height);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = RectangleCanvasRenderer;
        /***/ },
        /* 1124 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1125);
            renderCanvas = __webpack_require__(1126);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1125 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(114);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = StarWebGLRenderer;
        /***/ },
        /* 1126 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = StarCanvasRenderer;
        /***/ },
        /* 1127 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1128);
            renderCanvas = __webpack_require__(1129);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1128 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) {
                    var fillTint = pipeline.fillTint;
                    var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    var x1 = src.geom.x1 - dx;
                    var y1 = src.geom.y1 - dy;
                    var x2 = src.geom.x2 - dx;
                    var y2 = src.geom.y2 - dy;
                    var x3 = src.geom.x3 - dx;
                    var y3 = src.geom.y3 - dy;
                    pipeline.batchFillTriangle(x1, y1, x2, y2, x3, y3, result.sprite, result.camera);
                }
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TriangleWebGLRenderer;
        /***/ },
        /* 1129 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(48);
            var LineStyleCanvas = __webpack_require__(60);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var x1 = src.geom.x1 - dx;
                    var y1 = src.geom.y1 - dy;
                    var x2 = src.geom.x2 - dx;
                    var y2 = src.geom.y2 - dy;
                    var x3 = src.geom.x3 - dx;
                    var y3 = src.geom.y3 - dy;
                    ctx.beginPath();
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x2, y2);
                    ctx.lineTo(x3, y3);
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = TriangleCanvasRenderer;
        /***/ },
        /* 1130 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(213);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Blitter Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#blitter
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} key - The key of the Texture the Blitter object will use.
 * @param {(string|number)} [frame] - The default Frame children of the Blitter will use.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectFactory.register("blitter", function(x, y, key, frame) {
                return this.displayList.add(new Blitter(this.scene, x, y, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1131 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Container = __webpack_require__(214);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Container Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#container
 * @since 3.4.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectFactory.register("container", function(x, y, children) {
                return this.displayList.add(new Container(this.scene, x, y, children));
            });
        /***/ },
        /* 1132 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DOMElement = __webpack_require__(442);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * When this is added, Phaser will automatically create a DOM Container div that is positioned over the top
 * of the game canvas. This div is sized to match the canvas, and if the canvas size changes, as a result of
 * settings within the Scale Manager, the dom container is resized accordingly.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * Note: This method will only be available if the DOM Element Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dom
 * @since 3.17.0
 *
 * @param {number} x - The horizontal position of this DOM Element in the world.
 * @param {number} y - The vertical position of this DOM Element in the world.
 * @param {(HTMLElement|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 *
 * @return {Phaser.GameObjects.DOMElement} The Game Object that was created.
 */ GameObjectFactory.register("dom", function(x, y, element, style, innerText) {
                var gameObject = new DOMElement(this.scene, x, y, element, style, innerText);
                this.displayList.add(gameObject);
                return gameObject;
            });
        /***/ },
        /* 1133 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DynamicBitmapText = __webpack_require__(215);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Dynamic Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dynamicBitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectFactory.register("dynamicBitmapText", function(x, y, font, text, size) {
                return this.displayList.add(new DynamicBitmapText(this.scene, x, y, font, text, size));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1134 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extern = __webpack_require__(444);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Extern Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Extern Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#extern
 * @since 3.16.0
 *
 * @return {Phaser.GameObjects.Extern} The Game Object that was created.
 */ GameObjectFactory.register("extern", function() {
                var extern = new Extern(this.scene);
                this.displayList.add(extern);
                return extern;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1135 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Graphics = __webpack_require__(216);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Graphics Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#graphics
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Graphics.Options} [config] - The Graphics configuration.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectFactory.register("graphics", function(config) {
                return this.displayList.add(new Graphics(this.scene, config));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1136 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Group = __webpack_require__(113);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Group Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#group
 * @since 3.0.0
 *
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupConfig[])} [children] - Game Objects to add to this Group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - A Group Configuration object.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectFactory.register("group", function(children, config) {
                return this.updateList.add(new Group(this.scene, children, config));
            });
        /***/ },
        /* 1137 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Image1 = __webpack_require__(125);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Image Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#image
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectFactory.register("image", function(x, y, key, frame) {
                return this.displayList.add(new Image1(this.scene, x, y, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1138 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Layer = __webpack_require__(219);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Layer Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#layer
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectFactory.register("layer", function(children) {
                return this.displayList.add(new Layer(this.scene, children));
            });
        /***/ },
        /* 1139 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var ParticleEmitterManager = __webpack_require__(220);
            /**
 * Creates a new Particle Emitter Manager Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#particles
 * @since 3.0.0
 *
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number|object)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterConfig[]} [emitters] - Configuration settings for one or more emitters to create.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
 */ GameObjectFactory.register("particles", function(key, frame, emitters) {
                return this.displayList.add(new ParticleEmitterManager(this.scene, key, frame, emitters));
            });
        /***/ },
        /* 1140 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var PathFollower = __webpack_require__(457);
            /**
 * Creates a new PathFollower Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the PathFollower Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#follower
 * @since 3.0.0
 *
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is connected to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.PathFollower} The Game Object that was created.
 */ GameObjectFactory.register("follower", function(path, x, y, key, frame) {
                var sprite = new PathFollower(this.scene, path, x, y, key, frame);
                this.displayList.add(sprite);
                this.updateList.add(sprite);
                return sprite;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1141 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var RenderTexture = __webpack_require__(221);
            /**
 * Creates a new Render Texture Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 * 
 * A Render Texture is a special texture that allows any number of Game Objects to be drawn to it. You can take many complex objects and
 * draw them all to this one texture, which can they be used as the texture for other Game Object's. It's a way to generate dynamic
 * textures at run-time that are WebGL friendly and don't invoke expensive GPU uploads.
 *
 * @method Phaser.GameObjects.GameObjectFactory#renderTexture
 * @since 3.2.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 * @property {string} [key] - The texture key to make the RenderTexture from.
 * @property {string} [frame] - the frame to make the RenderTexture from.
 * 
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectFactory.register("renderTexture", function(x, y, width, height, key, frame) {
                return this.displayList.add(new RenderTexture(this.scene, x, y, width, height, key, frame));
            });
        /***/ },
        /* 1142 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rope = __webpack_require__(223);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register("rope", function(x, y, texture, frame, points, horizontal, colors, alphas) {
                return this.displayList.add(new Rope(this.scene, x, y, texture, frame, points, horizontal, colors, alphas));
            });
        /***/ },
        /* 1143 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Sprite = __webpack_require__(73);
            /**
 * Creates a new Sprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#sprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectFactory.register("sprite", function(x, y, key, frame) {
                var sprite = new Sprite(this.scene, x, y, key, frame);
                this.displayList.add(sprite);
                return sprite;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1144 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(148);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#bitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 *
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectFactory.register("bitmapText", function(x, y, font, text, size, align) {
                return this.displayList.add(new BitmapText(this.scene, x, y, font, text, size, align));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1145 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Text = __webpack_require__(224);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Text Game Object and adds it to the Scene.
 *
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do ths for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#text
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} [style] - The Text style configuration object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectFactory.register("text", function(x, y, text, style) {
                return this.displayList.add(new Text(this.scene, x, y, text, style));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1146 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileSprite = __webpack_require__(225);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new TileSprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tileSprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectFactory.register("tileSprite", function(x, y, width, height, key, frame) {
                return this.displayList.add(new TileSprite(this.scene, x, y, width, height, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1147 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Zone = __webpack_require__(129);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Zone Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#zone
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object.
 * @param {number} height - The height of the Game Object.
 * 
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectFactory.register("zone", function(x, y, width, height) {
                return this.displayList.add(new Zone(this.scene, x, y, width, height));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //  
        //  There are several properties available to use:
        //  
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1148 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Video = __webpack_require__(226);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Video Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#video
 * @since 3.20.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectFactory.register("video", function(x, y, key) {
                return this.displayList.add(new Video(this.scene, x, y, key));
            });
        /***/ },
        /* 1149 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arc = __webpack_require__(461);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Arc Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 * 
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 *
 * @method Phaser.GameObjects.GameObjectFactory#arc
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register("arc", function(x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                return this.displayList.add(new Arc(this.scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha));
            });
            /**
 * Creates a new Circle Shape Game Object and adds it to the Scene.
 * 
 * A Circle is an Arc with no defined start and end angle, making it render as a complete circle.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#circle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the circle.
 * @param {number} [fillColor] - The color the circle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the circle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register("circle", function(x, y, radius, fillColor, fillAlpha) {
                return this.displayList.add(new Arc(this.scene, x, y, radius, 0, 360, false, fillColor, fillAlpha));
            });
        /***/ },
        /* 1150 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Curve = __webpack_require__(462);
            /**
 * Creates a new Curve Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Curve Game Object has been built into Phaser.
 * 
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 * 
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#curve
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Curve} The Game Object that was created.
 */ GameObjectFactory.register("curve", function(x, y, curve, fillColor, fillAlpha) {
                return this.displayList.add(new Curve(this.scene, x, y, curve, fillColor, fillAlpha));
            });
        /***/ },
        /* 1151 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(463);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Ellipse Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Ellipse Game Object has been built into Phaser.
 * 
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 * 
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#ellipse
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Ellipse} The Game Object that was created.
 */ GameObjectFactory.register("ellipse", function(x, y, width, height, fillColor, fillAlpha) {
                return this.displayList.add(new Ellipse(this.scene, x, y, width, height, fillColor, fillAlpha));
            });
        /***/ },
        /* 1152 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Grid = __webpack_require__(464);
            /**
 * Creates a new Grid Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Grid Game Object has been built into Phaser.
 * 
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @method Phaser.GameObjects.GameObjectFactory#grid
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 *
 * @return {Phaser.GameObjects.Grid} The Game Object that was created.
 */ GameObjectFactory.register("grid", function(x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                return this.displayList.add(new Grid(this.scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha));
            });
        /***/ },
        /* 1153 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var IsoBox = __webpack_require__(465);
            /**
 * Creates a new IsoBox Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoBox Game Object has been built into Phaser.
 * 
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isobox
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 *
 * @return {Phaser.GameObjects.IsoBox} The Game Object that was created.
 */ GameObjectFactory.register("isobox", function(x, y, size, height, fillTop, fillLeft, fillRight) {
                return this.displayList.add(new IsoBox(this.scene, x, y, size, height, fillTop, fillLeft, fillRight));
            });
        /***/ },
        /* 1154 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var IsoTriangle = __webpack_require__(466);
            /**
 * Creates a new IsoTriangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoTriangle Game Object has been built into Phaser.
 * 
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isotriangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 *
 * @return {Phaser.GameObjects.IsoTriangle} The Game Object that was created.
 */ GameObjectFactory.register("isotriangle", function(x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                return this.displayList.add(new IsoTriangle(this.scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight));
            });
        /***/ },
        /* 1155 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Line = __webpack_require__(467);
            /**
 * Creates a new Line Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Line Game Object has been built into Phaser.
 * 
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only stroke colors and cannot be filled.
 * 
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 * 
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#line
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Line} The Game Object that was created.
 */ GameObjectFactory.register("line", function(x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                return this.displayList.add(new Line(this.scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha));
            });
        /***/ },
        /* 1156 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Polygon = __webpack_require__(468);
            /**
 * Creates a new Polygon Shape Game Object and adds it to the Scene.
 * 
 * Note: This method will only be available if the Polygon Game Object has been built into Phaser.
 * 
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 * 
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * @method Phaser.GameObjects.GameObjectFactory#polygon
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Polygon} The Game Object that was created.
 */ GameObjectFactory.register("polygon", function(x, y, points, fillColor, fillAlpha) {
                return this.displayList.add(new Polygon(this.scene, x, y, points, fillColor, fillAlpha));
            });
        /***/ },
        /* 1157 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Rectangle = __webpack_require__(473);
            /**
 * Creates a new Rectangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Rectangle Game Object has been built into Phaser.
 * 
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @method Phaser.GameObjects.GameObjectFactory#rectangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Rectangle} The Game Object that was created.
 */ GameObjectFactory.register("rectangle", function(x, y, width, height, fillColor, fillAlpha) {
                return this.displayList.add(new Rectangle(this.scene, x, y, width, height, fillColor, fillAlpha));
            });
        /***/ },
        /* 1158 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Star = __webpack_require__(474);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Star Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Star Game Object has been built into Phaser.
 * 
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 * 
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#star
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Star} The Game Object that was created.
 */ GameObjectFactory.register("star", function(x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                return this.displayList.add(new Star(this.scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha));
            });
        /***/ },
        /* 1159 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Triangle = __webpack_require__(475);
            /**
 * Creates a new Triangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Triangle Game Object has been built into Phaser.
 * 
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#triangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Triangle} The Game Object that was created.
 */ GameObjectFactory.register("triangle", function(x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                return this.displayList.add(new Triangle(this.scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha));
            });
        /***/ },
        /* 1160 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(213);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Blitter Game Object and returns it.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#blitter
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectCreator.register("blitter", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var blitter = new Blitter(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, blitter, config);
                return blitter;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1161 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var Container = __webpack_require__(214);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Container Game Object and returns it.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#container
 * @since 3.4.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectCreator.register("container", function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, "x", 0);
                var y = GetAdvancedValue(config, "y", 0);
                var children = GetAdvancedValue(config, "children", null);
                var container = new Container(this.scene, x, y, children);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, container, config);
                return container;
            });
        /***/ },
        /* 1162 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(215);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Dynamic Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#dynamicBitmapText
 * @since 3.0.0
 *²
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectCreator.register("dynamicBitmapText", function(config, addToScene) {
                if (config === undefined) config = {};
                var font = GetAdvancedValue(config, "font", "");
                var text = GetAdvancedValue(config, "text", "");
                var size = GetAdvancedValue(config, "size", false);
                var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, bitmapText, config);
                return bitmapText;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1163 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var Graphics = __webpack_require__(216);
            /**
 * Creates a new Graphics Game Object and returns it.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#graphics
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectCreator.register("graphics", function(config, addToScene) {
                if (config === undefined) config = {};
                if (addToScene !== undefined) config.add = addToScene;
                var graphics = new Graphics(this.scene, config);
                if (config.add) this.scene.sys.displayList.add(graphics);
                return graphics;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1164 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var Group = __webpack_require__(113);
            /**
 * Creates a new Group Game Object and returns it.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#group
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectCreator.register("group", function(config) {
                return new Group(this.scene, null, config);
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1165 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Image1 = __webpack_require__(125);
            /**
 * Creates a new Image Game Object and returns it.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#image
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectCreator.register("image", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var image = new Image1(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, image, config);
                return image;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1166 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var Layer = __webpack_require__(219);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Layer Game Object and returns it.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#layer
 * @since 3.50.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectCreator.register("layer", function(config, addToScene) {
                if (config === undefined) config = {};
                var children = GetAdvancedValue(config, "children", null);
                var layer = new Layer(this.scene, children);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, layer, config);
                return layer;
            });
        /***/ },
        /* 1167 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetFastValue = __webpack_require__(2);
            var ParticleEmitterManager = __webpack_require__(220);
            /**
 * Creates a new Particle Emitter Manager Game Object and returns it.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#particles
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
 */ GameObjectCreator.register("particles", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var emitters = GetFastValue(config, "emitters", null);
                //  frame is optional and can contain the emitters array or object if skipped
                var manager = new ParticleEmitterManager(this.scene, key, frame, emitters);
                if (addToScene !== undefined) config.add = addToScene;
                var add = GetFastValue(config, "add", false);
                if (add) this.displayList.add(manager);
                else this.updateList.add(manager);
                return manager;
            });
        /***/ },
        /* 1168 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var RenderTexture = __webpack_require__(221);
            /**
 * Creates a new Render Texture Game Object and returns it.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#renderTexture
 * @since 3.2.0
 *
 * @param {Phaser.Types.GameObjects.RenderTexture.RenderTextureConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectCreator.register("renderTexture", function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, "x", 0);
                var y = GetAdvancedValue(config, "y", 0);
                var width = GetAdvancedValue(config, "width", 32);
                var height = GetAdvancedValue(config, "height", 32);
                var key = GetAdvancedValue(config, "key", undefined);
                var frame = GetAdvancedValue(config, "frame", undefined);
                var renderTexture = new RenderTexture(this.scene, x, y, width, height, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, renderTexture, config);
                return renderTexture;
            });
        /***/ },
        /* 1169 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var Rope = __webpack_require__(223);
            /**
 * Creates a new Rope Game Object and returns it.
 *
 * Note: This method will only be available if the Rope Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#rope
 * @since 3.23.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Rope} The Game Object that was created.
 */ GameObjectCreator.register("rope", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var horizontal = GetAdvancedValue(config, "horizontal", true);
                var points = GetValue(config, "points", undefined);
                var colors = GetValue(config, "colors", undefined);
                var alphas = GetValue(config, "alphas", undefined);
                var rope = new Rope(this.scene, 0, 0, key, frame, points, horizontal, colors, alphas);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, rope, config);
                if (!config.add) this.updateList.add(rope);
                return rope;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1170 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var BuildGameObjectAnimation = __webpack_require__(439);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Sprite = __webpack_require__(73);
            /**
 * Creates a new Sprite Game Object and returns it.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#sprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectCreator.register("sprite", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var sprite = new Sprite(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, sprite, config);
                //  Sprite specific config options:
                BuildGameObjectAnimation(sprite, config);
                return sprite;
            });
        /***/ },
        /* 1171 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(148);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            /**
 * Creates a new Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#bitmapText
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 * 
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectCreator.register("bitmapText", function(config, addToScene) {
                if (config === undefined) config = {};
                var font = GetValue(config, "font", "");
                var text = GetAdvancedValue(config, "text", "");
                var size = GetAdvancedValue(config, "size", false);
                var align = GetValue(config, "align", 0);
                var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size, align);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, bitmapText, config);
                return bitmapText;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1172 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Text = __webpack_require__(224);
            /**
 * Creates a new Text Game Object and returns it.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#text
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Text.TextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectCreator.register("text", function(config, addToScene) {
                if (config === undefined) config = {};
                // style Object = {
                //     font: [ 'font', '16px Courier' ],
                //     backgroundColor: [ 'backgroundColor', null ],
                //     fill: [ 'fill', '#fff' ],
                //     stroke: [ 'stroke', '#fff' ],
                //     strokeThickness: [ 'strokeThickness', 0 ],
                //     shadowOffsetX: [ 'shadow.offsetX', 0 ],
                //     shadowOffsetY: [ 'shadow.offsetY', 0 ],
                //     shadowColor: [ 'shadow.color', '#000' ],
                //     shadowBlur: [ 'shadow.blur', 0 ],
                //     shadowStroke: [ 'shadow.stroke', false ],
                //     shadowFill: [ 'shadow.fill', false ],
                //     align: [ 'align', 'left' ],
                //     maxLines: [ 'maxLines', 0 ],
                //     fixedWidth: [ 'fixedWidth', false ],
                //     fixedHeight: [ 'fixedHeight', false ],
                //     rtl: [ 'rtl', false ]
                // }
                var content = GetAdvancedValue(config, "text", "");
                var style = GetAdvancedValue(config, "style", null);
                //  Padding
                //      { padding: 2 }
                //      { padding: { x: , y: }}
                //      { padding: { left: , top: }}
                //      { padding: { left: , right: , top: , bottom: }}
                var padding = GetAdvancedValue(config, "padding", null);
                if (padding !== null) style.padding = padding;
                var text = new Text(this.scene, 0, 0, content, style);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, text, config);
                //  Text specific config options:
                text.autoRound = GetAdvancedValue(config, "autoRound", true);
                text.resolution = GetAdvancedValue(config, "resolution", 1);
                return text;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1173 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var TileSprite = __webpack_require__(225);
            /**
 * Creates a new TileSprite Game Object and returns it.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tileSprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.TileSprite.TileSpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectCreator.register("tileSprite", function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, "x", 0);
                var y = GetAdvancedValue(config, "y", 0);
                var width = GetAdvancedValue(config, "width", 512);
                var height = GetAdvancedValue(config, "height", 512);
                var key = GetAdvancedValue(config, "key", "");
                var frame = GetAdvancedValue(config, "frame", "");
                var tile = new TileSprite(this.scene, x, y, width, height, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, tile, config);
                return tile;
            });
        /***/ },
        /* 1174 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Zone = __webpack_require__(129);
            /**
 * Creates a new Zone Game Object and returns it.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#zone
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectCreator.register("zone", function(config) {
                var x = GetAdvancedValue(config, "x", 0);
                var y = GetAdvancedValue(config, "y", 0);
                var width = GetAdvancedValue(config, "width", 1);
                var height = GetAdvancedValue(config, "height", width);
                return new Zone(this.scene, x, y, width, height);
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1175 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Video = __webpack_require__(226);
            /**
 * Creates a new Video Game Object and returns it.
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#video
 * @since 3.20.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectCreator.register("video", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var video = new Video(this.scene, 0, 0, key);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, video, config);
                if (!config.add) this.updateList.add(video);
                return video;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1176 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1177);
            renderCanvas = __webpack_require__(1178);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1177 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Shader#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ShaderWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (!src.shader) return;
                camera.addToRenderList(src);
                renderer.pipelines.clear();
                if (src.renderToTexture) {
                    src.load();
                    src.flush();
                } else {
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    //  Renderer size changed?
                    if (renderer.width !== src._rendererWidth || renderer.height !== src._rendererHeight) src.projOrtho(0, renderer.width, renderer.height, 0);
                    src.load(calcMatrix.matrix);
                    src.flush();
                }
                renderer.pipelines.rebind();
            };
            module1.exports = ShaderWebGLRenderer;
        /***/ },
        /* 1178 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Shader.Render. There is no Canvas renderer for Shader objects.
 *
 * @method Phaser.GameObjects.Shader#renderCanvas
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var ShaderCanvasRenderer = function() {};
            module1.exports = ShaderCanvasRenderer;
        /***/ },
        /* 1179 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1180);
            renderCanvas = __webpack_require__(1181);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1180 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Mesh#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var MeshWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var faces = src.faces;
                var totalFaces = faces.length;
                if (totalFaces === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var textureUnit = pipeline.setGameObject(src);
                var F32 = pipeline.vertexViewF32;
                var U32 = pipeline.vertexViewU32;
                var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                var tintEffect = src.tintFill;
                var debugFaces = [];
                var debugCallback = src.debugCallback;
                var a = calcMatrix.a;
                var b = calcMatrix.b;
                var c = calcMatrix.c;
                var d = calcMatrix.d;
                var e = calcMatrix.e;
                var f = calcMatrix.f;
                var z = src.viewPosition.z;
                var hideCCW = src.hideCCW;
                var roundPixels = camera.roundPixels;
                var alpha = camera.alpha * src.alpha;
                var totalFacesRendered = 0;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < totalFaces; i++){
                    var face = faces[i];
                    //  If face has alpha <= 0, or hideCCW + clockwise, or isn't in camera view, then don't draw it
                    if (!face.isInView(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels)) continue;
                    if (pipeline.shouldFlush(3)) {
                        pipeline.flush();
                        vertexOffset = 0;
                    }
                    vertexOffset = face.load(F32, U32, vertexOffset, textureUnit, tintEffect);
                    totalFacesRendered++;
                    pipeline.vertexCount += 3;
                    if (debugCallback) debugFaces.push(face);
                }
                src.totalFrame += totalFacesRendered;
                if (debugCallback) debugCallback.call(src, src, debugFaces);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = MeshWebGLRenderer;
        /***/ },
        /* 1181 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Mesh.Render. There is no Canvas renderer for Mesh objects.
 *
 * @method Phaser.GameObjects.Mesh#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var MeshCanvasRenderer = function() {};
            module1.exports = MeshCanvasRenderer;
        /***/ },
        /* 1182 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1183);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1183 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.PointLight#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.PointLight} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PointLightWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var width = src.width;
                var height = src.height;
                var x = -src._radius;
                var y = -src._radius;
                var xw = x + width;
                var yh = y + height;
                var lightX = calcMatrix.getX(0, 0);
                var lightY = calcMatrix.getY(0, 0);
                var tx0 = calcMatrix.getX(x, y);
                var ty0 = calcMatrix.getY(x, y);
                var tx1 = calcMatrix.getX(x, yh);
                var ty1 = calcMatrix.getY(x, yh);
                var tx2 = calcMatrix.getX(xw, yh);
                var ty2 = calcMatrix.getY(xw, yh);
                var tx3 = calcMatrix.getX(xw, y);
                var ty3 = calcMatrix.getY(xw, y);
                renderer.pipelines.preBatch(src);
                pipeline.batchPointLight(src, camera, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, lightX, lightY);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = PointLightWebGLRenderer;
        /***/ },
        /* 1184 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Shader = __webpack_require__(229);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register("shader", function(key, x, y, width, height, textures, textureData) {
                return this.displayList.add(new Shader(this.scene, key, x, y, width, height, textures, textureData));
            });
        /***/ },
        /* 1185 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Mesh = __webpack_require__(230);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register("mesh", function(x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                return this.displayList.add(new Mesh(this.scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas));
            });
        /***/ },
        /* 1186 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var PointLight = __webpack_require__(150);
            /**
 * Creates a new Point Light Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the dislay list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @method Phaser.GameObjects.GameObjectFactory#pointlight
 * @since 3.50.0
 *
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or colr blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectFactory.register("pointlight", function(x, y, color, radius, intensity, attenuation) {
                return this.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity, attenuation));
            });
        /***/ },
        /* 1187 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Shader = __webpack_require__(229);
            /**
 * Creates a new Shader Game Object and returns it.
 *
 * Note: This method will only be available if the Shader Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#shader
 * @since 3.17.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Shader} The Game Object that was created.
 */ GameObjectCreator.register("shader", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var x = GetAdvancedValue(config, "x", 0);
                var y = GetAdvancedValue(config, "y", 0);
                var width = GetAdvancedValue(config, "width", 128);
                var height = GetAdvancedValue(config, "height", 128);
                var shader = new Shader(this.scene, key, x, y, width, height);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, shader, config);
                return shader;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1188 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var Mesh = __webpack_require__(230);
            /**
 * Creates a new Mesh Game Object and returns it.
 *
 * Note: This method will only be available if the Mesh Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#mesh
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Mesh} The Game Object that was created.
 */ GameObjectCreator.register("mesh", function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, "key", null);
                var frame = GetAdvancedValue(config, "frame", null);
                var vertices = GetValue(config, "vertices", []);
                var uvs = GetValue(config, "uvs", []);
                var indicies = GetValue(config, "indicies", []);
                var containsZ = GetValue(config, "containsZ", false);
                var normals = GetValue(config, "normals", []);
                var colors = GetValue(config, "colors", 0xffffff);
                var alphas = GetValue(config, "alphas", 1);
                var mesh = new Mesh(this.scene, 0, 0, key, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, mesh, config);
                return mesh;
            });
        /***/ },
        /* 1189 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var PointLight = __webpack_require__(150);
            /**
 * Creates a new Point Light Game Object and returns it.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#pointlight
 * @since 3.50.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectCreator.register("pointlight", function(config, addToScene) {
                if (config === undefined) config = {};
                var color = GetAdvancedValue(config, "color", 0xffffff);
                var radius = GetAdvancedValue(config, "radius", 128);
                var intensity = GetAdvancedValue(config, "intensity", 1);
                var attenuation = GetAdvancedValue(config, "attenuation", 0.1);
                var layer = new PointLight(this.scene, 0, 0, color, radius, intensity, attenuation);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, layer, config);
                return layer;
            });
        /***/ },
        /* 1190 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var LightsManager = __webpack_require__(482);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * A Scene plugin that provides a {@link Phaser.GameObjects.LightsManager} for the Light2D pipeline.
 *
 * Available from within a Scene via `this.lights`.
 *
 * Add Lights using the {@link Phaser.GameObjects.LightsManager#addLight} method:
 *
 * ```javascript
 * // Enable the Lights Manager because it is disabled by default
 * this.lights.enable();
 *
 * // Create a Light at [400, 300] with a radius of 200
 * this.lights.addLight(400, 300, 200);
 * ```
 *
 * For Game Objects to be affected by the Lights when rendered, you will need to set them to use the `Light2D` pipeline like so:
 *
 * ```javascript
 * sprite.setPipeline('Light2D');
 * ```
 *
 * Note that you cannot use this pipeline on Graphics Game Objects or Shape Game Objects.
 *
 * @class LightsPlugin
 * @extends Phaser.GameObjects.LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Lights Plugin belongs to.
 */ var LightsPlugin = new Class({
                Extends: LightsManager,
                initialize: function LightsPlugin(scene) {
                    /**
         * A reference to the Scene that this Lights Plugin belongs to.
         *
         * @name Phaser.GameObjects.LightsPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene's systems.
         *
         * @name Phaser.GameObjects.LightsPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    if (!scene.sys.settings.isBooted) scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    LightsManager.call(this);
                },
                /**
     * Boot the Lights Plugin.
     *
     * @method Phaser.GameObjects.LightsPlugin#boot
     * @since 3.0.0
     */ boot: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.SHUTDOWN, this.shutdown, this);
                    eventEmitter.on(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * Destroy the Lights Plugin.
     *
     * Cleans up all references.
     *
     * @method Phaser.GameObjects.LightsPlugin#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene = undefined;
                    this.systems = undefined;
                }
            });
            PluginCache.register("LightsPlugin", LightsPlugin, "lights");
            module1.exports = LightsPlugin;
        /***/ },
        /* 1191 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(65);
            Circle.Area = __webpack_require__(1192);
            Circle.Circumference = __webpack_require__(302);
            Circle.CircumferencePoint = __webpack_require__(169);
            Circle.Clone = __webpack_require__(1193);
            Circle.Contains = __webpack_require__(66);
            Circle.ContainsPoint = __webpack_require__(1194);
            Circle.ContainsRect = __webpack_require__(1195);
            Circle.CopyFrom = __webpack_require__(1196);
            Circle.Equals = __webpack_require__(1197);
            Circle.GetBounds = __webpack_require__(1198);
            Circle.GetPoint = __webpack_require__(300);
            Circle.GetPoints = __webpack_require__(301);
            Circle.Offset = __webpack_require__(1199);
            Circle.OffsetPoint = __webpack_require__(1200);
            Circle.Random = __webpack_require__(170);
            module1.exports = Circle;
        /***/ },
        /* 1192 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the circle.
 *
 * @function Phaser.Geom.Circle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the area of.
 *
 * @return {number} The area of the Circle.
 */ var Area = function(circle) {
                return circle.radius > 0 ? Math.PI * circle.radius * circle.radius : 0;
            };
            module1.exports = Area;
        /***/ },
        /* 1193 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(65);
            /**
 * Creates a new Circle instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Circle.Clone
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|object)} source - The Circle to be cloned. Can be an instance of a Circle or a circle-like object, with x, y and radius properties.
 *
 * @return {Phaser.Geom.Circle} A clone of the source Circle.
 */ var Clone = function(source) {
                return new Circle(source.x, source.y, source.radius);
            };
            module1.exports = Clone;
        /***/ },
        /* 1194 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(66);
            /**
 * Check to see if the Circle contains the given Point object.
 *
 * @function Phaser.Geom.Circle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(circle, point) {
                return Contains(circle, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1195 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(66);
            /**
 * Check to see if the Circle contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Circle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Circle or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the circle, otherwise false.
 */ var ContainsRect = function(circle, rect) {
                return Contains(circle, rect.x, rect.y) && Contains(circle, rect.right, rect.y) && Contains(circle, rect.x, rect.bottom) && Contains(circle, rect.right, rect.bottom);
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 1196 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y` and `radius` properties from the `source` Circle
 * into the given `dest` Circle, then returns the `dest` Circle.
 *
 * @function Phaser.Geom.Circle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Circle} source - The source Circle to copy the values from.
 * @param {Phaser.Geom.Circle} dest - The destination Circle to copy the values to.
 *
 * @return {Phaser.Geom.Circle} The destination Circle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.radius);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1197 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y` and `radius` properties of the two given Circles.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Circle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The first Circle to compare.
 * @param {Phaser.Geom.Circle} toCompare - The second Circle to compare.
 *
 * @return {boolean} `true` if the two Circles equal each other, otherwise `false`.
 */ var Equals = function(circle, toCompare) {
                return circle.x === toCompare.x && circle.y === toCompare.y && circle.radius === toCompare.radius;
            };
            module1.exports = Equals;
        /***/ },
        /* 1198 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Returns the bounds of the Circle object.
 *
 * @function Phaser.Geom.Circle.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the circle bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Circles bounds.
 */ var GetBounds = function(circle, out) {
                if (out === undefined) out = new Rectangle();
                out.x = circle.left;
                out.y = circle.top;
                out.width = circle.diameter;
                out.height = circle.diameter;
                return out;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 1199 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given.
 *
 * @function Phaser.Geom.Circle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Circle by.
 * @param {number} y - The amount to vertically offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var Offset = function(circle, x, y) {
                circle.x += x;
                circle.y += y;
                return circle;
            };
            module1.exports = Offset;
        /***/ },
        /* 1200 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Circle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var OffsetPoint = function(circle, point) {
                circle.x += point.x;
                circle.y += point.y;
                return circle;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1201 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(111);
            Ellipse.Area = __webpack_require__(1202);
            Ellipse.Circumference = __webpack_require__(447);
            Ellipse.CircumferencePoint = __webpack_require__(218);
            Ellipse.Clone = __webpack_require__(1203);
            Ellipse.Contains = __webpack_require__(112);
            Ellipse.ContainsPoint = __webpack_require__(1204);
            Ellipse.ContainsRect = __webpack_require__(1205);
            Ellipse.CopyFrom = __webpack_require__(1206);
            Ellipse.Equals = __webpack_require__(1207);
            Ellipse.GetBounds = __webpack_require__(1208);
            Ellipse.GetPoint = __webpack_require__(445);
            Ellipse.GetPoints = __webpack_require__(446);
            Ellipse.Offset = __webpack_require__(1209);
            Ellipse.OffsetPoint = __webpack_require__(1210);
            Ellipse.Random = __webpack_require__(180);
            module1.exports = Ellipse;
        /***/ },
        /* 1202 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the area of.
 *
 * @return {number} The area of the Ellipse.
 */ var Area = function(ellipse) {
                if (ellipse.isEmpty()) return 0;
                //  units squared
                return ellipse.getMajorRadius() * ellipse.getMinorRadius() * Math.PI;
            };
            module1.exports = Area;
        /***/ },
        /* 1203 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(111);
            /**
 * Creates a new Ellipse instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Ellipse.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} source - The Ellipse to be cloned. Can be an instance of an Ellipse or a ellipse-like object, with x, y, width and height properties.
 *
 * @return {Phaser.Geom.Ellipse} A clone of the source Ellipse.
 */ var Clone = function(source) {
                return new Ellipse(source.x, source.y, source.width, source.height);
            };
            module1.exports = Clone;
        /***/ },
        /* 1204 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(112);
            /**
 * Check to see if the Ellipse contains the given Point object.
 *
 * @function Phaser.Geom.Ellipse.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(ellipse, point) {
                return Contains(ellipse, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1205 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(112);
            /**
 * Check to see if the Ellipse contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Ellipse.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Ellipse or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the ellipse, otherwise false.
 */ var ContainsRect = function(ellipse, rect) {
                return Contains(ellipse, rect.x, rect.y) && Contains(ellipse, rect.right, rect.y) && Contains(ellipse, rect.x, rect.bottom) && Contains(ellipse, rect.right, rect.bottom);
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 1206 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y`, `width` and `height` properties from the `source` Ellipse
 * into the given `dest` Ellipse, then returns the `dest` Ellipse.
 *
 * @function Phaser.Geom.Ellipse.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [dest,$return]
 *
 * @param {Phaser.Geom.Ellipse} source - The source Ellipse to copy the values from.
 * @param {Phaser.Geom.Ellipse} dest - The destination Ellipse to copy the values to.
 *
 * @return {Phaser.Geom.Ellipse} The destination Ellipse.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.width, source.height);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1207 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of the two given Ellipses.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Ellipse.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The first Ellipse to compare.
 * @param {Phaser.Geom.Ellipse} toCompare - The second Ellipse to compare.
 *
 * @return {boolean} `true` if the two Ellipse equal each other, otherwise `false`.
 */ var Equals = function(ellipse, toCompare) {
                return ellipse.x === toCompare.x && ellipse.y === toCompare.y && ellipse.width === toCompare.width && ellipse.height === toCompare.height;
            };
            module1.exports = Equals;
        /***/ },
        /* 1208 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Returns the bounds of the Ellipse object.
 *
 * @function Phaser.Geom.Ellipse.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the ellipse bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Ellipse bounds.
 */ var GetBounds = function(ellipse, out) {
                if (out === undefined) out = new Rectangle();
                out.x = ellipse.left;
                out.y = ellipse.top;
                out.width = ellipse.width;
                out.height = ellipse.height;
                return out;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 1209 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given.
 *
 * @function Phaser.Geom.Ellipse.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Ellipse by.
 * @param {number} y - The amount to vertically offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var Offset = function(ellipse, x, y) {
                ellipse.x += x;
                ellipse.y += y;
                return ellipse;
            };
            module1.exports = Offset;
        /***/ },
        /* 1210 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Ellipse.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var OffsetPoint = function(ellipse, point) {
                ellipse.x += point.x;
                ellipse.y += point.y;
                return ellipse;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1211 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var CircleToCircle = __webpack_require__(231);
            /**
 * Checks if two Circles intersect and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToCircle = function(circleA, circleB, out) {
                if (out === undefined) out = [];
                if (CircleToCircle(circleA, circleB)) {
                    var x0 = circleA.x;
                    var y0 = circleA.y;
                    var r0 = circleA.radius;
                    var x1 = circleB.x;
                    var y1 = circleB.y;
                    var r1 = circleB.radius;
                    var coefficientA, coefficientB, coefficientC, lambda, x;
                    if (y0 === y1) {
                        x = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0) / (2 * (x0 - x1));
                        coefficientA = 1;
                        coefficientB = -2 * y1;
                        coefficientC = x1 * x1 + x * x - 2 * x1 * x + y1 * y1 - r1 * r1;
                        lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                        if (lambda === 0) out.push(new Point(x, -coefficientB / (2 * coefficientA)));
                        else if (lambda > 0) {
                            out.push(new Point(x, (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA)));
                            out.push(new Point(x, (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA)));
                        }
                    } else {
                        var v1 = (x0 - x1) / (y0 - y1);
                        var n = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0 - y1 * y1 + y0 * y0) / (2 * (y0 - y1));
                        coefficientA = v1 * v1 + 1;
                        coefficientB = 2 * y0 * v1 - 2 * n * v1 - 2 * x0;
                        coefficientC = x0 * x0 + y0 * y0 + n * n - r0 * r0 - 2 * y0 * n;
                        lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                        if (lambda === 0) {
                            x = -coefficientB / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                        } else if (lambda > 0) {
                            x = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                            x = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                        }
                    }
                }
                return out;
            };
            module1.exports = GetCircleToCircle;
        /***/ },
        /* 1212 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(232);
            var CircleToRectangle = __webpack_require__(151);
            /**
 * Checks for intersection between a circle and a rectangle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToRectangle = function(circle, rect, out) {
                if (out === undefined) out = [];
                if (CircleToRectangle(circle, rect)) {
                    var lineA = rect.getLineA();
                    var lineB = rect.getLineB();
                    var lineC = rect.getLineC();
                    var lineD = rect.getLineD();
                    GetLineToCircle(lineA, circle, out);
                    GetLineToCircle(lineB, circle, out);
                    GetLineToCircle(lineC, circle, out);
                    GetLineToCircle(lineD, circle, out);
                }
                return out;
            };
            module1.exports = GetCircleToRectangle;
        /***/ },
        /* 1213 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector4 = __webpack_require__(140);
            var GetLineToPolygon = __webpack_require__(487);
            var Line = __webpack_require__(47);
            //  Temp calculation segment
            var segment = new Line();
            /**
 * @ignore
 */ function CheckIntersects(angle, x, y, polygons, intersects) {
                var dx = Math.cos(angle);
                var dy = Math.sin(angle);
                segment.setTo(x, y, x + dx, y + dy);
                var closestIntersect = GetLineToPolygon(segment, polygons);
                if (closestIntersect) intersects.push(new Vector4(closestIntersect.x, closestIntersect.y, angle, closestIntersect.w));
            }
            /**
 * @ignore
 */ function SortIntersects(a, b) {
                return a.z - b.z;
            }
            /**
 * Projects rays out from the given point to each line segment of the polygons.
 *
 * If the rays intersect with the polygons, the points of intersection are returned in an array.
 *
 * If no intersections are found, the returned array will be empty.
 *
 * Each Vector4 intersection result has the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the angle of intersection.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetRaysFromPointToPolygon
 * @since 3.50.0
 *
 * @param {number} x - The x coordinate to project the rays from.
 * @param {number} y - The y coordinate to project the rays from.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check against the rays.
 *
 * @return {Phaser.Math.Vector4[]} An array containing all intersections in Vector4s.
 */ var GetRaysFromPointToPolygon = function(x, y, polygons) {
                if (!Array.isArray(polygons)) polygons = [
                    polygons
                ];
                var intersects = [];
                var angles = [];
                for(var i = 0; i < polygons.length; i++){
                    var points = polygons[i].points;
                    for(var p = 0; p < points.length; p++){
                        var angle = Math.atan2(points[p].y - y, points[p].x - x);
                        if (angles.indexOf(angle) === -1) {
                            //  +- 0.00001 rads to catch lines behind segment corners
                            CheckIntersects(angle, x, y, polygons, intersects);
                            CheckIntersects(angle - 0.00001, x, y, polygons, intersects);
                            CheckIntersects(angle + 0.00001, x, y, polygons, intersects);
                            angles.push(angle);
                        }
                    }
                }
                return intersects.sort(SortIntersects);
            };
            module1.exports = GetRaysFromPointToPolygon;
        /***/ },
        /* 1214 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var RectangleToRectangle = __webpack_require__(152);
            /**
 * Checks if two Rectangle shapes intersect and returns the area of this intersection as Rectangle object.
 * 
 * If optional `output` parameter is omitted, new Rectangle object is created and returned. If there is intersection, it will contain intersection area. If there is no intersection, it wil be empty Rectangle (all values set to zero).
 * 
 * If Rectangle object is passed as `output` and there is intersection, then intersection area data will be loaded into it and it will be returned. If there is no intersection, it will be returned without any change.
 *
 * @function Phaser.Geom.Intersects.GetRectangleIntersection
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [output,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle object.
 * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object. If given, the intersection data will be loaded into it (in case of no intersection, it will be left unchanged). Otherwise, new Rectangle object will be created and returned with either intersection data or empty (all values set to zero), if there is no intersection.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle object with intersection data.
 */ var GetRectangleIntersection = function(rectA, rectB, output) {
                if (output === undefined) output = new Rectangle();
                if (RectangleToRectangle(rectA, rectB)) {
                    output.x = Math.max(rectA.x, rectB.x);
                    output.y = Math.max(rectA.y, rectB.y);
                    output.width = Math.min(rectA.right, rectB.right) - output.x;
                    output.height = Math.min(rectA.bottom, rectB.bottom) - output.y;
                }
                return output;
            };
            module1.exports = GetRectangleIntersection;
        /***/ },
        /* 1215 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToRectangle = __webpack_require__(234);
            var RectangleToRectangle = __webpack_require__(152);
            /**
 * Checks if two Rectangles intersect and returns the intersection points as a Point object array.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds. As such, the two Rectangles are considered "solid". A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToRectangle = function(rectA, rectB, out) {
                if (out === undefined) out = [];
                if (RectangleToRectangle(rectA, rectB)) {
                    var lineA = rectA.getLineA();
                    var lineB = rectA.getLineB();
                    var lineC = rectA.getLineC();
                    var lineD = rectA.getLineD();
                    GetLineToRectangle(lineA, rectB, out);
                    GetLineToRectangle(lineB, rectB, out);
                    GetLineToRectangle(lineC, rectB, out);
                    GetLineToRectangle(lineD, rectB, out);
                }
                return out;
            };
            module1.exports = GetRectangleToRectangle;
        /***/ },
        /* 1216 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RectangleToTriangle = __webpack_require__(489);
            var GetLineToRectangle = __webpack_require__(234);
            /**
 * Checks for intersection between Rectangle shape and Triangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToTriangle = function(rect, triangle, out) {
                if (out === undefined) out = [];
                if (RectangleToTriangle(rect, triangle)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    GetLineToRectangle(lineA, rect, out);
                    GetLineToRectangle(lineB, rect, out);
                    GetLineToRectangle(lineC, rect, out);
                }
                return out;
            };
            module1.exports = GetRectangleToTriangle;
        /***/ },
        /* 1217 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(232);
            var TriangleToCircle = __webpack_require__(491);
            /**
 * Checks if a Triangle and a Circle intersect, and returns the intersection points as a Point object array.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.GetTriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToCircle = function(triangle, circle, out) {
                if (out === undefined) out = [];
                if (TriangleToCircle(triangle, circle)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    GetLineToCircle(lineA, circle, out);
                    GetLineToCircle(lineB, circle, out);
                    GetLineToCircle(lineC, circle, out);
                }
                return out;
            };
            module1.exports = GetTriangleToCircle;
        /***/ },
        /* 1218 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TriangleToTriangle = __webpack_require__(494);
            var GetTriangleToLine = __webpack_require__(492);
            /**
 * Checks if two Triangles intersect, and returns the intersection points as a Point object array.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToTriangle = function(triangleA, triangleB, out) {
                if (out === undefined) out = [];
                if (TriangleToTriangle(triangleA, triangleB)) {
                    var lineA = triangleB.getLineA();
                    var lineB = triangleB.getLineB();
                    var lineC = triangleB.getLineC();
                    GetTriangleToLine(triangleA, lineA, out);
                    GetTriangleToLine(triangleA, lineB, out);
                    GetTriangleToLine(triangleA, lineC, out);
                }
                return out;
            };
            module1.exports = GetTriangleToTriangle;
        /***/ },
        /* 1219 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PointToLine = __webpack_require__(496);
            /**
 * Checks if a Point is located on the given line segment.
 *
 * @function Phaser.Geom.Intersects.PointToLineSegment
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The Point to check for intersection.
 * @param {Phaser.Geom.Line} line - The line segment to check for intersection.
 *
 * @return {boolean} `true` if the Point is on the given line segment, otherwise `false`.
 */ var PointToLineSegment = function(point, line) {
                if (!PointToLine(point, line)) return false;
                var xMin = Math.min(line.x1, line.x2);
                var xMax = Math.max(line.x1, line.x2);
                var yMin = Math.min(line.y1, line.y2);
                var yMax = Math.max(line.y1, line.y2);
                return point.x >= xMin && point.x <= xMax && point.y >= yMin && point.y <= yMax;
            };
            module1.exports = PointToLineSegment;
        /***/ },
        /* 1220 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if rectangle intersects with values.
 *
 * @function Phaser.Geom.Intersects.RectangleToValues
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle object
 * @param {number} left - The x coordinate of the left of the Rectangle.
 * @param {number} right - The x coordinate of the right of the Rectangle.
 * @param {number} top - The y coordinate of the top of the Rectangle.
 * @param {number} bottom - The y coordinate of the bottom of the Rectangle.
 * @param {number} [tolerance=0] - Tolerance allowed in the calculation, expressed in pixels.
 *
 * @return {boolean} Returns true if there is an intersection.
 */ var RectangleToValues = function(rect, left, right, top, bottom, tolerance) {
                if (tolerance === undefined) tolerance = 0;
                return !(left > rect.right + tolerance || right < rect.left - tolerance || top > rect.bottom + tolerance || bottom < rect.top - tolerance);
            };
            module1.exports = RectangleToValues;
        /***/ },
        /* 1221 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(47);
            Line.Angle = __webpack_require__(97);
            Line.BresenhamPoints = __webpack_require__(317);
            Line.CenterOn = __webpack_require__(1222);
            Line.Clone = __webpack_require__(1223);
            Line.CopyFrom = __webpack_require__(1224);
            Line.Equals = __webpack_require__(1225);
            Line.Extend = __webpack_require__(1226);
            Line.GetEasedPoints = __webpack_require__(1227);
            Line.GetMidPoint = __webpack_require__(1228);
            Line.GetNearestPoint = __webpack_require__(1229);
            Line.GetNormal = __webpack_require__(1230);
            Line.GetPoint = __webpack_require__(307);
            Line.GetPoints = __webpack_require__(172);
            Line.GetShortestDistance = __webpack_require__(1231);
            Line.Height = __webpack_require__(1232);
            Line.Length = __webpack_require__(67);
            Line.NormalAngle = __webpack_require__(497);
            Line.NormalX = __webpack_require__(1233);
            Line.NormalY = __webpack_require__(1234);
            Line.Offset = __webpack_require__(1235);
            Line.PerpSlope = __webpack_require__(1236);
            Line.Random = __webpack_require__(173);
            Line.ReflectAngle = __webpack_require__(1237);
            Line.Rotate = __webpack_require__(1238);
            Line.RotateAroundPoint = __webpack_require__(1239);
            Line.RotateAroundXY = __webpack_require__(236);
            Line.SetToAngle = __webpack_require__(1240);
            Line.Slope = __webpack_require__(1241);
            Line.Width = __webpack_require__(1242);
            module1.exports = Line;
        /***/ },
        /* 1222 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Center a line on the given coordinates.
 *
 * @function Phaser.Geom.Line.CenterOn
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to center.
 * @param {number} x - The horizontal coordinate to center the line on.
 * @param {number} y - The vertical coordinate to center the line on.
 *
 * @return {Phaser.Geom.Line} The centered line.
 */ var CenterOn = function(line, x, y) {
                var tx = x - (line.x1 + line.x2) / 2;
                var ty = y - (line.y1 + line.y2) / 2;
                line.x1 += tx;
                line.y1 += ty;
                line.x2 += tx;
                line.y2 += ty;
                return line;
            };
            module1.exports = CenterOn;
        /***/ },
        /* 1223 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(47);
            /**
 * Clone the given line.
 *
 * @function Phaser.Geom.Line.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} source - The source line to clone.
 *
 * @return {Phaser.Geom.Line} The cloned line.
 */ var Clone = function(source) {
                return new Line(source.x1, source.y1, source.x2, source.y2);
            };
            module1.exports = Clone;
        /***/ },
        /* 1224 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one line to a destination line.
 *
 * @function Phaser.Geom.Line.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [dest,$return]
 *
 * @param {Phaser.Geom.Line} source - The source line to copy the values from.
 * @param {Phaser.Geom.Line} dest - The destination line to copy the values to.
 *
 * @return {Phaser.Geom.Line} The destination line.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x1, source.y1, source.x2, source.y2);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1225 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compare two lines for strict equality.
 *
 * @function Phaser.Geom.Line.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The first line to compare.
 * @param {Phaser.Geom.Line} toCompare - The second line to compare.
 *
 * @return {boolean} Whether the two lines are equal.
 */ var Equals = function(line, toCompare) {
                return line.x1 === toCompare.x1 && line.y1 === toCompare.y1 && line.x2 === toCompare.x2 && line.y2 === toCompare.y2;
            };
            module1.exports = Equals;
        /***/ },
        /* 1226 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            /**
 * Extends the start and end points of a Line by the given amounts.
 *
 * The amounts can be positive or negative. Positive points will increase the length of the line,
 * while negative ones will decrease it.
 *
 * If no `right` value is provided it will extend the length of the line equally in both directions.
 *
 * Pass a value of zero to leave the start or end point unchanged.
 *
 * @function Phaser.Geom.Line.Extend
 * @since 3.16.0
 *
 * @param {Phaser.Geom.Line} line - The line instance to extend.
 * @param {number} left - The amount to extend the start of the line by.
 * @param {number} [right] - The amount to extend the end of the line by. If not given it will be set to the `left` value.
 *
 * @return {Phaser.Geom.Line} The modified Line instance.
 */ var Extend = function(line, left, right) {
                if (right === undefined) right = left;
                var length = Length(line);
                var slopX = line.x2 - line.x1;
                var slopY = line.y2 - line.y1;
                if (left) {
                    line.x1 = line.x1 - slopX / length * left;
                    line.y1 = line.y1 - slopY / length * left;
                }
                if (right) {
                    line.x2 = line.x2 + slopX / length * right;
                    line.y2 = line.y2 + slopY / length * right;
                }
                return line;
            };
            module1.exports = Extend;
        /***/ },
        /* 1227 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetweenPoints = __webpack_require__(352);
            var GetEaseFunction = __webpack_require__(80);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of `quantity` Points where each point is taken from the given Line,
 * spaced out according to the ease function specified.
 * 
 * ```javascript
 * const line = new Phaser.Geom.Line(100, 300, 700, 300);
 * const points = Phaser.Geom.Line.GetEasedPoints(line, 'sine.out', 32)
 * ```
 * 
 * In the above example, the `points` array will contain 32 points spread-out across
 * the length of `line`, where the position of each point is determined by the `Sine.out`
 * ease function.
 * 
 * You can optionally provide a collinear threshold. In this case, the resulting points
 * are checked against each other, and if they are `< collinearThreshold` distance apart,
 * they are dropped from the results. This can help avoid lots of clustered points at
 * far ends of the line with tightly-packed eases such as Quartic. Leave the value set
 * to zero to skip this check.
 * 
 * Note that if you provide a collinear threshold, the resulting array may not always
 * contain `quantity` points.
 *
 * @function Phaser.Geom.Line.GetEasedPoints
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line object.
 * @param {(string|function)} ease - The ease to use. This can be either a string from the EaseMap, or a custom function.
 * @param {number} quantity - The number of points to return. Note that if you provide a `collinearThreshold`, the resulting array may not always contain this number of points.
 * @param {number} [collinearThreshold=0] - An optional threshold. The final array is reduced so that each point is spaced out at least this distance apart. This helps reduce clustering in noisey eases.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {Phaser.Geom.Point[]} An array of Geom.Points containing the coordinates of the points on the line.
 */ var GetEasedPoints = function(line, ease, quantity, collinearThreshold, easeParams) {
                if (collinearThreshold === undefined) collinearThreshold = 0;
                if (easeParams === undefined) easeParams = [];
                var results = [];
                var x1 = line.x1;
                var y1 = line.y1;
                var spaceX = line.x2 - x1;
                var spaceY = line.y2 - y1;
                var easeFunc = GetEaseFunction(ease, easeParams);
                var i;
                var v;
                var q = quantity - 1;
                for(i = 0; i < q; i++){
                    v = easeFunc(i / q);
                    results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                }
                //  Always include the end of the line
                v = easeFunc(1);
                results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                //  Remove collinear parts
                if (collinearThreshold > 0) {
                    var prevPoint = results[0];
                    //  Store the new results here
                    var sortedResults = [
                        prevPoint
                    ];
                    for(i = 1; i < results.length - 1; i++){
                        var point = results[i];
                        if (DistanceBetweenPoints(prevPoint, point) >= collinearThreshold) {
                            sortedResults.push(point);
                            prevPoint = point;
                        }
                    }
                    //  Top and tail
                    var endPoint = results[results.length - 1];
                    if (DistanceBetweenPoints(prevPoint, endPoint) < collinearThreshold) sortedResults.pop();
                    sortedResults.push(endPoint);
                    return sortedResults;
                } else return results;
            };
            module1.exports = GetEasedPoints;
        /***/ },
        /* 1228 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the midpoint of the given line.
 *
 * @function Phaser.Geom.Line.GetMidPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the midpoint of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the midpoint in.
 *
 * @return {(Phaser.Geom.Point|object)} The midpoint of the Line.
 */ var GetMidPoint = function(line, out) {
                if (out === undefined) out = new Point();
                out.x = (line.x1 + line.x2) / 2;
                out.y = (line.y1 + line.y2) / 2;
                return out;
            };
            module1.exports = GetMidPoint;
        /***/ },
        /* 1229 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the nearest point on a line perpendicular to the given point.
 *
 * @function Phaser.Geom.Line.GetNearestPoint
 * @since 3.16.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the nearest point on.
 * @param {(Phaser.Geom.Point|object)} point - The point to get the nearest point to.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the nearest point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The nearest point on the line.
 */ var GetNearestPoint = function(line, point, out) {
                if (out === undefined) out = new Point();
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return out;
                var r = ((point.x - x1) * (x2 - x1) + (point.y - y1) * (y2 - y1)) / L2;
                out.x = x1 + r * (x2 - x1);
                out.y = y1 + r * (y2 - y1);
                return out;
            };
            module1.exports = GetNearestPoint;
        /***/ },
        /* 1230 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(97);
            var Point = __webpack_require__(4);
            /**
 * Calculate the normal of the given line.
 *
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.GetNormal
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the normal in.
 *
 * @return {(Phaser.Geom.Point|object)} The normal of the Line.
 */ var GetNormal = function(line, out) {
                if (out === undefined) out = new Point();
                var a = Angle(line) - MATH_CONST.TAU;
                out.x = Math.cos(a);
                out.y = Math.sin(a);
                return out;
            };
            module1.exports = GetNormal;
        /***/ },
        /* 1231 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Get the shortest distance from a Line to the given Point.
 *
 * @function Phaser.Geom.Line.GetShortestDistance
 * @since 3.16.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the distance from.
 * @param {(Phaser.Geom.Point|object)} point - The point to get the shortest distance to.
 *
 * @return {number} The shortest distance from the line to the point.
 */ var GetShortestDistance = function(line, point) {
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return false;
                var s = ((y1 - point.y) * (x2 - x1) - (x1 - point.x) * (y2 - y1)) / L2;
                return Math.abs(s) * Math.sqrt(L2);
            };
            module1.exports = GetShortestDistance;
        /***/ },
        /* 1232 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the height of the given line.
 *
 * @function Phaser.Geom.Line.Height
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the height of.
 *
 * @return {number} The height of the line.
 */ var Height = function(line) {
                return Math.abs(line.y1 - line.y2);
            };
            module1.exports = Height;
        /***/ },
        /* 1233 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(97);
            /**
 * Returns the x component of the normal vector of the given line.
 *
 * @function Phaser.Geom.Line.NormalX
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line object to get the normal value from.
 *
 * @return {number} The x component of the normal vector of the line.
 */ var NormalX = function(line) {
                return Math.cos(Angle(line) - MATH_CONST.TAU);
            };
            module1.exports = NormalX;
        /***/ },
        /* 1234 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(97);
            /**
 * The Y value of the normal of the given line.
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.NormalY
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 *
 * @return {number} The Y value of the normal of the Line.
 */ var NormalY = function(line) {
                return Math.sin(Angle(line) - MATH_CONST.TAU);
            };
            module1.exports = NormalY;
        /***/ },
        /* 1235 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offset a line by the given amount.
 *
 * @function Phaser.Geom.Line.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to offset.
 * @param {number} x - The horizontal offset to add to the line.
 * @param {number} y - The vertical offset to add to the line.
 *
 * @return {Phaser.Geom.Line} The offset line.
 */ var Offset = function(line, x, y) {
                line.x1 += x;
                line.y1 += y;
                line.x2 += x;
                line.y2 += y;
                return line;
            };
            module1.exports = Offset;
        /***/ },
        /* 1236 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the perpendicular slope of the given line.
 *
 * @function Phaser.Geom.Line.PerpSlope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the perpendicular slope of.
 *
 * @return {number} The perpendicular slope of the line.
 */ var PerpSlope = function(line) {
                return -((line.x2 - line.x1) / (line.y2 - line.y1));
            };
            module1.exports = PerpSlope;
        /***/ },
        /* 1237 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(97);
            var NormalAngle = __webpack_require__(497);
            /**
 * Calculate the reflected angle between two lines.
 *
 * This is the outgoing angle based on the angle of Line 1 and the normalAngle of Line 2.
 *
 * @function Phaser.Geom.Line.ReflectAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} lineA - The first line.
 * @param {Phaser.Geom.Line} lineB - The second line.
 *
 * @return {number} The reflected angle between each line.
 */ var ReflectAngle = function(lineA, lineB) {
                return 2 * NormalAngle(lineB) - Math.PI - Angle(lineA);
            };
            module1.exports = ReflectAngle;
        /***/ },
        /* 1238 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(236);
            /**
 * Rotate a line around its midpoint by the given angle in radians.
 *
 * @function Phaser.Geom.Line.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var Rotate = function(line, angle) {
                var x = (line.x1 + line.x2) / 2;
                var y = (line.y1 + line.y2) / 2;
                return RotateAroundXY(line, x, y, angle);
            };
            module1.exports = Rotate;
        /***/ },
        /* 1239 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(236);
            /**
 * Rotate a line around a point by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {(Phaser.Geom.Point|object)} point - The point to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundPoint = function(line, point, angle) {
                return RotateAroundXY(line, point.x, point.y, angle);
            };
            module1.exports = RotateAroundPoint;
        /***/ },
        /* 1240 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Set a line to a given position, angle and length.
 *
 * @function Phaser.Geom.Line.SetToAngle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to set.
 * @param {number} x - The horizontal start position of the line.
 * @param {number} y - The vertical start position of the line.
 * @param {number} angle - The angle of the line in radians.
 * @param {number} length - The length of the line.
 *
 * @return {Phaser.Geom.Line} The updated line.
 */ var SetToAngle = function(line, x, y, angle, length) {
                line.x1 = x;
                line.y1 = y;
                line.x2 = x + Math.cos(angle) * length;
                line.y2 = y + Math.sin(angle) * length;
                return line;
            };
            module1.exports = SetToAngle;
        /***/ },
        /* 1241 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the slope of the given line.
 *
 * @function Phaser.Geom.Line.Slope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the slope of.
 *
 * @return {number} The slope of the line.
 */ var Slope = function(line) {
                return (line.y2 - line.y1) / (line.x2 - line.x1);
            };
            module1.exports = Slope;
        /***/ },
        /* 1242 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the width of the given line.
 *
 * @function Phaser.Geom.Line.Width
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the width of.
 *
 * @return {number} The width of the line.
 */ var Width = function(line) {
                return Math.abs(line.x1 - line.x2);
            };
            module1.exports = Width;
        /***/ },
        /* 1243 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Mesh
 */ var Mesh = {
                Face: __webpack_require__(116),
                GenerateGridVerts: __webpack_require__(1244),
                GenerateObjVerts: __webpack_require__(480),
                GenerateVerts: __webpack_require__(479),
                ParseObj: __webpack_require__(498),
                ParseObjMaterial: __webpack_require__(499),
                RotateFace: __webpack_require__(1245),
                Vertex: __webpack_require__(117)
            };
            module1.exports = Mesh;
        /***/ },
        /* 1244 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(116);
            var GetFastValue = __webpack_require__(2);
            var Matrix4 = __webpack_require__(69);
            var Vector3 = __webpack_require__(39);
            var Vertex = __webpack_require__(117);
            var tempPosition = new Vector3();
            var tempRotation = new Vector3();
            var tempMatrix = new Matrix4();
            /**
 * Creates a grid of vertices based on the given configuration object and optionally adds it to a Mesh.
 *
 * The size of the grid is given in pixels. An example configuration may be:
 *
 * `{ width: 256, height: 256, widthSegments: 2, heightSegments: 2, tile: true }`
 *
 * This will create a grid 256 x 256 pixels in size, split into 2 x 2 segments, with
 * the texture tiling across the cells.
 *
 * You can split the grid into segments both vertically and horizontally. This will
 * generate two faces per grid segment as a result.
 *
 * The `tile` parameter allows you to control if the tile will repeat across the grid
 * segments, or be displayed in full.
 *
 * If adding this grid to a Mesh you can offset the grid via the `x` and `y` properties.
 *
 * UV coordinates are generated based on the given texture and frame in the config. For
 * example, no frame is given, the UVs will be in the range 0 to 1. If a frame is given,
 * such as from a texture atlas, the UVs will be generated within the range of that frame.
 *
 * @function Phaser.Geom.Mesh.GenerateGridVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.GenerateGridConfig} config - A Grid configuration object.
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateGridVertsResult} A Grid Result object, containing the generated vertices and indicies.
 */ var GenerateGridVerts = function(config) {
                var mesh = GetFastValue(config, "mesh");
                var texture = GetFastValue(config, "texture", null);
                var frame = GetFastValue(config, "frame");
                var width = GetFastValue(config, "width", 1);
                var height = GetFastValue(config, "height", width);
                var widthSegments = GetFastValue(config, "widthSegments", 1);
                var heightSegments = GetFastValue(config, "heightSegments", widthSegments);
                var posX = GetFastValue(config, "x", 0);
                var posY = GetFastValue(config, "y", 0);
                var posZ = GetFastValue(config, "z", 0);
                var rotateX = GetFastValue(config, "rotateX", 0);
                var rotateY = GetFastValue(config, "rotateY", 0);
                var rotateZ = GetFastValue(config, "rotateZ", 0);
                var zIsUp = GetFastValue(config, "zIsUp", true);
                var isOrtho = GetFastValue(config, "isOrtho", mesh ? mesh.dirtyCache[11] : false);
                var colors = GetFastValue(config, "colors", [
                    0xffffff
                ]);
                var alphas = GetFastValue(config, "alphas", [
                    1
                ]);
                var tile = GetFastValue(config, "tile", false);
                var flipY = GetFastValue(config, "flipY", false);
                var widthSet = GetFastValue(config, "width", null);
                var result = {
                    faces: [],
                    verts: []
                };
                tempPosition.set(posX, posY, posZ);
                tempRotation.set(rotateX, rotateY, rotateZ);
                tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                if (!texture && mesh) texture = mesh.texture;
                else if (mesh && typeof texture === "string") texture = mesh.scene.sys.textures.get(texture);
                else //  There's nothing more we can do without a texture
                return result;
                var textureFrame = texture.get(frame);
                //  If the Mesh is ortho and no width / height is given, we'll default to texture sizes (if set!)
                if (!widthSet && isOrtho && texture && mesh) {
                    width = textureFrame.width / mesh.height;
                    height = textureFrame.height / mesh.height;
                }
                var halfWidth = width / 2;
                var halfHeight = height / 2;
                var gridX = Math.floor(widthSegments);
                var gridY = Math.floor(heightSegments);
                var gridX1 = gridX + 1;
                var gridY1 = gridY + 1;
                var segmentWidth = width / gridX;
                var segmentHeight = height / gridY;
                var uvs = [];
                var vertices = [];
                var ix;
                var iy;
                var frameU0 = 0;
                var frameU1 = 1;
                var frameV0 = 0;
                var frameV1 = 1;
                if (textureFrame) {
                    frameU0 = textureFrame.u0;
                    frameU1 = textureFrame.u1;
                    if (!flipY) {
                        frameV0 = textureFrame.v0;
                        frameV1 = textureFrame.v1;
                    } else {
                        frameV0 = textureFrame.v1;
                        frameV1 = textureFrame.v0;
                    }
                }
                var frameU = frameU1 - frameU0;
                var frameV = frameV1 - frameV0;
                for(iy = 0; iy < gridY1; iy++){
                    var y = iy * segmentHeight - halfHeight;
                    for(ix = 0; ix < gridX1; ix++){
                        var x = ix * segmentWidth - halfWidth;
                        vertices.push(x, -y);
                        var tu = frameU0 + frameU * (ix / gridX);
                        var tv = frameV0 + frameV * (iy / gridY);
                        uvs.push(tu, tv);
                    }
                }
                if (!Array.isArray(colors)) colors = [
                    colors
                ];
                if (!Array.isArray(alphas)) alphas = [
                    alphas
                ];
                var alphaIndex = 0;
                var colorIndex = 0;
                for(iy = 0; iy < gridY; iy++)for(ix = 0; ix < gridX; ix++){
                    var a = (ix + gridX1 * iy) * 2;
                    var b = (ix + gridX1 * (iy + 1)) * 2;
                    var c = (ix + 1 + gridX1 * (iy + 1)) * 2;
                    var d = (ix + 1 + gridX1 * iy) * 2;
                    var color = colors[colorIndex];
                    var alpha = alphas[alphaIndex];
                    var vert1 = new Vertex(vertices[a], vertices[a + 1], 0, uvs[a], uvs[a + 1], color, alpha).transformMat4(tempMatrix);
                    var vert2 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                    var vert3 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                    var vert4 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                    var vert5 = new Vertex(vertices[c], vertices[c + 1], 0, uvs[c], uvs[c + 1], color, alpha).transformMat4(tempMatrix);
                    var vert6 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                    if (tile) {
                        vert1.setUVs(frameU0, frameV1);
                        vert2.setUVs(frameU0, frameV0);
                        vert3.setUVs(frameU1, frameV1);
                        vert4.setUVs(frameU0, frameV0);
                        vert5.setUVs(frameU1, frameV0);
                        vert6.setUVs(frameU1, frameV1);
                    }
                    colorIndex++;
                    if (colorIndex === colors.length) colorIndex = 0;
                    alphaIndex++;
                    if (alphaIndex === alphas.length) alphaIndex = 0;
                    result.verts.push(vert1, vert2, vert3, vert4, vert5, vert6);
                    result.faces.push(new Face(vert1, vert2, vert3), new Face(vert4, vert5, vert6));
                }
                if (mesh) {
                    mesh.faces = mesh.faces.concat(result.faces);
                    mesh.vertices = mesh.vertices.concat(result.verts);
                }
                return result;
            };
            module1.exports = GenerateGridVerts;
        /***/ },
        /* 1245 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates the vertices of a Face to the given angle.
 *
 * The actual vertex positions are adjusted, not their transformed positions.
 *
 * Therefore, this updates the vertex data directly.
 *
 * @function Phaser.Geom.Mesh.RotateFace
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Face} face - The Face to rotate.
 * @param {number} angle - The angle to rotate to, in radians.
 * @param {number} [cx] - An optional center of rotation. If not given, the Face in-center is used.
 * @param {number} [cy] - An optional center of rotation. If not given, the Face in-center is used.
 */ var RotateFace = function(face, angle, cx, cy) {
                var x;
                var y;
                //  No point of rotation? Use the inCenter instead, then.
                if (cx === undefined && cy === undefined) {
                    var inCenter = face.getInCenter();
                    x = inCenter.x;
                    y = inCenter.y;
                }
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var v1 = face.vertex1;
                var v2 = face.vertex2;
                var v3 = face.vertex3;
                var tx = v1.x - x;
                var ty = v1.y - y;
                v1.set(tx * c - ty * s + x, tx * s + ty * c + y);
                tx = v2.x - x;
                ty = v2.y - y;
                v2.set(tx * c - ty * s + x, tx * s + ty * c + y);
                tx = v3.x - x;
                ty = v3.y - y;
                v3.set(tx * c - ty * s + x, tx * s + ty * c + y);
            };
            module1.exports = RotateFace;
        /***/ },
        /* 1246 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            Point.Ceil = __webpack_require__(1247);
            Point.Clone = __webpack_require__(1248);
            Point.CopyFrom = __webpack_require__(1249);
            Point.Equals = __webpack_require__(1250);
            Point.Floor = __webpack_require__(1251);
            Point.GetCentroid = __webpack_require__(1252);
            Point.GetMagnitude = __webpack_require__(500);
            Point.GetMagnitudeSq = __webpack_require__(501);
            Point.GetRectangleFromPoints = __webpack_require__(1253);
            Point.Interpolate = __webpack_require__(1254);
            Point.Invert = __webpack_require__(1255);
            Point.Negative = __webpack_require__(1256);
            Point.Project = __webpack_require__(1257);
            Point.ProjectUnit = __webpack_require__(1258);
            Point.SetMagnitude = __webpack_require__(1259);
            module1.exports = Point;
        /***/ },
        /* 1247 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to ceil.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.ceil()` applied to its coordinates.
 */ var Ceil = function(point) {
                return point.setTo(Math.ceil(point.x), Math.ceil(point.y));
            };
            module1.exports = Ceil;
        /***/ },
        /* 1248 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Clone the given Point.
 *
 * @function Phaser.Geom.Point.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} source - The source Point to clone.
 *
 * @return {Phaser.Geom.Point} The cloned Point.
 */ var Clone = function(source) {
                return new Point(source.x, source.y);
            };
            module1.exports = Clone;
        /***/ },
        /* 1249 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Point to a destination Point.
 *
 * @function Phaser.Geom.Point.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [dest,$return]
 *
 * @param {Phaser.Geom.Point} source - The source Point to copy the values from.
 * @param {Phaser.Geom.Point} dest - The destination Point to copy the values to.
 *
 * @return {Phaser.Geom.Point} The destination Point.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1250 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A comparison of two `Point` objects to see if they are equal.
 *
 * @function Phaser.Geom.Point.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The original `Point` to compare against.
 * @param {Phaser.Geom.Point} toCompare - The second `Point` to compare.
 *
 * @return {boolean} Returns true if the both `Point` objects are equal.
 */ var Equals = function(point, toCompare) {
                return point.x === toCompare.x && point.y === toCompare.y;
            };
            module1.exports = Equals;
        /***/ },
        /* 1251 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to floor.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.floor()` applied to its coordinates.
 */ var Floor = function(point) {
                return point.setTo(Math.floor(point.x), Math.floor(point.y));
            };
            module1.exports = Floor;
        /***/ },
        /* 1252 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the centroid or geometric center of a plane figure (the arithmetic mean position of all the points in the figure).
 * Informally, it is the point at which a cutout of the shape could be perfectly balanced on the tip of a pin.
 *
 * @function Phaser.Geom.Point.GetCentroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the geometric center of.
 * @param {Phaser.Geom.Point} [out] - A Point object to store the output coordinates in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object representing the geometric center of the given points.
 */ var GetCentroid = function(points, out) {
                if (out === undefined) out = new Point();
                if (!Array.isArray(points)) throw new Error("GetCentroid points argument must be an array");
                var len = points.length;
                if (len < 1) throw new Error("GetCentroid points array must not be empty");
                else if (len === 1) {
                    out.x = points[0].x;
                    out.y = points[0].y;
                } else {
                    for(var i = 0; i < len; i++){
                        out.x += points[i].x;
                        out.y += points[i].y;
                    }
                    out.x /= len;
                    out.y /= len;
                }
                return out;
            };
            module1.exports = GetCentroid;
        /***/ },
        /* 1253 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Calculates the Axis Aligned Bounding Box (or aabb) from an array of points.
 *
 * @function Phaser.Geom.Point.GetRectangleFromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the AABB from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the results in. If not given, a new Rectangle instance is created.
 *
 * @return {Phaser.Geom.Rectangle} A Rectangle object holding the AABB values for the given points.
 */ var GetRectangleFromPoints = function(points, out) {
                if (out === undefined) out = new Rectangle();
                var xMax = Number.NEGATIVE_INFINITY;
                var xMin = Number.POSITIVE_INFINITY;
                var yMax = Number.NEGATIVE_INFINITY;
                var yMin = Number.POSITIVE_INFINITY;
                for(var i = 0; i < points.length; i++){
                    var point = points[i];
                    if (point.x > xMax) xMax = point.x;
                    if (point.x < xMin) xMin = point.x;
                    if (point.y > yMax) yMax = point.y;
                    if (point.y < yMin) yMin = point.y;
                }
                out.x = xMin;
                out.y = yMin;
                out.width = xMax - xMin;
                out.height = yMax - yMin;
                return out;
            };
            module1.exports = GetRectangleFromPoints;
        /***/ },
        /* 1254 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the linear interpolation point between the two given points, based on `t`.
 *
 * @function Phaser.Geom.Point.Interpolate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - The starting `Point` for the interpolation.
 * @param {Phaser.Geom.Point} pointB - The target `Point` for the interpolation.
 * @param {number} [t=0] - The amount to interpolate between the two points. Generally, a value between 0 (returns the starting `Point`) and 1 (returns the target `Point`). If omitted, 0 is used.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional `Point` object whose `x` and `y` values will be set to the result of the interpolation (can also be any object with `x` and `y` properties). If omitted, a new `Point` created and returned.
 *
 * @return {(Phaser.Geom.Point|object)} Either the object from the `out` argument with the properties `x` and `y` set to the result of the interpolation or a newly created `Point` object.
 */ var Interpolate = function(pointA, pointB, t, out) {
                if (t === undefined) t = 0;
                if (out === undefined) out = new Point();
                out.x = pointA.x + (pointB.x - pointA.x) * t;
                out.y = pointA.y + (pointB.y - pointA.y) * t;
                return out;
            };
            module1.exports = Interpolate;
        /***/ },
        /* 1255 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the X and the Y coordinate of a point.
 *
 * @function Phaser.Geom.Point.Invert
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to modify.
 *
 * @return {Phaser.Geom.Point} The modified `point`.
 */ var Invert = function(point) {
                return point.setTo(point.y, point.x);
            };
            module1.exports = Invert;
        /***/ },
        /* 1256 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Inverts a Point's coordinates.
 *
 * @function Phaser.Geom.Point.Negative
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to invert.
 * @param {Phaser.Geom.Point} [out] - The Point to return the inverted coordinates in.
 *
 * @return {Phaser.Geom.Point} The modified `out` Point, or a new Point if none was provided.
 */ var Negative = function(point, out) {
                if (out === undefined) out = new Point();
                return out.setTo(-point.x, -point.y);
            };
            module1.exports = Negative;
        /***/ },
        /* 1257 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var GetMagnitudeSq = __webpack_require__(501);
            /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line parallel to `pointB`.
 *
 * @function Phaser.Geom.Point.Project
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var Project = function(pointA, pointB, out) {
                if (out === undefined) out = new Point();
                var dot = pointA.x * pointB.x + pointA.y * pointB.y;
                var amt = dot / GetMagnitudeSq(pointB);
                if (amt !== 0) {
                    out.x = amt * pointB.x;
                    out.y = amt * pointB.y;
                }
                return out;
            };
            module1.exports = Project;
        /***/ },
        /* 1258 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line paralle to `pointB`.
 *
 * @function Phaser.Geom.Point.ProjectUnit
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B. Must be a normalized point with a magnitude of 1.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A unit Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var ProjectUnit = function(pointA, pointB, out) {
                if (out === undefined) out = new Point();
                var amt = pointA.x * pointB.x + pointA.y * pointB.y;
                if (amt !== 0) {
                    out.x = amt * pointB.x;
                    out.y = amt * pointB.y;
                }
                return out;
            };
            module1.exports = ProjectUnit;
        /***/ },
        /* 1259 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetMagnitude = __webpack_require__(500);
            /**
 * Changes the magnitude (length) of a two-dimensional vector without changing its direction.
 *
 * @function Phaser.Geom.Point.SetMagnitude
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to treat as the end point of the vector.
 * @param {number} magnitude - The new magnitude of the vector.
 *
 * @return {Phaser.Geom.Point} The modified Point.
 */ var SetMagnitude = function(point, magnitude) {
                if (point.x !== 0 || point.y !== 0) {
                    var m = GetMagnitude(point);
                    point.x /= m;
                    point.y /= m;
                }
                point.x *= magnitude;
                point.y *= magnitude;
                return point;
            };
            module1.exports = SetMagnitude;
        /***/ },
        /* 1260 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(227);
            Polygon.Clone = __webpack_require__(1261);
            Polygon.Contains = __webpack_require__(228);
            Polygon.ContainsPoint = __webpack_require__(1262);
            Polygon.Earcut = __webpack_require__(59);
            Polygon.GetAABB = __webpack_require__(469);
            Polygon.GetNumberArray = __webpack_require__(1263);
            Polygon.GetPoints = __webpack_require__(470);
            Polygon.Perimeter = __webpack_require__(471);
            Polygon.Reverse = __webpack_require__(1264);
            Polygon.Simplify = __webpack_require__(1265);
            Polygon.Smooth = __webpack_require__(472);
            Polygon.Translate = __webpack_require__(1266);
            module1.exports = Polygon;
        /***/ },
        /* 1261 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(227);
            /**
 * Create a new polygon which is a copy of the specified polygon
 *
 * @function Phaser.Geom.Polygon.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to create a clone of
 *
 * @return {Phaser.Geom.Polygon} A new separate Polygon cloned from the specified polygon, based on the same points.
 */ var Clone = function(polygon) {
                return new Polygon(polygon.points);
            };
            module1.exports = Clone;
        /***/ },
        /* 1262 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(228);
            /**
 * Checks the given Point again the Polygon to see if the Point lays within its vertices.
 *
 * @function Phaser.Geom.Polygon.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check.
 * @param {Phaser.Geom.Point} point - The Point to check if it's within the Polygon.
 *
 * @return {boolean} `true` if the Point is within the Polygon, otherwise `false`.
 */ var ContainsPoint = function(polygon, point) {
                return Contains(polygon, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1263 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Export the points as an array of flat numbers, following the sequence [ x,y, x,y, x,y ]
            /**
 * Stores all of the points of a Polygon into a flat array of numbers following the sequence [ x,y, x,y, x,y ],
 * i.e. each point of the Polygon, in the order it's defined, corresponds to two elements of the resultant
 * array for the point's X and Y coordinate.
 *
 * @function Phaser.Geom.Polygon.GetNumberArray
 * @since 3.0.0
 *
 * @generic {number[]} O - [output,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon whose points to export.
 * @param {(array|number[])} [output] - An array to which the points' coordinates should be appended.
 *
 * @return {(array|number[])} The modified `output` array, or a new array if none was given.
 */ var GetNumberArray = function(polygon, output) {
                if (output === undefined) output = [];
                for(var i = 0; i < polygon.points.length; i++){
                    output.push(polygon.points[i].x);
                    output.push(polygon.points[i].y);
                }
                return output;
            };
            module1.exports = GetNumberArray;
        /***/ },
        /* 1264 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the order of the points of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Reverse
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Reverse = function(polygon) {
                polygon.points.reverse();
                return polygon;
            };
            module1.exports = Reverse;
        /***/ },
        /* 1265 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Vladimir Agafonkin
 * @see          Based on Simplify.js mourner.github.io/simplify-js
 */ /**
 * Copyright (c) 2017, Vladimir Agafonkin
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
 * TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * @ignore
 */ function getSqDist(p1, p2) {
                var dx = p1.x - p2.x, dy = p1.y - p2.y;
                return dx * dx + dy * dy;
            }
            /**
 * Square distance from a point to a segment
 *
 * @ignore
 */ function getSqSegDist(p, p1, p2) {
                var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
                if (dx !== 0 || dy !== 0) {
                    var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
                    if (t > 1) {
                        x = p2.x;
                        y = p2.y;
                    } else if (t > 0) {
                        x += dx * t;
                        y += dy * t;
                    }
                }
                dx = p.x - x;
                dy = p.y - y;
                return dx * dx + dy * dy;
            }
            /**
 * Basic distance-based simplification
 *
 * @ignore
 */ function simplifyRadialDist(points, sqTolerance) {
                var prevPoint = points[0], newPoints = [
                    prevPoint
                ], point;
                for(var i = 1, len = points.length; i < len; i++){
                    point = points[i];
                    if (getSqDist(point, prevPoint) > sqTolerance) {
                        newPoints.push(point);
                        prevPoint = point;
                    }
                }
                if (prevPoint !== point) newPoints.push(point);
                return newPoints;
            }
            /**
 * @ignore
 */ function simplifyDPStep(points, first, last, sqTolerance, simplified) {
                var maxSqDist = sqTolerance, index;
                for(var i = first + 1; i < last; i++){
                    var sqDist = getSqSegDist(points[i], points[first], points[last]);
                    if (sqDist > maxSqDist) {
                        index = i;
                        maxSqDist = sqDist;
                    }
                }
                if (maxSqDist > sqTolerance) {
                    if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
                    simplified.push(points[index]);
                    if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
                }
            }
            /**
 * Simplification using Ramer-Douglas-Peucker algorithm
 *
 * @ignore
 */ function simplifyDouglasPeucker(points, sqTolerance) {
                var last = points.length - 1;
                var simplified = [
                    points[0]
                ];
                simplifyDPStep(points, 0, last, sqTolerance, simplified);
                simplified.push(points[last]);
                return simplified;
            }
            /**
 * Takes a Polygon object and simplifies the points by running them through a combination of
 * Douglas-Peucker and Radial Distance algorithms. Simplification dramatically reduces the number of
 * points in a polygon while retaining its shape, giving a huge performance boost when processing
 * it and also reducing visual noise.
 *
 * @function Phaser.Geom.Polygon.Simplify
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be simplified. The polygon will be modified in-place and returned.
 * @param {number} [tolerance=1] - Affects the amount of simplification (in the same metric as the point coordinates).
 * @param {boolean} [highestQuality=false] - Excludes distance-based preprocessing step which leads to highest quality simplification but runs ~10-20 times slower.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Simplify = function(polygon, tolerance, highestQuality) {
                if (tolerance === undefined) tolerance = 1;
                if (highestQuality === undefined) highestQuality = false;
                var points = polygon.points;
                if (points.length > 2) {
                    var sqTolerance = tolerance * tolerance;
                    if (!highestQuality) points = simplifyRadialDist(points, sqTolerance);
                    polygon.setTo(simplifyDouglasPeucker(points, sqTolerance));
                }
                return polygon;
            };
            module1.exports = Simplify;
        /***/ },
        /* 1266 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tranlates the points of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Translate
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 * @param {number} x - The amount to horizontally translate the points by.
 * @param {number} y - The amount to vertically translate the points by.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Translate = function(polygon, x, y) {
                var points = polygon.points;
                for(var i = 0; i < points.length; i++){
                    points[i].x += x;
                    points[i].y += y;
                }
                return polygon;
            };
            module1.exports = Translate;
        /***/ },
        /* 1267 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the given Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to calculate the area of.
 *
 * @return {number} The area of the Rectangle object.
 */ var Area = function(rect) {
                return rect.width * rect.height;
            };
            module1.exports = Area;
        /***/ },
        /* 1268 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position up to the smallest integer greater than or equal to each current coordinate.
 *
 * @function Phaser.Geom.Rectangle.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Ceil = function(rect) {
                rect.x = Math.ceil(rect.x);
                rect.y = Math.ceil(rect.y);
                return rect;
            };
            module1.exports = Ceil;
        /***/ },
        /* 1269 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size up to the smallest integer greater than or equal to each respective value.
 *
 * @function Phaser.Geom.Rectangle.CeilAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to modify.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var CeilAll = function(rect) {
                rect.x = Math.ceil(rect.x);
                rect.y = Math.ceil(rect.y);
                rect.width = Math.ceil(rect.width);
                rect.height = Math.ceil(rect.height);
                return rect;
            };
            module1.exports = CeilAll;
        /***/ },
        /* 1270 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Creates a new Rectangle which is identical to the given one.
 *
 * @function Phaser.Geom.Rectangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} source - The Rectangle to clone.
 *
 * @return {Phaser.Geom.Rectangle} The newly created Rectangle, which is separate from the given one.
 */ var Clone = function(source) {
                return new Rectangle(source.x, source.y, source.width, source.height);
            };
            module1.exports = Clone;
        /***/ },
        /* 1271 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(57);
            /**
 * Determines whether the specified point is contained within the rectangular region defined by this Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object.
 * @param {Phaser.Geom.Point} point - The point object to be checked. Can be a Phaser Point object or any object with x and y values.
 *
 * @return {boolean} A value of true if the Rectangle object contains the specified point, otherwise false.
 */ var ContainsPoint = function(rect, point) {
                return Contains(rect, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1272 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Rectangle to a destination Rectangle.
 *
 * @function Phaser.Geom.Rectangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Rectangle} source - The source Rectangle to copy the values from.
 * @param {Phaser.Geom.Rectangle} dest - The destination Rectangle to copy the values to.
 *
 * @return {Phaser.Geom.Rectangle} The destination Rectangle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.width, source.height);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1273 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of two rectangles.
 *
 * @function Phaser.Geom.Rectangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle A
 * @param {Phaser.Geom.Rectangle} toCompare - Rectangle B
 *
 * @return {boolean} `true` if the rectangles' properties are an exact match, otherwise `false`.
 */ var Equals = function(rect, toCompare) {
                return rect.x === toCompare.x && rect.y === toCompare.y && rect.width === toCompare.width && rect.height === toCompare.height;
            };
            module1.exports = Equals;
        /***/ },
        /* 1274 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(237);
            /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fits inside the area of the source rectangle, while maintaining its original
 * aspect ratio.
 * 
 * Unlike the `FitOutside` function, there may be some space inside the source area not covered.
 *
 * @function Phaser.Geom.Rectangle.FitInside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelop the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitInside = function(target, source) {
                var ratio = GetAspectRatio(target);
                if (ratio < GetAspectRatio(source)) //  Taller than Wide
                target.setSize(source.height * ratio, source.height);
                else //  Wider than Tall
                target.setSize(source.width, source.width / ratio);
                return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
            };
            module1.exports = FitInside;
        /***/ },
        /* 1275 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(237);
            /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fully covers the area of the source rectangle, while maintaining its original
 * aspect ratio.
 * 
 * Unlike the `FitInside` function, the target rectangle may extend further out than the source.
 *
 * @function Phaser.Geom.Rectangle.FitOutside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelope the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitOutside = function(target, source) {
                var ratio = GetAspectRatio(target);
                if (ratio > GetAspectRatio(source)) //  Wider than Tall
                target.setSize(source.height * ratio, source.height);
                else //  Taller than Wide
                target.setSize(source.width, source.width / ratio);
                return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
            };
            module1.exports = FitOutside;
        /***/ },
        /* 1276 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds down (floors) the top left X and Y coordinates of the given Rectangle to the largest integer less than or equal to them
 *
 * @function Phaser.Geom.Rectangle.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to floor the top left X and Y coordinates of
 *
 * @return {Phaser.Geom.Rectangle} The rectangle that was passed to this function with its coordinates floored.
 */ var Floor = function(rect) {
                rect.x = Math.floor(rect.x);
                rect.y = Math.floor(rect.y);
                return rect;
            };
            module1.exports = Floor;
        /***/ },
        /* 1277 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size down to the largest integer less than or equal to each current coordinate or dimension.
 *
 * @function Phaser.Geom.Rectangle.FloorAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var FloorAll = function(rect) {
                rect.x = Math.floor(rect.x);
                rect.y = Math.floor(rect.y);
                rect.width = Math.floor(rect.width);
                rect.height = Math.floor(rect.height);
                return rect;
            };
            module1.exports = FloorAll;
        /***/ },
        /* 1278 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Create the smallest Rectangle containing two coordinate pairs.
 *
 * @function Phaser.Geom.Rectangle.FromXY
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {number} x1 - The X coordinate of the first point.
 * @param {number} y1 - The Y coordinate of the first point.
 * @param {number} x2 - The X coordinate of the second point.
 * @param {number} y2 - The Y coordinate of the second point.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromXY = function(x1, y1, x2, y2, out) {
                if (out === undefined) out = new Rectangle();
                return out.setTo(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x1 - x2), Math.abs(y1 - y2));
            };
            module1.exports = FromXY;
        /***/ },
        /* 1279 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the center of a Rectangle as a Point.
 *
 * @function Phaser.Geom.Rectangle.GetCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the center of.
 * @param {(Phaser.Geom.Point|object)} [out] - Optional point-like object to update with the center coordinates.
 *
 * @return {(Phaser.Geom.Point|object)} The modified `out` object, or a new Point if none was provided.
 */ var GetCenter = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.centerX;
                out.y = rect.centerY;
                return out;
            };
            module1.exports = GetCenter;
        /***/ },
        /* 1280 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the size of the Rectangle, expressed as a Point object.
 * With the value of the `width` as the `x` property and the `height` as the `y` property.
 *
 * @function Phaser.Geom.Rectangle.GetSize
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the size from.
 * @param {(Phaser.Geom.Point|object)} [out] - The Point object to store the size in. If not given, a new Point instance is created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where `x` holds the width and `y` holds the height of the Rectangle.
 */ var GetSize = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.width;
                out.y = rect.height;
                return out;
            };
            module1.exports = GetSize;
        /***/ },
        /* 1281 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(190);
            /**
 * Increases the size of a Rectangle by a specified amount.
 *
 * The center of the Rectangle stays the same. The amounts are added to each side, so the actual increase in width or height is two times bigger than the respective argument.
 *
 * @function Phaser.Geom.Rectangle.Inflate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to inflate.
 * @param {number} x - How many pixels the left and the right side should be moved by horizontally.
 * @param {number} y - How many pixels the top and the bottom side should be moved by vertically.
 *
 * @return {Phaser.Geom.Rectangle} The inflated Rectangle.
 */ var Inflate = function(rect, x, y) {
                var cx = rect.centerX;
                var cy = rect.centerY;
                rect.setSize(rect.width + x * 2, rect.height + y * 2);
                return CenterOn(rect, cx, cy);
            };
            module1.exports = Inflate;
        /***/ },
        /* 1282 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var Intersects = __webpack_require__(152);
            /**
 * Takes two Rectangles and first checks to see if they intersect.
 * If they intersect it will return the area of intersection in the `out` Rectangle.
 * If they do not intersect, the `out` Rectangle will have a width and height of zero.
 *
 * @function Phaser.Geom.Rectangle.Intersection
 * @since 3.11.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle to store the intersection results in.
 *
 * @return {Phaser.Geom.Rectangle} The intersection result. If the width and height are zero, no intersection occurred.
 */ var Intersection = function(rectA, rectB, out) {
                if (out === undefined) out = new Rectangle();
                if (Intersects(rectA, rectB)) {
                    out.x = Math.max(rectA.x, rectB.x);
                    out.y = Math.max(rectA.y, rectB.y);
                    out.width = Math.min(rectA.right, rectB.right) - out.x;
                    out.height = Math.min(rectA.bottom, rectB.bottom) - out.y;
                } else out.setEmpty();
                return out;
            };
            module1.exports = Intersection;
        /***/ },
        /* 1283 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a list of points by repositioning and/or resizing it such that all points are located on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergePoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged.
 * @param {Phaser.Geom.Point[]} points - An array of Points (or any object with public `x` and `y` properties) which should be merged with the Rectangle.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var MergePoints = function(target, points) {
                var minX = target.x;
                var maxX = target.right;
                var minY = target.y;
                var maxY = target.bottom;
                for(var i = 0; i < points.length; i++){
                    minX = Math.min(minX, points[i].x);
                    maxX = Math.max(maxX, points[i].x);
                    minY = Math.min(minY, points[i].y);
                    maxY = Math.max(maxY, points[i].y);
                }
                target.x = minX;
                target.y = minY;
                target.width = maxX - minX;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergePoints;
        /***/ },
        /* 1284 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Merges source rectangle into target rectangle and returns target
            //  Neither rect should have negative widths or heights
            /**
 * Merges the source rectangle into the target rectangle and returns the target.
 * Neither rectangle should have a negative width or height.
 *
 * @function Phaser.Geom.Rectangle.MergeRect
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - Target rectangle. Will be modified to include source rectangle.
 * @param {Phaser.Geom.Rectangle} source - Rectangle that will be merged into target rectangle.
 *
 * @return {Phaser.Geom.Rectangle} Modified target rectangle that contains source rectangle.
 */ var MergeRect = function(target, source) {
                var minX = Math.min(target.x, source.x);
                var maxX = Math.max(target.right, source.right);
                target.x = minX;
                target.width = maxX - minX;
                var minY = Math.min(target.y, source.y);
                var maxY = Math.max(target.bottom, source.bottom);
                target.y = minY;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergeRect;
        /***/ },
        /* 1285 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a point by repositioning and/or resizing it so that the point is on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergeXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged and modified.
 * @param {number} x - The X coordinate of the point which should be merged.
 * @param {number} y - The Y coordinate of the point which should be merged.
 *
 * @return {Phaser.Geom.Rectangle} The modified `target` Rectangle.
 */ var MergeXY = function(target, x, y) {
                var minX = Math.min(target.x, x);
                var maxX = Math.max(target.right, x);
                target.x = minX;
                target.width = maxX - minX;
                var minY = Math.min(target.y, y);
                var maxY = Math.max(target.bottom, y);
                target.y = minY;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergeXY;
        /***/ },
        /* 1286 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top left corner of a Rectangle by a given offset.
 *
 * @function Phaser.Geom.Rectangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {number} x - The distance to move the Rectangle horizontally.
 * @param {number} y - The distance to move the Rectangle vertically.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Offset = function(rect, x, y) {
                rect.x += x;
                rect.y += y;
                return rect;
            };
            module1.exports = Offset;
        /***/ },
        /* 1287 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top-left corner of a Rectangle by the coordinates of a point (translation vector).
 *
 * @function Phaser.Geom.Rectangle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2)} point - The point whose coordinates should be used as an offset.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var OffsetPoint = function(rect, point) {
                rect.x += point.x;
                rect.y += point.y;
                return rect;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1288 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles overlap. If a Rectangle is within another Rectangle, the two will be considered overlapping. Thus, the Rectangles are treated as "solid".
 *
 * @function Phaser.Geom.Rectangle.Overlaps
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check.
 *
 * @return {boolean} `true` if the two Rectangles overlap, `false` otherwise.
 */ var Overlaps = function(rectA, rectB) {
                return rectA.x < rectB.right && rectA.right > rectB.x && rectA.y < rectB.bottom && rectA.bottom > rectB.y;
            };
            module1.exports = Overlaps;
        /***/ },
        /* 1289 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var DegToRad = __webpack_require__(36);
            /**
 * Returns a Point from the perimeter of a Rectangle based on the given angle.
 *
 * @function Phaser.Geom.Rectangle.PerimeterPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} angle - The angle of the point, in degrees.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the Rectangle perimeter.
 */ var PerimeterPoint = function(rectangle, angle, out) {
                if (out === undefined) out = new Point();
                angle = DegToRad(angle);
                var s = Math.sin(angle);
                var c = Math.cos(angle);
                var dx = c > 0 ? rectangle.width / 2 : rectangle.width / -2;
                var dy = s > 0 ? rectangle.height / 2 : rectangle.height / -2;
                if (Math.abs(dx * s) < Math.abs(dy * c)) dy = dx * s / c;
                else dx = dy * c / s;
                out.x = dx + rectangle.centerX;
                out.y = dy + rectangle.centerY;
                return out;
            };
            module1.exports = PerimeterPoint;
        /***/ },
        /* 1290 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(195);
            var ContainsRect = __webpack_require__(503);
            var Point = __webpack_require__(4);
            /**
 * Calculates a random point that lies within the `outer` Rectangle, but outside of the `inner` Rectangle.
 * The inner Rectangle must be fully contained within the outer rectangle.
 *
 * @function Phaser.Geom.Rectangle.RandomOutside
 * @since 3.10.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} outer - The outer Rectangle to get the random point within.
 * @param {Phaser.Geom.Rectangle} inner - The inner Rectangle to exclude from the returned point.
 * @param {Phaser.Geom.Point} [out] - A Point, or Point-like object to store the result in. If not specified, a new Point will be created.
 *
 * @return {Phaser.Geom.Point} A Point object containing the random values in its `x` and `y` properties.
 */ var RandomOutside = function(outer, inner, out) {
                if (out === undefined) out = new Point();
                if (ContainsRect(outer, inner)) //  Pick a random quadrant
                //
                //  The quadrants don't extend the full widths / heights of the outer rect to give
                //  us a better uniformed distribution, otherwise you get clumping in the corners where
                //  the 4 quads would overlap
                switch(Between(0, 3)){
                    case 0:
                        out.x = outer.x + Math.random() * (inner.right - outer.x);
                        out.y = outer.y + Math.random() * (inner.top - outer.y);
                        break;
                    case 1:
                        out.x = inner.x + Math.random() * (outer.right - inner.x);
                        out.y = inner.bottom + Math.random() * (outer.bottom - inner.bottom);
                        break;
                    case 2:
                        out.x = outer.x + Math.random() * (inner.x - outer.x);
                        out.y = inner.y + Math.random() * (outer.bottom - inner.y);
                        break;
                    case 3:
                        out.x = inner.right + Math.random() * (outer.right - inner.right);
                        out.y = outer.y + Math.random() * (inner.bottom - outer.y);
                        break;
                }
                return out;
            };
            module1.exports = RandomOutside;
        /***/ },
        /* 1291 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines if the two objects (either Rectangles or Rectangle-like) have the same width and height values under strict equality.
 *
 * @function Phaser.Geom.Rectangle.SameDimensions
 * @since 3.15.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} toCompare - The second Rectangle object.
 *
 * @return {boolean} `true` if the objects have equivalent values for the `width` and `height` properties, otherwise `false`.
 */ var SameDimensions = function(rect, toCompare) {
                return rect.width === toCompare.width && rect.height === toCompare.height;
            };
            module1.exports = SameDimensions;
        /***/ },
        /* 1292 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Scales the width and height of this Rectangle by the given amounts.
            /**
 * Scales the width and height of this Rectangle by the given amounts.
 *
 * @function Phaser.Geom.Rectangle.Scale
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The `Rectangle` object that will be scaled by the specified amount(s).
 * @param {number} x - The factor by which to scale the rectangle horizontally.
 * @param {number} y - The amount by which to scale the rectangle vertically. If this is not specified, the rectangle will be scaled by the factor `x` in both directions.
 *
 * @return {Phaser.Geom.Rectangle} The rectangle object with updated `width` and `height` properties as calculated from the scaling factor(s).
 */ var Scale = function(rect, x, y) {
                if (y === undefined) y = x;
                rect.width *= x;
                rect.height *= y;
                return rect;
            };
            module1.exports = Scale;
        /***/ },
        /* 1293 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            Triangle.Area = __webpack_require__(1294);
            Triangle.BuildEquilateral = __webpack_require__(1295);
            Triangle.BuildFromPolygon = __webpack_require__(1296);
            Triangle.BuildRight = __webpack_require__(1297);
            Triangle.CenterOn = __webpack_require__(1298);
            Triangle.Centroid = __webpack_require__(504);
            Triangle.CircumCenter = __webpack_require__(1299);
            Triangle.CircumCircle = __webpack_require__(1300);
            Triangle.Clone = __webpack_require__(1301);
            Triangle.Contains = __webpack_require__(115);
            Triangle.ContainsArray = __webpack_require__(235);
            Triangle.ContainsPoint = __webpack_require__(1302);
            Triangle.CopyFrom = __webpack_require__(1303);
            Triangle.Decompose = __webpack_require__(495);
            Triangle.Equals = __webpack_require__(1304);
            Triangle.GetPoint = __webpack_require__(476);
            Triangle.GetPoints = __webpack_require__(477);
            Triangle.InCenter = __webpack_require__(506);
            Triangle.Perimeter = __webpack_require__(1305);
            Triangle.Offset = __webpack_require__(505);
            Triangle.Random = __webpack_require__(181);
            Triangle.Rotate = __webpack_require__(1306);
            Triangle.RotateAroundPoint = __webpack_require__(1307);
            Triangle.RotateAroundXY = __webpack_require__(238);
            module1.exports = Triangle;
        /***/ },
        /* 1294 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // The 2D area of a triangle. The area value is always non-negative.
            /**
 * Returns the area of a Triangle.
 *
 * @function Phaser.Geom.Triangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 *
 * @return {number} The area of the Triangle, always non-negative.
 */ var Area = function(triangle) {
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                return Math.abs(((x3 - x1) * (y2 - y1) - (x2 - x1) * (y3 - y1)) / 2);
            };
            module1.exports = Area;
        /***/ },
        /* 1295 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            /**
 * Builds an equilateral triangle. In the equilateral triangle, all the sides are the same length (congruent) and all the angles are the same size (congruent).
 * The x/y specifies the top-middle of the triangle (x1/y1) and length is the length of each side.
 *
 * @function Phaser.Geom.Triangle.BuildEquilateral
 * @since 3.0.0
 *
 * @param {number} x - x coordinate of the top point of the triangle.
 * @param {number} y - y coordinate of the top point of the triangle.
 * @param {number} length - Length of each side of the triangle.
 *
 * @return {Phaser.Geom.Triangle} The Triangle object of the given size.
 */ var BuildEquilateral = function(x, y, length) {
                var height = length * (Math.sqrt(3) / 2);
                var x1 = x;
                var y1 = y;
                var x2 = x + length / 2;
                var y2 = y + height;
                var x3 = x - length / 2;
                var y3 = y + height;
                return new Triangle(x1, y1, x2, y2, x3, y3);
            };
            module1.exports = BuildEquilateral;
        /***/ },
        /* 1296 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EarCut = __webpack_require__(59);
            var Triangle = __webpack_require__(82);
            /**
 * Takes an array of vertex coordinates, and optionally an array of hole indices, then returns an array
 * of Triangle instances, where the given vertices have been decomposed into a series of triangles.
 *
 * @function Phaser.Geom.Triangle.BuildFromPolygon
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle[]} O - [out,$return]
 *
 * @param {array} data - A flat array of vertex coordinates like [x0,y0, x1,y1, x2,y2, ...]
 * @param {array} [holes=null] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [scaleX=1] - Horizontal scale factor to multiply the resulting points by.
 * @param {number} [scaleY=1] - Vertical scale factor to multiply the resulting points by.
 * @param {(array|Phaser.Geom.Triangle[])} [out] - An array to store the resulting Triangle instances in. If not provided, a new array is created.
 *
 * @return {(array|Phaser.Geom.Triangle[])} An array of Triangle instances, where each triangle is based on the decomposed vertices data.
 */ var BuildFromPolygon = function(data, holes, scaleX, scaleY, out) {
                if (holes === undefined) holes = null;
                if (scaleX === undefined) scaleX = 1;
                if (scaleY === undefined) scaleY = 1;
                if (out === undefined) out = [];
                var tris = EarCut(data, holes);
                var a;
                var b;
                var c;
                var x1;
                var y1;
                var x2;
                var y2;
                var x3;
                var y3;
                for(var i = 0; i < tris.length; i += 3){
                    a = tris[i];
                    b = tris[i + 1];
                    c = tris[i + 2];
                    x1 = data[a * 2] * scaleX;
                    y1 = data[a * 2 + 1] * scaleY;
                    x2 = data[b * 2] * scaleX;
                    y2 = data[b * 2 + 1] * scaleY;
                    x3 = data[c * 2] * scaleX;
                    y3 = data[c * 2 + 1] * scaleY;
                    out.push(new Triangle(x1, y1, x2, y2, x3, y3));
                }
                return out;
            };
            module1.exports = BuildFromPolygon;
        /***/ },
        /* 1297 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            //  Builds a right triangle, with one 90 degree angle and two acute angles
            //  The x/y is the coordinate of the 90 degree angle (and will map to x1/y1 in the resulting Triangle)
            //  w/h can be positive or negative and represent the length of each side
            /**
 * Builds a right triangle, i.e. one which has a 90-degree angle and two acute angles.
 *
 * @function Phaser.Geom.Triangle.BuildRight
 * @since 3.0.0
 *
 * @param {number} x - The X coordinate of the right angle, which will also be the first X coordinate of the constructed Triangle.
 * @param {number} y - The Y coordinate of the right angle, which will also be the first Y coordinate of the constructed Triangle.
 * @param {number} width - The length of the side which is to the left or to the right of the right angle.
 * @param {number} height - The length of the side which is above or below the right angle.
 *
 * @return {Phaser.Geom.Triangle} The constructed right Triangle.
 */ var BuildRight = function(x, y, width, height) {
                if (height === undefined) height = width;
                //  90 degree angle
                var x1 = x;
                var y1 = y;
                var x2 = x;
                var y2 = y - height;
                var x3 = x + width;
                var y3 = y;
                return new Triangle(x1, y1, x2, y2, x3, y3);
            };
            module1.exports = BuildRight;
        /***/ },
        /* 1298 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Centroid = __webpack_require__(504);
            var Offset = __webpack_require__(505);
            /**
 * @callback CenterFunction
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to return the center coordinates of.
 *
 * @return {Phaser.Math.Vector2} The center point of the Triangle according to the function.
 */ /**
 * Positions the Triangle so that it is centered on the given coordinates.
 *
 * @function Phaser.Geom.Triangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle to be positioned.
 * @param {number} x - The horizontal coordinate to center on.
 * @param {number} y - The vertical coordinate to center on.
 * @param {CenterFunction} [centerFunc] - The function used to center the triangle. Defaults to Centroid centering.
 *
 * @return {Phaser.Geom.Triangle} The Triangle that was centered.
 */ var CenterOn = function(triangle, x, y, centerFunc) {
                if (centerFunc === undefined) centerFunc = Centroid;
                //  Get the center of the triangle
                var center = centerFunc(triangle);
                //  Difference
                var diffX = x - center.x;
                var diffY = y - center.y;
                return Offset(triangle, diffX, diffY);
            };
            module1.exports = CenterOn;
        /***/ },
        /* 1299 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            //  Adapted from http://bjornharrtell.github.io/jsts/doc/api/jsts_geom_Triangle.js.html
            /**
 * Computes the determinant of a 2x2 matrix. Uses standard double-precision arithmetic, so is susceptible to round-off error.
 *
 * @function det
 * @private
 * @since 3.0.0
 *
 * @param {number} m00 - The [0,0] entry of the matrix.
 * @param {number} m01 - The [0,1] entry of the matrix.
 * @param {number} m10 - The [1,0] entry of the matrix.
 * @param {number} m11 - The [1,1] entry of the matrix.
 *
 * @return {number} the determinant.
 */ function det(m00, m01, m10, m11) {
                return m00 * m11 - m01 * m10;
            }
            /**
 * Computes the circumcentre of a triangle. The circumcentre is the centre of
 * the circumcircle, the smallest circle which encloses the triangle. It is also
 * the common intersection point of the perpendicular bisectors of the sides of
 * the triangle, and is the only point which has equal distance to all three
 * vertices of the triangle.
 *
 * @function Phaser.Geom.Triangle.CircumCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Math.Vector2} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the circumcenter of.
 * @param {Phaser.Math.Vector2} [out] - The Vector2 object to store the position in. If not given, a new Vector2 instance is created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 object holding the coordinates of the circumcenter of the Triangle.
 */ var CircumCenter = function(triangle, out) {
                if (out === undefined) out = new Vector2();
                var cx = triangle.x3;
                var cy = triangle.y3;
                var ax = triangle.x1 - cx;
                var ay = triangle.y1 - cy;
                var bx = triangle.x2 - cx;
                var by = triangle.y2 - cy;
                var denom = 2 * det(ax, ay, bx, by);
                var numx = det(ay, ax * ax + ay * ay, by, bx * bx + by * by);
                var numy = det(ax, ax * ax + ay * ay, bx, bx * bx + by * by);
                out.x = cx - numx / denom;
                out.y = cy + numy / denom;
                return out;
            };
            module1.exports = CircumCenter;
        /***/ },
        /* 1300 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(65);
            //  Adapted from https://gist.github.com/mutoo/5617691
            /**
 * Finds the circumscribed circle (circumcircle) of a Triangle object. The circumcircle is the circle which touches all of the triangle's vertices.
 *
 * @function Phaser.Geom.Triangle.CircumCircle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use as input.
 * @param {Phaser.Geom.Circle} [out] - An optional Circle to store the result in.
 *
 * @return {Phaser.Geom.Circle} The updated `out` Circle, or a new Circle if none was provided.
 */ var CircumCircle = function(triangle, out) {
                if (out === undefined) out = new Circle();
                //  A
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                //  B
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                //  C
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                var A = x2 - x1;
                var B = y2 - y1;
                var C = x3 - x1;
                var D = y3 - y1;
                var E = A * (x1 + x2) + B * (y1 + y2);
                var F = C * (x1 + x3) + D * (y1 + y3);
                var G = 2 * (A * (y3 - y2) - B * (x3 - x2));
                var dx;
                var dy;
                //  If the points of the triangle are collinear, then just find the
                //  extremes and use the midpoint as the center of the circumcircle.
                if (Math.abs(G) < 0.000001) {
                    var minX = Math.min(x1, x2, x3);
                    var minY = Math.min(y1, y2, y3);
                    dx = (Math.max(x1, x2, x3) - minX) * 0.5;
                    dy = (Math.max(y1, y2, y3) - minY) * 0.5;
                    out.x = minX + dx;
                    out.y = minY + dy;
                    out.radius = Math.sqrt(dx * dx + dy * dy);
                } else {
                    out.x = (D * E - B * F) / G;
                    out.y = (A * F - C * E) / G;
                    dx = out.x - x1;
                    dy = out.y - y1;
                    out.radius = Math.sqrt(dx * dx + dy * dy);
                }
                return out;
            };
            module1.exports = CircumCircle;
        /***/ },
        /* 1301 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            /**
 * Clones a Triangle object.
 *
 * @function Phaser.Geom.Triangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} source - The Triangle to clone.
 *
 * @return {Phaser.Geom.Triangle} A new Triangle identical to the given one but separate from it.
 */ var Clone = function(source) {
                return new Triangle(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
            };
            module1.exports = Clone;
        /***/ },
        /* 1302 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(115);
            /**
 * Tests if a triangle contains a point.
 *
 * @function Phaser.Geom.Triangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|any)} point - The point to test, or any point-like object with public `x` and `y` properties.
 *
 * @return {boolean} `true` if the point is within the triangle, otherwise `false`.
 */ var ContainsPoint = function(triangle, point) {
                return Contains(triangle, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1303 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Triangle to a destination Triangle.
 *
 * @function Phaser.Geom.Triangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Triangle} source - The source Triangle to copy the values from.
 * @param {Phaser.Geom.Triangle} dest - The destination Triangle to copy the values to.
 *
 * @return {Phaser.Geom.Triangle} The destination Triangle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1304 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns true if two triangles have the same coordinates.
 *
 * @function Phaser.Geom.Triangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The first triangle to check.
 * @param {Phaser.Geom.Triangle} toCompare - The second triangle to check.
 *
 * @return {boolean} `true` if the two given triangles have the exact same coordinates, otherwise `false`.
 */ var Equals = function(triangle, toCompare) {
                return triangle.x1 === toCompare.x1 && triangle.y1 === toCompare.y1 && triangle.x2 === toCompare.x2 && triangle.y2 === toCompare.y2 && triangle.x3 === toCompare.x3 && triangle.y3 === toCompare.y3;
            };
            module1.exports = Equals;
        /***/ },
        /* 1305 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(67);
            /**
 * Gets the length of the perimeter of the given triangle.
 * Calculated by adding together the length of each of the three sides.
 *
 * @function Phaser.Geom.Triangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the length from.
 *
 * @return {number} The length of the Triangle.
 */ var Perimeter = function(triangle) {
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                return Length(line1) + Length(line2) + Length(line3);
            };
            module1.exports = Perimeter;
        /***/ },
        /* 1306 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(238);
            var InCenter = __webpack_require__(506);
            /**
 * Rotates a Triangle about its incenter, which is the point at which its three angle bisectors meet.
 *
 * @function Phaser.Geom.Triangle.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var Rotate = function(triangle, angle) {
                var point = InCenter(triangle);
                return RotateAroundXY(triangle, point.x, point.y, angle);
            };
            module1.exports = Rotate;
        /***/ },
        /* 1307 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(238);
            /**
 * Rotates a Triangle at a certain angle about a given Point or object with public `x` and `y` properties.
 *
 * @function Phaser.Geom.Triangle.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {Phaser.Geom.Point} point - The Point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundPoint = function(triangle, point, angle) {
                return RotateAroundXY(triangle, point.x, point.y, angle);
            };
            module1.exports = RotateAroundPoint;
        /***/ },
        /* 1308 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(203);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Input
 */ var Input = {
                CreatePixelPerfectHandler: __webpack_require__(507),
                CreateInteractiveObject: __webpack_require__(508),
                Events: __webpack_require__(51),
                Gamepad: __webpack_require__(1309),
                InputManager: __webpack_require__(409),
                InputPlugin: __webpack_require__(1321),
                InputPluginCache: __webpack_require__(153),
                Keyboard: __webpack_require__(1322),
                Mouse: __webpack_require__(1336),
                Pointer: __webpack_require__(412),
                Touch: __webpack_require__(1337)
            };
            //   Merge in the consts
            Input = Extend(false, Input, CONST);
            module1.exports = Input;
        /***/ },
        /* 1309 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad
 */ module1.exports = {
                Axis: __webpack_require__(509),
                Button: __webpack_require__(510),
                Events: __webpack_require__(239),
                Gamepad: __webpack_require__(511),
                GamepadPlugin: __webpack_require__(1316),
                Configs: __webpack_require__(1317)
            };
        /***/ },
        /* 1310 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a button has been pressed on any active Gamepad.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.on('down', listener)`.
 * 
 * You can also listen for a DOWN event from a Gamepad instance. See the [GAMEPAD_BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_DOWN
 * @since 3.10.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was pressed.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = "down";
        /***/ },
        /* 1311 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a button has been released on any active Gamepad.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.on('up', listener)`.
 * 
 * You can also listen for an UP event from a Gamepad instance. See the [GAMEPAD_BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_UP
 * @since 3.10.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was released.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = "up";
        /***/ },
        /* 1312 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Connected Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been connected.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.once('connected', listener)`.
 * 
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * @event Phaser.Input.Gamepad.Events#CONNECTED
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was connected.
 * @param {Event} event - The native DOM Event that triggered the connection.
 */ module1.exports = "connected";
        /***/ },
        /* 1313 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Disconnected Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been disconnected.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.once('disconnected', listener)`.
 *
 * @event Phaser.Input.Gamepad.Events#DISCONNECTED
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was disconnected.
 * @param {Event} event - The native DOM Event that triggered the disconnection.
 */ module1.exports = "disconnected";
        /***/ },
        /* 1314 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 * 
 * This event is dispatched by a Gamepad instance when a button has been pressed on it.
 * 
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('down', listener)`.
 * 
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 * 
 * You can also listen for a DOWN event from the Gamepad Plugin. See the [BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
 * @since 3.10.0
 * 
 * @param {number} index - The index of the button that was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 */ module1.exports = "down";
        /***/ },
        /* 1315 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 * 
 * This event is dispatched by a Gamepad instance when a button has been released on it.
 * 
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('up', listener)`.
 * 
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 * 
 * You can also listen for an UP event from the Gamepad Plugin. See the [BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
 * @since 3.10.0
 * 
 * @param {number} index - The index of the button that was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 */ module1.exports = "up";
        /***/ },
        /* 1316 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(239);
            var Gamepad = __webpack_require__(511);
            var GetValue = __webpack_require__(6);
            var InputPluginCache = __webpack_require__(153);
            var InputEvents = __webpack_require__(51);
            /**
 * @classdesc
 * The Gamepad Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Gamepad Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.gamepad`.
 *
 * To listen for a gamepad being connected:
 *
 * ```javascript
 * this.input.gamepad.once('connected', function (pad) {
 *     //   'pad' is a reference to the gamepad that was just connected
 * });
 * ```
 *
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * Once you have received the connected event, or polled the gamepads and found them enabled, you can access
 * them via the built-in properties `GamepadPlugin.pad1` to `pad4`, for up to 4 game pads. With a reference
 * to the gamepads you can poll its buttons and axis sticks. See the properties and methods available on
 * the `Gamepad` class for more details.
 *
 * As of September 2020 Chrome, and likely other browsers, will soon start to require that games requesting
 * access to the Gamepad API are running under SSL. They will actively block API access if they are not.
 *
 * For more information about Gamepad support in browsers see the following resources:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
 * https://www.smashingmagazine.com/2015/11/gamepad-api-in-web-games/
 * http://html5gamepad.com/
 *
 * @class GamepadPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var GamepadPlugin = new Class({
                Extends: EventEmitter,
                initialize: function GamepadPlugin(sceneInputPlugin) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                    /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                    /**
         * A boolean that controls if the Gamepad Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                    /**
         * The Gamepad Event target, as defined in the Game Config.
         * Typically the browser window, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#target
         * @type {any}
         * @since 3.10.0
         */ this.target;
                    /**
         * An array of the connected Gamepads.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#gamepads
         * @type {Phaser.Input.Gamepad.Gamepad[]}
         * @default []
         * @since 3.10.0
         */ this.gamepads = [];
                    /**
         * An internal event queue.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#queue
         * @type {GamepadEvent[]}
         * @private
         * @since 3.10.0
         */ this.queue = [];
                    /**
         * Internal event handler.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#onGamepadHandler
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.onGamepadHandler;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad1
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad1;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad2
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad2;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad3
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad3;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad4
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad4;
                    sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                    sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                    var game = this.scene.sys.game;
                    var settings = this.settings.input;
                    var config = game.config;
                    this.enabled = GetValue(settings, "gamepad", config.inputGamepad) && game.device.input.gamepads;
                    this.target = GetValue(settings, "gamepad.target", config.inputGamepadEventTarget);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                    if (this.enabled) {
                        this.startListeners();
                        this.refreshPads();
                    }
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * Starts the Gamepad Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#startListeners
     * @private
     * @since 3.10.0
     */ startListeners: function() {
                    var _this = this;
                    var target = this.target;
                    var handler = function(event) {
                        if (event.defaultPrevented || !_this.isActive()) // Do nothing if event already handled
                        return;
                        _this.refreshPads();
                        _this.queue.push(event);
                    };
                    this.onGamepadHandler = handler;
                    target.addEventListener("gamepadconnected", handler, false);
                    target.addEventListener("gamepaddisconnected", handler, false);
                    //  FF also supports gamepadbuttondown, gamepadbuttonup and gamepadaxismove but
                    //  nothing else does, and we can get those values via the gamepads anyway, so we will
                    //  until more browsers support this
                    //  Finally, listen for an update event from the Input Plugin
                    this.sceneInputPlugin.pluginEvents.on(InputEvents.UPDATE, this.update, this);
                },
                /**
     * Stops the Gamepad Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#stopListeners
     * @private
     * @since 3.10.0
     */ stopListeners: function() {
                    this.target.removeEventListener("gamepadconnected", this.onGamepadHandler);
                    this.target.removeEventListener("gamepaddisconnected", this.onGamepadHandler);
                    this.sceneInputPlugin.pluginEvents.off(InputEvents.UPDATE, this.update);
                    for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].removeAllListeners();
                },
                /**
     * Disconnects all current Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#disconnectAll
     * @since 3.10.0
     */ disconnectAll: function() {
                    for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].pad.connected = false;
                },
                /**
     * Refreshes the list of connected Gamepads.
     *
     * This is called automatically when a gamepad is connected or disconnected,
     * and during the update loop.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#refreshPads
     * @private
     * @since 3.10.0
     */ refreshPads: function() {
                    var connectedPads = navigator.getGamepads();
                    if (!connectedPads) this.disconnectAll();
                    else {
                        var currentPads = this.gamepads;
                        for(var i = 0; i < connectedPads.length; i++){
                            var livePad = connectedPads[i];
                            //  Because sometimes they're null (yes, really)
                            if (!livePad) continue;
                            var id = livePad.id;
                            var index = livePad.index;
                            var currentPad = currentPads[index];
                            if (!currentPad) {
                                //  A new Gamepad, not currently stored locally
                                var newPad = new Gamepad(this, livePad);
                                currentPads[index] = newPad;
                                if (!this._pad1) this._pad1 = newPad;
                                else if (!this._pad2) this._pad2 = newPad;
                                else if (!this._pad3) this._pad3 = newPad;
                                else if (!this._pad4) this._pad4 = newPad;
                            } else if (currentPad.id !== id) {
                                //  A new Gamepad with a different vendor string, but it has got the same index as an old one
                                currentPad.destroy();
                                currentPads[index] = new Gamepad(this, livePad);
                            } else //  If neither of these, it's a pad we've already got, so update it
                            currentPad.update(livePad);
                        }
                    }
                },
                /**
     * Returns an array of all currently connected Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getAll
     * @since 3.10.0
     *
     * @return {Phaser.Input.Gamepad.Gamepad[]} An array of all currently connected Gamepads.
     */ getAll: function() {
                    var out = [];
                    var pads = this.gamepads;
                    for(var i = 0; i < pads.length; i++)if (pads[i]) out.push(pads[i]);
                    return out;
                },
                /**
     * Looks-up a single Gamepad based on the given index value.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getPad
     * @since 3.10.0
     *
     * @param {number} index - The index of the Gamepad to get.
     *
     * @return {Phaser.Input.Gamepad.Gamepad} The Gamepad matching the given index, or undefined if none were found.
     */ getPad: function(index) {
                    var pads = this.gamepads;
                    for(var i = 0; i < pads.length; i++){
                        if (pads[i] && pads[i].index === index) return pads[i];
                    }
                },
                /**
     * The internal update loop. Refreshes all connected gamepads and processes their events.
     *
     * Called automatically by the Input Manager, invoked from the Game step.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#update
     * @private
     * @fires Phaser.Input.Gamepad.Events#CONNECTED
     * @fires Phaser.Input.Gamepad.Events#DISCONNECTED
     * @since 3.10.0
     */ update: function() {
                    if (!this.enabled) return;
                    this.refreshPads();
                    var len = this.queue.length;
                    if (len === 0) return;
                    var queue = this.queue.splice(0, len);
                    //  Process the event queue, dispatching all of the events that have stored up
                    for(var i = 0; i < len; i++){
                        var event = queue[i];
                        var pad = this.getPad(event.gamepad.index);
                        if (event.type === "gamepadconnected") this.emit(Events.CONNECTED, pad, event);
                        else if (event.type === "gamepaddisconnected") this.emit(Events.DISCONNECTED, pad, event);
                    }
                },
                /**
     * Shuts the Gamepad Plugin down.
     * All this does is remove any listeners bound to it.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                    this.stopListeners();
                    this.removeAllListeners();
                },
                /**
     * Destroys this Gamepad Plugin, disconnecting all Gamepads and releasing internal references.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                    this.shutdown();
                    for(var i = 0; i < this.gamepads.length; i++)if (this.gamepads[i]) this.gamepads[i].destroy();
                    this.gamepads = [];
                    this.scene = null;
                    this.settings = null;
                    this.sceneInputPlugin = null;
                    this.target = null;
                },
                /**
     * The total number of connected game pads.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#total
     * @type {number}
     * @since 3.10.0
     */ total: {
                    get: function() {
                        return this.gamepads.length;
                    }
                },
                /**
     * A reference to the first connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad1
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad1: {
                    get: function() {
                        return this._pad1;
                    }
                },
                /**
     * A reference to the second connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad2
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad2: {
                    get: function() {
                        return this._pad2;
                    }
                },
                /**
     * A reference to the third connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad3
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad3: {
                    get: function() {
                        return this._pad3;
                    }
                },
                /**
     * A reference to the fourth connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad4
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad4: {
                    get: function() {
                        return this._pad4;
                    }
                }
            });
            /**
 * An instance of the Gamepad Plugin class, if enabled via the `input.gamepad` Scene or Game Config property.
 * Use this to create access Gamepads connected to the browser and respond to gamepad buttons.
 *
 * @name Phaser.Input.InputPlugin#gamepad
 * @type {?Phaser.Input.Gamepad.GamepadPlugin}
 * @since 3.10.0
 */ InputPluginCache.register("GamepadPlugin", GamepadPlugin, "gamepad", "gamepad", "inputGamepad");
            module1.exports = GamepadPlugin;
        /***/ },
        /* 1317 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Configs
 */ module1.exports = {
                DUALSHOCK_4: __webpack_require__(1318),
                SNES_USB: __webpack_require__(1319),
                XBOX_360: __webpack_require__(1320)
            };
        /***/ },
        /* 1318 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * PlayStation DualShock 4 Gamepad Configuration.
 * Sony PlayStation DualShock 4 (v2) wireless controller
 *
 * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SHARE: 8,
                OPTIONS: 9,
                PS: 16,
                TOUCHBAR: 17,
                X: 0,
                CIRCLE: 1,
                SQUARE: 2,
                TRIANGLE: 3,
                L1: 4,
                R1: 5,
                L2: 6,
                R2: 7,
                L3: 10,
                R3: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        /***/ },
        /* 1319 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tatar SNES USB Controller Gamepad Configuration.
 * USB Gamepad  (STANDARD GAMEPAD Vendor: 0079 Product: 0011)
 *
 * @name Phaser.Input.Gamepad.Configs.SNES_USB
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SELECT: 8,
                START: 9,
                B: 0,
                A: 1,
                Y: 2,
                X: 3,
                LEFT_SHOULDER: 4,
                RIGHT_SHOULDER: 5
            };
        /***/ },
        /* 1320 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * XBox 360 Gamepad Configuration.
 *
 * @name Phaser.Input.Gamepad.Configs.XBOX_360
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                MENU: 16,
                A: 0,
                B: 1,
                X: 2,
                Y: 3,
                LB: 4,
                RB: 5,
                LT: 6,
                RT: 7,
                BACK: 8,
                START: 9,
                LS: 10,
                RS: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        /***/ },
        /* 1321 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(65);
            var CircleContains = __webpack_require__(66);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(203);
            var CreateInteractiveObject = __webpack_require__(508);
            var CreatePixelPerfectHandler = __webpack_require__(507);
            var DistanceBetween = __webpack_require__(50);
            var Ellipse = __webpack_require__(111);
            var EllipseContains = __webpack_require__(112);
            var Events = __webpack_require__(51);
            var EventEmitter = __webpack_require__(9);
            var GetFastValue = __webpack_require__(2);
            var GEOM_CONST = __webpack_require__(56);
            var InputPluginCache = __webpack_require__(153);
            var IsPlainObject = __webpack_require__(7);
            var PluginCache = __webpack_require__(24);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(57);
            var SceneEvents = __webpack_require__(20);
            var Triangle = __webpack_require__(82);
            var TriangleContains = __webpack_require__(115);
            /**
 * @classdesc
 * The Input Plugin belongs to a Scene and handles all input related events and operations for it.
 *
 * You can access it from within a Scene using `this.input`.
 *
 * It emits events directly. For example, you can do:
 *
 * ```javascript
 * this.input.on('pointerdown', callback, context);
 * ```
 *
 * To listen for a pointer down event anywhere on the game canvas.
 *
 * Game Objects can be enabled for input by calling their `setInteractive` method. After which they
 * will directly emit input events:
 *
 * ```javascript
 * var sprite = this.add.sprite(x, y, texture);
 * sprite.setInteractive();
 * sprite.on('pointerdown', callback, context);
 * ```
 *
 * There are lots of game configuration options available relating to input.
 * See the [Input Config object]{@linkcode Phaser.Types.Core.InputConfig} for more details, including how to deal with Phaser
 * listening for input events outside of the canvas, how to set a default number of pointers, input
 * capture settings and more.
 *
 * Please also see the Input examples and tutorials for further information.
 *
 * **Incorrect input coordinates with Angular**
 *
 * If you are using Phaser within Angular, and use nglf or the router, to make the component in which the Phaser game resides
 * change state (i.e. appear or disappear) then you'll need to notify the Scale Manager about this, as Angular will mess with
 * the DOM in a way in which Phaser can't detect directly. Call `this.scale.updateBounds()` as part of your game init in order
 * to refresh the canvas DOM bounds values, which Phaser uses for input point position calculations.
 *
 * @class InputPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this Input Plugin is responsible for.
 */ var InputPlugin = new Class({
                Extends: EventEmitter,
                initialize: function InputPlugin(scene) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.InputPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems class.
         *
         * @name Phaser.Input.InputPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.InputPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.5.0
         */ this.settings = scene.sys.settings;
                    /**
         * A reference to the Game Input Manager.
         *
         * @name Phaser.Input.InputPlugin#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.input;
                    /**
         * Internal event queue used for plugins only.
         *
         * @name Phaser.Input.InputPlugin#pluginEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.10.0
         */ this.pluginEvents = new EventEmitter();
                    /**
         * If `true` this Input Plugin will process DOM input events.
         *
         * @name Phaser.Input.InputPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.5.0
         */ this.enabled = true;
                    /**
         * A reference to the Scene Display List. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Cameras Manager. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    //  Inject the available input plugins into this class
                    InputPluginCache.install(this);
                    /**
         * A reference to the Mouse Manager.
         *
         * This property is only set if Mouse support has been enabled in your Game Configuration file.
         *
         * If you just wish to get access to the mouse pointer, use the `mousePointer` property instead.
         *
         * @name Phaser.Input.InputPlugin#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = this.manager.mouse;
                    /**
         * When set to `true` (the default) the Input Plugin will emulate DOM behavior by only emitting events from
         * the top-most Game Objects in the Display List.
         *
         * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
         *
         * @name Phaser.Input.InputPlugin#topOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.topOnly = true;
                    /**
         * How often should the Pointers be checked?
         *
         * The value is a time, given in ms, and is the time that must have elapsed between game steps before
         * the Pointers will be polled again. When a pointer is polled it runs a hit test to see which Game
         * Objects are currently below it, or being interacted with it.
         *
         * Pointers will *always* be checked if they have been moved by the user, or press or released.
         *
         * This property only controls how often they will be polled if they have not been updated.
         * You should set this if you want to have Game Objects constantly check against the pointers, even
         * if the pointer didn't itself move.
         *
         * Set to 0 to poll constantly. Set to -1 to only poll on user movement.
         *
         * @name Phaser.Input.InputPlugin#pollRate
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.pollRate = -1;
                    /**
         * Internal poll timer value.
         *
         * @name Phaser.Input.InputPlugin#_pollTimer
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pollTimer = 0;
                    var _eventData = {
                        cancelled: false
                    };
                    /**
         * Internal event propagation callback container.
         *
         * @name Phaser.Input.InputPlugin#_eventContainer
         * @type {Phaser.Types.Input.EventData}
         * @private
         * @since 3.13.0
         */ this._eventContainer = {
                        stopPropagation: function() {
                            _eventData.cancelled = true;
                        }
                    };
                    /**
         * Internal event propagation data object.
         *
         * @name Phaser.Input.InputPlugin#_eventData
         * @type {object}
         * @private
         * @since 3.13.0
         */ this._eventData = _eventData;
                    /**
         * The distance, in pixels, a pointer has to move while being held down, before it thinks it is being dragged.
         *
         * @name Phaser.Input.InputPlugin#dragDistanceThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragDistanceThreshold = 0;
                    /**
         * The amount of time, in ms, a pointer has to be held down before it thinks it is dragging.
         *
         * The default polling rate is to poll only on move so once the time threshold is reached the
         * drag event will not start until you move the mouse. If you want it to start immediately
         * when the time threshold is reached, you must increase the polling rate by calling
         * [setPollAlways]{@linkcode Phaser.Input.InputPlugin#setPollAlways} or
         * [setPollRate]{@linkcode Phaser.Input.InputPlugin#setPollRate}.
         *
         * @name Phaser.Input.InputPlugin#dragTimeThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragTimeThreshold = 0;
                    /**
         * Used to temporarily store the results of the Hit Test
         *
         * @name Phaser.Input.InputPlugin#_temp
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._temp = [];
                    /**
         * Used to temporarily store the results of the Hit Test dropZones
         *
         * @name Phaser.Input.InputPlugin#_tempZones
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempZones = [];
                    /**
         * A list of all Game Objects that have been set to be interactive in the Scene this Input Plugin is managing.
         *
         * @name Phaser.Input.InputPlugin#_list
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._list = [];
                    /**
         * Objects waiting to be inserted to the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingInsertion
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                    /**
         * Objects waiting to be removed from the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingRemoval
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                    /**
         * A list of all Game Objects that have been enabled for dragging.
         *
         * @name Phaser.Input.InputPlugin#_draggable
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._draggable = [];
                    /**
         * A list of all Interactive Objects currently considered as being 'draggable' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_drag
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._drag = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    };
                    /**
         * A array containing the dragStates, for this Scene, index by the Pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_dragState
         * @type {number[]}
         * @private
         * @since 3.16.0
         */ this._dragState = [];
                    /**
         * A list of all Interactive Objects currently considered as being 'over' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_over
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._over = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    };
                    /**
         * A list of valid DOM event types.
         *
         * @name Phaser.Input.InputPlugin#_validTypes
         * @type {string[]}
         * @private
         * @since 3.0.0
         */ this._validTypes = [
                        "onDown",
                        "onUp",
                        "onOver",
                        "onOut",
                        "onMove",
                        "onDragStart",
                        "onDrag",
                        "onDragEnd",
                        "onDragEnter",
                        "onDragLeave",
                        "onDragOver",
                        "onDrop"
                    ];
                    /**
         * Internal property that tracks frame event state.
         *
         * @name Phaser.Input.InputPlugin#_updatedThisFrame
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._updatedThisFrame = false;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#boot
     * @fires Phaser.Input.Events#BOOT
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.cameras = this.systems.cameras;
                    this.displayList = this.systems.displayList;
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.BOOT);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#start
     * @fires Phaser.Input.Events#START
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.TRANSITION_START, this.transitionIn, this);
                    eventEmitter.on(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                    eventEmitter.on(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.manager.events.on(Events.GAME_OUT, this.onGameOut, this);
                    this.manager.events.on(Events.GAME_OVER, this.onGameOver, this);
                    this.enabled = true;
                    //  Populate the pointer drag states
                    this._dragState = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.START);
                },
                /**
     * Game Over handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.2
     */ onGameOver: function(event) {
                    if (this.isActive()) this.emit(Events.GAME_OVER, event.timeStamp, event);
                },
                /**
     * Game Out handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.2
     */ onGameOut: function(event) {
                    if (this.isActive()) this.emit(Events.GAME_OUT, event.timeStamp, event);
                },
                /**
     * The pre-update handler is responsible for checking the pending removal and insertion lists and
     * deleting old Game Objects.
     *
     * @method Phaser.Input.InputPlugin#preUpdate
     * @private
     * @fires Phaser.Input.Events#PRE_UPDATE
     * @since 3.0.0
     */ preUpdate: function() {
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.PRE_UPDATE);
                    var removeList = this._pendingRemoval;
                    var insertList = this._pendingInsertion;
                    var toRemove = removeList.length;
                    var toInsert = insertList.length;
                    if (toRemove === 0 && toInsert === 0) //  Quick bail
                    return;
                    var current = this._list;
                    //  Delete old gameObjects
                    for(var i = 0; i < toRemove; i++){
                        var gameObject = removeList[i];
                        var index = current.indexOf(gameObject);
                        if (index > -1) {
                            current.splice(index, 1);
                            this.clear(gameObject, true);
                        }
                    }
                    //  Clear the removal list
                    removeList.length = 0;
                    this._pendingRemoval.length = 0;
                    //  Move pendingInsertion to list (also clears pendingInsertion at the same time)
                    this._list = current.concat(insertList.splice(0));
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.InputPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * This is called automatically by the Input Manager.
     * It emits events for plugins to listen to and also handles polling updates, if enabled.
     *
     * @method Phaser.Input.InputPlugin#updatePoll
     * @since 3.18.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ updatePoll: function(time, delta) {
                    if (!this.isActive()) return false;
                    //  The plugins should update every frame, regardless if there has been
                    //  any DOM input events or not (such as the Gamepad and Keyboard)
                    this.pluginEvents.emit(Events.UPDATE, time, delta);
                    //  We can leave now if we've already updated once this frame via the immediate DOM event handlers
                    if (this._updatedThisFrame) {
                        this._updatedThisFrame = false;
                        return false;
                    }
                    var i;
                    var manager = this.manager;
                    var pointers = manager.pointers;
                    var pointersTotal = manager.pointersTotal;
                    for(i = 0; i < pointersTotal; i++)pointers[i].updateMotion();
                    //  No point going any further if there aren't any interactive objects
                    if (this._list.length === 0) return false;
                    var rate = this.pollRate;
                    if (rate === -1) return false;
                    else if (rate > 0) {
                        this._pollTimer -= delta;
                        if (this._pollTimer < 0) //  Discard timer diff, we're ready to poll again
                        this._pollTimer = this.pollRate;
                        else //  Not enough time has elapsed since the last poll, so abort now
                        return false;
                    }
                    //  We got this far? Then we should poll for movement
                    var captured = false;
                    for(i = 0; i < pointersTotal; i++){
                        var total = 0;
                        var pointer = pointers[i];
                        //  Always reset this array
                        this._tempZones = [];
                        //  _temp contains a hit tested and camera culled list of IO objects
                        this._temp = this.hitTestPointer(pointer);
                        this.sortGameObjects(this._temp, pointer);
                        this.sortDropZones(this._tempZones);
                        if (this.topOnly) {
                            //  Only the top-most one counts now, so safely ignore the rest
                            if (this._temp.length) this._temp.splice(1);
                            if (this._tempZones.length) this._tempZones.splice(1);
                        }
                        total += this.processOverOutEvents(pointer);
                        if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, time);
                        if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                        captured = true;
                    }
                    return captured;
                },
                /**
     * This method is called when a DOM Event is received by the Input Manager. It handles dispatching the events
     * to relevant input enabled Game Objects in this scene.
     *
     * @method Phaser.Input.InputPlugin#update
     * @private
     * @fires Phaser.Input.Events#UPDATE
     * @since 3.0.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     *
     * @return {boolean} `true` if this Scene has captured the input events from all other Scenes, otherwise `false`.
     */ update: function(type, pointers) {
                    if (!this.isActive()) return false;
                    var pointersTotal = pointers.length;
                    var captured = false;
                    for(var i = 0; i < pointersTotal; i++){
                        var total = 0;
                        var pointer = pointers[i];
                        //  Always reset this array
                        this._tempZones = [];
                        //  _temp contains a hit tested and camera culled list of IO objects
                        this._temp = this.hitTestPointer(pointer);
                        this.sortGameObjects(this._temp, pointer);
                        this.sortDropZones(this._tempZones);
                        if (this.topOnly) {
                            //  Only the top-most one counts now, so safely ignore the rest
                            if (this._temp.length) this._temp.splice(1);
                            if (this._tempZones.length) this._tempZones.splice(1);
                        }
                        switch(type){
                            case CONST.MOUSE_DOWN:
                                total += this.processDragDownEvent(pointer);
                                total += this.processDownEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.MOUSE_UP:
                                total += this.processDragUpEvent(pointer);
                                total += this.processUpEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.TOUCH_START:
                                total += this.processDragDownEvent(pointer);
                                total += this.processDownEvents(pointer);
                                total += this.processOverEvents(pointer);
                                break;
                            case CONST.TOUCH_END:
                            case CONST.TOUCH_CANCEL:
                                total += this.processDragUpEvent(pointer);
                                total += this.processUpEvents(pointer);
                                total += this.processOutEvents(pointer);
                                break;
                            case CONST.MOUSE_MOVE:
                            case CONST.TOUCH_MOVE:
                                total += this.processDragMoveEvent(pointer);
                                total += this.processMoveEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.MOUSE_WHEEL:
                                total += this.processWheelEvent(pointer);
                                break;
                        }
                        if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                        captured = true;
                    }
                    this._updatedThisFrame = true;
                    return captured;
                },
                /**
     * Clears a Game Object so it no longer has an Interactive Object associated with it.
     * The Game Object is then queued for removal from the Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#clear
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have its Interactive Object removed.
     * @param {boolean} [skipQueue=false] - Skip adding this Game Object into the removal queue?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that had its Interactive Object removed.
     */ clear: function(gameObject, skipQueue) {
                    if (skipQueue === undefined) skipQueue = false;
                    var input = gameObject.input;
                    // If GameObject.input already cleared from higher class
                    if (!input) return;
                    if (!skipQueue) this.queueForRemoval(gameObject);
                    input.gameObject = undefined;
                    input.target = undefined;
                    input.hitArea = undefined;
                    input.hitAreaCallback = undefined;
                    input.callbackContext = undefined;
                    gameObject.input = null;
                    //  Clear from _draggable, _drag and _over
                    var index = this._draggable.indexOf(gameObject);
                    if (index > -1) this._draggable.splice(index, 1);
                    index = this._drag[0].indexOf(gameObject);
                    if (index > -1) this._drag[0].splice(index, 1);
                    index = this._over[0].indexOf(gameObject);
                    if (index > -1) {
                        this._over[0].splice(index, 1);
                        this.manager.resetCursor(input);
                    }
                    return gameObject;
                },
                /**
     * Disables Input on a single Game Object.
     *
     * An input disabled Game Object still retains its Interactive Object component and can be re-enabled
     * at any time, by passing it to `InputPlugin.enable`.
     *
     * @method Phaser.Input.InputPlugin#disable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its input system disabled.
     */ disable: function(gameObject) {
                    gameObject.input.enabled = false;
                },
                /**
     * Enable a Game Object for interaction.
     *
     * If the Game Object already has an Interactive Object component, it is enabled and returned.
     *
     * Otherwise, a new Interactive Object component is created and assigned to the Game Object's `input` property.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @method Phaser.Input.InputPlugin#enable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to be enabled for input.
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     * @param {boolean} [dropZone=false] - Is this Game Object a drop zone or not?
     *
     * @return {this} This Input Plugin.
     */ enable: function(gameObject, hitArea, hitAreaCallback, dropZone) {
                    if (dropZone === undefined) dropZone = false;
                    if (gameObject.input) //  If it is already has an InteractiveObject then just enable it and return
                    gameObject.input.enabled = true;
                    else //  Create an InteractiveObject and enable it
                    this.setHitArea(gameObject, hitArea, hitAreaCallback);
                    if (gameObject.input && dropZone && !gameObject.input.dropZone) gameObject.input.dropZone = dropZone;
                    return this;
                },
                /**
     * Takes the given Pointer and performs a hit test against it, to see which interactive Game Objects
     * it is currently above.
     *
     * The hit test is performed against which-ever Camera the Pointer is over. If it is over multiple
     * cameras, it starts checking the camera at the top of the camera list, and if nothing is found, iterates down the list.
     *
     * @method Phaser.Input.InputPlugin#hitTestPointer
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of all the interactive Game Objects the Pointer was above.
     */ hitTestPointer: function(pointer) {
                    var cameras = this.cameras.getCamerasBelowPointer(pointer);
                    for(var c = 0; c < cameras.length; c++){
                        var camera = cameras[c];
                        //  Get a list of all objects that can be seen by the camera below the pointer in the scene and store in 'over' array.
                        //  All objects in this array are input enabled, as checked by the hitTest method, so we don't need to check later on as well.
                        var over = this.manager.hitTest(pointer, this._list, camera);
                        //  Filter out the drop zones
                        for(var i = 0; i < over.length; i++){
                            var obj = over[i];
                            if (obj.input.dropZone) this._tempZones.push(obj);
                        }
                        if (over.length > 0) {
                            pointer.camera = camera;
                            return over;
                        }
                    }
                    //  If we got this far then there were no Game Objects below the pointer, but it was still over
                    //  a camera, so set that the top-most one into the pointer
                    pointer.camera = cameras[0];
                    return [];
                },
                /**
     * An internal method that handles the Pointer down event.
     *
     * @method Phaser.Input.InputPlugin#processDownEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
     * @fires Phaser.Input.Events#GAMEOBJECT_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer being tested.
     *
     * @return {number} The total number of objects interacted with.
     */ processDownEvents: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_DOWN, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_DOWN, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    //  If they released outside the canvas, but pressed down inside it, we'll still dispatch the event.
                    if (!aborted && this.manager) {
                        if (pointer.downElement === this.manager.game.canvas) this.emit(Events.POINTER_DOWN, pointer, currentlyOver);
                        else this.emit(Events.POINTER_DOWN_OUTSIDE, pointer);
                    }
                    return total;
                },
                /**
     * Returns the drag state of the given Pointer for this Input Plugin.
     *
     * The state will be one of the following:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#getDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to get the drag state for.
     *
     * @return {number} The drag state of the given Pointer.
     */ getDragState: function(pointer) {
                    return this._dragState[pointer.id];
                },
                /**
     * Sets the drag state of the given Pointer for this Input Plugin.
     *
     * The state must be one of the following values:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#setDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to set the drag state for.
     * @param {number} state - The drag state value. An integer between 0 and 5.
     */ setDragState: function(pointer, state) {
                    this._dragState[pointer.id] = state;
                },
                /**
     * Checks to see if a Pointer is ready to drag the objects below it, based on either a distance
     * or time threshold.
     *
     * @method Phaser.Input.InputPlugin#processDragThresholdEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check the drag thresholds on.
     * @param {number} time - The current time.
     */ processDragThresholdEvent: function(pointer, time) {
                    var passed = false;
                    var timeThreshold = this.dragTimeThreshold;
                    var distanceThreshold = this.dragDistanceThreshold;
                    if (distanceThreshold > 0 && DistanceBetween(pointer.x, pointer.y, pointer.downX, pointer.downY) >= distanceThreshold) //  It has moved far enough to be considered a drag
                    passed = true;
                    else if (timeThreshold > 0 && time >= pointer.downTime + timeThreshold) //  It has been held down long enough to be considered a drag
                    passed = true;
                    if (passed) {
                        this.setDragState(pointer, 3);
                        return this.processDragStartList(pointer);
                    }
                },
                /**
     * Processes the drag list for the given pointer and dispatches the start events for each object on it.
     *
     * @method Phaser.Input.InputPlugin#processDragStartList
     * @private
     * @fires Phaser.Input.Events#DRAG_START
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_START
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that DRAG_START was called on.
     */ processDragStartList: function(pointer) {
                    //  3 = Pointer meets criteria and is freshly down, notify the draglist
                    if (this.getDragState(pointer) !== 3) return 0;
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        input.dragState = 2;
                        input.dragStartX = gameObject.x;
                        input.dragStartY = gameObject.y;
                        input.dragStartXGlobal = pointer.worldX;
                        input.dragStartYGlobal = pointer.worldY;
                        input.dragX = input.dragStartXGlobal - input.dragStartX;
                        input.dragY = input.dragStartYGlobal - input.dragStartY;
                        gameObject.emit(Events.GAMEOBJECT_DRAG_START, pointer, input.dragX, input.dragY);
                        this.emit(Events.DRAG_START, pointer, gameObject);
                    }
                    this.setDragState(pointer, 4);
                    return list.length;
                },
                /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragDownEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were collected on the drag list.
     */ processDragDownEvent: function(pointer) {
                    var currentlyOver = this._temp;
                    if (this._draggable.length === 0 || currentlyOver.length === 0 || !pointer.primaryDown || this.getDragState(pointer) !== 0) //  There are no draggable items, no over items or the pointer isn't down, so let's not even bother going further
                    return 0;
                    //  1 = Primary button down and objects below, so collect a draglist
                    this.setDragState(pointer, 1);
                    //  Get draggable objects, sort them, pick the top (or all) and store them somewhere
                    var draglist = [];
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (gameObject.input.draggable && gameObject.input.dragState === 0) draglist.push(gameObject);
                    }
                    if (draglist.length === 0) {
                        this.setDragState(pointer, 0);
                        return 0;
                    } else if (draglist.length > 1) {
                        this.sortGameObjects(draglist, pointer);
                        if (this.topOnly) draglist.splice(1);
                    }
                    //  draglist now contains all potential candidates for dragging
                    this._drag[pointer.id] = draglist;
                    if (this.dragDistanceThreshold === 0 && this.dragTimeThreshold === 0) {
                        //  No drag criteria, so snap immediately to mode 3
                        this.setDragState(pointer, 3);
                        return this.processDragStartList(pointer);
                    } else {
                        //  Check the distance / time on the next event
                        this.setDragState(pointer, 2);
                        return 0;
                    }
                },
                /**
     * Processes a 'drag move' event for the given pointer.
     *
     * @method Phaser.Input.InputPlugin#processDragMoveEvent
     * @private
     * @fires Phaser.Input.Events#DRAG_ENTER
     * @fires Phaser.Input.Events#DRAG
     * @fires Phaser.Input.Events#DRAG_LEAVE
     * @fires Phaser.Input.Events#DRAG_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragMoveEvent: function(pointer) {
                    //  2 = Pointer being checked if meets drag criteria
                    if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, this.manager.game.loop.now);
                    if (this.getDragState(pointer) !== 4) return 0;
                    //  4 = Pointer actively dragging the draglist and has moved
                    var dropZones = this._tempZones;
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        var target = input.target;
                        //  If this GO has a target then let's check it
                        if (target) {
                            var index = dropZones.indexOf(target);
                            //  Got a target, are we still over it?
                            if (index === 0) {
                                //  We're still over it, and it's still the top of the display list, phew ...
                                gameObject.emit(Events.GAMEOBJECT_DRAG_OVER, pointer, target);
                                this.emit(Events.DRAG_OVER, pointer, gameObject, target);
                            } else if (index > 0) {
                                //  Still over it but it's no longer top of the display list (targets must always be at the top)
                                gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                input.target = dropZones[0];
                                target = input.target;
                                gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                            } else {
                                //  Nope, we've moved on (or the target has!), leave the old target
                                gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                //  Anything new to replace it?
                                //  Yup!
                                if (dropZones[0]) {
                                    input.target = dropZones[0];
                                    target = input.target;
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                    this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                                } else //  Nope
                                input.target = null;
                            }
                        } else if (!target && dropZones[0]) {
                            input.target = dropZones[0];
                            target = input.target;
                            gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                            this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                        }
                        var dragX;
                        var dragY;
                        if (!gameObject.parentContainer) {
                            dragX = pointer.worldX - input.dragX;
                            dragY = pointer.worldY - input.dragY;
                        } else {
                            var dx = pointer.worldX - input.dragStartXGlobal;
                            var dy = pointer.worldY - input.dragStartYGlobal;
                            var rotation = gameObject.getParentRotation();
                            var dxRotated = dx * Math.cos(rotation) + dy * Math.sin(rotation);
                            var dyRotated = dy * Math.cos(rotation) - dx * Math.sin(rotation);
                            dxRotated *= 1 / gameObject.parentContainer.scaleX;
                            dyRotated *= 1 / gameObject.parentContainer.scaleY;
                            dragX = dxRotated + input.dragStartX;
                            dragY = dyRotated + input.dragStartY;
                        }
                        gameObject.emit(Events.GAMEOBJECT_DRAG, pointer, dragX, dragY);
                        this.emit(Events.DRAG, pointer, gameObject, dragX, dragY);
                    }
                    return list.length;
                },
                /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragUpEvent
     * @fires Phaser.Input.Events#DRAG_END
     * @fires Phaser.Input.Events#DROP
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_END
     * @fires Phaser.Input.Events#GAMEOBJECT_DROP
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragUpEvent: function(pointer) {
                    //  5 = Pointer was actively dragging but has been released, notify draglist
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        if (input && input.dragState === 2) {
                            input.dragState = 0;
                            input.dragX = input.localX - gameObject.displayOriginX;
                            input.dragY = input.localY - gameObject.displayOriginY;
                            var dropped = false;
                            var target = input.target;
                            if (target) {
                                gameObject.emit(Events.GAMEOBJECT_DROP, pointer, target);
                                this.emit(Events.DROP, pointer, gameObject, target);
                                input.target = null;
                                dropped = true;
                            }
                            //  And finally the dragend event
                            if (gameObject.input) {
                                gameObject.emit(Events.GAMEOBJECT_DRAG_END, pointer, input.dragX, input.dragY, dropped);
                                this.emit(Events.DRAG_END, pointer, gameObject, dropped);
                            }
                        }
                    }
                    this.setDragState(pointer, 0);
                    list.splice(0);
                    return 0;
                },
                /**
     * An internal method that handles the Pointer movement event.
     *
     * @method Phaser.Input.InputPlugin#processMoveEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
     * @fires Phaser.Input.Events#GAMEOBJECT_MOVE
     * @fires Phaser.Input.Events#POINTER_MOVE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processMoveEvents: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_MOVE, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_MOVE, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        if (this.topOnly) break;
                    }
                    if (!aborted) this.emit(Events.POINTER_MOVE, pointer, currentlyOver);
                    return total;
                },
                /**
     * An internal method that handles a mouse wheel event.
     *
     * @method Phaser.Input.InputPlugin#processWheelEvent
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
     * @fires Phaser.Input.Events#GAMEOBJECT_WHEEL
     * @fires Phaser.Input.Events#POINTER_WHEEL
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processWheelEvent: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    var dx = pointer.deltaX;
                    var dy = pointer.deltaY;
                    var dz = pointer.deltaZ;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_WHEEL, pointer, dx, dy, dz, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_WHEEL, pointer, gameObject, dx, dy, dz, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    if (!aborted) this.emit(Events.POINTER_WHEEL, pointer, currentlyOver, dx, dy, dz);
                    return total;
                },
                /**
     * An internal method that handles the Pointer over events.
     * This is called when a touch input hits the canvas, having previously been off of it.
     *
     * @method Phaser.Input.InputPlugin#processOverEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var totalInteracted = 0;
                    var total = currentlyOver.length;
                    var justOver = [];
                    if (total > 0) {
                        var manager = this.manager;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        var aborted = false;
                        for(var i = 0; i < total; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input) continue;
                            justOver.push(gameObject);
                            manager.setCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OVER, pointer, justOver);
                    }
                    //  Then sort it into display list order
                    this._over[pointer.id] = justOver;
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer out events.
     * This is called when a touch input leaves the canvas, as it can never be 'over' in this case.
     *
     * @method Phaser.Input.InputPlugin#processOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOutEvents: function(pointer) {
                    var previouslyOver = this._over[pointer.id];
                    var totalInteracted = 0;
                    var total = previouslyOver.length;
                    if (total > 0) {
                        var manager = this.manager;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        var aborted = false;
                        this.sortGameObjects(previouslyOver, pointer);
                        for(var i = 0; i < total; i++){
                            var gameObject = previouslyOver[i];
                            //  Call onOut for everything in the previouslyOver array
                            gameObject = previouslyOver[i];
                            if (!gameObject.input) continue;
                            manager.resetCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            if (!aborted) this.emit(Events.POINTER_OUT, pointer, previouslyOver);
                        }
                        this._over[pointer.id] = [];
                    }
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer over and out events.
     *
     * @method Phaser.Input.InputPlugin#processOverOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverOutEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var i;
                    var gameObject;
                    var justOut = [];
                    var justOver = [];
                    var stillOver = [];
                    var previouslyOver = this._over[pointer.id];
                    var currentlyDragging = this._drag[pointer.id];
                    var manager = this.manager;
                    //  Go through all objects the pointer was previously over, and see if it still is.
                    //  Splits the previouslyOver array into two parts: justOut and stillOver
                    for(i = 0; i < previouslyOver.length; i++){
                        gameObject = previouslyOver[i];
                        if (currentlyOver.indexOf(gameObject) === -1 && currentlyDragging.indexOf(gameObject) === -1) //  Not in the currentlyOver array, so must be outside of this object now
                        justOut.push(gameObject);
                        else //  In the currentlyOver array
                        stillOver.push(gameObject);
                    }
                    //  Go through all objects the pointer is currently over (the hit test results)
                    //  and if not in the previouslyOver array we know it's a new entry, so add to justOver
                    for(i = 0; i < currentlyOver.length; i++){
                        gameObject = currentlyOver[i];
                        //  Is this newly over?
                        if (previouslyOver.indexOf(gameObject) === -1) justOver.push(gameObject);
                    }
                    //  By this point the arrays are filled, so now we can process what happened...
                    //  Process the Just Out objects
                    var total = justOut.length;
                    var totalInteracted = 0;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    if (total > 0) {
                        this.sortGameObjects(justOut, pointer);
                        //  Call onOut for everything in the justOut array
                        for(i = 0; i < total; i++){
                            gameObject = justOut[i];
                            if (!gameObject.input) continue;
                            //  Reset cursor before we emit the event, in case they want to change it during the event
                            manager.resetCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OUT, pointer, justOut);
                    }
                    //  Process the Just Over objects
                    total = justOver.length;
                    _eventData.cancelled = false;
                    aborted = false;
                    if (total > 0) {
                        this.sortGameObjects(justOver, pointer);
                        //  Call onOver for everything in the justOver array
                        for(i = 0; i < total; i++){
                            gameObject = justOver[i];
                            if (!gameObject.input) continue;
                            //  Set cursor before we emit the event, in case they want to change it during the event
                            manager.setCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OVER, pointer, justOver);
                    }
                    //  Add the contents of justOver to the previously over array
                    previouslyOver = stillOver.concat(justOver);
                    //  Then sort it into display list order
                    this._over[pointer.id] = this.sortGameObjects(previouslyOver, pointer);
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer up events.
     *
     * @method Phaser.Input.InputPlugin#processUpEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_UP
     * @fires Phaser.Input.Events#GAMEOBJECT_UP
     * @fires Phaser.Input.Events#POINTER_UP
     * @fires Phaser.Input.Events#POINTER_UP_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processUpEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_UP, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_UP, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    //  If they released outside the canvas, but pressed down inside it, we'll still dispatch the event.
                    if (!aborted && this.manager) {
                        if (pointer.upElement === this.manager.game.canvas) this.emit(Events.POINTER_UP, pointer, currentlyOver);
                        else this.emit(Events.POINTER_UP_OUTSIDE, pointer);
                    }
                    return currentlyOver.length;
                },
                /**
     * Queues a Game Object for insertion into this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForInsertion
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     *
     * @return {this} This InputPlugin object.
     */ queueForInsertion: function(child) {
                    if (this._pendingInsertion.indexOf(child) === -1 && this._list.indexOf(child) === -1) this._pendingInsertion.push(child);
                    return this;
                },
                /**
     * Queues a Game Object for removal from this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForRemoval
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     *
     * @return {this} This InputPlugin object.
     */ queueForRemoval: function(child) {
                    this._pendingRemoval.push(child);
                    return this;
                },
                /**
     * Sets the draggable state of the given array of Game Objects.
     *
     * They can either be set to be draggable, or can have their draggable state removed by passing `false`.
     *
     * A Game Object will not fire drag events unless it has been specifically enabled for drag.
     *
     * @method Phaser.Input.InputPlugin#setDraggable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to change the draggable state on.
     * @param {boolean} [value=true] - Set to `true` if the Game Objects should be made draggable, `false` if they should be unset.
     *
     * @return {this} This InputPlugin object.
     */ setDraggable: function(gameObjects, value) {
                    if (value === undefined) value = true;
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        gameObject.input.draggable = value;
                        var index = this._draggable.indexOf(gameObject);
                        if (value && index === -1) this._draggable.push(gameObject);
                        else if (!value && index > -1) this._draggable.splice(index, 1);
                    }
                    return this;
                },
                /**
     * Creates a function that can be passed to `setInteractive`, `enable` or `setHitArea` that will handle
     * pixel-perfect input detection on an Image or Sprite based Game Object, or any custom class that extends them.
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 1.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect());
     * ```
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 150.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect(150));
     * ```
     *
     * Once you have made an Interactive Object pixel perfect it impacts all input related events for it: down, up,
     * dragstart, drag, etc.
     *
     * As a pointer interacts with the Game Object it will constantly poll the texture, extracting a single pixel from
     * the given coordinates and checking its color values. This is an expensive process, so should only be enabled on
     * Game Objects that really need it.
     *
     * You cannot make non-texture based Game Objects pixel perfect. So this will not work on Graphics, BitmapText,
     * Render Textures, Text, Tilemaps, Containers or Particles.
     *
     * @method Phaser.Input.InputPlugin#makePixelPerfect
     * @since 3.10.0
     *
     * @param {number} [alphaTolerance=1] - The alpha level that the pixel should be above to be included as a successful interaction.
     *
     * @return {function} A Pixel Perfect Handler for use as a hitArea shape callback.
     */ makePixelPerfect: function(alphaTolerance) {
                    if (alphaTolerance === undefined) alphaTolerance = 1;
                    var textureManager = this.systems.textures;
                    return CreatePixelPerfectHandler(textureManager, alphaTolerance);
                },
                /**
     * Sets the hit area for the given array of Game Objects.
     *
     * A hit area is typically one of the geometric shapes Phaser provides, such as a `Phaser.Geom.Rectangle`
     * or `Phaser.Geom.Circle`. However, it can be any object as long as it works with the provided callback.
     *
     * If no hit area is provided a Rectangle is created based on the size of the Game Object, if possible
     * to calculate.
     *
     * The hit area callback is the function that takes an `x` and `y` coordinate and returns a boolean if
     * those values fall within the area of the shape or not. All of the Phaser geometry objects provide this,
     * such as `Phaser.Geom.Rectangle.Contains`.
     *
     * @method Phaser.Input.InputPlugin#setHitArea
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set the hit area on.
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     *
     * @return {this} This InputPlugin object.
     */ setHitArea: function(gameObjects, hitArea, hitAreaCallback) {
                    if (hitArea === undefined) return this.setHitAreaFromTexture(gameObjects);
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    var draggable = false;
                    var dropZone = false;
                    var cursor = false;
                    var useHandCursor = false;
                    var pixelPerfect = false;
                    var customHitArea = true;
                    //  Config object?
                    if (IsPlainObject(hitArea)) {
                        var config = hitArea;
                        hitArea = GetFastValue(config, "hitArea", null);
                        hitAreaCallback = GetFastValue(config, "hitAreaCallback", null);
                        draggable = GetFastValue(config, "draggable", false);
                        dropZone = GetFastValue(config, "dropZone", false);
                        cursor = GetFastValue(config, "cursor", false);
                        useHandCursor = GetFastValue(config, "useHandCursor", false);
                        pixelPerfect = GetFastValue(config, "pixelPerfect", false);
                        var alphaTolerance = GetFastValue(config, "alphaTolerance", 1);
                        if (pixelPerfect) {
                            hitArea = {};
                            hitAreaCallback = this.makePixelPerfect(alphaTolerance);
                        }
                        //  Still no hitArea or callback?
                        if (!hitArea || !hitAreaCallback) {
                            this.setHitAreaFromTexture(gameObjects);
                            customHitArea = false;
                        }
                    } else if (typeof hitArea === "function" && !hitAreaCallback) {
                        hitAreaCallback = hitArea;
                        hitArea = {};
                    }
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        if (pixelPerfect && gameObject.type === "Container") {
                            console.warn("Cannot pixelPerfect test a Container. Use a custom callback.");
                            continue;
                        }
                        var io = !gameObject.input ? CreateInteractiveObject(gameObject, hitArea, hitAreaCallback) : gameObject.input;
                        io.customHitArea = customHitArea;
                        io.dropZone = dropZone;
                        io.cursor = useHandCursor ? "pointer" : cursor;
                        gameObject.input = io;
                        if (draggable) this.setDraggable(gameObject);
                        this.queueForInsertion(gameObject);
                    }
                    return this;
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Circle` shape, using
     * the given coordinates and radius to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaCircle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a circle hit area.
     * @param {number} x - The center of the circle.
     * @param {number} y - The center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Circle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaCircle: function(gameObjects, x, y, radius, callback) {
                    if (callback === undefined) callback = CircleContains;
                    var shape = new Circle(x, y, radius);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Ellipse` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaEllipse
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {number} x - The center of the ellipse.
     * @param {number} y - The center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Ellipse.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaEllipse: function(gameObjects, x, y, width, height, callback) {
                    if (callback === undefined) callback = EllipseContains;
                    var shape = new Ellipse(x, y, width, height);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the Game Objects texture frame to define the position and size of the hit area.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaFromTexture
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaFromTexture: function(gameObjects, callback) {
                    if (callback === undefined) callback = RectangleContains;
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        var frame = gameObject.frame;
                        var width = 0;
                        var height = 0;
                        if (gameObject.width) {
                            width = gameObject.width;
                            height = gameObject.height;
                        } else if (frame) {
                            width = frame.realWidth;
                            height = frame.realHeight;
                        }
                        if (gameObject.type === "Container" && (width === 0 || height === 0)) {
                            console.warn("Container.setInteractive must specify a Shape or call setSize() first");
                            continue;
                        }
                        if (width !== 0 && height !== 0) {
                            gameObject.input = CreateInteractiveObject(gameObject, new Rectangle(0, 0, width, height), callback);
                            this.queueForInsertion(gameObject);
                        }
                    }
                    return this;
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaRectangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a rectangular hit area.
     * @param {number} x - The top-left of the rectangle.
     * @param {number} y - The top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaRectangle: function(gameObjects, x, y, width, height, callback) {
                    if (callback === undefined) callback = RectangleContains;
                    var shape = new Rectangle(x, y, width, height);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Triangle` shape, using
     * the given coordinates to control the position of its points.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaTriangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a  triangular hit area.
     * @param {number} x1 - The x coordinate of the first point of the triangle.
     * @param {number} y1 - The y coordinate of the first point of the triangle.
     * @param {number} x2 - The x coordinate of the second point of the triangle.
     * @param {number} y2 - The y coordinate of the second point of the triangle.
     * @param {number} x3 - The x coordinate of the third point of the triangle.
     * @param {number} y3 - The y coordinate of the third point of the triangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Triangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaTriangle: function(gameObjects, x1, y1, x2, y2, x3, y3, callback) {
                    if (callback === undefined) callback = TriangleContains;
                    var shape = new Triangle(x1, y1, x2, y2, x3, y3);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Creates an Input Debug Shape for the given Game Object.
     *
     * The Game Object must have _already_ been enabled for input prior to calling this method.
     *
     * This is intended to assist you during development and debugging.
     *
     * Debug Shapes can only be created for Game Objects that are using standard Phaser Geometry for input,
     * including: Circle, Ellipse, Line, Polygon, Rectangle and Triangle.
     *
     * Game Objects that are using their automatic hit areas are using Rectangles by default, so will also work.
     *
     * The Debug Shape is created and added to the display list and is then kept in sync with the Game Object
     * it is connected with. Should you need to modify it yourself, such as to hide it, you can access it via
     * the Game Object property: `GameObject.input.hitAreaDebug`.
     *
     * Calling this method on a Game Object that already has a Debug Shape will first destroy the old shape,
     * before creating a new one. If you wish to remove the Debug Shape entirely, you should call the
     * method `InputPlugin.removeDebug`.
     *
     * Note that the debug shape will only show the outline of the input area. If the input test is using a
     * pixel perfect check, for example, then this is not displayed. If you are using a custom shape, that
     * doesn't extend one of the base Phaser Geometry objects, as your hit area, then this method will not
     * work.
     *
     * @method Phaser.Input.InputPlugin#enableDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to create the input debug shape for.
     * @param {number} [color=0x00ff00] - The outline color of the debug shape.
     *
     * @return {this} This Input Plugin.
     */ enableDebug: function(gameObject, color) {
                    if (color === undefined) color = 0x00ff00;
                    var input = gameObject.input;
                    if (!input || !input.hitArea) return this;
                    var shape = input.hitArea;
                    var shapeType = shape.type;
                    var debug = input.hitAreaDebug;
                    var factory = this.systems.add;
                    var updateList = this.systems.updateList;
                    if (debug) {
                        updateList.remove(debug);
                        debug.destroy();
                        debug = null;
                    }
                    var offsetx = 0;
                    var offsety = 0;
                    switch(shapeType){
                        case GEOM_CONST.CIRCLE:
                            debug = factory.arc(0, 0, shape.radius);
                            offsetx = shape.x - shape.radius;
                            offsety = shape.y - shape.radius;
                            break;
                        case GEOM_CONST.ELLIPSE:
                            debug = factory.ellipse(0, 0, shape.width, shape.height);
                            offsetx = shape.x - shape.width / 2;
                            offsety = shape.y - shape.height / 2;
                            break;
                        case GEOM_CONST.LINE:
                            debug = factory.line(0, 0, shape.x1, shape.y1, shape.x2, shape.y2);
                            break;
                        case GEOM_CONST.POLYGON:
                            debug = factory.polygon(0, 0, shape.points);
                            break;
                        case GEOM_CONST.RECTANGLE:
                            debug = factory.rectangle(0, 0, shape.width, shape.height);
                            offsetx = shape.x;
                            offsety = shape.y;
                            break;
                        case GEOM_CONST.TRIANGLE:
                            debug = factory.triangle(0, 0, shape.x1, shape.y1, shape.x2, shape.y2, shape.x3, shape.y3);
                            break;
                    }
                    if (debug) {
                        debug.isFilled = false;
                        debug.preUpdate = function() {
                            debug.setStrokeStyle(1 / gameObject.scale, color);
                            debug.setDisplayOrigin(gameObject.displayOriginX, gameObject.displayOriginY);
                            var x = gameObject.x;
                            var y = gameObject.y;
                            var rotation = gameObject.rotation;
                            var scaleX = gameObject.scaleX;
                            var scaleY = gameObject.scaleY;
                            if (gameObject.parentContainer) {
                                var matrix = gameObject.getWorldTransformMatrix();
                                x = matrix.tx;
                                y = matrix.ty;
                                rotation = matrix.rotation;
                                scaleX = matrix.scaleX;
                                scaleY = matrix.scaleY;
                            }
                            debug.setRotation(rotation);
                            debug.setScale(scaleX, scaleY);
                            debug.setPosition(x + offsetx, y + offsety);
                            debug.setScrollFactor(gameObject.scrollFactorX, gameObject.scrollFactorY);
                            debug.setDepth(gameObject.depth);
                        };
                        updateList.add(debug);
                        input.hitAreaDebug = debug;
                    }
                    return this;
                },
                /**
     * Removes an Input Debug Shape from the given Game Object.
     *
     * The shape is destroyed immediately and the `hitAreaDebug` property is set to `null`.
     *
     * @method Phaser.Input.InputPlugin#removeDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to remove the input debug shape from.
     *
     * @return {this} This Input Plugin.
     */ removeDebug: function(gameObject) {
                    var input = gameObject.input;
                    if (input && input.hitAreaDebug) {
                        var debug = input.hitAreaDebug;
                        this.systems.updateList.remove(debug);
                        debug.destroy();
                        input.hitAreaDebug = null;
                    }
                    return this;
                },
                /**
     * Sets the Pointers to always poll.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it, regardless if the Pointer has actually moved or not.
     *
     * You should enable this if you want objects in your game to fire over / out events, and the objects
     * are constantly moving, but the pointer may not have. Polling every frame has additional computation
     * costs, especially if there are a large number of interactive objects in your game.
     *
     * @method Phaser.Input.InputPlugin#setPollAlways
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollAlways: function() {
                    return this.setPollRate(0);
                },
                /**
     * Sets the Pointers to only poll when they are moved or updated.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it.
     *
     * @method Phaser.Input.InputPlugin#setPollOnMove
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollOnMove: function() {
                    return this.setPollRate(-1);
                },
                /**
     * Sets the poll rate value. This is the amount of time that should have elapsed before a pointer
     * will be polled again. See the `setPollAlways` and `setPollOnMove` methods.
     *
     * @method Phaser.Input.InputPlugin#setPollRate
     * @since 3.0.0
     *
     * @param {number} value - The amount of time, in ms, that should elapsed before re-polling the pointers.
     *
     * @return {this} This InputPlugin object.
     */ setPollRate: function(value) {
                    this.pollRate = value;
                    this._pollTimer = 0;
                    return this;
                },
                /**
     * When set to `true` the global Input Manager will emulate DOM behavior by only emitting events from
     * the top-most Scene in the Scene List. By default, if a Scene receives an input event it will then stop the event
     * from flowing down to any Scenes below it in the Scene list. To disable this behavior call this method with `false`.
     *
     * @method Phaser.Input.InputPlugin#setGlobalTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - Set to `true` to stop processing input events on the Scene that receives it, or `false` to let the event continue down the Scene list.
     *
     * @return {this} This InputPlugin object.
     */ setGlobalTopOnly: function(value) {
                    this.manager.globalTopOnly = value;
                    return this;
                },
                /**
     * When set to `true` this Input Plugin will emulate DOM behavior by only emitting events from
     * the top-most Game Objects in the Display List.
     *
     * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
     *
     * @method Phaser.Input.InputPlugin#setTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to only include the top-most Game Object, or `false` to include all Game Objects in a hit test.
     *
     * @return {this} This InputPlugin object.
     */ setTopOnly: function(value) {
                    this.topOnly = value;
                    return this;
                },
                /**
     * Given an array of Game Objects and a Pointer, sort the array and return it,
     * so that the objects are in render order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortGameObjects
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortGameObjects: function(gameObjects, pointer) {
                    if (gameObjects.length < 2) return gameObjects;
                    var list = pointer.camera.renderList;
                    return gameObjects.sort(function(childA, childB) {
                        return list.indexOf(childB) - list.indexOf(childA);
                    });
                },
                /**
     * Given an array of Drop Zone Game Objects, sort the array and return it,
     * so that the objects are in depth index order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortDropZones
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortDropZones: function(gameObjects) {
                    if (gameObjects.length < 2) return gameObjects;
                    this.scene.sys.depthSort();
                    return gameObjects.sort(this.sortDropZoneHandler.bind(this));
                },
                /**
     * Return the child lowest down the display list (with the smallest index)
     * Will iterate through all parent containers, if present.
     *
     * Prior to version 3.52.0 this method was called `sortHandlerGO`.
     *
     * @method Phaser.Input.InputPlugin#sortDropZoneHandler
     * @private
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object to compare.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object to compare.
     *
     * @return {number} Returns either a negative or positive integer, or zero if they match.
     */ sortDropZoneHandler: function(childA, childB) {
                    if (!childA.parentContainer && !childB.parentContainer) //  Quick bail out when neither child has a container
                    return this.displayList.getIndex(childB) - this.displayList.getIndex(childA);
                    else if (childA.parentContainer === childB.parentContainer) //  Quick bail out when both children have the same container
                    return childB.parentContainer.getIndex(childB) - childA.parentContainer.getIndex(childA);
                    else if (childA.parentContainer === childB) //  Quick bail out when childA is a child of childB
                    return -1;
                    else if (childB.parentContainer === childA) //  Quick bail out when childA is a child of childB
                    return 1;
                    else {
                        //  Container index check
                        var listA = childA.getIndexList();
                        var listB = childB.getIndexList();
                        var len = Math.min(listA.length, listB.length);
                        for(var i = 0; i < len; i++){
                            var indexA = listA[i];
                            var indexB = listB[i];
                            if (indexA === indexB) continue;
                            else //  Non-matching parents, so return
                            return indexB - indexA;
                        }
                        return listB.length - listA.length;
                    }
                    //  Technically this shouldn't happen, but ...
                    // eslint-disable-next-line no-unreachable
                    return 0;
                },
                /**
     * This method should be called from within an input event handler, such as `pointerdown`.
     *
     * When called, it stops the Input Manager from allowing _this specific event_ to be processed by any other Scene
     * not yet handled in the scene list.
     *
     * @method Phaser.Input.InputPlugin#stopPropagation
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ stopPropagation: function() {
                    this.manager._tempSkip = true;
                    return this;
                },
                /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputPlugin#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                    return this.manager.addPointer(quantity);
                },
                /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputPlugin#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     *
     * @return {this} This Input instance.
     */ setDefaultCursor: function(cursor) {
                    this.manager.setDefaultCursor(cursor);
                    return this;
                },
                /**
     * The Scene that owns this plugin is transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionIn
     * @private
     * @since 3.5.0
     */ transitionIn: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                /**
     * The Scene that owns this plugin has finished transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionComplete
     * @private
     * @since 3.5.0
     */ transitionComplete: function() {
                    if (!this.settings.transitionAllowInput) this.enabled = true;
                },
                /**
     * The Scene that owns this plugin is transitioning out.
     *
     * @method Phaser.Input.InputPlugin#transitionOut
     * @private
     * @since 3.5.0
     */ transitionOut: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Input.InputPlugin#shutdown
     * @fires Phaser.Input.Events#SHUTDOWN
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.SHUTDOWN);
                    this._temp.length = 0;
                    this._list.length = 0;
                    this._draggable.length = 0;
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                    this._dragState.length = 0;
                    for(var i = 0; i < 10; i++){
                        this._drag[i] = [];
                        this._over[i] = [];
                    }
                    this.removeAllListeners();
                    var manager = this.manager;
                    manager.canvas.style.cursor = manager.defaultCursor;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.TRANSITION_START, this.transitionIn, this);
                    eventEmitter.off(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                    eventEmitter.off(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    manager.events.off(Events.GAME_OUT, this.onGameOut, this);
                    manager.events.off(Events.GAME_OVER, this.onGameOver, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Input.InputPlugin#destroy
     * @fires Phaser.Input.Events#DESTROY
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.DESTROY);
                    this.pluginEvents.removeAllListeners();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.cameras = null;
                    this.manager = null;
                    this.events = null;
                    this.mouse = null;
                },
                /**
     * The x coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#x
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.manager.activePointer.x;
                    }
                },
                /**
     * The y coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#y
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.manager.activePointer.y;
                    }
                },
                /**
     * Are any mouse or touch pointers currently over the game canvas?
     *
     * @name Phaser.Input.InputPlugin#isOver
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isOver: {
                    get: function() {
                        return this.manager.isOver;
                    }
                },
                /**
     * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
     * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
     * which will always map to the most recently interacted pointer.
     *
     * @name Phaser.Input.InputPlugin#mousePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ mousePointer: {
                    get: function() {
                        return this.manager.mousePointer;
                    }
                },
                /**
     * The current active input Pointer.
     *
     * @name Phaser.Input.InputPlugin#activePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.0.0
     */ activePointer: {
                    get: function() {
                        return this.manager.activePointer;
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer1
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer1: {
                    get: function() {
                        return this.manager.pointers[1];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer2
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer2: {
                    get: function() {
                        return this.manager.pointers[2];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer3
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer3: {
                    get: function() {
                        return this.manager.pointers[3];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer4
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer4: {
                    get: function() {
                        return this.manager.pointers[4];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer5
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer5: {
                    get: function() {
                        return this.manager.pointers[5];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer6
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer6: {
                    get: function() {
                        return this.manager.pointers[6];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer7
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer7: {
                    get: function() {
                        return this.manager.pointers[7];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer8
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer8: {
                    get: function() {
                        return this.manager.pointers[8];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer9
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer9: {
                    get: function() {
                        return this.manager.pointers[9];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer10
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer10: {
                    get: function() {
                        return this.manager.pointers[10];
                    }
                }
            });
            PluginCache.register("InputPlugin", InputPlugin, "input");
            module1.exports = InputPlugin;
        /***/ },
        /* 1322 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard
 */ module1.exports = {
                Events: __webpack_require__(154),
                KeyboardManager: __webpack_require__(410),
                KeyboardPlugin: __webpack_require__(1330),
                Key: __webpack_require__(512),
                KeyCodes: __webpack_require__(143),
                KeyCombo: __webpack_require__(513),
                AdvanceKeyCombo: __webpack_require__(515),
                ProcessKeyCombo: __webpack_require__(514),
                ResetKeyCombo: __webpack_require__(516),
                JustDown: __webpack_require__(1332),
                JustUp: __webpack_require__(1333),
                DownDuration: __webpack_require__(1334),
                UpDuration: __webpack_require__(1335)
            };
        /***/ },
        /* 1323 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Down Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 * 
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keydown', listener)`.
 * 
 * You can also listen for a specific key being pressed. See [Keyboard.Events.KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_DOWN} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 * 
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = "keydown";
        /***/ },
        /* 1324 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Up Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 * 
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keyup', listener)`.
 * 
 * You can also listen for a specific key being released. See [Keyboard.Events.KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_UP} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_UP
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = "keyup";
        /***/ },
        /* 1325 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Combo Match Event.
 * 
 * This event is dispatched by the Keyboard Plugin when a [Key Combo]{@link Phaser.Input.Keyboard.KeyCombo} is matched.
 * 
 * Listen for this event from the Key Plugin after a combo has been created:
 * 
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * @event Phaser.Input.Keyboard.Events#COMBO_MATCH
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.KeyCombo} keycombo - The Key Combo object that was matched.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event of the final key in the combo. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = "keycombomatch";
        /***/ },
        /* 1326 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 * 
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is pressed.
 * 
 * Listen for this event from the Key object instance directly:
 * 
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * 
 * spaceBar.on('down', listener)
 * ```
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 *
 * @event Phaser.Input.Keyboard.Events#DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was pressed.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = "down";
        /***/ },
        /* 1327 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 * 
 * Unlike the `ANY_KEY_DOWN` event, this one has a special dynamic event name. For example, to listen for the `A` key being pressed
 * use the following from within a Scene: `this.input.keyboard.on('keydown-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar: 
 * `this.input.keyboard.on('keydown-SPACE', listener)`.
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 * 
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_DOWN
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = "keydown-";
        /***/ },
        /* 1328 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 * 
 * Unlike the `ANY_KEY_UP` event, this one has a special dynamic event name. For example, to listen for the `A` key being released
 * use the following from within a Scene: `this.input.keyboard.on('keyup-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar: 
 * `this.input.keyboard.on('keyup-SPACE', listener)`.
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_UP
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = "keyup-";
        /***/ },
        /* 1329 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 * 
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is released.
 * 
 * Listen for this event from the Key object instance directly:
 * 
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * 
 * spaceBar.on('up', listener)
 * ```
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was released.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = "up";
        /***/ },
        /* 1330 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(154);
            var GameEvents = __webpack_require__(22);
            var GetValue = __webpack_require__(6);
            var InputEvents = __webpack_require__(51);
            var InputPluginCache = __webpack_require__(153);
            var Key = __webpack_require__(512);
            var KeyCodes = __webpack_require__(143);
            var KeyCombo = __webpack_require__(513);
            var KeyMap = __webpack_require__(1331);
            var SceneEvents = __webpack_require__(20);
            var SnapFloor = __webpack_require__(76);
            /**
 * @classdesc
 * The Keyboard Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Keyboard Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.keyboard`. For example, you can do:
 *
 * ```javascript
 * this.input.keyboard.on('keydown', callback, context);
 * ```
 *
 * Or, to listen for a specific key:
 *
 * ```javascript
 * this.input.keyboard.on('keydown-A', callback, context);
 * ```
 *
 * You can also create Key objects, which you can then poll in your game loop:
 *
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * ```
 *
 * If you have multiple parallel Scenes, each trying to get keyboard input, be sure to disable capture on them to stop them from
 * stealing input from another Scene in the list. You can do this with `this.input.keyboard.enabled = false` within the
 * Scene to stop all input, or `this.input.keyboard.preventDefault = false` to stop a Scene halting input on another Scene.
 *
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * See http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/ for more details.
 *
 * Also please be aware that certain browser extensions can disable or override Phaser keyboard handling.
 * For example the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * And there are others. So, please check your extensions before opening Phaser issues about keys that don't work.
 *
 * @class KeyboardPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var KeyboardPlugin = new Class({
                Extends: EventEmitter,
                initialize: function KeyboardPlugin(sceneInputPlugin) {
                    EventEmitter.call(this);
                    /**
         * A reference to the core game, so we can listen for visibility events.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#game
         * @type {Phaser.Game}
         * @since 3.16.0
         */ this.game = sceneInputPlugin.systems.game;
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                    /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                    /**
         * A reference to the global Keyboard Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#manager
         * @type {Phaser.Input.Keyboard.KeyboardManager}
         * @since 3.16.0
         */ this.manager = sceneInputPlugin.manager.keyboard;
                    /**
         * A boolean that controls if this Keyboard Plugin is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                    /**
         * An array of Key objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#keys
         * @type {Phaser.Input.Keyboard.Key[]}
         * @since 3.10.0
         */ this.keys = [];
                    /**
         * An array of KeyCombo objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#combos
         * @type {Phaser.Input.Keyboard.KeyCombo[]}
         * @since 3.10.0
         */ this.combos = [];
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevCode
         * @type {string}
         * @private
         * @since 3.50.0
         */ this.prevCode = null;
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevTime
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.prevTime = 0;
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevType
         * @type {string}
         * @private
         * @since 3.50.1
         */ this.prevType = null;
                    sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                    sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                    var settings = this.settings.input;
                    this.enabled = GetValue(settings, "keyboard", true);
                    var captures = GetValue(settings, "keyboard.capture", null);
                    if (captures) this.addCaptures(captures);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                    this.sceneInputPlugin.manager.events.on(InputEvents.MANAGER_PROCESS, this.update, this);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                    this.game.events.on(GameEvents.BLUR, this.resetKeys, this);
                    this.scene.sys.events.on(SceneEvents.PAUSE, this.resetKeys, this);
                    this.scene.sys.events.on(SceneEvents.SLEEP, this.resetKeys, this);
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard events for specific keys, so they don't bubble up the browser
     * and cause the default behaviors.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ addCapture: function(keycode) {
                    this.manager.addCapture(keycode);
                    return this;
                },
                /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ removeCapture: function(keycode) {
                    this.manager.removeCapture(keycode);
                    return this;
                },
                /**
     * Returns an array that contains all of the keyboard captures currently enabled.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#getCaptures
     * @since 3.16.0
     *
     * @return {number[]} An array of all the currently capturing key codes.
     */ getCaptures: function() {
                    return this.manager.captures;
                },
                /**
     * Allows Phaser to prevent any key captures you may have defined from bubbling up the browser.
     * You can use this to re-enable event capturing if you had paused it via `disableGlobalCapture`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#enableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ enableGlobalCapture: function() {
                    this.manager.preventDefault = true;
                    return this;
                },
                /**
     * Disables Phaser from preventing any key captures you may have defined, without actually removing them.
     * You can use this to temporarily disable event capturing if, for example, you swap to a DOM element.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#disableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ disableGlobalCapture: function() {
                    this.manager.preventDefault = false;
                    return this;
                },
                /**
     * Removes all keyboard captures.
     *
     * Note that this is a global change. It will clear all event captures across your game, not just for this specific Scene.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#clearCaptures
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ clearCaptures: function() {
                    this.manager.clearCaptures();
                    return this;
                },
                /**
     * Creates and returns an object containing 4 hotkeys for Up, Down, Left and Right, and also Space Bar and shift.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCursorKeys
     * @since 3.10.0
     *
     * @return {Phaser.Types.Input.Keyboard.CursorKeys} An object containing the properties: `up`, `down`, `left`, `right`, `space` and `shift`.
     */ createCursorKeys: function() {
                    return this.addKeys({
                        up: KeyCodes.UP,
                        down: KeyCodes.DOWN,
                        left: KeyCodes.LEFT,
                        right: KeyCodes.RIGHT,
                        space: KeyCodes.SPACE,
                        shift: KeyCodes.SHIFT
                    });
                },
                /**
     * A practical way to create an object containing user selected hotkeys.
     *
     * For example:
     *
     * ```javascript
     * this.input.keyboard.addKeys({ 'up': Phaser.Input.Keyboard.KeyCodes.W, 'down': Phaser.Input.Keyboard.KeyCodes.S });
     * ```
     *
     * would return an object containing the properties (`up` and `down`) mapped to W and S {@link Phaser.Input.Keyboard.Key} objects.
     *
     * You can also pass in a comma-separated string:
     *
     * ```javascript
     * this.input.keyboard.addKeys('W,S,A,D');
     * ```
     *
     * Which will return an object with the properties W, S, A and D mapped to the relevant Key objects.
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKeys
     * @since 3.10.0
     *
     * @param {(object|string)} keys - An object containing Key Codes, or a comma-separated string.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {object} An object containing Key objects mapped to the input properties.
     */ addKeys: function(keys, enableCapture, emitOnRepeat) {
                    if (enableCapture === undefined) enableCapture = true;
                    if (emitOnRepeat === undefined) emitOnRepeat = false;
                    var output = {};
                    if (typeof keys === "string") {
                        keys = keys.split(",");
                        for(var i = 0; i < keys.length; i++){
                            var currentKey = keys[i].trim();
                            if (currentKey) output[currentKey] = this.addKey(currentKey, enableCapture, emitOnRepeat);
                        }
                    } else for(var key in keys)output[key] = this.addKey(keys[key], enableCapture, emitOnRepeat);
                    return output;
                },
                /**
     * Adds a Key object to this Keyboard Plugin.
     *
     * The given argument can be either an existing Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * If a Key object is given, and one already exists matching the same key code, the existing one is replaced with the new one.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {Phaser.Input.Keyboard.Key} The newly created Key object, or a reference to it if it already existed in the keys array.
     */ addKey: function(key, enableCapture, emitOnRepeat) {
                    if (enableCapture === undefined) enableCapture = true;
                    if (emitOnRepeat === undefined) emitOnRepeat = false;
                    var keys = this.keys;
                    if (key instanceof Key) {
                        var idx = keys.indexOf(key);
                        if (idx > -1) keys[idx] = key;
                        else keys[key.keyCode] = key;
                        if (enableCapture) this.addCapture(key.keyCode);
                        key.setEmitOnRepeat(emitOnRepeat);
                        return key;
                    }
                    if (typeof key === "string") key = KeyCodes[key.toUpperCase()];
                    if (!keys[key]) {
                        keys[key] = new Key(this, key);
                        if (enableCapture) this.addCapture(key);
                        keys[key].setEmitOnRepeat(emitOnRepeat);
                    }
                    return keys[key];
                },
                /**
     * Removes a Key object from this Keyboard Plugin.
     *
     * The given argument can be either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [destroy=false] - Call `Key.destroy` on the removed Key object?
     *
     * @return {this} This KeyboardPlugin object.
     */ removeKey: function(key, destroy) {
                    if (destroy === undefined) destroy = false;
                    var keys = this.keys;
                    var ref;
                    if (key instanceof Key) {
                        var idx = keys.indexOf(key);
                        if (idx > -1) {
                            ref = this.keys[idx];
                            this.keys[idx] = undefined;
                        }
                    } else if (typeof key === "string") key = KeyCodes[key.toUpperCase()];
                    if (keys[key]) {
                        ref = keys[key];
                        keys[key] = undefined;
                    }
                    if (ref) {
                        ref.plugin = null;
                        if (destroy) ref.destroy();
                    }
                    return this;
                },
                /**
     * Removes all Key objects created by _this_ Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeAllKeys
     * @since 3.24.0
     *
     * @param {boolean} [destroy=false] - Call `Key.destroy` on each removed Key object?
     *
     * @return {this} This KeyboardPlugin object.
     */ removeAllKeys: function(destroy) {
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (key) {
                            keys[i] = undefined;
                            if (destroy) key.destroy();
                        }
                    }
                    return this;
                },
                /**
     * Creates a new KeyCombo.
     *
     * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
     * it will emit a `keycombomatch` event from this Keyboard Plugin.
     *
     * The keys to be listened for can be defined as:
     *
     * A string (i.e. 'ATARI')
     * An array of either integers (key codes) or strings, or a mixture of both
     * An array of objects (such as Key objects) with a public 'keyCode' property
     *
     * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
     * you could pass the following array of key codes:
     *
     * ```javascript
     * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
     *
     * this.input.keyboard.on('keycombomatch', function (event) {
     *     console.log('Konami Code entered!');
     * });
     * ```
     *
     * Or, to listen for the user entering the word PHASER:
     *
     * ```javascript
     * this.input.keyboard.createCombo('PHASER');
     * ```
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCombo
     * @since 3.10.0
     *
     * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
     * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
     *
     * @return {Phaser.Input.Keyboard.KeyCombo} The new KeyCombo object.
     */ createCombo: function(keys, config) {
                    return new KeyCombo(this, keys, config);
                },
                /**
     * Checks if the given Key object is currently being held down.
     *
     * The difference between this method and checking the `Key.isDown` property directly is that you can provide
     * a duration to this method. For example, if you wanted a key press to fire a bullet, but you only wanted
     * it to be able to fire every 100ms, then you can call this method with a `duration` of 100 and it
     * will only return `true` every 100ms.
     *
     * If the Keyboard Plugin has been disabled, this method will always return `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#checkDown
     * @since 3.11.0
     *
     * @param {Phaser.Input.Keyboard.Key} key - A Key object.
     * @param {number} [duration=0] - The duration which must have elapsed before this Key is considered as being down.
     *
     * @return {boolean} `true` if the Key is down within the duration specified, otherwise `false`.
     */ checkDown: function(key, duration) {
                    if (duration === undefined) duration = 0;
                    if (this.enabled && key.isDown) {
                        var t = SnapFloor(this.time - key.timeDown, duration);
                        if (t > key._tick) {
                            key._tick = t;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Internal update handler called by the Input Plugin, which is in turn invoked by the Game step.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#update
     * @private
     * @since 3.10.0
     */ update: function() {
                    var queue = this.manager.queue;
                    var len = queue.length;
                    if (!this.isActive() || len === 0) return;
                    var keys = this.keys;
                    //  Process the event queue, dispatching all of the events that have stored up
                    for(var i = 0; i < len; i++){
                        var event = queue[i];
                        var code = event.keyCode;
                        var key = keys[code];
                        var repeat = false;
                        //  Override the default functions (it's too late for the browser to use them anyway, so we may as well)
                        if (event.cancelled === undefined) {
                            //  Event allowed to flow across all handlers in this Scene, and any other Scene in the Scene list
                            event.cancelled = 0;
                            //  Won't reach any more local (Scene level) handlers
                            event.stopImmediatePropagation = function() {
                                event.cancelled = 1;
                            };
                            //  Won't reach any more handlers in any Scene further down the Scene list
                            event.stopPropagation = function() {
                                event.cancelled = -1;
                            };
                        }
                        if (event.cancelled === -1) continue;
                        //  Duplicate event bailout
                        if (code === this.prevCode && event.timeStamp === this.prevTime && event.type === this.prevType) continue;
                        this.prevCode = code;
                        this.prevTime = event.timeStamp;
                        this.prevType = event.type;
                        if (event.type === "keydown") {
                            //  Key specific callback first
                            if (key) {
                                repeat = key.isDown;
                                key.onDown(event);
                            }
                            if (!event.cancelled && (!key || !repeat)) {
                                if (KeyMap[code]) this.emit(Events.KEY_DOWN + KeyMap[code], event);
                                if (!event.cancelled) this.emit(Events.ANY_KEY_DOWN, event);
                            }
                        } else {
                            //  Key specific callback first
                            if (key) key.onUp(event);
                            if (!event.cancelled) {
                                if (KeyMap[code]) this.emit(Events.KEY_UP + KeyMap[code], event);
                                if (!event.cancelled) this.emit(Events.ANY_KEY_UP, event);
                            }
                        }
                        //  Reset the cancel state for other Scenes to use
                        if (event.cancelled === 1) event.cancelled = 0;
                    }
                },
                /**
     * Resets all Key objects created by _this_ Keyboard Plugin back to their default un-pressed states.
     * This can only reset keys created via the `addKey`, `addKeys` or `createCursorKeys` methods.
     * If you have created a Key object directly you'll need to reset it yourself.
     *
     * This method is called automatically when the Keyboard Plugin shuts down, but can be
     * invoked directly at any time you require.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#resetKeys
     * @since 3.15.0
     *
     * @return {this} This KeyboardPlugin object.
     */ resetKeys: function() {
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                    if (keys[i]) keys[i].reset();
                    return this;
                },
                /**
     * Shuts this Keyboard Plugin down. This performs the following tasks:
     *
     * 1 - Removes all keys created by this Keyboard plugin.
     * 2 - Stops and removes the keyboard event listeners.
     * 3 - Clears out any pending requests in the queue, without processing them.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                    this.removeAllKeys(true);
                    this.removeAllListeners();
                    this.sceneInputPlugin.manager.events.off(InputEvents.MANAGER_PROCESS, this.update, this);
                    this.game.events.off(GameEvents.BLUR, this.resetKeys);
                    this.scene.sys.events.off(SceneEvents.PAUSE, this.resetKeys, this);
                    this.scene.sys.events.off(SceneEvents.SLEEP, this.resetKeys, this);
                    this.queue = [];
                },
                /**
     * Destroys this Keyboard Plugin instance and all references it holds, plus clears out local arrays.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                    this.shutdown();
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                    if (keys[i]) keys[i].destroy();
                    this.keys = [];
                    this.combos = [];
                    this.queue = [];
                    this.scene = null;
                    this.settings = null;
                    this.sceneInputPlugin = null;
                    this.manager = null;
                },
                /**
     * Internal time value.
     *
     * @name Phaser.Input.Keyboard.KeyboardPlugin#time
     * @type {number}
     * @private
     * @since 3.11.0
     */ time: {
                    get: function() {
                        return this.sceneInputPlugin.manager.time;
                    }
                }
            });
            /**
 * An instance of the Keyboard Plugin class, if enabled via the `input.keyboard` Scene or Game Config property.
 * Use this to create Key objects and listen for keyboard specific events.
 *
 * @name Phaser.Input.InputPlugin#keyboard
 * @type {?Phaser.Input.Keyboard.KeyboardPlugin}
 * @since 3.10.0
 */ InputPluginCache.register("KeyboardPlugin", KeyboardPlugin, "keyboard", "keyboard", "inputKeyboard");
            module1.exports = KeyboardPlugin;
        /***/ },
        /* 1331 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var KeyCodes = __webpack_require__(143);
            var KeyMap = {};
            for(var key in KeyCodes)KeyMap[KeyCodes[key]] = key;
            module1.exports = KeyMap;
        /***/ },
        /* 1332 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justDown value allows you to test if this Key has just been pressed down or not.
 * 
 * When you check this value it will return `true` if the Key is down, otherwise `false`.
 * 
 * You can only call justDown once per key press. It will only return `true` once, until the Key is released and pressed down again.
 * This allows you to use it in situations where you want to check if this key is down without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustDown
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just down or not.
 *
 * @return {boolean} `true` if the Key was just pressed, otherwise `false`.
 */ var JustDown = function(key) {
                if (key._justDown) {
                    key._justDown = false;
                    return true;
                } else return false;
            };
            module1.exports = JustDown;
        /***/ },
        /* 1333 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justUp value allows you to test if this Key has just been released or not.
 * 
 * When you check this value it will return `true` if the Key is up, otherwise `false`.
 * 
 * You can only call JustUp once per key release. It will only return `true` once, until the Key is pressed down and released again.
 * This allows you to use it in situations where you want to check if this key is up without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustUp
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just up or not.
 *
 * @return {boolean} `true` if the Key was just released, otherwise `false`.
 */ var JustUp = function(key) {
                if (key._justUp) {
                    key._justUp = false;
                    return true;
                } else return false;
            };
            module1.exports = JustUp;
        /***/ },
        /* 1334 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was pressed down within the `duration` value given, based on the current
 * game clock time. Or `false` if it either isn't down, or was pressed down longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.DownDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been pressed down.
 *
 * @return {boolean} `true` if the Key was pressed down within `duration` ms ago, otherwise `false`.
 */ var DownDuration = function(key, duration) {
                if (duration === undefined) duration = 50;
                var current = key.plugin.game.loop.time - key.timeDown;
                return key.isDown && current < duration;
            };
            module1.exports = DownDuration;
        /***/ },
        /* 1335 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was released within the `duration` value given, based on the current
 * game clock time. Or returns `false` if it either isn't up, or was released longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.UpDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been released.
 *
 * @return {boolean} `true` if the Key was released within `duration` ms ago, otherwise `false`.
 */ var UpDuration = function(key, duration) {
                if (duration === undefined) duration = 50;
                var current = key.plugin.game.loop.time - key.timeUp;
                return key.isUp && current < duration;
            };
            module1.exports = UpDuration;
        /***/ },
        /* 1336 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Mouse
 */ /* eslint-disable */ module1.exports = {
                MouseManager: __webpack_require__(411)
            };
        /* eslint-enable */ /***/ },
        /* 1337 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Touch
 */ /* eslint-disable */ module1.exports = {
                TouchManager: __webpack_require__(413)
            };
        /* eslint-enable */ /***/ },
        /* 1338 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(21);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Loader
 */ var Loader = {
                Events: __webpack_require__(95),
                FileTypes: __webpack_require__(1339),
                File: __webpack_require__(23),
                FileTypesManager: __webpack_require__(8),
                GetURL: __webpack_require__(155),
                LoaderPlugin: __webpack_require__(1365),
                MergeXHRSettings: __webpack_require__(240),
                MultiFile: __webpack_require__(49),
                XHRLoader: __webpack_require__(517),
                XHRSettings: __webpack_require__(156)
            };
            //   Merge in the consts
            Loader = Extend(false, Loader, CONST);
            module1.exports = Loader;
        /***/ },
        /* 1339 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.FileTypes
 */ module1.exports = {
                AnimationJSONFile: __webpack_require__(1340),
                AsepriteFile: __webpack_require__(1341),
                AtlasJSONFile: __webpack_require__(1342),
                AtlasXMLFile: __webpack_require__(1343),
                AudioFile: __webpack_require__(518),
                AudioSpriteFile: __webpack_require__(1344),
                BinaryFile: __webpack_require__(1345),
                BitmapFontFile: __webpack_require__(1346),
                CSSFile: __webpack_require__(1347),
                GLSLFile: __webpack_require__(1348),
                HTML5AudioFile: __webpack_require__(519),
                HTMLFile: __webpack_require__(1349),
                HTMLTextureFile: __webpack_require__(1350),
                ImageFile: __webpack_require__(71),
                JSONFile: __webpack_require__(61),
                MultiAtlasFile: __webpack_require__(1351),
                MultiScriptFile: __webpack_require__(1352),
                OBJFile: __webpack_require__(1353),
                PackFile: __webpack_require__(1354),
                PluginFile: __webpack_require__(1355),
                SceneFile: __webpack_require__(1356),
                ScenePluginFile: __webpack_require__(1357),
                ScriptFile: __webpack_require__(520),
                SpriteSheetFile: __webpack_require__(1358),
                SVGFile: __webpack_require__(1359),
                TextFile: __webpack_require__(242),
                TilemapCSVFile: __webpack_require__(1360),
                TilemapImpactFile: __webpack_require__(1361),
                TilemapJSONFile: __webpack_require__(1362),
                UnityAtlasFile: __webpack_require__(1363),
                VideoFile: __webpack_require__(1364),
                XMLFile: __webpack_require__(241)
            };
        /***/ },
        /* 1340 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(61);
            var LoaderEvents = __webpack_require__(95);
            /**
 * @classdesc
 * A single Animation JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#animation method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#animation.
 *
 * @class AnimationJSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var AnimationJSONFile = new Class({
                Extends: JSONFile,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function AnimationJSONFile(loader, key, url, xhrSettings, dataKey) {
                    JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                    this.type = "animationJSON";
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    //  We need to hook into this event:
                    this.loader.once(LoaderEvents.POST_PROCESS, this.onLoadComplete, this);
                    //  But the rest is the same as a normal JSON file
                    JSONFile.prototype.onProcess.call(this);
                },
                /**
     * Called at the end of the load process, after the Loader has finished all files in its queue.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onLoadComplete
     * @since 3.7.0
     */ onLoadComplete: function() {
                    this.loader.systems.anims.fromJSON(this.data);
                }
            });
            /**
 * Adds an Animation JSON Data file, or array of Animation JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.animation({
 *     key: 'baddieAnims',
 *     url: 'files/BaddieAnims.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be passed to the global Animation Managers `fromJSON` method.
 * This will parse all of the JSON data and create animation data from it. This process happens at the very end
 * of the Loader, once every other file in the load queue has finished. The reason for this is to allow you to load
 * both animation data and the images it relies upon in the same load call.
 *
 * Once the animation data has been parsed you will be able to play animations using that data.
 * Please see the Animation Manager `fromJSON` method for more details about the format and playback.
 *
 * You can also access the raw animation data from its Cache using its key:
 *
 * ```javascript
 * this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * // and later in your game ...
 * var data = this.cache.json.get('baddieAnims');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And if you only wanted to create animations from the `boss` data, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#animation
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the Animation JSON file loads only this property will be stored in the Cache and used to create animation data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("animation", function(key, url, dataKey, xhrSettings) {
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new AnimationJSONFile(this, key[i]));
                else this.addFile(new AnimationJSONFile(this, key, url, xhrSettings, dataKey));
                return this;
            });
            module1.exports = AnimationJSONFile;
        /***/ },
        /* 1341 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(61);
            var MultiFile = __webpack_require__(49);
            /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AsepriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AsepriteFile = new Class({
                Extends: MultiFile,
                initialize: function AsepriteFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, "textureURL"),
                            extension: GetFastValue(config, "textureExtension", "png"),
                            normalMap: GetFastValue(config, "normalMap"),
                            xhrSettings: GetFastValue(config, "textureXhrSettings")
                        });
                        data = new JSONFile(loader, {
                            key: key,
                            url: GetFastValue(config, "atlasURL"),
                            extension: GetFastValue(config, "atlasExtension", "json"),
                            xhrSettings: GetFastValue(config, "atlasXhrSettings")
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, "atlasjson", key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, "atlasjson", key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AsepriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var json = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                        json.addToCache();
                        this.complete = true;
                    }
                }
            });
            /**
 * Aseprite is a powerful animated sprite editor and pixel art tool.
 *
 * You can find more details at https://www.aseprite.org/
 *
 * Adds a JSON based Aseprite Animation, or array of animations, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.aseprite('gladiator', 'images/Gladiator.png', 'images/Gladiator.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * To export a compatible JSON file in Aseprite, please do the following:
 *
 * 1. Go to "File - Export Sprite Sheet"
 *
 * 2. On the **Layout** tab:
 * 2a. Set the "Sheet type" to "Packed"
 * 2b. Set the "Constraints" to "None"
 * 2c. Check the "Merge Duplicates" checkbox
 *
 * 3. On the **Sprite** tab:
 * 3a. Set "Layers" to "Visible layers"
 * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
 *
 * 4. On the **Borders** tab:
 * 4a. Check the "Trim Sprite" and "Trim Cells" options
 * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
 *
 * 5. On the **Output** tab:
 * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
 * 5b. Check "JSON Data" and give your json file a name
 * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
 * 5d. Make sure "Tags" is checked in the Meta options
 * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
 *
 * 6. Click export
 *
 * This was tested with Aseprite 1.2.25.
 *
 * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.aseprite({
 *     key: 'gladiator',
 *     textureURL: 'images/Gladiator.png',
 *     atlasURL: 'images/Gladiator.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AsepriteFileConfig` for more details.
 *
 * Instead of passing a URL for the JSON data you can also pass in a well formed JSON object instead.
 *
 * Once loaded, you can call this method from within a Scene with the 'atlas' key:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin');
 * ```
 *
 * Any animations defined in the JSON will now be available to use in Phaser and you play them
 * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
 * you can play it in Phaser using that Tag name:
 *
 * ```javascript
 * this.add.sprite(400, 300).play('War Cry');
 * ```
 *
 * When calling this method you can optionally provide an array of tag names, and only those animations
 * will be created. For example:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
 * ```
 *
 * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Aseprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#aseprite
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig|Phaser.Types.Loader.FileTypes.AsepriteFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("aseprite", function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AsepriteFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AsepriteFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AsepriteFile;
        /***/ },
        /* 1342 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(61);
            var MultiFile = __webpack_require__(49);
            /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AtlasJSONFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasJSONFile = new Class({
                Extends: MultiFile,
                initialize: function AtlasJSONFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, "textureURL"),
                            extension: GetFastValue(config, "textureExtension", "png"),
                            normalMap: GetFastValue(config, "normalMap"),
                            xhrSettings: GetFastValue(config, "textureXhrSettings")
                        });
                        data = new JSONFile(loader, {
                            key: key,
                            url: GetFastValue(config, "atlasURL"),
                            extension: GetFastValue(config, "atlasExtension", "json"),
                            xhrSettings: GetFastValue(config, "atlasXhrSettings")
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, "atlasjson", key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, "atlasjson", key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var json = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                        json.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a JSON based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file, using either the JSON Hash or JSON Array format.
 * These files are created by software such as Texture Packer, Shoebox and Adobe Flash / Animate.
 * If you are using Texture Packer and have enabled multi-atlas support, then please use the Phaser Multi Atlas loader
 * instead of this one.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.json');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("atlas", function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AtlasJSONFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AtlasJSONFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AtlasJSONFile;
        /***/ },
        /* 1343 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(49);
            var XMLFile = __webpack_require__(241);
            /**
 * @classdesc
 * A single XML based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlasXML method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlasXML.
 *
 * @class AtlasXMLFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasXMLFile = new Class({
                Extends: MultiFile,
                initialize: function AtlasXMLFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, "textureURL"),
                            extension: GetFastValue(config, "textureExtension", "png"),
                            normalMap: GetFastValue(config, "normalMap"),
                            xhrSettings: GetFastValue(config, "textureXhrSettings")
                        });
                        data = new XMLFile(loader, {
                            key: key,
                            url: GetFastValue(config, "atlasURL"),
                            extension: GetFastValue(config, "atlasExtension", "xml"),
                            xhrSettings: GetFastValue(config, "atlasXhrSettings")
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new XMLFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, "atlasxml", key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, "atlasxml", key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasXMLFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var xml = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlasXML(image.key, image.data, xml.data, normalMap);
                        xml.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an XML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in an XML file format.
 * These files are created by software such as Shoebox and Adobe Flash / Animate.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlasXML
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("atlasXML", function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AtlasXMLFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AtlasXMLFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AtlasXMLFile;
        /***/ },
        /* 1344 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AudioFile = __webpack_require__(518);
            var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(61);
            var MultiFile = __webpack_require__(49);
            /**
 * @classdesc
 * An Audio Sprite File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audioSprite method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audioSprite.
 *
 * @class AudioSpriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {{(string|string[])}} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 */ var AudioSpriteFile = new Class({
                Extends: MultiFile,
                initialize: function AudioSpriteFile(loader, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        jsonURL = GetFastValue(config, "jsonURL");
                        audioURL = GetFastValue(config, "audioURL");
                        audioConfig = GetFastValue(config, "audioConfig");
                        audioXhrSettings = GetFastValue(config, "audioXhrSettings");
                        jsonXhrSettings = GetFastValue(config, "jsonXhrSettings");
                    }
                    var data;
                    //  No url? then we're going to do a json load and parse it from that
                    if (!audioURL) {
                        data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                        MultiFile.call(this, loader, "audiosprite", key, [
                            data
                        ]);
                        this.config.resourceLoad = true;
                        this.config.audioConfig = audioConfig;
                        this.config.audioXhrSettings = audioXhrSettings;
                    } else {
                        var audio = AudioFile.create(loader, key, audioURL, audioConfig, audioXhrSettings);
                        if (audio) {
                            data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                            MultiFile.call(this, loader, "audiosprite", key, [
                                audio,
                                data
                            ]);
                            this.config.resourceLoad = false;
                        }
                    }
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) {
                        this.pending--;
                        if (this.config.resourceLoad && file.type === "json" && file.data.hasOwnProperty("resources")) {
                            //  Inspect the data for the files to now load
                            var urls = file.data.resources;
                            var audioConfig = GetFastValue(this.config, "audioConfig");
                            var audioXhrSettings = GetFastValue(this.config, "audioXhrSettings");
                            var audio = AudioFile.create(this.loader, file.key, urls, audioConfig, audioXhrSettings);
                            if (audio) {
                                this.addToMultiFile(audio);
                                this.loader.addFile(audio);
                            }
                        }
                    }
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var fileA = this.files[0];
                        var fileB = this.files[1];
                        fileA.addToCache();
                        fileB.addToCache();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a JSON based Audio Sprite, or array of audio sprites, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json', [
 *         'kyobi.ogg',
 *         'kyobi.mp3',
 *         'kyobi.m4a'
 *     ]);
 * }
 * ```
 *
 * Audio Sprites are a combination of audio files and a JSON configuration.
 * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
 *
 * If the JSON file includes a 'resource' object then you can let Phaser parse it and load the audio
 * files automatically based on its content. To do this exclude the audio URLs from the load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audioSprite({
 *     key: 'kyobi',
 *     jsonURL: 'audio/Kyobi.json',
 *     audioURL: [
 *         'audio/Kyobi.ogg',
 *         'audio/Kyobi.mp3',
 *         'audio/Kyobi.m4a'
 *     ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig` for more details.
 *
 * Instead of passing a URL for the audio JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the audio has finished loading you can use it create an Audio Sprite by referencing its key:
 *
 * ```javascript
 * this.load.audioSprite('kyobi', 'kyobi.json');
 * // and later in your game ...
 * var music = this.sound.addAudioSprite('kyobi');
 * music.play('title');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio Sprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audioSprite
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig[])} key - The key to use for this file, or a file configuration object, or an array of objects.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {(string|string[])} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader.
 */ FileTypesManager.register("audioSprite", function(key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                var game = this.systems.game;
                var gameAudioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                if (gameAudioConfig && gameAudioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                return this;
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AudioSpriteFile(this, key[i]);
                    if (multifile.files) this.addFile(multifile.files);
                }
                else {
                    multifile = new AudioSpriteFile(this, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings);
                    if (multifile.files) this.addFile(multifile.files);
                }
                return this;
            });
        /***/ },
        /* 1345 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Binary File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#binary method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#binary.
 *
 * @class BinaryFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 */ var BinaryFile = new Class({
                Extends: File,
                initialize: function BinaryFile(loader, key, url, xhrSettings, dataType) {
                    var extension = "bin";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        dataType = GetFastValue(config, "dataType", dataType);
                    }
                    var fileConfig = {
                        type: "binary",
                        cache: loader.cacheManager.binary,
                        extension: extension,
                        responseType: "arraybuffer",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            dataType: dataType
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.BinaryFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var ctor = this.config.dataType;
                    this.data = ctor ? new ctor(this.xhrLoader.response) : this.xhrLoader.response;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Binary file, or array of Binary files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.binary('doom', 'files/Doom.wad');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Binary Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Binary Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Binary Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.binary({
 *     key: 'doom',
 *     url: 'files/Doom.wad',
 *     dataType: Uint8Array
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BinaryFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.binary('doom', 'files/Doom.wad');
 * // and later in your game ...
 * var data = this.cache.binary.get('doom');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Data` the final key will be `LEVEL1.Data` and
 * this is what you would use to retrieve the text from the Binary Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "doom"
 * and no URL is given then the Loader will set the URL to be "doom.bin". It will always add `.bin` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Binary File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#binary
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig|Phaser.Types.Loader.FileTypes.BinaryFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("binary", function(key, url, dataType, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new BinaryFile(this, key[i]));
                else this.addFile(new BinaryFile(this, key, url, xhrSettings, dataType));
                return this;
            });
            module1.exports = BinaryFile;
        /***/ },
        /* 1346 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(49);
            var ParseXMLBitmapFont = __webpack_require__(212);
            var XMLFile = __webpack_require__(241);
            /**
 * @classdesc
 * A single Bitmap Font based File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#bitmapFont method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#bitmapFont.
 *
 * @class BitmapFontFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 */ var BitmapFontFile = new Class({
                Extends: MultiFile,
                initialize: function BitmapFontFile(loader, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, "textureURL"),
                            extension: GetFastValue(config, "textureExtension", "png"),
                            normalMap: GetFastValue(config, "normalMap"),
                            xhrSettings: GetFastValue(config, "textureXhrSettings")
                        });
                        data = new XMLFile(loader, {
                            key: key,
                            url: GetFastValue(config, "fontDataURL"),
                            extension: GetFastValue(config, "fontDataExtension", "xml"),
                            xhrSettings: GetFastValue(config, "fontDataXhrSettings")
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new XMLFile(loader, key, fontDataURL, fontDataXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, "bitmapfont", key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, "bitmapfont", key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.BitmapFontFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var xml = this.files[1];
                        image.addToCache();
                        xml.pendingDestroy();
                        var texture = image.cache.get(image.key);
                        var data = ParseXMLBitmapFont(xml.data, image.cache.getFrame(image.key), 0, 0, texture);
                        this.loader.cacheManager.bitmapFont.add(image.key, {
                            data: data,
                            texture: image.key,
                            frame: null
                        });
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an XML based Bitmap Font, or array of fonts, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:

 * ```javascript
 * function preload ()
 * {
 *     this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the font data to be provided in an XML file format.
 * These files are created by software such as the [Angelcode Bitmap Font Generator](http://www.angelcode.com/products/bmfont/),
 * [Littera](http://kvazars.com/littera/) or [Glyph Designer](https://71squared.com/glyphdesigner)
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BitmapFontFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use key of it when creating a Bitmap Text Game Object:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * // and later in your game ...
 * this.add.bitmapText(x, y, 'goldenFont', 'Hello World');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use when creating a Bitmap Text object.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', [ 'images/GoldFont.png', 'images/GoldFont-n.png' ], 'images/GoldFont.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     normalMap: 'images/GoldFont-n.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Bitmap Font File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#bitmapFont
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("bitmapFont", function(key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new BitmapFontFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new BitmapFontFile(this, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = BitmapFontFile;
        /***/ },
        /* 1347 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single CSS File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#css method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#css.
 *
 * @class CSSFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var CSSFile = new Class({
                Extends: File,
                initialize: function CSSFile(loader, key, url, xhrSettings) {
                    var extension = "css";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "script",
                        cache: false,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.CSSFile#onProcess
     * @since 3.17.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = document.createElement("style");
                    this.data.defer = false;
                    this.data.innerHTML = this.xhrLoader.responseText;
                    document.head.appendChild(this.data);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a CSS file, or array of CSS files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.css('headers', 'styles/headers.css');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.css({
 *     key: 'headers',
 *     url: 'styles/headers.css'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.CSSFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a style DOM element
 * via `document.createElement('style')`. It will have its `defer` property set to false and then the
 * resulting element will be appended to `document.head`. The CSS styles are then applied to the current document.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.css". It will always add `.css` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the CSS File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#css
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig|Phaser.Types.Loader.FileTypes.CSSFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.css`, i.e. if `key` was "alien" then the URL will be "alien.css".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("css", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new CSSFile(this, key[i]));
                else this.addFile(new CSSFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = CSSFile;
        /***/ },
        /* 1348 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var Shader = __webpack_require__(396);
            /**
 * @classdesc
 * A single GLSL File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#glsl method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#glsl.
 *
 * @class GLSLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var GLSLFile = new Class({
                Extends: File,
                initialize: function GLSLFile(loader, key, url, shaderType, xhrSettings) {
                    var extension = "glsl";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        shaderType = GetFastValue(config, "shaderType", "fragment");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    } else if (shaderType === undefined) shaderType = "fragment";
                    var fileConfig = {
                        type: "glsl",
                        cache: loader.cacheManager.shader,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        config: {
                            shaderType: shaderType
                        },
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                    var data = this.data.split("\n");
                    //  Check to see if this is a shader bundle, or raw glsl file.
                    var block = this.extractBlock(data, 0);
                    if (block) while(block){
                        var key = this.getShaderName(block.header);
                        var shaderType = this.getShaderType(block.header);
                        var uniforms = this.getShaderUniforms(block.header);
                        var shaderSrc = block.shader;
                        if (this.cache.has(key)) {
                            var shader = this.cache.get(key);
                            if (shaderType === "fragment") shader.fragmentSrc = shaderSrc;
                            else shader.vertexSrc = shaderSrc;
                            if (!shader.uniforms) shader.uniforms = uniforms;
                        } else if (shaderType === "fragment") this.cache.add(key, new Shader(key, shaderSrc, "", uniforms));
                        else this.cache.add(key, new Shader(key, "", shaderSrc, uniforms));
                        block = this.extractBlock(data, block.offset);
                    }
                    else if (this.config.shaderType === "fragment") //  Single shader
                    this.cache.add(this.key, new Shader(this.key, this.data));
                    else this.cache.add(this.key, new Shader(this.key, "", this.data));
                    this.pendingDestroy();
                },
                /**
     * Returns the name of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderName
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader name.
     */ getShaderName: function(headerSource) {
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 5) === "name:") return line.substring(5).trim();
                    }
                    return this.key;
                },
                /**
     * Returns the type of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderType
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader type. Either 'fragment' or 'vertex'.
     */ getShaderType: function(headerSource) {
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 5) === "type:") return line.substring(5).trim();
                    }
                    return this.config.shaderType;
                },
                /**
     * Returns the shader uniforms from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderUniforms
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {any} The shader uniforms object.
     */ getShaderUniforms: function(headerSource) {
                    var uniforms = {};
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 8) === "uniform.") {
                            var pos = line.indexOf(":");
                            if (pos) {
                                var key = line.substring(8, pos);
                                try {
                                    uniforms[key] = JSON.parse(line.substring(pos + 1));
                                } catch (e) {
                                    console.warn("Invalid uniform JSON: " + key);
                                }
                            }
                        }
                    }
                    return uniforms;
                },
                /**
     * Processes the shader file and extracts the relevant data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#extractBlock
     * @private
     * @since 3.17.0
     *
     * @param {string[]} data - The array of shader data to process.
     * @param {number} offset - The offset to start processing from.
     *
     * @return {any} The processed shader block, or null.
     */ extractBlock: function(data, offset) {
                    var headerStart = -1;
                    var headerEnd = -1;
                    var blockEnd = -1;
                    var headerOpen = false;
                    var captureSource = false;
                    var headerSource = [];
                    var shaderSource = [];
                    for(var i = offset; i < data.length; i++){
                        var line = data[i].trim();
                        if (line === "---") {
                            if (headerStart === -1) {
                                headerStart = i;
                                headerOpen = true;
                            } else if (headerOpen) {
                                headerEnd = i;
                                headerOpen = false;
                                captureSource = true;
                            } else {
                                //  We've hit another --- delimiter, break out
                                captureSource = false;
                                break;
                            }
                        } else if (headerOpen) headerSource.push(line);
                        else if (captureSource) {
                            shaderSource.push(line);
                            blockEnd = i;
                        }
                    }
                    if (!headerOpen && headerEnd !== -1) return {
                        header: headerSource,
                        shader: shaderSource.join("\n"),
                        offset: blockEnd
                    };
                    else return null;
                }
            });
            /**
 * Adds a GLSL file, or array of GLSL files, to the current load queue.
 * In Phaser 3 GLSL files are just plain Text files at the current moment in time.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Shader Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Shader Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Shader Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.glsl({
 *     key: 'plasma',
 *     shaderType: 'fragment',
 *     url: 'shaders/Plasma.glsl'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.GLSLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * // and later in your game ...
 * var data = this.cache.shader.get('plasma');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `FX.` and the key was `Plasma` the final key will be `FX.Plasma` and
 * this is what you would use to retrieve the text from the Shader Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "plasma"
 * and no URL is given then the Loader will set the URL to be "plasma.glsl". It will always add `.glsl` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the GLSL File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#glsl
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig|Phaser.Types.Loader.FileTypes.GLSLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.glsl`, i.e. if `key` was "alien" then the URL will be "alien.glsl".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("glsl", function(key, url, shaderType, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new GLSLFile(this, key[i]));
                else this.addFile(new GLSLFile(this, key, url, shaderType, xhrSettings));
                return this;
            });
            module1.exports = GLSLFile;
        /***/ },
        /* 1349 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#html method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#html.
 *
 * @class HTMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLFile = new Class({
                Extends: File,
                initialize: function HTMLFile(loader, key, url, xhrSettings) {
                    var extension = "html";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "text",
                        cache: loader.cacheManager.html,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds an HTML file, or array of HTML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.html('story', 'files/LoginForm.html');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global HTML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the HTML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the HTML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.html({
 *     key: 'login',
 *     url: 'files/LoginForm.html'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.html('login', 'files/LoginForm.html');
 * // and later in your game ...
 * var data = this.cache.html.get('login');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the html from the HTML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the HTML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#html
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig|Phaser.Types.Loader.FileTypes.HTMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("html", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new HTMLFile(this, key[i]));
                else this.addFile(new HTMLFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = HTMLFile;
        /***/ },
        /* 1350 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#htmlTexture method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#htmlTexture.
 *
 * @class HTMLTextureFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {number} [width] - The width of the texture the HTML will be rendered to.
 * @param {number} [height] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLTextureFile = new Class({
                Extends: File,
                initialize: function HTMLTextureFile(loader, key, url, width, height, xhrSettings) {
                    if (width === undefined) width = 512;
                    if (height === undefined) height = 512;
                    var extension = "html";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        width = GetFastValue(config, "width", width);
                        height = GetFastValue(config, "height", height);
                    }
                    var fileConfig = {
                        type: "html",
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            width: width,
                            height: height
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var w = this.config.width;
                    var h = this.config.height;
                    var data = [];
                    data.push('<svg width="' + w + 'px" height="' + h + 'px" viewBox="0 0 ' + w + " " + h + '" xmlns="http://www.w3.org/2000/svg">');
                    data.push('<foreignObject width="100%" height="100%">');
                    data.push('<body xmlns="http://www.w3.org/1999/xhtml">');
                    data.push(this.xhrLoader.responseText);
                    data.push("</body>");
                    data.push("</foreignObject>");
                    data.push("</svg>");
                    var svg = [
                        data.join("\n")
                    ];
                    var _this = this;
                    try {
                        var blob = new window.Blob(svg, {
                            type: "image/svg+xml;charset=utf-8"
                        });
                    } catch (e) {
                        _this.state = CONST.FILE_ERRORED;
                        _this.onProcessComplete();
                        return;
                    }
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    this.data.onload = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(this.data, blob, "image/svg+xml");
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds an HTML File, or array of HTML Files, to the current load queue. When the files are loaded they
 * will be rendered to textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.htmlTexture({
 *     key: 'instructions',
 *     url: 'content/intro.html',
 *     width: 256,
 *     height: 512
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * // and later in your game ...
 * this.add.image(x, y, 'instructions');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * The width and height are the size of the texture to which the HTML will be rendered. It's not possible to determine these
 * automatically, so you will need to provide them, either as arguments or in the file config object.
 * When the HTML file has loaded a new SVG element is created with a size and viewbox set to the width and height given.
 * The SVG file has a body tag added to it, with the HTML file contents included. It then calls `window.Blob` on the SVG,
 * and if successful is added to the Texture Manager, otherwise it fails processing. The overall quality of the rendered
 * HTML depends on your browser, and some of them may not even support the svg / blob process used. Be aware that there are
 * limitations on what HTML can be inside an SVG. You can find out more details in this
 * [Mozilla MDN entry](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Drawing_DOM_objects_into_a_canvas).
 *
 * Note: The ability to load this type of file will only be available if the HTMLTextureFile File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#htmlTexture
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {number} [width=512] - The width of the texture the HTML will be rendered to.
 * @param {number} [height=512] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("htmlTexture", function(key, url, width, height, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new HTMLTextureFile(this, key[i]));
                else this.addFile(new HTMLTextureFile(this, key, url, width, height, xhrSettings));
                return this;
            });
            module1.exports = HTMLTextureFile;
        /***/ },
        /* 1351 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(61);
            var MultiFile = __webpack_require__(49);
            /**
 * @classdesc
 * A single Multi Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#multiatlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#multiatlas.
 *
 * @class MultiAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig)} key - The key of the file. Must be unique within both the Loader and the Texture Manager. Or a config object.
 * @param {string} [atlasURL] - The absolute or relative URL to load the multi atlas json file from.
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture files.
 */ var MultiAtlasFile = new Class({
                Extends: MultiFile,
                initialize: function MultiAtlasFile(loader, key, atlasURL, path, baseURL, atlasXhrSettings, textureXhrSettings) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        if (GetFastValue(config, "url", false)) atlasURL = GetFastValue(config, "url");
                        else atlasURL = GetFastValue(config, "atlasURL");
                        atlasXhrSettings = GetFastValue(config, "xhrSettings");
                        path = GetFastValue(config, "path");
                        baseURL = GetFastValue(config, "baseURL");
                        textureXhrSettings = GetFastValue(config, "textureXhrSettings");
                    }
                    var data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    MultiFile.call(this, loader, "multiatlas", key, [
                        data
                    ]);
                    this.config.path = path;
                    this.config.baseURL = baseURL;
                    this.config.textureXhrSettings = textureXhrSettings;
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) {
                        this.pending--;
                        if (file.type === "json" && file.data.hasOwnProperty("textures")) {
                            //  Inspect the data for the files to now load
                            var textures = file.data.textures;
                            var config = this.config;
                            var loader = this.loader;
                            var currentBaseURL = loader.baseURL;
                            var currentPath = loader.path;
                            var currentPrefix = loader.prefix;
                            var baseURL = GetFastValue(config, "baseURL", this.baseURL);
                            var path = GetFastValue(config, "path", this.path);
                            var prefix = GetFastValue(config, "prefix", this.prefix);
                            var textureXhrSettings = GetFastValue(config, "textureXhrSettings");
                            loader.setBaseURL(baseURL);
                            loader.setPath(path);
                            loader.setPrefix(prefix);
                            for(var i = 0; i < textures.length; i++){
                                //  "image": "texture-packer-multi-atlas-0.png",
                                var textureURL = textures[i].image;
                                var key = "MA" + this.multiKeyIndex + "_" + textureURL;
                                var image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                                this.addToMultiFile(image);
                                loader.addFile(image);
                                //  "normalMap": "texture-packer-multi-atlas-0_n.png",
                                if (textures[i].normalMap) {
                                    var normalMap = new ImageFile(loader, key, textures[i].normalMap, textureXhrSettings);
                                    normalMap.type = "normalMap";
                                    image.setLink(normalMap);
                                    this.addToMultiFile(normalMap);
                                    loader.addFile(normalMap);
                                }
                            }
                            //  Reset the loader settings
                            loader.setBaseURL(currentBaseURL);
                            loader.setPath(currentPath);
                            loader.setPrefix(currentPrefix);
                        }
                    }
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var fileJSON = this.files[0];
                        var data = [];
                        var images = [];
                        var normalMaps = [];
                        for(var i = 1; i < this.files.length; i++){
                            var file = this.files[i];
                            if (file.type === "normalMap") continue;
                            var pos = file.key.indexOf("_");
                            var key = file.key.substr(pos + 1);
                            var image = file.data;
                            //  Now we need to find out which json entry this mapped to
                            for(var t = 0; t < fileJSON.data.textures.length; t++){
                                var item = fileJSON.data.textures[t];
                                if (item.image === key) {
                                    images.push(image);
                                    data.push(item);
                                    if (file.linkFile) normalMaps.push(file.linkFile.data);
                                    break;
                                }
                            }
                        }
                        if (normalMaps.length === 0) normalMaps = undefined;
                        this.loader.textureManager.addAtlasJSONArray(this.key, images, data, normalMaps);
                        this.complete = true;
                        for(i = 0; i < this.files.length; i++)this.files[i].pendingDestroy();
                    }
                }
            });
            /**
 * Adds a Multi Texture Atlas, or array of multi atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.multiatlas('level1', 'images/Level1.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file as exported from the application Texture Packer,
 * version 4.6.3 or above, where you have made sure to use the Phaser 3 Export option.
 *
 * The way it works internally is that you provide a URL to the JSON file. Phaser then loads this JSON, parses it and
 * extracts which texture files it also needs to load to complete the process. If the JSON also defines normal maps,
 * Phaser will load those as well.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.multiatlas({
 *     key: 'level1',
 *     atlasURL: 'images/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.multiatlas('level1', 'images/Level1.json');
 * // and later in your game ...
 * this.add.image(x, y, 'level1', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Multi Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#multiatlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("multiatlas", function(key, atlasURL, path, baseURL, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new MultiAtlasFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new MultiAtlasFile(this, key, atlasURL, path, baseURL, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = MultiAtlasFile;
        /***/ },
        /* 1352 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(49);
            var ScriptFile = __webpack_require__(520);
            /**
 * @classdesc
 * A Multi Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scripts method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scripts.
 *
 * @class MultiScriptFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object for the script files. Used in replacement of the Loaders default XHR Settings.
 */ var MultiScriptFile = new Class({
                Extends: MultiFile,
                initialize: function MultiScriptFile(loader, key, url, xhrSettings) {
                    var extension = "js";
                    var files = [];
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    if (!Array.isArray(url)) url = [
                        url
                    ];
                    for(var i = 0; i < url.length; i++){
                        var scriptFile = new ScriptFile(loader, {
                            key: key + "_" + i.toString(),
                            url: url[i],
                            extension: extension,
                            xhrSettings: xhrSettings
                        });
                        //  Override the default onProcess function
                        scriptFile.onProcess = function() {
                            this.onProcessComplete();
                        };
                        files.push(scriptFile);
                    }
                    MultiFile.call(this, loader, "scripts", key, files);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiScriptFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        for(var i = 0; i < this.files.length; i++){
                            var file = this.files[i];
                            file.data = document.createElement("script");
                            file.data.language = "javascript";
                            file.data.type = "text/javascript";
                            file.data.defer = false;
                            file.data.text = file.xhrLoader.responseText;
                            document.head.appendChild(file.data);
                        }
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an array of Script files to the current load queue.
 *
 * The difference between this and the `ScriptFile` file type is that you give an array of scripts to this method,
 * and the scripts are then processed _exactly_ in that order. This allows you to load a bunch of scripts that
 * may have dependencies on each other without worrying about the async nature of traditional script loading.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scripts('PostProcess', [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *    ]);
 * }
 * ```
 *
 * In the code above the script files will all be loaded in parallel but only processed (i.e. invoked) in the exact
 * order given in the array.
 *
 * The files are **not** loaded right away. They are added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the files are queued
 * it means you cannot use the files immediately after calling this method, but must wait for the files to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scripts({
 *     key: 'PostProcess',
 *     url: [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *        ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiScriptFileConfig` for more details.
 *
 * Once all the files have finished loading they will automatically be converted into a script element
 * via `document.createElement('script')`. They will have their language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. This is done in the exact order the files are specified in the url array.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Note: The ability to load this type of file will only be available if the MultiScript File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scripts
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {string} [extension='js'] - The default file extension to use if no url is provided.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("scripts", function(key, url, xhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new MultiScriptFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new MultiScriptFile(this, key, url, xhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = MultiScriptFile;
        /***/ },
        /* 1353 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(49);
            var ParseObj = __webpack_require__(498);
            var ParseObjMaterial = __webpack_require__(499);
            var TextFile = __webpack_require__(242);
            /**
 * @classdesc
 * A single Wavefront OBJ File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#obj method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#obj.
 *
 * @class OBJFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - The absolute or relative URL to load the material file from. If undefined or `null` it will be set to `<key>.mat`, i.e. if `key` was "alien" then the URL will be "alien.mat".
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 */ var OBJFile = new Class({
                Extends: MultiFile,
                initialize: function OBJFile(loader, key, objURL, matURL, flipUV, xhrSettings) {
                    var obj;
                    var mat;
                    var cache = loader.cacheManager.obj;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        obj = new TextFile(loader, {
                            key: key,
                            type: "obj",
                            cache: cache,
                            url: GetFastValue(config, "url"),
                            extension: GetFastValue(config, "extension", "obj"),
                            xhrSettings: GetFastValue(config, "xhrSettings"),
                            config: {
                                flipUV: GetFastValue(config, "flipUV", flipUV)
                            }
                        });
                        matURL = GetFastValue(config, "matURL");
                        if (matURL) mat = new TextFile(loader, {
                            key: key,
                            type: "mat",
                            cache: cache,
                            url: matURL,
                            extension: GetFastValue(config, "matExtension", "mat"),
                            xhrSettings: GetFastValue(config, "xhrSettings")
                        });
                    } else {
                        obj = new TextFile(loader, {
                            key: key,
                            url: objURL,
                            type: "obj",
                            cache: cache,
                            extension: "obj",
                            xhrSettings: xhrSettings,
                            config: {
                                flipUV: flipUV
                            }
                        });
                        if (matURL) mat = new TextFile(loader, {
                            key: key,
                            url: matURL,
                            type: "mat",
                            cache: cache,
                            extension: "mat",
                            xhrSettings: xhrSettings
                        });
                    }
                    MultiFile.call(this, loader, "obj", key, [
                        obj,
                        mat
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.OBJFile#addToCache
     * @since 3.50.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var obj = this.files[0];
                        var mat = this.files[1];
                        var objData = ParseObj(obj.data, obj.config.flipUV);
                        if (mat) objData.materials = ParseObjMaterial(mat.data);
                        obj.cache.add(obj.key, objData);
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a Wavefront OBJ file, or array of OBJ files, to the current load queue.
 *
 * Note: You should ensure your 3D package has triangulated the OBJ file prior to export.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj');
 * }
 * ```
 *
 * You can optionally also load a Wavefront Material file as well, by providing the 3rd parameter:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj', 'files/spaceship.mtl');
 * }
 * ```
 *
 * If given, the material will be parsed and stored along with the obj data in the cache.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global OBJ Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the OBJ Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the OBJ Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.obj({
 *     key: 'ufo',
 *     url: 'files/spaceship.obj',
 *     matURL: 'files/spaceship.mtl',
 *     flipUV: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.OBJFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.obj('ufo', 'files/spaceship.obj');
 * // and later in your game ...
 * var data = this.cache.obj.get('ufo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the obj from the OBJ Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.obj". It will always add `.obj` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the OBJ File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#obj
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig|Phaser.Types.Loader.FileTypes.OBJFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - Optional absolute or relative URL to load the obj material file from.
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("obj", function(key, objURL, matURL, flipUVs, xhrSettings) {
                var multifile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new OBJFile(this, key[i]);
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new OBJFile(this, key, objURL, matURL, flipUVs, xhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = OBJFile;
        /***/ },
        /* 1354 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(61);
            /**
 * @classdesc
 * A single JSON Pack File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#pack method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#pack.
 *
 * @class PackFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var PackFile = new Class({
                Extends: JSONFile,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function PackFile(loader, key, url, xhrSettings, dataKey) {
                    JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                    this.type = "packfile";
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PackFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    if (this.state !== CONST.FILE_POPULATED) {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = JSON.parse(this.xhrLoader.responseText);
                    }
                    //  Let's pass the pack file data over to the Loader ...
                    this.loader.addPack(this.data, this.config);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a JSON File Pack, or array of packs, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.pack('level1', 'data/Level1Files.json');
 * }
 * ```
 *
 * A File Pack is a JSON file (or object) that contains details about other files that should be added into the Loader.
 * Here is a small example:
 *
 * ```json
 * {
 *    "test1": {
 *        "files": [
 *            {
 *                "type": "image",
 *                "key": "taikodrummaster",
 *                "url": "assets/pics/taikodrummaster.jpg"
 *            },
 *            {
 *                "type": "image",
 *                "key": "sukasuka-chtholly",
 *                "url": "assets/pics/sukasuka-chtholly.png"
 *            }
 *        ]
 *    },
 *    "meta": {
 *        "generated": "1401380327373",
 *        "app": "Phaser 3 Asset Packer",
 *        "url": "https://phaser.io",
 *        "version": "1.0",
 *        "copyright": "Photon Storm Ltd. 2018"
 *    }
 * }
 * ```
 *
 * The pack can be split into sections. In the example above you'll see a section called `test1. You can tell
 * the `load.pack` method to parse only a particular section of a pack. The pack is stored in the JSON Cache,
 * so you can pass it to the Loader to process additional sections as needed in your game, or you can just load
 * them all at once without specifying anything.
 *
 * The pack file can contain an entry for any type of file that Phaser can load. The object structures exactly
 * match that of the file type configs, and all properties available within the file type configs can be used
 * in the pack file too.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.pack({
 *     key: 'level1',
 *     url: 'data/Level1Files.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PackFileConfig` for more details.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the Pack File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#pack
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig|Phaser.Types.Loader.FileTypes.PackFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("pack", function(key, url, packKey, xhrSettings) {
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new PackFile(this, key[i]));
                else this.addFile(new PackFile(this, key, url, xhrSettings, packKey));
                return this;
            });
            module1.exports = PackFile;
        /***/ },
        /* 1355 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#plugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#plugin.
 *
 * @class PluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {boolean} [start=false] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var PluginFile = new Class({
                Extends: File,
                initialize: function PluginFile(loader, key, url, start, mapping, xhrSettings) {
                    var extension = "js";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        start = GetFastValue(config, "start");
                        mapping = GetFastValue(config, "mapping");
                    }
                    var fileConfig = {
                        type: "plugin",
                        cache: false,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            start: start,
                            mapping: mapping
                        }
                    };
                    File.call(this, loader, fileConfig);
                    // If the url variable refers to a class, add the plugin directly
                    if (typeof url === "function") {
                        this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PluginFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    var pluginManager = this.loader.systems.plugins;
                    var config = this.config;
                    var start = GetFastValue(config, "start", false);
                    var mapping = GetFastValue(config, "mapping", null);
                    if (this.state === CONST.FILE_POPULATED) pluginManager.install(this.key, this.data, start, mapping);
                    else {
                        //  Plugin added via a js file
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement("script");
                        this.data.language = "javascript";
                        this.data.type = "text/javascript";
                        this.data.defer = false;
                        this.data.text = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        var plugin = pluginManager.install(this.key, window[this.key], start, mapping);
                        if (start || mapping) {
                            //  Install into the current Scene Systems and Scene
                            this.loader.systems[mapping] = plugin;
                            this.loader.scene[mapping] = plugin;
                        }
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.plugin('modplayer', 'plugins/ModPlayer.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.plugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Plugin File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#plugin
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig|Phaser.Types.Loader.FileTypes.PluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, a plugin function.
 * @param {boolean} [start] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("plugin", function(key, url, start, mapping, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new PluginFile(this, key[i]));
                else this.addFile(new PluginFile(this, key, url, start, mapping, xhrSettings));
                return this;
            });
            module1.exports = PluginFile;
        /***/ },
        /* 1356 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An external Scene JavaScript File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#sceneFile method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#sceneFile.
 *
 * @class SceneFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SceneFile = new Class({
                Extends: File,
                initialize: function SceneFile(loader, key, url, xhrSettings) {
                    var extension = "js";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "text",
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#onProcess
     * @since 3.16.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#addToCache
     * @since 3.16.0
     */ addToCache: function() {
                    var code = this.data.concat("(function(){\nreturn new " + this.key + "();\n" + "}).call(this);");
                    //  Stops rollup from freaking out during build
                    var eval2 = eval;
                    this.loader.sceneManager.add(this.key, eval2(code));
                    this.complete = true;
                }
            });
            /**
 * Adds an external Scene file, or array of Scene files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('Level1', 'src/Level1.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Scene Manager upon a successful load.
 *
 * For a Scene File it's vitally important that the key matches the class name in the JavaScript file.
 *
 * For example here is the source file:
 *
 * ```javascript
 * class ExternalScene extends Phaser.Scene {
 *
 *     constructor ()
 *     {
 *         super('myScene');
 *     }
 *
 * }
 * ```
 *
 * Because the class is called `ExternalScene` that is the exact same key you must use when loading it:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('ExternalScene', 'src/yourScene.js');
 * }
 * ```
 *
 * The key that is used within the Scene Manager can either be set to the same, or you can override it in the Scene
 * constructor, as we've done in the example above, where the Scene key was changed to `myScene`.
 *
 * The key should be unique both in terms of files being loaded and Scenes already present in the Scene Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Scene Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.sceneFile({
 *     key: 'Level1',
 *     url: 'src/Level1.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SceneFileConfig` for more details.
 *
 * Once the file has finished loading it will be added to the Scene Manager.
 *
 * ```javascript
 * this.load.sceneFile('Level1', 'src/Level1.js');
 * // and later in your game ...
 * this.scene.start('Level1');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `WORLD1.` and the key was `Story` the final key will be `WORLD1.Story` and
 * this is what you would use to retrieve the text from the Scene Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Scene File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#sceneFile
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.16.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig|Phaser.Types.Loader.FileTypes.SceneFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("sceneFile", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SceneFile(this, key[i]));
                else this.addFile(new SceneFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = SceneFile;
        /***/ },
        /* 1357 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Scene Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scenePlugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scenePlugin.
 *
 * @class ScenePluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScenePluginFile = new Class({
                Extends: File,
                initialize: function ScenePluginFile(loader, key, url, systemKey, sceneKey, xhrSettings) {
                    var extension = "js";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                        systemKey = GetFastValue(config, "systemKey");
                        sceneKey = GetFastValue(config, "sceneKey");
                    }
                    var fileConfig = {
                        type: "scenePlugin",
                        cache: false,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            systemKey: systemKey,
                            sceneKey: sceneKey
                        }
                    };
                    File.call(this, loader, fileConfig);
                    // If the url variable refers to a class, add the plugin directly
                    if (typeof url === "function") {
                        this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScenePluginFile#onProcess
     * @since 3.8.0
     */ onProcess: function() {
                    var pluginManager = this.loader.systems.plugins;
                    var config = this.config;
                    var key = this.key;
                    var systemKey = GetFastValue(config, "systemKey", key);
                    var sceneKey = GetFastValue(config, "sceneKey", key);
                    if (this.state === CONST.FILE_POPULATED) pluginManager.installScenePlugin(systemKey, this.data, sceneKey, this.loader.scene, true);
                    else {
                        //  Plugin added via a js file
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement("script");
                        this.data.language = "javascript";
                        this.data.type = "text/javascript";
                        this.data.defer = false;
                        this.data.text = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        pluginManager.installScenePlugin(systemKey, window[this.key], sceneKey, this.loader.scene, true);
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Scene Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scenePlugin('ModPlayer', 'plugins/ModPlayer.js', 'modPlayer', 'mods');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scenePlugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScenePluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scenePlugin
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.8.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, set to a plugin function.
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("scenePlugin", function(key, url, systemKey, sceneKey, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ScenePluginFile(this, key[i]));
                else this.addFile(new ScenePluginFile(this, key, url, systemKey, sceneKey, xhrSettings));
                return this;
            });
            module1.exports = ScenePluginFile;
        /***/ },
        /* 1358 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var ImageFile = __webpack_require__(71);
            /**
 * @classdesc
 * A single Sprite Sheet Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#spritesheet method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#spritesheet.
 *
 * @class SpriteSheetFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SpriteSheetFile = new Class({
                Extends: ImageFile,
                initialize: function SpriteSheetFile(loader, key, url, frameConfig, xhrSettings) {
                    ImageFile.call(this, loader, key, url, xhrSettings, frameConfig);
                    this.type = "spritesheet";
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SpriteSheetFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addSpriteSheet(this.key, this.data, this.config);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds a Sprite Sheet Image, or array of Sprite Sheet Images, to the current load queue.
 *
 * The term 'Sprite Sheet' in Phaser means a fixed-size sheet. Where every frame in the sheet is the exact same size,
 * and you reference those frames using numbers, not frame names. This is not the same thing as a Texture Atlas, where
 * the frames are packed in a way where they take up the least amount of space, and are referenced by their names,
 * not numbers. Some articles and software use the term 'Sprite Sheet' to mean Texture Atlas, so please be aware of
 * what sort of file you're actually trying to load.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 * 
 * ```javascript
 * function preload ()
 * {
 *     this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 * 
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 * 
 * ```javascript
 * this.load.spritesheet({
 *     key: 'bot',
 *     url: 'images/robot.png',
 *     frameConfig: {
 *         frameWidth: 32,
 *         frameHeight: 38,
 *         startFrame: 0,
 *         endFrame: 8
 *     }
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 * 
 * ```javascript
 * this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * // and later in your game ...
 * this.add.image(x, y, 'bot', 0);
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `PLAYER.` and the key was `Running` the final key will be `PLAYER.Running` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 * 
 * ```javascript
 * this.load.spritesheet('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ], { frameWidth: 256, frameHeight: 80 });
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 * 
 * ```javascript
 * this.load.spritesheet({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png',
 *     frameConfig: {
 *         frameWidth: 256,
 *         frameHeight: 80
 *     }
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 * 
 * Note: The ability to load this type of file will only be available if the Sprite Sheet File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#spritesheet
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. At a minimum it should have a `frameWidth` property.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("spritesheet", function(key, url, frameConfig, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SpriteSheetFile(this, key[i]));
                else this.addFile(new SpriteSheetFile(this, key, url, frameConfig, xhrSettings));
                return this;
            });
            module1.exports = SpriteSheetFile;
        /***/ },
        /* 1359 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single SVG File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#svg method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#svg.
 *
 * @class SVGFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SVGFile = new Class({
                Extends: File,
                initialize: function SVGFile(loader, key, url, svgConfig, xhrSettings) {
                    var extension = "svg";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        svgConfig = GetFastValue(config, "svgConfig", {});
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "svg",
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            width: GetFastValue(svgConfig, "width"),
                            height: GetFastValue(svgConfig, "height"),
                            scale: GetFastValue(svgConfig, "scale")
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var text = this.xhrLoader.responseText;
                    var svg = [
                        text
                    ];
                    var width = this.config.width;
                    var height = this.config.height;
                    var scale = this.config.scale;
                    resize: if (width && height || scale) {
                        var xml = null;
                        var parser = new DOMParser();
                        xml = parser.parseFromString(text, "text/xml");
                        var svgXML = xml.getElementsByTagName("svg")[0];
                        var hasViewBox = svgXML.hasAttribute("viewBox");
                        var svgWidth = parseFloat(svgXML.getAttribute("width"));
                        var svgHeight = parseFloat(svgXML.getAttribute("height"));
                        if (!hasViewBox && svgWidth && svgHeight) //  If there's no viewBox attribute, set one
                        svgXML.setAttribute("viewBox", "0  0 " + svgWidth + " " + svgHeight);
                        else if (hasViewBox && !svgWidth && !svgHeight) {
                            //  Get the w/h from the viewbox
                            var viewBox = svgXML.getAttribute("viewBox").split(/\s+|,/);
                            svgWidth = viewBox[2];
                            svgHeight = viewBox[3];
                        }
                        if (scale) {
                            if (svgWidth && svgHeight) {
                                width = svgWidth * scale;
                                height = svgHeight * scale;
                            } else break resize;
                        }
                        svgXML.setAttribute("width", width.toString() + "px");
                        svgXML.setAttribute("height", height.toString() + "px");
                        svg = [
                            new XMLSerializer().serializeToString(svgXML)
                        ];
                    }
                    try {
                        var blob = new window.Blob(svg, {
                            type: "image/svg+xml;charset=utf-8"
                        });
                    } catch (e) {
                        this.onProcessError();
                        return;
                    }
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    var _this = this;
                    var retry = false;
                    this.data.onload = function() {
                        if (!retry) File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        //  Safari 8 re-try
                        if (!retry) {
                            retry = true;
                            File.revokeObjectURL(_this.data);
                            _this.data.src = "data:image/svg+xml," + encodeURIComponent(svg.join(""));
                        } else _this.onProcessError();
                    };
                    File.createObjectURL(this.data, blob, "image/svg+xml");
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds an SVG File, or array of SVG Files, to the current load queue. When the files are loaded they
 * will be rendered to bitmap textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SVGFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.svg('morty', 'images/Morty.svg');
 * // and later in your game ...
 * this.add.image(x, y, 'morty');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can optionally pass an SVG Resize Configuration object when you load an SVG file. By default the SVG will be rendered to a texture
 * at the same size defined in the SVG file attributes. However, this isn't always desirable. You may wish to resize the SVG (either down
 * or up) to improve texture clarity, or reduce texture memory consumption. You can either specify an exact width and height to resize
 * the SVG to:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { width: 300, height: 600 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         width: 300,
 *         height: 600
 *     }
 * });
 * ```
 *
 * Alternatively, you can just provide a scale factor instead:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { scale: 2.5 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         scale: 2.5
 *     }
 * });
 * ```
 *
 * If scale, width and height values are all given, the scale has priority and the width and height values are ignored.
 *
 * Note: The ability to load this type of file will only be available if the SVG File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#svg
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig|Phaser.Types.Loader.FileTypes.SVGFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("svg", function(key, url, svgConfig, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SVGFile(this, key[i]));
                else this.addFile(new SVGFile(this, key, url, svgConfig, xhrSettings));
                return this;
            });
            module1.exports = SVGFile;
        /***/ },
        /* 1360 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var TILEMAP_FORMATS = __webpack_require__(40);
            /**
 * @classdesc
 * A single Tilemap CSV File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapCSV method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapCSV.
 *
 * @class TilemapCSVFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapCSVFile = new Class({
                Extends: File,
                initialize: function TilemapCSVFile(loader, key, url, xhrSettings) {
                    var extension = "csv";
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        url = GetFastValue(config, "url");
                        xhrSettings = GetFastValue(config, "xhrSettings");
                        extension = GetFastValue(config, "extension", extension);
                    }
                    var fileConfig = {
                        type: "tilemapCSV",
                        cache: loader.cacheManager.tilemap,
                        extension: extension,
                        responseType: "text",
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                    this.tilemapFormat = TILEMAP_FORMATS.CSV;
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: this.tilemapFormat,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds a CSV Tilemap file, or array of CSV files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * }
 * ```
 *
 * Tilemap CSV data can be created in a text editor, or a 3rd party app that exports as CSV.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapCSV({
 *     key: 'level1',
 *     url: 'maps/Level1.csv'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.csv". It will always add `.csv` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap CSV File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapCSV
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("tilemapCSV", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapCSVFile(this, key[i]));
                else this.addFile(new TilemapCSVFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapCSVFile;
        /***/ },
        /* 1361 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(61);
            var TILEMAP_FORMATS = __webpack_require__(40);
            /**
 * @classdesc
 * A single Impact.js Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapImpact method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapImpact.
 *
 * @class TilemapImpactFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapImpactFile = new Class({
                Extends: JSONFile,
                initialize: function TilemapImpactFile(loader, key, url, xhrSettings) {
                    JSONFile.call(this, loader, key, url, xhrSettings);
                    this.type = "tilemapJSON";
                    this.cache = loader.cacheManager.tilemap;
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapImpactFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: TILEMAP_FORMATS.WELTMEISTER,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds an Impact.js Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapImpact('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * Impact Tilemap data is created the Impact.js Map Editor called Weltmeister.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapImpact({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapImpact('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap Impact File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapImpact
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("tilemapImpact", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapImpactFile(this, key[i]));
                else this.addFile(new TilemapImpactFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapImpactFile;
        /***/ },
        /* 1362 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(61);
            var TILEMAP_FORMATS = __webpack_require__(40);
            /**
 * @classdesc
 * A single Tiled Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapTiledJSON method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapTiledJSON.
 *
 * @class TilemapJSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapJSONFile = new Class({
                Extends: JSONFile,
                initialize: function TilemapJSONFile(loader, key, url, xhrSettings) {
                    JSONFile.call(this, loader, key, url, xhrSettings);
                    this.type = "tilemapJSON";
                    this.cache = loader.cacheManager.tilemap;
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: TILEMAP_FORMATS.TILED_JSON,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds a Tiled JSON Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * The Tilemap data is created using the Tiled Map Editor and selecting JSON as the export format.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapTiledJSON({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapTiledJSON
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("tilemapTiledJSON", function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapJSONFile(this, key[i]));
                else this.addFile(new TilemapJSONFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapJSONFile;
        /***/ },
        /* 1363 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(71);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(49);
            var TextFile = __webpack_require__(242);
            /**
 * @classdesc
 * A single text file based Unity Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#unityAtlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#unityAtlas.
 *
 * @class UnityAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 */ var UnityAtlasFile = new Class({
                Extends: MultiFile,
                initialize: function UnityAtlasFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, "key");
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, "textureURL"),
                            extension: GetFastValue(config, "textureExtension", "png"),
                            normalMap: GetFastValue(config, "normalMap"),
                            xhrSettings: GetFastValue(config, "textureXhrSettings")
                        });
                        data = new TextFile(loader, {
                            key: key,
                            url: GetFastValue(config, "atlasURL"),
                            extension: GetFastValue(config, "atlasExtension", "txt"),
                            xhrSettings: GetFastValue(config, "atlasXhrSettings")
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new TextFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, "unityatlas", key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, "unityatlas", key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.UnityAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var text = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addUnityAtlas(image.key, image.data, text.data, normalMap);
                        text.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a Unity YAML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a YAML formatted text file as exported from Unity.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.txt');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Unity Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#unityAtlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("unityAtlas", function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new UnityAtlasFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new UnityAtlasFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = UnityAtlasFile;
        /***/ },
        /* 1364 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetURL = __webpack_require__(155);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Video File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#video method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#video.
 *
 * @class VideoFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.20.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {any} [urlConfig] - The absolute or relative URL to load this file from in a config object.
 * @param {string} [loadEvent] - The load event to listen for when _not_ loading as a blob. Either 'loadeddata', 'canplay' or 'canplaythrough'.
 * @param {boolean} [asBlob] - Load the video as a data blob, or via the Video element?
 * @param {boolean} [noAudio] - Does the video have an audio track? If not you can enable auto-playing on it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var VideoFile = new Class({
                Extends: File,
                initialize: //  URL is an object created by VideoFile.getVideoURL
                function VideoFile(loader, key, urlConfig, loadEvent, asBlob, noAudio, xhrSettings) {
                    if (loadEvent === undefined) loadEvent = "loadeddata";
                    if (asBlob === undefined) asBlob = false;
                    if (noAudio === undefined) noAudio = false;
                    if (loadEvent !== "loadeddata" && loadEvent !== "canplay" && loadEvent !== "canplaythrough") loadEvent = "loadeddata";
                    var fileConfig = {
                        type: "video",
                        cache: loader.cacheManager.video,
                        extension: urlConfig.type,
                        responseType: "blob",
                        key: key,
                        url: urlConfig.url,
                        xhrSettings: xhrSettings,
                        config: {
                            loadEvent: loadEvent,
                            asBlob: asBlob,
                            noAudio: noAudio
                        }
                    };
                    this.onLoadCallback = this.onVideoLoadHandler.bind(this);
                    this.onErrorCallback = this.onVideoErrorHandler.bind(this);
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onProcess
     * @since 3.20.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    if (!this.config.asBlob) {
                        this.onProcessComplete();
                        return;
                    }
                    //  Load Video as blob
                    var video = this.createVideoElement();
                    this.data = video;
                    var _this = this;
                    this.data.onloadeddata = function() {
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(video, this.xhrLoader.response, "");
                    video.load();
                },
                /**
     * Creates a Video Element within the DOM.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#createVideoElement
     * @private
     * @since 3.20.0
     *
     * @return {HTMLVideoElement} The newly created Video element.
     */ createVideoElement: function() {
                    var video = document.createElement("video");
                    video.controls = false;
                    video.crossOrigin = this.loader.crossOrigin;
                    if (this.config.noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute("autoplay", "autoplay");
                    }
                    video.setAttribute("playsinline", "playsinline");
                    video.setAttribute("preload", "auto");
                    return video;
                },
                /**
     * Internal load event callback.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onVideoLoadHandler
     * @private
     * @since 3.20.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onVideoLoadHandler: function(event) {
                    var video = event.target;
                    video.removeEventListener(this.config.loadEvent, this.onLoadCallback, true);
                    video.removeEventListener("error", this.onErrorCallback, true);
                    this.data = video;
                    this.resetXHR();
                    this.loader.nextFile(this, true);
                },
                /**
     * Internal load error event callback.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onVideoErrorHandler
     * @private
     * @since 3.20.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onVideoErrorHandler: function(event) {
                    var video = event.target;
                    if (video) {
                        video.removeEventListener(this.config.loadEvent, this.onLoadCallback, true);
                        video.removeEventListener("error", this.onErrorCallback, true);
                    }
                    this.resetXHR();
                    this.loader.nextFile(this, false);
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#load
     * @since 3.20.0
     */ load: function() {
                    var loadEvent = this.config.loadEvent;
                    if (this.config.asBlob) File.prototype.load.call(this);
                    else {
                        this.percentComplete = 0;
                        var video = this.createVideoElement();
                        video.addEventListener(loadEvent, this.onLoadCallback, true);
                        video.addEventListener("error", this.onErrorCallback, true);
                        video.src = GetURL(this, this.loader.baseURL);
                        video.load();
                    }
                }
            });
            VideoFile.create = function(loader, key, urls, loadEvent, asBlob, noAudio, xhrSettings) {
                var game = loader.systems.game;
                //  url may be inside key, which may be an object
                if (IsPlainObject(key)) {
                    urls = GetFastValue(key, "url", []);
                    loadEvent = GetFastValue(key, "loadEvent", "loadeddata");
                    asBlob = GetFastValue(key, "asBlob", false);
                    noAudio = GetFastValue(key, "noAudio", false);
                    xhrSettings = GetFastValue(key, "xhrSettings");
                    key = GetFastValue(key, "key");
                }
                var urlConfig = VideoFile.getVideoURL(game, urls);
                if (urlConfig) return new VideoFile(loader, key, urlConfig, loadEvent, asBlob, noAudio, xhrSettings);
            };
            VideoFile.getVideoURL = function(game, urls) {
                if (!Array.isArray(urls)) urls = [
                    urls
                ];
                for(var i = 0; i < urls.length; i++){
                    var url = GetFastValue(urls[i], "url", urls[i]);
                    if (url.indexOf("blob:") === 0) return {
                        url: url,
                        type: ""
                    };
                    var videoType;
                    if (url.indexOf("data:") === 0) videoType = url.split(",")[0].match(/\/(.*?);/);
                    else videoType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                    videoType = GetFastValue(urls[i], "type", videoType ? videoType[1] : "").toLowerCase();
                    if (game.device.video[videoType]) return {
                        url: url,
                        type: videoType
                    };
                }
                return null;
            };
            /**
 * Adds a Video file, or array of video files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.video('intro', [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Video Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Video Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Video Cache first, before loading a new one.
  *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.video({
 *     key: 'intro',
 *     url: [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ],
 *     asBlob: false,
 *     noAudio: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.VideoFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different video file types you should usually provide your video files in a variety of formats.
 * mp4, mov and webm are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support, starting with the first in the array and progressing to the end.
 *
 * Unlike most asset-types, videos do not _need_ to be preloaded. You can create a Video Game Object and then call its `loadURL` method,
 * to load a video at run-time, rather than in advance.
 *
 * Note: The ability to load this type of file will only be available if the Video File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#video
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.20.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig|Phaser.Types.Loader.FileTypes.VideoFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[])} [urls] - The absolute or relative URL to load the video files from.
 * @param {string} [loadEvent='loadeddata'] - The load event to listen for when _not_ loading as a blob. Either `loadeddata`, `canplay` or `canplaythrough`.
 * @param {boolean} [asBlob=false] - Load the video as a data blob, or stream it via the Video element?
 * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register("video", function(key, urls, loadEvent, asBlob, noAudio, xhrSettings) {
                var videoFile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    videoFile = VideoFile.create(this, key[i]);
                    if (videoFile) this.addFile(videoFile);
                }
                else {
                    videoFile = VideoFile.create(this, key, urls, loadEvent, asBlob, noAudio, xhrSettings);
                    if (videoFile) this.addFile(videoFile);
                }
                return this;
            });
            module1.exports = VideoFile;
        /***/ },
        /* 1365 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(21);
            var CustomSet = __webpack_require__(149);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(95);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            var XHRSettings = __webpack_require__(156);
            /**
 * @classdesc
 * The Loader handles loading all external content such as Images, Sounds, Texture Atlases and data files.
 * You typically interact with it via `this.load` in your Scene. Scenes can have a `preload` method, which is always
 * called before the Scenes `create` method, allowing you to preload assets that the Scene may need.
 *
 * If you call any `this.load` methods from outside of `Scene.preload` then you need to start the Loader going
 * yourself by calling `Loader.start()`. It's only automatically started during the Scene preload.
 *
 * The Loader uses a combination of tag loading (eg. Audio elements) and XHR and provides progress and completion events.
 * Files are loaded in parallel by default. The amount of concurrent connections can be controlled in your Game Configuration.
 *
 * Once the Loader has started loading you are still able to add files to it. These can be injected as a result of a loader
 * event, the type of file being loaded (such as a pack file) or other external events. As long as the Loader hasn't finished
 * simply adding a new file to it, while running, will ensure it's added into the current queue.
 *
 * Every Scene has its own instance of the Loader and they are bound to the Scene in which they are created. However,
 * assets loaded by the Loader are placed into global game-level caches. For example, loading an XML file will place that
 * file inside `Game.cache.xml`, which is accessible from every Scene in your game, no matter who was responsible
 * for loading it. The same is true of Textures. A texture loaded in one Scene is instantly available to all other Scenes
 * in your game.
 *
 * The Loader works by using custom File Types. These are stored in the FileTypesManager, which injects them into the Loader
 * when it's instantiated. You can create your own custom file types by extending either the File or MultiFile classes.
 * See those files for more details.
 *
 * @class LoaderPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Loader instance.
 */ var LoaderPlugin = new Class({
                Extends: EventEmitter,
                initialize: function LoaderPlugin(scene) {
                    EventEmitter.call(this);
                    var gameConfig = scene.sys.game.config;
                    var sceneConfig = scene.sys.settings.loader;
                    /**
         * The Scene which owns this Loader instance.
         *
         * @name Phaser.Loader.LoaderPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.Loader.LoaderPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the global Cache Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#cacheManager
         * @type {Phaser.Cache.CacheManager}
         * @since 3.7.0
         */ this.cacheManager = scene.sys.cache;
                    /**
         * A reference to the global Texture Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.7.0
         */ this.textureManager = scene.sys.textures;
                    /**
         * A reference to the global Scene Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @protected
         * @since 3.16.0
         */ this.sceneManager = scene.sys.game.scene;
                    //  Inject the available filetypes into the Loader
                    FileTypesManager.install(this);
                    /**
         * An optional prefix that is automatically prepended to the start of every file key.
         * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
         * You can set this directly, or call `Loader.setPrefix()`. It will then affect every file added to the Loader
         * from that point on. It does _not_ change any file already in the load queue.
         *
         * @name Phaser.Loader.LoaderPlugin#prefix
         * @type {string}
         * @default ''
         * @since 3.7.0
         */ this.prefix = "";
                    /**
         * The value of `path`, if set, is placed before any _relative_ file path given. For example:
         *
         * ```javascript
         * this.load.path = "images/sprites/";
         * this.load.image("ball", "ball.png");
         * this.load.image("tree", "level1/oaktree.png");
         * this.load.image("boom", "http://server.com/explode.png");
         * ```
         *
         * Would load the `ball` file from `images/sprites/ball.png` and the tree from
         * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
         * given as it's an absolute URL.
         *
         * Please note that the path is added before the filename but *after* the baseURL (if set.)
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setPath()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#path
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.path = "";
                    /**
         * If you want to append a URL before the path of any asset you can set this here.
         *
         * Useful if allowing the asset base url to be configured outside of the game code.
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setBaseURL()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#baseURL
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.baseURL = "";
                    this.setBaseURL(GetFastValue(sceneConfig, "baseURL", gameConfig.loaderBaseURL));
                    this.setPath(GetFastValue(sceneConfig, "path", gameConfig.loaderPath));
                    this.setPrefix(GetFastValue(sceneConfig, "prefix", gameConfig.loaderPrefix));
                    /**
         * The number of concurrent / parallel resources to try and fetch at once.
         *
         * Old browsers limit 6 requests per domain; modern ones, especially those with HTTP/2 don't limit it at all.
         *
         * The default is 32 but you can change this in your Game Config, or by changing this property before the Loader starts.
         *
         * @name Phaser.Loader.LoaderPlugin#maxParallelDownloads
         * @type {number}
         * @since 3.0.0
         */ this.maxParallelDownloads = GetFastValue(sceneConfig, "maxParallelDownloads", gameConfig.loaderMaxParallelDownloads);
                    /**
         * xhr specific global settings (can be overridden on a per-file basis)
         *
         * @name Phaser.Loader.LoaderPlugin#xhr
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhr = XHRSettings(GetFastValue(sceneConfig, "responseType", gameConfig.loaderResponseType), GetFastValue(sceneConfig, "async", gameConfig.loaderAsync), GetFastValue(sceneConfig, "user", gameConfig.loaderUser), GetFastValue(sceneConfig, "password", gameConfig.loaderPassword), GetFastValue(sceneConfig, "timeout", gameConfig.loaderTimeout), GetFastValue(sceneConfig, "withCredentials", gameConfig.loaderWithCredentials));
                    /**
         * The crossOrigin value applied to loaded images. Very often this needs to be set to 'anonymous'.
         *
         * @name Phaser.Loader.LoaderPlugin#crossOrigin
         * @type {string}
         * @since 3.0.0
         */ this.crossOrigin = GetFastValue(sceneConfig, "crossOrigin", gameConfig.loaderCrossOrigin);
                    /**
         * The total number of files to load. It may not always be accurate because you may add to the Loader during the process
         * of loading, especially if you load a Pack File. Therefore this value can change, but in most cases remains static.
         *
         * @name Phaser.Loader.LoaderPlugin#totalToLoad
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalToLoad = 0;
                    /**
         * The progress of the current load queue, as a float value between 0 and 1.
         * This is updated automatically as files complete loading.
         * Note that it is possible for this value to go down again if you add content to the current load queue during a load.
         *
         * @name Phaser.Loader.LoaderPlugin#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Files are placed in this Set when they're added to the Loader via `addFile`.
         *
         * They are moved to the `inflight` Set when they start loading, and assuming a successful
         * load, to the `queue` Set for further processing.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#list
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.list = new CustomSet();
                    /**
         * Files are stored in this Set while they're in the process of being loaded.
         *
         * Upon a successful load they are moved to the `queue` Set.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#inflight
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.inflight = new CustomSet();
                    /**
         * Files are stored in this Set while they're being processed.
         *
         * If the process is successful they are moved to their final destination, which could be
         * a Cache or the Texture Manager.
         *
         * At the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#queue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.queue = new CustomSet();
                    /**
         * A temporary Set in which files are stored after processing,
         * awaiting destruction at the end of the load process.
         *
         * @name Phaser.Loader.LoaderPlugin#_deleteQueue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @private
         * @since 3.7.0
         */ this._deleteQueue = new CustomSet();
                    /**
         * The total number of files that failed to load during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalFailed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalFailed = 0;
                    /**
         * The total number of files that successfully loaded during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalComplete
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalComplete = 0;
                    /**
         * The current state of the Loader.
         *
         * @name Phaser.Loader.LoaderPlugin#state
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.state = CONST.LOADER_IDLE;
                    /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.LoaderPlugin#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = 0;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.pluginStart, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#pluginStart
     * @private
     * @since 3.5.1
     */ pluginStart: function() {
                    this.systems.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * If you want to append a URL before the path of any asset you can set this here.
     *
     * Useful if allowing the asset base url to be configured outside of the game code.
     *
     * Once a base URL is set it will affect every file loaded by the Loader from that point on. It does _not_ change any
     * file _already_ being loaded. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setBaseURL
     * @since 3.0.0
     *
     * @param {string} [url] - The URL to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setBaseURL: function(url) {
                    if (url === undefined) url = "";
                    if (url !== "" && url.substr(-1) !== "/") url = url.concat("/");
                    this.baseURL = url;
                    return this;
                },
                /**
     * The value of `path`, if set, is placed before any _relative_ file path given. For example:
     *
     * ```javascript
     * this.load.setPath("images/sprites/");
     * this.load.image("ball", "ball.png");
     * this.load.image("tree", "level1/oaktree.png");
     * this.load.image("boom", "http://server.com/explode.png");
     * ```
     *
     * Would load the `ball` file from `images/sprites/ball.png` and the tree from
     * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
     * given as it's an absolute URL.
     *
     * Please note that the path is added before the filename but *after* the baseURL (if set.)
     *
     * Once a path is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPath
     * @since 3.0.0
     *
     * @param {string} [path] - The path to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPath: function(path) {
                    if (path === undefined) path = "";
                    if (path !== "" && path.substr(-1) !== "/") path = path.concat("/");
                    this.path = path;
                    return this;
                },
                /**
     * An optional prefix that is automatically prepended to the start of every file key.
     *
     * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
     *
     * Once a prefix is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPrefix
     * @since 3.7.0
     *
     * @param {string} [prefix] - The prefix to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPrefix: function(prefix) {
                    if (prefix === undefined) prefix = "";
                    this.prefix = prefix;
                    return this;
                },
                /**
     * Sets the Cross Origin Resource Sharing value used when loading files.
     *
     * Files can override this value on a per-file basis by specifying an alternative `crossOrigin` value in their file config.
     *
     * Once CORs is set it will then affect every file loaded by the Loader from that point on, as long as they don't have
     * their own CORs setting. To reset it, call this method with no arguments.
     *
     * For more details about CORs see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
     *
     * @method Phaser.Loader.LoaderPlugin#setCORS
     * @since 3.0.0
     *
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the load request.
     *
     * @return {this} This Loader object.
     */ setCORS: function(crossOrigin) {
                    this.crossOrigin = crossOrigin;
                    return this;
                },
                /**
     * Adds a file, or array of files, into the load queue.
     *
     * The file must be an instance of `Phaser.Loader.File`, or a class that extends it. The Loader will check that the key
     * used by the file won't conflict with any other key either in the loader, the inflight queue or the target cache.
     * If allowed it will then add the file into the pending list, read for the load to start. Or, if the load has already
     * started, ready for the next batch of files to be pulled from the list to the inflight queue.
     *
     * You should not normally call this method directly, but rather use one of the Loader methods like `image` or `atlas`,
     * however you can call this as long as the file given to it is well formed.
     *
     * @method Phaser.Loader.LoaderPlugin#addFile
     * @fires Phaser.Loader.Events#ADD
     * @since 3.0.0
     *
     * @param {(Phaser.Loader.File|Phaser.Loader.File[])} file - The file, or array of files, to be added to the load queue.
     */ addFile: function(file) {
                    if (!Array.isArray(file)) file = [
                        file
                    ];
                    for(var i = 0; i < file.length; i++){
                        var item = file[i];
                        //  Does the file already exist in the cache or texture manager?
                        //  Or will it conflict with a file already in the queue or inflight?
                        if (!this.keyExists(item)) {
                            this.list.set(item);
                            this.emit(Events.ADD, item.key, item.type, this, item);
                            if (this.isLoading()) {
                                this.totalToLoad++;
                                this.updateProgress();
                            }
                        }
                    }
                },
                /**
     * Checks the key and type of the given file to see if it will conflict with anything already
     * in a Cache, the Texture Manager, or the list or inflight queues.
     *
     * @method Phaser.Loader.LoaderPlugin#keyExists
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file to check the key of.
     *
     * @return {boolean} `true` if adding this file will cause a cache or queue conflict, otherwise `false`.
     */ keyExists: function(file) {
                    var keyConflict = file.hasCacheConflict();
                    if (!keyConflict) this.list.iterate(function(item) {
                        if (item.type === file.type && item.key === file.key) {
                            keyConflict = true;
                            return false;
                        }
                    });
                    if (!keyConflict && this.isLoading()) {
                        this.inflight.iterate(function(item) {
                            if (item.type === file.type && item.key === file.key) {
                                keyConflict = true;
                                return false;
                            }
                        });
                        this.queue.iterate(function(item) {
                            if (item.type === file.type && item.key === file.key) {
                                keyConflict = true;
                                return false;
                            }
                        });
                    }
                    return keyConflict;
                },
                /**
     * Takes a well formed, fully parsed pack file object and adds its entries into the load queue. Usually you do not call
     * this method directly, but instead use `Loader.pack` and supply a path to a JSON file that holds the
     * pack data. However, if you've got the data prepared you can pass it to this method.
     *
     * You can also provide an optional key. If you do then it will only add the entries from that part of the pack into
     * to the load queue. If not specified it will add all entries it finds. For more details about the pack file format
     * see the `LoaderPlugin.pack` method.
     *
     * @method Phaser.Loader.LoaderPlugin#addPack
     * @since 3.7.0
     *
     * @param {any} pack - The Pack File data to be parsed and each entry of it to added to the load queue.
     * @param {string} [packKey] - An optional key to use from the pack file data.
     *
     * @return {boolean} `true` if any files were added to the queue, otherwise `false`.
     */ addPack: function(pack, packKey) {
                    //  if no packKey provided we'll add everything to the queue
                    if (packKey && pack.hasOwnProperty(packKey)) pack = {
                        packKey: pack[packKey]
                    };
                    var total = 0;
                    //  Store the loader settings in case this pack replaces them
                    var currentBaseURL = this.baseURL;
                    var currentPath = this.path;
                    var currentPrefix = this.prefix;
                    //  Here we go ...
                    for(var key in pack){
                        if (!Object.prototype.hasOwnProperty.call(pack, key)) continue;
                        var config = pack[key];
                        //  Any meta data to process?
                        var baseURL = GetFastValue(config, "baseURL", currentBaseURL);
                        var path = GetFastValue(config, "path", currentPath);
                        var prefix = GetFastValue(config, "prefix", currentPrefix);
                        var files = GetFastValue(config, "files", null);
                        var defaultType = GetFastValue(config, "defaultType", "void");
                        if (Array.isArray(files)) {
                            this.setBaseURL(baseURL);
                            this.setPath(path);
                            this.setPrefix(prefix);
                            for(var i = 0; i < files.length; i++){
                                var file = files[i];
                                var type = file.hasOwnProperty("type") ? file.type : defaultType;
                                if (this[type]) {
                                    this[type](file);
                                    total++;
                                }
                            }
                        }
                    }
                    //  Reset the loader settings
                    this.setBaseURL(currentBaseURL);
                    this.setPath(currentPath);
                    this.setPrefix(currentPrefix);
                    return total > 0;
                },
                /**
     * Is the Loader actively loading, or processing loaded files?
     *
     * @method Phaser.Loader.LoaderPlugin#isLoading
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is busy loading or processing, otherwise `false`.
     */ isLoading: function() {
                    return this.state === CONST.LOADER_LOADING || this.state === CONST.LOADER_PROCESSING;
                },
                /**
     * Is the Loader ready to start a new load?
     *
     * @method Phaser.Loader.LoaderPlugin#isReady
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is ready to start a new load, otherwise `false`.
     */ isReady: function() {
                    return this.state === CONST.LOADER_IDLE || this.state === CONST.LOADER_COMPLETE;
                },
                /**
     * Starts the Loader running. This will reset the progress and totals and then emit a `start` event.
     * If there is nothing in the queue the Loader will immediately complete, otherwise it will start
     * loading the first batch of files.
     *
     * The Loader is started automatically if the queue is populated within your Scenes `preload` method.
     *
     * However, outside of this, you need to call this method to start it.
     *
     * If the Loader is already running this method will simply return.
     *
     * @method Phaser.Loader.LoaderPlugin#start
     * @fires Phaser.Loader.Events#START
     * @since 3.0.0
     */ start: function() {
                    if (!this.isReady()) return;
                    this.progress = 0;
                    this.totalFailed = 0;
                    this.totalComplete = 0;
                    this.totalToLoad = this.list.size;
                    this.emit(Events.START, this);
                    if (this.list.size === 0) this.loadComplete();
                    else {
                        this.state = CONST.LOADER_LOADING;
                        this.inflight.clear();
                        this.queue.clear();
                        this.updateProgress();
                        this.checkLoadQueue();
                        this.systems.events.on(SceneEvents.UPDATE, this.update, this);
                    }
                },
                /**
     * Called automatically during the load process.
     * It updates the `progress` value and then emits a progress event, which you can use to
     * display a loading bar in your game.
     *
     * @method Phaser.Loader.LoaderPlugin#updateProgress
     * @fires Phaser.Loader.Events#PROGRESS
     * @since 3.0.0
     */ updateProgress: function() {
                    this.progress = 1 - (this.list.size + this.inflight.size) / this.totalToLoad;
                    this.emit(Events.PROGRESS, this.progress);
                },
                /**
     * Called automatically during the load process.
     *
     * @method Phaser.Loader.LoaderPlugin#update
     * @since 3.10.0
     */ update: function() {
                    if (this.state === CONST.LOADER_LOADING && this.list.size > 0 && this.inflight.size < this.maxParallelDownloads) this.checkLoadQueue();
                },
                /**
     * An internal method called by the Loader.
     *
     * It will check to see if there are any more files in the pending list that need loading, and if so it will move
     * them from the list Set into the inflight Set, set their CORs flag and start them loading.
     *
     * It will carrying on doing this for each file in the pending list until it runs out, or hits the max allowed parallel downloads.
     *
     * @method Phaser.Loader.LoaderPlugin#checkLoadQueue
     * @private
     * @since 3.7.0
     */ checkLoadQueue: function() {
                    this.list.each(function(file) {
                        if (file.state === CONST.FILE_POPULATED || file.state === CONST.FILE_PENDING && this.inflight.size < this.maxParallelDownloads) {
                            this.inflight.set(file);
                            this.list.delete(file);
                            //  If the file doesn't have its own crossOrigin set, we'll use the Loaders (which is undefined by default)
                            if (!file.crossOrigin) file.crossOrigin = this.crossOrigin;
                            file.load();
                        }
                        if (this.inflight.size === this.maxParallelDownloads) //  Tells the Set iterator to abort
                        return false;
                    }, this);
                },
                /**
     * An internal method called automatically by the XHRLoader belong to a File.
     *
     * This method will remove the given file from the inflight Set and update the load progress.
     * If the file was successful its `onProcess` method is called, otherwise it is added to the delete queue.
     *
     * @method Phaser.Loader.LoaderPlugin#nextFile
     * @fires Phaser.Loader.Events#FILE_LOAD
     * @fires Phaser.Loader.Events#FILE_LOAD_ERROR
     * @since 3.0.0
     *
     * @param {Phaser.Loader.File} file - The File that just finished loading, or errored during load.
     * @param {boolean} success - `true` if the file loaded successfully, otherwise `false`.
     */ nextFile: function(file, success) {
                    //  Has the game been destroyed during load? If so, bail out now.
                    if (!this.inflight) return;
                    this.inflight.delete(file);
                    this.updateProgress();
                    if (success) {
                        this.totalComplete++;
                        this.queue.set(file);
                        this.emit(Events.FILE_LOAD, file);
                        file.onProcess();
                    } else {
                        this.totalFailed++;
                        this._deleteQueue.set(file);
                        this.emit(Events.FILE_LOAD_ERROR, file);
                        this.fileProcessComplete(file);
                    }
                },
                /**
     * An internal method that is called automatically by the File when it has finished processing.
     *
     * If the process was successful, and the File isn't part of a MultiFile, its `addToCache` method is called.
     *
     * It this then removed from the queue. If there are no more files to load `loadComplete` is called.
     *
     * @method Phaser.Loader.LoaderPlugin#fileProcessComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file that has finished processing.
     */ fileProcessComplete: function(file) {
                    //  Has the game been destroyed during load? If so, bail out now.
                    if (!this.scene || !this.systems || !this.systems.game || this.systems.game.pendingDestroy) return;
                    //  This file has failed, so move it to the failed Set
                    if (file.state === CONST.FILE_ERRORED) {
                        if (file.multiFile) file.multiFile.onFileFailed(file);
                    } else if (file.state === CONST.FILE_COMPLETE) {
                        if (file.multiFile) {
                            if (file.multiFile.isReadyToProcess()) //  If we got here then all files the link file needs are ready to add to the cache
                            file.multiFile.addToCache();
                        } else //  If we got here, then the file processed, so let it add itself to its cache
                        file.addToCache();
                    }
                    //  Remove it from the queue
                    this.queue.delete(file);
                    //  Nothing left to do?
                    if (this.list.size === 0 && this.inflight.size === 0 && this.queue.size === 0) this.loadComplete();
                },
                /**
     * Called at the end when the load queue is exhausted and all files have either loaded or errored.
     * By this point every loaded file will now be in its associated cache and ready for use.
     *
     * Also clears down the Sets, puts progress to 1 and clears the deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#loadComplete
     * @fires Phaser.Loader.Events#COMPLETE
     * @fires Phaser.Loader.Events#POST_PROCESS
     * @since 3.7.0
     */ loadComplete: function() {
                    this.emit(Events.POST_PROCESS, this);
                    this.list.clear();
                    this.inflight.clear();
                    this.queue.clear();
                    this.progress = 1;
                    this.state = CONST.LOADER_COMPLETE;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    //  Call 'destroy' on each file ready for deletion
                    this._deleteQueue.iterateLocal("destroy");
                    this._deleteQueue.clear();
                    this.emit(Events.COMPLETE, this, this.totalComplete, this.totalFailed);
                },
                /**
     * Adds a File into the pending-deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#flagForRemoval
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File to be queued for deletion when the Loader completes.
     */ flagForRemoval: function(file) {
                    this._deleteQueue.set(file);
                },
                /**
     * Converts the given JSON data into a file that the browser then prompts you to download so you can save it locally.
     *
     * The data must be well formed JSON and ready-parsed, not a JavaScript object.
     *
     * @method Phaser.Loader.LoaderPlugin#saveJSON
     * @since 3.0.0
     *
     * @param {*} data - The JSON data, ready parsed.
     * @param {string} [filename=file.json] - The name to save the JSON file as.
     *
     * @return {this} This Loader plugin.
     */ saveJSON: function(data, filename) {
                    return this.save(JSON.stringify(data), filename);
                },
                /**
     * Causes the browser to save the given data as a file to its default Downloads folder.
     *
     * Creates a DOM level anchor link, assigns it as being a `download` anchor, sets the href
     * to be an ObjectURL based on the given data, and then invokes a click event.
     *
     * @method Phaser.Loader.LoaderPlugin#save
     * @since 3.0.0
     *
     * @param {*} data - The data to be saved. Will be passed through URL.createObjectURL.
     * @param {string} [filename=file.json] - The filename to save the file as.
     * @param {string} [filetype=application/json] - The file type to use when saving the file. Defaults to JSON.
     *
     * @return {this} This Loader plugin.
     */ save: function(data, filename, filetype) {
                    if (filename === undefined) filename = "file.json";
                    if (filetype === undefined) filetype = "application/json";
                    var blob = new Blob([
                        data
                    ], {
                        type: filetype
                    });
                    var url = URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.download = filename;
                    a.textContent = "Download " + filename;
                    a.href = url;
                    a.click();
                    return this;
                },
                /**
     * Resets the Loader.
     *
     * This will clear all lists and reset the base URL, path and prefix.
     *
     * Warning: If the Loader is currently downloading files, or has files in its queue, they will be aborted.
     *
     * @method Phaser.Loader.LoaderPlugin#reset
     * @since 3.0.0
     */ reset: function() {
                    this.list.clear();
                    this.inflight.clear();
                    this.queue.clear();
                    var gameConfig = this.systems.game.config;
                    var sceneConfig = this.systems.settings.loader;
                    this.setBaseURL(GetFastValue(sceneConfig, "baseURL", gameConfig.loaderBaseURL));
                    this.setPath(GetFastValue(sceneConfig, "path", gameConfig.loaderPath));
                    this.setPrefix(GetFastValue(sceneConfig, "prefix", gameConfig.loaderPrefix));
                    this.state = CONST.LOADER_IDLE;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Loader.LoaderPlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.reset();
                    this.state = CONST.LOADER_SHUTDOWN;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Loader.LoaderPlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.state = CONST.LOADER_DESTROYED;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    this.systems.events.off(SceneEvents.START, this.pluginStart, this);
                    this.list = null;
                    this.inflight = null;
                    this.queue = null;
                    this.scene = null;
                    this.systems = null;
                    this.textureManager = null;
                    this.cacheManager = null;
                    this.sceneManager = null;
                }
            });
            PluginCache.register("Loader", LoaderPlugin, "load");
            module1.exports = LoaderPlugin;
        /***/ },
        /* 1366 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(62);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Physics.Arcade
 */ var Arcade = {
                ArcadePhysics: __webpack_require__(1367),
                Body: __webpack_require__(527),
                Collider: __webpack_require__(528),
                Components: __webpack_require__(243),
                Events: __webpack_require__(245),
                Factory: __webpack_require__(521),
                GetOverlapX: __webpack_require__(246),
                GetOverlapY: __webpack_require__(247),
                SeparateX: __webpack_require__(537),
                SeparateY: __webpack_require__(538),
                Group: __webpack_require__(524),
                Image: __webpack_require__(522),
                Sprite: __webpack_require__(157),
                StaticBody: __webpack_require__(539),
                StaticGroup: __webpack_require__(525),
                Tilemap: __webpack_require__(1391),
                World: __webpack_require__(526)
            };
            //   Merge in the consts
            Arcade = Extend(false, Arcade, CONST);
            module1.exports = Arcade;
        /***/ },
        /* 1367 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(36);
            var DistanceBetween = __webpack_require__(50);
            var DistanceSquared = __webpack_require__(353);
            var Factory = __webpack_require__(521);
            var GetFastValue = __webpack_require__(2);
            var Merge = __webpack_require__(127);
            var OverlapCirc = __webpack_require__(523);
            var OverlapRect = __webpack_require__(244);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            var Vector2 = __webpack_require__(3);
            var World = __webpack_require__(526);
            /**
 * @classdesc
 * The Arcade Physics Plugin belongs to a Scene and sets up and manages the Scene's physics simulation.
 * It also holds some useful methods for moving and rotating Arcade Physics Bodies.
 *
 * You can access it from within a Scene using `this.physics`.
 *
 * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
 * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
 * The separation that stops two objects penetrating may create a new penetration against a different object. If you
 * require a high level of stability please consider using an alternative physics system, such as Matter.js.
 *
 * @class ArcadePhysics
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Plugin belongs to.
 */ var ArcadePhysics = new Class({
                initialize: function ArcadePhysics(scene) {
                    /**
         * The Scene that this Plugin belongs to.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A configuration object. Union of the `physics.arcade.*` properties of the GameConfig and SceneConfig objects.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#config
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world;
                    /**
         * An object holding the Arcade Physics factory methods.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#add
         * @type {Phaser.Physics.Arcade.Factory}
         * @since 3.0.0
         */ this.add;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.world = new World(this.scene, this.config);
                    this.add = new Factory(this.world);
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    if (!this.world) {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                    }
                    var eventEmitter = this.systems.events;
                    if (!GetFastValue(this.config, "customUpdate", false)) eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Causes `World.update` to be automatically called each time the Scene
     * emits and `UPDATE` event. This is the default setting, so only needs
     * calling if you have specifically disabled it.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#enableUpdate
     * @since 3.50.0
     */ enableUpdate: function() {
                    this.systems.events.on(SceneEvents.UPDATE, this.world.update, this.world);
                },
                /**
     * Causes `World.update` to **not** be automatically called each time the Scene
     * emits and `UPDATE` event.
     *
     * If you wish to run the World update at your own rate, or from your own
     * component, then you should call this method to disable the built-in link,
     * and then call `World.update(delta, time)` accordingly.
     *
     * Note that `World.postUpdate` is always automatically called when the Scene
     * emits a `POST_UPDATE` event, regardless of this setting.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#disableUpdate
     * @since 3.50.0
     */ disableUpdate: function() {
                    this.systems.events.off(SceneEvents.UPDATE, this.world.update, this.world);
                },
                /**
     * Creates the physics configuration for the current Scene.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} The physics configuration.
     */ getConfig: function() {
                    var gameConfig = this.systems.game.config.physics;
                    var sceneConfig = this.systems.settings.physics;
                    var config = Merge(GetFastValue(sceneConfig, "arcade", {}), GetFastValue(gameConfig, "arcade", {}));
                    return config;
                },
                /**
     * Tests if Game Objects overlap. See {@link Phaser.Physics.Arcade.World#overlap}
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#overlap
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    return this.world.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                },
                /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link #overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided. The `collideCallback` is invoked if a collision occurs and the two colliding
     * objects are passed to it.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any overlapping Game Objects were separated, otherwise false.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    return this.world.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                },
                /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    return this.world.collideTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                },
                /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    return this.world.overlapTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                },
                /**
     * Pauses the simulation.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#pause
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ pause: function() {
                    return this.world.pause();
                },
                /**
     * Resumes the simulation (if paused).
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ resume: function() {
                    return this.world.resume();
                },
                /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to accelerate towards.
     * @param {number} y - The y coordinate to accelerate towards.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateTo: function(gameObject, x, y, speed, xSpeedMax, ySpeedMax) {
                    if (speed === undefined) speed = 60;
                    var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                    gameObject.body.acceleration.setToPolar(angle, speed);
                    if (xSpeedMax !== undefined && ySpeedMax !== undefined) gameObject.body.maxVelocity.set(xSpeedMax, ySpeedMax);
                    return angle;
                },
                /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {Phaser.GameObjects.GameObject} destination - The Game Object to move towards. Can be any object but must have visible x/y properties.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateToObject: function(gameObject, destination, speed, xSpeedMax, ySpeedMax) {
                    return this.accelerateTo(gameObject, destination.x, destination.y, speed, xSpeedMax, ySpeedMax);
                },
                /**
     * Finds the Body or Game Object closest to a source point or object.
     *
     * If a `targets` argument is passed, this method finds the closest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the closest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#closest
     * @since 3.0.0
     *
     * @param {any} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[]|Phaser.GameObjects.GameObject[])} [targets] - The targets.
     *
     * @return {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject)} The target closest to the given source point.
     */ closest: function(source, targets) {
                    if (!targets) targets = this.world.bodies.entries;
                    var min = Number.MAX_VALUE;
                    var closest = null;
                    var x = source.x;
                    var y = source.y;
                    var len = targets.length;
                    for(var i = 0; i < len; i++){
                        var target = targets[i];
                        var body = target.body || target;
                        if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                        var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                        if (distance < min) {
                            closest = target;
                            min = distance;
                        }
                    }
                    return closest;
                },
                /**
     * Finds the Body or Game Object farthest from a source point or object.
     *
     * If a `targets` argument is passed, this method finds the farthest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the farthest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#furthest
     * @since 3.0.0
     *
     * @param {any} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[]|Phaser.GameObjects.GameObject[])} [targets] - The targets.
     *
     * @return {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject)} The target farthest from the given source point.
     */ furthest: function(source, targets) {
                    if (!targets) targets = this.world.bodies.entries;
                    var max = -1;
                    var farthest = null;
                    var x = source.x;
                    var y = source.y;
                    var len = targets.length;
                    for(var i = 0; i < len; i++){
                        var target = targets[i];
                        var body = target.body || target;
                        if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                        var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                        if (distance > max) {
                            farthest = target;
                            max = distance;
                        }
                    }
                    return farthest;
                },
                /**
     * Move the given display object towards the x/y coordinates at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to move towards.
     * @param {number} y - The y coordinate to move towards.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveTo: function(gameObject, x, y, speed, maxTime) {
                    if (speed === undefined) speed = 60;
                    if (maxTime === undefined) maxTime = 0;
                    var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                    if (maxTime > 0) //  We know how many pixels we need to move, but how fast?
                    speed = DistanceBetween(gameObject.x, gameObject.y, x, y) / (maxTime / 1000);
                    gameObject.body.velocity.setToPolar(angle, speed);
                    return angle;
                },
                /**
     * Move the given display object towards the destination object at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (overwriting what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {object} destination - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveToObject: function(gameObject, destination, speed, maxTime) {
                    return this.moveTo(gameObject, destination.x, destination.y, speed, maxTime);
                },
                /**
     * Given the angle (in degrees) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromAngle(angle, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromAngle
     * @since 3.0.0
     *
     * @param {number} angle - The angle in degrees calculated in clockwise positive direction (down = 90 degrees positive, right = 0 degrees positive, up = 90 degrees negative)
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared.
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromAngle: function(angle, speed, vec2) {
                    if (speed === undefined) speed = 60;
                    if (vec2 === undefined) vec2 = new Vector2();
                    return vec2.setToPolar(DegToRad(angle), speed);
                },
                /**
     * Given the rotation (in radians) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromRotation(rotation, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromRotation
     * @since 3.0.0
     *
     * @param {number} rotation - The angle in radians.
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromRotation: function(rotation, speed, vec2) {
                    if (speed === undefined) speed = 60;
                    if (vec2 === undefined) vec2 = new Vector2();
                    return vec2.setToPolar(rotation, speed);
                },
                /**
     * This method will search the given rectangular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapRect
     * @since 3.17.0
     *
     * @param {number} x - The top-left x coordinate of the area to search within.
     * @param {number} y - The top-left y coordinate of the area to search within.
     * @param {number} width - The width of the area to search within.
     * @param {number} height - The height of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapRect: function(x, y, width, height, includeDynamic, includeStatic) {
                    return OverlapRect(this.world, x, y, width, height, includeDynamic, includeStatic);
                },
                /**
     * This method will search the given circular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapCirc
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate of the center of the area to search within.
     * @param {number} y - The y coordinate of the center of the area to search within.
     * @param {number} radius - The radius of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapCirc: function(x, y, radius, includeDynamic, includeStatic) {
                    return OverlapCirc(this.world, x, y, radius, includeDynamic, includeStatic);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    if (!this.world) //  Already destroyed
                    return;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.add.destroy();
                    this.world.destroy();
                    this.add = null;
                    this.world = null;
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("ArcadePhysics", ArcadePhysics, "arcadePhysics");
            module1.exports = ArcadePhysics;
        /***/ },
        /* 1368 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Acceleration
 * @since 3.0.0
 */ var Acceleration = {
                /**
     * Sets the body's horizontal and vertical acceleration. If the vertical acceleration value is not provided, the vertical acceleration is set to the same value as the horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal acceleration
     * @param {number} [y=x] - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAcceleration: function(x, y) {
                    this.body.acceleration.set(x, y);
                    return this;
                },
                /**
     * Sets the body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationX: function(value) {
                    this.body.acceleration.x = value;
                    return this;
                },
                /**
     * Sets the body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationY: function(value) {
                    this.body.acceleration.y = value;
                    return this;
                }
            };
            module1.exports = Acceleration;
        /***/ },
        /* 1369 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the angular acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Angular
 * @since 3.0.0
 */ var Angular = {
                /**
     * Sets the angular velocity of the body.
     * 
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular velocity.
     *
     * @return {this} This Game Object.
     */ setAngularVelocity: function(value) {
                    this.body.angularVelocity = value;
                    return this;
                },
                /**
     * Sets the angular acceleration of the body.
     * 
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular acceleration.
     *
     * @return {this} This Game Object.
     */ setAngularAcceleration: function(value) {
                    this.body.angularAcceleration = value;
                    return this;
                },
                /**
     * Sets the angular drag of the body. Drag is applied to the current velocity, providing a form of deceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The amount of drag.
     *
     * @return {this} This Game Object.
     */ setAngularDrag: function(value) {
                    this.body.angularDrag = value;
                    return this;
                }
            };
            module1.exports = Angular;
        /***/ },
        /* 1370 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the bounce properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                /**
     * Sets the bounce values of this body.
     * 
     * Bounce is the amount of restitution, or elasticity, the body has when it collides with another object.
     * A value of 1 means that it will retain its full velocity after the rebound. A value of 0 means it will not rebound at all.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     * @param {number} [y=x] - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounce: function(x, y) {
                    this.body.bounce.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceX: function(value) {
                    this.body.bounce.x = value;
                    return this;
                },
                /**
     * Sets the vertical bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceY: function(value) {
                    this.body.bounce.y = value;
                    return this;
                },
                /**
     * Sets whether this Body collides with the world boundary.
     * 
     * Optionally also sets the World Bounce values. If the `Body.worldBounce` is null, it's set to a new Phaser.Math.Vector2 first.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if this body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this will be replace the `worldBounce.x` value.
     * @param {number} [bounceY] - If given this will be replace the `worldBounce.y` value.
     *
     * @return {this} This Game Object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY) {
                    this.body.setCollideWorldBounds(value, bounceX, bounceY);
                    return this;
                }
            };
            module1.exports = Bounce;
        /***/ },
        /* 1371 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the debug properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Debug
 * @since 3.0.0
 */ var Debug = {
                /**
     * Sets the debug values of this body.
     * 
     * Bodies will only draw their debug if debug has been enabled for Arcade Physics as a whole.
     * Note that there is a performance cost in drawing debug displays. It should never be used in production.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebug
     * @since 3.0.0
     *
     * @param {boolean} showBody - Set to `true` to have this body render its outline to the debug display.
     * @param {boolean} showVelocity - Set to `true` to have this body render a velocity marker to the debug display.
     * @param {number} bodyColor - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebug: function(showBody, showVelocity, bodyColor) {
                    this.debugShowBody = showBody;
                    this.debugShowVelocity = showVelocity;
                    this.debugBodyColor = bodyColor;
                    return this;
                },
                /**
     * Sets the color of the body outline when it renders to the debug display.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebugBodyColor
     * @since 3.0.0
     *
     * @param {number} value - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebugBodyColor: function(value) {
                    this.body.debugBodyColor = value;
                    return this;
                },
                /**
     * Set to `true` to have this body render its outline to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowBody
     * @type {boolean}
     * @since 3.0.0
     */ debugShowBody: {
                    get: function() {
                        return this.body.debugShowBody;
                    },
                    set: function(value) {
                        this.body.debugShowBody = value;
                    }
                },
                /**
     * Set to `true` to have this body render a velocity marker to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowVelocity
     * @type {boolean}
     * @since 3.0.0
     */ debugShowVelocity: {
                    get: function() {
                        return this.body.debugShowVelocity;
                    },
                    set: function(value) {
                        this.body.debugShowVelocity = value;
                    }
                },
                /**
     * The color of the body outline when it renders to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugBodyColor
     * @type {number}
     * @since 3.0.0
     */ debugBodyColor: {
                    get: function() {
                        return this.body.debugBodyColor;
                    },
                    set: function(value) {
                        this.body.debugBodyColor = value;
                    }
                }
            };
            module1.exports = Debug;
        /***/ },
        /* 1372 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the drag properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Drag
 * @since 3.0.0
 */ var Drag = {
                /**
     * Sets the body's horizontal and vertical drag. If the vertical drag value is not provided, the vertical drag is set to the same value as the horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal drag to apply.
     * @param {number} [y=x] - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDrag: function(x, y) {
                    this.body.drag.set(x, y);
                    return this;
                },
                /**
     * Sets the body's horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragX: function(value) {
                    this.body.drag.x = value;
                    return this;
                },
                /**
     * Sets the body's vertical drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragY: function(value) {
                    this.body.drag.y = value;
                    return this;
                },
                /**
     * If this Body is using `drag` for deceleration this function controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDamping
     * @since 3.10.0
     *
     * @param {boolean} value - `true` to use damping for deceleration, or `false` to use linear deceleration.
     *
     * @return {this} This Game Object.
     */ setDamping: function(value) {
                    this.body.useDamping = value;
                    return this;
                }
            };
            module1.exports = Drag;
        /***/ },
        /* 1373 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the enable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Enable
 * @since 3.0.0
 */ var Enable = {
                /**
     * Enables this Game Object's Body.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#enableBody
     * @since 3.0.0
     *
     * @param {boolean} reset - Also reset the Body and place it at (x, y).
     * @param {number} x - The horizontal position to place the Game Object and Body.
     * @param {number} y - The horizontal position to place the Game Object and Body.
     * @param {boolean} enableGameObject - Also activate this Game Object.
     * @param {boolean} showGameObject - Also show this Game Object.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.Physics.Arcade.Body#reset
     * @see Phaser.Physics.Arcade.StaticBody#reset
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ enableBody: function(reset, x, y, enableGameObject, showGameObject) {
                    if (reset) this.body.reset(x, y);
                    if (enableGameObject) this.body.gameObject.active = true;
                    if (showGameObject) this.body.gameObject.visible = true;
                    this.body.enable = true;
                    return this;
                },
                /**
     * Stops and disables this Game Object's Body.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#disableBody
     * @since 3.0.0
     *
     * @param {boolean} [disableGameObject=false] - Also deactivate this Game Object.
     * @param {boolean} [hideGameObject=false] - Also hide this Game Object.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ disableBody: function(disableGameObject, hideGameObject) {
                    if (disableGameObject === undefined) disableGameObject = false;
                    if (hideGameObject === undefined) hideGameObject = false;
                    this.body.stop();
                    this.body.enable = false;
                    if (disableGameObject) this.body.gameObject.active = false;
                    if (hideGameObject) this.body.gameObject.visible = false;
                    return this;
                },
                /**
     * Syncs the Body's position and size with its parent Game Object.
     * You don't need to call this for Dynamic Bodies, as it happens automatically.
     * But for Static bodies it's a useful way of modifying the position of a Static Body
     * in the Physics World, based on its Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#refreshBody
     * @since 3.1.0
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ refreshBody: function() {
                    this.body.updateFromGameObject();
                    return this;
                }
            };
            module1.exports = Enable;
        /***/ },
        /* 1374 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Methods for setting the friction of an Arcade Physics Body.
 *
 * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Friction
 * @since 3.0.0
 *
 * @see Phaser.Physics.Arcade.Body#friction
 */ var Friction = {
                /**
     * Sets the friction of this game object's physics body.
     * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal friction to apply, [0, 1].
     * @param {number} [y=x] - The amount of vertical friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFriction: function(x, y) {
                    this.body.friction.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal friction of this game object's physics body.
     * This can move a riding body horizontally when it collides with this one on the vertical axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionX
     * @since 3.0.0
     *
     * @param {number} x - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionX: function(x) {
                    this.body.friction.x = x;
                    return this;
                },
                /**
     * Sets the vertical friction of this game object's physics body.
     * This can move a riding body vertically when it collides with this one on the horizontal axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionY
     * @since 3.0.0
     *
     * @param {number} y - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionY: function(y) {
                    this.body.friction.y = y;
                    return this;
                }
            };
            module1.exports = Friction;
        /***/ },
        /* 1375 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the gravity properties of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                /**
     * Set the X and Y values of the gravitational pull to act upon this Arcade Physics Game Object. Values can be positive or negative. Larger values result in a stronger effect.
     * 
     * If only one value is provided, this value will be used for both the X and Y axis.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     * @param {number} [y=x] - The gravitational force to be applied to the Y-axis. If this is not specified, the X value will be used.
     *
     * @return {this} This Game Object.
     */ setGravity: function(x, y) {
                    this.body.gravity.set(x, y);
                    return this;
                },
                /**
     * Set the gravitational force to be applied to the X axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityX
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     *
     * @return {this} This Game Object.
     */ setGravityX: function(x) {
                    this.body.gravity.x = x;
                    return this;
                },
                /**
     * Set the gravitational force to be applied to the Y axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityY
     * @since 3.0.0
     *
     * @param {number} y - The gravitational force to be applied to the Y-axis.
     *
     * @return {this} This Game Object.
     */ setGravityY: function(y) {
                    this.body.gravity.y = y;
                    return this;
                }
            };
            module1.exports = Gravity;
        /***/ },
        /* 1376 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the immovable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Immovable
 * @since 3.0.0
 */ var Immovable = {
                /**
     * Sets if this Body can be separated during collisions with other bodies.
     *
     * When a body is immovable it means it won't move at all, not even to separate it from collision
     * overlap. If you just wish to prevent a body from being knocked around by other bodies, see
     * the `setPushable` method instead.
     *
     * @method Phaser.Physics.Arcade.Components.Immovable#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Sets if this body will be separated during collisions with other bodies.
     *
     * @return {this} This Game Object.
     */ setImmovable: function(value) {
                    if (value === undefined) value = true;
                    this.body.immovable = value;
                    return this;
                }
            };
            module1.exports = Immovable;
        /***/ },
        /* 1377 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the mass properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                /**
     * Sets the mass of the physics body
     *
     * @method Phaser.Physics.Arcade.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - New value for the mass of the body.
     *
     * @return {this} This Game Object.
     */ setMass: function(value) {
                    this.body.mass = value;
                    return this;
                }
            };
            module1.exports = Mass;
        /***/ },
        /* 1378 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the pushable property of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Pushable
 * @since 3.50.0
 */ var Pushable = {
                /**
     * Sets if this Body can be pushed by another Body.
     *
     * A body that cannot be pushed will reflect back all of the velocity it is given to the
     * colliding body. If that body is also not pushable, then the separation will be split
     * between them evenly.
     *
     * If you want your body to never move or seperate at all, see the `setImmovable` method.
     *
     * @method Phaser.Physics.Arcade.Components.Pushable#setPushable
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Sets if this body can be pushed by collisions with another Body.
     *
     * @return {this} This Game Object.
     */ setPushable: function(value) {
                    if (value === undefined) value = true;
                    this.body.pushable = value;
                    return this;
                }
            };
            module1.exports = Pushable;
        /***/ },
        /* 1379 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the size of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Size
 * @since 3.0.0
 */ var Size = {
                /**
     * Sets the body offset. This allows you to adjust the difference between the center of the body
     * and the x and y coordinates of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [y=x] - The amount to offset the body from the parent Game Object along the y-axis. Defaults to the value given for the x-axis.
     *
     * @return {this} This Game Object.
     */ setOffset: function(x, y) {
                    this.body.setOffset(x, y);
                    return this;
                },
                /**
     * **DEPRECATED**: Please use `setBodySize` instead.
     *
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setSize
     * @since 3.0.0
     * @deprecated
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, center) {
                    this.body.setSize(width, height, center);
                    return this;
                },
                /**
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setBodySize
     * @since 3.24.0
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setBodySize: function(width, height, center) {
                    this.body.setSize(width, height, center);
                    return this;
                },
                /**
     * Sets this physics body to use a circle for collision instead of a rectangle.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the physics body, in pixels.
     * @param {number} [offsetX] - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [offsetY] - The amount to offset the body from the parent Game Object along the y-axis.
     *
     * @return {this} This Game Object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    this.body.setCircle(radius, offsetX, offsetY);
                    return this;
                }
            };
            module1.exports = Size;
        /***/ },
        /* 1380 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for modifying the velocity of an Arcade Physics body.
 *
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                /**
     * Sets the velocity of the Body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity of the body. Positive values move the body to the right, while negative values move it to the left.
     * @param {number} [y=x] - The vertical velocity of the body. Positive values move the body down, while negative values move it up.
     *
     * @return {this} This Game Object.
     */ setVelocity: function(x, y) {
                    this.body.setVelocity(x, y);
                    return this;
                },
                /**
     * Sets the horizontal component of the body's velocity.
     *
     * Positive values move the body to the right, while negative values move it to the left.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The new horizontal velocity.
     *
     * @return {this} This Game Object.
     */ setVelocityX: function(x) {
                    this.body.setVelocityX(x);
                    return this;
                },
                /**
     * Sets the vertical component of the body's velocity.
     *
     * Positive values move the body down, while negative values move it up.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The new vertical velocity of the body.
     *
     * @return {this} This Game Object.
     */ setVelocityY: function(y) {
                    this.body.setVelocityY(y);
                    return this;
                },
                /**
     * Sets the maximum velocity of the body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setMaxVelocity
     * @since 3.0.0
     *
     * @param {number} x - The new maximum horizontal velocity.
     * @param {number} [y=x] - The new maximum vertical velocity.
     *
     * @return {this} This Game Object.
     */ setMaxVelocity: function(x, y) {
                    this.body.maxVelocity.set(x, y);
                    return this;
                }
            };
            module1.exports = Velocity;
        /***/ },
        /* 1381 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Collide Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if two bodies collide _and_ at least
 * one of them has their [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('collide', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#COLLIDE
 * @since 3.0.0
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the collision. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the collision. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the collision.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the collision.
 */ module1.exports = "collide";
        /***/ },
        /* 1382 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Overlap Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if two bodies overlap _and_ at least
 * one of them has their [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 * 
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('overlap', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#OVERLAP
 * @since 3.0.0
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the overlap. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the overlap. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the overlap.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the overlap.
 */ module1.exports = "overlap";
        /***/ },
        /* 1383 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Pause Event.
 * 
 * This event is dispatched by an Arcade Physics World instance when it is paused.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = "pause";
        /***/ },
        /* 1384 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Resume Event.
 * 
 * This event is dispatched by an Arcade Physics World instance when it resumes from a paused state.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#RESUME
 * @since 3.0.0
 */ module1.exports = "resume";
        /***/ },
        /* 1385 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Collide Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body collides with a Tile _and_
 * has its [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('tilecollide', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_COLLIDE
 * @since 3.16.1
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the collision. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body collided with.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the collision.
 */ module1.exports = "tilecollide";
        /***/ },
        /* 1386 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Overlap Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body overlaps with a Tile _and_
 * has its [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 * 
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('tileoverlap', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_OVERLAP
 * @since 3.16.1
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the overlap. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body overlapped.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the overlap.
 */ module1.exports = "tileoverlap";
        /***/ },
        /* 1387 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Bounds Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body makes contact with the world bounds _and_
 * it has its [onWorldBounds]{@link Phaser.Physics.Arcade.Body#onWorldBounds} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('worldbounds', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_BOUNDS
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body that hit the world bounds.
 * @param {boolean} up - Is the Body blocked up? I.e. collided with the top of the world bounds.
 * @param {boolean} down - Is the Body blocked down? I.e. collided with the bottom of the world bounds.
 * @param {boolean} left - Is the Body blocked left? I.e. collided with the left of the world bounds.
 * @param {boolean} right - Is the Body blocked right? I.e. collided with the right of the world bounds.
 */ module1.exports = "worldbounds";
        /***/ },
        /* 1388 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Step Event.
 *
 * This event is dispatched by an Arcade Physics World instance whenever a physics step is run.
 * It is emitted _after_ the bodies and colliders have been updated.
 *
 * In high framerate settings this can be multiple times per game frame.
 *
 * Listen to it from a Scene using: `this.physics.world.on('worldstep', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_STEP
 * @since 3.18.0
 *
 * @param {number} delta - The delta time amount of this step, in seconds.
 */ module1.exports = "worldstep";
        /***/ },
        /* 1389 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
            var body2;
            var body1Pushable;
            var body2Pushable;
            var body1MassImpact;
            var body2MassImpact;
            var body1FullImpact;
            var body2FullImpact;
            var body1MovingLeft;
            var body1MovingRight;
            var body1Stationary;
            var body2MovingLeft;
            var body2MovingRight;
            var body2Stationary;
            var body1OnLeft;
            var body2OnLeft;
            var overlap;
            /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateX` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                body1 = b1;
                body2 = b2;
                var v1 = body1.velocity.x;
                var v2 = body2.velocity.x;
                body1Pushable = body1.pushable;
                body1MovingLeft = body1._dx < 0;
                body1MovingRight = body1._dx > 0;
                body1Stationary = body1._dx === 0;
                body1OnLeft = Math.abs(body1.right - body2.x) <= Math.abs(body2.right - body1.x);
                body1FullImpact = v2 - v1 * body1.bounce.x;
                body2Pushable = body2.pushable;
                body2MovingLeft = body2._dx < 0;
                body2MovingRight = body2._dx > 0;
                body2Stationary = body2._dx === 0;
                body2OnLeft = !body1OnLeft;
                body2FullImpact = v1 - v2 * body2.bounce.x;
                //  negative delta = up, positive delta = down (inc. gravity)
                overlap = Math.abs(ov);
                return BlockCheck();
            };
            /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessX.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                //  Body1 is moving right and Body2 is blocked from going right any further
                if (body1MovingRight && body1OnLeft && body2.blocked.right) {
                    body1.processX(-overlap, body1FullImpact, false, true);
                    return 1;
                }
                //  Body1 is moving up and Body2 is blocked from going up any further
                if (body1MovingLeft && body2OnLeft && body2.blocked.left) {
                    body1.processX(overlap, body1FullImpact, true);
                    return 1;
                }
                //  Body2 is moving right and Body1 is blocked from going right any further
                if (body2MovingRight && body2OnLeft && body1.blocked.right) {
                    body2.processX(-overlap, body2FullImpact, false, true);
                    return 2;
                }
                //  Body2 is moving up and Body1 is blocked from going up any further
                if (body2MovingLeft && body1OnLeft && body1.blocked.left) {
                    body2.processX(overlap, body2FullImpact, true);
                    return 2;
                }
                return 0;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                var v1 = body1.velocity.x;
                var v2 = body2.velocity.x;
                var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                var avg = (nv1 + nv2) * 0.5;
                nv1 -= avg;
                nv2 -= avg;
                body1MassImpact = avg + nv1 * body1.bounce.x;
                body2MassImpact = avg + nv2 * body2.bounce.x;
                //  Body1 hits Body2 on the right hand side
                if (body1MovingLeft && body2OnLeft) return Run(0);
                //  Body2 hits Body1 on the right hand side
                if (body2MovingLeft && body1OnLeft) return Run(1);
                //  Body1 hits Body2 on the left hand side
                if (body1MovingRight && body1OnLeft) return Run(2);
                //  Body2 hits Body1 on the left hand side
                if (body2MovingRight && body2OnLeft) return Run(3);
                return false;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                if (body1Pushable && body2Pushable) {
                    //  Both pushable, or both moving at the same time, so equal rebound
                    overlap *= 0.5;
                    if (side === 0 || side === 3) {
                        //  body1MovingLeft && body2OnLeft
                        //  body2MovingRight && body2OnLeft
                        body1.processX(overlap, body1MassImpact);
                        body2.processX(-overlap, body2MassImpact);
                    } else {
                        //  body2MovingLeft && body1OnLeft
                        //  body1MovingRight && body1OnLeft
                        body1.processX(-overlap, body1MassImpact);
                        body2.processX(overlap, body2MassImpact);
                    }
                } else if (body1Pushable && !body2Pushable) {
                    //  Body1 pushable, Body2 not
                    if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                    //  body2MovingRight && body2OnLeft
                    body1.processX(overlap, body1FullImpact, true);
                    else //  body2MovingLeft && body1OnLeft
                    //  body1MovingRight && body1OnLeft
                    body1.processX(-overlap, body1FullImpact, false, true);
                } else if (!body1Pushable && body2Pushable) {
                    //  Body2 pushable, Body1 not
                    if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                    //  body2MovingRight && body2OnLeft
                    body2.processX(-overlap, body2FullImpact, false, true);
                    else //  body2MovingLeft && body1OnLeft
                    //  body1MovingRight && body1OnLeft
                    body2.processX(overlap, body2FullImpact, true);
                } else {
                    //  Neither body is pushable, so base it on movement
                    var halfOverlap = overlap * 0.5;
                    if (side === 0) {
                        //  body1MovingLeft && body2OnLeft
                        if (body2Stationary) {
                            body1.processX(overlap, 0, true);
                            body2.processX(0, null, false, true);
                        } else if (body2MovingRight) {
                            body1.processX(halfOverlap, 0, true);
                            body2.processX(-halfOverlap, 0, false, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processX(halfOverlap, body2.velocity.x, true);
                            body2.processX(-halfOverlap, null, false, true);
                        }
                    } else if (side === 1) {
                        //  body2MovingLeft && body1OnLeft
                        if (body1Stationary) {
                            body1.processX(0, null, false, true);
                            body2.processX(overlap, 0, true);
                        } else if (body1MovingRight) {
                            body1.processX(-halfOverlap, 0, false, true);
                            body2.processX(halfOverlap, 0, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processX(-halfOverlap, null, false, true);
                            body2.processX(halfOverlap, body1.velocity.x, true);
                        }
                    } else if (side === 2) {
                        //  body1MovingRight && body1OnLeft
                        if (body2Stationary) {
                            body1.processX(-overlap, 0, false, true);
                            body2.processX(0, null, true);
                        } else if (body2MovingLeft) {
                            body1.processX(-halfOverlap, 0, false, true);
                            body2.processX(halfOverlap, 0, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processX(-halfOverlap, body2.velocity.x, false, true);
                            body2.processX(halfOverlap, null, true);
                        }
                    } else if (side === 3) {
                        //  body2MovingRight && body2OnLeft
                        if (body1Stationary) {
                            body1.processX(0, null, true);
                            body2.processX(-overlap, 0, false, true);
                        } else if (body1MovingLeft) {
                            body1.processX(halfOverlap, 0, true);
                            body2.processX(-halfOverlap, 0, false, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processX(halfOverlap, body2.velocity.y, true);
                            body2.processX(-halfOverlap, null, false, true);
                        }
                    }
                }
                return true;
            };
            /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body2.velocity.x = 0;
                else if (body1OnLeft) body2.processX(overlap, body2FullImpact, true);
                else body2.processX(-overlap, body2FullImpact, false, true);
                //  This is special case code that handles things like vertically moving platforms you can ride
                if (body1.moves) {
                    body2.y += (body1.y - body1.prev.y) * body1.friction.y;
                    body2._dy = body2.y - body2.prev.y;
                }
            };
            /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body1.velocity.x = 0;
                else if (body2OnLeft) body1.processX(overlap, body1FullImpact, true);
                else body1.processX(-overlap, body1FullImpact, false, true);
                //  This is special case code that handles things like vertically moving platforms you can ride
                if (body2.moves) {
                    body1.y += (body2.y - body2.prev.y) * body2.friction.y;
                    body1._dy = body1.y - body1.prev.y;
                }
            };
            /**
 * @namespace Phaser.Physics.Arcade.ProcessX
 * @ignore
 */ module1.exports = {
                BlockCheck: BlockCheck,
                Check: Check,
                Set: Set,
                Run: Run,
                RunImmovableBody1: RunImmovableBody1,
                RunImmovableBody2: RunImmovableBody2
            };
        /***/ },
        /* 1390 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
            var body2;
            var body1Pushable;
            var body2Pushable;
            var body1MassImpact;
            var body2MassImpact;
            var body1FullImpact;
            var body2FullImpact;
            var body1MovingUp;
            var body1MovingDown;
            var body1Stationary;
            var body2MovingUp;
            var body2MovingDown;
            var body2Stationary;
            var body1OnTop;
            var body2OnTop;
            var overlap;
            /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateY` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                body1 = b1;
                body2 = b2;
                var v1 = body1.velocity.y;
                var v2 = body2.velocity.y;
                body1Pushable = body1.pushable;
                body1MovingUp = body1._dy < 0;
                body1MovingDown = body1._dy > 0;
                body1Stationary = body1._dy === 0;
                body1OnTop = Math.abs(body1.bottom - body2.y) <= Math.abs(body2.bottom - body1.y);
                body1FullImpact = v2 - v1 * body1.bounce.y;
                body2Pushable = body2.pushable;
                body2MovingUp = body2._dy < 0;
                body2MovingDown = body2._dy > 0;
                body2Stationary = body2._dy === 0;
                body2OnTop = !body1OnTop;
                body2FullImpact = v1 - v2 * body2.bounce.y;
                //  negative delta = up, positive delta = down (inc. gravity)
                overlap = Math.abs(ov);
                return BlockCheck();
            };
            /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessY.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                //  Body1 is moving down and Body2 is blocked from going down any further
                if (body1MovingDown && body1OnTop && body2.blocked.down) {
                    body1.processY(-overlap, body1FullImpact, false, true);
                    return 1;
                }
                //  Body1 is moving up and Body2 is blocked from going up any further
                if (body1MovingUp && body2OnTop && body2.blocked.up) {
                    body1.processY(overlap, body1FullImpact, true);
                    return 1;
                }
                //  Body2 is moving down and Body1 is blocked from going down any further
                if (body2MovingDown && body2OnTop && body1.blocked.down) {
                    body2.processY(-overlap, body2FullImpact, false, true);
                    return 2;
                }
                //  Body2 is moving up and Body1 is blocked from going up any further
                if (body2MovingUp && body1OnTop && body1.blocked.up) {
                    body2.processY(overlap, body2FullImpact, true);
                    return 2;
                }
                return 0;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                var v1 = body1.velocity.y;
                var v2 = body2.velocity.y;
                var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                var avg = (nv1 + nv2) * 0.5;
                nv1 -= avg;
                nv2 -= avg;
                body1MassImpact = avg + nv1 * body1.bounce.y;
                body2MassImpact = avg + nv2 * body2.bounce.y;
                //  Body1 hits Body2 on the bottom side
                if (body1MovingUp && body2OnTop) return Run(0);
                //  Body2 hits Body1 on the bottom side
                if (body2MovingUp && body1OnTop) return Run(1);
                //  Body1 hits Body2 on the top side
                if (body1MovingDown && body1OnTop) return Run(2);
                //  Body2 hits Body1 on the top side
                if (body2MovingDown && body2OnTop) return Run(3);
                return false;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                if (body1Pushable && body2Pushable) {
                    //  Both pushable, or both moving at the same time, so equal rebound
                    overlap *= 0.5;
                    if (side === 0 || side === 3) {
                        //  body1MovingUp && body2OnTop
                        //  body2MovingDown && body2OnTop
                        body1.processY(overlap, body1MassImpact);
                        body2.processY(-overlap, body2MassImpact);
                    } else {
                        //  body2MovingUp && body1OnTop
                        //  body1MovingDown && body1OnTop
                        body1.processY(-overlap, body1MassImpact);
                        body2.processY(overlap, body2MassImpact);
                    }
                } else if (body1Pushable && !body2Pushable) {
                    //  Body1 pushable, Body2 not
                    if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                    //  body2MovingDown && body2OnTop
                    body1.processY(overlap, body1FullImpact, true);
                    else //  body2MovingUp && body1OnTop
                    //  body1MovingDown && body1OnTop
                    body1.processY(-overlap, body1FullImpact, false, true);
                } else if (!body1Pushable && body2Pushable) {
                    //  Body2 pushable, Body1 not
                    if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                    //  body2MovingDown && body2OnTop
                    body2.processY(-overlap, body2FullImpact, false, true);
                    else //  body2MovingUp && body1OnTop
                    //  body1MovingDown && body1OnTop
                    body2.processY(overlap, body2FullImpact, true);
                } else {
                    //  Neither body is pushable, so base it on movement
                    var halfOverlap = overlap * 0.5;
                    if (side === 0) {
                        //  body1MovingUp && body2OnTop
                        if (body2Stationary) {
                            body1.processY(overlap, 0, true);
                            body2.processY(0, null, false, true);
                        } else if (body2MovingDown) {
                            body1.processY(halfOverlap, 0, true);
                            body2.processY(-halfOverlap, 0, false, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processY(halfOverlap, body2.velocity.y, true);
                            body2.processY(-halfOverlap, null, false, true);
                        }
                    } else if (side === 1) {
                        //  body2MovingUp && body1OnTop
                        if (body1Stationary) {
                            body1.processY(0, null, false, true);
                            body2.processY(overlap, 0, true);
                        } else if (body1MovingDown) {
                            body1.processY(-halfOverlap, 0, false, true);
                            body2.processY(halfOverlap, 0, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processY(-halfOverlap, null, false, true);
                            body2.processY(halfOverlap, body1.velocity.y, true);
                        }
                    } else if (side === 2) {
                        //  body1MovingDown && body1OnTop
                        if (body2Stationary) {
                            body1.processY(-overlap, 0, false, true);
                            body2.processY(0, null, true);
                        } else if (body2MovingUp) {
                            body1.processY(-halfOverlap, 0, false, true);
                            body2.processY(halfOverlap, 0, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processY(-halfOverlap, body2.velocity.y, false, true);
                            body2.processY(halfOverlap, null, true);
                        }
                    } else if (side === 3) {
                        //  body2MovingDown && body2OnTop
                        if (body1Stationary) {
                            body1.processY(0, null, true);
                            body2.processY(-overlap, 0, false, true);
                        } else if (body1MovingUp) {
                            body1.processY(halfOverlap, 0, true);
                            body2.processY(-halfOverlap, 0, false, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processY(halfOverlap, body2.velocity.y, true);
                            body2.processY(-halfOverlap, null, false, true);
                        }
                    }
                }
                return true;
            };
            /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body2.velocity.y = 0;
                else if (body1OnTop) body2.processY(overlap, body2FullImpact, true);
                else body2.processY(-overlap, body2FullImpact, false, true);
                //  This is special case code that handles things like horizontally moving platforms you can ride
                if (body1.moves) {
                    body2.x += (body1.x - body1.prev.x) * body1.friction.x;
                    body2._dx = body2.x - body2.prev.x;
                }
            };
            /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body1.velocity.y = 0;
                else if (body2OnTop) body1.processY(overlap, body1FullImpact, true);
                else body1.processY(-overlap, body1FullImpact, false, true);
                //  This is special case code that handles things like horizontally moving platforms you can ride
                if (body2.moves) {
                    body1.x += (body2.x - body2.prev.x) * body2.friction.x;
                    body1._dx = body1.x - body1.prev.x;
                }
            };
            /**
 * @namespace Phaser.Physics.Arcade.ProcessY
 * @ignore
 */ module1.exports = {
                BlockCheck: BlockCheck,
                Check: Check,
                Set: Set,
                Run: Run,
                RunImmovableBody1: RunImmovableBody1,
                RunImmovableBody2: RunImmovableBody2
            };
        /***/ },
        /* 1391 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Tilemap
 */ var Tilemap = {
                ProcessTileCallbacks: __webpack_require__(530),
                ProcessTileSeparationX: __webpack_require__(534),
                ProcessTileSeparationY: __webpack_require__(536),
                SeparateTile: __webpack_require__(532),
                TileCheckX: __webpack_require__(533),
                TileCheckY: __webpack_require__(535),
                TileIntersectsBody: __webpack_require__(248)
            };
            module1.exports = Tilemap;
        /***/ },
        /* 1392 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * 
 * The Body Bounds class contains methods to help you extract the world coordinates from various points around
 * the bounds of a Matter Body. Because Matter bodies are positioned based on their center of mass, and not a
 * dimension based center, you often need to get the bounds coordinates in order to properly align them in the world.
 * 
 * You can access this class via the MatterPhysics class from a Scene, i.e.:
 * 
 * ```javascript
 * this.matter.bodyBounds.getTopLeft(body);
 * ```
 * 
 * See also the `MatterPhysics.alignBody` method.
 *
 * @class BodyBounds
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.22.0
 */ var BodyBounds = new Class({
                initialize: function BodyBounds() {
                    /**
         * A Vector2 that stores the temporary bounds center value during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#boundsCenter
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.boundsCenter = new Vector2();
                    /**
         * A Vector2 that stores the temporary center diff values during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#centerDiff
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.centerDiff = new Vector2();
                },
                /**
     * Parses the given body to get the bounds diff values from it.
     * 
     * They're stored in this class in the temporary properties `boundsCenter` and `centerDiff`.
     * 
     * This method is called automatically by all other methods in this class.
     *
     * @method Phaser.Physics.Matter.BodyBounds#parseBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the bounds position from.
     *
     * @return {boolean} `true` if it was able to get the bounds, otherwise `false`.
     */ parseBody: function(body) {
                    body = body.hasOwnProperty("body") ? body.body : body;
                    if (!body.hasOwnProperty("bounds") || !body.hasOwnProperty("centerOfMass")) return false;
                    var boundsCenter = this.boundsCenter;
                    var centerDiff = this.centerDiff;
                    var boundsWidth = body.bounds.max.x - body.bounds.min.x;
                    var boundsHeight = body.bounds.max.y - body.bounds.min.y;
                    var bodyCenterX = boundsWidth * body.centerOfMass.x;
                    var bodyCenterY = boundsHeight * body.centerOfMass.y;
                    boundsCenter.set(boundsWidth / 2, boundsHeight / 2);
                    centerDiff.set(bodyCenterX - boundsCenter.x, bodyCenterY - boundsCenter.y);
                    return true;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-left of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopLeft: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-right of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopRight: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the left-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getLeftCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getLeftCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the right-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getRightCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getRightCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-left of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomLeft: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y - (center.y - diff.y));
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y - (center.y - diff.y));
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-right of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomRight: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y - (center.y - diff.y));
                    }
                    return false;
                }
            });
            module1.exports = BodyBounds;
        /***/ },
        /* 1393 */ /***/ function(module1, exports) {
            /**
 * @author       Stefan Hedman <schteppe@gmail.com> (http://steffe.se)
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  v0.3.0
            module1.exports = {
                decomp: polygonDecomp,
                quickDecomp: polygonQuickDecomp,
                isSimple: polygonIsSimple,
                removeCollinearPoints: polygonRemoveCollinearPoints,
                removeDuplicatePoints: polygonRemoveDuplicatePoints,
                makeCCW: polygonMakeCCW
            };
            /**
 * Compute the intersection between two lines.
 * @static
 * @method lineInt
 * @param  {Array}  l1          Line vector 1
 * @param  {Array}  l2          Line vector 2
 * @param  {Number} precision   Precision to use when checking if the lines are parallel
 * @return {Array}              The intersection point.
 */ function lineInt(l1, l2, precision) {
                precision = precision || 0;
                var i = [
                    0,
                    0
                ]; // point
                var a1, b1, c1, a2, b2, c2, det; // scalars
                a1 = l1[1][1] - l1[0][1];
                b1 = l1[0][0] - l1[1][0];
                c1 = a1 * l1[0][0] + b1 * l1[0][1];
                a2 = l2[1][1] - l2[0][1];
                b2 = l2[0][0] - l2[1][0];
                c2 = a2 * l2[0][0] + b2 * l2[0][1];
                det = a1 * b2 - a2 * b1;
                if (!scalar_eq(det, 0, precision)) {
                    i[0] = (b2 * c1 - b1 * c2) / det;
                    i[1] = (a1 * c2 - a2 * c1) / det;
                }
                return i;
            }
            /**
 * Checks if two line segments intersects.
 * @method segmentsIntersect
 * @param {Array} p1 The start vertex of the first line segment.
 * @param {Array} p2 The end vertex of the first line segment.
 * @param {Array} q1 The start vertex of the second line segment.
 * @param {Array} q2 The end vertex of the second line segment.
 * @return {Boolean} True if the two line segments intersect
 */ function lineSegmentsIntersect(p1, p2, q1, q2) {
                var dx = p2[0] - p1[0];
                var dy = p2[1] - p1[1];
                var da = q2[0] - q1[0];
                var db = q2[1] - q1[1];
                // segments are parallel
                if (da * dy - db * dx === 0) return false;
                var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
                var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
                return s >= 0 && s <= 1 && t >= 0 && t <= 1;
            }
            /**
 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
 * @static
 * @method area
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return {Number}
 */ function triangleArea(a, b, c) {
                return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
            }
            function isLeft(a, b, c) {
                return triangleArea(a, b, c) > 0;
            }
            function isLeftOn(a, b, c) {
                return triangleArea(a, b, c) >= 0;
            }
            function isRight(a, b, c) {
                return triangleArea(a, b, c) < 0;
            }
            function isRightOn(a, b, c) {
                return triangleArea(a, b, c) <= 0;
            }
            var tmpPoint1 = [], tmpPoint2 = [];
            /**
 * Check if three points are collinear
 * @method collinear
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
 * @return {Boolean}
 */ function collinear(a, b, c, thresholdAngle) {
                if (!thresholdAngle) return triangleArea(a, b, c) === 0;
                else {
                    var ab = tmpPoint1, bc = tmpPoint2;
                    ab[0] = b[0] - a[0];
                    ab[1] = b[1] - a[1];
                    bc[0] = c[0] - b[0];
                    bc[1] = c[1] - b[1];
                    var dot = ab[0] * bc[0] + ab[1] * bc[1], magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]), magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]), angle = Math.acos(dot / (magA * magB));
                    return angle < thresholdAngle;
                }
            }
            function sqdist(a, b) {
                var dx = b[0] - a[0];
                var dy = b[1] - a[1];
                return dx * dx + dy * dy;
            }
            /**
 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
 * @method at
 * @param  {Number} i
 * @return {Array}
 */ function polygonAt(polygon, i) {
                var s = polygon.length;
                return polygon[i < 0 ? i % s + s : i % s];
            }
            /**
 * Clear the polygon data
 * @method clear
 * @return {Array}
 */ function polygonClear(polygon) {
                polygon.length = 0;
            }
            /**
 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
 * @method append
 * @param {Polygon} poly The polygon to get points from.
 * @param {Number}  from The vertex index in "poly".
 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
 * @return {Array}
 */ function polygonAppend(polygon, poly, from, to) {
                for(var i = from; i < to; i++)polygon.push(poly[i]);
            }
            /**
 * Make sure that the polygon vertices are ordered counter-clockwise.
 * @method makeCCW
 */ function polygonMakeCCW(polygon) {
                var br = 0, v = polygon;
                // find bottom right point
                for(var i = 1; i < polygon.length; ++i)if (v[i][1] < v[br][1] || v[i][1] === v[br][1] && v[i][0] > v[br][0]) br = i;
                // reverse poly if clockwise
                if (!isLeft(polygonAt(polygon, br - 1), polygonAt(polygon, br), polygonAt(polygon, br + 1))) {
                    polygonReverse(polygon);
                    return true;
                } else return false;
            }
            /**
 * Reverse the vertices in the polygon
 * @method reverse
 */ function polygonReverse(polygon) {
                var tmp = [];
                var N = polygon.length;
                for(var i = 0; i !== N; i++)tmp.push(polygon.pop());
                for(var i = 0; i !== N; i++)polygon[i] = tmp[i];
            }
            /**
 * Check if a point in the polygon is a reflex point
 * @method isReflex
 * @param  {Number}  i
 * @return {Boolean}
 */ function polygonIsReflex(polygon, i) {
                return isRight(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1));
            }
            var tmpLine1 = [], tmpLine2 = [];
            /**
 * Check if two vertices in the polygon can see each other
 * @method canSee
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee(polygon, a, b) {
                var p, dist, l1 = tmpLine1, l2 = tmpLine2;
                if (isLeftOn(polygonAt(polygon, a + 1), polygonAt(polygon, a), polygonAt(polygon, b)) && isRightOn(polygonAt(polygon, a - 1), polygonAt(polygon, a), polygonAt(polygon, b))) return false;
                dist = sqdist(polygonAt(polygon, a), polygonAt(polygon, b));
                for(var i = 0; i !== polygon.length; ++i){
                    if ((i + 1) % polygon.length === a || i === a) continue;
                    if (isLeftOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i + 1)) && isRightOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i))) {
                        l1[0] = polygonAt(polygon, a);
                        l1[1] = polygonAt(polygon, b);
                        l2[0] = polygonAt(polygon, i);
                        l2[1] = polygonAt(polygon, i + 1);
                        p = lineInt(l1, l2);
                        if (sqdist(polygonAt(polygon, a), p) < dist) return false;
                    }
                }
                return true;
            }
            /**
 * Check if two vertices in the polygon can see each other
 * @method canSee2
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee2(polygon, a, b) {
                // for each edge
                for(var i = 0; i !== polygon.length; ++i){
                    // ignore incident edges
                    if (i === a || i === b || (i + 1) % polygon.length === a || (i + 1) % polygon.length === b) continue;
                    if (lineSegmentsIntersect(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i), polygonAt(polygon, i + 1))) return false;
                }
                return true;
            }
            /**
 * Copy the polygon from vertex i to vertex j.
 * @method copy
 * @param  {Number} i
 * @param  {Number} j
 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
 * @return {Polygon}                The resulting copy.
 */ function polygonCopy(polygon, i, j, targetPoly) {
                var p = targetPoly || [];
                polygonClear(p);
                if (i < j) // Insert all vertices from i to j
                for(var k = i; k <= j; k++)p.push(polygon[k]);
                else {
                    // Insert vertices 0 to j
                    for(var k = 0; k <= j; k++)p.push(polygon[k]);
                    // Insert vertices i to end
                    for(var k = i; k < polygon.length; k++)p.push(polygon[k]);
                }
                return p;
            }
            /**
 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
 * @method getCutEdges
 * @return {Array}
 */ function polygonGetCutEdges(polygon) {
                var min = [], tmp1 = [], tmp2 = [], tmpPoly = [];
                var nDiags = Number.MAX_VALUE;
                for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(polygon, i)) {
                    for(var j = 0; j < polygon.length; ++j)if (polygonCanSee(polygon, i, j)) {
                        tmp1 = polygonGetCutEdges(polygonCopy(polygon, i, j, tmpPoly));
                        tmp2 = polygonGetCutEdges(polygonCopy(polygon, j, i, tmpPoly));
                        for(var k = 0; k < tmp2.length; k++)tmp1.push(tmp2[k]);
                        if (tmp1.length < nDiags) {
                            min = tmp1;
                            nDiags = tmp1.length;
                            min.push([
                                polygonAt(polygon, i),
                                polygonAt(polygon, j)
                            ]);
                        }
                    }
                }
                return min;
            }
            /**
 * Decomposes the polygon into one or more convex sub-Polygons.
 * @method decomp
 * @return {Array} An array or Polygon objects.
 */ function polygonDecomp(polygon) {
                var edges = polygonGetCutEdges(polygon);
                if (edges.length > 0) return polygonSlice(polygon, edges);
                else return [
                    polygon
                ];
            }
            /**
 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
 * @method slice
 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
 * @return {Array}
 */ function polygonSlice(polygon, cutEdges) {
                if (cutEdges.length === 0) return [
                    polygon
                ];
                if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length === 2 && cutEdges[0][0] instanceof Array) {
                    var polys = [
                        polygon
                    ];
                    for(var i = 0; i < cutEdges.length; i++){
                        var cutEdge = cutEdges[i];
                        // Cut all polys
                        for(var j = 0; j < polys.length; j++){
                            var poly = polys[j];
                            var result = polygonSlice(poly, cutEdge);
                            if (result) {
                                // Found poly! Cut and quit
                                polys.splice(j, 1);
                                polys.push(result[0], result[1]);
                                break;
                            }
                        }
                    }
                    return polys;
                } else {
                    // Was given one edge
                    var cutEdge = cutEdges;
                    var i = polygon.indexOf(cutEdge[0]);
                    var j = polygon.indexOf(cutEdge[1]);
                    if (i !== -1 && j !== -1) return [
                        polygonCopy(polygon, i, j),
                        polygonCopy(polygon, j, i)
                    ];
                    else return false;
                }
            }
            /**
 * Checks that the line segments of this polygon do not intersect each other.
 * @method isSimple
 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
 * @return {Boolean}
 * @todo Should it check all segments with all others?
 */ function polygonIsSimple(polygon) {
                var path = polygon, i;
                // Check
                for(i = 0; i < path.length - 1; i++)for(var j = 0; j < i - 1; j++){
                    if (lineSegmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) return false;
                }
                // Check the segment between the last and the first point to all others
                for(i = 1; i < path.length - 2; i++){
                    if (lineSegmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) return false;
                }
                return true;
            }
            function getIntersectionPoint(p1, p2, q1, q2, delta) {
                delta = delta || 0;
                var a1 = p2[1] - p1[1];
                var b1 = p1[0] - p2[0];
                var c1 = a1 * p1[0] + b1 * p1[1];
                var a2 = q2[1] - q1[1];
                var b2 = q1[0] - q2[0];
                var c2 = a2 * q1[0] + b2 * q1[1];
                var det = a1 * b2 - a2 * b1;
                if (!scalar_eq(det, 0, delta)) return [
                    (b2 * c1 - b1 * c2) / det,
                    (a1 * c2 - a2 * c1) / det
                ];
                else return [
                    0,
                    0
                ];
            }
            /**
 * Quickly decompose the Polygon into convex sub-polygons.
 * @method quickDecomp
 * @param  {Array} result
 * @param  {Array} [reflexVertices]
 * @param  {Array} [steinerPoints]
 * @param  {Number} [delta]
 * @param  {Number} [maxlevel]
 * @param  {Number} [level]
 * @return {Array}
 */ function polygonQuickDecomp(polygon, result, reflexVertices, steinerPoints, delta, maxlevel, level) {
                maxlevel = maxlevel || 100;
                level = level || 0;
                delta = delta || 25;
                result = typeof result !== "undefined" ? result : [];
                reflexVertices = reflexVertices || [];
                steinerPoints = steinerPoints || [];
                var upperInt = [
                    0,
                    0
                ], lowerInt = [
                    0,
                    0
                ], p = [
                    0,
                    0
                ]; // Points
                var upperDist = 0, lowerDist = 0, d = 0, closestDist = 0; // scalars
                var upperIndex = 0, lowerIndex = 0, closestIndex = 0; // Integers
                var lowerPoly = [], upperPoly = []; // polygons
                var poly = polygon, v = polygon;
                if (v.length < 3) return result;
                level++;
                if (level > maxlevel) {
                    console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
                    return result;
                }
                for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(poly, i)) {
                    reflexVertices.push(poly[i]);
                    upperDist = lowerDist = Number.MAX_VALUE;
                    for(var j = 0; j < polygon.length; ++j){
                        if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j - 1))) {
                            p = getIntersectionPoint(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j - 1)); // find the point of intersection
                            if (isRight(polygonAt(poly, i + 1), polygonAt(poly, i), p)) {
                                d = sqdist(poly[i], p);
                                if (d < lowerDist) {
                                    lowerDist = d;
                                    lowerInt = p;
                                    lowerIndex = j;
                                }
                            }
                        }
                        if (isLeft(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j + 1)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                            p = getIntersectionPoint(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j + 1));
                            if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), p)) {
                                d = sqdist(poly[i], p);
                                if (d < upperDist) {
                                    upperDist = d;
                                    upperInt = p;
                                    upperIndex = j;
                                }
                            }
                        }
                    }
                    // if there are no vertices to connect to, choose a point in the middle
                    if (lowerIndex === (upperIndex + 1) % polygon.length) {
                        //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+polygon.length+")");
                        p[0] = (lowerInt[0] + upperInt[0]) / 2;
                        p[1] = (lowerInt[1] + upperInt[1]) / 2;
                        steinerPoints.push(p);
                        if (i < upperIndex) {
                            //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
                            polygonAppend(lowerPoly, poly, i, upperIndex + 1);
                            lowerPoly.push(p);
                            upperPoly.push(p);
                            if (lowerIndex !== 0) //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
                            polygonAppend(upperPoly, poly, lowerIndex, poly.length);
                            //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
                            polygonAppend(upperPoly, poly, 0, i + 1);
                        } else {
                            if (i !== 0) //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
                            polygonAppend(lowerPoly, poly, i, poly.length);
                            //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
                            polygonAppend(lowerPoly, poly, 0, upperIndex + 1);
                            lowerPoly.push(p);
                            upperPoly.push(p);
                            //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
                            polygonAppend(upperPoly, poly, lowerIndex, i + 1);
                        }
                    } else {
                        // connect to the closest point within the triangle
                        //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+polygon.length+")\n");
                        if (lowerIndex > upperIndex) upperIndex += polygon.length;
                        closestDist = Number.MAX_VALUE;
                        if (upperIndex < lowerIndex) return result;
                        for(var j = lowerIndex; j <= upperIndex; ++j)if (isLeftOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                            d = sqdist(polygonAt(poly, i), polygonAt(poly, j));
                            if (d < closestDist && polygonCanSee2(poly, i, j)) {
                                closestDist = d;
                                closestIndex = j % polygon.length;
                            }
                        }
                        if (i < closestIndex) {
                            polygonAppend(lowerPoly, poly, i, closestIndex + 1);
                            if (closestIndex !== 0) polygonAppend(upperPoly, poly, closestIndex, v.length);
                            polygonAppend(upperPoly, poly, 0, i + 1);
                        } else {
                            if (i !== 0) polygonAppend(lowerPoly, poly, i, v.length);
                            polygonAppend(lowerPoly, poly, 0, closestIndex + 1);
                            polygonAppend(upperPoly, poly, closestIndex, i + 1);
                        }
                    }
                    // solve smallest poly first
                    if (lowerPoly.length < upperPoly.length) {
                        polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                    } else {
                        polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                    }
                    return result;
                }
                result.push(polygon);
                return result;
            }
            /**
 * Remove collinear points in the polygon.
 * @method removeCollinearPoints
 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
 * @return {Number}           The number of points removed
 */ function polygonRemoveCollinearPoints(polygon, precision) {
                var num = 0;
                for(var i = polygon.length - 1; polygon.length > 3 && i >= 0; --i)if (collinear(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1), precision)) {
                    // Remove the middle point
                    polygon.splice(i % polygon.length, 1);
                    num++;
                }
                return num;
            }
            /**
 * Remove duplicate points in the polygon.
 * @method removeDuplicatePoints
 * @param  {Number} [precision] The threshold to use when determining whether two points are the same. Use zero for best precision.
 */ function polygonRemoveDuplicatePoints(polygon, precision) {
                for(var i = polygon.length - 1; i >= 1; --i){
                    var pi = polygon[i];
                    for(var j = i - 1; j >= 0; --j)if (points_eq(pi, polygon[j], precision)) {
                        polygon.splice(i, 1);
                        continue;
                    }
                }
            }
            /**
 * Check if two scalars are equal
 * @static
 * @method eq
 * @param  {Number} a
 * @param  {Number} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function scalar_eq(a, b, precision) {
                precision = precision || 0;
                return Math.abs(a - b) <= precision;
            }
            /**
 * Check if two points are equal
 * @static
 * @method points_eq
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function points_eq(a, b, precision) {
                return scalar_eq(a[0], b[0], precision) && scalar_eq(a[1], b[1], precision);
            }
        /***/ },
        /* 1394 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Class = __webpack_require__(0);
            var Composites = __webpack_require__(591);
            var Constraint = __webpack_require__(128);
            var Svg = __webpack_require__(592);
            var MatterGameObject = __webpack_require__(1395);
            var MatterImage = __webpack_require__(1396);
            var MatterSprite = __webpack_require__(1397);
            var MatterTileBody = __webpack_require__(593);
            var PhysicsEditorParser = __webpack_require__(589);
            var PhysicsJSONParser = __webpack_require__(590);
            var PointerConstraint = __webpack_require__(1398);
            var Vertices = __webpack_require__(64);
            /**
 * @classdesc
 * The Matter Factory is responsible for quickly creating a variety of different types of
 * bodies, constraints and Game Objects and adding them into the physics world.
 *
 * You access the factory from within a Scene using `add`:
 *
 * ```javascript
 * this.matter.add.rectangle(x, y, width, height);
 * ```
 *
 * Use of the Factory is optional. All of the objects it creates can also be created
 * directly via your own code or constructors. It is provided as a means to keep your
 * code concise.
 *
 * @class Factory
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter World which this Factory adds to.
 */ var Factory = new Class({
                initialize: function Factory(world) {
                    /**
         * The Matter World which this Factory adds to.
         *
         * @name Phaser.Physics.Matter.Factory#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Scene which this Factory's Matter World belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                    /**
         * A reference to the Scene.Systems this Matter Physics instance belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                },
                /**
     * Creates a new rigid rectangular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#rectangle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the Body.
     * @param {number} height - The height of the Body.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ rectangle: function(x, y, width, height, options) {
                    var body = Bodies.rectangle(x, y, width, height, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid trapezoidal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#trapezoid
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ trapezoid: function(x, y, width, height, slope, options) {
                    var body = Bodies.trapezoid(x, y, width, height, slope, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid circular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#circle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {number} [maxSides] - The maximum amount of sides to use for the polygon which will approximate this circle.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ circle: function(x, y, radius, options, maxSides) {
                    var body = Bodies.circle(x, y, radius, options, maxSides);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid polygonal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#polygon
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} sides - The number of sides the polygon will have.
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ polygon: function(x, y, sides, radius, options) {
                    var body = Bodies.polygon(x, y, sides, radius, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices) and adds it to the World.
     * If the vertices are convex, they will pass through as supplied. Otherwise, if the vertices are concave, they will be decomposed. Note that this process is not guaranteed to support complex sets of vertices, e.g. ones with holes.
     *
     * @method Phaser.Physics.Matter.Factory#fromVertices
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {(string|array)} vertexSets - The vertices data. Either a path string or an array of vertices.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [flagInternal=false] - Flag internal edges (coincident part edges)
     * @param {number} [removeCollinear=0.01] - Whether Matter.js will discard collinear edges (to improve performance).
     * @param {number} [minimumArea=10] - During decomposition discard parts that have an area less than this.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromVertices: function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
                    if (typeof vertexSets === "string") vertexSets = Vertices.fromPath(vertexSets);
                    var body = Bodies.fromVertices(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using data exported from the application PhysicsEditor (https://www.codeandweb.com/physicseditor)
     *
     * The PhysicsEditor file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('vehicles', 'assets/vehicles.json);
     * }
     *
     * create ()
     * {
     *   const vehicleShapes = this.cache.json.get('vehicles');
     *   this.matter.add.fromPhysicsEditor(400, 300, vehicleShapes.truck);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the PhysicsEditor config object.
     *
     * @method Phaser.Physics.Matter.Factory#fromPhysicsEditor
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {any} config - The JSON data exported from PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromPhysicsEditor: function(x, y, config, options, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    var body = PhysicsEditorParser.parseBody(x, y, config, options);
                    if (addToWorld && !this.world.has(body)) this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the path data from an SVG file.
     *
     * SVG Parsing requires the pathseg polyfill from https://github.com/progers/pathseg
     *
     * The SVG file should be loaded as XML, as this method requires the ability to extract
     * the path data from it. I.e.:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.xml('face', 'assets/face.svg);
     * }
     *
     * create ()
     * {
     *   this.matter.add.fromSVG(400, 300, this.cache.xml.get('face'));
     * }
     * ```
     *
     * @method Phaser.Physics.Matter.Factory#fromSVG
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {object} xml - The SVG Path data.
     * @param {number} [scale=1] - Scale the vertices by this amount after creation.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromSVG: function(x, y, xml, scale, options, addToWorld) {
                    if (scale === undefined) scale = 1;
                    if (options === undefined) options = {};
                    if (addToWorld === undefined) addToWorld = true;
                    var path = xml.getElementsByTagName("path");
                    var vertexSets = [];
                    for(var i = 0; i < path.length; i++){
                        var points = Svg.pathToVertices(path[i], 30);
                        if (scale !== 1) Vertices.scale(points, scale, scale);
                        vertexSets.push(points);
                    }
                    var body = Bodies.fromVertices(x, y, vertexSets, options);
                    if (addToWorld) this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the supplied physics data, as provided by a JSON file.
     *
     * The data file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('ninjas', 'assets/ninjas.json);
     * }
     *
     * create ()
     * {
     *   const ninjaShapes = this.cache.json.get('ninjas');
     *
     *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the config object.
     *
     * The structure of the JSON file is as follows:
     *
     * ```text
     * {
     *   'generator_info': // The name of the application that created the JSON data
     *   'shapeName': {
     *     'type': // The type of body
     *     'label': // Optional body label
     *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
     *   }
     * }
     * ```
     *
     * At the time of writing, only the Phaser Physics Tracer App exports in this format.
     *
     * @method Phaser.Physics.Matter.Factory#fromJSON
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {any} config - The JSON physics data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromJSON: function(x, y, config, options, addToWorld) {
                    if (options === undefined) options = {};
                    if (addToWorld === undefined) addToWorld = true;
                    var body = PhysicsJSONParser.parseBody(x, y, config, options);
                    if (body && addToWorld) this.world.add(body);
                    return body;
                },
                /**
     * Create a new composite containing Matter Image objects created in a grid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#imageStack
     * @since 3.0.0
     *
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} frame - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} [columnGap=0] - The distance between each column.
     * @param {number} [rowGap=0] - The distance between each row.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite Stack.
     */ imageStack: function(key, frame, x, y, columns, rows, columnGap, rowGap, options) {
                    if (columnGap === undefined) columnGap = 0;
                    if (rowGap === undefined) rowGap = 0;
                    if (options === undefined) options = {};
                    var world = this.world;
                    var displayList = this.sys.displayList;
                    options.addToWorld = false;
                    var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, function(x, y) {
                        var image = new MatterImage(world, x, y, key, frame, options);
                        displayList.add(image);
                        return image.body;
                    });
                    world.add(stack);
                    return stack;
                },
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     *
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#stack
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback that creates the stack.
     *
     * @return {MatterJS.CompositeType} A new composite containing objects created in the callback.
     */ stack: function(x, y, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, callback);
                    this.world.add(stack);
                    return stack;
                },
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#pyramid
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the pyramid.
     * @param {number} rows - The number of rows in the pyramid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback function to be invoked.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite pyramid.
     */ pyramid: function(x, y, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composites.pyramid(x, y, columns, rows, columnGap, rowGap, callback);
                    this.world.add(stack);
                    return stack;
                },
                /**
     * Chains all bodies in the given composite together using constraints.
     *
     * @method Phaser.Physics.Matter.Factory#chain
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together sequentially.
     * @param {number} xOffsetA - The horizontal offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetA - The vertical offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} xOffsetB - The horizontal offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetB - The vertical offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ chain: function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    return Composites.chain(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options);
                },
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     *
     * @method Phaser.Physics.Matter.Factory#mesh
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together.
     * @param {number} columns - The number of columns in the mesh.
     * @param {number} rows - The number of rows in the mesh.
     * @param {boolean} crossBrace - Create cross braces for the mesh as well?
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ mesh: function(composite, columns, rows, crossBrace, options) {
                    return Composites.mesh(composite, columns, rows, crossBrace, options);
                },
                /**
     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#newtonsCradle
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the start of the cradle.
     * @param {number} y - The vertical position of the start of the cradle.
     * @param {number} number - The number of balls in the cradle.
     * @param {number} size - The radius of each ball in the cradle.
     * @param {number} length - The length of the 'string' the balls hang from.
     *
     * @return {MatterJS.CompositeType} A Newton's cradle composite.
     */ newtonsCradle: function(x, y, number, size, length) {
                    var composite = Composites.newtonsCradle(x, y, number, size, length);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * Creates a composite with simple car setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#car
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the car in the world.
     * @param {number} y - The vertical position of the car in the world.
     * @param {number} width - The width of the car chasis.
     * @param {number} height - The height of the car chasis.
     * @param {number} wheelSize - The radius of the car wheels.
     *
     * @return {MatterJS.CompositeType} A new composite car body.
     */ car: function(x, y, width, height, wheelSize) {
                    var composite = Composites.car(x, y, width, height, wheelSize);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * Creates a simple soft body like object.
     *
     * @method Phaser.Physics.Matter.Factory#softBody
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the Composite.
     * @param {number} rows - The number of rows in the Composite.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {boolean} crossBrace - `true` to create cross braces between the bodies, or `false` to create just straight braces.
     * @param {number} particleRadius - The radius of this circlular composite.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [particleOptions] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [constraintOptions] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} A new composite simple soft body.
     */ softBody: function(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    var composite = Composites.softBody(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#joint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ joint: function(bodyA, bodyB, length, stiffness, options) {
                    return this.constraint(bodyA, bodyB, length, stiffness, options);
                },
                /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#spring
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ spring: function(bodyA, bodyB, length, stiffness, options) {
                    return this.constraint(bodyA, bodyB, length, stiffness, options);
                },
                /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#constraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ constraint: function(bodyA, bodyB, length, stiffness, options) {
                    if (stiffness === undefined) stiffness = 1;
                    if (options === undefined) options = {};
                    options.bodyA = bodyA.type === "body" ? bodyA : bodyA.body;
                    options.bodyB = bodyB.type === "body" ? bodyB : bodyB.body;
                    if (!isNaN(length)) options.length = length;
                    options.stiffness = stiffness;
                    var constraint = Constraint.create(options);
                    this.world.add(constraint);
                    return constraint;
                },
                /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * A world constraint has only one body, you should specify a `pointA` position in
     * the constraint options parameter to attach the constraint to the world.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#worldConstraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Matter `Body` that this constraint is attached to.
     * @param {number} [length] - A number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ worldConstraint: function(body, length, stiffness, options) {
                    if (stiffness === undefined) stiffness = 1;
                    if (options === undefined) options = {};
                    options.bodyB = body.type === "body" ? body : body.body;
                    if (!isNaN(length)) options.length = length;
                    options.stiffness = stiffness;
                    var constraint = Constraint.create(options);
                    this.world.add(constraint);
                    return constraint;
                },
                /**
     * This method is an alias for `Factory.pointerConstraint`.
     *
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#mouseSpring
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ mouseSpring: function(options) {
                    return this.pointerConstraint(options);
                },
                /**
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#pointerConstraint
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ pointerConstraint: function(options) {
                    if (options === undefined) options = {};
                    if (!options.hasOwnProperty("render")) options.render = {
                        visible: false
                    };
                    var pointerConstraint = new PointerConstraint(this.scene, this.world, options);
                    this.world.add(pointerConstraint.constraint);
                    return pointerConstraint;
                },
                /**
     * Creates a Matter Physics Image Game Object.
     *
     * An Image is a light-weight Game Object useful for the display of static images in your game,
     * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
     * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
     * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
     *
     * @method Phaser.Physics.Matter.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Image} The Matter Image Game Object.
     */ image: function(x, y, key, frame, options) {
                    var image = new MatterImage(this.world, x, y, key, frame, options);
                    this.sys.displayList.add(image);
                    return image;
                },
                /**
     * Creates a wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
     * have one Matter body associated with it. You can either pass in an existing Matter body for
     * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
     * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
     * tile's rectangle bounding box will be used.
     *
     * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
     *
     * Note: not all Tiled collision shapes are supported. See
     * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
     *
     * @method Phaser.Physics.Matter.Factory#tileBody
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
     * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
     *
     * @return {Phaser.Physics.Matter.TileBody} The Matter Tile Body Game Object.
     */ tileBody: function(tile, options) {
                    return new MatterTileBody(this.world, tile, options);
                },
                /**
     * Creates a Matter Physics Sprite Game Object.
     *
     * A Sprite Game Object is used for the display of both static and animated images in your game.
     * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
     * and animated.
     *
     * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
     * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
     * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
     *
     * @method Phaser.Physics.Matter.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Sprite} The Matter Sprite Game Object.
     */ sprite: function(x, y, key, frame, options) {
                    var sprite = new MatterSprite(this.world, x, y, key, frame, options);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    return sprite;
                },
                /**
     * Takes an existing Game Object and injects all of the Matter Components into it.
     *
     * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
     * this Game Object.
     *
     * You can also pass in either a Matter Body Configuration object, or a Matter Body instance
     * to link with this Game Object.
     *
     * @method Phaser.Physics.Matter.Factory#gameObject
     * @since 3.3.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to inject the Matter Components in to.
     * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
     * @param {boolean} [addToWorld=true] - Add this Matter Body to the World?
     *
     * @return {(Phaser.Physics.Matter.Image|Phaser.Physics.Matter.Sprite|Phaser.GameObjects.GameObject)} The Game Object that had the Matter Components injected into it.
     */ gameObject: function(gameObject, options, addToWorld) {
                    return MatterGameObject(this.world, gameObject, options, addToWorld);
                },
                /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Matter.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.world = null;
                    this.scene = null;
                    this.sys = null;
                }
            });
            module1.exports = Factory;
        /***/ },
        /* 1395 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Components = __webpack_require__(249);
            var GetFastValue = __webpack_require__(2);
            var Vector2 = __webpack_require__(3);
            /**
 * Internal function to check if the object has a getter or setter.
 *
 * @function hasGetterOrSetter
 * @private
 *
 * @param {object} def - The object to check.
 *
 * @return {boolean} True if it has a getter or setter, otherwise false.
 */ function hasGetterOrSetter(def) {
                return !!def.get && typeof def.get === "function" || !!def.set && typeof def.set === "function";
            }
            /**
 * A Matter Game Object is a generic object that allows you to combine any Phaser Game Object,
 * including those you have extended or created yourself, with all of the Matter Components.
 * 
 * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
 * this Game Object.
 *
 * @function Phaser.Physics.Matter.MatterGameObject
 * @since 3.3.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world to add the body to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have the Matter body applied to it.
 * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
 * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was created with the Matter body.
 */ var MatterGameObject = function(world, gameObject, options, addToWorld) {
                if (options === undefined) options = {};
                if (addToWorld === undefined) addToWorld = true;
                var x = gameObject.x;
                var y = gameObject.y;
                //  Temp body pos to avoid body null checks
                gameObject.body = {
                    temp: true,
                    position: {
                        x: x,
                        y: y
                    }
                };
                var mixins = [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity
                ];
                //  First let's inject all of the components into the Game Object
                mixins.forEach(function(mixin) {
                    for(var key in mixin)if (hasGetterOrSetter(mixin[key])) Object.defineProperty(gameObject, key, {
                        get: mixin[key].get,
                        set: mixin[key].set
                    });
                    else Object.defineProperty(gameObject, key, {
                        value: mixin[key]
                    });
                });
                gameObject.world = world;
                gameObject._tempVec2 = new Vector2(x, y);
                if (options.hasOwnProperty("type") && options.type === "body") gameObject.setExistingBody(options, addToWorld);
                else {
                    var shape = GetFastValue(options, "shape", null);
                    if (!shape) shape = "rectangle";
                    options.addToWorld = addToWorld;
                    gameObject.setBody(shape, options);
                }
                return gameObject;
            };
            module1.exports = MatterGameObject;
        /***/ },
        /* 1396 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(249);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Image1 = __webpack_require__(125);
            var Pipeline = __webpack_require__(167);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matter Physics Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterImage = new Class({
                Extends: Image1,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity,
                    Pipeline
                ],
                initialize: function MatterImage(world, x, y, texture, frame, options) {
                    GameObject.call(this, world.scene, "Image");
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Image#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                    this.setTexture(texture, frame);
                    this.setSizeToFrame();
                    this.setOrigin();
                    /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Image#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Image#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                    var shape = GetFastValue(options, "shape", null);
                    if (shape) this.setBody(shape, options);
                    else this.setRectangle(this.width, this.height, options);
                    this.setPosition(x, y);
                    this.initPipeline();
                }
            });
            module1.exports = MatterImage;
        /***/ },
        /* 1397 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(164);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(249);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Pipeline = __webpack_require__(167);
            var Sprite = __webpack_require__(73);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matter Physics Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterSprite = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity,
                    Pipeline
                ],
                initialize: function MatterSprite(world, x, y, texture, frame, options) {
                    GameObject.call(this, world.scene, "Sprite");
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                    this.anims = new AnimationState(this);
                    this.setTexture(texture, frame);
                    this.setSizeToFrame();
                    this.setOrigin();
                    /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Sprite#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Sprite#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                    var shape = GetFastValue(options, "shape", null);
                    if (shape) this.setBody(shape, options);
                    else this.setRectangle(this.width, this.height, options);
                    this.setPosition(x, y);
                    this.initPipeline();
                }
            });
            module1.exports = MatterSprite;
        /***/ },
        /* 1398 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bounds = __webpack_require__(84);
            var Class = __webpack_require__(0);
            var Composite = __webpack_require__(118);
            var Constraint = __webpack_require__(128);
            var Detector = __webpack_require__(273);
            var Events = __webpack_require__(272);
            var InputEvents = __webpack_require__(51);
            var Merge = __webpack_require__(127);
            var Sleeping = __webpack_require__(165);
            var Vector2 = __webpack_require__(3);
            var Vertices = __webpack_require__(64);
            /**
 * @classdesc
 * A Pointer Constraint is a special type of constraint that allows you to click
 * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
 * and when one is pressed down it checks to see if that hit any part of any active
 * body in the world. If it did, and the body has input enabled, it will begin to
 * drag it until either released, or you stop it via the `stopDrag` method.
 * 
 * You can adjust the stiffness, length and other properties of the constraint via
 * the `options` object on creation.
 *
 * @class PointerConstraint
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene to which this Pointer Constraint belongs.
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter World instance to which this Constraint belongs.
 * @param {object} [options] - A Constraint configuration object.
 */ var PointerConstraint = new Class({
                initialize: function PointerConstraint(scene, world, options) {
                    if (options === undefined) options = {};
                    //  Defaults
                    var defaults = {
                        label: "Pointer Constraint",
                        pointA: {
                            x: 0,
                            y: 0
                        },
                        pointB: {
                            x: 0,
                            y: 0
                        },
                        length: 0.01,
                        stiffness: 0.1,
                        angularStiffness: 1,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        }
                    };
                    /**
         * A reference to the Scene to which this Pointer Constraint belongs.
         * This is the same Scene as the Matter World instance.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Matter World instance to which this Constraint belongs.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Camera the Pointer was interacting with when the input
         * down event was processed.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.camera = null;
                    /**
         * A reference to the Input Pointer that activated this Constraint.
         * This is set in the `onDown` handler.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#pointer
         * @type {Phaser.Input.Pointer}
         * @default null
         * @since 3.0.0
         */ this.pointer = null;
                    /**
         * Is this Constraint active or not?
         * 
         * An active constraint will be processed each update. An inactive one will be skipped.
         * Use this to toggle a Pointer Constraint on and off.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * The internal transformed position.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2();
                    /**
         * The body that is currently being dragged, if any.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#body
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.body = null;
                    /**
         * The part of the body that was clicked on to start the drag.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#part
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.part = null;
                    /**
         * The native Matter Constraint that is used to attach to bodies.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#constraint
         * @type {MatterJS.ConstraintType}
         * @since 3.0.0
         */ this.constraint = Constraint.create(Merge(options, defaults));
                    this.world.on(Events.BEFORE_UPDATE, this.update, this);
                    scene.sys.input.on(InputEvents.POINTER_DOWN, this.onDown, this);
                    scene.sys.input.on(InputEvents.POINTER_UP, this.onUp, this);
                },
                /**
     * A Pointer has been pressed down onto the Scene.
     * 
     * If this Constraint doesn't have an active Pointer then a hit test is set to
     * run against all active bodies in the world during the _next_ call to `update`.
     * If a body is found, it is bound to this constraint and the drag begins.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onDown
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onDown: function(pointer) {
                    if (!this.pointer) {
                        this.pointer = pointer;
                        this.camera = pointer.camera;
                    }
                },
                /**
     * A Pointer has been released from the Scene. If it was the one this constraint was using, it's cleared.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onUp
     * @since 3.22.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onUp: function(pointer) {
                    if (pointer === this.pointer) this.pointer = null;
                },
                /**
     * Scans all active bodies in the current Matter World to see if any of them
     * are hit by the Pointer. The _first one_ found to hit is set as the active contraint
     * body.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#getBody
     * @fires Phaser.Physics.Matter.Events#DRAG_START
     * @since 3.16.2
     * 
     * @return {boolean} `true` if a body was found and set, otherwise `false`.
     */ getBody: function(pointer) {
                    var pos = this.position;
                    var constraint = this.constraint;
                    this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                    var bodies = Composite.allBodies(this.world.localWorld);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (!body.ignorePointer && Bounds.contains(body.bounds, pos) && Detector.canCollide(body.collisionFilter, constraint.collisionFilter)) {
                            if (this.hitTestBody(body, pos)) {
                                this.world.emit(Events.DRAG_START, body, this.part, this);
                                return true;
                            }
                        }
                    }
                    return false;
                },
                /**
     * Scans the current body to determine if a part of it was clicked on.
     * If a part is found the body is set as the `constraint.bodyB` property,
     * as well as the `body` property of this class. The part is also set.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#hitTestBody
     * @since 3.16.2
     *
     * @param {MatterJS.BodyType} body - The Matter Body to check.
     * @param {Phaser.Math.Vector2} position - A translated hit test position.
     *
     * @return {boolean} `true` if a part of the body was hit, otherwise `false`.
     */ hitTestBody: function(body, position) {
                    var constraint = this.constraint;
                    var partsLength = body.parts.length;
                    var start = partsLength > 1 ? 1 : 0;
                    for(var i = start; i < partsLength; i++){
                        var part = body.parts[i];
                        if (Vertices.contains(part.vertices, position)) {
                            constraint.pointA = position;
                            constraint.pointB = {
                                x: position.x - body.position.x,
                                y: position.y - body.position.y
                            };
                            constraint.bodyB = body;
                            constraint.angleB = body.angle;
                            Sleeping.set(body, false);
                            this.part = part;
                            this.body = body;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Internal update handler. Called in the Matter BEFORE_UPDATE step.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#update
     * @fires Phaser.Physics.Matter.Events#DRAG
     * @since 3.0.0
     */ update: function() {
                    var pointer = this.pointer;
                    var body = this.body;
                    if (!this.active || !pointer) {
                        if (body) this.stopDrag();
                        return;
                    }
                    if (!pointer.isDown && body) {
                        this.stopDrag();
                        return;
                    } else if (pointer.isDown) {
                        if (!body && !this.getBody(pointer)) return;
                        body = this.body;
                        var pos = this.position;
                        var constraint = this.constraint;
                        this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                        //  Drag update
                        constraint.pointA.x = pos.x;
                        constraint.pointA.y = pos.y;
                        Sleeping.set(body, false);
                        this.world.emit(Events.DRAG, body, this);
                    }
                },
                /**
     * Stops the Pointer Constraint from dragging the body any further.
     * 
     * This is called automatically if the Pointer is released while actively
     * dragging a body. Or, you can call it manually to release a body from a
     * constraint without having to first release the pointer.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#stopDrag
     * @fires Phaser.Physics.Matter.Events#DRAG_END
     * @since 3.16.2
     */ stopDrag: function() {
                    var body = this.body;
                    var constraint = this.constraint;
                    constraint.bodyB = null;
                    constraint.pointB = null;
                    this.pointer = null;
                    this.body = null;
                    this.part = null;
                    if (body) this.world.emit(Events.DRAG_END, body, this);
                },
                /**
     * Destroys this Pointer Constraint instance and all of its references.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.world.removeConstraint(this.constraint);
                    this.pointer = null;
                    this.constraint = null;
                    this.body = null;
                    this.part = null;
                    this.world.off(Events.BEFORE_UPDATE, this.update);
                    this.scene.sys.input.off(InputEvents.POINTER_DOWN, this.onDown, this);
                    this.scene.sys.input.off(InputEvents.POINTER_UP, this.onUp, this);
                }
            });
            module1.exports = PointerConstraint;
        /***/ },
        /* 1399 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
*
* @class Matter
*/ var Matter = {};
            module1.exports = Matter;
            var Plugin = __webpack_require__(595);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * The library name.
     * @property name
     * @readOnly
     * @type {String}
     */ Matter.name = "matter-js";
                /**
     * The library version.
     * @property version
     * @readOnly
     * @type {String}
     */ Matter.version = "0.14.2";
                /**
     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
     * @property uses
     * @type {Array}
     */ Matter.uses = [];
                /**
     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
     * @property used
     * @readOnly
     * @type {Array}
     */ Matter.used = [];
                /**
     * Installs the given plugins on the `Matter` namespace.
     * This is a short-hand for `Plugin.use`, see it for more information.
     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
     * Avoid calling this function multiple times unless you intend to manually control installation order.
     * @method use
     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
     */ Matter.use = function() {
                    Plugin.use(Matter, Array.prototype.slice.call(arguments));
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method before
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Matter.before = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathBefore(Matter, path, func);
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method after
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Matter.after = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathAfter(Matter, path, func);
                };
            })();
        /***/ },
        /* 1400 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Query` module contains methods for performing collision queries.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Query
*/ var Query = {};
            module1.exports = Query;
            var Vector = __webpack_require__(83);
            var SAT = __webpack_require__(274);
            var Bounds = __webpack_require__(84);
            var Bodies = __webpack_require__(86);
            var Vertices = __webpack_require__(64);
            (function() {
                /**
     * Returns a list of collisions between `body` and `bodies`.
     * @method collides
     * @param {body} body
     * @param {body[]} bodies
     * @return {object[]} Collisions
     */ Query.collides = function(body, bodies) {
                    var collisions = [];
                    for(var i = 0; i < bodies.length; i++){
                        var bodyA = bodies[i];
                        //  Phaser addition - skip same body checks
                        if (body === bodyA) continue;
                        if (Bounds.overlaps(bodyA.bounds, body.bounds)) for(var j = bodyA.parts.length === 1 ? 0 : 1; j < bodyA.parts.length; j++){
                            var part = bodyA.parts[j];
                            if (Bounds.overlaps(part.bounds, body.bounds)) {
                                var collision = SAT.collides(part, body);
                                if (collision.collided) {
                                    collisions.push(collision);
                                    break;
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
     * @method ray
     * @param {body[]} bodies
     * @param {vector} startPoint
     * @param {vector} endPoint
     * @param {number} [rayWidth]
     * @return {object[]} Collisions
     */ Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
                    rayWidth = rayWidth || 1e-100;
                    var rayAngle = Vector.angle(startPoint, endPoint), rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)), rayX = (endPoint.x + startPoint.x) * 0.5, rayY = (endPoint.y + startPoint.y) * 0.5, ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, {
                        angle: rayAngle
                    }), collisions = Query.collides(ray, bodies);
                    for(var i = 0; i < collisions.length; i += 1){
                        var collision = collisions[i];
                        collision.body = collision.bodyB = collision.bodyA;
                    }
                    return collisions;
                };
                /**
     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
     * @method region
     * @param {body[]} bodies
     * @param {bounds} bounds
     * @param {bool} [outside=false]
     * @return {body[]} The bodies matching the query
     */ Query.region = function(bodies, bounds, outside) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], overlaps = Bounds.overlaps(body.bounds, bounds);
                        if (overlaps && !outside || !overlaps && outside) result.push(body);
                    }
                    return result;
                };
                /**
     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
     * @method point
     * @param {body[]} bodies
     * @param {vector} point
     * @return {body[]} The bodies matching the query
     */ Query.point = function(bodies, point) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (Bounds.contains(body.bounds, point)) for(var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++){
                            var part = body.parts[j];
                            if (Bounds.contains(part.bounds, point) && Vertices.contains(part.vertices, point)) {
                                result.push(body);
                                break;
                            }
                        }
                    }
                    return result;
                };
            })();
        /***/ },
        /* 1401 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Engine` module contains methods for creating and manipulating engines.
* An engine is a controller that manages updating the simulation of the world.
* See `Matter.Runner` for an optional game loop utility.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Engine
*/ var Engine = {};
            module1.exports = Engine;
            var World = __webpack_require__(596);
            var Sleeping = __webpack_require__(165);
            var Resolver = __webpack_require__(599);
            var Pairs = __webpack_require__(598);
            var Metrics = __webpack_require__(1523);
            var Grid = __webpack_require__(597);
            var Events = __webpack_require__(166);
            var Composite = __webpack_require__(118);
            var Constraint = __webpack_require__(128);
            var Common = __webpack_require__(32);
            var Body = __webpack_require__(41);
            (function() {
                /**
     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {engine} engine
     */ Engine.create = function(element, options) {
                    // options may be passed as the first (and only) argument
                    options = Common.isElement(element) ? options : element;
                    element = Common.isElement(element) ? element : null;
                    options = options || {};
                    if (element || options.render) Common.warn("Engine.create: engine.render is deprecated (see docs)");
                    var defaults = {
                        positionIterations: 6,
                        velocityIterations: 4,
                        constraintIterations: 2,
                        enableSleeping: false,
                        events: [],
                        plugin: {},
                        timing: {
                            timestamp: 0,
                            timeScale: 1
                        },
                        broadphase: {
                            controller: Grid
                        }
                    };
                    var engine = Common.extend(defaults, options);
                    engine.world = options.world || World.create(engine.world);
                    engine.pairs = Pairs.create();
                    engine.broadphase = engine.broadphase.controller.create(engine.broadphase);
                    engine.metrics = engine.metrics || {
                        extended: false
                    };
                    // @if DEBUG
                    engine.metrics = Metrics.create(engine.metrics);
                    // @endif
                    return engine;
                };
                /**
     * Moves the simulation forward in time by `delta` ms.
     * The `correction` argument is an optional `Number` that specifies the time correction factor to apply to the update.
     * This can help improve the accuracy of the simulation in cases where `delta` is changing between updates.
     * The value of `correction` is defined as `delta / lastDelta`, i.e. the percentage change of `delta` over the last step.
     * Therefore the value is always `1` (no correction) when `delta` constant (or when no correction is desired, which is the default).
     * See the paper on <a href="http://lonesock.net/article/verlet.html">Time Corrected Verlet</a> for more information.
     *
     * Triggers `beforeUpdate` and `afterUpdate` events.
     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * @method update
     * @param {engine} engine
     * @param {number} [delta=16.666]
     * @param {number} [correction=1]
     */ Engine.update = function(engine, delta, correction) {
                    delta = delta || 1000 / 60;
                    correction = correction || 1;
                    var world = engine.world, timing = engine.timing, broadphase = engine.broadphase, broadphasePairs = [], i;
                    // increment timestamp
                    timing.timestamp += delta * timing.timeScale;
                    // create an event object
                    var event = {
                        timestamp: timing.timestamp
                    };
                    Events.trigger(engine, "beforeUpdate", event);
                    // get lists of all bodies and constraints, no matter what composites they are in
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world);
                    // @if DEBUG
                    // reset metrics logging
                    Metrics.reset(engine.metrics);
                    // @endif
                    // if sleeping enabled, call the sleeping controller
                    if (engine.enableSleeping) Sleeping.update(allBodies, timing.timeScale);
                    // applies gravity to all bodies
                    Engine._bodiesApplyGravity(allBodies, world.gravity);
                    // update all body position and rotation by integration
                    Engine._bodiesUpdate(allBodies, delta, timing.timeScale, correction, world.bounds);
                    // update all constraints (first pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // broadphase pass: find potential collision pairs
                    if (broadphase.controller) {
                        // if world is dirty, we must flush the whole grid
                        if (world.isModified) broadphase.controller.clear(broadphase);
                        // update the grid buckets based on current bodies
                        broadphase.controller.update(broadphase, allBodies, engine, world.isModified);
                        broadphasePairs = broadphase.pairsList;
                    } else // if no broadphase set, we just pass all bodies
                    broadphasePairs = allBodies;
                    // clear all composite modified flags
                    if (world.isModified) Composite.setModified(world, false, false, true);
                    // narrowphase pass: find actual collisions, then create or update collision pairs
                    var collisions = broadphase.detector(broadphasePairs, engine);
                    // update collision pairs
                    var pairs = engine.pairs, timestamp = timing.timestamp;
                    Pairs.update(pairs, collisions, timestamp);
                    Pairs.removeOld(pairs, timestamp);
                    // wake up bodies involved in collisions
                    if (engine.enableSleeping) Sleeping.afterCollisions(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionStart.length > 0) Events.trigger(engine, "collisionStart", {
                        pairs: pairs.collisionStart
                    });
                    // iteratively resolve position between collisions
                    Resolver.preSolvePosition(pairs.list);
                    for(i = 0; i < engine.positionIterations; i++)Resolver.solvePosition(pairs.list, allBodies, timing.timeScale);
                    Resolver.postSolvePosition(allBodies);
                    // update all constraints (second pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // iteratively resolve velocity between collisions
                    Resolver.preSolveVelocity(pairs.list);
                    for(i = 0; i < engine.velocityIterations; i++)Resolver.solveVelocity(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionActive.length > 0) Events.trigger(engine, "collisionActive", {
                        pairs: pairs.collisionActive
                    });
                    if (pairs.collisionEnd.length > 0) Events.trigger(engine, "collisionEnd", {
                        pairs: pairs.collisionEnd
                    });
                    // @if DEBUG
                    // update metrics log
                    Metrics.update(engine.metrics, engine);
                    // @endif
                    // clear force buffers
                    Engine._bodiesClearForces(allBodies);
                    Events.trigger(engine, "afterUpdate", event);
                    return engine;
                };
                /**
     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
     * @method merge
     * @param {engine} engineA
     * @param {engine} engineB
     */ Engine.merge = function(engineA, engineB) {
                    Common.extend(engineA, engineB);
                    if (engineB.world) {
                        engineA.world = engineB.world;
                        Engine.clear(engineA);
                        var bodies = Composite.allBodies(engineA.world);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            Sleeping.set(body, false);
                            body.id = Common.nextId();
                        }
                    }
                };
                /**
     * Clears the engine including the world, pairs and broadphase.
     * @method clear
     * @param {engine} engine
     */ Engine.clear = function(engine) {
                    var world = engine.world;
                    Pairs.clear(engine.pairs);
                    var broadphase = engine.broadphase;
                    if (broadphase.controller) {
                        var bodies = Composite.allBodies(world);
                        broadphase.controller.clear(broadphase);
                        broadphase.controller.update(broadphase, bodies, engine, true);
                    }
                };
                /**
     * Zeroes the `body.force` and `body.torque` force buffers.
     * @method _bodiesClearForces
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesClearForces = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        // reset force buffers
                        body.force.x = 0;
                        body.force.y = 0;
                        body.torque = 0;
                    }
                };
                /**
     * Applys a mass dependant force to all given bodies.
     * @method _bodiesApplyGravity
     * @private
     * @param {body[]} bodies
     * @param {vector} gravity
     */ Engine._bodiesApplyGravity = function(bodies, gravity) {
                    var gravityScale = typeof gravity.scale !== "undefined" ? gravity.scale : 0.001;
                    if (gravity.x === 0 && gravity.y === 0 || gravityScale === 0) return;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.ignoreGravity || body.isStatic || body.isSleeping) continue;
                        // apply gravity
                        body.force.x += body.mass * gravity.x * gravityScale * body.gravityScale.x;
                        body.force.y += body.mass * gravity.y * gravityScale * body.gravityScale.y;
                    }
                };
                /**
     * Applys `Body.update` to all given `bodies`.
     * @method _bodiesUpdate
     * @private
     * @param {body[]} bodies
     * @param {number} deltaTime 
     * The amount of time elapsed between updates
     * @param {number} timeScale
     * @param {number} correction 
     * The Verlet correction factor (deltaTime / lastDeltaTime)
     * @param {bounds} worldBounds
     */ Engine._bodiesUpdate = function(bodies, deltaTime, timeScale, correction, worldBounds) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        Body.update(body, deltaTime, timeScale, correction);
                    }
                };
            /**
     * An alias for `Runner.run`, see `Matter.Runner` for more information.
     * @method run
     * @param {engine} engine
     */ /**
    * Fired just before an update
    *
    * @event beforeUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update and all collision events
    *
    * @event afterUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
    *
    * @event collisionStart
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
    *
    * @event collisionActive
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
    *
    * @event collisionEnd
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` that specifies the number of position iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property positionIterations
     * @type number
     * @default 6
     */ /**
     * An integer `Number` that specifies the number of velocity iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property velocityIterations
     * @type number
     * @default 4
     */ /**
     * An integer `Number` that specifies the number of constraint iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     * The default value of `2` is usually very adequate.
     *
     * @property constraintIterations
     * @type number
     * @default 2
     */ /**
     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
     * Sleeping can improve stability and performance, but often at the expense of accuracy.
     *
     * @property enableSleeping
     * @type boolean
     * @default false
     */ /**
     * An `Object` containing properties regarding the timing systems of the engine. 
     *
     * @property timing
     * @type object
     */ /**
     * A `Number` that specifies the global scaling factor of time for all bodies.
     * A value of `0` freezes the simulation.
     * A value of `0.1` gives a slow-motion effect.
     * A value of `1.2` gives a speed-up effect.
     *
     * @property timing.timeScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
     * It is incremented on every `Engine.update` by the given `delta` argument. 
     *
     * @property timing.timestamp
     * @type number
     * @default 0
     */ /**
     * An instance of a `Render` controller. The default value is a `Matter.Render` instance created by `Engine.create`.
     * One may also develop a custom renderer module based on `Matter.Render` and pass an instance of it to `Engine.create` via `options.render`.
     *
     * A minimal custom renderer object must define at least three functions: `create`, `clear` and `world` (see `Matter.Render`).
     * It is also possible to instead pass the _module_ reference via `options.render.controller` and `Engine.create` will instantiate one for you.
     *
     * @property render
     * @type render
     * @deprecated see Demo.js for an example of creating a renderer
     * @default a Matter.Render instance
     */ /**
     * An instance of a broadphase controller. The default value is a `Matter.Grid` instance created by `Engine.create`.
     *
     * @property broadphase
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * A `World` composite object that will contain all simulated bodies and constraints.
     *
     * @property world
     * @type world
     * @default a Matter.World instance
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 1402 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            var Class = __webpack_require__(0);
            var Common = __webpack_require__(32);
            var Composite = __webpack_require__(118);
            var Engine = __webpack_require__(1401);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(272);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var MatterBody = __webpack_require__(41);
            var MatterEvents = __webpack_require__(166);
            var MatterTileBody = __webpack_require__(593);
            var MatterWorld = __webpack_require__(596);
            var Vector = __webpack_require__(83);
            /**
 * @classdesc
 * The Matter World class is responsible for managing one single instance of a Matter Physics World for Phaser.
 * 
 * Access this via `this.matter.world` from within a Scene.
 * 
 * This class creates a Matter JS World Composite along with the Matter JS Engine during instantiation. It also
 * handles delta timing, bounds, body and constraint creation and debug drawing.
 * 
 * If you wish to access the Matter JS World object directly, see the `localWorld` property.
 * If you wish to access the Matter Engine directly, see the `engine` property.
 * 
 * This class is an Event Emitter and will proxy _all_ Matter JS events, as they are received.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Matter World instance belongs.
 * @param {Phaser.Types.Physics.Matter.MatterWorldConfig} config - The Matter World configuration object.
 */ var World = new Class({
                Extends: EventEmitter,
                initialize: function World(scene, config) {
                    EventEmitter.call(this);
                    /**
         * The Scene to which this Matter World instance belongs.
         *
         * @name Phaser.Physics.Matter.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * An instance of the MatterJS Engine.
         *
         * @name Phaser.Physics.Matter.World#engine
         * @type {MatterJS.Engine}
         * @since 3.0.0
         */ this.engine = Engine.create(config);
                    /**
         * A `World` composite object that will contain all simulated bodies and constraints.
         *
         * @name Phaser.Physics.Matter.World#localWorld
         * @type {MatterJS.World}
         * @since 3.0.0
         */ this.localWorld = this.engine.world;
                    var gravity = GetValue(config, "gravity", null);
                    if (gravity) this.setGravity(gravity.x, gravity.y, gravity.scale);
                    else if (gravity === false) this.setGravity(0, 0, 0);
                    /**
         * An object containing the 4 wall bodies that bound the physics world.
         *
         * @name Phaser.Physics.Matter.World#walls
         * @type {object}
         * @since 3.0.0
         */ this.walls = {
                        left: null,
                        right: null,
                        top: null,
                        bottom: null
                    };
                    /**
         * A flag that toggles if the world is enabled or not.
         *
         * @name Phaser.Physics.Matter.World#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = GetValue(config, "enabled", true);
                    /**
         * The correction argument is an optional Number that specifies the time correction factor to apply to the update.
         * This can help improve the accuracy of the simulation in cases where delta is changing between updates.
         * The value of correction is defined as delta / lastDelta, i.e. the percentage change of delta over the last step.
         * Therefore the value is always 1 (no correction) when delta is constant (or when no correction is desired, which is the default).
         * See the paper on Time Corrected Verlet for more information.
         *
         * @name Phaser.Physics.Matter.World#correction
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.correction = GetValue(config, "correction", 1);
                    /**
         * This function is called every time the core game loop steps, which is bound to the
         * Request Animation Frame frequency unless otherwise modified.
         * 
         * The function is passed two values: `time` and `delta`, both of which come from the game step values.
         * 
         * It must return a number. This number is used as the delta value passed to Matter.Engine.update.
         * 
         * You can override this function with your own to define your own timestep.
         * 
         * If you need to update the Engine multiple times in a single game step then call
         * `World.update` as many times as required. Each call will trigger the `getDelta` function.
         * If you wish to have full control over when the Engine updates then see the property `autoUpdate`.
         *
         * You can also adjust the number of iterations that Engine.update performs.
         * Use the Scene Matter Physics config object to set the following properties:
         *
         * positionIterations (defaults to 6)
         * velocityIterations (defaults to 4)
         * constraintIterations (defaults to 2)
         *
         * Adjusting these values can help performance in certain situations, depending on the physics requirements
         * of your game.
         *
         * @name Phaser.Physics.Matter.World#getDelta
         * @type {function}
         * @since 3.4.0
         */ this.getDelta = GetValue(config, "getDelta", this.update60Hz);
                    var runnerConfig = GetFastValue(config, "runner", {});
                    var hasFPS = GetFastValue(runnerConfig, "fps", false);
                    var fps = GetFastValue(runnerConfig, "fps", 60);
                    var delta = GetFastValue(runnerConfig, "delta", 1000 / fps);
                    var deltaMin = GetFastValue(runnerConfig, "deltaMin", 1000 / fps);
                    var deltaMax = GetFastValue(runnerConfig, "deltaMax", 1000 / (fps * 0.5));
                    if (!hasFPS) fps = 1000 / delta;
                    /**
         * The Matter JS Runner Configuration object.
         * 
         * This object is populated via the Matter Configuration object's `runner` property and is
         * updated constantly during the game step.
         *
         * @name Phaser.Physics.Matter.World#runner
         * @type {Phaser.Types.Physics.Matter.MatterRunnerConfig}
         * @since 3.22.0
         */ this.runner = {
                        fps: fps,
                        correction: GetFastValue(runnerConfig, "correction", 1),
                        deltaSampleSize: GetFastValue(runnerConfig, "deltaSampleSize", 60),
                        counterTimestamp: 0,
                        frameCounter: 0,
                        deltaHistory: [],
                        timePrev: null,
                        timeScalePrev: 1,
                        frameRequestId: null,
                        isFixed: GetFastValue(runnerConfig, "isFixed", false),
                        delta: delta,
                        deltaMin: deltaMin,
                        deltaMax: deltaMax
                    };
                    /**
         * Automatically call Engine.update every time the game steps.
         * If you disable this then you are responsible for calling `World.step` directly from your game.
         * If you call `set60Hz` or `set30Hz` then `autoUpdate` is reset to `true`.
         *
         * @name Phaser.Physics.Matter.World#autoUpdate
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.autoUpdate = GetValue(config, "autoUpdate", true);
                    var debugConfig = GetValue(config, "debug", false);
                    /**
         * A flag that controls if the debug graphics will be drawn to or not.
         *
         * @name Phaser.Physics.Matter.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = typeof debugConfig === "object" ? true : debugConfig;
                    /**
         * An instance of the Graphics object the debug bodies are drawn to, if enabled.
         *
         * @name Phaser.Physics.Matter.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                    /**
         * The debug configuration object.
         * 
         * The values stored in this object are read from the Matter World Config `debug` property.
         * 
         * When a new Body or Constraint is _added to the World_, they are given the values stored in this object,
         * unless they have their own `render` object set that will override them.
         * 
         * Note that while you can modify the values of properties in this object at run-time, it will not change
         * any of the Matter objects _already added_. It will only impact objects newly added to the world, or one
         * that is removed and then re-added at a later time.
         *
         * @name Phaser.Physics.Matter.World#debugConfig
         * @type {Phaser.Types.Physics.Matter.MatterDebugConfig}
         * @since 3.22.0
         */ this.debugConfig = {
                        showAxes: GetFastValue(debugConfig, "showAxes", false),
                        showAngleIndicator: GetFastValue(debugConfig, "showAngleIndicator", false),
                        angleColor: GetFastValue(debugConfig, "angleColor", 0xe81153),
                        showBroadphase: GetFastValue(debugConfig, "showBroadphase", false),
                        broadphaseColor: GetFastValue(debugConfig, "broadphaseColor", 0xffb400),
                        showBounds: GetFastValue(debugConfig, "showBounds", false),
                        boundsColor: GetFastValue(debugConfig, "boundsColor", 0xffffff),
                        showVelocity: GetFastValue(debugConfig, "showVelocity", false),
                        velocityColor: GetFastValue(debugConfig, "velocityColor", 0x00aeef),
                        showCollisions: GetFastValue(debugConfig, "showCollisions", false),
                        collisionColor: GetFastValue(debugConfig, "collisionColor", 0xf5950c),
                        showSeparations: GetFastValue(debugConfig, "showSeparations", false),
                        separationColor: GetFastValue(debugConfig, "separationColor", 0xffa500),
                        showBody: GetFastValue(debugConfig, "showBody", true),
                        showStaticBody: GetFastValue(debugConfig, "showStaticBody", true),
                        showInternalEdges: GetFastValue(debugConfig, "showInternalEdges", false),
                        renderFill: GetFastValue(debugConfig, "renderFill", false),
                        renderLine: GetFastValue(debugConfig, "renderLine", true),
                        fillColor: GetFastValue(debugConfig, "fillColor", 0x106909),
                        fillOpacity: GetFastValue(debugConfig, "fillOpacity", 1),
                        lineColor: GetFastValue(debugConfig, "lineColor", 0x28de19),
                        lineOpacity: GetFastValue(debugConfig, "lineOpacity", 1),
                        lineThickness: GetFastValue(debugConfig, "lineThickness", 1),
                        staticFillColor: GetFastValue(debugConfig, "staticFillColor", 0x0d177b),
                        staticLineColor: GetFastValue(debugConfig, "staticLineColor", 0x1327e4),
                        showSleeping: GetFastValue(debugConfig, "showSleeping", false),
                        staticBodySleepOpacity: GetFastValue(debugConfig, "staticBodySleepOpacity", 0.7),
                        sleepFillColor: GetFastValue(debugConfig, "sleepFillColor", 0x464646),
                        sleepLineColor: GetFastValue(debugConfig, "sleepLineColor", 0x999a99),
                        showSensors: GetFastValue(debugConfig, "showSensors", true),
                        sensorFillColor: GetFastValue(debugConfig, "sensorFillColor", 0x0d177b),
                        sensorLineColor: GetFastValue(debugConfig, "sensorLineColor", 0x1327e4),
                        showPositions: GetFastValue(debugConfig, "showPositions", true),
                        positionSize: GetFastValue(debugConfig, "positionSize", 4),
                        positionColor: GetFastValue(debugConfig, "positionColor", 0xe042da),
                        showJoint: GetFastValue(debugConfig, "showJoint", true),
                        jointColor: GetFastValue(debugConfig, "jointColor", 0xe0e042),
                        jointLineOpacity: GetFastValue(debugConfig, "jointLineOpacity", 1),
                        jointLineThickness: GetFastValue(debugConfig, "jointLineThickness", 2),
                        pinSize: GetFastValue(debugConfig, "pinSize", 4),
                        pinColor: GetFastValue(debugConfig, "pinColor", 0x42e0e0),
                        springColor: GetFastValue(debugConfig, "springColor", 0xe042e0),
                        anchorColor: GetFastValue(debugConfig, "anchorColor", 0xefefef),
                        anchorSize: GetFastValue(debugConfig, "anchorSize", 4),
                        showConvexHulls: GetFastValue(debugConfig, "showConvexHulls", false),
                        hullColor: GetFastValue(debugConfig, "hullColor", 0xd703d0)
                    };
                    if (this.drawDebug) this.createDebugGraphic();
                    this.setEventsProxy();
                    //  Create the walls
                    if (GetFastValue(config, "setBounds", false)) {
                        var boundsConfig = config["setBounds"];
                        if (typeof boundsConfig === "boolean") this.setBounds();
                        else {
                            var x = GetFastValue(boundsConfig, "x", 0);
                            var y = GetFastValue(boundsConfig, "y", 0);
                            var width = GetFastValue(boundsConfig, "width", scene.sys.scale.width);
                            var height = GetFastValue(boundsConfig, "height", scene.sys.scale.height);
                            var thickness = GetFastValue(boundsConfig, "thickness", 64);
                            var left = GetFastValue(boundsConfig, "left", true);
                            var right = GetFastValue(boundsConfig, "right", true);
                            var top = GetFastValue(boundsConfig, "top", true);
                            var bottom = GetFastValue(boundsConfig, "bottom", true);
                            this.setBounds(x, y, width, height, thickness, left, right, top, bottom);
                        }
                    }
                },
                /**
     * Sets the debug render style for the children of the given Matter Composite.
     * 
     * Composites themselves do not render, but they can contain bodies, constraints and other composites that may do.
     * So the children of this composite are passed to the `setBodyRenderStyle`, `setCompositeRenderStyle` and
     * `setConstraintRenderStyle` methods accordingly.
     * 
     * @method Phaser.Physics.Matter.World#setCompositeRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.CompositeType} composite - The Matter Composite to set the render style on.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setCompositeRenderStyle: function(composite) {
                    var bodies = composite.bodies;
                    var constraints = composite.constraints;
                    var composites = composite.composites;
                    var i;
                    var obj;
                    var render;
                    for(i = 0; i < bodies.length; i++){
                        obj = bodies[i];
                        render = obj.render;
                        this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                    }
                    for(i = 0; i < constraints.length; i++){
                        obj = constraints[i];
                        render = obj.render;
                        this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                    }
                    for(i = 0; i < composites.length; i++){
                        obj = composites[i];
                        this.setCompositeRenderStyle(obj);
                    }
                    return this;
                },
                /**
     * Sets the debug render style for the given Matter Body.
     * 
     * If you are using this on a Phaser Game Object, such as a Matter Sprite, then pass in the body property
     * to this method, not the Game Object itself.
     * 
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     * 
     * If you wish to reset the Body render colors to the defaults found in the World Debug Config, then call
     * this method with just the `body` parameter provided and no others.
     * 
     * @method Phaser.Physics.Matter.World#setBodyRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.BodyType} body - The Matter Body to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [fillColor] - The fill color. If `null` it will use the World Debug Config value.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setBodyRenderStyle: function(body, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                    var render = body.render;
                    var config = this.debugConfig;
                    if (!render) return this;
                    if (lineColor === undefined || lineColor === null) lineColor = body.isStatic ? config.staticLineColor : config.lineColor;
                    if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.lineOpacity;
                    if (lineThickness === undefined || lineThickness === null) lineThickness = config.lineThickness;
                    if (fillColor === undefined || fillColor === null) fillColor = body.isStatic ? config.staticFillColor : config.fillColor;
                    if (fillOpacity === undefined || fillOpacity === null) fillOpacity = config.fillOpacity;
                    if (lineColor !== false) render.lineColor = lineColor;
                    if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                    if (lineThickness !== false) render.lineThickness = lineThickness;
                    if (fillColor !== false) render.fillColor = fillColor;
                    if (fillOpacity !== false) render.fillOpacity = fillOpacity;
                    return this;
                },
                /**
     * Sets the debug render style for the given Matter Constraint.
     * 
     * If you are using this on a Phaser Game Object, then pass in the body property
     * to this method, not the Game Object itself.
     * 
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     * 
     * If you wish to reset the Constraint render colors to the defaults found in the World Debug Config, then call
     * this method with just the `constraint` parameter provided and no others.
     * 
     * @method Phaser.Physics.Matter.World#setConstraintRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [pinSize] - If this constraint is a pin, this sets the size of the pin circle. If `null` it will use the World Debug Config value.
     * @param {number} [anchorColor] - The color used when rendering this constraints anchors.  If `null` it will use the World Debug Config value.
     * @param {number} [anchorSize] - The size of the anchor circle, if this constraint has anchors. If `null` it will use the World Debug Config value.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setConstraintRenderStyle: function(constraint, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                    var render = constraint.render;
                    var config = this.debugConfig;
                    if (!render) return this;
                    //  Reset them
                    if (lineColor === undefined || lineColor === null) {
                        var type = render.type;
                        if (type === "line") lineColor = config.jointColor;
                        else if (type === "pin") lineColor = config.pinColor;
                        else if (type === "spring") lineColor = config.springColor;
                    }
                    if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.jointLineOpacity;
                    if (lineThickness === undefined || lineThickness === null) lineThickness = config.jointLineThickness;
                    if (pinSize === undefined || pinSize === null) pinSize = config.pinSize;
                    if (anchorColor === undefined || anchorColor === null) anchorColor = config.anchorColor;
                    if (anchorSize === undefined || anchorSize === null) anchorSize = config.anchorSize;
                    if (lineColor !== false) render.lineColor = lineColor;
                    if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                    if (lineThickness !== false) render.lineThickness = lineThickness;
                    if (pinSize !== false) render.pinSize = pinSize;
                    if (anchorColor !== false) render.anchorColor = anchorColor;
                    if (anchorSize !== false) render.anchorSize = anchorSize;
                    return this;
                },
                /**
     * This internal method acts as a proxy between all of the Matter JS events and then re-emits them
     * via this class.
     *
     * @method Phaser.Physics.Matter.World#setEventsProxy
     * @since 3.0.0
     */ setEventsProxy: function() {
                    var _this = this;
                    var engine = this.engine;
                    var world = this.localWorld;
                    //  Inject debug styles
                    if (this.drawDebug) {
                        MatterEvents.on(world, "compositeModified", function(composite) {
                            _this.setCompositeRenderStyle(composite);
                        });
                        MatterEvents.on(world, "beforeAdd", function(event) {
                            var objects = [].concat(event.object);
                            for(var i = 0; i < objects.length; i++){
                                var obj = objects[i];
                                var render = obj.render;
                                if (obj.type === "body") _this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                                else if (obj.type === "composite") _this.setCompositeRenderStyle(obj);
                                else if (obj.type === "constraint") _this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                            }
                        });
                    }
                    MatterEvents.on(world, "beforeAdd", function(event) {
                        _this.emit(Events.BEFORE_ADD, event);
                    });
                    MatterEvents.on(world, "afterAdd", function(event) {
                        _this.emit(Events.AFTER_ADD, event);
                    });
                    MatterEvents.on(world, "beforeRemove", function(event) {
                        _this.emit(Events.BEFORE_REMOVE, event);
                    });
                    MatterEvents.on(world, "afterRemove", function(event) {
                        _this.emit(Events.AFTER_REMOVE, event);
                    });
                    MatterEvents.on(engine, "beforeUpdate", function(event) {
                        _this.emit(Events.BEFORE_UPDATE, event);
                    });
                    MatterEvents.on(engine, "afterUpdate", function(event) {
                        _this.emit(Events.AFTER_UPDATE, event);
                    });
                    MatterEvents.on(engine, "collisionStart", function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_START, event, bodyA, bodyB);
                    });
                    MatterEvents.on(engine, "collisionActive", function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_ACTIVE, event, bodyA, bodyB);
                    });
                    MatterEvents.on(engine, "collisionEnd", function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_END, event, bodyA, bodyB);
                    });
                },
                /**
     * Sets the bounds of the Physics world to match the given world pixel dimensions.
     * You can optionally set which 'walls' to create: left, right, top or bottom.
     * If none of the walls are given it will default to use the walls settings it had previously.
     * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
     * the newly created bounds will also not have the left and right walls.
     * Explicitly state them in the parameters to override this.
     *
     * @method Phaser.Physics.Matter.World#setBounds
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left corner of the bounds.
     * @param {number} [y=0] - The y coordinate of the top-left corner of the bounds.
     * @param {number} [width] - The width of the bounds.
     * @param {number} [height] - The height of the bounds.
     * @param {number} [thickness=64] - The thickness of each wall, in pixels.
     * @param {boolean} [left=true] - If true will create the left bounds wall.
     * @param {boolean} [right=true] - If true will create the right bounds wall.
     * @param {boolean} [top=true] - If true will create the top bounds wall.
     * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
     *
     * @return {Phaser.Physics.Matter.World} This Matter World object.
     */ setBounds: function(x, y, width, height, thickness, left, right, top, bottom) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    if (thickness === undefined) thickness = 64;
                    if (left === undefined) left = true;
                    if (right === undefined) right = true;
                    if (top === undefined) top = true;
                    if (bottom === undefined) bottom = true;
                    this.updateWall(left, "left", x - thickness, y - thickness, thickness, height + thickness * 2);
                    this.updateWall(right, "right", x + width, y - thickness, thickness, height + thickness * 2);
                    this.updateWall(top, "top", x, y - thickness, width, thickness);
                    this.updateWall(bottom, "bottom", x, y + height, width, thickness);
                    return this;
                },
                /**
     * Updates the 4 rectangle bodies that were created, if `setBounds` was set in the Matter config, to use
     * the new positions and sizes. This method is usually only called internally via the `setBounds` method.
     *
     * @method Phaser.Physics.Matter.World#updateWall
     * @since 3.0.0
     *
     * @param {boolean} add - `true` if the walls are being added or updated, `false` to remove them from the world.
     * @param {string} [position] - Either `left`, `right`, `top` or `bottom`. Only optional if `add` is `false`.
     * @param {number} [x] - The horizontal position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [y] - The vertical position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [width] - The width of the walls, in pixels. Only optional if `add` is `false`.
     * @param {number} [height] - The height of the walls, in pixels. Only optional if `add` is `false`.
     */ updateWall: function(add, position, x, y, width, height) {
                    var wall = this.walls[position];
                    if (add) {
                        if (wall) MatterWorld.remove(this.localWorld, wall);
                        //  adjust center
                        x += width / 2;
                        y += height / 2;
                        this.walls[position] = this.create(x, y, width, height, {
                            isStatic: true,
                            friction: 0,
                            frictionStatic: 0
                        });
                    } else {
                        if (wall) MatterWorld.remove(this.localWorld, wall);
                        this.walls[position] = null;
                    }
                },
                /**
     * Creates a Phaser.GameObjects.Graphics object that is used to render all of the debug bodies and joints to.
     * 
     * This method is called automatically by the constructor, if debugging has been enabled.
     * 
     * The created Graphics object is automatically added to the Scene at 0x0 and given a depth of `Number.MAX_VALUE`,
     * so it renders above all else in the Scene.
     * 
     * The Graphics object is assigned to the `debugGraphic` property of this class and `drawDebug` is enabled.
     *
     * @method Phaser.Physics.Matter.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The newly created Graphics object.
     */ createDebugGraphic: function() {
                    var graphic = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    graphic.setDepth(Number.MAX_VALUE);
                    this.debugGraphic = graphic;
                    this.drawDebug = true;
                    return graphic;
                },
                /**
     * Sets the world gravity and gravity scale to 0.
     *
     * @method Phaser.Physics.Matter.World#disableGravity
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ disableGravity: function() {
                    this.localWorld.gravity.x = 0;
                    this.localWorld.gravity.y = 0;
                    this.localWorld.gravity.scale = 0;
                    return this;
                },
                /**
     * Sets the worlds gravity to the values given.
     * 
     * Gravity effects all bodies in the world, unless they have the `ignoreGravity` flag set.
     *
     * @method Phaser.Physics.Matter.World#setGravity
     * @since 3.0.0
     *
     * @param {number} [x=0] - The world gravity x component.
     * @param {number} [y=1] - The world gravity y component.
     * @param {number} [scale=0.001] - The gravity scale factor.
     *
     * @return {this} This Matter World object.
     */ setGravity: function(x, y, scale) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 1;
                    this.localWorld.gravity.x = x;
                    this.localWorld.gravity.y = y;
                    if (scale !== undefined) this.localWorld.gravity.scale = scale;
                    return this;
                },
                /**
     * Creates a rectangle Matter body and adds it to the world.
     *
     * @method Phaser.Physics.Matter.World#create
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the body in the world.
     * @param {number} y - The vertical position of the body in the world.
     * @param {number} width - The width of the body.
     * @param {number} height - The height of the body.
     * @param {object} options - Optional Matter configuration object.
     *
     * @return {MatterJS.BodyType} The Matter.js body that was created.
     */ create: function(x, y, width, height, options) {
                    var body = Bodies.rectangle(x, y, width, height, options);
                    MatterWorld.add(this.localWorld, body);
                    return body;
                },
                /**
     * Adds a Matter JS object, or array of objects, to the world.
     * 
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     * 
     * Triggers `beforeAdd` and `afterAdd` events.
     *
     * @method Phaser.Physics.Matter.World#add
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     *
     * @return {this} This Matter World object.
     */ add: function(object) {
                    MatterWorld.add(this.localWorld, object);
                    return this;
                },
                /**
     * Removes a Matter JS object, or array of objects, from the world.
     * 
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     * 
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#remove
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ remove: function(object, deep) {
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entity = object[i];
                        var body = entity.body ? entity.body : entity;
                        Composite.remove(this.localWorld, body, deep);
                    }
                    return this;
                },
                /**
     * Removes a Matter JS constraint, or array of constraints, from the world.
     * 
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#removeConstraint
     * @since 3.0.0
     *
     * @param {(MatterJS.ConstraintType|MatterJS.ConstraintType[])} constraint - A Matter JS Constraint, or an array of constraints, to be removed.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ removeConstraint: function(constraint, deep) {
                    Composite.remove(this.localWorld, constraint, deep);
                    return this;
                },
                /**
     * Adds `MatterTileBody` instances for all the colliding tiles within the given tilemap layer.
     * 
     * Set the appropriate tiles in your layer to collide before calling this method!
     *
     * @method Phaser.Physics.Matter.World#convertTilemapLayer
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTilemapLayer: function(tilemapLayer, options) {
                    var layerData = tilemapLayer.layer;
                    var tiles = tilemapLayer.getTilesWithin(0, 0, layerData.width, layerData.height, {
                        isColliding: true
                    });
                    this.convertTiles(tiles, options);
                    return this;
                },
                /**
     * Adds `MatterTileBody` instances for the given tiles. This adds bodies regardless of whether the
     * tiles are set to collide or not.
     *
     * @method Phaser.Physics.Matter.World#convertTiles
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTiles: function(tiles, options) {
                    if (tiles.length === 0) return this;
                    for(var i = 0; i < tiles.length; i++)new MatterTileBody(this, tiles[i], options);
                    return this;
                },
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will not collide.
     *
     * @method Phaser.Physics.Matter.World#nextGroup
     * @since 3.0.0
     *
     * @param {boolean} [isNonColliding=false] - If `true`, returns the next unique group index for which bodies will _not_ collide.
     *
     * @return {number} Unique category bitfield
     */ nextGroup: function(isNonColliding) {
                    return MatterBody.nextGroup(isNonColliding);
                },
                /**
     * Returns the next unique category bitfield (starting after the initial default category 0x0001).
     * There are 32 available.
     *
     * @method Phaser.Physics.Matter.World#nextCategory
     * @since 3.0.0
     *
     * @return {number} Unique category bitfield
     */ nextCategory: function() {
                    return MatterBody.nextCategory();
                },
                /**
     * Pauses this Matter World instance and sets `enabled` to `false`.
     * 
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.World#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ pause: function() {
                    this.enabled = false;
                    this.emit(Events.PAUSE);
                    return this;
                },
                /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.World#resume
     * @fires Phaser.Physics.Matter.Events#RESUME
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ resume: function() {
                    this.enabled = true;
                    this.emit(Events.RESUME);
                    return this;
                },
                /**
     * The internal update method. This is called automatically by the parent Scene.
     * 
     * Moves the simulation forward in time by delta ms. Uses `World.correction` value as an optional number that
     * specifies the time correction factor to apply to the update. This can help improve the accuracy of the
     * simulation in cases where delta is changing between updates. The value of correction is defined as `delta / lastDelta`,
     * i.e. the percentage change of delta over the last step. Therefore the value is always 1 (no correction) when
     * delta is constant (or when no correction is desired, which is the default).
     * See the paper on Time Corrected Verlet for more information.
     * 
     * Triggers `beforeUpdate` and `afterUpdate` events. Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * 
     * If the World is paused, `update` is still run, but exits early and does not update the Matter Engine.
     *
     * @method Phaser.Physics.Matter.World#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time, delta) {
                    if (!this.enabled || !this.autoUpdate) return;
                    var engine = this.engine;
                    var runner = this.runner;
                    var timing = engine.timing;
                    var correction = this.correction;
                    if (runner.isFixed) //  fixed timestep
                    delta = this.getDelta(time, delta);
                    else {
                        //  dynamic timestep based on wall clock between calls
                        delta = time - runner.timePrev || runner.delta;
                        runner.timePrev = time;
                        // optimistically filter delta over a few frames, to improve stability
                        runner.deltaHistory.push(delta);
                        runner.deltaHistory = runner.deltaHistory.slice(-runner.deltaSampleSize);
                        delta = Math.min.apply(null, runner.deltaHistory);
                        // limit delta
                        delta = delta < runner.deltaMin ? runner.deltaMin : delta;
                        delta = delta > runner.deltaMax ? runner.deltaMax : delta;
                        // correction for delta
                        correction = delta / runner.delta;
                        // update engine timing object
                        runner.delta = delta;
                    }
                    // time correction for time scaling
                    if (runner.timeScalePrev !== 0) correction *= timing.timeScale / runner.timeScalePrev;
                    if (timing.timeScale === 0) correction = 0;
                    runner.timeScalePrev = timing.timeScale;
                    runner.correction = correction;
                    // fps counter
                    runner.frameCounter += 1;
                    if (time - runner.counterTimestamp >= 1000) {
                        runner.fps = runner.frameCounter * ((time - runner.counterTimestamp) / 1000);
                        runner.counterTimestamp = time;
                        runner.frameCounter = 0;
                    }
                    Engine.update(engine, delta, correction);
                },
                /**
     * Manually advances the physics simulation by one iteration.
     * 
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     * 
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     * 
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.World#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     * @param {number} [correction=1] - Optional delta correction value.
     */ step: function(delta, correction) {
                    Engine.update(this.engine, delta, correction);
                },
                /**
     * Runs the Matter Engine.update at a fixed timestep of 60Hz.
     *
     * @method Phaser.Physics.Matter.World#update60Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update60Hz: function() {
                    return 1000 / 60;
                },
                /**
     * Runs the Matter Engine.update at a fixed timestep of 30Hz.
     *
     * @method Phaser.Physics.Matter.World#update30Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update30Hz: function() {
                    return 1000 / 30;
                },
                /**
     * Returns `true` if the given body can be found within the World.
     *
     * @method Phaser.Physics.Matter.World#has
     * @since 3.22.0
     * 
     * @param {(MatterJS.Body|Phaser.GameObjects.GameObject)} body - The Matter Body, or Game Object, to search for within the world.
     * 
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ has: function(body) {
                    var src = body.hasOwnProperty("body") ? body.body : body;
                    return Composite.get(this.localWorld, src.id, src.type) !== null;
                },
                /**
     * Returns all the bodies in the Matter World, including all bodies in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllBodies
     * @since 3.22.0
     * 
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ getAllBodies: function() {
                    return Composite.allBodies(this.localWorld);
                },
                /**
     * Returns all the constraints in the Matter World, including all constraints in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllConstraints
     * @since 3.22.0
     * 
     * @return {MatterJS.ConstraintType[]} An array of all the Matter JS Constraints in this World.
     */ getAllConstraints: function() {
                    return Composite.allConstraints(this.localWorld);
                },
                /**
     * Returns all the composites in the Matter World, including all composites in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllComposites
     * @since 3.22.0
     * 
     * @return {MatterJS.CompositeType[]} An array of all the Matter JS Composites in this World.
     */ getAllComposites: function() {
                    return Composite.allComposites(this.localWorld);
                },
                /**
     * Handles the rendering of bodies and debug information to the debug Graphics object, if enabled.
     * 
     * This method is called automatically by the Scene after all processing has taken place.
     *
     * @method Phaser.Physics.Matter.World#postUpdate
     * @private
     * @since 3.0.0
     */ postUpdate: function() {
                    if (!this.drawDebug) return;
                    var config = this.debugConfig;
                    var engine = this.engine;
                    var graphics = this.debugGraphic;
                    var bodies = Composite.allBodies(this.localWorld);
                    this.debugGraphic.clear();
                    if (config.showBroadphase && engine.broadphase.controller) this.renderGrid(engine.broadphase, graphics, config.broadphaseColor, 0.5);
                    if (config.showBounds) this.renderBodyBounds(bodies, graphics, config.boundsColor, 0.5);
                    if (config.showBody || config.showStaticBody) this.renderBodies(bodies);
                    if (config.showJoint) this.renderJoints();
                    if (config.showAxes || config.showAngleIndicator) this.renderBodyAxes(bodies, graphics, config.showAxes, config.angleColor, 0.5);
                    if (config.showVelocity) this.renderBodyVelocity(bodies, graphics, config.velocityColor, 1, 2);
                    if (config.showSeparations) this.renderSeparations(engine.pairs.list, graphics, config.separationColor);
                    if (config.showCollisions) this.renderCollisions(engine.pairs.list, graphics, config.collisionColor);
                },
                /**
     * Renders the Engine Broadphase Controller Grid to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showBroadphase` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderGrid
     * @since 3.22.0
     * 
     * @param {MatterJS.Grid} grid - The Matter Grid to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderGrid: function(grid, graphics, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    var bucketKeys = Common.keys(grid.buckets);
                    for(var i = 0; i < bucketKeys.length; i++){
                        var bucketId = bucketKeys[i];
                        if (grid.buckets[bucketId].length < 2) continue;
                        var region = bucketId.split(/C|R/);
                        graphics.strokeRect(parseInt(region[1], 10) * grid.bucketWidth, parseInt(region[2], 10) * grid.bucketHeight, grid.bucketWidth, grid.bucketHeight);
                    }
                    return this;
                },
                /**
     * Renders the list of Pair separations to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showSeparations` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderSeparations
     * @since 3.22.0
     * 
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderSeparations: function(pairs, graphics, lineColor) {
                    graphics.lineStyle(1, lineColor, 1);
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        if (!pair.isActive) continue;
                        var collision = pair.collision;
                        var bodyA = collision.bodyA;
                        var bodyB = collision.bodyB;
                        var posA = bodyA.position;
                        var posB = bodyB.position;
                        var penetration = collision.penetration;
                        var k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                        if (bodyB.isStatic) k = 0;
                        graphics.lineBetween(posB.x, posB.y, posB.x - penetration.x * k, posB.y - penetration.y * k);
                        k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                        if (bodyA.isStatic) k = 0;
                        graphics.lineBetween(posA.x, posA.y, posA.x - penetration.x * k, posA.y - penetration.y * k);
                    }
                    return this;
                },
                /**
     * Renders the list of collision points and normals to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showCollisions` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderCollisions
     * @since 3.22.0
     * 
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderCollisions: function(pairs, graphics, lineColor) {
                    graphics.lineStyle(1, lineColor, 0.5);
                    graphics.fillStyle(lineColor, 1);
                    var i;
                    var pair;
                    //  Collision Positions
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        for(var j = 0; j < pair.activeContacts.length; j++){
                            var contact = pair.activeContacts[j];
                            var vertex = contact.vertex;
                            graphics.fillRect(vertex.x - 2, vertex.y - 2, 5, 5);
                        }
                    }
                    //  Collision Normals
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        var collision = pair.collision;
                        var contacts = pair.activeContacts;
                        if (contacts.length > 0) {
                            var normalPosX = contacts[0].vertex.x;
                            var normalPosY = contacts[0].vertex.y;
                            if (contacts.length === 2) {
                                normalPosX = (contacts[0].vertex.x + contacts[1].vertex.x) / 2;
                                normalPosY = (contacts[0].vertex.y + contacts[1].vertex.y) / 2;
                            }
                            if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic) graphics.lineBetween(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8, normalPosX, normalPosY);
                            else graphics.lineBetween(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8, normalPosX, normalPosY);
                        }
                    }
                    return this;
                },
                /**
     * Renders the bounds of an array of Bodies to the given Graphics instance.
     * 
     * If the body is a compound body, it will render the bounds for the parent compound.
     * 
     * The debug renderer calls this method if the `showBounds` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyBounds
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyBounds: function(bodies, graphics, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        var bounds = body.bounds;
                        if (bounds) graphics.strokeRect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
                        else {
                            var parts = body.parts;
                            for(var j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                var part = parts[j];
                                graphics.strokeRect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
                            }
                        }
                    }
                    return this;
                },
                /**
     * Renders either all axes, or a single axis indicator, for an array of Bodies, to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showAxes` or `showAngleIndicator` config values are set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyAxes
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showAxes - If `true` it will render all body axes. If `false` it will render a single axis indicator.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyAxes: function(bodies, graphics, showAxes, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        var parts = body.parts;
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        var part;
                        var j;
                        var k;
                        if (showAxes) for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                var axis = part.axes[k];
                                graphics.lineBetween(part.position.x, part.position.y, part.position.x + axis.x * 20, part.position.y + axis.y * 20);
                            }
                        }
                        else for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++)graphics.lineBetween(part.position.x, part.position.y, (part.vertices[0].x + part.vertices[part.vertices.length - 1].x) / 2, (part.vertices[0].y + part.vertices[part.vertices.length - 1].y) / 2);
                        }
                    }
                    return this;
                },
                /**
     * Renders a velocity indicator for an array of Bodies, to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showVelocity` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyVelocity
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     */ renderBodyVelocity: function(bodies, graphics, lineColor, lineOpacity, lineThickness) {
                    graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        graphics.lineBetween(body.position.x, body.position.y, body.position.x + (body.position.x - body.positionPrev.x) * 2, body.position.y + (body.position.y - body.positionPrev.y) * 2);
                    }
                    return this;
                },
                /**
     * Renders the given array of Bodies to the debug graphics instance.
     * 
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderBodies
     * @private
     * @since 3.14.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     */ renderBodies: function(bodies) {
                    var graphics = this.debugGraphic;
                    var config = this.debugConfig;
                    var showBody = config.showBody;
                    var showStaticBody = config.showStaticBody;
                    var showSleeping = config.showSleeping;
                    var showInternalEdges = config.showInternalEdges;
                    var showConvexHulls = config.showConvexHulls;
                    var renderFill = config.renderFill;
                    var renderLine = config.renderLine;
                    var staticBodySleepOpacity = config.staticBodySleepOpacity;
                    var sleepFillColor = config.sleepFillColor;
                    var sleepLineColor = config.sleepLineColor;
                    var hullColor = config.hullColor;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        //  2) Don't show static bodies, OR
                        //  3) Don't show dynamic bodies
                        if (!showStaticBody && body.isStatic || !showBody && !body.isStatic) continue;
                        var lineColor = body.render.lineColor;
                        var lineOpacity = body.render.lineOpacity;
                        var lineThickness = body.render.lineThickness;
                        var fillColor = body.render.fillColor;
                        var fillOpacity = body.render.fillOpacity;
                        if (showSleeping && body.isSleeping) {
                            if (body.isStatic) {
                                lineOpacity *= staticBodySleepOpacity;
                                fillOpacity *= staticBodySleepOpacity;
                            } else {
                                lineColor = sleepLineColor;
                                fillColor = sleepFillColor;
                            }
                        }
                        if (!renderFill) fillColor = null;
                        if (!renderLine) lineColor = null;
                        this.renderBody(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity);
                        var partsLength = body.parts.length;
                        if (showConvexHulls && partsLength > 1) this.renderConvexHull(body, graphics, hullColor, lineThickness);
                    }
                },
                /**
     * Renders a single Matter Body to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body to your own Graphics instance.
     * 
     * If you don't wish to render a line around the body, set the `lineColor` parameter to `null`.
     * Equally, if you don't wish to render a fill, set the `fillColor` parameter to `null`.
     * 
     * @method Phaser.Physics.Matter.World#renderBody
     * @since 3.22.0
     * 
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showInternalEdges - Render internal edges of the polygon?
     * @param {number} [lineColor] - The line color.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1.
     * @param {number} [lineThickness=1] - The line thickness.
     * @param {number} [fillColor] - The fill color.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderBody: function(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                    if (lineColor === undefined) lineColor = null;
                    if (lineOpacity === undefined) lineOpacity = null;
                    if (lineThickness === undefined) lineThickness = 1;
                    if (fillColor === undefined) fillColor = null;
                    if (fillOpacity === undefined) fillOpacity = null;
                    var config = this.debugConfig;
                    var sensorFillColor = config.sensorFillColor;
                    var sensorLineColor = config.sensorLineColor;
                    //  Handle compound parts
                    var parts = body.parts;
                    var partsLength = parts.length;
                    for(var k = partsLength > 1 ? 1 : 0; k < partsLength; k++){
                        var part = parts[k];
                        var render = part.render;
                        var opacity = render.opacity;
                        if (!render.visible || opacity === 0 || part.isSensor && !config.showSensors) continue;
                        //  Part polygon
                        var circleRadius = part.circleRadius;
                        graphics.beginPath();
                        if (part.isSensor) {
                            if (fillColor !== null) graphics.fillStyle(sensorFillColor, fillOpacity * opacity);
                            if (lineColor !== null) graphics.lineStyle(lineThickness, sensorLineColor, lineOpacity * opacity);
                        } else {
                            if (fillColor !== null) graphics.fillStyle(fillColor, fillOpacity * opacity);
                            if (lineColor !== null) graphics.lineStyle(lineThickness, lineColor, lineOpacity * opacity);
                        }
                        if (circleRadius) graphics.arc(part.position.x, part.position.y, circleRadius, 0, 2 * Math.PI);
                        else {
                            var vertices = part.vertices;
                            var vertLength = vertices.length;
                            graphics.moveTo(vertices[0].x, vertices[0].y);
                            for(var j = 1; j < vertLength; j++){
                                var vert = vertices[j];
                                if (!vertices[j - 1].isInternal || showInternalEdges) graphics.lineTo(vert.x, vert.y);
                                else graphics.moveTo(vert.x, vert.y);
                                if (j < vertLength && vert.isInternal && !showInternalEdges) {
                                    var nextIndex = (j + 1) % vertLength;
                                    graphics.moveTo(vertices[nextIndex].x, vertices[nextIndex].y);
                                }
                            }
                            graphics.closePath();
                        }
                        if (fillColor !== null) graphics.fillPath();
                        if (lineColor !== null) graphics.strokePath();
                    }
                    if (config.showPositions && !body.isStatic) {
                        var px = body.position.x;
                        var py = body.position.y;
                        var hs = Math.ceil(config.positionSize / 2);
                        graphics.fillStyle(config.positionColor, 1);
                        graphics.fillRect(px - hs, py - hs, config.positionSize, config.positionSize);
                    }
                    return this;
                },
                /**
     * Renders the Convex Hull for a single Matter Body to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body hull to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderConvexHull
     * @since 3.22.0
     * 
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} hullColor - The color used to render the hull.
     * @param {number} [lineThickness=1] - The hull line thickness.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderConvexHull: function(body, graphics, hullColor, lineThickness) {
                    if (lineThickness === undefined) lineThickness = 1;
                    var parts = body.parts;
                    var partsLength = parts.length;
                    //  Render Convex Hulls
                    if (partsLength > 1) {
                        var verts = body.vertices;
                        graphics.lineStyle(lineThickness, hullColor);
                        graphics.beginPath();
                        graphics.moveTo(verts[0].x, verts[0].y);
                        for(var v = 1; v < verts.length; v++)graphics.lineTo(verts[v].x, verts[v].y);
                        graphics.lineTo(verts[0].x, verts[0].y);
                        graphics.strokePath();
                    }
                    return this;
                },
                /**
     * Renders all of the constraints in the world (unless they are specifically set to invisible).
     * 
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderJoints
     * @private
     * @since 3.14.0
     */ renderJoints: function() {
                    var graphics = this.debugGraphic;
                    // Render constraints 
                    var constraints = Composite.allConstraints(this.localWorld);
                    for(var i = 0; i < constraints.length; i++){
                        var config = constraints[i].render;
                        var lineColor = config.lineColor;
                        var lineOpacity = config.lineOpacity;
                        var lineThickness = config.lineThickness;
                        var pinSize = config.pinSize;
                        var anchorColor = config.anchorColor;
                        var anchorSize = config.anchorSize;
                        this.renderConstraint(constraints[i], graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize);
                    }
                },
                /**
     * Renders a single Matter Constraint, such as a Pin or a Spring, to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Constraint to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderConstraint
     * @since 3.22.0
     * 
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to render.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     * @param {number} pinSize - If this constraint is a pin, this sets the size of the pin circle.
     * @param {number} anchorColor - The color used when rendering this constraints anchors. Set to `null` to not render anchors.
     * @param {number} anchorSize - The size of the anchor circle, if this constraint has anchors and is rendering them.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderConstraint: function(constraint, graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                    var render = constraint.render;
                    if (!render.visible || !constraint.pointA || !constraint.pointB) return this;
                    graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                    var bodyA = constraint.bodyA;
                    var bodyB = constraint.bodyB;
                    var start;
                    var end;
                    if (bodyA) start = Vector.add(bodyA.position, constraint.pointA);
                    else start = constraint.pointA;
                    if (render.type === "pin") graphics.strokeCircle(start.x, start.y, pinSize);
                    else {
                        if (bodyB) end = Vector.add(bodyB.position, constraint.pointB);
                        else end = constraint.pointB;
                        graphics.beginPath();
                        graphics.moveTo(start.x, start.y);
                        if (render.type === "spring") {
                            var delta = Vector.sub(end, start);
                            var normal = Vector.perp(Vector.normalise(delta));
                            var coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20));
                            var offset;
                            for(var j = 1; j < coils; j += 1){
                                offset = j % 2 === 0 ? 1 : -1;
                                graphics.lineTo(start.x + delta.x * (j / coils) + normal.x * offset * 4, start.y + delta.y * (j / coils) + normal.y * offset * 4);
                            }
                        }
                        graphics.lineTo(end.x, end.y);
                    }
                    graphics.strokePath();
                    if (render.anchors && anchorSize > 0) {
                        graphics.fillStyle(anchorColor);
                        graphics.fillCircle(start.x, start.y, anchorSize);
                        graphics.fillCircle(end.x, end.y, anchorSize);
                    }
                    return this;
                },
                /**
     * Resets the internal collision IDs that Matter.JS uses for Body collision groups.
     * 
     * You should call this before destroying your game if you need to restart the game
     * again on the same page, without first reloading the page. Or, if you wish to
     * consistently destroy a Scene that contains Matter.js and then run it again
     * later in the same game.
     *
     * @method Phaser.Physics.Matter.World#resetCollisionIDs
     * @since 3.17.0
     */ resetCollisionIDs: function() {
                    Body._nextCollidingGroupId = 1;
                    Body._nextNonCollidingGroupId = -1;
                    Body._nextCategory = 0x0001;
                    return this;
                },
                /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * @method Phaser.Physics.Matter.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    MatterEvents.off(this.engine);
                    this.removeAllListeners();
                    MatterWorld.clear(this.localWorld, false);
                    Engine.clear(this.engine);
                    if (this.drawDebug) this.debugGraphic.destroy();
                },
                /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * After destroying the world it cannot be re-used again.
     *
     * @method Phaser.Physics.Matter.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                }
            });
            module1.exports = World;
        /***/ },
        /* 1403 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Plugins
 */ module1.exports = {
                BasePlugin: __webpack_require__(540),
                DefaultPlugins: __webpack_require__(197),
                PluginCache: __webpack_require__(24),
                PluginManager: __webpack_require__(414),
                ScenePlugin: __webpack_require__(1404)
            };
        /***/ },
        /* 1404 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* @author       Richard Davey <rich@photonstorm.com>
* @copyright    2020 Photon Storm Ltd.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var BasePlugin = __webpack_require__(540);
            var Class = __webpack_require__(0);
            var SceneEvents = __webpack_require__(20);
            /**
 * @classdesc
 * A Scene Level Plugin is installed into every Scene and belongs to that Scene.
 * It can listen for Scene events and respond to them.
 * It can map itself to a Scene property, or into the Scene Systems, or both.
 *
 * @class ScenePlugin
 * @memberof Phaser.Plugins
 * @extends Phaser.Plugins.BasePlugin
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that has installed this plugin.
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 * @param {string} pluginKey - The key under which this plugin has been installed into the Scene Systems.
 */ var ScenePlugin = new Class({
                Extends: BasePlugin,
                initialize: function ScenePlugin(scene, pluginManager, pluginKey) {
                    BasePlugin.call(this, pluginManager);
                    /**
         * A reference to the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#scene
         * @type {?Phaser.Scene}
         * @protected
         * @since 3.8.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems of the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#systems
         * @type {?Phaser.Scenes.Systems}
         * @protected
         * @since 3.8.0
         */ this.systems = scene.sys;
                    /**
         * The key under which this plugin was installed into the Scene Systems.
         *
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#pluginKey
         * @type {string}
         * @readonly
         * @since 3.54.0
         */ this.pluginKey = pluginKey;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                },
                /**
     * This method is called when the Scene boots. It is only ever called once.
     *
     * By this point the plugin properties `scene` and `systems` will have already been set.
     *
     * In here you can listen for {@link Phaser.Scenes.Events Scene events} and set-up whatever you need for this plugin to run.
     * Here are the Scene events you can listen to:
     *
     * - start
     * - ready
     * - preupdate
     * - update
     * - postupdate
     * - resize
     * - pause
     * - resume
     * - sleep
     * - wake
     * - transitioninit
     * - transitionstart
     * - transitioncomplete
     * - transitionout
     * - shutdown
     * - destroy
     *
     * At the very least you should offer a destroy handler for when the Scene closes down, i.e:
     *
     * ```javascript
     * var eventEmitter = this.systems.events;
     * eventEmitter.once('destroy', this.sceneDestroy, this);
     * ```
     *
     * @method Phaser.Plugins.ScenePlugin#boot
     * @since 3.8.0
     */ boot: function() {},
                /**
     * Game instance has been destroyed.
     *
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.ScenePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                    this.pluginManager = null;
                    this.game = null;
                    this.scene = null;
                    this.systems = null;
                }
            });
            module1.exports = ScenePlugin;
        /***/ },
        /* 1405 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer
 */ /**
 * @namespace Phaser.Types.Renderer
 */ module1.exports = {
                Canvas: __webpack_require__(1406),
                Events: __webpack_require__(91),
                Snapshot: __webpack_require__(1407),
                WebGL: __webpack_require__(1408)
            };
        /***/ },
        /* 1406 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Canvas
 */ module1.exports = {
                CanvasRenderer: __webpack_require__(368),
                GetBlendModes: __webpack_require__(370),
                SetTransform: __webpack_require__(30)
            };
        /***/ },
        /* 1407 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Snapshot
 */ module1.exports = {
                Canvas: __webpack_require__(369),
                WebGL: __webpack_require__(383)
            };
        /***/ },
        /* 1408 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = __webpack_require__(107);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Renderer.WebGL
 */ var WebGL = {
                PipelineManager: __webpack_require__(372),
                Pipelines: __webpack_require__(1409),
                RenderTarget: __webpack_require__(141),
                Utils: __webpack_require__(12),
                WebGLPipeline: __webpack_require__(58),
                WebGLRenderer: __webpack_require__(371),
                WebGLShader: __webpack_require__(375)
            };
            //   Merge in the consts
            WebGL = Extend(false, WebGL, WEBGL_CONST);
            //  Export it
            module1.exports = WebGL;
        /***/ },
        /* 1409 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(92);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Renderer.WebGL.Pipelines
 */ var Pipelines = {
                BitmapMaskPipeline: __webpack_require__(373),
                Events: __webpack_require__(374),
                GraphicsPipeline: __webpack_require__(376),
                LightPipeline: __webpack_require__(377),
                MultiPipeline: __webpack_require__(108),
                PointLightPipeline: __webpack_require__(378),
                PostFXPipeline: __webpack_require__(1410),
                RopePipeline: __webpack_require__(379),
                SinglePipeline: __webpack_require__(380),
                UtilityPipeline: __webpack_require__(381)
            };
            //   Merge in the consts
            Pipelines = Extend(false, Pipelines, CONST);
            //  Export it
            module1.exports = Pipelines;
        /***/ },
        /* 1410 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ColorMatrix = __webpack_require__(198);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(1411);
            var ShaderSourceVS = __webpack_require__(382);
            var WebGLPipeline = __webpack_require__(58);
            /**
 * @classdesc
 * The Post FX Pipeline is a special kind of pipeline specifically for handling post
 * processing effects. Where-as a standard Pipeline allows you to control the process
 * of rendering Game Objects by configuring the shaders and attributes used to draw them,
 * a Post FX Pipeline is designed to allow you to apply processing _after_ the Game Object/s
 * have been rendered. Typical examples of post processing effects are bloom filters,
 * blurs, light effects and color manipulation.
 *
 * The pipeline works by creating a tiny vertex buffer with just one single hard-coded quad
 * in it. Game Objects can have a Post Pipeline set on them. Those objects are then rendered
 * using their standard pipeline, but are redirected to the Render Targets owned by the
 * post pipeline, which can then apply their own shaders and effects, before passing them
 * back to the main renderer.
 *
 * Please see the Phaser 3 examples for further details on this extensive subject.
 *
 * The default fragment shader it uses can be found in `shaders/src/PostFX.frag`.
 * The default vertex shader it uses can be found in `shaders/src/Quad.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * The vertices array layout is:
 *
 * -1,  1   B----C   1,  1
 *  0,  1   |   /|   1,  1
 *          |  / |
 *          | /  |
 *          |/   |
 * -1, -1   A----D   1, -1
 *  0,  0            1,  0
 *
 * A = -1, -1 (pos) and 0, 0 (uv)
 * B = -1,  1 (pos) and 0, 1 (uv)
 * C =  1,  1 (pos) and 1, 1 (uv)
 * D =  1, -1 (pos) and 1, 0 (uv)
 *
 * First tri: A, B, C
 * Second tri: A, C, D
 *
 * Array index:
 *
 * 0  = Tri 1 - Vert A - x pos
 * 1  = Tri 1 - Vert A - y pos
 * 2  = Tri 1 - Vert A - uv u
 * 3  = Tri 1 - Vert A - uv v
 *
 * 4  = Tri 1 - Vert B - x pos
 * 5  = Tri 1 - Vert B - y pos
 * 6  = Tri 1 - Vert B - uv u
 * 7  = Tri 1 - Vert B - uv v
 *
 * 8  = Tri 1 - Vert C - x pos
 * 9  = Tri 1 - Vert C - y pos
 * 10 = Tri 1 - Vert C - uv u
 * 11 = Tri 1 - Vert C - uv v
 *
 * 12 = Tri 2 - Vert A - x pos
 * 13 = Tri 2 - Vert A - y pos
 * 14 = Tri 2 - Vert A - uv u
 * 15 = Tri 2 - Vert A - uv v
 *
 * 16 = Tri 2 - Vert C - x pos
 * 17 = Tri 2 - Vert C - y pos
 * 18 = Tri 2 - Vert C - uv u
 * 19 = Tri 2 - Vert C - uv v
 *
 * 20 = Tri 2 - Vert D - x pos
 * 21 = Tri 2 - Vert D - y pos
 * 22 = Tri 2 - Vert D - uv u
 * 23 = Tri 2 - Vert D - uv v
 *
 * @class PostFXPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PostFXPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function PostFXPipeline(config) {
                    config.renderTarget = GetFastValue(config, "renderTarget", 1);
                    config.fragShader = GetFastValue(config, "fragShader", ShaderSourceFS);
                    config.vertShader = GetFastValue(config, "vertShader", ShaderSourceVS);
                    config.attributes = GetFastValue(config, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        }
                    ]);
                    config.batchSize = 1;
                    config.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ];
                    WebGLPipeline.call(this, config);
                    this.isPostFX = true;
                    /**
         * If this post-pipeline belongs to a Game Object or Camera, this contains a reference to it.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.50.0
         */ this.gameObject;
                    /**
         * A Color Matrix instance belonging to this pipeline.
         *
         * Used during calls to the `drawFrame` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                    /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                    if (this.renderer.isBooted) {
                        this.manager = this.renderer.pipelines;
                        this.boot();
                    }
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var utility = this.manager.UTILITY_PIPELINE;
                    this.fullFrame1 = utility.fullFrame1;
                    this.fullFrame2 = utility.fullFrame2;
                    this.halfFrame1 = utility.halfFrame1;
                    this.halfFrame2 = utility.halfFrame2;
                    this.set1i("uMainSampler", 0);
                },
                onDraw: function(renderTarget) {
                    this.bindAndDraw(renderTarget);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    this.manager.copyFrame(source, target, brightness, clear, clearAlpha);
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    this.manager.copyToGame(source);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ drawFrame: function(source, target, clearAlpha) {
                    this.manager.drawFrame(source, target, clearAlpha, this.colorMatrix);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                    this.manager.blendFrames(source1, source2, target, strength, clearAlpha);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.manager.blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                    this.manager.clearFrame(target, clearAlpha);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    this.manager.blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    this.manager.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                },
                /**
     * Binds this pipeline and draws the `source` Render Target to the `target` Render Target.
     *
     * If no `target` is specified, it will pop the framebuffer from the Renderers FBO stack
     * and use that instead, which should be done when you need to draw the final results of
     * this pipeline to the game canvas.
     *
     * You can optionally set the shader to be used for the draw here, if this is a multi-shader
     * pipeline. By default `currentShader` will be used. If you need to set a shader but not
     * a target, just pass `null` as the `target` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#bindAndDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to draw to. If not set, it will pop the fbo from the stack.
     * @param {boolean} [clear=true] - Clear the target before copying? Only used if `target` parameter is set.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to use during the draw.
     */ bindAndDraw: function(source, target, clear, clearAlpha, currentShader) {
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    this.bind(currentShader);
                    this.set1i("uMainSampler", 0);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                        if (clear) {
                            if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                            else gl.clearColor(0, 0, 0, 1);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                    } else {
                        renderer.popFramebuffer(false, false, false);
                        if (!renderer.currentFramebuffer) gl.viewport(0, 0, renderer.width, renderer.height);
                    }
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    if (!target) renderer.resetTextures();
                    else {
                        gl.bindTexture(gl.TEXTURE_2D, null);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    }
                }
            });
            module1.exports = PostFXPipeline;
        /***/ },
        /* 1411 */ /***/ function(module1, exports) {
            module1.exports = [
                "#define SHADER_NAME PHASER_POSTFX_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = texture2D(uMainSampler, outTexCoord);",
                "}",
                ""
            ].join("\n");
        /***/ },
        /* 1412 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var CONST = __webpack_require__(201);
            /**
 * @namespace Phaser.Scale
 * 
 * @borrows Phaser.Scale.Center.NO_CENTER as NO_CENTER
 * @borrows Phaser.Scale.Center.CENTER_BOTH as CENTER_BOTH
 * @borrows Phaser.Scale.Center.CENTER_HORIZONTALLY as CENTER_HORIZONTALLY
 * @borrows Phaser.Scale.Center.CENTER_VERTICALLY as CENTER_VERTICALLY
 * 
 * @borrows Phaser.Scale.Orientation.LANDSCAPE as LANDSCAPE
 * @borrows Phaser.Scale.Orientation.PORTRAIT as PORTRAIT
 * 
 * @borrows Phaser.Scale.ScaleModes.NONE as NONE
 * @borrows Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT as WIDTH_CONTROLS_HEIGHT
 * @borrows Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH as HEIGHT_CONTROLS_WIDTH
 * @borrows Phaser.Scale.ScaleModes.FIT as FIT
 * @borrows Phaser.Scale.ScaleModes.ENVELOP as ENVELOP
 * @borrows Phaser.Scale.ScaleModes.RESIZE as RESIZE
 * 
 * @borrows Phaser.Scale.Zoom.NO_ZOOM as NO_ZOOM
 * @borrows Phaser.Scale.Zoom.ZOOM_2X as ZOOM_2X
 * @borrows Phaser.Scale.Zoom.ZOOM_4X as ZOOM_4X
 * @borrows Phaser.Scale.Zoom.MAX_ZOOM as MAX_ZOOM
 */ var Scale = {
                Center: __webpack_require__(403),
                Events: __webpack_require__(104),
                Orientation: __webpack_require__(404),
                ScaleManager: __webpack_require__(415),
                ScaleModes: __webpack_require__(405),
                Zoom: __webpack_require__(406)
            };
            Scale = Extend(false, Scale, CONST.CENTER);
            Scale = Extend(false, Scale, CONST.ORIENTATION);
            Scale = Extend(false, Scale, CONST.SCALE_MODE);
            Scale = Extend(false, Scale, CONST.ZOOM);
            module1.exports = Scale;
        /***/ },
        /* 1413 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(144);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Scenes
 */ var Scene = {
                Events: __webpack_require__(20),
                GetPhysicsPlugins: __webpack_require__(419),
                GetScenePlugins: __webpack_require__(420),
                SceneManager: __webpack_require__(417),
                ScenePlugin: __webpack_require__(1414),
                Settings: __webpack_require__(421),
                Systems: __webpack_require__(204)
            };
            //   Merge in the consts
            Scene = Extend(false, Scene, CONST);
            module1.exports = Scene;
        /***/ },
        /* 1414 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(20);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            /**
 * @classdesc
 * The Scene Plugin is the main interface to the Scene Manager and allows you to control
 * any Scene running in your game. You should always use this plugin. By default, it is
 * mapped to the Scene property `this.scene`. Meaning, from within a Scene, you can call
 * methods such as `this.scene.start()`.
 *
 * Note that nearly all methods in this class are run on a queue-basis and not
 * immediately. For example, calling `this.scene.launch('SceneB')` will try to
 * launch SceneB when the Scene Manager next updates, which is at the start of the game
 * step. All operations are queued and run in the order in which they are invoked here.
 *
 * @class ScenePlugin
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this ScenePlugin belongs to.
 */ var ScenePlugin = new Class({
                initialize: function ScenePlugin(scene) {
                    /**
         * The Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene Systems instance of the Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The settings of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = scene.sys.settings;
                    /**
         * The key of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#key
         * @type {string}
         * @since 3.0.0
         */ this.key = scene.sys.settings.key;
                    /**
         * The Game's SceneManager.
         *
         * @name Phaser.Scenes.ScenePlugin#manager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.scene;
                    /**
         * If this Scene is currently transitioning to another, this holds
         * the current percentage of the transition progress, between 0 and 1.
         *
         * @name Phaser.Scenes.ScenePlugin#transitionProgress
         * @type {number}
         * @since 3.5.0
         */ this.transitionProgress = 0;
                    /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_target
         * @type {?Phaser.Scenes.Scene}
         * @private
         * @since 3.5.0
         */ this._target = null;
                    /**
         * Transition duration.
         *
         * @name Phaser.Scenes.ScenePlugin#_duration
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._duration = 0;
                    /**
         * Transition callback.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdate
         * @type {function}
         * @private
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * Transition callback scope.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdateScope
         * @type {object}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                    /**
         * Will this Scene sleep (true) after the transition, or stop (false)
         *
         * @name Phaser.Scenes.ScenePlugin#_willSleep
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willSleep = false;
                    /**
         * Will this Scene be removed from the Scene Manager after the transition completes?
         *
         * @name Phaser.Scenes.ScenePlugin#_willRemove
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willRemove = false;
                    scene.sys.events.once(Events.BOOT, this.boot, this);
                    scene.sys.events.on(Events.START, this.pluginStart, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    this.systems.events.once(Events.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#pluginStart
     * @private
     * @since 3.5.0
     */ pluginStart: function() {
                    this._target = null;
                    this.systems.events.once(Events.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Shutdown this Scene and run the given one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#start
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to start.
     * @param {object} [data] - The Scene data.
     *
     * @return {this} This Scene Plugin instance.
     */ start: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("stop", this.key);
                    this.manager.queueOp("start", key, data);
                    return this;
                },
                /**
     * Restarts this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#restart
     * @since 3.4.0
     *
     * @param {object} [data] - The Scene data.
     *
     * @return {this} This Scene Plugin instance.
     */ restart: function(data) {
                    var key = this.key;
                    this.manager.queueOp("stop", key);
                    this.manager.queueOp("start", key, data);
                    return this;
                },
                /**
     * This will start a transition from the current Scene to the target Scene given.
     *
     * The transition will last for the duration specified in milliseconds.
     *
     * You can have the target Scene moved above or below this one in the display list.
     *
     * You can specify an update callback. This callback will be invoked _every frame_ for the duration
     * of the transition.
     *
     * This Scene can either be sent to sleep at the end of the transition, or stopped. The default is to stop.
     *
     * There are also 5 transition related events: This scene will emit the event `transitionout` when
     * the transition begins, which is typically the frame after calling this method.
     *
     * The target Scene will emit the event `transitioninit` when that Scene's `init` method is called.
     * It will then emit the event `transitionstart` when its `create` method is called.
     * If the Scene was sleeping and has been woken up, it will emit the event `transitionwake` instead of these two,
     * as the Scenes `init` and `create` methods are not invoked when a Scene wakes up.
     *
     * When the duration of the transition has elapsed it will emit the event `transitioncomplete`.
     * These events are cleared of all listeners when the Scene shuts down, but not if it is sent to sleep.
     *
     * It's important to understand that the duration of the transition begins the moment you call this method.
     * If the Scene you are transitioning to includes delayed processes, such as waiting for files to load, the
     * time still counts down even while that is happening. If the game itself pauses, or something else causes
     * this Scenes update loop to stop, then the transition will also pause for that duration. There are
     * checks in place to prevent you accidentally stopping a transitioning Scene but if you've got code to
     * override this understand that until the target Scene completes it might never be unlocked for input events.
     *
     * @method Phaser.Scenes.ScenePlugin#transition
     * @fires Phaser.Scenes.Events#TRANSITION_OUT
     * @since 3.5.0
     *
     * @param {Phaser.Types.Scenes.SceneTransitionConfig} config - The transition configuration object.
     *
     * @return {boolean} `true` is the transition was started, otherwise `false`.
     */ transition: function(config) {
                    if (config === undefined) config = {};
                    var key = GetFastValue(config, "target", false);
                    var target = this.manager.getScene(key);
                    if (!key || !this.checkValidTransition(target)) return false;
                    var duration = GetFastValue(config, "duration", 1000);
                    this._elapsed = 0;
                    this._target = target;
                    this._duration = duration;
                    this._willSleep = GetFastValue(config, "sleep", false);
                    this._willRemove = GetFastValue(config, "remove", false);
                    var callback = GetFastValue(config, "onUpdate", null);
                    if (callback) {
                        this._onUpdate = callback;
                        this._onUpdateScope = GetFastValue(config, "onUpdateScope", this.scene);
                    }
                    var allowInput = GetFastValue(config, "allowInput", false);
                    this.settings.transitionAllowInput = allowInput;
                    var targetSettings = target.sys.settings;
                    targetSettings.isTransition = true;
                    targetSettings.transitionFrom = this.scene;
                    targetSettings.transitionDuration = duration;
                    targetSettings.transitionAllowInput = allowInput;
                    if (GetFastValue(config, "moveAbove", false)) this.manager.moveAbove(this.key, key);
                    else if (GetFastValue(config, "moveBelow", false)) this.manager.moveBelow(this.key, key);
                    if (target.sys.isSleeping()) target.sys.wake(GetFastValue(config, "data"));
                    else this.manager.start(key, GetFastValue(config, "data"));
                    this.systems.events.emit(Events.TRANSITION_OUT, target, duration);
                    this.systems.events.on(Events.UPDATE, this.step, this);
                    return true;
                },
                /**
     * Checks to see if this Scene can transition to the target Scene or not.
     *
     * @method Phaser.Scenes.ScenePlugin#checkValidTransition
     * @private
     * @since 3.5.0
     *
     * @param {Phaser.Scene} target - The Scene to test against.
     *
     * @return {boolean} `true` if this Scene can transition, otherwise `false`.
     */ checkValidTransition: function(target) {
                    //  Not a valid target if it doesn't exist, isn't active or is already transitioning in or out
                    if (!target || target.sys.isActive() || target.sys.isTransitioning() || target === this.scene || this.systems.isTransitioning()) return false;
                    return true;
                },
                /**
     * A single game step. This is only called if the parent Scene is transitioning
     * out to another Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#step
     * @private
     * @since 3.5.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                    this._elapsed += delta;
                    this.transitionProgress = Clamp(this._elapsed / this._duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.transitionProgress);
                    if (this._elapsed >= this._duration) this.transitionComplete();
                },
                /**
     * Called by `step` when the transition out of this scene to another is over.
     *
     * @method Phaser.Scenes.ScenePlugin#transitionComplete
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_COMPLETE
     * @since 3.5.0
     */ transitionComplete: function() {
                    var targetSys = this._target.sys;
                    var targetSettings = this._target.sys.settings;
                    //  Stop the step
                    this.systems.events.off(Events.UPDATE, this.step, this);
                    //  Notify target scene
                    targetSys.events.emit(Events.TRANSITION_COMPLETE, this.scene);
                    //  Clear target scene settings
                    targetSettings.isTransition = false;
                    targetSettings.transitionFrom = null;
                    //  Clear local settings
                    this._duration = 0;
                    this._target = null;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    //  Now everything is clear we can handle what happens to this Scene
                    if (this._willRemove) this.manager.remove(this.key);
                    else if (this._willSleep) this.systems.sleep();
                    else this.manager.stop(this.key);
                },
                /**
     * Add the Scene into the Scene Manager and start it if 'autoStart' is true or the Scene config 'active' property is set.
     *
     * @method Phaser.Scenes.ScenePlugin#add
     * @since 3.0.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig|function)} sceneConfig - The config for the Scene
     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
     * @param {object} [data] - Optional data object. This will be set as `Scene.settings.data` and passed to `Scene.init`, and `Scene.create`.
     *
     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
     */ add: function(key, sceneConfig, autoStart, data) {
                    return this.manager.add(key, sceneConfig, autoStart, data);
                },
                /**
     * Launch the given Scene and run it in parallel with this one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#launch
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to launch.
     * @param {object} [data] - The Scene data.
     *
     * @return {this} This Scene Plugin instance.
     */ launch: function(key, data) {
                    if (key && key !== this.key) this.manager.queueOp("start", key, data);
                    return this;
                },
                /**
     * Runs the given Scene, but does not change the state of this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#run
     * @since 3.10.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene and emitted in its ready, wake, or resume events.
     *
     * @return {this} This Scene Plugin instance.
     */ run: function(key, data) {
                    if (key && key !== this.key) this.manager.queueOp("run", key, data);
                    return this;
                },
                /**
     * Pause the Scene - this stops the update step from happening but it still renders.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#pause
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its pause event.
     *
     * @return {this} This Scene Plugin instance.
     */ pause: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("pause", key, data);
                    return this;
                },
                /**
     * Resume the Scene - starts the update loop again.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#resume
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its resume event.
     *
     * @return {this} This Scene Plugin instance.
     */ resume: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("resume", key, data);
                    return this;
                },
                /**
     * Makes the Scene sleep (no update, no render) but doesn't shutdown.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#sleep
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its sleep event.
     *
     * @return {this} This Scene Plugin instance.
     */ sleep: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("sleep", key, data);
                    return this;
                },
                /**
     * Makes the Scene wake-up (starts update and render)
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#wake
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its wake event.
     *
     * @return {this} This Scene Plugin instance.
     */ wake: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("wake", key, data);
                    return this;
                },
                /**
     * Makes this Scene sleep then starts the Scene given.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#switch
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to start.
     *
     * @return {this} This Scene Plugin instance.
     */ switch: function(key) {
                    if (key !== this.key) this.manager.queueOp("switch", this.key, key);
                    return this;
                },
                /**
     * Shutdown the Scene, clearing display list, timers, etc.
     *
     * This happens at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#stop
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to stop.
     * @param {any} [data] - Optional data object to pass to Scene.Systems.shutdown.
     *
     * @return {this} This Scene Plugin instance.
     */ stop: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp("stop", key, data);
                    return this;
                },
                /**
     * Sets the active state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - If `true` the Scene will be resumed. If `false` it will be paused.
     * @param {(string|Phaser.Scene)} [key] - The Scene to set the active state of.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted with its events.
     *
     * @return {this} This Scene Plugin instance.
     */ setActive: function(value, key, data) {
                    if (key === undefined) key = this.key;
                    var scene = this.manager.getScene(key);
                    if (scene) scene.sys.setActive(value, data);
                    return this;
                },
                /**
     * Sets the visible state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible value.
     * @param {(string|Phaser.Scene)} [key] - The Scene to set the visible state for.
     *
     * @return {this} This Scene Plugin instance.
     */ setVisible: function(value, key) {
                    if (key === undefined) key = this.key;
                    var scene = this.manager.getScene(key);
                    if (scene) scene.sys.setVisible(value);
                    return this;
                },
                /**
     * Checks if the given Scene is sleeping or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isSleeping
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping, or `null` if no matching Scene was found.
     */ isSleeping: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isSleeping(key);
                },
                /**
     * Checks if the given Scene is running or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isActive
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running, or `null` if no matching Scene was found.
     */ isActive: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isActive(key);
                },
                /**
     * Checks if the given Scene is paused or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isPaused
     * @since 3.17.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused, or `null` if no matching Scene was found.
     */ isPaused: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isPaused(key);
                },
                /**
     * Checks if the given Scene is visible or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isVisible
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible, or `null` if no matching Scene was found.
     */ isVisible: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isVisible(key);
                },
                /**
     * Swaps the position of two scenes in the Scenes list.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#swapPosition
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
     * @param {(string|Phaser.Scene)} [keyB] - The second Scene to swap. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ swapPosition: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.swapPosition(keyA, keyB);
                    return this;
                },
                /**
     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly above Scene A.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#moveAbove
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved to be above.
     * @param {(string|Phaser.Scene)} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ moveAbove: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.moveAbove(keyA, keyB);
                    return this;
                },
                /**
     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly below Scene A.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#moveBelow
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved to be below.
     * @param {(string|Phaser.Scene)} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {this} This Scene Plugin instance.
     */ moveBelow: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.moveBelow(keyA, keyB);
                    return this;
                },
                /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.ScenePlugin#remove
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to be removed.
     *
     * @return {this} This Scene Plugin instance.
     */ remove: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.remove(key);
                    return this;
                },
                /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveUp
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ moveUp: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.moveUp(key);
                    return this;
                },
                /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveDown
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ moveDown: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.moveDown(key);
                    return this;
                },
                /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#bringToTop
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ bringToTop: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.bringToTop(key);
                    return this;
                },
                /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#sendToBack
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to move.
     *
     * @return {this} This Scene Plugin instance.
     */ sendToBack: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.sendToBack(key);
                    return this;
                },
                /**
     * Retrieve a Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#get
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to retrieve.
     *
     * @return {Phaser.Scene} The Scene.
     */ get: function(key) {
                    return this.manager.getScene(key);
                },
                /**
     * Retrieves the numeric index of a Scene in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#getIndex
     * @since 3.7.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to get the index of.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.getIndex(key);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Scenes.ScenePlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(Events.SHUTDOWN, this.shutdown, this);
                    eventEmitter.off(Events.POST_UPDATE, this.step, this);
                    eventEmitter.off(Events.TRANSITION_OUT);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     *
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Scenes.ScenePlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(Events.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.settings = null;
                    this.manager = null;
                }
            });
            PluginCache.register("ScenePlugin", ScenePlugin, "scenePlugin");
            module1.exports = ScenePlugin;
        /***/ },
        /* 1415 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs
 */ module1.exports = {
                Events: __webpack_require__(438),
                List: __webpack_require__(110),
                Map: __webpack_require__(102),
                ProcessQueue: __webpack_require__(211),
                RTree: __webpack_require__(531),
                Set: __webpack_require__(149),
                Size: __webpack_require__(416)
            };
        /***/ },
        /* 1416 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var FilterMode = __webpack_require__(1417);
            /**
 * @namespace Phaser.Textures
 */ /**
 * Linear filter type.
 * 
 * @name Phaser.Textures.LINEAR
 * @type {number}
 * @const
 * @since 3.0.0
 */ /**
 * Nearest Neighbor filter type.
 * 
 * @name Phaser.Textures.NEAREST
 * @type {number}
 * @const
 * @since 3.0.0
 */ var Textures = {
                CanvasTexture: __webpack_require__(423),
                Events: __webpack_require__(106),
                FilterMode: FilterMode,
                Frame: __webpack_require__(109),
                Parsers: __webpack_require__(425),
                Texture: __webpack_require__(206),
                TextureManager: __webpack_require__(422),
                TextureSource: __webpack_require__(424)
            };
            Textures = Extend(false, Textures, FilterMode);
            module1.exports = Textures;
        /***/ },
        /* 1417 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Filter Types.
 *
 * @namespace Phaser.Textures.FilterMode
 * @memberof Phaser.Textures
 * @since 3.0.0
 */ var CONST = {
                /**
     * Linear filter type.
     * 
     * @name Phaser.Textures.FilterMode.LINEAR
     * @type {number}
     * @const
     * @since 3.0.0
     */ LINEAR: 0,
                /**
     * Nearest neighbor filter type.
     * 
     * @name Phaser.Textures.FilterMode.NEAREST
     * @type {number}
     * @const
     * @since 3.0.0
     */ NEAREST: 1
            };
            module1.exports = CONST;
        /***/ },
        /* 1418 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var CONST = __webpack_require__(1419);
            /**
 * @namespace Phaser.Tilemaps
 *
 * @borrows Phaser.Tilemaps.Orientation.ORTHOGONAL as ORTHOGONAL
 * @borrows Phaser.Tilemaps.Orientation.ISOMETRIC as ISOMETRIC
 * @borrows Phaser.Tilemaps.Orientation.STAGGERED as STAGGERED
 * @borrows Phaser.Tilemaps.Orientation.HEXAGONAL as HEXAGONAL
 */ var Tilemaps = {
                Components: __webpack_require__(251),
                Parsers: __webpack_require__(1452),
                Formats: __webpack_require__(40),
                ImageCollection: __webpack_require__(576),
                ParseToTilemap: __webpack_require__(262),
                Tile: __webpack_require__(85),
                Tilemap: __webpack_require__(580),
                TilemapCreator: __webpack_require__(1459),
                TilemapFactory: __webpack_require__(1460),
                Tileset: __webpack_require__(122),
                TilemapLayer: __webpack_require__(581),
                Orientation: __webpack_require__(29),
                LayerData: __webpack_require__(120),
                MapData: __webpack_require__(121),
                ObjectLayer: __webpack_require__(572)
            };
            Tilemaps = Extend(false, Tilemaps, CONST.ORIENTATION);
            module1.exports = Tilemaps;
        /***/ },
        /* 1419 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                ORIENTATION: __webpack_require__(29)
            };
            module1.exports = CONST;
        /***/ },
        /* 1420 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var CalculateFacesWithin = __webpack_require__(63);
            /**
 * Copies the tiles in the source rectangular area to a new destination (all specified in tile
 * coordinates) within the layer. This copies all tile properties & recalculates collision
 * information in the destination region.
 *
 * @function Phaser.Tilemaps.Components.Copy
 * @since 3.0.0
 *
 * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} width - The width of the area to copy, in tiles, not pixels.
 * @param {number} height - The height of the area to copy, in tiles, not pixels.
 * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
 * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Copy = function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (srcTileX < 0) srcTileX = 0;
                if (srcTileY < 0) srcTileY = 0;
                var srcTiles = GetTilesWithin(srcTileX, srcTileY, width, height, null, layer);
                var offsetX = destTileX - srcTileX;
                var offsetY = destTileY - srcTileY;
                for(var i = 0; i < srcTiles.length; i++){
                    var tileX = srcTiles[i].x + offsetX;
                    var tileY = srcTiles[i].y + offsetY;
                    if (tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height) {
                        if (layer.data[tileY][tileX]) layer.data[tileY][tileX].copy(srcTiles[i]);
                    }
                }
                if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                CalculateFacesWithin(destTileX - 1, destTileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = Copy;
        /***/ },
        /* 1421 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var ReplaceByIndex = __webpack_require__(542);
            /**
 * Creates a Sprite for every object matching the given tile indexes in the layer. You can
 * optionally specify if each tile will be replaced with a new tile after the Sprite has been
 * created. This is useful if you want to lay down special tiles in a level that are converted to
 * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
 *
 * @function Phaser.Tilemaps.Components.CreateFromTiles
 * @since 3.0.0
 *
 * @param {(number|number[])} indexes - The tile index, or array of indexes, to create Sprites from.
 * @param {(number|number[])} replacements - The tile index, or array of indexes, to change a converted tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a one-to-one mapping with the indexes array.
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} spriteConfig - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
 * @param {Phaser.Scene} scene - The Scene to create the Sprites within.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when determining the world XY
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
 */ var CreateFromTiles = function(indexes, replacements, spriteConfig, scene, camera, layer) {
                if (!spriteConfig) spriteConfig = {};
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                var tilemapLayer = layer.tilemapLayer;
                if (!scene) scene = tilemapLayer.scene;
                if (!camera) camera = scene.cameras.main;
                var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
                var sprites = [];
                var i;
                for(i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    if (indexes.indexOf(tile.index) !== -1) {
                        var point = tilemapLayer.tileToWorldXY(tile.x, tile.y, undefined, camera, layer);
                        spriteConfig.x = point.x;
                        spriteConfig.y = point.y;
                        sprites.push(scene.make.sprite(spriteConfig));
                    }
                }
                if (typeof replacements === "number") //  Assume 1 replacement for all types of tile given
                for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements, 0, 0, layer.width, layer.height, layer);
                else if (Array.isArray(replacements)) //  Assume 1 to 1 mapping with indexes array
                for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements[i], 0, 0, layer.width, layer.height, layer);
                return sprites;
            };
            module1.exports = CreateFromTiles;
        /***/ },
        /* 1422 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var CalculateFacesWithin = __webpack_require__(63);
            var SetTileCollision = __webpack_require__(72);
            /**
 * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
 * specified index. Tiles will be set to collide if the given index is a colliding index.
 * Collision information in the region will be recalculated.
 *
 * @function Phaser.Tilemaps.Components.Fill
 * @since 3.0.0
 *
 * @param {number} index - The tile index to fill the area with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The tile layer to use. If not given the current layer is used.
 */ var Fill = function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                var doesIndexCollide = layer.collideIndexes.indexOf(index) !== -1;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++){
                    tiles[i].index = index;
                    SetTileCollision(tiles[i], doesIndexCollide);
                }
                if (recalculateFaces) // Recalculate the faces within the area and neighboring tiles
                CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = Fill;
        /***/ },
        /* 1423 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
 * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FilterTiles
 * @since 3.0.0
 *
 * @param {function} callback - The callback. Each tile in the given area will be passed to this
 * callback as the first and only parameter. The callback should return true for tiles that pass the
 * filter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} The filtered array of Tiles.
 */ var FilterTiles = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                return tiles.filter(callback, context);
            };
            module1.exports = FilterTiles;
        /***/ },
        /* 1424 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches the entire map layer for the first tile matching the given index, then returns that Tile
 * object. If no match is found, it returns null. The search starts from the top-left tile and
 * continues horizontally until it hits the end of the row, then it drops down to the next column.
 * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
 * the top-left.
 *
 * @function Phaser.Tilemaps.Components.FindByIndex
 * @since 3.0.0
 *
 * @param {number} index - The tile index value to search for.
 * @param {number} skip - The number of times to skip a matching tile before returning.
 * @param {boolean} reverse - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} The first (or n skipped) tile with the matching index.
 */ var FindByIndex = function(findIndex, skip, reverse, layer) {
                if (skip === undefined) skip = 0;
                if (reverse === undefined) reverse = false;
                var count = 0;
                var tx;
                var ty;
                var tile;
                if (reverse) {
                    for(ty = layer.height - 1; ty >= 0; ty--)for(tx = layer.width - 1; tx >= 0; tx--){
                        tile = layer.data[ty][tx];
                        if (tile && tile.index === findIndex) {
                            if (count === skip) return tile;
                            else count += 1;
                        }
                    }
                } else {
                    for(ty = 0; ty < layer.height; ty++)for(tx = 0; tx < layer.width; tx++){
                        tile = layer.data[ty][tx];
                        if (tile && tile.index === findIndex) {
                            if (count === skip) return tile;
                            else count += 1;
                        }
                    }
                }
                return null;
            };
            module1.exports = FindByIndex;
        /***/ },
        /* 1425 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * @callback FindTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 *
 * @return {boolean} Return `true` if the callback should run, otherwise `false`.
 */ /**
 * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
 * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
 * true. Similar to Array.prototype.find in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FindTile
 * @since 3.0.0
 *
 * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} A Tile that matches the search, or null if no Tile found
 */ var FindTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                return tiles.find(callback, context) || null;
            };
            module1.exports = FindTile;
        /***/ },
        /* 1426 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * @callback EachTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 */ /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * callback. Similar to Array.prototype.forEach in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.ForEachTile
 * @since 3.0.0
 *
 * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ForEachTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                tiles.forEach(callback, context);
            };
            module1.exports = ForEachTile;
        /***/ },
        /* 1427 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var CullTiles = __webpack_require__(544);
            var HexagonalCullTiles = __webpack_require__(545);
            var IsometricCullTiles = __webpack_require__(547);
            var NOOP = __webpack_require__(1);
            var StaggeredCullTiles = __webpack_require__(548);
            /**
 * Gets the correct function to use to cull tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetCullTilesFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to cull tiles for the given map type.
 */ var GetCullTilesFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return CullTiles;
                else if (orientation === CONST.HEXAGONAL) return HexagonalCullTiles;
                else if (orientation === CONST.STAGGERED) return StaggeredCullTiles;
                else if (orientation === CONST.ISOMETRIC) return IsometricCullTiles;
                else return NOOP;
            };
            module1.exports = GetCullTilesFunction;
        /***/ },
        /* 1428 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(158);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Gets a tile at the given world coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - X position to get the tile from (given in pixels)
 * @param {number} worldY - Y position to get the tile from (given in pixels)
 * @param {boolean} nonNull - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAtWorldXY = function(worldX, worldY, nonNull, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                return GetTileAt(point.x, point.y, nonNull, layer);
            };
            module1.exports = GetTileAtWorldXY;
        /***/ },
        /* 1429 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Geom = __webpack_require__(483);
            var GetTilesWithin = __webpack_require__(26);
            var Intersects = __webpack_require__(484);
            var NOOP = __webpack_require__(1);
            var Vector2 = __webpack_require__(3);
            var TriangleToRectangle = function(triangle, rect) {
                return Intersects.RectangleToTriangle(rect, triangle);
            };
            var point = new Vector2();
            var pointStart = new Vector2();
            var pointEnd = new Vector2();
            /**
 * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
 * Line, Rectangle or Triangle. The shape should be in world coordinates.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinShape
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinShape = function(shape, filteringOptions, camera, layer) {
                if (shape === undefined) return [];
                // intersectTest is a function with parameters: shape, rect
                var intersectTest = NOOP;
                if (shape instanceof Geom.Circle) intersectTest = Intersects.CircleToRectangle;
                else if (shape instanceof Geom.Rectangle) intersectTest = Intersects.RectangleToRectangle;
                else if (shape instanceof Geom.Triangle) intersectTest = TriangleToRectangle;
                else if (shape instanceof Geom.Line) intersectTest = Intersects.LineToRectangle;
                // Top left corner of the shapes's bounding box, rounded down to include partial tiles
                layer.tilemapLayer.worldToTileXY(shape.left, shape.top, true, pointStart, camera);
                var xStart = pointStart.x;
                var yStart = pointStart.y;
                // Bottom right corner of the shapes's bounding box, rounded up to include partial tiles
                layer.tilemapLayer.worldToTileXY(shape.right, shape.bottom, true, pointEnd, camera);
                var xEnd = Math.ceil(pointEnd.x);
                var yEnd = Math.ceil(pointEnd.y);
                // Tiles within bounding rectangle of shape. Bounds are forced to be at least 1 x 1 tile in size
                // to grab tiles for shapes that don't have a height or width (e.g. a horizontal line).
                var width = Math.max(xEnd - xStart, 1);
                var height = Math.max(yEnd - yStart, 1);
                var tiles = GetTilesWithin(xStart, yStart, width, height, filteringOptions, layer);
                var tileWidth = layer.tileWidth;
                var tileHeight = layer.tileHeight;
                if (layer.tilemapLayer) {
                    tileWidth *= layer.tilemapLayer.scaleX;
                    tileHeight *= layer.tilemapLayer.scaleY;
                }
                var results = [];
                var tileRect = new Geom.Rectangle(0, 0, tileWidth, tileHeight);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    layer.tilemapLayer.tileToWorldXY(tile.x, tile.y, point, camera);
                    tileRect.x = point.x;
                    tileRect.y = point.y;
                    if (intersectTest(shape, tileRect)) results.push(tile);
                }
                return results;
            };
            module1.exports = GetTilesWithinShape;
        /***/ },
        /* 1430 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var NOOP = __webpack_require__(1);
            var TileToWorldX = __webpack_require__(253);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldX;
                else return NOOP;
            };
            module1.exports = GetTileToWorldXFunction;
        /***/ },
        /* 1431 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalTileToWorldXY = __webpack_require__(550);
            var IsometricTileToWorldXY = __webpack_require__(551);
            var NOOP = __webpack_require__(1);
            var StaggeredTileToWorldXY = __webpack_require__(552);
            var TileToWorldXY = __webpack_require__(553);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldXY;
                else if (orientation === CONST.ISOMETRIC) return IsometricTileToWorldXY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalTileToWorldXY;
                else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldXY;
                else return NOOP;
            };
            module1.exports = GetTileToWorldXYFunction;
        /***/ },
        /* 1432 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalTileToWorldY = __webpack_require__(554);
            var NOOP = __webpack_require__(1);
            var StaggeredTileToWorldY = __webpack_require__(555);
            var TileToWorldY = __webpack_require__(254);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalTileToWorldY;
                else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldY;
                else return NOOP;
            };
            module1.exports = GetTileToWorldYFunction;
        /***/ },
        /* 1433 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var NOOP = __webpack_require__(1);
            var WorldToTileX = __webpack_require__(255);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileX;
                else return NOOP;
            };
            module1.exports = GetWorldToTileXFunction;
        /***/ },
        /* 1434 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalWorldToTileXY = __webpack_require__(556);
            var IsometricWorldToTileXY = __webpack_require__(557);
            var NOOP = __webpack_require__(1);
            var StaggeredWorldToTileXY = __webpack_require__(558);
            var WorldToTileXY = __webpack_require__(559);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileXY;
                else if (orientation === CONST.ISOMETRIC) return IsometricWorldToTileXY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalWorldToTileXY;
                else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileXY;
                else return NOOP;
            };
            module1.exports = GetWorldToTileXYFunction;
        /***/ },
        /* 1435 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalWorldToTileY = __webpack_require__(560);
            var NOOP = __webpack_require__(1);
            var StaggeredWorldToTileY = __webpack_require__(561);
            var WorldToTileY = __webpack_require__(256);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalWorldToTileY;
                else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileY;
                else return NOOP;
            };
            module1.exports = GetWorldToTileYFunction;
        /***/ },
        /* 1436 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasTileAt = __webpack_require__(562);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The X coordinate of the world position.
 * @param {number} worldY - The Y coordinate of the world position.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAtWorldXY = function(worldX, worldY, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                var tileX = point.x;
                var tileY = point.y;
                return HasTileAt(tileX, tileY, layer);
            };
            module1.exports = HasTileAtWorldXY;
        /***/ },
        /* 1437 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PutTileAt = __webpack_require__(257);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
 * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
 * specified location. If you pass in an index, only the index at the specified location will be
 * changed. Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAtWorldXY
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAtWorldXY = function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                return PutTileAt(tile, point.x, point.y, recalculateFaces, layer);
            };
            module1.exports = PutTileAtWorldXY;
        /***/ },
        /* 1438 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CalculateFacesWithin = __webpack_require__(63);
            var PutTileAt = __webpack_require__(257);
            /**
 * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
 * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
 * all attributes will be copied over to the specified location. If you pass in an index, only the
 * index at the specified location will be changed. Collision information will be recalculated
 * within the region tiles were changed.
 *
 * @function Phaser.Tilemaps.Components.PutTilesAt
 * @since 3.0.0
 *
 * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var PutTilesAt = function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!Array.isArray(tilesArray)) return null;
                // Force the input array to be a 2D array
                if (!Array.isArray(tilesArray[0])) tilesArray = [
                    tilesArray
                ];
                var height = tilesArray.length;
                var width = tilesArray[0].length;
                for(var ty = 0; ty < height; ty++)for(var tx = 0; tx < width; tx++){
                    var tile = tilesArray[ty][tx];
                    PutTileAt(tile, tileX + tx, tileY + ty, false, layer);
                }
                if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = PutTilesAt;
        /***/ },
        /* 1439 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var GetRandom = __webpack_require__(210);
            /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
 * those will be used for randomly assigning new tile indexes. If an array is not provided, the
 * indexes found within the region (excluding -1) will be used for randomly assigning new tile
 * indexes. This method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.Randomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {number[]} indexes - An array of indexes to randomly draw from during randomization.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Randomize = function(tileX, tileY, width, height, indexes, layer) {
                var i;
                var tiles = GetTilesWithin(tileX, tileY, width, height, {}, layer);
                // If no indices are given, then find all the unique indexes within the specified region
                if (!indexes) {
                    indexes = [];
                    for(i = 0; i < tiles.length; i++)if (indexes.indexOf(tiles[i].index) === -1) indexes.push(tiles[i].index);
                }
                for(i = 0; i < tiles.length; i++)tiles[i].index = GetRandom(indexes);
            };
            module1.exports = Randomize;
        /***/ },
        /* 1440 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RemoveTileAt = __webpack_require__(563);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Removes the tile at the given world coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAtWorldXY = function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                return RemoveTileAt(point.x, point.y, replaceWithNull, recalculateFaces, layer);
            };
            module1.exports = RemoveTileAtWorldXY;
        /***/ },
        /* 1441 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var Color = __webpack_require__(397);
            var defaultTileColor = new Color(105, 210, 231, 150);
            var defaultCollidingTileColor = new Color(243, 134, 48, 200);
            var defaultFaceColor = new Color(40, 39, 37, 150);
            /**
 * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
 * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
 * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
 * wherever you want on the screen.
 *
 * @function Phaser.Tilemaps.Components.RenderDebug
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
 * @param {Phaser.Types.Tilemaps.DebugStyleOptions} styleConfig - An object specifying the colors to use for the debug drawing.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var RenderDebug = function(graphics, styleConfig, layer) {
                if (styleConfig === undefined) styleConfig = {};
                // Default colors without needlessly creating Color objects
                var tileColor = styleConfig.tileColor !== undefined ? styleConfig.tileColor : defaultTileColor;
                var collidingTileColor = styleConfig.collidingTileColor !== undefined ? styleConfig.collidingTileColor : defaultCollidingTileColor;
                var faceColor = styleConfig.faceColor !== undefined ? styleConfig.faceColor : defaultFaceColor;
                var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
                graphics.translateCanvas(layer.tilemapLayer.x, layer.tilemapLayer.y);
                graphics.scaleCanvas(layer.tilemapLayer.scaleX, layer.tilemapLayer.scaleY);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    var tw = tile.width;
                    var th = tile.height;
                    var x = tile.pixelX;
                    var y = tile.pixelY;
                    var color = tile.collides ? collidingTileColor : tileColor;
                    if (color !== null) {
                        graphics.fillStyle(color.color, color.alpha / 255);
                        graphics.fillRect(x, y, tw, th);
                    }
                    // Inset the face line to prevent neighboring tile's lines from overlapping
                    x += 1;
                    y += 1;
                    tw -= 2;
                    th -= 2;
                    if (faceColor !== null) {
                        graphics.lineStyle(1, faceColor.color, faceColor.alpha / 255);
                        if (tile.faceTop) graphics.lineBetween(x, y, x + tw, y);
                        if (tile.faceRight) graphics.lineBetween(x + tw, y, x + tw, y + th);
                        if (tile.faceBottom) graphics.lineBetween(x, y + th, x + tw, y + th);
                        if (tile.faceLeft) graphics.lineBetween(x, y, x, y + th);
                    }
                }
            };
            module1.exports = RenderDebug;
        /***/ },
        /* 1442 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(63);
            var SetLayerCollisionIndex = __webpack_require__(160);
            /**
 * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
 * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
 * collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollision
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollision = function(indexes, collides, recalculateFaces, layer, updateLayer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (updateLayer === undefined) updateLayer = true;
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                // Update the array of colliding indexes
                for(var i = 0; i < indexes.length; i++)SetLayerCollisionIndex(indexes[i], collides, layer);
                // Update the tiles
                if (updateLayer) {
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile && indexes.indexOf(tile.index) !== -1) SetTileCollision(tile, collides);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollision;
        /***/ },
        /* 1443 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(63);
            var SetLayerCollisionIndex = __webpack_require__(160);
            /**
 * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
 * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
 * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
 * enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionBetween
 * @since 3.0.0
 *
 * @param {number} start - The first index of the tile to be set for collision.
 * @param {number} stop - The last index of the tile to be set for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollisionBetween = function(start, stop, collides, recalculateFaces, layer, updateLayer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (updateLayer === undefined) updateLayer = true;
                if (start > stop) return;
                //  Update the array of colliding indexes
                for(var index = start; index <= stop; index++)SetLayerCollisionIndex(index, collides, layer);
                //  Update the tiles
                if (updateLayer) {
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile) {
                            if (tile.index >= start && tile.index <= stop) SetTileCollision(tile, collides);
                        }
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionBetween;
        /***/ },
        /* 1444 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(63);
            var SetLayerCollisionIndex = __webpack_require__(160);
            /**
 * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
 * the given array. The `collides` parameter controls if collision will be enabled (true) or
 * disabled (false). Tile indexes not currently in the layer are not affected.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByExclusion
 * @since 3.0.0
 *
 * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByExclusion = function(indexes, collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                // Note: this only updates layer.collideIndexes for tile indexes found currently in the layer
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (tile && indexes.indexOf(tile.index) === -1) {
                        SetTileCollision(tile, collides);
                        SetLayerCollisionIndex(tile.index, collides, layer);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionByExclusion;
        /***/ },
        /* 1445 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(63);
            var HasValue = __webpack_require__(126);
            /**
 * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
 * that matches the given properties object, its collision flag will be set. The `collides`
 * parameter controls if collision will be enabled (true) or disabled (false). Passing in
 * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
 * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
 * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
 * "types" property that matches any of those values, its collision flag will be updated.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByProperty
 * @since 3.0.0
 *
 * @param {object} properties - An object with tile properties and corresponding values that should be checked.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByProperty = function(properties, collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (!tile) continue;
                    for(var property in properties){
                        if (!HasValue(tile.properties, property)) continue;
                        var values = properties[property];
                        if (!Array.isArray(values)) values = [
                            values
                        ];
                        for(var i = 0; i < values.length; i++)if (tile.properties[property] === values[i]) SetTileCollision(tile, collides);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionByProperty;
        /***/ },
        /* 1446 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(63);
            /**
 * Sets collision on the tiles within a layer by checking each tile's collision group data
 * (typically defined in Tiled within the tileset collision editor). If any objects are found within
 * a tile's collision group, the tile's colliding information will be set. The `collides` parameter
 * controls if collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionFromCollisionGroup
 * @since 3.0.0
 *
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionFromCollisionGroup = function(collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (!tile) continue;
                    var collisionGroup = tile.getCollisionGroup();
                    // It's possible in Tiled to have a collision group without any shapes, e.g. create a
                    // shape and then delete the shape.
                    if (collisionGroup && collisionGroup.objects && collisionGroup.objects.length > 0) SetTileCollision(tile, collides);
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionFromCollisionGroup;
        /***/ },
        /* 1447 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a global collision callback for the given tile index within the layer. This will affect all
 * tiles on this layer that have the same index. If a callback is already set for the tile index it
 * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
 * at a specific location on the map then see setTileLocationCallback.
 *
 * @function Phaser.Tilemaps.Components.SetTileIndexCallback
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileIndexCallback = function(indexes, callback, callbackContext, layer) {
                if (typeof indexes === "number") layer.callbacks[indexes] = callback !== null ? {
                    callback: callback,
                    callbackContext: callbackContext
                } : undefined;
                else for(var i = 0, len = indexes.length; i < len; i++)layer.callbacks[indexes[i]] = callback !== null ? {
                    callback: callback,
                    callbackContext: callbackContext
                } : undefined;
            };
            module1.exports = SetTileIndexCallback;
        /***/ },
        /* 1448 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
 * If a callback is already set for the tile index it will be replaced. Set the callback to null to
 * remove it.
 *
 * @function Phaser.Tilemaps.Components.SetTileLocationCallback
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileLocationCallback = function(tileX, tileY, width, height, callback, callbackContext, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)tiles[i].setCollisionCallback(callback, callbackContext);
            };
            module1.exports = SetTileLocationCallback;
        /***/ },
        /* 1449 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var ShuffleArray = __webpack_require__(131);
            /**
 * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
 * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
 * appear to have changed! This method only modifies tile indexes and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.Shuffle
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Shuffle = function(tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                var indexes = tiles.map(function(tile) {
                    return tile.index;
                });
                ShuffleArray(indexes);
                for(var i = 0; i < tiles.length; i++)tiles[i].index = indexes[i];
            };
            module1.exports = Shuffle;
        /***/ },
        /* 1450 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.SwapByIndex
 * @since 3.0.0
 *
 * @param {number} tileA - First tile index.
 * @param {number} tileB - Second tile index.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SwapByIndex = function(indexA, indexB, tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)if (tiles[i]) {
                    if (tiles[i].index === indexA) tiles[i].index = indexB;
                    else if (tiles[i].index === indexB) tiles[i].index = indexA;
                }
            };
            module1.exports = SwapByIndex;
        /***/ },
        /* 1451 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. New indexes are drawn from the given
 * weightedIndexes array. An example weighted array:
 *
 * [
 *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
 *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
 *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
 *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
 * ]
 *
 * The probability of any index being choose is (the index's weight) / (sum of all weights). This
 * method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.WeightedRandomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {object[]} weightedIndexes - An array of objects to randomly draw from during
 * randomization. They should be in the form: { index: 0, weight: 4 } or
 * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var WeightedRandomize = function(tileX, tileY, width, height, weightedIndexes, layer) {
                if (!weightedIndexes) return;
                var i;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                var weightTotal = 0;
                for(i = 0; i < weightedIndexes.length; i++)weightTotal += weightedIndexes[i].weight;
                if (weightTotal <= 0) return;
                for(i = 0; i < tiles.length; i++){
                    var rand = Math.random() * weightTotal;
                    var sum = 0;
                    var randomIndex = -1;
                    for(var j = 0; j < weightedIndexes.length; j++){
                        sum += weightedIndexes[j].weight;
                        if (rand <= sum) {
                            var chosen = weightedIndexes[j].index;
                            randomIndex = Array.isArray(chosen) ? chosen[Math.floor(Math.random() * chosen.length)] : chosen;
                            break;
                        }
                    }
                    tiles[i].index = randomIndex;
                }
            };
            module1.exports = WeightedRandomize;
        /***/ },
        /* 1452 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers
 */ module1.exports = {
                FromOrientationString: __webpack_require__(258),
                Parse: __webpack_require__(564),
                Parse2DArray: __webpack_require__(259),
                ParseCSV: __webpack_require__(565),
                Impact: __webpack_require__(1454),
                Tiled: __webpack_require__(1455)
            };
        /***/ },
        /* 1453 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses out the Wangset information from Tiled 1.1.5+ map data, if present.
 *
 * Since a given tile can be in more than one wangset, the resulting properties
 * are nested. `tile.data.wangid[someWangsetName]` will return the array-based wang id in
 * this implementation.
 *
 * Note that we're not guaranteed that there will be any 'normal' tiles if the only
 * thing in the tilset are wangtile definitions, so this has to be parsed separately.
 *
 * See https://doc.mapeditor.org/en/latest/manual/using-wang-tiles/ for more information.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseWangsets
 * @since 3.53.0
 *
 * @param {Array.<object>} wangsets - The array of wangset objects (parsed from JSON)
 * @param {object} datas - The field into which to put wangset data from Tiled.
 *
 * @return {object} An object containing the tileset and image collection data.
 */ var ParseWangsets = function(wangsets, datas) {
                for(var w = 0; w < wangsets.length; w++){
                    var wangset = wangsets[w];
                    var identifier = w;
                    if (wangset.name && wangset.name !== "") identifier = wangset.name;
                    if (Array.isArray(wangset.wangtiles) && wangset.wangtiles.length > 0) {
                        var edgeColors = {};
                        var cornerColors = {};
                        var c;
                        var color;
                        var colorIndex;
                        // Tiled before v2020.09.09
                        if (Array.isArray(wangset.edgecolors)) for(c = 0; c < wangset.edgecolors.length; c++){
                            colorIndex = 1 + c;
                            color = wangset.edgecolors[c];
                            if (color.name !== "") edgeColors[colorIndex] = color.name;
                        }
                        if (Array.isArray(wangset.cornercolors)) for(c = 0; c < wangset.cornercolors.length; c++){
                            colorIndex = 1 + c;
                            color = wangset.cornercolors[c];
                            if (color.name !== "") cornerColors[colorIndex] = color.name;
                        }
                        // Tiled after v2020.09.09
                        if (Array.isArray(wangset.colors)) for(c = 0; c < wangset.colors.length; c++){
                            color = wangset.colors[c];
                            colorIndex = 1 + c;
                            if (color.name !== "") edgeColors[colorIndex] = cornerColors[colorIndex] = color.name;
                        }
                        // The wangid layout is north, northeast, east, southeast, etc.
                        var idLayout = [
                            edgeColors,
                            cornerColors,
                            edgeColors,
                            cornerColors,
                            edgeColors,
                            cornerColors,
                            edgeColors,
                            cornerColors
                        ];
                        for(var t = 0; t < wangset.wangtiles.length; t++){
                            var wangtile = wangset.wangtiles[t];
                            var obj = datas[wangtile.tileid] || (datas[wangtile.tileid] = {});
                            obj = obj.wangid || (obj.wangid = {});
                            var wangid = [];
                            for(var i = 0; i < Math.min(idLayout.length, wangtile.wangid.length); i++){
                                color = wangtile.wangid[i];
                                if (color === 0) {
                                    wangid.push(undefined);
                                    continue;
                                }
                                var renamed = idLayout[i][color];
                                if (renamed !== undefined) {
                                    wangid.push(renamed);
                                    continue;
                                }
                                wangid.push(color);
                            }
                            obj[identifier] = wangid;
                        }
                    }
                }
            };
            module1.exports = ParseWangsets;
        /***/ },
        /* 1454 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Impact
 */ module1.exports = {
                ParseTileLayers: __webpack_require__(578),
                ParseTilesets: __webpack_require__(579),
                ParseWeltmeister: __webpack_require__(577)
            };
        /***/ },
        /* 1455 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Tiled
 */ module1.exports = {
                AssignTileProperties: __webpack_require__(567),
                Base64Decode: __webpack_require__(574),
                BuildTilesetIndex: __webpack_require__(568),
                CreateGroupLayer: __webpack_require__(161),
                ParseGID: __webpack_require__(261),
                ParseImageLayers: __webpack_require__(569),
                ParseJSONTiled: __webpack_require__(566),
                ParseObject: __webpack_require__(260),
                ParseObjectLayers: __webpack_require__(570),
                ParseTileLayers: __webpack_require__(573),
                ParseTilesets: __webpack_require__(575)
            };
        /***/ },
        /* 1456 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1457);
            renderCanvas = __webpack_require__(1458);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1457 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var TilemapLayerWebGLRenderer = function(renderer, src, camera) {
                var renderTiles = src.cull(camera);
                var tileCount = renderTiles.length;
                var alpha = camera.alpha * src.alpha;
                if (tileCount === 0 || alpha <= 0) return;
                var gidMap = src.gidMap;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var getTint = Utils.getTintAppendFloatAlpha;
                var scrollFactorX = src.scrollFactorX;
                var scrollFactorY = src.scrollFactorY;
                var x = src.x;
                var y = src.y;
                var sx = src.scaleX;
                var sy = src.scaleY;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < tileCount; i++){
                    var tile = renderTiles[i];
                    var tileset = gidMap[tile.index];
                    if (!tileset) continue;
                    var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                    if (tileTexCoords === null) continue;
                    var texture = tileset.glTexture;
                    var textureUnit = pipeline.setTexture2D(texture, src);
                    var frameWidth = tileset.tileWidth;
                    var frameHeight = tileset.tileHeight;
                    var frameX = tileTexCoords.x;
                    var frameY = tileTexCoords.y;
                    var tw = tileset.tileWidth * 0.5;
                    var th = tileset.tileHeight * 0.5;
                    var tint = getTint(tile.tint, alpha * tile.alpha);
                    pipeline.batchTexture(src, texture, texture.width, texture.height, x + (tw + tile.pixelX) * sx, y + (th + tile.pixelY) * sy, tile.width, tile.height, sx, sy, tile.rotation, tile.flipX, tile.flipY, scrollFactorX, scrollFactorY, tw, th, frameX, frameY, frameWidth, frameHeight, tint, tint, tint, tint, false, 0, 0, camera, null, true, textureUnit);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TilemapLayerWebGLRenderer;
        /***/ },
        /* 1458 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TilemapLayerCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var renderTiles = src.cull(camera);
                var tileCount = renderTiles.length;
                var alpha = camera.alpha * src.alpha;
                if (tileCount === 0 || alpha <= 0) return;
                var camMatrix = tempMatrix1;
                var layerMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                layerMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                camMatrix.copyFrom(camera.matrix);
                var ctx = renderer.currentContext;
                var gidMap = src.gidMap;
                ctx.save();
                if (parentMatrix) {
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    layerMatrix.e = src.x;
                    layerMatrix.f = src.y;
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(layerMatrix, calcMatrix);
                    calcMatrix.copyToContext(ctx);
                } else {
                    layerMatrix.e -= camera.scrollX * src.scrollFactorX;
                    layerMatrix.f -= camera.scrollY * src.scrollFactorY;
                    layerMatrix.copyToContext(ctx);
                }
                if (!renderer.antialias || src.scaleX > 1 || src.scaleY > 1) ctx.imageSmoothingEnabled = false;
                for(var i = 0; i < tileCount; i++){
                    var tile = renderTiles[i];
                    var tileset = gidMap[tile.index];
                    if (!tileset) continue;
                    var image = tileset.image.getSourceImage();
                    var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                    if (tileTexCoords === null) continue;
                    var tileWidth = tileset.tileWidth;
                    var tileHeight = tileset.tileHeight;
                    var halfWidth = tileWidth * 0.5;
                    var halfHeight = tileHeight * 0.5;
                    ctx.save();
                    ctx.translate(tile.pixelX + halfWidth, tile.pixelY + halfHeight);
                    if (tile.rotation !== 0) ctx.rotate(tile.rotation);
                    if (tile.flipX || tile.flipY) ctx.scale(tile.flipX ? -1 : 1, tile.flipY ? -1 : 1);
                    ctx.globalAlpha = alpha * tile.alpha;
                    ctx.drawImage(image, tileTexCoords.x, tileTexCoords.y, tileWidth, tileHeight, -halfWidth, -halfHeight, tileWidth, tileHeight);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = TilemapLayerCanvasRenderer;
        /***/ },
        /* 1459 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var ParseToTilemap = __webpack_require__(262);
            /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tilemap
 * @since 3.0.0
 * 
 * @param {Phaser.Types.Tilemaps.TilemapConfig} [config] - The config options for the Tilemap.
 * 
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectCreator.register("tilemap", function(config) {
                // Defaults are applied in ParseToTilemap
                var c = config !== undefined ? config : {};
                return ParseToTilemap(this.scene, c.key, c.tileWidth, c.tileHeight, c.width, c.height, c.data, c.insertNull);
            });
        /***/ },
        /* 1460 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var ParseToTilemap = __webpack_require__(262);
            /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tilemap
 * @since 3.0.0
 *
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [tileHeight=32] - The height of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [width=10] - The width of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number} [height=10] - The height of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes. Pass in `null` for no data.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 * 
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectFactory.register("tilemap", function(key, tileWidth, tileHeight, width, height, data, insertNull) {
                // Allow users to specify null to indicate that they want the default value, since null is
                // shorter & more legible than undefined. Convert null to undefined to allow ParseToTilemap
                // defaults to take effect.
                if (key === null) key = undefined;
                if (tileWidth === null) tileWidth = undefined;
                if (tileHeight === null) tileHeight = undefined;
                if (width === null) width = undefined;
                if (height === null) height = undefined;
                return ParseToTilemap(this.scene, key, tileWidth, tileHeight, width, height, data, insertNull);
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1461 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Time
 */ module1.exports = {
                Clock: __webpack_require__(1462),
                TimerEvent: __webpack_require__(582)
            };
        /***/ },
        /* 1462 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            var TimerEvent = __webpack_require__(582);
            var Remove = __webpack_require__(93);
            /**
 * @classdesc
 * The Clock is a Scene plugin which creates and updates Timer Events for its Scene.
 *
 * @class Clock
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Clock.
 */ var Clock = new Class({
                initialize: function Clock(scene) {
                    /**
         * The Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene Systems object of the Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The current time of the Clock, in milliseconds.
         *
         * If accessed externally, this is equivalent to the `time` parameter normally passed to a Scene's `update` method.
         *
         * @name Phaser.Time.Clock#now
         * @type {number}
         * @since 3.0.0
         */ this.now = 0;
                    /**
         * The scale of the Clock's time delta.
         *
         * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Clock and anything which uses it, such as its Timer Events. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing the Clock.
         *
         * @name Phaser.Time.Clock#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Whether the Clock is paused (`true`) or active (`false`).
         *
         * When paused, the Clock will not update any of its Timer Events, thus freezing time.
         *
         * @name Phaser.Time.Clock#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * An array of all Timer Events whose delays haven't expired - these are actively updating Timer Events.
         *
         * @name Phaser.Time.Clock#_active
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                    /**
         * An array of all Timer Events which will be added to the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingInsertion
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                    /**
         * An array of all Timer Events which will be removed from the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingRemoval
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    //  Sync with the TimeStep
                    this.now = this.systems.game.loop.time;
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Creates a Timer Event and adds it to this Clock at the start of the next frame.
     *
     * You can pass in either a `TimerEventConfig` object, from with a new `TimerEvent` will
     * be created, or you can pass in a `TimerEvent` instance.
     *
     * If passing an instance please make sure that this instance hasn't been used before.
     * If it has ever entered a 'completed' state then it will no longer be suitable to
     * run again.
     *
     * Also, if the `TimerEvent` instance is being used by _another_ Clock (in another Scene)
     * it will still be updated by that Clock as well, so be careful when using this feature.
     *
     * @method Phaser.Time.Clock#addEvent
     * @since 3.0.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Types.Time.TimerEventConfig)} config - The configuration for the Timer Event, or an existing Timer Event object.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created, or passed in.
     */ addEvent: function(config) {
                    var event;
                    if (config instanceof TimerEvent) {
                        event = config;
                        this.removeEvent(event);
                        event.elapsed = event.startAt;
                        event.hasDispatched = false;
                        event.repeatCount = event.repeat === -1 || event.loop ? 999999999999 : event.repeat;
                    } else event = new TimerEvent(config);
                    this._pendingInsertion.push(event);
                    return event;
                },
                /**
     * Creates a Timer Event and adds it to the Clock at the start of the frame.
     *
     * This is a shortcut for {@link #addEvent} which can be shorter and is compatible with the syntax of the GreenSock Animation Platform (GSAP).
     *
     * @method Phaser.Time.Clock#delayedCall
     * @since 3.0.0
     *
     * @param {number} delay - The delay of the function call, in milliseconds.
     * @param {function} callback - The function to call after the delay expires.
     * @param {Array.<*>} [args] - The arguments to call the function with.
     * @param {*} [callbackScope] - The scope (`this` object) to call the function with.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created.
     */ delayedCall: function(delay, callback, args, callbackScope) {
                    return this.addEvent({
                        delay: delay,
                        callback: callback,
                        args: args,
                        callbackScope: callbackScope
                    });
                },
                /**
     * Clears and recreates the array of pending Timer Events.
     *
     * @method Phaser.Time.Clock#clearPendingEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ clearPendingEvents: function() {
                    this._pendingInsertion = [];
                    return this;
                },
                /**
     * Removes the given Timer Event, or an array of Timer Events, from this Clock.
     *
     * The events are removed from all internal lists (active, pending and removal),
     * freeing the event up to be re-used.
     *
     * @method Phaser.Time.Clock#removeEvent
     * @since 3.50.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Time.TimerEvent[])} events - The Timer Event, or an array of Timer Events, to remove from this Clock.
     *
     * @return {this} - This Clock instance.
     */ removeEvent: function(events) {
                    if (!Array.isArray(events)) events = [
                        events
                    ];
                    for(var i = 0; i < events.length; i++){
                        var event = events[i];
                        Remove(this._pendingRemoval, event);
                        Remove(this._pendingInsertion, event);
                        Remove(this._active, event);
                    }
                    return this;
                },
                /**
     * Schedules all active Timer Events for removal at the start of the frame.
     *
     * @method Phaser.Time.Clock#removeAllEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ removeAllEvents: function() {
                    this._pendingRemoval = this._pendingRemoval.concat(this._active);
                    return this;
                },
                /**
     * Updates the arrays of active and pending Timer Events. Called at the start of the frame.
     *
     * @method Phaser.Time.Clock#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ preUpdate: function() {
                    var toRemove = this._pendingRemoval.length;
                    var toInsert = this._pendingInsertion.length;
                    if (toRemove === 0 && toInsert === 0) //  Quick bail
                    return;
                    var i;
                    var event;
                    //  Delete old events
                    for(i = 0; i < toRemove; i++){
                        event = this._pendingRemoval[i];
                        var index = this._active.indexOf(event);
                        if (index > -1) this._active.splice(index, 1);
                        //  Pool them?
                        event.destroy();
                    }
                    for(i = 0; i < toInsert; i++){
                        event = this._pendingInsertion[i];
                        this._active.push(event);
                    }
                    //  Clear the lists
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                },
                /**
     * Updates the Clock's internal time and all of its Timer Events.
     *
     * @method Phaser.Time.Clock#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time, delta) {
                    this.now = time;
                    if (this.paused) return;
                    delta *= this.timeScale;
                    for(var i = 0; i < this._active.length; i++){
                        var event = this._active[i];
                        if (event.paused) continue;
                        //  Use delta time to increase elapsed.
                        //  Avoids needing to adjust for pause / resume.
                        //  Automatically smoothed by TimeStep class.
                        //  In testing accurate to +- 1ms!
                        event.elapsed += delta * event.timeScale;
                        if (event.elapsed >= event.delay) {
                            var remainder = event.elapsed - event.delay;
                            //  Limit it, in case it's checked in the callback
                            event.elapsed = event.delay;
                            //  Process the event
                            if (!event.hasDispatched && event.callback) {
                                event.hasDispatched = true;
                                event.callback.apply(event.callbackScope, event.args);
                            }
                            if (event.repeatCount > 0) {
                                event.repeatCount--;
                                event.elapsed = remainder;
                                event.hasDispatched = false;
                            } else this._pendingRemoval.push(event);
                        }
                    }
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Time.Clock#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var i;
                    for(i = 0; i < this._pendingInsertion.length; i++)this._pendingInsertion[i].destroy();
                    for(i = 0; i < this._active.length; i++)this._active[i].destroy();
                    for(i = 0; i < this._pendingRemoval.length; i++)this._pendingRemoval[i].destroy();
                    this._active.length = 0;
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Time.Clock#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("Clock", Clock, "time");
            module1.exports = Clock;
        /***/ },
        /* 1463 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(100);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Tweens
 */ var Tweens = {
                Builders: __webpack_require__(1464),
                Events: __webpack_require__(267),
                TweenManager: __webpack_require__(1480),
                Tween: __webpack_require__(266),
                TweenData: __webpack_require__(268),
                Timeline: __webpack_require__(588)
            };
            //   Merge in the consts
            Tweens = Extend(false, Tweens, CONST);
            module1.exports = Tweens;
        /***/ },
        /* 1464 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Builders
 */ module1.exports = {
                GetBoolean: __webpack_require__(99),
                GetEaseFunction: __webpack_require__(80),
                GetNewValue: __webpack_require__(162),
                GetProps: __webpack_require__(583),
                GetTargets: __webpack_require__(263),
                GetTweens: __webpack_require__(584),
                GetValueOp: __webpack_require__(264),
                NumberTweenBuilder: __webpack_require__(585),
                StaggerBuilder: __webpack_require__(586),
                TimelineBuilder: __webpack_require__(587),
                TweenBuilder: __webpack_require__(163)
            };
        /***/ },
        /* 1465 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  RESERVED properties that a Tween config object uses
            //  completeDelay: The time the tween will wait before the onComplete event is dispatched once it has completed
            //  delay: The time the tween will wait before it first starts
            //  duration: The duration of the tween
            //  ease: The ease function used by the tween
            //  easeParams: The parameters to go with the ease function (if any)
            //  flipX: flip X the GameObject on tween end
            //  flipY: flip Y the GameObject on tween end//  hold: The time the tween will pause before running a yoyo
            //  hold: The time the tween will pause before running a yoyo
            //  loop: The time the tween will pause before starting either a yoyo or returning to the start for a repeat
            //  loopDelay:
            //  offset: Used when the Tween is part of a Timeline
            //  paused: Does the tween start in a paused state, or playing?
            //  props: The properties being tweened by the tween
            //  repeat: The number of times the tween will repeat itself (a value of 1 means the tween will play twice, as it repeated once)
            //  repeatDelay: The time the tween will pause for before starting a repeat. The tween holds in the start state.
            //  targets: The targets the tween is updating.
            //  useFrames: Use frames or milliseconds?
            //  yoyo: boolean - Does the tween reverse itself (yoyo) when it reaches the end?
            module1.exports = [
                "callbackScope",
                "completeDelay",
                "delay",
                "duration",
                "ease",
                "easeParams",
                "flipX",
                "flipY",
                "hold",
                "loop",
                "loopDelay",
                "offset",
                "onActive",
                "onActiveParams",
                "onActiveScope",
                "onComplete",
                "onCompleteParams",
                "onCompleteScope",
                "onLoop",
                "onLoopParams",
                "onLoopScope",
                "onRepeat",
                "onRepeatParams",
                "onRepeatScope",
                "onStart",
                "onStartParams",
                "onStartScope",
                "onStop",
                "onStopParams",
                "onStopScope",
                "onUpdate",
                "onUpdateParams",
                "onUpdateScope",
                "onYoyo",
                "onYoyoParams",
                "onYoyoScope",
                "paused",
                "props",
                "repeat",
                "repeatDelay",
                "targets",
                "useFrames",
                "yoyo"
            ];
        /***/ },
        /* 1466 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Complete Event.
 * 
 * This event is dispatched by a Tween Timeline when it completes playback.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('complete', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_COMPLETE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "complete";
        /***/ },
        /* 1467 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Loop Event.
 * 
 * This event is dispatched by a Tween Timeline every time it loops.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     loop: 4,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('loop', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_LOOP
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "loop";
        /***/ },
        /* 1468 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Pause Event.
 * 
 * This event is dispatched by a Tween Timeline when it is paused.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('pause', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('pause', listener);
 * // At some point later ...
 * timeline.pause();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_PAUSE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "pause";
        /***/ },
        /* 1469 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Resume Event.
 * 
 * This event is dispatched by a Tween Timeline when it is resumed from a paused state.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('resume', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('resume', listener);
 * // At some point later ...
 * timeline.resume();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_RESUME
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "resume";
        /***/ },
        /* 1470 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Start Event.
 * 
 * This event is dispatched by a Tween Timeline when it starts.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('start', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('start', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_START
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "start";
        /***/ },
        /* 1471 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Update Event.
 * 
 * This event is dispatched by a Tween Timeline every time it updates, which can happen a lot of times per second,
 * so be careful about listening to this event unless you absolutely require it.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('update', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('update', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = "update";
        /***/ },
        /* 1472 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Active Event.
 * 
 * This event is dispatched by a Tween when it becomes active within the Tween Manager.
 * 
 * An 'active' Tween is one that is now progressing, although it may not yet be updating
 * any target properties, due to settings such as `delay`. If you need an event for when
 * the Tween starts actually updating its first property, see `TWEEN_START`.
 * 
 * Listen to it from a Tween instance using `Tween.on('active', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('active', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_ACTIVE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = "active";
        /***/ },
        /* 1473 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Complete Event.
 * 
 * This event is dispatched by a Tween when it completes playback entirely, factoring in repeats and loops.
 * 
 * If the Tween has been set to loop or repeat infinitely, this event will not be dispatched
 * unless the `Tween.stop` method is called.
 * 
 * If a Tween has a `completeDelay` set, this event will fire after that delay expires.
 * 
 * Listen to it from a Tween instance using `Tween.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('complete', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_COMPLETE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = "complete";
        /***/ },
        /* 1474 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Loop Event.
 * 
 * This event is dispatched by a Tween when it loops.
 * 
 * This event will only be dispatched if the Tween has a loop count set.
 * 
 * If a Tween has a `loopDelay` set, this event will fire after that delay expires.
 * 
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 * 
 * Listen to it from a Tween instance using `Tween.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     loop: 6
 * });
 * tween.on('loop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_LOOP
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = "loop";
        /***/ },
        /* 1475 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Repeat Event.
 * 
 * This event is dispatched by a Tween when one of the properties it is tweening repeats.
 * 
 * This event will only be dispatched if the Tween has a property with a repeat count set.
 * 
 * If a Tween has a `repeatDelay` set, this event will fire after that delay expires.
 * 
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 * 
 * Listen to it from a Tween instance using `Tween.on('repeat', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     repeat: 4
 * });
 * tween.on('repeat', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_REPEAT
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The key of the property that just repeated.
 * @param {any} target - The target that the property just repeated on.
 */ module1.exports = "repeat";
        /***/ },
        /* 1476 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Start Event.
 * 
 * This event is dispatched by a Tween when it starts tweening its first property.
 * 
 * A Tween will only emit this event once, as it can only start once.
 * 
 * If a Tween has a `delay` set, this event will fire after that delay expires.
 * 
 * Listen to it from a Tween instance using `Tween.on('start', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('start', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_START
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = "start";
        /***/ },
        /* 1477 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Stop Event.
 *
 * This event is dispatched by a Tween when it is stopped.
 *
 * Listen to it from a Tween instance using `Tween.on('stop', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('stop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_STOP
 * @since 3.24.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = "stop";
        /***/ },
        /* 1478 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Update Event.
 * 
 * This event is dispatched by a Tween every time it updates _any_ of the properties it is tweening.
 * 
 * A Tween that is changing 3 properties of a target will emit this event 3 times per change, once per property.
 * 
 * **Note:** This is a very high frequency event and may be dispatched multiple times, every single frame.
 * 
 * Listen to it from a Tween instance using `Tween.on('update', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 * });
 * tween.on('update', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_UPDATE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property that was updated, i.e. `x` or `scale`.
 * @param {any} target - The target object that was updated. Usually a Game Object, but can be of any type.
 * @param {number} current - The current value of the property that was tweened.
 * @param {number} previous - The previous value of the property that was tweened, prior to this update.
 */ module1.exports = "update";
        /***/ },
        /* 1479 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Yoyo Event.
 * 
 * This event is dispatched by a Tween whenever a property it is tweening yoyos.
 * 
 * This event will only be dispatched if the Tween has a property with `yoyo` set.
 * 
 * If the Tween has a `hold` value, this event is dispatched when the hold expires.
 * 
 * This event is dispatched for every property, and for every target, that yoyos.
 * For example, if a Tween was updating 2 properties and had 10 targets, this event
 * would be dispatched 20 times (twice per target). So be careful how you use it!
 * 
 * Listen to it from a Tween instance using `Tween.on('yoyo', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     yoyo: true
 * });
 * tween.on('yoyo', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_YOYO
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property that yoyo'd, i.e. `x` or `scale`.
 * @param {any} target - The target object that was yoyo'd. Usually a Game Object, but can be of any type.
 */ module1.exports = "yoyo";
        /***/ },
        /* 1480 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(93);
            var Class = __webpack_require__(0);
            var NumberTweenBuilder = __webpack_require__(585);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(20);
            var StaggerBuilder = __webpack_require__(586);
            var TimelineBuilder = __webpack_require__(587);
            var TWEEN_CONST = __webpack_require__(100);
            var TweenBuilder = __webpack_require__(163);
            /**
 * @classdesc
 * The Tween Manager is a default Scene Plugin which controls and updates Tweens and Timelines.
 *
 * @class TweenManager
 * @memberof Phaser.Tweens
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Tween Manager.
 */ var TweenManager = new Class({
                initialize: function TweenManager(scene) {
                    /**
         * The Scene which owns this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Systems object of the Scene which owns this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The time scale of the Tween Manager.
         *
         * This value scales the time delta between two frames, thus influencing the speed of time for all Tweens owned by this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * An array of Tweens and Timelines which will be added to the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_add
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._add = [];
                    /**
         * An array of Tweens and Timelines pending to be later added to the Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#_pending
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * An array of Tweens and Timelines which are still incomplete and are actively processed by the Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#_active
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._active = [];
                    /**
         * An array of Tweens and Timelines which will be removed from the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_destroy
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._destroy = [];
                    /**
         * The number of Tweens and Timelines which need to be processed by the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._toProcess = 0;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.timeScale = 1;
                },
                /**
     * Create a Tween Timeline and return it, but do NOT add it to the active or pending Tween lists.
     *
     * @method Phaser.Tweens.TweenManager#createTimeline
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TimelineBuilderConfig} [config] - The configuration object for the Timeline and its Tweens.
     *
     * @return {Phaser.Tweens.Timeline} The created Timeline object.
     */ createTimeline: function(config) {
                    return TimelineBuilder(this, config);
                },
                /**
     * Create a Tween Timeline and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#timeline
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TimelineBuilderConfig} [config] - The configuration object for the Timeline and its Tweens.
     *
     * @return {Phaser.Tweens.Timeline} The created Timeline object.
     */ timeline: function(config) {
                    var timeline = TimelineBuilder(this, config);
                    if (!timeline.paused) {
                        this._add.push(timeline);
                        this._toProcess++;
                    }
                    return timeline;
                },
                /**
     * Create a Tween and return it, but do NOT add it to the active or pending Tween lists.
     *
     * @method Phaser.Tweens.TweenManager#create
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The configuration object for the Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Tween object.
     */ create: function(config) {
                    return TweenBuilder(this, config);
                },
                /**
     * Create a Tween and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#add
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The configuration object for the Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Tween.
     */ add: function(config) {
                    var tween = TweenBuilder(this, config);
                    this._add.push(tween);
                    this._toProcess++;
                    return tween;
                },
                /**
     * Add an existing tween into the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#existing
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to add.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ existing: function(tween) {
                    this._add.push(tween);
                    this._toProcess++;
                    return this;
                },
                /**
     * Create a Number Tween and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#addCounter
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - The configuration object for the Number Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Number Tween.
     */ addCounter: function(config) {
                    var tween = NumberTweenBuilder(this, config);
                    this._add.push(tween);
                    this._toProcess++;
                    return tween;
                },
                /**
     * Creates a Stagger function to be used by a Tween property.
     *
     * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
     *
     * This is only worth using if the tween has multiple targets.
     *
     * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
     * over the duration specified:
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(100)
     * });
     * ```
     *
     * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
     * from the center out, using a cubic ease.
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
     * });
     * ```
     *
     * @method Phaser.Tweens.TweenManager#stagger
     * @since 3.19.0
     *
     * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
     * @param {Phaser.Types.Tweens.StaggerConfig} config - The configuration object for the Stagger function.
     *
     * @return {function} The stagger function.
     */ stagger: function(value, options) {
                    return StaggerBuilder(value, options);
                },
                /**
     * Updates the Tween Manager's internal lists at the start of the frame.
     *
     * This method will return immediately if no changes have been indicated.
     *
     * @method Phaser.Tweens.TweenManager#preUpdate
     * @since 3.0.0
     */ preUpdate: function() {
                    if (this._toProcess === 0) //  Quick bail
                    return;
                    var list = this._destroy;
                    var active = this._active;
                    var pending = this._pending;
                    var i;
                    var tween;
                    //  Clear the 'destroy' list
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        //  Remove from the 'active' array
                        var idx = active.indexOf(tween);
                        if (idx === -1) {
                            //  Not in the active array, is it in pending instead?
                            idx = pending.indexOf(tween);
                            if (idx > -1) {
                                tween.state = TWEEN_CONST.REMOVED;
                                pending.splice(idx, 1);
                            }
                        } else {
                            tween.state = TWEEN_CONST.REMOVED;
                            active.splice(idx, 1);
                        }
                    }
                    list.length = 0;
                    //  Process the addition list
                    //  This stops callbacks and out of sync events from populating the active array mid-way during the update
                    list = this._add;
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        if (tween.state === TWEEN_CONST.PENDING_ADD) {
                            //  Return true if the Tween should be started right away, otherwise false
                            if (tween.init()) {
                                tween.play();
                                this._active.push(tween);
                            } else this._pending.push(tween);
                        }
                    }
                    list.length = 0;
                    this._toProcess = 0;
                },
                /**
     * Updates all Tweens and Timelines of the Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#update
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time in milliseconds.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(timestamp, delta) {
                    //  Process active tweens
                    var list = this._active;
                    var tween;
                    //  Scale the delta
                    delta *= this.timeScale;
                    for(var i = 0; i < list.length; i++){
                        tween = list[i];
                        //  If Tween.update returns 'true' then it means it has completed,
                        //  so move it to the destroy list
                        if (tween.update(timestamp, delta)) {
                            this._destroy.push(tween);
                            this._toProcess++;
                        }
                    }
                },
                /**
     * Removes the given tween from the Tween Manager, regardless of its state (pending or active).
     *
     * @method Phaser.Tweens.TweenManager#remove
     * @since 3.17.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be removed.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ remove: function(tween) {
                    ArrayRemove(this._add, tween);
                    ArrayRemove(this._pending, tween);
                    ArrayRemove(this._active, tween);
                    ArrayRemove(this._destroy, tween);
                    tween.state = TWEEN_CONST.REMOVED;
                    return this;
                },
                /**
     * Checks if a Tween or Timeline is active and adds it to the Tween Manager at the start of the frame if it isn't.
     *
     * @method Phaser.Tweens.TweenManager#makeActive
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ makeActive: function(tween) {
                    if (this._add.indexOf(tween) !== -1 || this._active.indexOf(tween) !== -1) return this;
                    var idx = this._pending.indexOf(tween);
                    if (idx !== -1) this._pending.splice(idx, 1);
                    this._add.push(tween);
                    tween.state = TWEEN_CONST.PENDING_ADD;
                    this._toProcess++;
                    return this;
                },
                /**
     * Passes all Tweens to the given callback.
     *
     * @method Phaser.Tweens.TweenManager#each
     * @since 3.0.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [scope] - The scope (`this` object) to call the function with.
     * @param {...*} [args] - The arguments to pass into the function. Its first argument will always be the Tween currently being iterated.
     */ each: function(callback, scope) {
                    var args = [
                        null
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var texture in this.list){
                        args[0] = this.list[texture];
                        callback.apply(scope, args);
                    }
                },
                /**
     * Returns an array of all active Tweens and Timelines in the Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#getAllTweens
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing references to all active Tweens and Timelines.
     */ getAllTweens: function() {
                    var list = this._active;
                    var output = [];
                    for(var i = 0; i < list.length; i++)output.push(list[i]);
                    return output;
                },
                /**
     * Returns the scale of the time delta for all Tweens and Timelines owned by this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#getGlobalTimeScale
     * @since 3.0.0
     *
     * @return {number} The scale of the time delta, usually 1.
     */ getGlobalTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Returns an array of all Tweens or Timelines in the Tween Manager which affect the given target or array of targets.
     *
     * Only the currently active tweens are tested. A tween that has completed and is
     * awaiting removal will not be included in the results.
     *
     * If you wish to also search pending tweens, use the `includePending` flag.
     *
     * @method Phaser.Tweens.TweenManager#getTweensOf
     * @since 3.0.0
     *
     * @param {(object|array)} target - The target to look for. Provide an array to look for multiple targets.
     * @param {boolean} [includePending=false] - Also check for pending tweens, not just active ones?
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing all Tweens and Timelines which affect the given target(s).
     */ getTweensOf: function(target, includePending) {
                    if (includePending === undefined) includePending = false;
                    var list = this._active;
                    var tween;
                    var output = [];
                    var i;
                    var t;
                    if (!Array.isArray(target)) target = [
                        target
                    ];
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        for(t = 0; t < target.length; t++)if (tween.hasTarget(target[t])) output.push(tween);
                    }
                    if (includePending) {
                        list = this._pending;
                        for(i = 0; i < list.length; i++){
                            tween = list[i];
                            for(t = 0; t < target.length; t++)if (tween.hasTarget(target[t])) output.push(tween);
                        }
                    }
                    return output;
                },
                /**
     * Checks if the given object is being affected by a playing Tween.
     *
     * @method Phaser.Tweens.TweenManager#isTweening
     * @since 3.0.0
     *
     * @param {object} target - target Phaser.Tweens.Tween object
     *
     * @return {boolean} returns if target tween object is active or not
     */ isTweening: function(target) {
                    var list = this._active;
                    var tween;
                    for(var i = 0; i < list.length; i++){
                        tween = list[i];
                        if (tween.hasTarget(target) && tween.isPlaying()) return true;
                    }
                    return false;
                },
                /**
     * Stops all Tweens in this Tween Manager. They will be removed at the start of the frame.
     *
     * @method Phaser.Tweens.TweenManager#killAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ killAll: function() {
                    var tweens = this.getAllTweens();
                    for(var i = 0; i < tweens.length; i++)tweens[i].stop();
                    return this;
                },
                /**
     * Stops all Tweens which affect the given target or array of targets. The Tweens will be removed from the Tween Manager at the start of the frame.
     *
     * @see {@link #getTweensOf}
     *
     * @method Phaser.Tweens.TweenManager#killTweensOf
     * @since 3.0.0
     *
     * @param {(object|array)} target - The target to look for. Provide an array to look for multiple targets.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ killTweensOf: function(target) {
                    var tweens = this.getTweensOf(target);
                    for(var i = 0; i < tweens.length; i++)tweens[i].stop();
                    return this;
                },
                /**
     * Pauses all Tweens in this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#pauseAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ pauseAll: function() {
                    var list = this._active;
                    for(var i = 0; i < list.length; i++)list[i].pause();
                    return this;
                },
                /**
     * Resumes all Tweens in this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#resumeAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ resumeAll: function() {
                    var list = this._active;
                    for(var i = 0; i < list.length; i++)list[i].resume();
                    return this;
                },
                /**
     * Sets a new scale of the time delta for this Tween Manager.
     *
     * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Tween Manager and all Tweens it owns. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing all Tweens.
     *
     * @method Phaser.Tweens.TweenManager#setGlobalTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The new scale of the time delta, where 1 is the normal speed.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ setGlobalTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Tweens.TweenManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.killAll();
                    this._add = [];
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                    this._toProcess = 0;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Tweens.TweenManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("TweenManager", TweenManager, "tweens");
            module1.exports = TweenManager;
        /***/ },
        /* 1481 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils
 */ module1.exports = {
                Array: __webpack_require__(208),
                Base64: __webpack_require__(1482),
                Objects: __webpack_require__(1484),
                String: __webpack_require__(1488),
                NOOP: __webpack_require__(1)
            };
        /***/ },
        /* 1482 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Base64
 */ module1.exports = {
                ArrayBufferToBase64: __webpack_require__(1483),
                Base64ToArrayBuffer: __webpack_require__(433)
            };
        /***/ },
        /* 1483 */ /***/ function(module1, exports) {
            /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            /**
 * Converts an ArrayBuffer into a base64 string.
 * 
 * The resulting string can optionally be a data uri if the `mediaType` argument is provided.
 * 
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs for more details.
 *
 * @function Phaser.Utils.Base64.ArrayBufferToBase64
 * @since 3.18.0
 * 
 * @param {ArrayBuffer} arrayBuffer - The Array Buffer to encode.
 * @param {string} [mediaType] - An optional media type, i.e. `audio/ogg` or `image/jpeg`. If included the resulting string will be a data URI.
 * 
 * @return {string} The base64 encoded Array Buffer.
 */ var ArrayBufferToBase64 = function(arrayBuffer, mediaType) {
                var bytes = new Uint8Array(arrayBuffer);
                var len = bytes.length;
                var base64 = mediaType ? "data:" + mediaType + ";base64," : "";
                for(var i = 0; i < len; i += 3){
                    base64 += chars[bytes[i] >> 2];
                    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                    base64 += chars[bytes[i + 2] & 63];
                }
                if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
                else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
                return base64;
            };
            module1.exports = ArrayBufferToBase64;
        /***/ },
        /* 1484 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Objects
 */ module1.exports = {
                Clone: __webpack_require__(77),
                DeepCopy: __webpack_require__(175),
                Extend: __webpack_require__(17),
                GetAdvancedValue: __webpack_require__(13),
                GetFastValue: __webpack_require__(2),
                GetMinMaxValue: __webpack_require__(1485),
                GetValue: __webpack_require__(6),
                HasAll: __webpack_require__(1486),
                HasAny: __webpack_require__(455),
                HasValue: __webpack_require__(126),
                IsPlainObject: __webpack_require__(7),
                Merge: __webpack_require__(127),
                MergeRight: __webpack_require__(1487),
                Pick: __webpack_require__(571),
                SetValue: __webpack_require__(478)
            };
        /***/ },
        /* 1485 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            var Clamp = __webpack_require__(18);
            /**
 * Retrieves and clamps a numerical value from an object.
 *
 * @function Phaser.Utils.Objects.GetMinMaxValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`).
 * @param {number} min - The minimum value which can be returned.
 * @param {number} max - The maximum value which can be returned.
 * @param {number} defaultValue - The value to return if the property doesn't exist. It's also constrained to the given bounds.
 *
 * @return {number} The clamped value from the `source` object.
 */ var GetMinMaxValue = function(source, key, min, max, defaultValue) {
                if (defaultValue === undefined) defaultValue = min;
                var value = GetValue(source, key, defaultValue);
                return Clamp(value, min, max);
            };
            module1.exports = GetMinMaxValue;
        /***/ },
        /* 1486 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains all requested keys
 *
 * @function Phaser.Utils.Objects.HasAll
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to ensure the source object contains
 *
 * @return {boolean} true if the source object contains all keys, false otherwise.
 */ var HasAll = function(source, keys) {
                for(var i = 0; i < keys.length; i++){
                    if (!source.hasOwnProperty(keys[i])) return false;
                }
                return true;
            };
            module1.exports = HasAll;
        /***/ },
        /* 1487 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Creates a new Object using all values from obj1.
 * 
 * Then scans obj2. If a property is found in obj2 that *also* exists in obj1, the value from obj2 is used, otherwise the property is skipped.
 *
 * @function Phaser.Utils.Objects.MergeRight
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object to merge.
 * @param {object} obj2 - The second object to merge. Keys from this object which also exist in `obj1` will be copied to `obj1`.
 *
 * @return {object} The merged object. `obj1` and `obj2` are not modified.
 */ var MergeRight = function(obj1, obj2) {
                var clone = Clone(obj1);
                for(var key in obj2)if (clone.hasOwnProperty(key)) clone[key] = obj2[key];
                return clone;
            };
            module1.exports = MergeRight;
        /***/ },
        /* 1488 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.String
 */ module1.exports = {
                Format: __webpack_require__(1489),
                Pad: __webpack_require__(186),
                RemoveAt: __webpack_require__(1490),
                Reverse: __webpack_require__(1491),
                UppercaseFirst: __webpack_require__(205),
                UUID: __webpack_require__(222)
            };
        /***/ },
        /* 1489 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and replaces instances of markers with values in the given array.
 * The markers take the form of `%1`, `%2`, etc. I.e.:
 *
 * `Format("The %1 is worth %2 gold", [ 'Sword', 500 ])`
 *
 * @function Phaser.Utils.String.Format
 * @since 3.0.0
 *
 * @param {string} string - The string containing the replacement markers.
 * @param {array} values - An array containing values that will replace the markers. If no value exists an empty string is inserted instead.
 *
 * @return {string} The string containing replaced values.
 */ var Format = function(string, values) {
                return string.replace(/%([0-9]+)/g, function(s, n) {
                    return values[Number(n) - 1];
                });
            };
            module1.exports = Format;
        /***/ },
        /* 1490 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and removes the character at the given index.
 *
 * @function Phaser.Utils.String.RemoveAt
 * @since 3.50.0
 *
 * @param {string} string - The string to be worked on.
 * @param {number} index - The index of the character to be removed.
 *
 * @return {string} The modified string.
 */ var RemoveAt = function(string, index) {
                if (index === 0) return string.slice(1);
                else return string.slice(0, index - 1) + string.slice(index);
            };
            module1.exports = RemoveAt;
        /***/ },
        /* 1491 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and reverses it, returning the reversed string.
 * For example if given the string `Atari 520ST` it would return `TS025 iratA`.
 *
 * @function Phaser.Utils.String.Reverse
 * @since 3.0.0
 *
 * @param {string} string - The string to be reversed.
 *
 * @return {string} The reversed string.
 */ var Reverse = function(string) {
                return string.split("").reverse().join("");
            };
            module1.exports = Reverse;
        /***/ },
        /* 1492 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound
 */ module1.exports = {
                SoundManagerCreator: __webpack_require__(426),
                Events: __webpack_require__(70),
                BaseSound: __webpack_require__(146),
                BaseSoundManager: __webpack_require__(145),
                WebAudioSound: __webpack_require__(434),
                WebAudioSoundManager: __webpack_require__(432),
                HTML5AudioSound: __webpack_require__(429),
                HTML5AudioSoundManager: __webpack_require__(427),
                NoAudioSound: __webpack_require__(431),
                NoAudioSoundManager: __webpack_require__(430)
            };
        /***/ },
        /* 1493 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics
 */ /**
 * @namespace Phaser.Types.Physics
 */ module1.exports = {
                Arcade: __webpack_require__(1366),
                Matter: __webpack_require__(1494)
            };
        /***/ },
        /* 1494 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter
 */ module1.exports = {
                BodyBounds: __webpack_require__(1392),
                Components: __webpack_require__(249),
                Events: __webpack_require__(272),
                Factory: __webpack_require__(1394),
                MatterGameObject: __webpack_require__(1395),
                Image: __webpack_require__(1396),
                Matter: __webpack_require__(594),
                MatterPhysics: __webpack_require__(1524),
                PolyDecomp: __webpack_require__(1393),
                Sprite: __webpack_require__(1397),
                TileBody: __webpack_require__(593),
                PhysicsEditorParser: __webpack_require__(589),
                PhysicsJSONParser: __webpack_require__(590),
                PointerConstraint: __webpack_require__(1398),
                World: __webpack_require__(1402)
            };
        /***/ },
        /* 1495 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to set restitution on objects.
 *
 * @namespace Phaser.Physics.Matter.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                /**
     * Sets the restitution on the physics object.
     *
     * @method Phaser.Physics.Matter.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} value - A Number that defines the restitution (elasticity) of the body. The value is always positive and is in the range (0, 1). A value of 0 means collisions may be perfectly inelastic and no bouncing may occur. A value of 0.8 means the body may bounce back with approximately 80% of its kinetic energy. Note that collision response is based on pairs of bodies, and that restitution values are combined with the following formula: `Math.max(bodyA.restitution, bodyB.restitution)`
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setBounce: function(value) {
                    this.body.restitution = value;
                    return this;
                }
            };
            module1.exports = Bounce;
        /***/ },
        /* 1496 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the collision filter of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Collision
 * @since 3.0.0
 */ var Collision = {
                /**
     * Sets the collision category of this Game Object's Matter Body. This number must be a power of two between 2^0 (= 1) and 2^31.
     * Two bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionCategory
     * @since 3.0.0
     *
     * @param {number} value - Unique category bitfield.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollisionCategory: function(value) {
                    this.body.collisionFilter.category = value;
                    return this;
                },
                /**
     * Sets the collision group of this Game Object's Matter Body. If this is zero or two Matter Bodies have different values,
     * they will collide according to the usual rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     * If two Matter Bodies have the same positive value, they will always collide; if they have the same negative value,
     * they will never collide.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionGroup
     * @since 3.0.0
     *
     * @param {number} value - Unique group index.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollisionGroup: function(value) {
                    this.body.collisionFilter.group = value;
                    return this;
                },
                /**
     * Sets the collision mask for this Game Object's Matter Body. Two Matter Bodies with different collision groups will only
     * collide if each one includes the other's category in its mask based on a bitwise AND, i.e. `(categoryA & maskB) !== 0`
     * and `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollidesWith
     * @since 3.0.0
     *
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollidesWith: function(categories) {
                    var flags = 0;
                    if (!Array.isArray(categories)) flags = categories;
                    else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                    this.body.collisionFilter.mask = flags;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollide
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body starts colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollide: function(callback) {
                    this.body.onCollideCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideEnd
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body stops colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideEnd: function(callback) {
                    this.body.onCollideEndCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideActive
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke for the duration of this body colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideActive: function(callback) {
                    this.body.onCollideActiveCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a reference to the other body, along with a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideWith
     * @since 3.22.0
     *
     * @param {(MatterJS.Body|MatterJS.Body[])} body - The body, or an array of bodies, to test for collisions with.
     * @param {function} callback - The callback to invoke when this body collides with the given body or bodies.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideWith: function(body, callback) {
                    if (!Array.isArray(body)) body = [
                        body
                    ];
                    for(var i = 0; i < body.length; i++){
                        var src = body[i].hasOwnProperty("body") ? body[i].body : body[i];
                        this.body.setOnCollideWith(src, callback);
                    }
                    return this;
                }
            };
            module1.exports = Collision;
        /***/ },
        /* 1497 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(41);
            /**
 * A component to apply force to Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Force
 * @since 3.0.0
 */ var Force = {
                //  force = vec2 / point
                /**
     * Applies a force to a body.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForce
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ applyForce: function(force) {
                    this._tempVec2.set(this.body.position.x, this.body.position.y);
                    Body.applyForce(this.body, this._tempVec2, force);
                    return this;
                },
                /**
     * Applies a force to a body from a given position.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForceFrom
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} position - The position in which the force comes from.
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ applyForceFrom: function(position, force) {
                    Body.applyForce(this.body, position, force);
                    return this;
                },
                /**
     * Apply thrust to the forward position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrust
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrust: function(speed) {
                    var angle = this.body.angle;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the left position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustLeft
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustLeft: function(speed) {
                    var angle = this.body.angle - Math.PI / 2;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the right position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustRight
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustRight: function(speed) {
                    var angle = this.body.angle + Math.PI / 2;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the back position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustBack
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustBack: function(speed) {
                    var angle = this.body.angle - Math.PI;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                }
            };
            module1.exports = Force;
        /***/ },
        /* 1498 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the friction of a Game Object's Matter Body. Should be used a mixin, not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Friction
 * @since 3.0.0
 */ var Friction = {
                /**
     * Sets new friction values for this Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} value - The new friction of the body, between 0 and 1, where 0 allows the Body to slide indefinitely, while 1 allows it to stop almost immediately after a force is applied.
     * @param {number} [air] - If provided, the new air resistance of the Body. The higher the value, the faster the Body will slow as it moves through space. 0 means the body has no air resistance.
     * @param {number} [fstatic] - If provided, the new static friction of the Body. The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary. 0 means the body will never "stick" when it is nearly stationary.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFriction: function(value, air, fstatic) {
                    this.body.friction = value;
                    if (air !== undefined) this.body.frictionAir = air;
                    if (fstatic !== undefined) this.body.frictionStatic = fstatic;
                    return this;
                },
                /**
     * Sets a new air resistance for this Game Object's Matter Body.
     * A value of 0 means the Body will never slow as it moves through space.
     * The higher the value, the faster a Body slows when moving through space.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionAir
     * @since 3.0.0
     *
     * @param {number} value - The new air resistance for the Body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFrictionAir: function(value) {
                    this.body.frictionAir = value;
                    return this;
                },
                /**
     * Sets a new static friction for this Game Object's Matter Body.
     * A value of 0 means the Body will never "stick" when it is nearly stationary.
     * The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionStatic
     * @since 3.0.0
     *
     * @param {number} value - The new static friction for the Body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFrictionStatic: function(value) {
                    this.body.frictionStatic = value;
                    return this;
                }
            };
            module1.exports = Friction;
        /***/ },
        /* 1499 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to manipulate world gravity for Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                /**
     * A togglable function for ignoring world gravity in real-time on the current body.
     *
     * @method Phaser.Physics.Matter.Components.Gravity#setIgnoreGravity
     * @since 3.0.0
     *
     * @param {boolean} value - Set to true to ignore the effect of world gravity, or false to not ignore it.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setIgnoreGravity: function(value) {
                    this.body.ignoreGravity = value;
                    return this;
                }
            };
            module1.exports = Gravity;
        /***/ },
        /* 1500 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(41);
            var Vector2 = __webpack_require__(3);
            /**
 * Allows accessing the mass, density, and center of mass of a Matter-enabled Game Object. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                /**
     * Sets the mass of the Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - The new mass of the body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setMass: function(value) {
                    Body.setMass(this.body, value);
                    return this;
                },
                /**
     * Sets density of the body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setDensity
     * @since 3.0.0
     *
     * @param {number} value - The new density of the body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setDensity: function(value) {
                    Body.setDensity(this.body, value);
                    return this;
                },
                /**
     * The body's center of mass.
     * 
     * Calling this creates a new `Vector2 each time to avoid mutation.
     * 
     * If you only need to read the value and won't change it, you can get it from `GameObject.body.centerOfMass`.
     *
     * @name Phaser.Physics.Matter.Components.Mass#centerOfMass
     * @type {Phaser.Math.Vector2}
     * @readonly
     * @since 3.10.0
     *
     * @return {Phaser.Math.Vector2} The center of mass.
     */ centerOfMass: {
                    get: function() {
                        return new Vector2(this.body.centerOfMass.x, this.body.centerOfMass.y);
                    }
                }
            };
            module1.exports = Mass;
        /***/ },
        /* 1501 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Enables a Matter-enabled Game Object to be a sensor. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sensor
 * @since 3.0.0
 */ var Sensor = {
                /**
     * Set the body belonging to this Game Object to be a sensor.
     * Sensors trigger collision events, but don't react with colliding body physically.
     *
     * @method Phaser.Physics.Matter.Components.Sensor#setSensor
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as a sensor, or `false` to disable it.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setSensor: function(value) {
                    this.body.isSensor = value;
                    return this;
                },
                /**
     * Is the body belonging to this Game Object a sensor or not?
     *
     * @method Phaser.Physics.Matter.Components.Sensor#isSensor
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is a sensor, otherwise `false`.
     */ isSensor: function() {
                    return this.body.isSensor;
                }
            };
            module1.exports = Sensor;
        /***/ },
        /* 1502 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            var FuzzyEquals = __webpack_require__(124);
            var GetFastValue = __webpack_require__(2);
            var PhysicsEditorParser = __webpack_require__(589);
            var PhysicsJSONParser = __webpack_require__(590);
            var Vertices = __webpack_require__(64);
            /**
 * Enables a Matter-enabled Game Object to set its Body. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.SetBody
 * @since 3.0.0
 */ var SetBody = {
                /**
     * Set the body on a Game Object to a rectangle.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setRectangle
     * @since 3.0.0
     *
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setRectangle: function(width, height, options) {
                    return this.setBody({
                        type: "rectangle",
                        width: width,
                        height: height
                    }, options);
                },
                /**
     * Set the body on a Game Object to a circle.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCircle: function(radius, options) {
                    return this.setBody({
                        type: "circle",
                        radius: radius
                    }, options);
                },
                /**
     * Set the body on the Game Object to a polygon shape.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setPolygon
     * @since 3.0.0
     *
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {number} sides - The number of sides the polygon will have.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setPolygon: function(radius, sides, options) {
                    return this.setBody({
                        type: "polygon",
                        sides: sides,
                        radius: radius
                    }, options);
                },
                /**
     * Set the body on the Game Object to a trapezoid shape.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setTrapezoid
     * @since 3.0.0
     *
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setTrapezoid: function(width, height, slope, options) {
                    return this.setBody({
                        type: "trapezoid",
                        width: width,
                        height: height,
                        slope: slope
                    }, options);
                },
                /**
     * Set this Game Object to use the given existing Matter Body.
     * 
     * The body is first removed from the world before being added to this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setExistingBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Body this Game Object should use.
     * @param {boolean} [addToWorld=true] - Should the body be immediately added to the World?
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setExistingBody: function(body, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    if (this.body) this.world.remove(this.body, true);
                    this.body = body;
                    for(var i = 0; i < body.parts.length; i++)body.parts[i].gameObject = this;
                    var _this = this;
                    body.destroy = function destroy() {
                        _this.world.remove(_this.body, true);
                        _this.body.gameObject = null;
                    };
                    if (addToWorld) {
                        if (this.world.has(body)) //  Because it could be part of another Composite
                        this.world.remove(body, true);
                        this.world.add(body);
                    }
                    if (this._originComponent) {
                        var rx = body.render.sprite.xOffset;
                        var ry = body.render.sprite.yOffset;
                        var comx = body.centerOfMass.x;
                        var comy = body.centerOfMass.y;
                        if (FuzzyEquals(comx, 0.5) && FuzzyEquals(comy, 0.5)) this.setOrigin(rx + 0.5, ry + 0.5);
                        else {
                            var cx = body.centerOffset.x;
                            var cy = body.centerOffset.y;
                            this.setOrigin(rx + cx / this.displayWidth, ry + cy / this.displayHeight);
                        }
                    }
                    return this;
                },
                /**
     * Set this Game Object to create and use a new Body based on the configuration object given.
     * 
     * Calling this method resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setBody
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Physics.Matter.MatterSetBodyConfig)} config - Either a string, such as `circle`, or a Matter Set Body Configuration object.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setBody: function(config, options) {
                    if (!config) return this;
                    var body;
                    //  Allow them to do: shape: 'circle' instead of shape: { type: 'circle' }
                    if (typeof config === "string") //  Using defaults
                    config = {
                        type: config
                    };
                    var shapeType = GetFastValue(config, "type", "rectangle");
                    var bodyX = GetFastValue(config, "x", this._tempVec2.x);
                    var bodyY = GetFastValue(config, "y", this._tempVec2.y);
                    var bodyWidth = GetFastValue(config, "width", this.width);
                    var bodyHeight = GetFastValue(config, "height", this.height);
                    switch(shapeType){
                        case "rectangle":
                            body = Bodies.rectangle(bodyX, bodyY, bodyWidth, bodyHeight, options);
                            break;
                        case "circle":
                            var radius = GetFastValue(config, "radius", Math.max(bodyWidth, bodyHeight) / 2);
                            var maxSides = GetFastValue(config, "maxSides", 25);
                            body = Bodies.circle(bodyX, bodyY, radius, options, maxSides);
                            break;
                        case "trapezoid":
                            var slope = GetFastValue(config, "slope", 0.5);
                            body = Bodies.trapezoid(bodyX, bodyY, bodyWidth, bodyHeight, slope, options);
                            break;
                        case "polygon":
                            var sides = GetFastValue(config, "sides", 5);
                            var pRadius = GetFastValue(config, "radius", Math.max(bodyWidth, bodyHeight) / 2);
                            body = Bodies.polygon(bodyX, bodyY, sides, pRadius, options);
                            break;
                        case "fromVertices":
                        case "fromVerts":
                            var verts = GetFastValue(config, "verts", null);
                            if (verts) {
                                //  Has the verts array come from Vertices.fromPath, or is it raw?
                                if (typeof verts === "string") verts = Vertices.fromPath(verts);
                                if (this.body && !this.body.hasOwnProperty("temp")) {
                                    Body.setVertices(this.body, verts);
                                    body = this.body;
                                } else {
                                    var flagInternal = GetFastValue(config, "flagInternal", false);
                                    var removeCollinear = GetFastValue(config, "removeCollinear", 0.01);
                                    var minimumArea = GetFastValue(config, "minimumArea", 10);
                                    body = Bodies.fromVertices(bodyX, bodyY, verts, options, flagInternal, removeCollinear, minimumArea);
                                }
                            }
                            break;
                        case "fromPhysicsEditor":
                            body = PhysicsEditorParser.parseBody(bodyX, bodyY, config, options);
                            break;
                        case "fromPhysicsTracer":
                            body = PhysicsJSONParser.parseBody(bodyX, bodyY, config, options);
                            break;
                    }
                    if (body) this.setExistingBody(body, config.addToWorld);
                    return this;
                }
            };
            module1.exports = SetBody;
        /***/ },
        /* 1503 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(272);
            var Sleeping = __webpack_require__(165);
            var MatterEvents = __webpack_require__(166);
            /**
 * Enables a Matter-enabled Game Object to be able to go to sleep. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sleep
 * @since 3.0.0
 */ var Sleep = {
                /**
     * Sets this Body to sleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setToSleep
     * @since 3.22.0
     *
     * @return {this} This Game Object.
     */ setToSleep: function() {
                    Sleeping.set(this.body, true);
                    return this;
                },
                /**
     * Wakes this Body if asleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setAwake
     * @since 3.22.0
     *
     * @return {this} This Game Object.
     */ setAwake: function() {
                    Sleeping.set(this.body, false);
                    return this;
                },
                /**
     * Sets the number of updates in which this body must have near-zero velocity before it is set as sleeping (if sleeping is enabled by the engine).
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepThreshold
     * @since 3.0.0
     *
     * @param {number} [value=60] - A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping.
     *
     * @return {this} This Game Object.
     */ setSleepThreshold: function(value) {
                    if (value === undefined) value = 60;
                    this.body.sleepThreshold = value;
                    return this;
                },
                /**
     * Enable sleep and wake events for this body.
     *
     * By default when a body goes to sleep, or wakes up, it will not emit any events.
     *
     * The events are emitted by the Matter World instance and can be listened to via
     * the `SLEEP_START` and `SLEEP_END` events.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEvents
     * @since 3.0.0
     *
     * @param {boolean} start - `true` if you want the sleep start event to be emitted for this body.
     * @param {boolean} end - `true` if you want the sleep end event to be emitted for this body.
     *
     * @return {this} This Game Object.
     */ setSleepEvents: function(start, end) {
                    this.setSleepStartEvent(start);
                    this.setSleepEndEvent(end);
                    return this;
                },
                /**
     * Enables or disables the Sleep Start event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepStartEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object.
     */ setSleepStartEvent: function(value) {
                    if (value) {
                        var world = this.world;
                        MatterEvents.on(this.body, "sleepStart", function(event) {
                            world.emit(Events.SLEEP_START, event, this);
                        });
                    } else MatterEvents.off(this.body, "sleepStart");
                    return this;
                },
                /**
     * Enables or disables the Sleep End event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEndEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object.
     */ setSleepEndEvent: function(value) {
                    if (value) {
                        var world = this.world;
                        MatterEvents.on(this.body, "sleepEnd", function(event) {
                            world.emit(Events.SLEEP_END, event, this);
                        });
                    } else MatterEvents.off(this.body, "sleepEnd");
                    return this;
                }
            };
            module1.exports = Sleep;
        /***/ },
        /* 1504 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterAddEvent
 *
 * @property {any[]} object - An array of the object(s) that have been added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Add Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the end of the process when a new Body
 * or Constraint has just been added to the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afteradd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_ADD
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterAddEvent} event - The Add Event object.
 */ module1.exports = "afteradd";
        /***/ },
        /* 1505 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) that were removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Remove Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the end of the process when a 
 * Body or Constraint was removed from the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afterremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_REMOVE
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterRemoveEvent} event - The Remove Event object.
 */ module1.exports = "afterremove";
        /***/ },
        /* 1506 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Update Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated and all collision events have resolved.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afterupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterUpdateEvent} event - The Update Event object.
 */ module1.exports = "afterupdate";
        /***/ },
        /* 1507 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeAddEvent
 *
 * @property {any[]} object - An array of the object(s) to be added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Add Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the start of the process when a new Body
 * or Constraint is being added to the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeadd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_ADD
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeAddEvent} event - The Add Event object.
 */ module1.exports = "beforeadd";
        /***/ },
        /* 1508 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) to be removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Remove Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the start of the process when a 
 * Body or Constraint is being removed from the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_REMOVE
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeRemoveEvent} event - The Remove Event object.
 */ module1.exports = "beforeremove";
        /***/ },
        /* 1509 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Update Event.
 * 
 * This event is dispatched by a Matter Physics World instance right before all the collision processing takes place.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeUpdateEvent} event - The Update Event object.
 */ module1.exports = "beforeupdate";
        /***/ },
        /* 1510 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionActiveEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Active Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that are colliding in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionactive', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_ACTIVE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionActiveEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = "collisionactive";
        /***/ },
        /* 1511 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionEndEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision End Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have finished colliding in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_END
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionEndEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = "collisionend";
        /***/ },
        /* 1512 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionStartEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have started to collide in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_START
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionStartEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = "collisionstart";
        /***/ },
        /* 1513 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag End Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * stops dragging a body.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('dragend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_END
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that has stopped being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that was dragging the body.
 */ module1.exports = "dragend";
        /***/ },
        /* 1514 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * is actively dragging a body. It is emitted each time the pointer moves.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('drag', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that is being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = "drag";
        /***/ },
        /* 1515 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * starts dragging a body.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('dragstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_START
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that has started being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {MatterJS.BodyType} part - The part of the body that was clicked on.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = "dragstart";
        /***/ },
        /* 1516 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Pause Event.
 * 
 * This event is dispatched by an Matter Physics World instance when it is paused.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = "pause";
        /***/ },
        /* 1517 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Resume Event.
 * 
 * This event is dispatched by an Matter Physics World instance when it resumes from a paused state.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#RESUME
 * @since 3.0.0
 */ module1.exports = "resume";
        /***/ },
        /* 1518 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepEndEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep End Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Body stop sleeping.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('sleepend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_END
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.SleepEndEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has stopped sleeping.
 */ module1.exports = "sleepend";
        /***/ },
        /* 1519 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepStartEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Body goes to sleep.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('sleepstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_START
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.SleepStartEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has gone to sleep.
 */ module1.exports = "sleepstart";
        /***/ },
        /* 1520 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(41);
            /**
 * Provides methods used for getting and setting the static state of a physics body.
 *
 * @namespace Phaser.Physics.Matter.Components.Static
 * @since 3.0.0
 */ var Static = {
                /**
     * Changes the physics body to be either static `true` or dynamic `false`.
     *
     * @method Phaser.Physics.Matter.Components.Static#setStatic
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as being static, or `false` to make it dynamic.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setStatic: function(value) {
                    Body.setStatic(this.body, value);
                    return this;
                },
                /**
     * Returns `true` if the body is static, otherwise `false` for a dynamic body.
     *
     * @method Phaser.Physics.Matter.Components.Static#isStatic
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is static, otherwise `false`.
     */ isStatic: function() {
                    return this.body.isStatic;
                }
            };
            module1.exports = Static;
        /***/ },
        /* 1521 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(41);
            var MATH_CONST = __webpack_require__(14);
            var WrapAngle = __webpack_require__(269);
            var WrapAngleDegrees = __webpack_require__(270);
            //  global bitmask flag for GameObject.renderMask (used by Scale)
            var _FLAG = 4; // 0100
            //  Transform Component
            /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.Physics.Matter.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                /**
     * The x position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.body.position.x;
                    },
                    set: function(value) {
                        this._tempVec2.set(value, this.y);
                        Body.setPosition(this.body, this._tempVec2);
                    }
                },
                /**
     * The y position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.body.position.y;
                    },
                    set: function(value) {
                        this._tempVec2.set(this.x, value);
                        Body.setPosition(this.body, this._tempVec2);
                    }
                },
                /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleX
     * @type {number}
     * @since 3.0.0
     */ scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(value) {
                        var factorX = 1 / this._scaleX;
                        var factorY = 1 / this._scaleY;
                        this._scaleX = value;
                        if (this._scaleX === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        //  Reset Matter scale back to 1 (sigh)
                        Body.scale(this.body, factorX, factorY);
                        Body.scale(this.body, value, this._scaleY);
                    }
                },
                /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleY
     * @type {number}
     * @since 3.0.0
     */ scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(value) {
                        var factorX = 1 / this._scaleX;
                        var factorY = 1 / this._scaleY;
                        this._scaleY = value;
                        if (this._scaleY === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        Body.scale(this.body, factorX, factorY);
                        Body.scale(this.body, this._scaleX, value);
                    }
                },
                /**
     * Use `angle` to set or get rotation of the physics body associated to this GameObject.
     * Unlike rotation, when using set the value can be in degrees, which will be converted to radians internally.
     *
     * @name Phaser.Physics.Matter.Components.Transform#angle
     * @type {number}
     * @since 3.0.0
     */ angle: {
                    get: function() {
                        return WrapAngleDegrees(this.body.angle * MATH_CONST.RAD_TO_DEG);
                    },
                    set: function(value) {
                        //  value is in degrees
                        this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                    }
                },
                /**
     * Use `rotation` to set or get the rotation of the physics body associated with this GameObject.
     * The value when set must be in radians.
     *
     * @name Phaser.Physics.Matter.Components.Transform#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this.body.angle;
                    },
                    set: function(value) {
                        //  value is in radians
                        this._rotation = WrapAngle(value);
                        Body.setAngle(this.body, this._rotation);
                    }
                },
                /**
     * Sets the position of the physics body along x and y axes.
     * Both the parameters to this function are optional and if not passed any they default to 0.
     * Velocity, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the body.
     * @param {number} [y=x] - The vertical position of the body.
     *
     * @return {this} This Game Object.
     */ setPosition: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this._tempVec2.set(x, y);
                    Body.setPosition(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The angle of the body, in radians.
     *
     * @return {this} This Game Object.
     */ setRotation: function(radians) {
                    if (radians === undefined) radians = 0;
                    this._rotation = WrapAngle(radians);
                    Body.setAngle(this.body, radians);
                    return this;
                },
                /**
     * Setting fixed rotation sets the Body inertia to Infinity, which stops it
     * from being able to rotate when forces are applied to it.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setFixedRotation
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ setFixedRotation: function() {
                    Body.setInertia(this.body, Infinity);
                    return this;
                },
                /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The angle to set, in degrees.
     *
     * @return {this} This Game Object.
     */ setAngle: function(degrees) {
                    if (degrees === undefined) degrees = 0;
                    this.angle = degrees;
                    Body.setAngle(this.body, this.rotation);
                    return this;
                },
                /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the x value.
     * @param {Phaser.Math.Vector2} [point] - The point (Vector2) from which scaling will occur.
     *
     * @return {this} This Game Object.
     */ setScale: function(x, y, point) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    var factorX = 1 / this._scaleX;
                    var factorY = 1 / this._scaleY;
                    this._scaleX = x;
                    this._scaleY = y;
                    Body.scale(this.body, factorX, factorY, point);
                    Body.scale(this.body, x, y, point);
                    return this;
                }
            };
            module1.exports = Transform;
        /***/ },
        /* 1522 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(41);
            /**
 * Contains methods for changing the velocity of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                /**
     * Sets the angular velocity of the body instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The angular velocity.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setAngularVelocity: function(value) {
                    Body.setAngularVelocity(this.body, value);
                    return this;
                },
                /**
     * Sets the horizontal velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocityX: function(x) {
                    this._tempVec2.set(x, this.body.velocity.y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Sets vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The vertical velocity value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocityY: function(y) {
                    this._tempVec2.set(this.body.velocity.x, y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Sets both the horizontal and vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     * @param {number} [y=x] - The vertical velocity value, it can be either positive or negative. If not given, it will be the same as the `x` value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocity: function(x, y) {
                    this._tempVec2.set(x, y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                }
            };
            module1.exports = Velocity;
        /***/ },
        /* 1523 */ /***/ function(module1, exports, __webpack_require__) {
            // @if DEBUG
            /**
* _Internal Class_, not generally used outside of the engine's internals.
*
*/ var Metrics = {};
            module1.exports = Metrics;
            var Composite = __webpack_require__(118);
            var Common = __webpack_require__(32);
            (function() {
                /**
     * Creates a new metrics.
     * @method create
     * @private
     * @return {metrics} A new metrics
     */ Metrics.create = function(options) {
                    var defaults = {
                        extended: false,
                        narrowDetections: 0,
                        narrowphaseTests: 0,
                        narrowReuse: 0,
                        narrowReuseCount: 0,
                        midphaseTests: 0,
                        broadphaseTests: 0,
                        narrowEff: 0.0001,
                        midEff: 0.0001,
                        broadEff: 0.0001,
                        collisions: 0,
                        buckets: 0,
                        bodies: 0,
                        pairs: 0
                    };
                    return Common.extend(defaults, false, options);
                };
                /**
     * Resets metrics.
     * @method reset
     * @private
     * @param {metrics} metrics
     */ Metrics.reset = function(metrics) {
                    if (metrics.extended) {
                        metrics.narrowDetections = 0;
                        metrics.narrowphaseTests = 0;
                        metrics.narrowReuse = 0;
                        metrics.narrowReuseCount = 0;
                        metrics.midphaseTests = 0;
                        metrics.broadphaseTests = 0;
                        metrics.narrowEff = 0;
                        metrics.midEff = 0;
                        metrics.broadEff = 0;
                        metrics.collisions = 0;
                        metrics.buckets = 0;
                        metrics.pairs = 0;
                        metrics.bodies = 0;
                    }
                };
                /**
     * Updates metrics.
     * @method update
     * @private
     * @param {metrics} metrics
     * @param {engine} engine
     */ Metrics.update = function(metrics, engine) {
                    if (metrics.extended) {
                        var world = engine.world, bodies = Composite.allBodies(world);
                        metrics.collisions = metrics.narrowDetections;
                        metrics.pairs = engine.pairs.list.length;
                        metrics.bodies = bodies.length;
                        metrics.midEff = (metrics.narrowDetections / (metrics.midphaseTests || 1)).toFixed(2);
                        metrics.narrowEff = (metrics.narrowDetections / (metrics.narrowphaseTests || 1)).toFixed(2);
                        metrics.broadEff = (1 - metrics.broadphaseTests / (bodies.length || 1)).toFixed(2);
                        metrics.narrowReuse = (metrics.narrowReuseCount / (metrics.narrowphaseTests || 1)).toFixed(2);
                    //var broadphase = engine.broadphase[engine.broadphase.current];
                    //if (broadphase.instance)
                    //    metrics.buckets = Common.keys(broadphase.instance.buckets).length;
                    }
                };
            })();
        // @endif
        /***/ },
        /* 1524 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(123);
            var Axes = __webpack_require__(271);
            var Bodies = __webpack_require__(86);
            var Body = __webpack_require__(41);
            var BodyBounds = __webpack_require__(1392);
            var Bounds = __webpack_require__(84);
            var Class = __webpack_require__(0);
            var Composite = __webpack_require__(118);
            var Composites = __webpack_require__(591);
            var Constraint = __webpack_require__(128);
            var Detector = __webpack_require__(273);
            var DistanceBetween = __webpack_require__(50);
            var Factory = __webpack_require__(1394);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var Grid = __webpack_require__(597);
            var MatterAttractors = __webpack_require__(1525);
            var MatterCollisionEvents = __webpack_require__(1526);
            var MatterLib = __webpack_require__(1399);
            var MatterWrap = __webpack_require__(1527);
            var Merge = __webpack_require__(127);
            var Pair = __webpack_require__(250);
            var Pairs = __webpack_require__(598);
            var Plugin = __webpack_require__(595);
            var PluginCache = __webpack_require__(24);
            var Query = __webpack_require__(1400);
            var Resolver = __webpack_require__(599);
            var SAT = __webpack_require__(274);
            var SceneEvents = __webpack_require__(20);
            var Svg = __webpack_require__(592);
            var Vector = __webpack_require__(83);
            var Vertices = __webpack_require__(64);
            var World = __webpack_require__(1402);
            /**
 * @classdesc
 * The Phaser Matter plugin provides the ability to use the Matter JS Physics Engine within your Phaser games.
 * 
 * Unlike Arcade Physics, the other physics system provided with Phaser, Matter JS is a full-body physics system.
 * It features:
 * 
 * * Rigid bodies
 * * Compound bodies
 * * Composite bodies
 * * Concave and convex hulls
 * * Physical properties (mass, area, density etc.)
 * * Restitution (elastic and inelastic collisions)
 * * Collisions (broad-phase, mid-phase and narrow-phase)
 * * Stable stacking and resting
 * * Conservation of momentum
 * * Friction and resistance
 * * Constraints
 * * Gravity
 * * Sleeping and static bodies
 * * Rounded corners (chamfering)
 * * Views (translate, zoom)
 * * Collision queries (raycasting, region tests)
 * * Time scaling (slow-mo, speed-up)
 * 
 * Configuration of Matter is handled via the Matter World Config object, which can be passed in either the
 * Phaser Game Config, or Phaser Scene Config. Here is a basic example:
 * 
 * ```js
 * physics: {
 *     default: 'matter',
 *     matter: {
 *         enableSleeping: true,
 *         gravity: {
 *             y: 0
 *         },
 *         debug: {
 *             showBody: true,
 *             showStaticBody: true
 *         }
 *     }
 * }
 * ```
 * 
 * This class acts as an interface between a Phaser Scene and a single instance of the Matter Engine.
 * 
 * Use it to access the most common Matter features and helper functions.
 * 
 * You can find details, documentation and examples on the Matter JS website: https://brm.io/matter-js/
 *
 * @class MatterPhysics
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Phaser Scene that owns this Matter Physics instance.
 */ var MatterPhysics = new Class({
                initialize: function MatterPhysics(scene) {
                    /**
         * The Phaser Scene that owns this Matter Physics instance
         *
         * @name Phaser.Physics.Matter.MatterPhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems that belong to the Scene owning this Matter Physics instance.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The parsed Matter Configuration object.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#config
         * @type {Phaser.Types.Physics.Matter.MatterWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                    /**
         * An instance of the Matter World class. This class is responsible for the updating of the
         * Matter Physics world, as well as handling debug drawing functions.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world;
                    /**
         * An instance of the Matter Factory. This class provides lots of functions for creating a
         * wide variety of physics objects and adds them automatically to the Matter World.
         * 
         * You can use this class to cut-down on the amount of code required in your game, however,
         * use of the Factory is entirely optional and should be seen as a development aid. It's
         * perfectly possible to create and add components to the Matter world without using it.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#add
         * @type {Phaser.Physics.Matter.Factory}
         * @since 3.0.0
         */ this.add;
                    /**
         * An instance of the Body Bounds class. This class contains functions used for getting the
         * world position from various points around the bounds of a physics body.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodyBounds
         * @type {Phaser.Physics.Matter.BodyBounds}
         * @since 3.22.0
         */ this.bodyBounds;
                    //  Body
                    /**
         * A reference to the `Matter.Body` module.
         * 
         * The `Matter.Body` module contains methods for creating and manipulating body models.
         * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
         * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the `Bodies` module.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#body
         * @type {MatterJS.BodyFactory}
         * @since 3.18.0
         */ this.body = Body;
                    /**
         * A reference to the `Matter.Composite` module.
         * 
         * The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
         * A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
         * It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
         * Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composite
         * @type {MatterJS.CompositeFactory}
         * @since 3.22.0
         */ this.composite = Composite;
                    //  Collision:
                    /**
         * A reference to the `Matter.Detector` module.
         * 
         * The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#detector
         * @type {MatterJS.DetectorFactory}
         * @since 3.22.0
         */ this.detector = Detector;
                    /**
         * A reference to the `Matter.Grid` module.
         * 
         * The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#grid
         * @type {MatterJS.GridFactory}
         * @since 3.22.0
         */ this.grid = Grid;
                    /**
         * A reference to the `Matter.Pair` module.
         * 
         * The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pair
         * @type {MatterJS.PairFactory}
         * @since 3.22.0
         */ this.pair = Pair;
                    /**
         * A reference to the `Matter.Pairs` module.
         * 
         * The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pairs
         * @type {MatterJS.PairsFactory}
         * @since 3.22.0
         */ this.pairs = Pairs;
                    /**
         * A reference to the `Matter.Query` module.
         * 
         * The `Matter.Query` module contains methods for performing collision queries.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#query
         * @type {MatterJS.QueryFactory}
         * @since 3.22.0
         */ this.query = Query;
                    /**
         * A reference to the `Matter.Resolver` module.
         * 
         * The `Matter.Resolver` module contains methods for resolving collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#resolver
         * @type {MatterJS.ResolverFactory}
         * @since 3.22.0
         */ this.resolver = Resolver;
                    /**
         * A reference to the `Matter.SAT` module.
         * 
         * The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#sat
         * @type {MatterJS.SATFactory}
         * @since 3.22.0
         */ this.sat = SAT;
                    //  Constraint
                    /**
         * A reference to the `Matter.Constraint` module.
         * 
         * The `Matter.Constraint` module contains methods for creating and manipulating constraints.
         * Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
         * The stiffness of constraints can be modified to create springs or elastic.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#constraint
         * @type {MatterJS.ConstraintFactory}
         * @since 3.22.0
         */ this.constraint = Constraint;
                    //  Factory
                    /**
         * A reference to the `Matter.Bodies` module.
         * 
         * The `Matter.Bodies` module contains factory methods for creating rigid bodies
         * with commonly used body configurations (such as rectangles, circles and other polygons).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodies
         * @type {MatterJS.BodiesFactory}
         * @since 3.18.0
         */ this.bodies = Bodies;
                    /**
         * A reference to the `Matter.Composites` module.
         * 
         * The `Matter.Composites` module contains factory methods for creating composite bodies
         * with commonly used configurations (such as stacks and chains).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composites
         * @type {MatterJS.CompositesFactory}
         * @since 3.22.0
         */ this.composites = Composites;
                    //  Geometry
                    /**
         * A reference to the `Matter.Axes` module.
         * 
         * The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#axes
         * @type {MatterJS.AxesFactory}
         * @since 3.22.0
         */ this.axes = Axes;
                    /**
         * A reference to the `Matter.Bounds` module.
         * 
         * The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bounds
         * @type {MatterJS.BoundsFactory}
         * @since 3.22.0
         */ this.bounds = Bounds;
                    /**
         * A reference to the `Matter.Svg` module.
         * 
         * The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
         *
         * To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
         *
         * @name Phaser.Physics.Matter.MatterPhysics#svg
         * @type {MatterJS.SvgFactory}
         * @since 3.22.0
         */ this.svg = Svg;
                    /**
         * A reference to the `Matter.Vector` module.
         * 
         * The `Matter.Vector` module contains methods for creating and manipulating vectors.
         * Vectors are the basis of all the geometry related operations in the engine.
         * A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vector
         * @type {MatterJS.VectorFactory}
         * @since 3.22.0
         */ this.vector = Vector;
                    /**
         * A reference to the `Matter.Vertices` module.
         * 
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vertices
         * @type {MatterJS.VerticesFactory}
         * @since 3.22.0
         */ this.vertices = Vertices;
                    /**
         * A reference to the `Matter.Vertices` module.
         * 
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#verts
         * @type {MatterJS.VerticesFactory}
         * @since 3.14.0
         */ this.verts = Vertices;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#_tempVec2
         * @type {MatterJS.Vector}
         * @private
         * @since 3.22.0
         */ this._tempVec2 = Vector.create();
                    //  Matter plugins
                    if (GetValue(this.config, "plugins.collisionevents", true)) this.enableCollisionEventsPlugin();
                    if (GetValue(this.config, "plugins.attractors", false)) this.enableAttractorPlugin();
                    if (GetValue(this.config, "plugins.wrap", false)) this.enableWrapPlugin();
                    Resolver._restingThresh = GetValue(this.config, "restingThresh", 4);
                    Resolver._restingThreshTangent = GetValue(this.config, "restingThreshTangent", 6);
                    Resolver._positionDampen = GetValue(this.config, "positionDampen", 0.9);
                    Resolver._positionWarming = GetValue(this.config, "positionWarming", 0.8);
                    Resolver._frictionNormalMultiplier = GetValue(this.config, "frictionNormalMultiplier", 5);
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.world = new World(this.scene, this.config);
                    this.add = new Factory(this.world);
                    this.bodyBounds = new BodyBounds();
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    if (!this.world) {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                    }
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * This internal method is called when this class starts and retrieves the final Matter World Config.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Matter.MatterWorldConfig} The Matter World Config.
     */ getConfig: function() {
                    var gameConfig = this.systems.game.config.physics;
                    var sceneConfig = this.systems.settings.physics;
                    var config = Merge(GetFastValue(sceneConfig, "matter", {}), GetFastValue(gameConfig, "matter", {}));
                    return config;
                },
                /**
     * Enables the Matter Attractors Plugin.
     * 
     * The attractors plugin that makes it easy to apply continual forces on bodies.
     * It's possible to simulate effects such as wind, gravity and magnetism.
     * 
     * https://github.com/liabru/matter-attractors
     * 
     * This method is called automatically if `plugins.attractors` is set in the Matter World Config.
     * However, you can also call it directly from within your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableAttractorPlugin
     * @since 3.0.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableAttractorPlugin: function() {
                    Plugin.register(MatterAttractors);
                    Plugin.use(MatterLib, MatterAttractors);
                    return this;
                },
                /**
     * Enables the Matter Wrap Plugin.
     * 
     * The coordinate wrapping plugin that automatically wraps the position of bodies such that they always stay
     * within the given bounds. Upon crossing a boundary the body will appear on the opposite side of the bounds,
     * while maintaining its velocity.
     * 
     * https://github.com/liabru/matter-wrap
     * 
     * This method is called automatically if `plugins.wrap` is set in the Matter World Config.
     * However, you can also call it directly from within your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableWrapPlugin
     * @since 3.0.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableWrapPlugin: function() {
                    Plugin.register(MatterWrap);
                    Plugin.use(MatterLib, MatterWrap);
                    return this;
                },
                /**
     * Enables the Matter Collision Events Plugin.
     * 
     * Note that this plugin is enabled by default. So you should only ever need to call this
     * method if you have specifically disabled the plugin in your Matter World Config.
     * You can disable it by setting `plugins.collisionevents: false` in your Matter World Config.
     * 
     * This plugin triggers three new events on Matter.Body:
     * 
     * 1. `onCollide`
     * 2. `onCollideEnd`
     * 3. `onCollideActive`
     * 
     * These events correspond to the Matter.js events `collisionStart`, `collisionActive` and `collisionEnd`, respectively.
     * You can listen to these events via Matter.Events or they will also be emitted from the Matter World.
     * 
     * This plugin also extends Matter.Body with three convenience functions:
     * 
     * `Matter.Body.setOnCollide(callback)`
     * `Matter.Body.setOnCollideEnd(callback)`
     * `Matter.Body.setOnCollideActive(callback)`
     * 
     * You can register event callbacks by providing a function of type (pair: Matter.Pair) => void
     * 
     * https://github.com/dxu/matter-collision-events
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableCollisionEventsPlugin
     * @since 3.22.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableCollisionEventsPlugin: function() {
                    Plugin.register(MatterCollisionEvents);
                    Plugin.use(MatterLib, MatterCollisionEvents);
                    return this;
                },
                /**
     * Pauses the Matter World instance and sets `enabled` to `false`.
     * 
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ pause: function() {
                    return this.world.pause();
                },
                /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ resume: function() {
                    return this.world.resume();
                },
                /**
     * Sets the Matter Engine to run at fixed timestep of 60Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set60Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set60Hz: function() {
                    this.world.getDelta = this.world.update60Hz;
                    this.world.autoUpdate = true;
                    return this;
                },
                /**
     * Sets the Matter Engine to run at fixed timestep of 30Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set30Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set30Hz: function() {
                    this.world.getDelta = this.world.update30Hz;
                    this.world.autoUpdate = true;
                    return this;
                },
                /**
     * Manually advances the physics simulation by one iteration.
     * 
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     * 
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     * 
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     * @param {number} [correction=1] - Optional delta correction value.
     */ step: function(delta, correction) {
                    this.world.step(delta, correction);
                },
                /**
     * Checks if the vertices of the given body, or an array of bodies, contains the given point, or not.
     * 
     * You can pass in either a single body, or an array of bodies to be checked. This method will
     * return `true` if _any_ of the bodies in the array contain the point. See the `intersectPoint` method if you need
     * to get a list of intersecting bodies.
     * 
     * The point should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use points from another system you may need to
     * transform them before passing them.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#containsPoint
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} body - The body, or an array of bodies, to check against the point.
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     * 
     * @return {boolean} `true` if the point is within one of the bodies given, otherwise `false`.
     */ containsPoint: function(body, x, y) {
                    body = this.getMatterBodies(body);
                    var position = Vector.create(x, y);
                    var result = Query.point(body, position);
                    return result.length > 0 ? true : false;
                },
                /**
     * Checks the given coordinates to see if any vertices of the given bodies contain it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     * 
     * The coordinates should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use coordinates from another system you may need to
     * transform them before passing them.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectPoint
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies which contain the given point.
     */ intersectPoint: function(x, y, bodies) {
                    bodies = this.getMatterBodies(bodies);
                    var position = Vector.create(x, y);
                    var output = [];
                    var result = Query.point(bodies, position);
                    result.forEach(function(body) {
                        if (output.indexOf(body) === -1) output.push(body);
                    });
                    return output;
                },
                /**
     * Checks the given rectangular area to see if any vertices of the given bodies intersect with it.
     * Or, if the `outside` parameter is set to `true`, it checks to see which bodies do not
     * intersect with it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRect
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the top-left of the area.
     * @param {number} y - The vertical coordinate of the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {boolean} [outside=false] - If `false` it checks for vertices inside the area, if `true` it checks for vertices outside the area.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies that intersect with the given area.
     */ intersectRect: function(x, y, width, height, outside, bodies) {
                    if (outside === undefined) outside = false;
                    bodies = this.getMatterBodies(bodies);
                    var bounds = {
                        min: {
                            x: x,
                            y: y
                        },
                        max: {
                            x: x + width,
                            y: y + height
                        }
                    };
                    var output = [];
                    var result = Query.region(bodies, bounds, outside);
                    result.forEach(function(body) {
                        if (output.indexOf(body) === -1) output.push(body);
                    });
                    return output;
                },
                /**
     * Checks the given ray segment to see if any vertices of the given bodies intersect with it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World.
     * 
     * The width of the ray can be specified via the `rayWidth` parameter.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRay
     * @since 3.22.0
     *
     * @param {number} x1 - The horizontal coordinate of the start of the ray segment.
     * @param {number} y1 - The vertical coordinate of the start of the ray segment.
     * @param {number} x2 - The horizontal coordinate of the end of the ray segment.
     * @param {number} y2 - The vertical coordinate of the end of the ray segment.
     * @param {number} [rayWidth=1] - The width of the ray segment.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with the ray segment.
     */ intersectRay: function(x1, y1, x2, y2, rayWidth, bodies) {
                    if (rayWidth === undefined) rayWidth = 1;
                    bodies = this.getMatterBodies(bodies);
                    var result = [];
                    var collisions = Query.ray(bodies, Vector.create(x1, y1), Vector.create(x2, y2), rayWidth);
                    for(var i = 0; i < collisions.length; i++)result.push(collisions[i].body);
                    return result;
                },
                /**
     * Checks the given Matter Body to see if it intersects with any of the given bodies.
     * 
     * If no bodies are provided it will check against all bodies in the Matter World.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The target body.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check the target body against. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with target body.
     */ intersectBody: function(body, bodies) {
                    bodies = this.getMatterBodies(bodies);
                    var result = [];
                    var collisions = Query.collides(body, bodies);
                    for(var i = 0; i < collisions.length; i++){
                        var pair = collisions[i];
                        if (pair.bodyA === body) result.push(pair.bodyB);
                        else result.push(pair.bodyA);
                    }
                    return result;
                },
                /**
     * Checks to see if the target body, or an array of target bodies, intersects with any of the given bodies.
     * 
     * If intersection occurs this method will return `true` and, if provided, invoke the callbacks.
     * 
     * If no bodies are provided for the second parameter the target will check again all bodies in the Matter World.
     * 
     * Note that bodies can only overlap if they are in non-colliding collision groups or categories.
     * 
     * If you provide a `processCallback` then the two bodies that overlap are sent to it. This callback
     * must return a boolean and is used to allow you to perform additional processing tests before a final
     * outcome is decided. If it returns `true` then the bodies are finally passed to the `overlapCallback`, if set.
     * 
     * If you provide an `overlapCallback` then the matching pairs of overlapping bodies will be sent to it.
     * 
     * Both callbacks have the following signature: `function (bodyA, bodyB, collisionInfo)` where `bodyA` is always
     * the target body. The `collisionInfo` object contains additional data, such as the angle and depth of penetration.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#overlap
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} target - The target body, or array of target bodies, to check.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - The second body, or array of bodies, to check. If falsey it will check against all bodies in the world.
     * @param {ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the bodies overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two bodies if they overlap. If this is set then `overlapCallback` will only be invoked if this callback returns `true`.
     * @param {*} [callbackContext] - The context, or scope, in which to run the callbacks.
     * 
     * @return {boolean} `true` if the target body intersects with _any_ of the bodies given, otherwise `false`.
     */ overlap: function(target, bodies, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    if (!Array.isArray(target)) target = [
                        target
                    ];
                    target = this.getMatterBodies(target);
                    bodies = this.getMatterBodies(bodies);
                    var match = false;
                    for(var i = 0; i < target.length; i++){
                        var entry = target[i];
                        var collisions = Query.collides(entry, bodies);
                        for(var c = 0; c < collisions.length; c++){
                            var info = collisions[c];
                            var bodyB = info.bodyA.id === entry.id ? info.bodyB : info.bodyA;
                            if (!processCallback || processCallback.call(callbackContext, entry, bodyB, info)) {
                                match = true;
                                if (overlapCallback) overlapCallback.call(callbackContext, entry, bodyB, info);
                                else if (!processCallback) //  If there are no callbacks we don't need to test every body, just exit when the first is found
                                return true;
                            }
                        }
                    }
                    return match;
                },
                /**
     * Sets the collision filter category of all given Matter Bodies to the given value.
     * 
     * This number must be a power of two between 2^0 (= 1) and 2^31.
     * 
     * Bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionCategory
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique category bitfield.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionCategory: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        body.collisionFilter.category = value;
                    });
                    return this;
                },
                /**
     * Sets the collision filter group of all given Matter Bodies to the given value.
     * 
     * If the group value is zero, or if two Matter Bodies have different group values,
     * they will collide according to the usual collision filter rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     * 
     * If two Matter Bodies have the same positive group value, they will always collide;
     * if they have the same negative group value they will never collide.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionGroup
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique group index.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionGroup: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        body.collisionFilter.group = value;
                    });
                    return this;
                },
                /**
     * Sets the collision filter mask of all given Matter Bodies to the given value.
     * 
     * Two Matter Bodies with different collision groups will only collide if each one includes the others
     * category in its mask based on a bitwise AND operation: `(categoryA & maskB) !== 0` and 
     * `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollidesWith
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {this} This Matter Physics instance.
     */ setCollidesWith: function(bodies, categories) {
                    bodies = this.getMatterBodies(bodies);
                    var flags = 0;
                    if (!Array.isArray(categories)) flags = categories;
                    else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                    bodies.forEach(function(body) {
                        body.collisionFilter.mask = flags;
                    });
                    return this;
                },
                /**
     * Takes an array and returns a new array made from all of the Matter Bodies found in the original array.
     * 
     * For example, passing in Matter Game Objects, such as a bunch of Matter Sprites, to this method, would
     * return an array containing all of their native Matter Body objects.
     * 
     * If the `bodies` argument is falsey, it will return all bodies in the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getMatterBodies
     * @since 3.22.0
     *
     * @param {array} [bodies] - An array of objects to extract the bodies from. If falsey, it will return all bodies in the world.
     *
     * @return {MatterJS.BodyType[]} An array of native Matter Body objects.
     */ getMatterBodies: function(bodies) {
                    if (!bodies) return this.world.getAllBodies();
                    if (!Array.isArray(bodies)) bodies = [
                        bodies
                    ];
                    var output = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i].hasOwnProperty("body") ? bodies[i].body : bodies[i];
                        output.push(body);
                    }
                    return output;
                },
                /**
     * Sets both the horizontal and vertical linear velocity of the physics bodies.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocity: function(bodies, x, y) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.x = x;
                    vec2.y = y;
                    bodies.forEach(function(body) {
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets just the horizontal linear velocity of the physics bodies.
     * The vertical velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityX
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityX: function(bodies, x) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.x = x;
                    bodies.forEach(function(body) {
                        vec2.y = body.velocity.y;
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets just the vertical linear velocity of the physics bodies.
     * The horizontal velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityY
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityY: function(bodies, y) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.y = y;
                    bodies.forEach(function(body) {
                        vec2.x = body.velocity.x;
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets the angular velocity of the bodies instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setAngularVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - The angular velocity.
     *
     * @return {this} This Matter Physics instance.
     */ setAngularVelocity: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        Body.setAngularVelocity(body, value);
                    });
                    return this;
                },
                /**
     * Applies a force to a body, at the bodies current position, including resulting torque.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForce
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} force - A Vector that specifies the force to apply.
     *
     * @return {this} This Matter Physics instance.
     */ applyForce: function(bodies, force) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        vec2.x = body.position.x;
                        vec2.y = body.position.y;
                        Body.applyForce(body, vec2, force);
                    });
                    return this;
                },
                /**
     * Applies a force to a body, from the given world position, including resulting torque.
     * If no angle is given, the current body angle is used.
     * 
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromPosition
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} position - A Vector that specifies the world-space position to apply the force at.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromPosition: function(bodies, position, speed, angle) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        if (angle === undefined) angle = body.angle;
                        vec2.x = speed * Math.cos(angle);
                        vec2.y = speed * Math.sin(angle);
                        Body.applyForce(body, position, vec2);
                    });
                    return this;
                },
                /**
     * Apply a force to a body based on the given angle and speed.
     * If no angle is given, the current body angle is used.
     * 
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromAngle
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromAngle: function(bodies, speed, angle) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        if (angle === undefined) angle = body.angle;
                        vec2.x = speed * Math.cos(angle);
                        vec2.y = speed * Math.sin(angle);
                        Body.applyForce(body, {
                            x: body.position.x,
                            y: body.position.y
                        }, vec2);
                    });
                    return this;
                },
                /**
     * Returns the length of the given constraint, which is the distance between the two points.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConstraintLength
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The constraint to get the length from.
     *
     * @return {number} The length of the constraint.
     */ getConstraintLength: function(constraint) {
                    var aX = constraint.pointA.x;
                    var aY = constraint.pointA.y;
                    var bX = constraint.pointB.x;
                    var bY = constraint.pointB.y;
                    if (constraint.bodyA) {
                        aX += constraint.bodyA.position.x;
                        aY += constraint.bodyA.position.y;
                    }
                    if (constraint.bodyB) {
                        bX += constraint.bodyB.position.x;
                        bY += constraint.bodyB.position.y;
                    }
                    return DistanceBetween(aX, aY, bX, bY);
                },
                /**
     * Aligns a Body, or Matter Game Object, against the given coordinates.
     * 
     * The alignment takes place using the body bounds, which take into consideration things
     * like body scale and rotation.
     * 
     * Although a Body has a `position` property, it is based on the center of mass for the body,
     * not a dimension based center. This makes aligning bodies difficult, especially if they have
     * rotated or scaled. This method will derive the correct position based on the body bounds and
     * its center of mass offset, in order to align the body with the given coordinate.
     * 
     * For example, if you wanted to align a body so it sat in the bottom-center of the
     * Scene, and the world was 800 x 600 in size:
     * 
     * ```javascript
     * this.matter.alignBody(body, 400, 600, Phaser.Display.Align.BOTTOM_CENTER);
     * ```
     * 
     * You pass in 400 for the x coordinate, because that is the center of the world, and 600 for
     * the y coordinate, as that is the base of the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#alignBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to align.
     * @param {number} x - The horizontal position to align the body to.
     * @param {number} y - The vertical position to align the body to.
     * @param {number} align - One of the `Phaser.Display.Align` constants, such as `Phaser.Display.Align.TOP_LEFT`.
     *
     * @return {this} This Matter Physics instance.
     */ alignBody: function(body, x, y, align) {
                    body = body.hasOwnProperty("body") ? body.body : body;
                    var pos;
                    switch(align){
                        case ALIGN_CONST.TOP_LEFT:
                        case ALIGN_CONST.LEFT_TOP:
                            pos = this.bodyBounds.getTopLeft(body, x, y);
                            break;
                        case ALIGN_CONST.TOP_CENTER:
                            pos = this.bodyBounds.getTopCenter(body, x, y);
                            break;
                        case ALIGN_CONST.TOP_RIGHT:
                        case ALIGN_CONST.RIGHT_TOP:
                            pos = this.bodyBounds.getTopRight(body, x, y);
                            break;
                        case ALIGN_CONST.LEFT_CENTER:
                            pos = this.bodyBounds.getLeftCenter(body, x, y);
                            break;
                        case ALIGN_CONST.CENTER:
                            pos = this.bodyBounds.getCenter(body, x, y);
                            break;
                        case ALIGN_CONST.RIGHT_CENTER:
                            pos = this.bodyBounds.getRightCenter(body, x, y);
                            break;
                        case ALIGN_CONST.LEFT_BOTTOM:
                        case ALIGN_CONST.BOTTOM_LEFT:
                            pos = this.bodyBounds.getBottomLeft(body, x, y);
                            break;
                        case ALIGN_CONST.BOTTOM_CENTER:
                            pos = this.bodyBounds.getBottomCenter(body, x, y);
                            break;
                        case ALIGN_CONST.BOTTOM_RIGHT:
                        case ALIGN_CONST.RIGHT_BOTTOM:
                            pos = this.bodyBounds.getBottomRight(body, x, y);
                            break;
                    }
                    if (pos) Body.setPosition(body, pos);
                    return this;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var eventEmitter = this.systems.events;
                    if (this.world) {
                        eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                        eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    }
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    if (this.add) this.add.destroy();
                    if (this.world) this.world.destroy();
                    this.add = null;
                    this.world = null;
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register("MatterPhysics", MatterPhysics, "matterPhysics");
            module1.exports = MatterPhysics;
        /***/ },
        /* 1525 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = __webpack_require__(594);
            /**
 * An attractors plugin for matter.js.
 * See the readme for usage and examples.
 * @module MatterAttractors
 */ var MatterAttractors = {
                name: "matter-attractors",
                version: "0.1.7",
                for: "matter-js@^0.14.2",
                silent: true,
                // installs the plugin where `base` is `Matter`
                // you should not need to call this directly.
                install: function(base) {
                    base.after("Body.create", function() {
                        MatterAttractors.Body.init(this);
                    });
                    base.before("Engine.update", function(engine) {
                        MatterAttractors.Engine.update(engine);
                    });
                },
                Body: {
                    /**
         * Initialises the `body` to support attractors.
         * This is called automatically by the plugin.
         * @function MatterAttractors.Body.init
         * @param {Matter.Body} body The body to init.
         * @returns {void} No return value.
         */ init: function(body) {
                        body.plugin.attractors = body.plugin.attractors || [];
                    }
                },
                Engine: {
                    /**
         * Applies all attractors for all bodies in the `engine`.
         * This is called automatically by the plugin.
         * @function MatterAttractors.Engine.update
         * @param {Matter.Engine} engine The engine to update.
         * @returns {void} No return value.
         */ update: function(engine) {
                        var bodies = Matter.Composite.allBodies(engine.world);
                        for(var i = 0; i < bodies.length; i++){
                            var bodyA = bodies[i];
                            var attractors = bodyA.plugin.attractors;
                            if (attractors && attractors.length > 0) for(var j = 0; j < bodies.length; j++){
                                var bodyB = bodies[j];
                                if (i !== j) for(var k = 0; k < attractors.length; k++){
                                    var attractor = attractors[k];
                                    var forceVector = attractor;
                                    if (Matter.Common.isFunction(attractor)) forceVector = attractor(bodyA, bodyB);
                                    if (forceVector) Matter.Body.applyForce(bodyB, bodyB.position, forceVector);
                                }
                            }
                        }
                    }
                },
                /**
     * Defines some useful common attractor functions that can be used
     * by pushing them to your body's `body.plugin.attractors` array.
     * @namespace MatterAttractors.Attractors
     * @property {number} gravityConstant The gravitational constant used by the gravity attractor.
     */ Attractors: {
                    gravityConstant: 0.001,
                    /**
         * An attractor function that applies Newton's law of gravitation.
         * Use this by pushing `MatterAttractors.Attractors.gravity` to your body's `body.plugin.attractors` array.
         * The gravitational constant defaults to `0.001` which you can change
         * at `MatterAttractors.Attractors.gravityConstant`.
         * @function MatterAttractors.Attractors.gravity
         * @param {Matter.Body} bodyA The first body.
         * @param {Matter.Body} bodyB The second body.
         * @returns {void} No return value.
         */ gravity: function(bodyA, bodyB) {
                        // use Newton's law of gravitation
                        var bToA = Matter.Vector.sub(bodyB.position, bodyA.position);
                        var distanceSq = Matter.Vector.magnitudeSquared(bToA) || 0.0001;
                        var normal = Matter.Vector.normalise(bToA);
                        var magnitude = -MatterAttractors.Attractors.gravityConstant * (bodyA.mass * bodyB.mass / distanceSq);
                        var force = Matter.Vector.mult(normal, magnitude);
                        // to apply forces to both bodies
                        Matter.Body.applyForce(bodyA, bodyA.position, Matter.Vector.neg(force));
                        Matter.Body.applyForce(bodyB, bodyB.position, force);
                    }
                }
            };
            module1.exports = MatterAttractors;
        /**
 * @namespace Matter.Body
 * @see http://brm.io/matter-js/docs/classes/Body.html
 */ /**
 * This plugin adds a new property `body.plugin.attractors` to instances of `Matter.Body`.
 * This is an array of callback functions that will be called automatically
 * for every pair of bodies, on every engine update.
 * @property {Function[]} body.plugin.attractors
 * @memberof Matter.Body
 */ /**
 * An attractor function calculates the force to be applied
 * to `bodyB`, it should either:
 * - return the force vector to be applied to `bodyB`
 * - or apply the force to the body(s) itself
 * @callback AttractorFunction
 * @param {Matter.Body} bodyA
 * @param {Matter.Body} bodyB
 * @returns {(Vector|undefined)} a force vector (optional)
 */ /***/ },
        /* 1526 */ /***/ function(module1, exports) {
            /**
 * @author       @dxu https://github.com/dxu/matter-collision-events
 * @author       Richard Davey <rich@photonstorm.com>
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MatterCollisionEvents = {
                name: "matter-collision-events",
                version: "0.1.6",
                for: "matter-js@^0.14.2",
                silent: true,
                install: function(matter) {
                    matter.after("Engine.create", function() {
                        matter.Events.on(this, "collisionStart", function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit("collide", bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit("collide", bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, "onCollide", {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, "onCollide", {
                                    pair: pair
                                });
                                if (bodyA.onCollideCallback) bodyA.onCollideCallback(pair);
                                if (bodyB.onCollideCallback) bodyB.onCollideCallback(pair);
                                if (bodyA.onCollideWith[bodyB.id]) bodyA.onCollideWith[bodyB.id](bodyB, pair);
                                if (bodyB.onCollideWith[bodyA.id]) bodyB.onCollideWith[bodyA.id](bodyA, pair);
                            });
                        });
                        matter.Events.on(this, "collisionActive", function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit("collideActive", bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit("collideActive", bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, "onCollideActive", {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, "onCollideActive", {
                                    pair: pair
                                });
                                if (bodyA.onCollideActiveCallback) bodyA.onCollideActiveCallback(pair);
                                if (bodyB.onCollideActiveCallback) bodyB.onCollideActiveCallback(pair);
                            });
                        });
                        matter.Events.on(this, "collisionEnd", function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit("collideEnd", bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit("collideEnd", bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, "onCollideEnd", {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, "onCollideEnd", {
                                    pair: pair
                                });
                                if (bodyA.onCollideEndCallback) bodyA.onCollideEndCallback(pair);
                                if (bodyB.onCollideEndCallback) bodyB.onCollideEndCallback(pair);
                            });
                        });
                    });
                }
            };
            module1.exports = MatterCollisionEvents;
        /***/ },
        /* 1527 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = __webpack_require__(594);
            /**
 * A coordinate wrapping plugin for matter.js.
 * See the readme for usage and examples.
 * @module MatterWrap
 */ var MatterWrap = {
                // plugin meta
                name: "matter-wrap",
                version: "0.1.4",
                for: "matter-js@^0.14.2",
                silent: true,
                // installs the plugin where `base` is `Matter`
                // you should not need to call this directly.
                install: function(base) {
                    base.after("Engine.update", function() {
                        MatterWrap.Engine.update(this);
                    });
                },
                Engine: {
                    /**
     * Updates the engine by wrapping bodies and composites inside `engine.world`.
     * This is called automatically by the plugin.
     * @function MatterWrap.Engine.update
     * @param {Matter.Engine} engine The engine to update.
     * @returns {void} No return value.
     */ update: function(engine) {
                        var world = engine.world, bodies = Matter.Composite.allBodies(world), composites = Matter.Composite.allComposites(world);
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            if (body.plugin.wrap) MatterWrap.Body.wrap(body, body.plugin.wrap);
                        }
                        for(i = 0; i < composites.length; i += 1){
                            var composite = composites[i];
                            if (composite.plugin.wrap) MatterWrap.Composite.wrap(composite, composite.plugin.wrap);
                        }
                    }
                },
                Bounds: {
                    /**
     * Returns a translation vector that wraps the `objectBounds` inside the `bounds`.
     * @function MatterWrap.Bounds.wrap
     * @param {Matter.Bounds} objectBounds The bounds of the object to wrap inside the bounds.
     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
     * @returns {?Matter.Vector} A translation vector (only if wrapping is required).
     */ wrap: function(objectBounds, bounds) {
                        var x = null, y = null;
                        if (typeof bounds.min.x !== "undefined" && typeof bounds.max.x !== "undefined") {
                            if (objectBounds.min.x > bounds.max.x) x = bounds.min.x - objectBounds.max.x;
                            else if (objectBounds.max.x < bounds.min.x) x = bounds.max.x - objectBounds.min.x;
                        }
                        if (typeof bounds.min.y !== "undefined" && typeof bounds.max.y !== "undefined") {
                            if (objectBounds.min.y > bounds.max.y) y = bounds.min.y - objectBounds.max.y;
                            else if (objectBounds.max.y < bounds.min.y) y = bounds.max.y - objectBounds.min.y;
                        }
                        if (x !== null || y !== null) return {
                            x: x || 0,
                            y: y || 0
                        };
                    }
                },
                Body: {
                    /**
     * Wraps the `body` position such that it always stays within the given bounds. 
     * Upon crossing a boundary the body will appear on the opposite side of the bounds, 
     * while maintaining its velocity.
     * This is called automatically by the plugin.
     * @function MatterWrap.Body.wrap
     * @param {Matter.Body} body The body to wrap.
     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ wrap: function(body, bounds) {
                        var translation = MatterWrap.Bounds.wrap(body.bounds, bounds);
                        if (translation) Matter.Body.translate(body, translation);
                        return translation;
                    }
                },
                Composite: {
                    /**
     * Returns the union of the bounds of all of the composite's bodies
     * (not accounting for constraints).
     * @function MatterWrap.Composite.bounds
     * @param {Matter.Composite} composite The composite.
     * @returns {Matter.Bounds} The composite bounds.
     */ bounds: function(composite) {
                        var bodies = Matter.Composite.allBodies(composite), vertices = [];
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            vertices.push(body.bounds.min, body.bounds.max);
                        }
                        return Matter.Bounds.create(vertices);
                    },
                    /**
     * Wraps the `composite` position such that it always stays within the given bounds. 
     * Upon crossing a boundary the composite will appear on the opposite side of the bounds, 
     * while maintaining its velocity.
     * This is called automatically by the plugin.
     * @function MatterWrap.Composite.wrap
     * @param {Matter.Composite} composite The composite to wrap.
     * @param {Matter.Bounds} bounds The bounds to wrap the composite inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ wrap: function(composite, bounds) {
                        var translation = MatterWrap.Bounds.wrap(MatterWrap.Composite.bounds(composite), bounds);
                        if (translation) Matter.Composite.translate(composite, translation);
                        return translation;
                    }
                }
            };
            module1.exports = MatterWrap;
        /**
 * @namespace Matter.Body
 * @see http://brm.io/matter-js/docs/classes/Body.html
 */ /**
 * This plugin adds a new property `body.plugin.wrap` to instances of `Matter.Body`.  
 * This is a `Matter.Bounds` instance that specifies the wrapping region.
 * @property {Matter.Bounds} body.plugin.wrap
 * @memberof Matter.Body
 */ /**
 * This plugin adds a new property `composite.plugin.wrap` to instances of `Matter.Composite`.  
 * This is a `Matter.Bounds` instance that specifies the wrapping region.
 * @property {Matter.Bounds} composite.plugin.wrap
 * @memberof Matter.Composite
 */ /***/ },
        /* 1528 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(global) {
                var CONST = __webpack_require__(33);
                var Extend = __webpack_require__(17);
                /**
 * @namespace Phaser
 */ var Phaser = {
                    Actions: __webpack_require__(275),
                    Animations: __webpack_require__(723),
                    BlendModes: __webpack_require__(35),
                    Cache: __webpack_require__(735),
                    Cameras: __webpack_require__(738),
                    Core: __webpack_require__(806),
                    Class: __webpack_require__(0),
                    Create: __webpack_require__(888),
                    Curves: __webpack_require__(894),
                    Data: __webpack_require__(896),
                    Display: __webpack_require__(898),
                    DOM: __webpack_require__(917),
                    Events: __webpack_require__(918),
                    Game: __webpack_require__(920),
                    GameObjects: __webpack_require__(1011),
                    Geom: __webpack_require__(483),
                    Input: __webpack_require__(1308),
                    Loader: __webpack_require__(1338),
                    Math: __webpack_require__(193),
                    Physics: __webpack_require__(1493),
                    Plugins: __webpack_require__(1403),
                    Renderer: __webpack_require__(1405),
                    Scale: __webpack_require__(1412),
                    ScaleModes: __webpack_require__(168),
                    Scene: __webpack_require__(418),
                    Scenes: __webpack_require__(1413),
                    Structs: __webpack_require__(1415),
                    Textures: __webpack_require__(1416),
                    Tilemaps: __webpack_require__(1418),
                    Time: __webpack_require__(1461),
                    Tweens: __webpack_require__(1463),
                    Utils: __webpack_require__(1481)
                };
                Phaser.Sound = __webpack_require__(1492);
                //   Merge in the consts
                Phaser = Extend(false, Phaser, CONST);
                /**
 * The root types namespace.
 *
 * @namespace Phaser.Types
 * @since 3.17.0
 */ //  Export it
                module1.exports = Phaser;
                global.Phaser = Phaser;
            /*
 * "Documentation is like pizza: when it is good, it is very, very good;
 * and when it is bad, it is better than nothing."
 *  -- Dick Brandon
 */ /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(600));
        /***/ }
    ]);
});


// copy from Phaser.GameObjects.Text
const $be22bc453d6850c5$var$Utils = Phaser.Renderer.WebGL.Utils;
var $be22bc453d6850c5$var$WebGLRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.dirty) {
        src.updateTexture();
        src.dirty = false;
    }
    if (src.width === 0 || src.height === 0) return;
    camera.addToRenderList(src);
    var frame = src.frame;
    var width = frame.width;
    var height = frame.height;
    var getTint = $be22bc453d6850c5$var$Utils.getTintAppendFloatAlpha;
    var pipeline = renderer.pipelines.set(src.pipeline, src);
    var textureUnit = pipeline.setTexture2D(frame.glTexture, src);
    renderer.pipelines.preBatch(src);
    pipeline.batchTexture(src, frame.glTexture, width, height, src.x, src.y, width / src.resolution, height / src.resolution, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, false, textureUnit);
    renderer.pipelines.postBatch(src);
};
var $be22bc453d6850c5$export$2e2bcd8739ae039 = $be22bc453d6850c5$var$WebGLRenderer;


// copy from Phaser.GameObjects.Text
var $7c0e27891f6d2b56$var$CanvasRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.dirty) {
        src.updateTexture();
        src.dirty = false;
    }
    if (src.width === 0 || src.height === 0) return;
    camera.addToRenderList(src);
    renderer.batchSprite(src, src.frame, camera, parentMatrix);
};
var $7c0e27891f6d2b56$export$2e2bcd8739ae039 = $7c0e27891f6d2b56$var$CanvasRenderer;


var $c94368fdf496f8f4$export$2e2bcd8739ae039 = {
    renderWebGL: (0, $be22bc453d6850c5$export$2e2bcd8739ae039),
    renderCanvas: (0, $7c0e27891f6d2b56$export$2e2bcd8739ae039)
};


const $f0661915878f3ab7$var$Color = Phaser.Display.Color;
var $f0661915878f3ab7$export$2e2bcd8739ae039 = {
    clear () {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.dirty = true;
        return this;
    },
    fill (color) {
        this.context.fillStyle = color;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.dirty = true;
        return this;
    },
    drawFrame (key, frame, dx, dy, dWidth, dHeight, sxOffset, syOffset, sWidth, sHeight) {
        var textureFrame = this.scene.sys.textures.getFrame(key, frame);
        if (!textureFrame) return this;
        var frameWidth = textureFrame.cutWidth, frameHeight = textureFrame.cutHeight;
        if (dx === undefined) dx = 0;
        if (dy === undefined) dy = 0;
        if (dWidth === undefined) dWidth = frameWidth;
        if (dHeight === undefined) dHeight = frameHeight;
        if (sxOffset === undefined) sxOffset = 0;
        if (syOffset === undefined) syOffset = 0;
        if (sWidth === undefined) sWidth = frameWidth;
        if (sHeight === undefined) sHeight = frameHeight;
        var sx = textureFrame.cutX + sxOffset;
        var sy = textureFrame.cutY + syOffset;
        this.context.drawImage(textureFrame.source.image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        this.dirty = true;
        return this;
    },
    getDataURL (type, encoderOptions) {
        return this.canvas.toDataURL(type, encoderOptions);
    },
    getPixel (x, y, out) {
        if (out === undefined) out = new $f0661915878f3ab7$var$Color();
        var rgb = this.context.getImageData(x, y, 1, 1);
        out.setTo(rgb.data[0], rgb.data[1], rgb.data[2], rgb.data[3]);
        return out;
    },
    setPixel (x, y, r, g, b, a) {
        if (typeof r !== "number") {
            var color = r;
            r = color.red;
            g = color.green;
            b = color.blue;
            a = color.alpha;
        }
        if (a === undefined) a = r !== 0 || g !== 0 || b !== 0 ? 255 : 0;
        var imgData = this.context.createImageData(1, 1);
        imgData.data[0] = r;
        imgData.data[1] = g;
        imgData.data[2] = b;
        imgData.data[3] = a;
        this.context.putImageData(imgData, x, y);
        this.dirty = true;
        return this;
    }
};


var $54458364436c144b$var$CopyCanvasToTexture = function(scene, srcCanvas, key, x, y, width, height) {
    var textures = scene.sys.textures;
    var renderer = scene.renderer;
    if (x === undefined) x = 0;
    if (y === undefined) y = 0;
    if (width === undefined) width = srcCanvas.width;
    if (height === undefined) height = srcCanvas.height;
    var texture;
    if (textures.exists(key)) texture = textures.get(key);
    else texture = textures.createCanvas(key, width, height);
    var destCanvas = texture.getSourceImage();
    if (destCanvas.width !== width) destCanvas.width = width;
    if (destCanvas.height !== height) destCanvas.height = height;
    var destCtx = destCanvas.getContext("2d", {
        willReadFrequently: true
    });
    destCtx.clearRect(0, 0, width, height);
    destCtx.drawImage(srcCanvas, x, y, width, height);
    if (renderer.gl && texture) renderer.canvasToTexture(destCanvas, texture.source[0].glTexture, true, 0);
};
var $54458364436c144b$export$2e2bcd8739ae039 = $54458364436c144b$var$CopyCanvasToTexture;


var $369e645c177115ec$export$2e2bcd8739ae039 = {
    updateTexture (callback, scope) {
        if (callback) {
            if (scope) callback.call(scope, this.canvas, this.context);
            else callback(this.canvas, this.context);
        }
        if (this.canvas.width !== this.frame.width || this.canvas.height !== this.frame.height) this.frame.setSize(this.canvas.width, this.canvas.height);
        if (this.renderer && this.renderer.gl) {
            this.frame.source.glTexture = this.renderer.canvasToTexture(this.canvas, this.frame.source.glTexture, true);
            this.frame.glTexture = this.frame.source.glTexture;
        }
        this.dirty = false;
        var input = this.input;
        if (input && !input.customHitArea) {
            input.hitArea.width = this.width;
            input.hitArea.height = this.height;
        }
        return this;
    },
    generateTexture (key, x, y, width, height) {
        var srcCanvas = this.canvas;
        if (width === undefined) width = srcCanvas.width;
        else width *= this.resolution;
        if (height === undefined) height = srcCanvas.height;
        else height *= this.resolution;
        (0, $54458364436c144b$export$2e2bcd8739ae039)(this.scene, srcCanvas, key, x, y, width, height);
        return this;
    },
    loadTexture (key, frame) {
        var textureFrame = this.scene.sys.textures.getFrame(key, frame);
        if (!textureFrame) return this;
        if (this.width !== textureFrame.cutWidth || this.height !== textureFrame.cutHeight) this.setSize(textureFrame.cutWidth, textureFrame.cutHeight);
        else this.clear();
        this.drawFrame(key, frame);
        this.dirty = true;
        return this;
    }
};


const $3842bed83c6c142c$var$CanvasPool = Phaser.Display.Canvas.CanvasPool;
const $3842bed83c6c142c$var$GameObject = Phaser.GameObjects.GameObject;
class $3842bed83c6c142c$var$Canvas extends $3842bed83c6c142c$var$GameObject {
    constructor(scene, x, y, width, height){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 1;
        if (height === undefined) height = 1;
        super(scene, "rexCanvas");
        this.renderer = scene.sys.game.renderer;
        this.resolution = 1;
        this._width = width;
        this._height = height;
        width = Math.max(Math.ceil(width * this.resolution), 1);
        height = Math.max(Math.ceil(height * this.resolution), 1);
        this.canvas = $3842bed83c6c142c$var$CanvasPool.create(this, width, height);
        this.context = this.canvas.getContext("2d", {
            willReadFrequently: true
        });
        this.dirty = false;
        this.setPosition(x, y);
        this.setOrigin(0.5, 0.5);
        this.initPipeline();
        this._crop = this.resetCropObject();
        //  Create a Texture for this Text object
        this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
        //  Get the frame
        this.frame = this.texture.get();
        //  Set the resolution
        this.frame.source.resolution = this.resolution;
        if (this.renderer && this.renderer.gl) {
            //  Clear the default 1x1 glTexture, as we override it later
            this.renderer.deleteTexture(this.frame.source.glTexture);
            this.frame.source.glTexture = null;
        }
        this.dirty = true;
    }
    preDestroy() {
        $3842bed83c6c142c$var$CanvasPool.remove(this.canvas);
        this.texture.destroy();
        this.canvas = null;
        this.context = null;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this.setSize(value, this._height);
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this.setSize(this._width, value);
    }
    setCanvasSize(width, height) {
        if (this._width === width && this._height === height) return this;
        this._width = width;
        this._height = height;
        this.updateDisplayOrigin();
        width = Math.max(Math.ceil(width * this.resolution), 1);
        height = Math.max(Math.ceil(height * this.resolution), 1);
        this.canvas.width = width;
        this.canvas.height = height;
        this.frame.setSize(width, height);
        this.dirty = true;
        return this;
    }
    // setSize might be override
    setSize(width, height) {
        this.setCanvasSize(width, height);
        return this;
    }
    get displayWidth() {
        return this.scaleX * this._width;
    }
    set displayWidth(value) {
        this.scaleX = value / this._width;
    }
    get displayHeight() {
        return this.scaleY * this._height;
    }
    set displayHeight(value) {
        this.scaleY = value / this._height;
    }
    setDisplaySize(width, height) {
        this.displayWidth = width;
        this.displayHeight = height;
        return this;
    }
    getCanvas(readOnly) {
        if (!readOnly) this.dirty = true;
        return this.canvas;
    }
    getContext(readOnly) {
        if (!readOnly) this.dirty = true;
        return this.context;
    }
    needRedraw() {
        this.dirty = true;
        return this;
    }
    resize(width, height) {
        this.setSize(width, height);
        return this;
    }
}
const $3842bed83c6c142c$var$Components = Phaser.GameObjects.Components;
Phaser.Class.mixin($3842bed83c6c142c$var$Canvas, [
    $3842bed83c6c142c$var$Components.Alpha,
    $3842bed83c6c142c$var$Components.BlendMode,
    $3842bed83c6c142c$var$Components.Crop,
    $3842bed83c6c142c$var$Components.Depth,
    $3842bed83c6c142c$var$Components.Flip,
    // Components.FX,  // Open for 3.60
    $3842bed83c6c142c$var$Components.GetBounds,
    $3842bed83c6c142c$var$Components.Mask,
    $3842bed83c6c142c$var$Components.Origin,
    $3842bed83c6c142c$var$Components.Pipeline,
    $3842bed83c6c142c$var$Components.ScrollFactor,
    $3842bed83c6c142c$var$Components.Tint,
    $3842bed83c6c142c$var$Components.Transform,
    $3842bed83c6c142c$var$Components.Visible,
    (0, $c94368fdf496f8f4$export$2e2bcd8739ae039),
    (0, $f0661915878f3ab7$export$2e2bcd8739ae039),
    (0, $369e645c177115ec$export$2e2bcd8739ae039)
]);
var $3842bed83c6c142c$export$2e2bcd8739ae039 = $3842bed83c6c142c$var$Canvas;


const $f78f8433559b1e88$var$GetValue = Phaser.Utils.Objects.GetValue;
class $f78f8433559b1e88$var$RoundRectangle {
    constructor(x, y, width, height, radiusConfig){
        if (x === undefined) x = 0;
        if (y === undefined) y = x;
        if (width === undefined) width = 0;
        if (height === undefined) height = 0;
        if (radiusConfig === undefined) radiusConfig = 0;
        this.cornerRadius = {};
        this._width = 0;
        this._height = 0;
        this.setTo(x, y, width, height, radiusConfig);
    }
    setTo(x, y, width, height, radiusConfig) {
        this.setPosition(x, y);
        this.setRadius(radiusConfig);
        this.setSize(width, height);
        return this;
    }
    setPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setRadius(value) {
        if (value === undefined) value = 0;
        this.radius = value;
        return this;
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        return this;
    }
    get minWidth() {
        var radius = this.cornerRadius;
        return Math.max(radius.tl.x + radius.tr.x, radius.bl.x + radius.br.x);
    }
    get minHeight() {
        var radius = this.cornerRadius;
        return Math.max(radius.tl.y + radius.bl.y, radius.tr.y + radius.br.y);
    }
    get width() {
        return this._width;
    }
    set width(value) {
        if (value == null) value = 0;
        this._width = Math.max(value, this.minWidth);
    }
    get height() {
        return this._height;
    }
    set height(value) {
        if (value == null) value = 0;
        this._height = Math.max(value, this.minHeight);
    }
    get radius() {
        var radius = this.cornerRadius;
        return Math.max(radius.tl.x, radius.tl.y, radius.tr.x, radius.tr.y, radius.bl.x, radius.bl.y, radius.br.x, radius.br.y);
    }
    set radius(value) {
        var defaultRadiusX, defaultRadiusY;
        if (typeof value === "number") {
            defaultRadiusX = value;
            defaultRadiusY = value;
        } else {
            defaultRadiusX = $f78f8433559b1e88$var$GetValue(value, "x", 0);
            defaultRadiusY = $f78f8433559b1e88$var$GetValue(value, "y", 0);
        }
        var radius = this.cornerRadius;
        radius.tl = $f78f8433559b1e88$var$GetRadius($f78f8433559b1e88$var$GetValue(value, "tl", undefined), defaultRadiusX, defaultRadiusY);
        radius.tr = $f78f8433559b1e88$var$GetRadius($f78f8433559b1e88$var$GetValue(value, "tr", undefined), defaultRadiusX, defaultRadiusY);
        radius.bl = $f78f8433559b1e88$var$GetRadius($f78f8433559b1e88$var$GetValue(value, "bl", undefined), defaultRadiusX, defaultRadiusY);
        radius.br = $f78f8433559b1e88$var$GetRadius($f78f8433559b1e88$var$GetValue(value, "br", undefined), defaultRadiusX, defaultRadiusY);
    }
    get radiusTL() {
        var radius = this.cornerRadius.tl;
        return Math.max(radius.x, radius.y);
    }
    set radiusTL(value) {
        $f78f8433559b1e88$var$SetRadius(this.cornerRadius.tl, value);
    }
    get radiusTR() {
        var radius = this.cornerRadius.tr;
        return Math.max(radius.x, radius.y);
    }
    set radiusTR(value) {
        $f78f8433559b1e88$var$SetRadius(this.cornerRadius.tr, value);
    }
    get radiusBL() {
        var radius = this.cornerRadius.bl;
        return Math.max(radius.x, radius.y);
    }
    set radiusBL(value) {
        $f78f8433559b1e88$var$SetRadius(this.cornerRadius.bl, value);
    }
    get radiusBR() {
        var radius = this.cornerRadius.br;
        return Math.max(radius.x, radius.y);
    }
    set radiusBR(value) {
        $f78f8433559b1e88$var$SetRadius(this.cornerRadius.br, value);
    }
}
var $f78f8433559b1e88$var$GetRadius = function(radius, defaultRadiusX, defaultRadiusY) {
    if (radius === undefined) radius = {
        x: defaultRadiusX,
        y: defaultRadiusY
    };
    else if (typeof radius === "number") radius = {
        x: radius,
        y: radius
    };
    $f78f8433559b1e88$var$SetConvex(radius);
    return radius;
};
var $f78f8433559b1e88$var$SetRadius = function(radius, value) {
    if (typeof value === "number") {
        radius.x = value;
        radius.y = value;
    } else {
        radius.x = $f78f8433559b1e88$var$GetValue(value, "x", 0);
        radius.y = $f78f8433559b1e88$var$GetValue(value, "y", 0);
    }
    $f78f8433559b1e88$var$SetConvex(radius);
};
var $f78f8433559b1e88$var$SetConvex = function(radius) {
    radius.convex = radius.x >= 0 || radius.y >= 0;
    radius.x = Math.abs(radius.x);
    radius.y = Math.abs(radius.y);
};
var $f78f8433559b1e88$export$2e2bcd8739ae039 = $f78f8433559b1e88$var$RoundRectangle;


const $5627e24e60e2bd67$var$DegToRad = Phaser.Math.DegToRad;
var $5627e24e60e2bd67$var$AddRoundRectanglePath = function(context, x, y, width, height, radiusConfig, iteration) {
    var geom = new (0, $f78f8433559b1e88$export$2e2bcd8739ae039)(x, y, width, height, radiusConfig), minWidth = geom.minWidth, minHeight = geom.minHeight, scaleRX = width >= minWidth ? 1 : width / minWidth, scaleRY = height >= minHeight ? 1 : height / minHeight;
    var cornerRadius = geom.cornerRadius;
    var radius, radiusX, radiusY, centerX, centerY;
    context.save();
    context.beginPath();
    context.translate(x, y);
    // Top-left
    radius = cornerRadius.tl;
    if ($5627e24e60e2bd67$var$IsArcCorner(radius)) {
        radiusX = radius.x * scaleRX;
        radiusY = radius.y * scaleRY;
        if ($5627e24e60e2bd67$var$IsConvexArc(radius)) {
            centerX = radiusX;
            centerY = radiusY;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 180, 270, false, iteration);
        } else {
            centerX = 0;
            centerY = 0;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 90, 0, true, iteration);
        }
    } else context.lineTo(0, 0);
    // Top-right
    radius = cornerRadius.tr;
    if ($5627e24e60e2bd67$var$IsArcCorner(radius)) {
        radiusX = radius.x * scaleRX;
        radiusY = radius.y * scaleRY;
        if ($5627e24e60e2bd67$var$IsConvexArc(radius)) {
            centerX = width - radiusX;
            centerY = radiusY;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 270, 360, false, iteration);
        } else {
            centerX = width;
            centerY = 0;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 180, 90, true, iteration);
        }
    } else context.lineTo(width, 0);
    // Bottom-right
    radius = cornerRadius.br;
    if ($5627e24e60e2bd67$var$IsArcCorner(radius)) {
        radiusX = radius.x * scaleRX;
        radiusY = radius.y * scaleRY;
        if ($5627e24e60e2bd67$var$IsConvexArc(radius)) {
            centerX = width - radiusX;
            centerY = height - radiusY;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 0, 90, false, iteration);
        } else {
            centerX = width;
            centerY = height;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 270, 180, true, iteration);
        }
    } else context.lineTo(width, height);
    // Bottom-left
    radius = cornerRadius.bl;
    if ($5627e24e60e2bd67$var$IsArcCorner(radius)) {
        radiusX = radius.x * scaleRX;
        radiusY = radius.y * scaleRY;
        if ($5627e24e60e2bd67$var$IsConvexArc(radius)) {
            centerX = radiusX;
            centerY = height - radiusY;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 90, 180, false, iteration);
        } else {
            centerX = 0;
            centerY = height;
            $5627e24e60e2bd67$var$ArcTo(context, centerX, centerY, radiusX, radiusY, 360, 270, true, iteration);
        }
    } else context.lineTo(0, height);
    context.closePath();
    context.restore();
};
var $5627e24e60e2bd67$var$IsConvexArc = function(radius) {
    return !radius.hasOwnProperty("convex") || // radius does not have convex property
    radius.convex;
};
var $5627e24e60e2bd67$var$IsArcCorner = function(radius) {
    return radius.x > 0 && radius.y > 0;
};
var $5627e24e60e2bd67$var$ArcTo = function(context, centerX, centerY, radiusX, radiusY, startAngle, endAngle, antiClockWise, iteration) {
    // startAngle, endAngle: 0 ~ 360
    if (antiClockWise && endAngle > startAngle) endAngle -= 360;
    else if (!antiClockWise && endAngle < startAngle) endAngle += 360;
    startAngle = $5627e24e60e2bd67$var$DegToRad(startAngle);
    endAngle = $5627e24e60e2bd67$var$DegToRad(endAngle);
    if (iteration == null) context.ellipse(centerX, centerY, radiusX, radiusY, 0, startAngle, endAngle, antiClockWise);
    else {
        iteration += 1;
        var x, y, angle;
        var step = (endAngle - startAngle) / iteration;
        for(var i = 0; i <= iteration; i++){
            angle = startAngle + step * i;
            x = centerX + radiusX * Math.cos(angle);
            y = centerY + radiusY * Math.sin(angle);
            context.lineTo(x, y);
        }
    }
};
var $5627e24e60e2bd67$export$2e2bcd8739ae039 = $5627e24e60e2bd67$var$AddRoundRectanglePath;


const $1b1f0d179197d128$var$GetValue = Phaser.Utils.Objects.GetValue;
class $1b1f0d179197d128$var$CircleMaskImage extends (0, $3842bed83c6c142c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, key, frame, config){
        super(scene, x, y);
        this.type = "rexCircleMaskImage";
        this.setTexture(key, frame, config);
    }
    setTexture(key, frame, config) {
        if (typeof frame === "object") {
            config = frame;
            frame = undefined;
        }
        if (typeof config === "string") config = {
            maskType: config
        };
        var maskType = $1b1f0d179197d128$var$GetValue(config, "maskType", 0);
        var backgroundColor = $1b1f0d179197d128$var$GetValue(config, "backgroundColor", undefined);
        var strokeColor = $1b1f0d179197d128$var$GetValue(config, "strokeColor", undefined);
        var defaultStrokeWidth = strokeColor != null ? 10 : 0;
        var strokeWidth = $1b1f0d179197d128$var$GetValue(config, "strokeWidth", defaultStrokeWidth);
        if (maskType === undefined) maskType = 0;
        else if (typeof maskType === "string") maskType = $1b1f0d179197d128$var$MASKTYPE[maskType];
        this._textureKey = key;
        this._frameName = frame;
        if (maskType === null) {
            this.loadTexture(key, frame);
            this.dirty = true;
            return this;
        }
        var textureFrame = this.scene.sys.textures.getFrame(key, frame);
        if (!textureFrame) return this;
        // Resize to frame size
        if (textureFrame.cutWidth !== this.width || textureFrame.cutHeight !== this.height) this.setCanvasSize(textureFrame.cutWidth, textureFrame.cutHeight);
        else this.clear();
        var canvas = this.canvas, ctx = this.context;
        var width = canvas.width, height = canvas.height;
        // Fill background
        if (backgroundColor != null) {
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(0, 0, width, height);
        }
        ctx.save();
        ctx.beginPath();
        // Build clip path 
        var halfStrokeLineWidth = strokeWidth / 2;
        switch(maskType){
            case 1:
                var centerX = Math.floor(width / 2);
                var centerY = Math.floor(height / 2);
                var radiusX = centerX - halfStrokeLineWidth;
                var radiusY = centerY - halfStrokeLineWidth;
                ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, 2 * Math.PI);
                break;
            case 2:
                var radiusConfig = $1b1f0d179197d128$var$GetValue(config, "radius", 0);
                var iteration = $1b1f0d179197d128$var$GetValue(config, "iteration", undefined);
                (0, $5627e24e60e2bd67$export$2e2bcd8739ae039)(ctx, halfStrokeLineWidth, halfStrokeLineWidth, width - strokeWidth, height - strokeWidth, radiusConfig, iteration);
                break;
            default:
                var centerX = Math.floor(width / 2);
                var centerY = Math.floor(height / 2);
                var radius = Math.min(centerX, centerY) - halfStrokeLineWidth;
                ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                break;
        }
        // Draw stroke line
        if (strokeColor != null) {
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = strokeWidth;
            ctx.stroke();
        }
        // Clip frame image
        ctx.clip();
        this.loadTexture(key, frame);
        ctx.restore();
        this.dirty = true;
        return this;
    }
    resize(width, height) {
        // Don't draw content again.
        this.setDisplaySize(width, height);
        return this;
    }
}
const $1b1f0d179197d128$var$MASKTYPE = {
    circle: 0,
    ellipse: 1,
    roundRectangle: 2
};
var $1b1f0d179197d128$export$2e2bcd8739ae039 = $1b1f0d179197d128$var$CircleMaskImage;


function $f9adf77afddb686a$export$2e2bcd8739ae039(x, y, key, frame, config) {
    var gameObject = new (0, $1b1f0d179197d128$export$2e2bcd8739ae039)(this.scene, x, y, key, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $6d30d7ab9d2e9503$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $6d30d7ab9d2e9503$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $6d30d7ab9d2e9503$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var key = $6d30d7ab9d2e9503$var$GetAdvancedValue(config, "key", undefined);
    var frame = $6d30d7ab9d2e9503$var$GetAdvancedValue(config, "frame", undefined);
    var gameObject = new (0, $1b1f0d179197d128$export$2e2bcd8739ae039)(this.scene, 0, 0, key, frame, config);
    $6d30d7ab9d2e9503$var$BuildGameObject(this.scene, gameObject, config);
    return gameObject;
}



var $5e5c240d4107cac2$var$IsInValidKey = function(keys) {
    return keys == null || keys === "" || keys.length === 0;
};
var $5e5c240d4107cac2$var$GetEntry = function(target, keys, defaultEntry) {
    var entry = target;
    if ($5e5c240d4107cac2$var$IsInValidKey(keys)) ;
    else {
        if (typeof keys === "string") keys = keys.split(".");
        var key;
        for(var i = 0, cnt = keys.length; i < cnt; i++){
            key = keys[i];
            if (entry[key] == null || typeof entry[key] !== "object") {
                var newEntry;
                if (i === cnt - 1) {
                    if (defaultEntry === undefined) newEntry = {};
                    else newEntry = defaultEntry;
                } else newEntry = {};
                entry[key] = newEntry;
            }
            entry = entry[key];
        }
    }
    return entry;
};
var $5e5c240d4107cac2$var$SetValue = function(target, keys, value, delimiter) {
    if (delimiter === undefined) delimiter = ".";
    // no object
    if (typeof target !== "object") return;
    else if ($5e5c240d4107cac2$var$IsInValidKey(keys)) {
        // don't erase target
        if (value == null) return;
        else if (typeof value === "object") target = value;
    } else {
        if (typeof keys === "string") keys = keys.split(delimiter);
        var lastKey = keys.pop();
        var entry = $5e5c240d4107cac2$var$GetEntry(target, keys);
        entry[lastKey] = value;
    }
    return target;
};
var $5e5c240d4107cac2$export$2e2bcd8739ae039 = $5e5c240d4107cac2$var$SetValue;


class $4ee1eb1018340b71$var$CircleMaskImagePlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexCircleMaskImage", (0, $f9adf77afddb686a$export$2e2bcd8739ae039), (0, $6d30d7ab9d2e9503$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.CircleMaskImage", (0, $1b1f0d179197d128$export$2e2bcd8739ae039));
var $4ee1eb1018340b71$export$2e2bcd8739ae039 = $4ee1eb1018340b71$var$CircleMaskImagePlugin;



var $1e7d39678bf81ea6$var$LineTo = function(x, y, pathData) {
    var cnt = pathData.length;
    if (cnt >= 2) {
        var lastX = pathData[cnt - 2];
        var lastY = pathData[cnt - 1];
        if (x === lastX && y === lastY) return pathData;
    }
    pathData.push(x, y);
    return pathData;
};
var $1e7d39678bf81ea6$export$2e2bcd8739ae039 = $1e7d39678bf81ea6$var$LineTo;



const $1c11e56450824a5f$var$DegToRad = Phaser.Math.DegToRad;
var $1c11e56450824a5f$var$ArcTo = function(centerX, centerY, radiusX, radiusY, startAngle, endAngle, antiClockWise, iteration, pathData) {
    // startAngle, endAngle: 0 ~ 360
    if (antiClockWise && endAngle > startAngle) endAngle -= 360;
    else if (!antiClockWise && endAngle < startAngle) endAngle += 360;
    var deltaAngle = endAngle - startAngle;
    var step = $1c11e56450824a5f$var$DegToRad(deltaAngle) / iteration;
    startAngle = $1c11e56450824a5f$var$DegToRad(startAngle);
    for(var i = 0; i <= iteration; i++){
        var angle = startAngle + step * i;
        var x = centerX + radiusX * Math.cos(angle);
        var y = centerY + radiusY * Math.sin(angle);
        (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(x, y, pathData);
    }
    return pathData;
};
var $1c11e56450824a5f$export$2e2bcd8739ae039 = $1c11e56450824a5f$var$ArcTo;


/*
src: {
    fillColor, 
    fillAlpha, 
    pathData, 
    pathIndexes  // Earcut(pathData)
}
*/ var $a0d79412d6a22091$var$Utils = Phaser.Renderer.WebGL.Utils;
var $a0d79412d6a22091$var$FillPathWebGL = function(pipeline, calcMatrix, src, alpha, dx, dy) {
    var fillTintColor = $a0d79412d6a22091$var$Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
    var path = src.pathData;
    var pathIndexes = src.pathIndexes;
    for(var i = 0; i < pathIndexes.length; i += 3){
        var p0 = pathIndexes[i] * 2;
        var p1 = pathIndexes[i + 1] * 2;
        var p2 = pathIndexes[i + 2] * 2;
        var x0 = path[p0 + 0] - dx;
        var y0 = path[p0 + 1] - dy;
        var x1 = path[p1 + 0] - dx;
        var y1 = path[p1 + 1] - dy;
        var x2 = path[p2 + 0] - dx;
        var y2 = path[p2 + 1] - dy;
        var tx0 = calcMatrix.getX(x0, y0);
        var ty0 = calcMatrix.getY(x0, y0);
        var tx1 = calcMatrix.getX(x1, y1);
        var ty1 = calcMatrix.getY(x1, y1);
        var tx2 = calcMatrix.getX(x2, y2);
        var ty2 = calcMatrix.getY(x2, y2);
        pipeline.batchTri(src, tx0, ty0, tx1, ty1, tx2, ty2, 0, 0, 1, 1, fillTintColor, fillTintColor, fillTintColor, 2);
    }
};
var $a0d79412d6a22091$export$2e2bcd8739ae039 = $a0d79412d6a22091$var$FillPathWebGL;


/*
src: {
    strokeColor,
    strokeAlpha,
    pathData,
    lineWidth,
    closePath
}
*/ var $5c58a174c1ab3565$var$Utils = Phaser.Renderer.WebGL.Utils;
var $5c58a174c1ab3565$var$StrokePathWebGL = function(pipeline, src, alpha, dx, dy) {
    var strokeTint = pipeline.strokeTint;
    var strokeTintColor = $5c58a174c1ab3565$var$Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
    strokeTint.TL = strokeTintColor;
    strokeTint.TR = strokeTintColor;
    strokeTint.BL = strokeTintColor;
    strokeTint.BR = strokeTintColor;
    var path = src.pathData;
    var pathLength = path.length - 1;
    var lineWidth = src.lineWidth;
    var halfLineWidth = lineWidth / 2;
    var px1 = path[0] - dx;
    var py1 = path[1] - dy;
    if (!src.closePath) pathLength -= 2;
    for(var i = 2; i < pathLength; i += 2){
        var px2 = path[i] - dx;
        var py2 = path[i + 1] - dy;
        pipeline.batchLine(px1, py1, px2, py2, halfLineWidth, halfLineWidth, lineWidth, i - 2, src.closePath ? i === pathLength - 1 : false);
        px1 = px2;
        py1 = py2;
    }
};
var $5c58a174c1ab3565$export$2e2bcd8739ae039 = $5c58a174c1ab3565$var$StrokePathWebGL;


const $052b92f8b1dffd7d$var$GetCalcMatrix = Phaser.GameObjects.GetCalcMatrix;
var $052b92f8b1dffd7d$var$PolygonWebGLRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.dirty) {
        src.updateData();
        src.dirty = false;
    }
    camera.addToRenderList(src);
    var pipeline = renderer.pipelines.set(src.pipeline);
    var result = $052b92f8b1dffd7d$var$GetCalcMatrix(src, camera, parentMatrix);
    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
    var dx = src._displayOriginX;
    var dy = src._displayOriginY;
    var alpha = camera.alpha * src.alpha;
    renderer.pipelines.preBatch(src);
    if (src.isFilled) (0, $a0d79412d6a22091$export$2e2bcd8739ae039)(pipeline, calcMatrix, src, alpha, dx, dy);
    if (src.isStroked) (0, $5c58a174c1ab3565$export$2e2bcd8739ae039)(pipeline, src, alpha, dx, dy);
    renderer.pipelines.postBatch(src);
};
var $052b92f8b1dffd7d$export$2e2bcd8739ae039 = $052b92f8b1dffd7d$var$PolygonWebGLRenderer;


var $2669e1c300ac8e45$var$FillStyleCanvas = function(ctx, src, altColor, altAlpha) {
    var fillColor = altColor ? altColor : src.fillColor;
    var fillAlpha = altAlpha ? altAlpha : src.fillAlpha;
    var red = (fillColor & 0xFF0000) >>> 16;
    var green = (fillColor & 0xFF00) >>> 8;
    var blue = fillColor & 0xFF;
    ctx.fillStyle = "rgba(" + red + "," + green + "," + blue + "," + fillAlpha + ")";
};
var $2669e1c300ac8e45$export$2e2bcd8739ae039 = $2669e1c300ac8e45$var$FillStyleCanvas;


var $dafcb0d30a33b02c$var$LineStyleCanvas = function(ctx, src, altColor, altAlpha) {
    var strokeColor = altColor ? altColor : src.strokeColor;
    var strokeAlpha = altAlpha ? altAlpha : src.strokeAlpha;
    var red = (strokeColor & 0xFF0000) >>> 16;
    var green = (strokeColor & 0xFF00) >>> 8;
    var blue = strokeColor & 0xFF;
    ctx.strokeStyle = "rgba(" + red + "," + green + "," + blue + "," + strokeAlpha + ")";
    ctx.lineWidth = src.lineWidth;
};
var $dafcb0d30a33b02c$export$2e2bcd8739ae039 = $dafcb0d30a33b02c$var$LineStyleCanvas;


const $d4d61dcae3a7c324$var$SetTransform = Phaser.Renderer.Canvas.SetTransform;
var $d4d61dcae3a7c324$var$PolygonCanvasRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.dirty) {
        src.updateData();
        src.dirty = false;
    }
    camera.addToRenderList(src);
    var ctx = renderer.currentContext;
    if ($d4d61dcae3a7c324$var$SetTransform(renderer, ctx, src, camera, parentMatrix)) {
        var dx = src._displayOriginX;
        var dy = src._displayOriginY;
        var path = src.pathData;
        var pathLength = path.length - 1;
        var px1 = path[0] - dx;
        var py1 = path[1] - dy;
        ctx.beginPath();
        ctx.moveTo(px1, py1);
        if (!src.closePath) pathLength -= 2;
        for(var i = 2; i < pathLength; i += 2){
            var px2 = path[i] - dx;
            var py2 = path[i + 1] - dy;
            ctx.lineTo(px2, py2);
        }
        ctx.closePath();
        if (src.isFilled) {
            (0, $2669e1c300ac8e45$export$2e2bcd8739ae039)(ctx, src);
            ctx.fill();
        }
        if (src.isStroked) {
            (0, $dafcb0d30a33b02c$export$2e2bcd8739ae039)(ctx, src);
            ctx.stroke();
        }
        //  Restore the context saved in SetTransform
        ctx.restore();
    }
};
var $d4d61dcae3a7c324$export$2e2bcd8739ae039 = $d4d61dcae3a7c324$var$PolygonCanvasRenderer;


var $1f7602a64beea091$export$2e2bcd8739ae039 = {
    renderWebGL: (0, $052b92f8b1dffd7d$export$2e2bcd8739ae039),
    renderCanvas: (0, $d4d61dcae3a7c324$export$2e2bcd8739ae039)
};


const $26b7b1c524f62b32$var$Shape = Phaser.GameObjects.Shape;
const $26b7b1c524f62b32$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $26b7b1c524f62b32$var$GetValue = Phaser.Utils.Objects.GetValue;
const $26b7b1c524f62b32$var$Earcut = Phaser.Geom.Polygon.Earcut;
class $26b7b1c524f62b32$var$RoundRectangle extends $26b7b1c524f62b32$var$Shape {
    constructor(scene, x, y, width, height, radiusConfig, fillColor, fillAlpha){
        var strokeColor, strokeAlpha, strokeWidth, shapeType;
        if ($26b7b1c524f62b32$var$IsPlainObject(x)) {
            var config = x;
            x = config.x;
            y = config.y;
            width = config.width;
            height = config.height;
            radiusConfig = config.radius;
            fillColor = config.color;
            fillAlpha = config.alpha;
            strokeColor = config.strokeColor;
            strokeAlpha = config.strokeAlpha;
            strokeWidth = config.strokeWidth;
            shapeType = config.shape;
        }
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 1;
        if (height === undefined) height = width;
        if (radiusConfig === undefined) radiusConfig = 0;
        if (shapeType === undefined) shapeType = 0;
        var geom = new (0, $f78f8433559b1e88$export$2e2bcd8739ae039)(); // Configurate it later
        super(scene, "rexRoundRectangleShape", geom);
        this.setShapeType(shapeType);
        if (this.shapeType === 0) {
            var radius = $26b7b1c524f62b32$var$GetValue(radiusConfig, "radius", radiusConfig);
            geom.setTo(0, 0, width, height, radius);
        } else {
            var radius = {
                x: width / 2,
                y: height / 2
            };
            geom.setTo(0, 0, width, height, radius);
        }
        var iteration = $26b7b1c524f62b32$var$GetValue(radiusConfig, "iteration", undefined);
        this.setIteration(iteration);
        this.setPosition(x, y);
        this.setFillStyle(fillColor, fillAlpha);
        if (strokeColor !== undefined && strokeWidth === undefined) strokeWidth = 2;
        this.setStrokeStyle(strokeWidth, strokeColor, strokeAlpha);
        this.updateDisplayOrigin();
        this.dirty = true;
    }
    get fillColor() {
        return this._fillColor;
    }
    set fillColor(value) {
        this._fillColor = value;
        this.isFilled = value != null && this._fillAlpha > 0;
    }
    get fillAlpha() {
        return this._fillAlpha;
    }
    set fillAlpha(value) {
        this._fillAlpha = value;
        this.isFilled = value > 0 && this._fillColor != null;
    }
    // Fully override setFillStyle method
    setFillStyle(color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.fillColor = color;
        this.fillAlpha = alpha;
        return this;
    }
    get strokeColor() {
        return this._strokeColor;
    }
    set strokeColor(value) {
        this._strokeColor = value;
        this.isStroked = value != null && this._lineWidth > 0;
    }
    get lineWidth() {
        return this._lineWidth;
    }
    set lineWidth(value) {
        this._lineWidth = value;
        this.isStroked = value > 0 && this._strokeColor != null;
    }
    // Fully override setStrokeStyle method
    setStrokeStyle(lineWidth, color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.lineWidth = lineWidth;
        this.strokeColor = color;
        this.strokeAlpha = alpha;
        return this;
    }
    updateData() {
        var geom = this.geom;
        var pathData = this.pathData;
        pathData.length = 0;
        var width = geom.width, height = geom.height, cornerRadius = geom.cornerRadius, radius, iteration = this.iteration + 1;
        // Top-left
        radius = cornerRadius.tl;
        if ($26b7b1c524f62b32$var$IsArcCorner(radius)) {
            if (radius.convex) {
                var centerX = radius.x;
                var centerY = radius.y;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 180, 270, false, iteration, pathData);
            } else {
                var centerX = 0;
                var centerY = 0;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 90, 0, true, iteration, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(0, 0, pathData);
        // Top-right
        radius = cornerRadius.tr;
        if ($26b7b1c524f62b32$var$IsArcCorner(radius)) {
            if (radius.convex) {
                var centerX = width - radius.x;
                var centerY = radius.y;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 270, 360, false, iteration, pathData);
            } else {
                var centerX = width;
                var centerY = 0;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 180, 90, true, iteration, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(width, 0, pathData);
        // Bottom-right
        radius = cornerRadius.br;
        if ($26b7b1c524f62b32$var$IsArcCorner(radius)) {
            if (radius.convex) {
                var centerX = width - radius.x;
                var centerY = height - radius.y;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 0, 90, false, iteration, pathData);
            } else {
                var centerX = width;
                var centerY = height;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 270, 180, true, iteration, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(width, height, pathData);
        // Bottom-left
        radius = cornerRadius.bl;
        if ($26b7b1c524f62b32$var$IsArcCorner(radius)) {
            if (radius.convex) {
                var centerX = radius.x;
                var centerY = height - radius.y;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 90, 180, false, iteration, pathData);
            } else {
                var centerX = 0;
                var centerY = height;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius.x, radius.y, 360, 270, true, iteration, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(0, height, pathData);
        pathData.push(pathData[0], pathData[1]); // Repeat first point to close curve
        this.pathIndexes = $26b7b1c524f62b32$var$Earcut(pathData);
        return this;
    }
    setShapeType(shapeType) {
        if (typeof shapeType === "string") shapeType = $26b7b1c524f62b32$var$ShapeTypeMap[shapeType];
        this.shapeType = shapeType;
        return this;
    }
    get width() {
        return this.geom.width;
    }
    set width(value) {
        this.resize(value, this.height);
    }
    get height() {
        return this.geom.height;
    }
    set height(value) {
        this.resize(this.width, value);
    }
    setSize(width, height) {
        // Override Shape's setSize method
        if (height === undefined) height = width;
        if (this.geom.width === width && this.geom.height === height) return this;
        this.geom.setSize(width, height);
        if (this.shapeType === 1) this.setRadius({
            x: width / 2,
            y: height / 2
        });
        this.updateDisplayOrigin();
        this.dirty = true;
        var input = this.input;
        if (input && !input.customHitArea) {
            input.hitArea.width = width;
            input.hitArea.height = height;
        }
        return this;
    }
    resize(width, height) {
        this.setSize(width, height);
        return this;
    }
    get radius() {
        return this.geom.radius;
    }
    set radius(value) {
        this.geom.setRadius(value);
        this.updateDisplayOrigin();
        this.dirty = true;
    }
    get radiusTL() {
        return this.geom.radiusTL;
    }
    set radiusTL(value) {
        this.geom.radiusTL = value;
        this.dirty = true;
    }
    get radiusTR() {
        return this.geom.radiusTR;
    }
    set radiusTR(value) {
        this.geom.radiusTR = value;
        this.dirty = true;
    }
    get radiusBL() {
        return this.geom.radiusBL;
    }
    set radiusBL(value) {
        this.geom.radiusBL = value;
        this.dirty = true;
    }
    get radiusBR() {
        return this.geom.radiusBR;
    }
    set radiusBR(value) {
        this.geom.radiusBR = value;
        this.dirty = true;
    }
    setRadius(value) {
        if (value === undefined) value = 0;
        this.radius = value;
        return this;
    }
    setRadiusTL(value) {
        if (value === undefined) value = 0;
        this.radiusTL = value;
        return this;
    }
    setRadiusTR(value) {
        if (value === undefined) value = 0;
        this.radiusTR = value;
        return this;
    }
    setRadiusBL(value) {
        if (value === undefined) value = 0;
        this.radiusBL = value;
        return this;
    }
    setRadiusBR(value) {
        if (value === undefined) value = 0;
        this.radiusBR = value;
        return this;
    }
    get cornerRadius() {
        return this.geom.cornerRadius;
    }
    set cornerRadius(value) {
        this.radius = value;
    }
    setCornerRadius(value) {
        return this.setRadius(value);
    }
    get iteration() {
        return this._iteration;
    }
    set iteration(value) {
        // Set iteration first time
        if (this._iteration === undefined) {
            this._iteration = value;
            return;
        }
        // Change iteration value
        if (this._iteration === value) return;
        this._iteration = value;
        this.dirty = true;
    }
    setIteration(iteration) {
        if (iteration === undefined) iteration = 6;
        this.iteration = iteration;
        return this;
    }
}
var $26b7b1c524f62b32$var$IsArcCorner = function(radius) {
    return radius.x > 0 && radius.y > 0;
};
const $26b7b1c524f62b32$var$ShapeTypeMap = {
    rectangle: 0,
    circle: 1
};
Object.assign($26b7b1c524f62b32$var$RoundRectangle.prototype, (0, $1f7602a64beea091$export$2e2bcd8739ae039));
var $26b7b1c524f62b32$export$2e2bcd8739ae039 = $26b7b1c524f62b32$var$RoundRectangle;


function $e78591ab1ba4730e$export$2e2bcd8739ae039(x, y, width, height, radiusConfig, fillColor, fillAlpha) {
    var gameObject = new (0, $26b7b1c524f62b32$export$2e2bcd8739ae039)(this.scene, x, y, width, height, radiusConfig, fillColor, fillAlpha);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $89e85ec95ab75c2d$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $89e85ec95ab75c2d$var$GetValue = Phaser.Utils.Objects.GetValue;
const $89e85ec95ab75c2d$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $89e85ec95ab75c2d$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var width = $89e85ec95ab75c2d$var$GetAdvancedValue(config, "width", undefined);
    var height = $89e85ec95ab75c2d$var$GetAdvancedValue(config, "height", width);
    var radiusConfig = $89e85ec95ab75c2d$var$GetValue(config, "radius", undefined);
    var fillColor = $89e85ec95ab75c2d$var$GetAdvancedValue(config, "fillColor", undefined);
    var fillAlpha = $89e85ec95ab75c2d$var$GetAdvancedValue(config, "fillAlpha", undefined);
    var gameObject = new (0, $26b7b1c524f62b32$export$2e2bcd8739ae039)(this.scene, 0, 0, width, height, radiusConfig, fillColor, fillAlpha);
    $89e85ec95ab75c2d$var$BuildGameObject(this.scene, gameObject, config);
    return gameObject;
}




class $91bb69ca4812315d$var$RoundRectanglePlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexRoundRectangle", (0, $e78591ab1ba4730e$export$2e2bcd8739ae039), (0, $89e85ec95ab75c2d$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.RoundRectangle", (0, $26b7b1c524f62b32$export$2e2bcd8739ae039));
var $91bb69ca4812315d$export$2e2bcd8739ae039 = $91bb69ca4812315d$var$RoundRectanglePlugin;


const $99f04f9ac16407e6$var$Zone = Phaser.GameObjects.Zone;
const $99f04f9ac16407e6$var$AddItem = Phaser.Utils.Array.Add;
const $99f04f9ac16407e6$var$RemoveItem = Phaser.Utils.Array.Remove;
class $99f04f9ac16407e6$var$Base extends $99f04f9ac16407e6$var$Zone {
    constructor(scene, x, y, width, height){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 1;
        if (height === undefined) height = 1;
        super(scene, x, y, width, height);
        this.children = [];
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (fromScene) {
            // Stop scene
            var child;
            for(var i = this.children.length - 1; i >= 0; i--){
                child = this.children[i];
                if (!child.parentContainer && // Not in container
                !child.displayList // Not in scene, neither in layer
                ) // Destroy child which is not in scene, container, or layer manually
                child.destroy(fromScene);
            }
        }
        // Destroy/remove children
        this.clear(!fromScene);
        super.destroy(fromScene);
    }
    contains(gameObject) {
        return this.children.indexOf(gameObject) !== -1;
    }
    add(gameObjects) {
        var parent = this;
        $99f04f9ac16407e6$var$AddItem(this.children, gameObjects, 0, // Callback of item added
        function(gameObject) {
            gameObject.once("destroy", parent.onChildDestroy, parent);
        }, this);
        return this;
    }
    remove(gameObjects, destroyChild) {
        var parent = this;
        $99f04f9ac16407e6$var$RemoveItem(this.children, gameObjects, // Callback of item removed
        function(gameObject) {
            gameObject.off("destroy", parent.onChildDestroy, parent);
            if (destroyChild) gameObject.destroy();
        });
        return this;
    }
    onChildDestroy(child, fromScene) {
        // Only remove reference
        this.remove(child, false);
    }
    clear(destroyChild) {
        var parent = this;
        var gameObject;
        for(var i = 0, cnt = this.children.length; i < cnt; i++){
            gameObject = this.children[i];
            gameObject.off("destroy", parent.onChildDestroy, parent);
            if (destroyChild) gameObject.destroy();
        }
        this.children.length = 0;
        return this;
    }
}
const $99f04f9ac16407e6$var$Components = Phaser.GameObjects.Components;
Phaser.Class.mixin($99f04f9ac16407e6$var$Base, [
    $99f04f9ac16407e6$var$Components.Alpha,
    $99f04f9ac16407e6$var$Components.Flip
]);
var $99f04f9ac16407e6$export$2e2bcd8739ae039 = $99f04f9ac16407e6$var$Base;


var $b14a503379e18b6f$export$b9fe6ae6245f98f4 = function(gameObject, name) {
    var parent;
    if (name === undefined) {
        if (gameObject.hasOwnProperty("rexContainer")) parent = gameObject.rexContainer.parent;
    } else {
        parent = $b14a503379e18b6f$export$b9fe6ae6245f98f4(gameObject);
        while(parent){
            if (parent.name === name) break;
            parent = $b14a503379e18b6f$export$b9fe6ae6245f98f4(parent);
        }
    }
    return parent;
};
var $b14a503379e18b6f$export$ebf2fa9b80324b88 = function(gameObject) {
    var parent = $b14a503379e18b6f$export$b9fe6ae6245f98f4(gameObject);
    while(parent){
        gameObject = parent;
        parent = $b14a503379e18b6f$export$b9fe6ae6245f98f4(parent);
    }
    return gameObject;
};


const $29bd99d178520224$var$DegToRad = Phaser.Math.DegToRad;
const $29bd99d178520224$var$RadToDeg = Phaser.Math.RadToDeg;
var $29bd99d178520224$var$GetLocalState = function(gameObject) {
    if (!gameObject.hasOwnProperty("rexContainer")) {
        var rexContainer = {
            parent: null,
            self: null,
            layer: null,
            x: 0,
            y: 0,
            syncPosition: true,
            rotation: 0,
            syncRotation: true,
            scaleX: 0,
            scaleY: 0,
            syncScale: true,
            alpha: 0,
            syncAlpha: true,
            visible: true,
            active: true
        };
        Object.defineProperty(rexContainer, "angle", {
            get: function() {
                return $29bd99d178520224$var$RadToDeg(this.rotation);
            },
            set: function(value) {
                this.rotation = $29bd99d178520224$var$DegToRad(value);
            }
        });
        Object.defineProperty(rexContainer, "displayWidth", {
            get: function() {
                return gameObject.width * this.scaleX;
            },
            set: function(width) {
                this.scaleX = width / gameObject.width;
            }
        });
        Object.defineProperty(rexContainer, "displayHeight", {
            get: function() {
                return gameObject.height * this.scaleY;
            },
            set: function(height) {
                this.scaleY = height / gameObject.height;
            }
        });
        gameObject.rexContainer = rexContainer;
    }
    return gameObject.rexContainer;
};
var $29bd99d178520224$export$2e2bcd8739ae039 = $29bd99d178520224$var$GetLocalState;


var $9a7c75412864ae65$export$2e2bcd8739ae039 = {
    setParent (gameObject, parent) {
        if (parent === undefined) parent = this;
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
        if (parent) {
            localState.parent = parent;
            localState.self = gameObject;
        } else {
            localState.parent = null;
            localState.self = null;
        }
        return this;
    },
    getParent (gameObject, name) {
        if (typeof gameObject === "string") {
            name = gameObject;
            gameObject = undefined;
        }
        if (gameObject === undefined) gameObject = this;
        return (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(gameObject, name);
    },
    getTopmostParent (gameObject) {
        if (gameObject === undefined) gameObject = this;
        return (0, $b14a503379e18b6f$export$ebf2fa9b80324b88)(gameObject);
    }
};




const $3149070c0f8b37c4$var$GetValue = Phaser.Utils.Objects.GetValue;
const $3149070c0f8b37c4$var$BaseAdd = (0, $99f04f9ac16407e6$export$2e2bcd8739ae039).prototype.add;
var $3149070c0f8b37c4$var$Add = function(gameObject, config) {
    this.setParent(gameObject);
    var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
    $3149070c0f8b37c4$var$SetupSyncFlags(state, config);
    this.resetChildState(gameObject) // Reset local state of child
    .updateChildVisible(gameObject) // Apply parent's visible to child
    .updateChildActive(gameObject) // Apply parent's active to child
    .updateChildScrollFactor(gameObject) // Apply parent's scroll factor to child
    .updateChildMask(gameObject); // Apply parent's mask to child
    $3149070c0f8b37c4$var$BaseAdd.call(this, gameObject);
    this.addToParentContainer(gameObject);
    this.addToRenderLayer(gameObject);
    return this;
};
var $3149070c0f8b37c4$var$AddLocal = function(gameObject, config) {
    this.setParent(gameObject);
    // Set local state from child directly
    var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
    $3149070c0f8b37c4$var$SetupSyncFlags(state, config);
    // Position
    state.x = gameObject.x;
    state.y = gameObject.y;
    state.rotation = gameObject.rotation;
    state.scaleX = gameObject.scaleX;
    state.scaleY = gameObject.scaleY;
    // Alpha
    state.alpha = gameObject.alpha;
    // Visible
    state.visible = gameObject.visible;
    // Active
    state.active = gameObject.active;
    this.updateChildPosition(gameObject).updateChildAlpha(gameObject).updateChildVisible(gameObject) // Apply parent's visible to child
    .updateChildActive(gameObject) // Apply parent's active to child
    .updateChildScrollFactor(gameObject) // Apply parent's scroll factor to child
    .updateChildMask(gameObject); // Apply parent's mask to child
    $3149070c0f8b37c4$var$BaseAdd.call(this, gameObject);
    this.addToRenderLayer(gameObject);
    return this;
};
var $3149070c0f8b37c4$var$SetupSyncFlags = function(state, config) {
    if (config === undefined) config = true;
    if (typeof config === "boolean") {
        state.syncPosition = config;
        state.syncRotation = config;
        state.syncScale = config;
        state.syncAlpha = config;
        state.syncScrollFactor = config;
    } else {
        state.syncPosition = $3149070c0f8b37c4$var$GetValue(config, "syncPosition", true);
        state.syncRotation = $3149070c0f8b37c4$var$GetValue(config, "syncRotation", true);
        state.syncScale = $3149070c0f8b37c4$var$GetValue(config, "syncScale", true);
        state.syncAlpha = $3149070c0f8b37c4$var$GetValue(config, "syncAlpha", true);
        state.syncScrollFactor = $3149070c0f8b37c4$var$GetValue(config, "syncScrollFactor", true);
    }
};
var $3149070c0f8b37c4$export$2e2bcd8739ae039 = {
    // Can override this method
    add (gameObject) {
        if (Array.isArray(gameObject)) this.addMultiple(gameObject);
        else $3149070c0f8b37c4$var$Add.call(this, gameObject);
        return this;
    },
    // Don't override this method
    pin (gameObject, config) {
        if (Array.isArray(gameObject)) this.addMultiple(gameObject, config);
        else $3149070c0f8b37c4$var$Add.call(this, gameObject, config);
        return this;
    },
    addMultiple (gameObjects) {
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$3149070c0f8b37c4$var$Add.call(this, gameObjects[i]);
        return this;
    },
    addLocal (gameObject) {
        if (Array.isArray(gameObject)) this.addMultiple(gameObject);
        else $3149070c0f8b37c4$var$AddLocal.call(this, gameObject);
        return this;
    },
    // Don't override this method
    pinLocal (gameObject, config) {
        if (Array.isArray(gameObject)) this.addMultiple(gameObject, config);
        else $3149070c0f8b37c4$var$AddLocal.call(this, gameObject, config);
        return this;
    },
    addLocalMultiple (gameObjects) {
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$3149070c0f8b37c4$var$AddLocal.call(this, gameObjects[i]);
        return this;
    }
};




const $9d8512674a134b95$var$BaseRemove = (0, $99f04f9ac16407e6$export$2e2bcd8739ae039).prototype.remove;
const $9d8512674a134b95$var$BaseClear = (0, $99f04f9ac16407e6$export$2e2bcd8739ae039).prototype.clear;
var $9d8512674a134b95$export$2e2bcd8739ae039 = {
    // Can override this method
    remove (gameObject, destroyChild) {
        if ((0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(gameObject) !== this) return this;
        this.setParent(gameObject, null);
        if (!destroyChild) this.removeFromRenderLayer(gameObject);
        $9d8512674a134b95$var$BaseRemove.call(this, gameObject, destroyChild);
        return this;
    },
    // Don't override this method
    unpin (gameObject, destroyChild) {
        if ((0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(gameObject) !== this) return this;
        this.setParent(gameObject, null);
        if (!destroyChild) this.removeFromRenderLayer(gameObject);
        $9d8512674a134b95$var$BaseRemove.call(this, gameObject, destroyChild);
        return this;
    },
    clear (destroyChild) {
        var children = this.children;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            var child = children[i];
            this.setParent(child, null);
            if (!destroyChild) this.removeFromRenderLayer(child);
        }
        $9d8512674a134b95$var$BaseClear.call(this, destroyChild);
        return this;
    }
};



var $78a91ecfb88b3636$export$2e2bcd8739ae039 = {
    getLocalState (gameObject) {
        return (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
    },
    resetChildState (gameObject) {
        this.resetChildPositionState(gameObject).resetChildVisibleState(gameObject).resetChildAlphaState(gameObject).resetChildActiveState(gameObject);
        return this;
    },
    resetChildrenState (gameObjects) {
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)this.resetChildState(gameObjects[i]);
        return this;
    },
    syncProperties () {
        this.syncPosition().syncVisible().syncAlpha().syncActive().syncScrollFactor().syncMask();
        return this;
    }
};


const $ae69f7d3fd8535d1$var$RotateAround = Phaser.Math.RotateAround;
var $ae69f7d3fd8535d1$export$2e2bcd8739ae039 = {
    worldToLocal (point) {
        // Transform
        point.x -= this.x;
        point.y -= this.y;
        // Rotate
        $ae69f7d3fd8535d1$var$RotateAround(point, 0, 0, -this.rotation);
        // Scale
        point.x /= this.scaleX;
        point.y /= this.scaleY;
        return point;
    },
    localToWorld (point) {
        // Scale
        point.x *= this.scaleX;
        point.y *= this.scaleY;
        // Rotate
        $ae69f7d3fd8535d1$var$RotateAround(point, 0, 0, this.rotation);
        // Transform
        point.x += this.x;
        point.y += this.y;
        return point;
    }
};



var $7d55ca19989e4e3c$var$GetScale = function(a, b) {
    if (a === b) return 1;
    else return a / b;
};
var $7d55ca19989e4e3c$export$2e2bcd8739ae039 = $7d55ca19989e4e3c$var$GetScale;


var $4a085b1051fbc47c$export$2e2bcd8739ae039 = {
    updateChildPosition (child) {
        if (child.isRexContainerLite) child.syncChildrenEnable = false;
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        if (state.syncPosition) {
            child.x = state.x;
            child.y = state.y;
            parent.localToWorld(child);
        }
        if (state.syncRotation) child.rotation = state.rotation + parent.rotation;
        if (state.syncScale) {
            child.scaleX = state.scaleX * parent.scaleX;
            child.scaleY = state.scaleY * parent.scaleY;
        }
        if (child.isRexContainerLite) {
            child.syncChildrenEnable = true;
            child.syncPosition();
        }
        return this;
    },
    syncPosition () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildPosition, this);
        return this;
    },
    resetChildPositionState (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        state.x = child.x;
        state.y = child.y;
        parent.worldToLocal(state);
        state.scaleX = (0, $7d55ca19989e4e3c$export$2e2bcd8739ae039)(child.scaleX, parent.scaleX);
        state.scaleY = (0, $7d55ca19989e4e3c$export$2e2bcd8739ae039)(child.scaleY, parent.scaleY);
        state.rotation = child.rotation - parent.rotation;
        return this;
    },
    setChildPosition (child, x, y) {
        child.x = x;
        child.y = y;
        this.resetChildPositionState(child);
        return this;
    },
    setChildLocalPosition (child, x, y) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        state.x = x;
        state.y = y;
        this.updateChildPosition(child);
        return this;
    },
    resetLocalPositionState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildPositionState(this);
        return this;
    }
};



const $a1d596bc2a63a01b$var$DegToRad = Phaser.Math.DegToRad;
var $a1d596bc2a63a01b$export$2e2bcd8739ae039 = {
    updateChildRotation (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        if (state.syncRotation) child.rotation = parent.rotation + state.rotation;
        return this;
    },
    syncRotation () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildRotation, this);
        return this;
    },
    resetChildRotationState (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        state.rotation = child.rotation - parent.rotation;
        return this;
    },
    setChildRotation (child, rotation) {
        child.rotation = rotation;
        this.resetChildRotationState(child);
        return this;
    },
    setChildAngle (child, angle) {
        child.angle = angle;
        this.resetChildRotationState(child);
        return this;
    },
    setChildLocalRotation (child, rotation) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        state.rotation = rotation;
        this.updateChildRotation(child);
        return this;
    },
    setChildLocalAngle (child, angle) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        state.rotation = $a1d596bc2a63a01b$var$DegToRad(angle);
        this.updateChildRotation(child);
        return this;
    },
    resetLocalRotationState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildRotationState(this);
        return this;
    }
};




var $4193ee2105db819d$export$2e2bcd8739ae039 = {
    updateChildScale (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        if (state.syncScale) {
            child.scaleX = parent.scaleX * state.scaleX;
            child.scaleY = parent.scaleY * state.scaleY;
        }
        return this;
    },
    syncScale () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildScale, this);
        return this;
    },
    resetChildScaleState (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        state.scaleX = (0, $7d55ca19989e4e3c$export$2e2bcd8739ae039)(child.scaleX, parent.scaleX);
        state.scaleY = (0, $7d55ca19989e4e3c$export$2e2bcd8739ae039)(child.scaleY, parent.scaleY);
        return this;
    },
    setChildScale (child, scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        child.scaleX = scaleX;
        child.scaleY = scaleY;
        this.resetChildScaleState(child);
        return this;
    },
    setChildLocalScale (child, scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        state.scaleX = scaleX;
        state.scaleY = scaleY;
        this.updateChildScale(child);
        return this;
    },
    setChildDisplaySize (child, width, height) {
        child.setDisplaySize(width, height);
        this.resetChildScaleState(child);
        return this;
    },
    resetLocalScaleState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildScaleState(this);
        return this;
    }
};


/*

Visible in localState:

  - visible: original visible of child
  - maskVisible: invisible by parent mask, see MaskChildren.js
      - undefined (not in masking) : Equal to mask visible
      - true (mask visible) : Inside, or across parent's visible area
      - false (maske invisible) : Out of parent's visible area

Visible result of child = (parent visible) && (child visible) && (mask visible)
*/ 
var $2fa020e6b3f16046$export$2e2bcd8739ae039 = {
    updateChildVisible (child) {
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = localState.parent;
        var maskVisible = localState.hasOwnProperty("maskVisible") ? localState.maskVisible : true;
        child.visible = parent.visible && localState.visible && maskVisible;
        return this;
    },
    syncVisible () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildVisible, this);
        return this;
    },
    resetChildVisibleState (child) {
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        // Delete maskVisible property
        if (localState.hasOwnProperty("maskVisible")) delete localState.maskVisible;
        localState.visible = child.visible;
        return this;
    },
    setChildVisible (child, visible) {
        // Visible of child will be affect by parent's visible, and mask visible
        this.setChildLocalVisible(child, visible);
        return this;
    },
    // Internal method
    setChildLocalVisible (child, visible) {
        if (visible === undefined) visible = true;
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        localState.visible = visible;
        this.updateChildVisible(child);
        return this;
    },
    // Internal method
    setChildMaskVisible (child, visible) {
        if (visible === undefined) visible = true;
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        localState.maskVisible = visible;
        this.updateChildVisible(child);
        return this;
    },
    resetLocalVisibleState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildVisibleState(this);
        return this;
    }
};




var $80da322d648a3957$export$2e2bcd8739ae039 = {
    updateChildAlpha (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        if (state.syncAlpha) child.alpha = parent.alpha * state.alpha;
        return this;
    },
    syncAlpha () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildAlpha, this);
        return this;
    },
    resetChildAlphaState (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        state.alpha = (0, $7d55ca19989e4e3c$export$2e2bcd8739ae039)(child.alpha, parent.alpha);
        return this;
    },
    setChildAlpha (child, alpha) {
        child.alpha = alpha;
        this.resetChildAlphaState(child);
        return this;
    },
    setChildLocalAlpha (child, alpha) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        state.alpha = alpha;
        this.updateChildAlpha(child);
        return this;
    },
    resetLocalAlphaState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildAlphaState(this);
        return this;
    }
};



var $007e853fc6e877f7$export$2e2bcd8739ae039 = {
    updateChildActive (child) {
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = localState.parent;
        child.active = parent.active && localState.active;
        return this;
    },
    syncActive () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildActive, this);
        return this;
    },
    resetChildActiveState (child) {
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        localState.active = child.active;
        return this;
    },
    setChildActive (child, active) {
        child.active = active;
        this.resetChildActiveState(child);
        return this;
    },
    setChildLocalActive (child, active) {
        if (active === undefined) active = true;
        var localState = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        localState.active = active;
        this.updateChildActive(child);
        return this;
    },
    resetLocalActiveState () {
        var parent = (0, $29bd99d178520224$export$2e2bcd8739ae039)(this).parent;
        if (parent) parent.resetChildActiveState(this);
        return this;
    }
};



var $a9dccba50b98de63$export$2e2bcd8739ae039 = {
    updateChildScrollFactor (child) {
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(child);
        var parent = state.parent;
        if (state.syncScrollFactor) child.setScrollFactor(parent.scrollFactorX, parent.scrollFactorY);
        return this;
    },
    syncScrollFactor () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildScrollFactor, this);
        return this;
    }
};


var $92db07db6d27df95$export$2e2bcd8739ae039 = {
    updateChildMask (child) {
        // Don't propagate null mask to clear children's mask
        if (this.mask == null) return this;
        var maskGameObject = this.mask.hasOwnProperty("geometryMask") ? this.mask.geometryMask : this.mask.bitmapMask;
        if (maskGameObject !== child) child.mask = this.mask;
        return this;
    },
    syncMask () {
        if (this.syncChildrenEnable) this.children.forEach(this.updateChildMask, this);
        return this;
    },
    setMask (mask) {
        this.mask = mask;
        return this;
    },
    clearMask (destroyMask) {
        if (destroyMask === undefined) destroyMask = false;
        // Clear current mask
        this._mask = null;
        // Clear children mask
        this.children.forEach(function(child) {
            child.clearMask(false);
        });
        if (destroyMask && this.mask) this.mask.destroy();
        return this;
    }
};


var $953e6dff251f5cd4$var$SortGameObjectsByDepth = function(gameObjects, descending) {
    if (gameObjects.length <= 1) return gameObjects;
    if (descending === undefined) descending = false;
    var scene = gameObjects[0].scene;
    var displayList = scene.sys.displayList;
    displayList.depthSort();
    if (descending) gameObjects.sort(function(childA, childB) {
        return displayList.getIndex(childB) - displayList.getIndex(childA);
    });
    else gameObjects.sort(function(childA, childB) {
        return displayList.getIndex(childA) - displayList.getIndex(childB);
    });
    return gameObjects;
};
var $953e6dff251f5cd4$export$2e2bcd8739ae039 = $953e6dff251f5cd4$var$SortGameObjectsByDepth;


var $c1fbb52d4aaa8f93$export$2e2bcd8739ae039 = {
    setDepth (value, containerOnly) {
        this.depth = value;
        if (!containerOnly && this.children) {
            var children = this.getAllChildren();
            for(var i = 0, cnt = children.length; i < cnt; i++)children[i].depth = value;
        }
        return this;
    },
    swapDepth (containerB) {
        var depthA = this.depth;
        var depthB = containerB.depth;
        this.setDepth(depthB);
        containerB.setDepth(depthA);
        return this;
    },
    incDepth (inc) {
        this.depth += inc;
        if (this.children) {
            var children = this.getAllChildren();
            for(var i = 0, cnt = children.length; i < cnt; i++)children[i].depth += inc;
        }
        return this;
    },
    bringToTop () {
        var displayList = this.displayList;
        var children = this.getAllChildren([
            this
        ]);
        (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)(children, false);
        for(var i = 0, cnt = children.length; i < cnt; i++){
            var child = children[i];
            if (displayList.exists(child)) displayList.bringToTop(child);
        }
        return this;
    },
    moveDepthBelow (gameObject) {
        var displayList = this.displayList;
        if (gameObject.displayList !== displayList) // Do nothing if not at the same display list
        return this;
        var children = this.getAllChildren([
            this
        ]);
        (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)(children, false);
        for(var i = 0, cnt = children.length; i < cnt; i++){
            var child = children[i];
            if (displayList.exists(child)) {
                displayList.moveBelow(gameObject, child);
                break;
            }
        }
        return this;
    },
    moveDepthAbove (gameObject) {
        var displayList = this.displayList;
        if (gameObject.displayList !== displayList) // Do nothing if not at the same display list
        return this;
        var children = this.getAllChildren([
            this
        ]);
        (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)(children, true);
        for(var i = 0, cnt = children.length; i < cnt; i++){
            var child = children[i];
            if (displayList.exists(child)) {
                displayList.moveAbove(gameObject, child);
                break;
            }
        }
        return this;
    }
};



var $955cb7343b581334$export$8b05b23d87faf5e6 = function(root, callback) {
    var skip = callback(root);
    if (!skip && root.isRexContainerLite) {
        var children = root.children;
        for(var i = 0, cnt = children.length; i < cnt; i++)$955cb7343b581334$export$8b05b23d87faf5e6(children[i], callback);
    }
};
var $955cb7343b581334$export$efd0177a1e9c64e4 = function(root, callback) {
    var queue = [
        root
    ];
    while(queue.length > 0){
        var current = queue.shift();
        var skip = callback(current);
        if (!skip && current.isRexContainerLite) queue.push(...current.children);
    }
};


const $ab778a8872e4a69a$var$ArrayUtils = Phaser.Utils.Array;
var $ab778a8872e4a69a$export$2e2bcd8739ae039 = {
    getChildren (out) {
        if (!out) out = this.children; // Return internal children array
        else for(var i = 0, cnt = this.children.length; i < cnt; i++)out.push(this.children[i]);
        return out;
    },
    getAllChildren (out) {
        if (out === undefined) out = [];
        var root = this;
        (0, $955cb7343b581334$export$efd0177a1e9c64e4)(root, function(child) {
            // Don't add root
            if (child === root) return;
            out.push(child);
        });
        return out;
    },
    getAllVisibleChildren (out) {
        if (out === undefined) out = [];
        var root = this;
        (0, $955cb7343b581334$export$efd0177a1e9c64e4)(root, function(child) {
            // Don't add root
            if (child === root) return;
            // Don't add invisible child
            if (!child.visible) return true;
            out.push(child);
        });
        return out;
    },
    bfs (callback, root) {
        if (root === undefined) root = this;
        (0, $955cb7343b581334$export$efd0177a1e9c64e4)(root, callback);
        return this;
    },
    dfs (callback, root) {
        if (root === undefined) root = this;
        (0, $955cb7343b581334$export$8b05b23d87faf5e6)(root, callback);
        return this;
    },
    contains (gameObject) {
        var parent = (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(gameObject);
        if (!parent) return false;
        else if (parent === this) return true;
        else return this.contains(parent);
    },
    getByName (name, recursive) {
        if (!recursive) return $ab778a8872e4a69a$var$ArrayUtils.GetFirst(this.children, "name", name); // object, or null if not found
        else {
            // Breadth-first search
            var queue = [
                this
            ];
            var parent, child;
            while(queue.length){
                parent = queue.shift();
                for(var i = 0, cnt = parent.children.length; i < cnt; i++){
                    child = parent.children[i];
                    if (child.name === name) return child;
                    else if (child.isRexContainerLite) queue.push(child);
                }
            }
            return null;
        }
    },
    getRandom (startIndex, length) {
        return $ab778a8872e4a69a$var$ArrayUtils.GetRandom(this.children, startIndex, length);
    },
    getFirst (property, value, startIndex, endIndex) {
        return $ab778a8872e4a69a$var$ArrayUtils.GetFirstElement(this.children, property, value, startIndex, endIndex);
    },
    getAll (property, value, startIndex, endIndex) {
        return $ab778a8872e4a69a$var$ArrayUtils.GetAll(this.children, property, value, startIndex, endIndex);
    },
    count (property, value, startIndex, endIndex) {
        return $ab778a8872e4a69a$var$ArrayUtils.CountAllMatching(this.children, property, value, startIndex, endIndex);
    },
    swap (child1, child2) {
        $ab778a8872e4a69a$var$ArrayUtils.Swap(this.children, child1, child2);
        return this;
    },
    setAll (property, value, startIndex, endIndex) {
        $ab778a8872e4a69a$var$ArrayUtils.SetAll(this.children, property, value, startIndex, endIndex);
        return this;
    }
};


var $105436a4f997d551$var$GetLocalStates = function(gameObjects) {
    var localStates = [];
    for(var i = 0, cnt = gameObjects.length; i < cnt; i++){
        var gameObject = gameObjects[i];
        if (!gameObject.hasOwnProperty("rexContainer")) continue;
        localStates.push(gameObject.rexContainer);
    }
    return localStates;
};
var $105436a4f997d551$var$GetScene = function(gameObjects) {
    for(var i = 0, cnt = gameObjects.length; i < cnt; i++){
        var scene = gameObjects[i].scene;
        if (scene) return scene;
    }
    return null;
};
var $105436a4f997d551$var$UpdateChild = function(tween, key, target) {
    if (!target.parent) {
        // target object was removed, so remove this tween too
        tween.remove();
        return;
    }
    var parent = target.parent;
    var child = target.self;
    switch(key){
        case "x":
        case "y":
            parent.updateChildPosition(child);
            break;
        case "angle":
        case "rotation":
            parent.updateChildRotation(child);
            break;
        case "scaleX":
        case "scaleY":
        case "displayWidth":
        case "displayHeight":
            parent.updateChildScale(child);
            break;
        case "alpha":
            parent.updateChildAlpha(child);
            break;
        default:
            parent.updateChildPosition(child);
            parent.updateChildRotation(child);
            parent.updateChildScale(child);
            parent.updateChildAlpha(child);
            break;
    }
};
var $105436a4f997d551$export$2e2bcd8739ae039 = {
    tweenChild (tweenConfig) {
        var targets = tweenConfig.targets;
        if (!Array.isArray(targets)) targets = [
            targets
        ];
        var scene = this.scene || $105436a4f997d551$var$GetScene(targets);
        if (!scene) return;
        // Map child game objects to local states
        tweenConfig.targets = $105436a4f997d551$var$GetLocalStates(targets);
        var tween = scene.tweens.add(tweenConfig);
        // Update child game object in 'update' event
        tween.on("update", $105436a4f997d551$var$UpdateChild);
        return tween;
    },
    tweenSelf (tweenConfig) {
        tweenConfig.targets = [
            this
        ];
        return this.tweenChild(tweenConfig);
    },
    createTweenChildConfig (tweenConfig) {
        var targets = tweenConfig.targets;
        if (targets) {
            if (!Array.isArray(targets)) targets = [
                targets
            ];
            // Map child game objects to local states
            tweenConfig.targets = $105436a4f997d551$var$GetLocalStates(targets);
        }
        var onUpdate = tweenConfig.onUpdate;
        tweenConfig.onUpdate = function(tween, target) {
            if (onUpdate) onUpdate(tween, target);
            $105436a4f997d551$var$UpdateChild(tween, undefined, target);
        };
        return tweenConfig;
    },
    tween (tweenConfig) {
        var scene = this.scene;
        if (!tweenConfig.targets) tweenConfig.targets = this;
        return scene.tweens.add(tweenConfig);
    },
    timelineChild (timelineConfig) {
        var targets = timelineConfig.targets;
        // Map child game objects to local states
        if (targets) {
            if (!Array.isArray(targets)) targets = [
                targets
            ];
            timelineConfig.targets = $105436a4f997d551$var$GetLocalStates(targets);
        }
        var tweens = timelineConfig.tweens;
        for(var i = 0, cnt = tweens.length; i < cnt; i++)tweens[i] = this.createTweenChildConfig(tweens[i]);
        var timeline = this.scene.tweens.timeline(timelineConfig);
        return timeline;
    }
};



var $bb2085f3de263e0e$export$2e2bcd8739ae039 = {
    addToContainer (p3Container) {
        this._setParentContainerFlag = true;
        var gameObjects = this.getAllChildren([
            this
        ]);
        (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)(gameObjects);
        p3Container.add(gameObjects);
        this._setParentContainerFlag = false;
        return this;
    },
    addToLayer (layer) {
        this.addToContainer(layer);
        return this;
    },
    removeFromContainer () {
        if (!this.parentContainer) return this;
        // Will add gameObjects to scene
        var gameObjects = this.getAllChildren([
            this
        ]).filter(function(gameObject) {
            return !!gameObject.scene;
        });
        if (gameObjects.length === 0) return this;
        this._setParentContainerFlag = true;
        if (gameObjects.length > 1) {
            (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)(gameObjects);
            gameObjects.reverse();
        }
        this.parentContainer.remove(gameObjects);
        this._setParentContainerFlag = false;
        return this;
    },
    getParentContainer () {
        if (this.parentContainer) return this.parentContainer;
        // One of parent container has a layer
        var parent = this.getParent();
        while(parent){
            var p3Container = parent.parentContainer;
            if (p3Container) return p3Container;
            parent = parent.getParent();
        }
        return null;
    },
    addToParentContainer (gameObject) {
        // Don't add to layer if gameObject is not in any displayList
        if (!gameObject.displayList) return this;
        var p3Container = this.getParentContainer();
        if (!p3Container) return this;
        if (gameObject.isRexContainerLite) // Add containerLite and its children
        gameObject.addToContainer(p3Container);
        else // Add gameObject directly
        p3Container.add(gameObject);
        return this;
    }
};



var $896e4b5ad9570078$export$2e2bcd8739ae039 = {
    enableLayer () {
        if (this.privateRenderLayer) return this;
        var layer = this.scene.add.layer();
        // layer.name = (this.name) ? `${this.name}.privateLayer` : 'privateLayer';
        this.moveDepthBelow(layer);
        this.addToLayer(layer);
        this.privateRenderLayer = layer;
        return this;
    },
    getLayer () {
        if (!this.privateRenderLayer) this.enableLayer();
        return this.privateRenderLayer;
    },
    getRenderLayer () {
        // This containerLite has a layer
        if (this.privateRenderLayer) return this.privateRenderLayer;
        // One of parent container has a layer
        var parent = this.getParent();
        while(parent){
            var layer = parent.privateRenderLayer;
            if (layer) return layer;
            parent = parent.getParent();
        }
        return null;
    },
    // Internal method for adding child
    addToRenderLayer (gameObject) {
        // Don't add to layer if gameObject is not in any displayList
        if (!gameObject.displayList) return this;
        // Move gameObject from scene to layer
        var layer = this.getRenderLayer();
        if (!layer) return this;
        if (gameObject.isRexContainerLite) // Add containerLite and its children
        gameObject.addToLayer(layer);
        else // Add gameObject directly
        layer.add(gameObject);
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
        state.layer = layer;
        return this;
    },
    // Internal method for removing child
    removeFromRenderLayer (gameObject) {
        // Move gameObject from layer to scene
        var state = (0, $29bd99d178520224$export$2e2bcd8739ae039)(gameObject);
        var layer = state.layer;
        if (!layer) return this;
        layer.remove(gameObject);
        state.layer = null;
        return this;
    }
};


var $3d5f5580139892aa$export$a60660135e2d0135 = function(gameObject) {
    if (gameObject.displayWidth !== undefined) return gameObject.displayWidth;
    else return gameObject.width;
};
var $3d5f5580139892aa$export$20a373b59e34b4e5 = function(gameObject) {
    if (gameObject.displayHeight !== undefined) return gameObject.displayHeight;
    else return gameObject.height;
};


const $bf502811d69b7d21$var$Rectangle = Phaser.Geom.Rectangle;
const $bf502811d69b7d21$var$Vector2 = Phaser.Math.Vector2;
const $bf502811d69b7d21$var$RotateAround = Phaser.Math.RotateAround;
var $bf502811d69b7d21$export$a48dd0a2c64c17f2 = function(gameObject, output) {
    if (output === undefined) output = new $bf502811d69b7d21$var$Rectangle();
    else if (output === true) {
        if ($bf502811d69b7d21$var$GlobRect === undefined) $bf502811d69b7d21$var$GlobRect = new $bf502811d69b7d21$var$Rectangle();
        output = $bf502811d69b7d21$var$GlobRect;
    }
    if (gameObject.getBounds) return gameObject.getBounds(output);
    //  We can use the output object to temporarily store the x/y coords in:
    var TLx, TLy, TRx, TRy, BLx, BLy, BRx, BRy;
    // Instead of doing a check if parent container is
    // defined per corner we only do it once.
    if (gameObject.parentContainer) {
        var parentMatrix = gameObject.parentContainer.getBoundsTransformMatrix();
        $bf502811d69b7d21$export$48014eff5f467d56(gameObject, output);
        parentMatrix.transformPoint(output.x, output.y, output);
        TLx = output.x;
        TLy = output.y;
        $bf502811d69b7d21$export$6333332ce0a0eff6(gameObject, output);
        parentMatrix.transformPoint(output.x, output.y, output);
        TRx = output.x;
        TRy = output.y;
        $bf502811d69b7d21$export$a7c7d8676dfd9c82(gameObject, output);
        parentMatrix.transformPoint(output.x, output.y, output);
        BLx = output.x;
        BLy = output.y;
        $bf502811d69b7d21$export$ee58ddc9bde0167(gameObject, output);
        parentMatrix.transformPoint(output.x, output.y, output);
        BRx = output.x;
        BRy = output.y;
    } else {
        $bf502811d69b7d21$export$48014eff5f467d56(gameObject, output);
        TLx = output.x;
        TLy = output.y;
        $bf502811d69b7d21$export$6333332ce0a0eff6(gameObject, output);
        TRx = output.x;
        TRy = output.y;
        $bf502811d69b7d21$export$a7c7d8676dfd9c82(gameObject, output);
        BLx = output.x;
        BLy = output.y;
        $bf502811d69b7d21$export$ee58ddc9bde0167(gameObject, output);
        BRx = output.x;
        BRy = output.y;
    }
    output.x = Math.min(TLx, TRx, BLx, BRx);
    output.y = Math.min(TLy, TRy, BLy, BRy);
    output.width = Math.max(TLx, TRx, BLx, BRx) - output.x;
    output.height = Math.max(TLy, TRy, BLy, BRy) - output.y;
    return output;
};
var $bf502811d69b7d21$var$GlobRect = undefined;
var $bf502811d69b7d21$export$48014eff5f467d56 = function(gameObject, output, includeParent) {
    if (output === undefined) output = new $bf502811d69b7d21$var$Vector2();
    else if (output === true) {
        if ($bf502811d69b7d21$var$GlobVector === undefined) $bf502811d69b7d21$var$GlobVector = new $bf502811d69b7d21$var$Vector2();
        output = $bf502811d69b7d21$var$GlobVector;
    }
    if (gameObject.getTopLeft) return gameObject.getTopLeft(output);
    output.x = gameObject.x - (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) * gameObject.originX;
    output.y = gameObject.y - (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) * gameObject.originY;
    return $bf502811d69b7d21$var$PrepareBoundsOutput(gameObject, output, includeParent);
};
var $bf502811d69b7d21$export$6333332ce0a0eff6 = function(gameObject, output, includeParent) {
    if (output === undefined) output = new $bf502811d69b7d21$var$Vector2();
    else if (output === true) {
        if ($bf502811d69b7d21$var$GlobVector === undefined) $bf502811d69b7d21$var$GlobVector = new $bf502811d69b7d21$var$Vector2();
        output = $bf502811d69b7d21$var$GlobVector;
    }
    if (gameObject.getTopRight) return gameObject.getTopRight(output);
    output.x = gameObject.x - (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) * gameObject.originX + (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    output.y = gameObject.y - (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) * gameObject.originY;
    return $bf502811d69b7d21$var$PrepareBoundsOutput(gameObject, output, includeParent);
};
var $bf502811d69b7d21$export$a7c7d8676dfd9c82 = function(gameObject, output, includeParent) {
    if (output === undefined) output = new $bf502811d69b7d21$var$Vector2();
    else if (output === true) {
        if ($bf502811d69b7d21$var$GlobVector === undefined) $bf502811d69b7d21$var$GlobVector = new $bf502811d69b7d21$var$Vector2();
        output = $bf502811d69b7d21$var$GlobVector;
    }
    if (gameObject.getBottomLeft) return gameObject.getBottomLeft(output);
    output.x = gameObject.x - (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) * gameObject.originX;
    output.y = gameObject.y - (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) * gameObject.originY + (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    return $bf502811d69b7d21$var$PrepareBoundsOutput(gameObject, output, includeParent);
};
var $bf502811d69b7d21$export$ee58ddc9bde0167 = function(gameObject, output, includeParent) {
    if (output === undefined) output = new $bf502811d69b7d21$var$Vector2();
    else if (output === true) {
        if ($bf502811d69b7d21$var$GlobVector === undefined) $bf502811d69b7d21$var$GlobVector = new $bf502811d69b7d21$var$Vector2();
        output = $bf502811d69b7d21$var$GlobVector;
    }
    if (gameObject.getBottomRight) return gameObject.getBottomRight(output);
    output.x = gameObject.x - (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) * gameObject.originX + (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    output.y = gameObject.y - (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) * gameObject.originY + (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    return $bf502811d69b7d21$var$PrepareBoundsOutput(gameObject, output, includeParent);
};
var $bf502811d69b7d21$var$GlobVector = undefined;
var $bf502811d69b7d21$var$PrepareBoundsOutput = function(gameObject, output, includeParent) {
    if (includeParent === undefined) includeParent = false;
    if (gameObject.rotation !== 0) $bf502811d69b7d21$var$RotateAround(output, gameObject.x, gameObject.y, gameObject.rotation);
    if (includeParent && gameObject.parentContainer) {
        var parentMatrix = gameObject.parentContainer.getBoundsTransformMatrix();
        parentMatrix.transformPoint(output.x, output.y, output);
    }
    return output;
};


const $2ac803dfb763bac6$var$Rectangle = Phaser.Geom.Rectangle;
const $2ac803dfb763bac6$var$Union = Phaser.Geom.Rectangle.Union;
var $2ac803dfb763bac6$var$GetBoundsOfGameObjects = function(gameObjects, out) {
    if (out === undefined) out = new $2ac803dfb763bac6$var$Rectangle();
    else if (out === true) {
        if ($2ac803dfb763bac6$var$GlobRect === undefined) $2ac803dfb763bac6$var$GlobRect = new $2ac803dfb763bac6$var$Rectangle();
        out = $2ac803dfb763bac6$var$GlobRect;
    }
    out.setTo(0, 0, 0, 0);
    var gameObject;
    var firstClone = true;
    for(var i = 0, cnt = gameObjects.length; i < cnt; i++){
        gameObject = gameObjects[i];
        if (!gameObject.getBounds) continue;
        var boundsRect = (0, $bf502811d69b7d21$export$a48dd0a2c64c17f2)(gameObject, true);
        if (firstClone) {
            out.setTo(boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
            firstClone = false;
        } else $2ac803dfb763bac6$var$Union(boundsRect, out, out);
    }
    return out;
};
var $2ac803dfb763bac6$var$GlobRect;
var $2ac803dfb763bac6$export$2e2bcd8739ae039 = $2ac803dfb763bac6$var$GetBoundsOfGameObjects;


var $46f5de22f239821d$var$Clear = function(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) obj.length = 0;
    else for(var key in obj)delete obj[key];
    return obj;
};
var $46f5de22f239821d$export$2e2bcd8739ae039 = $46f5de22f239821d$var$Clear;


/**
 * Shallow Object Clone. Will not out nested objects.
 * @param {object} obj JSON object
 * @param {object} ret JSON object to return, set null to return a new object
 * @returns {object} this object
 */ var $1aafd1214cd046a0$var$Clone = function(obj, out) {
    var objIsArray = Array.isArray(obj);
    if (out === undefined) out = objIsArray ? [] : {};
    else (0, $46f5de22f239821d$export$2e2bcd8739ae039)(out);
    if (objIsArray) {
        out.length = obj.length;
        for(var i = 0, cnt = obj.length; i < cnt; i++)out[i] = obj[i];
    } else for(var key in obj)out[key] = obj[key];
    return out;
};
var $1aafd1214cd046a0$export$2e2bcd8739ae039 = $1aafd1214cd046a0$var$Clone;



var $77b8570de39b9238$var$GetValue = Phaser.Utils.Objects.GetValue;
var $77b8570de39b9238$var$Snapshot = function(config) {
    if (!config) return;
    var gameObjects = config.gameObjects;
    var renderTexture = config.renderTexture;
    var x = $77b8570de39b9238$var$GetValue(config, "x", undefined);
    var y = $77b8570de39b9238$var$GetValue(config, "y", undefined);
    var width = $77b8570de39b9238$var$GetValue(config, "width", undefined);
    var height = $77b8570de39b9238$var$GetValue(config, "height", undefined);
    var originX = $77b8570de39b9238$var$GetValue(config, "originX", 0);
    var originY = $77b8570de39b9238$var$GetValue(config, "originY", 0);
    var padding = $77b8570de39b9238$var$GetValue(config, "padding", 0);
    var scrollX, scrollY;
    if (width === undefined || height === undefined || x === undefined || y === undefined) {
        // Union bounds of gameObjects
        var bounds = (0, $2ac803dfb763bac6$export$2e2bcd8739ae039)(gameObjects, true);
        var isCenterOrigin = x !== undefined && y !== undefined;
        if (isCenterOrigin) {
            width = Math.max(x - bounds.left, bounds.right - x) * 2;
            height = Math.max(y - bounds.top, bounds.bottom - y) * 2;
            originX = 0.5;
            originY = 0.5;
        } else {
            x = bounds.x;
            y = bounds.y;
            width = bounds.width;
            height = bounds.height;
            originX = 0;
            originY = 0;
        }
        scrollX = bounds.x;
        scrollY = bounds.y;
    } else {
        scrollX = x + (0 - originX) * width;
        scrollY = y + (0 - originY) * height;
    }
    scrollX -= padding;
    scrollY -= padding;
    width += padding * 2;
    height += padding * 2;
    var tempRT = !renderTexture;
    // Configurate render texture
    if (tempRT) {
        var scene = gameObjects[0].scene;
        renderTexture = scene.add.renderTexture(0, 0, width, height);
    }
    renderTexture.setPosition(x, y);
    if (renderTexture.width !== width || renderTexture.height !== height) renderTexture.setSize(width, height);
    renderTexture.setOrigin(originX, originY);
    renderTexture.camera.setScroll(scrollX, scrollY);
    // Draw gameObjects
    gameObjects = (0, $953e6dff251f5cd4$export$2e2bcd8739ae039)((0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(gameObjects));
    renderTexture.draw(gameObjects);
    // Save render result to texture    
    var saveTexture = config.saveTexture;
    if (saveTexture) renderTexture.saveTexture(saveTexture);
    // Destroy render texture if tempRT and saveTexture
    if (tempRT && saveTexture) renderTexture.destroy();
    return renderTexture;
};
var $77b8570de39b9238$export$2e2bcd8739ae039 = $77b8570de39b9238$var$Snapshot;


var $373a6df27718efde$export$2e2bcd8739ae039 = {
    snapshot (config) {
        // Save scale
        var scaleXSave = this.scaleX;
        var scaleYSave = this.scaleY;
        var scale1 = scaleXSave === 1 && scaleYSave === 1;
        if (!scale1) this.setScale(1);
        // Snapshot with scale = 1
        if (config === undefined) config = {};
        config.gameObjects = this.getAllVisibleChildren();
        config.x = this.x;
        config.y = this.y;
        config.originX = this.originX;
        config.originY = this.originY;
        var rt = (0, $77b8570de39b9238$export$2e2bcd8739ae039)(config);
        var isValidRT = !!rt.scene;
        // Restore scale
        if (!scale1) {
            this.setScale(scaleXSave, scaleYSave);
            if (isValidRT) rt.setScale(scaleXSave, scaleYSave);
        }
        return isValidRT ? rt : this;
    }
};



const $f1363fb23984dede$var$GetValue = Phaser.Utils.Objects.GetValue;
var $f1363fb23984dede$var$DrawBounds = function(gameObjects, graphics, config) {
    var strokeColor, lineWidth, fillColor, fillAlpha, padding;
    if (typeof config === "number") strokeColor = config;
    else {
        strokeColor = $f1363fb23984dede$var$GetValue(config, "color");
        lineWidth = $f1363fb23984dede$var$GetValue(config, "lineWidth");
        fillColor = $f1363fb23984dede$var$GetValue(config, "fillColor");
        fillAlpha = $f1363fb23984dede$var$GetValue(config, "fillAlpha", 1);
        padding = $f1363fb23984dede$var$GetValue(config, "padding", 0);
    }
    if (Array.isArray(gameObjects)) for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$f1363fb23984dede$var$Draw(gameObjects[i], graphics, strokeColor, lineWidth, fillColor, fillAlpha, padding);
    else $f1363fb23984dede$var$Draw(gameObjects, graphics, strokeColor, lineWidth, fillColor, fillAlpha, padding);
};
var $f1363fb23984dede$var$Draw = function(gameObject, graphics, strokeColor, lineWidth, fillColor, fillAlpha, padding) {
    var canDrawBound = gameObject.getBounds || gameObject.width !== undefined && gameObject.height !== undefined;
    if (!canDrawBound) return;
    if (strokeColor === undefined) strokeColor = 0xffffff;
    if (lineWidth === undefined) lineWidth = 1;
    if (fillColor === undefined) fillColor = null;
    if (fillAlpha === undefined) fillAlpha = 1;
    if (padding === undefined) padding = 0;
    var p0 = (0, $bf502811d69b7d21$export$48014eff5f467d56)(gameObject, $f1363fb23984dede$var$Points[0]);
    p0.x -= padding;
    p0.y -= padding;
    var p1 = (0, $bf502811d69b7d21$export$6333332ce0a0eff6)(gameObject, $f1363fb23984dede$var$Points[1]);
    p1.x += padding;
    p1.y -= padding;
    var p2 = (0, $bf502811d69b7d21$export$ee58ddc9bde0167)(gameObject, $f1363fb23984dede$var$Points[2]);
    p2.x += padding;
    p2.y += padding;
    var p3 = (0, $bf502811d69b7d21$export$a7c7d8676dfd9c82)(gameObject, $f1363fb23984dede$var$Points[3]);
    p3.x -= padding;
    p3.y += padding;
    if (fillColor !== null) graphics.fillStyle(fillColor, fillAlpha).fillPoints($f1363fb23984dede$var$Points, true, true);
    if (strokeColor !== null) graphics.lineStyle(lineWidth, strokeColor).strokePoints($f1363fb23984dede$var$Points, true, true);
};
var $f1363fb23984dede$var$Points = [
    {
        x: 0,
        y: 0
    },
    {
        x: 0,
        y: 0
    },
    {
        x: 0,
        y: 0
    },
    {
        x: 0,
        y: 0
    }
];
var $f1363fb23984dede$export$2e2bcd8739ae039 = $f1363fb23984dede$var$DrawBounds;


const $98e486452dc76812$var$GetValue = Phaser.Utils.Objects.GetValue;
var $98e486452dc76812$var$DrawBounds = function(graphics, config) {
    var drawContainer = $98e486452dc76812$var$GetValue(config, "drawContainer", true);
    var gameObjects = $98e486452dc76812$var$GetValue(config, "children");
    if (gameObjects === undefined) gameObjects = this.getAllVisibleChildren([
        this
    ]);
    if (!drawContainer) gameObjects = gameObjects.filter(function(gameObject) {
        return !gameObject.isRexContainerLite;
    });
    (0, $f1363fb23984dede$export$2e2bcd8739ae039)(gameObjects, graphics, config);
    return this;
};
var $98e486452dc76812$export$2e2bcd8739ae039 = $98e486452dc76812$var$DrawBounds;


const $faffa5c981390b1f$var$RotateAround = Phaser.Math.RotateAround;
var $faffa5c981390b1f$var$ChangeOrigin = function(gameObject, originX, originY) {
    if (originY === undefined) originY = originX;
    var deltaXY = {
        x: (originX - gameObject.originX) * gameObject.displayWidth,
        y: (originY - gameObject.originY) * gameObject.displayHeight
    };
    $faffa5c981390b1f$var$RotateAround(deltaXY, 0, 0, gameObject.rotation);
    gameObject.originX = originX;
    gameObject.originY = originY;
    gameObject.x = gameObject.x + deltaXY.x;
    gameObject.y = gameObject.y + deltaXY.y;
    return gameObject;
};
var $faffa5c981390b1f$export$2e2bcd8739ae039 = $faffa5c981390b1f$var$ChangeOrigin;


var $23f02c64b16190fd$var$ChangeOrigin = function(originX, originY) {
    this.syncChildrenEnable = false;
    (0, $faffa5c981390b1f$export$2e2bcd8739ae039)(this, originX, originY);
    this.syncChildrenEnable = true;
    var children = this.getAllChildren();
    for(var i = 0, cnt = children.length; i < cnt; i++)this.resetChildPositionState(children[i]);
    return this;
};
var $23f02c64b16190fd$export$2e2bcd8739ae039 = $23f02c64b16190fd$var$ChangeOrigin;


var $dd4942435894f818$var$methods = {
    changeOrigin: (0, $23f02c64b16190fd$export$2e2bcd8739ae039),
    drawBounds: (0, $98e486452dc76812$export$2e2bcd8739ae039)
};
Object.assign($dd4942435894f818$var$methods, (0, $9a7c75412864ae65$export$2e2bcd8739ae039), (0, $3149070c0f8b37c4$export$2e2bcd8739ae039), (0, $9d8512674a134b95$export$2e2bcd8739ae039), (0, $78a91ecfb88b3636$export$2e2bcd8739ae039), (0, $ae69f7d3fd8535d1$export$2e2bcd8739ae039), (0, $4a085b1051fbc47c$export$2e2bcd8739ae039), (0, $a1d596bc2a63a01b$export$2e2bcd8739ae039), (0, $4193ee2105db819d$export$2e2bcd8739ae039), (0, $2fa020e6b3f16046$export$2e2bcd8739ae039), (0, $80da322d648a3957$export$2e2bcd8739ae039), (0, $007e853fc6e877f7$export$2e2bcd8739ae039), (0, $a9dccba50b98de63$export$2e2bcd8739ae039), (0, $92db07db6d27df95$export$2e2bcd8739ae039), (0, $c1fbb52d4aaa8f93$export$2e2bcd8739ae039), (0, $ab778a8872e4a69a$export$2e2bcd8739ae039), (0, $105436a4f997d551$export$2e2bcd8739ae039), (0, $bb2085f3de263e0e$export$2e2bcd8739ae039), (0, $896e4b5ad9570078$export$2e2bcd8739ae039), (0, $373a6df27718efde$export$2e2bcd8739ae039));
var $dd4942435894f818$export$2e2bcd8739ae039 = $dd4942435894f818$var$methods;



class $3799588e8b69e578$var$ContainerLite extends (0, $99f04f9ac16407e6$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, children){
        if (Array.isArray(width)) {
            children = width;
            width = undefined;
            height = undefined;
        }
        super(scene, x, y, width, height);
        this.type = "rexContainerLite";
        this.isRexContainerLite = true;
        this.syncChildrenEnable = true;
        this._active = true;
        this._mask = null;
        this._scrollFactorX = 1;
        this._scrollFactorY = 1;
        this.privateRenderLayer = undefined;
        if (children) this.add(children);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.syncChildrenEnable = false; // Don't sync properties changing anymore
        super.destroy(fromScene);
        if (this.privateRenderLayer) {
            this.privateRenderLayer.list.length = 0; // Remove all children without trigger callback
            this.privateRenderLayer.destroy();
        }
    }
    resize(width, height) {
        this.setSize(width, height);
        return this;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        if (this._x === value) return;
        this._x = value;
        this.syncPosition();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        if (this._y === value) return;
        this._y = value;
        this.syncPosition();
    }
    // Override
    get rotation() {
        return super.rotation;
    }
    set rotation(value) {
        if (this.rotation === value) return;
        super.rotation = value;
        this.syncPosition();
    }
    // Override
    get scaleX() {
        return super.scaleX;
    }
    set scaleX(value) {
        if (this.scaleX === value) return;
        super.scaleX = value;
        this.syncPosition();
    }
    // Override
    get scaleY() {
        return super.scaleY;
    }
    set scaleY(value) {
        if (this.scaleY === value) return;
        super.scaleY = value;
        this.syncPosition();
    }
    // Override
    get scale() {
        return super.scale;
    }
    set scale(value) {
        if (this.scale === value) return;
        super.scale = value;
        this.syncPosition();
    }
    // Override
    get visible() {
        return super.visible;
    }
    set visible(value) {
        if (super.visible === value) return;
        super.visible = value;
        this.syncVisible();
    }
    // Override
    get alpha() {
        return super.alpha;
    }
    set alpha(value) {
        if (super.alpha === value) return;
        super.alpha = value;
        this.syncAlpha();
    }
    // Override
    get active() {
        return this._active;
    }
    set active(value) {
        if (this._active === value) return;
        this._active = value;
        this.syncActive();
    }
    // Override
    get mask() {
        return this._mask;
    }
    set mask(mask) {
        if (this._mask === mask) return;
        this._mask = mask;
        this.syncMask();
    }
    // Override
    get scrollFactorX() {
        return this._scrollFactorX;
    }
    set scrollFactorX(value) {
        if (this._scrollFactorX === value) return;
        this._scrollFactorX = value;
        this.syncScrollFactor();
    }
    get scrollFactorY() {
        return this._scrollFactorY;
    }
    set scrollFactorY(value) {
        if (this._scrollFactorY === value) return;
        this._scrollFactorY = value;
        this.syncScrollFactor();
    }
    // Compatiable with container plugin
    get list() {
        return this.children;
    }
    static GetParent(child) {
        return (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(child);
    }
    // For p3-container
    get parentContainer() {
        return this._parentContainer;
    }
    set parentContainer(value) {
        // Initialize
        if (!this._parentContainer && !value) {
            this._parentContainer = value;
            return;
        }
        // Set this._parentContainer only,
        // if under AddToContainer, or RemoveFromContainer methods
        if (this.setParentContainerFlag) {
            this._parentContainer = value;
            return;
        }
        // else if (!this.setParentContainerFlag)
        // Add itself and all children to container,
        // Or remove itseld and all children from container
        if (this._parentContainer && !value) {
            // Remove from container
            this.removeFromContainer();
            this._parentContainer = value;
        } else if (value) {
            // Add to container
            this._parentContainer = value;
            this.addToContainer(value);
        } else this._parentContainer = value;
    }
    get setParentContainerFlag() {
        if (this._setParentContainerFlag) return true;
        var parent = (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(this);
        return parent ? parent.setParentContainerFlag : false;
    }
}
Object.assign($3799588e8b69e578$var$ContainerLite.prototype, (0, $dd4942435894f818$export$2e2bcd8739ae039));
var $3799588e8b69e578$export$2e2bcd8739ae039 = $3799588e8b69e578$var$ContainerLite;


/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ //  Source object
//  The key as a string, or an array of keys, i.e. 'banner', or 'banner.hideBanner'
//  The default value to use if the key doesn't exist
/**
 * Retrieves a value from an object.
 *
 * @function Phaser.Utils.Objects.GetValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var $06ba717ef5182ca0$var$GetValue = function(source, key, defaultValue) {
    if (!source || typeof source === "number") return defaultValue;
    else if (source.hasOwnProperty(key)) return source[key];
    else if (key.indexOf(".") !== -1) {
        var keys = key.split(".");
        var parent = source;
        var value = defaultValue;
        //  Use for loop here so we can break early
        for(var i = 0; i < keys.length; i++)if (parent.hasOwnProperty(keys[i])) {
            //  Yes it has a key property, let's carry on down
            value = parent[keys[i]];
            parent = parent[keys[i]];
        } else {
            //  Can't go any further, so reset to default
            value = defaultValue;
            break;
        }
        return value;
    } else return defaultValue;
};
var $06ba717ef5182ca0$export$2e2bcd8739ae039 = $06ba717ef5182ca0$var$GetValue;



var $90fdebfc958065d1$export$2e2bcd8739ae039 = {
    enableData () {
        if (this.data === undefined) this.data = {};
        return this;
    },
    setData (key, value) {
        this.enableData();
        if (arguments.length === 1) {
            var data = key;
            for(key in data)this.data[key] = data[key];
        } else this.data[key] = value;
        return this;
    },
    getData (key, defaultValue) {
        this.enableData();
        return key === undefined ? this.data : (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(this.data, key, defaultValue);
    },
    incData (key, inc, defaultValue) {
        if (defaultValue === undefined) defaultValue = 0;
        this.enableData();
        this.setData(key, this.getData(key, defaultValue) + inc);
        return this;
    },
    mulData (key, mul, defaultValue) {
        if (defaultValue === undefined) defaultValue = 0;
        this.enableData();
        this.setData(key, this.getData(key, defaultValue) * mul);
        return this;
    },
    clearData () {
        if (this.data) (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.data);
        return this;
    }
};


const $e76743698f0ffd60$var$ALIGN = Phaser.Display.Align;
var $e76743698f0ffd60$export$2e2bcd8739ae039 = {
    center: $e76743698f0ffd60$var$ALIGN.CENTER,
    left: $e76743698f0ffd60$var$ALIGN.LEFT_CENTER,
    right: $e76743698f0ffd60$var$ALIGN.RIGHT_CENTER,
    top: $e76743698f0ffd60$var$ALIGN.TOP_CENTER,
    bottom: $e76743698f0ffd60$var$ALIGN.BOTTOM_CENTER,
    "left-top": $e76743698f0ffd60$var$ALIGN.TOP_LEFT,
    "left-center": $e76743698f0ffd60$var$ALIGN.LEFT_CENTER,
    "left-bottom": $e76743698f0ffd60$var$ALIGN.BOTTOM_LEFT,
    "center-top": $e76743698f0ffd60$var$ALIGN.TOP_CENTER,
    "center-center": $e76743698f0ffd60$var$ALIGN.CENTER,
    "center-bottom": $e76743698f0ffd60$var$ALIGN.BOTTOM_CENTER,
    "right-top": $e76743698f0ffd60$var$ALIGN.TOP_RIGHT,
    "right-center": $e76743698f0ffd60$var$ALIGN.RIGHT_CENTER,
    "right-bottom": $e76743698f0ffd60$var$ALIGN.BOTTOM_RIGHT
};


class $3f1a34a79a9f8652$var$Cell {
    constructor(parent, config){
        this.container = null;
        this._deltaHeight = 0;
        this.setParent(parent);
    // this.resetFromJSON(config);
    }
    setParent(parent) {
        this.parent = parent; // parent: table
        this.parentContainer = parent.getParentContainer();
    }
    // resetFromJSON(o) {
    //     return this;
    // }
    destroy(fromScene) {
        if (fromScene === undefined) fromScene = false;
        if (!fromScene) this.destroyContainer();
        this.deltaHeight = 0;
        this.data = undefined;
        this.container = null;
        this.parent = undefined;
        this.parentContainer = undefined;
    }
    get table() {
        return this.parent;
    }
    get scrollMode() {
        return this.parentContainer.scrollMode;
    }
    get colIndx() {
        return this.parent.cellIndxeToColIndex(this.index);
    }
    get rowIndx() {
        return this.parent.cellIndxeToRowIndex(this.index);
    }
    getContainer() {
        return this.container;
    }
    setContainer(container) {
        if (!container) {
            this.destroyContainer();
            return this;
        }
        if (this.container) this.container.destroy();
        this.container = container;
        this.parentContainer.add(container);
        return this;
    }
    destroyContainer() {
        if (this.container) {
            this.container.destroy();
            this.container = null;
        }
        return this;
    }
    popContainer() {
        if (this.container) {
            var container = this.container;
            this.container = null;
            this.parentContainer.remove(container);
            return container;
        } else return null;
    }
    setXY(x, y) {
        if (this.container) this.parentContainer.setChildLocalPosition(this.container, x, y);
        return this;
    }
    setCellContainerAlign(align) {
        if (typeof align === "string") align = (0, $e76743698f0ffd60$export$2e2bcd8739ae039)[align];
        this.cellContainerAlign = align;
        return this;
    }
    get deltaHeight() {
        return this._deltaHeight;
    }
    set deltaHeight(deltaHeight) {
        if (deltaHeight == null) deltaHeight = 0;
        var table = this.parent;
        if (this._deltaHeight === 0 && deltaHeight !== 0) table.nonZeroDeltaHeightCount++;
        else if (this._deltaHeight !== 0 && deltaHeight === 0) table.nonZeroDeltaHeightCount--;
        var isTableHeightChanged = this._deltaHeight !== deltaHeight;
        this._deltaHeight = deltaHeight;
        if (isTableHeightChanged) {
            table.resetTotalRowsHeight();
            var eventName = this.scrollMode === 0 ? "cellheightchange" : "cellwidthchange";
            this.parentContainer.emit(eventName, this, this.container, this.parentContainer);
        }
    }
    get deltaWidth() {
        return this.deltaHeight;
    }
    set deltaWidth(deltaWidth) {
        this.deltaHeight = deltaWidth;
    }
    setDeltaHeight(deltaHeight) {
        this.deltaHeight = deltaHeight;
        return this;
    }
    setDeltaWidth(deltaWidth) {
        this.deltaHeight = deltaWidth;
        return this;
    }
    get height() {
        if (this.scrollMode === 0) return this.deltaHeight + this.parent.defaultCellHeight;
        else return this.parent.defaultCellWidth;
    }
    set height(height) {
        // Only worked when scrollMode is 0
        if (this.scrollMode === 1) return;
        this.setDeltaHeight(height - this.parent.defaultCellHeight);
    }
    setHeight(height) {
        // Only worked when scrollMode is 0
        this.height = height;
        return this;
    }
    get width() {
        if (this.scrollMode === 0) return this.parent.defaultCellWidth;
        else return this.deltaHeight + this.parent.defaultCellHeight;
    }
    set width(width) {
        // Only worked when scrollMode is 1
        if (this.scrollMode === 0) return;
        this.setDeltaHeight(width - this.parent.defaultCellHeight);
    }
    setWidth(width) {
        this.width = width;
        return this;
    }
    get scene() {
        return this.parentContainer.scene;
    }
}
Object.assign($3f1a34a79a9f8652$var$Cell.prototype, (0, $90fdebfc958065d1$export$2e2bcd8739ae039));
var $3f1a34a79a9f8652$export$2e2bcd8739ae039 = $3f1a34a79a9f8652$var$Cell;


class $39e62d6bdfefe3b4$var$Stack {
    constructor(){
        this.items = [];
    }
    destroy() {
        this.clear();
        this.items = undefined;
    }
    pop() {
        return this.items.length > 0 ? this.items.pop() : null;
    }
    push(l) {
        this.items.push(l);
        return this;
    }
    pushMultiple(arr) {
        this.items.push.apply(this.items, arr);
        arr.length = 0;
        return this;
    }
    clear() {
        this.items.length = 0;
        return this;
    }
}
var $39e62d6bdfefe3b4$export$2e2bcd8739ae039 = $39e62d6bdfefe3b4$var$Stack;


var $3a1e84ac82f806c8$export$2e2bcd8739ae039 = (0, $39e62d6bdfefe3b4$export$2e2bcd8739ae039);


const $cdc5c7a476ef8c52$var$GetValue = Phaser.Utils.Objects.GetValue;
const $cdc5c7a476ef8c52$var$SpliceOne = Phaser.Utils.Array.SpliceOne;
class $cdc5c7a476ef8c52$var$Table {
    constructor(parent, config){
        this.parent = parent; // parent: GridTable game object (Container)
        this.cells = [];
        this.cellPool = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        if (o === undefined) o = {};
        this.colCount = undefined;
        this.nonZeroDeltaHeightCount = 0;
        this.resetTotalRowsHeight();
        var cellHeight = o.cellHeight;
        if (cellHeight === undefined) cellHeight = 30;
        var cellWidth = o.cellWidth;
        if (cellWidth === undefined) cellWidth = 30;
        this.setDefaultCellHeight(cellHeight);
        this.setDefaultCellWidth(cellWidth);
        this.initCells($cdc5c7a476ef8c52$var$GetValue(o, "cellsCount", 0));
        this.setColumnCount($cdc5c7a476ef8c52$var$GetValue(o, "columns", 1));
        return this;
    }
    destroy(fromScene) {
        // GridTable is destroyed, all cell containers will also be destroyed too
        // Don't have to freeCell
        this.cellPool.destroy();
        this.cells = undefined;
        this.parent = undefined;
    }
    get defaultCellHeightMode() {
        return this.nonZeroDeltaHeightCount === 0;
    }
    setDefaultCellHeight(height) {
        this.defaultCellHeight = height;
        return this;
    }
    setDefaultCellWidth(width) {
        this.defaultCellWidth = width;
        return this;
    }
    initCells(size) {
        var cells = this.cells;
        cells.length = size;
        for(var i = 0; i < size; i++)cells[i] = null;
        return this;
    }
    insertNewCells(cellIdx, count) {
        var cells = this.cells;
        if (cellIdx === cells.length) {
            // append at end of array
            var endIdx = cellIdx + count;
            cells.legth = endIdx;
            for(var i = cellIdx; i < endIdx; i++)cells[i] = null;
        } else {
            var newCells = [];
            newCells.length = count;
            for(var i = 0; i < count; i++)newCells[i] = null;
            this.cells.splice(cellIdx, 0, ...newCells);
        }
        this.resetTotalRowsHeight();
        return this;
    }
    removeCells(cellIdx, count) {
        var endIdx = cellIdx + count;
        for(var i = cellIdx; i < endIdx; i++)this.freeCell(i);
        if (endIdx === this.cells.length) // remove until end of array
        this.cells.length = cellIdx;
        else {
            if (count === 1) $cdc5c7a476ef8c52$var$SpliceOne(this.cells, cellIdx);
            else this.cells.splice(cellIdx, count);
            this.buildCellIndex(cellIdx);
        }
        this.resetTotalRowsHeight();
        return this;
    }
    setColumnCount(cnt) {
        this.colCount = cnt;
        this.resetTotalRowsHeight();
        return this;
    }
    get rowCount() {
        return Math.ceil(this.cells.length / this.colCount);
    }
    get cellsCount() {
        return this.cells.length;
    }
    isValidCellIdx(idx) {
        return idx >= 0 && idx < this.cells.length;
    }
    heightToRowIndex(height, roundMode) {
        if (roundMode === undefined) roundMode = 0;
        /*
        roundMode:
        - 0 : floor
        - 1 : ceil
        - 2 : plus one if rowIdx is an integer, else floor
        */ if (height === 0) return 0;
        // defaultCellHeightMode
        if (this.defaultCellHeightMode) {
            var rowIdx = height / this.defaultCellHeight;
            switch(roundMode){
                case 0:
                    rowIdx = Math.floor(rowIdx);
                    break;
                case 1:
                    rowIdx = Math.ceil(rowIdx);
                    break;
                default:
                    if (Number.isInteger(rowIdx)) rowIdx += 1;
                    else rowIdx = Math.floor(rowIdx);
                    break;
            }
            return rowIdx;
        }
        // count cell height one by one
        var rowCount = this.rowCount;
        var remainder = height, isValidIdx;
        var cell, rowHeight, rowIdx = 0;
        while(true){
            rowHeight = this.getRowHeight(rowIdx);
            remainder -= rowHeight;
            isValidIdx = rowIdx >= 0 && rowIdx < rowCount;
            if (remainder > 0 && isValidIdx) rowIdx += 1;
            else if (remainder === 0) {
                if (roundMode === 2) rowIdx += 1;
                return rowIdx;
            } else {
                if (roundMode === 1) {
                    var preRowIdx = rowIdx;
                    rowIdx += 1;
                    isValidIdx = rowIdx >= 0 && rowIdx < rowCount;
                    if (!isValidIdx) rowIdx = preRowIdx;
                }
                return rowIdx;
            }
        }
    }
    widthToColIndex(width, isCeil) {
        if (width === 0) return 0;
        var colIdx = width / this.defaultCellWidth;
        if (isCeil) colIdx = Math.ceil(colIdx);
        else colIdx = Math.floor(colIdx);
        return colIdx;
    }
    colRowToCellIndex(colIdx, rowIdx) {
        if (colIdx >= this.colCount) return null;
        return rowIdx * this.colCount + colIdx;
    }
    rowIndexToHeight(start, end) {
        // defaultCellHeightMode
        if (this.defaultCellHeightMode) return (end - start + 1) * this.defaultCellHeight;
        var h, sum = 0;
        for(var i = start; i <= end; i++){
            h = this.getRowHeight(i);
            sum += h;
        }
        return sum;
    }
    colIndexToWidth(start, end) {
        return (end - start + 1) * this.defaultCellWidth;
    }
    getRowHeight(rowIdx) {
        var cnt = this.colCount;
        // single column
        if (cnt <= 1) return this.getCellHeight(this.colRowToCellIndex(0, rowIdx));
        // multiple columns, get the maximum height
        var maxHeight = 0, cellHeight;
        for(var i = 0; i < cnt; i++){
            cellHeight = this.getCellHeight(this.colRowToCellIndex(i, rowIdx));
            if (maxHeight < cellHeight) maxHeight = cellHeight;
        }
        return maxHeight;
    }
    getColWidth(idx) {
        return this.defaultCellWidth;
    }
    getCellHeight(cellIdx) {
        if (!this.isValidCellIdx(cellIdx)) return 0;
        var cellHeight;
        if (this.defaultCellHeightMode) cellHeight = this.defaultCellHeight;
        else {
            var cell = this.getCell(cellIdx, false);
            var deltaHeight = cell ? cell.deltaHeight : 0;
            cellHeight = this.defaultCellHeight + deltaHeight;
        }
        return cellHeight;
    }
    resetTotalRowsHeight() {
        this._totalRowsHeight = null;
    }
    get totalRowsHeight() {
        if (this._totalRowsHeight === null) this._totalRowsHeight = this.rowIndexToHeight(0, this.rowCount - 1);
        return this._totalRowsHeight;
    }
    get totalColumnWidth() {
        return this.colCount * this.defaultCellWidth;
    }
    cellIndxeToColIndex(cellIdx) {
        return cellIdx % this.colCount;
    }
    cellIndxeToRowIndex(cellIdx) {
        return Math.floor(cellIdx / this.colCount);
    }
    getCell(cellIdx, createNewCell) {
        if (!this.isValidCellIdx(cellIdx)) return null;
        if (createNewCell === undefined) createNewCell = true;
        if (this.cells[cellIdx] === null && createNewCell) {
            var cell = this.newCell(cellIdx);
            this.cells[cellIdx] = cell;
        }
        return this.cells[cellIdx];
    }
    newCell(cellIdx) {
        var cell = this.cellPool.pop();
        if (cell === null) cell = new (0, $3f1a34a79a9f8652$export$2e2bcd8739ae039)(this);
        else cell.setParent(this);
        cell.index = cellIdx;
        return cell;
    }
    buildCellIndex(startIdx) {
        if (startIdx === undefined) startIdx = 0;
        var cells = this.cells, cell;
        for(var i = startIdx, len = cells.length; i < len; i++){
            cell = cells[i];
            if (cell) cell.index = i;
        }
        return this;
    }
    getParentContainer() {
        return this.parent;
    }
    freeCell(cell) {
        if (typeof cell === "number") cell = this.cells[cell];
        if (!cell) return this;
        cell.destroy();
        this.cellPool.push(cell);
        return this;
    }
}
var $cdc5c7a476ef8c52$export$2e2bcd8739ae039 = $cdc5c7a476ef8c52$var$Table;


var $a224d2aab8b9336d$var$SetTableOY = function(oy) {
    var table = this.table;
    var topTableOY = this.topTableOY;
    var bottomTableOY = this.bottomTableOY;
    var tableOYExceedTop = oy > this.topTableOY;
    var tableOYExeceedBottom = oy < this.bottomTableOY;
    if (this.clampTableOXY) {
        var rowCount = table.rowCount;
        var visibleRowCount = table.heightToRowIndex(this.instHeight, 1);
        // less then 1 page
        if (rowCount < visibleRowCount) oy = 0;
        else if (tableOYExceedTop) oy = topTableOY;
        else if (tableOYExeceedBottom) oy = bottomTableOY;
    }
    if (this._tableOY !== oy) this._tableOY = oy;
    if (tableOYExceedTop) {
        if (!this.execeedTopState) this.emit("execeedtop", this, oy, topTableOY);
    }
    this.execeedTopState = tableOYExceedTop;
    if (tableOYExeceedBottom) {
        if (!this.execeedBottomState) this.emit("execeedbottom", this, oy, bottomTableOY);
    }
    this.execeedBottomState = tableOYExeceedBottom;
    return this;
};
var $a224d2aab8b9336d$export$2e2bcd8739ae039 = $a224d2aab8b9336d$var$SetTableOY;


var $7c1d0c834b96dc23$var$SetTableOX = function(ox) {
    var table = this.table;
    var leftTableOX = this.leftTableOX;
    var rightTableOX = this.rightTableOX;
    var tableOXExeceedLeft = ox > this.leftTableOX;
    var tableOXExeceedRight = ox < this.rightTableOX;
    if (this.clampTableOXY) {
        var colCount = table.colCount;
        var visibleColCount = table.widthToColIndex(this.instWidth, true);
        // less then 1 page            
        if (colCount < visibleColCount) ox = 0;
        else if (tableOXExeceedLeft) ox = leftTableOX;
        else // var tableVisibleWidth = this.tableVisibleWidth;
        if (tableOXExeceedRight) ox = rightTableOX;
    }
    if (this._tableOX !== ox) this._tableOX = ox;
    if (tableOXExeceedLeft) {
        if (!this.execeedLeftState) this.emit("execeedleft", this, ox, leftTableOX);
    }
    this.execeedLeftState = tableOXExeceedLeft;
    if (tableOXExeceedRight) {
        if (!this.execeedRightState) this.emit("execeedright", this, ox, rightTableOX);
    }
    this.execeedRightState = tableOXExeceedRight;
    return this;
};
var $7c1d0c834b96dc23$export$2e2bcd8739ae039 = $7c1d0c834b96dc23$var$SetTableOX;


var $d9e0c4993fa99f05$var$MaskToGameObject = function(mask) {
    return mask.hasOwnProperty("geometryMask") ? mask.geometryMask : mask.bitmapMask;
};
var $d9e0c4993fa99f05$export$2e2bcd8739ae039 = $d9e0c4993fa99f05$var$MaskToGameObject;


const $552f267606498f91$var$Intersects = Phaser.Geom.Intersects.RectangleToRectangle;
const $552f267606498f91$var$Overlaps = Phaser.Geom.Rectangle.Overlaps;
var $552f267606498f91$var$MaskChildren = function(parent, mask, children) {
    if (!mask) return;
    if (children === undefined) children = parent.getAllChildren();
    var parentBounds = parent.getBounds();
    var maskGameObject = (0, $d9e0c4993fa99f05$export$2e2bcd8739ae039)(mask);
    var child, childBounds, visiblePointsNumber;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.hasOwnProperty("isRexContainerLite")) continue;
        if (child === maskGameObject) continue;
        if (!$552f267606498f91$var$IsVisible(child)) continue;
        if (child.getBounds) {
            childBounds = child.getBounds(childBounds);
            visiblePointsNumber = $552f267606498f91$var$ContainsPoints(parentBounds, childBounds);
            switch(visiblePointsNumber){
                case 4:
                    $552f267606498f91$var$ShowAll(parent, child, mask);
                    break;
                case 0:
                    // Parent intersects with child, or parent is inside child, set visible, and apply mask
                    if ($552f267606498f91$var$Intersects(parentBounds, childBounds) || $552f267606498f91$var$Overlaps(parentBounds, childBounds)) $552f267606498f91$var$ShowSome(parent, child, mask);
                    else $552f267606498f91$var$ShowNone(parent, child, mask);
                    break;
                default:
                    $552f267606498f91$var$ShowSome(parent, child, mask);
                    break;
            }
        } else $552f267606498f91$var$ShowSome(parent, child, mask);
    }
};
var $552f267606498f91$var$IsVisible = function(gameObject) {
    if (!gameObject.displayList) return false;
    while(true){
        var localState = gameObject.rexContainer;
        if (!localState) return gameObject.visible;
        else if (localState.visible) {
            var parent = localState.parent;
            if (parent) {
                gameObject = parent;
                continue;
            } else return true;
        } else return false;
    }
};
var $552f267606498f91$var$ContainsPoints = function(rectA, rectB) {
    var result = 0;
    var top = rectB.top, bottom = rectB.bottom, left = rectB.left, right = rectB.right;
    result += rectA.contains(left, top) ? 1 : 0;
    result += rectA.contains(left, bottom) ? 1 : 0;
    result += rectA.contains(right, top) ? 1 : 0;
    result += rectA.contains(right, bottom) ? 1 : 0;
    return result;
};
var $552f267606498f91$var$ShowAll = function(parent, child, mask) {
    parent.setChildMaskVisible(child, true);
    if (child.clearMask) child.clearMask();
};
var $552f267606498f91$var$ShowSome = function(parent, child, mask) {
    parent.setChildMaskVisible(child, true);
    if (child.setMask) child.setMask(mask);
};
var $552f267606498f91$var$ShowNone = function(parent, child, mask) {
    parent.setChildMaskVisible(child, false);
    if (child.clearMask) child.clearMask();
};
var $552f267606498f91$export$2e2bcd8739ae039 = $552f267606498f91$var$MaskChildren;


var $d45d439e116138e2$var$DrawShape = function(width, height, padding, originX, originY) {
    this.clear().fillStyle(0xffffff);
    switch(this.shape){
        case 1:
            var radius = Math.min(width, height) / 2;
            this.fillCircle(-width * (originX - 0.5), -height * (originY - 0.5), radius + padding);
            break;
        default:
            this.fillRect(-(width * originX) - padding, -(height * originY) - padding, width + 2 * padding, height + 2 * padding);
            break;
    }
};
var $d45d439e116138e2$export$2e2bcd8739ae039 = $d45d439e116138e2$var$DrawShape;


const $bf9d9eb28e7b19f2$var$Graphics = Phaser.GameObjects.Graphics;
class $bf9d9eb28e7b19f2$var$DefaultMaskGraphics extends $bf9d9eb28e7b19f2$var$Graphics {
    constructor(parent, shape, padding){
        if (shape === undefined) shape = 0;
        if (typeof shape === "string") shape = $bf9d9eb28e7b19f2$var$SHAPEMODE[shape];
        if (padding === undefined) padding = 0;
        super(parent.scene);
        this.parent = parent;
        this.shape = shape;
        this.padding = padding;
        this.setPosition().resize().setVisible(false);
    // Don't add it to display list
    }
    destroy() {
        this.parent = undefined;
        super.destroy();
        return this;
    }
    setPosition(x, y) {
        var parent = this.parent;
        if (x === undefined) x = parent.x;
        if (y === undefined) y = parent.y;
        super.setPosition(x, y);
        return this;
    }
    resize(width, height, padding) {
        var parent = this.parent;
        if (width === undefined) width = parent.width;
        if (height === undefined) height = parent.height;
        if (padding === undefined) padding = this.padding;
        if (this.width === width && this.height === height && this.paddingSave === padding) return this;
        this.width = width;
        this.height = height;
        this.originX = parent.originX;
        this.originY = parent.originY;
        this.paddingSave = padding;
        (0, $d45d439e116138e2$export$2e2bcd8739ae039).call(this, width, height, padding, parent.originX, parent.originY);
        return this;
    }
    setOrigin(originX, originY) {
        if (originY === undefined) originY = originX;
        var parent = this.parent;
        if (originX === undefined) originX = parent.originX;
        if (originY === undefined) originY = parent.originY;
        if (this.originX === originX && this.originY === originY) return this;
        this.originX = originX;
        this.originY = originY;
        (0, $d45d439e116138e2$export$2e2bcd8739ae039).call(this, this.width, this.height, this.paddingSave, originX, originY);
        return this;
    }
}
const $bf9d9eb28e7b19f2$var$SHAPEMODE = {
    rectangle: 0,
    circle: 1
};
var $bf9d9eb28e7b19f2$export$2e2bcd8739ae039 = $bf9d9eb28e7b19f2$var$DefaultMaskGraphics;


var $a0eb54418fe4678f$var$AddChildMask = function(maskTarget, sizeTarget, shape, padding) {
    var maskGameObject = new (0, $bf9d9eb28e7b19f2$export$2e2bcd8739ae039)(sizeTarget, shape, padding); // A Graphics game object
    if (maskTarget && !maskTarget.isRexSizer) {
        var mask = maskGameObject.createGeometryMask();
        maskTarget.setMask(mask);
        this.once("destroy", function() {
            maskTarget.setMask();
            mask.destroy();
        });
    }
    this.pin(maskGameObject);
    return maskGameObject;
};
var $a0eb54418fe4678f$export$2e2bcd8739ae039 = $a0eb54418fe4678f$var$AddChildMask;



const $3a1020a77d4e472b$var$GetValue = Phaser.Utils.Objects.GetValue;
const $3a1020a77d4e472b$var$MASKUPDATEMODE = {
    update: 0,
    everyTick: 1
};
var $3a1020a77d4e472b$export$2e2bcd8739ae039 = {
    setupChildrenMask (config) {
        if (config === false) // No children mask
        return this;
        this.setMaskUpdateMode($3a1020a77d4e472b$var$GetValue(config, "updateMode", 0));
        this.enableChildrenMask($3a1020a77d4e472b$var$GetValue(config, "padding", 0));
        this.setMaskLayer($3a1020a77d4e472b$var$GetValue(config, "layer", undefined));
        this.startMaskUpdate();
        return this;
    },
    destroyChildrenMask () {
        if (!this.childrenMask) return this;
        this.stopMaskUpdate();
        this.childrenMask.destroy();
        this.childrenMask = undefined;
        return this;
    },
    setMaskUpdateMode (mode) {
        if (typeof mode === "string") mode = $3a1020a77d4e472b$var$MASKUPDATEMODE[mode];
        this.maskUpdateMode = mode;
        return this;
    },
    startMaskUpdate () {
        this.scene.game.events.on("poststep", this.maskChildren, this);
    },
    stopMaskUpdate () {
        this.scene.game.events.off("poststep", this.maskChildren, this);
    },
    enableChildrenMask (maskPadding) {
        var maskGameObject = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, null, this, 0, maskPadding);
        this.childrenMask = maskGameObject.createGeometryMask();
        // this.childrenMask is a mask object, not a (Graphics) game object
        return this;
    },
    setMaskChildrenFlag (value) {
        if (value === undefined) value = true;
        this.maskChildrenFlag = value;
        return this;
    },
    setMaskLayer (layer) {
        // To reduce amount of masked game object
        this.maskLayer = layer;
        return this;
    },
    maskChildren () {
        if (!this.childrenMask || // No childrenMask
        !this.maskChildrenFlag || // No maskChildrenFlag set
        this.alpha === 0 || !this.visible // Parent is not visible
        ) return this;
        if (this.privateRenderLayer) this.privateRenderLayer.setMask(this.childrenMask);
        else if (this.maskLayer) {
            // 1. Add parent and children into layer
            this.addToLayer(this.maskLayer);
            // 2. Mask this layer
            this.maskLayer.setMask(this.childrenMask);
        } else (0, $552f267606498f91$export$2e2bcd8739ae039)(this, this.childrenMask);
        if (this.maskUpdateMode === 0) this.maskChildrenFlag = false;
        return this;
    },
    layoutChildrenMask () {
        if (!this.childrenMask) return this;
        var maskGameObject = (0, $d9e0c4993fa99f05$export$2e2bcd8739ae039)(this.childrenMask);
        maskGameObject.setPosition().resize();
        this.resetChildPositionState(maskGameObject);
        return this;
    }
};


var $990223f7da3447ad$var$NOOP = function() {
//  NOOP
};
var $990223f7da3447ad$export$2e2bcd8739ae039 = $990223f7da3447ad$var$NOOP;


var $80840a65bc2c7700$var$globZone = new Phaser.GameObjects.Zone({
    sys: {
        queueDepthSort: (0, $990223f7da3447ad$export$2e2bcd8739ae039),
        events: {
            once: (0, $990223f7da3447ad$export$2e2bcd8739ae039)
        }
    }
}, 0, 0, 1, 1);
$80840a65bc2c7700$var$globZone.setOrigin(0);
var $80840a65bc2c7700$export$2e2bcd8739ae039 = $80840a65bc2c7700$var$globZone;


var $59fab53e91b2de17$var$ALIGN_CONST = {
    /**
    * A constant representing a top-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_LEFT
    * @since 3.0.0
    * @type {integer}
    */ TOP_LEFT: 0,
    /**
    * A constant representing a top-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_CENTER
    * @since 3.0.0
    * @type {integer}
    */ TOP_CENTER: 1,
    /**
    * A constant representing a top-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_RIGHT
    * @since 3.0.0
    * @type {integer}
    */ TOP_RIGHT: 2,
    /**
    * A constant representing a left-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_TOP
    * @since 3.0.0
    * @type {integer}
    */ LEFT_TOP: 3,
    /**
    * A constant representing a left-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_CENTER
    * @since 3.0.0
    * @type {integer}
    */ LEFT_CENTER: 4,
    /**
    * A constant representing a left-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_BOTTOM
    * @since 3.0.0
    * @type {integer}
    */ LEFT_BOTTOM: 5,
    /**
    * A constant representing a center alignment or position.
    * @constant
    * @name Phaser.Display.Align.CENTER
    * @since 3.0.0
    * @type {integer}
    */ CENTER: 6,
    /**
    * A constant representing a right-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_TOP
    * @since 3.0.0
    * @type {integer}
    */ RIGHT_TOP: 7,
    /**
    * A constant representing a right-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_CENTER
    * @since 3.0.0
    * @type {integer}
    */ RIGHT_CENTER: 8,
    /**
    * A constant representing a right-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_BOTTOM
    * @since 3.0.0
    * @type {integer}
    */ RIGHT_BOTTOM: 9,
    /**
    * A constant representing a bottom-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_LEFT
    * @since 3.0.0
    * @type {integer}
    */ BOTTOM_LEFT: 10,
    /**
    * A constant representing a bottom-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_CENTER
    * @since 3.0.0
    * @type {integer}
    */ BOTTOM_CENTER: 11,
    /**
    * A constant representing a bottom-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_RIGHT
    * @since 3.0.0
    * @type {integer}
    */ BOTTOM_RIGHT: 12
};
var $59fab53e91b2de17$export$2e2bcd8739ae039 = $59fab53e91b2de17$var$ALIGN_CONST;



var $55a749770af81adb$var$GetBottom = function(gameObject) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    return gameObject.y + height - height * gameObject.originY;
};
var $55a749770af81adb$export$2e2bcd8739ae039 = $55a749770af81adb$var$GetBottom;



var $a9558b8d6fab71ce$var$GetCenterX = function(gameObject) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    return gameObject.x - width * gameObject.originX + width * 0.5;
};
var $a9558b8d6fab71ce$export$2e2bcd8739ae039 = $a9558b8d6fab71ce$var$GetCenterX;



var $89095fc1dfc36325$var$SetBottom = function(gameObject, value) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    gameObject.y = value - height + height * gameObject.originY;
    return gameObject;
};
var $89095fc1dfc36325$export$2e2bcd8739ae039 = $89095fc1dfc36325$var$SetBottom;



var $1207b10981f3c019$var$SetCenterX = function(gameObject, x) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    var offsetX = width * gameObject.originX;
    gameObject.x = x + offsetX - width * 0.5;
    return gameObject;
};
var $1207b10981f3c019$export$2e2bcd8739ae039 = $1207b10981f3c019$var$SetCenterX;


var $975047af831cb5bf$var$BottomCenter = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $1207b10981f3c019$export$2e2bcd8739ae039)(gameObject, (0, $a9558b8d6fab71ce$export$2e2bcd8739ae039)(alignIn) + offsetX);
    (0, $89095fc1dfc36325$export$2e2bcd8739ae039)(gameObject, (0, $55a749770af81adb$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $975047af831cb5bf$export$2e2bcd8739ae039 = $975047af831cb5bf$var$BottomCenter;




var $93b235cf15b31791$var$GetLeft = function(gameObject) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    return gameObject.x - width * gameObject.originX;
};
var $93b235cf15b31791$export$2e2bcd8739ae039 = $93b235cf15b31791$var$GetLeft;




var $141e6f32f5395f33$var$SetLeft = function(gameObject, value) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    gameObject.x = value + width * gameObject.originX;
    return gameObject;
};
var $141e6f32f5395f33$export$2e2bcd8739ae039 = $141e6f32f5395f33$var$SetLeft;


var $eeaf3900efa6e885$var$BottomLeft = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $141e6f32f5395f33$export$2e2bcd8739ae039)(gameObject, (0, $93b235cf15b31791$export$2e2bcd8739ae039)(alignIn) - offsetX);
    (0, $89095fc1dfc36325$export$2e2bcd8739ae039)(gameObject, (0, $55a749770af81adb$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $eeaf3900efa6e885$export$2e2bcd8739ae039 = $eeaf3900efa6e885$var$BottomLeft;




var $6e08541d1fe3f79c$var$GetRight = function(gameObject) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    return gameObject.x + width - width * gameObject.originX;
};
var $6e08541d1fe3f79c$export$2e2bcd8739ae039 = $6e08541d1fe3f79c$var$GetRight;




var $8176646d86a51932$var$SetRight = function(gameObject, value) {
    var width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject);
    gameObject.x = value - width + width * gameObject.originX;
    return gameObject;
};
var $8176646d86a51932$export$2e2bcd8739ae039 = $8176646d86a51932$var$SetRight;


var $6e15b004e4685283$var$BottomRight = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $8176646d86a51932$export$2e2bcd8739ae039)(gameObject, (0, $6e08541d1fe3f79c$export$2e2bcd8739ae039)(alignIn) + offsetX);
    (0, $89095fc1dfc36325$export$2e2bcd8739ae039)(gameObject, (0, $55a749770af81adb$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $6e15b004e4685283$export$2e2bcd8739ae039 = $6e15b004e4685283$var$BottomRight;




var $e3b4bd6c17751047$var$SetCenterY = function(gameObject, y) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    var offsetY = height * gameObject.originY;
    gameObject.y = y + offsetY - height * 0.5;
    return gameObject;
};
var $e3b4bd6c17751047$export$2e2bcd8739ae039 = $e3b4bd6c17751047$var$SetCenterY;


var $3fb229b488c6cf05$var$CenterOn = function(gameObject, x, y) {
    (0, $1207b10981f3c019$export$2e2bcd8739ae039)(gameObject, x);
    return (0, $e3b4bd6c17751047$export$2e2bcd8739ae039)(gameObject, y);
};
var $3fb229b488c6cf05$export$2e2bcd8739ae039 = $3fb229b488c6cf05$var$CenterOn;




var $356ad5a5bee36cbf$var$GetCenterY = function(gameObject) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    return gameObject.y - height * gameObject.originY + height * 0.5;
};
var $356ad5a5bee36cbf$export$2e2bcd8739ae039 = $356ad5a5bee36cbf$var$GetCenterY;


var $f22d959ae2dd012f$var$Center = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $3fb229b488c6cf05$export$2e2bcd8739ae039)(gameObject, (0, $a9558b8d6fab71ce$export$2e2bcd8739ae039)(alignIn) + offsetX, (0, $356ad5a5bee36cbf$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $f22d959ae2dd012f$export$2e2bcd8739ae039 = $f22d959ae2dd012f$var$Center;






var $49d04fc258a500db$var$LeftCenter = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $141e6f32f5395f33$export$2e2bcd8739ae039)(gameObject, (0, $93b235cf15b31791$export$2e2bcd8739ae039)(alignIn) - offsetX);
    (0, $e3b4bd6c17751047$export$2e2bcd8739ae039)(gameObject, (0, $356ad5a5bee36cbf$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $49d04fc258a500db$export$2e2bcd8739ae039 = $49d04fc258a500db$var$LeftCenter;






var $f2c0683dff4ccf2a$var$RightCenter = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $8176646d86a51932$export$2e2bcd8739ae039)(gameObject, (0, $6e08541d1fe3f79c$export$2e2bcd8739ae039)(alignIn) + offsetX);
    (0, $e3b4bd6c17751047$export$2e2bcd8739ae039)(gameObject, (0, $356ad5a5bee36cbf$export$2e2bcd8739ae039)(alignIn) + offsetY);
    return gameObject;
};
var $f2c0683dff4ccf2a$export$2e2bcd8739ae039 = $f2c0683dff4ccf2a$var$RightCenter;




var $40d6b39d8457b9fc$var$GetTop = function(gameObject) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    return gameObject.y - height * gameObject.originY;
};
var $40d6b39d8457b9fc$export$2e2bcd8739ae039 = $40d6b39d8457b9fc$var$GetTop;




var $434c03cbab366dcf$var$SetTop = function(gameObject, value) {
    var height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject);
    gameObject.y = value + height * gameObject.originY;
    return gameObject;
};
var $434c03cbab366dcf$export$2e2bcd8739ae039 = $434c03cbab366dcf$var$SetTop;


var $712d96abc00e2dc0$var$TopCenter = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $1207b10981f3c019$export$2e2bcd8739ae039)(gameObject, (0, $a9558b8d6fab71ce$export$2e2bcd8739ae039)(alignIn) + offsetX);
    (0, $434c03cbab366dcf$export$2e2bcd8739ae039)(gameObject, (0, $40d6b39d8457b9fc$export$2e2bcd8739ae039)(alignIn) - offsetY);
    return gameObject;
};
var $712d96abc00e2dc0$export$2e2bcd8739ae039 = $712d96abc00e2dc0$var$TopCenter;






var $001c6155c483d1aa$var$TopLeft = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $141e6f32f5395f33$export$2e2bcd8739ae039)(gameObject, (0, $93b235cf15b31791$export$2e2bcd8739ae039)(alignIn) - offsetX);
    (0, $434c03cbab366dcf$export$2e2bcd8739ae039)(gameObject, (0, $40d6b39d8457b9fc$export$2e2bcd8739ae039)(alignIn) - offsetY);
    return gameObject;
};
var $001c6155c483d1aa$export$2e2bcd8739ae039 = $001c6155c483d1aa$var$TopLeft;






var $c9baa79a4045b35c$var$TopRight = function(gameObject, alignIn, offsetX, offsetY) {
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    (0, $8176646d86a51932$export$2e2bcd8739ae039)(gameObject, (0, $6e08541d1fe3f79c$export$2e2bcd8739ae039)(alignIn) + offsetX);
    (0, $434c03cbab366dcf$export$2e2bcd8739ae039)(gameObject, (0, $40d6b39d8457b9fc$export$2e2bcd8739ae039)(alignIn) - offsetY);
    return gameObject;
};
var $c9baa79a4045b35c$export$2e2bcd8739ae039 = $c9baa79a4045b35c$var$TopRight;


var $2d796d344b5ce591$var$AlignInMap = [];
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).BOTTOM_CENTER] = (0, $975047af831cb5bf$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).BOTTOM_LEFT] = (0, $eeaf3900efa6e885$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).BOTTOM_RIGHT] = (0, $6e15b004e4685283$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).CENTER] = (0, $f22d959ae2dd012f$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).LEFT_CENTER] = (0, $49d04fc258a500db$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).RIGHT_CENTER] = (0, $f2c0683dff4ccf2a$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).TOP_CENTER] = (0, $712d96abc00e2dc0$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).TOP_LEFT] = (0, $001c6155c483d1aa$export$2e2bcd8739ae039);
$2d796d344b5ce591$var$AlignInMap[(0, $59fab53e91b2de17$export$2e2bcd8739ae039).TOP_RIGHT] = (0, $c9baa79a4045b35c$export$2e2bcd8739ae039);
var $2d796d344b5ce591$var$QuickSet = function(child, alignIn, position, offsetX, offsetY) {
    return $2d796d344b5ce591$var$AlignInMap[position](child, alignIn, offsetX, offsetY);
};
var $2d796d344b5ce591$export$2e2bcd8739ae039 = $2d796d344b5ce591$var$QuickSet;


var $b7e28befb839484c$var$AlignIn = function(child, x, y, width, height, align) {
    (0, $80840a65bc2c7700$export$2e2bcd8739ae039).setPosition(x, y).setSize(width, height);
    (0, $2d796d344b5ce591$export$2e2bcd8739ae039)(child, (0, $80840a65bc2c7700$export$2e2bcd8739ae039), align);
};
var $b7e28befb839484c$export$2e2bcd8739ae039 = $b7e28befb839484c$var$AlignIn;


var $f7b38c8a7d42edb1$var$ShowCells = function() {
    if (this.cellsCount === 0) return;
    var table = this.table;
    this.startRowIndex = Math.max(table.heightToRowIndex(-this.tableOY, 2), 0);
    var rowIndex = this.startRowIndex;
    var startColumnIndex = Math.max(table.widthToColIndex(-this.tableOX), 0);
    var columnIndex = startColumnIndex;
    var cellIdx = table.colRowToCellIndex(columnIndex, rowIndex);
    var bottomBound = this.bottomBound;
    var rightBound = this.rightBound;
    var lastIdx = table.cellsCount - 1;
    var lastColIdx = table.colCount - 1;
    var startCellTLX = this.getCellTLX(columnIndex), cellTLX = startCellTLX;
    var cellTLY = this.getCellTLY(rowIndex);
    while(cellTLY < bottomBound && cellIdx <= lastIdx){
        if (this.table.isValidCellIdx(cellIdx)) {
            var cell = table.getCell(cellIdx, true);
            this.visibleCells.set(cell);
            if (!this.preVisibleCells.contains(cell)) this.showCell(cell);
            var x, y;
            if (this.scrollMode === 0) {
                x = cellTLX;
                y = cellTLY;
            } else {
                x = cellTLY;
                y = cellTLX;
            }
            if (cell.cellContainerAlign == null) cell.setXY(x, y);
            else {
                var cellContainer = cell.getContainer();
                (0, $b7e28befb839484c$export$2e2bcd8739ae039)(cellContainer, x, y, cell.width, cell.height, cell.cellContainerAlign);
                cell.setXY(cellContainer.x, cellContainer.y);
            }
        }
        if (cellTLX < rightBound && columnIndex < lastColIdx) {
            cellTLX += table.getColWidth(columnIndex);
            columnIndex += 1;
        } else {
            cellTLX = startCellTLX;
            cellTLY += table.getRowHeight(rowIndex);
            columnIndex = startColumnIndex;
            rowIndex += 1;
        }
        cellIdx = table.colRowToCellIndex(columnIndex, rowIndex);
    }
};
var $f7b38c8a7d42edb1$export$2e2bcd8739ae039 = $f7b38c8a7d42edb1$var$ShowCells;


var $bd982a51dcaad553$var$ShowCell = function(cell) {
    // Attach container to cell by cell.setContainer(container) under this event
    var reusedCellContainer = null;
    var cellContainer = cell.getContainer();
    if (cellContainer) {
        reusedCellContainer = cellContainer;
        cell.popContainer();
    } else if (this.cellContainersPool) {
        reusedCellContainer = this.cellContainersPool.getFirstDead();
        if (reusedCellContainer !== null) reusedCellContainer.setActive(true).setVisible(true);
    }
    this.emit("cellvisible", cell, reusedCellContainer, this);
    if (this.cellContainersPool) {
        var cellContainer = cell.getContainer();
        if (cellContainer) {
            if (reusedCellContainer === null) this.cellContainersPool.add(cellContainer); // New cell container, add to pool
            else if (reusedCellContainer !== cellContainer) {
                // Why reusedCellContainer is not equal to cellContainer?
                this.cellContainersPool.add(cellContainer); // New cell container, add to pool
                this.cellContainersPool.killAndHide(reusedCellContainer); // Unused cell container, put back to pool
            }
        } else if (reusedCellContainer !== null) this.cellContainersPool.killAndHide(reusedCellContainer); // Unused cell container, put back to pool
    }
};
var $bd982a51dcaad553$export$2e2bcd8739ae039 = $bd982a51dcaad553$var$ShowCell;


var $559282c3d4c34370$var$GetCellTLX = function(colIdx) {
    var ox = this.scrollMode === 0 ? this.topLeftX : this.topLeftY;
    var x = this.tableOX + this.table.colIndexToWidth(0, colIdx - 1) + ox;
    return x;
};
var $559282c3d4c34370$export$2e2bcd8739ae039 = $559282c3d4c34370$var$GetCellTLX;


var $ac1a0f0a614d5b47$var$GetCellTLY = function(rowIdx) {
    var oy = this.scrollMode === 0 ? this.topLeftY : this.topLeftX;
    var y = this.tableOY + this.table.rowIndexToHeight(0, rowIdx - 1) + oy;
    return y;
};
var $ac1a0f0a614d5b47$export$2e2bcd8739ae039 = $ac1a0f0a614d5b47$var$GetCellTLY;


var $10210c317c18a36d$var$HideCells = function() {
    var preList = this.preVisibleCells;
    var curList = this.visibleCells;
    preList.iterate(function(cell) {
        if (!curList.contains(cell)) this.hideCell(cell);
    }, this);
};
var $10210c317c18a36d$export$2e2bcd8739ae039 = $10210c317c18a36d$var$HideCells;


var $3c1780ce4ac7b11f$var$HideCell = function(cell) {
    // Option: pop container of cell by cell.popContainer() under this event 
    this.emit("cellinvisible", cell);
    if (this.cellContainersPool) {
        var cellContainer = cell.popContainer(); // null if already been removed
        if (cellContainer) this.cellContainersPool.killAndHide(cellContainer);
    }
    cell.destroyContainer(); // Destroy container of cell
};
var $3c1780ce4ac7b11f$export$2e2bcd8739ae039 = $3c1780ce4ac7b11f$var$HideCell;


var $0a47a92a66f18935$var$UpdateTable = function(refresh) {
    if (refresh === undefined) refresh = false;
    if (refresh) {
        $0a47a92a66f18935$var$ClearVisibleCellIndexes.call(this);
        this.hideCells();
    }
    $0a47a92a66f18935$var$ClearVisibleCellIndexes.call(this);
    this.showCells();
    this.hideCells();
    this.setMaskChildrenFlag();
    return this;
};
var $0a47a92a66f18935$var$ClearVisibleCellIndexes = function() {
    var tmp = this.preVisibleCells;
    this.preVisibleCells = this.visibleCells;
    this.visibleCells = tmp;
    this.visibleCells.clear();
};
var $0a47a92a66f18935$export$2e2bcd8739ae039 = $0a47a92a66f18935$var$UpdateTable;


var $d61010db176c777d$var$IsCellVisible = function(cellIdx) {
    var cell = this.table.getCell(cellIdx, false);
    return cell && this.visibleCells.contains(cell);
};
var $d61010db176c777d$export$2e2bcd8739ae039 = $d61010db176c777d$var$IsCellVisible;


var $1543dac7312a6a8b$export$74457285787e6813 = function(x, y) {
    y -= this.y + this.topLeftY;
    x -= this.x + this.topLeftX;
    var offsetTableOY = this.tableOY - (this.scrollMode === 0 ? y : x);
    var offsetTableOX = this.tableOX - (this.scrollMode === 0 ? x : y);
    var table = this.table;
    var rowIdx = table.heightToRowIndex(-offsetTableOY, 0);
    var colIdx = table.widthToColIndex(-offsetTableOX);
    var cellIdx = table.colRowToCellIndex(colIdx, rowIdx);
    if (cellIdx === null) return null;
    if (!this.isCellVisible(cellIdx)) return null;
    return cellIdx;
};
var $1543dac7312a6a8b$export$efa488f3efeada54 = function(x, y) {
    var cellIdx = $1543dac7312a6a8b$export$74457285787e6813.call(this, x, y);
    if (cellIdx === null) return undefined;
    return this.getCellContainer(cellIdx);
};


// For when you know this Set will be modified during the iteration
var $a4bdcb7600f8ea7b$export$3c526fc8450dcbdc = function(callback, scope) {
    this.visibleCells.each(callback, scope);
    return this;
};
// For when you absolutely know this Set won't be modified during the iteration
var $a4bdcb7600f8ea7b$export$ec443eeed0220734 = function(callback, scope) {
    this.visibleCells.iterate(callback, scope);
    return this;
};
var $a4bdcb7600f8ea7b$export$686edfad90c48a3 = function(callback, scope) {
    this.table.cells.slice().forEach(callback, scope);
    return this;
};
var $a4bdcb7600f8ea7b$export$a6e1966015c36e33 = function(callback, scope) {
    this.table.cells.forEach(callback, scope);
    return this;
};


var $bf592ab5a80cbef8$var$SetCellsCount = function(count) {
    var cellsCount = this.cellsCount;
    if (cellsCount === count) return this;
    if (cellsCount > count) this.removeCells(count, cellsCount - count);
    else this.insertNewCells(cellsCount, count - cellsCount);
    return this;
};
var $bf592ab5a80cbef8$export$2e2bcd8739ae039 = $bf592ab5a80cbef8$var$SetCellsCount;


const $fc0412de52616138$var$Clamp = Phaser.Math.Clamp;
var $fc0412de52616138$var$InsertNewCells = function(cellIdx, count) {
    if (typeof cellIdx === "object") cellIdx = cellIdx.index;
    if (count === undefined) count = 1;
    if (count <= 0) return this;
    cellIdx = $fc0412de52616138$var$Clamp(cellIdx, 0, this.cellsCount);
    this.table.insertNewCells(cellIdx, count);
    return this;
};
var $fc0412de52616138$export$2e2bcd8739ae039 = $fc0412de52616138$var$InsertNewCells;



var $8f4e33aaff16dff9$var$RemoveCells = function(cellIdx, count) {
    if (typeof cellIdx === "object") cellIdx = cellIdx.index;
    if (count === undefined) count = 1;
    if (cellIdx < 0) {
        count += cellIdx;
        cellIdx = 0;
    }
    if (count <= 0) return this;
    // out-of-range
    if (cellIdx > this.cellsCount) return this;
    var cell;
    for(var i = cellIdx, endIdx = cellIdx + count; i < endIdx; i++){
        cell = this.getCell(i, false);
        if (cell) {
            if (this.visibleCells.contains(cell)) {
                (0, $3c1780ce4ac7b11f$export$2e2bcd8739ae039).call(this, cell);
                this.visibleCells.delete(cell);
            }
            this.preVisibleCells.delete(cell);
        }
    }
    this.table.removeCells(cellIdx, count);
    return this;
};
var $8f4e33aaff16dff9$export$2e2bcd8739ae039 = $8f4e33aaff16dff9$var$RemoveCells;


var $d2aa74c4d9d6aefb$var$SetColumnCount = function(count) {
    if (this.table.colCount === count) return this;
    this.table.setColumnCount(count);
    return this;
};
var $d2aa74c4d9d6aefb$export$2e2bcd8739ae039 = $d2aa74c4d9d6aefb$var$SetColumnCount;


var $31272094778a3746$var$SetGridSize = function(colCount, rowCount) {
    this.setCellsCount(colCount * rowCount);
    this.table.setColumnCount(colCount);
    return this;
};
var $31272094778a3746$export$2e2bcd8739ae039 = $31272094778a3746$var$SetGridSize;



var $ca443c2f83fa0704$var$UpdateVisibleCell = function(cellIdx) {
    var cell = this.table.getCell(cellIdx, false);
    if (!cell || !cell.container) return this;
    (0, $bd982a51dcaad553$export$2e2bcd8739ae039).call(this, cell);
    return this;
};
var $ca443c2f83fa0704$export$2e2bcd8739ae039 = $ca443c2f83fa0704$var$UpdateVisibleCell;


var $b6ecd49ae59d106f$var$methods = {
    setTableOY: (0, $a224d2aab8b9336d$export$2e2bcd8739ae039),
    setTableOX: (0, $7c1d0c834b96dc23$export$2e2bcd8739ae039),
    showCells: (0, $f7b38c8a7d42edb1$export$2e2bcd8739ae039),
    showCell: (0, $bd982a51dcaad553$export$2e2bcd8739ae039),
    getCellTLX: (0, $559282c3d4c34370$export$2e2bcd8739ae039),
    getCellTLY: (0, $ac1a0f0a614d5b47$export$2e2bcd8739ae039),
    hideCells: (0, $10210c317c18a36d$export$2e2bcd8739ae039),
    hideCell: (0, $3c1780ce4ac7b11f$export$2e2bcd8739ae039),
    updateTable: (0, $0a47a92a66f18935$export$2e2bcd8739ae039),
    isCellVisible: (0, $d61010db176c777d$export$2e2bcd8739ae039),
    pointToCellIndex: (0, $1543dac7312a6a8b$export$74457285787e6813),
    pointToCellContainer: (0, $1543dac7312a6a8b$export$efa488f3efeada54),
    eachVisibleCell: (0, $a4bdcb7600f8ea7b$export$3c526fc8450dcbdc),
    iterateVisibleCell: (0, $a4bdcb7600f8ea7b$export$ec443eeed0220734),
    eachCell: (0, $a4bdcb7600f8ea7b$export$686edfad90c48a3),
    iterateCell: (0, $a4bdcb7600f8ea7b$export$a6e1966015c36e33),
    setCellsCount: (0, $bf592ab5a80cbef8$export$2e2bcd8739ae039),
    insertNewCells: (0, $fc0412de52616138$export$2e2bcd8739ae039),
    removeCells: (0, $8f4e33aaff16dff9$export$2e2bcd8739ae039),
    setColumnCount: (0, $d2aa74c4d9d6aefb$export$2e2bcd8739ae039),
    setGridSize: (0, $31272094778a3746$export$2e2bcd8739ae039),
    updateVisibleCell: (0, $ca443c2f83fa0704$export$2e2bcd8739ae039)
};
Object.assign($b6ecd49ae59d106f$var$methods, (0, $3a1020a77d4e472b$export$2e2bcd8739ae039));
var $b6ecd49ae59d106f$export$2e2bcd8739ae039 = $b6ecd49ae59d106f$var$methods;


const $339617a0d54a0874$var$Group = Phaser.GameObjects.Group;
const $339617a0d54a0874$var$Set = Phaser.Structs.Set;
const $339617a0d54a0874$var$GetValue = Phaser.Utils.Objects.GetValue;
class $339617a0d54a0874$var$GridTable extends (0, $3799588e8b69e578$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, config){
        if (config === undefined) config = {};
        super(scene, x, y, width, height);
        this.type = "rexGridTable";
        this._tableOX = 0;
        this._tableOY = 0;
        this.visibleCells = new $339617a0d54a0874$var$Set();
        this.preVisibleCells = new $339617a0d54a0874$var$Set();
        this.execeedTopState = false;
        this.execeedBottomState = false;
        this.execeedLeftState = false;
        this.execeedRightState = false;
        var reuseCellContainer = $339617a0d54a0874$var$GetValue(config, "reuseCellContainer", false);
        if (reuseCellContainer) this.cellContainersPool = new $339617a0d54a0874$var$Group(scene); // Don't add Group into update list, I will destroy it manually
        var callback = $339617a0d54a0874$var$GetValue(config, "cellVisibleCallback", null);
        if (callback !== null) {
            var scope = $339617a0d54a0874$var$GetValue(config, "cellVisibleCallbackScope", undefined);
            this.on("cellvisible", callback, scope);
        }
        callback = $339617a0d54a0874$var$GetValue(config, "cellInvisibleCallback", null);
        if (callback !== null) {
            var scope = $339617a0d54a0874$var$GetValue(config, "cellInvisibleCallbackScope", undefined);
            this.on("cellinvisible", callback, scope);
        }
        if ($339617a0d54a0874$var$GetValue(config, "enableLayer", false)) this.enableLayer();
        this.setupChildrenMask($339617a0d54a0874$var$GetValue(config, "mask", undefined));
        this.setScrollMode($339617a0d54a0874$var$GetValue(config, "scrollMode", 0));
        this.setClampMode($339617a0d54a0874$var$GetValue(config, "clamplTableOXY", true));
        // Pre-process cell size
        var cellWidth, cellHeight, columns;
        var scrollY = this.scrollMode === 0;
        if (scrollY) {
            cellWidth = config.cellWidth;
            cellHeight = config.cellHeight;
            columns = config.columns;
        } else {
            cellWidth = config.cellHeight;
            cellHeight = config.cellWidth;
            columns = $339617a0d54a0874$var$GetValue(config, "rows", config.columns);
        }
        if (!columns) columns = 1; // Default columns
        this.expandCellSize = cellWidth === undefined;
        if (this.expandCellSize) {
            var width = scrollY ? this.width : this.height;
            cellWidth = width / columns;
        }
        config.cellWidth = cellWidth;
        config.cellHeight = cellHeight;
        config.columns = columns;
        this.table = new (0, $cdc5c7a476ef8c52$export$2e2bcd8739ae039)(this, config);
        this.updateTable();
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.destroyChildrenMask();
        this.table.destroy(fromScene);
        this.table = undefined;
        if (this.cellContainersPool) {
            this.cellContainersPool.destroy(true);
            this.cellContainersPool = undefined;
        }
        super.destroy(fromScene);
    }
    setScrollMode(mode) {
        if (typeof mode === "string") mode = $339617a0d54a0874$var$SCROLLMODE[mode.toLowerCase()];
        this.scrollMode = mode;
        return this;
    }
    setClampMode(mode) {
        if (mode === undefined) mode = true;
        this.clampTableOXY = mode;
        return this;
    }
    get tableOY() {
        return this._tableOY;
    }
    get tableOX() {
        return this._tableOX;
    }
    set tableOY(oy) {
        this.setTableOY(oy).updateTable();
    }
    set tableOX(ox) {
        this.setTableOX(ox).updateTable();
    }
    setTableOXY(ox, oy) {
        this.setTableOY(oy).setTableOX(ox);
        return this;
    }
    addTableOY(dy) {
        this.setTableOY(this.tableOY + dy);
        return this;
    }
    addTableOX(dx) {
        this.setTableOX(this.tableOX + dx);
        return this;
    }
    addTableOXY(dx, dy) {
        this.addTableOY(dy).addTableOX(dx);
        return this;
    }
    setTableOYByPercentage(percentage) {
        this.setTableOY(-this.tableVisibleHeight * percentage);
        return this;
    }
    getTableOYPercentage() {
        var tableVisibleHeight = this.tableVisibleHeight;
        if (tableVisibleHeight === 0) return 0;
        return this.tableOY / -tableVisibleHeight;
    }
    set t(value) {
        this.setTableOYByPercentage(value).updateTable();
    }
    get t() {
        return this.getTableOYPercentage();
    }
    scrollToBottom() {
        this.t = 1;
        // t will be 0 if table does not exceed visible area
        if (this.t === 0) return this;
        // Table height might be expanded while cells are visible        
        do this.t = 1;
        while (this.t !== 1);
        return this;
    }
    scrollToRow(rowIndex) {
        // To get all height of cells
        this.scrollToBottom();
        var height = this.table.rowIndexToHeight(0, rowIndex - 1);
        this.setTableOY(-height).updateTable();
        return this;
    }
    scrollToNextRow(rowCount) {
        if (rowCount === undefined) rowCount = 1;
        this.scrollToRow(this.startRowIndex + rowCount);
        return this;
    }
    getCell(cellIdx) {
        return this.table.getCell(cellIdx, true);
    }
    getCellContainer(cellIdx) {
        var cell = this.table.getCell(cellIdx, false);
        var container;
        if (cell) container = cell.getContainer();
        return container;
    }
    get cellsCount() {
        return this.table.cellsCount;
    }
    get columnCount() {
        return this.table.colCount;
    }
    setCellHeight(cellIdx, height) {
        var cell;
        if (typeof cellIdx === "number") cell = this.table.getCell(cellIdx, true);
        else cell = cellIdx;
        cell.height = height; // Only worked when scrollMode is 0
        return this;
    }
    setCellWidth(cellIdx, width) {
        var cell;
        if (typeof cellIdx === "number") cell = this.table.getCell(cellIdx, true);
        else cell = cellIdx;
        cell.width = width; // Only worked when scrollMode is 1
        return this;
    }
    get instHeight() {
        return this.scrollMode === 0 ? this.height : this.width;
    }
    get instWidth() {
        return this.scrollMode === 0 ? this.width : this.height;
    }
    get tableHeight() {
        return this.table.totalRowsHeight;
    }
    get tableWidth() {
        return this.table.totalColumnWidth;
    }
    get topTableOY() {
        return 0;
    }
    get bottomTableOY() {
        return -this.tableVisibleHeight;
    }
    get leftTableOX() {
        return 0;
    }
    get rightTableOX() {
        return -this.tableVisibleWidth;
    }
    get tableVisibleHeight() {
        var h = this.tableHeight - this.instHeight;
        if (h < 0) h = 0;
        return h;
    }
    get tableVisibleWidth() {
        var w;
        var tableWidth = this.tableWidth;
        var instWidth = this.instWidth;
        if (tableWidth > instWidth) w = tableWidth - instWidth;
        else w = 0;
        return w;
    }
    get bottomLeftY() {
        return -(this.displayHeight * this.originY) + this.displayHeight;
    }
    get topRightX() {
        return -(this.displayWidth * this.originX) + this.displayWidth;
    }
    get topLeftX() {
        return -(this.displayWidth * this.originX);
    }
    get topLeftY() {
        return -(this.displayHeight * this.originY);
    }
    get bottomBound() {
        if (this.scrollMode === 0) return this.bottomLeftY;
        else return this.topRightX;
    }
    get rightBound() {
        if (this.scrollMode === 0) return this.topRightX;
        else return this.bottomLeftY;
    }
    resize(width, height) {
        if (this.width === width && this.height === height) return this;
        super.resize(width, height);
        if (this.expandCellSize) this.table.setDefaultCellWidth(this.instWidth / this.table.colCount);
        this.updateTable(true);
        // Layout children-mask
        this.layoutChildrenMask();
        // Re-mask children
        this.maskChildren();
        return this;
    }
}
// mixin
Object.assign($339617a0d54a0874$var$GridTable.prototype, (0, $b6ecd49ae59d106f$export$2e2bcd8739ae039));
const $339617a0d54a0874$var$SCROLLMODE = {
    v: 0,
    vertical: 0,
    h: 1,
    horizontal: 1
};
const $339617a0d54a0874$var$MASKUPDATEMODE = {
    update: 0,
    everyTick: 1
};
var $339617a0d54a0874$export$2e2bcd8739ae039 = $339617a0d54a0874$var$GridTable;


function $fb53c9b9a258b5ce$export$2e2bcd8739ae039(x, y, width, height, config) {
    var gameObject = new (0, $339617a0d54a0874$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $8ab2bf756a94f1bf$var$GetValue = Phaser.Utils.Objects.GetValue;
const $8ab2bf756a94f1bf$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $8ab2bf756a94f1bf$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var width = $8ab2bf756a94f1bf$var$GetValue(config, "width", 256);
    var height = $8ab2bf756a94f1bf$var$GetValue(config, "height", 256);
    var gameObject = new (0, $339617a0d54a0874$export$2e2bcd8739ae039)(this.scene, 0, 0, width, height, config);
    // set properties wo modify children
    gameObject.syncChildrenEnable = false;
    $8ab2bf756a94f1bf$var$BuildGameObject(this.scene, gameObject, config);
    // sync properties of children
    gameObject.syncChildrenEnable = true;
    gameObject.syncPosition().syncVisible().syncAlpha();
    return gameObject;
}




class $23303318b248b6d8$var$GridTablePlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexGridTable", (0, $fb53c9b9a258b5ce$export$2e2bcd8739ae039), (0, $8ab2bf756a94f1bf$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.GridTable", (0, $339617a0d54a0874$export$2e2bcd8739ae039));
var $23303318b248b6d8$export$2e2bcd8739ae039 = $23303318b248b6d8$var$GridTablePlugin;


var $0611249a3cf734f2$var$Resize = function(width, height) {
    if (this.scene.sys.scale.autoRound) {
        width = Math.floor(width);
        height = Math.floor(height);
    }
    if (this.width === width && this.height === height) return this;
    var style = this.node.style;
    style.width = `${width}px`;
    style.height = `${height}px`;
    this.updateSize();
    return this;
};
var $0611249a3cf734f2$export$2e2bcd8739ae039 = $0611249a3cf734f2$var$Resize;


const $9489f6bd7fc878de$export$5ceae51f304f907a = {
    id: [
        "id",
        undefined
    ],
    text: [
        "value",
        undefined
    ],
    maxLength: [
        "maxLength",
        undefined
    ],
    minLength: [
        "minLength",
        undefined
    ],
    placeholder: [
        "placeholder",
        undefined
    ],
    tooltip: [
        "title",
        undefined
    ],
    readOnly: [
        "readOnly",
        false
    ],
    spellCheck: [
        "spellcheck",
        false
    ],
    autoComplete: [
        "autocomplete",
        "off"
    ]
};
const $9489f6bd7fc878de$export$382e5b25557d359c = {
    align: [
        "textAlign",
        undefined
    ],
    paddingLeft: [
        "padding-left",
        undefined
    ],
    paddingRight: [
        "padding-right",
        undefined
    ],
    paddingTop: [
        "padding-top",
        undefined
    ],
    paddingBottom: [
        "padding-bottom",
        undefined
    ],
    fontFamily: [
        "fontFamily",
        undefined
    ],
    fontSize: [
        "font-size",
        undefined
    ],
    color: [
        "color",
        "#ffffff"
    ],
    backgroundColor: [
        "backgroundColor",
        "transparent"
    ],
    border: [
        "border",
        0
    ],
    borderColor: [
        "borderColor",
        "transparent"
    ],
    outline: [
        "outline",
        "none"
    ],
    direction: [
        "direction",
        undefined
    ]
};
const $9489f6bd7fc878de$export$e61302b39fb2a4f6 = {
    input: "textchange",
    click: "click",
    dblclick: "dblclick",
    mousedown: "pointerdown",
    mousemove: "pointermove",
    mouseup: "pointerup",
    touchstart: "pointerdown",
    touchmove: "pointermove",
    touchend: "pointerup",
    keydown: "keydown",
    keyup: "keyup",
    keypress: "keypress",
    compositionstart: "compositionStart",
    compositionend: "compositionEnd",
    compositionupdate: "compositionUpdate",
    focus: "focus",
    blur: "blur",
    select: "select"
};


const $b4f8dc12fa48d39a$var$GetValue = Phaser.Utils.Objects.GetValue;
var $b4f8dc12fa48d39a$var$SetProperties = function(properties, config, out) {
    if (out === undefined) out = {};
    var property, value;
    for(var key in properties){
        property = properties[key]; // [propName, defaultValue]
        value = $b4f8dc12fa48d39a$var$GetValue(config, key, property[1]);
        if (value !== undefined) out[property[0]] = value;
    }
    return out;
};
var $b4f8dc12fa48d39a$export$2e2bcd8739ae039 = $b4f8dc12fa48d39a$var$SetProperties;


const $fe14a876e6921d2b$var$GetValue = Phaser.Utils.Objects.GetValue;
var $fe14a876e6921d2b$var$RouteEvents = function(gameObject, element, elementEvents, config) {
    var preventDefault = $fe14a876e6921d2b$var$GetValue(config, "preventDefault", false);
    var preTest = $fe14a876e6921d2b$var$GetValue(config, "preTest");
    for(let elementEventName in elementEvents)element.addEventListener(elementEventName, function(e) {
        if (!preTest || preTest(gameObject, elementEventName)) gameObject.emit(elementEvents[elementEventName], gameObject, e);
        if (preventDefault) e.preventDefault();
    });
};
var $fe14a876e6921d2b$export$2e2bcd8739ae039 = $fe14a876e6921d2b$var$RouteEvents;


var $c9f4424d09c314d0$var$StopPropagationTouchEvents = function(element) {
    // Don't propagate touch/mouse events to parent(game canvas)
    element.addEventListener("touchstart", $c9f4424d09c314d0$var$callback, false);
    element.addEventListener("touchmove", $c9f4424d09c314d0$var$callback, false);
    element.addEventListener("touchend", $c9f4424d09c314d0$var$callback, false);
    element.addEventListener("mousedown", $c9f4424d09c314d0$var$callback, false);
    element.addEventListener("mouseup", $c9f4424d09c314d0$var$callback, false);
    element.addEventListener("mousemove", $c9f4424d09c314d0$var$callback, false);
};
var $c9f4424d09c314d0$var$callback = function(e) {
    e.stopPropagation();
};
var $c9f4424d09c314d0$export$2e2bcd8739ae039 = $c9f4424d09c314d0$var$StopPropagationTouchEvents;


const $28892e8128e1413d$var$DOMElement = Phaser.GameObjects.DOMElement;
const $28892e8128e1413d$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $28892e8128e1413d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $28892e8128e1413d$var$InputText extends $28892e8128e1413d$var$DOMElement {
    constructor(scene, x, y, width, height, config){
        if ($28892e8128e1413d$var$IsPlainObject(x)) {
            config = x;
            x = $28892e8128e1413d$var$GetValue(config, "x", 0);
            y = $28892e8128e1413d$var$GetValue(config, "y", 0);
            width = $28892e8128e1413d$var$GetValue(config, "width", 0);
            height = $28892e8128e1413d$var$GetValue(config, "height", 0);
        } else if ($28892e8128e1413d$var$IsPlainObject(width)) {
            config = width;
            width = $28892e8128e1413d$var$GetValue(config, "width", 0);
            height = $28892e8128e1413d$var$GetValue(config, "height", 0);
        }
        if (config === undefined) config = {};
        var element;
        var textType = $28892e8128e1413d$var$GetValue(config, "type", "text");
        if (textType === "textarea") {
            element = document.createElement("textarea");
            element.style.resize = "none";
        } else {
            element = document.createElement("input");
            element.type = textType;
        }
        (0, $b4f8dc12fa48d39a$export$2e2bcd8739ae039)((0, $9489f6bd7fc878de$export$5ceae51f304f907a), config, element);
        var style = $28892e8128e1413d$var$GetValue(config, "style", undefined);
        style = (0, $b4f8dc12fa48d39a$export$2e2bcd8739ae039)((0, $9489f6bd7fc878de$export$382e5b25557d359c), config, style);
        // Apply other style properties
        var elementStyle = element.style;
        for(var key in config){
            if (key in (0, $9489f6bd7fc878de$export$5ceae51f304f907a) || key in (0, $9489f6bd7fc878de$export$382e5b25557d359c)) continue;
            else if (key in elementStyle) style[key] = config[key];
        }
        style["box-sizing"] = "border-box";
        super(scene, x, y, element, style);
        this.type = "rexInputText";
        this.resize(width, height);
        // Apply events
        (0, $fe14a876e6921d2b$export$2e2bcd8739ae039)(this, element, (0, $9489f6bd7fc878de$export$e61302b39fb2a4f6));
        // Don't propagate touch/mouse events to parent(game canvas)
        (0, $c9f4424d09c314d0$export$2e2bcd8739ae039)(element);
        if ($28892e8128e1413d$var$GetValue(config, "selectAll", false)) this.selectAll();
        this._isFocused = false;
        this.on("focus", function() {
            this._isFocused = true;
        }, this).on("blur", function() {
            this._isFocused = false;
        }, this);
    }
    get text() {
        return this.node.value;
    }
    set text(value) {
        this.node.value = value;
    }
    setText(value) {
        this.text = value;
        return this;
    }
    get maxLength() {
        return this.node.maxLength;
    }
    set maxLength(value) {
        this.node.maxLength = value;
    }
    setMaxLength(value) {
        this.maxLength = value;
        return this;
    }
    get minLength() {
        return this.node.minLength;
    }
    set minLength(value) {
        this.node.minLength = value;
    }
    setMinLength(value) {
        this.minLength = value;
        return this;
    }
    get placeholder() {
        return this.node.placeholder;
    }
    set placeholder(value) {
        this.node.placeholder = value;
    }
    setPlaceholder(value) {
        this.placeholder = value;
        return this;
    }
    selectText(selectionStart, selectionEnd) {
        if (selectionStart === undefined) this.node.select();
        else this.node.setSelectionRange(selectionStart, selectionEnd);
        return this;
    }
    selectAll() {
        this.selectText();
        return this;
    }
    get selectionStart() {
        return this.node.selectionStart;
    }
    get selectionEnd() {
        return this.node.selectionEnd;
    }
    get selectedText() {
        var node = this.node;
        return node.value.substring(node.selectionStart, node.selectionEnd);
    }
    get cursorPosition() {
        return this.node.selectionStart;
    }
    set cursorPosition(value) {
        this.node.setSelectionRange(value, value);
    }
    setCursorPosition(value) {
        if (value === undefined) value = this.text.length;
        else if (value < 0) value = this.text.length + value;
        this.cursorPosition = value;
        return this;
    }
    get tooltip() {
        return this.node.title;
    }
    set tooltip(value) {
        this.node.title = value;
    }
    setTooltip(value) {
        this.tooltip = value;
        return this;
    }
    setTextChangedCallback(callback) {
        this.onTextChanged = callback;
        return this;
    }
    get readOnly() {
        return this.node.readOnly;
    }
    set readOnly(value) {
        this.node.readOnly = value;
    }
    setReadOnly(value) {
        if (value === undefined) value = true;
        this.readOnly = value;
        return this;
    }
    get spellCheck() {
        return this.node.spellcheck;
    }
    set spellCheck(value) {
        this.node.spellcheck = value;
    }
    setSpellCheck(value) {
        this.spellCheck = value;
        return this;
    }
    get fontColor() {
        return this.node.style.color;
    }
    set fontColor(value) {
        this.node.style.color = value;
    }
    setFontColor(value) {
        this.fontColor = value;
        return this;
    }
    setStyle(key, value) {
        this.node.style[key] = value;
        return this;
    }
    getStyle(key) {
        return this.node.style[key];
    }
    scrollToBottom() {
        this.node.scrollTop = this.node.scrollHeight;
        return this;
    }
    setEnabled(enabled) {
        if (enabled === undefined) enabled = true;
        this.node.disabled = !enabled;
        return this;
    }
    setBlur() {
        this.node.blur();
        return this;
    }
    setFocus() {
        this.node.focus();
        return this;
    }
    get isFocused() {
        return this._isFocused;
    }
}
var $28892e8128e1413d$var$methods = {
    resize: (0, $0611249a3cf734f2$export$2e2bcd8739ae039)
};
Object.assign($28892e8128e1413d$var$InputText.prototype, $28892e8128e1413d$var$methods);
var $28892e8128e1413d$export$2e2bcd8739ae039 = $28892e8128e1413d$var$InputText;


function $5f8026b7c642e21a$export$2e2bcd8739ae039(x, y, width, height, config) {
    var gameObject = new (0, $28892e8128e1413d$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $6abbee5f535ecbe8$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $6abbee5f535ecbe8$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $6abbee5f535ecbe8$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var width = $6abbee5f535ecbe8$var$GetAdvancedValue(config, "width", undefined);
    var height = $6abbee5f535ecbe8$var$GetAdvancedValue(config, "height", undefined);
    var gameObject = new (0, $28892e8128e1413d$export$2e2bcd8739ae039)(this.scene, 0, 0, width, height, config);
    $6abbee5f535ecbe8$var$BuildGameObject(this.scene, gameObject, config);
    return gameObject;
}




class $d4f525ef5e7fbe59$var$InputTextPlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexInputText", (0, $5f8026b7c642e21a$export$2e2bcd8739ae039), (0, $6abbee5f535ecbe8$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.InputText", (0, $28892e8128e1413d$export$2e2bcd8739ae039));
var $d4f525ef5e7fbe59$export$2e2bcd8739ae039 = $d4f525ef5e7fbe59$var$InputTextPlugin;



const $efa8a86e39512506$var$GetValue = Phaser.Utils.Objects.GetValue;
var $efa8a86e39512506$export$95358a8f491113ca = function(padding, key) {
    if (key === undefined) return padding;
    return padding[key];
};
var $efa8a86e39512506$export$dd20faac850f550d = function(padding, key, value) {
    if (padding === undefined) padding = {};
    if (key === undefined) key = 0;
    var keyType = typeof key;
    if (keyType === "string") padding[key] = value;
    else if (keyType === "number") {
        padding.left = key;
        padding.right = key;
        padding.top = key;
        padding.bottom = key;
    } else {
        padding.left = $efa8a86e39512506$var$GetValue(key, "left", 0);
        padding.right = $efa8a86e39512506$var$GetValue(key, "right", 0);
        padding.top = $efa8a86e39512506$var$GetValue(key, "top", 0);
        padding.bottom = $efa8a86e39512506$var$GetValue(key, "bottom", 0);
    }
    return padding;
};



class $e74dea98d2a81481$var$Base {
    constructor(parent, type){
        this.setParent(parent);
        this.type = type;
        this.renderable = false;
        this.reset().setActive();
    }
    destroy() {
        this.parent.removeChild(this);
    }
    setParent(parent) {
        this.parent = parent;
        return this;
    }
    get scene() {
        return this.parent.scene;
    }
    get canvas() {
        return this.parent ? this.parent.canvas : null;
    }
    get context() {
        return this.parent ? this.parent.context : null;
    }
    setDirty(dirty) {
        if (dirty && this.parent) this.parent.dirty = true;
        return this;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this.setDirty(this._active != value);
        this._active = value;
    }
    setActive(active) {
        if (active === undefined) active = true;
        this.active = active;
        return this;
    }
    modifyPorperties(o) {
        return this;
    }
    // Override
    onFree() {
        this.reset().setParent();
    }
    // Override
    reset() {
        return this;
    }
    // Override
    render() {}
    // Override
    contains(x, y) {
        return false;
    }
}
Object.assign($e74dea98d2a81481$var$Base.prototype, (0, $90fdebfc958065d1$export$2e2bcd8739ae039));
var $e74dea98d2a81481$export$2e2bcd8739ae039 = $e74dea98d2a81481$var$Base;


var $bb28b08f662f24a0$export$2e2bcd8739ae039 = {
    // Override
    renderContent () {},
    // Override
    render () {
        if (!this.willRender) return this;
        var context = this.context;
        context.save();
        context.globalAlpha = this.alpha;
        if (this.toLocalPosition) {
            var x = this.drawX, y = this.drawY;
            if (this.autoRound) {
                x = Math.round(x);
                y = Math.round(y);
            }
            context.translate(x, y);
            context.scale(this.scaleX, this.scaleY);
            context.rotate(this.rotation);
        }
        if (this.drawBelowCallback) this.drawBelowCallback(this);
        this.renderContent();
        if (this.drawAboveCallback) this.drawAboveCallback(this);
        context.restore();
        return this;
    }
};


const $3e37cb9858ff6c59$var$RotateAround = Phaser.Math.RotateAround;
var $3e37cb9858ff6c59$var$CanvasPositionToBobPosition = function(canvasX, canvasY, bob, out) {
    if (out === undefined) out = {};
    else if (out === true) {
        if ($3e37cb9858ff6c59$var$globPoint === undefined) $3e37cb9858ff6c59$var$globPoint = {};
        out = $3e37cb9858ff6c59$var$globPoint;
    }
    out.x = (canvasX - bob.drawX) / bob.scaleX;
    out.y = (canvasY - bob.drawY) / bob.scaleY;
    if (bob.rotation !== 0) $3e37cb9858ff6c59$var$RotateAround(out, 0, 0, -bob.rotation);
    return out;
};
var $3e37cb9858ff6c59$var$globPoint;
var $3e37cb9858ff6c59$export$2e2bcd8739ae039 = $3e37cb9858ff6c59$var$CanvasPositionToBobPosition;


const $4485df6deb1e76ef$var$Rectangle = Phaser.Geom.Rectangle;
var $4485df6deb1e76ef$var$Contains = function(canvasX, canvasY) {
    if (this.width === 0 || this.height === 0) return false;
    var bobPosition = (0, $3e37cb9858ff6c59$export$2e2bcd8739ae039)(canvasX, canvasY, this, true);
    return $4485df6deb1e76ef$var$GetBounds(this).contains(bobPosition.x, bobPosition.y);
};
var $4485df6deb1e76ef$var$GetBounds = function(bob) {
    if ($4485df6deb1e76ef$var$globBounds === undefined) $4485df6deb1e76ef$var$globBounds = new $4485df6deb1e76ef$var$Rectangle();
    var x = bob.drawTLX, y = bob.drawTLY;
    $4485df6deb1e76ef$var$globBounds.setTo(x, y, bob.drawTRX - x, bob.drawBLY - y);
    return $4485df6deb1e76ef$var$globBounds;
};
var $4485df6deb1e76ef$var$globBounds;
var $4485df6deb1e76ef$export$2e2bcd8739ae039 = $4485df6deb1e76ef$var$Contains;


const $633a579d5651fab7$var$RotateAround = Phaser.Math.RotateAround;
var $633a579d5651fab7$var$BobPositionToCanvasPosition = function(bob, bobX, bobY, out) {
    if (out === undefined) out = {};
    else if (out === true) {
        if ($633a579d5651fab7$var$globPoint === undefined) $633a579d5651fab7$var$globPoint = {};
        out = $633a579d5651fab7$var$globPoint;
    }
    out.x = bobX;
    out.y = bobY;
    if (bob.rotation !== 0) $633a579d5651fab7$var$RotateAround(out, 0, 0, bob.rotation);
    out.x = out.x * bob.scaleX + bob.drawX;
    out.y = out.y * bob.scaleY + bob.drawY;
    return out;
};
var $633a579d5651fab7$var$globPoint;
var $633a579d5651fab7$export$2e2bcd8739ae039 = $633a579d5651fab7$var$BobPositionToCanvasPosition;


const $f6d2dbf9d70b91dc$var$TransformMatrix = Phaser.GameObjects.Components.TransformMatrix;
var $f6d2dbf9d70b91dc$var$GameObjectLocalXYToWorldXY = function(gameObject, localX, localY, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $f6d2dbf9d70b91dc$var$globOut;
    var px = localX - gameObject.width * gameObject.originX;
    var py = localY - gameObject.height * gameObject.originY;
    if ($f6d2dbf9d70b91dc$var$tempMatrix === undefined) {
        $f6d2dbf9d70b91dc$var$tempMatrix = new $f6d2dbf9d70b91dc$var$TransformMatrix();
        $f6d2dbf9d70b91dc$var$parentMatrix = new $f6d2dbf9d70b91dc$var$TransformMatrix();
    }
    if (gameObject.parentContainer) gameObject.getWorldTransformMatrix($f6d2dbf9d70b91dc$var$tempMatrix, $f6d2dbf9d70b91dc$var$parentMatrix);
    else $f6d2dbf9d70b91dc$var$tempMatrix.applyITRS(gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY);
    $f6d2dbf9d70b91dc$var$tempMatrix.transformPoint(px, py, out);
    return out;
};
var $f6d2dbf9d70b91dc$var$tempMatrix, $f6d2dbf9d70b91dc$var$parentMatrix;
var $f6d2dbf9d70b91dc$var$globOut = {};
var $f6d2dbf9d70b91dc$export$2e2bcd8739ae039 = $f6d2dbf9d70b91dc$var$GameObjectLocalXYToWorldXY;


var $f617371f1b713354$var$BobPositionToWorldPosition = function(dynamicText, bob, bobX, bobY, out) {
    var localXY = (0, $633a579d5651fab7$export$2e2bcd8739ae039)(bob, bobX, bobY, true);
    var worldXY = (0, $f6d2dbf9d70b91dc$export$2e2bcd8739ae039)(dynamicText, localXY.x, localXY.y, out);
    return worldXY;
};
var $f617371f1b713354$export$2e2bcd8739ae039 = $f617371f1b713354$var$BobPositionToWorldPosition;


var $d8082040f8a2b380$var$GetBobWorldPosition = function(dynamicText, bob, offsetX, offsetY, out) {
    if (typeof offsetX !== "number") {
        out = offsetX;
        offsetX = 0;
        offsetY = 0;
    }
    var bobX = bob.drawCenterX + offsetX;
    var bobY = bob.drawCenterY + offsetY;
    return (0, $f617371f1b713354$export$2e2bcd8739ae039)(dynamicText, bob, bobX, bobY, out);
};
var $d8082040f8a2b380$export$2e2bcd8739ae039 = $d8082040f8a2b380$var$GetBobWorldPosition;


var $89ebbcfbbba47217$var$GetWorldPosition = function(offsetX, offsetY, out) {
    return (0, $d8082040f8a2b380$export$2e2bcd8739ae039)(this.parent, this, offsetX, offsetY, out);
};
var $89ebbcfbbba47217$export$2e2bcd8739ae039 = $89ebbcfbbba47217$var$GetWorldPosition;


var $2a5cc015800e92d0$var$Methods = {
    contains: (0, $4485df6deb1e76ef$export$2e2bcd8739ae039),
    getWorldPosition: (0, $89ebbcfbbba47217$export$2e2bcd8739ae039)
};
Object.assign($2a5cc015800e92d0$var$Methods, (0, $bb28b08f662f24a0$export$2e2bcd8739ae039));
var $2a5cc015800e92d0$export$2e2bcd8739ae039 = $2a5cc015800e92d0$var$Methods;


const $5172eeaecaf3ec82$var$DegToRad = Phaser.Math.DegToRad;
const $5172eeaecaf3ec82$var$RadToDeg = Phaser.Math.RadToDeg;
const $5172eeaecaf3ec82$var$GetValue = Phaser.Utils.Objects.GetValue;
class $5172eeaecaf3ec82$var$RenderBase extends (0, $e74dea98d2a81481$export$2e2bcd8739ae039) {
    constructor(parent, type){
        super(parent, type);
        this.renderable = true;
        this.toLocalPosition = true;
        this.originX = 0;
        this.offsetX = 0; // Override
        this.offsetY = 0; // Override
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        this.setDirty(this._visible != value);
        this._visible = value;
    }
    setVisible(visible) {
        if (visible === undefined) visible = true;
        this.visible = visible;
        return this;
    }
    get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        this.setDirty(this._alpha != value);
        this._alpha = value;
    }
    setAlpha(alpha) {
        this.alpha = alpha;
        return this;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this.setDirty(this._x != value);
        this._x = value;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this.setDirty(this._y != value);
        this._y = value;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setInitialPosition(x, y) {
        this.x0 = x;
        this.y0 = y;
        return this;
    }
    get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        this.setDirty(this._rotation != value);
        this._rotation = value;
    }
    setRotation(rotation) {
        this.rotation = rotation;
        return this;
    }
    get angle() {
        return $5172eeaecaf3ec82$var$RadToDeg(this._rotation);
    }
    set angle(value) {
        this.rotation = $5172eeaecaf3ec82$var$DegToRad(value);
    }
    setAngle(angle) {
        this.angle = angle;
        return this;
    }
    get scaleX() {
        return this._scaleX;
    }
    set scaleX(value) {
        this.setDirty(this._scaleX !== value);
        this._scaleX = value;
    }
    setScaleX(scaleX) {
        this.scaleX = scaleX;
        return this;
    }
    // Override
    get width() {
        return 0;
    }
    // Override
    set width(value) {}
    setWidth(width, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.width = width;
        if (keepAspectRatio) this.scaleY = this.scaleX;
        return this;
    }
    get leftSpace() {
        return this._leftSpace;
    }
    set leftSpace(value) {
        this.setDirty(this._leftSpace !== value);
        this._leftSpace = value;
    }
    setLeftSpace(value) {
        this.leftSpace = value;
        return this;
    }
    get rightSpace() {
        return this._rightSpace;
    }
    set rightSpace(value) {
        this.setDirty(this._rightSpace !== value);
        this._rightSpace = value;
    }
    setRightSpace(value) {
        this.rightSpace = value;
        return this;
    }
    get outerWidth() {
        return this.width + this.leftSpace + this.rightSpace;
    }
    get scaleY() {
        return this._scaleY;
    }
    set scaleY(value) {
        this.setDirty(this._scaleY !== value);
        this._scaleY = value;
    }
    setScaleY(scaleY) {
        this.scaleY = scaleY;
        return this;
    }
    // Override
    get height() {
        return 0;
    }
    // Override
    set height(value) {}
    setHeight(height, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.height = height;
        if (keepAspectRatio) this.scaleX = this.scaleY;
        return this;
    }
    setScale(scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        return this;
    }
    setOrigin(x) {
        this.originX = x;
        return this;
    }
    setAlign(align) {
        this.align = align;
        return this;
    }
    modifyPorperties(o) {
        if (!o) return this;
        if (o.hasOwnProperty("x")) this.setX(o.x);
        if (o.hasOwnProperty("y")) this.setY(o.y);
        if (o.hasOwnProperty("rotation")) this.setRotation(o.rotation);
        else if (o.hasOwnProperty("angle")) this.setAngle(o.angle);
        if (o.hasOwnProperty("alpha")) this.setAlpha(o.alpha);
        // ScaleX, ScaleY
        var width = $5172eeaecaf3ec82$var$GetValue(o, "width", undefined);
        var height = $5172eeaecaf3ec82$var$GetValue(o, "height", undefined);
        var scaleX = $5172eeaecaf3ec82$var$GetValue(o, "scaleX", undefined);
        var scaleY = $5172eeaecaf3ec82$var$GetValue(o, "scaleY", undefined);
        if (width !== undefined) {
            if (height === undefined && scaleY === undefined) this.setWidth(width, true);
            else this.setWidth(width);
        } else if (scaleX !== undefined) this.setScaleX(scaleX);
        if (height !== undefined) {
            if (width === undefined && scaleX === undefined) this.setHeight(height, true);
            else this.setHeight(height);
        } else if (scaleY !== undefined) this.setScaleY(scaleY);
        if (o.hasOwnProperty("leftSpace")) this.setLeftSpace(o.leftSpace);
        if (o.hasOwnProperty("rightSpace")) this.setRightSpace(o.rightSpace);
        if (o.hasOwnProperty("align")) this.setAlign(o.align);
        return this;
    }
    setDrawBelowCallback(callback) {
        this.drawBelowCallback = callback;
        return this;
    }
    setDrawAboveCallback(callback) {
        this.drawAboveCallback = callback;
        return this;
    }
    reset() {
        this.setVisible().setAlpha(1).setPosition(0, 0).setRotation(0).setScale(1, 1).setLeftSpace(0).setRightSpace(0).setOrigin(0).setAlign().setDrawBelowCallback().setDrawAboveCallback();
        return this;
    }
    // Override
    get willRender() {
        return this.visible && this.alpha > 0;
    }
    get drawX() {
        return this.x + this.leftSpace + this.offsetX - this.originX * this.width;
    }
    get drawY() {
        return this.y + this.offsetY;
    }
    // Override
    get drawTLX() {
        return 0;
    }
    get drawTLY() {
        return 0;
    }
    get drawBLX() {
        return 0;
    }
    get drawBLY() {
        return 0;
    }
    get drawTRX() {
        return 0;
    }
    get drawTRY() {
        return 0;
    }
    get drawBRX() {
        return 0;
    }
    get drawBRY() {
        return 0;
    }
    get drawCenterX() {
        return (this.drawTRX + this.drawTLX) / 2;
    }
    get drawCenterY() {
        return (this.drawBLY + this.drawTLY) / 2;
    }
}
Object.assign($5172eeaecaf3ec82$var$RenderBase.prototype, (0, $2a5cc015800e92d0$export$2e2bcd8739ae039));
var $5172eeaecaf3ec82$export$2e2bcd8739ae039 = $5172eeaecaf3ec82$var$RenderBase;


const $cc1ef7664a70c92f$var$Pad = Phaser.Utils.String.Pad;
var $cc1ef7664a70c92f$var$GetStyle = function(style, canvas, context) {
    if (style == null) return style;
    switch(typeof style){
        case "string":
            return style;
        case "number":
            return `#${$cc1ef7664a70c92f$var$Pad(Math.floor(style).toString(16), 6, "0", 1)}`;
        case "function":
            return style(canvas, context);
        case "object":
            if (style.hasOwnProperty("r")) {
                if (style.hasOwnProperty("a")) return `rgba(${style.r},${style.g},${style.b},${style.a})`;
                else return `rgb(${style.r},${style.g},${style.b})`;
            } else if (style.hasOwnProperty("h")) {
                if (style.hasOwnProperty("a")) return `hsla(${style.h},${style.s},${style.l},${style.a})`;
                else return `hsl(${style.h},${style.s},${style.l})`;
            } else return style; // Not a valid input
        default:
            return style;
    }
};
var $cc1ef7664a70c92f$export$2e2bcd8739ae039 = $cc1ef7664a70c92f$var$GetStyle;


var $44836e48cc77912a$var$GetProperty = function(name, config, defaultConfig) {
    if (config.hasOwnProperty(name)) return config[name];
    else return defaultConfig[name];
};
var $44836e48cc77912a$export$2e2bcd8739ae039 = $44836e48cc77912a$var$GetProperty;



var $b71f8cdbe1be936b$var$DrawRoundRectangle = function(canvas, context, x, y, width, height, radiusConfig, fillStyle, strokeStyle, lineWidth, fillColor2, isHorizontalGradient, iteration) {
    (0, $5627e24e60e2bd67$export$2e2bcd8739ae039)(context, x, y, width, height, radiusConfig, iteration);
    if (fillStyle != null) {
        if (fillColor2 != null) {
            var grd;
            if (isHorizontalGradient) grd = context.createLinearGradient(0, 0, width, 0);
            else grd = context.createLinearGradient(0, 0, 0, height);
            grd.addColorStop(0, fillStyle);
            grd.addColorStop(1, fillColor2);
            fillStyle = grd;
        }
        context.fillStyle = fillStyle;
        context.fill();
    }
    if (strokeStyle != null && lineWidth > 0) {
        context.strokeStyle = strokeStyle;
        context.lineWidth = lineWidth;
        context.stroke();
    }
};
var $b71f8cdbe1be936b$export$2e2bcd8739ae039 = $b71f8cdbe1be936b$var$DrawRoundRectangle;


var $3c945d5472df192a$var$DrawRoundRectangleBackground = function(canvasObject, color, strokeColor, strokeLineWidth, radius, color2, isHorizontalGradient, iteration) {
    if (color == null && strokeColor == null) return;
    var width = canvasObject.canvas.width, height = canvasObject.canvas.height;
    if (strokeColor == null) strokeLineWidth = 0;
    var x = strokeLineWidth / 2;
    width = Math.max(1, width - strokeLineWidth); // Min width is 1
    height = Math.max(1, height - strokeLineWidth); // Min height is 1
    (0, $b71f8cdbe1be936b$export$2e2bcd8739ae039)(canvasObject.canvas, canvasObject.context, x, x, width, height, radius, color, strokeColor, strokeLineWidth, color2, isHorizontalGradient, iteration);
};
var $3c945d5472df192a$export$2e2bcd8739ae039 = $3c945d5472df192a$var$DrawRoundRectangleBackground;


const $2131f61bdc74b865$var$GetValue = Phaser.Utils.Objects.GetValue;
class $2131f61bdc74b865$var$Background extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, "background");
        this.setColor($2131f61bdc74b865$var$GetValue(config, "color", null), $2131f61bdc74b865$var$GetValue(config, "color2", null), $2131f61bdc74b865$var$GetValue(config, "horizontalGradient", true));
        this.setStroke($2131f61bdc74b865$var$GetValue(config, "stroke", null), $2131f61bdc74b865$var$GetValue(config, "strokeThickness", 2));
        this.setCornerRadius($2131f61bdc74b865$var$GetValue(config, "cornerRadius", 0), $2131f61bdc74b865$var$GetValue(config, "cornerIteration", null));
    }
    set color(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._color != value);
        this._color = value;
    }
    get color() {
        return this._color;
    }
    set color2(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._color2 != value);
        this._color2 = value;
    }
    get color2() {
        return this._color2;
    }
    set horizontalGradient(value) {
        this.setDirty(this._horizontalGradient != value);
        this._horizontalGradient = value;
    }
    get horizontalGradient() {
        return this._horizontalGradient;
    }
    setColor(color, color2, isHorizontalGradient) {
        if (isHorizontalGradient === undefined) isHorizontalGradient = true;
        this.color = color;
        this.color2 = color2;
        this.horizontalGradient = isHorizontalGradient;
        return this;
    }
    set stroke(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._stroke != value);
        this._stroke = value;
    }
    get stroke() {
        return this._stroke;
    }
    set strokeThickness(value) {
        this.setDirty(this._strokeThickness != value);
        this._strokeThickness = value;
    }
    get strokeThickness() {
        return this._strokeThickness;
    }
    setStroke(color, lineWidth) {
        if (color != null) {
            if (lineWidth === undefined) lineWidth = 2;
        }
        this.stroke = color;
        this.strokeThickness = lineWidth;
        return this;
    }
    set cornerRadius(value) {
        this.setDirty(this._cornerRadius != value);
        this._cornerRadius = value;
    }
    get cornerRadius() {
        return this._cornerRadius;
    }
    set cornerIteration(value) {
        this.setDirty(this._cornerIteration != value);
        this._cornerIteration = value;
    }
    get cornerIteration() {
        return this._cornerIteration;
    }
    modifyStyle(o) {
        if (o.hasOwnProperty("color")) this.setColor(o.color, (0, $44836e48cc77912a$export$2e2bcd8739ae039)("color2", o, this), (0, $44836e48cc77912a$export$2e2bcd8739ae039)("horizontalGradient", o, this));
        if (o.hasOwnProperty("stroke")) this.setStroke(o.stroke, (0, $44836e48cc77912a$export$2e2bcd8739ae039)("strokeThickness", o, this));
        if (o.hasOwnProperty("cornerRadius")) this.setCornerRadius(o.cornerRadius, (0, $44836e48cc77912a$export$2e2bcd8739ae039)("cornerIteration", o, this));
        return this;
    }
    modifyPorperties(o) {
        super.modifyPorperties(o);
        this.modifyStyle(o);
        return this;
    }
    setCornerRadius(radius, iteration) {
        this.cornerRadius = radius;
        this.cornerIteration = iteration;
        return this;
    }
    renderContent() {
        (0, $3c945d5472df192a$export$2e2bcd8739ae039)(this.parent, this.color, this.stroke, this.strokeThickness, this.cornerRadius, this.color2, this.horizontalGradient, this.cornerIteration);
    }
}
var $2131f61bdc74b865$export$2e2bcd8739ae039 = $2131f61bdc74b865$var$Background;




const $1e7c8fd32a50e88d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $1e7c8fd32a50e88d$var$InnerBounds extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, "innerbounds");
        this.setColor($1e7c8fd32a50e88d$var$GetValue(config, "color", null), $1e7c8fd32a50e88d$var$GetValue(config, "color2", null), $1e7c8fd32a50e88d$var$GetValue(config, "horizontalGradient", true));
        this.setStroke($1e7c8fd32a50e88d$var$GetValue(config, "stroke", null), $1e7c8fd32a50e88d$var$GetValue(config, "strokeThickness", 2));
    }
    set color(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._color != value);
        this._color = value;
    }
    get color() {
        return this._color;
    }
    set color2(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._color2 != value);
        this._color2 = value;
    }
    get color2() {
        return this._color2;
    }
    set horizontalGradient(value) {
        this.setDirty(this._horizontalGradient != value);
        this._horizontalGradient = value;
    }
    get horizontalGradient() {
        return this._horizontalGradient;
    }
    setColor(color, color2, isHorizontalGradient) {
        if (isHorizontalGradient === undefined) isHorizontalGradient = true;
        this.color = color;
        this.color2 = color2;
        this.horizontalGradient = isHorizontalGradient;
        return this;
    }
    set stroke(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.setDirty(this._stroke != value);
        this._stroke = value;
    }
    get stroke() {
        return this._stroke;
    }
    set strokeThickness(value) {
        this.setDirty(this._strokeThickness != value);
        this._strokeThickness = value;
    }
    get strokeThickness() {
        return this._strokeThickness;
    }
    setStroke(color, lineWidth) {
        if (color != null) {
            if (lineWidth === undefined) lineWidth = 2;
        }
        this.stroke = color;
        this.strokeThickness = lineWidth;
        return this;
    }
    modifyPorperties(o) {
        super.modifyPorperties(o);
        if (o.hasOwnProperty("color")) this.setColor(o.color, $1e7c8fd32a50e88d$var$GetValue(o, "color2", null), $1e7c8fd32a50e88d$var$GetValue(o, "horizontalGradient", true));
        if (o.hasOwnProperty("stroke")) this.setStroke(o.stroke, $1e7c8fd32a50e88d$var$GetValue(o, "strokeThickness", 2));
    }
    renderContent() {
        var padding = this.parent.padding;
        var x = padding.left, y = padding.top, width = this.parent.width - padding.left - padding.right, height = this.parent.height - padding.top - padding.bottom;
        var context = this.context;
        if (this.color != null) {
            var fillStyle;
            if (this.color2 != null) {
                var grd;
                if (this.horizontalGradient) grd = context.createLinearGradient(0, 0, width, 0);
                else grd = context.createLinearGradient(0, 0, 0, height);
                grd.addColorStop(0, this.color);
                grd.addColorStop(1, this.color2);
                fillStyle = grd;
            } else fillStyle = this.color;
            context.fillStyle = fillStyle;
            context.fillRect(x, y, width, height);
        }
        if (this.stroke != null && this.strokeThickness > 0) {
            context.strokeStyle = this.stroke;
            context.lineWidth = this.strokeThickness;
            context.strokeRect(x, y, width, height);
        }
    }
}
var $1e7c8fd32a50e88d$export$2e2bcd8739ae039 = $1e7c8fd32a50e88d$var$InnerBounds;




const $8b2883a087adad94$var$GetValue = Phaser.Utils.Objects.GetValue;
class $8b2883a087adad94$var$TextStyle {
    constructor(parent, config){
        this.parent = parent;
        this.set(config);
    }
    toJSON() {
        return {
            bold: this.bold,
            italic: this.italic,
            fontSize: this.fontSize,
            fontFamily: this.fontFamily,
            color: this.color,
            stroke: this.stroke,
            strokeThickness: this.strokeThickness,
            shaodwColor: this.shadowColor,
            shadowBlur: this.shadowBlur,
            shadowOffsetX: this.shadowOffsetX,
            shadowOffsetY: this.shadowOffsetY,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            leftSpace: this.leftSpace,
            rightSpace: this.rightSpace,
            backgroundHeight: this.backgroundHeight,
            backgroundBottomY: this.backgroundBottomY,
            align: this.align
        };
    }
    set(o) {
        this.setBold($8b2883a087adad94$var$GetValue(o, "bold", false));
        this.setItalic($8b2883a087adad94$var$GetValue(o, "italic", false));
        this.setFontSize($8b2883a087adad94$var$GetValue(o, "fontSize", "16px"));
        this.setFontFamily($8b2883a087adad94$var$GetValue(o, "fontFamily", "Courier"));
        this.setColor($8b2883a087adad94$var$GetValue(o, "color", "#fff"));
        this.setStrokeStyle($8b2883a087adad94$var$GetValue(o, "stroke", null), $8b2883a087adad94$var$GetValue(o, "strokeThickness", 0));
        this.setShadow($8b2883a087adad94$var$GetValue(o, "shadowColor", null), $8b2883a087adad94$var$GetValue(o, "shadowOffsetX", 0), $8b2883a087adad94$var$GetValue(o, "shadowOffsetY", 0), $8b2883a087adad94$var$GetValue(o, "shadowBlur", 0));
        this.setOffset($8b2883a087adad94$var$GetValue(o, "offsetX", 0), $8b2883a087adad94$var$GetValue(o, "offsetY", 0));
        this.setSpace($8b2883a087adad94$var$GetValue(o, "leftSpace", 0), $8b2883a087adad94$var$GetValue(o, "rightSpace", 0));
        this.setAlign($8b2883a087adad94$var$GetValue(o, "align", undefined));
        this.setBackgroundColor($8b2883a087adad94$var$GetValue(o, "backgroundColor", null));
        this.setBackgroundHeight($8b2883a087adad94$var$GetValue(o, "backgroundHeight", undefined));
        this.setBackgroundBottomY($8b2883a087adad94$var$GetValue(o, "backgroundBottomY", undefined));
        return this;
    }
    modify(o) {
        if (o.hasOwnProperty("bold")) this.setBold(o.bold);
        if (o.hasOwnProperty("italic")) this.setItalic(o.italic);
        if (o.hasOwnProperty("fontSize")) this.setFontSize(o.fontSize);
        if (o.hasOwnProperty("fontFamily")) this.setFontFamily(o.fontFamily);
        if (o.hasOwnProperty("color")) this.setColor(o.color);
        if (o.hasOwnProperty("stroke") || o.hasOwnProperty("strokeThickness")) this.setStrokeStyle((0, $44836e48cc77912a$export$2e2bcd8739ae039)("stroke", o, this), (0, $44836e48cc77912a$export$2e2bcd8739ae039)("strokeThickness", o, this));
        if (o.hasOwnProperty("shadowColor")) this.setShadowColor(o.shadowColor);
        if (o.hasOwnProperty("shadowOffsetX") || o.hasOwnProperty("shadowOffsetY")) this.setShadowOffset((0, $44836e48cc77912a$export$2e2bcd8739ae039)("shadowOffsetX", o, this), (0, $44836e48cc77912a$export$2e2bcd8739ae039)("shadowOffsetY", o, this));
        if (o.hasOwnProperty("shadowBlur")) this.setShadowBlur(o.shaodwBlur);
        if (o.hasOwnProperty("offsetX")) this.setOffsetX(o.offsetX);
        if (o.hasOwnProperty("offsetY")) this.setOffsetY(o.offsetY);
        if (o.hasOwnProperty("leftSpace")) this.setLeftSpace(o.leftSpace);
        if (o.hasOwnProperty("rightSpace")) this.setRightSpace(o.rightSpace);
        if (o.hasOwnProperty("align")) this.setAlign(o.align);
        if (o.hasOwnProperty("backgroundColor")) this.setBackgroundColor(o.backgroundColor);
        if (o.hasOwnProperty("backgroundHeight")) this.setBackgroundHeight(o.backgroundHeight);
        if (o.hasOwnProperty("backgroundBottomY")) this.setBackgroundBottomY(o.backgroundBottomY);
        return this;
    }
    setUpdateTextFlag() {
        if (this.parent) this.parent.updateTextFlag = true;
        return this;
    }
    clone() {
        return new $8b2883a087adad94$var$TextStyle(null, this.toJSON());
    }
    copyFrom(sourceTextStyle) {
        this.set(sourceTextStyle.toJSON());
        return this;
    }
    copyTo(targetTextStyle) {
        targetTextStyle.set(this.toJSON());
        return this;
    }
    setBold(value) {
        if (value === undefined) value = true;
        this.bold = value;
        this.setUpdateTextFlag();
        return this;
    }
    setItalic(value) {
        if (value === undefined) value = true;
        this.italic = value;
        this.setUpdateTextFlag();
        return this;
    }
    get fontStyle() {
        if (this.bold && this.italic) return "bold italic";
        else if (this.bold) return "bold";
        else if (this.italic) return "italic";
        else return "";
    }
    setFontSize(fontSize) {
        if (typeof fontSize === "number") fontSize = `${fontSize}px`;
        this.fontSize = fontSize;
        this.setUpdateTextFlag();
        return this;
    }
    setFontFamily(fontFamily) {
        this.fontFamily = fontFamily;
        this.setUpdateTextFlag();
        return this;
    }
    get font() {
        return `${this.fontStyle} ${this.fontSize} ${this.fontFamily}`;
    }
    setColor(color) {
        this.color = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color);
        return this;
    }
    get hasFill() {
        return this.color != null;
    }
    setStrokeStyle(stroke, strokeThickness) {
        this.stroke = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(stroke);
        if (strokeThickness !== undefined) this.strokeThickness = strokeThickness;
        return this;
    }
    setStrokeThickness(strokeThickness) {
        this.strokeThickness = strokeThickness;
        return this;
    }
    get hasStroke() {
        return this.stroke != null && this.strokeThickness > 0;
    }
    setShadowColor(color) {
        this.shadowColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color);
        return this;
    }
    setShadowOffset(offsetX, offsetY) {
        if (offsetX === undefined) offsetX = 0;
        if (offsetY === undefined) offsetY = 0;
        this.shadowOffsetX = offsetX;
        this.shadowOffsetY = offsetY;
        return this;
    }
    setShadowBlur(blur) {
        if (blur === undefined) blur = 0;
        this.shaodwBlur = blur;
        return this;
    }
    setShadow(color, offsetX, offsetY, blur) {
        this.setShadowColor(color).setShadowOffset(offsetX, offsetY).setShadowBlur(blur);
        return this;
    }
    setBackgroundColor(color) {
        this.backgroundColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color);
        return this;
    }
    get hasBackgroundColor() {
        return this.backgroundColor != null;
    }
    setBackgroundHeight(height) {
        this.backgroundHeight = height;
        return this;
    }
    setBackgroundBottomY(y) {
        this.backgroundBottomY = y;
        return this;
    }
    setOffsetX(offsetX) {
        if (offsetX === undefined) offsetX = 0;
        this.offsetX = offsetX;
        return this;
    }
    setOffsetY(offsetY) {
        if (offsetY === undefined) offsetY = 0;
        this.offsetY = offsetY;
        return this;
    }
    setOffset(offsetX, offsetY) {
        this.setOffsetX(offsetX).setOffsetY(offsetY);
        return this;
    }
    setLeftSpace(space) {
        if (space === undefined) space = 0;
        this.leftSpace = space;
        return this;
    }
    setRightSpace(space) {
        if (space === undefined) space = 0;
        this.rightSpace = space;
        return this;
    }
    setSpace(leftSpace, rightSpace) {
        this.setLeftSpace(leftSpace).setRightSpace(rightSpace);
        return this;
    }
    setAlign(align) {
        this.align = align;
        return this;
    }
    syncFont(context) {
        context.font = this.font;
        return this;
    }
    syncStyle(context) {
        context.textBaseline = "alphabetic";
        var hasFill = this.hasFill;
        var hasStroke = this.hasStroke;
        context.fillStyle = hasFill ? this.color : "#000";
        context.strokeStyle = hasStroke ? this.stroke : "#000";
        context.lineWidth = hasStroke ? this.strokeThickness : 0;
        context.lineCap = "round";
        context.lineJoin = "round";
        return this;
    }
    syncShadow(context) {
        if (context.shadowColor != null) {
            context.shadowColor = this.shadowColor;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
            context.shadowBlur = this.shadowBlur;
        } else {
            context.shadowColor = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
            context.shadowBlur = 0;
        }
    }
    getTextMetrics(context, text) {
        this.syncFont(context).syncStyle(context);
        return context.measureText(text);
    }
}
var $8b2883a087adad94$export$2e2bcd8739ae039 = $8b2883a087adad94$var$TextStyle;


var $0ed54e0694c21abe$var$SetFixedSize = function(width, height) {
    if (width === undefined) width = 0;
    if (height === undefined) height = 0;
    var dirty = this.fixedWidth !== width || this.fixedHeight !== height;
    if (!dirty) return this;
    this.fixedWidth = width;
    this.fixedHeight = height;
    this.dirty = true;
    this.setCanvasSize(width > 0 ? width : this.width, height > 0 ? height : this.height);
    return this;
};
var $0ed54e0694c21abe$export$2e2bcd8739ae039 = $0ed54e0694c21abe$var$SetFixedSize;



var $1b01777947c6985f$var$SetPadding = function(key, value) {
    var padding = this.padding;
    var paddingLeft = padding.left, paddingRight = padding.right, paddingTop = padding.top, paddingBottom = padding.bottom;
    (0, $efa8a86e39512506$export$dd20faac850f550d)(padding, key, value);
    this.dirty = this.dirty || paddingLeft != padding.left || paddingRight != padding.right || paddingTop != padding.top || paddingBottom != padding.bottom;
    return this;
};
var $1b01777947c6985f$export$2e2bcd8739ae039 = $1b01777947c6985f$var$SetPadding;



var $7a68142e70f9013d$var$GetPadding = function(key) {
    return (0, $efa8a86e39512506$export$95358a8f491113ca)(this.padding, key);
};
var $7a68142e70f9013d$export$2e2bcd8739ae039 = $7a68142e70f9013d$var$GetPadding;


var $dd7524e0304e757b$var$ModifyTextStyle = function(style) {
    this.textStyle.modify(style);
    return this;
};
var $dd7524e0304e757b$export$2e2bcd8739ae039 = $dd7524e0304e757b$var$ModifyTextStyle;


var $24308041a1287356$var$ModifyDefaultTextStyle = function(style) {
    this.defaultTextStyle.modify(style);
    return this;
};
var $24308041a1287356$export$2e2bcd8739ae039 = $24308041a1287356$var$ModifyDefaultTextStyle;


var $1c77eaff31f6bc5d$var$ResetTextStyle = function() {
    this.textStyle.copyFrom(this.defaultTextStyle);
    return this;
};
var $1c77eaff31f6bc5d$export$2e2bcd8739ae039 = $1c77eaff31f6bc5d$var$ResetTextStyle;


var $8b28dc7739c98703$var$SetTestString = function(testString) {
    this.testString = testString;
    return this;
};
var $8b28dc7739c98703$export$2e2bcd8739ae039 = $8b28dc7739c98703$var$SetTestString;


const $5e2df4efedd104b6$var$RemoveItem = Phaser.Utils.Array.Remove;
var $5e2df4efedd104b6$var$RemoveChild = function(child) {
    this.poolManager.free(child);
    $5e2df4efedd104b6$var$RemoveItem(this.children, child);
    this.lastAppendedChildren.length = 0;
    this.lastOverChild = null;
    this.dirty = true;
    return this;
};
var $5e2df4efedd104b6$export$2e2bcd8739ae039 = $5e2df4efedd104b6$var$RemoveChild;


var $9a1d2f799d6fd5be$var$RemoveChildren = function() {
    this.poolManager.freeMultiple(this.children);
    this.children.length = 0;
    this.lastAppendedChildren.length = 0;
    this.lastOverChild = null;
    this.dirty = true;
    return this;
};
var $9a1d2f799d6fd5be$export$2e2bcd8739ae039 = $9a1d2f799d6fd5be$var$RemoveChildren;


const $db7fdee9407bb41e$var$RemoveItem = Phaser.Utils.Array.Remove;
var $db7fdee9407bb41e$var$PopChild = function(child) {
    $db7fdee9407bb41e$var$RemoveItem(this.children, child);
    this.lastAppendedChildren.length = 0;
    this.lastOverChild = null;
    this.dirty = true;
    return this;
};
var $db7fdee9407bb41e$export$2e2bcd8739ae039 = $db7fdee9407bb41e$var$PopChild;


var $d2b1814f8721fee0$var$ClearContent = function() {
    this.setText();
    return this;
};
var $d2b1814f8721fee0$export$2e2bcd8739ae039 = $d2b1814f8721fee0$var$ClearContent;


// const RemoveItem = Phaser.Utils.Array.Remove;
var $bcb8cf611e291abc$var$AddChild = function(child, index) {
    var areChildren = Array.isArray(child);
    // Remove existed child(s)
    // RemoveItem(this.children, child);
    if (index === undefined || index === this.children.length) {
        if (areChildren) this.children.push(...child);
        else this.children.push(child);
    } else if (areChildren) this.children.splice(index, 0, ...child);
    else this.children.splice(index, 0, child);
    this.lastAppendedChildren.length = 0;
    if (areChildren) this.lastAppendedChildren.push(...child);
    else this.lastAppendedChildren.push(child);
    return this;
};
var $bcb8cf611e291abc$export$2e2bcd8739ae039 = $bcb8cf611e291abc$var$AddChild;



const $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f = "text";
const $5ef7af43adf3a4f3$export$8ac940edd7aeacfd = "image";
const $5ef7af43adf3a4f3$export$bdc82af646e1d9ad = "drawer";
const $5ef7af43adf3a4f3$export$e807660a8cf938ce = "space";
const $5ef7af43adf3a4f3$export$2e4fac2880e543a = "command";
var $5ef7af43adf3a4f3$export$1d9551ed25b16f2b = function(bob) {
    return bob.type === $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f && bob.text === "\n";
};
var $5ef7af43adf3a4f3$export$8a45046ee0f7fa8e = function(bob) {
    return bob.type === $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f && bob.text === "\f";
};
var $5ef7af43adf3a4f3$export$be5f01e68f8ba9f9 = function(bob) {
    return bob.type === $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f && bob.text === " ";
};
var $5ef7af43adf3a4f3$export$a4ff6875eea5bed7 = function(bob) {
    return bob.type === $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f;
};
var $5ef7af43adf3a4f3$export$5d4d9a7a8abe34b5 = function(bob) {
    return bob.type === $5ef7af43adf3a4f3$export$2e4fac2880e543a;
};



class $11d2e0546b8fcee4$var$CharData extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, text, style){
        super(parent, (0, $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f));
        this.updateTextFlag = false;
        this.style = new (0, $8b2883a087adad94$export$2e2bcd8739ae039)(this, style);
        this.setText(text);
    }
    get autoRound() {
        return this.parent.autoRound;
    }
    get offsetX() {
        return this.style.offsetX;
    }
    set offsetX(value) {
        if (this.style) this.style.offsetX = value;
    }
    get offsetY() {
        return this.style.offsetY;
    }
    set offsetY(value) {
        if (this.style) this.style.offsetY = value;
    }
    get leftSpace() {
        return this.style.leftSpace * this.scaleX;
    }
    set leftSpace(value) {
        if (this.style) this.style.leftSpace = value;
        super.leftSpace = value;
    }
    get rightSpace() {
        return this.style.rightSpace * this.scaleX;
    }
    set rightSpace(value) {
        if (this.style) this.style.rightSpace = value;
        super.rightSpace = value;
    }
    get align() {
        return this.style.align;
    }
    set align(value) {
        if (this.style) this.style.align = value;
    }
    modifyStyle(style) {
        this.setDirty(true);
        this.style.modify(style);
        if (this.updateTextFlag) this.updateTextSize();
        return this;
    }
    modifyPorperties(o) {
        if (!o) return this;
        this.modifyStyle(o);
        super.modifyPorperties(o);
        return this;
    }
    setText(text) {
        this.setDirty(this.text != text);
        this.text = text;
        this.updateTextSize();
        return this;
    }
    updateTextSize() {
        var text = this.text;
        // Is new-line, page-break, or empty character
        if (text === "\n" || text === "\f" || text === "") {
            this.textWidth = 0;
            this.textHeight = 0;
            this.ascent = 0;
            this.descent = 0;
        } else {
            var metrics = this.style.getTextMetrics(this.context, this.text);
            this.textWidth = metrics.width;
            var ascent, descent;
            if ("actualBoundingBoxAscent" in metrics) {
                ascent = metrics.actualBoundingBoxAscent;
                descent = metrics.actualBoundingBoxDescent;
            } else {
                ascent = 0;
                descent = 0;
            }
            this.textHeight = ascent + descent;
            this.ascent = ascent;
            this.descent = descent;
        }
        this.updateTextFlag = false;
        return this;
    }
    get width() {
        return this.textWidth * this.scaleX;
    }
    set width(value) {
        if (this.textWidth > 0) this.scaleX = value / this.textWidth;
        else this.scaleX = 1;
    }
    get height() {
        return this.textHeight * this.scaleY;
    }
    set height(value) {
        if (this.textHeight > 0) this.scaleY = value / this.textHeight;
        else this.scaleY = 1;
    }
    get willRender() {
        var text = this.text;
        if (text === "\n" || text === "\f") return false;
        return super.willRender;
    }
    renderContent() {
        var context = this.context;
        var textStyle = this.style;
        if (textStyle.hasBackgroundColor) {
            context.fillStyle = textStyle.backgroundColor;
            var x = this.drawTLX;
            var width = this.drawTRX - x;
            var bottomY = textStyle.backgroundBottomY;
            if (bottomY == null) bottomY = this.drawBLY;
            var height = textStyle.backgroundHeight;
            if (height == null) height = bottomY - this.drawTLY;
            var y = bottomY - height;
            context.fillRect(x, y, width, height);
        }
        var hasFill = textStyle.hasFill, hasStroke = textStyle.hasStroke;
        if (!hasFill && !hasStroke) return;
        textStyle.syncFont(context).syncStyle(context);
        // textBaseline = 'alphabetic'
        if (hasStroke) {
            textStyle.syncShadow(context);
            context.strokeText(this.text, 0, 0);
        }
        if (hasFill) {
            textStyle.syncShadow(context);
            context.fillText(this.text, 0, 0);
        }
    }
    get drawTLX() {
        return -this.leftSpace;
    }
    get drawTLY() {
        return -this.ascent;
    }
    get drawBLX() {
        return -this.leftSpace;
    }
    get drawBLY() {
        return this.descent;
    }
    get drawTRX() {
        return this.textWidth + this.rightSpace;
    }
    get drawTRY() {
        return -this.ascent;
    }
    get drawBRX() {
        return this.textWidth + this.rightSpace;
    }
    get drawBRY() {
        return this.descent;
    }
}
var $11d2e0546b8fcee4$export$2e2bcd8739ae039 = $11d2e0546b8fcee4$var$CharData;



var $8d96e356f69b696b$var$CreateCharChild = function(text, style) {
    if (style) this.textStyle.modify(style);
    var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f));
    if (child === null) child = new (0, $11d2e0546b8fcee4$export$2e2bcd8739ae039)(this, text, this.textStyle);
    else child.setParent(this).setActive().modifyStyle(this.textStyle).setText(text);
    return child;
};
var $8d96e356f69b696b$export$2e2bcd8739ae039 = $8d96e356f69b696b$var$CreateCharChild;




var $d186ecb35a2f0c2d$var$CreateCharChildren = function(text, style) {
    if (style) this.textStyle.modify(style);
    var children = [];
    for(var i = 0, cnt = text.length; i < cnt; i++){
        var char = text.charAt(i);
        var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f));
        if (child === null) child = new (0, $11d2e0546b8fcee4$export$2e2bcd8739ae039)(this, char, this.textStyle);
        else child.setParent(this).setActive().modifyStyle(this.textStyle).setText(char);
        // child.modifyPorperties(properties);  // Warning: Will modify text-style twice
        children.push(child);
    }
    return children;
};
var $d186ecb35a2f0c2d$export$2e2bcd8739ae039 = $d186ecb35a2f0c2d$var$CreateCharChildren;


var $a1b2cd985c54bbaf$var$AppendText = function(text, style) {
    var children = this.createCharChildren(text, style);
    this.addChild(children);
    return this;
};
var $a1b2cd985c54bbaf$export$2e2bcd8739ae039 = $a1b2cd985c54bbaf$var$AppendText;


var $322b581f13a3b7e0$var$SetText = function(text, style) {
    if (text === undefined) text = "";
    this.removeChildren();
    (0, $a1b2cd985c54bbaf$export$2e2bcd8739ae039).call(this, text, style); // this.appendText might be override
    this.dirty = true;
    return this;
};
var $322b581f13a3b7e0$export$2e2bcd8739ae039 = $322b581f13a3b7e0$var$SetText;



var $624fcbdc0195e261$var$InsertText = function(index, text, style) {
    var children = this.createCharChildren(text, style);
    index = this.getCharChildIndex(index, true);
    this.addChild(children, index);
    return this;
};
var $624fcbdc0195e261$export$2e2bcd8739ae039 = $624fcbdc0195e261$var$InsertText;


var $17cda18b8eb88ad4$var$RemoveText = function(index, length) {
    if (length === undefined) length = 1;
    for(var i = 0; i < length; i++){
        var childIndex = this.getCharChildIndex(index, true);
        if (childIndex === undefined) break;
        this.removeChild(this.children[childIndex]);
    }
    return this;
};
var $17cda18b8eb88ad4$export$2e2bcd8739ae039 = $17cda18b8eb88ad4$var$RemoveText;


var $836532c63c99fa08$var$GetText = function(activeOnly) {
    var text = "";
    this.forEachCharChild(function(child) {
        text += child.text;
    }, undefined, activeOnly);
    return text;
};
var $836532c63c99fa08$export$2e2bcd8739ae039 = $836532c63c99fa08$var$GetText;




class $bcf327348d83e2ff$var$ImageData extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, key, frame){
        super(parent, (0, $5ef7af43adf3a4f3$export$8ac940edd7aeacfd));
        this.setTexture(key, frame);
    }
    get frameWidth() {
        return this.frameObj ? this.frameObj.cutWidth : 0;
    }
    get frameHeight() {
        return this.frameObj ? this.frameObj.cutHeight : 0;
    }
    get offsetY() {
        return -this.height;
    }
    set offsetY(value) {}
    get key() {
        return this._key;
    }
    set key(value) {
        this.setDirty(this._key != value);
        this._key = value;
    }
    get frame() {
        return this._frame;
    }
    set frame(value) {
        this.setDirty(this._frame != value);
        this._frame = value;
    }
    setTexture(key, frame) {
        this.key = key;
        this.frame = frame;
        this.frameObj = this.scene.sys.textures.getFrame(key, frame);
        return this;
    }
    get width() {
        return this.frameWidth * this.scaleX;
    }
    set width(value) {
        this.setDirty(this.width !== value);
        this.scaleX = value / this.frameWidth;
    }
    get height() {
        return this.frameHeight * this.scaleY;
    }
    set height(value) {
        this.setDirty(this.height !== value);
        this.scaleY = value / this.frameHeight;
    }
    setHeight(height, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.height = height;
        if (keepAspectRatio) this.scaleX = this.scaleY;
        return this;
    }
    renderContent() {
        var context = this.context;
        var frame = this.frameObj;
        var width = this.frameWidth, height = this.frameHeight;
        context.drawImage(frame.source.image, frame.cutX, frame.cutY, width, height, 0, 0, width, height);
    }
    get drawTLX() {
        return -this.leftSpace;
    }
    get drawTLY() {
        return 0;
    }
    get drawBLX() {
        return -this.leftSpace;
    }
    get drawBLY() {
        return this.frameHeight;
    }
    get drawTRX() {
        return this.frameWidth + this.rightSpace;
    }
    get drawTRY() {
        return 0;
    }
    get drawBRX() {
        return this.frameWidth + this.rightSpace;
    }
    get drawBRY() {
        return this.frameHeight;
    }
}
var $bcf327348d83e2ff$export$2e2bcd8739ae039 = $bcf327348d83e2ff$var$ImageData;



var $7d1e31868af30e18$var$CreateImageChild = function(key, frame, properties) {
    var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$8ac940edd7aeacfd));
    if (child === null) child = new (0, $bcf327348d83e2ff$export$2e2bcd8739ae039)(this, key, frame);
    else child.setParent(this).setActive().setTexture(key, frame);
    child.modifyPorperties(properties);
    return child;
};
var $7d1e31868af30e18$export$2e2bcd8739ae039 = $7d1e31868af30e18$var$CreateImageChild;


var $6d623769bfdd4525$var$AppendImage = function(key, frame, properties) {
    var child = this.createImageChild(key, frame, properties);
    this.addChild(child);
    return this;
};
var $6d623769bfdd4525$export$2e2bcd8739ae039 = $6d623769bfdd4525$var$AppendImage;




class $4c1cd42a7584b271$var$Drawer extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, renderCallback, width, height){
        super(parent, (0, $5ef7af43adf3a4f3$export$bdc82af646e1d9ad));
        this.setRenderCallback(renderCallback);
        this.setDrawerSize(width, height);
    }
    setRenderCallback(callback) {
        if (callback) this.renderContent = callback.bind(this);
        else delete this.renderContent;
        return this;
    }
    setDrawerSize(width, height) {
        // Whole canvas
        if (width === true) {
            this.toLocalPosition = false;
            width = undefined;
            height = undefined;
        } else this.toLocalPosition = true;
        if (width === undefined) width = 0;
        if (height === undefined) height = width;
        this.drawerWidth = width;
        this.drawerHeight = height;
        return this;
    }
    onFree() {
        super.onFree();
        this.setRenderCallback();
    }
    get width() {
        return this.drawerWidth * this.scaleX;
    }
    set width(value) {
        this.setDirty(this.width !== value);
        this.scaleX = this.drawerWidth > 0 ? value / this.drawerWidth : 1;
    }
    get height() {
        return this.drawerHeight * this.scaleY;
    }
    set height(value) {
        this.setDirty(this.height !== value);
        this.scaleY = this.drawerHeight > 0 ? value / this.drawerHeight : 1;
    }
    get offsetY() {
        return -this.height;
    }
    set offsetY(value) {}
    get drawTLX() {
        return -this.leftSpace;
    }
    get drawTLY() {
        return 0;
    }
    get drawBLX() {
        return -this.leftSpace;
    }
    get drawBLY() {
        return this.drawerHeight;
    }
    get drawTRX() {
        return this.drawerWidth + this.rightSpace;
    }
    get drawTRY() {
        return 0;
    }
    get drawBRX() {
        return this.drawerWidth + this.rightSpace;
    }
    get drawBRY() {
        return this.drawerHeight;
    }
}
var $4c1cd42a7584b271$export$2e2bcd8739ae039 = $4c1cd42a7584b271$var$Drawer;



var $f66c47955d5c3ca6$var$CreateDrawerChild = function(renderCallback, width, height) {
    var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$bdc82af646e1d9ad));
    if (child === null) child = new (0, $4c1cd42a7584b271$export$2e2bcd8739ae039)(this, renderCallback, width, height);
    else child.setParent(this).setActive().setRenderCallback(renderCallback).setDrawerSize(width, height);
    return child;
};
var $f66c47955d5c3ca6$export$2e2bcd8739ae039 = $f66c47955d5c3ca6$var$CreateDrawerChild;


var $35484843ff1563f3$var$AppendDrawer = function(renderCallback, width, height) {
    var child = this.createDrawerChild(renderCallback, width, height);
    this.addChild(child);
    return this;
};
var $35484843ff1563f3$export$2e2bcd8739ae039 = $35484843ff1563f3$var$AppendDrawer;




class $5975c6caae4ad229$var$Space extends (0, $5172eeaecaf3ec82$export$2e2bcd8739ae039) {
    constructor(parent, width){
        super(parent, (0, $5ef7af43adf3a4f3$export$e807660a8cf938ce));
        this.setSpaceWidth(width);
    }
    get width() {
        return this.spaceWidth * this.scaleX;
    }
    set width(value) {
        if (this.spaceWidth > 0) this.scaleX = value / this.spaceWidth;
        else this.scaleX = 1;
    }
    setSpaceWidth(width) {
        this.spaceWidth = width;
        return this;
    }
}
var $5975c6caae4ad229$export$2e2bcd8739ae039 = $5975c6caae4ad229$var$Space;



var $059bc853f935cf27$var$CreateSpaceChild = function(width) {
    var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$e807660a8cf938ce));
    if (child === null) child = new (0, $5975c6caae4ad229$export$2e2bcd8739ae039)(this, width);
    else child.setParent(this).setActive().setSpaceWidth(width);
    return child;
};
var $059bc853f935cf27$export$2e2bcd8739ae039 = $059bc853f935cf27$var$CreateSpaceChild;


var $5a2f0ac7beb464ab$var$AppendSpace = function(width) {
    var child = this.createSpaceChild(width);
    this.addChild(child);
    return this;
};
var $5a2f0ac7beb464ab$export$2e2bcd8739ae039 = $5a2f0ac7beb464ab$var$AppendSpace;





class $441a690555f39a76$var$Command extends (0, $e74dea98d2a81481$export$2e2bcd8739ae039) {
    constructor(parent, name, callback, param, scope){
        super(parent, (0, $5ef7af43adf3a4f3$export$2e4fac2880e543a));
        this.setName(name).setParameter(param).setCallback(callback, scope);
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setParameter(param) {
        this.param = param;
        return this;
    }
    setCallback(callback, scope) {
        this.callback = callback;
        this.scope = scope;
        return this;
    }
    exec() {
        var result;
        if (this.scope) result = this.callback.call(this.scope, this.param, this.name);
        else result = this.callback(this.param, this.name);
        return result;
    }
    onFree() {
        super.onFree();
        this.setName().setCallback().setParameter();
    }
}
var $441a690555f39a76$export$2e2bcd8739ae039 = $441a690555f39a76$var$Command;


var $e485e3d4af1e3b0c$var$CreateCommandChild = function(name, callback, param, scope) {
    var child = this.poolManager.allocate((0, $5ef7af43adf3a4f3$export$2e4fac2880e543a));
    if (child === null) child = new (0, $441a690555f39a76$export$2e2bcd8739ae039)(this, name, callback, param, scope);
    else child.setParent(this).setActive().setName(name).setCallback(callback, scope).setParameter(param);
    return child;
};
var $e485e3d4af1e3b0c$export$2e2bcd8739ae039 = $e485e3d4af1e3b0c$var$CreateCommandChild;


var $399ddda816911e07$var$AppendCommand = function(name, callback, param, scope) {
    var child = this.createCommandChild(name, callback, param, scope);
    this.addChild(child);
    return this;
};
var $399ddda816911e07$export$2e2bcd8739ae039 = $399ddda816911e07$var$AppendCommand;


/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ /**
 * This is a slightly modified version of jQuery.isPlainObject.
 * A plain object is an object whose internal class property is [object Object].
 *
 * @function Phaser.Utils.Objects.IsPlainObject
 * @since 3.0.0
 *
 * @param {object} obj - The object to inspect.
 *
 * @return {boolean} `true` if the object is plain, otherwise `false`.
 */ var $dcd330f49310c793$var$IsPlainObject = function(obj) {
    // Not plain objects:
    // - Any object or value whose internal [[Class]] property is not "[object Object]"
    // - DOM nodes
    // - window
    if (typeof obj !== "object" || obj.nodeType || obj === obj.window) return false;
    // Support: Firefox <20
    // The try/catch suppresses exceptions thrown when attempting to access
    // the "constructor" property of certain host objects, ie. |window.location|
    // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
    try {
        if (obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf")) return false;
    } catch (e) {
        return false;
    }
    // If the function hasn't returned already, we're confident that
    // |obj| is a plain object, created by {} or constructed with new Object
    return true;
};
var $dcd330f49310c793$export$2e2bcd8739ae039 = $dcd330f49310c793$var$IsPlainObject;


var $207ab8eaca87355d$var$DeepClone = function(inObject) {
    var outObject;
    var value;
    var key;
    if (inObject == null || typeof inObject !== "object") //  inObject is not an object
    return inObject;
    //  Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {};
    if ((0, $dcd330f49310c793$export$2e2bcd8739ae039)(inObject)) for(key in inObject){
        value = inObject[key];
        //  Recursively (deep) copy for nested objects, including arrays
        outObject[key] = $207ab8eaca87355d$var$DeepClone(value);
    }
    else outObject = inObject;
    return outObject;
};
var $207ab8eaca87355d$export$2e2bcd8739ae039 = $207ab8eaca87355d$var$DeepClone;


var $09f7ae1c80539995$var$SetWrapConfig = function(config) {
    if (config === undefined) config = {};
    else if (typeof config === "object") config = (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config);
    this.wrapConfig = config;
    return this;
};
var $09f7ae1c80539995$export$2e2bcd8739ae039 = $09f7ae1c80539995$var$SetWrapConfig;




var $8a26698af76532e5$var$GetWord = function(children, startIndex, charMode, result) {
    if (result === undefined) result = {
        word: [],
        width: 0
    };
    result.word.length = 0;
    var endIndex = children.length;
    var currentIndex = startIndex;
    var word = result.word, wordWidth = 0;
    while(currentIndex < endIndex){
        var child = children[currentIndex];
        // Can't render (command child), put into output directly
        if (!child.renderable) {
            word.push(child);
            currentIndex++;
            continue;
        }
        var text = child.type === (0, $5ef7af43adf3a4f3$export$5b5f35c9a7f1052f) ? child.text : null;
        if (text !== null && text !== " " && text !== "\n" && text !== "\f") {
            word.push(child);
            wordWidth += child.outerWidth;
            currentIndex++;
        // Continue
        } else {
            if (currentIndex === startIndex) {
                word.push(child);
                wordWidth += child.outerWidth;
            }
            break;
        }
        if (charMode) break;
    }
    result.width = wordWidth;
    return result;
};
var $8a26698af76532e5$export$2e2bcd8739ae039 = $8a26698af76532e5$var$GetWord;


var $8877c45a05d9ae06$var$GetChildrenAlign = function(children) {
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.align !== undefined) return child.align;
    }
    return undefined;
};
var $8877c45a05d9ae06$export$2e2bcd8739ae039 = $8877c45a05d9ae06$var$GetChildrenAlign;


var $2228d1e65e783c78$var$OffsetChildren = function(children, offsetX, offsetY) {
    if (offsetX === 0 && offsetY === 0) return;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (!child.renderable) continue;
        child.x += offsetX;
        child.y += offsetY;
    }
};
var $2228d1e65e783c78$export$2e2bcd8739ae039 = $2228d1e65e783c78$var$OffsetChildren;


var $5d19c496cbc96756$var$AlignLines = function(result, width, height) {
    var hAlign = result.hAlign, vAlign = result.vAlign;
    var offsetX, offsetY;
    var linesHeight = result.linesHeight;
    switch(vAlign){
        case 1:
        case "center":
            offsetY = (height - linesHeight) / 2;
            break;
        case 2:
        case "bottom":
            offsetY = height - linesHeight;
            break;
        default:
            offsetY = 0;
            break;
    }
    var lines = result.lines;
    for(var li = 0, lcnt = lines.length; li < lcnt; li++){
        var line = lines[li];
        var lineWidth = line.width, children = line.children;
        var lineHAlign = (0, $8877c45a05d9ae06$export$2e2bcd8739ae039)(children);
        if (lineHAlign === undefined) lineHAlign = hAlign;
        switch(lineHAlign){
            case 1:
            case "center":
                offsetX = (width - lineWidth) / 2;
                break;
            case 2:
            case "right":
                offsetX = width - lineWidth;
                break;
            default:
                offsetX = 0;
                break;
        }
        (0, $2228d1e65e783c78$export$2e2bcd8739ae039)(children, offsetX, offsetY);
    }
};
var $5d19c496cbc96756$export$2e2bcd8739ae039 = $5d19c496cbc96756$var$AlignLines;



var $b3d178cae1cf4059$var$GetDefaultTextHeight = function() {
    var metrics = this.defaultTextStyle.getTextMetrics(this.context, this.testString);
    var ascent, descent;
    if ("actualBoundingBoxAscent" in metrics) {
        ascent = metrics.actualBoundingBoxAscent;
        descent = metrics.actualBoundingBoxDescent;
    } else {
        ascent = 0;
        descent = 0;
    }
    $b3d178cae1cf4059$var$Result.ascent = ascent;
    $b3d178cae1cf4059$var$Result.descent = descent;
    $b3d178cae1cf4059$var$Result.height = ascent + descent;
    return $b3d178cae1cf4059$var$Result;
};
var $b3d178cae1cf4059$var$Result = {};
var $b3d178cae1cf4059$export$2e2bcd8739ae039 = $b3d178cae1cf4059$var$GetDefaultTextHeight;


const $367e644f92a78e42$var$GetValue = Phaser.Utils.Objects.GetValue;
var $367e644f92a78e42$var$RunWordWrap = function(config) {
    // Parse parameters
    var startIndex = $367e644f92a78e42$var$GetValue(config, "start", 0);
    (0, $efa8a86e39512506$export$dd20faac850f550d)(this.wrapPadding, $367e644f92a78e42$var$GetValue(config, "padding", 0));
    var paddingVertical = this.padding.top + this.padding.bottom + this.wrapPadding.top + this.wrapPadding.bottom;
    var paddingHorizontal = this.padding.left + this.padding.right + this.wrapPadding.left + this.wrapPadding.right;
    // Get lineHeight, maxLines
    var lineHeight = $367e644f92a78e42$var$GetValue(config, "lineHeight");
    var ascent = $367e644f92a78e42$var$GetValue(config, "ascent", lineHeight);
    var maxLines;
    if (lineHeight === undefined) {
        // Calculate lineHeight
        var useDefaultTextHeight = $367e644f92a78e42$var$GetValue(config, "useDefaultTextHeight", false);
        maxLines = $367e644f92a78e42$var$GetValue(config, "maxLines", 0);
        if (this.fixedHeight > 0 && !useDefaultTextHeight) {
            var innerHeight = this.fixedHeight - paddingVertical;
            if (maxLines > 0) // Calculate lineHeight via maxLines, in fixedHeight mode
            lineHeight = innerHeight / maxLines;
            else {
                var textHeightResult = (0, $b3d178cae1cf4059$export$2e2bcd8739ae039).call(this);
                lineHeight = textHeightResult.height;
                ascent = textHeightResult.ascent;
                // Calculate maxLines via (ascent, lineHeight), in fixedHeight mode
                maxLines = Math.floor((innerHeight - ascent) / lineHeight);
            }
        } else {
            var textHeightResult = (0, $b3d178cae1cf4059$export$2e2bcd8739ae039).call(this);
            lineHeight = textHeightResult.height;
            ascent = textHeightResult.ascent;
        }
    } else // Calculate maxLines
    if (this.fixedHeight > 0) {
        // Calculate maxLines via lineHeight, in fixedHeight mode
        maxLines = $367e644f92a78e42$var$GetValue(config, "maxLines");
        if (maxLines === undefined) {
            var innerHeight = this.fixedHeight - paddingVertical;
            maxLines = Math.floor(innerHeight / lineHeight);
        }
    } else maxLines = $367e644f92a78e42$var$GetValue(config, "maxLines", 0); // Default is show all lines
    // If ascent is undefined, assign to lineHeight
    if (ascent === undefined) ascent = lineHeight;
    var showAllLines = maxLines === 0;
    // Get wrapWidth
    var wrapWidth = $367e644f92a78e42$var$GetValue(config, "wrapWidth", undefined);
    if (wrapWidth === undefined) {
        if (this.fixedWidth > 0) wrapWidth = this.fixedWidth - paddingHorizontal;
        else wrapWidth = Infinity; // No word-wrap
    }
    var letterSpacing = $367e644f92a78e42$var$GetValue(config, "letterSpacing", 0);
    var hAlign = $367e644f92a78e42$var$GetValue(config, "hAlign", 0);
    var vAlign = $367e644f92a78e42$var$GetValue(config, "vAlign", 0);
    var charWrap = $367e644f92a78e42$var$GetValue(config, "charWrap", false);
    var result = {
        callback: "runWordWrap",
        start: startIndex,
        isLastPage: false,
        padding: this.wrapPadding,
        ascent: ascent,
        lineHeight: lineHeight,
        maxLines: maxLines,
        wrapWidth: wrapWidth,
        letterSpacing: letterSpacing,
        hAlign: hAlign,
        vAlign: vAlign,
        charWrap: charWrap,
        children: [],
        lines: [],
        maxLineWidth: 0,
        linesHeight: 0
    };
    // Set all children to inactive
    var children = this.children;
    for(var i = 0, cnt = children.length; i < cnt; i++)children[i].setActive(false);
    // Layout children
    wrapWidth += letterSpacing;
    var startX = this.padding.left + this.wrapPadding.left, startY = this.padding.top + this.wrapPadding.top + ascent, x = startX, y = startY;
    var remainderWidth = wrapWidth, childIndex = startIndex, lastChildIndex = children.length;
    var resultChildren = result.children;
    var resultLines = result.lines, lastLine = [], lastLineWidth = 0, maxLineWidth = 0;
    var wordResult;
    while(childIndex < lastChildIndex){
        wordResult = (0, $8a26698af76532e5$export$2e2bcd8739ae039)(children, childIndex, charWrap, wordResult);
        var word = wordResult.word;
        var charCnt = word.length;
        var wordWidth = wordResult.width + charCnt * letterSpacing;
        childIndex += charCnt;
        // Next line
        var isNewLineChar = (0, $5ef7af43adf3a4f3$export$1d9551ed25b16f2b)(word[0]);
        var isPageBreakChar = (0, $5ef7af43adf3a4f3$export$8a45046ee0f7fa8e)(word[0]);
        var isControlChar = isNewLineChar || isPageBreakChar;
        if (remainderWidth < wordWidth || isControlChar) {
            // Add to result
            if (isControlChar) {
                var char = word[0];
                char.setActive().setPosition(x, y);
                resultChildren.push(char);
                lastLine.push(char);
            }
            // Move cursor
            x = startX;
            y += lineHeight;
            remainderWidth = wrapWidth;
            resultLines.push({
                children: lastLine,
                width: lastLineWidth
            });
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
            lastLineWidth = 0;
            lastLine = [];
            var isPageEnd = isPageBreakChar || !showAllLines && resultLines.length === maxLines; // Exceed maxLines
            if (isPageEnd) break;
            else if (isControlChar) continue;
        }
        remainderWidth -= wordWidth;
        lastLineWidth += wordWidth;
        for(var i = 0, cnt = word.length; i < cnt; i++){
            var child = word[i];
            child.setActive();
            resultChildren.push(child);
            lastLine.push(child);
            if (child.renderable) {
                child.setPosition(x, y);
                x += child.outerWidth + letterSpacing;
            }
        }
    }
    if (lastLine.length > 0) {
        resultLines.push({
            children: lastLine,
            width: lastLineWidth
        });
        maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
    }
    result.start += resultChildren.length;
    result.isLastPage = result.start === lastChildIndex;
    result.maxLineWidth = maxLineWidth;
    result.linesHeight = resultLines.length * lineHeight;
    // Calculate size of game object
    var width = this.fixedWidth > 0 ? this.fixedWidth : result.maxLineWidth + paddingHorizontal;
    var height = this.fixedHeight > 0 ? this.fixedHeight : result.linesHeight + paddingVertical;
    // Size might be changed after wrapping
    var innerWidth = width - paddingHorizontal;
    var innerHeight = height - paddingVertical;
    (0, $5d19c496cbc96756$export$2e2bcd8739ae039)(result, innerWidth, innerHeight);
    // Resize
    this.setCanvasSize(width, height);
    // Set initial position
    for(var i = 0, cnt = resultChildren.length; i < cnt; i++){
        var child = resultChildren[i];
        if (!child.renderable) continue;
        child.x0 = child.x;
        child.y0 = child.y;
    }
    return result;
};
var $367e644f92a78e42$export$2e2bcd8739ae039 = $367e644f92a78e42$var$RunWordWrap;


const $a5e1203b55897eab$var$Merge = Phaser.Utils.Objects.Merge;
var $a5e1203b55897eab$var$RunWordWrap = function(config) {
    if (config === undefined) config = {};
    return (0, $367e644f92a78e42$export$2e2bcd8739ae039).call(this, $a5e1203b55897eab$var$Merge(config, this.wrapConfig));
};
var $a5e1203b55897eab$export$2e2bcd8739ae039 = $a5e1203b55897eab$var$RunWordWrap;





var $114dae87a66ced61$var$AlignLines = function(result, width, height) {
    var hAlign = result.hAlign, vAlign = result.vAlign;
    var offsetX, offsetY;
    var rtl = result.rtl;
    var lines = result.lines, lineWidth = result.lineWidth, linesWidth = result.linesWidth;
    switch(hAlign){
        case 1:
        case "center":
            offsetX = (width - linesWidth) / 2;
            break;
        case 2:
        case "right":
            offsetX = width - linesWidth;
            break;
        default:
            offsetX = 0;
            break;
    }
    if (rtl) offsetX += lineWidth;
    for(var li = 0, lcnt = lines.length; li < lcnt; li++){
        var line = lines[rtl ? lcnt - li - 1 : li];
        var children = line.children;
        var lineHeight = line.height;
        var lineVAlign = (0, $8877c45a05d9ae06$export$2e2bcd8739ae039)(children);
        if (lineVAlign === undefined) lineVAlign = vAlign;
        switch(lineVAlign){
            case 1:
            case "center":
                offsetY = (height - lineHeight) / 2;
                break;
            case 2:
            case "bottom":
                offsetY = height - lineHeight;
                break;
            default:
                offsetY = 0;
                break;
        }
        (0, $2228d1e65e783c78$export$2e2bcd8739ae039)(children, offsetX, offsetY);
        offsetX += lineWidth;
    }
};
var $114dae87a66ced61$export$2e2bcd8739ae039 = $114dae87a66ced61$var$AlignLines;



const $f02ae9770c009e3c$var$GetValue = Phaser.Utils.Objects.GetValue;
var $f02ae9770c009e3c$var$RunVerticalWrap = function(config) {
    // Parse parameters
    var startIndex = $f02ae9770c009e3c$var$GetValue(config, "start", 0);
    (0, $efa8a86e39512506$export$dd20faac850f550d)(this.wrapPadding, $f02ae9770c009e3c$var$GetValue(config, "padding", 0));
    var paddingVertical = this.padding.top + this.padding.bottom + this.wrapPadding.top + this.wrapPadding.bottom;
    var paddingHorizontal = this.padding.left + this.padding.right + this.wrapPadding.left + this.wrapPadding.right;
    var lineWidth = $f02ae9770c009e3c$var$GetValue(config, "lineWidth", undefined);
    var maxLines;
    if (lineWidth === undefined) {
        // Calculate lineWidth via maxLines, in fixedWidth mode
        maxLines = $f02ae9770c009e3c$var$GetValue(config, "maxLines", 0);
        if (this.fixedWidth > 0) {
            var innerWidth = this.fixedWidth - paddingHorizontal;
            lineWidth = innerWidth / maxLines;
        } else lineWidth = 0;
    } else if (this.fixedWidth > 0) {
        // Calculate maxLines via lineWidth, in fixedWidth mode
        maxLines = $f02ae9770c009e3c$var$GetValue(config, "maxLines", undefined);
        if (maxLines === undefined) {
            var innerWidth = this.fixedWidth - paddingHorizontal;
            maxLines = Math.floor(innerWidth / lineWidth) + 1;
        }
    } else maxLines = $f02ae9770c009e3c$var$GetValue(config, "maxLines", 0); // Default is show all lines
    var showAllLines = maxLines === 0;
    // Get fixedChildHeight
    var fixedChildHeight = $f02ae9770c009e3c$var$GetValue(config, "fixedChildHeight", undefined);
    if (fixedChildHeight === undefined) {
        var charPerLine = $f02ae9770c009e3c$var$GetValue(config, "charPerLine", undefined);
        if (charPerLine !== undefined) {
            var innerHeight = this.fixedHeight - paddingVertical;
            fixedChildHeight = Math.floor(innerHeight / charPerLine);
        }
    }
    // Get wrapHeight
    var wrapHeight = $f02ae9770c009e3c$var$GetValue(config, "wrapHeight", undefined);
    if (wrapHeight === undefined) {
        if (this.fixedHeight > 0) wrapHeight = this.fixedHeight - paddingVertical;
        else wrapHeight = Infinity; // No word-wrap
    }
    var letterSpacing = $f02ae9770c009e3c$var$GetValue(config, "letterSpacing", 0);
    var rtl = $f02ae9770c009e3c$var$GetValue(config, "rtl", true);
    var hAlign = $f02ae9770c009e3c$var$GetValue(config, "hAlign", rtl ? 2 : 0);
    var vAlign = $f02ae9770c009e3c$var$GetValue(config, "vAlign", 0);
    var result = {
        callback: "runVerticalWrap",
        start: startIndex,
        isLastPage: false,
        padding: this.wrapPadding,
        lineWidth: lineWidth,
        maxLines: maxLines,
        fixedChildHeight: fixedChildHeight,
        wrapHeight: wrapHeight,
        letterSpacing: letterSpacing,
        hAlign: hAlign,
        vAlign: vAlign,
        rtl: rtl,
        children: [],
        lines: [],
        maxLineHeight: 0,
        linesWidth: 0
    };
    // Set all children to active
    var children = this.children;
    for(var i = 0, cnt = children.length; i < cnt; i++)children[i].setActive(false);
    // Layout children
    wrapHeight += letterSpacing;
    var startX = this.padding.left + this.wrapPadding.left, startY = this.padding.top + this.wrapPadding.top, x = startX, y = startY;
    var remainderHeight = wrapHeight, childIndex = startIndex, lastChildIndex = children.length;
    var resultChildren = result.children;
    var resultLines = result.lines, lastLine = [], lastLineHeight = 0, maxLineHeight = 0;
    while(childIndex < lastChildIndex){
        // Append non-typeable child directly
        var char = children[childIndex];
        childIndex++;
        if (!child.renderable) {
            char.setActive();
            resultChildren.push(char);
            lastLine.push(char);
            continue;
        }
        var childHeight = (fixedChildHeight !== undefined ? fixedChildHeight : char.height) + letterSpacing;
        // Next line
        var isNewLineChar = (0, $5ef7af43adf3a4f3$export$1d9551ed25b16f2b)(char);
        var isPageBreakChar = (0, $5ef7af43adf3a4f3$export$8a45046ee0f7fa8e)(char);
        var isControlChar = isNewLineChar || isPageBreakChar;
        if (remainderHeight < childHeight || isControlChar) {
            // Add to result
            if (isNewLineChar) {
                char.setActive().setPosition(x, y).setOrigin(0.5);
                resultChildren.push(char);
                lastLine.push(char);
            }
            // Move cursor
            x = startX;
            y = startY;
            remainderHeight = wrapHeight;
            resultLines.push({
                children: lastLine,
                height: lastLineHeight
            });
            maxLineHeight = Math.max(maxLineHeight, lastLineHeight);
            lastLineHeight = 0;
            lastLine = [];
            var isPageEnd = isPageBreakChar || !showAllLines && resultLines.length === maxLines; // Exceed maxLines
            if (isPageEnd) break;
            else if (isControlChar) continue;
        }
        remainderHeight -= childHeight;
        lastLineHeight += childHeight;
        char.setActive().setPosition(x, y).setOrigin(0.5);
        resultChildren.push(char);
        lastLine.push(char);
        y += childHeight;
    }
    if (lastLine.length > 0) {
        resultLines.push({
            children: lastLine,
            height: lastLineHeight
        });
        maxLineHeight = Math.max(maxLineHeight, lastLineHeight);
    }
    result.start += resultChildren.length;
    result.isLastPage = result.start === lastChildIndex;
    result.maxLineHeight = maxLineHeight;
    result.linesWidth = resultLines.length * lineWidth;
    // Calculate size of game object
    var width = this.fixedWidth > 0 ? this.fixedWidth : result.linesWidth + paddingHorizontal;
    var height = this.fixedHeight > 0 ? this.fixedHeight : result.maxLineHeight + paddingVertical;
    // Size might be changed after wrapping
    var innerWidth = width - paddingHorizontal;
    var innerHeight = height - paddingVertical;
    (0, $114dae87a66ced61$export$2e2bcd8739ae039)(result, innerWidth, innerHeight);
    // Resize
    this.setCanvasSize(width, height);
    // Set initial position
    for(var i = 0, cnt = resultChildren.length; i < cnt; i++){
        var child = resultChildren[i];
        if (!child.renderable) continue;
        child.x0 = child.x;
        child.y0 = child.y;
    }
    return result;
};
var $f02ae9770c009e3c$export$2e2bcd8739ae039 = $f02ae9770c009e3c$var$RunVerticalWrap;


const $57a244a05ed46d20$var$Merge = Phaser.Utils.Objects.Merge;
var $57a244a05ed46d20$var$RunVerticalWrap = function(config) {
    if (config === undefined) config = {};
    return (0, $f02ae9770c009e3c$export$2e2bcd8739ae039).call(this, $57a244a05ed46d20$var$Merge(config, this.wrapConfig));
};
var $57a244a05ed46d20$export$2e2bcd8739ae039 = $57a244a05ed46d20$var$RunVerticalWrap;


const $0d300fb8698b1885$var$GetValue = Phaser.Utils.Objects.GetValue;
var $0d300fb8698b1885$var$RunWrap = function(config) {
    var wrapCallback = $0d300fb8698b1885$var$GetValue(this.wrapConfig, "callback");
    if (!wrapCallback) wrapCallback = $0d300fb8698b1885$var$GetValue(config, "callback", this.runWordWrap);
    if (typeof wrapCallback === "string") wrapCallback = this[wrapCallback];
    return wrapCallback.call(this, config);
};
var $0d300fb8698b1885$export$2e2bcd8739ae039 = $0d300fb8698b1885$var$RunWrap;


var $1db3498fe114bccc$export$2e2bcd8739ae039 = {
    setVAlign (align) {
        this.wrapConfig.vAlign = align;
        return this;
    },
    setHAlign (align) {
        this.wrapConfig.hAlign = align;
        return this;
    }
};


var $c43489207c1d8b44$var$RenderContent = function() {
    this.clear();
    this.setCanvasSize(this.width, this.height);
    if (this.background.active) this.background.render();
    var child;
    for(var i = 0, cnt = this.children.length; i < cnt; i++){
        child = this.children[i];
        if (child.active) child.render();
    }
    if (this.innerBounds.active) this.innerBounds.render();
};
var $c43489207c1d8b44$export$2e2bcd8739ae039 = $c43489207c1d8b44$var$RenderContent;


var $7ac1e37261a2afea$var$ForEachChild = function(callback, scope, activeOnly) {
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    var childIndex = 0;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        var isBreak;
        if (scope) isBreak = callback.call(this, child, childIndex, children);
        else isBreak = callback(child, childIndex, children);
        childIndex++;
        if (isBreak) break;
    }
    return this;
};
var $7ac1e37261a2afea$export$2e2bcd8739ae039 = $7ac1e37261a2afea$var$ForEachChild;


var $f3ce07931d5baa4a$var$ForEachRenderableChild = function(callback, scope, activeOnly) {
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    var childIndex = 0;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        if (child.renderable && !child.removed) {
            var isBreak;
            if (scope) isBreak = callback.call(this, child, childIndex, children);
            else isBreak = callback(child, childIndex, children);
            childIndex++;
            if (isBreak) break;
        }
    }
    return this;
};
var $f3ce07931d5baa4a$export$2e2bcd8739ae039 = $f3ce07931d5baa4a$var$ForEachRenderableChild;



var $6a0a29c544bb8ddc$var$ForEachCharChild = function(callback, scope, activeOnly) {
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    var charIndex = 0;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child) && !child.removed) {
            var isBreak;
            if (scope) isBreak = callback.call(this, child, charIndex, children);
            else isBreak = callback(child, charIndex, children);
            charIndex++;
            if (isBreak) break;
        }
    }
    return this;
};
var $6a0a29c544bb8ddc$export$2e2bcd8739ae039 = $6a0a29c544bb8ddc$var$ForEachCharChild;


var $3d99ae5a16ae9133$var$GetChildren = function() {
    return this.children;
};
var $3d99ae5a16ae9133$export$2e2bcd8739ae039 = $3d99ae5a16ae9133$var$GetChildren;


const $6f2b148417c3c955$var$GetAll = Phaser.Utils.Array.GetAll;
var $6f2b148417c3c955$var$GetActiveChildren = function() {
    return $6f2b148417c3c955$var$GetAll(this.children, "active", true);
};
var $6f2b148417c3c955$export$2e2bcd8739ae039 = $6f2b148417c3c955$var$GetActiveChildren;


var $7500eb7b4406d29d$var$GetCharChildren = function(activeOnly, out) {
    if (out === undefined) out = [];
    this.forEachCharChild(function(child) {
        out.push(child);
    }, undefined, activeOnly);
    return out;
};
var $7500eb7b4406d29d$export$2e2bcd8739ae039 = $7500eb7b4406d29d$var$GetCharChildren;


var $021904e08929300a$var$GetLastAppendedChildren = function() {
    return this.lastAppendedChildren;
};
var $021904e08929300a$export$2e2bcd8739ae039 = $021904e08929300a$var$GetLastAppendedChildren;



var $65c81aea9d6b74c5$var$GetBobCenterPosition = function(bob, offsetX, offsetY, out) {
    if (typeof offsetX !== "number") {
        out = offsetX;
        offsetX = 0;
        offsetY = 0;
    }
    var bobX = bob.drawCenterX + offsetX;
    var bobY = bob.drawCenterY + offsetY;
    return (0, $633a579d5651fab7$export$2e2bcd8739ae039)(bob, bobX, bobY, out);
};
var $65c81aea9d6b74c5$export$2e2bcd8739ae039 = $65c81aea9d6b74c5$var$GetBobCenterPosition;


const $9c9fdee9e6caf865$var$GetDistance = Phaser.Math.Distance.BetweenPointsSquared;
var $9c9fdee9e6caf865$var$GetNearestChild = function(canvasX, canvasY) {
    var pointA = {
        x: canvasX,
        y: canvasY
    };
    var minDistance = Infinity;
    var nearestChild = null;
    this.forEachRenderableChild(function(child) {
        var distance = $9c9fdee9e6caf865$var$GetDistance(pointA, (0, $65c81aea9d6b74c5$export$2e2bcd8739ae039)(child, true));
        if (minDistance > distance) {
            minDistance = distance;
            nearestChild = child;
        }
    });
    return nearestChild;
};
var $9c9fdee9e6caf865$export$2e2bcd8739ae039 = $9c9fdee9e6caf865$var$GetNearestChild;



var $68aa1edb3cd391c3$var$GetCharWorldPosition = function(child, offsetX, offsetY, out) {
    if (typeof child === "number") child = this.getCharChild(child, true);
    return (0, $d8082040f8a2b380$export$2e2bcd8739ae039)(this, child, offsetX, offsetY, out);
};
var $68aa1edb3cd391c3$export$2e2bcd8739ae039 = $68aa1edb3cd391c3$var$GetCharWorldPosition;


var $aded42d10619bfcd$var$SetToMinSize = function() {
    var children = this.children;
    var maxX = 0, maxY = 0;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (!child.renderable || !child.active || !child.visible) continue;
        var x0 = child.x0 !== undefined ? child.x0 : child.x;
        var y0 = child.y0 !== undefined ? child.y0 : child.y;
        maxX = Math.max(maxX, x0);
        maxY = Math.max(maxY, y0);
    }
    var width = maxX + this.padding.left + this.padding.right + this.wrapPadding.left + this.wrapPadding.right;
    var height = maxY + this.padding.top + this.padding.bottom + this.wrapPadding.top + this.wrapPadding.bottom;
    // Ignore fixedWidth, and fixedHeight
    if (this.width !== width || this.height !== height) {
        this.dirty = true;
        this.setCanvasSize(width, height);
    }
    return this;
};
var $aded42d10619bfcd$export$2e2bcd8739ae039 = $aded42d10619bfcd$var$SetToMinSize;



var $72a5e26664fcd095$var$GetCharChildIndex = function(charIndex, activeOnly) {
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child) && !child.removed) {
            if (charIndex === 0) return i;
            else charIndex--;
        }
    }
    return undefined;
};
var $72a5e26664fcd095$export$2e2bcd8739ae039 = $72a5e26664fcd095$var$GetCharChildIndex;



var $5c95adc9c2ce0ade$var$GetCharChild = function(charIndex, activeOnly) {
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child) && !child.removed) {
            if (charIndex === 0) return child;
            else charIndex--;
        }
    }
    return undefined;
};
var $5c95adc9c2ce0ade$export$2e2bcd8739ae039 = $5c95adc9c2ce0ade$var$GetCharChild;



var $59cd5bd3424fdd1f$var$GetCharIndex = function(childIndex, activeOnly) {
    if (typeof childIndex !== "number") {
        childIndex = this.children.indexOf(childIndex);
        if (childIndex < 0) return null;
    }
    if (activeOnly === undefined) activeOnly = true;
    var children = this.children;
    if (childIndex >= children.length) childIndex = children.length;
    var charIndex = 0;
    for(var i = 0; i < childIndex; i++){
        var child = children[i];
        if (activeOnly && !child.active) continue;
        if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child) && !child.removed) charIndex++;
    }
    return charIndex;
};
var $59cd5bd3424fdd1f$export$2e2bcd8739ae039 = $59cd5bd3424fdd1f$var$GetCharIndex;


var $5cd3ee1e5de19607$var$SetChildrenInteractiveEnable = function(enable) {
    if (enable === undefined) enable = true;
    if (this.childrenInteractiveEnable !== enable) this.lastOverChild = null;
    this.childrenInteractiveEnable = enable;
    return this;
};
var $5cd3ee1e5de19607$export$2e2bcd8739ae039 = $5cd3ee1e5de19607$var$SetChildrenInteractiveEnable;


var $818b1d5c3e8f1810$var$GetFirstChildContains = function(children, x, y) {
    var children = children;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (!child.active || !child.renderable) continue;
        if (child.contains(x, y)) return child;
    }
    return null;
};
var $818b1d5c3e8f1810$export$2e2bcd8739ae039 = $818b1d5c3e8f1810$var$GetFirstChildContains;


var $8e29fa208b585643$var$SetChildrenInteractive = function() {
    this.on("pointerdown", $8e29fa208b585643$var$OnPointerDown, this).on("pointerdown", $8e29fa208b585643$var$OnPointerUp, this).on("pointermove", $8e29fa208b585643$var$OnPointOverOut, this).on("pointerover", $8e29fa208b585643$var$OnPointOverOut, this).on("pointerout", function(pointer, event) {
        $8e29fa208b585643$var$OnPointOverOut.call(this, pointer, null, null, event);
    }, this);
    return this;
};
var $8e29fa208b585643$var$OnPointerDown = function(pointer, localX, localY, event) {
    if (!this.childrenInteractiveEnable) return;
    var child = (0, $818b1d5c3e8f1810$export$2e2bcd8739ae039)(this.children, localX, localY);
    if (!child) return;
    this.emit("child.pointerdown", child, pointer, localX, localY, event);
};
var $8e29fa208b585643$var$OnPointerUp = function(pointer, localX, localY, event) {
    if (!this.childrenInteractiveEnable) return;
    var child = (0, $818b1d5c3e8f1810$export$2e2bcd8739ae039)(this.children, localX, localY);
    if (!child) return;
    this.emit("child.pointerup", child, pointer, localX, localY, event);
};
var $8e29fa208b585643$var$OnPointOverOut = function(pointer, localX, localY, event) {
    if (!this.childrenInteractiveEnable) return;
    if (localX === null) {
        if (this.lastOverChild !== null) {
            this.emit("child.pointerout", this.lastOverChild, pointer, localX, localY, event);
            this.lastOverChild = null;
        }
        return;
    }
    var child = (0, $818b1d5c3e8f1810$export$2e2bcd8739ae039)(this.children, localX, localY);
    if (child === this.lastOverChild) return;
    if (this.lastOverChild !== null) this.emit("child.pointerout", this.lastOverChild, pointer, localX, localY, event);
    if (child !== null) this.emit("child.pointerover", child, pointer, localX, localY, event);
    this.lastOverChild = child;
};
var $8e29fa208b585643$export$2e2bcd8739ae039 = $8e29fa208b585643$var$SetChildrenInteractive;


const $3dfe5a42498c325a$var$GameObject = Phaser.GameObjects.GameObject;
var $3dfe5a42498c325a$var$SetInteractive = function(hitArea, hitAreaCallback, dropZone) {
    var isInteractived = !!this.input;
    $3dfe5a42498c325a$var$GameObject.prototype.setInteractive.call(this, hitArea, hitAreaCallback, dropZone);
    if (!isInteractived) (0, $8e29fa208b585643$export$2e2bcd8739ae039).call(this);
    return this;
};
var $3dfe5a42498c325a$export$2e2bcd8739ae039 = $3dfe5a42498c325a$var$SetInteractive;


const $d9ae0e8eb0b9ac68$var$BringToTop = Phaser.Utils.Array.BringToTop;
const $d9ae0e8eb0b9ac68$var$SendToBack = Phaser.Utils.Array.SendToBack;
const $d9ae0e8eb0b9ac68$var$MoveUp = Phaser.Utils.Array.MoveUp;
const $d9ae0e8eb0b9ac68$var$MoveDown = Phaser.Utils.Array.MoveDown;
const $d9ae0e8eb0b9ac68$var$MoveAbove = Phaser.Utils.Array.MoveAbove;
const $d9ae0e8eb0b9ac68$var$MoveBelow = Phaser.Utils.Array.MoveBelow;
var $d9ae0e8eb0b9ac68$export$2e2bcd8739ae039 = {
    moveChildToFist (child) {
        $d9ae0e8eb0b9ac68$var$SendToBack(this.children, child);
        return this;
    },
    moveChildToLast (child) {
        $d9ae0e8eb0b9ac68$var$BringToTop(this.children, child);
        return this;
    },
    movechildUp (child) {
        $d9ae0e8eb0b9ac68$var$MoveUp(this.children, child);
        return this;
    },
    movechildDown (child) {
        $d9ae0e8eb0b9ac68$var$MoveDown(this.children, child);
        return this;
    },
    movechildAbove (child, baseChild) {
        $d9ae0e8eb0b9ac68$var$MoveAbove(this.children, child, baseChild);
        return this;
    },
    movechildBelow (child, baseChild) {
        $d9ae0e8eb0b9ac68$var$MoveBelow(this.children, child, baseChild);
        return this;
    }
};


var $14abfa13f586fc4c$export$2e2bcd8739ae039 = {
    setBackgroundColor (color, color2, isHorizontalGradient) {
        this.background.setColor(color, color2, isHorizontalGradient);
        return this;
    },
    setBackgroundStroke (color, lineWidth) {
        this.background.setStroke(color, lineWidth);
        return this;
    },
    setBackgroundCornerRadius (radius, iteration) {
        this.background.setCornerRadius(radius, iteration);
        return this;
    }
};


var $5e48fa9a8f2ce190$export$2e2bcd8739ae039 = {
    setInnerBoundsColor (color, color2, isHorizontalGradient) {
        this.innerBounds.setColor(color, color2, isHorizontalGradient);
        return this;
    },
    setInnerBoundsStroke (color, lineWidth) {
        this.innerBounds.setStroke(color, lineWidth);
        return this;
    }
};


var $f955be105b6806a5$var$Methods = {
    setFixedSize: (0, $0ed54e0694c21abe$export$2e2bcd8739ae039),
    setPadding: (0, $1b01777947c6985f$export$2e2bcd8739ae039),
    getPadding: (0, $7a68142e70f9013d$export$2e2bcd8739ae039),
    modifyTextStyle: (0, $dd7524e0304e757b$export$2e2bcd8739ae039),
    modifyDefaultTextStyle: (0, $24308041a1287356$export$2e2bcd8739ae039),
    resetTextStyle: (0, $1c77eaff31f6bc5d$export$2e2bcd8739ae039),
    setTestString: (0, $8b28dc7739c98703$export$2e2bcd8739ae039),
    removeChild: (0, $5e2df4efedd104b6$export$2e2bcd8739ae039),
    removeChildren: (0, $9a1d2f799d6fd5be$export$2e2bcd8739ae039),
    popChild: (0, $db7fdee9407bb41e$export$2e2bcd8739ae039),
    clearContent: (0, $d2b1814f8721fee0$export$2e2bcd8739ae039),
    addChild: (0, $bcb8cf611e291abc$export$2e2bcd8739ae039),
    createCharChild: (0, $8d96e356f69b696b$export$2e2bcd8739ae039),
    createCharChildren: (0, $d186ecb35a2f0c2d$export$2e2bcd8739ae039),
    setText: (0, $322b581f13a3b7e0$export$2e2bcd8739ae039),
    appendText: (0, $a1b2cd985c54bbaf$export$2e2bcd8739ae039),
    insertText: (0, $624fcbdc0195e261$export$2e2bcd8739ae039),
    removeText: (0, $17cda18b8eb88ad4$export$2e2bcd8739ae039),
    getText: (0, $836532c63c99fa08$export$2e2bcd8739ae039),
    createImageChild: (0, $7d1e31868af30e18$export$2e2bcd8739ae039),
    appendImage: (0, $6d623769bfdd4525$export$2e2bcd8739ae039),
    createDrawerChild: (0, $f66c47955d5c3ca6$export$2e2bcd8739ae039),
    appendDrawer: (0, $35484843ff1563f3$export$2e2bcd8739ae039),
    createSpaceChild: (0, $059bc853f935cf27$export$2e2bcd8739ae039),
    appendSpace: (0, $5a2f0ac7beb464ab$export$2e2bcd8739ae039),
    createCommandChild: (0, $e485e3d4af1e3b0c$export$2e2bcd8739ae039),
    appendCommand: (0, $399ddda816911e07$export$2e2bcd8739ae039),
    setWrapConfig: (0, $09f7ae1c80539995$export$2e2bcd8739ae039),
    runWordWrap: (0, $a5e1203b55897eab$export$2e2bcd8739ae039),
    runVerticalWrap: (0, $57a244a05ed46d20$export$2e2bcd8739ae039),
    runWrap: (0, $0d300fb8698b1885$export$2e2bcd8739ae039),
    renderContent: (0, $c43489207c1d8b44$export$2e2bcd8739ae039),
    forEachChild: (0, $7ac1e37261a2afea$export$2e2bcd8739ae039),
    forEachRenderableChild: (0, $f3ce07931d5baa4a$export$2e2bcd8739ae039),
    forEachCharChild: (0, $6a0a29c544bb8ddc$export$2e2bcd8739ae039),
    getChildren: (0, $3d99ae5a16ae9133$export$2e2bcd8739ae039),
    getActiveChildren: (0, $6f2b148417c3c955$export$2e2bcd8739ae039),
    getCharChildren: (0, $7500eb7b4406d29d$export$2e2bcd8739ae039),
    getLastAppendedChildren: (0, $021904e08929300a$export$2e2bcd8739ae039),
    getNearestChild: (0, $9c9fdee9e6caf865$export$2e2bcd8739ae039),
    getCharWorldPosition: (0, $68aa1edb3cd391c3$export$2e2bcd8739ae039),
    setToMinSize: (0, $aded42d10619bfcd$export$2e2bcd8739ae039),
    getCharChildIndex: (0, $72a5e26664fcd095$export$2e2bcd8739ae039),
    getCharChild: (0, $5c95adc9c2ce0ade$export$2e2bcd8739ae039),
    getCharIndex: (0, $59cd5bd3424fdd1f$export$2e2bcd8739ae039),
    setChildrenInteractiveEnable: (0, $5cd3ee1e5de19607$export$2e2bcd8739ae039),
    setInteractive: (0, $3dfe5a42498c325a$export$2e2bcd8739ae039)
};
Object.assign($f955be105b6806a5$var$Methods, (0, $d9ae0e8eb0b9ac68$export$2e2bcd8739ae039), (0, $14abfa13f586fc4c$export$2e2bcd8739ae039), (0, $5e48fa9a8f2ce190$export$2e2bcd8739ae039), (0, $1db3498fe114bccc$export$2e2bcd8739ae039));
var $f955be105b6806a5$export$2e2bcd8739ae039 = $f955be105b6806a5$var$Methods;



const $5583d54917eb9ef0$var$GetFastValue = Phaser.Utils.Objects.GetFastValue;
var $5583d54917eb9ef0$var$Pools = {};
class $5583d54917eb9ef0$var$PoolManager {
    constructor(config){
        this.pools = $5583d54917eb9ef0$var$GetFastValue(config, "pools", $5583d54917eb9ef0$var$Pools);
    }
    free(bob) {
        if (!this.pools) return this;
        var bobType = bob.type;
        if (!this.pools.hasOwnProperty(bobType)) this.pools[bobType] = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
        this.pools[bobType].push(bob);
        bob.onFree();
        return this;
    }
    freeMultiple(arr) {
        if (!this.pools) return this;
        for(var i = 0, cnt = arr.length; i < cnt; i++)this.free(arr[i]);
        return this;
    }
    allocate(bobType) {
        if (!this.pools || !this.pools.hasOwnProperty(bobType)) return null;
        return this.pools[bobType].pop();
    }
}
var $5583d54917eb9ef0$export$2e2bcd8739ae039 = $5583d54917eb9ef0$var$PoolManager;


const $c7da6d512822e889$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $c7da6d512822e889$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c7da6d512822e889$var$DynamicText extends (0, $3842bed83c6c142c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, fixedWidth, fixedHeight, config){
        if ($c7da6d512822e889$var$IsPlainObject(x)) {
            config = x;
            x = $c7da6d512822e889$var$GetValue(config, "x", 0);
            y = $c7da6d512822e889$var$GetValue(config, "y", 0);
            fixedWidth = $c7da6d512822e889$var$GetValue(config, "width", 0);
            fixedHeight = $c7da6d512822e889$var$GetValue(config, "height", 0);
        } else if ($c7da6d512822e889$var$IsPlainObject(fixedWidth)) {
            config = fixedWidth;
            fixedWidth = $c7da6d512822e889$var$GetValue(config, "width", 0);
            fixedHeight = $c7da6d512822e889$var$GetValue(config, "height", 0);
        }
        var width = fixedWidth === 0 ? 1 : fixedWidth;
        var height = fixedHeight === 0 ? 1 : fixedHeight;
        super(scene, x, y, width, height);
        this.type = "rexDynamicText";
        this.autoRound = true;
        this.padding = (0, $efa8a86e39512506$export$dd20faac850f550d)();
        this.wrapPadding = (0, $efa8a86e39512506$export$dd20faac850f550d)();
        var textStyleConfig = $c7da6d512822e889$var$GetValue(config, "style", undefined);
        this.defaultTextStyle = new (0, $8b2883a087adad94$export$2e2bcd8739ae039)(null, textStyleConfig);
        this.textStyle = this.defaultTextStyle.clone();
        this.setTestString($c7da6d512822e889$var$GetValue(config, "testString", "|M\xc9qgy"));
        this.background = new (0, $2131f61bdc74b865$export$2e2bcd8739ae039)(this, $c7da6d512822e889$var$GetValue(config, "background", undefined));
        this.innerBounds = new (0, $1e7c8fd32a50e88d$export$2e2bcd8739ae039)(this, $c7da6d512822e889$var$GetValue(config, "innerBounds", undefined));
        this.children = [];
        this.lastAppendedChildren = [];
        this.lastOverChild = null;
        this.poolManager = new (0, $5583d54917eb9ef0$export$2e2bcd8739ae039)(config);
        this.setFixedSize(fixedWidth, fixedHeight);
        this.setPadding($c7da6d512822e889$var$GetValue(config, "padding", 0));
        this.setWrapConfig($c7da6d512822e889$var$GetValue(config, "wrap", undefined));
        this.setChildrenInteractiveEnable($c7da6d512822e889$var$GetValue(config, "childrenInteractive", false));
        var text = $c7da6d512822e889$var$GetValue(config, "text", undefined);
        if (text) this.setText(text);
    }
    updateTexture() {
        this.renderContent();
        super.updateTexture();
        return this;
    }
    get text() {
        return this.getText(true);
    }
    set text(value) {
        this.setText(value);
    }
    setSize(width, height) {
        this.setFixedSize(width, height);
        return this;
    }
}
Object.assign($c7da6d512822e889$var$DynamicText.prototype, (0, $f955be105b6806a5$export$2e2bcd8739ae039));
var $c7da6d512822e889$export$2e2bcd8739ae039 = $c7da6d512822e889$var$DynamicText;


function $6b7635f721dd2cfc$export$2e2bcd8739ae039(x, y, width, height, config) {
    var gameObject = new (0, $c7da6d512822e889$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $fa1b4883010c871a$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $fa1b4883010c871a$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $fa1b4883010c871a$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var width = $fa1b4883010c871a$var$GetAdvancedValue(config, "width", undefined);
    var height = $fa1b4883010c871a$var$GetAdvancedValue(config, "height", undefined);
    var gameObject = new (0, $c7da6d512822e889$export$2e2bcd8739ae039)(this.scene, 0, 0, width, height, config);
    $fa1b4883010c871a$var$BuildGameObject(this.scene, gameObject, config);
    return gameObject;
}




class $704e80d2a9f1c27f$var$DynamicTextPlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexDynamicText", (0, $6b7635f721dd2cfc$export$2e2bcd8739ae039), (0, $fa1b4883010c871a$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.DynamicText", (0, $c7da6d512822e889$export$2e2bcd8739ae039));
var $704e80d2a9f1c27f$export$2e2bcd8739ae039 = $704e80d2a9f1c27f$var$DynamicTextPlugin;


class $79dcaf015ecfe983$var$ObjectFactory {
    constructor(scene){
        this.scene = scene;
        this.displayList = scene.sys.displayList;
        this.updateList = scene.sys.updateList;
        scene.events.once("destroy", this.destroy, this);
    }
    destroy() {
        this.scene = null;
        this.displayList = null;
        this.updateList = null;
    }
    static register(type, callback) {
        $79dcaf015ecfe983$var$ObjectFactory.prototype[type] = callback;
    }
}
var $79dcaf015ecfe983$export$2e2bcd8739ae039 = $79dcaf015ecfe983$var$ObjectFactory;


var $b2f0fc0103fca0a3$var$SetGetFrameNameCallback = function(callback) {
    if (callback === undefined) callback = $b2f0fc0103fca0a3$var$DefaultGetFrameNameCallback;
    this.getFrameNameCallback = callback;
    return this;
};
var $b2f0fc0103fca0a3$var$DefaultGetFrameNameCallback = function(colIndex, rowIndex, baseFrameName) {
    if (baseFrameName === "__BASE") return `${colIndex},${rowIndex}`;
    else return `${baseFrameName}_${colIndex},${rowIndex}`;
};
var $b2f0fc0103fca0a3$export$2e2bcd8739ae039 = $b2f0fc0103fca0a3$var$SetGetFrameNameCallback;



var $4d544c2507da8ac1$var$SetBaseTexture = function(key, baseFrameName, columns, rows) {
    if (Array.isArray(baseFrameName)) {
        rows = columns;
        columns = baseFrameName;
        baseFrameName = undefined;
    }
    if (baseFrameName === undefined) baseFrameName = "__BASE";
    columns = (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(columns);
    rows = (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(rows);
    this.textureKey = key;
    this.baseFrameName = baseFrameName;
    this.columns.data = columns;
    this.columns.count = columns ? columns.length : 0;
    this.columns.stretch = 0;
    this.columns.minWidth = 0;
    this.columns.scale = 1;
    this.rows.data = rows;
    this.rows.count = rows ? rows.length : 0;
    this.rows.stretch = 0;
    this.rows.minHeight = 0;
    this.rows.scale = 1;
    var texture = this.scene.sys.textures.get(key);
    if (!texture) {
        this.clear();
        return this;
    }
    if (!columns || !rows) {
        this.clear();
        return this;
    }
    // Get remainder width/height for unknown width/height
    var baseFrame = texture.get(baseFrameName);
    var remainderTextureWidth = baseFrame.width;
    var unknownColumnWidthCount = 0;
    for(var i = 0, cnt = columns.length; i < cnt; i++){
        if (columns[i] === undefined) unknownColumnWidthCount++;
        else if (typeof columns[i] === "number") remainderTextureWidth -= columns[i];
        else remainderTextureWidth -= columns[i].width;
    }
    var unknownColumnWidth = remainderTextureWidth / unknownColumnWidthCount;
    var remainderTextureHeight = baseFrame.height;
    var unknownRowHeightCount = 0;
    for(var i = 0, cnt = rows.length; i < cnt; i++){
        if (rows[i] === undefined) unknownRowHeightCount++;
        else if (typeof rows[i] === "number") remainderTextureHeight -= rows[i];
        else remainderTextureHeight -= rows[i].width;
    }
    var unknownRowHeight = remainderTextureHeight / unknownRowHeightCount;
    var row, col, rowHeight, colWidth, frameName;
    var offsetX = 0, offsetY = 0;
    for(var j = 0, jcnt = rows.length; j < jcnt; j++){
        // Unknown height
        if (rows[j] === undefined) rows[j] = unknownRowHeight;
        if (typeof rows[j] === "number") rows[j] = {
            height: rows[j],
            stretch: j % 2
        };
        row = rows[j];
        rowHeight = row.height;
        this.rows.stretch += row.stretch | 0;
        this.rows.minHeight += row.stretch > 0 ? 0 : rowHeight;
        offsetX = 0;
        for(var i = 0, icnt = columns.length; i < icnt; i++){
            // Unknown width
            if (columns[i] === undefined) columns[i] = unknownColumnWidth;
            if (typeof columns[i] === "number") columns[i] = {
                width: columns[i],
                stretch: i % 2
            };
            col = columns[i];
            colWidth = col.width;
            if (j === 0) {
                this.columns.stretch += col.stretch | 0;
                this.columns.minWidth += col.stretch > 0 ? 0 : colWidth;
            }
            if (colWidth >= 1 && rowHeight >= 1) {
                frameName = this.getFrameNameCallback(i, j, baseFrameName);
                var frameNameType = typeof frameName;
                if (frameNameType === "string" || frameNameType === "number") texture.add(frameName, 0, offsetX + baseFrame.cutX, offsetY + baseFrame.cutY, colWidth, rowHeight);
            }
            offsetX += colWidth;
        }
        offsetY += rowHeight;
    }
    this.updateTexture();
    return this;
};
var $4d544c2507da8ac1$export$2e2bcd8739ae039 = $4d544c2507da8ac1$var$SetBaseTexture;


var $6e2e05d51e0c64d4$var$UpdateTexture = function() {
    this.clear();
    if (this.textureKey === undefined) return this;
    var texture = this.scene.sys.textures.get(this.textureKey);
    if (!texture) return this;
    var minWidth = this.columns.minWidth * this.maxFixedPartScaleX; // Fixed-part width
    var minHeight = this.rows.minHeight * this.maxFixedPartScaleY; // Fixed-part height
    var stretchWidth = this.width - minWidth;
    var stretchHeight = this.height - minHeight;
    var fixedPartScaleX = stretchWidth >= 0 ? this.maxFixedPartScaleX : this.width / minWidth;
    var fixedPartScaleY = stretchHeight >= 0 ? this.maxFixedPartScaleY : this.height / minHeight;
    if (this.preserveRatio) {
        var minScale = Math.min(fixedPartScaleX, fixedPartScaleY);
        if (fixedPartScaleX > minScale) {
            var compensationWidth = (fixedPartScaleX - minScale) * minWidth;
            if (stretchWidth >= 0) stretchWidth += compensationWidth;
            else stretchWidth = compensationWidth;
            fixedPartScaleX = minScale;
        }
        if (fixedPartScaleY > minScale) {
            var compensationHeight = (fixedPartScaleY - minScale) * minHeight;
            if (stretchHeight >= 0) stretchHeight += compensationHeight;
            else stretchHeight = compensationHeight;
            fixedPartScaleY = minScale;
        }
    }
    this.columns.scale = fixedPartScaleX;
    this.rows.scale = fixedPartScaleY;
    var proportionWidth;
    if (stretchWidth > 0) proportionWidth = this.columns.stretch > 0 ? stretchWidth / this.columns.stretch : 0;
    else proportionWidth = 0;
    var proportionHeight;
    if (stretchHeight > 0) proportionHeight = this.rows.stretch > 0 ? stretchHeight / this.rows.stretch : 0;
    else proportionHeight = 0;
    var frameName, col, row, colWidth, rowHeight;
    var offsetX = 0, offsetY = 0;
    var imageType;
    for(var j = 0, jcnt = this.rows.count; j < jcnt; j++){
        row = this.rows.data[j];
        rowHeight = row.stretch === 0 ? row.height * fixedPartScaleY : proportionHeight * row.stretch;
        offsetX = 0;
        for(var i = 0, icnt = this.columns.count; i < icnt; i++){
            col = this.columns.data[i];
            colWidth = col.stretch === 0 ? col.width * fixedPartScaleX : proportionWidth * col.stretch;
            frameName = this.getFrameNameCallback(i, j, this.baseFrameName);
            if (texture.has(frameName) && colWidth > 0 && rowHeight > 0) {
                if (row.stretch === 0 && col.stretch === 0) imageType = 0; // Draw image
                else if (this.getStretchMode(i, j) === 0) imageType = 0; // Draw scaled image
                else imageType = 1; // Draw tile-sprite
                if (imageType === 0) this._drawImage(this.textureKey, frameName, offsetX, offsetY, colWidth, rowHeight);
                else this._drawTileSprite(this.textureKey, frameName, offsetX, offsetY, colWidth, rowHeight);
            }
            offsetX += colWidth;
        }
        offsetY += rowHeight;
    }
};
var $6e2e05d51e0c64d4$export$2e2bcd8739ae039 = $6e2e05d51e0c64d4$var$UpdateTexture;


const $173d7796917183b4$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $173d7796917183b4$var$GetValue = Phaser.Utils.Objects.GetValue;
var $173d7796917183b4$var$SetStretchMode = function(mode) {
    if ($173d7796917183b4$var$IsPlainObject(mode)) {
        this.stretchMode.edge = $173d7796917183b4$var$parseMode($173d7796917183b4$var$GetValue(mode, "edge", 0));
        this.stretchMode.internal = $173d7796917183b4$var$parseMode($173d7796917183b4$var$GetValue(mode, "internal", 0));
    } else {
        mode = $173d7796917183b4$var$parseMode(mode);
        this.stretchMode.edge = mode;
        this.stretchMode.internal = mode;
    }
    return this;
};
var $173d7796917183b4$var$parseMode = function(mode) {
    if (typeof mode === "string") mode = $173d7796917183b4$var$EXTENDMODE[mode];
    return mode;
};
const $173d7796917183b4$var$EXTENDMODE = {
    scale: 0,
    repeat: 1
};
var $173d7796917183b4$export$2e2bcd8739ae039 = $173d7796917183b4$var$SetStretchMode;


var $d17f7ddd8e3053fd$var$IsEdge = function(colIndex, rowIndex) {
    return colIndex === 0 || colIndex === this.columns.count - 1 || rowIndex === 0 || rowIndex === this.rows.count - 1;
};
var $d17f7ddd8e3053fd$export$2e2bcd8739ae039 = $d17f7ddd8e3053fd$var$IsEdge;


var $40f49e3184b6342c$var$GetStretchMode = function(colIndex, rowIndex) {
    return (0, $d17f7ddd8e3053fd$export$2e2bcd8739ae039).call(this, colIndex, rowIndex) ? this.stretchMode.edge : this.stretchMode.internal;
};
var $40f49e3184b6342c$export$2e2bcd8739ae039 = $40f49e3184b6342c$var$GetStretchMode;


var $f2d0570b7d46b0f4$var$SetPreserveRatio = function(enable) {
    if (enable == undefined) enable = true;
    this.preserveRatio = enable;
    return this;
};
var $f2d0570b7d46b0f4$export$2e2bcd8739ae039 = $f2d0570b7d46b0f4$var$SetPreserveRatio;


var $0cfc4fe464d965c8$var$SetMaxFixedPartScale = function(scaleX, scaleY) {
    if (scaleY === undefined) scaleY = scaleX;
    this.maxFixedPartScaleX = scaleX;
    this.maxFixedPartScaleY = scaleY;
    return this;
};
var $0cfc4fe464d965c8$export$2e2bcd8739ae039 = $0cfc4fe464d965c8$var$SetMaxFixedPartScale;



var $958f88d0ca8e3ba4$export$2e2bcd8739ae039 = {
    _drawImage: (0, $990223f7da3447ad$export$2e2bcd8739ae039),
    _drawTileSprite: (0, $990223f7da3447ad$export$2e2bcd8739ae039),
    setGetFrameNameCallback: (0, $b2f0fc0103fca0a3$export$2e2bcd8739ae039),
    setBaseTexture: (0, $4d544c2507da8ac1$export$2e2bcd8739ae039),
    updateTexture: (0, $6e2e05d51e0c64d4$export$2e2bcd8739ae039),
    setStretchMode: (0, $173d7796917183b4$export$2e2bcd8739ae039),
    getStretchMode: (0, $40f49e3184b6342c$export$2e2bcd8739ae039),
    setPreserveRatio: (0, $f2d0570b7d46b0f4$export$2e2bcd8739ae039),
    setMaxFixedPartScale: (0, $0cfc4fe464d965c8$export$2e2bcd8739ae039)
};


const $6f5244192c655290$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $6f5244192c655290$var$GetValue = Phaser.Utils.Objects.GetValue;
var $6f5244192c655290$var$NinePatchBase = function(GOClass, type) {
    class NinePatch extends GOClass {
        constructor(scene, x, y, width, height, key, baseFrame, columns, rows, config){
            if ($6f5244192c655290$var$IsPlainObject(x)) {
                config = x;
                x = $6f5244192c655290$var$GetValue(config, "x", 0);
                y = $6f5244192c655290$var$GetValue(config, "y", 0);
                width = $6f5244192c655290$var$GetValue(config, "width", 1);
                height = $6f5244192c655290$var$GetValue(config, "height", 1);
                key = $6f5244192c655290$var$GetValue(config, "key", undefined);
                baseFrame = $6f5244192c655290$var$GetValue(config, "baseFrame", undefined);
                columns = $6f5244192c655290$var$GetValue(config, "columns", undefined);
                rows = $6f5244192c655290$var$GetValue(config, "rows", undefined);
            } else if ($6f5244192c655290$var$IsPlainObject(width)) {
                config = width;
                width = $6f5244192c655290$var$GetValue(config, "width", 1);
                height = $6f5244192c655290$var$GetValue(config, "height", 1);
                key = $6f5244192c655290$var$GetValue(config, "key", undefined);
                baseFrame = $6f5244192c655290$var$GetValue(config, "baseFrame", undefined);
                columns = $6f5244192c655290$var$GetValue(config, "columns", undefined);
                rows = $6f5244192c655290$var$GetValue(config, "rows", undefined);
            } else if ($6f5244192c655290$var$IsPlainObject(key)) {
                config = key;
                key = $6f5244192c655290$var$GetValue(config, "key", undefined);
                baseFrame = $6f5244192c655290$var$GetValue(config, "baseFrame", undefined);
                columns = $6f5244192c655290$var$GetValue(config, "columns", undefined);
                rows = $6f5244192c655290$var$GetValue(config, "rows", undefined);
            } else if ($6f5244192c655290$var$IsPlainObject(baseFrame)) {
                config = baseFrame;
                baseFrame = $6f5244192c655290$var$GetValue(config, "baseFrame", undefined);
                columns = $6f5244192c655290$var$GetValue(config, "columns", undefined);
                rows = $6f5244192c655290$var$GetValue(config, "rows", undefined);
            } else if (Array.isArray(baseFrame)) {
                config = rows;
                rows = columns;
                columns = baseFrame;
                baseFrame = $6f5244192c655290$var$GetValue(config, "baseFrame", undefined);
            } else if ($6f5244192c655290$var$IsPlainObject(columns)) {
                config = columns;
                columns = $6f5244192c655290$var$GetValue(config, "columns", undefined);
                rows = $6f5244192c655290$var$GetValue(config, "rows", undefined);
            }
            super(scene);
            this.type = type;
            this.setPosition(x, y).setSize(width, height).setOrigin(0.5, 0.5);
            this.columns = {};
            this.rows = {};
            this.stretchMode = {};
            this._tileSprite = undefined; // Reserved for drawing image
            this._image = undefined; // Reserved for drawing image
            this.setGetFrameNameCallback($6f5244192c655290$var$GetValue(config, "getFrameNameCallback", undefined));
            this.setStretchMode($6f5244192c655290$var$GetValue(config, "stretchMode", 0));
            this.setPreserveRatio($6f5244192c655290$var$GetValue(config, "preserveRatio", true));
            var maxFixedPartScale = $6f5244192c655290$var$GetValue(config, "maxFixedPartScale", 1);
            var maxFixedPartScaleX = $6f5244192c655290$var$GetValue(config, "maxFixedPartScaleX", maxFixedPartScale);
            var maxFixedPartScaleY = $6f5244192c655290$var$GetValue(config, "maxFixedPartScaleY", undefined);
            this.setMaxFixedPartScale(maxFixedPartScaleX, maxFixedPartScaleY);
            this.setBaseTexture(key, baseFrame, columns, rows);
        }
        get minWidth() {
            return this.columns.minWidth;
        }
        get minHeight() {
            return this.rows.minHeight;
        }
        get fixedPartScaleX() {
            return this.columns.scale;
        }
        get fixedPartScaleY() {
            return this.rows.scale;
        }
        resize(width, height) {
            if (this.width === width && this.height === height) return this;
            super.resize(width, height);
            this.updateTexture();
            return this;
        }
    }
    Object.assign(NinePatch.prototype, (0, $958f88d0ca8e3ba4$export$2e2bcd8739ae039));
    return NinePatch;
};
var $6f5244192c655290$export$2e2bcd8739ae039 = $6f5244192c655290$var$NinePatchBase;


var $da0724577e120259$var$MakeChildImageGameObject = function(parent, key, className) {
    if (className === undefined) className = "image";
    if (!parent[key]) {
        parent[key] = parent.scene.make[className]({
            add: false,
            origin: {
                x: 0,
                y: 0
            }
        });
        parent.once("destroy", function() {
            if (parent[key]) {
                parent[key].destroy();
                parent[key] = undefined;
            }
        });
    }
    return parent[key];
};
var $da0724577e120259$export$2e2bcd8739ae039 = $da0724577e120259$var$MakeChildImageGameObject;


var $6d46694bddfa506d$var$DrawImage = function(key, frame, x, y, width, height) {
    var gameObject = (0, $da0724577e120259$export$2e2bcd8739ae039)(this, "_image", "image").setTexture(key, frame).setDisplaySize(width, height);
    this.draw(gameObject, x, y);
};
var $6d46694bddfa506d$export$2e2bcd8739ae039 = $6d46694bddfa506d$var$DrawImage;



var $fdbf986a10ac5b4d$var$DrawTileSprite = function(key, frame, x, y, width, height) {
    var gameObject = (0, $da0724577e120259$export$2e2bcd8739ae039)(this, "_tileSprite", "tileSprite").setTexture(key, frame).setSize(width, height);
    this.draw(gameObject, x, y);
};
var $fdbf986a10ac5b4d$export$2e2bcd8739ae039 = $fdbf986a10ac5b4d$var$DrawTileSprite;


var $4cc42e5c3be401a4$export$2e2bcd8739ae039 = {
    _drawImage: (0, $6d46694bddfa506d$export$2e2bcd8739ae039),
    _drawTileSprite: (0, $fdbf986a10ac5b4d$export$2e2bcd8739ae039)
};


const $e38371531f54c872$var$RenderTexture = Phaser.GameObjects.RenderTexture;
class $e38371531f54c872$var$NinePatch extends (0, $6f5244192c655290$export$2e2bcd8739ae039)($e38371531f54c872$var$RenderTexture, "rexNinePatch") {
}
Object.assign($e38371531f54c872$var$NinePatch.prototype, (0, $4cc42e5c3be401a4$export$2e2bcd8739ae039));
var $e38371531f54c872$export$2e2bcd8739ae039 = $e38371531f54c872$var$NinePatch;


var $454404c08301ed49$export$2e2bcd8739ae039 = (0, $e38371531f54c872$export$2e2bcd8739ae039);


var $90d3e4359652cc6f$export$2e2bcd8739ae039 = (0, $454404c08301ed49$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("ninePatch", function(x, y, width, height, key, columns, rows, config) {
    var gameObject = new (0, $90d3e4359652cc6f$export$2e2bcd8739ae039)(this.scene, x, y, width, height, key, columns, rows, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.NinePatch", (0, $90d3e4359652cc6f$export$2e2bcd8739ae039));
var $cd447fd2d9d98f80$export$2e2bcd8739ae039 = (0, $90d3e4359652cc6f$export$2e2bcd8739ae039);


const $40430ce194dc81be$var$GetCalcMatrix = Phaser.GameObjects.GetCalcMatrix;
var $40430ce194dc81be$var$WebGLRenderer = function(renderer, src, camera, parentMatrix) {
    var bobs = src.getRenderList();
    if (bobs.length === 0) return;
    camera.addToRenderList(src);
    var pipeline = renderer.pipelines.set(src.pipeline);
    var texture = src.frame.glTexture;
    var textureUnit = pipeline.setGameObject(src);
    var roundPixels = camera.roundPixels;
    var result = $40430ce194dc81be$var$GetCalcMatrix(src, camera, parentMatrix);
    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
    var dx = src._displayOriginX;
    var dy = src._displayOriginY;
    var alpha = camera.alpha * src.alpha;
    renderer.pipelines.preBatch(src);
    for(var i = 0, cnt = bobs.length; i < cnt; i++)bobs[i].webglRender(pipeline, calcMatrix, alpha, dx, dy, texture, textureUnit, roundPixels);
    renderer.pipelines.postBatch(src);
};
var $40430ce194dc81be$export$2e2bcd8739ae039 = $40430ce194dc81be$var$WebGLRenderer;


const $67f56da5804b3caf$var$SetTransform = Phaser.Renderer.Canvas.SetTransform;
var $67f56da5804b3caf$var$CanvasRenderer = function(renderer, src, camera, parentMatrix) {
    var ctx = renderer.currentContext;
    var bobs = src.getRenderList();
    if (bobs.length === 0 || !$67f56da5804b3caf$var$SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
    camera.addToRenderList(src);
    var roundPixels = camera.roundPixels;
    var dx = -src._displayOriginX, dy = -src._displayOriginY;
    ctx.translate(dx, dy);
    for(var i = 0, cnt = bobs.length; i < cnt; i++)bobs[i].canvasRender(ctx, dx, dy, roundPixels);
    //  Restore the context saved in SetTransform
    ctx.restore();
};
var $67f56da5804b3caf$export$2e2bcd8739ae039 = $67f56da5804b3caf$var$CanvasRenderer;


var $78fc9c843013b74d$export$2e2bcd8739ae039 = {
    renderWebGL: (0, $40430ce194dc81be$export$2e2bcd8739ae039),
    renderCanvas: (0, $67f56da5804b3caf$export$2e2bcd8739ae039)
};


var $a35f9371c0ef0b34$var$SetTexture = function(key, frame) {
    this.texture = this.scene.sys.textures.get(key);
    this.frame = this.texture.get(frame);
    return this;
};
var $a35f9371c0ef0b34$export$2e2bcd8739ae039 = $a35f9371c0ef0b34$var$SetTexture;


var $1a3bb93a57ff7645$var$Resize = function(width, height) {
    if (this.width === width && this.height === height) return this;
    this.width = width;
    this.height = height;
    this.updateDisplayOrigin();
    var input = this.input;
    if (input && !input.customHitArea) {
        input.hitArea.width = width;
        input.hitArea.height = height;
    }
    return this;
};
var $1a3bb93a57ff7645$export$2e2bcd8739ae039 = $1a3bb93a57ff7645$var$Resize;


var $b917eab43db595e4$var$AddChild = function(bob) {
    this.lastAppendedChildren.length = 0;
    if (Array.isArray(bob)) {
        this.children.add(bob);
        this.lastAppendedChildren.push(...bob);
    } else {
        this.children.add(bob);
        this.lastAppendedChildren.push(bob);
    }
    return this;
};
var $b917eab43db595e4$export$2e2bcd8739ae039 = $b917eab43db595e4$var$AddChild;


const $6be7d93d74b75066$var$RemoveItem = Phaser.Utils.Array.Remove;
var $6be7d93d74b75066$var$RemoveChild = function(bob) {
    if (this.poolManager) // Free this bob (bob.onFree())
    this.poolManager.free(bob);
    // Remove this bob from blitter
    $6be7d93d74b75066$var$RemoveItem(this.children.list, bob);
    this.lastAppendedChildren.length = 0;
    this.dirty = true;
    return this;
};
var $6be7d93d74b75066$export$2e2bcd8739ae039 = $6be7d93d74b75066$var$RemoveChild;


var $a513468f68211c6f$var$RemoveChildren = function() {
    if (this.poolManager) // Free all bobs (bob.onFree())
    this.poolManager.freeMultiple(this.children.list);
    // Remove all bobs from blitter
    this.children.list.length = 0;
    this.lastAppendedChildren.length = 0;
    this.dirty = true;
    return this;
};
var $a513468f68211c6f$export$2e2bcd8739ae039 = $a513468f68211c6f$var$RemoveChildren;


var $2b2496bb2b06fd9a$var$GetLastAppendedChildren = function() {
    return this.lastAppendedChildren;
};
var $2b2496bb2b06fd9a$export$2e2bcd8739ae039 = $2b2496bb2b06fd9a$var$GetLastAppendedChildren;


var $df381894b394dea1$var$GetChildren = function() {
    return this.children.list;
};
var $df381894b394dea1$export$2e2bcd8739ae039 = $df381894b394dea1$var$GetChildren;


var $686f2719168d7541$export$2e2bcd8739ae039 = {
    setTint (tint) {
        // 0: Solid tint + texture alpha
        this.tint = tint;
        this.tintFill = false;
        return this;
    },
    setTintFill (tint) {
        // 1: Solid tint, no texture
        this.tint = tint;
        this.tintFill = true;
        return this;
    },
    clearTint () {
        this.setTint(0xffffff);
        return this;
    }
};


var $90750ba45754f987$var$methods = {
    setTexture: (0, $a35f9371c0ef0b34$export$2e2bcd8739ae039),
    resize: (0, $1a3bb93a57ff7645$export$2e2bcd8739ae039),
    setSize: (0, $1a3bb93a57ff7645$export$2e2bcd8739ae039),
    addChild: (0, $b917eab43db595e4$export$2e2bcd8739ae039),
    removeChild: (0, $6be7d93d74b75066$export$2e2bcd8739ae039),
    removeChildren: (0, $a513468f68211c6f$export$2e2bcd8739ae039),
    clear: (0, $a513468f68211c6f$export$2e2bcd8739ae039),
    getLastAppendedChildren: (0, $2b2496bb2b06fd9a$export$2e2bcd8739ae039),
    getChildren: (0, $df381894b394dea1$export$2e2bcd8739ae039)
};
Object.assign($90750ba45754f987$var$methods, (0, $686f2719168d7541$export$2e2bcd8739ae039));
var $90750ba45754f987$export$2e2bcd8739ae039 = $90750ba45754f987$var$methods;



const $88cf4e1964399312$var$GetValue = Phaser.Utils.Objects.GetValue;
var $88cf4e1964399312$var$Pools = {};
class $88cf4e1964399312$var$PoolManager {
    constructor(config){
        this.pools = $88cf4e1964399312$var$GetValue(config, "pools", $88cf4e1964399312$var$Pools);
    }
    destroy() {
        this.pools = undefined;
    }
    free(bob) {
        if (!this.pools) return this;
        var bobType = bob.type;
        if (!this.pools.hasOwnProperty(bobType)) this.pools[bobType] = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
        this.pools[bobType].push(bob);
        bob.onFree();
        return this;
    }
    freeMultiple(bobs) {
        if (!this.pools) return this;
        for(var i = 0, cnt = bobs.length; i < cnt; i++)this.free(bobs[i]);
        return this;
    }
    allocate(bobType) {
        if (!this.pools || !this.pools.hasOwnProperty(bobType)) return null;
        return this.pools[bobType].pop();
    }
}
var $88cf4e1964399312$export$2e2bcd8739ae039 = $88cf4e1964399312$var$PoolManager;


const $c8b39480da60d90e$var$GameObject = Phaser.GameObjects.GameObject;
const $c8b39480da60d90e$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $c8b39480da60d90e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $c8b39480da60d90e$var$List = Phaser.Structs.List;
const $c8b39480da60d90e$var$StableSort = Phaser.Utils.Array.StableSort;
class $c8b39480da60d90e$var$Blitter extends $c8b39480da60d90e$var$GameObject {
    constructor(scene, x, y, texture, frame, config){
        if ($c8b39480da60d90e$var$IsPlainObject(x)) {
            config = x;
            x = $c8b39480da60d90e$var$GetValue(config, "x", 0);
            y = $c8b39480da60d90e$var$GetValue(config, "y", 0);
            texture = $c8b39480da60d90e$var$GetValue(config, "texture");
            frame = $c8b39480da60d90e$var$GetValue(config, "frame");
        }
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        super(scene, "rexBlitter");
        this.children = new $c8b39480da60d90e$var$List();
        this.renderList = [];
        this.displayListDirty = false;
        this.lastAppendedChildren = [];
        var reuseBob = $c8b39480da60d90e$var$GetValue(config, "reuseBob", true);
        this.poolManager = reuseBob ? new (0, $88cf4e1964399312$export$2e2bcd8739ae039)(config) : undefined;
        this.setTexture(texture, frame).setPosition(x, y).setOrigin(0, 0).clearTint().initPipeline();
    }
    preDestroy() {
        this.removeChildren();
        this.children.destroy();
        this.renderList.length = 0;
        if (this.poolManager) this.poolManager.destroy();
    }
    getRenderList() {
        if (this.displayListDirty) {
            this.renderList.length = 0;
            var needDepthSort = false;
            var children = this.children.list;
            for(var i = 0, cnt = children.length; i < cnt; i++){
                var child = children[i];
                if ($c8b39480da60d90e$var$ChildCanRender(child)) {
                    this.renderList.push(child);
                    if (!needDepthSort) needDepthSort = child.depth !== 0;
                }
            }
            if (needDepthSort) $c8b39480da60d90e$var$StableSort(this.renderList, $c8b39480da60d90e$var$SortByDepth);
            this.displayListDirty = false;
        }
        return this.renderList;
    }
}
var $c8b39480da60d90e$var$ChildCanRender = function(child) {
    return child.active && child.visible && child.alpha > 0;
};
var $c8b39480da60d90e$var$SortByDepth = function(childA, childB) {
    return childA._depth - childB._depth;
};
const $c8b39480da60d90e$var$Components = Phaser.GameObjects.Components;
Phaser.Class.mixin($c8b39480da60d90e$var$Blitter, [
    $c8b39480da60d90e$var$Components.Alpha,
    $c8b39480da60d90e$var$Components.BlendMode,
    $c8b39480da60d90e$var$Components.ComputedSize,
    $c8b39480da60d90e$var$Components.Depth,
    $c8b39480da60d90e$var$Components.GetBounds,
    $c8b39480da60d90e$var$Components.Mask,
    $c8b39480da60d90e$var$Components.Origin,
    $c8b39480da60d90e$var$Components.Pipeline,
    $c8b39480da60d90e$var$Components.ScrollFactor,
    $c8b39480da60d90e$var$Components.Transform,
    $c8b39480da60d90e$var$Components.Visible,
    (0, $78fc9c843013b74d$export$2e2bcd8739ae039),
    (0, $90750ba45754f987$export$2e2bcd8739ae039)
]);
var $c8b39480da60d90e$export$2e2bcd8739ae039 = $c8b39480da60d90e$var$Blitter;



const $076c5b163e5d1d51$export$8ac940edd7aeacfd = "image";



class $5be6b32d7ffbdde3$var$Base {
    constructor(parent, type){
        this.type = type;
        this.data = undefined;
        this.setParent(parent).reset().setActive();
    }
    destroy() {
        if (this.parent) this.parent.removeChild(this);
    }
    setParent(parent) {
        this.parent = parent;
        return this;
    }
    // get scene() {
    //     if (this.parent) {
    //         return this.parent.scene;
    //     } else {
    //         return null;
    //     }
    // }
    setDisplayListDirty(displayListDirty) {
        if (displayListDirty && this.parent) this.parent.displayListDirty = true;
        return this;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this.setDisplayListDirty(this._active != value);
        this._active = value;
    }
    setActive(active) {
        if (active === undefined) active = true;
        this.active = active;
        return this;
    }
    modifyPorperties(o) {
        return this;
    }
    // Override
    reset() {
        this.clearData();
    }
    // Override
    onFree() {
        this.reset().setActive(false).setParent();
    }
}
Object.assign($5be6b32d7ffbdde3$var$Base.prototype, (0, $90fdebfc958065d1$export$2e2bcd8739ae039));
var $5be6b32d7ffbdde3$export$2e2bcd8739ae039 = $5be6b32d7ffbdde3$var$Base;


const $c22907c909999509$var$DegToRad = Phaser.Math.DegToRad;
const $c22907c909999509$var$RadToDeg = Phaser.Math.RadToDeg;
const $c22907c909999509$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c22907c909999509$var$RenderBase extends (0, $5be6b32d7ffbdde3$export$2e2bcd8739ae039) {
    get visible() {
        return this._visible;
    }
    set visible(value) {
        this.setDisplayListDirty(this._visible != value);
        this._visible = value;
    }
    setVisible(visible) {
        if (visible === undefined) visible = true;
        this.visible = visible;
        return this;
    }
    get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        this.setDisplayListDirty(!!this._alpha !== !!value);
        this._alpha = value;
    }
    setAlpha(alpha) {
        this.alpha = alpha;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setRotation(rotation) {
        this.rotation = rotation;
        return this;
    }
    get angle() {
        return $c22907c909999509$var$RadToDeg(this.rotation);
    }
    set angle(value) {
        this.rotation = $c22907c909999509$var$DegToRad(value);
    }
    setAngle(angle) {
        this.angle = angle;
        return this;
    }
    setScaleX(scaleX) {
        this.scaleX = scaleX;
        return this;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    setWidth(width, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.width = width;
        if (keepAspectRatio) this.scaleY = this.scaleX;
        return this;
    }
    setScaleY(scaleY) {
        this.scaleY = scaleY;
        return this;
    }
    setScale(scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        return this;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
    setHeight(height, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.height = height;
        if (keepAspectRatio) this.scaleX = this.scaleY;
        return this;
    }
    setScale(scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        return this;
    }
    get displayWidth() {
        return this._width * this.scaleX;
    }
    set displayWidth(value) {
        this.scaleX = value / this._width;
    }
    setDisplayWidth(width, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.displayWidth = width;
        if (keepAspectRatio) this.scaleY = this.scaleX;
        return this;
    }
    get displayHeight() {
        return this._height * this.scaleY;
    }
    set displayHeight(value) {
        this.scaleY = value / this._height;
    }
    setDisplayHeight(height, keepAspectRatio) {
        if (keepAspectRatio === undefined) keepAspectRatio = false;
        this.displayHeight = height;
        if (keepAspectRatio) this.scaleX = this.scaleY;
        return this;
    }
    setOriginX(originX) {
        this.originX = originX;
        this._displayOriginX = this.width * originX;
        return this;
    }
    setOriginY(originY) {
        this.originY = originY;
        this._displayOriginY = this.height * originY;
        return this;
    }
    setOrigin(originX, originY) {
        if (originY === undefined) originY = originX;
        this.setOriginX(originX).setOriginY(originY);
        return this;
    }
    get depth() {
        return this._depth;
    }
    set depth(value) {
        this.setDisplayListDirty(this._depth != value);
        this._depth = value;
    }
    setDepth(depth) {
        if (depth === undefined) depth = 0;
        this.depth = depth;
        return this;
    }
    modifyPorperties(o) {
        if (!o) return this;
        if (o.hasOwnProperty("x")) this.setX(o.x);
        if (o.hasOwnProperty("y")) this.setY(o.y);
        if (o.hasOwnProperty("rotation")) this.setRotation(o.rotation);
        else if (o.hasOwnProperty("angle")) this.setAngle(o.angle);
        if (o.hasOwnProperty("alpha")) this.setAlpha(o.alpha);
        // ScaleX, ScaleY
        var width = $c22907c909999509$var$GetValue(o, "width", undefined);
        var height = $c22907c909999509$var$GetValue(o, "height", undefined);
        var scale = $c22907c909999509$var$GetValue(o, "scale", undefined);
        var scaleX = $c22907c909999509$var$GetValue(o, "scaleX", scale);
        var scaleY = $c22907c909999509$var$GetValue(o, "scaleY", scale);
        if (width !== undefined) {
            if (height === undefined && scaleY === undefined) this.setWidth(width, true);
            else this.setWidth(width);
        } else if (scaleX !== undefined) this.setScaleX(scaleX);
        else if (o.hasOwnProperty("displayWidth")) this.setDisplayWidth(o.displayWidth);
        if (height !== undefined) {
            if (width === undefined && scaleX === undefined) this.setHeight(height, true);
            else this.setHeight(height);
        } else if (scaleY !== undefined) this.setScaleY(scaleY);
        else if (o.hasOwnProperty("displayHeight")) this.setDisplayHeight(o.displayHeight);
        var origin = $c22907c909999509$var$GetValue(o, "origin", undefined);
        if (origin !== undefined) this.setOrigin(origin);
        else {
            if (o.hasOwnProperty("originX")) this.setOriginX(o.originX);
            if (o.hasOwnProperty("originY")) this.setOriginY(o.originY);
        }
        if (o.hasOwnProperty("depth")) this.setDepth(o.depth);
        return this;
    }
    reset() {
        super.reset();
        this.setVisible().setAlpha(1).setPosition(0, 0).setRotation(0).setScale(1, 1).setOrigin(0).setDepth(0);
        return this;
    }
    // Override
    webglRender(pipeline, calcMatrix, alpha, dx, dy, texture, textureUnit, roundPixels) {}
    // Override
    canvasRender(ctx, dx, dy, roundPixels) {}
}
var $c22907c909999509$export$2e2bcd8739ae039 = $c22907c909999509$var$RenderBase;



const $1362e9423a7a514d$var$TransformMatrix = Phaser.GameObjects.Components.TransformMatrix;
const $1362e9423a7a514d$var$GetTint = Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha;
var $1362e9423a7a514d$var$FrameMatrix = new $1362e9423a7a514d$var$TransformMatrix();
var $1362e9423a7a514d$var$WebglRender = function(pipeline, calcMatrix, alpha, dx, dy, texture, textureUnit, roundPixels) {
    var width = this._width, height = this._height;
    var displayOriginX = width * this.originX, displayOriginY = height * this.originY;
    var x = this.x - dx, y = this.y - dy;
    var flipX = 1;
    var flipY = 1;
    if (this.flipX) {
        x += width - displayOriginX * 2;
        flipX = -1;
    }
    if (this.flipY) {
        y += height - displayOriginY * 2;
        flipY = -1;
    }
    $1362e9423a7a514d$var$FrameMatrix.applyITRS(x, y, this.rotation, this.scaleX * flipX, this.scaleY * flipY);
    calcMatrix.multiply($1362e9423a7a514d$var$FrameMatrix, $1362e9423a7a514d$var$FrameMatrix);
    var tx = -displayOriginX;
    var ty = -displayOriginY;
    var tw = tx + width;
    var th = ty + height;
    var tx0 = $1362e9423a7a514d$var$FrameMatrix.getXRound(tx, ty, roundPixels);
    var tx1 = $1362e9423a7a514d$var$FrameMatrix.getXRound(tx, th, roundPixels);
    var tx2 = $1362e9423a7a514d$var$FrameMatrix.getXRound(tw, th, roundPixels);
    var tx3 = $1362e9423a7a514d$var$FrameMatrix.getXRound(tw, ty, roundPixels);
    var ty0 = $1362e9423a7a514d$var$FrameMatrix.getYRound(tx, ty, roundPixels);
    var ty1 = $1362e9423a7a514d$var$FrameMatrix.getYRound(tx, th, roundPixels);
    var ty2 = $1362e9423a7a514d$var$FrameMatrix.getYRound(tw, th, roundPixels);
    var ty3 = $1362e9423a7a514d$var$FrameMatrix.getYRound(tw, ty, roundPixels);
    var u0 = this.frame.u0;
    var v0 = this.frame.v0;
    var u1 = this.frame.u1;
    var v1 = this.frame.v1;
    var tint = $1362e9423a7a514d$var$GetTint(this.tint, this.alpha * alpha);
    pipeline.batchQuad(this.parent, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tint, tint, tint, tint, this.tintFill, texture, textureUnit);
};
var $1362e9423a7a514d$export$2e2bcd8739ae039 = $1362e9423a7a514d$var$WebglRender;


var $30178097f9fdea87$var$CanvasRender = function(ctx, dx, dy, roundPixels) {
    ctx.save();
    var width = this._width, height = this._height;
    var displayOriginX = width * this.originX, displayOriginY = height * this.originY;
    var x = this.x - displayOriginX, y = this.y - displayOriginY;
    var flipX = 1;
    var flipY = 1;
    if (this.flipX) {
        x += width;
        flipX = -1;
    }
    if (this.flipY) {
        y += height;
        flipY = -1;
    }
    if (roundPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    ctx.translate(x, y);
    ctx.rotate(this.rotation);
    ctx.scale(this.scaleX * flipX, this.scaleY * flipY);
    var frame = this.frame;
    ctx.drawImage(frame.source.image, frame.cutX, frame.cutY, width, height, 0, 0, width, height);
    ctx.restore();
};
var $30178097f9fdea87$export$2e2bcd8739ae039 = $30178097f9fdea87$var$CanvasRender;


const $9958c395c613da1f$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $9958c395c613da1f$var$ImageData extends (0, $c22907c909999509$export$2e2bcd8739ae039) {
    constructor(parent, frame){
        super(parent, (0, $076c5b163e5d1d51$export$8ac940edd7aeacfd));
        this.setFrame(frame);
    }
    get width() {
        return this._width;
    }
    set width(value) {}
    get height() {
        return this._height;
    }
    set height(value) {}
    setFrame(frame) {
        if (arguments.length > 0 && !$9958c395c613da1f$var$IsPlainObject(frame)) frame = this.parent.texture.get(frame);
        this.frame = frame;
        this._width = frame ? frame.width : 0;
        this._height = frame ? frame.height : 0;
        return this;
    }
    setFlipX(flipX) {
        if (flipX === undefined) flipX = true;
        this.flipX = flipX;
        return this;
    }
    setFlipY(flipY) {
        if (flipY === undefined) flipY = true;
        this.flipY = flipY;
        return this;
    }
    resetFlip() {
        this.flipX = false;
        this.flipY = false;
        return this;
    }
    get tint() {
        if (this._tint === undefined) return this.parent.tint;
        else return this._tint;
    }
    set tint(value) {
        this._tint = value;
    }
    setTint(value) {
        this.tint = value;
        this.tintFill = false;
        return this;
    }
    setTintFill(value) {
        this.tint = value;
        this.tintFill = true;
        return this;
    }
    clearTint() {
        this.setTint(0xffffff);
        return this;
    }
    resetTint() {
        this.tint = undefined;
        this.tintFill = undefined;
        return this;
    }
    get tintFill() {
        if (this._tintFill === undefined) return this.parent.tintFill;
        else return this._tintFill;
    }
    set tintFill(value) {
        this._tintFill = value;
    }
    reset() {
        super.reset();
        this.resetFlip().resetTint().setFrame();
        return this;
    }
    modifyPorperties(o) {
        if (!o) return this;
        // Size of Image is equal to frame size,
        // Move width, height properties to displayWidth,displayHeight
        if (o.hasOwnProperty("width")) {
            o.displayWidth = o.width;
            delete o.width;
        }
        if (o.hasOwnProperty("height")) {
            o.displayHeight = o.height;
            delete o.height;
        }
        if (o.hasOwnProperty("frame")) this.setFrame(o.frame);
        super.modifyPorperties(o);
        if (o.hasOwnProperty("flipX")) this.setFlipX(o.flipX);
        if (o.hasOwnProperty("flipY")) this.setFlipY(o.flipY);
        if (o.hasOwnProperty("tint")) this.setTint(o.tint);
        if (o.hasOwnProperty("tintFill")) this.setTintFill(o.tintFill);
        return this;
    }
}
var $9958c395c613da1f$var$methods = {
    webglRender: (0, $1362e9423a7a514d$export$2e2bcd8739ae039),
    canvasRender: (0, $30178097f9fdea87$export$2e2bcd8739ae039)
};
Object.assign($9958c395c613da1f$var$ImageData.prototype, $9958c395c613da1f$var$methods);
var $9958c395c613da1f$export$2e2bcd8739ae039 = $9958c395c613da1f$var$ImageData;


var $502399ea0614a9f6$var$AddImage = function(blitter, config) {
    if (typeof config === "string") config = {
        frame: config
    };
    var bob = blitter.poolManager ? blitter.poolManager.allocate((0, $076c5b163e5d1d51$export$8ac940edd7aeacfd)) : null;
    if (bob === null) bob = new (0, $9958c395c613da1f$export$2e2bcd8739ae039)(blitter);
    else bob.setParent(blitter).setActive();
    bob.modifyPorperties(config);
    blitter.addChild(bob);
    return bob;
};
var $502399ea0614a9f6$export$2e2bcd8739ae039 = $502399ea0614a9f6$var$AddImage;


var $8e37ccf223738e21$var$DrawImage = function(key, frame, x, y, width, height) {
    (0, $502399ea0614a9f6$export$2e2bcd8739ae039)(this, {
        frame: frame,
        x: x,
        y: y,
        width: width,
        height: height
    });
};
var $8e37ccf223738e21$export$2e2bcd8739ae039 = $8e37ccf223738e21$var$DrawImage;



var $2a711517d95a50ff$var$DrawTileSprite = function(key, frame, x, y, width, height) {
    var frameObj = this.texture.get(frame);
    var frameWidth = frameObj.width, frameHeight = frameObj.height;
    var colCount = Math.floor(width / frameWidth), rowCount = Math.floor(height / frameHeight);
    // Align images at center
    x += (width - colCount * frameWidth) / 2;
    y += (height - rowCount * frameHeight) / 2;
    for(var colIndex = 0; colIndex < colCount; colIndex++)for(var rowIndex = 0; rowIndex < rowCount; rowIndex++)(0, $502399ea0614a9f6$export$2e2bcd8739ae039)(this, {
        frame: frame,
        x: x + colIndex * frameWidth,
        y: y + rowIndex * frameHeight
    });
};
var $2a711517d95a50ff$export$2e2bcd8739ae039 = $2a711517d95a50ff$var$DrawTileSprite;


var $e4b38a40eebb1852$export$2e2bcd8739ae039 = {
    _drawImage: (0, $8e37ccf223738e21$export$2e2bcd8739ae039),
    _drawTileSprite: (0, $2a711517d95a50ff$export$2e2bcd8739ae039)
};


class $0e05bff45289e6cf$var$NinePatch extends (0, $6f5244192c655290$export$2e2bcd8739ae039)((0, $c8b39480da60d90e$export$2e2bcd8739ae039), "rexNinePatch2") {
    setBaseTexture(key, baseFrameName, columns, rows) {
        this.setTexture(key, baseFrameName);
        super.setBaseTexture(key, baseFrameName, columns, rows);
        return this;
    }
}
Object.assign($0e05bff45289e6cf$var$NinePatch.prototype, (0, $e4b38a40eebb1852$export$2e2bcd8739ae039));
var $0e05bff45289e6cf$export$2e2bcd8739ae039 = $0e05bff45289e6cf$var$NinePatch;


var $47731d6e8d18b05a$export$2e2bcd8739ae039 = (0, $0e05bff45289e6cf$export$2e2bcd8739ae039);


var $ae77dc6441cab7f5$export$2e2bcd8739ae039 = (0, $47731d6e8d18b05a$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("ninePatch2", function(x, y, width, height, key, columns, rows, config) {
    var gameObject = new (0, $ae77dc6441cab7f5$export$2e2bcd8739ae039)(this.scene, x, y, width, height, key, columns, rows, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.NinePatch2", (0, $ae77dc6441cab7f5$export$2e2bcd8739ae039));
var $06f5f452899f8048$export$2e2bcd8739ae039 = (0, $ae77dc6441cab7f5$export$2e2bcd8739ae039);



var $7c42a48c5df6c287$export$2e2bcd8739ae039 = (0, $26b7b1c524f62b32$export$2e2bcd8739ae039);


var $b4dc4d4434a4bd47$export$2e2bcd8739ae039 = (0, $7c42a48c5df6c287$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("roundRectangle", function(x, y, width, height, radiusConfig, fillColor, fillAlpha) {
    var gameObject = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(this.scene, x, y, width, height, radiusConfig, fillColor, fillAlpha);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.RoundRectangle", (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039));
var $9ea85a28c2ce7f93$export$2e2bcd8739ae039 = (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039);



var $8af47e6cc9907a17$var$ExtractByPrefix = function(obj, prefix, delimiter, out) {
    if (delimiter === undefined) delimiter = ".";
    if (out === undefined) out = {};
    if (!obj) return out;
    if (prefix in obj) return Object.assign(out, obj[prefix]);
    prefix += delimiter;
    for(var key in obj){
        if (!key.startsWith(prefix)) continue;
        out[key.replace(prefix, "")] = obj[key];
    }
    return out;
};
var $8af47e6cc9907a17$export$2e2bcd8739ae039 = $8af47e6cc9907a17$var$ExtractByPrefix;


var $f0324188b9cf7ec6$var$ExtractStyle = function(config, prefix, propertiesMap) {
    var result = (0, $8af47e6cc9907a17$export$2e2bcd8739ae039)(config, prefix);
    if (propertiesMap) {
        for(var name in result)if (propertiesMap.hasOwnProperty(name)) {
            result[propertiesMap[name]] = result[name];
            delete result[name];
        }
    }
    return result;
};
var $f0324188b9cf7ec6$export$2e2bcd8739ae039 = $f0324188b9cf7ec6$var$ExtractStyle;


var $fc246cfe00d52bbe$var$GetPartialData = function(obj, keys, out) {
    if (out === undefined) out = {};
    if (Array.isArray(keys)) {
        var key;
        for(var i = 0, cnt = keys.length; i < cnt; i++){
            key = keys[i];
            out[key] = obj[key];
        }
    } else for(var key in keys)out[key] = obj[key];
    return out;
};
var $fc246cfe00d52bbe$export$2e2bcd8739ae039 = $fc246cfe00d52bbe$var$GetPartialData;


var $a2443fc83542336c$var$IsKeyValueEqual = function(objA, objB) {
    for(var key in objA){
        if (!(key in objB)) return false;
        if (objA[key] !== objB[key]) return false;
    }
    for(var key in objB){
        if (!(key in objA)) return false;
    }
    return true;
};
var $a2443fc83542336c$export$2e2bcd8739ae039 = $a2443fc83542336c$var$IsKeyValueEqual;


var $b6b96f831d087cdb$var$ApplyStyle = function(gameObject, newStyle) {
    if (!newStyle) return undefined;
    var currentStyle = (0, $fc246cfe00d52bbe$export$2e2bcd8739ae039)(gameObject, newStyle);
    if (!(0, $a2443fc83542336c$export$2e2bcd8739ae039)(currentStyle, newStyle)) {
        gameObject.modifyStyle(newStyle);
        return currentStyle;
    } else return undefined;
};
var $b6b96f831d087cdb$export$2e2bcd8739ae039 = {
    setActiveState (enable) {
        if (enable === undefined) enable = true;
        if (this.activeState === enable) return this;
        this.activeState = enable;
        if (enable) this.activeStyleSave = $b6b96f831d087cdb$var$ApplyStyle(this, this.activeStyle);
        else {
            $b6b96f831d087cdb$var$ApplyStyle(this, this.activeStyleSave);
            this.activeStyleSave = undefined;
        }
        return this;
    },
    setHoverState (enable) {
        if (enable === undefined) enable = true;
        if (this.hoverState === enable) return this;
        this.hoverState = enable;
        if (enable) this.hoverStyleSave = $b6b96f831d087cdb$var$ApplyStyle(this, this.hoverStyle);
        else {
            $b6b96f831d087cdb$var$ApplyStyle(this, this.hoverStyleSave);
            this.hoverStyleSave = undefined;
        }
        return this;
    },
    setDisableState (enable) {
        if (enable === undefined) enable = true;
        if (this.disableState === enable) return this;
        this.disableState = enable;
        if (enable) this.disableStyleSave = $b6b96f831d087cdb$var$ApplyStyle(this, this.disableStyle);
        else {
            $b6b96f831d087cdb$var$ApplyStyle(this, this.disableStyleSave);
            this.disableStyleSave = undefined;
        }
        return this;
    }
};


class $da55f0aef34a64ad$var$StatesRoundRectangle extends (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene, config);
        this.activeStyle = (0, $f0324188b9cf7ec6$export$2e2bcd8739ae039)(config, "active", $da55f0aef34a64ad$var$PropertiesMap);
        this.hoverStyle = (0, $f0324188b9cf7ec6$export$2e2bcd8739ae039)(config, "hover", $da55f0aef34a64ad$var$PropertiesMap);
        this.disableStyle = (0, $f0324188b9cf7ec6$export$2e2bcd8739ae039)(config, "disable", $da55f0aef34a64ad$var$PropertiesMap);
    }
    modifyStyle(style) {
        for(var key in style)this[key] = style[key];
        return this;
    }
}
const $da55f0aef34a64ad$var$PropertiesMap = {
    color: "fillColor",
    alpha: "fillAlpha",
    // strokeColor: 'strokeColor',
    // strokeAlpha: 'strokeAlpha',
    strokeWidth: "lineWidth"
};
Object.assign($da55f0aef34a64ad$var$StatesRoundRectangle.prototype, (0, $b6b96f831d087cdb$export$2e2bcd8739ae039));
var $da55f0aef34a64ad$export$2e2bcd8739ae039 = $da55f0aef34a64ad$var$StatesRoundRectangle;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("statesRoundRectangle", function(config) {
    var gameObject = new (0, $da55f0aef34a64ad$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.StatesRoundRectangle", (0, $da55f0aef34a64ad$export$2e2bcd8739ae039));
var $2471125f8eaaa7ce$export$2e2bcd8739ae039 = (0, $da55f0aef34a64ad$export$2e2bcd8739ae039);





var $18776b2495ea0e99$var$DrawContent = function() {
    (0, $3c945d5472df192a$export$2e2bcd8739ae039)(this, this.fillStyle, this.strokeStyle, this.lineWidth, this.radius, this.fillColor2, this.isHorizontalGradient, this.iteration);
};
var $18776b2495ea0e99$export$2e2bcd8739ae039 = $18776b2495ea0e99$var$DrawContent;


const $28001ff6ebf2adbb$var$GetValue = Phaser.Utils.Objects.GetValue;
class $28001ff6ebf2adbb$var$RoundRectangle extends (0, $3842bed83c6c142c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, radiusConfig, fillStyle, strokeStyle, lineWidth, fillColor2, isHorizontalGradient){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 1;
        if (height === undefined) height = width;
        if (radiusConfig === undefined) radiusConfig = 0;
        super(scene, x, y, width, height);
        this.type = "rexRoundRectangleCanvas";
        var radius = $28001ff6ebf2adbb$var$GetValue(radiusConfig, "radius", radiusConfig);
        var iteration = $28001ff6ebf2adbb$var$GetValue(radiusConfig, "iteration", undefined);
        this.setRadius(radius);
        this.setIteration(iteration);
        this.setFillStyle(fillStyle, fillColor2, isHorizontalGradient);
        this.setStrokeStyle(strokeStyle, lineWidth);
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this.dirty |= this._radius != value;
        this._radius = value;
    }
    setRadius(radius) {
        this.radius = radius;
        return this;
    }
    get iteration() {
        return this._iteration;
    }
    set iteration(value) {
        this.dirty |= this._iteration != value;
        this._iteration = value;
    }
    setIteration(iteration) {
        this.iteration = iteration;
        return this;
    }
    get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty |= this._fillStyle != value;
        this._fillStyle = value;
    }
    get fillColor2() {
        return this._fillColor2;
    }
    set fillColor2(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty |= this._fillColor2 != value;
        this._fillColor2 = value;
    }
    get isHorizontalGradient() {
        return this._isHorizontalGradient;
    }
    set isHorizontalGradient(value) {
        this.dirty |= this._isHorizontalGradient != value;
        this._isHorizontalGradient = value;
    }
    setFillStyle(fillStyle, fillColor2, isHorizontalGradient) {
        if (isHorizontalGradient === undefined) isHorizontalGradient = true;
        this.fillStyle = fillStyle;
        this.fillColor2 = fillColor2;
        this.isHorizontalGradient = isHorizontalGradient;
        return this;
    }
    get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty |= this._strokeStyle != value;
        this._strokeStyle = value;
    }
    get lineWidth() {
        return this._lineWidth;
    }
    set lineWidth(value) {
        this.dirty |= this._lineWidth != value;
        this._lineWidth = value;
    }
    setStrokeStyle(strokeStyle, lineWidth) {
        this.strokeStyle = strokeStyle;
        this.lineWidth = lineWidth;
        return this;
    }
    updateTexture() {
        this.clear();
        (0, $18776b2495ea0e99$export$2e2bcd8739ae039).call(this);
        super.updateTexture();
        return this;
    }
}
var $28001ff6ebf2adbb$export$2e2bcd8739ae039 = $28001ff6ebf2adbb$var$RoundRectangle;


var $7d6dea8f1628229a$export$2e2bcd8739ae039 = (0, $28001ff6ebf2adbb$export$2e2bcd8739ae039);


var $8f3bc160899bb42f$export$2e2bcd8739ae039 = (0, $7d6dea8f1628229a$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("roundRectangleCanvas", function(x, y, width, height, radius, fillStyle, strokeStyle, lineWidth, fillColor2, isHorizontalGradient) {
    var gameObject = new (0, $8f3bc160899bb42f$export$2e2bcd8739ae039)(this.scene, x, y, width, height, radius, fillStyle, strokeStyle, lineWidth, fillColor2, isHorizontalGradient);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.RoundRectangleCanvas", (0, $8f3bc160899bb42f$export$2e2bcd8739ae039));
var $a3a05077063bd450$export$2e2bcd8739ae039 = (0, $8f3bc160899bb42f$export$2e2bcd8739ae039);


/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ var $a32c5a7633f99d78$var$Utils = Phaser.Renderer.WebGL.Utils;
/**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var $a32c5a7633f99d78$var$WebGLRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.width === 0 || src.height === 0) return;
    camera.addToRenderList(src);
    var frame = src.frame;
    var width = frame.width;
    var height = frame.height;
    var getTint = $a32c5a7633f99d78$var$Utils.getTintAppendFloatAlpha;
    var pipeline = renderer.pipelines.set(src.pipeline, src);
    var textureUnit = pipeline.setTexture2D(frame.glTexture, src);
    renderer.pipelines.preBatch(src);
    pipeline.batchTexture(src, frame.glTexture, width, height, src.x, src.y, width / src.style.resolution, height / src.style.resolution, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, false, textureUnit);
    renderer.pipelines.postBatch(src);
};
var $a32c5a7633f99d78$export$2e2bcd8739ae039 = $a32c5a7633f99d78$var$WebGLRenderer;


/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var $4e0fff161b9b54f0$var$CanvasRenderer = function(renderer, src, camera, parentMatrix) {
    if (src.width === 0 || src.height === 0) return;
    camera.addToRenderList(src);
    renderer.batchSprite(src, src.frame, camera, parentMatrix);
};
var $4e0fff161b9b54f0$export$2e2bcd8739ae039 = $4e0fff161b9b54f0$var$CanvasRenderer;


var $7298ab63990ba1e9$export$2e2bcd8739ae039 = {
    renderWebGL: (0, $a32c5a7633f99d78$export$2e2bcd8739ae039),
    renderCanvas: (0, $4e0fff161b9b54f0$export$2e2bcd8739ae039)
};


const $9c5000ad23867565$var$CanvasPool = Phaser.Display.Canvas.CanvasPool;
var $9c5000ad23867565$var$MeasureTextMargins = function(textStyle, testString, out) {
    if (out === undefined) out = {};
    var canvas = $9c5000ad23867565$var$CanvasPool.create(this);
    var context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    textStyle.syncFont(canvas, context);
    var metrics = context.measureText(testString);
    var width = Math.ceil(metrics.width * textStyle.baselineX);
    var baseline = width;
    var height = 2 * baseline;
    baseline = baseline * textStyle.baselineY | 0;
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = "#f00";
    context.fillRect(0, 0, width, height);
    context.font = textStyle._font;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#000";
    context.fillText(textStyle.testString, 0, baseline);
    out.left = 0;
    if (width === 0 || height === 0 || !context.getImageData(0, 0, width, height)) {
        $9c5000ad23867565$var$CanvasPool.remove(canvas);
        return out;
    }
    var imagedata = context.getImageData(0, 0, width, height).data;
    var stop = false;
    for(var x = 0; x < width; x++){
        for(var y = 0; y < height; y++){
            var idx = (y * width + x) * 4;
            if (imagedata[idx] !== 255) {
                out.left = x;
                stop = true;
                break;
            }
        }
        if (stop) break;
    }
    $9c5000ad23867565$var$CanvasPool.remove(canvas);
    return out;
};
var $9c5000ad23867565$export$2e2bcd8739ae039 = $9c5000ad23867565$var$MeasureTextMargins;


const $ecf8c20979c10435$var$GameObject = Phaser.GameObjects.GameObject;
class $ecf8c20979c10435$var$TextBase extends $ecf8c20979c10435$var$GameObject {
    setStyle(style) {
        return this.style.setStyle(style);
    }
    setFont(font) {
        return this.style.setFont(font);
    }
    setFontFamily(family) {
        return this.style.setFontFamily(family);
    }
    setFontSize(size) {
        return this.style.setFontSize(size);
    }
    setFontStyle(style) {
        return this.style.setFontStyle(style);
    }
    setTestString(string) {
        return this.style.setTestString(string);
    }
    setFixedSize(width, height) {
        return this.style.setFixedSize(width, height);
    }
    setBackgroundColor(color, color2, isHorizontalGradient) {
        return this.style.setBackgroundColor(color, color2, isHorizontalGradient);
    }
    setBackgroundStrokeColor(color, lineWidth) {
        return this.style.setBackgroundStrokeColor(color, lineWidth);
    }
    setBackgroundCornerRadius(radius, iteration) {
        return this.style.setBackgroundCornerRadius(radius, iteration);
    }
    setFill(color) {
        return this.style.setFill(color);
    }
    setColor(color) {
        return this.style.setColor(color);
    }
    setStroke(color, thickness) {
        return this.style.setStroke(color, thickness);
    }
    setShadow(x, y, color, blur, shadowStroke, shadowFill) {
        return this.style.setShadow(x, y, color, blur, shadowStroke, shadowFill);
    }
    setShadowOffset(x, y) {
        return this.style.setShadowOffset(x, y);
    }
    setShadowColor(color) {
        return this.style.setShadowColor(color);
    }
    setShadowBlur(blur) {
        return this.style.setShadowBlur(blur);
    }
    setShadowStroke(enabled) {
        return this.style.setShadowStroke(enabled);
    }
    setShadowFill(enabled) {
        return this.style.setShadowFill(enabled);
    }
    setWrapMode(mode) {
        return this.style.setWrapMode(mode);
    }
    setWrapWidth(width) {
        return this.style.setWrapWidth(width);
    }
    // Align with built-in text game object
    setWordWrapWidth(width) {
        return this.style.setWrapWidth(width);
    }
    setAlign(align) {
        return this.style.setHAlign(align);
    }
    setHAlign(align) {
        return this.style.setHAlign(align);
    }
    setVAlign(align) {
        return this.style.setVAlign(align);
    }
    setLineSpacing(value) {
        return this.style.setLineSpacing(value);
    }
    set lineSpacing(value) {
        this.setLineSpacing(value);
    }
    get lineSpacing() {
        return this.style.lineSpacing;
    }
    setXOffset(value) {
        return this.style.setXOffset(value);
    }
    setMaxLines(max) {
        return this.style.setMaxLines(max);
    }
    setResolution(value) {
        return this.style.setResolution(value);
    }
    getTextMetrics() {
        return this.style.getTextMetrics();
    }
    setTextMetrics(metrics, font) {
        return this.style.setTextMetrics(metrics, font);
    }
    measureTextMargins(testString, out) {
        return (0, $9c5000ad23867565$export$2e2bcd8739ae039)(this.style, testString, out);
    }
}
const $ecf8c20979c10435$var$Components = Phaser.GameObjects.Components;
Phaser.Class.mixin($ecf8c20979c10435$var$TextBase, [
    $ecf8c20979c10435$var$Components.Alpha,
    $ecf8c20979c10435$var$Components.BlendMode,
    $ecf8c20979c10435$var$Components.ComputedSize,
    $ecf8c20979c10435$var$Components.Crop,
    $ecf8c20979c10435$var$Components.Depth,
    $ecf8c20979c10435$var$Components.Flip,
    // Components.FX,  // Open for 3.60
    $ecf8c20979c10435$var$Components.GetBounds,
    $ecf8c20979c10435$var$Components.Mask,
    $ecf8c20979c10435$var$Components.Origin,
    $ecf8c20979c10435$var$Components.Pipeline,
    $ecf8c20979c10435$var$Components.ScrollFactor,
    $ecf8c20979c10435$var$Components.Tint,
    $ecf8c20979c10435$var$Components.Transform,
    $ecf8c20979c10435$var$Components.Visible,
    (0, $7298ab63990ba1e9$export$2e2bcd8739ae039)
]);
var $ecf8c20979c10435$export$2e2bcd8739ae039 = $ecf8c20979c10435$var$TextBase;



//  Key: [ Object Key, Default Value, postCallback ]
var $d4a9abab1509a92c$var$PropertyMap = {
    // background
    backgroundColor: [
        "backgroundColor",
        null,
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    backgroundColor2: [
        "backgroundColor2",
        null,
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    backgroundHorizontalGradient: [
        "backgroundHorizontalGradient",
        true,
        null
    ],
    backgroundStrokeColor: [
        "backgroundStrokeColor",
        null,
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    backgroundStrokeLineWidth: [
        "backgroundStrokeLineWidth",
        2,
        null
    ],
    backgroundCornerRadius: [
        "backgroundCornerRadius",
        0,
        null
    ],
    backgroundCornerIteration: [
        "backgroundCornerIteration",
        null,
        null
    ],
    // font
    fontFamily: [
        "fontFamily",
        "Courier",
        null
    ],
    fontSize: [
        "fontSize",
        "16px",
        null
    ],
    fontStyle: [
        "fontStyle",
        "",
        null
    ],
    color: [
        "color",
        "#fff",
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    stroke: [
        "stroke",
        "#fff",
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    strokeThickness: [
        "strokeThickness",
        0,
        null
    ],
    shadowOffsetX: [
        "shadow.offsetX",
        0,
        null
    ],
    shadowOffsetY: [
        "shadow.offsetY",
        0,
        null
    ],
    shadowColor: [
        "shadow.color",
        "#000",
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    shadowBlur: [
        "shadow.blur",
        0,
        null
    ],
    shadowStroke: [
        "shadow.stroke",
        false,
        null
    ],
    shadowFill: [
        "shadow.fill",
        false,
        null
    ],
    // underline
    underlineColor: [
        "underline.color",
        "#000",
        (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)
    ],
    underlineThickness: [
        "underline.thickness",
        0,
        null
    ],
    underlineOffset: [
        "underline.offset",
        0,
        null
    ],
    // align
    halign: [
        "halign",
        "left",
        null
    ],
    valign: [
        "valign",
        "top",
        null
    ],
    // size
    maxLines: [
        "maxLines",
        0,
        null
    ],
    fixedWidth: [
        "fixedWidth",
        0,
        null
    ],
    fixedHeight: [
        "fixedHeight",
        0,
        null
    ],
    resolution: [
        "resolution",
        0,
        null
    ],
    lineSpacing: [
        "lineSpacing",
        0,
        null
    ],
    xOffset: [
        "xOffset",
        0,
        null
    ],
    rtl: [
        "rtl",
        false,
        null
    ],
    testString: [
        "testString",
        "|M\xc3\u2030qgy",
        null
    ],
    baselineX: [
        "baselineX",
        1.2,
        null
    ],
    baselineY: [
        "baselineY",
        1.4,
        null
    ],
    // wrap
    wrapMode: [
        "wrap.mode",
        0,
        null
    ],
    wrapWidth: [
        "wrap.width",
        0,
        null
    ],
    wrapCallback: [
        "wrap.callback",
        null
    ],
    wrapCallbackScope: [
        "wrap.callbackScope",
        null
    ]
};
var $d4a9abab1509a92c$export$2e2bcd8739ae039 = $d4a9abab1509a92c$var$PropertyMap;


/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ const $c66096378ed21e2a$var$CanvasPool = Phaser.Display.Canvas.CanvasPool;
/**
 * Calculates the ascent, descent and fontSize of a given font style.
 *
 * @function Phaser.GameObjects.MeasureText
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text.TextStyle} textStyle - The TextStyle object to measure.
 *
 * @return {object} An object containing the ascent, descent and fontSize of the TextStyle.
 */ var $c66096378ed21e2a$var$MeasureText = function(textStyle) {
    // @property {HTMLCanvasElement} canvas - The canvas element that the text is rendered.
    var canvas = $c66096378ed21e2a$var$CanvasPool.create(this);
    // @property {HTMLCanvasElement} context - The context of the canvas element that the text is rendered to.
    var context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    textStyle.syncFont(canvas, context);
    var metrics = context.measureText(textStyle.testString);
    if ("actualBoundingBoxAscent" in metrics) {
        var ascent = metrics.actualBoundingBoxAscent;
        var descent = metrics.actualBoundingBoxDescent;
        var output = {
            ascent: ascent,
            descent: descent,
            fontSize: ascent + descent
        };
        $c66096378ed21e2a$var$CanvasPool.remove(canvas);
        return output;
    }
    var width = Math.ceil(metrics.width * textStyle.baselineX);
    var baseline = width;
    var height = 2 * baseline;
    baseline = baseline * textStyle.baselineY | 0;
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = "#f00";
    context.fillRect(0, 0, width, height);
    context.font = textStyle._font;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#000";
    context.fillText(textStyle.testString, 0, baseline);
    var output = {
        ascent: 0,
        descent: 0,
        fontSize: 0
    };
    if (!context.getImageData(0, 0, width, height)) {
        output.ascent = baseline;
        output.descent = baseline + 6;
        output.fontSize = output.ascent + output.descent;
        $c66096378ed21e2a$var$CanvasPool.remove(canvas);
        return output;
    }
    var imagedata = context.getImageData(0, 0, width, height).data;
    var pixels = imagedata.length;
    var line = width * 4;
    var i;
    var j;
    var idx = 0;
    var stop = false;
    // ascent. scan from top to bottom until we find a non red pixel
    for(i = 0; i < baseline; i++){
        for(j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
            stop = true;
            break;
        }
        if (!stop) idx += line;
        else break;
    }
    output.ascent = baseline - i;
    idx = pixels - line;
    stop = false;
    // descent. scan from bottom to top until we find a non red pixel
    for(i = height; i > baseline; i--){
        for(j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
            stop = true;
            break;
        }
        if (!stop) idx -= line;
        else break;
    }
    output.descent = i - baseline;
    output.fontSize = output.ascent + output.descent;
    $c66096378ed21e2a$var$CanvasPool.remove(canvas);
    return output;
};
var $c66096378ed21e2a$export$2e2bcd8739ae039 = $c66096378ed21e2a$var$MeasureText;


var $85f77e4ecbc486f7$var$CONST = {
    // new line mode
    NO_NEWLINE: 0,
    RAW_NEWLINE: 1,
    WRAPPED_NEWLINE: 2,
    // wrap mode
    NO_WRAP: 0,
    WORD_WRAP: 1,
    CHAR_WRAP: 2,
    // split lines
    SPLITREGEXP: /(?:\r\n|\r|\n)/
};
var $85f77e4ecbc486f7$export$2e2bcd8739ae039 = $85f77e4ecbc486f7$var$CONST;



const $c4330fa75cd41892$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $c4330fa75cd41892$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c4330fa75cd41892$var$TextStyle {
    constructor(text, style, propertyMap){
        this.parent = text;
        // parent.updateText()
        // parent.width, parent.height
        if (propertyMap === undefined) propertyMap = (0, $d4a9abab1509a92c$export$2e2bcd8739ae039);
        this.propertyMap = propertyMap;
        this.backgroundColor;
        this.backgroundColor2;
        this.backgroundHorizontalGradient;
        this.backgroundStrokeColor;
        this.backgroundStrokeLineWidth;
        this.backgroundCornerRadius;
        this.backgroundCornerIteration;
        this.fontFamily;
        this.fontSize;
        this.fontStyle;
        this.color;
        this.stroke;
        this.strokeThickness;
        this.shadowOffsetX;
        this.shadowOffsetY;
        this.shadowColor;
        this.shadowBlur;
        this.shadowStroke;
        this.shadowFill;
        this.underlineColor;
        this.underlineThickness;
        this.underlineOffset;
        this.halign;
        this.valign;
        this.maxLines;
        this.fixedWidth;
        this.fixedHeight;
        this.resolution;
        this.lineSpacing;
        this.xOffset;
        this.rtl;
        this.testString;
        this.baselineX;
        this.baselineY;
        this.wrapMode;
        this.wrapWidth;
        this.wrapCallback;
        this.wrapCallbackScope;
        this._font;
        //  Set to defaults + user style
        this.setStyle(style, false, true);
    }
    get isWrapFitMode() {
        return this.fixedWidth > 0 && this.wrapMode !== (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_WRAP && this.wrapWidth === 0;
    }
    setStyle(style, updateText, setDefaults) {
        if (updateText === undefined) updateText = true;
        if (setDefaults === undefined) setDefaults = false;
        if (style && style.hasOwnProperty("wrap")) {
            var wrap = style.wrap;
            if (wrap.hasOwnProperty("mode")) {
                var mode = wrap.mode;
                if (typeof mode === "string") wrap.mode = $c4330fa75cd41892$var$WRAPMODE[mode];
            } else if (wrap.hasOwnProperty("width")) wrap.mode = 1;
        }
        // default halign of RTL is 'right'
        if (style && style.rtl && setDefaults && !style.hasOwnProperty("halign")) style.halign = "right";
        //  Avoid type mutation
        if (style && style.hasOwnProperty("fontSize") && typeof style.fontSize === "number") style.fontSize = style.fontSize.toString() + "px";
        var propertyMap = this.propertyMap;
        for(var key in propertyMap){
            var prop = propertyMap[key]; // [ Object Key, Default Value, preCallback ]
            var objKey = prop[0];
            var defaultValue = setDefaults ? prop[1] : this[key];
            var postCallback = prop[2];
            if (key === "wrapCallback" || key === "wrapCallbackScope") // Callback & scope should be set without processing the values
            this[key] = $c4330fa75cd41892$var$GetValue(style, objKey, defaultValue);
            else {
                var value = $c4330fa75cd41892$var$GetAdvancedValue(style, objKey, defaultValue);
                if (postCallback) value = postCallback(value);
                this[key] = value;
            }
        }
        //  Allow for 'font' override
        var font = $c4330fa75cd41892$var$GetValue(style, "font", null);
        if (font === null) this._font = this.fontStyle + " " + this.fontSize + " " + this.fontFamily;
        else this._font = font;
        //  Allow for 'fill' to be used in place of 'color'
        var fill = $c4330fa75cd41892$var$GetValue(style, "fill", null);
        if (fill !== null) this.color = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(fill);
        var metrics = $c4330fa75cd41892$var$GetValue(style, "metrics", false);
        //  Provide optional TextMetrics in the style object to avoid the canvas look-up / scanning
        //  Doing this is reset if you then change the font of this TextStyle after creation
        if (metrics) this.metrics = {
            ascent: $c4330fa75cd41892$var$GetValue(metrics, "ascent", 0),
            descent: $c4330fa75cd41892$var$GetValue(metrics, "descent", 0),
            fontSize: $c4330fa75cd41892$var$GetValue(metrics, "fontSize", 0)
        };
        else if (updateText || !this.metrics) this.metrics = (0, $c66096378ed21e2a$export$2e2bcd8739ae039)(this);
        if (updateText) return this.parent.updateText();
        else return this.parent;
    }
    syncFont(canvas, context) {
        context.font = this._font;
    }
    syncStyle(canvas, context) {
        context.textBaseline = "alphabetic";
        context.fillStyle = this.color;
        context.strokeStyle = this.stroke;
        context.lineWidth = this.strokeThickness;
        context.lineCap = "round";
        context.lineJoin = "round";
    }
    syncShadow(context, enabled) {
        if (enabled) {
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
        } else {
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
            context.shadowColor = 0;
            context.shadowBlur = 0;
        }
    }
    update(recalculateMetrics) {
        if (recalculateMetrics) {
            this._font = `${this.fontStyle} ${this.fontSize} ${this.fontFamily}`.trim();
            this.metrics = (0, $c66096378ed21e2a$export$2e2bcd8739ae039)(this);
        }
        return this.parent.updateText(recalculateMetrics);
    }
    buildFont() {
        var newFont = `${this.fontStyle} ${this.fontSize} ${this.fontFamily}`.trim();
        if (newFont !== this._font) this._font = newFont;
        return this;
    }
    setFont(font) {
        if (typeof font === "string") {
            this.fontFamily = font;
            this.fontSize = "";
            this.fontStyle = "";
        } else {
            this.fontFamily = $c4330fa75cd41892$var$GetValue(font, "fontFamily", "Courier");
            this.fontSize = $c4330fa75cd41892$var$GetValue(font, "fontSize", "16px");
            this.fontStyle = $c4330fa75cd41892$var$GetValue(font, "fontStyle", "");
        }
        return this.update(true);
    }
    setFontFamily(family) {
        this.fontFamily = family;
        return this.update(true);
    }
    setFontStyle(style) {
        this.fontStyle = style;
        return this.update(true);
    }
    setFontSize(size) {
        if (typeof size === "number") size = size.toString() + "px";
        this.fontSize = size;
        return this.update(true);
    }
    setTestString(string) {
        this.testString = string;
        return this.update(true);
    }
    setFixedSize(width, height) {
        this.fixedWidth = width;
        this.fixedHeight = height;
        if (width) this.parent.width = width;
        if (height) this.parent.height = height;
        return this.update(this.isWrapFitMode);
    }
    setResolution(value) {
        this.resolution = value;
        return this.update(false);
    }
    setLineSpacing(value) {
        this.lineSpacing = value;
        return this.update(false);
    }
    setXOffset(value) {
        this.xOffset = value;
        return this.update(false);
    }
    setBackgroundColor(color, color2, isHorizontalGradient) {
        if (isHorizontalGradient === undefined) isHorizontalGradient = true;
        this.backgroundColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        this.backgroundColor2 = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color2, this.parent.canvas, this.parent.context);
        this.backgroundHorizontalGradient = isHorizontalGradient;
        return this.update(false);
    }
    setBackgroundStrokeColor(color, lineWidth) {
        this.backgroundStrokeColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        this.backgroundStrokeLineWidth = lineWidth;
        return this.update(false);
    }
    setBackgroundCornerRadius(radius, iteration) {
        this.backgroundCornerRadius = radius;
        this.backgroundCornerIteration = iteration;
        return this.update(false);
    }
    setFill(color) {
        this.color = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        return this.update(false);
    }
    setColor(color) {
        this.color = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        return this.update(false);
    }
    setStroke(color, thickness) {
        if (color === undefined) //  Reset the stroke to zero (disabling it)
        this.strokeThickness = 0;
        else {
            if (thickness === undefined) thickness = this.strokeThickness;
            this.stroke = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
            this.strokeThickness = thickness;
        }
        return this.update(true);
    }
    setShadow(x, y, color, blur, shadowStroke, shadowFill) {
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (color === undefined) color = "#000";
        if (blur === undefined) blur = 0;
        if (shadowStroke === undefined) shadowStroke = false;
        if (shadowFill === undefined) shadowFill = true;
        this.shadowOffsetX = x;
        this.shadowOffsetY = y;
        this.shadowColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        this.shadowBlur = blur;
        this.shadowStroke = shadowStroke;
        this.shadowFill = shadowFill;
        return this.update(false);
    }
    setShadowOffset(x, y) {
        if (x === undefined) x = 0;
        if (y === undefined) y = x;
        this.shadowOffsetX = x;
        this.shadowOffsetY = y;
        return this.update(false);
    }
    setShadowColor(color) {
        if (color === undefined) color = "#000";
        this.shadowColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        return this.update(false);
    }
    setShadowBlur(blur) {
        if (blur === undefined) blur = 0;
        this.shadowBlur = blur;
        return this.update(false);
    }
    setShadowStroke(enabled) {
        this.shadowStroke = enabled;
        return this.update(false);
    }
    setShadowFill(enabled) {
        this.shadowFill = enabled;
        return this.update(false);
    }
    setUnderline(color, thickness, offset) {
        if (color === undefined) color = "#000";
        if (thickness === undefined) thickness = 0;
        if (offset === undefined) offset = 0;
        this.underlineColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        this.underlineThickness = thickness;
        this.underlineOffset = offset;
        return this.update(false);
    }
    setUnderlineColor(color) {
        if (color === undefined) color = "#000";
        this.underlineColor = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(color, this.parent.canvas, this.parent.context);
        return this.update(false);
    }
    setUnderlineThickness(thickness) {
        if (thickness === undefined) thickness = 0;
        this.underlineThickness = thickness;
        return this.update(false);
    }
    setUnderlineOffset(offset) {
        if (offset === undefined) offset = 0;
        this.underlineOffset = offset;
        return this.update(false);
    }
    setWrapMode(mode) {
        if (typeof mode === "string") mode = $c4330fa75cd41892$var$WRAPMODE[mode.toLowerCase()] || 0;
        this.wrapMode = mode;
        return this.update(true);
    }
    setWrapWidth(width) {
        this.wrapWidth = width;
        return this.update(false);
    }
    setAlign(halign, valign) {
        if (halign === undefined) halign = "left";
        if (valign === undefined) valign = "top";
        this.halign = halign;
        this.valign = valign;
        return this.update(false);
    }
    setHAlign(halign) {
        if (halign === undefined) halign = "left";
        this.halign = halign;
        return this.update(false);
    }
    setVAlign(valign) {
        if (valign === undefined) valign = "top";
        this.valign = valign;
        return this.update(false);
    }
    setMaxLines(max) {
        if (max === undefined) max = 0;
        this.maxLines = max;
        return this.update(false);
    }
    getTextMetrics() {
        var metrics = this.metrics;
        return {
            ascent: metrics.ascent,
            descent: metrics.descent,
            fontSize: metrics.fontSize
        };
    }
    setTextMetrics(metrics, font) {
        this.metrics.ascent = metrics.ascent;
        this.metrics.descent = metrics.descent;
        this.metrics.fontSize = metrics.fontSize;
        if (font) {
            if (typeof font === "string") {
                this.fontFamily = font;
                this.fontSize = "";
                this.fontStyle = "";
            } else {
                this.fontFamily = $c4330fa75cd41892$var$GetValue(font, "fontFamily", this.fontFamily);
                this.fontSize = $c4330fa75cd41892$var$GetValue(font, "fontSize", this.fontSize);
                this.fontStyle = $c4330fa75cd41892$var$GetValue(font, "fontStyle", this.fontStyle);
            }
        }
        return this.parent.updateText(true);
    }
    get lineHeight() {
        return this.metrics.fontSize + this.strokeThickness + this.lineSpacing;
    }
    toJSON() {
        var output = {};
        var propertyMap = this.propertyMap;
        for(var key in propertyMap)output[key] = this[key];
        output.metrics = this.getTextMetrics();
        return output;
    }
    destroy() {
        this.parent = undefined;
    }
}
const $c4330fa75cd41892$var$WRAPMODE = {
    none: (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_WRAP,
    word: (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).WORD_WRAP,
    char: (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).CHAR_WRAP,
    character: (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).CHAR_WRAP
};
var $c4330fa75cd41892$export$2e2bcd8739ae039 = $c4330fa75cd41892$var$TextStyle;



var $fdf0aeb815b7cd93$export$2e2bcd8739ae039 = {
    draw (startX, startY, textWidth, textHeight) {
        var penManager = this.penManager;
        this.hitAreaManager.clear();
        var context = this.context;
        context.save();
        var defaultStyle = this.defaultStyle;
        this.clear();
        (0, $3c945d5472df192a$export$2e2bcd8739ae039)(this, defaultStyle.backgroundColor, defaultStyle.backgroundStrokeColor, defaultStyle.backgroundStrokeLineWidth, defaultStyle.backgroundCornerRadius, defaultStyle.backgroundColor2, defaultStyle.backgroundHorizontalGradient, defaultStyle.backgroundCornerIteration);
        // draw lines
        startX += this.startXOffset;
        startY += this.startYOffset;
        var defaultHalign = defaultStyle.halign, valign = defaultStyle.valign;
        var lineWidth, lineHeight = defaultStyle.lineHeight;
        var lines = penManager.lines;
        var totalLinesNum = lines.length, maxLines = defaultStyle.maxLines;
        var drawLinesNum, drawLineStartIdx, drawLineEndIdx;
        if (maxLines > 0 && totalLinesNum > maxLines) {
            drawLinesNum = maxLines;
            if (valign === "center") drawLineStartIdx = Math.floor((totalLinesNum - drawLinesNum) / 2);
            else if (valign === "bottom") drawLineStartIdx = totalLinesNum - drawLinesNum;
            else drawLineStartIdx = 0;
        } else {
            drawLinesNum = totalLinesNum;
            drawLineStartIdx = 0;
        }
        drawLineEndIdx = drawLineStartIdx + drawLinesNum;
        var offsetX, offsetY;
        var rtl = this.rtl, rtlOffset = rtl ? this.parent.width : undefined;
        if (valign === "center") offsetY = Math.max((textHeight - drawLinesNum * lineHeight) / 2, 0);
        else if (valign === "bottom") offsetY = Math.max(textHeight - drawLinesNum * lineHeight - 2, 0);
        else offsetY = 0;
        offsetY += startY;
        for(var lineIdx = drawLineStartIdx; lineIdx < drawLineEndIdx; lineIdx++){
            lineWidth = penManager.getLineWidth(lineIdx);
            if (lineWidth === 0) continue;
            var pens = lines[lineIdx], penCount = pens.length;
            var halign = defaultHalign;
            // Seek if there has algin tag
            for(var penIdx = 0; penIdx < penCount; penIdx++){
                var penAlign = pens[penIdx].prop.align;
                if (penAlign !== undefined) {
                    halign = penAlign;
                    break;
                }
            }
            if (halign === "center") offsetX = (textWidth - lineWidth) / 2;
            else if (halign === "right") offsetX = !rtl ? textWidth - lineWidth : 0;
            else offsetX = !rtl ? 0 : textWidth - lineWidth;
            offsetX += startX;
            for(var penIdx = 0; penIdx < penCount; penIdx++)this.drawPen(pens[penIdx], offsetX, offsetY, rtlOffset);
        }
        context.restore();
    },
    drawPen (pen, offsetX, offsetY, rtlOffset) {
        offsetX += pen.x;
        offsetY += pen.y + (pen.prop.y || 0);
        if (rtlOffset !== undefined) offsetX = rtlOffset - offsetX;
        var canvas = this.canvas;
        var context = this.context;
        context.save();
        var curStyle = this.parser.propToContextStyle(this.defaultStyle, pen.prop);
        curStyle.buildFont();
        curStyle.syncFont(canvas, context);
        curStyle.syncStyle(canvas, context);
        // Underline
        if (curStyle.underlineThickness > 0 && pen.width > 0) this.drawUnderline(offsetX, offsetY, pen.width, curStyle);
        // Text
        if (pen.isTextPen) this.drawText(offsetX, offsetY, pen.text, curStyle);
        // Image
        if (pen.isImagePen) this.drawImage(offsetX, offsetY, pen.prop.img, curStyle);
        context.restore();
        if (pen.hasAreaMarker && pen.width > 0) {
            var data;
            var areaKey = pen.prop.area;
            if (areaKey) data = {
                key: areaKey
            };
            else {
                var url = pen.prop.url;
                data = {
                    key: `url:${url}`,
                    url: url
                };
            }
            this.hitAreaManager.add(offsetX, offsetY - this.startYOffset, pen.width, this.defaultStyle.lineHeight, data);
        }
    },
    clear () {
        var canvas = this.canvas;
        this.context.clearRect(0, 0, canvas.width, canvas.height);
    },
    drawUnderline (x, y, width, style) {
        y += style.underlineOffset - style.underlineThickness / 2;
        if (this.autoRound) {
            x = Math.round(x);
            y = Math.round(y);
        }
        var context = this.context;
        var savedLineCap = context.lineCap;
        context.lineCap = "butt";
        context.strokeStyle = style.underlineColor;
        context.lineWidth = style.underlineThickness;
        context.beginPath();
        context.moveTo(x, y);
        context.lineTo(x + width, y);
        context.stroke();
        context.lineCap = savedLineCap;
    },
    drawText (x, y, text, style) {
        if (this.autoRound) {
            x = Math.round(x);
            y = Math.round(y);
        }
        var context = this.context;
        if (style.stroke && style.stroke !== "none" && style.strokeThickness > 0) {
            style.syncShadow(context, style.shadowStroke);
            context.strokeText(text, x, y);
        }
        if (style.color && style.color !== "none") {
            style.syncShadow(context, style.shadowFill);
            context.fillText(text, x, y);
        }
    },
    drawImage (x, y, imgKey, style) {
        y -= this.startYOffset;
        this.parent.imageManager.draw(imgKey, this.context, x, y, this.autoRound);
    }
};



const $b4a7cffc269a416d$var$GetValue = Phaser.Utils.Objects.GetValue;
const $b4a7cffc269a416d$var$NO_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_NEWLINE;
const $b4a7cffc269a416d$var$RAW_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).RAW_NEWLINE;
class $b4a7cffc269a416d$var$Pen {
    constructor(config){
        this.prop = {};
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        this.text = $b4a7cffc269a416d$var$GetValue(o, "text", "");
        this.x = $b4a7cffc269a416d$var$GetValue(o, "x", 0);
        this.y = $b4a7cffc269a416d$var$GetValue(o, "y", 0);
        this.width = $b4a7cffc269a416d$var$GetValue(o, "width", 0);
        var prop = $b4a7cffc269a416d$var$GetValue(o, "prop", null);
        if (prop === null) prop = {};
        this.prop = prop;
        this.newLineMode = $b4a7cffc269a416d$var$GetValue(o, "newLineMode", 0);
        this.startIndex = $b4a7cffc269a416d$var$GetValue(o, "startIndex", 0);
    }
    get plainText() {
        var txt = this.text;
        if (this.newLineMode === $b4a7cffc269a416d$var$RAW_NEWLINE) txt += "\n";
        return txt;
    }
    get wrapText() {
        var txt = this.text;
        if (this.newLineMode !== $b4a7cffc269a416d$var$NO_NEWLINE) txt += "\n";
        return txt;
    }
    get rawTextLength() {
        var len = this.text.length;
        if (this.newLineMode === $b4a7cffc269a416d$var$RAW_NEWLINE) len += 1;
        return len;
    }
    get endIndex() {
        return this.startIndex + this.rawTextLength;
    }
    get lastX() {
        return this.x + this.width;
    }
    get isTextPen() {
        return this.text !== "";
    }
    get isImagePen() {
        return !!this.prop.img;
    }
    get hasAreaMarker() {
        return !!this.prop.area || !!this.prop.url;
    }
}
var $b4a7cffc269a416d$export$2e2bcd8739ae039 = $b4a7cffc269a416d$var$Pen;





const $30f9917715c7f405$var$GetFastValue = Phaser.Utils.Objects.GetFastValue;
const $30f9917715c7f405$var$NO_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_NEWLINE;
const $30f9917715c7f405$var$WRAPPED_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).WRAPPED_NEWLINE;
class $30f9917715c7f405$var$PenManager {
    constructor(config){
        this.pens = []; // all pens
        this.lines = []; // pens in lines [ [],[],[],.. ]
        this.maxLinesWidth = undefined;
        this.pensPool = config.pensPool; // Required
        this.linesPool = config.linesPool; // Required
        this.tagToText = $30f9917715c7f405$var$GetFastValue(config, "tagToText", (0, $990223f7da3447ad$export$2e2bcd8739ae039));
        this.tagToTextScope = $30f9917715c7f405$var$GetFastValue(config, "tagToTextScope", undefined);
    }
    destroy() {
        this.clear();
        this.tagToText = undefined;
        this.tagToTextScope = undefined;
    }
    clear() {
        for(var i = 0, len = this.lines.length; i < len; i++)this.lines[i].length = 0;
        this.pensPool.pushMultiple(this.pens);
        this.linesPool.pushMultiple(this.lines);
        this.maxLinesWidth = undefined;
    }
    addTextPen(text, x, y, width, prop, newLineMode) {
        var pen = this.pensPool.pop();
        if (pen == null) pen = new (0, $b4a7cffc269a416d$export$2e2bcd8739ae039)();
        $30f9917715c7f405$var$PEN_CONFIG.text = text;
        $30f9917715c7f405$var$PEN_CONFIG.x = x;
        $30f9917715c7f405$var$PEN_CONFIG.y = y;
        $30f9917715c7f405$var$PEN_CONFIG.width = width;
        $30f9917715c7f405$var$PEN_CONFIG.prop = prop;
        $30f9917715c7f405$var$PEN_CONFIG.newLineMode = newLineMode;
        pen.resetFromJSON($30f9917715c7f405$var$PEN_CONFIG);
        this.addPen(pen);
        return this;
    }
    addImagePen(x, y, width, prop) {
        this.addTextPen("", x, y, width, prop, $30f9917715c7f405$var$NO_NEWLINE);
        return this;
    }
    addNewLinePen() {
        var previousPen = this.lastPen;
        var x = previousPen ? previousPen.lastX : 0;
        var y = previousPen ? previousPen.y : 0;
        var prop = previousPen ? (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(previousPen.prop) : null;
        this.addTextPen("", x, y, 0, prop, $30f9917715c7f405$var$WRAPPED_NEWLINE);
        return this;
    }
    addPen(pen) {
        var previousPen = this.lastPen;
        if (previousPen == null) pen.startIndex = 0;
        else pen.startIndex = previousPen.endIndex;
        this.pens.push(pen);
        // maintan lines
        var line = this.lastLine;
        if (line == null) {
            line = this.linesPool.pop() || [];
            this.lines.push(line);
        }
        line.push(pen);
        // new line, add an empty line
        if (pen.newLineMode !== $30f9917715c7f405$var$NO_NEWLINE) {
            line = this.linesPool.pop() || [];
            this.lines.push(line);
        }
        this.maxLinesWidth = undefined;
    }
    clone(targetPenManager) {
        if (targetPenManager == null) targetPenManager = new $30f9917715c7f405$var$PenManager();
        targetPenManager.clear();
        for(var li = 0, llen = this.lines.length; li < llen; li++){
            var pens = this.lines[li];
            for(var pi = 0, plen = pens.length; pi < plen; pi++){
                var pen = pens[pi];
                targetPenManager.addPen(pen.text, pen.x, pen.y, pen.width, (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(pen.prop), pen.newLineMode);
            }
        }
        return targetPenManager;
    }
    get lastPen() {
        return this.pens[this.pens.length - 1];
    }
    get lastLine() {
        return this.lines[this.lines.length - 1];
    }
    getLineStartIndex(i) {
        if (i >= this.lines.length) return this.getLineEndIndex(i);
        else {
            var line = this.lines[i];
            return line && line[0] ? line[0].startIndex : 0;
        }
    }
    getLineEndIndex(i) {
        if (i >= this.lines.length) i = this.lines.length - 1;
        var li, hasLastPen = false, line;
        for(li = i; li >= 0; li--){
            line = this.lines[li];
            hasLastPen = line != null && line.length > 0;
            if (hasLastPen) break;
        }
        if (!hasLastPen) return 0;
        var lastPen = line[line.length - 1];
        return lastPen.endIndex;
    }
    getLineWidth(i) {
        var line = this.lines[i];
        if (!line) return 0;
        var lastPen = line[line.length - 1];
        if (lastPen == null) return 0;
        var lineWidth = lastPen.lastX; // start from 0
        return lineWidth;
    }
    getMaxLineWidth() {
        if (this.maxLinesWidth !== undefined) return this.maxLinesWidth;
        var w, maxW = 0;
        for(var i = 0, len = this.lines.length; i < len; i++){
            w = this.getLineWidth(i);
            if (w > maxW) maxW = w;
        }
        this.maxLinesWidth = maxW;
        return maxW;
    }
    getLineWidths() {
        var result = [];
        for(var i = 0, len = this.lines.length; i < len; i++)result.push(this.getLineWidth(i));
        return result;
    }
    get linesCount() {
        return this.lines.length;
    }
    get plainText() {
        var txt = "", pens = this.pens;
        for(var i = 0, len = pens.length; i < len; i++)txt += pens[i].plainText;
        return txt;
    }
    get rawTextLength() {
        var l = 0, pens = this.pens;
        for(var i = 0, len = this.pens.length; i < len; i++)l += pens[i].rawTextLength;
        return l;
    }
    getSliceTagText(start, end, wrap) {
        if (start === undefined) start = 0;
        if (end === undefined) {
            var lastPen = this.lastPen;
            if (lastPen == null) return "";
            end = lastPen.endIndex;
        }
        if (wrap === undefined) wrap = false;
        var txt = "", formatTxt, pen, penTxt, penStartIdx, penEndIdx, isInRange;
        var currentProp, previousProp;
        for(var i = 0, len = this.pens.length; i < len; i++){
            pen = this.pens[i];
            penEndIdx = pen.endIndex;
            if (penEndIdx <= start) continue;
            pen = this.pens[i];
            penTxt = !wrap ? pen.plainText : pen.wrapText;
            currentProp = pen.prop;
            penStartIdx = pen.startIndex;
            isInRange = penStartIdx >= start && penEndIdx <= end;
            if (!isInRange) penTxt = penTxt.substring(start - penStartIdx, end - penStartIdx);
            if (this.tagToTextScope) txt += this.tagToText.call(this.tagToTextScope, penTxt, currentProp, previousProp);
            else txt += this.tagToText(penTxt, currentProp, previousProp);
            previousProp = currentProp;
            if (penEndIdx >= end) break;
        }
        return txt;
    }
    get length() {
        return this.lines.length;
    }
    set length(value) {
        // Only for set length to 0 (clear)
        this.clear();
    }
}
var $30f9917715c7f405$var$PEN_CONFIG = {};
var $30f9917715c7f405$export$2e2bcd8739ae039 = $30f9917715c7f405$var$PenManager;




const $994d4e8eb7be8d1c$var$Rectangle = Phaser.Geom.Rectangle;
var $994d4e8eb7be8d1c$var$RectanglePool = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
class $994d4e8eb7be8d1c$var$HitAreaManager {
    constructor(){
        this.hitAreas = [];
    }
    destroy() {
        this.clear();
    }
    clear() {
        // Reuse hitArea(rectangle) later
        for(var i = 0, cnt = this.hitAreas.length; i < cnt; i++)(0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.hitAreas[i].data);
        $994d4e8eb7be8d1c$var$RectanglePool.pushMultiple(this.hitAreas);
        return this;
    }
    add(x, y, width, height, data) {
        var rectangle = $994d4e8eb7be8d1c$var$RectanglePool.pop();
        if (rectangle === null) rectangle = new $994d4e8eb7be8d1c$var$Rectangle(x, y, width, height);
        else rectangle.setTo(x, y, width, height);
        rectangle.data = data;
        this.hitAreas.push(rectangle);
        return this;
    }
    getFirst(x, y) {
        for(var i = 0, cnt = this.hitAreas.length; i < cnt; i++){
            var hitArea = this.hitAreas[i];
            if (hitArea.contains(x, y)) return hitArea;
        }
        return null;
    }
    getByKey(key) {
        for(var i = 0, cnt = this.hitAreas.length; i < cnt; i++){
            var hitArea = this.hitAreas[i];
            if (hitArea.data.key === key) return hitArea;
        }
        return null;
    }
    drawBounds(graphics, color, parent) {
        if (color === undefined) color = 0xffffff;
        if (parent) graphics.save().scaleCanvas(parent.scaleX, parent.scaleY).rotateCanvas(parent.rotation).translateCanvas(parent.x, parent.y);
        for(var i = 0, cnt = this.hitAreas.length; i < cnt; i++){
            var hitArea = this.hitAreas[i];
            graphics.lineStyle(1, color).strokeRect(hitArea.x, hitArea.y, hitArea.width, hitArea.height);
        }
        if (parent) graphics.restore();
        return this;
    }
}
var $994d4e8eb7be8d1c$export$2e2bcd8739ae039 = $994d4e8eb7be8d1c$var$HitAreaManager;


var $c6d122c031e37e3c$var$SetInteractive = function() {
    this.parent.on("pointerdown", $c6d122c031e37e3c$var$OnAreaDown, this).on("pointerup", $c6d122c031e37e3c$var$OnAreaUp, this).on("pointermove", $c6d122c031e37e3c$var$OnAreaOverOut, this).on("pointerover", $c6d122c031e37e3c$var$OnAreaOverOut, this).on("pointerout", function(pointer, event) {
        $c6d122c031e37e3c$var$OnAreaOverOut.call(this, pointer, null, null, event);
    }, this);
};
var $c6d122c031e37e3c$var$OnAreaDown = function(pointer, localX, localY, event) {
    var area = this.hitAreaManager.getFirst(localX, localY);
    if (area === null) return;
    var key = area.data.key;
    $c6d122c031e37e3c$var$FireEvent.call(this, "areadown", key, pointer, localX, localY, event);
    area.data.isDown = true;
};
var $c6d122c031e37e3c$var$OnAreaUp = function(pointer, localX, localY, event) {
    var area = this.hitAreaManager.getFirst(localX, localY);
    if (area === null) return;
    var areaData = area.data;
    var key = areaData.key;
    $c6d122c031e37e3c$var$FireEvent.call(this, "areaup", key, pointer, localX, localY, event);
    if (areaData.isDown) {
        $c6d122c031e37e3c$var$FireEvent.call(this, "areaclick", key, pointer, localX, localY, event);
        var url = areaData.url;
        if (url) window.open(url, "_blank");
    }
    areaData.isDown = false;
};
var $c6d122c031e37e3c$var$OnAreaOverOut = function(pointer, localX, localY, event) {
    if (localX === null) {
        if (this.lastHitAreaKey !== null) {
            $c6d122c031e37e3c$var$FireEvent.call(this, "areaout", this.lastHitAreaKey, pointer, localX, localY, event);
            this.hitAreaManager.getByKey(this.lastHitAreaKey).isDown = false;
            this.lastHitAreaKey = null;
        }
        return;
    }
    var area = this.hitAreaManager.getFirst(localX, localY);
    var key = area ? area.data.key : null;
    if (this.lastHitAreaKey === key) return;
    if (this.lastHitAreaKey !== null) {
        $c6d122c031e37e3c$var$FireEvent.call(this, "areaout", this.lastHitAreaKey, pointer, localX, localY, event);
        var prevHitArea = this.hitAreaManager.getByKey(this.lastHitAreaKey);
        if (this.urlTagCursorStyle && !!prevHitArea.data.url) this.scene.input.manager.canvas.style.cursor = "";
        prevHitArea.isDown = false;
    }
    if (key !== null) {
        $c6d122c031e37e3c$var$FireEvent.call(this, "areaover", key, pointer, localX, localY, event);
        if (this.urlTagCursorStyle && !!area.data.url) this.scene.input.manager.canvas.style.cursor = this.urlTagCursorStyle;
    }
    this.lastHitAreaKey = key;
};
var $c6d122c031e37e3c$var$FireEvent = function(eventName, key, pointer, localX, localY, event) {
    this.parent.emit(`${eventName}-${key}`, pointer, localX, localY, event);
    this.parent.emit(eventName, key, pointer, localX, localY, event);
};
var $c6d122c031e37e3c$export$2e2bcd8739ae039 = $c6d122c031e37e3c$var$SetInteractive;




const $d54db420350be5de$var$NO_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_NEWLINE;
const $d54db420350be5de$var$RAW_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).RAW_NEWLINE;
const $d54db420350be5de$var$WRAPPED_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).WRAPPED_NEWLINE;
const $d54db420350be5de$var$NO_WRAP = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_WRAP;
const $d54db420350be5de$var$WORD_WRAP = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).WORD_WRAP;
const $d54db420350be5de$var$CHAR_WRAP = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).CHAR_WRAP;
const $d54db420350be5de$var$splitRegExp = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).SPLITREGEXP;
var $d54db420350be5de$var$WrapText = function(text, getTextWidth, wrapMode, wrapWidth, offset, wrapTextLinesPool) {
    if (wrapWidth <= 0) wrapMode = $d54db420350be5de$var$NO_WRAP;
    var retLines = [];
    if (!text || !text.length) return retLines;
    var isNoWrap = wrapMode === $d54db420350be5de$var$NO_WRAP;
    var isWordWrap = wrapMode === $d54db420350be5de$var$WORD_WRAP;
    var lines = text.split($d54db420350be5de$var$splitRegExp), line, remainWidth, newLineMode;
    for(var i = 0, linesLen = lines.length; i < linesLen; i++){
        line = lines[i];
        newLineMode = i === linesLen - 1 ? $d54db420350be5de$var$NO_NEWLINE : $d54db420350be5de$var$RAW_NEWLINE;
        if (isNoWrap) {
            var textWidth = getTextWidth(line);
            retLines.push(wrapTextLinesPool.getLine(line, textWidth, newLineMode));
            continue;
        }
        remainWidth = i === 0 ? wrapWidth - offset : wrapWidth;
        // short string testing
        if (line.length <= 100) {
            var textWidth = getTextWidth(line);
            if (textWidth <= remainWidth) {
                retLines.push(wrapTextLinesPool.getLine(line, textWidth, newLineMode));
                continue;
            }
        }
        var tokenArray, isSpaceCharacterEnd;
        if (isWordWrap) {
            // word mode
            tokenArray = line.split(" ");
            isSpaceCharacterEnd = tokenArray[tokenArray.length - 1] === "";
            if (isSpaceCharacterEnd) tokenArray.length -= 1;
        } else tokenArray = line;
        var token, tokenWidth, isLastToken;
        var lineText = "", lineWidth = 0;
        var currLineWidth;
        var whiteSpaceWidth = isWordWrap ? getTextWidth(" ") : undefined;
        for(var j = 0, tokenLen = tokenArray.length; j < tokenLen; j++){
            token = tokenArray[j];
            tokenWidth = getTextWidth(token);
            isLastToken = j === tokenLen - 1;
            if (isWordWrap && (!isLastToken || isSpaceCharacterEnd)) {
                token += " ";
                tokenWidth += whiteSpaceWidth;
            }
            // Text width of single token is larger than a line width
            if (isWordWrap && tokenWidth > wrapWidth) {
                if (lineText !== "") // Has pending lineText, flush it out
                retLines.push(wrapTextLinesPool.getLine(lineText, lineWidth, $d54db420350be5de$var$WRAPPED_NEWLINE));
                else if (j === 0 && offset > 0) // No pending lineText, but has previous text. Append a newline
                retLines.push(wrapTextLinesPool.getLine("", 0, $d54db420350be5de$var$WRAPPED_NEWLINE));
                // Word break
                retLines.push(...$d54db420350be5de$var$WrapText(token, getTextWidth, $d54db420350be5de$var$CHAR_WRAP, wrapWidth, 0, wrapTextLinesPool));
                // Continue at last-wordBreak-line
                var lastwordBreakLine = retLines.pop();
                lineText = lastwordBreakLine.text;
                lineWidth = lastwordBreakLine.width;
                // Free this line
                wrapTextLinesPool.freeLine(lastwordBreakLine);
                // Special case : Start at a space character, discard it
                if (lineText === " ") {
                    lineText = "";
                    lineWidth = 0;
                }
                continue;
            }
            currLineWidth = lineWidth + tokenWidth;
            if (currLineWidth > remainWidth) {
                // New line
                retLines.push(wrapTextLinesPool.getLine(lineText, lineWidth, $d54db420350be5de$var$WRAPPED_NEWLINE));
                lineText = token;
                lineWidth = tokenWidth;
                remainWidth = wrapWidth;
            } else {
                // Append token, continue
                lineText += token;
                lineWidth = currLineWidth;
            }
            if (isLastToken) // Flush remain text
            retLines.push(wrapTextLinesPool.getLine(lineText, lineWidth, newLineMode));
        } // for token in tokenArray
    } // for each line in lines
    return retLines;
};
var $d54db420350be5de$export$2e2bcd8739ae039 = $d54db420350be5de$var$WrapText;



const $74b1eae8d330bcdd$var$GetValue = Phaser.Utils.Objects.GetValue;
const $74b1eae8d330bcdd$var$NO_WRAP = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_WRAP;
const $74b1eae8d330bcdd$var$NO_NEWLINE = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).NO_NEWLINE;
class $74b1eae8d330bcdd$var$CanvasText {
    constructor(config){
        this.parent = config.parent;
        this.scene = this.parent.scene;
        this.context = $74b1eae8d330bcdd$var$GetValue(config, "context", null);
        this.canvas = this.context.canvas;
        this.parser = $74b1eae8d330bcdd$var$GetValue(config, "parser", null);
        this.defaultStyle = $74b1eae8d330bcdd$var$GetValue(config, "style", null);
        this.autoRound = true;
        this.pensPool = config.pensPool; // Required
        this.linesPool = config.linesPool; // Required
        this.wrapTextLinesPool = config.wrapTextLinesPool; // Required
        this.penManager = this.newPenManager();
        this._tmpPenManager = null;
        this.hitAreaManager = new (0, $994d4e8eb7be8d1c$export$2e2bcd8739ae039)();
        this.lastHitAreaKey = null;
        this.urlTagCursorStyle = null;
        var context = this.context;
        this.getTextWidth = function(text) {
            return context.measureText(text).width;
        };
    }
    destroy() {
        this.parent = undefined;
        this.scene = undefined;
        this.context = undefined;
        this.canvas = undefined;
        this.parser = undefined;
        this.defaultStyle = undefined;
        if (this.penManager) {
            this.penManager.destroy();
            this.penManager = undefined;
        }
        if (this._tmpPenManager) {
            this._tmpPenManager.destroy();
            this._tmpPenManager = undefined;
        }
        if (this.hitAreaManager) {
            this.hitAreaManager.destroy();
            this.hitAreaManager = undefined;
        }
        this.pensPool = undefined;
        this.linesPool = undefined;
        this.wrapTextLinesPool = undefined;
    }
    updatePenManager(text, wrapMode, wrapWidth, lineHeight, penManager) {
        if (penManager === undefined) penManager = this.penManager;
        penManager.clear();
        if (text === "") return penManager;
        var textStyle = this.parent.style;
        if (textStyle.isWrapFitMode) {
            var padding = this.parent.padding;
            wrapWidth = textStyle.fixedWidth - padding.left - padding.right;
        }
        var canvas = this.canvas;
        var context = this.context;
        var MeasureText = function(text) {
            return context.measureText(text).width;
        };
        var cursorX = 0, cursorY = 0;
        var customTextWrapCallback = textStyle.wrapCallback, customTextWrapCallbackScope = textStyle.wrapCallbackScope;
        var reuseLines = true;
        var plainText, curProp, curStyle;
        var match = this.parser.splitText(text), result, wrapLines, wrapTextLinesPool = this.wrapTextLinesPool;
        for(var i = 0, len = match.length; i < len; i++){
            result = this.parser.tagTextToProp(match[i], curProp);
            plainText = result.plainText;
            curProp = result.prop;
            if (curProp.img) {
                var imgWidth = this.imageManager.getOuterWidth(curProp.img);
                if (wrapWidth > 0 && wrapMode !== $74b1eae8d330bcdd$var$NO_WRAP) {
                    if (wrapWidth < cursorX + imgWidth) {
                        penManager.addNewLinePen();
                        cursorY += lineHeight;
                        cursorX = 0;
                    }
                }
                penManager.addImagePen(cursorX, cursorY, imgWidth, (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(curProp));
                cursorX += imgWidth;
            } else if (plainText !== "") {
                // wrap text to lines
                // Save the current context.
                context.save();
                curStyle = this.parser.propToContextStyle(this.defaultStyle, curProp);
                curStyle.buildFont();
                curStyle.syncFont(canvas, context);
                curStyle.syncStyle(canvas, context);
                if (!customTextWrapCallback) wrapLines = (0, $d54db420350be5de$export$2e2bcd8739ae039)(plainText, MeasureText, wrapMode, wrapWidth, cursorX, wrapTextLinesPool);
                else {
                    wrapLines = customTextWrapCallback.call(customTextWrapCallbackScope, plainText, MeasureText, wrapWidth, cursorX);
                    if (typeof wrapLines === "string") wrapLines = wrapLines.split("\n");
                    var n;
                    for(var j = 0, jLen = wrapLines.length; j < jLen; j++){
                        n = wrapLines[j];
                        if (typeof n === "string") wrapLines[j] = wrapTextLinesPool.getLine(n, MeasureText(n), j < jLen - 1 ? 2 : 0);
                        else reuseLines = false;
                    }
                } // customTextWrapCallback
                // add pens
                var n;
                for(var j = 0, jLen = wrapLines.length; j < jLen; j++){
                    n = wrapLines[j];
                    penManager.addTextPen(n.text, cursorX, cursorY, n.width, (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(curProp), n.newLineMode);
                    if (n.newLineMode !== $74b1eae8d330bcdd$var$NO_NEWLINE) {
                        cursorX = 0;
                        cursorY += lineHeight;
                    } else cursorX += n.width;
                }
                if (reuseLines) wrapTextLinesPool.freeLines(wrapLines);
                wrapLines = null;
                context.restore();
            }
        }
        // Add strokeThinkness to last pen of each line
        for(var i = 0, len = this.lines.length; i < len; i++){
            var line = this.lines[i];
            var lastPen = line[line.length - 1];
            if (lastPen) lastPen.width += this.parser.getStrokeThinkness(this.defaultStyle, lastPen.prop);
        }
        return penManager;
    }
    get startXOffset() {
        var defaultStyle = this.defaultStyle;
        return defaultStyle.strokeThickness / 2 + defaultStyle.xOffset;
    }
    get startYOffset() {
        var defaultStyle = this.defaultStyle;
        return defaultStyle.strokeThickness / 2 + defaultStyle.metrics.ascent;
    }
    get lines() {
        return this.penManager.lines;
    }
    get desplayLinesCount() {
        var linesCount = this.penManager.linesCount, maxLines = this.defaultStyle.maxLines;
        if (maxLines > 0 && linesCount > maxLines) linesCount = maxLines;
        return linesCount;
    }
    get linesWidth() {
        return Math.ceil(this.penManager.getMaxLineWidth());
    }
    get linesHeight() {
        var linesCount = this.desplayLinesCount;
        var linesHeight = this.defaultStyle.lineHeight * linesCount;
        if (linesCount > 0) linesHeight -= this.defaultStyle.lineSpacing;
        return linesHeight;
    }
    get imageManager() {
        return this.parent.imageManager;
    }
    get rtl() {
        return this.parent.style.rtl;
    }
    newPenManager() {
        return new (0, $30f9917715c7f405$export$2e2bcd8739ae039)({
            pensPool: this.pensPool,
            linesPool: this.linesPool,
            tagToText: this.parser.propToTagText,
            tagToTextScope: this.parser
        });
    }
    get tmpPenManager() {
        if (this._tmpPenManager === null) this._tmpPenManager = this.newPenManager();
        return this._tmpPenManager;
    }
    getPlainText(text, start, end) {
        var plainText;
        if (text == null) plainText = this.penManager.plainText;
        else {
            var m, match = this.parser.splitText(text, 1); // PLAINTEXTONLY_MODE
            plainText = "";
            for(var i = 0, len = match.length; i < len; i++)plainText += match[i];
        }
        if (start != null || end != null) {
            if (start == null) start = 0;
            if (end == null) end = plainText.length;
            plainText = plainText.substring(start, end);
        }
        return plainText;
    }
    getPenManager(text, retPenManager) {
        if (text === undefined) return this.copyPenManager(retPenManager, this.penManager);
        if (retPenManager === undefined) retPenManager = this.newPenManager();
        var defaultStyle = this.defaultStyle;
        this.updatePenManager(text, defaultStyle.wrapMode, defaultStyle.wrapWidth, defaultStyle.lineHeight, retPenManager);
        return retPenManager;
    }
    getText(text, start, end, wrap) {
        if (text == null) return this.penManager.getSliceTagText(start, end, wrap);
        var penManager = this.tmpPenManager;
        var defaultStyle = this.defaultStyle;
        this.updatePenManager(text, defaultStyle.wrapMode, defaultStyle.wrapWidth, defaultStyle.lineHeight, penManager);
        return penManager.getSliceTagText(start, end, wrap);
    }
    copyPenManager(ret, src) {
        if (src === undefined) src = this.penManager;
        return src.copy(ret);
    }
    getTextWidth(penManager) {
        if (penManager === undefined) penManager = this.penManager;
        return penManager.getMaxLineWidth();
    }
    getLastPen(penManager) {
        if (penManager === undefined) penManager = this.penManager;
        return penManager.lastPen;
    }
}
var $74b1eae8d330bcdd$var$methods = {
    setInteractive: (0, $c6d122c031e37e3c$export$2e2bcd8739ae039)
};
Object.assign($74b1eae8d330bcdd$var$CanvasText.prototype, (0, $fdf0aeb815b7cd93$export$2e2bcd8739ae039), $74b1eae8d330bcdd$var$methods);
var $74b1eae8d330bcdd$export$2e2bcd8739ae039 = $74b1eae8d330bcdd$var$CanvasText;




class $c41f336502acd1f4$var$WrapTextLinesPool extends (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039) {
    freeLine(line) {
        if (!line) return;
        this.push(line);
        return this;
    }
    freeLines(lines) {
        if (!lines) return;
        this.pushMultiple(lines);
        return this;
    }
    getLine(text, width, newLineMode) {
        var l = this.pop();
        if (l === null) l = {};
        l.text = text;
        l.width = width;
        l.newLineMode = newLineMode;
        return l;
    }
}
var $c41f336502acd1f4$export$2e2bcd8739ae039 = $c41f336502acd1f4$var$WrapTextLinesPool;



const $11fdcb0779bf6728$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $11fdcb0779bf6728$var$GetValue = Phaser.Utils.Objects.GetValue;
var $11fdcb0779bf6728$var$AddImage = function(key, config) {
    if ($11fdcb0779bf6728$var$IsPlainObject(key)) {
        config = key;
        key = config.key;
    } else if (config === undefined) config = {
        key: key
    };
    if (!config.hasOwnProperty("key")) config.key = key;
    var textureKey = config.key, frameKey = config.frame;
    var width = config.width, height = config.height;
    if (width === undefined || height === undefined) {
        var frame = this.textureManager.getFrame(textureKey, frameKey);
        var frameWidth = frame ? frame.cutWidth : 0;
        var frameHeight = frame ? frame.cutHeight : 0;
        if (width === undefined && height === undefined) {
            width = frameWidth;
            height = frameHeight;
        } else if (width === undefined) width = frameWidth * (height / frameHeight);
        else if (height === undefined) height = frameHeight * (width / frameWidth);
    }
    this.images[key] = {
        key: textureKey,
        frame: frameKey,
        width: width,
        height: height,
        y: $11fdcb0779bf6728$var$GetValue(config, "y", 0),
        left: $11fdcb0779bf6728$var$GetValue(config, "left", 0),
        right: $11fdcb0779bf6728$var$GetValue(config, "right", 0),
        originX: $11fdcb0779bf6728$var$GetValue(config, "originX", 0),
        originY: $11fdcb0779bf6728$var$GetValue(config, "originY", 0)
    };
};
var $11fdcb0779bf6728$export$2e2bcd8739ae039 = $11fdcb0779bf6728$var$AddImage;


var $9ad34907b2c185c1$var$DrawImage = function(key, context, x, y, autoRound) {
    var imgData = this.get(key);
    var frame = this.textureManager.getFrame(imgData.key, imgData.frame);
    var width = imgData.width, height = imgData.height;
    x += imgData.left - imgData.originX * width;
    y += imgData.y - imgData.originY * height;
    if (autoRound) {
        x = Math.round(x);
        y = Math.round(y);
    }
    context.drawImage(frame.source.image, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, x, y, width, height);
};
var $9ad34907b2c185c1$export$2e2bcd8739ae039 = $9ad34907b2c185c1$var$DrawImage;


class $d45b470a96528418$var$ImageManager {
    constructor(scene){
        this.textureManager = scene.sys.textures;
        this.images = {};
    }
    destroy() {
        this.textureManager = undefined;
        this.images = undefined;
    }
    add(key, config) {
        if (typeof key === "string") (0, $11fdcb0779bf6728$export$2e2bcd8739ae039).call(this, key, config);
        else if (Array.isArray(key)) {
            var data = key;
            for(var i = 0, cnt = data.length; i < cnt; i++)(0, $11fdcb0779bf6728$export$2e2bcd8739ae039).call(this, data[i]);
        } else {
            var data = key;
            for(var key in data)(0, $11fdcb0779bf6728$export$2e2bcd8739ae039).call(this, key, data[key]);
        }
        return this;
    }
    has(key) {
        return this.images.hasOwnProperty(key);
    }
    remove(key) {
        if (this.has(key)) delete this.images[key];
        return this;
    }
    get(key) {
        if (!this.has(key)) {
            if (this.textureManager.exists(key)) this.add(key);
        }
        return this.images[key];
    }
    getOuterWidth(key) {
        var data = this.get(key);
        return data ? data.width + data.left + data.right : 0;
    }
    getFrame(key) {
        var data = this.get(key);
        return data ? this.textureManager.getFrame(data.key, data.frame) : undefined;
    }
    hasTexture(key) {
        return !!this.getFrame(key);
    }
}
var $d45b470a96528418$var$methods = {
    draw: (0, $9ad34907b2c185c1$export$2e2bcd8739ae039)
};
Object.assign($d45b470a96528418$var$ImageManager.prototype, $d45b470a96528418$var$methods);
var $d45b470a96528418$export$2e2bcd8739ae039 = $d45b470a96528418$var$ImageManager;



const $906d9cf89196472a$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $906d9cf89196472a$var$AddToDOM = Phaser.DOM.AddToDOM;
const $906d9cf89196472a$var$CanvasPool = Phaser.Display.Canvas.CanvasPool;
const $906d9cf89196472a$var$GameObject = Phaser.GameObjects.GameObject;
const $906d9cf89196472a$var$GetValue = Phaser.Utils.Objects.GetValue;
const $906d9cf89196472a$var$RemoveFromDOM = Phaser.DOM.RemoveFromDOM;
const $906d9cf89196472a$var$SPLITREGEXP = (0, $85f77e4ecbc486f7$export$2e2bcd8739ae039).SPLITREGEXP;
// Reuse objects can increase performance
var $906d9cf89196472a$var$SharedPensPools = null;
var $906d9cf89196472a$var$SharedLinesPool = null;
var $906d9cf89196472a$var$SharedWrapTextLinesPool = null;
class $906d9cf89196472a$var$Text extends (0, $ecf8c20979c10435$export$2e2bcd8739ae039) {
    constructor(scene, x, y, text, style, type, parser){
        if ($906d9cf89196472a$var$IsPlainObject(x)) {
            var config = x;
            x = $906d9cf89196472a$var$GetValue(config, "x", 0);
            y = $906d9cf89196472a$var$GetValue(config, "y", 0);
            text = $906d9cf89196472a$var$GetValue(config, "text", "");
            style = $906d9cf89196472a$var$GetValue(config, "style");
        }
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        super(scene, type);
        this.renderer = scene.sys.game.renderer;
        this.setPosition(x, y);
        this.setOrigin(0, 0);
        this.initPipeline();
        this.canvas = $906d9cf89196472a$var$CanvasPool.create(this);
        this.context = this.canvas.getContext("2d", {
            willReadFrequently: true
        });
        this._imageManager = undefined;
        if (style) {
            // Override align
            if (style.hasOwnProperty("align")) {
                var halign = style.align;
                delete style.align;
                style.halign = halign;
            }
            // Has Stroke color but stroke thinkness, set stroke thinkness to 1
            if (style.hasOwnProperty("stroke") && !style.hasOwnProperty("strokeThickness")) style.strokeThickness = 1;
        }
        this.style = new (0, $c4330fa75cd41892$export$2e2bcd8739ae039)(this, style);
        var imageData = $906d9cf89196472a$var$GetValue(style, "images", undefined);
        if (imageData) this.addImage(imageData);
        this.autoRound = true;
        this._text = undefined;
        this.padding = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.width = 1;
        this.height = 1;
        this.dirty = false;
        //  If resolution wasn't set, force it to 1
        if (this.style.resolution === 0) this.style.resolution = 1;
        this._crop = this.resetCropObject();
        //  Create a Texture for this Text object
        this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
        //  Get the frame
        this.frame = this.texture.get();
        //  Set the resolution
        this.frame.source.resolution = this.style.resolution;
        if (this.renderer && this.renderer.gl) {
            //  Clear the default 1x1 glTexture, as we override it later
            this.renderer.deleteTexture(this.frame.source.glTexture);
            this.frame.source.glTexture = null;
        }
        var sharedPoolMode = $906d9cf89196472a$var$GetValue(style, "sharedPool", true);
        var pensPool, linesPool, wrapTextLinesPool;
        if (sharedPoolMode) {
            // Use pools first time
            if (!$906d9cf89196472a$var$SharedPensPools) {
                $906d9cf89196472a$var$SharedPensPools = {};
                $906d9cf89196472a$var$SharedLinesPool = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
                $906d9cf89196472a$var$SharedWrapTextLinesPool = new (0, $c41f336502acd1f4$export$2e2bcd8739ae039)();
                // Remove cached data
                this.scene.game.events.once("destroy", function() {
                    $906d9cf89196472a$var$SharedPensPools = null;
                    $906d9cf89196472a$var$SharedLinesPool = null;
                    $906d9cf89196472a$var$SharedWrapTextLinesPool = null;
                });
            }
            if (!$906d9cf89196472a$var$SharedPensPools.hasOwnProperty(type)) $906d9cf89196472a$var$SharedPensPools[type] = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
            pensPool = $906d9cf89196472a$var$SharedPensPools[type];
            linesPool = $906d9cf89196472a$var$SharedLinesPool;
            wrapTextLinesPool = $906d9cf89196472a$var$SharedWrapTextLinesPool;
        } else {
            pensPool = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
            linesPool = new (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039)();
            wrapTextLinesPool = new (0, $c41f336502acd1f4$export$2e2bcd8739ae039)();
        }
        this.canvasText = new (0, $74b1eae8d330bcdd$export$2e2bcd8739ae039)({
            parent: this,
            context: this.context,
            parser: parser,
            style: this.style,
            pensPool: pensPool,
            linesPool: linesPool,
            wrapTextLinesPool: wrapTextLinesPool
        });
        this.parser = parser;
        this.initRTL();
        if (style && style.padding) this.setPadding(style.padding);
        this.setText(text);
        this.setUrlTagCursorStyle($906d9cf89196472a$var$GetValue(style, "urlTagCursorStyle", "pointer"));
        if ($906d9cf89196472a$var$GetValue(style, "interactive", false)) this.setInteractive();
    }
    preDestroy() {
        if (this.style.rtl) $906d9cf89196472a$var$RemoveFromDOM(this.canvas);
        this.canvasText.destroy();
        this.canvasText = undefined;
        if (this._imageManager) {
            this._imageManager.destroy();
            this._imageManager = undefined;
        }
        $906d9cf89196472a$var$CanvasPool.remove(this.canvas);
        this.texture.destroy();
    }
    set text(value) {
        this.setText(value);
    }
    get text() {
        return this._text;
    }
    initRTL() {
        if (!this.style.rtl) return;
        //  Here is where the crazy starts.
        //
        //  Due to browser implementation issues, you cannot fillText BiDi text to a canvas
        //  that is not part of the DOM. It just completely ignores the direction property.
        this.canvas.dir = "rtl";
        //  Experimental atm, but one day ...
        this.context.direction = "rtl";
        //  Add it to the DOM, but hidden within the parent canvas.
        this.canvas.style.display = "none";
        $906d9cf89196472a$var$AddToDOM(this.canvas, this.scene.sys.canvas);
        //  And finally we set the x origin
        this.originX = 1;
    }
    setText(value) {
        if (value == null) value = "";
        else if (Array.isArray(value)) value = value.join("\n");
        else value = value.toString();
        if (value === this._text) return this;
        this._text = value;
        this.updateText();
        return this;
    }
    appendText(value) {
        if (value == null) return this;
        if (Array.isArray(value)) value = value.join("\n");
        this.setText(this.text + value.toString());
        return this;
    }
    setPadding(left, top, right, bottom) {
        if (typeof left === "object") {
            var config = left;
            //  If they specify x and/or y this applies to all
            var x = $906d9cf89196472a$var$GetValue(config, "x", null);
            if (x !== null) {
                left = x;
                right = x;
            } else {
                left = $906d9cf89196472a$var$GetValue(config, "left", 0);
                right = $906d9cf89196472a$var$GetValue(config, "right", left);
            }
            var y = $906d9cf89196472a$var$GetValue(config, "y", null);
            if (y !== null) {
                top = y;
                bottom = y;
            } else {
                top = $906d9cf89196472a$var$GetValue(config, "top", 0);
                bottom = $906d9cf89196472a$var$GetValue(config, "bottom", top);
            }
        } else {
            if (left === undefined) left = 0;
            if (top === undefined) top = left;
            if (right === undefined) right = left;
            if (bottom === undefined) bottom = top;
        }
        this.padding.left = left;
        this.padding.top = top;
        this.padding.right = right;
        this.padding.bottom = bottom;
        return this.updateText(false);
    }
    updateText(runWrap) {
        if (runWrap === undefined) runWrap = true;
        var canvasText = this.canvasText;
        // wrap text to pens
        var style = this.style;
        if (runWrap) canvasText.updatePenManager(this._text, style.wrapMode, style.wrapWidth, style.lineHeight);
        // resize
        var padding = this.padding;
        var textWidth, textHeight;
        var linesWidth = Math.ceil(canvasText.linesWidth);
        if (style.fixedWidth === 0) {
            this.width = linesWidth + padding.left + padding.right;
            textWidth = linesWidth;
        } else {
            this.width = style.fixedWidth;
            textWidth = this.width - padding.left - padding.right;
            if (textWidth < linesWidth) textWidth = linesWidth;
        }
        if (style.fixedHeight === 0) {
            this.height = canvasText.linesHeight + padding.top + padding.bottom;
            textHeight = canvasText.linesHeight;
        } else {
            this.height = style.fixedHeight;
            textHeight = this.height - padding.top - padding.bottom;
            if (textHeight < canvasText.linesHeight) textHeight = canvasText.linesHeight;
        }
        var w = this.width;
        var h = this.height;
        this.updateDisplayOrigin();
        var resolution = style.resolution;
        w *= resolution;
        h *= resolution;
        w = Math.max(Math.ceil(w), 1);
        h = Math.max(Math.ceil(h), 1);
        var canvas = this.canvas;
        var context = this.context;
        if (canvas.width !== w || canvas.height !== h) {
            canvas.width = w;
            canvas.height = h;
            this.frame.setSize(w, h);
        } else context.clearRect(0, 0, w, h);
        context.save();
        context.scale(resolution, resolution);
        // draw
        var startX = !this.style.rtl ? padding.left : padding.right;
        var startY = padding.top;
        canvasText.draw(startX, startY, textWidth, textHeight);
        context.restore();
        if (this.renderer && this.renderer.gl) {
            this.frame.source.glTexture = this.renderer.canvasToTexture(canvas, this.frame.source.glTexture, true);
            this.frame.glTexture = this.frame.source.glTexture;
        }
        this.dirty = true;
        var input = this.input;
        if (input && !input.customHitArea) {
            input.hitArea.width = this.width;
            input.hitArea.height = this.height;
        }
        return this;
    }
    toJSON() {
        var out = Components.ToJSON(this);
        //  Extra Text data is added here
        var data = {
            autoRound: this.autoRound,
            text: this._text,
            style: this.style.toJSON(),
            resolution: this.resolution,
            padding: {
                left: this.padding.left,
                right: this.padding.right,
                top: this.padding.top,
                bottom: this.padding.bottom
            }
        };
        out.data = data;
        return out;
    }
    setInteractive(hitArea, hitAreaCallback, dropZone) {
        var isInteractived = !!this.input;
        $906d9cf89196472a$var$GameObject.prototype.setInteractive.call(this, hitArea, hitAreaCallback, dropZone);
        if (!isInteractived) this.canvasText.setInteractive();
        return this;
    }
    setUrlTagCursorStyle(cursor) {
        this.urlTagCursorStyle = cursor;
        return this;
    }
    get urlTagCursorStyle() {
        return this.canvasText.urlTagCursorStyle;
    }
    set urlTagCursorStyle(value) {
        this.canvasText.urlTagCursorStyle = value;
    }
    getWrappedText(text, start, end) {
        text = this.canvasText.getText(text, start, end, true);
        return text.split($906d9cf89196472a$var$SPLITREGEXP);
    }
    getPlainText(text, start, end) {
        return this.canvasText.getPlainText(text, start, end);
    }
    getText(text, start, end, wrap) {
        if (wrap === undefined) wrap = false;
        return this.canvasText.getText(text, start, end, wrap);
    }
    getSubString(text, start, end) {
        return this.getText(text, start, end);
    }
    copyPenManager(penManager) {
        return this.canvasText.copyPenManager(penManager);
    }
    getPenManager(text, penManager) {
        return this.canvasText.getPenManager(text, penManager);
    }
    setSize(width, height) {
        return this.setFixedSize(width, height);
    }
    resize(width, height) {
        return this.setFixedSize(width, height);
    }
    get imageManager() {
        if (!this._imageManager) this._imageManager = new (0, $d45b470a96528418$export$2e2bcd8739ae039)(this.scene);
        return this._imageManager;
    }
    addImage(key, config) {
        this.imageManager.add(key, config);
        return this;
    }
    drawAreaBounds(graphics, color) {
        this.canvasText.hitAreaManager.drawBounds(graphics, color, this);
        return this;
    }
    generateTexture(key, x, y, width, height) {
        var srcCanvas = this.canvas;
        if (width === undefined) width = srcCanvas.width;
        else width *= this.resolution;
        if (height === undefined) height = srcCanvas.height;
        else height *= this.resolution;
        (0, $54458364436c144b$export$2e2bcd8739ae039)(this.scene, srcCanvas, key, x, y, width, height);
        return this;
    }
}
var $906d9cf89196472a$export$2e2bcd8739ae039 = $906d9cf89196472a$var$Text;


var $517b23c54a53d4e7$export$b3a453a73a170878 = function(tagName, param) {
    if (param === undefined) return `\\[${tagName}\\]`;
    else return `\\[${tagName}=(${param})\\]`;
};
var $517b23c54a53d4e7$export$a13557f290b60b43 = function(tagName) {
    return `\\[\/${tagName}\\]`;
};
const $517b23c54a53d4e7$export$a0914041aedb1184 = "[-.0-9]+";
const $517b23c54a53d4e7$export$b37872d86e0e2eaf = "[a-z]+|#[0-9abcdef]+";
const $517b23c54a53d4e7$export$90bbb87c420d2b6b = "[^\\]]+";
const $517b23c54a53d4e7$var$ESC = "esc";
const $517b23c54a53d4e7$var$ESC_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$ESC);
const $517b23c54a53d4e7$var$ESC_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$ESC);
const $517b23c54a53d4e7$var$RAW = "raw";
const $517b23c54a53d4e7$var$RAW_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$RAW);
const $517b23c54a53d4e7$var$RAW_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$RAW);
const $517b23c54a53d4e7$var$BLOD = "b";
const $517b23c54a53d4e7$var$BLOD_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$BLOD);
const $517b23c54a53d4e7$var$BLOD_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$BLOD);
const $517b23c54a53d4e7$var$ITALICS = "i";
const $517b23c54a53d4e7$var$ITALICS_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$ITALICS);
const $517b23c54a53d4e7$var$ITALICS_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$ITALICS);
const $517b23c54a53d4e7$var$WEIGHT = "weight";
const $517b23c54a53d4e7$var$WEIGHT_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$WEIGHT, $517b23c54a53d4e7$export$a0914041aedb1184);
const $517b23c54a53d4e7$var$WEIGHT_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$WEIGHT);
const $517b23c54a53d4e7$var$SIZE = "size";
const $517b23c54a53d4e7$var$SIZE_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$SIZE, $517b23c54a53d4e7$export$a0914041aedb1184);
const $517b23c54a53d4e7$var$SIZE_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$SIZE);
const $517b23c54a53d4e7$var$COLOR = "color";
const $517b23c54a53d4e7$var$COLOR_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$COLOR, $517b23c54a53d4e7$export$b37872d86e0e2eaf);
const $517b23c54a53d4e7$var$COLOR_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$COLOR);
const $517b23c54a53d4e7$var$UNDERLINE = "u";
const $517b23c54a53d4e7$var$UNDERLINE_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$UNDERLINE);
const $517b23c54a53d4e7$var$UNDERLINE_OPENC = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$UNDERLINE, $517b23c54a53d4e7$export$b37872d86e0e2eaf);
const $517b23c54a53d4e7$var$UNDERLINE_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$UNDERLINE);
const $517b23c54a53d4e7$var$SHADOW = "shadow";
const $517b23c54a53d4e7$var$SHADOW_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$SHADOW);
const $517b23c54a53d4e7$var$SHADOW_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$SHADOW);
const $517b23c54a53d4e7$var$STROKE = "stroke";
const $517b23c54a53d4e7$var$STROKE_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$STROKE);
const $517b23c54a53d4e7$var$STROKE_OPENC = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$STROKE, $517b23c54a53d4e7$export$b37872d86e0e2eaf);
const $517b23c54a53d4e7$var$STROKE_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$STROKE);
const $517b23c54a53d4e7$var$OFFSETY = "y";
const $517b23c54a53d4e7$var$OFFSETY_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$OFFSETY, $517b23c54a53d4e7$export$a0914041aedb1184);
const $517b23c54a53d4e7$var$OFFSETY_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$OFFSETY);
const $517b23c54a53d4e7$var$IMAGE = "img";
const $517b23c54a53d4e7$var$IMAGE_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$IMAGE, $517b23c54a53d4e7$export$90bbb87c420d2b6b);
const $517b23c54a53d4e7$var$IMAGE_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$IMAGE);
const $517b23c54a53d4e7$var$AREA = "area";
const $517b23c54a53d4e7$var$AREA_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$AREA, $517b23c54a53d4e7$export$90bbb87c420d2b6b);
const $517b23c54a53d4e7$var$AREA_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$AREA);
const $517b23c54a53d4e7$var$URL = "url";
const $517b23c54a53d4e7$var$URL_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$URL, $517b23c54a53d4e7$export$90bbb87c420d2b6b);
const $517b23c54a53d4e7$var$URL_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$URL);
const $517b23c54a53d4e7$var$ALIGN = "align";
const $517b23c54a53d4e7$var$ALIGN_OPEN = $517b23c54a53d4e7$export$b3a453a73a170878($517b23c54a53d4e7$var$ALIGN, $517b23c54a53d4e7$export$90bbb87c420d2b6b);
const $517b23c54a53d4e7$var$ALIGN_CLOSE = $517b23c54a53d4e7$export$a13557f290b60b43($517b23c54a53d4e7$var$ALIGN);
const $517b23c54a53d4e7$export$3a25b2efffb52460 = new RegExp($517b23c54a53d4e7$var$ESC_OPEN, "i");
const $517b23c54a53d4e7$export$b361abc3e5fb4765 = new RegExp($517b23c54a53d4e7$var$ESC_CLOSE, "i");
const $517b23c54a53d4e7$export$3f0509716be543c = new RegExp($517b23c54a53d4e7$var$RAW_OPEN, "i");
const $517b23c54a53d4e7$export$f9d188b996795224 = new RegExp($517b23c54a53d4e7$var$RAW_CLOSE, "i");
const $517b23c54a53d4e7$export$f8dd6b3a302a5922 = new RegExp($517b23c54a53d4e7$var$BLOD_OPEN, "i");
const $517b23c54a53d4e7$export$2e192cbbe37d35cb = new RegExp($517b23c54a53d4e7$var$BLOD_CLOSE, "i");
const $517b23c54a53d4e7$export$af73528bb48eb4a1 = new RegExp($517b23c54a53d4e7$var$ITALICS_OPEN, "i");
const $517b23c54a53d4e7$export$6cd82a3358e5b0c5 = new RegExp($517b23c54a53d4e7$var$ITALICS_CLOSE, "i");
const $517b23c54a53d4e7$export$a9a43e78eec43d60 = new RegExp($517b23c54a53d4e7$var$WEIGHT_OPEN, "i");
const $517b23c54a53d4e7$export$3b005ef8e9946a9c = new RegExp($517b23c54a53d4e7$var$WEIGHT_CLOSE, "i");
const $517b23c54a53d4e7$export$636bf0f9b2ecf6f8 = new RegExp($517b23c54a53d4e7$var$SIZE_OPEN, "i");
const $517b23c54a53d4e7$export$fb5dcd0f2f7f8c22 = new RegExp($517b23c54a53d4e7$var$SIZE_CLOSE, "i");
const $517b23c54a53d4e7$export$73f25d97dde46767 = new RegExp($517b23c54a53d4e7$var$COLOR_OPEN, "i");
const $517b23c54a53d4e7$export$a694bdd63bcda793 = new RegExp($517b23c54a53d4e7$var$COLOR_CLOSE, "i");
const $517b23c54a53d4e7$export$634625aafae50ce7 = new RegExp($517b23c54a53d4e7$var$UNDERLINE_OPEN, "i");
const $517b23c54a53d4e7$export$676abff8cb99a42f = new RegExp($517b23c54a53d4e7$var$UNDERLINE_OPENC, "i");
const $517b23c54a53d4e7$export$74b258e94e7cb093 = new RegExp($517b23c54a53d4e7$var$UNDERLINE_CLOSE, "i");
const $517b23c54a53d4e7$export$55be400fdd4dfb79 = new RegExp($517b23c54a53d4e7$var$SHADOW_OPEN, "i");
const $517b23c54a53d4e7$export$c18ef6bb13f29edf = new RegExp($517b23c54a53d4e7$var$SHADOW_CLOSE, "i");
const $517b23c54a53d4e7$export$52350638dce54626 = new RegExp($517b23c54a53d4e7$var$STROKE_OPEN, "i");
const $517b23c54a53d4e7$export$197d2726e3ab50b1 = new RegExp($517b23c54a53d4e7$var$STROKE_OPENC, "i");
const $517b23c54a53d4e7$export$48304fe7e2e60fd8 = new RegExp($517b23c54a53d4e7$var$STROKE_CLOSE, "i");
const $517b23c54a53d4e7$export$5f9bf77c6e93b7e7 = new RegExp($517b23c54a53d4e7$var$OFFSETY_OPEN, "i");
const $517b23c54a53d4e7$export$ac83a17e14b20fb3 = new RegExp($517b23c54a53d4e7$var$OFFSETY_CLOSE, "i");
const $517b23c54a53d4e7$export$d02f6a7559b8984d = new RegExp($517b23c54a53d4e7$var$IMAGE_OPEN, "i");
const $517b23c54a53d4e7$export$3fee36f36cdf2350 = new RegExp($517b23c54a53d4e7$var$IMAGE_CLOSE, "i");
const $517b23c54a53d4e7$export$b8cf0bbbbfc5efa2 = new RegExp($517b23c54a53d4e7$var$AREA_OPEN, "i");
const $517b23c54a53d4e7$export$a422261d5d6415c3 = new RegExp($517b23c54a53d4e7$var$AREA_CLOSE, "i");
const $517b23c54a53d4e7$export$b2ac0224d7ea1c4b = new RegExp($517b23c54a53d4e7$var$URL_OPEN, "i");
const $517b23c54a53d4e7$export$385015c140a7724c = new RegExp($517b23c54a53d4e7$var$URL_CLOSE, "i");
const $517b23c54a53d4e7$export$e7523ef1825dc32c = new RegExp($517b23c54a53d4e7$var$ALIGN_OPEN, "i");
const $517b23c54a53d4e7$export$6e358e81752978e6 = new RegExp($517b23c54a53d4e7$var$ALIGN_CLOSE, "i");
const $517b23c54a53d4e7$export$a4541e1b202afec2 = new RegExp([
    $517b23c54a53d4e7$var$RAW_OPEN,
    $517b23c54a53d4e7$var$RAW_CLOSE,
    $517b23c54a53d4e7$var$ESC_OPEN,
    $517b23c54a53d4e7$var$ESC_CLOSE,
    $517b23c54a53d4e7$var$BLOD_OPEN,
    $517b23c54a53d4e7$var$BLOD_CLOSE,
    $517b23c54a53d4e7$var$ITALICS_OPEN,
    $517b23c54a53d4e7$var$ITALICS_CLOSE,
    $517b23c54a53d4e7$var$WEIGHT_OPEN,
    $517b23c54a53d4e7$var$WEIGHT_CLOSE,
    $517b23c54a53d4e7$var$SIZE_OPEN,
    $517b23c54a53d4e7$var$SIZE_CLOSE,
    $517b23c54a53d4e7$var$COLOR_OPEN,
    $517b23c54a53d4e7$var$COLOR_CLOSE,
    $517b23c54a53d4e7$var$UNDERLINE_OPEN,
    $517b23c54a53d4e7$var$UNDERLINE_OPENC,
    $517b23c54a53d4e7$var$UNDERLINE_CLOSE,
    $517b23c54a53d4e7$var$SHADOW_OPEN,
    $517b23c54a53d4e7$var$SHADOW_CLOSE,
    $517b23c54a53d4e7$var$STROKE_OPEN,
    $517b23c54a53d4e7$var$STROKE_OPENC,
    $517b23c54a53d4e7$var$STROKE_CLOSE,
    $517b23c54a53d4e7$var$OFFSETY_OPEN,
    $517b23c54a53d4e7$var$OFFSETY_CLOSE,
    $517b23c54a53d4e7$var$IMAGE_OPEN,
    $517b23c54a53d4e7$var$IMAGE_CLOSE,
    $517b23c54a53d4e7$var$AREA_OPEN,
    $517b23c54a53d4e7$var$AREA_CLOSE,
    $517b23c54a53d4e7$var$URL_OPEN,
    $517b23c54a53d4e7$var$URL_CLOSE,
    $517b23c54a53d4e7$var$ALIGN_OPEN,
    $517b23c54a53d4e7$var$ALIGN_CLOSE
].join("|"), "ig");


var $3d6795dcf08d8fe0$var$SplitText = function(text, mode) {
    var result = [];
    var charIdx = 0;
    var rawMode = false, escMode = false;
    while(true){
        var regexResult = (0, $517b23c54a53d4e7$export$a4541e1b202afec2).exec(text);
        if (!regexResult) break;
        var match = regexResult[0];
        if (escMode) {
            if ((0, $517b23c54a53d4e7$export$b361abc3e5fb4765).test(match)) escMode = false;
            else continue; // Skip other tags
        } else if (rawMode) {
            if ((0, $517b23c54a53d4e7$export$f9d188b996795224).test(match)) rawMode = false;
            else continue; // Skip other tags
        } else {
            if ((0, $517b23c54a53d4e7$export$3a25b2efffb52460).test(match)) escMode = true;
            else if ((0, $517b23c54a53d4e7$export$3f0509716be543c).test(match)) rawMode = true;
        }
        var matchEnd = (0, $517b23c54a53d4e7$export$a4541e1b202afec2).lastIndex;
        var matchStart = matchEnd - match.length;
        if (charIdx < matchStart) {
            var content = text.substring(charIdx, matchStart);
            result.push(content);
        }
        if (mode === undefined) result.push(match);
        charIdx = matchEnd;
    }
    var totalLen = text.length;
    if (charIdx < totalLen) result.push(text.substring(charIdx, totalLen));
    return result; // [text,...]
};
var $3d6795dcf08d8fe0$export$2e2bcd8739ae039 = $3d6795dcf08d8fe0$var$SplitText;



const $9b2c12a77785ea34$var$PROP_REMOVE = false;
const $9b2c12a77785ea34$var$PROP_ADD = true;
var $9b2c12a77785ea34$var$GETPROP_RESULT = {
    plainText: null,
    prevProp: null
};
var $9b2c12a77785ea34$var$TagTextToProp = function(text, prevProp) {
    // text : result of splitText()
    if (prevProp == null) prevProp = {};
    var plainText = "";
    // close image tag
    if (prevProp.img) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "img");
    if (prevProp.esc) {
        if ((0, $517b23c54a53d4e7$export$b361abc3e5fb4765).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "esc");
        else plainText = text;
    } else if (prevProp.raw) {
        if ((0, $517b23c54a53d4e7$export$f9d188b996795224).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "raw");
        else plainText = text;
    } else {
        if ((0, $517b23c54a53d4e7$export$3a25b2efffb52460).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "esc", true);
        else if ((0, $517b23c54a53d4e7$export$b361abc3e5fb4765).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "esc");
        else if ((0, $517b23c54a53d4e7$export$3f0509716be543c).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "raw", true);
        else if ((0, $517b23c54a53d4e7$export$f9d188b996795224).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "raw");
        else if ((0, $517b23c54a53d4e7$export$f8dd6b3a302a5922).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "b", true);
        else if ((0, $517b23c54a53d4e7$export$2e192cbbe37d35cb).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "b");
        else if ((0, $517b23c54a53d4e7$export$af73528bb48eb4a1).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "i", true);
        else if ((0, $517b23c54a53d4e7$export$6cd82a3358e5b0c5).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "i");
        else if ((0, $517b23c54a53d4e7$export$a9a43e78eec43d60).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$a9a43e78eec43d60));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "weight", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$3b005ef8e9946a9c).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "weight");
        else if ((0, $517b23c54a53d4e7$export$636bf0f9b2ecf6f8).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$636bf0f9b2ecf6f8));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "size", `${innerMatch[1]}px`);
        } else if ((0, $517b23c54a53d4e7$export$fb5dcd0f2f7f8c22).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "size");
        else if ((0, $517b23c54a53d4e7$export$73f25d97dde46767).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$73f25d97dde46767));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "color", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$a694bdd63bcda793).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "color");
        else if ((0, $517b23c54a53d4e7$export$634625aafae50ce7).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "u", true);
        else if ((0, $517b23c54a53d4e7$export$676abff8cb99a42f).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$676abff8cb99a42f));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "u", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$74b258e94e7cb093).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "u");
        else if ((0, $517b23c54a53d4e7$export$55be400fdd4dfb79).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "shadow", true);
        else if ((0, $517b23c54a53d4e7$export$c18ef6bb13f29edf).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "shadow");
        else if ((0, $517b23c54a53d4e7$export$52350638dce54626).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "stroke", true);
        else if ((0, $517b23c54a53d4e7$export$197d2726e3ab50b1).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$197d2726e3ab50b1));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "stroke", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$48304fe7e2e60fd8).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "stroke");
        else if ((0, $517b23c54a53d4e7$export$5f9bf77c6e93b7e7).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$5f9bf77c6e93b7e7));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "y", parseFloat(innerMatch[1]));
        } else if ((0, $517b23c54a53d4e7$export$ac83a17e14b20fb3).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "y");
        else if ((0, $517b23c54a53d4e7$export$d02f6a7559b8984d).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$d02f6a7559b8984d));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "img", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$3fee36f36cdf2350).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "img");
        else if ((0, $517b23c54a53d4e7$export$b8cf0bbbbfc5efa2).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$b8cf0bbbbfc5efa2));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "area", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$a422261d5d6415c3).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "area");
        else if ((0, $517b23c54a53d4e7$export$b2ac0224d7ea1c4b).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$b2ac0224d7ea1c4b));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "url", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$385015c140a7724c).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "url");
        else if ((0, $517b23c54a53d4e7$export$e7523ef1825dc32c).test(text)) {
            var innerMatch = text.match((0, $517b23c54a53d4e7$export$e7523ef1825dc32c));
            $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_ADD, "align", innerMatch[1]);
        } else if ((0, $517b23c54a53d4e7$export$6e358e81752978e6).test(text)) $9b2c12a77785ea34$var$UpdateProp(prevProp, $9b2c12a77785ea34$var$PROP_REMOVE, "align");
        else plainText = text;
    }
    var result = $9b2c12a77785ea34$var$GETPROP_RESULT;
    result.plainText = plainText;
    result.prop = prevProp;
    return result;
};
var $9b2c12a77785ea34$var$UpdateProp = function(prop, op, key, value) {
    if (op === $9b2c12a77785ea34$var$PROP_ADD) // PROP_ADD     
    prop[key] = value;
    else // PROP_REMOVE        
    if (prop.hasOwnProperty(key)) delete prop[key];
    return prop;
};
var $9b2c12a77785ea34$export$2e2bcd8739ae039 = $9b2c12a77785ea34$var$TagTextToProp;



var $e305658aca8ab94f$var$PropToContextStyle = function(defaultStyle, prop) {
    var result = $e305658aca8ab94f$var$STYLE_RESULT;
    if (!prop.hasOwnProperty("img")) {
        result.image = null;
        if (prop.hasOwnProperty("family")) result.fontFamily = prop.family;
        else result.fontFamily = defaultStyle.fontFamily;
        if (prop.hasOwnProperty("size")) {
            var size = prop.size;
            if (typeof size === "number") size = `${size}px`;
            result.fontSize = size;
        } else result.fontSize = defaultStyle.fontSize;
        result.fontStyle = $e305658aca8ab94f$var$GetFontStyle(prop);
        if (prop.hasOwnProperty("color")) result.color = prop.color;
        else result.color = defaultStyle.color;
        if (prop.hasOwnProperty("stroke")) {
            if (prop.stroke === true) {
                result.stroke = defaultStyle.stroke;
                result.strokeThickness = defaultStyle.strokeThickness;
            } else {
                result.stroke = prop.stroke;
                result.strokeThickness = defaultStyle.strokeThickness;
            }
        } else {
            result.stroke = defaultStyle.stroke;
            result.strokeThickness = 0;
        }
    } else result.image = prop.img;
    if (prop.hasOwnProperty("shadow")) {
        if (prop.shadow === true) {
            result.shadowColor = defaultStyle.shadowColor;
            result.shadowOffsetX = defaultStyle.shadowOffsetX;
            result.shadowOffsetY = defaultStyle.shadowOffsetY;
            result.shadowBlur = defaultStyle.shadowBlur;
            result.shadowStroke = true;
            result.shadowFill = true;
        } else {
            result.shadowColor = prop.shadow;
            result.shadowOffsetX = defaultStyle.shadowOffsetX;
            result.shadowOffsetY = defaultStyle.shadowOffsetY;
            result.shadowBlur = defaultStyle.shadowBlur;
            result.shadowStroke = true;
            result.shadowFill = true;
        }
    } else {
        result.shadowColor = "#000";
        result.shadowOffsetX = 0;
        result.shadowOffsetY = 0;
        result.shadowBlur = 0;
        result.shadowStroke = false;
        result.shadowFill = false;
    }
    if (prop.hasOwnProperty("u")) {
        if (prop.u === true) {
            result.underlineColor = defaultStyle.underlineColor;
            result.underlineThickness = defaultStyle.underlineThickness;
            result.underlineOffset = defaultStyle.underlineOffset;
        } else {
            result.underlineColor = prop.u;
            result.underlineThickness = defaultStyle.underlineThickness;
            result.underlineOffset = defaultStyle.underlineOffset;
        }
    } else {
        result.underlineColor = "#000";
        result.underlineThickness = 0;
        result.underlineOffset = 0;
    }
    return result;
};
var $e305658aca8ab94f$var$GetFontStyle = function(prop) {
    var isBold = prop.b;
    var weight = prop.weight;
    var isItalic = prop.i;
    if (isBold || weight || isItalic) {
        if (isItalic) {
            if (isBold) return "bold italic";
            else if (weight) return `${weight} italic`;
            else return "italic";
        } else {
            if (isBold) return "bold";
            else return weight.toString();
        }
    } else return "";
};
var $e305658aca8ab94f$var$STYLE_RESULT = new (0, $c4330fa75cd41892$export$2e2bcd8739ae039)();
var $e305658aca8ab94f$export$2e2bcd8739ae039 = $e305658aca8ab94f$var$PropToContextStyle;


var $251871c8ee1c5595$var$PropToTagText = function(text, prop, prevProp) {
    if (prevProp == null) prevProp = $251871c8ee1c5595$var$EMPTYPROP;
    var headers = [];
    for(var k in prevProp)if (!prop.hasOwnProperty(k)) headers.push(`[/${k}]`);
    for(var k in prop){
        var value = prop[k];
        if (prevProp[k] === value) continue;
        switch(k){
            case "size":
                headers.push(`[size=${value.replace("px", "")}]`);
                break;
            case "color":
            case "weight":
            case "stroke":
            case "y":
            case "img":
            case "area":
            case "url":
            case "align":
                headers.push(`[${k}=${value}]`);
                break;
            case "u":
                if (value === true) headers.push("[u]");
                else headers.push(`[u=${value}]`);
                break;
            default:
                headers.push(`[${k}]`);
                break;
        }
    }
    headers.push(text);
    return headers.join("");
};
var $251871c8ee1c5595$var$EMPTYPROP = {};
var $251871c8ee1c5595$export$2e2bcd8739ae039 = $251871c8ee1c5595$var$PropToTagText;


class $95984e7891ca8802$var$Parser {
    getStrokeThinkness(defaultStyle, prop) {
        var strokeThickness;
        if (prop.hasOwnProperty("stroke")) strokeThickness = defaultStyle.strokeThickness;
        else strokeThickness = 0;
        return strokeThickness;
    }
}
var $95984e7891ca8802$var$methods = {
    splitText: (0, $3d6795dcf08d8fe0$export$2e2bcd8739ae039),
    tagTextToProp: (0, $9b2c12a77785ea34$export$2e2bcd8739ae039),
    propToContextStyle: (0, $e305658aca8ab94f$export$2e2bcd8739ae039),
    propToTagText: (0, $251871c8ee1c5595$export$2e2bcd8739ae039)
};
Object.assign($95984e7891ca8802$var$Parser.prototype, $95984e7891ca8802$var$methods);
var $95984e7891ca8802$export$2e2bcd8739ae039 = $95984e7891ca8802$var$Parser;


class $5a7189c8dd19ee9b$var$BBCodeText extends (0, $906d9cf89196472a$export$2e2bcd8739ae039) {
    constructor(scene, x, y, text, style){
        var parser = new (0, $95984e7891ca8802$export$2e2bcd8739ae039)(style);
        super(scene, x, y, text, style, "rexBBCodeText", parser);
    }
}
var $5a7189c8dd19ee9b$export$2e2bcd8739ae039 = $5a7189c8dd19ee9b$var$BBCodeText;


var $02ef971ba989594a$export$2e2bcd8739ae039 = (0, $5a7189c8dd19ee9b$export$2e2bcd8739ae039);


var $5c78a248668eabc1$export$2e2bcd8739ae039 = (0, $02ef971ba989594a$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("BBCodeText", function(x, y, text, style) {
    var gameObject = new (0, $5c78a248668eabc1$export$2e2bcd8739ae039)(this.scene, x, y, text, style);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.BBCodeText", (0, $5c78a248668eabc1$export$2e2bcd8739ae039));
var $34409c84e2e42750$export$2e2bcd8739ae039 = (0, $5c78a248668eabc1$export$2e2bcd8739ae039);




var $a03161b614152e21$var$GETPROP_RESULT = {
    plainText: null,
    prevProp: null
};
var $a03161b614152e21$var$STYLE_RESULT = new (0, $c4330fa75cd41892$export$2e2bcd8739ae039)();
class $a03161b614152e21$var$Parser {
    constructor(tags){
        if (tags === undefined) tags = {};
        this.tags = tags;
    }
    addTag(name, prop) {
        this.tags[name] = prop;
    }
    getTag(name) {
        return this.tags[name];
    }
    splitText(text, mode) {
        var result = [];
        var charIdx = 0;
        while(true){
            var regexResult = $a03161b614152e21$var$RE_SPLITTEXT.exec(text);
            if (!regexResult) break;
            var match = regexResult[0];
            var matchStart = $a03161b614152e21$var$RE_SPLITTEXT.lastIndex - match.length;
            if (charIdx < matchStart) result.push(text.substring(charIdx, matchStart));
            if (mode === undefined) result.push(match);
            else if (mode === 1) {
                if ($a03161b614152e21$var$RE_CLASS_HEADER.test(match)) {
                    var innerMatch = match.match($a03161b614152e21$var$RE_CLASS);
                    result.push(innerMatch[2]);
                } else if ($a03161b614152e21$var$RE_STYLE_HEADER.test(match)) {
                    var innerMatch = match.match($a03161b614152e21$var$RE_STYLE);
                    result.push(innerMatch[2]);
                }
            }
            charIdx = $a03161b614152e21$var$RE_SPLITTEXT.lastIndex;
        }
        var totalLen = text.length;
        if (charIdx < totalLen) result.push(text.substring(charIdx, totalLen));
        return result; // [text,...]         
    }
    tagTextToProp(text, prevProp) {
        var plainText, propOut;
        if ($a03161b614152e21$var$RE_CLASS_HEADER.test(text)) {
            var innerMatch = text.match($a03161b614152e21$var$RE_CLASS);
            if (innerMatch != null) {
                var name = innerMatch[1];
                var tags = this.tags;
                if (tags.hasOwnProperty(name)) propOut = tags[name];
                else propOut = {};
                propOut._class = name;
                plainText = innerMatch[2];
            }
        } else if ($a03161b614152e21$var$RE_STYLE_HEADER.test(text)) {
            var innerMatch = text.match($a03161b614152e21$var$RE_STYLE);
            if (innerMatch != null) {
                var style = innerMatch[1];
                propOut = $a03161b614152e21$var$StyleToProp(style);
                propOut._style = style;
                plainText = innerMatch[2];
            }
        }
        if (plainText == null) plainText = text;
        if (propOut == null) propOut = {};
        var result = $a03161b614152e21$var$GETPROP_RESULT;
        result.plainText = plainText;
        result.prop = propOut;
        return result;
    }
    propToContextStyle(defaultStyle, prop) {
        var result = $a03161b614152e21$var$STYLE_RESULT;
        if (!prop.hasOwnProperty("img")) {
            result.image = null;
            if (prop.hasOwnProperty("family") || prop.hasOwnProperty("fontFamily") || prop.hasOwnProperty("font-family")) {
                var family = prop.hasOwnProperty("family") ? prop.family : prop.hasOwnProperty("fontFamily") ? prop.fontFamily : prop["font-family"];
                result.fontFamily = family;
            } else result.fontFamily = defaultStyle.fontFamily;
            if (prop.hasOwnProperty("size") || prop.hasOwnProperty("fontSize") || prop.hasOwnProperty("font-size")) {
                var size = prop.hasOwnProperty("size") ? prop.size : prop.hasOwnProperty("fontSize") ? prop.fontSize : prop["font-size"];
                if (typeof size === "number") size = `${size}px`;
                result.fontSize = size;
            } else result.fontSize = defaultStyle.fontSize;
            if (prop.hasOwnProperty("style") || prop.hasOwnProperty("fontStyle") || prop.hasOwnProperty("font-style")) {
                var fontStyle = prop.hasOwnProperty("style") ? prop.style : prop.hasOwnProperty("fontStyle") ? prop.fontStyle : prop["font-style"];
                result.fontStyle = fontStyle;
            } else result.fontStyle = defaultStyle.fontStyle;
            if (prop.hasOwnProperty("color") || prop.hasOwnProperty("font-color")) {
                var color = prop.hasOwnProperty("color") ? prop.color : prop["font-color"];
                result.color = color;
            } else result.color = defaultStyle.color;
            if (prop.hasOwnProperty("stroke")) {
                var stroke = prop.stroke; // {color, thickness}
                result.stroke = stroke.hasOwnProperty("color") ? stroke.color : defaultStyle.stroke;
                result.strokeThickness = stroke.hasOwnProperty("thickness") ? stroke.thickness : defaultStyle.strokeThickness;
            } else {
                result.stroke = defaultStyle.stroke;
                result.strokeThickness = defaultStyle.strokeThickness;
            }
        } else result.image = prop.img;
        if (prop.hasOwnProperty("shadow")) {
            var shadow = prop.shadow; // {color, offsetX, offsetY, blur}
            result.shadowColor = shadow.hasOwnProperty("color") ? shadow.color : defaultStyle.shadowColor;
            result.shadowOffsetX = shadow.hasOwnProperty("offsetX") ? shadow.offsetX : defaultStyle.shadowOffsetX;
            result.shadowOffsetY = shadow.hasOwnProperty("offsetY") ? shadow.offsetY : defaultStyle.shadowOffsetY;
            result.shadowBlur = shadow.hasOwnProperty("blur") ? shadow.blur : defaultStyle.shadowBlur;
            result.shadowStroke = true;
            result.shadowFill = true;
        } else {
            result.shadowColor = defaultStyle.shadowColor;
            result.shadowOffsetX = defaultStyle.shadowOffsetX;
            result.shadowOffsetY = defaultStyle.shadowOffsetY;
            result.shadowBlur = defaultStyle.shadowBlur;
            result.shadowStroke = defaultStyle.shadowStroke;
            result.shadowFill = defaultStyle.shadowFill;
        }
        if (prop.hasOwnProperty("u") || prop.hasOwnProperty("underline")) {
            var u = prop.hasOwnProperty("u") ? prop.u : prop.underline; // {color, thickness, offset}
            result.underlineColor = u.hasOwnProperty("color") ? u.color : defaultStyle.underlineColor;
            result.underlineThickness = u.hasOwnProperty("thickness") ? u.thickness : defaultStyle.underlineThickness;
            result.underlineOffset = u.hasOwnProperty("offset") ? u.offset : defaultStyle.underlineOffset;
        } else {
            result.underlineColor = defaultStyle.underlineColor;
            result.underlineThickness = defaultStyle.underlineThickness;
            result.underlineOffset = defaultStyle.underlineOffset;
        }
        return result;
    }
    getStrokeThinkness(defaultStyle, prop) {
        var strokeThinkness;
        if (prop.hasOwnProperty("stroke")) {
            var stroke = prop.stroke; // {color, thickness}           
            strokeThinkness = stroke.hasOwnProperty("thickness") ? stroke.thickness : defaultStyle.strokeThickness;
        } else strokeThinkness = defaultStyle.strokeThickness;
        return strokeThinkness;
    }
    propToTagText(text, prop, prevProp) {
        if (prop.hasOwnProperty("_class")) {
            if (text === "") {
                if (this.isTextTag(prop._class)) return "";
            }
            return `<class='${prop._class}'>${text}</class>`;
        } else if (prop.hasOwnProperty("_style")) return `<style='${prop._style}'>${text}</style>`;
        else return text;
    }
    destroy() {
        this.tags = undefined;
    }
    isTextTag(tagName) {
        var tag = this.tags[tagName];
        if (tag) return tag.img == null;
        else return false;
    }
}
var $a03161b614152e21$var$StyleToProp = function(s) {
    s = s.split(";");
    var result = {}, prop, k, v;
    for(var i = 0, slen = s.length; i < slen; i++){
        prop = s[i].split(":");
        k = prop[0], v = prop[1];
        if ($a03161b614152e21$var$isEmpty(k) || $a03161b614152e21$var$isEmpty(v)) continue;
        switch(k){
            case "stroke":
                var stroke = v.split(" "); // stroke:blue 1px
                var len = stroke.length;
                v = {};
                if (len >= 1) v.color = stroke[0];
                if (len >= 2) v.thickness = parseInt(stroke[1].replace("px", ""));
                break;
            case "shadow":
                var shadow = v.split(" "); // shadow:blue 2px 2px 2px
                var len = shadow.length;
                v = {};
                if (len >= 1) v.color = shadow[0];
                if (len >= 2) v.offsetX = parseInt(shadow[1].replace("px", ""));
                if (len >= 3) v.offsetY = parseInt(shadow[2].replace("px", ""));
                if (len >= 4) v.blur = parseInt(shadow[3].replace("px", ""));
                break;
            case "u":
            case "underline":
                var u = v.split(" ");
                var len = u.length;
                v = {};
                if (len >= 1) v.color = u[0];
                if (len >= 2) v.thickness = parseInt(u[1].replace("px", ""));
                if (len >= 3) v.offset = parseInt(u[2].replace("px", ""));
                break;
            case "y":
                v = parseFloat(v);
                break;
        }
        result[k] = v;
    }
    return result;
};
var $a03161b614152e21$var$isEmpty = function(s) {
    // Remove white spaces.
    s = s.replace($a03161b614152e21$var$RE_SPACE, "");
    return s.length === 0;
};
var $a03161b614152e21$var$RE_SPLITTEXT = /<\s*class=["|']([^"|']+)["|']\s*\>([\s\S]*?)<\s*\/class\s*\>|<\s*style=["|']([^"|']+)["|']\s*\>([\s\S]*?)<\s*\/style\s*\>/g;
var $a03161b614152e21$var$RE_CLASS_HEADER = /<\s*class=/i;
var $a03161b614152e21$var$RE_CLASS = /<\s*class=["|']([^"|']+)["|']\s*\>([\s\S]*?)<\s*\/class\s*\>/;
var $a03161b614152e21$var$RE_STYLE_HEADER = /<\s*style=/i;
var $a03161b614152e21$var$RE_STYLE = /<\s*style=["|']([^"|']+)["|']\s*\>([\s\S]*?)<\s*\/style\s*\>/;
var $a03161b614152e21$var$RE_SPACE = /^\s+|\s+$/;
var $a03161b614152e21$export$2e2bcd8739ae039 = $a03161b614152e21$var$Parser;


const $5270ca95600a543a$var$GetValue = Phaser.Utils.Objects.GetValue;
class $5270ca95600a543a$var$TagText extends (0, $906d9cf89196472a$export$2e2bcd8739ae039) {
    constructor(scene, x, y, text, style){
        var tags = $5270ca95600a543a$var$GetValue(style, "tags", undefined);
        var parser = new (0, $a03161b614152e21$export$2e2bcd8739ae039)(tags);
        super(scene, x, y, text, style, "rexTagText", parser);
    }
    addTag(name, prop) {
        this.parser.addTag(name, prop);
        return this.updateText(true);
    }
    addTags(tags) {
        for(var name in tags)this.parser.addTag(name, tags[name]);
        return this.updateText(true);
    }
    getTag(name) {
        return this.parser.getTag(name);
    }
    preDestroy() {
        super.preDestroy();
        this.parser.destroy();
        this.parser = undefined;
    }
}
var $5270ca95600a543a$export$2e2bcd8739ae039 = $5270ca95600a543a$var$TagText;


var $44f76db3ab3c5683$export$2e2bcd8739ae039 = (0, $5270ca95600a543a$export$2e2bcd8739ae039);


var $5577e55dcd4894b0$export$2e2bcd8739ae039 = (0, $44f76db3ab3c5683$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("tagText", function(x, y, text, style) {
    var gameObject = new (0, $5577e55dcd4894b0$export$2e2bcd8739ae039)(this.scene, x, y, text, style);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TagText", (0, $5577e55dcd4894b0$export$2e2bcd8739ae039));
var $dfe8776990346f01$export$2e2bcd8739ae039 = (0, $5577e55dcd4894b0$export$2e2bcd8739ae039);



var $5f66a3a3cad0452c$export$2e2bcd8739ae039 = (0, $c7da6d512822e889$export$2e2bcd8739ae039);


var $0a1dceb2e89d5770$export$2e2bcd8739ae039 = (0, $5f66a3a3cad0452c$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("dynamicText", function(x, y, width, height, config) {
    var gameObject = new (0, $0a1dceb2e89d5770$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.DynamicText", (0, $0a1dceb2e89d5770$export$2e2bcd8739ae039));
var $2f9a563bcd4fea6e$export$2e2bcd8739ae039 = (0, $0a1dceb2e89d5770$export$2e2bcd8739ae039);


const $fc3c3469177a1a71$var$SceneClass = Phaser.Scene;
var $fc3c3469177a1a71$var$IsSceneObject = function(object) {
    return object instanceof $fc3c3469177a1a71$var$SceneClass;
};
var $fc3c3469177a1a71$export$2e2bcd8739ae039 = $fc3c3469177a1a71$var$IsSceneObject;


var $98c9a6d564490d18$var$GetSoundManager = function(game) {
    if ((0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(game)) return game.sys.sound;
    return game.sound;
};
var $98c9a6d564490d18$export$2e2bcd8739ae039 = $98c9a6d564490d18$var$GetSoundManager;


var $9df503a375d92377$export$2e2bcd8739ae039 = {
    setEventEmitter (eventEmitter, EventEmitterClass) {
        if (EventEmitterClass === undefined) EventEmitterClass = Phaser.Events.EventEmitter; // Use built-in EventEmitter class by default
        this._privateEE = eventEmitter === true || eventEmitter === undefined;
        this._eventEmitter = this._privateEE ? new EventEmitterClass() : eventEmitter;
        return this;
    },
    destroyEventEmitter () {
        if (this._eventEmitter && this._privateEE) this._eventEmitter.shutdown();
        return this;
    },
    getEventEmitter () {
        return this._eventEmitter;
    },
    on: function() {
        if (this._eventEmitter) this._eventEmitter.on.apply(this._eventEmitter, arguments);
        return this;
    },
    once: function() {
        if (this._eventEmitter) this._eventEmitter.once.apply(this._eventEmitter, arguments);
        return this;
    },
    off: function() {
        if (this._eventEmitter) this._eventEmitter.off.apply(this._eventEmitter, arguments);
        return this;
    },
    emit: function(event) {
        if (this._eventEmitter && event) this._eventEmitter.emit.apply(this._eventEmitter, arguments);
        return this;
    },
    addListener: function() {
        if (this._eventEmitter) this._eventEmitter.addListener.apply(this._eventEmitter, arguments);
        return this;
    },
    removeListener: function() {
        if (this._eventEmitter) this._eventEmitter.removeListener.apply(this._eventEmitter, arguments);
        return this;
    },
    removeAllListeners: function() {
        if (this._eventEmitter) this._eventEmitter.removeAllListeners.apply(this._eventEmitter, arguments);
        return this;
    },
    listenerCount: function() {
        if (this._eventEmitter) return this._eventEmitter.listenerCount.apply(this._eventEmitter, arguments);
        return 0;
    },
    listeners: function() {
        if (this._eventEmitter) return this._eventEmitter.listeners.apply(this._eventEmitter, arguments);
        return [];
    },
    eventNames: function() {
        if (this._eventEmitter) return this._eventEmitter.eventNames.apply(this._eventEmitter, arguments);
        return [];
    }
};



var $a7f896f05814bf38$var$GetSceneObject = function(object) {
    if (object == null || typeof object !== "object") return null;
    else if ((0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(object)) return object;
    else if (object.scene && (0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(object.scene)) return object.scene;
    else if (object.parent && object.parent.scene && (0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(object.parent.scene)) return object.parent.scene;
    else return null;
};
var $a7f896f05814bf38$export$2e2bcd8739ae039 = $a7f896f05814bf38$var$GetSceneObject;


const $ee302ca5c89b9713$var$GameClass = Phaser.Game;
var $ee302ca5c89b9713$var$IsGame = function(object) {
    return object instanceof $ee302ca5c89b9713$var$GameClass;
};
var $ee302ca5c89b9713$export$2e2bcd8739ae039 = $ee302ca5c89b9713$var$IsGame;



var $2e10bcf1e5b86bcf$var$GetGame = function(object) {
    if (object == null || typeof object !== "object") return null;
    else if ((0, $ee302ca5c89b9713$export$2e2bcd8739ae039)(object)) return object;
    else if ((0, $ee302ca5c89b9713$export$2e2bcd8739ae039)(object.game)) return object.game;
    else if ((0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(object)) return object.sys.game;
    else if ((0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(object.scene)) return object.scene.sys.game;
};
var $2e10bcf1e5b86bcf$export$2e2bcd8739ae039 = $2e10bcf1e5b86bcf$var$GetGame;


const $116285784eb8fd63$var$GetValue = Phaser.Utils.Objects.GetValue;
class $116285784eb8fd63$var$ComponentBase {
    constructor(parent, config){
        this.setParent(parent); // gameObject, scene, or game
        this.isShutdown = false;
        // Event emitter, default is private event emitter
        this.setEventEmitter($116285784eb8fd63$var$GetValue(config, "eventEmitter", true));
        // Register callback of parent destroy event, also see `shutdown` method
        if (this.parent) {
            if (this.parent === this.scene) this.scene.sys.events.once("shutdown", this.onEnvDestroy, this);
            else if (this.parent === this.game) this.game.events.once("shutdown", this.onEnvDestroy, this);
            else if (this.parent.once) this.parent.once("destroy", this.onParentDestroy, this);
        // bob object does not have event emitter
        }
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // parent might not be shutdown yet
        if (this.parent) {
            if (this.parent === this.scene) this.scene.sys.events.off("shutdown", this.onEnvDestroy, this);
            else if (this.parent === this.game) this.game.events.off("shutdown", this.onEnvDestroy, this);
            else if (this.parent.once) this.parent.off("destroy", this.onParentDestroy, this);
        // bob object does not have event emitter
        }
        this.destroyEventEmitter();
        this.parent = undefined;
        this.scene = undefined;
        this.game = undefined;
        this.isShutdown = true;
    }
    destroy(fromScene) {
        this.shutdown(fromScene);
    }
    onEnvDestroy() {
        this.destroy(true);
    }
    onParentDestroy(parent, fromScene) {
        this.destroy(fromScene);
    }
    setParent(parent) {
        this.parent = parent; // gameObject, scene, or game
        this.scene = (0, $a7f896f05814bf38$export$2e2bcd8739ae039)(parent);
        this.game = (0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(parent);
        return this;
    }
}
Object.assign($116285784eb8fd63$var$ComponentBase.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039));
var $116285784eb8fd63$export$2e2bcd8739ae039 = $116285784eb8fd63$var$ComponentBase;


const $de3bc6fefe1470a6$var$GetValue = Phaser.Utils.Objects.GetValue;
class $de3bc6fefe1470a6$var$TickTask extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        this._isRunning = false;
        this.isPaused = false;
        this.tickingState = false;
        this.setTickingMode($de3bc6fefe1470a6$var$GetValue(config, "tickingMode", 1));
    // boot() later
    }
    // override
    boot() {
        if (this.tickingMode === 2 && !this.tickingState) this.startTicking();
    }
    // override
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.stop();
        if (this.tickingState) this.stopTicking();
        super.shutdown(fromScene);
    }
    setTickingMode(mode) {
        if (typeof mode === "string") mode = $de3bc6fefe1470a6$var$TICKINGMODE[mode];
        this.tickingMode = mode;
    }
    // override
    startTicking() {
        this.tickingState = true;
    }
    // override
    stopTicking() {
        this.tickingState = false;
    }
    get isRunning() {
        return this._isRunning;
    }
    set isRunning(value) {
        if (this._isRunning === value) return;
        this._isRunning = value;
        if (this.tickingMode === 1 && value != this.tickingState) {
            if (value) this.startTicking();
            else this.stopTicking();
        }
    }
    start() {
        this.isPaused = false;
        this.isRunning = true;
        return this;
    }
    pause() {
        // Only can ba paused in running state
        if (this.isRunning) {
            this.isPaused = true;
            this.isRunning = false;
        }
        return this;
    }
    resume() {
        // Only can ba resumed in paused state (paused from running state)
        if (this.isPaused) this.isRunning = true;
        return this;
    }
    stop() {
        this.isPaused = false;
        this.isRunning = false;
        return this;
    }
    complete() {
        this.isPaused = false;
        this.isRunning = false;
        this.emit("complete", this.parent, this);
    }
}
const $de3bc6fefe1470a6$var$TICKINGMODE = {
    "no": 0,
    "lazy": 1,
    "always": 2
};
var $de3bc6fefe1470a6$export$2e2bcd8739ae039 = $de3bc6fefe1470a6$var$TickTask;


const $a6467920301cebba$var$GetValue = Phaser.Utils.Objects.GetValue;
class $a6467920301cebba$var$SceneUpdateTickTask extends (0, $de3bc6fefe1470a6$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        // scene update : update, preupdate, postupdate, prerender, render
        // game update : step, poststep, 
        // If this.scene is not available, use game's 'step' event
        var defaultEventName = this.scene ? "update" : "step";
        this.tickEventName = $a6467920301cebba$var$GetValue(config, "tickEventName", defaultEventName);
        this.isSceneTicker = !$a6467920301cebba$var$IsGameUpdateEvent(this.tickEventName);
    }
    startTicking() {
        super.startTicking();
        if (this.isSceneTicker) this.scene.sys.events.on(this.tickEventName, this.update, this);
        else this.game.events.on(this.tickEventName, this.update, this);
    }
    stopTicking() {
        super.stopTicking();
        if (this.isSceneTicker && this.scene) this.scene.sys.events.off(this.tickEventName, this.update, this);
        else if (this.game) this.game.events.off(this.tickEventName, this.update, this);
    }
}
var $a6467920301cebba$var$IsGameUpdateEvent = function(eventName) {
    return eventName === "step" || eventName === "poststep";
};
var $a6467920301cebba$export$2e2bcd8739ae039 = $a6467920301cebba$var$SceneUpdateTickTask;


const $db278215acdb3af4$var$GetValue = Phaser.Utils.Objects.GetValue;
const $db278215acdb3af4$var$Clamp = Phaser.Math.Clamp;
class $db278215acdb3af4$var$Timer {
    constructor(config){
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        this.state = $db278215acdb3af4$var$GetValue(o, "state", $db278215acdb3af4$var$IDLE);
        this.timeScale = $db278215acdb3af4$var$GetValue(o, "timeScale", 1);
        this.delay = $db278215acdb3af4$var$GetValue(o, "delay", 0);
        this.repeat = $db278215acdb3af4$var$GetValue(o, "repeat", 0);
        this.repeatCounter = $db278215acdb3af4$var$GetValue(o, "repeatCounter", 0);
        this.repeatDelay = $db278215acdb3af4$var$GetValue(o, "repeatDelay", 0);
        this.duration = $db278215acdb3af4$var$GetValue(o, "duration", 0);
        this.nowTime = $db278215acdb3af4$var$GetValue(o, "nowTime", 0);
        this.justRestart = $db278215acdb3af4$var$GetValue(o, "justRestart", false);
    }
    toJSON() {
        return {
            state: this.state,
            timeScale: this.timeScale,
            delay: this.delay,
            repeat: this.repeat,
            repeatCounter: this.repeatCounter,
            repeatDelay: this.repeatDelay,
            duration: this.duration,
            nowTime: this.nowTime,
            justRestart: this.justRestart
        };
    }
    destroy() {}
    setTimeScale(timeScale) {
        this.timeScale = timeScale;
        return this;
    }
    setDelay(delay) {
        if (delay === undefined) delay = 0;
        this.delay = delay;
        return this;
    }
    setDuration(duration) {
        this.duration = duration;
        return this;
    }
    setRepeat(repeat) {
        this.repeat = repeat;
        return this;
    }
    setRepeatInfinity() {
        this.repeat = -1;
        return this;
    }
    setRepeatDelay(repeatDelay) {
        this.repeatDelay = repeatDelay;
        return this;
    }
    start() {
        this.nowTime = this.delay > 0 ? -this.delay : 0;
        this.state = this.nowTime >= 0 ? $db278215acdb3af4$var$COUNTDOWN : $db278215acdb3af4$var$DELAY;
        this.repeatCounter = 0;
        return this;
    }
    stop() {
        this.state = $db278215acdb3af4$var$IDLE;
        return this;
    }
    update(time, delta) {
        if (this.state === $db278215acdb3af4$var$IDLE || this.state === $db278215acdb3af4$var$DONE || delta === 0 || this.timeScale === 0) return;
        this.nowTime += delta * this.timeScale;
        this.justRestart = false;
        if (this.nowTime >= this.duration) {
            if (this.repeat === -1 || this.repeatCounter < this.repeat) {
                this.repeatCounter++;
                this.justRestart = true;
                this.nowTime -= this.duration;
                if (this.repeatDelay > 0) {
                    this.nowTime -= this.repeatDelay;
                    this.state = $db278215acdb3af4$var$REPEATDELAY;
                }
            } else {
                this.nowTime = this.duration;
                this.state = $db278215acdb3af4$var$DONE;
            }
        } else if (this.nowTime >= 0) this.state = $db278215acdb3af4$var$COUNTDOWN;
    }
    get t() {
        var t;
        switch(this.state){
            case $db278215acdb3af4$var$IDLE:
            case $db278215acdb3af4$var$DELAY:
            case $db278215acdb3af4$var$REPEATDELAY:
                t = 0;
                break;
            case $db278215acdb3af4$var$COUNTDOWN:
                t = this.nowTime / this.duration;
                break;
            case $db278215acdb3af4$var$DONE:
                t = 1;
                break;
        }
        return $db278215acdb3af4$var$Clamp(t, 0, 1);
    }
    set t(value) {
        value = $db278215acdb3af4$var$Clamp(value, -1, 1);
        if (value < 0) {
            this.state = $db278215acdb3af4$var$DELAY;
            this.nowTime = -this.delay * value;
        } else {
            this.state = $db278215acdb3af4$var$COUNTDOWN;
            this.nowTime = this.duration * value;
            if (value === 1 && this.repeat !== 0) this.repeatCounter++;
        }
    }
    setT(t) {
        this.t = t;
        return this;
    }
    get isIdle() {
        return this.state === $db278215acdb3af4$var$IDLE;
    }
    get isDelay() {
        return this.state === $db278215acdb3af4$var$DELAY;
    }
    get isCountDown() {
        return this.state === $db278215acdb3af4$var$COUNTDOWN;
    }
    get isRunning() {
        return this.state === $db278215acdb3af4$var$DELAY || this.state === $db278215acdb3af4$var$COUNTDOWN;
    }
    get isDone() {
        return this.state === $db278215acdb3af4$var$DONE;
    }
    get isOddIteration() {
        return (this.repeatCounter & 1) === 1;
    }
    get isEvenIteration() {
        return (this.repeatCounter & 1) === 0;
    }
}
const $db278215acdb3af4$var$IDLE = 0;
const $db278215acdb3af4$var$DELAY = 1;
const $db278215acdb3af4$var$COUNTDOWN = 2;
const $db278215acdb3af4$var$REPEATDELAY = 3;
const $db278215acdb3af4$var$DONE = -1;
var $db278215acdb3af4$export$2e2bcd8739ae039 = $db278215acdb3af4$var$Timer;


class $0a161b37cd2a445c$var$TimerTickTask extends (0, $a6467920301cebba$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        this.timer = new (0, $db278215acdb3af4$export$2e2bcd8739ae039)();
    // boot() later 
    }
    // override
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        super.shutdown(fromScene);
        this.timer.destroy();
        this.timer = undefined;
    }
    start() {
        this.timer.start();
        super.start();
        return this;
    }
    stop() {
        this.timer.stop();
        super.stop();
        return this;
    }
    complete() {
        this.timer.stop();
        super.complete();
        return this;
    }
}
var $0a161b37cd2a445c$export$2e2bcd8739ae039 = $0a161b37cd2a445c$var$TimerTickTask;


const $ee7bf184597091ca$var$GetValue = Phaser.Utils.Objects.GetValue;
const $ee7bf184597091ca$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $ee7bf184597091ca$var$GetEaseFunction = Phaser.Tweens.Builders.GetEaseFunction;
class $ee7bf184597091ca$var$EaseValueTaskBase extends (0, $0a161b37cd2a445c$export$2e2bcd8739ae039) {
    resetFromJSON(o) {
        this.timer.resetFromJSON($ee7bf184597091ca$var$GetValue(o, "timer"));
        this.setEnable($ee7bf184597091ca$var$GetValue(o, "enable", true));
        this.setTarget($ee7bf184597091ca$var$GetValue(o, "target", this.parent));
        this.setDelay($ee7bf184597091ca$var$GetAdvancedValue(o, "delay", 0));
        this.setDuration($ee7bf184597091ca$var$GetAdvancedValue(o, "duration", 1000));
        this.setEase($ee7bf184597091ca$var$GetValue(o, "ease", "Linear"));
        this.setRepeat($ee7bf184597091ca$var$GetValue(o, "repeat", 0));
        return this;
    }
    setEnable(e) {
        if (e == undefined) e = true;
        this.enable = e;
        return this;
    }
    setTarget(target) {
        if (target === undefined) target = this.parent;
        this.target = target;
        return this;
    }
    setDelay(time) {
        this.delay = time;
        // Assign `this.timer.setRepeat(repeat)` manually
        return this;
    }
    setDuration(time) {
        this.duration = time;
        return this;
    }
    setRepeat(repeat) {
        this.repeat = repeat;
        // Assign `this.timer.setRepeat(repeat)` manually
        return this;
    }
    setRepeatDelay(repeatDelay) {
        this.repeatDelay = repeatDelay;
        // Assign `this.timer.setRepeatDelay(repeatDelay)` manually
        return this;
    }
    setEase(ease) {
        if (ease === undefined) ease = "Linear";
        this.ease = ease;
        this.easeFn = $ee7bf184597091ca$var$GetEaseFunction(ease);
        return this;
    }
    // Override
    start() {
        // Ignore start if timer is running, i.e. in DELAY, o RUN state
        if (this.timer.isRunning) return this;
        super.start();
        return this;
    }
    restart() {
        this.timer.stop();
        this.start.apply(this, arguments);
        return this;
    }
    stop(toEnd) {
        if (toEnd === undefined) toEnd = false;
        super.stop();
        if (toEnd) {
            this.timer.setT(1);
            this.updateGameObject(this.target, this.timer);
            this.complete();
        }
        return this;
    }
    update(time, delta) {
        if (!this.isRunning || !this.enable || !this.parent.active) return this;
        var target = this.target, timer = this.timer;
        timer.update(time, delta);
        // isDelay, isCountDown, isDone
        if (!timer.isDelay) this.updateGameObject(target, timer);
        this.emit("update", target, this);
        if (timer.isDone) this.complete();
        return this;
    }
    // Override
    updateGameObject(target, timer) {}
}
var $ee7bf184597091ca$export$2e2bcd8739ae039 = $ee7bf184597091ca$var$EaseValueTaskBase;


const $c6f71ac84be3e5b9$var$SoundObjectClass = Phaser.Sound.BaseSound;
var $c6f71ac84be3e5b9$var$IsSoundObject = function(object) {
    return object instanceof $c6f71ac84be3e5b9$var$SoundObjectClass;
};
var $c6f71ac84be3e5b9$export$2e2bcd8739ae039 = $c6f71ac84be3e5b9$var$IsSoundObject;


const $5a042fa26e52fa0e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $5a042fa26e52fa0e$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $5a042fa26e52fa0e$var$Linear = Phaser.Math.Linear;
class $5a042fa26e52fa0e$var$Fade extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(scene, sound, config){
        if ((0, $c6f71ac84be3e5b9$export$2e2bcd8739ae039)(scene)) {
            config = sound;
            sound = scene;
            scene = undefined;
        }
        sound.active = true;
        sound.scene = scene;
        sound.game = sound.manager.game;
        super(sound, config);
        // this.parent = parent
        // this.timer
        this.volume = {};
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setMode($5a042fa26e52fa0e$var$GetValue(o, "mode", 0));
        this.setEnable($5a042fa26e52fa0e$var$GetValue(o, "enable", true));
        this.setVolumeRange($5a042fa26e52fa0e$var$GetAdvancedValue(o, "volume.start", this.parent.volume), $5a042fa26e52fa0e$var$GetAdvancedValue(o, "volume.end", 0));
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $5a042fa26e52fa0e$var$MODE[m];
        this.mode = m;
        return this;
    }
    setVolumeRange(start, end) {
        this.volume.start = start;
        this.volume.end = end;
        return this;
    }
    start() {
        if (this.timer.isRunning) return this;
        this.parent.setVolume(this.volume.start);
        this.timer.setDelay(this.delay).setDuration(this.duration);
        super.start();
        return this;
    }
    updateGameObject(parent, timer) {
        parent.volume = $5a042fa26e52fa0e$var$Linear(this.volume.start, this.volume.end, timer.t);
    }
    complete() {
        super.complete();
        switch(this.mode){
            case 1:
                this.parent.stop();
                break;
            case 2:
                this.parent.destroy();
                break;
        }
        return this;
    }
}
const $5a042fa26e52fa0e$var$MODE = {
    stop: 1,
    destroy: 2
};
var $5a042fa26e52fa0e$export$2e2bcd8739ae039 = $5a042fa26e52fa0e$var$Fade;



var $193a8e6f6c6a5629$var$FadeIn = function(scene, sound, duration, endVolume, startVolume) {
    if ((0, $c6f71ac84be3e5b9$export$2e2bcd8739ae039)(scene)) {
        startVolume = endVolume;
        endVolume = duration;
        duration = sound;
        sound = scene;
        scene = undefined;
    }
    if (endVolume === undefined) endVolume = 1;
    if (startVolume === undefined) startVolume = 0;
    var config = {
        mode: 0,
        volume: {
            start: startVolume,
            end: endVolume
        },
        duration: duration
    };
    // create sound instance by key
    if (typeof sound === "string") sound = scene.sys.sound.add(sound);
    var fade;
    if (sound.hasOwnProperty("_fade")) {
        fade = sound._fade;
        fade.stop().resetFromJSON(config);
    } else {
        fade = new (0, $5a042fa26e52fa0e$export$2e2bcd8739ae039)(scene, sound, config);
        sound._fade = fade;
    }
    fade.start();
    if (!sound.isPlaying) sound.setVolume(startVolume).play();
    return sound;
};
var $193a8e6f6c6a5629$export$2e2bcd8739ae039 = $193a8e6f6c6a5629$var$FadeIn;




var $7cd70152b3b0e556$var$FadeOut = function(scene, sound, duration, destroy) {
    if ((0, $c6f71ac84be3e5b9$export$2e2bcd8739ae039)(scene)) {
        destroy = duration;
        duration = sound;
        sound = scene;
        scene = undefined;
    }
    if (destroy === undefined) destroy = true;
    var config = {
        mode: destroy ? 2 : 1,
        volume: {
            start: sound.volume,
            end: 0
        },
        duration: duration
    };
    var fade;
    if (sound.hasOwnProperty("_fade")) {
        fade = sound._fade;
        fade.stop().resetFromJSON(config);
    } else {
        fade = new (0, $5a042fa26e52fa0e$export$2e2bcd8739ae039)(scene, sound, config);
        sound._fade = fade;
    }
    fade.start();
    if (!sound.isPlaying) sound.play();
    return sound;
};
var $7cd70152b3b0e556$export$2e2bcd8739ae039 = $7cd70152b3b0e556$var$FadeOut;


var $04c6861c743dee07$export$2e2bcd8739ae039 = {
    setBackgroundMusicLoopValue (value) {
        this.backgroundMusicLoopValue = value;
        return this;
    },
    setBackgroundMusicFadeTime (time) {
        this.backgroundMusicFadeTime = time;
        return this;
    },
    getBackgroundMusic () {
        return this.backgroundMusic;
    },
    // Internal method
    setCurrentBackgroundMusic (music) {
        this.backgroundMusic = music;
        if (music) {
            music.setLoop(this.backgroundMusicLoopValue);
            music.once("complete", function() {
                if (this.backgroundMusic === music) {
                    this.backgroundMusic.destroy();
                    this.backgroundMusic = undefined;
                }
            }, this).once("destroy", function() {
                if (this.backgroundMusic === music) this.backgroundMusic = undefined;
            }, this);
            if (!music.isPlaying) music.play();
        }
        return this;
    },
    playBackgroundMusic (key) {
        // Don't re-play the same background music
        if (this.backgroundMusic && this.backgroundMusic.key === key) return this;
        this.stopBackgroundMusic(); // Stop previous background music
        this.setCurrentBackgroundMusic(this.sound.add(key));
        if (this.backgroundMusicFadeTime > 0) this.fadeInBackgroundMusic(this.backgroundMusicFadeTime);
        return this;
    },
    pauseBackgroundMusic () {
        if (this.backgroundMusic) this.backgroundMusic.pause();
        return this;
    },
    resumeBackgroundMusic () {
        if (this.backgroundMusic) this.backgroundMusic.resume();
        return this;
    },
    stopBackgroundMusic () {
        if (this.backgroundMusic) {
            if (this.backgroundMusicFadeTime > 0) this.fadeOutBackgroundMusic(this.backgroundMusicFadeTime, true);
            else {
                this.backgroundMusic.stop();
                this.backgroundMusic.destroy();
                this.backgroundMusic = undefined;
            }
        }
        return this;
    },
    fadeInBackgroundMusic (time) {
        if (this.backgroundMusic) (0, $193a8e6f6c6a5629$export$2e2bcd8739ae039)(this.backgroundMusic, time, this.backgroundMusicVolume, 0);
        return this;
    },
    fadeOutBackgroundMusic (time, isStopped) {
        if (this.backgroundMusic) (0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(this.backgroundMusic, time, isStopped);
        return this;
    },
    crossFadeBackgroundMusic (key, time) {
        var backgroundMusicFadeTimeSave = this.backgroundMusicFadeTime;
        this.backgroundMusicFadeTime = 0;
        this.fadeOutBackgroundMusic(time, true).playBackgroundMusic(key).fadeInBackgroundMusic(time);
        this.backgroundMusicFadeTime = backgroundMusicFadeTimeSave;
        return this;
    },
    setBackgroundMusicVolume (volume) {
        this.backgroundMusicVolume = volume;
        return this;
    }
};




var $1a556853a0f62b4c$export$2e2bcd8739ae039 = {
    setBackgroundMusic2LoopValue (value) {
        this.backgroundMusic2LoopValue = value;
        return this;
    },
    setBackgroundMusic2FadeTime (time) {
        this.backgroundMusic2FadeTime = time;
        return this;
    },
    getBackgroundMusic2 () {
        return this.backgroundMusic2;
    },
    // Internal method
    setCurrentBackgroundMusic2 (music) {
        this.backgroundMusic2 = music;
        if (music) {
            music.setLoop(this.backgroundMusic2LoopValue);
            music.once("complete", function() {
                if (this.backgroundMusic2 === music) {
                    this.backgroundMusic2.destroy();
                    this.backgroundMusic2 = undefined;
                }
            }, this).once("destroy", function() {
                if (this.backgroundMusic2 === music) this.backgroundMusic2 = undefined;
            }, this);
            if (!music.isPlaying) music.play();
        }
        return this;
    },
    playBackgroundMusic2 (key) {
        // Don't re-play the same background music
        if (this.backgroundMusic2 && this.backgroundMusic2.key === key) return this;
        this.stopBackgroundMusic2(); // Stop previous background music
        this.setCurrentBackgroundMusic2(this.sound.add(key));
        if (this.backgroundMusic2FadeTime > 0) this.fadeInBackgroundMusic2(this.backgroundMusic2FadeTime);
        return this;
    },
    pauseBackgroundMusic2 () {
        if (this.backgroundMusic2) this.backgroundMusic2.pause();
        return this;
    },
    resumeBackgroundMusic2 () {
        if (this.backgroundMusic2) this.backgroundMusic2.resume();
        return this;
    },
    stopBackgroundMusic2 () {
        if (this.backgroundMusic2) {
            if (this.backgroundMusic2FadeTime > 0) this.fadeOutBackgroundMusic2(this.backgroundMusic2FadeTime, true);
            else {
                this.backgroundMusic2.stop();
                this.backgroundMusic2.destroy();
                this.backgroundMusic2 = undefined;
            }
        }
        return this;
    },
    fadeInBackgroundMusic2 (time) {
        if (this.backgroundMusic2) (0, $193a8e6f6c6a5629$export$2e2bcd8739ae039)(this.backgroundMusic2, time, this.backgroundMusic2Volume, 0);
        return this;
    },
    fadeOutBackgroundMusic2 (time, isStopped) {
        if (this.backgroundMusic2) (0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(this.backgroundMusic2, time, isStopped);
        return this;
    },
    crossFadeBackgroundMusic2 (key, time) {
        var backgroundMusic2FadeTimeSave = this.backgroundMusic2FadeTime;
        this.backgroundMusic2FadeTime = 0;
        this.fadeOutBackgroundMusic2(time, true).playBackgroundMusic2(key).fadeInBackgroundMusic2(time);
        this.backgroundMusic2FadeTime = backgroundMusic2FadeTimeSave;
        return this;
    },
    setBackgroundMusic2Volume (volume) {
        this.backgroundMusic2Volume = volume;
        return this;
    }
};




const $12f2571bdb33eccf$var$RemoveItem = Phaser.Utils.Array.Remove;
var $12f2571bdb33eccf$export$2e2bcd8739ae039 = {
    getSoundEffects () {
        return this.soundEffects;
    },
    getLastSoundEffect () {
        return this.soundEffects[this.soundEffects.length - 1];
    },
    playSoundEffect (key) {
        var soundEffect = this.sound.add(key);
        soundEffect.setVolume(this.soundEffectsVolume);
        this.soundEffects.push(soundEffect);
        soundEffect.once("complete", function() {
            soundEffect.destroy();
            // SoundManager has been destroyed
            if (!this.sound) return;
            $12f2571bdb33eccf$var$RemoveItem(this.soundEffects, soundEffect);
        }, this).once("destroy", function() {
            // SoundManager has been destroyed
            if (!this.sound) return;
            $12f2571bdb33eccf$var$RemoveItem(this.soundEffects, soundEffect);
        }, this).play();
        return this;
    },
    fadeInSoundEffect (time) {
        var soundEffect = this.getLastSoundEffect();
        if (soundEffect) (0, $193a8e6f6c6a5629$export$2e2bcd8739ae039)(soundEffect, time, this.soundEffectsVolume, 0);
        return this;
    },
    fadeOutSoundEffect (time, isStopped) {
        var soundEffect = this.getLastSoundEffect();
        if (soundEffect) (0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(soundEffect, time, isStopped);
        return this;
    },
    fadeOutAllSoundEffects (time, isStopped) {
        for(var i = this.soundEffects.length - 1; i >= 0; i--)(0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(this.soundEffects[i], time, isStopped);
        return this;
    },
    setSoundEffectVolume (volume, lastSoundEffect) {
        if (lastSoundEffect === undefined) lastSoundEffect = false;
        if (lastSoundEffect) {
            // Set volume of last sound effect
            var soundEffect = this.getLastSoundEffect();
            if (soundEffect) soundEffect.setVolume(volume);
        } else // Set volume of all sound effects
        this.soundEffectsVolume = volume;
        return this;
    }
};




const $fa74a8507c7b4c7c$var$RemoveItem = Phaser.Utils.Array.Remove;
var $fa74a8507c7b4c7c$export$2e2bcd8739ae039 = {
    getSoundEffects2 () {
        return this.soundEffects2;
    },
    getLastSoundEffect2 () {
        return this.soundEffects2[this.soundEffects2.length - 1];
    },
    playSoundEffect2 (key) {
        var soundEffect = this.sound.add(key);
        soundEffect.setVolume(this.soundEffects2Volume);
        this.soundEffects2.push(soundEffect);
        soundEffect.once("complete", function() {
            soundEffect.destroy();
            // SoundManager has been destroyed
            if (!this.sound) return;
            $fa74a8507c7b4c7c$var$RemoveItem(this.soundEffects2, soundEffect);
        }, this).once("destroy", function() {
            // SoundManager has been destroyed
            if (!this.sound) return;
            $fa74a8507c7b4c7c$var$RemoveItem(this.soundEffects2, soundEffect);
        }, this).play();
        return this;
    },
    fadeInSoundEffect2 (time) {
        var soundEffect = this.getLastSoundEffect2();
        if (soundEffect) (0, $193a8e6f6c6a5629$export$2e2bcd8739ae039)(soundEffect, time, this.soundEffects2Volume, 0);
        return this;
    },
    fadeOutSoundEffect2 (time, isStopped) {
        var soundEffect = this.getLastSoundEffect2();
        if (soundEffect) (0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(soundEffect, time, isStopped);
        return this;
    },
    fadeOutAllSoundEffects2 (time, isStopped) {
        for(var i = this.soundEffects2.length - 1; i >= 0; i--)(0, $7cd70152b3b0e556$export$2e2bcd8739ae039)(this.soundEffects2[i], time, isStopped);
        return this;
    },
    setSoundEffect2Volume (volume, lastSoundEffect) {
        if (lastSoundEffect === undefined) lastSoundEffect = false;
        if (lastSoundEffect) {
            // Set volume of last sound effect
            var soundEffect = this.getLastSoundEffect2();
            if (soundEffect) soundEffect.setVolume(volume);
        } else // Set volume of all sound effects
        this.soundEffects2Volume = volume;
        return this;
    }
};


var $eb1036def9786238$var$Methods = {};
Object.assign($eb1036def9786238$var$Methods, (0, $04c6861c743dee07$export$2e2bcd8739ae039), (0, $1a556853a0f62b4c$export$2e2bcd8739ae039), (0, $12f2571bdb33eccf$export$2e2bcd8739ae039), (0, $fa74a8507c7b4c7c$export$2e2bcd8739ae039));
var $eb1036def9786238$export$2e2bcd8739ae039 = $eb1036def9786238$var$Methods;


const $39ac58e18a0f585d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $39ac58e18a0f585d$var$SoundManager {
    constructor(game, config){
        this.sound = (0, $98c9a6d564490d18$export$2e2bcd8739ae039)(game);
        // Background music will be (fade out)destroyed when play next one.
        this.backgroundMusic = undefined;
        this._backgroundMusicVolume = $39ac58e18a0f585d$var$GetValue(config, "bgm.volume", 1);
        this.setBackgroundMusicLoopValue($39ac58e18a0f585d$var$GetValue(config, "bgm.loop", true));
        this.setBackgroundMusicFadeTime($39ac58e18a0f585d$var$GetValue(config, "bgm.fade", 500));
        this.backgroundMusic2 = undefined;
        this._backgroundMusic2Volume = $39ac58e18a0f585d$var$GetValue(config, "bgm2.volume", 1);
        this.setBackgroundMusic2LoopValue($39ac58e18a0f585d$var$GetValue(config, "bgm2.loop", true));
        this.setBackgroundMusic2FadeTime($39ac58e18a0f585d$var$GetValue(config, "bgm2.fade", 500));
        // Sound effect will be destroyed when completed
        this.soundEffects = [];
        this._soundEffectsVolume = $39ac58e18a0f585d$var$GetValue(config, "soundEffect.volume", 1);
        this.soundEffects2 = [];
        this._soundEffects2Volume = $39ac58e18a0f585d$var$GetValue(config, "soundEffect2.volume", 1);
        var initialBackgroundMusic = $39ac58e18a0f585d$var$GetValue(config, "bgm.initial", undefined);
        if (initialBackgroundMusic) this.setCurrentBackgroundMusic(initialBackgroundMusic);
        var initialBackgroundMusic2 = $39ac58e18a0f585d$var$GetValue(config, "bgm2.initial", undefined);
        if (initialBackgroundMusic2) this.setCurrentBackgroundMusic2(initialBackgroundMusic2);
    }
    destroy() {
        if (this.backgroundMusic) this.backgroundMusic.destroy();
        this.backgroundMusic = undefined;
        if (this.backgroundMusic2) this.backgroundMusic2.destroy();
        this.backgroundMusic2 = undefined;
        if (this.soundEffects.length) for(var i = this.soundEffects.length - 1; i >= 0; i--)this.soundEffects[i].destroy();
        this.soundEffects.length = 0;
        if (this.soundEffects2.length) for(var i = this.soundEffects2.length - 1; i >= 0; i--)this.soundEffects2[i].destroy();
        this.soundEffects2.length = 0;
        this.sound = undefined;
        return this;
    }
    get backgroundMusicVolume() {
        return this._backgroundMusicVolume;
    }
    set backgroundMusicVolume(value) {
        this._backgroundMusicVolume = value;
        if (this.backgroundMusic) this.backgroundMusic.setVolume(value);
    }
    get backgroundMusic2Volume() {
        return this._backgroundMusic2Volume;
    }
    set backgroundMusic2Volume(value) {
        this._backgroundMusic2Volume = value;
        if (this.backgroundMusic2) this.backgroundMusic2.setVolume(value);
    }
    get soundEffectsVolume() {
        return this._soundEffectsVolume;
    }
    set soundEffectsVolume(value) {
        this._soundEffectsVolume = value;
        var soundEffects = this.soundEffects;
        for(var i = 0, cnt = soundEffects.length; i < cnt; i++)soundEffects[i].setVolume(value);
    }
}
Object.assign($39ac58e18a0f585d$var$SoundManager.prototype, (0, $eb1036def9786238$export$2e2bcd8739ae039));
var $39ac58e18a0f585d$export$2e2bcd8739ae039 = $39ac58e18a0f585d$var$SoundManager;



const $a69251abd8b86daa$var$GetValue = Phaser.Utils.Objects.GetValue;
class $a69251abd8b86daa$var$BaseClock extends (0, $de3bc6fefe1470a6$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.isRunning = $a69251abd8b86daa$var$GetValue(o, "isRunning", false);
        this.timeScale = $a69251abd8b86daa$var$GetValue(o, "timeScale", 1);
        this.now = $a69251abd8b86daa$var$GetValue(o, "now", 0);
        return this;
    }
    toJSON() {
        return {
            isRunning: this.isRunning,
            timeScale: this.timeScale,
            now: this.now,
            tickingMode: this.tickingMode
        };
    }
    // Override
    // startTicking() { }
    // Override
    // stopTicking() {}
    start(startAt) {
        if (startAt === undefined) startAt = 0;
        this.delta = 0;
        this.now = startAt;
        super.start();
        return this;
    }
    seek(time) {
        this.now = time;
        return this;
    }
    setTimeScale(value) {
        this.timeScale = value;
        return this;
    }
    tick(delta) {
        delta *= this.timeScale;
        this.now += delta;
        this.delta = delta;
        this.emit("update", this.now, this.delta);
        return this;
    }
}
var $a69251abd8b86daa$export$2e2bcd8739ae039 = $a69251abd8b86daa$var$BaseClock;


class $3f2ea1a0cae0e7a0$var$Clock extends (0, $a69251abd8b86daa$export$2e2bcd8739ae039) {
    startTicking() {
        super.startTicking();
        this.scene.sys.events.on("update", this.update, this);
    }
    stopTicking() {
        super.stopTicking();
        if (this.scene) this.scene.sys.events.off("update", this.update, this);
    }
    update(time, delta) {
        if (!this.isRunning || this.timeScale === 0) return this;
        this.tick(delta);
        return this;
    }
}
var $3f2ea1a0cae0e7a0$export$2e2bcd8739ae039 = $3f2ea1a0cae0e7a0$var$Clock;


var $74b0702f77cce664$var$Yoyo = function(t, threshold) {
    if (threshold === undefined) threshold = 0.5;
    if (t <= threshold) t = t / threshold;
    else t = 1 - (t - threshold) / (1 - threshold);
    return t;
};
var $74b0702f77cce664$export$2e2bcd8739ae039 = $74b0702f77cce664$var$Yoyo;


const $8b84356b88d70d6f$var$Clamp = Phaser.Math.Clamp;
class $8b84356b88d70d6f$var$Timer {
    constructor(timeline, config){
        this.setTimeline(timeline).reset(config);
    }
    setTimeline(timeline) {
        this.timeline = timeline;
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setCallbacks(target, onStart, onProgress, onComplete) {
        this.target = target;
        this.onStart = onStart;
        this.onProgress = onProgress;
        this.onComplete = onComplete;
        return this;
    }
    setDuration(duration, yoyo) {
        if (yoyo === undefined) yoyo = false;
        this.duration = duration;
        this.remainder = duration;
        this.t = 0;
        this.yoyo = yoyo;
        return this;
    }
    setPaused(state) {
        this.isPaused = state;
        return this;
    }
    pause() {
        this.isPaused = true;
        return this;
    }
    resume() {
        this.isPaused = false;
        return this;
    }
    setRemoved(state) {
        this.removed = state;
        return this;
    }
    remove() {
        this.removed = true;
        return this;
    }
    seek(t) {
        this.remainder = this.duration * (1 - t);
        return this;
    }
    reset(o) {
        this.setName(o.name).setDuration(o.duration, o.yoyo).setCallbacks(o.target, o.onStart, o.onProgress, o.onComplete).setPaused(false).setRemoved(false);
        return this;
    }
    onFree() {
        this.setTimeline().setCallbacks();
    }
    getProgress() {
        var value = 1 - this.remainder / this.duration;
        value = $8b84356b88d70d6f$var$Clamp(value, 0, 1);
        if (this.yoyo) value = (0, $74b0702f77cce664$export$2e2bcd8739ae039)(value);
        return value;
    }
    setProgress(value) {
        value = $8b84356b88d70d6f$var$Clamp(value, 0, 1);
        this.remainder = this.duration * (1 - value);
    }
    runCallback(callback) {
        if (!callback) return;
        callback(this.target, this.t, this);
    }
    update(time, delta) {
        if (this.removed) return true;
        else if (this.isPaused) return false;
        this.remainder -= delta;
        this.t = this.getProgress();
        this.runCallback(this.onProgress);
        var isCompleted = this.remainder <= 0;
        if (isCompleted) this.runCallback(this.onComplete);
        return isCompleted;
    }
}
var $8b84356b88d70d6f$export$2e2bcd8739ae039 = $8b84356b88d70d6f$var$Timer;



class $07027a602bb05747$var$TimerPool extends (0, $3a1e84ac82f806c8$export$2e2bcd8739ae039) {
    allocate() {
        return this.pop();
    }
    free(timer) {
        timer.onFree();
        this.push(timer);
    }
    freeMultiple(arr) {
        for(var i = 0, cnt = arr.length; i < cnt; i++)this.free(arr[i]);
        return this;
    }
}
var $07027a602bb05747$export$2e2bcd8739ae039 = $07027a602bb05747$var$TimerPool;


const $16b769b86e02bfda$var$GetValue = Phaser.Utils.Objects.GetValue;
const $16b769b86e02bfda$var$TimerPool = new (0, $07027a602bb05747$export$2e2bcd8739ae039)();
class $16b769b86e02bfda$var$Timeline extends (0, $3f2ea1a0cae0e7a0$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        this.addedTimers = [];
        this.timers = [];
        this.timerPool = $16b769b86e02bfda$var$GetValue(config, "pool", $16b769b86e02bfda$var$TimerPool);
    }
    shutdown() {
        // Already shutdown
        if (this.isShutdown) return;
        this.timerPool.freeMultiple(this.addedTimers).freeMultiple(this.timers);
        this.timerPool = undefined;
        this.addedTimers = undefined;
        this.timers = undefined;
        super.shutdown();
    }
    addTimer(config) {
        var timer = this.timerPool.allocate();
        if (!timer) timer = new (0, $8b84356b88d70d6f$export$2e2bcd8739ae039)(this, config);
        else timer.setTimeline(this).reset(config);
        this.addedTimers.push(timer);
        timer.runCallback(timer.onStart);
        if (!this.isRunning) this.start();
        return timer;
    }
    delayCall(delay, callback, args, scope) {
        var timer = this.addTimer({
            duration: delay,
            onComplete: function(target, t, timer) {
                if (args === undefined) args = [];
                args.push(timer);
                callback.apply(scope, args);
            }
        });
        return timer;
    }
    getTimers(name) {
        var timers = [];
        var timerQueues = [
            this.addedTimers,
            this.timers
        ];
        for(var ti = 0, tcnt = timerQueues.length; ti < tcnt; ti++){
            var timerQueue = timerQueues[ti];
            for(var i = 0, cnt = timerQueue.length; i < cnt; i++){
                var timer = timerQueue[i];
                if (timer.name === name) timers.push(timer);
            }
        }
        return timers;
    }
    update(time, delta) {
        super.update(time, delta);
        if (!this.isRunning) return;
        this.timers.push(...this.addedTimers);
        this.addedTimers.length = 0;
        var pendingTimers = [];
        for(var i = 0, cnt = this.timers.length; i < cnt; i++){
            var timer = this.timers[i];
            var isStopped = timer.update(this.now, this.delta);
            if (isStopped) this.timerPool.free(timer); // Free timer
            else pendingTimers.push(timer); // Add to timer queue
        }
        this.timers = pendingTimers;
        if (this.timers.length === 0 && this.addedTimers.length === 0) this.complete(); // Emit 'complete' event
    }
}
var $16b769b86e02bfda$export$2e2bcd8739ae039 = $16b769b86e02bfda$var$Timeline;


const $7bedc3809526bd68$var$GetValue = Phaser.Utils.Objects.GetValue;
var $7bedc3809526bd68$var$InitManagers = function(scene, config) {
    var soundManagerConfig = $7bedc3809526bd68$var$GetValue(config, "sounds");
    if (soundManagerConfig !== false) this.soundManager = new (0, $39ac58e18a0f585d$export$2e2bcd8739ae039)(scene, soundManagerConfig);
    this.gameObjectManagers = {};
    this.timeline = new (0, $16b769b86e02bfda$export$2e2bcd8739ae039)(this);
    this.managersScene = scene;
    return this;
};
var $7bedc3809526bd68$export$2e2bcd8739ae039 = $7bedc3809526bd68$var$InitManagers;


var $ad2fb83b72b1f33b$var$SetTimeScale = function(value) {
    this.timeline.timeScale = value;
    for(var name in this.gameObjectManagers)this.gameObjectManagers[name].setTimeScale(value);
    return this;
};
var $ad2fb83b72b1f33b$export$2e2bcd8739ae039 = $ad2fb83b72b1f33b$var$SetTimeScale;


var $c9a561614e068035$var$GetTimeScale = function() {
    return this.timeline.timeScale;
};
var $c9a561614e068035$export$2e2bcd8739ae039 = $c9a561614e068035$var$GetTimeScale;


var $f9f04e4b8907d1b8$var$DestroyManagers = function(fromScene) {
    if (this.soundManager) this.soundManager.destroy();
    this.soundManager = undefined;
    for(var name in this.gameObjectManagers){
        this.gameObjectManagers[name].destroy(fromScene);
        delete this.gameObjectManagers[name];
    }
    if (this.timeline) this.timeline.destroy();
    this.timeline = undefined;
    this.managersScene = undefined;
};
var $f9f04e4b8907d1b8$export$2e2bcd8739ae039 = $f9f04e4b8907d1b8$var$DestroyManagers;



var $39705794cc6e2cd0$export$2e2bcd8739ae039 = {
    hasProperty (property) {
        var gameObject = this.gameObject;
        if (gameObject.hasOwnProperty(property)) return true;
        else {
            var value = gameObject[property];
            return value !== undefined;
        }
    },
    getProperty (property) {
        return this.gameObject[property];
    },
    setProperty (property, value) {
        this.gameObject[property] = value;
        return this;
    },
    easeProperty (property, value, duration, ease, repeat, isYoyo, onComplete) {
        var tweenTasks = this.tweens;
        var tweenTask = tweenTasks[property];
        if (tweenTask) tweenTask.remove();
        var gameObject = this.gameObject;
        var config = {
            targets: gameObject,
            duration: duration,
            ease: ease,
            repeat: repeat,
            yoyo: isYoyo,
            onComplete: function() {
                tweenTasks[property].remove();
                tweenTasks[property] = null;
                if (onComplete) onComplete(gameObject, property);
            },
            onCompleteScope: this
        };
        config[property] = value;
        tweenTask = this.scene.tweens.add(config);
        tweenTask.timeScale = this.timeScale;
        tweenTasks[property] = tweenTask;
        return this;
    }
};


var $79e0c1f7ac8b1295$export$2e2bcd8739ae039 = {
    hasMethod (methodName) {
        return typeof this.gameObject[methodName] === "function";
    },
    call (methodName, ...parameters) {
        if (!this.hasMethod(methodName)) return this;
        var gameObject = this.gameObject;
        gameObject[methodName].apply(gameObject, parameters);
        return this;
    }
};


var $054dfa959f57fe28$export$2e2bcd8739ae039 = {
    hasData (dataKey) {
        var gameObject = this.gameObject;
        return gameObject.data ? gameObject.data.has(dataKey) : false;
    },
    getData (dataKey) {
        return this.gameObject.getData(dataKey);
    },
    setData (dataKey, value) {
        this.gameObject.setData(dataKey, value);
        return this;
    }
};


class $495cd9567d1d8022$var$BobBase {
    constructor(GOManager, gameObject, name){
        this.GOManager = GOManager;
        this.tweens = {};
        this.setGO(gameObject, name);
    }
    get scene() {
        return this.GOManager.scene;
    }
    get timeScale() {
        return this.GOManager.timeScale;
    }
    destroy() {
        this.freeGO();
        this.GOManager = undefined;
    }
    freeTweens() {
        var tweenTasks = this.tweens, tweenTask;
        for(var propName in tweenTasks){
            tweenTask = tweenTasks[propName];
            if (tweenTask) tweenTask.remove();
            tweenTasks[propName] = null;
        }
        return this;
    }
    freeGO() {
        this.freeTweens();
        this.gameObject.destroy();
        this.gameObject = undefined;
        return this;
    }
    setGO(gameObject, name) {
        gameObject.setName(name);
        this.gameObject = gameObject;
        this.name = name;
        this.freeTweens();
        return this;
    }
    setTimeScale(timeScale) {
        var tweenTasks = this.tweens;
        for(var key in tweenTasks){
            var tweenTask = tweenTasks[key];
            if (tweenTask) tweenTask.timeScale = timeScale;
        }
        return this;
    }
}
Object.assign($495cd9567d1d8022$var$BobBase.prototype, (0, $39705794cc6e2cd0$export$2e2bcd8739ae039), (0, $79e0c1f7ac8b1295$export$2e2bcd8739ae039), (0, $054dfa959f57fe28$export$2e2bcd8739ae039));
var $495cd9567d1d8022$export$2e2bcd8739ae039 = $495cd9567d1d8022$var$BobBase;


var $aba8f4b64d947bef$var$IsEmpty = function(source) {
    for(var k in source)return false;
    return true;
};
var $aba8f4b64d947bef$export$2e2bcd8739ae039 = $aba8f4b64d947bef$var$IsEmpty;


const $6ad743dc626cd7a0$var$FadeMode = {
    tint: 0,
    alpha: 1
};
var $6ad743dc626cd7a0$export$2e2bcd8739ae039 = {
    setGOFadeMode (fadeMode) {
        if (typeof fadeMode === "string") fadeMode = $6ad743dc626cd7a0$var$FadeMode[fadeMode];
        this.fadeMode = fadeMode;
        return this;
    },
    setGOFadeTime (time) {
        this.fadeTime = time;
        return this;
    },
    hasTintFadeEffect (gameObject) {
        return (this.fadeMode === undefined || this.fadeMode === 0) && this.fadeTime > 0 && gameObject.setTint !== undefined;
    },
    hasAlphaFadeEffect (gameObject) {
        return (this.fadeMode === undefined || this.fadeMode === 1) && this.fadeTime > 0 && gameObject.setAlpha !== undefined;
    },
    fadeBob (bob, fromValue, toValue, onComplete) {
        var gameObject = bob.gameObject;
        if (this.hasTintFadeEffect(gameObject)) {
            if (fromValue !== undefined) bob.setProperty("tintGray", 255 * fromValue);
            bob.easeProperty("tintGray", Math.floor(255 * toValue), this.fadeTime, "Linear", 0, false, onComplete // onComplete
            );
        } else if (this.hasAlphaFadeEffect(gameObject)) {
            if (fromValue !== undefined) bob.setProperty("alpha", fromValue);
            bob.easeProperty("alpha", toValue, this.fadeTime, "Linear", 0, false, onComplete // onComplete
            );
        } else if (onComplete) onComplete(gameObject);
        return this;
    }
};


var $8f5ae6faf2588ae9$export$41462b6f413ab95a = function(colorInt) {
    return colorInt >> 16 & 0xff;
};
var $8f5ae6faf2588ae9$export$2beaff7905ae7854 = function(colorInt) {
    return colorInt >> 8 & 0xff;
};
var $8f5ae6faf2588ae9$export$6b1cf35401b5f75a = function(colorInt) {
    return colorInt & 0xff;
};


const $61659b022c4adb1b$var$MaskR = 65535;
const $61659b022c4adb1b$var$MaskG = 16711935;
const $61659b022c4adb1b$var$MaskB = 16776960;
var $61659b022c4adb1b$export$6a17e58ace23dc4b = function(colorInt, r) {
    return (r & 0xff) << 16 | colorInt & $61659b022c4adb1b$var$MaskR;
};
var $61659b022c4adb1b$export$ab0ce6687057b2a4 = function(colorInt, g) {
    return (g & 0xff) << 8 | colorInt & $61659b022c4adb1b$var$MaskG;
};
var $61659b022c4adb1b$export$8df3b51c6b8310c7 = function(colorInt, b) {
    return b & 0xff | colorInt & $61659b022c4adb1b$var$MaskB;
};
var $61659b022c4adb1b$export$b9443d24333facf7 = function(colorInt, r, g, b) {
    return (r & 0xff) << 16 | (g & 0xff) << 8 | b & 0xff;
};


var $e7bfb7fe490d91c9$var$AddTintRGBProperties = function(gameObject, tintRGB) {
    // Don't attach properties again
    if (gameObject.hasOwnProperty("tintR")) return gameObject;
    if (tintRGB === undefined) tintRGB = 0xffffff;
    var tintR = (0, $8f5ae6faf2588ae9$export$41462b6f413ab95a)(tintRGB);
    var tintG = (0, $8f5ae6faf2588ae9$export$2beaff7905ae7854)(tintRGB);
    var tintB = (0, $8f5ae6faf2588ae9$export$6b1cf35401b5f75a)(tintRGB);
    // Override tint property
    Object.defineProperty(gameObject, "tint", {
        get: function() {
            return tintRGB;
        },
        set: function(value) {
            value = Math.floor(value) & 0xffffff;
            if (gameObject.setTint) gameObject.setTint(value);
            if (tintRGB !== value) {
                tintRGB = value;
                tintR = (0, $8f5ae6faf2588ae9$export$41462b6f413ab95a)(tintRGB);
                tintG = (0, $8f5ae6faf2588ae9$export$2beaff7905ae7854)(tintRGB);
                tintB = (0, $8f5ae6faf2588ae9$export$6b1cf35401b5f75a)(tintRGB);
            // gameObject.emit('_tintchange', value, tintR, tintG, tintB);
            }
        }
    });
    Object.defineProperty(gameObject, "tintR", {
        get: function() {
            return tintR;
        },
        set: function(value) {
            value = Math.floor(value) & 0xff;
            if (tintR !== value) {
                tintR = value;
                gameObject.tint = (0, $61659b022c4adb1b$export$6a17e58ace23dc4b)(tintRGB, value);
            }
        }
    });
    Object.defineProperty(gameObject, "tintG", {
        get: function() {
            return tintG;
        },
        set: function(value) {
            value = Math.floor(value) & 0xff;
            if (tintG !== value) {
                tintG = value;
                gameObject.tint = (0, $61659b022c4adb1b$export$ab0ce6687057b2a4)(tintRGB, value);
            }
        }
    });
    Object.defineProperty(gameObject, "tintB", {
        get: function() {
            return tintB;
        },
        set: function(value) {
            value = Math.floor(value) & 0xff;
            if (tintB !== value) {
                tintB = value;
                gameObject.tint = (0, $61659b022c4adb1b$export$8df3b51c6b8310c7)(tintRGB, value);
            }
        }
    });
    Object.defineProperty(gameObject, "tintGray", {
        get: function() {
            return Math.floor((tintR + tintG + tintB) / 3);
        },
        set: function(value) {
            value = Math.floor(value) & 0xff;
            if (tintR !== value || tintG !== value || tintB !== value) {
                tintR = value;
                tintG = value;
                tintB = value;
                gameObject.tint = (0, $61659b022c4adb1b$export$b9443d24333facf7)(tintRGB, value, value, value);
            }
        }
    });
    gameObject.tint = tintRGB;
    return gameObject;
};
var $e7bfb7fe490d91c9$export$2e2bcd8739ae039 = $e7bfb7fe490d91c9$var$AddTintRGBProperties;


const $2fa11f540ec7903b$var$EventEmitter = Phaser.Events.EventEmitter;
var $2fa11f540ec7903b$var$MonitorViewport = function(viewport) {
    if (viewport.events) return viewport;
    var events = new $2fa11f540ec7903b$var$EventEmitter();
    var x = viewport.x;
    Object.defineProperty(viewport, "x", {
        get: function() {
            return x;
        },
        set: function(value) {
            if (x !== value) {
                x = value;
                events.emit("update", viewport);
            }
        }
    });
    var y = viewport.y;
    Object.defineProperty(viewport, "y", {
        get: function() {
            return y;
        },
        set: function(value) {
            if (y !== value) {
                y = value;
                events.emit("update", viewport);
            }
        }
    });
    var width = viewport.width;
    Object.defineProperty(viewport, "width", {
        get: function() {
            return width;
        },
        set: function(value) {
            if (width !== value) {
                width = value;
                events.emit("update", viewport);
            }
        }
    });
    var height = viewport.height;
    Object.defineProperty(viewport, "height", {
        get: function() {
            return height;
        },
        set: function(value) {
            if (height !== value) {
                height = value;
                events.emit("update", viewport);
            }
        }
    });
    viewport.events = events;
    return viewport;
};
var $2fa11f540ec7903b$export$2e2bcd8739ae039 = $2fa11f540ec7903b$var$MonitorViewport;


var $9b2afe020f2b0787$var$VPXYToXY = function(vpx, vpy, vpxOffset, vpyOffset, viewport, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $9b2afe020f2b0787$var$GlobXY;
    if (typeof vpxOffset !== "number") {
        vpxOffset = 0;
        vpyOffset = 0;
    }
    out.x = viewport.x + viewport.width * vpx + vpxOffset;
    out.y = viewport.y + viewport.height * vpy + vpyOffset;
    return out;
};
var $9b2afe020f2b0787$var$GlobXY = {};
var $9b2afe020f2b0787$export$2e2bcd8739ae039 = $9b2afe020f2b0787$var$VPXYToXY;


var $36b1c9569e1f20d8$var$AddViewportCoordinateProperties = function(gameObject, viewport, vpx, vpy, vpxOffset, vpyOffset, transformCallback) {
    // Don't attach properties again
    if (gameObject.hasOwnProperty("vp")) return gameObject;
    if (typeof vpx === "function") {
        transformCallback = vpx;
        vpx = undefined;
    }
    if (typeof vpxOffset === "function") {
        transformCallback = vpxOffset;
        vpxOffset = undefined;
    }
    if (vpx === undefined) vpx = 0.5;
    if (vpy === undefined) vpy = 0.5;
    if (vpxOffset === undefined) vpxOffset = 0;
    if (vpyOffset === undefined) vpyOffset = 0;
    if (transformCallback === undefined) transformCallback = (0, $9b2afe020f2b0787$export$2e2bcd8739ae039);
    (0, $2fa11f540ec7903b$export$2e2bcd8739ae039)(viewport);
    var events = viewport.events;
    gameObject.vp = viewport;
    // Set position of game object when view-port changed.
    var Transform = function() {
        transformCallback(vpx, vpy, vpxOffset, vpyOffset, viewport, gameObject);
    };
    events.on("update", Transform);
    gameObject.once("destroy", function() {
        events.off("update", Transform);
        gameObject.vp = undefined;
    });
    Object.defineProperty(gameObject, "vpx", {
        get: function() {
            return vpx;
        },
        set: function(value) {
            if (vpx !== value) {
                vpx = value;
                Transform();
            }
        }
    });
    Object.defineProperty(gameObject, "vpy", {
        get: function() {
            return vpy;
        },
        set: function(value) {
            if (vpy !== value) {
                vpy = value;
                Transform();
            }
        }
    });
    Object.defineProperty(gameObject, "vpxOffset", {
        get: function() {
            return vpxOffset;
        },
        set: function(value) {
            if (vpxOffset !== value) {
                vpxOffset = value;
                Transform();
            }
        }
    });
    Object.defineProperty(gameObject, "vpyOffset", {
        get: function() {
            return vpyOffset;
        },
        set: function(value) {
            if (vpyOffset !== value) {
                vpyOffset = value;
                Transform();
            }
        }
    });
    Transform();
};
var $36b1c9569e1f20d8$export$2e2bcd8739ae039 = $36b1c9569e1f20d8$var$AddViewportCoordinateProperties;


const $f895badcd54a8a85$var$RemoveItem = Phaser.Utils.Array.Remove;
var $f895badcd54a8a85$export$2e2bcd8739ae039 = {
    has (name) {
        return this.bobs.hasOwnProperty(name);
    },
    exists (name) {
        return this.bobs.hasOwnProperty(name);
    },
    get (name) {
        return this.bobs[name];
    },
    getGO (name) {
        var bob = this.get(name);
        return bob ? bob.gameObject : null;
    },
    addGO (name, gameObject) {
        this.remove(name, true);
        if (this.hasTintFadeEffect(gameObject)) (0, $e7bfb7fe490d91c9$export$2e2bcd8739ae039)(gameObject);
        if (this.viewportCoordinateEnable) (0, $36b1c9569e1f20d8$export$2e2bcd8739ae039)(gameObject, this.viewport);
        gameObject.once("destroy", function() {
            $f895badcd54a8a85$var$RemoveItem(this.removedGOs, gameObject);
            if (this.isEmpty) this.emit("empty");
        }, this);
        var bob = new this.BobClass(this, gameObject, name);
        this.bobs[name] = bob;
        return this;
    },
    add (name, ...args) {
        var callback = this.createGameObjectCallback;
        var scope = this.createGameObjectScope;
        var gameObject = callback.call(scope, this.scene, ...args);
        this.addGO(name, gameObject);
        var bob = this.get(name);
        this.fadeBob(bob, 0, 1);
        return this;
    },
    forEachGO (callback, scope) {
        for(var name in this.bobs){
            var gameObject = this.bobs[name].gameObject;
            var stopLoop;
            if (scope) stopLoop = callback.call(scope, gameObject, name, this);
            else stopLoop = callback(gameObject, name, this);
            if (stopLoop) break;
        }
        return this;
    }
};


var $425204984221e222$export$2e2bcd8739ae039 = {
    remove (name, ignoreFade) {
        if (!this.has(name)) return this;
        var bob = this.get(name);
        delete this.bobs[name];
        this.removedGOs.push(bob.gameObject);
        if (!ignoreFade) this.fadeBob(bob, undefined, 0, function() {
            bob.destroy();
        });
        else bob.destroy();
        return this;
    },
    removeAll () {
        var bobs = this.bobs;
        for(var name in bobs)this.remove(name);
        return this;
    },
    clear (destroyChild) {
        if (destroyChild === undefined) destroyChild = true;
        var bobs = this.bobs;
        for(var name in bobs){
            if (destroyChild) bobs[name].destroy();
            delete bobs[name];
        }
        this.removedGOs.length = 0;
        return this;
    }
};


var $e85d8246874b9205$export$2e2bcd8739ae039 = {
    hasProperty (name, property) {
        if (!this.has(name)) return false;
        return this.get(name).hasProperty(property);
    },
    getProperty (name, property) {
        if (!this.has(name)) return undefined;
        return this.get(name).getProperty(property);
    },
    isNumberProperty (name, property) {
        var value = this.getProperty(name, property);
        return typeof value === "number";
    },
    setProperty (name, property, value) {
        if (!this.has(name)) return this;
        if (this.symbols && typeof value === "string" && this.isNumberProperty(name, property)) {
            if (value in this.symbols) value = this.symbols[value];
            else console.warn(`Can't find symbol ${value}`);
        }
        this.get(name).setProperty(property, value);
        return this;
    },
    easeProperty (name, property, value, duration, ease, repeat, isYoyo, onComplete) {
        if (!this.has(name)) return this;
        if (duration === undefined) duration = 1000;
        if (ease === undefined) ease = "Linear";
        if (repeat === undefined) repeat = 0;
        if (isYoyo === undefined) isYoyo = false;
        if (this.symbols && typeof value === "string" && this.isNumberProperty(name, property)) {
            if (value in this.symbols) value = this.symbols[value];
            else console.warn(`Can't find symbol ${value}`);
        }
        this.get(name).easeProperty(property, value, duration, ease, repeat, isYoyo, onComplete);
        return this;
    },
    hasTweenTask (name, property) {
        if (!this.has(name)) return false;
        var tweenTasks = this.get(name).tweens;
        return tweenTasks.hasOwnProperty(property);
    },
    getTweenTask (name, property) {
        if (!this.has(name)) return null;
        var tweenTasks = this.get(name).tweens;
        var tweenTask = tweenTasks[property];
        return tweenTask ? tweenTask : null;
    }
};


var $9dc986769e01cb9a$export$2e2bcd8739ae039 = {
    hasMethod (name, methodName) {
        if (!this.has(name)) return false;
        return this.get(name).hasMethod(methodName);
    },
    call (name, methodName, ...parameters) {
        if (!this.has(name)) return this;
        this.get(name).call(methodName, ...parameters);
        return this;
    }
};


var $f0d462b1c2d4aaf9$export$2e2bcd8739ae039 = {
    hasData (name, dataKey) {
        if (!this.has(name)) return false;
        return this.get(name).hasData(dataKey);
    },
    getData (name, dataKey) {
        if (!this.has(name)) return undefined;
        return this.get(name).getData(dataKey);
    },
    setData (name, dataKey, value) {
        if (!this.has(name)) return this;
        this.get(name).setData(dataKey, value);
        return this;
    }
};



var $e50d7d5bf309c086$var$DrawGameObjectsBounds = function(graphics, config) {
    this.forEachGO(function(gameObject) {
        if (gameObject.drawBounds) gameObject.drawBounds(graphics, config);
        else (0, $f1363fb23984dede$export$2e2bcd8739ae039)(gameObject, graphics, config);
    });
    return this;
};
var $e50d7d5bf309c086$export$2e2bcd8739ae039 = $e50d7d5bf309c086$var$DrawGameObjectsBounds;


var $6b8ad443a92796e6$var$Methods = {
    drawGameObjectsBounds: (0, $e50d7d5bf309c086$export$2e2bcd8739ae039)
};
Object.assign($6b8ad443a92796e6$var$Methods, (0, $6ad743dc626cd7a0$export$2e2bcd8739ae039), (0, $f895badcd54a8a85$export$2e2bcd8739ae039), (0, $425204984221e222$export$2e2bcd8739ae039), (0, $e85d8246874b9205$export$2e2bcd8739ae039), (0, $9dc986769e01cb9a$export$2e2bcd8739ae039), (0, $f0d462b1c2d4aaf9$export$2e2bcd8739ae039));
var $6b8ad443a92796e6$export$2e2bcd8739ae039 = $6b8ad443a92796e6$var$Methods;


const $320b12fdb58e924c$var$CameraClass = Phaser.Cameras.Scene2D.BaseCamera;
var $320b12fdb58e924c$var$IsCameraObject = function(object) {
    return object instanceof $320b12fdb58e924c$var$CameraClass;
};
var $320b12fdb58e924c$export$2e2bcd8739ae039 = $320b12fdb58e924c$var$IsCameraObject;


const $80787edf9415f7c3$var$Rectangle = Phaser.Geom.Rectangle;
var $80787edf9415f7c3$var$GetViewport = function(scene, camera, out) {
    if (!(0, $320b12fdb58e924c$export$2e2bcd8739ae039)(camera)) {
        out = camera;
        camera = undefined;
    }
    if (out === undefined) out = new $80787edf9415f7c3$var$Rectangle();
    else if (out === true) out = $80787edf9415f7c3$var$globRect;
    var scaleManager = scene.sys.scale;
    var baseSize = scaleManager.baseSize;
    var parentSize = scaleManager.parentSize;
    var canvasBounds = scaleManager.canvasBounds;
    var displayScale = scaleManager.displayScale;
    var x = canvasBounds.x >= 0 ? 0 : -(canvasBounds.x * displayScale.x);
    var y = canvasBounds.y >= 0 ? 0 : -(canvasBounds.y * displayScale.y);
    var width;
    if (parentSize.width >= canvasBounds.width) width = baseSize.width;
    else width = baseSize.width - (canvasBounds.width - parentSize.width) * displayScale.x;
    var height;
    if (parentSize.height >= canvasBounds.height) height = baseSize.height;
    else height = baseSize.height - (canvasBounds.height - parentSize.height) * displayScale.y;
    out.setTo(x, y, width, height);
    if (camera) {
        out.width /= camera.zoomX;
        out.height /= camera.zoomY;
        out.centerX = camera.centerX + camera.scrollX;
        out.centerY = camera.centerY + camera.scrollY;
    }
    return out;
};
var $80787edf9415f7c3$var$globRect = new $80787edf9415f7c3$var$Rectangle();
var $80787edf9415f7c3$export$2e2bcd8739ae039 = $80787edf9415f7c3$var$GetViewport;


const $38db5a279359788b$var$GetValue = Phaser.Utils.Objects.GetValue;
class $38db5a279359788b$var$GOManager {
    constructor(scene, config){
        this.scene = scene;
        this.BobClass = $38db5a279359788b$var$GetValue(config, "BobClass", (0, $495cd9567d1d8022$export$2e2bcd8739ae039));
        this.setCreateGameObjectCallback($38db5a279359788b$var$GetValue(config, "createGameObject"), $38db5a279359788b$var$GetValue(config, "createGameObjectScope"));
        this.setEventEmitter($38db5a279359788b$var$GetValue(config, "eventEmitter", undefined));
        var fadeConfig = $38db5a279359788b$var$GetValue(config, "fade", 500);
        if (typeof fadeConfig === "number") {
            this.setGOFadeMode();
            this.setGOFadeTime(fadeConfig);
        } else {
            this.setGOFadeMode($38db5a279359788b$var$GetValue(fadeConfig, "mode"));
            this.setGOFadeTime($38db5a279359788b$var$GetValue(fadeConfig, "time", 500));
        }
        var viewportCoordinateConfig = $38db5a279359788b$var$GetValue(config, "viewportCoordinate", false);
        if (viewportCoordinateConfig !== false) {
            this.setViewportCoordinateEnable($38db5a279359788b$var$GetValue(config, "enable", true));
            this.setViewport($38db5a279359788b$var$GetValue(viewportCoordinateConfig, "viewport"));
        } else this.setViewportCoordinateEnable(false);
        this.setSymbols($38db5a279359788b$var$GetValue(config, "symbols"));
        this.bobs = {};
        this.removedGOs = [];
        this._timeScale = 1;
    }
    destroy(fromScene) {
        this.clear(!fromScene);
        this.createGameObjectCallback = undefined;
        this.viewport = undefined;
        this.scene = undefined;
    }
    set timeScale(timeScale) {
        if (this._timeScale === timeScale) return;
        this._timeScale = timeScale;
        var bobs = this.bobs;
        for(var name in bobs)bobs[name].setTimeScale(timeScale);
    }
    get timeScale() {
        return this._timeScale;
    }
    setTimeScale(timeScale) {
        this.timeScale = timeScale;
        return this;
    }
    setCreateGameObjectCallback(callback, scope) {
        this.createGameObjectCallback = callback;
        this.createGameObjectScope = scope;
        return this;
    }
    setViewportCoordinateEnable(enable) {
        if (enable === undefined) enable = true;
        this.viewportCoordinateEnable = enable;
        return this;
    }
    setViewport(viewport) {
        if (viewport === undefined) viewport = (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(this.scene, this.scene.cameras.main);
        this.viewport = viewport;
        return this;
    }
    setSymbols(symbols) {
        this.symbols = symbols;
        return this;
    }
    get isEmpty() {
        return (0, $aba8f4b64d947bef$export$2e2bcd8739ae039)(this.bobs) && this.removedGOs.length === 0;
    }
}
Object.assign($38db5a279359788b$var$GOManager.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039), (0, $6b8ad443a92796e6$export$2e2bcd8739ae039));
var $38db5a279359788b$export$2e2bcd8739ae039 = $38db5a279359788b$var$GOManager;


var $41adaf3b69b53b5f$export$2e2bcd8739ae039 = {
    addGameObjectManager (config, GameObjectManagerClass) {
        if (config === undefined) config = {};
        if (GameObjectManagerClass === undefined) GameObjectManagerClass = (0, $38db5a279359788b$export$2e2bcd8739ae039);
        if (!config.createGameObjectScope) config.createGameObjectScope = this;
        var gameobjectManager = new GameObjectManagerClass(this.managersScene, config);
        this.gameObjectManagers[config.name] = gameobjectManager;
        return this;
    },
    getGameObjectManager (name) {
        return this.gameObjectManagers[name];
    },
    getGameObjectManagerNames () {
        var names = [];
        for(var name in this.gameObjectManagers)names.push(name);
        return names;
    }
};


var $241556d85d8ee28d$export$2e2bcd8739ae039 = {
    createGameObject (goType, name, ...params) {
        this.getGameObjectManager(goType).add(name, ...params);
        return this;
    },
    destroyGameObject (goType, name) {
        var gameObjectManager = this.getGameObjectManager(goType);
        if (name === undefined) gameObjectManager.removeAll();
        else gameObjectManager.remove(name);
        return this;
    },
    callGameObjectMethod (goType, name, methodName, ...params) {
        this.getGameObjectManager(goType).call(name, methodName, ...params);
        return this;
    },
    setGameObjectProperty (goType, name, prop, value) {
        this.getGameObjectManager(goType).setProperty(name, prop, value);
        return this;
    },
    easeGameObjectProperty (goType, name, prop, value, duration, ease, repeat, isYoyo) {
        this.getGameObjectManager(goType).easeProperty(name, prop, value, duration, ease, repeat, isYoyo);
        return this;
    },
    getGameObject (goType, name, out) {
        var gameobjectManager = this.getGameObjectManager(goType);
        if (typeof name === "string") return gameobjectManager.getGO(name);
        else {
            var names = name;
            if (names === undefined) names = gameobjectManager.bobs;
            if (out === undefined) out = {};
            for(name in names)out[name] = gameobjectManager.getGO(name);
            return out;
        }
    },
    addGameObject (goType, name, gameObject) {
        var gameobjectManager = this.getGameObjectManager(goType);
        if (typeof name === "string") gameobjectManager.addGO(name, gameObject);
        else {
            var names = name;
            for(name in names)gameobjectManager.addGO(name, names[name]);
        }
        return this;
    },
    drawGameObjectsBounds (goTypes, graphics, config) {
        if (goTypes instanceof Phaser.GameObjects.Graphics) {
            config = graphics;
            graphics = goTypes;
            goTypes = undefined;
        }
        if (goTypes === undefined) goTypes = this.getGameObjectManagerNames();
        if (!Array.isArray(goTypes)) goTypes = [
            goTypes
        ];
        for(var i = 0, cnt = goTypes.length; i < cnt; i++)this.getGameObjectManager(goTypes[i]).drawGameObjectsBounds(graphics, config);
        return this;
    }
};


var $a58b77e71ec0444d$var$Extend = function(BaseClass) {
    class Managers extends BaseClass {
    }
    var Methods = {
        initManagers: (0, $7bedc3809526bd68$export$2e2bcd8739ae039),
        setTimeScale: (0, $ad2fb83b72b1f33b$export$2e2bcd8739ae039),
        getTimeScale: (0, $c9a561614e068035$export$2e2bcd8739ae039),
        destroyManagers: (0, $f9f04e4b8907d1b8$export$2e2bcd8739ae039)
    };
    Object.assign(Managers.prototype, Methods, (0, $41adaf3b69b53b5f$export$2e2bcd8739ae039), (0, $241556d85d8ee28d$export$2e2bcd8739ae039));
    return Managers;
};
var $a58b77e71ec0444d$export$2e2bcd8739ae039 = $a58b77e71ec0444d$var$Extend;





var $409bc89f18a52545$var$FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
var $409bc89f18a52545$var$HEX = /^0x[0-9A-F]+$/i;
var $409bc89f18a52545$var$TypeConvert = function(s) {
    if (typeof s !== "string") return s;
    if (s === "") s = null;
    else if ($409bc89f18a52545$var$FLOAT.test(s)) s = parseFloat(s);
    else if ($409bc89f18a52545$var$HEX.test(s)) s = parseInt(s, 16);
    else {
        if (s === "false") s = false;
        else if (s === "true") s = true;
    }
    return s;
};
var $409bc89f18a52545$export$2e2bcd8739ae039 = $409bc89f18a52545$var$TypeConvert;


// https://github.com/sindresorhus/escape-string-regexp/blob/master/index.js
var $2eb8f7579e816dbb$var$EscapeRegex = function(s) {
    return s.replace($2eb8f7579e816dbb$var$re0, "\\$&").replace($2eb8f7579e816dbb$var$re1, "\\x2d");
};
var $2eb8f7579e816dbb$var$re0 = /[|\\{}()[\]^$+*?.]/g;
var $2eb8f7579e816dbb$var$re1 = /-/g;
var $2eb8f7579e816dbb$export$2e2bcd8739ae039 = $2eb8f7579e816dbb$var$EscapeRegex;


class $3e8a57a9b83b2076$var$BracketParser {
    constructor(config){
        // Event emitter
        this.setEventEmitter((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "eventEmitter", undefined));
        // Value convert
        this.setValueConverter((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "valueConvert", true));
        // Loop
        this.setLoopEnable((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "loop", false));
        // Brackets and generate regex
        this.setMultipleLinesTagEnable((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "multipleLinesTag", false));
        var delimiters = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "delimiters", "<>");
        this.setDelimiters(delimiters[0], delimiters[1]);
        // Translate tagName callback
        this.setTranslateTagNameCallback((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "translateTagNameCallback"));
        this.isRunning = false;
        this.isPaused = false;
        this.skipEventFlag = false;
        this.justCompleted = false;
        this.lastTagStart = null;
        this.lastTagEnd = null;
        this.lastContent = null;
    }
    shutdown() {
        this.destroyEventEmitter();
    }
    destroy() {
        this.shutdown();
    }
    setMultipleLinesTagEnable(enable) {
        if (enable === undefined) enable = true;
        this.multipleLinesTagEnable = enable;
        return this;
    }
    // Override
    setDelimiters(delimiterLeft, delimiterRight) {
        if (delimiterRight === undefined) {
            delimiterRight = delimiterLeft[1];
            delimiterLeft = delimiterLeft[0];
        }
        this.delimiterLeft = delimiterLeft;
        this.delimiterRight = delimiterRight;
        delimiterLeft = (0, $2eb8f7579e816dbb$export$2e2bcd8739ae039)(this.delimiterLeft);
        delimiterRight = (0, $2eb8f7579e816dbb$export$2e2bcd8739ae039)(this.delimiterRight);
        var flag = this.multipleLinesTagEnable ? "gs" : "gi";
        this.reSplit = RegExp(`${delimiterLeft}(.+?)${delimiterRight}`, flag);
        return this;
    }
    setTranslateTagNameCallback(callback) {
        this.translateTagNameCallback = callback;
        return this;
    }
    setValueConverter(converter) {
        if (converter === true) converter = (0, $409bc89f18a52545$export$2e2bcd8739ae039);
        else if (!converter) converter = $3e8a57a9b83b2076$var$BypassValueConverter;
        this.valueConverter = converter;
        return this;
    }
    setLoopEnable(enable) {
        if (enable === undefined) enable = true;
        this.loopEnable = enable;
        return this;
    }
    setSource(source) {
        this.source = source;
        return this;
    }
    resetIndex(index) {
        if (index === undefined) index = 0;
        this.progressIndex = index;
        this.reSplit.lastIndex = index;
        this.lastTagStart = null;
        this.lastTagEnd = null;
        this.lastContent = null;
        this.justCompleted = false;
        this.isRunning = false;
        return this;
    }
    start(source) {
        this.setSource(source).restart();
        return this;
    }
    restart() {
        this.resetIndex().next();
    }
    next() {
        if (this.isPaused) this.onResume();
        // Don't re-enter this method
        if (this.isRunning) return this;
        this.isRunning = true;
        if (this.justCompleted) {
            this.isRunning = false;
            return this;
        }
        if (this.reSplit.lastIndex === 0) this.onStart();
        var text = this.source, lastIndex = text.length;
        this.reSplit.lastIndex = this.progressIndex;
        while(true){
            var regexResult = this.reSplit.exec(text);
            // No tag found, complete
            if (!regexResult) {
                if (this.progressIndex < lastIndex) {
                    this.onContent(text.substring(this.progressIndex, lastIndex));
                    // Might pause here
                    if (this.isPaused) {
                        this.progressIndex = lastIndex;
                        break;
                    }
                }
                this.onComplete();
                this.isRunning = false;
                return;
            }
            var matchEnd = this.reSplit.lastIndex;
            var matchStart = matchEnd - regexResult[0].length;
            // Process content between previous tag and current tag            
            if (this.progressIndex < matchStart) {
                this.onContent(text.substring(this.progressIndex, matchStart));
                // Might pause here
                if (this.isPaused) {
                    this.progressIndex = matchStart;
                    break;
                }
            }
            // Process current tag
            this.onTag(regexResult[1]);
            this.progressIndex = matchEnd;
            // Might pause here
            if (this.isPaused) break;
        }
        this.isRunning = false;
        return this;
    }
    skipEvent() {
        this.skipEventFlag = true;
        return this;
    }
    pause() {
        if (!this.isPaused) this.onPause();
        return this;
    }
    pauseUntilEvent(eventEmitter, eventName) {
        if (this.isPaused) return this;
        this.pause();
        eventEmitter.once(eventName, function() {
            this.next();
        }, this);
        return this;
    }
    onContent(content) {
        this.skipEventFlag = false;
        this.emit("content", content);
        this.lastContent = content;
    }
    // Override
    onTag(tagContent) {}
    onStart() {
        this.isRunning = true;
        this.emit("start", this);
    }
    onComplete() {
        this.isRunning = false;
        this.justCompleted = true;
        this.emit("complete", this);
        if (this.loopEnable) this.resetIndex();
    }
    onPause() {
        this.isPaused = true;
        this.emit("pause", this);
    }
    onResume() {
        this.isPaused = false;
        this.emit("resume", this);
    }
}
const $3e8a57a9b83b2076$var$BypassValueConverter = function(s) {
    return s;
};
Object.assign($3e8a57a9b83b2076$var$BracketParser.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039));
var $3e8a57a9b83b2076$export$2e2bcd8739ae039 = $3e8a57a9b83b2076$var$BracketParser;



var $c44561821864e5f0$var$ParseValue = function(text, valueConverter) {
    if (text == null) return [];
    var values = text.split(",");
    for(var i = 0, cnt = values.length; i < cnt; i++)values[i] = valueConverter(values[i]);
    return values;
};
var $c44561821864e5f0$export$2e2bcd8739ae039 = $c44561821864e5f0$var$ParseValue;



class $4eb951596d061d1e$var$BracketParser extends (0, $3e8a57a9b83b2076$export$2e2bcd8739ae039) {
    constructor(config){
        if (config === undefined) config = {};
        if (!config.hasOwnProperty("multipleLinesTag")) config.multipleLinesTag = false;
        super(config);
        // Parameters for regex
        this.setTagExpression((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "regex.tag", undefined));
        this.setValueExpression((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "regex.value", undefined));
        // Brackets and generate regex
        var delimiters = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "delimiters", "<>");
        this.setDelimiters(delimiters[0], delimiters[1]);
    }
    setTagExpression(express) {
        if (!express) express = $4eb951596d061d1e$var$DefaultTokenExpression;
        this.tagExpression = express;
        return this;
    }
    setValueExpression(express) {
        if (!express) express = $4eb951596d061d1e$var$DefaultTokenExpression;
        this.valueExpression = express;
        return this;
    }
    setDelimiters(delimiterLeft, delimiterRight) {
        super.setDelimiters(delimiterLeft, delimiterRight);
        var tag = `(${this.tagExpression})(=(${this.valueExpression}))?`;
        this.reTag = RegExp(tag, "i");
        if (this.tagExpression !== $4eb951596d061d1e$var$DefaultTokenExpression || this.valueExpression !== $4eb951596d061d1e$var$DefaultTokenExpression) {
            var startTagExpression = `${this.tagExpression}(=${this.valueExpression})?`;
            var endTagExpression = `/${this.tagExpression}`;
            delimiterLeft = (0, $2eb8f7579e816dbb$export$2e2bcd8739ae039)(this.delimiterLeft);
            delimiterRight = (0, $2eb8f7579e816dbb$export$2e2bcd8739ae039)(this.delimiterRight);
            var flag = this.multipleLinesTagEnable ? "gs" : "gi";
            this.reSplit = RegExp(`${delimiterLeft}((${startTagExpression})|(${endTagExpression}))${delimiterRight}`, flag);
        }
        return this;
    }
    onTag(tagContent) {
        var regexResult = tagContent.match(this.reTag);
        var tagName = regexResult[1];
        var isEndTag = tagName.charAt(0) === "/";
        if (isEndTag) tagName = tagName.substring(1, tagName.length);
        if (this.translateTagNameCallback) tagName = this.translateTagNameCallback(tagName);
        this.skipEventFlag = false;
        if (!isEndTag) {
            var values = (0, $c44561821864e5f0$export$2e2bcd8739ae039)(regexResult[3], this.valueConverter);
            this.emit(`+${tagName}`, ...values);
            if (!this.skipEventFlag) this.emit("+", tagName, ...values);
            this.lastTagStart = tagName;
        } else {
            this.emit(`-${tagName}`);
            if (!this.skipEventFlag) this.emit("-", tagName);
            this.lastTagEnd = tagName;
        }
    }
}
const $4eb951596d061d1e$var$DefaultTokenExpression = `[^=]+`;
var $4eb951596d061d1e$export$2e2bcd8739ae039 = $4eb951596d061d1e$var$BracketParser;


var $c5190bc0dd90be6e$export$2e2bcd8739ae039 = (0, $4eb951596d061d1e$export$2e2bcd8739ae039);


var $b5e2585d085d760e$var$OnParseColorTag = function(textPlayer, parser, config) {
    var tagName = "color";
    var defaultColor;
    parser.on("start", function() {
        defaultColor = textPlayer.textStyle.color;
    }).on(`+${tagName}`, function(color) {
        textPlayer.textStyle.setColor(color);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setColor(defaultColor);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setColor(defaultColor);
    });
};
var $b5e2585d085d760e$export$2e2bcd8739ae039 = $b5e2585d085d760e$var$OnParseColorTag;


var $3510e863adab1f49$var$OnParseStrokeColorTag = function(textPlayer, parser, config) {
    var tagName = "stroke";
    var defaultStroke;
    parser.on("start", function() {
        defaultStroke = textPlayer.textStyle.stroke;
        textPlayer.textStyle.setStrokeStyle(null);
    }).on(`+${tagName}`, function(color) {
        if (color === undefined) color = defaultStroke;
        textPlayer.textStyle.setStrokeStyle(color);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setStrokeStyle(null);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setStrokeStyle(defaultStroke);
    });
};
var $3510e863adab1f49$export$2e2bcd8739ae039 = $3510e863adab1f49$var$OnParseStrokeColorTag;


var $7b54352589c9cd4d$var$OnParseBoldTag = function(textPlayer, parser, config) {
    var tagName = "b";
    parser.on("start", function() {
        textPlayer.textStyle.setBold(false);
    }).on(`+${tagName}`, function() {
        textPlayer.textStyle.setBold(true);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setBold(false);
        parser.skipEvent();
    });
};
var $7b54352589c9cd4d$export$2e2bcd8739ae039 = $7b54352589c9cd4d$var$OnParseBoldTag;


var $3c73600c7d99f306$var$OnParseItalicTag = function(textPlayer, parser, config) {
    var tagName = "i";
    parser.on("start", function() {
        textPlayer.textStyle.setItalic(false);
    }).on(`+${tagName}`, function() {
        textPlayer.textStyle.setItalic(true);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setItalic(false);
        parser.skipEvent();
    });
};
var $3c73600c7d99f306$export$2e2bcd8739ae039 = $3c73600c7d99f306$var$OnParseItalicTag;


var $2789fc57ec6719da$var$OnParseFontSizeTag = function(textPlayer, parser, config) {
    var tagName = "size";
    var defaultFontSize;
    parser.on("start", function() {
        defaultFontSize = textPlayer.textStyle.fontSize;
    }).on(`+${tagName}`, function(fontSize) {
        textPlayer.textStyle.setFontSize(fontSize);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setFontSize(defaultFontSize);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setFontSize(defaultFontSize);
    });
};
var $2789fc57ec6719da$export$2e2bcd8739ae039 = $2789fc57ec6719da$var$OnParseFontSizeTag;


var $f185739860ce276c$var$OnParseOffsetYTag = function(textPlayer, parser, config) {
    var tagName = "y";
    var defaultOffsetY;
    parser.on("start", function() {
        defaultOffsetY = textPlayer.textStyle.offsetY;
        textPlayer.textStyle.setOffsetY(0);
    }).on(`+${tagName}`, function(y) {
        if (y === undefined) y = defaultOffsetY;
        textPlayer.textStyle.setOffsetY(y);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setOffsetY(0);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setOffsetY(0);
    });
};
var $f185739860ce276c$export$2e2bcd8739ae039 = $f185739860ce276c$var$OnParseOffsetYTag;


var $bb9e865e62364ef0$var$OnParseOffsetXTag = function(textPlayer, parser, config) {
    var tagName = "x";
    var defaultOffsetX;
    parser.on("start", function() {
        defaultOffsetX = textPlayer.textStyle.offsetY;
        textPlayer.textStyle.setOffsetX(0);
    }).on(`+${tagName}`, function(y) {
        if (y === undefined) y = defaultOffsetX;
        textPlayer.textStyle.setOffsetX(y);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setOffsetX(0);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setOffsetX(0);
    });
};
var $bb9e865e62364ef0$export$2e2bcd8739ae039 = $bb9e865e62364ef0$var$OnParseOffsetXTag;


var $f6ae67727b2f1f0d$var$OnParseLeftSpaceTag = function(textPlayer, parser, config) {
    var tagName = "left";
    var defaultLeftSpace;
    parser.on("start", function() {
        defaultLeftSpace = textPlayer.textStyle.leftSpace;
        textPlayer.textStyle.setLeftSpace(0);
    }).on(`+${tagName}`, function(space) {
        if (space === undefined) space = defaultLeftSpace;
        textPlayer.textStyle.setLeftSpace(space);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setLeftSpace(0);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setLeftSpace(0);
    });
};
var $f6ae67727b2f1f0d$export$2e2bcd8739ae039 = $f6ae67727b2f1f0d$var$OnParseLeftSpaceTag;


var $37740a088b8d082a$var$OnParseRightSpaceTag = function(textPlayer, parser, config) {
    var tagName = "right";
    var defaultRightSpace;
    parser.on("start", function() {
        defaultRightSpace = textPlayer.textStyle.rightSpace;
        textPlayer.textStyle.setRightSpace(0);
    }).on(`+${tagName}`, function(space) {
        if (space === undefined) space = defaultRightSpace;
        textPlayer.textStyle.setRightSpace(space);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setRightSpace(0);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setRightSpace(0);
    });
};
var $37740a088b8d082a$export$2e2bcd8739ae039 = $37740a088b8d082a$var$OnParseRightSpaceTag;


var $dc61f5a61aedf8c5$var$OnParseShadowColorTag = function(textPlayer, parser, config) {
    var tagName = "shadow";
    var defaultShadowColor;
    parser.on("start", function() {
        defaultShadowColor = textPlayer.textStyle.shadowColor;
        textPlayer.textStyle.setShadowColor(null);
    }).on(`+${tagName}`, function(color) {
        if (color === undefined) color = defaultShadowColor;
        textPlayer.textStyle.setShadowColor(color);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setShadowColor(null);
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setShadowColor(defaultShadowColor);
    });
};
var $dc61f5a61aedf8c5$export$2e2bcd8739ae039 = $dc61f5a61aedf8c5$var$OnParseShadowColorTag;


var $e12dcae57eeb10bf$var$OnParseAlignTag = function(textPlayer, parser, config) {
    var tagName = "align";
    parser.on(`+${tagName}`, function(align) {
        textPlayer.textStyle.setAlign(align);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        textPlayer.textStyle.setAlign();
        parser.skipEvent();
    }).on("complete", function() {
        textPlayer.textStyle.setAlign();
    });
};
var $e12dcae57eeb10bf$export$2e2bcd8739ae039 = $e12dcae57eeb10bf$var$OnParseAlignTag;



var $676ef01a05cae0ff$var$OnParseImageTag = function(textPlayer, parser, config) {
    var tagName = "img";
    parser.on(`+${tagName}`, function(name) {
        var imgData = textPlayer.imageManager.get(name);
        (0, $6d623769bfdd4525$export$2e2bcd8739ae039).call(textPlayer, imgData.key, imgData.frame, {
            width: imgData.width,
            hieght: imgData.height,
            leftSpace: imgData.left,
            rightSpace: imgData.right
        });
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $676ef01a05cae0ff$export$2e2bcd8739ae039 = $676ef01a05cae0ff$var$OnParseImageTag;



var $7c473ddf997b1c1c$var$OnParseImageTag = function(textPlayer, parser, config) {
    var tagName = "space";
    parser.on(`+${tagName}`, function(width) {
        (0, $5a2f0ac7beb464ab$export$2e2bcd8739ae039).call(textPlayer, width);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $7c473ddf997b1c1c$export$2e2bcd8739ae039 = $7c473ddf997b1c1c$var$OnParseImageTag;



var $796ff13f2d08f613$var$OnParseTypingSpeedTag = function(textPlayer, parser, config) {
    var tagName = "speed";
    parser.on(`+${tagName}`, function(speed) {
        $796ff13f2d08f613$var$AppendCommand(textPlayer, speed);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        $796ff13f2d08f613$var$AppendCommand(textPlayer, undefined);
        parser.skipEvent();
    });
};
var $796ff13f2d08f613$var$SetTypingSpeed = function(speed) {
    this.typeWriter.setTypingSpeed(speed); // this: textPlayer
};
var $796ff13f2d08f613$var$AppendCommand = function(textPlayer, speed) {
    (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "speed", $796ff13f2d08f613$var$SetTypingSpeed, speed, textPlayer);
};
var $796ff13f2d08f613$export$2e2bcd8739ae039 = $796ff13f2d08f613$var$OnParseTypingSpeedTag;



var $c1faab8110b696f1$var$OnParsePlaySoundEffectTag = function(textPlayer, parser, config) {
    var tagName = "se";
    parser.on(`+${tagName}`, function(name, fadeInTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $c1faab8110b696f1$var$PlaySoundEffect, [
            name,
            fadeInTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "se2";
    parser.on(`+${tagName}`, function(name, fadeInTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $c1faab8110b696f1$var$PlaySoundEffect2, [
            name,
            fadeInTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $c1faab8110b696f1$var$PlaySoundEffect = function(params) {
    if (this.skipSoundEffect) return;
    var name = params[0];
    var fadeInTime = params[1];
    this.soundManager.playSoundEffect(name); // this: textPlayer
    if (fadeInTime) this.soundManager.fadeInSoundEffect(fadeInTime);
};
var $c1faab8110b696f1$var$PlaySoundEffect2 = function(params) {
    if (this.skipSoundEffect) return;
    var name = params[0];
    var fadeInTime = params[1];
    this.soundManager.playSoundEffect2(name); // this: textPlayer
    if (fadeInTime) this.soundManager.fadeInSoundEffect2(fadeInTime);
};
var $c1faab8110b696f1$export$2e2bcd8739ae039 = $c1faab8110b696f1$var$OnParsePlaySoundEffectTag;



var $2076661f541fd567$var$OnParseFadeInSoundEffectTag = function(textPlayer, parser, config) {
    var tagName = "se.fadein";
    parser.on(`+${tagName}`, function(time) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $2076661f541fd567$var$FadeInSoundEffect, time, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "se2.fadein";
    parser.on(`+${tagName}`, function(time) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $2076661f541fd567$var$FadeInSoundEffect2, time, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $2076661f541fd567$var$FadeInSoundEffect = function(time) {
    // this: textPlayer
    this.soundManager.fadeInSoundEffect(time);
};
var $2076661f541fd567$var$FadeInSoundEffect2 = function(time) {
    // this: textPlayer
    this.soundManager.fadeInSoundEffect2(time);
};
var $2076661f541fd567$export$2e2bcd8739ae039 = $2076661f541fd567$var$OnParseFadeInSoundEffectTag;



var $6f11db08e0ea1d00$var$OnParseFadeOutSoundEffectTag = function(textPlayer, parser, config) {
    var tagName = "se.fadeout";
    parser.on(`+${tagName}`, function(time, isStopped) {
        isStopped = isStopped === "stop";
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $6f11db08e0ea1d00$var$FadeOutSoundEffect, [
            time,
            isStopped
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "se2.fadeout";
    parser.on(`+${tagName}`, function(time, isStopped) {
        isStopped = isStopped === "stop";
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $6f11db08e0ea1d00$var$FadeOutSoundEffect2, [
            time,
            isStopped
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $6f11db08e0ea1d00$var$FadeOutSoundEffect = function(params) {
    // this: textPlayer
    this.soundManager.fadeOutSoundEffect(...params);
};
var $6f11db08e0ea1d00$var$FadeOutSoundEffect2 = function(params) {
    // this: textPlayer
    this.soundManager.fadeOutSoundEffect2(...params);
};
var $6f11db08e0ea1d00$export$2e2bcd8739ae039 = $6f11db08e0ea1d00$var$OnParseFadeOutSoundEffectTag;



var $8f4c98b16a970260$var$OnParseSetSoundEffectVolumeTag = function(textPlayer, parser, config) {
    var tagName = "se.volume";
    parser.on(`+${tagName}`, function(volume) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $8f4c98b16a970260$var$SetSoundEffectVolume, volume, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "se2.volume";
    parser.on(`+${tagName}`, function(volume) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $8f4c98b16a970260$var$SetSoundEffectVolume2, volume, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $8f4c98b16a970260$var$SetSoundEffectVolume = function(volume) {
    // this: textPlayer
    this.soundManager.setSoundEffectVolume(volume, true);
};
var $8f4c98b16a970260$var$SetSoundEffectVolume2 = function(volume) {
    // this: textPlayer
    this.soundManager.setSoundEffectVolume2(volume, true);
};
var $8f4c98b16a970260$export$2e2bcd8739ae039 = $8f4c98b16a970260$var$OnParseSetSoundEffectVolumeTag;



var $bc034d513df5a345$var$OnParsePlayBackgroundMusicTag = function(textPlayer, parser, config) {
    var tagName = "bgm";
    parser.on(`+${tagName}`, function(name, fadeInTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $bc034d513df5a345$var$PlayBackgroundMusic, [
            name,
            fadeInTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "bgm.stop", $bc034d513df5a345$var$StopBackgroundMusic, undefined, textPlayer);
        parser.skipEvent();
    });
    var tagName = "bgm2";
    parser.on(`+${tagName}`, function(name, fadeInTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $bc034d513df5a345$var$PlayBackgroundMusic2, [
            name,
            fadeInTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "bgm2.stop", $bc034d513df5a345$var$StopBackgroundMusic2, undefined, textPlayer);
        parser.skipEvent();
    });
};
var $bc034d513df5a345$var$PlayBackgroundMusic = function(params) {
    var name = params[0];
    var fadeInTime = params[1];
    // this: textPlayer
    this.soundManager.playBackgroundMusic(name);
    if (fadeInTime) this.soundManager.fadeInBackgroundMusic(fadeInTime);
};
var $bc034d513df5a345$var$StopBackgroundMusic = function() {
    // this: textPlayer
    this.soundManager.stopBackgroundMusic();
};
var $bc034d513df5a345$var$PlayBackgroundMusic2 = function(params) {
    var name = params[0];
    var fadeInTime = params[1];
    // this: textPlayer
    this.soundManager.playBackgroundMusic2(name);
    if (fadeInTime) this.soundManager.fadeInBackgroundMusic2(fadeInTime);
};
var $bc034d513df5a345$var$StopBackgroundMusic2 = function() {
    // this: textPlayer
    this.soundManager.stopBackgroundMusic2();
};
var $bc034d513df5a345$export$2e2bcd8739ae039 = $bc034d513df5a345$var$OnParsePlayBackgroundMusicTag;



var $e8836ab6db12d18a$var$OnParseFadeInBackgroundMusicTag = function(textPlayer, parser, config) {
    var tagName = "bgm.fadein";
    parser.on(`+${tagName}`, function(time) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $e8836ab6db12d18a$var$FadeInBackgroundMusic, time, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "bgm2.fadein";
    parser.on(`+${tagName}`, function(time) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $e8836ab6db12d18a$var$FadeInBackgroundMusic2, time, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $e8836ab6db12d18a$var$FadeInBackgroundMusic = function(time) {
    // this: textPlayer
    this.soundManager.fadeInBackgroundMusic(time);
};
var $e8836ab6db12d18a$var$FadeInBackgroundMusic2 = function(time) {
    // this: textPlayer
    this.soundManager.fadeInBackgroundMusic2(time);
};
var $e8836ab6db12d18a$export$2e2bcd8739ae039 = $e8836ab6db12d18a$var$OnParseFadeInBackgroundMusicTag;



var $a325e5fd2a053014$var$OnParseFadeOutBackgroundMusicTag = function(textPlayer, parser, config) {
    var tagName = "bgm.fadeout";
    parser.on(`+${tagName}`, function(time, isStopped) {
        isStopped = isStopped === "stop";
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $a325e5fd2a053014$var$FadeOutBackgroundMusic, [
            time,
            isStopped
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "bgm2.fadeout";
    parser.on(`+${tagName}`, function(time, isStopped) {
        isStopped = isStopped === "stop";
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $a325e5fd2a053014$var$FadeOutBackgroundMusic2, [
            time,
            isStopped
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $a325e5fd2a053014$var$FadeOutBackgroundMusic = function(params) {
    // this: textPlayer
    this.soundManager.fadeOutBackgroundMusic(...params);
};
var $a325e5fd2a053014$var$FadeOutBackgroundMusic2 = function(params) {
    // this: textPlayer
    this.soundManager.fadeOutBackgroundMusic2(...params);
};
var $a325e5fd2a053014$export$2e2bcd8739ae039 = $a325e5fd2a053014$var$OnParseFadeOutBackgroundMusicTag;



var $1d4206e8002a5a76$var$OnParseCrossFadeBackgroundMusicTag = function(textPlayer, parser, config) {
    var tagName = "bgm.cross";
    parser.on(`+${tagName}`, function(name, fadeTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $1d4206e8002a5a76$var$CrossFadeBackgroundMusic, [
            name,
            fadeTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
    var tagName = "bgm2.cross";
    parser.on(`+${tagName}`, function(name, fadeTime) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $1d4206e8002a5a76$var$CrossFadeBackgroundMusic2, [
            name,
            fadeTime
        ], textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $1d4206e8002a5a76$var$CrossFadeBackgroundMusic = function(params) {
    // this: textPlayer
    this.soundManager.crossFadeBackgroundMusic(...params);
};
var $1d4206e8002a5a76$var$CrossFadeBackgroundMusic2 = function(params) {
    // this: textPlayer
    this.soundManager.crossFadeBackgroundMusic2(...params);
};
var $1d4206e8002a5a76$export$2e2bcd8739ae039 = $1d4206e8002a5a76$var$OnParseCrossFadeBackgroundMusicTag;



var $a70229f5ba982bca$var$OnParsePauseBackgroundMusicTag = function(textPlayer, parser, config) {
    var tagName = "bgm.pause";
    parser.on(`+${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $a70229f5ba982bca$var$PauseBackgroundMusic, undefined, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "bgm.resume", $a70229f5ba982bca$var$ResumeBackgroundMusic, undefined, textPlayer);
        parser.skipEvent();
    });
    var tagName = "bgm2.pause";
    parser.on(`+${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $a70229f5ba982bca$var$PauseBackgroundMusic2, undefined, textPlayer);
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "bgm2.resume", $a70229f5ba982bca$var$ResumeBackgroundMusic2, undefined, textPlayer);
        parser.skipEvent();
    });
};
var $a70229f5ba982bca$var$PauseBackgroundMusic = function() {
    // this: textPlayer
    this.soundManager.pauseBackgroundMusic();
};
var $a70229f5ba982bca$var$ResumeBackgroundMusic = function() {
    // this: textPlayer
    this.soundManager.resumeBackgroundMusic();
};
var $a70229f5ba982bca$var$PauseBackgroundMusic2 = function() {
    // this: textPlayer
    this.soundManager.pauseBackgroundMusic2();
};
var $a70229f5ba982bca$var$ResumeBackgroundMusic2 = function() {
    // this: textPlayer
    this.soundManager.resumeBackgroundMusic2();
};
var $a70229f5ba982bca$export$2e2bcd8739ae039 = $a70229f5ba982bca$var$OnParsePauseBackgroundMusicTag;



var $0a3217c05e09aaf3$var$OnParseFadeInCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.fadein";
    parser.on(`+${tagName}`, function(duration, red, green, blue) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $0a3217c05e09aaf3$var$PlayFadeInEffect, [
            duration,
            red,
            green,
            blue
        ], textPlayer);
        parser.skipEvent();
    });
};
var $0a3217c05e09aaf3$var$PlayFadeInEffect = function(params) {
    // this: textPlayer
    this.targetCamera.fadeIn(...params);
};
var $0a3217c05e09aaf3$export$2e2bcd8739ae039 = $0a3217c05e09aaf3$var$OnParseFadeInCameraTag;



var $e194c663220b8dd9$var$OnParseFadeOutCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.fadeout";
    parser.on(`+${tagName}`, function(duration, red, green, blue) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $e194c663220b8dd9$var$PlayFadeOutEffect, [
            duration,
            red,
            green,
            blue
        ], textPlayer);
        parser.skipEvent();
    });
};
var $e194c663220b8dd9$var$PlayFadeOutEffect = function(params) {
    // this: textPlayer
    this.targetCamera.fadeOut(...params);
};
var $e194c663220b8dd9$export$2e2bcd8739ae039 = $e194c663220b8dd9$var$OnParseFadeOutCameraTag;



var $0cdc97993737eb78$var$OnParseShakeCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.shake";
    parser.on(`+${tagName}`, function(duration, intensity) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $0cdc97993737eb78$var$PlayShakeEffect, [
            duration,
            intensity
        ], textPlayer);
        parser.skipEvent();
    });
};
var $0cdc97993737eb78$var$PlayShakeEffect = function(params) {
    // this: textPlayer
    this.targetCamera.shake(...params);
};
var $0cdc97993737eb78$export$2e2bcd8739ae039 = $0cdc97993737eb78$var$OnParseShakeCameraTag;



var $4a7235a837f1ac4c$var$OnParseFlashCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.flash";
    parser.on(`+${tagName}`, function(duration, red, green, blue) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $4a7235a837f1ac4c$var$PlayFlashEffect, [
            duration,
            red,
            green,
            blue
        ], textPlayer);
        parser.skipEvent();
    });
};
var $4a7235a837f1ac4c$var$PlayFlashEffect = function(params) {
    // this: textPlayer
    this.targetCamera.flash(...params);
};
var $4a7235a837f1ac4c$export$2e2bcd8739ae039 = $4a7235a837f1ac4c$var$OnParseFlashCameraTag;



var $e9f12af69f583e50$var$OnParseZoomCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.zoom";
    parser.on(`+${tagName}`, function(value) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $e9f12af69f583e50$var$Zoom, value, textPlayer);
        parser.skipEvent();
    }).on(`+${tagName}.to`, function(value, duration, ease) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "camera.zoom.to", $e9f12af69f583e50$var$ZoomTo, [
            value,
            duration,
            ease
        ], textPlayer);
        parser.skipEvent();
    });
};
var $e9f12af69f583e50$var$Zoom = function(value) {
    // this: textPlayer
    this.targetCamera.setZoom(value);
};
var $e9f12af69f583e50$var$ZoomTo = function(params) {
    // this: textPlayer
    this.targetCamera.zoomTo(...params);
};
var $e9f12af69f583e50$export$2e2bcd8739ae039 = $e9f12af69f583e50$var$OnParseZoomCameraTag;



const $b9649d60846d68be$var$DegToRad = Phaser.Math.DegToRad;
var $b9649d60846d68be$var$OnParseRotateCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.rotate";
    parser.on(`+${tagName}`, function(value) {
        value = $b9649d60846d68be$var$DegToRad(value);
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $b9649d60846d68be$var$Rotate, value, textPlayer);
        parser.skipEvent();
    }).on(`+${tagName}.to`, function(value, duration, ease) {
        value = $b9649d60846d68be$var$DegToRad(value);
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "camera.rotate.to", $b9649d60846d68be$var$RotateTo, [
            value,
            duration,
            ease
        ], textPlayer);
        parser.skipEvent();
    });
};
var $b9649d60846d68be$var$Rotate = function(value) {
    // this: textPlayer
    this.targetCamera.setRotation(value);
};
var $b9649d60846d68be$var$RotateTo = function(params) {
    var value = params[0];
    var duration = params[1];
    var ease = params[2];
    // this: textPlayer
    this.targetCamera.rotateTo(value, false, duration, ease);
};
var $b9649d60846d68be$export$2e2bcd8739ae039 = $b9649d60846d68be$var$OnParseRotateCameraTag;



var $948e2b338233dc6e$var$OnParseScrollCameraTag = function(textPlayer, parser, config) {
    var tagName = "camera.scroll";
    parser.on(`+${tagName}`, function(x, y) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, tagName, $948e2b338233dc6e$var$Scroll, [
            x,
            y
        ], textPlayer);
        parser.skipEvent();
    }).on(`+${tagName}.to`, function(x, y, duration, ease) {
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "camera.scroll.to", $948e2b338233dc6e$var$ScrollTo, [
            x,
            y,
            duration,
            ease
        ], textPlayer);
        parser.skipEvent();
    });
};
var $948e2b338233dc6e$var$Scroll = function(params) {
    // this: textPlayer
    this.targetCamera.setScroll(...params);
};
var $948e2b338233dc6e$var$ScrollTo = function(params) {
    var x = params[0];
    var y = params[1];
    var duration = params[2];
    var ease = params[3];
    // this: textPlayer
    var camera = this.targetCamera;
    var xSave = camera.scrollX;
    var ySave = camera.scrollY;
    camera.setScroll(x, y);
    x += camera.centerX;
    y += camera.centerY;
    camera.setScroll(xSave, ySave);
    // x,y in pan() is the centerX, centerY
    camera.pan(x, y, duration, ease);
};
var $948e2b338233dc6e$export$2e2bcd8739ae039 = $948e2b338233dc6e$var$OnParseScrollCameraTag;



var $e1eeedf5457fbec8$var$OnParseWaitTag = function(textPlayer, parser, config) {
    var tagWait = "wait";
    var tagClick = "click";
    parser.on(`+${tagWait}`, function(name) {
        $e1eeedf5457fbec8$var$AppendCommand(textPlayer, name);
        parser.skipEvent();
    }).on(`-${tagWait}`, function() {
        parser.skipEvent();
    }).on(`+${tagClick}`, function() {
        $e1eeedf5457fbec8$var$AppendCommand(textPlayer, "click");
        parser.skipEvent();
    }).on(`-${tagClick}`, function() {
        parser.skipEvent();
    });
};
var $e1eeedf5457fbec8$var$Wait = function(name) {
    this.typeWriter.wait(name); // this: textPlayer
};
var $e1eeedf5457fbec8$var$AppendCommand = function(textPlayer, name) {
    (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, "wait", $e1eeedf5457fbec8$var$Wait, name, textPlayer);
};
var $e1eeedf5457fbec8$export$2e2bcd8739ae039 = $e1eeedf5457fbec8$var$OnParseWaitTag;



var $d84611a5005a5c26$var$OnParseNewLineTag = function(textPlayer, parser, config) {
    var tagName = "r";
    parser.on(`+${tagName}`, function() {
        (0, $a1b2cd985c54bbaf$export$2e2bcd8739ae039).call(textPlayer, "\n");
        parser.skipEvent();
    }).on(`-${tagName}`, function() {
        parser.skipEvent();
    });
};
var $d84611a5005a5c26$export$2e2bcd8739ae039 = $d84611a5005a5c26$var$OnParseNewLineTag;



var $c1655c55a750292f$var$OnParsePageBreakTag = function(textPlayer, parser, config) {
    var tagNames = [
        "pagebreak",
        "pb"
    ];
    for(var i = 0, cnt = tagNames.length; i < cnt; i++){
        var tagName = tagNames[i];
        parser.on(`+${tagName}`, function() {
            (0, $a1b2cd985c54bbaf$export$2e2bcd8739ae039).call(textPlayer, "\f");
            parser.skipEvent();
        }).on(`-${tagName}`, function() {
            parser.skipEvent();
        });
    }
};
var $c1655c55a750292f$export$2e2bcd8739ae039 = $c1655c55a750292f$var$OnParsePageBreakTag;


var $10155a3f0257ad63$var$OnParseContentOff = function(textPlayer, parser, config) {
    var tagName = "content.off";
    parser.on(`+${tagName}`, function() {
        parser.setContentOutputEnable(false);
        parser.skipEvent();
    });
};
var $10155a3f0257ad63$export$2e2bcd8739ae039 = $10155a3f0257ad63$var$OnParseContentOff;


var $115d641c1f326d07$var$OnParseContentOn = function(textPlayer, parser, config) {
    var tagName = "content.on";
    parser.on(`+${tagName}`, function() {
        parser.setContentOutputEnable();
        parser.skipEvent();
    });
};
var $115d641c1f326d07$export$2e2bcd8739ae039 = $115d641c1f326d07$var$OnParseContentOn;



var $496bdf392571011d$var$OnParseContent = function(textPlayer, parser, config) {
    parser.on("content", function(content) {
        if (parser.contentOutputEnable) (0, $a1b2cd985c54bbaf$export$2e2bcd8739ae039).call(textPlayer, content);
        else {
            var startTag = `+${parser.lastTagStart}`;
            textPlayer.emit(`parser.${startTag}#content`, parser, content);
        }
    });
};
var $496bdf392571011d$export$2e2bcd8739ae039 = $496bdf392571011d$var$OnParseContent;



var $6c329b15c50f5c31$var$OnParseCustomTag = function(textPlayer, parser, config) {
    parser.on("start", function() {
        textPlayer.emit("parser.start", parser);
    }).on("+", function(tagName, ...value) {
        if (parser.skipEventFlag) return;
        var startTag = `+${tagName}`;
        var param = value;
        textPlayer.emit(`parser.${startTag}`, parser, ...value, param);
        $6c329b15c50f5c31$var$AppendCommand(textPlayer, startTag, param);
    }).on("-", function(tagName) {
        if (parser.skipEventFlag) return;
        var endTag = `-${tagName}`;
        var param = [];
        textPlayer.emit(`parser.${endTag}`, parser, param);
        $6c329b15c50f5c31$var$AppendCommand(textPlayer, endTag, param);
    }).on("complete", function() {
        textPlayer.emit("parser.complete", parser);
    });
};
var $6c329b15c50f5c31$var$FireEvent = function(param, tagName) {
    var eventName = `tag.${tagName}`;
    // this: textPlayer
    if (param == null) this.emit(eventName);
    else this.emit(eventName, ...param);
};
var $6c329b15c50f5c31$var$AppendCommand = function(textPlayer, name, param) {
    (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, name, $6c329b15c50f5c31$var$FireEvent, param, textPlayer);
};
var $6c329b15c50f5c31$export$2e2bcd8739ae039 = $6c329b15c50f5c31$var$OnParseCustomTag;


const $49003e8391f07be6$var$ParseCallbacks = [
    (0, $b5e2585d085d760e$export$2e2bcd8739ae039),
    (0, $3510e863adab1f49$export$2e2bcd8739ae039),
    (0, $7b54352589c9cd4d$export$2e2bcd8739ae039),
    (0, $3c73600c7d99f306$export$2e2bcd8739ae039),
    (0, $2789fc57ec6719da$export$2e2bcd8739ae039),
    (0, $dc61f5a61aedf8c5$export$2e2bcd8739ae039),
    (0, $e12dcae57eeb10bf$export$2e2bcd8739ae039),
    (0, $f185739860ce276c$export$2e2bcd8739ae039),
    (0, $bb9e865e62364ef0$export$2e2bcd8739ae039),
    (0, $f6ae67727b2f1f0d$export$2e2bcd8739ae039),
    (0, $37740a088b8d082a$export$2e2bcd8739ae039),
    (0, $676ef01a05cae0ff$export$2e2bcd8739ae039),
    (0, $7c473ddf997b1c1c$export$2e2bcd8739ae039),
    (0, $796ff13f2d08f613$export$2e2bcd8739ae039),
    (0, $c1faab8110b696f1$export$2e2bcd8739ae039),
    (0, $2076661f541fd567$export$2e2bcd8739ae039),
    (0, $6f11db08e0ea1d00$export$2e2bcd8739ae039),
    (0, $8f4c98b16a970260$export$2e2bcd8739ae039),
    (0, $bc034d513df5a345$export$2e2bcd8739ae039),
    (0, $e8836ab6db12d18a$export$2e2bcd8739ae039),
    (0, $a325e5fd2a053014$export$2e2bcd8739ae039),
    (0, $1d4206e8002a5a76$export$2e2bcd8739ae039),
    (0, $a70229f5ba982bca$export$2e2bcd8739ae039),
    (0, $0a3217c05e09aaf3$export$2e2bcd8739ae039),
    (0, $e194c663220b8dd9$export$2e2bcd8739ae039),
    (0, $0cdc97993737eb78$export$2e2bcd8739ae039),
    (0, $4a7235a837f1ac4c$export$2e2bcd8739ae039),
    (0, $e9f12af69f583e50$export$2e2bcd8739ae039),
    (0, $b9649d60846d68be$export$2e2bcd8739ae039),
    (0, $948e2b338233dc6e$export$2e2bcd8739ae039),
    (0, $e1eeedf5457fbec8$export$2e2bcd8739ae039),
    (0, $d84611a5005a5c26$export$2e2bcd8739ae039),
    (0, $c1655c55a750292f$export$2e2bcd8739ae039),
    (0, $10155a3f0257ad63$export$2e2bcd8739ae039),
    (0, $115d641c1f326d07$export$2e2bcd8739ae039),
    (0, $496bdf392571011d$export$2e2bcd8739ae039),
    (0, $6c329b15c50f5c31$export$2e2bcd8739ae039)
];
var $49003e8391f07be6$var$AddParseCallbacks = function(textPlayer, parser, config) {
    for(var i = 0, cnt = $49003e8391f07be6$var$ParseCallbacks.length; i < cnt; i++)$49003e8391f07be6$var$ParseCallbacks[i](textPlayer, parser, config);
};
var $49003e8391f07be6$export$2e2bcd8739ae039 = $49003e8391f07be6$var$AddParseCallbacks;


/*
Skip line
- An empty line, only has space
- A comment line, start with commentLineStart ('//')
*/ var $32dc1635635be1f1$var$PreProcess = function(parser, source) {
    var comentLineStart = parser.commentLineStart;
    var lines = source.split("\n");
    for(var i = 0, cnt = lines.length; i < cnt; i++){
        var line = lines[i];
        if (line === "") ;
        else if (line.trim().length === 0) // An empty line, only has space
        lines[i] = "";
        else if (comentLineStart && line.startsWith(comentLineStart)) // A comment line, start with commentLineStart ('//')
        lines[i] = "";
    }
    // Use [r] to put \n
    return lines.join("");
};
var $32dc1635635be1f1$export$2e2bcd8739ae039 = $32dc1635635be1f1$var$PreProcess;


const $da22066eb14ef287$var$GetValue = Phaser.Utils.Objects.GetValue;
class $da22066eb14ef287$var$Parser extends (0, $c5190bc0dd90be6e$export$2e2bcd8739ae039) {
    constructor(textPlayer, config){
        if (config === undefined) config = {};
        if (!config.hasOwnProperty("delimiters")) config.delimiters = "[]";
        super(config);
        (0, $49003e8391f07be6$export$2e2bcd8739ae039)(textPlayer, this, config);
        this.setCommentLineStartSymbol($da22066eb14ef287$var$GetValue(config, "comment", "//"));
        this.setContentOutputEnable();
    }
    setCommentLineStartSymbol(symbol) {
        this.commentLineStart = symbol;
        return this;
    }
    setContentOutputEnable(enable) {
        if (enable === undefined) enable = true;
        this.contentOutputEnable = enable;
        return this;
    }
    start(source) {
        super.start((0, $32dc1635635be1f1$export$2e2bcd8739ae039)(this, source));
        return this;
    }
}
var $da22066eb14ef287$export$2e2bcd8739ae039 = $da22066eb14ef287$var$Parser;



var $ab18d50c55a363fb$export$2e2bcd8739ae039 = {
    setDefaultTypingSpeed (speed) {
        this.defaultSpeed = speed;
        return this;
    },
    setTypingSpeed (speed) {
        if (speed === undefined) speed = this.defaultSpeed;
        this.speed = speed;
        return this;
    }
};


const $697dceb1188400d2$var$PageFadeOutCompleteEvent = "page.fadeout";
var $697dceb1188400d2$var$FadeOutPage = function() {
    if (!this.fadeOutPageCallback || !this.children) {
        this.emit($697dceb1188400d2$var$PageFadeOutCompleteEvent);
        return this;
    }
    var renderableChildren = this.children.filter(function(child) {
        return child.renderable;
    });
    var waitObject = this.fadeOutPageCallback(renderableChildren, this.fadeOutPageDuration);
    if (!waitObject) this.emit($697dceb1188400d2$var$PageFadeOutCompleteEvent);
    else if (waitObject.once) waitObject.once("complete", function() {
        this.emit($697dceb1188400d2$var$PageFadeOutCompleteEvent);
    }, this);
    else if (waitObject.then) {
        var self = this;
        waitObject.then(function() {
            self.emit($697dceb1188400d2$var$PageFadeOutCompleteEvent);
        });
    } else this.emit($697dceb1188400d2$var$PageFadeOutCompleteEvent);
    return this;
};
var $697dceb1188400d2$export$2e2bcd8739ae039 = $697dceb1188400d2$var$FadeOutPage;


var $2b5b0b08519578fd$export$64e00c1c113b35b1 = function(eventEmitter, eventName) {
    return new Promise(function(resolve, reject) {
        eventEmitter.once(eventName, function() {
            resolve();
        });
    });
};
var $2b5b0b08519578fd$export$f539506d32c8afaa = function(eventEmitter) {
    return $2b5b0b08519578fd$export$64e00c1c113b35b1(eventEmitter, "complete");
};


var $35575e0f5c09ce8a$var$Start = function(children) {
    this.children = children;
    this.index = 0;
    this.isPageTyping = true;
    if (this.onTypeStart) this.onTypeStart(children);
    this.typing();
    return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this); // Promise
};
var $35575e0f5c09ce8a$export$2e2bcd8739ae039 = $35575e0f5c09ce8a$var$Start;



const $0eed0dd02cd38de1$export$e9171358ae8cd2e8 = "delay";
const $0eed0dd02cd38de1$export$beb72ae4653b914b = "anim";


var $e1968fe14742aaff$var$Typing = function(offsetTime) {
    if (offsetTime === undefined) offsetTime = 0;
    var delay = 0;
    this.inTypingProcessLoop = true;
    while(this.inTypingProcessLoop){
        var child = this.getNextChild();
        if (!child) {
            if (this.timeline.isRunning) // Wait until last animationConfig is end
            this.timeline.once("complete", function() {
                this.isPageTyping = false;
                this.emit("complete");
            }, this);
            else {
                this.isPageTyping = false;
                this.emit("complete");
            }
            break; // Leave this typing loop
        }
        if (child.renderable) {
            // Typing this char
            var animationConfig = this.animationConfig;
            if (animationConfig.duration > 0) {
                var animationTimer = this.timeline.addTimer({
                    name: (0, $0eed0dd02cd38de1$export$beb72ae4653b914b),
                    target: child,
                    duration: animationConfig.duration,
                    yoyo: animationConfig.yoyo,
                    onStart: animationConfig.onStart,
                    onProgress: animationConfig.onProgress,
                    onComplete: animationConfig.onComplete
                });
                if (this.skipTypingAnimation) animationTimer.seek(1);
            } else if (animationConfig.onStart) animationConfig.onStart(child, 0);
            // Set to min size
            if (this.minSizeEnable) this.textPlayer.setToMinSize();
            this.textPlayer.emit("typing", child);
            var nextChild = this.nextChild;
            if (nextChild) {
                if (this.skipSpaceEnable && (0, $5ef7af43adf3a4f3$export$be5f01e68f8ba9f9)(nextChild)) ;
                else {
                    delay += this.speed + offsetTime;
                    offsetTime = 0;
                    if (delay > 0) {
                        // Process next character later
                        this.typingTimer = this.timeline.addTimer({
                            name: (0, $0eed0dd02cd38de1$export$e9171358ae8cd2e8),
                            target: this,
                            duration: delay,
                            onComplete: function(target, t, timer) {
                                target.typingTimer = undefined;
                                $e1968fe14742aaff$var$Typing.call(target, timer.remainder);
                            }
                        });
                        break; // Leave this typing loop     
                    }
                }
            }
        // Process next child
        } else if ((0, $5ef7af43adf3a4f3$export$5d4d9a7a8abe34b5)(child)) child.exec();
    }
    // Set to min size
    if (this.minSizeEnable) this.textPlayer.setToMinSize();
    this.inTypingProcessLoop = false;
};
var $e1968fe14742aaff$export$2e2bcd8739ae039 = $e1968fe14742aaff$var$Typing;


var $f9c86ffa86229e88$var$Pause = function() {
    // Pause typing timer and animation progresses
    this.timeline.pause();
    return this;
};
var $f9c86ffa86229e88$export$2e2bcd8739ae039 = $f9c86ffa86229e88$var$Pause;


var $b75460df8addbfde$var$Resume = function() {
    // Resume typing timer and animation progresses
    this.timeline.resume();
    return this;
};
var $b75460df8addbfde$export$2e2bcd8739ae039 = $b75460df8addbfde$var$Resume;


var $1c42a84d8b7875c8$var$PauseTyping = function() {
    // Already in typingPaused state
    if (this.isTypingPaused) return this;
    if (this.typingTimer) {
        this.typingTimer.pause();
        this.isTypingPaused = true;
    } else if (this.inTypingProcessLoop) {
        this.inTypingProcessLoop = false;
        this.isTypingPaused = true;
    }
    return this;
};
var $1c42a84d8b7875c8$export$2e2bcd8739ae039 = $1c42a84d8b7875c8$var$PauseTyping;


var $f4999af364e75485$var$ResumeTyping = function(offsetTime) {
    // Already not in typingPaused state
    if (!this.isTypingPaused) return this;
    if (offsetTime === undefined) offsetTime = 0;
    if (this.typingTimer) {
        this.isTypingPaused = false;
        this.typingTimer.resume();
        this.typingTimer.remainder += offsetTime;
    } else if (this.isTypingPaused) {
        this.isTypingPaused = false;
        this.typing(offsetTime);
    }
    return this;
};
var $f4999af364e75485$export$2e2bcd8739ae039 = $f4999af364e75485$var$ResumeTyping;


// Internal events
const $81d8b20172b7b4eb$export$a1392b132e92a41 = "_remove.wait";
const $81d8b20172b7b4eb$export$70835ff13aecfd19 = "_remove.play";
const $81d8b20172b7b4eb$export$767aa61fd26dda28 = [
    $81d8b20172b7b4eb$export$a1392b132e92a41,
    $81d8b20172b7b4eb$export$70835ff13aecfd19
];


var $8a31dbae13fddb57$var$GetWrapCallback = function(textPlayer, callback, args, scope, removeFrom) {
    return function() {
        textPlayer.emit((0, $81d8b20172b7b4eb$export$a1392b132e92a41), removeFrom); // Remove all wait events
        callback.apply(scope, args);
    };
};
var $8a31dbae13fddb57$export$2e2bcd8739ae039 = $8a31dbae13fddb57$var$GetWrapCallback;


var $373e6ffdaf9ff5d0$var$WaitCallback = function(textPlayer, postfixName, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, "custom");
    var eventName = postfixName ? `wait.${postfixName}` : "wait";
    textPlayer.emit(eventName, wrapCallback);
};
var $373e6ffdaf9ff5d0$export$2e2bcd8739ae039 = $373e6ffdaf9ff5d0$var$WaitCallback;




var $072e0b9d4bf570f0$var$WaitTime = function(textPlayer, time, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, "time");
    var timer;
    // Remove all wait events
    textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
        if (timer) {
            timer.remove();
            timer = undefined;
        }
    });
    timer = textPlayer.timeline.delayCall(time, wrapCallback);
    textPlayer.emit("wait.time", time);
};
var $072e0b9d4bf570f0$export$2e2bcd8739ae039 = $072e0b9d4bf570f0$var$WaitTime;




var $728cb136f064a26b$var$WaitClick = function(textPlayer, callback, args, scope) {
    var clickEE = textPlayer.clickEE;
    if (!clickEE) return;
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, "click");
    // Remove all wait events
    textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
        clickEE.off("pointerdown", wrapCallback, textPlayer);
    });
    clickEE.once("pointerdown", wrapCallback, textPlayer);
    textPlayer.emit("wait.click");
};
var $728cb136f064a26b$export$2e2bcd8739ae039 = $728cb136f064a26b$var$WaitClick;




var $d262c250e3c16260$var$WaitMusic = function(textPlayer, music, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, "music");
    if (music) {
        // Remove all wait events
        textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
            music.off("complete", wrapCallback, textPlayer);
        });
        music.once("complete", wrapCallback, textPlayer);
    }
    textPlayer.emit("wait.music", music);
    if (!music) wrapCallback();
};
var $d262c250e3c16260$export$2e2bcd8739ae039 = $d262c250e3c16260$var$WaitMusic;




var $4503154485bbd7e3$export$1d9b609ec5ef859d = function(name) {
    switch(name){
        case "camera.fadein":
        case "camera.fadeout":
        case "camera.flash":
        case "camera.shake":
        case "camera.zoom":
        case "camera.rotate":
        case "camera.scroll":
            return true;
        default:
            return false;
    }
};
var $4503154485bbd7e3$export$655d94a4d8de9c06 = function(textPlayer, effectName, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, `camera.${effectName}`);
    var camera = textPlayer.targetCamera;
    var effect, completeEventName;
    switch(effectName){
        case "camera.fadein":
            effect = camera.fadeEffect;
            completeEventName = "camerafadeincomplete";
            break;
        case "camera.fadeout":
            effect = camera.fadeEffect;
            completeEventName = "camerafadeoutcomplete";
            break;
        case "camera.flash":
            effect = camera.flashEffect;
            completeEventName = "cameraflashcomplete";
            break;
        case "camera.shake":
            effect = camera.shakeEffect;
            completeEventName = "camerashakecomplete";
            break;
        case "camera.zoom":
            effect = camera.zoomEffect;
            completeEventName = "camerazoomcomplete";
            break;
        case "camera.rotate":
            effect = camera.rotateToEffect;
            completeEventName = "camerarotatecomplete";
            break;
        case "camera.scroll":
            effect = camera.panEffect;
            completeEventName = "camerapancomplete";
            break;
    }
    if (!effect.isRunning) {
        textPlayer.emit("wait.camera", effectName);
        wrapCallback();
    } else {
        // Remove all wait events
        textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function(removeFrom) {
            camera.off(completeEventName, wrapCallback, textPlayer);
        });
        camera.once(completeEventName, wrapCallback, textPlayer);
        textPlayer.emit("wait.camera", effectName);
    }
};




var $372492a37c9f13ec$var$WaitKeyDown = function(textPlayer, keyName, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope, "keydown");
    var eventName = `keydown-${keyName.toUpperCase()}`;
    var keyboard = textPlayer.scene.input.keyboard;
    // Remove all wait events
    textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
        keyboard.off(eventName, wrapCallback, textPlayer);
    });
    keyboard.once(eventName, wrapCallback, textPlayer);
    textPlayer.emit("wait.keydown", keyName);
};
var $372492a37c9f13ec$export$2e2bcd8739ae039 = $372492a37c9f13ec$var$WaitKeyDown;




var $8d1d14b5f8a81433$export$256053356913af5a = function(textPlayer, name) {
    var names = name.split(".");
    return textPlayer.gameObjectManagers.hasOwnProperty(names[0]);
};
var $8d1d14b5f8a81433$export$5db9de98c05b272e = function(textPlayer, tag, callback, args, scope) {
    var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope);
    var tags = tag.split(".");
    var goType = tags[0];
    var gameObjectManager = textPlayer.getGameObjectManager(goType);
    var waitEventName = `wait.${goType}`;
    switch(tags.length){
        case 1:
            if (gameObjectManager.isEmpty) {
                textPlayer.emit(waitEventName);
                wrapCallback();
            } else {
                // Remove all wait events
                textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function(removeFrom) {
                    gameObjectManager.off("empty", wrapCallback, textPlayer);
                });
                gameObjectManager.once("empty", wrapCallback, textPlayer);
                textPlayer.emit(waitEventName);
            }
            return;
        case 2:
            var name = tags[1];
            if (!gameObjectManager.has(name)) {
                textPlayer.emit(waitEventName, name);
                wrapCallback();
            } else {
                var spriteData = gameObjectManager.get(name);
                var gameObject = spriteData.gameObject;
                // Remove all wait events
                textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
                    gameObject.off("destroy", wrapCallback, textPlayer);
                });
                gameObject.once("destroy", wrapCallback, textPlayer);
                textPlayer.emit(waitEventName, name);
            }
            return;
        case 3:
            var name = tags[1], prop = tags[2];
            var value = gameObjectManager.getProperty(name, prop);
            // Can start tween task for a number property
            if (typeof value === "number") {
                var task = gameObjectManager.getTweenTask(name, prop);
                if (!task) {
                    textPlayer.emit(waitEventName, name, prop);
                    wrapCallback();
                } else {
                    // Remove all wait events
                    textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
                        task.off("complete", wrapCallback, textPlayer);
                    });
                    task.once("complete", wrapCallback, textPlayer);
                    textPlayer.emit(waitEventName, name, prop);
                }
                return;
            }
            var dataKey = prop;
            var matchFalseFlag = dataKey.startsWith("!");
            if (matchFalseFlag) dataKey = dataKey.substring(1);
            // Wait until flag is true/false
            if (gameObjectManager.hasData(name, dataKey)) {
                var gameObject = gameObjectManager.getGO(name);
                var flag = gameObject.getData(dataKey);
                var matchTrueFlag = !matchFalseFlag;
                if (flag === matchTrueFlag) {
                    textPlayer.emit(waitEventName, name, prop);
                    wrapCallback();
                } else {
                    // Remove all wait events
                    var eventName = `changedata-${dataKey}`;
                    var callback = function(gameObject, value, previousValue) {
                        value = !!value;
                        if (value === matchTrueFlag) wrapCallback.call(textPlayer);
                    };
                    textPlayer.once((0, $81d8b20172b7b4eb$export$a1392b132e92a41), function() {
                        gameObject.off(eventName, callback);
                    });
                    gameObject.on(eventName, callback);
                    textPlayer.emit(waitEventName, name, prop);
                }
                return;
            }
    }
};


const $4726902188cc32e3$var$KeyCodes = Phaser.Input.Keyboard.KeyCodes;
var $4726902188cc32e3$var$WaitMultiple = function(textPlayer, names, callback, args, scope) {
    if (typeof names === "string" && names.length > 1 && names.indexOf("|") !== -1) names = names.split("|");
    else names = [
        names
    ];
    for(var i = 0, cnt = names.length; i < cnt; i++){
        var name = names[i];
        if (name == null || name === "wait") (0, $373e6ffdaf9ff5d0$export$2e2bcd8739ae039)(textPlayer, undefined, callback, args, scope);
        else if (typeof name === "number" || !isNaN(name)) (0, $072e0b9d4bf570f0$export$2e2bcd8739ae039)(textPlayer, parseFloat(name), callback, args, scope);
        else if (name === "click") (0, $728cb136f064a26b$export$2e2bcd8739ae039)(textPlayer, callback, args, scope);
        else if (name === "se") {
            var music = textPlayer.soundManager.getLastSoundEffect();
            (0, $d262c250e3c16260$export$2e2bcd8739ae039)(textPlayer, music, callback, args, scope);
        } else if (name === "se2") {
            var music = textPlayer.soundManager.getLastSoundEffect2();
            (0, $d262c250e3c16260$export$2e2bcd8739ae039)(textPlayer, music, callback, args, scope);
        } else if (name === "bgm") {
            var music = textPlayer.soundManager.getBackgroundMusic();
            (0, $d262c250e3c16260$export$2e2bcd8739ae039)(textPlayer, music, callback, args, scope);
        } else if (name === "bgm2") {
            var music = textPlayer.soundManager.getBackgroundMusic2();
            (0, $d262c250e3c16260$export$2e2bcd8739ae039)(textPlayer, music, callback, args, scope);
        } else if ($4726902188cc32e3$var$KeyCodes.hasOwnProperty(name.toUpperCase())) (0, $372492a37c9f13ec$export$2e2bcd8739ae039)(textPlayer, name, callback, args, scope);
        else if ((0, $4503154485bbd7e3$export$1d9b609ec5ef859d)(name)) (0, $4503154485bbd7e3$export$655d94a4d8de9c06)(textPlayer, name, callback, args, scope);
        else if ((0, $8d1d14b5f8a81433$export$256053356913af5a)(textPlayer, name)) (0, $8d1d14b5f8a81433$export$5db9de98c05b272e)(textPlayer, name, callback, args, scope);
        else (0, $373e6ffdaf9ff5d0$export$2e2bcd8739ae039)(textPlayer, name, callback, args, scope);
    }
};
var $4726902188cc32e3$export$2e2bcd8739ae039 = $4726902188cc32e3$var$WaitMultiple;


var $b6bb0958338ba652$var$Wait = function(name) {
    // Already in typingPaused state, or ignore any wait
    if (this.ignoreWait) return this;
    this.pauseTyping();
    (0, $4726902188cc32e3$export$2e2bcd8739ae039)(this.textPlayer, name, this.resumeTyping, [], this);
    return this;
};
var $b6bb0958338ba652$export$2e2bcd8739ae039 = $b6bb0958338ba652$var$Wait;


var $22a804269c0e9510$var$SetIgnoreWait = function(value) {
    if (value === undefined) value = true;
    this.ignoreWait = value;
    return this;
};
var $22a804269c0e9510$export$2e2bcd8739ae039 = $22a804269c0e9510$var$SetIgnoreWait;


var $a6ccd3c6ae1555b5$var$SetSkipSpaceEnable = function(enable) {
    if (enable === undefined) enable = true;
    this.skipSpaceEnable = enable;
    return this;
};
var $a6ccd3c6ae1555b5$export$2e2bcd8739ae039 = $a6ccd3c6ae1555b5$var$SetSkipSpaceEnable;



var $fb62055a1b9fcfe5$var$SetSkipTypingAnimation = function(value) {
    if (value === undefined) value = true;
    this.skipTypingAnimation = value;
    if (value) {
        // Skip current playing typing-animation
        var timers = this.timeline.getTimers((0, $0eed0dd02cd38de1$export$beb72ae4653b914b));
        for(var i = 0, cnt = timers.length; i < cnt; i++)timers[i].seek(1);
    }
    return this;
};
var $fb62055a1b9fcfe5$export$2e2bcd8739ae039 = $fb62055a1b9fcfe5$var$SetSkipTypingAnimation;


var $0096dff71392bb0c$var$SetSkipSoundEffect = function(value) {
    if (value === undefined) value = true;
    this.skipSoundEffect = value;
    if (value) {
        var soundManager = this.textPlayer._soundManager;
        if (soundManager) soundManager.fadeOutAllSoundEffects(100, true);
    }
    return this;
};
var $0096dff71392bb0c$export$2e2bcd8739ae039 = $0096dff71392bb0c$var$SetSkipSoundEffect;


var $9d24b2b00907b0e3$var$SkipCurrentTypingDelay = function() {
    if (this.typingTimer) this.typingTimer.seek(1);
    return this;
};
var $9d24b2b00907b0e3$export$2e2bcd8739ae039 = $9d24b2b00907b0e3$var$SkipCurrentTypingDelay;


var $5c78175df69a232b$var$Methods = {
    fadeOutPage: (0, $697dceb1188400d2$export$2e2bcd8739ae039),
    start: (0, $35575e0f5c09ce8a$export$2e2bcd8739ae039),
    typing: (0, $e1968fe14742aaff$export$2e2bcd8739ae039),
    pause: (0, $f9c86ffa86229e88$export$2e2bcd8739ae039),
    resume: (0, $b75460df8addbfde$export$2e2bcd8739ae039),
    pauseTyping: (0, $1c42a84d8b7875c8$export$2e2bcd8739ae039),
    resumeTyping: (0, $f4999af364e75485$export$2e2bcd8739ae039),
    wait: (0, $b6bb0958338ba652$export$2e2bcd8739ae039),
    setIgnoreWait: (0, $22a804269c0e9510$export$2e2bcd8739ae039),
    setSkipSpaceEnable: (0, $a6ccd3c6ae1555b5$export$2e2bcd8739ae039),
    setSkipTypingAnimation: (0, $fb62055a1b9fcfe5$export$2e2bcd8739ae039),
    setSkipSoundEffect: (0, $0096dff71392bb0c$export$2e2bcd8739ae039),
    skipCurrentTypingDelay: (0, $9d24b2b00907b0e3$export$2e2bcd8739ae039)
};
Object.assign($5c78175df69a232b$var$Methods, (0, $ab18d50c55a363fb$export$2e2bcd8739ae039));
var $5c78175df69a232b$export$2e2bcd8739ae039 = $5c78175df69a232b$var$Methods;


const $8361e76c9f04fd3b$var$GetValue = Phaser.Utils.Objects.GetValue;
class $8361e76c9f04fd3b$var$TypeWriter {
    constructor(textPlayer, config){
        this.setEventEmitter();
        this.textPlayer = textPlayer;
        this.isPageTyping = false;
        this.typingTimer = undefined; // Typing delay
        this.pauseTypingTimer = undefined; // Wait time
        this.inTypingProcessLoop = false; // Used in this.typing()
        this.isTypingPaused = false; // Used in this.wait(), this.pauseTyping(), this.resumeTyping()
        this.setIgnoreWait(false);
        this.setSkipTypingAnimation(false);
        this.setTypingStartCallback($8361e76c9f04fd3b$var$GetValue(config, "onTypingStart", $8361e76c9f04fd3b$var$SetChildrenInvisible));
        this.setDefaultTypingSpeed($8361e76c9f04fd3b$var$GetValue(config, "speed", 250));
        this.setTypingSpeed();
        this.setSkipSpaceEnable($8361e76c9f04fd3b$var$GetValue(config, "skipSpace", false));
        this.setAnimationConfig($8361e76c9f04fd3b$var$GetValue(config, "animation", undefined));
        this.setMinSizeEnable($8361e76c9f04fd3b$var$GetValue(config, "minSizeEnable", false));
        this.setFadeOutPageCallback($8361e76c9f04fd3b$var$GetValue(config, "fadeOutPage"));
    }
    destroy() {
        this.destroyEventEmitter();
        this.textPlayer = undefined;
        this.typingTimer = undefined;
        this.pauseTypingTimer = undefined;
        this.onTypeStart = undefined;
        this.animationConfig = undefined;
    }
    get timeline() {
        return this.textPlayer.timeline;
    }
    setTypingStartCallback(callback) {
        this.onTypeStart = callback;
        return this;
    }
    setAnimationConfig(config) {
        if (!config) config = {};
        if (!config.hasOwnProperty("duration")) config.duration = 0;
        if (!config.hasOwnProperty("onStart")) // Apply default onStart callback
        config.onStart = $8361e76c9f04fd3b$var$SetChildVisible;
        this.animationConfig = config;
        return this;
    }
    setFadeOutPageCallback(callback) {
        this.fadeOutPageCallback = callback;
        return this;
    }
    setMinSizeEnable(enable) {
        if (enable === undefined) enable = true;
        this.minSizeEnable = enable;
        return this;
    }
    getNextChild() {
        var child = this.nextChild;
        this.index = Math.min(this.index + 1, this.children.length); // Point to next child
        this._nextChild = undefined;
        return child;
    }
    get nextChild() {
        if (!this._nextChild) this._nextChild = this.children[this.index];
        return this._nextChild;
    }
}
var $8361e76c9f04fd3b$var$SetChildVisible = function(child) {
    if (child.setVisible) child.setVisible();
};
var $8361e76c9f04fd3b$var$SetChildrenInvisible = function(children) {
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.setVisible) child.setVisible(false);
    }
};
Object.assign($8361e76c9f04fd3b$var$TypeWriter.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039), (0, $5c78175df69a232b$export$2e2bcd8739ae039));
var $8361e76c9f04fd3b$export$2e2bcd8739ae039 = $8361e76c9f04fd3b$var$TypeWriter;





class $9617933aa422d7a5$var$SpriteBob extends (0, $495cd9567d1d8022$export$2e2bcd8739ae039) {
    playAnimation(key) {
        this.gameObject.anims.timeScale = this.timeScale;
        this.gameObject.play(key);
        return this;
    }
    stopAnimation() {
        this.gameObject.stop();
        return this;
    }
    chainAnimation(keys) {
        this.gameObject.chain(keys);
        return this;
    }
    pauseAnimation() {
        this.gameObject.anims.pause();
        return this;
    }
    setTimeScale(timeScale) {
        super.setTimeScale(timeScale);
        if (this.gameObject.anims) this.gameObject.anims.timeScale = timeScale;
        return this;
    }
}
var $9617933aa422d7a5$export$2e2bcd8739ae039 = $9617933aa422d7a5$var$SpriteBob;


var $7ac7e485b661ba78$export$2e2bcd8739ae039 = {
    playAnimation (name, key) {
        if (!this.has(name)) this.add(name);
        this.get(name).playAnimation(key);
        return this;
    },
    stopAnimation (name) {
        if (!this.has(name)) return this;
        this.get(name).stopAnimation();
        return this;
    },
    chainAnimation (name, keys) {
        if (!this.has(name)) return this;
        this.get(name).chainAnimation(keys);
        return this;
    },
    pauseAnimation (name) {
        if (!this.has(name)) return this;
        this.get(name).pauseAnimation();
        return this;
    }
};


var $2327d91d12729066$var$Methods = {};
Object.assign($2327d91d12729066$var$Methods, (0, $7ac7e485b661ba78$export$2e2bcd8739ae039));
var $2327d91d12729066$export$2e2bcd8739ae039 = $2327d91d12729066$var$Methods;


class $e6a2a452bfbefed6$var$SpriteManager extends (0, $38db5a279359788b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        config.BobClass = (0, $9617933aa422d7a5$export$2e2bcd8739ae039);
        super(scene, config);
    }
    setCreateGameObjectCallback(callback, scope) {
        if (!callback || callback === "sprite") callback = $e6a2a452bfbefed6$var$CreateSprite;
        else if (callback === "image") callback = $e6a2a452bfbefed6$var$CreateImage;
        super.setCreateGameObjectCallback(callback, scope);
        return this;
    }
}
var $e6a2a452bfbefed6$var$CreateSprite = function(scene, textureKey, frameName) {
    if (typeof frameName !== "string" && typeof frameName !== "number") frameName = undefined;
    return scene.add.sprite(0, 0, textureKey, frameName);
};
var $e6a2a452bfbefed6$var$CreateImage = function(scene, textureKey, frameName) {
    if (typeof frameName !== "string" && typeof frameName !== "number") frameName = undefined;
    return scene.add.image(0, 0, textureKey, frameName);
};
Object.assign($e6a2a452bfbefed6$var$SpriteManager.prototype, (0, $2327d91d12729066$export$2e2bcd8739ae039));
var $e6a2a452bfbefed6$export$2e2bcd8739ae039 = $e6a2a452bfbefed6$var$SpriteManager;



var $3c3bd3923289f30e$var$IsPlayAnimationTag = function(tags, goType) {
    // goType.name.play
    return tags.length === 3 && tags[0] === goType && tags[2] === "play";
};
var $3c3bd3923289f30e$var$IsStopAnimationTag = function(tags, goType) {
    // goType.name.stop
    return tags.length === 3 && tags[0] === goType && tags[2] === "stop";
};
var $3c3bd3923289f30e$var$OnParsePlayAnimationTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on("+", function(tag, ...keys) {
        if (parser.skipEventFlag) return;
        // [goType.name.play=key], or [goType.name.play=key0,key1,...]
        var tags = tag.split(".");
        var name;
        if ($3c3bd3923289f30e$var$IsPlayAnimationTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.play`, $3c3bd3923289f30e$var$PlayAnimation, [
            goType,
            name,
            keys
        ], textPlayer);
        parser.skipEvent();
    }).on("+", function(tag) {
        if (parser.skipEventFlag) return;
        // [goType.name.stop]
        var tags = tag.split(".");
        var name;
        if ($3c3bd3923289f30e$var$IsStopAnimationTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.stop`, $3c3bd3923289f30e$var$StopAnimation, [
            goType,
            name
        ], textPlayer);
        parser.skipEvent();
    }).on("-", function(tag) {
        if (parser.skipEventFlag) return;
        // [/goType.name.play]
        var tags = tag.split(".");
        var name;
        if ($3c3bd3923289f30e$var$IsPlayAnimationTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.stop`, $3c3bd3923289f30e$var$StopAnimation, [
            goType,
            name
        ], textPlayer);
        parser.skipEvent();
    });
};
var $3c3bd3923289f30e$var$PlayAnimation = function(params) {
    var goType, name, keys;
    [goType, name, keys] = params;
    var key = keys.shift();
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.playAnimation(name, key);
    if (keys.length > 0) gameObjectManager.chainAnimation(name, keys);
};
var $3c3bd3923289f30e$var$StopAnimation = function(params) {
    var goType, args;
    [goType, ...args] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.stopAnimation(...args);
};
var $3c3bd3923289f30e$export$2e2bcd8739ae039 = $3c3bd3923289f30e$var$OnParsePlayAnimationTag;



var $bae38b976489fc8a$var$IsPauseAnimationTag = function(tags, goType) {
    // goType.name.pause 
    return tags.length === 3 && tags[0] === goType && tags[2] === "pause";
};
var $bae38b976489fc8a$var$OnParsePauseAnimationTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on("+", function(tag) {
        if (parser.skipEventFlag) return;
        // [goType.name.pause=key]
        var tags = tag.split(".");
        var name;
        if ($bae38b976489fc8a$var$IsPauseAnimationTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.pause`, $bae38b976489fc8a$var$PauseAnimation, [
            goType,
            name
        ], textPlayer);
        parser.skipEvent();
    });
};
var $bae38b976489fc8a$var$PauseAnimation = function(params) {
    var goType, args;
    [goType, ...args] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.pauseAnimation(...args);
};
var $bae38b976489fc8a$export$2e2bcd8739ae039 = $bae38b976489fc8a$var$OnParsePauseAnimationTag;



var $735e8d52afd3326d$var$IsChainAnimationTag = function(tags, goType) {
    // goType.name.chain 
    return tags.length === 3 && tags[0] === goType && tags[2] === "chain";
};
var $735e8d52afd3326d$var$OnParseChainAnimationTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on("+", function(tag) {
        if (parser.skipEventFlag) return;
        // [goType.name.chain=key]
        var tags = tag.split(".");
        var name;
        if ($735e8d52afd3326d$var$IsChainAnimationTag(tags, goType)) name = tags[1];
        else return;
        var keys = Array.prototype.slice.call(arguments, 1);
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.chain`, $735e8d52afd3326d$var$ChainAnimation, [
            goType,
            name,
            keys
        ], textPlayer);
        parser.skipEvent();
    });
};
var $735e8d52afd3326d$var$ChainAnimation = function(params) {
    var goType, args;
    [goType, ...args] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.chainAnimation(...args);
};
var $735e8d52afd3326d$export$2e2bcd8739ae039 = $735e8d52afd3326d$var$OnParseChainAnimationTag;


const $6ba1239fe8a2deb6$var$ParseCallbacks = [
    (0, $3c3bd3923289f30e$export$2e2bcd8739ae039),
    (0, $bae38b976489fc8a$export$2e2bcd8739ae039),
    (0, $735e8d52afd3326d$export$2e2bcd8739ae039)
];
var $6ba1239fe8a2deb6$var$AddSpriteManager = function(config) {
    if (config === undefined) config = {};
    config.name = "sprite";
    config.parseCallbacks = $6ba1239fe8a2deb6$var$ParseCallbacks;
    this.addGameObjectManager(config, (0, $e6a2a452bfbefed6$export$2e2bcd8739ae039));
};
var $6ba1239fe8a2deb6$export$2e2bcd8739ae039 = $6ba1239fe8a2deb6$var$AddSpriteManager;




var $6f0632fbb92e05e0$var$IsAddGameObjectTag = function(tags, goType) {
    // goType.name
    return tags.length === 2 && tags[0] === goType;
};
var $6f0632fbb92e05e0$var$OnParseAddGameObjectTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on("+", function(tag, ...args) {
        if (parser.skipEventFlag) return;
        // [goType.name=key,frame], or [goType.name]
        var tags = tag.split(".");
        var name;
        if ($6f0632fbb92e05e0$var$IsAddGameObjectTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.add`, $6f0632fbb92e05e0$var$AddGameObject, [
            goType,
            name,
            ...args
        ], textPlayer);
        parser.skipEvent();
    }).on("-", function(tag) {
        if (parser.skipEventFlag) return;
        // [/goType.name]
        var tags = tag.split(".");
        var name;
        if ($6f0632fbb92e05e0$var$IsAddGameObjectTag(tags, goType)) name = tags[1];
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.remove`, $6f0632fbb92e05e0$var$RemoveGameObject, [
            goType,
            name
        ], textPlayer);
        parser.skipEvent();
    });
};
var $6f0632fbb92e05e0$var$AddGameObject = function(params) {
    var goType, args;
    [goType, ...args] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.add(...args);
};
var $6f0632fbb92e05e0$var$RemoveGameObject = function(params) {
    var goType, args;
    [goType, ...args] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.remove(...args);
};
var $6f0632fbb92e05e0$export$2e2bcd8739ae039 = $6f0632fbb92e05e0$var$OnParseAddGameObjectTag;



var $90a693d76fbff5fb$var$OnParseRemoveAllGameObjectsTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on("-", function(tag) {
        if (parser.skipEventFlag) return;
        // [/goType]
        if (tag === goType) ;
        else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.removeall`, $90a693d76fbff5fb$var$RemoveAllSprites, goType, textPlayer);
        parser.skipEvent();
    });
};
var $90a693d76fbff5fb$var$RemoveAllSprites = function(goType) {
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    gameObjectManager.removeAll();
};
var $90a693d76fbff5fb$export$2e2bcd8739ae039 = $90a693d76fbff5fb$var$OnParseRemoveAllGameObjectsTag;



var $bc8bcd1e053f62ae$var$IsPropTag = function(tags, goType) {
    // goType.name.prop
    return tags.length === 3 && tags[0] === goType;
};
var $bc8bcd1e053f62ae$var$OnParseCallGameObjectMethodTag = function(textPlayer, parser, config) {
    var goType = config.name;
    parser.on(`+`, function(tag, ...parameters) {
        if (parser.skipEventFlag) return;
        // [goType.name.methodName=value0,value1,value2...]
        // [goType.name.prop=value]
        var tags = tag.split(".");
        var name, prop;
        if ($bc8bcd1e053f62ae$var$IsPropTag(tags, goType)) {
            name = tags[1];
            prop = tags[2];
        } else return;
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.call`, $bc8bcd1e053f62ae$var$CallMethod, [
            goType,
            name,
            prop,
            ...parameters
        ], textPlayer);
        parser.skipEvent();
    });
};
var $bc8bcd1e053f62ae$var$CallMethod = function(params) {
    var goType, name, prop, args;
    [goType, name, prop, ...args] = params;
    // this: textPlayer
    var eventName = `${goType}.${prop}`;
    this.emit(eventName, name, ...args);
    if (this.listenerCount(eventName) > 0) return;
    var gameObjectManager = this.getGameObjectManager(goType);
    if (gameObjectManager.hasMethod(name, prop)) // Is method
    gameObjectManager.call(name, prop, ...args);
    else // Is property
    gameObjectManager.setProperty(name, prop, args[0]);
};
var $bc8bcd1e053f62ae$export$2e2bcd8739ae039 = $bc8bcd1e053f62ae$var$OnParseCallGameObjectMethodTag;



var $9e81bd7923f0464e$var$EaseMode = {
    to: true,
    yoyo: true,
    from: true,
    toLeft: true,
    toRight: true,
    toUp: true,
    toDown: true,
    yoyoLeft: true,
    yoyoRight: true,
    yoyoUp: true,
    yoyoDown: true,
    fromLeft: true,
    fromRight: true,
    fromUp: true,
    fromDown: true
};
var $9e81bd7923f0464e$var$IsEasePropertyTag = function(tags, goType) {
    // goType.name.prop.to
    return tags.length === 4 && tags[0] === goType && $9e81bd7923f0464e$var$EaseMode[tags[3]];
};
var $9e81bd7923f0464e$var$OnParseEaseGameObjectPropertyTag = function(textPlayer, parser, config) {
    var goType = config.name;
    var gameObjectManager = textPlayer.getGameObjectManager(goType);
    parser.on(`+`, function(tag, value, duration, ease, repeat) {
        if (parser.skipEventFlag) return;
        // [goType.name.prop.to=value,duration]
        // [goType.name.prop.to=value,duration,ease,repeat]
        // [goType.name.prop.to=value,duration,repeat]
        var tags = tag.split(".");
        var name, property, easeMode;
        if ($9e81bd7923f0464e$var$IsEasePropertyTag(tags, goType)) {
            name = tags[1];
            property = tags[2];
            easeMode = tags[3];
        } else return;
        if (typeof ease === "number") {
            repeat = ease;
            ease = undefined;
        }
        (0, $399ddda816911e07$export$2e2bcd8739ae039).call(textPlayer, `${goType}.ease`, $9e81bd7923f0464e$var$EaseProperty, [
            goType,
            name,
            property,
            value,
            duration,
            ease,
            repeat,
            easeMode
        ], textPlayer);
        parser.skipEvent();
    });
};
var $9e81bd7923f0464e$var$EaseProperty = function(params) {
    var goType, name, property, value, duration, ease, repeat, easeMode;
    [goType, name, property, value, duration, ease, repeat, easeMode] = params;
    // this: textPlayer
    var gameObjectManager = this.getGameObjectManager(goType);
    var currentValue = gameObjectManager.getProperty(name, property);
    // Only can tween number property
    if (typeof currentValue !== "number") return;
    if (easeMode.endsWith("Left") || easeMode.endsWith("Up")) {
        if (easeMode.startsWith("to") || easeMode.startsWith("yoyo")) value = currentValue - value;
        else if (easeMode.startsWith("from")) {
            gameObjectManager.setProperty(name, property, currentValue - value);
            value = currentValue;
        }
    } else if (easeMode.endsWith("Right") || easeMode.endsWith("Down")) {
        if (easeMode.startsWith("to") || easeMode.startsWith("yoyo")) value = currentValue + value;
        else if (easeMode.startsWith("from")) {
            gameObjectManager.setProperty(name, property, currentValue + value);
            value = currentValue;
        }
    } else if (easeMode === "from") {
        gameObjectManager.setProperty(name, property, value);
        value = currentValue;
    }
    var isYoyo = easeMode.startsWith("yoyo");
    gameObjectManager.easeProperty(name, property, value, duration, ease, repeat, isYoyo);
};
var $9e81bd7923f0464e$export$2e2bcd8739ae039 = $9e81bd7923f0464e$var$OnParseEaseGameObjectPropertyTag;


const $248c9d0a3c47888e$var$ParseCallbacks = [
    (0, $6f0632fbb92e05e0$export$2e2bcd8739ae039),
    (0, $90a693d76fbff5fb$export$2e2bcd8739ae039),
    (0, $bc8bcd1e053f62ae$export$2e2bcd8739ae039),
    (0, $9e81bd7923f0464e$export$2e2bcd8739ae039)
];
const $248c9d0a3c47888e$var$AddGameObjectManager = (0, $41adaf3b69b53b5f$export$2e2bcd8739ae039).addGameObjectManager;
var $248c9d0a3c47888e$export$2e2bcd8739ae039 = {
    addGameObjectManager (config, GameObjectManagerClass) {
        if (config === undefined) config = {};
        var name = config.name;
        if (!name) console.warn(`Parameter 'name' is required in TextPlayer.addGameObjectManager(config) method`);
        $248c9d0a3c47888e$var$AddGameObjectManager.call(this, config, GameObjectManagerClass);
        // Register parse callbacks
        var customParseCallbacks = config.parseCallbacks;
        if (!customParseCallbacks) customParseCallbacks = $248c9d0a3c47888e$var$ParseCallbacks;
        else customParseCallbacks = [
            ...customParseCallbacks,
            ...$248c9d0a3c47888e$var$ParseCallbacks
        ];
        for(var i = 0, cnt = customParseCallbacks.length; i < cnt; i++)customParseCallbacks[i](this, this.parser, config);
        return this;
    }
};



var $ffd37ce26ece9ff1$var$SetClickTarget = function(target) {
    this.clickTarget = target;
    if (!target) this.clickEE = null;
    else if ((0, $fc3c3469177a1a71$export$2e2bcd8739ae039)(target)) this.clickEE = target.input;
    else this.clickEE = target.setInteractive();
    return this;
};
var $ffd37ce26ece9ff1$export$2e2bcd8739ae039 = $ffd37ce26ece9ff1$var$SetClickTarget;


var $a3547a909d28fdb8$var$SetTargetCamera = function(camera) {
    this.targetCamera = camera;
    return this;
};
var $a3547a909d28fdb8$export$2e2bcd8739ae039 = $a3547a909d28fdb8$var$SetTargetCamera;




var $9f9985e230d5aa9c$var$SetNextPageInput = function(input) {
    var textPlayer = this;
    if (!input) this.nextPageInput = null;
    else if (typeof input === "function") this.nextPageInput = function(callback, args, scope) {
        var wrapCallback = (0, $8a31dbae13fddb57$export$2e2bcd8739ae039)(textPlayer, callback, args, scope);
        input.call(textPlayer, wrapCallback);
    };
    else this.nextPageInput = function(callback, args, scope) {
        (0, $4726902188cc32e3$export$2e2bcd8739ae039)(textPlayer, input, callback, args, scope);
    };
};
var $9f9985e230d5aa9c$export$2e2bcd8739ae039 = $9f9985e230d5aa9c$var$SetNextPageInput;


var $f5f29afd721a1328$var$AddImage = function(key, config) {
    this.imageManager.add(key, config);
    return this;
};
var $f5f29afd721a1328$export$2e2bcd8739ae039 = $f5f29afd721a1328$var$AddImage;



var $9570c757b11f8d82$export$2e2bcd8739ae039 = {
    play (content) {
        if (this.isPlaying) return this;
        this.removeChildren();
        this.parser.start(content); // Parse bbcode-content
        this.isPlaying = true;
        this.once("complete", function() {
            this.isPlaying = false;
        }, this);
        this.lastWrapResult = undefined;
        this.typingNextPage();
        return this;
    },
    playPromise (content) {
        var promise = (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this);
        this.play(content);
        return promise;
    }
};



const $a373e48e69221b42$var$GetValue = Phaser.Utils.Objects.GetValue;
var $a373e48e69221b42$var$TypingNextPage = function() {
    if (!this.isPlaying || this.isPageTyping) return this;
    this.typeWriter.once("page.fadeout", $a373e48e69221b42$var$_TypingNextPage, this).fadeOutPage();
    return this;
};
var $a373e48e69221b42$var$_TypingNextPage = function() {
    var result = this.runWrap(this.lastWrapResult);
    this.lastWrapResult = result;
    this.emit("page.start");
    var OnTypingPageComplete = function() {
        this.emit((0, $81d8b20172b7b4eb$export$70835ff13aecfd19)); // Clear registed StopPlayEvent
        if (result.isLastPage) this.emit("complete");
        else {
            this.emit("page.complete");
            if (this.ignoreNextPageInput) $a373e48e69221b42$var$TypingNextPage.call(this);
            else if (this.nextPageInput) this.nextPageInput($a373e48e69221b42$var$TypingNextPage, [], this);
        }
    };
    // Remove event when typing pages has been canceled
    this.once((0, $81d8b20172b7b4eb$export$70835ff13aecfd19), function() {
        this.typeWriter.off("complete", OnTypingPageComplete, this);
    });
    this.typeWriter.once("complete", OnTypingPageComplete, this).start(result.children);
};
var $a373e48e69221b42$export$2e2bcd8739ae039 = $a373e48e69221b42$var$TypingNextPage;


var $16f499a29ebd5e5e$export$2e2bcd8739ae039 = {
    pause () {
        // Pause typing, typing timer and animation progresses
        this.timeline.pause();
        return this;
    },
    pauseTyping () {
        // Pause typing
        this.typeWriter.pauseTyping();
        return this;
    }
};


var $5518067f7676c6be$export$2e2bcd8739ae039 = {
    resume () {
        // Resume typing timer, animation progresses and typing
        this.timeline.resume();
        return this;
    },
    resumeTyping (offsetTime) {
        // Resume typing
        this.typeWriter.resumeTyping(offsetTime);
        return this;
    }
};


var $b0cb24feffc1eb3f$var$Wait = function(name) {
    this.typeWriter.wait(name);
    return this;
};
var $b0cb24feffc1eb3f$export$2e2bcd8739ae039 = $b0cb24feffc1eb3f$var$Wait;


var $d6ddfa406156a9e6$export$2e2bcd8739ae039 = {
    setDefaultTypingSpeed (speed) {
        this.defaultTypingSpeed = speed;
        return this;
    },
    setTypingSpeed (speed) {
        this.typingSpeed = speed;
        return this;
    }
};


var $b4c246f4769d09a0$var$SetIgnoreWait = function(value) {
    this.typeWriter.setIgnoreWait(value);
    return this;
};
var $b4c246f4769d09a0$export$2e2bcd8739ae039 = $b4c246f4769d09a0$var$SetIgnoreWait;


var $9205999802577327$var$SetIgnoreNextPageInput = function(enable) {
    if (enable === undefined) enable = true;
    this.ignoreNextPageInput = enable;
    return this;
};
var $9205999802577327$export$2e2bcd8739ae039 = $9205999802577327$var$SetIgnoreNextPageInput;


var $bfcd953b2ba9ab4c$var$ShowPage = function() {
    // Only can work after playing, and before processing last child
    if (!this.isPlaying || !this.isPageTyping) return this;
    // Save parameters
    var typingSpeedSave = this.typeWriter.speed;
    var ignoreWaitSave = this.typeWriter.ignoreWait;
    var skipTypingAnimationSave = this.typeWriter.skipTypingAnimation;
    var skipSoundEffectSave = this.typeWriter.skipSoundEffect;
    this.typeWriter.once("complete", function() {
        // Recover parameters
        this.typeWriter.setTypingSpeed(typingSpeedSave).setIgnoreWait(ignoreWaitSave).setSkipTypingAnimation(skipTypingAnimationSave).setSkipSoundEffect(skipSoundEffectSave);
    }, this).setTypingSpeed(0).skipCurrentTypingDelay().setIgnoreWait(true).setSkipTypingAnimation(true).setSkipSoundEffect(true);
    return this;
};
var $bfcd953b2ba9ab4c$export$2e2bcd8739ae039 = $bfcd953b2ba9ab4c$var$ShowPage;


var $acd765db8fc4b53a$export$2e2bcd8739ae039 = {
    getSprite (name) {
        return this.getGameObject("sprite", name);
    },
    addSprite (name, gameObject) {
        this.addGameObject("sprite", name, gameObject);
        return this;
    }
};


var $5814f10bbbc5869c$export$2e2bcd8739ae039 = {
    setContentOutputEnable (enable) {
        this.parser.setContentOutputEnable(enable);
        return this;
    },
    setContentCallback (callback, scope) {
        this.contentCallback = callback;
        this.contentCallbackScope = scope;
        return this;
    }
};


var $8a4ae713fb052191$var$Methods = {
    setClickTarget: (0, $ffd37ce26ece9ff1$export$2e2bcd8739ae039),
    setTargetCamera: (0, $a3547a909d28fdb8$export$2e2bcd8739ae039),
    setNextPageInput: (0, $9f9985e230d5aa9c$export$2e2bcd8739ae039),
    addImage: (0, $f5f29afd721a1328$export$2e2bcd8739ae039),
    typingNextPage: (0, $a373e48e69221b42$export$2e2bcd8739ae039),
    wait: (0, $b0cb24feffc1eb3f$export$2e2bcd8739ae039),
    setIgnoreWait: (0, $b4c246f4769d09a0$export$2e2bcd8739ae039),
    setIgnoreNextPageInput: (0, $9205999802577327$export$2e2bcd8739ae039),
    showPage: (0, $bfcd953b2ba9ab4c$export$2e2bcd8739ae039)
};
Object.assign($8a4ae713fb052191$var$Methods, (0, $248c9d0a3c47888e$export$2e2bcd8739ae039), (0, $9570c757b11f8d82$export$2e2bcd8739ae039), (0, $16f499a29ebd5e5e$export$2e2bcd8739ae039), (0, $5518067f7676c6be$export$2e2bcd8739ae039), (0, $d6ddfa406156a9e6$export$2e2bcd8739ae039), (0, $acd765db8fc4b53a$export$2e2bcd8739ae039), (0, $5814f10bbbc5869c$export$2e2bcd8739ae039));
var $8a4ae713fb052191$export$2e2bcd8739ae039 = $8a4ae713fb052191$var$Methods;



var $128d3971a7495b18$var$ClearEvents = function(textPlayer) {
    for(var i = 0, cnt = (0, $81d8b20172b7b4eb$export$767aa61fd26dda28).length; i < cnt; i++)textPlayer.emit((0, $81d8b20172b7b4eb$export$767aa61fd26dda28)[i]);
};
var $128d3971a7495b18$export$2e2bcd8739ae039 = $128d3971a7495b18$var$ClearEvents;


const $8f16f64e4b91fa15$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $8f16f64e4b91fa15$var$GetValue = Phaser.Utils.Objects.GetValue;
class $8f16f64e4b91fa15$var$TextPlayer extends (0, $a58b77e71ec0444d$export$2e2bcd8739ae039)((0, $c7da6d512822e889$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, fixedWidth, fixedHeight, config){
        if ($8f16f64e4b91fa15$var$IsPlainObject(x)) config = x;
        else if ($8f16f64e4b91fa15$var$IsPlainObject(fixedWidth)) config = fixedWidth;
        if (config === undefined) config = {};
        // Don't set text in DynamicText's constructor
        var content = config.text;
        delete config.text;
        super(scene, x, y, fixedWidth, fixedHeight, config);
        this.type = "rexTextPlayer";
        this.parser = new (0, $da22066eb14ef287$export$2e2bcd8739ae039)(this, $8f16f64e4b91fa15$var$GetValue(config, "parser", undefined));
        this.typeWriter = new (0, $8361e76c9f04fd3b$export$2e2bcd8739ae039)(this, $8f16f64e4b91fa15$var$GetValue(config, "typing", undefined));
        this._imageManager = undefined;
        var imageData = $8f16f64e4b91fa15$var$GetValue(config, "images", undefined);
        if (imageData) this.addImage(imageData);
        this.setTargetCamera($8f16f64e4b91fa15$var$GetValue(config, "camera", this.scene.sys.cameras.main));
        this.initManagers(scene, config);
        var spriteManagerConfig = $8f16f64e4b91fa15$var$GetValue(config, "sprites");
        if (spriteManagerConfig !== false && spriteManagerConfig !== null) (0, $6ba1239fe8a2deb6$export$2e2bcd8739ae039).call(this, spriteManagerConfig);
        this.setIgnoreNextPageInput($8f16f64e4b91fa15$var$GetValue(config, "ignoreNextPageInput", false));
        this.setClickTarget($8f16f64e4b91fa15$var$GetValue(config, "clickTarget", this)); // this.clickEE
        this.setNextPageInput($8f16f64e4b91fa15$var$GetValue(config, "nextPageInput", null));
        this.isPlaying = false;
        if (content) this.play(content);
    }
    get imageManager() {
        if (this._imageManager === undefined) this._imageManager = new (0, $d45b470a96528418$export$2e2bcd8739ae039)(this.scene);
        return this._imageManager;
    }
    get spriteManager() {
        return this.getGameObjectManager("sprite");
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        (0, $128d3971a7495b18$export$2e2bcd8739ae039)(this);
        this.parser.destroy();
        this.parser = undefined;
        this.typeWriter.destroy(fromScene);
        this.typeWriter = undefined;
        if (this._imageManager) this._imageManager.destroy(fromScene);
        this._imageManager = undefined;
        this.targetCamera = undefined;
        this.clickEE = undefined;
        this.destroyManagers(fromScene);
        super.destroy(fromScene);
    }
    get isPageTyping() {
        return this.typeWriter.isPageTyping;
    }
    set defaultTypingSpeed(speed) {
        this.typeWriter.setDefaultTypingSpeed(speed);
    }
    get defaultTypingSpeed() {
        return this.typeWriter.defaultTypingSpeed;
    }
    set typingSpeed(speed) {
        this.typeWriter.setTypingSpeed(speed);
    }
    get typingSpeed() {
        return this.typeWriter.speed;
    }
    set timeScale(value) {
        this.setTimeScale(value);
    }
    get timeScale() {
        return this.getTimeScale();
    }
}
Object.assign($8f16f64e4b91fa15$var$TextPlayer.prototype, (0, $8a4ae713fb052191$export$2e2bcd8739ae039));
var $8f16f64e4b91fa15$export$2e2bcd8739ae039 = $8f16f64e4b91fa15$var$TextPlayer;


var $f36a43deb080bb85$export$2e2bcd8739ae039 = (0, $8f16f64e4b91fa15$export$2e2bcd8739ae039);


var $7e78ae0863c9dfdc$export$2e2bcd8739ae039 = (0, $f36a43deb080bb85$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textPlayer", function(x, y, width, height, config) {
    var gameObject = new (0, $7e78ae0863c9dfdc$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextPlayer", (0, $7e78ae0863c9dfdc$export$2e2bcd8739ae039));
var $a25f85f7047ffe37$export$2e2bcd8739ae039 = (0, $7e78ae0863c9dfdc$export$2e2bcd8739ae039);




const $ebe020556a27d1b9$export$5ceae51f304f907a = {
    maxLength: [
        "maxLength",
        undefined
    ],
    minLength: [
        "minLength",
        undefined
    ],
    readOnly: [
        "readOnly",
        false
    ]
};
const $ebe020556a27d1b9$export$382e5b25557d359c = {
    direction: [
        "direction",
        undefined
    ]
};


var $d9a464a8d4168f82$var$CopyProperty = function(from, to, key) {
    if (typeof key === "string") {
        if (from.hasOwnProperty(key)) to[key] = from[key];
    } else {
        var keys = key;
        if (Array.isArray(keys)) for(var i = 0, cnt = keys.length; i < cnt; i++)$d9a464a8d4168f82$var$CopyProperty(from, to, keys[i]);
        else for(var key in keys)$d9a464a8d4168f82$var$CopyProperty(from, to, key);
    }
};
var $d9a464a8d4168f82$export$2e2bcd8739ae039 = $d9a464a8d4168f82$var$CopyProperty;


var $10efb319d1f23d81$var$CopyElementConfig = function(from) {
    if (from === undefined) from = {};
    var to = {};
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(from, to, "inputType");
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(from, to, "type");
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(from, to, "style");
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(from, to, (0, $ebe020556a27d1b9$export$382e5b25557d359c));
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(from, to, (0, $ebe020556a27d1b9$export$5ceae51f304f907a));
    return to;
};
var $10efb319d1f23d81$export$2e2bcd8739ae039 = $10efb319d1f23d81$var$CopyElementConfig;


var $13b05035f77fdc38$var$IsPointerInHitArea = function(gameObject, pointer, preTest, postTest) {
    if (pointer) {
        if (preTest && !preTest(gameObject, pointer)) return false;
        if (!$13b05035f77fdc38$var$HitTest(gameObject, pointer)) return false;
        if (postTest && !postTest(gameObject, pointer)) return false;
        return true;
    } else {
        var inputManager = gameObject.scene.input.manager;
        var pointersTotal = inputManager.pointersTotal;
        var pointers = inputManager.pointers, pointer;
        for(var i = 0; i < pointersTotal; i++){
            pointer = pointers[i];
            if (preTest && !preTest(gameObject, pointer)) continue;
            if (!$13b05035f77fdc38$var$HitTest(gameObject, pointer)) continue;
            if (postTest && !postTest(gameObject, pointer)) continue;
            return true;
        }
        return false;
    }
};
var $13b05035f77fdc38$var$HitTest = function(gameObject, pointer) {
    var scene = gameObject.scene;
    var cameras = scene.input.cameras.getCamerasBelowPointer(pointer);
    var inputManager = scene.input.manager;
    var gameObjects = [
        gameObject
    ];
    var output;
    for(var i = 0, len = cameras.length; i < len; i++){
        output = inputManager.hitTest(pointer, gameObjects, cameras[i]);
        if (output.length > 0) return true;
    }
    return false;
};
var $13b05035f77fdc38$export$2e2bcd8739ae039 = $13b05035f77fdc38$var$IsPointerInHitArea;


var $bf2b52c3a1293af5$var$LastOpenedEditor = undefined;
var $bf2b52c3a1293af5$export$668cbdf16c1aa400 = function(editor) {
    if (editor === $bf2b52c3a1293af5$var$LastOpenedEditor) return;
    if ($bf2b52c3a1293af5$var$LastOpenedEditor !== undefined) $bf2b52c3a1293af5$var$LastOpenedEditor.close();
    $bf2b52c3a1293af5$var$LastOpenedEditor = editor;
};
var $bf2b52c3a1293af5$export$798937d41b1530cb = function(editor) {
    if (editor !== $bf2b52c3a1293af5$var$LastOpenedEditor) return;
    // Don't call `LastOpenedEditor.close()`
    $bf2b52c3a1293af5$var$LastOpenedEditor = undefined;
};





const $daa436494015a4db$var$GetValue = Phaser.Utils.Objects.GetValue;
var $daa436494015a4db$var$CreateElement = function(parent, config) {
    var element;
    var textType = $daa436494015a4db$var$GetValue(config, "inputType", undefined);
    if (textType === undefined) textType = $daa436494015a4db$var$GetValue(config, "type", "text");
    if (textType === "textarea") {
        element = document.createElement("textarea");
        element.style.resize = "none";
    } else {
        element = document.createElement("input");
        element.type = textType;
    }
    var style = $daa436494015a4db$var$GetValue(config, "style", undefined);
    // Apply other style properties
    var elementStyle = element.style;
    (0, $b4f8dc12fa48d39a$export$2e2bcd8739ae039)((0, $ebe020556a27d1b9$export$382e5b25557d359c), style, elementStyle);
    // Set style
    elementStyle.position = "absolute";
    elementStyle.opacity = 0;
    elementStyle.pointerEvents = "none";
    elementStyle.zIndex = 0;
    // hide native blue text cursor on iOS
    elementStyle.transform = "scale(0)";
    (0, $b4f8dc12fa48d39a$export$2e2bcd8739ae039)((0, $ebe020556a27d1b9$export$5ceae51f304f907a), config, element);
    // Don't propagate touch/mouse events to parent(game canvas)
    (0, $c9f4424d09c314d0$export$2e2bcd8739ae039)(element);
    // Attach element to fullscreenTarget in full screen mode
    var scaleManager = parent.scene.sys.scale;
    var parentElement = scaleManager.isFullscreen ? scaleManager.fullscreenTarget : document.body;
    parentElement.appendChild(element);
    return element;
};
var $daa436494015a4db$export$2e2bcd8739ae039 = $daa436494015a4db$var$CreateElement;


var $4c6b493a8da0fa0b$var$Open = function() {
    // Already opened
    if (this.isOpened) return this;
    // Read only
    if (this.readOnly) return this;
    (0, $bf2b52c3a1293af5$export$668cbdf16c1aa400)(this);
    this.isOpened = true;
    if (!this.node) // Create input text element when opening editor
    this.node = (0, $daa436494015a4db$export$2e2bcd8739ae039)(this, this.nodeConfig);
    this.setFocus();
    this.initText();
    if (this.enterCloseEnable) this.scene.input.keyboard.once("keydown-ENTER", this.close, this);
    // There is no cursor-position-change event, 
    // so updating cursor position every tick
    this.scene.sys.events.on("postupdate", this.updateText, this);
    this.scene.input.on("pointerdown", this.onClickOutside, this);
    if (this.onOpenCallback) this.onOpenCallback(this.parent, this);
    this.emit("open", this);
    return this;
};
var $4c6b493a8da0fa0b$export$2e2bcd8739ae039 = $4c6b493a8da0fa0b$var$Open;



var $4c227d7e02be0904$var$RemoveElement = function(element) {
    if (!element) return;
    var parentElement = element.parentElement;
    if (parentElement) parentElement.removeChild(element);
};
var $4c227d7e02be0904$export$2e2bcd8739ae039 = $4c227d7e02be0904$var$RemoveElement;


var $df787ad47d9b9360$var$Close = function() {
    // Already closed
    if (!this.isOpened) return this;
    (0, $bf2b52c3a1293af5$export$798937d41b1530cb)(this);
    this.setBlur();
    this.isOpened = false;
    this.updateText();
    this.scene.sys.events.off("postupdate", this.updateText, this);
    this.scene.input.off("pointerdown", this.onClickOutside, this);
    if (this.onCloseCallback) this.onCloseCallback(this.parent, this);
    // Remove input text element when closing editor
    (0, $4c227d7e02be0904$export$2e2bcd8739ae039)(this.node);
    this.node = undefined;
    this.emit("close", this);
    return this;
};
var $df787ad47d9b9360$export$2e2bcd8739ae039 = $df787ad47d9b9360$var$Close;


var $841577a62babf955$var$Methods = {
    open: (0, $4c6b493a8da0fa0b$export$2e2bcd8739ae039),
    close: (0, $df787ad47d9b9360$export$2e2bcd8739ae039)
};
var $841577a62babf955$export$2e2bcd8739ae039 = $841577a62babf955$var$Methods;


const $252c9b782f14b3fd$var$GetValue = Phaser.Utils.Objects.GetValue;
class $252c9b782f14b3fd$var$HiddenTextEditBase extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject);
        // this.parent = gameObject;
        var textType = $252c9b782f14b3fd$var$GetValue(config, "inputType", undefined);
        if (textType === undefined) textType = $252c9b782f14b3fd$var$GetValue(config, "type", "text");
        this.setEnterCloseEnable($252c9b782f14b3fd$var$GetValue(config, "enterClose", textType !== "textarea"));
        var onOpen = $252c9b782f14b3fd$var$GetValue(config, "onOpen", undefined);
        if (!onOpen) onOpen = $252c9b782f14b3fd$var$GetValue(config, "onFocus", undefined);
        this.onOpenCallback = onOpen;
        var onClose = $252c9b782f14b3fd$var$GetValue(config, "onClose", undefined);
        if (!onClose) onClose = $252c9b782f14b3fd$var$GetValue(config, "onBlur", undefined);
        this.onCloseCallback = onClose;
        this.onUpdateCallback = $252c9b782f14b3fd$var$GetValue(config, "onUpdate", undefined);
        this.isOpened = false;
        gameObject.on("pointerdown", function() {
            this.open();
        }, this).setInteractive();
        this.nodeConfig = (0, $10efb319d1f23d81$export$2e2bcd8739ae039)(config);
        // Create/remove input text element when opening/closing editor
        this.node = undefined;
    }
    destroy() {
        // this.parent.off('pointerdown', this.open, this);
        this.close();
        super.destroy();
    }
    onClickOutside(pointer) {
        if (!(0, $13b05035f77fdc38$export$2e2bcd8739ae039)(this.parent, pointer)) this.close();
    }
    setEnterCloseEnable(enable) {
        if (enable === undefined) enable = true;
        this.enterCloseEnable = enable;
        return this;
    }
    // Override
    initText() {}
    // Override
    updateText() {}
    // Copy from InputText class
    get text() {
        if (!this.node) return "";
        return this.node.value;
    }
    set text(value) {
        if (!this.node) return;
        this.node.value = value;
    }
    setText(value) {
        this.text = value;
        return this;
    }
    get maxLength() {
        return this.nodeConfig.maxLength;
    }
    set maxLength(value) {
        this.nodeConfig.maxLength = value;
        if (this.node) this.node.maxLength = value;
    }
    setMaxLength(value) {
        this.maxLength = value;
        return this;
    }
    get minLength() {
        return this.nodeConfig.minLength;
    }
    set minLength(value) {
        this.nodeConfig.minLength = value;
        if (this.node) this.node.minLength = value;
    }
    setMinLength(value) {
        this.minLength = value;
        return this;
    }
    get placeholder() {
        return this.node.placeholder;
    }
    set placeholder(value) {
        if (!this.node) return;
        this.node.placeholder = value;
    }
    setPlaceholder(value) {
        this.placeholder = value;
        return this;
    }
    selectText(selectionStart, selectionEnd) {
        if (!this.node) return this;
        if (selectionStart === undefined) this.node.select();
        else this.node.setSelectionRange(selectionStart, selectionEnd);
        return this;
    }
    selectAll() {
        this.selectText();
        return this;
    }
    get selectionStart() {
        if (!this.node) return 0;
        return this.node.selectionStart;
    }
    get selectionEnd() {
        if (!this.node) return 0;
        return this.node.selectionEnd;
    }
    get selectedText() {
        if (!this.node) return "";
        var node = this.node;
        return node.value.substring(node.selectionStart, node.selectionEnd);
    }
    get cursorPosition() {
        if (!this.node) return 0;
        return this.node.selectionStart;
    }
    set cursorPosition(value) {
        if (!this.node) return;
        this.node.setSelectionRange(value, value);
    }
    setCursorPosition(value) {
        if (value === undefined) value = this.text.length;
        else if (value < 0) value = this.text.length + value;
        this.cursorPosition = value;
        return this;
    }
    get tooltip() {
        if (!this.node) return "";
        return this.node.title;
    }
    set tooltip(value) {
        if (!this.node) return this;
        this.node.title = value;
    }
    setTooltip(value) {
        this.tooltip = value;
        return this;
    }
    setTextChangedCallback(callback) {
        this.onTextChanged = callback;
        return this;
    }
    get readOnly() {
        return this.nodeConfig.readOnly;
    }
    set readOnly(value) {
        this.nodeConfig.readOnly = value;
        if (this.node) this.node.readOnly = value;
    }
    setReadOnly(value) {
        if (value === undefined) value = true;
        this.readOnly = value;
        return this;
    }
    get spellCheck() {
        if (!this.node) return "";
        return this.node.spellcheck;
    }
    set spellCheck(value) {
        if (!this.node) return;
        this.node.spellcheck = value;
    }
    setSpellCheck(value) {
        this.spellCheck = value;
        return this;
    }
    get fontColor() {
        if (!this.node) return undefined;
        return this.node.style.color;
    }
    set fontColor(value) {
        if (!this.node) return;
        this.node.style.color = value;
    }
    setFontColor(value) {
        this.fontColor = value;
        return this;
    }
    setStyle(key, value) {
        if (!this.node) return this;
        this.node.style[key] = value;
        return this;
    }
    getStyle(key) {
        if (!this.node) return undefined;
        return this.node.style[key];
    }
    scrollToBottom() {
        if (!this.node) return this;
        this.node.scrollTop = this.node.scrollHeight;
        return this;
    }
    setEnabled(enabled) {
        if (!this.node) return this;
        if (enabled === undefined) enabled = true;
        this.node.disabled = !enabled;
        return this;
    }
    setBlur() {
        if (!this.node) return this;
        this.node.blur();
        return this;
    }
    setFocus() {
        if (!this.node) return this;
        this.node.focus();
        return this;
    }
    get isFocused() {
        return this.isOpened;
    }
}
Object.assign($252c9b782f14b3fd$var$HiddenTextEditBase.prototype, (0, $841577a62babf955$export$2e2bcd8739ae039));
var $252c9b782f14b3fd$export$2e2bcd8739ae039 = $252c9b782f14b3fd$var$HiddenTextEditBase;


var $13b252f1a08478ca$var$NumberInputUpdateCallback = function(text, textObject, hiddenInputText) {
    text = text.replace(" ", "");
    var previousText = hiddenInputText.previousText;
    if (text === previousText) return text;
    if (isNaN(text)) {
        // Enter a NaN character, back to previous text
        hiddenInputText.emit("nan", text, hiddenInputText);
        text = previousText;
        var cursorPosition = hiddenInputText.cursorPosition - 1;
        hiddenInputText.setText(text);
        hiddenInputText.setCursorPosition(cursorPosition);
    } else // New number text, update previous texr
    hiddenInputText.previousText = text;
    return text;
};
var $13b252f1a08478ca$export$2e2bcd8739ae039 = $13b252f1a08478ca$var$NumberInputUpdateCallback;


var $7ca2c02fea2040ab$var$OnSelectRange = function(hiddenTextEdit) {
    var textObject = hiddenTextEdit.parent;
    // var text = textObject.text;
    var selectionStart = hiddenTextEdit.isOpened ? hiddenTextEdit.selectionStart : null;
    var selectionEnd = hiddenTextEdit.isOpened ? hiddenTextEdit.selectionEnd : null;
    var prevSelectionStart = hiddenTextEdit.prevSelectionStart;
    var prevSelectionEnd = hiddenTextEdit.prevSelectionEnd;
    if (prevSelectionStart === selectionStart && prevSelectionEnd === selectionEnd) return;
    var min, max;
    if (prevSelectionStart === null) {
        min = selectionStart;
        max = selectionEnd;
    } else {
        min = Math.min(prevSelectionStart, selectionStart);
        max = Math.max(prevSelectionEnd, selectionEnd);
    }
    for(var i = min; i < max; i++){
        var inPrevSelectionRange = prevSelectionStart === null ? false : i >= prevSelectionStart && i < prevSelectionEnd;
        var inSelectionRange = i >= selectionStart && i < selectionEnd;
        if (inPrevSelectionRange && inSelectionRange) continue;
        var child = textObject.getCharChild(i);
        if (child) {
            if (inPrevSelectionRange) textObject.emit("cursorout", child, i, textObject);
            else textObject.emit("cursorin", child, i, textObject);
        }
    }
    hiddenTextEdit.prevSelectionStart = selectionStart;
    hiddenTextEdit.prevSelectionEnd = selectionEnd;
};
var $7ca2c02fea2040ab$export$2e2bcd8739ae039 = $7ca2c02fea2040ab$var$OnSelectRange;


var $171da9f1ac210364$var$MoveCursor = function(hiddenTextEdit) {
    var textObject = hiddenTextEdit.parent;
    var text = textObject.text;
    var cursorPosition = hiddenTextEdit.cursorPosition;
    if (hiddenTextEdit.prevCursorPosition === cursorPosition) return;
    if (hiddenTextEdit.prevCursorPosition !== null) {
        if (hiddenTextEdit.prevCursorPosition > text.length) hiddenTextEdit.prevCursorPosition = null;
    }
    if (hiddenTextEdit.prevCursorPosition !== null) {
        var child = textObject.getCharChild(hiddenTextEdit.prevCursorPosition);
        if (child) textObject.emit("cursorout", child, hiddenTextEdit.prevCursorPosition, textObject);
    }
    if (cursorPosition != null) {
        var child = textObject.getCharChild(cursorPosition);
        if (child) textObject.emit("cursorin", child, cursorPosition, textObject);
    }
    textObject.emit("movecursor", cursorPosition, hiddenTextEdit.prevCursorPosition, textObject);
    hiddenTextEdit.prevCursorPosition = cursorPosition;
};
var $171da9f1ac210364$export$2e2bcd8739ae039 = $171da9f1ac210364$var$MoveCursor;


var $61bb03b93b2984ee$var$ClearSelectRange = function(hiddenTextEdit) {
    var prevSelectionStart = hiddenTextEdit.prevSelectionStart;
    if (prevSelectionStart === null) return;
    var prevSelectionEnd = hiddenTextEdit.prevSelectionEnd;
    var textObject = hiddenTextEdit.parent;
    for(var i = prevSelectionStart; i < prevSelectionEnd; i++){
        var child = textObject.getCharChild(i);
        if (child) textObject.emit("cursorout", child, i, textObject);
    }
    hiddenTextEdit.prevSelectionStart = null;
    hiddenTextEdit.prevSelectionEnd = null;
};
var $61bb03b93b2984ee$export$2e2bcd8739ae039 = $61bb03b93b2984ee$var$ClearSelectRange;


var $d9beaacdadbf56a0$var$ClearCursor = function(hiddenTextEdit) {
    var prevCursorPosition = hiddenTextEdit.prevCursorPosition;
    if (prevCursorPosition === null) return;
    var textObject = hiddenTextEdit.parent;
    var child = textObject.getCharChild(prevCursorPosition);
    if (child) textObject.emit("cursorout", child, prevCursorPosition, textObject);
    hiddenTextEdit.prevCursorPosition = null;
};
var $d9beaacdadbf56a0$export$2e2bcd8739ae039 = $d9beaacdadbf56a0$var$ClearCursor;


const $c3d5ba7b1626c9e7$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c3d5ba7b1626c9e7$var$HiddenTextEdit extends (0, $252c9b782f14b3fd$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this.setSelectAllWhenFocusEnable($c3d5ba7b1626c9e7$var$GetValue(config, "selectAll", false));
        this.cursorMoveStartIndex = null;
        this.prevCursorPosition = null;
        this.prevSelectionStart = null;
        this.prevSelectionEnd = null;
        this.firstClickAfterOpen = false;
        gameObject// Open editor by 'pointerdown' event
        // Then set cursor position to nearest char
        .on("pointerdown", function(pointer, localX, localY, event) {
            var child = gameObject.getNearestChild(localX, localY);
            var charIndex = gameObject.getCharIndex(child);
            if (!this.selectAllWhenFocus || !this.firstClickAfterOpen) this.setCursorPosition(charIndex);
            this.cursorMoveStartIndex = charIndex;
            this.firstClickAfterOpen = false;
        }, this).on("pointermove", function(pointer, localX, localY, event) {
            if (!pointer.isDown) return;
            var child = gameObject.getNearestChild(localX, localY);
            var charIndex = gameObject.getCharIndex(child);
            if (this.cursorMoveStartIndex < charIndex) this.selectText(this.cursorMoveStartIndex, charIndex + 1);
            else this.selectText(charIndex, this.cursorMoveStartIndex + 1);
        }, this);
        this.on("open", function() {
            if (this.selectAllWhenFocus) this.selectAll();
            this.firstClickAfterOpen = true;
            gameObject.emit("open");
        }, this).on("close", function() {
            gameObject.emit("close");
        }, this);
    }
    initText() {
        var textObject = this.parent;
        this.prevCursorPosition = null;
        this.setText(textObject.text);
        return this;
    }
    updateText() {
        var textObject = this.parent;
        var text = this.text;
        if (this.onUpdateCallback) {
            var newText = this.onUpdateCallback(text, textObject, this);
            if (newText != null) text = newText;
        }
        if (textObject.text !== text) {
            textObject.setText(text);
            textObject.emit("textchange", text, textObject, this);
        }
        if (this.isOpened) {
            if (this.selectionStart !== this.selectionEnd) {
                (0, $d9beaacdadbf56a0$export$2e2bcd8739ae039)(this);
                (0, $7ca2c02fea2040ab$export$2e2bcd8739ae039)(this);
            } else {
                (0, $61bb03b93b2984ee$export$2e2bcd8739ae039)(this);
                (0, $171da9f1ac210364$export$2e2bcd8739ae039)(this);
            }
        } else {
            (0, $61bb03b93b2984ee$export$2e2bcd8739ae039)(this);
            (0, $d9beaacdadbf56a0$export$2e2bcd8739ae039)(this);
        }
        return this;
    }
    setNumberInput() {
        this.onUpdateCallback = (0, $13b252f1a08478ca$export$2e2bcd8739ae039);
        return this;
    }
    setSelectAllWhenFocusEnable(enable) {
        if (enable === undefined) enable = true;
        this.selectAllWhenFocus = enable;
        return this;
    }
}
var $c3d5ba7b1626c9e7$export$2e2bcd8739ae039 = $c3d5ba7b1626c9e7$var$HiddenTextEdit;



const $c6e29cbb2ab3c213$var$GetValue = Phaser.Utils.Objects.GetValue;
const $c6e29cbb2ab3c213$var$PropertiesList = [
    "inputType",
    "onOpen",
    "onFocus",
    "onClose",
    "onBlur",
    "onUpdate",
    "enterClose",
    "readOnly",
    "maxLength",
    "minLength",
    "selectAll"
];
var $c6e29cbb2ab3c213$var$CreateHiddenTextEdit = function(parent, parentConfig) {
    var config = $c6e29cbb2ab3c213$var$GetValue(parentConfig, "edit");
    if (config === undefined) config = {};
    (0, $d9a464a8d4168f82$export$2e2bcd8739ae039)(parentConfig, config, $c6e29cbb2ab3c213$var$PropertiesList);
    return new (0, $c3d5ba7b1626c9e7$export$2e2bcd8739ae039)(parent, config);
};
var $c6e29cbb2ab3c213$export$2e2bcd8739ae039 = $c6e29cbb2ab3c213$var$CreateHiddenTextEdit;


var $0cef6ee9dfdf1f0b$var$HasValue = function(source, key) {
    if (!source || typeof source === "number") return false;
    else if (source.hasOwnProperty(key)) return true;
    else if (key.indexOf(".") !== -1) {
        var keys = key.split(".");
        var parent = source;
        //  Use for loop here so we can break early
        for(var i = 0; i < keys.length; i++){
            if (parent.hasOwnProperty(keys[i])) parent = parent[keys[i]];
            else //  Can't go any further
            return false;
        }
        return true;
    } else return false;
};
var $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039 = $0cef6ee9dfdf1f0b$var$HasValue;



var $682d97cadfcfd615$var$InjectDefaultConfig = function(config) {
    var isSingleLineMode = !config.textArea;
    if (!(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "wrap.vAlign")) {
        var defaultValue = isSingleLineMode ? "center" : "top";
        (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "wrap.vAlign", defaultValue);
    }
    if (!(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "wrap.charWrap")) (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "wrap.charWrap", true);
    if (!(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "wrap.maxLines")) {
        var defaultValue = isSingleLineMode ? 1 : undefined;
        (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "wrap.maxLines", defaultValue);
    }
    if (!(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "wrap.useDefaultTextHeight")) (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "wrap.useDefaultTextHeight", true);
    if (!config.edit) config.edit = {};
    if (!(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config.edit, "inputType")) {
        var defaultValue = isSingleLineMode ? "text" : "textarea";
        (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config.edit, "inputType", defaultValue);
    }
    return config;
};
var $682d97cadfcfd615$export$2e2bcd8739ae039 = $682d97cadfcfd615$var$InjectDefaultConfig;






var $ef8ba2c9adc1ff88$var$RegisterCursorStyle = function(cursorStyle) {
    if ((0, $aba8f4b64d947bef$export$2e2bcd8739ae039)(cursorStyle)) return;
    this.setCursorStyle(cursorStyle).on("cursorin", function(child) {
        var cursorStyle = this.cursorStyle;
        var styleSave = (0, $fc246cfe00d52bbe$export$2e2bcd8739ae039)(child.style, cursorStyle);
        if ((0, $a2443fc83542336c$export$2e2bcd8739ae039)(cursorStyle, styleSave)) return;
        child.styleSave = styleSave;
        child.modifyStyle(cursorStyle);
    }, this).on("cursorout", function(child) {
        if (!child.styleSave) return;
        child.modifyStyle(child.styleSave);
        child.styleSave = undefined;
    }, this);
};
var $ef8ba2c9adc1ff88$export$2e2bcd8739ae039 = $ef8ba2c9adc1ff88$var$RegisterCursorStyle;





var $5e9b81e523bb9c7d$var$RegisterFocusStyle = function(focusStyle) {
    if ((0, $aba8f4b64d947bef$export$2e2bcd8739ae039)(focusStyle)) return;
    this.setFocusStyle(focusStyle).on("open", function() {
        var child = this.background;
        var focusStyle = this.focusStyle;
        var styleSave = (0, $fc246cfe00d52bbe$export$2e2bcd8739ae039)(child, focusStyle);
        if ((0, $a2443fc83542336c$export$2e2bcd8739ae039)(focusStyle, styleSave)) return;
        child.styleSave = styleSave;
        child.modifyStyle(focusStyle);
    }, this).on("close", function() {
        var child = this.background;
        if (!child.styleSave) return;
        child.modifyStyle(child.styleSave);
        child.styleSave = undefined;
    }, this);
};
var $5e9b81e523bb9c7d$export$2e2bcd8739ae039 = $5e9b81e523bb9c7d$var$RegisterFocusStyle;



var $b9964988827574d7$var$AddLastInsertCursor = function(textObject) {
    var child = textObject.createCharChild("|"); // Use '|' to update render size
    child.text = ""; // Render empty string ''
    // Invoke DynamicText's addChild method directly
    (0, $bcb8cf611e291abc$export$2e2bcd8739ae039).call(textObject, child);
    return child;
};
var $b9964988827574d7$export$2e2bcd8739ae039 = $b9964988827574d7$var$AddLastInsertCursor;


/* See LICENSE file for terms of use */ /*
 * Text diff implementation.
 *
 * This library supports the following APIS:
 * JsDiff.diffChars: Character by character diff
 * JsDiff.diffWords: Word (as defined by \b regex) diff which ignores whitespace
 * JsDiff.diffLines: Line based diff
 *
 * JsDiff.diffCss: Diff targeted at CSS content
 *
 * These methods are based on the implementation proposed in
 * "An O(ND) Difference Algorithm and its Variations" (Myers, 1986).
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
 */ function $5c0572bf01fe0534$export$2e2bcd8739ae039() {}
$5c0572bf01fe0534$export$2e2bcd8739ae039.prototype = {
    diff (oldString, newString, options = {}) {
        let callback = options.callback;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        this.options = options;
        let self = this;
        function done(value) {
            if (callback) {
                setTimeout(function() {
                    callback(undefined, value);
                }, 0);
                return true;
            } else return value;
        }
        // Allow subclasses to massage the input prior to running
        oldString = this.castInput(oldString);
        newString = this.castInput(newString);
        oldString = this.removeEmpty(this.tokenize(oldString));
        newString = this.removeEmpty(this.tokenize(newString));
        let newLen = newString.length, oldLen = oldString.length;
        let editLength = 1;
        let maxEditLength = newLen + oldLen;
        if (options.maxEditLength) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
        let bestPath = [
            {
                newPos: -1,
                components: []
            }
        ];
        // Seed editLength = 0, i.e. the content starts with the same values
        let oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
        if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) // Identity per the equality and tokenizer
        return done([
            {
                value: this.join(newString),
                count: newString.length
            }
        ]);
        // Main worker method. checks all permutations of a given edit length for acceptance.
        function execEditLength() {
            for(let diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
                let basePath;
                let addPath = bestPath[diagonalPath - 1], removePath = bestPath[diagonalPath + 1], oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
                if (addPath) // No one else is going to attempt to use this value, clear it
                bestPath[diagonalPath - 1] = undefined;
                let canAdd = addPath && addPath.newPos + 1 < newLen, canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
                if (!canAdd && !canRemove) {
                    // If this path is a terminal then prune
                    bestPath[diagonalPath] = undefined;
                    continue;
                }
                // Select the diagonal that we want to branch from. We select the prior
                // path whose position in the new string is the farthest from the origin
                // and does not pass the bounds of the diff graph
                if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                    basePath = $5c0572bf01fe0534$var$clonePath(removePath);
                    self.pushComponent(basePath.components, undefined, true);
                } else {
                    basePath = addPath; // No need to clone, we've pulled it from the list
                    basePath.newPos++;
                    self.pushComponent(basePath.components, true, undefined);
                }
                oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath);
                // If we have hit the end of both strings, then we are done
                if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return done($5c0572bf01fe0534$var$buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
                else // Otherwise track this path as a potential candidate and continue.
                bestPath[diagonalPath] = basePath;
            }
            editLength++;
        }
        // Performs the length of edit iteration. Is a bit fugly as this has to support the
        // sync and async mode which is never fun. Loops over execEditLength until a value
        // is produced, or until the edit length exceeds options.maxEditLength (if given),
        // in which case it will return undefined.
        if (callback) (function exec() {
            setTimeout(function() {
                if (editLength > maxEditLength) return callback();
                if (!execEditLength()) exec();
            }, 0);
        })();
        else while(editLength <= maxEditLength){
            let ret = execEditLength();
            if (ret) return ret;
        }
    },
    pushComponent (components, added, removed) {
        let last = components[components.length - 1];
        if (last && last.added === added && last.removed === removed) // We need to clone here as the component clone operation is just
        // as shallow array clone
        components[components.length - 1] = {
            count: last.count + 1,
            added: added,
            removed: removed
        };
        else components.push({
            count: 1,
            added: added,
            removed: removed
        });
    },
    extractCommon (basePath, newString, oldString, diagonalPath) {
        let newLen = newString.length, oldLen = oldString.length, newPos = basePath.newPos, oldPos = newPos - diagonalPath, commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])){
            newPos++;
            oldPos++;
            commonCount++;
        }
        if (commonCount) basePath.components.push({
            count: commonCount
        });
        basePath.newPos = newPos;
        return oldPos;
    },
    equals (left, right) {
        if (this.options.comparator) return this.options.comparator(left, right);
        else return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
    },
    removeEmpty (array) {
        let ret = [];
        for(let i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
        return ret;
    },
    castInput (value) {
        return value;
    },
    tokenize (value) {
        return value.split("");
    },
    join (chars) {
        return chars.join("");
    }
};
function $5c0572bf01fe0534$var$buildValues(diff, components, newString, oldString, useLongestToken) {
    let componentPos = 0, componentLen = components.length, newPos = 0, oldPos = 0;
    for(; componentPos < componentLen; componentPos++){
        let component = components[componentPos];
        if (!component.removed) {
            if (!component.added && useLongestToken) {
                let value = newString.slice(newPos, newPos + component.count);
                value = value.map(function(value, i) {
                    let oldValue = oldString[oldPos + i];
                    return oldValue.length > value.length ? oldValue : value;
                });
                component.value = diff.join(value);
            } else component.value = diff.join(newString.slice(newPos, newPos + component.count));
            newPos += component.count;
            // Common case
            if (!component.added) oldPos += component.count;
        } else {
            component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
            oldPos += component.count;
            // Reverse add and remove so removes are output first to match common convention
            // The diffing algorithm is tied to add then remove output and this is the simplest
            // route to get the desired output with minimal overhead.
            if (componentPos && components[componentPos - 1].added) {
                let tmp = components[componentPos - 1];
                components[componentPos - 1] = components[componentPos];
                components[componentPos] = tmp;
            }
        }
    }
    // Special case handle for when one terminal is ignored (i.e. whitespace).
    // For this case we merge the terminal into the prior string and drop the change.
    // This is only available for string mode.
    let lastComponent = components[componentLen - 1];
    if (componentLen > 1 && typeof lastComponent.value === "string" && (lastComponent.added || lastComponent.removed) && diff.equals("", lastComponent.value)) {
        components[componentLen - 2].value += lastComponent.value;
        components.pop();
    }
    return components;
}
function $5c0572bf01fe0534$var$clonePath(path) {
    return {
        newPos: path.newPos,
        components: path.components.slice(0)
    };
}



const $de0f25e7b33e1f4f$export$7ca665effb3e6ce5 = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
function $de0f25e7b33e1f4f$export$325021f2061a40f5(oldStr, newStr, options) {
    return $de0f25e7b33e1f4f$export$7ca665effb3e6ce5.diff(oldStr, newStr, options);
}



function $6eb703735d5d8159$export$c21133b4499f5374(options, defaults) {
    if (typeof options === "function") defaults.callback = options;
    else if (options) {
        for(let name in options)/* istanbul ignore else */ if (options.hasOwnProperty(name)) defaults[name] = options[name];
    }
    return defaults;
}


// Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
//
// Ranges and exceptions:
// Latin-1 Supplement, 0080–00FF
//  - U+00D7  × Multiplication sign
//  - U+00F7  ÷ Division sign
// Latin Extended-A, 0100–017F
// Latin Extended-B, 0180–024F
// IPA Extensions, 0250–02AF
// Spacing Modifier Letters, 02B0–02FF
//  - U+02C7  ˇ &#711;  Caron
//  - U+02D8  ˘ &#728;  Breve
//  - U+02D9  ˙ &#729;  Dot Above
//  - U+02DA  ˚ &#730;  Ring Above
//  - U+02DB  ˛ &#731;  Ogonek
//  - U+02DC  ˜ &#732;  Small Tilde
//  - U+02DD  ˝ &#733;  Double Acute Accent
// Latin Extended Additional, 1E00–1EFF
const $bdbd131d78a26da0$var$extendedWordChars = /^[a-zA-Z\u{C0}-\u{FF}\u{D8}-\u{F6}\u{F8}-\u{2C6}\u{2C8}-\u{2D7}\u{2DE}-\u{2FF}\u{1E00}-\u{1EFF}]+$/u;
const $bdbd131d78a26da0$var$reWhitespace = /\S/;
const $bdbd131d78a26da0$export$bcda4af332628932 = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
$bdbd131d78a26da0$export$bcda4af332628932.equals = function(left, right) {
    if (this.options.ignoreCase) {
        left = left.toLowerCase();
        right = right.toLowerCase();
    }
    return left === right || this.options.ignoreWhitespace && !$bdbd131d78a26da0$var$reWhitespace.test(left) && !$bdbd131d78a26da0$var$reWhitespace.test(right);
};
$bdbd131d78a26da0$export$bcda4af332628932.tokenize = function(value) {
    // All whitespace symbols except newline group into one token, each newline - in separate token
    let tokens = value.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/);
    // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
    for(let i = 0; i < tokens.length - 1; i++)// If we have an empty string in the next field and we have only word chars before and after, merge
    if (!tokens[i + 1] && tokens[i + 2] && $bdbd131d78a26da0$var$extendedWordChars.test(tokens[i]) && $bdbd131d78a26da0$var$extendedWordChars.test(tokens[i + 2])) {
        tokens[i] += tokens[i + 2];
        tokens.splice(i + 1, 2);
        i--;
    }
    return tokens;
};
function $bdbd131d78a26da0$export$5643fba310ccb33(oldStr, newStr, options) {
    options = (0, $6eb703735d5d8159$export$c21133b4499f5374)(options, {
        ignoreWhitespace: true
    });
    return $bdbd131d78a26da0$export$bcda4af332628932.diff(oldStr, newStr, options);
}
function $bdbd131d78a26da0$export$3941790a84174c86(oldStr, newStr, options) {
    return $bdbd131d78a26da0$export$bcda4af332628932.diff(oldStr, newStr, options);
}




const $33da5216b46040d6$export$ab62ee490ea249f1 = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
$33da5216b46040d6$export$ab62ee490ea249f1.tokenize = function(value) {
    let retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/);
    // Ignore the final empty token that occurs if the string ends with a new line
    if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
    // Merge the content and line separators into single tokens
    for(let i = 0; i < linesAndNewlines.length; i++){
        let line = linesAndNewlines[i];
        if (i % 2 && !this.options.newlineIsToken) retLines[retLines.length - 1] += line;
        else {
            if (this.options.ignoreWhitespace) line = line.trim();
            retLines.push(line);
        }
    }
    return retLines;
};
function $33da5216b46040d6$export$a2a88fc03c6c0a3(oldStr, newStr, callback) {
    return $33da5216b46040d6$export$ab62ee490ea249f1.diff(oldStr, newStr, callback);
}
function $33da5216b46040d6$export$cd9eeaf4d4607510(oldStr, newStr, callback) {
    let options = (0, $6eb703735d5d8159$export$c21133b4499f5374)(callback, {
        ignoreWhitespace: true
    });
    return $33da5216b46040d6$export$ab62ee490ea249f1.diff(oldStr, newStr, options);
}



const $820658b9b7e87a2f$export$8fdc181b03757dcf = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
$820658b9b7e87a2f$export$8fdc181b03757dcf.tokenize = function(value) {
    return value.split(/(\S.+?[.!?])(?=\s+|$)/);
};
function $820658b9b7e87a2f$export$59a838b01f064bbb(oldStr, newStr, callback) {
    return $820658b9b7e87a2f$export$8fdc181b03757dcf.diff(oldStr, newStr, callback);
}



const $4aad74c759278f7d$export$8a88d549ade89d13 = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
$4aad74c759278f7d$export$8a88d549ade89d13.tokenize = function(value) {
    return value.split(/([{}:;,]|\s+)/);
};
function $4aad74c759278f7d$export$c4fce3ea136641c(oldStr, newStr, callback) {
    return $4aad74c759278f7d$export$8a88d549ade89d13.diff(oldStr, newStr, callback);
}




const $e8feb78c6107c0cb$var$objectPrototypeToString = Object.prototype.toString;
const $e8feb78c6107c0cb$export$7d1bca74ea33ae0d = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
// Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
$e8feb78c6107c0cb$export$7d1bca74ea33ae0d.useLongestToken = true;
$e8feb78c6107c0cb$export$7d1bca74ea33ae0d.tokenize = (0, $33da5216b46040d6$export$ab62ee490ea249f1).tokenize;
$e8feb78c6107c0cb$export$7d1bca74ea33ae0d.castInput = function(value) {
    const { undefinedReplacement: undefinedReplacement, stringifyReplacer: stringifyReplacer = (k, v)=>typeof v === "undefined" ? undefinedReplacement : v } = this.options;
    return typeof value === "string" ? value : JSON.stringify($e8feb78c6107c0cb$export$e55b76bdd351fffc(value, null, null, stringifyReplacer), stringifyReplacer, "  ");
};
$e8feb78c6107c0cb$export$7d1bca74ea33ae0d.equals = function(left, right) {
    return (0, $5c0572bf01fe0534$export$2e2bcd8739ae039).prototype.equals.call($e8feb78c6107c0cb$export$7d1bca74ea33ae0d, left.replace(/,([\r\n])/g, "$1"), right.replace(/,([\r\n])/g, "$1"));
};
function $e8feb78c6107c0cb$export$904c012e6be94faf(oldObj, newObj, options) {
    return $e8feb78c6107c0cb$export$7d1bca74ea33ae0d.diff(oldObj, newObj, options);
}
function $e8feb78c6107c0cb$export$e55b76bdd351fffc(obj, stack, replacementStack, replacer, key) {
    stack = stack || [];
    replacementStack = replacementStack || [];
    if (replacer) obj = replacer(key, obj);
    let i;
    for(i = 0; i < stack.length; i += 1){
        if (stack[i] === obj) return replacementStack[i];
    }
    let canonicalizedObj;
    if ("[object Array]" === $e8feb78c6107c0cb$var$objectPrototypeToString.call(obj)) {
        stack.push(obj);
        canonicalizedObj = new Array(obj.length);
        replacementStack.push(canonicalizedObj);
        for(i = 0; i < obj.length; i += 1)canonicalizedObj[i] = $e8feb78c6107c0cb$export$e55b76bdd351fffc(obj[i], stack, replacementStack, replacer, key);
        stack.pop();
        replacementStack.pop();
        return canonicalizedObj;
    }
    if (obj && obj.toJSON) obj = obj.toJSON();
    if (typeof obj === "object" && obj !== null) {
        stack.push(obj);
        canonicalizedObj = {};
        replacementStack.push(canonicalizedObj);
        let sortedKeys = [], key;
        for(key in obj)/* istanbul ignore else */ if (obj.hasOwnProperty(key)) sortedKeys.push(key);
        sortedKeys.sort();
        for(i = 0; i < sortedKeys.length; i += 1){
            key = sortedKeys[i];
            canonicalizedObj[key] = $e8feb78c6107c0cb$export$e55b76bdd351fffc(obj[key], stack, replacementStack, replacer, key);
        }
        stack.pop();
        replacementStack.pop();
    } else canonicalizedObj = obj;
    return canonicalizedObj;
}



const $687be3d611b641e8$export$c60e0e71ff2ff066 = new (0, $5c0572bf01fe0534$export$2e2bcd8739ae039)();
$687be3d611b641e8$export$c60e0e71ff2ff066.tokenize = function(value) {
    return value.slice();
};
$687be3d611b641e8$export$c60e0e71ff2ff066.join = $687be3d611b641e8$export$c60e0e71ff2ff066.removeEmpty = function(value) {
    return value;
};
function $687be3d611b641e8$export$f1c08b3bfc8443c4(oldArr, newArr, callback) {
    return $687be3d611b641e8$export$c60e0e71ff2ff066.diff(oldArr, newArr, callback);
}


function $3cc14d410f0501f6$export$319fae3601428334(uniDiff, options = {}) {
    let diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/), delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [], list = [], i = 0;
    function parseIndex() {
        let index = {};
        list.push(index);
        // Parse diff metadata
        while(i < diffstr.length){
            let line = diffstr[i];
            // File header found, end parsing diff metadata
            if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) break;
            // Diff index
            let header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
            if (header) index.index = header[1];
            i++;
        }
        // Parse file headers if they are defined. Unified diff requires them, but
        // there's no technical issues to have an isolated hunk without file header
        parseFileHeader(index);
        parseFileHeader(index);
        // Parse hunks
        index.hunks = [];
        while(i < diffstr.length){
            let line = diffstr[i];
            if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(line)) break;
            else if (/^@@/.test(line)) index.hunks.push(parseHunk());
            else if (line && options.strict) // Ignore unexpected content unless in strict mode
            throw new Error("Unknown line " + (i + 1) + " " + JSON.stringify(line));
            else i++;
        }
    }
    // Parses the --- and +++ headers, if none are found, no lines
    // are consumed.
    function parseFileHeader(index) {
        const fileHeader = /^(---|\+\+\+)\s+(.*)$/.exec(diffstr[i]);
        if (fileHeader) {
            let keyPrefix = fileHeader[1] === "---" ? "old" : "new";
            const data = fileHeader[2].split("	", 2);
            let fileName = data[0].replace(/\\\\/g, "\\");
            if (/^".*"$/.test(fileName)) fileName = fileName.substr(1, fileName.length - 2);
            index[keyPrefix + "FileName"] = fileName;
            index[keyPrefix + "Header"] = (data[1] || "").trim();
            i++;
        }
    }
    // Parses a hunk
    // This assumes that we are at the start of a hunk.
    function parseHunk() {
        let chunkHeaderIndex = i, chunkHeaderLine = diffstr[i++], chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
        let hunk = {
            oldStart: +chunkHeader[1],
            oldLines: typeof chunkHeader[2] === "undefined" ? 1 : +chunkHeader[2],
            newStart: +chunkHeader[3],
            newLines: typeof chunkHeader[4] === "undefined" ? 1 : +chunkHeader[4],
            lines: [],
            linedelimiters: []
        };
        // Unified Diff Format quirk: If the chunk size is 0,
        // the first number is one lower than one would expect.
        // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
        if (hunk.oldLines === 0) hunk.oldStart += 1;
        if (hunk.newLines === 0) hunk.newStart += 1;
        let addCount = 0, removeCount = 0;
        for(; i < diffstr.length; i++){
            // Lines starting with '---' could be mistaken for the "remove line" operation
            // But they could be the header for the next file. Therefore prune such cases out.
            if (diffstr[i].indexOf("--- ") === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf("+++ ") === 0 && diffstr[i + 2].indexOf("@@") === 0) break;
            let operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? " " : diffstr[i][0];
            if (operation === "+" || operation === "-" || operation === " " || operation === "\\") {
                hunk.lines.push(diffstr[i]);
                hunk.linedelimiters.push(delimiters[i] || "\n");
                if (operation === "+") addCount++;
                else if (operation === "-") removeCount++;
                else if (operation === " ") {
                    addCount++;
                    removeCount++;
                }
            } else break;
        }
        // Handle the empty block count case
        if (!addCount && hunk.newLines === 1) hunk.newLines = 0;
        if (!removeCount && hunk.oldLines === 1) hunk.oldLines = 0;
        // Perform optional sanity checking
        if (options.strict) {
            if (addCount !== hunk.newLines) throw new Error("Added line count did not match for hunk at line " + (chunkHeaderIndex + 1));
            if (removeCount !== hunk.oldLines) throw new Error("Removed line count did not match for hunk at line " + (chunkHeaderIndex + 1));
        }
        return hunk;
    }
    while(i < diffstr.length)parseIndex();
    return list;
}


// Iterator that traverses in the range of [min, max], stepping
// by distance from a given start position. I.e. for [0, 4], with
// start of 2, this will iterate 2, 3, 1, 4, 0.
function $2e4fb2392b1b6823$export$2e2bcd8739ae039(start, minLine, maxLine) {
    let wantForward = true, backwardExhausted = false, forwardExhausted = false, localOffset = 1;
    return function iterator() {
        if (wantForward && !forwardExhausted) {
            if (backwardExhausted) localOffset++;
            else wantForward = false;
            // Check if trying to fit beyond text length, and if not, check it fits
            // after offset location (or desired location on first iteration)
            if (start + localOffset <= maxLine) return localOffset;
            forwardExhausted = true;
        }
        if (!backwardExhausted) {
            if (!forwardExhausted) wantForward = true;
            // Check if trying to fit before text beginning, and if not, check it fits
            // before offset location
            if (minLine <= start - localOffset) return -localOffset++;
            backwardExhausted = true;
            return iterator();
        }
    // We tried to fit hunk before text beginning and beyond text length, then
    // hunk can't fit on the text. Return undefined
    };
}


function $f1dbd7b7eda1f6cc$export$7383fd3fd73657b6(source, uniDiff, options = {}) {
    if (typeof uniDiff === "string") uniDiff = (0, $3cc14d410f0501f6$export$319fae3601428334)(uniDiff);
    if (Array.isArray(uniDiff)) {
        if (uniDiff.length > 1) throw new Error("applyPatch only works with a single input.");
        uniDiff = uniDiff[0];
    }
    // Apply the diff to the input
    let lines = source.split(/\r\n|[\n\v\f\r\x85]/), delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [], hunks = uniDiff.hunks, compareLine = options.compareLine || ((lineNumber, line, operation, patchContent)=>line === patchContent), errorCount = 0, fuzzFactor = options.fuzzFactor || 0, minLine = 0, offset = 0, removeEOFNL, addEOFNL;
    /**
   * Checks if the hunk exactly fits on the provided location
   */ function hunkFits(hunk, toPos) {
        for(let j = 0; j < hunk.lines.length; j++){
            let line = hunk.lines[j], operation = line.length > 0 ? line[0] : " ", content = line.length > 0 ? line.substr(1) : line;
            if (operation === " " || operation === "-") {
                // Context sanity check
                if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
                    errorCount++;
                    if (errorCount > fuzzFactor) return false;
                }
                toPos++;
            }
        }
        return true;
    }
    // Search best fit offsets for each hunk based on the previous ones
    for(let i = 0; i < hunks.length; i++){
        let hunk = hunks[i], maxLine = lines.length - hunk.oldLines, localOffset = 0, toPos = offset + hunk.oldStart - 1;
        let iterator = (0, $2e4fb2392b1b6823$export$2e2bcd8739ae039)(toPos, minLine, maxLine);
        for(; localOffset !== undefined; localOffset = iterator())if (hunkFits(hunk, toPos + localOffset)) {
            hunk.offset = offset += localOffset;
            break;
        }
        if (localOffset === undefined) return false;
        // Set lower text limit to end of the current hunk, so next ones don't try
        // to fit over already patched text
        minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
    }
    // Apply patch hunks
    let diffOffset = 0;
    for(let i = 0; i < hunks.length; i++){
        let hunk = hunks[i], toPos = hunk.oldStart + hunk.offset + diffOffset - 1;
        diffOffset += hunk.newLines - hunk.oldLines;
        for(let j = 0; j < hunk.lines.length; j++){
            let line = hunk.lines[j], operation = line.length > 0 ? line[0] : " ", content = line.length > 0 ? line.substr(1) : line, delimiter = hunk.linedelimiters[j];
            if (operation === " ") toPos++;
            else if (operation === "-") {
                lines.splice(toPos, 1);
                delimiters.splice(toPos, 1);
            /* istanbul ignore else */ } else if (operation === "+") {
                lines.splice(toPos, 0, content);
                delimiters.splice(toPos, 0, delimiter);
                toPos++;
            } else if (operation === "\\") {
                let previousOperation = hunk.lines[j - 1] ? hunk.lines[j - 1][0] : null;
                if (previousOperation === "+") removeEOFNL = true;
                else if (previousOperation === "-") addEOFNL = true;
            }
        }
    }
    // Handle EOFNL insertion/removal
    if (removeEOFNL) while(!lines[lines.length - 1]){
        lines.pop();
        delimiters.pop();
    }
    else if (addEOFNL) {
        lines.push("");
        delimiters.push("\n");
    }
    for(let _k = 0; _k < lines.length - 1; _k++)lines[_k] = lines[_k] + delimiters[_k];
    return lines.join("");
}
function $f1dbd7b7eda1f6cc$export$a8b8e03e6bbe5473(uniDiff, options) {
    if (typeof uniDiff === "string") uniDiff = (0, $3cc14d410f0501f6$export$319fae3601428334)(uniDiff);
    let currentIndex = 0;
    function processIndex() {
        let index = uniDiff[currentIndex++];
        if (!index) return options.complete();
        options.loadFile(index, function(err, data) {
            if (err) return options.complete(err);
            let updatedContent = $f1dbd7b7eda1f6cc$export$7383fd3fd73657b6(data, index, options);
            options.patched(index, updatedContent, function(err) {
                if (err) return options.complete(err);
                processIndex();
            });
        });
    }
    processIndex();
}




function $dc19cbd27c72eba3$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    if (!options) options = {};
    if (typeof options.context === "undefined") options.context = 4;
    const diff = (0, $33da5216b46040d6$export$a2a88fc03c6c0a3)(oldStr, newStr, options);
    if (!diff) return;
    diff.push({
        value: "",
        lines: []
    }); // Append an empty value to make cleanup easier
    function contextLines(lines) {
        return lines.map(function(entry) {
            return " " + entry;
        });
    }
    let hunks = [];
    let oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
    for(let i = 0; i < diff.length; i++){
        const current = diff[i], lines = current.lines || current.value.replace(/\n$/, "").split("\n");
        current.lines = lines;
        if (current.added || current.removed) {
            // If we have previous context, start with that
            if (!oldRangeStart) {
                const prev = diff[i - 1];
                oldRangeStart = oldLine;
                newRangeStart = newLine;
                if (prev) {
                    curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
                    oldRangeStart -= curRange.length;
                    newRangeStart -= curRange.length;
                }
            }
            // Output our changes
            curRange.push(...lines.map(function(entry) {
                return (current.added ? "+" : "-") + entry;
            }));
            // Track the updated file position
            if (current.added) newLine += lines.length;
            else oldLine += lines.length;
        } else {
            // Identical context lines. Track line changes
            if (oldRangeStart) {
                // Close out any changes that have been output (or join overlapping)
                if (lines.length <= options.context * 2 && i < diff.length - 2) // Overlapping
                curRange.push(...contextLines(lines));
                else {
                    // end the range and output
                    let contextSize = Math.min(lines.length, options.context);
                    curRange.push(...contextLines(lines.slice(0, contextSize)));
                    let hunk = {
                        oldStart: oldRangeStart,
                        oldLines: oldLine - oldRangeStart + contextSize,
                        newStart: newRangeStart,
                        newLines: newLine - newRangeStart + contextSize,
                        lines: curRange
                    };
                    if (i >= diff.length - 2 && lines.length <= options.context) {
                        // EOF is inside this hunk
                        let oldEOFNewline = /\n$/.test(oldStr);
                        let newEOFNewline = /\n$/.test(newStr);
                        let noNlBeforeAdds = lines.length == 0 && curRange.length > hunk.oldLines;
                        if (!oldEOFNewline && noNlBeforeAdds && oldStr.length > 0) // special case: old has no eol and no trailing context; no-nl can end up before adds
                        // however, if the old file is empty, do not output the no-nl line
                        curRange.splice(hunk.oldLines, 0, "\\ No newline at end of file");
                        if (!oldEOFNewline && !noNlBeforeAdds || !newEOFNewline) curRange.push("\\ No newline at end of file");
                    }
                    hunks.push(hunk);
                    oldRangeStart = 0;
                    newRangeStart = 0;
                    curRange = [];
                }
            }
            oldLine += lines.length;
            newLine += lines.length;
        }
    }
    return {
        oldFileName: oldFileName,
        newFileName: newFileName,
        oldHeader: oldHeader,
        newHeader: newHeader,
        hunks: hunks
    };
}
function $dc19cbd27c72eba3$export$3c97ed4bbaa81f7a(diff) {
    const ret = [];
    if (diff.oldFileName == diff.newFileName) ret.push("Index: " + diff.oldFileName);
    ret.push("===================================================================");
    ret.push("--- " + diff.oldFileName + (typeof diff.oldHeader === "undefined" ? "" : "	" + diff.oldHeader));
    ret.push("+++ " + diff.newFileName + (typeof diff.newHeader === "undefined" ? "" : "	" + diff.newHeader));
    for(let i = 0; i < diff.hunks.length; i++){
        const hunk = diff.hunks[i];
        // Unified Diff Format quirk: If the chunk size is 0,
        // the first number is one lower than one would expect.
        // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
        if (hunk.oldLines === 0) hunk.oldStart -= 1;
        if (hunk.newLines === 0) hunk.newStart -= 1;
        ret.push("@@ -" + hunk.oldStart + "," + hunk.oldLines + " +" + hunk.newStart + "," + hunk.newLines + " @@");
        ret.push.apply(ret, hunk.lines);
    }
    return ret.join("\n") + "\n";
}
function $dc19cbd27c72eba3$export$80aac8782e10a34f(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    return $dc19cbd27c72eba3$export$3c97ed4bbaa81f7a($dc19cbd27c72eba3$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options));
}
function $dc19cbd27c72eba3$export$4b8f0727f602f200(fileName, oldStr, newStr, oldHeader, newHeader, options) {
    return $dc19cbd27c72eba3$export$80aac8782e10a34f(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
}



function $bad406681d83bfba$export$5b61df4dabb66ee7(a, b) {
    if (a.length !== b.length) return false;
    return $bad406681d83bfba$export$28e46a10850766f0(a, b);
}
function $bad406681d83bfba$export$28e46a10850766f0(array, start) {
    if (start.length > array.length) return false;
    for(let i = 0; i < start.length; i++){
        if (start[i] !== array[i]) return false;
    }
    return true;
}


function $ad95cc956f7a4881$export$a8f0ced609c2ec2d(hunk) {
    const { oldLines: oldLines, newLines: newLines } = $ad95cc956f7a4881$var$calcOldNewLineCount(hunk.lines);
    if (oldLines !== undefined) hunk.oldLines = oldLines;
    else delete hunk.oldLines;
    if (newLines !== undefined) hunk.newLines = newLines;
    else delete hunk.newLines;
}
function $ad95cc956f7a4881$export$4950aa0f605343fb(mine, theirs, base) {
    mine = $ad95cc956f7a4881$var$loadPatch(mine, base);
    theirs = $ad95cc956f7a4881$var$loadPatch(theirs, base);
    let ret = {};
    // For index we just let it pass through as it doesn't have any necessary meaning.
    // Leaving sanity checks on this to the API consumer that may know more about the
    // meaning in their own context.
    if (mine.index || theirs.index) ret.index = mine.index || theirs.index;
    if (mine.newFileName || theirs.newFileName) {
        if (!$ad95cc956f7a4881$var$fileNameChanged(mine)) {
            // No header or no change in ours, use theirs (and ours if theirs does not exist)
            ret.oldFileName = theirs.oldFileName || mine.oldFileName;
            ret.newFileName = theirs.newFileName || mine.newFileName;
            ret.oldHeader = theirs.oldHeader || mine.oldHeader;
            ret.newHeader = theirs.newHeader || mine.newHeader;
        } else if (!$ad95cc956f7a4881$var$fileNameChanged(theirs)) {
            // No header or no change in theirs, use ours
            ret.oldFileName = mine.oldFileName;
            ret.newFileName = mine.newFileName;
            ret.oldHeader = mine.oldHeader;
            ret.newHeader = mine.newHeader;
        } else {
            // Both changed... figure it out
            ret.oldFileName = $ad95cc956f7a4881$var$selectField(ret, mine.oldFileName, theirs.oldFileName);
            ret.newFileName = $ad95cc956f7a4881$var$selectField(ret, mine.newFileName, theirs.newFileName);
            ret.oldHeader = $ad95cc956f7a4881$var$selectField(ret, mine.oldHeader, theirs.oldHeader);
            ret.newHeader = $ad95cc956f7a4881$var$selectField(ret, mine.newHeader, theirs.newHeader);
        }
    }
    ret.hunks = [];
    let mineIndex = 0, theirsIndex = 0, mineOffset = 0, theirsOffset = 0;
    while(mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length){
        let mineCurrent = mine.hunks[mineIndex] || {
            oldStart: Infinity
        }, theirsCurrent = theirs.hunks[theirsIndex] || {
            oldStart: Infinity
        };
        if ($ad95cc956f7a4881$var$hunkBefore(mineCurrent, theirsCurrent)) {
            // This patch does not overlap with any of the others, yay.
            ret.hunks.push($ad95cc956f7a4881$var$cloneHunk(mineCurrent, mineOffset));
            mineIndex++;
            theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
        } else if ($ad95cc956f7a4881$var$hunkBefore(theirsCurrent, mineCurrent)) {
            // This patch does not overlap with any of the others, yay.
            ret.hunks.push($ad95cc956f7a4881$var$cloneHunk(theirsCurrent, theirsOffset));
            theirsIndex++;
            mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
        } else {
            // Overlap, merge as best we can
            let mergedHunk = {
                oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
                oldLines: 0,
                newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
                newLines: 0,
                lines: []
            };
            $ad95cc956f7a4881$var$mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
            theirsIndex++;
            mineIndex++;
            ret.hunks.push(mergedHunk);
        }
    }
    return ret;
}
function $ad95cc956f7a4881$var$loadPatch(param, base) {
    if (typeof param === "string") {
        if (/^@@/m.test(param) || /^Index:/m.test(param)) return (0, $3cc14d410f0501f6$export$319fae3601428334)(param)[0];
        if (!base) throw new Error("Must provide a base reference or pass in a patch");
        return (0, $dc19cbd27c72eba3$export$a67febf3ed67329c)(undefined, undefined, base, param);
    }
    return param;
}
function $ad95cc956f7a4881$var$fileNameChanged(patch) {
    return patch.newFileName && patch.newFileName !== patch.oldFileName;
}
function $ad95cc956f7a4881$var$selectField(index, mine, theirs) {
    if (mine === theirs) return mine;
    else {
        index.conflict = true;
        return {
            mine: mine,
            theirs: theirs
        };
    }
}
function $ad95cc956f7a4881$var$hunkBefore(test, check) {
    return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
}
function $ad95cc956f7a4881$var$cloneHunk(hunk, offset) {
    return {
        oldStart: hunk.oldStart,
        oldLines: hunk.oldLines,
        newStart: hunk.newStart + offset,
        newLines: hunk.newLines,
        lines: hunk.lines
    };
}
function $ad95cc956f7a4881$var$mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
    // This will generally result in a conflicted hunk, but there are cases where the context
    // is the only overlap where we can successfully merge the content here.
    let mine = {
        offset: mineOffset,
        lines: mineLines,
        index: 0
    }, their = {
        offset: theirOffset,
        lines: theirLines,
        index: 0
    };
    // Handle any leading content
    $ad95cc956f7a4881$var$insertLeading(hunk, mine, their);
    $ad95cc956f7a4881$var$insertLeading(hunk, their, mine);
    // Now in the overlap content. Scan through and select the best changes from each.
    while(mine.index < mine.lines.length && their.index < their.lines.length){
        let mineCurrent = mine.lines[mine.index], theirCurrent = their.lines[their.index];
        if ((mineCurrent[0] === "-" || mineCurrent[0] === "+") && (theirCurrent[0] === "-" || theirCurrent[0] === "+")) // Both modified ...
        $ad95cc956f7a4881$var$mutualChange(hunk, mine, their);
        else if (mineCurrent[0] === "+" && theirCurrent[0] === " ") // Mine inserted
        hunk.lines.push(...$ad95cc956f7a4881$var$collectChange(mine));
        else if (theirCurrent[0] === "+" && mineCurrent[0] === " ") // Theirs inserted
        hunk.lines.push(...$ad95cc956f7a4881$var$collectChange(their));
        else if (mineCurrent[0] === "-" && theirCurrent[0] === " ") // Mine removed or edited
        $ad95cc956f7a4881$var$removal(hunk, mine, their);
        else if (theirCurrent[0] === "-" && mineCurrent[0] === " ") // Their removed or edited
        $ad95cc956f7a4881$var$removal(hunk, their, mine, true);
        else if (mineCurrent === theirCurrent) {
            // Context identity
            hunk.lines.push(mineCurrent);
            mine.index++;
            their.index++;
        } else // Context mismatch
        $ad95cc956f7a4881$var$conflict(hunk, $ad95cc956f7a4881$var$collectChange(mine), $ad95cc956f7a4881$var$collectChange(their));
    }
    // Now push anything that may be remaining
    $ad95cc956f7a4881$var$insertTrailing(hunk, mine);
    $ad95cc956f7a4881$var$insertTrailing(hunk, their);
    $ad95cc956f7a4881$export$a8f0ced609c2ec2d(hunk);
}
function $ad95cc956f7a4881$var$mutualChange(hunk, mine, their) {
    let myChanges = $ad95cc956f7a4881$var$collectChange(mine), theirChanges = $ad95cc956f7a4881$var$collectChange(their);
    if ($ad95cc956f7a4881$var$allRemoves(myChanges) && $ad95cc956f7a4881$var$allRemoves(theirChanges)) {
        // Special case for remove changes that are supersets of one another
        if ((0, $bad406681d83bfba$export$28e46a10850766f0)(myChanges, theirChanges) && $ad95cc956f7a4881$var$skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
            hunk.lines.push(...myChanges);
            return;
        } else if ((0, $bad406681d83bfba$export$28e46a10850766f0)(theirChanges, myChanges) && $ad95cc956f7a4881$var$skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
            hunk.lines.push(...theirChanges);
            return;
        }
    } else if ((0, $bad406681d83bfba$export$5b61df4dabb66ee7)(myChanges, theirChanges)) {
        hunk.lines.push(...myChanges);
        return;
    }
    $ad95cc956f7a4881$var$conflict(hunk, myChanges, theirChanges);
}
function $ad95cc956f7a4881$var$removal(hunk, mine, their, swap) {
    let myChanges = $ad95cc956f7a4881$var$collectChange(mine), theirChanges = $ad95cc956f7a4881$var$collectContext(their, myChanges);
    if (theirChanges.merged) hunk.lines.push(...theirChanges.merged);
    else $ad95cc956f7a4881$var$conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
}
function $ad95cc956f7a4881$var$conflict(hunk, mine, their) {
    hunk.conflict = true;
    hunk.lines.push({
        conflict: true,
        mine: mine,
        theirs: their
    });
}
function $ad95cc956f7a4881$var$insertLeading(hunk, insert, their) {
    while(insert.offset < their.offset && insert.index < insert.lines.length){
        let line = insert.lines[insert.index++];
        hunk.lines.push(line);
        insert.offset++;
    }
}
function $ad95cc956f7a4881$var$insertTrailing(hunk, insert) {
    while(insert.index < insert.lines.length){
        let line = insert.lines[insert.index++];
        hunk.lines.push(line);
    }
}
function $ad95cc956f7a4881$var$collectChange(state) {
    let ret = [], operation = state.lines[state.index][0];
    while(state.index < state.lines.length){
        let line = state.lines[state.index];
        // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
        if (operation === "-" && line[0] === "+") operation = "+";
        if (operation === line[0]) {
            ret.push(line);
            state.index++;
        } else break;
    }
    return ret;
}
function $ad95cc956f7a4881$var$collectContext(state, matchChanges) {
    let changes = [], merged = [], matchIndex = 0, contextChanges = false, conflicted = false;
    while(matchIndex < matchChanges.length && state.index < state.lines.length){
        let change = state.lines[state.index], match = matchChanges[matchIndex];
        // Once we've hit our add, then we are done
        if (match[0] === "+") break;
        contextChanges = contextChanges || change[0] !== " ";
        merged.push(match);
        matchIndex++;
        // Consume any additions in the other block as a conflict to attempt
        // to pull in the remaining context after this
        if (change[0] === "+") {
            conflicted = true;
            while(change[0] === "+"){
                changes.push(change);
                change = state.lines[++state.index];
            }
        }
        if (match.substr(1) === change.substr(1)) {
            changes.push(change);
            state.index++;
        } else conflicted = true;
    }
    if ((matchChanges[matchIndex] || "")[0] === "+" && contextChanges) conflicted = true;
    if (conflicted) return changes;
    while(matchIndex < matchChanges.length)merged.push(matchChanges[matchIndex++]);
    return {
        merged: merged,
        changes: changes
    };
}
function $ad95cc956f7a4881$var$allRemoves(changes) {
    return changes.reduce(function(prev, change) {
        return prev && change[0] === "-";
    }, true);
}
function $ad95cc956f7a4881$var$skipRemoveSuperset(state, removeChanges, delta) {
    for(let i = 0; i < delta; i++){
        let changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
        if (state.lines[state.index + i] !== " " + changeContent) return false;
    }
    state.index += delta;
    return true;
}
function $ad95cc956f7a4881$var$calcOldNewLineCount(lines) {
    let oldLines = 0;
    let newLines = 0;
    lines.forEach(function(line) {
        if (typeof line !== "string") {
            let myCount = $ad95cc956f7a4881$var$calcOldNewLineCount(line.mine);
            let theirCount = $ad95cc956f7a4881$var$calcOldNewLineCount(line.theirs);
            if (oldLines !== undefined) {
                if (myCount.oldLines === theirCount.oldLines) oldLines += myCount.oldLines;
                else oldLines = undefined;
            }
            if (newLines !== undefined) {
                if (myCount.newLines === theirCount.newLines) newLines += myCount.newLines;
                else newLines = undefined;
            }
        } else {
            if (newLines !== undefined && (line[0] === "+" || line[0] === " ")) newLines++;
            if (oldLines !== undefined && (line[0] === "-" || line[0] === " ")) oldLines++;
        }
    });
    return {
        oldLines: oldLines,
        newLines: newLines
    };
}



// See: http://code.google.com/p/google-diff-match-patch/wiki/API
function $89fb4d2dea11c2bd$export$56e038dc2cb96fda(changes) {
    let ret = [], change, operation;
    for(let i = 0; i < changes.length; i++){
        change = changes[i];
        if (change.added) operation = 1;
        else if (change.removed) operation = -1;
        else operation = 0;
        ret.push([
            operation,
            change.value
        ]);
    }
    return ret;
}


function $f03d5bf76f886b4a$export$1fa5526f71269cc8(changes) {
    let ret = [];
    for(let i = 0; i < changes.length; i++){
        let change = changes[i];
        if (change.added) ret.push("<ins>");
        else if (change.removed) ret.push("<del>");
        ret.push($f03d5bf76f886b4a$var$escapeHTML(change.value));
        if (change.added) ret.push("</ins>");
        else if (change.removed) ret.push("</del>");
    }
    return ret.join("");
}
function $f03d5bf76f886b4a$var$escapeHTML(s) {
    let n = s;
    n = n.replace(/&/g, "&amp;");
    n = n.replace(/</g, "&lt;");
    n = n.replace(/>/g, "&gt;");
    n = n.replace(/"/g, "&quot;");
    return n;
}




const $39f2b5fa2c9706a5$var$RemoveItem = Phaser.Utils.Array.Remove;
var $39f2b5fa2c9706a5$var$SetText = function(textObject, newText) {
    var text = textObject.text;
    if (newText === text) return;
    // textObject.setText(newText);
    // Remove lastInsertCursor directly 
    $39f2b5fa2c9706a5$var$RemoveItem(textObject.children, textObject.lastInsertCursor);
    if (newText === "") textObject.removeChildren();
    else {
        var results = (0, $de0f25e7b33e1f4f$export$325021f2061a40f5)(text, newText);
        var charIndex = 0;
        for(var i = 0, cnt = results.length; i < cnt; i++){
            var result = results[i];
            if (result.removed) // Remove character at charIndex
            textObject.removeText(charIndex, result.count);
            else if (result.added) {
                textObject.insertText(charIndex, result.value);
                charIndex += result.count;
            } else charIndex += result.count;
        }
    }
    // Push back lastInsertCursor directly
    textObject.children.push(textObject.lastInsertCursor);
    textObject.runWordWrap();
};
var $39f2b5fa2c9706a5$export$2e2bcd8739ae039 = $39f2b5fa2c9706a5$var$SetText;



const $b312eecc4ac364b1$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $b312eecc4ac364b1$var$CanvasInput extends (0, $c7da6d512822e889$export$2e2bcd8739ae039) {
    constructor(scene, x, y, fixedWidth, fixedHeight, config){
        if ($b312eecc4ac364b1$var$IsPlainObject(x)) config = x;
        else if ($b312eecc4ac364b1$var$IsPlainObject(fixedWidth)) config = fixedWidth;
        if (config === undefined) config = {};
        (0, $682d97cadfcfd615$export$2e2bcd8739ae039)(config);
        // Set text later
        var text = config.text;
        if (text) delete config.text;
        var focusStyle = (0, $8af47e6cc9907a17$export$2e2bcd8739ae039)(config.background, "focus");
        var cursorStyle = (0, $8af47e6cc9907a17$export$2e2bcd8739ae039)(config.style, "cursor");
        super(scene, x, y, fixedWidth, fixedHeight, config);
        this.type = "rexCanvasInput";
        this._text = "";
        this.textEdit = (0, $c6e29cbb2ab3c213$export$2e2bcd8739ae039)(this, config);
        if (config.focusStyle) Object.assign(focusStyle, config.focusStyle);
        (0, $5e9b81e523bb9c7d$export$2e2bcd8739ae039).call(this, focusStyle);
        if (config.cursorStyle) Object.assign(cursorStyle, config.cursorStyle);
        (0, $ef8ba2c9adc1ff88$export$2e2bcd8739ae039).call(this, cursorStyle);
        var addCharCallback = config.onAddChar;
        if (addCharCallback) this.on("addchar", addCharCallback);
        var cursorOutCallback = config.onCursorOut;
        if (cursorOutCallback) this.on("cursorout", cursorOutCallback);
        var cursorInCallback = config.onCursorIn;
        if (cursorInCallback) this.on("cursorin", cursorInCallback);
        var moveCursorCallback = config.onMoveCursor;
        if (moveCursorCallback) this.on("movecursor", moveCursorCallback);
        this.setParseTextCallback(config.parseTextCallback);
        this.lastInsertCursor = (0, $b9964988827574d7$export$2e2bcd8739ae039)(this);
        if (text) this.setText(text);
        else // Still need run word wrap for lastInsertCursor child
        this.runWordWrap();
    }
    addChild(child, index) {
        super.addChild(child, index);
        if (Array.isArray(child)) {
            var children = child;
            for(var i = 0, cnt = children.length; i < cnt; i++){
                var child = children[i];
                if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child)) this.emit("addchar", child, index + i, this);
            }
        } else if ((0, $5ef7af43adf3a4f3$export$a4ff6875eea5bed7)(child)) this.emit("addchar", child, index, this);
        return this;
    }
    get text() {
        return this._text;
    }
    set text(value) {
        if (value == null) value = "";
        else value = value.toString();
        if (this._text === value) return;
        (0, $39f2b5fa2c9706a5$export$2e2bcd8739ae039)(this, value);
        this._text = value;
    }
    setText(text) {
        this.text = text;
        return this;
    }
    appendText(text) {
        this.setText(this.text + text);
        return this;
    }
    setSize(width, height) {
        if (this.width === width && this.height === height) return this;
        super.setSize(width, height);
        // Run wrap again since fixedWidth and fixedHeight are changed
        this.runWrap();
        return this;
    }
    get displayText() {
        return this.text;
    }
    set displayText(value) {
        this.text = value;
    }
    setDisplayText(value) {
        this.displayText = value;
        return this;
    }
    get inputText() {
        return this.textEdit.text;
    }
    set inputText(value) {
        this.textEdit.text = value;
    }
    setInputText(value) {
        this.inputText = value;
        return this;
    }
    setParseTextCallback(callback) {
        if (!callback) callback = $b312eecc4ac364b1$var$DefaultParseTextCallback;
        this.parseTextCallback = callback;
        return this;
    }
    get value() {
        return this.parseTextCallback(this.text);
    }
    set value(value) {
        this.setText(value);
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    get readOnly() {
        return this.textEdit.readOnly;
    }
    set readOnly(value) {
        this.textEdit.readOnly = value;
    }
    setReadOnly(value) {
        this.textEdit.setReadOnly(value);
        return this;
    }
    open(onCloseCallback) {
        if (onCloseCallback) this.textEdit.once("close", onCloseCallback);
        this.textEdit.open();
        return this;
    }
    close() {
        this.textEdit.close();
        return this;
    }
    get isOpened() {
        return this.textEdit.isOpened;
    }
    setFocusStyle(style) {
        this.focusStyle = style;
        return this;
    }
    setCursorStyle(style) {
        this.cursorStyle = style;
        return this;
    }
    setNumberInput() {
        this.textEdit.setNumberInput();
        this.parseTextCallback = Number;
        return this;
    }
    get maxLength() {
        return this.textEdit.maxLength;
    }
    set maxLength(value) {
        this.textEdit.maxLength = value;
    }
    setMaxLength(value) {
        this.maxLength = value;
        return this;
    }
    get minLength() {
        return this.textEdit.minLength;
    }
    set minLength(value) {
        this.textEdit.minLength = value;
    }
    setMinLength(value) {
        this.minLength = value;
        return this;
    }
}
var $b312eecc4ac364b1$var$DefaultParseTextCallback = function(text) {
    return text;
};
var $b312eecc4ac364b1$export$2e2bcd8739ae039 = $b312eecc4ac364b1$var$CanvasInput;


var $ddf037e4ad936b23$export$2e2bcd8739ae039 = (0, $b312eecc4ac364b1$export$2e2bcd8739ae039);


var $27ef680b345dde22$export$2e2bcd8739ae039 = (0, $ddf037e4ad936b23$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("canvasInput", function(x, y, fixedWidth, fixedHeight, config) {
    var gameObject = new (0, $27ef680b345dde22$export$2e2bcd8739ae039)(this.scene, x, y, fixedWidth, fixedHeight, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CanvasInput", (0, $27ef680b345dde22$export$2e2bcd8739ae039));
var $44c779f20d957227$export$2e2bcd8739ae039 = (0, $27ef680b345dde22$export$2e2bcd8739ae039);





var $faac1631b82f4951$var$GetTickDelta = function(game) {
    return (0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(game).loop.delta;
};
var $faac1631b82f4951$export$2e2bcd8739ae039 = $faac1631b82f4951$var$GetTickDelta;


const $b52786e2f52453b1$var$GetValue = Phaser.Utils.Objects.GetValue;
const $b52786e2f52453b1$var$Wrap = Phaser.Math.Wrap;
class $b52786e2f52453b1$var$HiddenTextEdit extends (0, $252c9b782f14b3fd$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        if (config === undefined) config = {};
        if (config.onUpdate === "number") config.onUpdate = (0, $13b252f1a08478ca$export$2e2bcd8739ae039);
        super(gameObject, config);
        // this.parent = gameObject;
        this.setCursor($b52786e2f52453b1$var$GetValue(config, "cursor", "|"));
        this.setCursorFlashDuration($b52786e2f52453b1$var$GetValue(config, "cursorFlashDuration", 1000));
        this.cursorFlashTimer = 0;
    }
    initText() {
        this.cursorFlashTimer = 0;
        this.prevCursorPosition = undefined;
        this.setText(this.parent.text);
        this.setCursorPosition();
        return this;
    }
    updateText() {
        var textObject = this.parent;
        var text = this.text;
        if (this.onUpdateCallback) {
            var newText = this.onUpdateCallback(text, textObject, this);
            if (newText != null) text = newText;
        }
        if (this.isOpened && this.hasCursor) {
            // Insert Cursor
            var cursorPosition = this.cursorPosition;
            text = text.substring(0, cursorPosition) + this.cursor + text.substring(cursorPosition);
            if (this.prevCursorPosition !== cursorPosition) // console.log(cursorPosition);
            this.prevCursorPosition = cursorPosition;
        }
        if (textObject.text !== text) {
            textObject.setText(text);
            this.emit("textchange", text, textObject, this);
        }
        return this;
    }
    setCursor(s) {
        this._cursor = s;
        this.hasCursor = s && s !== "";
        return s;
    }
    setCursorFlashDuration(duration) {
        this.cursorFlashDuration = duration;
        return this;
    }
    get cursor() {
        if (!this._isFocused) return this._cursor;
        // Flash Cursor
        var cursor;
        if (this.cursorFlashTimer < this.cursorFlashDuration / 2) cursor = this._cursor;
        else cursor = " ";
        var timerValue = this.cursorFlashTimer + (0, $faac1631b82f4951$export$2e2bcd8739ae039)(this.scene);
        this.cursorFlashTimer = $b52786e2f52453b1$var$Wrap(timerValue, 0, this.cursorFlashDuration);
        return cursor;
    }
}
var $b52786e2f52453b1$export$2e2bcd8739ae039 = $b52786e2f52453b1$var$HiddenTextEdit;


var $5c46f65f7ca09a5d$export$2e2bcd8739ae039 = (0, $b52786e2f52453b1$export$2e2bcd8739ae039);


var $e36c60b10acf01cc$export$2e2bcd8739ae039 = (0, $5c46f65f7ca09a5d$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("hiddenEdit", function(textObject, config) {
    var gameObject = new (0, $e36c60b10acf01cc$export$2e2bcd8739ae039)(textObject, config);
    // Note: Don't add this game object into scene
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.HiddenEdit", (0, $e36c60b10acf01cc$export$2e2bcd8739ae039));
var $7d15bf8405a56433$export$2e2bcd8739ae039 = (0, $e36c60b10acf01cc$export$2e2bcd8739ae039);


const $fe3648590494b79f$var$GetCalcMatrix = Phaser.GameObjects.GetCalcMatrix;
var $fe3648590494b79f$var$WebGLRenderer = function(renderer, src, camera, parentMatrix) {
    src.updateData();
    camera.addToRenderList(src);
    var pipeline = renderer.pipelines.set(src.pipeline);
    var result = $fe3648590494b79f$var$GetCalcMatrix(src, camera, parentMatrix);
    var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
    var dx = src._displayOriginX;
    var dy = src._displayOriginY;
    var alpha = camera.alpha * src.alpha;
    renderer.pipelines.preBatch(src);
    var shapes = src.geom;
    for(var i = 0, cnt = shapes.length; i < cnt; i++)shapes[i].webglRender(pipeline, calcMatrix, alpha, dx, dy);
    renderer.pipelines.postBatch(src);
};
var $fe3648590494b79f$export$2e2bcd8739ae039 = $fe3648590494b79f$var$WebGLRenderer;


const $bd2b5eb85214cf48$var$SetTransform = Phaser.Renderer.Canvas.SetTransform;
var $bd2b5eb85214cf48$var$CanvasRenderer = function(renderer, src, camera, parentMatrix) {
    src.updateData();
    camera.addToRenderList(src);
    var ctx = renderer.currentContext;
    if ($bd2b5eb85214cf48$var$SetTransform(renderer, ctx, src, camera, parentMatrix)) {
        var dx = src._displayOriginX;
        var dy = src._displayOriginY;
        var shapes = src.geom;
        for(var i = 0, cnt = shapes.length; i < cnt; i++)shapes[i].canvasRender(ctx, dx, dy);
        //  Restore the context saved in SetTransform
        ctx.restore();
    }
};
var $bd2b5eb85214cf48$export$2e2bcd8739ae039 = $bd2b5eb85214cf48$var$CanvasRenderer;


var $7b8165543a7d61f3$export$2e2bcd8739ae039 = {
    renderWebGL: (0, $fe3648590494b79f$export$2e2bcd8739ae039),
    renderCanvas: (0, $bd2b5eb85214cf48$export$2e2bcd8739ae039)
};



const $fa309bb54d70b13f$var$Shape = Phaser.GameObjects.Shape;
const $fa309bb54d70b13f$var$RemoveItem = Phaser.Utils.Array.Remove;
class $fa309bb54d70b13f$var$BaseShapes extends $fa309bb54d70b13f$var$Shape {
    constructor(scene, x, y, width, height){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 2;
        if (height === undefined) height = width;
        super(scene, "rexShapes", []);
        this._width = -1;
        this._height = -1;
        this.dirty = true;
        this.isSizeChanged = true;
        this.shapes = {};
        this.setPosition(x, y);
        this.setSize(width, height);
        this.updateDisplayOrigin();
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this.setSize(value, this._height);
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this.setSize(this._width, value);
    }
    setDirty(value) {
        if (value === undefined) value = true;
        this.dirty = value;
        return this;
    }
    setSize(width, height) {
        this.isSizeChanged = this.isSizeChanged || this._width !== width || this._height !== height;
        this.dirty = this.dirty || this.isSizeChanged;
        this._width = width;
        this._height = height;
        this.updateDisplayOrigin();
        var input = this.input;
        if (input && !input.customHitArea) {
            input.hitArea.width = width;
            input.hitArea.height = height;
        }
        return this;
    }
    resize(width, height) {
        this.setSize(width, height);
        return this;
    }
    get fillColor() {
        return this._fillColor;
    }
    set fillColor(value) {
        this.setFillStyle(value, this._fillAlpha);
    }
    get fillAlpha() {
        return this._fillAlpha;
    }
    set fillAlpha(value) {
        this.setFillStyle(this._fillColor, value);
    }
    setFillStyle(color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.fillColor !== color || this.fillAlpha !== alpha;
        this._fillColor = color;
        this._fillAlpha = alpha;
        return this;
    }
    get lineWidth() {
        return this._lineWidth;
    }
    set lineWidth(value) {
        this.setStrokeStyle(value, this._strokeColor, this._strokeAlpha);
    }
    get strokeColor() {
        return this._strokeColor;
    }
    set strokeColor(value) {
        this.setStrokeStyle(this._lineWidth, value, this._strokeAlpha);
    }
    get strokeAlpha() {
        return this._strokeAlpha;
    }
    set strokeAlpha(value) {
        this.setStrokeStyle(this._lineWidth, this._strokeColor, value);
    }
    setStrokeStyle(lineWidth, color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.lineWidth !== lineWidth || this.strokeColor !== color || this.strokeAlpha !== alpha;
        this._lineWidth = lineWidth;
        this._strokeColor = color;
        this._strokeAlpha = alpha;
        return this;
    }
    updateShapes() {}
    updateData() {
        if (!this.dirty) return this;
        this.updateShapes();
        var shapes = this.geom;
        for(var i = 0, cnt = shapes.length; i < cnt; i++){
            var shape = shapes[i];
            if (shape.dirty) shape.updateData();
        }
        this.isSizeChanged = false;
        this.dirty = false;
        return this;
    }
    clear() {
        this.geom.length = 0;
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.shapes);
        return this;
    }
    getShape(name) {
        return this.shapes[name];
    }
    getShapes() {
        return this.geom;
    }
    addShape(shape) {
        this.geom.push(shape);
        var name = shape.name;
        if (name) this.shapes[name] = shape;
        this.dirty = true;
        return this;
    }
    deleteShape(name) {
        var shape = this.getShape(name);
        if (shape) {
            delete this.shapes[name];
            $fa309bb54d70b13f$var$RemoveItem(this.geom, shape);
        }
        return this;
    }
}
Object.assign($fa309bb54d70b13f$var$BaseShapes.prototype, (0, $7b8165543a7d61f3$export$2e2bcd8739ae039));
var $fa309bb54d70b13f$export$2e2bcd8739ae039 = $fa309bb54d70b13f$var$BaseShapes;


var $37e42f4969aba3e0$export$2e2bcd8739ae039 = {
    setBoxFillStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.boxFillColor !== color || this.boxFillAlpha !== alpha;
        this.boxFillColor = color;
        this.boxFillAlpha = alpha;
        return this;
    },
    setUncheckedBoxFillStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.uncheckedBoxFillColor !== color || this.uncheckedBoxFillAlpha !== alpha;
        this.uncheckedBoxFillColor = color;
        this.uncheckedBoxFillAlpha = alpha;
        return this;
    },
    setBoxStrokeStyle (lineWidth, color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.boxLineWidth !== lineWidth || this.boxStrokeColor !== color || this.boxStrokeAlpha !== alpha;
        this.boxLineWidth = lineWidth;
        this.boxStrokeColor = color;
        this.boxStrokeAlpha = alpha;
        return this;
    },
    setUncheckedBoxStrokeStyle (lineWidth, color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.uncheckedBoxLineWidth !== lineWidth || this.uncheckedBoxStrokeColor !== color || this.uncheckedBoxStrokeAlpha !== alpha;
        this.uncheckedBoxLineWidth = lineWidth;
        this.uncheckedBoxStrokeColor = color;
        this.uncheckedBoxStrokeAlpha = alpha;
        return this;
    },
    setCheckerStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.checkerColor !== color || this.checkAlpha !== alpha;
        this.checkerColor = color;
        this.checkAlpha = alpha;
        return this;
    },
    setBoxShape (isCircleShape) {
        if (isCircleShape === undefined) isCircleShape = false;
        if (this.isCircleShape === isCircleShape) return this;
        this.isCircleShape = isCircleShape;
        this.isSizeChanged = true;
        this.dirty = true;
        return this;
    }
};


var $14d40989dbeb9db8$export$2e2bcd8739ae039 = {
    setBoxSize (size) {
        this.dirty = this.dirty || this.boxSize !== size;
        this.boxSize = size;
        return this;
    },
    setCheckerSize (size) {
        this.dirty = this.dirty || this.checkerSize !== size;
        this.checkerSize = size;
        return this;
    }
};


var $5e7bfbdd04336dd2$var$FillStyle = function(color, alpha) {
    if (color == null) this.isFilled = false;
    else {
        if (alpha === undefined) alpha = 1;
        this.isFilled = true;
        this.fillColor = color;
        this.fillAlpha = alpha;
    }
    return this;
};
var $5e7bfbdd04336dd2$var$LineStyle = function(lineWidth, color, alpha) {
    if (lineWidth == null || color == null) this.isStroked = false;
    else {
        if (alpha === undefined) alpha = 1;
        this.isStroked = true;
        this.lineWidth = lineWidth;
        this.strokeColor = color;
        this.strokeAlpha = alpha;
    }
    return this;
};
var $5e7bfbdd04336dd2$export$2e2bcd8739ae039 = {
    fillStyle: $5e7bfbdd04336dd2$var$FillStyle,
    lineStyle: $5e7bfbdd04336dd2$var$LineStyle
};



class $e827ac8fdad78770$var$BaseGeom {
    constructor(){
        this.name = undefined;
        this.dirty = true;
        this.data = undefined;
        this.isFilled = false;
        this.fillColor = undefined;
        this.fillAlpha = 1;
        this.isStroked = false;
        this.lineWidth = 1;
        this.strokeColor = undefined;
        this.strokeAlpha = 1;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    reset() {
        this.fillStyle().lineStyle();
        return this;
    }
    webglRender(pipeline, calcMatrix, alpha, dx, dy) {}
    canvasRender(ctx, dx, dy) {}
    updateData() {
        this.dirty = false;
    }
}
Object.assign($e827ac8fdad78770$var$BaseGeom.prototype, (0, $5e7bfbdd04336dd2$export$2e2bcd8739ae039), (0, $90fdebfc958065d1$export$2e2bcd8739ae039));
var $e827ac8fdad78770$export$2e2bcd8739ae039 = $e827ac8fdad78770$var$BaseGeom;






const $4fe36ba947ccd74d$var$Earcut = Phaser.Geom.Polygon.Earcut;
class $4fe36ba947ccd74d$var$PathBase extends (0, $e827ac8fdad78770$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.pathData = [];
        this.pathIndexes = [];
        this.closePath = false;
    }
    updateData() {
        this.pathIndexes = $4fe36ba947ccd74d$var$Earcut(this.pathData);
        super.updateData();
        return this;
    }
    webglRender(pipeline, calcMatrix, alpha, dx, dy) {
        if (this.isFilled) (0, $a0d79412d6a22091$export$2e2bcd8739ae039)(pipeline, calcMatrix, this, alpha, dx, dy);
        if (this.isStroked) (0, $5c58a174c1ab3565$export$2e2bcd8739ae039)(pipeline, this, alpha, dx, dy);
    }
    canvasRender(ctx, dx, dy) {
        var path = this.pathData;
        var pathLength = path.length - 1;
        var px1 = path[0] - dx;
        var py1 = path[1] - dy;
        ctx.beginPath();
        ctx.moveTo(px1, py1);
        if (!this.closePath) pathLength -= 2;
        for(var i = 2; i < pathLength; i += 2){
            var px2 = path[i] - dx;
            var py2 = path[i + 1] - dy;
            ctx.lineTo(px2, py2);
        }
        if (this.closePath) ctx.closePath();
        if (this.isFilled) {
            (0, $2669e1c300ac8e45$export$2e2bcd8739ae039)(ctx, this);
            ctx.fill();
        }
        if (this.isStroked) {
            (0, $dafcb0d30a33b02c$export$2e2bcd8739ae039)(ctx, this);
            ctx.stroke();
        }
    }
}
var $4fe36ba947ccd74d$export$2e2bcd8739ae039 = $4fe36ba947ccd74d$var$PathBase;





const $dc5d4817ddd3622b$var$DegToRad = Phaser.Math.DegToRad;
class $dc5d4817ddd3622b$var$Arc extends (0, $4fe36ba947ccd74d$export$2e2bcd8739ae039) {
    constructor(x, y, radiusX, radiusY, startAngle, endAngle, anticlockwise, pie){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (radiusX === undefined) radiusX = 0;
        if (radiusY === undefined) radiusY = 0;
        if (startAngle === undefined) startAngle = 0;
        if (endAngle === undefined) endAngle = 360;
        if (anticlockwise === undefined) anticlockwise = false;
        if (pie === undefined) pie = false;
        super();
        this.setCenterPosition(x, y);
        this.setRadius(radiusX, radiusY);
        this.setAngle(startAngle, endAngle, anticlockwise);
        this.setPie(pie);
        this.setIterations(32);
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this.dirty = this.dirty || this._x !== value;
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this.dirty = this.dirty || this._y !== value;
        this._y = value;
    }
    setCenterPosition(x, y) {
        if (y === undefined) y = x;
        this.x = x;
        this.y = y;
        return this;
    }
    get radiusX() {
        return this._radiusX;
    }
    set radiusX(value) {
        this.dirty = this.dirty || this._radiusX !== value;
        this._radiusX = value;
    }
    get radiusY() {
        return this._radiusY;
    }
    set radiusY(value) {
        this.dirty = this.dirty || this._radiusY !== value;
        this._radiusY = value;
    }
    setRadius(radiusX, radiusY) {
        if (radiusY === undefined) radiusY = radiusX;
        this.radiusX = radiusX;
        this.radiusY = radiusY;
        return this;
    }
    get startAngle() {
        return this._startAngle;
    }
    set startAngle(value) {
        this.dirty = this.dirty || this._startAngle !== value;
        this._startAngle = value;
    }
    get endAngle() {
        return this._endAngle;
    }
    set endAngle(value) {
        this.dirty = this.dirty || this._endAngle !== value;
        this._endAngle = value;
    }
    get anticlockwise() {
        return this._anticlockwise;
    }
    set anticlockwise(value) {
        this.dirty = this.dirty || this._anticlockwise !== value;
        this._anticlockwise = value;
    }
    setAngle(startAngle, endAngle, anticlockwise) {
        // startAngle, endAngle in degrees
        if (anticlockwise === undefined) anticlockwise = false;
        this.startAngle = startAngle;
        this.endAngle = endAngle;
        this.anticlockwise = anticlockwise;
        return this;
    }
    get pie() {
        return this._pie;
    }
    set pie(value) {
        this.dirty = this.dirty || this._pie !== value;
        this._pie = value;
    }
    setPie(pie) {
        if (pie === undefined) pie = true;
        this.pie = pie;
        return this;
    }
    get iterations() {
        return this._iterations;
    }
    set iterations(value) {
        this.dirty = this.dirty || this._iterations !== value;
        this._iterations = value;
    }
    setIterations(iterations) {
        this.iterations = iterations;
        return this;
    }
    updateData() {
        this.pathData.length = 0;
        if (this.pie) this.pathData.push(this.x, this.y);
        (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(this.x, this.y, this.radiusX, this.radiusY, this.startAngle, this.endAngle, this.anticlockwise, this.iterations, this.pathData);
        if (this.pie) this.pathData.push(this.x, this.y);
        this.pathData.push(this.pathData[0], this.pathData[1]);
        super.updateData();
        return this;
    }
    canvasRender(ctx, dx, dy) {
        ctx.beginPath();
        var x = this.x - dx, y = this.y - dy, startAngle = $dc5d4817ddd3622b$var$DegToRad(this.startAngle), endAngle = $dc5d4817ddd3622b$var$DegToRad(this.endAngle);
        if (this.pie) {
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(startAngle) * this.radiusX, y + Math.sin(startAngle) * this.radiusY);
        }
        ctx.ellipse(x, y, this.radiusX, this.radiusY, 0, startAngle, endAngle, this.anticlockwise);
        if (this.pie) ctx.lineTo(x, y);
        if (this.isFilled) {
            (0, $2669e1c300ac8e45$export$2e2bcd8739ae039)(ctx, this);
            ctx.fill();
        }
        if (this.isStroked) {
            (0, $dafcb0d30a33b02c$export$2e2bcd8739ae039)(ctx, this);
            ctx.stroke();
        }
    }
}
var $dc5d4817ddd3622b$export$2e2bcd8739ae039 = $dc5d4817ddd3622b$var$Arc;



class $59dabc3f63aed362$var$Circle extends (0, $dc5d4817ddd3622b$export$2e2bcd8739ae039) {
    constructor(x, y, radius){
        super(x, y, radius, radius, 0, 360);
    }
}
var $59dabc3f63aed362$export$2e2bcd8739ae039 = $59dabc3f63aed362$var$Circle;



class $f596752abc0a1658$var$Curve extends (0, $4fe36ba947ccd74d$export$2e2bcd8739ae039) {
    constructor(curve){
        super();
        this.setCurve(curve);
        this.setIterations(32);
    }
    get curve() {
        return this._curve;
    }
    set curve(value) {
        this.dirty = this.dirty || this._curve !== value;
        this._curve = value;
    }
    setCurve(curve) {
        this.curve = curve;
        return this;
    }
    get iterations() {
        return this._iterations;
    }
    set iterations(value) {
        this.dirty = this.dirty || this._iterations !== value;
        this._iterations = value;
    }
    setIterations(iterations) {
        this.iterations = iterations;
        return this;
    }
    updateData() {
        this.pathData.length = 0;
        var points = this.curve.getPoints(this.iterations);
        for(var i = 0, cnt = points.length; i < cnt; i++)this.pathData.push(points[i].x, points[i].y);
        this.pathData.push(points[0].x, points[0].y);
        super.updateData();
        return this;
    }
}
var $f596752abc0a1658$export$2e2bcd8739ae039 = $f596752abc0a1658$var$Curve;



class $f42682a29e99067e$var$Ellipse extends (0, $dc5d4817ddd3622b$export$2e2bcd8739ae039) {
    constructor(x, y, radiusX, radiusY){
        super(x, y, radiusX, radiusY, 0, 360);
    }
}
var $f42682a29e99067e$export$2e2bcd8739ae039 = $f42682a29e99067e$var$Ellipse;



class $4f910d95da79b3d8$var$Line extends (0, $4fe36ba947ccd74d$export$2e2bcd8739ae039) {
    constructor(x0, y0, x1, y1){
        if (x0 === undefined) x0 = 0;
        if (y0 === undefined) y0 = 0;
        if (x1 === undefined) x1 = 0;
        if (y1 === undefined) y1 = 0;
        super();
        this.setP0(x0, y0);
        this.setP1(x1, y1);
    }
    get x0() {
        return this._x0;
    }
    set x0(value) {
        this.dirty = this.dirty || this._x0 !== value;
        this._x0 = value;
    }
    get y0() {
        return this._y0;
    }
    set y0(value) {
        this.dirty = this.dirty || this._y0 !== value;
        this._y0 = value;
    }
    setP0(x, y) {
        this.x0 = x;
        this.y0 = y;
        return this;
    }
    get x1() {
        return this._x1;
    }
    set x1(value) {
        this.dirty = this.dirty || this._x1 !== value;
        this._x1 = value;
    }
    get y1() {
        return this._y1;
    }
    set y1(value) {
        this.dirty = this.dirty || this._y1 !== value;
        this._y1 = value;
    }
    setP1(x, y) {
        this.x1 = x;
        this.y1 = y;
        return this;
    }
    updateData() {
        this.pathData.length = 0;
        this.pathData.push(this.x0, this.y0);
        this.pathData.push(this.x1, this.y1);
        this.pathData.push(this.x0, this.y0);
        super.updateData();
        return this;
    }
}
var $4f910d95da79b3d8$export$2e2bcd8739ae039 = $4f910d95da79b3d8$var$Line;



var $9d2bf922ebab018f$var$StartAt = function(x, y, pathData) {
    pathData.length = 0;
    if (x != null) pathData.push(x, y);
    return pathData;
};
var $9d2bf922ebab018f$export$2e2bcd8739ae039 = $9d2bf922ebab018f$var$StartAt;




//import QuadraticBezierInterpolation from '../../utils/math/interpolation/QuadraticBezierInterpolation.js';
const $30e01aee2d942449$var$QuadraticBezierInterpolation = Phaser.Math.Interpolation.QuadraticBezier;
var $30e01aee2d942449$var$QuadraticBezierTo = function(cx, cy, x, y, iterations, pathData) {
    var pathDataCnt = pathData.length;
    var p0x = pathData[pathDataCnt - 2];
    var p0y = pathData[pathDataCnt - 1];
    for(var i = 1, last = iterations - 1; i <= last; i++){
        var t = i / last;
        pathData.push($30e01aee2d942449$var$QuadraticBezierInterpolation(t, p0x, cx, x), $30e01aee2d942449$var$QuadraticBezierInterpolation(t, p0y, cy, y));
    }
    return pathData;
};
var $30e01aee2d942449$export$2e2bcd8739ae039 = $30e01aee2d942449$var$QuadraticBezierTo;


// import CubicBezierInterpolation from '../../utils/math/interpolation/CubicBezierInterpolation.js';
const $9c9eda03ef736091$var$CubicBezierInterpolation = Phaser.Math.Interpolation.CubicBezier;
var $9c9eda03ef736091$var$CubicBezierCurveTo = function(cx0, cy0, cx1, cy1, x, y, iterations, pathData) {
    var pathDataCnt = pathData.length;
    var p0x = pathData[pathDataCnt - 2];
    var p0y = pathData[pathDataCnt - 1];
    for(var i = 1, last = iterations - 1; i <= last; i++){
        var t = i / last;
        pathData.push($9c9eda03ef736091$var$CubicBezierInterpolation(t, p0x, cx0, cx1, x), $9c9eda03ef736091$var$CubicBezierInterpolation(t, p0y, cy0, cy1, y));
    }
    return pathData;
};
var $9c9eda03ef736091$export$2e2bcd8739ae039 = $9c9eda03ef736091$var$CubicBezierCurveTo;


var $fba9202cb84f95fe$var$DuplicateLast = function(pathData) {
    var len = pathData.length;
    if (len < 2) return pathData;
    var lastX = pathData[len - 2];
    var lastY = pathData[len - 1];
    pathData.push(lastX);
    pathData.push(lastY);
    return pathData;
};
var $fba9202cb84f95fe$export$2e2bcd8739ae039 = $fba9202cb84f95fe$var$DuplicateLast;


var $567511a54097a3bc$export$2e2bcd8739ae039 = {
    clear () {
        this.start();
        return this;
    },
    start () {
        this.startAt();
        return this;
    },
    startAt (x, y) {
        this.restorePathData();
        this.accumulationLengths = undefined;
        (0, $9d2bf922ebab018f$export$2e2bcd8739ae039)(x, y, this.pathData);
        this.firstPointX = x;
        this.firstPointY = y;
        this.lastPointX = x;
        this.lastPointY = y;
        return this;
    },
    lineTo (x, y, relative) {
        if (relative === undefined) relative = false;
        if (relative) {
            x += this.lastPointX;
            y += this.lastPointY;
        }
        (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(x, y, this.pathData);
        this.lastPointX = x;
        this.lastPointY = y;
        return this;
    },
    verticalLineTo (x, relative) {
        this.lineTo(x, this.lastPointY, relative);
        return this;
    },
    horizontalLineTo (y, relative) {
        this.lineTo(this.lastPointX, y, relative);
        return this;
    },
    ellipticalArc (centerX, centerY, radiusX, radiusY, startAngle, endAngle, anticlockwise) {
        if (anticlockwise === undefined) anticlockwise = false;
        (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radiusX, radiusY, startAngle, endAngle, anticlockwise, this.iterations, this.pathData);
        this.lastPointX = this.pathData[this.pathData.length - 2];
        this.lastPointY = this.pathData[this.pathData.length - 1];
        return this;
    },
    arc (centerX, centerY, radius, startAngle, endAngle, anticlockwise) {
        this.ellipticalArc(centerX, centerY, radius, radius, startAngle, endAngle, anticlockwise);
        return this;
    },
    quadraticBezierTo (cx, cy, x, y) {
        (0, $30e01aee2d942449$export$2e2bcd8739ae039)(cx, cy, x, y, this.iterations, this.pathData);
        this.lastPointX = x;
        this.lastPointY = y;
        this.lastCX = cx;
        this.lastCY = cy;
        return this;
    },
    smoothQuadraticBezierTo (x, y) {
        var cx = this.lastPointX * 2 - this.lastCX;
        var cy = this.lastPointY * 2 - this.lastCY;
        this.quadraticBezierTo(cx, cy, x, y);
        return this;
    },
    cubicBezierCurveTo (cx0, cy0, cx1, cy1, x, y) {
        (0, $9c9eda03ef736091$export$2e2bcd8739ae039)(cx0, cy0, cx1, cy1, x, y, this.iterations, this.pathData);
        this.lastPointX = x;
        this.lastPointY = y;
        this.lastCX = cx1;
        this.lastCY = cy1;
        return this;
    },
    smoothCubicBezierCurveTo (cx1, cy1, x, y) {
        var cx0 = this.lastPointX * 2 - this.lastCX;
        var cy0 = this.lastPointY * 2 - this.lastCY;
        this.cubicBezierCurveTo(cx0, cy0, cx1, cy1, x, y);
        return this;
    },
    close () {
        this.closePath = true;
        return this;
    },
    end () {
        (0, $fba9202cb84f95fe$export$2e2bcd8739ae039)(this.pathData);
        return this;
    }
};


//import PointRotateAround from '../../utils/math/RotateAround.js';
const $cdbc8baf322c3267$var$PointRotateAround = Phaser.Math.RotateAround;
var $cdbc8baf322c3267$var$RotateAround = function(centerX, centerY, angle, pathData) {
    var point = {
        x: 0,
        y: 0
    };
    for(var i = 0, cnt = pathData.length - 1; i < cnt; i += 2){
        point.x = pathData[i];
        point.y = pathData[i + 1];
        $cdbc8baf322c3267$var$PointRotateAround(point, centerX, centerY, angle);
        pathData[i] = point.x;
        pathData[i + 1] = point.y;
    }
    return pathData;
};
var $cdbc8baf322c3267$export$2e2bcd8739ae039 = $cdbc8baf322c3267$var$RotateAround;


var $37ac3db09933a8d1$var$Scale = function(centerX, centerY, scaleX, scaleY, pathData) {
    for(var i = 0, cnt = pathData.length - 1; i < cnt; i += 2){
        var x = pathData[i] - centerX;
        var y = pathData[i + 1] - centerY;
        x *= scaleX;
        y *= scaleY;
        pathData[i] = x + centerX;
        pathData[i + 1] = y + centerY;
    }
    return pathData;
};
var $37ac3db09933a8d1$export$2e2bcd8739ae039 = $37ac3db09933a8d1$var$Scale;


var $9267a414a7812d76$var$Offset = function(x, y, pathData) {
    for(var i = 0, cnt = pathData.length - 1; i < cnt; i += 2){
        pathData[i] += x;
        pathData[i + 1] += y;
    }
    return pathData;
};
var $9267a414a7812d76$export$2e2bcd8739ae039 = $9267a414a7812d76$var$Offset;


const $eb344122415c5f4b$var$DegToRad = Phaser.Math.DegToRad;
const $eb344122415c5f4b$var$PointRotateAround = Phaser.Math.RotateAround;
var $eb344122415c5f4b$export$2e2bcd8739ae039 = {
    rotateAround (centerX, centerY, angle) {
        if (this.pathData.length === 0) return this;
        angle = $eb344122415c5f4b$var$DegToRad(angle);
        (0, $cdbc8baf322c3267$export$2e2bcd8739ae039)(centerX, centerY, angle, this.pathData);
        var pathDataCnt1 = this.pathData.length;
        this.lastPointX = this.pathData[pathDataCnt1 - 2];
        this.lastPointY = this.pathData[pathDataCnt1 - 1];
        if (this.lastCX !== undefined) {
            var point = {
                x: this.lastCX,
                y: this.lastCY
            };
            $eb344122415c5f4b$var$PointRotateAround(point, centerX, centerY, angle);
            this.lastCX = point.x;
            this.lastCY = point.y;
        }
        return this;
    },
    scale (centerX, centerY, scaleX, scaleY) {
        if (this.pathData.length === 0) return this;
        (0, $37ac3db09933a8d1$export$2e2bcd8739ae039)(centerX, centerY, scaleX, scaleY, this.pathData);
        this.lastPointX = this.pathData[pathDataCnt - 2];
        this.lastPointY = this.pathData[pathDataCnt - 1];
        if (this.lastCX !== undefined) {
            var x = this.lastCX - centerX;
            var y = this.lastCY - centerY;
            x *= scaleX;
            y *= scaleY;
            this.lastCX = x + centerX;
            this.lastCY = y + centerY;
        }
        return this;
    },
    offset (x, y) {
        (0, $9267a414a7812d76$export$2e2bcd8739ae039)(x, y, this.pathData);
        return this;
    }
};


var $265c374eaa549425$var$Copy = function(dest, src, startIdx, endIdx) {
    if (startIdx === undefined) startIdx = 0;
    if (endIdx === undefined) endIdx = src.length;
    dest.length = endIdx - startIdx;
    for(var i = 0, len = dest.length; i < len; i++)dest[i] = src[i + startIdx];
    return dest;
};
var $265c374eaa549425$export$2e2bcd8739ae039 = $265c374eaa549425$var$Copy;


var $05383b3a7a2ff08f$export$2e2bcd8739ae039 = {
    savePathData () {
        if (this.pathDataSaved) return this;
        this.pathDataSave = [
            ...this.pathData
        ];
        this.pathData.length = 0;
        this.pathDataSaved = true;
        return this;
    },
    restorePathData () {
        if (!this.pathDataSaved) return this;
        (0, $265c374eaa549425$export$2e2bcd8739ae039)(this.pathData, this.pathDataSave);
        this.pathDataSave = undefined;
        this.pathDataSaved = false;
        return this;
    }
};



const $ee03ddc3b73574ce$var$DistanceBetween = Phaser.Math.Distance.Between;
const $ee03ddc3b73574ce$var$Wrap = Phaser.Math.Wrap;
const $ee03ddc3b73574ce$var$Linear = Phaser.Math.Linear;
var $ee03ddc3b73574ce$var$AppendFromPathSegment = function(srcPathData, accumulationLengths, startT, endT, destPathData) {
    if (endT === undefined) {
        endT = startT;
        startT = 0;
    }
    startT = $ee03ddc3b73574ce$var$WrapT(startT);
    endT = $ee03ddc3b73574ce$var$WrapT(endT);
    if (startT === endT) return;
    var totalPathLength = accumulationLengths[accumulationLengths.length - 1];
    var startL = totalPathLength * startT;
    var endL = totalPathLength * endT;
    if (startT < endT) $ee03ddc3b73574ce$var$AddPathSegment(srcPathData, accumulationLengths, startL, endL, destPathData);
    else {
        $ee03ddc3b73574ce$var$AddPathSegment(srcPathData, accumulationLengths, startL, totalPathLength, destPathData);
        $ee03ddc3b73574ce$var$AddPathSegment(srcPathData, accumulationLengths, 0, endL, destPathData);
    }
    (0, $fba9202cb84f95fe$export$2e2bcd8739ae039)(destPathData);
};
var $ee03ddc3b73574ce$var$AddPathSegment = function(srcPathData, accumulationLengths, startL, endL, destPathData) {
    var skipState = startL > 0;
    for(var i = 0, cnt = accumulationLengths.length; i < cnt; i++){
        var pIdx = i * 2;
        var d = accumulationLengths[i];
        if (skipState) {
            if (d < startL) continue;
            else if (d == startL) skipState = false;
            else {
                var deltaD = d - accumulationLengths[i - 1];
                var t = 1 - (d - startL) / deltaD;
                destPathData.push($ee03ddc3b73574ce$var$GetInterpolation(srcPathData, pIdx - 2, pIdx, t));
                destPathData.push($ee03ddc3b73574ce$var$GetInterpolation(srcPathData, pIdx - 1, pIdx + 1, t));
                skipState = false;
            }
        }
        if (d <= endL) {
            destPathData.push(srcPathData[pIdx]);
            destPathData.push(srcPathData[pIdx + 1]);
            if (d === endL) break;
        } else {
            var deltaD = d - accumulationLengths[i - 1];
            var t = 1 - (d - endL) / deltaD;
            destPathData.push($ee03ddc3b73574ce$var$GetInterpolation(srcPathData, pIdx - 2, pIdx, t));
            destPathData.push($ee03ddc3b73574ce$var$GetInterpolation(srcPathData, pIdx - 1, pIdx + 1, t));
            break;
        }
    }
};
var $ee03ddc3b73574ce$var$GetInterpolation = function(pathData, i0, i1, t) {
    var p0 = pathData[i0], p1 = pathData[i1];
    return $ee03ddc3b73574ce$var$Linear(p0, p1, t);
};
var $ee03ddc3b73574ce$var$WrapT = function(t) {
    if (t === 0) return 0;
    else if (t % 1 === 0) return 1;
    return $ee03ddc3b73574ce$var$Wrap(t, 0, 1);
};
var $ee03ddc3b73574ce$export$2e2bcd8739ae039 = {
    updateAccumulationLengths () {
        if (this.accumulationLengths == null) this.accumulationLengths = [];
        else if (this.accumulationLengths.length === this.pathData.length / 2) return this;
        var accumulationLengths = this.accumulationLengths;
        var pathData = this.pathData;
        var prevX, prevY, x, y;
        var d, accumulationLength = 0;
        for(var i = 0, cnt = pathData.length; i < cnt; i += 2){
            x = pathData[i];
            y = pathData[i + 1];
            d = prevX === undefined ? 0 : $ee03ddc3b73574ce$var$DistanceBetween(prevX, prevY, x, y);
            accumulationLength += d;
            accumulationLengths.push(accumulationLength);
            prevX = x;
            prevY = y;
        }
        this.totalPathLength = accumulationLength;
        return this;
    },
    setDisplayPathSegment (startT, endT) {
        if (!this.pathDataSaved) {
            this.updateAccumulationLengths();
            this.savePathData();
        }
        this.pathData.length = 0;
        $ee03ddc3b73574ce$var$AppendFromPathSegment(this.pathDataSave, this.accumulationLengths, startT, endT, this.pathData);
        return this;
    },
    appendFromPathSegment (src, startT, endT) {
        if (startT === undefined) this.pathData.push(...src.pathData);
        else {
            src.updateAccumulationLengths();
            $ee03ddc3b73574ce$var$AppendFromPathSegment(src.pathData, src.accumulationLengths, startT, endT, this.pathData);
        }
        this.firstPointX = this.pathData[0];
        this.firstPointY = this.pathData[1];
        this.lastPointX = this.pathData[this.pathData.length - 2];
        this.lastPointY = this.pathData[this.pathData.length - 1];
        return this;
    }
};


var $f3d6cf5070b5d337$export$2e2bcd8739ae039 = {
    draw (graphics, isFill, isStroke) {
        var points = this.toPoints();
        if (isFill) graphics.fillPoints(points, this.closePath, this.closePath);
        if (isStroke) graphics.strokePoints(points, this.closePath, this.closePath);
        return this;
    }
};


var $8c9196d835357f09$var$ToPoints = function(pathData, points) {
    if (points === undefined) points = [];
    for(var i = 0, cnt = pathData.length - 1; i < cnt; i += 2)points.push({
        x: pathData[i],
        y: pathData[i + 1]
    });
    return points;
};
var $8c9196d835357f09$export$2e2bcd8739ae039 = $8c9196d835357f09$var$ToPoints;


//import Polygon from '../../utils/geom/polygon/Polygon.js';
const $7a3de4ad63967e8d$var$Polygon = Phaser.Geom.Polygon;
var $7a3de4ad63967e8d$var$ToPolygon = function(pathData, polygon) {
    if (polygon === undefined) polygon = new $7a3de4ad63967e8d$var$Polygon();
    polygon.setTo(pathData);
    return polygon;
};
var $7a3de4ad63967e8d$export$2e2bcd8739ae039 = $7a3de4ad63967e8d$var$ToPolygon;


class $fc357603ee829742$var$PathDataBuilder {
    constructor(pathData){
        if (pathData === undefined) pathData = [];
        this.pathData = pathData;
        this.closePath = false;
        this.setIterations(32);
        this.firstPointX = undefined;
        this.firstPointY = undefined;
        this.lastPointX = undefined;
        this.lastPointY = undefined;
        this.accumulationLengths = undefined;
    }
    setIterations(iterations) {
        this.iterations = iterations;
        return this;
    }
    toPoints() {
        return (0, $8c9196d835357f09$export$2e2bcd8739ae039)(this.pathData);
    }
    toPolygon(polygon) {
        return (0, $7a3de4ad63967e8d$export$2e2bcd8739ae039)(this.pathData, polygon);
    }
}
Object.assign($fc357603ee829742$var$PathDataBuilder.prototype, (0, $567511a54097a3bc$export$2e2bcd8739ae039), (0, $eb344122415c5f4b$export$2e2bcd8739ae039), (0, $05383b3a7a2ff08f$export$2e2bcd8739ae039), (0, $ee03ddc3b73574ce$export$2e2bcd8739ae039), (0, $f3d6cf5070b5d337$export$2e2bcd8739ae039));
var $fc357603ee829742$export$2e2bcd8739ae039 = $fc357603ee829742$var$PathDataBuilder;


class $1e62846ec481ae38$var$Lines extends (0, $4fe36ba947ccd74d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.builder = new (0, $fc357603ee829742$export$2e2bcd8739ae039)(this.pathData);
    }
    get iterations() {
        return this.builder.iterations;
    }
    set iterations(value) {
        this.dirty = this.dirty || this.builder.iterations !== value;
        this.builder.setIterations(value);
    }
    setIterations(iterations) {
        this.iterations = iterations;
        return this;
    }
    get lastPointX() {
        return this.builder.lastPointX;
    }
    get lastPointY() {
        return this.builder.lastPointY;
    }
    start() {
        this.builder.start();
        this.dirty = true;
        return this;
    }
    startAt(x, y) {
        this.builder.startAt(x, y);
        this.dirty = true;
        return this;
    }
    lineTo(x, y, relative) {
        this.builder.lineTo(x, y, relative);
        this.dirty = true;
        return this;
    }
    verticalLineTo(x, relative) {
        this.builder.verticalLineTo(x, relative);
        this.dirty = true;
        return this;
    }
    horizontalLineTo(y, relative) {
        this.builder.horizontalLineTo(y, relative);
        this.dirty = true;
        return this;
    }
    ellipticalArc(centerX, centerY, radiusX, radiusY, startAngle, endAngle, anticlockwise) {
        this.builder.ellipticalArc(centerX, centerY, radiusX, radiusY, startAngle, endAngle, anticlockwise);
        this.dirty = true;
        return this;
    }
    arc(centerX, centerY, radius, startAngle, endAngle, anticlockwise) {
        this.builder.arc(centerX, centerY, radius, startAngle, endAngle, anticlockwise);
        this.dirty = true;
        return this;
    }
    quadraticBezierTo(cx, cy, x, y) {
        this.builder.quadraticBezierTo(cx, cy, x, y);
        this.dirty = true;
        return this;
    }
    smoothQuadraticBezierTo(x, y) {
        this.builder.smoothQuadraticBezierTo(x, y);
        this.dirty = true;
        return this;
    }
    cubicBezierCurveTo(cx0, cy0, cx1, cy1, x, y) {
        this.builder.cubicBezierCurveTo(cx0, cy0, cx1, cy1, x, y);
        this.dirty = true;
        return this;
    }
    smoothCubicBezierCurveTo(cx1, cy1, x, y) {
        this.builder.smoothCubicBezierCurveTo(cx1, cy1, x, y);
        this.dirty = true;
        return this;
    }
    close() {
        this.builder.close();
        this.closePath = this.builder.closePath;
        this.dirty = true;
        return this;
    }
    end() {
        this.builder.end();
        this.dirty = true;
        return this;
    }
    rotateAround(centerX, centerY, angle) {
        this.builder.rotateAround(centerX, centerY, angle);
        this.dirty = true;
        return this;
    }
    scale(centerX, centerY, scaleX, scaleY) {
        this.builder.scale(centerX, centerY, scaleX, scaleY);
        this.dirty = true;
        return this;
    }
    offset(x, y) {
        this.builder.offset(x, y);
        this.dirty = true;
        return this;
    }
    toPolygon(polygon) {
        return this.builder.toPolygon(polygon);
    }
    appendPathFrom(src, startT, endT) {
        this.builder.appendFromPathSegment(src.builder, startT, endT);
        return this;
    }
    copyPathFrom(src, startT, endT) {
        this.builder.clear().appendFromPathSegment(src.builder, startT, endT);
        return this;
    }
    setDisplayPathSegment(startT, endT) {
        this.builder.setDisplayPathSegment(startT, endT);
        return this;
    }
}
var $1e62846ec481ae38$export$2e2bcd8739ae039 = $1e62846ec481ae38$var$Lines;






const $6a12d6eebe280651$var$GetTint = Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha;
class $6a12d6eebe280651$var$Rectangle extends (0, $e827ac8fdad78770$export$2e2bcd8739ae039) {
    constructor(x, y, width, height){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 0;
        if (height === undefined) height = width;
        super();
        this.pathData = [];
        this.closePath = true;
        this.setTopLeftPosition(x, y);
        this.setSize(width, height);
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this.dirty = this.dirty || this._x !== value;
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this.dirty = this.dirty || this._y !== value;
        this._y = value;
    }
    setTopLeftPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this.dirty = this.dirty || this._width !== value;
        this._width = value;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this.dirty = this.dirty || this._height !== value;
        this._height = value;
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        return this;
    }
    get centerX() {
        return this.x + this.width / 2;
    }
    set centerX(value) {
        this.x = value - this.width / 2;
    }
    get centerY() {
        return this.y + this.height / 2;
    }
    set centerY(value) {
        this.y = value - this.height / 2;
    }
    setCenterPosition(x, y) {
        this.centerX = x;
        this.centerY = y;
        return this;
    }
    updateData() {
        this.pathData.length = 0;
        var x0 = this.x, x1 = x0 + this.width, y0 = this.y, y1 = y0 + this.height;
        this.pathData.push(x0, y0);
        this.pathData.push(x1, y0);
        this.pathData.push(x1, y1);
        this.pathData.push(x0, y1);
        this.pathData.push(x0, y0);
        super.updateData();
        return this;
    }
    webglRender(pipeline, calcMatrix, alpha, dx, dy) {
        if (this.isFilled) {
            var fillTint = pipeline.fillTint;
            var fillTintColor = $6a12d6eebe280651$var$GetTint(this.fillColor, this.fillAlpha * alpha);
            fillTint.TL = fillTintColor;
            fillTint.TR = fillTintColor;
            fillTint.BL = fillTintColor;
            fillTint.BR = fillTintColor;
            pipeline.batchFillRect(-dx + this.x, -dy + this.y, this.width, this.height);
        }
        if (this.isStroked) (0, $5c58a174c1ab3565$export$2e2bcd8739ae039)(pipeline, this, alpha, dx, dy);
    }
    canvasRender(ctx, dx, dy) {
        if (this.isFilled) {
            (0, $2669e1c300ac8e45$export$2e2bcd8739ae039)(ctx, this);
            ctx.fillRect(-dx, -dy, this.width, this.height);
        }
        if (this.isStroked) {
            (0, $dafcb0d30a33b02c$export$2e2bcd8739ae039)(ctx, this);
            ctx.beginPath();
            ctx.rect(-dx, -dy, this.width, this.height);
            ctx.stroke();
        }
    }
}
var $6a12d6eebe280651$export$2e2bcd8739ae039 = $6a12d6eebe280651$var$Rectangle;






const $0fa05e5e72af2e13$var$GetValue = Phaser.Utils.Objects.GetValue;
class $0fa05e5e72af2e13$var$RoundRectangle extends (0, $4fe36ba947ccd74d$export$2e2bcd8739ae039) {
    constructor(x, y, width, height, radius, iterations){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 0;
        if (height === undefined) height = width;
        if (radius === undefined) radius = 0;
        if (iterations === undefined) iterations = 6;
        super();
        this.setTopLeftPosition(x, y);
        this.setSize(width, height);
        this.setRadius(radius);
        this.setIterations(iterations);
        this.closePath = true;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this.dirty = this.dirty || this._x !== value;
        this._x = value;
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this.dirty = this.dirty || this._y !== value;
        this._y = value;
    }
    setTopLeftPosition(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    get width() {
        return this._width;
    }
    set width(value) {
        this.dirty = this.dirty || this._width !== value;
        this._width = value;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this.dirty = this.dirty || this._height !== value;
        this._height = value;
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        return this;
    }
    get centerX() {
        return this.x + this.width / 2;
    }
    set centerX(value) {
        this.x = value - this.width / 2;
    }
    get centerY() {
        return this.y + this.height / 2;
    }
    set centerY(value) {
        this.y = value - this.height / 2;
    }
    setCenterPosition(x, y) {
        this.centerX = x;
        this.centerY = y;
        return this;
    }
    get radiusTL() {
        return this._radiusTL;
    }
    set radiusTL(value) {
        var isConvex = value > 0;
        this.dirty = this.dirty || this._radiusTL !== value || this._convexTL !== isConvex;
        this._convexTL = isConvex;
        this._radiusTL = Math.abs(value);
    }
    get radiusTR() {
        return this._radiusTR;
    }
    set radiusTR(value) {
        var isConvex = value > 0;
        this.dirty = this.dirty || this._radiusTR !== value || this._convexTR !== isConvex;
        this._convexTR = isConvex;
        this._radiusTR = Math.abs(value);
    }
    get radiusBL() {
        return this._radiusBL;
    }
    set radiusBL(value) {
        var isConvex = value > 0;
        this.dirty = this.dirty || this._radiusBL !== value || this._convexBL !== isConvex;
        this._convexBL = isConvex;
        this._radiusBL = Math.abs(value);
    }
    get radiusBR() {
        return this._radiusBR;
    }
    set radiusBR(value) {
        var isConvex = value > 0;
        this.dirty = this.dirty || this._radiusBR !== value || this._convexBR !== isConvex;
        this._convexBR = isConvex;
        this._radiusBR = Math.abs(value);
    }
    get radius() {
        return Math.max(this.radiusTL, this.radiusTR, this.radiusBL, this.radiusBR);
    }
    set radius(value) {
        if (typeof value === "number") {
            this.radiusTL = value;
            this.radiusTR = value;
            this.radiusBL = value;
            this.radiusBR = value;
        } else {
            this.radiusTL = $0fa05e5e72af2e13$var$GetValue(value, "tl", 0);
            this.radiusTR = $0fa05e5e72af2e13$var$GetValue(value, "tr", 0);
            this.radiusBL = $0fa05e5e72af2e13$var$GetValue(value, "bl", 0);
            this.radiusBR = $0fa05e5e72af2e13$var$GetValue(value, "br", 0);
        }
    }
    setRadius(radius) {
        if (radius === undefined) radius = 0;
        this.radius = radius;
        return this;
    }
    get iterations() {
        return this._iterations;
    }
    set iterations(value) {
        this.dirty = this.dirty || this._iterations !== value;
        this._iterations = value;
    }
    setIterations(iterations) {
        this.iterations = iterations;
        return this;
    }
    updateData() {
        var pathData = this.pathData;
        pathData.length = 0;
        var width = this.width, height = this.height, radius, iterations = this.iterations + 1;
        // top-left
        radius = this.radiusTL;
        if (radius > 0) {
            if (this._convexTL) {
                var centerX = radius;
                var centerY = radius;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 180, 270, false, iterations, pathData);
            } else {
                var centerX = 0;
                var centerY = 0;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 90, 0, true, iterations, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(0, 0, pathData);
        // top-right
        radius = this.radiusTR;
        if (radius > 0) {
            if (this._convexTR) {
                var centerX = width - radius;
                var centerY = radius;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 270, 360, false, iterations, pathData);
            } else {
                var centerX = width;
                var centerY = 0;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 180, 90, true, iterations, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(width, 0, pathData);
        // bottom-right
        radius = this.radiusBR;
        if (radius > 0) {
            if (this._convexBR) {
                var centerX = width - radius;
                var centerY = height - radius;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 0, 90, false, iterations, pathData);
            } else {
                var centerX = width;
                var centerY = height;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 270, 180, true, iterations, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(width, height, pathData);
        // bottom-left
        radius = this.radiusBL;
        if (radius > 0) {
            if (this._convexBL) {
                var centerX = radius;
                var centerY = height - radius;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 90, 180, false, iterations, pathData);
            } else {
                var centerX = 0;
                var centerY = height;
                (0, $1c11e56450824a5f$export$2e2bcd8739ae039)(centerX, centerY, radius, radius, 360, 270, true, iterations, pathData);
            }
        } else (0, $1e7d39678bf81ea6$export$2e2bcd8739ae039)(0, height, pathData);
        pathData.push(pathData[0], pathData[1]); // Repeat first point to close curve
        (0, $9267a414a7812d76$export$2e2bcd8739ae039)(this.x, this.y, pathData);
        super.updateData();
        return this;
    }
}
var $0fa05e5e72af2e13$export$2e2bcd8739ae039 = $0fa05e5e72af2e13$var$RoundRectangle;






const $c2e68ce48d3429c6$var$GetTint = Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha;
class $c2e68ce48d3429c6$var$Triangle extends (0, $e827ac8fdad78770$export$2e2bcd8739ae039) {
    constructor(x0, y0, x1, y1, x2, y2){
        if (x0 === undefined) x0 = 0;
        if (y0 === undefined) y0 = 0;
        if (x1 === undefined) x1 = 0;
        if (y1 === undefined) y1 = 0;
        if (x2 === undefined) x2 = 0;
        if (y2 === undefined) y2 = 0;
        super();
        this.pathData = [];
        this.closePath = true;
        this.setP0(x0, y0);
        this.setP1(x1, y1);
        this.setP2(x2, y2);
    }
    get x0() {
        return this._x0;
    }
    set x0(value) {
        this.dirty = this.dirty || this._x0 !== value;
        this._x0 = value;
    }
    get y0() {
        return this._y0;
    }
    set y0(value) {
        this.dirty = this.dirty || this._y0 !== value;
        this._y0 = value;
    }
    setP0(x, y) {
        this.x0 = x;
        this.y0 = y;
        return this;
    }
    get x1() {
        return this._x1;
    }
    set x1(value) {
        this.dirty = this.dirty || this._x1 !== value;
        this._x1 = value;
    }
    get y1() {
        return this._y1;
    }
    set y1(value) {
        this.dirty = this.dirty || this._y1 !== value;
        this._y1 = value;
    }
    setP1(x, y) {
        this.x1 = x;
        this.y1 = y;
        return this;
    }
    get x2() {
        return this._x2;
    }
    set x2(value) {
        this.dirty = this.dirty || this._x2 !== value;
        this._x2 = value;
    }
    get y2() {
        return this._y2;
    }
    set y2(value) {
        this.dirty = this.dirty || this._y2 !== value;
        this._y2 = value;
    }
    setP2(x, y) {
        this.dirty = this.dirty || this.x2 !== x || this.y2 !== y;
        this.x2 = x;
        this.y2 = y;
        return this;
    }
    updateData() {
        this.pathData.length = 0;
        this.pathData.push(this.x0, this.y0);
        this.pathData.push(this.x1, this.y1);
        this.pathData.push(this.x2, this.y2);
        this.pathData.push(this.x0, this.y0);
        super.updateData();
        return this;
    }
    webglRender(pipeline, calcMatrix, alpha, dx, dy) {
        if (this.isFilled) {
            var fillTintColor = $c2e68ce48d3429c6$var$GetTint(this.fillColor, this.fillAlpha * alpha);
            var x0 = this.x0 - dx;
            var y0 = this.y0 - dy;
            var x1 = this.x1 - dx;
            var y1 = this.y1 - dy;
            var x2 = this.x2 - dx;
            var y2 = this.y2 - dy;
            var tx0 = calcMatrix.getX(x0, y0);
            var ty0 = calcMatrix.getY(x0, y0);
            var tx1 = calcMatrix.getX(x1, y1);
            var ty1 = calcMatrix.getY(x1, y1);
            var tx2 = calcMatrix.getX(x2, y2);
            var ty2 = calcMatrix.getY(x2, y2);
            pipeline.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, fillTintColor, fillTintColor, fillTintColor);
        }
        if (this.isStroked) (0, $5c58a174c1ab3565$export$2e2bcd8739ae039)(pipeline, this, alpha, dx, dy);
    }
    canvasRender(ctx, dx, dy) {
        var x1 = this.x1 - dx;
        var y1 = this.y1 - dy;
        var x2 = this.x2 - dx;
        var y2 = this.y2 - dy;
        var x3 = this.x3 - dx;
        var y3 = this.y3 - dy;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineTo(x3, y3);
        ctx.closePath();
        if (this.isFilled) {
            (0, $2669e1c300ac8e45$export$2e2bcd8739ae039)(ctx, this);
            ctx.fill();
        }
        if (this.isStroked) {
            (0, $dafcb0d30a33b02c$export$2e2bcd8739ae039)(ctx, this);
            ctx.stroke();
        }
    }
}
var $c2e68ce48d3429c6$export$2e2bcd8739ae039 = $c2e68ce48d3429c6$var$Triangle;




var $3122809fca07f505$export$2e2bcd8739ae039 = {
    buildShapes () {
        this.addShape(new (0, $0fa05e5e72af2e13$export$2e2bcd8739ae039)().setName("box")).addShape(new (0, $1e62846ec481ae38$export$2e2bcd8739ae039)().setName("checker"));
    },
    updateShapes () {
        var centerX = this.width / 2, centerY = this.height / 2, radius = Math.min(centerX, centerY);
        var width = radius * 2;
        var x = centerX - radius, y = centerY - radius;
        var boxLineWidth = this.boxLineWidth;
        var checkLineWidth = Math.max(width / 10, 2);
        var boxShape = this.getShape("box");
        var checkerShape = this.getShape("checker");
        // Setup shapes
        if (this.isSizeChanged) {
            // Box
            var posOffset = width * (1 - this.boxSize) / 2;
            var halfBoxLineWidth = boxLineWidth / 2;
            var boxInnerWidth = width * this.boxSize - boxLineWidth;
            boxShape.setTopLeftPosition(x + halfBoxLineWidth + posOffset, y + halfBoxLineWidth + posOffset).setSize(boxInnerWidth, boxInnerWidth);
            if (this.isCircleShape) boxShape.setRadius(boxInnerWidth / 2);
            else boxShape.setRadius(0);
            // Checker
            var posOffset = width * (1 - this.checkerSize) / 2;
            var unit = width * this.checkerSize / 4;
            var u0 = 0, u1 = unit * 1, u2 = unit * 2, u3 = unit * 3;
            checkerShape.startAt(u1, u2).lineTo(u2, u3).lineTo(u3, u1).offset(x + posOffset, y + posOffset).end();
        }
        // Set styles
        if (this.checked) {
            boxShape.fillStyle(this.boxFillColor, this.boxFillAlpha).lineStyle(boxLineWidth, this.boxStrokeColor, this.boxStrokeAlpha);
            checkerShape.lineStyle(checkLineWidth, this.checkerColor);
        } else {
            boxShape.fillStyle(this.uncheckedBoxFillColor, this.uncheckedBoxFillAlpha).lineStyle(boxLineWidth, this.uncheckedBoxStrokeColor, this.uncheckedBoxStrokeAlpha);
            checkerShape.lineStyle();
        }
        // Play checker animation
        if (this.checked) checkerShape.setDisplayPathSegment(this.checkerAnimProgress);
    }
};



const $52de0f0b406ab759$var$GetValue = Phaser.Utils.Objects.GetValue;
const $52de0f0b406ab759$var$Linear = Phaser.Math.Linear;
class $52de0f0b406ab759$var$EaseValueTask extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON();
        this.boot();
    }
    start(config) {
        if (this.timer.isRunning) return this;
        var target = this.target;
        this.propertyKey = $52de0f0b406ab759$var$GetValue(config, "key", "value");
        var currentValue = target[this.propertyKey];
        this.fromValue = $52de0f0b406ab759$var$GetValue(config, "from", currentValue);
        this.toValue = $52de0f0b406ab759$var$GetValue(config, "to", currentValue);
        this.setEase($52de0f0b406ab759$var$GetValue(config, "ease", this.ease));
        this.setDuration($52de0f0b406ab759$var$GetValue(config, "duration", this.duration));
        this.setRepeat($52de0f0b406ab759$var$GetValue(config, "repeat", 0));
        this.setDelay($52de0f0b406ab759$var$GetValue(config, "delay", 0));
        this.setRepeatDelay($52de0f0b406ab759$var$GetValue(config, "repeatDelay", 0));
        this.timer.setDuration(this.duration).setRepeat(this.repeat).setDelay(this.delay).setRepeatDelay(this.repeatDelay);
        target[this.propertyKey] = this.fromValue;
        super.start();
        return this;
    }
    updateGameObject(target, timer) {
        var t = timer.t;
        t = this.easeFn(t);
        target[this.propertyKey] = $52de0f0b406ab759$var$Linear(this.fromValue, this.toValue, t);
    }
}
var $52de0f0b406ab759$export$2e2bcd8739ae039 = $52de0f0b406ab759$var$EaseValueTask;


var $343ec7714e3641c9$export$2e2bcd8739ae039 = {
    setCheckerAnimationDuration (duration) {
        if (duration === undefined) duration = 0;
        this.checkerAnimDuration = duration;
        return this;
    },
    playCheckerAnimation () {
        if (this.checkerAnimProgressTask === undefined) this.checkerAnimProgressTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
            eventEmitter: null
        });
        this.checkerAnimProgressTask.restart({
            key: "checkerAnimProgress",
            from: 0,
            to: 1,
            duration: this.checkerAnimDuration
        });
        return this;
    },
    stopCheckerAnimation () {
        if (this.checkerAnimProgressTask === undefined) return this;
        this.checkerAnimProgressTask.stop();
        return this;
    }
};


var $79c12dfd53db8b04$var$methods = {};
Object.assign($79c12dfd53db8b04$var$methods, (0, $37e42f4969aba3e0$export$2e2bcd8739ae039), (0, $14d40989dbeb9db8$export$2e2bcd8739ae039), (0, $3122809fca07f505$export$2e2bcd8739ae039), (0, $343ec7714e3641c9$export$2e2bcd8739ae039));
var $79c12dfd53db8b04$export$2e2bcd8739ae039 = $79c12dfd53db8b04$var$methods;


const $fa006db9b576934d$var$GetValue = Phaser.Utils.Objects.GetValue;
const $fa006db9b576934d$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $fa006db9b576934d$var$DefaultBoxFillColor = 0x005cb2;
const $fa006db9b576934d$var$DefaultCheckerColor = 0xffffff;
class $fa006db9b576934d$var$CheckboxShape extends (0, $fa309bb54d70b13f$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, color, config){
        if ($fa006db9b576934d$var$IsPlainObject(x)) {
            config = x;
            x = $fa006db9b576934d$var$GetValue(config, "x", 0);
            y = $fa006db9b576934d$var$GetValue(config, "y", 0);
            width = $fa006db9b576934d$var$GetValue(config, "width", 2);
            height = $fa006db9b576934d$var$GetValue(config, "height", 2);
            color = $fa006db9b576934d$var$GetValue(config, "color", $fa006db9b576934d$var$DefaultBoxFillColor);
        } else if ($fa006db9b576934d$var$IsPlainObject(color)) {
            config = color;
            color = $fa006db9b576934d$var$GetValue(config, "color", $fa006db9b576934d$var$DefaultBoxFillColor);
        }
        super(scene, x, y, width, height);
        this.type = "rexCheckbox";
        if (color === undefined) color = $fa006db9b576934d$var$DefaultBoxFillColor;
        this.setBoxShape($fa006db9b576934d$var$GetValue(config, "circleBox", false));
        this.setBoxFillStyle(color, $fa006db9b576934d$var$GetValue(config, "boxFillAlpha", 1));
        this.setUncheckedBoxFillStyle($fa006db9b576934d$var$GetValue(config, "uncheckedColor", null), $fa006db9b576934d$var$GetValue(config, "uncheckedBoxFillAlpha", 1));
        this.setBoxStrokeStyle($fa006db9b576934d$var$GetValue(config, "boxLineWidth", 4), $fa006db9b576934d$var$GetValue(config, "boxStrokeColor", color), $fa006db9b576934d$var$GetValue(config, "boxStrokeAlpha", 1));
        this.setUncheckedBoxStrokeStyle(this.boxLineWidth, $fa006db9b576934d$var$GetValue(config, "uncheckedBoxStrokeColor", this.boxStrokeColor), $fa006db9b576934d$var$GetValue(config, "uncheckedBoxStrokeAlpha", this.boxStrokeAlpha));
        this.setCheckerStyle($fa006db9b576934d$var$GetValue(config, "checkerColor", $fa006db9b576934d$var$DefaultCheckerColor), $fa006db9b576934d$var$GetValue(config, "checkerAlpha", 1));
        this.setBoxSize($fa006db9b576934d$var$GetValue(config, "boxSize", 1));
        this.setCheckerSize($fa006db9b576934d$var$GetValue(config, "checkerSize", 1));
        this.setCheckerAnimationDuration($fa006db9b576934d$var$GetValue(config, "animationDuration", 150));
        this.buildShapes();
        var value = $fa006db9b576934d$var$GetValue(config, "checked");
        if (value === undefined) value = $fa006db9b576934d$var$GetValue(config, "value", false);
        this.setValue(value);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        value = !!value;
        if (this._value === value) return;
        this.dirty = true;
        this._value = value;
        if (value) this.playCheckerAnimation();
        else this.stopCheckerAnimation();
        this.emit("valuechange", value);
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    toggleValue() {
        this.setValue(!this.value);
        return this;
    }
    get checked() {
        return this.value;
    }
    set checked(value) {
        this.value = value;
    }
    setChecked(checked) {
        if (checked === undefined) checked = true;
        this.setValue(checked);
        return this;
    }
    toggleChecked() {
        this.toggleValue();
        return this;
    }
    get checkerAnimProgress() {
        return this._checkerAnimProgress;
    }
    set checkerAnimProgress(value) {
        if (this._checkerAnimProgress === value) return;
        this._checkerAnimProgress = value;
        this.dirty = true;
    }
}
Object.assign($fa006db9b576934d$var$CheckboxShape.prototype, (0, $79c12dfd53db8b04$export$2e2bcd8739ae039));
var $fa006db9b576934d$export$2e2bcd8739ae039 = $fa006db9b576934d$var$CheckboxShape;



const $d7386e5b0e39fd99$var$GetValue = Phaser.Utils.Objects.GetValue;
class $d7386e5b0e39fd99$var$Button extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this._enable = undefined;
        gameObject.setInteractive($d7386e5b0e39fd99$var$GetValue(config, "inputConfig", undefined));
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.pointer = undefined;
        this.lastClickTime = undefined;
        this.setEnable($d7386e5b0e39fd99$var$GetValue(o, "enable", true));
        this.setMode($d7386e5b0e39fd99$var$GetValue(o, "mode", 1));
        this.setClickInterval($d7386e5b0e39fd99$var$GetValue(o, "clickInterval", 100));
        this.setDragThreshold($d7386e5b0e39fd99$var$GetValue(o, "threshold", undefined));
        return this;
    }
    boot() {
        var gameObject = this.parent;
        gameObject.on("pointerdown", this.onPress, this);
        gameObject.on("pointerup", this.onRelease, this);
        gameObject.on("pointerout", this.onPointOut, this);
        gameObject.on("pointermove", this.onMove, this);
        gameObject.on("pointerover", this.onOver, this);
        gameObject.on("pointerout", this.onOut, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // GameObject events will be removed when this gameObject destroyed 
        // this.parent.on('pointerdown', this.onPress, this);
        // this.parent.on('pointerup', this.onRelease, this);
        // this.parent.on('pointerout', this.onPointOut, this);
        // this.parent.on('pointermove', this.onMove, this);
        this.pointer = null;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) this.cancel();
        this._enable = e;
        var eventName = e ? "enable" : "disable";
        this.emit(eventName, this, this.parent);
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $d7386e5b0e39fd99$var$CLICKMODE[m];
        this.mode = m;
        return this;
    }
    setClickInterval(interval) {
        this.clickInterval = interval; // ms
        return this;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
    // internal
    onPress(pointer, localX, localY, event) {
        if (this.pointer !== undefined) return;
        this.pointer = pointer;
        if (this.mode === 0) this.click(pointer.downTime, pointer, event);
    }
    onRelease(pointer, localX, localY, event) {
        if (this.pointer !== pointer) return;
        if (this.mode === 1) this.click(pointer.upTime, pointer, event);
        this.pointer = undefined;
    }
    onPointOut(pointer, event) {
        if (this.pointer !== pointer) return;
        this.cancel();
    }
    onMove(pointer, localX, localY, event) {
        if (this.pointer !== pointer) return;
        if (this.dragThreshold === undefined) return;
        if (pointer.getDistance() >= this.dragThreshold) this.cancel();
    }
    click(nowTime, pointer, event) {
        if (!this.enable) return this;
        if (nowTime === undefined) {
            // fires 'click' event manually
            this.emit("click", this, this.parent, pointer, event);
            return this;
        }
        this.pointer = undefined;
        var lastClickTime = this.lastClickTime;
        if (lastClickTime !== undefined && nowTime - lastClickTime <= this.clickInterval) return this;
        this.lastClickTime = nowTime;
        this.emit("click", this, this.parent, pointer, event);
        return this;
    }
    cancel() {
        this.pointer = undefined;
        return this;
    }
    onOver(pointer, localX, localY, event) {
        if (!this.enable) return this;
        this.emit("over", this, this.parent, pointer, event);
        return this;
    }
    onOut(pointer, event) {
        if (!this.enable) return this;
        this.emit("out", this, this.parent, pointer, event);
        return this;
    }
}
const $d7386e5b0e39fd99$var$CLICKMODE = {
    press: 0,
    pointerdown: 0,
    release: 1,
    pointerup: 1
};
var $d7386e5b0e39fd99$export$2e2bcd8739ae039 = $d7386e5b0e39fd99$var$Button;


const $e2fc71da9a80d544$var$GetValue = Phaser.Utils.Objects.GetValue;
class $e2fc71da9a80d544$var$Checkbox extends (0, $fa006db9b576934d$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, color, config){
        super(scene, x, y, width, height, color, config);
        this._click = new (0, $d7386e5b0e39fd99$export$2e2bcd8739ae039)(this, $e2fc71da9a80d544$var$GetValue(config, "click"));
        this._click.on("click", function() {
            this.toggleValue();
        }, this);
        this.setReadOnly($e2fc71da9a80d544$var$GetValue(config, "readOnly", false));
    }
    get readOnly() {
        return !this._click.enable;
    }
    set readOnly(value) {
        this._click.enable = !value;
    }
    setReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.readOnly = enable;
        return this;
    }
}
var $e2fc71da9a80d544$export$2e2bcd8739ae039 = $e2fc71da9a80d544$var$Checkbox;


var $a0ff1f68ab75d1db$export$2e2bcd8739ae039 = (0, $e2fc71da9a80d544$export$2e2bcd8739ae039);


var $80b01800e6b54880$export$2e2bcd8739ae039 = (0, $a0ff1f68ab75d1db$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("checkbox", function(x, y, width, height, color, config) {
    var gameObject = new (0, $80b01800e6b54880$export$2e2bcd8739ae039)(this.scene, x, y, width, height, color, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Checkbox", (0, $80b01800e6b54880$export$2e2bcd8739ae039));
var $7ad5939174a39a82$export$2e2bcd8739ae039 = (0, $80b01800e6b54880$export$2e2bcd8739ae039);



var $3cab40e1f13e546c$export$2e2bcd8739ae039 = {
    setTrackFillStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.trackFillColor !== color || this.trackFillAlpha !== alpha;
        this.trackFillColor = color;
        this.trackFillAlpha = alpha;
        return this;
    },
    setFalseValueTrackFillStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.falseValueTrackColor !== color || this.uncheckedTrackFillAlpha !== alpha;
        this.falseValueTrackColor = color;
        this.falseValueTrackFillAlpha = alpha;
        return this;
    },
    setThumbStyle (color, alpha) {
        if (alpha === undefined) alpha = 1;
        this.dirty = this.dirty || this.thumbColor !== color || this.checkAlpha !== alpha;
        this.thumbColor = color;
        this.thumbAlpha = alpha;
        return this;
    }
};


var $340226521066c48a$export$2e2bcd8739ae039 = {
    setTrackSize (width, height) {
        this.dirty = this.dirty || this.trackWidth !== width || this.trackHeight !== height;
        this.trackWidth = width;
        this.trackHeight = height;
        return this;
    },
    setTrackRadius (radius) {
        this.dirty = this.dirty || this.trackRadius !== radius;
        this.trackRadius = radius;
        return this;
    },
    setThumbSize (width, height) {
        if (height === undefined) height = width;
        this.dirty = this.dirty || this.thumbWidth !== width || this.thumbHeight !== height;
        this.thumbWidth = width;
        this.thumbHeight = height;
        return this;
    },
    setThumbRadius (radius) {
        this.dirty = this.dirty || this.thumbRadius !== radius;
        this.thumbRadius = radius;
        return this;
    }
};


var $0adbd86044adb9c3$export$2e2bcd8739ae039 = {
    setThumbPosition (left, right) {
        if (right === undefined) right = 1 - left;
        this.thumbLeftX = left;
        this.thumbRightX = right;
        return this;
    },
    setRTL (rtl) {
        if (rtl === undefined) rtl = true;
        this.rtl = rtl;
        return this;
    }
};



/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ /**
 * Calculates a linear (interpolation) value over t.
 *
 * @function Phaser.Math.Linear
 * @since 3.0.0
 *
 * @param {number} p0 - The first point.
 * @param {number} p1 - The second point.
 * @param {number} t - The percentage between p0 and p1 to return, represented as a number between 0 and 1.
 *
 * @return {number} The step t% of the way between p0 and p1.
 */ var $bd3c5d9f4ae3d69d$var$Linear = function(p0, p1, t) {
    return (p1 - p0) * t + p0;
};
var $bd3c5d9f4ae3d69d$export$2e2bcd8739ae039 = $bd3c5d9f4ae3d69d$var$Linear;



var $b0bd44a7f8015b11$var$MixColor = function(color0, color1, t) {
    var r = (0, $bd3c5d9f4ae3d69d$export$2e2bcd8739ae039)((0, $8f5ae6faf2588ae9$export$41462b6f413ab95a)(color0), (0, $8f5ae6faf2588ae9$export$41462b6f413ab95a)(color1), t);
    var g = (0, $bd3c5d9f4ae3d69d$export$2e2bcd8739ae039)((0, $8f5ae6faf2588ae9$export$2beaff7905ae7854)(color0), (0, $8f5ae6faf2588ae9$export$2beaff7905ae7854)(color1), t);
    var b = (0, $bd3c5d9f4ae3d69d$export$2e2bcd8739ae039)((0, $8f5ae6faf2588ae9$export$6b1cf35401b5f75a)(color0), (0, $8f5ae6faf2588ae9$export$6b1cf35401b5f75a)(color1), t);
    return (r & 0xff) << 16 | (g & 0xff) << 8 | b & 0xff;
};
var $b0bd44a7f8015b11$export$2e2bcd8739ae039 = $b0bd44a7f8015b11$var$MixColor;


const $355ea71ca0881480$var$Linear = Phaser.Math.Linear;
var $355ea71ca0881480$export$2e2bcd8739ae039 = {
    buildShapes () {
        this.addShape(new (0, $0fa05e5e72af2e13$export$2e2bcd8739ae039)().setName("track")).addShape(new (0, $0fa05e5e72af2e13$export$2e2bcd8739ae039)().setName("thumb"));
    },
    updateShapes () {
        var width = this.width, height = this.height;
        var toggleAnimProgress = this.value ? this.toggleAnimProgress : 1 - this.toggleAnimProgress;
        // Track
        var trackShape = this.getShape("track");
        if (this.isSizeChanged) {
            var trackWidth = width * this.trackWidth, trackHeight = height * this.trackHeight, trackX = (width - trackWidth) / 2, trackY = (height - trackHeight) / 2, trackRadius = height * this.trackRadius;
            trackShape.setTopLeftPosition(trackX, trackY).setSize(trackWidth, trackHeight).setRadius(trackRadius);
        }
        var trackFillColor = (0, $b0bd44a7f8015b11$export$2e2bcd8739ae039)(this.falseValueTrackColor, this.trackFillColor, toggleAnimProgress);
        var trackFillAlpha = $355ea71ca0881480$var$Linear(this.falseValueTrackFillAlpha, this.trackFillAlpha, toggleAnimProgress);
        trackShape.fillStyle(trackFillColor, trackFillAlpha);
        // Thumb
        var thumbShape = this.getShape("thumb");
        if (this.isSizeChanged) {
            var thumbWidth = width * this.thumbWidth, thumbHeight = height * this.thumbHeight, thumbRadius = height * this.thumbRadius;
            thumbShape.setSize(thumbWidth, thumbHeight).setRadius(thumbRadius);
        }
        var thumbX = $355ea71ca0881480$var$Linear(this.thumbLeftX, this.thumbRightX, toggleAnimProgress) * width;
        if (this.rtl) thumbX = width - thumbX;
        var thumbY = height / 2;
        thumbShape.setCenterPosition(thumbX, thumbY);
        thumbShape.fillStyle(this.thumbColor, this.thumbAlpha);
    }
};



var $b1d8abe7dae74265$export$2e2bcd8739ae039 = {
    setToggleAnimationDuration (duration) {
        if (duration === undefined) duration = 0;
        this.toggleAnimDuration = duration;
        return this;
    },
    playToggleAnimation () {
        if (this.toggleAnimProgressTask === undefined) this.toggleAnimProgressTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
            eventEmitter: null
        });
        this.toggleAnimProgressTask.restart({
            key: "toggleAnimProgress",
            from: 0,
            to: 1,
            duration: this.toggleAnimDuration
        });
        return this;
    },
    stopToggleAnimation () {
        if (this.toggleAnimProgressTask === undefined) return this;
        this.toggleAnimProgressTask.stop();
        return this;
    }
};


var $ede177329c8d082f$var$methods = {};
Object.assign($ede177329c8d082f$var$methods, (0, $3cab40e1f13e546c$export$2e2bcd8739ae039), (0, $340226521066c48a$export$2e2bcd8739ae039), (0, $0adbd86044adb9c3$export$2e2bcd8739ae039), (0, $355ea71ca0881480$export$2e2bcd8739ae039), (0, $b1d8abe7dae74265$export$2e2bcd8739ae039));
var $ede177329c8d082f$export$2e2bcd8739ae039 = $ede177329c8d082f$var$methods;



var $525a031c2be3fbac$var$GrayScale = function(color) {
    var shade = 0.3 * (0, $8f5ae6faf2588ae9$export$41462b6f413ab95a)(color) + 0.59 * (0, $8f5ae6faf2588ae9$export$2beaff7905ae7854)(color) + 0.11 * (0, $8f5ae6faf2588ae9$export$6b1cf35401b5f75a)(color);
    return (shade & 0xff) << 16 | (shade & 0xff) << 8 | shade & 0xff;
};
var $525a031c2be3fbac$export$2e2bcd8739ae039 = $525a031c2be3fbac$var$GrayScale;


const $8be83df9225188c3$var$GetValue = Phaser.Utils.Objects.GetValue;
const $8be83df9225188c3$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $8be83df9225188c3$var$DefaultTrackFillColor = 0x005cb2;
const $8be83df9225188c3$var$DefaultThumbFillColor = 0xffffff;
class $8be83df9225188c3$var$ToggleSwitchShape extends (0, $fa309bb54d70b13f$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, color, config){
        if ($8be83df9225188c3$var$IsPlainObject(x)) {
            config = x;
            x = $8be83df9225188c3$var$GetValue(config, "x", 0);
            y = $8be83df9225188c3$var$GetValue(config, "y", 0);
            width = $8be83df9225188c3$var$GetValue(config, "width", 2);
            height = $8be83df9225188c3$var$GetValue(config, "height", 2);
            color = $8be83df9225188c3$var$GetValue(config, "color", $8be83df9225188c3$var$DefaultTrackFillColor);
        } else if ($8be83df9225188c3$var$IsPlainObject(color)) {
            config = color;
            color = $8be83df9225188c3$var$GetValue(config, "color", $8be83df9225188c3$var$DefaultTrackFillColor);
        }
        super(scene, x, y, width, height);
        this.type = "rexToggleSwitch";
        if (color === undefined) color = $8be83df9225188c3$var$DefaultTrackFillColor;
        this.setTrackFillStyle(color, $8be83df9225188c3$var$GetValue(config, "trackFillAlpha", 1));
        this.setFalseValueTrackFillStyle($8be83df9225188c3$var$GetValue(config, "falseValueTrackColor", (0, $525a031c2be3fbac$export$2e2bcd8739ae039)(color)), $8be83df9225188c3$var$GetValue(config, "falseValueTrackFillAlpha", 1));
        this.setThumbStyle($8be83df9225188c3$var$GetValue(config, "thumbColor", $8be83df9225188c3$var$DefaultThumbFillColor), $8be83df9225188c3$var$GetValue(config, "thumbAlpha", 1));
        this.setTrackSize($8be83df9225188c3$var$GetValue(config, "trackWidth", 0.9), $8be83df9225188c3$var$GetValue(config, "trackHeight", 0.5));
        this.setTrackRadius($8be83df9225188c3$var$GetValue(config, "trackRadius", this.trackHeight * 0.5));
        var thumbHeight = $8be83df9225188c3$var$GetValue(config, "thumbHeight", undefined);
        var thumbWidth = $8be83df9225188c3$var$GetValue(config, "thumbWidth", thumbHeight);
        if (thumbWidth === undefined) thumbWidth = this.trackHeight * 0.9;
        this.setThumbSize(thumbWidth, thumbHeight);
        this.setThumbRadius($8be83df9225188c3$var$GetValue(config, "thumbRadius", this.thumbHeight * 0.5));
        this.setThumbPosition($8be83df9225188c3$var$GetValue(config, "thumbLeft", 0.3), $8be83df9225188c3$var$GetValue(config, "thumbRight", undefined));
        this.setRTL($8be83df9225188c3$var$GetValue(config, "rtl", false));
        this.setToggleAnimationDuration($8be83df9225188c3$var$GetValue(config, "animationDuration", 150));
        this.buildShapes();
        this.setValue($8be83df9225188c3$var$GetValue(config, "value", false), 0);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        value = !!value;
        if (this._value === value) return;
        this.dirty = true;
        this._value = value;
        this.playToggleAnimation();
        this.emit("valuechange", value);
    }
    setValue(value, duration) {
        if (duration === undefined) duration = this.toggleAnimDuration;
        var durationSave = this.toggleAnimDuration;
        this.toggleAnimDuration = duration;
        this.value = value;
        this.toggleAnimDuration = durationSave;
        return this;
    }
    toggleValue(duration) {
        this.setValue(!this.value, duration);
        return this;
    }
    get toggleAnimProgress() {
        return this._toggleAnimProgress;
    }
    set toggleAnimProgress(value) {
        if (this._toggleAnimProgress === value) return;
        this._toggleAnimProgress = value;
        this.dirty = true;
    }
}
Object.assign($8be83df9225188c3$var$ToggleSwitchShape.prototype, (0, $ede177329c8d082f$export$2e2bcd8739ae039));
var $8be83df9225188c3$export$2e2bcd8739ae039 = $8be83df9225188c3$var$ToggleSwitchShape;



const $d930f2b2815e4f56$var$GetValue = Phaser.Utils.Objects.GetValue;
class $d930f2b2815e4f56$var$ToggleSwitch extends (0, $8be83df9225188c3$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, color, config){
        super(scene, x, y, width, height, color, config);
        this._click = new (0, $d7386e5b0e39fd99$export$2e2bcd8739ae039)(this, $d930f2b2815e4f56$var$GetValue(config, "click"));
        this._click.on("click", function() {
            this.toggleValue();
        }, this);
        this.setReadOnly($d930f2b2815e4f56$var$GetValue(config, "readOnly", false));
    }
    get readOnly() {
        return !this._click.enable;
    }
    set readOnly(value) {
        this._click.enable = !value;
    }
    setReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.readOnly = enable;
        return this;
    }
}
var $d930f2b2815e4f56$export$2e2bcd8739ae039 = $d930f2b2815e4f56$var$ToggleSwitch;


var $23c692fa99ee56bd$export$2e2bcd8739ae039 = (0, $d930f2b2815e4f56$export$2e2bcd8739ae039);


var $ec6363d3c943d949$export$2e2bcd8739ae039 = (0, $23c692fa99ee56bd$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("toggleSwitch", function(x, y, width, height, color, config) {
    var gameObject = new (0, $ec6363d3c943d949$export$2e2bcd8739ae039)(this.scene, x, y, width, height, color, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ToggleSwitch", (0, $ec6363d3c943d949$export$2e2bcd8739ae039));
var $a9742911970e0ac3$export$2e2bcd8739ae039 = (0, $ec6363d3c943d949$export$2e2bcd8739ae039);



var $d8195d18b0220ee1$export$2e2bcd8739ae039 = {
    loadFromURL (url, callback) {
        var self = this;
        var img = new Image();
        img.onload = function() {
            if (self.width !== img.width || self.height !== img.height) self.resize(img.width, img.height);
            else self.clear();
            self.context.drawImage(img, 0, 0);
            self.updateTexture();
            if (callback) callback();
            img.onload = null;
            img.src = "";
            img.remove();
        };
        img.src = url;
        return this;
    },
    loadFromURLPromise (url) {
        var self = this;
        return new Promise(function(resolve, reject) {
            self.loadFromURL(url, resolve);
        });
    },
    loadFromFile (file, callback) {
        var url = URL.createObjectURL(file);
        this.loadFromURL(url, function() {
            URL.revokeObjectURL(url);
            if (callback) callback();
        });
        return this;
    },
    loadFromFilePromise (file) {
        var self = this;
        return new Promise(function(resolve, reject) {
            self.loadFromFile(file, resolve);
        });
    }
};


class $dbd59faa0dbda79a$var$Canvas extends (0, $3842bed83c6c142c$export$2e2bcd8739ae039) {
}
Object.assign($dbd59faa0dbda79a$var$Canvas.prototype, (0, $d8195d18b0220ee1$export$2e2bcd8739ae039));
var $dbd59faa0dbda79a$export$2e2bcd8739ae039 = $dbd59faa0dbda79a$var$Canvas;


var $6e79d7989642e197$export$2e2bcd8739ae039 = (0, $dbd59faa0dbda79a$export$2e2bcd8739ae039);


var $a7cd42622da8fab8$export$2e2bcd8739ae039 = (0, $6e79d7989642e197$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("canvas", function(x, y, width, height) {
    var gameObject = new (0, $a7cd42622da8fab8$export$2e2bcd8739ae039)(this.scene, x, y, width, height);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Canvas", (0, $a7cd42622da8fab8$export$2e2bcd8739ae039));
var $084582104b83eb6b$export$2e2bcd8739ae039 = (0, $a7cd42622da8fab8$export$2e2bcd8739ae039);



var $53a247a9dadbd479$export$2e2bcd8739ae039 = (0, $1b1f0d179197d128$export$2e2bcd8739ae039);


var $931ba31fd5fc4735$export$2e2bcd8739ae039 = (0, $53a247a9dadbd479$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("circleMaskImage", function(x, y, key, frame, config) {
    var gameObject = new (0, $931ba31fd5fc4735$export$2e2bcd8739ae039)(this.scene, x, y, key, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CircleMaskImage", (0, $931ba31fd5fc4735$export$2e2bcd8739ae039));
var $92fb1dc1b905d1f4$export$2e2bcd8739ae039 = (0, $931ba31fd5fc4735$export$2e2bcd8739ae039);



const $6e2779b6a7b75e8c$var$GetValue = Phaser.Utils.Objects.GetValue;
class $6e2779b6a7b75e8c$var$AlphaMaskImage extends (0, $3842bed83c6c142c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, key, frame, config){
        super(scene, x, y);
        this.type = "rexAlphaMaskImage";
        this.maskFrame = null;
        this.setTexture(key, frame, config);
    }
    setTexture(key, frame, config) {
        if (typeof frame === "object") {
            config = frame;
            frame = undefined;
        }
        if (typeof config === "string") config = {
            mask: {
                key: config
            }
        };
        var maskKey = $6e2779b6a7b75e8c$var$GetValue(config, "mask.key");
        var maskFrame = $6e2779b6a7b75e8c$var$GetValue(config, "mask.frame");
        var invertMaskAlpha = $6e2779b6a7b75e8c$var$GetValue(config, "mask.invertAlpha", false);
        var maskScale = $6e2779b6a7b75e8c$var$GetValue(config, "mask.scale");
        var backgroundColor = $6e2779b6a7b75e8c$var$GetValue(config, "backgroundColor");
        if (maskKey) {
            this._maskKey = maskKey;
            this._maskFrame = maskFrame;
            this._maskScale = maskScale;
            var texture = maskKey ? this.scene.sys.textures.get(maskKey) : null;
            this.maskFrame = texture ? texture.get(maskFrame) : null;
        }
        this._textureKey = key;
        this._frameName = frame;
        var maskTextureFrame = this.maskFrame;
        if (maskTextureFrame === null) {
            this.loadTexture(key, frame);
            this.dirty = true;
            return this;
        }
        var hasBackgroundColor = backgroundColor != null;
        this.loadTexture(key, frame);
        // Draw mask
        var canvas = this.canvas, ctx = this.context;
        var width = canvas.width, height = canvas.height;
        ctx.save();
        ctx.globalCompositeOperation = invertMaskAlpha ? "destination-out" : "destination-in";
        var maskWidth, maskHeight;
        if (this._maskScale != null) {
            maskWidth = maskTextureFrame.cutWidth * this._maskScale;
            maskHeight = maskTextureFrame.cutHeight * this._maskScale;
        } else {
            maskWidth = width;
            maskHeight = height;
        }
        var maskX = (width - maskWidth) / 2;
        var maskY = (height - maskHeight) / 2;
        this.drawFrame(this._maskKey, this._maskFrame, maskX, maskY, maskWidth, maskHeight);
        ctx.restore();
        if (hasBackgroundColor) {
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(0, 0, width, height);
            ctx.restore();
        }
        this.dirty = true;
        return this;
    }
    resize(width, height) {
        // Don't draw content again.
        this.setDisplaySize(width, height);
        return this;
    }
}
var $6e2779b6a7b75e8c$export$2e2bcd8739ae039 = $6e2779b6a7b75e8c$var$AlphaMaskImage;


var $f3086f5bc82eda0c$export$2e2bcd8739ae039 = (0, $6e2779b6a7b75e8c$export$2e2bcd8739ae039);


var $febaacff662f2518$export$2e2bcd8739ae039 = (0, $f3086f5bc82eda0c$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("alphaMaskImage", function(x, y, key, frame, config) {
    var gameObject = new (0, $febaacff662f2518$export$2e2bcd8739ae039)(this.scene, x, y, key, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.AlphaMaskImage", (0, $febaacff662f2518$export$2e2bcd8739ae039));
var $2c6f637037b765b5$export$2e2bcd8739ae039 = (0, $febaacff662f2518$export$2e2bcd8739ae039);



const $5b34cdefdda56487$var$Linear = Phaser.Math.Linear;
const $5b34cdefdda56487$var$Percent = Phaser.Math.Percent;
var $5b34cdefdda56487$export$2e2bcd8739ae039 = {
    setValue (value, min, max) {
        if (value === undefined || value === null) return this;
        if (min !== undefined) value = $5b34cdefdda56487$var$Percent(value, min, max);
        this.value = value;
        return this;
    },
    addValue (inc, min, max) {
        if (min !== undefined) inc = $5b34cdefdda56487$var$Percent(inc, min, max);
        this.value += inc;
        return this;
    },
    getValue (min, max) {
        var value = this.value;
        if (min !== undefined) value = $5b34cdefdda56487$var$Linear(min, max, value);
        return value;
    }
};



const $4fb4186834dceb86$var$Percent = Phaser.Math.Percent;
var $4fb4186834dceb86$var$SetEaseValuePropName = function(name) {
    this.easeValuePropName = name;
    return this;
};
var $4fb4186834dceb86$var$SetEaseValueDuration = function(duration) {
    this.easeValueDuration = duration;
    return this;
};
var $4fb4186834dceb86$var$SetEaseValueFunction = function(ease) {
    this.easeFunction = ease;
    return this;
};
var $4fb4186834dceb86$var$StopEaseValue = function() {
    if (this.easeValueTask) this.easeValueTask.stop();
    return this;
};
var $4fb4186834dceb86$var$EaseValueTo = function(value, min, max) {
    if (value === undefined || value === null) return this;
    if (min !== undefined) value = $4fb4186834dceb86$var$Percent(value, min, max);
    if (this.easeValueTask === undefined) this.easeValueTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
        eventEmitter: null
    });
    this.easeValueTask.restart({
        key: this.easeValuePropName,
        to: value,
        duration: this.easeValueDuration,
        ease: this.easeFunction
    });
    return this;
};
var $4fb4186834dceb86$var$EaseValueRepeat = function(from, to, repeat, repeatDelay) {
    if (repeat === undefined) repeat = -1;
    if (repeatDelay === undefined) repeatDelay = 0;
    if (this.easeValueTask === undefined) this.easeValueTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
        eventEmitter: null
    });
    this.easeValueTask.restart({
        key: this.easeValuePropName,
        from: from,
        to: to,
        duration: this.easeValueDuration,
        ease: this.easeFunction,
        repeat: repeat,
        repeatDelay: repeatDelay
    });
    return this;
};
var $4fb4186834dceb86$export$2e2bcd8739ae039 = {
    setEaseValuePropName: $4fb4186834dceb86$var$SetEaseValuePropName,
    setEaseValueDuration: $4fb4186834dceb86$var$SetEaseValueDuration,
    setEaseValueFunction: $4fb4186834dceb86$var$SetEaseValueFunction,
    stopEaseValue: $4fb4186834dceb86$var$StopEaseValue,
    easeValueTo: $4fb4186834dceb86$var$EaseValueTo,
    easeValueRepeat: $4fb4186834dceb86$var$EaseValueRepeat
};


const $3b85503cb0648427$var$GetValue = Phaser.Utils.Objects.GetValue;
const $3b85503cb0648427$var$Clamp = Phaser.Math.Clamp;
function $3b85503cb0648427$export$2e2bcd8739ae039(BaseClass) {
    class ProgressBase extends BaseClass {
        bootProgressBase(config) {
            this.eventEmitter = $3b85503cb0648427$var$GetValue(config, "eventEmitter", this);
            var callback = $3b85503cb0648427$var$GetValue(config, "valuechangeCallback", null);
            if (callback !== null) {
                var scope = $3b85503cb0648427$var$GetValue(config, "valuechangeCallbackScope", undefined);
                this.eventEmitter.on("valuechange", callback, scope);
            }
            this.setEaseValuePropName("value").setEaseValueDuration($3b85503cb0648427$var$GetValue(config, "easeValue.duration", 0)).setEaseValueFunction($3b85503cb0648427$var$GetValue(config, "easeValue.ease", "Linear"));
            return this;
        }
        get value() {
            return this._value;
        }
        set value(value) {
            value = $3b85503cb0648427$var$Clamp(value, 0, 1);
            var oldValue = this._value;
            var valueChanged = oldValue != value;
            this.dirty = this.dirty || valueChanged;
            this._value = value;
            if (valueChanged) this.eventEmitter.emit("valuechange", this._value, oldValue, this.eventEmitter);
        }
    }
    Object.assign(ProgressBase.prototype, (0, $5b34cdefdda56487$export$2e2bcd8739ae039), (0, $4fb4186834dceb86$export$2e2bcd8739ae039));
    return ProgressBase;
}



const $847541e16d22a713$var$RadToDeg = Phaser.Math.RadToDeg;
var $847541e16d22a713$export$2e2bcd8739ae039 = {
    buildShapes () {
        this.addShape(new (0, $59dabc3f63aed362$export$2e2bcd8739ae039)().setName("track")).addShape(new (0, $dc5d4817ddd3622b$export$2e2bcd8739ae039)().setName("bar")).addShape(new (0, $59dabc3f63aed362$export$2e2bcd8739ae039)().setName("center"));
    },
    updateShapes () {
        var x = this.radius;
        var lineWidth = this.thickness * this.radius;
        var barRadius = this.radius - lineWidth / 2;
        var centerRadius = this.radius - lineWidth;
        // Track shape
        var trackShape = this.getShape("track");
        if (this.trackColor != null && lineWidth > 0) trackShape.setCenterPosition(x, x).setRadius(barRadius).lineStyle(lineWidth, this.trackColor);
        else trackShape.reset();
        // Bar shape
        var barShape = this.getShape("bar");
        if (this.barColor != null && barRadius > 0) {
            var anticlockwise, startAngle, endAngle;
            if (this.value === 1) {
                anticlockwise = false;
                startAngle = 0;
                endAngle = 361; // overshoot 1
            } else {
                anticlockwise = this.anticlockwise;
                startAngle = $847541e16d22a713$var$RadToDeg(this.startAngle);
                var deltaAngle = 360 * (anticlockwise ? 1 - this.value : this.value);
                endAngle = deltaAngle + startAngle;
            }
            barShape.setCenterPosition(x, x).setRadius(barRadius).setAngle(startAngle, endAngle, anticlockwise).lineStyle(lineWidth, this.barColor);
        } else barShape.reset();
        // Center shape
        var centerShape = this.getShape("center");
        if (this.centerColor && centerRadius > 0) centerShape.setCenterPosition(x, x).setRadius(centerRadius).fillStyle(this.centerColor);
        else centerShape.reset();
    }
};


const $065bf4c4caa1d2b6$var$GetValue = Phaser.Utils.Objects.GetValue;
const $065bf4c4caa1d2b6$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $065bf4c4caa1d2b6$var$Clamp = Phaser.Math.Clamp;
const $065bf4c4caa1d2b6$var$DefaultStartAngle = Phaser.Math.DegToRad(270);
class $065bf4c4caa1d2b6$var$CircularProgress extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $fa309bb54d70b13f$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, radius, barColor, value, config){
        if ($065bf4c4caa1d2b6$var$IsPlainObject(x)) {
            config = x;
            x = $065bf4c4caa1d2b6$var$GetValue(config, "x", 0);
            y = $065bf4c4caa1d2b6$var$GetValue(config, "y", 0);
            radius = $065bf4c4caa1d2b6$var$GetValue(config, "radius", 1);
            barColor = $065bf4c4caa1d2b6$var$GetValue(config, "barColor", undefined);
            value = $065bf4c4caa1d2b6$var$GetValue(config, "value", 0);
        }
        if (radius === undefined) radius = 1;
        var width = radius * 2;
        super(scene, x, y, width, width);
        this.type = "rexCircularProgress";
        this.bootProgressBase(config);
        this.setRadius(radius);
        this.setTrackColor($065bf4c4caa1d2b6$var$GetValue(config, "trackColor", undefined));
        this.setBarColor(barColor);
        this.setCenterColor($065bf4c4caa1d2b6$var$GetValue(config, "centerColor", undefined));
        this.setThickness($065bf4c4caa1d2b6$var$GetValue(config, "thickness", 0.2));
        this.setStartAngle($065bf4c4caa1d2b6$var$GetValue(config, "startAngle", $065bf4c4caa1d2b6$var$DefaultStartAngle));
        this.setAnticlockwise($065bf4c4caa1d2b6$var$GetValue(config, "anticlockwise", false));
        this.buildShapes();
        this.setValue(value);
    }
    resize(width, height) {
        width = Math.floor(Math.min(width, height));
        if (width === this.width) return this;
        super.resize(width, width);
        this.setRadius(width / 2);
        return this;
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this.dirty = this.dirty || this._radius != value;
        this._radius = value;
        var width = value * 2;
        this.resize(width, width);
    }
    setRadius(radius) {
        this.radius = radius;
        return this;
    }
    get trackColor() {
        return this._trackColor;
    }
    set trackColor(value) {
        this.dirty = this.dirty || this._trackColor != value;
        this._trackColor = value;
    }
    setTrackColor(color) {
        this.trackColor = color;
        return this;
    }
    get barColor() {
        return this._barColor;
    }
    set barColor(value) {
        this.dirty = this.dirty || this._barColor != value;
        this._barColor = value;
    }
    setBarColor(color) {
        this.barColor = color;
        return this;
    }
    get startAngle() {
        return this._startAngle;
    }
    set startAngle(value) {
        this.dirty = this.dirty || this._startAngle != value;
        this._startAngle = value;
    }
    setStartAngle(angle) {
        this.startAngle = angle;
        return this;
    }
    get anticlockwise() {
        return this._anticlockwise;
    }
    set anticlockwise(value) {
        this.dirty = this.dirty || this._anticlockwise != value;
        this._anticlockwise = value;
    }
    setAnticlockwise(anticlockwise) {
        if (anticlockwise === undefined) anticlockwise = true;
        this.anticlockwise = anticlockwise;
        return this;
    }
    get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        value = $065bf4c4caa1d2b6$var$Clamp(value, 0, 1);
        this.dirty = this.dirty || this._thickness != value;
        this._thickness = value;
    }
    setThickness(thickness) {
        this.thickness = thickness;
        return this;
    }
    get centerColor() {
        return this._centerColor;
    }
    set centerColor(value) {
        this.dirty = this.dirty || this._centerColor != value;
        this._centerColor = value;
    }
    setCenterColor(color) {
        this.centerColor = color;
        return this;
    }
}
Object.assign($065bf4c4caa1d2b6$var$CircularProgress.prototype, (0, $847541e16d22a713$export$2e2bcd8739ae039));
var $065bf4c4caa1d2b6$export$2e2bcd8739ae039 = $065bf4c4caa1d2b6$var$CircularProgress;


var $5646dec7131164da$export$2e2bcd8739ae039 = (0, $065bf4c4caa1d2b6$export$2e2bcd8739ae039);


var $c2a88b80fc9d5955$export$2e2bcd8739ae039 = (0, $5646dec7131164da$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("circularProgress", function(x, y, radius, barColor, value, config) {
    var gameObject = new (0, $c2a88b80fc9d5955$export$2e2bcd8739ae039)(this.scene, x, y, radius, barColor, value, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CircularProgress", (0, $c2a88b80fc9d5955$export$2e2bcd8739ae039));
var $eea283fdbf78f97e$export$2e2bcd8739ae039 = (0, $c2a88b80fc9d5955$export$2e2bcd8739ae039);





var $c611d46754e737fd$var$DrawCircle = function(canvas, context, x, y, rx, ry, fillStyle, strokeStyle, lineWidth, startAngle, endAngle, anticlockwise) {
    if (startAngle === undefined) startAngle = 0;
    if (endAngle === undefined) endAngle = 2 * Math.PI;
    if (anticlockwise === undefined) anticlockwise = false;
    context.beginPath();
    context.ellipse(x, y, rx, ry, 0, startAngle, endAngle, anticlockwise);
    if (fillStyle != null) {
        context.fillStyle = fillStyle;
        context.fill();
    }
    if (strokeStyle != null) {
        context.strokeStyle = strokeStyle;
        context.lineWidth = lineWidth;
        context.stroke();
    }
};
var $c611d46754e737fd$export$2e2bcd8739ae039 = $c611d46754e737fd$var$DrawCircle;


var $f1064b0aabf7a8f1$var$DrawText = function(canvas, context, x, y, text, font, fillStyle, strokeStyle, lineWidth, textAlign, textBaseline) {
    if (lineWidth === undefined && strokeStyle != null) lineWidth = 2;
    if (textAlign === undefined) textAlign = "start";
    if (textBaseline === undefined) textBaseline = "alphabetic";
    context.font = font;
    context.textAlign = textAlign;
    context.textBaseline = textBaseline;
    context.fillStyle = fillStyle;
    context.strokeStyle = strokeStyle;
    context.lineWidth = lineWidth;
    context.lineCap = "round";
    context.lineJoin = "round";
    if (strokeStyle != null && strokeStyle !== "none" && lineWidth > 0) context.strokeText(text, x, y);
    if (fillStyle != null && fillStyle !== "none") context.fillText(text, x, y);
};
var $f1064b0aabf7a8f1$export$2e2bcd8739ae039 = $f1064b0aabf7a8f1$var$DrawText;


var $16a7173d64ec9b18$var$DrawContent = function() {
    var x = this.radius;
    var lineWidth = this.thickness * this.radius;
    var barRadius = this.radius - lineWidth / 2;
    var centerRadius = this.radius - lineWidth;
    var canvas = this.canvas, context = this.context;
    // Draw track
    if (this.trackColor && lineWidth > 0) {
        context.save();
        (0, $c611d46754e737fd$export$2e2bcd8739ae039)(canvas, context, x, x, barRadius, barRadius, undefined, this.trackColor, lineWidth);
        context.restore();
    }
    // Draw bar
    if (this.barColor && barRadius > 0) {
        var anticlockwise, startAngle, endAngle;
        if (this.value === 1) {
            anticlockwise = false;
            startAngle = 0;
            endAngle = 2 * Math.PI;
        } else {
            anticlockwise = this.anticlockwise;
            startAngle = this.startAngle;
            var deltaAngle = 2 * Math.PI * (anticlockwise ? 1 - this.value : this.value);
            endAngle = deltaAngle + startAngle;
        }
        context.save();
        (0, $c611d46754e737fd$export$2e2bcd8739ae039)(canvas, context, x, x, barRadius, barRadius, undefined, this.barColor, lineWidth, startAngle, endAngle, anticlockwise);
        context.restore();
    }
    // Draw center
    if (this.centerColor && centerRadius > 0) {
        var fillStyle;
        if (this.centerColor2) {
            fillStyle = this.context.createRadialGradient(x, x, 0, x, x, centerRadius);
            fillStyle.addColorStop(0, this.centerColor);
            fillStyle.addColorStop(1, this.centerColor2);
        } else fillStyle = this.centerColor;
        context.save();
        (0, $c611d46754e737fd$export$2e2bcd8739ae039)(canvas, context, x, x, centerRadius, centerRadius, fillStyle);
        context.restore();
    }
    // Draw text
    if (this.textFormatCallback && (this.textColor || this.textStrokeColor)) {
        context.save();
        (0, $f1064b0aabf7a8f1$export$2e2bcd8739ae039)(canvas, context, x, x, this.getFormatText(), this.textFont, this.textColor, this.textStrokeColor, this.textStrokeThickness, "center", "middle" // textBaseline
        );
        context.restore();
    }
};
var $16a7173d64ec9b18$export$2e2bcd8739ae039 = $16a7173d64ec9b18$var$DrawContent;


const $13a05aaa68611033$var$GetValue = Phaser.Utils.Objects.GetValue;
const $13a05aaa68611033$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $13a05aaa68611033$var$Clamp = Phaser.Math.Clamp;
const $13a05aaa68611033$var$DefaultStartAngle = Phaser.Math.DegToRad(270);
class $13a05aaa68611033$var$CircularProgress extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $3842bed83c6c142c$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, radius, barColor, value, config){
        if ($13a05aaa68611033$var$IsPlainObject(x)) {
            config = x;
            x = $13a05aaa68611033$var$GetValue(config, "x", 0);
            y = $13a05aaa68611033$var$GetValue(config, "y", 0);
            radius = $13a05aaa68611033$var$GetValue(config, "radius", 1);
            barColor = $13a05aaa68611033$var$GetValue(config, "barColor", undefined);
            value = $13a05aaa68611033$var$GetValue(config, "value", 0);
        }
        var width = radius * 2;
        super(scene, x, y, width, width);
        this.type = "rexCircularProgressCanvas";
        this.bootProgressBase(config);
        this.setRadius(radius);
        this.setTrackColor($13a05aaa68611033$var$GetValue(config, "trackColor", undefined));
        this.setBarColor(barColor);
        this.setCenterColor($13a05aaa68611033$var$GetValue(config, "centerColor", undefined));
        this.setThickness($13a05aaa68611033$var$GetValue(config, "thickness", 0.2));
        this.setStartAngle($13a05aaa68611033$var$GetValue(config, "startAngle", $13a05aaa68611033$var$DefaultStartAngle));
        this.setAnticlockwise($13a05aaa68611033$var$GetValue(config, "anticlockwise", false));
        this.setTextColor($13a05aaa68611033$var$GetValue(config, "textColor", undefined));
        this.setTextStrokeColor($13a05aaa68611033$var$GetValue(config, "textStrokeColor", undefined), $13a05aaa68611033$var$GetValue(config, "textStrokeThickness", undefined));
        var textFont = $13a05aaa68611033$var$GetValue(config, "textFont", undefined);
        if (textFont) this.setTextFont(textFont);
        else this.setTextFont($13a05aaa68611033$var$GetValue(config, "textSize", "16px"), $13a05aaa68611033$var$GetValue(config, "textFamily", "Courier"), $13a05aaa68611033$var$GetValue(config, "textStyle", ""));
        this.setTextFormatCallback($13a05aaa68611033$var$GetValue(config, "textFormatCallback", undefined), $13a05aaa68611033$var$GetValue(config, "textFormatCallbackScope", undefined));
        this.setValue(value);
    }
    resize(width, height) {
        width = Math.floor(Math.min(width, height));
        if (width === this.width) return this;
        super.resize(width, width);
        this.setRadius(width / 2);
        return this;
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this.dirty = this.dirty || this._radius != value;
        this._radius = value;
        var width = value * 2;
        this.resize(width, width);
    }
    setRadius(radius) {
        this.radius = radius;
        return this;
    }
    get trackColor() {
        return this._trackColor;
    }
    set trackColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._trackColor != value;
        this._trackColor = value;
    }
    setTrackColor(color) {
        this.trackColor = color;
        return this;
    }
    get barColor() {
        return this._barColor;
    }
    set barColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._barColor != value;
        this._barColor = value;
    }
    setBarColor(color) {
        this.barColor = color;
        return this;
    }
    get startAngle() {
        return this._startAngle;
    }
    set startAngle(value) {
        this.dirty = this.dirty || this._startAngle != value;
        this._startAngle = value;
    }
    setStartAngle(angle) {
        this.startAngle = angle;
        return this;
    }
    get anticlockwise() {
        return this._anticlockwise;
    }
    set anticlockwise(value) {
        this.dirty = this.dirty || this._anticlockwise != value;
        this._anticlockwise = value;
    }
    setAnticlockwise(anticlockwise) {
        if (anticlockwise === undefined) anticlockwise = true;
        this.anticlockwise = anticlockwise;
        return this;
    }
    get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        value = $13a05aaa68611033$var$Clamp(value, 0, 1);
        this.dirty = this.dirty || this._thickness != value;
        this._thickness = value;
    }
    setThickness(thickness) {
        this.thickness = thickness;
        return this;
    }
    get centerColor() {
        return this._centerColor;
    }
    set centerColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._centerColor != value;
        this._centerColor = value;
    }
    get centerColor2() {
        return this._centerColor2;
    }
    set centerColor2(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._centerColor2 != value;
        this._centerColor2 = value;
    }
    setCenterColor(color, color2) {
        this.centerColor = color;
        this.centerColor2 = color2;
        return this;
    }
    get textColor() {
        return this._textColor;
    }
    set textColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._textColor != value;
        this._textColor = value;
    }
    setTextColor(color) {
        this.textColor = color;
        return this;
    }
    get textStrokeColor() {
        return this._textStrokeColor;
    }
    set textStrokeColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._textStrokeColor != value;
        this._textStrokeColor = value;
    }
    get textStrokeThickness() {
        return this._textStrokeThickness;
    }
    set textStrokeThickness(value) {
        this.dirty = this.dirty || this._textStrokeThickness != value;
        this._textStrokeThickness = value;
    }
    setTextStrokeColor(color, thickness) {
        if (thickness === undefined) thickness = 2;
        this.textStrokeColor = color;
        this.textStrokeThickness = thickness;
        return this;
    }
    get textFont() {
        return this._textFont;
    }
    set textFont(value) {
        this.dirty = this.dirty || this._textFont != value;
        this._textFont = value;
    }
    setTextFont(fontSize, fontFamily, fontStyle) {
        var font;
        if (fontFamily === undefined) font = fontSize;
        else font = fontStyle + " " + fontSize + " " + fontFamily;
        this.textFont = font;
        return this;
    }
    setTextFormatCallback(callback, scope) {
        this.textFormatCallback = callback;
        this.textFormatCallbackScope = scope;
        return this;
    }
    updateTexture() {
        this.clear();
        (0, $16a7173d64ec9b18$export$2e2bcd8739ae039).call(this);
        super.updateTexture();
        return this;
    }
    getFormatText(value) {
        if (value === undefined) value = this.value;
        var text;
        if (this.textFormatCallbackScope) text = this.textFormatCallback(value);
        else text = this.textFormatCallback.call(this.textFormatCallbackScope, value);
        return text;
    }
}
var $13a05aaa68611033$export$2e2bcd8739ae039 = $13a05aaa68611033$var$CircularProgress;


var $86933cada44f1b04$export$2e2bcd8739ae039 = (0, $13a05aaa68611033$export$2e2bcd8739ae039);


var $6119752de8eb7a22$export$2e2bcd8739ae039 = (0, $86933cada44f1b04$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("circularProgressCanvas", function(x, y, radius, barColor, value, config) {
    var gameObject = new (0, $6119752de8eb7a22$export$2e2bcd8739ae039)(this.scene, x, y, radius, barColor, value, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CircularProgressCanvas", (0, $6119752de8eb7a22$export$2e2bcd8739ae039));
var $b1dfd3c74e27cf19$export$2e2bcd8739ae039 = (0, $6119752de8eb7a22$export$2e2bcd8739ae039);





var $22f2c66b623bd72c$var$UpdateShapes = function() {
    var skewX = this.skewX;
    var width = this.width - Math.abs(skewX);
    var height = this.height;
    var trackFill = this.getShape("trackFill");
    trackFill.fillStyle(this.trackColor);
    if (trackFill.isFilled) $22f2c66b623bd72c$var$BuildRectangle(trackFill, 0, 0, width, height, skewX // skewX
    ).close();
    var bar = this.getShape("bar");
    bar.fillStyle(this.barColor);
    if (bar.isFilled) {
        var barX0, barX1;
        if (!this.rtl) {
            barX0 = 0;
            barX1 = width * this.value;
        } else {
            barX0 = width * (1 - this.value);
            barX1 = width;
        }
        $22f2c66b623bd72c$var$BuildRectangle(bar, barX0, 0, barX1, height, skewX // skew
        ).close();
    }
    var trackStroke = this.getShape("trackStroke");
    trackStroke.lineStyle(this.trackStrokeThickness, this.trackStrokeColor);
    if (trackStroke.isStroked) $22f2c66b623bd72c$var$BuildRectangle(trackStroke, 0, 0, width, height, skewX // skewX
    ).end();
};
var $22f2c66b623bd72c$var$BuildRectangle = function(lines, x0, y0, x1, y1, skewX) {
    if (skewX >= 0) lines.startAt(x0 + skewX, y0).lineTo(x1 + skewX, y0).lineTo(x1, y1).lineTo(x0, y1).lineTo(x0 + skewX, y0);
    else lines.startAt(x0, y0).lineTo(x1, y0).lineTo(x1 - skewX, y1).lineTo(x0 - skewX, y1).lineTo(x0, y0);
    return lines;
};
var $22f2c66b623bd72c$export$2e2bcd8739ae039 = $22f2c66b623bd72c$var$UpdateShapes;


const $a182a11d4e4226e6$var$GetValue = Phaser.Utils.Objects.GetValue;
const $a182a11d4e4226e6$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $a182a11d4e4226e6$var$LineProgress extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $fa309bb54d70b13f$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, width, height, barColor, value, config){
        if ($a182a11d4e4226e6$var$IsPlainObject(x)) {
            config = x;
            x = $a182a11d4e4226e6$var$GetValue(config, "x", 0);
            y = $a182a11d4e4226e6$var$GetValue(config, "y", 0);
            width = $a182a11d4e4226e6$var$GetValue(config, "width", 2);
            height = $a182a11d4e4226e6$var$GetValue(config, "height", 2);
            barColor = $a182a11d4e4226e6$var$GetValue(config, "barColor", undefined);
            value = $a182a11d4e4226e6$var$GetValue(config, "value", 0);
        } else if ($a182a11d4e4226e6$var$IsPlainObject(width)) {
            config = width;
            width = $a182a11d4e4226e6$var$GetValue(config, "width", 2);
            height = $a182a11d4e4226e6$var$GetValue(config, "height", 2);
            barColor = $a182a11d4e4226e6$var$GetValue(config, "barColor", undefined);
            value = $a182a11d4e4226e6$var$GetValue(config, "value", 0);
        } else if ($a182a11d4e4226e6$var$IsPlainObject(barColor)) {
            config = barColor;
            barColor = $a182a11d4e4226e6$var$GetValue(config, "barColor", undefined);
            value = $a182a11d4e4226e6$var$GetValue(config, "value", 0);
        }
        super(scene, x, y, width, height, config);
        this.type = "rexLineProgress";
        this.bootProgressBase(config);
        this.addShape(new (0, $1e62846ec481ae38$export$2e2bcd8739ae039)().setName("trackFill")).addShape(new (0, $1e62846ec481ae38$export$2e2bcd8739ae039)().setName("bar")).addShape(new (0, $1e62846ec481ae38$export$2e2bcd8739ae039)().setName("trackStroke"));
        this.setTrackColor($a182a11d4e4226e6$var$GetValue(config, "trackColor", undefined));
        this.setBarColor(barColor);
        this.setTrackStroke($a182a11d4e4226e6$var$GetValue(config, "trackStrokeThickness", 2), $a182a11d4e4226e6$var$GetValue(config, "trackStrokeColor", undefined));
        this.setSkewX($a182a11d4e4226e6$var$GetValue(config, "skewX", 0));
        this.setRTL($a182a11d4e4226e6$var$GetValue(config, "rtl", false));
        this.setValue(value);
    }
    get trackColor() {
        return this._trackColor;
    }
    set trackColor(value) {
        this.dirty = this.dirty || this._trackColor != value;
        this._trackColor = value;
    }
    setTrackColor(color) {
        this.trackColor = color;
        return this;
    }
    get trackStrokeColor() {
        return this._trackStrokeColor;
    }
    set trackStrokeColor(value) {
        this.dirty = this.dirty || this._trackStrokeColor != value;
        this._trackStrokeColor = value;
    }
    get trackStrokeThickness() {
        return this._trackStrokeThickness;
    }
    set trackStrokeThickness(value) {
        this.dirty = this.dirty || this._trackStrokeThickness != value;
        this._trackStrokeThickness = value;
    }
    setTrackStroke(lineWidth, color) {
        this.trackStrokeThickness = lineWidth;
        this.trackStrokeColor = color;
        return this;
    }
    get barColor() {
        return this._barColor;
    }
    set barColor(value) {
        this.dirty = this.dirty || this._barColor != value;
        this._barColor = value;
    }
    setBarColor(color) {
        this.barColor = color;
        return this;
    }
    get skewX() {
        return this._skewX;
    }
    set skewX(value) {
        this.dirty = this.dirty || this._skewX != value;
        this._skewX = value;
    }
    setSkewX(value) {
        this.skewX = value;
        return this;
    }
    get rtl() {
        return this._rtl;
    }
    set rtl(value) {
        value = !!value;
        this.dirty = this.dirty || this._rtl != value;
        this._rtl = value;
    }
    setRTL(enable) {
        if (enable === undefined) enable = true;
        this.rtl = enable;
        return this;
    }
}
var $a182a11d4e4226e6$var$Methods = {
    updateShapes: (0, $22f2c66b623bd72c$export$2e2bcd8739ae039)
};
Object.assign($a182a11d4e4226e6$var$LineProgress.prototype, $a182a11d4e4226e6$var$Methods);
var $a182a11d4e4226e6$export$2e2bcd8739ae039 = $a182a11d4e4226e6$var$LineProgress;


var $ff45cf7fe83476dc$export$2e2bcd8739ae039 = (0, $a182a11d4e4226e6$export$2e2bcd8739ae039);


var $5e23d65a6225dbac$export$2e2bcd8739ae039 = (0, $ff45cf7fe83476dc$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("lineProgress", function(x, y, width, height, barColor, value, config) {
    var gameObject = new (0, $5e23d65a6225dbac$export$2e2bcd8739ae039)(this.scene, x, y, width, height, barColor, value, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.LineProgress", (0, $5e23d65a6225dbac$export$2e2bcd8739ae039));
var $4aa2da707696ed7c$export$2e2bcd8739ae039 = (0, $5e23d65a6225dbac$export$2e2bcd8739ae039);





var $14cc0acc39e27970$var$AddPolygonPath = function(context, points) {
    context.save();
    context.beginPath();
    var point = points[0];
    context.moveTo(point.x, point.y);
    for(var i = 1, cnt = points.length; i < cnt; i++){
        point = points[i];
        context.lineTo(point.x, point.y);
    }
    context.closePath();
    context.restore();
};
var $14cc0acc39e27970$export$2e2bcd8739ae039 = $14cc0acc39e27970$var$AddPolygonPath;


var $0a2b5f91aa3f88a5$var$DrawPolygon = function(canvas, context, points, fillStyle, strokeStyle, lineWidth, lineJoin) {
    if (lineJoin === undefined) lineJoin = "round";
    (0, $14cc0acc39e27970$export$2e2bcd8739ae039)(context, points);
    context.lineJoin = lineJoin;
    if (fillStyle != null) {
        context.fillStyle = fillStyle;
        context.fill();
    }
    if (strokeStyle != null) {
        context.strokeStyle = strokeStyle;
        context.lineWidth = lineWidth;
        context.stroke();
    }
};
var $0a2b5f91aa3f88a5$export$2e2bcd8739ae039 = $0a2b5f91aa3f88a5$var$DrawPolygon;


var $f9b66c84729180f8$var$DrawContent = function() {
    var skewX = this.skewX;
    var width = this.width - Math.abs(skewX);
    var height = this.height;
    var canvas = this.canvas, context = this.context;
    // Has track
    if (this.trackColor || this.trackStrokeColor) $f9b66c84729180f8$var$BuildPolygon(0, 0, width, height, skewX, this.trackPoints);
    // Has bar
    var barX0, barX1;
    if (this.barColor) {
        if (!this.rtl) {
            barX0 = 0;
            barX1 = width * this.value;
        } else {
            barX0 = width * (1 - this.value);
            barX1 = width;
        }
        $f9b66c84729180f8$var$BuildPolygon(barX0, 0, barX1, height, skewX, this.barPoints);
    }
    if (this.trackColor) {
        context.save();
        (0, $0a2b5f91aa3f88a5$export$2e2bcd8739ae039)(canvas, context, this.trackPoints, this.trackColor);
        context.restore();
    }
    if (this.barColor) {
        context.save();
        var style;
        if (this.barColor2) {
            var grd;
            if (this.isHorizontalGradient) {
                var helfHeight = height / 2;
                grd = context.createLinearGradient(barX0, helfHeight, barX1, helfHeight);
            } else {
                var helfWidth = width / 2;
                grd = context.createLinearGradient(helfWidth, 0, helfWidth, height);
            }
            grd.addColorStop(0, this.rtl ? this.barColor : this.barColor2);
            grd.addColorStop(1, this.rtl ? this.barColor2 : this.barColor);
            style = grd;
        } else style = this.barColor;
        (0, $0a2b5f91aa3f88a5$export$2e2bcd8739ae039)(canvas, context, this.barPoints, style);
        context.restore();
    }
    if (this.trackStrokeColor && this.trackStrokeThickness > 0) {
        context.save();
        (0, $0a2b5f91aa3f88a5$export$2e2bcd8739ae039)(canvas, context, this.trackPoints, undefined, this.trackStrokeColor, this.trackStrokeThickness);
        context.restore();
    }
};
var $f9b66c84729180f8$var$BuildPolygon = function(x0, y0, x1, y1, skewX, out) {
    if (out === undefined) out = [];
    out.length = 4;
    for(var i = 0; i < 4; i++)if (!out[i]) out[i] = {};
    var p;
    if (skewX >= 0) {
        p = out[0];
        p.x = x0 + skewX;
        p.y = y0;
        p = out[1];
        p.x = x1 + skewX;
        p.y = y0;
        p = out[2];
        p.x = x1;
        p.y = y1;
        p = out[3];
        p.x = x0;
        p.y = y1;
    } else {
        p = out[0];
        p.x = x0;
        p.y = y0;
        p = out[1];
        p.x = x1;
        p.y = y0;
        p = out[2];
        p.x = x1 - skewX;
        p.y = y1;
        p = out[3];
        p.x = x0 - skewX;
        p.y = y1;
    }
    return out;
};
var $f9b66c84729180f8$export$2e2bcd8739ae039 = $f9b66c84729180f8$var$DrawContent;


const $2b258d5189fc281e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $2b258d5189fc281e$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $2b258d5189fc281e$var$LineProgress extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $3842bed83c6c142c$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, width, height, barColor, value, config){
        if ($2b258d5189fc281e$var$IsPlainObject(x)) {
            config = x;
            x = $2b258d5189fc281e$var$GetValue(config, "x", 0);
            y = $2b258d5189fc281e$var$GetValue(config, "y", 0);
            width = $2b258d5189fc281e$var$GetValue(config, "width", 2);
            height = $2b258d5189fc281e$var$GetValue(config, "height", 2);
            barColor = $2b258d5189fc281e$var$GetValue(config, "barColor", undefined);
            value = $2b258d5189fc281e$var$GetValue(config, "value", 0);
        } else if ($2b258d5189fc281e$var$IsPlainObject(width)) {
            config = width;
            width = $2b258d5189fc281e$var$GetValue(config, "width", 2);
            height = $2b258d5189fc281e$var$GetValue(config, "height", 2);
            barColor = $2b258d5189fc281e$var$GetValue(config, "barColor", undefined);
            value = $2b258d5189fc281e$var$GetValue(config, "value", 0);
        } else if ($2b258d5189fc281e$var$IsPlainObject(barColor)) {
            config = barColor;
            barColor = $2b258d5189fc281e$var$GetValue(config, "barColor", undefined);
            value = $2b258d5189fc281e$var$GetValue(config, "value", 0);
        }
        super(scene, x, y, width, height);
        this.type = "rexLineProgressCanvas";
        this.trackPoints = [];
        this.barPoints = [];
        this.bootProgressBase(config);
        this.setTrackColor($2b258d5189fc281e$var$GetValue(config, "trackColor", undefined));
        this.setBarColor(barColor, $2b258d5189fc281e$var$GetValue(config, "barColor2", undefined), $2b258d5189fc281e$var$GetValue(config, "isHorizontalGradient", undefined));
        this.setTrackStroke($2b258d5189fc281e$var$GetValue(config, "trackStrokeThickness", 2), $2b258d5189fc281e$var$GetValue(config, "trackStrokeColor", undefined));
        this.setSkewX($2b258d5189fc281e$var$GetValue(config, "skewX", 0));
        this.setRTL($2b258d5189fc281e$var$GetValue(config, "rtl", false));
        this.setValue(value);
    }
    get trackColor() {
        return this._trackColor;
    }
    set trackColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._trackColor != value;
        this._trackColor = value;
    }
    setTrackColor(color) {
        this.trackColor = color;
        return this;
    }
    get trackStrokeColor() {
        return this._trackStrokeColor;
    }
    set trackStrokeColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._trackStrokeColor != value;
        this._trackStrokeColor = value;
    }
    get trackStrokeThickness() {
        return this._trackStrokeThickness;
    }
    set trackStrokeThickness(value) {
        this.dirty = this.dirty || this._trackStrokeThickness != value;
        this._trackStrokeThickness = value;
    }
    setTrackStroke(lineWidth, color) {
        this.trackStrokeThickness = lineWidth;
        this.trackStrokeColor = color;
        return this;
    }
    get barColor() {
        return this._barColor;
    }
    set barColor(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._barColor != value;
        this._barColor = value;
    }
    get barColor2() {
        return this._barColor2;
    }
    set barColor2(value) {
        value = (0, $cc1ef7664a70c92f$export$2e2bcd8739ae039)(value, this.canvas, this.context);
        this.dirty = this.dirty || this._barColor2 != value;
        this._barColor2 = value;
    }
    get isHorizontalGradient() {
        return this._isHorizontalGradient;
    }
    set isHorizontalGradient(value) {
        this.dirty |= this._isHorizontalGradient != value;
        this._isHorizontalGradient = value;
    }
    setBarColor(color, color2, isHorizontalGradient) {
        if (isHorizontalGradient === undefined) isHorizontalGradient = true;
        this.barColor = color;
        this.barColor2 = color2;
        this.isHorizontalGradient = isHorizontalGradient;
        return this;
    }
    get skewX() {
        return this._skewX;
    }
    set skewX(value) {
        this.dirty = this.dirty || this._skewX != value;
        this._skewX = value;
    }
    setSkewX(value) {
        this.skewX = value;
        return this;
    }
    get rtl() {
        return this._rtl;
    }
    set rtl(value) {
        value = !!value;
        this.dirty = this.dirty || this._rtl != value;
        this._rtl = value;
    }
    setRTL(enable) {
        if (enable === undefined) enable = true;
        this.rtl = enable;
        return this;
    }
    updateTexture() {
        this.clear();
        (0, $f9b66c84729180f8$export$2e2bcd8739ae039).call(this);
        super.updateTexture();
        return this;
    }
}
var $2b258d5189fc281e$export$2e2bcd8739ae039 = $2b258d5189fc281e$var$LineProgress;


var $081a51404b623712$export$2e2bcd8739ae039 = (0, $2b258d5189fc281e$export$2e2bcd8739ae039);


var $bcbd612c21a81a48$export$2e2bcd8739ae039 = (0, $081a51404b623712$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("circularProgressCanvas", function(x, y, width, height, barColor, value, config) {
    var gameObject = new (0, $bcbd612c21a81a48$export$2e2bcd8739ae039)(this.scene, x, y, width, height, barColor, value, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.LineProgressCanvas", (0, $bcbd612c21a81a48$export$2e2bcd8739ae039));
var $e8fe1e3328c554d4$export$2e2bcd8739ae039 = (0, $bcbd612c21a81a48$export$2e2bcd8739ae039);




const $f5e82967de0c76cd$var$Wrap = Phaser.Math.Wrap;
const $f5e82967de0c76cd$var$Linear = Phaser.Math.Linear;
var $f5e82967de0c76cd$var$DrawFitTriangle = function() {
    var triangle = this.getShape("triangle");
    var padding = this.padding;
    var right = this.width - padding.right;
    var left = 0 + padding.left;
    var bottom = this.height - padding.bottom;
    var top = 0 + padding.top;
    var centerX = (left + right) / 2;
    var centerY = (top + bottom) / 2;
    var points = {
        0: {
            a: {
                x: left,
                y: top
            },
            b: {
                x: right,
                y: centerY
            },
            c: {
                x: left,
                y: bottom
            }
        },
        1: {
            a: {
                x: left,
                y: top
            },
            b: {
                x: centerX,
                y: bottom
            },
            c: {
                x: right,
                y: top
            }
        },
        2: {
            a: {
                x: right,
                y: top
            },
            b: {
                x: left,
                y: centerY
            },
            c: {
                x: right,
                y: bottom
            }
        },
        3: {
            a: {
                x: left,
                y: bottom
            },
            b: {
                x: centerX,
                y: top
            },
            c: {
                x: right,
                y: bottom
            }
        }
    };
    var pax, pay, pbx, pby, pcx, pcy;
    if (this.previousDirection === undefined) {
        var currentTrianglePoints = points[this.direction];
        var pa = currentTrianglePoints.a, pb = currentTrianglePoints.b, pc = currentTrianglePoints.c;
        pax = pa.x;
        pay = pa.y;
        pbx = pb.x;
        pby = pb.y;
        pcx = pc.x;
        pcy = pc.y;
    } else {
        var p0 = points[this.previousDirection];
        var p1 = points[this.direction];
        var t = this.easeDirectionProgress;
        pax = $f5e82967de0c76cd$var$Linear(p0.a.x, p1.a.x, t);
        pay = $f5e82967de0c76cd$var$Linear(p0.a.y, p1.a.y, t);
        pbx = $f5e82967de0c76cd$var$Linear(p0.b.x, p1.b.x, t);
        pby = $f5e82967de0c76cd$var$Linear(p0.b.y, p1.b.y, t);
        pcx = $f5e82967de0c76cd$var$Linear(p0.c.x, p1.c.x, t);
        pcy = $f5e82967de0c76cd$var$Linear(p0.c.y, p1.c.y, t);
    }
    triangle.startAt(pax, pay).lineTo(pbx, pby).lineTo(pcx, pcy);
    if (!this.arrowOnly) triangle.close();
    else triangle.end();
};
var $f5e82967de0c76cd$export$2e2bcd8739ae039 = $f5e82967de0c76cd$var$DrawFitTriangle;


const $9605b78024a46712$var$DegToRad = Phaser.Math.DegToRad;
const $9605b78024a46712$var$Rad120 = $9605b78024a46712$var$DegToRad(120);
var $9605b78024a46712$var$DrawCircleVerticesTriangle = function(triangle) {
    var triangle = this.getShape("triangle");
    var centerX = this.width / 2, centerY = this.height / 2;
    var radius = Math.min(centerX, centerY) * this.radius, verticeRotation = this.verticeRotation;
    triangle.startAt(centerX + radius * Math.cos(verticeRotation + $9605b78024a46712$var$Rad120), centerY + radius * Math.sin(verticeRotation + $9605b78024a46712$var$Rad120)).lineTo(centerX + radius * Math.cos(verticeRotation), centerY + radius * Math.sin(verticeRotation)).lineTo(centerX + radius * Math.cos(verticeRotation - $9605b78024a46712$var$Rad120), centerY + radius * Math.sin(verticeRotation - $9605b78024a46712$var$Rad120));
    if (!this.arrowOnly) triangle.close();
    else triangle.end();
};
var $9605b78024a46712$export$2e2bcd8739ae039 = $9605b78024a46712$var$DrawCircleVerticesTriangle;


var $8930065b0348d39d$export$2e2bcd8739ae039 = {
    buildShapes () {
        this.addShape(new (0, $1e62846ec481ae38$export$2e2bcd8739ae039)().setName("triangle"));
    },
    updateShapes () {
        // Set style
        var triangle = this.getShape("triangle");
        if (!this.arrowOnly) triangle.fillStyle(this.fillColor, this.fillAlpha).lineStyle(this.lineWidth, this.strokeColor, this.strokeAlpha);
        else triangle.fillStyle().lineStyle(this.lineWidth, this.strokeColor, this.strokeAlpha);
        // Set points
        if (this.shapeMode === 0) (0, $f5e82967de0c76cd$export$2e2bcd8739ae039).call(this);
        else (0, $9605b78024a46712$export$2e2bcd8739ae039).call(this);
    }
};



var $d0c27922fce823fd$export$2e2bcd8739ae039 = {
    setEaseDuration (duration) {
        if (duration === undefined) duration = 0;
        this.easeDuration = duration;
        return this;
    },
    playEaseDirectionation () {
        if (this.easeDirectionProgressTask === undefined) this.easeDirectionProgressTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
            eventEmitter: null
        });
        this.easeDirectionProgressTask.restart({
            key: "easeDirectionProgress",
            from: 0,
            to: 1,
            duration: this.easeDuration
        });
        return this;
    },
    stopEaseDirection () {
        if (this.easeDirectionProgressTask === undefined) return this;
        this.easeDirectionProgressTask.stop();
        return this;
    }
};


const $30637997ce06ea9b$var$GetValue = Phaser.Utils.Objects.GetValue;
const $30637997ce06ea9b$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $30637997ce06ea9b$var$DegToRad = Phaser.Math.DegToRad;
const $30637997ce06ea9b$var$RadToDeg = Phaser.Math.RadToDeg;
class $30637997ce06ea9b$var$Triangle extends (0, $fa309bb54d70b13f$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, fillColor, fillAlpha){
        var strokeColor, strokeAlpha, strokeWidth, arrowOnly;
        var direction, easeDuration, padding;
        var radius;
        if ($30637997ce06ea9b$var$IsPlainObject(x)) {
            var config = x;
            x = config.x;
            y = config.y;
            width = config.width;
            height = config.height;
            fillColor = config.color;
            fillAlpha = config.alpha;
            strokeColor = config.strokeColor;
            strokeAlpha = config.strokeAlpha;
            strokeWidth = config.strokeWidth;
            arrowOnly = config.arrowOnly;
            direction = config.direction;
            easeDuration = config.easeDuration;
            padding = config.padding;
            radius = config.radius;
        }
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 1;
        if (height === undefined) height = width;
        if (arrowOnly === undefined) arrowOnly = false;
        if (direction === undefined) direction = 0;
        if (easeDuration === undefined) easeDuration = 0;
        if (padding === undefined) padding = 0;
        if (radius === undefined) radius = undefined;
        super(scene, x, y, width, height);
        this.type = "rexTriangle";
        this.setFillStyle(fillColor, fillAlpha);
        if (strokeColor !== undefined && strokeWidth === undefined) strokeWidth = 2;
        this.setStrokeStyle(strokeWidth, strokeColor, strokeAlpha);
        this.setArrowOnly(arrowOnly);
        this.setDirection(direction, easeDuration);
        this.setPadding(padding);
        this.setRadius(radius);
        this.buildShapes();
    }
    get arrowOnly() {
        return this._arrowOnly;
    }
    set arrowOnly(value) {
        this.dirty = this.dirty || this._arrowOnly != value;
        this._arrowOnly = value;
    }
    setArrowOnly(enable) {
        if (enable === undefined) enable = true;
        this.arrowOnly = enable;
        return this;
    }
    get direction() {
        return this._direction;
    }
    set direction(value) {
        value = $30637997ce06ea9b$var$ParseDirection(value);
        if (this._direction === value) return;
        if (this.easeDuration > 0 && this._direction !== undefined) this.previousDirection = this._direction;
        else this.previousDirection = undefined;
        this._direction = value;
        this.verticeAngle = value * 90;
        this.dirty = true;
        if (this.previousDirection !== undefined) this.playEaseDirectionation();
        else this.stopEaseDirection();
    }
    setDirection(direction, easeDuration) {
        if (easeDuration !== undefined) this.setEaseDuration(easeDuration);
        this.direction = direction;
        return this;
    }
    toggleDirection(easeDuration) {
        this.setDirection(this.direction + 2, easeDuration);
        return this;
    }
    get easeDirectionProgress() {
        return this._easeDirectionProgress;
    }
    set easeDirectionProgress(value) {
        if (this._easeDirectionProgress === value) return;
        this._easeDirectionProgress = value;
        this.dirty = true;
    }
    setPadding(left, top, right, bottom) {
        if (typeof left === "object") {
            var config = left;
            //  If they specify x and/or y this applies to all
            var x = $30637997ce06ea9b$var$GetValue(config, "x", null);
            if (x !== null) {
                left = x;
                right = x;
            } else {
                left = $30637997ce06ea9b$var$GetValue(config, "left", 0);
                right = $30637997ce06ea9b$var$GetValue(config, "right", left);
            }
            var y = $30637997ce06ea9b$var$GetValue(config, "y", null);
            if (y !== null) {
                top = y;
                bottom = y;
            } else {
                top = $30637997ce06ea9b$var$GetValue(config, "top", 0);
                bottom = $30637997ce06ea9b$var$GetValue(config, "bottom", top);
            }
        } else {
            if (left === undefined) left = 0;
            if (top === undefined) top = left;
            if (right === undefined) right = left;
            if (bottom === undefined) bottom = top;
        }
        if (this.padding === undefined) this.padding = {};
        this.dirty = this.dirty || this.padding.left != left || this.padding.top != top || this.padding.right != right || this.padding.bottom != bottom;
        this.padding.left = left;
        this.padding.top = top;
        this.padding.right = right;
        this.padding.bottom = bottom;
        // Switch to fit mode
        this.setRadius();
        return this;
    }
    get radius() {
        return this._radius;
    }
    set radius(value) {
        this.dirty = this.dirty || this._radius != value;
        this._radius = value;
    }
    setRadius(radius) {
        this.radius = radius;
        // 0: fit mode
        // 1: circle mode
        this.shapeMode = radius == null ? 0 : 1;
        return this;
    }
    get verticeRotation() {
        return this._verticeRotation;
    }
    set verticeRotation(value) {
        this.dirty = this.dirty || this._verticeRotation != value;
        this._verticeRotation = value;
    }
    setVerticeRotation(rotation) {
        this.verticeRotation = rotation;
        return this;
    }
    get verticeAngle() {
        return $30637997ce06ea9b$var$RadToDeg(this.verticeRotation);
    }
    set verticeAngle(value) {
        this.verticeRotation = $30637997ce06ea9b$var$DegToRad(value);
    }
    setVerticeAngle(angle) {
        this.verticeAngle = angle;
        return this;
    }
}
const $30637997ce06ea9b$var$DirectionNameMap = {
    right: 0,
    down: 1,
    left: 2,
    up: 3
};
var $30637997ce06ea9b$var$ParseDirection = function(direction) {
    if (typeof direction === "string") direction = $30637997ce06ea9b$var$DirectionNameMap[direction];
    direction = direction % 4;
    return direction;
};
Object.assign($30637997ce06ea9b$var$Triangle.prototype, (0, $8930065b0348d39d$export$2e2bcd8739ae039), (0, $d0c27922fce823fd$export$2e2bcd8739ae039));
var $30637997ce06ea9b$export$2e2bcd8739ae039 = $30637997ce06ea9b$var$Triangle;


var $9ec43f4ee6d1e990$export$2e2bcd8739ae039 = (0, $30637997ce06ea9b$export$2e2bcd8739ae039);


var $9e6ca4daafc103a2$export$2e2bcd8739ae039 = (0, $9ec43f4ee6d1e990$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("triangle", function(x, y, width, height, fillColor, fillAlpha) {
    var gameObject = new (0, $9e6ca4daafc103a2$export$2e2bcd8739ae039)(this.scene, x, y, width, height, fillColor, fillAlpha);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Triangle", (0, $9e6ca4daafc103a2$export$2e2bcd8739ae039));
var $319d471a56b99707$export$2e2bcd8739ae039 = (0, $9e6ca4daafc103a2$export$2e2bcd8739ae039);



var $f852d8af2af0c86f$export$2e2bcd8739ae039 = (0, $3799588e8b69e578$export$2e2bcd8739ae039);


var $c5e95e90a54f0634$export$2e2bcd8739ae039 = (0, $f852d8af2af0c86f$export$2e2bcd8739ae039);


var $69b2c83c99373b68$var$GetSizerConfig = function(gameObject) {
    if (!gameObject.hasOwnProperty("rexSizer")) gameObject.rexSizer = {};
    return gameObject.rexSizer;
};
var $69b2c83c99373b68$export$2e2bcd8739ae039 = $69b2c83c99373b68$var$GetSizerConfig;


function $1a1339e580bb462f$export$2e2bcd8739ae039(gameObject) {
    if (gameObject === undefined) gameObject = this;
    return (0, $69b2c83c99373b68$export$2e2bcd8739ae039)(gameObject);
}



var $0cfa3ee8e0eb5712$var$GetChildPrevState = function(child) {
    var childConfig = (0, $69b2c83c99373b68$export$2e2bcd8739ae039)(child);
    if (!childConfig.hasOwnProperty("prevState")) childConfig.prevState = {};
    return childConfig.prevState;
};
var $0cfa3ee8e0eb5712$export$2e2bcd8739ae039 = $0cfa3ee8e0eb5712$var$GetChildPrevState;



var $2a6f6536d00f92a0$var$PushIntoBounds = function(bounds) {
    if (bounds === undefined) bounds = (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(this.scene);
    this.left = Math.max(this.left, bounds.left);
    this.right = Math.min(this.right, bounds.right);
    this.top = Math.max(this.top, bounds.top);
    this.bottom = Math.min(this.bottom, bounds.bottom);
    return this;
};
var $2a6f6536d00f92a0$export$2e2bcd8739ae039 = $2a6f6536d00f92a0$var$PushIntoBounds;



var $519fe85d403be4ec$export$2e2bcd8739ae039 = (0, $e76743698f0ffd60$export$2e2bcd8739ae039);




const $dc4b283ca02f246c$var$GetValue = Phaser.Utils.Objects.GetValue;
const $dc4b283ca02f246c$var$Group = Phaser.GameObjects.Group;
var $dc4b283ca02f246c$var$DrawBounds = function(graphics, config) {
    var scene = graphics.scene;
    var color, lineWidth;
    var createTextCallback, createTextCallbackScope, textAlign;
    if (typeof config === "number") color = config;
    else {
        color = $dc4b283ca02f246c$var$GetValue(config, "color");
        lineWidth = $dc4b283ca02f246c$var$GetValue(config, "lineWidth");
        var nameTextConfig = $dc4b283ca02f246c$var$GetValue(config, "name", false);
        if (nameTextConfig) {
            createTextCallback = $dc4b283ca02f246c$var$GetValue(nameTextConfig, "createTextCallback", $dc4b283ca02f246c$var$DefaultCreateTextCallback);
            createTextCallbackScope = $dc4b283ca02f246c$var$GetValue(nameTextConfig, "createTextCallbackScope", undefined);
            textAlign = $dc4b283ca02f246c$var$GetValue(nameTextConfig, "align", "left-top");
            if (typeof textAlign === "string") textAlign = (0, $519fe85d403be4ec$export$2e2bcd8739ae039)[textAlign];
        }
    }
    if (color === undefined) color = 0xffffff;
    if (lineWidth === undefined) lineWidth = 1;
    if (createTextCallback && !graphics.children) {
        graphics.children = new $dc4b283ca02f246c$var$Group(scene);
        graphics.once("destroy", function(graphics, fromScene) {
            graphics.children.destroy(!fromScene);
            graphics.children = undefined;
        });
        var graphicsClear = graphics.clear.bind(graphics);
        graphics.clear = function() {
            graphicsClear();
            graphics.children.clear(false, true);
        };
    }
    var children = this.getAllShownChildren([
        this
    ]), child;
    var nameText;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.getBounds || child.width !== undefined && child.height !== undefined) $dc4b283ca02f246c$var$GlobRect = (0, $bf502811d69b7d21$export$a48dd0a2c64c17f2)(child, $dc4b283ca02f246c$var$GlobRect);
        else continue;
        if (color != null) graphics.lineStyle(lineWidth, color).strokeRectShape($dc4b283ca02f246c$var$GlobRect);
        if (child.name && createTextCallback) {
            if (createTextCallbackScope) nameText = createTextCallback.call(createTextCallbackScope, scene);
            else nameText = createTextCallback(scene);
            if (nameText) {
                nameText.setText(child.name);
                graphics.children.add(nameText);
                (0, $b7e28befb839484c$export$2e2bcd8739ae039)(nameText, $dc4b283ca02f246c$var$GlobRect.x, $dc4b283ca02f246c$var$GlobRect.y, $dc4b283ca02f246c$var$GlobRect.width, $dc4b283ca02f246c$var$GlobRect.height, textAlign);
            }
        }
    }
    return this;
};
var $dc4b283ca02f246c$var$DefaultCreateTextCallback = function(scene, child, childBoundsRect) {
    return scene.add.text(0, 0, "");
};
var $dc4b283ca02f246c$var$GlobRect = undefined;
var $dc4b283ca02f246c$export$2e2bcd8739ae039 = $dc4b283ca02f246c$var$DrawBounds;


const $bcec9459417c78b0$var$GetValue = Phaser.Utils.Objects.GetValue;
var $bcec9459417c78b0$var$GetBoundsConfig = function(config, out) {
    if (out === undefined) out = {};
    if (typeof config === "number") {
        out.left = config;
        out.right = config;
        out.top = config;
        out.bottom = config;
    } else {
        out.left = $bcec9459417c78b0$var$GetValue(config, "left", 0);
        out.right = $bcec9459417c78b0$var$GetValue(config, "right", 0);
        out.top = $bcec9459417c78b0$var$GetValue(config, "top", 0);
        out.bottom = $bcec9459417c78b0$var$GetValue(config, "bottom", 0);
    }
    return out;
};
var $bcec9459417c78b0$export$2e2bcd8739ae039 = $bcec9459417c78b0$var$GetBoundsConfig;


var $974f2fb082d06dfe$export$2e2bcd8739ae039 = (0, $bcec9459417c78b0$export$2e2bcd8739ae039);



const $6676609feda42dce$var$ContainerAdd = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039).prototype.add;
var $6676609feda42dce$var$AddChild = function(gameObject) {
    $6676609feda42dce$var$ContainerAdd.call(this, gameObject);
    if (this.sizerEventsEnable) {
        gameObject.emit("sizer.add", gameObject, this);
        this.emit("add", gameObject, this);
    }
    return this;
};
var $6676609feda42dce$export$2e2bcd8739ae039 = $6676609feda42dce$var$AddChild;


var $3b98bfa52f31c7dd$export$2e2bcd8739ae039 = {
    addBackground (gameObject, paddingConfig, childKey) {
        if (this.backgroundChildren === undefined) this.backgroundChildren = [];
        if (typeof paddingConfig === "string") {
            childKey = paddingConfig;
            paddingConfig = undefined;
        }
        if (paddingConfig === undefined) paddingConfig = 0;
        (0, $6676609feda42dce$export$2e2bcd8739ae039).call(this, gameObject);
        this.backgroundChildren.push(gameObject);
        var config = this.getSizerConfig(gameObject);
        config.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(paddingConfig);
        if (childKey !== undefined) this.addChildrenMap(childKey, gameObject);
        return this;
    },
    isBackground (gameObject) {
        if (this.backgroundChildren === undefined) return false;
        return this.backgroundChildren.indexOf(gameObject) !== -1;
    }
};



const $3af1c74b73a28a17$var$RemoveItem = Phaser.Utils.Array.Remove;
const $3af1c74b73a28a17$var$ContainerRemove = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039).prototype.remove;
var $3af1c74b73a28a17$var$RemoveChild = function(gameObject, destroyChild) {
    if (this.isBackground(gameObject)) $3af1c74b73a28a17$var$RemoveItem(this.backgroundChildren, gameObject);
    $3af1c74b73a28a17$var$ContainerRemove.call(this, gameObject, destroyChild);
    if (!destroyChild && this.sizerEventsEnable) {
        gameObject.emit("sizer.remove", gameObject, this);
        this.emit("remove", gameObject, this);
    }
    return this;
};
var $3af1c74b73a28a17$export$2e2bcd8739ae039 = $3af1c74b73a28a17$var$RemoveChild;


var $44f9283e5c7dc34d$var$GetParent = function(gameObject, name) {
    var parent = null;
    if (name === undefined) {
        if (gameObject.hasOwnProperty("rexContainer")) {
            parent = gameObject.rexContainer.parent;
            if (parent) {
                if (!parent.isRexSizer) // Try to get sizer parent
                parent = $44f9283e5c7dc34d$var$GetParent(parent);
            } else parent = null;
        }
    } else {
        parent = $44f9283e5c7dc34d$var$GetParent(gameObject);
        while(parent){
            if (parent.name === name) break;
            parent = $44f9283e5c7dc34d$var$GetParent(parent);
        }
    }
    return parent;
};
var $44f9283e5c7dc34d$var$GetTopmostParent = function(gameObject) {
    var parent = $44f9283e5c7dc34d$var$GetParent(gameObject);
    while(parent){
        gameObject = parent;
        parent = $44f9283e5c7dc34d$var$GetParent(parent);
    }
    return gameObject;
};
var $44f9283e5c7dc34d$export$2e2bcd8739ae039 = {
    getParentSizer (gameObject, name) {
        if (typeof gameObject === "string") {
            name = gameObject;
            gameObject = undefined;
        }
        if (gameObject === undefined) gameObject = this;
        return $44f9283e5c7dc34d$var$GetParent(gameObject, name);
    },
    getTopmostSizer (gameObject) {
        if (gameObject === undefined) gameObject = this;
        return $44f9283e5c7dc34d$var$GetTopmostParent(gameObject);
    }
};


const $d5362b366b0f8608$var$RemoveItem = Phaser.Utils.Array.Remove;
var $d5362b366b0f8608$export$2e2bcd8739ae039 = {
    removeFromParentSizer () {
        var parent = (0, $44f9283e5c7dc34d$export$2e2bcd8739ae039).getParentSizer(gameObject);
        if (parent) parent.remove(this);
        return this;
    },
    removeBackground (gameObject1, destroyChild) {
        if (this.backgroundChildren === undefined) return this;
        if (this.getParentSizer(gameObject1) !== this) return this;
        $d5362b366b0f8608$var$RemoveItem(this.backgroundChildren, gameObject1);
        (0, $3af1c74b73a28a17$export$2e2bcd8739ae039).call(this, gameObject1, destroyChild);
        return this;
    },
    removeAllBackgrounds (destroyChild) {
        if (this.backgroundChildren === undefined) return this;
        for(var i = this.backgroundChildren.length - 1; i >= 0; i--)this.remove(this.backgroundChildren[i], destroyChild);
        return this;
    }
};


var $550f5eabc57c8951$var$AddChildrenMap = function(key, gameObject) {
    this.childrenMap[key] = gameObject;
    return this;
};
var $550f5eabc57c8951$export$2e2bcd8739ae039 = $550f5eabc57c8951$var$AddChildrenMap;


var $c242cfa2eb33e585$var$RemoveChildrenMap = function(key) {
    if (typeof key === "object") {
        var gameObject = key;
        for(var key in this.childrenMap)if (this.childrenMap[key] === gameObject) {
            delete this.childrenMap[key];
            return this;
        }
    }
    delete this.childrenMap[key];
    return this;
};
var $c242cfa2eb33e585$export$2e2bcd8739ae039 = $c242cfa2eb33e585$var$RemoveChildrenMap;


var $c1b78c44c0369a27$var$GetElement = function(mapNameList, recursive) {
    if (typeof mapNameList === "string") mapNameList = mapNameList.split(".");
    if (mapNameList.length === 0) return undefined;
    var name = mapNameList.shift(), element = null;
    if (name.charAt(0) === "#") {
        name = name.substring(1);
        element = this.getByName(name, recursive);
    } else if (name.indexOf("[") === -1) {
        if (this.childrenMap) element = this.childrenMap[name];
    } else {
        var innerMatch = name.match($c1b78c44c0369a27$var$RE_OBJ);
        if (innerMatch != null) {
            if (this.childrenMap) {
                var elements = this.childrenMap[innerMatch[1]];
                if (elements) element = elements[innerMatch[2]];
            }
        }
    }
    if (mapNameList.length === 0) return element;
    else if (element && element.childrenMap) return element.getElement(mapNameList);
    else return null;
};
const $c1b78c44c0369a27$var$RE_OBJ = /(\S+)\[(\d+)\]/i;
var $c1b78c44c0369a27$export$2e2bcd8739ae039 = $c1b78c44c0369a27$var$GetElement;



var $25bb40e0ffb31fb7$export$2e2bcd8739ae039 = {
    getInnerPadding (key) {
        return (0, $efa8a86e39512506$export$95358a8f491113ca)(this.space, key);
    },
    setInnerPadding (key, value) {
        (0, $efa8a86e39512506$export$dd20faac850f550d)(this.space, key, value);
        return this;
    },
    getOuterPadding (key) {
        return (0, $efa8a86e39512506$export$95358a8f491113ca)(this.getSizerConfig(this).padding, key);
    },
    setOuterPadding (key, value) {
        (0, $efa8a86e39512506$export$dd20faac850f550d)(this.getSizerConfig(this).padding, key, value);
        return this;
    },
    getChildOuterPadding (child, key) {
        if (typeof child === "string") child = this.getElement(child);
        return (0, $efa8a86e39512506$export$95358a8f491113ca)(this.getSizerConfig(child).padding, key);
    },
    setChildOuterPadding (child, key, value) {
        if (typeof child === "string") child = this.getElement(child);
        (0, $efa8a86e39512506$export$dd20faac850f550d)(this.getSizerConfig(child).padding, key, value);
        return this;
    }
};


var $411cee766f03e513$var$ResolveWidth = function(width) {
    if (width === undefined) width = Math.max(this.childrenWidth, this.minWidth);
    return width;
};
var $411cee766f03e513$export$2e2bcd8739ae039 = $411cee766f03e513$var$ResolveWidth;


var $cf74ac6a586942b6$var$ResolveChildrenWidth = function(parentWidth) {
    // Resolve width of sizer children
    var child, childWidth;
    for(var i in this.sizerChildren){
        child = this.sizerChildren[i];
        if (child && child.isRexSizer && !child.ignoreLayout) {
            childWidth = this.getExpandedChildWidth(child, parentWidth);
            childWidth = child.resolveWidth(childWidth);
            child.resolveChildrenWidth(childWidth);
        }
    }
};
var $cf74ac6a586942b6$export$2e2bcd8739ae039 = $cf74ac6a586942b6$var$ResolveChildrenWidth;


var $da2b6b6b16a97213$var$ResolveHeight = function(height) {
    var minHeight = Math.max(this.childrenHeight, this.minHeight);
    if (height === undefined) height = minHeight;
    return height;
};
var $da2b6b6b16a97213$export$2e2bcd8739ae039 = $da2b6b6b16a97213$var$ResolveHeight;


var $397de2fd6c16cecf$var$PostResolveSize = function(width, height) {};
var $397de2fd6c16cecf$export$2e2bcd8739ae039 = $397de2fd6c16cecf$var$PostResolveSize;



var $c1b89dee547f2674$var$GetChildWidth = function(child) {
    var childWidth;
    if (child.isRexSizer) childWidth = Math.max(child.minWidth, child.childrenWidth);
    else if (child.minWidth !== undefined) childWidth = child.minWidth;
    else childWidth = (0, $3d5f5580139892aa$export$a60660135e2d0135)(child);
    return childWidth;
};
var $c1b89dee547f2674$export$2e2bcd8739ae039 = $c1b89dee547f2674$var$GetChildWidth;



var $1f3b0de67405dcaf$var$GetChildHeight = function(child) {
    var childHeight;
    if (child.isRexSizer) childHeight = Math.max(child.minHeight, child.childrenHeight);
    else if (child.minHeight !== undefined) childHeight = child.minHeight;
    else childHeight = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
    return childHeight;
};
var $1f3b0de67405dcaf$export$2e2bcd8739ae039 = $1f3b0de67405dcaf$var$GetChildHeight;


// Override
var $d540c1cc01a2cb9c$var$GetExpandedChildWidth = function(child, parentWidth) {
    return parentWidth;
};
var $d540c1cc01a2cb9c$export$2e2bcd8739ae039 = $d540c1cc01a2cb9c$var$GetExpandedChildWidth;


// Override
var $783121464a425c08$var$GetExpandedChildHeight = function(child, parentHeight) {
    return parentHeight;
};
var $783121464a425c08$export$2e2bcd8739ae039 = $783121464a425c08$var$GetExpandedChildHeight;


// Override
var $77f5a78ffc77eba8$var$GetChildrenWidth = function() {
    return 0;
};
var $77f5a78ffc77eba8$export$2e2bcd8739ae039 = $77f5a78ffc77eba8$var$GetChildrenWidth;


// Override
var $a7b3d0279eaf6749$var$GetChildrenHeight = function() {
    return 0;
};
var $a7b3d0279eaf6749$export$2e2bcd8739ae039 = $a7b3d0279eaf6749$var$GetChildrenHeight;


var $4bf3b7e260fa3950$var$GetAllChildrenSizers = function(out) {
    if (out === undefined) out = [];
    var startIdx = out.length;
    var children = this.getChildrenSizers(out);
    var endIdx = out.length;
    for(var i = startIdx; i < endIdx; i++)children[i].getAllChildrenSizers(out);
    return out;
};
var $4bf3b7e260fa3950$export$2e2bcd8739ae039 = $4bf3b7e260fa3950$var$GetAllChildrenSizers;


// Default method
var $fa4d0991cb5e13da$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    return out;
};
var $fa4d0991cb5e13da$export$2e2bcd8739ae039 = $fa4d0991cb5e13da$var$GetChildrenSizers;


var $6938927fe9660df6$export$2e2bcd8739ae039 = {
    getShownChildren (out) {
        if (out === undefined) out = [];
        var children = this.children, child;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            child = children[i];
            if (child.rexSizer && child.rexSizer.hidden) continue;
            out.push(child);
        }
        return out;
    },
    getAllShownChildren (out) {
        if (out === undefined) out = [];
        var queue = [
            this
        ];
        while(queue.length > 0){
            var current = queue.shift();
            if (current.rexSizer && current.rexSizer.hidden) continue;
            if (current !== this) out.push(current);
            if (current.isRexContainerLite) queue.push(...current.children);
        }
        return out;
    }
};


var $8777309d0690526c$var$PreLayout = function() {
    this._childrenWidth = undefined;
    this._childrenHeight = undefined;
    var children = this.getChildrenSizers(), child;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.ignoreLayout) continue;
        child.preLayout();
    }
};
var $8777309d0690526c$export$2e2bcd8739ae039 = $8777309d0690526c$var$PreLayout;


var $cc3114ae446d6400$var$Layout = function() {
    // Save scale
    var scaleXSave = this.scaleX;
    var scaleYSave = this.scaleY;
    var scale1 = scaleXSave === 1 && scaleYSave === 1;
    if (!scale1) this.setScale(1);
    // Run layout with scale = 1
    this.runLayout();
    // Restore scale
    if (!scale1) this.setScale(scaleXSave, scaleYSave);
    return this;
};
var $cc3114ae446d6400$export$2e2bcd8739ae039 = $cc3114ae446d6400$var$Layout;


// Override
var $df82898f04075e26$var$RunLayout = function(parent, newWidth, newHeight) {
    // Skip hidden or !dirty sizer
    if (this.ignoreLayout) return this;
    var isTopmostParent = !parent;
    // Preprocessor, top parent only
    if (isTopmostParent) this.preLayout();
    // Calculate parent width
    newWidth = this.resolveWidth(newWidth);
    // Calculate all children width, run width wrap
    if (isTopmostParent) {
        this.resolveChildrenWidth(newWidth);
        this.runWidthWrap(newWidth);
    }
    // Calculate parent height
    newHeight = this.resolveHeight(newHeight);
    // The last chance of resolving size
    this.postResolveSize(newWidth, newHeight);
    // Resize parent
    this.resize(newWidth, newHeight);
    if (this.sizerEventsEnable) {
        if (this.layoutedChildren === undefined) this.layoutedChildren = [];
    }
    // Layout children    
    this.layoutChildren();
    // Layout background children
    this.layoutBackgrounds();
    if (this.sizerEventsEnable) {
        this.emit("postlayout", this.layoutedChildren, this);
        this.layoutedChildren.length = 0;
    }
    return this.postLayout();
};
var $df82898f04075e26$export$2e2bcd8739ae039 = $df82898f04075e26$var$RunLayout;


// Override
var $e6cdfec26ef3787d$var$LayoutChildren = function() {};
var $e6cdfec26ef3787d$export$2e2bcd8739ae039 = $e6cdfec26ef3787d$var$LayoutChildren;


var $a8e8c8d2123230d4$var$PostLayout = function(parent, newWidth, newHeight) {
    if (this._anchor) this._anchor.updatePosition();
    return this;
};
var $a8e8c8d2123230d4$export$2e2bcd8739ae039 = $a8e8c8d2123230d4$var$PostLayout;


// Default method
var $10fc52975e1b187e$var$RunWidthWrap = function(parentWidth) {
    var child, childWidth;
    for(var i in this.sizerChildren){
        child = this.sizerChildren[i];
        if (!child || child.isRexSizer && child.ignoreLayout || !child.runWidthWrap) continue;
        childWidth = this.getExpandedChildWidth(child, parentWidth);
        if (child.isRexSizer) childWidth = child.resolveWidth(childWidth);
        child.runWidthWrap(childWidth);
    }
    return this;
};
var $10fc52975e1b187e$export$2e2bcd8739ae039 = $10fc52975e1b187e$var$RunWidthWrap;




class $3380d9805ef112d2$var$Anchor extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, {
            eventEmitter: false
        });
        // No event emitter
        // this.parent = gameObject;
        this.viewport = undefined;
        this.resetFromJSON(config);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.autoAnchor(false);
        this.viewport = undefined;
        this.onUpdateViewportCallback = undefined;
        this.onUpdateViewportCallbackScope = undefined;
        this.onResizeCallback = undefined;
        this.onResizeCallbackScope = undefined;
        super.shutdown(fromScene);
    }
    resetFromJSON(o) {
        if (o === undefined) o = {};
        // Position
        var alignX, configX;
        if (o.x !== undefined) {
            alignX = null;
            configX = o.x;
        } else if (o.left !== undefined) {
            alignX = 0;
            configX = o.left;
        } else if (o.right !== undefined) {
            alignX = 1;
            configX = o.right;
        } else if (o.centerX !== undefined) {
            alignX = 0.5;
            configX = o.centerX;
        }
        var alignY, configY;
        if (o.y !== undefined) {
            alignY = null;
            configY = o.y;
        } else if (o.top !== undefined) {
            alignY = 0;
            configY = o.top;
        } else if (o.bottom !== undefined) {
            alignY = 1;
            configY = o.bottom;
        } else if (o.centerY !== undefined) {
            alignY = 0.5;
            configY = o.centerY;
        }
        var percentageX, offsetX;
        if (configX !== undefined) {
            configX = configX.replace("left", "0%").replace("right", "100%").replace("center", "50%").split("%");
            percentageX = parseFloat(configX[0]) / 100;
            offsetX = configX[1] === "" ? 0 : parseFloat(configX[1]);
        }
        var percentageY, offsetY;
        if (configY !== undefined) {
            configY = configY.replace("top", "0%").replace("bottom", "100%").replace("center", "50%").split("%");
            percentageY = parseFloat(configY[0]) / 100;
            offsetY = configY[1] === "" ? 0 : parseFloat(configY[1]);
        }
        // Size
        var configWidth = o.width;
        var percentageWidth, paddingWidth;
        if (configWidth !== undefined) {
            configWidth = configWidth.split("%");
            percentageWidth = parseFloat(configWidth[0]) / 100;
            paddingWidth = configWidth[1] === "" ? 0 : parseFloat(configWidth[1]);
        }
        var configHeight = o.height;
        var percentageHeight, paddingHeight;
        if (configHeight !== undefined) {
            configHeight = configHeight.split("%");
            percentageHeight = parseFloat(configHeight[0]) / 100;
            paddingHeight = configHeight[1] === "" ? 0 : parseFloat(configHeight[1]);
        }
        // Position
        this.setAlign(alignX, alignY);
        this.setPercentage(percentageX, percentageY);
        this.setOffset(offsetX, offsetY);
        // Size
        this.setSizePercentage(percentageWidth, percentageHeight);
        this.setSizePadding(paddingWidth, paddingHeight);
        var onResizeCallback = o.onResizeCallback;
        var onResizeCallbackScope = o.onResizeCallbackScope;
        if (onResizeCallback !== undefined) this.setResizeCallback(onResizeCallback, onResizeCallbackScope);
        var onUpdateViewportCallback = o.onUpdateViewportCallback;
        var onUpdateViewportCallbackScope = o.onUpdateViewportCallbackScope;
        if (onUpdateViewportCallback !== undefined) this.setUpdateViewportCallback(onUpdateViewportCallback, onUpdateViewportCallbackScope);
        this.autoAnchor(o.enable);
        return this;
    }
    autoAnchor(enable) {
        if (enable === undefined) enable = true;
        enable = !!enable;
        if (this.autoAnchorEnable === enable) return this;
        if (enable) {
            this.scene.sys.scale.on("resize", this.anchor, this);
            this.anchor();
        } else this.scene.sys.scale.off("resize", this.anchor, this);
        this.autoAnchorEnable = enable;
        return this;
    }
    // Position
    setAlign(x, y) {
        this.alignX = x;
        this.alignY = y;
        return this;
    }
    setPercentage(x, y) {
        this.percentageX = x;
        this.percentageY = y;
        return this;
    }
    setOffset(x, y) {
        this.offsetX = x;
        this.offsetY = y;
        return this;
    }
    // Size
    setSizePercentage(width, height) {
        this.percentageWidth = width;
        this.percentageHeight = height;
        return this;
    }
    setSizePadding(width, height) {
        this.paddingWidth = width;
        this.paddingHeight = height;
        return this;
    }
    setResizeCallback(callback, scope) {
        this.onResizeCallback = callback;
        this.onResizeCallbackScope = scope;
        return this;
    }
    setUpdateViewportCallback(callback, scope) {
        this.onUpdateViewportCallback = callback;
        this.onUpdateViewportCallbackScope = scope;
        return this;
    }
    anchor() {
        this.updateViewport();
        this.updateSize();
        this.updatePosition();
        return this;
    }
    updateSize() {
        var callback = this.onResizeCallback, scope = this.onResizeCallbackScope;
        var newWidth = this.anchorWidth, newHeight = this.anchorHeight;
        if (newWidth === undefined && newHeight === undefined || !callback) return;
        var gameObject = this.parent;
        if (newWidth === undefined) newWidth = gameObject.width;
        if (newHeight === undefined) newHeight = gameObject.height;
        if (scope) callback.call(scope, newWidth, newHeight, gameObject, this);
        else callback(newWidth, newHeight, gameObject, this);
    }
    updatePosition() {
        var gameObject = this.parent;
        if (this.alignX === null) gameObject.x = this.anchorX;
        else if (this.alignX !== undefined) gameObject.x = this.anchorX + gameObject.displayWidth * (gameObject.originX - this.alignX);
        if (this.alignY === null) gameObject.y = this.anchorY;
        else if (this.alignY !== undefined) gameObject.y = this.anchorY + gameObject.displayHeight * (gameObject.originY - this.alignY);
        return this;
    }
    get anchorX() {
        return this.viewport.x + this.viewport.width * this.percentageX + this.offsetX;
    }
    get anchorY() {
        return this.viewport.y + this.viewport.height * this.percentageY + this.offsetY;
    }
    get anchorWidth() {
        if (this.percentageWidth === undefined) return undefined;
        return this.viewport.width * this.percentageWidth + this.paddingWidth;
    }
    get anchorHeight() {
        if (this.percentageHeight === undefined) return undefined;
        return this.viewport.height * this.percentageHeight + this.paddingHeight;
    }
    updateViewport() {
        var camera = this.parent.scene.cameras.main;
        this.viewport = (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(this.scene, camera, this.viewport);
        var viewport = this.viewport;
        var callback = this.onUpdateViewportCallback, scope = this.onUpdateViewportCallbackScope;
        if (callback) {
            if (scope) callback.call(scope, viewport, this.parent, this);
            else callback(viewport, this.parent, this);
        }
    }
}
var $3380d9805ef112d2$export$2e2bcd8739ae039 = $3380d9805ef112d2$var$Anchor;


var $0214e441a3ca6ed5$export$2e2bcd8739ae039 = (0, $3380d9805ef112d2$export$2e2bcd8739ae039);


var $a900dfc1914435a9$var$SetAnchor = function(config) {
    if (config === undefined) config = {};
    // Assign default onResizeCallback if not given    
    var hasMinWidth = config.hasOwnProperty("width");
    var hasMinHeight = config.hasOwnProperty("height");
    var hasOnResizeCallback = config.hasOwnProperty("onResizeCallback");
    if ((hasMinWidth || hasMinHeight) && !hasOnResizeCallback) config.onResizeCallback = function(width, height, sizer) {
        if (hasMinWidth) sizer.setMinWidth(width);
        if (hasMinHeight) sizer.setMinHeight(height);
        sizer.layout();
    };
    if (this._anchor === undefined) this._anchor = new (0, $0214e441a3ca6ed5$export$2e2bcd8739ae039)(this, config);
    else this._anchor.resetFromJSON(config);
    return this;
};
var $a900dfc1914435a9$export$2e2bcd8739ae039 = $a900dfc1914435a9$var$SetAnchor;



const $f4977f68b8f13065$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f4977f68b8f13065$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $f4977f68b8f13065$var$Linear = Phaser.Math.Linear;
class $f4977f68b8f13065$var$Scale extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.scaleStart = {};
        this.scaleEnd = {};
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setMode($f4977f68b8f13065$var$GetValue(o, "mode", 0));
        this.setScaleRange($f4977f68b8f13065$var$GetAdvancedValue(o, "start", undefined), $f4977f68b8f13065$var$GetAdvancedValue(o, "end", 0));
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $f4977f68b8f13065$var$MODE[m];
        this.mode = m;
        return this;
    }
    setScaleRange(start, end) {
        if (typeof start === "number") {
            this.startX = start;
            this.startY = start;
        } else {
            this.startX = $f4977f68b8f13065$var$GetAdvancedValue(start, "x", this.parent.scaleX);
            this.startY = $f4977f68b8f13065$var$GetAdvancedValue(start, "y", this.parent.scaleY);
        }
        if (typeof end === "number") {
            this.endX = end;
            this.endY = end;
        } else {
            this.endX = $f4977f68b8f13065$var$GetAdvancedValue(end, "x", undefined);
            this.endY = $f4977f68b8f13065$var$GetAdvancedValue(end, "y", undefined);
        }
        this.hasScaleX = this.startX !== undefined && this.endX !== undefined;
        this.hasScaleY = this.startY !== undefined && this.endY !== undefined;
        return this;
    }
    start() {
        if (this.timer.isRunning) return this;
        var gameObject = this.parent;
        if (this.hasScaleX) gameObject.scaleX = this.startX;
        if (this.hasScaleY) gameObject.scaleY = this.startY;
        var repeat = this.repeat;
        if (this.mode === 2) {
            if (repeat !== -1) repeat = (repeat + 1) * 2 - 1;
        }
        this.timer.setDelay(this.delay).setDuration(this.duration).setRepeat(repeat);
        super.start();
        return this;
    }
    updateGameObject(gameObject, timer) {
        var t = timer.t;
        if (timer.isOddIteration) t = 1 - t;
        t = this.easeFn(t);
        if (this.hasScaleX) gameObject.scaleX = $f4977f68b8f13065$var$Linear(this.startX, this.endX, t);
        if (this.hasScaleY) gameObject.scaleY = $f4977f68b8f13065$var$Linear(this.startY, this.endY, t);
    }
    complete() {
        super.complete();
        if (this.mode === 1) this.parent.destroy();
        return this;
    }
}
const $f4977f68b8f13065$var$MODE = {
    stop: 0,
    destroy: 1,
    yoyo: 2
};
var $f4977f68b8f13065$export$2e2bcd8739ae039 = $f4977f68b8f13065$var$Scale;


var $85135a7cf8f876f7$var$PopUp = function(gameObject, duration, orientation, ease, scale) {
    if (ease === undefined) ease = "Cubic";
    // Ease scale from 0 to current scale
    var start, end;
    switch(orientation){
        case 0:
        case "x":
            start = {
                x: 0
            };
            end = {
                x: gameObject.scaleX
            };
            break;
        case 1:
        case "y":
            start = {
                y: 0
            };
            end = {
                y: gameObject.scaleY
            };
            break;
        default:
            start = 0;
            end = gameObject.scale;
            break;
    }
    var config = {
        mode: 0,
        start: start,
        end: end,
        duration: duration,
        ease: ease
    };
    if (scale === undefined) scale = new (0, $f4977f68b8f13065$export$2e2bcd8739ae039)(gameObject, config);
    else scale.resetFromJSON(config);
    scale.restart();
    return scale;
};
var $85135a7cf8f876f7$export$2e2bcd8739ae039 = $85135a7cf8f876f7$var$PopUp;


var $7fc63b8d8e1b2022$export$2e2bcd8739ae039 = (0, $85135a7cf8f876f7$export$2e2bcd8739ae039);



var $32018e52d7aa4c40$var$ScaleDownDestroy = function(gameObject, duration, orientation, ease, destroyMode, scale) {
    if (ease === undefined) ease = "Linear";
    // Ease from current scale to 0
    if (destroyMode instanceof (0, $f4977f68b8f13065$export$2e2bcd8739ae039)) {
        scale = destroyMode;
        destroyMode = undefined;
    }
    if (destroyMode === undefined) destroyMode = true;
    var config = {};
    config.mode = destroyMode ? 1 : 0;
    switch(orientation){
        case 0:
        case "x":
            config.end = {
                x: 0
            };
            break;
        case 1:
        case "y":
            config.end = {
                y: 0
            };
            break;
        default:
            config.end = 0;
            break;
    }
    config.duration = duration;
    config.ease = ease;
    if (scale === undefined) scale = new (0, $f4977f68b8f13065$export$2e2bcd8739ae039)(gameObject, config);
    else scale.resetFromJSON(config);
    scale.restart();
    return scale;
};
var $32018e52d7aa4c40$export$2e2bcd8739ae039 = $32018e52d7aa4c40$var$ScaleDownDestroy;


var $188d7bfa74eda983$export$2e2bcd8739ae039 = (0, $32018e52d7aa4c40$export$2e2bcd8739ae039);



var $810d107c6fb6dbe6$var$Yoyo = function(gameObject, duration, peakValue, repeat, orientation, ease, scale) {
    if (peakValue === undefined) peakValue = 1.2;
    if (repeat === undefined) repeat = 0;
    if (ease === undefined) ease = "Cubic";
    // Ease scale from 0 to current scale
    var start, end;
    switch(orientation){
        case 0:
        case "x":
            start = {
                x: gameObject.scaleX
            };
            end = {
                x: peakValue
            };
            break;
        case 1:
        case "y":
            start = {
                y: gameObject.scaleX
            };
            end = {
                y: peakValue
            };
            break;
        default:
            start = gameObject.scaleX;
            end = peakValue;
            break;
    }
    var config = {
        mode: 2,
        start: start,
        end: end,
        duration: duration / 2,
        ease: ease,
        repeat: repeat
    };
    if (scale === undefined) scale = new (0, $f4977f68b8f13065$export$2e2bcd8739ae039)(gameObject, config);
    else scale.resetFromJSON(config);
    scale.restart();
    return scale;
};
var $810d107c6fb6dbe6$export$2e2bcd8739ae039 = $810d107c6fb6dbe6$var$Yoyo;






const $419bbe1decd04038$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
var $419bbe1decd04038$var$OnInitScale = function(gameObject, scale) {
    // Route 'complete' of scale to gameObject
    scale.completeEventName = undefined;
    scale.on("complete", function() {
        if (scale.completeEventName) {
            gameObject.emit(scale.completeEventName, gameObject);
            scale.completeEventName = undefined;
        }
    });
    // Update local state
    scale.on("update", function() {
        var parent = (0, $44f9283e5c7dc34d$export$2e2bcd8739ae039).getParentSizer(gameObject);
        if (parent) parent.resetChildPositionState(gameObject);
    });
};
var $419bbe1decd04038$export$2e2bcd8739ae039 = {
    popUp (duration, orientation, ease) {
        if ($419bbe1decd04038$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            orientation = config.orientation;
            ease = config.ease;
        }
        var isInit = this._scaleBehavior === undefined;
        this._scaleBehavior = (0, $7fc63b8d8e1b2022$export$2e2bcd8739ae039)(this, duration, orientation, ease, this._scaleBehavior);
        if (isInit) $419bbe1decd04038$var$OnInitScale(this, this._scaleBehavior);
        this._scaleBehavior.completeEventName = "popup.complete";
        return this;
    },
    popUpPromise (duration, orientation, ease) {
        this.popUp(duration, orientation, ease);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._scaleBehavior);
    },
    scaleDownDestroy (duration, orientation, ease, destroyMode) {
        if ($419bbe1decd04038$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            orientation = config.orientation;
            ease = config.ease;
            destroyMode = config.destroy;
        }
        var isInit = this._scaleBehavior === undefined;
        this._scaleBehavior = (0, $188d7bfa74eda983$export$2e2bcd8739ae039)(this, duration, orientation, ease, destroyMode, this._scaleBehavior);
        if (isInit) $419bbe1decd04038$var$OnInitScale(this, this._scaleBehavior);
        this._scaleBehavior.completeEventName = "scaledown.complete";
        return this;
    },
    scaleDownDestroyPromise (duration, orientation, ease, destroyMode) {
        this.scaleDownDestroy(duration, orientation, ease, destroyMode);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._scaleBehavior);
    },
    scaleDown (duration, orientation, ease) {
        this.scaleDownDestroy(duration, orientation, ease, false);
        return this;
    },
    scaleDownPromise (duration, orientation, ease) {
        this.scaleDown(duration, orientation, ease);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._scaleBehavior);
    },
    scaleYoyo (duration, peakValue, repeat, orientation, ease) {
        if ($419bbe1decd04038$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            peakValue = config.peakValue;
            repeat = config.repeat;
            orientation = config.orientation;
            ease = config.ease;
        }
        var isInit = this._scaleBehavior === undefined;
        this._scaleBehavior = (0, $810d107c6fb6dbe6$export$2e2bcd8739ae039)(this, duration, peakValue, repeat, orientation, ease, this._scaleBehavior);
        if (isInit) $419bbe1decd04038$var$OnInitScale(this, this._scaleBehavior);
        this._scaleBehavior.completeEventName = "scaleyoyo.complete";
        return this;
    },
    scaleYoyoPromise (duration, peakValue, repeat, orientation, ease) {
        this.scaleYoyo(duration, peakValue, repeat, orientation, ease);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._scaleBehavior);
    }
};



const $83d69c8272f9421c$var$GetValue = Phaser.Utils.Objects.GetValue;
const $83d69c8272f9421c$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $83d69c8272f9421c$var$Linear = Phaser.Math.Linear;
class $83d69c8272f9421c$var$Fade extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setMode($83d69c8272f9421c$var$GetValue(o, "mode", 0));
        this.setAlphaRange($83d69c8272f9421c$var$GetAdvancedValue(o, "start", this.parent.alpha), $83d69c8272f9421c$var$GetAdvancedValue(o, "end", 0));
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $83d69c8272f9421c$var$MODE[m];
        this.mode = m;
        return this;
    }
    setAlphaRange(start, end) {
        this.alphaStart = start;
        this.alphaEnd = end;
        return this;
    }
    start() {
        if (this.timer.isRunning) return this;
        var gameObject = this.parent;
        gameObject.setAlpha(this.alphaStart);
        this.timer.setDelay(this.delay).setDuration(this.duration).setRepeat(this.mode === 2 ? -1 : 0);
        super.start();
        return this;
    }
    updateGameObject(gameObject, timer) {
        var t = timer.t;
        if (timer.isOddIteration) t = 1 - t;
        gameObject.alpha = $83d69c8272f9421c$var$Linear(this.alphaStart, this.alphaEnd, t);
    }
    complete() {
        super.complete();
        if (this.mode === 1) this.parent.destroy();
        return this;
    }
}
const $83d69c8272f9421c$var$MODE = {
    stop: 0,
    destroy: 1,
    yoyo: 2
};
var $83d69c8272f9421c$export$2e2bcd8739ae039 = $83d69c8272f9421c$var$Fade;


var $5c3d1032279d79d3$export$2e2bcd8739ae039 = (0, $83d69c8272f9421c$export$2e2bcd8739ae039);



const $0b78b699f711afbf$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
var $0b78b699f711afbf$var$FadeIn = function(gameObject, duration, alpha, fade) {
    var startAlpha, endAlpha;
    if ($0b78b699f711afbf$var$IsPlainObject(alpha)) {
        startAlpha = alpha.start;
        endAlpha = alpha.end;
    } else endAlpha = alpha;
    if (startAlpha === undefined) startAlpha = 0;
    if (endAlpha === undefined) endAlpha = 1;
    var config = {
        mode: 0,
        start: startAlpha,
        end: endAlpha,
        duration: duration
    };
    if (fade === undefined) fade = new (0, $5c3d1032279d79d3$export$2e2bcd8739ae039)(gameObject, config);
    else fade.resetFromJSON(config);
    fade.restart();
    return fade;
};
var $0b78b699f711afbf$export$2e2bcd8739ae039 = $0b78b699f711afbf$var$FadeIn;



var $607af573d5a48304$var$FadeOutDestroy = function(gameObject, duration, destroyMode, fade) {
    if (destroyMode instanceof (0, $5c3d1032279d79d3$export$2e2bcd8739ae039)) {
        fade = destroyMode;
        destroyMode = undefined;
    }
    if (destroyMode === undefined) destroyMode = true;
    var config = {
        mode: destroyMode ? 1 : 0,
        end: 0,
        duration: duration
    };
    if (fade === undefined) fade = new (0, $5c3d1032279d79d3$export$2e2bcd8739ae039)(gameObject, config);
    else fade.resetFromJSON(config);
    fade.restart();
    return fade;
};
var $607af573d5a48304$export$2e2bcd8739ae039 = $607af573d5a48304$var$FadeOutDestroy;






const $7a01cb75922d4f8c$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
var $7a01cb75922d4f8c$var$OnInitFade = function(gameObject, fade) {
    // Route 'complete' of fade to gameObject
    fade.completeEventName = undefined;
    fade.on("complete", function() {
        if (fade.completeEventName) {
            gameObject.emit(fade.completeEventName, gameObject);
            fade.completeEventName = undefined;
        }
    });
    // Update local state
    fade.on("update", function() {
        var parent = (0, $44f9283e5c7dc34d$export$2e2bcd8739ae039).getParentSizer(gameObject);
        if (parent) parent.resetChildAlphaState(gameObject);
    });
};
var $7a01cb75922d4f8c$export$2e2bcd8739ae039 = {
    fadeIn (duration, alpha) {
        if ($7a01cb75922d4f8c$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            alpha = config.alpha;
        }
        var isInit = this._fade === undefined;
        this._fade = (0, $0b78b699f711afbf$export$2e2bcd8739ae039)(this, duration, alpha, this._fade);
        if (isInit) $7a01cb75922d4f8c$var$OnInitFade(this, this._fade);
        this._fade.completeEventName = "fadein.complete";
        return this;
    },
    fadeInPromise (duration, alpha) {
        this.fadeIn(duration, alpha);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._fade);
    },
    fadeOutDestroy (duration, destroyMode) {
        if ($7a01cb75922d4f8c$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            destroyMode = config.destroy;
        }
        var isInit = this._fade === undefined;
        this._fade = (0, $607af573d5a48304$export$2e2bcd8739ae039)(this, duration, destroyMode, this._fade);
        if (isInit) $7a01cb75922d4f8c$var$OnInitFade(this, this._fade);
        this._fade.completeEventName = "fadeout.complete";
        return this;
    },
    fadeOutDestroyPromise (duration, destroyMode) {
        this.fadeOutDestroy(duration, destroyMode);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._fade);
    },
    fadeOut (duration) {
        this.fadeOutDestroy(duration, false);
        return this;
    },
    fadeOutPromise (duration) {
        this.fadeOut(duration);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._fade);
    }
};



const $2d4835d8e5793d06$var$GetValue = Phaser.Utils.Objects.GetValue;
const $2d4835d8e5793d06$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $2d4835d8e5793d06$var$Linear = Phaser.Math.Linear;
class $2d4835d8e5793d06$var$EaseMove extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setMode($2d4835d8e5793d06$var$GetValue(o, "mode", 0));
        if (o && (o.hasOwnProperty("x") || o.hasOwnProperty("y"))) {
            var endX = $2d4835d8e5793d06$var$GetAdvancedValue(o, "x", undefined);
            var endY = $2d4835d8e5793d06$var$GetAdvancedValue(o, "y", undefined);
            this.setTargetPosition(endX, endY);
        } else this.setTargetPosition(o);
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $2d4835d8e5793d06$var$MODE[m];
        this.mode = m;
        return this;
    }
    setTargetPosition(x, y) {
        if (typeof x === "number" || typeof y === "number") {
            // endX, endY
            // x,y : a number, or undefined
            this.startX = this.parent.x;
            this.startY = this.parent.y;
            this.endX = x;
            this.endY = y;
        } else {
            var config = x;
            this.startX = $2d4835d8e5793d06$var$GetAdvancedValue(config, "startX", undefined);
            this.startY = $2d4835d8e5793d06$var$GetAdvancedValue(config, "startY", undefined);
            this.endX = $2d4835d8e5793d06$var$GetAdvancedValue(config, "endX", undefined);
            this.endY = $2d4835d8e5793d06$var$GetAdvancedValue(config, "endY", undefined);
        }
        this.hasMoveX = this.startX !== undefined && this.endX !== undefined;
        this.hasMoveY = this.startY !== undefined && this.endY !== undefined;
        return this;
    }
    start() {
        if (this.timer.isRunning) return this;
        var gameObject = this.parent;
        if (this.hasMoveX) gameObject.x = this.startX;
        if (this.hasMoveY) gameObject.y = this.startY;
        this.timer.setDelay(this.delay).setDuration(this.duration).setRepeat(this.mode === 2 ? -1 : 0);
        super.start();
        return this;
    }
    updateGameObject(gameObject, timer) {
        var t = timer.t;
        if (timer.isOddIteration) t = 1 - t;
        t = this.easeFn(t);
        if (this.hasMoveX) gameObject.x = $2d4835d8e5793d06$var$Linear(this.startX, this.endX, t);
        if (this.hasMoveY) gameObject.y = $2d4835d8e5793d06$var$Linear(this.startY, this.endY, t);
    }
    complete() {
        super.complete();
        if (this.mode === 1) this.parent.destroy();
        return this;
    }
}
const $2d4835d8e5793d06$var$MODE = {
    stop: 0,
    destroy: 1,
    yoyo: 2
};
var $2d4835d8e5793d06$export$2e2bcd8739ae039 = $2d4835d8e5793d06$var$EaseMove;



var $38cc5d373df53969$var$ParseValue = function(propertyValue, startValue) {
    // propertyValue : number or string
    if (typeof propertyValue === "number") return propertyValue;
    else {
        var op = propertyValue[0];
        var num = parseFloat(propertyValue.substr(2));
        switch(op){
            case "+":
                return startValue + num;
            case "-":
                return startValue - num;
            case "*":
                return startValue * num;
            case "/":
                return startValue / num;
        }
    }
};
var $38cc5d373df53969$export$2e2bcd8739ae039 = $38cc5d373df53969$var$ParseValue;


var $eeb9cc7ef6d9e9f6$var$EaseMoveTo = function(gameObject, duration, endX, endY, ease, destroyMode, easeMove) {
    if (destroyMode instanceof (0, $2d4835d8e5793d06$export$2e2bcd8739ae039)) {
        easeMove = destroyMode;
        destroyMode = undefined;
    }
    if (destroyMode === undefined) destroyMode = false;
    var config = {};
    config.mode = destroyMode ? 1 : 0;
    if (endX !== undefined) {
        config.startX = gameObject.x;
        config.endX = (0, $38cc5d373df53969$export$2e2bcd8739ae039)(endX, gameObject.x);
    }
    if (endY !== undefined) {
        config.startY = gameObject.y;
        config.endY = (0, $38cc5d373df53969$export$2e2bcd8739ae039)(endY, gameObject.y);
    }
    config.duration = duration;
    config.ease = ease === undefined ? "Linear" : ease;
    if (easeMove === undefined) easeMove = new (0, $2d4835d8e5793d06$export$2e2bcd8739ae039)(gameObject, config);
    else easeMove.resetFromJSON(config);
    easeMove.restart();
    return easeMove;
};
var $eeb9cc7ef6d9e9f6$export$2e2bcd8739ae039 = $eeb9cc7ef6d9e9f6$var$EaseMoveTo;




var $2eac648027d38869$var$EaseMoveFrom = function(gameObject, duration, startX, startY, ease, destroyMode, easeMove) {
    if (destroyMode instanceof (0, $2d4835d8e5793d06$export$2e2bcd8739ae039)) {
        easeMove = destroyMode;
        destroyMode = undefined;
    }
    if (destroyMode === undefined) destroyMode = false;
    var config = {};
    config.mode = destroyMode ? 1 : 0;
    if (startX !== undefined) {
        config.startX = (0, $38cc5d373df53969$export$2e2bcd8739ae039)(startX, gameObject.x);
        config.endX = gameObject.x;
    }
    if (startY !== undefined) {
        config.startY = (0, $38cc5d373df53969$export$2e2bcd8739ae039)(startY, gameObject.y);
        config.endY = gameObject.y;
    }
    config.duration = duration;
    config.ease = ease === undefined ? "Linear" : ease;
    if (easeMove === undefined) easeMove = new (0, $2d4835d8e5793d06$export$2e2bcd8739ae039)(gameObject, config);
    else easeMove.resetFromJSON(config);
    easeMove.restart();
    return easeMove;
};
var $2eac648027d38869$export$2e2bcd8739ae039 = $2eac648027d38869$var$EaseMoveFrom;


var $010e30874bafb6b1$export$44e3e933cf589510 = function(gameObject, duration, endX, endY, ease, easeMove) {
    return (0, $eeb9cc7ef6d9e9f6$export$2e2bcd8739ae039)(gameObject, duration, endX, endY, ease, true, easeMove);
};
var $010e30874bafb6b1$export$220aeb678d889c64 = function(gameObject, duration, startX, startY, ease, easeMove) {
    return (0, $2eac648027d38869$export$2e2bcd8739ae039)(gameObject, duration, startX, startY, ease, true, easeMove);
};






const $5ee72f51e35a5767$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $5ee72f51e35a5767$var$DistanceBetween = Phaser.Math.Distance.Between;
var $5ee72f51e35a5767$var$OnInitEaseMove = function(gameObject, easeMove) {
    // Route 'complete' of easeMove to gameObject
    easeMove.completeEventName = undefined;
    easeMove.on("complete", function() {
        if (easeMove.completeEventName) {
            gameObject.emit(easeMove.completeEventName, gameObject);
            easeMove.completeEventName = undefined;
        }
    });
    // Update local state
    easeMove.on("update", function() {
        var parent = (0, $44f9283e5c7dc34d$export$2e2bcd8739ae039).getParentSizer(gameObject);
        if (parent) parent.resetChildPositionState(gameObject);
    });
};
var $5ee72f51e35a5767$export$2e2bcd8739ae039 = {
    moveFrom (duration, x, y, ease, destroyMode) {
        if ($5ee72f51e35a5767$var$IsPlainObject(duration)) {
            var config = duration;
            x = config.x;
            y = config.y;
            if (config.hasOwnProperty("speed")) duration = $5ee72f51e35a5767$var$DistanceBetween(x, y, this.x, this.y) * 1000 / config.speed;
            else duration = config.duration;
            ease = config.ease;
        }
        var isInit = this._easeMove === undefined;
        this._easeMove = (0, $2eac648027d38869$export$2e2bcd8739ae039)(this, duration, x, y, ease, destroyMode, this._easeMove);
        if (isInit) $5ee72f51e35a5767$var$OnInitEaseMove(this, this._easeMove);
        this._easeMove.completeEventName = "movefrom.complete";
        return this;
    },
    moveFromPromise (duration, x, y, ease, destroyMode) {
        this.moveFrom(duration, x, y, ease, destroyMode);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._easeMove);
    },
    moveFromDestroy (duration, x, y, ease) {
        this.moveFrom(duration, x, y, ease, true);
        return this;
    },
    moveFromDestroyPromise (duration, x, y, ease) {
        this.moveFromDestroy(duration, x, y, ease);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._easeMove);
    },
    moveTo (duration, x, y, ease, destroyMode) {
        if ($5ee72f51e35a5767$var$IsPlainObject(duration)) {
            var config = duration;
            x = config.x;
            y = config.y;
            if (config.hasOwnProperty("speed")) duration = $5ee72f51e35a5767$var$DistanceBetween(x, y, this.x, this.y) * 1000 / config.speed;
            else duration = config.duration;
            ease = config.ease;
        }
        var isInit = this._easeMove === undefined;
        this._easeMove = (0, $eeb9cc7ef6d9e9f6$export$2e2bcd8739ae039)(this, duration, x, y, ease, destroyMode, this._easeMove);
        if (isInit) $5ee72f51e35a5767$var$OnInitEaseMove(this, this._easeMove);
        this._easeMove.completeEventName = "moveto.complete";
        return this;
    },
    moveToPromise (duration, x, y, ease, destroyMode) {
        this.moveTo(duration, x, y, ease, destroyMode);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._easeMove);
    },
    moveToDestroy (duration, x, y, ease) {
        this.moveTo(duration, x, y, ease, true);
        return this;
    },
    moveToDestroyPromise (duration, x, y, ease) {
        this.moveToDestroy(duration, x, y, ease, true);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._easeMove);
    },
    moveStop (toEnd) {
        if (!this._easeMove) return this;
        this._easeMove.stop(toEnd);
        return this;
    }
};




const $68abb6c752dbe698$var$GetValue = Phaser.Utils.Objects.GetValue;
class $68abb6c752dbe698$var$ShakePosition extends (0, $de3bc6fefe1470a6$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this.timer = new (0, $db278215acdb3af4$export$2e2bcd8739ae039)();
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.timer.resetFromJSON($68abb6c752dbe698$var$GetValue(o, "timer"));
        this.setEnable($68abb6c752dbe698$var$GetValue(o, "enable", true));
        this.setMode($68abb6c752dbe698$var$GetValue(o, "mode", 1));
        this.isRunning = $68abb6c752dbe698$var$GetValue(o, "isRunning", false);
        this.setMagnitudeMode($68abb6c752dbe698$var$GetValue(o, "magnitudeMode", 1));
        this.setAxisMode($68abb6c752dbe698$var$GetValue(o, "axis", 0));
        this.setDuration($68abb6c752dbe698$var$GetValue(o, "duration", 500));
        this.setMagnitude($68abb6c752dbe698$var$GetValue(o, "magnitude", 10));
        this.ox = $68abb6c752dbe698$var$GetValue(o, "ox", undefined);
        this.oy = $68abb6c752dbe698$var$GetValue(o, "oy", undefined);
        return this;
    }
    toJSON() {
        return {
            timer: this.timer.toJSON(),
            enable: this.enable,
            mode: this.mode,
            isRunning: this.isRunning,
            magnitudeMode: magnitudeMode,
            duration: this.duration,
            magnitude: this.magnitude,
            ox: this.ox,
            oy: this.oy
        };
    }
    // override
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        super.shutdown(fromScene);
        this.timer.destroy();
        this.timer = undefined;
    }
    startTicking() {
        super.startTicking();
        if (this.mode === 0) {
            this.scene.game.events.on("poststep", this.update, this);
            this.scene.game.events.on("prestep", this.backToOrigin, this);
        } else this.scene.sys.events.on("preupdate", this.update, this);
    }
    stopTicking() {
        super.stopTicking();
        if (this.scene) {
            if (this.mode === 0) {
                this.scene.game.events.off("poststep", this.update, this);
                this.scene.game.events.off("prestep", this.backToOrigin, this);
            } else this.scene.sys.events.off("preupdate", this.update, this);
        }
    }
    setEnable(e) {
        if (e == undefined) e = true;
        this.enable = e;
        return this;
    }
    setMode(mode) {
        if (typeof mode === "string") mode = $68abb6c752dbe698$var$MODE[mode];
        this.mode = mode;
        return this;
    }
    setMagnitudeMode(magnitudeMode1) {
        if (typeof magnitudeMode1 === "string") magnitudeMode1 = $68abb6c752dbe698$var$MANITUDEMODE[magnitudeMode1];
        this.magnitudeMode = magnitudeMode1;
        return this;
    }
    setAxisMode(m) {
        if (typeof m === "string") m = $68abb6c752dbe698$var$DIRECTIONNODE[m];
        this.axisMode = m;
        return this;
    }
    setDuration(duration) {
        this.duration = duration;
        return this;
    }
    setMagnitude(magnitude) {
        this.magnitude = magnitude;
        return this;
    }
    start(duration, magnitude) {
        if (typeof duration !== "number") {
            var config = duration;
            magnitude = $68abb6c752dbe698$var$GetValue(config, "magnitude", undefined);
            duration = $68abb6c752dbe698$var$GetValue(config, "duration", undefined);
        }
        if (magnitude !== undefined) this.setMagnitude(magnitude);
        if (duration !== undefined) this.setDuration(duration);
        this.timer.setDuration(this.duration).start();
        super.start();
        return this;
    }
    shake(duration, magnitude) {
        this.start(duration, magnitude);
        return this;
    }
    update(time, delta) {
        if (!this.isRunning || !this.enable) return this;
        var gameObject = this.parent;
        if (!gameObject.active) return this;
        this.timer.update(time, delta);
        if (this.timer.isDone) {
            this.backToOrigin();
            this.complete();
        } else {
            if (this.ox === undefined) {
                this.ox = gameObject.x;
                this.oy = gameObject.y;
            }
            var magnitude = this.magnitude;
            if (this.magnitudeMode === 1) magnitude *= 1 - this.timer.t;
            var a = Math.random() * Math.PI * 2;
            var x = this.ox + Math.cos(a) * magnitude;
            var y = this.oy + Math.sin(a) * magnitude;
            switch(this.axisMode){
                case 1:
                    gameObject.x = x;
                    break;
                case 2:
                    gameObject.y = y;
                    break;
                default:
                    gameObject.x = x;
                    gameObject.y = y;
                    break;
            }
        }
        return this;
    }
    backToOrigin() {
        if (!this.isRunning || !this.enable) return this;
        if (this.ox === undefined) return this;
        var gameObject = this.parent;
        switch(this.axisMode){
            case 1:
                gameObject.x = this.ox;
                break;
            case 2:
                gameObject.y = this.oy;
                break;
            default:
                gameObject.x = this.ox;
                gameObject.y = this.oy;
                break;
        }
        this.ox = undefined;
        this.oy = undefined;
        return this;
    }
}
const $68abb6c752dbe698$var$MODE = {
    effect: 0,
    behavior: 1
};
const $68abb6c752dbe698$var$DIRECTIONNODE = {
    "both": 0,
    "h&v": 0,
    "x&y": 0,
    "horizontal": 1,
    "h": 1,
    "x": 1,
    "vertical": 2,
    "v": 2,
    "y": 2
};
const $68abb6c752dbe698$var$MANITUDEMODE = {
    constant: 0,
    decay: 1
};
var $68abb6c752dbe698$export$2e2bcd8739ae039 = $68abb6c752dbe698$var$ShakePosition;


var $fb2412b6925fda8e$export$2e2bcd8739ae039 = (0, $68abb6c752dbe698$export$2e2bcd8739ae039);


var $6ab2998d09e67d74$export$2e2bcd8739ae039 = (0, $fb2412b6925fda8e$export$2e2bcd8739ae039);



const $7563a2b4a47f3bfc$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
var $7563a2b4a47f3bfc$var$OnInitShake = function(gameObject, shake) {
    // Route 'complete' of shake to gameObject
    shake.on("complete", function() {
        gameObject.emit("shake.complete", gameObject);
    });
// Shake effect won't change position
};
var $7563a2b4a47f3bfc$export$2e2bcd8739ae039 = {
    shake (duration, magnitude, magnitudeMode) {
        if ($7563a2b4a47f3bfc$var$IsPlainObject(duration)) {
            var config = duration;
            duration = config.duration;
            magnitude = config.magnitude;
            magnitudeMode = config.magnitudeMode;
        }
        if (this._shake === undefined) {
            this._shake = new (0, $6ab2998d09e67d74$export$2e2bcd8739ae039)(this, {
                mode: 0,
                magnitudeMode: 1
            });
            $7563a2b4a47f3bfc$var$OnInitShake(this, this._shake);
        }
        if (duration !== undefined) this._shake.setDuration(duration);
        if (magnitude !== undefined) this._shake.setMagnitude(magnitude);
        if (magnitudeMode !== undefined) this._shake.setMagnitudeMode(magnitudeMode);
        this._shake.shake();
        return this;
    },
    shakePromise (duration, alpha) {
        this.shake(duration, alpha);
        return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(this._shake);
    }
};




const $6bf2a76f63cf975d$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $6bf2a76f63cf975d$var$EaseData extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        this.parent.setDataEnabled();
        this.easeTasks = {};
    }
    complete(key) {
        this.emit(`complete-${key}`, this.parent, this);
        this.emit("complete", key, this.parent, this);
    }
    getEaseTask(key) {
        var easeTask = this.easeTasks[key];
        if (easeTask === undefined) {
            easeTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this.parent);
            this.easeTasks[key] = easeTask;
            easeTask.setTarget(this.parent.data.values).on("complete", function() {
                this.complete(key);
            }, this);
        }
        return easeTask;
    }
    easeTo(key, value, duration, ease) {
        if ($6bf2a76f63cf975d$var$IsPlainObject(key)) {
            var config = key;
            key = config.key;
            value = config.value;
            duration = config.duration;
            ease = config.ease;
            var speed = config.speed;
            if (duration === undefined && speed !== undefined) duration = Math.abs(value - this.parent.data.values[key]) / speed * 1000;
        }
        if (duration === undefined) duration = 1000;
        if (ease === undefined) ease = "Linear";
        var easeTask = this.getEaseTask(key);
        easeTask.restart({
            key: key,
            to: value,
            duration: duration,
            ease: ease
        });
        return this;
    }
    easeFrom(key, value, duration, ease) {
        if ($6bf2a76f63cf975d$var$IsPlainObject(key)) {
            var config = key;
            key = config.key;
            value = config.value;
            duration = config.duration;
            ease = config.ease;
            var speed = config.speed;
            if (duration === undefined && speed !== undefined) duration = Math.abs(value - this.parent.data.values[key]) / speed * 1000;
        }
        if (duration === undefined) duration = 1000;
        if (ease === undefined) ease = "Linear";
        var easeTask = this.getEaseTask(key);
        easeTask.restart({
            key: key,
            from: value,
            duration: duration,
            ease: ease
        });
        return this;
    }
    stopEase(key, toEnd) {
        if (toEnd === undefined) toEnd = true;
        var easeTask = this.easeTasks[key];
        if (easeTask) easeTask.stop(toEnd);
        return this;
    }
    stopAll(toEnd) {
        if (toEnd === undefined) toEnd = true;
        for(var key in this.easeTasks)this.stopEase(key, toEnd);
        return this;
    }
}
var $6bf2a76f63cf975d$export$2e2bcd8739ae039 = $6bf2a76f63cf975d$var$EaseData;





var $1f6812a49491b2c1$var$OnInitEaseData = function(gameObject, easeData) {
    // Route 'complete' of easeData to gameObject
    easeData.on("complete", function(key) {
        gameObject.emit(`easedata.${key}.complete`, gameObject);
        gameObject.emit("easedata.complete", key, gameObject);
    });
};
var $1f6812a49491b2c1$export$2e2bcd8739ae039 = {
    easeDataTo (key, value, duration, ease) {
        if (!this._easeData) {
            this._easeData = new (0, $6bf2a76f63cf975d$export$2e2bcd8739ae039)(this);
            $1f6812a49491b2c1$var$OnInitEaseData(this, this._easeData);
        }
        this._easeData.easeTo(key, value, duration, ease);
        return this;
    },
    easeDataToPromise (key, value, duration, ease) {
        this.easeDataTo(key, value, duration, ease);
        return (0, $2b5b0b08519578fd$export$64e00c1c113b35b1)(this._easeData, `complete-${key}`);
    },
    stopEaseData (key, toEnd) {
        if (!this._easeData) return this;
        this._easeData.stopEase(key, toEnd);
        return this;
    },
    stopAllEaseData (toEnd) {
        if (!this._easeData) return this;
        this._easeData.stopAll(toEnd);
        return this;
    }
};




var $f55461eb0d33b5f5$export$f6a3d19be20f5819 = function(gameObject) {
    $f55461eb0d33b5f5$var$_hide(gameObject, false);
};
var $f55461eb0d33b5f5$export$bed28288a051538 = function(gameObject) {
    $f55461eb0d33b5f5$var$_hide(gameObject, true);
};
var $f55461eb0d33b5f5$export$be736b6b33b78275 = function(gameObject) {
    if (!gameObject) return false;
    var config = (0, $69b2c83c99373b68$export$2e2bcd8739ae039)(gameObject);
    return !config.hidden;
};
var $f55461eb0d33b5f5$var$_hide = function(gameObject, hidden) {
    if (!gameObject) return;
    var config = (0, $69b2c83c99373b68$export$2e2bcd8739ae039)(gameObject);
    config.hidden = hidden;
    var parent = (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4)(gameObject);
    if (parent) parent.setChildVisible(gameObject, !hidden);
    else gameObject.setVisible(!hidden);
};


var $5839d8def94e320c$export$2e2bcd8739ae039 = {
    show (gameObject) {
        if (gameObject === undefined) gameObject = this;
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(gameObject, false);
        return this;
    },
    hide (gameObject) {
        if (gameObject === undefined) gameObject = this;
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(gameObject, true);
        return this;
    },
    isShow (gameObject) {
        if (gameObject === undefined) gameObject = this;
        return (0, $f55461eb0d33b5f5$export$be736b6b33b78275)(gameObject);
    }
};





const $f9c3353eec30c551$var$StateProperties = [
    "next",
    "exit",
    "enter"
];
class $f9c3353eec30c551$var$FSM {
    /*
    var config = {
        start: 'A',   // default: undefined
        states: {
            A: {
                next: 'B',  // function() { return 'B'; }
                enter: function() {},
                exit: function() {},
            },
            // ...
        },        
        extend: {
            i: 0,
            name: 'abc'
            // ...
        },
        init: function() {},
        enable: true,
        eventEmitter: true,
    };
    */ constructor(config){
        // Attach get-next-state function
        var states = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "states", undefined);
        if (states) this.addStates(states);
        // Attach extend members
        var extend = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "extend", undefined);
        if (extend) {
            for(var name in extend)if (!this.hasOwnProperty(name) || this[name] === undefined) this[name] = extend[name];
        }
        // Event emitter
        var eventEmitter = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "eventEmitter", undefined);
        var EventEmitterClass = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "EventEmitterClass", undefined);
        this.setEventEmitter(eventEmitter, EventEmitterClass);
        this._stateLock = false;
        this.resetFromJSON(config);
    }
    shutdown() {
        this.destroyEventEmitter();
    }
    destroy() {
        this.shutdown();
    }
    resetFromJSON(o) {
        this.setEnable((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(o, "enable", true));
        this.start((0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(o, "start", undefined));
        var init = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(o, "init", undefined);
        if (init) init.call(this);
        return this;
    }
    toJSON() {
        return {
            curState: this.state,
            prevState: this.prevState,
            enable: this.enable,
            start: this._start
        };
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    set state(newState) {
        if (!this.enable || this._stateLock) return;
        if (this._state === newState) return;
        this._prevState = this._state;
        this._state = newState;
        this._stateLock = true; // lock state
        this.emit("statechange", this);
        if (this._prevState != null) {
            var exitEventName = "exit_" + this._prevState;
            var exitCallback = this[exitEventName];
            if (exitCallback) exitCallback.call(this);
            this.emit(exitEventName, this);
        }
        this._stateLock = false;
        if (this._state != null) {
            var enterEventName = "enter_" + this._state;
            var enterCallback = this[enterEventName];
            if (enterCallback) enterCallback.call(this);
            this.emit(enterEventName, this);
        }
    }
    get state() {
        return this._state;
    }
    get prevState() {
        return this._prevState;
    }
    start(state) {
        this._start = state;
        this._prevState = undefined;
        this._state = state; // Won't fire statechange events
        return this;
    }
    goto(nextState) {
        if (nextState != null) this.state = nextState;
        return this;
    }
    next() {
        var nextState;
        var getNextState = this["next_" + this.state];
        if (getNextState) {
            if (typeof getNextState === "string") nextState = getNextState;
            else nextState = getNextState.call(this);
        }
        this.goto(nextState);
        return this;
    }
    get stateProperties() {
        return $f9c3353eec30c551$var$StateProperties;
    }
    addState(name, state) {
        if (typeof name !== "string") {
            state = name;
            name = state.name;
        }
        var stateProperties = this.stateProperties;
        for(var i = 0, cnt = stateProperties.length; i < cnt; i++){
            var propertyName = stateProperties[i];
            var propertyValue = state[propertyName];
            if (propertyValue) this[`${propertyName}_${name}`] = propertyValue;
        }
        return this;
    }
    addStates(states) {
        if (Array.isArray(states)) for(var i = 0, cnt = states.length; i < cnt; i++)this.addState(states[i]);
        else for(var name in states)this.addState(name, states[name]);
        return this;
    }
    runMethod(methodName, a1, a2, a3, a4, a5) {
        var fn = this[methodName + "_" + this.state];
        if (!fn) return undefined;
        // Copy from eventemitter3
        var len = arguments.length;
        switch(len){
            case 1:
                return fn.call(this);
            case 2:
                return fn.call(this, a1);
            case 3:
                return fn.call(this, a1, a2);
            case 4:
                return fn.call(this, a1, a2, a3);
            case 5:
                return fn.call(this, a1, a2, a3, a4);
            case 6:
                return fn.call(this, a1, a2, a3, a4, a5);
        }
        var args = new Array(len - 1);
        for(var i = 1; i < len; i++)args[i - 1] = arguments[i];
        return fn.apply(this, args);
    }
}
Object.assign($f9c3353eec30c551$var$FSM.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039));
var $f9c3353eec30c551$export$2e2bcd8739ae039 = $f9c3353eec30c551$var$FSM;



var $314c9a80e6300d0e$var$HasListener = function(eventEmitter, eventName, fn, context, once) {
    if (once === undefined) once = false;
    var listeners = eventEmitter._events[eventName];
    if (!listeners) return false;
    for(var i = 0, cnt = listeners.length; i < cnt; i++){
        var listener = listeners[i];
        if (listener.fn === fn && listener.context === context && listener.once === once) return true;
    }
    return false;
};
var $314c9a80e6300d0e$export$2e2bcd8739ae039 = $314c9a80e6300d0e$var$HasListener;


const $6fbac7201eeee4ca$var$StateProperties = [
    "next",
    "exit",
    "enter",
    "update",
    "preupdate",
    "postupdate"
];
class $6fbac7201eeee4ca$var$FSM extends (0, $f9c3353eec30c551$export$2e2bcd8739ae039) {
    /*
    var config = {
        start: 'A',   // default: undefined
        states: {
            A: {
                next: 'B',  // function() { return 'B'; }
                enter: function() {},
                exit: function() {},
                update: function(time, delta) {},
                preupdate: function(time, delta) {},
                postupdate: function(time, delta) {},
            },
            // ...
        },        
        extend: {
            i: 0,
            name: 'abc'
            // ...
        },
        init: function() {},
        enable: true,
        scene: undefined,
        eventEmitter: true,
    };
    */ shutdown() {
        this.stopUpdate();
        this.stopPreUpdate();
        this.stopPostUpdate();
        this._scene = undefined;
        super.shutdown();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this._scene = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(o, "scene", undefined);
        return this;
    }
    get stateProperties() {
        return $6fbac7201eeee4ca$var$StateProperties;
    }
    update(time, delta) {
        this.runMethod("update", time, delta);
    }
    preupdate(time, delta) {
        this.runMethod("preupdate", time, delta);
    }
    postupdate(time, delta) {
        this.runMethod("postupdate", time, delta);
    }
    startUpdate(scene) {
        if (!scene) scene = this._scene;
        var eventEmitter = scene.sys.events;
        if ((0, $314c9a80e6300d0e$export$2e2bcd8739ae039)(eventEmitter, "update", this.update, this)) return this;
        this._scene = scene;
        eventEmitter.on("update", this.update, this);
        return this;
    }
    stopUpdate() {
        if (!this._scene) return this;
        this._scene.sys.events.off("update", this.update, this);
        return this;
    }
    startPreUpdate(scene) {
        if (!scene) scene = this._scene;
        var eventEmitter = scene.sys.events;
        if ((0, $314c9a80e6300d0e$export$2e2bcd8739ae039)(eventEmitter, "preupdate", this.preupdate, this)) return this;
        this._scene = scene;
        eventEmitter.on("preupdate", this.preupdate, this);
        return this;
    }
    stopPreUpdate() {
        if (!this._scene) return this;
        this._scene.sys.events.off("preupdate", this.preupdate, this);
        return this;
    }
    startPostUpdate(scene) {
        if (!scene) scene = this._scene;
        var eventEmitter = scene.sys.events;
        if ((0, $314c9a80e6300d0e$export$2e2bcd8739ae039)(eventEmitter, "postupdate", this.postupdate, this)) return this;
        this._scene = scene;
        eventEmitter.on("postupdate", this.postupdate, this);
        return this;
    }
    stopPostUpdate() {
        if (!this._scene) return this;
        this._scene.sys.events.off("postupdate", this.postupdate, this);
        return this;
    }
}
var $6fbac7201eeee4ca$export$2e2bcd8739ae039 = $6fbac7201eeee4ca$var$FSM;


var $57ebe48317eef8b7$export$2e2bcd8739ae039 = (0, $6fbac7201eeee4ca$export$2e2bcd8739ae039);


/*
graph TD

IDLE --> |"requestOpen()"| TRANS_OPNE["TRAN_OPEN<br>runTransitionInCallback()"]
TRANS_OPNE --> |transitInTime| OPEN
OPEN --> |"requestClose()"| TRANS_CLOSE["TRANS_CLOSE<br>runTransitionOutCallback()"]
TRANS_CLOSE --> |transitOutTime| CLOSE
CLOSE --> |"requestOpen()"| TRANS_OPNE
*/ class $a59a68eca367061b$var$State extends (0, $57ebe48317eef8b7$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(config);
        this.parent = parent;
        var initState = config.initState || "IDLE";
        this.start(initState);
    }
    init() {
        this.start("IDLE");
    }
    // IDLE -> TRANS_OPNE
    next_IDLE() {
        return "TRANS_OPNE";
    }
    // IDLE
    // TRANS_OPNE -> OPEN
    next_TRANS_OPNE() {
        return "OPEN";
    }
    enter_TRANS_OPNE() {
        var transitionBehavior = this.parent;
        if (transitionBehavior.transitInTime > 0) {
            var delay = transitionBehavior.runTransitionInCallback();
            transitionBehavior.delayCall(delay, this.next, this);
        } else this.next();
    }
    exit_TRANS_OPNE() {
        var transitionBehavior = this.parent;
        transitionBehavior.removeDelayCall();
    }
    // TRANS_OPNE
    // OPEN -> TRANS_CLOSE
    next_OPEN() {
        return "TRANS_CLOSE";
    }
    enter_OPEN() {
        var transitionBehavior = this.parent;
        transitionBehavior.onOpen();
    }
    exit_OPEN() {
        var transitionBehavior = this.parent;
        transitionBehavior.removeDelayCall();
    }
    // OPEN
    // TRANS_CLOSE -> CLOSE
    next_TRANS_CLOSE() {
        return "CLOSE";
    }
    enter_TRANS_CLOSE() {
        var transitionBehavior = this.parent;
        if (transitionBehavior.transitOutTime > 0) {
            var delay = transitionBehavior.runTransitionOutCallback();
            transitionBehavior.delayCall(delay, this.next, this);
        } else this.next();
    }
    exit_TRANS_CLOSE() {
        var transitionBehavior = this.parent;
        transitionBehavior.removeDelayCall();
    }
    // TRANS_CLOSE
    // CLOSE -> TRANS_OPNE
    next_CLOSE() {
        return "TRANS_OPNE";
    }
    enter_CLOSE() {
        var transitionBehavior = this.parent;
        transitionBehavior.onClose();
    }
    exit_CLOSE() {}
    // CLOSE
    canOpen() {
        return this.state === "IDLE" || this.state === "CLOSE";
    }
    canClose() {
        return this.state === "IDLE" || this.state === "OPEN";
    }
}
var $a59a68eca367061b$export$2e2bcd8739ae039 = $a59a68eca367061b$var$State;


var $bf6654c282684795$var$PostUpdateDelayCall = function(gameObject, delay, callback, scope, args) {
    // Invoke callback under scene's 'postupdate' event
    var scene = gameObject.scene;
    var sceneEE = scene.sys.events;
    var timer = scene.time.delayedCall(delay, sceneEE.once, [
        // Event name of scene
        "postupdate",
        // Callback
        function() {
            callback.call(scope, args);
        }
    ], sceneEE // scope, scene's EE
    );
    return timer;
};
var $bf6654c282684795$export$2e2bcd8739ae039 = $bf6654c282684795$var$PostUpdateDelayCall;


var $ecd82bf5df9fbc23$export$2e2bcd8739ae039 = {
    delayCall (delay, callback, scope) {
        // Invoke callback under scene's 'postupdate' event
        this.delayCallTimer = (0, $bf6654c282684795$export$2e2bcd8739ae039)(this, delay, callback, scope);
        return this;
    },
    removeDelayCall () {
        if (this.delayCallTimer) {
            this.delayCallTimer.remove(false);
            this.delayCallTimer = undefined;
        }
        return this;
    }
};



var $21406d51b440f7e4$export$2e2bcd8739ae039 = {
    setTransitInTime (time) {
        this.transitInTime = time;
        return this;
    },
    setTransitOutTime (time) {
        this.transitOutTime = time;
        return this;
    },
    setTransitInCallback (callback) {
        if (!callback) callback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
        this.transitInCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    setTransitOutCallback (callback) {
        if (!callback) callback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
        this.transitOutCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    }
};


var $7519fb3e07e8ffd2$export$2e2bcd8739ae039 = {
    // Override
    runTransitionInCallback () {
        this.transitInCallback(this.parent, this.transitInTime);
        return this.transitInTime;
    },
    // Override
    onOpen () {},
    requestOpen (openEventData, duration) {
        if (!this._state.canOpen()) return this;
        this.openEventData = arguments.length > 0 ? openEventData : this.parent;
        var transitionTimeSave = this.transitInTime;
        if (duration !== undefined) this.transitInTime = duration;
        this._state.goto("TRANS_OPNE");
        this.transitInTime = transitionTimeSave;
        return this;
    }
};


var $1c6e1feba532fce1$export$2e2bcd8739ae039 = {
    // Override
    runTransitionOutCallback () {
        this.transitOutCallback(this.parent, this.transitOutTime);
        return this.transitOutTime;
    },
    // Override
    onClose () {
        // Destroy parent and this behavior
        if (this.oneShotMode) this.parent.destroy();
    },
    requestClose (closeEventData, duration) {
        if (!this._state.canClose) return this;
        this.closeEventData = arguments.length > 0 ? closeEventData : this.parent;
        var transitionTimeSave = this.transitOutTime;
        if (duration !== undefined) this.transitOutTime = duration;
        this._state.goto("TRANS_CLOSE");
        this.transitOutTime = transitionTimeSave;
        return this;
    }
};


var $0d86bc59ea0de161$var$methods = {};
Object.assign($0d86bc59ea0de161$var$methods, (0, $ecd82bf5df9fbc23$export$2e2bcd8739ae039), (0, $21406d51b440f7e4$export$2e2bcd8739ae039), (0, $7519fb3e07e8ffd2$export$2e2bcd8739ae039), (0, $1c6e1feba532fce1$export$2e2bcd8739ae039));
var $0d86bc59ea0de161$export$2e2bcd8739ae039 = $0d86bc59ea0de161$var$methods;


const $0e96a087d32d6b8e$var$GetValue = Phaser.Utils.Objects.GetValue;
class $0e96a087d32d6b8e$var$OpenCloseTransition extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.scene
        this.setTransitInTime($0e96a087d32d6b8e$var$GetValue(config, "duration.in", 200));
        this.setTransitOutTime($0e96a087d32d6b8e$var$GetValue(config, "duration.out", 200));
        this.setTransitInCallback($0e96a087d32d6b8e$var$GetValue(config, "transitIn"));
        this.setTransitOutCallback($0e96a087d32d6b8e$var$GetValue(config, "transitOut"));
        this.oneShotMode = $0e96a087d32d6b8e$var$GetValue(config, "destroy", false);
        this.delayCallTimer = undefined;
        this._state = new (0, $a59a68eca367061b$export$2e2bcd8739ae039)(this, {
            eventEmitter: false,
            initState: $0e96a087d32d6b8e$var$GetValue(config, "initState", "IDLE")
        });
        this.openEventData = undefined;
        this.closeEventData = undefined;
    }
    get state() {
        return this._state.state;
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.transitInCallback = undefined;
        this.transitOutCallback = undefined;
        this.openEventData = undefined;
        this.closeEventData = undefined;
        this.removeDelayCall();
        super.shutdown(fromScene);
    }
}
Object.assign($0e96a087d32d6b8e$var$OpenCloseTransition.prototype, (0, $0d86bc59ea0de161$export$2e2bcd8739ae039));
var $0e96a087d32d6b8e$export$2e2bcd8739ae039 = $0e96a087d32d6b8e$var$OpenCloseTransition;


const $ef4c8b73b47b333b$var$Rectangle = Phaser.GameObjects.Rectangle;
class $ef4c8b73b47b333b$var$FullWindowRectangle extends $ef4c8b73b47b333b$var$Rectangle {
    constructor(scene, color, alpha){
        super(scene, 0, 0, 2, 2, color, 1);
        this.setAlpha(alpha);
        this.setScrollFactor(0);
        this.boot();
    }
    boot() {
        var scene = this.scene;
        scene.sys.events.on("prerender", this.resize, this);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.scene.sys.events.off("prerender", this.resize, this);
        super.destroy(fromScene);
    }
    get tint() {
        return this.fillColor;
    }
    set tint(value) {
        this.setFillStyle(value, this.fillAlpha);
    }
    resize() {
        var scene = this.scene;
        var gameSize = scene.sys.scale.gameSize;
        var camera = scene.sys.cameras.main;
        var gameWidth = gameSize.width, gameHeight = gameSize.height, scale = 1 / camera.zoom;
        var x = gameWidth / 2, y = gameHeight / 2, width = gameWidth * scale, height = gameHeight * scale;
        if (this.x !== x || this.y !== y) this.setPosition(x, y);
        if (this.width !== width || this.height !== height) this.setSize(width, height).setOrigin(0.5);
    }
}
var $ef4c8b73b47b333b$export$2e2bcd8739ae039 = $ef4c8b73b47b333b$var$FullWindowRectangle;



const $68e42c4eb1100300$var$GetValue = Phaser.Utils.Objects.GetValue;
class $68e42c4eb1100300$var$TouchEventStop extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, {
            eventEmitter: false
        });
        // No event emitter
        // this.parent = gameObject;
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.setHitAreaMode($68e42c4eb1100300$var$GetValue(o, "hitAreaMode", 0));
        this.setEnable($68e42c4eb1100300$var$GetValue(o, "enable", true));
        this.setStopMode($68e42c4eb1100300$var$GetValue(o, "stopAllLevels", true));
        return this;
    }
    boot() {
        this.parent.on("pointerdown", function(pointer, localX, localY, event) {
            if (this.stopAllLevels) event.stopPropagation();
        }, this).on("pointerup", function(pointer, localX, localY, event) {
            if (this.stopAllLevels) event.stopPropagation();
        }, this).on("pointermove", function(pointer, localX, localY, event) {
            if (this.stopAllLevels) event.stopPropagation();
        }, this).on("pointerover", function(pointer, localX, localY, event) {
            if (this.stopAllLevels) event.stopPropagation();
        }, this).on("pointerout", function(pointer, event) {
            if (this.stopAllLevels) event.stopPropagation();
        }, this);
    }
    setHitAreaMode(mode) {
        if (typeof mode === "string") mode = $68e42c4eb1100300$var$HitAreaMode[mode];
        var gameObject = this.parent;
        if (gameObject.input) gameObject.removeInteractive();
        if (mode === 0) gameObject.setInteractive();
        else gameObject.setInteractive({
            hitArea: {},
            hitAreaCallback: function() {
                return true;
            }
        });
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        if (e) this.parent.setInteractive();
        else this.parent.disableInteractive();
        this.enable = e;
        return this;
    }
    setStopMode(allLevels) {
        if (allLevels === undefined) allLevels = true;
        this.stopAllLevels = allLevels;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
}
var $68e42c4eb1100300$var$HitAreaMode = {
    default: 0,
    fullWindow: 1
};
var $68e42c4eb1100300$export$2e2bcd8739ae039 = $68e42c4eb1100300$var$TouchEventStop;


const $699a25c94ddc77a8$var$GetValue = Phaser.Utils.Objects.GetValue;
class $699a25c94ddc77a8$var$Cover extends (0, $ef4c8b73b47b333b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        var fillColor = $699a25c94ddc77a8$var$GetValue(config, "color", 0x0);
        var fillAlpha = $699a25c94ddc77a8$var$GetValue(config, "alpha", 0.8);
        super(scene, fillColor, fillAlpha);
        this.touchEventStop = new (0, $68e42c4eb1100300$export$2e2bcd8739ae039)(this, {
            hitAreaMode: 1
        });
    }
}
var $699a25c94ddc77a8$export$2e2bcd8739ae039 = $699a25c94ddc77a8$var$Cover;


var $adef7ea87cd5a36d$var$CreateCover = function(gameObject, config) {
    var scene = gameObject.scene;
    var cover = new (0, $699a25c94ddc77a8$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(cover);
    // Put cover behind game object
    if (gameObject.isRexContainerLite) {
        gameObject.moveDepthBelow(cover);
        gameObject.pin(cover, {
            syncPosition: false,
            syncRotation: false,
            syncScale: false,
            syncAlpha: false,
            syncScrollFactor: false
        });
    } else scene.children.moveBelow(cover, gameObject);
    return cover;
};
var $adef7ea87cd5a36d$export$2e2bcd8739ae039 = $adef7ea87cd5a36d$var$CreateCover;






var $40d5b7908bf1c7cc$export$2e2bcd8739ae039 = {
    popUp (gameObject, duration) {
        if (gameObject._modalScaleSave !== undefined) {
            gameObject.scaleX = gameObject._modalScaleSave;
            gameObject.scaleY = gameObject._modalScaleSave;
        } else gameObject._modalScaleSave = gameObject.scaleX;
        (0, $7fc63b8d8e1b2022$export$2e2bcd8739ae039)(gameObject, duration);
    },
    scaleDown (gameObject, duration) {
        // Don't destroy here
        (0, $188d7bfa74eda983$export$2e2bcd8739ae039)(gameObject, duration, undefined, undefined, false);
    },
    fadeIn (gameObject, duration) {
        if (gameObject._modalAlphaSave !== undefined) gameObject.alpha = gameObject._modalAlphaSave;
        else gameObject._modalAlphaSave = gameObject.alpha;
        (0, $0b78b699f711afbf$export$2e2bcd8739ae039)(gameObject, duration);
    },
    fadeOut (gameObject, duration) {
        // Don't destroy here
        (0, $607af573d5a48304$export$2e2bcd8739ae039)(gameObject, duration, false);
    }
};




var $ecacf4d4d2e2232a$export$53f1749d004a2c4e = function(cover, duration) {
    if (cover._modalAlphaSave !== undefined) cover.alpha = cover._modalAlphaSave;
    else cover._modalAlphaSave = cover.alpha;
    (0, $0b78b699f711afbf$export$2e2bcd8739ae039)(cover, duration, cover.alpha);
};
var $ecacf4d4d2e2232a$export$e87550a231b6d89a = function(cover, duration) {
    (0, $607af573d5a48304$export$2e2bcd8739ae039)(cover, duration, false);
};



var $56f678951934d060$var$IsPointInBounds = function(gameObject, x, y, preTest, postTest) {
    // Can't get bounds
    if (!gameObject) return false;
    if (preTest && !preTest(gameObject, x, y)) return false;
    var boundsRect = (0, $bf502811d69b7d21$export$a48dd0a2c64c17f2)(gameObject, true);
    if (!boundsRect.contains(x, y)) return false;
    if (postTest && !postTest(gameObject, x, y)) return false;
    return true;
};
var $56f678951934d060$export$2e2bcd8739ae039 = $56f678951934d060$var$IsPointInBounds;


const $3d1e50ddfacd71c8$var$GetValue = Phaser.Utils.Objects.GetValue;
class $3d1e50ddfacd71c8$var$Modal extends (0, $0e96a087d32d6b8e$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        if (config === undefined) config = {};
        if (config.transitIn == null) config.transitIn = $3d1e50ddfacd71c8$var$TransitionMode.popUp;
        if (config.transitOut == null) config.transitOut = $3d1e50ddfacd71c8$var$TransitionMode.scaleDown;
        config.destroy = $3d1e50ddfacd71c8$var$GetValue(config, "destroy", true);
        super(gameObject, config);
        // this.parent = gameObject;
        // this.scene
        // Cover : key of modal, to block touch input        
        var coverConfig = $3d1e50ddfacd71c8$var$GetValue(config, "cover");
        this.cover = coverConfig !== false ? (0, $adef7ea87cd5a36d$export$2e2bcd8739ae039)(gameObject, coverConfig) : undefined;
        if (this.cover) {
            this.setCoverTransitInCallback($3d1e50ddfacd71c8$var$GetValue(coverConfig, "transitIn", (0, $ecacf4d4d2e2232a$export$53f1749d004a2c4e)));
            this.setCoverTransitOutCallback($3d1e50ddfacd71c8$var$GetValue(coverConfig, "transitOut", (0, $ecacf4d4d2e2232a$export$e87550a231b6d89a)));
        }
        // Close conditions:
        var touchOutsideClose = $3d1e50ddfacd71c8$var$GetValue(config, "touchOutsideClose", false);
        var timeOutDuration = $3d1e50ddfacd71c8$var$GetValue(config, "duration.hold", -1);
        var timeOutClose = $3d1e50ddfacd71c8$var$GetValue(config, "timeOutClose", timeOutDuration >= 0);
        var anyTouchClose = $3d1e50ddfacd71c8$var$GetValue(config, "anyTouchClose", false);
        var manualClose = $3d1e50ddfacd71c8$var$GetValue(config, "manualClose", false);
        if (manualClose) {
            touchOutsideClose = false;
            anyTouchClose = false;
            timeOutClose = false;
        }
        if (anyTouchClose) touchOutsideClose = false;
        if (timeOutClose) this.setDisplayTime(timeOutDuration);
        else this.setDisplayTime(-1);
        // Registet touch-close event after opened
        if (anyTouchClose) this.once("open", this.anyTouchClose, this);
        else if (touchOutsideClose) this.once("open", this.touchOutsideClose, this);
        if ($3d1e50ddfacd71c8$var$GetValue(config, "openOnStart", true)) // Run this.requestOpen() next tick
        // User can register events before this.requestOpen()
        this.delayCall(0, this.requestOpen, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // Registered in touchOutsideClose(), or anyTouchClose()
        if (!this.cover) this.scene.input.off("pointerup", this.touchCloseCallback, this);
        if (this.cover && !fromScene) {
            this.cover.destroy();
            this.cover = undefined;
        }
        super.shutdown(fromScene);
    }
    touchOutsideClose() {
        if (this.cover) this.cover.on("pointerup", this.touchCloseCallback, this);
        else this.scene.input.on("pointerup", this.touchCloseCallback, this);
        this.clickOutsideTest = true;
        return this;
    }
    anyTouchClose() {
        if (this.cover) this.cover.once("pointerup", this.touchCloseCallback, this);
        else this.scene.input.once("pointerup", this.touchCloseCallback, this);
        return this;
    }
    touchCloseCallback(pointer) {
        if (this.clickOutsideTest && (0, $56f678951934d060$export$2e2bcd8739ae039)(this.parent, pointer.worldX, pointer.worldY)) return;
        this.requestClose();
    }
    runTransitionInCallback() {
        var duration = super.runTransitionInCallback();
        var cover = this.cover;
        if (cover && this.coverTransitInCallback) this.coverTransitInCallback(cover, duration);
        return duration;
    }
    runTransitionOutCallback() {
        var duration = super.runTransitionOutCallback();
        var cover = this.cover;
        if (cover && this.coverTransitOutCallback) this.coverTransitOutCallback(cover, duration);
        return duration;
    }
    onOpen() {
        var duration = this.displayTime;
        if (duration >= 0) this.delayCall(duration, this.requestClose, this // scope
        );
        this.emit("open", this.parent, this);
        super.onOpen();
    }
    onClose() {
        this.emit("close", this.closeEventData);
        super.onClose();
    }
    setDisplayTime(time) {
        this.displayTime = time;
        return this;
    }
    setTransitInCallback(callback) {
        if (typeof callback === "string") callback = $3d1e50ddfacd71c8$var$TransitionMode[callback];
        switch(callback){
            case $3d1e50ddfacd71c8$var$TransitionMode.popUp:
                callback = (0, $40d5b7908bf1c7cc$export$2e2bcd8739ae039).popUp;
                break;
            case $3d1e50ddfacd71c8$var$TransitionMode.fadeIn:
                callback = (0, $40d5b7908bf1c7cc$export$2e2bcd8739ae039).fadeIn;
                break;
        }
        super.setTransitInCallback(callback);
        // callback = function(gameObject, duration) {}
        return this;
    }
    setTransitOutCallback(callback) {
        if (typeof callback === "string") callback = $3d1e50ddfacd71c8$var$TransitionMode[callback];
        switch(callback){
            case $3d1e50ddfacd71c8$var$TransitionMode.scaleDown:
                callback = (0, $40d5b7908bf1c7cc$export$2e2bcd8739ae039).scaleDown;
                break;
            case $3d1e50ddfacd71c8$var$TransitionMode.fadeOut:
                callback = (0, $40d5b7908bf1c7cc$export$2e2bcd8739ae039).fadeOut;
                break;
        }
        super.setTransitOutCallback(callback);
        // callback = function(gameObject, duration) {}
        return this;
    }
    setCoverTransitInCallback(callback) {
        this.coverTransitInCallback = callback;
        return this;
    }
    setCoverTransitOutCallback(callback) {
        this.coverTransitOutCallback = callback;
        return this;
    }
}
const $3d1e50ddfacd71c8$var$TransitionMode = {
    popUp: 0,
    fadeIn: 1,
    scaleDown: 0,
    fadeOut: 1
};
var $3d1e50ddfacd71c8$export$2e2bcd8739ae039 = $3d1e50ddfacd71c8$var$Modal;



var $afe4e67dd61048bf$export$2b77a92f1a5ad772 = function(gameObject, config) {
    var modalBehavior = new (0, $3d1e50ddfacd71c8$export$2e2bcd8739ae039)(gameObject, config);
    // Route modal's 'open', 'close' event
    modalBehavior.on("open", function() {
        gameObject.emit("modal.open", modalBehavior);
    });
    modalBehavior.on("close", function(closeEventData) {
        gameObject.emit("modal.close", closeEventData, modalBehavior);
    });
    // Reigster 'modal.requestClose' event for invoking modalBehavior.requestClose() method
    gameObject.on("modal.requestClose", modalBehavior.requestClose, modalBehavior);
    /*
    It is not necessary to turn off gameObject's 'modal.requestClose' event because that :

    - If `config.destroy` is `undefined` (or `true), gameObject and modalBehavior will be destroyed
    - If `config.destroy` is `false` (for reusing dialog), keeping gameObject and modalBehavior 
    */ return modalBehavior;
};
var $afe4e67dd61048bf$export$6667d84de02f0870 = function(gameObject, config) {
    var modalBehavior = $afe4e67dd61048bf$export$2b77a92f1a5ad772(gameObject, config);
    return new Promise(function(resolve, reject) {
        modalBehavior.once("close", function(closeEventData) {
            resolve(closeEventData);
        });
    });
};
var $afe4e67dd61048bf$export$9bf0f2717ffc648c = function(gameObject, closeEventData) {
    gameObject.emit("modal.requestClose", closeEventData);
};






var $761920aac251583f$var$IsFunction = function(obj) {
    return obj && typeof obj === "function";
};
var $761920aac251583f$export$2e2bcd8739ae039 = $761920aac251583f$var$IsFunction;


var $01897f2cfdbbb3a7$export$2e2bcd8739ae039 = {
    // Override
    // onCreateModalBehavior(self, config) { },
    modal (config, onClose) {
        if ((0, $761920aac251583f$export$2e2bcd8739ae039)(config)) {
            onClose = config;
            config = undefined;
        }
        if (this._modalBehavior === undefined) {
            if (this.onCreateModalBehavior) this.onCreateModalBehavior(this, config);
            this._modalBehavior = (0, $afe4e67dd61048bf$export$2b77a92f1a5ad772)(this, config);
        }
        if (onClose) this._modalBehavior.once("close", onClose);
        this._modalBehavior.requestOpen();
        return this;
    },
    modalPromise (config) {
        var self = this;
        return new Promise(function(resolve, reject) {
            self.modal(config, resolve);
        });
    },
    modalClose (closeEventData) {
        (0, $afe4e67dd61048bf$export$9bf0f2717ffc648c)(this, closeEventData);
        return this;
    }
};



var $e4fa7f2032964b1a$var$IsPointerInBounds = function(gameObject, pointer, preTest, postTest) {
    if (pointer) return (0, $56f678951934d060$export$2e2bcd8739ae039)(gameObject, pointer.worldX, pointer.worldY, preTest, postTest);
    else {
        var inputManager = gameObject.scene.input.manager;
        var pointersTotal = inputManager.pointersTotal;
        var pointers = inputManager.pointers;
        for(var i = 0; i < pointersTotal; i++){
            pointer = pointers[i];
            if ((0, $56f678951934d060$export$2e2bcd8739ae039)(gameObject, pointer.worldX, pointer.worldY, preTest, postTest)) return true;
        }
        return false;
    }
};
var $e4fa7f2032964b1a$export$2e2bcd8739ae039 = $e4fa7f2032964b1a$var$IsPointerInBounds;


const $028756cbb60d16db$var$GameObjectClass = Phaser.GameObjects.GameObject;
var $028756cbb60d16db$var$IsGameObject = function(object) {
    return object instanceof $028756cbb60d16db$var$GameObjectClass;
};
var $028756cbb60d16db$export$2e2bcd8739ae039 = $028756cbb60d16db$var$IsGameObject;


var $f4c6c96ddcd95232$var$IsInTouching = function(pointer, gameObject) {
    if ((0, $028756cbb60d16db$export$2e2bcd8739ae039)(pointer) || typeof pointer === "string") {
        gameObject = pointer;
        pointer = undefined;
    }
    if (gameObject === undefined) gameObject = this;
    else if (typeof gameObject === "string") gameObject = this.getElement(gameObject);
    return (0, $e4fa7f2032964b1a$export$2e2bcd8739ae039)(gameObject, pointer);
};
var $f4c6c96ddcd95232$export$2e2bcd8739ae039 = $f4c6c96ddcd95232$var$IsInTouching;



var $2d252120406e33cc$var$IsArray = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
var $2d252120406e33cc$export$2e2bcd8739ae039 = $2d252120406e33cc$var$IsArray;



var $a96d1cc514159357$var$ContainsPoint = function(gameObject, x, y, preTest, postTest) {
    return (0, $56f678951934d060$export$2e2bcd8739ae039)(gameObject, x, y, $a96d1cc514159357$var$GetPreTestCallback(preTest), $a96d1cc514159357$var$GetPostTestCallback(postTest));
};
var $a96d1cc514159357$var$IsNotHiddenSizer = function(gameObject) {
    var isHiddenSizer = gameObject.rexSizer && gameObject.rexSizer.hidden;
    return !isHiddenSizer;
};
var $a96d1cc514159357$var$GetPreTestCallback = function(preTest) {
    if (!preTest) return $a96d1cc514159357$var$IsNotHiddenSizer;
    return function(gameObject, x, y) {
        if (!$a96d1cc514159357$var$IsNotHiddenSizer(gameObject)) return false;
        preTest(gameObject, x, y);
        return true;
    };
};
var $a96d1cc514159357$var$GetPostTestCallback = function(postTest) {
    return postTest;
};
var $a96d1cc514159357$export$2e2bcd8739ae039 = $a96d1cc514159357$var$ContainsPoint;


var $c0e2b01b94bb68dd$var$PointToChild = function(x, y, preTest, postTest, children) {
    if (!(0, $761920aac251583f$export$2e2bcd8739ae039)(preTest)) {
        children = preTest;
        preTest = undefined;
        postTest = undefined;
    }
    if (children === undefined) {
        if (this.sizerChildren) children = this.sizerChildren;
        else children = this.children;
    }
    if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(children)) {
        var child;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            child = children[i];
            if ((0, $a96d1cc514159357$export$2e2bcd8739ae039)(child, x, y, preTest, postTest)) return child;
        }
    } else {
        var child;
        for(var key in children){
            child = children[key];
            if ((0, $a96d1cc514159357$export$2e2bcd8739ae039)(child, x, y, preTest, postTest)) return child;
        }
    }
    return null;
};
var $c0e2b01b94bb68dd$export$2e2bcd8739ae039 = $c0e2b01b94bb68dd$var$PointToChild;



var $70a3d2b487b0ec73$var$ResizeGameObject = function(gameObject, newWidth, newHeight) {
    if (!gameObject || newWidth === undefined && newHeight === undefined) return;
    if (gameObject.resize) {
        if (newWidth === undefined) newWidth = gameObject.width;
        if (newHeight === undefined) newHeight = gameObject.height;
        gameObject.resize(newWidth, newHeight);
    } else {
        if (newWidth !== undefined) gameObject.displayWidth = newWidth;
        if (newHeight !== undefined) gameObject.displayHeight = newHeight;
    }
};
var $70a3d2b487b0ec73$export$2e2bcd8739ae039 = $70a3d2b487b0ec73$var$ResizeGameObject;


var $6e7e58b6967dc16b$var$CopyState = function(gamObject, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $6e7e58b6967dc16b$var$GlobState;
    out.x = gamObject.x;
    out.y = gamObject.y;
    out.scaleX = gamObject.scaleX;
    out.scaleY = gamObject.scaleY;
    out.width = gamObject.width;
    out.height = gamObject.height;
    out.displayWidth = gamObject.displayWidth;
    out.displayHeight = gamObject.displayHeight;
    return out;
};
var $6e7e58b6967dc16b$var$GlobState = {};
var $6e7e58b6967dc16b$export$2e2bcd8739ae039 = $6e7e58b6967dc16b$var$CopyState;


var $977b9616557db798$var$PreLayoutChild = function(child) {
    if (this.sizerEventsEnable) {
        (0, $6e7e58b6967dc16b$export$2e2bcd8739ae039)(child, this.getChildPrevState(child));
        this.layoutedChildren.push(child);
    }
};
var $977b9616557db798$export$2e2bcd8739ae039 = $977b9616557db798$var$PreLayoutChild;



var $ba01042a1e30641f$var$LayoutChild = function(child, x, y, width, height, align, offsetX, offsetY) {
    (0, $b7e28befb839484c$export$2e2bcd8739ae039)(child, x, y, width, height, align);
    if (offsetX !== undefined) child.x += offsetX;
    if (offsetY !== undefined) child.y += offsetY;
    this.resetChildPositionState(child);
    if (this.sizerEventsEnable) child.emit("sizer.postlayout", child, this);
};
var $ba01042a1e30641f$export$2e2bcd8739ae039 = $ba01042a1e30641f$var$LayoutChild;


const $5c7762eac7c78464$var$ALIGN_CENTER = Phaser.Display.Align.CENTER;
var $5c7762eac7c78464$var$LayoutBackgrounds = function() {
    if (this.backgroundChildren === undefined) return;
    var backgrounds = this.backgroundChildren;
    var startX = this.left, startY = this.top;
    var parentWidth = this.width, parentHeight = this.height;
    var child, childConfig, padding, x, y, width, height;
    for(var i = 0, cnt = backgrounds.length; i < cnt; i++){
        child = backgrounds[i];
        childConfig = child.rexSizer;
        if (childConfig.hidden) continue;
        padding = childConfig.padding;
        (0, $977b9616557db798$export$2e2bcd8739ae039).call(this, child);
        x = startX + padding.left;
        y = startY + padding.top;
        width = parentWidth - padding.left - padding.right;
        height = parentHeight - padding.top - padding.bottom;
        (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, width, height);
        (0, $ba01042a1e30641f$export$2e2bcd8739ae039).call(this, child, x, y, width, height, $5c7762eac7c78464$var$ALIGN_CENTER);
    }
};
var $5c7762eac7c78464$export$2e2bcd8739ae039 = $5c7762eac7c78464$var$LayoutBackgrounds;


var $685a5a748c64a392$var$SetDraggable = function(senser, draggable) {
    var senserType = typeof senser;
    if (senserType === "string") {
        var senserName = senser;
        senser = this.getElement(senserName);
        if (!senser) {
            console.error(`Can get element '${senserName}'`);
            return this;
        }
    } else if (senser === undefined || senserType != "object") {
        draggable = senser;
        senser = this;
    }
    if (draggable === undefined) draggable = true;
    if (senser.input && senser.input._dragTopmostSizer) // Draggable is already registered
    senser.input.draggable = draggable;
    else if (draggable) {
        // Register draggable
        senser.setInteractive();
        senser.scene.input.setDraggable(senser);
        senser.on("drag", function(pointer, dragX, dragY) {
            var topmostParent = this.getTopmostSizer();
            topmostParent.x += dragX - senser.x;
            topmostParent.y += dragY - senser.y;
            topmostParent.emit("sizer.drag", pointer, dragX, dragY);
        }, this).on("dragstart", function(pointer, dragX, dragY) {
            var topmostParent = this.getTopmostSizer();
            topmostParent.emit("sizer.dragstart", pointer, dragX, dragY);
        }, this).on("dragend", function(pointer, dragX, dragY, dropped) {
            var topmostParent = this.getTopmostSizer();
            topmostParent.emit("sizer.dragend", pointer, dragX, dragY, dropped);
        }, this);
        senser.input._dragTopmostSizer = true;
    }
    return this;
};
var $685a5a748c64a392$export$2e2bcd8739ae039 = $685a5a748c64a392$var$SetDraggable;



var $30feda3e405b43bc$export$2e2bcd8739ae039 = (0, $d7386e5b0e39fd99$export$2e2bcd8739ae039);


var $24e6f4a5f37412ea$export$2e2bcd8739ae039 = (0, $30feda3e405b43bc$export$2e2bcd8739ae039);


var $d714fc8f92a6e32b$export$2e2bcd8739ae039 = {
    onClick (gameObject, callback, scope, config) {
        if (!gameObject) return this;
        if (typeof gameObject === "function") {
            config = scope;
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._click === undefined) gameObject._click = new (0, $24e6f4a5f37412ea$export$2e2bcd8739ae039)(gameObject, config);
        gameObject._click.on("click", callback, scope);
        return this;
    },
    offClick (gameObject, callback, scope) {
        if (typeof gameObject === "function") {
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._click === undefined) return this;
        gameObject._click.off("click", callback, scope);
        return this;
    },
    enableClick (gameObject, enabled) {
        if (gameObject && typeof gameObject !== "object") {
            enabled = gameObject;
            gameObject = this;
        }
        if (gameObject._click === undefined) return this;
        gameObject._click.setEnable(enabled);
        return this;
    },
    disableClick (gameObject) {
        if (gameObject && typeof gameObject !== "object") gameObject = this;
        if (gameObject._click === undefined) return this;
        gameObject._click.setEnable(false);
        return this;
    }
};





const $650d353d3e8913b8$var$GetValue = Phaser.Utils.Objects.GetValue;
class $650d353d3e8913b8$var$ClickOutside extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this._enable = undefined;
        var inputConfig = $650d353d3e8913b8$var$GetValue(config, "inputConfig", undefined);
        if (inputConfig) gameObject.setInteractive(inputConfig);
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.setEnable($650d353d3e8913b8$var$GetValue(o, "enable", true));
        this.setMode($650d353d3e8913b8$var$GetValue(o, "mode", 1));
        this.setClickInterval($650d353d3e8913b8$var$GetValue(o, "clickInterval", 100));
        return this;
    }
    boot() {
        var scene = this.parent.scene;
        scene.input.on("pointerdown", this.onPress, this);
        scene.input.on("pointerup", this.onRelease, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        var scene = this.parent.scene;
        scene.input.off("pointerdown", this.onPress, this);
        scene.input.off("pointerup", this.onRelease, this);
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        this._enable = e;
        var eventName = e ? "enable" : "disable";
        this.emit(eventName, this, this.parent);
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    setMode(m) {
        if (typeof m === "string") m = $650d353d3e8913b8$var$CLICKMODE[m];
        this.mode = m;
        return this;
    }
    setClickInterval(interval) {
        this.clickInterval = interval; // ms
        return this;
    }
    isPointerInside(pointer) {
        var gameObject = this.parent;
        var isInsideCallback = gameObject.input ? (0, $13b05035f77fdc38$export$2e2bcd8739ae039) : (0, $e4fa7f2032964b1a$export$2e2bcd8739ae039);
        return isInsideCallback(gameObject, pointer);
    }
    // internal
    onPress(pointer) {
        if (this.mode === 0) {
            // Do nothing if game object is not visible
            if (!this.parent.willRender(pointer.camera)) return;
            if (!this.isPointerInside(pointer)) this.click(pointer.downTime, pointer);
        }
    }
    onRelease(pointer) {
        if (this.mode === 1) {
            // Do nothing if game object is not visible
            if (!this.parent.willRender(pointer.camera)) return;
            if (!this.isPointerInside(pointer)) this.click(pointer.upTime, pointer);
        }
    }
    click(nowTime, pointer) {
        if (!this.enable) return this;
        if (nowTime === undefined) {
            // fires 'clickoutside' event manually
            this.emit("clickoutside", this, this.parent, pointer);
            return this;
        }
        var lastClickTime = this.lastClickTime;
        if (lastClickTime !== undefined && nowTime - lastClickTime <= this.clickInterval) return this;
        this.lastClickTime = nowTime;
        this.emit("clickoutside", this, this.parent, pointer);
        return this;
    }
}
const $650d353d3e8913b8$var$CLICKMODE = {
    press: 0,
    pointerdown: 0,
    release: 1,
    pointerup: 1
};
var $650d353d3e8913b8$export$2e2bcd8739ae039 = $650d353d3e8913b8$var$ClickOutside;


var $8be604647dac5288$export$2e2bcd8739ae039 = (0, $650d353d3e8913b8$export$2e2bcd8739ae039);


var $9f1db0a44efe872e$export$2e2bcd8739ae039 = (0, $8be604647dac5288$export$2e2bcd8739ae039);


var $7f51dfbd7392611f$export$2e2bcd8739ae039 = {
    onClickOutside (gameObject, callback, scope, config) {
        if (!gameObject) return this;
        if (typeof gameObject === "function") {
            config = scope;
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._clickOutside === undefined) gameObject._clickOutside = new (0, $9f1db0a44efe872e$export$2e2bcd8739ae039)(gameObject, config);
        gameObject._clickOutside.on("clickoutside", callback, scope);
        return this;
    },
    offClickOutside (gameObject, callback, scope) {
        if (typeof gameObject === "function") {
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._clickOutside === undefined) return this;
        gameObject._clickOutside.off("clickoutside", callback, scope);
        return this;
    },
    enableClickOutside (gameObject, enabled) {
        if (gameObject && typeof gameObject !== "object") {
            enabled = gameObject;
            gameObject = this;
        }
        if (gameObject._clickOutside === undefined) return this;
        gameObject._clickOutside.setEnable(enabled);
        return this;
    },
    disableClickOutside (gameObject) {
        if (gameObject && typeof gameObject !== "object") gameObject = this;
        if (gameObject._clickOutside === undefined) return this;
        gameObject._clickOutside.setEnable(false);
        return this;
    }
};




class $015d60567edf5e48$var$Cooldown extends (0, $6fbac7201eeee4ca$export$2e2bcd8739ae039) {
    constructor(){
        super({
            eventEmitter: false
        });
        this.goto("IDLE");
    }
    setCooldownTime(time) {
        this.cooldownTime = time;
        this.cooldownMode = time !== undefined;
        return this;
    }
    request() {
        return this.runMethod("request");
    }
    // IDLE state
    update_IDLE() {
        this.compensationTime = 0;
    }
    request_IDLE() {
        this.next();
        return true;
    }
    next_IDLE() {
        if (this.cooldownMode) return "COOLDOWN";
    }
    // COOLDOWN state
    enter_COOLDOWN() {
        this.remainderTime = this.cooldownTime + this.compensationTime;
    }
    update_COOLDOWN(time, delta) {
        this.remainderTime -= delta;
        if (this.remainderTime < 0) {
            this.compensationTime = this.cooldownTime > delta ? -this.remainderTime : 0;
            this.goto("IDLE");
        }
    }
    request_COOLDOWN() {
        return false;
    }
}
var $015d60567edf5e48$export$2e2bcd8739ae039 = $015d60567edf5e48$var$Cooldown;


const $f9f303773ff6a49f$var$GetValue = Phaser.Utils.Objects.GetValue;
class $f9f303773ff6a49f$var$InTouching extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this._enable = undefined;
        this.cooldown = new (0, $015d60567edf5e48$export$2e2bcd8739ae039)();
        this.parent.setInteractive($f9f303773ff6a49f$var$GetValue(config, "inputConfig", undefined));
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.pointer = undefined;
        this.prevIsInTouch = false;
        this.isInTouching = false;
        this.setEnable($f9f303773ff6a49f$var$GetValue(o, "enable", true));
        this.setCooldown($f9f303773ff6a49f$var$GetValue(o, "cooldown", undefined));
        return this;
    }
    boot() {
        var gameObject = this.parent;
        gameObject.on("pointerdown", this.onPointIn, this);
        gameObject.on("pointerover", this.onPointIn, this);
        gameObject.on("pointerup", this.onPointOut, this);
        gameObject.on("pointerout", this.onPointOut, this);
        this.scene.sys.events.on("preupdate", this.preupdate, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // GameObject events will be removed when this gameObject destroyed 
        // this.parent.off('pointerdown', this.onPointIn, this);
        // this.parent.off('pointerover', this.onPointIn, this);
        // this.parent.off('pointerup', this.onPointOut, this);
        // this.parent.off('pointerout', this.onPointOut, this);
        this.scene.sys.events.off("preupdate", this.preupdate, this);
        this.pointer = undefined;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) {
            this.prevIsInTouch = false;
            this.isInTouching = false;
            this.pointer = undefined;
        }
        this._enable = e;
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    get cooldownTime() {
        return this.cooldown.cooldownTime;
    }
    set cooldownTime(time) {
        this.cooldown.setCooldownTime(time);
    }
    setCooldown(time) {
        this.cooldownTime = time;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    // internal
    onPointIn(pointer, localX, localY) {
        if (!this.enable || !pointer.isDown || this.pointer !== undefined) return;
        this.pointer = pointer;
        this.isInTouching = true;
    }
    onPointOut(pointer) {
        if (!this.enable || this.pointer !== pointer) return;
        this.pointer = undefined;
        this.isInTouching = false;
    }
    preupdate(time, delta) {
        this.cooldown.update(time, delta);
        if (!this.prevIsInTouch && this.isInTouching) this.emit("touchstart", this, this.parent);
        if (this.isInTouching && this.cooldown.request()) this.emit("intouch", this, this.parent, this.pointer);
        if (this.prevIsInTouch && !this.isInTouching) this.emit("touchend", this, this.parent);
        this.prevIsInTouch = this.isInTouching;
    }
}
var $f9f303773ff6a49f$export$2e2bcd8739ae039 = $f9f303773ff6a49f$var$InTouching;


var $fe46c714b3d93f06$export$2e2bcd8739ae039 = (0, $f9f303773ff6a49f$export$2e2bcd8739ae039);


var $213484a77f0b6ac4$export$2e2bcd8739ae039 = (0, $fe46c714b3d93f06$export$2e2bcd8739ae039);



var $523fb478203da3c8$export$2e2bcd8739ae039 = {
    isPointerInBounds (target) {
        if (target === undefined) target = this;
        else if (typeof target === "string") target = this.getElement(target);
        if (!target) return false;
        return (0, $e4fa7f2032964b1a$export$2e2bcd8739ae039)(target);
    },
    onTouching (gameObject, callback, scope, config) {
        if (!gameObject) return this;
        if (typeof gameObject === "function") {
            config = scope;
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._inTouching === undefined) gameObject._inTouching = new (0, $213484a77f0b6ac4$export$2e2bcd8739ae039)(gameObject, config);
        gameObject._inTouching.on("intouch", callback, scope);
        return this;
    },
    offTouching (gameObject, callback, scope) {
        if (typeof gameObject === "function") {
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._inTouching === undefined) return this;
        gameObject._inTouching.off("intouch", callback, scope);
        return this;
    },
    onTouchingEnd (gameObject, callback, scope, config) {
        if (!gameObject) return this;
        if (typeof gameObject === "function") {
            config = scope;
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._inTouching === undefined) gameObject._inTouching = new (0, $213484a77f0b6ac4$export$2e2bcd8739ae039)(gameObject, config);
        gameObject._inTouching.on("touchend", callback, scope);
        return this;
    },
    offTouchingEnd (gameObject, callback, scope) {
        if (typeof gameObject === "function") {
            scope = callback;
            callback = gameObject;
            gameObject = this;
        }
        if (gameObject._inTouching === undefined) return this;
        gameObject._inTouching.off("touchend", callback, scope);
        return this;
    },
    enableTouching (gameObject, enabled) {
        if (gameObject && typeof gameObject !== "object") {
            enabled = gameObject;
            gameObject = this;
        }
        if (gameObject._inTouching === undefined) return this;
        gameObject._inTouching.setEnable(enabled);
        return this;
    },
    disableTouching (gameObject) {
        if (gameObject && typeof gameObject !== "object") gameObject = this;
        if (gameObject._inTouching === undefined) return this;
        gameObject._inTouching.setEnable(false);
        return this;
    }
};



var $af1f26cd819250cc$var$PointToChild = function(parents, x, y) {
    var parent;
    for(var i = 0, cnt = parents.length; i < cnt; i++){
        parent = parents[i];
        if (!(0, $a96d1cc514159357$export$2e2bcd8739ae039)(parent, x, y)) continue;
        return parent.pointToChild(x, y);
    }
    return null;
};
var $af1f26cd819250cc$export$2e2bcd8739ae039 = $af1f26cd819250cc$var$PointToChild;


var $ab5f58a58315aaf6$var$EmitChildEvent = function(eventEmitter, eventName, parents, x, y, pointer, event) {
    var child;
    if (y === undefined) child = x;
    else child = (0, $af1f26cd819250cc$export$2e2bcd8739ae039)(parents, x, y);
    if (!child) return;
    eventEmitter.emit(eventName, child, pointer, event);
};
var $ab5f58a58315aaf6$export$2e2bcd8739ae039 = $ab5f58a58315aaf6$var$EmitChildEvent;


const $61b62cb2c68be014$var$GetValue = Phaser.Utils.Objects.GetValue;
var $61b62cb2c68be014$var$DownChild = function(config) {
    var downConfig = $61b62cb2c68be014$var$GetValue(config, "down", undefined);
    if (downConfig === false) return;
    else if (downConfig === true) downConfig = undefined;
    this.on("pointerdown", $61b62cb2c68be014$var$OnDown, this);
};
var $61b62cb2c68be014$var$OnDown = function(pointer, localX, localY, event) {
    var childrenInteractive = this._childrenInteractive;
    (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}down`, childrenInteractive.targetSizers, pointer.worldX, pointer.worldY, pointer, event);
};
var $61b62cb2c68be014$export$2e2bcd8739ae039 = $61b62cb2c68be014$var$DownChild;



const $8c63de580a552289$var$GetValue = Phaser.Utils.Objects.GetValue;
var $8c63de580a552289$var$UpChild = function(config) {
    var upConfig = $8c63de580a552289$var$GetValue(config, "up", undefined);
    if (upConfig === false) return;
    else if (upConfig === true) upConfig = undefined;
    this.on("pointerup", $8c63de580a552289$var$OnUp, this);
};
var $8c63de580a552289$var$OnUp = function(pointer, localX, localY, event) {
    var childrenInteractive = this._childrenInteractive;
    (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}up`, childrenInteractive.targetSizers, pointer.worldX, pointer.worldY, pointer, event);
};
var $8c63de580a552289$export$2e2bcd8739ae039 = $8c63de580a552289$var$UpChild;




const $c9eec21dda04d9f8$var$GetValue = Phaser.Utils.Objects.GetValue;
var $c9eec21dda04d9f8$var$OverChild = function(config) {
    var overConfig = $c9eec21dda04d9f8$var$GetValue(config, "over", undefined);
    if (overConfig === false) return;
    else if (overConfig === true) overConfig = undefined;
    this.on("pointermove", $c9eec21dda04d9f8$var$OnMove, this).on("pointerover", $c9eec21dda04d9f8$var$OnMove, this).on("pointerout", $c9eec21dda04d9f8$var$OnOut, this) // pointer-up is included too
    ;
};
var $c9eec21dda04d9f8$var$OnMove = function(pointer, localX, localY, event) {
    var childrenInteractive = this._childrenInteractive;
    var child = (0, $af1f26cd819250cc$export$2e2bcd8739ae039)(childrenInteractive.targetSizers, pointer.worldX, pointer.worldY);
    var preChild = childrenInteractive.lastOverChild;
    if (child && preChild && child === preChild) return;
    childrenInteractive.lastOverChild = child;
    (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}out`, childrenInteractive.targetSizers, preChild, undefined, pointer, event);
    (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}over`, childrenInteractive.targetSizers, child, undefined, pointer, event);
};
var $c9eec21dda04d9f8$var$OnOut = function(pointer, event) {
    var childrenInteractive = this._childrenInteractive;
    var child = childrenInteractive.lastOverChild;
    childrenInteractive.lastOverChild = null;
    (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}out`, childrenInteractive.targetSizers, child, undefined, pointer, event);
};
var $c9eec21dda04d9f8$export$2e2bcd8739ae039 = $c9eec21dda04d9f8$var$OverChild;




const $31c9ef441f3e7a6c$var$GetValue = Phaser.Utils.Objects.GetValue;
var $31c9ef441f3e7a6c$var$ClickChild = function(config) {
    var clickConfig = $31c9ef441f3e7a6c$var$GetValue(config, "click", undefined);
    if (clickConfig === false) return;
    else if (clickConfig === true) clickConfig = undefined;
    if (clickConfig === undefined) clickConfig = {};
    if (!clickConfig.hasOwnProperty("threshold")) clickConfig.threshold = 10;
    var childrenInteractive = this._childrenInteractive;
    this._click = new (0, $d7386e5b0e39fd99$export$2e2bcd8739ae039)(this, clickConfig);
    this._click.on("click", function(button, gameObject, pointer, event) {
        (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}click`, childrenInteractive.targetSizers, pointer.worldX, pointer.worldY, pointer, event);
    }, this);
};
var $31c9ef441f3e7a6c$export$2e2bcd8739ae039 = $31c9ef441f3e7a6c$var$ClickChild;




const $e411f35b913e4d50$var$GetValue = Phaser.Utils.Objects.GetValue;
class $e411f35b913e4d50$var$OnePointerTracer extends (0, $de3bc6fefe1470a6$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        var scene = (0, $a7f896f05814bf38$export$2e2bcd8739ae039)(gameObject);
        if (scene === gameObject) gameObject = undefined;
        super(scene, config);
        this.gameObject = gameObject;
        if (gameObject) gameObject.setInteractive($e411f35b913e4d50$var$GetValue(config, "inputConfig", undefined));
        this._enable = undefined;
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.setEnable($e411f35b913e4d50$var$GetValue(o, "enable", true));
        this.setDetectBounds();
        if (this.gameObject === undefined) this.setDetectBounds($e411f35b913e4d50$var$GetValue(o, "bounds", undefined));
        else this.setDetectBounds();
        this.tracerState = $e411f35b913e4d50$var$TOUCH0;
        // this.recongizedState = new stateClass(this);
        this.pointer = undefined;
        this.lastPointer = undefined; // Last catched pointer
        this.movedState = false;
        this.isTouchingAnyObject = false;
        return this;
    }
    boot() {
        super.boot();
        if (this.gameObject) this.gameObject.on("pointerdown", this.onPointerDown, this);
        else this.scene.input.on("pointerdown", this.onPointerDown, this);
        this.scene.input.on("pointerup", this.onPointerUp, this);
        this.scene.input.on("gameout", this.dragCancel, this);
        this.scene.input.on("pointermove", this.onPointerMove, this);
        this.scene.sys.events.once("shutdown", this.destroy, this);
    }
    shutdown(fromScene) {
        if (!this.scene) return;
        if (this.gameObject) ;
        else this.scene.input.off("pointerdown", this.onPointerDown, this);
        this.scene.input.off("pointerup", this.onPointerUp, this);
        this.scene.input.off("gameout", this.dragCancel, this);
        this.scene.input.off("pointermove", this.onPointerMove, this);
        this.scene.sys.events.off("shutdown", this.destroy, this);
        this.gameObject = undefined;
        this.bounds = undefined;
        this.pointer = undefined;
        this.lastPointer = undefined; // Last catched pointer
        this.movedState = false;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) this.dragCancel();
        this._enable = e;
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    setDetectBounds(bounds) {
        this.bounds = bounds;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    onPointerDown(pointer, gameObjects) {
        if (!this.enable) return;
        if (this.pointer !== undefined) return;
        var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
        if (!isInsideBounds) return;
        if (this.pointer === pointer) return;
        this.pointer = pointer;
        this.lastPointer = pointer;
        this.movedState = false;
        this.tracerState = $e411f35b913e4d50$var$TOUCH1;
        if (this.gameObject === undefined) this.isTouchingAnyObject = gameObjects.length > 0;
        this.onDragStart();
    }
    onPointerUp(pointer) {
        if (!this.enable) return;
        var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
        if (!isInsideBounds) return;
        if (this.pointer !== pointer) return;
        this.pointer = undefined;
        this.movedState = false;
        this.tracerState = $e411f35b913e4d50$var$TOUCH0;
        this.onDragEnd();
    }
    onPointerMove(pointer) {
        if (!this.enable) return;
        if (pointer.isDown) {
            var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
            var isCatchedPointer = this.pointer === pointer;
            if (!isCatchedPointer && isInsideBounds) ;
            else if (isCatchedPointer && !isInsideBounds) this.onPointerUp(pointer);
            else {
                if (!this.movedState) this.movedState = pointer.x !== pointer.downX || pointer.y !== pointer.downY;
                if (this.movedState) this.onDrag();
            }
        }
    }
    dragCancel() {
        if (this.tracerState === $e411f35b913e4d50$var$TOUCH1) this.onDragEnd();
        this.pointer = undefined;
        this.tracerState = $e411f35b913e4d50$var$TOUCH0;
        return this;
    }
    onDragStart() {
        this.emit("dragstart", this);
    }
    onDragEnd() {
        this.emit("dragend", this);
    }
    onDrag() {
        this.emit("drag", this);
    }
    // onLastPointerMove() { }
    preUpdate(time, delta) {}
    postUpdate(time, delta) {}
    startTicking() {
        super.startTicking();
        this.scene.sys.events.on("preupdate", this.preUpdate, this);
        this.scene.sys.events.on("postupdate", this.postUpdate, this);
    }
    stopTicking() {
        super.stopTicking();
        if (this.scene) {
            this.scene.sys.events.off("preupdate", this.preUpdate, this);
            this.scene.sys.events.off("postupdate", this.postUpdate, this);
        }
    }
    setRecongizedStateObject(stateObject) {
        this.recongizedState = stateObject;
        return this;
    }
    get state() {
        return this.recongizedState.state;
    }
    set state(newState) {
        this.recongizedState.state = newState;
    }
    cancel() {
        this.state = $e411f35b913e4d50$var$IDLE;
        return this;
    }
}
const $e411f35b913e4d50$var$TOUCH0 = 0;
const $e411f35b913e4d50$var$TOUCH1 = 1;
const $e411f35b913e4d50$var$IDLE = "IDLE";
var $e411f35b913e4d50$export$2e2bcd8739ae039 = $e411f35b913e4d50$var$OnePointerTracer;



const $c423cd7db7a3df9b$var$GetValue = Phaser.Utils.Objects.GetValue;
const $c423cd7db7a3df9b$var$DistanceBetween = Phaser.Math.Distance.Between;
class $c423cd7db7a3df9b$var$Tap extends (0, $e411f35b913e4d50$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {
                    enter: function() {
                        self.stop();
                        self.tapsCount = 0;
                        self.x = 0;
                        self.y = 0;
                        self.worldX = 0;
                        self.worldY = 0;
                    },
                    exit: function() {
                        var pointer = self.lastPointer;
                        self.x = pointer.x;
                        self.y = pointer.y;
                        self.worldX = pointer.worldX;
                        self.worldY = pointer.worldY;
                    }
                },
                BEGIN: {
                    enter: function() {
                        self.start();
                        self.tapsCount = 0;
                        self.emit("tappingstart", self, self.gameObject, self.lastPointer);
                    }
                },
                RECOGNIZED: {
                    enter: function() {
                        self.start();
                        self.emit("tap", self, self.gameObject, self.lastPointer);
                        self.emit(`${self.tapsCount}tap`, self, self.gameObject, self.lastPointer);
                    }
                }
            },
            init: function() {
                this.state = $c423cd7db7a3df9b$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setHoldTime($c423cd7db7a3df9b$var$GetValue(o, "time", 250)); // min-hold-time of Press is 251
        this.setTapInterval($c423cd7db7a3df9b$var$GetValue(o, "tapInterval", 200));
        this.setDragThreshold($c423cd7db7a3df9b$var$GetValue(o, "threshold", 9));
        this.setTapOffset($c423cd7db7a3df9b$var$GetValue(o, "tapOffset", 10));
        var taps = $c423cd7db7a3df9b$var$GetValue(o, "taps", undefined);
        if (taps !== undefined) this.setTaps(taps);
        else {
            this.setMaxTaps($c423cd7db7a3df9b$var$GetValue(o, "maxTaps", undefined));
            this.setMinTaps($c423cd7db7a3df9b$var$GetValue(o, "minTaps", undefined));
        }
        return this;
    }
    onDragStart() {
        switch(this.state){
            case $c423cd7db7a3df9b$var$IDLE:
                this.state = $c423cd7db7a3df9b$var$BEGIN;
                break;
            case $c423cd7db7a3df9b$var$BEGIN:
                var pointer = this.lastPointer;
                var tapsOffset = $c423cd7db7a3df9b$var$DistanceBetween(pointer.upX, pointer.upY, pointer.x, pointer.y);
                if (tapsOffset > this.tapOffset) {
                    this.state = $c423cd7db7a3df9b$var$RECOGNIZED;
                    this.state = $c423cd7db7a3df9b$var$BEGIN;
                }
                break;
            case $c423cd7db7a3df9b$var$RECOGNIZED:
                this.state = $c423cd7db7a3df9b$var$BEGIN;
                break;
        }
    }
    onDragEnd() {
        if (this.state === $c423cd7db7a3df9b$var$BEGIN) {
            this.tapsCount++; // Try recognize next level
            this.emit("tapping", this, this.gameObject, this.lastPointer);
            if (this.maxTaps !== undefined && this.tapsCount === this.maxTaps) this.state = $c423cd7db7a3df9b$var$RECOGNIZED;
        }
    }
    onDrag() {
        if (this.state === $c423cd7db7a3df9b$var$IDLE) return;
        if (this.pointer.getDistance() > this.dragThreshold) this.state = $c423cd7db7a3df9b$var$IDLE;
    }
    preUpdate(time, delta) {
        if (!this.isRunning || !this.enable) return;
        if (this.state === $c423cd7db7a3df9b$var$BEGIN) {
            var pointer = this.lastPointer;
            if (pointer.isDown) {
                var holdTime = time - pointer.downTime;
                if (holdTime > this.holdTime) this.state = $c423cd7db7a3df9b$var$IDLE;
            } else {
                var releasedTime = time - pointer.upTime;
                if (releasedTime > this.tapInterval) {
                    if (this.minTaps === undefined || this.tapsCount >= this.minTaps) this.state = $c423cd7db7a3df9b$var$RECOGNIZED;
                    else this.state = $c423cd7db7a3df9b$var$IDLE;
                }
            }
        }
    }
    postUpdate(time, delta) {
        if (!this.isRunning || !this.enable) return;
        // Clear RECOGNIZED after update()
        if (this.state === $c423cd7db7a3df9b$var$RECOGNIZED) this.state = $c423cd7db7a3df9b$var$IDLE;
    }
    get isTapped() {
        return this.state === $c423cd7db7a3df9b$var$RECOGNIZED;
    }
    setHoldTime(time) {
        this.holdTime = time; // ms
        return this;
    }
    setTapInterval(time) {
        this.tapInterval = time; // ms
        return this;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
    setTapOffset(distance) {
        this.tapOffset = distance;
        return this;
    }
    setMaxTaps(taps) {
        this.maxTaps = taps;
        return this;
    }
    setMinTaps(taps) {
        this.minTaps = taps;
        return this;
    }
    setTaps(minTaps, maxTaps) {
        if (maxTaps === undefined) maxTaps = minTaps;
        this.setMinTaps(minTaps).setMaxTaps(maxTaps);
        return this;
    }
}
const $c423cd7db7a3df9b$var$IDLE = "IDLE";
const $c423cd7db7a3df9b$var$BEGIN = "BEGIN";
const $c423cd7db7a3df9b$var$RECOGNIZED = "RECOGNIZED";
var $c423cd7db7a3df9b$export$2e2bcd8739ae039 = $c423cd7db7a3df9b$var$Tap;




const $bd413cf8c4c59f3d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $bd413cf8c4c59f3d$var$Press extends (0, $e411f35b913e4d50$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {
                    enter: function() {
                        self.x = 0;
                        self.y = 0;
                        self.worldX = 0;
                        self.worldY = 0;
                    },
                    exit: function() {
                        var pointer = self.lastPointer;
                        self.x = pointer.x;
                        self.y = pointer.y;
                        self.worldX = pointer.worldX;
                        self.worldY = pointer.worldY;
                    }
                },
                BEGIN: {
                    enter: function() {
                        self.start();
                    },
                    exit: function() {
                        self.stop();
                    }
                },
                RECOGNIZED: {
                    enter: function() {
                        self.emit("pressstart", self, self.gameObject, self.lastPointer);
                    },
                    exit: function() {
                        self.emit("pressend", self, self.gameObject, self.lastPointer);
                    }
                }
            },
            init: function() {
                this.state = $bd413cf8c4c59f3d$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDragThreshold($bd413cf8c4c59f3d$var$GetValue(o, "threshold", 9));
        this.setHoldTime($bd413cf8c4c59f3d$var$GetValue(o, "time", 251));
        return this;
    }
    onDragStart() {
        this.state = $bd413cf8c4c59f3d$var$BEGIN;
        if (this.holdTime === 0) this.state = $bd413cf8c4c59f3d$var$RECOGNIZED;
    }
    onDragEnd() {
        this.state = $bd413cf8c4c59f3d$var$IDLE;
    }
    onDrag() {
        if (this.state === $bd413cf8c4c59f3d$var$IDLE) return;
        if (this.pointer.getDistance() > this.dragThreshold) this.state = $bd413cf8c4c59f3d$var$IDLE;
    }
    preUpdate(time, delta) {
        if (!this.isRunning || !this.enable) return;
        if (this.state === $bd413cf8c4c59f3d$var$BEGIN) {
            var holdTime = time - this.pointer.downTime;
            if (holdTime >= this.holdTime) this.state = $bd413cf8c4c59f3d$var$RECOGNIZED;
        }
    }
    get isPressed() {
        return this.state === $bd413cf8c4c59f3d$var$RECOGNIZED;
    }
    setHoldTime(time) {
        this.holdTime = time; // ms
        return this;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
}
const $bd413cf8c4c59f3d$var$IDLE = "IDLE";
const $bd413cf8c4c59f3d$var$BEGIN = "BEGIN";
const $bd413cf8c4c59f3d$var$RECOGNIZED = "RECOGNIZED";
var $bd413cf8c4c59f3d$export$2e2bcd8739ae039 = $bd413cf8c4c59f3d$var$Press;




const $158020c4c937b10c$var$GetValue = Phaser.Utils.Objects.GetValue;
class $158020c4c937b10c$var$Pan extends (0, $e411f35b913e4d50$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {},
                BEGIN: {
                    enter: function() {
                        var pointer = self.pointer;
                        self.startX = pointer.x;
                        self.startY = pointer.y;
                        self.startWorldX = pointer.worldX;
                        self.startWorldY = pointer.worldY;
                    }
                },
                RECOGNIZED: {
                    enter: function() {
                        self.emit("panstart", self, self.gameObject, self.lastPointer);
                    },
                    exit: function() {
                        var pointer = self.lastPointer;
                        self.endX = pointer.x;
                        self.endY = pointer.y;
                        self.endWorldX = pointer.worldX;
                        self.endWorldY = pointer.worldY;
                        self.emit("panend", self, self.gameObject, self.lastPointer);
                    }
                }
            },
            init: function() {
                this.state = $158020c4c937b10c$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDragThreshold($158020c4c937b10c$var$GetValue(o, "threshold", 10));
        return this;
    }
    onDragStart() {
        this.state = $158020c4c937b10c$var$BEGIN;
        if (this.dragThreshold === 0) this.state = $158020c4c937b10c$var$RECOGNIZED;
    }
    onDragEnd() {
        this.state = $158020c4c937b10c$var$IDLE;
    }
    onDrag() {
        switch(this.state){
            case $158020c4c937b10c$var$BEGIN:
                if (this.pointer.getDistance() >= this.dragThreshold) this.state = $158020c4c937b10c$var$RECOGNIZED;
                break;
            case $158020c4c937b10c$var$RECOGNIZED:
                var p1 = this.pointer.position;
                var p0 = this.pointer.prevPosition;
                this.dx = p1.x - p0.x;
                this.dy = p1.y - p0.y;
                var pointer = this.pointer;
                this.x = pointer.x;
                this.y = pointer.y;
                this.worldX = pointer.worldX;
                this.worldY = pointer.worldY;
                this.emit("pan", this, this.gameObject, this.lastPointer);
                break;
        }
    }
    get isPanned() {
        return this.state === $158020c4c937b10c$var$RECOGNIZED;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
}
const $158020c4c937b10c$var$IDLE = "IDLE";
const $158020c4c937b10c$var$BEGIN = "BEGIN";
const $158020c4c937b10c$var$RECOGNIZED = "RECOGNIZED";
var $158020c4c937b10c$export$2e2bcd8739ae039 = $158020c4c937b10c$var$Pan;





const $0cfbb79009f61e09$var$DistanceBetween = Phaser.Math.Distance.Between;
const $0cfbb79009f61e09$var$AngleBetween = Phaser.Math.Angle.Between;
var $0cfbb79009f61e09$export$2e2bcd8739ae039 = {
    getDt: function() {
        var dt = (0, $faac1631b82f4951$export$2e2bcd8739ae039)(this.scene);
        return dt;
    },
    getVelocity: function() {
        var p1 = this.pointer.position;
        var p0 = this.pointer.prevPosition;
        var d = $0cfbb79009f61e09$var$DistanceBetween(p0.x, p0.y, p1.x, p1.y);
        var velocity = d / (this.getDt() * 0.001);
        return velocity;
    },
    getVelocityX: function() {
        var p1 = this.pointer.position;
        var p0 = this.pointer.prevPosition;
        var d = Math.abs(p1.x - p0.x);
        var velocity = d / (this.getDt() * 0.001);
        return velocity;
    },
    getVelocityY: function() {
        var p1 = this.pointer.position;
        var p0 = this.pointer.prevPosition;
        var d = Math.abs(p1.y - p0.y);
        var velocity = d / (this.getDt() * 0.001);
        return velocity;
    },
    getVelocityAngle: function() {
        var p1 = this.pointer.position;
        var p0 = this.pointer.prevPosition;
        var angle = $0cfbb79009f61e09$var$AngleBetween(p0.x, p0.y, p1.x, p1.y);
        return angle;
    }
};


var $03423dcb267a0812$export$2e2bcd8739ae039 = {
    "up&down": 0,
    "left&right": 1,
    "4dir": 2,
    "8dir": 3
};


var $8629cf7565833a9e$var$AngleToDirections = function(angle, dirMode, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $8629cf7565833a9e$var$globOut;
    out.left = false;
    out.right = false;
    out.up = false;
    out.down = false;
    angle = (angle + 360) % 360;
    switch(dirMode){
        case 0:
            if (angle < 180) out.down = true;
            else out.up = true;
            break;
        case 1:
            if (angle > 90 && angle <= 270) out.left = true;
            else out.right = true;
            break;
        case 2:
            if (angle > 45 && angle <= 135) out.down = true;
            else if (angle > 135 && angle <= 225) out.left = true;
            else if (angle > 225 && angle <= 315) out.up = true;
            else out.right = true;
            break;
        case 3:
            if (angle > 22.5 && angle <= 67.5) {
                out.down = true;
                out.right = true;
            } else if (angle > 67.5 && angle <= 112.5) out.down = true;
            else if (angle > 112.5 && angle <= 157.5) {
                out.down = true;
                out.left = true;
            } else if (angle > 157.5 && angle <= 202.5) out.left = true;
            else if (angle > 202.5 && angle <= 247.5) {
                out.left = true;
                out.up = true;
            } else if (angle > 247.5 && angle <= 292.5) out.up = true;
            else if (angle > 292.5 && angle <= 337.5) {
                out.up = true;
                out.right = true;
            } else out.right = true;
            break;
    }
    return out;
};
var $8629cf7565833a9e$var$globOut = {};
var $8629cf7565833a9e$export$2e2bcd8739ae039 = $8629cf7565833a9e$var$AngleToDirections;


const $fe0982b3352f5999$var$GetValue = Phaser.Utils.Objects.GetValue;
const $fe0982b3352f5999$var$RadToDeg = Phaser.Math.RadToDeg;
class $fe0982b3352f5999$var$Swipe extends (0, $e411f35b913e4d50$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {
                    enter: function() {
                        self.x = 0;
                        self.y = 0;
                        self.worldX = 0;
                        self.worldY = 0;
                    },
                    exit: function() {
                        var pointer = self.lastPointer;
                        self.x = pointer.x;
                        self.y = pointer.y;
                        self.worldX = pointer.worldX;
                        self.worldY = pointer.worldY;
                    }
                },
                BEGIN: {
                    enter: function() {
                        self.validDrag = false;
                    }
                },
                RECOGNIZED: {
                    enter: function() {
                        self.start();
                        self.updateDirectionStates();
                        self.emit("swipe", self, self.gameObject, self.lastPointer);
                    },
                    exit: function() {
                        self.stop();
                        self.clearDirectionStates();
                    }
                }
            },
            init: function() {
                this.state = $fe0982b3352f5999$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
        this.clearDirectionStates();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDragThreshold($fe0982b3352f5999$var$GetValue(o, "threshold", 10));
        this.setVelocityThreshold($fe0982b3352f5999$var$GetValue(o, "velocityThreshold", 1000));
        this.setDirectionMode($fe0982b3352f5999$var$GetValue(o, "dir", "8dir"));
        return this;
    }
    onDragStart() {
        this.state = $fe0982b3352f5999$var$BEGIN;
    }
    onDragEnd() {
        this.state = $fe0982b3352f5999$var$IDLE;
    }
    onDrag() {
        if (this.state === $fe0982b3352f5999$var$BEGIN) {
            if (!this.validDrag) this.validDrag = this.dragThreshold === 0 || this.pointer.getDistance() >= this.dragThreshold;
            if (this.validDrag && this.dragVelocity > this.velocityThreshold) this.state = $fe0982b3352f5999$var$RECOGNIZED;
        }
    }
    postUpdate(time, delta) {
        if (!this.isRunning || !this.enable) return;
        // Clear RECOGNIZED after update()
        if (this.state === $fe0982b3352f5999$var$RECOGNIZED) this.state = $fe0982b3352f5999$var$IDLE;
    }
    get isSwiped() {
        return this.state === $fe0982b3352f5999$var$RECOGNIZED;
    }
    get dragVelocity() {
        var velocity;
        switch(this.dirMode){
            case 0:
                velocity = this.getVelocityY();
                break; // up & down
            case 1:
                velocity = this.getVelocityX();
                break; // left & right
            default:
                velocity = this.getVelocity();
                break; // 4 dir, 8 dir
        }
        return velocity;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
    setVelocityThreshold(velocity) {
        this.velocityThreshold = velocity;
        return this;
    }
    setDirectionMode(m) {
        if (typeof m === "string") m = (0, $03423dcb267a0812$export$2e2bcd8739ae039)[m];
        this.dirMode = m;
        return this;
    }
    updateDirectionStates() {
        var angle = $fe0982b3352f5999$var$RadToDeg(this.getVelocityAngle());
        (0, $8629cf7565833a9e$export$2e2bcd8739ae039)(angle, this.dirMode, this);
        return this;
    }
    clearDirectionStates() {
        this.left = false;
        this.right = false;
        this.up = false;
        this.down = false;
        return this;
    }
}
Object.assign($fe0982b3352f5999$var$Swipe.prototype, (0, $0cfbb79009f61e09$export$2e2bcd8739ae039));
const $fe0982b3352f5999$var$IDLE = "IDLE";
const $fe0982b3352f5999$var$BEGIN = "BEGIN";
const $fe0982b3352f5999$var$RECOGNIZED = "RECOGNIZED";
var $fe0982b3352f5999$export$2e2bcd8739ae039 = $fe0982b3352f5999$var$Swipe;




const $760470ca5c9afc36$var$GetValue = Phaser.Utils.Objects.GetValue;
const $760470ca5c9afc36$var$SpliceOne = Phaser.Utils.Array.SpliceOne;
const $760470ca5c9afc36$var$DistanceBetween = Phaser.Math.Distance.Between;
const $760470ca5c9afc36$var$AngleBetween = Phaser.Math.Angle.Between;
class $760470ca5c9afc36$var$TwoPointersTracer {
    constructor(scene, config){
        var amount = scene.input.manager.pointersTotal - 1;
        if (amount < 2) scene.input.addPointer(2 - amount);
        this.scene = scene;
        // Event emitter
        this.setEventEmitter($760470ca5c9afc36$var$GetValue(config, "eventEmitter", undefined));
        this._enable = undefined;
        this.pointers = [];
        this.movedState = {};
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.setEnable($760470ca5c9afc36$var$GetValue(o, "enable", true));
        this.bounds = $760470ca5c9afc36$var$GetValue(o, "bounds", undefined);
        this.tracerState = $760470ca5c9afc36$var$TOUCH0;
        this.pointers.length = 0;
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.movedState);
        return this;
    }
    boot() {
        this.scene.input.on("pointerdown", this.onPointerDown, this);
        this.scene.input.on("pointerup", this.onPointerUp, this);
        this.scene.input.on("gameout", this.dragCancel, this);
        this.scene.input.on("pointermove", this.onPointerMove, this);
        this.scene.sys.events.once("shutdown", this.destroy, this);
    }
    shutdown() {
        if (!this.scene) return;
        this.destroyEventEmitter();
        this.pointers.length = 0;
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.movedState);
        this.scene.input.off("pointerdown", this.onPointerDown, this);
        this.scene.input.off("pointerup", this.onPointerUp, this);
        this.scene.input.off("gameout", this.dragCancel, this);
        this.scene.input.off("pointermove", this.onPointerMove, this);
        this.scene.sys.events.off("shutdown", this.destroy, this);
        this.scene = undefined;
    }
    destroy() {
        this.shutdown();
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) this.dragCancel();
        this._enable = e;
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    onPointerDown(pointer) {
        if (!this.enable) return;
        if (this.pointers.length === 2) return;
        var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
        if (!isInsideBounds) return;
        var index = this.pointers.indexOf(pointer);
        if (index !== -1) return;
        this.movedState[pointer.id] = false;
        this.pointers.push(pointer);
        switch(this.tracerState){
            case $760470ca5c9afc36$var$TOUCH0:
                this.tracerState = $760470ca5c9afc36$var$TOUCH1;
                this.onDrag1Start();
                break;
            case $760470ca5c9afc36$var$TOUCH1:
                this.tracerState = $760470ca5c9afc36$var$TOUCH2;
                this.onDrag2Start();
                break;
        }
    }
    onPointerUp(pointer) {
        if (!this.enable) return;
        var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
        if (!isInsideBounds) return;
        var index = this.pointers.indexOf(pointer);
        if (index === -1) return;
        else {
            delete this.movedState[pointer.id];
            $760470ca5c9afc36$var$SpliceOne(this.pointers, index);
        }
        switch(this.tracerState){
            case $760470ca5c9afc36$var$TOUCH1:
                this.tracerState = $760470ca5c9afc36$var$TOUCH0;
                this.onDrag1End();
                break;
            case $760470ca5c9afc36$var$TOUCH2:
                this.tracerState = $760470ca5c9afc36$var$TOUCH1;
                this.onDrag2End();
                this.onDrag1Start();
                break;
        }
    }
    onPointerMove(pointer) {
        if (!this.enable) return;
        if (pointer.isDown) {
            var isInsideBounds = this.bounds ? this.bounds.contains(pointer.x, pointer.y) : true;
            var isCatchedPointer = this.pointers.indexOf(pointer) !== -1;
            if (!isCatchedPointer && isInsideBounds) ;
            else if (isCatchedPointer && !isInsideBounds) this.onPointerUp(pointer);
            else {
                if (!this.movedState[pointer.id]) this.movedState[pointer.id] = pointer.x !== pointer.downX || pointer.y !== pointer.downY;
                if (this.movedState[pointer.id]) switch(this.tracerState){
                    case $760470ca5c9afc36$var$TOUCH1:
                        this.onDrag1();
                        break;
                    case $760470ca5c9afc36$var$TOUCH2:
                        this.onDrag2();
                        break;
                }
            }
        }
    }
    dragCancel() {
        if (this.tracerState === $760470ca5c9afc36$var$TOUCH2) this.onDrag2End();
        this.pointers.length = 0;
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.movedState);
        this.tracerState = $760470ca5c9afc36$var$TOUCH0;
        return this;
    }
    onDrag1Start() {
        this.emit("drag1start", this);
    }
    onDrag1End() {
        this.emit("drag1end", this);
    }
    onDrag1() {
        this.emit("drag1", this);
    }
    onDrag2Start() {
        this.emit("drag2start", this);
    }
    onDrag2End() {
        this.emit("drag2end", this);
    }
    onDrag2() {
        this.emit("drag2", this);
    }
    get distanceBetween() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var p0 = this.pointers[0], p1 = this.pointers[1];
        return $760470ca5c9afc36$var$DistanceBetween(p0.x, p0.y, p1.x, p1.y);
    }
    get angleBetween() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var p0 = this.pointers[0], p1 = this.pointers[1];
        return $760470ca5c9afc36$var$AngleBetween(p0.x, p0.y, p1.x, p1.y);
    }
    get drag1Vector() {
        var pointer = this.pointers[0];
        if (pointer && this.movedState[pointer.id]) {
            var p1 = pointer.position;
            var p0 = pointer.prevPosition;
            $760470ca5c9afc36$var$tmpDragVector.x = p1.x - p0.x;
            $760470ca5c9afc36$var$tmpDragVector.y = p1.y - p0.y;
        } else {
            $760470ca5c9afc36$var$tmpDragVector.x = 0;
            $760470ca5c9afc36$var$tmpDragVector.y = 0;
        }
        return $760470ca5c9afc36$var$tmpDragVector;
    }
    get centerX() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var p0 = this.pointers[0].position;
        var p1 = this.pointers[1].position;
        return (p0.x + p1.x) / 2;
    }
    get centerY() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var p0 = this.pointers[0].position;
        var p1 = this.pointers[1].position;
        return (p0.y + p1.y) / 2;
    }
    get prevCenterX() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var preP0 = this.movedState[this.pointers[0].id] ? this.pointers[0].prevPosition : this.pointers[0].position;
        var preP1 = this.movedState[this.pointers[1].id] ? this.pointers[1].prevPosition : this.pointers[1].position;
        return (preP0.x + preP1.x) / 2;
    }
    get prevCenterY() {
        if (this.tracerState !== $760470ca5c9afc36$var$TOUCH2) return 0;
        var preP0 = this.movedState[this.pointers[0].id] ? this.pointers[0].prevPosition : this.pointers[0].position;
        var preP1 = this.movedState[this.pointers[1].id] ? this.pointers[1].prevPosition : this.pointers[1].position;
        return (preP0.y + preP1.y) / 2;
    }
    get movementCenterX() {
        return this.centerX - this.prevCenterX;
    }
    get movementCenterY() {
        return this.centerY - this.prevCenterY;
    }
    setRecongizedStateObject(stateObject) {
        this.recongizedState = stateObject;
        return this;
    }
    get state() {
        return this.recongizedState.state;
    }
    set state(newState) {
        this.recongizedState.state = newState;
    }
    cancel() {
        this.state = $760470ca5c9afc36$var$IDLE;
        return this;
    }
}
Object.assign($760470ca5c9afc36$var$TwoPointersTracer.prototype, (0, $9df503a375d92377$export$2e2bcd8739ae039));
var $760470ca5c9afc36$var$tmpDragVector = {};
const $760470ca5c9afc36$var$TOUCH0 = 0;
const $760470ca5c9afc36$var$TOUCH1 = 1;
const $760470ca5c9afc36$var$TOUCH2 = 2;
const $760470ca5c9afc36$var$IDLE = "IDLE";
var $760470ca5c9afc36$export$2e2bcd8739ae039 = $760470ca5c9afc36$var$TwoPointersTracer;



const $2473314c4f700424$var$GetValue = Phaser.Utils.Objects.GetValue;
class $2473314c4f700424$var$Pinch extends (0, $760470ca5c9afc36$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {
                    enter: function() {
                        self.prevDistance = undefined;
                        self.scaleFactor = 1;
                    }
                },
                BEGIN: {},
                RECOGNIZED: {
                    enter: function() {
                        self.emit("pinchstart", self);
                    },
                    exit: function() {
                        self.emit("pinchend", self);
                    }
                }
            },
            init: function() {
                this.state = $2473314c4f700424$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDragThreshold($2473314c4f700424$var$GetValue(o, "threshold", 0));
        return this;
    }
    onDrag2Start() {
        this.scaleFactor = 1;
        this.prevDistance = this.distanceBetween;
        this.state = $2473314c4f700424$var$BEGIN;
        if (this.dragThreshold === 0) this.state = $2473314c4f700424$var$RECOGNIZED;
    }
    onDrag2End() {
        this.state = $2473314c4f700424$var$IDLE;
    }
    onDrag2() {
        switch(this.state){
            case $2473314c4f700424$var$BEGIN:
                if (this.pointers[0].getDistance() >= this.dragThreshold && this.pointers[1].getDistance() >= this.dragThreshold) {
                    var curDistance = this.distanceBetween;
                    this.scaleFactor = curDistance / this.prevDistance;
                    this.prevDistance = curDistance;
                    this.state = $2473314c4f700424$var$RECOGNIZED;
                }
                break;
            case $2473314c4f700424$var$RECOGNIZED:
                var curDistance = this.distanceBetween;
                this.scaleFactor = curDistance / this.prevDistance;
                this.emit("pinch", this);
                this.prevDistance = curDistance;
                break;
        }
    }
    get isPinched() {
        return this.state === $2473314c4f700424$var$RECOGNIZED;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
}
const $2473314c4f700424$var$IDLE = "IDLE";
const $2473314c4f700424$var$BEGIN = "BEGIN";
const $2473314c4f700424$var$RECOGNIZED = "RECOGNIZED";
var $2473314c4f700424$export$2e2bcd8739ae039 = $2473314c4f700424$var$Pinch;




const $5a57d2b8eab8c778$var$RotateAround = Phaser.Math.RotateAround;
var $5a57d2b8eab8c778$var$RotateObjectAround = function(gameObject, x, y, angle) {
    $5a57d2b8eab8c778$var$RotateAround(gameObject, x, y, angle);
    gameObject.rotation += angle;
    return gameObject;
};
var $5a57d2b8eab8c778$export$2e2bcd8739ae039 = $5a57d2b8eab8c778$var$RotateObjectAround;


var $ee05bdebdf45d8e1$var$ScreenXYToWorldXY = function(screenX, screenY, camera, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $ee05bdebdf45d8e1$var$globalOut;
    camera.getWorldPoint(screenX, screenY, out);
    return out;
};
var $ee05bdebdf45d8e1$var$globalOut = {};
var $ee05bdebdf45d8e1$export$2e2bcd8739ae039 = $ee05bdebdf45d8e1$var$ScreenXYToWorldXY;


var $8184249c0e10f455$var$SpinObject = function(gameObject, camera) {
    if (!this.isRotation) return this;
    if (camera === undefined) camera = this.pointers[0].camera;
    var movementX = this.movementCenterX, movementY = this.movementCenterY;
    var worldXY = (0, $ee05bdebdf45d8e1$export$2e2bcd8739ae039)(this.centerX, this.centerY, camera, true);
    var centerWorldX = worldXY.x;
    var centerWorldY = worldXY.y;
    var angle = this.rotation;
    if (Array.isArray(gameObject)) {
        var gameObjects = gameObject;
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++){
            gameObject = gameObjects[i];
            gameObject.x += movementX;
            gameObject.y += movementY;
            (0, $5a57d2b8eab8c778$export$2e2bcd8739ae039)(gameObject, centerWorldX, centerWorldY, angle);
        }
    } else {
        gameObject.x += movementX;
        gameObject.y += movementY;
        (0, $5a57d2b8eab8c778$export$2e2bcd8739ae039)(gameObject, centerWorldX, centerWorldY, angle);
    }
    return this;
};
var $8184249c0e10f455$export$2e2bcd8739ae039 = $8184249c0e10f455$var$SpinObject;


const $e931bff4dafc605f$var$GetValue = Phaser.Utils.Objects.GetValue;
const $e931bff4dafc605f$var$WrapDegrees = Phaser.Math.Angle.WrapDegrees; // Wrap degrees: -180 to 180 
const $e931bff4dafc605f$var$ShortestBetween = Phaser.Math.Angle.ShortestBetween;
const $e931bff4dafc605f$var$RadToDeg = Phaser.Math.RadToDeg;
const $e931bff4dafc605f$var$DegToRad = Phaser.Math.DegToRad;
class $e931bff4dafc605f$var$Rotate extends (0, $760470ca5c9afc36$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        var self = this;
        var stateConfig = {
            states: {
                IDLE: {
                    enter: function() {
                        self.prevAngle = undefined;
                        self.angle = 0;
                    }
                },
                BEGIN: {},
                RECOGNIZED: {
                    enter: function() {
                        self.emit("rotatestart", self);
                    },
                    exit: function() {
                        self.emit("rotateend", self);
                    }
                }
            },
            init: function() {
                this.state = $e931bff4dafc605f$var$IDLE;
            },
            eventEmitter: false
        };
        this.setRecongizedStateObject(new (0, $57ebe48317eef8b7$export$2e2bcd8739ae039)(stateConfig));
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDragThreshold($e931bff4dafc605f$var$GetValue(o, "threshold", 0));
        return this;
    }
    onDrag2Start() {
        this.prevAngle = $e931bff4dafc605f$var$WrapDegrees($e931bff4dafc605f$var$RadToDeg(this.angleBetween)); // Degrees
        this.state = $e931bff4dafc605f$var$BEGIN;
        if (this.dragThreshold === 0) this.state = $e931bff4dafc605f$var$RECOGNIZED;
    }
    onDrag2End() {
        this.state = $e931bff4dafc605f$var$IDLE;
    }
    onDrag2() {
        switch(this.state){
            case $e931bff4dafc605f$var$BEGIN:
                if (this.pointers[0].getDistance() >= this.dragThreshold && this.pointers[1].getDistance() >= this.dragThreshold) {
                    var curAngle = $e931bff4dafc605f$var$WrapDegrees($e931bff4dafc605f$var$RadToDeg(this.angleBetween));
                    this.angle = $e931bff4dafc605f$var$ShortestBetween(this.prevAngle, curAngle);
                    this.prevAngle = curAngle;
                    this.state = $e931bff4dafc605f$var$RECOGNIZED;
                }
                break;
            case $e931bff4dafc605f$var$RECOGNIZED:
                var curAngle = $e931bff4dafc605f$var$WrapDegrees($e931bff4dafc605f$var$RadToDeg(this.angleBetween));
                this.angle = $e931bff4dafc605f$var$ShortestBetween(this.prevAngle, curAngle);
                this.prevAngle = curAngle;
                this.emit("rotate", this);
                break;
        }
    }
    get isRotated() {
        return this.state === $e931bff4dafc605f$var$RECOGNIZED;
    }
    get rotation() {
        return $e931bff4dafc605f$var$DegToRad(this.angle);
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
}
var $e931bff4dafc605f$var$methods = {
    spinObject: (0, $8184249c0e10f455$export$2e2bcd8739ae039)
};
Object.assign($e931bff4dafc605f$var$Rotate.prototype, $e931bff4dafc605f$var$methods);
const $e931bff4dafc605f$var$IDLE = "IDLE";
const $e931bff4dafc605f$var$BEGIN = "BEGIN";
const $e931bff4dafc605f$var$RECOGNIZED = "RECOGNIZED";
var $e931bff4dafc605f$export$2e2bcd8739ae039 = $e931bff4dafc605f$var$Rotate;




var $b0329087b2ba8053$export$2e2bcd8739ae039 = (0, $c423cd7db7a3df9b$export$2e2bcd8739ae039);



const $57fa56b9bdab7071$var$GetValue = Phaser.Utils.Objects.GetValue;
var $57fa56b9bdab7071$var$TapChild = function(config) {
    var tapConfig = $57fa56b9bdab7071$var$GetValue(config, "tap", undefined);
    if (tapConfig === false) return;
    else if (tapConfig === true) tapConfig = undefined;
    var childrenInteractive = this._childrenInteractive;
    this._tap = new (0, $b0329087b2ba8053$export$2e2bcd8739ae039)(this, tapConfig);
    this._tap.on("tap", function(tap, gameObject, lastPointer) {
        (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}${tap.tapsCount}tap`, childrenInteractive.targetSizers, tap.worldX, tap.worldY, lastPointer);
    }, this);
};
var $57fa56b9bdab7071$export$2e2bcd8739ae039 = $57fa56b9bdab7071$var$TapChild;



var $4ba3c2f484e52118$export$2e2bcd8739ae039 = (0, $bd413cf8c4c59f3d$export$2e2bcd8739ae039);



const $3a0b3c49cb6be169$var$GetValue = Phaser.Utils.Objects.GetValue;
var $3a0b3c49cb6be169$var$PressChild = function(config) {
    var pressConfig = $3a0b3c49cb6be169$var$GetValue(config, "press", undefined);
    if (pressConfig === false) return;
    else if (pressConfig === true) pressConfig = undefined;
    var childrenInteractive = this._childrenInteractive;
    this._press = new (0, $4ba3c2f484e52118$export$2e2bcd8739ae039)(this, pressConfig);
    this._press.on("pressstart", function(press, gameObject, lastPointer) {
        (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}pressstart`, childrenInteractive.targetSizers, press.worldX, press.worldY, lastPointer);
    }, this).on("pressend", function(press, gameObject, lastPointer) {
        (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}pressend`, childrenInteractive.targetSizers, press.worldX, press.worldY, lastPointer);
    }, this);
};
var $3a0b3c49cb6be169$export$2e2bcd8739ae039 = $3a0b3c49cb6be169$var$PressChild;



var $e375a08b6454e44f$export$2e2bcd8739ae039 = (0, $fe0982b3352f5999$export$2e2bcd8739ae039);



const $c0ffa1bba0aa9d76$var$GetValue = Phaser.Utils.Objects.GetValue;
var $c0ffa1bba0aa9d76$var$SwipeChild = function(config) {
    var swipeConfig = $c0ffa1bba0aa9d76$var$GetValue(config, "swipe", undefined);
    if (swipeConfig === false) return;
    else if (swipeConfig === true) swipeConfig = undefined;
    if (swipeConfig === undefined) swipeConfig = {};
    if (!swipeConfig.hasOwnProperty("dir")) swipeConfig.dir = "4dir";
    var childrenInteractive = this._childrenInteractive;
    this._swipe = new (0, $e375a08b6454e44f$export$2e2bcd8739ae039)(this, swipeConfig);
    this._swipe.on("swipe", function(swipe, gameObject, lastPointer) {
        var dirName = swipe.left ? "left" : swipe.right ? "right" : swipe.up ? "up" : "down";
        (0, $ab5f58a58315aaf6$export$2e2bcd8739ae039)(childrenInteractive.eventEmitter, `${childrenInteractive.eventNamePrefix}swipe${dirName}`, childrenInteractive.targetSizers, swipe.worldX, swipe.worldY, lastPointer);
    }, this);
};
var $c0ffa1bba0aa9d76$export$2e2bcd8739ae039 = $c0ffa1bba0aa9d76$var$SwipeChild;


const $d32ee249a5c7144d$var$GetValue = Phaser.Utils.Objects.GetValue;
var $d32ee249a5c7144d$var$SetChildrenInteractive = function(gameObject, config) {
    gameObject.setInteractive();
    gameObject._childrenInteractive = {
        targetSizers: $d32ee249a5c7144d$var$GetValue(config, "targets", [
            gameObject
        ]),
        eventEmitter: $d32ee249a5c7144d$var$GetValue(config, "eventEmitter", gameObject),
        eventNamePrefix: $d32ee249a5c7144d$var$GetValue(config, "inputEventPrefix", "child.")
    };
    (0, $61b62cb2c68be014$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $8c63de580a552289$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $c9eec21dda04d9f8$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $31c9ef441f3e7a6c$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $57fa56b9bdab7071$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $3a0b3c49cb6be169$export$2e2bcd8739ae039).call(gameObject, config);
    (0, $c0ffa1bba0aa9d76$export$2e2bcd8739ae039).call(gameObject, config);
    return gameObject;
};
var $d32ee249a5c7144d$export$2e2bcd8739ae039 = $d32ee249a5c7144d$var$SetChildrenInteractive;


var $dcde202b919b8112$var$SetChildrenInteractiveWrap = function(config) {
    (0, $d32ee249a5c7144d$export$2e2bcd8739ae039)(this, config);
    return this;
};
var $dcde202b919b8112$export$2e2bcd8739ae039 = $dcde202b919b8112$var$SetChildrenInteractiveWrap;


var $9cf3ae8d1e724d8e$var$BroadcastEvent = function() {
    var gameObjects = this.getAllChildren([
        this
    ]);
    for(var i = 0, cnt = gameObjects.length; i < cnt; i++){
        var gameObject = gameObjects[i];
        gameObject.emit.apply(gameObject, arguments);
    }
    return this;
};
var $9cf3ae8d1e724d8e$export$2e2bcd8739ae039 = $9cf3ae8d1e724d8e$var$BroadcastEvent;


var $dcb3bbb03ccd6c0f$var$methods = {
    getSizerConfig: (0, $1a1339e580bb462f$export$2e2bcd8739ae039),
    getChildPrevState: (0, $0cfa3ee8e0eb5712$export$2e2bcd8739ae039),
    pushIntoBounds: (0, $2a6f6536d00f92a0$export$2e2bcd8739ae039),
    drawBounds: (0, $dc4b283ca02f246c$export$2e2bcd8739ae039),
    resolveWidth: (0, $411cee766f03e513$export$2e2bcd8739ae039),
    resolveChildrenWidth: (0, $cf74ac6a586942b6$export$2e2bcd8739ae039),
    resolveHeight: (0, $da2b6b6b16a97213$export$2e2bcd8739ae039),
    postResolveSize: (0, $397de2fd6c16cecf$export$2e2bcd8739ae039),
    getChildWidth: (0, $c1b89dee547f2674$export$2e2bcd8739ae039),
    getChildHeight: (0, $1f3b0de67405dcaf$export$2e2bcd8739ae039),
    getExpandedChildWidth: (0, $d540c1cc01a2cb9c$export$2e2bcd8739ae039),
    getExpandedChildHeight: (0, $783121464a425c08$export$2e2bcd8739ae039),
    getChildrenWidth: (0, $77f5a78ffc77eba8$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $a7b3d0279eaf6749$export$2e2bcd8739ae039),
    addChildrenMap: (0, $550f5eabc57c8951$export$2e2bcd8739ae039),
    addElement: (0, $550f5eabc57c8951$export$2e2bcd8739ae039),
    removeChildrenMap: (0, $c242cfa2eb33e585$export$2e2bcd8739ae039),
    getElement: (0, $c1b78c44c0369a27$export$2e2bcd8739ae039),
    getAllChildrenSizers: (0, $4bf3b7e260fa3950$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $fa4d0991cb5e13da$export$2e2bcd8739ae039),
    preLayout: (0, $8777309d0690526c$export$2e2bcd8739ae039),
    layout: (0, $cc3114ae446d6400$export$2e2bcd8739ae039),
    runLayout: (0, $df82898f04075e26$export$2e2bcd8739ae039),
    layoutChildren: (0, $e6cdfec26ef3787d$export$2e2bcd8739ae039),
    runWidthWrap: (0, $10fc52975e1b187e$export$2e2bcd8739ae039),
    layoutBackgrounds: (0, $5c7762eac7c78464$export$2e2bcd8739ae039),
    postLayout: (0, $a8e8c8d2123230d4$export$2e2bcd8739ae039),
    setAnchor: (0, $a900dfc1914435a9$export$2e2bcd8739ae039),
    isInTouching: (0, $f4c6c96ddcd95232$export$2e2bcd8739ae039),
    pointToChild: (0, $c0e2b01b94bb68dd$export$2e2bcd8739ae039),
    setDraggable: (0, $685a5a748c64a392$export$2e2bcd8739ae039),
    setChildrenInteractive: (0, $dcde202b919b8112$export$2e2bcd8739ae039),
    broadcastEvent: (0, $9cf3ae8d1e724d8e$export$2e2bcd8739ae039)
};
Object.assign($dcb3bbb03ccd6c0f$var$methods, (0, $25bb40e0ffb31fb7$export$2e2bcd8739ae039), (0, $3b98bfa52f31c7dd$export$2e2bcd8739ae039), (0, $d5362b366b0f8608$export$2e2bcd8739ae039), (0, $44f9283e5c7dc34d$export$2e2bcd8739ae039), (0, $419bbe1decd04038$export$2e2bcd8739ae039), (0, $7a01cb75922d4f8c$export$2e2bcd8739ae039), (0, $5ee72f51e35a5767$export$2e2bcd8739ae039), (0, $7563a2b4a47f3bfc$export$2e2bcd8739ae039), (0, $1f6812a49491b2c1$export$2e2bcd8739ae039), (0, $d714fc8f92a6e32b$export$2e2bcd8739ae039), (0, $7f51dfbd7392611f$export$2e2bcd8739ae039), (0, $523fb478203da3c8$export$2e2bcd8739ae039), (0, $5839d8def94e320c$export$2e2bcd8739ae039), (0, $01897f2cfdbbb3a7$export$2e2bcd8739ae039), (0, $6938927fe9660df6$export$2e2bcd8739ae039));
var $dcb3bbb03ccd6c0f$export$2e2bcd8739ae039 = $dcb3bbb03ccd6c0f$var$methods;




const $09c5ef84005dfeb8$var$GetValue = Phaser.Utils.Objects.GetValue;
class $09c5ef84005dfeb8$var$Base extends (0, $c5e95e90a54f0634$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, config){
        super(scene, x, y, 1, 1);
        this.isRexSizer = true;
        this.setMinSize(minWidth, minHeight);
        this.setName($09c5ef84005dfeb8$var$GetValue(config, "name", ""));
        this.rexSizer = {};
        this.space = {};
        this.backgroundChildren = undefined;
        this.sizerChildren = undefined; // [] or {}
        this.childrenMap = {};
        this.layoutedChildren = undefined;
        var anchorConfig = $09c5ef84005dfeb8$var$GetValue(config, "anchor", undefined);
        if (anchorConfig) this.setAnchor(anchorConfig);
        this.setInnerPadding($09c5ef84005dfeb8$var$GetValue(config, "space", 0));
        var draggable = $09c5ef84005dfeb8$var$GetValue(config, "draggable", false);
        if (draggable) this.setDraggable(draggable);
        this.setSizerEventsEnable($09c5ef84005dfeb8$var$GetValue(config, "sizerEvents", false));
        this.setDirty(true);
        if ($09c5ef84005dfeb8$var$GetValue(config, "enableLayer", false)) this.enableLayer();
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (fromScene) {
            // In this case, children will be cleared and destroy in scene level
            var sizers = this.getAllChildrenSizers([
                this
            ]);
            for(var i = 0, cnt = sizers.length; i < cnt; i++)sizers[i].sizerEventsEnable = false;
        }
        super.destroy(fromScene);
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.backgroundChildren);
        (0, $46f5de22f239821d$export$2e2bcd8739ae039)(this.sizerChildren);
        this.childrenMap = undefined;
        this.space = undefined;
        this.rexSizer = undefined;
        this.layoutedChildren = undefined;
    }
    setMinSize(minWidth, minHeight) {
        this.setMinWidth(minWidth).setMinHeight(minHeight);
        return this;
    }
    setMinWidth(minWidth) {
        if (minWidth == null) minWidth = 0;
        this.minWidth = minWidth;
        return this;
    }
    setMinHeight(minHeight) {
        if (minHeight == null) minHeight = 0;
        this.minHeight = minHeight;
        return this;
    }
    setDirty(dirty) {
        if (dirty === undefined) dirty = true;
        this.dirty = dirty;
        return this;
    }
    setSizerEventsEnable(enable) {
        if (enable === undefined) enable = true;
        this.sizerEventsEnable = enable;
        return this;
    }
    get ignoreLayout() {
        // Skip hidden or !dirty sizer
        return this.rexSizer.hidden || !this.dirty;
    }
    get childrenWidth() {
        if (this._childrenWidth === undefined) this._childrenWidth = this.getChildrenWidth();
        return this._childrenWidth;
    }
    get childrenHeight() {
        if (this._childrenHeight === undefined) this._childrenHeight = this.getChildrenHeight();
        return this._childrenHeight;
    }
    get left() {
        return this.x - (0, $3d5f5580139892aa$export$a60660135e2d0135)(this) * this.originX;
    }
    set left(value) {
        this.x += value - this.left;
    }
    alignLeft(value) {
        this.left = value;
        return this;
    }
    get right() {
        return this.left + (0, $3d5f5580139892aa$export$a60660135e2d0135)(this);
    }
    set right(value) {
        this.x += value - this.right;
    }
    alignRight(value) {
        this.right = value;
        return this;
    }
    get centerX() {
        return this.left + (0, $3d5f5580139892aa$export$a60660135e2d0135)(this) / 2;
    }
    set centerX(value) {
        this.x += value - this.centerX;
    }
    alignCenterX(value) {
        this.centerX = value;
        return this;
    }
    get top() {
        return this.y - (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this) * this.originY;
    }
    set top(value) {
        this.y += value - this.top;
    }
    alignTop(value) {
        this.top = value;
        return this;
    }
    get bottom() {
        return this.top + (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this);
    }
    set bottom(value) {
        this.y += value - this.bottom;
    }
    alignBottom(value) {
        this.bottom = value;
        return this;
    }
    get centerY() {
        return this.top + (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this) / 2;
    }
    set centerY(value) {
        this.y += value - this.centerY;
    }
    alignCenterY(value) {
        this.centerY = value;
        return this;
    }
    get innerLeft() {
        return this.left + this.space.left;
    }
    get innerRight() {
        return this.right - this.space.right;
    }
    get innerTop() {
        return this.top + this.space.top;
    }
    get innerBottom() {
        return this.bottom - this.space.bottom;
    }
    get innerWidth() {
        return this.width - this.space.left - this.space.right;
    }
    get innerHeight() {
        return this.height - this.space.top - this.space.bottom;
    }
    get minInnerWidth() {
        var result = this.minWidth - this.space.left - this.space.right;
        return Math.max(result, 0);
    }
    get minInnerHeight() {
        var result = this.minHeight - this.space.top - this.space.bottom;
        return Math.max(result, 0);
    }
}
Object.assign($09c5ef84005dfeb8$var$Base.prototype, (0, $dcb3bbb03ccd6c0f$export$2e2bcd8739ae039));
var $09c5ef84005dfeb8$export$2e2bcd8739ae039 = $09c5ef84005dfeb8$var$Base;


var $adc36f8ee6d091c6$var$GetChildrenWidth = function() {
    if (this.rexSizer.hidden) return 0;
    var result = 0;
    var children = this.sizerChildren;
    var child, padding, childWidth;
    for(var key in children){
        child = children[key];
        padding = child.rexSizer.padding;
        childWidth = this.getChildWidth(child) + padding.left + padding.right;
        result = Math.max(childWidth, result);
    }
    return result + this.space.left + this.space.right;
};
var $adc36f8ee6d091c6$export$2e2bcd8739ae039 = $adc36f8ee6d091c6$var$GetChildrenWidth;



var $1157a4c961f2360f$var$GetChildrenHeight = function() {
    if (this.rexSizer.hidden) return 0;
    var result = 0;
    var children = this.sizerChildren;
    var child, padding, childHeight;
    for(var key in children){
        child = children[key];
        childHeight = child.isRexSizer ? Math.max(child.minHeight, child.childrenHeight) : child.minHeight !== undefined ? child.minHeight : (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
        padding = child.rexSizer.padding;
        childHeight += padding.top + padding.bottom;
        result = Math.max(childHeight, result);
    }
    return result + this.space.top + this.space.bottom;
};
var $1157a4c961f2360f$export$2e2bcd8739ae039 = $1157a4c961f2360f$var$GetChildrenHeight;


var $dc5f439fef4bbf0d$var$GetExpandedChildWidth = function(child, parentWidth) {
    if (parentWidth === undefined) parentWidth = this.width;
    var childWidth;
    var childConfig = child.rexSizer;
    if (childConfig.expandWidth) {
        var innerWidth = parentWidth - this.space.left - this.space.right;
        var padding = childConfig.padding;
        childWidth = innerWidth - padding.left - padding.right;
    }
    return childWidth;
};
var $dc5f439fef4bbf0d$export$2e2bcd8739ae039 = $dc5f439fef4bbf0d$var$GetExpandedChildWidth;


var $bf5d257f345859cd$var$GetExpandedChildHeight = function(child, parentHeight) {
    if (parentHeight === undefined) parentHeight = this.height;
    var childHeight;
    var childConfig = child.rexSizer;
    if (childConfig.expandHeight) {
        var innerHeight = parentHeight - this.space.top - this.space.bottom;
        var padding = childConfig.padding;
        childHeight = innerHeight - padding.top - padding.bottom;
    }
    return childHeight;
};
var $bf5d257f345859cd$export$2e2bcd8739ae039 = $bf5d257f345859cd$var$GetExpandedChildHeight;


var $6e5ee5a25a04cf17$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    var children = this.sizerChildren, child;
    for(var key in children){
        child = children[key];
        if (child.isRexSizer) out.push(child);
    }
    return out;
};
var $6e5ee5a25a04cf17$export$2e2bcd8739ae039 = $6e5ee5a25a04cf17$var$GetChildrenSizers;





var $3c9326963468a61e$var$CheckSize = function(child, parent) {
    if (child.width < child.childrenWidth) // Warning
    console.warn(`Layout width error: Parent=${parent.constructor.name}, Child=${child.constructor.name}`);
    if (child.height < child.childrenHeight) // Warning
    console.warn(`Layout height error: Parent=${parent.constructor.name}, Child=${child.constructor.name}`);
};
var $3c9326963468a61e$export$2e2bcd8739ae039 = $3c9326963468a61e$var$CheckSize;


var $890f9303a3049486$var$LayoutChildren = function() {
    var child, childConfig, padding;
    var startX = this.innerLeft, startY = this.innerTop;
    var innerWidth = this.innerWidth, innerHeight = this.innerHeight;
    var x, y, width, height; // Align zone
    var childWidth, childHeight;
    // Layout current page
    var children = this.sizerChildren;
    for(var key in children){
        child = children[key];
        if (child.rexSizer.hidden) continue;
        childConfig = child.rexSizer;
        padding = childConfig.padding;
        (0, $977b9616557db798$export$2e2bcd8739ae039).call(this, child);
        // Set size
        if (child.isRexSizer) {
            child.runLayout(this, this.getExpandedChildWidth(child), this.getExpandedChildHeight(child));
            (0, $3c9326963468a61e$export$2e2bcd8739ae039)(child, this);
        } else {
            childWidth = undefined;
            childHeight = undefined;
            if (childConfig.expandWidth) childWidth = innerWidth - padding.left - padding.right;
            if (childConfig.expandHeight) childHeight = innerHeight - padding.top - padding.bottom;
            (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, childWidth, childHeight);
        }
        // Set position
        x = startX + padding.left;
        width = innerWidth - padding.left - padding.right;
        y = startY + padding.top;
        height = innerHeight - padding.top - padding.bottom;
        (0, $ba01042a1e30641f$export$2e2bcd8739ae039).call(this, child, x, y, width, height, childConfig.align, childConfig.alignOffsetX, childConfig.alignOffsetY);
    }
};
var $890f9303a3049486$export$2e2bcd8739ae039 = $890f9303a3049486$var$LayoutChildren;






const $004e7e39acc5e58e$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $004e7e39acc5e58e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $004e7e39acc5e58e$var$ALIGN_CENTER = Phaser.Display.Align.CENTER;
const $004e7e39acc5e58e$var$UUID = Phaser.Utils.String.UUID;
var $004e7e39acc5e58e$var$Add = function(gameObject, childKey, align, padding, expand, minWidth, minHeight, offsetX, offsetY) {
    (0, $6676609feda42dce$export$2e2bcd8739ae039).call(this, gameObject);
    if ($004e7e39acc5e58e$var$IsPlainObject(childKey)) {
        var config = childKey;
        childKey = $004e7e39acc5e58e$var$GetValue(config, "key", undefined);
        align = $004e7e39acc5e58e$var$GetValue(config, "align", $004e7e39acc5e58e$var$ALIGN_CENTER);
        offsetX = $004e7e39acc5e58e$var$GetValue(config, "offsetX", 0);
        offsetY = $004e7e39acc5e58e$var$GetValue(config, "offsetY", 0);
        padding = $004e7e39acc5e58e$var$GetValue(config, "padding", 0);
        expand = $004e7e39acc5e58e$var$GetValue(config, "expand", true);
        if (!gameObject.isRexSizer) {
            // Get minWidth,minHeight from config
            minWidth = $004e7e39acc5e58e$var$GetValue(config, "minWidth", gameObject._minWidth);
            minHeight = $004e7e39acc5e58e$var$GetValue(config, "minHeight", gameObject._minHeighted);
        }
    }
    var hasValidKey = childKey !== undefined;
    if (!hasValidKey) childKey = $004e7e39acc5e58e$var$UUID();
    if (typeof align === "string") align = (0, $519fe85d403be4ec$export$2e2bcd8739ae039)[align];
    if (align === undefined) align = $004e7e39acc5e58e$var$ALIGN_CENTER;
    if (offsetX === undefined) offsetX = 0;
    if (offsetY === undefined) offsetY = 0;
    if (padding === undefined) padding = 0;
    if (expand === undefined) expand = true;
    if (!gameObject.isRexSizer) {
        // Get minWidth,minHeight from game object
        if (minWidth === undefined) minWidth = gameObject._minWidth;
        if (minHeight === undefined) minHeight = gameObject._minHeight;
    }
    var config = this.getSizerConfig(gameObject);
    config.align = align;
    config.alignOffsetX = offsetX;
    config.alignOffsetY = offsetY;
    config.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(padding);
    if ($004e7e39acc5e58e$var$IsPlainObject(expand)) {
        config.expandWidth = $004e7e39acc5e58e$var$GetValue(expand, "width", false);
        config.expandHeight = $004e7e39acc5e58e$var$GetValue(expand, "height", false);
    } else {
        config.expandWidth = expand;
        config.expandHeight = expand;
    }
    if (!gameObject.isRexSizer) {
        if (config.expandWidth) // minWidth is still undefined, uses current display width
        gameObject.minWidth = minWidth === undefined ? (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) : minWidth;
        if (config.expandHeight) // minHeight is still undefined, uses current display height
        gameObject.minHeight = minHeight === undefined ? (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) : minHeight;
    }
    if (this.sizerChildren.hasOwnProperty(childKey)) this.sizerChildren[childKey].destroy();
    this.sizerChildren[childKey] = gameObject;
    if (hasValidKey) this.addChildrenMap(childKey, gameObject);
    return this;
};
var $004e7e39acc5e58e$export$2e2bcd8739ae039 = {
    add: $004e7e39acc5e58e$var$Add
};




const $6059775ef8ca5482$var$ContainerClear = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039).prototype.clear;
var $6059775ef8ca5482$var$ClearChildren = function(destroyChild) {
    if (this.backgroundChildren) this.backgroundChildren.length = 0;
    var fireRemoveEvent = !destroyChild && this.sizerEventsEnable;
    var children;
    if (fireRemoveEvent) children = this.getChildren([]);
    $6059775ef8ca5482$var$ContainerClear.call(this, destroyChild);
    if (fireRemoveEvent) {
        var gameObject;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            gameObject = children[i];
            gameObject.emit("sizer.remove", gameObject, this);
            this.emit("remove", gameObject, this);
        }
    }
    return this;
};
var $6059775ef8ca5482$export$2e2bcd8739ae039 = $6059775ef8ca5482$var$ClearChildren;


var $42593ae1d2ea0a64$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        var key;
        if (typeof gameObject === "string") {
            key = gameObject;
            gameObject = this.sizerChildren[key];
            if (!gameObject) return this;
        } else if (this.getParentSizer(gameObject) !== this) return this;
        else key = this.childToKey(gameObject);
        if (key) {
            delete this.sizerChildren[key];
            if (this.childrenMap.hasOwnProperty(key)) delete this.childrenMap[key];
        }
        (0, $3af1c74b73a28a17$export$2e2bcd8739ae039).call(this, gameObject, destroyChild);
        return this;
    },
    removeAll (destroyChild) {
        for(var key in this.sizerChildren)this.remove(key, destroyChild);
        return this;
    },
    clear (destroyChild) {
        for(var key in this.sizerChildren){
            delete this.sizerChildren[key];
            if (this.childrenMap.hasOwnProperty(key)) delete this.childrenMap[key];
        }
        (0, $6059775ef8ca5482$export$2e2bcd8739ae039).call(this, destroyChild);
        return this;
    }
};


var $ec2506d036051ef5$var$methods = {
    getChildrenWidth: (0, $adc36f8ee6d091c6$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $1157a4c961f2360f$export$2e2bcd8739ae039),
    getExpandedChildWidth: (0, $dc5f439fef4bbf0d$export$2e2bcd8739ae039),
    getExpandedChildHeight: (0, $bf5d257f345859cd$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $6e5ee5a25a04cf17$export$2e2bcd8739ae039),
    layoutChildren: (0, $890f9303a3049486$export$2e2bcd8739ae039)
};
Object.assign($ec2506d036051ef5$var$methods, (0, $004e7e39acc5e58e$export$2e2bcd8739ae039), (0, $42593ae1d2ea0a64$export$2e2bcd8739ae039));
var $ec2506d036051ef5$export$2e2bcd8739ae039 = $ec2506d036051ef5$var$methods;



var $b3508344d02c0d81$var$IndexOf = function(obj, child) {
    if (Array.isArray(obj)) return obj.indexOf(child);
    else {
        for(var key in obj){
            if (obj[key] === child) return key;
        }
        return null;
    }
};
var $b3508344d02c0d81$export$2e2bcd8739ae039 = $b3508344d02c0d81$var$IndexOf;


const $4d318a74c42de65b$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $4d318a74c42de65b$var$GetValue = Phaser.Utils.Objects.GetValue;
class $4d318a74c42de65b$var$OverlapSizer extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, config){
        if ($4d318a74c42de65b$var$IsPlainObject(x)) {
            config = x;
            x = $4d318a74c42de65b$var$GetValue(config, "x", 0);
            y = $4d318a74c42de65b$var$GetValue(config, "y", 0);
            minWidth = $4d318a74c42de65b$var$GetValue(config, "width", undefined);
            minHeight = $4d318a74c42de65b$var$GetValue(config, "height", undefined);
        } else if ($4d318a74c42de65b$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $4d318a74c42de65b$var$GetValue(config, "width", undefined);
            minHeight = $4d318a74c42de65b$var$GetValue(config, "height", undefined);
        }
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexOverlapSizer";
        this.sizerChildren = {};
        this.addChildrenMap("items", this.sizerChildren);
    }
    childToKey(gameObject) {
        if (typeof gameObject === "string") {
            var key = gameObject;
            if (this.sizerChildren.hasOwnPropery(key)) return key;
        } else return (0, $b3508344d02c0d81$export$2e2bcd8739ae039)(this.sizerChildren, gameObject);
        return null;
    }
}
Object.assign($4d318a74c42de65b$var$OverlapSizer.prototype, (0, $ec2506d036051ef5$export$2e2bcd8739ae039));
var $4d318a74c42de65b$export$2e2bcd8739ae039 = $4d318a74c42de65b$var$OverlapSizer;




var $0f8e79371015e42c$var$GetDistance = Phaser.Math.Distance.Between;
var $0f8e79371015e42c$var$IsLocalPointInKnob = function(knob, localX, localY) {
    var centerX = knob.width / 2;
    return $0f8e79371015e42c$var$GetDistance(centerX, centerX, localX, localY) <= centerX;
};
var $0f8e79371015e42c$export$2e2bcd8739ae039 = $0f8e79371015e42c$var$IsLocalPointInKnob;


const $e878f98bc86c6896$var$GetAngle = Phaser.Math.Angle.Between;
const $e878f98bc86c6896$var$NormalizeAngle = Phaser.Math.Angle.Normalize;
var $e878f98bc86c6896$var$OnTouchPad = function(pointer, localX, localY) {
    if (!this.enable) return;
    if (!pointer.isDown) return;
    var knob = this.sizerChildren.knob;
    if (!(0, $0f8e79371015e42c$export$2e2bcd8739ae039)(knob, localX, localY)) return;
    var centerX = knob.width / 2;
    var startAngle = knob.startAngle;
    var endAngle = $e878f98bc86c6896$var$GetAngle(centerX, centerX, localX, localY);
    var deltaAngle = knob.anticlockwise ? startAngle - endAngle : endAngle - startAngle;
    var value = $e878f98bc86c6896$var$NormalizeAngle(deltaAngle) / (2 * Math.PI);
    this.stopEaseValue();
    if (this.easeValueDuration === 0 || Math.abs(this.value - value) < 0.1) this.value = value;
    else this.easeValueTo(value);
};
var $e878f98bc86c6896$var$InstallEvents = function() {
    var knob = this.sizerChildren.knob;
    knob.on("pointerdown", $e878f98bc86c6896$var$OnTouchPad, this).on("pointermove", $e878f98bc86c6896$var$OnTouchPad, this).setInteractive();
};
var $e878f98bc86c6896$export$2e2bcd8739ae039 = $e878f98bc86c6896$var$InstallEvents;



const $b9dec35c14503800$var$GetAngle = Phaser.Math.Angle.Between;
const $b9dec35c14503800$var$WrapAngle = Phaser.Math.Angle.Wrap;
var $b9dec35c14503800$var$OnPointerDown = function(pointer, localX, localY) {
    if (!this.enable || this.panPointer) return;
    var knob = this.sizerChildren.knob;
    if (!(0, $0f8e79371015e42c$export$2e2bcd8739ae039)(knob, localX, localY)) return;
    $b9dec35c14503800$var$OnPanStart.call(this, pointer);
};
var $b9dec35c14503800$var$OnPointerMove = function(pointer, localX, localY) {
    if (!this.enable) return;
    if (!pointer.isDown) return;
    var knob = this.sizerChildren.knob;
    switch(this.panState){
        case $b9dec35c14503800$var$TOUCH0:
            if ((0, $0f8e79371015e42c$export$2e2bcd8739ae039)(knob, localX, localY)) $b9dec35c14503800$var$OnPanStart.call(this, pointer);
            break;
        case $b9dec35c14503800$var$TOUCH1:
            if ((0, $0f8e79371015e42c$export$2e2bcd8739ae039)(knob, localX, localY)) $b9dec35c14503800$var$OnPan.call(this);
            else $b9dec35c14503800$var$OnPanEnd.call(this);
            break;
    }
};
var $b9dec35c14503800$var$OnPointerUp = function(pointer, localX, localY) {
    if (!this.enable || this.panPointer !== pointer) return;
    $b9dec35c14503800$var$OnPanEnd.call(this);
};
var $b9dec35c14503800$var$OnPanStart = function(pointer) {
    this.panPointer = pointer;
    this.panState = $b9dec35c14503800$var$TOUCH1;
};
var $b9dec35c14503800$var$OnPanEnd = function() {
    this.panPointer = undefined;
    this.panState = $b9dec35c14503800$var$TOUCH0;
};
var $b9dec35c14503800$var$OnPan = function() {
    var p0 = this.panPointer.prevPosition, p1 = this.panPointer.position;
    var knob = this.sizerChildren.knob;
    var startAngle = $b9dec35c14503800$var$GetAngle(knob.x, knob.y, p0.x, p0.y), endAngle = $b9dec35c14503800$var$GetAngle(knob.x, knob.y, p1.x, p1.y);
    var deltaAngle = knob.anticlockwise ? startAngle - endAngle : endAngle - startAngle;
    var deltaValue = $b9dec35c14503800$var$WrapAngle(deltaAngle) / (Math.PI * 2);
    this.stopEaseValue();
    this.value += deltaValue;
};
const $b9dec35c14503800$var$TOUCH0 = 0;
const $b9dec35c14503800$var$TOUCH1 = 1;
var $b9dec35c14503800$var$InstallEvents = function() {
    var knob = this.sizerChildren.knob;
    knob.on("pointerdown", $b9dec35c14503800$var$OnPointerDown, this).on("pointermove", $b9dec35c14503800$var$OnPointerMove, this).on("pointerup", $b9dec35c14503800$var$OnPointerUp, this).setInteractive();
    this.panPointer = undefined;
    this.panState = $b9dec35c14503800$var$TOUCH0;
};
var $b9dec35c14503800$export$2e2bcd8739ae039 = $b9dec35c14503800$var$InstallEvents;


var $1fa899f4c0d3e602$var$SetTextFormatCallback = function(callback, scope) {
    this.textFormatCallback = callback;
    this.textFormatCallbackScope = scope;
    return this;
};
var $1fa899f4c0d3e602$var$GetFormatText = function(value) {
    if (value === undefined) value = this.value;
    var text;
    if (this.textFormatCallbackScope) text = this.textFormatCallback(value);
    else text = this.textFormatCallback.call(this.textFormatCallbackScope, value);
    return text;
};
var $1fa899f4c0d3e602$var$UpdateText = function(value) {
    var textObject = this.sizerChildren.text;
    if (textObject && this.textFormatCallback) {
        textObject.setText($1fa899f4c0d3e602$var$GetFormatText.call(this, value));
        if (textObject.layout) textObject.layout();
    }
    return this;
};
var $1fa899f4c0d3e602$export$2e2bcd8739ae039 = {
    setTextFormatCallback: $1fa899f4c0d3e602$var$SetTextFormatCallback,
    getFormatText: $1fa899f4c0d3e602$var$GetFormatText,
    updateText: $1fa899f4c0d3e602$var$UpdateText
};


const $2c49d15ec30e2ec2$var$GetValue = Phaser.Utils.Objects.GetValue;
const $2c49d15ec30e2ec2$var$SnapTo = Phaser.Math.Snap.To;
class $2c49d15ec30e2ec2$var$Knob extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $4d318a74c42de65b$export$2e2bcd8739ae039)) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create sizer
        super(scene, config);
        this.type = "rexKnob";
        this.bootProgressBase(config);
        // Add elements
        var background = $2c49d15ec30e2ec2$var$GetValue(config, "background", undefined);
        var textObject = $2c49d15ec30e2ec2$var$GetValue(config, "text", undefined);
        if (background) this.addBackground(background);
        // Get text object
        if (textObject) {
            // Don't draw text on knob directly
            config.textColor = undefined;
            config.textStrokeColor = undefined;
            this.setTextFormatCallback($2c49d15ec30e2ec2$var$GetValue(config, "textFormatCallback", undefined), $2c49d15ec30e2ec2$var$GetValue(config, "textFormatCallbackScope", undefined));
        }
        // Create circular progress object
        var knob = new (0, $c2a88b80fc9d5955$export$2e2bcd8739ae039)(scene, config);
        knob.setDepth($2c49d15ec30e2ec2$var$GetValue(config, "knobDepth", 0));
        knob._value = -1; // To trigger text updating
        scene.add.existing(knob);
        this.add(knob, "knob");
        if (textObject) {
            this.add(textObject, "text", "center", 0, false);
            scene.children.moveBelow(knob, textObject); // Move knob below textObject
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("knob", knob);
        this.addChildrenMap("text", textObject);
        this.setEnable($2c49d15ec30e2ec2$var$GetValue(config, "enable", undefined));
        this.setGap($2c49d15ec30e2ec2$var$GetValue(config, "gap", undefined));
        this.setValue($2c49d15ec30e2ec2$var$GetValue(config, "value", 0), $2c49d15ec30e2ec2$var$GetValue(config, "min", undefined), $2c49d15ec30e2ec2$var$GetValue(config, "max", undefined));
        // Input
        var inputMode = $2c49d15ec30e2ec2$var$GetValue(config, "input", 0);
        if (typeof inputMode === "string") inputMode = $2c49d15ec30e2ec2$var$INPUTMODE[inputMode];
        switch(inputMode){
            case 0:
                (0, $b9dec35c14503800$export$2e2bcd8739ae039).call(this);
                break;
            case 1:
                (0, $e878f98bc86c6896$export$2e2bcd8739ae039).call(this);
                break;
        }
    }
    setEnable(enable) {
        if (enable === undefined) enable = true;
        this.enable = enable;
        return this;
    }
    setGap(gap) {
        this.gap = gap;
        return this;
    }
    // Override
    get value() {
        return this.sizerChildren.knob.value;
    }
    // Override
    set value(value) {
        if (this.gap !== undefined) value = $2c49d15ec30e2ec2$var$SnapTo(value, this.gap);
        var oldValue = this.value;
        this.sizerChildren.knob.value = value;
        var newValue = this.value;
        if (oldValue !== newValue) {
            this.updateText();
            this.eventEmitter.emit("valuechange", newValue, oldValue, this.eventEmitter);
        }
    }
}
const $2c49d15ec30e2ec2$var$INPUTMODE = {
    pan: 0,
    drag: 0,
    click: 1,
    none: -1
};
Object.assign($2c49d15ec30e2ec2$var$Knob.prototype, (0, $1fa899f4c0d3e602$export$2e2bcd8739ae039));
var $2c49d15ec30e2ec2$export$2e2bcd8739ae039 = $2c49d15ec30e2ec2$var$Knob;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("knob", function(config) {
    var gameObject = new (0, $2c49d15ec30e2ec2$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Knob", (0, $2c49d15ec30e2ec2$export$2e2bcd8739ae039));
var $9f746367346b7c01$export$2e2bcd8739ae039 = (0, $2c49d15ec30e2ec2$export$2e2bcd8739ae039);




const $f217f187f6d48da9$var$ShapeClasses = {
    arc: (0, $dc5d4817ddd3622b$export$2e2bcd8739ae039),
    circle: (0, $59dabc3f63aed362$export$2e2bcd8739ae039),
    curve: (0, $f596752abc0a1658$export$2e2bcd8739ae039),
    ellipse: (0, $f42682a29e99067e$export$2e2bcd8739ae039),
    line: (0, $4f910d95da79b3d8$export$2e2bcd8739ae039),
    lines: (0, $1e62846ec481ae38$export$2e2bcd8739ae039),
    rectangle: (0, $6a12d6eebe280651$export$2e2bcd8739ae039),
    roundRectangle: (0, $0fa05e5e72af2e13$export$2e2bcd8739ae039),
    triangle: (0, $c2e68ce48d3429c6$export$2e2bcd8739ae039)
};
const $f217f187f6d48da9$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f217f187f6d48da9$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $f217f187f6d48da9$var$ClearAll = function() {
    var shapes = this.getShapes();
    for(var i = 0, cnt = shapes.length; i < cnt; i++)shapes[i].lineStyle().fillStyle();
};
var $f217f187f6d48da9$export$2e2bcd8739ae039 = {
    createShape (shapeType, name) {
        var ShapeClass = $f217f187f6d48da9$var$ShapeClasses[shapeType];
        var shape = new ShapeClass();
        if (name) shape.setName(name);
        return shape;
    },
    buildShapes (config) {
        var createCallback = $f217f187f6d48da9$var$GetValue(config, "create", undefined);
        if ($f217f187f6d48da9$var$IsPlainObject(createCallback)) {
            var shapes = createCallback;
            for(var shapeType in shapes){
                var name = shapes[shapeType];
                switch(typeof name){
                    case "number":
                        for(var i = 0; i < name; i++)this.addShape(this.createShape(shapeType));
                        break;
                    case "string":
                        this.addShape(this.createShape(shapeType, name));
                        break;
                    default:
                        var names = name;
                        for(var i = 0, cnt = names.length; i < cnt; i++)this.addShape(this.createShape(shapeType, names[i]));
                        break;
                }
            }
        } else if (Array.isArray(createCallback)) {
            var shapes = createCallback;
            for(var i = 0, cnt = shapes.length; i < cnt; i++){
                var shape = shapes[i];
                this.addShape(this.createShape(shape.type, shape.name));
            }
        } else if (typeof createCallback === "function") createCallback.call(this);
        this.setUpdateShapesCallback($f217f187f6d48da9$var$GetValue(config, "update"));
    },
    setUpdateShapesCallback (callback) {
        if (callback === undefined) callback = $f217f187f6d48da9$var$ClearAll;
        this.dirty = this.dirty || this.updateCallback !== callback;
        this.updateCallback = callback;
        return this;
    },
    updateShapes () {
        this.updateCallback.call(this);
    }
};


const $0641b34241fa77f4$var$TransformMatrix = Phaser.GameObjects.Components.TransformMatrix;
const $0641b34241fa77f4$var$TransformXY = Phaser.Math.TransformXY;
var $0641b34241fa77f4$var$WorldXYToGameObjectLocalXY = function(gameObject, worldX, worldY, camera, out) {
    if (camera === undefined) camera = gameObject.scene.cameras.main;
    if (out === undefined) out = {};
    else if (out === true) out = $0641b34241fa77f4$var$globOut;
    var csx = camera.scrollX;
    var csy = camera.scrollY;
    var px = worldX + csx * gameObject.scrollFactorX - csx;
    var py = worldY + csy * gameObject.scrollFactorY - csy;
    if (gameObject.parentContainer) {
        if ($0641b34241fa77f4$var$tempMatrix === undefined) {
            $0641b34241fa77f4$var$tempMatrix = new $0641b34241fa77f4$var$TransformMatrix();
            $0641b34241fa77f4$var$parentMatrix = new $0641b34241fa77f4$var$TransformMatrix();
        }
        gameObject.getWorldTransformMatrix($0641b34241fa77f4$var$tempMatrix, $0641b34241fa77f4$var$parentMatrix);
        $0641b34241fa77f4$var$tempMatrix.applyInverse(px, py, out);
    } else $0641b34241fa77f4$var$TransformXY(px, py, gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY, out);
    out.x += gameObject.displayOriginX;
    out.y += gameObject.displayOriginY;
    return out;
};
var $0641b34241fa77f4$var$tempMatrix, $0641b34241fa77f4$var$parentMatrix;
var $0641b34241fa77f4$var$globOut = {};
var $0641b34241fa77f4$export$2e2bcd8739ae039 = $0641b34241fa77f4$var$WorldXYToGameObjectLocalXY;


const $f3267fe44ff8e3d3$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f3267fe44ff8e3d3$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $f3267fe44ff8e3d3$var$CustomShapes extends (0, $fa309bb54d70b13f$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, config){
        if ($f3267fe44ff8e3d3$var$IsPlainObject(x)) {
            config = x;
            x = $f3267fe44ff8e3d3$var$GetValue(config, "x", 0);
            y = $f3267fe44ff8e3d3$var$GetValue(config, "y", 0);
            width = $f3267fe44ff8e3d3$var$GetValue(config, "width", 2);
            height = $f3267fe44ff8e3d3$var$GetValue(config, "height", 2);
        }
        super(scene, x, y, width, height);
        this.type = $f3267fe44ff8e3d3$var$GetValue(config, "type", "rexCustomShapes");
        this.buildShapes(config);
    }
    get centerX() {
        return this.width / 2;
    }
    get centerY() {
        return this.height / 2;
    }
    worldToLocalXY(worldX, worldY, camera, out) {
        if (typeof camera === "boolean") {
            out = camera;
            camera = undefined;
        }
        return (0, $0641b34241fa77f4$export$2e2bcd8739ae039)(this, worldX, worldY, camera, out);
    }
}
Object.assign($f3267fe44ff8e3d3$var$CustomShapes.prototype, (0, $f217f187f6d48da9$export$2e2bcd8739ae039));
var $f3267fe44ff8e3d3$export$2e2bcd8739ae039 = $f3267fe44ff8e3d3$var$CustomShapes;


var $0563c36a3c2e3f6a$export$2e2bcd8739ae039 = (0, $f3267fe44ff8e3d3$export$2e2bcd8739ae039);


var $0e30dae797539176$export$2e2bcd8739ae039 = (0, $0563c36a3c2e3f6a$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("customShapes", function(x, y, width, height, config) {
    var gameObject = new (0, $0e30dae797539176$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CustomShapes", (0, $0e30dae797539176$export$2e2bcd8739ae039));
var $e162bf102e81cfbe$export$2e2bcd8739ae039 = (0, $0e30dae797539176$export$2e2bcd8739ae039);




const $bdf704f34b4fe37d$var$GetValue = Phaser.Utils.Objects.GetValue;
const $bdf704f34b4fe37d$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $bdf704f34b4fe37d$var$CustomProgress extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $f3267fe44ff8e3d3$export$2e2bcd8739ae039)) {
    constructor(scene, x, y, width, height, config){
        if ($bdf704f34b4fe37d$var$IsPlainObject(x)) {
            config = x;
            x = $bdf704f34b4fe37d$var$GetValue(config, "x", 0);
            y = $bdf704f34b4fe37d$var$GetValue(config, "y", 0);
            width = $bdf704f34b4fe37d$var$GetValue(config, "width", 2);
            height = $bdf704f34b4fe37d$var$GetValue(config, "height", 2);
        }
        if (config === undefined) config = {};
        if (!config.type) config.type = "rexCustomProgress";
        super(scene, x, y, width, height, config);
        this.bootProgressBase(config);
        this.setValue($bdf704f34b4fe37d$var$GetValue(config, "value", 0));
    }
    get centerX() {
        return this.width / 2;
    }
    get centerY() {
        return this.height / 2;
    }
    get radius() {
        return Math.min(this.centerX, this.centerY);
    }
}
var $bdf704f34b4fe37d$export$2e2bcd8739ae039 = $bdf704f34b4fe37d$var$CustomProgress;


var $75660bf4dd54ad63$export$2e2bcd8739ae039 = (0, $bdf704f34b4fe37d$export$2e2bcd8739ae039);


var $e84cd92dc0cf6a04$export$2e2bcd8739ae039 = (0, $75660bf4dd54ad63$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("customProgress", function(x, y, width, height, config) {
    var gameObject = new (0, $e84cd92dc0cf6a04$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.CustomProgress", (0, $e84cd92dc0cf6a04$export$2e2bcd8739ae039));
var $0e575cf540bc5956$export$2e2bcd8739ae039 = (0, $e84cd92dc0cf6a04$export$2e2bcd8739ae039);



var $0e85fd788b05be09$export$2e2bcd8739ae039 = {
    setTransitionStartCallback (callback, scope) {
        this.onStartCallback = callback;
        this.onStartCallbackScope = scope;
        return this;
    },
    setTransitionProgressCallback (callback, scope) {
        this.onProgressCallback = callback;
        this.onProgressCallbackScope = scope;
        return this;
    },
    setTransitionCompleteCallback (callback, scope) {
        this.onCompleteCallback = callback;
        this.onCompleteCallbackScope = scope;
        return this;
    }
};



const $6396a426f6dd7405$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $6396a426f6dd7405$var$GetValue = Phaser.Utils.Objects.GetValue;
var $6396a426f6dd7405$var$DirMode = {
    out: 0,
    in: 1
};
var $6396a426f6dd7405$export$2e2bcd8739ae039 = {
    setTransitionDirection (dir) {
        if (typeof dir === "string") dir = $6396a426f6dd7405$var$DirMode[dir];
        this.dir = dir;
        return this;
    },
    setDuration (duration) {
        this.duration = duration;
        return this;
    },
    setEaseFunction (ease) {
        this.easeFunction = ease;
        return this;
    },
    setNextTexture (texture, frame) {
        this.nextImage.setTexture(texture, frame);
        return this;
    },
    transit (texture, frame) {
        if (this.isRunning) {
            this.ignoreCompleteEvent = true;
            this.stop();
            this.ignoreCompleteEvent = false;
        }
        if ($6396a426f6dd7405$var$IsPlainObject(texture)) {
            var config = texture;
            texture = $6396a426f6dd7405$var$GetValue(config, "key", undefined);
            frame = $6396a426f6dd7405$var$GetValue(config, "frame", undefined);
            this.setDuration($6396a426f6dd7405$var$GetValue(config, "duration", this.duration)).setEaseFunction($6396a426f6dd7405$var$GetValue(config, "ease", this.easeFunction)).setTransitionDirection($6396a426f6dd7405$var$GetValue(config, "dir", this.dir));
            var maskGameObject = $6396a426f6dd7405$var$GetValue(config, "mask", undefined);
            if (maskGameObject) this.setMaskGameObject(maskGameObject);
            this.setMaskEnable(maskGameObject === true);
            var onStart = $6396a426f6dd7405$var$GetValue(config, "onStart", undefined);
            var onProgress = $6396a426f6dd7405$var$GetValue(config, "onProgress", undefined);
            var onComplete = $6396a426f6dd7405$var$GetValue(config, "onComplete", undefined);
            if (onStart !== undefined || onProgress !== undefined || onComplete !== undefined) this.setTransitionStartCallback(onStart, $6396a426f6dd7405$var$GetValue(config, "onStartScope", undefined)).setTransitionProgressCallback(onProgress, $6396a426f6dd7405$var$GetValue(config, "onProgressScope", undefined)).setTransitionCompleteCallback(onComplete, $6396a426f6dd7405$var$GetValue(config, "onCompleteScope", undefined));
        }
        this.setNextTexture(texture, frame);
        this.start();
        return this;
    },
    start () {
        if (this.easeValueTask === undefined) this.easeValueTask = new (0, $52de0f0b406ab759$export$2e2bcd8739ae039)(this, {
            eventEmitter: null
        });
        this.easeValueTask.restart({
            key: "t",
            from: 0,
            to: 1,
            duration: this.duration,
            ease: this.easeFunction
        });
        return this;
    },
    pause () {
        if (this.easeValueTask) this.easeValueTask.pause();
        return this;
    },
    resume () {
        if (this.easeValueTask) this.easeValueTask.resume();
        return this;
    },
    stop () {
        if (this.easeValueTask) this.easeValueTask.stop();
        this.setT(1);
        return this;
    }
};



var $bd7ffad023288172$export$2e2bcd8739ae039 = {
    setMaskGameObject (gameObject) {
        if (!gameObject) {
            this.removeMaskGameObject();
            return this;
        }
        if (this.maskGameObject) {
            if (gameObject === true && this.maskGameObject instanceof (0, $bf9d9eb28e7b19f2$export$2e2bcd8739ae039)) return this;
            if (this.maskGameObject === gameObject) return this;
            // Remove previous Mask Game Object
            this.removeMaskGameObject();
        }
        // Add new Mask Game Object
        if (gameObject === true) gameObject = new (0, $bf9d9eb28e7b19f2$export$2e2bcd8739ae039)(this);
        this.maskGameObject = gameObject;
        this.maskGameObject.resize(this.width, this.height).setOrigin(this.originX, this.originY).setPosition(0, 0).setScale(1).setVisible(false);
        this.addLocal(this.maskGameObject);
        this.childrenMask = this.maskGameObject.createGeometryMask();
        return this;
    },
    removeMaskGameObject () {
        this.backImage.clearMask();
        this.frontImage.clearMask();
        this.childrenMask = undefined;
        this.remove(this.maskGameObject, true);
        this.maskGameObject = undefined;
        return this;
    },
    setImageMaskEnable (gameObject, enable, invertAlpha) {
        if (enable === undefined) enable = true;
        // Use DefaultMaskGraphics if not given
        if (!this.childrenMask) this.setMaskGameObject(true);
        if (enable) {
            gameObject.setMask(this.childrenMask);
            if (invertAlpha) this.childrenMask.setInvertAlpha();
        } else gameObject.clearMask();
        return this;
    },
    setCurrentImageMaskEnable (enable, invertAlpha) {
        this.setImageMaskEnable(this.currentImage, enable, invertAlpha);
        return this;
    },
    setNextImageMaskEnable (enable, invertAlpha) {
        this.setImageMaskEnable(this.nextImage, enable, invertAlpha);
        return this;
    },
    setCellImagesMaskEnable (enable, invertAlpha) {
        var cellImages = this.getCellImages();
        for(var i = 0, cnt = cellImages.length; i < cnt; i++)this.setImageMaskEnable(cellImages[i], enable, invertAlpha);
        return this;
    },
    setMaskEnable (enable, invertAlpha) {
        this.setImageMaskEnable(this.backImage, enable, invertAlpha);
        this.setImageMaskEnable(this.frontImage, enable, invertAlpha);
        this.setCellImagesMaskEnable(enable, invertAlpha);
        return this;
    }
};


var $7f3e8e099e821ae3$var$GetFrameNameCallback = function(baseFrameName, delimiter) {
    if (delimiter === undefined) delimiter = ",";
    var callback;
    if (baseFrameName === "__BASE") callback = function(colIndex, rowIndex) {
        return `${colIndex}${delimiter}${rowIndex}`;
    };
    else callback = function(colIndex, rowIndex) {
        return `${baseFrameName}_${colIndex}${delimiter}${rowIndex}`;
    };
    return callback;
};
var $7f3e8e099e821ae3$export$2e2bcd8739ae039 = $7f3e8e099e821ae3$var$GetFrameNameCallback;


var $43208629d4877a38$var$GridCut = function(scene, key, frame, columns, rows, getFrameNameCallback) {
    if (frame == null) frame = "__BASE";
    if (!getFrameNameCallback) getFrameNameCallback = (0, $7f3e8e099e821ae3$export$2e2bcd8739ae039)(frame, getFrameNameCallback);
    var texture = scene.sys.textures.get(key);
    var isRenderTexture = texture.source[0].isRenderTexture;
    var baseFrame = typeof frame === "object" ? frame : texture.get(frame);
    var baseWidth = baseFrame.width, baseHeight = baseFrame.height;
    var cellX, cellY, cellName;
    var cellWidth = baseWidth / columns, cellHeight = baseHeight / rows;
    var offsetX = 0, offsetY = 0;
    for(var y = 0; y < rows; y++){
        offsetX = 0;
        for(var x = 0; x < columns; x++){
            cellName = getFrameNameCallback(x, y);
            cellX = offsetX + baseFrame.cutX;
            if (!isRenderTexture) cellY = offsetY + baseFrame.cutY;
            else cellY = baseHeight - offsetY - cellHeight + baseFrame.cutY;
            texture.add(cellName, 0, cellX, cellY, cellWidth, cellHeight);
            offsetX += cellWidth;
        }
        offsetY += cellHeight;
    }
    return {
        getFrameNameCallback: getFrameNameCallback,
        cellWidth: cellWidth,
        cellHeight: cellHeight,
        columns: columns,
        rows: rows
    };
};
var $43208629d4877a38$export$2e2bcd8739ae039 = $43208629d4877a38$var$GridCut;


const $f54aaa365fc8a657$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f54aaa365fc8a657$var$DefaultImageClass = Phaser.GameObjects.Image;
const $f54aaa365fc8a657$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $f54aaa365fc8a657$var$RotateAround = Phaser.Math.RotateAround;
var $f54aaa365fc8a657$var$GridCutImage = function(gameObject, columns, rows, config) {
    if ($f54aaa365fc8a657$var$IsPlainObject(columns)) {
        config = columns;
        columns = $f54aaa365fc8a657$var$GetValue(config, "columns", 1);
        rows = $f54aaa365fc8a657$var$GetValue(config, "rows", 1);
    }
    var createImageCallback = $f54aaa365fc8a657$var$GetValue(config, "onCreateImage");
    if (!createImageCallback) {
        var ImageClass = $f54aaa365fc8a657$var$GetValue(config, "ImageClass", $f54aaa365fc8a657$var$DefaultImageClass);
        createImageCallback = function(scene, key, frame) {
            return new ImageClass(scene, 0, 0, key, frame);
        };
    }
    var originX = $f54aaa365fc8a657$var$GetValue(config, "originX", 0.5);
    var originY = $f54aaa365fc8a657$var$GetValue(config, "originY", 0.5);
    var addToScene = $f54aaa365fc8a657$var$GetValue(config, "add", true);
    var align = $f54aaa365fc8a657$var$GetValue(config, "align", addToScene);
    var imageObjectPool = $f54aaa365fc8a657$var$GetValue(config, "objectPool", undefined);
    var scene = gameObject.scene;
    var texture = gameObject.texture;
    var frame = gameObject.frame;
    var result = (0, $43208629d4877a38$export$2e2bcd8739ae039)(scene, texture, frame, columns, rows);
    var getFrameNameCallback = result.getFrameNameCallback;
    var scaleX = gameObject.scaleX, scaleY = gameObject.scaleY;
    var rotation = gameObject.rotation;
    var topLeft = gameObject.getTopLeft(), startX = topLeft.x, startY = topLeft.y;
    var cellGameObjects = [];
    var cellWidth = result.cellWidth * scaleX, cellHeight = result.cellHeight * scaleY;
    for(var y = 0; y < rows; y++)for(var x = 0; x < columns; x++){
        var cellGameObject;
        var frameName = getFrameNameCallback(x, y);
        if (imageObjectPool && imageObjectPool.length > 0) cellGameObject = imageObjectPool.pop().setTexture(texture, frameName);
        else cellGameObject = createImageCallback(scene, texture, frameName);
        if (addToScene) scene.add.existing(cellGameObject);
        var cellTLX = startX + cellWidth * x;
        var cellTLY = startY + cellHeight * y;
        var cellX = cellTLX + originX * cellWidth;
        var cellY = cellTLY + originY * cellHeight;
        if (align) {
            cellGameObject.setOrigin(originX, originY).setPosition(cellX, cellY).setScale(scaleX, scaleY).setRotation(rotation);
            $f54aaa365fc8a657$var$RotateAround(cellGameObject, startX, startY, rotation);
        }
        cellGameObjects.push(cellGameObject);
    }
    return cellGameObjects;
};
var $f54aaa365fc8a657$export$2e2bcd8739ae039 = $f54aaa365fc8a657$var$GridCutImage;


var $7cd030196fd0153e$export$2e2bcd8739ae039 = {
    gridCutImage (gameObject, columns, rows, config) {
        if (config === undefined) config = {};
        config.objectPool = this.imagesPool;
        var cellImages = (0, $f54aaa365fc8a657$export$2e2bcd8739ae039)(gameObject, columns, rows, config), cellImage;
        for(var i = 0, cnt = cellImages.length; i < cnt; i++){
            cellImage = cellImages[i];
            cellImage.setVisible(true);
            this.add(cellImage);
        }
        this.cellImages = cellImages;
        this.setChildLocalVisible(gameObject, false); // Set cut target to invisible
        return cellImages;
    },
    gridCutCurrentImage (columns, rows, config) {
        return this.gridCutImage(this.currentImage, columns, rows, config);
    },
    gridCutNextImage (columns, rows, config) {
        return this.gridCutImage(this.nextImage, columns, rows, config);
    },
    getCellImages () {
        return this.cellImages;
    },
    freeCellImages () {
        if (this.cellImages.length === 0) return this;
        var texture = this.cellImages[0].texture;
        var cellImages = this.cellImages, cellImage, frameName;
        for(var i = 0, cnt = cellImages.length; i < cnt; i++){
            cellImage = cellImages[i];
            // Reset property of cell image
            this.setChildLocalAlpha(cellImage, 1).setChildLocalScale(cellImage, 1).setChildLocalVisible(cellImage, false);
            cellImage.clearMask();
            // Remove frame object
            frameName = cellImage.frame.name;
            cellImage.setTexture();
            texture.remove(frameName);
        }
        this.imagesPool.push(...cellImages);
        cellImages.length = 0;
        return this;
    }
};


var $8c9c9cc255b9bee7$export$2e2bcd8739ae039 = {
    setFlipX (value) {
        this.flipX = value;
        return this;
    },
    setFlipY (value) {
        this.flipY = value;
        return this;
    },
    toggleFlipX () {
        this.flipX = !this.flipX;
        return this;
    },
    toggleFlipY () {
        this.flipY = !this.flipY;
        return this;
    },
    setFlip (x, y) {
        this.flipX = x;
        this.flipY = y;
        return this;
    },
    resetFlip () {
        this.flipX = false;
        this.flipY = false;
        return this;
    }
};


var $4ac6c78c6cdb73ef$var$methods = {};
Object.assign($4ac6c78c6cdb73ef$var$methods, (0, $0e85fd788b05be09$export$2e2bcd8739ae039), (0, $6396a426f6dd7405$export$2e2bcd8739ae039), (0, $bd7ffad023288172$export$2e2bcd8739ae039), (0, $7cd030196fd0153e$export$2e2bcd8739ae039), (0, $8c9c9cc255b9bee7$export$2e2bcd8739ae039));
var $4ac6c78c6cdb73ef$export$2e2bcd8739ae039 = $4ac6c78c6cdb73ef$var$methods;


var $24a1531e81a70e95$export$6bef79582e51b4bf = function(parent, currentImage, nextImage, t) {};
var $24a1531e81a70e95$export$aa8dcc60f04912e1 = function(parent, currentImage, nextImage, t) {
    parent.setChildLocalAlpha(currentImage, 1 - t).setChildLocalAlpha(nextImage, t);
};
var $24a1531e81a70e95$export$30346a2d90c8ce81 = function(parent, currentImage, nextImage, t) {
    parent.setChildLocalAlpha(currentImage, 1);
};


const $abcad68cb94416ae$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $abcad68cb94416ae$var$GetValue = Phaser.Utils.Objects.GetValue;
const $abcad68cb94416ae$var$Clamp = Phaser.Math.Clamp;
class $abcad68cb94416ae$var$TransitionImage extends (0, $3799588e8b69e578$export$2e2bcd8739ae039) {
    constructor(scene, x, y, texture, frame, config){
        if ($abcad68cb94416ae$var$IsPlainObject(x)) {
            config = x;
            x = $abcad68cb94416ae$var$GetValue(config, "x", 0);
            y = $abcad68cb94416ae$var$GetValue(config, "y", 0);
            texture = $abcad68cb94416ae$var$GetValue(config, "key", undefined);
            frame = $abcad68cb94416ae$var$GetValue(config, "frame", undefined);
        } else if ($abcad68cb94416ae$var$IsPlainObject(frame)) {
            config = frame;
            frame = undefined;
        }
        var backImage = $abcad68cb94416ae$var$GetValue(config, "back", undefined);
        var frontImage = $abcad68cb94416ae$var$GetValue(config, "front", undefined);
        if (!backImage) backImage = scene.add.image(x, y, texture, frame);
        if (!frontImage) frontImage = scene.add.image(x, y, texture, frame);
        var width = $abcad68cb94416ae$var$GetValue(config, "width", frontImage.width);
        var height = $abcad68cb94416ae$var$GetValue(config, "height", frontImage.height);
        super(scene, x, y, width, height);
        this.type = "rexTransitionImage";
        backImage.setVisible(false);
        this.addMultiple([
            backImage,
            frontImage
        ]);
        this.backImage = backImage;
        this.frontImage = frontImage;
        this.maskGameObject = undefined;
        this.cellImages = [];
        this.imagesPool = [];
        // Transition parameters
        var onStart = $abcad68cb94416ae$var$GetValue(config, "onStart", undefined);
        var onProgress = $abcad68cb94416ae$var$GetValue(config, "onProgress", undefined);
        var onComplete = $abcad68cb94416ae$var$GetValue(config, "onComplete", undefined);
        var dir = $abcad68cb94416ae$var$GetValue(config, "dir", 0);
        if (onStart === undefined && onProgress === undefined && onComplete === undefined) {
            onStart = (0, $24a1531e81a70e95$export$6bef79582e51b4bf);
            onProgress = (0, $24a1531e81a70e95$export$aa8dcc60f04912e1);
            onComplete = (0, $24a1531e81a70e95$export$30346a2d90c8ce81);
            dir = 0;
        }
        this.setTransitionStartCallback(onStart, $abcad68cb94416ae$var$GetValue(config, "onStartScope", undefined)).setTransitionProgressCallback(onProgress, $abcad68cb94416ae$var$GetValue(config, "onProgressScope", undefined)).setTransitionCompleteCallback(onComplete, $abcad68cb94416ae$var$GetValue(config, "onCompleteScope", undefined)).setTransitionDirection(dir).setDuration($abcad68cb94416ae$var$GetValue(config, "duration", 1000)).setEaseFunction($abcad68cb94416ae$var$GetValue(config, "ease", "Linear"));
        var maskGameObject = $abcad68cb94416ae$var$GetValue(config, "mask", undefined);
        if (maskGameObject) this.setMaskGameObject(maskGameObject);
        this.setMaskEnable(false);
        this.ignoreCompleteEvent = false;
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (this.childrenMask) {
            this.childrenMask.destroy();
            this.childrenMask = undefined;
        }
        this.backImage = undefined;
        this.frontImage = undefined;
        this.maskGameObject = undefined;
        this.cellImages.length = 0;
        this.imagesPool.length = 0;
        super.destroy(fromScene);
        this.onStartCallback = undefined;
        this.onStartCallbackScope = undefined;
        this.onProgressCallback = undefined;
        this.onProgressCallbackScope = undefined;
        this.onCompleteCallback = undefined;
        this.onCompleteCallbackScope = undefined;
        this.easeValueTask = undefined;
    }
    get currentImage() {
        return this.dir === 0 ? this.frontImage : this.backImage;
    }
    get nextImage() {
        return this.dir === 0 ? this.backImage : this.frontImage;
    }
    get texture() {
        return this.nextImage.texture;
    }
    get frame() {
        return this.nextImage.frame;
    }
    get flipX() {
        return this._flipX;
    }
    set flipX(value) {
        if (this._flipX === value) return;
        this._flipX = value;
        this.backImage.setFlipX(value);
        this.frontImage.setFlipX(value);
    }
    get flipY() {
        return this._flipY;
    }
    set flipY(value) {
        if (this._flipY === value) return;
        this._flipY = value;
        this.backImage.setFlipY(value);
        this.frontImage.setFlipY(value);
    }
    get t() {
        return this._t;
    }
    set t(value) {
        value = $abcad68cb94416ae$var$Clamp(value, 0, 1);
        if (this._t === value) return;
        this._t = value;
        var currentImage = this.currentImage;
        var nextImage = this.nextImage;
        // Start
        if (value === 0) {
            this.setChildVisible(this.frontImage, true).setChildVisible(this.backImage, true);
            $abcad68cb94416ae$var$RunCallback(this.onStartCallback, this.onStartCallbackScope, this, currentImage, nextImage, value);
        }
        // Progress
        $abcad68cb94416ae$var$RunCallback(this.onProgressCallback, this.onProgressCallbackScope, this, currentImage, nextImage, value);
        // Complete
        if (value === 1) {
            $abcad68cb94416ae$var$RunCallback(this.onCompleteCallback, this.onCompleteCallbackScope, this, currentImage, nextImage, value);
            var key = nextImage.texture.key, frame = nextImage.frame.name;
            this.frontImage.setTexture(key, frame);
            this.backImage.setTexture(key, frame);
            this.setChildVisible(this.frontImage, true).setChildVisible(this.backImage, false).setMaskEnable(false).freeCellImages();
        }
        if (value === 1 && !this.ignoreCompleteEvent) this.emit("complete");
    }
    setT(value) {
        this.t = value;
        return this;
    }
    get isRunning() {
        return this.easeValueTask ? this.easeValueTask.isRunning : false;
    }
    setOrigin(originX, originY) {
        super.setOrigin(originX, originY);
        this.backImage.setOrigin(originX, originY);
        this.frontImage.setOrigin(originX, originY);
        if (this.maskGameObject) this.maskGameObject.setOrigin(originX, originY);
        return this;
    }
    setTexture(texture, frame) {
        // Without transition
        this.frontImage.setTexture(texture, frame);
        this.backImage.setTexture(texture, frame).setVisible(false);
        return this;
    }
}
var $abcad68cb94416ae$var$RunCallback = function(callback, scope, parent, currentImage, nextImage, t) {
    if (!callback) return;
    if (scope) callback.call(scope, parent, currentImage, nextImage, t);
    else callback(parent, currentImage, nextImage, t);
};
// mixin
Object.assign($abcad68cb94416ae$var$TransitionImage.prototype, (0, $4ac6c78c6cdb73ef$export$2e2bcd8739ae039));
var $abcad68cb94416ae$export$2e2bcd8739ae039 = $abcad68cb94416ae$var$TransitionImage;


var $7502d580e4f89569$export$2e2bcd8739ae039 = (0, $abcad68cb94416ae$export$2e2bcd8739ae039);


var $df268ae0137e98f3$export$2e2bcd8739ae039 = (0, $7502d580e4f89569$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("transitionImage", function(x, y, texture, frame, config) {
    var gameObject = new (0, $df268ae0137e98f3$export$2e2bcd8739ae039)(this.scene, x, y, texture, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TransitionImage", (0, $df268ae0137e98f3$export$2e2bcd8739ae039));
var $219bb083776a44c8$export$2e2bcd8739ae039 = (0, $df268ae0137e98f3$export$2e2bcd8739ae039);



var $f8bc9c871011dc12$var$FitTo = function(child, parent, out) {
    if (out === undefined) out = {};
    else if (out === true) out = $f8bc9c871011dc12$var$globalSize;
    if (child.width <= parent.width && child.height <= parent.height) {
        out.width = child.width;
        out.height = child.height;
        return out;
    }
    var childRatio = child.width / child.height;
    out.width = Math.min(child.width, parent.width);
    out.height = Math.min(child.height, parent.height);
    var ratio = out.width / out.height;
    if (ratio < childRatio) out.height = out.width / childRatio;
    else if (ratio > childRatio) out.width = out.height * childRatio;
    return out;
};
var $f8bc9c871011dc12$var$globalSize = {};
var $f8bc9c871011dc12$export$2e2bcd8739ae039 = $f8bc9c871011dc12$var$FitTo;




var $1ddaa9a494d5a4a5$var$HasTexture = function(game, key, frame) {
    game = (0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(game);
    var cache = game.textures;
    var hasTexture = cache.exists(key);
    if (frame === undefined) return hasTexture;
    return cache.get(key).has(frame);
};
var $1ddaa9a494d5a4a5$export$2e2bcd8739ae039 = $1ddaa9a494d5a4a5$var$HasTexture;


const $3b110f0c809df8c0$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $3b110f0c809df8c0$var$GetValue = Phaser.Utils.Objects.GetValue;
class $3b110f0c809df8c0$var$ImageBox extends (0, $3799588e8b69e578$export$2e2bcd8739ae039) {
    constructor(scene, x, y, texture, frame, config){
        if ($3b110f0c809df8c0$var$IsPlainObject(x)) {
            config = x;
            x = $3b110f0c809df8c0$var$GetValue(config, "x", 0);
            y = $3b110f0c809df8c0$var$GetValue(config, "y", 0);
            texture = $3b110f0c809df8c0$var$GetValue(config, "key", undefined);
            frame = $3b110f0c809df8c0$var$GetValue(config, "frame", undefined);
        } else if ($3b110f0c809df8c0$var$IsPlainObject(frame)) {
            config = frame;
            frame = undefined;
        }
        var image = $3b110f0c809df8c0$var$GetValue(config, "image");
        if (!image) {
            image = scene.add.image(x, y, texture, frame);
            if (texture === undefined) image.setVisible(false);
        } else image.setPosition(x, y).setOrigin(0.5);
        super(scene, x, y, 1, 1);
        this.type = "rexImageBox";
        this.add(image);
        this.image = image;
        var width = $3b110f0c809df8c0$var$GetValue(config, "width", image.width);
        var height = $3b110f0c809df8c0$var$GetValue(config, "height", image.height);
        this.resize(width, height);
    }
    get texture() {
        return this.image.texture;
    }
    get frame() {
        return this.image.frame;
    }
    get flipX() {
        return this._flipX;
    }
    set flipX(value) {
        if (this._flipX === value) return;
        this._flipX = value;
        this.image.setFlipX(value);
    }
    get flipY() {
        return this._flipY;
    }
    set flipY(value) {
        if (this._flipY === value) return;
        this._flipY = value;
        this.image.setFlipY(value);
    }
    scaleImage() {
        var image = this.image;
        var result = (0, $f8bc9c871011dc12$export$2e2bcd8739ae039)(image, {
            width: this.width,
            height: this.height
        }, true);
        image.setDisplaySize(result.width, result.height);
        this.resetChildScaleState(image);
        return this;
    }
    resize(width, height) {
        super.resize(width, height);
        this.scaleImage();
        return this;
    }
    setTexture(texture, frame) {
        var image = this.image;
        image.setTexture(texture, frame);
        if (texture !== null) {
            this.setChildVisible(image, true);
            this.scaleImage();
        } else this.setChildVisible(image, false);
        return this;
    }
}
Object.assign($3b110f0c809df8c0$var$ImageBox.prototype, (0, $8c9c9cc255b9bee7$export$2e2bcd8739ae039));
var $3b110f0c809df8c0$export$2e2bcd8739ae039 = $3b110f0c809df8c0$var$ImageBox;


var $da22686379953874$export$2e2bcd8739ae039 = (0, $3b110f0c809df8c0$export$2e2bcd8739ae039);


var $891a542dbaed8086$export$2e2bcd8739ae039 = (0, $da22686379953874$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("imageBox", function(x, y, texture, frame, config) {
    var gameObject = new (0, $891a542dbaed8086$export$2e2bcd8739ae039)(this.scene, x, y, texture, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ImageBox", (0, $891a542dbaed8086$export$2e2bcd8739ae039));
var $52f4a324f4a00430$export$2e2bcd8739ae039 = (0, $891a542dbaed8086$export$2e2bcd8739ae039);



var $12138c76ddc8a0e4$export$2e2bcd8739ae039 = (0, $ef4c8b73b47b333b$export$2e2bcd8739ae039);


var $1a84d0f11b7e6acf$export$2e2bcd8739ae039 = (0, $12138c76ddc8a0e4$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fullWindowRectangle", function(fillColor, fillAlpha) {
    var gameObject = new (0, $1a84d0f11b7e6acf$export$2e2bcd8739ae039)(this.scene, fillColor, fillAlpha);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FullWindowRectangle", (0, $1a84d0f11b7e6acf$export$2e2bcd8739ae039));
var $cace8bd8f3ba76f3$export$2e2bcd8739ae039 = (0, $1a84d0f11b7e6acf$export$2e2bcd8739ae039);



var $48a1a866f9505946$export$2e2bcd8739ae039 = (0, $699a25c94ddc77a8$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("cover", function(config) {
    var gameObject = new (0, $48a1a866f9505946$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Cover", (0, $48a1a866f9505946$export$2e2bcd8739ae039));
var $6941b716f9a812b8$export$2e2bcd8739ae039 = (0, $48a1a866f9505946$export$2e2bcd8739ae039);



var $7e52109d06afffa6$export$2e2bcd8739ae039 = (0, $28892e8128e1413d$export$2e2bcd8739ae039);


var $1889380b12d32afd$export$2e2bcd8739ae039 = (0, $7e52109d06afffa6$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("inputText", function(config) {
    var gameObject = new (0, $1889380b12d32afd$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.InputText", (0, $1889380b12d32afd$export$2e2bcd8739ae039));
var $42d987c373c9cbff$export$2e2bcd8739ae039 = (0, $1889380b12d32afd$export$2e2bcd8739ae039);


// Note: Not working in iOS9+
const $37405dc5bea33854$var$GetValue = Phaser.Utils.Objects.GetValue;
var $37405dc5bea33854$var$CreateFileInput = function(config) {
    var fileInput = document.createElement("input");
    fileInput.type = "file";
    var accept = $37405dc5bea33854$var$GetValue(config, "accept", "");
    var multiple = $37405dc5bea33854$var$GetValue(config, "multiple", false);
    fileInput.setAttribute("accept", accept);
    if (multiple) fileInput.setAttribute("multiple", "");
    else fileInput.removeAttribute("multiple");
    return fileInput;
};
var $37405dc5bea33854$export$2e2bcd8739ae039 = $37405dc5bea33854$var$CreateFileInput;




var $beb798f9c639b258$var$Delay = function(time, result) {
    if (time === undefined) time = 0;
    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            resolve(result);
        }, time);
    });
};
var $beb798f9c639b258$export$2e2bcd8739ae039 = $beb798f9c639b258$var$Delay;


var $6a03f95d1aa72422$var$ClickPromise = function({ game: game, fileInput: fileInput, closeDelay: closeDelay }) {
    return (0, $2b5b0b08519578fd$export$64e00c1c113b35b1)((0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(game).events, "focus").then(function() {
        return (0, $beb798f9c639b258$export$2e2bcd8739ae039)(closeDelay);
    }).then(function() {
        var result = {
            files: fileInput.files
        };
        return Promise.resolve(result);
    });
};
var $6a03f95d1aa72422$export$2e2bcd8739ae039 = $6a03f95d1aa72422$var$ClickPromise;


const $f2dcf909375d9d62$var$GetValue = Phaser.Utils.Objects.GetValue;
var $f2dcf909375d9d62$var$Open = function(game, config) {
    // game: game, scene, or game object
    var closeDelay = $f2dcf909375d9d62$var$GetValue(config, "closeDelay", 200);
    var fileInput = (0, $37405dc5bea33854$export$2e2bcd8739ae039)(config);
    fileInput.click();
    return (0, $6a03f95d1aa72422$export$2e2bcd8739ae039)({
        game: game,
        fileInput: fileInput,
        closeDelay: closeDelay
    }).then(function(result) {
        fileInput.remove();
        return Promise.resolve(result);
    });
};
var $f2dcf909375d9d62$export$2e2bcd8739ae039 = $f2dcf909375d9d62$var$Open;



var $05c418be0dbc7d7c$var$SyncTo = function(gameObject) {
    this.setOrigin(gameObject.originX, gameObject.originY);
    this.setPosition(gameObject.x, gameObject.y);
    this.resize(gameObject.displayWidth, gameObject.displayHeight);
    return this;
};
var $05c418be0dbc7d7c$export$2e2bcd8739ae039 = $05c418be0dbc7d7c$var$SyncTo;



var $d2097376e16b7dba$var$GetCache = function(game, loaderType, cacheType) {
    if (cacheType === undefined) switch(loaderType){
        case "image":
        case "svg":
            cacheType = "textures";
            break;
        case "animation":
            cacheType = "json";
            break;
        case "tilemapTiledJSON":
        case "tilemapCSV":
            cacheType = "tilemap";
            break;
        case "glsl":
            cacheType = "shader";
            break;
        default:
            cacheType = loaderType;
            break;
    }
    game = (0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(game);
    var cache;
    if (cacheType === "textures") cache = game.textures;
    else cache = game.cache[cacheType];
    return cache;
};
var $d2097376e16b7dba$export$2e2bcd8739ae039 = $d2097376e16b7dba$var$GetCache;



var $af84747a0b501bdd$var$FileObjectToCache = function(scene, file, loaderType, key, cacheType, onComplete) {
    // Remove data from cache
    if (cacheType === null || cacheType === false) ;
    else if ((0, $761920aac251583f$export$2e2bcd8739ae039)(cacheType)) cacheType();
    else {
        var cache = (0, $d2097376e16b7dba$export$2e2bcd8739ae039)(scene, loaderType, cacheType);
        if (cache.exists(key)) cache.remove(key);
    }
    // Add filecomplete event
    var loader = scene.load;
    if (onComplete) loader.once(`filecomplete-${loaderType}-${key}`, function(key, type, data) {
        onComplete(data);
    });
    // Load file from url
    if ((0, $761920aac251583f$export$2e2bcd8739ae039)(file)) file();
    else {
        var url = window.URL.createObjectURL(file);
        loader[loaderType](key, url);
    }
    loader.start();
};
var $af84747a0b501bdd$export$2e2bcd8739ae039 = $af84747a0b501bdd$var$FileObjectToCache;


var $5e52ec621251dac9$var$LoadFile = function(file, loaderType, key, cacheType, onComplete) {
    var scene = this.scene;
    (0, $af84747a0b501bdd$export$2e2bcd8739ae039)(scene, file, loaderType, key, cacheType, onComplete);
    return this;
};
var $5e52ec621251dac9$var$LoadFilePromise = function(file, loaderType, key, cacheType) {
    var scene = this.scene;
    return new Promise(function(resolve, reject) {
        var onComplete = function(data) {
            resolve(data);
        };
        (0, $af84747a0b501bdd$export$2e2bcd8739ae039)(scene, file, loaderType, key, cacheType, onComplete);
    });
};
var $5e52ec621251dac9$export$2e2bcd8739ae039 = {
    loadFile: $5e52ec621251dac9$var$LoadFile,
    loadFilePromise: $5e52ec621251dac9$var$LoadFilePromise
};



const $c57c3d4ef22bfaaa$var$DOMElement = Phaser.GameObjects.DOMElement;
const $c57c3d4ef22bfaaa$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $c57c3d4ef22bfaaa$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c57c3d4ef22bfaaa$var$FileChooser extends $c57c3d4ef22bfaaa$var$DOMElement {
    constructor(scene, x, y, width, height, config){
        if ($c57c3d4ef22bfaaa$var$IsPlainObject(x)) {
            config = x;
            x = $c57c3d4ef22bfaaa$var$GetValue(config, "x", 0);
            y = $c57c3d4ef22bfaaa$var$GetValue(config, "y", 0);
            width = $c57c3d4ef22bfaaa$var$GetValue(config, "width", 0);
            height = $c57c3d4ef22bfaaa$var$GetValue(config, "height", 0);
        } else if ($c57c3d4ef22bfaaa$var$IsPlainObject(width)) {
            config = width;
            width = $c57c3d4ef22bfaaa$var$GetValue(config, "width", 0);
            height = $c57c3d4ef22bfaaa$var$GetValue(config, "height", 0);
        }
        // Create a hidden file input
        var inputElement = document.createElement("input");
        inputElement.type = "file";
        var inputStyle = inputElement.style;
        inputStyle.display = "none";
        // Create a label parent
        var labelElement = document.createElement("label");
        labelElement.appendChild(inputElement);
        var style = $c57c3d4ef22bfaaa$var$GetValue(config, "style", undefined);
        super(scene, x, y, labelElement, style);
        this.type = "rexFileChooser";
        this.resetFromJSON(config);
        this.resize(width, height);
        // Register events
        var self = this;
        inputElement.onchange = function() {
            self.emit("change", self);
        };
        this.setCloseDelay($c57c3d4ef22bfaaa$var$GetValue(config, "closeDelay", 200));
        inputElement.onclick = function() {
            (0, $6a03f95d1aa72422$export$2e2bcd8739ae039)({
                game: scene,
                fileInput: inputElement,
                closeDelay: self.closeDelay
            }).then(function() {
                self.emit("select", self);
            });
        };
    }
    resetFromJSON(config) {
        this.setAccept($c57c3d4ef22bfaaa$var$GetValue(config, "accept", ""));
        this.setMultiple($c57c3d4ef22bfaaa$var$GetValue(config, "multiple", false));
        return this;
    }
    setAccept(accept) {
        if (accept === undefined) accept = "";
        this.fileInput.setAttribute("accept", accept);
        return this;
    }
    setMultiple(enabled) {
        if (enabled === undefined) enabled = true;
        if (enabled) this.fileInput.setAttribute("multiple", "");
        else this.fileInput.removeAttribute("multiple");
        return this;
    }
    setCloseDelay(delay) {
        if (delay === undefined) delay = 200;
        this.closeDelay = delay;
        return this;
    }
    get fileInput() {
        return this.node.children[0];
    }
    open() {
        this.fileInput.click();
        return this;
    }
    get files() {
        return this.fileInput.files;
    }
}
var $c57c3d4ef22bfaaa$var$methods = {
    resize: (0, $0611249a3cf734f2$export$2e2bcd8739ae039),
    syncTo: (0, $05c418be0dbc7d7c$export$2e2bcd8739ae039)
};
Object.assign($c57c3d4ef22bfaaa$var$FileChooser.prototype, $c57c3d4ef22bfaaa$var$methods, (0, $5e52ec621251dac9$export$2e2bcd8739ae039));
var $c57c3d4ef22bfaaa$export$2e2bcd8739ae039 = $c57c3d4ef22bfaaa$var$FileChooser;








(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fileChooser", function(config) {
    var gameObject = new (0, $c57c3d4ef22bfaaa$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FileChooser", (0, $c57c3d4ef22bfaaa$export$2e2bcd8739ae039));
var $aa39f27f9c4bca1c$export$2e2bcd8739ae039 = (0, $c57c3d4ef22bfaaa$export$2e2bcd8739ae039);





var $a30ae261d050a604$export$2e2bcd8739ae039 = {
    setDropEnable (enable) {
        if (enable === undefined) enable = true;
        this.dropEnable = enable;
        return this;
    },
    toggleDropEnable () {
        this.dropEnable = !this.dropEnable;
        return this;
    }
};


var $ec57cb2a647ec311$export$2e2bcd8739ae039 = {
    addFilter (name, callback) {
        if (!this.filters) this.filters = {};
        this.filters[name] = callback;
        return this;
    },
    addFilters (filters) {
        if (!this.filters) this.filters = {};
        for(var name in filters)this.filters[name] = filters[name];
        return this;
    }
};


var $ea7112d8607c4c19$var$Methods = {
    resize: (0, $0611249a3cf734f2$export$2e2bcd8739ae039),
    syncTo: (0, $05c418be0dbc7d7c$export$2e2bcd8739ae039)
};
Object.assign($ea7112d8607c4c19$var$Methods, (0, $a30ae261d050a604$export$2e2bcd8739ae039), (0, $ec57cb2a647ec311$export$2e2bcd8739ae039), (0, $5e52ec621251dac9$export$2e2bcd8739ae039));
var $ea7112d8607c4c19$export$2e2bcd8739ae039 = $ea7112d8607c4c19$var$Methods;


const $aa07aed0b606495e$export$1aacc6904af1ee9b = {
    dragenter: "dragenter",
    dragleave: "dragleave",
    dragover: "dragover",
    drop: "drop"
};



const $5de3152ace4aa3df$var$DOMElement = Phaser.GameObjects.DOMElement;
const $5de3152ace4aa3df$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $5de3152ace4aa3df$var$GetValue = Phaser.Utils.Objects.GetValue;
class $5de3152ace4aa3df$var$FileDropZone extends $5de3152ace4aa3df$var$DOMElement {
    constructor(scene, x, y, width, height, config){
        if ($5de3152ace4aa3df$var$IsPlainObject(x)) {
            config = x;
            x = $5de3152ace4aa3df$var$GetValue(config, "x", 0);
            y = $5de3152ace4aa3df$var$GetValue(config, "y", 0);
            width = $5de3152ace4aa3df$var$GetValue(config, "width", 0);
            height = $5de3152ace4aa3df$var$GetValue(config, "height", 0);
        } else if ($5de3152ace4aa3df$var$IsPlainObject(width)) {
            config = width;
            width = $5de3152ace4aa3df$var$GetValue(config, "width", 0);
            height = $5de3152ace4aa3df$var$GetValue(config, "height", 0);
        }
        if (config === undefined) config = {};
        var element = document.createElement("div");
        var style = $5de3152ace4aa3df$var$GetValue(config, "style", undefined);
        super(scene, x, y, element, style);
        this.type = "rexFileDropZone";
        this.resize(width, height);
        this._files = [];
        this.setDropEnable($5de3152ace4aa3df$var$GetValue(config, "dropEnable", true));
        var filters = $5de3152ace4aa3df$var$GetValue(config, "filters");
        if (filters) this.addFilters(filters);
        // Apply events
        (0, $fe14a876e6921d2b$export$2e2bcd8739ae039)(this, element, (0, $aa07aed0b606495e$export$1aacc6904af1ee9b), {
            preventDefault: true,
            preTest (gameObject) {
                return gameObject.dropEnable;
            }
        });
        this.on("drop", function(gameObject, e) {
            this._files = e.dataTransfer.files;
            var files = this._files;
            if (files && this.filters) for(var filterType in this.filters){
                var filterCallback = this.filters[filterType];
                var filteredFiles = [];
                for(var i = 0, cnt = files.length; i < cnt; i++){
                    var file = files[i];
                    if (filterCallback(file, files)) filteredFiles.push(file);
                }
                if (filteredFiles.length > 0) this.emit(`drop.${filterType}`, filteredFiles);
            }
        }, this);
    }
    get files() {
        return this._files;
    }
}
Object.assign($5de3152ace4aa3df$var$FileDropZone.prototype, (0, $ea7112d8607c4c19$export$2e2bcd8739ae039));
var $5de3152ace4aa3df$export$2e2bcd8739ae039 = $5de3152ace4aa3df$var$FileDropZone;


var $1aa714b3cd0224e0$export$2e2bcd8739ae039 = (0, $5de3152ace4aa3df$export$2e2bcd8739ae039);


var $2015447ef1d718ed$export$2e2bcd8739ae039 = (0, $1aa714b3cd0224e0$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fileDropZone", function(config) {
    var gameObject = new (0, $2015447ef1d718ed$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FileDropZone", (0, $2015447ef1d718ed$export$2e2bcd8739ae039));
var $794cf0907ce5feaa$export$2e2bcd8739ae039 = (0, $2015447ef1d718ed$export$2e2bcd8739ae039);



var $9c6897575494f831$var$SetChart = function(config) {
    if (!window.Chart) {
        var msg = `Can not find chartjs! Load chartjs in preload stage.
scene.load.script('chartjs', 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.8.0/Chart.min.js');`;
        console.error(msg);
        return this;
    }
    if (this.chart) this.chart.destroy();
    this.chart = new Chart(this.context, $9c6897575494f831$var$FillConfig(this, config));
    return this;
};
var $9c6897575494f831$var$FillConfig = function(canvas, config) {
    // Get options
    if (config === undefined) config = {};
    if (config.options === undefined) config.options = {};
    var options = config.options;
    // Fill options
    options.responsive = false;
    options.maintainAspectRatio = false;
    if (!options.hasOwnProperty("devicePixelRatio")) options.devicePixelRatio = 1;
    // Get animation config
    var noAnimation = false;
    if (options.animation === undefined) options.animation = {};
    else if (options.animation === false) {
        noAnimation = true;
        options.animation = {};
    }
    var animationConfig = options.animation;
    // Fill animation config
    if (noAnimation) animationConfig.duration = 0;
    var onProgress = animationConfig.onProgress;
    animationConfig.onProgress = function(animation) {
        if (onProgress) onProgress(animation);
        canvas.needRedraw();
    };
    var onComplete = animationConfig.onComplete;
    animationConfig.onComplete = function(animation) {
        if (onComplete) onComplete(animation);
        canvas.needRedraw();
    };
    return config;
};
var $9c6897575494f831$export$2e2bcd8739ae039 = $9c6897575494f831$var$SetChart;


var $e8beb5b4d835e0e4$var$GetChartDataset = function(datasetIndex) {
    if (this.chart === undefined) return undefined;
    if (typeof datasetIndex === "string") {
        var datasets = this.chart.data.datasets, dataset;
        for(var i = 0, cnt = datasets.length; i < cnt; i++){
            dataset = datasets[i];
            if (dataset.label === datasetIndex) return dataset;
        }
    } else return this.chart.data.datasets[datasetIndex];
    return undefined;
};
var $e8beb5b4d835e0e4$export$2e2bcd8739ae039 = $e8beb5b4d835e0e4$var$GetChartDataset;


var $12347eaf06c40345$var$GetChartData = function(datasetIndex, dataIndex) {
    var dataset = this.getChartDataset(datasetIndex);
    if (dataset === undefined) return undefined;
    if (typeof dataIndex === "string") {
        var labels = this.chart.data.labels;
        dataIndex = labels.indexOf(dataIndex);
        if (dataIndex === -1) return undefined;
    }
    return dataset.data[dataIndex];
};
var $12347eaf06c40345$export$2e2bcd8739ae039 = $12347eaf06c40345$var$GetChartData;


var $46eaf9e72c3e258e$var$SetChartData = function(datasetIndex, dataIndex, value) {
    if (this.chart === undefined) return this;
    var dataset = this.getChartDataset(datasetIndex);
    if (typeof dataIndex === "string") {
        var labels = this.chart.data.labels;
        dataIndex = labels.indexOf(dataIndex);
        if (dataIndex === -1) return this;
    }
    dataset.data[dataIndex] = value;
    return this;
};
var $46eaf9e72c3e258e$export$2e2bcd8739ae039 = $46eaf9e72c3e258e$var$SetChartData;


var $cff8741637b75fa0$var$UpdateChart = function() {
    if (this.chart === undefined) return this;
    this.chart.update();
    return this;
};
var $cff8741637b75fa0$export$2e2bcd8739ae039 = $cff8741637b75fa0$var$UpdateChart;


// This plugin does not contain chart.js
// Load chart.js in preload stage -
// scene.load.script('chartjs', 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.8.0/Chart.min.js');
class $5ac26defd98be22f$var$Chart extends (0, $a7cd42622da8fab8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, config){
        super(scene, x, y, width, height);
        this.type = "rexChart";
        this.chart = undefined;
        if (config !== undefined) this.setChart(config);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (this.chart) {
            this.chart.destroy();
            this.chart = undefined;
        }
        super.destroy(fromScene);
    }
    resize(width, height) {
        if (width === this.width && height === this.height) return this;
        super.resize(width, height);
        if (this.chart) {
            var chart = this.chart;
            chart.height = this.canvas.height;
            chart.width = this.canvas.width;
            chart.aspectRatio = chart.height ? chart.width / chart.height : null;
            chart.update();
        }
        return this;
    }
}
var $5ac26defd98be22f$var$methods = {
    setChart: (0, $9c6897575494f831$export$2e2bcd8739ae039),
    getChartDataset: (0, $e8beb5b4d835e0e4$export$2e2bcd8739ae039),
    getChartData: (0, $12347eaf06c40345$export$2e2bcd8739ae039),
    setChartData: (0, $46eaf9e72c3e258e$export$2e2bcd8739ae039),
    updateChart: (0, $cff8741637b75fa0$export$2e2bcd8739ae039)
};
Object.assign($5ac26defd98be22f$var$Chart.prototype, $5ac26defd98be22f$var$methods);
var $5ac26defd98be22f$export$2e2bcd8739ae039 = $5ac26defd98be22f$var$Chart;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("chart", function(x, y, width, height, config) {
    var gameObject = new (0, $5ac26defd98be22f$export$2e2bcd8739ae039)(this.scene, x, y, width, height, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Chart", (0, $5ac26defd98be22f$export$2e2bcd8739ae039));
var $80ce5de288953085$export$2e2bcd8739ae039 = (0, $5ac26defd98be22f$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("container", function(x, y, width, height, children) {
    var gameObject = new (0, $c5e95e90a54f0634$export$2e2bcd8739ae039)(this.scene, x, y, width, height, children);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Container", (0, $c5e95e90a54f0634$export$2e2bcd8739ae039));
var $c10844b8820725c2$export$2e2bcd8739ae039 = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039);



var $9a0687d72e923a3d$var$GetChildrenWidth = function(minimumMode) {
    if (this.rexSizer.hidden) return 0;
    if (minimumMode === undefined) minimumMode = true;
    var result = 0;
    var children = this.sizerChildren;
    var child, padding, childWidth;
    if (this.orientation === 0) {
        // Get summation of minimum width
        var itemSpace = this.space.item;
        var isFirstChild = true;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            child = children[i];
            if (child.rexSizer.hidden) continue;
            if (child.rexSizer.proportion === 0 || minimumMode) childWidth = this.getChildWidth(child);
            else childWidth = 0;
            padding = child.rexSizer.padding;
            childWidth += padding.left + padding.right;
            if (isFirstChild) isFirstChild = false;
            else childWidth += itemSpace;
            result += childWidth;
        }
    } else // Get maximun width
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (!child.hasOwnProperty("rexSizer")) continue;
        if (child.rexSizer.hidden) continue;
        padding = child.rexSizer.padding;
        childWidth = this.getChildWidth(child) + padding.left + padding.right;
        result = Math.max(childWidth, result);
    }
    return result + this.space.left + this.space.right;
};
var $9a0687d72e923a3d$export$2e2bcd8739ae039 = $9a0687d72e923a3d$var$GetChildrenWidth;


var $89504bd15e33433d$var$GetChildrenHeight = function(minimumMode) {
    if (this.rexSizer.hidden) return 0;
    if (minimumMode === undefined) minimumMode = true;
    var result = 0;
    var children = this.sizerChildren;
    var child, padding, childHeight;
    if (this.orientation === 0) // Get maximun height
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.rexSizer.hidden) continue;
        padding = child.rexSizer.padding;
        childHeight = this.getChildHeight(child) + padding.top + padding.bottom;
        result = Math.max(childHeight, result);
    }
    else {
        // Get summation of minimum height
        var itemSpace = this.space.item;
        var isFirstChild = true;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            child = children[i];
            if (!child.hasOwnProperty("rexSizer")) continue;
            if (child.rexSizer.hidden) continue;
            if (child.rexSizer.proportion === 0 || minimumMode) childHeight = this.getChildHeight(child);
            else childHeight = 0;
            padding = child.rexSizer.padding;
            childHeight += padding.top + padding.bottom;
            if (isFirstChild) isFirstChild = false;
            else childHeight += itemSpace;
            result += childHeight;
        }
    }
    return result + this.space.top + this.space.bottom;
};
var $89504bd15e33433d$export$2e2bcd8739ae039 = $89504bd15e33433d$var$GetChildrenHeight;


var $a61dada0dbc5a34d$var$GetExpandedChildWidth = function(child, parentWidth) {
    if (parentWidth === undefined) parentWidth = this.width;
    var childWidth;
    var childConfig = child.rexSizer;
    var padding = childConfig.padding;
    if (this.orientation === 0) {
        if (childConfig.proportion > 0 && this.proportionLength > 0) childWidth = childConfig.proportion * this.proportionLength;
    } else if (childConfig.expand) {
        var innerWidth = parentWidth - this.space.left - this.space.right;
        childWidth = innerWidth - padding.left - padding.right;
    }
    return childWidth;
};
var $a61dada0dbc5a34d$export$2e2bcd8739ae039 = $a61dada0dbc5a34d$var$GetExpandedChildWidth;


var $977a867c8d820a80$var$GetExpandedChildHeight = function(child, parentHeight) {
    if (parentHeight === undefined) parentHeight = this.height;
    var childHeight;
    var childConfig = child.rexSizer;
    var padding = childConfig.padding;
    if (this.orientation === 0) {
        if (childConfig.expand) {
            var innerHeight = parentHeight - this.space.top - this.space.bottom;
            childHeight = innerHeight - padding.top - padding.bottom;
        }
    } else if (childConfig.proportion > 0 && this.proportionLength > 0) childHeight = childConfig.proportion * this.proportionLength;
    return childHeight;
};
var $977a867c8d820a80$export$2e2bcd8739ae039 = $977a867c8d820a80$var$GetExpandedChildHeight;


var $b7090c3618268725$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    var children = this.sizerChildren, child;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.isRexSizer) out.push(child);
    }
    return out;
};
var $b7090c3618268725$export$2e2bcd8739ae039 = $b7090c3618268725$var$GetChildrenSizers;




var $8d4c51eeb234bdae$var$PreLayout = function() {
    // Resize child to 1x1 for ratio-fit 
    this.hasRatioFitChild = false;
    var children = this.sizerChildren;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.rexSizer.hidden) continue;
        if (!child.rexSizer.fitRatio) continue;
        (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, 1, 1);
        this.hasRatioFitChild = true;
    }
    this._childrenProportion = undefined;
    this.proportionLength = undefined;
    (0, $8777309d0690526c$export$2e2bcd8739ae039).call(this);
    return this;
};
var $8d4c51eeb234bdae$export$2e2bcd8739ae039 = $8d4c51eeb234bdae$var$PreLayout;



var $b878687860679a6f$var$PostResolveSize = function(width, height) {
    if (this.hasRatioFitChild) {
        // Resize child for ratio-fit 
        var innerHeight, innerWidth;
        if (this.orientation === 0) innerHeight = height - this.getInnerPadding("top") - this.getInnerPadding("bottom");
        else innerWidth = width - this.getInnerPadding("left") - this.getInnerPadding("right");
        var children = this.sizerChildren, childWidth, childHeight;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            var child = children[i];
            if (child.rexSizer.hidden) continue;
            var fitRatio = child.rexSizer.fitRatio;
            if (!fitRatio) continue;
            if (this.orientation === 0) {
                childHeight = innerHeight - this.getChildOuterPadding(child, "top") - this.getChildOuterPadding(child, "bottom");
                childWidth = childHeight * fitRatio;
            } else {
                childWidth = innerHeight - this.getChildOuterPadding(child, "top") - this.getChildOuterPadding(child, "bottom");
                childHeight = childWidth / fitRatio;
            }
            (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, childWidth, childHeight);
            if (child.isRexSizer) child.setMinSize(childWidth, childHeight);
        }
        this.proportionLength = undefined;
        this._childrenWidth = undefined;
        this.resolveWidth(width, true);
    }
};
var $b878687860679a6f$export$2e2bcd8739ae039 = $b878687860679a6f$var$PostResolveSize;







const $85e96301acc043e5$var$Wrap = Phaser.Math.Wrap;
var $85e96301acc043e5$var$LayoutChildren = function() {
    var children = this.sizerChildren;
    var child, childConfig, padding;
    var startX = this.innerLeft, startY = this.innerTop;
    var innerWidth = this.innerWidth;
    var innerHeight = this.innerHeight;
    var itemX = startX, itemY = startY;
    var x, y, width, height; // Align zone
    var childWidth, childHeight;
    var childIndex, startChildIndex = this.startChildIndex;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        if (startChildIndex === 0) childIndex = i;
        else childIndex = $85e96301acc043e5$var$Wrap(i + startChildIndex, 0, cnt);
        if (this.rtl) childIndex = cnt - childIndex - 1;
        child = children[childIndex];
        if (child.rexSizer.hidden) continue;
        childConfig = child.rexSizer;
        padding = childConfig.padding;
        (0, $977b9616557db798$export$2e2bcd8739ae039).call(this, child);
        // Set size
        if (child.isRexSpace) {
            childWidth = 0;
            childHeight = 0;
        } else {
            childWidth = this.getExpandedChildWidth(child);
            childHeight = this.getExpandedChildHeight(child);
        }
        if (child.isRexSizer) {
            child.runLayout(this, childWidth, childHeight);
            (0, $3c9326963468a61e$export$2e2bcd8739ae039)(child, this);
        } else (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, childWidth, childHeight);
        if (childWidth === undefined) childWidth = (0, $3d5f5580139892aa$export$a60660135e2d0135)(child);
        if (childHeight === undefined) childHeight = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
        // Set position
        if (this.orientation === 0) {
            x = itemX + padding.left;
            if (childConfig.proportion === 0 || this.proportionLength === 0) width = childWidth;
            else width = childConfig.proportion * this.proportionLength;
            y = itemY + padding.top;
            height = innerHeight - padding.top - padding.bottom;
        } else {
            x = itemX + padding.left;
            width = innerWidth - padding.left - padding.right;
            y = itemY + padding.top;
            if (childConfig.proportion === 0 || this.proportionLength === 0) height = childHeight;
            else height = childConfig.proportion * this.proportionLength;
        }
        (0, $ba01042a1e30641f$export$2e2bcd8739ae039).call(this, child, x, y, width, height, childConfig.align);
        if (this.orientation === 0) itemX += width + padding.left + padding.right + this.space.item;
        else itemY += height + padding.top + padding.bottom + this.space.item;
    }
};
var $85e96301acc043e5$export$2e2bcd8739ae039 = $85e96301acc043e5$var$LayoutChildren;



var $9ecff7a97db34b4e$var$ResolveWidth = function(width) {
    var width = (0, $411cee766f03e513$export$2e2bcd8739ae039).call(this, width);
    // Calculate proportionLength
    if (this.proportionLength === undefined && this.orientation === 0) {
        var remainder = width - this.childrenWidth;
        if (remainder > 0) {
            remainder = width - this.getChildrenWidth(false);
            this.proportionLength = remainder / this.childrenProportion;
        } else {
            this.proportionLength = 0;
            remainder;
        }
    }
    return width;
};
var $9ecff7a97db34b4e$export$2e2bcd8739ae039 = $9ecff7a97db34b4e$var$ResolveWidth;



var $870268bdd0ce039d$var$ResolveHeight = function(height) {
    var height = (0, $da2b6b6b16a97213$export$2e2bcd8739ae039).call(this, height);
    // Get proportionLength
    if (this.proportionLength === undefined && this.orientation === 1) {
        var remainder = height - this.childrenHeight;
        if (remainder > 0) {
            remainder = height - this.getChildrenHeight(false);
            this.proportionLength = remainder / this.childrenProportion;
        } else {
            this.proportionLength = 0;
            remainder;
        }
    }
    return height;
};
var $870268bdd0ce039d$export$2e2bcd8739ae039 = $870268bdd0ce039d$var$ResolveHeight;





const $82ced9ca3c38b64a$var$Zone = Phaser.GameObjects.Zone;
class $82ced9ca3c38b64a$var$Space extends $82ced9ca3c38b64a$var$Zone {
    constructor(scene){
        super(scene, 0, 0, 1, 1);
        // Don't add Zone into scene
        this.isRexSpace = true;
    }
}
var $82ced9ca3c38b64a$export$2e2bcd8739ae039 = $82ced9ca3c38b64a$var$Space;



var $5d175390b61db315$var$GetNearestChildIndex = function(x, y) {
    var children = this.sizerChildren;
    if (children.length === 0) return -1;
    var nearestIndex = -1, minDistance = Infinity;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        var distance;
        if (this.orientation === 0) distance = Math.abs(child.left - x);
        else distance = Math.abs(child.top - y);
        if (minDistance > distance) {
            minDistance = distance;
            nearestIndex = i;
        }
    }
    // Check right bound of last child
    var child = children[children.length - 1];
    var distance;
    if (this.orientation === 0) distance = Math.abs(child.right - x);
    else distance = Math.abs(child.bottom - y);
    if (minDistance > distance) {
        minDistance = distance;
        nearestIndex = i + 1;
    }
    return nearestIndex;
};
var $5d175390b61db315$export$2e2bcd8739ae039 = $5d175390b61db315$var$GetNearestChildIndex;


const $0545eb70f9897c85$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $0545eb70f9897c85$var$GetValue = Phaser.Utils.Objects.GetValue;
const $0545eb70f9897c85$var$ALIGN_CENTER = Phaser.Display.Align.CENTER;
const $0545eb70f9897c85$var$PROPORTIONMODE = {
    min: 0,
    full: -1
};
var $0545eb70f9897c85$var$Add = function(gameObject, proportion, align, paddingConfig, expand, childKey, index, minWidth, minHeight, fitRatio) {
    (0, $6676609feda42dce$export$2e2bcd8739ae039).call(this, gameObject);
    var isRexSpace = gameObject.isRexSpace;
    var proportionType = typeof proportion;
    if (proportion === null) return this;
    else if (proportionType === "number") ;
    else if (proportionType === "string") proportion = $0545eb70f9897c85$var$PROPORTIONMODE[proportion];
    else if ($0545eb70f9897c85$var$IsPlainObject(proportion)) {
        var config = proportion;
        proportion = $0545eb70f9897c85$var$GetValue(config, "proportion", undefined);
        align = $0545eb70f9897c85$var$GetValue(config, "align", $0545eb70f9897c85$var$ALIGN_CENTER);
        paddingConfig = $0545eb70f9897c85$var$GetValue(config, "padding", 0);
        expand = $0545eb70f9897c85$var$GetValue(config, "expand", false);
        childKey = $0545eb70f9897c85$var$GetValue(config, "key", undefined);
        index = $0545eb70f9897c85$var$GetValue(config, "index", undefined);
        if (!gameObject.isRexSizer) {
            minWidth = $0545eb70f9897c85$var$GetValue(config, "minWidth", undefined);
            minHeight = $0545eb70f9897c85$var$GetValue(config, "minHeight", undefined);
        }
        fitRatio = $0545eb70f9897c85$var$GetValue(config, "fitRatio", 0); // width/height
    }
    if (typeof align === "string") align = (0, $519fe85d403be4ec$export$2e2bcd8739ae039)[align];
    if (proportion === undefined) proportion = isRexSpace ? 1 : 0;
    if (align === undefined) align = $0545eb70f9897c85$var$ALIGN_CENTER;
    if (paddingConfig === undefined) paddingConfig = 0;
    if (expand === undefined) expand = false;
    if (minWidth === undefined) {
        if (isRexSpace) minWidth = 0;
        else if (!gameObject.isRexSizer) minWidth = gameObject._minWidth;
    }
    if (minHeight === undefined) {
        if (isRexSpace) minHeight = 0;
        else if (!gameObject.isRexSizer) minHeight = gameObject._minHeight;
    }
    if (fitRatio === undefined) fitRatio = 0;
    var config = this.getSizerConfig(gameObject);
    config.proportion = proportion;
    config.align = align;
    config.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(paddingConfig);
    config.expand = expand;
    config.fitRatio = proportion === 0 ? fitRatio : 0;
    if (index === undefined || index >= this.sizerChildren.length) this.sizerChildren.push(gameObject);
    else this.sizerChildren.splice(index, 0, gameObject);
    if (!gameObject.isRexSizer) {
        if (proportion > 0) {
            if (this.orientation === 0) // minWidth is still undefined, uses current display width
            gameObject.minWidth = minWidth === undefined ? (0, $3d5f5580139892aa$export$a60660135e2d0135)(gameObject) : minWidth;
            else // minHeight is still undefined, uses current display height
            gameObject.minHeight = minHeight === undefined ? (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(gameObject) : minHeight;
        }
        if (expand) {
            if (this.orientation === 0) // Might have minHeight value, or still undefined
            gameObject.minHeight = minHeight;
            else // Might have minWidth value, or still undefined
            gameObject.minWidth = minWidth;
        }
    }
    if (childKey !== undefined) this.addChildrenMap(childKey, gameObject);
    return this;
};
var $0545eb70f9897c85$export$2e2bcd8739ae039 = {
    add: $0545eb70f9897c85$var$Add,
    addSpace (proportion) {
        this.insertSpace(undefined, proportion);
        return this;
    },
    insertSpace (index, proportion) {
        if (proportion === undefined) proportion = 1;
        $0545eb70f9897c85$var$Add.call(this, new (0, $82ced9ca3c38b64a$export$2e2bcd8739ae039)(this.scene), {
            proportion: proportion,
            minWidth: 0,
            minHeight: 0,
            index: index
        });
        // No problem if sizer.add is override
        return this;
    },
    insert (index, gameObject, proportion, align, paddingConfig, expand, childKey, minSize) {
        if ($0545eb70f9897c85$var$IsPlainObject(proportion)) proportion.index = index;
        $0545eb70f9897c85$var$Add.call(this, gameObject, proportion, align, paddingConfig, expand, childKey, index, minSize);
        // No problem if sizer.add is override
        return this;
    },
    insertAtPosition (x, y, gameObject, proportion, align, paddingConfig, expand, childKey, minSize) {
        var index = (0, $5d175390b61db315$export$2e2bcd8739ae039).call(this, x, y);
        if (index === -1) index = undefined;
        this.insert(index, gameObject, proportion, align, paddingConfig, expand, childKey, minSize);
        return this;
    }
};




const $5fd38c0f552653a9$var$RemoveItem = Phaser.Utils.Array.Remove;
var $5fd38c0f552653a9$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        if (this.getParentSizer(gameObject) !== this) return this;
        $5fd38c0f552653a9$var$RemoveItem(this.sizerChildren, gameObject);
        (0, $3af1c74b73a28a17$export$2e2bcd8739ae039).call(this, gameObject, destroyChild);
        return this;
    },
    removeAll (destroyChild) {
        for(var i = this.sizerChildren.length - 1; i >= 0; i--)this.remove(this.sizerChildren[i], destroyChild);
        return this;
    },
    clear (destroyChild) {
        this.sizerChildren.length = 0;
        (0, $6059775ef8ca5482$export$2e2bcd8739ae039).call(this, destroyChild);
        return this;
    }
};



var $e8c35c98138b8def$export$2e2bcd8739ae039 = {
    getChildAlign (gameObject) {
        return this.getSizerConfig(gameObject).align;
    },
    setChildAlign (gameObject, align) {
        if (typeof align === "string") align = (0, $519fe85d403be4ec$export$2e2bcd8739ae039)[align];
        this.getSizerConfig(gameObject).align = align;
        return this;
    }
};


var $63918e20731d2aa5$export$2e2bcd8739ae039 = {
    getChildProportion (gameObject) {
        return this.getSizerConfig(gameObject).proportion;
    },
    setChildProportion (gameObject, proportion) {
        this.getSizerConfig(gameObject).proportion = proportion;
        return this;
    }
};


var $732f68687a166e10$export$2e2bcd8739ae039 = {
    getChildExpand (gameObject) {
        return this.getSizerConfig(gameObject).expand;
    },
    setChildExpand (gameObject, expand) {
        this.getSizerConfig(gameObject).expand = expand;
        return this;
    }
};


var $98c9390c468f424b$var$methods = {
    getChildrenWidth: (0, $9a0687d72e923a3d$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $89504bd15e33433d$export$2e2bcd8739ae039),
    getExpandedChildWidth: (0, $a61dada0dbc5a34d$export$2e2bcd8739ae039),
    getExpandedChildHeight: (0, $977a867c8d820a80$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $b7090c3618268725$export$2e2bcd8739ae039),
    preLayout: (0, $8d4c51eeb234bdae$export$2e2bcd8739ae039),
    postResolveSize: (0, $b878687860679a6f$export$2e2bcd8739ae039),
    layoutChildren: (0, $85e96301acc043e5$export$2e2bcd8739ae039),
    resolveWidth: (0, $9ecff7a97db34b4e$export$2e2bcd8739ae039),
    resolveHeight: (0, $870268bdd0ce039d$export$2e2bcd8739ae039)
};
Object.assign($98c9390c468f424b$var$methods, (0, $0545eb70f9897c85$export$2e2bcd8739ae039), (0, $5fd38c0f552653a9$export$2e2bcd8739ae039), (0, $e8c35c98138b8def$export$2e2bcd8739ae039), (0, $63918e20731d2aa5$export$2e2bcd8739ae039), (0, $732f68687a166e10$export$2e2bcd8739ae039));
var $98c9390c468f424b$export$2e2bcd8739ae039 = $98c9390c468f424b$var$methods;


var $7aea8c11d146e657$var$GetChildrenProportion = function() {
    var result = 0;
    var children = this.sizerChildren;
    var child, proportion;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child.rexSizer.hidden) continue;
        proportion = child.rexSizer.proportion;
        if (proportion > 0) result += proportion;
    }
    return result;
};
var $7aea8c11d146e657$export$2e2bcd8739ae039 = $7aea8c11d146e657$var$GetChildrenProportion;


var $3c3f84ff9ee02f02$var$OrientationMode = {
    x: 0,
    h: 0,
    horizontal: 0,
    "left-to-right": 0,
    y: 1,
    v: 1,
    vertical: 1,
    "top-to-bottom": 1
};
var $3c3f84ff9ee02f02$var$GetOrientationMode = function(orientation) {
    if (typeof orientation === "string") orientation = $3c3f84ff9ee02f02$var$OrientationMode[orientation];
    return orientation;
};
var $3c3f84ff9ee02f02$export$2e2bcd8739ae039 = $3c3f84ff9ee02f02$var$GetOrientationMode;


const $51cc3ff23d0f8c1d$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $51cc3ff23d0f8c1d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $51cc3ff23d0f8c1d$var$Sizer extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, orientation, config){
        if ($51cc3ff23d0f8c1d$var$IsPlainObject(x)) {
            config = x;
            x = $51cc3ff23d0f8c1d$var$GetValue(config, "x", 0);
            y = $51cc3ff23d0f8c1d$var$GetValue(config, "y", 0);
            minWidth = $51cc3ff23d0f8c1d$var$GetValue(config, "width", undefined);
            minHeight = $51cc3ff23d0f8c1d$var$GetValue(config, "height", undefined);
            orientation = $51cc3ff23d0f8c1d$var$GetValue(config, "orientation", 0);
        } else if ($51cc3ff23d0f8c1d$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $51cc3ff23d0f8c1d$var$GetValue(config, "width", undefined);
            minHeight = $51cc3ff23d0f8c1d$var$GetValue(config, "height", undefined);
            orientation = $51cc3ff23d0f8c1d$var$GetValue(config, "orientation", 0);
        } else if ($51cc3ff23d0f8c1d$var$IsPlainObject(orientation)) {
            config = orientation;
            orientation = $51cc3ff23d0f8c1d$var$GetValue(config, "orientation", 0);
        }
        if (orientation === undefined) orientation = 0;
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexSizer";
        this.sizerChildren = [];
        this.setOrientation(orientation);
        this.setItemSpacing($51cc3ff23d0f8c1d$var$GetValue(config, "space.item", 0));
        this.setStartChildIndex($51cc3ff23d0f8c1d$var$GetValue(config, "startChildIndex", 0));
        this.setRTL($51cc3ff23d0f8c1d$var$GetValue(config, "rtl", false));
        this.addChildrenMap("items", this.sizerChildren);
    }
    setOrientation(orientation) {
        this.orientation = (0, $3c3f84ff9ee02f02$export$2e2bcd8739ae039)(orientation);
        return this;
    }
    setItemSpacing(space) {
        this.space.item = space;
        return this;
    }
    setStartChildIndex(index) {
        this.startChildIndex = index;
        return this;
    }
    setRTL(enable) {
        if (enable === undefined) enable = true;
        this.rtl = enable;
        return this;
    }
    get childrenProportion() {
        if (this._childrenProportion === undefined) this._childrenProportion = (0, $7aea8c11d146e657$export$2e2bcd8739ae039).call(this);
        return this._childrenProportion;
    }
}
Object.assign($51cc3ff23d0f8c1d$var$Sizer.prototype, (0, $98c9390c468f424b$export$2e2bcd8739ae039));
var $51cc3ff23d0f8c1d$export$2e2bcd8739ae039 = $51cc3ff23d0f8c1d$var$Sizer;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("sizer", function(x, y, minWidth, minHeight, orientation, config) {
    var gameObject = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(this.scene, x, y, minWidth, minHeight, orientation, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Sizer", (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039));
var $d17fb73515123ed9$export$2e2bcd8739ae039 = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039);



var $cccfac135a8a29fc$var$Sum = function() {
    return Array.prototype.reduce.call(arguments, $cccfac135a8a29fc$var$Add, 0);
};
var $cccfac135a8a29fc$var$Add = function(a, b) {
    return a + b;
};
var $cccfac135a8a29fc$export$2e2bcd8739ae039 = $cccfac135a8a29fc$var$Sum;


var $72a34271bac4abd5$var$GetChildrenWidth = function(minimumMode) {
    if (this.rexSizer.hidden) return 0;
    if (minimumMode === undefined) minimumMode = true;
    var result = 0, columnWidth;
    var children = this.sizerChildren;
    var child, padding, childWidth, proportion;
    for(var i = 0; i < this.columnCount; i++){
        proportion = this.columnProportions[i];
        columnWidth = 0;
        if (proportion === 0 || minimumMode) {
            for(var j = 0; j < this.rowCount; j++){
                child = children[j * this.columnCount + i];
                if (!child) continue;
                if (child.rexSizer.hidden) continue;
                padding = child.rexSizer.padding;
                childWidth = this.getChildWidth(child) + padding.left + padding.right;
                columnWidth = Math.max(columnWidth, childWidth);
            }
            result += columnWidth;
        }
        // else,(proportion > 0) : columnWidth is 0
        this.columnWidth[i] = columnWidth;
    }
    var space = this.space;
    var indentLeft = Math.max(space.indentLeftOdd, space.indentLeftEven);
    return result + (0, $cccfac135a8a29fc$export$2e2bcd8739ae039)(space.left, indentLeft, ...space.column, space.right);
};
var $72a34271bac4abd5$export$2e2bcd8739ae039 = $72a34271bac4abd5$var$GetChildrenWidth;




var $202a1b484e2fc750$var$GetChildrenHeight = function(minimumMode) {
    if (this.rexSizer.hidden) return 0;
    if (minimumMode === undefined) minimumMode = true;
    var result = 0, rowHeight;
    var children = this.sizerChildren;
    var child, padding, childHeight, proportion;
    for(var i = 0; i < this.rowCount; i++){
        proportion = this.rowProportions[i];
        rowHeight = 0;
        if (proportion === 0 || minimumMode) {
            for(var j = 0; j < this.columnCount; j++){
                child = children[i * this.columnCount + j];
                if (!child) continue;
                if (child.rexSizer.hidden) continue;
                childHeight = child.isRexSizer ? Math.max(child.minHeight, child.childrenHeight) : child.hasOwnProperty("minHeight") ? child.minHeight : (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
                padding = child.rexSizer.padding;
                childHeight += padding.top + padding.bottom;
                rowHeight = Math.max(rowHeight, childHeight);
            }
            result += rowHeight;
        }
        // else,(proportion > 0) : rowHeight is 0
        this.rowHeight[i] = rowHeight;
    }
    var space = this.space;
    var indentTop = Math.max(space.indentTopOdd, space.indentTopEven);
    return result + (0, $cccfac135a8a29fc$export$2e2bcd8739ae039)(space.top, indentTop, ...space.row, space.bottom);
};
var $202a1b484e2fc750$export$2e2bcd8739ae039 = $202a1b484e2fc750$var$GetChildrenHeight;


var $b51a5c2659130f96$var$GetExpandedChildWidth = function(child, colWidth) {
    var childWidth;
    var childConfig = child.rexSizer;
    if (childConfig.expand) {
        var padding = childConfig.padding;
        childWidth = colWidth - padding.left - padding.right;
    }
    return childWidth;
};
var $b51a5c2659130f96$export$2e2bcd8739ae039 = $b51a5c2659130f96$var$GetExpandedChildWidth;


var $94273a92bace0dad$var$GetExpandedChildHeight = function(child, rowHeight) {
    var childHeight;
    var childConfig = child.rexSizer;
    if (childConfig.expand) {
        var padding = childConfig.padding;
        childHeight = rowHeight - padding.top - padding.bottom;
    }
    return childHeight;
};
var $94273a92bace0dad$export$2e2bcd8739ae039 = $94273a92bace0dad$var$GetExpandedChildHeight;


var $d1f0596524b6daee$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    var children = this.sizerChildren, child;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child && child.isRexSizer) out.push(child);
    }
    return out;
};
var $d1f0596524b6daee$export$2e2bcd8739ae039 = $d1f0596524b6daee$var$GetChildrenSizers;



var $49553d29e2d18234$var$PreLayout = function() {
    this._totalColumnProportions = undefined;
    this._totalRowProportions = undefined;
    this.proportionWidthLength = undefined;
    this.proportionHeightLength = undefined;
    (0, $8777309d0690526c$export$2e2bcd8739ae039).call(this);
    return this;
};
var $49553d29e2d18234$export$2e2bcd8739ae039 = $49553d29e2d18234$var$PreLayout;






var $4767fd9e9d1c33cb$var$LayoutChildren = function() {
    var child, childConfig, padding;
    var startX = this.innerLeft, startY = this.innerTop;
    var itemX, itemY = startY;
    var x, y, width, height; // Align zone
    var childWidth, childHeight;
    // Layout grid children
    var columnSpace = this.space.column, rowSpace = this.space.row, indentLeftOdd = this.space.indentLeftOdd, indentLeftEven = this.space.indentLeftEven, indentTopOdd = this.space.indentTopOdd, indentTopEven = this.space.indentTopEven;
    var colWidth, rowHeight;
    var indentLeft, indentTop;
    for(var rowIndex = 0; rowIndex < this.rowCount; rowIndex++){
        rowHeight = this.getRowHeight(rowIndex);
        indentLeft = rowIndex % 2 ? indentLeftEven : indentLeftOdd;
        itemX = startX + indentLeft;
        for(var columnIndex = 0; columnIndex < this.columnCount; columnIndex++){
            colWidth = this.getColumnWidth(columnIndex);
            child = this.getChildAt(columnIndex, rowIndex);
            if (!child || child.rexSizer.hidden) {
                itemX += colWidth + columnSpace[columnIndex];
                continue;
            }
            (0, $977b9616557db798$export$2e2bcd8739ae039).call(this, child);
            childWidth = this.getExpandedChildWidth(child, colWidth);
            childHeight = this.getExpandedChildHeight(child, rowHeight);
            if (child.isRexSizer) {
                child.runLayout(this, childWidth, childHeight);
                (0, $3c9326963468a61e$export$2e2bcd8739ae039)(child, this);
            } else (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, childWidth, childHeight);
            childConfig = child.rexSizer;
            padding = childConfig.padding;
            x = itemX + padding.left;
            width = colWidth - padding.left - padding.right;
            indentTop = columnIndex % 2 ? indentTopEven : indentTopOdd;
            y = itemY + indentTop + padding.top;
            height = rowHeight - padding.top - padding.bottom;
            (0, $ba01042a1e30641f$export$2e2bcd8739ae039).call(this, child, x, y, width, height, childConfig.align);
            itemX += colWidth + columnSpace[columnIndex];
        }
        itemY += rowHeight + rowSpace[rowIndex];
    }
};
var $4767fd9e9d1c33cb$export$2e2bcd8739ae039 = $4767fd9e9d1c33cb$var$LayoutChildren;



var $d76700e6cb86a946$var$ResolveWidth = function(width) {
    var width = (0, $411cee766f03e513$export$2e2bcd8739ae039).call(this, width);
    // Get proportionLength
    if (this.proportionWidthLength === undefined) {
        var totalColumnProportions = this.totalColumnProportions;
        if (totalColumnProportions > 0) {
            var remainder = width - this.getChildrenWidth(false);
            if (remainder >= 0) this.proportionWidthLength = remainder / totalColumnProportions;
        } else this.proportionWidthLength = 0;
    }
    return width;
};
var $d76700e6cb86a946$export$2e2bcd8739ae039 = $d76700e6cb86a946$var$ResolveWidth;



var $44b71d589857798f$var$ResolveHeight = function(height) {
    var height = (0, $da2b6b6b16a97213$export$2e2bcd8739ae039).call(this, height);
    // Get proportionLength    
    if (this.proportionHeightLength === undefined) {
        var totalRowProportions = this.totalRowProportions;
        if (totalRowProportions > 0) {
            var remainder = height - this.getChildrenHeight(false);
            if (remainder >= 0) this.proportionHeightLength = remainder / totalRowProportions;
        } else this.proportionHeightLength = 0;
    }
    return height;
};
var $44b71d589857798f$export$2e2bcd8739ae039 = $44b71d589857798f$var$ResolveHeight;


var $f0de0c797781f7fc$var$ResolveChildrenWidth = function(parentWidth) {
    // Resolve width of sizer children
    var child, childWidth;
    var colWidth;
    for(var i in this.sizerChildren){
        child = this.sizerChildren[i];
        if (child && child.isRexSizer && !child.ignoreLayout) {
            colWidth = this.getColumnWidth(parseInt(i) % this.columnCount);
            childWidth = this.getExpandedChildWidth(child, colWidth);
            childWidth = child.resolveWidth(childWidth);
            child.resolveChildrenWidth(childWidth);
        }
    }
};
var $f0de0c797781f7fc$export$2e2bcd8739ae039 = $f0de0c797781f7fc$var$ResolveChildrenWidth;


// Default method
var $e09ba653a3210d53$var$RunWidthWrap = function(width) {
    var child, childWidth;
    var colWidth;
    for(var i in this.sizerChildren){
        child = this.sizerChildren[i];
        if (!child || child.isRexSizer && child.ignoreLayout || !child.runWidthWrap) continue;
        colWidth = this.getColumnWidth(parseInt(i) % this.columnCount);
        childWidth = this.getExpandedChildWidth(child, colWidth);
        if (child.isRexSizer) childWidth = child.resolveWidth(childWidth);
        child.runWidthWrap(childWidth);
    }
    return this;
};
var $e09ba653a3210d53$export$2e2bcd8739ae039 = $e09ba653a3210d53$var$RunWidthWrap;





const $fd51899ecd93f4f9$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $fd51899ecd93f4f9$var$GetValue = Phaser.Utils.Objects.GetValue;
const $fd51899ecd93f4f9$var$ALIGN_CENTER = Phaser.Display.Align.CENTER;
var $fd51899ecd93f4f9$var$GetEmptyCellIndex = function(columnIndex, rowIndex, cells, columnCount, rowCount) {
    if (typeof columnIndex === "number" || typeof rowIndex === "number") {
        if (columnIndex === undefined) {
            var idx;
            for(var i = 0; i < columnCount; i++){
                idx = rowIndex * columnCount + i;
                if (!cells[idx]) return idx;
            }
        } else if (rowIndex === undefined) {
            var idx;
            for(var i = 0; i < rowCount; i++){
                idx = i * columnCount + columnIndex;
                if (!cells[idx]) return idx;
            }
        } else {
            var idx = rowIndex * columnCount + columnIndex;
            if (!cells[idx]) return idx;
        }
    } else if (rowIndex === true) {
        var idx;
        for(var i = 0; i < columnCount; i++)for(var j = 0; j < rowCount; j++){
            idx = j * columnCount + i;
            if (!cells[idx]) return idx;
        }
    } else for(var i = 0, cnt = cells.length; i < cnt; i++){
        if (!cells[i]) return i;
    }
    return null;
};
var $fd51899ecd93f4f9$var$Add = function(gameObject, columnIndex, rowIndex, align, paddingConfig, expand, childKey) {
    (0, $6676609feda42dce$export$2e2bcd8739ae039).call(this, gameObject);
    if ($fd51899ecd93f4f9$var$IsPlainObject(columnIndex)) {
        var config = columnIndex;
        columnIndex = $fd51899ecd93f4f9$var$GetValue(config, "column", undefined);
        rowIndex = $fd51899ecd93f4f9$var$GetValue(config, "row", undefined);
        align = $fd51899ecd93f4f9$var$GetValue(config, "align", $fd51899ecd93f4f9$var$ALIGN_CENTER);
        paddingConfig = $fd51899ecd93f4f9$var$GetValue(config, "padding", 0);
        expand = $fd51899ecd93f4f9$var$GetValue(config, "expand", false);
        childKey = $fd51899ecd93f4f9$var$GetValue(config, "key", undefined);
    }
    // Get insert index
    var itemIndex = $fd51899ecd93f4f9$var$GetEmptyCellIndex(columnIndex, rowIndex, this.sizerChildren, this.columnCount, this.rowCount);
    if (itemIndex === null) {
        // Specific index mode
        if (typeof columnIndex === "number" && typeof rowIndex === "number") return this;
        if (rowIndex === true || typeof rowIndex === "number") this.addEmptyColumn();
        else this.addEmptyRow();
        // Get insert index again
        itemIndex = $fd51899ecd93f4f9$var$GetEmptyCellIndex(columnIndex, rowIndex, this.sizerChildren, this.columnCount, this.rowCount);
    }
    if (typeof align === "string") align = (0, $519fe85d403be4ec$export$2e2bcd8739ae039)[align];
    if (align === undefined) align = $fd51899ecd93f4f9$var$ALIGN_CENTER;
    if (paddingConfig === undefined) paddingConfig = 0;
    if (expand === undefined) expand = true;
    var config = this.getSizerConfig(gameObject);
    config.align = align;
    config.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(paddingConfig);
    config.expand = expand;
    this.sizerChildren[itemIndex] = gameObject;
    if (childKey !== undefined) this.addChildrenMap(childKey, gameObject);
    return this;
};
var $fd51899ecd93f4f9$export$2e2bcd8739ae039 = {
    add: $fd51899ecd93f4f9$var$Add
};




var $5d3e1a53770ae20d$var$Fill = function(arr, value, startIdx, endIdx) {
    if (startIdx === undefined) startIdx = 0;
    if (endIdx === undefined) endIdx = arr.length - 1;
    for(var i = startIdx; i <= endIdx; i++)arr[i] = value;
    return arr;
};
var $5d3e1a53770ae20d$export$2e2bcd8739ae039 = $5d3e1a53770ae20d$var$Fill;


var $9bf479d7710bcae6$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        if (this.getParentSizer(gameObject) !== this) return this;
        var idx = this.sizerChildren.indexOf(gameObject);
        if (idx !== -1) this.sizerChildren[idx] = null;
        (0, $3af1c74b73a28a17$export$2e2bcd8739ae039).call(this, gameObject, destroyChild);
        return this;
    },
    removeAt (columnIndex, rowIndex, destroyChild) {
        var child = this.getChildAt(columnIndex, rowIndex);
        if (child) this.remove(child, destroyChild);
        return this;
    },
    removeAll (destroyChild) {
        for(var i = this.sizerChildren.length - 1; i >= 0; i--){
            var child = this.sizerChildren[i];
            if (!child) continue;
            this.remove(child, destroyChild);
        }
        return this;
    },
    clear (destroyChild) {
        (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.sizerChildren, null);
        (0, $6059775ef8ca5482$export$2e2bcd8739ae039).call(this, destroyChild);
        return this;
    }
};



const $2424e0740210ee24$var$GetValue = Phaser.Utils.Objects.GetValue;
var $2424e0740210ee24$var$ResetGrid = function(columnCount, rowCount, columnProportions, rowProportions, space) {
    if (columnProportions === undefined) columnProportions = 0;
    if (rowProportions === undefined) rowProportions = 0;
    this.columnCount = columnCount;
    this.rowCount = rowCount;
    this.gridCount = columnCount * rowCount;
    // children
    if (this.sizerChildren === undefined) this.sizerChildren = [];
    else this.removeAll();
    this.sizerChildren.length = columnCount * rowCount;
    (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.sizerChildren, null);
    // proportions
    this.columnProportions = [];
    this.columnProportions.length = columnCount;
    if (typeof columnProportions === "number") (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.columnProportions, columnProportions);
    else for(var i = 0; i < columnCount; i++)this.columnProportions[i] = columnProportions[i] || 0;
    this.rowProportions = [];
    this.rowProportions.length = rowCount;
    if (typeof rowProportions === "number") (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.rowProportions, rowProportions);
    else for(var i = 0; i < rowCount; i++)this.rowProportions[i] = rowProportions[i] || 0;
    // width & height
    this.columnWidth = [];
    this.columnWidth.length = columnCount;
    this.rowHeight = [];
    this.rowHeight.length = rowCount;
    // space
    this.space.column = [];
    this.space.column.length = columnCount - 1;
    var columnSpace = $2424e0740210ee24$var$GetValue(space, "column", 0);
    if (typeof columnSpace === "number") (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.space.column, columnSpace);
    else for(var i = 0, cnt = this.space.column.length; i < cnt; i++)this.space.column[i] = columnSpace[i] || 0;
    this.space.row = [];
    this.space.row.length = rowCount - 1;
    var rowSpace = $2424e0740210ee24$var$GetValue(space, "row", 0);
    if (typeof rowSpace === "number") (0, $5d3e1a53770ae20d$export$2e2bcd8739ae039)(this.space.row, rowSpace);
    else for(var i = 0, cnt = this.space.row.length; i < cnt; i++)this.space.row[i] = rowSpace[i] || 0;
    return this;
};
var $2424e0740210ee24$export$2e2bcd8739ae039 = $2424e0740210ee24$var$ResetGrid;


var $b5a145ca18e9006e$export$1c5bbb13b1c63b97 = function(rowIndex, proportion, space) {
    if (proportion === undefined) proportion = this.rowProportions[0] || 0;
    if (space === undefined) space = this.space.row[0] || 0;
    this.rowCount += 1;
    this.gridCount += this.columnCount;
    var args = [
        rowIndex * this.columnCount,
        0
    ];
    for(var i = 0; i < this.columnCount; i++)args.push(null);
    this.sizerChildren.splice.apply(this.sizerChildren, args);
    this.rowProportions.push(proportion);
    this.rowHeight.length += 1; // this.rowHeight will be recalculated when layout()    
    this.space.row.splice(rowIndex, 0, space);
    return this;
};
var $b5a145ca18e9006e$export$5d141470e02bbe47 = function(proportion, space) {
    $b5a145ca18e9006e$export$1c5bbb13b1c63b97.call(this, this.rowCount, proportion, space);
    return this;
};


var $8e33592c79f8a5f7$export$dbb9c9e18619709c = function(colIndex, proportion, space) {
    if (proportion === undefined) proportion = this.columnProportions[0] || 0;
    if (space === undefined) space = this.space.column[0] || 0;
    this.columnCount += 1;
    this.gridCount += this.rowCount;
    for(var i = this.rowCount - 1; i >= 0; i--){
        var insertIndex = i * this.columnCount + colIndex;
        this.sizerChildren.splice(insertIndex, 0, null);
    }
    this.columnProportions.push(proportion);
    this.columnWidth.length += 1; // this.columnWidth will be recalculated when layout()    
    this.space.column.splice(colIndex, 0, space);
    return this;
};
var $8e33592c79f8a5f7$export$6738175f46002461 = function(proportion, space) {
    $8e33592c79f8a5f7$export$dbb9c9e18619709c.call(this, this.columnCount, proportion, space);
    return this;
};


var $e97abf9947e7eb1b$var$methods = {
    getChildrenWidth: (0, $72a34271bac4abd5$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $202a1b484e2fc750$export$2e2bcd8739ae039),
    getExpandedChildWidth: (0, $b51a5c2659130f96$export$2e2bcd8739ae039),
    getExpandedChildHeight: (0, $94273a92bace0dad$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $d1f0596524b6daee$export$2e2bcd8739ae039),
    preLayout: (0, $49553d29e2d18234$export$2e2bcd8739ae039),
    layoutChildren: (0, $4767fd9e9d1c33cb$export$2e2bcd8739ae039),
    resolveWidth: (0, $d76700e6cb86a946$export$2e2bcd8739ae039),
    resolveHeight: (0, $44b71d589857798f$export$2e2bcd8739ae039),
    resolveChildrenWidth: (0, $f0de0c797781f7fc$export$2e2bcd8739ae039),
    runWidthWrap: (0, $e09ba653a3210d53$export$2e2bcd8739ae039),
    resetGrid: (0, $2424e0740210ee24$export$2e2bcd8739ae039),
    inseryEmptyRow: (0, $b5a145ca18e9006e$export$1c5bbb13b1c63b97),
    addEmptyRow: (0, $b5a145ca18e9006e$export$5d141470e02bbe47),
    insertEmptyColumn: (0, $8e33592c79f8a5f7$export$dbb9c9e18619709c),
    addEmptyColumn: (0, $8e33592c79f8a5f7$export$6738175f46002461)
};
Object.assign($e97abf9947e7eb1b$var$methods, (0, $fd51899ecd93f4f9$export$2e2bcd8739ae039), (0, $9bf479d7710bcae6$export$2e2bcd8739ae039));
var $e97abf9947e7eb1b$export$2e2bcd8739ae039 = $e97abf9947e7eb1b$var$methods;


var $3d86870ad98c505c$var$GetTotalColumnProportions = function() {
    var result = 0, proportion;
    for(var i = 0; i < this.columnCount; i++){
        proportion = this.columnProportions[i];
        if (proportion > 0) result += proportion;
    }
    return result;
};
var $3d86870ad98c505c$export$2e2bcd8739ae039 = $3d86870ad98c505c$var$GetTotalColumnProportions;


var $023cb88fd1487f41$var$GetTotalRowProportions = function() {
    var result = 0, proportion;
    for(var i = 0; i < this.rowCount; i++){
        proportion = this.rowProportions[i];
        if (proportion > 0) result += proportion;
    }
    return result;
};
var $023cb88fd1487f41$export$2e2bcd8739ae039 = $023cb88fd1487f41$var$GetTotalRowProportions;


const $a949ee088f929daa$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $a949ee088f929daa$var$GetValue = Phaser.Utils.Objects.GetValue;
class $a949ee088f929daa$var$GridSizer extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, columnCount, rowCount, columnProportions, rowProportions, config){
        if ($a949ee088f929daa$var$IsPlainObject(x)) {
            config = x;
            x = $a949ee088f929daa$var$GetValue(config, "x", 0);
            y = $a949ee088f929daa$var$GetValue(config, "y", 0);
            minWidth = $a949ee088f929daa$var$GetValue(config, "width", undefined);
            minHeight = $a949ee088f929daa$var$GetValue(config, "height", undefined);
            columnCount = $a949ee088f929daa$var$GetValue(config, "column", config.col || 0);
            rowCount = $a949ee088f929daa$var$GetValue(config, "row", 0);
            columnProportions = $a949ee088f929daa$var$GetValue(config, "columnProportions", 0);
            rowProportions = $a949ee088f929daa$var$GetValue(config, "rowProportions", 0);
        } else if ($a949ee088f929daa$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $a949ee088f929daa$var$GetValue(config, "width", undefined);
            minHeight = $a949ee088f929daa$var$GetValue(config, "height", undefined);
            columnCount = $a949ee088f929daa$var$GetValue(config, "column", config.col || 0);
            rowCount = $a949ee088f929daa$var$GetValue(config, "row", 0);
            columnProportions = $a949ee088f929daa$var$GetValue(config, "columnProportions", 0);
            rowProportions = $a949ee088f929daa$var$GetValue(config, "rowProportions", 0);
        } else if ($a949ee088f929daa$var$IsPlainObject(columnCount)) {
            config = columnCount;
            columnCount = $a949ee088f929daa$var$GetValue(config, "column", config.col || 0);
            rowCount = $a949ee088f929daa$var$GetValue(config, "row", 0);
            columnProportions = $a949ee088f929daa$var$GetValue(config, "columnProportions", 0);
            rowProportions = $a949ee088f929daa$var$GetValue(config, "rowProportions", 0);
        } else if ($a949ee088f929daa$var$IsPlainObject(columnProportions)) {
            config = columnProportions;
            columnProportions = $a949ee088f929daa$var$GetValue(config, "columnProportions", 0);
            rowProportions = $a949ee088f929daa$var$GetValue(config, "rowProportions", 0);
        }
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexGridSizer";
        this.resetGrid(columnCount, rowCount, columnProportions, rowProportions, $a949ee088f929daa$var$GetValue(config, "space", undefined));
        this.setIndentLeft($a949ee088f929daa$var$GetValue(config, "space.indentLeftOdd", 0), $a949ee088f929daa$var$GetValue(config, "space.indentLeftEven", 0));
        this.setIndentTop($a949ee088f929daa$var$GetValue(config, "space.indentTopOdd", 0), $a949ee088f929daa$var$GetValue(config, "space.indentTopEven", 0));
        this.addChildrenMap("items", this.sizerChildren);
        var createCellContainerCallback = $a949ee088f929daa$var$GetValue(config, "createCellContainerCallback");
        if (createCellContainerCallback) {
            for(var y = 0, ycnt = this.rowCount; y < ycnt; y++)for(var x = 0, xcnt = this.columnCount; x < xcnt; x++){
                var addConfig = {
                    column: x,
                    row: y
                };
                var child = createCellContainerCallback(scene, x, y, addConfig);
                if (child) this.add(child, addConfig);
            }
        }
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        super.destroy(fromScene);
        // More free resources
        this.columnProportions = undefined;
        this.rowProportions = undefined;
        this.columnWidth = undefined;
        this.rowHeight = undefined;
    }
    setIndentLeft(odd, even) {
        this.space.indentLeftOdd = odd;
        this.space.indentLeftEven = even;
        return this;
    }
    setIndentTop(odd, even) {
        this.space.indentTopOdd = odd;
        this.space.indentTopEven = even;
        return this;
    }
    setColumnProportion(columnIndex, proportion) {
        if (columnIndex >= this.columnProportions.length) return this;
        this.columnProportions[columnIndex] = proportion;
        return this;
    }
    setRowProportion(rowIndex, proportion) {
        if (rowIndex >= this.rowProportions.length) return this;
        this.rowProportions[rowIndex] = proportion;
        return this;
    }
    get totalColumnProportions() {
        if (this._totalColumnProportions === undefined) this._totalColumnProportions = (0, $3d86870ad98c505c$export$2e2bcd8739ae039).call(this);
        return this._totalColumnProportions;
    }
    get totalRowProportions() {
        if (this._totalRowProportions === undefined) this._totalRowProportions = (0, $023cb88fd1487f41$export$2e2bcd8739ae039).call(this);
        return this._totalRowProportions;
    }
    getChildAt(columnIndex, rowIndex) {
        return this.sizerChildren[rowIndex * this.columnCount + columnIndex];
    }
    childToGridIndex(child, out) {
        if (!child) return null;
        var index = this.sizerChildren.indexOf(child);
        if (index === -1) return null;
        if (out === undefined) out = {};
        out.x = index % this.columnCount;
        out.y = Math.floor(index / this.columnCount);
        return out;
    }
    getColumnWidth(columnIndex) {
        var colProportion = this.columnProportions[columnIndex];
        var colWidth = colProportion === 0 ? this.columnWidth[columnIndex] : colProportion * this.proportionWidthLength;
        return colWidth;
    }
    getRowHeight(rowIndex) {
        var rowProportion = this.rowProportions[rowIndex];
        var rowHeight = rowProportion === 0 ? this.rowHeight[rowIndex] : rowProportion * this.proportionHeightLength;
        return rowHeight;
    }
}
Object.assign($a949ee088f929daa$var$GridSizer.prototype, (0, $e97abf9947e7eb1b$export$2e2bcd8739ae039));
var $a949ee088f929daa$export$2e2bcd8739ae039 = $a949ee088f929daa$var$GridSizer;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("gridSizer", function(x, y, minWidth, minHeight, columnCount, rowCount, columnProportions, rowProportion, config) {
    var gameObject = new (0, $a949ee088f929daa$export$2e2bcd8739ae039)(this.scene, x, y, minWidth, minHeight, columnCount, rowCount, columnProportions, rowProportion, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.GridSizer", (0, $a949ee088f929daa$export$2e2bcd8739ae039));
var $92bc61f1133c78e6$export$2e2bcd8739ae039 = (0, $a949ee088f929daa$export$2e2bcd8739ae039);



var $77a3ef5b9ab624c7$var$GetChildrenWidth = function() {
    if (this.rexSizer.hidden) return 0;
    // Before RunChildrenWrap
    return this.maxChildWidth + this.space.left + this.space.right;
};
var $77a3ef5b9ab624c7$export$2e2bcd8739ae039 = $77a3ef5b9ab624c7$var$GetChildrenWidth;


var $c956a3100c30c4ee$var$GetChildrenHeight = function() {
    if (this.rexSizer.hidden) return 0;
    // After RunChildrenWrap
    return this.widthWrapResult.height + this.space.top + this.space.bottom;
};
var $c956a3100c30c4ee$export$2e2bcd8739ae039 = $c956a3100c30c4ee$var$GetChildrenHeight;


var $c3ae7fbdf544f1e0$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    var children = this.sizerChildren, child;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child === "\n") continue;
        if (child.isRexSizer) out.push(child);
    }
    return out;
};
var $c3ae7fbdf544f1e0$export$2e2bcd8739ae039 = $c3ae7fbdf544f1e0$var$GetChildrenSizers;



var $5e26ee653dddb1e2$var$PreLayout = function() {
    this._maxChildWidth = undefined;
    this._maxChildHeight = undefined;
    (0, $8777309d0690526c$export$2e2bcd8739ae039).call(this);
    return this;
};
var $5e26ee653dddb1e2$export$2e2bcd8739ae039 = $5e26ee653dddb1e2$var$PreLayout;





var $ee69f9365f0fe546$var$LayoutChildren = function() {
    var innerLineWidth = this.innerWidth;
    var justifyPercentage = this.justifyPercentage;
    var itemSpace = this.space.item, lineSpace = this.space.line, indentLeftOdd = this.space.indentLeftOdd, indentLeftEven = this.space.indentLeftEven, indentTopOdd = this.space.indentTopOdd, indentTopEven = this.space.indentTopEven;
    var child, childConfig, padding, justifySpace = 0, indentLeft, indentTop;
    var startX = this.innerLeft, startY = this.innerTop;
    var x, y, width, height; // Align zone
    var lines = this.widthWrapResult.lines;
    var line, lineChlidren, remainderLineWidth;
    var itemX, itemY = startY;
    for(var i = 0, icnt = lines.length; i < icnt; i++){
        // Layout this line
        line = lines[i];
        lineChlidren = line.children;
        if (this.rtl) lineChlidren.reverse();
        indentLeft = i % 2 ? indentLeftEven : indentLeftOdd;
        itemX = startX + indentLeft;
        remainderLineWidth = innerLineWidth - line.width;
        switch(this.align){
            case 0:
                break;
            case 1:
                itemX += remainderLineWidth;
                break;
            case 2:
                itemX += remainderLineWidth / 2;
                break;
            case 3:
                justifySpace = $ee69f9365f0fe546$var$GetJustifySpace(innerLineWidth, remainderLineWidth, justifyPercentage, lineChlidren.length);
                break;
            case 4:
                justifySpace = $ee69f9365f0fe546$var$GetJustifySpace(innerLineWidth, remainderLineWidth, justifyPercentage, lineChlidren.length);
                if (justifySpace === 0) // Align right
                itemX += remainderLineWidth;
                break;
            case 5:
                justifySpace = $ee69f9365f0fe546$var$GetJustifySpace(innerLineWidth, remainderLineWidth, justifyPercentage, lineChlidren.length);
                if (justifySpace === 0) // Align center
                itemX += remainderLineWidth / 2;
                break;
        }
        var isFirstChild = true;
        for(var j = 0, jcnt = lineChlidren.length; j < jcnt; j++){
            child = lineChlidren[j];
            if (child.rexSizer.hidden) continue;
            childConfig = child.rexSizer;
            padding = childConfig.padding;
            (0, $977b9616557db798$export$2e2bcd8739ae039).call(this, child);
            x = itemX + padding.left;
            if (isFirstChild) isFirstChild = false;
            else x += itemSpace;
            indentTop = j % 2 ? indentTopEven : indentTopOdd;
            y = itemY + indentTop + padding.top;
            width = (0, $3d5f5580139892aa$export$a60660135e2d0135)(child);
            height = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
            itemX = x + width + padding.right + justifySpace;
            (0, $ba01042a1e30641f$export$2e2bcd8739ae039).call(this, child, x, y, width, height, childConfig.align);
        }
        itemY += line.height + lineSpace;
    }
};
var $ee69f9365f0fe546$var$GetJustifySpace = function(total, remainder, justifyPercentage, childCount) {
    return remainder / total <= justifyPercentage ? remainder / (childCount - 1) : 0;
};
var $ee69f9365f0fe546$export$2e2bcd8739ae039 = $ee69f9365f0fe546$var$LayoutChildren;




var $415edf46685830f8$var$RunChildrenWrap = function(lineWidth, out) {
    if (out === undefined) out = {
        lines: [],
        width: 0,
        height: 0
    };
    else {
        out.lines.length = 0;
        out.width = 0;
        out.height = 0;
    }
    var children = this.sizerChildren;
    var itemSpace = this.space.item, lineSpace = this.space.line, indentLeftOdd = this.space.indentLeftOdd, indentLeftEven = this.space.indentLeftEven, indentTopOdd = this.space.indentTopOdd, indentTopEven = this.space.indentTopEven;
    var child, childWidth, childHeight, remainder = 0, indentLeft;
    var lines = out.lines, lastLine = undefined, newLine;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child === "\n") {
            child = undefined;
            childWidth = 0;
            newLine = true;
        } else {
            if (child.rexSizer.hidden) continue;
            if (child.isRexSizer) child.layout(); // Use original size
            childWidth = $415edf46685830f8$var$GetChildWidth(child);
            newLine = remainder < childWidth || lastLine === undefined;
        }
        // New line
        if (newLine) {
            if (lastLine) {
                lastLine.width = lineWidth - (remainder + itemSpace);
                out.width = Math.max(out.width, lastLine.width);
                out.height += lastLine.height + lineSpace;
            }
            lastLine = {
                children: [],
                // width: 0,
                height: 0
            };
            lines.push(lastLine);
            var indentLeft = lines.length % 2 ? indentLeftOdd : indentLeftEven;
            remainder = lineWidth - indentLeft;
        }
        remainder -= childWidth + itemSpace;
        if (child) {
            lastLine.children.push(child);
            childHeight = $415edf46685830f8$var$GeChildHeight(child);
            lastLine.height = Math.max(lastLine.height, childHeight);
        }
    }
    if (lastLine) {
        lastLine.width = lineWidth - (remainder + itemSpace);
        out.width = Math.max(out.width, lastLine.width);
        out.height += lastLine.height;
    }
    out.height += Math.max(indentTopOdd, indentTopEven);
    return out;
};
var $415edf46685830f8$var$GetChildWidth = function(child) {
    var padding = child.rexSizer.padding;
    return (0, $3d5f5580139892aa$export$a60660135e2d0135)(child) + padding.left + padding.right;
};
var $415edf46685830f8$var$GeChildHeight = function(child) {
    var padding = child.rexSizer.padding;
    return (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child) + padding.top + padding.bottom;
};
var $415edf46685830f8$export$2e2bcd8739ae039 = $415edf46685830f8$var$RunChildrenWrap;


var $67a0342e7f43bc2c$var$RunWidthWrap = function(width) {
    var innerWidth = width - this.space.left - this.space.right;
    this.widthWrapResult = (0, $415edf46685830f8$export$2e2bcd8739ae039).call(this, innerWidth, this.widthWrapResult);
    (0, $10fc52975e1b187e$export$2e2bcd8739ae039).call(this, width);
};
var $67a0342e7f43bc2c$export$2e2bcd8739ae039 = $67a0342e7f43bc2c$var$RunWidthWrap;





const $e52204f4585d8622$var$DistanceBetween = Phaser.Math.Distance.Between;
var $e52204f4585d8622$var$GetNearestChildIndex = function(x, y) {
    var children = this.sizerChildren;
    if (children.length === 0) return -1;
    var nearestIndex = -1, minDistance = Infinity;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        // position is not at this line
        if (Math.abs(child.centerY - y) > child.height / 2) continue;
        // Check left bound
        var distance = $e52204f4585d8622$var$DistanceBetween(child.left, child.centerY, x, y);
        if (minDistance > distance) {
            minDistance = distance;
            nearestIndex = i;
        }
        // Is last child of this line
        var nextChild = children[i + 1];
        if (nextChild && nextChild.y === child.y) continue;
        var distance = $e52204f4585d8622$var$DistanceBetween(child.right, child.centerY, x, y);
        if (minDistance > distance) {
            minDistance = distance;
            nearestIndex = i + 1;
        }
    }
    return nearestIndex;
};
var $e52204f4585d8622$export$2e2bcd8739ae039 = $e52204f4585d8622$var$GetNearestChildIndex;


const $2ecb9db13c8a373a$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $2ecb9db13c8a373a$var$GetValue = Phaser.Utils.Objects.GetValue;
const $2ecb9db13c8a373a$var$ALIGN_CENTER = Phaser.Display.Align.CENTER;
var $2ecb9db13c8a373a$var$Add = function(gameObject, paddingConfig, childKey, index) {
    if (gameObject === "\n") {
        this.addNewLine();
        return this;
    }
    (0, $6676609feda42dce$export$2e2bcd8739ae039).call(this, gameObject);
    if ($2ecb9db13c8a373a$var$IsPlainObject(paddingConfig)) {
        var config = paddingConfig;
        paddingConfig = $2ecb9db13c8a373a$var$GetValue(config, "padding", 0);
        childKey = $2ecb9db13c8a373a$var$GetValue(config, "key", undefined);
        index = $2ecb9db13c8a373a$var$GetValue(config, "index", undefined);
    }
    if (paddingConfig === undefined) paddingConfig = 0;
    var config = this.getSizerConfig(gameObject);
    config.align = $2ecb9db13c8a373a$var$ALIGN_CENTER;
    config.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(paddingConfig);
    if (index === undefined || index >= this.sizerChildren.length) this.sizerChildren.push(gameObject);
    else this.sizerChildren.splice(index, 0, gameObject);
    if (childKey !== undefined) this.addChildrenMap(childKey, gameObject);
    return this;
};
var $2ecb9db13c8a373a$export$2e2bcd8739ae039 = {
    add (gameObject, paddingConfig, childKey) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$2ecb9db13c8a373a$var$Add.call(this, gameObjects[i], paddingConfig);
        } else $2ecb9db13c8a373a$var$Add.call(this, gameObject, paddingConfig, childKey);
        return this;
    },
    addNewLine () {
        this.sizerChildren.push("\n");
        return this;
    },
    insert (index, gameObject, paddingConfig, childKey) {
        $2ecb9db13c8a373a$var$Add.call(this, gameObject, paddingConfig, childKey, index);
        return this;
    },
    insertAtPosition (x, y, gameObject, paddingConfig, childKey) {
        var index = (0, $e52204f4585d8622$export$2e2bcd8739ae039).call(this, x, y);
        if (index === -1) index = undefined;
        this.insert(index, gameObject, paddingConfig, childKey);
        return this;
    }
};




const $052e94b52c9d4d39$var$RemoveItem = Phaser.Utils.Array.Remove;
var $052e94b52c9d4d39$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        if (this.getParentSizer(gameObject) !== this) return this;
        $052e94b52c9d4d39$var$RemoveItem(this.sizerChildren, gameObject);
        (0, $3af1c74b73a28a17$export$2e2bcd8739ae039).call(this, gameObject, destroyChild);
        return this;
    },
    removeAll (destroyChild) {
        for(var i = this.sizerChildren.length - 1; i >= 0; i--)this.remove(this.sizerChildren[i], destroyChild);
        return this;
    },
    clear (destroyChild) {
        this.sizerChildren.length = 0;
        (0, $6059775ef8ca5482$export$2e2bcd8739ae039).call(this, destroyChild);
        return this;
    }
};


var $9d5ba927f1b89d4e$var$methods = {
    getChildrenWidth: (0, $77a3ef5b9ab624c7$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $c956a3100c30c4ee$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $c3ae7fbdf544f1e0$export$2e2bcd8739ae039),
    preLayout: (0, $5e26ee653dddb1e2$export$2e2bcd8739ae039),
    layoutChildren: (0, $ee69f9365f0fe546$export$2e2bcd8739ae039),
    runWidthWrap: (0, $67a0342e7f43bc2c$export$2e2bcd8739ae039)
};
Object.assign($9d5ba927f1b89d4e$var$methods, (0, $2ecb9db13c8a373a$export$2e2bcd8739ae039), (0, $052e94b52c9d4d39$export$2e2bcd8739ae039));
var $9d5ba927f1b89d4e$export$2e2bcd8739ae039 = $9d5ba927f1b89d4e$var$methods;



var $5337503edfea9eef$var$GetMaxChildWidth = function(children) {
    if (children === undefined) children = this.sizerChildren;
    var result = 0;
    var child, childWidth;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child === "\n") continue;
        childWidth = this.getChildWidth(child);
        result = Math.max(childWidth, result);
    }
    return result;
};
var $5337503edfea9eef$export$2e2bcd8739ae039 = $5337503edfea9eef$var$GetMaxChildWidth;



var $3f0b8b1b64ba4fe7$var$GetMaxChildHeight = function(children) {
    if (children === undefined) children = this.sizerChildren;
    var result = 0;
    var child, childHeight;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        child = children[i];
        if (child === "\n") continue;
        childHeight = child.isRexSizer ? Math.max(child.minHeight, child.childrenHeight) : child.hasOwnProperty("minHeight") ? child.minHeight : (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
        result = Math.max(childHeight, result);
    }
    return result;
};
var $3f0b8b1b64ba4fe7$export$2e2bcd8739ae039 = $3f0b8b1b64ba4fe7$var$GetMaxChildHeight;


const $92d11076da36f893$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $92d11076da36f893$var$GetValue = Phaser.Utils.Objects.GetValue;
class $92d11076da36f893$var$FixWidthSizer extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, config){
        if ($92d11076da36f893$var$IsPlainObject(x)) {
            config = x;
            x = $92d11076da36f893$var$GetValue(config, "x", 0);
            y = $92d11076da36f893$var$GetValue(config, "y", 0);
            minWidth = $92d11076da36f893$var$GetValue(config, "width", undefined);
            minHeight = $92d11076da36f893$var$GetValue(config, "height", undefined);
        } else if ($92d11076da36f893$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $92d11076da36f893$var$GetValue(config, "width", undefined);
            minHeight = $92d11076da36f893$var$GetValue(config, "height", undefined);
        }
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexFixWidthSizer";
        this.sizerChildren = [];
        this.setOrientation($92d11076da36f893$var$GetValue(config, "orientation", 0));
        this.setItemSpacing($92d11076da36f893$var$GetValue(config, "space.item", 0));
        this.setLineSpacing($92d11076da36f893$var$GetValue(config, "space.line", 0));
        this.setIntentLeft($92d11076da36f893$var$GetValue(config, "space.indentLeftOdd", 0), $92d11076da36f893$var$GetValue(config, "space.indentLeftEven", 0));
        this.setIntentTop($92d11076da36f893$var$GetValue(config, "space.indentTopOdd", 0), $92d11076da36f893$var$GetValue(config, "space.indentTopEven", 0));
        this.setAlign($92d11076da36f893$var$GetValue(config, "align", 0));
        this.setJustifyPercentage($92d11076da36f893$var$GetValue(config, "justifyPercentage", 0.25));
        this.setRTL($92d11076da36f893$var$GetValue(config, "rtl", false));
        this.addChildrenMap("items", this.sizerChildren);
    }
    setOrientation(orientation) {
        this.orientation = (0, $3c3f84ff9ee02f02$export$2e2bcd8739ae039)(orientation);
        return this;
    }
    setItemSpacing(space) {
        this.space.item = space;
        return this;
    }
    setLineSpacing(space) {
        this.space.line = space;
        return this;
    }
    setIntentLeft(odd, even) {
        this.space.indentLeftOdd = odd;
        this.space.indentLeftEven = even;
        return this;
    }
    setIntentTop(odd, even) {
        this.space.indentTopOdd = odd;
        this.space.indentTopEven = even;
        return this;
    }
    setAlign(align) {
        if (typeof align === "string") align = $92d11076da36f893$var$ALIGN[align];
        this.align = align;
        return this;
    }
    setJustifyPercentage(value) {
        this.justifyPercentage = value;
        return this;
    }
    setRTL(enabled) {
        if (enabled === undefined) enabled = true;
        this.rtl = enabled;
        return this;
    }
    get maxChildWidth() {
        if (this._maxChildWidth === undefined) this._maxChildWidth = (0, $5337503edfea9eef$export$2e2bcd8739ae039).call(this);
        return this._maxChildWidth;
    }
    get maxChildHeight() {
        if (this._maxChildHeight === undefined) this._maxChildHeight = (0, $3f0b8b1b64ba4fe7$export$2e2bcd8739ae039).call(this);
        return this._maxChildHeight;
    }
}
const $92d11076da36f893$var$ALIGN = {
    left: 0,
    top: 0,
    right: 1,
    bottom: 1,
    center: 2,
    justify: 3,
    "justify-left": 3,
    "justify-top": 3,
    "justify-right": 4,
    "justify-bottom": 4,
    "justify-center": 5
};
Object.assign($92d11076da36f893$var$FixWidthSizer.prototype, (0, $9d5ba927f1b89d4e$export$2e2bcd8739ae039));
var $92d11076da36f893$export$2e2bcd8739ae039 = $92d11076da36f893$var$FixWidthSizer;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fixWidthSizer", function(x, y, minWidth, minHeight, config) {
    var gameObject = new (0, $92d11076da36f893$export$2e2bcd8739ae039)(this.scene, x, y, minWidth, minHeight, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FixWidthSizer", (0, $92d11076da36f893$export$2e2bcd8739ae039));
var $b20b0c026221a700$export$2e2bcd8739ae039 = (0, $92d11076da36f893$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("overlapSizer", function(x, y, minWidth, minHeight, config) {
    var gameObject = new (0, $4d318a74c42de65b$export$2e2bcd8739ae039)(this.scene, x, y, minWidth, minHeight, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.OverlapSizer", (0, $4d318a74c42de65b$export$2e2bcd8739ae039));
var $daed09d028ee575a$export$2e2bcd8739ae039 = (0, $4d318a74c42de65b$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("space", function() {
    var gameObject = new (0, $82ced9ca3c38b64a$export$2e2bcd8739ae039)(this.scene);
    // Don't add Zone into scene
    // this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Space", (0, $82ced9ca3c38b64a$export$2e2bcd8739ae039));
var $fadb9e352df9a391$export$2e2bcd8739ae039 = (0, $82ced9ca3c38b64a$export$2e2bcd8739ae039);




var $e5744fe8de8c4d74$var$SetDisplaySize = function(gameObject, width, height) {
    if (!gameObject) return;
    var unknownWidth = width == null;
    var unknownHeight = height == null;
    if (unknownWidth && unknownHeight) return gameObject;
    if (!unknownWidth) gameObject.displayWidth = width;
    if (!unknownHeight) gameObject.displayHeight = height;
    if (unknownWidth) gameObject.scaleX = gameObject.scaleY;
    if (unknownHeight) gameObject.scaleY = gameObject.scaleX;
    return gameObject;
};
var $e5744fe8de8c4d74$export$2e2bcd8739ae039 = $e5744fe8de8c4d74$var$SetDisplaySize;


var $e6b514fd35115483$var$ResetDisplayContent = function(config) {
    if (config === undefined) config = {};
    else if (typeof config === "string") config = {
        text: config
    };
    var text = config.text || "";
    this.setText(text);
    var iconGameObjct = this.childrenMap.icon;
    if (iconGameObjct) {
        if (config.icon === undefined) this.hide(iconGameObjct);
        else this.show(iconGameObjct);
        var iconSize = config.iconSize;
        if (iconSize) {
            this.setChildDisplaySize(iconGameObjct, iconSize, iconSize);
            if (this.iconWidth !== undefined) this.setIconSize(iconSize);
        }
        this.setIconTexture(config.icon, config.iconFrame);
    }
    var actionGameObjct = this.childrenMap.action;
    if (actionGameObjct) {
        if (config.action === undefined) this.hide(actionGameObjct);
        else this.show(actionGameObjct);
        var actionSize = config.actionSize;
        if (actionSize) {
            this.setChildDisplaySize(actionGameObjct, actionSize, actionSize);
            if (this.actionWidth !== undefined) this.setActionSize(actionSize);
        }
        this.setActionTexture(config.action, config.actionFrame);
    }
    return this;
};
var $e6b514fd35115483$export$2e2bcd8739ae039 = $e6b514fd35115483$var$ResetDisplayContent;


var $fe363030058ced45$var$methods = {
    resetDisplayContent: (0, $e6b514fd35115483$export$2e2bcd8739ae039)
};
var $fe363030058ced45$export$2e2bcd8739ae039 = $fe363030058ced45$var$methods;


const $2ae0d347a90f71ca$var$GetValue = Phaser.Utils.Objects.GetValue;
class $2ae0d347a90f71ca$var$Label extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexLabel";
        // Add elements
        var background = $2ae0d347a90f71ca$var$GetValue(config, "background", undefined);
        var icon = $2ae0d347a90f71ca$var$GetValue(config, "icon", undefined);
        var iconMask = $2ae0d347a90f71ca$var$GetValue(config, "iconMask", undefined);
        var text = $2ae0d347a90f71ca$var$GetValue(config, "text", undefined);
        var action = $2ae0d347a90f71ca$var$GetValue(config, "action", undefined);
        var actionMask = $2ae0d347a90f71ca$var$GetValue(config, "actionMask", undefined);
        // Align
        var align = $2ae0d347a90f71ca$var$GetValue(config, "align", undefined); // undefined/left/top: no space
        if (background) this.addBackground(background);
        // Add space
        if (align === "right" || align === "bottom" || align === "center") this.addSpace();
        if (icon) {
            var iconSpace = $2ae0d347a90f71ca$var$GetValue(config, "space.icon", 0);
            var padding;
            if (this.orientation === 0) {
                if (text || action) padding = {
                    right: iconSpace
                };
            } else if (text || action) padding = {
                bottom: iconSpace
            };
            var fitRatio = $2ae0d347a90f71ca$var$GetValue(config, "squareFitIcon", false) ? 1 : 0;
            this.add(icon, {
                proportion: 0,
                padding: padding,
                fitRatio: fitRatio
            });
            if (iconMask) iconMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, icon, icon, 1); // Circle mask
            if (!fitRatio) {
                var iconSize = $2ae0d347a90f71ca$var$GetValue(config, "iconSize", undefined);
                this.setIconSize($2ae0d347a90f71ca$var$GetValue(config, "iconWidth", iconSize), $2ae0d347a90f71ca$var$GetValue(config, "iconHeight", iconSize));
            }
        }
        if (text) {
            var textSpace = $2ae0d347a90f71ca$var$GetValue(config, "space.text", 0);
            var expandTextWidth = $2ae0d347a90f71ca$var$GetValue(config, "expandTextWidth", false);
            var expandTextHeight = $2ae0d347a90f71ca$var$GetValue(config, "expandTextHeight", false);
            var proportion, padding, expand;
            if (this.orientation === 0) {
                proportion = expandTextWidth ? 1 : 0;
                if (action) padding = {
                    right: textSpace
                };
                expand = expandTextHeight;
            } else {
                proportion = expandTextHeight ? 1 : 0;
                if (action) padding = {
                    bottom: textSpace
                };
                expand = expandTextWidth;
            }
            this.add(text, {
                proportion: proportion,
                expand: expand,
                padding: padding
            });
        }
        if (action) {
            var fitRatio = $2ae0d347a90f71ca$var$GetValue(config, "squareFitAction", false) ? 1 : 0;
            this.add(action, {
                proportion: 0,
                fitRatio: fitRatio
            });
            if (actionMask) actionMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, action, action, 1); // Circle mask
            if (!fitRatio) {
                var actionSize = $2ae0d347a90f71ca$var$GetValue(config, "actionSize");
                this.setActionSize($2ae0d347a90f71ca$var$GetValue(config, "actionWidth", actionSize), $2ae0d347a90f71ca$var$GetValue(config, "actionHeight", actionSize));
            }
        }
        // Add space
        if (align === "center") this.addSpace();
        this.addChildrenMap("background", background);
        this.addChildrenMap("icon", icon);
        this.addChildrenMap("iconMask", iconMask);
        this.addChildrenMap("text", text);
        this.addChildrenMap("action", action);
        this.addChildrenMap("actionMask", actionMask);
    }
    // Access text game object
    get text() {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return "";
        return textObject.text;
    }
    set text(value) {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return;
        textObject.setText(value);
    }
    setText(value) {
        this.text = value;
        return this;
    }
    appendText(value) {
        this.text += value;
        return this;
    }
    // Access icon game object
    setIconTexture(key, frame) {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return this;
        imageObject.setTexture(key, frame);
        if (this.iconWidth !== undefined) {
            (0, $e5744fe8de8c4d74$export$2e2bcd8739ae039)(imageObject, this.iconWidth, this.iconHeight);
            this.resetChildScaleState(imageObject);
        }
        return this;
    }
    setTexture(key, frame) {
        this.setIconTexture(key, frame);
        return this;
    }
    setIconSize(width, height) {
        if (height === undefined) height = width;
        this.iconWidth = width;
        this.iconHeight = height;
        return this;
    }
    get texture() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.texture;
    }
    get frame() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.frame;
    }
    setActionTexture(key, frame) {
        var imageObject = this.childrenMap.action;
        if (imageObject === undefined) return this;
        imageObject.setTexture(key, frame);
        if (this.actionWidth !== undefined) {
            (0, $e5744fe8de8c4d74$export$2e2bcd8739ae039)(imageObject, this.actionWidth, this.actionHeight);
            this.resetChildScaleState(imageObject);
        }
        return this;
    }
    get actionTexture() {
        var imageObject = this.childrenMap.action;
        if (imageObject === undefined) return undefined;
        return imageObject.texture;
    }
    get actionFrame() {
        var imageObject = this.childrenMap.action;
        if (imageObject === undefined) return undefined;
        return imageObject.frame;
    }
    setActionSize(width, height) {
        if (height === undefined) height = width;
        this.actionWidth = width;
        this.actionHeight = height;
        return this;
    }
    preLayout() {
        var icon = this.childrenMap.icon;
        if (icon && this.iconWidth !== undefined) (0, $e5744fe8de8c4d74$export$2e2bcd8739ae039)(icon, this.iconWidth, this.iconHeight);
        var action = this.childrenMap.action;
        if (action && this.actionWidth !== undefined) (0, $e5744fe8de8c4d74$export$2e2bcd8739ae039)(action, this.actionWidth, this.actionHeight);
        super.preLayout();
    }
    runLayout(parent, newWidth, newHeight) {
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        // Pin icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) {
            iconMask.setPosition();
            this.resetChildPositionState(iconMask);
        }
        // Pin action-mask to action game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) {
            actionMask.setPosition();
            this.resetChildPositionState(actionMask);
        }
        return this;
    }
    resize(width, height) {
        super.resize(width, height);
        // Resize icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) iconMask.resize();
        // Resize action-mask to icon game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) actionMask.resize();
        return this;
    }
}
Object.assign($2ae0d347a90f71ca$var$Label.prototype, (0, $fe363030058ced45$export$2e2bcd8739ae039));
var $2ae0d347a90f71ca$export$2e2bcd8739ae039 = $2ae0d347a90f71ca$var$Label;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("label", function(config) {
    var gameObject = new (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Label", (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039));
var $ac1cb2d4e32bf218$export$2e2bcd8739ae039 = (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039);






var $855a17c75ce39274$var$CreateBackground = function(scene, config) {
    var gameObject = new (0, $da55f0aef34a64ad$export$2e2bcd8739ae039)(scene, config);
    // TODO: Create nine-slice background game object
    scene.add.existing(gameObject);
    return gameObject;
};
var $855a17c75ce39274$export$2e2bcd8739ae039 = $855a17c75ce39274$var$CreateBackground;



const $bcf9b28c2e62c80a$var$GetValue = Phaser.Utils.Objects.GetValue;
const $bcf9b28c2e62c80a$var$PhaserText = Phaser.GameObjects.Text;
const $bcf9b28c2e62c80a$var$PhaserBitmapText = Phaser.GameObjects.BitmapText;
var $bcf9b28c2e62c80a$var$CreateText = function(scene, config) {
    var type = $bcf9b28c2e62c80a$var$GetValue(config, "$type");
    if (type === undefined) {
        if (!!$bcf9b28c2e62c80a$var$GetValue(config, "key")) type = "bitmaptext";
    }
    var gameObject;
    switch(type){
        case "bitmaptext":
            var key = $bcf9b28c2e62c80a$var$GetValue(config, "key");
            var size = $bcf9b28c2e62c80a$var$GetValue(config, "size");
            if (size === undefined) size = $bcf9b28c2e62c80a$var$GetValue(config, "fontSize");
            gameObject = new $bcf9b28c2e62c80a$var$PhaserBitmapText(scene, 0, 0, key, "", size);
            var color = $bcf9b28c2e62c80a$var$GetValue(config, "color");
            if (color !== undefined) gameObject.setTint(color);
            break;
        case "text":
            gameObject = new $bcf9b28c2e62c80a$var$PhaserText(scene, 0, 0, "", config);
            break;
        default:
            gameObject = new (0, $5c78a248668eabc1$export$2e2bcd8739ae039)(scene, 0, 0, "", config);
            break;
    }
    scene.add.existing(gameObject);
    return gameObject;
};
var $bcf9b28c2e62c80a$export$2e2bcd8739ae039 = $bcf9b28c2e62c80a$var$CreateText;



const $dc9c00e28f8765b6$var$BitmapTextKlass = Phaser.GameObjects.BitmapText;
var $dc9c00e28f8765b6$var$IsBitmapTextGameObject = function(gameObject) {
    return gameObject instanceof $dc9c00e28f8765b6$var$BitmapTextKlass;
};
var $dc9c00e28f8765b6$export$2e2bcd8739ae039 = $dc9c00e28f8765b6$var$IsBitmapTextGameObject;


const $0d3d6f3277aad4a5$var$TextKlass = Phaser.GameObjects.Text;
var $0d3d6f3277aad4a5$var$IsTextGameObject = function(gameObject) {
    return gameObject instanceof $0d3d6f3277aad4a5$var$TextKlass;
};
var $0d3d6f3277aad4a5$export$2e2bcd8739ae039 = $0d3d6f3277aad4a5$var$IsTextGameObject;


var $576a9bc207737222$var$TextRunWidthWrap = function(textObject) {
    var RunWidthWrap = function(width) {
        var padding = textObject.padding;
        var wrapWidth = width - padding.left - padding.right;
        var style = textObject.style;
        if ((0, $0d3d6f3277aad4a5$export$2e2bcd8739ae039)(textObject)) {
            style.wordWrapWidth = wrapWidth;
            style.maxLines = 0;
        } else {
            if (style.wrapMode === 0) style.wrapMode = 1;
            style.wrapWidth = wrapWidth;
            style.maxLines = 0;
        }
        style.fixedWidth = width;
        style.fixedHeight = 0;
        textObject.updateText(); // Redraw text
        textObject.minHeight = textObject.height;
        return textObject;
    };
    return RunWidthWrap;
};
var $576a9bc207737222$export$2e2bcd8739ae039 = $576a9bc207737222$var$TextRunWidthWrap;


var $0dadbc89295edd9c$var$DynamicTextRunWidthWrap = function(textObject) {
    var RunWidthWrap = function(width) {
        textObject.setFixedSize(width, 0).runWordWrap();
        textObject.minHeight = textObject.height;
        return textObject;
    };
    return RunWidthWrap;
};
var $0dadbc89295edd9c$export$2e2bcd8739ae039 = $0dadbc89295edd9c$var$DynamicTextRunWidthWrap;


var $ce78015dad06053e$var$BitmapTextRunWidthWrap = function(textObject) {
    var RunWidthWrap = function(width) {
        textObject.setMaxWidth(width);
        textObject.minHeight = textObject.height;
        return textObject;
    };
    return RunWidthWrap;
};
var $ce78015dad06053e$export$2e2bcd8739ae039 = $ce78015dad06053e$var$BitmapTextRunWidthWrap;


var $21ed2ed093f8e79c$var$IsDynamicTextGameObject = function(gameObject) {
    return gameObject instanceof (0, $0a1dceb2e89d5770$export$2e2bcd8739ae039);
};
var $21ed2ed093f8e79c$var$WrapExpandText = function(textObject, minWidth) {
    if (minWidth === undefined) minWidth = 0;
    textObject._minWidth = minWidth;
    textObject.runWidthWrap = $21ed2ed093f8e79c$var$IsDynamicTextGameObject(textObject) ? (0, $0dadbc89295edd9c$export$2e2bcd8739ae039)(textObject) : (0, $dc9c00e28f8765b6$export$2e2bcd8739ae039)(textObject) ? (0, $ce78015dad06053e$export$2e2bcd8739ae039)(textObject) : (0, $576a9bc207737222$export$2e2bcd8739ae039)(textObject);
    return textObject;
};
var $21ed2ed093f8e79c$export$2e2bcd8739ae039 = $21ed2ed093f8e79c$var$WrapExpandText;


const $b150042315c3d9f8$var$PhaserImage = Phaser.GameObjects.Image;
var $b150042315c3d9f8$var$CreateImage = function(scene, config) {
    var gameObject = new $b150042315c3d9f8$var$PhaserImage(scene, 0, 0, "");
    scene.add.existing(gameObject);
    return gameObject;
};
var $b150042315c3d9f8$export$2e2bcd8739ae039 = $b150042315c3d9f8$var$CreateImage;


const $07dafb4ba614c407$var$GetValue = Phaser.Utils.Objects.GetValue;
var $07dafb4ba614c407$var$BuildLabelConfig = function(scene, config, creators) {
    config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
    var createBackground = $07dafb4ba614c407$var$GetValue(creators, "background", (0, $855a17c75ce39274$export$2e2bcd8739ae039));
    var createText = $07dafb4ba614c407$var$GetValue(creators, "text", (0, $bcf9b28c2e62c80a$export$2e2bcd8739ae039));
    var createIcon = $07dafb4ba614c407$var$GetValue(creators, "icon", (0, $b150042315c3d9f8$export$2e2bcd8739ae039));
    var createAction = $07dafb4ba614c407$var$GetValue(creators, "action", (0, $b150042315c3d9f8$export$2e2bcd8739ae039));
    if (createBackground) config.background = createBackground(scene, config.background);
    else delete config.background;
    if (createText) {
        var wrapText = $07dafb4ba614c407$var$GetValue(config, "wrapText", false);
        if (wrapText) {
            if (wrapText === true) wrapText = "word";
            (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "text.wrap.mode", wrapText);
            config.expandTextWidth = true;
        }
        config.text = createText(scene, config.text);
        if (wrapText) config.text = (0, $21ed2ed093f8e79c$export$2e2bcd8739ae039)(config.text);
    } else delete config.text;
    if (createIcon && config.icon !== null) config.icon = createIcon(scene, config.icon);
    else delete config.icon;
    if (createAction && config.action !== null) config.action = createAction(scene, config.action);
    else delete config.action;
    return config;
};
var $07dafb4ba614c407$export$2e2bcd8739ae039 = $07dafb4ba614c407$var$BuildLabelConfig;


class $aba8d16e8e1e1748$var$SimpleLabel extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config, creators){
        config = (0, $07dafb4ba614c407$export$2e2bcd8739ae039)(scene, config, creators);
        super(scene, config);
        this.type = "rexSimpleLabel";
    }
    setActiveState(enable) {
        var background = this.childrenMap.background;
        if (background && background.setActiveState) background.setActiveState(enable);
        return this;
    }
    setHoverState(enable) {
        var background = this.childrenMap.background;
        if (background && background.setHoverState) background.setHoverState(enable);
        return this;
    }
    setDisableState(enable) {
        var background = this.childrenMap.background;
        if (background && background.setDisableState) background.setDisableState(enable);
        return this;
    }
}
var $aba8d16e8e1e1748$export$2e2bcd8739ae039 = $aba8d16e8e1e1748$var$SimpleLabel;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("simpleLabel", function(config, creators) {
    var gameObject = new (0, $aba8d16e8e1e1748$export$2e2bcd8739ae039)(this.scene, config, creators);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.SimpleLabel", (0, $aba8d16e8e1e1748$export$2e2bcd8739ae039));
var $577454205a4f337c$export$2e2bcd8739ae039 = (0, $aba8d16e8e1e1748$export$2e2bcd8739ae039);




const $aa50bddde9596d28$var$GetValue = Phaser.Utils.Objects.GetValue;
class $aa50bddde9596d28$var$TitleLabel extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexTitleLabel";
        // Add elements
        var background = $aa50bddde9596d28$var$GetValue(config, "background", undefined);
        var icon = $aa50bddde9596d28$var$GetValue(config, "icon", undefined);
        var iconMask = $aa50bddde9596d28$var$GetValue(config, "iconMask", undefined);
        var title = $aa50bddde9596d28$var$GetValue(config, "title", undefined);
        var separator = $aa50bddde9596d28$var$GetValue(config, "separator", undefined);
        var text = $aa50bddde9596d28$var$GetValue(config, "text", undefined);
        var action = $aa50bddde9596d28$var$GetValue(config, "action", undefined);
        var actionMask = $aa50bddde9596d28$var$GetValue(config, "actionMask", undefined);
        var hasTextSizer = text || title || separator;
        if (background) this.addBackground(background);
        if (icon) {
            var padding = undefined;
            if (this.orientation === 0) {
                if (hasTextSizer || action) padding = {
                    right: $aa50bddde9596d28$var$GetValue(config, "space.icon", 0),
                    top: $aa50bddde9596d28$var$GetValue(config, "space.iconTop", 0),
                    bottom: $aa50bddde9596d28$var$GetValue(config, "space.iconBottom", 0)
                };
            } else if (hasTextSizer || action) padding = {
                bottom: $aa50bddde9596d28$var$GetValue(config, "space.icon", 0),
                left: $aa50bddde9596d28$var$GetValue(config, "space.iconLeft", 0),
                right: $aa50bddde9596d28$var$GetValue(config, "space.iconRight", 0)
            };
            this.add(icon, {
                proportion: 0,
                padding: padding
            });
            if (iconMask) iconMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, icon, icon, 1); // Circle mask
        }
        if (hasTextSizer) {
            var textSizer = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
                orientation: 1
            });
            var separatorSpace = $aa50bddde9596d28$var$GetValue(config, "space.separator", 0);
            if (title) {
                var titleAlign = $aa50bddde9596d28$var$GetValue(config, "align.title", "right");
                var padding = {
                    bottom: !separator && text ? separatorSpace : 0
                };
                textSizer.add(title, {
                    align: titleAlign
                });
            }
            if (separator) {
                var padding = {
                    top: title ? separatorSpace : 0,
                    bottom: text ? separatorSpace : 0,
                    left: $aa50bddde9596d28$var$GetValue(config, "space.separatorLeft", 0),
                    right: $aa50bddde9596d28$var$GetValue(config, "space.separatorRight", 0)
                };
                textSizer.add(separator, {
                    expand: true,
                    padding: padding
                });
            }
            if (text) {
                var textAlign = $aa50bddde9596d28$var$GetValue(config, "align.text", "right");
                textSizer.add(text, {
                    align: textAlign
                });
            }
            var padding = undefined;
            if (action) padding = {
                right: $aa50bddde9596d28$var$GetValue(config, "space.text", 0)
            };
            this.add(textSizer, {
                proportion: 1,
                padding: padding
            });
        }
        if (action) {
            var padding;
            if (this.orientation === 0) padding = {
                top: $aa50bddde9596d28$var$GetValue(config, "space.actionTop", 0),
                bottom: $aa50bddde9596d28$var$GetValue(config, "space.actionBottom", 0)
            };
            else padding = {
                left: $aa50bddde9596d28$var$GetValue(config, "space.actionLeft", 0),
                right: $aa50bddde9596d28$var$GetValue(config, "space.actionRight", 0)
            };
            this.add(action, {
                proportion: 0,
                padding: padding
            });
            if (actionMask) actionMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, action, action, 1); // Circle mask
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("icon", icon);
        this.addChildrenMap("iconMask", iconMask);
        this.addChildrenMap("title", title);
        this.addChildrenMap("separator", separator);
        this.addChildrenMap("text", text);
        this.addChildrenMap("action", action);
        this.addChildrenMap("actionMask", actionMask);
    }
    // Access title game object
    get title() {
        var textObject = this.childrenMap.title;
        if (textObject === undefined) return "";
        return textObject.title;
    }
    set title(value) {
        var textObject = this.childrenMap.title;
        if (textObject === undefined) return;
        textObject.setText(value);
    }
    setTitle(value) {
        this.title = value;
        return this;
    }
    appendTitle(value) {
        this.title += value;
        return this;
    }
    // Access text game object
    get text() {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return "";
        return textObject.text;
    }
    set text(value) {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return;
        textObject.setText(value);
    }
    setText(value) {
        this.text = value;
        return this;
    }
    appendText(value) {
        this.text += value;
        return this;
    }
    // Access icon game object
    setTexture(key, frame) {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return;
        imageObject.setTexture(key, frame);
        return this;
    }
    get texture() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.texture;
    }
    get frame() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.frame;
    }
    runLayout(parent, newWidth, newHeight) {
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        // Pin icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) {
            iconMask.setPosition();
            this.resetChildPositionState(iconMask);
        }
        // Pin action-mask to action game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) {
            actionMask.setPosition();
            this.resetChildPositionState(actionMask);
        }
        return this;
    }
    resize(width, height) {
        super.resize(width, height);
        // Resize icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) iconMask.resize();
        // Resize action-mask to icon game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) actionMask.resize();
        return this;
    }
}
var $aa50bddde9596d28$export$2e2bcd8739ae039 = $aa50bddde9596d28$var$TitleLabel;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("titleLabel", function(config) {
    var gameObject = new (0, $aa50bddde9596d28$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TitleLabel", (0, $aa50bddde9596d28$export$2e2bcd8739ae039));
var $96c96da0865225e2$export$2e2bcd8739ae039 = (0, $aa50bddde9596d28$export$2e2bcd8739ae039);






const $5236f2094cdb2ac2$var$GetValue = Phaser.Utils.Objects.GetValue;
const $5236f2094cdb2ac2$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
var $5236f2094cdb2ac2$var$Build = function(scene, config) {
    // Add elements
    var background = $5236f2094cdb2ac2$var$GetValue(config, "background", undefined);
    var icon = $5236f2094cdb2ac2$var$GetValue(config, "icon", undefined);
    var iconMask = $5236f2094cdb2ac2$var$GetValue(config, "iconMask", undefined);
    var nameText = $5236f2094cdb2ac2$var$GetValue(config, "nameText", undefined);
    var valueText = $5236f2094cdb2ac2$var$GetValue(config, "valueText", undefined);
    var bar = $5236f2094cdb2ac2$var$GetValue(config, "bar", undefined);
    var action = $5236f2094cdb2ac2$var$GetValue(config, "action", undefined);
    var actionMask = $5236f2094cdb2ac2$var$GetValue(config, "actionMask", undefined);
    if ($5236f2094cdb2ac2$var$IsPlainObject(bar)) {
        bar = new (0, $bcbd612c21a81a48$export$2e2bcd8739ae039)(scene, bar);
        scene.add.existing(bar);
        // Move bar game object below nameText and valueText
        if (nameText) scene.children.moveBelow(bar, nameText);
        if (valueText) scene.children.moveBelow(bar, valueText);
    }
    var hasTextSizer = nameText || valueText || bar;
    if (background) this.addBackground(background);
    if (icon) {
        var padding = undefined;
        if (this.orientation === 0) {
            if (hasTextSizer || action) padding = {
                right: $5236f2094cdb2ac2$var$GetValue(config, "space.icon", 0),
                top: $5236f2094cdb2ac2$var$GetValue(config, "space.iconTop", 0),
                bottom: $5236f2094cdb2ac2$var$GetValue(config, "space.iconBottom", 0)
            };
        } else if (hasTextSizer || action) padding = {
            bottom: $5236f2094cdb2ac2$var$GetValue(config, "space.icon", 0),
            left: $5236f2094cdb2ac2$var$GetValue(config, "space.iconLeft", 0),
            right: $5236f2094cdb2ac2$var$GetValue(config, "space.iconRight", 0)
        };
        this.add(icon, {
            proportion: 0,
            padding: padding
        });
        if (iconMask) iconMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, icon, icon, 1); // Circle mask
    }
    if (hasTextSizer) {
        var textSizer = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
            orientation: 1
        });
        var nameValueSizer;
        if (nameText || valueText) {
            nameValueSizer = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
                orientation: 0
            });
            if (nameText) {
                // A space character to reserve text height
                if (nameText.text === "") nameText.setText(" ");
                nameText.setOrigin(0, nameText.originY);
                var padding = {
                    left: $5236f2094cdb2ac2$var$GetValue(config, "space.name", 0)
                };
                nameValueSizer.add(nameText, {
                    padding: padding
                });
            }
            if (valueText) {
                // A space character to reserve text height
                if (valueText.text === "") valueText.setText(" ");
                valueText.setOrigin(1, valueText.originY);
                nameValueSizer.addSpace();
                var padding = {
                    right: $5236f2094cdb2ac2$var$GetValue(config, "space.value", 0)
                };
                nameValueSizer.add(valueText, {
                    padding: padding
                });
                this.setValueTextFormatCallback($5236f2094cdb2ac2$var$GetValue(config, "valueTextFormatCallback", $5236f2094cdb2ac2$var$DefaultValueTextFormatCallback), $5236f2094cdb2ac2$var$GetValue(config, "valueTextFormatCallbackScope", undefined));
            }
            textSizer.add(nameValueSizer, {
                expand: true
            });
        }
        if (bar) {
            var padding = {
                top: nameValueSizer ? $5236f2094cdb2ac2$var$GetValue(config, "space.bar", 0) : 0,
                bottom: $5236f2094cdb2ac2$var$GetValue(config, "space.barBottom", 0),
                left: $5236f2094cdb2ac2$var$GetValue(config, "space.barLeft", 0),
                right: $5236f2094cdb2ac2$var$GetValue(config, "space.barRight", 0)
            };
            textSizer.add(bar, {
                expand: true,
                padding: padding
            });
        }
        var padding = undefined;
        if (action) padding = {
            right: $5236f2094cdb2ac2$var$GetValue(config, "space.text", 0)
        };
        var textAlign = $5236f2094cdb2ac2$var$GetValue(config, "align.text", "bottom");
        this.add(textSizer, {
            proportion: 1,
            align: textAlign,
            padding: padding
        });
    }
    if (action) {
        var padding;
        if (this.orientation === 0) padding = {
            top: $5236f2094cdb2ac2$var$GetValue(config, "space.actionTop", 0),
            bottom: $5236f2094cdb2ac2$var$GetValue(config, "space.actionBottom", 0)
        };
        else padding = {
            left: $5236f2094cdb2ac2$var$GetValue(config, "space.actionLeft", 0),
            right: $5236f2094cdb2ac2$var$GetValue(config, "space.actionRight", 0)
        };
        this.add(action, {
            proportion: 0,
            padding: padding
        });
        if (actionMask) actionMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, action, action, 1); // Circle mask
    }
    this.addChildrenMap("background", background);
    this.addChildrenMap("icon", icon);
    this.addChildrenMap("iconMask", iconMask);
    this.addChildrenMap("name", nameText);
    this.addChildrenMap("value", valueText);
    this.addChildrenMap("bar", bar);
    this.addChildrenMap("action", action);
    this.addChildrenMap("actionMask", actionMask);
};
var $5236f2094cdb2ac2$var$DefaultValueTextFormatCallback = function(value, min, max) {
    return value.toString();
};
var $5236f2094cdb2ac2$export$2e2bcd8739ae039 = $5236f2094cdb2ac2$var$Build;


const $e033e325ce6310dd$var$Clamp = Phaser.Math.Clamp;
var $e033e325ce6310dd$export$2e2bcd8739ae039 = {
    setValueTextFormatCallback (callback, scope) {
        this.valueTextFormatCallback = callback;
        this.valueTextFormatCallbackScope = scope;
        return this;
    },
    getFormatValueText (value, min, max) {
        if (value === undefined) value = this.value;
        if (min === undefined) min = this.minValue;
        if (max === undefined) max = this.maxValue;
        var text;
        if (this.valueTextFormatCallbackScope) text = this.valueTextFormatCallback(value, min, max);
        else text = this.valueTextFormatCallback.call(this.valueTextFormatCallbackScope, value, min, max);
        return text;
    },
    updateValueText (value, min, max) {
        var textObject = this.childrenMap.value;
        if (textObject && this.valueTextFormatCallback) {
            textObject.setText(this.getFormatValueText(value, min, max));
            if (textObject.layout) textObject.layout();
        }
        return this;
    },
    setValue (value, min, max) {
        value = $e033e325ce6310dd$var$Clamp(value, min, max);
        this.value = value;
        this.minValue = min;
        this.maxValue = max;
        this.updateValueText(value, min, max);
        this.setBarValue(value, min, max);
        return this;
    }
};


class $cbd33a4784005452$var$NameValueLabel extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexNameValueLabel";
        (0, $5236f2094cdb2ac2$export$2e2bcd8739ae039).call(this, scene, config);
    }
    // Access nameText game object
    get nameText() {
        var textObject = this.childrenMap.name;
        if (textObject === undefined) return "";
        return textObject.text;
    }
    set nameText(value) {
        var textObject = this.childrenMap.name;
        if (textObject === undefined) return;
        textObject.setText(value);
    }
    setNameText(value) {
        this.nameText = value;
        return this;
    }
    // Access valueText game object
    get valueText() {
        var textObject = this.childrenMap.value;
        if (textObject === undefined) return "";
        return textObject.text;
    }
    set valueText(value) {
        var textObject = this.childrenMap.value;
        if (textObject === undefined) return;
        textObject.setText(value);
    }
    setValueText(value) {
        this.valueText = value;
        return this;
    }
    // Accrss bar game object
    get barValue() {
        var bar = this.childrenMap.bar;
        if (bar === undefined) return;
        return bar.value;
    }
    set barValue(value) {
        var bar = this.childrenMap.bar;
        if (bar === undefined) return;
        bar.setValue(value);
    }
    setBarValue(value, min, max) {
        var bar = this.childrenMap.bar;
        if (bar === undefined) return this;
        bar.setValue(value, min, max);
        return this;
    }
    easeBarValueTo(value, min, max) {
        var bar = this.childrenMap.bar;
        if (bar === undefined) return this;
        bar.easeValueTo(value, min, max);
        return this;
    }
    // Access icon game object
    setTexture(key, frame) {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return;
        imageObject.setTexture(key, frame);
        return this;
    }
    get texture() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.texture;
    }
    get frame() {
        var imageObject = this.childrenMap.icon;
        if (imageObject === undefined) return undefined;
        return imageObject.frame;
    }
    runLayout(parent, newWidth, newHeight) {
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        // Pin icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) {
            iconMask.setPosition();
            this.resetChildPositionState(iconMask);
        }
        // Pin action-mask to action game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) {
            actionMask.setPosition();
            this.resetChildPositionState(actionMask);
        }
        return this;
    }
    resize(width, height) {
        super.resize(width, height);
        // Resize icon-mask to icon game object
        var iconMask = this.childrenMap.iconMask;
        if (iconMask) iconMask.resize();
        // Resize action-mask to icon game object
        var actionMask = this.childrenMap.actionMask;
        if (actionMask) actionMask.resize();
        return this;
    }
}
Object.assign($cbd33a4784005452$var$NameValueLabel.prototype, (0, $e033e325ce6310dd$export$2e2bcd8739ae039));
var $cbd33a4784005452$export$2e2bcd8739ae039 = $cbd33a4784005452$var$NameValueLabel;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("nameValueLabel", function(config) {
    var gameObject = new (0, $cbd33a4784005452$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.NameValueLabel", (0, $cbd33a4784005452$export$2e2bcd8739ae039));
var $d0a48e4bf5c470b2$export$2e2bcd8739ae039 = (0, $cbd33a4784005452$export$2e2bcd8739ae039);





const $b09955fe1f21b74c$var$SizerAdd = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039).prototype.add;
const $b09955fe1f21b74c$var$SizerAddSpace = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039).prototype.addSpace;
var $b09955fe1f21b74c$var$Add = function(gameObject) {
    var isNormalGameObject = !gameObject.isRexSpace;
    var proportion = !isNormalGameObject || this.buttonsExpand ? 1 : 0;
    if (this.sizerChildren.length === 0) {
        if (isNormalGameObject) {
            // Add space at head
            var hasHeadSpace = !this.buttonsExpand && (this.buttonsAlign === "right" || this.buttonsAlign === "center" || this.buttonsAlign === "bottom");
            if (hasHeadSpace) $b09955fe1f21b74c$var$SizerAddSpace.call(this);
            $b09955fe1f21b74c$var$SizerAdd.call(this, gameObject, {
                proportion: proportion,
                expand: true
            });
            // Add space at tail
            var hasTailSpace = !this.buttonsExpand && this.buttonsAlign === "center";
            if (hasTailSpace) $b09955fe1f21b74c$var$SizerAddSpace.call(this);
            this.hasTailSpace = hasTailSpace;
        } else {
            $b09955fe1f21b74c$var$SizerAdd.call(this, gameObject, {
                proportion: proportion,
                expand: true
            });
            this.hasTailSpace = false;
        }
    } else if (this.hasTailSpace) {
        var lastIndex = this.sizerChildren.length - 1;
        $b09955fe1f21b74c$var$SizerAdd.call(this, gameObject, {
            index: lastIndex,
            proportion: proportion,
            expand: true
        });
    } else $b09955fe1f21b74c$var$SizerAdd.call(this, gameObject, {
        proportion: proportion,
        expand: true
    });
    // Space or other game object as button
    if (isNormalGameObject) this.buttonGroup.add(gameObject);
    return this;
};
var $b09955fe1f21b74c$export$2e2bcd8739ae039 = {
    addButton (gameObject) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$b09955fe1f21b74c$var$Add.call(this, gameObjects[i]);
        } else $b09955fe1f21b74c$var$Add.call(this, gameObject);
        return this;
    },
    addButtons (gameObjects) {
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$b09955fe1f21b74c$var$Add.call(this, gameObjects[i]);
        return this;
    }
};




const $6cc3c2d6184aa4fa$var$SizerRmove = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039).prototype.remove;
const $6cc3c2d6184aa4fa$var$SizerClear = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039).prototype.clear;
var $6cc3c2d6184aa4fa$var$Remove = function(gameObject, destroyChild) {
    if (this.getParentSizer(gameObject) !== this) return this;
    this.buttonGroup.remove(gameObject);
    $6cc3c2d6184aa4fa$var$SizerRmove.call(this, gameObject, destroyChild);
    return this;
};
var $6cc3c2d6184aa4fa$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        // Remove gameObject no matter it is a button or not
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$6cc3c2d6184aa4fa$var$Remove.call(this, gameObjects[i], destroyChild);
        } else $6cc3c2d6184aa4fa$var$Remove.call(this, gameObject, destroyChild);
        return this;
    },
    clear (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        buttons.length = 0;
        $6cc3c2d6184aa4fa$var$SizerClear.call(this, destroyChild);
        return this;
    },
    removeButton (gameObject, destroyChild) {
        var gameObject = this.getButton(gameObject);
        // Don't remove this gameObject, it is not a button
        if (!gameObject) return this;
        this.remove(gameObject, destroyChild);
        return this;
    },
    clearButtons (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        for(var i = buttons.length - 1; i >= 0; i--)$6cc3c2d6184aa4fa$var$Remove.call(this, buttons[i], destroyChild);
        return this;
    }
};



var $4984d4bb6776b550$var$OnButtonStateChange = function(button, value, previousValue) {
    if (!button) return;
    var callback = this.setValueCallback;
    var scope = this.setValueCallbackScope;
    if (callback) {
        if (scope) callback.call(scope, button, value, previousValue);
        else callback(button, value, previousValue);
    }
    this.fireEvent("button.statechange", button, value, previousValue);
};
var $4984d4bb6776b550$export$2e2bcd8739ae039 = $4984d4bb6776b550$var$OnButtonStateChange;


var $b98c8975078bacff$var$InjectSelectedProperty = function(gameObject) {
    var self = this;
    gameObject._selected = undefined;
    Object.defineProperty(gameObject, "selected", {
        get: function() {
            return gameObject._selected;
        },
        set: function(newValue) {
            if (gameObject._selected === newValue) return;
            var previousValue = gameObject._selected;
            gameObject._selected = newValue;
            (0, $4984d4bb6776b550$export$2e2bcd8739ae039).call(self, gameObject, newValue, previousValue);
        },
        enumerable: true,
        configurable: true
    });
    gameObject.selected = false;
};
var $b98c8975078bacff$export$2e2bcd8739ae039 = $b98c8975078bacff$var$InjectSelectedProperty;


var $2cfc9d020fdfc91c$export$2e2bcd8739ae039 = {
    add (gameObject) {
        this.buttons.push(gameObject);
        //Default: Fire 'click' event when touch released after pressed.
        if (!gameObject._click) {
            gameObject._click = new (0, $24e6f4a5f37412ea$export$2e2bcd8739ae039)(gameObject, this.clickConfig);
            gameObject._click.on("click", function(buttonBehavior, gameObject, pointer, event) {
                this.fireEvent("button.click", gameObject, pointer, event);
            }, this).on("enable", function(buttonBehavior, gameObject) {
                this.fireEvent("button.enable", gameObject);
            }, this).on("disable", function(buttonBehavior, gameObject) {
                this.fireEvent("button.disable", gameObject);
            }, this);
            gameObject.on("pointerover", function(pointer, localX, localY, event) {
                this.fireEvent("button.over", gameObject, pointer, event);
            }, this).on("pointerout", function(pointer, event) {
                this.fireEvent("button.out", gameObject, pointer, event);
            }, this);
        }
        if (this.buttonsType) {
            if (gameObject.name === undefined) console.error(`${this.parent.constructor.name}: Option button miss value`);
            (0, $b98c8975078bacff$export$2e2bcd8739ae039).call(this, gameObject);
        }
        return this;
    },
    addMultiple (gameObjects) {
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)this.add(gameObjects[i]);
        return this;
    }
};


const $200aa063cbf4e640$var$RemoveItem = Phaser.Utils.Array.Remove;
var $200aa063cbf4e640$export$2e2bcd8739ae039 = {
    remove (gameObject) {
        if (this.buttonsType) delete gameObject.selected;
        $200aa063cbf4e640$var$RemoveItem(this.buttons, gameObject);
        return this;
    },
    clear () {
        if (this.buttonsType) {
            var buttons = this.buttons;
            for(var i = 0, cnt = buttons.length; i < cnt; i++)delete buttons[i].selected;
        }
        this.buttons.length = 0;
        return this;
    }
};


var $df52604de8561413$var$FireEvent = function(eventName, button, ...args) {
    var index;
    if (typeof button === "number") {
        index = button;
        button = this.buttons[index];
        if (!button) return;
    } else {
        index = this.buttons.indexOf(button);
        if (index === -1) return;
    }
    // Buttons is a child. Fire internal events.
    if (this.eventEmitter !== this.parent) this.parent.emit(eventName, button, index, ...args);
    if (this.groupName !== undefined) this.eventEmitter.emit(eventName, button, this.groupName, index, ...args);
    else this.eventEmitter.emit(eventName, button, index, ...args);
};
var $df52604de8561413$export$2e2bcd8739ae039 = $df52604de8561413$var$FireEvent;


const $728b017c19c06224$var$GetValue = Phaser.Utils.Objects.GetValue;
var $728b017c19c06224$export$2e2bcd8739ae039 = {
    setButtonsType (config) {
        if (config === undefined) config = {};
        var buttonsType = $728b017c19c06224$var$GetValue(config, "buttonsType", config.type);
        this.buttonsType = buttonsType;
        if (!this.buttonsType) return this;
        // Assign this.setValueCallback, this.setValueCallbackScope
        var setValueCallback, setValueCallbackScope;
        setValueCallback = $728b017c19c06224$var$GetValue(config, "setValueCallback", undefined);
        setValueCallbackScope = $728b017c19c06224$var$GetValue(config, "setValueCallbackScope", undefined);
        if (setValueCallback === undefined) {
            setValueCallback = $728b017c19c06224$var$GetValue(config, "setButtonStateCallback", undefined);
            setValueCallbackScope = $728b017c19c06224$var$GetValue(config, "setButtonStateCallbackScope", undefined);
        }
        this.setValueCallback = setValueCallback;
        this.setValueCallbackScope = setValueCallbackScope;
        switch(buttonsType){
            case "radio":
                this.setRadioType();
                break;
            case "checkboxes":
                this.setCheckboxesType();
                break;
        }
        return this;
    },
    setRadioType () {
        var parent = this.parent, buttons = this.buttons;
        parent._value = undefined;
        var selectedIndex = undefined;
        Object.defineProperty(parent, "value", {
            get: function() {
                return parent._value;
            },
            set: function(newValue) {
                if (parent._value === newValue) return;
                parent._value = newValue;
                for(var i = 0, cnt = buttons.length; i < cnt; i++){
                    var button = buttons[i];
                    if (button.rexSizer.hidden) continue;
                    if (selectedIndex === undefined) {
                        if (button.name === newValue) button.selected = true;
                        else button.selected = false;
                    } else if (selectedIndex === i) button.selected = true;
                    else button.selected = false;
                }
            },
            enumerable: true,
            configurable: true
        });
        parent.on("button.click", function(button) {
            selectedIndex = this.buttons.indexOf(button);
            parent.value = button.name;
            selectedIndex = undefined;
        }, this);
        return this;
    },
    setCheckboxesType () {
        var parent = this.parent;
        parent.on("button.click", function(button) {
            button.selected = !button.selected;
        });
        return this;
    },
    // Common
    clearAllButtonsState () {
        var buttons = this.buttons;
        for(var i = 0, cnt = buttons.length; i < cnt; i++){
            var button = buttons[i];
            button.selected = false;
        }
        return this;
    },
    getAllButtonsState () {
        var states = {};
        var buttons = this.buttons;
        for(var i = 0, cnt = buttons.length; i < cnt; i++){
            var button = buttons[i];
            if (button.rexSizer.hidden) continue;
            states[button.name] = button.selected;
        }
        return states;
    },
    // For radio
    setSelectedButtonName (name) {
        this.parent.value = name;
        return this;
    },
    getSelectedButtonName () {
        return this.parent.value;
    },
    // For checkboxes
    setButtonState (name, state) {
        if (state === undefined) state = true;
        var buttons = this.buttons;
        for(var i = 0, cnt = buttons.length; i < cnt; i++){
            var button = buttons[i];
            if (button.rexSizer.hidden) continue;
            if (button.name === name) {
                button.selected = state;
                break;
            }
        }
        return this;
    },
    getButtonState (name) {
        var buttons = this.buttons;
        for(var i = 0, cnt = buttons.length; i < cnt; i++){
            var button = buttons[i];
            if (button.rexSizer.hidden) continue;
            if (button.name === name) return button.selected;
        }
        return undefined;
    }
};


// Include in ButtonGroup class and Buttons/GridButtons/FixedWidthButtons class

var $d38174b6f21b2629$var$GetGameObjectByName = function(children, name) {
    if (!children) return null;
    else if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(children)) {
        var child;
        for(var i = 0, cnt = children.length; i < cnt; i++){
            child = $d38174b6f21b2629$var$TestName(children[i], name);
            if (child) return child;
        }
    } else {
        var child;
        for(var key in children){
            child = $d38174b6f21b2629$var$TestName(children[key], name);
            if (child) return child;
        }
    }
};
var $d38174b6f21b2629$var$TestName = function(gameObject, name) {
    if (!gameObject) return null;
    else if (gameObject.hasOwnProperty("name")) return gameObject.name === name ? gameObject : null;
    else return GetElementByName(gameObject, name);
};
var $d38174b6f21b2629$export$2e2bcd8739ae039 = $d38174b6f21b2629$var$GetGameObjectByName;


var $8ddbc41fbaadb437$export$2e2bcd8739ae039 = (0, $d38174b6f21b2629$export$2e2bcd8739ae039);



var $7030dae108e5ac1d$export$2e2bcd8739ae039 = {
    getButton (index) {
        // buttonGroup and button-sizer have *buttons* member both
        var buttons = this.buttons, button;
        var indexType = typeof index;
        switch(indexType){
            case "number":
                button = buttons[index];
                break;
            case "string":
                button = (0, $8ddbc41fbaadb437$export$2e2bcd8739ae039)(buttons, index);
                break;
            default:
                button = index;
                if (buttons.indexOf(button) === -1) button = undefined;
                break;
        }
        return button;
    },
    setButtonEnable (index, enabled) {
        // buttonGroup and button-sizer have *buttons* member both
        var buttons = this.buttons;
        if (index === undefined || typeof index === "boolean") {
            enabled = index;
            for(var i = 0, cnt = buttons.length; i < cnt; i++)buttons[i]._click.setEnable(enabled);
        } else this.getButton(index)._click.setEnable(enabled);
        return this;
    },
    toggleButtonEnable (index) {
        // buttonGroup and button-sizer have *buttons* member both
        var buttons = this.buttons;
        if (index === undefined || typeof index === "boolean") for(var i = 0, cnt = buttons.length; i < cnt; i++)buttons[i]._click.toggleEnable();
        else this.getButton(index)._click.toggleEnable();
        return this;
    },
    getButtonEnable (index) {
        if (index === undefined) index = 0;
        return this.getButton(index)._click.enable;
    },
    emitButtonClick (index) {
        // index or button game object
        // this: buttonGroup or button-sizer
        var buttonGroup = this.buttonGroup ? this.buttonGroup : this;
        buttonGroup.fireEvent("button.click", index);
        return this;
    },
    showButton (index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getButton(index));
        return this;
    },
    hideButton (index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getButton(index));
        return this;
    },
    isButtonShown (index) {
        (0, $f55461eb0d33b5f5$export$be736b6b33b78275)(this.getButton(index));
        return this;
    },
    forEachButtton (callback, scope) {
        // buttonGroup and button-sizer have *buttons* member both
        var buttons = this.buttons;
        for(var i = 0, cnt = buttons.length; i < cnt; i++)if (scope) callback.call(scope, buttons[i], i, buttons);
        else callback(buttons[i], i, buttons);
        return this;
    }
};


class $765151541b18acf0$var$ButtonGroup {
    constructor(config){
        this.parent = config.parent;
        this.eventEmitter = config.eventEmitter;
        this.groupName = config.groupName;
        this.clickConfig = config.clickConfig;
        this.buttonsType = undefined;
        this.buttons = [];
    }
    destroy() {
        this.parent = undefined;
        this.eventEmitter = undefined;
        this.clickConfig = undefined;
        this.buttons = undefined; // GameObjects will be destroyed outside
    }
}
var $765151541b18acf0$var$methods = {
    fireEvent: (0, $df52604de8561413$export$2e2bcd8739ae039)
};
Object.assign($765151541b18acf0$var$ButtonGroup.prototype, (0, $2cfc9d020fdfc91c$export$2e2bcd8739ae039), (0, $200aa063cbf4e640$export$2e2bcd8739ae039), (0, $728b017c19c06224$export$2e2bcd8739ae039), (0, $7030dae108e5ac1d$export$2e2bcd8739ae039), $765151541b18acf0$var$methods);
var $765151541b18acf0$export$2e2bcd8739ae039 = $765151541b18acf0$var$ButtonGroup;



// Include in Buttons/GridButtons/FixedWidthButtons class
var $9ce511a679e082b3$export$2e2bcd8739ae039 = {
    // Common
    clearAllButtonsState () {
        this.buttonGroup.clearAllButtonsState();
        return this;
    },
    getAllButtonsState () {
        return this.buttonGroup.getAllButtonsState();
    },
    // For radio
    setSelectedButtonName (name) {
        this.buttonGroup.setSelectedButtonName(name);
        return this;
    },
    getSelectedButtonName () {
        return this.buttonGroup.getSelectedButtonName();
    },
    // For checkboxes
    setButtonState (name, state) {
        this.buttonGroup.setButtonState(name, state);
        return this;
    },
    getButtonState (name) {
        return this.buttonGroup.getButtonState(name);
    }
};


const $e713f60692044763$var$GetValue = Phaser.Utils.Objects.GetValue;
class $e713f60692044763$var$Buttons extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var buttonSpace = config.space;
        if (typeof buttonSpace === "number") config.space = {
            item: buttonSpace
        };
        // Create
        super(scene, config);
        this.type = "rexButtons";
        this.buttonGroup = new (0, $765151541b18acf0$export$2e2bcd8739ae039)({
            parent: this,
            eventEmitter: $e713f60692044763$var$GetValue(config, "eventEmitter", this),
            groupName: $e713f60692044763$var$GetValue(config, "groupName", undefined),
            clickConfig: $e713f60692044763$var$GetValue(config, "click", undefined)
        }).setButtonsType(config);
        // Add elements
        var background = $e713f60692044763$var$GetValue(config, "background", undefined);
        var buttons = $e713f60692044763$var$GetValue(config, "buttons", undefined);
        // Buttons properties
        this.buttonsExpand = $e713f60692044763$var$GetValue(config, "expand", false);
        this.buttonsAlign = $e713f60692044763$var$GetValue(config, "align", undefined); // undefined/left/top: no space                
        if (background) this.addBackground(background);
        if (buttons) this.addButtons(buttons);
        this.addChildrenMap("background", background);
        this.addChildrenMap("buttons", this.buttonGroup.buttons);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        super.destroy(fromScene);
        this.buttonGroup.destroy();
        this.buttonGroup = undefined;
    }
    get buttons() {
        return this.buttonGroup.buttons;
    }
    get groupName() {
        return this.buttonGroup.groupName;
    }
    set groupName(value) {
        this.buttonGroup.groupName = value;
    }
    get eventEmitter() {
        return this.buttonGroup.eventEmitter;
    }
}
Object.assign($e713f60692044763$var$Buttons.prototype, (0, $b09955fe1f21b74c$export$2e2bcd8739ae039), (0, $6cc3c2d6184aa4fa$export$2e2bcd8739ae039), (0, $7030dae108e5ac1d$export$2e2bcd8739ae039), (0, $9ce511a679e082b3$export$2e2bcd8739ae039));
var $e713f60692044763$export$2e2bcd8739ae039 = $e713f60692044763$var$Buttons;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("buttons", function(config) {
    var gameObject = new (0, $e713f60692044763$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Buttons", (0, $e713f60692044763$export$2e2bcd8739ae039));
var $17ef1a9d6537753b$export$2e2bcd8739ae039 = (0, $e713f60692044763$export$2e2bcd8739ae039);




const $5e4d698507cafc99$var$SizerAdd = (0, $a949ee088f929daa$export$2e2bcd8739ae039).prototype.add;
var $5e4d698507cafc99$export$2e2bcd8739ae039 = {
    addButton (gameObject, columnIndex, rowIndex) {
        $5e4d698507cafc99$var$SizerAdd.call(this, gameObject, columnIndex, rowIndex, undefined, 0, this.buttonsExpand);
        this.buttonGroup.add(gameObject);
        return this;
    },
    addButtons (gameObjects, rowThenColumn) {
        for(var i = 0, cnt = gameObjects; i < cnt; i++)this.addButton(gameObjects[i], undefined, rowThenColumn);
        return this;
    }
};




const $962ee00ebde95c0e$var$SizerRmove = (0, $a949ee088f929daa$export$2e2bcd8739ae039).prototype.remove;
const $962ee00ebde95c0e$var$SizerClear = (0, $a949ee088f929daa$export$2e2bcd8739ae039).prototype.clear;
var $962ee00ebde95c0e$var$Remove = function(gameObject, destroyChild) {
    var gameObject = this.getButton(gameObject);
    if (!gameObject) return this;
    this.buttonGroup.remove(gameObject);
    $962ee00ebde95c0e$var$SizerRmove.call(this, gameObject, destroyChild);
    return this;
};
var $962ee00ebde95c0e$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$962ee00ebde95c0e$var$Remove.call(this, gameObjects[i], destroyChild);
        } else $962ee00ebde95c0e$var$Remove.call(this, gameObject, destroyChild);
        return this;
    },
    clear (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        buttons.length = 0;
        $962ee00ebde95c0e$var$SizerClear.call(this, destroyChild);
        return this;
    },
    removeButton (gameObject, destroyChild) {
        this.remove(gameObject, destroyChild);
        return this;
    },
    clearButtons (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        for(var i = buttons.length - 1; i >= 0; i--)$962ee00ebde95c0e$var$Remove.call(this, buttons[i], destroyChild);
        return this;
    }
};





const $3ff850ea042009c0$var$GetValue = Phaser.Utils.Objects.GetValue;
class $3ff850ea042009c0$var$GridButtons extends (0, $a949ee088f929daa$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var rowCount = $3ff850ea042009c0$var$GetValue(config, "row", 0);
        var columnCount = $3ff850ea042009c0$var$GetValue(config, "column", config.col || 0);
        var createCellContainerCallback = $3ff850ea042009c0$var$GetValue(config, "createCellContainerCallback");
        var buttons = $3ff850ea042009c0$var$GetValue(config, "buttons", undefined);
        var buttonsExpand = $3ff850ea042009c0$var$GetValue(config, "expand", true);
        var buttonProportion = buttonsExpand ? 1 : 0;
        if (createCellContainerCallback) config.createCellContainerCallback = undefined;
        if (buttons !== undefined) {
            rowCount = Math.max(rowCount, buttons.length);
            for(var i = 0, cnt = buttons.length; i < cnt; i++)columnCount = Math.max(columnCount, buttons[i].length);
        }
        config.row = rowCount;
        config.column = columnCount;
        config.columnProportions = buttonProportion;
        config.rowProportions = buttonProportion;
        // Create
        super(scene, config);
        this.type = "rexGridButtons";
        this.buttonGroup = new (0, $765151541b18acf0$export$2e2bcd8739ae039)({
            parent: this,
            eventEmitter: $3ff850ea042009c0$var$GetValue(config, "eventEmitter", this),
            groupName: $3ff850ea042009c0$var$GetValue(config, "groupName", undefined),
            clickConfig: $3ff850ea042009c0$var$GetValue(config, "click", undefined)
        }).setButtonsType(config);
        // Add elements
        var background = $3ff850ea042009c0$var$GetValue(config, "background", undefined);
        // Buttons properties
        this.buttonsExpand = buttonsExpand;
        var space = $3ff850ea042009c0$var$GetValue(config, "space", undefined);
        if (typeof space === "number") space = {
            itemX: space,
            itemY: space
        };
        if (background) this.addBackground(background);
        if (buttons) {
            var rowButtons, button;
            for(var r = 0, rcnt = buttons.length; r < rcnt; r++){
                rowButtons = buttons[r];
                for(var c = 0, ccnt = rowButtons.length; c < ccnt; c++){
                    button = rowButtons[c];
                    if (button) this.addButton(button, c, r);
                }
            }
        } else if (createCellContainerCallback) {
            for(var y = 0; y < rowCount; y++)for(var x = 0; x < columnCount; x++){
                var button = createCellContainerCallback(scene, x, y);
                if (button) this.addButton(button, x, y);
            }
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("buttons", this.buttonGroup.buttons);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        super.destroy(fromScene);
        this.buttonGroup.destroy();
        this.buttonGroup = undefined;
    }
    get buttons() {
        return this.buttonGroup.buttons;
    }
    get groupName() {
        return this.buttonGroup.groupName;
    }
    set groupName(value) {
        this.buttonGroup.groupName = value;
    }
    get eventEmitter() {
        return this.buttonGroup.eventEmitter;
    }
}
Object.assign($3ff850ea042009c0$var$GridButtons.prototype, (0, $5e4d698507cafc99$export$2e2bcd8739ae039), (0, $962ee00ebde95c0e$export$2e2bcd8739ae039), (0, $7030dae108e5ac1d$export$2e2bcd8739ae039), (0, $9ce511a679e082b3$export$2e2bcd8739ae039));
var $3ff850ea042009c0$export$2e2bcd8739ae039 = $3ff850ea042009c0$var$GridButtons;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("gridButtons", function(config) {
    var gameObject = new (0, $3ff850ea042009c0$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.GridButtons", (0, $3ff850ea042009c0$export$2e2bcd8739ae039));
var $a466adfc30794de2$export$2e2bcd8739ae039 = (0, $3ff850ea042009c0$export$2e2bcd8739ae039);





const $eb24154cb33c42ab$var$SizerAdd = (0, $92d11076da36f893$export$2e2bcd8739ae039).prototype.add;
var $eb24154cb33c42ab$var$Add = function(gameObject) {
    $eb24154cb33c42ab$var$SizerAdd.call(this, gameObject);
    this.buttonGroup.add(gameObject);
    return this;
};
var $eb24154cb33c42ab$export$2e2bcd8739ae039 = {
    addButton (gameObject) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$eb24154cb33c42ab$var$Add.call(this, gameObjects[i]);
        } else $eb24154cb33c42ab$var$Add.call(this, gameObject);
        return this;
    },
    addButtons (gameObjects) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObjects[0])) {
            // 2d array
            var lines = gameObjects, line;
            for(var lineIdx = 0, lastLineIdx = lines.length - 1; lineIdx <= lastLineIdx; lineIdx++){
                line = lines[lineIdx];
                for(var i = 0, cnt = line.length; i < cnt; i++)$eb24154cb33c42ab$var$Add.call(this, line[i]);
                if (lineIdx > lastLineIdx) $eb24154cb33c42ab$var$SizerAdd.addNewLine(this);
            }
        } else // 1d array
        for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$eb24154cb33c42ab$var$Add.call(this, gameObjects[i]);
        return this;
    }
};




const $da1c943fa9b919c3$var$SizerRmove = (0, $92d11076da36f893$export$2e2bcd8739ae039).prototype.remove;
const $da1c943fa9b919c3$var$SizerClear = (0, $92d11076da36f893$export$2e2bcd8739ae039).prototype.clear;
var $da1c943fa9b919c3$var$Remove = function(gameObject, destroyChild) {
    var gameObject = this.getButton(gameObject);
    if (!gameObject) return this;
    this.buttonGroup.remove(gameObject);
    $da1c943fa9b919c3$var$SizerRmove.call(this, gameObject, destroyChild);
    return this;
};
var $da1c943fa9b919c3$export$2e2bcd8739ae039 = {
    remove (gameObject, destroyChild) {
        if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(gameObject)) {
            var gameObjects = gameObject;
            for(var i = 0, cnt = gameObjects.length; i < cnt; i++)$da1c943fa9b919c3$var$Remove.call(this, gameObjects[i], destroyChild);
        } else $da1c943fa9b919c3$var$Remove.call(this, gameObject, destroyChild);
        return this;
    },
    clear (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        buttons.length = 0;
        $da1c943fa9b919c3$var$SizerClear.call(this, destroyChild);
        return this;
    },
    removeButton (gameObject, destroyChild) {
        this.remove(gameObject, destroyChild);
        return this;
    },
    clearButtons (destroyChild) {
        var buttons = this.buttonGroup.buttons;
        for(var i = buttons.length - 1; i >= 0; i--)$da1c943fa9b919c3$var$Remove.call(this, buttons[i], destroyChild);
        return this;
    }
};





const $1418690eca2b4065$var$GetValue = Phaser.Utils.Objects.GetValue;
class $1418690eca2b4065$var$Buttons extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var buttonSpace = config.space;
        if (typeof buttonSpace === "number") config.space = {
            item: buttonSpace,
            line: buttonSpace
        };
        // Create
        super(scene, config);
        this.type = "rexFixWidthButtons";
        this.buttonGroup = new (0, $765151541b18acf0$export$2e2bcd8739ae039)({
            parent: this,
            eventEmitter: $1418690eca2b4065$var$GetValue(config, "eventEmitter", this),
            groupName: $1418690eca2b4065$var$GetValue(config, "groupName", undefined),
            clickConfig: $1418690eca2b4065$var$GetValue(config, "click", undefined)
        }).setButtonsType(config);
        // Add elements
        var background = $1418690eca2b4065$var$GetValue(config, "background", undefined);
        var buttons = $1418690eca2b4065$var$GetValue(config, "buttons", undefined);
        // Buttons properties
        this.buttonsAlign = $1418690eca2b4065$var$GetValue(config, "align", undefined);
        if (background) this.addBackground(background);
        if (buttons) this.addButtons(buttons);
        this.addChildrenMap("background", background);
        this.addChildrenMap("buttons", this.buttonGroup.buttons);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        super.destroy(fromScene);
        this.buttonGroup.destroy();
        this.buttonGroup = undefined;
    }
    get buttons() {
        return this.buttonGroup.buttons;
    }
    get groupName() {
        return this.buttonGroup.groupName;
    }
    set groupName(value) {
        this.buttonGroup.groupName = value;
    }
    get eventEmitter() {
        return this.buttonGroup.eventEmitter;
    }
}
Object.assign($1418690eca2b4065$var$Buttons.prototype, (0, $eb24154cb33c42ab$export$2e2bcd8739ae039), (0, $da1c943fa9b919c3$export$2e2bcd8739ae039), (0, $7030dae108e5ac1d$export$2e2bcd8739ae039), (0, $9ce511a679e082b3$export$2e2bcd8739ae039));
var $1418690eca2b4065$export$2e2bcd8739ae039 = $1418690eca2b4065$var$Buttons;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fixWidthButtons", function(config) {
    var gameObject = new (0, $1418690eca2b4065$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FixWidthButtons", (0, $1418690eca2b4065$export$2e2bcd8739ae039));
var $f3bf34cd7b49f18e$export$2e2bcd8739ae039 = (0, $1418690eca2b4065$export$2e2bcd8739ae039);




var $5c8391e6f0724d81$export$2e2bcd8739ae039 = {
    setAccept (accept) {
        this.childrenMap.fileChooser.setAccept(accept);
        return this;
    },
    setMultiple (enabled) {
        this.childrenMap.fileChooser.setMultiple(enabled);
        return this;
    },
    loadFile (file, loaderType, key, cacheType, onComplete) {
        this.childrenMap.fileChooser.loadFile(file, loaderType, key, cacheType, onComplete);
        return this;
    },
    loadFilePromise (file, loaderType, key, cacheType) {
        return this.childrenMap.fileChooser.loadFilePromise(file, loaderType, key, cacheType);
    }
};


const $f3a540f82c16766d$var$GetValue = Phaser.Utils.Objects.GetValue;
class $f3a540f82c16766d$var$FileSelectorButton extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexFileSelectorButton";
        var fileChooser = new (0, $c57c3d4ef22bfaaa$export$2e2bcd8739ae039)(scene);
        scene.add.existing(fileChooser);
        this.addBackground(fileChooser);
        this.addChildrenMap("fileChooser", fileChooser);
        this.setAccept($f3a540f82c16766d$var$GetValue(config, "accept", ""));
        this.setMultiple($f3a540f82c16766d$var$GetValue(config, "multiple", false));
        fileChooser.on("change", function(gameObject) {
            var files = gameObject.files;
            if (files.length === 0) return;
            files = Array.from(files);
            this.emit("select", files, this);
        }, this);
    }
    get files() {
        return this.childrenMap.fileChooser.files;
    }
}
Object.assign($f3a540f82c16766d$var$FileSelectorButton.prototype, (0, $5c8391e6f0724d81$export$2e2bcd8739ae039));
var $f3a540f82c16766d$export$2e2bcd8739ae039 = $f3a540f82c16766d$var$FileSelectorButton;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("fileSelectorButton", function(config) {
    var gameObject = new (0, $f3a540f82c16766d$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.FileSelectorButton", (0, $f3a540f82c16766d$export$2e2bcd8739ae039));
var $1ff9976e350234c8$export$2e2bcd8739ae039 = (0, $f3a540f82c16766d$export$2e2bcd8739ae039);







var $89c1a8f64f110e28$export$2e2bcd8739ae039 = {
    getChoice (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) return choicesSizer.getButton(index);
        else return undefined;
    },
    getAction (index) {
        return this.childrenMap.actionsSizer.getButton(index);
    },
    getToolbar (index) {
        return this.childrenMap.toolbarSizer.getButton(index);
    },
    getLeftToolbar (index) {
        return this.childrenMap.leftToolbarSizer.getButton(index);
    },
    setChoiceEnable (index, enabled) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.setButtonEnable(index, enabled);
        return this;
    },
    setActionEnable (index, enabled) {
        this.childrenMap.actionsSizer.setButtonEnable(index, enabled);
        return this;
    },
    setToolbarEnable (index, enabled) {
        this.childrenMap.toolbarSizer.setButtonEnable(index, enabled);
        return this;
    },
    setLeftToolbarEnable (index, enabled) {
        this.childrenMap.leftToolbarSizer.setButtonEnable(index, enabled);
        return this;
    },
    toggleChoiceEnable (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.toggleButtonEnable(index);
        return this;
    },
    toggleActionEnable (index) {
        this.childrenMap.actionsSizer.toggleButtonEnable(index);
        return this;
    },
    toggleToolbarEnable (index) {
        this.childrenMap.toolbarSizer.toggleButtonEnable(index);
        return this;
    },
    toggleLeftToolbarEnable (index) {
        this.childrenMap.leftToolbarSizer.toggleButtonEnable(index);
        return this;
    },
    getChoiceEnable (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) return choicesSizer.getButtonEnable(index);
        else return false;
    },
    getActionEnable (index) {
        return this.childrenMap.actionsSizer.getButtonEnable(index);
    },
    getToolbarEnable (index) {
        return this.childrenMap.toolbarSizer.getButtonEnable(index);
    },
    getLeftToolbarEnable (index) {
        return this.childrenMap.leftToolbarSizer.getButtonEnable(index);
    },
    emitChoiceClick (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.emitButtonClick(index);
        return this;
    },
    emitActionClick (index) {
        this.childrenMap.actionsSizer.emitButtonClick(index);
        return this;
    },
    emitToolbarClick (index) {
        this.childrenMap.toolbarSizer.emitButtonClick(index);
        return this;
    },
    emitLeftToolbarClick (index) {
        this.childrenMap.leftToolbarSizer.emitButtonClick(index);
        return this;
    },
    showChoice (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.showButton(index);
        return this;
    },
    showAction (index) {
        this.childrenMap.actionsSizer.showButton(index);
        return this;
    },
    showToolbar (index) {
        this.childrenMap.toolbarSizer.showButton(index);
        return this;
    },
    showLeftToolbar (index) {
        this.childrenMap.leftToolbarSizer.showButton(index);
        return this;
    },
    hideChoice (index) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.hideButton(index);
        return this;
    },
    hideAction (index) {
        this.childrenMap.actionsSizer.hideButton(index);
        return this;
    },
    hideToolbar (index) {
        this.childrenMap.toolbarSizer.hideButton(index);
        return this;
    },
    hideLeftToolbar (index) {
        this.childrenMap.leftToolbarSizer.hideButton(index);
        return this;
    },
    addChoice (gameObject) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.addButton(gameObject);
        return this;
    },
    addAction (gameObject) {
        this.childrenMap.actionsSizer.addButton(gameObject);
        return this;
    },
    addToolbar (gameObject) {
        this.childrenMap.toolbarSizer.addButton(gameObject);
        return this;
    },
    addLeftToolbar (gameObject) {
        this.childrenMap.leftToolbarSizer.addButton(gameObject);
        return this;
    },
    removeChoice (index, destroyChild) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.removeButton(index, destroyChild);
        return this;
    },
    removeAction (index, destroyChild) {
        this.childrenMap.actionsSizer.removeButton(index, destroyChild);
        return this;
    },
    removeToolbar (index, destroyChild) {
        this.childrenMap.toolbarSizer.removeButton(index, destroyChild);
        return this;
    },
    removeLeftToolbar (index, destroyChild) {
        this.childrenMap.leftToolbarSizer.removeButton(index, destroyChild);
        return this;
    },
    clearChoices (destroyChild) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.clearButtons(destroyChild);
        return this;
    },
    clearActions (destroyChild) {
        this.childrenMap.actionsSizer.clearButtons(destroyChild);
        return this;
    },
    clearToolbar (destroyChild) {
        this.childrenMap.toolbarSizer.clearButtons(destroyChild);
        return this;
    },
    clearLeftToolbar (destroyChild) {
        this.childrenMap.leftToolbarSizer.clearButtons(destroyChild);
        return this;
    },
    forEachChoice (callback, scope) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachAction (callback, scope) {
        this.childrenMap.actionsSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachToolbar (callback, scope) {
        this.childrenMap.toolbarSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachLeftToolbar (callback, scope) {
        this.childrenMap.leftToolbarSizer.forEachButtton(callback, scope);
        return this;
    },
    setAllButtonsEnable (enabled) {
        if (enabled === undefined) enabled = true;
        if (this.childrenMap.toolbarSizer) this.setToolbarEnable(enabled);
        if (this.childrenMap.leftToolbarSizer) this.setLeftToolbarEnable(enabled);
        if (this.childrenMap.actionsSizer) this.setActionEnable(enabled);
        if (this.childrenMap.choicesSizer) this.setChoiceEnable(enabled);
        return this;
    },
    // Checkboxes
    getChoicesButtonStates () {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) return choicesSizer.getAllButtonsState();
        else return {};
    },
    getChoicesButtonState (name) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (name === undefined) {
            if (choicesSizer) return choicesSizer.getAllButtonsState();
            else return {};
        } else {
            if (choicesSizer) return choicesSizer.getButtonState(name);
            else return false;
        }
    },
    setChoicesButtonState (name, state) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.setButtonState(name, state);
        return this;
    },
    clearChoicesButtonStates () {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.clearAllButtonsState();
        return this;
    },
    // Radio buttons
    getChoicesSelectedButtonName () {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) return choicesSizer.getSelectedButtonName();
        else return "";
    },
    setChoicesSelectedButtonName (name) {
        var choicesSizer = this.childrenMap.choicesSizer;
        if (choicesSizer) choicesSizer.setSelectedButtonName(name);
        return this;
    }
};



var $b9eee60d9ab4c401$export$2e2bcd8739ae039 = {
    onCreateModalBehavior (self) {
        self.on("button.click", function(button, groupName, index, pointer, event) {
            if (groupName !== "actions") return;
            var closeEventData = {
                index: index,
                text: button.text,
                button: button,
                dialog: self
            };
            switch(self.buttonsType){
                case "radio":
                    closeEventData.value = self.getChoicesSelectedButtonName();
                    break;
                case "checkboxes":
                    closeEventData.value = self.getChoicesButtonStates();
                    break;
                default:
                    closeEventData.value = undefined;
            }
            self.modalClose(closeEventData);
        });
    },
    modal (config, onClose) {
        if (config && config.defaultBehavior === false) this.onCreateModalBehavior = false;
        else delete this.onCreateModalBehavior;
        (0, $01897f2cfdbbb3a7$export$2e2bcd8739ae039).modal.call(this, config, onClose);
        return this;
    }
};


var $29f617e8456ef643$var$Methods = {};
Object.assign($29f617e8456ef643$var$Methods, (0, $89c1a8f64f110e28$export$2e2bcd8739ae039), (0, $b9eee60d9ab4c401$export$2e2bcd8739ae039));
var $29f617e8456ef643$export$2e2bcd8739ae039 = $29f617e8456ef643$var$Methods;


const $c21a8bce83a7363c$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c21a8bce83a7363c$var$Dialog extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create sizer        
        config.orientation = 1; // Top to bottom
        super(scene, config);
        this.type = "rexDialog";
        this.eventEmitter = $c21a8bce83a7363c$var$GetValue(config, "eventEmitter", this);
        // Add elements
        var background = $c21a8bce83a7363c$var$GetValue(config, "background", undefined);
        var title = $c21a8bce83a7363c$var$GetValue(config, "title", undefined);
        var toolbar = $c21a8bce83a7363c$var$GetValue(config, "toolbar", undefined);
        var toolbarBackground = $c21a8bce83a7363c$var$GetValue(config, "toolbarBackground", undefined);
        var leftToolbar = $c21a8bce83a7363c$var$GetValue(config, "leftToolbar", undefined);
        var leftToolbarBackground = $c21a8bce83a7363c$var$GetValue(config, "leftToolbarBackground", undefined);
        var content = $c21a8bce83a7363c$var$GetValue(config, "content", undefined);
        var description = $c21a8bce83a7363c$var$GetValue(config, "description", undefined);
        var choicesSizer;
        var choices = $c21a8bce83a7363c$var$GetValue(config, "choices", undefined);
        var choicesBackground = $c21a8bce83a7363c$var$GetValue(config, "choicesBackground", undefined);
        var actionsSizer;
        var actions = $c21a8bce83a7363c$var$GetValue(config, "actions", undefined);
        var actionsBackground = $c21a8bce83a7363c$var$GetValue(config, "actionsBackground", undefined);
        var clickConfig = $c21a8bce83a7363c$var$GetValue(config, "click", undefined);
        if (background) this.addBackground(background);
        var toolbarSizer;
        if (toolbar) toolbarSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
            groupName: "toolbar",
            background: toolbarBackground,
            buttons: toolbar,
            orientation: 0,
            space: {
                item: $c21a8bce83a7363c$var$GetValue(config, "space.toolbarItem", 0)
            },
            click: clickConfig,
            eventEmitter: this.eventEmitter
        });
        var leftToolbarSizer;
        if (leftToolbar) leftToolbarSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
            groupName: "leftToolbar",
            background: leftToolbarBackground,
            buttons: leftToolbar,
            orientation: 0,
            space: {
                item: $c21a8bce83a7363c$var$GetValue(config, "space.leftToolbarItem", 0)
            },
            click: clickConfig,
            eventEmitter: this.eventEmitter
        });
        // title or toolbar or leftToolbar
        if (title || toolbar || leftToolbar) {
            var titleExpandWidth = !!title && $c21a8bce83a7363c$var$GetValue(config, "expand.title", true);
            var titleAlign = $c21a8bce83a7363c$var$GetValue(config, "align.title", "center");
            var useOverlapSizer = // Has title, title is not exapnd-width, title align to center
            title && !titleExpandWidth && titleAlign === "center" || // No title
            !title && (toolbar || leftToolbar);
            var useSizer = !useOverlapSizer;
            var titleSizer;
            if (useSizer) titleSizer = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
                orientation: 0
            });
            else titleSizer = new (0, $4d318a74c42de65b$export$2e2bcd8739ae039)(scene);
            var titleChildExpand = useSizer ? true : {
                height: true
            };
            // Add leftToolbar
            if (leftToolbarSizer) titleSizer.add(leftToolbarSizer, {
                align: "left",
                expand: titleChildExpand
            });
            // Add title
            if (title) {
                // Add space if not expand, align to right
                if (useSizer && !titleExpandWidth && titleAlign === "right") titleSizer.addSpace();
                var padding = {
                    left: $c21a8bce83a7363c$var$GetValue(config, "space.titleLeft", 0),
                    right: $c21a8bce83a7363c$var$GetValue(config, "space.titleRight", 0)
                };
                var proportion = titleExpandWidth ? 1 : 0;
                titleSizer.add(title, {
                    align: titleAlign,
                    proportion: proportion,
                    expand: titleChildExpand,
                    padding: padding
                });
                // Add space if not expand, align to left
                if (useSizer && !titleExpandWidth && titleAlign === "left") titleSizer.addSpace();
            }
            // Add toolbar
            if (toolbarSizer) {
                // Add space if not title
                if (useSizer && !title) titleSizer.addSpace();
                titleSizer.add(toolbarSizer, {
                    align: "right",
                    expand: titleChildExpand
                });
            }
            // Add sizer to dialog
            var titleSpace = $c21a8bce83a7363c$var$GetValue(config, "space.title", 0);
            var padding;
            if (content || description || choices || actions) padding = {
                bottom: titleSpace
            };
            var proportion = $c21a8bce83a7363c$var$GetValue(config, "proportion.title", 0);
            this.add(titleSizer, {
                padding: padding,
                proportion: proportion,
                expand: true
            });
        }
        if (content) {
            var align = $c21a8bce83a7363c$var$GetValue(config, "align.content", "center");
            var contentSpace = $c21a8bce83a7363c$var$GetValue(config, "space.content", 0);
            var padding = {
                left: $c21a8bce83a7363c$var$GetValue(config, "space.contentLeft", 0),
                right: $c21a8bce83a7363c$var$GetValue(config, "space.contentRight", 0),
                bottom: description || choices || actions ? contentSpace : 0
            };
            var proportion = $c21a8bce83a7363c$var$GetValue(config, "proportion.content", 0);
            var expand = $c21a8bce83a7363c$var$GetValue(config, "expand.content", true);
            this.add(content, {
                align: align,
                padding: padding,
                proportion: proportion,
                expand: expand
            });
        }
        if (description) {
            var align = $c21a8bce83a7363c$var$GetValue(config, "align.description", "center");
            var descriptionSpace = $c21a8bce83a7363c$var$GetValue(config, "space.description", 0);
            var padding = {
                left: $c21a8bce83a7363c$var$GetValue(config, "space.descriptionLeft", 0),
                right: $c21a8bce83a7363c$var$GetValue(config, "space.descriptionRight", 0),
                bottom: choices || actions ? descriptionSpace : 0
            };
            var proportion = $c21a8bce83a7363c$var$GetValue(config, "proportion.description", 0);
            var expand = $c21a8bce83a7363c$var$GetValue(config, "expand.description", true);
            this.add(description, {
                align: align,
                padding: padding,
                proportion: proportion,
                expand: expand
            });
        }
        if (choices) {
            var choicesType = $c21a8bce83a7363c$var$GetValue(config, "choicesType", "").split("-");
            var ButtonsClass = $c21a8bce83a7363c$var$Contains(choicesType, "wrap") ? (0, $1418690eca2b4065$export$2e2bcd8739ae039) : $c21a8bce83a7363c$var$Contains(choicesType, "grid") ? (0, $3ff850ea042009c0$export$2e2bcd8739ae039) : (0, $e713f60692044763$export$2e2bcd8739ae039);
            var buttonsType = $c21a8bce83a7363c$var$Contains(choicesType, "radio") ? "radio" : $c21a8bce83a7363c$var$Contains(choicesType, "checkboxes") ? "checkboxes" : undefined;
            var space = {
                left: $c21a8bce83a7363c$var$GetValue(config, "space.choicesBackgroundLeft", 0),
                right: $c21a8bce83a7363c$var$GetValue(config, "space.choicesBackgroundRight", 0),
                top: $c21a8bce83a7363c$var$GetValue(config, "space.choicesBackgroundTop", 0),
                bottom: $c21a8bce83a7363c$var$GetValue(config, "space.choicesBackgroundBottom", 0)
            };
            var itemSpace = $c21a8bce83a7363c$var$GetValue(config, "space.choice", 0);
            if (ButtonsClass === (0, $e713f60692044763$export$2e2bcd8739ae039)) space.item = itemSpace;
            else if (ButtonsClass === (0, $1418690eca2b4065$export$2e2bcd8739ae039)) {
                space.item = itemSpace;
                space.line = $c21a8bce83a7363c$var$GetValue(config, "space.choiceLine", itemSpace);
            } else {
                space.column = $c21a8bce83a7363c$var$GetValue(config, "space.choiceColumn", itemSpace);
                space.row = $c21a8bce83a7363c$var$GetValue(config, "space.choiceRow", itemSpace);
            }
            var choicesConfig = {
                width: $c21a8bce83a7363c$var$GetValue(config, "choicesWidth", undefined),
                height: $c21a8bce83a7363c$var$GetValue(config, "choicesHeight", undefined),
                groupName: "choices",
                buttonsType: buttonsType,
                background: choicesBackground,
                buttons: choices,
                space: space,
                click: clickConfig,
                eventEmitter: this.eventEmitter,
                setValueCallback: $c21a8bce83a7363c$var$GetValue(config, "choicesSetValueCallback", undefined),
                setValueCallbackScope: $c21a8bce83a7363c$var$GetValue(config, "choicesSetValueCallbackScope", undefined)
            };
            if (ButtonsClass === (0, $e713f60692044763$export$2e2bcd8739ae039)) choicesConfig.orientation = $c21a8bce83a7363c$var$Contains(choicesType, "x") ? 0 : 1;
            choicesSizer = new ButtonsClass(scene, choicesConfig);
            var choicesSpace = $c21a8bce83a7363c$var$GetValue(config, "space.choices", 0);
            var padding = {
                left: $c21a8bce83a7363c$var$GetValue(config, "space.choicesLeft", 0),
                right: $c21a8bce83a7363c$var$GetValue(config, "space.choicesRight", 0),
                bottom: actions ? choicesSpace : 0
            };
            var align = $c21a8bce83a7363c$var$GetValue(config, "align.choices", "center");
            var proportion = $c21a8bce83a7363c$var$GetValue(config, "proportion.choices", 0);
            var expand = $c21a8bce83a7363c$var$GetValue(config, "expand.choices", true);
            this.add(choicesSizer, {
                align: align,
                padding: padding,
                proportion: proportion,
                expand: expand
            });
            this.buttonsType = buttonsType;
        }
        if (actions) {
            actionsSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
                groupName: "actions",
                background: actionsBackground,
                buttons: actions,
                orientation: 0,
                space: {
                    item: $c21a8bce83a7363c$var$GetValue(config, "space.action", 0)
                },
                expand: $c21a8bce83a7363c$var$GetValue(config, "expand.actions", false),
                align: $c21a8bce83a7363c$var$GetValue(config, "align.actions", "center"),
                click: clickConfig,
                eventEmitter: this.eventEmitter
            });
            var padding = {
                left: $c21a8bce83a7363c$var$GetValue(config, "space.actionsLeft", 0),
                right: $c21a8bce83a7363c$var$GetValue(config, "space.actionsRight", 0)
            };
            var proportion = $c21a8bce83a7363c$var$GetValue(config, "proportion.action", 0);
            this.add(actionsSizer, {
                align: "center",
                padding: padding,
                proportion: proportion,
                expand: true
            });
        }
        $c21a8bce83a7363c$var$EmitButtonEvent(this, "click");
        $c21a8bce83a7363c$var$EmitButtonEvent(this, "over");
        $c21a8bce83a7363c$var$EmitButtonEvent(this, "out");
        $c21a8bce83a7363c$var$EmitButtonEvent(this, "enable");
        $c21a8bce83a7363c$var$EmitButtonEvent(this, "disable");
        this.addChildrenMap("background", background);
        this.addChildrenMap("title", title);
        this.addChildrenMap("toolbar", toolbar);
        this.addChildrenMap("leftToolbar", leftToolbar);
        this.addChildrenMap("content", content);
        this.addChildrenMap("description", description);
        this.addChildrenMap("choices", choicesSizer ? choicesSizer.buttons : undefined);
        this.addChildrenMap("actions", actionsSizer ? actionsSizer.buttons : undefined);
        this.addChildrenMap("choicesSizer", choicesSizer);
        this.addChildrenMap("actionsSizer", actionsSizer);
        this.addChildrenMap("toolbarSizer", toolbarSizer);
        this.addChildrenMap("leftToolbarSizer", leftToolbarSizer);
    }
}
var $c21a8bce83a7363c$var$Contains = function(arr, item) {
    return arr.indexOf(item) !== -1;
};
var $c21a8bce83a7363c$var$ButtonsGroupEventNameMap = {
    actions: "action",
    choices: "choice",
    toolbar: "toolbar",
    leftToolbar: "leftToolbar"
};
var $c21a8bce83a7363c$var$EmitButtonEvent = function(dialog, postEventName) {
    dialog.on(`button.${postEventName}`, function(button, groupName, index, pointer, event) {
        if (!$c21a8bce83a7363c$var$ButtonsGroupEventNameMap.hasOwnProperty(groupName)) return;
        dialog.emit(`${$c21a8bce83a7363c$var$ButtonsGroupEventNameMap[groupName]}.${postEventName}`, button, index, pointer, event);
    });
};
Object.assign($c21a8bce83a7363c$var$Dialog.prototype, (0, $29f617e8456ef643$export$2e2bcd8739ae039));
var $c21a8bce83a7363c$export$2e2bcd8739ae039 = $c21a8bce83a7363c$var$Dialog;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("dialog", function(config) {
    var gameObject = new (0, $c21a8bce83a7363c$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Dialog", (0, $c21a8bce83a7363c$export$2e2bcd8739ae039));
var $72c93154407e386c$export$2e2bcd8739ae039 = (0, $c21a8bce83a7363c$export$2e2bcd8739ae039);




var $06c7e7c2354ea840$var$CreateLabel = function(scene, config, creators) {
    var gameObject = new (0, $aba8d16e8e1e1748$export$2e2bcd8739ae039)(scene, config, creators);
    scene.add.existing(gameObject);
    return gameObject;
};
var $06c7e7c2354ea840$export$2e2bcd8739ae039 = $06c7e7c2354ea840$var$CreateLabel;


var $ac9bb6a45f4edd1e$var$ResetDisplayContent = function(config) {
    if (config === undefined) config = {};
    $ac9bb6a45f4edd1e$var$ResetTitle.call(this, config);
    $ac9bb6a45f4edd1e$var$ResetContent.call(this, config);
    $ac9bb6a45f4edd1e$var$ResetActions.call(this, config);
    $ac9bb6a45f4edd1e$var$ResetChoices.call(this, config);
    return this;
};
var $ac9bb6a45f4edd1e$var$ResetTitle = function(config) {
    var title = this.childrenMap.title;
    title.resetDisplayContent(config.title);
};
var $ac9bb6a45f4edd1e$var$ResetContent = function(config) {
    var content = this.childrenMap.content;
    if (content.resetDisplayContent) // Label
    content.resetDisplayContent(config.content);
    else {
        // TextArea
        var text = config.content || "";
        content.setText(text);
    }
};
var $ac9bb6a45f4edd1e$var$ResetActions = function(config) {
    var actionButtons = this.childrenMap.actions;
    if (!actionButtons) return;
    var buttonContentArray = config.buttons;
    if (!buttonContentArray) {
        var buttonA = actionButtons[0];
        if (buttonA) buttonA.resetDisplayContent(config.buttonA);
        var buttonB = actionButtons[1];
        if (buttonB) buttonB.resetDisplayContent(config.buttonB);
    } else {
        var scene = this.scene;
        var defaultActionConfig = this.defaultActionConfig;
        var defaultActionButtonCreator = this.defaultActionButtonCreator;
        for(var i = 0, cnt = buttonContentArray.length; i < cnt; i++){
            var buttonContent = buttonContentArray[i];
            var button = actionButtons[i];
            if (!button) {
                button = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, defaultActionConfig, defaultActionButtonCreator);
                this.addAction(button);
            }
            button.show().resetDisplayContent(buttonContent);
        }
        this.buttonMode = buttonContentArray.length;
        for(var i = buttonContentArray.length, cnt = actionButtons.length; i < cnt; i++)actionButtons[i].hide();
    }
};
var $ac9bb6a45f4edd1e$var$ResetChoices = function(config) {
    var choices = this.childrenMap.choices;
    if (!choices) return;
    var buttonContentArray = config.choices;
    if (!buttonContentArray) buttonContentArray = [];
    var scene = this.scene;
    var defaultChoiceConfig = this.defaultChoiceConfig;
    var defaultActionButtonCreator = this.defaultActionButtonCreator;
    for(var i = 0, cnt = buttonContentArray.length; i < cnt; i++){
        var buttonContent = buttonContentArray[i];
        if (typeof buttonContent === "string") buttonContent = {
            text: buttonContent
        };
        var button = choices[i];
        if (!button) {
            button = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, defaultChoiceConfig, defaultActionButtonCreator);
            this.addChoice(button);
        }
        button.show().resetDisplayContent(buttonContent);
        var optionValue;
        if (buttonContent.hasOwnProperty("value")) optionValue = buttonContent.value;
        else optionValue = buttonContent.text;
        button.setName(optionValue);
    }
    for(var i = buttonContentArray.length, cnt = choices.length; i < cnt; i++)choices[i].hide();
};
var $ac9bb6a45f4edd1e$export$2e2bcd8739ae039 = $ac9bb6a45f4edd1e$var$ResetDisplayContent;




var $2941a784efa2e32a$var$Modal = function(config, onClose) {
    if ((0, $761920aac251583f$export$2e2bcd8739ae039)(config)) {
        onClose = config;
        config = undefined;
    }
    if (config === undefined) config = {};
    var zeroButtonMode = this.buttonMode === 0;
    if (!config.hasOwnProperty("anyTouchClose")) config.anyTouchClose = zeroButtonMode;
    if (!config.hasOwnProperty("manualClose")) config.manualClose = !zeroButtonMode;
    (0, $01897f2cfdbbb3a7$export$2e2bcd8739ae039).modal.call(this, config, onClose);
    return this;
};
var $2941a784efa2e32a$export$2e2bcd8739ae039 = $2941a784efa2e32a$var$Modal;


var $bb3bf2853f9e2a94$var$Methods = {
    resetDisplayContent: (0, $ac9bb6a45f4edd1e$export$2e2bcd8739ae039),
    modal: (0, $2941a784efa2e32a$export$2e2bcd8739ae039)
};
var $bb3bf2853f9e2a94$export$2e2bcd8739ae039 = $bb3bf2853f9e2a94$var$Methods;


var $f59e0561d9a5961e$var$OnPointerOverCallback = function(button) {
    if (button.setHoverState) button.setHoverState(true);
};
var $f59e0561d9a5961e$var$OnPointerOutCallback = function(button) {
    if (button.setHoverState) button.setHoverState(false);
};
var $f59e0561d9a5961e$var$OnChoiceButtonStateChange = function(button, groupName, index, value) {
    if (button.setActiveState) button.setActiveState(value);
};
var $f59e0561d9a5961e$var$OnButtonEnable = function(button) {
    if (button.setDisableState) button.setDisableState(false);
};
var $f59e0561d9a5961e$var$OnButtonDisable = function(button) {
    if (button.setDisableState) button.setDisableState(true);
};
var $f59e0561d9a5961e$var$RegisterEvents = function() {
    this.on("button.over", $f59e0561d9a5961e$var$OnPointerOverCallback).on("button.out", $f59e0561d9a5961e$var$OnPointerOutCallback).on("button.enable", $f59e0561d9a5961e$var$OnButtonEnable).on("button.disable", $f59e0561d9a5961e$var$OnButtonDisable).on("button.statechange", $f59e0561d9a5961e$var$OnChoiceButtonStateChange);
};
var $f59e0561d9a5961e$export$2e2bcd8739ae039 = $f59e0561d9a5961e$var$RegisterEvents;










var $c4c49e166ab625a6$export$2e2bcd8739ae039 = {
    v: 0,
    vertical: 0,
    y: 0,
    h: 1,
    horizontal: 1,
    x: 1
};


const $391df8fa33f776dd$var$GetValue = Phaser.Utils.Objects.GetValue;
var $391df8fa33f776dd$var$GetScrollMode = function(config, key) {
    var scrollMode = $391df8fa33f776dd$var$GetValue(config, "scrollMode", 0); // Vertical
    if (typeof scrollMode === "string") scrollMode = (0, $c4c49e166ab625a6$export$2e2bcd8739ae039)[scrollMode];
    return scrollMode;
};
var $391df8fa33f776dd$export$2e2bcd8739ae039 = $391df8fa33f776dd$var$GetScrollMode;








const $41622126d2383ebc$var$Percent = Phaser.Math.Percent;
var $41622126d2383ebc$var$PositionToPercent = function(startPoint, endPoint, currentPoint) {
    var value;
    if (startPoint.y === endPoint.y) value = $41622126d2383ebc$var$Percent(currentPoint.x, startPoint.x, endPoint.x);
    else if (startPoint.x === endPoint.x) value = $41622126d2383ebc$var$Percent(currentPoint.y, startPoint.y, endPoint.y);
    return value;
};
var $41622126d2383ebc$export$2e2bcd8739ae039 = $41622126d2383ebc$var$PositionToPercent;


var $9e0ac6d8235ddc7e$var$OnDragThumb = function(pointer, dragX, dragY) {
    if (!this.enable) return;
    $9e0ac6d8235ddc7e$var$tmpPoint.x = dragX;
    $9e0ac6d8235ddc7e$var$tmpPoint.y = dragY;
    var startPoint, endPoint;
    if (!this.reverseAxis) {
        startPoint = this.getStartPoint();
        endPoint = this.getEndPoint();
    } else {
        startPoint = this.getEndPoint();
        endPoint = this.getStartPoint();
    }
    this.value = (0, $41622126d2383ebc$export$2e2bcd8739ae039)(startPoint, endPoint, $9e0ac6d8235ddc7e$var$tmpPoint);
};
var $9e0ac6d8235ddc7e$var$tmpPoint = {};
var $9e0ac6d8235ddc7e$export$2e2bcd8739ae039 = $9e0ac6d8235ddc7e$var$OnDragThumb;



var $b1c99122f7bfc0e5$var$OnTouchTrack = function(pointer, localX, localY) {
    if (!this.enable) return;
    if (!pointer.isDown) return;
    $b1c99122f7bfc0e5$var$tmpPoint.x = pointer.worldX;
    $b1c99122f7bfc0e5$var$tmpPoint.y = pointer.worldY;
    var startPoint, endPoint;
    if (!this.reverseAxis) {
        startPoint = this.getStartPoint();
        endPoint = this.getEndPoint();
    } else {
        startPoint = this.getEndPoint();
        endPoint = this.getStartPoint();
    }
    var value = (0, $41622126d2383ebc$export$2e2bcd8739ae039)(startPoint, endPoint, $b1c99122f7bfc0e5$var$tmpPoint);
    this.stopEaseValue();
    if (this.easeValueDuration === 0 || Math.abs(this.value - value) < 0.1) this.value = value;
    else this.easeValueTo(value);
};
var $b1c99122f7bfc0e5$var$tmpPoint = {};
var $b1c99122f7bfc0e5$export$2e2bcd8739ae039 = $b1c99122f7bfc0e5$var$OnTouchTrack;



var $8e5a95583f190967$var$GetThumbAlignPoint = function(align, out) {
    if (out === undefined) out = $8e5a95583f190967$var$tmpPoint;
    var thumb = this.childrenMap.thumb;
    var currentX = thumb.x;
    var currentY = thumb.y;
    (0, $b7e28befb839484c$export$2e2bcd8739ae039)(thumb, this.innerLeft, this.innerTop, this.innerWidth, this.innerHeight, align);
    out.x = thumb.x;
    out.y = thumb.y;
    thumb.x = currentX;
    thumb.y = currentY;
    return out;
};
var $8e5a95583f190967$var$tmpPoint = {};
var $8e5a95583f190967$export$2e2bcd8739ae039 = $8e5a95583f190967$var$GetThumbAlignPoint;


const $62c9b6c8bce642b4$var$AlignLeft = Phaser.Display.Align.LEFT_CENTER;
const $62c9b6c8bce642b4$var$AlignTop = Phaser.Display.Align.TOP_CENTER;
var $62c9b6c8bce642b4$var$GetStartPoint = function(out) {
    if (out === undefined) out = $62c9b6c8bce642b4$var$tmpPoint;
    if (this.childrenMap.thumb) {
        var align = this.orientation === 0 ? $62c9b6c8bce642b4$var$AlignLeft : $62c9b6c8bce642b4$var$AlignTop;
        (0, $8e5a95583f190967$export$2e2bcd8739ae039).call(this, align, out);
    } else if (this.orientation === 0) {
        out.x = this.innerLeft + 1; // Add 1 pixel margin
        out.y = this.centerY;
    } else {
        out.x = this.centerX;
        out.y = this.innerTop + 1; // Add 1 pixel margin
    }
    return out;
};
var $62c9b6c8bce642b4$var$tmpPoint = {};
var $62c9b6c8bce642b4$export$2e2bcd8739ae039 = $62c9b6c8bce642b4$var$GetStartPoint;



const $806756b00a6491d7$var$AlignRight = Phaser.Display.Align.RIGHT_CENTER;
const $806756b00a6491d7$var$AlignBottom = Phaser.Display.Align.BOTTOM_CENTER;
var $806756b00a6491d7$var$GetEndoint = function(out) {
    if (out === undefined) out = $806756b00a6491d7$var$tmpPoint;
    if (this.childrenMap.thumb) {
        var align = this.orientation === 0 ? $806756b00a6491d7$var$AlignRight : $806756b00a6491d7$var$AlignBottom;
        (0, $8e5a95583f190967$export$2e2bcd8739ae039).call(this, align, out);
    } else if (this.orientation === 0) {
        out.x = this.innerRight - 1; // Add 1 pixel margin
        out.y = this.centerY;
    } else {
        out.x = this.centerX;
        out.y = this.innerBottom - 1; // Add 1 pixel margin
    }
    return out;
};
var $806756b00a6491d7$var$tmpPoint = {};
var $806756b00a6491d7$export$2e2bcd8739ae039 = $806756b00a6491d7$var$GetEndoint;


const $97f1fc34e4969ef2$var$Linear = Phaser.Math.Linear;
var $97f1fc34e4969ef2$var$PercentToPosition = function(t, startPoint, endPoint, out) {
    if (out === undefined) out = $97f1fc34e4969ef2$var$tmpOut;
    out.x = $97f1fc34e4969ef2$var$Linear(startPoint.x, endPoint.x, t);
    out.y = $97f1fc34e4969ef2$var$Linear(startPoint.y, endPoint.y, t);
    return out;
};
var $97f1fc34e4969ef2$var$tmpOut = {};
var $97f1fc34e4969ef2$export$2e2bcd8739ae039 = $97f1fc34e4969ef2$var$PercentToPosition;


var $33020d3a5b603abf$var$UpdateThumb = function(t) {
    var thumb = this.childrenMap.thumb;
    if (thumb === undefined) return this;
    if (t === undefined) t = this.value;
    var startPoint, endPoint;
    if (!this.reverseAxis) {
        startPoint = this.getStartPoint();
        endPoint = this.getEndPoint();
    } else {
        startPoint = this.getEndPoint();
        endPoint = this.getStartPoint();
    }
    (0, $97f1fc34e4969ef2$export$2e2bcd8739ae039)(t, startPoint, endPoint, thumb);
    this.resetChildPositionState(thumb);
    return this;
};
var $33020d3a5b603abf$export$2e2bcd8739ae039 = $33020d3a5b603abf$var$UpdateThumb;





const $4cb007335aa009df$var$AlignLeft = Phaser.Display.Align.LEFT_CENTER;
const $4cb007335aa009df$var$AlignTop = Phaser.Display.Align.TOP_CENTER;
const $4cb007335aa009df$var$AlignRight = Phaser.Display.Align.RIGHT_CENTER;
const $4cb007335aa009df$var$AlignBottom = Phaser.Display.Align.BOTTOM_CENTER;
var $4cb007335aa009df$var$UpdateIndicator = function(t) {
    var indicator = this.childrenMap.indicator;
    if (indicator === undefined) return this;
    if (t === undefined) t = this.value;
    var reverseAxis = this.reverseAxis;
    var newWidth, newHeight;
    var thumb = this.childrenMap.thumb;
    if (thumb) {
        if (this.orientation === 0) {
            var thumbWidth = (0, $3d5f5580139892aa$export$a60660135e2d0135)(thumb);
            if (!reverseAxis) {
                var thumbLeft = thumb.x - thumbWidth * thumb.originX;
                var thumbRight = thumbLeft + thumbWidth;
                newWidth = thumbRight - this.left;
            } else {
                var thumbLeft = thumb.x - thumbWidth * thumb.originX;
                newWidth = this.right - thumbLeft;
            }
        } else {
            var thumbHeight = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(thumb);
            if (!reverseAxis) {
                var thumbTop = thumb.y - thumbHeight * thumb.originY;
                var thumbBottom = thumbTop + thumbHeight;
                newHeight = thumbBottom - this.top;
            } else {
                var thumbTop = thumb.y - thumbHeight * thumb.originY;
                newHeight = this.bottom - thumbTop;
            }
        }
    } else if (this.orientation === 0) newWidth = this.width * t;
    else newHeight = this.height * t;
    (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(indicator, newWidth, newHeight);
    var align;
    if (!reverseAxis) align = this.orientation === 0 ? $4cb007335aa009df$var$AlignLeft : $4cb007335aa009df$var$AlignTop;
    else align = this.orientation === 0 ? $4cb007335aa009df$var$AlignRight : $4cb007335aa009df$var$AlignBottom;
    (0, $2d796d344b5ce591$export$2e2bcd8739ae039)(indicator, this, align);
    this.resetChildPositionState(indicator);
};
var $4cb007335aa009df$export$2e2bcd8739ae039 = $4cb007335aa009df$var$UpdateIndicator;


const $acd4b431e3164bd7$var$GetValue = Phaser.Utils.Objects.GetValue;
const $acd4b431e3164bd7$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $acd4b431e3164bd7$var$Clamp = Phaser.Math.Clamp;
const $acd4b431e3164bd7$var$SnapTo = Phaser.Math.Snap.To;
class $acd4b431e3164bd7$var$Slider extends (0, $3b85503cb0648427$export$2e2bcd8739ae039)((0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexSlider";
        this.bootProgressBase(config);
        this.reverseAxis = $acd4b431e3164bd7$var$GetValue(config, "reverseAxis", false);
        // Add elements
        var background = $acd4b431e3164bd7$var$GetValue(config, "background", undefined);
        var track = $acd4b431e3164bd7$var$GetValue(config, "track", undefined);
        var indicator = $acd4b431e3164bd7$var$GetValue(config, "indicator", undefined);
        var thumb = $acd4b431e3164bd7$var$GetValue(config, "thumb", undefined);
        if (background) {
            if ($acd4b431e3164bd7$var$IsPlainObject(background)) background = (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, background);
            this.addBackground(background);
        }
        if (track) {
            if ($acd4b431e3164bd7$var$IsPlainObject(track)) track = (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, track);
            this.add(track, {
                proportion: 1,
                expand: true,
                minWidth: this.orientation === 0 ? 0 : undefined,
                minHeight: this.orientation === 1 ? 0 : undefined
            });
        }
        if (indicator) {
            if ($acd4b431e3164bd7$var$IsPlainObject(indicator)) indicator = (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, indicator);
            this.pin(indicator); // Put into container but not layout it
        }
        if (thumb) {
            if ($acd4b431e3164bd7$var$IsPlainObject(thumb)) thumb = (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, thumb);
            this.pin(thumb); // Put into container but not layout it
        }
        // Input
        var inputMode = $acd4b431e3164bd7$var$GetValue(config, "input", 0);
        if (typeof inputMode === "string") inputMode = $acd4b431e3164bd7$var$INPUTMODE[inputMode];
        switch(inputMode){
            case 0:
                if (thumb) {
                    thumb.setInteractive();
                    this.scene.input.setDraggable(thumb);
                    thumb.on("drag", (0, $9e0ac6d8235ddc7e$export$2e2bcd8739ae039), this).on("dragstart", function(pointer) {
                        this.eventEmitter.emit("inputstart", pointer);
                    }, this).on("dragend", function(pointer) {
                        this.eventEmitter.emit("inputend", pointer);
                    }, this);
                }
                break;
            case 1:
                this.on("pointerdown", (0, $b1c99122f7bfc0e5$export$2e2bcd8739ae039), this).on("pointermove", (0, $b1c99122f7bfc0e5$export$2e2bcd8739ae039), this).on("pointerdown", function(pointer) {
                    this.eventEmitter.emit("inputstart", pointer);
                }, this).on("pointerup", function(pointer) {
                    this.eventEmitter.emit("inputend", pointer);
                }, this).on("pointerover", function(pointer) {
                    if (pointer.isDown) this.eventEmitter.emit("inputstart", pointer);
                }, this).on("pointerout", function(pointer) {
                    if (pointer.isDown) this.eventEmitter.emit("inputend", pointer);
                }, this).setInteractive();
                break;
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("track", track);
        this.addChildrenMap("indicator", indicator);
        this.addChildrenMap("thumb", thumb);
        this.setEnable($acd4b431e3164bd7$var$GetValue(config, "enable", undefined));
        this.setGap($acd4b431e3164bd7$var$GetValue(config, "gap", undefined));
        this.setValue($acd4b431e3164bd7$var$GetValue(config, "value", 0), $acd4b431e3164bd7$var$GetValue(config, "min", undefined), $acd4b431e3164bd7$var$GetValue(config, "max", undefined));
    }
    setEnable(enable) {
        if (enable === undefined) enable = true;
        this.enable = enable;
        return this;
    }
    setGap(gap, min, max) {
        if (gap && min !== undefined) gap = gap / (max - min);
        this.gap = gap;
        return this;
    }
    // Override
    get value() {
        return this._value;
    }
    // Override
    set value(value) {
        if (this.gap !== undefined) value = $acd4b431e3164bd7$var$SnapTo(value, this.gap);
        var oldValue = this._value;
        this._value = $acd4b431e3164bd7$var$Clamp(value, 0, 1);
        if (oldValue !== this._value) {
            this.updateThumb(this._value);
            this.updateIndicator(this._value);
            this.eventEmitter.emit("valuechange", this._value, oldValue, this.eventEmitter);
        }
    }
    runLayout(parent, newWidth, newHeight) {
        // Skip hidden or !dirty sizer
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        this.updateThumb();
        this.updateIndicator();
        return this;
    }
}
const $acd4b431e3164bd7$var$INPUTMODE = {
    pan: 0,
    drag: 0,
    click: 1,
    none: -1
};
var $acd4b431e3164bd7$var$methods = {
    getStartPoint: (0, $62c9b6c8bce642b4$export$2e2bcd8739ae039),
    getEndPoint: (0, $806756b00a6491d7$export$2e2bcd8739ae039),
    updateThumb: (0, $33020d3a5b603abf$export$2e2bcd8739ae039),
    updateIndicator: (0, $4cb007335aa009df$export$2e2bcd8739ae039)
};
Object.assign($acd4b431e3164bd7$var$Slider.prototype, $acd4b431e3164bd7$var$methods);
var $acd4b431e3164bd7$export$2e2bcd8739ae039 = $acd4b431e3164bd7$var$Slider;



const $e0992a47ab11a94a$var$GetValue = Phaser.Utils.Objects.GetValue;
class $e0992a47ab11a94a$var$ScrollBar extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexScrollBar";
        // Add elements
        var background = $e0992a47ab11a94a$var$GetValue(config, "background", undefined);
        var buttonsConfig = $e0992a47ab11a94a$var$GetValue(config, "buttons", undefined);
        var button0 = $e0992a47ab11a94a$var$GetValue(buttonsConfig, "top", $e0992a47ab11a94a$var$GetValue(buttonsConfig, "left", undefined));
        var button1 = $e0992a47ab11a94a$var$GetValue(buttonsConfig, "bottom", $e0992a47ab11a94a$var$GetValue(buttonsConfig, "right", undefined));
        var slider, sliderConfig = $e0992a47ab11a94a$var$GetValue(config, "slider", undefined);
        if (background) this.addBackground(background);
        if (button0) {
            this.add(button0);
            var inTouching = new (0, $213484a77f0b6ac4$export$2e2bcd8739ae039)(button0);
            inTouching.on("intouch", function() {
                if (!this.enable) return;
                var step = !slider.reverseAxis ? -this.scrollStep : this.scrollStep;
                this.value += step;
            }, this);
        }
        if (sliderConfig) {
            sliderConfig.orientation = this.orientation;
            sliderConfig.eventEmitter = this;
            sliderConfig.value = null;
            var proportion;
            if (this.orientation === 0) {
                var sliderWidth = $e0992a47ab11a94a$var$GetValue(sliderConfig, "width", undefined);
                proportion = sliderWidth === undefined ? 1 : 0;
            } else {
                var sliderHeight = $e0992a47ab11a94a$var$GetValue(sliderConfig, "height", undefined);
                proportion = sliderHeight === undefined ? 1 : 0;
            }
            slider = new (0, $acd4b431e3164bd7$export$2e2bcd8739ae039)(scene, sliderConfig);
            scene.add.existing(slider);
            this.add(slider, {
                proportion: proportion
            });
        }
        if (button1) {
            this.add(button1);
            var inTouching = new (0, $213484a77f0b6ac4$export$2e2bcd8739ae039)(button1);
            inTouching.on("intouch", function() {
                if (!this.enable) return;
                var step = !slider.reverseAxis ? this.scrollStep : -this.scrollStep;
                this.value += step;
            }, this);
        }
        var buttons = [
            button0,
            button1
        ];
        this.addChildrenMap("background", background);
        this.addChildrenMap("slider", slider);
        this.addChildrenMap("buttons", buttons);
        var callback = $e0992a47ab11a94a$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $e0992a47ab11a94a$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        this.setEnable($e0992a47ab11a94a$var$GetValue(config, "enable", undefined));
        this.setValue($e0992a47ab11a94a$var$GetValue(config, "value", 0));
        this.setScrollStep($e0992a47ab11a94a$var$GetValue(buttonsConfig, "step", 0.01));
    }
    setScrollStep(value) {
        this.scrollStep = value;
        return this;
    }
    get enable() {
        if (this.childrenMap.slider) return this.childrenMap.slider.enable;
        else return false;
    }
    set enable(value) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEnable(value);
    }
    setEnable(enable) {
        if (enable === undefined) enable = true;
        this.enable = enable;
        return this;
    }
    get value() {
        if (this.childrenMap.slider) return this.childrenMap.slider.value;
        else return 0;
    }
    set value(value) {
        if (!this.childrenMap.slider) return;
        this.childrenMap.slider.value = value;
    }
    setValue(value, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.setValue(value, min, max);
        return this;
    }
    addValue(inc, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.addValue(inc, min, max);
        return this;
    }
    getValue(min, max) {
        if (this.childrenMap.slider) return this.childrenMap.slider.getValue(min, max);
        else return 0;
    }
    easeValueTo(value, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.easeValueTo(value, min, max);
        return this;
    }
    stopEaseValue() {
        if (this.childrenMap.slider) this.childrenMap.slider.stopEaseValue();
        return this;
    }
    setEaseValueDuration(duration) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEaseValueDuration(duration);
        return this;
    }
    setEaseValueFunction(ease) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEaseValueFunction(ease);
        return this;
    }
}
var $e0992a47ab11a94a$export$2e2bcd8739ae039 = $e0992a47ab11a94a$var$ScrollBar;



class $3d95d827f9b64db8$var$Slider extends (0, $e0992a47ab11a94a$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var sliderConfig = (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(config);
        config = {
            slider: sliderConfig
        };
        // Move orientation parameter from sliderConfig to config
        config.orientation = sliderConfig.orientation;
        delete sliderConfig.orientation;
        // Move background parameter from sliderConfig to config
        config.background = sliderConfig.background;
        delete sliderConfig.background;
        // Move buttons parameter from sliderConfig to config
        config.buttons = sliderConfig.buttons;
        delete sliderConfig.buttons;
        super(scene, config);
        var slider = this.childrenMap.slider;
        this.addChildrenMap("track", slider.childrenMap.track);
        this.addChildrenMap("indicator", slider.childrenMap.indicator);
        this.addChildrenMap("thumb", slider.childrenMap.thumb);
    }
}
var $3d95d827f9b64db8$export$2e2bcd8739ae039 = $3d95d827f9b64db8$var$Slider;




class $2203702ff2785c1a$var$State extends (0, $57ebe48317eef8b7$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(config);
        this.parent = parent;
        this.init();
    }
    init() {
        this.start("IDLE");
    }
    // IDLE -> DRAGBEGIN|DRAG
    next_IDLE() {
        var nextState, parent = this.parent, dragState = parent.dragState;
        if (dragState.isDown) nextState = parent.dragThreshold === 0 ? "DRAG" : "DRAGBEGIN";
        return nextState;
    }
    update_IDLE(time, delta) {
        this.next();
    }
    // IDLE
    // DRAGBEGIN -> DRAG|IDLE
    next_DRAGBEGIN() {
        var nextState, parent = this.parent, dragState = parent.dragState;
        if (dragState.isDown) nextState = dragState.pointer.getDistance() >= parent.dragThreshold ? "DRAG" : "DRAGBEGIN";
        else nextState = "IDLE";
        return nextState;
    }
    update_DRAGBEGIN(time, delta) {
        this.next();
    }
    // DRAGBEGIN
    // DRAG -> BACK|SLIDE|IDLE
    next_DRAG() {
        var nextState, parent = this.parent, dragState = parent.dragState;
        if (dragState.isUp) {
            if (parent.outOfBounds) nextState = "BACK";
            else if (parent.slidingEnable) nextState = "SLIDE";
            else nextState = "IDLE";
        }
        return nextState;
    }
    update_DRAG(time, delta) {
        var parent = this.parent, dragState = parent.dragState;
        if (dragState.justMoved) parent.dragging();
        this.next();
    }
    enter_DRAG() {
        this.parent.onDragStart();
    }
    exit_DRAG() {
        this.parent.onDragEnd();
    }
    // DRAG    
    // SLIDE -> DRAG|IDLE
    next_SLIDE() {
        var nextState, parent = this.parent, dragState = parent.dragState;
        if (dragState.isDown) nextState = "DRAG";
        else if (!parent.isSliding) nextState = "IDLE";
        return nextState;
    }
    enter_SLIDE() {
        this.parent.onSliding();
    }
    exit_SLIDE() {
        this.parent.stop();
    }
    update_SLIDE(time, delta) {
        this.parent.sliding(time, delta);
        this.next();
    }
    // SLIDE    
    // BACK -> DRAG|IDLE
    next_BACK() {
        var nextState, parent = this.parent, dragState = parent.dragState;
        if (dragState.isDown) nextState = "DRAG";
        else if (!parent.isPullBack) nextState = "IDLE";
        return nextState;
    }
    enter_BACK() {
        this.parent.onPullBack();
    }
    exit_BACK() {
        this.parent.stop();
    }
    update_BACK(time, delta) {
        this.parent.pullBack(time, delta);
        this.next();
    }
}
var $2203702ff2785c1a$export$2e2bcd8739ae039 = $2203702ff2785c1a$var$State;




const $f727c19302a75041$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f727c19302a75041$var$DistanceBetween = Phaser.Math.Distance.Between;
class $f727c19302a75041$var$DragSpeed extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this._enable = undefined;
        gameObject.setInteractive($f727c19302a75041$var$GetValue(config, "inputConfig", undefined));
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.pointer = undefined;
        this.isInTouched = false;
        this.holdStartTime = undefined;
        this.x = undefined;
        this.y = undefined;
        this.preX = undefined;
        this.preY = undefined;
        this.localX = undefined;
        this.localY = undefined;
        this.justMoved = false;
        this.setEnable($f727c19302a75041$var$GetValue(o, "enable", true));
        this.holdThreshold = $f727c19302a75041$var$GetValue(o, "holdThreshold", 50); // ms
        this.pointerOutReleaseEnable = $f727c19302a75041$var$GetValue(o, "pointerOutRelease", true);
        return this;
    }
    boot() {
        // Drag start only when pointer down
        this.parent.on("pointerdown", this.onPointIn, this);
        // this.parent.on('pointerover', this.onPointIn, this);
        this.parent.on("pointerup", this.onPointOut, this);
        if (this.pointerOutReleaseEnable) this.parent.on("pointerout", this.onPointOut, this);
        this.parent.on("pointermove", this.onPointerMove, this);
        this.scene.sys.events.on("preupdate", this.preupdate, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // GameObject events will be removed when this gameObject destroyed 
        // this.parent.off('pointerdown', this.onPointIn, this);
        // this.parent.off('pointerup', this.onPointOut, this);
        // this.parent.off('pointerout', this.onPointOut, this);
        // this.parent.off('pointermove', this.onPointerMove, this);
        this.scene.sys.events.off("preupdate", this.preupdate, this);
        this.pointer = undefined;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) {
            this.isInTouched = false;
            this.pointer = undefined;
        }
        this._enable = e;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    setPointerOutReleaseEnable(enable) {
        if (enable === undefined) enable = true;
        this.pointerOutReleaseEnable = enable;
        return this;
    }
    get isDown() {
        return this.pointer && this.pointer.isDown;
    }
    get isUp() {
        return !this.isDown;
    }
    get dx() {
        return this.x - this.preX;
    }
    get dy() {
        return this.y - this.preY;
    }
    get dt() {
        var delta = (0, $faac1631b82f4951$export$2e2bcd8739ae039)(this.scene);
        return delta;
    }
    get speed() {
        if (this.x === this.preX && this.y === this.preY) return 0;
        var d = $f727c19302a75041$var$DistanceBetween(this.preX, this.preY, this.x, this.y);
        var speed = d / (this.dt * 0.001);
        return speed;
    }
    get speedX() {
        return this.dx / (this.dt * 0.001);
    }
    get speedY() {
        return this.dy / (this.dt * 0.001);
    }
    // internal
    onPointIn(pointer, localX, localY) {
        if (!this.enable || !pointer.isDown || this.pointer !== undefined) return;
        this.pointer = pointer;
        this.localX = localX;
        this.localY = localY;
    }
    onPointOut(pointer) {
        if (!this.enable || this.pointer !== pointer) return;
        this.pointer = undefined;
    }
    onPointerMove(pointer, localX, localY) {
        if (!this.enable || !pointer.isDown || this.pointer !== pointer) return;
        this.localX = localX;
        this.localY = localY;
    }
    preupdate(time, delta) {
        if (!this.enable) return;
        var pointer = this.pointer;
        this.justMoved = false;
        if (pointer && !this.isInTouched) {
            // Touch start
            this.x = pointer.worldX;
            this.y = pointer.worldY;
            this.preX = pointer.worldX;
            this.preY = pointer.worldY;
            this.isInTouched = true;
            this.holdStartTime = undefined;
            this.emit("touchstart", pointer, this.localX, this.localY);
        } else if (pointer && this.isInTouched) {
            // In touch
            if (this.x === pointer.x && this.y === pointer.y) {
                // Hold
                if (this.holdStartTime === undefined) this.holdStartTime = time;
                else if (time - this.holdStartTime > this.holdThreshold) {
                    this.preX = this.x;
                    this.preY = this.y;
                }
            } else {
                // Move
                this.preX = this.x;
                this.preY = this.y;
                this.x = pointer.worldX;
                this.y = pointer.worldY;
                this.holdStartTime = undefined;
                this.justMoved = true;
                this.emit("touchmove", pointer, this.localX, this.localY);
            }
        } else if (!pointer && this.isInTouched) {
            // Touch end
            this.isInTouched = false;
            this.holdStartTime = undefined;
            this.emit("touchend", pointer);
        }
    }
}
var $f727c19302a75041$export$2e2bcd8739ae039 = $f727c19302a75041$var$DragSpeed;


var $1a3e39d5486ab811$export$2e2bcd8739ae039 = (0, $f727c19302a75041$export$2e2bcd8739ae039);


const $f7c5e09cc8baa364$var$GetValue = Phaser.Utils.Objects.GetValue;
class $f7c5e09cc8baa364$var$Movement {
    constructor(config){
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        this.setValue($f7c5e09cc8baa364$var$GetValue(o, "value", 0));
        this.setSpeed($f7c5e09cc8baa364$var$GetValue(o, "speed", 0));
        this.setAcceleration($f7c5e09cc8baa364$var$GetValue(o, "acceleration", 0));
        return this;
    }
    reset() {
        this.setValue(0);
        this.setSpeed(0);
        this.setAcceleration(0);
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    setSpeed(speed) {
        // speed == 0 : stop
        // speed  > 0 : move
        this.speed = speed;
        return this;
    }
    setAcceleration(acc) {
        // acc == 0 : constant speed
        // acc  > 0 : acceleration
        // acc  < 0 : deceleration
        this.acceleration = acc;
        return this;
    }
    updateSpeed(delta) {
        // delta in sec
        if (this.acceleration !== 0) {
            this.speed += this.acceleration * delta;
            if (this.speed < 0) this.speed = 0;
        }
        return this;
    }
    getDeltaValue(delta) {
        // delta in sec
        this.updateSpeed(delta);
        if (this.speed <= 0) return 0;
        return this.speed * delta;
    }
    update(delta) {
        // delta in sec
        this.updateSpeed(delta);
        if (this.speed > 0) this.value += this.getDeltaValue(delta);
        return this;
    }
    get isMoving() {
        return this.speed > 0;
    }
}
var $f7c5e09cc8baa364$export$2e2bcd8739ae039 = $f7c5e09cc8baa364$var$Movement;


class $d47f0c7710b9fb69$var$SlowDown {
    constructor(){
        this.value;
        this.dir; // true:+, false:-
        this.movement = new (0, $f7c5e09cc8baa364$export$2e2bcd8739ae039)();
    }
    init(start, dir, speed, dec, end) {
        this.value = start;
        this.end = end;
        if (end !== undefined) this.dir = start < end;
        else this.dir = dir;
        this.movement.setSpeed(speed).setAcceleration(-dec);
        return this;
    }
    stop() {
        this.movement.reset();
    }
    update(delta) {
        // delta in sec
        var d = this.movement.getDeltaValue(delta);
        if (!this.dir) d = -d;
        if (this.end === undefined) this.value += d;
        else if (d === 0) this.value = this.end;
        else {
            this.value += d;
            if (this.dir) {
                if (this.value > this.end) this.value = this.end;
            } else if (this.value < this.end) this.value = this.end;
        }
        return this;
    }
    get isMoving() {
        return this.movement.isMoving;
    }
}
var $d47f0c7710b9fb69$export$2e2bcd8739ae039 = $d47f0c7710b9fb69$var$SlowDown;


const $5cc1b98d00b3dc74$var$GetValue = Phaser.Utils.Objects.GetValue;
const $5cc1b98d00b3dc74$var$Clamp = Phaser.Math.Clamp;
class $5cc1b98d00b3dc74$var$Scroller extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        var enable = $5cc1b98d00b3dc74$var$GetValue(config, "enable", true);
        this._state = new (0, $2203702ff2785c1a$export$2e2bcd8739ae039)(this, {
            enable: enable,
            eventEmitter: false
        });
        var drapSpeedConfig = {
            inputConfig: $5cc1b98d00b3dc74$var$GetValue(config, "inputConfig", undefined),
            enable: enable,
            pointerOutRelease: $5cc1b98d00b3dc74$var$GetValue(config, "pointerOutRelease", true),
            eventEmitter: false
        };
        this.dragState = new (0, $1a3e39d5486ab811$export$2e2bcd8739ae039)(gameObject, drapSpeedConfig);
        this._enable = undefined;
        this._value = undefined;
        this._slowDown = new (0, $d47f0c7710b9fb69$export$2e2bcd8739ae039)();
        var callback = $5cc1b98d00b3dc74$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $5cc1b98d00b3dc74$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        callback = $5cc1b98d00b3dc74$var$GetValue(config, "overmaxCallback", null);
        if (callback !== null) {
            var scope = $5cc1b98d00b3dc74$var$GetValue(config, "overmaxCallbackScope", undefined);
            this.on("overmax", callback, scope);
        }
        callback = $5cc1b98d00b3dc74$var$GetValue(config, "overminCallback", null);
        if (callback !== null) {
            var scope = $5cc1b98d00b3dc74$var$GetValue(config, "overminCallbackScope", undefined);
            this.on("overmin", callback, scope);
        }
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.setOrientationMode($5cc1b98d00b3dc74$var$GetValue(o, "orientation", 0));
        this.setDragThreshold($5cc1b98d00b3dc74$var$GetValue(o, "threshold", 10));
        this.setSlidingDeceleration($5cc1b98d00b3dc74$var$GetValue(o, "slidingDeceleration", 5000));
        this.setBackDeceleration($5cc1b98d00b3dc74$var$GetValue(o, "backDeceleration", 2000));
        var dragRate = $5cc1b98d00b3dc74$var$GetValue(o, "dragRate", 1);
        dragRate = dragRate * ($5cc1b98d00b3dc74$var$GetValue(o, "dragReverse", false) ? -1 : 1);
        this.setDragRate(dragRate);
        var bounds = $5cc1b98d00b3dc74$var$GetValue(o, "bounds", undefined);
        if (bounds) this.setBounds(bounds);
        else this.setBounds($5cc1b98d00b3dc74$var$GetValue(o, "max", 0), $5cc1b98d00b3dc74$var$GetValue(o, "min", 0));
        this.setValue($5cc1b98d00b3dc74$var$GetValue(o, "value", this.maxValue || 0));
        this.setEnable($5cc1b98d00b3dc74$var$GetValue(o, "enable", true));
        return this;
    }
    boot() {
        this.scene.sys.events.on("preupdate", this._state.update, this._state);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.scene.sys.events.off("preupdate", this._state.update, this._state);
        this._state.destroy(fromScene);
        this.dragState.destroy(fromScene);
        this._state = undefined;
        this.dragState = undefined;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        this._enable = e;
        this._state.setEnable(e);
        this.dragState.setEnable(e);
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    setOrientationMode(m) {
        if (typeof m === "string") m = $5cc1b98d00b3dc74$var$ORIENTATIONMODE[m];
        this.orientationMode = m;
        return this;
    }
    setDragThreshold(distance) {
        this.dragThreshold = distance;
        return this;
    }
    setSlidingDeceleration(dec) {
        this.slidingDeceleration = dec;
        return this;
    }
    setBackDeceleration(dec) {
        this.backDeceleration = dec;
        return this;
    }
    setDragRate(ratio) {
        this.dragRate = ratio;
        return this;
    }
    setBounds(value0, value1) {
        if (Array.isArray(value0)) {
            var bounds = value0;
            value0 = bounds[0];
            value1 = bounds[1];
        }
        if (value0 < value1) {
            this.minValue = value0;
            this.maxValue = value1;
        } else {
            this.minValue = value1;
            this.maxValue = value0;
        }
        return this;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (value === this._value) return;
        var oldValue = this._value;
        var isOverMax = this.overMax(value);
        var isOverMin = this.overMin(value);
        if (isOverMax) this.emit("overmax", value, oldValue);
        if (isOverMin) this.emit("overmin", value, oldValue);
        if (!this.backEnable) {
            if (isOverMax) value = this.maxValue;
            if (isOverMin) value = this.minValue;
        }
        this._value = value;
        this.emit("valuechange", value, oldValue);
    }
    setValue(value, clamp) {
        if (clamp === undefined) clamp = false;
        if (clamp) value = $5cc1b98d00b3dc74$var$Clamp(value, this.minValue, this.maxValue);
        this.value = value;
        return this;
    }
    addValue(inc, clamp) {
        this.setValue(this.value + inc, clamp);
        return this;
    }
    get state() {
        return this._state.state;
    }
    get isDragging() {
        return this.dragState.isInTouched;
    }
    get outOfMaxBound() {
        return this.overMax(this.value);
    }
    get outOfMinBound() {
        return this.overMin(this.value);
    }
    get outOfBounds() {
        return this.outOfMinBound || this.outOfMaxBound;
    }
    // internal
    overMax(value) {
        return this.maxValue != null && value > this.maxValue;
    }
    overMin(value) {
        return this.minValue != null && value < this.minValue;
    }
    get backEnable() {
        return typeof this.backDeceleration === "number";
    }
    get isPullBack() {
        return this._slowDown.isMoving;
    }
    get slidingEnable() {
        return typeof this.slidingDeceleration === "number";
    }
    get isSliding() {
        return this._slowDown.isMoving;
    }
    get dragDelta() {
        var delta;
        if (this.orientationMode === 0) delta = this.dragState.dy;
        else if (this.orientationMode === 1) delta = this.dragState.dx;
        else delta = 0;
        delta *= this.dragRate;
        return delta;
    }
    get dragSpeed() {
        var speed;
        if (this.orientationMode === 0) speed = this.dragState.speedY;
        else if (this.orientationMode === 1) speed = this.dragState.speedX;
        else speed = 0;
        speed *= this.dragRate;
        return speed;
    }
    // enter_DRAG
    onDragStart() {
        this.emit("dragstart");
    }
    // exit_DRAG
    onDragEnd() {
        this.emit("dragend");
    }
    // everyTick_DRAG
    dragging() {
        this.value += this.dragDelta;
    }
    // enter_SLIDE 
    onSliding() {
        var start = this.value;
        var speed = this.dragSpeed;
        if (speed === 0) {
            this._slowDown.stop();
            this._state.next();
            return;
        }
        var dec = this.slidingDeceleration;
        this._slowDown.init(start, speed > 0, Math.abs(speed), dec);
    }
    // everyTick_SLIDE
    sliding(time, delta) {
        delta *= 0.001;
        var newValue = this._slowDown.update(delta).value;
        if (this.overMax(newValue)) {
            this.value = this.maxValue;
            this._slowDown.stop();
        } else if (this.overMin(newValue)) {
            this.value = this.minValue;
            this._slowDown.stop();
        } else this.value = newValue;
    }
    // enter_BACK
    onPullBack() {
        var start = this.value;
        var end = this.outOfMinBound ? this.minValue : this.maxValue;
        var dist = Math.abs(end - start);
        var dec = this.backDeceleration;
        var speed = Math.sqrt(2 * dec * dist);
        this._slowDown.init(start, undefined, speed, dec, end);
    }
    // everyTick_BACK
    pullBack(time, delta) {
        delta *= 0.001;
        this.value = this._slowDown.update(delta).value;
        if (!this._slowDown.isMoving) this._state.next();
    }
    // exit_SLIDE, exit_BACK
    stop() {
        this._slowDown.stop();
    }
}
const $5cc1b98d00b3dc74$var$ORIENTATIONMODE = {
    y: 0,
    v: 0,
    vertical: 0,
    x: 1,
    h: 1,
    horizontal: 1
};
var $5cc1b98d00b3dc74$export$2e2bcd8739ae039 = $5cc1b98d00b3dc74$var$Scroller;


var $aa75ab8c8048afae$export$2e2bcd8739ae039 = (0, $5cc1b98d00b3dc74$export$2e2bcd8739ae039);



const $7cf4439fedb2600a$var$GetValue = Phaser.Utils.Objects.GetValue;
class $7cf4439fedb2600a$var$MouseWheelScroller extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        if (this.parent !== this.scene) this.focusMode = $7cf4439fedb2600a$var$GetValue(config, "focus", false);
        else this.focusMode = false;
        this.setSpeed($7cf4439fedb2600a$var$GetValue(config, "speed", 0.1));
        this.setEnable($7cf4439fedb2600a$var$GetValue(config, "enable", true));
        if (!this.focusMode) this.scene.input.on("wheel", this.onSceneScroll, this);
        else {
            var gameObject = this.parent;
            gameObject.setInteractive($7cf4439fedb2600a$var$GetValue(config, "inputConfig", undefined)).on("wheel", function(pointer, dx, dy, dz, event) {
                if (!this.enable) return;
                this.scroll(dy);
            }, this);
        }
    }
    destroy() {
        if (!this.focusMode) this.scene.input.off("wheel", this.onSceneScroll, this);
    }
    onSceneScroll(pointer, currentlyOver, dx, dy, dz, event) {
        if (!this.enable) return;
        this.scroll(dy);
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    setSpeed(speed) {
        this.speed = speed;
        return this;
    }
    scroll(dy) {
        dy *= this.speed;
        this.emit("scroll", dy, this.parent, this);
    }
}
var $7cf4439fedb2600a$export$2e2bcd8739ae039 = $7cf4439fedb2600a$var$MouseWheelScroller;


const $775890bf31762586$var$GetValue = Phaser.Utils.Objects.GetValue;
var $775890bf31762586$var$CreateScrollableSizer = function(parent, config) {
    var scene = parent.scene;
    var scrollMode = (0, $391df8fa33f776dd$export$2e2bcd8739ae039)(config);
    var scrollableSizer = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
        orientation: scrollMode
    });
    // A child which not put into scene
    var child = $775890bf31762586$var$GetValue(config, "child.gameObject", undefined), childPadding = 0;
    var sliderConfig = $775890bf31762586$var$GetValue(config, "slider", undefined), slider, sliderPadding = 0;
    var sliderPosition = $775890bf31762586$var$GetValue(sliderConfig, "position", 0);
    if (typeof sliderPosition === "string") sliderPosition = $775890bf31762586$var$SLIDER_POSITION_MAP[sliderPosition];
    var isRightSlider = sliderPosition === 0; // Right/bottom slider
    var scrollerConfig = $775890bf31762586$var$GetValue(config, "scroller", true), scroller;
    var mouseWheelScrollerConfig = $775890bf31762586$var$GetValue(config, "mouseWheelScroller", false), mouseWheelScroller;
    // Child, slider, scroller, mouseWheelScroller
    if (child) {
        var childSpace = $775890bf31762586$var$GetValue(config, "space.child", 0);
        parent.childMargin = {};
        if (typeof childSpace !== "number") {
            var paddingConfig = childSpace;
            if (scrollMode === 0) {
                childPadding = {
                    left: $775890bf31762586$var$GetValue(paddingConfig, "left", 0),
                    right: $775890bf31762586$var$GetValue(paddingConfig, "right", 0)
                };
                parent.childMargin.top = $775890bf31762586$var$GetValue(paddingConfig, "top", 0);
                parent.childMargin.bottom = $775890bf31762586$var$GetValue(paddingConfig, "bottom", 0);
            } else {
                childPadding = {
                    top: $775890bf31762586$var$GetValue(paddingConfig, "top", 0),
                    bottom: $775890bf31762586$var$GetValue(paddingConfig, "bottom", 0)
                };
                parent.childMargin.top = $775890bf31762586$var$GetValue(paddingConfig, "left", 0);
                parent.childMargin.bottom = $775890bf31762586$var$GetValue(paddingConfig, "right", 0);
            }
        } else {
            if (sliderConfig) {
                if (scrollMode === 0) childPadding = isRightSlider ? {
                    right: childSpace
                } : {
                    left: childSpace
                };
                else childPadding = isRightSlider ? {
                    bottom: childSpace
                } : {
                    top: childSpace
                };
            }
            parent.childMargin.top = 0;
            parent.childMargin.bottom = 0;
        }
        if (sliderConfig) {
            if (sliderConfig === true) sliderConfig = {};
            // Vertical slider(orientation=1) for left-right scrollableSizer(orientation=0)
            // Horizontal slider(orientation=0) for top-bottom scrollableSizer(orientation=1)
            sliderConfig.orientation = scrollableSizer.orientation === 0 ? 1 : 0;
            slider = new (0, $3d95d827f9b64db8$export$2e2bcd8739ae039)(scene, sliderConfig);
            sliderPadding = $775890bf31762586$var$GetValue(config, "space.slider", 0);
            parent.hideUnscrollableSlider = $775890bf31762586$var$GetValue(sliderConfig, "hideUnscrollableSlider", false);
            parent.adaptThumbSizeMode = $775890bf31762586$var$GetValue(sliderConfig, "adaptThumbSize", false);
            parent.minThumbSize = $775890bf31762586$var$GetValue(sliderConfig, "minThumbSize", undefined);
        } else {
            parent.adaptThumbSizeMode = false;
            parent.minThumbSize = undefined;
        }
        if (scrollerConfig) {
            if (scrollerConfig === true) scrollerConfig = {};
            scrollerConfig.orientation = scrollMode;
            scroller = new (0, $aa75ab8c8048afae$export$2e2bcd8739ae039)(child, scrollerConfig);
        }
        if (mouseWheelScrollerConfig) mouseWheelScroller = new (0, $7cf4439fedb2600a$export$2e2bcd8739ae039)(child, mouseWheelScrollerConfig);
        // Add slider to parent sizer at left/top side
        if (slider && !isRightSlider) scrollableSizer.add(slider, {
            proportion: 0,
            align: "center",
            padding: sliderPadding,
            expand: true
        });
        // Add child to parent sizer
        var proportion = $775890bf31762586$var$GetValue(config, "child.proportion", 1);
        var expand = $775890bf31762586$var$GetValue(config, "child.expand", true);
        scrollableSizer.add(child, {
            proportion: proportion,
            align: "center",
            padding: childPadding,
            expand: expand
        });
        // Add slider to parent sizer at right/bottom side
        if (slider && isRightSlider) scrollableSizer.add(slider, {
            proportion: 0,
            align: "center",
            padding: sliderPadding,
            expand: true
        });
    }
    // Control
    if (slider) slider.on("valuechange", function(newValue) {
        parent.t = newValue;
        parent.emit("scroll", parent);
    });
    if (scroller) scroller.on("valuechange", function(newValue) {
        parent.childOY = newValue;
        parent.emit("scroll", parent);
    });
    if (mouseWheelScroller) mouseWheelScroller.on("scroll", function(incValue) {
        parent.addChildOY(-incValue, true);
    });
    parent.addChildrenMap("child", child);
    parent.addChildrenMap("slider", slider);
    parent.addChildrenMap("scroller", scroller);
    parent.addChildrenMap("mouseWheelScroller", mouseWheelScroller);
    return scrollableSizer;
};
var $775890bf31762586$var$SLIDER_POSITION_MAP = {
    right: 0,
    left: 1,
    bottom: 0,
    top: 1
};
var $775890bf31762586$export$2e2bcd8739ae039 = $775890bf31762586$var$CreateScrollableSizer;




var $87672b6b224f4435$var$ResizeController = function() {
    var topChildOY = this.topChildOY;
    var bottomChildOY = this.bottomChildOY;
    var scroller = this.childrenMap.scroller;
    var slider = this.childrenMap.slider;
    if (scroller) scroller.setBounds(bottomChildOY, topChildOY);
    if (slider) slider.setEnable(bottomChildOY !== topChildOY);
    this.updateController();
    if (slider) {
        if (this.hideUnscrollableSlider) this.setChildVisible(slider, this.isOverflow);
        if (this.adaptThumbSizeMode) $87672b6b224f4435$var$AdaptThumbSize.call(this);
    }
    return this;
};
var $87672b6b224f4435$var$AdaptThumbSize = function() {
    // Change slider size according to visible ratio
    var ratio = Math.min(this.childVisibleHeight / this.childHeight, 1);
    var slider = this.childrenMap.slider;
    var track = slider.childrenMap.track;
    var thumb = slider.childrenMap.thumb;
    var minThumbSize = this.minThumbSize;
    if (this.scrollMode === 0) {
        var newHeight = track.displayHeight * ratio;
        if (minThumbSize !== undefined && newHeight < minThumbSize) newHeight = minThumbSize;
        (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(thumb, undefined, newHeight);
    } else {
        var newWidth = track.displayWidth * ratio;
        if (minThumbSize !== undefined && newWidth < minThumbSize) newWidth = minThumbSize;
        (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(thumb, newWidth, undefined);
    }
    $87672b6b224f4435$var$LayoutSlider.call(this);
};
var $87672b6b224f4435$var$LayoutSlider = function() {
    var slider = this.childrenMap.slider;
    // Save minSize
    var minWidthSave = slider.minWidth;
    var minHeightSave = slider.minHeight;
    // Set minSize to current size
    slider.minWidth = slider.width;
    slider.minHeight = slider.height;
    // Layout slider
    slider.layout();
    // Restore minSize
    slider.minWidth = minWidthSave;
    slider.minHeight = minHeightSave;
};
var $87672b6b224f4435$export$2e2bcd8739ae039 = $87672b6b224f4435$var$ResizeController;


var $df05bae471e45130$var$UpdateController = function() {
    var scroller = this.childrenMap.scroller;
    var slider = this.childrenMap.slider;
    if (scroller) scroller.setValue(this.childOY);
    if (slider) slider.setValue(this.t);
};
var $df05bae471e45130$export$2e2bcd8739ae039 = $df05bae471e45130$var$UpdateController;


const $b48de4bdb562f812$var$GetValue = Phaser.Utils.Objects.GetValue;
const $b48de4bdb562f812$var$Clamp = Phaser.Math.Clamp;
class $b48de4bdb562f812$var$Scrollable extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var scrollMode = (0, $391df8fa33f776dd$export$2e2bcd8739ae039)(config); // Left-to-right, or top-to-bottom
        // Create sizer
        config.orientation = scrollMode === 0 ? 1 : 0;
        super(scene, config);
        this.type = $b48de4bdb562f812$var$GetValue(config, "type", "rexScrollable");
        // Add elements
        var background = $b48de4bdb562f812$var$GetValue(config, "background", undefined);
        var scrollableSizer = (0, $775890bf31762586$export$2e2bcd8739ae039)(this, config);
        var header = $b48de4bdb562f812$var$GetValue(config, "header", undefined);
        var footer = $b48de4bdb562f812$var$GetValue(config, "footer", undefined);
        // Background
        if (background) this.addBackground(background);
        if (header) {
            var align = $b48de4bdb562f812$var$GetValue(config, "align.header", "center");
            var headerSpace = $b48de4bdb562f812$var$GetValue(config, "space.header", 0);
            var padding;
            if (scrollMode === 0) padding = {
                bottom: headerSpace
            };
            else padding = {
                right: headerSpace
            };
            var expand = $b48de4bdb562f812$var$GetValue(config, "expand.header", true);
            this.add(header, {
                proportion: 0,
                align: align,
                padding: padding,
                expand: expand
            });
        }
        if (scrollableSizer) this.add(scrollableSizer, {
            proportion: 1,
            align: "center",
            padding: 0,
            expand: true
        });
        if (footer) {
            var align = $b48de4bdb562f812$var$GetValue(config, "align.footer", "center");
            var footerSpace = $b48de4bdb562f812$var$GetValue(config, "space.footer", 0);
            var padding;
            if (scrollMode === 0) padding = {
                top: footerSpace
            };
            else padding = {
                left: footerSpace
            };
            var expand = $b48de4bdb562f812$var$GetValue(config, "expand.footer", true);
            this.add(footer, {
                proportion: 0,
                align: align,
                padding: padding,
                expand: expand
            });
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("header", header);
        this.addChildrenMap("footer", footer);
        this.runLayoutFlag = false;
    /* Necessary properties of child object
        - child.t (RW), 
        - child.childOY (RW)
        - child.topChildOY (R)
        - child.bottomChildOY (R)
        - child.childVisibleHeight (R)
        - child.childHeight (R)
        */ }
    runLayout(parent, newWidth, newHeight) {
        // Skip hidden or !dirty sizer
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        this.resizeController();
        // Set `t` to 0 at first runLayout()
        if (!this.runLayoutFlag) {
            this.runLayoutFlag = true;
            this.setT(0);
        }
        return this;
    }
    set t(t) {
        // Get inner childT
        var childMargin = this.childMargin;
        if (childMargin.top !== 0 || childMargin.bottom !== 0) {
            var child = this.childrenMap.child;
            var innerHeight = child.topChildOY - child.bottomChildOY;
            var outerHeight = innerHeight + childMargin.top + childMargin.bottom;
            var innerChildOY = outerHeight * t - childMargin.top;
            t = innerChildOY / innerHeight;
        }
        this.childrenMap.child.t = t;
        this.updateController();
    }
    get t() {
        var t = this.childrenMap.child.t;
        // Get outer childT
        var childMargin = this.childMargin;
        if (childMargin.top !== 0 || childMargin.bottom !== 0) {
            var child = this.childrenMap.child;
            var innerHeight = child.topChildOY - child.bottomChildOY;
            var outerHeight = innerHeight + childMargin.top + childMargin.bottom;
            var outerChildOY = innerHeight * t + childMargin.top;
            t = outerChildOY / outerHeight;
        }
        return t;
    }
    set childOY(value) {
        this.childrenMap.child.childOY = value;
        this.updateController();
    }
    get childOY() {
        return this.childrenMap.child.childOY;
    }
    get topChildOY() {
        return this.childrenMap.child.topChildOY + this.childMargin.top;
    }
    get bottomChildOY() {
        return this.childrenMap.child.bottomChildOY - this.childMargin.bottom;
    }
    get childVisibleHeight() {
        return this.childrenMap.child.childVisibleHeight;
    }
    get childHeight() {
        return this.childrenMap.child.childHeight;
    }
    get isOverflow() {
        var child = this.childrenMap.child;
        return child.topChildOY !== child.bottomChildOY;
    }
    get scrollMode() {
        return this.orientation === 0 ? 1 : 0;
    }
    setChildOY(value, clamp) {
        if (clamp === undefined) clamp = false;
        if (clamp) value = $b48de4bdb562f812$var$Clamp(value, this.bottomChildOY, this.topChildOY);
        this.childOY = value;
        return this;
    }
    addChildOY(inc, clamp) {
        this.setChildOY(this.childOY + inc, clamp);
        return this;
    }
    setT(value, clamp) {
        if (clamp === undefined) clamp = false;
        if (clamp) value = $b48de4bdb562f812$var$Clamp(value, 0, 1);
        this.t = value;
        return this;
    }
    addT(inc, clamp) {
        this.setT(this.t + inc, clamp);
        return this;
    }
    scrollToTop() {
        this.t = 0;
        return this;
    }
    scrollToBottom() {
        this.t = 1;
        // t will be 0 if panel/table does not exceed visible area
        if (this.t === 0) return this;
        // Panel/Table height might be expanded while cells are visible        
        do this.t = 1;
        while (this.t !== 1);
        return this;
    }
    get sliderEnable() {
        var slider = this.childrenMap.slider;
        if (!slider) return false;
        return slider.enable;
    }
    set sliderEnable(value) {
        var slider = this.childrenMap.slider;
        if (!slider) return;
        slider.setEnable(value);
    }
    setSliderEnable(enabled) {
        if (enabled === undefined) enabled = true;
        this.sliderEnable = enabled;
        return this;
    }
    get scrollerEnable() {
        var scroller = this.childrenMap.scroller;
        if (!scroller) return false;
        return scroller.enable;
    }
    set scrollerEnable(value) {
        var scroller = this.childrenMap.scroller;
        if (!scroller) return;
        scroller.setEnable(value);
    }
    setScrollerEnable(enabled) {
        if (enabled === undefined) enabled = true;
        this.scrollerEnable = enabled;
        return this;
    }
    get mouseWheelScrollerEnable() {
        var mouseWheelScroller = this.childrenMap.mouseWheelScroller;
        if (!mouseWheelScroller) return false;
        return mouseWheelScroller.enable;
    }
    set mouseWheelScrollerEnable(value) {
        var mouseWheelScroller = this.childrenMap.mouseWheelScrollerEnable;
        if (!mouseWheelScroller) return;
        mouseWheelScroller.setEnable(value);
    }
    setMouseWheelScrollerEnable(enabled) {
        if (enabled === undefined) enabled = true;
        this.mouseWheelScrollerEnable = enabled;
        return this;
    }
    setDropZoneEnable(enable) {
        if (enable === undefined) enable = true;
        var child = this.childrenMap.child;
        child.setInteractive();
        child.input.dropZone = enable;
        return this;
    }
}
var $b48de4bdb562f812$var$Methods = {
    resizeController: (0, $87672b6b224f4435$export$2e2bcd8739ae039),
    updateController: (0, $df05bae471e45130$export$2e2bcd8739ae039)
};
// mixin
Object.assign($b48de4bdb562f812$var$Scrollable.prototype, $b48de4bdb562f812$var$Methods);
var $b48de4bdb562f812$export$2e2bcd8739ae039 = $b48de4bdb562f812$var$Scrollable;




const $d5c1e4e4661e06e7$export$a61816c1105a5bb3 = 0;
const $d5c1e4e4661e06e7$export$1aa83cfb15776bf4 = 1;
const $d5c1e4e4661e06e7$export$48237aa1a9416166 = 2;
var $d5c1e4e4661e06e7$var$GetTextObjectType = function(textObject) {
    var textObjectType;
    if ((0, $dc9c00e28f8765b6$export$2e2bcd8739ae039)(textObject)) textObjectType = $d5c1e4e4661e06e7$export$48237aa1a9416166;
    else if ((0, $0d3d6f3277aad4a5$export$2e2bcd8739ae039)(textObject)) textObjectType = $d5c1e4e4661e06e7$export$a61816c1105a5bb3;
    else textObjectType = $d5c1e4e4661e06e7$export$1aa83cfb15776bf4;
    return textObjectType;
};
var $d5c1e4e4661e06e7$export$2e2bcd8739ae039 = $d5c1e4e4661e06e7$var$GetTextObjectType;





var $23d8a788b6242ef5$var$TextToLines = function(textObject, text, lines) {
    var textObjectType = (0, $d5c1e4e4661e06e7$export$2e2bcd8739ae039)(textObject);
    switch(textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
            lines = textObject.getWrappedText(text); // Array of string
            break;
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            lines = textObject.getPenManager(text, lines); // Pens-manager
            break;
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            if (textObject.maxWidth > 0) lines = textObject.setText(text).getTextBounds().wrappedText.split("\n");
            else lines = text.split("\n");
            break;
    }
    return lines;
};
var $23d8a788b6242ef5$export$2e2bcd8739ae039 = $23d8a788b6242ef5$var$TextToLines;


var $f68fdfa33171ce5c$var$SetText = function(text) {
    if (text !== undefined) this.text = text;
    // Wrap content in lines
    this.lines = (0, $23d8a788b6242ef5$export$2e2bcd8739ae039)(this.textObject, this.text, this.lines);
    // Get lines count
    this.linesCount = this.lines.length;
    // Re-calculate these values later
    this._textHeight = undefined;
    this._textVisibleHeight = undefined;
    this.updateTextObject();
    return this;
};
var $f68fdfa33171ce5c$export$2e2bcd8739ae039 = $f68fdfa33171ce5c$var$SetText;


var $349e65aa60afb871$var$TextHeightToLinesCount = function(height) {
    // height = (lines * (lineHeight + lineSpacing)) - lineSpacing
    return (height - this.textLineSpacing) / (this.textLineHeight + this.textLineSpacing);
};
var $349e65aa60afb871$export$2e2bcd8739ae039 = $349e65aa60afb871$var$TextHeightToLinesCount;


var $711c3acacab49bba$var$LinesCountToTextHeight = function(linesCount) {
    // height = (linesCount * (lineHeight + lineSpacing)) - lineSpacing
    return linesCount * (this.textLineHeight + this.textLineSpacing) - this.textLineSpacing;
};
var $711c3acacab49bba$export$2e2bcd8739ae039 = $711c3acacab49bba$var$LinesCountToTextHeight;



var $e152599ea9dce515$var$GetLines = function(startLineIdx) {
    var endLineIdx = startLineIdx + this.visibleLinesCount + 1;
    var text;
    switch(this.textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
            text = this.lines.slice(startLineIdx, endLineIdx).join("\n");
            break;
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            var startIdx = this.lines.getLineStartIndex(startLineIdx);
            var endIdx = this.lines.getLineEndIndex(endLineIdx - 1);
            text = this.lines.getSliceTagText(startIdx, endIdx, true);
            break;
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            text = this.lines.slice(startLineIdx, endLineIdx).join("\n");
            break;
    }
    return text;
};
var $e152599ea9dce515$export$2e2bcd8739ae039 = $e152599ea9dce515$var$GetLines;



var $d4581d482844dcb0$var$SetNoWrapText = function(textObject, text) {
    var textObjectType = (0, $d5c1e4e4661e06e7$export$2e2bcd8739ae039)(textObject);
    switch(textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
            // Store wrap properties
            var style = textObject.style;
            var wordWrapWidth = style.wordWrapWidth;
            var wordWrapCallback = style.wordWrapCallback;
            // Disable wrap
            style.wordWrapWidth = 0;
            style.wordWrapCallback = undefined;
            // Set text
            textObject.setText(text);
            // Restore wrap
            style.wordWrapWidth = wordWrapWidth;
            style.wordWrapCallback = wordWrapCallback;
            break;
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            // Store wrap properties
            var style = textObject.style;
            var wrapMode = style.wrapMode;
            // Disable wrap
            style.wrapMode = 0;
            // Set text
            textObject.setText(text);
            // Restore wrap
            style.wrapMode = wrapMode;
            break;
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            // Store wrap properties
            var maxWidth = textObject._maxWidth;
            // Disable wrap
            textObject._maxWidth = 0;
            // Set text
            textObject.setText(text);
            // Restore wrap
            textObject._maxWidth = maxWidth;
            break;
    }
};
var $d4581d482844dcb0$export$2e2bcd8739ae039 = $d4581d482844dcb0$var$SetNoWrapText;


var $3fa61d4fe370e768$var$ResetTextObjectPosition = function() {
    var config = this.textObject.rexSizer;
    this.textObject.y += config.offsetY - config.preOffsetY;
    config.preOffsetY = config.offsetY;
    this.resetChildPositionState(this.textObject);
    if (this.textCropEnable) $3fa61d4fe370e768$var$CropTextObject.call(this);
};
var $3fa61d4fe370e768$var$CropTextObject = function() {
    // Don't have setCrop method, return
    if (!this.textObject.setCrop) return;
    var offsetY = this.textObject.rexSizer.offsetY;
    var cropY, cropHeight;
    if (offsetY <= 0) {
        cropY = -offsetY;
        cropHeight = this.height;
    } else {
        cropY = 0;
        cropHeight = this.height - offsetY;
    }
    this.textObject.setCrop(0, cropY, this.width, cropHeight);
};
var $3fa61d4fe370e768$export$2e2bcd8739ae039 = $3fa61d4fe370e768$var$ResetTextObjectPosition;


var $04b361759bad6e42$var$UpdateTextObject = function() {
    var startLineIndex = Math.max(Math.floor((0, $349e65aa60afb871$export$2e2bcd8739ae039).call(this, -this.textOY)), 0);
    var textOffset = (0, $711c3acacab49bba$export$2e2bcd8739ae039).call(this, startLineIndex) + this.textOY;
    // Grab visible lines
    var text = (0, $e152599ea9dce515$export$2e2bcd8739ae039).call(this, startLineIndex);
    // Display visible content
    (0, $d4581d482844dcb0$export$2e2bcd8739ae039)(this.textObject, text);
    this.textObject.rexSizer.offsetY = textOffset;
    (0, $3fa61d4fe370e768$export$2e2bcd8739ae039).call(this);
    return this;
};
var $04b361759bad6e42$export$2e2bcd8739ae039 = $04b361759bad6e42$var$UpdateTextObject;



var $deb46fc265c72f61$var$PreLayout = function() {
    // Style of text
    this._textLineHeight = undefined;
    this._textLineSpacing = undefined;
    // Style of text, width of text
    this._visibleLinesCount = undefined;
    // Style of text, total lines of content
    this._textHeight = undefined;
    this._textVisibleHeight = undefined;
    (0, $8777309d0690526c$export$2e2bcd8739ae039).call(this);
    return this;
};
var $deb46fc265c72f61$export$2e2bcd8739ae039 = $deb46fc265c72f61$var$PreLayout;



var $fc62de71332dc518$var$ResizeText = function(textObject, width, height) {
    height += this.textLineHeight + this.textLineSpacing; // Add 1 line
    if (this.textObjectWidth === width && this._textObjectRealHeight === height) return;
    this.textObjectWidth = width;
    this._textObjectRealHeight = height;
    switch(this.textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            textObject.setFixedSize(width, height);
            var style = textObject.style;
            var wrapWidth = Math.max(width, 0);
            if (this.textObjectType === (0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3)) style.wordWrapWidth = wrapWidth;
            else {
                if (style.wrapMode === 0) style.wrapMode = 1;
                style.wrapWidth = wrapWidth;
            }
            break;
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            textObject.setMaxWidth(width);
            break;
    }
    // Render content again
    this.setText();
};
var $fc62de71332dc518$export$2e2bcd8739ae039 = $fc62de71332dc518$var$ResizeText;




var $c81032cf98980913$var$LayoutChildren = function() {
    var child, childConfig, padding;
    var startX = this.left, startY = this.top;
    var x, y, width, height; // Align zone
    // LayoutChildren text child
    // Skip invisible child
    child = this.textObject;
    if (!child.rexSizer.hidden) {
        childConfig = child.rexSizer;
        padding = childConfig.padding;
        x = startX + padding.left;
        y = startY + padding.top;
        width = this.width - padding.left - padding.right;
        height = this.height - padding.top - padding.bottom;
        (0, $fc62de71332dc518$export$2e2bcd8739ae039).call(this, child, width, height);
        (0, $b7e28befb839484c$export$2e2bcd8739ae039)(child, x, y, width, height, childConfig.align);
        childConfig.preOffsetY = 0; // Clear preOffsetY
        (0, $3fa61d4fe370e768$export$2e2bcd8739ae039).call(this);
        if (this.textMask) {
            this.textMask.setPosition().resize();
            this.resetChildPositionState(this.textMask);
        }
    }
};
var $c81032cf98980913$export$2e2bcd8739ae039 = $c81032cf98980913$var$LayoutChildren;


var $7b8d9247353c5aaa$export$2e2bcd8739ae039 = {
    setText: (0, $f68fdfa33171ce5c$export$2e2bcd8739ae039),
    updateTextObject: (0, $04b361759bad6e42$export$2e2bcd8739ae039),
    preLayout: (0, $deb46fc265c72f61$export$2e2bcd8739ae039),
    layoutChildren: (0, $c81032cf98980913$export$2e2bcd8739ae039)
};





const $d3f931ef07450b80$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $d3f931ef07450b80$var$GetValue = Phaser.Utils.Objects.GetValue;
const $d3f931ef07450b80$var$ALIGN_LEFTTOP = Phaser.Display.Align.TOP_LEFT;
class $d3f931ef07450b80$var$TextBlock extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, config){
        if ($d3f931ef07450b80$var$IsPlainObject(x)) {
            config = x;
            x = $d3f931ef07450b80$var$GetValue(config, "x", 0);
            y = $d3f931ef07450b80$var$GetValue(config, "y", 0);
            minWidth = $d3f931ef07450b80$var$GetValue(config, "width", undefined);
            minHeight = $d3f931ef07450b80$var$GetValue(config, "height", undefined);
        } else if ($d3f931ef07450b80$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $d3f931ef07450b80$var$GetValue(config, "width", undefined);
            minHeight = $d3f931ef07450b80$var$GetValue(config, "height", undefined);
        }
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexTextBlock";
        this.textObject = undefined;
        this.linesCount = 0;
        this.textMask = undefined;
        this.textObjectType = undefined;
        this._textLineHeight = undefined;
        this._textLineSpacing = undefined;
        this._visibleLinesCount = undefined;
        this._textHeight = undefined;
        this._textVisibleHeight = undefined;
        this._textObjectRealHeight = 0;
        this.lines = undefined;
        // Text object : array of string
        // Tag text object : pens-manager
        // Bitmap text object : array of string
        this.text = $d3f931ef07450b80$var$GetValue(config, "content", "");
        this._textOY = 0;
        this.execeedTopState = false;
        this.execeedBottomState = false;
        this.setClampMode($d3f931ef07450b80$var$GetValue(config, "clamplTextOY", true));
        this.alwaysScrollable = $d3f931ef07450b80$var$GetValue(config, "alwaysScrollable", false);
        // Add elements
        var background = $d3f931ef07450b80$var$GetValue(config, "background", undefined);
        var textObject = $d3f931ef07450b80$var$GetValue(config, "text", undefined);
        if (textObject === undefined) textObject = $d3f931ef07450b80$var$CreateDefaultTextObject(scene);
        this.textCropEnable = $d3f931ef07450b80$var$GetValue(config, "textCrop", !!textObject.setCrop);
        var textMaskEnable = $d3f931ef07450b80$var$GetValue(config, "textMask", !this.textCropEnable);
        if (background) this.addBackground(background);
        this.add(textObject);
        this.sizerChildren = [
            textObject
        ];
        var sizerConfig = this.getSizerConfig(textObject);
        sizerConfig.align = $d3f931ef07450b80$var$ALIGN_LEFTTOP;
        sizerConfig.padding = (0, $974f2fb082d06dfe$export$2e2bcd8739ae039)(0);
        sizerConfig.expand = true;
        this.textObject = textObject;
        this.textObjectType = (0, $d5c1e4e4661e06e7$export$2e2bcd8739ae039)(textObject);
        // Add more variables
        sizerConfig.preOffsetY = 0;
        sizerConfig.offsetY = 0;
        // Create mask of text object
        if (textMaskEnable) this.textMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, this.textObject, this);
        this.addChildrenMap("background", background);
        this.addChildrenMap("text", textObject);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.textObject = undefined;
        this.textMask = undefined;
        if (this.lines) {
            switch(this.textObjectType){
                case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
                    this.lines.length = 0;
                    break;
                case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
                    this.lines.destroy();
                    break;
                case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
                    this.lines.length = 0;
                    break;
            }
            this.lines = undefined;
        }
        super.destroy(fromScene);
    }
    setClampMode(mode) {
        if (mode === undefined) mode = true;
        this.clampTextOY = mode;
        return this;
    }
    get textLineHeight() {
        if (this._textLineHeight === undefined) {
            var lineHeight;
            switch(this.textObjectType){
                case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
                case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
                    var style = this.textObject.style;
                    lineHeight = style.metrics.fontSize + style.strokeThickness;
                    break;
                case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
                    var scale = this.textObject.fontSize / this.textObject.fontData.size;
                    lineHeight = this.textObject.fontData.lineHeight * scale;
                    break;
            }
            this._textLineHeight = lineHeight;
        }
        return this._textLineHeight;
    }
    get textLineSpacing() {
        if (this._textLineSpacing === undefined) {
            var lineSpacing;
            switch(this.textObjectType){
                case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
                case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
                    lineSpacing = this.textObject.lineSpacing;
                    break;
                case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
                    lineSpacing = 0;
                    break;
            }
            this._textLineSpacing = lineSpacing;
        }
        return this._textLineSpacing;
    }
    get visibleLinesCount() {
        if (this._visibleLinesCount === undefined) this._visibleLinesCount = Math.floor((0, $349e65aa60afb871$export$2e2bcd8739ae039).call(this, this._textObjectRealHeight));
        return this._visibleLinesCount;
    }
    get topTextOY() {
        return 0;
    }
    get bottomTextOY() {
        return -this.textVisibleHeight;
    }
    get textHeight() {
        if (this._textHeight === undefined) this._textHeight = (0, $711c3acacab49bba$export$2e2bcd8739ae039).call(this, this.linesCount);
        return this._textHeight;
    }
    get textObjectHeight() {
        return this._textObjectRealHeight - (this.textLineHeight + this.textLineSpacing); // Remove 1 text line
    }
    get textVisibleHeight() {
        if (this._textVisibleHeight === undefined) {
            var h = this.textHeight - this.textObjectHeight;
            if (!this.alwaysScrollable && h < 0) h = 0;
            this._textVisibleHeight = h;
        }
        return this._textVisibleHeight;
    }
    textOYExceedTop(oy) {
        if (oy === undefined) oy = this.textOY;
        return oy > this.topTextOY;
    }
    textOYExeceedBottom(oy) {
        if (oy === undefined) oy = this.textOY;
        return oy < this.bottomTextOY;
    }
    get textOY() {
        return this._textOY;
    }
    set textOY(oy) {
        var topTextOY = this.topTextOY;
        var bottomTextOY = this.bottomTextOY;
        var textOYExceedTop = this.textOYExceedTop(oy);
        var textOYExeceedBottom = this.textOYExeceedBottom(oy);
        if (this.clampTextOY) {
            if (this.visibleLinesCount > this.linesCount) oy = 0;
            else if (textOYExceedTop) oy = topTextOY;
            else if (textOYExeceedBottom) oy = bottomTextOY;
        }
        if (this._textOY !== oy) {
            this._textOY = oy;
            this.updateTextObject();
        }
        if (textOYExceedTop) {
            if (!this.execeedTopState) this.emit("execeedtop", this, oy, topTextOY);
        }
        this.execeedTopState = textOYExceedTop;
        if (textOYExeceedBottom) {
            if (!this.execeedBottomState) this.emit("execeedbottom", this, oy, bottomTextOY);
        }
        this.execeedBottomState = textOYExeceedBottom;
    }
    setTextOY(oy) {
        this.textOY = oy;
        return this;
    }
    set t(value) {
        this.textOY = -this.textVisibleHeight * value;
    }
    get t() {
        var textVisibleHeight = this.textVisibleHeight;
        if (textVisibleHeight === 0) return 0;
        return this.textOY / -textVisibleHeight;
    }
    setTextOYByPercentage(percentage) {
        this.t = percentage;
        return this;
    }
}
var $d3f931ef07450b80$var$CreateDefaultTextObject = function(scene) {
    return scene.add.text(0, 0, "");
};
Object.assign($d3f931ef07450b80$var$TextBlock.prototype, (0, $7b8d9247353c5aaa$export$2e2bcd8739ae039));
var $d3f931ef07450b80$export$2e2bcd8739ae039 = $d3f931ef07450b80$var$TextBlock;


var $74a561d5adb6660a$var$InjectProperties = function(textBlock) {
    Object.defineProperty(textBlock, "childOY", {
        configurable: true,
        get: function() {
            return textBlock.textOY;
        },
        set: function(value) {
            textBlock.textOY = value;
        }
    });
    Object.defineProperty(textBlock, "topChildOY", {
        get: function() {
            return textBlock.topTextOY;
        }
    });
    Object.defineProperty(textBlock, "bottomChildOY", {
        get: function() {
            return textBlock.bottomTextOY;
        }
    });
    Object.defineProperty(textBlock, "childVisibleHeight", {
        get: function() {
            return textBlock.textObjectHeight;
        }
    });
    Object.defineProperty(textBlock, "childHeight", {
        get: function() {
            return textBlock.textHeight;
        }
    });
};
var $74a561d5adb6660a$export$2e2bcd8739ae039 = $74a561d5adb6660a$var$InjectProperties;


var $2f10a911fc85a907$export$2e2bcd8739ae039 = {
    setText (text) {
        var textBlock = this.childrenMap.child;
        textBlock.setText(text);
        this.resizeController();
        return this;
    },
    appendText (text) {
        this.setText(this.text + text);
        return this;
    }
};


const $106dd4d30bc56f1d$var$Clamp = Phaser.Math.Clamp;
var $106dd4d30bc56f1d$export$2e2bcd8739ae039 = {
    scrollToLine (lineIndex) {
        this.setChildOY(-this.lineHeight * lineIndex);
        return this;
    },
    scrollToNextLine (lineCount) {
        if (lineCount === undefined) lineCount = 1;
        var lineIndex = this.lineIndex + lineCount;
        this.scrollToLine(lineIndex);
        return this;
    }
};


const $876c0af2debb51b1$var$GetValue = Phaser.Utils.Objects.GetValue;
class $876c0af2debb51b1$var$TextArea extends (0, $b48de4bdb562f812$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create text-block
        var textObject = $876c0af2debb51b1$var$GetValue(config, "text", undefined);
        var textWidth = $876c0af2debb51b1$var$GetValue(config, "textWidth", undefined);
        var textHeight = $876c0af2debb51b1$var$GetValue(config, "textHeight", undefined);
        var textCrop = $876c0af2debb51b1$var$GetValue(config, "textCrop", !!textObject.setCrop);
        var textMask = $876c0af2debb51b1$var$GetValue(config, "textMask", !textCrop);
        var content = $876c0af2debb51b1$var$GetValue(config, "content", "");
        var textBlock = new (0, $d3f931ef07450b80$export$2e2bcd8739ae039)(scene, {
            width: textWidth,
            height: textHeight,
            text: textObject,
            textMask: textMask,
            textCrop: textCrop && !textMask,
            content: content,
            clamplTextOY: $876c0af2debb51b1$var$GetValue(config, "clamplChildOY", false),
            alwaysScrollable: $876c0af2debb51b1$var$GetValue(config, "alwaysScrollable", false)
        });
        scene.add.existing(textBlock); // Important: Add to display list for touch detecting
        var proportion = textWidth === undefined ? 1 : 0;
        var expand = textHeight === undefined;
        // Inject properties for scrollable interface
        (0, $74a561d5adb6660a$export$2e2bcd8739ae039)(textBlock);
        // Fill config of scrollable
        config.scrollMode = 0; // Vertical
        config.type = "rexTextArea";
        config.child = {
            gameObject: textBlock,
            proportion: proportion,
            expand: expand
        };
        var spaceConfig = $876c0af2debb51b1$var$GetValue(config, "space", undefined);
        if (spaceConfig) spaceConfig.child = spaceConfig.text;
        super(scene, config);
        this.addChildrenMap("text", textObject);
    }
    get text() {
        return this.childrenMap.child.text;
    }
    get lineHeight() {
        var textBlock = this.childrenMap.child;
        return textBlock.textLineHeight + textBlock.textLineSpacing;
    }
    get lineIndex() {
        return Math.floor(-this.childOY / this.lineHeight);
    }
    get linesCount() {
        return this.childrenMap.child.linesCount;
    }
    get contentHeight() {
        return this.childrenMap.child.textHeight;
    }
}
Object.assign($876c0af2debb51b1$var$TextArea.prototype, (0, $2f10a911fc85a907$export$2e2bcd8739ae039), (0, $106dd4d30bc56f1d$export$2e2bcd8739ae039));
var $876c0af2debb51b1$export$2e2bcd8739ae039 = $876c0af2debb51b1$var$TextArea;


const $2cd8fece9cafb189$var$GetValue = Phaser.Utils.Objects.GetValue;
var $2cd8fece9cafb189$var$CreateTextArea = function(scene, config, creators) {
    config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
    var createBackground = $2cd8fece9cafb189$var$GetValue(creators, "background", (0, $855a17c75ce39274$export$2e2bcd8739ae039));
    var createText = $2cd8fece9cafb189$var$GetValue(creators, "text", (0, $bcf9b28c2e62c80a$export$2e2bcd8739ae039));
    var createTrack = $2cd8fece9cafb189$var$GetValue(creators, "track", (0, $855a17c75ce39274$export$2e2bcd8739ae039));
    var createThumb = $2cd8fece9cafb189$var$GetValue(creators, "thumb", (0, $855a17c75ce39274$export$2e2bcd8739ae039));
    if (createBackground) config.background = createBackground(scene, config.background);
    else delete config.background;
    if (createText) config.text = createText(scene, config.text);
    else delete config.text;
    var sliderConfig = config.slider;
    if (sliderConfig !== false) {
        if (sliderConfig === undefined) sliderConfig = {};
        if (createTrack) sliderConfig.track = createTrack(scene, sliderConfig.track);
        else delete sliderConfig.track;
        if (createThumb) sliderConfig.thumb = createThumb(scene, sliderConfig.thumb);
        else delete sliderConfig.thumb;
        config.slider = sliderConfig;
    }
    // No header
    // No footer
    var gameObject = new (0, $876c0af2debb51b1$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $2cd8fece9cafb189$export$2e2bcd8739ae039 = $2cd8fece9cafb189$var$CreateTextArea;


const $8a94ed5cb7c60c62$var$GetValue = Phaser.Utils.Objects.GetValue;
var $8a94ed5cb7c60c62$var$CreateContent = function(scene, config, creators) {
    var type = $8a94ed5cb7c60c62$var$GetValue(config, "$type");
    if (type === undefined) {
        if (config && (config.hasOwnProperty("slider") || config.hasOwnProperty("scroller"))) type = "textarea";
    }
    var gameObject;
    switch(type){
        case "textarea":
            gameObject = new (0, $2cd8fece9cafb189$export$2e2bcd8739ae039)(scene, config, creators);
            break;
        default:
            gameObject = new (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, config, creators);
            break;
    }
    scene.add.existing(gameObject);
    return gameObject;
};
var $8a94ed5cb7c60c62$export$2e2bcd8739ae039 = $8a94ed5cb7c60c62$var$CreateContent;





const $a28ade46188ccdb6$var$GetValue = Phaser.Utils.Objects.GetValue;
class $a28ade46188ccdb6$var$ConfirmDialog extends (0, $c21a8bce83a7363c$export$2e2bcd8739ae039) {
    constructor(scene, config, creators){
        config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
        if (creators === undefined) creators = {};
        var createBackground = $a28ade46188ccdb6$var$GetValue(creators, "background", (0, $855a17c75ce39274$export$2e2bcd8739ae039));
        if (createBackground) config.background = createBackground(scene, config.background);
        else delete config.background;
        config.title = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, config.title, creators.title);
        config.content = (0, $8a94ed5cb7c60c62$export$2e2bcd8739ae039)(scene, config.content, creators.content);
        if (config.content instanceof (0, $876c0af2debb51b1$export$2e2bcd8739ae039)) {
            if ((0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "height") && !(0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(config, "proportion.content")) (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(config, "proportion.content", 1);
        }
        var defaultButtonConfig = config.button;
        var buttonAConfig = config.buttonA || defaultButtonConfig;
        var buttonBConfig = config.buttonB || defaultButtonConfig;
        var buttonMode = config.buttonMode;
        if (buttonMode === undefined) buttonMode = !!buttonAConfig && !!buttonBConfig ? 2 : !!buttonAConfig ? 1 : 0;
        var defaultButtonCreator = creators.button;
        var buttonACreators = creators.buttonA || defaultButtonCreator;
        var buttonBCreators = creators.buttonB || defaultButtonCreator;
        switch(buttonMode){
            case 2:
                config.actions = [
                    (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, buttonAConfig, buttonACreators),
                    (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, buttonBConfig, buttonBCreators)
                ];
                break;
            case 1:
                config.actions = [
                    (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, buttonAConfig, buttonACreators)
                ];
                break;
            case 0:
                break;
            default:
                config.actions = [];
                break;
        }
        var defaultChoiceConfig = config.choice;
        if (defaultChoiceConfig) config.choices = [];
        super(scene, config);
        this.type = "rexConfirmDialog";
        this.buttonMode = buttonMode;
        this.defaultActionConfig = defaultButtonConfig;
        this.defaultActionButtonCreator = defaultButtonCreator;
        this.defaultChoiceConfig = defaultChoiceConfig;
        this.defaultChoiceCreator = creators.choice;
        var buttons = this.childrenMap.actions;
        this.addChildrenMap("buttonA", buttons ? buttons[0] : null);
        this.addChildrenMap("buttonB", buttons ? buttons[1] : null);
        // Interactive
        (0, $f59e0561d9a5961e$export$2e2bcd8739ae039).call(this);
    }
}
Object.assign($a28ade46188ccdb6$var$ConfirmDialog.prototype, (0, $bb3bf2853f9e2a94$export$2e2bcd8739ae039));
var $a28ade46188ccdb6$export$2e2bcd8739ae039 = $a28ade46188ccdb6$var$ConfirmDialog;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("confirmDialog", function(config, creators) {
    var gameObject = new (0, $a28ade46188ccdb6$export$2e2bcd8739ae039)(this.scene, config, creators);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ConfirmDialog", (0, $a28ade46188ccdb6$export$2e2bcd8739ae039));
var $98b718e9b7515314$export$2e2bcd8739ae039 = (0, $a28ade46188ccdb6$export$2e2bcd8739ae039);



/*
Elements:
    ```
    HHH
    LCR
    FFF
    ```
*/ const $ca8564f1e6e30145$var$GetValue = Phaser.Utils.Objects.GetValue;
var $ca8564f1e6e30145$var$GetAddChildConfig = function(config, key, defaultValues) {
    var proportion = $ca8564f1e6e30145$var$GetValue(config, `proportion.${key}`, defaultValues.proportion);
    var align = $ca8564f1e6e30145$var$GetValue(config, `align.${key}`, "center");
    var padding = $ca8564f1e6e30145$var$GetValue(config, `space.${key}`, undefined);
    if (typeof padding === "number" && defaultValues.paddingKey) {
        var paddingNum = padding;
        padding = {};
        padding[defaultValues.paddingKey] = paddingNum;
    }
    var expand = $ca8564f1e6e30145$var$GetValue(config, `expand.${key}`, true);
    return {
        proportion: proportion,
        align: align,
        padding: padding,
        expand: expand
    };
};
var $ca8564f1e6e30145$export$aad441ff9478c2b4 = function(config) {
    return $ca8564f1e6e30145$var$GetAddChildConfig(config, "header", {
        proportion: 0,
        paddingKey: "bottom"
    });
};
var $ca8564f1e6e30145$export$107dfca2a01416f1 = function(config) {
    return $ca8564f1e6e30145$var$GetAddChildConfig(config, "leftSide", {
        proportion: 0,
        paddingKey: "right"
    });
};
var $ca8564f1e6e30145$export$9161c48ee9ea43f9 = function(config) {
    return $ca8564f1e6e30145$var$GetAddChildConfig(config, "content", {
        proportion: 1
    });
};
var $ca8564f1e6e30145$export$6aad88f8c82e0eda = function(config) {
    return $ca8564f1e6e30145$var$GetAddChildConfig(config, "rightSide", {
        proportion: 0,
        paddingKey: "left"
    });
};
var $ca8564f1e6e30145$export$52beb3c7704732f4 = function(config) {
    return $ca8564f1e6e30145$var$GetAddChildConfig(config, "footer", {
        proportion: 0,
        paddingKey: "top"
    });
};
var $ca8564f1e6e30145$export$f9404bd3f885f5e = function(config) {
    return {
        proportion: 1,
        align: "center",
        padding: 0,
        expand: true
    };
};



var $0845f44975cf6941$var$CreatExpandContainer = function(scene, orientation) {
    var container = new (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039)(scene, {
        orientation: orientation
    });
    scene.add.existing(container);
    return container;
};
var $0845f44975cf6941$export$2e2bcd8739ae039 = $0845f44975cf6941$var$CreatExpandContainer;


var $d5b95b397936ec36$var$LayoutMode0 = function(config) {
    var scene = this.scene;
    // Add Header
    var header = config.header;
    if (header) this.add(header, (0, $ca8564f1e6e30145$export$aad441ff9478c2b4)(config));
    /*
    L C R
    */ var bodySizer = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    this.add(bodySizer, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add Left-side
    var leftSide = config.leftSide;
    if (leftSide) bodySizer.add(leftSide, (0, $ca8564f1e6e30145$export$107dfca2a01416f1)(config));
    // Add content
    var content = config.content;
    if (content) bodySizer.add(content, (0, $ca8564f1e6e30145$export$9161c48ee9ea43f9)(config));
    // Add Right-side
    var rightSide = config.rightSide;
    if (rightSide) bodySizer.add(rightSide, (0, $ca8564f1e6e30145$export$6aad88f8c82e0eda)(config));
    // Add Footer
    var footer = config.footer;
    if (footer) this.add(footer, (0, $ca8564f1e6e30145$export$52beb3c7704732f4)(config));
};
var $d5b95b397936ec36$export$2e2bcd8739ae039 = $d5b95b397936ec36$var$LayoutMode0;


/*
Elements:
    ```
    HHH
    LCR
    LFF
    ```
*/ 

var $5327df4f4a6f8208$var$LayoutMode1 = function(config) {
    var scene = this.scene;
    // Add Header
    var header = config.header;
    if (header) this.add(header, (0, $ca8564f1e6e30145$export$aad441ff9478c2b4)(config));
    /*
    L CR
    L FF
    */ var bodySizer0 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    this.add(bodySizer0, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add Left-side
    var leftSide = config.leftSide;
    if (leftSide) bodySizer0.add(leftSide, (0, $ca8564f1e6e30145$export$107dfca2a01416f1)(config));
    /*
    CR

    FF
    */ var bodySizer1 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 1);
    bodySizer0.add(bodySizer1, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    /*
    C R
    */ var bodySizer2 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    bodySizer1.add(bodySizer2, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add content
    var content = config.content;
    if (content) bodySizer2.add(content, (0, $ca8564f1e6e30145$export$9161c48ee9ea43f9)(config));
    // Add Right-side
    var rightSide = config.rightSide;
    if (rightSide) bodySizer2.add(rightSide, (0, $ca8564f1e6e30145$export$6aad88f8c82e0eda)(config));
    // Add Footer
    var footer = config.footer;
    if (footer) bodySizer1.add(footer, (0, $ca8564f1e6e30145$export$52beb3c7704732f4)(config));
};
var $5327df4f4a6f8208$export$2e2bcd8739ae039 = $5327df4f4a6f8208$var$LayoutMode1;


/*
Elements:
    ```
    HHH
    LCR
    FFR
    ```
*/ 

var $aad48020f92ba24d$var$LayoutMode2 = function(config) {
    var scene = this.scene;
    // Add Header
    var header = config.header;
    if (header) this.add(header, (0, $ca8564f1e6e30145$export$aad441ff9478c2b4)(config));
    /*
    LC R
    FF R
    */ var bodySizer0 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    this.add(bodySizer0, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    /*
    LC

    FF
    */ var bodySizer1 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 1);
    bodySizer0.add(bodySizer1, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    /*
    L C
    */ var bodySizer2 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    bodySizer1.add(bodySizer2, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add Left-side
    var leftSide = config.leftSide;
    if (leftSide) bodySizer2.add(leftSide, (0, $ca8564f1e6e30145$export$107dfca2a01416f1)(config));
    // Add content
    var content = config.content;
    if (content) bodySizer2.add(content, (0, $ca8564f1e6e30145$export$9161c48ee9ea43f9)(config));
    // Add Footer
    var footer = config.footer;
    if (footer) bodySizer1.add(footer, (0, $ca8564f1e6e30145$export$52beb3c7704732f4)(config));
    // Add Right-side
    var rightSide = config.rightSide;
    if (rightSide) bodySizer0.add(rightSide, (0, $ca8564f1e6e30145$export$6aad88f8c82e0eda)(config));
};
var $aad48020f92ba24d$export$2e2bcd8739ae039 = $aad48020f92ba24d$var$LayoutMode2;


/*
Elements:
    ```
    HHH
    LCR
    LFR
    ```
*/ 

var $5f5b8bfb86848966$var$LayoutMode0 = function(config) {
    var scene = this.scene;
    // Add Header
    var header = config.header;
    if (header) this.add(header, (0, $ca8564f1e6e30145$export$aad441ff9478c2b4)(config));
    /*
    L C R
    L F R
    */ var bodySizer0 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 0);
    this.add(bodySizer0, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add Left-side
    var leftSide = config.leftSide;
    if (leftSide) bodySizer0.add(leftSide, (0, $ca8564f1e6e30145$export$107dfca2a01416f1)(config));
    /*
    C

    F
    */ var bodySizer1 = (0, $0845f44975cf6941$export$2e2bcd8739ae039)(scene, 1);
    bodySizer0.add(bodySizer1, (0, $ca8564f1e6e30145$export$f9404bd3f885f5e)(config));
    // Add content
    var content = config.content;
    if (content) bodySizer1.add(content, (0, $ca8564f1e6e30145$export$9161c48ee9ea43f9)(config));
    // Add Footer
    var footer = config.footer;
    if (footer) bodySizer1.add(footer, (0, $ca8564f1e6e30145$export$52beb3c7704732f4)(config));
    // Add Right-side
    var rightSide = config.rightSide;
    if (rightSide) bodySizer0.add(rightSide, (0, $ca8564f1e6e30145$export$6aad88f8c82e0eda)(config));
};
var $5f5b8bfb86848966$export$2e2bcd8739ae039 = $5f5b8bfb86848966$var$LayoutMode0;


const $8f0fbfdfa5057cff$var$GetValue = Phaser.Utils.Objects.GetValue;
const $8f0fbfdfa5057cff$var$LayoutCallbacks = [
    (0, $d5b95b397936ec36$export$2e2bcd8739ae039),
    (0, $5327df4f4a6f8208$export$2e2bcd8739ae039),
    (0, $aad48020f92ba24d$export$2e2bcd8739ae039),
    (0, $5f5b8bfb86848966$export$2e2bcd8739ae039)
];
var $8f0fbfdfa5057cff$var$Build = function(config) {
    this.clear(true);
    // Add Background
    var background = $8f0fbfdfa5057cff$var$GetValue(config, "background", undefined);
    if (background) this.addBackground(background);
    var layoutMode = $8f0fbfdfa5057cff$var$GetValue(config, "layoutMode", 0);
    if (typeof layoutMode === "string") layoutMode = $8f0fbfdfa5057cff$var$LayoutModesMap[layoutMode.toUpperCase()];
    var layoutCallback = $8f0fbfdfa5057cff$var$LayoutCallbacks[layoutMode] || $8f0fbfdfa5057cff$var$LayoutCallbacks[0];
    layoutCallback.call(this, config);
    this.addChildrenMap("background", config.background);
    this.addChildrenMap("header", config.header);
    this.addChildrenMap("leftSide", config.leftSide);
    this.addChildrenMap("content", config.content);
    this.addChildrenMap("rightSide", config.rightSide);
    this.addChildrenMap("footer", config.footer);
};
const $8f0fbfdfa5057cff$var$LayoutModesMap = {
    "FFF": 0,
    "LFF": 1,
    "FFR": 2,
    "LFR": 3
};
var $8f0fbfdfa5057cff$export$2e2bcd8739ae039 = $8f0fbfdfa5057cff$var$Build;


class $10c56e8ed684d538$var$HolyGrail extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        config.orientation = 1; // top-to-bottom
        // Create sizer
        super(scene, config);
        this.type = "rexHolyGrail";
        this.build(config);
    }
}
var $10c56e8ed684d538$var$methods = {
    build: (0, $8f0fbfdfa5057cff$export$2e2bcd8739ae039)
};
Object.assign($10c56e8ed684d538$var$HolyGrail.prototype, $10c56e8ed684d538$var$methods);
var $10c56e8ed684d538$export$2e2bcd8739ae039 = $10c56e8ed684d538$var$HolyGrail;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("holyGrail", function(config) {
    var gameObject = new (0, $10c56e8ed684d538$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.HolyGrail", (0, $10c56e8ed684d538$export$2e2bcd8739ae039));
var $73c8ac6af393cfc7$export$2e2bcd8739ae039 = (0, $10c56e8ed684d538$export$2e2bcd8739ae039);





var $9d977ede84125a89$export$2e2bcd8739ae039 = {
    getButtonsSizer (groupName) {
        return this.childrenMap[`${groupName}ButtonsSizer`];
    },
    getButton (groupName, index) {
        var buttonsSizer = this.getButtonsSizer(groupName);
        return buttonsSizer ? buttonsSizer.getButton(index) : undefined;
    },
    setButtonEnable (groupName, index, enabled) {
        this.getButtonsSizer(groupName).setButtonEnable(index, enabled);
        return this;
    },
    setLeftButtonEnable (index, enabled) {
        this.childrenMap.leftButtonsSizer.setButtonEnable(index, enabled);
        return this;
    },
    setRightButtonEnable (index, enabled) {
        this.childrenMap.rightButtonsSizer.setButtonEnable(index, enabled);
        return this;
    },
    setTopButtonEnable (index, enabled) {
        this.childrenMap.topButtonsSizer.setButtonEnable(index, enabled);
        return this;
    },
    setBottomButtonEnable (index, enabled) {
        this.childrenMap.bottomButtonsSizer.setButtonEnable(index, enabled);
        return this;
    },
    toggleButtonEnable (groupName, index) {
        this.getButtonsSizer(groupName).toggleButtonEnable(index);
        return this;
    },
    toggleLeftButtonEnable (index) {
        this.childrenMap.leftButtonsSizer.toggleButtonEnable(index);
        return this;
    },
    toggleRightButtonEnable (index) {
        this.childrenMap.rightButtonsSizer.toggleButtonEnable(index);
        return this;
    },
    toggleTopButtonEnable (index) {
        this.childrenMap.topButtonsSizer.toggleButtonEnable(index);
        return this;
    },
    toggleBottomButtonEnable (index) {
        this.childrenMap.bottomButtonsSizer.toggleButtonEnable(index);
        return this;
    },
    getButtonEnable (groupName, index) {
        return this.getButtonsSizer(groupName).getButtonEnable(index);
    },
    getLeftButtonEnable (index) {
        return this.childrenMap.leftButtonsSizer.getButtonEnable(index);
    },
    getRightButtonEnable (index) {
        return this.childrenMap.rightButtonsSizer.getButtonEnable(index);
    },
    getTopButtonEnable (index) {
        return this.childrenMap.topButtonsSizer.getButtonEnable(index);
    },
    getBottomButtonEnable (index) {
        return this.childrenMap.bottomButtonsSizer.getButtonEnable(index);
    },
    emitButtonClick (groupName, index) {
        var buttonsSizer = this.getButtonsSizer(groupName);
        if (!buttonsSizer) return this;
        buttonsSizer.emitButtonClick(index);
        return this;
    },
    emitLeftButtonClick (index) {
        this.childrenMap.leftButtonsSizer.emitButtonClick(index);
        return this;
    },
    emitRightButtonClick (index) {
        this.childrenMap.rightButtonsSizer.emitButtonClick(index);
        return this;
    },
    emitTopButtonClick (index) {
        this.childrenMap.topButtonsSizer.emitButtonClick(index);
        return this;
    },
    emitBottomButtonClick (index) {
        this.childrenMap.bottomButtonsSizer.emitButtonClick(index);
        return this;
    },
    getLeftButton (index) {
        return this.childrenMap.leftButtonsSizer.getButton(index);
    },
    getRightButton (index) {
        return this.childrenMap.rightButtonsSizer.getButton(index);
    },
    getTopButton (index) {
        return this.childrenMap.topButtonsSizer.getButton(index);
    },
    getBottomButton (index) {
        return this.childrenMap.bottomButtonsSizer.getButton(index);
    },
    showButton (groupName, index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getButton(groupName, index));
        return this;
    },
    showLeftButton (index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getLeftButton(index));
        return this;
    },
    showRightButton (index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getRightButton(index));
        return this;
    },
    showTopButton (index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getTopButton(index));
        return this;
    },
    showBottomButton (index) {
        (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819)(this.getBottomButton(index));
        return this;
    },
    hideButton (groupName, index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getButton(groupName, index));
        return this;
    },
    hideLeftButton (index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getLeftButton(index));
        return this;
    },
    hideRightButton (index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getRightButton(index));
        return this;
    },
    hideTopButton (index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getTopButton(index));
        return this;
    },
    hideBottomButton (index) {
        (0, $f55461eb0d33b5f5$export$bed28288a051538)(this.getBottomButton(index));
        return this;
    },
    addButton (groupName, gameObject) {
        this.getButtonsSizer(groupName).addButton(gameObject);
        return this;
    },
    addLeftButton (gameObject) {
        this.addButton("left", gameObject);
        return this;
    },
    addRightButton (gameObject) {
        this.addButton("right", gameObject);
        return this;
    },
    addTopButton (gameObject) {
        this.addButton("top", gameObject);
        return this;
    },
    removeButton (groupName, index, destroyChild) {
        this.getButtonsSizer(groupName).removeButton(index, destroyChild);
        return this;
    },
    removeLeftButton (index, destroyChild) {
        this.removeButton("left", index, destroyChild);
        return this;
    },
    removeRightButton (index, destroyChild) {
        this.removeButton("right", index, destroyChild);
        return this;
    },
    removeTopButton (index, destroyChild) {
        this.removeButton("top", index, destroyChild);
        return this;
    },
    removeBottomButton (index, destroyChild) {
        this.removeButton("bottom", index, destroyChild);
        return this;
    },
    clearButtons (groupName, destroyChild) {
        this.getButtonsSizer(groupName).clearButtons(destroyChild);
        return this;
    },
    clearLeftButtons (destroyChild) {
        this.clearButtons("left", destroyChild);
        return this;
    },
    clearRightButtons (destroyChild) {
        this.clearButtons("right", destroyChild);
        return this;
    },
    clearTopButtons (destroyChild) {
        this.clearButtons("top", destroyChild);
        return this;
    },
    clearBottomButtonss (destroyChild) {
        this.clearButtons("bottom", destroyChild);
        return this;
    },
    forEachButton (groupName, callback, scope) {
        this.getButtonsSizer(groupName).forEachButtton(callback, scope);
        return this;
    },
    forEachLeftButton (callback, scope) {
        this.childrenMap.leftButtonsSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachRightButton (callback, scope) {
        this.childrenMap.rightButtonsSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachTopButton (callback, scope) {
        this.childrenMap.topButtonsSizer.forEachButtton(callback, scope);
        return this;
    },
    forEachBottomButton (callback, scope) {
        this.childrenMap.bottomButtonsSizer.forEachButtton(callback, scope);
        return this;
    }
};


const $0f6ec962fc4b1b22$var$GetValue = Phaser.Utils.Objects.GetValue;
class $0f6ec962fc4b1b22$var$Tabs extends (0, $a949ee088f929daa$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create sizer
        config.column = 3;
        config.row = 3;
        super(scene, config);
        this.type = "rexTabs";
        this.eventEmitter = $0f6ec962fc4b1b22$var$GetValue(config, "eventEmitter", this);
        // Add elements
        var background = $0f6ec962fc4b1b22$var$GetValue(config, "background", undefined);
        var panel = $0f6ec962fc4b1b22$var$GetValue(config, "panel", undefined);
        var leftButtons = $0f6ec962fc4b1b22$var$GetValue(config, "leftButtons", undefined);
        var leftButtonsBackground = $0f6ec962fc4b1b22$var$GetValue(config, "leftButtonsBackground", undefined);
        var leftButtonsSizer;
        var rightButtons = $0f6ec962fc4b1b22$var$GetValue(config, "rightButtons", undefined);
        var rightButtonsBackground = $0f6ec962fc4b1b22$var$GetValue(config, "rightButtonsBackground", undefined);
        var rightButtonsSizer;
        var topButtons = $0f6ec962fc4b1b22$var$GetValue(config, "topButtons", undefined);
        var topButtonsBackground = $0f6ec962fc4b1b22$var$GetValue(config, "topButtonsBackground", undefined);
        var topButtonsSizer;
        var bottomButtons = $0f6ec962fc4b1b22$var$GetValue(config, "bottomButtons", undefined);
        var bottomButtonsBackground = $0f6ec962fc4b1b22$var$GetValue(config, "bottomButtonsBackground", undefined);
        var bottomButtonsSizer;
        var clickConfig = $0f6ec962fc4b1b22$var$GetValue(config, "click", undefined);
        if (background) this.addBackground(background);
        if (panel) this.add(panel, 1, 1, "center", 0, true);
        if (leftButtons) {
            var leftButtonsOffset = $0f6ec962fc4b1b22$var$GetValue(config, "space.leftButtonsOffset", 0);
            var leftButtonSpace = $0f6ec962fc4b1b22$var$GetValue(config, "space.leftButton", 0);
            leftButtonsSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
                groupName: "left",
                background: leftButtonsBackground,
                buttons: leftButtons,
                orientation: 1,
                space: {
                    item: leftButtonSpace
                },
                align: $0f6ec962fc4b1b22$var$GetValue(config, "align.leftButtons", undefined),
                click: clickConfig,
                eventEmitter: this.eventEmitter
            });
            var padding = {
                top: leftButtonsOffset
            };
            this.add(leftButtonsSizer, 0, 1, "top", padding, false);
        }
        if (rightButtons) {
            var rightButtonsOffset = $0f6ec962fc4b1b22$var$GetValue(config, "space.rightButtonsOffset", 0);
            var rightButtonSpace = $0f6ec962fc4b1b22$var$GetValue(config, "space.rightButton", 0);
            rightButtonsSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
                groupName: "right",
                background: rightButtonsBackground,
                buttons: rightButtons,
                orientation: 1,
                space: {
                    item: rightButtonSpace
                },
                align: $0f6ec962fc4b1b22$var$GetValue(config, "align.rightButtons", undefined),
                click: clickConfig,
                eventEmitter: this.eventEmitter
            });
            var padding = {
                top: rightButtonsOffset
            };
            this.add(rightButtonsSizer, 2, 1, "top", padding, false);
        }
        if (topButtons) {
            var toptButtonsOffset = $0f6ec962fc4b1b22$var$GetValue(config, "space.topButtonsOffset", 0);
            var topButtonSpace = $0f6ec962fc4b1b22$var$GetValue(config, "space.topButton", 0);
            topButtonsSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
                groupName: "top",
                background: topButtonsBackground,
                buttons: topButtons,
                orientation: 0,
                space: {
                    item: topButtonSpace
                },
                align: $0f6ec962fc4b1b22$var$GetValue(config, "align.topButtons", undefined),
                click: clickConfig,
                eventEmitter: this.eventEmitter
            });
            var padding = {
                left: toptButtonsOffset
            };
            this.add(topButtonsSizer, 1, 0, "left", padding, false);
        }
        if (bottomButtons) {
            var bottomButtonsOffset = $0f6ec962fc4b1b22$var$GetValue(config, "space.bottomButtonsOffset", 0);
            var bottomButtonSpace = $0f6ec962fc4b1b22$var$GetValue(config, "space.bottomButton", 0);
            bottomButtonsSizer = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
                groupName: "bottom",
                background: bottomButtonsBackground,
                buttons: bottomButtons,
                orientation: 0,
                space: {
                    item: bottomButtonSpace
                },
                align: $0f6ec962fc4b1b22$var$GetValue(config, "align.bottomButtons", undefined),
                click: clickConfig,
                eventEmitter: this.eventEmitter
            });
            var padding = {
                left: bottomButtonsOffset
            };
            this.add(bottomButtonsSizer, 1, 2, "left", padding, false);
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("panel", panel);
        this.addChildrenMap("leftButtons", leftButtons);
        this.addChildrenMap("rightButtons", rightButtons);
        this.addChildrenMap("topButtons", topButtons);
        this.addChildrenMap("bottomButtons", bottomButtons);
        this.addChildrenMap("leftButtonsSizer", leftButtonsSizer);
        this.addChildrenMap("rightButtonsSizer", rightButtonsSizer);
        this.addChildrenMap("topButtonsSizer", topButtonsSizer);
        this.addChildrenMap("bottomButtonsSizer", bottomButtonsSizer);
    }
}
Object.assign($0f6ec962fc4b1b22$var$Tabs.prototype, (0, $9d977ede84125a89$export$2e2bcd8739ae039));
var $0f6ec962fc4b1b22$export$2e2bcd8739ae039 = $0f6ec962fc4b1b22$var$Tabs;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("tabs", function(config) {
    var gameObject = new (0, $0f6ec962fc4b1b22$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Tabs", (0, $0f6ec962fc4b1b22$export$2e2bcd8739ae039));
var $605ead071b730768$export$2e2bcd8739ae039 = (0, $0f6ec962fc4b1b22$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("slider", function(config) {
    var gameObject = new (0, $acd4b431e3164bd7$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Slider", (0, $acd4b431e3164bd7$export$2e2bcd8739ae039));
var $1d0335a7f1a4e011$export$2e2bcd8739ae039 = (0, $acd4b431e3164bd7$export$2e2bcd8739ae039);





var $33ac7365ebc77ac6$export$2e2bcd8739ae039 = (0, $339617a0d54a0874$export$2e2bcd8739ae039);


var $56fc1f11618f750f$var$InjectProperties = function(table) {
    Object.defineProperty(table, "childOY", {
        configurable: true,
        get: function() {
            return table.tableOY;
        },
        set: function(value) {
            table.tableOY = value;
        }
    });
    Object.defineProperty(table, "topChildOY", {
        get: function() {
            return table.topTableOY;
        }
    });
    Object.defineProperty(table, "bottomChildOY", {
        get: function() {
            return table.bottomTableOY;
        }
    });
    Object.defineProperty(table, "childVisibleHeight", {
        get: function() {
            return table.instHeight;
        }
    });
    Object.defineProperty(table, "childHeight", {
        get: function() {
            return table.tableHeight;
        }
    });
};
var $56fc1f11618f750f$export$2e2bcd8739ae039 = $56fc1f11618f750f$var$InjectProperties;


var $4e8abf2d1220b3fd$var$TableOnCellVisible = function(table) {
    table.on("cellvisible", function(cell, cellContainer, table) {
        var callback = this.createCellContainerCallback;
        var scope = this.createCellContainerCallbackScope;
        cell.item = this.items[cell.index];
        cell.items = this.items;
        var cellContainer;
        if (scope) cellContainer = callback.call(scope, cell, cellContainer, table);
        else cellContainer = callback(cell, cellContainer, table);
        if (cellContainer) {
            if (cell.cellContainerAlign == null && cellContainer.setOrigin) cellContainer.setOrigin(0);
            if (cellContainer.isRexSizer) cellContainer.layout(); // Use original size
        }
        cell.item = undefined;
        cell.items = undefined;
        cell.setContainer(cellContainer);
    }, this);
};
var $4e8abf2d1220b3fd$export$2e2bcd8739ae039 = $4e8abf2d1220b3fd$var$TableOnCellVisible;


var $85bdede747120ec4$var$EmitCellEvent = function(eventEmitter, eventName, table, x, y, pointer, event) {
    var cellIndex;
    if (y === undefined) cellIndex = x;
    else cellIndex = table.pointToCellIndex(x, y);
    if (cellIndex === null || cellIndex === undefined) return;
    var cellContainer = table.getCellContainer(cellIndex);
    if (cellContainer) eventEmitter.emit(eventName, cellContainer, cellIndex, pointer, event);
};
var $85bdede747120ec4$export$2e2bcd8739ae039 = $85bdede747120ec4$var$EmitCellEvent;


var $450e772d543802e3$var$PointerUpDownCell = function(table, tableConfig) {
    table.on("pointerdown", function(pointer, localX, localY, event) {
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.down", table, pointer.worldX, pointer.worldY, pointer, event);
    }, this).on("pointerup", function(pointer, localX, localY, event) {
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.up", table, pointer.worldX, pointer.worldY, pointer, event);
    }, this);
};
var $450e772d543802e3$export$2e2bcd8739ae039 = $450e772d543802e3$var$PointerUpDownCell;



var $14591210dbc111d1$var$OverCell = function(table, tableConfig) {
    table.on("pointermove", $14591210dbc111d1$var$OnMove, this).on("pointerover", $14591210dbc111d1$var$OnMove, this).on("pointerout", $14591210dbc111d1$var$OnOut, this) // pointer-up is included too
    ;
};
var $14591210dbc111d1$var$OnMove = function(pointer, localX, localY, event) {
    var table = this.childrenMap.child;
    var cellIndex = table.pointToCellIndex(pointer.worldX, pointer.worldY);
    if (cellIndex === table.input.lastOverCellIndex) return;
    var preCellIndex = table.input.lastOverCellIndex;
    table.input.lastOverCellIndex = cellIndex;
    (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.out", table, preCellIndex, undefined, pointer, event);
    (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.over", table, cellIndex, undefined, pointer, event);
};
var $14591210dbc111d1$var$OnOut = function(pointer, event) {
    var table = this.childrenMap.child;
    var cellIndex = table.input.lastOverCellIndex;
    table.input.lastOverCellIndex = undefined;
    (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.out", table, cellIndex, undefined, pointer, event);
};
var $14591210dbc111d1$export$2e2bcd8739ae039 = $14591210dbc111d1$var$OverCell;




const $d20a36998d7fd2b5$var$GetValue = Phaser.Utils.Objects.GetValue;
var $d20a36998d7fd2b5$var$ClickCell = function(table, tableConfig) {
    var buttonConfig = $d20a36998d7fd2b5$var$GetValue(tableConfig, "click", undefined);
    if (buttonConfig === false) return;
    else if (buttonConfig === undefined) buttonConfig = {};
    buttonConfig.threshold = 10;
    table._click = new (0, $d7386e5b0e39fd99$export$2e2bcd8739ae039)(table, buttonConfig);
    table._click.on("click", function(button, gameObject, pointer, event) {
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.click", gameObject, pointer.worldX, pointer.worldY, pointer, event);
    }, this);
};
var $d20a36998d7fd2b5$export$2e2bcd8739ae039 = $d20a36998d7fd2b5$var$ClickCell;




const $abca576e572a3acd$var$GetValue = Phaser.Utils.Objects.GetValue;
var $abca576e572a3acd$var$TapCell = function(table, tableConfig) {
    var tapConfig = $abca576e572a3acd$var$GetValue(tableConfig, "tap", undefined);
    if (tapConfig === false) return;
    table._tap = new (0, $b0329087b2ba8053$export$2e2bcd8739ae039)(table, tapConfig);
    table._tap.on("tap", function(tap, gameObject, lastPointer) {
        var eventName = `cell.${tap.tapsCount}tap`;
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, eventName, tap.gameObject, tap.worldX, tap.worldY, lastPointer);
    }, this);
};
var $abca576e572a3acd$export$2e2bcd8739ae039 = $abca576e572a3acd$var$TapCell;




const $8761d0e2b23609c7$var$GetValue = Phaser.Utils.Objects.GetValue;
var $8761d0e2b23609c7$var$PressCell = function(table, tableConfig) {
    var pressConfig = $8761d0e2b23609c7$var$GetValue(tableConfig, "press", undefined);
    if (pressConfig === false) return;
    table._press = new (0, $4ba3c2f484e52118$export$2e2bcd8739ae039)(table, pressConfig);
    table._press.on("pressstart", function(press, gameObject, lastPointer) {
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.pressstart", table, press.worldX, press.worldY, lastPointer);
    }, this).on("pressend", function(press, gameObject, lastPointer) {
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, "cell.pressend", table, press.worldX, press.worldY, lastPointer);
    }, this);
};
var $8761d0e2b23609c7$export$2e2bcd8739ae039 = $8761d0e2b23609c7$var$PressCell;




const $ba47915dc454db85$var$GetValue = Phaser.Utils.Objects.GetValue;
var $ba47915dc454db85$var$SwipeCell = function(table, tableConfig) {
    var swipeConfig = $ba47915dc454db85$var$GetValue(tableConfig, "swipe", undefined);
    if (swipeConfig === false) return;
    else if (swipeConfig === undefined) swipeConfig = {};
    swipeConfig.dir = "4dir";
    table._swipe = new (0, $e375a08b6454e44f$export$2e2bcd8739ae039)(table, swipeConfig);
    table._swipe.on("swipe", function(swipe, gameObject, lastPointer) {
        var dirName = swipe.left ? "left" : swipe.right ? "right" : swipe.up ? "up" : "down";
        (0, $85bdede747120ec4$export$2e2bcd8739ae039)(this.eventEmitter, `cell.swipe${dirName}`, table, swipe.worldX, swipe.worldY, lastPointer);
    }, this);
};
var $ba47915dc454db85$export$2e2bcd8739ae039 = $ba47915dc454db85$var$SwipeCell;


var $fd39a66e267b3262$var$TableSetInteractive = function(table, tableConfig) {
    table.setInteractive();
    (0, $450e772d543802e3$export$2e2bcd8739ae039).call(this, table, tableConfig);
    (0, $14591210dbc111d1$export$2e2bcd8739ae039).call(this, table, tableConfig);
    (0, $d20a36998d7fd2b5$export$2e2bcd8739ae039).call(this, table, tableConfig);
    (0, $abca576e572a3acd$export$2e2bcd8739ae039).call(this, table, tableConfig);
    (0, $8761d0e2b23609c7$export$2e2bcd8739ae039).call(this, table, tableConfig);
    (0, $ba47915dc454db85$export$2e2bcd8739ae039).call(this, table, tableConfig);
};
var $fd39a66e267b3262$export$2e2bcd8739ae039 = $fd39a66e267b3262$var$TableSetInteractive;



var $2feb33c79daab760$var$SetItems = function(items) {
    if (items === undefined) this.items = [];
    else this.items = items;
    var table = this.childrenMap.child;
    table.setCellsCount(this.items.length);
    table.updateTable(true);
    this.resizeController();
    return this;
};
var $2feb33c79daab760$export$2e2bcd8739ae039 = $2feb33c79daab760$var$SetItems;


var $b4f167dd7ba1a2c3$export$2e2bcd8739ae039 = {
    scrollToRow (rowIndex) {
        var table = this.childrenMap.child;
        table.scrollToRow(rowIndex);
        return this;
    },
    scrollToNextRow (rowCount) {
        var table = this.childrenMap.child;
        table.scrollToNextRow(rowCount);
        return this;
    }
};


const $d4e362fc74c31208$var$GetValue = Phaser.Utils.Objects.GetValue;
class $d4e362fc74c31208$var$GridTable extends (0, $b48de4bdb562f812$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create grid table core
        var scrollMode = (0, $391df8fa33f776dd$export$2e2bcd8739ae039)(config);
        var tableConfig = $d4e362fc74c31208$var$GetValue(config, "table", undefined);
        if (tableConfig === undefined) tableConfig = {};
        tableConfig.scrollMode = scrollMode;
        tableConfig.clamplTableOXY = $d4e362fc74c31208$var$GetValue(config, "clamplChildOY", false);
        var tableWidth = $d4e362fc74c31208$var$GetValue(tableConfig, "width", undefined);
        var tableHeight = $d4e362fc74c31208$var$GetValue(tableConfig, "height", undefined);
        var table = new (0, $33ac7365ebc77ac6$export$2e2bcd8739ae039)(scene, 0, 0, tableWidth, tableHeight, tableConfig);
        scene.add.existing(table); // Important: Add to display list for touch detecting
        var proportion, expand;
        if (scrollMode === 0) {
            proportion = tableWidth === undefined ? 1 : 0;
            expand = tableHeight === undefined;
        } else {
            proportion = tableHeight === undefined ? 1 : 0;
            expand = tableWidth === undefined;
        }
        // Inject properties for scrollable interface
        (0, $56fc1f11618f750f$export$2e2bcd8739ae039)(table);
        // Set minWidth/minHeight to 0 if tableWidth/tableHeight is undefined
        table.minWidth = tableWidth === undefined ? 0 : undefined;
        table.minHeight = tableHeight === undefined ? 0 : undefined;
        // Fill config of scrollable
        config.type = "rexGridTable";
        config.child = {
            gameObject: table,
            proportion: proportion,
            expand: expand
        };
        var spaceConfig = $d4e362fc74c31208$var$GetValue(config, "space", undefined);
        if (spaceConfig) spaceConfig.child = spaceConfig.table;
        super(scene, config);
        this.addChildrenMap("table", table);
        this.addChildrenMap("tableLayer", table.maskLayer);
        this.eventEmitter = $d4e362fc74c31208$var$GetValue(config, "eventEmitter", this);
        var callback = $d4e362fc74c31208$var$GetValue(config, "createCellContainerCallback", (0, $990223f7da3447ad$export$2e2bcd8739ae039));
        var scope = $d4e362fc74c31208$var$GetValue(config, "createCellContainerCallbackScope", undefined);
        this.setCreateCellContainerCallback(callback, scope);
        (0, $4e8abf2d1220b3fd$export$2e2bcd8739ae039).call(this, table);
        this.resizeControllerFlag = false;
        var eventName = scrollMode === 0 ? "cellheightchange" : "cellwidthchange";
        table.on(eventName, function() {
            this.resizeControllerFlag = true;
        }, this);
        if ($d4e362fc74c31208$var$GetValue(tableConfig, "interactive", true)) (0, $fd39a66e267b3262$export$2e2bcd8739ae039).call(this, table, tableConfig);
        this.setItems($d4e362fc74c31208$var$GetValue(config, "items", []));
        scene.game.events.on("poststep", this.onPostStep, this);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.scene.game.events.off("poststep", this.onPostStep, this);
        super.destroy(fromScene);
    }
    setCreateCellContainerCallback(callback, scope) {
        this.createCellContainerCallback = callback;
        this.createCellContainerCallbackScope = scope;
        return this;
    }
    refresh() {
        this.setItems(this.items);
        return this;
    }
    getCell(cellIdx) {
        var table = this.childrenMap.child;
        return table.getCell(cellIdx);
    }
    getCellContainer(cellIdx) {
        var table = this.childrenMap.child;
        return table.getCellContainer(cellIdx);
    }
    updateVisibleCell(cellIdx) {
        var table = this.childrenMap.child;
        return table.updateVisibleCell(cellIdx);
    }
    onPostStep() {
        if (this.resizeControllerFlag) {
            this.resizeController();
            this.resizeControllerFlag = false;
        }
    }
    get startRowIndex() {
        var table = this.childrenMap.child;
        return table.startRowIndex;
    }
}
var $d4e362fc74c31208$var$methods = {
    setItems: (0, $2feb33c79daab760$export$2e2bcd8739ae039)
};
Object.assign($d4e362fc74c31208$var$GridTable.prototype, (0, $b4f167dd7ba1a2c3$export$2e2bcd8739ae039), $d4e362fc74c31208$var$methods);
var $d4e362fc74c31208$export$2e2bcd8739ae039 = $d4e362fc74c31208$var$GridTable;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("gridTable", function(config) {
    var gameObject = new (0, $d4e362fc74c31208$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.GridTable", (0, $d4e362fc74c31208$export$2e2bcd8739ae039));
var $aae7fadc26270552$export$2e2bcd8739ae039 = (0, $d4e362fc74c31208$export$2e2bcd8739ae039);



var $5530b77fd309ef37$var$GetEaseConfig = function(easeConfig, menu) {
    if (easeConfig.sameOrientation) easeConfig.orientation = menu.orientation;
    else easeConfig.orientation = menu.orientation === 0 ? 1 : 0;
    return easeConfig;
};
var $5530b77fd309ef37$export$2e2bcd8739ae039 = $5530b77fd309ef37$var$GetEaseConfig;


var $32cd408ac8f960e7$var$PopUp = function(menu, duration) {
    menu.popUp((0, $5530b77fd309ef37$export$2e2bcd8739ae039)(menu.root.easeIn, menu));
};
var $32cd408ac8f960e7$var$ScaleDown = function(menu, duration) {
    // Don't destroy here
    menu.scaleDown((0, $5530b77fd309ef37$export$2e2bcd8739ae039)(menu.root.easeOut, menu));
};
var $32cd408ac8f960e7$export$2e2bcd8739ae039 = {
    setTransitInCallback (callback) {
        if (callback === undefined) callback = $32cd408ac8f960e7$var$PopUp;
        this.transitInCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    setTransitOutCallback (callback) {
        if (callback === undefined) callback = $32cd408ac8f960e7$var$ScaleDown;
        this.transitOutCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    }
};



var $006ba0f091f43a96$export$2e2bcd8739ae039 = {
    delayCall (delay, callback, scope) {
        // Invoke callback under scene's 'postupdate' event
        this.timer = (0, $bf6654c282684795$export$2e2bcd8739ae039)(this, delay, callback, scope);
        return this;
    },
    removeDelayCall () {
        if (this.timer) {
            this.timer.remove(false);
            this.timer = undefined;
        }
        return this;
    }
};


var $a8cfc9993907b52a$var$ExpandSubMenu = function(parentButton, items) {
    var subMenu = this.childrenMap.subMenu;
    // Submenu already expand
    if (subMenu && subMenu.parentButton === parentButton) return this;
    this.collapseSubMenu();
    var orientation;
    if (this.root.toggleOrientation) orientation = this.orientation === 0 ? 1 : 0;
    else orientation = this.orientation;
    var subMenu = new this.constructor(this.scene, {
        items: items,
        orientation: orientation,
        space: this.space,
        createBackgroundCallback: this.root.createBackgroundCallback,
        createBackgroundCallbackScope: this.root.createBackgroundCallbackScope,
        createButtonCallback: this.root.createButtonCallback,
        createButtonCallbackScope: this.root.createButtonCallbackScope,
        easeIn: this.root.easeIn,
        easeOut: this.root.easeOut,
        _rootMenu: this.root,
        _parentMenu: this,
        _parentButton: parentButton
    });
    this.pin(subMenu);
    this.childrenMap.subMenu = subMenu;
    this.root.emit("expand", subMenu, parentButton, this);
    return this;
};
var $a8cfc9993907b52a$export$2e2bcd8739ae039 = $a8cfc9993907b52a$var$ExpandSubMenu;


var $55e6a845dcf3ab1a$var$Collapse = function() {
    var root = this.root;
    root.emit("collapse", this, this.parentButton, root);
    var duration = root.easeOut.duration;
    // Don't destroy under transitOutCallback
    root.transitOutCallback(this, duration);
    this.collapseSubMenu();
    // Destroy by delayCall
    this.delayCall(duration, this.destroy, this);
    return this;
};
var $55e6a845dcf3ab1a$export$2e2bcd8739ae039 = $55e6a845dcf3ab1a$var$Collapse;


var $13638d22ec18deea$var$CollapseSubMenu = function() {
    var subMenu = this.childrenMap.subMenu;
    if (subMenu === undefined) return this;
    this.childrenMap.subMenu = undefined;
    this.remove(subMenu);
    subMenu.collapse();
    return this;
};
var $13638d22ec18deea$export$2e2bcd8739ae039 = $13638d22ec18deea$var$CollapseSubMenu;


var $3a0ae86b4dfbb1a1$var$Methods = {
    expandSubMenu: (0, $a8cfc9993907b52a$export$2e2bcd8739ae039),
    collapse: (0, $55e6a845dcf3ab1a$export$2e2bcd8739ae039),
    collapseSubMenu: (0, $13638d22ec18deea$export$2e2bcd8739ae039)
};
Object.assign($3a0ae86b4dfbb1a1$var$Methods, (0, $32cd408ac8f960e7$export$2e2bcd8739ae039), (0, $006ba0f091f43a96$export$2e2bcd8739ae039));
var $3a0ae86b4dfbb1a1$export$2e2bcd8739ae039 = $3a0ae86b4dfbb1a1$var$Methods;


var $23d7df06daf3e069$var$CreateBackground = function(scene, items, callback, scope) {
    var background;
    if (callback) {
        items.scene = scene;
        if (scope) background = callback.call(scope, items);
        else background = callback(items);
        items.scene = undefined;
    }
    return background;
};
var $23d7df06daf3e069$export$2e2bcd8739ae039 = $23d7df06daf3e069$var$CreateBackground;


var $8d34f960423311af$var$CreateButtons = function(scene, items, callback, scope) {
    var item;
    var buttons = [], button;
    if (items && callback) for(var i = 0, cnt = items.length; i < cnt; i++){
        item = items[i];
        item.scene = scene;
        if (scope) button = callback.call(scope, item, i, items);
        else button = callback(item, i, items);
        item.scene = undefined;
        buttons.push(button);
    }
    return buttons;
};
var $8d34f960423311af$export$2e2bcd8739ae039 = $8d34f960423311af$var$CreateButtons;



var $cd041eae85418149$var$MenuSetInteractive = function(menu) {
    menu// Expand sub event
    .on(menu.root.expandEventName, function(button, index) {
        if (this._isPassedEvent) return;
        var childrenKey = this.root.childrenKey;
        var subItems = this.items[index][childrenKey];
        if (subItems) this.expandSubMenu(button, subItems);
    }, menu)// Click any button
    .on("button.click", function(button, index, pointer, event) {
        // Pass event to root menu object
        if (this !== this.root) {
            this.root._isPassedEvent = true;
            this.root.emit("button.click", button, index, pointer, event);
            this.root._isPassedEvent = false;
        }
    }, menu)//Pointer over any button
    .on("button.over", function(button, index, pointer, event) {
        // Pass event to root menu object
        if (this !== this.root) {
            this.root._isPassedEvent = true;
            this.root.emit("button.over", button, index, pointer, event);
            this.root._isPassedEvent = false;
        }
    }, menu)//Pointer out any button
    .on("button.out", function(button, index, pointer, event) {
        // Pass event to root menu object
        if (this !== this.root) {
            this.root._isPassedEvent = true;
            this.root.emit("button.out", button, index, pointer, event);
            this.root._isPassedEvent = false;
        }
    }, menu);
};
var $cd041eae85418149$export$2e2bcd8739ae039 = $cd041eae85418149$var$MenuSetInteractive;



var $22dff48ccdcd10d3$var$ParseEaseConfig = function(menu, easeConfig) {
    if (typeof easeConfig === "number") easeConfig = {
        duration: easeConfig
    };
    if (easeConfig.hasOwnProperty("orientation") && easeConfig.orientation !== undefined) easeConfig.sameOrientation = (0, $3c3f84ff9ee02f02$export$2e2bcd8739ae039)(easeConfig.orientation) === menu.orientation;
    else easeConfig.sameOrientation = true;
    easeConfig.destroy = false;
    return easeConfig;
};
var $22dff48ccdcd10d3$export$2e2bcd8739ae039 = $22dff48ccdcd10d3$var$ParseEaseConfig;



var $b248c5442cbe0b67$var$Expand = function() {
    var root = this.root;
    var duration = root.easeIn.duration;
    // Ease in menu
    root.transitInCallback(this, duration);
    if (this !== this.root) this.delayCall(duration, function() {
        // Pass event to root menu object
        this.root.emit("popup.complete", this);
    }, this);
};
var $b248c5442cbe0b67$export$2e2bcd8739ae039 = $b248c5442cbe0b67$var$Expand;


const $6234e1332f70f2b6$var$GetValue = Phaser.Utils.Objects.GetValue;
class $6234e1332f70f2b6$var$Menu extends (0, $e713f60692044763$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Orientation
        if (!config.hasOwnProperty("orientation")) config.orientation = 1; // y
        // Parent
        var rootMenu = config._rootMenu;
        var parentMenu = config._parentMenu;
        var parentButton = config._parentButton;
        // Popup, root menu can be static, sub-menus are always popup.
        var popUp = $6234e1332f70f2b6$var$GetValue(config, "popup", true);
        // Items
        var items = $6234e1332f70f2b6$var$GetValue(config, "items", undefined);
        // Background
        var createBackgroundCallback = $6234e1332f70f2b6$var$GetValue(config, "createBackgroundCallback", undefined);
        var createBackgroundCallbackScope = $6234e1332f70f2b6$var$GetValue(config, "createBackgroundCallbackScope", undefined);
        config.background = (0, $23d7df06daf3e069$export$2e2bcd8739ae039)(scene, items, createBackgroundCallback, createBackgroundCallbackScope);
        // Buttons
        var createButtonCallback = $6234e1332f70f2b6$var$GetValue(config, "createButtonCallback", undefined);
        var createButtonCallbackScope = $6234e1332f70f2b6$var$GetValue(config, "createButtonCallbackScope", undefined);
        config.buttons = (0, $8d34f960423311af$export$2e2bcd8739ae039)(scene, items, createButtonCallback, createButtonCallbackScope);
        super(scene, config);
        this.type = "rexMenu";
        this.items = items;
        this.root = rootMenu === undefined ? this : rootMenu;
        this.isRoot = this.root === this;
        this.parentMenu = parentMenu;
        this.parentButton = parentButton;
        this.timer = undefined;
        // Root menu
        if (this.isRoot) {
            this.isPopUpMode = popUp;
            // Bounds
            var bounds = config.bounds;
            if (bounds === undefined) bounds = (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(scene);
            this.bounds = bounds;
            // Side of submenu
            this.subMenuSide = [
                this.y < bounds.centerY ? $6234e1332f70f2b6$var$SUBMENU_DOWN : $6234e1332f70f2b6$var$SUBMENU_UP,
                this.x < bounds.centerX ? $6234e1332f70f2b6$var$SUBMENU_RIGHT : $6234e1332f70f2b6$var$SUBMENU_LEFT
            ];
            // Overwrite subMenuSide value if given
            var subMenuSide = $6234e1332f70f2b6$var$GetValue(config, "subMenuSide", undefined);
            if (subMenuSide !== undefined) {
                if (typeof subMenuSide === "string") subMenuSide = $6234e1332f70f2b6$var$SubMenuSideMode[subMenuSide];
                this.subMenuSide[this.orientation] = subMenuSide;
            }
            // ToggleOrientation mode
            this.toggleOrientation = $6234e1332f70f2b6$var$GetValue(config, "toggleOrientation", false);
            // Expand mode
            this.expandEventName = $6234e1332f70f2b6$var$GetValue(config, "expandEvent", "button.click");
            // Transition
            this.easeIn = (0, $22dff48ccdcd10d3$export$2e2bcd8739ae039)(this, $6234e1332f70f2b6$var$GetValue(config, "easeIn", 0));
            this.easeOut = (0, $22dff48ccdcd10d3$export$2e2bcd8739ae039)(this, $6234e1332f70f2b6$var$GetValue(config, "easeOut", 0));
            this.setTransitInCallback($6234e1332f70f2b6$var$GetValue(config, "transitIn"));
            this.setTransitOutCallback($6234e1332f70f2b6$var$GetValue(config, "transitOut"));
            // Callbacks
            this.createBackgroundCallback = createBackgroundCallback;
            this.createBackgroundCallbackScope = createBackgroundCallbackScope;
            this.createButtonCallback = createButtonCallback;
            this.createButtonCallbackScope = createButtonCallbackScope;
            // Children key
            this.childrenKey = $6234e1332f70f2b6$var$GetValue(config, "childrenKey", "children");
            // Event flag
            this._isPassedEvent = false;
            // pointerdown-outside-collapse
            this.pointerDownOutsideCollapsing = $6234e1332f70f2b6$var$GetValue(config, "pointerDownOutsideCollapsing", true);
            if (this.pointerDownOutsideCollapsing) scene.input.on("pointerdown", this.onPointerDownOutside, this);
        }
        var originX = 0, originY = 0;
        if (!this.root.easeIn.sameOrientation) {
            var easeOrientation = (0, $5530b77fd309ef37$export$2e2bcd8739ae039)(this.root.easeIn, this).orientation;
            var menuOrientation = parentMenu ? parentMenu.orientation : this.orientation;
            var subMenuSide = this.root.subMenuSide[menuOrientation];
            if (easeOrientation === 0 && subMenuSide === $6234e1332f70f2b6$var$SUBMENU_LEFT) originX = 1;
            if (easeOrientation === 1 && subMenuSide === $6234e1332f70f2b6$var$SUBMENU_UP) originY = 1;
        }
        if (popUp) this.setOrigin(originX, originY).layout();
        // Sub-menu: 
        // - scale to root's scale value
        // - align to parent button
        if (!this.isRoot) {
            this.setScale(this.root.scaleX, this.root.scaleY);
            var subMenuSide = this.root.subMenuSide[parentMenu.orientation];
            switch(subMenuSide){
                case $6234e1332f70f2b6$var$SUBMENU_LEFT:
                    this.alignTop(parentButton.top).alignRight(parentButton.left);
                    break;
                case $6234e1332f70f2b6$var$SUBMENU_RIGHT:
                    this.alignTop(parentButton.top).alignLeft(parentButton.right);
                    break;
                case $6234e1332f70f2b6$var$SUBMENU_UP:
                    this.alignLeft(parentButton.left).alignBottom(parentButton.top);
                    break;
                case $6234e1332f70f2b6$var$SUBMENU_DOWN:
                    this.alignLeft(parentButton.left).alignTop(parentButton.bottom);
                    break;
            }
        }
        (0, $cd041eae85418149$export$2e2bcd8739ae039)(this);
        if (popUp) {
            this.pushIntoBounds(this.root.bounds);
            // Expand this menu
            (0, $b248c5442cbe0b67$export$2e2bcd8739ae039).call(this);
        }
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (this.isRoot && this.pointerDownOutsideCollapsing) this.scene.input.off("pointerdown", this.onPointerDownOutside, this);
        super.destroy(fromScene);
        this.removeDelayCall();
    }
    isInTouching(pointer) {
        if (super.isInTouching(pointer)) return true;
        else if (this.childrenMap.subMenu) return this.childrenMap.subMenu.isInTouching(pointer);
        else return false;
    }
    onPointerDownOutside(pointer) {
        if (this.isInTouching(pointer)) return;
        if (this.isPopUpMode) this.collapse();
        else this.collapseSubMenu();
    }
}
const $6234e1332f70f2b6$var$SUBMENU_LEFT = 2;
const $6234e1332f70f2b6$var$SUBMENU_RIGHT = 0;
const $6234e1332f70f2b6$var$SUBMENU_UP = 3;
const $6234e1332f70f2b6$var$SUBMENU_DOWN = 1;
const $6234e1332f70f2b6$var$SubMenuSideMode = {
    up: $6234e1332f70f2b6$var$SUBMENU_UP,
    down: $6234e1332f70f2b6$var$SUBMENU_DOWN,
    left: $6234e1332f70f2b6$var$SUBMENU_LEFT,
    right: $6234e1332f70f2b6$var$SUBMENU_RIGHT
};
Object.assign($6234e1332f70f2b6$var$Menu.prototype, (0, $3a0ae86b4dfbb1a1$export$2e2bcd8739ae039));
var $6234e1332f70f2b6$export$2e2bcd8739ae039 = $6234e1332f70f2b6$var$Menu;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("menu", function(config) {
    var gameObject = new (0, $6234e1332f70f2b6$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Menu", (0, $6234e1332f70f2b6$export$2e2bcd8739ae039));
var $e77b6af3328b929b$export$2e2bcd8739ae039 = (0, $6234e1332f70f2b6$export$2e2bcd8739ae039);



var $fbd26ee0c443df95$var$methods = {
    setWrapEnable (enable) {
        if (enable === undefined) enable = true;
        this.listWrapEnable = enable;
        return this;
    },
    setCreateButtonCallback (callback) {
        this.listCreateButtonCallback = callback;
        return this;
    },
    setCreateListBackgroundCallback (callback) {
        this.listCreateBackgroundCallback = callback;
        return this;
    },
    setButtonClickCallback (callback) {
        this.listOnButtonClick = callback;
        return this;
    },
    setButtonOverCallback (callback) {
        this.listOnButtonOver = callback;
        return this;
    },
    setButtonOutCallback (callback) {
        this.listOnButtonOut = callback;
        return this;
    },
    setListExpandDirection (direction) {
        if (typeof direction === "string") direction = $fbd26ee0c443df95$var$ListExpandDirections[direction];
        this.listExpandDirection = direction;
        return this;
    },
    setListEaseInDuration (duration) {
        if (duration === undefined) duration = 0;
        this.listEaseInDuration = duration;
        return this;
    },
    setListEaseOutDuration (duration) {
        if (duration === undefined) duration = 0;
        this.listEaseOutDuration = duration;
        return this;
    },
    setListTransitInCallback (callback) {
        this.listTransitInCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    settListTransitOutCallback (callback) {
        this.listTransitOutCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    setListBounds (bounds) {
        this.listBounds = bounds;
        return this;
    },
    setListWidth (width) {
        this.listWidth = width;
        return this;
    },
    setListHeight (height) {
        this.listHeight = height;
        return this;
    },
    setListSize (width, height) {
        this.setListWidth(width).setListHeight(height);
        return this;
    },
    setListAlignmentMode (mode) {
        this.listAlignMode = mode;
        return this;
    },
    setListAlignmentSide (side) {
        if (side === undefined) side = "";
        this.listAlignSide = side;
        return this;
    },
    setListSpace (space) {
        if (space === undefined) space = {};
        this.listSpace = space;
        return this;
    },
    setListDraggable (enable) {
        if (enable === undefined) enable = true;
        this.listDraggable = enable;
        return this;
    }
};
const $fbd26ee0c443df95$var$ListExpandDirections = {
    down: 0,
    up: 1
};
var $fbd26ee0c443df95$export$2e2bcd8739ae039 = $fbd26ee0c443df95$var$methods;




var $5848833bd384a20f$var$CreateListPanel = function() {
    var scene = this.scene;
    var background;
    var createBackgroundCallback = this.listCreateBackgroundCallback;
    if (createBackgroundCallback) {
        background = createBackgroundCallback.call(this, scene);
        scene.add.existing(background);
    }
    var buttons = [];
    var createButtonCallback = this.listCreateButtonCallback;
    if (createButtonCallback) {
        var options = this.options;
        for(var i = 0, cnt = options.length; i < cnt; i++){
            var button = createButtonCallback.call(this, scene, options[i], i, options);
            scene.add.existing(button);
            buttons.push(button);
        }
    }
    var width = this.listWidth;
    if (width === undefined) {
        if (this.listAlignMode === "text") width = this.getElement("text").width;
        else width = this.width;
    }
    var height = this.listHeight;
    var listPanel;
    if (!this.listWrapEnable) listPanel = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, {
        width: width,
        height: height,
        orientation: "y",
        background: background,
        buttons: buttons,
        space: this.listSpace,
        draggable: this.listDraggable
    });
    else listPanel = new (0, $1418690eca2b4065$export$2e2bcd8739ae039)(scene, {
        width: width,
        height: height,
        background: background,
        buttons: buttons,
        space: this.listSpace,
        draggable: this.listDraggable
    });
    scene.add.existing(listPanel);
    return listPanel;
};
var $5848833bd384a20f$export$2e2bcd8739ae039 = $5848833bd384a20f$var$CreateListPanel;





var $3747788d811c427d$var$ScaleDown = function(gameObject, duration, orientation, ease, scale) {
    if (ease === undefined) ease = "Linear";
    var config = {};
    config.mode = 0;
    switch(orientation){
        case 0:
        case "x":
            config.end = {
                x: 0
            };
            break;
        case 1:
        case "y":
            config.end = {
                y: 0
            };
            break;
        default:
            config.end = 0;
            break;
    }
    config.duration = duration;
    config.ease = ease;
    if (scale === undefined) scale = new (0, $f4977f68b8f13065$export$2e2bcd8739ae039)(gameObject, config);
    else scale.resetFromJSON(config);
    scale.restart();
    return scale;
};
var $3747788d811c427d$export$2e2bcd8739ae039 = $3747788d811c427d$var$ScaleDown;




var $124f39118a77d04d$var$GetValueFromAliasKeys = function(source, key0, key1, key2, defaultValue) {
    if ((0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(source, key0)) return (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(source, key0);
    else if (key1 && (0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(source, key1)) return (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(source, key1);
    else if (key2 && (0, $0cef6ee9dfdf1f0b$export$2e2bcd8739ae039)(source, key2)) return (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(source, key2);
    else return defaultValue;
};
var $124f39118a77d04d$export$2e2bcd8739ae039 = $124f39118a77d04d$var$GetValueFromAliasKeys;



const $3ab3297af090e91d$var$GetValue = Phaser.Utils.Objects.GetValue;
var $3ab3297af090e91d$var$SetPosition = function(gameObject, config) {
    var expandDirection = $3ab3297af090e91d$var$GetValue(config, "expandDirection", undefined);
    if (typeof expandDirection === "string") expandDirection = $3ab3297af090e91d$var$ExpandDirections[expandDirection];
    var alignTargetX = (0, $124f39118a77d04d$export$2e2bcd8739ae039)(config, "alignTarget", "alignTargetX");
    var alignTargetY = $3ab3297af090e91d$var$GetValue(config, "alignTargetY", alignTargetX);
    var alignOffsetX = $3ab3297af090e91d$var$GetValue(config, "alignOffsetX", 0);
    var alignOffsetY = $3ab3297af090e91d$var$GetValue(config, "alignOffsetY", 0);
    var alignSide = $3ab3297af090e91d$var$GetValue(config, "alignSide", "");
    var alignRight = alignSide.includes("right");
    var positionBounds = $3ab3297af090e91d$var$GetValue(config, "bounds");
    // Expand direction
    var isExpandDown = expandDirection === 0;
    var isExpandUp = expandDirection === 1;
    var flexExpand = !isExpandDown && !isExpandUp;
    var originX = alignRight ? 1 : 0;
    var originY = isExpandDown || flexExpand ? 0 : 1;
    gameObject.setOrigin(originX, originY);
    var x, y;
    if (alignRight) x = alignTargetX.getTopRight().x;
    else x = alignTargetX.getTopLeft().x;
    y = alignTargetY.getBottomLeft().y;
    gameObject.setPosition(x + alignOffsetX, y + alignOffsetY);
    var bounds = positionBounds;
    if (!bounds) bounds = (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(gameObject.scene);
    if (flexExpand && gameObject.getBottomLeft().y > bounds.bottom) {
        // Out of bounds, can't put list-panel below parent
        y = alignTargetY.getTopLeft().y;
        gameObject.setOrigin(0, 1).setPosition(x + alignOffsetX, y + alignOffsetY);
    }
};
const $3ab3297af090e91d$var$ExpandDirections = {
    down: 0,
    up: 1
};
var $3ab3297af090e91d$export$2e2bcd8739ae039 = $3ab3297af090e91d$var$SetPosition;



const $1a52b50c6f462d43$var$GetValue = Phaser.Utils.Objects.GetValue;
class $1a52b50c6f462d43$var$DropDown extends (0, $0e96a087d32d6b8e$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        if (config === undefined) config = {};
        if (config.transitIn == null) config.transitIn = function(gameObject, duration) {
            (0, $7fc63b8d8e1b2022$export$2e2bcd8739ae039)(gameObject, duration, "y", "Cubic");
        };
        if (config.transitOut == null) config.transitOut = function(gameObject, duration) {
            // Don't destroy here
            (0, $3747788d811c427d$export$2e2bcd8739ae039)(gameObject, duration, "y", "Linear");
        };
        config.manualClose = true;
        config.clickOutsideClose = true;
        config.destroy = true;
        super(gameObject, config);
        // this.parent = gameObject;
        // this.scene
        (0, $3ab3297af090e91d$export$2e2bcd8739ae039)(gameObject, config);
        if (gameObject.isRexSizer) gameObject.layout();
        // Close conditions:
        var touchOutsideClose = $1a52b50c6f462d43$var$GetValue(config, "touchOutsideClose", false);
        var anyTouchClose = $1a52b50c6f462d43$var$GetValue(config, "anyTouchClose", false);
        if (anyTouchClose) touchOutsideClose = false;
        // Registet touch-close event after opened
        if (anyTouchClose) this.once("open", this.anyTouchClose, this);
        else if (touchOutsideClose) this.once("open", this.touchOutsideClose, this);
        this.requestOpen();
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // Registered in touchOutsideClose()
        this.scene.input.off("pointerup", this.touchCloseCallback, this);
        super.shutdown(fromScene);
    }
    touchOutsideClose() {
        this.scene.input.on("pointerup", this.touchCloseCallback, this);
        this.clickOutsideTest = true;
        return this;
    }
    anyTouchClose() {
        this.scene.input.once("pointerup", this.touchCloseCallback, this);
        return this;
    }
    touchCloseCallback(pointer) {
        if (this.clickOutsideTest && (0, $56f678951934d060$export$2e2bcd8739ae039)(this.parent, pointer.worldX, pointer.worldY)) return;
        this.requestClose();
    }
    onOpen() {
        this.emit("open", this.parent, this);
        super.onOpen();
    }
    onClose() {
        this.emit("close", this.parent, this);
        super.onClose();
    }
}
var $1a52b50c6f462d43$export$2e2bcd8739ae039 = $1a52b50c6f462d43$var$DropDown;


var $a845dc893742a9eb$export$2e2bcd8739ae039 = (0, $1a52b50c6f462d43$export$2e2bcd8739ae039);


var $6d1f09173c680891$export$2e2bcd8739ae039 = (0, $a845dc893742a9eb$export$2e2bcd8739ae039);


var $7ff1d2488defd1ff$var$OpenListPanel = function() {
    if (this.listPanel) return this;
    var listPanel = (0, $5848833bd384a20f$export$2e2bcd8739ae039).call(this);
    // Button over/out
    listPanel.on("button.over", function(button, index, pointer, event) {
        if (this.listOnButtonOver) this.listOnButtonOver.call(this, button, index, pointer, event);
        this.emit("button.over", this, listPanel, button, index, pointer, event);
    }, this).on("button.out", function(button, index, pointer, event) {
        if (this.listOnButtonOut) this.listOnButtonOut.call(this, button, index, pointer, event);
        this.emit("button.out", this, listPanel, button, index, pointer, event);
    }, this);
    var alignTargetX;
    if (!this.listAlignMode || this.listAlignMode === "label") alignTargetX = this;
    else alignTargetX = this.getElement(this.listAlignMode);
    var dropDownBehavior = new (0, $6d1f09173c680891$export$2e2bcd8739ae039)(listPanel, {
        // Transition
        duration: {
            in: this.listEaseInDuration,
            out: this.listEaseOutDuration
        },
        transitIn: this.listTransitInCallback,
        transitOut: this.listTransitOutCallback,
        // Position
        expandDirection: this.listExpandDirection,
        alignTargetX: alignTargetX,
        alignTargetY: this,
        alignSide: this.listAlignSide,
        bounds: this.listBounds,
        // Close condition
        anyTouchClose: true
    }).on("open", function() {
        // After popping up
        // Can click
        listPanel.on("button.click", function(button, index, pointer, event) {
            if (this.listOnButtonClick) this.listOnButtonClick.call(this, button, index, pointer, event);
            this.emit("button.click", this, listPanel, button, index, pointer, event);
        }, this);
        this.emit("list.open", this, listPanel);
    }, this).on("close", function() {
        this.listPanel = undefined;
        this.dropDownBehavior = undefined;
    }, this);
    this.listPanel = listPanel;
    this.dropDownBehavior = dropDownBehavior;
    this.pin(listPanel);
    return this;
};
var $7ff1d2488defd1ff$export$2e2bcd8739ae039 = $7ff1d2488defd1ff$var$OpenListPanel;


var $b9ab62c21802476a$var$CloseListPanel = function() {
    if (!this.dropDownBehavior) return this;
    this.dropDownBehavior.requestClose();
    return this;
};
var $b9ab62c21802476a$export$2e2bcd8739ae039 = $b9ab62c21802476a$var$CloseListPanel;


var $056c3ffd601aa02c$var$ToggleListPanel = function() {
    if (!this.listPanel) this.openListPanel();
    else this.closeListPanel();
    return this;
};
var $056c3ffd601aa02c$export$2e2bcd8739ae039 = $056c3ffd601aa02c$var$ToggleListPanel;


var $fb7c0da4712cd35b$var$Methods = {
    openListPanel: (0, $7ff1d2488defd1ff$export$2e2bcd8739ae039),
    closeListPanel: (0, $b9ab62c21802476a$export$2e2bcd8739ae039),
    toggleListPanel: (0, $056c3ffd601aa02c$export$2e2bcd8739ae039)
};
Object.assign($fb7c0da4712cd35b$var$Methods, (0, $fbd26ee0c443df95$export$2e2bcd8739ae039));
var $fb7c0da4712cd35b$export$2e2bcd8739ae039 = $fb7c0da4712cd35b$var$Methods;


const $c354e056ec3b0874$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c354e056ec3b0874$var$DropDownList extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexDropDownList";
        this.timer = undefined;
        this.setOptions($c354e056ec3b0874$var$GetValue(config, "options"));
        var listConfig = $c354e056ec3b0874$var$GetValue(config, "list");
        this.setWrapEnable($c354e056ec3b0874$var$GetValue(listConfig, "wrap", false));
        this.setCreateButtonCallback($c354e056ec3b0874$var$GetValue(listConfig, "createButtonCallback"));
        this.setCreateListBackgroundCallback($c354e056ec3b0874$var$GetValue(listConfig, "createBackgroundCallback"));
        this.setButtonClickCallback($c354e056ec3b0874$var$GetValue(listConfig, "onButtonClick"));
        this.setButtonOverCallback($c354e056ec3b0874$var$GetValue(listConfig, "onButtonOver"));
        this.setButtonOutCallback($c354e056ec3b0874$var$GetValue(listConfig, "onButtonOut"));
        this.setListExpandDirection($c354e056ec3b0874$var$GetValue(listConfig, "expandDirection"));
        this.setListEaseInDuration($c354e056ec3b0874$var$GetValue(listConfig, "easeIn", 500));
        this.setListEaseOutDuration($c354e056ec3b0874$var$GetValue(listConfig, "easeOut", 100));
        this.setListTransitInCallback($c354e056ec3b0874$var$GetValue(listConfig, "transitIn"));
        this.settListTransitOutCallback($c354e056ec3b0874$var$GetValue(listConfig, "transitOut"));
        this.setListSize($c354e056ec3b0874$var$GetValue(listConfig, "width"), $c354e056ec3b0874$var$GetValue(listConfig, "height"));
        this.setListAlignmentMode($c354e056ec3b0874$var$GetValue(listConfig, "alignParent", "text"));
        this.setListAlignmentSide($c354e056ec3b0874$var$GetValue(listConfig, "alignSide", ""));
        this.setListBounds($c354e056ec3b0874$var$GetValue(listConfig, "bounds"));
        this.setListSpace($c354e056ec3b0874$var$GetValue(listConfig, "space"));
        this.setListDraggable($c354e056ec3b0874$var$GetValue(listConfig, "draggable", false));
        this.setValueChangeCallback($c354e056ec3b0874$var$GetValue(config, "setValueCallback"), $c354e056ec3b0874$var$GetValue(config, "setValueCallbackScope"));
        this.setValue($c354e056ec3b0874$var$GetValue(config, "value"));
        this.onClick(this.toggleListPanel, this);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        if (this.listPanel) {
            this.listPanel.destroy(fromScene);
            this.listPanel = undefined;
        }
        super.destroy(fromScene);
    }
    setOptions(options) {
        if (options === undefined) options = [];
        this.options = options;
        return this;
    }
    setValueChangeCallback(callback, scope) {
        this.valueChangeCallback = callback;
        this.valueChangeCallbackScope = scope;
        return this;
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        var previousValue = this._value;
        this._value = value;
        var callback = this.valueChangeCallback, scope = this.valueChangeCallbackScope;
        if (callback) {
            if (scope) callback.call(scope, this, value, previousValue);
            else callback(this, value, previousValue);
        }
        this.emit("valuechange", this, value, previousValue);
    }
    emitButtonClick(index) {
        var option = this.options[index];
        if (!option) return this;
        this.emit("button.click", this, undefined, option, index);
        return this;
    }
}
Object.assign($c354e056ec3b0874$var$DropDownList.prototype, (0, $fb7c0da4712cd35b$export$2e2bcd8739ae039));
var $c354e056ec3b0874$export$2e2bcd8739ae039 = $c354e056ec3b0874$var$DropDownList;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("dropDownList", function(config) {
    var gameObject = new (0, $c354e056ec3b0874$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.DropDownList", (0, $c354e056ec3b0874$export$2e2bcd8739ae039));
var $5cb0e456fe951807$export$2e2bcd8739ae039 = (0, $c354e056ec3b0874$export$2e2bcd8739ae039);






var $a85d756d8bc2f834$var$BuildListConfig = function(scene, config, creators) {
    config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
    if (creators === undefined) creators = {};
    var labelConfig = config.label || config.button;
    var listButtonConfig = config.button || config.label;
    delete config.label;
    delete config.button;
    var labelCreator = creators.label || creators.button || creators;
    var listButtonCreator = creators.button || creators.label || creators;
    var listConfig = (0, $07dafb4ba614c407$export$2e2bcd8739ae039)(scene, labelConfig, labelCreator);
    listConfig.list = config.list || {};
    listConfig.list.createButtonCallback = function(scene, option) {
        var gameObject = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, listButtonConfig, listButtonCreator).resetDisplayContent({
            text: option.text
        });
        if (option.hasOwnProperty("value")) gameObject.value = option.value;
        return gameObject;
    };
    listConfig.list.onButtonOver = function(button, index, pointer, event) {
        if (button.setHoverState) button.setHoverState(true);
    };
    listConfig.list.onButtonOut = function(button, index, pointer, event) {
        if (button.setHoverState) button.setHoverState(false);
    };
    return listConfig;
};
var $a85d756d8bc2f834$export$2e2bcd8739ae039 = $a85d756d8bc2f834$var$BuildListConfig;


class $5849a74086225c58$var$SimpleDropDownList extends (0, $c354e056ec3b0874$export$2e2bcd8739ae039) {
    constructor(scene, config, creators){
        config = (0, $a85d756d8bc2f834$export$2e2bcd8739ae039)(scene, config, creators);
        super(scene, config);
        this.type = "rexSimpleDropDownList";
    }
    setOptions(options) {
        if (options === undefined) options = [];
        for(var i = 0, cnt = options.length; i < cnt; i++){
            var option = options[i];
            if (typeof option === "string") options[i] = {
                text: option,
                value: option
            };
        }
        super.setOptions(options);
        return this;
    }
}
var $5849a74086225c58$export$2e2bcd8739ae039 = $5849a74086225c58$var$SimpleDropDownList;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("simpleDropDownList", function(config, creators) {
    var gameObject = new (0, $5849a74086225c58$export$2e2bcd8739ae039)(this.scene, config, creators);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.SimpleDropDownList", (0, $5849a74086225c58$export$2e2bcd8739ae039));
var $0ce458cdee855839$export$2e2bcd8739ae039 = (0, $5849a74086225c58$export$2e2bcd8739ae039);







var $3256c17bd52f7028$var$GetLines = function(startLineIndex, endLineIdx) {
    if (startLineIndex === undefined) startLineIndex = this.startLineIndex;
    if (endLineIdx === undefined) endLineIdx = startLineIndex + this.pageLinesCount;
    var text;
    switch(this.textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            text = this.lines.slice(startLineIndex, endLineIdx).join("\n");
            break;
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            var startIdx = this.lines.getLineStartIndex(startLineIndex);
            var endIdx = this.lines.getLineEndIndex(endLineIdx - 1);
            text = this.lines.getSliceTagText(startIdx, endIdx, true);
            break;
    }
    return text;
};
var $3256c17bd52f7028$export$2e2bcd8739ae039 = $3256c17bd52f7028$var$GetLines;



var $386de709026577fd$var$GetString = function(text) {
    if (Array.isArray(text)) text = text.join("\n");
    else if (typeof text === "number") text = text.toString();
    return text;
};
var $386de709026577fd$export$2e2bcd8739ae039 = {
    clearText () {
        this.sections.length = 0;
        this.pageStartIndexes.length = 0;
        this.lines.length = 0;
        return this;
    },
    appendPage (text) {
        var pageStartIndex = this.totalLinesCount;
        this.sections.push($386de709026577fd$var$GetString(text));
        var text = this.sections.join("\n");
        this.lines = (0, $23d8a788b6242ef5$export$2e2bcd8739ae039)(this.parent, text, this.lines);
        var newLinesCount = this.totalLinesCount - pageStartIndex;
        var pageCount = Math.ceil(newLinesCount / this.pageLinesCount);
        for(var i = 0; i < pageCount; i++)this.pageStartIndexes.push(pageStartIndex + i * this.pageLinesCount);
        return this;
    },
    setText (text, resetPageIdx) {
        if (resetPageIdx === undefined) resetPageIdx = true;
        if (resetPageIdx) this.resetPageIdx();
        this.clearText();
        var sections = $386de709026577fd$var$GetString(text).split(this.pageBreak);
        // if (sections[sections.length - 1] === '') { // Last section is an empty string
        //     sections.length -= 1;
        // }
        for(var i = 0, cnt = sections.length; i < cnt; i++)this.appendPage(sections[i]);
        return this;
    },
    appendText (text) {
        var content = this.content + $386de709026577fd$var$GetString(text);
        this.setText(content, false);
        return this;
    }
};


const $ec3448b8c52f1ba7$var$Clamp = Phaser.Math.Clamp;
var $ec3448b8c52f1ba7$export$2e2bcd8739ae039 = {
    getPage (idx) {
        if (idx === undefined) idx = this.pageIndex;
        return this.setPageIndex(idx).getLines(this.startLineIndex, this.endLineIndex);
    },
    getNextPage () {
        return this.getPage(this.pageIndex + 1);
    },
    getPreviousPage () {
        return this.getPage(this.pageIndex - 1);
    },
    resetPageIdx () {
        this.pageIndex = -1;
        return this;
    },
    setPageIndex (idx) {
        idx = $ec3448b8c52f1ba7$var$Clamp(idx, 0, this.pageCount - 1);
        this.pageIndex = idx;
        this.startLineIndex = this.pageStartIndexes[idx];
        this.endLineIndex = this.pageStartIndexes[idx + 1];
        return this;
    }
};



var $f1ccf31311644c10$export$2e2bcd8739ae039 = {
    showPage (idx) {
        this.displayText(this.getPage(idx));
        return this;
    },
    showNextPage () {
        this.displayText(this.getNextPage());
        return this;
    },
    showPreviousPage () {
        this.displayText(this.getPreviousPage());
        return this;
    },
    show () {
        this.displayText(this.getLines());
        return this;
    },
    showNextLine () {
        this.displayText(this.setStartLineIndex(this.startLineIndex + 1).getLines());
        return this;
    },
    showPreviousLine () {
        this.displayText(this.setStartLineIndex(this.startLineIndex - 1).getLines());
        return this;
    },
    displayText (text) {
        (0, $d4581d482844dcb0$export$2e2bcd8739ae039)(this.parent, text);
    }
};


var $9aa7316716dd0033$var$Methods = {
    getLines: (0, $3256c17bd52f7028$export$2e2bcd8739ae039)
};
Object.assign($9aa7316716dd0033$var$Methods, (0, $386de709026577fd$export$2e2bcd8739ae039), (0, $ec3448b8c52f1ba7$export$2e2bcd8739ae039), (0, $f1ccf31311644c10$export$2e2bcd8739ae039));
var $9aa7316716dd0033$export$2e2bcd8739ae039 = $9aa7316716dd0033$var$Methods;


const $b67dd92f3404bbdc$var$GetValue = Phaser.Utils.Objects.GetValue;
const $b67dd92f3404bbdc$var$Clamp = Phaser.Math.Clamp;
class $b67dd92f3404bbdc$var$TextPage extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, {
            eventEmitter: false
        });
        // No event emitter
        // this.parent = gameObject;
        this.textObjectType = (0, $d5c1e4e4661e06e7$export$2e2bcd8739ae039)(this.parent);
        this.pageStartIndexes = [];
        // Text object : array of string
        // Tag text object : pens-manager
        // Bitmap text object : array of string
        this.lines = (0, $23d8a788b6242ef5$export$2e2bcd8739ae039)(this.parent, "");
        this.sections = [];
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        this.setMaxLines($b67dd92f3404bbdc$var$GetValue(o, "maxLines", undefined));
        this.setPageBreak($b67dd92f3404bbdc$var$GetValue(o, "pageBreak", "\f\n"));
        this.setText($b67dd92f3404bbdc$var$GetValue(o, "text", ""));
        this.setStartLineIndex($b67dd92f3404bbdc$var$GetValue(o, "start", 0));
        this.setPageIndex($b67dd92f3404bbdc$var$GetValue(o, "page", -1));
        return this;
    }
    toJSON() {
        return {
            maxLines: this.maxLines,
            text: this.content,
            start: this.startLineIndex,
            page: this.pageIndex,
            pageBreak: this.pageBreak
        };
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        switch(this.textObjectType){
            case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
                this.lines.length = 0;
                break;
            case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
                this.lines.destroy();
                break;
            case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
                this.lines.length = 0;
                break;
        }
        this.pageStartIndexes.length = 0;
        this.sections.length = 0;
        this.lines = undefined;
        this.pageStartIndexes = undefined;
        this.sections = undefined;
        super.shutdown(fromScene);
    }
    setMaxLines(maxLines) {
        this.maxLines = maxLines;
        return this;
    }
    setPageBreak(pageBreak) {
        this.pageBreak = pageBreak;
        return this;
    }
    get pageCount() {
        return this.pageStartIndexes.length;
    }
    get isFirstPage() {
        return this.pageIndex <= 0;
    }
    get isLastPage() {
        return this.pageIndex >= this.pageCount - 1;
    }
    get totalLinesCount() {
        return this.lines ? this.lines.length : 0;
    }
    get startLineIndex() {
        return this._startLineIndex;
    }
    set startLineIndex(value) {
        value = $b67dd92f3404bbdc$var$Clamp(value, 0, this.totalLinesCount - 1);
        this._startLineIndex = value;
    }
    setStartLineIndex(idx) {
        this.startLineIndex = idx;
        return this;
    }
    get pageLinesCount() {
        if (this.maxLines !== undefined) return this.maxLines;
        else {
            var count;
            switch(this.textObjectType){
                case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
                case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
                    var maxLines = this.parent.style.maxLines;
                    if (maxLines > 0) count = maxLines;
                    else count = this.totalLinesCount;
                    break;
                case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
                    count = this.totalLinesCount;
                    break;
            }
            return count;
        }
    }
    get content() {
        return this.sections.join(this.pageBreak);
    }
}
Object.assign($b67dd92f3404bbdc$var$TextPage.prototype, (0, $9aa7316716dd0033$export$2e2bcd8739ae039));
var $b67dd92f3404bbdc$export$2e2bcd8739ae039 = $b67dd92f3404bbdc$var$TextPage;


var $68cbcbcb9ddf1ff8$export$2e2bcd8739ae039 = (0, $b67dd92f3404bbdc$export$2e2bcd8739ae039);


var $45891b7699fcfb45$export$2e2bcd8739ae039 = (0, $68cbcbcb9ddf1ff8$export$2e2bcd8739ae039);




var $005a6bc186ee479d$var$GetWrapText = function(textObject, text) {
    var textObjectType = (0, $d5c1e4e4661e06e7$export$2e2bcd8739ae039)(textObject);
    switch(textObjectType){
        case 0, $d5c1e4e4661e06e7$export$a61816c1105a5bb3:
            textObject.style.syncFont(textObject.canvas, textObject.context);
            text = textObject.runWordWrap(text);
            break;
        case 0, $d5c1e4e4661e06e7$export$1aa83cfb15776bf4:
            text = textObject.getText(text, undefined, undefined, true);
            break;
        case 0, $d5c1e4e4661e06e7$export$48237aa1a9416166:
            text = textObject.setText(text).getTextBounds().wrappedText;
            break;
    }
    return text;
};
var $005a6bc186ee479d$export$2e2bcd8739ae039 = $005a6bc186ee479d$var$GetWrapText;



const $5bb449e80607875f$var$GetFastValue = Phaser.Utils.Objects.GetFastValue;
const $5bb449e80607875f$var$GetValue = Phaser.Utils.Objects.GetValue;
class $5bb449e80607875f$var$TextTyping extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        this.timer = null;
        this.resetFromJSON(config);
    }
    resetFromJSON(o) {
        this.setTextWrapEnable($5bb449e80607875f$var$GetValue(o, "wrap", false));
        this.setTypeMode($5bb449e80607875f$var$GetValue(o, "typeMode", 0));
        this.setTypingSpeed($5bb449e80607875f$var$GetValue(o, "speed", 333));
        this.setTextCallback = $5bb449e80607875f$var$GetFastValue(o, "setTextCallback", null);
        this.setTextCallbackScope = $5bb449e80607875f$var$GetFastValue(o, "setTextCallbackScope", null);
        this.setTypingContent($5bb449e80607875f$var$GetFastValue(o, "text", ""));
        this.typingIdx = $5bb449e80607875f$var$GetFastValue(o, "typingIdx", 0);
        this.insertIdx = $5bb449e80607875f$var$GetFastValue(o, "insertIdx", null);
        var elapsed = $5bb449e80607875f$var$GetFastValue(o, "elapsed", null);
        if (elapsed !== null) this.start(undefined, undefined, this.typingIdx, elapsed);
        return this;
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.freeTimer();
        super.shutdown(fromScene);
    }
    setTypeMode(m) {
        if (typeof m === "string") m = $5bb449e80607875f$var$TYPEMODE[m];
        this.typeMode = m;
        return this;
    }
    setTypeSpeed(speed) {
        this.speed = speed;
        return this;
    }
    setTypingSpeed(speed) {
        this.speed = speed;
        return this;
    }
    setTextWrapEnable(enable) {
        if (enable === undefined) enable = true;
        this.textWrapEnable = enable;
        return this;
    }
    set text(value) {
        var text = $5bb449e80607875f$var$TransferText(value);
        if (this.textWrapEnable) text = (0, $005a6bc186ee479d$export$2e2bcd8739ae039)(this.parent, text);
        this._text = text;
    }
    get text() {
        return this._text;
    }
    get isTyping() {
        return this.getTimer() !== null;
    }
    get isLastChar() {
        return this.typingIdx === this.textLen;
    }
    start(text, speed, startIdx, timerStartAt) {
        if (text !== undefined) this.setTypingContent(text);
        if (speed !== undefined) this.speed = speed;
        if (startIdx === undefined) startIdx = 0;
        this.typingIdx = startIdx + 1;
        if (this.speed === 0) this.stop(true);
        else {
            this.setText("");
            this.startTimer(timerStartAt);
        }
        return this;
    }
    appendText(text) {
        var newText = this.text.concat($5bb449e80607875f$var$TransferText(text));
        if (this.isTyping) this.setTypingContent(newText);
        else this.start(newText, undefined, this.textLen);
        return this;
    }
    stop(showAllText) {
        var timer = this.getTimer();
        if (timer) this.freeTimer();
        if (showAllText) {
            this.typingIdx = this.textLen;
            this.setText(this.text);
            this.emit("type");
            this.emit("complete", this, this.parent);
        }
        return this;
    }
    pause() {
        var timer = this.getTimer();
        if (timer) timer.paused = true;
        return this;
    }
    resume() {
        var timer = this.getTimer();
        if (timer) timer.paused = false;
        return this;
    }
    setTypingContent(text) {
        this.text = text;
        this.textLen = this.getTextLength(this.text);
        return this;
    }
    onTyping() {
        var newText = this.getTypingString(this.text, this.typingIdx, this.textLen, this.typeMode);
        this.setText(newText);
        this.emit("type");
        if (this.isLastChar) {
            this.freeTimer();
            this.emit("complete", this, this.parent);
        } else {
            this.timer.delay = this.speed; // delay of next typing            
            this.typingIdx++;
        }
    }
    getTypingString(text, typeIdx, textLen, typeMode) {
        var result;
        if (typeMode === 0) {
            var startIdx = 0;
            var endIdx = typeIdx;
            this.insertIdx = endIdx;
            result = this.getSubString(text, startIdx, endIdx);
        } else if (typeMode === 1) {
            var endIdx = textLen;
            var startIdx = endIdx - typeIdx;
            this.insertIdx = 0;
            result = this.getSubString(text, startIdx, endIdx);
        } else if (typeMode === 2) {
            var midIdx = textLen / 2;
            var startIdx = Math.floor(midIdx - typeIdx / 2);
            var endIdx = startIdx + typeIdx;
            this.insertIdx = typeIdx % 2 ? typeIdx : 0;
            result = this.getSubString(text, startIdx, endIdx);
        } else if (typeMode === 3) {
            var lowerLen = Math.floor(typeIdx / 2);
            var lowerResult;
            if (lowerLen > 0) {
                var endIdx = textLen;
                var startIdx = endIdx - lowerLen;
                lowerResult = this.getSubString(text, startIdx, endIdx);
            } else lowerResult = "";
            var upperLen = typeIdx - lowerLen;
            var upperResult;
            if (upperLen > 0) {
                var startIdx = 0;
                var endIdx = startIdx + upperLen;
                this.insertIdx = endIdx;
                upperResult = this.getSubString(text, startIdx, endIdx);
            } else {
                upperResult = "";
                this.insertIdx = 0;
            }
            result = upperResult + lowerResult;
        }
        return result;
    }
    startTimer(timerStartAt) {
        if (this.timer) this.freeTimer();
        var delay, startAt;
        if (timerStartAt === undefined) {
            delay = 0;
            startAt = 0;
        } else {
            delay = this.speed;
            startAt = timerStartAt;
        }
        this.timer = this.scene.time.addEvent({
            delay: 0,
            startAt: startAt,
            loop: true,
            callback: this.onTyping,
            callbackScope: this
        });
        return this;
    }
    getTimer() {
        return this.timer;
    }
    freeTimer() {
        if (this.timer) {
            this.timer.remove();
            this.timer = null;
        }
        return this;
    }
    setText(text) {
        if (this.setTextCallback) {
            if (this.setTextCallbackScope) text = this.setTextCallback.call(this.setTextCallbackScope, text, this.isLastChar, this.insertIdx);
            else text = this.setTextCallback(text, this.isLastChar, this.insertIdx);
        }
        if (this.textWrapEnable) (0, $d4581d482844dcb0$export$2e2bcd8739ae039)(this.parent, text);
        else this.parent.setText(text);
    }
    getTextLength(text) {
        var gameObject = this.parent;
        var len;
        if (gameObject.getPlainText) len = gameObject.getPlainText(text).length;
        else len = text.length;
        return len;
    }
    getSubString(text, startIdx, endIdx) {
        var gameObject = this.parent;
        var result;
        if (gameObject.getSubString) result = gameObject.getSubString(text, startIdx, endIdx);
        else result = text.slice(startIdx, endIdx);
        return result;
    }
}
var $5bb449e80607875f$var$TransferText = function(text) {
    if (Array.isArray(text)) text = text.join("\n");
    else if (typeof text === "number") text = text.toString();
    return text;
};
const $5bb449e80607875f$var$TYPEMODE = {
    "left-to-right": 0,
    "right-to-left": 1,
    "middle-to-sides": 2,
    "sides-to-middle": 3
};
var $5bb449e80607875f$export$2e2bcd8739ae039 = $5bb449e80607875f$var$TextTyping;


var $083d465ba72f39f1$export$2e2bcd8739ae039 = (0, $5bb449e80607875f$export$2e2bcd8739ae039);


var $649aaec0a328c95d$export$2e2bcd8739ae039 = (0, $083d465ba72f39f1$export$2e2bcd8739ae039);


const $920f50ff0285db84$var$GetValue = Phaser.Utils.Objects.GetValue;
class $920f50ff0285db84$var$TextBox extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {
            text: $920f50ff0285db84$var$createDefaultTextObject(scene)
        };
        super(scene, config);
        this.type = "rexTextBox";
        var text = this.childrenMap.text;
        this.page = new (0, $45891b7699fcfb45$export$2e2bcd8739ae039)(text, $920f50ff0285db84$var$GetValue(config, "page", undefined));
        this.typing = new (0, $649aaec0a328c95d$export$2e2bcd8739ae039)(text, $920f50ff0285db84$var$GetValue(config, "typing", config.type));
        this.typing.on("complete", this.onPageEnd, this).on("type", this.onType, this);
        this.textWidth = text.width;
        this.textHeight = text.height;
    }
    start(text, speed) {
        this.page.setText(text);
        if (speed !== undefined) this.setTypingSpeed(speed);
        this.typeNextPage();
        return this;
    }
    typeNextPage() {
        if (!this.isLastPage) {
            var txt = this.page.getNextPage();
            this.typing.start(txt);
        } else this.emit("complete");
        return this;
    }
    pause() {
        this.typing.pause();
        return this;
    }
    resume() {
        this.typing.resume();
        return this;
    }
    stop(showAllText) {
        this.typing.stop(showAllText);
        return this;
    }
    setTypeSpeed(speed) {
        this.typing.setTypingSpeed(speed);
        return this;
    }
    setTypingSpeed(speed) {
        this.typing.setTypingSpeed(speed);
        return this;
    }
    get isTyping() {
        return this.typing.isTyping;
    }
    get isLastPage() {
        return this.page.isLastPage;
    }
    get isFirstPage() {
        return this.page.isFirstPage;
    }
    get pageCount() {
        return this.page.pageCount;
    }
    get pageIndex() {
        return this.page.pageIndex;
    }
    onType() {
        var text = this.childrenMap.text;
        if (this.textWidth !== text.width || this.textHeight !== text.height) {
            this.textWidth = text.width;
            this.textHeight = text.height;
            this.getTopmostSizer().layout();
        }
        this.emit("type");
    }
    onPageEnd() {
        this.emit("pageend");
        if (this.isLastPage) this.emit("complete");
    }
}
var $920f50ff0285db84$var$createDefaultTextObject = function(scene) {
    return scene.add.text(0, 0, "", {
        wordWrap: {
            width: 200
        },
        maxLines: 5
    });
};
var $920f50ff0285db84$export$2e2bcd8739ae039 = $920f50ff0285db84$var$TextBox;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textBox", function(config) {
    var gameObject = new (0, $920f50ff0285db84$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextBox", (0, $920f50ff0285db84$export$2e2bcd8739ae039));
var $d8f4a6b72eb44e24$export$2e2bcd8739ae039 = (0, $920f50ff0285db84$export$2e2bcd8739ae039);





const $b79455eadeb99a69$var$GetValue = Phaser.Utils.Objects.GetValue;
class $b79455eadeb99a69$var$NumberBar extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer
        super(scene, config);
        this.type = "rexNumberBar";
        // Add elements
        var background = $b79455eadeb99a69$var$GetValue(config, "background", undefined);
        var icon = $b79455eadeb99a69$var$GetValue(config, "icon", undefined);
        var iconMask = $b79455eadeb99a69$var$GetValue(config, "iconMask", undefined);
        var sliderConfig = $b79455eadeb99a69$var$GetValue(config, "slider", undefined);
        var text = $b79455eadeb99a69$var$GetValue(config, "text", undefined);
        // Space
        var iconSpace = $b79455eadeb99a69$var$GetValue(config, "space.icon", 0);
        var sliderSpace = $b79455eadeb99a69$var$GetValue(config, "space.slider", 0);
        if (background) this.addBackground(background);
        if (icon) {
            var padding;
            if (this.orientation === 0) {
                if (sliderConfig || text) padding = {
                    right: iconSpace
                };
            } else if (sliderConfig || text) padding = {
                bottom: iconSpace
            };
            this.add(icon, {
                proportion: 0,
                align: "center",
                padding: padding
            });
            if (iconMask) iconMask = (0, $a0eb54418fe4678f$export$2e2bcd8739ae039).call(this, icon, icon, 1); // Circle mask
        }
        var slider;
        if (sliderConfig) {
            sliderConfig.orientation = this.orientation;
            sliderConfig.eventEmitter = this;
            sliderConfig.value = null;
            if (!sliderConfig.hasOwnProperty("input")) sliderConfig.input = -1;
            slider = new (0, $acd4b431e3164bd7$export$2e2bcd8739ae039)(scene, sliderConfig);
            scene.add.existing(slider);
            var padding;
            if (this.orientation === 0) {
                if (text) padding = {
                    right: sliderSpace
                };
            } else if (text) padding = {
                bottom: sliderSpace
            };
            var proportion;
            if (this.orientation === 0) {
                var sliderWidth = $b79455eadeb99a69$var$GetValue(sliderConfig, "width", undefined);
                proportion = sliderWidth === undefined ? 1 : 0;
            } else {
                var sliderHeight = $b79455eadeb99a69$var$GetValue(sliderConfig, "height", undefined);
                proportion = sliderHeight === undefined ? 1 : 0;
            }
            this.add(slider, {
                proportion: proportion,
                align: "center",
                padding: padding
            });
        }
        if (text) this.add(text);
        this.addChildrenMap("background", background);
        this.addChildrenMap("icon", icon);
        this.addChildrenMap("iconMask", iconMask);
        this.addChildrenMap("slider", slider);
        this.addChildrenMap("text", text);
        var callback = $b79455eadeb99a69$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $b79455eadeb99a69$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        this.setEnable($b79455eadeb99a69$var$GetValue(config, "enable", undefined));
        this.setValue($b79455eadeb99a69$var$GetValue(config, "value", 0));
    }
    get enable() {
        if (this.childrenMap.slider) return this.childrenMap.slider.enable;
        else return false;
    }
    set enable(value) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEnable(value);
    }
    setEnable(enable) {
        if (enable === undefined) enable = true;
        this.enable = enable;
        return this;
    }
    get value() {
        if (this.childrenMap.slider) return this.childrenMap.slider.value;
        else return 0;
    }
    set value(value) {
        if (!this.childrenMap.slider) return;
        this.childrenMap.slider.value = value;
    }
    setValue(value, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.setValue(value, min, max);
        return this;
    }
    addValue(inc, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.addValue(inc, min, max);
        return this;
    }
    getValue(min, max) {
        if (this.childrenMap.slider) return this.childrenMap.slider.getValue(min, max);
        else return 0;
    }
    easeValueTo(value, min, max) {
        if (this.childrenMap.slider) this.childrenMap.slider.easeValueTo(value, min, max);
        return this;
    }
    stopEaseValue() {
        if (this.childrenMap.slider) this.childrenMap.slider.stopEaseValue();
        return this;
    }
    setEaseValueDuration(duration) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEaseValueDuration(duration);
        return this;
    }
    setEaseValueFunction(ease) {
        if (this.childrenMap.slider) this.childrenMap.slider.setEaseValueFunction(ease);
        return this;
    }
    get text() {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return "";
        var value;
        if (textObject.text) value = textObject.text;
        else value = textObject.getData("text");
        return value;
    }
    set text(value) {
        var textObject = this.childrenMap.text;
        if (textObject === undefined) return;
        if (textObject.setText) textObject.setText(value);
        else textObject.setData("text", value);
    }
    setText(value) {
        this.text = value;
        return this;
    }
}
var $b79455eadeb99a69$export$2e2bcd8739ae039 = $b79455eadeb99a69$var$NumberBar;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("numberBar", function(config) {
    var gameObject = new (0, $b79455eadeb99a69$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.NumberBar", (0, $b79455eadeb99a69$export$2e2bcd8739ae039));
var $22914c4a08d253fe$export$2e2bcd8739ae039 = (0, $b79455eadeb99a69$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("scrollBar", function(config) {
    var gameObject = new (0, $e0992a47ab11a94a$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ScrollBar", (0, $e0992a47ab11a94a$export$2e2bcd8739ae039));
var $1cda6ed391f04ef1$export$2e2bcd8739ae039 = (0, $e0992a47ab11a94a$export$2e2bcd8739ae039);



const $a1a15cacc45ad7fd$var$GetValue = Phaser.Utils.Objects.GetValue;
const $a1a15cacc45ad7fd$var$BadgeKeys = {
    leftTop: "left-top",
    centerTop: "center-top",
    rightTop: "right-top",
    leftCenter: "left-center",
    center: "center",
    rightCenter: "right-center",
    leftBottom: "left-bottom",
    centerBottom: "center-bottom",
    rightBottom: "right-bottom"
};
class $a1a15cacc45ad7fd$var$Badge extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        // Create sizer  
        super(scene, config);
        this.type = "rexBadge";
        // Add elements
        var background = $a1a15cacc45ad7fd$var$GetValue(config, "background", undefined);
        if (background) this.addBackground(background);
        this.addChildrenMap("background", background);
        // Base item
        var main = $a1a15cacc45ad7fd$var$GetValue(config, "main", undefined);
        if (main) this.add(main, {
            key: "main",
            align: "center",
            expand: false
        });
        this.addChildrenMap("main", main);
        // Badges
        for(var key in $a1a15cacc45ad7fd$var$BadgeKeys){
            var badge = $a1a15cacc45ad7fd$var$GetValue(config, key, undefined);
            if (badge) {
                this.add(badge, {
                    key: key,
                    align: $a1a15cacc45ad7fd$var$BadgeKeys[key],
                    expand: false
                });
                this.addChildrenMap(key, badge);
            }
        }
    }
}
var $a1a15cacc45ad7fd$export$2e2bcd8739ae039 = $a1a15cacc45ad7fd$var$Badge;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("badgeLabel", function(config) {
    var gameObject = new (0, $a1a15cacc45ad7fd$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.BadgeLabel", (0, $a1a15cacc45ad7fd$export$2e2bcd8739ae039));
var $d02e3fa1e868976d$export$2e2bcd8739ae039 = (0, $a1a15cacc45ad7fd$export$2e2bcd8739ae039);




const $4c3dd15b78cf39b4$var$OverlapSizerAdd = (0, $4d318a74c42de65b$export$2e2bcd8739ae039).prototype.add;
var $4c3dd15b78cf39b4$var$Add = function(gameObject, childKey, align, padding, expand, minWidth, minHeight, offsetX, offsetY) {
    gameObject.setVisible(false); // Default is invisible
    $4c3dd15b78cf39b4$var$OverlapSizerAdd.call(this, gameObject, childKey, align, padding, expand, minWidth, minHeight, offsetX, offsetY);
    return this;
};
var $4c3dd15b78cf39b4$export$2e2bcd8739ae039 = {
    add: $4c3dd15b78cf39b4$var$Add,
    addPage: $4c3dd15b78cf39b4$var$Add
};


var $2337c2d8d7c95aff$var$GetPage = function(key) {
    if (key === undefined) return null;
    else if (!this.sizerChildren.hasOwnProperty(key)) return null;
    else return this.sizerChildren[key];
};
var $2337c2d8d7c95aff$export$2e2bcd8739ae039 = $2337c2d8d7c95aff$var$GetPage;



const $69c7d1696994b4fe$var$ContainerSetChildVisible = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039).prototype.setChildVisible;
var $69c7d1696994b4fe$var$SwapPage = function(key, fadeInDuration) {
    this._previousKey = this._currentKey;
    var prevoiusPage = this.previousPage;
    if (prevoiusPage) {
        if (this.swapMode === 0) {
            $69c7d1696994b4fe$var$ContainerSetChildVisible.call(this, prevoiusPage, false);
            this.emit("pageinvisible", prevoiusPage, this._previousKey, this);
        } else prevoiusPage.destroy();
    }
    if (key && !this.sizerChildren.hasOwnProperty(key)) this.emit("createpage", key, this);
    this._currentKey = key;
    var currentPage = this.currentPage;
    if (currentPage) {
        $69c7d1696994b4fe$var$ContainerSetChildVisible.call(this, currentPage, true);
        this.emit("pagevisible", currentPage, this._currentKey, this);
        if (fadeInDuration === undefined) fadeInDuration = this.fadeInDuration;
        if (fadeInDuration > 0) currentPage.setAlpha(0).fadeIn(fadeInDuration, 1);
    }
    return this;
};
var $69c7d1696994b4fe$export$2e2bcd8739ae039 = $69c7d1696994b4fe$var$SwapPage;


var $c096e77095383e31$var$HasPage = function(key) {
    return this.sizerChildren.hasOwnProperty(key);
};
var $c096e77095383e31$export$2e2bcd8739ae039 = $c096e77095383e31$var$HasPage;


var $573d3b7bd96b6257$var$methods = {
    getPage: (0, $2337c2d8d7c95aff$export$2e2bcd8739ae039),
    swapPage: (0, $69c7d1696994b4fe$export$2e2bcd8739ae039),
    hasPage: (0, $c096e77095383e31$export$2e2bcd8739ae039)
};
Object.assign($573d3b7bd96b6257$var$methods, (0, $4c3dd15b78cf39b4$export$2e2bcd8739ae039));
var $573d3b7bd96b6257$export$2e2bcd8739ae039 = $573d3b7bd96b6257$var$methods;


const $27d0a6de10246f93$var$GetValue = Phaser.Utils.Objects.GetValue;
class $27d0a6de10246f93$var$Pages extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexPages";
        this.childrenMap = this.sizerChildren;
        this._previousKey = undefined;
        this._currentKey = undefined;
        this.setSwapMode($27d0a6de10246f93$var$GetValue(config, "swapMode", 0));
        this.setFadeInDuration($27d0a6de10246f93$var$GetValue(config, "fadeIn", 0));
    }
    setSwapMode(mode) {
        if (typeof mode === "string") mode = $27d0a6de10246f93$var$SWAPMODE[mode];
        this.swapMode = mode;
        return this;
    }
    setFadeInDuration(duration) {
        this.fadeInDuration = duration;
        return this;
    }
    get previousKey() {
        return this._previousKey;
    }
    get currentKey() {
        return this._currentKey;
    }
    set currentKey(key) {
        this.swapPage(key);
    }
    get currentPage() {
        return this.getPage(this.currentKey);
    }
    get previousPage() {
        return this.getPage(this.previousKey);
    }
    get keys() {
        return Object.keys(this.sizerChildren);
    }
}
Object.assign($27d0a6de10246f93$var$Pages.prototype, (0, $573d3b7bd96b6257$export$2e2bcd8739ae039));
const $27d0a6de10246f93$var$SWAPMODE = {
    invisible: 0,
    destroy: 1
};
var $27d0a6de10246f93$export$2e2bcd8739ae039 = $27d0a6de10246f93$var$Pages;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("pages", function(config) {
    var gameObject = new (0, $27d0a6de10246f93$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Pages", (0, $27d0a6de10246f93$export$2e2bcd8739ae039));
var $540043c7162ad771$export$2e2bcd8739ae039 = (0, $27d0a6de10246f93$export$2e2bcd8739ae039);



const $9f813d65cd866fd7$var$Vector3 = Phaser.Math.Vector3;
const $9f813d65cd866fd7$var$Matrix4 = Phaser.Math.Matrix4;
var $9f813d65cd866fd7$var$tempPosition = new $9f813d65cd866fd7$var$Vector3();
var $9f813d65cd866fd7$var$tempRotation = new $9f813d65cd866fd7$var$Vector3();
var $9f813d65cd866fd7$var$tempMatrix = new $9f813d65cd866fd7$var$Matrix4();
var $9f813d65cd866fd7$var$TransformVerts = function(mesh, x, y, z, rotateX, rotateY, rotateZ) {
    if (x === undefined) x = 0;
    if (y === undefined) y = 0;
    if (z === undefined) z = 0;
    if (rotateX === undefined) rotateX = 0;
    if (rotateY === undefined) rotateY = 0;
    if (rotateZ === undefined) rotateZ = 0;
    $9f813d65cd866fd7$var$tempPosition.set(x, y, z);
    $9f813d65cd866fd7$var$tempRotation.set(rotateX, rotateY, rotateZ);
    $9f813d65cd866fd7$var$tempMatrix.fromRotationXYTranslation($9f813d65cd866fd7$var$tempRotation, $9f813d65cd866fd7$var$tempPosition, true);
    for(var i = 0, cnt = mesh.vertices.length; i < cnt; i++)mesh.vertices[i].transformMat4($9f813d65cd866fd7$var$tempMatrix);
};
var $9f813d65cd866fd7$export$2e2bcd8739ae039 = $9f813d65cd866fd7$var$TransformVerts;


const $6603d560a1c4ce3c$var$Mesh = Phaser.GameObjects.Mesh;
const $6603d560a1c4ce3c$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $6603d560a1c4ce3c$var$GetValue = Phaser.Utils.Objects.GetValue;
const $6603d560a1c4ce3c$var$GenerateGridVerts = Phaser.Geom.Mesh.GenerateGridVerts;
const $6603d560a1c4ce3c$var$RadToDeg = Phaser.Math.RadToDeg;
const $6603d560a1c4ce3c$var$DegToRad = Phaser.Math.DegToRad;
const $6603d560a1c4ce3c$var$FOV = 45;
const $6603d560a1c4ce3c$var$PanZ = 1 + 1 / Math.sin($6603d560a1c4ce3c$var$DegToRad($6603d560a1c4ce3c$var$FOV));
class $6603d560a1c4ce3c$var$Image extends $6603d560a1c4ce3c$var$Mesh {
    constructor(scene, x, y, key, frame, config){
        if ($6603d560a1c4ce3c$var$IsPlainObject(x)) {
            config = x;
            x = $6603d560a1c4ce3c$var$GetValue(config, "x", 0);
            y = $6603d560a1c4ce3c$var$GetValue(config, "y", 0);
            key = $6603d560a1c4ce3c$var$GetValue(config, "key", null);
            frame = $6603d560a1c4ce3c$var$GetValue(config, "frame", null);
        }
        super(scene, x, y, key, frame);
        this.type = "rexPerspectiveImage";
        this.setSizeToFrame();
        this.resetPerspective();
        this.panZ($6603d560a1c4ce3c$var$PanZ);
        this.hideCCW = $6603d560a1c4ce3c$var$GetValue(config, "hideCCW", true);
        var gridWidth = $6603d560a1c4ce3c$var$GetValue(config, "gridWidth", 32);
        var gridHeight = $6603d560a1c4ce3c$var$GetValue(config, "gridHeight", gridWidth);
        this.resetVerts(gridWidth, gridHeight);
    }
    get originX() {
        return 0.5;
    }
    get originY() {
        return 0.5;
    }
    get displayOriginX() {
        return this.width * 0.5;
    }
    get displayOriginY() {
        return this.height * 0.5;
    }
    resetPerspective() {
        this.setPerspective(this.width, this.height, $6603d560a1c4ce3c$var$FOV);
        return this;
    }
    resetVerts(gridWidth, gridHeight) {
        if (gridWidth !== undefined) this.gridWidth = gridWidth;
        if (gridHeight !== undefined) this.gridHeight = gridHeight;
        // Clear faces and vertices
        this.clear();
        this.dirtyCache[9] = -1;
        if (this.width === 0 || this.height === 0) return this;
        // Generate faces and vertices
        var frameWidth = this.frame.cutWidth, frameHeight = this.frame.cutHeight;
        $6603d560a1c4ce3c$var$GenerateGridVerts({
            mesh: this,
            texture: this.texture.key,
            frame: this.frame.name,
            width: frameWidth / this.height,
            height: frameHeight / this.height,
            widthSegments: Math.ceil(frameWidth / this.gridWidth),
            heightSegments: Math.ceil(frameHeight / this.gridHeight),
            flipY: this.frame.source.isRenderTexture
        });
        // Recover vertices transform
        var transformInfo = this.transformInfo;
        if (transformInfo) this.transformVerts(transformInfo.x, transformInfo.y, transformInfo.z, transformInfo.rotateX, transformInfo.rotateY, transformInfo.rotateZ);
        return this;
    }
    syncSize() {
        this.setSizeToFrame(); // Reset size
        this.resetPerspective(); // Reset perspective
        this.resetVerts(); // Reset verts
        return this;
    }
    get rotationX() {
        return this.modelRotation.x;
    }
    set rotationX(value) {
        this.modelRotation.x = value;
    }
    get angleX() {
        return $6603d560a1c4ce3c$var$RadToDeg(this.rotationX);
    }
    set angleX(value) {
        this.rotationX = $6603d560a1c4ce3c$var$DegToRad(value);
    }
    get rotationY() {
        return this.modelRotation.y;
    }
    set rotationY(value) {
        this.modelRotation.y = value;
    }
    get angleY() {
        return $6603d560a1c4ce3c$var$RadToDeg(this.rotationY);
    }
    set angleY(value) {
        this.rotationY = $6603d560a1c4ce3c$var$DegToRad(value);
    }
    get rotationZ() {
        return this.modelRotation.z;
    }
    set rotationZ(value) {
        this.modelRotation.z = value;
    }
    get angleZ() {
        return $6603d560a1c4ce3c$var$RadToDeg(this.rotationZ);
    }
    set angleZ(value) {
        this.rotationZ = $6603d560a1c4ce3c$var$DegToRad(value);
    }
    transformVerts(x, y, z, rotateX, rotateY, rotateZ) {
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (z === undefined) z = 0;
        if (rotateX === undefined) rotateX = 0;
        if (rotateY === undefined) rotateY = 0;
        if (rotateZ === undefined) rotateZ = 0;
        if (!this.transformInfo) this.transformInfo = {};
        this.transformInfo.x = x;
        this.transformInfo.y = y;
        this.transformInfo.rotateX = rotateX;
        this.transformInfo.rotateY = rotateY;
        this.transformInfo.rotateZ = rotateZ;
        (0, $9f813d65cd866fd7$export$2e2bcd8739ae039)(this, x, y, z, rotateX, rotateY, rotateZ);
        return this;
    }
    forceUpdate() {
        this.dirtyCache[10] = 1;
        return this;
    }
    get tint() {
        if (this.vertices.length === 0) return 0xffffff;
        else return this.vertices[0].color;
    }
    set tint(value) {
        var vertices = this.vertices;
        for(var i = 0, cnt = vertices.length; i < cnt; i++)vertices[i].color = value;
    }
    setTint(color) {
        this.tint = color;
        return this;
    }
}
var $6603d560a1c4ce3c$export$2e2bcd8739ae039 = $6603d560a1c4ce3c$var$Image;




const $1ee2acf186d8581a$var$RT = Phaser.GameObjects.RenderTexture;
const $1ee2acf186d8581a$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $1ee2acf186d8581a$var$GetValue = Phaser.Utils.Objects.GetValue;
class $1ee2acf186d8581a$var$RenderTexture extends (0, $6603d560a1c4ce3c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, config){
        if ($1ee2acf186d8581a$var$IsPlainObject(x)) {
            config = x;
            x = $1ee2acf186d8581a$var$GetValue(config, "x", 0);
            y = $1ee2acf186d8581a$var$GetValue(config, "y", 0);
            width = $1ee2acf186d8581a$var$GetValue(config, "width", 32);
            height = $1ee2acf186d8581a$var$GetValue(config, "height", 32);
        }
        // render-texture -> perspective-image
        var rt = new $1ee2acf186d8581a$var$RT(scene, x, y, width, height).setOrigin(0.5);
        super(scene, x, y, rt.texture.key, null, config);
        this.type = "rexPerspectiveRenderTexture";
        this.rt = rt;
    }
    destroy(fromScene) {
        super.destroy(fromScene);
        this.rt.destroy();
        this.rt = null;
    }
    snapshot(gameObjects, config) {
        if (config === undefined) config = {};
        config.gameObjects = gameObjects;
        config.renderTexture = this.rt;
        (0, $77b8570de39b9238$export$2e2bcd8739ae039)(config);
        if (this.width !== this.frame.realWidth || this.height !== this.frame.realHeight) this.syncSize();
        return this;
    }
}
var $1ee2acf186d8581a$export$2e2bcd8739ae039 = $1ee2acf186d8581a$var$RenderTexture;



const $d601e2fd7ea37cbe$var$AnimationState = Phaser.Animations.AnimationState;
const $d601e2fd7ea37cbe$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $d601e2fd7ea37cbe$var$GetValue = Phaser.Utils.Objects.GetValue;
class $d601e2fd7ea37cbe$var$Sprite extends (0, $6603d560a1c4ce3c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, key, frame, config){
        if ($d601e2fd7ea37cbe$var$IsPlainObject(x)) {
            config = x;
            x = $d601e2fd7ea37cbe$var$GetValue(config, "x", 0);
            y = $d601e2fd7ea37cbe$var$GetValue(config, "y", 0);
            key = $d601e2fd7ea37cbe$var$GetValue(config, "key", null);
            frame = $d601e2fd7ea37cbe$var$GetValue(config, "frame", null);
        }
        super(scene, x, y, key, frame, config);
        this.type = "rexPerspectiveSprite";
        this.anims = new $d601e2fd7ea37cbe$var$AnimationState(this);
    }
    destroy(fromScene) {
        this.anims.destroy();
        this.anims = undefined;
        super.destroy(fromScene);
    }
    preUpdate(time, delta) {
        var prevFrame = this.anims.currentFrame;
        this.anims.update(time, delta);
        if (this.anims.currentFrame !== prevFrame) this.syncSize();
        super.preUpdate(time, delta);
    }
    play(key, ignoreIfPlaying, startFrame) {
        return this.anims.play(key, ignoreIfPlaying, startFrame);
    }
    playReverse(key, ignoreIfPlaying) {
        return this.anims.playReverse(key, ignoreIfPlaying);
    }
    playAfterDelay(key, delay) {
        return this.anims.playAfterDelay(key, delay);
    }
    playAfterRepeat(key, repeatCount) {
        return this.anims.playAfterRepeat(key, repeatCount);
    }
    chain(key) {
        return this.anims.chain(key);
    }
    stop() {
        return this.anims.stop();
    }
    stopAfterDelay(delay) {
        return this.anims.stopAfterDelay(delay);
    }
    stopAfterRepeat(repeatCount) {
        return this.anims.stopAfterRepeat(repeatCount);
    }
    stopOnFrame(frame) {
        return this.anims.stopOnFrame(frame);
    }
}
var $d601e2fd7ea37cbe$export$2e2bcd8739ae039 = $d601e2fd7ea37cbe$var$Sprite;



var $dfd6b9e1b12c66d3$var$ForEachFace = function(faces, callback, scope, ignoreInvalid) {
    if (Array.isArray(faces)) {
        var isBreak = false;
        for(var i = 0, cnt = faces.length; i < cnt; i++){
            var face = faces[i];
            if (ignoreInvalid && !face) continue;
            if (scope) isBreak = callback.call(scope, face, i, faces);
            else isBreak = callback(face, i, faces);
            if (isBreak) return;
        }
    } else {
        var isBreak = false;
        for(var name in faces){
            var face = faces[name];
            if (ignoreInvalid && !face) continue;
            if (scope) isBreak = callback.call(scope, face, name, faces);
            else isBreak = callback(face, name, faces);
            if (isBreak) return;
        }
    }
};
var $dfd6b9e1b12c66d3$export$2e2bcd8739ae039 = $dfd6b9e1b12c66d3$var$ForEachFace;


const $2bfda3f951c8cd4c$var$RadToDeg = Phaser.Math.RadToDeg;
const $2bfda3f951c8cd4c$var$DegToRad = Phaser.Math.DegToRad;
class $2bfda3f951c8cd4c$var$FaceContainer extends (0, $3799588e8b69e578$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, faces){
        super(scene, x, y, width, height);
        this.faces = faces; // Face Dictionary, or array
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(faces, function(face) {
            face.setPosition(x, y);
            this.add(face);
        }, this, true);
    }
    // Override
    get rotationX() {
        return 0;
    }
    // Override
    set rotationX(value) {
    // rad
    }
    get angleX() {
        return $2bfda3f951c8cd4c$var$RadToDeg(this.rotationX);
    }
    set angleX(value) {
        this.rotationX = $2bfda3f951c8cd4c$var$DegToRad(value);
    }
    // Override
    get rotationY() {
        return 0;
    }
    // Override
    set rotationY(value) {
    // rad
    }
    get angleY() {
        return $2bfda3f951c8cd4c$var$RadToDeg(this.rotationY);
    }
    set angleY(value) {
        this.rotationY = $2bfda3f951c8cd4c$var$DegToRad(value);
    }
    // Override
    get rotationZ() {
        return 0;
    }
    // Override
    set rotationZ(value) {
    // rad
    }
    get angleZ() {
        return $2bfda3f951c8cd4c$var$RadToDeg(this.rotationZ);
    }
    set angleZ(value) {
        this.rotationZ = $2bfda3f951c8cd4c$var$DegToRad(value);
    }
    setDebug(graphic, callback) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.setDebug(graphic, callback);
        }, null, true);
        return this;
    }
    panX(v) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.panX(v);
        }, null, true);
        return this;
    }
    panY(v) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.panY(v);
        }, null, true);
        return this;
    }
    panZ(v) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.panZ(v);
        }, null, true);
        return this;
    }
    transformVerts(x, y, z, rotateX, rotateY, rotateZ) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.transformVerts(x, y, z, rotateX, rotateY, rotateZ);
        }, null, true);
        return this;
    }
    forEachFace(callback, scope, ignoreInvalid) {
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, callback, scope, ignoreInvalid);
        return this;
    }
}
var $2bfda3f951c8cd4c$export$2e2bcd8739ae039 = $2bfda3f951c8cd4c$var$FaceContainer;




const $faf2d181f4822cb9$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $faf2d181f4822cb9$var$DefaultImageConfig = {
    key: "__WHITE"
};
const $faf2d181f4822cb9$var$ClassMap = {
    image: (0, $6603d560a1c4ce3c$export$2e2bcd8739ae039),
    rendertexture: (0, $1ee2acf186d8581a$export$2e2bcd8739ae039)
};
var $faf2d181f4822cb9$var$CreatePerspectiveObject = function(scene, config) {
    if (config === undefined) config = $faf2d181f4822cb9$var$DefaultImageConfig;
    var perspectiveObject;
    if ($faf2d181f4822cb9$var$IsPlainObject(config)) {
        if (!config.hasOwnProperty("type")) {
            if (config.hasOwnProperty("key")) config.type = "image";
            else if (config.hasOwnProperty("width")) config.type = "rendertexture";
        }
        perspectiveObject = new $faf2d181f4822cb9$var$ClassMap[config.type](scene, config);
        scene.add.existing(perspectiveObject);
    } else perspectiveObject = config;
    return perspectiveObject;
};
var $faf2d181f4822cb9$export$2e2bcd8739ae039 = $faf2d181f4822cb9$var$CreatePerspectiveObject;


var $004aadb34e4aa1f9$var$CreateFaces = function(scene, config, faceNames) {
    var faces;
    if (faceNames === undefined) {
        faces = [];
        var face, faceConfig;
        for(var i = 0, cnt = config.length; i < cnt; i++){
            faceConfig = config[i];
            if (faceConfig) face = (0, $faf2d181f4822cb9$export$2e2bcd8739ae039)(scene, faceConfig);
            else face = null;
            faces.push(face);
        }
    } else {
        faces = {};
        var face, name;
        for(var i = 0, cnt = faceNames.length; i < cnt; i++){
            name = faceNames[i];
            if (config.hasOwnProperty(name)) face = (0, $faf2d181f4822cb9$export$2e2bcd8739ae039)(scene, config[name]);
            else face = null;
            faces[name] = face;
        }
    }
    return faces;
};
var $004aadb34e4aa1f9$export$2e2bcd8739ae039 = $004aadb34e4aa1f9$var$CreateFaces;



const $05bec6dd25ec056b$var$DegToRad = Phaser.Math.DegToRad;
const $05bec6dd25ec056b$var$RAD180 = $05bec6dd25ec056b$var$DegToRad(180);
var $05bec6dd25ec056b$var$LayoutFaces = function(parent, faces) {
    var backFace = faces.back;
    if (backFace) {
        if (parent.orientation === 0) backFace.transformVerts(0, 0, 0, 0, $05bec6dd25ec056b$var$RAD180, 0);
        else backFace.transformVerts(0, 0, 0, $05bec6dd25ec056b$var$RAD180, 0, 0);
    }
};
var $05bec6dd25ec056b$export$2e2bcd8739ae039 = $05bec6dd25ec056b$var$LayoutFaces;



const $bd4aedbad60ffa75$var$GetValue = Phaser.Utils.Objects.GetValue;
const $bd4aedbad60ffa75$var$Linear = Phaser.Math.Linear;
class $bd4aedbad60ffa75$var$Flip extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setEase($bd4aedbad60ffa75$var$GetValue(o, "ease", "Cubic"));
        this.setFrontToBackDirection($bd4aedbad60ffa75$var$GetValue(o, "frontToBack", 0));
        this.setBackToFrontDirection($bd4aedbad60ffa75$var$GetValue(o, "backToFront", 1));
        return this;
    }
    setFrontToBackDirection(direction) {
        if (typeof direction === "string") direction = $bd4aedbad60ffa75$var$DIRMODE[direction];
        this.endAngleFB = direction === 0 ? 180 : -180;
        return this;
    }
    setBackToFrontDirection(direction) {
        if (typeof direction === "string") direction = $bd4aedbad60ffa75$var$DIRMODE[direction];
        this.endAngleBF = direction === 0 ? -180 : 180;
        return this;
    }
    start(duration, repeat) {
        if (this.timer.isRunning) return this;
        this.timer.setDelay(this.delay).setDuration(duration);
        var loop = repeat + 1;
        var gameObject = this.parent;
        if (gameObject.face === 0) {
            this.startAngle = 0;
            this.endAngle = this.endAngleFB * loop;
        } else {
            this.startAngle = this.endAngleBF;
            this.endAngle = this.startAngle - this.endAngleBF * loop;
        }
        super.start();
        return this;
    }
    flip(duration, repeat) {
        if (this.isRunning) return this;
        if (duration === undefined) duration = this.duration;
        if (repeat === undefined) repeat = 0;
        this.start(duration, repeat);
        this.emit("start", this.parent, this);
        // Set face index
        this.parent.currentFaceIndex = (this.parent.currentFaceIndex + repeat + 1) % 2;
        return this;
    }
    flipRight(duration, repeat) {
        if (this.parent.currentFaceIndex === 0) this.setFrontToBackDirection(0);
        else this.setBackToFrontDirection(0);
        this.flip(duration, repeat);
        return this;
    }
    flipLeft(duration, repeat) {
        if (this.parent.currentFaceIndex === 0) this.setFrontToBackDirection(1);
        else this.setBackToFrontDirection(1);
        this.flip(duration, repeat);
        return this;
    }
    updateGameObject(gameObject, timer) {
        var t = this.easeFn(timer.t);
        var value = $bd4aedbad60ffa75$var$Linear(this.startAngle, this.endAngle, t);
        if (gameObject.orientation === 0) gameObject.angleY = value;
        else gameObject.angleX = value;
    }
}
const $bd4aedbad60ffa75$var$DIRMODE = {
    "right": 0,
    "left-to-right": 0,
    "left": 1,
    "right-to-left": 1
};
var $bd4aedbad60ffa75$export$2e2bcd8739ae039 = $bd4aedbad60ffa75$var$Flip;


const $e519ff1627507adc$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $e519ff1627507adc$var$GetValue = Phaser.Utils.Objects.GetValue;
const $e519ff1627507adc$var$FaceNames = [
    "back",
    "front"
];
class $e519ff1627507adc$var$Card extends (0, $2bfda3f951c8cd4c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, config){
        if ($e519ff1627507adc$var$IsPlainObject(x)) {
            config = x;
            x = $e519ff1627507adc$var$GetValue(config, "x", 0);
            y = $e519ff1627507adc$var$GetValue(config, "y", 0);
        }
        var faces = (0, $004aadb34e4aa1f9$export$2e2bcd8739ae039)(scene, config, $e519ff1627507adc$var$FaceNames);
        var backFace = faces.back;
        var frontFace = faces.front;
        var width = $e519ff1627507adc$var$GetValue(config, "width");
        var height = $e519ff1627507adc$var$GetValue(config, "height");
        if (width === undefined || height === undefined) {
            if (width === undefined) {
                var frontFaceWidth = frontFace ? frontFace.width : 0;
                var backFaceWidth = backFace ? backFace.width : 0;
                width = Math.max(frontFaceWidth, backFaceWidth);
            }
            if (height === undefined) {
                var frontFaceHeight = frontFace ? frontFace.height : 0;
                var backFaceHeight = backFace ? backFace.height : 0;
                height = Math.max(frontFaceHeight, backFaceHeight);
            }
        }
        super(scene, x, y, width, height, faces);
        this.type = "rexPerspectiveCard";
        this.frontFaceRotationX = 0;
        this.frontFaceRotationY = 0;
        this.frontFaceRotationZ = 0;
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(faces, function(face, name) {
            this[`${name}Face`] = face;
        }, this);
        var flipConfig = $e519ff1627507adc$var$GetValue(config, "flip", undefined);
        if (flipConfig !== false) this.flip = new (0, $bd4aedbad60ffa75$export$2e2bcd8739ae039)(this, flipConfig);
        this.setOrientation($e519ff1627507adc$var$GetValue(config, "orientation", 0));
        (0, $05bec6dd25ec056b$export$2e2bcd8739ae039)(this, faces);
        this.setFace($e519ff1627507adc$var$GetValue(config, "face", 0));
    }
    get rotationX() {
        return this.frontFaceRotationX;
    }
    set rotationX(value) {
        if (this.frontFaceRotationX === value) return;
        this.frontFaceRotationX = value;
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.rotationX = value;
        }, null, true);
    }
    get rotationY() {
        return this.frontFaceRotationY;
    }
    set rotationY(value) {
        if (this.frontFaceRotationY === value) return;
        this.frontFaceRotationY = value;
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.rotationY = value;
        }, null, true);
    }
    get rotationZ() {
        return this.frontFaceRotationZ;
    }
    set rotationZ(value) {
        if (this.frontFaceRotationZ === value) return;
        this.frontFaceRotationZ = value;
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face) {
            face.rotationZ = value;
        }, null, true);
    }
    setOrientation(orientation) {
        if (typeof orientation === "string") orientation = $e519ff1627507adc$var$ORIENTATIONMODE[orientation];
        this.orientation = orientation;
        return this;
    }
    get face() {
        return this.currentFaceIndex;
    }
    set face(index) {
        if (typeof index === "string") index = $e519ff1627507adc$var$FACEMODE[index];
        this.currentFaceIndex = index;
        var isBackFace = index === 1;
        var angle = isBackFace ? 180 : 0;
        if (this.orientation === 0) this.angleY = angle;
        else this.angleX = angle;
    }
    setFace(face) {
        this.face = face;
        return this;
    }
    toggleFace() {
        var newFace = this.face === 0 ? 1 : 0;
        this.setFace(newFace);
        return this;
    }
}
const $e519ff1627507adc$var$ORIENTATIONMODE = {
    x: 0,
    horizontal: 0,
    h: 0,
    y: 1,
    vertical: 1,
    v: 1
};
const $e519ff1627507adc$var$FACEMODE = {
    front: 0,
    back: 1
};
var $e519ff1627507adc$export$2e2bcd8739ae039 = $e519ff1627507adc$var$Card;




var $3571af9c97d34523$var$FaceNameToIndex = function(faces, name) {
    for(var i = 0, cnt = faces.length; i < cnt; i++){
        if (face && face.name === name) return i;
    }
    return -1;
};
var $3571af9c97d34523$export$2e2bcd8739ae039 = $3571af9c97d34523$var$FaceNameToIndex;


const $7a8d613749200449$var$GetValue = Phaser.Utils.Objects.GetValue;
const $7a8d613749200449$var$RadToDeg = Phaser.Math.RadToDeg;
const $7a8d613749200449$var$DegToRad = Phaser.Math.DegToRad;
const $7a8d613749200449$var$WrapDegrees = Phaser.Math.Angle.WrapDegrees;
const $7a8d613749200449$var$ShortestBetween = Phaser.Math.Angle.ShortestBetween;
const $7a8d613749200449$var$Wrap = Phaser.Math.Wrap;
const $7a8d613749200449$var$Linear = Phaser.Math.Linear;
class $7a8d613749200449$var$Roll extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setEase($7a8d613749200449$var$GetValue(o, "ease", "Cubic"));
        return this;
    }
    start(deltaRotation) {
        if (this.timer.isRunning) return this;
        this.timer.setDelay(this.delay).setDuration(this.duration);
        var gameObject = this.parent;
        this.startRotationY = gameObject.rotationY;
        this.endRotationY = this.startRotationY + deltaRotation;
        super.start();
        return this;
    }
    to(index, duration) {
        if (this.isRunning) return this;
        var carousel = this.parent;
        if (typeof index === "string") {
            index = (0, $3571af9c97d34523$export$2e2bcd8739ae039)(carousel.faces, index);
            if (index === -1) index = 0;
        }
        index = $7a8d613749200449$var$Wrap(index, 0, carousel.faces.length);
        if (duration !== undefined) this.setDuration(duration);
        var start = $7a8d613749200449$var$WrapDegrees($7a8d613749200449$var$RadToDeg(carousel.rotationY));
        var end = $7a8d613749200449$var$WrapDegrees($7a8d613749200449$var$RadToDeg((carousel.rtl ? 1 : -1) * carousel.faceAngle * index));
        var delta = $7a8d613749200449$var$ShortestBetween(start, end); // Degrees
        this.start($7a8d613749200449$var$DegToRad(delta));
        carousel.currentFaceIndex = index;
        return this;
    }
    toNext(duration) {
        var index = this.parent.currentFaceIndex + 1;
        this.to(index, duration);
        return this;
    }
    toPrevious(duration) {
        var index = this.parent.currentFaceIndex - 1;
        this.to(index, duration);
        return this;
    }
    toRight(duration) {
        if (!this.parent.rtl) this.toNext(duration);
        else this.toPrevious(duration);
        return this;
    }
    toLeft(duration) {
        if (!this.parent.rtl) this.toPrevious(duration);
        else this.toNext(duration);
        return this;
    }
    updateGameObject(gameObject, timer) {
        var t = this.easeFn(timer.t);
        gameObject.rotationY = $7a8d613749200449$var$Linear(this.startRotationY, this.endRotationY, t);
    }
}
var $7a8d613749200449$export$2e2bcd8739ae039 = $7a8d613749200449$var$Roll;




var $7a3e8c6e3343e996$var$GetFirstFace = function(faces) {
    var face;
    for(var i = 0, cnt = faces.length; i < cnt; i++){
        face = faces[i];
        if (face) break;
    }
    return face;
};
var $7a3e8c6e3343e996$export$2e2bcd8739ae039 = $7a3e8c6e3343e996$var$GetFirstFace;



var $e99038552e890af6$var$LayoutFaces = function(parent, faces) {
    if (parent.faceWidth === 0) return;
    var radius = parent.faceRadius;
    (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(faces, function(face) {
        var transferZ = radius / face.height;
        face.transformVerts(0, 0, transferZ).panZ(transferZ);
    }, null, true);
};
var $e99038552e890af6$export$2e2bcd8739ae039 = $e99038552e890af6$var$LayoutFaces;



const $f7c1d2ff79ac5edc$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $f7c1d2ff79ac5edc$var$GetValue = Phaser.Utils.Objects.GetValue;
const $f7c1d2ff79ac5edc$var$DegToRad = Phaser.Math.DegToRad;
const $f7c1d2ff79ac5edc$var$RadToDeg = Phaser.Math.RadToDeg;
const $f7c1d2ff79ac5edc$var$WrapDegrees = Phaser.Math.Angle.WrapDegrees;
const $f7c1d2ff79ac5edc$var$Linear = Phaser.Math.Linear;
const $f7c1d2ff79ac5edc$var$Wrap = Phaser.Math.Wrap;
class $f7c1d2ff79ac5edc$var$Carousel extends (0, $2bfda3f951c8cd4c$export$2e2bcd8739ae039) {
    constructor(scene, x, y, config){
        if ($f7c1d2ff79ac5edc$var$IsPlainObject(x)) {
            config = x;
            x = $f7c1d2ff79ac5edc$var$GetValue(config, "x", 0);
            y = $f7c1d2ff79ac5edc$var$GetValue(config, "y", 0);
        }
        var faceConfig = $f7c1d2ff79ac5edc$var$GetValue(config, "faces", undefined);
        if (!faceConfig) faceConfig = [];
        var faces = (0, $004aadb34e4aa1f9$export$2e2bcd8739ae039)(scene, faceConfig);
        var firstFace = (0, $7a3e8c6e3343e996$export$2e2bcd8739ae039)(faces);
        var width = $f7c1d2ff79ac5edc$var$GetValue(config, "width");
        var height = $f7c1d2ff79ac5edc$var$GetValue(config, "height");
        if (width === undefined) width = firstFace ? firstFace.width : 0;
        if (height === undefined) height = firstFace ? firstFace.height : 0;
        super(scene, x, y, width, height, faces);
        this.type = "rexPerspectiveCarousel";
        this.face0RotationY = undefined;
        var faceCount = faces.length;
        // Face angle
        this.faceAngle = faceCount > 0 ? $f7c1d2ff79ac5edc$var$DegToRad(360 / faces.length) : 0;
        // Face width, face radius
        var faceWidth = $f7c1d2ff79ac5edc$var$GetValue(config, "faceWidth", undefined);
        if (faceWidth === undefined) {
            var faceSpace = $f7c1d2ff79ac5edc$var$GetValue(config, "faceSpace", 0);
            faceWidth = firstFace ? firstFace.width + faceSpace : 0;
        }
        this.faceWidth = faceWidth;
        if (faceCount > 2) this.faceRadius = faceWidth / 2 / Math.tan(this.faceAngle / 2);
        else this.faceRadius = faceWidth / 2;
        (0, $e99038552e890af6$export$2e2bcd8739ae039)(this, faces);
        var rollConfig = $f7c1d2ff79ac5edc$var$GetValue(config, "roll", undefined);
        if (rollConfig !== false) {
            var RollClass = $f7c1d2ff79ac5edc$var$GetValue(config, "rollClass", (0, $7a8d613749200449$export$2e2bcd8739ae039));
            this.roll = new RollClass(this, rollConfig);
        }
        // Left-To-Right, or Right-To-Left
        this.rtl = $f7c1d2ff79ac5edc$var$GetValue(config, "rtl", false);
        // z-index
        this.zStart = $f7c1d2ff79ac5edc$var$GetValue(config, "z", 1);
        this.zEnd = $f7c1d2ff79ac5edc$var$GetValue(config, "zEnd", this.zStart - 1);
        this.setFace($f7c1d2ff79ac5edc$var$GetValue(config, "face", 0));
    }
    get rotationY() {
        return this.face0RotationY;
    }
    set rotationY(value) {
        if (this.face0RotationY === value) return;
        this.face0RotationY = value;
        var deltaAngle = this.faceAngle;
        var zStart = this.zStart;
        var zEnd = this.zEnd;
        var sign = this.rtl ? -1 : 1;
        (0, $dfd6b9e1b12c66d3$export$2e2bcd8739ae039)(this.faces, function(face, i) {
            // Set rotationY
            var rotationY = value + sign * deltaAngle * i;
            face.rotationY = rotationY;
            // Set depth
            var angle = Math.abs($f7c1d2ff79ac5edc$var$WrapDegrees($f7c1d2ff79ac5edc$var$RadToDeg(rotationY))); // 0~180
            var z = $f7c1d2ff79ac5edc$var$Linear(zStart, zEnd, angle / 180);
            face.setDepth(z);
        }, null, true);
    }
    get face() {
        return this.currentFaceIndex;
    }
    set face(index) {
        if (typeof index === "string") {
            index = (0, $3571af9c97d34523$export$2e2bcd8739ae039)(this.faces, index);
            if (index === -1) index = 0;
        }
        index = $f7c1d2ff79ac5edc$var$Wrap(index, 0, this.faces.length);
        this.currentFaceIndex = index;
        this.rotationY = (this.rtl ? 1 : -1) * this.faceAngle * index;
    }
    setFace(index) {
        this.face = index;
        return this;
    }
}
var $f7c1d2ff79ac5edc$export$2e2bcd8739ae039 = $f7c1d2ff79ac5edc$var$Carousel;




class $fc60e68bdcf997ce$var$Roll extends (0, $7a8d613749200449$export$2e2bcd8739ae039) {
    toNext(duration) {
        var gameObject = this.parent;
        if (!gameObject.repeat && gameObject.isLastImage) return this;
        if (this.isRunning) return this;
        gameObject.setImageIndex(gameObject.currentImageIndex + 1);
        super.toNext(duration).once("complete", gameObject.updateTexture, gameObject);
        return this;
    }
    toPrevious(duration) {
        var gameObject = this.parent;
        if (!gameObject.repeat && gameObject.isFirstImage) return this;
        if (this.isRunning) return this;
        gameObject.setImageIndex(gameObject.currentImageIndex - 1);
        super.toPrevious(duration).once("complete", gameObject.updateTexture, gameObject);
        return this;
    }
}
var $fc60e68bdcf997ce$export$2e2bcd8739ae039 = $fc60e68bdcf997ce$var$Roll;



var $64bdfd043a8814b6$var$GetFaceSize = function(scene, images) {
    if (!images) return null;
    if (Array.isArray(images)) {
        var textureKey = images[0];
        var frame = scene.sys.textures.getFrame(textureKey.key, textureKey.frame);
        $64bdfd043a8814b6$var$result.width = frame.cutWidth;
        $64bdfd043a8814b6$var$result.height = frame.cutHeight;
    } else {
        $64bdfd043a8814b6$var$result.width = images.width;
        $64bdfd043a8814b6$var$result.height = images.height;
    }
    return $64bdfd043a8814b6$var$result;
};
var $64bdfd043a8814b6$var$result = {};
var $64bdfd043a8814b6$export$2e2bcd8739ae039 = $64bdfd043a8814b6$var$GetFaceSize;


var $91c26fb2323db81c$var$GetIndexOffsetMap = function(faceCount) {
    var indexOffsetMap = [
        0
    ];
    for(var i = 1, cnt = Math.floor((faceCount - 1) / 2); i <= cnt; i++){
        indexOffsetMap.push(i);
        indexOffsetMap.push(-i);
    }
    return indexOffsetMap;
};
var $91c26fb2323db81c$export$2e2bcd8739ae039 = $91c26fb2323db81c$var$GetIndexOffsetMap;


const $52256f7c0a987619$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $52256f7c0a987619$var$GetValue = Phaser.Utils.Objects.GetValue;
const $52256f7c0a987619$var$Wrap = Phaser.Math.Wrap;
class $52256f7c0a987619$var$ImageCarousel extends (0, $f7c1d2ff79ac5edc$export$2e2bcd8739ae039) {
    constructor(scene, x, y, config){
        if ($52256f7c0a987619$var$IsPlainObject(x)) {
            config = x;
            x = $52256f7c0a987619$var$GetValue(config, "x", 0);
            y = $52256f7c0a987619$var$GetValue(config, "y", 0);
        }
        if (config === undefined) config = {};
        var faceWidth, faceHeight;
        var images = $52256f7c0a987619$var$GetValue(config, "images");
        var faceSize = (0, $64bdfd043a8814b6$export$2e2bcd8739ae039)(scene, images);
        if (faceSize) {
            faceWidth = faceSize.width;
            faceHeight = faceSize.height;
        } else {
            faceWidth = $52256f7c0a987619$var$GetValue(config, "width");
            faceHeight = $52256f7c0a987619$var$GetValue(config, "height");
        }
        // Create 4 render-texture faces
        var faceCount = $52256f7c0a987619$var$GetValue(config, "faceCount", 4);
        var face, faces = [];
        for(var i = 0; i < faceCount; i++){
            face = new (0, $1ee2acf186d8581a$export$2e2bcd8739ae039)(scene, 0, 0, faceWidth, faceHeight, config);
            scene.add.existing(face);
            faces.push(face);
        }
        config.faces = faces;
        config.rollClass = (0, $fc60e68bdcf997ce$export$2e2bcd8739ae039);
        super(scene, x, y, config);
        this.type = "rexPerspectiveImageCarousel";
        this.images = images;
        this.indexOffsetMap = (0, $91c26fb2323db81c$export$2e2bcd8739ae039)(faceCount);
        this.repeat = $52256f7c0a987619$var$GetValue(config, "repeat", true);
        this.setImageIndex($52256f7c0a987619$var$GetValue(config, "index", 0)).updateTexture();
    }
    setImageIndex(index) {
        this.currentImageIndex = $52256f7c0a987619$var$Wrap(index, 0, this.images.length);
        return this;
    }
    get isFirstImage() {
        return this.images.length === 0 || this.currentImageIndex === 0;
    }
    get isLastImage() {
        return this.images.length === 0 || this.currentImageIndex === this.images.length - 1;
    }
    updateTexture() {
        var totalKeys = this.images.length;
        var totalFaces = this.faces.length;
        this.indexOffsetMap.forEach(function(indexOffset) {
            var textureIndex = $52256f7c0a987619$var$Wrap(this.currentImageIndex + indexOffset, 0, totalKeys);
            var faceIndex = $52256f7c0a987619$var$Wrap(this.currentFaceIndex + indexOffset, 0, totalFaces);
            var textureKey = this.images[textureIndex];
            this.faces[faceIndex].rt.drawFrame(textureKey.key, textureKey.frame);
        }, this);
        return this;
    }
}
var $52256f7c0a987619$export$2e2bcd8739ae039 = $52256f7c0a987619$var$ImageCarousel;


const $41f5d64c4233e153$var$GetValue = Phaser.Utils.Objects.GetValue;
var $41f5d64c4233e153$var$Init = function(parentContainer, rtOwner, config) {
    rtOwner.visibleSibling = [];
    rtOwner.isRunning = false;
    rtOwner.useParentBounds = $41f5d64c4233e153$var$GetValue(config, "useParentBounds", false);
    rtOwner.setPosition(parentContainer.x, parentContainer.y).setVisible(false);
    parentContainer.pin(rtOwner);
};
var $41f5d64c4233e153$export$2e2bcd8739ae039 = $41f5d64c4233e153$var$Init;


var $b93069309c29e4f2$var$Exit = function(parentContainer, rtOwner) {
    if (!parentContainer) return false;
    var visibleSibling = rtOwner.visibleSibling;
    // Set all visible children back
    for(var i = 0, cnt = visibleSibling.length; i < cnt; i++)parentContainer.setChildVisible(visibleSibling[i], true);
    visibleSibling.length = 0;
    // Set rtOwner to be invisible
    parentContainer.setChildVisible(rtOwner, false);
    rtOwner.isRunning = false;
    return true;
};
var $b93069309c29e4f2$export$2e2bcd8739ae039 = $b93069309c29e4f2$var$Exit;



var $4e3f6c00804a7e5c$var$Enter = function(parentContainer, rtOwner) {
    if (!parentContainer) return false;
    (0, $b93069309c29e4f2$export$2e2bcd8739ae039)(parentContainer, rtOwner);
    // Get and paste all visible children, which dose not include this render texture
    var useParentBounds = rtOwner.useParentBounds;
    (0, $77b8570de39b9238$export$2e2bcd8739ae039)({
        gameObjects: parentContainer.getAllVisibleChildren(),
        renderTexture: rtOwner.rt,
        x: rtOwner.x,
        y: rtOwner.y,
        width: useParentBounds ? parentContainer.displayWidth : undefined,
        height: useParentBounds ? parentContainer.displayHeighth : undefined,
        originX: useParentBounds ? parentContainer.originX : undefined,
        originY: useParentBounds ? parentContainer.originY : undefined
    });
    // Set rtOwner to be visible
    parentContainer.setChildVisible(rtOwner, true);
    // Set visible sibling to be invisible
    var visibleSibling = rtOwner.visibleSibling;
    var children = parentContainer.children;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.visible && child !== rtOwner) {
            parentContainer.setChildVisible(child, false);
            visibleSibling.push(child);
        }
    }
    rtOwner.isRunning = true;
    return true;
};
var $4e3f6c00804a7e5c$export$2e2bcd8739ae039 = $4e3f6c00804a7e5c$var$Enter;



var $a804e9f9da8a6b4c$var$MeshRenderTextureBase = function(RenderTextureOwnerClass) {
    return class Base extends RenderTextureOwnerClass {
        constructor(parentContainer, config){
            var scene = parentContainer.scene;
            super(scene, 0, 0, 1, 1, config);
            scene.add.existing(this);
            (0, $41f5d64c4233e153$export$2e2bcd8739ae039)(parentContainer, this, config);
        }
        destroy(fromScene) {
            if (!this.scene) return;
            this.exit();
            super.destroy(fromScene);
        }
        enter() {
            var result = (0, $4e3f6c00804a7e5c$export$2e2bcd8739ae039)(this.rexContainer.parent, this);
            if (result) this.syncSize();
            return this;
        }
        exit() {
            (0, $b93069309c29e4f2$export$2e2bcd8739ae039)(this.rexContainer.parent, this);
            return this;
        }
    };
};
var $a804e9f9da8a6b4c$export$2e2bcd8739ae039 = $a804e9f9da8a6b4c$var$MeshRenderTextureBase;



class $7ff63fc496eb7b81$var$ContainerPerspective extends (0, $a804e9f9da8a6b4c$export$2e2bcd8739ae039)((0, $1ee2acf186d8581a$export$2e2bcd8739ae039)) {
    get perspectiveState() {
        return this.isRunning;
    }
}
var $7ff63fc496eb7b81$export$2e2bcd8739ae039 = $7ff63fc496eb7b81$var$ContainerPerspective;





const $87a7a2880846dc0d$var$GetValue = Phaser.Utils.Objects.GetValue;
var $87a7a2880846dc0d$var$CreatePerspectiveCardMesh = function(config) {
    var scene = this.scene;
    this.setSnapshotPadding($87a7a2880846dc0d$var$GetValue(config, "snapshotPadding", 0));
    config = (0, $1aafd1214cd046a0$export$2e2bcd8739ae039)(config);
    // Remove size config
    delete config.width;
    delete config.height;
    // Initial size of render-texture is 1x1
    config.front = {
        width: 1,
        height: 1
    };
    config.back = {
        width: 1,
        height: 1
    };
    // Create PerspectiveCard as card-behavior
    var card = new (0, $e519ff1627507adc$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(card);
    var flip = card.flip;
    if (flip) {
        var parent = this;
        flip.on("start", function() {
            // Before flipping
            parent.enterPerspectiveMode();
        }).on("complete", function() {
            // After flipping
            parent.exitPerspectiveMode();
        });
    }
    return card;
};
var $87a7a2880846dc0d$export$2e2bcd8739ae039 = $87a7a2880846dc0d$var$CreatePerspectiveCardMesh;


const $4367ed56441900da$var$FaceIndexMap = [
    "front",
    "back"
];
var $4367ed56441900da$export$2e2bcd8739ae039 = {
    enterPerspectiveMode () {
        if (this.isInPerspectiveMode) return this;
        // Set card's visible to true
        this.setChildVisible(this.perspectiveCard, true);
        // Snapshot front and back children to card's faces
        this.snapshotFace(0);
        this.snapshotFace(1);
        // Set front and back children's visible to false
        this.setChildVisible(this.childrenMap.front, false);
        this.setChildVisible(this.childrenMap.back, false);
        // Reset size of card
        this.perspectiveCard.setSize(this.width, this.height);
        return this;
    },
    exitPerspectiveMode () {
        if (!this.isInPerspectiveMode) return this;
        // Set card's visible to false
        this.setChildVisible(this.perspectiveCard, false);
        // Set front or back children's visible to true, according to card's face
        var isFrontFace = this.perspectiveCard.face === 0;
        this.setChildVisible(this.childrenMap.front, isFrontFace);
        this.setChildVisible(this.childrenMap.back, !isFrontFace);
        return this;
    },
    setSnapshotPadding (padding) {
        this.snapshotPadding = padding;
        return this;
    },
    snapshotFace (face) {
        if (typeof face === "number") face = $4367ed56441900da$var$FaceIndexMap[face];
        var cardFace = this.perspectiveCard.faces[face];
        var faceChild = this.childrenMap[face];
        cardFace.rt.clear();
        var faceChildVisibleSave = faceChild.visible;
        faceChild.visible = true;
        var gameObjects = faceChild.isRexContainerLite ? faceChild.getAllVisibleChildren() : faceChild;
        cardFace.snapshot(gameObjects, {
            padding: this.snapshotPadding
        });
        faceChild.visible = faceChildVisibleSave;
        return this;
    }
};


const $6174f5e793805620$var$GetValue = Phaser.Utils.Objects.GetValue;
class $6174f5e793805620$var$PerspectiveCard extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexPerspectiveCard";
        // Layout faces
        var backFace = config.back;
        var backFaceExpand = $6174f5e793805620$var$GetValue(config, "expand.back", true);
        this.add(backFace, {
            key: "back",
            expand: backFaceExpand
        });
        var frontFace = config.front;
        var frontFaceExpand = $6174f5e793805620$var$GetValue(config, "expand.front", true);
        this.add(frontFace, {
            key: "front",
            expand: frontFaceExpand
        });
        // Add PerspectiveCardMesh
        this.perspectiveCard = (0, $87a7a2880846dc0d$export$2e2bcd8739ae039).call(this, config);
        this.pin(this.perspectiveCard);
        this.exitPerspectiveMode(false);
    }
    get flip() {
        return this.perspectiveCard.flip;
    }
    get face() {
        return this.perspectiveCard.face;
    }
    set face(index) {
        // Can't set face during flipping
        if (this.flip && this.flip.isRunning) return;
        this.perspectiveCard.face = index;
        var isFrontFace = index === 0;
        var frontFace = this.childrenMap.front;
        var backFace = this.childrenMap.back;
        this.setChildVisible(frontFace, isFrontFace);
        this.setChildVisible(backFace, !isFrontFace);
    }
    setFace(face) {
        this.face = face;
        return this;
    }
    toggleFace() {
        var newFace = this.face === 0 ? 1 : 0;
        this.setFace(newFace);
        return this;
    }
    get isInPerspectiveMode() {
        return this.perspectiveCard.visible;
    }
    get rotationX() {
        return this.perspectiveCard.rotationX;
    }
    set rotationX(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.rotationX = value;
    }
    get angleX() {
        return this.perspectiveCard.angleX;
    }
    set angleX(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.angleX = value;
    }
    get rotationY() {
        return this.perspectiveCard.rotationY;
    }
    set rotationY(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.rotationY = value;
    }
    get angleY() {
        return this.perspectiveCard.angleY;
    }
    set angleY(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.angleY = value;
    }
    get rotationZ() {
        return this.perspectiveCard.rotationZ;
    }
    set rotationZ(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.rotationZ = value;
    }
    get angleZ() {
        return this.perspectiveCard.angleZ;
    }
    set angleZ(value) {
        this.enterPerspectiveMode();
        this.perspectiveCard.angleZ = value;
    }
    panX(v) {
        this.enterPerspectiveMode();
        this.perspectiveCard.panX(v);
        return this;
    }
    panY(v) {
        this.enterPerspectiveMode();
        this.perspectiveCard.panY(v);
        return this;
    }
    panZ(v) {
        this.enterPerspectiveMode();
        this.perspectiveCard.panZ(v);
        return this;
    }
    transformVerts(x, y, z, rotateX, rotateY, rotateZ) {
        this.enterPerspectiveMode();
        this.perspectiveCard.transformVerts(x, y, z, rotateX, rotateY, rotateZ);
        return this;
    }
    forEachFace(callback, scope, ignoreInvalid) {
        this.enterPerspectiveMode();
        this.perspectiveCard.forEachFace(callback, scope, ignoreInvalid);
        return this;
    }
}
Object.assign($6174f5e793805620$var$PerspectiveCard.prototype, (0, $4367ed56441900da$export$2e2bcd8739ae039));
var $6174f5e793805620$export$2e2bcd8739ae039 = $6174f5e793805620$var$PerspectiveCard;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("perspectiveCard", function(config) {
    var gameObject = new (0, $6174f5e793805620$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.PerspectiveCard", (0, $6174f5e793805620$export$2e2bcd8739ae039));
var $985288fc611e7f4a$export$2e2bcd8739ae039 = (0, $6174f5e793805620$export$2e2bcd8739ae039);






var $84f1bddd35408b91$var$GetPageKeyByIndex = function(index) {
    var buttons = this.getElement("tabs.buttons");
    if (index >= buttons.length) return undefined;
    return buttons[index].name;
};
var $84f1bddd35408b91$export$2e2bcd8739ae039 = $84f1bddd35408b91$var$GetPageKeyByIndex;


var $f49ffcbc716eb19c$var$GetPageIndexByKey = function(key) {
    var buttons = this.getElement("tabs.buttons");
    for(var i = 0, cnt = buttons.length; i < cnt; i++){
        if (buttons[i].name === key) return i;
    }
    return undefined;
};
var $f49ffcbc716eb19c$export$2e2bcd8739ae039 = $f49ffcbc716eb19c$var$GetPageIndexByKey;


const $cb7ee5b0e4b24b52$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $cb7ee5b0e4b24b52$var$GetValue = Phaser.Utils.Objects.GetValue;
const $cb7ee5b0e4b24b52$var$UUID = Phaser.Utils.String.UUID;
var $cb7ee5b0e4b24b52$var$AddPage = function(key, tabGameObject, pageGameObject) {
    if ($cb7ee5b0e4b24b52$var$IsPlainObject(key)) {
        var config = key;
        key = $cb7ee5b0e4b24b52$var$GetValue(config, "key");
        tabGameObject = $cb7ee5b0e4b24b52$var$GetValue(config, "tab");
        pageGameObject = $cb7ee5b0e4b24b52$var$GetValue(config, "page");
    }
    if (!key) key = $cb7ee5b0e4b24b52$var$UUID();
    tabGameObject.name = key; // For ratio buttons
    this.childrenMap.tabs.addButton(tabGameObject);
    this.childrenMap.pages.addPage(pageGameObject, {
        key: key
    });
    return this;
};
var $cb7ee5b0e4b24b52$export$2e2bcd8739ae039 = $cb7ee5b0e4b24b52$var$AddPage;


var $2249909d21eeead1$var$SwapPage = function(key, fadeInDuration) {
    var index;
    if (typeof key === "number") index = key;
    else index = this.getPageIndex(key);
    if (index != null) {
        // Override fadeInDuration
        var fadeInDurationSave;
        if (fadeInDuration !== undefined) {
            fadeInDurationSave = this.childrenMap.pages.fadeInDuration;
            this.childrenMap.pages.fadeInDuration = fadeInDuration;
        }
        this.childrenMap.tabs.emitButtonClick(index);
        // Restore fadeInDuration
        if (fadeInDurationSave !== undefined) this.childrenMap.pages.fadeInDuration = fadeInDurationSave;
    }
    return this;
};
var $2249909d21eeead1$var$SwapFirstPage = function(fadeInDuration) {
    this.swapPage(0, fadeInDuration);
    return this;
};
var $2249909d21eeead1$var$SwapLastPage = function(fadeInDuration) {
    var index = this.getElement("tabs.buttons").length - 1;
    this.swapPage(index, fadeInDuration);
    return this;
};
var $2249909d21eeead1$export$2e2bcd8739ae039 = {
    swapPage: $2249909d21eeead1$var$SwapPage,
    swapFirstPage: $2249909d21eeead1$var$SwapFirstPage,
    swapLastPage: $2249909d21eeead1$var$SwapLastPage
};


var $1449c1ae77ccd507$var$RemovePage = function(key, destroyChild) {
    if (typeof key === "number") key = this.getPageKey(key);
    var tabs = this.childrenMap.tabs;
    var tabGameObject = tabs.getByName(key);
    var pages = this.childrenMap.pages;
    var pageGameObject = pages.getElement(key);
    if (!tabGameObject || !pageGameObject) return this;
    pages.removeChildrenMap(key);
    tabs.removeButton(tabGameObject, destroyChild);
    pages.remove(pageGameObject, destroyChild);
    return this;
};
var $1449c1ae77ccd507$export$2e2bcd8739ae039 = {
    removePage: $1449c1ae77ccd507$var$RemovePage
};


var $a039c821e1fc5d5d$var$GetPage = function(key) {
    if (typeof key === "number") key = this.getPageKey(key);
    return this.childrenMap.pages.getPage(key);
};
var $a039c821e1fc5d5d$export$2e2bcd8739ae039 = $a039c821e1fc5d5d$var$GetPage;


var $d564dd368ce9e327$var$GetTab = function(key) {
    var index;
    if (typeof key === "number") index = key;
    else index = this.getPageIndex(key);
    return this.getElement("tabs.buttons")[index];
};
var $d564dd368ce9e327$export$2e2bcd8739ae039 = $d564dd368ce9e327$var$GetTab;


var $36f822b1b1e3a4b0$var$methods = {
    getPageKey: (0, $84f1bddd35408b91$export$2e2bcd8739ae039),
    getPageIndex: (0, $f49ffcbc716eb19c$export$2e2bcd8739ae039),
    addPage: (0, $cb7ee5b0e4b24b52$export$2e2bcd8739ae039),
    getPage: (0, $a039c821e1fc5d5d$export$2e2bcd8739ae039),
    getTab: (0, $d564dd368ce9e327$export$2e2bcd8739ae039)
};
Object.assign($36f822b1b1e3a4b0$var$methods, (0, $2249909d21eeead1$export$2e2bcd8739ae039), (0, $1449c1ae77ccd507$export$2e2bcd8739ae039));
var $36f822b1b1e3a4b0$export$2e2bcd8739ae039 = $36f822b1b1e3a4b0$var$methods;


const $1d165303128e7db5$var$GetValue = Phaser.Utils.Objects.GetValue;
const $1d165303128e7db5$var$SizerAdd = (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039).prototype.add;
class $1d165303128e7db5$var$TabPages extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        var tabsPosition = $1d165303128e7db5$var$GetValue(config, "tabPosition", "top");
        var sizerOrientation = tabsPosition === "left" || tabsPosition === "right" ? "x" : "y";
        config.orientation = sizerOrientation;
        super(scene, config);
        this.type = "rexTabPages";
        // Add elements
        var background = $1d165303128e7db5$var$GetValue(config, "background", undefined);
        if (background) this.addBackground(background);
        var pagesConfig = $1d165303128e7db5$var$GetValue(config, "pages");
        var pages = new (0, $27d0a6de10246f93$export$2e2bcd8739ae039)(scene, pagesConfig);
        scene.add.existing(pages);
        var isHorizontalTabs = sizerOrientation === "y";
        var wrapTabs = isHorizontalTabs ? $1d165303128e7db5$var$GetValue(config, "wrapTabs", false) : false;
        var tabsConfig = $1d165303128e7db5$var$GetValue(config, "tabs", undefined);
        if (tabsConfig === undefined) tabsConfig = {};
        var ButtonsClass = wrapTabs ? (0, $1418690eca2b4065$export$2e2bcd8739ae039) : (0, $e713f60692044763$export$2e2bcd8739ae039);
        tabsConfig.orientation = isHorizontalTabs ? "x" : "y";
        tabsConfig.buttonsType = "radio";
        var tabs = new ButtonsClass(scene, tabsConfig);
        scene.add.existing(tabs);
        var tabsExpand = wrapTabs ? true : $1d165303128e7db5$var$GetValue(config, "expand.tabs", false);
        var tabAlign = $1d165303128e7db5$var$GetValue(config, "align.tabs", "left");
        switch(tabsPosition){
            case "top":
            case "left":
                $1d165303128e7db5$var$SizerAdd.call(this, tabs, {
                    proportion: 0,
                    expand: tabsExpand,
                    align: tabAlign
                });
                $1d165303128e7db5$var$SizerAdd.call(this, pages, {
                    proportion: 1,
                    expand: true
                });
                break;
            case "bottom":
            case "right":
                $1d165303128e7db5$var$SizerAdd.call(this, pages, {
                    proportion: 1,
                    expand: true
                });
                $1d165303128e7db5$var$SizerAdd.call(this, tabs, {
                    proportion: 0,
                    expand: tabsExpand,
                    align: tabAlign
                });
                break;
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("tabs", tabs);
        this.addChildrenMap("pages", pages);
        // Register events
        tabs.on("button.click", function(tab) {
            var key = tab.name;
            if (pages.hasPage(key)) pages.swapPage(key);
        });
        tabs.on("button.statechange", function(tab, index, value, previousValue) {
            var eventName = value ? "tab.focus" : "tab.blur";
            this.emit(eventName, tab, tab.name);
        }, this);
        pages.on("pagevisible", function(pageObject, key, pages) {
            this.emit("page.focus", pageObject, key);
        });
        pages.on("pageinvisible", function(pageObject, key, pages) {
            this.emit("page.blur", pageObject, key);
        });
    }
    get currentKey() {
        return this.getElement("pages").currentKey;
    }
    set currentKey(key) {
        this.showPage(key);
    }
    get keys() {
        return this.getElement("pages").keys;
    }
    get currentPage() {
        return this.getElement("pages").currentPage;
    }
    get previousPage() {
        return this.getElement("pages").previousPage;
    }
}
Object.assign($1d165303128e7db5$var$TabPages.prototype, (0, $36f822b1b1e3a4b0$export$2e2bcd8739ae039));
var $1d165303128e7db5$export$2e2bcd8739ae039 = $1d165303128e7db5$var$TabPages;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("tabPages", function(config) {
    var gameObject = new (0, $1d165303128e7db5$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TabPages", (0, $1d165303128e7db5$export$2e2bcd8739ae039));
var $8457723bc66cefb4$export$2e2bcd8739ae039 = (0, $1d165303128e7db5$export$2e2bcd8739ae039);




class $c768a8fe102d0069$var$Transition extends (0, $0e96a087d32d6b8e$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        if (config === undefined) config = {};
        config.destroy = false;
        super(gameObject, config);
    }
    onOpen() {
        this.emit("open", this.parent, this);
        super.onOpen();
    }
    onClose() {
        this.emit("close", this.parent, this);
        super.onClose();
    }
}
var $c768a8fe102d0069$export$2e2bcd8739ae039 = $c768a8fe102d0069$var$Transition;


var $411fb292899c19e7$export$2e2bcd8739ae039 = {
    expand (duration) {
        if (this.expanded === true) return this;
        if (duration === undefined) duration = this.transitionDuration;
        this.expanded = true;
        var title = this.childrenMap.title;
        var child = this.childrenMap.child;
        this.show(child);
        var layoutTarget = this.reLayoutTarget ? this.reLayoutTarget : this.getTopmostSizer();
        layoutTarget.layout();
        title.emit("folder.expand", duration, this);
        child.emit("folder.expand", duration, this);
        this.emit("expand.start", this);
        this.childTransition.once("open", function() {
            this.emit("expand.complete", this);
        }, this).requestOpen(null, duration);
        return this;
    },
    collapse (duration) {
        if (this.expanded === false) return this;
        if (duration === undefined) duration = this.transitionDuration;
        this.expanded = false;
        var title = this.childrenMap.title;
        var child = this.childrenMap.child;
        title.emit("folder.collapse", duration, this);
        child.emit("folder.collapse", duration, this);
        this.emit("collapse.start", this);
        this.childTransition.once("close", function() {
            this.setChildScale(child, 1, 1).hide(child);
            var layoutTarget = this.reLayoutTarget ? this.reLayoutTarget : this.getTopmostSizer();
            layoutTarget.layout();
            this.emit("collapse.complete", this);
        }, this).requestClose(null, duration);
        return this;
    },
    toggle (duration) {
        if (this.expanded) this.collapse(duration);
        else this.expand(duration);
        return this;
    }
};




var $2e980e202722cc66$var$DefaultExpandCallback = function(gameObject, duration) {
    (0, $419bbe1decd04038$export$2e2bcd8739ae039).popUp.call(gameObject, duration, this.expandDirection);
};
var $2e980e202722cc66$var$DefaultCollapseCallback = function(gameObject, duration) {
    (0, $419bbe1decd04038$export$2e2bcd8739ae039).scaleDown.call(gameObject, duration, this.expandDirection);
};
var $2e980e202722cc66$export$2e2bcd8739ae039 = {
    setTransitionDuration (duration) {
        this.transitionDuration = duration;
        this.childTransition.setTransitInTime(duration).setTransitOutTime(duration);
        return this;
    },
    setExpandCallback (callback) {
        if (callback === undefined) callback = $2e980e202722cc66$var$DefaultExpandCallback.bind(this);
        this.childTransition.setTransitInCallback(callback);
        return this;
    },
    setCollapseCallback (callback) {
        if (callback === undefined) callback = $2e980e202722cc66$var$DefaultCollapseCallback.bind(this);
        this.childTransition.setTransitOutCallback(callback);
        return this;
    }
};


const $9ce3eacedc63f086$var$GetValue = Phaser.Utils.Objects.GetValue;
class $9ce3eacedc63f086$var$Folder extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        if (!config.hasOwnProperty("orientation")) config.orientation = 1;
        super(scene, config);
        this.type = "rexFolder";
        this.expanded = undefined;
        this.expandDirection = this.orientation === 1 ? "y" : "x";
        var background = config.background;
        var title = config.title;
        var child = config.child;
        // background
        if (background) this.addBackground(background);
        // title
        var defaultAlign = this.orientation === 1 ? "left" : "top";
        var align = $9ce3eacedc63f086$var$GetValue(config, "align.title", defaultAlign);
        var expand = $9ce3eacedc63f086$var$GetValue(config, "expand.title", true);
        this.add(title, {
            proportion: 0,
            align: align,
            expand: expand
        });
        var toggleByTarget = $9ce3eacedc63f086$var$GetValue(config, "toggleByTarget", undefined);
        var toggleClickConfig = $9ce3eacedc63f086$var$GetValue(config, "toggleClickConfig");
        if (toggleByTarget === undefined) toggleByTarget = title;
        if (toggleByTarget) (0, $d714fc8f92a6e32b$export$2e2bcd8739ae039).onClick.call(toggleByTarget, function() {
            this.toggle();
        }, this, toggleClickConfig);
        // child
        this.childTransition = new (0, $c768a8fe102d0069$export$2e2bcd8739ae039)(child);
        var customOrigin = $9ce3eacedc63f086$var$GetValue(config, "customChildOrigin", false);
        if (!customOrigin) {
            var origin = !this.rtl ? 0 : 1;
            child.setOrigin(origin);
        }
        var align = $9ce3eacedc63f086$var$GetValue(config, "align.child", "left");
        var expand = $9ce3eacedc63f086$var$GetValue(config, "expand.child", true);
        var proportion = expand ? 1 : 0;
        this.add(child, {
            proportion: proportion,
            align: align,
            expand: expand
        });
        this.addChildrenMap("title", title);
        this.addChildrenMap("child", child);
        this.addChildrenMap("background", background);
        var transitionConfig = config.transition;
        this.setTransitionDuration($9ce3eacedc63f086$var$GetValue(transitionConfig, "duration", 200));
        this.setExpandCallback($9ce3eacedc63f086$var$GetValue(transitionConfig, "expandCallback", undefined));
        this.setCollapseCallback($9ce3eacedc63f086$var$GetValue(transitionConfig, "collapseCallback", undefined));
        this.reLayoutTarget = $9ce3eacedc63f086$var$GetValue(config, "reLayoutTarget", undefined);
        var onExpandStart = config.onExpandStart;
        if (onExpandStart) this.on("expand.start", onExpandStart);
        var onExpandComplete = config.onExpandComplete;
        if (onExpandComplete) this.on("expand.complete", onExpandComplete);
        var onCollapseStart = config.onCollapseStart;
        if (onCollapseStart) this.on("collapse.start", onCollapseStart);
        var onCollapseComplete = config.onCollapseComplete;
        if (onCollapseComplete) this.on("collapse.complete", onCollapseComplete);
    }
}
Object.assign($9ce3eacedc63f086$var$Folder.prototype, (0, $411fb292899c19e7$export$2e2bcd8739ae039), (0, $2e980e202722cc66$export$2e2bcd8739ae039));
var $9ce3eacedc63f086$export$2e2bcd8739ae039 = $9ce3eacedc63f086$var$Folder;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("folder", function(config) {
    var gameObject = new (0, $9ce3eacedc63f086$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Folder", (0, $9ce3eacedc63f086$export$2e2bcd8739ae039));
var $f4d32f2ce92e0c08$export$2e2bcd8739ae039 = (0, $9ce3eacedc63f086$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textArea", function(config) {
    var gameObject = new (0, $876c0af2debb51b1$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextArea", (0, $876c0af2debb51b1$export$2e2bcd8739ae039));
var $3eb2195201b59a10$export$2e2bcd8739ae039 = (0, $876c0af2debb51b1$export$2e2bcd8739ae039);





var $4bf58ac268eeb69b$var$GetChildrenWidth = function() {
    if (this.rexSizer.hidden) return 0;
    var result;
    var child = this.child, childConfig = child.rexSizer;
    if (childConfig.hidden) result = 0;
    else if (this.scrollMode === 0) result = this.getChildWidth(child);
    else result = 0;
    return result;
};
var $4bf58ac268eeb69b$export$2e2bcd8739ae039 = $4bf58ac268eeb69b$var$GetChildrenWidth;



var $13b95e2d9dd8ad97$var$GetChildrenHeight = function() {
    if (this.rexSizer.hidden) return 0;
    var result;
    var child = this.child, childConfig = child.rexSizer;
    if (childConfig.hidden) result = 0;
    else if (this.scrollMode === 0) result = 0;
    else result = child.isRexSizer ? Math.max(child.minHeight, child.childrenHeight) : child.hasOwnProperty("minHeight") ? child.minHeight : (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
    return result;
};
var $13b95e2d9dd8ad97$export$2e2bcd8739ae039 = $13b95e2d9dd8ad97$var$GetChildrenHeight;


var $1c0673128d9db465$var$GetChildrenSizers = function(out) {
    if (out === undefined) out = [];
    if (this.child && this.child.isRexSizer) out.push(this.child);
    return out;
};
var $1c0673128d9db465$export$2e2bcd8739ae039 = $1c0673128d9db465$var$GetChildrenSizers;


var $df3c701093efcbfc$var$ResetChildPosition = function() {
    var x = this.left;
    var y = this.top;
    if (this.scrollMode === 0) y += this.childOY;
    else x += this.childOY;
    this.child.setPosition(x, y);
    this.resetChildPositionState(this.child);
    this.setMaskChildrenFlag();
};
var $df3c701093efcbfc$export$2e2bcd8739ae039 = $df3c701093efcbfc$var$ResetChildPosition;



var $d1d7a41f7255895f$var$LayoutChildren = function() {
    // LayoutChildren child
    var child = this.child;
    var childWidth, childHeight;
    if (!child.rexSizer.hidden) {
        // Set size
        if (this.scrollMode === 0) childWidth = this.width;
        else childHeight = this.height;
        if (child.isRexSizer) child.runLayout(this, childWidth, childHeight);
        else (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(child, childWidth, childHeight);
        // Update local state
        this.resetChildPosition();
        // Layout children-mask
        this.layoutChildrenMask();
        // Re-mask children
        this.maskChildren();
    }
};
var $d1d7a41f7255895f$export$2e2bcd8739ae039 = $d1d7a41f7255895f$var$LayoutChildren;



var $156d8925b92a9085$var$methods = {
    getChildrenWidth: (0, $4bf58ac268eeb69b$export$2e2bcd8739ae039),
    getChildrenHeight: (0, $13b95e2d9dd8ad97$export$2e2bcd8739ae039),
    getChildrenSizers: (0, $1c0673128d9db465$export$2e2bcd8739ae039),
    resetChildPosition: (0, $df3c701093efcbfc$export$2e2bcd8739ae039),
    layoutChildren: (0, $d1d7a41f7255895f$export$2e2bcd8739ae039)
};
Object.assign($156d8925b92a9085$var$methods, (0, $3a1020a77d4e472b$export$2e2bcd8739ae039));
var $156d8925b92a9085$export$2e2bcd8739ae039 = $156d8925b92a9085$var$methods;





const $6a51452c7aa1d43a$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $6a51452c7aa1d43a$var$GetValue = Phaser.Utils.Objects.GetValue;
const $6a51452c7aa1d43a$var$ALIGN_LEFTTOP = Phaser.Display.Align.TOP_LEFT;
class $6a51452c7aa1d43a$var$ScrollableBlock extends (0, $09c5ef84005dfeb8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, minWidth, minHeight, config){
        if ($6a51452c7aa1d43a$var$IsPlainObject(x)) {
            config = x;
            x = $6a51452c7aa1d43a$var$GetValue(config, "x", 0);
            y = $6a51452c7aa1d43a$var$GetValue(config, "y", 0);
            minWidth = $6a51452c7aa1d43a$var$GetValue(config, "width", undefined);
            minHeight = $6a51452c7aa1d43a$var$GetValue(config, "height", undefined);
        } else if ($6a51452c7aa1d43a$var$IsPlainObject(minWidth)) {
            config = minWidth;
            minWidth = $6a51452c7aa1d43a$var$GetValue(config, "width", undefined);
            minHeight = $6a51452c7aa1d43a$var$GetValue(config, "height", undefined);
        }
        super(scene, x, y, minWidth, minHeight, config);
        this.type = "rexScrollableBlock";
        this.child = undefined;
        this.childrenMask = undefined;
        this._childOY = 0;
        this.execeedTopState = false;
        this.execeedBottomState = false;
        this.setScrollMode($6a51452c7aa1d43a$var$GetValue(config, "scrollMode", true));
        this.setClampMode($6a51452c7aa1d43a$var$GetValue(config, "clamplChildOY", true));
        // Add elements
        // No background object, and child does not have padding
        var child = $6a51452c7aa1d43a$var$GetValue(config, "child", undefined);
        var expand = $6a51452c7aa1d43a$var$GetValue(config, "expand", true);
        if (child.setOrigin) child.setOrigin(0);
        this.add(child);
        this.sizerChildren = [
            child
        ];
        var sizerConfig = this.getSizerConfig(child);
        sizerConfig.align = $6a51452c7aa1d43a$var$ALIGN_LEFTTOP;
        sizerConfig.expand = expand;
        this.child = child;
        // Create mask of child object
        this.setupChildrenMask($6a51452c7aa1d43a$var$GetValue(config, "mask", undefined));
        this.maskGameObject = (0, $d9e0c4993fa99f05$export$2e2bcd8739ae039)(this.childrenMask);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.destroyChildrenMask();
        this.child = undefined;
        super.destroy(fromScene);
    }
    setScrollMode(mode) {
        if (typeof mode === "string") mode = (0, $c4c49e166ab625a6$export$2e2bcd8739ae039)[mode.toLowerCase()];
        this.scrollMode = mode;
        return this;
    }
    setClampMode(mode) {
        if (mode === undefined) mode = true;
        this.clampChildOY = mode;
        return this;
    }
    get instHeight() {
        return this.scrollMode === 0 ? this.height : this.width;
    }
    get instWidth() {
        return this.scrollMode === 0 ? this.width : this.height;
    }
    get childHeight() {
        return this.scrollMode === 0 ? (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this.child) : (0, $3d5f5580139892aa$export$a60660135e2d0135)(this.child);
    }
    get childWidth() {
        return this.scrollMode === 0 ? (0, $3d5f5580139892aa$export$a60660135e2d0135)(this.child) : (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this.child);
    }
    get topChildOY() {
        return 0;
    }
    get bottomChildOY() {
        return -this.visibleHeight;
    }
    get childVisibleHeight() {
        return this.instHeight;
    }
    get visibleHeight() {
        var h = this.childHeight - this.childVisibleHeight;
        if (h < 0) h = 0;
        return h;
    }
    childOYExceedTop(oy) {
        if (oy === undefined) oy = this.childOY;
        return oy > this.topChildOY;
    }
    childOYExeceedBottom(oy) {
        if (oy === undefined) oy = this.childOY;
        return oy < this.bottomChildOY;
    }
    get childOY() {
        return this._childOY;
    }
    set childOY(oy) {
        var topChildOY = this.topChildOY;
        var bottomChildOY = this.bottomChildOY;
        var childOYExceedTop = this.childOYExceedTop(oy);
        var childOYExeceedBottom = this.childOYExeceedBottom(oy);
        if (this.clampChildOY) {
            if (this.childVisibleHeight > this.childHeight) oy = 0;
            else if (childOYExceedTop) oy = topChildOY;
            else if (childOYExeceedBottom) oy = bottomChildOY;
        }
        if (this._childOY !== oy) {
            this._childOY = oy;
            this.resetChildPosition();
        }
        if (childOYExceedTop) {
            if (!this.execeedTopState) this.emit("execeedtop", this, oy, topChildOY);
        }
        this.execeedTopState = childOYExceedTop;
        if (childOYExeceedBottom) {
            if (!this.execeedBottomState) this.emit("execeedbottom", this, oy, bottomChildOY);
        }
        this.execeedBottomState = childOYExeceedBottom;
    }
    setChildOY(oy) {
        this.childOY = oy;
        return this;
    }
    set t(value) {
        this.childOY = -this.visibleHeight * value;
    }
    get t() {
        var visibleHeight = this.visibleHeight;
        if (visibleHeight === 0) return 0;
        return this.childOY / -visibleHeight;
    }
    setChildOYByPercentage(percentage) {
        this.t = percentage;
        return this;
    }
}
Object.assign($6a51452c7aa1d43a$var$ScrollableBlock.prototype, (0, $156d8925b92a9085$export$2e2bcd8739ae039));
var $6a51452c7aa1d43a$export$2e2bcd8739ae039 = $6a51452c7aa1d43a$var$ScrollableBlock;



const $6449a3e76a76d511$var$GetValue = Phaser.Utils.Objects.GetValue;
class $6449a3e76a76d511$var$ScrollablePanel extends (0, $b48de4bdb562f812$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        // Create scrollable-block
        var scrollMode = (0, $391df8fa33f776dd$export$2e2bcd8739ae039)(config);
        var panelConfig = $6449a3e76a76d511$var$GetValue(config, "panel", undefined);
        if (panelConfig === undefined) panelConfig = {};
        panelConfig.scrollMode = scrollMode;
        panelConfig.clamplChildOY = $6449a3e76a76d511$var$GetValue(config, "clamplChildOY", false);
        var scrollableBlock = new (0, $6a51452c7aa1d43a$export$2e2bcd8739ae039)(scene, panelConfig);
        scene.add.existing(scrollableBlock); // Important: Add to display list for touch detecting
        var panelWidth = $6449a3e76a76d511$var$GetValue(panelConfig, "width", undefined);
        var panelHeight = $6449a3e76a76d511$var$GetValue(panelConfig, "height", undefined);
        var proportion, expand;
        if (scrollMode === 0) {
            proportion = panelWidth === undefined ? 1 : 0;
            expand = panelHeight === undefined;
        } else {
            proportion = panelHeight === undefined ? 1 : 0;
            expand = panelWidth === undefined;
        }
        // Fill config of scrollable
        config.type = "rexScrollablePanel";
        config.child = {
            gameObject: scrollableBlock,
            proportion: proportion,
            expand: expand
        };
        var spaceConfig = $6449a3e76a76d511$var$GetValue(config, "space", undefined);
        if (spaceConfig) spaceConfig.child = spaceConfig.panel;
        super(scene, config);
        this.addChildrenMap("panel", scrollableBlock.child);
        this.addChildrenMap("panelLayer", scrollableBlock.maskLayer);
        this.addChildrenMap("mask", scrollableBlock.maskGameObject);
    }
    setChildrenInteractive(config) {
        if (config === undefined) config = {};
        if (!config.hasOwnProperty("eventEmitter")) config.eventEmitter = this;
        if (!config.hasOwnProperty("targets")) config.targets = [
            this.childrenMap.panel
        ];
        (0, $d32ee249a5c7144d$export$2e2bcd8739ae039)(this.childrenMap.child, config);
        return this;
    }
}
var $6449a3e76a76d511$export$2e2bcd8739ae039 = $6449a3e76a76d511$var$ScrollablePanel;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("scrollablePanel", function(config) {
    var gameObject = new (0, $6449a3e76a76d511$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ScrollablePanel", (0, $6449a3e76a76d511$export$2e2bcd8739ae039));
var $e1d5762badf4b728$export$2e2bcd8739ae039 = (0, $6449a3e76a76d511$export$2e2bcd8739ae039);



var $f75ffc4ae1f7b65b$export$2e2bcd8739ae039 = {
    popUp: function(gameObject, duration) {
        gameObject.popUp(duration);
    },
    scaleDown: function(gameObject, duration) {
        gameObject.scaleDown(duration);
    },
    fadeIn: function(gameObject, duration) {
        gameObject.fadeIn(duration);
    },
    fadeOut: function(gameObject, duration) {
        gameObject.fadeOut(duration);
    }
};




var $92fb28cfb604c27b$export$2e2bcd8739ae039 = (0, $3f2ea1a0cae0e7a0$export$2e2bcd8739ae039);







var $c0061b56c3ef3f03$var$RunCommands = function(queue, scope, config) {
    var reverse = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "reverse", false);
    var retVal;
    if ((0, $2d252120406e33cc$export$2e2bcd8739ae039)(queue[0])) {
        if (!reverse) for(var i = 0, len = queue.length; i < len; i++)retVal = $c0061b56c3ef3f03$var$RunCommands(queue[i], scope, config);
        else for(var len = queue.length, i = len - 1; i >= 0; i--)retVal = $c0061b56c3ef3f03$var$RunCommands(queue[i], scope, config);
    } else retVal = $c0061b56c3ef3f03$var$RunCommand(queue, scope, config);
    return retVal;
};
var $c0061b56c3ef3f03$var$RunCommand = function(cmd, scope, config) {
    var argsConvert = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "argsConvert", undefined);
    var argsConvertScope = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(config, "argsConvertScope", undefined);
    var fnName = cmd[0];
    $c0061b56c3ef3f03$var$ARGS = (0, $265c374eaa549425$export$2e2bcd8739ae039)($c0061b56c3ef3f03$var$ARGS, cmd, 1);
    if (argsConvert) {
        // convert string to floating number, boolean, null, or string        
        if (argsConvert === true) {
            argsConvert = (0, $409bc89f18a52545$export$2e2bcd8739ae039);
            argsConvertScope = undefined;
        }
        for(var i = 0, len = $c0061b56c3ef3f03$var$ARGS.length; i < len; i++)if (argsConvertScope) $c0061b56c3ef3f03$var$ARGS[i] = argsConvert.call(argsConvertScope, $c0061b56c3ef3f03$var$ARGS[i], cmd);
        else $c0061b56c3ef3f03$var$ARGS[i] = argsConvert($c0061b56c3ef3f03$var$ARGS[i], cmd);
    }
    var fn;
    if (typeof fnName === "string") {
        fn = scope[fnName];
        if (fn == null) fn = (0, $06ba717ef5182ca0$export$2e2bcd8739ae039)(scope, fnName, null);
    } else fn = fnName;
    var retValue = fn.apply(scope, $c0061b56c3ef3f03$var$ARGS);
    return retValue;
};
var $c0061b56c3ef3f03$var$ARGS = []; // reuse this array
var $c0061b56c3ef3f03$export$2e2bcd8739ae039 = $c0061b56c3ef3f03$var$RunCommands;


var $cc1bd03d8502a42a$export$2e2bcd8739ae039 = (0, $c0061b56c3ef3f03$export$2e2bcd8739ae039);



const $74b2e838cfda53fb$var$GetValue = Phaser.Utils.Objects.GetValue;
class $74b2e838cfda53fb$var$Player extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(parent, config){
        super(parent, config);
        var clock = $74b2e838cfda53fb$var$GetValue(config, "clock", undefined);
        if (!clock) clock = new (0, $92fb28cfb604c27b$export$2e2bcd8739ae039)(parent);
        this.clock = clock;
        this.clock.on("update", this.update, this);
        this.resetFromJSON(config); // this function had been called in super(config)
    }
    resetFromJSON(o) {
        this.clock.resetFromJSON($74b2e838cfda53fb$var$GetValue(o, "clock", undefined));
        this.state = $74b2e838cfda53fb$var$GetValue(o, "state", 0); // 0=idle, 1=run, 2=completed
        this.commands = $74b2e838cfda53fb$var$GetValue(o, "commands", []); // [[time, cmds], [time, cmds], ...]
        this.scope = $74b2e838cfda53fb$var$GetValue(o, "scope", undefined);
        this.setTimeUnit($74b2e838cfda53fb$var$GetValue(o, "timeUnit", 0));
        this.setDtMode($74b2e838cfda53fb$var$GetValue(o, "dtMode", 0));
        this.index = $74b2e838cfda53fb$var$GetValue(o, "index", 0);
        this.nextTime = $74b2e838cfda53fb$var$GetValue(o, "nextTime", 0);
        return this;
    }
    toJSON() {
        return {
            clock: this.clock.toJSON(),
            state: this.state,
            commands: this.commands,
            scope: this.scope,
            timeUnit: this.timeUnit,
            dtMode: this.dtMode,
            index: this.index,
            nextTime: this.nextTime
        };
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.clock.shutdown(fromScene);
        this.commands = undefined;
        super.shutdown(fromScene);
    }
    load(commands, scope, config) {
        this.stop();
        var timeUnit = $74b2e838cfda53fb$var$GetValue(config, "timeUnit", undefined);
        if (timeUnit !== undefined) this.setTimeUnit(timeUnit);
        var dtMode = $74b2e838cfda53fb$var$GetValue(config, "dtMode", undefined);
        if (dtMode !== undefined) this.setDtMode(dtMode);
        commands = commands.filter(function(item) {
            var dt = item[0];
            return !isNaN(dt);
        }).map(function(item) {
            var dt = item[0];
            if (typeof dt === "string") item[0] = parseFloat(item[0]);
            return item;
        });
        if (this.dtMode === 0) commands.sort(function(itemA, itemB) {
            var dtA = itemA[0], dtB = itemB[0];
            return dtA > dtB ? 1 : dtA < dtB ? -1 : 0;
        });
        this.commands = commands;
        this.scope = scope;
        return this;
    }
    start(startAt) {
        if (startAt === undefined) startAt = 0;
        this.stop();
        this.index = 0;
        this.state = 1;
        this.nextTime = this.getNextDt(0);
        this.clock.start(startAt);
        this.update(startAt);
        this.emit("start", this.parent, this);
        return this;
    }
    pause() {
        this.clock.pause();
        this.emit("pause", this.parent, this);
        return this;
    }
    resume() {
        this.clock.resume();
        this.emit("resume", this.parent, this);
        return this;
    }
    stop() {
        this.clock.stop();
        this.state = 0;
        this.emit("stop", this.parent, this);
        return this;
    }
    seek(time) {
        this.clock.seek(time);
        return this;
    }
    seekToNext() {
        this.seek(this.nextTime);
        return this;
    }
    get isPlaying() {
        return this.clock.isRunning;
    }
    get completed() {
        return this.state === 2;
    }
    get timeScale() {
        return this.clock.timeScale;
    }
    set timeScale(timeScale) {
        this.clock.timeScale = timeScale;
    }
    setTimeScale(timeScale) {
        this.timeScale = timeScale;
        return this;
    }
    get now() {
        return this.clock.now;
    }
    update(now) {
        if (this.nextTime > now) return this;
        var lastCommandIndex = this.commands.length - 1;
        while(true){
            // Execute a command
            var item = this.commands[this.index];
            var command = item[1];
            if (!(0, $2d252120406e33cc$export$2e2bcd8739ae039)(command)) command = (0, $265c374eaa549425$export$2e2bcd8739ae039)($74b2e838cfda53fb$var$CMD, item, 1);
            (0, $cc1bd03d8502a42a$export$2e2bcd8739ae039)(command, this.scope);
            this.emit("runcommand", command, this.scope);
            // Execute a command
            if (this.index === lastCommandIndex) {
                this.complete();
                return this;
            } else {
                // Get next time
                this.index++; // Point to next command
                this.nextTime = this.getNextDt(this.nextTime);
                if (this.nextTime > now) return this;
            // Get next time
            }
        }
    }
    complete() {
        this.clock.stop();
        this.state = 2;
        this.emit("complete", this.parent, this);
    }
    getNextDt(currentDt) {
        var time = this.commands[this.index][0];
        if (this.timeUnit === 1) time = time * 1000;
        if (this.dtMode === 1) time += currentDt;
        return time;
    }
    setDtMode(dtMode) {
        if (typeof dtMode === "string") dtMode = $74b2e838cfda53fb$var$DTMODE[dtMode];
        this.dtMode = dtMode;
        return this;
    }
    setTimeUnit(timeUnit) {
        if (typeof timeUnit === "string") timeUnit = $74b2e838cfda53fb$var$TIMEUNITMODE[timeUnit];
        this.timeUnit = timeUnit;
        return this;
    }
}
var $74b2e838cfda53fb$var$CMD = []; // reuse this array
const $74b2e838cfda53fb$var$TIMEUNITMODE = {
    ms: 0,
    s: 1,
    sec: 1
};
const $74b2e838cfda53fb$var$DTMODE = {
    abs: 0,
    absolute: 0,
    inc: 1,
    increment: 1
};
var $74b2e838cfda53fb$export$2e2bcd8739ae039 = $74b2e838cfda53fb$var$Player;



const $41a74c2cba0e0e57$var$GetValue = Phaser.Utils.Objects.GetValue;
class $41a74c2cba0e0e57$var$Toast extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {
            text: createDefaultTextObject(scene)
        };
        super(scene, config);
        this.type = "rexToast";
        this.setTransitInTime($41a74c2cba0e0e57$var$GetValue(config, "duration.in", 200));
        this.setDisplayTime($41a74c2cba0e0e57$var$GetValue(config, "duration.hold", 1200));
        this.setTransitOutTime($41a74c2cba0e0e57$var$GetValue(config, "duration.out", 200));
        this.setTransitInCallback($41a74c2cba0e0e57$var$GetValue(config, "transitIn", $41a74c2cba0e0e57$var$TransitionMode.popUp));
        this.setTransitOutCallback($41a74c2cba0e0e57$var$GetValue(config, "transitOut", $41a74c2cba0e0e57$var$TransitionMode.scaleDown));
        this.player = new (0, $74b2e838cfda53fb$export$2e2bcd8739ae039)(this, {
            dtMode: 1
        });
        this.messages = [];
        this.scaleX0 = undefined;
        this.scaleY0 = undefined;
        this.setVisible(false);
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.player.destroy();
        this.player = undefined;
        this.messages = undefined;
        super.destroy(fromScene);
    }
    setDisplayTime(time) {
        this.displayTime = time;
        return this;
    }
    setTransitOutTime(time) {
        this.transitOutTime = time;
        return this;
    }
    setTransitInTime(time) {
        this.transitInTime = time;
        return this;
    }
    setTransitInCallback(callback) {
        if (typeof callback === "string") callback = $41a74c2cba0e0e57$var$TransitionMode[callback];
        switch(callback){
            case $41a74c2cba0e0e57$var$TransitionMode.popUp:
                callback = (0, $f75ffc4ae1f7b65b$export$2e2bcd8739ae039).popUp;
                break;
            case $41a74c2cba0e0e57$var$TransitionMode.fadeIn:
                callback = (0, $f75ffc4ae1f7b65b$export$2e2bcd8739ae039).fadeIn;
                break;
        }
        if (!callback) callback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
        this.transitInCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    }
    setTransitOutCallback(callback) {
        if (typeof callback === "string") callback = $41a74c2cba0e0e57$var$TransitionMode[callback];
        switch(callback){
            case $41a74c2cba0e0e57$var$TransitionMode.scaleDown:
                callback = (0, $f75ffc4ae1f7b65b$export$2e2bcd8739ae039).scaleDown;
                break;
            case $41a74c2cba0e0e57$var$TransitionMode.fadeOut:
                callback = (0, $f75ffc4ae1f7b65b$export$2e2bcd8739ae039).fadeOut;
                break;
        }
        if (!callback) callback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
        this.transitOutCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    }
    setScale(scaleX, scaleY) {
        if (scaleY === undefined) scaleY = scaleX;
        // Can override initial scale
        this.scaleX0 = scaleX;
        this.scaleY0 = scaleY;
        super.setScale(scaleX, scaleY);
        return this;
    }
    showMessage(callback) {
        // Remember first scaleX, scaleY as initial scale
        if (this.scaleX0 === undefined) this.scaleX0 = this.scaleX;
        if (this.scaleY0 === undefined) this.scaleY0 = this.scaleY;
        if (callback === undefined) {
            // Try pop up a pendding message
            if (this.messages.length === 0) return this;
            callback = this.messages.shift();
        }
        if (this.player.isPlaying) {
            // Pend message
            this.messages.push(callback);
            return this;
        }
        // Recover to initial state
        this.setScale(this.scaleX0, this.scaleY0).setVisible(true);
        if (typeof callback === "string") this.setText(callback);
        else callback(this);
        this.layout();
        var commands = [
            [
                0,
                [
                    this.transitInCallback,
                    this,
                    this.transitInTime
                ] // [callback, param, ...]
            ],
            [
                this.transitInTime,
                [
                    (0, $990223f7da3447ad$export$2e2bcd8739ae039)
                ]
            ],
            [
                this.displayTime,
                [
                    this.transitOutCallback,
                    this,
                    this.transitOutTime
                ]
            ],
            [
                this.transitOutTime,
                [
                    this.setVisible,
                    false
                ]
            ],
            [
                30,
                [
                    (0, $990223f7da3447ad$export$2e2bcd8739ae039)
                ]
            ]
        ];
        this.player.load(commands, this).once("complete", function() {
            this.showMessage();
        }, this).start();
        return this;
    }
}
const $41a74c2cba0e0e57$var$TransitionMode = {
    popUp: 0,
    fadeIn: 1,
    scaleDown: 0,
    fadeOut: 1
};
var $41a74c2cba0e0e57$export$2e2bcd8739ae039 = $41a74c2cba0e0e57$var$Toast;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("toast", function(config) {
    var gameObject = new (0, $41a74c2cba0e0e57$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Toast", (0, $41a74c2cba0e0e57$export$2e2bcd8739ae039));
var $766a4d3c503bedb7$export$2e2bcd8739ae039 = (0, $41a74c2cba0e0e57$export$2e2bcd8739ae039);





var $270d40c855faa2a5$var$CreateSwatch = function(scene, config) {
    if (config === false) return null;
    else if ((0, $028756cbb60d16db$export$2e2bcd8739ae039)(config)) return config;
    var swatch = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(swatch);
    return swatch;
};
var $270d40c855faa2a5$export$2e2bcd8739ae039 = $270d40c855faa2a5$var$CreateSwatch;




var $1491b3a644681e30$var$CreateInputText = function(scene, config, deepCloneConfig) {
    if (deepCloneConfig === undefined) deepCloneConfig = true;
    if (deepCloneConfig) config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
    else if (!config) config = {};
    var inputText = new (0, $27ef680b345dde22$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(inputText);
    return inputText;
};
var $1491b3a644681e30$export$2e2bcd8739ae039 = $1491b3a644681e30$var$CreateInputText;


const $d0474c16a8e641cd$export$780986a01cffdb1d = [
    "AliceBlue",
    "AntiqueWhite",
    "Aqua",
    "Aquamarine",
    "Azure",
    "Beige",
    "Bisque",
    "Black",
    "BlanchedAlmond",
    "Blue",
    "BlueViolet",
    "Brown",
    "BurlyWood",
    "CadetBlue",
    "Chartreuse",
    "Chocolate",
    "Coral",
    "CornflowerBlue",
    "Cornsilk",
    "Crimson",
    "Cyan",
    "DarkBlue",
    "DarkCyan",
    "DarkGoldenRod",
    "DarkGray",
    "DarkGrey",
    "DarkGreen",
    "DarkKhaki",
    "DarkMagenta",
    "DarkOliveGreen",
    "DarkOrange",
    "DarkOrchid",
    "DarkRed",
    "DarkSalmon",
    "DarkSeaGreen",
    "DarkSlateBlue",
    "DarkSlateGray",
    "DarkSlateGrey",
    "DarkTurquoise",
    "DarkViolet",
    "DeepPink",
    "DeepSkyBlue",
    "DimGray",
    "DimGrey",
    "DodgerBlue",
    "FireBrick",
    "FloralWhite",
    "ForestGreen",
    "Fuchsia",
    "Gainsboro",
    "GhostWhite",
    "Gold",
    "GoldenRod",
    "Gray",
    "Grey",
    "Green",
    "GreenYellow",
    "HoneyDew",
    "HotPink",
    "IndianRed",
    "Indigo",
    "Ivory",
    "Khaki",
    "Lavender",
    "LavenderBlush",
    "LawnGreen",
    "LemonChiffon",
    "LightBlue",
    "LightCoral",
    "LightCyan",
    "LightGoldenRodYellow",
    "LightGray",
    "LightGrey",
    "LightGreen",
    "LightPink",
    "LightSalmon",
    "LightSeaGreen",
    "LightSkyBlue",
    "LightSlateGray",
    "LightSlateGrey",
    "LightSteelBlue",
    "LightYellow",
    "Lime",
    "LimeGreen",
    "Linen",
    "Magenta",
    "Maroon",
    "MediumAquaMarine",
    "MediumBlue",
    "MediumOrchid",
    "MediumPurple",
    "MediumSeaGreen",
    "MediumSlateBlue",
    "MediumSpringGreen",
    "MediumTurquoise",
    "MediumVioletRed",
    "MidnightBlue",
    "MintCream",
    "MistyRose",
    "Moccasin",
    "NavajoWhite",
    "Navy",
    "OldLace",
    "Olive",
    "OliveDrab",
    "Orange",
    "OrangeRed",
    "Orchid",
    "PaleGoldenRod",
    "PaleGreen",
    "PaleTurquoise",
    "PaleVioletRed",
    "PapayaWhip",
    "PeachPuff",
    "Peru",
    "Pink",
    "Plum",
    "PowderBlue",
    "Purple",
    "RebeccaPurple",
    "Red",
    "RosyBrown",
    "RoyalBlue",
    "SaddleBrown",
    "Salmon",
    "SandyBrown",
    "SeaGreen",
    "SeaShell",
    "Sienna",
    "Silver",
    "SkyBlue",
    "SlateBlue",
    "SlateGray",
    "SlateGrey",
    "Snow",
    "SpringGreen",
    "SteelBlue",
    "Tan",
    "Teal",
    "Thistle",
    "Tomato",
    "Turquoise",
    "Violet",
    "Wheat",
    "White",
    "WhiteSmoke",
    "Yellow",
    "YellowGreen"
];
const $d0474c16a8e641cd$var$ColorValues = [
    0xf0f8ff,
    0xfaebd7,
    0x00ffff,
    0x7fffd4,
    0xf0ffff,
    0xf5f5dc,
    0xffe4c4,
    0x000000,
    0xffebcd,
    0x0000ff,
    0x8a2be2,
    0xa52a2a,
    0xdeb887,
    0x5f9ea0,
    0x7fff00,
    0xd2691e,
    0xff7f50,
    0x6495ed,
    0xfff8dc,
    0xdc143c,
    0x00ffff,
    0x00008b,
    0x008b8b,
    0xb8860b,
    0xa9a9a9,
    0xa9a9a9,
    0x006400,
    0xbdb76b,
    0x8b008b,
    0x556b2f,
    0xff8c00,
    0x9932cc,
    0x8b0000,
    0xe9967a,
    0x8fbc8f,
    0x483d8b,
    0x2f4f4f,
    0x2f4f4f,
    0x00ced1,
    0x9400d3,
    0xff1493,
    0x00bfff,
    0x696969,
    0x696969,
    0x1e90ff,
    0xb22222,
    0xfffaf0,
    0x228b22,
    0xff00ff,
    0xdcdcdc,
    0xf8f8ff,
    0xffd700,
    0xdaa520,
    0x808080,
    0x808080,
    0x008000,
    0xadff2f,
    0xf0fff0,
    0xff69b4,
    0xcd5c5c,
    0x4b0082,
    0xfffff0,
    0xf0e68c,
    0xe6e6fa,
    0xfff0f5,
    0x7cfc00,
    0xfffacd,
    0xadd8e6,
    0xf08080,
    0xe0ffff,
    0xfafad2,
    0xd3d3d3,
    0xd3d3d3,
    0x90ee90,
    0xffb6c1,
    0xffa07a,
    0x20b2aa,
    0x87cefa,
    0x778899,
    0x778899,
    0xb0c4de,
    0xffffe0,
    0x00ff00,
    0x32cd32,
    0xfaf0e6,
    0xff00ff,
    0x800000,
    0x66cdaa,
    0x0000cd,
    0xba55d3,
    0x9370db,
    0x3cb371,
    0x7b68ee,
    0x00fa9a,
    0x48d1cc,
    0xc71585,
    0x191970,
    0xf5fffa,
    0xffe4e1,
    0xffe4b5,
    0xffdead,
    0x000080,
    0xfdf5e6,
    0x808000,
    0x6b8e23,
    0xffa500,
    0xff4500,
    0xda70d6,
    0xeee8aa,
    0x98fb98,
    0xafeeee,
    0xdb7093,
    0xffefd5,
    0xffdab9,
    0xcd853f,
    0xffc0cb,
    0xdda0dd,
    0xb0e0e6,
    0x800080,
    0x663399,
    0xff0000,
    0xbc8f8f,
    0x4169e1,
    0x8b4513,
    0xfa8072,
    0xf4a460,
    0x2e8b57,
    0xfff5ee,
    0xa0522d,
    0xc0c0c0,
    0x87ceeb,
    0x6a5acd,
    0x708090,
    0x708090,
    0xfffafa,
    0x00ff7f,
    0x4682b4,
    0xd2b48c,
    0x008080,
    0xd8bfd8,
    0xff6347,
    0x40e0d0,
    0xee82ee,
    0xf5deb3,
    0xffffff,
    0xf5f5f5,
    0xffff00,
    0x9acd32
];
var $d0474c16a8e641cd$var$ColorNameToIntegerDict = {}, $d0474c16a8e641cd$var$name;
for(var $d0474c16a8e641cd$var$i = 0, $d0474c16a8e641cd$var$cnt = $d0474c16a8e641cd$export$780986a01cffdb1d.length; $d0474c16a8e641cd$var$i < $d0474c16a8e641cd$var$cnt; $d0474c16a8e641cd$var$i++){
    $d0474c16a8e641cd$var$name = $d0474c16a8e641cd$export$780986a01cffdb1d[$d0474c16a8e641cd$var$i].toLowerCase();
    $d0474c16a8e641cd$var$ColorNameToIntegerDict[$d0474c16a8e641cd$var$name] = $d0474c16a8e641cd$var$ColorValues[$d0474c16a8e641cd$var$i];
}
var $d0474c16a8e641cd$export$8274257ff3cbefad = function(colorName) {
    colorName = colorName.toLowerCase();
    if ($d0474c16a8e641cd$var$ColorNameToIntegerDict.hasOwnProperty(colorName)) return $d0474c16a8e641cd$var$ColorNameToIntegerDict[colorName];
    else return null;
};
var $d0474c16a8e641cd$export$bc41600b79e631a4 = function(colorValue) {
    var idx = $d0474c16a8e641cd$var$ColorValues.indexOf(colorValue);
    if (idx === -1) return "";
    else return $d0474c16a8e641cd$export$780986a01cffdb1d[idx];
};


var $d9effec52f4612f3$var$ColorStringToInteger = function(value) {
    if (typeof value !== "string") return value;
    if (value.startsWith("#")) value = parseInt(value.substring(1), 16);
    else if (value.startsWith("0x")) value = parseInt(value.substring(2), 16);
    else value = (0, $d0474c16a8e641cd$export$8274257ff3cbefad)(value);
    return value;
};
var $d9effec52f4612f3$export$2e2bcd8739ae039 = $d9effec52f4612f3$var$ColorStringToInteger;


const $982fab8fd15081ea$var$Pad = Phaser.Utils.String.Pad;
var $982fab8fd15081ea$var$GetHexColorString = function(value, prefix) {
    if (prefix === undefined) prefix = "0x";
    var colorString = value.toString(16).toUpperCase();
    colorString = $982fab8fd15081ea$var$Pad(colorString, 6, 0, 1);
    colorString = prefix + colorString;
    return colorString;
};
var $982fab8fd15081ea$export$2e2bcd8739ae039 = $982fab8fd15081ea$var$GetHexColorString;


var $ab154b6940f7d91e$var$SetSwatchColor = function(swatch, color) {
    if (!swatch) return;
    if (swatch.setTint) swatch.setTint(color);
    else if (swatch.setFillStyle) swatch.setFillStyle(color);
};
var $ab154b6940f7d91e$export$2e2bcd8739ae039 = $ab154b6940f7d91e$var$SetSwatchColor;



const $16f48e9989276376$var$GetValue = Phaser.Utils.Objects.GetValue;
const $16f48e9989276376$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $16f48e9989276376$var$Clamp = Phaser.Math.Clamp;
class $16f48e9989276376$var$ColorInput extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        config.orientation = 0;
        super(scene, config);
        this.type = "rexColorInputLite";
        // Add elements
        var background = $16f48e9989276376$var$GetValue(config, "background", undefined);
        var swatchConfig = $16f48e9989276376$var$GetValue(config, "swatch");
        var swatchSize;
        if ($16f48e9989276376$var$IsPlainObject(swatchConfig)) swatchSize = $16f48e9989276376$var$GetValue(swatchConfig, "size");
        var swatch = (0, $270d40c855faa2a5$export$2e2bcd8739ae039)(scene, $16f48e9989276376$var$GetValue(config, "swatch"));
        var inputTextConfig = $16f48e9989276376$var$GetValue(config, "inputText", true);
        var inputText;
        if (inputTextConfig) inputText = (0, $1491b3a644681e30$export$2e2bcd8739ae039)(scene, inputTextConfig);
        if (background) this.addBackground(background);
        if (swatch) {
            swatchSize = $16f48e9989276376$var$GetValue(config, "swatchSize", swatchSize);
            var squareExpandSwatch;
            if (swatchSize !== undefined) {
                (0, $70a3d2b487b0ec73$export$2e2bcd8739ae039)(swatch, swatchSize, swatchSize);
                squareExpandSwatch = false;
            } else squareExpandSwatch = $16f48e9989276376$var$GetValue(config, "squareExpandSwatch", true);
            var fitRatio = squareExpandSwatch ? 1 : 0;
            this.add(swatch, {
                proportion: 0,
                expand: false,
                fitRatio: fitRatio
            });
        }
        if (inputText) {
            var proportion = $16f48e9989276376$var$GetValue(inputTextConfig, "width") === undefined ? 1 : 0;
            var expand = $16f48e9989276376$var$GetValue(inputTextConfig, "height") === undefined ? true : false;
            this.add(inputText, {
                proportion: proportion,
                expand: expand
            });
        }
        this.addChildrenMap("background", background);
        this.addChildrenMap("swatch", swatch);
        this.addChildrenMap("inputText", inputText);
        if (inputText) inputText.on("close", function() {
            this.setValue(inputText.value);
        }, this);
        var callback = $16f48e9989276376$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $16f48e9989276376$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        this.setValue($16f48e9989276376$var$GetValue(config, "value", 0x0));
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (typeof value === "string") {
            value = (0, $d9effec52f4612f3$export$2e2bcd8739ae039)(value);
            if (value == null) {
                var inputText = this.childrenMap.inputText;
                if (inputText) inputText.setText((0, $982fab8fd15081ea$export$2e2bcd8739ae039)(this._value));
                return;
            }
        } else value = $16f48e9989276376$var$Clamp(Math.floor(value), 0, 0xffffff);
        if (this._value === value) return;
        this._value = value;
        var swatch = this.childrenMap.swatch;
        if (swatch) (0, $ab154b6940f7d91e$export$2e2bcd8739ae039)(swatch, value);
        var inputText = this.childrenMap.inputText;
        if (inputText) inputText.setText((0, $982fab8fd15081ea$export$2e2bcd8739ae039)(value));
        this.emit("valuechange", this._value);
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    get color() {
        return this._value;
    }
    set color(color) {
        this.value = color;
    }
    setColor(color) {
        this.color = color;
        return this;
    }
}
var $16f48e9989276376$export$2e2bcd8739ae039 = $16f48e9989276376$var$ColorInput;


var $e6d925b8b150c51a$var$methods = {
    // Color picker
    setCreateColorPickerBackgroundCallback (callback) {
        this.colorPickerCreateBackgroundCallback = callback;
        return this;
    },
    setColorPickerHPalettePosition (position) {
        this.colorPickerHPalettePosition = position;
        return this;
    },
    setColorPickerExpandDirection (direction) {
        if (typeof direction === "string") direction = $e6d925b8b150c51a$var$ColorPickerExpandDirections[direction];
        this.colorPickerExpandDirection = direction;
        return this;
    },
    setColorPickerEaseInDuration (duration) {
        if (duration === undefined) duration = 0;
        this.colorPickerEaseInDuration = duration;
        return this;
    },
    setColorPickerEaseOutDuration (duration) {
        if (duration === undefined) duration = 0;
        this.colorPickerEaseOutDuration = duration;
        return this;
    },
    setColorPickerTransitInCallback (callback) {
        this.colorPickerTransitInCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    setColorPickerTransitOutCallback (callback) {
        this.colorPickerTransitOutCallback = callback;
        // callback = function(gameObject, duration) {}
        return this;
    },
    setColorPickerBounds (bounds) {
        this.colorPickerBounds = bounds;
        return this;
    },
    setColorPickerWidth (width) {
        this.colorPickerWidth = width;
        return this;
    },
    setColorPickerHeight (height) {
        this.colorPickerHeight = height;
        return this;
    },
    setColorPickerSize (width, height) {
        this.setColorPickerWidth(width).setColorPickerHeight(height);
        return this;
    },
    setColorPickerSpace (space) {
        if (space === undefined) space = {};
        this.colorPickerSpace = space;
        return this;
    },
    // Color components
    setColorComponentsHeight (height) {
        this.colorComponentsHeight = height;
        return this;
    },
    setColorComponentsFormatLabelConfig (config) {
        this.colorComponentsFormatLabelConfig = config;
        return this;
    },
    setColorComponentsInputTextConfig (config) {
        this.colorComponentsInputTextConfig = config;
        return this;
    },
    setColorComponentsSpace (space) {
        if (space === undefined) space = {};
        this.colorComponentsSpace = space;
        return this;
    }
};
const $e6d925b8b150c51a$var$ColorPickerExpandDirections = {
    down: 0,
    up: 1
};
var $e6d925b8b150c51a$export$2e2bcd8739ae039 = $e6d925b8b150c51a$var$methods;







const $77d3311865b2a755$var$Color = Phaser.Display.Color;
const $77d3311865b2a755$var$Percent = Phaser.Math.Percent;
var $77d3311865b2a755$export$7201a2c14487ecc4 = function(canvas, context, verticalMode) {
    if (verticalMode === undefined) verticalMode = false;
    var width = canvas.width;
    var height = canvas.height;
    var color = new $77d3311865b2a755$var$Color();
    if (verticalMode) for(var iy = 0; iy < height; iy++){
        var h = $77d3311865b2a755$var$Percent(iy, 0, height);
        color.setFromHSV(h, 1, 1);
        context.fillStyle = color.rgba;
        context.fillRect(0, iy, width, 1);
    }
    else for(var ix = 0; ix < width; ix++){
        var h = $77d3311865b2a755$var$Percent(ix, 0, width);
        color.setFromHSV(h, 1, 1);
        context.fillStyle = color.rgba;
        context.fillRect(ix, 0, 1, height);
    }
};
var $77d3311865b2a755$export$ace501f70d1e5bb5 = function(canvas, context, h) {
    var width = canvas.width;
    var height = canvas.height;
    var imgData = context.getImageData(0, 0, width, height);
    var data = imgData.data;
    var color = new $77d3311865b2a755$var$Color();
    for(var iy = 0; iy < height; iy++)for(var ix = 0; ix < width; ix++){
        var s = $77d3311865b2a755$var$Percent(ix, 0, width);
        var v = 1 - $77d3311865b2a755$var$Percent(iy, 0, height);
        color.setFromHSV(h, s, v);
        var i = (iy * width + ix) * 4;
        data[i] = color.red;
        data[i + 1] = color.green;
        data[i + 2] = color.blue;
        data[i + 3] = 255;
    }
    context.putImageData(imgData, 0, 0);
};


const $ada9402ffe856335$var$Color = Phaser.Display.Color;
const $ada9402ffe856335$var$Percent = Phaser.Math.Percent;
const $ada9402ffe856335$var$ColorToRGBA = Phaser.Display.Color.ColorToRGBA;
const $ada9402ffe856335$var$HSVToRGB = Phaser.Display.Color.HSVToRGB;
class $ada9402ffe856335$var$HPaletteCanvas extends (0, $a7cd42622da8fab8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, orientation){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 2;
        if (height === undefined) height = 2;
        super(scene, x, y, width, height);
        this.type = "rexColorPicker.HPaletteCanvas";
        this.colorObject = new $ada9402ffe856335$var$Color();
        this.setOrientation(orientation);
        this.setSize(width, height);
    }
    setOrientation(orientation) {
        this.orientation = (0, $3c3f84ff9ee02f02$export$2e2bcd8739ae039)(orientation);
        return this;
    }
    updateTexture() {
        (0, $77d3311865b2a755$export$7201a2c14487ecc4)(this.canvas, this.context, this.orientation);
        super.updateTexture();
        return this;
    }
    get color() {
        return this.colorObject.color;
    }
    get hue() {
        return this._hue;
    }
    set hue(value) {
        this._hue = value;
    }
    getHue(localX, localY) {
        if (localX === undefined) return this.hue;
        if (this.orientation === 0) this.hue = $ada9402ffe856335$var$Percent(localX, 0, this.width);
        else this.hue = $ada9402ffe856335$var$Percent(localY, 0, this.height);
        return this.hue;
    }
    getColor(localX, localY) {
        if (localX === undefined) return this.color;
        var h = this.getHue(localX, localY);
        this.colorObject.setFromRGB($ada9402ffe856335$var$HSVToRGB(h, 1, 1));
        return this.colorObject.color;
    }
    setColor(color) {
        if (this.color === color) return this;
        return this;
    }
    colorToLocalPosition(color, out) {
        if (out === undefined) out = {};
        else if (out === true) {
            if ($ada9402ffe856335$var$LocalXY === undefined) $ada9402ffe856335$var$LocalXY = {};
            out = $ada9402ffe856335$var$LocalXY;
        }
        this.colorObject.setFromRGB($ada9402ffe856335$var$ColorToRGBA(color));
        if (this.orientation === 0) {
            out.x = this.width * this.colorObject.h;
            out.y = this.height / 2;
        } else {
            out.x = this.width / 2;
            out.y = this.height * this.colorObject.h;
        }
        return out;
    }
}
var $ada9402ffe856335$var$LocalXY = undefined;
var $ada9402ffe856335$export$2e2bcd8739ae039 = $ada9402ffe856335$var$HPaletteCanvas;



var $795beefc1195c426$var$RotateAround = Phaser.Math.RotateAround;
var $795beefc1195c426$export$fa5399b0ae3e4127 = function(gameObject, localX, localY, out) {
    if (out === undefined) out = {};
    else if (out === true) {
        if ($795beefc1195c426$var$GlobOut === undefined) $795beefc1195c426$var$GlobOut = {};
        out = $795beefc1195c426$var$GlobOut;
    }
    localX -= gameObject.width * gameObject.originX;
    localY -= gameObject.height * gameObject.originY;
    var point = {
        x: localX * gameObject.scaleX,
        y: localY * gameObject.scaleY
    };
    $795beefc1195c426$var$RotateAround(point, 0, 0, -gameObject.rotation);
    out.x = gameObject.x + localX;
    out.y = gameObject.y + localY;
    return out;
};
var $795beefc1195c426$var$GlobOut;


class $8603d5712c27b988$var$HPalette extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene, config);
        var orientation = config.width != null ? 1 : 0;
        var paletteCanvas = new (0, $ada9402ffe856335$export$2e2bcd8739ae039)(scene).setOrientation(orientation);
        scene.add.existing(paletteCanvas);
        this.type = "rexColorPicker.HPalette";
        paletteCanvas.setInteractive().on("pointerdown", this.onPaletteCanvasPointerDown, this).on("pointermove", this.onPaletteCanvasPointerDown, this);
        var marker = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(scene, {
            strokeColor: 0xffffff,
            strokeWidth: 2
        });
        scene.add.existing(marker);
        this.add(paletteCanvas, {
            key: "paletteCanvas",
            expand: true
        }).add(marker, {
            key: "marker",
            expand: false
        });
    }
    resize(width, height) {
        if (this.width === width && this.height === height) return this;
        super.resize(width, height);
        var size = Math.min(width, height);
        this.childrenMap.marker.setSize(size, size);
        return this;
    }
    onPaletteCanvasPointerDown(pointer, localX, localY, event) {
        if (!pointer.isDown) return;
        var paletteCanvas = this.childrenMap.paletteCanvas;
        var color = paletteCanvas.getColor(localX, localY);
        this.setMarkerPosition(color);
        this.emit("input", color);
    }
    get color() {
        return this.childrenMap.paletteCanvas.color;
    }
    setColor(color) {
        if (this.color === color) return this;
        var paletteCanvas = this.childrenMap.paletteCanvas;
        paletteCanvas.setColor(color);
        this.setMarkerPosition(color);
        return this;
    }
    setMarkerPosition(color) {
        var paletteCanvas = this.childrenMap.paletteCanvas;
        var marker = this.childrenMap.marker;
        var localXY = paletteCanvas.colorToLocalPosition(color, true);
        (0, $795beefc1195c426$export$fa5399b0ae3e4127)(paletteCanvas, localXY.x, localXY.y, marker);
        this.resetChildPositionState(marker);
        return this;
    }
    getHue(localX, localY) {
        var paletteCanvas = this.childrenMap.paletteCanvas;
        return paletteCanvas.getHue(localX, localY);
    }
}
var $8603d5712c27b988$export$2e2bcd8739ae039 = $8603d5712c27b988$var$HPalette;





const $18ead31bc858ed50$var$Color = Phaser.Display.Color;
const $18ead31bc858ed50$var$Percent = Phaser.Math.Percent;
const $18ead31bc858ed50$var$ColorToRGBA = Phaser.Display.Color.ColorToRGBA;
const $18ead31bc858ed50$var$HSVToRGB = Phaser.Display.Color.HSVToRGB;
class $18ead31bc858ed50$var$SVPaletteCanvas extends (0, $a7cd42622da8fab8$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, hue){
        if (x === undefined) x = 0;
        if (y === undefined) y = 0;
        if (width === undefined) width = 2;
        if (height === undefined) height = 2;
        super(scene, x, y, width, height);
        this.type = "rexColorPicker.SVPaletteCanvas";
        if (hue === undefined) hue = 1;
        this.colorObject = new $18ead31bc858ed50$var$Color();
        this.setHue(hue);
        this.setSize(width, height);
    }
    get color() {
        return this.colorObject.color;
    }
    get hue() {
        return this._hue;
    }
    set hue(hue) {
        if (this._hue === hue) return;
        this._hue = hue;
        this.colorObject.h = hue;
        this.dirty = true;
    }
    setHue(hue) {
        this.hue = hue;
        return this;
    }
    updateTexture() {
        (0, $77d3311865b2a755$export$ace501f70d1e5bb5)(this.canvas, this.context, this.hue);
        super.updateTexture();
        return this;
    }
    getColor(localX, localY) {
        if (localX === undefined) return this.colorObject.color;
        var s = $18ead31bc858ed50$var$Percent(localX, 0, this.width);
        var v = 1 - $18ead31bc858ed50$var$Percent(localY, 0, this.height);
        this.colorObject.setFromRGB($18ead31bc858ed50$var$HSVToRGB(this.hue, s, v));
        return this.colorObject.color;
    }
    setColor(color) {
        if (this.color === color) return this;
        this.colorObject.setFromRGB($18ead31bc858ed50$var$ColorToRGBA(color));
        this.setHue(this.colorObject.h);
        return this;
    }
    colorToLocalPosition(color, out) {
        if (out === undefined) out = {};
        else if (out === true) {
            if ($18ead31bc858ed50$var$LocalXY === undefined) $18ead31bc858ed50$var$LocalXY = {};
            out = $18ead31bc858ed50$var$LocalXY;
        }
        this.colorObject.setFromRGB($18ead31bc858ed50$var$ColorToRGBA(color));
        out.x = this.width * this.colorObject.s;
        out.y = this.height * (1 - this.colorObject.v);
        return out;
    }
}
var $18ead31bc858ed50$var$LocalXY = undefined;
var $18ead31bc858ed50$export$2e2bcd8739ae039 = $18ead31bc858ed50$var$SVPaletteCanvas;




class $c6798b7e213871bc$var$SVPalette extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        var paletteCanvas = new (0, $18ead31bc858ed50$export$2e2bcd8739ae039)(scene);
        scene.add.existing(paletteCanvas);
        this.type = "rexColorPicker.SVPalette";
        paletteCanvas.setInteractive().on("pointerdown", this.onPaletteCanvasPointerDown, this).on("pointermove", this.onPaletteCanvasPointerDown, this);
        var marker = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(scene, {
            radius: 5,
            strokeColor: 0xffffff,
            strokeWidth: 2
        });
        scene.add.existing(marker);
        this.add(paletteCanvas, {
            key: "paletteCanvas",
            expand: true
        }).add(marker, {
            key: "marker",
            expand: false
        });
    }
    onPaletteCanvasPointerDown(pointer, localX, localY, event) {
        if (!pointer.isDown) return;
        var paletteCanvas = this.childrenMap.paletteCanvas;
        var color = paletteCanvas.getColor(localX, localY);
        this.setMarkerPosition(color);
        this.emit("input", color);
    }
    get color() {
        return this.childrenMap.paletteCanvas.color;
    }
    setHue(hue) {
        var paletteCanvas = this.childrenMap.paletteCanvas;
        paletteCanvas.setHue(hue); // Redraw paletteCanvas
        // Position of marker does not change
        return this;
    }
    setColor(color) {
        if (this.color === color) return this;
        var paletteCanvas = this.childrenMap.paletteCanvas;
        paletteCanvas.setColor(color); // Redraw paletteCanvas
        this.setMarkerPosition(color);
        return this;
    }
    setMarkerPosition(color) {
        var paletteCanvas = this.childrenMap.paletteCanvas;
        var marker = this.childrenMap.marker;
        var localXY = paletteCanvas.colorToLocalPosition(color, true);
        (0, $795beefc1195c426$export$fa5399b0ae3e4127)(paletteCanvas, localXY.x, localXY.y, marker);
        this.resetChildPositionState(marker);
        return this;
    }
}
var $c6798b7e213871bc$export$2e2bcd8739ae039 = $c6798b7e213871bc$var$SVPalette;


const $5104d5badb86c9b5$var$GetValue = Phaser.Utils.Objects.GetValue;
class $5104d5badb86c9b5$var$ColorPicker extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexColorPicker";
        this.freezePalettes = false;
        // orientation
        var hPalettePosition = $5104d5badb86c9b5$var$GetValue(config, "hPalette.position", 0);
        if (typeof hPalettePosition === "string") hPalettePosition = $5104d5badb86c9b5$var$HPalettePositionNamesMap[hPalettePosition];
        var orientation = hPalettePosition === 0 || // bottom
        hPalettePosition === 2 // top
         ? 1 : 0; // x
        this.setOrientation(orientation);
        // Add elements
        var background = $5104d5badb86c9b5$var$GetValue(config, "background", undefined);
        var hPaletteWidth, hPaletteHeight;
        if (this.orientation === 0) {
            var hPaletteWidth = $5104d5badb86c9b5$var$GetValue(config, "hPalette.width", undefined);
            if (hPaletteWidth === undefined) hPaletteWidth = $5104d5badb86c9b5$var$GetValue(config, "hPalette.size", 10);
        } else {
            hPaletteHeight = $5104d5badb86c9b5$var$GetValue(config, "hPalette.height", undefined);
            if (hPaletteHeight === undefined) hPaletteHeight = $5104d5badb86c9b5$var$GetValue(config, "hPalette.size", 10);
        }
        var hPalette = new (0, $8603d5712c27b988$export$2e2bcd8739ae039)(scene, {
            width: hPaletteWidth,
            height: hPaletteHeight
        });
        scene.add.existing(hPalette);
        var svPaletteWidth = $5104d5badb86c9b5$var$GetValue(config, "svPalette.width", undefined);
        var svPaletteHeight = $5104d5badb86c9b5$var$GetValue(config, "svPalette.height", undefined);
        var svPalette = new (0, $c6798b7e213871bc$export$2e2bcd8739ae039)(scene, {
            width: svPaletteWidth,
            height: svPaletteHeight
        });
        scene.add.existing(svPalette);
        if (background) this.addBackground(background);
        var hPaletteAddConfig = {
            proportion: 0,
            expand: true
        };
        var svPaletteProportion, svPaletteExpand;
        if (this.orientation === 0) {
            svPaletteProportion = svPaletteWidth === undefined ? 1 : 0;
            svPaletteExpand = svPaletteHeight === undefined ? true : false;
        } else {
            svPaletteProportion = svPaletteHeight === undefined ? 1 : 0;
            svPaletteExpand = svPaletteWidth === undefined ? true : false;
        }
        var svPaletteAddConfig = {
            proportion: svPaletteProportion,
            expand: svPaletteExpand
        };
        if (hPalettePosition === 0 || hPalettePosition === 3) this.add(svPalette, svPaletteAddConfig).add(hPalette, hPaletteAddConfig);
        else this.add(hPalette, hPaletteAddConfig).add(svPalette, svPaletteAddConfig);
        hPalette.on("input", function() {
            svPalette.setHue(hPalette.getHue());
            this.setValue(svPalette.color, true);
        }, this);
        svPalette.on("input", function() {
            this.setValue(svPalette.color, true);
        }, this);
        this.addChildrenMap("background", background);
        this.addChildrenMap("hPalette", hPalette);
        this.addChildrenMap("svPalette", svPalette);
        var callback = $5104d5badb86c9b5$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $5104d5badb86c9b5$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        this.setValue($5104d5badb86c9b5$var$GetValue(config, "value", 0xffffff));
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        var oldValue = this._value;
        this._value = value;
        if (!this.freezePalettes) this.updatePalettes();
        this.emit("valuechange", value, oldValue, this);
    }
    setValue(value, freezePalettes) {
        this.freezePalettes = !!freezePalettes;
        this.value = value;
        this.freezePalettes = false;
        return this;
    }
    get color() {
        return this._value;
    }
    set color(color) {
        this.value = color;
    }
    setColor(color) {
        this.color = color;
        return this;
    }
    updatePalettes() {
        this.childrenMap.hPalette.setColor(this.color);
        this.childrenMap.svPalette.setColor(this.color);
        return this;
    }
    runLayout(parent, newWidth, newHeight) {
        if (this.ignoreLayout) return this;
        super.runLayout(parent, newWidth, newHeight);
        this.childrenMap.hPalette.setMarkerPosition(this.value);
        this.childrenMap.svPalette.setMarkerPosition(this.value);
        return this;
    }
}
var $5104d5badb86c9b5$var$HPalettePositionNamesMap = {
    bottom: 0,
    left: 1,
    top: 2,
    right: 3
};
var $5104d5badb86c9b5$export$2e2bcd8739ae039 = $5104d5badb86c9b5$var$ColorPicker;






const $b7379f9253be233e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $b7379f9253be233e$var$Color = Phaser.Display.Color;
const $b7379f9253be233e$var$ColorToRGBA = Phaser.Display.Color.ColorToRGBA;
const $b7379f9253be233e$var$HSVToRGB = Phaser.Display.Color.HSVToRGB;
const $b7379f9253be233e$var$Clamp = Phaser.Math.Clamp;
class $b7379f9253be233e$var$ColorComponents extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        config.orientation = 0;
        super(scene, config);
        this.type = "rexColorComponents";
        this.colorObject = new $b7379f9253be233e$var$Color();
        // Add elements
        var background = $b7379f9253be233e$var$GetValue(config, "background", undefined);
        var formatLabel = $b7379f9253be233e$var$GetValue(config, "formatLabel", undefined);
        if (!(0, $028756cbb60d16db$export$2e2bcd8739ae039)(formatLabel)) formatLabel = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, formatLabel).resetDisplayContent();
        var components = [];
        if (config.inputText0 && config.inputText1 && config.inputText2) {
            components.push(config.inputText0);
            components.push(config.inputText1);
            components.push(config.inputText2);
        } else {
            var inputTextConfig = $b7379f9253be233e$var$GetValue(config, "inputText");
            for(var i = 0; i < 3; i++){
                var inputText = (0, $1491b3a644681e30$export$2e2bcd8739ae039)(scene, inputTextConfig).setMaxLength(3).setNumberInput();
                components.push(inputText);
            }
        }
        if (background) this.addBackground(background);
        var proportion = $b7379f9253be233e$var$GetValue(config, "proportion.formatLabel", 0);
        var defaultExpand = formatLabel.isRexContainerLite ? true : false;
        var expand = $b7379f9253be233e$var$GetValue(config, "expand.formatLabel", defaultExpand);
        this.add(formatLabel, {
            proportion: proportion,
            expand: expand
        });
        var proportion = $b7379f9253be233e$var$GetValue(inputTextConfig, "width") === undefined ? 1 : 0;
        var expand = $b7379f9253be233e$var$GetValue(inputTextConfig, "height") === undefined ? true : false;
        for(var i = 0, cnt = components.length; i < cnt; i++)this.add(components[i], {
            proportion: proportion,
            expand: expand
        });
        this.addChildrenMap("background", background);
        this.addChildrenMap("formatLabel", formatLabel);
        this.addChildrenMap("components", components);
        this.onClick(formatLabel, this.toggleColorFormat, this);
        for(var i = 0, cnt = components.length; i < cnt; i++)components[i].on("close", function() {
            this.updateColorObject();
            this.setValue(this.colorObject.color);
        }, this);
        var callback = $b7379f9253be233e$var$GetValue(config, "valuechangeCallback", null);
        if (callback !== null) {
            var scope = $b7379f9253be233e$var$GetValue(config, "valuechangeCallbackScope", undefined);
            this.on("valuechange", callback, scope);
        }
        formatLabel.setText("RGB");
        this.setValue($b7379f9253be233e$var$GetValue(config, "value", 0xffffff));
    }
    get value() {
        return this._value;
    }
    set value(value) {
        value = $b7379f9253be233e$var$Clamp(Math.floor(value), 0, 0xffffff);
        if (this._value === value) return;
        this._value = value;
        this.colorObject.setFromRGB($b7379f9253be233e$var$ColorToRGBA(value));
        this.updateComponents();
        this.emit("valuechange", this._value);
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    get color() {
        return this._value;
    }
    set color(color) {
        this.value = color;
    }
    setColor(color) {
        this.color = color;
        return this;
    }
    get colorFormat() {
        return this.childrenMap.formatLabel.text;
    }
    set colorFormat(value) {
        if (this.colorFormat === value) return;
        this.childrenMap.formatLabel.setText(value);
        this.updateComponents();
    }
    setColorFormat(colrType) {
        this.colorFormat = colrType;
        return this;
    }
    toggleColorFormat() {
        this.colorFormat = this.colorFormat === "RGB" ? "HSV" : "RGB";
        return this;
    }
    updateComponents() {
        var components = this.childrenMap.components;
        var value0, value1, value2;
        if (this.colorFormat === "RGB") {
            value0 = this.colorObject.red;
            value1 = this.colorObject.green;
            value2 = this.colorObject.blue;
        } else {
            value0 = Math.floor(this.colorObject.h * 360);
            value1 = Math.floor(this.colorObject.s * 100);
            value2 = Math.floor(this.colorObject.v * 100);
        }
        components[0].setValue(value0);
        components[1].setValue(value1);
        components[2].setValue(value2);
        return this;
    }
    updateColorObject() {
        var components = this.childrenMap.components;
        if (this.colorFormat === "RGB") {
            var red = $b7379f9253be233e$var$Clamp(components[0].value, 0, 255);
            var green = $b7379f9253be233e$var$Clamp(components[1].value, 0, 255);
            var blue = $b7379f9253be233e$var$Clamp(components[2].value, 0, 255);
            this.colorObject.setTo(red, green, blue);
        } else {
            var h = $b7379f9253be233e$var$Clamp(components[0].value, 0, 359) / 360;
            var s = $b7379f9253be233e$var$Clamp(components[1].value, 0, 100) / 100;
            var v = $b7379f9253be233e$var$Clamp(components[2].value, 0, 100) / 100;
            this.colorObject.setFromRGB($b7379f9253be233e$var$HSVToRGB(h, s, v));
        }
        return this;
    }
}
var $b7379f9253be233e$export$2e2bcd8739ae039 = $b7379f9253be233e$var$ColorComponents;



var $8995c512b14e3cd5$export$2e2bcd8739ae039 = (0, $68e42c4eb1100300$export$2e2bcd8739ae039);


var $2b20d0e3b0aea15b$export$2e2bcd8739ae039 = (0, $8995c512b14e3cd5$export$2e2bcd8739ae039);


const $55dce8ca68e46ed2$var$GetValue = Phaser.Utils.Objects.GetValue;
class $55dce8ca68e46ed2$var$ColorPickerPanel extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        config.orientation = 1;
        super(scene, config);
        this.type = "rexColorInput.ColorPickerPanel";
        // Add elements
        var background = $55dce8ca68e46ed2$var$GetValue(config, "background", undefined);
        var colorPicker = new (0, $5104d5badb86c9b5$export$2e2bcd8739ae039)(scene, {
            hPalette: config.hPalette || {},
            svPalette: config.svPalette || {},
            space: {
                item: $55dce8ca68e46ed2$var$GetValue(config, "space.hPalette", 8)
            }
        });
        scene.add.existing(colorPicker);
        var colorComponents;
        if (config.colorComponents) {
            colorComponents = new (0, $b7379f9253be233e$export$2e2bcd8739ae039)(scene, config.colorComponents);
            scene.add.existing(colorComponents);
        }
        if (background) {
            this.addBackground(background);
            var touchEventStop = new (0, $2b20d0e3b0aea15b$export$2e2bcd8739ae039)(background, {
                stopAllLevels: false
            });
        }
        this.add(colorPicker, {
            proportion: 1,
            expand: true
        });
        if (colorComponents) this.add(colorComponents, {
            proportion: 0,
            expand: true
        });
        this.addChildrenMap("background", background);
        this.addChildrenMap("colorPicker", colorPicker);
        this.addChildrenMap("colorComponents", colorComponents);
        colorPicker.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
        if (colorComponents) colorComponents.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
        this.setValue($55dce8ca68e46ed2$var$GetValue(config, "value", 0xffffff));
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        this._value = value;
        var colorPicker = this.childrenMap.colorPicker;
        colorPicker.setValue(value);
        var colorComponents = this.childrenMap.colorComponents;
        if (colorComponents) colorComponents.setValue(value);
        this.emit("valuechange", value);
    }
    setValue(value) {
        this.value = value;
        return this;
    }
}
var $55dce8ca68e46ed2$export$2e2bcd8739ae039 = $55dce8ca68e46ed2$var$ColorPickerPanel;


const $b135439b42509140$var$GetValue = Phaser.Utils.Objects.GetValue;
var $b135439b42509140$var$CreateColorPicker = function(scene) {
    var scene = this.scene;
    var background;
    var createBackgroundCallback = this.colorPickerCreateBackgroundCallback;
    if (createBackgroundCallback) {
        background = createBackgroundCallback.call(this, scene);
        scene.add.existing(background);
    }
    var width = this.colorPickerWidth;
    if (width === undefined) width = this.width;
    var height = this.colorPickerHeight;
    if (height === undefined) height = width;
    var colorComponentsConfig;
    if (this.colorComponentsHeight > 0) colorComponentsConfig = {
        height: this.colorComponentsHeight,
        formatLabel: this.colorComponentsFormatLabelConfig,
        inputText: this.colorComponentsInputTextConfig,
        space: this.colorComponentsSpace
    };
    else colorComponentsConfig = false;
    var colorPicker = new (0, $55dce8ca68e46ed2$export$2e2bcd8739ae039)(scene, {
        width: width,
        height: height,
        background: background,
        space: this.colorPickerSpace,
        hPalette: {
            position: this.colorPickerHPalettePosition
        },
        colorComponents: colorComponentsConfig,
        value: this.value
    });
    scene.add.existing(colorPicker);
    return colorPicker;
};
var $b135439b42509140$export$2e2bcd8739ae039 = $b135439b42509140$var$CreateColorPicker;



var $ab8547d9b91bbdc3$var$OpenColorPicker = function() {
    if (this.colorPicker) return;
    // Layout it to get full height
    var colorPicker = (0, $b135439b42509140$export$2e2bcd8739ae039).call(this).layout();
    var dropDownBehavior = new (0, $6d1f09173c680891$export$2e2bcd8739ae039)(colorPicker, {
        // Transition
        duration: {
            in: this.colorPickerEaseInDuration,
            out: this.colorPickerEaseOutDuration
        },
        transitIn: this.colorPickerTransitInCallback,
        transitOut: this.colorPickerTransitOutCallback,
        // Position
        expandDirection: this.colorPickerExpandDirection,
        alignTargetX: this,
        alignTargetY: this,
        bounds: this.colorPickerBounds,
        // Close condition
        touchOutsideClose: true
    }).on("open", function() {
        // After popping up
        // Can click
        colorPicker.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
    }, this).on("close", function() {
        this.colorPicker = undefined;
        this.dropDownBehavior = undefined;
    }, this);
    this.colorPicker = colorPicker;
    this.dropDownBehavior = dropDownBehavior;
    this.pin(colorPicker);
    return this;
};
var $ab8547d9b91bbdc3$export$2e2bcd8739ae039 = $ab8547d9b91bbdc3$var$OpenColorPicker;


var $f01c999de350f6fa$var$methods = {
    openColorPicker: (0, $ab8547d9b91bbdc3$export$2e2bcd8739ae039)
};
Object.assign($f01c999de350f6fa$var$methods, (0, $e6d925b8b150c51a$export$2e2bcd8739ae039));
var $f01c999de350f6fa$export$2e2bcd8739ae039 = $f01c999de350f6fa$var$methods;



const $c737b6988cf224f7$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c737b6988cf224f7$var$ColorInput extends (0, $16f48e9989276376$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene, config);
        this.type = "rexColorInput";
        if (!config.hasOwnProperty("colorPicker")) config.colorPicker = {
            background: {
                color: 0x0
            }
        };
        var colorPickerConfig = config.colorPicker;
        var hasColorPicker = colorPickerConfig !== false && colorPickerConfig !== null;
        if (hasColorPicker) {
            this.setColorPickerSize($c737b6988cf224f7$var$GetValue(colorPickerConfig, "width", 160), $c737b6988cf224f7$var$GetValue(colorPickerConfig, "height", 170));
            var createBackgroundCallback;
            var background = $c737b6988cf224f7$var$GetValue(colorPickerConfig, "background");
            if (background) createBackgroundCallback = function(scene) {
                return (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, background);
            };
            else createBackgroundCallback = $c737b6988cf224f7$var$GetValue(colorPickerConfig, "createBackgroundCallback");
            this.setCreateColorPickerBackgroundCallback(createBackgroundCallback);
            this.setColorPickerHPalettePosition($c737b6988cf224f7$var$GetValue(colorPickerConfig, "hPalettePosition", 0));
            this.setColorPickerExpandDirection($c737b6988cf224f7$var$GetValue(colorPickerConfig, "expandDirection"));
            this.setColorPickerEaseInDuration($c737b6988cf224f7$var$GetValue(colorPickerConfig, "easeIn", 200));
            this.setColorPickerEaseOutDuration($c737b6988cf224f7$var$GetValue(colorPickerConfig, "easeOut", 200));
            this.setColorPickerTransitInCallback($c737b6988cf224f7$var$GetValue(colorPickerConfig, "transitIn"));
            this.setColorPickerTransitOutCallback($c737b6988cf224f7$var$GetValue(colorPickerConfig, "transitOut"));
            this.setColorPickerBounds($c737b6988cf224f7$var$GetValue(colorPickerConfig, "bounds"));
            var colorPickerSpaceConfig = $c737b6988cf224f7$var$GetValue(colorPickerConfig, "space");
            if (colorPickerSpaceConfig === undefined) colorPickerSpaceConfig = {
                left: 10,
                right: 10,
                top: 10,
                bottom: 10,
                item: 8
            };
            this.setColorPickerSpace(colorPickerSpaceConfig);
        }
        var colorComponentsConfig = config.colorComponents;
        var hasColorComponents = colorComponentsConfig !== false && colorComponentsConfig !== null;
        if (hasColorPicker && hasColorComponents) {
            this.setColorComponentsHeight($c737b6988cf224f7$var$GetValue(colorComponentsConfig, "height", 30));
            this.setColorComponentsFormatLabelConfig($c737b6988cf224f7$var$GetValue(colorComponentsConfig, "formatLabel"));
            var colorComponentsInputTextConfig = $c737b6988cf224f7$var$GetValue(colorComponentsConfig, "inputText");
            if (!colorComponentsInputTextConfig) colorComponentsInputTextConfig = $c737b6988cf224f7$var$GetValue(config, "inputText");
            this.setColorComponentsInputTextConfig(colorComponentsInputTextConfig);
            var colorComponentsSpace = $c737b6988cf224f7$var$GetValue(colorComponentsConfig, "space");
            if (colorComponentsSpace === undefined) colorComponentsSpace = {
                item: 8
            };
            this.setColorComponentsSpace(colorComponentsSpace);
        }
        var swatch = this.childrenMap.swatch;
        if (swatch && hasColorPicker) this.onClick(swatch, this.openColorPicker, this);
    }
}
Object.assign($c737b6988cf224f7$var$ColorInput.prototype, (0, $f01c999de350f6fa$export$2e2bcd8739ae039));
var $c737b6988cf224f7$export$2e2bcd8739ae039 = $c737b6988cf224f7$var$ColorInput;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("colorInput", function(config) {
    var gameObject = new (0, $c737b6988cf224f7$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ColorInput", (0, $c737b6988cf224f7$export$2e2bcd8739ae039));
var $2ddba7bd8a15cc23$export$2e2bcd8739ae039 = (0, $c737b6988cf224f7$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("colorInputLite", function(config) {
    var gameObject = new (0, $16f48e9989276376$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ColorInputBase", (0, $16f48e9989276376$export$2e2bcd8739ae039));
var $564bc00094b5754b$export$2e2bcd8739ae039 = (0, $16f48e9989276376$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("colorPicker", function(config) {
    var gameObject = new (0, $5104d5badb86c9b5$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ColorPicker", (0, $5104d5badb86c9b5$export$2e2bcd8739ae039));
var $135764c2927f0d2e$export$2e2bcd8739ae039 = (0, $5104d5badb86c9b5$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("colorComponents", function(config) {
    var gameObject = new (0, $b7379f9253be233e$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ColorComponents", (0, $b7379f9253be233e$export$2e2bcd8739ae039));
var $d36012a1ed6fbe3b$export$2e2bcd8739ae039 = (0, $b7379f9253be233e$export$2e2bcd8739ae039);




var $253e5bd47eaff2e2$var$GetShowCallback = function() {
    return function(child, key, sides, reset) {
        if (key !== "panel") sides.setChildVisible(child, true);
    };
};
var $253e5bd47eaff2e2$var$GetHideCallback = function() {
    return function(child, key, sides, reset) {
        if (key !== "panel") sides.setChildVisible(child, false);
    };
};
var $253e5bd47eaff2e2$export$2e2bcd8739ae039 = {
    show: $253e5bd47eaff2e2$var$GetShowCallback,
    hide: $253e5bd47eaff2e2$var$GetHideCallback
};


var $2df4deb8fb076eb9$var$GetShowCallback = function(duration, alpha) {
    if (alpha === undefined) alpha = 1;
    return function(child, key, sides, reset) {
        if (key !== "panel") sides.fadeChild(child, reset ? 0 : duration, alpha);
    };
};
var $2df4deb8fb076eb9$var$GetHideCallback = function(duration, alpha) {
    if (alpha === undefined) alpha = 0;
    return function(child, key, sides, reset) {
        if (key !== "panel") sides.fadeChild(child, reset ? 0 : duration, alpha);
    };
};
var $2df4deb8fb076eb9$export$2e2bcd8739ae039 = {
    show: $2df4deb8fb076eb9$var$GetShowCallback,
    hide: $2df4deb8fb076eb9$var$GetHideCallback
};


var $1e4939d391b442d1$var$GetCallback = function(duration, ease) {
    return function(child, key, sides, reset) {
        if (key !== "panel") sides.moveChild(child, reset ? 0 : duration, ease);
    };
};
var $1e4939d391b442d1$export$2e2bcd8739ae039 = {
    show: $1e4939d391b442d1$var$GetCallback,
    hide: $1e4939d391b442d1$var$GetCallback
};


var $95e63123efa4495d$var$GetCallback = function(duration, ease) {
    return function(child, key, sides, reset) {
        if (key === "panel") sides.moveChild(child, reset ? 0 : duration, ease);
    };
};
var $95e63123efa4495d$export$2e2bcd8739ae039 = {
    show: $95e63123efa4495d$var$GetCallback,
    hide: $95e63123efa4495d$var$GetCallback
};



const $ac73891c8615cc71$var$DefaultCallbacks = {
    visible: (0, $253e5bd47eaff2e2$export$2e2bcd8739ae039),
    fade: (0, $2df4deb8fb076eb9$export$2e2bcd8739ae039),
    move: (0, $1e4939d391b442d1$export$2e2bcd8739ae039),
    "move-panel": (0, $95e63123efa4495d$export$2e2bcd8739ae039)
};
var $ac73891c8615cc71$var$GetDefaultCallbacks = function(config) {
    var callbackType, callbackParams;
    [callbackType, ...callbackParams] = typeof config === "string" ? [
        config
    ] : config;
    var showCallback, hideCallback;
    if ($ac73891c8615cc71$var$DefaultCallbacks.hasOwnProperty(callbackType)) {
        showCallback = $ac73891c8615cc71$var$DefaultCallbacks[callbackType].show.apply(null, callbackParams);
        hideCallback = $ac73891c8615cc71$var$DefaultCallbacks[callbackType].hide.apply(null, callbackParams);
    } else {
        showCallback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
        hideCallback = (0, $990223f7da3447ad$export$2e2bcd8739ae039);
    }
    return {
        show: showCallback,
        hide: hideCallback
    };
};
var $ac73891c8615cc71$export$2e2bcd8739ae039 = $ac73891c8615cc71$var$GetDefaultCallbacks;


var $4b3339f61208da04$export$2e2bcd8739ae039 = {
    showChild (key, reset) {
        var child = this.sizerChildren[key];
        if (child) {
            this.emit("showchild", child, key, this, reset);
            this.resetChildState(child);
        }
        return this;
    },
    hideChild (key, reset) {
        var child = this.sizerChildren[key];
        if (child) {
            this.emit("hidechild", child, key, this, reset);
            this.resetChildState(child);
        }
        return this;
    },
    swapChild (key, reset) {
        if (this.currentChildKey === key) ;
        else if (this.currentChildKey === "panel" || key === "panel") {
            this.previousChildKey = this.currentChildKey;
            this.currentChildKey = key;
            this.hideChild(this.previousChildKey, reset);
            this.showChild(this.currentChildKey, reset);
        } else {
            this.swapChild("panel", reset);
            this.swapChild(key, reset);
        }
        return this;
    },
    showPanel (reset) {
        this.swapChild("panel", reset);
        return this;
    },
    showLeftSide () {
        this.swapChild("leftSide");
        return this;
    },
    showRightSide () {
        this.swapChild("rightSide");
        return this;
    },
    showTopSide () {
        this.swapChild("topSide");
        return this;
    },
    showBottomSide () {
        this.swapChild("bottomSide");
        return this;
    },
    hideLeftSide () {
        if (this.currentChildKey == "leftSide") this.showPanel();
        return this;
    },
    hideRightSide () {
        if (this.currentChildKey == "rightSide") this.showPanel();
        return this;
    },
    hideTopSide () {
        if (this.currentChildKey == "topSide") this.showPanel();
        return this;
    },
    hideBottomSide () {
        if (this.currentChildKey == "bottomSide") this.showPanel();
        return this;
    },
    toggleLeftSide () {
        var key = this.currentChildKey !== "panel" ? "panel" : "leftSide";
        this.swapChild(key);
        return this;
    },
    toggleRightSide () {
        var key = this.currentChildKey !== "panel" ? "panel" : "rightSide";
        this.swapChild(key);
        return this;
    },
    toggleTopSide () {
        var key = this.currentChildKey !== "panel" ? "panel" : "topSide";
        this.swapChild(key);
        return this;
    },
    toggleBottomSide () {
        var key = this.currentChildKey !== "panel" ? "panel" : "bottomSide";
        this.swapChild(key);
        return this;
    }
};




const $827e6a0745ca3384$var$ContainerSetChildVisible = (0, $c5e95e90a54f0634$export$2e2bcd8739ae039).prototype.setChildVisible;
var $827e6a0745ca3384$export$2e2bcd8739ae039 = {
    setChildVisible (child, visible) {
        var key;
        if (typeof child === "string") {
            var key = child;
            child = this.sizerChildren[key];
        } else key = (0, $b3508344d02c0d81$export$2e2bcd8739ae039)(this.sizerChildren, child);
        if (visible === undefined) visible = this.currentChildKey === key ? true : false;
        $827e6a0745ca3384$var$ContainerSetChildVisible.call(this, child, visible);
        return this;
    }
};




var $5903c1a303570a0b$export$2e2bcd8739ae039 = {
    fadeChild (child, duration, alpha) {
        var key1;
        if (typeof child === "string") {
            key1 = child;
            child = this.sizerChildren[key1];
        } else key1 = (0, $b3508344d02c0d81$export$2e2bcd8739ae039)(this.sizerChildren, child);
        if (duration === undefined) duration = 500;
        if (alpha === undefined) alpha = this.currentChildKey === key1 ? 1 : 0;
        child.fadeIn(duration, {
            start: child.alpha,
            end: alpha
        });
        return this;
    },
    fadeChildPromise (child, duration, alpha) {
        if (typeof child === "string") child = this.sizerChildren[key];
        this.fadeChild(child, duration, alpha);
        if (child._fade) return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(child._fade);
        else return Promise.resolve();
    }
};





var $69141fab78fa2c2e$export$2e2bcd8739ae039 = {
    moveChild (child, duration, ease, distance) {
        var key1;
        if (typeof child === "string") {
            key1 = child;
            child = this.sizerChildren[key1];
        } else key1 = (0, $b3508344d02c0d81$export$2e2bcd8739ae039)(this.sizerChildren, child);
        if (duration === undefined) duration = 500;
        var isShownChild = this.currentChildKey === key1;
        if (distance === undefined) switch(key1){
            case "leftSide":
            case "rightSide":
                distance = (0, $3d5f5580139892aa$export$a60660135e2d0135)(child);
                break;
            case "topSide":
            case "bottomSide":
                distance = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(child);
                break;
            default:
                if (isShownChild) switch(this.previousChildKey){
                    case "leftSide":
                    case "rightSide":
                        distance = (0, $3d5f5580139892aa$export$a60660135e2d0135)(this.sizerChildren[this.previousChildKey]);
                        break;
                    case "topSide":
                    case "bottomSide":
                        distance = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this.sizerChildren[this.previousChildKey]);
                        break;
                    default:
                        distance = 0;
                        break;
                }
                else switch(this.currentChildKey){
                    case "leftSide":
                    case "rightSide":
                        distance = (0, $3d5f5580139892aa$export$a60660135e2d0135)(this.sizerChildren[this.currentChildKey]);
                        break;
                    case "topSide":
                    case "bottomSide":
                        distance = (0, $3d5f5580139892aa$export$20a373b59e34b4e5)(this.sizerChildren[this.currentChildKey]);
                        break;
                    default:
                        distance = 0;
                        break;
                }
                break;
        }
        var moveLeft, moveRight, moveUp, moveDown;
        if (isShownChild) switch(key1){
            case "panel":
                switch(this.previousChildKey){
                    case "leftSide":
                        moveLeft = true;
                        break;
                    case "rightSide":
                        moveRight = true;
                        break;
                    case "topSide":
                        moveUp = true;
                        break;
                    case "bottomSide":
                        moveDown = true;
                        break;
                }
                break;
            case "leftSide":
                moveRight = true;
                break;
            case "rightSide":
                moveLeft = true;
                break;
            case "topSide":
                moveDown = true;
                break;
            case "bottomSide":
                moveUp = true;
                break;
        }
        else switch(key1){
            case "panel":
                switch(this.currentChildKey){
                    case "leftSide":
                        moveRight = true;
                        break;
                    case "rightSide":
                        moveLeft = true;
                        break;
                    case "topSide":
                        moveDown = true;
                        break;
                    case "bottomSide":
                        moveUp = true;
                        break;
                }
                break;
            case "leftSide":
                moveLeft = true;
                break;
            case "rightSide":
                moveRight = true;
                break;
            case "topSide":
                moveUp = true;
                break;
            case "bottomSide":
                moveDown = true;
                break;
        }
        if (moveLeft) child.moveTo(duration, `-=${distance}`, undefined, ease);
        else if (moveRight) child.moveTo(duration, `+=${distance}`, undefined, ease);
        else if (moveUp) child.moveTo(duration, undefined, `-=${distance}`, ease);
        else if (moveDown) child.moveTo(duration, undefined, `+=${distance}`, ease);
        else child.moveTo(0);
        return this;
    },
    moveChildPromise (child, duration, ease, distance) {
        if (typeof child === "string") child = this.sizerChildren[key];
        this.moveChild(child, duration, ease, distance);
        if (child._easeMove) return (0, $2b5b0b08519578fd$export$f539506d32c8afaa)(child._easeMove);
        else return Promise.resolve();
    }
};


var $4b235cc7c8bdda23$var$methods = {};
Object.assign($4b235cc7c8bdda23$var$methods, (0, $827e6a0745ca3384$export$2e2bcd8739ae039), (0, $5903c1a303570a0b$export$2e2bcd8739ae039), (0, $69141fab78fa2c2e$export$2e2bcd8739ae039));
var $4b235cc7c8bdda23$export$2e2bcd8739ae039 = $4b235cc7c8bdda23$var$methods;


const $c7306a22d0c38e89$var$GetValue = Phaser.Utils.Objects.GetValue;
class $c7306a22d0c38e89$var$Sides extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexSides";
        this.childrenMap = this.sizerChildren;
        this.previousChildKey = undefined;
        this.currentChildKey = undefined;
        // Callbacks
        var showChildCallback = $c7306a22d0c38e89$var$GetValue(config, "showChildCallback", undefined);
        if (showChildCallback) {
            if ((0, $761920aac251583f$export$2e2bcd8739ae039)(showChildCallback)) {
                var showChildCallbackScope = $c7306a22d0c38e89$var$GetValue(config, "showChildCallbackScope", undefined);
                this.on("showchild", showChildCallback, showChildCallbackScope);
                var hideChildCallback = $c7306a22d0c38e89$var$GetValue(config, "hideChildCallback", undefined);
                var hideChildCallbackScope = $c7306a22d0c38e89$var$GetValue(config, "hideChildCallbackScope", undefined);
                this.on("hidechild", hideChildCallback, hideChildCallbackScope);
            } else {
                var defaultCallbacks = (0, $ac73891c8615cc71$export$2e2bcd8739ae039)(showChildCallback);
                this.on("showchild", defaultCallbacks.show);
                this.on("hidechild", defaultCallbacks.hide);
            }
        }
        // Add elements
        var background = $c7306a22d0c38e89$var$GetValue(config, "background", undefined);
        var panel = $c7306a22d0c38e89$var$GetValue(config, "panel", undefined);
        var leftSide = $c7306a22d0c38e89$var$GetValue(config, "leftSide", undefined);
        var rightSide = $c7306a22d0c38e89$var$GetValue(config, "rightSide", undefined);
        var topSide = $c7306a22d0c38e89$var$GetValue(config, "topSide", undefined);
        var bottomSide = $c7306a22d0c38e89$var$GetValue(config, "bottomSide", undefined);
        if (background) this.addBackground(background);
        if (panel) this.add(panel, "panel", "center", 0, true);
        if (leftSide) {
            var expand = $c7306a22d0c38e89$var$GetValue(config, "expand.left", true);
            this.add(leftSide, "leftSide", "left-top", 0, {
                height: expand
            });
        }
        if (rightSide) {
            var expand = $c7306a22d0c38e89$var$GetValue(config, "expand.right", true);
            this.add(rightSide, "rightSide", "right-top", 0, {
                height: expand
            });
        }
        if (topSide) {
            var expand = $c7306a22d0c38e89$var$GetValue(config, "expand.top", true);
            this.add(topSide, "topSide", "left-top", 0, {
                width: expand
            });
        }
        if (bottomSide) {
            var expand = $c7306a22d0c38e89$var$GetValue(config, "expand.bottom", true);
            this.add(bottomSide, "bottomSide", "left-bottom", 0, {
                width: expand
            });
        }
    }
    reset() {
        this.previousChildKey = undefined;
        this.currentChildKey = "panel";
        this.showChild("panel", true);
        this.hideChild("leftSide", true);
        this.hideChild("rightSide", true);
        this.hideChild("topSide", true);
        this.hideChild("bottomSide", true);
        return this;
    }
}
Object.assign($c7306a22d0c38e89$var$Sides.prototype, (0, $4b3339f61208da04$export$2e2bcd8739ae039), (0, $4b235cc7c8bdda23$export$2e2bcd8739ae039));
var $c7306a22d0c38e89$export$2e2bcd8739ae039 = $c7306a22d0c38e89$var$Sides;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("sides", function(config) {
    var gameObject = new (0, $c7306a22d0c38e89$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Sides", (0, $c7306a22d0c38e89$export$2e2bcd8739ae039));
var $ed60be194bf6c53f$export$2e2bcd8739ae039 = (0, $c7306a22d0c38e89$export$2e2bcd8739ae039);






class $e155e694f82cbba6$var$Title extends (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039) {
    constructor(scene, config){
        config = (0, $07dafb4ba614c407$export$2e2bcd8739ae039)(scene, config);
        super(scene, config);
        this.type = "rexTweaker.Title";
    }
    setTitle(config) {
        config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
        if (config.hasOwnProperty("text")) ;
        else if (config.hasOwnProperty("title")) config.text = config.title;
        else config.text = "";
        this.resetDisplayContent(config);
        return this;
    }
}
var $e155e694f82cbba6$export$2e2bcd8739ae039 = $e155e694f82cbba6$var$Title;



class $ffbfc660fb6609eb$var$FolderTitle extends (0, $e155e694f82cbba6$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene, config);
        this.type = "rexTweaker.FolderTitle";
        var expandedIcon = new (0, $9e6ca4daafc103a2$export$2e2bcd8739ae039)(scene, config.expandedIcon);
        scene.add.existing(expandedIcon);
        this.addSpace().add(expandedIcon, {
            proportion: 0,
            expand: false,
            padding: 1,
            fitRatio: 1
        });
        this.addChildrenMap("expandedIcon", expandedIcon);
    }
    setExpandedState(expanded) {
        if (expanded === undefined) expanded = true;
        var direction = expanded ? "down" : "right";
        var expandedIcon = this.childrenMap.expandedIcon;
        expandedIcon.setDirection(direction);
        return this;
    }
}
var $ffbfc660fb6609eb$export$2e2bcd8739ae039 = $ffbfc660fb6609eb$var$FolderTitle;



var $d49349b6494b9d29$var$CreateTweaker = function(scene, config) {
    var tweaker = new (0, $f59d1aee9d2eac85$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(tweaker);
    return tweaker;
};
var $d49349b6494b9d29$export$2e2bcd8739ae039 = $d49349b6494b9d29$var$CreateTweaker;



var $973d693bc49d4758$var$CreateBackground = function(scene, config, style) {
    // TODO: Might create nine-slice as background
    return (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, style);
};
var $973d693bc49d4758$export$2e2bcd8739ae039 = $973d693bc49d4758$var$CreateBackground;



var $90a10b4aa12e8653$export$2e2bcd8739ae039 = {
    setBindingTarget (target) {
        var child = this.childrenMap.child; // tweaker
        child.setBindingTarget(target);
        return this;
    }
};


var $1353edecad7955f1$export$2e2bcd8739ae039 = {
    getMaxInputRowTitleWidth () {
        var child = this.childrenMap.child; // tweaker
        var titleWidth = child.getMaxInputRowTitleWidth();
        return titleWidth + this.getInnerPadding("left");
    },
    setInputRowTitleWidth (width) {
        width -= this.getInnerPadding("left");
        var child = this.childrenMap.child; // tweaker
        child.setInputRowTitleWidth(width);
        return this;
    }
};


class $5ec120feb851ace5$var$Folder extends (0, $9ce3eacedc63f086$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexTweaker.Folder";
    }
    setTitle(config) {
        var title = this.childrenMap.title;
        title.setTitle(config);
        return this;
    }
}
Object.assign($5ec120feb851ace5$var$Folder.prototype, (0, $90a10b4aa12e8653$export$2e2bcd8739ae039), (0, $1353edecad7955f1$export$2e2bcd8739ae039));
var $5ec120feb851ace5$export$2e2bcd8739ae039 = $5ec120feb851ace5$var$Folder;


const $0e1b8638e5309b07$var$GetValue = Phaser.Utils.Objects.GetValue;
var $0e1b8638e5309b07$var$CreateFolder = function(scene, config, style) {
    // Create Folder-title
    var titleStyle = $0e1b8638e5309b07$var$GetValue(style, "title") || {};
    var title = new (0, $ffbfc660fb6609eb$export$2e2bcd8739ae039)(scene, titleStyle);
    scene.add.existing(title);
    title.on("folder.expand", function() {
        title.setExpandedState(true);
    }).on("folder.collapse", function() {
        title.setExpandedState(false);
    });
    var tweakerConfig = {
        root: $0e1b8638e5309b07$var$GetValue(style, "root"),
        styles: $0e1b8638e5309b07$var$GetValue(style, "tweaker"),
        space: $0e1b8638e5309b07$var$GetValue(style, "space") || {}
    };
    var child = (0, $d49349b6494b9d29$export$2e2bcd8739ae039)(scene, tweakerConfig);
    var backgroundStyle = $0e1b8638e5309b07$var$GetValue(style, "background");
    var background = (0, $973d693bc49d4758$export$2e2bcd8739ae039)(scene, config, backgroundStyle);
    var folder = new (0, $5ec120feb851ace5$export$2e2bcd8739ae039)(scene, {
        orientation: 1,
        title: title,
        child: child,
        background: background,
        transition: {
            duration: $0e1b8638e5309b07$var$GetValue(style, "transition.duration", 200)
        }
    });
    scene.add.existing(folder);
    return folder;
};
var $0e1b8638e5309b07$export$2e2bcd8739ae039 = $0e1b8638e5309b07$var$CreateFolder;


const $2b913a94131636a2$var$GetValue = Phaser.Utils.Objects.GetValue;
var $2b913a94131636a2$var$AddFolder = function(config) {
    var scene = this.scene;
    // Create folder
    var folderStyle = $2b913a94131636a2$var$GetValue(this.styles, "folder") || {};
    folderStyle.tweaker = this.styles;
    folderStyle.root = this.root;
    var folder = (0, $0e1b8638e5309b07$export$2e2bcd8739ae039)(scene, config, folderStyle);
    delete folderStyle.tweaker;
    delete folderStyle.root;
    // Add folder
    this.add(folder, {
        expand: true
    });
    // Set content
    folder.setTitle(config);
    var expanded = $2b913a94131636a2$var$GetValue(config, "expanded", true);
    if (expanded) folder.expand(0);
    else folder.collapse(0);
    var childTweaker = folder.getElement("child");
    if (config.key) this.root.addChildrenMap(config.key, childTweaker);
    return childTweaker;
};
var $2b913a94131636a2$export$2e2bcd8739ae039 = $2b913a94131636a2$var$AddFolder;



var $e3f6327a014685c6$export$2e2bcd8739ae039 = {
    setBindingTarget (target) {
        var children = this.childrenMap.pages.children;
        for(var i = 0, cnt = children.length; i < cnt; i++)children[i].setBindingTarget(target);
        return this;
    }
};


var $581901840d08a239$export$2e2bcd8739ae039 = {
    getMaxInputRowTitleWidth () {
        var maxTitleWidth = 0;
        var children = this.childrenMap.pages.children; // tweaker array
        for(var i = 0, cnt = children.length; i < cnt; i++)maxTitleWidth = Math.max(maxTitleWidth, children[i].getMaxInputRowTitleWidth());
        return maxTitleWidth + this.getInnerPadding("left");
    },
    setInputRowTitleWidth (width) {
        width -= this.getInnerPadding("left");
        var children = this.childrenMap.pages.children; // tweaker array
        for(var i = 0, cnt = children.length; i < cnt; i++)children[i].setInputRowTitleWidth(width);
        return this;
    }
};


class $405e5c4950f8e7ec$var$TabPages extends (0, $1d165303128e7db5$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexTweaker.TabPages";
    }
}
Object.assign($405e5c4950f8e7ec$var$TabPages.prototype, (0, $e3f6327a014685c6$export$2e2bcd8739ae039), (0, $581901840d08a239$export$2e2bcd8739ae039));
var $405e5c4950f8e7ec$export$2e2bcd8739ae039 = $405e5c4950f8e7ec$var$TabPages;




const $663c90ae26805ead$var$GetValue = Phaser.Utils.Objects.GetValue;
var $663c90ae26805ead$var$CreateTab = function(scene, config, style) {
    var tabPages = new (0, $405e5c4950f8e7ec$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(tabPages);
    var tabConfig = $663c90ae26805ead$var$GetValue(style, "tab");
    var tweakerConfig = {
        root: $663c90ae26805ead$var$GetValue(style, "root"),
        styles: $663c90ae26805ead$var$GetValue(style, "tweaker")
    };
    var pages = $663c90ae26805ead$var$GetValue(config, "pages") || [];
    for(var i = 0, cnt = pages.length; i < cnt; i++){
        var page = pages[i];
        tabPages.addPage({
            key: page.title,
            tab: (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, tabConfig).setActiveState(false).resetDisplayContent({
                text: page.title
            }),
            page: (0, $d49349b6494b9d29$export$2e2bcd8739ae039)(scene, tweakerConfig)
        });
    }
    tabPages.on("tab.focus", function(tab, key) {
        tab.setActiveState(true);
    }).on("tab.blur", function(tab, key) {
        tab.setActiveState(false);
    });
    return tabPages;
};
var $663c90ae26805ead$export$2e2bcd8739ae039 = $663c90ae26805ead$var$CreateTab;


const $4d880fa434664154$var$GetValue = Phaser.Utils.Objects.GetValue;
var $4d880fa434664154$var$AddTab = function(config) {
    var scene = this.scene;
    // Create tab
    var tabStyle = $4d880fa434664154$var$GetValue(this.styles, "tab") || {};
    tabStyle.tweaker = this.styles;
    tabStyle.root = this.root;
    var tab = (0, $663c90ae26805ead$export$2e2bcd8739ae039)(scene, config, tabStyle);
    delete tabStyle.tweaker;
    delete tabStyle.root;
    // Add tab
    this.add(tab, {
        expand: true
    });
    var pagesConfig = $4d880fa434664154$var$GetValue(config, "pages") || [];
    var pages = [];
    var shownPageIndex = 0;
    for(var i = 0, cnt = pagesConfig.length; i < cnt; i++){
        var childTweaker = tab.getPage(i);
        var isPageShown = pagesConfig[i].show;
        if (isPageShown) shownPageIndex = i;
        var key = pagesConfig[i].key;
        if (key) this.root.addChildrenMap(key, childTweaker);
        pages.push(childTweaker);
    }
    tab.swapPage(shownPageIndex, 0);
    return pages;
};
var $4d880fa434664154$export$2e2bcd8739ae039 = $4d880fa434664154$var$AddTab;


const $34be0bbd0f577887$export$2b93044cbf134323 = "string";
const $34be0bbd0f577887$export$86a7aca748b1e260 = "number";
const $34be0bbd0f577887$export$2ede450fbdbb4e4c = "range";
const $34be0bbd0f577887$export$3a2ac008cc5f4d18 = "list";
const $34be0bbd0f577887$export$33549a8289695320 = "buttons";
const $34be0bbd0f577887$export$240f7fffab1b25a0 = "boolean";
const $34be0bbd0f577887$export$4200df568ed0d32c = "toggleSwitch";
const $34be0bbd0f577887$export$2cd82751acc0e609 = "color";


var $331608946855c0eb$var$GetInputType = function(object, key, config) {
    // Force input type to view
    if (config.view) return config.view;
    if (config.options) return 0, $34be0bbd0f577887$export$3a2ac008cc5f4d18;
    if (!object) return 0, $34be0bbd0f577887$export$2b93044cbf134323;
    var value = object[key];
    switch(typeof value){
        case "number":
            if ($331608946855c0eb$var$HasProperties(config, "min", "max")) return 0, $34be0bbd0f577887$export$2ede450fbdbb4e4c;
            return 0, $34be0bbd0f577887$export$86a7aca748b1e260;
        case "string":
            return 0, $34be0bbd0f577887$export$2b93044cbf134323;
        case "boolean":
            return 0, $34be0bbd0f577887$export$240f7fffab1b25a0;
        default:
            return 0, $34be0bbd0f577887$export$2b93044cbf134323;
    }
};
var $331608946855c0eb$var$HasProperties = function(object, ...keys) {
    for(var i = 0, cnt = keys.length; i < cnt; i++){
        if (object[keys[i]] === undefined) return false;
    }
    return true;
};
var $331608946855c0eb$export$2e2bcd8739ae039 = $331608946855c0eb$var$GetInputType;



var $01fa046001edf27a$export$2e2bcd8739ae039 = {
    setupBinding () {
        var inputField = this.childrenMap.inputField;
        inputField// Set text value to object when closing editor
        .on("valuechange", function(value) {
            if (!this.bindingTarget || !this.autoUpdateEnable) return;
            this.bindingTarget[this.bindTargetKey] = value;
        }, this);
        return this;
    },
    setAutoUpdateEnable (enable) {
        if (enable === undefined) enable = true;
        this.autoUpdateEnable = enable;
        return this;
    },
    setBindingTarget (target, key) {
        this.bindingTarget = target;
        if (key !== undefined) this.setBindingTargetKey(key);
        this.syncTargetValue();
        return this;
    },
    setBindingTargetKey (key) {
        this.bindTargetKey = key;
        return this;
    },
    syncTargetValue () {
        if (!this.bindingTarget || !this.bindTargetKey) return this;
        var inputField = this.childrenMap.inputField;
        inputField.syncValue(this.bindingTarget[this.bindTargetKey]);
        return this;
    }
};


var $437373b5f069987b$export$2e2bcd8739ae039 = {
    startMonitorTarget () {
        if (this.isMonitoring) return this;
        this.isMonitoring = true;
        this.scene.events.on("postupdate", this.onMonitorTarget, this);
        return this;
    },
    stopMonitorTarget () {
        if (!this.isMonitoring) return this;
        this.isMonitoring = false;
        this.scene.events.off("postupdate", this.onMonitorTarget, this);
        return this;
    },
    onMonitorTarget () {
        if (!this.bindingTarget) return;
        var newValue = this.bindingTarget[this.bindTargetKey];
        var inputField = this.childrenMap.inputField;
        if (inputField.value === newValue) return;
        // Sync new value
        inputField.syncValue(newValue);
    }
};


var $3ee8d4b0062f3715$export$2e2bcd8739ae039 = {
    getMinTitleWidth () {
        var title = this.childrenMap.title;
        if (!title) return 0;
        var padding = title.rexSizer.padding;
        var titleWidth = this.getChildWidth(this.childrenMap.title) + padding.left + padding.right;
        return titleWidth + this.getInnerPadding("left");
    },
    setMinTitleWidth (width) {
        var title = this.childrenMap.title;
        if (!title) return this;
        var padding = title.rexSizer.padding;
        width -= padding.left + padding.right;
        title.minWidth = width;
        return this;
    }
};


const $d89f0adaab90d3d6$var$GetValue = Phaser.Utils.Objects.GetValue;
class $d89f0adaab90d3d6$var$InputRow extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        super(scene, config);
        this.type = "rexTweaker.InputRow";
        this.bindingTarget = undefined;
        this.bindTargetKey = undefined;
        this.autoUpdateEnable = true;
        var inputTitle = config.inputTitle;
        var inputField = config.inputField;
        var background = config.background;
        var proportion = $d89f0adaab90d3d6$var$GetValue(config, "proportion.title", 0);
        var titleSpace = $d89f0adaab90d3d6$var$GetValue(config, "space.title", 0);
        var padding;
        if (this.orientation === 0) padding = {
            right: titleSpace
        };
        else padding = {
            bottom: titleSpace
        };
        this.add(inputTitle, {
            proportion: proportion,
            expand: true,
            padding: padding
        });
        var defaultProportion = config.parentOrientation === 1 ? 1 : 0;
        var proportion = $d89f0adaab90d3d6$var$GetValue(config, "proportion.inputField", defaultProportion);
        this.add(inputField, {
            proportion: proportion,
            expand: true
        });
        if (background) this.addBackground(background);
        this.addChildrenMap("title", inputTitle);
        this.addChildrenMap("inputField", inputField);
        this.addChildrenMap("background", background);
        this.setupBinding();
    }
    destroy(fromScene) {
        //  This Game Object has already been destroyed
        if (!this.scene) return;
        this.stopMonitorTarget();
        super.destroy(fromScene);
    }
    setTitle(config) {
        var title = this.childrenMap.title;
        title.setTitle(config);
        return this;
    }
    preLayout() {
        var title = this.childrenMap.title;
        if (title) title.minWidth = 0;
        super.preLayout();
    }
}
Object.assign($d89f0adaab90d3d6$var$InputRow.prototype, (0, $01fa046001edf27a$export$2e2bcd8739ae039), (0, $437373b5f069987b$export$2e2bcd8739ae039), (0, $3ee8d4b0062f3715$export$2e2bcd8739ae039));
var $d89f0adaab90d3d6$export$2e2bcd8739ae039 = $d89f0adaab90d3d6$var$InputRow;




var $835c77a0f7e87a65$var$CreateTitleLabel = function(scene, config, style) {
    var gameObject = new (0, $e155e694f82cbba6$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    return gameObject;
};
var $835c77a0f7e87a65$export$2e2bcd8739ae039 = $835c77a0f7e87a65$var$CreateTitleLabel;




class $6d5aca34e4e6073f$var$InputFiledBase extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    get bindingTarget() {
        return this.getParentSizer().bindingTarget;
    }
    get bindingKey() {
        return this.getParentSizer().bindTargetKey;
    }
    get value() {
        return this._value;
    }
    validate(newValue) {
        if (this.syncValueFlag || !this.validateCallback) return true;
        return this.validateCallback(newValue, this._value, this.bindingTarget, this.bindingKey);
    }
    // Override
    set value(value) {
        if (this._value === value) return;
        var oldValue = this._value;
        this._value = value;
        if (!this.syncValueFlag) this.emit("valuechange", value, oldValue, this.bindingTarget, this.bindingKey);
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    /* 
    Internal method invoked when 
    - inputRow.setBindingTarget(target), or 
    - inputRow.syncTargetValue()
    */ syncValue(value) {
        this.syncValueFlag = true;
        this.value = value;
        this.syncValueFlag = false;
        return this;
    }
    // Override
    get readOnly() {
        return this._readOnly;
    }
    // Override
    set readOnly(value) {
        this._readOnly = value;
    }
    setReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.readOnly = enable;
        return true;
    }
    setTextFormatCallback(callback) {
        this.textFormatCallback = callback;
        return this;
    }
    setValidateCallback(callback) {
        this.validateCallback = callback;
        return this;
    }
}
var $6d5aca34e4e6073f$export$2e2bcd8739ae039 = $6d5aca34e4e6073f$var$InputFiledBase;



class $b6394907a9caeb85$var$TextInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.TextInput";
        var inputTextConfig = config.inputText;
        var inputText = (0, $1491b3a644681e30$export$2e2bcd8739ae039)(scene, inputTextConfig);
        this.add(inputText, {
            proportion: 1,
            expand: true
        });
        this.addChildrenMap("inputText", inputText);
        inputText.on("close", function() {
            this.setValue(inputText.value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        var text = this.textFormatCallback ? this.textFormatCallback(value) : value;
        this.childrenMap.inputText.setText(text);
        super.value = value; // Fire 'valuechange' event
    }
    setInputTextReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.childrenMap.inputText.setReadOnly(enable);
        return this;
    }
}
var $b6394907a9caeb85$export$2e2bcd8739ae039 = $b6394907a9caeb85$var$TextInput;


var $a05f33b4c491eaab$var$CreateTextInput = function(scene, config, style) {
    var gameObject = new (0, $b6394907a9caeb85$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    gameObject.setInputTextReadOnly(!!config.inputTextReadOnly);
    return gameObject;
};
var $a05f33b4c491eaab$export$2e2bcd8739ae039 = $a05f33b4c491eaab$var$CreateTextInput;




class $00a4131d578e9c5d$var$NumberInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.NumberInput";
        var inputTextConfig = config.inputNumber || config.inputText;
        var inputText = (0, $1491b3a644681e30$export$2e2bcd8739ae039)(scene, inputTextConfig).setNumberInput();
        this.add(inputText, {
            proportion: 1,
            expand: true
        });
        this.addChildrenMap("inputText", inputText);
        inputText.on("close", function() {
            this.setValue(inputText.value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        var text = this.textFormatCallback ? this.textFormatCallback(value) : value;
        this.childrenMap.inputText.setText(text);
        super.value = value; // Fire 'valuechange' event
    }
    setInputTextReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.childrenMap.inputText.setReadOnly(enable);
        return this;
    }
}
var $00a4131d578e9c5d$export$2e2bcd8739ae039 = $00a4131d578e9c5d$var$NumberInput;


var $ca11307674d2d22a$var$CreateNumberInput = function(scene, config, style) {
    var gameObject = new (0, $00a4131d578e9c5d$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    gameObject.setInputTextReadOnly(!!config.inputTextReadOnly);
    return gameObject;
};
var $ca11307674d2d22a$export$2e2bcd8739ae039 = $ca11307674d2d22a$var$CreateNumberInput;




var $5badf41e3fc6b5de$var$CreateSlider = function(scene, config) {
    var gameObject = new (0, $acd4b431e3164bd7$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $5badf41e3fc6b5de$export$2e2bcd8739ae039 = $5badf41e3fc6b5de$var$CreateSlider;



const $bafbed65470e2132$var$GetValue = Phaser.Utils.Objects.GetValue;
const $bafbed65470e2132$var$Linear = Phaser.Math.Linear;
const $bafbed65470e2132$var$SnapFloor = Phaser.Math.Snap.Floor;
class $bafbed65470e2132$var$RangeInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.RangeInput";
        var sliderConfig = config.slider;
        var trackSizeKey = this.orientation === 0 ? "track.height" : "track.width";
        var trackSize = $bafbed65470e2132$var$GetValue(sliderConfig, trackSizeKey);
        var slider = (0, $5badf41e3fc6b5de$export$2e2bcd8739ae039)(scene, sliderConfig);
        var defaultProportion = config.parentOrientation === 1 ? 2 : 0;
        var proportion = $bafbed65470e2132$var$GetValue(config, "proportion.range.slider", defaultProportion);
        var expand = trackSize === undefined;
        this.add(slider, {
            proportion: proportion,
            expand: expand
        });
        var inputTextConfig = config.inputNumber || config.inputText;
        var inputText = (0, $1491b3a644681e30$export$2e2bcd8739ae039)(scene, inputTextConfig).setNumberInput();
        var defaultProportion = config.parentOrientation === 1 ? 1 : 0;
        var proportion = $bafbed65470e2132$var$GetValue(config, "proportion.range.inputText", defaultProportion);
        this.add(inputText, {
            proportion: proportion,
            expand: true
        });
        this.addChildrenMap("slider", slider);
        this.addChildrenMap("inputText", inputText);
        inputText.on("close", function() {
            this.setValue(inputText.value);
        }, this);
        slider.on("valuechange", function() {
            var value = $bafbed65470e2132$var$Linear(this.minValue, this.maxValue, slider.value);
            if (this.step) value = $bafbed65470e2132$var$SnapFloor(value, this.step, this.minValue);
            this.setValue(value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        var text = this.textFormatCallback ? this.textFormatCallback(value) : value;
        this.childrenMap.inputText.setText("").setText(text);
        this.childrenMap.slider.setValue(value, this.minValue, this.maxValue);
        super.value = value; // Fire 'valuechange' event
    }
    setRange(min, max, step) {
        this.minValue = min;
        this.maxValue = max;
        this.step = step;
        this.childrenMap.slider.setGap(step, min, max);
        return this;
    }
    setInputTextReadOnly(enable) {
        if (enable === undefined) enable = true;
        this.childrenMap.inputText.setReadOnly(enable);
        return this;
    }
}
var $bafbed65470e2132$export$2e2bcd8739ae039 = $bafbed65470e2132$var$RangeInput;


var $999798e1f028d7d5$var$CreateRangeInput = function(scene, config, style) {
    var gameObject = new (0, $bafbed65470e2132$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    gameObject.setRange(config.min, config.max, config.step);
    gameObject.setInputTextReadOnly(!!config.inputTextReadOnly);
    return gameObject;
};
var $999798e1f028d7d5$export$2e2bcd8739ae039 = $999798e1f028d7d5$var$CreateRangeInput;





var $c19a751a28f3ef93$var$CreateDropDownList = function(scene, config) {
    config = (0, $a85d756d8bc2f834$export$2e2bcd8739ae039)(scene, config);
    var gameObject = new (0, $c354e056ec3b0874$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $c19a751a28f3ef93$export$2e2bcd8739ae039 = $c19a751a28f3ef93$var$CreateDropDownList;


var $402fe549a75c8716$export$fc1c04e591239fcb = function(options, value) {
    for(var i = 0, cnt = options.length; i < cnt; i++){
        var option = options[i];
        if (option.value === value) return i;
    }
    return undefined;
};
var $402fe549a75c8716$export$ab3ff1ea2e9d4ea = function(options, value) {
    var index = $402fe549a75c8716$export$fc1c04e591239fcb(options, value);
    if (index == null) return undefined;
    return options[index].text;
};


class $9f741c1407269770$var$ListInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.ListInput";
        var list = (0, $c19a751a28f3ef93$export$2e2bcd8739ae039)(scene, config.list);
        this.add(list, {
            proportion: 1,
            expand: true
        });
        this.addChildrenMap("list", list);
        list.on("button.click", function(dropDownList, listPanel, button, index, pointer, event) {
            this.setValue(button.value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        var list = this.childrenMap.list;
        var text = (0, $402fe549a75c8716$export$ab3ff1ea2e9d4ea)(list.options, value);
        list.resetDisplayContent({
            text: text
        });
        super.value = value; // Fire 'valuechange' event
    }
    setOptions(options) {
        this.childrenMap.list.setOptions(options);
        return this;
    }
}
var $9f741c1407269770$export$2e2bcd8739ae039 = $9f741c1407269770$var$ListInput;


var $36d52337dbaedca6$var$CreateListInput = function(scene, config, style) {
    var gameObject = new (0, $9f741c1407269770$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    gameObject.setOptions(config.options);
    return gameObject;
};
var $36d52337dbaedca6$export$2e2bcd8739ae039 = $36d52337dbaedca6$var$CreateListInput;




var $a92d53665b12314d$var$CreateButtons = function(scene, config) {
    var gameObject = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $a92d53665b12314d$export$2e2bcd8739ae039 = $a92d53665b12314d$var$CreateButtons;





var $a4f4b549ff4b34fd$var$SetButtonsActiveStateByIndex = function(buttons, index) {
    for(var i = 0, cnt = buttons.length; i < cnt; i++){
        var button = buttons[i];
        if (!button) continue;
        button.setActiveState(i === index);
    }
};
var $a4f4b549ff4b34fd$export$2e2bcd8739ae039 = $a4f4b549ff4b34fd$var$SetButtonsActiveStateByIndex;


const $571ea12420fcc358$var$GetValue = Phaser.Utils.Objects.GetValue;
class $571ea12420fcc358$var$ButtonsInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.ButtonsInput";
        var buttonConfig = config.button ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config.button) : {};
        var buttonExpand = $571ea12420fcc358$var$GetValue(buttonConfig, "expand", true);
        if (buttonExpand) buttonConfig.align = "center";
        delete buttonConfig.expand;
        var list = (0, $a92d53665b12314d$export$2e2bcd8739ae039)(scene, {
            expand: buttonExpand
        });
        list.buttonConfig = buttonConfig;
        this.add(list, {
            proportion: 1,
            expand: true
        });
        this.addChildrenMap("list", list);
        list.on("button.click", function(button, index, pointer, event) {
            var option = list.options[index];
            if (!option) return; // ??
            this._selectedIndex = index;
            this.setValue(option.value);
            this._selectedIndex = undefined;
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        var list = this.childrenMap.list;
        var index = this._selectedIndex; // See list's 'button.click' event
        if (index === undefined) index = (0, $402fe549a75c8716$export$fc1c04e591239fcb)(list.options, value);
        (0, $a4f4b549ff4b34fd$export$2e2bcd8739ae039)(list.childrenMap.buttons, index);
        super.value = value; // Fire 'valuechange' event
    }
    setOptions(options) {
        var list = this.childrenMap.list;
        list.options = options;
        var scene = this.scene;
        var buttonConfig = list.buttonConfig;
        list.clearButtons(true);
        for(var i = 0, cnt = options.length; i < cnt; i++){
            var option = options[i];
            var button = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, buttonConfig).setActiveState(false).resetDisplayContent({
                text: option.text
            });
            list.addButton(button);
        }
        return this;
    }
}
var $571ea12420fcc358$export$2e2bcd8739ae039 = $571ea12420fcc358$var$ButtonsInput;


var $f4ac8fc841c567f3$var$CreateButtonsInput = function(scene, config, style) {
    var gameObject = new (0, $571ea12420fcc358$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    gameObject.setOptions(config.options);
    return gameObject;
};
var $f4ac8fc841c567f3$export$2e2bcd8739ae039 = $f4ac8fc841c567f3$var$CreateButtonsInput;




var $14fb3b01703ed4c5$var$CreateCheckbox = function(scene, config) {
    var gameObject = new (0, $80b01800e6b54880$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $14fb3b01703ed4c5$export$2e2bcd8739ae039 = $14fb3b01703ed4c5$var$CreateCheckbox;


const $ac9b294bb648e25f$var$GetValue = Phaser.Utils.Objects.GetValue;
class $ac9b294bb648e25f$var$CheckboxInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.CheckboxInput";
        var checkboxConfig = config.checkbox;
        var checkbox = (0, $14fb3b01703ed4c5$export$2e2bcd8739ae039)(scene, checkboxConfig);
        var size = $ac9b294bb648e25f$var$GetValue(checkboxConfig, "size");
        if (size !== undefined) checkbox.setSize(size, size);
        var fitRatio = size !== undefined ? 0 : 1;
        this.add(checkbox, {
            proportion: 0,
            expand: false,
            fitRatio: fitRatio
        });
        this.addChildrenMap("checkbox", checkbox);
        checkbox.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        this.childrenMap.checkbox.setValue(value);
        super.value = value; // Fire 'valuechange' event
    }
}
var $ac9b294bb648e25f$export$2e2bcd8739ae039 = $ac9b294bb648e25f$var$CheckboxInput;


var $cc0cfd2e370d266a$var$CreateCheckboxInput = function(scene, config, style) {
    var gameObject = new (0, $ac9b294bb648e25f$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    return gameObject;
};
var $cc0cfd2e370d266a$export$2e2bcd8739ae039 = $cc0cfd2e370d266a$var$CreateCheckboxInput;




var $3444e94fb13a2810$var$CreateToggleSwitch = function(scene, config) {
    var gameObject = new (0, $ec6363d3c943d949$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $3444e94fb13a2810$export$2e2bcd8739ae039 = $3444e94fb13a2810$var$CreateToggleSwitch;


const $4d2c63f3d0afa7bc$var$GetValue = Phaser.Utils.Objects.GetValue;
class $4d2c63f3d0afa7bc$var$ToggleSwitchInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.ToggleSwitchInput";
        var toggleSwitchConfig = config.toggleSwitch;
        var toggleSwitch = (0, $3444e94fb13a2810$export$2e2bcd8739ae039)(scene, toggleSwitchConfig);
        var size = $4d2c63f3d0afa7bc$var$GetValue(toggleSwitchConfig, "size");
        if (size !== undefined) toggleSwitch.setSize(size, size);
        var fitRatio = size !== undefined ? 0 : 1;
        this.addSpace().add(toggleSwitch, {
            proportion: 0,
            expand: false,
            fitRatio: fitRatio
        });
        this.addChildrenMap("toggleSwitch", toggleSwitch);
        toggleSwitch.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        this.childrenMap.toggleSwitch.setValue(value);
        super.value = value; // Fire 'valuechange' event
    }
}
var $4d2c63f3d0afa7bc$export$2e2bcd8739ae039 = $4d2c63f3d0afa7bc$var$ToggleSwitchInput;


var $c696971ccf44d57e$var$CreateToggleSwitchInput = function(scene, config, style) {
    var gameObject = new (0, $4d2c63f3d0afa7bc$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    return gameObject;
};
var $c696971ccf44d57e$export$2e2bcd8739ae039 = $c696971ccf44d57e$var$CreateToggleSwitchInput;





var $a971488d12334d7c$var$CreateColorInput = function(scene, config, deepCloneConfig) {
    if (deepCloneConfig === undefined) deepCloneConfig = true;
    if (deepCloneConfig) config = config ? (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(config) : {};
    else if (!config) config = {};
    var inputText = new (0, $c737b6988cf224f7$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(inputText);
    return inputText;
};
var $a971488d12334d7c$export$2e2bcd8739ae039 = $a971488d12334d7c$var$CreateColorInput;


class $f876e35281820596$var$ColorInput extends (0, $6d5aca34e4e6073f$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        super(scene);
        this.type = "rexTweaker.ColorInput";
        var colorInputConfig = config.colorInput;
        var colorInput = (0, $a971488d12334d7c$export$2e2bcd8739ae039)(scene, colorInputConfig);
        this.add(colorInput, {
            proportion: 1,
            expand: true
        });
        this.addChildrenMap("colorInput", colorInput);
        colorInput.on("valuechange", function(value) {
            this.setValue(value);
        }, this);
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        if (!this.validate(value)) value = this._value; // Back to previous value
        this.childrenMap.colorInput.setValue(value);
        super.value = value; // Fire 'valuechange' event
    }
}
var $f876e35281820596$export$2e2bcd8739ae039 = $f876e35281820596$var$ColorInput;


var $8eb9571e011f511f$var$CreateColorInput = function(scene, config, style) {
    var gameObject = new (0, $f876e35281820596$export$2e2bcd8739ae039)(scene, style);
    scene.add.existing(gameObject);
    return gameObject;
};
var $8eb9571e011f511f$export$2e2bcd8739ae039 = $8eb9571e011f511f$var$CreateColorInput;



var $60f7635e1d1ce45e$var$CreateInputField = function(scene, config, style) {
    var viewType = config.view;
    var callback;
    switch(viewType){
        case 0, $34be0bbd0f577887$export$2b93044cbf134323:
            callback = (0, $a05f33b4c491eaab$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$86a7aca748b1e260:
            callback = (0, $ca11307674d2d22a$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$2ede450fbdbb4e4c:
            callback = (0, $999798e1f028d7d5$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$3a2ac008cc5f4d18:
            callback = (0, $36d52337dbaedca6$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$33549a8289695320:
            callback = (0, $f4ac8fc841c567f3$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$240f7fffab1b25a0:
            callback = (0, $cc0cfd2e370d266a$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$4200df568ed0d32c:
            callback = (0, $c696971ccf44d57e$export$2e2bcd8739ae039);
            break;
        case 0, $34be0bbd0f577887$export$2cd82751acc0e609:
            callback = (0, $8eb9571e011f511f$export$2e2bcd8739ae039);
            break;
        default:
            callback = (0, $761920aac251583f$export$2e2bcd8739ae039)(viewType) ? viewType : (0, $a05f33b4c491eaab$export$2e2bcd8739ae039);
            break;
    }
    var gameObject = callback(scene, config, style, gameObject);
    // Extra settings
    gameObject.setTextFormatCallback(config.format);
    return gameObject;
};
var $60f7635e1d1ce45e$export$2e2bcd8739ae039 = $60f7635e1d1ce45e$var$CreateInputField;


const $8bb7d41930ecf6da$var$GetValue = Phaser.Utils.Objects.GetValue;
var $8bb7d41930ecf6da$var$CreateInputRow = function(scene, config, style) {
    // Title
    var titleStyle = $8bb7d41930ecf6da$var$GetValue(style, "title") || {};
    var inputTitle = (0, $835c77a0f7e87a65$export$2e2bcd8739ae039)(scene, config, titleStyle);
    // InputField
    var inputField = (0, $60f7635e1d1ce45e$export$2e2bcd8739ae039)(scene, config, style);
    // Background
    var backgroundStyle = $8bb7d41930ecf6da$var$GetValue(style, "background") || {};
    var background = (0, $855a17c75ce39274$export$2e2bcd8739ae039)(scene, backgroundStyle);
    var inputRow = new (0, $d89f0adaab90d3d6$export$2e2bcd8739ae039)(scene, {
        ...config,
        ...style,
        inputTitle: inputTitle,
        inputField: inputField,
        background: background
    });
    scene.add.existing(inputRow);
    inputRow.setTitle(config);
    return inputRow;
};
var $8bb7d41930ecf6da$export$2e2bcd8739ae039 = $8bb7d41930ecf6da$var$CreateInputRow;


const $2299c17d1ef68b3a$var$GetValue = Phaser.Utils.Objects.GetValue;
var $2299c17d1ef68b3a$var$AddInput = function(object, key, config) {
    if (arguments.length === 1) {
        config = object;
        object = config.bindingTarget;
        key = config.bindingKey;
    } else if (config === undefined) config = {};
    if (!config.title) config.title = key;
    if (!config.view) config.view = (0, $331608946855c0eb$export$2e2bcd8739ae039)(object, key, config);
    // Create InputRow
    var inputRowStyle = this.styles.inputRow || {};
    inputRowStyle.parentOrientation = this.styles.orientation;
    var inputSizer = (0, $8bb7d41930ecf6da$export$2e2bcd8739ae039)(this.scene, config, inputRowStyle);
    var inputField = inputSizer.childrenMap.inputField;
    var proportion;
    if (this.orientation === 1) proportion = 0;
    else {
        proportion = this.itemWidth > 0 ? 0 : 1;
        inputSizer.setMinWidth(this.itemWidth);
    }
    // Add InputRow to Tweaker
    this.add(inputSizer, {
        proportion: proportion,
        expand: true
    });
    if (config.onValueChange) inputField.on("valuechange", config.onValueChange);
    if (config.onValidate) inputField.setValidateCallback(config.onValidate);
    // Bind target
    inputSizer.setAutoUpdateEnable(config.autoUpdate);
    inputSizer.setBindingTarget(object, key);
    if (config.monitor) inputSizer.startMonitorTarget();
    if (config.key) this.root.addChildrenMap(config.key, inputSizer);
    return this;
};
var $2299c17d1ef68b3a$export$2e2bcd8739ae039 = $2299c17d1ef68b3a$var$AddInput;



var $5ec6fd658aa8b31d$var$CreateRoundRectangle = function(scene, config) {
    var gameObject = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(scene, config);
    scene.add.existing(gameObject);
    return gameObject;
};
var $5ec6fd658aa8b31d$export$2e2bcd8739ae039 = $5ec6fd658aa8b31d$var$CreateRoundRectangle;






const $73d2129b36024239$var$GetValue = Phaser.Utils.Objects.GetValue;
var $73d2129b36024239$var$CreateButtons = function(scene, config, style) {
    // Title
    var titleStyle = $73d2129b36024239$var$GetValue(style, "title") || {};
    var title = (0, $835c77a0f7e87a65$export$2e2bcd8739ae039)(scene, config, titleStyle);
    // Buttons
    var buttonsConfig = config.buttons;
    var buttonStyle = $73d2129b36024239$var$GetValue(style, "button") || {};
    var buttons = [];
    for(var i = 0, cnt = buttonsConfig.length; i < cnt; i++){
        var button = (0, $06c7e7c2354ea840$export$2e2bcd8739ae039)(scene, buttonStyle);
        buttons.push(button);
        var buttonConfig = buttonsConfig[i];
        button.resetDisplayContent({
            text: buttonConfig.label
        });
        button.callback = buttonConfig.callback;
    }
    var buttonsSizer = (0, $a92d53665b12314d$export$2e2bcd8739ae039)(scene, {
        buttons: buttons,
        expand: buttons.length === 1
    });
    // Background
    var backgroundStyle = $73d2129b36024239$var$GetValue(style, "background") || {};
    var background = (0, $5ec6fd658aa8b31d$export$2e2bcd8739ae039)(scene, backgroundStyle);
    // InputRow
    var inputRow = new (0, $d89f0adaab90d3d6$export$2e2bcd8739ae039)(scene, {
        ...style,
        inputTitle: title,
        inputField: buttonsSizer,
        background: background
    });
    scene.add.existing(inputRow);
    inputRow.setTitle(config);
    buttonsSizer.on("button.click", function(button) {
        button.callback(inputRow.bindingTarget);
    });
    return inputRow;
};
var $73d2129b36024239$export$2e2bcd8739ae039 = $73d2129b36024239$var$CreateButtons;


const $1ce042fdc4e835da$var$GetValue = Phaser.Utils.Objects.GetValue;
var $1ce042fdc4e835da$var$AddButtons = function(config) {
    var scene = this.scene;
    if (config === undefined) config = {};
    if (config.hasOwnProperty("label")) {
        config.buttons = [
            {
                label: config.label,
                callback: config.callback
            }
        ];
        delete config.label;
        delete config.callback;
    }
    var target = config.bindingTarget;
    delete config.bindingTarget;
    // Create buttons
    var buttonsStyle = $1ce042fdc4e835da$var$GetValue(this.styles, "inputRow") || {};
    var buttons = (0, $73d2129b36024239$export$2e2bcd8739ae039)(scene, config, buttonsStyle);
    // Add buttons
    this.add(buttons, {
        expand: true
    });
    // Set binding target
    if (target) buttons.setBindingTarget(target);
    if (config.key) this.root.addChildrenMap(config.key, buttons);
    return this;
};
var $1ce042fdc4e835da$export$2e2bcd8739ae039 = $1ce042fdc4e835da$var$AddButtons;



const $df76e93611f64066$var$GetValue = Phaser.Utils.Objects.GetValue;
var $df76e93611f64066$var$AddSeparator = function(config) {
    var scene = this.scene;
    // Create separator
    var separatorStyle = $df76e93611f64066$var$GetValue(this.styles, "separator");
    var separator = (0, $973d693bc49d4758$export$2e2bcd8739ae039)(scene, config, separatorStyle);
    // Add separator
    this.add(separator, {
        expand: true
    });
    return this;
};
var $df76e93611f64066$export$2e2bcd8739ae039 = $df76e93611f64066$var$AddSeparator;


var $33789a45b14e761a$var$SetBindingTarget = function(target) {
    var children = this.sizerChildren;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (!child.setBindingTarget) continue;
        child.setBindingTarget(target);
    }
    return this;
};
var $33789a45b14e761a$export$2e2bcd8739ae039 = $33789a45b14e761a$var$SetBindingTarget;


var $558a6027e32131af$var$GetMaxInputRowTitleWidth = function() {
    var maxTitleWidth = 0;
    var children = this.sizerChildren;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.rexSizer.hidden) continue;
        if (child.getMinTitleWidth) maxTitleWidth = Math.max(maxTitleWidth, child.getMinTitleWidth());
        else if (child.getMaxInputRowTitleWidth) maxTitleWidth = Math.max(maxTitleWidth, child.getMaxInputRowTitleWidth());
    }
    return maxTitleWidth + this.getInnerPadding("left");
};
var $558a6027e32131af$export$2e2bcd8739ae039 = $558a6027e32131af$var$GetMaxInputRowTitleWidth;


var $f504ccfd5ab8ad27$var$SetInputRowTitleWidth = function(width) {
    width -= this.getInnerPadding("left");
    var children = this.sizerChildren;
    for(var i = 0, cnt = children.length; i < cnt; i++){
        var child = children[i];
        if (child.rexSizer.hidden) continue;
        if (child.setMinTitleWidth) child.setMinTitleWidth(width);
        else if (child.setInputRowTitleWidth) child.setInputRowTitleWidth(width);
    }
    return this;
};
var $f504ccfd5ab8ad27$export$2e2bcd8739ae039 = $f504ccfd5ab8ad27$var$SetInputRowTitleWidth;


var $dce809031bba1318$var$methods = {
    addFolder: (0, $2b913a94131636a2$export$2e2bcd8739ae039),
    addTab: (0, $4d880fa434664154$export$2e2bcd8739ae039),
    addInput: (0, $2299c17d1ef68b3a$export$2e2bcd8739ae039),
    addButton: (0, $1ce042fdc4e835da$export$2e2bcd8739ae039),
    addButtons: (0, $1ce042fdc4e835da$export$2e2bcd8739ae039),
    addSeparator: (0, $df76e93611f64066$export$2e2bcd8739ae039),
    setBindingTarget: (0, $33789a45b14e761a$export$2e2bcd8739ae039),
    getMaxInputRowTitleWidth: (0, $558a6027e32131af$export$2e2bcd8739ae039),
    setInputRowTitleWidth: (0, $f504ccfd5ab8ad27$export$2e2bcd8739ae039)
};
var $dce809031bba1318$export$2e2bcd8739ae039 = $dce809031bba1318$var$methods;




const $f59d1aee9d2eac85$var$GetValue = Phaser.Utils.Objects.GetValue;
class $f59d1aee9d2eac85$var$TweakerShell extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        if (config.orientation === undefined) config.orientation = 1;
        // Create sizer
        super(scene, config);
        this.type = "rexTweakerShell";
        this.root = config.root || this;
        this.styles = $f59d1aee9d2eac85$var$GetValue(config, "styles") || {};
        this.styles.orientation = this.orientation;
        this.itemWidth = $f59d1aee9d2eac85$var$GetValue(this.styles, "itemWidth", 0);
        if (this.root === this && this.orientation === 1) {
            var alignTitle = $f59d1aee9d2eac85$var$GetValue(config, "inputRow.alignTitle");
            if (alignTitle === undefined) {
                var titleProportion = $f59d1aee9d2eac85$var$GetValue(this.styles, "inputRow.proportion.title");
                alignTitle = !titleProportion;
            } else if (alignTitle) (0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(this.styles, "inputRow.proportion.title", 0);
            this.alignInputRowTitle = alignTitle;
        } else this.alignInputRowTitle = false;
        var background = (0, $973d693bc49d4758$export$2e2bcd8739ae039)(scene, undefined, config.background);
        if (background) this.addBackground(background);
    }
    preLayout() {
        super.preLayout();
        if (this.alignInputRowTitle) this.setInputRowTitleWidth(this.getMaxInputRowTitleWidth());
    }
}
Object.assign($f59d1aee9d2eac85$var$TweakerShell.prototype, (0, $dce809031bba1318$export$2e2bcd8739ae039));
var $f59d1aee9d2eac85$export$2e2bcd8739ae039 = $f59d1aee9d2eac85$var$TweakerShell;


class $19e8d3bbb6bec67f$var$Tweaker extends (0, $f59d1aee9d2eac85$export$2e2bcd8739ae039) {
    constructor(scene, config){
        if (config === undefined) config = {};
        if (config.styles === undefined) config.styles = {}; // TODO: Default styles
        config.background = config.styles.background || {};
        config.space = config.styles.space || {};
        // Create sizer
        super(scene, config);
        this.type = "rexTweaker";
    }
}
var $19e8d3bbb6bec67f$export$2e2bcd8739ae039 = $19e8d3bbb6bec67f$var$Tweaker;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("tweaker", function(config) {
    var gameObject = new (0, $19e8d3bbb6bec67f$export$2e2bcd8739ae039)(this.scene, config);
    this.scene.add.existing(gameObject);
    return gameObject;
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Tweaker", (0, $19e8d3bbb6bec67f$export$2e2bcd8739ae039));
var $6fdf4df9c884e1d7$export$2e2bcd8739ae039 = (0, $19e8d3bbb6bec67f$export$2e2bcd8739ae039);


/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */ function $10f8334abdfd44ee$var$isNothing(subject) {
    return typeof subject === "undefined" || subject === null;
}
function $10f8334abdfd44ee$var$isObject(subject) {
    return typeof subject === "object" && subject !== null;
}
function $10f8334abdfd44ee$var$toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if ($10f8334abdfd44ee$var$isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function $10f8334abdfd44ee$var$extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function $10f8334abdfd44ee$var$repeat(string, count) {
    var result = "", cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function $10f8334abdfd44ee$var$isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var $10f8334abdfd44ee$var$isNothing_1 = $10f8334abdfd44ee$var$isNothing;
var $10f8334abdfd44ee$var$isObject_1 = $10f8334abdfd44ee$var$isObject;
var $10f8334abdfd44ee$var$toArray_1 = $10f8334abdfd44ee$var$toArray;
var $10f8334abdfd44ee$var$repeat_1 = $10f8334abdfd44ee$var$repeat;
var $10f8334abdfd44ee$var$isNegativeZero_1 = $10f8334abdfd44ee$var$isNegativeZero;
var $10f8334abdfd44ee$var$extend_1 = $10f8334abdfd44ee$var$extend;
var $10f8334abdfd44ee$var$common = {
    isNothing: $10f8334abdfd44ee$var$isNothing_1,
    isObject: $10f8334abdfd44ee$var$isObject_1,
    toArray: $10f8334abdfd44ee$var$toArray_1,
    repeat: $10f8334abdfd44ee$var$repeat_1,
    isNegativeZero: $10f8334abdfd44ee$var$isNegativeZero_1,
    extend: $10f8334abdfd44ee$var$extend_1
};
// YAML error class. http://stackoverflow.com/questions/8458984
function $10f8334abdfd44ee$var$formatError(exception, compact) {
    var where = "", message = exception.reason || "(unknown reason)";
    if (!exception.mark) return message;
    if (exception.mark.name) where += 'in "' + exception.mark.name + '" ';
    where += "(" + (exception.mark.line + 1) + ":" + (exception.mark.column + 1) + ")";
    if (!compact && exception.mark.snippet) where += "\n\n" + exception.mark.snippet;
    return message + " " + where;
}
function $10f8334abdfd44ee$var$YAMLException$1(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = "YAMLException";
    this.reason = reason;
    this.mark = mark;
    this.message = $10f8334abdfd44ee$var$formatError(this, false);
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || "";
}
// Inherit from Error
$10f8334abdfd44ee$var$YAMLException$1.prototype = Object.create(Error.prototype);
$10f8334abdfd44ee$var$YAMLException$1.prototype.constructor = $10f8334abdfd44ee$var$YAMLException$1;
$10f8334abdfd44ee$var$YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ": " + $10f8334abdfd44ee$var$formatError(this, compact);
};
var $10f8334abdfd44ee$var$exception = $10f8334abdfd44ee$var$YAMLException$1;
// get snippet for a single line, respecting maxLength
function $10f8334abdfd44ee$var$getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = "";
    var tail = "";
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = " ... ";
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = " ...";
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length // relative position
    };
}
function $10f8334abdfd44ee$var$padStart(string, max) {
    return $10f8334abdfd44ee$var$common.repeat(" ", max - string.length) + string;
}
function $10f8334abdfd44ee$var$makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== "number") options.indent = 1;
    if (typeof options.linesBefore !== "number") options.linesBefore = 3;
    if (typeof options.linesAfter !== "number") options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = "", i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = $10f8334abdfd44ee$var$getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = $10f8334abdfd44ee$var$common.repeat(" ", options.indent) + $10f8334abdfd44ee$var$padStart((mark.line - i + 1).toString(), lineNoLength) + " | " + line.str + "\n" + result;
    }
    line = $10f8334abdfd44ee$var$getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += $10f8334abdfd44ee$var$common.repeat(" ", options.indent) + $10f8334abdfd44ee$var$padStart((mark.line + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    result += $10f8334abdfd44ee$var$common.repeat("-", options.indent + lineNoLength + 3 + line.pos) + "^" + "\n";
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = $10f8334abdfd44ee$var$getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += $10f8334abdfd44ee$var$common.repeat(" ", options.indent) + $10f8334abdfd44ee$var$padStart((mark.line + i + 1).toString(), lineNoLength) + " | " + line.str + "\n";
    }
    return result.replace(/\n$/, "");
}
var $10f8334abdfd44ee$var$snippet = $10f8334abdfd44ee$var$makeSnippet;
var $10f8334abdfd44ee$var$TYPE_CONSTRUCTOR_OPTIONS = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
];
var $10f8334abdfd44ee$var$YAML_NODE_KINDS = [
    "scalar",
    "sequence",
    "mapping"
];
function $10f8334abdfd44ee$var$compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function $10f8334abdfd44ee$var$Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if ($10f8334abdfd44ee$var$TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new $10f8334abdfd44ee$var$exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.options = options; // keep original options in case user wants to extend this type later
    this.tag = tag;
    this.kind = options["kind"] || null;
    this.resolve = options["resolve"] || function() {
        return true;
    };
    this.construct = options["construct"] || function(data) {
        return data;
    };
    this.instanceOf = options["instanceOf"] || null;
    this.predicate = options["predicate"] || null;
    this.represent = options["represent"] || null;
    this.representName = options["representName"] || null;
    this.defaultStyle = options["defaultStyle"] || null;
    this.multi = options["multi"] || false;
    this.styleAliases = $10f8334abdfd44ee$var$compileStyleAliases(options["styleAliases"] || null);
    if ($10f8334abdfd44ee$var$YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new $10f8334abdfd44ee$var$exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var $10f8334abdfd44ee$var$type = $10f8334abdfd44ee$var$Type$1;
/*eslint-disable max-len*/ function $10f8334abdfd44ee$var$compileList(schema, name) {
    var result = [];
    schema[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function $10f8334abdfd44ee$var$compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type) {
        if (type.multi) {
            result.multi[type.kind].push(type);
            result.multi["fallback"].push(type);
        } else result[type.kind][type.tag] = result["fallback"][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function $10f8334abdfd44ee$var$Schema$1(definition) {
    return this.extend(definition);
}
$10f8334abdfd44ee$var$Schema$1.prototype.extend = function extend(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof $10f8334abdfd44ee$var$type) // Schema.extend(type)
    explicit.push(definition);
    else if (Array.isArray(definition)) // Schema.extend([ type1, type2, ... ])
    explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new $10f8334abdfd44ee$var$exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof $10f8334abdfd44ee$var$type)) throw new $10f8334abdfd44ee$var$exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
        if (type$1.loadKind && type$1.loadKind !== "scalar") throw new $10f8334abdfd44ee$var$exception("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
        if (type$1.multi) throw new $10f8334abdfd44ee$var$exception("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof $10f8334abdfd44ee$var$type)) throw new $10f8334abdfd44ee$var$exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    var result = Object.create($10f8334abdfd44ee$var$Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = $10f8334abdfd44ee$var$compileList(result, "implicit");
    result.compiledExplicit = $10f8334abdfd44ee$var$compileList(result, "explicit");
    result.compiledTypeMap = $10f8334abdfd44ee$var$compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var $10f8334abdfd44ee$var$schema = $10f8334abdfd44ee$var$Schema$1;
var $10f8334abdfd44ee$var$str = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(data) {
        return data !== null ? data : "";
    }
});
var $10f8334abdfd44ee$var$seq = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(data) {
        return data !== null ? data : [];
    }
});
var $10f8334abdfd44ee$var$map = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(data) {
        return data !== null ? data : {};
    }
});
var $10f8334abdfd44ee$var$failsafe = new $10f8334abdfd44ee$var$schema({
    explicit: [
        $10f8334abdfd44ee$var$str,
        $10f8334abdfd44ee$var$seq,
        $10f8334abdfd44ee$var$map
    ]
});
function $10f8334abdfd44ee$var$resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === "~" || max === 4 && (data === "null" || data === "Null" || data === "NULL");
}
function $10f8334abdfd44ee$var$constructYamlNull() {
    return null;
}
function $10f8334abdfd44ee$var$isNull(object) {
    return object === null;
}
var $10f8334abdfd44ee$var$_null = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlNull,
    construct: $10f8334abdfd44ee$var$constructYamlNull,
    predicate: $10f8334abdfd44ee$var$isNull,
    represent: {
        canonical: function() {
            return "~";
        },
        lowercase: function() {
            return "null";
        },
        uppercase: function() {
            return "NULL";
        },
        camelcase: function() {
            return "Null";
        },
        empty: function() {
            return "";
        }
    },
    defaultStyle: "lowercase"
});
function $10f8334abdfd44ee$var$resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === "true" || data === "True" || data === "TRUE") || max === 5 && (data === "false" || data === "False" || data === "FALSE");
}
function $10f8334abdfd44ee$var$constructYamlBoolean(data) {
    return data === "true" || data === "True" || data === "TRUE";
}
function $10f8334abdfd44ee$var$isBoolean(object) {
    return Object.prototype.toString.call(object) === "[object Boolean]";
}
var $10f8334abdfd44ee$var$bool = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlBoolean,
    construct: $10f8334abdfd44ee$var$constructYamlBoolean,
    predicate: $10f8334abdfd44ee$var$isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? "true" : "false";
        },
        uppercase: function(object) {
            return object ? "TRUE" : "FALSE";
        },
        camelcase: function(object) {
            return object ? "True" : "False";
        }
    },
    defaultStyle: "lowercase"
});
function $10f8334abdfd44ee$var$isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function $10f8334abdfd44ee$var$isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function $10f8334abdfd44ee$var$isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function $10f8334abdfd44ee$var$resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === "-" || ch === "+") ch = data[++index];
    if (ch === "0") {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === "b") {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (ch !== "0" && ch !== "1") return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "x") {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!$10f8334abdfd44ee$var$isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
        if (ch === "o") {
            // base 8
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === "_") continue;
                if (!$10f8334abdfd44ee$var$isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== "_";
        }
    }
    // base 10 (except 0)
    // value should not start with `_`;
    if (ch === "_") return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === "_") continue;
        if (!$10f8334abdfd44ee$var$isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === "_") return false;
    return true;
}
function $10f8334abdfd44ee$var$constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf("_") !== -1) value = value.replace(/_/g, "");
    ch = value[0];
    if (ch === "-" || ch === "+") {
        if (ch === "-") sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === "0") return 0;
    if (ch === "0") {
        if (value[1] === "b") return sign * parseInt(value.slice(2), 2);
        if (value[1] === "x") return sign * parseInt(value.slice(2), 16);
        if (value[1] === "o") return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function $10f8334abdfd44ee$var$isInteger(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && object % 1 === 0 && !$10f8334abdfd44ee$var$common.isNegativeZero(object);
}
var $10f8334abdfd44ee$var$int = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlInteger,
    construct: $10f8334abdfd44ee$var$constructYamlInteger,
    predicate: $10f8334abdfd44ee$var$isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? "0b" + obj.toString(2) : "-0b" + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? "0o" + obj.toString(8) : "-0o" + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? "0x" + obj.toString(16).toUpperCase() : "-0x" + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: "decimal",
    styleAliases: {
        binary: [
            2,
            "bin"
        ],
        octal: [
            8,
            "oct"
        ],
        decimal: [
            10,
            "dec"
        ],
        hexadecimal: [
            16,
            "hex"
        ]
    }
});
var $10f8334abdfd44ee$var$YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function $10f8334abdfd44ee$var$resolveYamlFloat(data) {
    if (data === null) return false;
    if (!$10f8334abdfd44ee$var$YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === "_") return false;
    return true;
}
function $10f8334abdfd44ee$var$constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, "").toLowerCase();
    sign = value[0] === "-" ? -1 : 1;
    if ("+-".indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === ".inf") return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === ".nan") return NaN;
    return sign * parseFloat(value, 10);
}
var $10f8334abdfd44ee$var$SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function $10f8334abdfd44ee$var$representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case "lowercase":
            return ".nan";
        case "uppercase":
            return ".NAN";
        case "camelcase":
            return ".NaN";
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case "lowercase":
            return ".inf";
        case "uppercase":
            return ".INF";
        case "camelcase":
            return ".Inf";
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case "lowercase":
            return "-.inf";
        case "uppercase":
            return "-.INF";
        case "camelcase":
            return "-.Inf";
    }
    else if ($10f8334abdfd44ee$var$common.isNegativeZero(object)) return "-0.0";
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return $10f8334abdfd44ee$var$SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace("e", ".e") : res;
}
function $10f8334abdfd44ee$var$isFloat(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && (object % 1 !== 0 || $10f8334abdfd44ee$var$common.isNegativeZero(object));
}
var $10f8334abdfd44ee$var$float = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlFloat,
    construct: $10f8334abdfd44ee$var$constructYamlFloat,
    predicate: $10f8334abdfd44ee$var$isFloat,
    represent: $10f8334abdfd44ee$var$representYamlFloat,
    defaultStyle: "lowercase"
});
var $10f8334abdfd44ee$var$json = $10f8334abdfd44ee$var$failsafe.extend({
    implicit: [
        $10f8334abdfd44ee$var$_null,
        $10f8334abdfd44ee$var$bool,
        $10f8334abdfd44ee$var$int,
        $10f8334abdfd44ee$var$float
    ]
});
var $10f8334abdfd44ee$var$core = $10f8334abdfd44ee$var$json;
var $10f8334abdfd44ee$var$YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var $10f8334abdfd44ee$var$YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function $10f8334abdfd44ee$var$resolveYamlTimestamp(data) {
    if (data === null) return false;
    if ($10f8334abdfd44ee$var$YAML_DATE_REGEXP.exec(data) !== null) return true;
    if ($10f8334abdfd44ee$var$YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function $10f8334abdfd44ee$var$constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = $10f8334abdfd44ee$var$YAML_DATE_REGEXP.exec(data);
    if (match === null) match = $10f8334abdfd44ee$var$YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error("Date resolve error");
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += "0";
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === "-") delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function $10f8334abdfd44ee$var$representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
var $10f8334abdfd44ee$var$timestamp = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlTimestamp,
    construct: $10f8334abdfd44ee$var$constructYamlTimestamp,
    instanceOf: Date,
    represent: $10f8334abdfd44ee$var$representYamlTimestamp
});
function $10f8334abdfd44ee$var$resolveYamlMerge(data) {
    return data === "<<" || data === null;
}
var $10f8334abdfd44ee$var$merge = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlMerge
});
/*eslint-disable no-bitwise*/ // [ 64, 65, 66 ] -> [ padding, CR, LF ]
var $10f8334abdfd44ee$var$BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";
function $10f8334abdfd44ee$var$resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = $10f8334abdfd44ee$var$BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function $10f8334abdfd44ee$var$constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ""), max = input.length, map = $10f8334abdfd44ee$var$BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    return new Uint8Array(result);
}
function $10f8334abdfd44ee$var$representYamlBinary(object /*, style*/ ) {
    var result = "", bits = 0, idx, tail, max = object.length, map = $10f8334abdfd44ee$var$BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function $10f8334abdfd44ee$var$isBinary(obj) {
    return Object.prototype.toString.call(obj) === "[object Uint8Array]";
}
var $10f8334abdfd44ee$var$binary = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: $10f8334abdfd44ee$var$resolveYamlBinary,
    construct: $10f8334abdfd44ee$var$constructYamlBinary,
    predicate: $10f8334abdfd44ee$var$isBinary,
    represent: $10f8334abdfd44ee$var$representYamlBinary
});
var $10f8334abdfd44ee$var$_hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var $10f8334abdfd44ee$var$_toString$2 = Object.prototype.toString;
function $10f8334abdfd44ee$var$resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if ($10f8334abdfd44ee$var$_toString$2.call(pair) !== "[object Object]") return false;
        for(pairKey in pair)if ($10f8334abdfd44ee$var$_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function $10f8334abdfd44ee$var$constructYamlOmap(data) {
    return data !== null ? data : [];
}
var $10f8334abdfd44ee$var$omap = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: $10f8334abdfd44ee$var$resolveYamlOmap,
    construct: $10f8334abdfd44ee$var$constructYamlOmap
});
var $10f8334abdfd44ee$var$_toString$1 = Object.prototype.toString;
function $10f8334abdfd44ee$var$resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if ($10f8334abdfd44ee$var$_toString$1.call(pair) !== "[object Object]") return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function $10f8334abdfd44ee$var$constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var $10f8334abdfd44ee$var$pairs = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: $10f8334abdfd44ee$var$resolveYamlPairs,
    construct: $10f8334abdfd44ee$var$constructYamlPairs
});
var $10f8334abdfd44ee$var$_hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function $10f8334abdfd44ee$var$resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if ($10f8334abdfd44ee$var$_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function $10f8334abdfd44ee$var$constructYamlSet(data) {
    return data !== null ? data : {};
}
var $10f8334abdfd44ee$var$set = new $10f8334abdfd44ee$var$type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: $10f8334abdfd44ee$var$resolveYamlSet,
    construct: $10f8334abdfd44ee$var$constructYamlSet
});
var $10f8334abdfd44ee$var$_default = $10f8334abdfd44ee$var$core.extend({
    implicit: [
        $10f8334abdfd44ee$var$timestamp,
        $10f8334abdfd44ee$var$merge
    ],
    explicit: [
        $10f8334abdfd44ee$var$binary,
        $10f8334abdfd44ee$var$omap,
        $10f8334abdfd44ee$var$pairs,
        $10f8334abdfd44ee$var$set
    ]
});
/*eslint-disable max-len,no-use-before-define*/ var $10f8334abdfd44ee$var$_hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $10f8334abdfd44ee$var$CONTEXT_FLOW_IN = 1;
var $10f8334abdfd44ee$var$CONTEXT_FLOW_OUT = 2;
var $10f8334abdfd44ee$var$CONTEXT_BLOCK_IN = 3;
var $10f8334abdfd44ee$var$CONTEXT_BLOCK_OUT = 4;
var $10f8334abdfd44ee$var$CHOMPING_CLIP = 1;
var $10f8334abdfd44ee$var$CHOMPING_STRIP = 2;
var $10f8334abdfd44ee$var$CHOMPING_KEEP = 3;
var $10f8334abdfd44ee$var$PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var $10f8334abdfd44ee$var$PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var $10f8334abdfd44ee$var$PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var $10f8334abdfd44ee$var$PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var $10f8334abdfd44ee$var$PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function $10f8334abdfd44ee$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $10f8334abdfd44ee$var$is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $10f8334abdfd44ee$var$is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function $10f8334abdfd44ee$var$is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $10f8334abdfd44ee$var$is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function $10f8334abdfd44ee$var$fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function $10f8334abdfd44ee$var$escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function $10f8334abdfd44ee$var$fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function $10f8334abdfd44ee$var$simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? "\x00" : c === 0x61 /* a */  ? "\x07" : c === 0x62 /* b */  ? "\b" : c === 0x74 /* t */  ? "	" : c === 0x09 /* Tab */  ? "	" : c === 0x6E /* n */  ? "\n" : c === 0x76 /* v */  ? "\v" : c === 0x66 /* f */  ? "\f" : c === 0x72 /* r */  ? "\r" : c === 0x65 /* e */  ? "\x1b" : c === 0x20 /* Space */  ? " " : c === 0x22 /* " */  ? '"' : c === 0x2F /* / */  ? "/" : c === 0x5C /* \ */  ? "\\" : c === 0x4E /* N */  ? "\x85" : c === 0x5F /* _ */  ? "\xa0" : c === 0x4C /* L */  ? "\u2028" : c === 0x50 /* P */  ? "\u2029" : "";
}
function $10f8334abdfd44ee$var$charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
var $10f8334abdfd44ee$var$simpleEscapeCheck = new Array(256); // integer, for fast access
var $10f8334abdfd44ee$var$simpleEscapeMap = new Array(256);
for(var $10f8334abdfd44ee$var$i = 0; $10f8334abdfd44ee$var$i < 256; $10f8334abdfd44ee$var$i++){
    $10f8334abdfd44ee$var$simpleEscapeCheck[$10f8334abdfd44ee$var$i] = $10f8334abdfd44ee$var$simpleEscapeSequence($10f8334abdfd44ee$var$i) ? 1 : 0;
    $10f8334abdfd44ee$var$simpleEscapeMap[$10f8334abdfd44ee$var$i] = $10f8334abdfd44ee$var$simpleEscapeSequence($10f8334abdfd44ee$var$i);
}
function $10f8334abdfd44ee$var$State$1(input, options) {
    this.input = input;
    this.filename = options["filename"] || null;
    this.schema = options["schema"] || $10f8334abdfd44ee$var$_default;
    this.onWarning = options["onWarning"] || null;
    // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
    // if such documents have no explicit %YAML directive
    this.legacy = options["legacy"] || false;
    this.json = options["json"] || false;
    this.listener = options["listener"] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    // position of first leading tab in the current line,
    // used to make sure there are no tabs in the indentation
    this.firstTabInLine = -1;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function $10f8334abdfd44ee$var$generateError(state, message) {
    var mark = {
        name: state.filename,
        buffer: state.input.slice(0, -1),
        position: state.position,
        line: state.line,
        column: state.position - state.lineStart
    };
    mark.snippet = $10f8334abdfd44ee$var$snippet(mark);
    return new $10f8334abdfd44ee$var$exception(message, mark);
}
function $10f8334abdfd44ee$var$throwError(state, message) {
    throw $10f8334abdfd44ee$var$generateError(state, message);
}
function $10f8334abdfd44ee$var$throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, $10f8334abdfd44ee$var$generateError(state, message));
}
var $10f8334abdfd44ee$var$directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) $10f8334abdfd44ee$var$throwError(state, "duplication of %YAML directive");
        if (args.length !== 1) $10f8334abdfd44ee$var$throwError(state, "YAML directive accepts exactly one argument");
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) $10f8334abdfd44ee$var$throwError(state, "ill-formed argument of the YAML directive");
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) $10f8334abdfd44ee$var$throwError(state, "unacceptable YAML version of the document");
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) $10f8334abdfd44ee$var$throwWarning(state, "unsupported YAML version of the document");
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) $10f8334abdfd44ee$var$throwError(state, "TAG directive accepts exactly two arguments");
        handle = args[0];
        prefix = args[1];
        if (!$10f8334abdfd44ee$var$PATTERN_TAG_HANDLE.test(handle)) $10f8334abdfd44ee$var$throwError(state, "ill-formed tag handle (first argument) of the TAG directive");
        if ($10f8334abdfd44ee$var$_hasOwnProperty$1.call(state.tagMap, handle)) $10f8334abdfd44ee$var$throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!$10f8334abdfd44ee$var$PATTERN_TAG_URI.test(prefix)) $10f8334abdfd44ee$var$throwError(state, "ill-formed tag prefix (second argument) of the TAG directive");
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            $10f8334abdfd44ee$var$throwError(state, "tag prefix is malformed: " + prefix);
        }
        state.tagMap[handle] = prefix;
    }
};
function $10f8334abdfd44ee$var$captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) $10f8334abdfd44ee$var$throwError(state, "expected valid JSON character");
        }
        else if ($10f8334abdfd44ee$var$PATTERN_NON_PRINTABLE.test(_result)) $10f8334abdfd44ee$var$throwError(state, "the stream contains non-printable characters");
        state.result += _result;
    }
}
function $10f8334abdfd44ee$var$mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!$10f8334abdfd44ee$var$common.isObject(source)) $10f8334abdfd44ee$var$throwError(state, "cannot merge mappings; the provided source object is unacceptable");
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!$10f8334abdfd44ee$var$_hasOwnProperty$1.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) $10f8334abdfd44ee$var$throwError(state, "nested arrays are not supported inside keys");
            if (typeof keyNode === "object" && $10f8334abdfd44ee$var$_class(keyNode[index]) === "[object Object]") keyNode[index] = "[object Object]";
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if (typeof keyNode === "object" && $10f8334abdfd44ee$var$_class(keyNode) === "[object Object]") keyNode = "[object Object]";
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === "tag:yaml.org,2002:merge") {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)$10f8334abdfd44ee$var$mergeMappings(state, _result, valueNode[index], overridableKeys);
        else $10f8334abdfd44ee$var$mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !$10f8334abdfd44ee$var$_hasOwnProperty$1.call(overridableKeys, keyNode) && $10f8334abdfd44ee$var$_hasOwnProperty$1.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.lineStart = startLineStart || state.lineStart;
            state.position = startPos || state.position;
            $10f8334abdfd44ee$var$throwError(state, "duplicated mapping key");
        }
        // used for this specific key only because Object.defineProperty is slow
        if (keyNode === "__proto__") Object.defineProperty(_result, keyNode, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: valueNode
        });
        else _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function $10f8334abdfd44ee$var$readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else $10f8334abdfd44ee$var$throwError(state, "a line break is expected");
    state.line += 1;
    state.lineStart = state.position;
    state.firstTabInLine = -1;
}
function $10f8334abdfd44ee$var$skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while($10f8334abdfd44ee$var$is_WHITE_SPACE(ch)){
            if (ch === 0x09 /* Tab */  && state.firstTabInLine === -1) state.firstTabInLine = state.position;
            ch = state.input.charCodeAt(++state.position);
        }
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if ($10f8334abdfd44ee$var$is_EOL(ch)) {
            $10f8334abdfd44ee$var$readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) $10f8334abdfd44ee$var$throwWarning(state, "deficient indentation");
    return lineBreaks;
}
function $10f8334abdfd44ee$var$testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || $10f8334abdfd44ee$var$is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function $10f8334abdfd44ee$var$writeFoldedLines(state, count) {
    if (count === 1) state.result += " ";
    else if (count > 1) state.result += $10f8334abdfd44ee$var$common.repeat("\n", count - 1);
}
function $10f8334abdfd44ee$var$readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if ($10f8334abdfd44ee$var$is_WS_OR_EOL(ch) || $10f8334abdfd44ee$var$is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if ($10f8334abdfd44ee$var$is_WS_OR_EOL(following) || withinFlowCollection && $10f8334abdfd44ee$var$is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = "scalar";
    state.result = "";
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($10f8334abdfd44ee$var$is_WS_OR_EOL(following) || withinFlowCollection && $10f8334abdfd44ee$var$is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if ($10f8334abdfd44ee$var$is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && $10f8334abdfd44ee$var$testDocumentSeparator(state) || withinFlowCollection && $10f8334abdfd44ee$var$is_FLOW_INDICATOR(ch)) break;
        else if ($10f8334abdfd44ee$var$is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            $10f8334abdfd44ee$var$skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, captureEnd, false);
            $10f8334abdfd44ee$var$writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!$10f8334abdfd44ee$var$is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    $10f8334abdfd44ee$var$captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function $10f8334abdfd44ee$var$readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = "scalar";
    state.result = "";
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if ($10f8334abdfd44ee$var$is_EOL(ch)) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, captureEnd, true);
            $10f8334abdfd44ee$var$writeFoldedLines(state, $10f8334abdfd44ee$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $10f8334abdfd44ee$var$testDocumentSeparator(state)) $10f8334abdfd44ee$var$throwError(state, "unexpected end of the document within a single quoted scalar");
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $10f8334abdfd44ee$var$throwError(state, "unexpected end of the stream within a single quoted scalar");
}
function $10f8334abdfd44ee$var$readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = "scalar";
    state.result = "";
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if ($10f8334abdfd44ee$var$is_EOL(ch)) $10f8334abdfd44ee$var$skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && $10f8334abdfd44ee$var$simpleEscapeCheck[ch]) {
                state.result += $10f8334abdfd44ee$var$simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = $10f8334abdfd44ee$var$escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = $10f8334abdfd44ee$var$fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else $10f8334abdfd44ee$var$throwError(state, "expected hexadecimal character");
                }
                state.result += $10f8334abdfd44ee$var$charFromCodepoint(hexResult);
                state.position++;
            } else $10f8334abdfd44ee$var$throwError(state, "unknown escape sequence");
            captureStart = captureEnd = state.position;
        } else if ($10f8334abdfd44ee$var$is_EOL(ch)) {
            $10f8334abdfd44ee$var$captureSegment(state, captureStart, captureEnd, true);
            $10f8334abdfd44ee$var$writeFoldedLines(state, $10f8334abdfd44ee$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $10f8334abdfd44ee$var$testDocumentSeparator(state)) $10f8334abdfd44ee$var$throwError(state, "unexpected end of the document within a double quoted scalar");
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $10f8334abdfd44ee$var$throwError(state, "unexpected end of the stream within a double quoted scalar");
}
function $10f8334abdfd44ee$var$readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? "mapping" : "sequence";
            state.result = _result;
            return true;
        } else if (!readNext) $10f8334abdfd44ee$var$throwError(state, "missed comma between flow collection entries");
        else if (ch === 0x2C /* , */ ) // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
        $10f8334abdfd44ee$var$throwError(state, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($10f8334abdfd44ee$var$is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                $10f8334abdfd44ee$var$skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line; // Save the current line.
        _lineStart = state.lineStart;
        _pos = state.position;
        $10f8334abdfd44ee$var$composeNode(state, nodeIndent, $10f8334abdfd44ee$var$CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            $10f8334abdfd44ee$var$skipSeparationSpace(state, true, nodeIndent);
            $10f8334abdfd44ee$var$composeNode(state, nodeIndent, $10f8334abdfd44ee$var$CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push($10f8334abdfd44ee$var$storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    $10f8334abdfd44ee$var$throwError(state, "unexpected end of the stream within a flow collection");
}
function $10f8334abdfd44ee$var$readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = $10f8334abdfd44ee$var$CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = "scalar";
    state.result = "";
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if ($10f8334abdfd44ee$var$CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? $10f8334abdfd44ee$var$CHOMPING_KEEP : $10f8334abdfd44ee$var$CHOMPING_STRIP;
            else $10f8334abdfd44ee$var$throwError(state, "repeat of a chomping mode identifier");
        } else if ((tmp = $10f8334abdfd44ee$var$fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) $10f8334abdfd44ee$var$throwError(state, "bad explicit indentation width of a block scalar; it cannot be less than one");
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else $10f8334abdfd44ee$var$throwError(state, "repeat of an indentation width identifier");
        } else break;
    }
    if ($10f8334abdfd44ee$var$is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while ($10f8334abdfd44ee$var$is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!$10f8334abdfd44ee$var$is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        $10f8334abdfd44ee$var$readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if ($10f8334abdfd44ee$var$is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === $10f8334abdfd44ee$var$CHOMPING_KEEP) state.result += $10f8334abdfd44ee$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === $10f8334abdfd44ee$var$CHOMPING_CLIP) {
                if (didReadContent) state.result += "\n";
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if ($10f8334abdfd44ee$var$is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += $10f8334abdfd44ee$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += $10f8334abdfd44ee$var$common.repeat("\n", emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += " ";
            } else state.result += $10f8334abdfd44ee$var$common.repeat("\n", emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += $10f8334abdfd44ee$var$common.repeat("\n", didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!$10f8334abdfd44ee$var$is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        $10f8334abdfd44ee$var$captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function $10f8334abdfd44ee$var$readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $10f8334abdfd44ee$var$throwError(state, "tab characters must not be used in indentation");
        }
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!$10f8334abdfd44ee$var$is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if ($10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        $10f8334abdfd44ee$var$composeNode(state, nodeIndent, $10f8334abdfd44ee$var$CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $10f8334abdfd44ee$var$throwError(state, "bad indentation of a sequence entry");
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = "sequence";
        state.result = _result;
        return true;
    }
    return false;
}
function $10f8334abdfd44ee$var$readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (!atExplicitKey && state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $10f8334abdfd44ee$var$throwError(state, "tab characters must not be used in indentation");
        }
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && $10f8334abdfd44ee$var$is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else $10f8334abdfd44ee$var$throwError(state, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line");
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else {
            _keyLine = state.line;
            _keyLineStart = state.lineStart;
            _keyPos = state.position;
            if (!$10f8334abdfd44ee$var$composeNode(state, flowIndent, $10f8334abdfd44ee$var$CONTEXT_FLOW_OUT, false, true)) break;
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while($10f8334abdfd44ee$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!$10f8334abdfd44ee$var$is_WS_OR_EOL(ch)) $10f8334abdfd44ee$var$throwError(state, "a whitespace character is expected after the key-value separator within a block mapping");
                    if (atExplicitKey) {
                        $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) $10f8334abdfd44ee$var$throwError(state, "can not read an implicit mapping pair; a colon is missed");
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) $10f8334abdfd44ee$var$throwError(state, "can not read a block mapping entry; a multiline key may not be an implicit key");
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        }
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state.line;
                _keyLineStart = state.lineStart;
                _keyPos = state.position;
            }
            if ($10f8334abdfd44ee$var$composeNode(state, nodeIndent, $10f8334abdfd44ee$var$CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $10f8334abdfd44ee$var$throwError(state, "bad indentation of a mapping entry");
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) $10f8334abdfd44ee$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = "mapping";
        state.result = _result;
    }
    return detected;
}
function $10f8334abdfd44ee$var$readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) $10f8334abdfd44ee$var$throwError(state, "duplication of a tag property");
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = "!!";
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = "!";
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else $10f8334abdfd44ee$var$throwError(state, "unexpected end of the stream within a verbatim tag");
    } else {
        while(ch !== 0 && !$10f8334abdfd44ee$var$is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!$10f8334abdfd44ee$var$PATTERN_TAG_HANDLE.test(tagHandle)) $10f8334abdfd44ee$var$throwError(state, "named tag handle cannot contain such characters");
                    isNamed = true;
                    _position = state.position + 1;
                } else $10f8334abdfd44ee$var$throwError(state, "tag suffix cannot contain exclamation marks");
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if ($10f8334abdfd44ee$var$PATTERN_FLOW_INDICATORS.test(tagName)) $10f8334abdfd44ee$var$throwError(state, "tag suffix cannot contain flow indicator characters");
    }
    if (tagName && !$10f8334abdfd44ee$var$PATTERN_TAG_URI.test(tagName)) $10f8334abdfd44ee$var$throwError(state, "tag name cannot contain such characters: " + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        $10f8334abdfd44ee$var$throwError(state, "tag name is malformed: " + tagName);
    }
    if (isVerbatim) state.tag = tagName;
    else if ($10f8334abdfd44ee$var$_hasOwnProperty$1.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === "!") state.tag = "!" + tagName;
    else if (tagHandle === "!!") state.tag = "tag:yaml.org,2002:" + tagName;
    else $10f8334abdfd44ee$var$throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function $10f8334abdfd44ee$var$readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) $10f8334abdfd44ee$var$throwError(state, "duplication of an anchor property");
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$10f8334abdfd44ee$var$is_WS_OR_EOL(ch) && !$10f8334abdfd44ee$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $10f8334abdfd44ee$var$throwError(state, "name of an anchor node must contain at least one character");
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function $10f8334abdfd44ee$var$readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$10f8334abdfd44ee$var$is_WS_OR_EOL(ch) && !$10f8334abdfd44ee$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $10f8334abdfd44ee$var$throwError(state, "name of an alias node must contain at least one character");
    alias = state.input.slice(_position, state.position);
    if (!$10f8334abdfd44ee$var$_hasOwnProperty$1.call(state.anchorMap, alias)) $10f8334abdfd44ee$var$throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
    return true;
}
function $10f8334abdfd44ee$var$composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener("open", state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = $10f8334abdfd44ee$var$CONTEXT_BLOCK_OUT === nodeContext || $10f8334abdfd44ee$var$CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if ($10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while($10f8334abdfd44ee$var$readTagProperty(state) || $10f8334abdfd44ee$var$readAnchorProperty(state))if ($10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || $10f8334abdfd44ee$var$CONTEXT_BLOCK_OUT === nodeContext) {
        if ($10f8334abdfd44ee$var$CONTEXT_FLOW_IN === nodeContext || $10f8334abdfd44ee$var$CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && ($10f8334abdfd44ee$var$readBlockSequence(state, blockIndent) || $10f8334abdfd44ee$var$readBlockMapping(state, blockIndent, flowIndent)) || $10f8334abdfd44ee$var$readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && $10f8334abdfd44ee$var$readBlockScalar(state, flowIndent) || $10f8334abdfd44ee$var$readSingleQuotedScalar(state, flowIndent) || $10f8334abdfd44ee$var$readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if ($10f8334abdfd44ee$var$readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) $10f8334abdfd44ee$var$throwError(state, "alias node should not have any properties");
                } else if ($10f8334abdfd44ee$var$readPlainScalar(state, flowIndent, $10f8334abdfd44ee$var$CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = "?";
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && $10f8334abdfd44ee$var$readBlockSequence(state, blockIndent);
    }
    if (state.tag === null) {
        if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
    } else if (state.tag === "?") {
        // Implicit resolving is not allowed for non-scalar types, and '?'
        // non-specific tag is only automatically assigned to plain scalars.
        //
        // We only need to check kind conformity in case user explicitly assigns '?'
        // tag, for example like this: "!<?> [0]"
        //
        if (state.result !== null && state.kind !== "scalar") $10f8334abdfd44ee$var$throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
        for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type = state.implicitTypes[typeIndex];
            if (type.resolve(state.result)) {
                state.result = type.construct(state.result);
                state.tag = type.tag;
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                break;
            }
        }
    } else if (state.tag !== "!") {
        if ($10f8334abdfd44ee$var$_hasOwnProperty$1.call(state.typeMap[state.kind || "fallback"], state.tag)) type = state.typeMap[state.kind || "fallback"][state.tag];
        else {
            // looking for multi type
            type = null;
            typeList = state.typeMap.multi[state.kind || "fallback"];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type = typeList[typeIndex];
                break;
            }
        }
        if (!type) $10f8334abdfd44ee$var$throwError(state, "unknown tag !<" + state.tag + ">");
        if (state.result !== null && type.kind !== state.kind) $10f8334abdfd44ee$var$throwError(state, "unacceptable node kind for !<" + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
        if (!type.resolve(state.result, state.tag)) $10f8334abdfd44ee$var$throwError(state, "cannot resolve a node with !<" + state.tag + "> explicit tag");
        else {
            state.result = type.construct(state.result, state.tag);
            if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
        }
    }
    if (state.listener !== null) state.listener("close", state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function $10f8334abdfd44ee$var$readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = Object.create(null);
    state.anchorMap = Object.create(null);
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !$10f8334abdfd44ee$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) $10f8334abdfd44ee$var$throwError(state, "directive name must not be less than one character in length");
        while(ch !== 0){
            while($10f8334abdfd44ee$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !$10f8334abdfd44ee$var$is_EOL(ch));
                break;
            }
            if ($10f8334abdfd44ee$var$is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !$10f8334abdfd44ee$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) $10f8334abdfd44ee$var$readLineBreak(state);
        if ($10f8334abdfd44ee$var$_hasOwnProperty$1.call($10f8334abdfd44ee$var$directiveHandlers, directiveName)) $10f8334abdfd44ee$var$directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else $10f8334abdfd44ee$var$throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) $10f8334abdfd44ee$var$throwError(state, "directives end mark is expected");
    $10f8334abdfd44ee$var$composeNode(state, state.lineIndent - 1, $10f8334abdfd44ee$var$CONTEXT_BLOCK_OUT, false, true);
    $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && $10f8334abdfd44ee$var$PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) $10f8334abdfd44ee$var$throwWarning(state, "non-ASCII line breaks are interpreted as content");
    state.documents.push(state.result);
    if (state.position === state.lineStart && $10f8334abdfd44ee$var$testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            $10f8334abdfd44ee$var$skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) $10f8334abdfd44ee$var$throwError(state, "end of the stream or a document separator is expected");
    else return;
}
function $10f8334abdfd44ee$var$loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += "\n";
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new $10f8334abdfd44ee$var$State$1(input, options);
    var nullpos = input.indexOf("\x00");
    if (nullpos !== -1) {
        state.position = nullpos;
        $10f8334abdfd44ee$var$throwError(state, "null byte is not allowed in input");
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += "\x00";
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)$10f8334abdfd44ee$var$readDocument(state);
    return state.documents;
}
function $10f8334abdfd44ee$var$loadAll$1(input, iterator, options) {
    if (iterator !== null && typeof iterator === "object" && typeof options === "undefined") {
        options = iterator;
        iterator = null;
    }
    var documents = $10f8334abdfd44ee$var$loadDocuments(input, options);
    if (typeof iterator !== "function") return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function $10f8334abdfd44ee$var$load$1(input, options) {
    var documents = $10f8334abdfd44ee$var$loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new $10f8334abdfd44ee$var$exception("expected a single document in the stream, but found more");
}
var $10f8334abdfd44ee$var$loadAll_1 = $10f8334abdfd44ee$var$loadAll$1;
var $10f8334abdfd44ee$var$load_1 = $10f8334abdfd44ee$var$load$1;
var $10f8334abdfd44ee$var$loader = {
    loadAll: $10f8334abdfd44ee$var$loadAll_1,
    load: $10f8334abdfd44ee$var$load_1
};
/*eslint-disable no-use-before-define*/ var $10f8334abdfd44ee$var$_toString = Object.prototype.toString;
var $10f8334abdfd44ee$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
var $10f8334abdfd44ee$var$CHAR_BOM = 0xFEFF;
var $10f8334abdfd44ee$var$CHAR_TAB = 0x09; /* Tab */ 
var $10f8334abdfd44ee$var$CHAR_LINE_FEED = 0x0A; /* LF */ 
var $10f8334abdfd44ee$var$CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var $10f8334abdfd44ee$var$CHAR_SPACE = 0x20; /* Space */ 
var $10f8334abdfd44ee$var$CHAR_EXCLAMATION = 0x21; /* ! */ 
var $10f8334abdfd44ee$var$CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var $10f8334abdfd44ee$var$CHAR_SHARP = 0x23; /* # */ 
var $10f8334abdfd44ee$var$CHAR_PERCENT = 0x25; /* % */ 
var $10f8334abdfd44ee$var$CHAR_AMPERSAND = 0x26; /* & */ 
var $10f8334abdfd44ee$var$CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var $10f8334abdfd44ee$var$CHAR_ASTERISK = 0x2A; /* * */ 
var $10f8334abdfd44ee$var$CHAR_COMMA = 0x2C; /* , */ 
var $10f8334abdfd44ee$var$CHAR_MINUS = 0x2D; /* - */ 
var $10f8334abdfd44ee$var$CHAR_COLON = 0x3A; /* : */ 
var $10f8334abdfd44ee$var$CHAR_EQUALS = 0x3D; /* = */ 
var $10f8334abdfd44ee$var$CHAR_GREATER_THAN = 0x3E; /* > */ 
var $10f8334abdfd44ee$var$CHAR_QUESTION = 0x3F; /* ? */ 
var $10f8334abdfd44ee$var$CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var $10f8334abdfd44ee$var$CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var $10f8334abdfd44ee$var$CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var $10f8334abdfd44ee$var$CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var $10f8334abdfd44ee$var$CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var $10f8334abdfd44ee$var$CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var $10f8334abdfd44ee$var$CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var $10f8334abdfd44ee$var$ESCAPE_SEQUENCES = {};
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x00] = "\\0";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x07] = "\\a";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x08] = "\\b";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x09] = "\\t";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x0A] = "\\n";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x0B] = "\\v";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x0C] = "\\f";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x0D] = "\\r";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x1B] = "\\e";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x22] = '\\"';
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x5C] = "\\\\";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x85] = "\\N";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0xA0] = "\\_";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x2028] = "\\L";
$10f8334abdfd44ee$var$ESCAPE_SEQUENCES[0x2029] = "\\P";
var $10f8334abdfd44ee$var$DEPRECATED_BOOLEANS_SYNTAX = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
];
var $10f8334abdfd44ee$var$DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
function $10f8334abdfd44ee$var$compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === "!!") tag = "tag:yaml.org,2002:" + tag.slice(2);
        type = schema.compiledTypeMap["fallback"][tag];
        if (type && $10f8334abdfd44ee$var$_hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function $10f8334abdfd44ee$var$encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = "x";
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = "u";
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = "U";
        length = 8;
    } else throw new $10f8334abdfd44ee$var$exception("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + handle + $10f8334abdfd44ee$var$common.repeat("0", length - string.length) + string;
}
var $10f8334abdfd44ee$var$QUOTING_TYPE_SINGLE = 1, $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE = 2;
function $10f8334abdfd44ee$var$State(options) {
    this.schema = options["schema"] || $10f8334abdfd44ee$var$_default;
    this.indent = Math.max(1, options["indent"] || 2);
    this.noArrayIndent = options["noArrayIndent"] || false;
    this.skipInvalid = options["skipInvalid"] || false;
    this.flowLevel = $10f8334abdfd44ee$var$common.isNothing(options["flowLevel"]) ? -1 : options["flowLevel"];
    this.styleMap = $10f8334abdfd44ee$var$compileStyleMap(this.schema, options["styles"] || null);
    this.sortKeys = options["sortKeys"] || false;
    this.lineWidth = options["lineWidth"] || 80;
    this.noRefs = options["noRefs"] || false;
    this.noCompatMode = options["noCompatMode"] || false;
    this.condenseFlow = options["condenseFlow"] || false;
    this.quotingType = options["quotingType"] === '"' ? $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE : $10f8334abdfd44ee$var$QUOTING_TYPE_SINGLE;
    this.forceQuotes = options["forceQuotes"] || false;
    this.replacer = typeof options["replacer"] === "function" ? options["replacer"] : null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = "";
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function $10f8334abdfd44ee$var$indentString(string, spaces) {
    var ind = $10f8334abdfd44ee$var$common.repeat(" ", spaces), position = 0, next = -1, result = "", line, length = string.length;
    while(position < length){
        next = string.indexOf("\n", position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== "\n") result += ind;
        result += line;
    }
    return result;
}
function $10f8334abdfd44ee$var$generateNextLine(state, level) {
    return "\n" + $10f8334abdfd44ee$var$common.repeat(" ", state.indent * level);
}
function $10f8334abdfd44ee$var$testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function $10f8334abdfd44ee$var$isWhitespace(c) {
    return c === $10f8334abdfd44ee$var$CHAR_SPACE || c === $10f8334abdfd44ee$var$CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function $10f8334abdfd44ee$var$isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== $10f8334abdfd44ee$var$CHAR_BOM || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// Including s-white (for some reason, examples doesn't match specs in this aspect)
// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
function $10f8334abdfd44ee$var$isNsCharOrWhitespace(c) {
    return $10f8334abdfd44ee$var$isPrintable(c) && c !== $10f8334abdfd44ee$var$CHAR_BOM && c !== $10f8334abdfd44ee$var$CHAR_CARRIAGE_RETURN && c !== $10f8334abdfd44ee$var$CHAR_LINE_FEED;
}
// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
//                             c = flow-in   ⇒ ns-plain-safe-in
//                             c = block-key ⇒ ns-plain-safe-out
//                             c = flow-key  ⇒ ns-plain-safe-in
// [128] ns-plain-safe-out ::= ns-char
// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
//                            | ( /* An ns-char preceding */ “#” )
//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
function $10f8334abdfd44ee$var$isPlainSafe(c, prev, inblock) {
    var cIsNsCharOrWhitespace = $10f8334abdfd44ee$var$isNsCharOrWhitespace(c);
    var cIsNsChar = cIsNsCharOrWhitespace && !$10f8334abdfd44ee$var$isWhitespace(c);
    return(// ns-plain-safe
    (inblock ? cIsNsCharOrWhitespace : cIsNsCharOrWhitespace && c !== $10f8334abdfd44ee$var$CHAR_COMMA && c !== $10f8334abdfd44ee$var$CHAR_LEFT_SQUARE_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_LEFT_CURLY_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_RIGHT_CURLY_BRACKET) && c !== $10f8334abdfd44ee$var$CHAR_SHARP // false on '#'
     && !(prev === $10f8334abdfd44ee$var$CHAR_COLON && !cIsNsChar // false on ': '
    ) || $10f8334abdfd44ee$var$isNsCharOrWhitespace(prev) && !$10f8334abdfd44ee$var$isWhitespace(prev) && c === $10f8334abdfd44ee$var$CHAR_SHARP // change to true on '[^ ]#'
     || prev === $10f8334abdfd44ee$var$CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
}
// Simplified test for values allowed as the first character in plain style.
function $10f8334abdfd44ee$var$isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
    return $10f8334abdfd44ee$var$isPrintable(c) && c !== $10f8334abdfd44ee$var$CHAR_BOM && !$10f8334abdfd44ee$var$isWhitespace(c) // - s-white
     && c !== $10f8334abdfd44ee$var$CHAR_MINUS && c !== $10f8334abdfd44ee$var$CHAR_QUESTION && c !== $10f8334abdfd44ee$var$CHAR_COLON && c !== $10f8334abdfd44ee$var$CHAR_COMMA && c !== $10f8334abdfd44ee$var$CHAR_LEFT_SQUARE_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_LEFT_CURLY_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_RIGHT_CURLY_BRACKET && c !== $10f8334abdfd44ee$var$CHAR_SHARP && c !== $10f8334abdfd44ee$var$CHAR_AMPERSAND && c !== $10f8334abdfd44ee$var$CHAR_ASTERISK && c !== $10f8334abdfd44ee$var$CHAR_EXCLAMATION && c !== $10f8334abdfd44ee$var$CHAR_VERTICAL_LINE && c !== $10f8334abdfd44ee$var$CHAR_EQUALS && c !== $10f8334abdfd44ee$var$CHAR_GREATER_THAN && c !== $10f8334abdfd44ee$var$CHAR_SINGLE_QUOTE && c !== $10f8334abdfd44ee$var$CHAR_DOUBLE_QUOTE && c !== $10f8334abdfd44ee$var$CHAR_PERCENT && c !== $10f8334abdfd44ee$var$CHAR_COMMERCIAL_AT && c !== $10f8334abdfd44ee$var$CHAR_GRAVE_ACCENT;
}
// Simplified test for values allowed as the last character in plain style.
function $10f8334abdfd44ee$var$isPlainSafeLast(c) {
    // just not whitespace or colon, it will be checked to be plain character later
    return !$10f8334abdfd44ee$var$isWhitespace(c) && c !== $10f8334abdfd44ee$var$CHAR_COLON;
}
// Same as 'string'.codePointAt(pos), but works in older browsers.
function $10f8334abdfd44ee$var$codePointAt(string, pos) {
    var first = string.charCodeAt(pos), second;
    if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
        second = string.charCodeAt(pos + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
// Determines whether block indentation indicator is required.
function $10f8334abdfd44ee$var$needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var $10f8334abdfd44ee$var$STYLE_PLAIN = 1, $10f8334abdfd44ee$var$STYLE_SINGLE = 2, $10f8334abdfd44ee$var$STYLE_LITERAL = 3, $10f8334abdfd44ee$var$STYLE_FOLDED = 4, $10f8334abdfd44ee$var$STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function $10f8334abdfd44ee$var$chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType, quotingType, forceQuotes, inblock) {
    var i;
    var char = 0;
    var prevChar = null;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = $10f8334abdfd44ee$var$isPlainSafeFirst($10f8334abdfd44ee$var$codePointAt(string, 0)) && $10f8334abdfd44ee$var$isPlainSafeLast($10f8334abdfd44ee$var$codePointAt(string, string.length - 1));
    if (singleLineOnly || forceQuotes) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $10f8334abdfd44ee$var$codePointAt(string, i);
        if (!$10f8334abdfd44ee$var$isPrintable(char)) return $10f8334abdfd44ee$var$STYLE_DOUBLE;
        plain = plain && $10f8334abdfd44ee$var$isPlainSafe(char, prevChar, inblock);
        prevChar = char;
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
            char = $10f8334abdfd44ee$var$codePointAt(string, i);
            if (char === $10f8334abdfd44ee$var$CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== " ";
                    previousLineBreak = i;
                }
            } else if (!$10f8334abdfd44ee$var$isPrintable(char)) return $10f8334abdfd44ee$var$STYLE_DOUBLE;
            plain = plain && $10f8334abdfd44ee$var$isPlainSafe(char, prevChar, inblock);
            prevChar = char;
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== " ";
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) {
        // Strings interpretable as another type have to be quoted;
        // e.g. the string 'true' vs. the boolean true.
        if (plain && !forceQuotes && !testAmbiguousType(string)) return $10f8334abdfd44ee$var$STYLE_PLAIN;
        return quotingType === $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE ? $10f8334abdfd44ee$var$STYLE_DOUBLE : $10f8334abdfd44ee$var$STYLE_SINGLE;
    }
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && $10f8334abdfd44ee$var$needIndentIndicator(string)) return $10f8334abdfd44ee$var$STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    if (!forceQuotes) return hasFoldableLine ? $10f8334abdfd44ee$var$STYLE_FOLDED : $10f8334abdfd44ee$var$STYLE_LITERAL;
    return quotingType === $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE ? $10f8334abdfd44ee$var$STYLE_DOUBLE : $10f8334abdfd44ee$var$STYLE_SINGLE;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function $10f8334abdfd44ee$var$writeScalar(state, string, level, iskey, inblock) {
    state.dump = function() {
        if (string.length === 0) return state.quotingType === $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE ? '""' : "''";
        if (!state.noCompatMode) {
            if ($10f8334abdfd44ee$var$DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || $10f8334abdfd44ee$var$DEPRECATED_BASE60_SYNTAX.test(string)) return state.quotingType === $10f8334abdfd44ee$var$QUOTING_TYPE_DOUBLE ? '"' + string + '"' : "'" + string + "'";
        }
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return $10f8334abdfd44ee$var$testImplicitResolving(state, string);
        }
        switch($10f8334abdfd44ee$var$chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)){
            case $10f8334abdfd44ee$var$STYLE_PLAIN:
                return string;
            case $10f8334abdfd44ee$var$STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case $10f8334abdfd44ee$var$STYLE_LITERAL:
                return "|" + $10f8334abdfd44ee$var$blockHeader(string, state.indent) + $10f8334abdfd44ee$var$dropEndingNewline($10f8334abdfd44ee$var$indentString(string, indent));
            case $10f8334abdfd44ee$var$STYLE_FOLDED:
                return ">" + $10f8334abdfd44ee$var$blockHeader(string, state.indent) + $10f8334abdfd44ee$var$dropEndingNewline($10f8334abdfd44ee$var$indentString($10f8334abdfd44ee$var$foldString(string, lineWidth), indent));
            case $10f8334abdfd44ee$var$STYLE_DOUBLE:
                return '"' + $10f8334abdfd44ee$var$escapeString(string) + '"';
            default:
                throw new $10f8334abdfd44ee$var$exception("impossible error: invalid scalar style");
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function $10f8334abdfd44ee$var$blockHeader(string, indentPerLevel) {
    var indentIndicator = $10f8334abdfd44ee$var$needIndentIndicator(string) ? String(indentPerLevel) : "";
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === "\n";
    var keep = clip && (string[string.length - 2] === "\n" || string === "\n");
    var chomp = keep ? "+" : clip ? "" : "-";
    return indentIndicator + chomp + "\n";
}
// (See the note for writeScalar.)
function $10f8334abdfd44ee$var$dropEndingNewline(string) {
    return string[string.length - 1] === "\n" ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function $10f8334abdfd44ee$var$foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf("\n");
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return $10f8334abdfd44ee$var$foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === "\n" || string[0] === " ";
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === " ";
        result += prefix + (!prevMoreIndented && !moreIndented && line !== "" ? "\n" : "") + $10f8334abdfd44ee$var$foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function $10f8334abdfd44ee$var$foldLine(line, width) {
    if (line === "" || line[0] === " ") return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = "";
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += "\n" + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += "\n";
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + "\n" + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function $10f8334abdfd44ee$var$escapeString(string) {
    var result = "";
    var char = 0;
    var escapeSeq;
    for(var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $10f8334abdfd44ee$var$codePointAt(string, i);
        escapeSeq = $10f8334abdfd44ee$var$ESCAPE_SEQUENCES[char];
        if (!escapeSeq && $10f8334abdfd44ee$var$isPrintable(char)) {
            result += string[i];
            if (char >= 0x10000) result += string[i + 1];
        } else result += escapeSeq || $10f8334abdfd44ee$var$encodeHex(char);
    }
    return result;
}
function $10f8334abdfd44ee$var$writeFlowSequence(state, level, object) {
    var _result = "", _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($10f8334abdfd44ee$var$writeNode(state, level, value, false, false) || typeof value === "undefined" && $10f8334abdfd44ee$var$writeNode(state, level, null, false, false)) {
            if (_result !== "") _result += "," + (!state.condenseFlow ? " " : "");
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = "[" + _result + "]";
}
function $10f8334abdfd44ee$var$writeBlockSequence(state, level, object, compact) {
    var _result = "", _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($10f8334abdfd44ee$var$writeNode(state, level + 1, value, true, true, false, true) || typeof value === "undefined" && $10f8334abdfd44ee$var$writeNode(state, level + 1, null, true, true, false, true)) {
            if (!compact || _result !== "") _result += $10f8334abdfd44ee$var$generateNextLine(state, level);
            if (state.dump && $10f8334abdfd44ee$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += "-";
            else _result += "- ";
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = _result || "[]"; // Empty sequence if no valid values.
}
function $10f8334abdfd44ee$var$writeFlowMapping(state, level, object) {
    var _result = "", _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = "";
        if (_result !== "") pairBuffer += ", ";
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$10f8334abdfd44ee$var$writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += "? ";
        pairBuffer += state.dump + (state.condenseFlow ? '"' : "") + ":" + (state.condenseFlow ? "" : " ");
        if (!$10f8334abdfd44ee$var$writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = "{" + _result + "}";
}
function $10f8334abdfd44ee$var$writeBlockMapping(state, level, object, compact) {
    var _result = "", _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === "function") // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new $10f8334abdfd44ee$var$exception("sortKeys must be a boolean or a function");
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = "";
        if (!compact || _result !== "") pairBuffer += $10f8334abdfd44ee$var$generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$10f8334abdfd44ee$var$writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== "?" || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && $10f8334abdfd44ee$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += "?";
            else pairBuffer += "? ";
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += $10f8334abdfd44ee$var$generateNextLine(state, level);
        if (!$10f8334abdfd44ee$var$writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && $10f8334abdfd44ee$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ":";
        else pairBuffer += ": ";
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || "{}"; // Empty mapping if no valid pairs.
}
function $10f8334abdfd44ee$var$detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === "object" && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            if (explicit) {
                if (type.multi && type.representName) state.tag = type.representName(object);
                else state.tag = type.tag;
            } else state.tag = "?";
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if ($10f8334abdfd44ee$var$_toString.call(type.represent) === "[object Function]") _result = type.represent(object, style);
                else if ($10f8334abdfd44ee$var$_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new $10f8334abdfd44ee$var$exception("!<" + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function $10f8334abdfd44ee$var$writeNode(state, level, object, block, compact, iskey, isblockseq) {
    state.tag = null;
    state.dump = object;
    if (!$10f8334abdfd44ee$var$detectType(state, object, false)) $10f8334abdfd44ee$var$detectType(state, object, true);
    var type = $10f8334abdfd44ee$var$_toString.call(state.dump);
    var inblock = block;
    var tagStr;
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === "[object Object]" || type === "[object Array]", duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== "?" || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = "*ref_" + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === "[object Object]") {
            if (block && Object.keys(state.dump).length !== 0) {
                $10f8334abdfd44ee$var$writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = "&ref_" + duplicateIndex + state.dump;
            } else {
                $10f8334abdfd44ee$var$writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = "&ref_" + duplicateIndex + " " + state.dump;
            }
        } else if (type === "[object Array]") {
            if (block && state.dump.length !== 0) {
                if (state.noArrayIndent && !isblockseq && level > 0) $10f8334abdfd44ee$var$writeBlockSequence(state, level - 1, state.dump, compact);
                else $10f8334abdfd44ee$var$writeBlockSequence(state, level, state.dump, compact);
                if (duplicate) state.dump = "&ref_" + duplicateIndex + state.dump;
            } else {
                $10f8334abdfd44ee$var$writeFlowSequence(state, level, state.dump);
                if (duplicate) state.dump = "&ref_" + duplicateIndex + " " + state.dump;
            }
        } else if (type === "[object String]") {
            if (state.tag !== "?") $10f8334abdfd44ee$var$writeScalar(state, state.dump, level, iskey, inblock);
        } else if (type === "[object Undefined]") return false;
        else {
            if (state.skipInvalid) return false;
            throw new $10f8334abdfd44ee$var$exception("unacceptable kind of an object to dump " + type);
        }
        if (state.tag !== null && state.tag !== "?") {
            // Need to encode all characters except those allowed by the spec:
            //
            // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
            // [36] ns-hex-digit    ::=  ns-dec-digit
            //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
            // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
            // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
            // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
            //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
            //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
            //
            // Also need to encode '!' because it has special meaning (end of tag prefix).
            //
            tagStr = encodeURI(state.tag[0] === "!" ? state.tag.slice(1) : state.tag).replace(/!/g, "%21");
            if (state.tag[0] === "!") tagStr = "!" + tagStr;
            else if (tagStr.slice(0, 18) === "tag:yaml.org,2002:") tagStr = "!!" + tagStr.slice(18);
            else tagStr = "!<" + tagStr + ">";
            state.dump = tagStr + " " + state.dump;
        }
    }
    return true;
}
function $10f8334abdfd44ee$var$getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    $10f8334abdfd44ee$var$inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function $10f8334abdfd44ee$var$inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === "object") {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)$10f8334abdfd44ee$var$inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)$10f8334abdfd44ee$var$inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function $10f8334abdfd44ee$var$dump$1(input, options) {
    options = options || {};
    var state = new $10f8334abdfd44ee$var$State(options);
    if (!state.noRefs) $10f8334abdfd44ee$var$getDuplicateReferences(input, state);
    var value = input;
    if (state.replacer) value = state.replacer.call({
        "": value
    }, "", value);
    if ($10f8334abdfd44ee$var$writeNode(state, 0, value, true, true)) return state.dump + "\n";
    return "";
}
var $10f8334abdfd44ee$var$dump_1 = $10f8334abdfd44ee$var$dump$1;
var $10f8334abdfd44ee$var$dumper = {
    dump: $10f8334abdfd44ee$var$dump_1
};
function $10f8334abdfd44ee$var$renamed(from, to) {
    return function() {
        throw new Error("Function yaml." + from + " is removed in js-yaml 4. " + "Use yaml." + to + " instead, which is now safe by default.");
    };
}
var $10f8334abdfd44ee$export$92738401e1603719 = $10f8334abdfd44ee$var$type;
var $10f8334abdfd44ee$export$19342e026b58ebb7 = $10f8334abdfd44ee$var$schema;
var $10f8334abdfd44ee$export$aefe34bace55c48e = $10f8334abdfd44ee$var$failsafe;
var $10f8334abdfd44ee$export$3f5573a59aee743 = $10f8334abdfd44ee$var$json;
var $10f8334abdfd44ee$export$cb27b7e9f9bc8fa8 = $10f8334abdfd44ee$var$core;
var $10f8334abdfd44ee$export$54192bc17d2d9e2a = $10f8334abdfd44ee$var$_default;
var $10f8334abdfd44ee$export$11e63f7b0f3d9900 = $10f8334abdfd44ee$var$loader.load;
var $10f8334abdfd44ee$export$7aabae09a30b04c2 = $10f8334abdfd44ee$var$loader.loadAll;
var $10f8334abdfd44ee$export$2069a8a5a76faa2 = $10f8334abdfd44ee$var$dumper.dump;
var $10f8334abdfd44ee$export$28af3d4da69ed747 = $10f8334abdfd44ee$var$exception;
// Re-export all types in case user wants to create custom schema
var $10f8334abdfd44ee$export$b14ad400b1d09e0f = {
    binary: $10f8334abdfd44ee$var$binary,
    float: $10f8334abdfd44ee$var$float,
    map: $10f8334abdfd44ee$var$map,
    null: $10f8334abdfd44ee$var$_null,
    pairs: $10f8334abdfd44ee$var$pairs,
    set: $10f8334abdfd44ee$var$set,
    timestamp: $10f8334abdfd44ee$var$timestamp,
    bool: $10f8334abdfd44ee$var$bool,
    int: $10f8334abdfd44ee$var$int,
    merge: $10f8334abdfd44ee$var$merge,
    omap: $10f8334abdfd44ee$var$omap,
    seq: $10f8334abdfd44ee$var$seq,
    str: $10f8334abdfd44ee$var$str
};
// Removed functions from JS-YAML 3.0.x
var $10f8334abdfd44ee$export$ecc08907c0e2af9b = $10f8334abdfd44ee$var$renamed("safeLoad", "load");
var $10f8334abdfd44ee$export$c2cc0f4fb6d29644 = $10f8334abdfd44ee$var$renamed("safeLoadAll", "loadAll");
var $10f8334abdfd44ee$export$befffea07f2abcf0 = $10f8334abdfd44ee$var$renamed("safeDump", "dump");
var $10f8334abdfd44ee$var$jsYaml = {
    Type: $10f8334abdfd44ee$export$92738401e1603719,
    Schema: $10f8334abdfd44ee$export$19342e026b58ebb7,
    FAILSAFE_SCHEMA: $10f8334abdfd44ee$export$aefe34bace55c48e,
    JSON_SCHEMA: $10f8334abdfd44ee$export$3f5573a59aee743,
    CORE_SCHEMA: $10f8334abdfd44ee$export$cb27b7e9f9bc8fa8,
    DEFAULT_SCHEMA: $10f8334abdfd44ee$export$54192bc17d2d9e2a,
    load: $10f8334abdfd44ee$export$11e63f7b0f3d9900,
    loadAll: $10f8334abdfd44ee$export$7aabae09a30b04c2,
    dump: $10f8334abdfd44ee$export$2069a8a5a76faa2,
    YAMLException: $10f8334abdfd44ee$export$28af3d4da69ed747,
    types: $10f8334abdfd44ee$export$b14ad400b1d09e0f,
    safeLoad: $10f8334abdfd44ee$export$ecc08907c0e2af9b,
    safeLoadAll: $10f8334abdfd44ee$export$c2cc0f4fb6d29644,
    safeDump: $10f8334abdfd44ee$export$befffea07f2abcf0
};
var $10f8334abdfd44ee$export$2e2bcd8739ae039 = $10f8334abdfd44ee$var$jsYaml;


var $fed6b3da2415082b$export$2e2bcd8739ae039 = (0, $10f8334abdfd44ee$export$2e2bcd8739ae039);


var $4cc80e2b7af52dab$var$ParseYAML = function(s) {
    if (typeof s === "string") try {
        return (0, $fed6b3da2415082b$export$2e2bcd8739ae039).load(s);
    } catch (e) {
        console.log(e);
        return undefined;
    }
    return s;
};
var $4cc80e2b7af52dab$export$2e2bcd8739ae039 = $4cc80e2b7af52dab$var$ParseYAML;



var $f729235a1609e0b9$var$GetTypeName = function(data, styles) {
    if (data.hasOwnProperty("$type")) return data.$type;
    // Get $type from styles[`#${data.name}`]
    if (data.hasOwnProperty("name")) {
        var style = styles[`#${data.name}`];
        if (style && style.hasOwnProperty("$type")) return style.$type;
    }
    if (data.hasOwnProperty("$class")) {
        var clasKeys = data.$class.split(" ");
        for(var i = 0, cnt = clasKeys.length; i < cnt; i++){
            var style = styles[`.${clasKeys[i]}`];
            if (style && style.hasOwnProperty("$type")) return style.$type;
        }
    }
// return undefined
};
var $f729235a1609e0b9$export$2e2bcd8739ae039 = $f729235a1609e0b9$var$GetTypeName;



var $012b7c3456f30351$var$DeepMerge = function(toObj, fromObj) {
    if (fromObj === undefined) return toObj;
    for(var key in fromObj)if (!toObj.hasOwnProperty(key)) // Only add nonexistent property
    toObj[key] = (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(fromObj[key]);
    else {
        var value = toObj[key];
        if (value && typeof value === "object") $012b7c3456f30351$var$DeepMerge(value, fromObj[key]);
    }
    return toObj;
};
var $012b7c3456f30351$export$2e2bcd8739ae039 = $012b7c3456f30351$var$DeepMerge;


/*
Priority of styles : name, $class, $type
  1. name    (#name)
  2. $class  (.class)
  3. $type   (type)    
*/ var $bbb635568cf67cae$var$MergeStyle = function(data, styles) {
    if (styles === undefined) return data;
    if (data.hasOwnProperty("name")) (0, $012b7c3456f30351$export$2e2bcd8739ae039)(data, styles[`#${data.name}`]);
    if (data.hasOwnProperty("$class")) {
        var clasKeys = data.$class.split(" ");
        for(var i = 0, cnt = clasKeys.length; i < cnt; i++)(0, $012b7c3456f30351$export$2e2bcd8739ae039)(data, styles[`.${clasKeys[i]}`]);
    }
    if (data.hasOwnProperty("$type")) (0, $012b7c3456f30351$export$2e2bcd8739ae039)(data, styles[data.$type]);
    return data;
};
var $bbb635568cf67cae$export$2e2bcd8739ae039 = $bbb635568cf67cae$var$MergeStyle;


const $85416be1a6ae9618$var$ProperiteList = [
    "tint",
    "alpha",
    "visible",
    "flipX",
    "flipY"
];
var $85416be1a6ae9618$var$SetTextureProperties = function(gameObject, data) {
    for(var i = 0, cnt = $85416be1a6ae9618$var$ProperiteList.length; i < cnt; i++){
        var key = $85416be1a6ae9618$var$ProperiteList[i];
        var value = data[key];
        if (value !== undefined) gameObject[key] = value;
    }
    if (data.cropResize && !gameObject.resize) gameObject.resize = function(width, height) {
        gameObject.setCrop(0, 0, width, height);
        return gameObject;
    };
    return gameObject;
};
var $85416be1a6ae9618$export$2e2bcd8739ae039 = $85416be1a6ae9618$var$SetTextureProperties;


var $dee1a20822321552$var$CreateAnyImage = function(scene, data, view, styles, customBuilders, ImageClass) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new ImageClass(scene, 0, 0, data.key, data.frame);
    if (data.width !== undefined) gameObject.setDisplayWidth(data.width);
    if (data.height !== undefined) gameObject.setDisplayHeight(data.height);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $dee1a20822321552$export$2e2bcd8739ae039 = $dee1a20822321552$var$CreateAnyImage;


const $ede0a96e215f74ee$var$PhaserImage = Phaser.GameObjects.Image;
var $ede0a96e215f74ee$var$CreateImage = function(scene, data, view, styles, customBuilders) {
    return (0, $dee1a20822321552$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, $ede0a96e215f74ee$var$PhaserImage);
};
var $ede0a96e215f74ee$export$2e2bcd8739ae039 = $ede0a96e215f74ee$var$CreateImage;



const $60a28fb52de9aa40$var$Sprite = Phaser.GameObjects.Sprite;
var $60a28fb52de9aa40$var$CreateSprite = function(scene, data, view, styles, customBuilders) {
    return (0, $dee1a20822321552$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, $60a28fb52de9aa40$var$Sprite);
};
var $60a28fb52de9aa40$export$2e2bcd8739ae039 = $60a28fb52de9aa40$var$CreateSprite;




const $50acc5246cc7f7ba$var$PhaserVideo = Phaser.GameObjects.Video;
var $50acc5246cc7f7ba$var$CreateVideo = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new $50acc5246cc7f7ba$var$PhaserVideo(scene, 0, 0, data.key);
    if (data.width !== undefined) gameObject.setDisplayWidth(data.width);
    if (data.height !== undefined) gameObject.setDisplayHeight(data.height);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $50acc5246cc7f7ba$export$2e2bcd8739ae039 = $50acc5246cc7f7ba$var$CreateVideo;




const $feefe0d5e0a45263$var$PhaserText = Phaser.GameObjects.Text;
var $feefe0d5e0a45263$var$CreateText = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new $feefe0d5e0a45263$var$PhaserText(scene, 0, 0, data.text, data);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $feefe0d5e0a45263$export$2e2bcd8739ae039 = $feefe0d5e0a45263$var$CreateText;





var $aaf39ce3442c6c0a$var$CreateBBCodeText = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new (0, $5c78a248668eabc1$export$2e2bcd8739ae039)(scene, 0, 0, data.text, data);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $aaf39ce3442c6c0a$export$2e2bcd8739ae039 = $aaf39ce3442c6c0a$var$CreateBBCodeText;




var $07b22d0d5445be63$var$CreateRoundRectangle = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new (0, $b4dc4d4434a4bd47$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $07b22d0d5445be63$export$2e2bcd8739ae039 = $07b22d0d5445be63$var$CreateRoundRectangle;





var $186ec75e57ae6951$var$CreateNinePatch = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new (0, $90d3e4359652cc6f$export$2e2bcd8739ae039)(scene, data);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $186ec75e57ae6951$export$2e2bcd8739ae039 = $186ec75e57ae6951$var$CreateNinePatch;




var $385b21b80fc24316$var$CreateNinePatch2 = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new (0, $ae77dc6441cab7f5$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $385b21b80fc24316$export$2e2bcd8739ae039 = $385b21b80fc24316$var$CreateNinePatch2;





var $e33542a24302a0a9$var$CreateCanvas = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var width = data.width || 1;
    var height = data.height || 1;
    var gameObject = new (0, $a7cd42622da8fab8$export$2e2bcd8739ae039)(scene, 0, 0, width, height);
    if (data.fill !== undefined) gameObject.fill(data.fill);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $e33542a24302a0a9$export$2e2bcd8739ae039 = $e33542a24302a0a9$var$CreateCanvas;





var $df57bea87cbf5577$var$CreateCircleMaskImage = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var gameObject = new (0, $931ba31fd5fc4735$export$2e2bcd8739ae039)(scene, 0, 0, data.key, data.frame, data);
    if (data.width !== undefined) gameObject.setDisplayWidth(data.width);
    if (data.height !== undefined) gameObject.setDisplayHeight(data.height);
    (0, $85416be1a6ae9618$export$2e2bcd8739ae039)(gameObject, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $df57bea87cbf5577$export$2e2bcd8739ae039 = $df57bea87cbf5577$var$CreateCircleMaskImage;



var $d3146dd63d08ffb2$var$CreateSpace = function(scene, data, view, styles, customBuilders) {
    var gameObject = new (0, $82ced9ca3c38b64a$export$2e2bcd8739ae039)(scene);
    // Don't add Zone into scene
    // this.scene.add.existing(gameObject);
    return gameObject;
};
var $d3146dd63d08ffb2$export$2e2bcd8739ae039 = $d3146dd63d08ffb2$var$CreateSpace;




var $c116b48efddca383$var$CreateChild = function(scene, data, subKey, view, styles, customBuilders) {
    var childData = data[subKey];
    if (!childData) return undefined;
    var child;
    child = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, childData, view, styles, customBuilders);
    data[subKey] = child;
    return child;
};
var $c116b48efddca383$export$2e2bcd8739ae039 = $c116b48efddca383$var$CreateChild;


var $24f00af8d167496a$var$ReplaceChildrenConfig = function(scene, childrenConfig, view, styles, customBuilders) {
    if (childrenConfig) {
        if (!Array.isArray(childrenConfig)) childrenConfig = [
            childrenConfig
        ];
        for(var i = 0, cnt = childrenConfig.length; i < cnt; i++){
            var childConfig = childrenConfig[i];
            if (!childConfig.$child) {
                childConfig = {
                    $child: childConfig
                };
                childrenConfig[i] = childConfig;
            }
            (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, childConfig, "$child", view, styles, customBuilders);
        }
    }
    return childrenConfig;
};
var $24f00af8d167496a$export$2e2bcd8739ae039 = $24f00af8d167496a$var$ReplaceChildrenConfig;


var $4154026f384f4790$var$CreateAnySizer = function(scene, data, view, styles, customBuilders, SizerClass) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var backgroundConfig = (0, $24f00af8d167496a$export$2e2bcd8739ae039)(scene, data.background, view, styles, customBuilders);
    var childrenConfig = (0, $24f00af8d167496a$export$2e2bcd8739ae039)(scene, data.children, view, styles, customBuilders);
    var gameObject = new SizerClass(scene, data);
    scene.add.existing(gameObject);
    if (backgroundConfig) for(var i = 0, cnt = backgroundConfig.length; i < cnt; i++){
        var childConfig = backgroundConfig[i];
        gameObject.addBackground(childConfig.$child, childConfig.padding);
    }
    if (childrenConfig) for(var i = 0, cnt = childrenConfig.length; i < cnt; i++){
        var childConfig = childrenConfig[i];
        gameObject.add(childConfig.$child, childConfig);
    }
    return gameObject;
};
var $4154026f384f4790$export$2e2bcd8739ae039 = $4154026f384f4790$var$CreateAnySizer;



var $d84d2fbcfb083ac0$var$CreateSizer = function(scene, data, view, styles, customBuilders) {
    return (0, $4154026f384f4790$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039));
};
var $d84d2fbcfb083ac0$export$2e2bcd8739ae039 = $d84d2fbcfb083ac0$var$CreateSizer;




var $ab308ed4b73c46ff$var$CreateFixWidthSizer = function(scene, data, view, styles, customBuilders) {
    return (0, $4154026f384f4790$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $92d11076da36f893$export$2e2bcd8739ae039));
};
var $ab308ed4b73c46ff$export$2e2bcd8739ae039 = $ab308ed4b73c46ff$var$CreateFixWidthSizer;





var $eafe09ed658062b6$var$CreateGridSizer = function(scene, data, view, styles, customBuilders) {
    // Build createCellContainerCallback
    var createCellContainerCallbackConfig = data.createCellContainerCallback;
    if (createCellContainerCallbackConfig) {
        var childData = createCellContainerCallbackConfig.$child;
        delete createCellContainerCallbackConfig.$child;
        data.createCellContainerCallback = function(scene, x, y, config) {
            var child = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, childData, view, styles, customBuilders);
            // Copy config
            for(var key in createCellContainerCallbackConfig)config[key] = createCellContainerCallbackConfig[key];
            return child;
        };
    }
    return (0, $4154026f384f4790$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $a949ee088f929daa$export$2e2bcd8739ae039));
};
var $eafe09ed658062b6$export$2e2bcd8739ae039 = $eafe09ed658062b6$var$CreateGridSizer;




var $25c1ea0095c4b50a$var$CreateOverlapSizer = function(scene, data, view, styles, customBuilders) {
    return (0, $4154026f384f4790$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $4d318a74c42de65b$export$2e2bcd8739ae039));
};
var $25c1ea0095c4b50a$export$2e2bcd8739ae039 = $25c1ea0095c4b50a$var$CreateOverlapSizer;






var $a4ed3cc3c94ab6b9$var$CreateChildren = function(scene, data, subKey, view, styles, customBuilders) {
    var childData = data[subKey];
    if (!childData) return undefined;
    if (Array.isArray(childData)) {
        for(var i = 0, cnt = childData.length; i < cnt; i++)if (Array.isArray(childData[i])) $a4ed3cc3c94ab6b9$var$CreateChildren(scene, childData, i, view, styles, customBuilders);
        else (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, childData, i, view, styles, customBuilders);
    } else for(var key in childData)(0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, childData, key, view, styles, customBuilders);
    return childData;
};
var $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039 = $a4ed3cc3c94ab6b9$var$CreateChildren;


var $e4299f61489afe63$var$CreateButtons = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "buttons", view, styles, customBuilders);
    var gameObject = new (0, $e713f60692044763$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $e4299f61489afe63$export$2e2bcd8739ae039 = $e4299f61489afe63$var$CreateButtons;






var $b4cf55ed316c3f99$var$CreateFixWidthButtons = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "buttons", view, styles, customBuilders);
    var gameObject = new (0, $1418690eca2b4065$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $b4cf55ed316c3f99$export$2e2bcd8739ae039 = $b4cf55ed316c3f99$var$CreateFixWidthButtons;







var $b56d357c63c67472$var$CreateGridButtons = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    var buttonsConfig = data.buttons; // Game objects in 2d array
    if (buttonsConfig) for(var i = 0, cnt = buttonsConfig.length; i < cnt; i++)(0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, buttonsConfig, i, view, styles, customBuilders);
    // Build createCellContainerCallback
    var createCellContainerCallbackConfig = data.createCellContainerCallback;
    if (createCellContainerCallbackConfig) {
        var childData = createCellContainerCallbackConfig.$child;
        delete createCellContainerCallbackConfig.$child;
        data.createCellContainerCallback = function(scene, x, y, config) {
            var child = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, childData, view, styles, customBuilders);
            // Copy config
            for(var key in createCellContainerCallbackConfig)config[key] = createCellContainerCallbackConfig[key];
            return child;
        };
    }
    var gameObject = new (0, $3ff850ea042009c0$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $b56d357c63c67472$export$2e2bcd8739ae039 = $b56d357c63c67472$var$CreateGridButtons;




var $3b9a2f8f8409ddfb$var$CreateAnyLabel = function(scene, data, view, styles, customBuilders, LabelClass) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "icon", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "text", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "action", view, styles, customBuilders);
    var gameObject = new LabelClass(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $3b9a2f8f8409ddfb$export$2e2bcd8739ae039 = $3b9a2f8f8409ddfb$var$CreateAnyLabel;



var $310ee0b61ad1fdcf$var$CreateLabel = function(scene, data, view, styles, customBuilders) {
    return (0, $3b9a2f8f8409ddfb$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $2ae0d347a90f71ca$export$2e2bcd8739ae039));
};
var $310ee0b61ad1fdcf$export$2e2bcd8739ae039 = $310ee0b61ad1fdcf$var$CreateLabel;





var $400e3e3991bd02a1$var$CreateBadgeLabel = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "main", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "leftTop", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "centerTop", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "rightTop", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "leftCenter", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "center", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "rightCenter", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "leftBottom", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "centerBottom", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "rightBottom", view, styles, customBuilders);
    var gameObject = new (0, $a1a15cacc45ad7fd$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $400e3e3991bd02a1$export$2e2bcd8739ae039 = $400e3e3991bd02a1$var$CreateBadgeLabel;






var $6daf0d44ce804a57$var$CreateDialog = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "toolbarBackground", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "leftToolbarBackground", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "choicesBackground", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "actionsBackground", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "title", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "toolbar", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "leftToolbar", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "content", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "description", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "choices", view, styles, customBuilders);
    (0, $a4ed3cc3c94ab6b9$export$2e2bcd8739ae039)(scene, data, "actions", view, styles, customBuilders);
    var gameObject = new (0, $c21a8bce83a7363c$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $6daf0d44ce804a57$export$2e2bcd8739ae039 = $6daf0d44ce804a57$var$CreateDialog;




var $8b1bb8f31b06a958$var$CreateTextBox = function(scene, data, view, styles, customBuilders) {
    return (0, $3b9a2f8f8409ddfb$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $920f50ff0285db84$export$2e2bcd8739ae039));
};
var $8b1bb8f31b06a958$export$2e2bcd8739ae039 = $8b1bb8f31b06a958$var$CreateTextBox;





var $b88cf4851d84ff32$var$CreateSlider = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "track", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "indicator", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "thumb", view, styles, customBuilders);
    var gameObject = new (0, $acd4b431e3164bd7$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $b88cf4851d84ff32$export$2e2bcd8739ae039 = $b88cf4851d84ff32$var$CreateSlider;






var $a21e45e0414f9adc$var$ReplaceSliderConfig = function(scene, sliderConfig, view, styles, customBuilders) {
    if (sliderConfig) {
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, sliderConfig, "background", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, sliderConfig, "track", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, sliderConfig, "indicator", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, sliderConfig, "thumb", view, styles, customBuilders);
    }
    return sliderConfig;
};
var $a21e45e0414f9adc$export$2e2bcd8739ae039 = $a21e45e0414f9adc$var$ReplaceSliderConfig;


var $e5dd915715b96230$var$CreateNumberBar = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "icon", view, styles, customBuilders);
    (0, $a21e45e0414f9adc$export$2e2bcd8739ae039)(scene, data.slider, view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "text", view, styles, customBuilders);
    var gameObject = new (0, $b79455eadeb99a69$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $e5dd915715b96230$export$2e2bcd8739ae039 = $e5dd915715b96230$var$CreateNumberBar;






var $88c5075f23c3a074$var$CreateScrollBar = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $a21e45e0414f9adc$export$2e2bcd8739ae039)(scene, data.slider, view, styles, customBuilders);
    var buttonsConfig = data.buttons;
    if (buttonsConfig) {
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, buttonsConfig, "top", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, buttonsConfig, "bottom", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, buttonsConfig, "left", view, styles, customBuilders);
        (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, buttonsConfig, "right", view, styles, customBuilders);
    }
    var gameObject = new (0, $e0992a47ab11a94a$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $88c5075f23c3a074$export$2e2bcd8739ae039 = $88c5075f23c3a074$var$CreateScrollBar;






var $581dbb54c2a7c191$var$CreateTextArea = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "text", view, styles, customBuilders);
    (0, $a21e45e0414f9adc$export$2e2bcd8739ae039)(scene, data.slider, view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "header", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "footer", view, styles, customBuilders);
    var gameObject = new (0, $876c0af2debb51b1$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $581dbb54c2a7c191$export$2e2bcd8739ae039 = $581dbb54c2a7c191$var$CreateTextArea;




var $658e74ca8c3728d5$var$CreatePages = function(scene, data, view, styles, customBuilders) {
    return (0, $4154026f384f4790$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $27d0a6de10246f93$export$2e2bcd8739ae039));
};
var $658e74ca8c3728d5$export$2e2bcd8739ae039 = $658e74ca8c3728d5$var$CreatePages;




var $1ab803cf2524779c$var$CreateToast = function(scene, data, view, styles, customBuilders) {
    return (0, $3b9a2f8f8409ddfb$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders, (0, $41a74c2cba0e0e57$export$2e2bcd8739ae039));
};
var $1ab803cf2524779c$export$2e2bcd8739ae039 = $1ab803cf2524779c$var$CreateToast;





var $b245f5b80547772e$var$CreateKnob = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "text", view, styles, customBuilders);
    var gameObject = new (0, $2c49d15ec30e2ec2$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $b245f5b80547772e$export$2e2bcd8739ae039 = $b245f5b80547772e$var$CreateKnob;





var $12a7b8d00fb7b0ce$var$CreateDialog = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    // Replace data by child game object
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "background", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "content", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "leftSide", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "rightSide", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "header", view, styles, customBuilders);
    (0, $c116b48efddca383$export$2e2bcd8739ae039)(scene, data, "footer", view, styles, customBuilders);
    var gameObject = new (0, $10c56e8ed684d538$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $12a7b8d00fb7b0ce$export$2e2bcd8739ae039 = $12a7b8d00fb7b0ce$var$CreateDialog;






var $4c94806c85d7e301$var$CreateMenu = function(scene, data, view, styles, customBuilders) {
    data = (0, $bbb635568cf67cae$export$2e2bcd8739ae039)(data, styles);
    var backgroundConfig = data.background;
    delete data.background;
    if (backgroundConfig) data.createBackgroundCallback = function(items) {
        var scene = items.scene;
        var gameObject = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(backgroundConfig), view, styles, customBuilders);
        return gameObject;
    };
    data.createButtonCallback = function(item, index, items) {
        // Don't deep-clone scene and $next properties
        var scene = item.scene;
        var $next = item.$next;
        delete item.scene;
        delete item.$next;
        var gameObject = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, (0, $207ab8eaca87355d$export$2e2bcd8739ae039)(item), view, styles, customBuilders);
        // Add scene, $next properties back
        item.scene = scene;
        item.$next = $next;
        return gameObject;
    };
    data.childrenKey = "$next";
    var gameObject = new (0, $6234e1332f70f2b6$export$2e2bcd8739ae039)(scene, data);
    scene.add.existing(gameObject);
    return gameObject;
};
var $4c94806c85d7e301$export$2e2bcd8739ae039 = $4c94806c85d7e301$var$CreateMenu;


var $ccbe2ea6b14b1662$var$Builders = {
    Image: (0, $ede0a96e215f74ee$export$2e2bcd8739ae039),
    Sprite: (0, $60a28fb52de9aa40$export$2e2bcd8739ae039),
    Video: (0, $50acc5246cc7f7ba$export$2e2bcd8739ae039),
    Text: (0, $feefe0d5e0a45263$export$2e2bcd8739ae039),
    BBCodeText: (0, $aaf39ce3442c6c0a$export$2e2bcd8739ae039),
    RoundRectangle: (0, $07b22d0d5445be63$export$2e2bcd8739ae039),
    Ninepatch: (0, $186ec75e57ae6951$export$2e2bcd8739ae039),
    Ninepatch2: (0, $385b21b80fc24316$export$2e2bcd8739ae039),
    Canvas: (0, $e33542a24302a0a9$export$2e2bcd8739ae039),
    CircleMaskImage: (0, $df57bea87cbf5577$export$2e2bcd8739ae039),
    Space: (0, $d3146dd63d08ffb2$export$2e2bcd8739ae039),
    Sizer: (0, $d84d2fbcfb083ac0$export$2e2bcd8739ae039),
    FixWidthSizer: (0, $ab308ed4b73c46ff$export$2e2bcd8739ae039),
    GridSizer: (0, $eafe09ed658062b6$export$2e2bcd8739ae039),
    OverlapSizer: (0, $25c1ea0095c4b50a$export$2e2bcd8739ae039),
    Buttons: (0, $e4299f61489afe63$export$2e2bcd8739ae039),
    FixWidthButtons: (0, $b4cf55ed316c3f99$export$2e2bcd8739ae039),
    GridButtons: (0, $b56d357c63c67472$export$2e2bcd8739ae039),
    Label: (0, $310ee0b61ad1fdcf$export$2e2bcd8739ae039),
    BadgeLabel: (0, $400e3e3991bd02a1$export$2e2bcd8739ae039),
    Dialog: (0, $6daf0d44ce804a57$export$2e2bcd8739ae039),
    TextBox: (0, $8b1bb8f31b06a958$export$2e2bcd8739ae039),
    Slider: (0, $b88cf4851d84ff32$export$2e2bcd8739ae039),
    NumberBar: (0, $e5dd915715b96230$export$2e2bcd8739ae039),
    ScrollBar: (0, $88c5075f23c3a074$export$2e2bcd8739ae039),
    TextArea: (0, $581dbb54c2a7c191$export$2e2bcd8739ae039),
    Pages: (0, $658e74ca8c3728d5$export$2e2bcd8739ae039),
    Toast: (0, $1ab803cf2524779c$export$2e2bcd8739ae039),
    Knob: (0, $b245f5b80547772e$export$2e2bcd8739ae039),
    HolyGrail: (0, $12a7b8d00fb7b0ce$export$2e2bcd8739ae039),
    Menu: (0, $4c94806c85d7e301$export$2e2bcd8739ae039)
};
var /*
function(scene, data, view, styles, customBuilders) {
    return gameObject;
}
*/ $ccbe2ea6b14b1662$export$2e2bcd8739ae039 = $ccbe2ea6b14b1662$var$Builders;


var $ad0b74db061c26ba$var$Make = function(scene, data, view, styles, customBuilders) {
    var type = (0, $f729235a1609e0b9$export$2e2bcd8739ae039)(data, styles);
    if (!type) {
        console.warn(`rexUI.Make: Can't get type name in ${JSON.stringify(data)}`);
        return undefined;
    }
    var callback;
    if (customBuilders) callback = customBuilders[type];
    if (!callback) callback = (0, $ccbe2ea6b14b1662$export$2e2bcd8739ae039)[type];
    if (!callback) {
        console.warn(`rexUI.Make: Can't create ${type} game object.`);
        return undefined;
    }
    var gameObject = callback(scene, data, view, styles, customBuilders);
    if (data.name) gameObject.setName(data.name);
    return gameObject;
};
var $ad0b74db061c26ba$export$2e2bcd8739ae039 = $ad0b74db061c26ba$var$Make;


var $6806bb709b7824b8$var$YAMLMake = function(scene, data, view, styles, customBuilders) {
    data = (0, $4cc80e2b7af52dab$export$2e2bcd8739ae039)(data);
    if (Array.isArray(data)) // Parsing result of YAML data might be an array, 
    // Only last item will be used to create game object, others are references
    data = data[data.length - 1];
    else if (data.$root) {
        // Parsing result of YAML data might be an object, with $root key, 
        // data.$root will be used to create game object, others are default styles
        var defaultStyles = data;
        data = data.$root;
        delete defaultStyles.$root;
        if (styles === undefined) styles = defaultStyles;
        else {
            for(var key in defaultStyles)if (!styles[key]) styles[key] = defaultStyles[key];
        }
    }
    styles = (0, $4cc80e2b7af52dab$export$2e2bcd8739ae039)(styles);
    var gameObject = (0, $ad0b74db061c26ba$export$2e2bcd8739ae039)(scene, data, view, styles, customBuilders);
    return gameObject;
};
var $6806bb709b7824b8$export$2e2bcd8739ae039 = $6806bb709b7824b8$var$YAMLMake;


const $9ba5dc1bd6025c80$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
class $9ba5dc1bd6025c80$var$Maker {
    constructor(scene, styles, customBuilders){
        this.setScene(scene);
        this.setStyles(styles);
        this.setBuilders(customBuilders);
    }
    setScene(scene) {
        this.scene = scene;
        return this;
    }
    setStyles(styles) {
        this.styles = (0, $4cc80e2b7af52dab$export$2e2bcd8739ae039)(styles);
        return this;
    }
    addStyle(key, style) {
        if (this.styles === undefined) this.styles = {};
        if (typeof key === "string" && style === undefined) key = (0, $4cc80e2b7af52dab$export$2e2bcd8739ae039)(key);
        if ($9ba5dc1bd6025c80$var$IsPlainObject(key)) {
            var styles = key;
            for(key in styles)this.styles[key] = styles[key];
        } else this.styles[key] = (0, $4cc80e2b7af52dab$export$2e2bcd8739ae039)(style);
        return this;
    }
    clearStyles() {
        this.setStyles();
        return this;
    }
    setBuilders(customBuilders) {
        this.customBuilders = customBuilders;
        return this;
    }
    addBuilder(key, customBuilder) {
        if (this.customBuilders === undefined) this.customBuilders = {};
        if ($9ba5dc1bd6025c80$var$IsPlainObject(key)) {
            var customBuilders = key;
            for(key in customBuilders)this.customBuilders[key] = customBuilders[key];
        } else this.customBuilders[key] = customBuilder;
        return this;
    }
    clearBuilder() {
        this.setBuilders();
        return this;
    }
    make(data, view) {
        return (0, $6806bb709b7824b8$export$2e2bcd8739ae039)(this.scene, data, view, this.styles, this.customBuilders);
    }
}
var $9ba5dc1bd6025c80$export$2e2bcd8739ae039 = $9ba5dc1bd6025c80$var$Maker;




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("maker", function(styles, customBuilders) {
    return new (0, $9ba5dc1bd6025c80$export$2e2bcd8739ae039)(this.scene, styles, customBuilders);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Maker", (0, $9ba5dc1bd6025c80$export$2e2bcd8739ae039));
var $3d9a40d0b9348240$export$2e2bcd8739ae039 = (0, $9ba5dc1bd6025c80$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("click", function(gameObject, config) {
    return new (0, $24e6f4a5f37412ea$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Click", (0, $24e6f4a5f37412ea$export$2e2bcd8739ae039));
var $b9596adf6ef19f75$export$2e2bcd8739ae039 = (0, $24e6f4a5f37412ea$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("clickOutside", function(gameObject, config) {
    return new (0, $9f1db0a44efe872e$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.ClickOutside", (0, $9f1db0a44efe872e$export$2e2bcd8739ae039));
var $5fab1666d30be681$export$2e2bcd8739ae039 = (0, $9f1db0a44efe872e$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("inTouching", function(gameObject, config) {
    return new (0, $213484a77f0b6ac4$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.InTouching", (0, $213484a77f0b6ac4$export$2e2bcd8739ae039));
var $fec876521d24eafc$export$2e2bcd8739ae039 = (0, $213484a77f0b6ac4$export$2e2bcd8739ae039);






(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("tap", function(gameObject, config) {
    if (!(0, $028756cbb60d16db$export$2e2bcd8739ae039)(gameObject)) {
        config = gameObject;
        gameObject = this.scene;
    }
    return new (0, $b0329087b2ba8053$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Tap", (0, $b0329087b2ba8053$export$2e2bcd8739ae039));
var $60cda596fdf85cf5$export$2e2bcd8739ae039 = (0, $b0329087b2ba8053$export$2e2bcd8739ae039);






(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("press", function(gameObject, config) {
    if (!(0, $028756cbb60d16db$export$2e2bcd8739ae039)(gameObject)) {
        config = gameObject;
        gameObject = this.scene;
    }
    return new (0, $4ba3c2f484e52118$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Press", (0, $4ba3c2f484e52118$export$2e2bcd8739ae039));
var $8e1c22fca7da5855$export$2e2bcd8739ae039 = (0, $4ba3c2f484e52118$export$2e2bcd8739ae039);






(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("swipe", function(gameObject, config) {
    if (!(0, $028756cbb60d16db$export$2e2bcd8739ae039)(gameObject)) {
        config = gameObject;
        gameObject = this.scene;
    }
    return new (0, $e375a08b6454e44f$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Swipe", (0, $e375a08b6454e44f$export$2e2bcd8739ae039));
var $2b303269f537fa86$export$2e2bcd8739ae039 = (0, $e375a08b6454e44f$export$2e2bcd8739ae039);



var $ea39fe822741bcb2$export$2e2bcd8739ae039 = (0, $158020c4c937b10c$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("pan", function(gameObject, config) {
    if (!(0, $028756cbb60d16db$export$2e2bcd8739ae039)(gameObject)) {
        config = gameObject;
        gameObject = this.scene;
    }
    return new (0, $ea39fe822741bcb2$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Pan", (0, $ea39fe822741bcb2$export$2e2bcd8739ae039));
var $d73fdf8be09b78eb$export$2e2bcd8739ae039 = (0, $ea39fe822741bcb2$export$2e2bcd8739ae039);




var $59d59543b8a9818e$var$RequestDrag = function(gameObject) {
    var inputPlugin = gameObject.scene.input;
    var inputManager = inputPlugin.manager;
    var pointersTotal = inputManager.pointersTotal;
    var pointers = inputManager.pointers, pointer;
    for(var i = 0; i < pointersTotal; i++){
        pointer = pointers[i];
        if (!pointer.primaryDown || inputPlugin.getDragState(pointer) !== 0 || !(0, $13b05035f77fdc38$export$2e2bcd8739ae039)(gameObject, pointer)) continue;
        // For 3.18.0
        inputPlugin.setDragState(pointer, 1);
        inputPlugin._drag[pointer.id] = [
            gameObject
        ];
        if (inputPlugin.dragDistanceThreshold === 0 || inputPlugin.dragTimeThreshold === 0) {
            //  No drag criteria, so snap immediately to mode 3
            inputPlugin.setDragState(pointer, 3);
            inputPlugin.processDragStartList(pointer);
        } else //  Check the distance / time on the next event
        inputPlugin.setDragState(pointer, 2);
        // For 3.18.0
        return true;
    }
    return false;
};
var $59d59543b8a9818e$export$2e2bcd8739ae039 = $59d59543b8a9818e$var$RequestDrag;


const $da284742ce66ba4d$var$GetValue = Phaser.Utils.Objects.GetValue;
const $da284742ce66ba4d$var$DistanceBetween = Phaser.Math.Distance.Between;
const $da284742ce66ba4d$var$RotateAroundDistance = Phaser.Math.RotateAroundDistance;
class $da284742ce66ba4d$var$Drag extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, {
            eventEmitter: false
        });
        // No event emitter
        // this.parent = gameObject;
        this._enable = undefined;
        gameObject.setInteractive($da284742ce66ba4d$var$GetValue(config, "inputConfig", undefined));
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        this.pointer = undefined;
        this.setEnable($da284742ce66ba4d$var$GetValue(o, "enable", true));
        this.setAxisMode($da284742ce66ba4d$var$GetValue(o, "axis", 0));
        this.setAxisRotation($da284742ce66ba4d$var$GetValue(o, "rotation", 0));
        return this;
    }
    toJSON() {
        return {
            enable: this.enable,
            axis: this.axisMode,
            rotation: this.axisRotation
        };
    }
    boot() {
        var gameObject = this.parent;
        gameObject.on("dragstart", this.onDragStart, this);
        gameObject.on("drag", this.onDrag, this);
        gameObject.on("dragend", this.onDragEnd, this);
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        // GameObject events will be removed when this gameObject destroyed 
        // this.parent.on('dragstart', this.onDragStart, this);
        // this.parent.on('drag', this.onDrag, this);
        // this.parent.on('dragend', this.onDragEnd, this);
        this.pointer = undefined;
        super.shutdown(fromScene);
    }
    get enable() {
        return this._enable;
    }
    set enable(e) {
        if (this._enable === e) return;
        if (!e) this.dragend();
        this._enable = e;
        this.scene.input.setDraggable(this.parent, e);
        return this;
    }
    setEnable(e) {
        if (e === undefined) e = true;
        this.enable = e;
        return this;
    }
    toggleEnable() {
        this.setEnable(!this.enable);
        return this;
    }
    setAxisMode(m) {
        if (typeof m === "string") m = $da284742ce66ba4d$var$DIRECTIONNODE[m];
        this.axisMode = m;
        return this;
    }
    setAxisRotation(a) {
        this.axisRotation = a;
        return this;
    }
    drag() {
        (0, $59d59543b8a9818e$export$2e2bcd8739ae039)(this.parent);
        return this;
    }
    dragend() {
        if (!this.isDragging) return;
        this.scene.input.setDragState(this.pointer, 5);
        return this;
    }
    onDragStart(pointer, dragX, dragY) {
        if (this.isDragging) return;
        this.pointer = pointer;
    }
    onDrag(pointer, dragX, dragY) {
        if (this.pointer !== pointer) return;
        var gameObject = this.parent;
        if (this.axisMode === 0) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        } else if (this.axisRotation === 0) {
            if (this.axisMode === 1) gameObject.x = dragX;
            else if (this.axisMode === 2) gameObject.y = dragY;
        } else {
            var dist;
            var p1 = {
                x: dragX,
                y: dragY
            };
            dist = $da284742ce66ba4d$var$DistanceBetween(p1.x, p1.y, gameObject.x, gameObject.y);
            p1 = $da284742ce66ba4d$var$RotateAroundDistance(p1, gameObject.x, gameObject.y, -this.axisRotation, dist);
            if (this.axisMode === 1) p1.y = gameObject.y;
            else if (this.axisMode === 2) p1.x = gameObject.x;
            dist = $da284742ce66ba4d$var$DistanceBetween(p1.x, p1.y, gameObject.x, gameObject.y);
            p1 = $da284742ce66ba4d$var$RotateAroundDistance(p1, gameObject.x, gameObject.y, this.axisRotation, dist);
            gameObject.x = p1.x;
            gameObject.y = p1.y;
        }
    }
    onDragEnd(pointer, dragX, dragY, dropped) {
        if (this.pointer !== pointer) return;
        this.pointer = undefined;
    }
    get isDragging() {
        return this.pointer !== undefined;
    }
}
const $da284742ce66ba4d$var$DIRECTIONNODE = {
    "both": 0,
    "h&v": 0,
    "x&y": 0,
    "horizontal": 1,
    "h": 1,
    "x": 1,
    "vertical": 2,
    "v": 2,
    "y": 2
};
var $da284742ce66ba4d$export$2e2bcd8739ae039 = $da284742ce66ba4d$var$Drag;


var $e3907c2937ea91a6$export$2e2bcd8739ae039 = (0, $da284742ce66ba4d$export$2e2bcd8739ae039);


var $5557714d928b1187$export$2e2bcd8739ae039 = (0, $e3907c2937ea91a6$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("drag", function(gameObject, config) {
    return new (0, $5557714d928b1187$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Drag", (0, $5557714d928b1187$export$2e2bcd8739ae039));
var $0fb3f6dfeed9bdbf$export$2e2bcd8739ae039 = (0, $5557714d928b1187$export$2e2bcd8739ae039);



var $dedff75c01ca50d8$export$2e2bcd8739ae039 = (0, $2473314c4f700424$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("pinch", function(config) {
    return new (0, $dedff75c01ca50d8$export$2e2bcd8739ae039)(this.scene, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Pinch", (0, $dedff75c01ca50d8$export$2e2bcd8739ae039));
var $bfbb65ebac877a3e$export$2e2bcd8739ae039 = (0, $dedff75c01ca50d8$export$2e2bcd8739ae039);



var $bfd337961e1293fe$export$2e2bcd8739ae039 = (0, $e931bff4dafc605f$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("rotate", function(config) {
    return new (0, $bfd337961e1293fe$export$2e2bcd8739ae039)(this.scene, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Rotate", (0, $bfd337961e1293fe$export$2e2bcd8739ae039));
var $fcd695dff2cb30ef$export$2e2bcd8739ae039 = (0, $bfd337961e1293fe$export$2e2bcd8739ae039);



const $90d715a4f0fc4805$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $90d715a4f0fc4805$var$GetValue = Phaser.Utils.Objects.GetValue;
var $90d715a4f0fc4805$var$GetFrameUpdatingCallback = function(key, frame, gameObject) {
    var callback;
    if (key === undefined) {
        key = gameObject.texture.key;
        frame = gameObject.frame.name;
    } else if ($90d715a4f0fc4805$var$IsPlainObject(key)) {
        var config = key;
        key = $90d715a4f0fc4805$var$GetValue(config, "key", gameObject.texture.key);
        frame = $90d715a4f0fc4805$var$GetValue(config, "frame", gameObject.frame.name);
    } else if (typeof key === "string") ;
    else callback = key;
    if (callback === undefined) callback = function(gameObject) {
        gameObject.setTexture(key, frame);
    };
    return callback;
};
var $90d715a4f0fc4805$export$2e2bcd8739ae039 = $90d715a4f0fc4805$var$GetFrameUpdatingCallback;


const $6ea79c8e3f08eb6e$var$GetValue = Phaser.Utils.Objects.GetValue;
const $6ea79c8e3f08eb6e$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $6ea79c8e3f08eb6e$var$Linear = Phaser.Math.Linear;
class $6ea79c8e3f08eb6e$var$Flip extends (0, $ee7bf184597091ca$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject, config);
        // this.parent = gameObject;
        // this.timer
        this.resetFromJSON(config);
        this.boot();
    }
    resetFromJSON(o) {
        super.resetFromJSON(o);
        this.setDuration($6ea79c8e3f08eb6e$var$GetAdvancedValue(o, "duration", 500));
        this.setEase($6ea79c8e3f08eb6e$var$GetValue(o, "ease", "Sine"));
        this.setOrientation($6ea79c8e3f08eb6e$var$GetValue(o, "orientation", 0));
        this.setFrontFace($6ea79c8e3f08eb6e$var$GetValue(o, "front", undefined));
        this.setBackFace($6ea79c8e3f08eb6e$var$GetValue(o, "back", undefined));
        this.setFace($6ea79c8e3f08eb6e$var$GetValue(o, "face", 0));
        return this;
    }
    setOrientation(orientation) {
        if (typeof orientation === "string") orientation = $6ea79c8e3f08eb6e$var$ORIENTATIONMODE[orientation];
        this.orientation = orientation;
        return this;
    }
    get face() {
        return this._face;
    }
    set face(face) {
        if (typeof face === "string") face = $6ea79c8e3f08eb6e$var$FACEMODE[face];
        this._face = face;
        if (face === 0 && this.frontFaceCallback) this.frontFaceCallback(this.parent);
        else if (face === 1 && this.backFaceCallback) this.backFaceCallback(this.parent);
    }
    setFace(face) {
        this.face = face;
        return this;
    }
    toggleFace() {
        var newFace = this.face === 0 ? 1 : 0;
        this.setFace(newFace);
        return this;
    }
    setFrontFace(key, frame) {
        this.frontFaceCallback = (0, $90d715a4f0fc4805$export$2e2bcd8739ae039)(key, frame, this.parent);
        return this;
    }
    setBackFace(key, frame) {
        this.backFaceCallback = (0, $90d715a4f0fc4805$export$2e2bcd8739ae039)(key, frame, this.parent);
        return this;
    }
    start() {
        if (this.timer.isRunning) return this;
        var gameObject = this.parent;
        if (this.orientation === 0) this.scale0 = gameObject.scaleX;
        else this.scale0 = gameObject.scaleY;
        this.timer.setDelay(this.delay).setDuration(this.duration / 2).setRepeat(1); // 2 times
        super.start();
        return this;
    }
    flip(duration) {
        if (this.isRunning) return this;
        if (duration !== undefined) this.setDuration(duration);
        this.start();
        return this;
    }
    updateGameObject(gameObject, timer) {
        if (timer.justRestart) this.toggleFace();
        var t = timer.t;
        if (timer.isOddIteration) t = 1 - t;
        t = this.easeFn(t);
        var value = $6ea79c8e3f08eb6e$var$Linear(this.scale0, 0, t);
        if (this.orientation === 0) gameObject.scaleX = value;
        else gameObject.scaleY = value;
    }
}
const $6ea79c8e3f08eb6e$var$ORIENTATIONMODE = {
    x: 0,
    horizontal: 0,
    y: 1,
    vertical: 1
};
const $6ea79c8e3f08eb6e$var$FACEMODE = {
    front: 0,
    back: 1
};
var $6ea79c8e3f08eb6e$export$2e2bcd8739ae039 = $6ea79c8e3f08eb6e$var$Flip;


var $23797362128ad0bd$export$2e2bcd8739ae039 = (0, $6ea79c8e3f08eb6e$export$2e2bcd8739ae039);


var $ff0c048786464ff9$export$2e2bcd8739ae039 = (0, $23797362128ad0bd$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("flip", function(gameObject, config) {
    return new (0, $ff0c048786464ff9$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Flip", (0, $ff0c048786464ff9$export$2e2bcd8739ae039));
var $4273e3ff5c5f7a71$export$2e2bcd8739ae039 = (0, $ff0c048786464ff9$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("shake", function(gameObject, config) {
    return new (0, $6ab2998d09e67d74$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Shake", (0, $6ab2998d09e67d74$export$2e2bcd8739ae039));
var $a4284105ada4e8ab$export$2e2bcd8739ae039 = (0, $6ab2998d09e67d74$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("touchEventStop", function(gameObject, config) {
    return new (0, $2b20d0e3b0aea15b$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TouchEventStop", (0, $2b20d0e3b0aea15b$export$2e2bcd8739ae039));
var $55381283131ad642$export$2e2bcd8739ae039 = (0, $2b20d0e3b0aea15b$export$2e2bcd8739ae039);



var $f2fdda5773a1144d$export$2e2bcd8739ae039 = (0, $7ff63fc496eb7b81$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("perspective", function(gameObject, config) {
    return new (0, $f2fdda5773a1144d$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Perspective", (0, $f2fdda5773a1144d$export$2e2bcd8739ae039));
var $c254514737ba7bd2$export$2e2bcd8739ae039 = (0, $f2fdda5773a1144d$export$2e2bcd8739ae039);


const $c0c2a9344c317a37$var$RotateAround = Phaser.Math.RotateAround;
var $c0c2a9344c317a37$export$c103c79eea6a04dc = function(gameObject, localX, localY) {
    var ox = gameObject.width / 2;
    var oy = gameObject.height / 2;
    $c0c2a9344c317a37$var$out.x = localX - ox;
    $c0c2a9344c317a37$var$out.y = localY - oy;
    $c0c2a9344c317a37$var$RotateAround($c0c2a9344c317a37$var$out, 0, 0, gameObject.rotation);
    $c0c2a9344c317a37$var$out.x *= gameObject.scaleX;
    $c0c2a9344c317a37$var$out.y *= gameObject.scaleY;
    $c0c2a9344c317a37$var$out.x += gameObject.x;
    $c0c2a9344c317a37$var$out.y += gameObject.y;
    return $c0c2a9344c317a37$var$out;
};
var $c0c2a9344c317a37$export$79c19e31ed77eb4b = function(gameObject, worldX, worldY) {
    var ox = gameObject.width / 2;
    var oy = gameObject.height / 2;
    $c0c2a9344c317a37$var$out.x = worldX - gameObject.x;
    $c0c2a9344c317a37$var$out.y = worldY - gameObject.y;
    $c0c2a9344c317a37$var$out.x /= gameObject.scaleX;
    $c0c2a9344c317a37$var$out.y /= gameObject.scaleY;
    $c0c2a9344c317a37$var$RotateAround($c0c2a9344c317a37$var$out, 0, 0, -gameObject.rotation);
    $c0c2a9344c317a37$var$out.x += ox;
    $c0c2a9344c317a37$var$out.y += oy;
    return $c0c2a9344c317a37$var$out;
};
var $c0c2a9344c317a37$var$out = {
    x: 0,
    y: 0
};


class $dd7cf56b9f0e25fb$var$ControlPoint {
    constructor(parent, vertex){
        this.parent = parent;
        this.vertex = vertex;
        this._localX = undefined;
        this._localY = undefined;
    }
    destroy() {
        this.parent = undefined;
        this.vertex = undefined;
    }
    updateVertexPosition(x, y) {
        var gameObject = this.parent;
        var srcHeight = gameObject.height;
        var vHalfWidth = gameObject.frame.cutWidth / srcHeight / 2;
        var vHalfHeight = gameObject.frame.cutHeight / srcHeight / 2;
        var vx = x / srcHeight - vHalfWidth;
        var vy = y / srcHeight - vHalfHeight;
        var vertex = this.vertex;
        vertex.x = vx;
        vertex.y = -vy;
        gameObject.forceUpdate();
        return this;
    }
    get localX() {
        return this._localX;
    }
    set localX(x) {
        this.setLocalXY(x, this._localY);
    }
    get localY() {
        return this._localY;
    }
    set localY(y) {
        this.setLocalXY(this._localX, y);
    }
    get localXOrigin() {
        return this._localXOrigin;
    }
    get localYOrigin() {
        return this._localYOrigin;
    }
    resetLocalXY(x, y) {
        this._localXOrigin = x;
        this._localYOrigin = y;
        this._localX = x;
        this._localY = y;
        return this;
    }
    setLocalXY(x, y, ignoreUpdateVertex) {
        if (this._localX === x && this._localY === y) return this;
        this._localX = x;
        this._localY = y;
        if (!ignoreUpdateVertex) this.updateVertexPosition(x, y);
        return this;
    }
    setWorldXY(x, y) {
        if (this._worldX === x && this._worldY === y) return this;
        var localXY = (0, $c0c2a9344c317a37$export$79c19e31ed77eb4b)(this.parent, x, y);
        this.setLocalXY(localXY.x, localXY.y);
        return this;
    }
    setPosition(x, y) {
        this.setWorldXY(x, y);
        return this;
    }
    getWorldXY() {
        return (0, $c0c2a9344c317a37$export$c103c79eea6a04dc)(this.parent, this._localX, this._localY);
    }
    get x() {
        var worldXY = (0, $c0c2a9344c317a37$export$c103c79eea6a04dc)(this.parent, this._localX, this._localY);
        return worldXY.x;
    }
    set x(x) {
        this.setWorldXY(x, this.y);
    }
    get y() {
        var worldXY = (0, $c0c2a9344c317a37$export$c103c79eea6a04dc)(this.parent, this._localX, this._localY);
        return worldXY.y;
    }
    set y(y) {
        this.setWorldXY(this.x, y);
    }
}
var $dd7cf56b9f0e25fb$export$2e2bcd8739ae039 = $dd7cf56b9f0e25fb$var$ControlPoint;


const $7a6579c0670827b1$var$Vertex = Phaser.Geom.Mesh.Vertex;
const $7a6579c0670827b1$var$Face = Phaser.Geom.Mesh.Face;
var $7a6579c0670827b1$var$InitFaces = function(quad) {
    var isNinePointMode = quad.isNinePointMode;
    var pointCount = isNinePointMode ? 9 : 4;
    var vertices = quad.vertices;
    var faces = quad.faces;
    var controlPoints = quad.controlPoints;
    for(var i = 0; i < pointCount; i++){
        var vertex = new $7a6579c0670827b1$var$Vertex();
        vertices.push(vertex);
        controlPoints.push(new (0, $dd7cf56b9f0e25fb$export$2e2bcd8739ae039)(quad, vertex));
    }
    var indices;
    if (isNinePointMode) indices = $7a6579c0670827b1$var$NinePointsIndices;
    else if (!quad.fourPointsModeRTL) indices = $7a6579c0670827b1$var$FourPointsIndices;
    else indices = $7a6579c0670827b1$var$FourPointsIndicesRTL;
    for(var i = 0, cnt = indices.length; i < cnt; i += 3){
        var vert1 = vertices[indices[i + 0]];
        var vert2 = vertices[indices[i + 1]];
        var vert3 = vertices[indices[i + 2]];
        faces.push(new $7a6579c0670827b1$var$Face(vert1, vert2, vert3));
    }
    if (isNinePointMode) {
        quad.topLeft = controlPoints[0];
        quad.topCenter = controlPoints[1];
        quad.topRight = controlPoints[2];
        quad.centerLeft = controlPoints[3];
        quad.center = controlPoints[4];
        quad.centerRight = controlPoints[5];
        quad.bottomLeft = controlPoints[6];
        quad.bottomCenter = controlPoints[7];
        quad.bottomRight = controlPoints[8];
    } else {
        quad.topLeft = controlPoints[0];
        quad.topRight = controlPoints[1];
        quad.bottomLeft = controlPoints[2];
        quad.bottomRight = controlPoints[3];
    }
};
/*
0, 1,
2, 3,
*/ const $7a6579c0670827b1$var$FourPointsIndices = [
    0,
    2,
    3,
    0,
    3,
    1
];
const $7a6579c0670827b1$var$FourPointsIndicesRTL = [
    1,
    3,
    2,
    1,
    2,
    0
];
/*
0, 1, 2,
3, 4, 5,
6, 7, 8
*/ const $7a6579c0670827b1$var$NinePointsIndices = [
    0,
    3,
    4,
    0,
    4,
    1,
    1,
    4,
    2,
    4,
    5,
    2,
    3,
    6,
    4,
    6,
    7,
    4,
    4,
    7,
    8,
    4,
    8,
    5
];
var $7a6579c0670827b1$export$2e2bcd8739ae039 = $7a6579c0670827b1$var$InitFaces;


var $14abf2eb05370438$var$GetPointPosition = function(quad) {
    var points;
    var top = 0, bottom = quad.height, left = 0, right = quad.width;
    if (quad.isNinePointMode) {
        var centerX = (left + right) / 2;
        var centerY = (top + bottom) / 2;
        points = [
            left,
            top,
            centerX,
            top,
            right,
            top,
            left,
            centerY,
            centerX,
            centerY,
            right,
            centerY,
            left,
            bottom,
            centerX,
            bottom,
            right,
            bottom // bottom-right
        ];
    } else points = [
        left,
        top,
        right,
        top,
        left,
        bottom,
        right,
        bottom // bottom-right
    ];
    return points;
};
var $14abf2eb05370438$export$2e2bcd8739ae039 = $14abf2eb05370438$var$GetPointPosition;


const $82e5fd458768c1fd$var$Mesh = Phaser.GameObjects.Mesh;
const $82e5fd458768c1fd$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $82e5fd458768c1fd$var$GetValue = Phaser.Utils.Objects.GetValue;
class $82e5fd458768c1fd$var$Image extends $82e5fd458768c1fd$var$Mesh {
    constructor(scene, x, y, key, frame, config){
        if ($82e5fd458768c1fd$var$IsPlainObject(x)) {
            config = x;
            x = $82e5fd458768c1fd$var$GetValue(config, "x", 0);
            y = $82e5fd458768c1fd$var$GetValue(config, "y", 0);
            key = $82e5fd458768c1fd$var$GetValue(config, "key", null);
            frame = $82e5fd458768c1fd$var$GetValue(config, "frame", null);
        }
        super(scene, x, y, key, frame);
        this.type = "rexQuadImage";
        this.isNinePointMode = $82e5fd458768c1fd$var$GetValue(config, "ninePointMode", false);
        this.fourPointsModeRTL = $82e5fd458768c1fd$var$GetValue(config, "rtl", false);
        this.controlPoints = [];
        (0, $7a6579c0670827b1$export$2e2bcd8739ae039)(this);
        this.hideCCW = false;
        this.syncSize();
    }
    preDestroy() {
        for(var i = 0, cnt = this.controlPoints.length; i < cnt; i++)this.controlPoints[i].destroy();
        this.controlPoints = undefined;
        super.preDestroy();
    }
    resetVerts() {
        // Clear faces and vertices        
        this.dirtyCache[9] = -1;
        var points = (0, $14abf2eb05370438$export$2e2bcd8739ae039)(this);
        // Calculate vertex data
        var srcWidth = this.width;
        var srcHeight = this.height;
        var vHalfWidth = this.frame.cutWidth / srcHeight / 2;
        var vHalfHeight = this.frame.cutHeight / srcHeight / 2;
        var flipY = this.frame.source.isRenderTexture;
        var frameU0 = this.frame.u0;
        var frameU1 = this.frame.u1;
        var frameV0 = !flipY ? this.frame.v0 : this.frame.v1;
        var frameV1 = !flipY ? this.frame.v1 : this.frame.v0;
        var frameU = frameU1 - frameU0;
        var frameV = frameV1 - frameV0;
        // Update vertex
        var controlPoints = this.controlPoints;
        for(var i = 0, cnt = points.length; i < cnt; i += 2){
            var px = points[i + 0];
            var py = points[i + 1];
            var vertexIndex = i / 2;
            var x = px / srcHeight - vHalfWidth;
            var y = py / srcHeight - vHalfHeight;
            var u = frameU0 + frameU * (px / srcWidth);
            var v = frameV0 + frameV * (py / srcHeight);
            this.vertices[vertexIndex].set(x, -y, 0).setUVs(u, v);
            controlPoints[vertexIndex].resetLocalXY(px, py);
        }
        return this;
    }
    syncSize() {
        this.setSizeToFrame(); // Reset size
        this.setOrtho(this.width / this.height, 1);
        this.resetVerts(); // Reset verts
        return this;
    }
    forceUpdate() {
        this.dirtyCache[10] = 1;
        return this;
    }
    get tint() {
        if (this.vertices.length === 0) return 0xffffff;
        else return this.vertices[0].color;
    }
    set tint(value) {
        var vertices = this.vertices;
        for(var i = 0, cnt = vertices.length; i < cnt; i++)vertices[i].color = value;
    }
    setTint(color) {
        this.tint = color;
        return this;
    }
}
var $82e5fd458768c1fd$export$2e2bcd8739ae039 = $82e5fd458768c1fd$var$Image;




const $9bac87d98f4ebcf8$var$RT = Phaser.GameObjects.RenderTexture;
const $9bac87d98f4ebcf8$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $9bac87d98f4ebcf8$var$GetValue = Phaser.Utils.Objects.GetValue;
class $9bac87d98f4ebcf8$var$RenderTexture extends (0, $82e5fd458768c1fd$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height, config){
        if ($9bac87d98f4ebcf8$var$IsPlainObject(x)) {
            config = x;
            x = $9bac87d98f4ebcf8$var$GetValue(config, "x", 0);
            y = $9bac87d98f4ebcf8$var$GetValue(config, "y", 0);
            width = $9bac87d98f4ebcf8$var$GetValue(config, "width", 32);
            height = $9bac87d98f4ebcf8$var$GetValue(config, "height", 32);
        }
        // render-texture -> quad-image
        var rt = new $9bac87d98f4ebcf8$var$RT(scene, x, y, width, height).setOrigin(0.5);
        super(scene, x, y, rt.texture.key, null, config);
        this.type = "rexQuadRenderTexture";
        this.rt = rt;
    }
    destroy(fromScene) {
        super.destroy(fromScene);
        this.rt.destroy();
        this.rt = null;
    }
    snapshot(gameObjects, config) {
        if (config === undefined) config = {};
        config.gameObjects = gameObjects;
        config.renderTexture = this.rt;
        (0, $77b8570de39b9238$export$2e2bcd8739ae039)(config);
        if (this.width !== this.frame.realWidth || this.height !== this.frame.realHeight) this.syncSize();
        return this;
    }
}
var $9bac87d98f4ebcf8$export$2e2bcd8739ae039 = $9bac87d98f4ebcf8$var$RenderTexture;



var $4b644940d49eead8$var$Skew = function(gameObject, skewX, skewY) {
    if (skewX === undefined) skewX = 0;
    if (skewY === undefined) skewY = 0;
    var width = gameObject.width, height = gameObject.height;
    var ox = width * 0.5;
    var oy = height * 0.5;
    var xOffset = Math.tan(skewX) * oy;
    var yOffset = Math.tan(skewY) * ox;
    var controlPoints = gameObject.controlPoints;
    for(var i = 0, cnt = controlPoints.length; i < cnt; i++){
        var controlPoint = controlPoints[i];
        var x = controlPoint.localXOrigin;
        var y = controlPoint.localYOrigin;
        controlPoint.localX = x + (y > oy ? xOffset : -xOffset);
        controlPoint.localY = y + (x > ox ? yOffset : -yOffset);
    }
};
var $4b644940d49eead8$export$2e2bcd8739ae039 = $4b644940d49eead8$var$Skew;


const $07569d31253e1519$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $07569d31253e1519$var$GetValue = Phaser.Utils.Objects.GetValue;
const $07569d31253e1519$var$DegToRad = Phaser.Math.DegToRad;
const $07569d31253e1519$var$RadToDeg = Phaser.Math.RadToDeg;
class $07569d31253e1519$var$SkewImage extends (0, $82e5fd458768c1fd$export$2e2bcd8739ae039) {
    constructor(scene, x, y, key, frame){
        if ($07569d31253e1519$var$IsPlainObject(x)) {
            var config = x;
            x = $07569d31253e1519$var$GetValue(config, "x", 0);
            y = $07569d31253e1519$var$GetValue(config, "y", 0);
            key = $07569d31253e1519$var$GetValue(config, "key", null);
            frame = $07569d31253e1519$var$GetValue(config, "frame", null);
        }
        super(scene, x, y, key, frame);
        this.type = "rexSkewmage";
        this._skewX = 0;
        this._skewY = 0;
    }
    get skewX() {
        return this._skewX;
    }
    set skewX(value) {
        this._skewX = value;
        (0, $4b644940d49eead8$export$2e2bcd8739ae039)(this, this._skewX, this._skewY);
    }
    get skewXDeg() {
        return $07569d31253e1519$var$RadToDeg(this._skewX);
    }
    set skewXDeg(value) {
        this.skewX = $07569d31253e1519$var$DegToRad(value);
    }
    get skewY() {
        return this._skewY;
    }
    set skewY(value) {
        this._skewY = value;
        (0, $4b644940d49eead8$export$2e2bcd8739ae039)(this, this._skewX, this._skewY);
    }
    get skewYDeg() {
        return $07569d31253e1519$var$RadToDeg(this._skewY);
    }
    set skewYDeg(value) {
        this.skewY = $07569d31253e1519$var$DegToRad(value);
    }
    setSkewX(skewX) {
        this.skewX = skewX;
        return this;
    }
    setSkewY(skewY) {
        this.skewY = skewY;
        return this;
    }
    setSkew(skewX, skewY) {
        if (skewY === undefined) skewY = skewX;
        this.skewX = skewX;
        this.skewY = skewY;
        return this;
    }
    setSkewXDeg(skewX) {
        this.skewXDeg = skewX;
        return this;
    }
    setSkewYDeg(skewY) {
        this.skewYDeg = skewY;
        return this;
    }
    setSkewDeg(skewX, skewY) {
        if (skewY === undefined) skewY = skewX;
        this.skewXDeg = skewX;
        this.skewYDeg = skewY;
        return this;
    }
}
var $07569d31253e1519$export$2e2bcd8739ae039 = $07569d31253e1519$var$SkewImage;



const $4665f590026745e6$var$RT = Phaser.GameObjects.RenderTexture;
const $4665f590026745e6$var$IsPlainObject = Phaser.Utils.Objects.IsPlainObject;
const $4665f590026745e6$var$GetValue = Phaser.Utils.Objects.GetValue;
class $4665f590026745e6$var$SkewRenderTexture extends (0, $07569d31253e1519$export$2e2bcd8739ae039) {
    constructor(scene, x, y, width, height){
        if ($4665f590026745e6$var$IsPlainObject(x)) {
            var config = x;
            x = $4665f590026745e6$var$GetValue(config, "x", 0);
            y = $4665f590026745e6$var$GetValue(config, "y", 0);
            width = $4665f590026745e6$var$GetValue(config, "width", 32);
            height = $4665f590026745e6$var$GetValue(config, "height", 32);
        }
        // render-texture -> skew-image
        var rt = new $4665f590026745e6$var$RT(scene, x, y, width, height).setOrigin(0.5);
        super(scene, x, y, rt.texture.key, null);
        this.type = "rexSkewRenderTexture";
        this.rt = rt;
    }
    destroy(fromScene) {
        super.destroy(fromScene);
        this.rt.destroy();
        this.rt = null;
    }
}
var $4665f590026745e6$export$2e2bcd8739ae039 = $4665f590026745e6$var$SkewRenderTexture;




class $f7526be2914d9cd4$var$ContainerSkew extends (0, $a804e9f9da8a6b4c$export$2e2bcd8739ae039)((0, $4665f590026745e6$export$2e2bcd8739ae039)) {
    get skewState() {
        return this.isRunning;
    }
}
var $f7526be2914d9cd4$export$2e2bcd8739ae039 = $f7526be2914d9cd4$var$ContainerSkew;




var $342d002cc9d2795b$export$2e2bcd8739ae039 = (0, $f7526be2914d9cd4$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("skew", function(gameObject, config) {
    return new (0, $342d002cc9d2795b$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Skew", (0, $342d002cc9d2795b$export$2e2bcd8739ae039));
var $17224aafad22abee$export$2e2bcd8739ae039 = (0, $342d002cc9d2795b$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("anchor", function(gameObject, config) {
    return new (0, $0214e441a3ca6ed5$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.Anchor", (0, $0214e441a3ca6ed5$export$2e2bcd8739ae039));
var $407a738c3685c507$export$2e2bcd8739ae039 = (0, $0214e441a3ca6ed5$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textTyping", function(gameObject, config) {
    return new (0, $649aaec0a328c95d$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextTyping", (0, $649aaec0a328c95d$export$2e2bcd8739ae039));
var $753ee6b8abbb7327$export$2e2bcd8739ae039 = (0, $649aaec0a328c95d$export$2e2bcd8739ae039);





(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textPage", function(gameObject, config) {
    return new (0, $45891b7699fcfb45$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextPage", (0, $45891b7699fcfb45$export$2e2bcd8739ae039));
var $c624dce2a3190adb$export$2e2bcd8739ae039 = (0, $45891b7699fcfb45$export$2e2bcd8739ae039);



var $07a764b375077b02$var$LastOpenedEditor = undefined;
var $07a764b375077b02$export$668cbdf16c1aa400 = function(editor) {
    if (editor === $07a764b375077b02$var$LastOpenedEditor) return;
    if ($07a764b375077b02$var$LastOpenedEditor !== undefined) $07a764b375077b02$var$LastOpenedEditor.close();
    $07a764b375077b02$var$LastOpenedEditor = editor;
};
var $07a764b375077b02$export$798937d41b1530cb = function(editor) {
    if (editor !== $07a764b375077b02$var$LastOpenedEditor) return;
    // Don't call `LastOpenedEditor.close()`
    $07a764b375077b02$var$LastOpenedEditor = undefined;
};





const $9fb8132afbf56420$var$GetValue = Phaser.Utils.Objects.GetValue;
const $9fb8132afbf56420$var$Clone = Phaser.Utils.Objects.Clone;
var $9fb8132afbf56420$var$CreateInputText = function(text, config) {
    if (config === undefined) config = {};
    config = $9fb8132afbf56420$var$Clone(config);
    var scene = text.scene;
    var style = text.style;
    var backgroundColor = $9fb8132afbf56420$var$GetValue(config, "backgroundColor", style.backgroundColor);
    if (backgroundColor === null) backgroundColor = "transparent";
    config.text = $9fb8132afbf56420$var$GetValue(config, "text", text.text);
    config.fontFamily = $9fb8132afbf56420$var$GetValue(config, "fontFamily", style.fontFamily);
    config.fontSize = $9fb8132afbf56420$var$GetValue(config, "fontSize", style.fontSize);
    config.color = $9fb8132afbf56420$var$GetValue(config, "color", style.color);
    config.backgroundColor = backgroundColor;
    config.direction = $9fb8132afbf56420$var$GetValue(config, "rtl", style.rtl) ? "rtl" : "ltr";
    config.align = $9fb8132afbf56420$var$GetValue(config, "align", $9fb8132afbf56420$var$GetHAlign(style));
    // Built-in text game object with RTL only has 'right' align
    if (config.direction === "rtl" && (0, $0d3d6f3277aad4a5$export$2e2bcd8739ae039)(text)) config.align = "right";
    // config.paddingLeft = 0;
    // config.paddingRight = 0;
    // config.paddingTop = 0;
    // config.paddingBottom = 0;
    // var valign = GetVAlign(style);
    // switch (valign) {
    //     case 'top':
    //         break;
    //     case 'bottom':
    //         break;
    // }
    var inputText = new (0, $28892e8128e1413d$export$2e2bcd8739ae039)(scene, text.x, text.y, $9fb8132afbf56420$var$GetValue(config, "width", text.width), $9fb8132afbf56420$var$GetValue(config, "height", text.height), config);
    inputText// Sync origin
    .setOrigin(text.originX, text.originY)// Sync scrollFactor
    .setScrollFactor(text.scrollFactorX, text.scrollFactorY);
    var textParentContainer = text.parentContainer;
    if (!textParentContainer) scene.add.existing(inputText);
    else textParentContainer.add(inputText);
    return inputText;
};
var $9fb8132afbf56420$var$GetHAlign = function(style) {
    if (style.hasOwnProperty("align")) return style.align;
    else if (style.hasOwnProperty("halign")) return style.halign;
    else return "left";
};
var $9fb8132afbf56420$var$GetVAlign = function(style) {
    if (style.hasOwnProperty("halign")) return style.halign;
    else return "top";
};
var $9fb8132afbf56420$export$2e2bcd8739ae039 = $9fb8132afbf56420$var$CreateInputText;


const $a048ccec3bfe0db9$var$GetValue = Phaser.Utils.Objects.GetValue;
const $a048ccec3bfe0db9$var$Merge = Phaser.Utils.Objects.Merge;
var $a048ccec3bfe0db9$var$Open = function(config, onCloseCallback) {
    if (config === undefined) config = {};
    config = $a048ccec3bfe0db9$var$Merge(config, this.openConfig);
    (0, $07a764b375077b02$export$668cbdf16c1aa400)(this);
    if ((0, $761920aac251583f$export$2e2bcd8739ae039)(config)) {
        onCloseCallback = config;
        config = undefined;
    }
    if (onCloseCallback === undefined) onCloseCallback = $a048ccec3bfe0db9$var$GetValue(config, "onClose", undefined);
    var onOpenCallback = $a048ccec3bfe0db9$var$GetValue(config, "onOpen", undefined);
    var customOnTextChanged = $a048ccec3bfe0db9$var$GetValue(config, "onTextChanged", undefined);
    this.inputText = (0, $9fb8132afbf56420$export$2e2bcd8739ae039)(this.parent, config).on("textchange", function(inputText) {
        var text = inputText.text;
        if (customOnTextChanged) customOnTextChanged(this.parent, text);
        else this.parent.text = text;
    }, this).setFocus();
    this.parent.setVisible(false); // Set parent text invisible
    // Attach close event
    this.onClose = onCloseCallback;
    if ($a048ccec3bfe0db9$var$GetValue(config, "enterClose", true)) this.scene.input.keyboard.once("keydown-ENTER", this.close, this);
    // Attach pointerdown (outside of input-text) event, at next tick
    this.delayCall = this.scene.time.delayedCall(0, function() {
        this.scene.input.once("pointerdown", this.close, this);
        // Open editor completly, invoke onOpenCallback
        if (onOpenCallback) onOpenCallback(this.parent);
        this.emit("open", this.parent);
    }, [], this);
    return this;
};
var $a048ccec3bfe0db9$export$2e2bcd8739ae039 = $a048ccec3bfe0db9$var$Open;



var $2184bcfdc5be89d9$var$Close = function() {
    (0, $07a764b375077b02$export$798937d41b1530cb)(this);
    this.parent.setVisible(true); // Set parent text visible
    if (this.inputText) {
        this.inputText.destroy();
        this.inputText = undefined;
    }
    if (this.delayCall) {
        this.delayCall.remove();
        this.delayCall = undefined;
    }
    // Remove close event
    this.scene.input.keyboard.off("keydown-ENTER", this.close, this);
    this.scene.input.off("pointerdown", this.close, this);
    if (this.onClose) this.onClose(this.parent);
    this.emit("close", this.parent);
    return this;
};
var $2184bcfdc5be89d9$export$2e2bcd8739ae039 = $2184bcfdc5be89d9$var$Close;


var $d614cce2fd9e4aac$var$Methods = {
    open: (0, $a048ccec3bfe0db9$export$2e2bcd8739ae039),
    close: (0, $2184bcfdc5be89d9$export$2e2bcd8739ae039)
};
var $d614cce2fd9e4aac$export$2e2bcd8739ae039 = $d614cce2fd9e4aac$var$Methods;


const $0f4673a9a45fc929$var$GetValue = Phaser.Utils.Objects.GetValue;
class $0f4673a9a45fc929$var$TextEdit extends (0, $116285784eb8fd63$export$2e2bcd8739ae039) {
    constructor(gameObject, config){
        super(gameObject);
        // this.parent = gameObject;
        this.inputText = undefined;
        this.onClose = undefined;
        this.delayCall = undefined;
        this.setOpenConfig(config);
        var clickEnable = $0f4673a9a45fc929$var$GetValue(config, "clickEnable", true);
        if (clickEnable) gameObject.on("pointerdown", function() {
            this.open();
        }, this).setInteractive();
    }
    shutdown(fromScene) {
        // Already shutdown
        if (this.isShutdown) return;
        this.close();
        super.shutdown(fromScene);
    }
    setOpenConfig(config) {
        if (config === undefined) config = {};
        this.openConfig = config;
        return this;
    }
    get isOpened() {
        return this.inputText !== undefined;
    }
    get text() {
        return this.isOpened ? this.inputText.text : this.parent.text;
    }
}
Object.assign($0f4673a9a45fc929$var$TextEdit.prototype, (0, $d614cce2fd9e4aac$export$2e2bcd8739ae039));
var $0f4673a9a45fc929$export$2e2bcd8739ae039 = $0f4673a9a45fc929$var$TextEdit;



var $21bf2deb3ae87573$var$Edit = function(gameObject, config, onCloseCallback) {
    if (!gameObject._edit) gameObject._edit = new (0, $0f4673a9a45fc929$export$2e2bcd8739ae039)(gameObject, {
        clickEnable: false
    });
    gameObject._edit.open(config, onCloseCallback);
    return gameObject._edit;
};
var $21bf2deb3ae87573$export$2e2bcd8739ae039 = $21bf2deb3ae87573$var$Edit;




var $37b00c479a8aa33a$export$2e2bcd8739ae039 = (0, $0f4673a9a45fc929$export$2e2bcd8739ae039);




(0, $79dcaf015ecfe983$export$2e2bcd8739ae039).register("textEdit", function(gameObject, config) {
    return new (0, $37b00c479a8aa33a$export$2e2bcd8739ae039)(gameObject, config);
});
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.UI.TextEdit", (0, $37b00c479a8aa33a$export$2e2bcd8739ae039));
var $eb0e055e298a72dd$export$2e2bcd8739ae039 = (0, $37b00c479a8aa33a$export$2e2bcd8739ae039);








var $ff5977bf6fc7715f$export$2e2bcd8739ae039 = (0, $21bf2deb3ae87573$export$2e2bcd8739ae039);



const $08d93d5418ad866f$var$MaxTestCount = 65535;
var $08d93d5418ad866f$var$SetFontSizeToFitWidth = function(textObject, width, height) {
    if (width == null) // Do nothing if invalid width input
    return textObject;
    if (width === 0) {
        $08d93d5418ad866f$var$SetTextWidth(textObject, 0, height);
        return textObject;
    }
    var textLength = textObject.text.length;
    if (textLength === 0) {
        $08d93d5418ad866f$var$SetTextWidth(textObject, width, height);
        return textObject;
    }
    var fontSize = Math.floor(width * 1.5 / textLength);
    var sizeData = {};
    var testResult = $08d93d5418ad866f$var$TestFontSize(textObject, fontSize, width, height, sizeData);
    for(var i = 0; i <= $08d93d5418ad866f$var$MaxTestCount; i++){
        if (testResult === 0) break;
        else {
            fontSize += testResult;
            if (fontSize < 0) {
                fontSize = 0;
                break;
            }
        }
        testResult = $08d93d5418ad866f$var$TestFontSize(textObject, fontSize, width, height, sizeData);
    // console.log(fontSize, testResult)
    }
    if (i === $08d93d5418ad866f$var$MaxTestCount) console.warn(`SetFontSizeToFitWidth: Test count exceeds ${$08d93d5418ad866f$var$MaxTestCount}`);
    textObject.setFontSize(fontSize);
    $08d93d5418ad866f$var$SetTextWidth(textObject, width, height);
    return textObject;
};
var $08d93d5418ad866f$var$GetTextSize = function(textObject, fontSize, sizeData) {
    if (sizeData[fontSize] === undefined) {
        textObject.setFontSize(fontSize);
        sizeData[fontSize] = {
            width: textObject.width,
            height: textObject.height
        };
    }
    return sizeData[fontSize];
};
var $08d93d5418ad866f$var$TestFontSize = function(textObject, fontSize, width, height, sizeData) {
    var textSize = $08d93d5418ad866f$var$GetTextSize(textObject, fontSize, sizeData);
    var textSize1 = $08d93d5418ad866f$var$GetTextSize(textObject, fontSize + 1, sizeData);
    if (height !== undefined) {
        // Clamp by height
        if (textSize.height <= height && textSize1.height > height) return 0;
        else if (textSize.height > height) return -1;
    }
    // Clamp by width
    if (textSize.width <= width && textSize1.width > width) return 0;
    else if (textSize.width > width) return -1;
    else return Math.floor(width - textSize.width);
};
var $08d93d5418ad866f$var$SetTextWidth = function(textObject, width, height) {
    var style = textObject.style;
    style.fixedWidth = width;
    style.parent.width = width;
    if (height !== undefined) {
        style.fixedHeight = height;
        style.parent.height = height;
    }
    style.update(false);
};
var $08d93d5418ad866f$export$2e2bcd8739ae039 = $08d93d5418ad866f$var$SetFontSizeToFitWidth;


var $6cb6409ca646fdd1$var$FontSizeExpandText = function(textObject, minWidth) {
    if (minWidth === undefined) minWidth = 0;
    textObject._minWidth = minWidth;
    textObject.runWidthWrap = function(width, maxHeight) {
        (0, $08d93d5418ad866f$export$2e2bcd8739ae039)(textObject, width, maxHeight);
        return textObject;
    };
    textObject.resize = function(width, height) {
        if (textObject.width === width && textObject.height === height) return textObject;
        // Font size is set under runWidthWrap/SetFontSizeToFitWidth
        textObject.setFixedSize(width, height);
        return textObject;
    };
    return textObject;
};
var $6cb6409ca646fdd1$export$2e2bcd8739ae039 = $6cb6409ca646fdd1$var$FontSizeExpandText;












class $3246715e9c0b4015$var$UIPlugin extends Phaser.Plugins.ScenePlugin {
    constructor(scene, pluginManager){
        super(scene, pluginManager);
        this.add = new (0, $79dcaf015ecfe983$export$2e2bcd8739ae039)(scene);
    }
    start() {
        var eventEmitter = this.scene.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
    isInTouching(gameObject, pointer, preTest, postTest) {
        if (!gameObject.visible) return false;
        return (0, $e4fa7f2032964b1a$export$2e2bcd8739ae039)(gameObject, pointer, preTest, postTest);
    }
    get viewport() {
        return (0, $80787edf9415f7c3$export$2e2bcd8739ae039)(this.scene, this.scene.cameras.main, true);
    }
}
var $3246715e9c0b4015$var$methods = {
    getParentSizer: (0, $b14a503379e18b6f$export$b9fe6ae6245f98f4),
    getTopmostSizer: (0, $b14a503379e18b6f$export$ebf2fa9b80324b88),
    hide: (0, $f55461eb0d33b5f5$export$bed28288a051538),
    show: (0, $f55461eb0d33b5f5$export$f6a3d19be20f5819),
    isShown: (0, $f55461eb0d33b5f5$export$be736b6b33b78275),
    edit: (0, $ff5977bf6fc7715f$export$2e2bcd8739ae039),
    wrapExpandText: (0, $21ed2ed093f8e79c$export$2e2bcd8739ae039),
    fontSizeExpandText: (0, $6cb6409ca646fdd1$export$2e2bcd8739ae039),
    fontSizeResize: (0, $08d93d5418ad866f$export$2e2bcd8739ae039),
    setFontSizeToFitWidth: (0, $08d93d5418ad866f$export$2e2bcd8739ae039),
    waitEvent: (0, $2b5b0b08519578fd$export$64e00c1c113b35b1),
    waitComplete: (0, $2b5b0b08519578fd$export$f539506d32c8afaa),
    delayPromise: (0, $beb798f9c639b258$export$2e2bcd8739ae039),
    setChildrenInteractive: (0, $d32ee249a5c7144d$export$2e2bcd8739ae039),
    fadeIn: (0, $0b78b699f711afbf$export$2e2bcd8739ae039),
    fadeOutDestroy: (0, $607af573d5a48304$export$2e2bcd8739ae039),
    easeMoveTo: (0, $eeb9cc7ef6d9e9f6$export$2e2bcd8739ae039),
    easeMoveFrom: (0, $2eac648027d38869$export$2e2bcd8739ae039),
    modal: (0, $afe4e67dd61048bf$export$2b77a92f1a5ad772),
    modalPromise: (0, $afe4e67dd61048bf$export$6667d84de02f0870),
    modalClose: (0, $afe4e67dd61048bf$export$9bf0f2717ffc648c),
    requestDrag: (0, $59d59543b8a9818e$export$2e2bcd8739ae039),
    openFileChooser: (0, $f2dcf909375d9d62$export$2e2bcd8739ae039)
};
Object.assign($3246715e9c0b4015$var$UIPlugin.prototype, $3246715e9c0b4015$var$methods);
var $3246715e9c0b4015$export$2e2bcd8739ae039 = $3246715e9c0b4015$var$UIPlugin;


// https://gist.github.com/MatthewBarker/032c325ef8577c6d0188
const $21583bb3a43cf4b1$var$frag = `\
#ifdef GL_FRAGMENT_PRECISION_HIGH
#define highmedp highp
#else
#define highmedp mediump
#endif
precision highmedp float;

// Scene buffer
uniform sampler2D uMainSampler; 
varying vec2 outTexCoord;

// Effect parameters
uniform float intensity;

void main() {
  vec4 front = texture2D(uMainSampler, outTexCoord);
  vec4 sum = vec4(0);
  for(int xx = -4; xx <= 4; xx++) {
    for(int yy = -3; yy <= 3; yy++) {
      float dist = sqrt(float(xx*xx) + float(yy*yy));
      float factor = 0.0;
      if (dist == 0.0) {
        factor = 2.0;
      } else {
        factor = 2.0/abs(float(dist));
      }
      sum += texture2D(uMainSampler, outTexCoord + vec2(xx, yy) * 0.002) * factor;
    }
  }
  
  gl_FragColor = mix(front, sum, intensity);
}
`;
var $21583bb3a43cf4b1$export$2e2bcd8739ae039 = $21583bb3a43cf4b1$var$frag;


const $e4184c4b227c8499$var$PostFXPipeline = Phaser.Renderer.WebGL.Pipelines.PostFXPipeline;
const $e4184c4b227c8499$var$GetValue = Phaser.Utils.Objects.GetValue;
class $e4184c4b227c8499$var$GlowFilterPostFxPipeline extends $e4184c4b227c8499$var$PostFXPipeline {
    constructor(game){
        super({
            name: "rexGlowFilterPostFx",
            game: game,
            renderTarget: true,
            fragShader: (0, $21583bb3a43cf4b1$export$2e2bcd8739ae039)
        });
        this.intensity = 0;
    }
    resetFromJSON(o) {
        this.setIntensity($e4184c4b227c8499$var$GetValue(o, "intensity", 0));
        return this;
    }
    onPreRender() {
        this.set1f("intensity", this.intensity);
    }
    // intensity
    setIntensity(value) {
        this.intensity = value;
        return this;
    }
}
var $e4184c4b227c8499$export$2e2bcd8739ae039 = $e4184c4b227c8499$var$GlowFilterPostFxPipeline;


var $47dd3ab341c63f40$export$2e2bcd8739ae039 = (0, $e4184c4b227c8499$export$2e2bcd8739ae039);



var $934e1ba1472657f9$var$RegisterPostPipeline = function(game, postFxPipelineName, PostFxPipelineClass) {
    (0, $2e10bcf1e5b86bcf$export$2e2bcd8739ae039)(game).renderer.pipelines.addPostPipeline(postFxPipelineName, PostFxPipelineClass);
};
var $934e1ba1472657f9$export$2e2bcd8739ae039 = $934e1ba1472657f9$var$RegisterPostPipeline;


var $d746b2f015425a39$var$AddPostFxPipelineInstance = function(gameObject, PostFxPipelineClass, config) {
    if (config === undefined) config = {};
    gameObject.setPostPipeline(PostFxPipelineClass);
    var pipeline = gameObject.postPipelines[gameObject.postPipelines.length - 1];
    pipeline.resetFromJSON(config);
    if (config.name) pipeline.name = config.name;
    return pipeline;
};
var $d746b2f015425a39$export$2e2bcd8739ae039 = $d746b2f015425a39$var$AddPostFxPipelineInstance;


const $962e7d32fc52ec03$var$SpliceOne = Phaser.Utils.Array.SpliceOne;
var $962e7d32fc52ec03$var$RemovePostFxPipelineInstance = function(gameObject, PostFxPipelineClass, name) {
    if (name === undefined) {
        var pipelines = gameObject.postPipelines;
        for(var i = pipelines.length - 1; i >= 0; i--){
            var instance = pipelines[i];
            if (instance instanceof PostFxPipelineClass) {
                instance.destroy();
                $962e7d32fc52ec03$var$SpliceOne(pipelines, i);
            }
        }
    } else {
        var pipelines = gameObject.postPipelines;
        for(var i = 0, cnt = pipelines.length; i < cnt; i++){
            var instance = pipelines[i];
            if (instance instanceof PostFxPipelineClass && instance.name === name) {
                instance.destroy();
                $962e7d32fc52ec03$var$SpliceOne(pipelines, i);
            }
        }
    }
};
var $962e7d32fc52ec03$export$2e2bcd8739ae039 = $962e7d32fc52ec03$var$RemovePostFxPipelineInstance;


var $b5c6db0b63cf6e90$var$GetPostFxPipelineInstance = function(gameObject, PostFxPipelineClass, name) {
    if (name === undefined) {
        var result = [];
        var pipelines = gameObject.postPipelines;
        for(var i = 0, cnt = pipelines.length; i < cnt; i++){
            var instance = pipelines[i];
            if (instance instanceof PostFxPipelineClass) result.push(instance);
        }
        return result;
    } else {
        var pipelines = gameObject.postPipelines;
        for(var i = 0, cnt = pipelines.length; i < cnt; i++){
            var instance = pipelines[i];
            if (instance instanceof PostFxPipelineClass && instance.name === name) return instance;
        }
    }
};
var $b5c6db0b63cf6e90$export$2e2bcd8739ae039 = $b5c6db0b63cf6e90$var$GetPostFxPipelineInstance;


class $c243b0ab3a6659a1$var$BasePostFxPipelinePlugin extends Phaser.Plugins.BasePlugin {
    setPostPipelineClass(PostFxPipelineClass, postFxPipelineName) {
        this.PostFxPipelineClass = PostFxPipelineClass;
        this.postFxPipelineName = postFxPipelineName;
        return this;
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.once("destroy", this.destroy, this);
        (0, $934e1ba1472657f9$export$2e2bcd8739ae039)(this.game, this.postFxPipelineName, this.PostFxPipelineClass);
    }
    add(gameObject, config) {
        return (0, $d746b2f015425a39$export$2e2bcd8739ae039)(gameObject, this.PostFxPipelineClass, config);
    }
    remove(gameObject, name) {
        (0, $962e7d32fc52ec03$export$2e2bcd8739ae039)(gameObject, this.PostFxPipelineClass, name);
        return this;
    }
    get(gameObject, name) {
        return (0, $b5c6db0b63cf6e90$export$2e2bcd8739ae039)(gameObject, this.PostFxPipelineClass, name);
    }
}
var $c243b0ab3a6659a1$export$2e2bcd8739ae039 = $c243b0ab3a6659a1$var$BasePostFxPipelinePlugin;



class $0d82ebd0a86d72fb$var$GlowFilterPipelinePlugin extends (0, $c243b0ab3a6659a1$export$2e2bcd8739ae039) {
    constructor(pluginManager){
        super(pluginManager);
        this.setPostPipelineClass((0, $47dd3ab341c63f40$export$2e2bcd8739ae039), "rexGlowFilterPostFx");
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.Pipelines.GlowFilterPostFx", (0, $47dd3ab341c63f40$export$2e2bcd8739ae039));
var $0d82ebd0a86d72fb$export$2e2bcd8739ae039 = $0d82ebd0a86d72fb$var$GlowFilterPipelinePlugin;


// https://github.com/ykob/glsl-dissolve/blob/master/src/glsl/dissolve.fs
// Reference: https://medium.com/neosavvy-labs/webgl-with-perlin-noise-part-1-a87b56bbc9fb
const $df9e6233b626a964$var$frag = `\
vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec4 mod289(vec4 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec4 permute(vec4 x) { return mod289(((x*34.0)+1.0)*x); }
vec4 taylorInvSqrt(vec4 r) { return 1.79284291400159 - 0.85373472095314 * r; }
vec3 fade(vec3 t) { return t*t*t*(t*(t*6.0-15.0)+10.0); }
float Perlin(vec3 P) {
    vec3 i0 = mod289(floor(P)), i1 = mod289(i0 + vec3(1.0));
    vec3 f0 = fract(P), f1 = f0 - vec3(1.0), f = fade(f0);
    vec4 ix = vec4(i0.x, i1.x, i0.x, i1.x), iy = vec4(i0.yy, i1.yy);
    vec4 iz0 = i0.zzzz, iz1 = i1.zzzz;
    vec4 ixy = permute(permute(ix) + iy), ixy0 = permute(ixy + iz0), ixy1 = permute(ixy + iz1);
    vec4 gx0 = ixy0 * (1.0 / 7.0), gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
    vec4 gx1 = ixy1 * (1.0 / 7.0), gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
    gx0 = fract(gx0); gx1 = fract(gx1);
    vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0), sz0 = step(gz0, vec4(0.0));
    vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1), sz1 = step(gz1, vec4(0.0));
    gx0 -= sz0 * (step(0.0, gx0) - 0.5); gy0 -= sz0 * (step(0.0, gy0) - 0.5);
    gx1 -= sz1 * (step(0.0, gx1) - 0.5); gy1 -= sz1 * (step(0.0, gy1) - 0.5);
    vec3 g0 = vec3(gx0.x,gy0.x,gz0.x), g1 = vec3(gx0.y,gy0.y,gz0.y),
        g2 = vec3(gx0.z,gy0.z,gz0.z), g3 = vec3(gx0.w,gy0.w,gz0.w),
        g4 = vec3(gx1.x,gy1.x,gz1.x), g5 = vec3(gx1.y,gy1.y,gz1.y),
        g6 = vec3(gx1.z,gy1.z,gz1.z), g7 = vec3(gx1.w,gy1.w,gz1.w);
    vec4 norm0 = taylorInvSqrt(vec4(dot(g0,g0), dot(g2,g2), dot(g1,g1), dot(g3,g3)));
    vec4 norm1 = taylorInvSqrt(vec4(dot(g4,g4), dot(g6,g6), dot(g5,g5), dot(g7,g7)));
    g0 *= norm0.x; g2 *= norm0.y; g1 *= norm0.z; g3 *= norm0.w;
    g4 *= norm1.x; g6 *= norm1.y; g5 *= norm1.z; g7 *= norm1.w;
    vec4 nz = mix(vec4(dot(g0, vec3(f0.x, f0.y, f0.z)), dot(g1, vec3(f1.x, f0.y, f0.z)),
        dot(g2, vec3(f0.x, f1.y, f0.z)), dot(g3, vec3(f1.x, f1.y, f0.z))),
        vec4(dot(g4, vec3(f0.x, f0.y, f1.z)), dot(g5, vec3(f1.x, f0.y, f1.z)),
            dot(g6, vec3(f0.x, f1.y, f1.z)), dot(g7, vec3(f1.x, f1.y, f1.z))), f.z);
    return 2.2 * mix(mix(nz.x,nz.z,f.y), mix(nz.y,nz.w,f.y), f.x);
}
float Perlin(vec2 P) { return Perlin(vec3(P, 0.0)); }
`;
var $df9e6233b626a964$export$2e2bcd8739ae039 = $df9e6233b626a964$var$frag;


const $9983c5ab23791a11$var$frag = `\
#ifdef GL_FRAGMENT_PRECISION_HIGH
#define highmedp highp
#else
#define highmedp mediump
#endif
precision highmedp float;
// Scene buffer
uniform sampler2D uMainSampler;
uniform sampler2D uMainSampler2;

uniform int resizeMode;
uniform float progress;
uniform float fromRatio;
uniform float toRatio;
varying vec2 outFragCoord;
// Effect parameters
uniform float noiseX;
uniform float noiseY;
uniform float noiseZ;
uniform float fromEdgeStart;
uniform float fromEdgeWidth;
uniform float toEdgeStart;
uniform float toEdgeWidth;

${(0, $df9e6233b626a964$export$2e2bcd8739ae039)}

vec4 getFromColor (vec2 uv) {
  return texture2D(uMainSampler, uv);
}

vec4 getToColor (vec2 uv) {
  if (resizeMode == 2) {
    //  cover
    return texture2D(uMainSampler2, 0.5 + (vec2(uv.x, 1.0 - uv.y) - 0.5) * vec2(min(fromRatio / toRatio, 1.0), min((toRatio / fromRatio), 1.0)));
  } else if (resizeMode == 1) {
    //  contain
    return texture2D(uMainSampler2, 0.5 + (vec2(uv.x, 1.0 - uv.y) - 0.5) * vec2(max(fromRatio / toRatio, 1.0), max((toRatio / fromRatio), 1.0)));
  } else {
    //  stretch
    return texture2D(uMainSampler2, vec2(uv.x, 1.0 - uv.y));
  }
}

vec4 transition (vec2 uv) {    
  vec4 colorFront = getFromColor(uv);
  vec4 colorTo = getToColor(uv);

  float noise = (Perlin(vec3(uv.x * noiseX, uv.y * noiseY, noiseZ)) + 1.0) / 2.0
    * (1.0 - (fromEdgeStart + fromEdgeWidth + toEdgeStart + toEdgeWidth))
    + (fromEdgeStart + fromEdgeWidth + toEdgeStart + toEdgeWidth) * 0.5;
  vec4 colorResult = colorFront * smoothstep(progress - (fromEdgeStart + fromEdgeWidth), progress - fromEdgeStart, noise)
    + colorTo * smoothstep((1.0 - progress) - (toEdgeStart + toEdgeWidth), (1.0 - progress) - toEdgeStart, (1.0 - noise));
  return colorResult;
}

void main () {
  vec2 uv = outFragCoord;
  gl_FragColor = transition(uv);
}
`;
var $9983c5ab23791a11$export$2e2bcd8739ae039 = $9983c5ab23791a11$var$frag;


const $c9b1c53322d6721b$var$PostFXPipeline = Phaser.Renderer.WebGL.Pipelines.PostFXPipeline;
const $c9b1c53322d6721b$var$GetValue = Phaser.Utils.Objects.GetValue;
const $c9b1c53322d6721b$var$Clamp = Phaser.Math.Clamp;
class $c9b1c53322d6721b$var$DissolvePostFxPipeline extends $c9b1c53322d6721b$var$PostFXPipeline {
    constructor(game){
        super({
            name: "rexDissolvePostFx",
            game: game,
            renderTarget: true,
            fragShader: (0, $9983c5ab23791a11$export$2e2bcd8739ae039)
        });
        this._progress = 0;
        this.toFrame = null;
        this.targetTexture = null;
        this.resizeMode = 1;
        this.toRatio = 1;
        this.noiseX = 0;
        this.noiseY = 0;
        this.noiseZ = 0;
        this.fromEdgeStart = 0.01;
        this.fromEdgeWidth = 0.05;
        this.toEdgeStart = 0.01;
        this.toEdgeWidth = 0.05;
    }
    resetFromJSON(o) {
        this.setProgress($c9b1c53322d6721b$var$GetValue(o, "progress", 0));
        this.setTransitionTargetTexture($c9b1c53322d6721b$var$GetValue(o, "toTexture", "__DEFAULT"), $c9b1c53322d6721b$var$GetValue(o, "toFrame", undefined), $c9b1c53322d6721b$var$GetValue(o, "resizeMode", 1));
        this.setNoise($c9b1c53322d6721b$var$GetValue(o, "noiseX", undefined), $c9b1c53322d6721b$var$GetValue(o, "noiseY", undefined), $c9b1c53322d6721b$var$GetValue(o, "noiseZ", undefined));
        this.setFromEdge($c9b1c53322d6721b$var$GetValue(o, "fromEdgeStart", 0.01), $c9b1c53322d6721b$var$GetValue(o, "fromEdgeWidth", 0.05));
        this.setToEdge($c9b1c53322d6721b$var$GetValue(o, "toEdgeStart", 0.01), $c9b1c53322d6721b$var$GetValue(o, "toEdgeWidth", 0.05));
        return this;
    }
    onBoot() {
        this.setTransitionTargetTexture();
    }
    onPreRender() {
        this.set1f("progress", this.progress);
        this.set1i("resizeMode", this.resizeMode);
        this.set1f("noiseX", this.noiseX);
        this.set1f("noiseY", this.noiseY);
        this.set1f("noiseZ", this.noiseZ);
        this.set1f("fromEdgeStart", this.fromEdgeStart);
        this.set1f("fromEdgeWidth", this.fromEdgeWidth);
        this.set1f("toEdgeStart", this.toEdgeStart);
        this.set1f("toEdgeWidth", this.toEdgeWidth);
    }
    onDraw(renderTarget) {
        this.set1f("fromRatio", renderTarget.width / renderTarget.height);
        this.bindTexture(this.targetTexture, 1);
        this.bindAndDraw(renderTarget);
    }
    get progress() {
        return this._progress;
    }
    set progress(value) {
        this._progress = $c9b1c53322d6721b$var$Clamp(value, 0, 1);
    }
    setProgress(value) {
        this.progress = value;
        return this;
    }
    setTransitionTargetTexture(key, frame, resizeMode) {
        if (key === undefined) key = "__DEFAULT";
        var phaserTexture = this.game.textures.getFrame(key, frame);
        if (!phaserTexture) phaserTexture = this.game.textures.getFrame("__DEFAULT");
        this.toRatio = phaserTexture.width / phaserTexture.height;
        this.toFrame = phaserTexture;
        this.targetTexture = phaserTexture.glTexture;
        if (resizeMode !== undefined) this.resizeMode = resizeMode;
        this.set1i("uMainSampler2", 1);
        this.set1f("toRatio", this.toRatio);
        return this;
    }
    setResizeMode(mode) {
        if (typeof mode === "string") mode = $c9b1c53322d6721b$var$ResizeMode[mode];
        this.resizeMode = mode;
        return this;
    }
    setNoise(x, y, z) {
        if (x === undefined) x = 4 + Math.random() * 6;
        if (y === undefined) y = 4 + Math.random() * 6;
        if (z === undefined) z = Math.random() * 10;
        this.noiseX = x;
        this.noiseY = y;
        this.noiseZ = z;
        return this;
    }
    setFromEdge(edgeStart, edgeWidth) {
        this.fromEdgeStart = edgeStart;
        this.fromEdgeWidth = edgeWidth;
        return this;
    }
    setToEdge(edgeStart, edgeWidth) {
        this.toEdgeStart = edgeStart;
        this.toEdgeWidth = edgeWidth;
        return this;
    }
}
/**
 * Set the resize mode of the target texture.
 * 
 * Can be either:
 * 
 * 0 - Stretch. The target texture is stretched to the size of the source texture.
 * 1 - Contain. The target texture is resized to fit the source texture. This is the default.
 * 2 - Cover. The target texture is resized to cover the source texture.
 * 
 * If the source and target textures are the same size, then use a resize mode of zero
 * for speed.
 *
 */ var $c9b1c53322d6721b$var$ResizeMode = {
    stretch: 0,
    contain: 1,
    cover: 2
};
var $c9b1c53322d6721b$export$2e2bcd8739ae039 = $c9b1c53322d6721b$var$DissolvePostFxPipeline;


var $1dbb2c2ea5bb98a3$export$2e2bcd8739ae039 = (0, $c9b1c53322d6721b$export$2e2bcd8739ae039);




class $f9d3b9b80d54d861$var$DissolvePipelinePlugin extends (0, $c243b0ab3a6659a1$export$2e2bcd8739ae039) {
    constructor(pluginManager){
        super(pluginManager);
        this.setPostPipelineClass((0, $1dbb2c2ea5bb98a3$export$2e2bcd8739ae039), "rexDissolvePostFx");
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.Pipelines.DissolvePostFx", (0, $1dbb2c2ea5bb98a3$export$2e2bcd8739ae039));
var $f9d3b9b80d54d861$export$2e2bcd8739ae039 = $f9d3b9b80d54d861$var$DissolvePipelinePlugin;



function $51fdbbaa12272692$export$2e2bcd8739ae039(x, y, texture, frame, config) {
    var gameObject = new (0, $abcad68cb94416ae$export$2e2bcd8739ae039)(this.scene, x, y, texture, frame, config);
    this.scene.add.existing(gameObject);
    return gameObject;
}



const $ddba78dc5e81161c$var$GetAdvancedValue = Phaser.Utils.Objects.GetAdvancedValue;
const $ddba78dc5e81161c$var$BuildGameObject = Phaser.GameObjects.BuildGameObject;
function $ddba78dc5e81161c$export$2e2bcd8739ae039(config, addToScene) {
    if (config === undefined) config = {};
    if (addToScene !== undefined) config.add = addToScene;
    var key = $ddba78dc5e81161c$var$GetAdvancedValue(config, "key", null);
    var frame = $ddba78dc5e81161c$var$GetAdvancedValue(config, "frame", null);
    var gameObject = new (0, $abcad68cb94416ae$export$2e2bcd8739ae039)(this.scene, 0, 0, key, frame, config);
    $ddba78dc5e81161c$var$BuildGameObject(this.scene, gameObject, config);
    return gameObject;
}




class $3c0af5a5d252f7bb$var$TransitionImagePlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager){
        super(pluginManager);
        //  Register our new Game Object type
        pluginManager.registerGameObject("rexTransitionImage", (0, $51fdbbaa12272692$export$2e2bcd8739ae039), (0, $ddba78dc5e81161c$export$2e2bcd8739ae039));
    }
    start() {
        var eventEmitter = this.game.events;
        eventEmitter.on("destroy", this.destroy, this);
    }
}
(0, $5e5c240d4107cac2$export$2e2bcd8739ae039)(window, "RexPlugins.GameObjects.TransitionImage", (0, $abcad68cb94416ae$export$2e2bcd8739ae039));
var $3c0af5a5d252f7bb$export$2e2bcd8739ae039 = $3c0af5a5d252f7bb$var$TransitionImagePlugin;



var $801a11af1a79006d$exports = {};
$801a11af1a79006d$exports = new URL("homebase_tiles-export64_v2.9af65787.png", import.meta.url).toString();


// Squad Modals
var $9b931f2dca6d8b6a$exports = {};
$9b931f2dca6d8b6a$exports = new URL("squad_text.0c63ea3c.png", import.meta.url).toString();


var $474dcbcf3984a9c1$exports = {};
$474dcbcf3984a9c1$exports = new URL("squad_confirm_button.44d29edf.png", import.meta.url).toString();


var $c38e5ca88fb9bddb$exports = {};
$c38e5ca88fb9bddb$exports = new URL("squad_divider_line.7afe5319.png", import.meta.url).toString();


var $3d923e9ab7e52637$exports = {};
$3d923e9ab7e52637$exports = new URL("objectives_bg.c54dac1e.png", import.meta.url).toString();


var $7661a53477bd3b91$exports = {};
$7661a53477bd3b91$exports = new URL("list_view_panel.9947246c.png", import.meta.url).toString();


var $93017214051f5ee6$exports = {};
$93017214051f5ee6$exports = new URL("objectives_text.bdcf1986.png", import.meta.url).toString();


var $97f9ee3239e7b96d$exports = {};
$97f9ee3239e7b96d$exports = new URL("open_chest_button.8efb6e0b.png", import.meta.url).toString();


var $5ca3738ae4739662$exports = {};
$5ca3738ae4739662$exports = new URL("objectives_divider_line.8085c53e.png", import.meta.url).toString();


var $b3ccbb6d00b93209$exports = {};
$b3ccbb6d00b93209$exports = new URL("daily_chest_button.22c1f813.png", import.meta.url).toString();


var $150beeec846cad82$exports = {};
$150beeec846cad82$exports = new URL("sw_genesis_empty.4a95e218.png", import.meta.url).toString();


var $2d660b753128250e$exports = {};
$2d660b753128250e$exports = new URL("sw_generative_empty.d5215f16.png", import.meta.url).toString();


var $06e988ee283827a8$exports = {};
$06e988ee283827a8$exports = new URL("gape_genesis_empty.56f7c9d9.png", import.meta.url).toString();


var $c0c1f96af25f1a61$exports = {};
$c0c1f96af25f1a61$exports = new URL("gape_generative_empty.0eec5725.png", import.meta.url).toString();


var $0e2c4a12faa534fc$exports = {};
$0e2c4a12faa534fc$exports = new URL("gape_monke_empty.b6b3170f.png", import.meta.url).toString();


var $503f5f14f51d4f26$exports = {};
$503f5f14f51d4f26$exports = new URL("buy_one_button.a275bdbe.png", import.meta.url).toString();


var $ea6eafa9b054f877$exports = {};
$ea6eafa9b054f877$exports = new URL("stardust_icon.02644ff1.png", import.meta.url).toString();


var $d220a3ec798dcdab$exports = {};
$d220a3ec798dcdab$exports = new URL("os_button.7ee4596f.png", import.meta.url).toString();


var $dc1b86657827887e$exports = {};
$dc1b86657827887e$exports = new URL("objective_connect_button.a4757c8c.png", import.meta.url).toString();


var $9bf0be0e1c0e6771$exports = {};
$9bf0be0e1c0e6771$exports = new URL("objective_follow_button.780c5920.png", import.meta.url).toString();


var $fb0585b32fef2580$exports = {};
$fb0585b32fef2580$exports = new URL("objective_tweet_button.915770a2.png", import.meta.url).toString();


var $db84da4358e606fb$exports = {};
$db84da4358e606fb$exports = new URL("objective_retweet_button.785f1cb1.png", import.meta.url).toString();


var $3b2aa73a95238916$exports = {};
$3b2aa73a95238916$exports = new URL("objective_read_button.7124ee6d.png", import.meta.url).toString();


var $0b54a297d9ec5ed6$exports = {};
$0b54a297d9ec5ed6$exports = new URL("objective_view_button.c68f3fed.png", import.meta.url).toString();


var $9702291274a9f2fe$exports = {};
$9702291274a9f2fe$exports = new URL("objective_open_button.a22960c2.png", import.meta.url).toString();


var $e0f463880c80a68b$exports = {};
$e0f463880c80a68b$exports = new URL("objective_like_button.496c8626.png", import.meta.url).toString();


var $1c9b418ad90f694f$exports = {};
$1c9b418ad90f694f$exports = new URL("open_daily_chest_button.54842738.png", import.meta.url).toString();


var $56e0e84636726530$exports = {};
$56e0e84636726530$exports = new URL("open_all_button.cd8630bf.png", import.meta.url).toString();


var $4485b9aeaa23fc4d$exports = {};
$4485b9aeaa23fc4d$exports = new URL("open_all_button_disabled.48171e25.png", import.meta.url).toString();


var $09f4d1d917f2ba98$exports = {};
$09f4d1d917f2ba98$exports = new URL("modal_close_button.229c5d16.png", import.meta.url).toString();


var $31efa0eba304f195$exports = {};
$31efa0eba304f195$exports = new URL("star_wolvez_game_logo.f3b7c3ac.png", import.meta.url).toString();


var $2eb3c81a25112716$exports = {};
$2eb3c81a25112716$exports = new URL("star_wolvez_game_logo_mobile.71809962.png", import.meta.url).toString();


var $74a4fca5dd55f7b2$exports = {};
$74a4fca5dd55f7b2$exports = new URL("the_game_logo.f201f9b0.png", import.meta.url).toString();


var $8aadeda71661a991$exports = {};
$8aadeda71661a991$exports = new URL("connect_wallet_button.db787583.png", import.meta.url).toString();


var $98e57a104c3cdcb8$exports = {};
$98e57a104c3cdcb8$exports = new URL("login_divider.81de945b.png", import.meta.url).toString();


var $2ef86b23911d5362$exports = {};
$2ef86b23911d5362$exports = new URL("or_image.110898ad.png", import.meta.url).toString();


var $fe07c7fa78bbb8ab$exports = {};
$fe07c7fa78bbb8ab$exports = new URL("google_login_button.79722709.png", import.meta.url).toString();


var $38f043ae81368b6b$exports = {};
$38f043ae81368b6b$exports = new URL("apple_login_button.ef92ae69.png", import.meta.url).toString();


var $d703aaa1df7c1e39$exports = {};
$d703aaa1df7c1e39$exports = new URL("disclaimer_image.420276c7.png", import.meta.url).toString();


var $828308dde2fafd51$exports = {};
$828308dde2fafd51$exports = new URL("sw_feed_background.7493f32c.png", import.meta.url).toString();


var $d078bed1bab89673$exports = {};
$d078bed1bab89673$exports = new URL("feed_title_image.9f8f4fd3.png", import.meta.url).toString();


var $312f412adae2595f$exports = {};
$312f412adae2595f$exports = new URL("login_poster_1.9a05ff18.png", import.meta.url).toString();


var $cb22d35aa7092cba$exports = {};
$cb22d35aa7092cba$exports = new URL("login_poster_2.e1b42fdf.png", import.meta.url).toString();


var $affb94c77fc32182$exports = {};
$affb94c77fc32182$exports = new URL("login_poster_3.a1b8c47d.png", import.meta.url).toString();


var $948574fa1e80f7b6$exports = {};
$948574fa1e80f7b6$exports = new URL("login_poster_4.d813f3e5.png", import.meta.url).toString();


var $1d2e658f4e565f5f$exports = {};
$1d2e658f4e565f5f$exports = new URL("login_poster_5.9eb5adcc.png", import.meta.url).toString();


var $3e165130b07c7557$exports = {};
$3e165130b07c7557$exports = new URL("login_poster_6.f5614fbe.png", import.meta.url).toString();


var $edc01426edeb4eae$exports = {};
$edc01426edeb4eae$exports = new URL("reward_claim_button.dd21c4c6.png", import.meta.url).toString();


var $e2a783a4868d2e49$exports = {};
$e2a783a4868d2e49$exports = new URL("reward_cancel_button.31c9bd41.png", import.meta.url).toString();


var $013c33e3bfc134b4$exports = {};
$013c33e3bfc134b4$exports = new URL("reward_confirm_button.8f2f0f65.png", import.meta.url).toString();


var $5788213921e36427$exports = {};
$5788213921e36427$exports = new URL("machine_info_button.8af12c1a.png", import.meta.url).toString();


var $540a8b1b8afed723$exports = {};
$540a8b1b8afed723$exports = new URL("machine_upgrade_button.abec1006.png", import.meta.url).toString();


var $76b85da5621c3ed6$exports = {};
$76b85da5621c3ed6$exports = new URL("machine_speed_up_button.0e5fd437.png", import.meta.url).toString();


var $595e48258e248be6$exports = {};
$595e48258e248be6$exports = new URL("machine_activate_button.04173d56.png", import.meta.url).toString();


var $02a03d0060280a23$exports = {};
$02a03d0060280a23$exports = new URL("machine_claim_button.bde4779a.png", import.meta.url).toString();


var $11c786a253085c0f$exports = {};
$11c786a253085c0f$exports = new URL("machine_train_button.84e7cf04.png", import.meta.url).toString();


var $f6765c889b77cad0$exports = {};
$f6765c889b77cad0$exports = new URL("machine_troops_button.2edb2abd.png", import.meta.url).toString();


var $8ff534fe5e7246f2$exports = {};
$8ff534fe5e7246f2$exports = new URL("mainframe_level_2_v2.526c27c3.png", import.meta.url).toString();


var $9eac169af3b80ad6$exports = {};
$9eac169af3b80ad6$exports = new URL("mainframe_level_6_v2.4bfb903a.png", import.meta.url).toString();


var $b0a75e6341252c52$exports = {};
$b0a75e6341252c52$exports = new URL("mainframe_level_7.6a105d12.png", import.meta.url).toString();


var $623592bfe8252856$exports = {};
$623592bfe8252856$exports = new URL("mainframe_level_8.b494bcf4.png", import.meta.url).toString();


var $a857fd737f8c8bc6$exports = {};
$a857fd737f8c8bc6$exports = new URL("mainframe_level_9.c5d6a08e.png", import.meta.url).toString();


var $355ce7fdd9c62a78$exports = {};
$355ce7fdd9c62a78$exports = new URL("neon_gold_mine_level_10.8b1af5ac.png", import.meta.url).toString();


var $2938007d37fba5ae$exports = {};
$2938007d37fba5ae$exports = new URL("neon_gold_mine_level_11.d4ebc833.png", import.meta.url).toString();


var $4108ea3870597795$exports = {};
$4108ea3870597795$exports = new URL("neon_gold_mine_level_12.2fb16144.png", import.meta.url).toString();


var $75eb03a2bcf943bb$exports = {};
$75eb03a2bcf943bb$exports = new URL("neon_gold_mine_level_13.3f1197bf.png", import.meta.url).toString();


var $0c40e7deff99ddf0$exports = {};
$0c40e7deff99ddf0$exports = new URL("space_elixir_mine_level_10.663e22c9.png", import.meta.url).toString();


var $47745bf4cb57f846$exports = {};
$47745bf4cb57f846$exports = new URL("space_elixir_mine_level_11.03ea10af.png", import.meta.url).toString();


var $a4d4db7cb2d0d81a$exports = {};
$a4d4db7cb2d0d81a$exports = new URL("space_elixir_mine_level_12.c1d35ac6.png", import.meta.url).toString();


var $95317339cd6e584f$exports = {};
$95317339cd6e584f$exports = new URL("space_elixir_mine_level_13.a0e8b9b9.png", import.meta.url).toString();


var $a08ad3c403be241d$exports = {};
$a08ad3c403be241d$exports = new URL("neon_gold_storage_level_10.60ed378b.png", import.meta.url).toString();


var $e1b0b891067562e7$exports = {};
$e1b0b891067562e7$exports = new URL("neon_gold_storage_level_11.70f6c5d4.png", import.meta.url).toString();


var $4154b9bd81145851$exports = {};
$4154b9bd81145851$exports = new URL("neon_gold_storage_level_12.7c9568db.png", import.meta.url).toString();


var $1308c4a0f9d3444e$exports = {};
$1308c4a0f9d3444e$exports = new URL("neon_gold_storage_level_13.6e31ce40.png", import.meta.url).toString();


var $b1e367507a2fa006$exports = {};
$b1e367507a2fa006$exports = new URL("space_elixir_storage_level_10.8df3ab47.png", import.meta.url).toString();


var $0e7a506f97c62e40$exports = {};
$0e7a506f97c62e40$exports = new URL("space_elixir_storage_level_11.fe8d1366.png", import.meta.url).toString();


var $5c962e6c10dc8b9e$exports = {};
$5c962e6c10dc8b9e$exports = new URL("space_elixir_storage_level_12.a5d025c0.png", import.meta.url).toString();


var $2bdc348988de8162$exports = {};
$2bdc348988de8162$exports = new URL("space_elixir_storage_level_13.0f4c8690.png", import.meta.url).toString();


var $fc3201e168ec9864$exports = {};
$fc3201e168ec9864$exports = new URL("star_laboratory_level_1.d2d4a1a8.png", import.meta.url).toString();


var $54ffb3f874595fb1$exports = {};
$54ffb3f874595fb1$exports = new URL("star_laboratory_level_2.4c125025.png", import.meta.url).toString();


var $6119895e44c567cb$exports = {};
$6119895e44c567cb$exports = new URL("star_laboratory_level_3.7e4ed7a0.png", import.meta.url).toString();


var $a087138594d21a7b$exports = {};
$a087138594d21a7b$exports = new URL("gasa_embassy_level_1.cec1e582.png", import.meta.url).toString();


var $4447941b843f8129$exports = {};
$4447941b843f8129$exports = new URL("gasa_embassy_level_2.4743cf67.png", import.meta.url).toString();


var $6bf4b6b3a863809b$exports = {};
$6bf4b6b3a863809b$exports = new URL("gasa_embassy_level_3.830a4cee.png", import.meta.url).toString();


var $08391af8fb7c572a$exports = {};
$08391af8fb7c572a$exports = new URL("raijus_grave_level_1.197d3e44.png", import.meta.url).toString();


var $0a0fd2121efc2d71$exports = {};
$0a0fd2121efc2d71$exports = new URL("linkins_armory_level_1.b02b73f1.png", import.meta.url).toString();


var $1d42b74ae69fe412$exports = {};
$1d42b74ae69fe412$exports = new URL("bench_press_level_1.aa557076.png", import.meta.url).toString();


var $b25baa38b4d7107b$exports = {};
$b25baa38b4d7107b$exports = new URL("valentines_picnic_level_1.07752e6e.png", import.meta.url).toString();


var $e5ce1f0f6f57ea52$exports = {};
$e5ce1f0f6f57ea52$exports = new URL("gooh_refinery_level_1_v2.f86db09f.png", import.meta.url).toString();


var $c14ba136882bc2ff$exports = {};
$c14ba136882bc2ff$exports = new URL("gooh_refinery_level_2_v2.92ef634b.png", import.meta.url).toString();


var $2f2363992b0207e8$exports = {};
$2f2363992b0207e8$exports = new URL("gooh_refinery_level_3.372bd5a7.png", import.meta.url).toString();


var $0505524ffdd6a080$exports = {};
$0505524ffdd6a080$exports = new URL("alchemist_lab_level_1.3187608e.png", import.meta.url).toString();


var $53a37ccde8480b78$exports = {};
$53a37ccde8480b78$exports = new URL("1st_birthday_cake_level_1_v2.02fc963d.png", import.meta.url).toString();


var $c2500a3d9b8d5d70$exports = {};
$c2500a3d9b8d5d70$exports = new URL("brawler_cage_level_1.0f2c4438.png", import.meta.url).toString();


var $94a2cd62711f6f70$exports = {};
$94a2cd62711f6f70$exports = new URL("mother_wolf_statue_level_1.7673379b.png", import.meta.url).toString();


var $bfbe80836ad612e4$exports = {};
$bfbe80836ad612e4$exports = new URL("porcelain_throne_level_1.8a517820.png", import.meta.url).toString();


var $8654704014466fdd$exports = {};
$8654704014466fdd$exports = new URL("others_receiver_level_1.17466520.png", import.meta.url).toString();


var $a8c3b004ca9dcb6a$exports = {};
$a8c3b004ca9dcb6a$exports = new URL("space_cactus_level_1.764af65f.png", import.meta.url).toString();


var $ea59c6c7093d96fd$exports = {};
$ea59c6c7093d96fd$exports = new URL("plasma_cannon_level_1.6fc2ad00.png", import.meta.url).toString();


var $b149dfa414ab3ec7$exports = {};
$b149dfa414ab3ec7$exports = new URL("plasma_cannon_level_2.2ddf6504.png", import.meta.url).toString();


var $60aedd79a72d8303$exports = {};
$60aedd79a72d8303$exports = new URL("plasma_cannon_level_3.e5ecbd28.png", import.meta.url).toString();


var $55df8e393f643bf0$exports = {};
$55df8e393f643bf0$exports = new URL("plasma_cannon_level_1_skin.fc84fd8b.png", import.meta.url).toString();


var $f6dc5488479386e4$exports = {};
$f6dc5488479386e4$exports = new URL("plasma_cannon_level_2_skin.98df2e0f.png", import.meta.url).toString();


var $7a532fb2179ab294$exports = {};
$7a532fb2179ab294$exports = new URL("plasma_cannon_level_3_skin.b490d7d2.png", import.meta.url).toString();


var $6ddb8e6c7da84fca$exports = {};
$6ddb8e6c7da84fca$exports = new URL("little_lemon_tree_level_1.6495319c.png", import.meta.url).toString();


var $fc21c2f55186fafb$exports = {};
$fc21c2f55186fafb$exports = new URL("little_lemon_tree_level_2.c0c945c7.png", import.meta.url).toString();


var $025a3b57db31af76$exports = {};
$025a3b57db31af76$exports = new URL("little_lemon_tree_level_3.74abba45.png", import.meta.url).toString();


var $245487d76e67a12f$exports = {};
$245487d76e67a12f$exports = new URL("aic_lab_level_1.bf217aae.png", import.meta.url).toString();


var $e755cac71efbb40c$exports = {};
$e755cac71efbb40c$exports = new URL("aic_lab_level_2.c11e0d45.png", import.meta.url).toString();


var $e17b3904d505e74e$exports = {};
$e17b3904d505e74e$exports = new URL("aic_lab_level_3.9be40822.png", import.meta.url).toString();


var $3e54d6324b4bb8cd$exports = {};
$3e54d6324b4bb8cd$exports = new URL("mvhq_level_1.048d11a2.png", import.meta.url).toString();


var $41d5154b80ab3cde$exports = {};
$41d5154b80ab3cde$exports = new URL("mvhq_level_2.94d6acf9.png", import.meta.url).toString();


var $b5a48f61a62c547e$exports = {};
$b5a48f61a62c547e$exports = new URL("mvhq_level_3.581b4b87.png", import.meta.url).toString();


var $83f17598db96f50f$exports = {};
$83f17598db96f50f$exports = new URL("mvhq_level_4.754e3b6c.png", import.meta.url).toString();


var $aa64145592d6a78f$exports = {};
$aa64145592d6a78f$exports = new URL("kaiju_kingmaker_level_1.59d7d408.png", import.meta.url).toString();


var $dccad5bc4192b57e$exports = {};
$dccad5bc4192b57e$exports = new URL("kaiju_kingmaker_level_2.98dd517a.png", import.meta.url).toString();


var $fe623a0494863f21$exports = {};
$fe623a0494863f21$exports = new URL("kaiju_kingmaker_level_3.0c708920.png", import.meta.url).toString();


var $413f71780c257ee8$exports = {};
$413f71780c257ee8$exports = new URL("space_elixir_accelerator_level_1.6d66a55b.png", import.meta.url).toString();


var $e59f13c10ae4b5ec$exports = {};
$e59f13c10ae4b5ec$exports = new URL("space_elixir_accelerator_level_2.b081b216.png", import.meta.url).toString();


var $5249f472183c26a0$exports = {};
$5249f472183c26a0$exports = new URL("space_elixir_accelerator_level_3.604b7496.png", import.meta.url).toString();


var $ff48cbc95b4047e0$exports = {};
$ff48cbc95b4047e0$exports = new URL("neon_gold_accelerator_level_1.7d4753f7.png", import.meta.url).toString();


var $8c3630beb2110332$exports = {};
$8c3630beb2110332$exports = new URL("neon_gold_accelerator_level_2.e3251fde.png", import.meta.url).toString();


var $104e51552456fbdc$exports = {};
$104e51552456fbdc$exports = new URL("neon_gold_accelerator_level_3.8db17e3a.png", import.meta.url).toString();


var $7ee61d1ab0fa0048$exports = {};
$7ee61d1ab0fa0048$exports = new URL("mercenary_wolvez_hideout_level_1.a8a2b443.png", import.meta.url).toString();


var $6a5d9c84edbba057$exports = {};
$6a5d9c84edbba057$exports = new URL("mercenary_wolvez_hideout_level_2.af03be6e.png", import.meta.url).toString();


var $25ae3c76574c0c53$exports = {};
$25ae3c76574c0c53$exports = new URL("mercenary_wolvez_hideout_level_3.ba20d9cd.png", import.meta.url).toString();


var $7fd6fb6bf4837b45$exports = {};
$7fd6fb6bf4837b45$exports = new URL("mercenary_wolvez_hideout_level_4.687c358a.png", import.meta.url).toString();


var $094dc8ca175fc1e2$exports = {};
$094dc8ca175fc1e2$exports = new URL("kuma_ancestor_shrine_level_1.1b03d0f3.png", import.meta.url).toString();


var $87d71145a45aa9a4$exports = {};
$87d71145a45aa9a4$exports = new URL("kuma_ancestor_shrine_level_2.91efe0b0.png", import.meta.url).toString();


var $32775bbd6dfee363$exports = {};
$32775bbd6dfee363$exports = new URL("kuma_ancestor_shrine_level_3.ac78af2b.png", import.meta.url).toString();


var $a84852e6e8ab2493$exports = {};
$a84852e6e8ab2493$exports = new URL("super_swole_squad_department_level_1.48d71e36.png", import.meta.url).toString();


var $8df30ac1f9985710$exports = {};
$8df30ac1f9985710$exports = new URL("super_swole_squad_department_level_2.d9a4de50.png", import.meta.url).toString();


var $f505064c375f3dd7$exports = {};
$f505064c375f3dd7$exports = new URL("super_swole_squad_department_level_3.daa70383.png", import.meta.url).toString();


var $e1897fac0f7181d1$exports = {};
$e1897fac0f7181d1$exports = new URL("medical_academy_level_1.cee02db3.png", import.meta.url).toString();


var $afb0d8499a17c436$exports = {};
$afb0d8499a17c436$exports = new URL("medical_academy_level_2.eaa8ce6a.png", import.meta.url).toString();


var $2d79791fab742161$exports = {};
$2d79791fab742161$exports = new URL("medical_academy_level_3.b30d5f0b.png", import.meta.url).toString();


var $e40901da5d83ad3f$exports = {};
$e40901da5d83ad3f$exports = new URL("medical_academy_level_4.3ca4b4d1.png", import.meta.url).toString();


var $7dba5da3664b2244$exports = {};
$7dba5da3664b2244$exports = new URL("antirat_squad_department_level_1.fb33f4d8.png", import.meta.url).toString();


var $7de0d2f6b57ebab3$exports = {};
$7de0d2f6b57ebab3$exports = new URL("antirat_squad_department_level_2.be7cfbe3.png", import.meta.url).toString();


var $8284857af2654450$exports = {};
$8284857af2654450$exports = new URL("antirat_squad_department_level_3.85c5507a.png", import.meta.url).toString();


var $4f02ddda1bdf3b31$exports = {};
$4f02ddda1bdf3b31$exports = new URL("antirat_squad_department_level_4.cc118cf7.png", import.meta.url).toString();


var $1a05e59a10aba89f$exports = {};
$1a05e59a10aba89f$exports = new URL("machines_laser_cannon_level_1.a58ee437.png", import.meta.url).toString();


var $8323f87fda9cf51b$exports = {};
$8323f87fda9cf51b$exports = new URL("machines_laser_cannon_level_2.0f7543c9.png", import.meta.url).toString();


var $5d0e8f1d8563e712$exports = {};
$5d0e8f1d8563e712$exports = new URL("machines_laser_cannon_level_3.47cc4aa5.png", import.meta.url).toString();


var $d3b49cad2e5dc4cd$exports = {};
$d3b49cad2e5dc4cd$exports = new URL("machines_laser_cannon_level_4.1213f65f.png", import.meta.url).toString();


var $8c8e2d5164ab3c6a$exports = {};
$8c8e2d5164ab3c6a$exports = new URL("machines_photon_shield_level_1.f8520ea2.png", import.meta.url).toString();


var $d8adce741c1f5e9f$exports = {};
$d8adce741c1f5e9f$exports = new URL("machines_photon_shield_level_2.72329a8c.png", import.meta.url).toString();


var $63c114ff06a2b16e$exports = {};
$63c114ff06a2b16e$exports = new URL("machines_photon_shield_level_3.c8303be2.png", import.meta.url).toString();


var $cafb7813952e4337$exports = {};
$cafb7813952e4337$exports = new URL("machines_plasma_mortar_level_1.576bd2eb.png", import.meta.url).toString();


var $246f97e103730b1e$exports = {};
$246f97e103730b1e$exports = new URL("machines_plasma_mortar_level_2.0249caa7.png", import.meta.url).toString();


var $288380997f206dca$exports = {};
$288380997f206dca$exports = new URL("machines_plasma_mortar_level_3.7fc04028.png", import.meta.url).toString();


var $31bdee6844fc2d50$exports = {};
$31bdee6844fc2d50$exports = new URL("machines_shield_battery_level_1.0086d681.png", import.meta.url).toString();


var $888b259d308cdc1f$exports = {};
$888b259d308cdc1f$exports = new URL("machines_shield_battery_level_2.5c1eed27.png", import.meta.url).toString();


var $a13293fe05b9cef6$exports = {};
$a13293fe05b9cef6$exports = new URL("machines_shield_battery_level_3.86a01396.png", import.meta.url).toString();


var $4369aa57f209fb5f$exports = {};
$4369aa57f209fb5f$exports = new URL("saved_souls_level_1.ec474c84.png", import.meta.url).toString();


var $5646b19752ee17eb$exports = {};
$5646b19752ee17eb$exports = new URL("saved_souls_level_2.59f0b7bf.png", import.meta.url).toString();


var $4d532817751b739d$exports = {};
$4d532817751b739d$exports = new URL("saved_souls_level_3.4cdcb115.png", import.meta.url).toString();


var $b6f5f3429cc1cddf$exports = {};
$b6f5f3429cc1cddf$exports = new URL("machines_sunday_skirmish_trophy.49f72bb9.png", import.meta.url).toString();


var $ab81835de5daf260$exports = {};
$ab81835de5daf260$exports = new URL("machines_sunday_skirmish_trophy2.1ed2159f.png", import.meta.url).toString();


var $8280a545fdac8207$exports = {};
$8280a545fdac8207$exports = new URL("machines_christmas_tree_2023.0d18036b.png", import.meta.url).toString();


var $5d63bf5d96bd6b4d$exports = {};
$5d63bf5d96bd6b4d$exports = new URL("machines_community_nominee_2023_level_1.0329d5b1.png", import.meta.url).toString();


var $6e6edea75b77e9cf$exports = {};
$6e6edea75b77e9cf$exports = new URL("machines_community_hero_2023_level_1.233cbe63.png", import.meta.url).toString();


var $84cb27aec7eb356c$exports = {};
$84cb27aec7eb356c$exports = new URL("machines_nine_lives_lounge_level_1.ebee7856.png", import.meta.url).toString();


var $fed38f31b56c687e$exports = {};
$fed38f31b56c687e$exports = new URL("machines_glfhers_arcade_level_1.6fda782c.png", import.meta.url).toString();


var $d80d0d286f8f966a$exports = {};
$d80d0d286f8f966a$exports = new URL("machines_pirate_nation_golden_galleon_level_1.d9aac132.png", import.meta.url).toString();


var $fd02a264c99ac1db$exports = {};
$fd02a264c99ac1db$exports = new URL("machines_pirate_nation_wood_galleon_level_1.f29f7ff9.png", import.meta.url).toString();


var $70713c53eaa2e021$exports = {};
$70713c53eaa2e021$exports = new URL("machines_bp_fire_storm_tracker_cosmetic_level_1.c1ab1a78.png", import.meta.url).toString();


var $f20ea379b139ab19$exports = {};
$f20ea379b139ab19$exports = new URL("machines_bp_ice_storm_tracker_cosmetic_level_1.903b7ec7.png", import.meta.url).toString();


var $26a7720c8c638bfb$exports = {};
$26a7720c8c638bfb$exports = new URL("machines_bp_star_wolvez_helmet_cosmetic_level_1.4804ba62.png", import.meta.url).toString();


var $692d33c12975fd31$exports = {};
$692d33c12975fd31$exports = new URL("machines_bp_water_cooler_cosmetic_level_1.07115a4d.png", import.meta.url).toString();


var $add8dc4dd322adcc$exports = {};
$add8dc4dd322adcc$exports = new URL("machines_bp_blob_cosmetic_level_1.979f5315.png", import.meta.url).toString();


var $0b61a02967fe4c45$exports = {};
$0b61a02967fe4c45$exports = new URL("machines_bp_piece_of_home_cosmetic_level_1.a2e3c4f4.png", import.meta.url).toString();


var $71a601e30c6a352f$exports = {};
$71a601e30c6a352f$exports = new URL("machine_info_close_button.f7f8fa34.png", import.meta.url).toString();


var $afbbaff5378253cb$exports = {};
$afbbaff5378253cb$exports = new URL("machine_info_upgrade_button.1330e988.png", import.meta.url).toString();


var $a5a8068b23d7be88$exports = {};
$a5a8068b23d7be88$exports = new URL("machine_info_speed_up_button.80b1ed5d.png", import.meta.url).toString();


var $65deddcfb8f62827$exports = {};
$65deddcfb8f62827$exports = new URL("machine_item_info_divider_long.c3dfc163.png", import.meta.url).toString();


var $c5cd5a0b58bc0add$exports = {};
$c5cd5a0b58bc0add$exports = new URL("machine_item_info_divider_short.5378d25f.png", import.meta.url).toString();


var $c37248a1803118ae$exports = {};
$c37248a1803118ae$exports = new URL("cancel_btn_purple.8cd34028.png", import.meta.url).toString();


var $6ba27548310a0f86$exports = {};
$6ba27548310a0f86$exports = new URL("blob_room_door.ff33612c.png", import.meta.url).toString();


var $0d9c4198426dfa18$exports = {};
$0d9c4198426dfa18$exports = new URL("exit_room_door.876c5dff.png", import.meta.url).toString();


var $ba6c62ec232c284b$exports = {};
$ba6c62ec232c284b$exports = new URL("blob_sprite.d83cd357.png", import.meta.url).toString();


var $abe5584c3b9d65aa$exports = {};
$abe5584c3b9d65aa$exports = new URL("level_circle.40cca3b6.png", import.meta.url).toString();


var $0a79362e636b81b7$exports = {};
$0a79362e636b81b7$exports = new URL("lv_text.87873d27.png", import.meta.url).toString();


var $126c435e56b4c901$exports = {};
$126c435e56b4c901$exports = new URL("level_icon.dfd04cc8.png", import.meta.url).toString();


var $15f6cf264ece0fe1$exports = {};
$15f6cf264ece0fe1$exports = new URL("level_prog_bar.1e6091b5.png", import.meta.url).toString();


var $c4de446a19e9039e$exports = {};
$c4de446a19e9039e$exports = new URL("level_prog_shine.4121eaff.png", import.meta.url).toString();


var $f9a4ebcd022eab5a$exports = {};
$f9a4ebcd022eab5a$exports = new URL("objectives_icon.9bd84dd5.png", import.meta.url).toString();


var $6dd0e484ef832c23$exports = {};
$6dd0e484ef832c23$exports = new URL("objectives_rect.1fc5e4a5.png", import.meta.url).toString();


var $632929e199e68746$exports = {};
$632929e199e68746$exports = new URL("neon_gold_icon.48f69ef3.png", import.meta.url).toString();


var $3ff06241990e853f$exports = {};
$3ff06241990e853f$exports = new URL("space_elixir_icon.e844e9d0.png", import.meta.url).toString();


var $1e51e10e6b258b2f$exports = {};
$1e51e10e6b258b2f$exports = new URL("dark_matter_icon.a0b82354.png", import.meta.url).toString();


var $6e876ab10ca1e420$exports = {};
$6e876ab10ca1e420$exports = new URL("dark_matter_icon_44.ae452164.png", import.meta.url).toString();


var $c6536c0e1b335557$exports = {};
$c6536c0e1b335557$exports = new URL("stardust_pink_icon.3ae6c621.png", import.meta.url).toString();


var $352e3fb0a84a7f43$exports = {};
$352e3fb0a84a7f43$exports = new URL("stardust_pink_icon_44.4dd7225e.png", import.meta.url).toString();


var $ce116e3ba8cecc8e$exports = {};
$ce116e3ba8cecc8e$exports = new URL("stardust_prog_bar.04312c2a.png", import.meta.url).toString();


var $b049fc5b65c3c3f0$exports = {};
$b049fc5b65c3c3f0$exports = new URL("stardust_prog_shine.5deef5b3.png", import.meta.url).toString();


var $007ede4780a42db6$exports = {};
$007ede4780a42db6$exports = new URL("time_icon.daa280aa.png", import.meta.url).toString();


var $ef608ac5ac7513eb$exports = {};
$ef608ac5ac7513eb$exports = new URL("trophy_icon_small.74cabef8.png", import.meta.url).toString();


var $c8777eaf0af07724$exports = {};
$c8777eaf0af07724$exports = new URL("hp_icon.fc3570b9.png", import.meta.url).toString();


var $87eefc95b23f74ec$exports = {};
$87eefc95b23f74ec$exports = new URL("dps_icon.35456f04.png", import.meta.url).toString();


var $6a83f029721a225a$exports = {};
$6a83f029721a225a$exports = new URL("add_stardust_rect.0a185349.png", import.meta.url).toString();


var $f86092df24fdb36c$exports = {};
$f86092df24fdb36c$exports = new URL("squad_rect.fb8bfbf7.png", import.meta.url).toString();


var $f7e0b04b83c23a92$exports = {};
$f7e0b04b83c23a92$exports = new URL("shop_button.cae30533.png", import.meta.url).toString();


var $0befb22c27b8b201$exports = {};
$0befb22c27b8b201$exports = new URL("mission_rect.b0df653e.png", import.meta.url).toString();


var $1431e4a82a1b4436$exports = {};
$1431e4a82a1b4436$exports = new URL("mission_default_text.9d62981d.png", import.meta.url).toString();


var $3b73f066f0c935ff$exports = {};
$3b73f066f0c935ff$exports = new URL("mission_btn_enabled.0bf7d313.png", import.meta.url).toString();


var $bc53c1030ab4a239$exports = {};
$bc53c1030ab4a239$exports = new URL("view_mission_btn.43ef599a.png", import.meta.url).toString();


var $6c474bb081c9d485$exports = {};
$6c474bb081c9d485$exports = new URL("visit_mission_btn.04b7ca91.png", import.meta.url).toString();


var $3076fdebf254a4d8$exports = {};
$3076fdebf254a4d8$exports = new URL("mission_btn_disabled.3e01f265.png", import.meta.url).toString();


var $db25728465f6da54$exports = {};
$db25728465f6da54$exports = new URL("hud_helpdesk_button.53dcd311.png", import.meta.url).toString();


var $4fc13612716d298c$exports = {};
$4fc13612716d298c$exports = new URL("hud_leaderboard_button.1410cb00.png", import.meta.url).toString();


var $9a9aa5555baf01ec$exports = {};
$9a9aa5555baf01ec$exports = new URL("hud_rewards_button.29fc15c1.png", import.meta.url).toString();


var $ba57771d6a3f33b7$exports = {};
$ba57771d6a3f33b7$exports = new URL("hud_army_button.f6e787da.png", import.meta.url).toString();


var $1105fc79327fc7db$exports = {};
$1105fc79327fc7db$exports = new URL("hud_shop_button.5a581be9.png", import.meta.url).toString();


var $5e55a1c3f69949d8$exports = {};
$5e55a1c3f69949d8$exports = new URL("hud_build_button.a0bfb0fe.png", import.meta.url).toString();


var $ae872672ceec93f9$exports = {};
$ae872672ceec93f9$exports = new URL("hud_raid_history_button.9d5cd3b5.png", import.meta.url).toString();


var $c9df7d4e87c5c4e8$exports = {};
$c9df7d4e87c5c4e8$exports = new URL("hud_quests_button.891b250d.png", import.meta.url).toString();


var $475ab6017a7c9d14$exports = {};
$475ab6017a7c9d14$exports = new URL("hand_pointing_7_oclock.fd4a1315.png", import.meta.url).toString();


var $22a84467df8887b7$exports = {};
$22a84467df8887b7$exports = new URL("hand_pointing_9_oclock.f5941661.png", import.meta.url).toString();


var $d261f5f746d94264$exports = {};
$d261f5f746d94264$exports = new URL("hand_pointing_10_oclock.a81b2bc1.png", import.meta.url).toString();


var $9c0a215d272793f8$exports = {};
$9c0a215d272793f8$exports = new URL("close_notification_button.0a4b756d.png", import.meta.url).toString();


var $0674a9d8cdda4458$exports = {};
$0674a9d8cdda4458$exports = new URL("hud_battle_royale_background.90b13de8.png", import.meta.url).toString();


var $a73bc25cea830cf2$exports = {};
$a73bc25cea830cf2$exports = new URL("hud_battle_royale_ready_up_button.de7bda64.png", import.meta.url).toString();


var $4a0e694a2ad1f485$exports = {};
$4a0e694a2ad1f485$exports = new URL("hud_battle_royale_text.116d5352.png", import.meta.url).toString();


var $93e95ff024953d0f$exports = {};
$93e95ff024953d0f$exports = new URL("hud_battle_royale_blue_ready_up_button.d3e0c555.png", import.meta.url).toString();


var $60f601a47a04b8a5$exports = {};
$60f601a47a04b8a5$exports = new URL("hud_battle_royale_blue_view_button.c4fb4e1e.png", import.meta.url).toString();


var $2bb23131d4936e58$exports = {};
$2bb23131d4936e58$exports = new URL("hud_battle_royale_view_button.d2764f1f.png", import.meta.url).toString();


var $e57d3eb1d0cd8b6d$exports = {};
$e57d3eb1d0cd8b6d$exports = new URL("quests_text.4b4a8d10.png", import.meta.url).toString();


var $113e5e0a8ddec9f4$exports = {};
$113e5e0a8ddec9f4$exports = new URL("leaders_text.0b158bd6.png", import.meta.url).toString();


var $1b6a8ca1b449dd43$exports = {};
$1b6a8ca1b449dd43$exports = new URL("help_text.9b73c352.png", import.meta.url).toString();


var $93dc392ac007764c$exports = {};
$93dc392ac007764c$exports = new URL("troops_text.84d5774a.png", import.meta.url).toString();


var $002cf206916badd1$exports = {};
$002cf206916badd1$exports = new URL("shop_text.9dd37b9a.png", import.meta.url).toString();


var $72c24c015ce024f6$exports = {};
$72c24c015ce024f6$exports = new URL("build_text.9cdf2127.png", import.meta.url).toString();


var $6196b3e306e75f30$exports = {};
$6196b3e306e75f30$exports = new URL("raid_history_text.64b2d76a.png", import.meta.url).toString();


var $fd339cf8cb544db8$exports = {};
$fd339cf8cb544db8$exports = new URL("your_squad_text.6aa8afb8.png", import.meta.url).toString();


var $a1d7a9e2364cc7df$exports = {};
$a1d7a9e2364cc7df$exports = new URL("battlepass_text.30487af4.png", import.meta.url).toString();


var $8ae655b2556a43e3$exports = {};
$8ae655b2556a43e3$exports = new URL("hud_battlepass_button.d8d6d1a6.png", import.meta.url).toString();


var $5a9aab1396b97f3d$exports = {};
$5a9aab1396b97f3d$exports = new URL("battle_pass_icon_v2.162c23c1.png", import.meta.url).toString();


var $8f6511c6e20e2bb2$exports = {};
$8f6511c6e20e2bb2$exports = new URL("put_to_sleep_button.df590796.png", import.meta.url).toString();


var $954d528417d7daa5$exports = {};
$954d528417d7daa5$exports = new URL("pet_button.2bdab15c.png", import.meta.url).toString();


var $7efd6dfbffa9a491$exports = {};
$7efd6dfbffa9a491$exports = new URL("assign_points_button.a3457874.png", import.meta.url).toString();


var $92a8cf636ee58960$exports = {};
$92a8cf636ee58960$exports = new URL("give_food_button.bc490c9f.png", import.meta.url).toString();


var $c9df7883e2154e4e$exports = {};
$c9df7883e2154e4e$exports = new URL("give_medication_button.10ba8dd9.png", import.meta.url).toString();


var $7ea2abb159855bf3$exports = {};
$7ea2abb159855bf3$exports = new URL("blob_hud_image.3fa847b7.png", import.meta.url).toString();


var $485721dc2a29916e$exports = {};
$485721dc2a29916e$exports = new URL("blob_hud_divider_line.666e4755.png", import.meta.url).toString();


var $2b3139830cd2d82d$exports = {};
$2b3139830cd2d82d$exports = new URL("add_points_button.4110e346.png", import.meta.url).toString();


var $4cb65d1197a5182a$exports = {};
$4cb65d1197a5182a$exports = new URL("remove_points_button.0c1fe3b9.png", import.meta.url).toString();


var $87ab0a599167d26c$exports = {};
$87ab0a599167d26c$exports = new URL("blob_option_divider_line.7afe5319.png", import.meta.url).toString();


var $46b09f602d5ba6e1$exports = {};
$46b09f602d5ba6e1$exports = new URL("battery_icon.c03fdc08.png", import.meta.url).toString();


var $f66ee79cdcfb5abd$exports = {};
$f66ee79cdcfb5abd$exports = new URL("lock_icon.d734f569.png", import.meta.url).toString();


var $be4fd93302377262$exports = {};
$be4fd93302377262$exports = new URL("name_screen_rect.8e39544e.png", import.meta.url).toString();


var $f6fda76d4d1b18f9$exports = {};
$f6fda76d4d1b18f9$exports = new URL("name_screen_text.f613f836.png", import.meta.url).toString();


var $a6a878a84c3220c1$exports = {};
$a6a878a84c3220c1$exports = new URL("name_screen_btn_disabled.65a487e5.png", import.meta.url).toString();


var $03f7b9ca3a0dbcef$exports = {};
$03f7b9ca3a0dbcef$exports = new URL("name_screen_btn_enabled.44d29edf.png", import.meta.url).toString();


var $32ef4e8a3e68ebe3$exports = {};
$32ef4e8a3e68ebe3$exports = new URL("loading_screen_rectangle.8e39544e.png", import.meta.url).toString();


var $db7bf2722d94283a$exports = {};
$db7bf2722d94283a$exports = new URL("loading_screen_prog_bar.6fd69a92.png", import.meta.url).toString();


var $cc691702c3d21393$exports = {};
$cc691702c3d21393$exports = new URL("loading_screen_prog_1.70e244b1.png", import.meta.url).toString();


var $186b2efc2baa6adc$exports = {};
$186b2efc2baa6adc$exports = new URL("loading_screen_prog_2.ce0e7660.png", import.meta.url).toString();


var $b4ab77cf0aed23bb$exports = {};
$b4ab77cf0aed23bb$exports = new URL("loading_screen_prog_3.5805c950.png", import.meta.url).toString();


var $4e299be7159808fc$exports = {};
$4e299be7159808fc$exports = new URL("loading_screen_prog_4.2bad3b2e.png", import.meta.url).toString();


var $4530a769a02dd3fc$exports = {};
$4530a769a02dd3fc$exports = new URL("loading_screen_prog_5.b9d58d7d.png", import.meta.url).toString();


var $b40f8ee7b66e2022$exports = {};
$b40f8ee7b66e2022$exports = new URL("load_text_1.9382caa1.png", import.meta.url).toString();


var $453121e4cde59830$exports = {};
$453121e4cde59830$exports = new URL("load_text_2.f16e0fa0.png", import.meta.url).toString();


var $bf188843f286c0b3$exports = {};
$bf188843f286c0b3$exports = new URL("load_text_3.257636cd.png", import.meta.url).toString();


var $486354799ba08299$exports = {};
$486354799ba08299$exports = new URL("load_text_4.1ad322b3.png", import.meta.url).toString();


var $864be546d21f68ab$exports = {};
$864be546d21f68ab$exports = new URL("homebase_loading_text.62bb3372.png", import.meta.url).toString();


var $245174d3a4332e9a$exports = {};
$245174d3a4332e9a$exports = new URL("leaderboard_icon.7a32ed87.png", import.meta.url).toString();


var $8498057af217a603$exports = {};
$8498057af217a603$exports = new URL("leaderboard_divider_v2.e761eafd.png", import.meta.url).toString();


var $1321f834559dd6a4$exports = {};
$1321f834559dd6a4$exports = new URL("leaderboard_pvp_button.db2a23ff.png", import.meta.url).toString();


var $83a2718a7a9ce95f$exports = {};
$83a2718a7a9ce95f$exports = new URL("leaderboard_pvp_button_inactive.b55d0516.png", import.meta.url).toString();


var $ca22538e9d7e18ed$exports = {};
$ca22538e9d7e18ed$exports = new URL("leaderboard_stardust_button.f6b0860d.png", import.meta.url).toString();


var $714f7f3e0818a59d$exports = {};
$714f7f3e0818a59d$exports = new URL("leaderboard_stardust_button_inactive.9570f962.png", import.meta.url).toString();


var $63f7db4c62823033$exports = {};
$63f7db4c62823033$exports = new URL("leaderboard_logins_button.12385ce6.png", import.meta.url).toString();


var $9250a4689a0db7fb$exports = {};
$9250a4689a0db7fb$exports = new URL("leaderboard_logins_button_inactive.555d590d.png", import.meta.url).toString();


var $9e40aa13eb3d712c$exports = {};
$9e40aa13eb3d712c$exports = new URL("leaderboard_title.c7e9b0f7.png", import.meta.url).toString();


var $8980181273118be9$exports = {};
$8980181273118be9$exports = new URL("leaderboard_pve_button.a8345f38.png", import.meta.url).toString();


var $9c05270a86dfc28a$exports = {};
$9c05270a86dfc28a$exports = new URL("leaderboard_pve_button_inactive.b3e330ab.png", import.meta.url).toString();


var $238752cdb081f55f$exports = {};
$238752cdb081f55f$exports = new URL("leaderboard_xp_button.cb1852e6.png", import.meta.url).toString();


var $4f402a651584c979$exports = {};
$4f402a651584c979$exports = new URL("leaderboard_xp_button_inactive.89a5722a.png", import.meta.url).toString();


var $a9dc2534ef9708dc$exports = {};
$a9dc2534ef9708dc$exports = new URL("leaderboard_mining_button.412a6725.png", import.meta.url).toString();


var $309b47dd830c0ec4$exports = {};
$309b47dd830c0ec4$exports = new URL("leaderboard_mining_button_inactive.4a1a4410.png", import.meta.url).toString();


var $e3538d54ec030fc9$exports = {};
$e3538d54ec030fc9$exports = new URL("leaderboard_base_raid_button.618d6182.png", import.meta.url).toString();


var $c7207e1f2bff2019$exports = {};
$c7207e1f2bff2019$exports = new URL("leaderboard_base_raid_button_inactive.c84e82ac.png", import.meta.url).toString();


var $5b303489b647f361$exports = {};
$5b303489b647f361$exports = new URL("guide_changelog_text.82cc58ad.png", import.meta.url).toString();


var $ce2a6f41c824d469$exports = {};
$ce2a6f41c824d469$exports = new URL("guide_game_text.6fafe460.png", import.meta.url).toString();


var $feefb826f434e1c2$exports = {};
$feefb826f434e1c2$exports = new URL("guide_medium_text.d9af8241.png", import.meta.url).toString();


var $9dbd3206ba6a977c$exports = {};
$9dbd3206ba6a977c$exports = new URL("guide_wolf_e_dex_text.22218f9f.png", import.meta.url).toString();


var $93af9111adb70ad7$exports = {};
$93af9111adb70ad7$exports = new URL("litepaper_1_gameplay_text.923d81f4.png", import.meta.url).toString();


var $fe7e5fe08fc37c59$exports = {};
$fe7e5fe08fc37c59$exports = new URL("litepaper_2_tokenomics_text.14f07eba.png", import.meta.url).toString();


var $4ae20922fcf409cc$exports = {};
$4ae20922fcf409cc$exports = new URL("traits_text.ef6c0dc9.png", import.meta.url).toString();


var $b3a97345e2bdafeb$exports = {};
$b3a97345e2bdafeb$exports = new URL("partners_text.c9c7db0c.png", import.meta.url).toString();


var $17c8836ca233e370$exports = {};
$17c8836ca233e370$exports = new URL("helpdesk_option_bg.2e1277ca.png", import.meta.url).toString();


var $bb0227866ecb619b$exports = {};
$bb0227866ecb619b$exports = new URL("helpdesk_text.5ac43639.png", import.meta.url).toString();


var $3cf9b80ca3da32e0$exports = {};
$3cf9b80ca3da32e0$exports = new URL("missions_text.b723eab3.png", import.meta.url).toString();


var $27c4bc42362d7757$exports = {};
$27c4bc42362d7757$exports = new URL("pvp_button_bg.4698c358.png", import.meta.url).toString();


var $cc36528536cad54f$exports = {};
$cc36528536cad54f$exports = new URL("pvp_button_text.ffba04b2.png", import.meta.url).toString();


var $171a65724ef148d5$exports = {};
$171a65724ef148d5$exports = new URL("battle_royale_button_bg.b1dec4fd.png", import.meta.url).toString();


var $a46dce809d741f1f$exports = {};
$a46dce809d741f1f$exports = new URL("battle_royale_button_text.a4728905.png", import.meta.url).toString();


var $ad71c7e03822433e$exports = {};
$ad71c7e03822433e$exports = new URL("boss_fight_button_bg.e8f816b9.png", import.meta.url).toString();


var $26bd6c1ec5b37fb4$exports = {};
$26bd6c1ec5b37fb4$exports = new URL("boss_fight_button_text.5b83c8f5.png", import.meta.url).toString();


var $b994c34482951457$exports = {};
$b994c34482951457$exports = new URL("pve_button_bg.38275127.png", import.meta.url).toString();


var $26a15f1edf12658f$exports = {};
$26a15f1edf12658f$exports = new URL("pve_button_text.f109f0c0.png", import.meta.url).toString();


var $f4986983df16f97b$exports = {};
$f4986983df16f97b$exports = new URL("base_raid_button_bg.122a048c.png", import.meta.url).toString();


var $43e4bd0a956bd1f6$exports = {};
$43e4bd0a956bd1f6$exports = new URL("base_raid_button_text.b05d3662.png", import.meta.url).toString();


var $5459a257948490e7$exports = {};
$5459a257948490e7$exports = new URL("mining_mission_button_bg.40d54b32.png", import.meta.url).toString();


var $b6525687ae6cb35f$exports = {};
$b6525687ae6cb35f$exports = new URL("mining_mission_button_text_v2.713ac951.png", import.meta.url).toString();


var $9cf803ef2da6bdd3$exports = {};
$9cf803ef2da6bdd3$exports = new URL("mining_mission_logo_image.5fbf3210.png", import.meta.url).toString();


var $7ad2dbc0f5a744e3$exports = {};
$7ad2dbc0f5a744e3$exports = new URL("mining_cancel_dialog_cancel_button.3cc8a562.png", import.meta.url).toString();


var $68ddff60bb71c9ad$exports = {};
$68ddff60bb71c9ad$exports = new URL("mining_cancel_dialog_confirm_button.8f2f0f65.png", import.meta.url).toString();


var $728d33180c042ae2$exports = {};
$728d33180c042ae2$exports = new URL("mining_back_to_missions_button.db037c6d.png", import.meta.url).toString();


var $b5a91bfebc20752c$exports = {};
$b5a91bfebc20752c$exports = new URL("mining_launch_button.e64956f4.png", import.meta.url).toString();


var $5bb67394a9de79ee$exports = {};
$5bb67394a9de79ee$exports = new URL("mining_not_enough_resources_dialog_got_it_button.c6b57100.png", import.meta.url).toString();


var $d71f757e0568c7e3$exports = {};
$d71f757e0568c7e3$exports = new URL("mining_paw.44a44c2d.png", import.meta.url).toString();


var $c62faeb0e11d0ab8$exports = {};
$c62faeb0e11d0ab8$exports = new URL("mining_cancel_mission_button.c5b92c02.png", import.meta.url).toString();


var $15aa01ddbfb09c72$exports = {};
$15aa01ddbfb09c72$exports = new URL("mining_back_to_homebase_button.29feb859.png", import.meta.url).toString();


var $1ca4fc903c2450d4$exports = {};
$1ca4fc903c2450d4$exports = new URL("mining_return_home_button.1409f244.png", import.meta.url).toString();


var $9860e8e2c353ca49$exports = {};
$9860e8e2c353ca49$exports = new URL("mining_success_badge.068e1c65.png", import.meta.url).toString();


var $3c6414f3121cc100$exports = {};
$3c6414f3121cc100$exports = new URL("mining_defeat_badge.7a4266b6.png", import.meta.url).toString();


var $968c120b949c8e52$exports = {};
$968c120b949c8e52$exports = new URL("mining_success_label.8242f11b.png", import.meta.url).toString();


var $609e95b6e4b0fcf6$exports = {};
$609e95b6e4b0fcf6$exports = new URL("mining_defeat_label.edd94a1d.png", import.meta.url).toString();


var $be89bfe2522429e5$exports = {};
$be89bfe2522429e5$exports = new URL("common_asteroid.3caa2676.png", import.meta.url).toString();


var $153ffd75f0d5fd71$exports = {};
$153ffd75f0d5fd71$exports = new URL("rare_asteroid.620a8120.png", import.meta.url).toString();


var $2fafc7565cc316fc$exports = {};
$2fafc7565cc316fc$exports = new URL("epic_asteroid.59a2bd17.png", import.meta.url).toString();


var $e5e8a5c16eb96080$exports = {};
$e5e8a5c16eb96080$exports = new URL("legendary_asteroid.4ca84886.png", import.meta.url).toString();


var $f3438c8fb3a69d54$exports = {};
$f3438c8fb3a69d54$exports = new URL("mythical_asteroid.354033f9.png", import.meta.url).toString();


var $d4ea82ca289fd3c4$exports = {};
$d4ea82ca289fd3c4$exports = new URL("mining_divider.9ccb48df.png", import.meta.url).toString();


var $0dc500e74cdf489f$exports = {};
$0dc500e74cdf489f$exports = new URL("settings_text.5d108d90.png", import.meta.url).toString();


var $1f0ba91f8f3cc796$exports = {};
$1f0ba91f8f3cc796$exports = new URL("settings_connect_wallet_button.8a101441.png", import.meta.url).toString();


var $12dd268b0ed0243e$exports = {};
$12dd268b0ed0243e$exports = new URL("disconnect_button.b7e2175c.png", import.meta.url).toString();


var $c42f7f016762a26a$exports = {};
$c42f7f016762a26a$exports = new URL("disconnect_button_disabled.9f461877.png", import.meta.url).toString();


var $13449a3032c18cf3$exports = {};
$13449a3032c18cf3$exports = new URL("kick_button_disabled.4d1c8689.png", import.meta.url).toString();


var $140966120df452ae$exports = {};
$140966120df452ae$exports = new URL("save_and_exit_button.ccff2424.png", import.meta.url).toString();


var $249007e5b7028ca5$exports = {};
$249007e5b7028ca5$exports = new URL("music_button_active.ded1df97.png", import.meta.url).toString();


var $08253fd63200b62e$exports = {};
$08253fd63200b62e$exports = new URL("sound_effects_button_active.1a70b5c7.png", import.meta.url).toString();


var $ff5efbc6b58452f8$exports = {};
$ff5efbc6b58452f8$exports = new URL("help_pane_divider.7afe5319.png", import.meta.url).toString();


var $46eb864b9e9248ad$exports = {};
$46eb864b9e9248ad$exports = new URL("help_channel_image.12f2c7c0.png", import.meta.url).toString();


var $8a671f29073867f0$exports = {};
$8a671f29073867f0$exports = new URL("inter_planetary_image.363b142e.png", import.meta.url).toString();


var $43119a5520bb28f4$exports = {};
$43119a5520bb28f4$exports = new URL("pvp_heavy_attack_button.bded1cec.png", import.meta.url).toString();


var $d8967184e7d4b031$exports = {};
$d8967184e7d4b031$exports = new URL("pvp_heavy_attack_button_disabled.bacd5d7d.png", import.meta.url).toString();


var $f66fa572dcbabd4f$exports = {};
$f66fa572dcbabd4f$exports = new URL("pvp_light_attack_button.3e9ae306.png", import.meta.url).toString();


var $a19bc0c4559fbdc2$exports = {};
$a19bc0c4559fbdc2$exports = new URL("pvp_light_attack_button_disabled.a0f02fbf.png", import.meta.url).toString();


var $14257ea645dc5c45$exports = {};
$14257ea645dc5c45$exports = new URL("pvp_defend_button.76ae9ff6.png", import.meta.url).toString();


var $5289243f5fe295fc$exports = {};
$5289243f5fe295fc$exports = new URL("pvp_defend_button_disabled.81a541da.png", import.meta.url).toString();


var $7832184daba2913c$exports = {};
$7832184daba2913c$exports = new URL("pvp_restore_button.b59d1a5a.png", import.meta.url).toString();


var $1eca8d76545c9cfc$exports = {};
$1eca8d76545c9cfc$exports = new URL("pvp_restore_button_disabled.9347da30.png", import.meta.url).toString();


var $4fa3a10ca05b1860$exports = {};
$4fa3a10ca05b1860$exports = new URL("pvp_heal_button.c88bbc04.png", import.meta.url).toString();


var $d14f283ff565b2d5$exports = {};
$d14f283ff565b2d5$exports = new URL("pvp_heal_button_disabled.c8e1590c.png", import.meta.url).toString();


var $e603b3e4d1b2ce76$exports = {};
$e603b3e4d1b2ce76$exports = new URL("pvp_surrender_button.737c8566.png", import.meta.url).toString();


var $371701b0edf6b232$exports = {};
$371701b0edf6b232$exports = new URL("pvp_surrender_button_disabled.488130f1.png", import.meta.url).toString();


var $d96d3d2b0ad0b29d$exports = {};
$d96d3d2b0ad0b29d$exports = new URL("pvp_player_divider.76d6c83d.png", import.meta.url).toString();


var $880a9acc72afd6df$exports = {};
$880a9acc72afd6df$exports = new URL("pvp_game_divider.3cbdb7ce.png", import.meta.url).toString();


var $d651ffc44bdcbb91$exports = {};
$d651ffc44bdcbb91$exports = new URL("pvp_vertical_divider.24456554.png", import.meta.url).toString();


var $f51fac2f7010a241$exports = {};
$f51fac2f7010a241$exports = new URL("pvp_hp_icon.44fc12fc.png", import.meta.url).toString();


var $b26dcb725c1d556f$exports = {};
$b26dcb725c1d556f$exports = new URL("pvp_ap_icon.83a4a9bd.png", import.meta.url).toString();


var $9cc4c758e6c747ba$exports = {};
$9cc4c758e6c747ba$exports = new URL("cancel_button.56ac77cb.png", import.meta.url).toString();


var $34d00cd0f637669f$exports = {};
$34d00cd0f637669f$exports = new URL("pvp_victory_icon.5fc29112.png", import.meta.url).toString();


var $4c562f735b5a1bb5$exports = {};
$4c562f735b5a1bb5$exports = new URL("pvp_defeat_icon.c38873e8.png", import.meta.url).toString();


var $f44b904c8b426b24$exports = {};
$f44b904c8b426b24$exports = new URL("pvp_draw_icon.ffd57ccb.png", import.meta.url).toString();


var $684edc1fd2422bfb$exports = {};
$684edc1fd2422bfb$exports = new URL("pvp_victory_icon_label.e71401e8.png", import.meta.url).toString();


var $e9957f99ebc181b8$exports = {};
$e9957f99ebc181b8$exports = new URL("pvp_defeat_icon_label.768a562c.png", import.meta.url).toString();


var $7d5f3625cfb1b2c2$exports = {};
$7d5f3625cfb1b2c2$exports = new URL("pvp_draw_icon_label.c60e390a.png", import.meta.url).toString();


var $b2999f570de9ec23$exports = {};
$b2999f570de9ec23$exports = new URL("pvp_return_home_button.1409f244.png", import.meta.url).toString();


var $a7d97e893dd0a8bc$exports = {};
$a7d97e893dd0a8bc$exports = new URL("pvp_confirm_button.8f2f0f65.png", import.meta.url).toString();


var $e70441a2d03bcb5f$exports = {};
$e70441a2d03bcb5f$exports = new URL("pvp_cancel_button.8637ebd9.png", import.meta.url).toString();


var $334617e7d1189f28$exports = {};
$334617e7d1189f28$exports = new URL("pve_gameover_bg.360dd69a.png", import.meta.url).toString();


var $27184a1d05d0d746$exports = {};
$27184a1d05d0d746$exports = new URL("pve_victory_bg.98690f6c.png", import.meta.url).toString();


var $fb4f739456aac912$exports = {};
$fb4f739456aac912$exports = new URL("pve_continue_button.8880205a.png", import.meta.url).toString();


var $48400f8472f7bec9$exports = {};
$48400f8472f7bec9$exports = new URL("pve_opponent_pfp.43c4e9ee.png", import.meta.url).toString();


var $80d05b0a61ca47b2$exports = {};
$80d05b0a61ca47b2$exports = new URL("machines_tab_active.e51b08b1.png", import.meta.url).toString();


var $553b5870bd9af7b5$exports = {};
$553b5870bd9af7b5$exports = new URL("item_shop_tab_active.4bd7be42.png", import.meta.url).toString();


var $2ba632b9541e0d8c$exports = {};
$2ba632b9541e0d8c$exports = new URL("resources_tab_active.b94f17c6.png", import.meta.url).toString();


var $afe8b2301c5410f2$exports = {};
$afe8b2301c5410f2$exports = new URL("machines_tab_inactive.2ec23b71.png", import.meta.url).toString();


var $010cf85a9ba0eee1$exports = {};
$010cf85a9ba0eee1$exports = new URL("item_shop_tab_inactive.c170551f.png", import.meta.url).toString();


var $4cfa672db7a269b5$exports = {};
$4cfa672db7a269b5$exports = new URL("resources_tab_inactive.c4e23dad.png", import.meta.url).toString();


var $1b6636ae31b5bf06$exports = {};
$1b6636ae31b5bf06$exports = new URL("shop_common_resource_box_image.a37eec04.png", import.meta.url).toString();


var $8556ef45b78fffe1$exports = {};
$8556ef45b78fffe1$exports = new URL("shop_epic_resource_box_image.ac2cab2a.png", import.meta.url).toString();


var $d2a43cc5c21310ec$exports = {};
$d2a43cc5c21310ec$exports = new URL("shop_legendary_resource_box_image.0410bcdf.png", import.meta.url).toString();


var $5cb38a7bb1b9556d$exports = {};
$5cb38a7bb1b9556d$exports = new URL("shop_common_ng_refill_image.d321c7a3.png", import.meta.url).toString();


var $5b219aa4bfbc3447$exports = {};
$5b219aa4bfbc3447$exports = new URL("shop_rare_ng_refill_image.61496d9f.png", import.meta.url).toString();


var $c7fbccf35957187c$exports = {};
$c7fbccf35957187c$exports = new URL("shop_epic_ng_refill_image.421a35cd.png", import.meta.url).toString();


var $88ec0cf213d9cdfd$exports = {};
$88ec0cf213d9cdfd$exports = new URL("shop_common_se_refill_image.bbc14b04.png", import.meta.url).toString();


var $693c1e8aace7e7a9$exports = {};
$693c1e8aace7e7a9$exports = new URL("shop_rare_se_refill_image.9814f1c5.png", import.meta.url).toString();


var $60523745d96794fe$exports = {};
$60523745d96794fe$exports = new URL("shop_epic_se_refill_image.74debdac.png", import.meta.url).toString();


var $90b85855b07ccedb$exports = {};
$90b85855b07ccedb$exports = new URL("shop_animated_408_image.75f239e0.png", import.meta.url).toString();


var $8f4b02ccc100b7ad$exports = {};
$8f4b02ccc100b7ad$exports = new URL("shop_animated_3299_image.0bdd410a.png", import.meta.url).toString();


var $d562c1a427cfc140$exports = {};
$d562c1a427cfc140$exports = new URL("shop_star_wolvez_hoodie_image.df1816aa.png", import.meta.url).toString();


var $4ff495ee132c341a$exports = {};
$4ff495ee132c341a$exports = new URL("animation_chip_image.07744ce2.png", import.meta.url).toString();


var $e97a19424fe266df$exports = {};
$e97a19424fe266df$exports = new URL("shop_bk55_chip_image.7b0bb994.png", import.meta.url).toString();


var $308f1711a3a7d8b5$exports = {};
$308f1711a3a7d8b5$exports = new URL("shop_bk55_ii_chip_image.7b0bb994.png", import.meta.url).toString();


var $ecf5b34bcf5e51db$exports = {};
$ecf5b34bcf5e51db$exports = new URL("shop_fur_69_chip_image.5c75e744.png", import.meta.url).toString();


var $6943a954905eda91$exports = {};
$6943a954905eda91$exports = new URL("shop_little_lemon_friends_image.5915d93b.png", import.meta.url).toString();


var $daf869495e0301b3$exports = {};
$daf869495e0301b3$exports = new URL("shop_etherorc_allies_image.e9f72737.png", import.meta.url).toString();


var $b0940ff5a4085d5a$exports = {};
$b0940ff5a4085d5a$exports = new URL("shop_brawler_bearz_image_v2.ce6bfd5e.png", import.meta.url).toString();


var $b7ed6568870f5253$exports = {};
$b7ed6568870f5253$exports = new URL("shop_back_button.6875a205.png", import.meta.url).toString();


var $cca79c708520bcb9$exports = {};
$cca79c708520bcb9$exports = new URL("shop_stake_button.9e23247d.png", import.meta.url).toString();


var $7e228275c0d2e5d5$exports = {};
$7e228275c0d2e5d5$exports = new URL("shop_buy_swap_button.1cbea2d4.png", import.meta.url).toString();


var $05681221570bd0b9$exports = {};
$05681221570bd0b9$exports = new URL("shop_stake_button_inactive.e41f723b.png", import.meta.url).toString();


var $07d19fb579f89b66$exports = {};
$07d19fb579f89b66$exports = new URL("shop_buy_swap_button_inactive.e29586ae.png", import.meta.url).toString();


var $a9fde35cfa45da9b$exports = {};
$a9fde35cfa45da9b$exports = new URL("shop_cosmetics_button_inactive.592a996f.png", import.meta.url).toString();


var $2e4915df46f8fe71$exports = {};
$2e4915df46f8fe71$exports = new URL("shop_other_button_inactive.7b86830c.png", import.meta.url).toString();


var $ea03fdf242e653b0$exports = {};
$ea03fdf242e653b0$exports = new URL("shop_whitelist_button_inactive.4187ac0f.png", import.meta.url).toString();


var $ea3fc9ab63930b28$exports = {};
$ea3fc9ab63930b28$exports = new URL("shop_cosmetics_button.1d63aea9.png", import.meta.url).toString();


var $c5e4cfec3cfac563$exports = {};
$c5e4cfec3cfac563$exports = new URL("shop_other_button.4b1ef3dc.png", import.meta.url).toString();


var $b6a2acfafa6de887$exports = {};
$b6a2acfafa6de887$exports = new URL("shop_whitelist_button.80449378.png", import.meta.url).toString();


var $37d9a11c61c4be11$exports = {};
$37d9a11c61c4be11$exports = new URL("shop_administrative_button_inactive.e9072b2d.png", import.meta.url).toString();


var $be8b259d25c9b356$exports = {};
$be8b259d25c9b356$exports = new URL("shop_army_button_inactive.3f70090e.png", import.meta.url).toString();


var $cc0bd4ba3d8f049d$exports = {};
$cc0bd4ba3d8f049d$exports = new URL("shop_available_button.aef96c93.png", import.meta.url).toString();


var $94a755020f3a42d3$exports = {};
$94a755020f3a42d3$exports = new URL("shop_research_button_inactive.1e458587.png", import.meta.url).toString();


var $c6a86e94e671a1c8$exports = {};
$c6a86e94e671a1c8$exports = new URL("shop_resources_button_inactive.b4dd7104.png", import.meta.url).toString();


var $80c6a6aa9db13be0$exports = {};
$80c6a6aa9db13be0$exports = new URL("shop_administrative_button.876f7b16.png", import.meta.url).toString();


var $a19d3e16eb070d9e$exports = {};
$a19d3e16eb070d9e$exports = new URL("shop_army_button.8bea408d.png", import.meta.url).toString();


var $d5b5a0c147b77619$exports = {};
$d5b5a0c147b77619$exports = new URL("shop_available_button_inactive.70f69ff2.png", import.meta.url).toString();


var $9be1f4234ebcd0f6$exports = {};
$9be1f4234ebcd0f6$exports = new URL("shop_research_button.296e0a34.png", import.meta.url).toString();


var $bd79922b6b8479c3$exports = {};
$bd79922b6b8479c3$exports = new URL("shop_all_button.dcc7a94d.png", import.meta.url).toString();


var $b552cb7bf774ba28$exports = {};
$b552cb7bf774ba28$exports = new URL("shop_all_button_inactive.4e69d9d5.png", import.meta.url).toString();


var $0b6a43c5d816a90e$exports = {};
$0b6a43c5d816a90e$exports = new URL("shop_holder_exclusive_button.6530eb04.png", import.meta.url).toString();


var $dafd2c4d50ff49c8$exports = {};
$dafd2c4d50ff49c8$exports = new URL("shop_holder_exclusive_button_inactive.43817a38.png", import.meta.url).toString();


var $f1d9c233b1383671$exports = {};
$f1d9c233b1383671$exports = new URL("shop_resources_button.cf7c9432.png", import.meta.url).toString();


var $ab95b0ce2eac2af0$exports = {};
$ab95b0ce2eac2af0$exports = new URL("shop_item_info_button.9d105054.png", import.meta.url).toString();


var $6d734b99665274d7$exports = {};
$6d734b99665274d7$exports = new URL("shop_item_info_letter.a4ffd4e1.png", import.meta.url).toString();


var $9e57af70e07a9c61$exports = {};
$9e57af70e07a9c61$exports = new URL("shop_item_info_divider_long.350cf459.png", import.meta.url).toString();


var $b8366922dbfbc1b6$exports = {};
$b8366922dbfbc1b6$exports = new URL("shop_item_info_stardust_progress_bar.d4d72b2f.png", import.meta.url).toString();


var $1532596accee584d$exports = {};
$1532596accee584d$exports = new URL("shop_buy_button.0b1939fe.png", import.meta.url).toString();


var $c1c83665a24b086e$exports = {};
$c1c83665a24b086e$exports = new URL("shop_coming_soon_button.5f34dec4.png", import.meta.url).toString();


var $86440a202b5eb9ea$exports = {};
$86440a202b5eb9ea$exports = new URL("shop_sold_out_button.25449f9b.png", import.meta.url).toString();


var $d6fbd71deced2a5a$exports = {};
$d6fbd71deced2a5a$exports = new URL("shop_nfts_button.6120f4be.png", import.meta.url).toString();


var $2853bc53564eb3ba$exports = {};
$2853bc53564eb3ba$exports = new URL("shop_nfts_button_inactive.f0561222.png", import.meta.url).toString();


var $823b3182e6e04297$exports = {};
$823b3182e6e04297$exports = new URL("shop_special_items_button.1dbd802a.png", import.meta.url).toString();


var $fc0ffbe83ba35c7f$exports = {};
$fc0ffbe83ba35c7f$exports = new URL("shop_special_items_button_inactive.ad2dc279.png", import.meta.url).toString();


var $392095ccd09d577e$exports = {};
$392095ccd09d577e$exports = new URL("shop_resource_packs_button.b1d81b29.png", import.meta.url).toString();


var $0b277739caa0012e$exports = {};
$0b277739caa0012e$exports = new URL("shop_resource_packs_button_inactive.27c3ecec.png", import.meta.url).toString();


var $cf1a8a50154146f6$exports = {};
$cf1a8a50154146f6$exports = new URL("shop_battlepass_season_0_image.7272e083.png", import.meta.url).toString();


var $cee5c505070f6dff$exports = {};
$cee5c505070f6dff$exports = new URL("shop_machines_mainframe_v2.2afa78d0.png", import.meta.url).toString();


var $de828deefa6bf54b$exports = {};
$de828deefa6bf54b$exports = new URL("shop_machines_neon_gold_mine_v2.f60cc450.png", import.meta.url).toString();


var $a9fbcdbf8044ee7b$exports = {};
$a9fbcdbf8044ee7b$exports = new URL("shop_machines_neon_gold_storage_v2.eddb66f7.png", import.meta.url).toString();


var $20aeb8911ade14ee$exports = {};
$20aeb8911ade14ee$exports = new URL("shop_machines_space_elixir_mine_v2.f0e2af5b.png", import.meta.url).toString();


var $e6b75f937beda1cc$exports = {};
$e6b75f937beda1cc$exports = new URL("shop_machines_space_elixir_storage_v2.5481763e.png", import.meta.url).toString();


var $de79a1e06f759102$exports = {};
$de79a1e06f759102$exports = new URL("shop_machines_star_laboratory_v2.36359ee4.png", import.meta.url).toString();


var $359007c9f203efd1$exports = {};
$359007c9f203efd1$exports = new URL("shop_machines_technician_bunker_v2.7ddb99b6.png", import.meta.url).toString();


var $5b4c7ef0a07422b7$exports = {};
$5b4c7ef0a07422b7$exports = new URL("shop_machines_discord_airdrop_trophy_v2.062b4c9e.png", import.meta.url).toString();


var $596c3b0159d603c2$exports = {};
$596c3b0159d603c2$exports = new URL("shop_machines_tournament_one_competitor_trophy_v2.7919249b.png", import.meta.url).toString();


var $e72f00a8e8fa1058$exports = {};
$e72f00a8e8fa1058$exports = new URL("shop_machines_stardust_miner_v2.4f577c92.png", import.meta.url).toString();


var $e6ee5a244226c0cc$exports = {};
$e6ee5a244226c0cc$exports = new URL("shop_machines_genesis_holder_trophy_v2.fe5f4e9b.png", import.meta.url).toString();


var $3c2e302e98ae54ef$exports = {};
$3c2e302e98ae54ef$exports = new URL("shop_machines_gasa_embassy_v2.f1a1da27.png", import.meta.url).toString();


var $c4ed075b36a493c2$exports = {};
$c4ed075b36a493c2$exports = new URL("shop_machines_christmas_tree.97dc16ee.png", import.meta.url).toString();


var $c0c086281c665ba4$exports = {};
$c0c086281c665ba4$exports = new URL("shop_machines_beer_machine.3e2cb98a.png", import.meta.url).toString();


var $aeb96abf16f77670$exports = {};
$aeb96abf16f77670$exports = new URL("shop_machines_raijus_grave.f503b672.png", import.meta.url).toString();


var $d06cce5753eab453$exports = {};
$d06cce5753eab453$exports = new URL("shop_machines_linkins_armory.fbbed815.png", import.meta.url).toString();


var $4c7e6c32c0774fbb$exports = {};
$4c7e6c32c0774fbb$exports = new URL("shop_machines_bench_press.cfa2d745.png", import.meta.url).toString();


var $931fc71405f5c055$exports = {};
$931fc71405f5c055$exports = new URL("shop_machines_valentines_picnic.453a65ec.png", import.meta.url).toString();


var $022d548460a5868e$exports = {};
$022d548460a5868e$exports = new URL("shop_machines_gooh_refinery.2cc313c9.png", import.meta.url).toString();


var $0e5f6ae08965539e$exports = {};
$0e5f6ae08965539e$exports = new URL("shop_machines_alchemist_lab.88e02fc2.png", import.meta.url).toString();


var $d5c603ac4c5d56f1$exports = {};
$d5c603ac4c5d56f1$exports = new URL("shop_machines_1st_birthday_cake.fdf4be08.png", import.meta.url).toString();


var $37acbad4d876b2b1$exports = {};
$37acbad4d876b2b1$exports = new URL("shop_machines_brawler_cage.04b39913.png", import.meta.url).toString();


var $5ce844df66e7e36d$exports = {};
$5ce844df66e7e36d$exports = new URL("shop_machines_mother_wolf_statue.b3363a4b.png", import.meta.url).toString();


var $08da155aa774e4d1$exports = {};
$08da155aa774e4d1$exports = new URL("shop_machines_others_receiver.952ed4f1.png", import.meta.url).toString();


var $04bfce5e85cde564$exports = {};
$04bfce5e85cde564$exports = new URL("shop_machines_porcelain_throne.4efbac0b.png", import.meta.url).toString();


var $b3a041805dceecf1$exports = {};
$b3a041805dceecf1$exports = new URL("shop_machines_space_cactus.b0afdf61.png", import.meta.url).toString();


var $ce0b9b73571de486$exports = {};
$ce0b9b73571de486$exports = new URL("shop_machines_lightning_tower.d9b52033.png", import.meta.url).toString();


var $1ec387966eaec452$exports = {};
$1ec387966eaec452$exports = new URL("shop_machines_plasma_cannon.e6467424.png", import.meta.url).toString();


var $d285e5ffbdedcb9d$exports = {};
$d285e5ffbdedcb9d$exports = new URL("shop_machines_little_lemon_tree.d0840e6c.png", import.meta.url).toString();


var $50130e3c7a96e55a$exports = {};
$50130e3c7a96e55a$exports = new URL("shop_machines_kaiju_kingmaker.3d0ee275.png", import.meta.url).toString();


var $4fb9edca4708ddba$exports = {};
$4fb9edca4708ddba$exports = new URL("shop_machines_aic_lab.e8e7557b.png", import.meta.url).toString();


var $6b4b8f6924e40e1c$exports = {};
$6b4b8f6924e40e1c$exports = new URL("shop_machines_neon_gold_accelerator.0775b29d.png", import.meta.url).toString();


var $32d9434e985f4128$exports = {};
$32d9434e985f4128$exports = new URL("shop_machines_space_elixir_accelerator.5da1e61c.png", import.meta.url).toString();


var $08bd276b9bfab386$exports = {};
$08bd276b9bfab386$exports = new URL("shop_machines_barracks.ebd23424.png", import.meta.url).toString();


var $5fc01167255a2751$exports = {};
$5fc01167255a2751$exports = new URL("shop_machines_cadet_dorms.46f8767e.png", import.meta.url).toString();


var $65ba9ac42f208f4a$exports = {};
$65ba9ac42f208f4a$exports = new URL("shop_machines_laser_cannon.5a6afcd7.png", import.meta.url).toString();


var $bddaf9273bd2dbd7$exports = {};
$bddaf9273bd2dbd7$exports = new URL("shop_machines_shield_battery.02e88fcb.png", import.meta.url).toString();


var $cb47bbbc9b48da45$exports = {};
$cb47bbbc9b48da45$exports = new URL("shop_machines_plasma_mortar.677623fd.png", import.meta.url).toString();


var $734cf736512b1625$exports = {};
$734cf736512b1625$exports = new URL("shop_machines_photon_shield.ccfd5f95.png", import.meta.url).toString();


var $49f87a6ddb2783fd$exports = {};
$49f87a6ddb2783fd$exports = new URL("shop_machines_sunday_skirmish_trophy.58620836.png", import.meta.url).toString();


var $914f71d00b05aaa3$exports = {};
$914f71d00b05aaa3$exports = new URL("shop_machines_sunday_skirmish_trophy2.4205cc7c.png", import.meta.url).toString();


var $1889932a7f5ae01b$exports = {};
$1889932a7f5ae01b$exports = new URL("shop_machines_christmas_tree_2023.a452ad6a.png", import.meta.url).toString();


var $47e23ef4803c46a8$exports = {};
$47e23ef4803c46a8$exports = new URL("shop_machines_community_hero_2023.d6a7dee2.png", import.meta.url).toString();


var $0304dc4dbedd3d15$exports = {};
$0304dc4dbedd3d15$exports = new URL("shop_machines_community_nominee_2023.e27831e6.png", import.meta.url).toString();


var $2f546ac80835ed07$exports = {};
$2f546ac80835ed07$exports = new URL("shop_machines_nine_lives_lounge.ce003ba6.png", import.meta.url).toString();


var $a70b84b9dcb0981f$exports = {};
$a70b84b9dcb0981f$exports = new URL("shop_machines_glfhers_arcade.8b723beb.png", import.meta.url).toString();


var $5a556230783857d1$exports = {};
$5a556230783857d1$exports = new URL("shop_machines_pirate_nation_golden_galleon.9c589716.png", import.meta.url).toString();


var $5c626b5afa2daf2c$exports = {};
$5c626b5afa2daf2c$exports = new URL("shop_machines_pirate_nation_wood_galleon.9fbae74f.png", import.meta.url).toString();


var $d1028a0fdd0d528c$exports = {};
$d1028a0fdd0d528c$exports = new URL("shop_machines_bp_blob_cosmetic.17d1a75d.png", import.meta.url).toString();


var $28f174d0875eb23b$exports = {};
$28f174d0875eb23b$exports = new URL("shop_machines_bp_fire_storm_tracker_cosmetic.c40c3bf8.png", import.meta.url).toString();


var $c83f4b4089e746cf$exports = {};
$c83f4b4089e746cf$exports = new URL("shop_machines_bp_ice_storm_tracker_cosmetic.7b4e8d1c.png", import.meta.url).toString();


var $79632cd3d363f464$exports = {};
$79632cd3d363f464$exports = new URL("shop_machines_bp_star_wolvez_helmet_cosmetic.0247994d.png", import.meta.url).toString();


var $ed011fcd9ccf3e38$exports = {};
$ed011fcd9ccf3e38$exports = new URL("shop_machines_bp_water_cooler_cosmetic.d32397ef.png", import.meta.url).toString();


var $c709ff7ca4fea607$exports = {};
$c709ff7ca4fea607$exports = new URL("shop_machines_bp_piece_of_home_cosmetic.6b702af6.png", import.meta.url).toString();


var $778a23bb5e10a383$exports = {};
$778a23bb5e10a383$exports = new URL("shop_item_info_divider_short.65ef8a36.png", import.meta.url).toString();


var $1c61572936d6f41c$exports = {};
$1c61572936d6f41c$exports = new URL("shop_machines_mvhq.833a7b33.png", import.meta.url).toString();


var $b42224fa209d78d5$exports = {};
$b42224fa209d78d5$exports = new URL("shop_machines_mercenary_wolvez_hideout.d2014759.png", import.meta.url).toString();


var $7d000f0a349aa4e1$exports = {};
$7d000f0a349aa4e1$exports = new URL("shop_machines_kuma_ancestor_shrine.01f5810a.png", import.meta.url).toString();


var $e33e06c8a73e741d$exports = {};
$e33e06c8a73e741d$exports = new URL("shop_machines_super_swole_squad_department.addb4d7f.png", import.meta.url).toString();


var $c4cbf12e06fe8661$exports = {};
$c4cbf12e06fe8661$exports = new URL("shop_machines_medical_academy.ba2e2a64.png", import.meta.url).toString();


var $4c526723ae1e6c22$exports = {};
$4c526723ae1e6c22$exports = new URL("shop_machines_antirat_squad_department.2a39d6c3.png", import.meta.url).toString();


var $e544d7804894fd3e$exports = {};
$e544d7804894fd3e$exports = new URL("shop_machines_saved_souls.1ae40a73.png", import.meta.url).toString();


var $bf23189d5d829dba$exports = {};
$bf23189d5d829dba$exports = new URL("shop_machines_dimension_x.1307e1c7.png", import.meta.url).toString();


var $a1370df56d7dee33$exports = {};
$a1370df56d7dee33$exports = new URL("shop_battle_pass_image.03893e2f.png", import.meta.url).toString();


var $d952f703059717ec$exports = {};
$d952f703059717ec$exports = new URL("shop_machines_zen_garden.8e0f7592.png", import.meta.url).toString();


var $9294276dc22ccb80$exports = {};
$9294276dc22ccb80$exports = new URL("bronze_pack.dfa60ce3.png", import.meta.url).toString();


var $641a1af03c8bffbf$exports = {};
$641a1af03c8bffbf$exports = new URL("silver_pack.30fa1902.png", import.meta.url).toString();


var $91c43e96cf37d491$exports = {};
$91c43e96cf37d491$exports = new URL("golden_pack.6f5fb47d.png", import.meta.url).toString();


var $6581700443821a78$exports = {};
$6581700443821a78$exports = new URL("rare_pack.39d21904.png", import.meta.url).toString();


var $d5db9c25d1c7a73c$exports = {};
$d5db9c25d1c7a73c$exports = new URL("epic_pack.54be55a9.png", import.meta.url).toString();


var $df7456d32a40287e$exports = {};
$df7456d32a40287e$exports = new URL("legendary_pack.fecf913b.png", import.meta.url).toString();


var $1244084154c3c896$exports = {};
$1244084154c3c896$exports = new URL("mythical_pack.26651d7e.png", import.meta.url).toString();


var $5afa380e21577ca9$exports = {};
$5afa380e21577ca9$exports = new URL("space_elixir_pack_reward.10f7c556.png", import.meta.url).toString();


var $fbb9bc2d515e8cee$exports = {};
$fbb9bc2d515e8cee$exports = new URL("neon_gold_pack_reward.fb1eea7c.png", import.meta.url).toString();


var $4c31b4fa9027b889$exports = {};
$4c31b4fa9027b889$exports = new URL("pack_item_veil.818b2ef2.png", import.meta.url).toString();


var $1e2b5ab04807b001$exports = {};
$1e2b5ab04807b001$exports = new URL("artifact_0002.399f9f10.png", import.meta.url).toString();


var $85f6fef27d0b10df$exports = {};
$85f6fef27d0b10df$exports = new URL("artifact_0003.b0831681.png", import.meta.url).toString();


var $226ad78dbfb41c17$exports = {};
$226ad78dbfb41c17$exports = new URL("artifact_0004.3803de42.png", import.meta.url).toString();


var $1ce3761da034cf7b$exports = {};
$1ce3761da034cf7b$exports = new URL("artifact_0005.bd293b78.png", import.meta.url).toString();


var $c503ef53ecc18400$exports = {};
$c503ef53ecc18400$exports = new URL("artifact_0006.0010a82e.png", import.meta.url).toString();


var $8f37f02250b39fd8$exports = {};
$8f37f02250b39fd8$exports = new URL("artifact_0007.2083c39c.png", import.meta.url).toString();


var $26227b4aa1e1c5ce$exports = {};
$26227b4aa1e1c5ce$exports = new URL("artifact_0008.0f642e73.png", import.meta.url).toString();


var $8da801e1046435b1$exports = {};
$8da801e1046435b1$exports = new URL("artifact_0009.8ea20456.png", import.meta.url).toString();


var $7d43edccf6ce0ac1$exports = {};
$7d43edccf6ce0ac1$exports = new URL("artifact_0010.9d3218b6.png", import.meta.url).toString();


var $edf2a85c05fe2e4c$exports = {};
$edf2a85c05fe2e4c$exports = new URL("artifact_0011.fe7821b4.png", import.meta.url).toString();


var $4d986e56f1d16607$exports = {};
$4d986e56f1d16607$exports = new URL("fur69_chip.5dd77b43.png", import.meta.url).toString();


var $38fb9aa0dc3068a5$exports = {};
$38fb9aa0dc3068a5$exports = new URL("fur70_chip.053f593c.png", import.meta.url).toString();


var $10a5e1559393cac8$exports = {};
$10a5e1559393cac8$exports = new URL("nm8_chip.9b07a45c.png", import.meta.url).toString();


var $043d8026255d3452$exports = {};
$043d8026255d3452$exports = new URL("bk55_chip.f0c9965c.png", import.meta.url).toString();


var $aa5e3b23661fed5e$exports = {};
$aa5e3b23661fed5e$exports = new URL("bk55_ii_chip.f0c9965c.png", import.meta.url).toString();


var $52f55a03bbc2798d$exports = {};
$52f55a03bbc2798d$exports = new URL("stardust_pack_reward.2b815b0c.png", import.meta.url).toString();


var $3a2486e68d69d488$exports = {};
$3a2486e68d69d488$exports = new URL("base_raid_attack_btn.819cc3db.png", import.meta.url).toString();


var $b7e83928f7617dab$exports = {};
$b7e83928f7617dab$exports = new URL("base_raid_back_to_home_btn.e5f58d2f.png", import.meta.url).toString();


var $755ca188366e9a9a$exports = {};
$755ca188366e9a9a$exports = new URL("base_raid_back_to_home_btn_gray.6f66140a.png", import.meta.url).toString();


var $82680e797c179fe6$exports = {};
$82680e797c179fe6$exports = new URL("base_raid_next_btn.47c6bbe4.png", import.meta.url).toString();


var $3f4b83c0d4748c85$exports = {};
$3f4b83c0d4748c85$exports = new URL("base_raid_surrender_btn.6bd7cb38.png", import.meta.url).toString();


var $050920d3c1ee3350$exports = {};
$050920d3c1ee3350$exports = new URL("okay_button.33e516f4.png", import.meta.url).toString();


var $60cc6879b953092c$exports = {};
$60cc6879b953092c$exports = new URL("raid_result_banner.17035c64.png", import.meta.url).toString();


var $f077734625facc3f$exports = {};
$f077734625facc3f$exports = new URL("oh_no_text.49b1176c.png", import.meta.url).toString();


var $40bd351daa105fb4$exports = {};
$40bd351daa105fb4$exports = new URL("thank_heavens_text.f92bd76a.png", import.meta.url).toString();


var $787b39f8f4a05bd7$exports = {};
$787b39f8f4a05bd7$exports = new URL("attack_log_tab.62705ee7.png", import.meta.url).toString();


var $e674cb22314bf0ac$exports = {};
$e674cb22314bf0ac$exports = new URL("attack_log_tab_inactive.c7564635.png", import.meta.url).toString();


var $402e8ffd4cd2d2e5$exports = {};
$402e8ffd4cd2d2e5$exports = new URL("defense_log_tab.a71b5cdc.png", import.meta.url).toString();


var $dd17d91572b1b1ec$exports = {};
$dd17d91572b1b1ec$exports = new URL("defense_log_tab_inactive.085ccd84.png", import.meta.url).toString();


var $76dade7508d0c61a$exports = {};
$76dade7508d0c61a$exports = new URL("back_to_homebase_button.3d8cfa38.png", import.meta.url).toString();


var $4e8df0e61c5f4989$exports = {};
$4e8df0e61c5f4989$exports = new URL("go_raiding_button.3ed8709a.png", import.meta.url).toString();


var $183bbab7f82768ea$exports = {};
$183bbab7f82768ea$exports = new URL("bossfight_badge.5a3a34d6.png", import.meta.url).toString();


var $6bd5a10f9e7f0abd$exports = {};
$6bd5a10f9e7f0abd$exports = new URL("bossfight_title_text.b8bdb9e2.png", import.meta.url).toString();


var $4dd390d0fe52eaf4$exports = {};
$4dd390d0fe52eaf4$exports = new URL("bossfight_divider.214a95e2.png", import.meta.url).toString();


var $b3f41d7f88cad393$exports = {};
$b3f41d7f88cad393$exports = new URL("bossfight_status_not_started.d509ca96.png", import.meta.url).toString();


var $5d6612854ff082c1$exports = {};
$5d6612854ff082c1$exports = new URL("bossfight_status_in_progress.ea3ce292.png", import.meta.url).toString();


var $c7c49b90d91c6efa$exports = {};
$c7c49b90d91c6efa$exports = new URL("bossfight_ready_up_button.b3b52ef0.png", import.meta.url).toString();


var $ff5a654b185ce0e5$exports = {};
$ff5a654b185ce0e5$exports = new URL("bossfight_you_are_ready_button.f83fd8fa.png", import.meta.url).toString();


var $339f5531634ff8f4$exports = {};
$339f5531634ff8f4$exports = new URL("bossfight_clock_icon.76987941.png", import.meta.url).toString();


var $550d54cced66b562$exports = {};
$550d54cced66b562$exports = new URL("bossfight_hp_icon.784ad8c5.png", import.meta.url).toString();


var $b8e3b9dfaaf6cd34$exports = {};
$b8e3b9dfaaf6cd34$exports = new URL("bossfight_back_button.3258106d.png", import.meta.url).toString();


var $97e1f8bd97f61db3$exports = {};
$97e1f8bd97f61db3$exports = new URL("bossfight_notification_image.df73a8fb.png", import.meta.url).toString();


var $543f21685925f4ad$exports = {};
$543f21685925f4ad$exports = new URL("bossfight_notification_later_button.8f436706.png", import.meta.url).toString();


var $d269740a0e5649e7$exports = {};
$d269740a0e5649e7$exports = new URL("bossfight_notification_letsgo_button.fc644461.png", import.meta.url).toString();


var $08cd6fcb04a9aa9e$exports = {};
$08cd6fcb04a9aa9e$exports = new URL("bossfight_notification_title_text.efd633e9.png", import.meta.url).toString();


var $36a4e578f028d681$exports = {};
$36a4e578f028d681$exports = new URL("bossfight_battle_missed_image.5b4f4638.png", import.meta.url).toString();


var $d402e27bc832e603$exports = {};
$d402e27bc832e603$exports = new URL("bossfight_go_to_discord_button.40a0438b.png", import.meta.url).toString();


var $26649127fdfc1582$exports = {};
$26649127fdfc1582$exports = new URL("bossfight_defeat_badge.55a0555f.png", import.meta.url).toString();


var $35848fbafe7e1088$exports = {};
$35848fbafe7e1088$exports = new URL("bossfight_defeat_return_home_button.51c8911f.png", import.meta.url).toString();


var $a6c5dc8e00c2900b$exports = {};
$a6c5dc8e00c2900b$exports = new URL("bossfight_defeat_title.f6b4ef43.png", import.meta.url).toString();


var $6a1b4ea910c74194$exports = {};
$6a1b4ea910c74194$exports = new URL("bossfight_tweet_this_button.7ee3d66f.png", import.meta.url).toString();


var $ac6f4b648bce69b1$exports = {};
$ac6f4b648bce69b1$exports = new URL("bossfight_victory_badge.3b8ee411.png", import.meta.url).toString();


var $c3010849c15a99b4$exports = {};
$c3010849c15a99b4$exports = new URL("bossfight_victory_return_home_button.58482643.png", import.meta.url).toString();


var $f366d696a4dc150b$exports = {};
$f366d696a4dc150b$exports = new URL("bossfight_victory_title.80fabd3f.png", import.meta.url).toString();


var $e9cf7b432f165e4a$exports = {};
$e9cf7b432f165e4a$exports = new URL("bossfight_hud_go_to_battle_button.720c4bd7.png", import.meta.url).toString();


var $44513d62c64905f4$exports = {};
$44513d62c64905f4$exports = new URL("bossfight_sit_out_button.a723c2b5.png", import.meta.url).toString();


var $e4eb5358929f49eb$exports = {};
$e4eb5358929f49eb$exports = new URL("bossfight_boss_common.4af9d481.png", import.meta.url).toString();


var $56dbb91da8de288d$exports = {};
$56dbb91da8de288d$exports = new URL("bossfight_boss_epic.d4f1ce7b.png", import.meta.url).toString();


var $4bcc07e9101eea69$exports = {};
$4bcc07e9101eea69$exports = new URL("bossfight_boss_rare.e791433f.png", import.meta.url).toString();


var $e3681516cbc631b1$exports = {};
$e3681516cbc631b1$exports = new URL("bossfight_boss_legendary.5481bc52.png", import.meta.url).toString();


var $ef94296d523c32cf$exports = {};
$ef94296d523c32cf$exports = new URL("bossfight_boss_mythical.41519033.png", import.meta.url).toString();


var $a1edaaeaa06c0060$exports = {};
$a1edaaeaa06c0060$exports = new URL("bossfight_damage_button.997dff7d.png", import.meta.url).toString();


var $b1b0fdeaef682cdc$exports = {};
$b1b0fdeaef682cdc$exports = new URL("bossfight_damage_button_inactive.8498b20c.png", import.meta.url).toString();


var $aff4175493016cf8$exports = {};
$aff4175493016cf8$exports = new URL("bossfight_rounds_button.eb15f416.png", import.meta.url).toString();


var $4d81fb27314fd400$exports = {};
$4d81fb27314fd400$exports = new URL("bossfight_rounds_button_inactive.15e69c11.png", import.meta.url).toString();


var $e6c2ce2d060e441f$exports = {};
$e6c2ce2d060e441f$exports = new URL("bossfight_space_elixir_button.59dcedb8.png", import.meta.url).toString();


var $e8c218b21733e15e$exports = {};
$e8c218b21733e15e$exports = new URL("bossfight_space_elixir_button_inactive.8cad188f.png", import.meta.url).toString();


var $a3ddcbed50901c0c$exports = {};
$a3ddcbed50901c0c$exports = new URL("bossfight_neon_gold_button.5473a894.png", import.meta.url).toString();


var $7ff134c33e1daa03$exports = {};
$7ff134c33e1daa03$exports = new URL("bossfight_neon_gold_button_inactive.30152430.png", import.meta.url).toString();


var $4cce92ceedfcf959$exports = {};
$4cce92ceedfcf959$exports = new URL("bossfight_star_dust_button.1443a4a2.png", import.meta.url).toString();


var $b5fce86e8074c101$exports = {};
$b5fce86e8074c101$exports = new URL("bossfight_star_dust_button_inactive.c1502f95.png", import.meta.url).toString();


var $8851ad80fe4db867$exports = {};
$8851ad80fe4db867$exports = new URL("battleroyale_back_button.3258106d.png", import.meta.url).toString();


var $f07e65a946af479e$exports = {};
$f07e65a946af479e$exports = new URL("battleroyale_badge.79d0bdd1.png", import.meta.url).toString();


var $2fa292e85c4714c8$exports = {};
$2fa292e85c4714c8$exports = new URL("battleroyale_divider.214a95e2.png", import.meta.url).toString();


var $cec20b73c50580a1$exports = {};
$cec20b73c50580a1$exports = new URL("battleroyale_game_bg.227679ac.png", import.meta.url).toString();


var $f47cc2a5a7075e1f$exports = {};
$f47cc2a5a7075e1f$exports = new URL("battleroyale_join_bg.e1e2af1f.png", import.meta.url).toString();


var $3e8660a9d61ce773$exports = {};
$3e8660a9d61ce773$exports = new URL("battleroyale_ready_up_button.b3b52ef0.png", import.meta.url).toString();


var $3be9092e29e873d1$exports = {};
$3be9092e29e873d1$exports = new URL("battleroyale_title_text.af9892be.png", import.meta.url).toString();


var $bfac4a7efd4662ef$exports = {};
$bfac4a7efd4662ef$exports = new URL("battleroyale_you_are_ready_button.2dbba107.png", import.meta.url).toString();


var $e45d5c8ed9541ea4$exports = {};
$e45d5c8ed9541ea4$exports = new URL("battleroyale_neon_gold_icon.12ac7a86.png", import.meta.url).toString();


var $bc92535eb3f9a832$exports = {};
$bc92535eb3f9a832$exports = new URL("battleroyale_space_elixir_icon.3d848cf8.png", import.meta.url).toString();


var $4bdd90aca6383896$exports = {};
$4bdd90aca6383896$exports = new URL("battleroyale_stardust_icon.becabca3.png", import.meta.url).toString();


var $9b012232d4f5c81d$exports = {};
$9b012232d4f5c81d$exports = new URL("battleroyale_results_divider.95fe4c66.png", import.meta.url).toString();


var $1e0f6bfc135a0167$exports = {};
$1e0f6bfc135a0167$exports = new URL("battleroyale_results_pane_divider.6d33d53e.png", import.meta.url).toString();


var $b702af86506a0413$exports = {};
$b702af86506a0413$exports = new URL("battleroyale_placing_button.ffb4ee46.png", import.meta.url).toString();


var $674df338d68395ab$exports = {};
$674df338d68395ab$exports = new URL("battleroyale_placing_button_inactive.b9fb2586.png", import.meta.url).toString();


var $5c8a1729ea5ec17f$exports = {};
$5c8a1729ea5ec17f$exports = new URL("battleroyale_kills_button.d777f710.png", import.meta.url).toString();


var $3301365f0e8619f5$exports = {};
$3301365f0e8619f5$exports = new URL("battleroyale_kills_button_inactive.da30fbd3.png", import.meta.url).toString();


var $8a68941c71be8c4a$exports = {};
$8a68941c71be8c4a$exports = new URL("battleroyale_evades_button.aa38fa5e.png", import.meta.url).toString();


var $49d70b16e96bcedd$exports = {};
$49d70b16e96bcedd$exports = new URL("battleroyale_evades_button_inactive.94c81673.png", import.meta.url).toString();


var $f0665f0075b12192$exports = {};
$f0665f0075b12192$exports = new URL("battleroyale_suicides_button.c6dc6402.png", import.meta.url).toString();


var $c16756764c7d90d8$exports = {};
$c16756764c7d90d8$exports = new URL("battleroyale_suicides_button_inactive.dc703281.png", import.meta.url).toString();


var $bd7377fd34115939$exports = {};
$bd7377fd34115939$exports = new URL("battleroyale_view_results_button.469f52ad.png", import.meta.url).toString();


var $237d9f566dc30f1f$exports = {};
$237d9f566dc30f1f$exports = new URL("army_tab_active.7d7f29c5.png", import.meta.url).toString();


var $6ad5e9874acc5632$exports = {};
$6ad5e9874acc5632$exports = new URL("army_tab_inactive.a88cca8c.png", import.meta.url).toString();


var $ae7d296c4885ec14$exports = {};
$ae7d296c4885ec14$exports = new URL("training_tab_active.a724031c.png", import.meta.url).toString();


var $f1c1b8c20dc94760$exports = {};
$f1c1b8c20dc94760$exports = new URL("training_tab_inactive.6edfbf50.png", import.meta.url).toString();


var $a829ef0533fddab2$exports = {};
$a829ef0533fddab2$exports = new URL("army_modal_close_button.d0d5b07d.png", import.meta.url).toString();


var $e76cf34426c6a656$exports = {};
$e76cf34426c6a656$exports = new URL("remove_troop_button.82560c15.png", import.meta.url).toString();


var $84c735d7655d2768$exports = {};
$84c735d7655d2768$exports = new URL("troop_count_circle.a4ccf77c.png", import.meta.url).toString();


var $90051085bbae131f$exports = {};
$90051085bbae131f$exports = new URL("capacity_icon_small.0d1649a9.png", import.meta.url).toString();


var $54162465d41ce0e9$exports = {};
$54162465d41ce0e9$exports = new URL("dps_icon_small.5ce32a92.png", import.meta.url).toString();


var $5e176f5898c37bb0$exports = {};
$5e176f5898c37bb0$exports = new URL("hps_icon_small.4790ece6.png", import.meta.url).toString();


var $e9b95abdddc4b6ef$exports = {};
$e9b95abdddc4b6ef$exports = new URL("health_icon_small.1ca36849.png", import.meta.url).toString();


var $6520896c08694494$exports = {};
$6520896c08694494$exports = new URL("time_icon_small.9749b9f4.png", import.meta.url).toString();


var $51630e771e7ad0f8$exports = {};
$51630e771e7ad0f8$exports = new URL("troops_ars_v2.d12d1b26.png", import.meta.url).toString();


var $35d8fc5414653778$exports = {};
$35d8fc5414653778$exports = new URL("troops_healer.498521f1.png", import.meta.url).toString();


var $53278ab9b427c228$exports = {};
$53278ab9b427c228$exports = new URL("troops_mercenary.0a1b0dd8.png", import.meta.url).toString();


var $755daa5cd410b30e$exports = {};
$755daa5cd410b30e$exports = new URL("troops_super_swole.24ffd4e7.png", import.meta.url).toString();


var $547caa069b34eec4$exports = {};
$547caa069b34eec4$exports = new URL("troops_ars_small_v2.d710f1a6.png", import.meta.url).toString();


var $e7e9b9af13f63cfc$exports = {};
$e7e9b9af13f63cfc$exports = new URL("troops_healer_small.f9a26303.png", import.meta.url).toString();


var $a87231201bce33aa$exports = {};
$a87231201bce33aa$exports = new URL("troops_mercenary_small.720458dc.png", import.meta.url).toString();


var $36343753d610b3e8$exports = {};
$36343753d610b3e8$exports = new URL("troops_super_swole_small.c1593761.png", import.meta.url).toString();


var $811dcdeed8b5f637$exports = {};
$811dcdeed8b5f637$exports = new URL("all_tab_active.dcc7a94d.png", import.meta.url).toString();


var $02d43139e26c9ec7$exports = {};
$02d43139e26c9ec7$exports = new URL("all_tab_inactive.4e69d9d5.png", import.meta.url).toString();


var $47fc3ead00368688$exports = {};
$47fc3ead00368688$exports = new URL("level_1_tab_active.54481b09.png", import.meta.url).toString();


var $b0e0dc78313d83a8$exports = {};
$b0e0dc78313d83a8$exports = new URL("level_1_tab_inactive.cd52808c.png", import.meta.url).toString();


var $4f9e976359703515$exports = {};
$4f9e976359703515$exports = new URL("level_2_tab_active.1bff64c1.png", import.meta.url).toString();


var $3538e5469ff946ef$exports = {};
$3538e5469ff946ef$exports = new URL("level_2_tab_inactive.0c65153d.png", import.meta.url).toString();


var $b981b64a88fec159$exports = {};
$b981b64a88fec159$exports = new URL("level_3_tab_active.f1b1d001.png", import.meta.url).toString();


var $9ddc565dad6426e3$exports = {};
$9ddc565dad6426e3$exports = new URL("level_3_tab_inactive.f18a1861.png", import.meta.url).toString();


var $71e48e084c58a511$exports = {};
$71e48e084c58a511$exports = new URL("level_4_tab_active.7488a7b6.png", import.meta.url).toString();


var $3d72dd98cc7dc722$exports = {};
$3d72dd98cc7dc722$exports = new URL("level_4_tab_inactive.3b4c1dc7.png", import.meta.url).toString();


var $9209f82f78c0a5ca$exports = {};
$9209f82f78c0a5ca$exports = new URL("level_5_tab_active.7ded1f4b.png", import.meta.url).toString();


var $d87d248c7384484b$exports = {};
$d87d248c7384484b$exports = new URL("level_5_tab_inactive.38302979.png", import.meta.url).toString();


var $8254fb3e9c110cb8$exports = {};
$8254fb3e9c110cb8$exports = new URL("level_6_tab_active.b545e068.png", import.meta.url).toString();


var $7858d6088c4c5428$exports = {};
$7858d6088c4c5428$exports = new URL("level_6_tab_inactive.1884a67b.png", import.meta.url).toString();


var $8738a6280d3ae708$exports = {};
$8738a6280d3ae708$exports = new URL("level_7_tab_active.9abe64c6.png", import.meta.url).toString();


var $5e6281bbd2670242$exports = {};
$5e6281bbd2670242$exports = new URL("level_7_tab_inactive.e919b3af.png", import.meta.url).toString();


var $7302b2f74461eb1b$exports = {};
$7302b2f74461eb1b$exports = new URL("level_8_tab_active.0f4a6092.png", import.meta.url).toString();


var $bb4a77c34b8b3e76$exports = {};
$bb4a77c34b8b3e76$exports = new URL("level_8_tab_inactive.02d8aff0.png", import.meta.url).toString();


var $8cca79c3c62f03d5$exports = {};
$8cca79c3c62f03d5$exports = new URL("level_9_tab_active.35e85d58.png", import.meta.url).toString();


var $2d34010c18ef8465$exports = {};
$2d34010c18ef8465$exports = new URL("level_9_tab_inactive.a4fd0427.png", import.meta.url).toString();


var $74344a29082a0bdd$exports = {};
$74344a29082a0bdd$exports = new URL("level_10_tab_active.916db09d.png", import.meta.url).toString();


var $3b7474278ee695f3$exports = {};
$3b7474278ee695f3$exports = new URL("level_10_tab_inactive.5461d356.png", import.meta.url).toString();


var $ae0d8c34ddd8db0d$exports = {};
$ae0d8c34ddd8db0d$exports = new URL("train_1_active.80408306.png", import.meta.url).toString();


var $e270055e1c25fdaa$exports = {};
$e270055e1c25fdaa$exports = new URL("train_5_active.66e4d70e.png", import.meta.url).toString();


var $613b963614dd721d$exports = {};
$613b963614dd721d$exports = new URL("train_10_active.19acc283.png", import.meta.url).toString();


var $6f0b91e8f0b987f8$exports = {};
$6f0b91e8f0b987f8$exports = new URL("train_20_active.e472455c.png", import.meta.url).toString();


var $28b3090886bc3bce$exports = {};
$28b3090886bc3bce$exports = new URL("train_50_active.3f43d810.png", import.meta.url).toString();


var $e6f478f9a6681ad2$exports = {};
$e6f478f9a6681ad2$exports = new URL("train_100_active.c76c5397.png", import.meta.url).toString();


var $b59cc85be825a80e$exports = {};
$b59cc85be825a80e$exports = new URL("train_1_inactive.b18b3327.png", import.meta.url).toString();


var $e8fde4d7487b0bd3$exports = {};
$e8fde4d7487b0bd3$exports = new URL("train_5_inactive.a7100040.png", import.meta.url).toString();


var $7bb63a1e33a698d5$exports = {};
$7bb63a1e33a698d5$exports = new URL("train_10_inactive.9e7957d7.png", import.meta.url).toString();


var $c4e791156161d7a0$exports = {};
$c4e791156161d7a0$exports = new URL("train_20_inactive.59f27e92.png", import.meta.url).toString();


var $dc41a901af6d4ca7$exports = {};
$dc41a901af6d4ca7$exports = new URL("train_50_inactive.c24411bb.png", import.meta.url).toString();


var $9e6f8721665b2ff4$exports = {};
$9e6f8721665b2ff4$exports = new URL("train_100_inactive.186e86e3.png", import.meta.url).toString();


var $0bee91d379d56125$exports = {};
$0bee91d379d56125$exports = new URL("capacity_icon.1c80ff35.png", import.meta.url).toString();


var $d330e5c9d74c0c09$exports = {};
$d330e5c9d74c0c09$exports = new URL("dashboard_divider.b00239f4.png", import.meta.url).toString();


var $feac0c89eae71a94$exports = {};
$feac0c89eae71a94$exports = new URL("battlepass_back_button.a02589d5.png", import.meta.url).toString();


var $5fa7b54ccf5bd98e$exports = {};
$5fa7b54ccf5bd98e$exports = new URL("battlepass_background_image.7dbc4bff.png", import.meta.url).toString();


var $a1fbfee7e8fcfc63$exports = {};
$a1fbfee7e8fcfc63$exports = new URL("battlepass_buy_button.425367a8.png", import.meta.url).toString();


var $528777842579f4d4$exports = {};
$528777842579f4d4$exports = new URL("battlepass_buy_button_glfhers.e432c48b.png", import.meta.url).toString();


var $308b365d82c43444$exports = {};
$308b365d82c43444$exports = new URL("battlepass_explore_button.2e737067.png", import.meta.url).toString();


var $6e708bd5148b04f8$exports = {};
$6e708bd5148b04f8$exports = new URL("battlepass_season_text.f617a531.png", import.meta.url).toString();


var $22d501ef5fb47a08$exports = {};
$22d501ef5fb47a08$exports = new URL("battlepass_season_image.1a0aef85.png", import.meta.url).toString();


var $459057211da8c415$exports = {};
$459057211da8c415$exports = new URL("battlepass_buy_success_background.e4e35640.png", import.meta.url).toString();


var $895d81f7ffaf7db4$exports = {};
$895d81f7ffaf7db4$exports = new URL("battlepass_homebase_button.260199ef.png", import.meta.url).toString();


var $7bc258b94eefad3f$exports = {};
$7bc258b94eefad3f$exports = new URL("battlepass_success_info_text.4bedac92.png", import.meta.url).toString();


var $784ab7f8338be978$exports = {};
$784ab7f8338be978$exports = new URL("battlepass_success_text.fdc49e0f.png", import.meta.url).toString();


var $ddc685d403726a51$exports = {};
$ddc685d403726a51$exports = new URL("battlepass_background.6b1c8267.png", import.meta.url).toString();


var $f9752681dfb56ca3$exports = {};
$f9752681dfb56ca3$exports = new URL("battlepass_active_button.15a62877.png", import.meta.url).toString();


var $f7d85f15e66b1914$exports = {};
$f7d85f15e66b1914$exports = new URL("battlepass_inactive_button.238a03ab.png", import.meta.url).toString();


var $4cc7bd8b220ebdc2$exports = {};
$4cc7bd8b220ebdc2$exports = new URL("battlepass_raffle_active_button.8f1dffaa.png", import.meta.url).toString();


var $efc2b4bc5b3f5e7c$exports = {};
$efc2b4bc5b3f5e7c$exports = new URL("battlepass_raffle_inactive_button.e3491eda.png", import.meta.url).toString();


var $565eb55c83973d44$exports = {};
$565eb55c83973d44$exports = new URL("battlepass_home_button.be2103ce.png", import.meta.url).toString();


var $5b5230f76d140ee5$exports = {};
$5b5230f76d140ee5$exports = new URL("battlepass_next_page_button_active.67597fd7.png", import.meta.url).toString();


var $d5dca254edbf80d4$exports = {};
$d5dca254edbf80d4$exports = new URL("battlepass_previous_page_button_active.58c0c7c1.png", import.meta.url).toString();


var $12b49eb76c9f5f76$exports = {};
$12b49eb76c9f5f76$exports = new URL("battlepass_unlocked.14e809d6.png", import.meta.url).toString();


var $2f9c8b68afa95b9e$exports = {};
$2f9c8b68afa95b9e$exports = new URL("battlepass_raffle_rock.51fb1765.png", import.meta.url).toString();


var $1cc3db660c79a611$exports = {};
$1cc3db660c79a611$exports = new URL("battlepass_chapter.10b900b4.png", import.meta.url).toString();


var $ab958b78040d03d6$exports = {};
$ab958b78040d03d6$exports = new URL("battlepass_season.8b04a71f.png", import.meta.url).toString();


var $8101c967191cc69c$exports = {};
$8101c967191cc69c$exports = new URL("battlepass_xp_component_divider.95311e7a.png", import.meta.url).toString();


var $e8324986702b0306$exports = {};
$e8324986702b0306$exports = new URL("battlepass_present.60f072cf.png", import.meta.url).toString();


var $2b84c56f1a4f4811$exports = {};
$2b84c56f1a4f4811$exports = new URL("battlepass_assign_button.3dcd7213.png", import.meta.url).toString();


var $0d69055a1eeda954$exports = {};
$0d69055a1eeda954$exports = new URL("battlepass_assign_all_button.842d036d.png", import.meta.url).toString();


var $5d2c0c402edfb2eb$exports = {};
$5d2c0c402edfb2eb$exports = new URL("battlepass_mini_rock.51d50952.png", import.meta.url).toString();


var $f52971aeb6fd0578$exports = {};
$f52971aeb6fd0578$exports = new URL("battlepass_claimed_button.a56d876c.png", import.meta.url).toString();


var $e700bade35079516$exports = {};
$e700bade35079516$exports = new URL("battlepass_claim_button_active.57234d74.png", import.meta.url).toString();


var $a31d7d1ff1f732e7$exports = {};
$a31d7d1ff1f732e7$exports = new URL("battlepass_claim_button_inactive.ae8d53da.png", import.meta.url).toString();


var $168c31dd1f404834$exports = {};
$168c31dd1f404834$exports = new URL("xp_icon.8c2513eb.png", import.meta.url).toString();


var $184a5adfbd1ee28b$exports = {};
$184a5adfbd1ee28b$exports = new URL("bp_neon_gold_icon.f7691abc.png", import.meta.url).toString();


var $d2c5c4b66ca3e030$exports = {};
$d2c5c4b66ca3e030$exports = new URL("bp_space_elixir_icon.bb1010ad.png", import.meta.url).toString();


var $af401b09a960b2b2$exports = {};
$af401b09a960b2b2$exports = new URL("raffle_rock_icon.6eaa5df8.png", import.meta.url).toString();


var $c81595d9284dbe44$exports = {};
$c81595d9284dbe44$exports = new URL("nm8_icon.8eea8b8a.png", import.meta.url).toString();


var $f53ba20ead214b2f$exports = {};
$f53ba20ead214b2f$exports = new URL("bk55_icon.717f41b1.png", import.meta.url).toString();


var $5ea37a88d54e1206$exports = {};
$5ea37a88d54e1206$exports = new URL("bp_stardust_icon.d542f075.png", import.meta.url).toString();


var $6f801bdf7728b536$exports = {};
$6f801bdf7728b536$exports = new URL("fur_chip_icon.ec47273f.png", import.meta.url).toString();


var $705d08aed4eeca14$exports = {};
$705d08aed4eeca14$exports = new URL("bronze_pack_icon.31234a60.png", import.meta.url).toString();


var $275a89ca1dd90f7d$exports = {};
$275a89ca1dd90f7d$exports = new URL("silver_pack_icon.e38b7d20.png", import.meta.url).toString();


var $2e5dba3492219b55$exports = {};
$2e5dba3492219b55$exports = new URL("gold_pack_icon.15469798.png", import.meta.url).toString();


var $b31ffeb76e1d1ec0$exports = {};
$b31ffeb76e1d1ec0$exports = new URL("rare_pack_icon.83c1cab9.png", import.meta.url).toString();


var $7901a8f745a26dc0$exports = {};
$7901a8f745a26dc0$exports = new URL("epic_pack_icon.907efc45.png", import.meta.url).toString();


var $4a2233be6c6a9ddf$exports = {};
$4a2233be6c6a9ddf$exports = new URL("legendary_pack_icon.569b4fe5.png", import.meta.url).toString();


var $0f0afb177dbf0fa5$exports = {};
$0f0afb177dbf0fa5$exports = new URL("mythical_pack_icon.86948a51.png", import.meta.url).toString();


var $6398f65daf157ec5$exports = {};
$6398f65daf157ec5$exports = new URL("cadet_dorm_icon.e86d8014.png", import.meta.url).toString();


var $bcdc00e134a16aea$exports = {};
$bcdc00e134a16aea$exports = new URL("plasma_mortor_icon.7fc04028.png", import.meta.url).toString();


var $786b0efd9f05d486$exports = {};
$786b0efd9f05d486$exports = new URL("sw_hoodie_icon.ee12983f.png", import.meta.url).toString();


var $99ac8ee269b53252$exports = {};
$99ac8ee269b53252$exports = new URL("blob_consmetic_icon.f05bb7a4.png", import.meta.url).toString();


var $a58bc37b91f124b1$exports = {};
$a58bc37b91f124b1$exports = new URL("ice_storm_tracker_cosmetic.57957759.png", import.meta.url).toString();


var $c1addaa19e9effab$exports = {};
$c1addaa19e9effab$exports = new URL("fire_storm_tracker_cosmetic.bf02b7d2.png", import.meta.url).toString();


var $204e1b011fdb40ef$exports = {};
$204e1b011fdb40ef$exports = new URL("water_cooler_cosmetic_icon.40e94d9f.png", import.meta.url).toString();


var $2908516861a8686f$exports = {};
$2908516861a8686f$exports = new URL("gold_plasma_cannon_skin.423dcdec.png", import.meta.url).toString();


var $e9e15c4b69a6064a$exports = {};
$e9e15c4b69a6064a$exports = new URL("little_piece_of_home_cosmetic.771d9edb.png", import.meta.url).toString();


var $cf437fad9f39f67f$exports = {};
$cf437fad9f39f67f$exports = new URL("star_wolvez_helmet_cosmetic.901b5a61.png", import.meta.url).toString();


var $4358bd2a73d296ac$exports = {};
$4358bd2a73d296ac$exports = new URL("starwolvez_bolt_logo.8f9a4c36.png", import.meta.url).toString();


var $d371b1c7d5d6886d$exports = {};
$d371b1c7d5d6886d$exports = new URL("star_wolf_silhouette_v2.6e8e98b3.png", import.meta.url).toString();


var $1d881b694d7e5150$exports = {};
$1d881b694d7e5150$exports = new URL("chest_icon_large.41ac485f.png", import.meta.url).toString();


var $ffa924ffb865fbe4$exports = {};
$ffa924ffb865fbe4$exports = new URL("neon_gold_icon_large.a4fe33c5.png", import.meta.url).toString();


var $e802220e3a7bc634$exports = {};
$e802220e3a7bc634$exports = new URL("space_elixir_icon_large.90cadcf5.png", import.meta.url).toString();


var $f0fbcba4aa0ae92e$exports = {};
$f0fbcba4aa0ae92e$exports = new URL("hp_icon_large.e62de31c.png", import.meta.url).toString();


var $c15011977e8f3816$exports = {};
$c15011977e8f3816$exports = new URL("dps_icon_large.a9cabcfb.png", import.meta.url).toString();


var $f823c2268fdd6202$exports = {};
$f823c2268fdd6202$exports = new URL("stardust_pink_icon_large.780d75e7.png", import.meta.url).toString();


var $04e23b19fd9fbea6$exports = {};
$04e23b19fd9fbea6$exports = new URL("dark_matter_icon_large.98e48a4d.png", import.meta.url).toString();


var $6d5cb8f3e85371b4$exports = {};
$6d5cb8f3e85371b4$exports = new URL("wl_icon_large.d9ce9657.png", import.meta.url).toString();


var $62bf4b8f4b7aa6e0$exports = {};
$62bf4b8f4b7aa6e0$exports = new URL("Partyblob.5d12a2a8.png", import.meta.url).toString();


const $1aa2c39fc1fbb95e$export$3b37c5430056c4ff = {
    squad_text: (/*@__PURE__*/$parcel$interopDefault($9b931f2dca6d8b6a$exports)),
    squad_confirm_button: (/*@__PURE__*/$parcel$interopDefault($474dcbcf3984a9c1$exports)),
    squad_divider_line: (/*@__PURE__*/$parcel$interopDefault($c38e5ca88fb9bddb$exports))
};
const $1aa2c39fc1fbb95e$export$77e9ad0d5b42a6f9 = {
    objectives_bg: (/*@__PURE__*/$parcel$interopDefault($3d923e9ab7e52637$exports)),
    objectives_list_view_panel: (/*@__PURE__*/$parcel$interopDefault($7661a53477bd3b91$exports)),
    objectives_text: (/*@__PURE__*/$parcel$interopDefault($93017214051f5ee6$exports)),
    open_chest_button: (/*@__PURE__*/$parcel$interopDefault($97f9ee3239e7b96d$exports)),
    objectives_divider_line: (/*@__PURE__*/$parcel$interopDefault($5ca3738ae4739662$exports)),
    daily_chest_button: (/*@__PURE__*/$parcel$interopDefault($b3ccbb6d00b93209$exports)),
    sw_genesis_empty: (/*@__PURE__*/$parcel$interopDefault($150beeec846cad82$exports)),
    sw_generative_empty: (/*@__PURE__*/$parcel$interopDefault($2d660b753128250e$exports)),
    gape_genesis_empty: (/*@__PURE__*/$parcel$interopDefault($06e988ee283827a8$exports)),
    gape_generative_empty: (/*@__PURE__*/$parcel$interopDefault($c0c1f96af25f1a61$exports)),
    gape_monke_empty: (/*@__PURE__*/$parcel$interopDefault($0e2c4a12faa534fc$exports)),
    buy_one_button: (/*@__PURE__*/$parcel$interopDefault($503f5f14f51d4f26$exports)),
    objective_stardust_icon: (/*@__PURE__*/$parcel$interopDefault($ea6eafa9b054f877$exports)),
    os_button: (/*@__PURE__*/$parcel$interopDefault($d220a3ec798dcdab$exports)),
    objective_connect_button: (/*@__PURE__*/$parcel$interopDefault($dc1b86657827887e$exports)),
    objective_follow_button: (/*@__PURE__*/$parcel$interopDefault($9bf0be0e1c0e6771$exports)),
    objective_tweet_button: (/*@__PURE__*/$parcel$interopDefault($fb0585b32fef2580$exports)),
    objective_retweet_button: (/*@__PURE__*/$parcel$interopDefault($db84da4358e606fb$exports)),
    objective_read_button: (/*@__PURE__*/$parcel$interopDefault($3b2aa73a95238916$exports)),
    objective_view_button: (/*@__PURE__*/$parcel$interopDefault($0b54a297d9ec5ed6$exports)),
    objective_open_button: (/*@__PURE__*/$parcel$interopDefault($9702291274a9f2fe$exports)),
    objective_like_button: (/*@__PURE__*/$parcel$interopDefault($e0f463880c80a68b$exports)),
    open_daily_chest_button: (/*@__PURE__*/$parcel$interopDefault($1c9b418ad90f694f$exports)),
    open_all_button: (/*@__PURE__*/$parcel$interopDefault($56e0e84636726530$exports)),
    open_all_button_disabled: (/*@__PURE__*/$parcel$interopDefault($4485b9aeaa23fc4d$exports))
};
const $1aa2c39fc1fbb95e$export$60ce8cc956a8f1b0 = {
    modal_close_button: (/*@__PURE__*/$parcel$interopDefault($09f4d1d917f2ba98$exports))
};
const $1aa2c39fc1fbb95e$export$c8d88f36354fa59f = {
    login_sw_logo: (/*@__PURE__*/$parcel$interopDefault($31efa0eba304f195$exports)),
    login_sw_logo_mobile: (/*@__PURE__*/$parcel$interopDefault($2eb3c81a25112716$exports)),
    login_game_logo: (/*@__PURE__*/$parcel$interopDefault($74a4fca5dd55f7b2$exports)),
    connect_wallet_button: (/*@__PURE__*/$parcel$interopDefault($8aadeda71661a991$exports)),
    login_divider: (/*@__PURE__*/$parcel$interopDefault($98e57a104c3cdcb8$exports)),
    or_image: (/*@__PURE__*/$parcel$interopDefault($2ef86b23911d5362$exports)),
    google_login_button: (/*@__PURE__*/$parcel$interopDefault($fe07c7fa78bbb8ab$exports)),
    apple_login_button: (/*@__PURE__*/$parcel$interopDefault($38f043ae81368b6b$exports)),
    disclaimer_image: (/*@__PURE__*/$parcel$interopDefault($d703aaa1df7c1e39$exports)),
    sw_feed_background: (/*@__PURE__*/$parcel$interopDefault($828308dde2fafd51$exports)),
    feed_title_image: (/*@__PURE__*/$parcel$interopDefault($d078bed1bab89673$exports)),
    login_poster_1: (/*@__PURE__*/$parcel$interopDefault($312f412adae2595f$exports)),
    login_poster_2: (/*@__PURE__*/$parcel$interopDefault($cb22d35aa7092cba$exports)),
    login_poster_3: (/*@__PURE__*/$parcel$interopDefault($affb94c77fc32182$exports)),
    login_poster_4: (/*@__PURE__*/$parcel$interopDefault($948574fa1e80f7b6$exports)),
    login_poster_5: (/*@__PURE__*/$parcel$interopDefault($1d2e658f4e565f5f$exports)),
    login_poster_6: (/*@__PURE__*/$parcel$interopDefault($3e165130b07c7557$exports))
};
const $1aa2c39fc1fbb95e$export$7e2f8a660ede5d39 = {
    reward_claim_button: (/*@__PURE__*/$parcel$interopDefault($edc01426edeb4eae$exports)),
    reward_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e2a783a4868d2e49$exports)),
    reward_confirm_button: (/*@__PURE__*/$parcel$interopDefault($013c33e3bfc134b4$exports))
};
const $1aa2c39fc1fbb95e$export$d6d96f2257233255 = {
    machine_info_button: (/*@__PURE__*/$parcel$interopDefault($5788213921e36427$exports)),
    machine_upgrade_button: (/*@__PURE__*/$parcel$interopDefault($540a8b1b8afed723$exports)),
    machine_speed_up_button: (/*@__PURE__*/$parcel$interopDefault($76b85da5621c3ed6$exports)),
    machine_activate_button: (/*@__PURE__*/$parcel$interopDefault($595e48258e248be6$exports)),
    machine_claim_button: (/*@__PURE__*/$parcel$interopDefault($02a03d0060280a23$exports)),
    machine_train_button: (/*@__PURE__*/$parcel$interopDefault($11c786a253085c0f$exports)),
    machine_troops_button: (/*@__PURE__*/$parcel$interopDefault($f6765c889b77cad0$exports)),
    machines_mainframe_level_2: (/*@__PURE__*/$parcel$interopDefault($8ff534fe5e7246f2$exports)),
    machines_mainframe_level_6: (/*@__PURE__*/$parcel$interopDefault($9eac169af3b80ad6$exports)),
    machines_mainframe_level_7: (/*@__PURE__*/$parcel$interopDefault($b0a75e6341252c52$exports)),
    machines_mainframe_level_8: (/*@__PURE__*/$parcel$interopDefault($623592bfe8252856$exports)),
    machines_mainframe_level_9: (/*@__PURE__*/$parcel$interopDefault($a857fd737f8c8bc6$exports)),
    machines_neon_gold_mine_level_10: (/*@__PURE__*/$parcel$interopDefault($355ce7fdd9c62a78$exports)),
    machines_neon_gold_mine_level_11: (/*@__PURE__*/$parcel$interopDefault($2938007d37fba5ae$exports)),
    machines_neon_gold_mine_level_12: (/*@__PURE__*/$parcel$interopDefault($4108ea3870597795$exports)),
    machines_neon_gold_mine_level_13: (/*@__PURE__*/$parcel$interopDefault($75eb03a2bcf943bb$exports)),
    machines_space_elixir_mine_level_10: (/*@__PURE__*/$parcel$interopDefault($0c40e7deff99ddf0$exports)),
    machines_space_elixir_mine_level_11: (/*@__PURE__*/$parcel$interopDefault($47745bf4cb57f846$exports)),
    machines_space_elixir_mine_level_12: (/*@__PURE__*/$parcel$interopDefault($a4d4db7cb2d0d81a$exports)),
    machines_space_elixir_mine_level_13: (/*@__PURE__*/$parcel$interopDefault($95317339cd6e584f$exports)),
    machines_neon_gold_storage_level_10: (/*@__PURE__*/$parcel$interopDefault($a08ad3c403be241d$exports)),
    machines_neon_gold_storage_level_11: (/*@__PURE__*/$parcel$interopDefault($e1b0b891067562e7$exports)),
    machines_neon_gold_storage_level_12: (/*@__PURE__*/$parcel$interopDefault($4154b9bd81145851$exports)),
    machines_neon_gold_storage_level_13: (/*@__PURE__*/$parcel$interopDefault($1308c4a0f9d3444e$exports)),
    machines_space_elixir_storage_level_10: (/*@__PURE__*/$parcel$interopDefault($b1e367507a2fa006$exports)),
    machines_space_elixir_storage_level_11: (/*@__PURE__*/$parcel$interopDefault($0e7a506f97c62e40$exports)),
    machines_space_elixir_storage_level_12: (/*@__PURE__*/$parcel$interopDefault($5c962e6c10dc8b9e$exports)),
    machines_space_elixir_storage_level_13: (/*@__PURE__*/$parcel$interopDefault($2bdc348988de8162$exports)),
    machines_star_laboratory_level_1: (/*@__PURE__*/$parcel$interopDefault($fc3201e168ec9864$exports)),
    machines_star_laboratory_level_2: (/*@__PURE__*/$parcel$interopDefault($54ffb3f874595fb1$exports)),
    machines_star_laboratory_level_3: (/*@__PURE__*/$parcel$interopDefault($6119895e44c567cb$exports)),
    machines_gasa_embassy_level_1: (/*@__PURE__*/$parcel$interopDefault($a087138594d21a7b$exports)),
    machines_gasa_embassy_level_2: (/*@__PURE__*/$parcel$interopDefault($4447941b843f8129$exports)),
    machines_gasa_embassy_level_3: (/*@__PURE__*/$parcel$interopDefault($6bf4b6b3a863809b$exports)),
    machines_raijus_grave_level_1: (/*@__PURE__*/$parcel$interopDefault($08391af8fb7c572a$exports)),
    machines_linkins_armory_level_1: (/*@__PURE__*/$parcel$interopDefault($0a0fd2121efc2d71$exports)),
    machines_bench_press_level_1: (/*@__PURE__*/$parcel$interopDefault($1d42b74ae69fe412$exports)),
    machines_valentines_picnic_level_1: (/*@__PURE__*/$parcel$interopDefault($b25baa38b4d7107b$exports)),
    machines_gooh_refinery_level_1: (/*@__PURE__*/$parcel$interopDefault($e5ce1f0f6f57ea52$exports)),
    machines_gooh_refinery_level_2: (/*@__PURE__*/$parcel$interopDefault($c14ba136882bc2ff$exports)),
    machines_gooh_refinery_level_3: (/*@__PURE__*/$parcel$interopDefault($2f2363992b0207e8$exports)),
    machines_alchemist_lab_level_1: (/*@__PURE__*/$parcel$interopDefault($0505524ffdd6a080$exports)),
    machines_1st_birthday_cake_level_1: (/*@__PURE__*/$parcel$interopDefault($53a37ccde8480b78$exports)),
    machines_brawler_cage_level_1: (/*@__PURE__*/$parcel$interopDefault($c2500a3d9b8d5d70$exports)),
    machines_porcelain_throne_level_1: (/*@__PURE__*/$parcel$interopDefault($bfbe80836ad612e4$exports)),
    machines_others_receiver_level_1: (/*@__PURE__*/$parcel$interopDefault($8654704014466fdd$exports)),
    machines_space_cactus_level_1: (/*@__PURE__*/$parcel$interopDefault($a8c3b004ca9dcb6a$exports)),
    machines_mother_wolf_statue_level_1: (/*@__PURE__*/$parcel$interopDefault($94a2cd62711f6f70$exports)),
    machines_plasma_cannon_level_1: (/*@__PURE__*/$parcel$interopDefault($ea59c6c7093d96fd$exports)),
    machines_plasma_cannon_level_2: (/*@__PURE__*/$parcel$interopDefault($b149dfa414ab3ec7$exports)),
    machines_plasma_cannon_level_3: (/*@__PURE__*/$parcel$interopDefault($60aedd79a72d8303$exports)),
    machines_plasma_cannon_level_1_skin: (/*@__PURE__*/$parcel$interopDefault($55df8e393f643bf0$exports)),
    machines_plasma_cannon_level_2_skin: (/*@__PURE__*/$parcel$interopDefault($f6dc5488479386e4$exports)),
    machines_plasma_cannon_level_3_skin: (/*@__PURE__*/$parcel$interopDefault($7a532fb2179ab294$exports)),
    machines_little_lemon_tree_level_1: (/*@__PURE__*/$parcel$interopDefault($6ddb8e6c7da84fca$exports)),
    machines_little_lemon_tree_level_2: (/*@__PURE__*/$parcel$interopDefault($fc21c2f55186fafb$exports)),
    machines_little_lemon_tree_level_3: (/*@__PURE__*/$parcel$interopDefault($025a3b57db31af76$exports)),
    machines_aic_lab_level_1: (/*@__PURE__*/$parcel$interopDefault($245487d76e67a12f$exports)),
    machines_aic_lab_level_2: (/*@__PURE__*/$parcel$interopDefault($e755cac71efbb40c$exports)),
    machines_aic_lab_level_3: (/*@__PURE__*/$parcel$interopDefault($e17b3904d505e74e$exports)),
    machines_mvhq_level_1: (/*@__PURE__*/$parcel$interopDefault($3e54d6324b4bb8cd$exports)),
    machines_mvhq_level_2: (/*@__PURE__*/$parcel$interopDefault($41d5154b80ab3cde$exports)),
    machines_mvhq_level_3: (/*@__PURE__*/$parcel$interopDefault($b5a48f61a62c547e$exports)),
    machines_mvhq_level_4: (/*@__PURE__*/$parcel$interopDefault($83f17598db96f50f$exports)),
    machines_kaiju_kingmaker_level_1: (/*@__PURE__*/$parcel$interopDefault($aa64145592d6a78f$exports)),
    machines_kaiju_kingmaker_level_2: (/*@__PURE__*/$parcel$interopDefault($dccad5bc4192b57e$exports)),
    machines_kaiju_kingmaker_level_3: (/*@__PURE__*/$parcel$interopDefault($fe623a0494863f21$exports)),
    machines_space_elixir_accelerator_level_1: (/*@__PURE__*/$parcel$interopDefault($413f71780c257ee8$exports)),
    machines_space_elixir_accelerator_level_2: (/*@__PURE__*/$parcel$interopDefault($e59f13c10ae4b5ec$exports)),
    machines_space_elixir_accelerator_level_3: (/*@__PURE__*/$parcel$interopDefault($5249f472183c26a0$exports)),
    machines_neon_gold_accelerator_level_1: (/*@__PURE__*/$parcel$interopDefault($ff48cbc95b4047e0$exports)),
    machines_neon_gold_accelerator_level_2: (/*@__PURE__*/$parcel$interopDefault($8c3630beb2110332$exports)),
    machines_neon_gold_accelerator_level_3: (/*@__PURE__*/$parcel$interopDefault($104e51552456fbdc$exports)),
    machines_laser_cannon_level_1: (/*@__PURE__*/$parcel$interopDefault($1a05e59a10aba89f$exports)),
    machines_laser_cannon_level_2: (/*@__PURE__*/$parcel$interopDefault($8323f87fda9cf51b$exports)),
    machines_laser_cannon_level_3: (/*@__PURE__*/$parcel$interopDefault($5d0e8f1d8563e712$exports)),
    machines_laser_cannon_level_4: (/*@__PURE__*/$parcel$interopDefault($d3b49cad2e5dc4cd$exports)),
    machines_photon_shield_level_1: (/*@__PURE__*/$parcel$interopDefault($8c8e2d5164ab3c6a$exports)),
    machines_photon_shield_level_2: (/*@__PURE__*/$parcel$interopDefault($d8adce741c1f5e9f$exports)),
    machines_photon_shield_level_3: (/*@__PURE__*/$parcel$interopDefault($63c114ff06a2b16e$exports)),
    machines_plasma_mortar_level_1: (/*@__PURE__*/$parcel$interopDefault($cafb7813952e4337$exports)),
    machines_plasma_mortar_level_2: (/*@__PURE__*/$parcel$interopDefault($246f97e103730b1e$exports)),
    machines_plasma_mortar_level_3: (/*@__PURE__*/$parcel$interopDefault($288380997f206dca$exports)),
    machines_shield_battery_level_1: (/*@__PURE__*/$parcel$interopDefault($31bdee6844fc2d50$exports)),
    machines_shield_battery_level_2: (/*@__PURE__*/$parcel$interopDefault($888b259d308cdc1f$exports)),
    machines_shield_battery_level_3: (/*@__PURE__*/$parcel$interopDefault($a13293fe05b9cef6$exports)),
    machine_info_close_button: (/*@__PURE__*/$parcel$interopDefault($71a601e30c6a352f$exports)),
    machine_info_upgrade_button: (/*@__PURE__*/$parcel$interopDefault($afbbaff5378253cb$exports)),
    machine_info_speed_up_button: (/*@__PURE__*/$parcel$interopDefault($a5a8068b23d7be88$exports)),
    machine_item_info_divider_long: (/*@__PURE__*/$parcel$interopDefault($65deddcfb8f62827$exports)),
    machine_item_info_divider_short: (/*@__PURE__*/$parcel$interopDefault($c5cd5a0b58bc0add$exports)),
    cancel_btn_purple: (/*@__PURE__*/$parcel$interopDefault($c37248a1803118ae$exports)),
    blob_room_door: (/*@__PURE__*/$parcel$interopDefault($6ba27548310a0f86$exports)),
    exit_room_door: (/*@__PURE__*/$parcel$interopDefault($0d9c4198426dfa18$exports)),
    blob: (/*@__PURE__*/$parcel$interopDefault($ba6c62ec232c284b$exports)),
    machines_mercenary_wolvez_hideout_level_1: (/*@__PURE__*/$parcel$interopDefault($7ee61d1ab0fa0048$exports)),
    machines_mercenary_wolvez_hideout_level_2: (/*@__PURE__*/$parcel$interopDefault($6a5d9c84edbba057$exports)),
    machines_mercenary_wolvez_hideout_level_3: (/*@__PURE__*/$parcel$interopDefault($25ae3c76574c0c53$exports)),
    machines_mercenary_wolvez_hideout_level_4: (/*@__PURE__*/$parcel$interopDefault($7fd6fb6bf4837b45$exports)),
    machines_kuma_ancestor_shrine_level_1: (/*@__PURE__*/$parcel$interopDefault($094dc8ca175fc1e2$exports)),
    machines_kuma_ancestor_shrine_level_2: (/*@__PURE__*/$parcel$interopDefault($87d71145a45aa9a4$exports)),
    machines_kuma_ancestor_shrine_level_3: (/*@__PURE__*/$parcel$interopDefault($32775bbd6dfee363$exports)),
    machines_super_swole_squad_department_level_1: (/*@__PURE__*/$parcel$interopDefault($a84852e6e8ab2493$exports)),
    machines_super_swole_squad_department_level_2: (/*@__PURE__*/$parcel$interopDefault($8df30ac1f9985710$exports)),
    machines_super_swole_squad_department_level_3: (/*@__PURE__*/$parcel$interopDefault($f505064c375f3dd7$exports)),
    machines_medical_academy_level_1: (/*@__PURE__*/$parcel$interopDefault($e1897fac0f7181d1$exports)),
    machines_medical_academy_level_2: (/*@__PURE__*/$parcel$interopDefault($afb0d8499a17c436$exports)),
    machines_medical_academy_level_3: (/*@__PURE__*/$parcel$interopDefault($2d79791fab742161$exports)),
    machines_medical_academy_level_4: (/*@__PURE__*/$parcel$interopDefault($e40901da5d83ad3f$exports)),
    machines_antirat_squad_department_level_1: (/*@__PURE__*/$parcel$interopDefault($7dba5da3664b2244$exports)),
    machines_antirat_squad_department_level_2: (/*@__PURE__*/$parcel$interopDefault($7de0d2f6b57ebab3$exports)),
    machines_antirat_squad_department_level_3: (/*@__PURE__*/$parcel$interopDefault($8284857af2654450$exports)),
    machines_antirat_squad_department_level_4: (/*@__PURE__*/$parcel$interopDefault($4f02ddda1bdf3b31$exports)),
    machines_saved_souls_level_1: (/*@__PURE__*/$parcel$interopDefault($4369aa57f209fb5f$exports)),
    machines_saved_souls_level_2: (/*@__PURE__*/$parcel$interopDefault($5646b19752ee17eb$exports)),
    machines_saved_souls_level_3: (/*@__PURE__*/$parcel$interopDefault($4d532817751b739d$exports)),
    machines_sunday_skirmish_trophy_level_1: (/*@__PURE__*/$parcel$interopDefault($b6f5f3429cc1cddf$exports)),
    machines_sunday_skirmish_trophy2_level_1: (/*@__PURE__*/$parcel$interopDefault($ab81835de5daf260$exports)),
    machines_christmas_tree_2023_level_1: (/*@__PURE__*/$parcel$interopDefault($8280a545fdac8207$exports)),
    machines_community_hero_2023_level_1: (/*@__PURE__*/$parcel$interopDefault($6e6edea75b77e9cf$exports)),
    machines_community_nominee_2023_level_1: (/*@__PURE__*/$parcel$interopDefault($5d63bf5d96bd6b4d$exports)),
    machines_nine_lives_lounge_level_1: (/*@__PURE__*/$parcel$interopDefault($84cb27aec7eb356c$exports)),
    machines_glfhers_arcade_level_1: (/*@__PURE__*/$parcel$interopDefault($fed38f31b56c687e$exports)),
    machines_pirate_nation_golden_galleon_level_1: (/*@__PURE__*/$parcel$interopDefault($d80d0d286f8f966a$exports)),
    machines_pirate_nation_wood_galleon_level_1: (/*@__PURE__*/$parcel$interopDefault($fd02a264c99ac1db$exports)),
    machines_bp_fire_storm_tracker_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($70713c53eaa2e021$exports)),
    machines_bp_ice_storm_tracker_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($f20ea379b139ab19$exports)),
    machines_bp_star_wolvez_helmet_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($26a7720c8c638bfb$exports)),
    machines_bp_water_cooler_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($692d33c12975fd31$exports)),
    machines_bp_blob_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($add8dc4dd322adcc$exports)),
    machines_bp_piece_of_home_cosmetic_level_1: (/*@__PURE__*/$parcel$interopDefault($0b61a02967fe4c45$exports))
};
const $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f = {
    level_circle: (/*@__PURE__*/$parcel$interopDefault($abe5584c3b9d65aa$exports)),
    level_text: (/*@__PURE__*/$parcel$interopDefault($0a79362e636b81b7$exports)),
    level_icon: (/*@__PURE__*/$parcel$interopDefault($126c435e56b4c901$exports)),
    level_prog_bar: (/*@__PURE__*/$parcel$interopDefault($15f6cf264ece0fe1$exports)),
    level_prog_shine: (/*@__PURE__*/$parcel$interopDefault($c4de446a19e9039e$exports)),
    objectives_icon: (/*@__PURE__*/$parcel$interopDefault($f9a4ebcd022eab5a$exports)),
    objectives_rect: (/*@__PURE__*/$parcel$interopDefault($6dd0e484ef832c23$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    dark_matter_icon: (/*@__PURE__*/$parcel$interopDefault($1e51e10e6b258b2f$exports)),
    dark_matter_icon_44: (/*@__PURE__*/$parcel$interopDefault($6e876ab10ca1e420$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports)),
    stardust_icon_44: (/*@__PURE__*/$parcel$interopDefault($352e3fb0a84a7f43$exports)),
    time_icon: (/*@__PURE__*/$parcel$interopDefault($007ede4780a42db6$exports)),
    hp_icon: (/*@__PURE__*/$parcel$interopDefault($c8777eaf0af07724$exports)),
    dps_icon: (/*@__PURE__*/$parcel$interopDefault($87eefc95b23f74ec$exports)),
    trophy_icon_small: (/*@__PURE__*/$parcel$interopDefault($ef608ac5ac7513eb$exports)),
    stardust_prog_bar: (/*@__PURE__*/$parcel$interopDefault($ce116e3ba8cecc8e$exports)),
    stardust_prog_shine: (/*@__PURE__*/$parcel$interopDefault($b049fc5b65c3c3f0$exports)),
    add_stardust_button: (/*@__PURE__*/$parcel$interopDefault($6a83f029721a225a$exports)),
    squad_rect: (/*@__PURE__*/$parcel$interopDefault($f86092df24fdb36c$exports)),
    shop_button: (/*@__PURE__*/$parcel$interopDefault($f7e0b04b83c23a92$exports)),
    mission_rect: (/*@__PURE__*/$parcel$interopDefault($0befb22c27b8b201$exports)),
    mission_default_text: (/*@__PURE__*/$parcel$interopDefault($1431e4a82a1b4436$exports)),
    mission_btn_enabled: (/*@__PURE__*/$parcel$interopDefault($3b73f066f0c935ff$exports)),
    view_mission_btn: (/*@__PURE__*/$parcel$interopDefault($bc53c1030ab4a239$exports)),
    visit_mission_btn: (/*@__PURE__*/$parcel$interopDefault($6c474bb081c9d485$exports)),
    mission_btn_disabled: (/*@__PURE__*/$parcel$interopDefault($3076fdebf254a4d8$exports)),
    hud_helpdesk_button: (/*@__PURE__*/$parcel$interopDefault($db25728465f6da54$exports)),
    hud_leaderboard_button: (/*@__PURE__*/$parcel$interopDefault($4fc13612716d298c$exports)),
    hud_rewards_button: (/*@__PURE__*/$parcel$interopDefault($9a9aa5555baf01ec$exports)),
    hud_army_button: (/*@__PURE__*/$parcel$interopDefault($ba57771d6a3f33b7$exports)),
    hud_shop_button: (/*@__PURE__*/$parcel$interopDefault($1105fc79327fc7db$exports)),
    hud_build_button: (/*@__PURE__*/$parcel$interopDefault($5e55a1c3f69949d8$exports)),
    hud_raid_history_button: (/*@__PURE__*/$parcel$interopDefault($ae872672ceec93f9$exports)),
    hud_quests_button: (/*@__PURE__*/$parcel$interopDefault($c9df7d4e87c5c4e8$exports)),
    hand_pointing_7_oclock: (/*@__PURE__*/$parcel$interopDefault($475ab6017a7c9d14$exports)),
    hand_pointing_9_oclock: (/*@__PURE__*/$parcel$interopDefault($22a84467df8887b7$exports)),
    hand_pointing_10_oclock: (/*@__PURE__*/$parcel$interopDefault($d261f5f746d94264$exports)),
    close_notification_button: (/*@__PURE__*/$parcel$interopDefault($9c0a215d272793f8$exports)),
    hud_battle_royale_background: (/*@__PURE__*/$parcel$interopDefault($0674a9d8cdda4458$exports)),
    hud_battle_royale_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($a73bc25cea830cf2$exports)),
    hud_battle_royale_text: (/*@__PURE__*/$parcel$interopDefault($4a0e694a2ad1f485$exports)),
    hud_battle_royale_blue_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($93e95ff024953d0f$exports)),
    hud_battle_royale_blue_view_button: (/*@__PURE__*/$parcel$interopDefault($60f601a47a04b8a5$exports)),
    hud_battle_royale_view_button: (/*@__PURE__*/$parcel$interopDefault($2bb23131d4936e58$exports)),
    quests_text: (/*@__PURE__*/$parcel$interopDefault($e57d3eb1d0cd8b6d$exports)),
    leaders_text: (/*@__PURE__*/$parcel$interopDefault($113e5e0a8ddec9f4$exports)),
    help_text: (/*@__PURE__*/$parcel$interopDefault($1b6a8ca1b449dd43$exports)),
    troops_text: (/*@__PURE__*/$parcel$interopDefault($93dc392ac007764c$exports)),
    shop_text: (/*@__PURE__*/$parcel$interopDefault($002cf206916badd1$exports)),
    build_text: (/*@__PURE__*/$parcel$interopDefault($72c24c015ce024f6$exports)),
    raid_history_text: (/*@__PURE__*/$parcel$interopDefault($6196b3e306e75f30$exports)),
    your_squad_text: (/*@__PURE__*/$parcel$interopDefault($fd339cf8cb544db8$exports)),
    battlepass_text: (/*@__PURE__*/$parcel$interopDefault($a1d7a9e2364cc7df$exports)),
    hud_battlepass_button: (/*@__PURE__*/$parcel$interopDefault($8ae655b2556a43e3$exports)),
    battle_pass_icon: (/*@__PURE__*/$parcel$interopDefault($5a9aab1396b97f3d$exports))
};
const $1aa2c39fc1fbb95e$export$457b77cfbc171845 = {
    put_to_sleep_button: (/*@__PURE__*/$parcel$interopDefault($8f6511c6e20e2bb2$exports)),
    pet_button: (/*@__PURE__*/$parcel$interopDefault($954d528417d7daa5$exports)),
    assign_points_button: (/*@__PURE__*/$parcel$interopDefault($7efd6dfbffa9a491$exports)),
    give_food_button: (/*@__PURE__*/$parcel$interopDefault($92a8cf636ee58960$exports)),
    give_medication_button: (/*@__PURE__*/$parcel$interopDefault($c9df7883e2154e4e$exports)),
    blob_hud_image: (/*@__PURE__*/$parcel$interopDefault($7ea2abb159855bf3$exports)),
    blob_hud_divider_line: (/*@__PURE__*/$parcel$interopDefault($485721dc2a29916e$exports)),
    add_points_button: (/*@__PURE__*/$parcel$interopDefault($2b3139830cd2d82d$exports)),
    remove_points_button: (/*@__PURE__*/$parcel$interopDefault($4cb65d1197a5182a$exports)),
    blob_option_divider_line: (/*@__PURE__*/$parcel$interopDefault($87ab0a599167d26c$exports)),
    battery_icon: (/*@__PURE__*/$parcel$interopDefault($46b09f602d5ba6e1$exports)),
    lock_icon: (/*@__PURE__*/$parcel$interopDefault($f66ee79cdcfb5abd$exports))
};
const $1aa2c39fc1fbb95e$export$f9e0002d98f59480 = {
    name_rect: (/*@__PURE__*/$parcel$interopDefault($be4fd93302377262$exports)),
    name_text: (/*@__PURE__*/$parcel$interopDefault($f6fda76d4d1b18f9$exports)),
    name_btn_disabled: (/*@__PURE__*/$parcel$interopDefault($a6a878a84c3220c1$exports)),
    name_btn_enabled: (/*@__PURE__*/$parcel$interopDefault($03f7b9ca3a0dbcef$exports)),
    loading_rect: (/*@__PURE__*/$parcel$interopDefault($32ef4e8a3e68ebe3$exports)),
    loading_prog_bar: (/*@__PURE__*/$parcel$interopDefault($db7bf2722d94283a$exports)),
    loading_prog_1: (/*@__PURE__*/$parcel$interopDefault($cc691702c3d21393$exports)),
    loading_prog_2: (/*@__PURE__*/$parcel$interopDefault($186b2efc2baa6adc$exports)),
    loading_prog_3: (/*@__PURE__*/$parcel$interopDefault($b4ab77cf0aed23bb$exports)),
    loading_prog_4: (/*@__PURE__*/$parcel$interopDefault($4e299be7159808fc$exports)),
    loading_prog_5: (/*@__PURE__*/$parcel$interopDefault($4530a769a02dd3fc$exports)),
    loading_text_1: (/*@__PURE__*/$parcel$interopDefault($b40f8ee7b66e2022$exports)),
    loading_text_2: (/*@__PURE__*/$parcel$interopDefault($453121e4cde59830$exports)),
    loading_text_3: (/*@__PURE__*/$parcel$interopDefault($bf188843f286c0b3$exports)),
    loading_text_4: (/*@__PURE__*/$parcel$interopDefault($486354799ba08299$exports)),
    homebase_loading_text: (/*@__PURE__*/$parcel$interopDefault($864be546d21f68ab$exports))
};
const $1aa2c39fc1fbb95e$export$f4c0b61e75a7e807 = {
    leaderboard_icon: (/*@__PURE__*/$parcel$interopDefault($245174d3a4332e9a$exports)),
    leaderboard_divider: (/*@__PURE__*/$parcel$interopDefault($8498057af217a603$exports)),
    leaderboard_pvp_button: (/*@__PURE__*/$parcel$interopDefault($1321f834559dd6a4$exports)),
    leaderboard_pvp_button_inactive: (/*@__PURE__*/$parcel$interopDefault($83a2718a7a9ce95f$exports)),
    leaderboard_stardust_button: (/*@__PURE__*/$parcel$interopDefault($ca22538e9d7e18ed$exports)),
    leaderboard_stardust_button_inactive: (/*@__PURE__*/$parcel$interopDefault($714f7f3e0818a59d$exports)),
    leaderboard_logins_button: (/*@__PURE__*/$parcel$interopDefault($63f7db4c62823033$exports)),
    leaderboard_logins_button_inactive: (/*@__PURE__*/$parcel$interopDefault($9250a4689a0db7fb$exports)),
    leaderboard_title: (/*@__PURE__*/$parcel$interopDefault($9e40aa13eb3d712c$exports)),
    leaderboard_pve_button: (/*@__PURE__*/$parcel$interopDefault($8980181273118be9$exports)),
    leaderboard_pve_button_inactive: (/*@__PURE__*/$parcel$interopDefault($9c05270a86dfc28a$exports)),
    leaderboard_xp_button: (/*@__PURE__*/$parcel$interopDefault($238752cdb081f55f$exports)),
    leaderboard_xp_button_inactive: (/*@__PURE__*/$parcel$interopDefault($4f402a651584c979$exports)),
    leaderboard_mining_button: (/*@__PURE__*/$parcel$interopDefault($a9dc2534ef9708dc$exports)),
    leaderboard_mining_button_inactive: (/*@__PURE__*/$parcel$interopDefault($309b47dd830c0ec4$exports)),
    leaderboard_base_raid_button: (/*@__PURE__*/$parcel$interopDefault($e3538d54ec030fc9$exports)),
    leaderboard_base_raid_button_inactive: (/*@__PURE__*/$parcel$interopDefault($c7207e1f2bff2019$exports)),
    pvp_victory_icon: (/*@__PURE__*/$parcel$interopDefault($34d00cd0f637669f$exports))
};
const $1aa2c39fc1fbb95e$export$3fff705904dea5e1 = {
    guide_changelog_text: (/*@__PURE__*/$parcel$interopDefault($5b303489b647f361$exports)),
    guide_game_text: (/*@__PURE__*/$parcel$interopDefault($ce2a6f41c824d469$exports)),
    guide_medium_text: (/*@__PURE__*/$parcel$interopDefault($feefb826f434e1c2$exports)),
    guide_wolf_e_dex_text: (/*@__PURE__*/$parcel$interopDefault($9dbd3206ba6a977c$exports)),
    litepaper_1_gameplay_text: (/*@__PURE__*/$parcel$interopDefault($93af9111adb70ad7$exports)),
    litepaper_2_tokenomics_text: (/*@__PURE__*/$parcel$interopDefault($fe7e5fe08fc37c59$exports)),
    traits_text: (/*@__PURE__*/$parcel$interopDefault($4ae20922fcf409cc$exports)),
    partners_text: (/*@__PURE__*/$parcel$interopDefault($b3a97345e2bdafeb$exports)),
    helpdesk_option_bg: (/*@__PURE__*/$parcel$interopDefault($17c8836ca233e370$exports)),
    helpdesk_text: (/*@__PURE__*/$parcel$interopDefault($bb0227866ecb619b$exports))
};
const $1aa2c39fc1fbb95e$export$b438e31af3ecff0a = {
    missions_text: (/*@__PURE__*/$parcel$interopDefault($3cf9b80ca3da32e0$exports)),
    pvp_button_bg: (/*@__PURE__*/$parcel$interopDefault($27c4bc42362d7757$exports)),
    pvp_button_text: (/*@__PURE__*/$parcel$interopDefault($cc36528536cad54f$exports)),
    battle_royale_button_bg: (/*@__PURE__*/$parcel$interopDefault($171a65724ef148d5$exports)),
    battle_royale_button_text: (/*@__PURE__*/$parcel$interopDefault($a46dce809d741f1f$exports)),
    boss_fight_button_bg: (/*@__PURE__*/$parcel$interopDefault($ad71c7e03822433e$exports)),
    boss_fight_button_text: (/*@__PURE__*/$parcel$interopDefault($26bd6c1ec5b37fb4$exports)),
    pve_button_bg: (/*@__PURE__*/$parcel$interopDefault($b994c34482951457$exports)),
    pve_button_text: (/*@__PURE__*/$parcel$interopDefault($26a15f1edf12658f$exports)),
    base_raid_button_bg: (/*@__PURE__*/$parcel$interopDefault($f4986983df16f97b$exports)),
    base_raid_button_text: (/*@__PURE__*/$parcel$interopDefault($43e4bd0a956bd1f6$exports)),
    mining_mission_button_bg: (/*@__PURE__*/$parcel$interopDefault($5459a257948490e7$exports)),
    mining_mission_button_text: (/*@__PURE__*/$parcel$interopDefault($b6525687ae6cb35f$exports)),
    mining_mission_logo_image: (/*@__PURE__*/$parcel$interopDefault($9cf803ef2da6bdd3$exports))
};
const $1aa2c39fc1fbb95e$export$538ba78e0dbb1045 = {
    mining_cancel_dialog_cancel_button: (/*@__PURE__*/$parcel$interopDefault($7ad2dbc0f5a744e3$exports)),
    mining_cancel_dialog_confirm_button: (/*@__PURE__*/$parcel$interopDefault($68ddff60bb71c9ad$exports)),
    mining_back_to_missions_button: (/*@__PURE__*/$parcel$interopDefault($728d33180c042ae2$exports)),
    mining_launch_button: (/*@__PURE__*/$parcel$interopDefault($b5a91bfebc20752c$exports)),
    mining_not_enough_resources_dialog_got_it_button: (/*@__PURE__*/$parcel$interopDefault($5bb67394a9de79ee$exports)),
    mining_paw: (/*@__PURE__*/$parcel$interopDefault($d71f757e0568c7e3$exports)),
    mining_cancel_mission_button: (/*@__PURE__*/$parcel$interopDefault($c62faeb0e11d0ab8$exports)),
    mining_back_to_homebase_button: (/*@__PURE__*/$parcel$interopDefault($15aa01ddbfb09c72$exports)),
    mining_return_home_button: (/*@__PURE__*/$parcel$interopDefault($1ca4fc903c2450d4$exports)),
    mining_success_badge: (/*@__PURE__*/$parcel$interopDefault($9860e8e2c353ca49$exports)),
    mining_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($3c6414f3121cc100$exports)),
    mining_success_label: (/*@__PURE__*/$parcel$interopDefault($968c120b949c8e52$exports)),
    mining_defeat_label: (/*@__PURE__*/$parcel$interopDefault($609e95b6e4b0fcf6$exports)),
    common_asteroid: (/*@__PURE__*/$parcel$interopDefault($be89bfe2522429e5$exports)),
    rare_asteroid: (/*@__PURE__*/$parcel$interopDefault($153ffd75f0d5fd71$exports)),
    epic_asteroid: (/*@__PURE__*/$parcel$interopDefault($2fafc7565cc316fc$exports)),
    legendary_asteroid: (/*@__PURE__*/$parcel$interopDefault($e5e8a5c16eb96080$exports)),
    mythical_asteroid: (/*@__PURE__*/$parcel$interopDefault($f3438c8fb3a69d54$exports)),
    mining_divider: (/*@__PURE__*/$parcel$interopDefault($d4ea82ca289fd3c4$exports))
};
const $1aa2c39fc1fbb95e$export$4560731aa3c2c725 = {
    common_asteroid: (/*@__PURE__*/$parcel$interopDefault($be89bfe2522429e5$exports)),
    rare_asteroid: (/*@__PURE__*/$parcel$interopDefault($153ffd75f0d5fd71$exports)),
    epic_asteroid: (/*@__PURE__*/$parcel$interopDefault($2fafc7565cc316fc$exports)),
    legendary_asteroid: (/*@__PURE__*/$parcel$interopDefault($e5e8a5c16eb96080$exports)),
    mythical_asteroid: (/*@__PURE__*/$parcel$interopDefault($f3438c8fb3a69d54$exports))
};
const $1aa2c39fc1fbb95e$export$f11b8de07dc7df14 = {
    loading_rect: (/*@__PURE__*/$parcel$interopDefault($32ef4e8a3e68ebe3$exports)),
    loading_prog_bar: (/*@__PURE__*/$parcel$interopDefault($db7bf2722d94283a$exports)),
    loading_prog_1: (/*@__PURE__*/$parcel$interopDefault($cc691702c3d21393$exports)),
    loading_prog_2: (/*@__PURE__*/$parcel$interopDefault($186b2efc2baa6adc$exports)),
    loading_prog_3: (/*@__PURE__*/$parcel$interopDefault($b4ab77cf0aed23bb$exports)),
    loading_prog_4: (/*@__PURE__*/$parcel$interopDefault($4e299be7159808fc$exports)),
    loading_prog_5: (/*@__PURE__*/$parcel$interopDefault($4530a769a02dd3fc$exports))
};
const $1aa2c39fc1fbb95e$export$a71a584b9c5c35a7 = {
    mining_back_to_missions_button: (/*@__PURE__*/$parcel$interopDefault($728d33180c042ae2$exports)),
    mining_launch_button: (/*@__PURE__*/$parcel$interopDefault($b5a91bfebc20752c$exports)),
    common_asteroid: (/*@__PURE__*/$parcel$interopDefault($be89bfe2522429e5$exports)),
    rare_asteroid: (/*@__PURE__*/$parcel$interopDefault($153ffd75f0d5fd71$exports)),
    epic_asteroid: (/*@__PURE__*/$parcel$interopDefault($2fafc7565cc316fc$exports)),
    legendary_asteroid: (/*@__PURE__*/$parcel$interopDefault($e5e8a5c16eb96080$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    mining_divider: (/*@__PURE__*/$parcel$interopDefault($d4ea82ca289fd3c4$exports))
};
const $1aa2c39fc1fbb95e$export$905be90bf68d52dc = {
    mining_paw: (/*@__PURE__*/$parcel$interopDefault($d71f757e0568c7e3$exports)),
    mining_cancel_mission_button: (/*@__PURE__*/$parcel$interopDefault($c62faeb0e11d0ab8$exports)),
    mining_back_to_homebase_button: (/*@__PURE__*/$parcel$interopDefault($15aa01ddbfb09c72$exports))
};
const $1aa2c39fc1fbb95e$export$7c7b01c296abb151 = {
    mining_cancel_dialog_cancel_button: (/*@__PURE__*/$parcel$interopDefault($7ad2dbc0f5a744e3$exports)),
    mining_cancel_dialog_confirm_button: (/*@__PURE__*/$parcel$interopDefault($68ddff60bb71c9ad$exports))
};
const $1aa2c39fc1fbb95e$export$8f18fa8a20ab5c35 = {
    mining_return_home_button: (/*@__PURE__*/$parcel$interopDefault($1ca4fc903c2450d4$exports)),
    mining_success_badge: (/*@__PURE__*/$parcel$interopDefault($9860e8e2c353ca49$exports)),
    mining_success_label: (/*@__PURE__*/$parcel$interopDefault($968c120b949c8e52$exports)),
    mining_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($3c6414f3121cc100$exports)),
    mining_defeat_label: (/*@__PURE__*/$parcel$interopDefault($609e95b6e4b0fcf6$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$12ea44d094a282e0 = {
    settings_text: (/*@__PURE__*/$parcel$interopDefault($0dc500e74cdf489f$exports)),
    settings_connect_wallet_button: (/*@__PURE__*/$parcel$interopDefault($1f0ba91f8f3cc796$exports)),
    disconnect_button: (/*@__PURE__*/$parcel$interopDefault($12dd268b0ed0243e$exports)),
    disconnect_button_disabled: (/*@__PURE__*/$parcel$interopDefault($c42f7f016762a26a$exports)),
    kick_button_disabled: (/*@__PURE__*/$parcel$interopDefault($13449a3032c18cf3$exports)),
    save_and_exit_button: (/*@__PURE__*/$parcel$interopDefault($140966120df452ae$exports)),
    music_button_active: (/*@__PURE__*/$parcel$interopDefault($249007e5b7028ca5$exports)),
    sound_effects_button_active: (/*@__PURE__*/$parcel$interopDefault($08253fd63200b62e$exports)),
    help_pane_divider: (/*@__PURE__*/$parcel$interopDefault($ff5efbc6b58452f8$exports)),
    help_channel_image: (/*@__PURE__*/$parcel$interopDefault($46eb864b9e9248ad$exports)),
    inter_planetary_image: (/*@__PURE__*/$parcel$interopDefault($8a671f29073867f0$exports))
};
const $1aa2c39fc1fbb95e$export$76043ee8727017b5 = {
    neon_gold_icon_large: (/*@__PURE__*/$parcel$interopDefault($ffa924ffb865fbe4$exports)),
    space_elixir_icon_large: (/*@__PURE__*/$parcel$interopDefault($e802220e3a7bc634$exports)),
    stardust_icon_large: (/*@__PURE__*/$parcel$interopDefault($f823c2268fdd6202$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports)),
    pvp_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e70441a2d03bcb5f$exports)),
    pvp_confirm_button: (/*@__PURE__*/$parcel$interopDefault($a7d97e893dd0a8bc$exports))
};
const $1aa2c39fc1fbb95e$export$251c17ddc5e37a4c = {
    cancel_button: (/*@__PURE__*/$parcel$interopDefault($9cc4c758e6c747ba$exports))
};
const $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59 = {
    cancel_button: (/*@__PURE__*/$parcel$interopDefault($9cc4c758e6c747ba$exports)),
    pvp_return_home_button: (/*@__PURE__*/$parcel$interopDefault($b2999f570de9ec23$exports)),
    pvp_confirm_button: (/*@__PURE__*/$parcel$interopDefault($a7d97e893dd0a8bc$exports)),
    pvp_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e70441a2d03bcb5f$exports)),
    pve_continue_button: (/*@__PURE__*/$parcel$interopDefault($fb4f739456aac912$exports)),
    pve_opponent_pfp: (/*@__PURE__*/$parcel$interopDefault($48400f8472f7bec9$exports)),
    pve_gameover_bg: (/*@__PURE__*/$parcel$interopDefault($334617e7d1189f28$exports)),
    pve_victory_bg: (/*@__PURE__*/$parcel$interopDefault($27184a1d05d0d746$exports)),
    pvp_vertical_divider: (/*@__PURE__*/$parcel$interopDefault($d651ffc44bdcbb91$exports)),
    pvp_game_divider: (/*@__PURE__*/$parcel$interopDefault($880a9acc72afd6df$exports)),
    pvp_player_divider: (/*@__PURE__*/$parcel$interopDefault($d96d3d2b0ad0b29d$exports)),
    pvp_hp_icon: (/*@__PURE__*/$parcel$interopDefault($f51fac2f7010a241$exports)),
    pvp_ap_icon: (/*@__PURE__*/$parcel$interopDefault($b26dcb725c1d556f$exports)),
    pvp_heavy_attack_button: (/*@__PURE__*/$parcel$interopDefault($43119a5520bb28f4$exports)),
    pvp_heavy_attack_button_disabled: (/*@__PURE__*/$parcel$interopDefault($d8967184e7d4b031$exports)),
    pvp_light_attack_button: (/*@__PURE__*/$parcel$interopDefault($f66fa572dcbabd4f$exports)),
    pvp_light_attack_button_disabled: (/*@__PURE__*/$parcel$interopDefault($a19bc0c4559fbdc2$exports)),
    pvp_defend_button: (/*@__PURE__*/$parcel$interopDefault($14257ea645dc5c45$exports)),
    pvp_defend_button_disabled: (/*@__PURE__*/$parcel$interopDefault($5289243f5fe295fc$exports)),
    pvp_restore_button: (/*@__PURE__*/$parcel$interopDefault($7832184daba2913c$exports)),
    pvp_restore_button_disabled: (/*@__PURE__*/$parcel$interopDefault($1eca8d76545c9cfc$exports)),
    pvp_heal_button: (/*@__PURE__*/$parcel$interopDefault($4fa3a10ca05b1860$exports)),
    pvp_heal_button_disabled: (/*@__PURE__*/$parcel$interopDefault($d14f283ff565b2d5$exports)),
    pvp_surrender_button: (/*@__PURE__*/$parcel$interopDefault($e603b3e4d1b2ce76$exports)),
    pvp_surrender_button_disabled: (/*@__PURE__*/$parcel$interopDefault($371701b0edf6b232$exports))
};
const $1aa2c39fc1fbb95e$export$7b1be53f51071a08 = {
    pvp_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e70441a2d03bcb5f$exports)),
    pvp_confirm_button: (/*@__PURE__*/$parcel$interopDefault($a7d97e893dd0a8bc$exports))
};
const $1aa2c39fc1fbb95e$export$28f650127da92c3f = {
    pvp_victory_icon: (/*@__PURE__*/$parcel$interopDefault($34d00cd0f637669f$exports)),
    pvp_defeat_icon: (/*@__PURE__*/$parcel$interopDefault($4c562f735b5a1bb5$exports)),
    pvp_draw_icon: (/*@__PURE__*/$parcel$interopDefault($f44b904c8b426b24$exports)),
    pvp_victory_icon_label: (/*@__PURE__*/$parcel$interopDefault($684edc1fd2422bfb$exports)),
    pvp_defeat_icon_label: (/*@__PURE__*/$parcel$interopDefault($e9957f99ebc181b8$exports)),
    pvp_draw_icon_label: (/*@__PURE__*/$parcel$interopDefault($7d5f3625cfb1b2c2$exports)),
    pvp_return_home_button: (/*@__PURE__*/$parcel$interopDefault($b2999f570de9ec23$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$35664250ad2bd612 = {
    pve_gameover_bg: (/*@__PURE__*/$parcel$interopDefault($334617e7d1189f28$exports)),
    pve_victory_bg: (/*@__PURE__*/$parcel$interopDefault($27184a1d05d0d746$exports))
};
const $1aa2c39fc1fbb95e$export$fefbcb53f7841b7c = {
    pvp_victory_icon: (/*@__PURE__*/$parcel$interopDefault($34d00cd0f637669f$exports)),
    pve_victory_bg: (/*@__PURE__*/$parcel$interopDefault($27184a1d05d0d746$exports)),
    pvp_defeat_icon: (/*@__PURE__*/$parcel$interopDefault($4c562f735b5a1bb5$exports)),
    pve_gameover_bg: (/*@__PURE__*/$parcel$interopDefault($334617e7d1189f28$exports)),
    pvp_draw_icon: (/*@__PURE__*/$parcel$interopDefault($f44b904c8b426b24$exports)),
    pvp_draw_icon_label: (/*@__PURE__*/$parcel$interopDefault($7d5f3625cfb1b2c2$exports)),
    pvp_return_home_button: (/*@__PURE__*/$parcel$interopDefault($b2999f570de9ec23$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$51715d62b7d83d79 = {
    machines_tab_active: (/*@__PURE__*/$parcel$interopDefault($80d05b0a61ca47b2$exports)),
    item_shop_tab_active: (/*@__PURE__*/$parcel$interopDefault($553b5870bd9af7b5$exports)),
    resources_tab_active: (/*@__PURE__*/$parcel$interopDefault($2ba632b9541e0d8c$exports)),
    machines_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($afe8b2301c5410f2$exports)),
    item_shop_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($010cf85a9ba0eee1$exports)),
    resources_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($4cfa672db7a269b5$exports)),
    shop_common_resource_box_image: (/*@__PURE__*/$parcel$interopDefault($1b6636ae31b5bf06$exports)),
    shop_epic_resource_box_image: (/*@__PURE__*/$parcel$interopDefault($8556ef45b78fffe1$exports)),
    shop_legendary_resource_box_image: (/*@__PURE__*/$parcel$interopDefault($d2a43cc5c21310ec$exports)),
    shop_common_ng_refill_image: (/*@__PURE__*/$parcel$interopDefault($5cb38a7bb1b9556d$exports)),
    shop_rare_ng_refill_image: (/*@__PURE__*/$parcel$interopDefault($5b219aa4bfbc3447$exports)),
    shop_epic_ng_refill_image: (/*@__PURE__*/$parcel$interopDefault($c7fbccf35957187c$exports)),
    shop_common_se_refill_image: (/*@__PURE__*/$parcel$interopDefault($88ec0cf213d9cdfd$exports)),
    shop_rare_se_refill_image: (/*@__PURE__*/$parcel$interopDefault($693c1e8aace7e7a9$exports)),
    shop_epic_se_refill_image: (/*@__PURE__*/$parcel$interopDefault($60523745d96794fe$exports)),
    shop_animated_408_image: (/*@__PURE__*/$parcel$interopDefault($90b85855b07ccedb$exports)),
    shop_animated_3299_image: (/*@__PURE__*/$parcel$interopDefault($8f4b02ccc100b7ad$exports)),
    shop_star_wolvez_hoodie_image: (/*@__PURE__*/$parcel$interopDefault($d562c1a427cfc140$exports)),
    shop_animation_chip_image: (/*@__PURE__*/$parcel$interopDefault($4ff495ee132c341a$exports)),
    shop_bk55_chip_image: (/*@__PURE__*/$parcel$interopDefault($e97a19424fe266df$exports)),
    shop_bk55_ii_chip_image: (/*@__PURE__*/$parcel$interopDefault($308f1711a3a7d8b5$exports)),
    shop_fur_69_image: (/*@__PURE__*/$parcel$interopDefault($ecf5b34bcf5e51db$exports)),
    shop_little_lemon_friends_image: (/*@__PURE__*/$parcel$interopDefault($6943a954905eda91$exports)),
    shop_etherorc_allies_image: (/*@__PURE__*/$parcel$interopDefault($daf869495e0301b3$exports)),
    shop_brawler_bearz_image: (/*@__PURE__*/$parcel$interopDefault($b0940ff5a4085d5a$exports)),
    shop_back_button: (/*@__PURE__*/$parcel$interopDefault($b7ed6568870f5253$exports)),
    shop_stake_button: (/*@__PURE__*/$parcel$interopDefault($cca79c708520bcb9$exports)),
    shop_buy_swap_button: (/*@__PURE__*/$parcel$interopDefault($7e228275c0d2e5d5$exports)),
    shop_stake_button_inactive: (/*@__PURE__*/$parcel$interopDefault($05681221570bd0b9$exports)),
    shop_buy_swap_button_inactive: (/*@__PURE__*/$parcel$interopDefault($07d19fb579f89b66$exports)),
    shop_cosmetics_button_inactive: (/*@__PURE__*/$parcel$interopDefault($a9fde35cfa45da9b$exports)),
    shop_other_button_inactive: (/*@__PURE__*/$parcel$interopDefault($2e4915df46f8fe71$exports)),
    shop_whitelist_button_inactive: (/*@__PURE__*/$parcel$interopDefault($ea03fdf242e653b0$exports)),
    shop_cosmetics_button: (/*@__PURE__*/$parcel$interopDefault($ea3fc9ab63930b28$exports)),
    shop_other_button: (/*@__PURE__*/$parcel$interopDefault($c5e4cfec3cfac563$exports)),
    shop_whitelist_button: (/*@__PURE__*/$parcel$interopDefault($b6a2acfafa6de887$exports)),
    shop_administrative_button_inactive: (/*@__PURE__*/$parcel$interopDefault($37d9a11c61c4be11$exports)),
    shop_army_button_inactive: (/*@__PURE__*/$parcel$interopDefault($be8b259d25c9b356$exports)),
    shop_available_button: (/*@__PURE__*/$parcel$interopDefault($cc0bd4ba3d8f049d$exports)),
    shop_research_button_inactive: (/*@__PURE__*/$parcel$interopDefault($94a755020f3a42d3$exports)),
    shop_resources_button_inactive: (/*@__PURE__*/$parcel$interopDefault($c6a86e94e671a1c8$exports)),
    shop_administrative_button: (/*@__PURE__*/$parcel$interopDefault($80c6a6aa9db13be0$exports)),
    shop_army_button: (/*@__PURE__*/$parcel$interopDefault($a19d3e16eb070d9e$exports)),
    shop_available_button_inactive: (/*@__PURE__*/$parcel$interopDefault($d5b5a0c147b77619$exports)),
    shop_research_button: (/*@__PURE__*/$parcel$interopDefault($9be1f4234ebcd0f6$exports)),
    shop_resources_button: (/*@__PURE__*/$parcel$interopDefault($f1d9c233b1383671$exports)),
    shop_all_button: (/*@__PURE__*/$parcel$interopDefault($bd79922b6b8479c3$exports)),
    shop_all_button_inactive: (/*@__PURE__*/$parcel$interopDefault($b552cb7bf774ba28$exports)),
    shop_holder_exclusive_button: (/*@__PURE__*/$parcel$interopDefault($0b6a43c5d816a90e$exports)),
    shop_holder_exclusive_button_inactive: (/*@__PURE__*/$parcel$interopDefault($dafd2c4d50ff49c8$exports)),
    shop_item_info_button: (/*@__PURE__*/$parcel$interopDefault($ab95b0ce2eac2af0$exports)),
    shop_item_info_letter: (/*@__PURE__*/$parcel$interopDefault($6d734b99665274d7$exports)),
    shop_item_info_divider_long: (/*@__PURE__*/$parcel$interopDefault($9e57af70e07a9c61$exports)),
    shop_item_info_stardust_progress_bar: (/*@__PURE__*/$parcel$interopDefault($b8366922dbfbc1b6$exports)),
    shop_buy_button: (/*@__PURE__*/$parcel$interopDefault($1532596accee584d$exports)),
    shop_coming_soon_button: (/*@__PURE__*/$parcel$interopDefault($c1c83665a24b086e$exports)),
    shop_sold_out_button: (/*@__PURE__*/$parcel$interopDefault($86440a202b5eb9ea$exports)),
    shop_nfts_button: (/*@__PURE__*/$parcel$interopDefault($d6fbd71deced2a5a$exports)),
    shop_nfts_button_inactive: (/*@__PURE__*/$parcel$interopDefault($2853bc53564eb3ba$exports)),
    shop_special_items_button: (/*@__PURE__*/$parcel$interopDefault($823b3182e6e04297$exports)),
    shop_special_items_button_inactive: (/*@__PURE__*/$parcel$interopDefault($fc0ffbe83ba35c7f$exports)),
    shop_resource_packs_button: (/*@__PURE__*/$parcel$interopDefault($392095ccd09d577e$exports)),
    shop_resource_packs_button_inactive: (/*@__PURE__*/$parcel$interopDefault($0b277739caa0012e$exports)),
    shop_battlepass_season_0_image: (/*@__PURE__*/$parcel$interopDefault($cf1a8a50154146f6$exports)),
    shop_machines_mainframe: (/*@__PURE__*/$parcel$interopDefault($cee5c505070f6dff$exports)),
    shop_machines_neon_gold_mine: (/*@__PURE__*/$parcel$interopDefault($de828deefa6bf54b$exports)),
    shop_machines_neon_gold_storage: (/*@__PURE__*/$parcel$interopDefault($a9fbcdbf8044ee7b$exports)),
    shop_machines_space_elixir_mine: (/*@__PURE__*/$parcel$interopDefault($20aeb8911ade14ee$exports)),
    shop_machines_space_elixir_storage: (/*@__PURE__*/$parcel$interopDefault($e6b75f937beda1cc$exports)),
    shop_machines_star_laboratory: (/*@__PURE__*/$parcel$interopDefault($de79a1e06f759102$exports)),
    shop_machines_technician_bunker: (/*@__PURE__*/$parcel$interopDefault($359007c9f203efd1$exports)),
    shop_machines_discord_airdrop_trophy: (/*@__PURE__*/$parcel$interopDefault($5b4c7ef0a07422b7$exports)),
    shop_machines_stardust_mine: (/*@__PURE__*/$parcel$interopDefault($e72f00a8e8fa1058$exports)),
    shop_machines_tournament_one_competitor_trophy: (/*@__PURE__*/$parcel$interopDefault($596c3b0159d603c2$exports)),
    shop_machines_genesis_holder_trophy: (/*@__PURE__*/$parcel$interopDefault($e6ee5a244226c0cc$exports)),
    shop_machines_gasa_embassy: (/*@__PURE__*/$parcel$interopDefault($3c2e302e98ae54ef$exports)),
    shop_machines_christmas_tree_trophy: (/*@__PURE__*/$parcel$interopDefault($c4ed075b36a493c2$exports)),
    shop_machines_beer_machine: (/*@__PURE__*/$parcel$interopDefault($c0c086281c665ba4$exports)),
    shop_machines_raijus_grave: (/*@__PURE__*/$parcel$interopDefault($aeb96abf16f77670$exports)),
    shop_machines_linkins_armory: (/*@__PURE__*/$parcel$interopDefault($d06cce5753eab453$exports)),
    shop_machines_bench_press: (/*@__PURE__*/$parcel$interopDefault($4c7e6c32c0774fbb$exports)),
    shop_machines_valentines_picnic: (/*@__PURE__*/$parcel$interopDefault($931fc71405f5c055$exports)),
    shop_machines_gooh_refinery: (/*@__PURE__*/$parcel$interopDefault($022d548460a5868e$exports)),
    shop_machines_alchemist_lab: (/*@__PURE__*/$parcel$interopDefault($0e5f6ae08965539e$exports)),
    shop_machines_1st_birthday_cake: (/*@__PURE__*/$parcel$interopDefault($d5c603ac4c5d56f1$exports)),
    shop_machines_brawler_cage: (/*@__PURE__*/$parcel$interopDefault($37acbad4d876b2b1$exports)),
    shop_machines_mother_wolf_statue: (/*@__PURE__*/$parcel$interopDefault($5ce844df66e7e36d$exports)),
    shop_machines_others_receiver: (/*@__PURE__*/$parcel$interopDefault($08da155aa774e4d1$exports)),
    shop_machines_porcelain_throne: (/*@__PURE__*/$parcel$interopDefault($04bfce5e85cde564$exports)),
    shop_machines_space_cactus: (/*@__PURE__*/$parcel$interopDefault($b3a041805dceecf1$exports)),
    shop_machines_lightning_tower: (/*@__PURE__*/$parcel$interopDefault($ce0b9b73571de486$exports)),
    shop_machines_plasma_cannon: (/*@__PURE__*/$parcel$interopDefault($1ec387966eaec452$exports)),
    shop_machines_little_lemon_tree: (/*@__PURE__*/$parcel$interopDefault($d285e5ffbdedcb9d$exports)),
    shop_machines_kaiju_kingmaker: (/*@__PURE__*/$parcel$interopDefault($50130e3c7a96e55a$exports)),
    shop_machines_aic_lab: (/*@__PURE__*/$parcel$interopDefault($4fb9edca4708ddba$exports)),
    shop_machines_neon_gold_accelerator: (/*@__PURE__*/$parcel$interopDefault($6b4b8f6924e40e1c$exports)),
    shop_machines_space_elixir_accelerator: (/*@__PURE__*/$parcel$interopDefault($32d9434e985f4128$exports)),
    shop_machines_barracks: (/*@__PURE__*/$parcel$interopDefault($08bd276b9bfab386$exports)),
    shop_machines_cadet_dorms: (/*@__PURE__*/$parcel$interopDefault($5fc01167255a2751$exports)),
    shop_machines_laser_cannon: (/*@__PURE__*/$parcel$interopDefault($65ba9ac42f208f4a$exports)),
    shop_machines_shield_battery: (/*@__PURE__*/$parcel$interopDefault($bddaf9273bd2dbd7$exports)),
    shop_machines_plasma_mortar: (/*@__PURE__*/$parcel$interopDefault($cb47bbbc9b48da45$exports)),
    shop_machines_photon_shield: (/*@__PURE__*/$parcel$interopDefault($734cf736512b1625$exports)),
    shop_item_info_divider_short: (/*@__PURE__*/$parcel$interopDefault($778a23bb5e10a383$exports)),
    shop_machines_mvhq: (/*@__PURE__*/$parcel$interopDefault($1c61572936d6f41c$exports)),
    shop_machines_mercenary_wolvez_hideout: (/*@__PURE__*/$parcel$interopDefault($b42224fa209d78d5$exports)),
    shop_machines_kuma_ancestor_shrine: (/*@__PURE__*/$parcel$interopDefault($7d000f0a349aa4e1$exports)),
    shop_machines_super_swole_squad_department: (/*@__PURE__*/$parcel$interopDefault($e33e06c8a73e741d$exports)),
    shop_machines_medical_academy: (/*@__PURE__*/$parcel$interopDefault($c4cbf12e06fe8661$exports)),
    shop_machines_antirat_squad_department: (/*@__PURE__*/$parcel$interopDefault($4c526723ae1e6c22$exports)),
    shop_machines_saved_souls: (/*@__PURE__*/$parcel$interopDefault($e544d7804894fd3e$exports)),
    shop_machines_dimension_x: (/*@__PURE__*/$parcel$interopDefault($bf23189d5d829dba$exports)),
    shop_battle_pass_image: (/*@__PURE__*/$parcel$interopDefault($a1370df56d7dee33$exports)),
    shop_machines_sunday_skirmish_trophy: (/*@__PURE__*/$parcel$interopDefault($49f87a6ddb2783fd$exports)),
    shop_machines_sunday_skirmish_trophy2: (/*@__PURE__*/$parcel$interopDefault($914f71d00b05aaa3$exports)),
    shop_machines_zen_garden: (/*@__PURE__*/$parcel$interopDefault($d952f703059717ec$exports)),
    shop_machines_christmas_tree_2023: (/*@__PURE__*/$parcel$interopDefault($1889932a7f5ae01b$exports)),
    shop_machines_community_hero_2023: (/*@__PURE__*/$parcel$interopDefault($47e23ef4803c46a8$exports)),
    shop_machines_community_nominee_2023: (/*@__PURE__*/$parcel$interopDefault($0304dc4dbedd3d15$exports)),
    shop_machines_nine_lives_lounge: (/*@__PURE__*/$parcel$interopDefault($2f546ac80835ed07$exports)),
    shop_machines_glfhers_arcade: (/*@__PURE__*/$parcel$interopDefault($a70b84b9dcb0981f$exports)),
    shop_machines_pirate_nation_golden_galleon: (/*@__PURE__*/$parcel$interopDefault($5a556230783857d1$exports)),
    shop_machines_pirate_nation_wood_galleon: (/*@__PURE__*/$parcel$interopDefault($5c626b5afa2daf2c$exports)),
    shop_machines_bp_blob_cosmetic: (/*@__PURE__*/$parcel$interopDefault($d1028a0fdd0d528c$exports)),
    shop_machines_bp_fire_storm_tracker_cosmetic: (/*@__PURE__*/$parcel$interopDefault($28f174d0875eb23b$exports)),
    shop_machines_bp_ice_storm_tracker_cosmetic: (/*@__PURE__*/$parcel$interopDefault($c83f4b4089e746cf$exports)),
    shop_machines_bp_star_wolvez_helmet_cosmetic: (/*@__PURE__*/$parcel$interopDefault($79632cd3d363f464$exports)),
    shop_machines_bp_water_cooler_cosmetic: (/*@__PURE__*/$parcel$interopDefault($ed011fcd9ccf3e38$exports)),
    shop_machines_bp_piece_of_home_cosmetic: (/*@__PURE__*/$parcel$interopDefault($c709ff7ca4fea607$exports))
};
const $1aa2c39fc1fbb95e$export$4a92157dbd1ca5c5 = {
    bronze_pack: (/*@__PURE__*/$parcel$interopDefault($9294276dc22ccb80$exports)),
    silver_pack: (/*@__PURE__*/$parcel$interopDefault($641a1af03c8bffbf$exports)),
    golden_pack: (/*@__PURE__*/$parcel$interopDefault($91c43e96cf37d491$exports)),
    rare_pack: (/*@__PURE__*/$parcel$interopDefault($6581700443821a78$exports)),
    epic_pack: (/*@__PURE__*/$parcel$interopDefault($d5db9c25d1c7a73c$exports)),
    legendary_pack: (/*@__PURE__*/$parcel$interopDefault($df7456d32a40287e$exports)),
    mythical_pack: (/*@__PURE__*/$parcel$interopDefault($1244084154c3c896$exports)),
    space_elixir_pack_reward: (/*@__PURE__*/$parcel$interopDefault($5afa380e21577ca9$exports)),
    neon_gold_pack_reward: (/*@__PURE__*/$parcel$interopDefault($fbb9bc2d515e8cee$exports)),
    stardust_pack_reward: (/*@__PURE__*/$parcel$interopDefault($52f55a03bbc2798d$exports)),
    pack_item_veil: (/*@__PURE__*/$parcel$interopDefault($4c31b4fa9027b889$exports)),
    artifact_0002: (/*@__PURE__*/$parcel$interopDefault($1e2b5ab04807b001$exports)),
    artifact_0003: (/*@__PURE__*/$parcel$interopDefault($85f6fef27d0b10df$exports)),
    artifact_0004: (/*@__PURE__*/$parcel$interopDefault($226ad78dbfb41c17$exports)),
    artifact_0005: (/*@__PURE__*/$parcel$interopDefault($1ce3761da034cf7b$exports)),
    artifact_0006: (/*@__PURE__*/$parcel$interopDefault($c503ef53ecc18400$exports)),
    artifact_0007: (/*@__PURE__*/$parcel$interopDefault($8f37f02250b39fd8$exports)),
    artifact_0008: (/*@__PURE__*/$parcel$interopDefault($26227b4aa1e1c5ce$exports)),
    artifact_0009: (/*@__PURE__*/$parcel$interopDefault($8da801e1046435b1$exports)),
    artifact_0010: (/*@__PURE__*/$parcel$interopDefault($7d43edccf6ce0ac1$exports)),
    artifact_0011: (/*@__PURE__*/$parcel$interopDefault($edf2a85c05fe2e4c$exports)),
    fur69_chip: (/*@__PURE__*/$parcel$interopDefault($4d986e56f1d16607$exports)),
    fur70_chip: (/*@__PURE__*/$parcel$interopDefault($38fb9aa0dc3068a5$exports)),
    nm8_chip: (/*@__PURE__*/$parcel$interopDefault($10a5e1559393cac8$exports)),
    bk55_chip: (/*@__PURE__*/$parcel$interopDefault($043d8026255d3452$exports)),
    bk55_ii_chip: (/*@__PURE__*/$parcel$interopDefault($aa5e3b23661fed5e$exports))
};
const $1aa2c39fc1fbb95e$export$11c0038a143c3711 = {
    base_raid_attack_btn: (/*@__PURE__*/$parcel$interopDefault($3a2486e68d69d488$exports)),
    base_raid_back_to_home_btn: (/*@__PURE__*/$parcel$interopDefault($b7e83928f7617dab$exports)),
    base_raid_back_to_home_btn_gray: (/*@__PURE__*/$parcel$interopDefault($755ca188366e9a9a$exports)),
    base_raid_next_btn: (/*@__PURE__*/$parcel$interopDefault($82680e797c179fe6$exports)),
    base_raid_surrender_btn: (/*@__PURE__*/$parcel$interopDefault($3f4b83c0d4748c85$exports)),
    okay_button: (/*@__PURE__*/$parcel$interopDefault($050920d3c1ee3350$exports)),
    raid_result_banner: (/*@__PURE__*/$parcel$interopDefault($60cc6879b953092c$exports)),
    oh_no_text: (/*@__PURE__*/$parcel$interopDefault($f077734625facc3f$exports)),
    thank_heavens_text: (/*@__PURE__*/$parcel$interopDefault($40bd351daa105fb4$exports)),
    attack_log_tab: (/*@__PURE__*/$parcel$interopDefault($787b39f8f4a05bd7$exports)),
    attack_log_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($e674cb22314bf0ac$exports)),
    defense_log_tab: (/*@__PURE__*/$parcel$interopDefault($402e8ffd4cd2d2e5$exports)),
    defense_log_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($dd17d91572b1b1ec$exports)),
    back_to_homebase_button: (/*@__PURE__*/$parcel$interopDefault($76dade7508d0c61a$exports)),
    go_raiding_button: (/*@__PURE__*/$parcel$interopDefault($4e8df0e61c5f4989$exports))
};
const $1aa2c39fc1fbb95e$export$13b5492ca3439890 = {
    pvp_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e70441a2d03bcb5f$exports)),
    pvp_confirm_button: (/*@__PURE__*/$parcel$interopDefault($a7d97e893dd0a8bc$exports))
};
const $1aa2c39fc1fbb95e$export$e6bf8b311fe6eef6 = {
    loading_rect: (/*@__PURE__*/$parcel$interopDefault($32ef4e8a3e68ebe3$exports)),
    loading_prog_bar: (/*@__PURE__*/$parcel$interopDefault($db7bf2722d94283a$exports)),
    loading_prog_1: (/*@__PURE__*/$parcel$interopDefault($cc691702c3d21393$exports)),
    loading_prog_2: (/*@__PURE__*/$parcel$interopDefault($186b2efc2baa6adc$exports)),
    loading_prog_3: (/*@__PURE__*/$parcel$interopDefault($b4ab77cf0aed23bb$exports)),
    loading_prog_4: (/*@__PURE__*/$parcel$interopDefault($4e299be7159808fc$exports)),
    loading_prog_5: (/*@__PURE__*/$parcel$interopDefault($4530a769a02dd3fc$exports))
};
const $1aa2c39fc1fbb95e$export$d4d19d986b8fcaa2 = {
    base_raid_next_btn: (/*@__PURE__*/$parcel$interopDefault($82680e797c179fe6$exports)),
    base_raid_attack_btn: (/*@__PURE__*/$parcel$interopDefault($3a2486e68d69d488$exports)),
    base_raid_back_to_home_btn: (/*@__PURE__*/$parcel$interopDefault($b7e83928f7617dab$exports)),
    base_raid_back_to_home_btn_gray: (/*@__PURE__*/$parcel$interopDefault($755ca188366e9a9a$exports)),
    base_raid_surrender_btn: (/*@__PURE__*/$parcel$interopDefault($3f4b83c0d4748c85$exports))
};
const $1aa2c39fc1fbb95e$export$f3db403795e03c3b = {
    attack_log_tab: (/*@__PURE__*/$parcel$interopDefault($787b39f8f4a05bd7$exports)),
    attack_log_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($e674cb22314bf0ac$exports)),
    defense_log_tab: (/*@__PURE__*/$parcel$interopDefault($402e8ffd4cd2d2e5$exports)),
    defense_log_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($dd17d91572b1b1ec$exports)),
    back_to_homebase_button: (/*@__PURE__*/$parcel$interopDefault($76dade7508d0c61a$exports)),
    go_raiding_button: (/*@__PURE__*/$parcel$interopDefault($4e8df0e61c5f4989$exports))
};
const $1aa2c39fc1fbb95e$export$f6b70d869c907105 = {
    okay_button: (/*@__PURE__*/$parcel$interopDefault($050920d3c1ee3350$exports)),
    raid_result_banner: (/*@__PURE__*/$parcel$interopDefault($60cc6879b953092c$exports)),
    oh_no_text: (/*@__PURE__*/$parcel$interopDefault($f077734625facc3f$exports)),
    thank_heavens_text: (/*@__PURE__*/$parcel$interopDefault($40bd351daa105fb4$exports))
};
const $1aa2c39fc1fbb95e$export$2328bd5729fa76e5 = {
    bossfight_badge: (/*@__PURE__*/$parcel$interopDefault($183bbab7f82768ea$exports)),
    bossfight_title_text: (/*@__PURE__*/$parcel$interopDefault($6bd5a10f9e7f0abd$exports)),
    bossfight_divider: (/*@__PURE__*/$parcel$interopDefault($4dd390d0fe52eaf4$exports)),
    bossfight_status_not_started: (/*@__PURE__*/$parcel$interopDefault($b3f41d7f88cad393$exports)),
    bossfight_status_in_progress: (/*@__PURE__*/$parcel$interopDefault($5d6612854ff082c1$exports)),
    bossfight_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($c7c49b90d91c6efa$exports)),
    bossfight_you_are_ready_button: (/*@__PURE__*/$parcel$interopDefault($ff5a654b185ce0e5$exports)),
    bossfight_clock_icon: (/*@__PURE__*/$parcel$interopDefault($339f5531634ff8f4$exports)),
    bossfight_hp_icon: (/*@__PURE__*/$parcel$interopDefault($550d54cced66b562$exports)),
    bossfight_back_button: (/*@__PURE__*/$parcel$interopDefault($b8e3b9dfaaf6cd34$exports)),
    bossfight_notification_image: (/*@__PURE__*/$parcel$interopDefault($97e1f8bd97f61db3$exports)),
    bossfight_notification_later_button: (/*@__PURE__*/$parcel$interopDefault($543f21685925f4ad$exports)),
    bossfight_notification_letsgo_button: (/*@__PURE__*/$parcel$interopDefault($d269740a0e5649e7$exports)),
    bossfight_notification_title_text: (/*@__PURE__*/$parcel$interopDefault($08cd6fcb04a9aa9e$exports)),
    bossfight_battle_missed_image: (/*@__PURE__*/$parcel$interopDefault($36a4e578f028d681$exports)),
    bossfight_go_to_discord_button: (/*@__PURE__*/$parcel$interopDefault($d402e27bc832e603$exports)),
    bossfight_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($26649127fdfc1582$exports)),
    bossfight_defeat_return_home_button: (/*@__PURE__*/$parcel$interopDefault($35848fbafe7e1088$exports)),
    bossfight_defeat_title: (/*@__PURE__*/$parcel$interopDefault($a6c5dc8e00c2900b$exports)),
    bossfight_tweet_this_button: (/*@__PURE__*/$parcel$interopDefault($6a1b4ea910c74194$exports)),
    bossfight_victory_badge: (/*@__PURE__*/$parcel$interopDefault($ac6f4b648bce69b1$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    bossfight_victory_title: (/*@__PURE__*/$parcel$interopDefault($f366d696a4dc150b$exports)),
    bossfight_hud_go_to_battle_button: (/*@__PURE__*/$parcel$interopDefault($e9cf7b432f165e4a$exports)),
    bossfight_sit_out_button: (/*@__PURE__*/$parcel$interopDefault($44513d62c64905f4$exports)),
    bossfight_boss_common: (/*@__PURE__*/$parcel$interopDefault($e4eb5358929f49eb$exports)),
    bossfight_boss_epic: (/*@__PURE__*/$parcel$interopDefault($56dbb91da8de288d$exports)),
    bossfight_boss_rare: (/*@__PURE__*/$parcel$interopDefault($4bcc07e9101eea69$exports)),
    bossfight_boss_legendary: (/*@__PURE__*/$parcel$interopDefault($e3681516cbc631b1$exports)),
    bossfight_boss_mythical: (/*@__PURE__*/$parcel$interopDefault($ef94296d523c32cf$exports)),
    bossfight_damage_button: (/*@__PURE__*/$parcel$interopDefault($a1edaaeaa06c0060$exports)),
    bossfight_damage_button_inactive: (/*@__PURE__*/$parcel$interopDefault($b1b0fdeaef682cdc$exports)),
    bossfight_rounds_button: (/*@__PURE__*/$parcel$interopDefault($aff4175493016cf8$exports)),
    bossfight_rounds_button_inactive: (/*@__PURE__*/$parcel$interopDefault($4d81fb27314fd400$exports)),
    bossfight_space_elixir_button: (/*@__PURE__*/$parcel$interopDefault($e6c2ce2d060e441f$exports)),
    bossfight_space_elixir_button_inactive: (/*@__PURE__*/$parcel$interopDefault($e8c218b21733e15e$exports)),
    bossfight_neon_gold_button: (/*@__PURE__*/$parcel$interopDefault($a3ddcbed50901c0c$exports)),
    bossfight_neon_gold_button_inactive: (/*@__PURE__*/$parcel$interopDefault($7ff134c33e1daa03$exports)),
    bossfight_star_dust_button: (/*@__PURE__*/$parcel$interopDefault($4cce92ceedfcf959$exports)),
    bossfight_star_dust_button_inactive: (/*@__PURE__*/$parcel$interopDefault($b5fce86e8074c101$exports))
};
const $1aa2c39fc1fbb95e$export$ae4cf7f8491f730f = {
    level_circle: (/*@__PURE__*/$parcel$interopDefault($abe5584c3b9d65aa$exports)),
    level_text: (/*@__PURE__*/$parcel$interopDefault($0a79362e636b81b7$exports)),
    level_icon: (/*@__PURE__*/$parcel$interopDefault($126c435e56b4c901$exports)),
    level_prog_bar: (/*@__PURE__*/$parcel$interopDefault($15f6cf264ece0fe1$exports)),
    level_prog_shine: (/*@__PURE__*/$parcel$interopDefault($c4de446a19e9039e$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports)),
    stardust_prog_bar: (/*@__PURE__*/$parcel$interopDefault($ce116e3ba8cecc8e$exports)),
    stardust_prog_shine: (/*@__PURE__*/$parcel$interopDefault($b049fc5b65c3c3f0$exports)),
    bossfight_badge: (/*@__PURE__*/$parcel$interopDefault($183bbab7f82768ea$exports)),
    bossfight_title_text: (/*@__PURE__*/$parcel$interopDefault($6bd5a10f9e7f0abd$exports)),
    bossfight_divider: (/*@__PURE__*/$parcel$interopDefault($4dd390d0fe52eaf4$exports)),
    bossfight_status_not_started: (/*@__PURE__*/$parcel$interopDefault($b3f41d7f88cad393$exports)),
    bossfight_status_in_progress: (/*@__PURE__*/$parcel$interopDefault($5d6612854ff082c1$exports)),
    bossfight_clock_icon: (/*@__PURE__*/$parcel$interopDefault($339f5531634ff8f4$exports)),
    bossfight_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($c7c49b90d91c6efa$exports)),
    bossfight_you_are_ready_button: (/*@__PURE__*/$parcel$interopDefault($ff5a654b185ce0e5$exports)),
    bossfight_hp_icon: (/*@__PURE__*/$parcel$interopDefault($550d54cced66b562$exports)),
    bossfight_back_button: (/*@__PURE__*/$parcel$interopDefault($b8e3b9dfaaf6cd34$exports)),
    bossfight_sit_out_button: (/*@__PURE__*/$parcel$interopDefault($44513d62c64905f4$exports)),
    bossfight_boss_common: (/*@__PURE__*/$parcel$interopDefault($e4eb5358929f49eb$exports)),
    bossfight_boss_rare: (/*@__PURE__*/$parcel$interopDefault($4bcc07e9101eea69$exports)),
    bossfight_boss_epic: (/*@__PURE__*/$parcel$interopDefault($56dbb91da8de288d$exports)),
    bossfight_boss_legendary: (/*@__PURE__*/$parcel$interopDefault($e3681516cbc631b1$exports)),
    bossfight_boss_mythical: (/*@__PURE__*/$parcel$interopDefault($ef94296d523c32cf$exports))
};
const $1aa2c39fc1fbb95e$export$8e35485e4443b4ab = {
    bossfight_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($26649127fdfc1582$exports)),
    bossfight_defeat_title: (/*@__PURE__*/$parcel$interopDefault($a6c5dc8e00c2900b$exports)),
    bossfight_defeat_return_home_button: (/*@__PURE__*/$parcel$interopDefault($35848fbafe7e1088$exports)),
    battleroyale_view_results_button: (/*@__PURE__*/$parcel$interopDefault($bd7377fd34115939$exports))
};
const $1aa2c39fc1fbb95e$export$580998fdd520199e = {
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports))
};
const $1aa2c39fc1fbb95e$export$2399afebcbea323e = {
    battleroyale_results_divider: (/*@__PURE__*/$parcel$interopDefault($9b012232d4f5c81d$exports)),
    battleroyale_placing_button: (/*@__PURE__*/$parcel$interopDefault($b702af86506a0413$exports)),
    battleroyale_placing_button_inactive: (/*@__PURE__*/$parcel$interopDefault($674df338d68395ab$exports)),
    battleroyale_kills_button: (/*@__PURE__*/$parcel$interopDefault($5c8a1729ea5ec17f$exports)),
    battleroyale_kills_button_inactive: (/*@__PURE__*/$parcel$interopDefault($3301365f0e8619f5$exports)),
    battleroyale_evades_button: (/*@__PURE__*/$parcel$interopDefault($8a68941c71be8c4a$exports)),
    battleroyale_evades_button_inactive: (/*@__PURE__*/$parcel$interopDefault($49d70b16e96bcedd$exports)),
    battleroyale_suicides_button: (/*@__PURE__*/$parcel$interopDefault($f0665f0075b12192$exports)),
    battleroyale_suicides_button_inactive: (/*@__PURE__*/$parcel$interopDefault($c16756764c7d90d8$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    battleroyale_results_pane_divider: (/*@__PURE__*/$parcel$interopDefault($1e0f6bfc135a0167$exports)),
    bossfight_damage_button: (/*@__PURE__*/$parcel$interopDefault($a1edaaeaa06c0060$exports)),
    bossfight_damage_button_inactive: (/*@__PURE__*/$parcel$interopDefault($b1b0fdeaef682cdc$exports)),
    bossfight_rounds_button: (/*@__PURE__*/$parcel$interopDefault($aff4175493016cf8$exports)),
    bossfight_rounds_button_inactive: (/*@__PURE__*/$parcel$interopDefault($4d81fb27314fd400$exports)),
    bossfight_space_elixir_button: (/*@__PURE__*/$parcel$interopDefault($e6c2ce2d060e441f$exports)),
    bossfight_space_elixir_button_inactive: (/*@__PURE__*/$parcel$interopDefault($e8c218b21733e15e$exports)),
    bossfight_neon_gold_button: (/*@__PURE__*/$parcel$interopDefault($a3ddcbed50901c0c$exports)),
    bossfight_neon_gold_button_inactive: (/*@__PURE__*/$parcel$interopDefault($7ff134c33e1daa03$exports)),
    bossfight_star_dust_button: (/*@__PURE__*/$parcel$interopDefault($4cce92ceedfcf959$exports)),
    bossfight_star_dust_button_inactive: (/*@__PURE__*/$parcel$interopDefault($b5fce86e8074c101$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$c209f6ef1d95d3b4 = {
    bossfight_victory_badge: (/*@__PURE__*/$parcel$interopDefault($ac6f4b648bce69b1$exports)),
    bossfight_victory_title: (/*@__PURE__*/$parcel$interopDefault($f366d696a4dc150b$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    bossfight_tweet_this_button: (/*@__PURE__*/$parcel$interopDefault($6a1b4ea910c74194$exports)),
    battleroyale_view_results_button: (/*@__PURE__*/$parcel$interopDefault($bd7377fd34115939$exports))
};
const $1aa2c39fc1fbb95e$export$e7e7859328cf2591 = {
    bossfight_notification_image: (/*@__PURE__*/$parcel$interopDefault($97e1f8bd97f61db3$exports)),
    bossfight_notification_later_button: (/*@__PURE__*/$parcel$interopDefault($543f21685925f4ad$exports)),
    bossfight_notification_letsgo_button: (/*@__PURE__*/$parcel$interopDefault($d269740a0e5649e7$exports)),
    bossfight_notification_title_text: (/*@__PURE__*/$parcel$interopDefault($08cd6fcb04a9aa9e$exports))
};
const $1aa2c39fc1fbb95e$export$2556aa0fb1402c03 = {
    battleroyale_back_button: (/*@__PURE__*/$parcel$interopDefault($8851ad80fe4db867$exports)),
    battleroyale_badge: (/*@__PURE__*/$parcel$interopDefault($f07e65a946af479e$exports)),
    battleroyale_divider: (/*@__PURE__*/$parcel$interopDefault($2fa292e85c4714c8$exports)),
    battleroyale_game_bg: (/*@__PURE__*/$parcel$interopDefault($cec20b73c50580a1$exports)),
    battleroyale_join_bg: (/*@__PURE__*/$parcel$interopDefault($f47cc2a5a7075e1f$exports)),
    battleroyale_title_text: (/*@__PURE__*/$parcel$interopDefault($3be9092e29e873d1$exports)),
    bossfight_sit_out_button: (/*@__PURE__*/$parcel$interopDefault($44513d62c64905f4$exports)),
    battleroyale_results_pane_divider: (/*@__PURE__*/$parcel$interopDefault($1e0f6bfc135a0167$exports)),
    battleroyale_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($3e8660a9d61ce773$exports)),
    battleroyale_you_are_ready_button: (/*@__PURE__*/$parcel$interopDefault($bfac4a7efd4662ef$exports)),
    bossfight_clock_icon: (/*@__PURE__*/$parcel$interopDefault($339f5531634ff8f4$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports))
};
const $1aa2c39fc1fbb95e$export$5ba68ea21fea4e94 = {
    battleroyale_neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($e45d5c8ed9541ea4$exports)),
    battleroyale_space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($bc92535eb3f9a832$exports)),
    battleroyale_stardust_icon: (/*@__PURE__*/$parcel$interopDefault($4bdd90aca6383896$exports)),
    pvp_cancel_button: (/*@__PURE__*/$parcel$interopDefault($e70441a2d03bcb5f$exports)),
    pvp_confirm_button: (/*@__PURE__*/$parcel$interopDefault($a7d97e893dd0a8bc$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$16b2a7db5b493444 = {
    bossfight_victory_badge: (/*@__PURE__*/$parcel$interopDefault($ac6f4b648bce69b1$exports)),
    bossfight_victory_title: (/*@__PURE__*/$parcel$interopDefault($f366d696a4dc150b$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    bossfight_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($26649127fdfc1582$exports)),
    bossfight_defeat_title: (/*@__PURE__*/$parcel$interopDefault($a6c5dc8e00c2900b$exports)),
    battleroyale_view_results_button: (/*@__PURE__*/$parcel$interopDefault($bd7377fd34115939$exports))
};
const $1aa2c39fc1fbb95e$export$178b77bc36b4adf7 = {
    bossfight_victory_badge: (/*@__PURE__*/$parcel$interopDefault($ac6f4b648bce69b1$exports)),
    bossfight_victory_title: (/*@__PURE__*/$parcel$interopDefault($f366d696a4dc150b$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    bossfight_defeat_badge: (/*@__PURE__*/$parcel$interopDefault($26649127fdfc1582$exports)),
    bossfight_defeat_title: (/*@__PURE__*/$parcel$interopDefault($a6c5dc8e00c2900b$exports)),
    battleroyale_view_results_button: (/*@__PURE__*/$parcel$interopDefault($bd7377fd34115939$exports))
};
const $1aa2c39fc1fbb95e$export$5426087ae1039ec0 = {
    battleroyale_results_divider: (/*@__PURE__*/$parcel$interopDefault($9b012232d4f5c81d$exports)),
    battleroyale_placing_button: (/*@__PURE__*/$parcel$interopDefault($b702af86506a0413$exports)),
    battleroyale_placing_button_inactive: (/*@__PURE__*/$parcel$interopDefault($674df338d68395ab$exports)),
    battleroyale_kills_button: (/*@__PURE__*/$parcel$interopDefault($5c8a1729ea5ec17f$exports)),
    battleroyale_kills_button_inactive: (/*@__PURE__*/$parcel$interopDefault($3301365f0e8619f5$exports)),
    battleroyale_evades_button: (/*@__PURE__*/$parcel$interopDefault($8a68941c71be8c4a$exports)),
    battleroyale_evades_button_inactive: (/*@__PURE__*/$parcel$interopDefault($49d70b16e96bcedd$exports)),
    battleroyale_suicides_button: (/*@__PURE__*/$parcel$interopDefault($f0665f0075b12192$exports)),
    battleroyale_suicides_button_inactive: (/*@__PURE__*/$parcel$interopDefault($c16756764c7d90d8$exports)),
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports)),
    space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($3ff06241990e853f$exports)),
    neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($632929e199e68746$exports)),
    stardust_icon: (/*@__PURE__*/$parcel$interopDefault($c6536c0e1b335557$exports))
};
const $1aa2c39fc1fbb95e$export$6b05ab6b067cc0c6 = {
    bossfight_victory_return_home_button: (/*@__PURE__*/$parcel$interopDefault($c3010849c15a99b4$exports))
};
const $1aa2c39fc1fbb95e$export$cf87557e5793b920 = {
    hud_battle_royale_background: (/*@__PURE__*/$parcel$interopDefault($0674a9d8cdda4458$exports)),
    bossfight_notification_later_button: (/*@__PURE__*/$parcel$interopDefault($543f21685925f4ad$exports)),
    hud_battle_royale_ready_up_button: (/*@__PURE__*/$parcel$interopDefault($a73bc25cea830cf2$exports)),
    hud_battle_royale_view_button: (/*@__PURE__*/$parcel$interopDefault($2bb23131d4936e58$exports)),
    hud_battle_royale_text: (/*@__PURE__*/$parcel$interopDefault($4a0e694a2ad1f485$exports))
};
const $1aa2c39fc1fbb95e$export$bef64b52259dad30 = {
    army_tab_active: (/*@__PURE__*/$parcel$interopDefault($237d9f566dc30f1f$exports)),
    army_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($6ad5e9874acc5632$exports)),
    training_tab_active: (/*@__PURE__*/$parcel$interopDefault($ae7d296c4885ec14$exports)),
    training_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($f1c1b8c20dc94760$exports)),
    army_modal_close_button: (/*@__PURE__*/$parcel$interopDefault($a829ef0533fddab2$exports)),
    remove_troop_button: (/*@__PURE__*/$parcel$interopDefault($e76cf34426c6a656$exports)),
    troop_count_circle: (/*@__PURE__*/$parcel$interopDefault($84c735d7655d2768$exports)),
    capacity_icon_small: (/*@__PURE__*/$parcel$interopDefault($90051085bbae131f$exports)),
    dps_icon_small: (/*@__PURE__*/$parcel$interopDefault($54162465d41ce0e9$exports)),
    hps_icon_small: (/*@__PURE__*/$parcel$interopDefault($5e176f5898c37bb0$exports)),
    health_icon_small: (/*@__PURE__*/$parcel$interopDefault($e9b95abdddc4b6ef$exports)),
    time_icon_small: (/*@__PURE__*/$parcel$interopDefault($6520896c08694494$exports)),
    troops_ars: (/*@__PURE__*/$parcel$interopDefault($51630e771e7ad0f8$exports)),
    troops_healer: (/*@__PURE__*/$parcel$interopDefault($35d8fc5414653778$exports)),
    troops_mercenary: (/*@__PURE__*/$parcel$interopDefault($53278ab9b427c228$exports)),
    troops_super_swole: (/*@__PURE__*/$parcel$interopDefault($755daa5cd410b30e$exports)),
    troops_ars_small: (/*@__PURE__*/$parcel$interopDefault($547caa069b34eec4$exports)),
    troops_healer_small: (/*@__PURE__*/$parcel$interopDefault($e7e9b9af13f63cfc$exports)),
    troops_mercenary_small: (/*@__PURE__*/$parcel$interopDefault($a87231201bce33aa$exports)),
    troops_super_swole_small: (/*@__PURE__*/$parcel$interopDefault($36343753d610b3e8$exports)),
    all_tab_active: (/*@__PURE__*/$parcel$interopDefault($811dcdeed8b5f637$exports)),
    all_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($02d43139e26c9ec7$exports)),
    level_1_tab_active: (/*@__PURE__*/$parcel$interopDefault($47fc3ead00368688$exports)),
    level_1_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($b0e0dc78313d83a8$exports)),
    level_2_tab_active: (/*@__PURE__*/$parcel$interopDefault($4f9e976359703515$exports)),
    level_2_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($3538e5469ff946ef$exports)),
    level_3_tab_active: (/*@__PURE__*/$parcel$interopDefault($b981b64a88fec159$exports)),
    level_3_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($9ddc565dad6426e3$exports)),
    level_4_tab_active: (/*@__PURE__*/$parcel$interopDefault($71e48e084c58a511$exports)),
    level_4_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($3d72dd98cc7dc722$exports)),
    level_5_tab_active: (/*@__PURE__*/$parcel$interopDefault($9209f82f78c0a5ca$exports)),
    level_5_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($d87d248c7384484b$exports)),
    level_6_tab_active: (/*@__PURE__*/$parcel$interopDefault($8254fb3e9c110cb8$exports)),
    level_6_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($7858d6088c4c5428$exports)),
    level_7_tab_active: (/*@__PURE__*/$parcel$interopDefault($8738a6280d3ae708$exports)),
    level_7_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($5e6281bbd2670242$exports)),
    level_8_tab_active: (/*@__PURE__*/$parcel$interopDefault($7302b2f74461eb1b$exports)),
    level_8_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($bb4a77c34b8b3e76$exports)),
    level_9_tab_active: (/*@__PURE__*/$parcel$interopDefault($8cca79c3c62f03d5$exports)),
    level_9_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($2d34010c18ef8465$exports)),
    level_10_tab_active: (/*@__PURE__*/$parcel$interopDefault($74344a29082a0bdd$exports)),
    level_10_tab_inactive: (/*@__PURE__*/$parcel$interopDefault($3b7474278ee695f3$exports)),
    train_1_active: (/*@__PURE__*/$parcel$interopDefault($ae0d8c34ddd8db0d$exports)),
    train_5_active: (/*@__PURE__*/$parcel$interopDefault($e270055e1c25fdaa$exports)),
    train_10_active: (/*@__PURE__*/$parcel$interopDefault($613b963614dd721d$exports)),
    train_20_active: (/*@__PURE__*/$parcel$interopDefault($6f0b91e8f0b987f8$exports)),
    train_50_active: (/*@__PURE__*/$parcel$interopDefault($28b3090886bc3bce$exports)),
    train_100_active: (/*@__PURE__*/$parcel$interopDefault($e6f478f9a6681ad2$exports)),
    train_1_inactive: (/*@__PURE__*/$parcel$interopDefault($b59cc85be825a80e$exports)),
    train_5_inactive: (/*@__PURE__*/$parcel$interopDefault($e8fde4d7487b0bd3$exports)),
    train_10_inactive: (/*@__PURE__*/$parcel$interopDefault($7bb63a1e33a698d5$exports)),
    train_20_inactive: (/*@__PURE__*/$parcel$interopDefault($c4e791156161d7a0$exports)),
    train_50_inactive: (/*@__PURE__*/$parcel$interopDefault($dc41a901af6d4ca7$exports)),
    train_100_inactive: (/*@__PURE__*/$parcel$interopDefault($9e6f8721665b2ff4$exports)),
    capacity_icon: (/*@__PURE__*/$parcel$interopDefault($0bee91d379d56125$exports)),
    dashboard_divider: (/*@__PURE__*/$parcel$interopDefault($d330e5c9d74c0c09$exports))
};
const $1aa2c39fc1fbb95e$export$9942a5e7f80a7b1f = {
    battlepass_background: (/*@__PURE__*/$parcel$interopDefault($ddc685d403726a51$exports)),
    battlepass_active_button: (/*@__PURE__*/$parcel$interopDefault($f9752681dfb56ca3$exports)),
    battlepass_inactive_button: (/*@__PURE__*/$parcel$interopDefault($f7d85f15e66b1914$exports)),
    battlepass_raffle_active_button: (/*@__PURE__*/$parcel$interopDefault($4cc7bd8b220ebdc2$exports)),
    battlepass_raffle_inactive_button: (/*@__PURE__*/$parcel$interopDefault($efc2b4bc5b3f5e7c$exports)),
    battlepass_home_button: (/*@__PURE__*/$parcel$interopDefault($565eb55c83973d44$exports)),
    battlepass_next_page_button_active: (/*@__PURE__*/$parcel$interopDefault($5b5230f76d140ee5$exports)),
    battlepass_previous_page_button_active: (/*@__PURE__*/$parcel$interopDefault($d5dca254edbf80d4$exports)),
    battlepass_unlocked: (/*@__PURE__*/$parcel$interopDefault($12b49eb76c9f5f76$exports)),
    battlepass_raffle_rock: (/*@__PURE__*/$parcel$interopDefault($2f9c8b68afa95b9e$exports)),
    battlepass_chapter: (/*@__PURE__*/$parcel$interopDefault($1cc3db660c79a611$exports)),
    battlepass_season: (/*@__PURE__*/$parcel$interopDefault($ab958b78040d03d6$exports)),
    battlepass_xp_component_divider: (/*@__PURE__*/$parcel$interopDefault($8101c967191cc69c$exports)),
    battlepass_present: (/*@__PURE__*/$parcel$interopDefault($e8324986702b0306$exports)),
    battlepass_assign_button: (/*@__PURE__*/$parcel$interopDefault($2b84c56f1a4f4811$exports)),
    battlepass_assign_all_button: (/*@__PURE__*/$parcel$interopDefault($0d69055a1eeda954$exports)),
    battlepass_mini_rock: (/*@__PURE__*/$parcel$interopDefault($5d2c0c402edfb2eb$exports)),
    battlepass_claim_button_active: (/*@__PURE__*/$parcel$interopDefault($e700bade35079516$exports)),
    battlepass_claim_button_inactive: (/*@__PURE__*/$parcel$interopDefault($a31d7d1ff1f732e7$exports)),
    battlepass_claimed_button: (/*@__PURE__*/$parcel$interopDefault($f52971aeb6fd0578$exports)),
    raffle_rock_icon: (/*@__PURE__*/$parcel$interopDefault($af401b09a960b2b2$exports)),
    bk55_icon: (/*@__PURE__*/$parcel$interopDefault($f53ba20ead214b2f$exports)),
    nm8_icon: (/*@__PURE__*/$parcel$interopDefault($c81595d9284dbe44$exports)),
    xp_icon: (/*@__PURE__*/$parcel$interopDefault($168c31dd1f404834$exports)),
    bp_neon_gold_icon: (/*@__PURE__*/$parcel$interopDefault($184a5adfbd1ee28b$exports)),
    bp_space_elixir_icon: (/*@__PURE__*/$parcel$interopDefault($d2c5c4b66ca3e030$exports)),
    bp_stardust_icon: (/*@__PURE__*/$parcel$interopDefault($5ea37a88d54e1206$exports)),
    fur_chip_icon: (/*@__PURE__*/$parcel$interopDefault($6f801bdf7728b536$exports)),
    bronze_pack_icon: (/*@__PURE__*/$parcel$interopDefault($705d08aed4eeca14$exports)),
    silver_pack_icon: (/*@__PURE__*/$parcel$interopDefault($275a89ca1dd90f7d$exports)),
    gold_pack_icon: (/*@__PURE__*/$parcel$interopDefault($2e5dba3492219b55$exports)),
    rare_pack_icon: (/*@__PURE__*/$parcel$interopDefault($b31ffeb76e1d1ec0$exports)),
    epic_pack_icon: (/*@__PURE__*/$parcel$interopDefault($7901a8f745a26dc0$exports)),
    legendary_pack_icon: (/*@__PURE__*/$parcel$interopDefault($4a2233be6c6a9ddf$exports)),
    mythical_pack_icon: (/*@__PURE__*/$parcel$interopDefault($0f0afb177dbf0fa5$exports)),
    cadet_dorm_icon: (/*@__PURE__*/$parcel$interopDefault($6398f65daf157ec5$exports)),
    plasma_mortor_icon: (/*@__PURE__*/$parcel$interopDefault($bcdc00e134a16aea$exports)),
    sw_hoodie_icon: (/*@__PURE__*/$parcel$interopDefault($786b0efd9f05d486$exports)),
    blob_consmetic_icon: (/*@__PURE__*/$parcel$interopDefault($99ac8ee269b53252$exports)),
    fire_storm_tracker_cosmetic: (/*@__PURE__*/$parcel$interopDefault($c1addaa19e9effab$exports)),
    ice_storm_tracker_cosmetic: (/*@__PURE__*/$parcel$interopDefault($a58bc37b91f124b1$exports)),
    gold_plasma_cannon_skin: (/*@__PURE__*/$parcel$interopDefault($2908516861a8686f$exports)),
    water_cooler_cosmetic_icon: (/*@__PURE__*/$parcel$interopDefault($204e1b011fdb40ef$exports)),
    little_piece_of_home_cosmetic: (/*@__PURE__*/$parcel$interopDefault($e9e15c4b69a6064a$exports)),
    star_wolvez_helmet_cosmetic: (/*@__PURE__*/$parcel$interopDefault($cf437fad9f39f67f$exports)),
    squad_confirm_button: (/*@__PURE__*/$parcel$interopDefault($474dcbcf3984a9c1$exports))
};
const $1aa2c39fc1fbb95e$export$f615f228783efcde = {
    battlepass_back_button: (/*@__PURE__*/$parcel$interopDefault($feac0c89eae71a94$exports)),
    battlepass_background_image: (/*@__PURE__*/$parcel$interopDefault($5fa7b54ccf5bd98e$exports)),
    battlepass_buy_button: (/*@__PURE__*/$parcel$interopDefault($a1fbfee7e8fcfc63$exports)),
    battlepass_buy_button_glfhers: (/*@__PURE__*/$parcel$interopDefault($528777842579f4d4$exports)),
    battlepass_explore_button: (/*@__PURE__*/$parcel$interopDefault($308b365d82c43444$exports)),
    battlepass_season_image: (/*@__PURE__*/$parcel$interopDefault($22d501ef5fb47a08$exports)),
    battlepass_season_text: (/*@__PURE__*/$parcel$interopDefault($6e708bd5148b04f8$exports))
};
const $1aa2c39fc1fbb95e$export$afdd050f6270ccc4 = {
    battlepass_season_image: (/*@__PURE__*/$parcel$interopDefault($22d501ef5fb47a08$exports)),
    battlepass_buy_success_background: (/*@__PURE__*/$parcel$interopDefault($459057211da8c415$exports)),
    battlepass_homebase_button: (/*@__PURE__*/$parcel$interopDefault($895d81f7ffaf7db4$exports)),
    battlepass_explore_button: (/*@__PURE__*/$parcel$interopDefault($308b365d82c43444$exports)),
    battlepass_success_info_text: (/*@__PURE__*/$parcel$interopDefault($7bc258b94eefad3f$exports)),
    battlepass_success_text: (/*@__PURE__*/$parcel$interopDefault($784ab7f8338be978$exports))
};
const $1aa2c39fc1fbb95e$export$5319886d774f0b28 = {
    starwolvez_bolt_logo: (/*@__PURE__*/$parcel$interopDefault($4358bd2a73d296ac$exports)),
    starwolf_silhouette: (/*@__PURE__*/$parcel$interopDefault($d371b1c7d5d6886d$exports)),
    chest_icon_large: (/*@__PURE__*/$parcel$interopDefault($1d881b694d7e5150$exports)),
    neon_gold_icon_large: (/*@__PURE__*/$parcel$interopDefault($ffa924ffb865fbe4$exports)),
    space_elixir_icon_large: (/*@__PURE__*/$parcel$interopDefault($e802220e3a7bc634$exports)),
    hp_icon_large: (/*@__PURE__*/$parcel$interopDefault($f0fbcba4aa0ae92e$exports)),
    dps_icon_large: (/*@__PURE__*/$parcel$interopDefault($c15011977e8f3816$exports)),
    stardust_icon_large: (/*@__PURE__*/$parcel$interopDefault($f823c2268fdd6202$exports)),
    dark_matter_icon_large: (/*@__PURE__*/$parcel$interopDefault($04e23b19fd9fbea6$exports)),
    wl_icon_large: (/*@__PURE__*/$parcel$interopDefault($6d5cb8f3e85371b4$exports)),
    party_blob: (/*@__PURE__*/$parcel$interopDefault($62bf4b8f4b7aa6e0$exports))
};


function $e29d3e9b5d8af317$export$f0c7b4edffcddede(scene, assetObject, ignoreList) {
    if (assetObject) {
        var keys = Object.keys(assetObject);
        if (ignoreList) keys = Object.keys(assetObject).filter((key)=>!ignoreList.includes(key));
        keys.forEach((assetName)=>{
            scene.load.image(assetName, assetObject[assetName]);
        });
        return;
    }
}
function $e29d3e9b5d8af317$export$d3735b429a1c7a52(scene, assetObject, imageKeys, ignoreList) {
    if (imageKeys && imageKeys.length > 0) {
        var keys = imageKeys;
        if (ignoreList) keys = imageKeys.filter((key)=>!ignoreList.includes(key));
        console.log(`Unloading ${keys.toString()}`);
        keys.forEach((assetName)=>{
            scene.load.image(assetName, assetObject[assetName]);
        });
    }
}
function $e29d3e9b5d8af317$export$6d44be7cfb6bbf34(scene, keys) {
    console.log(`Unloading ${keys.toString()}`);
    keys.forEach((key)=>{
        scene.textures.remove(key);
    });
}
function $e29d3e9b5d8af317$export$91c11d74e81f7858(scene, keys) {
    console.log(`Unloading ${keys.toString()}`);
    keys.forEach((key)=>{
        scene.cache.audio.remove(key);
    });
}
function $e29d3e9b5d8af317$export$f40594dc5004abe6(scene, keys) {
    console.log(`Unloading ${keys.toString()}`);
    keys.forEach((key)=>{
        scene.cache.json.remove(key);
    });
}


var $9305be8412c9897f$exports = {};
$9305be8412c9897f$exports = new URL("homebase_map_64_blob_test.d4d156fc.json", import.meta.url).toString();


class $d8b90403e2e18020$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("Preloader");
    }
    preload() {
        // Font
        this.load.bitmapFont("cc_outline", "assets/fonts/cc_outline_0.png", "assets/fonts/cc_outline.xml");
        // Map assets
        this.load.image("tiles", (0, (/*@__PURE__*/$parcel$interopDefault($801a11af1a79006d$exports))));
        this.load.tilemapTiledJSON("homebase_map", $9305be8412c9897f$exports);
        // Shared Assets
        const ignoreList = [
            "party_blob"
        ];
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$5319886d774f0b28), ignoreList);
        // Loading Indicator Sprite
        this.load.spritesheet("party_blob", (0, $1aa2c39fc1fbb95e$export$5319886d774f0b28).party_blob, {
            frameWidth: 180,
            frameHeight: 180,
            endFrame: 7
        });
        // Modals
        this.load.image("mining_return_home_button", (0, $1aa2c39fc1fbb95e$export$538ba78e0dbb1045).mining_return_home_button);
        this.load.image("leaderboard_icon", (0, $1aa2c39fc1fbb95e$export$f4c0b61e75a7e807).leaderboard_icon);
        this.load.image("time_icon", (0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f).time_icon);
        this.load.image("hp_icon", (0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f).hp_icon);
        this.load.image("dps_icon", (0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f).dps_icon);
        this.load.image("trophy_icon_small", (0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f).trophy_icon_small);
        this.load.image("modal_close_button", (0, $1aa2c39fc1fbb95e$export$60ce8cc956a8f1b0).modal_close_button);
        this.load.image("troops_ars", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_ars);
        this.load.image("troops_healer", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_healer);
        this.load.image("troops_mercenary", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_mercenary);
        this.load.image("troops_super_swole", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_super_swole);
        this.load.image("troops_ars_small", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_ars_small);
        this.load.image("troops_healer_small", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_healer_small);
        this.load.image("troops_mercenary_small", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_mercenary_small);
        this.load.image("troops_super_swole_small", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).troops_super_swole_small);
    }
    create() {
        window.addEventListener("resize", ()=>{
            var canvas = document.querySelector("canvas");
            if (canvas) {
                canvas.style.width = window.innerWidth + "px";
                canvas.style.height = window.innerHeight + "px";
                this.game.scale.resize(window.innerWidth, window.innerHeight);
            }
            if (this.scene.get("HudScene").scene.isActive()) this.scene.get("HudScene").scene.restart();
            if (this.scene.get("BaseRaidHudScene").scene.isActive()) this.scene.get("BaseRaidHudScene").restartScene();
        }, false);
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") {
                if (this.scene.get("HudScene").scene.isActive()) this.scene.get("HudScene").onTabbedOut();
                if (this.scene.get("BossFightScene").scene.isActive()) this.scene.get("BossFightScene").onTabbedOut();
                if (this.scene.get("BattleRoyaleScene").scene.isActive()) this.scene.get("BattleRoyaleScene").onTabbedOut();
            } else {
                // Update Machines
                if (this.scene.get("HomebaseScene").scene.isActive() && !this.scene.get("HomebaseScene").isInBlobRoom()) this.scene.get("HomebaseScene").updateMachines(true);
                if (this.scene.get("BaseRaidHudScene").scene.isActive()) this.scene.get("BaseRaidHudScene").restartScene();
                if (this.scene.get("HudScene").scene.isActive()) this.scene.get("HudScene").onTabbedIn();
                if (this.scene.get("BossFightScene").scene.isActive()) this.scene.get("BossFightScene").onTabbedIn();
                if (this.scene.get("BattleRoyaleScene").scene.isActive()) this.scene.get("BattleRoyaleScene").onTabbedIn();
            }
        }, false);
        this.scene.stop("StartScene");
        this.scene.start("LoginScene");
    // this.scene.start('PackOpeningScene', {
    //   packType: 'rare_pack',
    //   loot_pack_info: [
    //     {
    //       loot_pack_reward_id: 1,
    //       rarity_type: 1,
    //       currency_id: 1,
    //       currency_value: 50000,
    //       shop_item_id: 0,
    //       nft_id: 0,
    //       prob_start: '0.00',
    //       prob_end: '20.00',
    //       reward_name: '50000 Neon Gold',
    //     },
    //     {
    //       loot_pack_reward_id: 2,
    //       rarity_type: 1,
    //       currency_id: 2,
    //       currency_value: 50000,
    //       shop_item_id: 0,
    //       nft_id: 0,
    //       prob_start: '20.00',
    //       prob_end: '40.00',
    //       reward_name: '50000 Space Elixir',
    //     },
    //   ],
    // });
    }
}














































































































const $c86a148e41b56706$export$86d43a1ff1212ba2 = (0, $08d93d5418ad866f$export$2e2bcd8739ae039);


var $a589f8dc1045cfaf$export$eb5ccdbd077479c;
(function(GameState) {
    GameState[GameState["PreGame"] = 0] = "PreGame";
    GameState[GameState["PreRound"] = 1] = "PreRound";
    GameState[GameState["Round"] = 2] = "Round";
    GameState[GameState["ProcessResults"] = 3] = "ProcessResults";
    GameState[GameState["DisplayResults"] = 4] = "DisplayResults";
    GameState[GameState["Finished"] = 5] = "Finished";
})($a589f8dc1045cfaf$export$eb5ccdbd077479c || ($a589f8dc1045cfaf$export$eb5ccdbd077479c = {}));



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $702e4d306615a028$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $702e4d306615a028$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $702e4d306615a028$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $702e4d306615a028$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $702e4d306615a028$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $702e4d306615a028$export$45d3717a4c69092e(o, m, p);
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $702e4d306615a028$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $702e4d306615a028$export$45d3717a4c69092e(result, mod, k);
    }
    $702e4d306615a028$var$__setModuleDefault(result, mod);
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $702e4d306615a028$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $702e4d306615a028$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $702e4d306615a028$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $702e4d306615a028$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $702e4d306615a028$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $702e4d306615a028$export$2e2bcd8739ae039 = {
    __extends: $702e4d306615a028$export$a8ba968b8961cb8a,
    __assign: $702e4d306615a028$export$18ce0697a983be9b,
    __rest: $702e4d306615a028$export$3c9a16f847548506,
    __decorate: $702e4d306615a028$export$29e00dfd3077644b,
    __param: $702e4d306615a028$export$d5ad3fd78186038f,
    __metadata: $702e4d306615a028$export$f1db080c865becb9,
    __awaiter: $702e4d306615a028$export$1050f835b63b671e,
    __generator: $702e4d306615a028$export$67ebef60e6f28a6,
    __createBinding: $702e4d306615a028$export$45d3717a4c69092e,
    __exportStar: $702e4d306615a028$export$f33643c0debef087,
    __values: $702e4d306615a028$export$19a8beecd37a4c45,
    __read: $702e4d306615a028$export$8d051b38c9118094,
    __spread: $702e4d306615a028$export$afc72e2116322959,
    __spreadArrays: $702e4d306615a028$export$6388937ca91ccae8,
    __spreadArray: $702e4d306615a028$export$1216008129fb82ed,
    __await: $702e4d306615a028$export$10c90e4f7922046c,
    __asyncGenerator: $702e4d306615a028$export$e427f37a30a4de9b,
    __asyncDelegator: $702e4d306615a028$export$bbd80228419bb833,
    __asyncValues: $702e4d306615a028$export$e3b29a3d6162315f,
    __makeTemplateObject: $702e4d306615a028$export$4fb47efe1390b86f,
    __importStar: $702e4d306615a028$export$c21735bcef00d192,
    __importDefault: $702e4d306615a028$export$da59b14a69baef04,
    __classPrivateFieldGet: $702e4d306615a028$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $702e4d306615a028$export$d40a35129aaff81f,
    __classPrivateFieldIn: $702e4d306615a028$export$81fdc39f203e4e04,
    __addDisposableResource: $702e4d306615a028$export$88ac25d8e944e405,
    __disposeResources: $702e4d306615a028$export$8f076105dc360e92
};



function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $702e4d306615a028$export$1216008129fb82ed)((0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(errors)), (0, $702e4d306615a028$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


const $4781ea40e0965510$var$defaultOverScale = 1.01;
const $4781ea40e0965510$var$useOverScaleDefault = true;
const $4781ea40e0965510$var$tintColor = 0xcdcdcd;
class $4781ea40e0965510$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image {
    constructor(scene, x, y, texture, useOverScaling, overScale, cursor, previousCursor){
        super(scene, x, y, texture);
        this.clickSubject = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        this.upTexture = texture;
        this.downTexture = texture;
        this.overTexture = texture;
        this.disabledTexture = texture;
        this.useOverScaling = useOverScaling === undefined || useOverScaling === null ? $4781ea40e0965510$var$useOverScaleDefault : useOverScaling;
        this.overScale = overScale === undefined || overScale === null ? $4781ea40e0965510$var$defaultOverScale : overScale;
        this._cursor = cursor || "pointer";
        this._previousCursor = previousCursor || "default";
        this._disabled = false;
        this.setInteractive().on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, this.handleUp, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, this.handleOut, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleDown, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.handleOver, this);
    }
    destroy(fromScene = false) {
        this.clickSubject.complete();
        super.destroy(fromScene);
    }
    onClick() {
        return this.clickSubject.asObservable();
    }
    setUpTexture(texture) {
        this.upTexture = texture;
        return this;
    }
    setDownTexture(texture) {
        this.downTexture = texture;
        return this;
    }
    setOverTexture(texture) {
        this.overTexture = texture;
        return this;
    }
    setDisabledTexture(texture) {
        this.disabledTexture = texture;
        return this;
    }
    setDisabled(disabled) {
        if (disabled) {
            this.setTexture(this.disabledTexture);
            this.disableInteractive();
            this._disabled = disabled;
            return this;
        }
        this.setTexture(this.upTexture);
        this.setInteractive();
        this._disabled = disabled;
        return this;
    }
    setOverScale(scale) {
        this.overScale = scale;
        return this;
    }
    setUseOverScaling(useOverGrowth) {
        this.useOverScaling = useOverGrowth;
        return this;
    }
    handleUp(pointer) {
        if (this._disabled) return;
        this.handleOver(pointer);
        this.clickSubject.next(pointer);
    }
    handleOut(pointer) {
        if (this._disabled) return;
        this.scene.input.manager.canvas.style.cursor = this._previousCursor;
        this.handleDown(pointer);
    }
    handleDown(pointer) {
        if (this._disabled) return;
        if (this.useOverScaling) this.setScale(this.scaleX / this.overScale);
        else {
            this.setAlpha(1);
            this.clearTint();
        }
    }
    handleOver(pointer) {
        if (this._disabled) return;
        this.scene.input.manager.canvas.style.cursor = this._cursor;
        if (this.useOverScaling) this.setScale(this.scaleX * this.overScale);
        else this.setTint($4781ea40e0965510$var$tintColor);
    }
}



const $e1cf0cb7989516d0$var$config = {
    config: {
        api: {
            base: "https://api.starwolvez.com",
            endpoints: {
                base_raid: {
                    path: "/base_raid/"
                },
                user: {
                    path: "/user/"
                },
                nfts: {
                    path: "/nfts/",
                    refresh_route: "from_marketplace",
                    cache_route: "all"
                },
                objectives: {
                    path: "/objectives/"
                },
                login: {
                    path: "/login/"
                },
                staking: {
                    path: "/staking/"
                },
                machines: {
                    path: "/machines/"
                },
                squad: {
                    path: "/squad/"
                },
                pvp_battle: {
                    path: "/pvp_battle/"
                },
                shop: {
                    path: "/shop/"
                },
                mining: {
                    path: "/mining/"
                },
                rewards: {
                    path: "/rewards/"
                },
                blobs: {
                    path: "/blobs/"
                },
                battle_pass: {
                    path: "/battle_pass/"
                },
                resources: {
                    path: "/resources/"
                }
            }
        },
        websockets: {
            base: "wss://api.starwolvez.com",
            pvp: {
                path: "/pvp"
            },
            pve: {
                path: "/pve"
            },
            bossfight: {
                path: "/bossfight"
            },
            battleroyale: {
                path: "/battleroyale"
            }
        },
        collections: [
            {
                displayName: "Star Wolvez",
                collectionSlugs: [
                    "starwolvez-generative",
                    "starwolves"
                ]
            },
            {
                displayName: "Galactic Apes",
                collectionSlugs: [
                    "gapes-nft",
                    "galacticapes",
                    "galacticapesgenesis"
                ]
            },
            {
                displayName: "Galactic Monkes",
                collectionSlugs: [
                    "galacticmonkes"
                ]
            },
            {
                displayName: "0N1 Force",
                collectionSlugs: [
                    "0n1-force"
                ]
            },
            {
                displayName: "a KID called BEAST",
                collectionSlugs: [
                    "akidcalledbeast"
                ]
            },
            {
                displayName: "acrocalypse",
                collectionSlugs: [
                    "acrocalypse"
                ]
            },
            {
                displayName: "AIC",
                collectionSlugs: [
                    "aicgenesis",
                    "operatives"
                ]
            },
            {
                displayName: "Anonymice",
                collectionSlugs: [
                    "anonymice"
                ]
            },
            {
                displayName: "Ape Gang",
                collectionSlugs: [
                    "ape-gang"
                ]
            },
            {
                displayName: "Ape Reunion",
                collectionSlugs: [
                    "apereunion"
                ]
            },
            {
                displayName: "Azuki",
                collectionSlugs: [
                    "azuki"
                ]
            },
            {
                displayName: "Azuki Elementals",
                collectionSlugs: [
                    "azukielementals"
                ]
            },
            {
                displayName: "BASTARD GAN PUNKS V2",
                collectionSlugs: [
                    "bastard-gan-punks-v2"
                ]
            },
            {
                displayName: "Bears Deluxe",
                collectionSlugs: [
                    "bears-deluxe"
                ]
            },
            {
                displayName: "BearX",
                collectionSlugs: [
                    "bearxlabs"
                ]
            },
            {
                displayName: "BEASTS Genesis",
                collectionSlugs: [
                    "beastsgenesis"
                ]
            },
            {
                displayName: "Bored Ape Kennel Club",
                collectionSlugs: [
                    "bored-ape-kennel-club"
                ]
            },
            {
                displayName: "Bored Ape Yacht Club",
                collectionSlugs: [
                    "boredapeyachtclub"
                ]
            },
            {
                displayName: "Brawler Bearz",
                collectionSlugs: [
                    "brawler-bearz"
                ]
            },
            {
                displayName: "Casual Sloths Official",
                collectionSlugs: [
                    "casual-sloths-official"
                ]
            },
            {
                displayName: "Chain Runners",
                collectionSlugs: [
                    "chain-runners-nft"
                ]
            },
            {
                displayName: "Chimpers",
                collectionSlugs: [
                    "chimpersnft"
                ]
            },
            {
                displayName: "Chompies",
                collectionSlugs: [
                    "chompiesnft"
                ]
            },
            {
                displayName: "Creepz by OVERLORD",
                collectionSlugs: [
                    "genesis-creepz"
                ]
            },
            {
                displayName: "Cryptoadz",
                collectionSlugs: [
                    "cryptoadz-by-gremplin"
                ]
            },
            {
                displayName: "Cyber Turtles",
                collectionSlugs: [
                    "cyberturtles-genesis"
                ]
            },
            {
                displayName: "CyberKongz (Babies)",
                collectionSlugs: [
                    "cyberkongz-babies"
                ]
            },
            {
                displayName: "CyberKongz VX",
                collectionSlugs: [
                    "cyberkongz-vx"
                ]
            },
            {
                displayName: "Dimension X",
                collectionSlugs: [
                    "dimensionx"
                ]
            },
            {
                displayName: "Dizzy Demons",
                collectionSlugs: [
                    "dizzydemons"
                ]
            },
            {
                displayName: "Dizzy Dragons",
                collectionSlugs: [
                    "dizzydragons"
                ]
            },
            {
                displayName: "Doodles Original Collection",
                collectionSlugs: [
                    "doodles-official"
                ]
            },
            {
                displayName: "Dormant Dragons",
                collectionSlugs: [
                    "official-dormant-dragons"
                ]
            },
            {
                displayName: "DystoApes",
                collectionSlugs: [
                    "dystoapez-official"
                ]
            },
            {
                displayName: "Ether Orcs",
                collectionSlugs: [
                    "ether-orcs"
                ]
            },
            {
                displayName: "EtherOrcsOfficial",
                collectionSlugs: [
                    "etherorcsallies"
                ]
            },
            {
                displayName: "Ethlizards",
                collectionSlugs: [
                    "ethlizards"
                ]
            },
            {
                displayName: "FishBallerz",
                collectionSlugs: [
                    "fishballerz"
                ]
            },
            {
                displayName: "Forgotten Runes Wizards Cult",
                collectionSlugs: [
                    "forgottenruneswizardscult"
                ]
            },
            {
                displayName: "Freckle Forever Pass",
                collectionSlugs: [
                    "freckle-forever-pass"
                ]
            },
            {
                displayName: "Freckle Gold Pass",
                collectionSlugs: [
                    "freckle-gold-pass"
                ]
            },
            {
                displayName: "Genuine Undead",
                collectionSlugs: [
                    "genuine-undead"
                ]
            },
            {
                displayName: "Ghost Child: Bones",
                collectionSlugs: [
                    "ghostchildbones"
                ]
            },
            {
                displayName: "GLHFers",
                collectionSlugs: [
                    "glhfers"
                ]
            },
            {
                displayName: "goblintown.wtf",
                collectionSlugs: [
                    "goblintownwtf"
                ]
            },
            {
                displayName: "Habibiz",
                collectionSlugs: [
                    "thehabibiz"
                ]
            },
            {
                displayName: "Kaiju Kingz",
                collectionSlugs: [
                    "kaiju-kingz"
                ]
            },
            {
                displayName: "Kaiju Mutants NFT",
                collectionSlugs: [
                    "kaijumutant"
                ]
            },
            {
                displayName: "KingFrogs",
                collectionSlugs: [
                    "kingfrogs"
                ]
            },
            {
                displayName: "Koin Games Dev Squad",
                collectionSlugs: [
                    "kgds"
                ]
            },
            {
                displayName: "KPR",
                collectionSlugs: [
                    "kprverse"
                ]
            },
            {
                displayName: "Kuma Cub",
                collectionSlugs: [
                    "kumacub"
                ]
            },
            {
                displayName: "Kuma Toys",
                collectionSlugs: [
                    "kumatoys"
                ]
            },
            {
                displayName: "Kumaverse",
                collectionSlugs: [
                    "kumaverse"
                ]
            },
            {
                displayName: "Lil Pudgys",
                collectionSlugs: [
                    "lilpudgys"
                ]
            },
            {
                displayName: "Little Lemon Friends",
                collectionSlugs: [
                    "little-lemon-friends"
                ]
            },
            {
                displayName: "Llamaverse Genesis",
                collectionSlugs: [
                    "llamaverse-genesis"
                ]
            },
            {
                displayName: "Magna",
                collectionSlugs: [
                    "magna-1"
                ]
            },
            {
                displayName: "Master Cats NFT",
                collectionSlugs: [
                    "mastercatsnft"
                ]
            },
            {
                displayName: "MetaHero: Generative Identities",
                collectionSlugs: [
                    "metahero-generative"
                ]
            },
            {
                displayName: "Metaverse HQ",
                collectionSlugs: [
                    "metaverse-hq"
                ]
            },
            {
                displayName: "Moonbirds",
                collectionSlugs: [
                    "proof-moonbirds"
                ]
            },
            {
                displayName: "Mooncats",
                collectionSlugs: [
                    "acclimatedmooncats"
                ]
            },
            {
                displayName: "Mooncatz",
                collectionSlugs: [
                    "mooncatz"
                ]
            },
            {
                displayName: "Moonrunners",
                collectionSlugs: [
                    "moonrunnersnft"
                ]
            },
            {
                displayName: "Moonrunners Dragonhorde Official",
                collectionSlugs: [
                    "moonrunners-dragonhorde-official"
                ]
            },
            {
                displayName: "Murakami Flowers",
                collectionSlugs: [
                    "murakami-flowers-2022-official"
                ]
            },
            {
                displayName: "Mutant Ape Yacht Club",
                collectionSlugs: [
                    "mutant-ape-yacht-club"
                ]
            },
            {
                displayName: "My Pet Hooligan",
                collectionSlugs: [
                    "mypethooligan"
                ]
            },
            {
                displayName: "Nakamigos",
                collectionSlugs: [
                    "nakamigos"
                ]
            },
            {
                displayName: "Neo Tokyo Citizens",
                collectionSlugs: [
                    "neotokyo-citizens"
                ]
            },
            {
                displayName: "Neo Tokyo Outer Citizens",
                collectionSlugs: [
                    "neotokyo-outer-citizens"
                ]
            },
            {
                displayName: "NEOZEN - ALPHA EX",
                collectionSlugs: [
                    "neozen"
                ]
            },
            {
                displayName: "Oceans of Terra: Origins",
                collectionSlugs: [
                    "oot-origins"
                ]
            },
            {
                displayName: "OnChainMonkey",
                collectionSlugs: [
                    "onchainmonkey"
                ]
            },
            {
                displayName: "Oogaverse",
                collectionSlugs: [
                    "oogaverse"
                ]
            },
            {
                displayName: "Opepen Edition",
                collectionSlugs: [
                    "opepen-edition"
                ]
            },
            {
                displayName: "Pirate Nation - Founder's Pirates",
                collectionSlugs: [
                    "piratenation"
                ]
            },
            {
                displayName: "Pixel Vampire Syndicate",
                collectionSlugs: [
                    "pixel-vampire-syndicate"
                ]
            },
            {
                displayName: "PixelTigers",
                collectionSlugs: [
                    "pixeltigers-official"
                ]
            },
            {
                displayName: "Planet Degen",
                collectionSlugs: [
                    "planetdegennft"
                ]
            },
            {
                displayName: "Potatoz",
                collectionSlugs: [
                    "thepotatoz"
                ]
            },
            {
                displayName: "Primal Beast",
                collectionSlugs: [
                    "primalbeast"
                ]
            },
            {
                displayName: "Project Godjira Genesis",
                collectionSlugs: [
                    "projectgodjiragenesis"
                ]
            },
            {
                displayName: "Project Metrograd Gen 2",
                collectionSlugs: [
                    "metrograd-gen-2"
                ]
            },
            {
                displayName: "Project Yin Yang",
                collectionSlugs: [
                    "projectyinyang"
                ]
            },
            {
                displayName: "Pudgy Penguins",
                collectionSlugs: [
                    "pudgypenguins"
                ]
            },
            {
                displayName: "Punks2023",
                collectionSlugs: [
                    "ul-punks2023"
                ]
            },
            {
                displayName: "Pxl Fangs",
                collectionSlugs: [
                    "pxlfangs"
                ]
            },
            {
                displayName: "PxMythics",
                collectionSlugs: [
                    "pxmythics-genesis"
                ]
            },
            {
                displayName: "PxQuest",
                collectionSlugs: [
                    "pxquest"
                ]
            },
            {
                displayName: "reepz",
                collectionSlugs: [
                    "reepz"
                ]
            },
            {
                displayName: "Sappy Seals",
                collectionSlugs: [
                    "sappy-seals"
                ]
            },
            {
                displayName: "Satoshi Runners",
                collectionSlugs: [
                    "satoshirunnersofficial"
                ]
            },
            {
                displayName: "Saved Souls",
                collectionSlugs: [
                    "savedsouls"
                ]
            },
            {
                displayName: "Sofa Vision",
                collectionSlugs: [
                    "sofa-vision"
                ]
            },
            {
                displayName: "Space Riders NFT",
                collectionSlugs: [
                    "spaceridersnft"
                ]
            },
            {
                displayName: "SpaceYetis",
                collectionSlugs: [
                    "space-yetis-official"
                ]
            },
            {
                displayName: "Spritely",
                collectionSlugs: [
                    "spritely-genesis"
                ]
            },
            {
                displayName: "Sproto Gremlins",
                collectionSlugs: [
                    "sproto-gremlins"
                ]
            },
            {
                displayName: "Squeakers",
                collectionSlugs: [
                    "squeakersnft"
                ]
            },
            {
                displayName: "Stumble upon Rumble: Boxing Gloves",
                collectionSlugs: [
                    "sur-boxing-gloves"
                ]
            },
            {
                displayName: "SupDucks",
                collectionSlugs: [
                    "supducks"
                ]
            },
            {
                displayName: "Swamp Souls",
                collectionSlugs: [
                    "swampsouls"
                ]
            },
            {
                displayName: "Swampverse",
                collectionSlugs: [
                    "swampverseofficial"
                ]
            },
            {
                displayName: "Teruko Labs Genesis",
                collectionSlugs: [
                    "teruko-genesis"
                ]
            },
            {
                displayName: "The 8102: Yachts",
                collectionSlugs: [
                    "the-8102-yachts"
                ]
            },
            {
                displayName: "The Captainz",
                collectionSlugs: [
                    "thecaptainz"
                ]
            },
            {
                displayName: "The Dreamers",
                collectionSlugs: [
                    "thedreamers"
                ]
            },
            {
                displayName: "The Grapes",
                collectionSlugs: [
                    "the-grapes"
                ]
            },
            {
                displayName: "The Littles",
                collectionSlugs: [
                    "thelittlesnft"
                ]
            },
            {
                displayName: "The Plague NFT",
                collectionSlugs: [
                    "the-plague"
                ]
            },
            {
                displayName: "Tiny Dinos",
                collectionSlugs: [
                    "tiny-dinos-eth"
                ]
            },
            {
                displayName: "Tycoon Tigers Club",
                collectionSlugs: [
                    "tycoontigersclub"
                ]
            },
            {
                displayName: "Tyranz Genesis",
                collectionSlugs: [
                    "tyranzgenesis"
                ]
            },
            {
                displayName: "Utility Wen",
                collectionSlugs: [
                    "utilitywen"
                ]
            },
            {
                displayName: "Valhalla",
                collectionSlugs: [
                    "valhalla"
                ]
            },
            {
                displayName: "Verb: Chapter One",
                collectionSlugs: [
                    "verblabsofficial"
                ]
            },
            {
                displayName: "Wave Catchers",
                collectionSlugs: [
                    "wavecatchersofficial"
                ]
            },
            {
                displayName: "We All Survived Death",
                collectionSlugs: [
                    "weallsurviveddeath"
                ]
            },
            {
                displayName: "Wulfz",
                collectionSlugs: [
                    "wulfz-official"
                ]
            },
            {
                displayName: "XTREME PIXELS",
                collectionSlugs: [
                    "xtreme-pixels"
                ]
            },
            {
                displayName: "Yeti Town",
                collectionSlugs: [
                    "yeti-town"
                ]
            },
            {
                displayName: "ZenApe",
                collectionSlugs: [
                    "zenapenft"
                ]
            }
        ],
        features: {
            profile_modal: false,
            objectives_modal: true
        },
        userBadges: [
            {
                badgeType: "Bronze",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/bronze_level_1.png",
                badgeImageKey: "bronze_level_1_badge",
                minLevel: 0,
                maxLevel: 10
            },
            {
                badgeType: "Bronze",
                badgeLevel: 2,
                badgeImagePath: "assets/hud/badges/bronze_level_2.png",
                badgeImageKey: "bronze_level_2_badge",
                minLevel: 11,
                maxLevel: 20
            },
            {
                badgeType: "Bronze",
                badgeLevel: 3,
                badgeImagePath: "assets/hud/badges/bronze_level_3.png",
                badgeImageKey: "bronze_level_3_badge",
                minLevel: 21,
                maxLevel: 30
            },
            {
                badgeType: "Silver",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/silver_level_1.png",
                badgeImageKey: "silver_level_1_badge",
                minLevel: 31,
                maxLevel: 40
            },
            {
                badgeType: "Silver",
                badgeLevel: 2,
                badgeImagePath: "assets/hud/badges/silver_level_2.png",
                badgeImageKey: "silver_level_2_badge",
                minLevel: 41,
                maxLevel: 50
            },
            {
                badgeType: "Silver",
                badgeLevel: 3,
                badgeImagePath: "assets/hud/badges/silver_level_3.png",
                badgeImageKey: "silver_level_3_badge",
                minLevel: 51,
                maxLevel: 60
            },
            {
                badgeType: "Gold",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/gold_level_1.png",
                badgeImageKey: "gold_level_1_badge",
                minLevel: 61,
                maxLevel: 70
            },
            {
                badgeType: "Gold",
                badgeLevel: 2,
                badgeImagePath: "assets/hud/badges/gold_level_2.png",
                badgeImageKey: "gold_level_2_badge",
                minLevel: 71,
                maxLevel: 80
            },
            {
                badgeType: "Gold",
                badgeLevel: 3,
                badgeImagePath: "assets/hud/badges/gold_level_3.png",
                badgeImageKey: "gold_level_3_badge",
                minLevel: 81,
                maxLevel: 90
            },
            {
                badgeType: "Master",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/master_level_1.png",
                badgeImageKey: "master_level_1_badge",
                minLevel: 91,
                maxLevel: 100
            },
            {
                badgeType: "Master",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/master_level_2.png",
                badgeImageKey: "master_level_2_badge",
                minLevel: 101,
                maxLevel: 110
            },
            {
                badgeType: "Master",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/master_level_3.png",
                badgeImageKey: "master_level_3_badge",
                minLevel: 111,
                maxLevel: 120
            },
            {
                badgeType: "Hero",
                badgeLevel: 1,
                badgeImagePath: "assets/hud/badges/hero_level_1.png",
                badgeImageKey: "hero_level_1_badge",
                minLevel: 121,
                maxLevel: null
            }
        ],
        machines: [
            // MAINFRAMES
            {
                key: "mainframe",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_1_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 2,
                type: "image",
                imageKey: "machines_mainframe_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_3_sprite_v2.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_4_sprite_v2.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 104,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_5_sprite_v2.png",
                numFrames: 9,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_6_sprite.png",
                numFrames: 80,
                frameRate: 12,
                frameWidth: 128,
                frameHeight: 146,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_6_sprite.png",
                numFrames: 80,
                frameRate: 12,
                frameWidth: 128,
                frameHeight: 146,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_6_sprite.png",
                numFrames: 80,
                frameRate: 12,
                frameWidth: 128,
                frameHeight: 146,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/mainframe_level_6_sprite.png",
                numFrames: 80,
                frameRate: 12,
                frameWidth: 128,
                frameHeight: 146,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 10,
                type: "image",
                imageKey: "machines_mainframe_level_7",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 11,
                type: "image",
                imageKey: "machines_mainframe_level_7",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 12,
                type: "image",
                imageKey: "machines_mainframe_level_7",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 13,
                type: "image",
                imageKey: "machines_mainframe_level_8",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 14,
                type: "image",
                imageKey: "machines_mainframe_level_8",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "mainframe",
                level: 15,
                type: "image",
                imageKey: "machines_mainframe_level_9",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            // SPACE ELIXIR MINES
            {
                key: "space_elixir_mine",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_1_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_2_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_3_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_4_sprite.png",
                numFrames: 18,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_5_sprite.png",
                numFrames: 18,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 74,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_6_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 120,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_7_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 123,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_8_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 137,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_mine_level_9_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 137,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 10,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_10",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 11,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_11",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 12,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 13,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 14,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_mine",
                level: 15,
                type: "image",
                imageKey: "machines_space_elixir_mine_level_13",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // SPACE ELIXIR STORAGE
            {
                key: "space_elixir_storage",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_1_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_2_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 76,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_3_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 68,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_4_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 86,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_5_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 106,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_6_sprite.png",
                numFrames: 20,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 115,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_7_sprite.png",
                numFrames: 20,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 135,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_8_sprite.png",
                numFrames: 20,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 153,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/space_elixir_storage_level_9_sprite.png",
                numFrames: 20,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 153,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 10,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_10",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 11,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_11",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 12,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 13,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 14,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_storage",
                level: 15,
                type: "image",
                imageKey: "machines_space_elixir_storage_level_13",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // NEON GOLD MINES
            {
                key: "neon_gold_mine",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_1_sprite.png",
                numFrames: 8,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_2_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_3_sprite.png",
                numFrames: 8,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_4_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 68,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_5_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 78,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_6_sprite.png",
                numFrames: 35,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 108,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_7_sprite.png",
                numFrames: 32,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_8_sprite.png",
                numFrames: 40,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_mine_level_9_sprite.png",
                numFrames: 40,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 108,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 10,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_10",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 11,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_11",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 12,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 13,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 14,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_mine",
                level: 15,
                type: "image",
                imageKey: "machines_neon_gold_mine_level_13",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            // NEON GOLD STORAGE
            {
                key: "neon_gold_storage",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_1_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_2_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 77,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_3_sprite.png",
                numFrames: 22,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 68,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_4_sprite.png",
                numFrames: 26,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 75,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_5_sprite.png",
                numFrames: 26,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 82,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_6_sprite.png",
                numFrames: 47,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 110,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_7_sprite.png",
                numFrames: 47,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 122,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_8_sprite.png",
                numFrames: 47,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 135,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/neon_gold_storage_level_9_sprite.png",
                numFrames: 49,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 134,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 10,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_10",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 11,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_11",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 12,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 13,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 14,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_12",
                baseCellWidth: 2,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_storage",
                level: 15,
                type: "image",
                imageKey: "machines_neon_gold_storage_level_13",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // Stardust Mine
            {
                key: "stardust_mine",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_1_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "stardust_mine",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_2_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 128,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "stardust_mine",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_3_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 128,
                frameHeight: 144,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "stardust_mine",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_4_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 128,
                frameHeight: 144,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "stardust_mine",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_5_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 128,
                frameHeight: 144,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "stardust_mine",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/stardust_mine_level_5_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 128,
                frameHeight: 144,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // Star Laboratories
            {
                key: "star_laboratory",
                level: 1,
                type: "image",
                imageKey: "machines_star_laboratory_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "star_laboratory",
                level: 2,
                type: "image",
                imageKey: "machines_star_laboratory_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "star_laboratory",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/star_laboratory_level_3_sprite.png",
                numFrames: 42,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 118,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "star_laboratory",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/star_laboratory_level_3_sprite.png",
                numFrames: 42,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 118,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "star_laboratory",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/star_laboratory_level_3_sprite.png",
                numFrames: 42,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 118,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "star_laboratory",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/star_laboratory_level_3_sprite.png",
                numFrames: 42,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 118,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Technician Bunkers
            {
                key: "technician_bunker",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/technician_bunker_level_1_sprite.png",
                numFrames: 56,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 116,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Accelerators
            {
                key: "neon_gold_accelerator",
                level: 1,
                type: "image",
                imageKey: "machines_neon_gold_accelerator_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_accelerator",
                level: 2,
                type: "image",
                imageKey: "machines_neon_gold_accelerator_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "neon_gold_accelerator",
                level: 3,
                type: "image",
                imageKey: "machines_neon_gold_accelerator_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_accelerator",
                level: 1,
                type: "image",
                imageKey: "machines_space_elixir_accelerator_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_accelerator",
                level: 2,
                type: "image",
                imageKey: "machines_space_elixir_accelerator_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_elixir_accelerator",
                level: 3,
                type: "image",
                imageKey: "machines_space_elixir_accelerator_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // COSMETICS
            {
                key: "discord_airdrop_trophy",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/discord_airdrop_trophy_level_1_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "tournament_one_competitor_trophy",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/tournament_one_competitor_trophy_level_1_sprite.png",
                numFrames: 16,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "genesis_holder_trophy",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/genesis_holder_trophy_level_1_sprite_v2.png",
                numFrames: 21,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 128,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "christmas_tree_trophy",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/Christmas_tree_trophy_level_1_sprite.png",
                numFrames: 64,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 96,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "beer_machine",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/beer_machine_level_1_sprite.png",
                numFrames: 68,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 106,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "raijus_grave",
                level: 1,
                type: "image",
                imageKey: "machines_raijus_grave_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "linkins_armory",
                level: 1,
                type: "image",
                imageKey: "machines_linkins_armory_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bench_press",
                level: 1,
                type: "image",
                imageKey: "machines_bench_press_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "valentines_picnic",
                level: 1,
                type: "image",
                imageKey: "machines_valentines_picnic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gooh_refinery",
                level: 1,
                type: "image",
                imageKey: "machines_gooh_refinery_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gooh_refinery",
                level: 2,
                type: "image",
                imageKey: "machines_gooh_refinery_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gooh_refinery",
                level: 3,
                type: "image",
                imageKey: "machines_gooh_refinery_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gooh_refinery",
                level: 4,
                type: "image",
                imageKey: "machines_gooh_refinery_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gooh_refinery",
                level: 5,
                type: "image",
                imageKey: "machines_gooh_refinery_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "alchemist_lab",
                level: 1,
                type: "image",
                imageKey: "machines_alchemist_lab_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "brawler_cage",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/brawler_cage_level_1_sprite.png",
                numFrames: 52,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 87,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mother_wolf_statue",
                level: 1,
                type: "image",
                imageKey: "machines_mother_wolf_statue_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "porcelain_throne",
                level: 1,
                type: "image",
                imageKey: "machines_porcelain_throne_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "others_receiver",
                level: 1,
                type: "image",
                imageKey: "machines_others_receiver_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "space_cactus",
                level: 1,
                type: "image",
                imageKey: "machines_space_cactus_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "1st_birthday_cake",
                level: 1,
                type: "image",
                imageKey: "machines_1st_birthday_cake_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // COLLAB PROJECT MACHINES
            // Gapes - Gasa Embassy
            {
                key: "gasa_embassy",
                level: 1,
                type: "image",
                imageKey: "machines_gasa_embassy_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gasa_embassy",
                level: 2,
                type: "image",
                imageKey: "machines_gasa_embassy_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gasa_embassy",
                level: 3,
                type: "image",
                imageKey: "machines_gasa_embassy_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gasa_embassy",
                level: 4,
                type: "image",
                imageKey: "machines_gasa_embassy_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gasa_embassy",
                level: 5,
                type: "image",
                imageKey: "machines_gasa_embassy_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "gasa_embassy",
                level: 6,
                type: "image",
                imageKey: "machines_gasa_embassy_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Kaiju Kingmaker
            {
                key: "kaiju_kingmaker",
                level: 1,
                type: "image",
                imageKey: "machines_kaiju_kingmaker_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "kaiju_kingmaker",
                level: 2,
                type: "image",
                imageKey: "machines_kaiju_kingmaker_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "kaiju_kingmaker",
                level: 3,
                type: "image",
                imageKey: "machines_kaiju_kingmaker_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Little Lemon Trees
            {
                key: "little_lemon_tree",
                level: 1,
                type: "image",
                imageKey: "machines_little_lemon_tree_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "little_lemon_tree",
                level: 2,
                type: "image",
                imageKey: "machines_little_lemon_tree_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "little_lemon_tree",
                level: 3,
                type: "image",
                imageKey: "machines_little_lemon_tree_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // AIC Labs
            {
                key: "aic_lab",
                level: 1,
                type: "image",
                imageKey: "machines_aic_lab_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "aic_lab",
                level: 2,
                type: "image",
                imageKey: "machines_aic_lab_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "aic_lab",
                level: 3,
                type: "image",
                imageKey: "machines_aic_lab_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // MVHQ
            {
                key: "mvhq",
                level: 1,
                type: "image",
                imageKey: "machines_mvhq_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mvhq",
                level: 2,
                type: "image",
                imageKey: "machines_mvhq_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mvhq",
                level: 3,
                type: "image",
                imageKey: "machines_mvhq_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mvhq",
                level: 4,
                type: "image",
                imageKey: "machines_mvhq_level_4",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Kuma Ancestor Shrine
            {
                key: "kuma_ancestor_shrine",
                level: 1,
                type: "image",
                imageKey: "machines_kuma_ancestor_shrine_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "kuma_ancestor_shrine",
                level: 2,
                type: "image",
                imageKey: "machines_kuma_ancestor_shrine_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "kuma_ancestor_shrine",
                level: 3,
                type: "image",
                imageKey: "machines_kuma_ancestor_shrine_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Dimension X
            {
                key: "dimension_x",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/dimension_x_level_1_sprite.png",
                numFrames: 5,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "dimension_x",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/dimension_x_level_2_sprite.png",
                numFrames: 5,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "dimension_x",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/dimension_x_level_3_sprite.png",
                numFrames: 5,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Defensive Machines
            {
                key: "plasma_cannon",
                level: 1,
                type: "image",
                imageKey: "machines_plasma_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 2,
                type: "image",
                imageKey: "machines_plasma_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 3,
                type: "image",
                imageKey: "machines_plasma_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 4,
                type: "image",
                imageKey: "machines_plasma_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 5,
                type: "image",
                imageKey: "machines_plasma_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 6,
                type: "image",
                imageKey: "machines_plasma_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 7,
                type: "image",
                imageKey: "machines_plasma_cannon_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 8,
                type: "image",
                imageKey: "machines_plasma_cannon_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 9,
                type: "image",
                imageKey: "machines_plasma_cannon_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_cannon",
                level: 10,
                type: "image",
                imageKey: "machines_plasma_cannon_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Lightning Tower
            {
                key: "lightning_tower",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_1_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_1_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_1_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_2_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_2_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_2_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_3_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 112,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_3_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 112,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_3_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 112,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "lightning_tower",
                level: 10,
                type: "animation",
                filePath: "assets/homebase/machines/lightning_tower_level_3_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 112,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Barracks
            {
                key: "barracks",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_1_sprite.png",
                numFrames: 6,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_1_sprite.png",
                numFrames: 6,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_1_sprite.png",
                numFrames: 6,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_2_sprite.png",
                numFrames: 7,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_2_sprite.png",
                numFrames: 7,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_2_sprite.png",
                numFrames: 7,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_3_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 120,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_3_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 120,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_3_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 120,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "barracks",
                level: 10,
                type: "animation",
                filePath: "assets/homebase/machines/barracks_level_3_sprite.png",
                numFrames: 12,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 120,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Cadet dorms
            {
                key: "cadet_dorms",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_1_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_1_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_1_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 4,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_2_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 5,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_2_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 6,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_2_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 7,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_3_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 125,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 8,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_3_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 125,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 9,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_3_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 125,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "cadet_dorms",
                level: 10,
                type: "animation",
                filePath: "assets/homebase/machines/cadet_dorms_level_3_sprite.png",
                numFrames: 14,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 125,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Mercenary Wolvez Hideout
            {
                key: "mercenary_wolvez_hideout",
                level: 1,
                type: "image",
                imageKey: "machines_mercenary_wolvez_hideout_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mercenary_wolvez_hideout",
                level: 2,
                type: "image",
                imageKey: "machines_mercenary_wolvez_hideout_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mercenary_wolvez_hideout",
                level: 3,
                type: "image",
                imageKey: "machines_mercenary_wolvez_hideout_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "mercenary_wolvez_hideout",
                level: 4,
                type: "image",
                imageKey: "machines_mercenary_wolvez_hideout_level_4",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Super Swole Squad Department
            {
                key: "super_swole_squad_department",
                level: 1,
                type: "image",
                imageKey: "machines_super_swole_squad_department_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "super_swole_squad_department",
                level: 2,
                type: "image",
                imageKey: "machines_super_swole_squad_department_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "super_swole_squad_department",
                level: 3,
                type: "image",
                imageKey: "machines_super_swole_squad_department_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Medical Academy
            {
                key: "medical_academy",
                level: 1,
                type: "image",
                imageKey: "machines_medical_academy_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "medical_academy",
                level: 2,
                type: "image",
                imageKey: "machines_medical_academy_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "medical_academy",
                level: 3,
                type: "image",
                imageKey: "machines_medical_academy_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "medical_academy",
                level: 4,
                type: "image",
                imageKey: "machines_medical_academy_level_4",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Anti-Rat Squad Department
            {
                key: "antirat_squad_department",
                level: 1,
                type: "image",
                imageKey: "machines_antirat_squad_department_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "antirat_squad_department",
                level: 2,
                type: "image",
                imageKey: "machines_antirat_squad_department_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "antirat_squad_department",
                level: 3,
                type: "image",
                imageKey: "machines_antirat_squad_department_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "antirat_squad_department",
                level: 4,
                type: "image",
                imageKey: "machines_antirat_squad_department_level_4",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Laser Tower
            {
                key: "laser_cannon",
                level: 1,
                type: "image",
                imageKey: "machines_laser_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 2,
                type: "image",
                imageKey: "machines_laser_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 3,
                type: "image",
                imageKey: "machines_laser_cannon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 4,
                type: "image",
                imageKey: "machines_laser_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 5,
                type: "image",
                imageKey: "machines_laser_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 6,
                type: "image",
                imageKey: "machines_laser_cannon_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "laser_cannon",
                level: 7,
                type: "image",
                imageKey: "machines_laser_cannon_level_3",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "laser_cannon",
                level: 8,
                type: "image",
                imageKey: "machines_laser_cannon_level_3",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "laser_cannon",
                level: 9,
                type: "image",
                imageKey: "machines_laser_cannon_level_3",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            {
                key: "laser_cannon",
                level: 10,
                type: "image",
                imageKey: "machines_laser_cannon_level_4",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // Plasma Mortar
            {
                key: "plasma_mortar",
                level: 1,
                type: "image",
                imageKey: "machines_plasma_mortar_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 2,
                type: "image",
                imageKey: "machines_plasma_mortar_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 3,
                type: "image",
                imageKey: "machines_plasma_mortar_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 4,
                type: "image",
                imageKey: "machines_plasma_mortar_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 5,
                type: "image",
                imageKey: "machines_plasma_mortar_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 6,
                type: "image",
                imageKey: "machines_plasma_mortar_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "plasma_mortar",
                level: 7,
                type: "image",
                imageKey: "machines_plasma_mortar_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Shield Battery
            {
                key: "shield_battery",
                level: 1,
                type: "image",
                imageKey: "machines_shield_battery_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 2,
                type: "image",
                imageKey: "machines_shield_battery_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 3,
                type: "image",
                imageKey: "machines_shield_battery_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 4,
                type: "image",
                imageKey: "machines_shield_battery_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 5,
                type: "image",
                imageKey: "machines_shield_battery_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 6,
                type: "image",
                imageKey: "machines_shield_battery_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "shield_battery",
                level: 7,
                type: "image",
                imageKey: "machines_shield_battery_level_3",
                baseCellWidth: 1,
                baseCellHeight: 2
            },
            // Photon Shield
            {
                key: "photon_shield",
                level: 1,
                type: "image",
                imageKey: "machines_photon_shield_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 2,
                type: "image",
                imageKey: "machines_photon_shield_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 3,
                type: "image",
                imageKey: "machines_photon_shield_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 4,
                type: "image",
                imageKey: "machines_photon_shield_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 5,
                type: "image",
                imageKey: "machines_photon_shield_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 6,
                type: "image",
                imageKey: "machines_photon_shield_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "photon_shield",
                level: 7,
                type: "image",
                imageKey: "machines_photon_shield_level_3",
                baseCellWidth: 2,
                baseCellHeight: 2
            },
            // Saved Souls
            {
                key: "saved_souls",
                level: 1,
                type: "image",
                imageKey: "machines_saved_souls_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "saved_souls",
                level: 2,
                type: "image",
                imageKey: "machines_saved_souls_level_2",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "saved_souls",
                level: 3,
                type: "image",
                imageKey: "machines_saved_souls_level_3",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "sunday_skirmish_trophy",
                level: 1,
                type: "image",
                imageKey: "machines_sunday_skirmish_trophy_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "sunday_skirmish_trophy2",
                level: 1,
                type: "image",
                imageKey: "machines_sunday_skirmish_trophy2_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // Zen Garden
            {
                key: "zen_garden",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/zen_garden_level_1_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "zen_garden",
                level: 2,
                type: "animation",
                filePath: "assets/homebase/machines/zen_garden_level_2_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 64,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "zen_garden",
                level: 3,
                type: "animation",
                filePath: "assets/homebase/machines/zen_garden_level_3_sprite.png",
                numFrames: 10,
                frameRate: 10,
                frameWidth: 64,
                frameHeight: 88,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "christmas_tree_2023",
                level: 1,
                type: "image",
                imageKey: "machines_christmas_tree_2023_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "community_nominee_2023",
                level: 1,
                type: "image",
                imageKey: "machines_community_nominee_2023_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "community_hero_2023",
                level: 1,
                type: "image",
                imageKey: "machines_community_hero_2023_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "nine_lives_lounge",
                level: 1,
                type: "image",
                imageKey: "machines_nine_lives_lounge_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "glfhers_arcade",
                level: 1,
                type: "image",
                imageKey: "machines_glfhers_arcade_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "pirate_nation_golden_galleon",
                level: 1,
                type: "image",
                imageKey: "machines_pirate_nation_golden_galleon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "pirate_nation_wood_galleon",
                level: 1,
                type: "image",
                imageKey: "machines_pirate_nation_wood_galleon_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            // {
            //   key: 'bp_blob_cosmetic',
            //   level: 1,
            //   type: 'image',
            //   imageKey: 'machines_bp_blob_cosmetic_level_1',
            //   baseCellWidth: 1,
            //   baseCellHeight: 1,
            // },
            {
                key: "bp_blob_cosmetic",
                level: 1,
                type: "animation",
                filePath: "assets/homebase/machines/machines_bp_blob_cosmetic_level_1_sprite.png",
                numFrames: 8,
                frameRate: 10,
                frameWidth: 51,
                frameHeight: 42,
                repeat: -1,
                repeatDelay: 0,
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bp_ice_storm_tracker_cosmetic",
                level: 1,
                type: "image",
                imageKey: "machines_bp_ice_storm_tracker_cosmetic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bp_water_cooler_cosmetic",
                level: 1,
                type: "image",
                imageKey: "machines_bp_water_cooler_cosmetic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bp_fire_storm_tracker_cosmetic",
                level: 1,
                type: "image",
                imageKey: "machines_bp_fire_storm_tracker_cosmetic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bp_star_wolvez_helmet_cosmetic",
                level: 1,
                type: "image",
                imageKey: "machines_bp_star_wolvez_helmet_cosmetic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            },
            {
                key: "bp_piece_of_home_cosmetic",
                level: 1,
                type: "image",
                imageKey: "machines_bp_piece_of_home_cosmetic_level_1",
                baseCellWidth: 1,
                baseCellHeight: 1
            }
        ],
        url: "https://api.starwolvez.com/"
    }
};
var $e1cf0cb7989516d0$export$2e2bcd8739ae039 = $e1cf0cb7989516d0$var$config;


class $148681abcefc5921$var$ConfigurationService {
    constructor(){
        this._configuration = [];
        if ($148681abcefc5921$var$ConfigurationService._instance) throw new Error("Error: Instantiation failed: Use ConfigurationService.getInstance() instead of new.");
        $148681abcefc5921$var$ConfigurationService._instance = this;
        this._configuration = (0, $e1cf0cb7989516d0$export$2e2bcd8739ae039).config;
    }
    static getInstance() {
        return $148681abcefc5921$var$ConfigurationService._instance;
    }
    setConfiguration(value) {
        this._configuration = value;
    }
    getConfig() {
        return this._configuration;
    }
}
$148681abcefc5921$var$ConfigurationService._instance = new $148681abcefc5921$var$ConfigurationService();
var $148681abcefc5921$export$2e2bcd8739ae039 = $148681abcefc5921$var$ConfigurationService;




class $60b229d208382899$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        var _a, _b, _c, _d, _e, _f;
        let conf = config ? config : {
            x: x,
            y: y,
            width: 149 * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.rtl = config.rtl;
        this.title = config.title.text;
        this.titleOffset = config.title.offset;
        this.titleFontSize = config.title.fontSize;
        this.titleTint = config.title.tint;
        this.titleAlign = config.title.align;
        this.titleIcon = config.title.icon;
        this.titleIconScale = config.title.iconScale;
        this.titleIconSpace = config.title.iconSpace;
        this.iconKey = config.icon ? config.icon.key : "";
        this.iconSpace = config.icon ? config.icon.space : "";
        this.iconScale = config.icon ? config.icon.scale : "";
        this.borderAlpha = (_a = config.border) === null || _a === void 0 ? void 0 : _a.alpha;
        this.borderColor = (_b = config.border) === null || _b === void 0 ? void 0 : _b.color;
        this.borderWidth = (_c = config.border) === null || _c === void 0 ? void 0 : _c.width;
        this.progressBarText = config.progressBar.text;
        this.progressBarTextAlign = config.progressBar.textAlign;
        this.progressBarFontSize = config.progressBar.fontSize;
        this.progressBarWidth = config.progressBar.width;
        this.progressBarHeight = config.progressBar.height;
        this.progressBarRadius = config.progressBar.radius;
        this.progressBarColor = config.progressBar.color;
        this.progressBarAlpha = config.progressBar.alpha;
        this.progressBarBackgroundColor = config.progressBar.backgroundColor;
        this.progressBarBackgroundAlpha = config.progressBar.backgroundAlpha;
        this.minValue = config.progressBar.minValue;
        this.maxValue = config.progressBar.maxValue;
        this.progressValue = config.progressBar.progressValue;
        this.glareHeight = config.progressBar.glare.height;
        this.glareWidth = config.progressBar.glare.width;
        this.glareRadius = config.progressBar.glare.radius;
        this.glareColor = config.progressBar.glare.color;
        this.glareAlpha = config.progressBar.glare.alpha;
        this.glareOffset = config.progressBar.glare.offset;
        this.previewBarWidth = (_d = config.previewBar) === null || _d === void 0 ? void 0 : _d.width;
        this.previewBarColor = (_e = config.previewBar) === null || _e === void 0 ? void 0 : _e.color;
        this.previewBarAlpha = (_f = config.previewBar) === null || _f === void 0 ? void 0 : _f.alpha;
        this.createProgressBar(scene, x, y);
    }
    createProgressBar(scene, x, y) {
        var _a, _b;
        this.add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(this.progressBarWidth), scene.applyScale(this.progressBarHeight), scene.applyScale(this.progressBarRadius), this.progressBarBackgroundColor, this.progressBarBackgroundAlpha).setStrokeStyle(this.borderWidth ? scene.applyScale(this.borderWidth) : 0, this.borderColor || 0x000000, this.borderAlpha || 0), {
            key: "progress_bar_bg",
            align: this.iconKey === "" ? "center" : this.rtl ? "right-center" : "left-center",
            offsetX: this.iconKey === "" ? 0 : this.rtl ? scene.applyScale(-25) : scene.applyScale(25),
            expand: false
        });
        if (this.previewBarColor) this.add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(this.previewBarWidth), scene.applyScale(this.progressBarHeight), scene.applyScale(this.progressBarRadius), this.previewBarColor, this.previewBarAlpha || 1), {
            key: "preview_bar",
            align: this.iconKey === "" ? "center" : this.rtl ? "right-center" : "left-center",
            offsetX: this.iconKey === "" ? 0 : this.rtl ? scene.applyScale(-25) : scene.applyScale(25),
            expand: false
        });
        this.add(scene.add.rexRoundRectangle(0, 0, this.getProgressWidth(scene, this.minValue, this.maxValue, this.progressBarWidth, this.progressValue), scene.applyScale(this.progressBarHeight), scene.applyScale(this.progressBarRadius), this.progressBarColor, this.progressBarAlpha).setAlpha(this.progressValue > 0 ? 1 : 0), {
            key: "progress_bar",
            align: this.iconKey === "" ? "left-center" : this.rtl ? "right-center" : "left-center",
            offsetX: this.iconKey === "" ? 0 : this.rtl ? scene.applyScale(-25) : scene.applyScale(25),
            expand: false
        }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(this.glareWidth), scene.applyScale(this.glareHeight), scene.applyScale(this.glareRadius), this.glareColor, this.glareAlpha), {
            key: "progress_bar_glare",
            align: this.iconKey === "" ? "center" : this.rtl ? "right-center" : "left-center",
            offsetX: this.iconKey === "" ? 0 : this.rtl ? scene.applyScale(-25) : scene.applyScale(25),
            offsetY: scene.applyScale(this.glareOffset || this.progressBarHeight * -0.27),
            expand: false
        }).add(scene.rexUI.add.label({
            orientation: "x",
            rtl: this.rtl,
            icon: this.iconKey === "" ? undefined : scene.add.image(0, 0, this.iconKey).setScale(scene.applyScale(this.iconScale)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.progressBarText, scene.applyScale(this.progressBarFontSize || 18), 0),
            space: {
                icon: this.iconSpace
            }
        }), {
            key: "progress_bar_text",
            align: this.progressBarTextAlign ? this.progressBarTextAlign : this.rtl ? "right-center" : "left-center",
            offsetX: 0,
            offsetY: scene.applyScale(1),
            expand: false
        }).add(scene.rexUI.add.label({
            orientation: "x",
            rtl: true,
            icon: !this.titleIcon || this.titleIcon === "" ? undefined : scene.add.image(0, 0, this.titleIcon).setScale(scene.applyScale(this.titleIconScale || 1)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.title, scene.applyScale(this.titleFontSize || 18), 0).setTint((_a = this.titleTint) !== null && _a !== void 0 ? _a : 0xffffff),
            space: {
                icon: this.titleIconSpace ? this.titleIconSpace : undefined
            }
        }), {
            key: "progress_bar_title",
            align: (_b = this.titleAlign) !== null && _b !== void 0 ? _b : "center",
            offsetX: this.iconKey === "" ? 0 : this.rtl ? scene.applyScale(-36) : scene.applyScale(36),
            offsetY: scene.applyScale(this.titleOffset || 1 - this.progressBarHeight * 0.67),
            expand: false
        }).layout();
    }
    setTitle(title) {
        var _a;
        if (title) {
            this.title = title;
            (_a = this.getElement("progress_bar_title")) === null || _a === void 0 || _a.setText(title);
            this.layout();
        }
    }
    setIcon(iconImageKey) {
        var _a;
        if (iconImageKey) {
            this.iconKey = iconImageKey;
            (_a = this.getElement("progress_bar_text")) === null || _a === void 0 || _a.setTexture(iconImageKey);
            this.layout();
        }
    }
    setProgressBarText(text) {
        var _a;
        if (text) {
            this.progressBarText = text;
            (_a = this.getElement("progress_bar_text")) === null || _a === void 0 || _a.setText(text);
        }
    }
    setProgressBarColor(color) {
        if (color) this.progressBarColor = color;
    }
    setProgressBarBackgroundColor(color) {
        var _a, _b;
        if (color) {
            var fillStyle = (_a = this.getElement("progress_bar_bg")) === null || _a === void 0 ? void 0 : _a.fillStyle;
            (_b = this.getElement("progress_bar_bg")) === null || _b === void 0 || _b.setFillStyle(fillStyle, color);
            //this.progressBarBackgroundColor = color
            this.layout();
        }
    }
    setProgress(scene, progress) {
        if (progress || progress === 0) {
            this.progressValue = progress;
            this.updateProgress(scene);
        }
    }
    setProgressValue(scene, progressValue) {
        var _a;
        this.progressValue = progressValue;
        (_a = this.getElement("progress_bar")) === null || _a === void 0 || _a.setSize(this.getProgressWidth(scene, this.minValue, this.maxValue, this.progressBarWidth, this.progressValue), scene.applyScale(this.progressBarHeight));
        this.layout();
    }
    updateMinValue(scene, minValue) {
        if (minValue) {
            this.minValue = minValue;
            this.updateProgress(scene);
        }
    }
    updateMaxValue(scene, maxValue) {
        if (maxValue) {
            this.maxValue = maxValue;
            this.updateProgress(scene);
        }
    }
    updateProgress(scene) {
        var _a, _b, _c;
        (_a = this.getElement("progress_bar")) === null || _a === void 0 || _a.setSize(this.getProgressWidth(scene, this.minValue, this.maxValue, this.progressBarWidth, this.progressValue), scene.applyScale(this.progressBarHeight));
        (_b = this.getElement("progress_bar")) === null || _b === void 0 || _b.setAlpha(this.progressValue > 0 ? 1 : 0);
        if (this.progressBarText !== "") (_c = this.getElement("progress_bar_text")) === null || _c === void 0 || _c.setText(Math.floor(this.progressValue).toLocaleString("en-us"));
        this.layout();
    }
    getProgressWidth(scene, min, max, barWidth, progress) {
        if (progress && progress > 0) {
            const localProgress = progress - min;
            const range = max - min;
            const percentComplete = localProgress / range;
            const res = Math.ceil(percentComplete * barWidth);
            // console.log(`barWidth: ${barWidth}`);
            // console.log(`progressWidth: ${res}`);
            // console.log(`range: ${range}`);
            // console.log(`percentComplete: ${percentComplete}`);
            // console.log(`localProgress: ${localProgress}`);
            return scene.applyScale(res > barWidth ? barWidth : res);
        } else return 0;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("progressBar", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $60b229d208382899$export$2e2bcd8739ae039(this.scene, x, y, config));
});


var $ae495e463874b7e9$var$Prando = /** @class */ function() {
    // ================================================================================================================
    // CONSTRUCTOR ----------------------------------------------------------------------------------------------------
    /**
     * Generate a new Prando pseudo-random number generator.
     *
     * @param seed - A number or string seed that determines which pseudo-random number sequence will be created. Defaults to a random seed based on `Math.random()`.
     */ function Prando(seed) {
        this._value = NaN;
        if (typeof seed === "string") // String seed
        this._seed = this.hashCode(seed);
        else if (typeof seed === "number") // Numeric seed
        this._seed = this.getSafeSeed(seed);
        else // Pseudo-random seed
        this._seed = this.getSafeSeed(Prando.MIN + Math.floor((Prando.MAX - Prando.MIN) * Math.random()));
        this.reset();
    }
    // ================================================================================================================
    // PUBLIC INTERFACE -----------------------------------------------------------------------------------------------
    /**
     * Generates a pseudo-random number between a lower (inclusive) and a higher (exclusive) bounds.
     *
     * @param min - The minimum number that can be randomly generated.
     * @param pseudoMax - The maximum number that can be randomly generated (exclusive).
     * @return The generated pseudo-random number.
     */ Prando.prototype.next = function(min, pseudoMax) {
        if (min === void 0) min = 0;
        if (pseudoMax === void 0) pseudoMax = 1;
        this.recalculate();
        return this.map(this._value, Prando.MIN, Prando.MAX, min, pseudoMax);
    };
    /**
     * Generates a pseudo-random integer number in a range (inclusive).
     *
     * @param min - The minimum number that can be randomly generated.
     * @param max - The maximum number that can be randomly generated.
     * @return The generated pseudo-random number.
     */ Prando.prototype.nextInt = function(min, max) {
        if (min === void 0) min = 10;
        if (max === void 0) max = 100;
        this.recalculate();
        return Math.floor(this.map(this._value, Prando.MIN, Prando.MAX, min, max + 1));
    };
    /**
     * Generates a pseudo-random string sequence of a particular length from a specific character range.
     *
     * Note: keep in mind that creating a random string sequence does not guarantee uniqueness; there is always a
     * 1 in (char_length^string_length) chance of collision. For real unique string ids, always check for
     * pre-existing ids, or employ a robust GUID/UUID generator.
     *
     * @param length - Length of the string to be generated.
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated string sequence.
     */ Prando.prototype.nextString = function(length, chars) {
        if (length === void 0) length = 16;
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var str = "";
        while(str.length < length)str += this.nextChar(chars);
        return str;
    };
    /**
     * Generates a pseudo-random string of 1 character specific character range.
     *
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated character.
     */ Prando.prototype.nextChar = function(chars) {
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        return chars.substr(this.nextInt(0, chars.length - 1), 1);
    };
    /**
     * Picks a pseudo-random item from an array. The array is left unmodified.
     *
     * Note: keep in mind that while the returned item will be random enough, picking one item from the array at a time
     * does not guarantee nor imply that a sequence of random non-repeating items will be picked. If you want to
     * *pick items in a random order* from an array, instead of *pick one random item from an array*, it's best to
     * apply a *shuffle* transformation to the array instead, then read it linearly.
     *
     * @param array - Array of any type containing one or more candidates for random picking.
     * @return An item from the array.
     */ Prando.prototype.nextArrayItem = function(array) {
        return array[this.nextInt(0, array.length - 1)];
    };
    /**
     * Generates a pseudo-random boolean.
     *
     * @return A value of true or false.
     */ Prando.prototype.nextBoolean = function() {
        this.recalculate();
        return this._value > 0.5;
    };
    /**
     * Skips ahead in the sequence of numbers that are being generated. This is equivalent to
     * calling next() a specified number of times, but faster since it doesn't need to map the
     * new random numbers to a range and return it.
     *
     * @param iterations - The number of items to skip ahead.
     */ Prando.prototype.skip = function(iterations) {
        if (iterations === void 0) iterations = 1;
        while(iterations-- > 0)this.recalculate();
    };
    /**
     * Reset the pseudo-random number sequence back to its starting seed. Further calls to next()
     * will then produce the same sequence of numbers it had produced before. This is equivalent to
     * creating a new Prando instance with the same seed as another Prando instance.
     *
     * Example:
     * let rng = new Prando(12345678);
     * console.log(rng.next()); // 0.6177754114889017
     * console.log(rng.next()); // 0.5784605181725837
     * rng.reset();
     * console.log(rng.next()); // 0.6177754114889017 again
     * console.log(rng.next()); // 0.5784605181725837 again
     */ Prando.prototype.reset = function() {
        this._value = this._seed;
    };
    // ================================================================================================================
    // PRIVATE INTERFACE ----------------------------------------------------------------------------------------------
    Prando.prototype.recalculate = function() {
        this._value = this.xorshift(this._value);
    };
    Prando.prototype.xorshift = function(value) {
        // Xorshift*32
        // Based on George Marsaglia's work: http://www.jstatsoft.org/v08/i14/paper
        value ^= value << 13;
        value ^= value >> 17;
        value ^= value << 5;
        return value;
    };
    Prando.prototype.map = function(val, minFrom, maxFrom, minTo, maxTo) {
        return (val - minFrom) / (maxFrom - minFrom) * (maxTo - minTo) + minTo;
    };
    Prando.prototype.hashCode = function(str) {
        var hash = 0;
        if (str) {
            var l = str.length;
            for(var i = 0; i < l; i++){
                hash = (hash << 5) - hash + str.charCodeAt(i);
                hash |= 0;
                hash = this.xorshift(hash);
            }
        }
        return this.getSafeSeed(hash);
    };
    Prando.prototype.getSafeSeed = function(seed) {
        if (seed === 0) return 1;
        return seed;
    };
    Prando.MIN = -2147483648; // Int32 min
    Prando.MAX = 2147483647; // Int32 max
    return Prando;
}();
var $ae495e463874b7e9$export$2e2bcd8739ae039 = $ae495e463874b7e9$var$Prando;


function $2e76b527e9362cab$export$95207235cf472c1d(seconds) {
    seconds = Number(seconds);
    var hDisplay = Math.floor(seconds / 3600) + "H ";
    var mDisplay = Math.floor(seconds % 3600 / 60) + "M ";
    var sDisplay = Math.floor(seconds % 3600 % 60) + "S";
    return hDisplay + mDisplay + sDisplay;
}
function $2e76b527e9362cab$export$f59a0cda704a3e4c(countdown) {
    return String(Math.floor(countdown / 60)).padStart(2, "0") + ":" + String(countdown % 60).padStart(2, "0");
}
function $2e76b527e9362cab$export$9446e10eb5cfa53(seconds) {
    return Math.floor(seconds / 3600) + "h";
}
function $2e76b527e9362cab$export$cb1a4a19b5054005(name) {
    if (name.length > 15) {
        var string = name.substring(0, 13);
        return string + "...";
    } else return name;
}
const $2e76b527e9362cab$var$RNG = new (0, $ae495e463874b7e9$export$2e2bcd8739ae039)();
function $2e76b527e9362cab$export$eab19c48dcb6310d(min, max) {
    return $2e76b527e9362cab$var$RNG.nextInt(min, max);
}
function $2e76b527e9362cab$export$c27c5a03b42fc70c() {
    var adjective = [
        "Manically Depressed",
        "Ordinary, Menial",
        "Sesquicentennial",
        "Lovely Self-willed",
        "Nominally Servile",
        "Polite Unobtrusive",
        "Regular Local",
        "Efficient, Polite",
        "Dummy Human",
        "All-powerful Mindless",
        "Successfully Brash",
        "Stupid Hulking",
        "Independent Annoying",
        "Frustratingly Contrary",
        "Sophisticated Autonomous",
        "Previously Cold",
        "Ordinary Self-willed",
        "Undifferentiated Cellular",
        "General-purpose",
        "Independent Eccentric",
        "Sophisticated Stubby",
        "Intensely Inconvenient",
        "Flexible Obedient",
        "Berserk Fiery",
        "Heavy-duty",
        "Anti-social",
        "Consciously Cold",
        "Deeply Ambitious"
    ];
    var names = [
        "Blob",
        "Wolf",
        "Bot",
        "Pup",
        "Elder",
        "Hybrid"
    ];
    return adjective[$2e76b527e9362cab$export$eab19c48dcb6310d(0, adjective.length - 1)] + " " + names[$2e76b527e9362cab$export$eab19c48dcb6310d(0, names.length - 1)];
}
var $2e76b527e9362cab$export$f2fba4fe2e3196c3 = [
    {
        "trait": "Plasma Rifle Mark I",
        "description": "6% additional damage per round."
    },
    {
        "trait": "Plasma Rifle Mark II",
        "description": "8% additional damage per round."
    },
    {
        "trait": "Plasma Rifle Mark Gold",
        "description": "10% additional damage per round."
    },
    {
        "trait": "Wormhole Pilot Goggles",
        "description": "4% increase in damage per round"
    },
    {
        "trait": "Viper Pilot Helmet",
        "description": "8% increase in damage per round."
    },
    {
        "trait": "Star Storm Pilot Helmet",
        "description": "10% increase in damage per round."
    },
    {
        "trait": "Enforcer V2 Headset",
        "description": "11% increase in damage per round."
    },
    {
        "trait": "Lil Fighter Helmet",
        "description": "12% increase in damage per round."
    },
    {
        "trait": "Enforcer Goggles",
        "description": "15% increase in damage per round."
    },
    {
        "trait": "Howl",
        "description": "3% increase in damage per turn."
    },
    {
        "trait": "Gib Rats",
        "description": "4% increase in damage per turn."
    },
    {
        "trait": "Brown Stash",
        "description": "2% increase in Stardust per successful mission."
    },
    {
        "trait": "High Elder",
        "description": "15% increase in damage per round."
    },
    {
        "trait": "Watch Scout Armor Green",
        "description": "8% increase in damage per round."
    },
    {
        "trait": "Watch Scout Armor Blue",
        "description": "10% increase in damage per round."
    },
    {
        "trait": "Genesis",
        "description": "15% additional damage per round."
    }
];
var $2e76b527e9362cab$export$987a94a66f3c9830 = [
    {
        "trait": "Patroller Helmet White",
        "description": "4% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Goo Brain Helmet",
        "description": "5% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Halo Effect Goggles Red",
        "description": "5% increase in successful attack."
    },
    {
        "trait": "Halo Effect Goggles White",
        "description": "6% increase in successful attack."
    },
    {
        "trait": "Far Sight Gear",
        "description": "8% increase in successful attack."
    },
    {
        "trait": "Airspeeder Goggles Green",
        "description": "8% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Patroller Helmet Gold",
        "description": "10% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Millenia Vision Goggles Red",
        "description": "10% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Millenia Vision Goggles Green",
        "description": "10% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Angry Emoji Goggles",
        "description": "12% increased likelihood of successfully hiding for a round."
    },
    {
        "trait": "Airspeeder Goggles Blue",
        "description": "12% likelihood of successfully hiding for a round."
    },
    {
        "trait": "Forest Regiment Armor",
        "description": "4% more chance of hiding successfully per turn"
    },
    {
        "trait": "Peacekeeper Armor",
        "description": "7% more chance of hiding successfully per turn"
    },
    {
        "trait": "Ambassador Armor",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Shadow Guard Armor",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Earth Fallout",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Water Fallout",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Dark Elder Body",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Young Elder Pink",
        "description": "10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Magma Body",
        "description": " Heavy Attacks do 10% more damage."
    },
    {
        "trait": "Celestial Regiment Armor",
        "description": " 10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Snow Runner Armor",
        "description": " 10% more chance of hiding successfully per turn"
    },
    {
        "trait": "High Elder Body",
        "description": " 10% more chance of hiding successfully per turn"
    },
    {
        "trait": "Chaplain of the Light",
        "description": " 12% more chance of hiding successfully per turn"
    },
    {
        "trait": "Chaplain of the Dark",
        "description": " 12% more chance of hiding successfully per turn"
    },
    {
        "trait": "Water Bearer Body",
        "description": " 12% more chance of hiding successfully per turn"
    },
    {
        "trait": "Skully Body",
        "description": " 12% more chance of hiding successfully per turn"
    },
    {
        "trait": "Sandstone Body",
        "description": " 12% more chance of hiding successfully per turn"
    }
];
const $2e76b527e9362cab$export$706bad4d7728db29 = {
    "Common": "bossfight_boss_common",
    "Rare": "bossfight_boss_rare",
    "Epic": "bossfight_boss_epic",
    "Legendary": "bossfight_boss_legendary",
    "Mythical": "bossfight_boss_mythical"
};
var $2e76b527e9362cab$export$fbc1ed301237afc4 = true;


// Timer Progress Bar
const $3a9bea67e0e561eb$var$progressBarWidth = 169;
const $3a9bea67e0e561eb$var$progressBarHeight = 22;
const $3a9bea67e0e561eb$var$progressBarRadius = 7;
const $3a9bea67e0e561eb$var$progressBarColor = 0x00A6D3;
const $3a9bea67e0e561eb$var$progressBarBackgroundColor = 0x440D31;
const $3a9bea67e0e561eb$var$progressBarBackgroundAlpha = 0.4;
const $3a9bea67e0e561eb$var$glareHeight = 6;
const $3a9bea67e0e561eb$var$glareColor = 0xffffff;
const $3a9bea67e0e561eb$var$glareAlpha = 0.17;
const $3a9bea67e0e561eb$var$glareOffset = 6;
const $3a9bea67e0e561eb$var$glareRadius = 3;
const $3a9bea67e0e561eb$var$progressBarLiveColor = 0x00C170;
class $3a9bea67e0e561eb$export$2e2bcd8739ae039 extends (0, $60b229d208382899$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, countDown, iconScale = 0.7){
        super(scene, x, y, paneScale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "bossfight_clock_icon",
                space: 8,
                scale: 1
            },
            border: {
                width: 2,
                color: 0x383d57
            },
            progressBar: {
                text: (0, $2e76b527e9362cab$export$95207235cf472c1d)(countDown),
                textAlign: "left",
                fontStyle: null,
                width: $3a9bea67e0e561eb$var$progressBarWidth,
                height: $3a9bea67e0e561eb$var$progressBarHeight,
                radius: $3a9bea67e0e561eb$var$progressBarRadius,
                color: $3a9bea67e0e561eb$var$progressBarColor,
                backgroundColor: $3a9bea67e0e561eb$var$progressBarBackgroundColor,
                backgroundAlpha: $3a9bea67e0e561eb$var$progressBarBackgroundAlpha,
                minValue: 0,
                maxValue: countDown,
                progressValue: countDown,
                glare: {
                    width: $3a9bea67e0e561eb$var$progressBarWidth - $3a9bea67e0e561eb$var$glareOffset,
                    height: $3a9bea67e0e561eb$var$glareHeight,
                    radius: $3a9bea67e0e561eb$var$glareRadius,
                    color: $3a9bea67e0e561eb$var$glareColor,
                    alpha: $3a9bea67e0e561eb$var$glareAlpha
                }
            }
        });
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this.setValues(scene, countDown);
    }
    updateDisplay(scene, countdown) {
        this.setProgressValue(scene, countdown);
        this.updateProgress(scene);
        this.setProgressBarText((0, $2e76b527e9362cab$export$95207235cf472c1d)(countdown));
    }
    roundTimerReset(scene, countdown) {
        if (countdown) this.setValues(scene, countdown);
    }
    setValues(scene, countdown) {
        this.updateMaxValue(scene, countdown);
        this.setProgressValue(scene, countdown);
        this.updateProgress(scene);
        this.setProgressBarText((0, $2e76b527e9362cab$export$95207235cf472c1d)(countdown));
    }
    setBattleRoyaleLive() {
        this.setProgressBarText("LIVE!");
    //this.setProgressBarBackgroundColor(progressBarLiveColor)
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("timerProgressBarComponent", function(x, y, userData) {
    // @ts-ignore
    return this.displayList.add(new $3a9bea67e0e561eb$export$2e2bcd8739ae039(this.scene, x, y, userData));
});


function $f12f0c85b935f07d$export$a14e8754c327dfd0(seconds) {
    seconds = Number(seconds);
    var h = Math.floor(seconds / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 3600 % 60);
    var hDisplay = h > 0 ? `${h}h` : "";
    var mDisplay = m > 0 ? `${m}m` : "";
    var sDisplay = s > 0 ? `${s}s` : "0s";
    return h > 0 ? `${hDisplay} ${mDisplay} ${sDisplay}` : m > 0 ? `${mDisplay} ${sDisplay}` : `${sDisplay}`;
}
function $f12f0c85b935f07d$export$43a43cf967792f11() {
    var startDate = new Date();
    startDate.setUTCMinutes(59);
    startDate.setUTCSeconds(59);
    startDate.setUTCMilliseconds(0);
    var startingHour = 0;
    var utcHour = new Date().getUTCHours();
    // 8 Games Per Day
    // if (utcHour >= 0 && utcHour <= 2) {
    //   startingHour = 2;
    // } else if (utcHour > 2 && utcHour <= 5) {
    //   startingHour =  5;
    // } else if (utcHour > 5 && utcHour <= 8) {
    //   startingHour =  8;
    // } else if (utcHour > 8 && utcHour <= 11) {
    //   startingHour =  11;
    // } else if (utcHour > 11 && utcHour <= 14) {
    //   startingHour =  14;
    // } else if (utcHour > 14 && utcHour <= 17) {
    //   startingHour =  17;
    // } else if (utcHour > 17 && utcHour <= 20) {
    //   startingHour =  20;
    // } else if (utcHour > 20 && utcHour <= 23) {
    //   startingHour =  23;
    // }
    // 4 Games Per Day
    if (utcHour >= 0 && utcHour <= 5) startingHour = 5;
    else if (utcHour > 5 && utcHour <= 11) startingHour = 11; // Reset Time
    else if (utcHour > 11 && utcHour <= 17) startingHour = 17;
    else if (utcHour > 17 && utcHour <= 23) startingHour = 23;
    startDate.setUTCHours(startingHour);
    var timetarget = startDate.getTime(); // this number is currently the time stamp for midnight in UTC time for todays date
    var timenow = new Date().getTime();
    var offsetmilliseconds = timetarget - timenow;
    var milliseconds = Math.floor(offsetmilliseconds / 1000);
    return milliseconds;
}
function $f12f0c85b935f07d$export$bcbf232a15e036ba() {
    var startDate = new Date();
    startDate.setUTCMinutes(59);
    startDate.setUTCSeconds(59);
    startDate.setUTCMilliseconds(0);
    var startingHour = 0;
    var utcHour = new Date().getUTCHours();
    // 6 Games Per Day
    if (utcHour >= 0 && utcHour < 3) startingHour = 2;
    else if (utcHour >= 3 && utcHour < 7) startingHour = 6;
    else if (utcHour >= 7 && utcHour < 11) startingHour = 10;
    else if (utcHour >= 11 && utcHour < 15) startingHour = 14;
    else if (utcHour >= 15 && utcHour < 19) startingHour = 18;
    else if (utcHour >= 18 && utcHour < 23) startingHour = 22;
    else if (utcHour >= 23) {
        startingHour = 2;
        startDate.setUTCDate(startDate.getUTCDate() + 1);
    }
    startDate.setUTCHours(startingHour);
    var timetarget = startDate.getTime(); // this number is currently the time stamp for midnight in UTC time for todays date
    var timenow = new Date().getTime();
    var offsetmilliseconds = timetarget - timenow;
    var milliseconds = Math.floor(offsetmilliseconds / 1000);
    return milliseconds;
}
function $f12f0c85b935f07d$export$1f6845f499a2fcc4() {
    return Math.floor(Date.now() / 1000);
}
function $f12f0c85b935f07d$export$bb44e56f8c7ecf33(unixEndTime) {
    return unixEndTime - $f12f0c85b935f07d$export$1f6845f499a2fcc4();
}


// Pane Details
const $048630434f6bd4fe$var$paneHeight = 184;
const $048630434f6bd4fe$var$paneWidth = 258;
const $048630434f6bd4fe$var$paneRadius = 26;
const $048630434f6bd4fe$var$paneColor = 0xa0116f;
const $048630434f6bd4fe$var$paneAlpha = 0.9;
class $048630434f6bd4fe$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $048630434f6bd4fe$var$paneWidth,
            height: paneScale * $048630434f6bd4fe$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scene = scene;
        this._scale = paneScale;
        this._roomData = data;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($048630434f6bd4fe$var$paneWidth), scene.applyScale($048630434f6bd4fe$var$paneHeight), scene.applyScale($048630434f6bd4fe$var$paneRadius), $048630434f6bd4fe$var$paneColor, $048630434f6bd4fe$var$paneAlpha);
        this.add(background, {
            key: "background",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Panel
        var panel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($048630434f6bd4fe$var$paneWidth),
            height: scene.applyScale($048630434f6bd4fe$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Timer Progress Bar
        this._countDownProgressBar = new (0, $3a9bea67e0e561eb$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, (0, $f12f0c85b935f07d$export$43a43cf967792f11)());
        this._countDownProgressBar.setVisible(false);
        panel.add(this._countDownProgressBar, {
            key: "progress_bar",
            align: "left-top",
            offsetX: this.applyScale(28),
            offsetY: this.applyScale(-16),
            expand: false
        });
        // BossFight Text
        this._bossFightText = this.scene.add.bitmapText(0, 0, "cc_outline", "", scene.applyScale(18), 1);
        panel.add(this._bossFightText, {
            key: "bossfight-text",
            align: "left-top",
            offsetX: this.applyScale(34),
            offsetY: this.applyScale(40),
            expand: true
        });
        // Ready up Button
        this._readyUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_hud_go_to_battle_button", false).setScale(this._scale);
        this._readyUpButton.onClick().subscribe((pointer)=>{
            this._scene.startBossFightScene();
        });
        panel.add(scene.add.existing(this._readyUpButton), {
            key: "ready-up-button",
            align: "left-top",
            offsetX: this.applyScale(28),
            offsetY: this.applyScale(102),
            expand: false
        });
        this.add(panel, {
            key: "panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    updateCard(battleData) {
        var gameState = this.getGameStateEnum(battleData.gameState);
        var cardText = "";
        switch(gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                this._countDownProgressBar.setVisible(true);
                this.startCountDownUI((0, $f12f0c85b935f07d$export$43a43cf967792f11)());
                cardText = "Boss Fight Game Status\nPre Game";
                if ((0, $f12f0c85b935f07d$export$43a43cf967792f11)() > 600) {
                    // Display Join Button
                    this._readyUpButton.setVisible(false);
                    cardText = "Boss Fight Game Status\nPreparing Server";
                }
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
                cardText = "Boss Fight Game Status\n Active";
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
                cardText = "Boss Fight Game Status\n Processing Results...";
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
                cardText = "Boss Fight Game Status\nPost Game";
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                cardText = "Boss Fight Game Status\nCompleted";
                break;
        }
        // update the text box based on the round number
        this._bossFightText.setText(cardText);
    }
    getGameStateEnum(number) {
        switch(number){
            case 0:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame;
            case 1:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound;
            case 2:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round;
            case 3:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults;
            case 4:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults;
            case 5:
                return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished;
        }
        return (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame;
    }
    startCountDownUI(countDown) {
        // Implements Countdown
        var remainingSeconds = countDown;
        // Resets Countdown Bar Values
        this._countDownProgressBar.roundTimerReset(this, remainingSeconds);
        clearInterval(this._internalTimer);
        this._internalTimer = setInterval(()=>{
            //var _timeRemainingInterval = setInterval(() => {
            try {
                if (remainingSeconds <= 0) return clearInterval(this._internalTimer);
                remainingSeconds--;
                this._countDownProgressBar.updateDisplay(this, remainingSeconds);
                if (remainingSeconds <= 600) {
                    this._readyUpButton.setVisible(true);
                    this._bossFightText.setText("Boss Fight Game Status\nPre Game");
                }
            } catch (error) {
                return clearInterval(this._internalTimer);
            }
        }, 1000);
    }
    stopTimer() {
        clearInterval(this._internalTimer);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("hudBossFightCardPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $048630434f6bd4fe$export$2e2bcd8739ae039(this.scene, x, y));
});



class $68aeb7e748328303$var$ScaleService {
    constructor(){
        if ($68aeb7e748328303$var$ScaleService._instance) throw new Error("Error: Instantiation failed: Use StakingService.getInstance() instead of new.");
        $68aeb7e748328303$var$ScaleService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $68aeb7e748328303$var$ScaleService._instance;
    }
    getScale(modalWidth, modalHeight, multiplier) {
        const vertRatio = window.innerHeight / modalHeight;
        const horzRatio = window.innerWidth / modalWidth;
        const lowest = vertRatio > horzRatio ? horzRatio : vertRatio;
        const ratio = multiplier ? multiplier : 0.9;
        return lowest <= 1 ? lowest * ratio : 1;
    }
    getMobileScale(modalWidth, modalHeight, multiplier) {
        const vertRatio = window.innerHeight / modalHeight;
        const horzRatio = window.innerWidth / modalWidth;
        const lowest = vertRatio > horzRatio ? horzRatio : vertRatio;
        const ratio = multiplier ? multiplier : 0.9;
        return lowest <= 1 ? 1 : lowest * ratio;
    }
}
$68aeb7e748328303$var$ScaleService._instance = new $68aeb7e748328303$var$ScaleService();
var $68aeb7e748328303$export$2e2bcd8739ae039 = $68aeb7e748328303$var$ScaleService;


const $821d3a4d53be6799$var$modalHeight = 400;
const $821d3a4d53be6799$var$modalWidth = 689;
class $821d3a4d53be6799$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "MiningTestingScene"
        });
    }
    preload() {}
    init() {}
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($821d3a4d53be6799$var$modalWidth, $821d3a4d53be6799$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $821d3a4d53be6799$var$modalWidth,
            height: $821d3a4d53be6799$var$modalHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        this._bossFightCardPane = new (0, $048630434f6bd4fe$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        this.add.existing(this._bossFightCardPane);
        sizer.add(this._bossFightCardPane, {
            key: "card-pane",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return this._scale * length;
    }
}





class $630775c37483ad23$var$ApiProxyService {
    constructor(){
        this._config = {};
        if ($630775c37483ad23$var$ApiProxyService._instance) throw new Error("Error: Instantiation failed: Use ApiProxyService.getInstance() instead of new.");
        $630775c37483ad23$var$ApiProxyService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $630775c37483ad23$var$ApiProxyService._instance;
    }
    setConfig(value) {
        this._config = value;
    }
    getConfig() {
        return this._config;
    }
    get(endpoint, pathParams, queryParams) {
        document.getElementsByTagName("canvas")[0].style.cursor = "wait";
        var url = this.getUrl(endpoint);
        url = this.addPathParams(url, pathParams);
        url = this.addQueryParams(url, queryParams);
        return fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
                "content-type": "application/json"
            }
        }).then((response)=>response.json()).then((data)=>{
            document.getElementsByTagName("canvas")[0].style.cursor = "default";
            return data;
        }).catch((err)=>{
            document.getElementsByTagName("canvas")[0].style.cursor = "default";
            console.log(`Error fetching data from ${url}`);
        });
    }
    post(endpoint, pathParams, body, queryParams) {
        var url = this.getUrl(endpoint);
        url = this.addPathParams(url, pathParams);
        if (queryParams) url = this.addQueryParams(url, queryParams);
        return fetch(url, {
            method: "POST",
            mode: "cors",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }).then((response)=>response.json()).then((data)=>{
            return data;
        }).catch((err)=>{
            console.log(`Error fetching data from ${url}`);
        });
    }
    getUrl(endpoint) {
        const endpointObj = this._config.api.endpoints[endpoint];
        if (endpointObj && endpointObj.path) return `${this._config.api.base}${endpointObj.path}`;
        return this._config.api.base;
    }
    addPathParams(url, pathParams) {
        if (pathParams.length > 0) pathParams.forEach((param)=>{
            url = url + (param === null || param === void 0 ? void 0 : param.toString()) + "/";
        });
        return url;
    }
    addQueryParams(url, queryParams) {
        var symbol = "?";
        if (queryParams && queryParams.length > 0) queryParams.forEach((param)=>{
            url = url + symbol + (param === null || param === void 0 ? void 0 : param.toString());
            symbol = "&";
        });
        return url;
    }
}
$630775c37483ad23$var$ApiProxyService._instance = new $630775c37483ad23$var$ApiProxyService();
var $630775c37483ad23$export$2e2bcd8739ae039 = $630775c37483ad23$var$ApiProxyService;



var $093a98c17cb6b6b8$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
$093a98c17cb6b6b8$exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$093a98c17cb6b6b8$exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return $093a98c17cb6b6b8$exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
$093a98c17cb6b6b8$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = $093a98c17cb6b6b8$exports.format.apply($093a98c17cb6b6b8$exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $093a98c17cb6b6b8$exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
$093a98c17cb6b6b8$exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $093a98c17cb6b6b8$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$093a98c17cb6b6b8$exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
$093a98c17cb6b6b8$exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$093a98c17cb6b6b8$exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
$093a98c17cb6b6b8$exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
$093a98c17cb6b6b8$exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
$093a98c17cb6b6b8$exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
$093a98c17cb6b6b8$exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$093a98c17cb6b6b8$exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
$093a98c17cb6b6b8$exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
$093a98c17cb6b6b8$exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
$093a98c17cb6b6b8$exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$093a98c17cb6b6b8$exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
$093a98c17cb6b6b8$exports.isDate = $093a98c17cb6b6b8$var$isDate;
$093a98c17cb6b6b8$exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
$093a98c17cb6b6b8$exports.isError = $093a98c17cb6b6b8$var$isError;
$093a98c17cb6b6b8$exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
$093a98c17cb6b6b8$exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$093a98c17cb6b6b8$exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

$093a98c17cb6b6b8$exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
$093a98c17cb6b6b8$exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), $093a98c17cb6b6b8$exports.format.apply($093a98c17cb6b6b8$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $093a98c17cb6b6b8$exports.inherits = (parcelRequire("dlqwk"));
$093a98c17cb6b6b8$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
$093a98c17cb6b6b8$exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
$093a98c17cb6b6b8$exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$093a98c17cb6b6b8$exports.callbackify = $093a98c17cb6b6b8$var$callbackify;



var $kqytL = parcelRequire("kqytL");
var $foFRw = parcelRequire("foFRw");
const $7f8fe1466d7f4db8$export$625cf84d855940d4 = /*#__PURE__*/ (0, $foFRw.defineChain)({
    id: 42161,
    name: "Arbitrum One",
    network: "arbitrum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://arb-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://arb-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://arbitrum-mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://arbitrum-mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        },
        public: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Arbiscan",
            url: "https://arbiscan.io"
        },
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});



var $gsd36 = parcelRequire("gsd36");
var $kqytL = parcelRequire("kqytL");
parcelRequire("k1l85");
var $aoKpV = parcelRequire("aoKpV");
var $j0fVO = parcelRequire("j0fVO");
var $efzgw = parcelRequire("efzgw");
var $bYnq1 = parcelRequire("bYnq1");
var $6CqNZ = parcelRequire("6CqNZ");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
var $cde2776e2e4ef349$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cde2776e2e4ef349$export$f039a2838669d98e = class W3mAccountButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = "show";
        this.charsStart = 4;
        this.charsEnd = 6;
        this.address = (0, $aoKpV.AccountController).state.address;
        this.balanceVal = (0, $aoKpV.AccountController).state.balance;
        this.balanceSymbol = (0, $aoKpV.AccountController).state.balanceSymbol;
        this.profileName = (0, $aoKpV.AccountController).state.profileName;
        this.profileImage = (0, $aoKpV.AccountController).state.profileImage;
        this.network = (0, $j0fVO.NetworkController).state.caipNetwork;
        this.unsubscribe.push(...[
            (0, $aoKpV.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    this.address = val.address;
                    this.balanceVal = val.balance;
                    this.profileName = val.profileName;
                    this.profileImage = val.profileImage;
                    this.balanceSymbol = val.balanceSymbol;
                } else {
                    this.address = "";
                    this.balanceVal = "";
                    this.profileName = "";
                    this.profileImage = "";
                    this.balanceSymbol = "";
                }
            }),
            (0, $j0fVO.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const networkImage = (0, $efzgw.AssetUtil).getNetworkImage(this.network);
        const showBalance = this.balance === "show";
        return (0, $8AeG9.html)`
      <wui-account-button
        .disabled=${Boolean(this.disabled)}
        address=${(0, $ljfXw.ifDefined)(this.profileName ?? this.address)}
        ?isProfileName=${Boolean(this.profileName)}
        networkSrc=${(0, $ljfXw.ifDefined)(networkImage)}
        avatarSrc=${(0, $ljfXw.ifDefined)(this.profileImage)}
        balance=${showBalance ? (0, $bYnq1.CoreHelperUtil).formatBalance(this.balanceVal, this.balanceSymbol) : ""}
        @click=${this.onClick.bind(this)}
        data-testid="account-button"
        .charsStart=${this.charsStart}
        .charsEnd=${this.charsEnd}
      >
      </wui-account-button>
    `;
    }
    onClick() {
        (0, $6CqNZ.ModalController).open();
    }
};
$cde2776e2e4ef349$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "disabled", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $kRRY9.property)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "balance", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $kRRY9.property)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "charsStart", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $kRRY9.property)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "charsEnd", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "address", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "balanceVal", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "balanceSymbol", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "profileName", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "profileImage", void 0);
$cde2776e2e4ef349$var$__decorate([
    (0, $dBBvD.state)()
], $cde2776e2e4ef349$export$f039a2838669d98e.prototype, "network", void 0);
$cde2776e2e4ef349$export$f039a2838669d98e = $cde2776e2e4ef349$var$__decorate([
    (0, $33Xir.customElement)("w3m-account-button")
], $cde2776e2e4ef349$export$f039a2838669d98e);


parcelRequire("k1l85");
var $aoKpV = parcelRequire("aoKpV");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $791986db58a12203$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $d046a72342f4f802$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d046a72342f4f802$export$857f19a8cabe3497 = class W3mButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = undefined;
        this.size = undefined;
        this.label = undefined;
        this.loadingLabel = undefined;
        this.charsStart = 4;
        this.charsEnd = 6;
        this.isAccount = (0, $aoKpV.AccountController).state.isConnected;
        this.unsubscribe.push((0, $aoKpV.AccountController).subscribeKey("isConnected", (val)=>{
            this.isAccount = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return this.isAccount ? (0, $8AeG9.html)`
          <w3m-account-button
            .disabled=${Boolean(this.disabled)}
            balance=${(0, $ljfXw.ifDefined)(this.balance)}
            .charsStart=${(0, $ljfXw.ifDefined)(this.charsStart)}
            .charsEnd=${(0, $ljfXw.ifDefined)(this.charsEnd)}
          >
          </w3m-account-button>
        ` : (0, $8AeG9.html)`
          <w3m-connect-button
            size=${(0, $ljfXw.ifDefined)(this.size)}
            label=${(0, $ljfXw.ifDefined)(this.label)}
            loadingLabel=${(0, $ljfXw.ifDefined)(this.loadingLabel)}
          ></w3m-connect-button>
        `;
    }
};
$d046a72342f4f802$export$857f19a8cabe3497.styles = (0, $791986db58a12203$export$2e2bcd8739ae039);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "disabled", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "balance", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "size", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "label", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "loadingLabel", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "charsStart", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $kRRY9.property)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "charsEnd", void 0);
$d046a72342f4f802$var$__decorate([
    (0, $dBBvD.state)()
], $d046a72342f4f802$export$857f19a8cabe3497.prototype, "isAccount", void 0);
$d046a72342f4f802$export$857f19a8cabe3497 = $d046a72342f4f802$var$__decorate([
    (0, $33Xir.customElement)("w3m-button")
], $d046a72342f4f802$export$857f19a8cabe3497);


parcelRequire("k1l85");
var $6CqNZ = parcelRequire("6CqNZ");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
var $180492e583103e25$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $180492e583103e25$export$277240c185e0322e = class W3mConnectButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.size = "md";
        this.label = "Connect Wallet";
        this.loadingLabel = "Connecting...";
        this.open = (0, $6CqNZ.ModalController).state.open;
        this.loading = (0, $6CqNZ.ModalController).state.loading;
        this.unsubscribe.push((0, $6CqNZ.ModalController).subscribe((val)=>{
            this.open = val.open;
            this.loading = val.loading;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const isLoading = this.loading || this.open;
        return (0, $8AeG9.html)`
      <wui-connect-button
        size=${(0, $ljfXw.ifDefined)(this.size)}
        .loading=${isLoading}
        @click=${this.onClick.bind(this)}
        data-testid="connect-button"
      >
        ${isLoading ? this.loadingLabel : this.label}
      </wui-connect-button>
    `;
    }
    onClick() {
        if (this.open) (0, $6CqNZ.ModalController).close();
        else if (!this.loading) (0, $6CqNZ.ModalController).open();
    }
};
$180492e583103e25$var$__decorate([
    (0, $kRRY9.property)()
], $180492e583103e25$export$277240c185e0322e.prototype, "size", void 0);
$180492e583103e25$var$__decorate([
    (0, $kRRY9.property)()
], $180492e583103e25$export$277240c185e0322e.prototype, "label", void 0);
$180492e583103e25$var$__decorate([
    (0, $kRRY9.property)()
], $180492e583103e25$export$277240c185e0322e.prototype, "loadingLabel", void 0);
$180492e583103e25$var$__decorate([
    (0, $dBBvD.state)()
], $180492e583103e25$export$277240c185e0322e.prototype, "open", void 0);
$180492e583103e25$var$__decorate([
    (0, $dBBvD.state)()
], $180492e583103e25$export$277240c185e0322e.prototype, "loading", void 0);
$180492e583103e25$export$277240c185e0322e = $180492e583103e25$var$__decorate([
    (0, $33Xir.customElement)("w3m-connect-button")
], $180492e583103e25$export$277240c185e0322e);


parcelRequire("8WgY8");
parcelRequire("k1l85");
var $j0fVO = parcelRequire("j0fVO");
var $aoKpV = parcelRequire("aoKpV");
var $6CqNZ = parcelRequire("6CqNZ");
var $efzgw = parcelRequire("efzgw");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $8d4b6712f7fb84db$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $f751cf0c88e10b73$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f751cf0c88e10b73$export$28375bf34267491c = class W3mNetworkButton extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.network = (0, $j0fVO.NetworkController).state.caipNetwork;
        this.connected = (0, $aoKpV.AccountController).state.isConnected;
        this.loading = (0, $6CqNZ.ModalController).state.loading;
        this.unsubscribe.push(...[
            (0, $j0fVO.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $aoKpV.AccountController).subscribeKey("isConnected", (val)=>this.connected = val),
            (0, $6CqNZ.ModalController).subscribeKey("loading", (val)=>this.loading = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-network-button
        .disabled=${Boolean(this.disabled || this.loading)}
        imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getNetworkImage(this.network))}
        @click=${this.onClick.bind(this)}
      >
        ${this.network?.name ?? (this.connected ? "Unknown Network" : "Select Network")}
      </wui-network-button>
    `;
    }
    onClick() {
        if (!this.loading) (0, $6CqNZ.ModalController).open({
            view: "Networks"
        });
    }
};
$f751cf0c88e10b73$export$28375bf34267491c.styles = (0, $8d4b6712f7fb84db$export$2e2bcd8739ae039);
$f751cf0c88e10b73$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $f751cf0c88e10b73$export$28375bf34267491c.prototype, "disabled", void 0);
$f751cf0c88e10b73$var$__decorate([
    (0, $dBBvD.state)()
], $f751cf0c88e10b73$export$28375bf34267491c.prototype, "network", void 0);
$f751cf0c88e10b73$var$__decorate([
    (0, $dBBvD.state)()
], $f751cf0c88e10b73$export$28375bf34267491c.prototype, "connected", void 0);
$f751cf0c88e10b73$var$__decorate([
    (0, $dBBvD.state)()
], $f751cf0c88e10b73$export$28375bf34267491c.prototype, "loading", void 0);
$f751cf0c88e10b73$export$28375bf34267491c = $f751cf0c88e10b73$var$__decorate([
    (0, $33Xir.customElement)("w3m-network-button")
], $f751cf0c88e10b73$export$28375bf34267491c);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $a9201467a9342a59$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    will-change: transform, opacity;
  }
`;


var $990fdbfa943f5dca$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $990fdbfa943f5dca$export$ccc15c9e32141a55 = class W3mRouter extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.resizeObserver = undefined;
        this.prevHeight = "0px";
        this.prevHistoryLength = 1;
        this.unsubscribe = [];
        this.view = (0, $eMpli.RouterController).state.view;
        this.unsubscribe.push((0, $eMpli.RouterController).subscribeKey("view", (val)=>this.onViewChange(val)));
    }
    firstUpdated() {
        this.resizeObserver = new ResizeObserver(async ([content])=>{
            const height = `${content?.contentRect.height}px`;
            if (this.prevHeight !== "0px") {
                await this.animate([
                    {
                        height: this.prevHeight
                    },
                    {
                        height: height
                    }
                ], {
                    duration: 150,
                    easing: "ease",
                    fill: "forwards"
                }).finished;
                this.style.height = "auto";
            }
            this.prevHeight = height;
        });
        this.resizeObserver.observe(this.getWrapper());
    }
    disconnectedCallback() {
        this.resizeObserver?.unobserve(this.getWrapper());
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`<div>${this.viewTemplate()}</div>`;
    }
    viewTemplate() {
        switch(this.view){
            case "Connect":
                return (0, $8AeG9.html)`<w3m-connect-view></w3m-connect-view>`;
            case "ConnectingWalletConnect":
                return (0, $8AeG9.html)`<w3m-connecting-wc-view></w3m-connecting-wc-view>`;
            case "ConnectingExternal":
                return (0, $8AeG9.html)`<w3m-connecting-external-view></w3m-connecting-external-view>`;
            case "ConnectingSiwe":
                return (0, $8AeG9.html)`<w3m-connecting-siwe-view></w3m-connecting-siwe-view>`;
            case "AllWallets":
                return (0, $8AeG9.html)`<w3m-all-wallets-view></w3m-all-wallets-view>`;
            case "Networks":
                return (0, $8AeG9.html)`<w3m-networks-view></w3m-networks-view>`;
            case "SwitchNetwork":
                return (0, $8AeG9.html)`<w3m-network-switch-view></w3m-network-switch-view>`;
            case "Account":
                return (0, $8AeG9.html)`<w3m-account-view></w3m-account-view>`;
            case "WhatIsAWallet":
                return (0, $8AeG9.html)`<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>`;
            case "WhatIsANetwork":
                return (0, $8AeG9.html)`<w3m-what-is-a-network-view></w3m-what-is-a-network-view>`;
            case "GetWallet":
                return (0, $8AeG9.html)`<w3m-get-wallet-view></w3m-get-wallet-view>`;
            case "Downloads":
                return (0, $8AeG9.html)`<w3m-downloads-view></w3m-downloads-view>`;
            case "EmailVerifyOtp":
                return (0, $8AeG9.html)`<w3m-email-verify-otp-view></w3m-email-verify-otp-view>`;
            case "EmailVerifyDevice":
                return (0, $8AeG9.html)`<w3m-email-verify-device-view></w3m-email-verify-device-view>`;
            case "ApproveTransaction":
                return (0, $8AeG9.html)`<w3m-approve-transaction-view></w3m-approve-transaction-view>`;
            case "Transactions":
                return (0, $8AeG9.html)`<w3m-transactions-view></w3m-transactions-view>`;
            case "UpgradeEmailWallet":
                return (0, $8AeG9.html)`<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>`;
            case "UpdateEmailWallet":
                return (0, $8AeG9.html)`<w3m-update-email-wallet-view></w3m-update-email-wallet-view>`;
            case "UpdateEmailWalletWaiting":
                return (0, $8AeG9.html)`<w3m-update-email-wallet-waiting-view></w3m-update-email-wallet-waiting-view>`;
            default:
                return (0, $8AeG9.html)`<w3m-connect-view></w3m-connect-view>`;
        }
    }
    async onViewChange(newView) {
        const { history: history } = (0, $eMpli.RouterController).state;
        let xOut = -10;
        let xIn = 10;
        if (history.length < this.prevHistoryLength) {
            xOut = 10;
            xIn = -10;
        }
        this.prevHistoryLength = history.length;
        await this.animate([
            {
                opacity: 1,
                transform: "translateX(0px)"
            },
            {
                opacity: 0,
                transform: `translateX(${xOut}px)`
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.view = newView;
        await this.animate([
            {
                opacity: 0,
                transform: `translateX(${xIn}px)`
            },
            {
                opacity: 1,
                transform: "translateX(0px)"
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards",
            delay: 50
        }).finished;
    }
    getWrapper() {
        return this.shadowRoot?.querySelector("div");
    }
};
$990fdbfa943f5dca$export$ccc15c9e32141a55.styles = (0, $a9201467a9342a59$export$2e2bcd8739ae039);
$990fdbfa943f5dca$var$__decorate([
    (0, $dBBvD.state)()
], $990fdbfa943f5dca$export$ccc15c9e32141a55.prototype, "view", void 0);
$990fdbfa943f5dca$export$ccc15c9e32141a55 = $990fdbfa943f5dca$var$__decorate([
    (0, $33Xir.customElement)("w3m-router")
], $990fdbfa943f5dca$export$ccc15c9e32141a55);


parcelRequire("k1l85");
var $aoKpV = parcelRequire("aoKpV");
var $j0fVO = parcelRequire("j0fVO");
var $6CqNZ = parcelRequire("6CqNZ");
var $efzgw = parcelRequire("efzgw");
var $bYnq1 = parcelRequire("bYnq1");
var $jheXw = parcelRequire("jheXw");
var $8L7Gu = parcelRequire("8L7Gu");
var $fz7Cd = parcelRequire("fz7Cd");
var $45Xo0 = parcelRequire("45Xo0");
var $eMpli = parcelRequire("eMpli");
var $bE42d = parcelRequire("bE42d");
var $58zho = parcelRequire("58zho");
parcelRequire("bG7tm");
var $8iLLL = parcelRequire("8iLLL");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $f79127c24845f056$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-flex {
    width: 100%;
  }

  :host > wui-flex:first-child {
    transform: translateY(calc(var(--wui-spacing-xxs) * -1));
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  wui-notice-card {
    margin-bottom: var(--wui-spacing-3xs);
  }
`;


var $1943880671b07789$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1943880671b07789$export$fb2cfdfbb483d2ac = class W3mAccountView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.usubscribe = [];
        this.address = (0, $aoKpV.AccountController).state.address;
        this.profileImage = (0, $aoKpV.AccountController).state.profileImage;
        this.profileName = (0, $aoKpV.AccountController).state.profileName;
        this.balance = (0, $aoKpV.AccountController).state.balance;
        this.balanceSymbol = (0, $aoKpV.AccountController).state.balanceSymbol;
        this.network = (0, $j0fVO.NetworkController).state.caipNetwork;
        this.disconecting = false;
        this.usubscribe.push(...[
            (0, $aoKpV.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else (0, $6CqNZ.ModalController).close();
            })
        ], (0, $j0fVO.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.usubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        const networkImage = (0, $efzgw.AssetUtil).getNetworkImage(this.network);
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "s",
            "m",
            "s"
        ]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $ljfXw.ifDefined)(this.profileImage === null ? undefined : this.profileImage)}
        ></wui-avatar>

        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="large-600" color="fg-100">
              ${this.profileName ? (0, $8iLLL.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $8iLLL.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-flex gap="s" flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-200">
              ${(0, $bYnq1.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}
            </wui-text>

            ${this.explorerBtnTemplate()}
          </wui-flex>
        </wui-flex>
      </wui-flex>

      <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}>
        ${this.emailCardTemplate()} ${this.emailBtnTemplate()}

        <wui-list-item
          .variant=${networkImage ? "image" : "icon"}
          iconVariant="overlay"
          icon="networkPlaceholder"
          imageSrc=${(0, $ljfXw.ifDefined)(networkImage)}
          ?chevron=${this.isAllowedNetworkSwitch()}
          @click=${this.onNetworks.bind(this)}
          data-testid="w3m-account-select-network"
        >
          <wui-text variant="paragraph-500" color="fg-100">
            ${this.network?.name ?? "Unknown"}
          </wui-text>
        </wui-list-item>
        <wui-list-item
          iconVariant="blue"
          icon="swapHorizontalBold"
          iconSize="sm"
          ?chevron=${true}
          @click=${this.onTransactions.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
        </wui-list-item>
        <wui-list-item
          variant="icon"
          iconVariant="overlay"
          icon="disconnect"
          ?chevron=${false}
          .loading=${this.disconecting}
          @click=${this.onDisconnect.bind(this)}
          data-testid="disconnect-button"
        >
          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
        </wui-list-item>
      </wui-flex>
    `;
    }
    emailCardTemplate() {
        const type = (0, $jheXw.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
        const { origin: origin } = location;
        if (!emailConnector || type !== "EMAIL" || origin.includes((0, $fz7Cd.ConstantsUtil).SECURE_SITE)) return null;
        return (0, $8AeG9.html)`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a non-custodial wallet"
        icon="wallet"
      ></wui-notice-card>
    `;
    }
    emailBtnTemplate() {
        const type = (0, $jheXw.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
        if (!emailConnector || type !== "EMAIL") return null;
        const email = emailConnector.provider.getEmail() ?? "";
        return (0, $8AeG9.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon="mail"
        iconSize="sm"
        ?chevron=${true}
        @click=${()=>this.onGoToUpdateEmail(email)}
      >
        <wui-text variant="paragraph-500" color="fg-100">${email}</wui-text>
      </wui-list-item>
    `;
    }
    explorerBtnTemplate() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $aoKpV.AccountController).state;
        if (!addressExplorerUrl) return null;
        return (0, $8AeG9.html)`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    isAllowedNetworkSwitch() {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $j0fVO.NetworkController).state;
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $bYnq1.CoreHelperUtil).copyToClopboard(this.address);
                (0, $45Xo0.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $45Xo0.SnackController).showError("Failed to copy");
        }
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) (0, $eMpli.RouterController).push("Networks");
    }
    onTransactions() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS"
        });
        (0, $eMpli.RouterController).push("Transactions");
    }
    async onDisconnect() {
        try {
            this.disconecting = true;
            await (0, $58zho.ConnectionController).disconnect();
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $6CqNZ.ModalController).close();
        } catch  {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $45Xo0.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconecting = false;
        }
    }
    onExplorer() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $aoKpV.AccountController).state;
        if (addressExplorerUrl) (0, $bYnq1.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
    onGoToUpgradeView() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_UPGRADE_FROM_MODAL"
        });
        (0, $eMpli.RouterController).push("UpgradeEmailWallet");
    }
    onGoToUpdateEmail(email) {
        (0, $eMpli.RouterController).push("UpdateEmailWallet", {
            email: email
        });
    }
};
$1943880671b07789$export$fb2cfdfbb483d2ac.styles = (0, $f79127c24845f056$export$2e2bcd8739ae039);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "address", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "profileImage", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "profileName", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "balance", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "balanceSymbol", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "network", void 0);
$1943880671b07789$var$__decorate([
    (0, $dBBvD.state)()
], $1943880671b07789$export$fb2cfdfbb483d2ac.prototype, "disconecting", void 0);
$1943880671b07789$export$fb2cfdfbb483d2ac = $1943880671b07789$var$__decorate([
    (0, $33Xir.customElement)("w3m-account-view")
], $1943880671b07789$export$fb2cfdfbb483d2ac);


parcelRequire("k1l85");
var $bYnq1 = parcelRequire("bYnq1");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $11d59b0539c0a938$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $11d59b0539c0a938$export$88f35657f4e64778 = class W3mAllWalletsView extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.search = "";
        this.onDebouncedSearch = (0, $bYnq1.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        });
    }
    render() {
        const isSearch = this.search.length >= 2;
        return (0, $8AeG9.html)`
      <wui-flex padding="s" gap="s">
        <wui-search-bar @inputChange=${this.onInputChange.bind(this)}></wui-search-bar>
        ${this.qrButtonTemplate()}
      </wui-flex>
      ${isSearch ? (0, $8AeG9.html)`<w3m-all-wallets-search query=${this.search}></w3m-all-wallets-search>` : (0, $8AeG9.html)`<w3m-all-wallets-list></w3m-all-wallets-list>`}
    `;
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    qrButtonTemplate() {
        if ((0, $bYnq1.CoreHelperUtil).isMobile()) return (0, $8AeG9.html)`
        <wui-icon-box
          size="lg"
          iconSize="xl"
          iconColor="accent-100"
          backgroundColor="accent-100"
          icon="qrCode"
          background="transparent"
          border
          borderColor="wui-accent-glass-010"
          @click=${this.onWalletConnectQr.bind(this)}
        ></wui-icon-box>
      `;
        return null;
    }
    onWalletConnectQr() {
        (0, $eMpli.RouterController).push("ConnectingWalletConnect");
    }
};
$11d59b0539c0a938$var$__decorate([
    (0, $dBBvD.state)()
], $11d59b0539c0a938$export$88f35657f4e64778.prototype, "search", void 0);
$11d59b0539c0a938$export$88f35657f4e64778 = $11d59b0539c0a938$var$__decorate([
    (0, $33Xir.customElement)("w3m-all-wallets-view")
], $11d59b0539c0a938$export$88f35657f4e64778);


parcelRequire("k1l85");
var $8L7Gu = parcelRequire("8L7Gu");
var $bYnq1 = parcelRequire("bYnq1");
var $efzgw = parcelRequire("efzgw");
var $3pfUo = parcelRequire("3pfUo");
var $k7Co7 = parcelRequire("k7Co7");
var $jheXw = parcelRequire("jheXw");
var $58zho = parcelRequire("58zho");
var $fz7Cd = parcelRequire("fz7Cd");
var $eMpli = parcelRequire("eMpli");
var $bE42d = parcelRequire("bE42d");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $27aba27d2fe7fbfc$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $c46c2f8fd5c49e36$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c46c2f8fd5c49e36$export$b7220f3d0ae9dbca = class W3mConnectView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $8L7Gu.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $8L7Gu.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-email-login-widget></w3m-email-login-widget>

        ${this.walletConnectConnectorTemplate()} ${this.recentTemplate()}
        ${this.announcedTemplate()} ${this.injectedTemplate()} ${this.featuredTemplate()}
        ${this.customTemplate()} ${this.recommendedTemplate()} ${this.connectorsTemplate()}
        ${this.allWalletsTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    walletConnectConnectorTemplate() {
        if ((0, $bYnq1.CoreHelperUtil).isMobile()) return null;
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        return (0, $8AeG9.html)`
      <wui-list-wallet
        imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getConnectorImage(connector))}
        name=${connector.name ?? "Unknown"}
        @click=${()=>this.onConnector(connector)}
        tagLabel="qr code"
        tagVariant="main"
        data-testid="wallet-selector-walletconnect"
      >
      </wui-list-wallet>
    `;
    }
    customTemplate() {
        const { customWallets: customWallets } = (0, $3pfUo.OptionsController).state;
        if (!customWallets?.length) return null;
        const wallets = this.filterOutDuplicateWallets(customWallets);
        return wallets.map((wallet)=>(0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    featuredTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { featured: featured } = (0, $k7Co7.ApiController).state;
        if (!featured.length) return null;
        const wallets = this.filterOutDuplicateWallets(featured);
        return wallets.map((wallet)=>(0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    recentTemplate() {
        const recent = (0, $jheXw.StorageUtil).getRecentWallets();
        return recent.map((wallet)=>(0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
          tagLabel="recent"
          tagVariant="shade"
        >
        </wui-list-wallet>
      `);
    }
    announcedTemplate() {
        return this.connectors.map((connector)=>{
            if (connector.type !== "ANNOUNCED") return null;
            return (0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
          tagVariant="success"
          .installed=${true}
        >
        </wui-list-wallet>
      `;
        });
    }
    injectedTemplate() {
        const announced = this.connectors.find((c)=>c.type === "ANNOUNCED");
        return this.connectors.map((connector)=>{
            if (connector.type !== "INJECTED") return null;
            if (!(0, $58zho.ConnectionController).checkInstalled()) return null;
            return (0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getConnectorImage(connector))}
          .installed=${Boolean(announced)}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    connectorsTemplate() {
        const announcedRdns = (0, $8L7Gu.ConnectorController).getAnnouncedConnectorRdns();
        return this.connectors.map((connector)=>{
            if ([
                "WALLET_CONNECT",
                "INJECTED",
                "ANNOUNCED",
                "EMAIL"
            ].includes(connector.type)) return null;
            if (announcedRdns.includes((0, $fz7Cd.ConstantsUtil).CONNECTOR_RDNS_MAP[connector.id])) return null;
            return (0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    allWalletsTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const count = (0, $k7Co7.ApiController).state.count;
        const featuredCount = (0, $k7Co7.ApiController).state.featured.length;
        const rawCount = count + featuredCount;
        const roundedCount = rawCount < 10 ? rawCount : Math.floor(rawCount / 10) * 10;
        const tagLabel = roundedCount < rawCount ? `${roundedCount}+` : `${roundedCount}`;
        return (0, $8AeG9.html)`
      <wui-list-wallet
        name="All Wallets"
        walletIcon="allWallets"
        showAllWallets
        @click=${this.onAllWallets.bind(this)}
        tagLabel=${tagLabel}
        tagVariant="shade"
        data-testid="all-wallets"
      ></wui-list-wallet>
    `;
    }
    recommendedTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { recommended: recommended } = (0, $k7Co7.ApiController).state;
        const { customWallets: customWallets, featuredWalletIds: featuredWalletIds } = (0, $3pfUo.OptionsController).state;
        const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
        const recent = (0, $jheXw.StorageUtil).getRecentWallets();
        const eip6963 = connectors.filter((c)=>c.type === "ANNOUNCED");
        if (featuredWalletIds || customWallets || !recommended.length) return null;
        const overrideLength = eip6963.length + recent.length;
        const maxRecommended = Math.max(0, 2 - overrideLength);
        const wallets = this.filterOutDuplicateWallets(recommended).slice(0, maxRecommended);
        return wallets.map((wallet)=>(0, $8AeG9.html)`
        <wui-list-wallet
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          name=${wallet?.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    onConnector(connector) {
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $bYnq1.CoreHelperUtil).isMobile()) (0, $eMpli.RouterController).push("AllWallets");
            else (0, $eMpli.RouterController).push("ConnectingWalletConnect");
        } else (0, $eMpli.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
    filterOutDuplicateWallets(wallets) {
        const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
        const recent = (0, $jheXw.StorageUtil).getRecentWallets();
        const recentIds = recent.map((wallet)=>wallet.id);
        const rdnsIds = connectors.map((c)=>c.info?.rdns).filter(Boolean);
        const filtered = wallets.filter((wallet)=>!recentIds.includes(wallet.id) && !rdnsIds.includes(wallet.rdns ?? undefined));
        return filtered;
    }
    onAllWallets() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CLICK_ALL_WALLETS"
        });
        (0, $eMpli.RouterController).push("AllWallets");
    }
    onConnectWallet(wallet) {
        (0, $eMpli.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$c46c2f8fd5c49e36$export$b7220f3d0ae9dbca.styles = (0, $27aba27d2fe7fbfc$export$2e2bcd8739ae039);
$c46c2f8fd5c49e36$var$__decorate([
    (0, $dBBvD.state)()
], $c46c2f8fd5c49e36$export$b7220f3d0ae9dbca.prototype, "connectors", void 0);
$c46c2f8fd5c49e36$export$b7220f3d0ae9dbca = $c46c2f8fd5c49e36$var$__decorate([
    (0, $33Xir.customElement)("w3m-connect-view")
], $c46c2f8fd5c49e36$export$b7220f3d0ae9dbca);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $jheXw = parcelRequire("jheXw");
var $58zho = parcelRequire("58zho");
var $afSSl = parcelRequire("afSSl");
var $eMpli = parcelRequire("eMpli");
var $6CqNZ = parcelRequire("6CqNZ");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $efzgw = parcelRequire("efzgw");
var $58zho = parcelRequire("58zho");
var $eMTTW = parcelRequire("eMTTW");
var $bYnq1 = parcelRequire("bYnq1");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $3c4fa32b8fc446db$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }
`;


var $67ff31ff27e88f46$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $67ff31ff27e88f46$export$902e3cfa9f67689d extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $eMpli.RouterController).state.data?.wallet;
        this.connector = (0, $eMpli.RouterController).state.data?.connector;
        this.timeout = undefined;
        this.secondaryBtnLabel = "Try again";
        this.secondaryBtnIcon = "refresh";
        this.secondaryLabel = "Accept connection request in the wallet";
        this.onConnect = undefined;
        this.onRender = undefined;
        this.onAutoConnect = undefined;
        this.isWalletConnect = true;
        this.unsubscribe = [];
        this.imageSrc = (0, $efzgw.AssetUtil).getWalletImage(this.wallet) ?? (0, $efzgw.AssetUtil).getConnectorImage(this.connector);
        this.name = this.wallet?.name ?? this.connector?.name ?? "Wallet";
        this.isRetrying = false;
        this.uri = (0, $58zho.ConnectionController).state.wcUri;
        this.error = (0, $58zho.ConnectionController).state.wcError;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $58zho.ConnectionController).subscribeKey("wcUri", (val)=>{
                this.uri = val;
                if (this.isRetrying && this.onRetry) {
                    this.isRetrying = false;
                    this.onConnect?.();
                }
            }),
            (0, $58zho.ConnectionController).subscribeKey("wcError", (val)=>this.error = val),
            (0, $58zho.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val)
        ]);
    }
    firstUpdated() {
        this.onAutoConnect?.();
        this.showRetry = !this.onAutoConnect;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        clearTimeout(this.timeout);
    }
    render() {
        this.onRender?.();
        this.onShowRetry();
        const subLabel = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
        let label = `Continue in ${this.name}`;
        if (this.buffering) label = "Connecting...";
        if (this.error) label = "Connection declined";
        return (0, $8AeG9.html)`
      <wui-flex
        data-error=${(0, $ljfXw.ifDefined)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image size="lg" imageSrc=${(0, $ljfXw.ifDefined)(this.imageSrc)}></wui-wallet-image>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          variant="accent"
          ?disabled=${!this.error && this.buffering}
          @click=${this.onTryAgain.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name=${this.secondaryBtnIcon}></wui-icon>
          ${this.secondaryBtnLabel}
        </wui-button>
      </wui-flex>

      ${this.isWalletConnect ? (0, $8AeG9.html)`
            <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
              <wui-link @click=${this.onCopyUri} color="fg-200">
                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
                Copy link
              </wui-link>
            </wui-flex>
          ` : null}

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onTryAgain() {
        if (!this.buffering) {
            (0, $58zho.ConnectionController).setWcError(false);
            if (this.onRetry) {
                this.isRetrying = true;
                this.onRetry?.();
            } else this.onConnect?.();
        }
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $eMTTW.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $8AeG9.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        try {
            if (this.uri) {
                (0, $bYnq1.CoreHelperUtil).copyToClopboard(this.uri);
                (0, $45Xo0.SnackController).showSuccess("Link copied");
            }
        } catch  {
            (0, $45Xo0.SnackController).showError("Failed to copy");
        }
    }
}
$67ff31ff27e88f46$export$902e3cfa9f67689d.styles = (0, $3c4fa32b8fc446db$export$2e2bcd8739ae039);
$67ff31ff27e88f46$var$__decorate([
    (0, $dBBvD.state)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "uri", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $dBBvD.state)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "error", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $dBBvD.state)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "ready", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $dBBvD.state)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "showRetry", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $dBBvD.state)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "buffering", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $kRRY9.property)({
        type: Boolean
    })
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "isMobile", void 0);
$67ff31ff27e88f46$var$__decorate([
    (0, $kRRY9.property)()
], $67ff31ff27e88f46$export$902e3cfa9f67689d.prototype, "onRetry", void 0);


var $45089002a3a58123$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $45089002a3a58123$var$platformMap = {
    INJECTED: "browser",
    ANNOUNCED: "browser"
};
let $45089002a3a58123$export$1d20b0281d81b1fd = class W3mConnectingExternalView extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.connector) throw new Error("w3m-connecting-view: No connector provided");
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.connector.name ?? "Unknown",
                platform: $45089002a3a58123$var$platformMap[this.connector.type] ?? "external"
            }
        });
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        this.isWalletConnect = false;
    }
    async onConnectProxy() {
        try {
            this.error = false;
            if (this.connector) {
                if (this.connector.imageUrl) (0, $jheXw.StorageUtil).setConnectedWalletImageUrl(this.connector.imageUrl);
                await (0, $58zho.ConnectionController).connectExternal(this.connector);
                if ((0, $afSSl.SIWEController).state.isSiweEnabled) (0, $eMpli.RouterController).push("ConnectingSiwe");
                else (0, $6CqNZ.ModalController).close();
                (0, $bE42d.EventsController).sendEvent({
                    type: "track",
                    event: "CONNECT_SUCCESS",
                    properties: {
                        method: "external"
                    }
                });
            }
        } catch (error) {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$45089002a3a58123$export$1d20b0281d81b1fd = $45089002a3a58123$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-external-view")
], $45089002a3a58123$export$1d20b0281d81b1fd);


parcelRequire("k1l85");
var $3pfUo = parcelRequire("3pfUo");
var $bE42d = parcelRequire("bE42d");
var $afSSl = parcelRequire("afSSl");
var $45Xo0 = parcelRequire("45Xo0");
var $aoKpV = parcelRequire("aoKpV");
var $58zho = parcelRequire("58zho");
var $6CqNZ = parcelRequire("6CqNZ");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $2c299bc849685c8e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2c299bc849685c8e$export$cbe596dc0e3ac801 = class W3mConnectingSiweView extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.dappName = (0, $3pfUo.OptionsController).state.metadata?.name;
        this.isSigning = false;
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex justifyContent="center" .padding=${[
            "2xl",
            "0",
            "xxl",
            "0"
        ]}>
        <w3m-connecting-siwe></w3m-connecting-siwe>
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "4xl",
            "l",
            "4xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="paragraph-500" align="center" color="fg-100"
          >${this.dappName ?? "Dapp"} needs to connect to your wallet</wui-text
        >
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "3xl",
            "l",
            "3xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="small-400" align="center" color="fg-200"
          >Sign this message to prove you own this wallet and proceed. Canceling will disconnect
          you.</wui-text
        >
      </wui-flex>
      <wui-flex .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]} gap="s" justifyContent="space-between">
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="shade"
          @click=${this.onCancel.bind(this)}
          data-testid="w3m-connecting-siwe-cancel"
        >
          Cancel
        </wui-button>
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="fill"
          @click=${this.onSign.bind(this)}
          ?loading=${this.isSigning}
          data-testid="w3m-connecting-siwe-sign"
        >
          ${this.isSigning ? "Signing..." : "Sign"}
        </wui-button>
      </wui-flex>
    `;
    }
    async onSign() {
        this.isSigning = true;
        (0, $bE42d.EventsController).sendEvent({
            event: "CLICK_SIGN_SIWE_MESSAGE",
            type: "track"
        });
        try {
            (0, $afSSl.SIWEController).setStatus("loading");
            const session = await (0, $afSSl.SIWEController).signIn();
            (0, $afSSl.SIWEController).setStatus("success");
            (0, $bE42d.EventsController).sendEvent({
                event: "SIWE_AUTH_SUCCESS",
                type: "track"
            });
            return session;
        } catch (error) {
            (0, $45Xo0.SnackController).showError("Signature declined");
            (0, $afSSl.SIWEController).setStatus("error");
            return (0, $bE42d.EventsController).sendEvent({
                event: "SIWE_AUTH_ERROR",
                type: "track"
            });
        } finally{
            this.isSigning = false;
        }
    }
    async onCancel() {
        const { isConnected: isConnected } = (0, $aoKpV.AccountController).state;
        if (isConnected) {
            await (0, $58zho.ConnectionController).disconnect();
            (0, $6CqNZ.ModalController).close();
        } else (0, $eMpli.RouterController).push("Connect");
        (0, $bE42d.EventsController).sendEvent({
            event: "CLICK_CANCEL_SIWE",
            type: "track"
        });
    }
};
$2c299bc849685c8e$var$__decorate([
    (0, $dBBvD.state)()
], $2c299bc849685c8e$export$cbe596dc0e3ac801.prototype, "isSigning", void 0);
$2c299bc849685c8e$export$cbe596dc0e3ac801 = $2c299bc849685c8e$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-siwe-view")
], $2c299bc849685c8e$export$cbe596dc0e3ac801);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $fz7Cd = parcelRequire("fz7Cd");
var $58zho = parcelRequire("58zho");
var $bYnq1 = parcelRequire("bYnq1");
var $efzgw = parcelRequire("efzgw");
var $jheXw = parcelRequire("jheXw");
var $8L7Gu = parcelRequire("8L7Gu");
var $afSSl = parcelRequire("afSSl");
var $6CqNZ = parcelRequire("6CqNZ");
var $bE42d = parcelRequire("bE42d");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $ffe21afc36ebd2f3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ffe21afc36ebd2f3$export$749260f2a44cfead = class W3mConnectingWcView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.interval = undefined;
        this.lastRetry = Date.now();
        this.wallet = (0, $eMpli.RouterController).state.data?.wallet;
        this.platform = undefined;
        this.platforms = [];
        this.initializeConnection();
        this.interval = setInterval(this.initializeConnection.bind(this), (0, $fz7Cd.ConstantsUtil).TEN_SEC_MS);
    }
    disconnectedCallback() {
        clearTimeout(this.interval);
    }
    render() {
        if (!this.wallet) return (0, $8AeG9.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
        this.determinePlatforms();
        return (0, $8AeG9.html)`
      ${this.headerTemplate()}
      <div>${this.platformTemplate()}</div>
    `;
    }
    async initializeConnection(retry = false) {
        try {
            const { wcPairingExpiry: wcPairingExpiry } = (0, $58zho.ConnectionController).state;
            if (retry || (0, $bYnq1.CoreHelperUtil).isPairingExpired(wcPairingExpiry)) {
                (0, $58zho.ConnectionController).connectWalletConnect();
                if (this.wallet) {
                    const url = (0, $efzgw.AssetUtil).getWalletImage(this.wallet);
                    if (url) (0, $jheXw.StorageUtil).setConnectedWalletImageUrl(url);
                } else {
                    const connectors = (0, $8L7Gu.ConnectorController).state.connectors;
                    const connector = connectors.find((c)=>c.type === "WALLET_CONNECT");
                    const url = (0, $efzgw.AssetUtil).getConnectorImage(connector);
                    if (url) (0, $jheXw.StorageUtil).setConnectedWalletImageUrl(url);
                }
                await (0, $58zho.ConnectionController).state.wcPromise;
                this.finalizeConnection();
                if ((0, $afSSl.SIWEController).state.isSiweEnabled) (0, $eMpli.RouterController).push("ConnectingSiwe");
                else (0, $6CqNZ.ModalController).close();
            }
        } catch (error) {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            (0, $58zho.ConnectionController).setWcError(true);
            if ((0, $bYnq1.CoreHelperUtil).isAllowedRetry(this.lastRetry)) {
                (0, $45Xo0.SnackController).showError("Declined");
                this.lastRetry = Date.now();
                this.initializeConnection(true);
            }
        }
    }
    finalizeConnection() {
        const { wcLinking: wcLinking, recentWallet: recentWallet } = (0, $58zho.ConnectionController).state;
        if (wcLinking) (0, $jheXw.StorageUtil).setWalletConnectDeepLink(wcLinking);
        if (recentWallet) (0, $jheXw.StorageUtil).setWeb3ModalRecent(recentWallet);
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CONNECT_SUCCESS",
            properties: {
                method: wcLinking ? "mobile" : "qrcode"
            }
        });
    }
    determinePlatforms() {
        if (!this.wallet) throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
        if (this.platform) return;
        const { mobile_link: mobile_link, desktop_link: desktop_link, webapp_link: webapp_link, injected: injected, rdns: rdns } = this.wallet;
        const injectedIds = injected?.map(({ injected_id: injected_id })=>injected_id).filter(Boolean);
        const browserIds = rdns ? [
            rdns
        ] : injectedIds ?? [];
        const isBrowser = browserIds.length;
        const isMobileWc = mobile_link;
        const isWebWc = webapp_link;
        const isBrowserInstalled = (0, $58zho.ConnectionController).checkInstalled(browserIds);
        const isBrowserWc = isBrowser && isBrowserInstalled;
        const isDesktopWc = desktop_link && !(0, $bYnq1.CoreHelperUtil).isMobile();
        if (isBrowserWc) this.platforms.push("browser");
        if (isMobileWc) this.platforms.push((0, $bYnq1.CoreHelperUtil).isMobile() ? "mobile" : "qrcode");
        if (isWebWc) this.platforms.push("web");
        if (isDesktopWc) this.platforms.push("desktop");
        if (!isBrowserWc && isBrowser) this.platforms.push("unsupported");
        this.platform = this.platforms[0];
    }
    platformTemplate() {
        switch(this.platform){
            case "browser":
                return (0, $8AeG9.html)`<w3m-connecting-wc-browser></w3m-connecting-wc-browser>`;
            case "desktop":
                return (0, $8AeG9.html)`
          <w3m-connecting-wc-desktop .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-desktop>
        `;
            case "web":
                return (0, $8AeG9.html)`
          <w3m-connecting-wc-web .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-web>
        `;
            case "mobile":
                return (0, $8AeG9.html)`
          <w3m-connecting-wc-mobile isMobile .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-mobile>
        `;
            case "qrcode":
                return (0, $8AeG9.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
            default:
                return (0, $8AeG9.html)`<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>`;
        }
    }
    headerTemplate() {
        const multiPlatform = this.platforms.length > 1;
        if (!multiPlatform) return null;
        return (0, $8AeG9.html)`
      <w3m-connecting-header
        .platforms=${this.platforms}
        .onSelectPlatfrom=${this.onSelectPlatform.bind(this)}
      >
      </w3m-connecting-header>
    `;
    }
    async onSelectPlatform(platform) {
        const container = this.shadowRoot?.querySelector("div");
        if (container) {
            await container.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.platform = platform;
            container.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
};
$ffe21afc36ebd2f3$var$__decorate([
    (0, $dBBvD.state)()
], $ffe21afc36ebd2f3$export$749260f2a44cfead.prototype, "platform", void 0);
$ffe21afc36ebd2f3$var$__decorate([
    (0, $dBBvD.state)()
], $ffe21afc36ebd2f3$export$749260f2a44cfead.prototype, "platforms", void 0);
$ffe21afc36ebd2f3$export$749260f2a44cfead = $ffe21afc36ebd2f3$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-view")
], $ffe21afc36ebd2f3$export$749260f2a44cfead);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $bYnq1 = parcelRequire("bYnq1");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
var $d0592ca6ff69f5da$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d0592ca6ff69f5da$export$72485cd62e8c17e7 = class W3mDownloadsView extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = (0, $eMpli.RouterController).state.data?.wallet;
    }
    render() {
        if (!this.wallet) throw new Error("w3m-downloads-view");
        return (0, $8AeG9.html)`
      <wui-flex gap="xs" flexDirection="column" .padding=${[
            "s",
            "s",
            "l",
            "s"
        ]}>
        ${this.chromeTemplate()} ${this.iosTemplate()} ${this.androidTemplate()}
        ${this.homepageTemplate()}
      </wui-flex>
    `;
    }
    chromeTemplate() {
        if (!this.wallet?.chrome_store) return null;
        return (0, $8AeG9.html)`<wui-list-item
      variant="icon"
      icon="chromeStore"
      iconVariant="square"
      @click=${this.onChromeStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>
    </wui-list-item>`;
    }
    iosTemplate() {
        if (!this.wallet?.app_store) return null;
        return (0, $8AeG9.html)`<wui-list-item
      variant="icon"
      icon="appStore"
      iconVariant="square"
      @click=${this.onAppStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>
    </wui-list-item>`;
    }
    androidTemplate() {
        if (!this.wallet?.play_store) return null;
        return (0, $8AeG9.html)`<wui-list-item
      variant="icon"
      icon="playStore"
      iconVariant="square"
      @click=${this.onPlayStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>
    </wui-list-item>`;
    }
    homepageTemplate() {
        if (!this.wallet?.homepage) return null;
        return (0, $8AeG9.html)`
      <wui-list-item
        variant="icon"
        icon="browser"
        iconVariant="square-blue"
        @click=${this.onHomePage.bind(this)}
        chevron
      >
        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>
      </wui-list-item>
    `;
    }
    onChromeStore() {
        if (this.wallet?.chrome_store) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.chrome_store, "_blank");
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$d0592ca6ff69f5da$export$72485cd62e8c17e7 = $d0592ca6ff69f5da$var$__decorate([
    (0, $33Xir.customElement)("w3m-downloads-view")
], $d0592ca6ff69f5da$export$72485cd62e8c17e7);


parcelRequire("k1l85");
var $bYnq1 = parcelRequire("bYnq1");
var $k7Co7 = parcelRequire("k7Co7");
var $3pfUo = parcelRequire("3pfUo");
var $efzgw = parcelRequire("efzgw");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
var $31450ffc5769fffa$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $31450ffc5769fffa$var$EXPLORER = "https://walletconnect.com/explorer";
let $31450ffc5769fffa$export$24ca15e036ec0442 = class W3mGetWalletView extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.recommendedWalletsTemplate()}
        <wui-list-wallet
          name="Explore all"
          showAllWallets
          walletIcon="allWallets"
          icon="externalLink"
          @click=${()=>{
            (0, $bYnq1.CoreHelperUtil).openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
        }}
        ></wui-list-wallet>
      </wui-flex>
    `;
    }
    recommendedWalletsTemplate() {
        const { recommended: recommended, featured: featured } = (0, $k7Co7.ApiController).state;
        const { customWallets: customWallets } = (0, $3pfUo.OptionsController).state;
        const wallets = [
            ...featured,
            ...customWallets ?? [],
            ...recommended
        ].slice(0, 4);
        return wallets.map((wallet)=>(0, $8AeG9.html)`
        <wui-list-wallet
          name=${wallet.name ?? "Unknown"}
          tagVariant="main"
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          @click=${()=>{
                (0, $bYnq1.CoreHelperUtil).openHref(wallet.homepage ?? $31450ffc5769fffa$var$EXPLORER, "_blank");
            }}
        ></wui-list-wallet>
      `);
    }
};
$31450ffc5769fffa$export$24ca15e036ec0442 = $31450ffc5769fffa$var$__decorate([
    (0, $33Xir.customElement)("w3m-get-wallet-view")
], $31450ffc5769fffa$export$24ca15e036ec0442);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $efzgw = parcelRequire("efzgw");
var $j0fVO = parcelRequire("j0fVO");
var $afSSl = parcelRequire("afSSl");
var $ap614 = parcelRequire("ap614");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $2a07e234396ce111$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: 4px;
    bottom: 0;
    opacity: 0;
    transform: scale(0.5);
    z-index: 1;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-button {
    display: none;
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  wui-button[data-retry='true'] {
    display: block;
    opacity: 1;
  }
`;


var $341ee0e128e16f15$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $341ee0e128e16f15$export$d124f6a585588d61 = class W3mNetworkSwitchView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.network = (0, $eMpli.RouterController).state.data?.network;
        this.unsubscribe = [];
        this.showRetry = false;
        this.error = false;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.onSwitchNetwork();
    }
    render() {
        if (!this.network) throw new Error("w3m-network-switch-view: No network provided");
        this.onShowRetry();
        const label = this.error ? "Switch declined" : "Approve in wallet";
        const subLabel = this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
        return (0, $8AeG9.html)`
      <wui-flex
        data-error=${this.error}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-network-image
            size="lg"
            imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getNetworkImage(this.network))}
          ></wui-network-image>

          ${this.error ? null : (0, $8AeG9.html)`<wui-loading-hexagon></wui-loading-hexagon>`}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            ?border=${true}
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">${label}</wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          data-retry=${this.showRetry}
          variant="fill"
          .disabled=${!this.error}
          @click=${this.onSwitchNetwork.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
          Try again
        </wui-button>
      </wui-flex>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onSwitchNetwork() {
        try {
            this.error = false;
            if (this.network) {
                await (0, $j0fVO.NetworkController).switchActiveNetwork(this.network);
                if (!(0, $afSSl.SIWEController).state.isSiweEnabled) (0, $ap614.RouterUtil).navigateAfterNetworkSwitch();
            }
        } catch  {
            this.error = true;
        }
    }
};
$341ee0e128e16f15$export$d124f6a585588d61.styles = (0, $2a07e234396ce111$export$2e2bcd8739ae039);
$341ee0e128e16f15$var$__decorate([
    (0, $dBBvD.state)()
], $341ee0e128e16f15$export$d124f6a585588d61.prototype, "showRetry", void 0);
$341ee0e128e16f15$var$__decorate([
    (0, $dBBvD.state)()
], $341ee0e128e16f15$export$d124f6a585588d61.prototype, "error", void 0);
$341ee0e128e16f15$export$d124f6a585588d61 = $341ee0e128e16f15$var$__decorate([
    (0, $33Xir.customElement)("w3m-network-switch-view")
], $341ee0e128e16f15$export$d124f6a585588d61);


parcelRequire("k1l85");
var $j0fVO = parcelRequire("j0fVO");
var $bE42d = parcelRequire("bE42d");
var $eMpli = parcelRequire("eMpli");
var $efzgw = parcelRequire("efzgw");
var $aoKpV = parcelRequire("aoKpV");
var $ap614 = parcelRequire("ap614");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $e62b8ecb70031d3c$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;


var $9e769e80613c396a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9e769e80613c396a$export$ff1f854e9d8d99b2 = class W3mNetworksView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.caipNetwork = (0, $j0fVO.NetworkController).state.caipNetwork;
        this.unsubscribe.push((0, $j0fVO.NetworkController).subscribeKey("caipNetwork", (val)=>this.caipNetwork = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-grid padding="s" gridTemplateColumns="repeat(4, 1fr)" rowGap="l" columnGap="xs">
        ${this.networksTemplate()}
      </wui-grid>

      <wui-separator></wui-separator>

      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">
        <wui-text variant="small-400" color="fg-300" align="center">
          Your connected wallet may not support some of the networks available for this dApp
        </wui-text>
        <wui-link @click=${this.onNetworkHelp.bind(this)}>
          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
          What is a network
        </wui-link>
      </wui-flex>
    `;
    }
    onNetworkHelp() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CLICK_NETWORK_HELP"
        });
        (0, $eMpli.RouterController).push("WhatIsANetwork");
    }
    networksTemplate() {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks, supportsAllNetworks: supportsAllNetworks } = (0, $j0fVO.NetworkController).state;
        const approvedIds = approvedCaipNetworkIds;
        const requestedNetworks = requestedCaipNetworks;
        const approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach((id, index)=>{
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort((a, b)=>{
                const indexA = approvedIndexMap[a.id];
                const indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks?.map((network)=>(0, $8AeG9.html)`
        <wui-card-select
          .selected=${this.caipNetwork?.id === network.id}
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getNetworkImage(network))}
          type="network"
          name=${network.name ?? network.id}
          @click=${()=>this.onSwitchNetwork(network)}
          .disabled=${!supportsAllNetworks && !approvedIds?.includes(network.id)}
          data-testid=${`w3m-network-switch-${network.name ?? network.id}`}
        ></wui-card-select>
      `);
    }
    async onSwitchNetwork(network) {
        const { isConnected: isConnected } = (0, $aoKpV.AccountController).state;
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, supportsAllNetworks: supportsAllNetworks, caipNetwork: caipNetwork } = (0, $j0fVO.NetworkController).state;
        const { data: data } = (0, $eMpli.RouterController).state;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $j0fVO.NetworkController).switchActiveNetwork(network);
                (0, $ap614.RouterUtil).navigateAfterNetworkSwitch();
            } else if (supportsAllNetworks) (0, $eMpli.RouterController).push("SwitchNetwork", {
                ...data,
                network: network
            });
        } else if (!isConnected) {
            (0, $j0fVO.NetworkController).setCaipNetwork(network);
            (0, $eMpli.RouterController).push("Connect");
        }
    }
};
$9e769e80613c396a$export$ff1f854e9d8d99b2.styles = (0, $e62b8ecb70031d3c$export$2e2bcd8739ae039);
$9e769e80613c396a$var$__decorate([
    (0, $dBBvD.state)()
], $9e769e80613c396a$export$ff1f854e9d8d99b2.prototype, "caipNetwork", void 0);
$9e769e80613c396a$export$ff1f854e9d8d99b2 = $9e769e80613c396a$var$__decorate([
    (0, $33Xir.customElement)("w3m-networks-view")
], $9e769e80613c396a$export$ff1f854e9d8d99b2);


parcelRequire("fS82a");
var $gEtkT = parcelRequire("gEtkT");
parcelRequire("k1l85");
var $aoKpV = parcelRequire("aoKpV");
var $6G808 = parcelRequire("6G808");
var $3pfUo = parcelRequire("3pfUo");
var $bE42d = parcelRequire("bE42d");
parcelRequire("bG7tm");
var $jbpJN = parcelRequire("jbpJN");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $fba776d8d023951a$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
`;


var $5f64506de7769536$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $5f64506de7769536$var$PAGINATOR_ID = "last-transaction";
const $5f64506de7769536$var$LOADING_ITEM_COUNT = 7;
let $5f64506de7769536$export$5b9982998ebc2231 = class W3mTransactionsView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.address = (0, $aoKpV.AccountController).state.address;
        this.transactions = (0, $6G808.TransactionsController).state.transactions;
        this.transactionsByYear = (0, $6G808.TransactionsController).state.transactionsByYear;
        this.loading = (0, $6G808.TransactionsController).state.loading;
        this.empty = (0, $6G808.TransactionsController).state.empty;
        this.next = (0, $6G808.TransactionsController).state.next;
        this.unsubscribe.push(...[
            (0, $aoKpV.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    if (this.address !== val.address) {
                        this.address = val.address;
                        (0, $6G808.TransactionsController).resetTransactions();
                        (0, $6G808.TransactionsController).fetchTransactions(val.address);
                    }
                }
            }),
            (0, $6G808.TransactionsController).subscribe((val)=>{
                this.transactions = val.transactions;
                this.transactionsByYear = val.transactionsByYear;
                this.loading = val.loading;
                this.empty = val.empty;
                this.next = val.next;
            })
        ]);
    }
    firstUpdated() {
        if (this.transactions.length === 0) (0, $6G808.TransactionsController).fetchTransactions(this.address);
        this.createPaginationObserver();
    }
    updated() {
        this.setPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" padding="s" gap="s">
        ${this.empty ? null : this.templateTransactionsByYear()}
        ${this.loading ? this.templateLoading() : null}
        ${!this.loading && this.empty ? this.templateEmpty() : null}
      </wui-flex>
    `;
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.transactionsByYear).sort().reverse();
        return sortedYearKeys.map((year, index)=>{
            const isLastGroup = index === sortedYearKeys.length - 1;
            const yearInt = parseInt(year, 10);
            const groupTitle = (0, $jbpJN.TransactionUtil).getTransactionGroupTitle(yearInt);
            const transactions = this.transactionsByYear[yearInt];
            if (!transactions) return null;
            return (0, $8AeG9.html)`
        <wui-flex flexDirection="column" gap="s">
          <wui-flex
            alignItems="center"
            flexDirection="row"
            .padding=${[
                "xs",
                "s",
                "s",
                "s"
            ]}
          >
            <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
          </wui-flex>
          <wui-flex flexDirection="column" gap="xs">
            ${this.templateTransactions(transactions, isLastGroup)}
          </wui-flex>
        </wui-flex>
      `;
        });
    }
    templateRenderTransaction(transaction, isLastTransaction) {
        const { date: date, descriptions: descriptions, direction: direction, isAllNFT: isAllNFT, images: images, status: status, transfers: transfers, type: type } = this.getTransactionListItemProps(transaction);
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return (0, $8AeG9.html)`
        <wui-transaction-list-item
          date=${date}
          .direction=${direction}
          id=${isLastTransaction && this.next ? $5f64506de7769536$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .images=${images}
          .descriptions=${descriptions}
        ></wui-transaction-list-item>
      `;
        if (haveMultipleTransfers) return transfers.map((transfer, index)=>{
            const description = (0, $jbpJN.TransactionUtil).getTransferDescription(transfer);
            const isLastTransfer = isLastTransaction && index === transfers.length - 1;
            return (0, $8AeG9.html)` <wui-transaction-list-item
          date=${date}
          direction=${transfer.direction}
          id=${isLastTransfer && this.next ? $5f64506de7769536$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .onlyDirectionIcon=${true}
          .images=${[
                images?.[index]
            ]}
          .descriptions=${[
                description
            ]}
        ></wui-transaction-list-item>`;
        });
        return (0, $8AeG9.html)`
      <wui-transaction-list-item
        date=${date}
        .direction=${direction}
        id=${isLastTransaction && this.next ? $5f64506de7769536$var$PAGINATOR_ID : ""}
        status=${status}
        type=${type}
        .images=${images}
        .descriptions=${descriptions}
      ></wui-transaction-list-item>
    `;
    }
    templateTransactions(transactions, isLastGroup) {
        return transactions.map((transaction, index)=>{
            const isLastTransaction = isLastGroup && index === transactions.length - 1;
            return (0, $8AeG9.html)`${this.templateRenderTransaction(transaction, isLastTransaction)}`;
        });
    }
    templateEmpty() {
        return (0, $8AeG9.html)`
      <wui-flex
        flexGrow="1"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-icon-box
          backgroundColor="glass-005"
          background="gray"
          iconColor="fg-200"
          icon="wallet"
          size="lg"
          ?border=${true}
          borderColor="wui-color-bg-125"
        ></wui-icon-box>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100"
            >No Transactions yet</wui-text
          >
          <wui-text align="center" variant="small-500" color="fg-200"
            >Start trading on dApps <br />
            to grow your wallet!</wui-text
          >
        </wui-flex>
      </wui-flex>
    `;
    }
    templateLoading() {
        return Array($5f64506de7769536$var$LOADING_ITEM_COUNT).fill((0, $8AeG9.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
    createPaginationObserver() {
        const { projectId: projectId } = (0, $3pfUo.OptionsController).state;
        this.paginationObserver = new IntersectionObserver(([element])=>{
            if (element?.isIntersecting && !this.loading) {
                (0, $6G808.TransactionsController).fetchTransactions(this.address);
                (0, $bE42d.EventsController).sendEvent({
                    type: "track",
                    event: "LOAD_MORE_TRANSACTIONS",
                    properties: {
                        address: this.address,
                        projectId: projectId,
                        cursor: this.next
                    }
                });
            }
        }, {});
        this.setPaginationObserver();
    }
    setPaginationObserver() {
        this.paginationObserver?.disconnect();
        const lastItem = this.shadowRoot?.querySelector(`#${$5f64506de7769536$var$PAGINATOR_ID}`);
        if (lastItem) this.paginationObserver?.observe(lastItem);
    }
    getTransactionListItemProps(transaction) {
        const date = (0, $gEtkT.DateUtil).getRelativeDateFromNow(transaction?.metadata?.minedAt);
        const descriptions = (0, $jbpJN.TransactionUtil).getTransactionDescriptions(transaction);
        const transfers = transaction?.transfers;
        const transfer = transaction?.transfers?.[0];
        const isAllNFT = Boolean(transfer) && transaction?.transfers?.every((item)=>Boolean(item.nft_info));
        const images = (0, $jbpJN.TransactionUtil).getTransactionImages(transfers);
        return {
            date: date,
            direction: transfer?.direction,
            descriptions: descriptions,
            isAllNFT: isAllNFT,
            images: images,
            status: transaction.metadata?.status,
            transfers: transfers,
            type: transaction.metadata?.operationType
        };
    }
};
$5f64506de7769536$export$5b9982998ebc2231.styles = (0, $fba776d8d023951a$export$2e2bcd8739ae039);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "address", void 0);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "transactions", void 0);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "transactionsByYear", void 0);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "loading", void 0);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "empty", void 0);
$5f64506de7769536$var$__decorate([
    (0, $dBBvD.state)()
], $5f64506de7769536$export$5b9982998ebc2231.prototype, "next", void 0);
$5f64506de7769536$export$5b9982998ebc2231 = $5f64506de7769536$var$__decorate([
    (0, $33Xir.customElement)("w3m-transactions-view")
], $5f64506de7769536$export$5b9982998ebc2231);


parcelRequire("k1l85");
var $bYnq1 = parcelRequire("bYnq1");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
var $d46241f90588918a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d46241f90588918a$var$data = [
    {
        images: [
            "network",
            "layers",
            "system"
        ],
        title: "The system\u2019s nuts and bolts",
        text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
    },
    {
        images: [
            "noun",
            "defiAlt",
            "dao"
        ],
        title: "Designed for different uses",
        text: "Each network is designed differently, and may therefore suit certain apps and experiences."
    }
];
let $d46241f90588918a$export$e747cd062ecb4580 = class W3mWhatIsANetworkView extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$d46241f90588918a$var$data}></w3m-help-widget>
        <wui-button
          variant="fill"
          size="sm"
          @click=${()=>{
            (0, $bYnq1.CoreHelperUtil).openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$d46241f90588918a$export$e747cd062ecb4580 = $d46241f90588918a$var$__decorate([
    (0, $33Xir.customElement)("w3m-what-is-a-network-view")
], $d46241f90588918a$export$e747cd062ecb4580);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
var $27518e386adff2ae$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $27518e386adff2ae$var$data = [
    {
        images: [
            "login",
            "profile",
            "lock"
        ],
        title: "One login for all of web3",
        text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
    },
    {
        images: [
            "defi",
            "nft",
            "eth"
        ],
        title: "A home for your digital assets",
        text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
    },
    {
        images: [
            "browser",
            "noun",
            "dao"
        ],
        title: "Your gateway to a new web",
        text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
    }
];
let $27518e386adff2ae$export$16ac3b6705a4e652 = class W3mWhatIsAWalletView extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$27518e386adff2ae$var$data}></w3m-help-widget>
        <wui-button variant="fill" size="sm" @click=${this.onGetWallet.bind(this)}>
          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>
          Get a wallet
        </wui-button>
      </wui-flex>
    `;
    }
    onGetWallet() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CLICK_GET_WALLET"
        });
        (0, $eMpli.RouterController).push("GetWallet");
    }
};
$27518e386adff2ae$export$16ac3b6705a4e652 = $27518e386adff2ae$var$__decorate([
    (0, $33Xir.customElement)("w3m-what-is-a-wallet-view")
], $27518e386adff2ae$export$16ac3b6705a4e652);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $8L7Gu = parcelRequire("8L7Gu");
var $bE42d = parcelRequire("bE42d");
var $58zho = parcelRequire("58zho");
var $6CqNZ = parcelRequire("6CqNZ");
var $bYnq1 = parcelRequire("bYnq1");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $296b4b4651557a00$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-loading-spinner {
    margin: 9px auto;
  }
`;


const $3bd53fa4dbe87b8e$export$3ff97a7390ed49be = {
    SECURE_SITE_SDK: "https://secure.web3modal.com/sdk",
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@w3m-storage/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_AWAIT_UPDATE_EMAIL_SUCCESS: "@w3m-frame/AWAIT_UPDATE_EMAIL_SUCCESS",
    FRAME_AWAIT_UPDATE_EMAIL_ERROR: "@w3m-frame/AWAIT_UPDATE_EMAIL_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR"
};
const $3bd53fa4dbe87b8e$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_blockNumber",
        "eth_estimateGas",
        "eth_getTransactionByHash"
    ],
    GET_CHAIN_ID: "eth_chainId"
};


var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
            $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $9ee9c7b494d01fc9$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
};
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    "enum": $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    "function": $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    "instanceof": $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    "null": $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    "undefined": $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    "void": $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});



const $6ea3c6ffccaa6df8$var$zError = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    message: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()
});
function $6ea3c6ffccaa6df8$var$zType(key) {
    return (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be)[key]);
}
const $6ea3c6ffccaa6df8$export$89415e8e09b5a4e0 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    accessList: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()),
    blockHash: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nullable(),
    blockNumber: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nullable(),
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    from: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    gas: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    hash: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    input: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nullable(),
    maxFeePerGas: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    maxPriorityFeePerGas: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    nonce: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    r: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    s: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    to: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    transactionIndex: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nullable(),
    type: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    v: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    value: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()
});
const $6ea3c6ffccaa6df8$export$6f296c19518f2ab2 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number()
});
const $6ea3c6ffccaa6df8$export$976f191ce42ce5be = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email()
});
const $6ea3c6ffccaa6df8$export$3c60c26d0e7c7485 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    otp: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()
});
const $6ea3c6ffccaa6df8$export$2b55edadc32e688a = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).optional((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number())
});
const $6ea3c6ffccaa6df8$export$65e6e56482b6df27 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email()
});
const $6ea3c6ffccaa6df8$export$c523bb85fd166f04 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    themeMode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).optional((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).optional((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).record((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(), (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number())))
});
const $6ea3c6ffccaa6df8$export$4ca9ea890e921270 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    metadata: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        name: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        description: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        url: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        icons: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string())
    }).optional(),
    sdkVersion: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    projectId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()
});
const $6ea3c6ffccaa6df8$export$333a7bf9d10b914 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    action: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP"
    ])
});
const $6ea3c6ffccaa6df8$export$2d6662dda0084b61 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email(),
    address: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number()
});
const $6ea3c6ffccaa6df8$export$775a450ce21f8fdf = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    isConnected: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).boolean()
});
const $6ea3c6ffccaa6df8$export$245abc04f43df573 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number()
});
const $6ea3c6ffccaa6df8$export$178941fe9bfa6200 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    chainId: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).number()
});
const $6ea3c6ffccaa6df8$export$b7aad26036b222d1 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email()
});
const $6ea3c6ffccaa6df8$export$d4ce1c0118069cf6 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any();
const $6ea3c6ffccaa6df8$export$57dc995d18380851 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("personal_sign"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$fc4f4bb7f991c8e0 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_sendTransaction"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$333c606c26a06359 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_accounts")
});
const $6ea3c6ffccaa6df8$export$ee6f1d87d1d6e0cb = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_getBalance"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$272161a7d614a7de = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_estimateGas"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$375f72aea2abe32f = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_gasPrice")
});
const $6ea3c6ffccaa6df8$export$98d6e3ae5e5869d0 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_signTypedData_v4"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$b498be03499c3270 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_getTransactionByHash"),
    params: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).array((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any())
});
const $6ea3c6ffccaa6df8$export$ed481a6ef87fb1a4 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_blockNumber")
});
const $6ea3c6ffccaa6df8$export$ced6b8fef5e3a1ae = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    method: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).literal("eth_chainId")
});
const $6ea3c6ffccaa6df8$export$583fad842749c757 = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
    token: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string()
});
const $6ea3c6ffccaa6df8$export$238f9986c2bb1b9a = {
    appEvent: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_SWITCH_NETWORK"),
        payload: $6ea3c6ffccaa6df8$export$6f296c19518f2ab2
    }).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_CONNECT_EMAIL"),
        payload: $6ea3c6ffccaa6df8$export$976f191ce42ce5be
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_CONNECT_DEVICE")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_CONNECT_OTP"),
        payload: $6ea3c6ffccaa6df8$export$3c60c26d0e7c7485
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_GET_USER"),
        payload: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).optional($6ea3c6ffccaa6df8$export$2b55edadc32e688a)
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_SIGN_OUT")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_IS_CONNECTED"),
        payload: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).optional($6ea3c6ffccaa6df8$export$583fad842749c757)
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_GET_CHAIN_ID")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_RPC_REQUEST"),
        payload: $6ea3c6ffccaa6df8$export$57dc995d18380851.or($6ea3c6ffccaa6df8$export$fc4f4bb7f991c8e0).or($6ea3c6ffccaa6df8$export$333c606c26a06359).or($6ea3c6ffccaa6df8$export$ee6f1d87d1d6e0cb).or($6ea3c6ffccaa6df8$export$272161a7d614a7de).or($6ea3c6ffccaa6df8$export$375f72aea2abe32f).or($6ea3c6ffccaa6df8$export$98d6e3ae5e5869d0).or($6ea3c6ffccaa6df8$export$ed481a6ef87fb1a4).or($6ea3c6ffccaa6df8$export$ced6b8fef5e3a1ae).or($6ea3c6ffccaa6df8$export$b498be03499c3270)
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_UPDATE_EMAIL"),
        payload: $6ea3c6ffccaa6df8$export$65e6e56482b6df27
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_AWAIT_UPDATE_EMAIL")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_SYNC_THEME"),
        payload: $6ea3c6ffccaa6df8$export$c523bb85fd166f04
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $6ea3c6ffccaa6df8$export$4ca9ea890e921270
    })),
    frameEvent: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    }).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$178941fe9bfa6200
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$333a7bf9d10b914
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_GET_USER_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$2d6662dda0084b61
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$775a450ce21f8fdf
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$245abc04f43df573
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$d4ce1c0118069cf6
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SESSION_UPDATE"),
        payload: $6ea3c6ffccaa6df8$export$583fad842749c757
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_UPDATE_EMAIL_SUCCESS")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_AWAIT_UPDATE_EMAIL_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_AWAIT_UPDATE_EMAIL_SUCCESS"),
        payload: $6ea3c6ffccaa6df8$export$b7aad26036b222d1
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $6ea3c6ffccaa6df8$var$zError
    })).or((0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        type: $6ea3c6ffccaa6df8$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    }))
};



const $a2166102d41a0e58$export$500c415dce2853c3 = {
    set (key, value) {
        localStorage.setItem(`${(0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).STORAGE_KEY}${key}`, value);
    },
    get (key) {
        return localStorage.getItem(`${(0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
    },
    delete (key) {
        localStorage.removeItem(`${(0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
    }
};



const $844e7bb2b686b713$var$RESTRICTED_TIMEZONES = [
    "ASIA/SHANGHAI",
    "ASIA/URUMQI",
    "ASIA/CHONGQING",
    "ASIA/HARBIN",
    "ASIA/KASHGAR",
    "ASIA/MACAU",
    "ASIA/HONG_KONG",
    "ASIA/MACAO",
    "ASIA/BEIJING",
    "ASIA/HARBIN"
];
const $844e7bb2b686b713$var$EMAIL_MINIMUM_TIMEOUT = 30000;
const $844e7bb2b686b713$export$794efc40d8765bc4 = {
    getBlockchainApiUrl () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return $844e7bb2b686b713$var$RESTRICTED_TIMEZONES.includes(capTimeZone) ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
        } catch  {
            return false;
        }
    },
    checkIfAllowedToTriggerEmail () {
        const lastEmailLoginTime = (0, $a2166102d41a0e58$export$500c415dce2853c3).get((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $844e7bb2b686b713$var$EMAIL_MINIMUM_TIMEOUT) {
                const cooldownSec = Math.ceil(($844e7bb2b686b713$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error(`Please try again after ${cooldownSec} seconds`);
            }
        }
    },
    getTimeToNextEmailLogin () {
        const lastEmailLoginTime = (0, $a2166102d41a0e58$export$500c415dce2853c3).get((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $844e7bb2b686b713$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($844e7bb2b686b713$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    }
};


class $5906d1e069300840$export$668e35d4f1b0aa08 {
    constructor(projectId, isAppClient = false){
        this.iframe = null;
        this.rpcUrl = (0, $844e7bb2b686b713$export$794efc40d8765bc4).getBlockchainApiUrl();
        this.events = {
            onFrameEvent: (callback)=>{
                window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_EVENT_KEY)) return;
                    const frameEvent = (0, $6ea3c6ffccaa6df8$export$238f9986c2bb1b9a).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: (callback)=>{
                window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_EVENT_KEY)) return;
                    const appEvent = (0, $6ea3c6ffccaa6df8$export$238f9986c2bb1b9a).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: (event)=>{
                if (!this.iframe?.contentWindow) throw new Error("W3mFrame: iframe is not set");
                (0, $6ea3c6ffccaa6df8$export$238f9986c2bb1b9a).appEvent.parse(event);
                window.postMessage(event);
                this.iframe.contentWindow.postMessage(event, "*");
            },
            postFrameEvent: (event)=>{
                if (!parent) throw new Error("W3mFrame: parent is not set");
                (0, $6ea3c6ffccaa6df8$export$238f9986c2bb1b9a).frameEvent.parse(event);
                parent.postMessage(event, "*");
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise((resolve, reject)=>{
            this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise((resolve, reject)=>{
                this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            const iframe = document.createElement("iframe");
            iframe.id = "w3m-iframe";
            iframe.src = `${(0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).SECURE_SITE_SDK}?projectId=${projectId}`;
            iframe.style.position = "fixed";
            iframe.style.zIndex = "999999";
            iframe.style.display = "none";
            iframe.style.opacity = "0";
            iframe.style.borderRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
            document.body.appendChild(iframe);
            this.iframe = iframe;
            this.iframe.onload = ()=>{
                this.frameLoadPromiseResolver?.resolve(undefined);
            };
            this.iframe.onerror = ()=>{
                this.frameLoadPromiseResolver?.reject("Unable to load email login dependency");
            };
        }
    }
    get networks() {
        const data = [
            1,
            5,
            11155111,
            10,
            420,
            42161,
            421613,
            137,
            80001,
            42220,
            1313161554,
            1313161555,
            56,
            97,
            43114,
            43113,
            324,
            280,
            100,
            8453,
            84531,
            7777777,
            999
        ].map((id)=>({
                [id]: {
                    rpcUrl: `${this.rpcUrl}/v1/?chainId=eip155:${id}&projectId=${this.projectId}`,
                    chainId: id
                }
            }));
        return Object.assign({}, ...data);
    }
}







class $7a7e5359f80f7e1f$export$112ca4a9acf9f612 {
    constructor(projectId){
        this.connectEmailResolver = undefined;
        this.connectDeviceResolver = undefined;
        this.connectOtpResolver = undefined;
        this.connectResolver = undefined;
        this.disconnectResolver = undefined;
        this.isConnectedResolver = undefined;
        this.getChainIdResolver = undefined;
        this.switchChainResolver = undefined;
        this.rpcRequestResolver = undefined;
        this.updateEmailResolver = undefined;
        this.awaitUpdateEmailResolver = undefined;
        this.syncThemeResolver = undefined;
        this.syncDappDataResolver = undefined;
        this.w3mFrame = new (0, $5906d1e069300840$export$668e35d4f1b0aa08)(projectId, true);
        this.w3mFrame.events.onFrameEvent((event)=>{
            console.log("\uD83D\uDCBB received", event);
            switch(event.type){
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_SUCCESS:
                    return this.onConnectEmailSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_ERROR:
                    return this.onConnectEmailError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_SUCCESS:
                    return this.onConnectDeviceSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_ERROR:
                    return this.onConnectDeviceError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_SUCCESS:
                    return this.onConnectOtpSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_ERROR:
                    return this.onConnectOtpError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS:
                    return this.onConnectSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_GET_USER_ERROR:
                    return this.onConnectError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_SUCCESS:
                    return this.onIsConnectedSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_ERROR:
                    return this.onIsConnectedError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_SUCCESS:
                    return this.onGetChainIdSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_ERROR:
                    return this.onGetChainIdError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SIGN_OUT_SUCCESS:
                    return this.onSignOutSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SIGN_OUT_ERROR:
                    return this.onSignOutError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_SUCCESS:
                    return this.onSwitchChainSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_ERROR:
                    return this.onSwitchChainError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_SUCCESS:
                    return this.onRpcRequestSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_ERROR:
                    return this.onRpcRequestError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SESSION_UPDATE:
                    return this.onSessionUpdate(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SUCCESS:
                    return this.onUpdateEmailSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_ERROR:
                    return this.onUpdateEmailError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_AWAIT_UPDATE_EMAIL_SUCCESS:
                    return this.onAwaitUpdateEmailSuccess(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_AWAIT_UPDATE_EMAIL_ERROR:
                    return this.onAwaitUpdateEmailError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SYNC_THEME_SUCCESS:
                    return this.onSyncThemeSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SYNC_THEME_ERROR:
                    return this.onSyncThemeError(event);
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_SUCCESS:
                    return this.onSyncDappDataSuccess();
                case (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_ERROR:
                    return this.onSyncDappDataError(event);
                default:
                    return null;
            }
        });
    }
    getLoginEmailUsed() {
        return Boolean((0, $a2166102d41a0e58$export$500c415dce2853c3).get((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY));
    }
    getEmail() {
        return (0, $a2166102d41a0e58$export$500c415dce2853c3).get((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL);
    }
    async connectEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $844e7bb2b686b713$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_CONNECT_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectDevice() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_CONNECT_DEVICE
        });
        return new Promise((resolve, reject)=>{
            this.connectDeviceResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_CONNECT_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async isConnected() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_IS_CONNECTED,
            payload: undefined
        });
        return new Promise((resolve, reject)=>{
            this.isConnectedResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async getChainId() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_GET_CHAIN_ID
        });
        return new Promise((resolve, reject)=>{
            this.getChainIdResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $844e7bb2b686b713$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_UPDATE_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async awaitUpdateEmail() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_AWAIT_UPDATE_EMAIL
        });
        return new Promise((resolve, reject)=>{
            this.awaitUpdateEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncTheme(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_SYNC_THEME,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncThemeResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncDappData(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_SYNC_DAPP_DATA,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncDappDataResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connect(payload) {
        const chainId = payload?.chainId ?? this.getLastUsedChainId() ?? 1;
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_GET_USER,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.connectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async switchNetwork(chainId) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_SWITCH_NETWORK,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.switchChainResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async disconnect() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_SIGN_OUT
        });
        return new Promise((resolve, reject)=>{
            this.disconnectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async request(req) {
        await this.w3mFrame.frameLoadPromise;
        if ((0, $3bd53fa4dbe87b8e$export$9975694bfb286db).GET_CHAIN_ID === req.method) return this.getLastUsedChainId();
        this.w3mFrame.events.postAppEvent({
            type: (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).APP_RPC_REQUEST,
            payload: req
        });
        return new Promise((resolve, reject)=>{
            this.rpcRequestResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    onRpcRequest(callback) {
        this.w3mFrame.events.onAppEvent((event)=>{
            if (event.type.includes((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onRpcResponse(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type.includes((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onIsConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS) callback();
        });
    }
    onConnectEmailSuccess(event) {
        this.connectEmailResolver?.resolve(event.payload);
        this.setNewLastEmailLoginTime();
    }
    onConnectEmailError(event) {
        this.connectEmailResolver?.reject(event.payload.message);
    }
    onConnectDeviceSuccess() {
        this.connectDeviceResolver?.resolve(undefined);
    }
    onConnectDeviceError(event) {
        this.connectDeviceResolver?.reject(event.payload.message);
    }
    onConnectOtpSuccess() {
        this.connectOtpResolver?.resolve(undefined);
    }
    onConnectOtpError(event) {
        this.connectOtpResolver?.reject(event.payload.message);
    }
    onConnectSuccess(event) {
        this.setEmailLoginSuccess(event.payload.email);
        this.setLastUsedChainId(event.payload.chainId);
        this.connectResolver?.resolve(event.payload);
    }
    onConnectError(event) {
        this.connectResolver?.reject(event.payload.message);
    }
    onIsConnectedSuccess(event) {
        if (!event.payload.isConnected) this.deleteEmailLoginCache();
        this.isConnectedResolver?.resolve(event.payload);
    }
    onIsConnectedError(event) {
        this.isConnectedResolver?.reject(event.payload.message);
    }
    onGetChainIdSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.getChainIdResolver?.resolve(event.payload);
    }
    onGetChainIdError(event) {
        this.getChainIdResolver?.reject(event.payload.message);
    }
    onSignOutSuccess() {
        this.disconnectResolver?.resolve(undefined);
        this.deleteEmailLoginCache();
    }
    onSignOutError(event) {
        this.disconnectResolver?.reject(event.payload.message);
    }
    onSwitchChainSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.switchChainResolver?.resolve(event.payload);
    }
    onSwitchChainError(event) {
        this.switchChainResolver?.reject(event.payload.message);
    }
    onRpcRequestSuccess(event) {
        this.rpcRequestResolver?.resolve(event.payload);
    }
    onRpcRequestError(event) {
        this.rpcRequestResolver?.reject(event.payload.message);
    }
    onSessionUpdate(event) {
        const { payload: payload } = event;
        payload;
    }
    onUpdateEmailSuccess() {
        this.updateEmailResolver?.resolve(undefined);
        this.setNewLastEmailLoginTime();
    }
    onUpdateEmailError(event) {
        this.updateEmailResolver?.reject(event.payload.message);
    }
    onAwaitUpdateEmailSuccess(event) {
        this.setEmailLoginSuccess(event.payload.email);
        this.awaitUpdateEmailResolver?.resolve(event.payload);
    }
    onAwaitUpdateEmailError(event) {
        this.awaitUpdateEmailResolver?.reject(event.payload.message);
    }
    onSyncThemeSuccess() {
        this.syncThemeResolver?.resolve(undefined);
    }
    onSyncThemeError(event) {
        this.syncThemeResolver?.reject(event.payload.message);
    }
    onSyncDappDataSuccess() {
        this.syncDappDataResolver?.resolve(undefined);
    }
    onSyncDappDataError(event) {
        this.syncDappDataResolver?.reject(event.payload.message);
    }
    setNewLastEmailLoginTime() {
        (0, $a2166102d41a0e58$export$500c415dce2853c3).set((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
    }
    setEmailLoginSuccess(email) {
        (0, $a2166102d41a0e58$export$500c415dce2853c3).set((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL, email);
        (0, $a2166102d41a0e58$export$500c415dce2853c3).set((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY, "true");
        (0, $a2166102d41a0e58$export$500c415dce2853c3).delete((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
    }
    deleteEmailLoginCache() {
        (0, $a2166102d41a0e58$export$500c415dce2853c3).delete((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY);
        (0, $a2166102d41a0e58$export$500c415dce2853c3).delete((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).EMAIL);
        (0, $a2166102d41a0e58$export$500c415dce2853c3).delete((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY);
    }
    setLastUsedChainId(chainId) {
        (0, $a2166102d41a0e58$export$500c415dce2853c3).set((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY, `${chainId}`);
    }
    getLastUsedChainId() {
        return Number((0, $a2166102d41a0e58$export$500c415dce2853c3).get((0, $3bd53fa4dbe87b8e$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY));
    }
}







var $a6649611ba7819b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $a6649611ba7819b2$var$OTP_LENGTH = 6;
let $a6649611ba7819b2$export$cf0da95883710edd = class W3mEmailVerifyOtpView extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.email = (0, $eMpli.RouterController).state.data?.email;
        this.emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
        this.loading = false;
        this.timeoutTimeLeft = (0, $844e7bb2b686b713$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.error = "";
        this.otp = "";
    }
    firstUpdated() {
        this.startOTPTimeout();
    }
    disconnectedCallback() {
        clearTimeout(this.OTPTimeout);
    }
    render() {
        if (!this.email) throw new Error("w3m-email-verify-otp-view: No email provided");
        const isResendDisabled = Boolean(this.timeoutTimeLeft);
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "l",
            "0",
            "l",
            "0"
        ]}
        gap="l"
      >
        <wui-flex flexDirection="column" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100"> Enter the code we sent to </wui-text>
          <wui-text variant="paragraph-500" color="fg-100">${this.email}</wui-text>
        </wui-flex>

        <wui-text variant="small-400" color="fg-200">The code expires in 20 minutes</wui-text>

        ${this.loading ? (0, $8AeG9.html)`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : (0, $8AeG9.html)` <wui-flex flexDirection="column" alignItems="center" gap="xs">
              <wui-otp
                dissabled
                length="6"
                @inputChange=${this.onOtpInputChange.bind(this)}
                .otp=${this.otp}
              ></wui-otp>
              ${this.error ? (0, $8AeG9.html)`<wui-text variant="small-400" color="error-100"
                    >${this.error}. Try Again</wui-text
                  >` : null}
            </wui-flex>`}

        <wui-flex alignItems="center">
          <wui-text variant="small-400" color="fg-200">Didn't receive it?</wui-text>
          <wui-link @click=${this.onResendCode.bind(this)} .disabled=${isResendDisabled}>
            Resend ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : "Code"}
          </wui-link>
        </wui-flex>
      </wui-flex>
    `;
    }
    startOTPTimeout() {
        this.timeoutTimeLeft = (0, $844e7bb2b686b713$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.OTPTimeout = setInterval(()=>{
            if (this.timeoutTimeLeft > 0) this.timeoutTimeLeft = (0, $844e7bb2b686b713$export$794efc40d8765bc4).getTimeToNextEmailLogin();
            else clearInterval(this.OTPTimeout);
        }, 1000);
    }
    async onOtpInputChange(event) {
        try {
            if (!this.loading) {
                this.otp = event.detail;
                if (this.emailConnector && this.otp.length === $a6649611ba7819b2$var$OTP_LENGTH) {
                    this.loading = true;
                    await this.emailConnector.provider.connectOtp({
                        otp: this.otp
                    });
                    (0, $bE42d.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    await (0, $58zho.ConnectionController).connectExternal(this.emailConnector);
                    (0, $6CqNZ.ModalController).close();
                    (0, $bE42d.EventsController).sendEvent({
                        type: "track",
                        event: "CONNECT_SUCCESS",
                        properties: {
                            method: "email"
                        }
                    });
                }
            }
        } catch (error) {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_VERIFICATION_CODE_FAIL"
            });
            this.error = (0, $bYnq1.CoreHelperUtil).parseError(error);
            this.loading = false;
        }
    }
    async onResendCode() {
        try {
            if (!this.loading && !this.timeoutTimeLeft) {
                this.error = "";
                this.otp = "";
                const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
                if (!emailConnector || !this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                this.loading = true;
                await emailConnector.provider.connectEmail({
                    email: this.email
                });
                (0, $bE42d.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
                this.startOTPTimeout();
                (0, $45Xo0.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $45Xo0.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$a6649611ba7819b2$export$cf0da95883710edd.styles = (0, $296b4b4651557a00$export$2e2bcd8739ae039);
$a6649611ba7819b2$var$__decorate([
    (0, $dBBvD.state)()
], $a6649611ba7819b2$export$cf0da95883710edd.prototype, "loading", void 0);
$a6649611ba7819b2$var$__decorate([
    (0, $dBBvD.state)()
], $a6649611ba7819b2$export$cf0da95883710edd.prototype, "timeoutTimeLeft", void 0);
$a6649611ba7819b2$var$__decorate([
    (0, $dBBvD.state)()
], $a6649611ba7819b2$export$cf0da95883710edd.prototype, "error", void 0);
$a6649611ba7819b2$export$cf0da95883710edd = $a6649611ba7819b2$var$__decorate([
    (0, $33Xir.customElement)("w3m-email-verify-otp-view")
], $a6649611ba7819b2$export$cf0da95883710edd);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $8400952a339c6d9f$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $8L7Gu = parcelRequire("8L7Gu");
var $bE42d = parcelRequire("bE42d");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $beea795944ecb853$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $beea795944ecb853$export$442e575aa1acbb10 = class W3mEmailVerifyDeviceView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.email = (0, $eMpli.RouterController).state.data?.email;
        this.emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
        this.loading = false;
        this.listenForDeviceApproval();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-verify-device-view: No email provided");
        if (!this.emailConnector) throw new Error("w3m-email-verify-device-view: No email connector provided");
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xxl",
            "s",
            "xxl",
            "s"
        ]}
        gap="l"
      >
        <wui-icon-box
          size="xl"
          iconcolor="accent-100"
          backgroundcolor="accent-100"
          icon="verify"
          background="opaque"
        ></wui-icon-box>

        <wui-flex flexDirection="column" alignItems="center" gap="s">
          <wui-flex flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-400" color="fg-100">
              Approve the login link we sent to
            </wui-text>
            <wui-text variant="paragraph-400" color="fg-100"><b>${this.email}</b></wui-text>
          </wui-flex>

          <wui-text variant="small-400" color="fg-200" align="center">
            The code expires in 20 minutes
          </wui-text>

          <wui-flex alignItems="center" id="w3m-resend-section">
            <wui-text variant="small-400" color="fg-100" align="center">
              Didn't receive it?
            </wui-text>
            <wui-link @click=${this.onResendCode.bind(this)} .disabled=${this.loading}>
              Resend email
            </wui-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    async listenForDeviceApproval() {
        if (this.emailConnector) {
            await this.emailConnector.provider.connectDevice();
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "DEVICE_REGISTERED_FOR_EMAIL"
            });
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_VERIFICATION_CODE_SENT"
            });
            (0, $eMpli.RouterController).replace("EmailVerifyOtp", {
                email: this.email
            });
        }
    }
    async onResendCode() {
        try {
            if (!this.loading) {
                if (!this.emailConnector || !this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                this.loading = true;
                await this.emailConnector.provider.connectEmail({
                    email: this.email
                });
                (0, $45Xo0.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $45Xo0.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$beea795944ecb853$export$442e575aa1acbb10.styles = (0, $8400952a339c6d9f$export$2e2bcd8739ae039);
$beea795944ecb853$var$__decorate([
    (0, $dBBvD.state)()
], $beea795944ecb853$export$442e575aa1acbb10.prototype, "loading", void 0);
$beea795944ecb853$export$442e575aa1acbb10 = $beea795944ecb853$var$__decorate([
    (0, $33Xir.customElement)("w3m-email-verify-device-view")
], $beea795944ecb853$export$442e575aa1acbb10);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $1693b6df35fc895b$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  div {
    width: 100%;
    height: 400px;
  }

  [data-ready='false'] {
    transform: scale(1.05);
  }

  @media (max-width: 430px) {
    [data-ready='false'] {
      transform: translateY(-50px);
    }
  }
`;


parcelRequire("k1l85");
var $6CqNZ = parcelRequire("6CqNZ");
var $a11c797f7eed9054$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a11c797f7eed9054$export$ab9ab0bd09f8f225 = class W3mApproveTransactionView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.bodyObserver = undefined;
        this.unsubscribe = [];
        this.iframe = document.getElementById("w3m-iframe");
        this.ready = false;
        this.unsubscribe.push((0, $6CqNZ.ModalController).subscribeKey("open", (val)=>{
            if (!val) this.onHideIframe();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.bodyObserver?.unobserve(window.document.body);
    }
    firstUpdated() {
        const verticalPadding = 10;
        this.iframe.style.display = "block";
        const blueprint = this.renderRoot.querySelector("div");
        this.bodyObserver = new ResizeObserver(()=>{
            const data = blueprint?.getBoundingClientRect();
            const dimensions = data ?? {
                left: 0,
                top: 0,
                width: 0,
                height: 0
            };
            this.iframe.style.width = `${dimensions.width}px`;
            this.iframe.style.height = `${dimensions.height - verticalPadding}px`;
            this.iframe.style.left = `${dimensions.left}px`;
            this.iframe.style.top = `${dimensions.top + verticalPadding / 2}px`;
            this.ready = true;
        });
        this.bodyObserver.observe(window.document.body);
    }
    render() {
        if (this.ready) this.onShowIframe();
        return (0, $8AeG9.html)`<div data-ready=${this.ready}></div>`;
    }
    onShowIframe() {
        const isMobile = window.innerWidth <= 430;
        this.iframe.animate([
            {
                opacity: 0,
                transform: isMobile ? "translateY(50px)" : "scale(.95)"
            },
            {
                opacity: 1,
                transform: isMobile ? "translateY(0)" : "scale(1)"
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        });
    }
    async onHideIframe() {
        await this.iframe.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.iframe.style.display = "none";
    }
};
$a11c797f7eed9054$export$ab9ab0bd09f8f225.styles = (0, $1693b6df35fc895b$export$2e2bcd8739ae039);
$a11c797f7eed9054$var$__decorate([
    (0, $dBBvD.state)()
], $a11c797f7eed9054$export$ab9ab0bd09f8f225.prototype, "ready", void 0);
$a11c797f7eed9054$export$ab9ab0bd09f8f225 = $a11c797f7eed9054$var$__decorate([
    (0, $33Xir.customElement)("w3m-approve-transaction-view")
], $a11c797f7eed9054$export$ab9ab0bd09f8f225);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("k1l85");
var $fz7Cd = parcelRequire("fz7Cd");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
var $d7c0da26d88892d8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d7c0da26d88892d8$export$a1f0d947f01e8672 = class W3mUpgradeWalletView extends (0, $gy3vm.LitElement) {
    render() {
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">
        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>
        <wui-chip
          icon="externalLink"
          variant="fill"
          href=${(0, $fz7Cd.ConstantsUtil).SECURE_SITE_DASHBOARD}
          imageSrc=${(0, $fz7Cd.ConstantsUtil).SECURE_SITE_FAVICON}
        >
        </wui-chip>
        <wui-text variant="small-400" color="fg-200">
          You will have to reconnect for security reasons
        </wui-text>
      </wui-flex>
    `;
    }
};
$d7c0da26d88892d8$export$a1f0d947f01e8672 = $d7c0da26d88892d8$var$__decorate([
    (0, $33Xir.customElement)("w3m-upgrade-wallet-view")
], $d7c0da26d88892d8$export$a1f0d947f01e8672);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $8L7Gu = parcelRequire("8L7Gu");
var $bE42d = parcelRequire("bE42d");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("i6b12");
var $fUwov = parcelRequire("fUwov");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ba6930dc7f21c9e9$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }
`;


var $057a571827c8a74e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $057a571827c8a74e$export$6814d6aff4948a0 = class W3mUpdateEmailWalletView extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.formRef = (0, $fUwov.createRef)();
        this.initialValue = (0, $eMpli.RouterController).state.data?.email ?? "";
        this.email = "";
        this.loading = false;
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialValue;
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" padding="m" gap="m">
        <form ${(0, $fUwov.ref)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
          <wui-email-input
            value=${this.initialValue}
            .disabled=${this.loading}
            @inputChange=${this.onEmailInputChange.bind(this)}
          >
          </wui-email-input>
          <input type="submit" hidden />
        </form>

        <wui-flex gap="s">
          <wui-button size="md" variant="shade" fullWidth @click=${(0, $eMpli.RouterController).goBack}>
            Cancel
          </wui-button>

          <wui-button
            size="md"
            variant="fill"
            fullWidth
            @click=${this.onSubmitEmail.bind(this)}
            .disabled=${!showSubmit}
            .loading=${this.loading}
          >
            Save
          </wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-update-email-wallet: Email connector not found");
            await emailConnector.provider.updateEmail({
                email: this.email
            });
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_EDIT"
            });
            (0, $eMpli.RouterController).replace("UpdateEmailWalletWaiting", {
                email: this.email
            });
        } catch (error) {
            (0, $45Xo0.SnackController).showError(error);
            this.loading = false;
        }
    }
};
$057a571827c8a74e$export$6814d6aff4948a0.styles = (0, $ba6930dc7f21c9e9$export$2e2bcd8739ae039);
$057a571827c8a74e$var$__decorate([
    (0, $dBBvD.state)()
], $057a571827c8a74e$export$6814d6aff4948a0.prototype, "email", void 0);
$057a571827c8a74e$var$__decorate([
    (0, $dBBvD.state)()
], $057a571827c8a74e$export$6814d6aff4948a0.prototype, "loading", void 0);
$057a571827c8a74e$export$6814d6aff4948a0 = $057a571827c8a74e$var$__decorate([
    (0, $33Xir.customElement)("w3m-update-email-wallet-view")
], $057a571827c8a74e$export$6814d6aff4948a0);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $7e435c7aada4bcbe$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $8L7Gu = parcelRequire("8L7Gu");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $343e96e22e8ed712$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $343e96e22e8ed712$export$59fc1d416fcce4da = class W3mUpdateEmailWalletWaitingView extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.email = (0, $eMpli.RouterController).state.data?.email;
        this.emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
        this.loading = false;
        this.listenForEmailUpdateApproval();
    }
    render() {
        if (!this.email) throw new Error("w3m-update-email-wallet-waiting-view: No email provided");
        if (!this.emailConnector) throw new Error("w3m-update-email-wallet-waiting-view: No email connector provided");
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xxl",
            "s",
            "xxl",
            "s"
        ]}
        gap="l"
      >
        <wui-icon-box
          size="xl"
          iconcolor="accent-100"
          backgroundcolor="accent-100"
          icon="mail"
          background="opaque"
        ></wui-icon-box>

        <wui-flex flexDirection="column" alignItems="center" gap="s">
          <wui-flex flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-400" color="fg-100">
              Approve verification link we sent to
            </wui-text>
            <wui-text variant="paragraph-400" color="fg-100">${this.email}</wui-text>
          </wui-flex>

          <wui-text variant="small-400" color="fg-200" align="center">
            You will receive an approval request on your former mail to confirm the new one
          </wui-text>

          <wui-flex alignItems="center" id="w3m-resend-section">
            <wui-text variant="small-400" color="fg-100" align="center">
              Didn't receive it?
            </wui-text>
            <wui-link @click=${this.onResendCode.bind(this)} .disabled=${this.loading}>
              Resend email
            </wui-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    async listenForEmailUpdateApproval() {
        if (this.emailConnector) {
            await this.emailConnector.provider.awaitUpdateEmail();
            (0, $eMpli.RouterController).replace("Account");
            (0, $45Xo0.SnackController).showSuccess("Email updated");
        }
    }
    async onResendCode() {
        try {
            if (!this.loading) {
                if (!this.emailConnector || !this.email) throw new Error("w3m-update-email-wallet-waiting-view: Unable to resend email");
                this.loading = true;
                await this.emailConnector.provider.updateEmail({
                    email: this.email
                });
                this.listenForEmailUpdateApproval();
                (0, $45Xo0.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $45Xo0.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$343e96e22e8ed712$export$59fc1d416fcce4da.styles = (0, $7e435c7aada4bcbe$export$2e2bcd8739ae039);
$343e96e22e8ed712$var$__decorate([
    (0, $dBBvD.state)()
], $343e96e22e8ed712$export$59fc1d416fcce4da.prototype, "loading", void 0);
$343e96e22e8ed712$export$59fc1d416fcce4da = $343e96e22e8ed712$var$__decorate([
    (0, $33Xir.customElement)("w3m-update-email-wallet-waiting-view")
], $343e96e22e8ed712$export$59fc1d416fcce4da);


parcelRequire("k1l85");
var $k7Co7 = parcelRequire("k7Co7");
var $efzgw = parcelRequire("efzgw");
var $8L7Gu = parcelRequire("8L7Gu");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $362bd3c524b3871a$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-grid {
    max-height: clamp(360px, 400px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(auto-fill, 76px);
  }

  @media (max-width: 435px) {
    wui-grid {
      grid-template-columns: repeat(auto-fill, 77px);
    }
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    justify-content: center;
    grid-column: 1 / span 4;
  }
`;


parcelRequire("k1l85");
var $8L7Gu = parcelRequire("8L7Gu");
function $cc595d5f9f5585c4$export$cffc81df24a1f1f1(wallets) {
    const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
    const installedConnectors = connectors.filter((c)=>c.type === "ANNOUNCED").reduce((acum, val)=>{
        if (!val.info?.rdns) return acum;
        acum[val.info.rdns] = true;
        return acum;
    }, {});
    const walletsWithInstalled = wallets.map((wallet)=>({
            ...wallet,
            installed: Boolean(wallet.rdns) && Boolean(installedConnectors[wallet.rdns ?? ""])
        }));
    const sortedWallets = walletsWithInstalled.sort((a, b)=>Number(b.installed) - Number(a.installed));
    return sortedWallets;
}


var $28fd9f743bd0620a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $28fd9f743bd0620a$var$PAGINATOR_ID = "local-paginator";
let $28fd9f743bd0620a$export$f39175f9037ce7d2 = class W3mAllWalletsList extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.initial = !(0, $k7Co7.ApiController).state.wallets.length;
        this.wallets = (0, $k7Co7.ApiController).state.wallets;
        this.recommended = (0, $k7Co7.ApiController).state.recommended;
        this.featured = (0, $k7Co7.ApiController).state.featured;
        this.unsubscribe.push(...[
            (0, $k7Co7.ApiController).subscribeKey("wallets", (val)=>this.wallets = val),
            (0, $k7Co7.ApiController).subscribeKey("recommended", (val)=>this.recommended = val),
            (0, $k7Co7.ApiController).subscribeKey("featured", (val)=>this.featured = val)
        ]);
    }
    firstUpdated() {
        this.initialFetch();
        this.createPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.paginationObserver?.disconnect();
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-grid
        data-scroll=${!this.initial}
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        columnGap="xxs"
        rowGap="l"
        justifyContent="space-between"
      >
        ${this.initial ? this.shimmerTemplate(16) : this.walletsTemplate()}
        ${this.paginationLoaderTemplate()}
      </wui-grid>
    `;
    }
    async initialFetch() {
        const gridEl = this.shadowRoot?.querySelector("wui-grid");
        if (this.initial && gridEl) {
            await (0, $k7Co7.ApiController).fetchWallets({
                page: 1
            });
            await gridEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.initial = false;
            gridEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    shimmerTemplate(items, id) {
        return [
            ...Array(items)
        ].map(()=>(0, $8AeG9.html)`
        <wui-card-select-loader type="wallet" id=${(0, $ljfXw.ifDefined)(id)}></wui-card-select-loader>
      `);
    }
    walletsTemplate() {
        const wallets = [
            ...this.featured,
            ...this.recommended,
            ...this.wallets
        ];
        const walletsWithInstalled = (0, $cc595d5f9f5585c4$export$cffc81df24a1f1f1)(wallets);
        return walletsWithInstalled.map((wallet)=>(0, $8AeG9.html)`
        <wui-card-select
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
          type="wallet"
          name=${wallet.name}
          @click=${()=>this.onConnectWallet(wallet)}
          .installed=${wallet.installed}
        ></wui-card-select>
      `);
    }
    paginationLoaderTemplate() {
        const { wallets: wallets, recommended: recommended, featured: featured, count: count } = (0, $k7Co7.ApiController).state;
        const columns = window.innerWidth < 352 ? 3 : 4;
        const currentWallets = wallets.length + recommended.length;
        const minimumRows = Math.ceil(currentWallets / columns);
        let shimmerCount = minimumRows * columns - currentWallets + columns;
        shimmerCount -= wallets.length ? featured.length % columns : 0;
        if (count === 0 && featured.length > 0) return null;
        if (count === 0 || [
            ...featured,
            ...wallets,
            ...recommended
        ].length < count) return this.shimmerTemplate(shimmerCount, $28fd9f743bd0620a$var$PAGINATOR_ID);
        return null;
    }
    createPaginationObserver() {
        const loaderEl = this.shadowRoot?.querySelector(`#${$28fd9f743bd0620a$var$PAGINATOR_ID}`);
        if (loaderEl) {
            this.paginationObserver = new IntersectionObserver(([element])=>{
                if (element?.isIntersecting && !this.initial) {
                    const { page: page, count: count, wallets: wallets } = (0, $k7Co7.ApiController).state;
                    if (wallets.length < count) (0, $k7Co7.ApiController).fetchWallets({
                        page: page + 1
                    });
                }
            });
            this.paginationObserver.observe(loaderEl);
        }
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $eMpli.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $eMpli.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$28fd9f743bd0620a$export$f39175f9037ce7d2.styles = (0, $362bd3c524b3871a$export$2e2bcd8739ae039);
$28fd9f743bd0620a$var$__decorate([
    (0, $dBBvD.state)()
], $28fd9f743bd0620a$export$f39175f9037ce7d2.prototype, "initial", void 0);
$28fd9f743bd0620a$var$__decorate([
    (0, $dBBvD.state)()
], $28fd9f743bd0620a$export$f39175f9037ce7d2.prototype, "wallets", void 0);
$28fd9f743bd0620a$var$__decorate([
    (0, $dBBvD.state)()
], $28fd9f743bd0620a$export$f39175f9037ce7d2.prototype, "recommended", void 0);
$28fd9f743bd0620a$var$__decorate([
    (0, $dBBvD.state)()
], $28fd9f743bd0620a$export$f39175f9037ce7d2.prototype, "featured", void 0);
$28fd9f743bd0620a$export$f39175f9037ce7d2 = $28fd9f743bd0620a$var$__decorate([
    (0, $33Xir.customElement)("w3m-all-wallets-list")
], $28fd9f743bd0620a$export$f39175f9037ce7d2);


parcelRequire("k1l85");
var $k7Co7 = parcelRequire("k7Co7");
var $efzgw = parcelRequire("efzgw");
var $8L7Gu = parcelRequire("8L7Gu");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $092e7c4c44107411$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-grid,
  wui-loading-spinner,
  wui-flex {
    height: 360px;
  }

  wui-grid {
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    justify-content: center;
    align-items: center;
  }
`;



var $7c71afbe2b59bfc5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7c71afbe2b59bfc5$export$65a744e48142d5af = class W3mAllWalletsSearch extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.prevQuery = "";
        this.loading = true;
        this.query = "";
    }
    render() {
        this.onSearch();
        return this.loading ? (0, $8AeG9.html)`<wui-loading-spinner color="accent-100"></wui-loading-spinner>` : this.walletsTemplate();
    }
    async onSearch() {
        if (this.query !== this.prevQuery) {
            this.prevQuery = this.query;
            this.loading = true;
            await (0, $k7Co7.ApiController).searchWallet({
                search: this.query
            });
            this.loading = false;
        }
    }
    walletsTemplate() {
        const { search: search } = (0, $k7Co7.ApiController).state;
        const wallets = (0, $cc595d5f9f5585c4$export$cffc81df24a1f1f1)(search);
        if (!search.length) return (0, $8AeG9.html)`
        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">
          <wui-icon-box
            size="lg"
            iconColor="fg-200"
            backgroundColor="fg-300"
            icon="wallet"
            background="transparent"
          ></wui-icon-box>
          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>
        </wui-flex>
      `;
        return (0, $8AeG9.html)`
      <wui-grid
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        gridTemplateColumns="repeat(4, 1fr)"
        rowGap="l"
        columnGap="xs"
      >
        ${wallets.map((wallet)=>(0, $8AeG9.html)`
            <wui-card-select
              imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(wallet))}
              type="wallet"
              name=${wallet.name}
              @click=${()=>this.onConnectWallet(wallet)}
              .installed=${wallet.installed}
            ></wui-card-select>
          `)}
      </wui-grid>
    `;
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $eMpli.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $eMpli.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$7c71afbe2b59bfc5$export$65a744e48142d5af.styles = (0, $092e7c4c44107411$export$2e2bcd8739ae039);
$7c71afbe2b59bfc5$var$__decorate([
    (0, $dBBvD.state)()
], $7c71afbe2b59bfc5$export$65a744e48142d5af.prototype, "loading", void 0);
$7c71afbe2b59bfc5$var$__decorate([
    (0, $kRRY9.property)()
], $7c71afbe2b59bfc5$export$65a744e48142d5af.prototype, "query", void 0);
$7c71afbe2b59bfc5$export$65a744e48142d5af = $7c71afbe2b59bfc5$var$__decorate([
    (0, $33Xir.customElement)("w3m-all-wallets-search")
], $7c71afbe2b59bfc5$export$65a744e48142d5af);


parcelRequire("k1l85");
var $58zho = parcelRequire("58zho");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $dBBvD = parcelRequire("dBBvD");
var $778378ecbbd34e15$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $778378ecbbd34e15$export$994bb77f05fbbbde = class W3mConnectingHeader extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.platformTabs = [];
        this.unsubscribe = [];
        this.platforms = [];
        this.onSelectPlatfrom = undefined;
        this.buffering = false;
        this.unsubscribe.push((0, $58zho.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const tabs = this.generateTabs();
        return (0, $8AeG9.html)`
      <wui-flex justifyContent="center" .padding=${[
            "l",
            "0",
            "0",
            "0"
        ]}>
        <wui-tabs
          ?disabled=${this.buffering}
          .tabs=${tabs}
          .onTabChange=${this.onTabChange.bind(this)}
        ></wui-tabs>
      </wui-flex>
    `;
    }
    generateTabs() {
        const tabs = this.platforms.map((platform)=>{
            if (platform === "browser") return {
                label: "Browser",
                icon: "extension",
                platform: "browser"
            };
            else if (platform === "mobile") return {
                label: "Mobile",
                icon: "mobile",
                platform: "mobile"
            };
            else if (platform === "qrcode") return {
                label: "Mobile",
                icon: "mobile",
                platform: "qrcode"
            };
            else if (platform === "web") return {
                label: "Webapp",
                icon: "browser",
                platform: "web"
            };
            else if (platform === "desktop") return {
                label: "Desktop",
                icon: "desktop",
                platform: "desktop"
            };
            return {
                label: "Browser",
                icon: "extension",
                platform: "unsupported"
            };
        });
        this.platformTabs = tabs.map(({ platform: platform })=>platform);
        return tabs;
    }
    onTabChange(index) {
        const tab = this.platformTabs[index];
        if (tab) this.onSelectPlatfrom?.(tab);
    }
};
$778378ecbbd34e15$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $778378ecbbd34e15$export$994bb77f05fbbbde.prototype, "platforms", void 0);
$778378ecbbd34e15$var$__decorate([
    (0, $kRRY9.property)()
], $778378ecbbd34e15$export$994bb77f05fbbbde.prototype, "onSelectPlatfrom", void 0);
$778378ecbbd34e15$var$__decorate([
    (0, $dBBvD.state)()
], $778378ecbbd34e15$export$994bb77f05fbbbde.prototype, "buffering", void 0);
$778378ecbbd34e15$export$994bb77f05fbbbde = $778378ecbbd34e15$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-header")
], $778378ecbbd34e15$export$994bb77f05fbbbde);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $8L7Gu = parcelRequire("8L7Gu");
var $58zho = parcelRequire("58zho");
var $6CqNZ = parcelRequire("6CqNZ");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");

var $85f93ea5309e0248$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $85f93ea5309e0248$export$f6b6073753ecd240 = class W3mConnectingWcBrowser extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-browser: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    async onConnectProxy() {
        try {
            this.error = false;
            const { connectors: connectors } = (0, $8L7Gu.ConnectorController).state;
            const announcedConnector = connectors.find((c)=>c.type === "ANNOUNCED" && c.info?.rdns === this.wallet?.rdns);
            const injectedConnector = connectors.find((c)=>c.type === "INJECTED");
            if (announcedConnector) await (0, $58zho.ConnectionController).connectExternal(announcedConnector);
            else if (injectedConnector) await (0, $58zho.ConnectionController).connectExternal(injectedConnector);
            (0, $6CqNZ.ModalController).close();
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_SUCCESS",
                properties: {
                    method: "browser"
                }
            });
        } catch (error) {
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$85f93ea5309e0248$export$f6b6073753ecd240 = $85f93ea5309e0248$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-browser")
], $85f93ea5309e0248$export$f6b6073753ecd240);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $bYnq1 = parcelRequire("bYnq1");
var $58zho = parcelRequire("58zho");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");

var $fa50891d461c392a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fa50891d461c392a$export$99d24518d9937f53 = class W3mConnectingWcDesktop extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-desktop: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "desktop"
            }
        });
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.timeout = setTimeout(()=>{
                this.onConnect?.();
            }, 200);
        }
    }
    onConnectProxy() {
        if (this.wallet?.desktop_link && this.uri) try {
            this.error = false;
            const { desktop_link: desktop_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $bYnq1.CoreHelperUtil).formatNativeUrl(desktop_link, this.uri);
            (0, $58zho.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $58zho.ConnectionController).setRecentWallet(this.wallet);
            (0, $bYnq1.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$fa50891d461c392a$export$99d24518d9937f53 = $fa50891d461c392a$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-desktop")
], $fa50891d461c392a$export$99d24518d9937f53);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $bYnq1 = parcelRequire("bYnq1");
var $58zho = parcelRequire("58zho");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");

var $4e6c3d3c39629417$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4e6c3d3c39629417$export$bde153011a6b26 = class W3mConnectingWcMobile extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-mobile: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        document.addEventListener("visibilitychange", this.onBuffering.bind(this));
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "mobile"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.onConnect?.();
        }
    }
    onConnectProxy() {
        if (this.wallet?.mobile_link && this.uri) try {
            this.error = false;
            const { mobile_link: mobile_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $bYnq1.CoreHelperUtil).formatNativeUrl(mobile_link, this.uri);
            (0, $58zho.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $58zho.ConnectionController).setRecentWallet(this.wallet);
            (0, $bYnq1.CoreHelperUtil).openHref(redirect, "_self");
        } catch  {
            this.error = true;
        }
    }
    onBuffering() {
        const isIos = (0, $bYnq1.CoreHelperUtil).isIos();
        if (document?.visibilityState === "visible" && !this.error && isIos) {
            (0, $58zho.ConnectionController).setBuffering(true);
            setTimeout(()=>{
                (0, $58zho.ConnectionController).setBuffering(false);
            }, 5000);
        }
    }
};
$4e6c3d3c39629417$export$bde153011a6b26 = $4e6c3d3c39629417$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-mobile")
], $4e6c3d3c39629417$export$bde153011a6b26);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $58zho = parcelRequire("58zho");
var $eMTTW = parcelRequire("eMTTW");
var $efzgw = parcelRequire("efzgw");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");

parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $9f9fbe440b3fb7ef$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }
`;


var $189dbb7bd680e258$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $189dbb7bd680e258$export$d4369b1b68d9b78a = class W3mConnectingWcQrcode extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        this.forceUpdate = ()=>{
            this.requestUpdate();
        };
        window.addEventListener("resize", this.forceUpdate);
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet?.name ?? "WalletConnect",
                platform: "qrcode"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("resize", this.forceUpdate);
    }
    render() {
        this.onRenderProxy();
        return (0, $8AeG9.html)`
      <wui-flex padding="xl" flexDirection="column" gap="xl" alignItems="center">
        <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

        <wui-text variant="paragraph-500" color="fg-100">
          Scan this QR Code with your phone
        </wui-text>
        ${this.copyTemplate()}
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onRenderProxy() {
        if (!this.ready && this.uri) this.timeout = setTimeout(()=>{
            this.ready = true;
        }, 200);
    }
    qrCodeTemplate() {
        if (!this.uri || !this.ready) return null;
        const size = this.getBoundingClientRect().width - 40;
        const alt = this.wallet ? this.wallet.name : undefined;
        (0, $58zho.ConnectionController).setWcLinking(undefined);
        (0, $58zho.ConnectionController).setRecentWallet(this.wallet);
        return (0, $8AeG9.html)` <wui-qr-code
      size=${size}
      theme=${(0, $eMTTW.ThemeController).state.themeMode}
      uri=${this.uri}
      imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(this.wallet))}
      alt=${(0, $ljfXw.ifDefined)(alt)}
    ></wui-qr-code>`;
    }
    copyTemplate() {
        const inactive = !this.uri || !this.ready;
        return (0, $8AeG9.html)`<wui-link
      .disabled=${inactive}
      @click=${this.onCopyUri}
      color="fg-200"
      data-testid="copy-wc2-uri"
    >
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
    }
};
$189dbb7bd680e258$export$d4369b1b68d9b78a.styles = (0, $9f9fbe440b3fb7ef$export$2e2bcd8739ae039);
$189dbb7bd680e258$export$d4369b1b68d9b78a = $189dbb7bd680e258$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-qrcode")
], $189dbb7bd680e258$export$d4369b1b68d9b78a);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $781f71edd2fb7712$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: flex;
    justify-content: center;
    gap: var(--wui-spacing-2xl);
  }

  wui-visual-thumbnail:nth-child(1) {
    z-index: 1;
  }
`;


parcelRequire("k1l85");
var $3pfUo = parcelRequire("3pfUo");
var $jheXw = parcelRequire("jheXw");
var $f768f4bd2aa7e063$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f768f4bd2aa7e063$export$415fdf721000461b = class W3mConnectingSiwe extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.dappImageUrl = (0, $3pfUo.OptionsController).state.metadata?.icons;
        this.walletImageUrl = (0, $jheXw.StorageUtil).getConnectedWalletImageUrl();
    }
    firstUpdated() {
        const visuals = this.shadowRoot?.querySelectorAll("wui-visual-thumbnail");
        if (visuals?.[0]) this.createAnimation(visuals[0], "translate(18px)");
        if (visuals?.[1]) this.createAnimation(visuals[1], "translate(-18px)");
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-visual-thumbnail
        ?borderRadiusFull=${true}
        .imageSrc=${this.dappImageUrl?.[0]}
      ></wui-visual-thumbnail>
      <wui-visual-thumbnail .imageSrc=${this.walletImageUrl}></wui-visual-thumbnail>
    `;
    }
    createAnimation(element, translation) {
        element.animate([
            {
                transform: "translateX(0px)"
            },
            {
                transform: translation
            }
        ], {
            duration: 1600,
            easing: "cubic-bezier(0.56, 0, 0.48, 1)",
            direction: "alternate",
            iterations: Infinity
        });
    }
};
$f768f4bd2aa7e063$export$415fdf721000461b.styles = (0, $781f71edd2fb7712$export$2e2bcd8739ae039);
$f768f4bd2aa7e063$export$415fdf721000461b = $f768f4bd2aa7e063$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-siwe")
], $f768f4bd2aa7e063$export$415fdf721000461b);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $bE42d = parcelRequire("bE42d");
var $efzgw = parcelRequire("efzgw");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("96Axb");
var $ljfXw = parcelRequire("ljfXw");
var $75d18963fee11312$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $75d18963fee11312$export$8ced6ff0971fe41b = class W3mConnectingWcUnsupported extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $eMpli.RouterController).state.data?.wallet;
        if (!this.wallet) throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-wallet-image
          size="lg"
          imageSrc=${(0, $ljfXw.ifDefined)((0, $efzgw.AssetUtil).getWalletImage(this.wallet))}
        ></wui-wallet-image>

        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
};
$75d18963fee11312$export$8ced6ff0971fe41b = $75d18963fee11312$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-unsupported")
], $75d18963fee11312$export$8ced6ff0971fe41b);


parcelRequire("k1l85");
var $bE42d = parcelRequire("bE42d");
var $bYnq1 = parcelRequire("bYnq1");
var $58zho = parcelRequire("58zho");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");

var $d6f8095a963d634a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d6f8095a963d634a$export$bdfe677b483cfd66 = class W3mConnectingWcWeb extends (0, $67ff31ff27e88f46$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-web: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.secondaryBtnLabel = "Open";
        this.secondaryLabel = "Open and continue in a new browser tab";
        this.secondaryBtnIcon = "externalLink";
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "web"
            }
        });
    }
    onConnectProxy() {
        if (this.wallet?.webapp_link && this.uri) try {
            this.error = false;
            const { webapp_link: webapp_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $bYnq1.CoreHelperUtil).formatUniversalUrl(webapp_link, this.uri);
            (0, $58zho.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $58zho.ConnectionController).setRecentWallet(this.wallet);
            (0, $bYnq1.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$d6f8095a963d634a$export$bdfe677b483cfd66 = $d6f8095a963d634a$var$__decorate([
    (0, $33Xir.customElement)("w3m-connecting-wc-web")
], $d6f8095a963d634a$export$bdfe677b483cfd66);


parcelRequire("k1l85");
var $eMpli = parcelRequire("eMpli");
var $8L7Gu = parcelRequire("8L7Gu");
var $58zho = parcelRequire("58zho");
var $bE42d = parcelRequire("bE42d");
var $afSSl = parcelRequire("afSSl");
var $6CqNZ = parcelRequire("6CqNZ");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $cbd3f883b1617e48$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }
`;


var $317a2f69eb54e376$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $317a2f69eb54e376$var$headings() {
    const connectorName = (0, $eMpli.RouterController).state.data?.connector?.name;
    const walletName = (0, $eMpli.RouterController).state.data?.wallet?.name;
    const networkName = (0, $eMpli.RouterController).state.data?.network?.name;
    const name = walletName ?? connectorName;
    const connectors = (0, $8L7Gu.ConnectorController).getConnectors();
    const isEmail = connectors.length === 1 && connectors[0]?.id === "w3m-email";
    return {
        Connect: `Connect ${isEmail ? "Email" : ""} Wallet`,
        Account: undefined,
        ConnectingExternal: name ?? "Connect Wallet",
        ConnectingWalletConnect: name ?? "WalletConnect",
        ConnectingSiwe: "Sign In",
        Networks: "Choose Network",
        SwitchNetwork: networkName ?? "Switch Network",
        AllWallets: "All Wallets",
        WhatIsANetwork: "What is a network?",
        WhatIsAWallet: "What is a wallet?",
        GetWallet: "Get a wallet",
        Downloads: name ? `Get ${name}` : "Downloads",
        EmailVerifyOtp: "Confirm Email",
        EmailVerifyDevice: "Register Device",
        ApproveTransaction: "Approve Transaction",
        Transactions: "Activity",
        UpgradeEmailWallet: "Upgrade your Wallet",
        UpdateEmailWallet: "Edit Email",
        UpdateEmailWalletWaiting: "Approve Email"
    };
}
let $317a2f69eb54e376$export$c6714271d9f13670 = class W3mHeader extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.heading = $317a2f69eb54e376$var$headings()[(0, $eMpli.RouterController).state.view];
        this.buffering = false;
        this.showBack = false;
        this.unsubscribe.push((0, $eMpli.RouterController).subscribeKey("view", (val)=>{
            this.onViewChange(val);
            this.onHistoryChange();
        }), (0, $58zho.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex .padding=${this.getPadding()} justifyContent="space-between" alignItems="center">
        ${this.dynamicButtonTemplate()} ${this.titleTemplate()}
        <wui-icon-link
          ?disabled=${this.buffering}
          icon="close"
          @click=${this.onClose.bind(this)}
          data-testid="w3m-header-close"
        ></wui-icon-link>
      </wui-flex>
      ${this.separatorTemplate()}
    `;
    }
    onWalletHelp() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "CLICK_WALLET_HELP"
        });
        (0, $eMpli.RouterController).push("WhatIsAWallet");
    }
    async onClose() {
        if ((0, $afSSl.SIWEController).state.isSiweEnabled && (0, $afSSl.SIWEController).state.status !== "success") await (0, $58zho.ConnectionController).disconnect();
        (0, $6CqNZ.ModalController).close();
    }
    titleTemplate() {
        return (0, $8AeG9.html)`<wui-text variant="paragraph-700" color="fg-100">${this.heading}</wui-text>`;
    }
    dynamicButtonTemplate() {
        const { view: view } = (0, $eMpli.RouterController).state;
        const isConnectHelp = view === "Connect";
        const isApproveTransaction = view === "ApproveTransaction";
        if (this.showBack && !isApproveTransaction) return (0, $8AeG9.html)`<wui-icon-link
        id="dynamic"
        icon="chevronLeft"
        ?disabled=${this.buffering}
        @click=${this.onGoBack.bind(this)}
      ></wui-icon-link>`;
        return (0, $8AeG9.html)`<wui-icon-link
      data-hidden=${!isConnectHelp}
      id="dynamic"
      icon="helpCircle"
      @click=${this.onWalletHelp.bind(this)}
    ></wui-icon-link>`;
    }
    separatorTemplate() {
        if (!this.heading) return null;
        return (0, $8AeG9.html)`<wui-separator></wui-separator>`;
    }
    getPadding() {
        if (this.heading) return [
            "l",
            "2l",
            "l",
            "2l"
        ];
        return [
            "l",
            "2l",
            "0",
            "2l"
        ];
    }
    async onViewChange(view) {
        const headingEl = this.shadowRoot?.querySelector("wui-text");
        if (headingEl) {
            const preset = $317a2f69eb54e376$var$headings()[view];
            await headingEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.heading = preset;
            headingEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onHistoryChange() {
        const { history: history } = (0, $eMpli.RouterController).state;
        const buttonEl = this.shadowRoot?.querySelector("#dynamic");
        if (history.length > 1 && !this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = true;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        } else if (history.length <= 1 && this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = false;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onGoBack() {
        if ((0, $eMpli.RouterController).state.view === "ConnectingSiwe") (0, $eMpli.RouterController).push("Connect");
        else (0, $eMpli.RouterController).goBack();
    }
};
$317a2f69eb54e376$export$c6714271d9f13670.styles = [
    (0, $cbd3f883b1617e48$export$2e2bcd8739ae039)
];
$317a2f69eb54e376$var$__decorate([
    (0, $dBBvD.state)()
], $317a2f69eb54e376$export$c6714271d9f13670.prototype, "heading", void 0);
$317a2f69eb54e376$var$__decorate([
    (0, $dBBvD.state)()
], $317a2f69eb54e376$export$c6714271d9f13670.prototype, "buffering", void 0);
$317a2f69eb54e376$var$__decorate([
    (0, $dBBvD.state)()
], $317a2f69eb54e376$export$c6714271d9f13670.prototype, "showBack", void 0);
$317a2f69eb54e376$export$c6714271d9f13670 = $317a2f69eb54e376$var$__decorate([
    (0, $33Xir.customElement)("w3m-header")
], $317a2f69eb54e376$export$c6714271d9f13670);


parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
var $2dfa6093c4611c05$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2dfa6093c4611c05$export$c95abd0ceed44b88 = class W3mHelpWidget extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.data = [];
    }
    render() {
        return (0, $8AeG9.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        ${this.data.map((item)=>(0, $8AeG9.html)`
            <wui-flex flexDirection="column" alignItems="center" gap="xl">
              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">
                ${item.images.map((image)=>(0, $8AeG9.html)`<wui-visual name=${image}></wui-visual>`)}
              </wui-flex>
            </wui-flex>
            <wui-flex flexDirection="column" alignItems="center" gap="xxs">
              <wui-text variant="paragraph-500" color="fg-100" align="center">
                ${item.title}
              </wui-text>
              <wui-text variant="small-500" color="fg-200" align="center">${item.text}</wui-text>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$2dfa6093c4611c05$var$__decorate([
    (0, $kRRY9.property)({
        type: Array
    })
], $2dfa6093c4611c05$export$c95abd0ceed44b88.prototype, "data", void 0);
$2dfa6093c4611c05$export$c95abd0ceed44b88 = $2dfa6093c4611c05$var$__decorate([
    (0, $33Xir.customElement)("w3m-help-widget")
], $2dfa6093c4611c05$export$c95abd0ceed44b88);


parcelRequire("k1l85");
var $3pfUo = parcelRequire("3pfUo");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $cd5979317d2dbf42$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-flex {
    background-color: var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
  }
`;


var $f719d26a95ba5895$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f719d26a95ba5895$export$c463b51fb31743f5 = class W3mLegalFooter extends (0, $gy3vm.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $3pfUo.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $8AeG9.html)`
      <wui-flex .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]} justifyContent="center">
        <wui-text color="fg-250" variant="small-400" align="center">
          By connecting your wallet, you agree to our <br />
          ${this.termsTemplate()} ${this.andTemplate()} ${this.privacyTemplate()}
        </wui-text>
      </wui-flex>
    `;
    }
    andTemplate() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $3pfUo.OptionsController).state;
        return termsConditionsUrl && privacyPolicyUrl ? "and" : "";
    }
    termsTemplate() {
        const { termsConditionsUrl: termsConditionsUrl } = (0, $3pfUo.OptionsController).state;
        if (!termsConditionsUrl) return null;
        return (0, $8AeG9.html)`<a href=${termsConditionsUrl}>Terms of Service</a>`;
    }
    privacyTemplate() {
        const { privacyPolicyUrl: privacyPolicyUrl } = (0, $3pfUo.OptionsController).state;
        if (!privacyPolicyUrl) return null;
        return (0, $8AeG9.html)`<a href=${privacyPolicyUrl}>Privacy Policy</a>`;
    }
};
$f719d26a95ba5895$export$c463b51fb31743f5.styles = [
    (0, $cd5979317d2dbf42$export$2e2bcd8739ae039)
];
$f719d26a95ba5895$export$c463b51fb31743f5 = $f719d26a95ba5895$var$__decorate([
    (0, $33Xir.customElement)("w3m-legal-footer")
], $f719d26a95ba5895$export$c463b51fb31743f5);


parcelRequire("k1l85");
var $bYnq1 = parcelRequire("bYnq1");
var $eMpli = parcelRequire("eMpli");
parcelRequire("bG7tm");
var $8iLLL = parcelRequire("8iLLL");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $kRRY9 = parcelRequire("kRRY9");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $7737ffb8ad1bd373$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;


var $cd5b535d0037887b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $cd5b535d0037887b$export$eabbdf5c2372470b = class W3mMobileDownloadLinks extends (0, $gy3vm.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = undefined;
    }
    render() {
        if (!this.wallet) {
            this.style.display = "none";
            return null;
        }
        const { name: name, app_store: app_store, play_store: play_store, chrome_store: chrome_store, homepage: homepage } = this.wallet;
        const isMobile = (0, $bYnq1.CoreHelperUtil).isMobile();
        const isIos = (0, $bYnq1.CoreHelperUtil).isIos();
        const isAndroid = (0, $bYnq1.CoreHelperUtil).isAndroid();
        const isMultiple = [
            app_store,
            play_store,
            homepage,
            chrome_store
        ].filter(Boolean).length > 1;
        const shortName = (0, $8iLLL.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 12,
            charsEnd: 0,
            truncate: "end"
        });
        if (isMultiple && !isMobile) return (0, $8AeG9.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${()=>(0, $eMpli.RouterController).push("Downloads", {
                wallet: this.wallet
            })}
        ></wui-cta-button>
      `;
        if (!isMultiple && homepage) return (0, $8AeG9.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onHomePage.bind(this)}
        ></wui-cta-button>
      `;
        if (app_store && isIos) return (0, $8AeG9.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onAppStore.bind(this)}
        ></wui-cta-button>
      `;
        if (play_store && isAndroid) return (0, $8AeG9.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onPlayStore.bind(this)}
        ></wui-cta-button>
      `;
        this.style.display = "none";
        return null;
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $bYnq1.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$cd5b535d0037887b$export$eabbdf5c2372470b.styles = [
    (0, $7737ffb8ad1bd373$export$2e2bcd8739ae039)
];
$cd5b535d0037887b$var$__decorate([
    (0, $kRRY9.property)({
        type: Object
    })
], $cd5b535d0037887b$export$eabbdf5c2372470b.prototype, "wallet", void 0);
$cd5b535d0037887b$export$eabbdf5c2372470b = $cd5b535d0037887b$var$__decorate([
    (0, $33Xir.customElement)("w3m-mobile-download-links")
], $cd5b535d0037887b$export$eabbdf5c2372470b);


parcelRequire("k1l85");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $ec1069d72c7496ab$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;


var $54a6db6c144c7d46$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $54a6db6c144c7d46$var$presets = {
    success: {
        backgroundColor: "success-100",
        iconColor: "success-100",
        icon: "checkmark"
    },
    error: {
        backgroundColor: "error-100",
        iconColor: "error-100",
        icon: "close"
    }
};
let $54a6db6c144c7d46$export$a84538312ac1ab9d = class W3mSnackBar extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.timeout = undefined;
        this.open = (0, $45Xo0.SnackController).state.open;
        this.unsubscribe.push((0, $45Xo0.SnackController).subscribeKey("open", (val)=>{
            this.open = val;
            this.onOpen();
        }));
    }
    disconnectedCallback() {
        clearTimeout(this.timeout);
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { message: message, variant: variant } = (0, $45Xo0.SnackController).state;
        const preset = $54a6db6c144c7d46$var$presets[variant];
        return (0, $8AeG9.html)`
      <wui-snackbar
        message=${message}
        backgroundColor=${preset.backgroundColor}
        iconColor=${preset.iconColor}
        icon=${preset.icon}
      ></wui-snackbar>
    `;
    }
    onOpen() {
        clearTimeout(this.timeout);
        if (this.open) {
            this.animate([
                {
                    opacity: 0,
                    transform: "translateX(-50%) scale(0.85)"
                },
                {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1)"
                }
            ], {
                duration: 150,
                fill: "forwards",
                easing: "ease"
            });
            this.timeout = setTimeout(()=>(0, $45Xo0.SnackController).hide(), 2500);
        } else this.animate([
            {
                opacity: 1,
                transform: "translateX(-50%) scale(1)"
            },
            {
                opacity: 0,
                transform: "translateX(-50%) scale(0.85)"
            }
        ], {
            duration: 150,
            fill: "forwards",
            easing: "ease"
        });
    }
};
$54a6db6c144c7d46$export$a84538312ac1ab9d.styles = (0, $ec1069d72c7496ab$export$2e2bcd8739ae039);
$54a6db6c144c7d46$var$__decorate([
    (0, $dBBvD.state)()
], $54a6db6c144c7d46$export$a84538312ac1ab9d.prototype, "open", void 0);
$54a6db6c144c7d46$export$a84538312ac1ab9d = $54a6db6c144c7d46$var$__decorate([
    (0, $33Xir.customElement)("w3m-snackbar")
], $54a6db6c144c7d46$export$a84538312ac1ab9d);


parcelRequire("k1l85");
var $8L7Gu = parcelRequire("8L7Gu");
var $bE42d = parcelRequire("bE42d");
var $eMpli = parcelRequire("eMpli");
var $bYnq1 = parcelRequire("bYnq1");
var $45Xo0 = parcelRequire("45Xo0");
parcelRequire("bG7tm");
var $33Xir = parcelRequire("33Xir");
parcelRequire("dYFMW");
var $8AeG9 = parcelRequire("8AeG9");
var $gy3vm = parcelRequire("gy3vm");
parcelRequire("7AsZS");
var $dBBvD = parcelRequire("dBBvD");
parcelRequire("i6b12");
var $fUwov = parcelRequire("fUwov");
parcelRequire("dYFMW");
var $6qGkP = parcelRequire("6qGkP");
var $933491d3171e1844$export$2e2bcd8739ae039 = (0, $6qGkP.css)`
  wui-separator {
    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }

  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }

  wui-icon-link,
  wui-loading-spinner {
    position: absolute;
    top: 21px;
    transform: translateY(-50%);
  }

  wui-icon-link {
    right: var(--wui-spacing-xs);
  }

  wui-loading-spinner {
    right: var(--wui-spacing-m);
  }

  .alphaBanner {
    padding: 10px 12px 10px 10px;
    border-radius: var(--wui-border-radius-s);
    background: var(--wui-accent-glass-010);
    margin-bottom: var(--wui-spacing-s);
  }
`;


var $96afeba546228c22$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $96afeba546228c22$export$73f53e8345d3576d = class W3mEmailLoginWidget extends (0, $gy3vm.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.formRef = (0, $fUwov.createRef)();
        this.connectors = (0, $8L7Gu.ConnectorController).state.connectors;
        this.email = "";
        this.loading = false;
        this.error = "";
        this.unsubscribe.push((0, $8L7Gu.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const multipleConnectors = this.connectors.length > 1;
        const connector = this.connectors.find((c)=>c.type === "EMAIL");
        if (!connector) return null;
        return (0, $8AeG9.html)`
      ${this.alphaWarningTemplate()}
      <form ${(0, $fUwov.ref)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          @focus=${this.onFocusEvent.bind(this)}
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
          .errorMessage=${this.error}
        >
        </wui-email-input>

        ${this.submitButtonTemplate()}${this.loadingTemplate()}
        <input type="submit" hidden />
      </form>

      ${multipleConnectors ? (0, $8AeG9.html)`<wui-separator text="or"></wui-separator>` : null}
    `;
    }
    alphaWarningTemplate() {
        const showAlphaWarning = true;
        return showAlphaWarning ? (0, $8AeG9.html)`
          <wui-flex class="alphaBanner" gap="xs" alignItems="center" justifyContent="center">
            <wui-icon-box
              size="sm"
              icon="alpha"
              iconColor="accent-100"
              background="opaque"
              backgroundColor="accent-100"
            ></wui-icon-box>
            <wui-text variant="small-400" color="accent-100">
              This is an alpha version to test before launch
            </wui-text>
          </wui-flex>
        ` : null;
    }
    submitButtonTemplate() {
        const showSubmit = !this.loading && this.email.length > 3;
        return showSubmit ? (0, $8AeG9.html)`
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitEmail.bind(this)}
          >
          </wui-icon-link>
        ` : null;
    }
    loadingTemplate() {
        return this.loading ? (0, $8AeG9.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
        this.error = "";
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-email-login-widget: Email connector not found");
            const { action: action } = await emailConnector.provider.connectEmail({
                email: this.email
            });
            (0, $bE42d.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_SUBMITTED"
            });
            if (action === "VERIFY_OTP") {
                (0, $bE42d.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
                (0, $eMpli.RouterController).push("EmailVerifyOtp", {
                    email: this.email
                });
            } else if (action === "VERIFY_DEVICE") (0, $eMpli.RouterController).push("EmailVerifyDevice", {
                email: this.email
            });
        } catch (error) {
            const parsedError = (0, $bYnq1.CoreHelperUtil).parseError(error);
            if (parsedError?.includes("Invalid email")) this.error = "Invalid email. Try again.";
            else (0, $45Xo0.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    onFocusEvent() {
        (0, $bE42d.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_LOGIN_SELECTED"
        });
    }
};
$96afeba546228c22$export$73f53e8345d3576d.styles = (0, $933491d3171e1844$export$2e2bcd8739ae039);
$96afeba546228c22$var$__decorate([
    (0, $dBBvD.state)()
], $96afeba546228c22$export$73f53e8345d3576d.prototype, "connectors", void 0);
$96afeba546228c22$var$__decorate([
    (0, $dBBvD.state)()
], $96afeba546228c22$export$73f53e8345d3576d.prototype, "email", void 0);
$96afeba546228c22$var$__decorate([
    (0, $dBBvD.state)()
], $96afeba546228c22$export$73f53e8345d3576d.prototype, "loading", void 0);
$96afeba546228c22$var$__decorate([
    (0, $dBBvD.state)()
], $96afeba546228c22$export$73f53e8345d3576d.prototype, "error", void 0);
$96afeba546228c22$export$73f53e8345d3576d = $96afeba546228c22$var$__decorate([
    (0, $33Xir.customElement)("w3m-email-login-widget")
], $96afeba546228c22$export$73f53e8345d3576d);


parcelRequire("k1l85");
var $aoKpV = parcelRequire("aoKpV");
var $j0fVO = parcelRequire("j0fVO");
var $8L7Gu = parcelRequire("8L7Gu");
var $58zho = parcelRequire("58zho");
var $cHcnO = parcelRequire("cHcnO");
var $afSSl = parcelRequire("afSSl");
var $6CqNZ = parcelRequire("6CqNZ");
var $eMTTW = parcelRequire("eMTTW");
var $dTOcV = parcelRequire("dTOcV");
var $bE42d = parcelRequire("bE42d");
var $3pfUo = parcelRequire("3pfUo");
var $bYnq1 = parcelRequire("bYnq1");
parcelRequire("bG7tm");
var $hCS0p = parcelRequire("hCS0p");
let $2747719ce9417d74$var$isInitialized = false;


class $2747719ce9417d74$export$14b4aa396d4aed9a {
    constructor(options){
        this.initPromise = undefined;
        this.setIsConnected = (isConnected)=>{
            (0, $aoKpV.AccountController).setIsConnected(isConnected);
        };
        this.setCaipAddress = (caipAddress)=>{
            (0, $aoKpV.AccountController).setCaipAddress(caipAddress);
        };
        this.setBalance = (balance, balanceSymbol)=>{
            (0, $aoKpV.AccountController).setBalance(balance, balanceSymbol);
        };
        this.setProfileName = (profileName)=>{
            (0, $aoKpV.AccountController).setProfileName(profileName);
        };
        this.setProfileImage = (profileImage)=>{
            (0, $aoKpV.AccountController).setProfileImage(profileImage);
        };
        this.resetAccount = ()=>{
            (0, $aoKpV.AccountController).resetAccount();
        };
        this.setCaipNetwork = (caipNetwork)=>{
            (0, $j0fVO.NetworkController).setCaipNetwork(caipNetwork);
        };
        this.getCaipNetwork = ()=>(0, $j0fVO.NetworkController).state.caipNetwork;
        this.setRequestedCaipNetworks = (requestedCaipNetworks)=>{
            (0, $j0fVO.NetworkController).setRequestedCaipNetworks(requestedCaipNetworks);
        };
        this.getApprovedCaipNetworksData = ()=>(0, $j0fVO.NetworkController).getApprovedCaipNetworksData();
        this.resetNetwork = ()=>{
            (0, $j0fVO.NetworkController).resetNetwork();
        };
        this.setConnectors = (connectors)=>{
            (0, $8L7Gu.ConnectorController).setConnectors(connectors);
        };
        this.addConnector = (connector)=>{
            (0, $8L7Gu.ConnectorController).addConnector(connector);
        };
        this.getConnectors = ()=>(0, $8L7Gu.ConnectorController).getConnectors();
        this.resetWcConnection = ()=>{
            (0, $58zho.ConnectionController).resetWcConnection();
        };
        this.fetchIdentity = (request)=>(0, $cHcnO.BlockchainApiController).fetchIdentity(request);
        this.setAddressExplorerUrl = (addressExplorerUrl)=>{
            (0, $aoKpV.AccountController).setAddressExplorerUrl(addressExplorerUrl);
        };
        this.setSIWENonce = (nonce)=>{
            (0, $afSSl.SIWEController).setNonce(nonce);
        };
        this.setSIWESession = (session)=>{
            (0, $afSSl.SIWEController).setSession(session);
        };
        this.setSIWEStatus = (status)=>{
            (0, $afSSl.SIWEController).setStatus(status);
        };
        this.setSIWEMessage = (message)=>{
            (0, $afSSl.SIWEController).setMessage(message);
        };
        this.initControllers(options);
        this.initOrContinue();
    }
    async open(options) {
        await this.initOrContinue();
        (0, $6CqNZ.ModalController).open(options);
    }
    async close() {
        await this.initOrContinue();
        (0, $6CqNZ.ModalController).close();
    }
    setLoading(loading) {
        (0, $6CqNZ.ModalController).setLoading(loading);
    }
    getThemeMode() {
        return (0, $eMTTW.ThemeController).state.themeMode;
    }
    getThemeVariables() {
        return (0, $eMTTW.ThemeController).state.themeVariables;
    }
    setThemeMode(themeMode) {
        (0, $eMTTW.ThemeController).setThemeMode(themeMode);
        (0, $hCS0p.setColorTheme)((0, $eMTTW.ThemeController).state.themeMode);
        try {
            const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeMode: (0, $eMTTW.ThemeController).getSnapshot().themeMode
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    }
    setThemeVariables(themeVariables) {
        (0, $eMTTW.ThemeController).setThemeVariables(themeVariables);
        (0, $hCS0p.setThemeVariables)((0, $eMTTW.ThemeController).state.themeVariables);
        try {
            const emailConnector = (0, $8L7Gu.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeVariables: (0, $eMTTW.ThemeController).getSnapshot().themeVariables
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    }
    subscribeTheme(callback) {
        return (0, $eMTTW.ThemeController).subscribe(callback);
    }
    getState() {
        return {
            ...(0, $dTOcV.PublicStateController).state
        };
    }
    subscribeState(callback) {
        return (0, $dTOcV.PublicStateController).subscribe(callback);
    }
    getEvent() {
        return {
            ...(0, $bE42d.EventsController).state
        };
    }
    subscribeEvents(callback) {
        return (0, $bE42d.EventsController).subscribe(callback);
    }
    subscribeSIWEState(callback) {
        return (0, $afSSl.SIWEController).subscribe(callback);
    }
    initControllers(options) {
        (0, $j0fVO.NetworkController).setClient(options.networkControllerClient);
        (0, $j0fVO.NetworkController).setDefaultCaipNetwork(options.defaultChain);
        (0, $3pfUo.OptionsController).setProjectId(options.projectId);
        (0, $3pfUo.OptionsController).setIncludeWalletIds(options.includeWalletIds);
        (0, $3pfUo.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
        (0, $3pfUo.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
        (0, $3pfUo.OptionsController).setTokens(options.tokens);
        (0, $3pfUo.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
        (0, $3pfUo.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
        (0, $3pfUo.OptionsController).setCustomWallets(options.customWallets);
        (0, $3pfUo.OptionsController).setEnableAnalytics(options.enableAnalytics);
        (0, $3pfUo.OptionsController).setSdkVersion(options._sdkVersion);
        (0, $58zho.ConnectionController).setClient(options.connectionControllerClient);
        if (options.siweControllerClient) {
            const siweClient = options.siweControllerClient;
            (0, $afSSl.SIWEController).setSIWEClient(siweClient);
        }
        if (options.metadata) (0, $3pfUo.OptionsController).setMetadata(options.metadata);
        if (options.themeMode) (0, $eMTTW.ThemeController).setThemeMode(options.themeMode);
        if (options.themeVariables) (0, $eMTTW.ThemeController).setThemeVariables(options.themeVariables);
    }
    async initOrContinue() {
        if (!this.initPromise && !$2747719ce9417d74$var$isInitialized && (0, $bYnq1.CoreHelperUtil).isClient()) {
            $2747719ce9417d74$var$isInitialized = true;
            this.initPromise = new Promise(async (resolve)=>{
                await Promise.all([
                    Promise.resolve((parcelRequire("bG7tm"))),
                    Promise.resolve((parcelRequire("8WgY8")))
                ]);
                const modal = document.createElement("w3m-modal");
                document.body.insertAdjacentElement("beforeend", modal);
                resolve();
            });
        }
        return this.initPromise;
    }
}


parcelRequire("k1l85");
var $bYnq1 = parcelRequire("bYnq1");


const $0379de9a4f8b4b81$export$aafe1f751f1bc52a = {
    WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
    INJECTED_CONNECTOR_ID: "injected",
    COINBASE_CONNECTOR_ID: "coinbaseWallet",
    SAFE_CONNECTOR_ID: "safe",
    LEDGER_CONNECTOR_ID: "ledger",
    EIP6963_CONNECTOR_ID: "eip6963",
    EMAIL_CONNECTOR_ID: "w3mEmail",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    VERSION: "3.5.7"
};



const $b1cc80ce6ca1d222$export$fd35d6514357600 = {
    ConnectorExplorerIds: {
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"
    },
    EIP155NetworkImageIds: {
        1: "692ed6ba-e569-459a-556a-776476829e00",
        42161: "600a9a04-c1b9-42ca-6785-9b4b6ff85200",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100"
    },
    ConnectorImageIds: {
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "461db637-8616-43ce-035a-d89b8a1d5800",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
    },
    ConnectorNamesMap: {
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "Browser Wallet",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WalletConnect",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "Coinbase",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "Ledger",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "Safe"
    },
    ConnectorTypesMap: {
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "INJECTED",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WALLET_CONNECT",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID]: "ANNOUNCED",
        [(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID]: "EMAIL"
    },
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};



const $7e0ecfd72436d7a9$export$518f198897991e39 = {
    caipNetworkIdToNumber (caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    getCaipTokens (tokens) {
        if (!tokens) return undefined;
        const caipTokens = {};
        Object.entries(tokens).forEach(([id, token])=>{
            caipTokens[`${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${id}`] = token;
        });
        return caipTokens;
    }
};





function $66287b5ebbf5bda1$export$1ee567fcdafbf4d8(chain) {
    if (!chain) return undefined;
    return {
        id: `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
        name: chain.name,
        imageId: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).EIP155NetworkImageIds[chain.id]
    };
}


const $c302cbda58930b42$export$327df3377a47c9e2 = "wagmi.wallet";


class $2ea12c1f81efc812$export$c03599cd5308d12b extends (0, $2747719ce9417d74$export$14b4aa396d4aed9a) {
    constructor(options){
        const { wagmiConfig: wagmiConfig, siweConfig: siweConfig, chains: chains, defaultChain: defaultChain, tokens: tokens, _sdkVersion: _sdkVersion, ...w3mOptions } = options;
        if (!wagmiConfig) throw new Error("web3modal:constructor - wagmiConfig is undefined");
        if (!w3mOptions.projectId) throw new Error("web3modal:constructor - projectId is undefined");
        const networkControllerClient = {
            switchCaipNetwork: async (caipNetwork)=>{
                const chainId = (0, $7e0ecfd72436d7a9$export$518f198897991e39).caipNetworkIdToNumber(caipNetwork?.id);
                if (chainId) await (0, $gsd36.switchNetwork)({
                    chainId: chainId
                });
            },
            async getApprovedCaipNetworksData () {
                const walletChoice = localStorage.getItem((0, $c302cbda58930b42$export$327df3377a47c9e2));
                if (walletChoice?.includes((0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID)) return {
                    supportsAllNetworks: false,
                    approvedCaipNetworkIds: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).WalletConnectRpcChainIds.map((id)=>`${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${id}`)
                };
                else if (walletChoice?.includes((0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID)) {
                    const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
                    const provider = await connector.getProvider();
                    const ns = provider.signer?.session?.namespaces;
                    const nsMethods = ns?.[(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155]?.methods;
                    const nsChains = ns?.[(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155]?.chains;
                    return {
                        supportsAllNetworks: nsMethods?.includes((0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).ADD_CHAIN_METHOD),
                        approvedCaipNetworkIds: nsChains
                    };
                }
                return {
                    approvedCaipNetworkIds: undefined,
                    supportsAllNetworks: true
                };
            }
        };
        const connectionControllerClient = {
            connectWalletConnect: async (onUri)=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                if (!connector) throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
                connector.on("message", (event)=>{
                    if (event.type === "display_uri") {
                        onUri(event.data);
                        connector.removeAllListeners();
                    }
                });
                const chainId = (0, $7e0ecfd72436d7a9$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $gsd36.connect)({
                    connector: connector,
                    chainId: chainId
                });
            },
            connectExternal: async ({ id: id, provider: provider, info: info })=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === id);
                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                if (provider && info && connector.id === (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID) connector.setEip6963Wallet?.({
                    provider: provider,
                    info: info
                });
                const chainId = (0, $7e0ecfd72436d7a9$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $gsd36.connect)({
                    connector: connector,
                    chainId: chainId
                });
            },
            checkInstalled: (ids)=>{
                const eip6963Connectors = this.getConnectors().filter((c)=>c.type === "ANNOUNCED");
                const injectedConnector = this.getConnectors().find((c)=>c.type === "INJECTED");
                if (!ids) return Boolean(window.ethereum);
                if (eip6963Connectors.length) {
                    const installed = ids.some((id)=>eip6963Connectors.some((c)=>c.info?.rdns === id));
                    if (installed) return true;
                }
                if (injectedConnector) {
                    if (!window?.ethereum) return false;
                    return ids.some((id)=>Boolean(window.ethereum?.[String(id)]));
                }
                return false;
            },
            disconnect: async ()=>{
                await (0, $gsd36.disconnect)();
                if (siweConfig?.options?.signOutOnDisconnect) await siweConfig.signOut();
            },
            signMessage: async (message)=>(0, $gsd36.signMessage)({
                    message: message
                })
        };
        super({
            networkControllerClient: networkControllerClient,
            connectionControllerClient: connectionControllerClient,
            siweControllerClient: siweConfig,
            defaultChain: (0, $66287b5ebbf5bda1$export$1ee567fcdafbf4d8)(defaultChain),
            tokens: (0, $7e0ecfd72436d7a9$export$518f198897991e39).getCaipTokens(tokens),
            _sdkVersion: _sdkVersion ?? `html-wagmi-${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).VERSION}`,
            ...w3mOptions
        });
        this.hasSyncedConnectedAccount = false;
        this.options = undefined;
        this.options = options;
        this.syncRequestedNetworks(chains);
        this.syncConnectors(wagmiConfig);
        this.syncEmailConnector(wagmiConfig);
        this.listenEIP6963Connector(wagmiConfig);
        this.listenEmailConnector(wagmiConfig);
        (0, $gsd36.watchAccount)(()=>this.syncAccount());
        (0, $gsd36.watchNetwork)(()=>this.syncNetwork());
    }
    getState() {
        const state = super.getState();
        return {
            ...state,
            selectedNetworkId: (0, $7e0ecfd72436d7a9$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
        };
    }
    subscribeState(callback) {
        return super.subscribeState((state)=>callback({
                ...state,
                selectedNetworkId: (0, $7e0ecfd72436d7a9$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
            }));
    }
    syncRequestedNetworks(chains) {
        const requestedCaipNetworks = chains?.map((chain)=>({
                id: `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
                name: chain.name,
                imageId: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                imageUrl: this.options?.chainImages?.[chain.id]
            }));
        this.setRequestedCaipNetworks(requestedCaipNetworks ?? []);
    }
    async syncAccount() {
        const { address: address, isConnected: isConnected } = (0, $gsd36.getAccount)();
        const { chain: chain } = (0, $gsd36.getNetwork)();
        this.resetAccount();
        if (isConnected && address && chain) {
            const caipAddress = `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}:${address}`;
            this.setIsConnected(isConnected);
            this.setCaipAddress(caipAddress);
            await Promise.all([
                this.syncProfile(address, chain),
                this.syncBalance(address, chain),
                this.getApprovedCaipNetworksData()
            ]);
            this.hasSyncedConnectedAccount = true;
        } else if (!isConnected && this.hasSyncedConnectedAccount) {
            this.resetWcConnection();
            this.resetNetwork();
        }
    }
    async syncNetwork() {
        const { address: address, isConnected: isConnected } = (0, $gsd36.getAccount)();
        const { chain: chain } = (0, $gsd36.getNetwork)();
        if (chain) {
            const chainId = String(chain.id);
            const caipChainId = `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chainId}`;
            this.setCaipNetwork({
                id: caipChainId,
                name: chain.name,
                imageId: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                imageUrl: this.options?.chainImages?.[chain.id]
            });
            if (isConnected && address) {
                const caipAddress = `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}:${address}`;
                this.setCaipAddress(caipAddress);
                if (chain.blockExplorers?.default?.url) {
                    const url = `${chain.blockExplorers.default.url}/address/${address}`;
                    this.setAddressExplorerUrl(url);
                } else this.setAddressExplorerUrl(undefined);
                if (this.hasSyncedConnectedAccount) {
                    await this.syncProfile(address, chain);
                    await this.syncBalance(address, chain);
                }
            }
        }
    }
    async syncProfile(address, chain) {
        if (chain.id !== (0, $kqytL.mainnet).id) {
            this.setProfileName(null);
            this.setProfileImage(null);
            return;
        }
        try {
            const { name: name, avatar: avatar } = await this.fetchIdentity({
                caipChainId: `${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
                address: address
            });
            this.setProfileName(name);
            this.setProfileImage(avatar);
        } catch  {
            const profileName = await (0, $gsd36.fetchEnsName)({
                address: address,
                chainId: chain.id
            });
            if (profileName) {
                this.setProfileName(profileName);
                const profileImage = await (0, $gsd36.fetchEnsAvatar)({
                    name: profileName,
                    chainId: chain.id
                });
                if (profileImage) this.setProfileImage(profileImage);
            }
        }
    }
    async syncBalance(address, chain) {
        const balance = await (0, $gsd36.fetchBalance)({
            address: address,
            chainId: chain.id,
            token: this.options?.tokens?.[chain.id]?.address
        });
        this.setBalance(balance.formatted, balance.symbol);
    }
    syncConnectors(wagmiConfig) {
        const w3mConnectors = [];
        wagmiConfig.connectors.forEach(({ id: id, name: name })=>{
            if (![
                (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID,
                (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID
            ].includes(id)) w3mConnectors.push({
                id: id,
                explorerId: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).ConnectorExplorerIds[id],
                imageId: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).ConnectorImageIds[id],
                imageUrl: this.options?.connectorImages?.[id],
                name: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).ConnectorNamesMap[id] ?? name,
                type: (0, $b1cc80ce6ca1d222$export$fd35d6514357600).ConnectorTypesMap[id] ?? "EXTERNAL"
            });
        });
        this.setConnectors(w3mConnectors);
    }
    async syncEmailConnector(wagmiConfig) {
        const emailConnector = wagmiConfig.connectors.find(({ id: id })=>id === "w3mEmail");
        if (emailConnector) {
            const provider = await emailConnector.getProvider();
            this.addConnector({
                id: (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID,
                type: "EMAIL",
                name: "Email",
                provider: provider
            });
        }
    }
    eip6963EventHandler(connector, event) {
        if (event.detail) {
            const { info: info, provider: provider } = event.detail;
            const connectors = this.getConnectors();
            const existingConnector = connectors.find((c)=>c.name === info.name);
            if (!existingConnector) {
                this.addConnector({
                    id: (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID,
                    type: "ANNOUNCED",
                    imageUrl: info.icon ?? this.options?.connectorImages?.[(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID],
                    name: info.name,
                    provider: provider,
                    info: info
                });
                connector.isAuthorized({
                    info: info,
                    provider: provider
                });
            }
        }
    }
    listenEIP6963Connector(wagmiConfig) {
        const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID);
        if (typeof window !== "undefined" && connector) {
            const handler = this.eip6963EventHandler.bind(this, connector);
            window.addEventListener((0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_ANNOUNCE_EVENT, handler);
            window.dispatchEvent(new Event((0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP6963_REQUEST_EVENT));
        }
    }
    async listenEmailConnector(wagmiConfig) {
        const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID);
        if (typeof window !== "undefined" && connector) {
            super.setLoading(true);
            const provider = await connector.getProvider();
            const isLoginEmailUsed = provider.getLoginEmailUsed();
            super.setLoading(isLoginEmailUsed);
            provider.onRpcRequest(()=>{
                super.open({
                    view: "ApproveTransaction"
                });
            });
            provider.onRpcResponse(()=>{
                super.close();
            });
            provider.onIsConnected(()=>{
                super.setLoading(false);
            });
        }
    }
}




var $baiWq = parcelRequire("baiWq");

var $kRozl = parcelRequire("kRozl");
var $7925b3f1a325544b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7925b3f1a325544b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7925b3f1a325544b$var$_EIP6963Connector_defaultProvider, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet;
const $7925b3f1a325544b$var$connectedRdnsKey = "connectedRdns";
class $7925b3f1a325544b$export$adfafaf458469701 extends (0, $baiWq.InjectedConnector) {
    constructor(config){
        super({
            chains: config.chains,
            options: {
                shimDisconnect: true
            }
        });
        this.id = "eip6963";
        this.name = "EIP6963";
        $7925b3f1a325544b$var$_EIP6963Connector_defaultProvider.set(this, undefined);
        $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet.set(this, undefined);
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) {
                this.storage?.removeItem($7925b3f1a325544b$var$connectedRdnsKey);
                this.emit("disconnect");
            } else if (accounts[0]) this.emit("change", {
                account: (0, $kRozl.getAddress)(accounts[0])
            });
        };
        $7925b3f1a325544b$var$__classPrivateFieldSet(this, $7925b3f1a325544b$var$_EIP6963Connector_defaultProvider, this.options.getProvider(), "f");
    }
    async connect(options) {
        const data = await super.connect(options);
        if ($7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f")) this.storage?.setItem($7925b3f1a325544b$var$connectedRdnsKey, $7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f").info.rdns);
        return data;
    }
    async disconnect() {
        await super.disconnect();
        this.storage?.removeItem($7925b3f1a325544b$var$connectedRdnsKey);
        $7925b3f1a325544b$var$__classPrivateFieldSet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, undefined, "f");
    }
    async isAuthorized(eip6963Wallet) {
        const connectedEIP6963Rdns = this.storage?.getItem($7925b3f1a325544b$var$connectedRdnsKey);
        if (connectedEIP6963Rdns) {
            if ($7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f") && connectedEIP6963Rdns === $7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f").info.rdns) {
                const provider = $7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f").provider;
                const accounts = await provider.request({
                    method: "eth_accounts"
                });
                if (accounts.length) return true;
            }
            if (eip6963Wallet) $7925b3f1a325544b$var$__classPrivateFieldSet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, eip6963Wallet, "f");
        }
        return super.isAuthorized();
    }
    async getProvider() {
        return Promise.resolve($7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, "f")?.provider ?? $7925b3f1a325544b$var$__classPrivateFieldGet(this, $7925b3f1a325544b$var$_EIP6963Connector_defaultProvider, "f"));
    }
    setEip6963Wallet(eip6963Wallet) {
        $7925b3f1a325544b$var$__classPrivateFieldSet(this, $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet, eip6963Wallet, "f");
    }
}
$7925b3f1a325544b$var$_EIP6963Connector_defaultProvider = new WeakMap(), $7925b3f1a325544b$var$_EIP6963Connector_eip6963Wallet = new WeakMap();



var $ltFnW = parcelRequire("ltFnW");


var $1mQc6 = parcelRequire("1mQc6");
var $dS1Df = parcelRequire("dS1Df");
var $9kZsO = parcelRequire("9kZsO");
class $243f185b6dc23029$export$608aee3998ddc79b extends (0, $ltFnW.Connector) {
    constructor(config){
        super(config);
        this.id = "w3mEmail";
        this.name = "Web3Modal Email";
        this.ready = true;
        this.provider = {};
        if (typeof window !== "undefined") this.provider = new (0, $7a7e5359f80f7e1f$export$112ca4a9acf9f612)(config.options.projectId);
    }
    async getProvider() {
        return Promise.resolve(this.provider);
    }
    async connect(options = {}) {
        const { address: address, chainId: chainId } = await this.provider.connect({
            chainId: options.chainId
        });
        return {
            account: address,
            chain: {
                id: chainId,
                unsupported: this.isChainUnsupported(1)
            }
        };
    }
    async switchChain(chainId) {
        try {
            const chain = this.chains.find((c)=>c.id === chainId);
            if (!chain) throw new (0, $1mQc6.SwitchChainError)(new Error("chain not found on connector."));
            await this.provider.switchNetwork(chainId);
            const unsupported = this.isChainUnsupported(chainId);
            this.emit("change", {
                chain: {
                    id: chainId,
                    unsupported: unsupported
                }
            });
            return chain;
        } catch (error) {
            if (error instanceof Error) throw new (0, $1mQc6.SwitchChainError)(error);
            throw error;
        }
    }
    async disconnect() {
        await this.provider.disconnect();
    }
    async getAccount() {
        const { address: address } = await this.provider.connect();
        return address;
    }
    async getChainId() {
        const { chainId: chainId } = await this.provider.getChainId();
        return chainId;
    }
    async getWalletClient() {
        const { address: address, chainId: chainId } = await this.provider.connect();
        return Promise.resolve((0, $dS1Df.createWalletClient)({
            account: address,
            chain: {
                id: chainId
            },
            transport: (0, $9kZsO.custom)(this.provider)
        }));
    }
    async isAuthorized() {
        const { isConnected: isConnected } = await this.provider.isConnected();
        return isConnected;
    }
    onAccountsChanged() {}
    onChainChanged() {}
    onDisconnect() {}
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3deb0861714e57d0$export$a143d493d941bafc;
var $3deb0861714e57d0$export$e4cf37d7f6fb9e0a;
var $3deb0861714e57d0$export$f99ded8fe4b79145;
var $3deb0861714e57d0$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $3deb0861714e57d0$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$3deb0861714e57d0$export$a143d493d941bafc = $3deb0861714e57d0$var$Buffer;
$3deb0861714e57d0$export$e4cf37d7f6fb9e0a = $3deb0861714e57d0$var$SlowBuffer;
$3deb0861714e57d0$export$f99ded8fe4b79145 = 50;
const $3deb0861714e57d0$var$K_MAX_LENGTH = 0x7fffffff;
$3deb0861714e57d0$export$599f31c3813fae4d = $3deb0861714e57d0$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3deb0861714e57d0$var$Buffer.TYPED_ARRAY_SUPPORT = $3deb0861714e57d0$var$typedArraySupport();
if (!$3deb0861714e57d0$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3deb0861714e57d0$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3deb0861714e57d0$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$3deb0861714e57d0$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3deb0861714e57d0$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$3deb0861714e57d0$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3deb0861714e57d0$var$createBuffer(length) {
    if (length > $3deb0861714e57d0$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3deb0861714e57d0$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3deb0861714e57d0$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3deb0861714e57d0$var$allocUnsafe(arg);
    }
    return $3deb0861714e57d0$var$from(arg, encodingOrOffset, length);
}
$3deb0861714e57d0$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3deb0861714e57d0$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $3deb0861714e57d0$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3deb0861714e57d0$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3deb0861714e57d0$var$isInstance(value, ArrayBuffer) || value && $3deb0861714e57d0$var$isInstance(value.buffer, ArrayBuffer)) return $3deb0861714e57d0$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($3deb0861714e57d0$var$isInstance(value, SharedArrayBuffer) || value && $3deb0861714e57d0$var$isInstance(value.buffer, SharedArrayBuffer))) return $3deb0861714e57d0$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3deb0861714e57d0$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3deb0861714e57d0$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $3deb0861714e57d0$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3deb0861714e57d0$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3deb0861714e57d0$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3deb0861714e57d0$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3deb0861714e57d0$var$Buffer, Uint8Array);
function $3deb0861714e57d0$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3deb0861714e57d0$var$alloc(size, fill, encoding) {
    $3deb0861714e57d0$var$assertSize(size);
    if (size <= 0) return $3deb0861714e57d0$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $3deb0861714e57d0$var$createBuffer(size).fill(fill, encoding) : $3deb0861714e57d0$var$createBuffer(size).fill(fill);
    return $3deb0861714e57d0$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3deb0861714e57d0$var$Buffer.alloc = function(size, fill, encoding) {
    return $3deb0861714e57d0$var$alloc(size, fill, encoding);
};
function $3deb0861714e57d0$var$allocUnsafe(size) {
    $3deb0861714e57d0$var$assertSize(size);
    return $3deb0861714e57d0$var$createBuffer(size < 0 ? 0 : $3deb0861714e57d0$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3deb0861714e57d0$var$Buffer.allocUnsafe = function(size) {
    return $3deb0861714e57d0$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3deb0861714e57d0$var$Buffer.allocUnsafeSlow = function(size) {
    return $3deb0861714e57d0$var$allocUnsafe(size);
};
function $3deb0861714e57d0$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$3deb0861714e57d0$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $3deb0861714e57d0$var$byteLength(string, encoding) | 0;
    let buf = $3deb0861714e57d0$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3deb0861714e57d0$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3deb0861714e57d0$var$checked(array.length) | 0;
    const buf = $3deb0861714e57d0$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3deb0861714e57d0$var$fromArrayView(arrayView) {
    if ($3deb0861714e57d0$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3deb0861714e57d0$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3deb0861714e57d0$var$fromArrayLike(arrayView);
}
function $3deb0861714e57d0$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3deb0861714e57d0$var$Buffer.prototype);
    return buf;
}
function $3deb0861714e57d0$var$fromObject(obj) {
    if ($3deb0861714e57d0$var$Buffer.isBuffer(obj)) {
        const len = $3deb0861714e57d0$var$checked(obj.length) | 0;
        const buf = $3deb0861714e57d0$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $3deb0861714e57d0$var$numberIsNaN(obj.length)) return $3deb0861714e57d0$var$createBuffer(0);
        return $3deb0861714e57d0$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $3deb0861714e57d0$var$fromArrayLike(obj.data);
}
function $3deb0861714e57d0$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3deb0861714e57d0$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3deb0861714e57d0$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $3deb0861714e57d0$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3deb0861714e57d0$var$Buffer.alloc(+length);
}
$3deb0861714e57d0$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3deb0861714e57d0$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3deb0861714e57d0$var$Buffer.compare = function compare(a, b) {
    if ($3deb0861714e57d0$var$isInstance(a, Uint8Array)) a = $3deb0861714e57d0$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3deb0861714e57d0$var$isInstance(b, Uint8Array)) b = $3deb0861714e57d0$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3deb0861714e57d0$var$Buffer.isBuffer(a) || !$3deb0861714e57d0$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3deb0861714e57d0$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$3deb0861714e57d0$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3deb0861714e57d0$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3deb0861714e57d0$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3deb0861714e57d0$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3deb0861714e57d0$var$Buffer.isBuffer(buf)) buf = $3deb0861714e57d0$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3deb0861714e57d0$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3deb0861714e57d0$var$byteLength(string, encoding) {
    if ($3deb0861714e57d0$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3deb0861714e57d0$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $3deb0861714e57d0$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $3deb0861714e57d0$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3deb0861714e57d0$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3deb0861714e57d0$var$Buffer.byteLength = $3deb0861714e57d0$var$byteLength;
function $3deb0861714e57d0$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $3deb0861714e57d0$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $3deb0861714e57d0$var$utf8Slice(this, start, end);
        case "ascii":
            return $3deb0861714e57d0$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $3deb0861714e57d0$var$latin1Slice(this, start, end);
        case "base64":
            return $3deb0861714e57d0$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3deb0861714e57d0$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3deb0861714e57d0$var$Buffer.prototype._isBuffer = true;
function $3deb0861714e57d0$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3deb0861714e57d0$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$3deb0861714e57d0$var$swap(this, i, i + 1);
    return this;
};
$3deb0861714e57d0$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $3deb0861714e57d0$var$swap(this, i, i + 3);
        $3deb0861714e57d0$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3deb0861714e57d0$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $3deb0861714e57d0$var$swap(this, i, i + 7);
        $3deb0861714e57d0$var$swap(this, i + 1, i + 6);
        $3deb0861714e57d0$var$swap(this, i + 2, i + 5);
        $3deb0861714e57d0$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3deb0861714e57d0$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $3deb0861714e57d0$var$utf8Slice(this, 0, length);
    return $3deb0861714e57d0$var$slowToString.apply(this, arguments);
};
$3deb0861714e57d0$var$Buffer.prototype.toLocaleString = $3deb0861714e57d0$var$Buffer.prototype.toString;
$3deb0861714e57d0$var$Buffer.prototype.equals = function equals(b) {
    if (!$3deb0861714e57d0$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $3deb0861714e57d0$var$Buffer.compare(this, b) === 0;
};
$3deb0861714e57d0$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $3deb0861714e57d0$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($3deb0861714e57d0$var$customInspectSymbol) $3deb0861714e57d0$var$Buffer.prototype[$3deb0861714e57d0$var$customInspectSymbol] = $3deb0861714e57d0$var$Buffer.prototype.inspect;
$3deb0861714e57d0$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3deb0861714e57d0$var$isInstance(target, Uint8Array)) target = $3deb0861714e57d0$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3deb0861714e57d0$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3deb0861714e57d0$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3deb0861714e57d0$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $3deb0861714e57d0$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3deb0861714e57d0$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3deb0861714e57d0$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3deb0861714e57d0$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $3deb0861714e57d0$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3deb0861714e57d0$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3deb0861714e57d0$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3deb0861714e57d0$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3deb0861714e57d0$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3deb0861714e57d0$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3deb0861714e57d0$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3deb0861714e57d0$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3deb0861714e57d0$var$utf8Write(buf, string, offset, length) {
    return $3deb0861714e57d0$var$blitBuffer($3deb0861714e57d0$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3deb0861714e57d0$var$asciiWrite(buf, string, offset, length) {
    return $3deb0861714e57d0$var$blitBuffer($3deb0861714e57d0$var$asciiToBytes(string), buf, offset, length);
}
function $3deb0861714e57d0$var$base64Write(buf, string, offset, length) {
    return $3deb0861714e57d0$var$blitBuffer($3deb0861714e57d0$var$base64ToBytes(string), buf, offset, length);
}
function $3deb0861714e57d0$var$ucs2Write(buf, string, offset, length) {
    return $3deb0861714e57d0$var$blitBuffer($3deb0861714e57d0$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3deb0861714e57d0$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $3deb0861714e57d0$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $3deb0861714e57d0$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $3deb0861714e57d0$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $3deb0861714e57d0$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3deb0861714e57d0$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3deb0861714e57d0$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3deb0861714e57d0$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $3deb0861714e57d0$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3deb0861714e57d0$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3deb0861714e57d0$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3deb0861714e57d0$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3deb0861714e57d0$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3deb0861714e57d0$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3deb0861714e57d0$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3deb0861714e57d0$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3deb0861714e57d0$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $3deb0861714e57d0$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3deb0861714e57d0$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3deb0861714e57d0$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3deb0861714e57d0$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3deb0861714e57d0$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$3deb0861714e57d0$var$Buffer.prototype.readUintLE = $3deb0861714e57d0$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3deb0861714e57d0$var$Buffer.prototype.readUintBE = $3deb0861714e57d0$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3deb0861714e57d0$var$Buffer.prototype.readUint8 = $3deb0861714e57d0$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3deb0861714e57d0$var$Buffer.prototype.readUint16LE = $3deb0861714e57d0$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3deb0861714e57d0$var$Buffer.prototype.readUint16BE = $3deb0861714e57d0$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3deb0861714e57d0$var$Buffer.prototype.readUint32LE = $3deb0861714e57d0$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3deb0861714e57d0$var$Buffer.prototype.readUint32BE = $3deb0861714e57d0$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3deb0861714e57d0$var$Buffer.prototype.readBigUInt64LE = $3deb0861714e57d0$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3deb0861714e57d0$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3deb0861714e57d0$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3deb0861714e57d0$var$Buffer.prototype.readBigUInt64BE = $3deb0861714e57d0$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3deb0861714e57d0$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3deb0861714e57d0$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3deb0861714e57d0$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3deb0861714e57d0$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3deb0861714e57d0$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3deb0861714e57d0$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3deb0861714e57d0$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3deb0861714e57d0$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3deb0861714e57d0$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3deb0861714e57d0$var$Buffer.prototype.readBigInt64LE = $3deb0861714e57d0$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3deb0861714e57d0$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3deb0861714e57d0$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3deb0861714e57d0$var$Buffer.prototype.readBigInt64BE = $3deb0861714e57d0$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3deb0861714e57d0$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3deb0861714e57d0$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3deb0861714e57d0$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$3deb0861714e57d0$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$3deb0861714e57d0$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$3deb0861714e57d0$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $3deb0861714e57d0$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3deb0861714e57d0$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$3deb0861714e57d0$var$Buffer.prototype.writeUintLE = $3deb0861714e57d0$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3deb0861714e57d0$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUintBE = $3deb0861714e57d0$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3deb0861714e57d0$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUint8 = $3deb0861714e57d0$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUint16LE = $3deb0861714e57d0$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUint16BE = $3deb0861714e57d0$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUint32LE = $3deb0861714e57d0$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3deb0861714e57d0$var$Buffer.prototype.writeUint32BE = $3deb0861714e57d0$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3deb0861714e57d0$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3deb0861714e57d0$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3deb0861714e57d0$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3deb0861714e57d0$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3deb0861714e57d0$var$Buffer.prototype.writeBigUInt64LE = $3deb0861714e57d0$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3deb0861714e57d0$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3deb0861714e57d0$var$Buffer.prototype.writeBigUInt64BE = $3deb0861714e57d0$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3deb0861714e57d0$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3deb0861714e57d0$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3deb0861714e57d0$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3deb0861714e57d0$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3deb0861714e57d0$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3deb0861714e57d0$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3deb0861714e57d0$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3deb0861714e57d0$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3deb0861714e57d0$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3deb0861714e57d0$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3deb0861714e57d0$var$Buffer.prototype.writeBigInt64LE = $3deb0861714e57d0$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3deb0861714e57d0$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$3deb0861714e57d0$var$Buffer.prototype.writeBigInt64BE = $3deb0861714e57d0$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3deb0861714e57d0$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $3deb0861714e57d0$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $3deb0861714e57d0$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3deb0861714e57d0$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3deb0861714e57d0$var$writeFloat(this, value, offset, true, noAssert);
};
$3deb0861714e57d0$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3deb0861714e57d0$var$writeFloat(this, value, offset, false, noAssert);
};
function $3deb0861714e57d0$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3deb0861714e57d0$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3deb0861714e57d0$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3deb0861714e57d0$var$writeDouble(this, value, offset, true, noAssert);
};
$3deb0861714e57d0$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3deb0861714e57d0$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3deb0861714e57d0$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3deb0861714e57d0$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3deb0861714e57d0$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$3deb0861714e57d0$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3deb0861714e57d0$var$Buffer.isBuffer(val) ? val : $3deb0861714e57d0$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3deb0861714e57d0$var$errors = {};
function $3deb0861714e57d0$var$E(sym, getMessage, Base) {
    $3deb0861714e57d0$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3deb0861714e57d0$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$3deb0861714e57d0$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3deb0861714e57d0$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3deb0861714e57d0$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3deb0861714e57d0$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3deb0861714e57d0$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3deb0861714e57d0$var$checkBounds(buf, offset, byteLength) {
    $3deb0861714e57d0$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3deb0861714e57d0$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3deb0861714e57d0$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3deb0861714e57d0$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $3deb0861714e57d0$var$checkBounds(buf, offset, byteLength);
}
function $3deb0861714e57d0$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $3deb0861714e57d0$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $3deb0861714e57d0$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3deb0861714e57d0$var$validateNumber(value, type);
        throw new $3deb0861714e57d0$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $3deb0861714e57d0$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3deb0861714e57d0$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3deb0861714e57d0$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3deb0861714e57d0$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3deb0861714e57d0$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $3deb0861714e57d0$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $3deb0861714e57d0$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3deb0861714e57d0$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3deb0861714e57d0$var$base64ToBytes(str) {
    return $kuxul.toByteArray($3deb0861714e57d0$var$base64clean(str));
}
function $3deb0861714e57d0$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3deb0861714e57d0$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3deb0861714e57d0$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3deb0861714e57d0$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3deb0861714e57d0$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $3deb0861714e57d0$var$BufferBigIntNotDefined : fn;
}
function $3deb0861714e57d0$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


if (typeof window !== "undefined") {
    if (!window.Buffer) window.Buffer = (0, $3deb0861714e57d0$export$a143d493d941bafc);
    if (!window.global) window.global = window;
    if (!window.process) window.process = {};
    if (!window.process?.env) window.process = {
        env: {}
    };
}



var $gsd36 = parcelRequire("gsd36");

var $gAovx = parcelRequire("gAovx");

var $8oV45 = parcelRequire("8oV45");

var $ltFnW = parcelRequire("ltFnW");

var $kRozl = parcelRequire("kRozl");
var $1mQc6 = parcelRequire("1mQc6");
var $dS1Df = parcelRequire("dS1Df");
var $9kZsO = parcelRequire("9kZsO");
var $hKqyW = parcelRequire("hKqyW");
var $35e7346dc6e4ff86$var$_client, $35e7346dc6e4ff86$var$_provider;

var $35e7346dc6e4ff86$export$d82bc807cfb93fc1 = class extends (0, $ltFnW.Connector) {
    constructor({ chains: chains, options: options }){
        super({
            chains: chains,
            options: {
                reloadOnDisconnect: false,
                ...options
            }
        });
        this.id = "coinbaseWallet";
        this.name = "Coinbase Wallet";
        this.ready = true;
        (0, $ltFnW.__privateAdd)(this, $35e7346dc6e4ff86$var$_client, void 0);
        (0, $ltFnW.__privateAdd)(this, $35e7346dc6e4ff86$var$_provider, void 0);
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $kRozl.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = (0, $8oV45.normalizeChainId)(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = ()=>{
            this.emit("disconnect");
        };
    }
    async connect({ chainId: chainId } = {}) {
        try {
            const provider = await this.getProvider();
            provider.on("accountsChanged", this.onAccountsChanged);
            provider.on("chainChanged", this.onChainChanged);
            provider.on("disconnect", this.onDisconnect);
            this.emit("message", {
                type: "connecting"
            });
            const accounts = await provider.enable();
            const account = (0, $kRozl.getAddress)(accounts[0]);
            let id = await this.getChainId();
            let unsupported = this.isChainUnsupported(id);
            if (chainId && id !== chainId) {
                const chain = await this.switchChain(chainId);
                id = chain.id;
                unsupported = this.isChainUnsupported(id);
            }
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (/(user closed modal|accounts received is empty)/i.test(error.message)) throw new (0, $1mQc6.UserRejectedRequestError)(error);
            throw error;
        }
    }
    async disconnect() {
        if (!(0, $ltFnW.__privateGet)(this, $35e7346dc6e4ff86$var$_provider)) return;
        const provider = await this.getProvider();
        provider.removeListener("accountsChanged", this.onAccountsChanged);
        provider.removeListener("chainChanged", this.onChainChanged);
        provider.removeListener("disconnect", this.onDisconnect);
        provider.disconnect();
        provider.close();
    }
    async getAccount() {
        const provider = await this.getProvider();
        const accounts = await provider.request({
            method: "eth_accounts"
        });
        return (0, $kRozl.getAddress)(accounts[0]);
    }
    async getChainId() {
        const provider = await this.getProvider();
        const chainId = (0, $8oV45.normalizeChainId)(provider.chainId);
        return chainId;
    }
    async getProvider() {
        if (!(0, $ltFnW.__privateGet)(this, $35e7346dc6e4ff86$var$_provider)) {
            let CoinbaseWalletSDK = (await (parcelRequire("b2ObJ"))).default;
            if (typeof CoinbaseWalletSDK !== "function" && typeof CoinbaseWalletSDK.default === "function") CoinbaseWalletSDK = CoinbaseWalletSDK.default;
            (0, $ltFnW.__privateSet)(this, $35e7346dc6e4ff86$var$_client, new CoinbaseWalletSDK(this.options));
            class WalletProvider {
            }
            class Client {
            }
            const walletExtensionChainId = (0, $ltFnW.__privateGet)(this, $35e7346dc6e4ff86$var$_client).walletExtension?.getChainId();
            const chain = this.chains.find((chain2)=>this.options.chainId ? chain2.id === this.options.chainId : chain2.id === walletExtensionChainId) || this.chains[0];
            const chainId = this.options.chainId || chain?.id;
            const jsonRpcUrl = this.options.jsonRpcUrl || chain?.rpcUrls.default.http[0];
            (0, $ltFnW.__privateSet)(this, $35e7346dc6e4ff86$var$_provider, (0, $ltFnW.__privateGet)(this, $35e7346dc6e4ff86$var$_client).makeWeb3Provider(jsonRpcUrl, chainId));
        }
        return (0, $ltFnW.__privateGet)(this, $35e7346dc6e4ff86$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider(),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $dS1Df.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $9kZsO.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            const account = await this.getAccount();
            return !!account;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const provider = await this.getProvider();
        const id = (0, $hKqyW.numberToHex)(chainId);
        try {
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId: id
                    }
                ]
            });
            return this.chains.find((x)=>x.id === chainId) ?? {
                id: chainId,
                name: `Chain ${id}`,
                network: `${id}`,
                nativeCurrency: {
                    name: "Ether",
                    decimals: 18,
                    symbol: "ETH"
                },
                rpcUrls: {
                    default: {
                        http: [
                            ""
                        ]
                    },
                    public: {
                        http: [
                            ""
                        ]
                    }
                }
            };
        } catch (error) {
            const chain = this.chains.find((x)=>x.id === chainId);
            if (!chain) throw new (0, $gAovx.ChainNotConfiguredForConnectorError)({
                chainId: chainId,
                connectorId: this.id
            });
            if (error.code === 4902) try {
                await provider.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: id,
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                chain.rpcUrls.public?.http[0] ?? ""
                            ],
                            blockExplorerUrls: this.getBlockExplorerUrls(chain)
                        }
                    ]
                });
                return chain;
            } catch (error2) {
                throw new (0, $1mQc6.UserRejectedRequestError)(error2);
            }
            throw new (0, $1mQc6.SwitchChainError)(error);
        }
    }
    async watchAsset({ address: address, decimals: decimals = 18, image: image, symbol: symbol }) {
        const provider = await this.getProvider();
        return provider.request({
            method: "wallet_watchAsset",
            params: {
                type: "ERC20",
                options: {
                    address: address,
                    decimals: decimals,
                    image: image,
                    symbol: symbol
                }
            }
        });
    }
};
$35e7346dc6e4ff86$var$_client = new WeakMap();
$35e7346dc6e4ff86$var$_provider = new WeakMap();



var $baiWq = parcelRequire("baiWq");

var $ltFnW = parcelRequire("ltFnW");

var $eeGmU = parcelRequire("eeGmU");

var $kRozl = parcelRequire("kRozl");
var $1mQc6 = parcelRequire("1mQc6");
var $dS1Df = parcelRequire("dS1Df");
var $9kZsO = parcelRequire("9kZsO");
var $hKqyW = parcelRequire("hKqyW");
var $db3b6993d3538f49$var$NAMESPACE = "eip155";
var $db3b6993d3538f49$var$STORE_KEY = "store";
var $db3b6993d3538f49$var$REQUESTED_CHAINS_KEY = "requestedChains";
var $db3b6993d3538f49$var$ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain";
var $db3b6993d3538f49$var$_provider, $db3b6993d3538f49$var$_initProviderPromise, $db3b6993d3538f49$var$_createProvider, $db3b6993d3538f49$var$createProvider_fn, $db3b6993d3538f49$var$_initProvider, $db3b6993d3538f49$var$initProvider_fn, $db3b6993d3538f49$var$_isChainsStale, $db3b6993d3538f49$var$isChainsStale_fn, $db3b6993d3538f49$var$_setupListeners, $db3b6993d3538f49$var$setupListeners_fn, $db3b6993d3538f49$var$_removeListeners, $db3b6993d3538f49$var$removeListeners_fn, $db3b6993d3538f49$var$_setRequestedChainsIds, $db3b6993d3538f49$var$setRequestedChainsIds_fn, $db3b6993d3538f49$var$_getRequestedChainsIds, $db3b6993d3538f49$var$getRequestedChainsIds_fn, $db3b6993d3538f49$var$_getNamespaceChainsIds, $db3b6993d3538f49$var$getNamespaceChainsIds_fn, $db3b6993d3538f49$var$_getNamespaceMethods, $db3b6993d3538f49$var$getNamespaceMethods_fn;
var $db3b6993d3538f49$export$c456b2d327ac201f = class extends (0, $ltFnW.Connector) {
    constructor(config){
        super({
            ...config,
            options: {
                isNewChainsStale: true,
                ...config.options
            }
        });
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_createProvider);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_initProvider);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_isChainsStale);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_setupListeners);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_removeListeners);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_setRequestedChainsIds);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_getRequestedChainsIds);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_getNamespaceChainsIds);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_getNamespaceMethods);
        this.id = "walletConnect";
        this.name = "WalletConnect";
        this.ready = true;
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_provider, void 0);
        (0, $ltFnW.__privateAdd)(this, $db3b6993d3538f49$var$_initProviderPromise, void 0);
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $kRozl.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = Number(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = ()=>{
            (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_setRequestedChainsIds, $db3b6993d3538f49$var$setRequestedChainsIds_fn).call(this, []);
            this.emit("disconnect");
        };
        this.onDisplayUri = (uri)=>{
            this.emit("message", {
                type: "display_uri",
                data: uri
            });
        };
        this.onConnect = ()=>{
            this.emit("connect", {});
        };
        (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_createProvider, $db3b6993d3538f49$var$createProvider_fn).call(this);
    }
    async connect({ chainId: chainId, pairingTopic: pairingTopic } = {}) {
        try {
            let targetChainId = chainId;
            if (!targetChainId) {
                const store = this.storage?.getItem($db3b6993d3538f49$var$STORE_KEY);
                const lastUsedChainId = store?.state?.data?.chain?.id;
                if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId)) targetChainId = lastUsedChainId;
                else targetChainId = this.chains[0]?.id;
            }
            if (!targetChainId) throw new Error("No chains found on connector.");
            const provider = await this.getProvider();
            (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_setupListeners, $db3b6993d3538f49$var$setupListeners_fn).call(this);
            const isChainsStale = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_isChainsStale, $db3b6993d3538f49$var$isChainsStale_fn).call(this);
            if (provider.session && isChainsStale) await provider.disconnect();
            if (!provider.session || isChainsStale) {
                const optionalChains = this.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                this.emit("message", {
                    type: "connecting"
                });
                await provider.connect({
                    pairingTopic: pairingTopic,
                    optionalChains: [
                        targetChainId,
                        ...optionalChains
                    ]
                });
                (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_setRequestedChainsIds, $db3b6993d3538f49$var$setRequestedChainsIds_fn).call(this, this.chains.map(({ id: id2 })=>id2));
            }
            const accounts = await provider.enable();
            const account = (0, $kRozl.getAddress)(accounts[0]);
            const id = await this.getChainId();
            const unsupported = this.isChainUnsupported(id);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (/user rejected/i.test(error?.message)) throw new (0, $1mQc6.UserRejectedRequestError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        try {
            await provider.disconnect();
        } catch (error) {
            if (!/No matching key/i.test(error.message)) throw error;
        } finally{
            (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_removeListeners, $db3b6993d3538f49$var$removeListeners_fn).call(this);
            (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_setRequestedChainsIds, $db3b6993d3538f49$var$setRequestedChainsIds_fn).call(this, []);
        }
    }
    async getAccount() {
        const { accounts: accounts } = await this.getProvider();
        return (0, $kRozl.getAddress)(accounts[0]);
    }
    async getChainId() {
        const { chainId: chainId } = await this.getProvider();
        return chainId;
    }
    async getProvider({ chainId: chainId } = {}) {
        if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider)) await (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_createProvider, $db3b6993d3538f49$var$createProvider_fn).call(this);
        if (chainId) await this.switchChain(chainId);
        return (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider({
                chainId: chainId
            }),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $dS1Df.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $9kZsO.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            const [account, provider] = await Promise.all([
                this.getAccount(),
                this.getProvider()
            ]);
            const isChainsStale = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_isChainsStale, $db3b6993d3538f49$var$isChainsStale_fn).call(this);
            if (!account) return false;
            if (isChainsStale && provider.session) {
                try {
                    await provider.disconnect();
                } catch  {}
                return false;
            }
            return true;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const chain = this.chains.find((chain2)=>chain2.id === chainId);
        if (!chain) throw new (0, $1mQc6.SwitchChainError)(new Error("chain not found on connector."));
        try {
            const provider = await this.getProvider();
            const namespaceChains = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getNamespaceChainsIds, $db3b6993d3538f49$var$getNamespaceChainsIds_fn).call(this);
            const namespaceMethods = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getNamespaceMethods, $db3b6993d3538f49$var$getNamespaceMethods_fn).call(this);
            const isChainApproved = namespaceChains.includes(chainId);
            if (!isChainApproved && namespaceMethods.includes($db3b6993d3538f49$var$ADD_ETH_CHAIN_METHOD)) {
                await provider.request({
                    method: $db3b6993d3538f49$var$ADD_ETH_CHAIN_METHOD,
                    params: [
                        {
                            chainId: (0, $hKqyW.numberToHex)(chain.id),
                            blockExplorerUrls: [
                                chain.blockExplorers?.default?.url
                            ],
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                ...chain.rpcUrls.default.http
                            ]
                        }
                    ]
                });
                const requestedChains = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getRequestedChainsIds, $db3b6993d3538f49$var$getRequestedChainsIds_fn).call(this);
                requestedChains.push(chainId);
                (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_setRequestedChainsIds, $db3b6993d3538f49$var$setRequestedChainsIds_fn).call(this, requestedChains);
            }
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId: (0, $hKqyW.numberToHex)(chainId)
                    }
                ]
            });
            return chain;
        } catch (error) {
            const message = typeof error === "string" ? error : error?.message;
            if (/user rejected request/i.test(message)) throw new (0, $1mQc6.UserRejectedRequestError)(error);
            throw new (0, $1mQc6.SwitchChainError)(error);
        }
    }
};
$db3b6993d3538f49$var$_provider = new WeakMap();
$db3b6993d3538f49$var$_initProviderPromise = new WeakMap();
$db3b6993d3538f49$var$_createProvider = new WeakSet();
$db3b6993d3538f49$var$createProvider_fn = async function() {
    if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_initProviderPromise) && typeof window !== "undefined") (0, $ltFnW.__privateSet)(this, $db3b6993d3538f49$var$_initProviderPromise, (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_initProvider, $db3b6993d3538f49$var$initProvider_fn).call(this));
    return (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_initProviderPromise);
};
$db3b6993d3538f49$var$_initProvider = new WeakSet();

$db3b6993d3538f49$var$initProvider_fn = async function() {
    const { EthereumProvider: EthereumProvider } = await (parcelRequire("3pIh1"));
    const optionalChains = this.chains.map(({ id: id })=>id);
    if (optionalChains.length) {
        const { projectId: projectId, showQrModal: showQrModal = true, qrModalOptions: qrModalOptions, metadata: metadata, relayUrl: relayUrl } = this.options;
        (0, $ltFnW.__privateSet)(this, $db3b6993d3538f49$var$_provider, await EthereumProvider.init({
            showQrModal: showQrModal,
            qrModalOptions: qrModalOptions,
            projectId: projectId,
            optionalChains: optionalChains,
            rpcMap: Object.fromEntries(this.chains.map((chain)=>[
                    chain.id,
                    chain.rpcUrls.default.http[0]
                ])),
            metadata: metadata,
            relayUrl: relayUrl
        }));
    }
};
$db3b6993d3538f49$var$_isChainsStale = new WeakSet();
$db3b6993d3538f49$var$isChainsStale_fn = function() {
    const namespaceMethods = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getNamespaceMethods, $db3b6993d3538f49$var$getNamespaceMethods_fn).call(this);
    if (namespaceMethods.includes($db3b6993d3538f49$var$ADD_ETH_CHAIN_METHOD)) return false;
    if (!this.options.isNewChainsStale) return false;
    const requestedChains = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getRequestedChainsIds, $db3b6993d3538f49$var$getRequestedChainsIds_fn).call(this);
    const connectorChains = this.chains.map(({ id: id })=>id);
    const namespaceChains = (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_getNamespaceChainsIds, $db3b6993d3538f49$var$getNamespaceChainsIds_fn).call(this);
    if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
    return !connectorChains.every((id)=>requestedChains.includes(id));
};
$db3b6993d3538f49$var$_setupListeners = new WeakSet();
$db3b6993d3538f49$var$setupListeners_fn = function() {
    if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider)) return;
    (0, $ltFnW.__privateMethod)(this, $db3b6993d3538f49$var$_removeListeners, $db3b6993d3538f49$var$removeListeners_fn).call(this);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("accountsChanged", this.onAccountsChanged);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("chainChanged", this.onChainChanged);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("disconnect", this.onDisconnect);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("session_delete", this.onDisconnect);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("display_uri", this.onDisplayUri);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).on("connect", this.onConnect);
};
$db3b6993d3538f49$var$_removeListeners = new WeakSet();
$db3b6993d3538f49$var$removeListeners_fn = function() {
    if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider)) return;
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("accountsChanged", this.onAccountsChanged);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("chainChanged", this.onChainChanged);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("disconnect", this.onDisconnect);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("session_delete", this.onDisconnect);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("display_uri", this.onDisplayUri);
    (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).removeListener("connect", this.onConnect);
};
$db3b6993d3538f49$var$_setRequestedChainsIds = new WeakSet();
$db3b6993d3538f49$var$setRequestedChainsIds_fn = function(chains) {
    this.storage?.setItem($db3b6993d3538f49$var$REQUESTED_CHAINS_KEY, chains);
};
$db3b6993d3538f49$var$_getRequestedChainsIds = new WeakSet();
$db3b6993d3538f49$var$getRequestedChainsIds_fn = function() {
    return this.storage?.getItem($db3b6993d3538f49$var$REQUESTED_CHAINS_KEY) ?? [];
};
$db3b6993d3538f49$var$_getNamespaceChainsIds = new WeakSet();
$db3b6993d3538f49$var$getNamespaceChainsIds_fn = function() {
    if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider)) return [];
    const namespaces = (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $eeGmU.normalizeNamespaces)(namespaces);
    const chainIds = normalizedNamespaces[$db3b6993d3538f49$var$NAMESPACE]?.chains?.map((chain)=>parseInt(chain.split(":")[1] || ""));
    return chainIds ?? [];
};
$db3b6993d3538f49$var$_getNamespaceMethods = new WeakSet();
$db3b6993d3538f49$var$getNamespaceMethods_fn = function() {
    if (!(0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider)) return [];
    const namespaces = (0, $ltFnW.__privateGet)(this, $db3b6993d3538f49$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $eeGmU.normalizeNamespaces)(namespaces);
    const methods = normalizedNamespaces[$db3b6993d3538f49$var$NAMESPACE]?.methods;
    return methods ?? [];
};



// src/providers/public.ts
function $60b71444085d64fe$export$794750c0ec24158c() {
    return function(chain) {
        if (!chain.rpcUrls.public.http[0]) return null;
        return {
            chain: chain,
            rpcUrls: chain.rpcUrls.public
        };
    };
}





var $bYnq1 = parcelRequire("bYnq1");

const $f3a6c0d5cbb42699$var$RPC_URL = (0, $bYnq1.CoreHelperUtil).getBlockchainApiUrl();
function $f3a6c0d5cbb42699$export$27011b7b6b8fe48c({ projectId: projectId }) {
    return function provider(chain) {
        if (!(0, $b1cc80ce6ca1d222$export$fd35d6514357600).WalletConnectRpcChainIds.includes(chain.id)) return null;
        const baseHttpUrl = `${$f3a6c0d5cbb42699$var$RPC_URL}/v1/?chainId=${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).EIP155}:${chain.id}&projectId=${projectId}`;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            baseHttpUrl
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    baseHttpUrl
                ]
            }
        };
    };
}


function $a0b4fa608a01dc24$export$134240a34d71525e({ projectId: projectId, chains: chains, metadata: metadata, enableInjected: enableInjected, enableCoinbase: enableCoinbase, enableEIP6963: enableEIP6963, enableEmail: enableEmail, enableWalletConnect: enableWalletConnect }) {
    const { publicClient: publicClient } = (0, $gsd36.configureChains)(chains, [
        (0, $f3a6c0d5cbb42699$export$27011b7b6b8fe48c)({
            projectId: projectId
        }),
        (0, $60b71444085d64fe$export$794750c0ec24158c)()
    ]);
    const connectors = [];
    if (enableWalletConnect !== false) connectors.push(new (0, $db3b6993d3538f49$export$c456b2d327ac201f)({
        chains: chains,
        options: {
            projectId: projectId,
            showQrModal: false,
            metadata: metadata
        }
    }));
    if (enableInjected !== false) connectors.push(new (0, $baiWq.InjectedConnector)({
        chains: chains,
        options: {
            shimDisconnect: true
        }
    }));
    if (enableEIP6963 !== false) connectors.push(new (0, $7925b3f1a325544b$export$adfafaf458469701)({
        chains: chains
    }));
    if (enableCoinbase !== false) connectors.push(new (0, $35e7346dc6e4ff86$export$d82bc807cfb93fc1)({
        chains: chains,
        options: {
            appName: metadata?.name ?? "Unknown"
        }
    }));
    if (enableEmail === true) connectors.push(new (0, $243f185b6dc23029$export$608aee3998ddc79b)({
        chains: chains,
        options: {
            projectId: projectId
        }
    }));
    return (0, $gsd36.createConfig)({
        autoConnect: true,
        connectors: connectors,
        publicClient: publicClient
    });
}



function $650cd9e96eacfd95$export$14650d4efb17e382(options) {
    return new (0, $2ea12c1f81efc812$export$c03599cd5308d12b)({
        ...options,
        _sdkVersion: `html-wagmi-${(0, $0379de9a4f8b4b81$export$aafe1f751f1bc52a).VERSION}`
    });
}



var $gsd36 = parcelRequire("gsd36");
var $baiWq = parcelRequire("baiWq");


// src/providers/jsonRpc.ts
function $e6d9d21f7576bd03$export$2dc41f6df3d9d4cf({ rpc: rpc }) {
    return function(chain) {
        const rpcConfig = rpc(chain);
        if (!rpcConfig || rpcConfig.http === "") return null;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            rpcConfig.http
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    rpcConfig.http
                ],
                webSocket: rpcConfig.webSocket ? [
                    rpcConfig.webSocket
                ] : void 0
            }
        };
    };
}


const $74f1fbb162590643$var$A = "wallet_addEthereumChain";
class $74f1fbb162590643$export$de370d1517aed7bb {
    constructor(t, e){
        this.wagmi = {}, this.chains = [], this.namespace = "eip155", this.disconnect = (0, $gsd36.disconnect), this.getAccount = (0, $gsd36.getAccount), this.watchAccount = (0, $gsd36.watchAccount), this.fetchBalance = (0, $gsd36.fetchBalance), this.getNetwork = (0, $gsd36.getNetwork), this.watchNetwork = (0, $gsd36.watchNetwork), this.switchNetwork = (0, $gsd36.switchNetwork), this.fetchEnsName = (0, $gsd36.fetchEnsName), this.fetchEnsAvatar = (0, $gsd36.fetchEnsAvatar), this.wagmi = t, this.chains = e;
    }
    getWalletConnectConnector() {
        const t = this.wagmi.connectors.find((e)=>e.id === "walletConnect");
        if (!t) throw new Error("WalletConnectConnector is required");
        return t;
    }
    async connectWalletConnectProvider(t, e) {
        return await t.getProvider(), new Promise((n)=>{
            t.once("message", (o)=>{
                o.type === "display_uri" && (e(o.data), n());
            });
        });
    }
    getConnectorById(t) {
        const e = this.wagmi.connectors.find((n)=>n.id === t);
        if (!e) throw new Error(`Connector for id ${t} was not found`);
        return e;
    }
    getConnectors() {
        return this.wagmi.connectors.filter((t)=>!t.id.includes("walletConnect"));
    }
    async connectWalletConnect(t, e) {
        const n = this.getWalletConnectConnector(), o = {
            connector: n
        };
        return e && (o.chainId = e), Promise.all([
            (0, $gsd36.connect)(o),
            this.connectWalletConnectProvider(n, t)
        ]);
    }
    async connectConnector(t, e) {
        const n = {
            connector: this.getConnectorById(t)
        };
        return e && (n.chainId = e), await (0, $gsd36.connect)(n);
    }
    isInjectedProviderInstalled() {
        return typeof window.ethereum < "u";
    }
    safeCheckInjectedProvider(t) {
        var e;
        try {
            const n = String(t);
            return Boolean((e = window.ethereum) == null ? void 0 : e[n]);
        } catch (n) {
            return console.error(n), !1;
        }
    }
    async getConnectedChainIds() {
        var t, e, n;
        const o = (e = (t = (await this.getWalletConnectConnector().getProvider()).signer) == null ? void 0 : t.session) == null ? void 0 : e.namespaces, s = (n = o?.[this.namespace]) == null ? void 0 : n.methods;
        if (s != null && s.includes($74f1fbb162590643$var$A)) return "ALL";
        if (o) {
            const i = [];
            return Object.keys(o).forEach((r)=>{
                r.includes(this.namespace) && i.push(...o[r].accounts);
            }), i?.map((r)=>r.split(":")[1]);
        }
        return "ALL";
    }
}
const $74f1fbb162590643$var$P = "eip155", $74f1fbb162590643$var$y = "https://rpc.walletconnect.com";
function $74f1fbb162590643$export$c6fada22b311e8ce({ projectId: c }) {
    return (0, $e6d9d21f7576bd03$export$2dc41f6df3d9d4cf)({
        rpc: (t)=>{
            var e;
            return [
                1,
                3,
                4,
                5,
                10,
                42,
                56,
                69,
                97,
                100,
                137,
                280,
                324,
                420,
                42161,
                42220,
                43114,
                80001,
                421611,
                421613,
                1313161554,
                1313161555
            ].includes(t.id) ? {
                http: `${$74f1fbb162590643$var$y}/v1/?chainId=${$74f1fbb162590643$var$P}:${t.id}&projectId=${c}`
            } : {
                http: t.rpcUrls.default.http[0],
                webSocket: (e = t.rpcUrls.default.webSocket) == null ? void 0 : e[0]
            };
        }
    });
}
function $74f1fbb162590643$export$1fa55742dee269b2({ chains: c, projectId: t }) {
    return [
        new (0, $db3b6993d3538f49$export$c456b2d327ac201f)({
            chains: c,
            options: {
                projectId: t,
                showQrModal: !1
            }
        }),
        new (0, $baiWq.InjectedConnector)({
            chains: c,
            options: {
                shimDisconnect: !0
            }
        })
    ];
}



const $8f311ccd3269afe0$var$projectId = "a85cfb9ade7953280d3008188d57bd54";
// 2. Create wagmiConfig
const $8f311ccd3269afe0$var$chains = [
    (0, $kqytL.mainnet),
    (0, $7f8fe1466d7f4db8$export$625cf84d855940d4)
];
const $8f311ccd3269afe0$var$wagmiConfig = (0, $a0b4fa608a01dc24$export$134240a34d71525e)({
    chains: $8f311ccd3269afe0$var$chains,
    projectId: $8f311ccd3269afe0$var$projectId,
    metadata: {
        name: "Star Wolvez",
        description: "Star Wolvez is the future",
        url: (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().url
    }
});
const $8f311ccd3269afe0$var$ethereumClient = new (0, $74f1fbb162590643$export$de370d1517aed7bb)($8f311ccd3269afe0$var$wagmiConfig, $8f311ccd3269afe0$var$chains);
const $8f311ccd3269afe0$var$web3modal = (0, $650cd9e96eacfd95$export$14650d4efb17e382)({
    wagmiConfig: $8f311ccd3269afe0$var$wagmiConfig,
    projectId: $8f311ccd3269afe0$var$projectId,
    chains: $8f311ccd3269afe0$var$chains,
    themeMode: "light"
});
class $8f311ccd3269afe0$var$WalletConnectService {
    constructor(){
        this._walletAddress = "";
        if ($8f311ccd3269afe0$var$WalletConnectService._instance) throw new Error("Error: Instantiation failed: Use WalletConnectService.getInstance() instead of new.");
        $8f311ccd3269afe0$var$WalletConnectService._instance = this;
        this.events = new Phaser.Events.EventEmitter();
        $8f311ccd3269afe0$var$web3modal.subscribeState((state)=>{
            if (state.open == false) this.events.emit("walletconnect-closed");
        });
        // This captures when wallet connect successfully connects an account
        $8f311ccd3269afe0$var$web3modal.subscribeEvents((event)=>{
            if (event.data.type === "track" && event.data.event == "CONNECT_SUCCESS") {
                this.setWalletAddress($8f311ccd3269afe0$var$ethereumClient.getAccount().address);
                this.events.emit("wallet-connected");
            }
        });
    }
    static getInstance() {
        return $8f311ccd3269afe0$var$WalletConnectService._instance;
    }
    connectWallet() {
        if ($8f311ccd3269afe0$var$ethereumClient.getAccount().isConnected) {
            this.setWalletAddress($8f311ccd3269afe0$var$ethereumClient.getAccount().address);
            this.events.emit("wallet-connected");
        } else $8f311ccd3269afe0$var$web3modal.open();
    }
    onWalletConnected(cb, context) {
        this.events.on("wallet-connected", cb, context);
    }
    onWalletConnectClosed(cb, context) {
        this.events.on("walletconnect-closed", cb, context);
    }
    stopWalletConnectListener() {
        this.events.removeAllListeners();
    }
    setWalletAddress(value) {
        console.log("Wallet Address set! " + value);
        this._walletAddress = value;
    }
    getWalletAddress() {
        return this._walletAddress;
    }
    isEthAddress(address) {
        console.log(address);
        var isAddress = isAddress(address.toString());
        console.log(`isAddress: ${(0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(isAddress)}`);
        return isAddress;
    }
}
$8f311ccd3269afe0$var$WalletConnectService._instance = new $8f311ccd3269afe0$var$WalletConnectService();
var $8f311ccd3269afe0$export$2e2bcd8739ae039 = $8f311ccd3269afe0$var$WalletConnectService;


class $57b0159e0c142865$var$NFTService {
    constructor(){
        if ($57b0159e0c142865$var$NFTService._instance) throw new Error("Error: Instantiation failed: Use NFTService.getInstance() instead of new.");
        $57b0159e0c142865$var$NFTService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $57b0159e0c142865$var$NFTService._instance;
    }
    getNFTs(nftIds, collection_slugs, startIndex, numRequested) {
        return this.fetchNFTs(nftIds, collection_slugs, startIndex, numRequested);
    }
    fetchNFTs(nftIds, collection_slugs, startIndex, numRequested) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const queryParams = nftIds && nftIds.length > 0 ? [
            `ids=${nftIds.toString()}`
        ] : [];
        if (collection_slugs) queryParams.push(`collection_slug=${collection_slugs.toString()}`);
        if (startIndex !== undefined && startIndex !== null) queryParams.push(`start_index=${startIndex}`);
        if (numRequested !== undefined && numRequested !== null) queryParams.push(`count=${numRequested}`);
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("nfts", [
            wallet,
            this._config.api.endpoints.nfts.cache_route
        ], queryParams).then((res)=>{
            return this.enrichImageData(res);
        });
    }
    getNFTsFromMarketplace(nftIds, collection_slugs, startIndex, numRequested) {
        return this.fetchNFTsFromMarketplace(nftIds, collection_slugs, startIndex, numRequested);
    }
    fetchNFTsFromMarketplace(nftIds, collection_slugs, startIndex, numRequested) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const queryParams = nftIds && nftIds.length > 0 ? [
            `ids=${nftIds.toString()}`
        ] : [];
        if (collection_slugs) queryParams.push(`collection_slug=${collection_slugs.toString()}`);
        if (startIndex !== undefined && startIndex !== null) queryParams.push(`start_index=${startIndex}`);
        if (numRequested !== undefined && numRequested !== null) queryParams.push(`count=${numRequested}`);
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("nfts", [
            wallet,
            this._config.api.endpoints.nfts.refresh_route
        ], queryParams).then((res)=>{
            return this.enrichImageData(res);
        });
    }
    enrichImageData(data) {
        data.nfts = data.nfts.map((nft)=>{
            nft.image_key = `nft_${nft.id}`;
            return nft;
        });
        return data;
    }
}
$57b0159e0c142865$var$NFTService._instance = new $57b0159e0c142865$var$NFTService();
var $57b0159e0c142865$export$2e2bcd8739ae039 = $57b0159e0c142865$var$NFTService;






function $c802003ad057a939$export$96f2a8cb44ca447b(originScene, targetScene, data, unload = true) {
    if (unload) originScene.unloadAssets();
    originScene.scene.start(targetScene, data);
}


//const LoginAudio = require('url:../../../public/assets/audios/login-button.wav');
const $c9c77db60c0a7195$var$desktopHeight = 982;
const $c9c77db60c0a7195$var$desktopWidth = 1512;
const $c9c77db60c0a7195$var$mobileHeight = 932;
const $c9c77db60c0a7195$var$mobileWidth = 430;
class $c9c77db60c0a7195$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "LoginScene"
        });
        // UI
        this._isDesktop = true;
        this.walletConnectService = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance();
        this.nftService = (0, $57b0159e0c142865$export$2e2bcd8739ae039).getInstance();
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$c8d88f36354fa59f));
        //this.load.audio('login-button', LoginAudio);
        this.walletConnectService.onWalletConnected(this.handleWalletFound, this);
        this.walletConnectService.onWalletConnectClosed(this.handleWalletConnectClosed, this);
        if (!this.sys.game.device.os.desktop) this._isDesktop = false;
    }
    create() {
        this.createComponent(this._isDesktop);
    }
    createComponent(isDesktop) {
        if (isDesktop) {
            this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($c9c77db60c0a7195$var$desktopHeight, $c9c77db60c0a7195$var$desktopWidth, 1.3);
            this.createDesktop();
        } else {
            this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getMobileScale($c9c77db60c0a7195$var$mobileWidth, $c9c77db60c0a7195$var$mobileHeight);
            this.createMobile();
        }
    }
    createDesktop() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: this.applyScale($c9c77db60c0a7195$var$desktopWidth),
            height: this.applyScale($c9c77db60c0a7195$var$desktopHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Images
        var swLogo = this.add.image(0, 0, "login_sw_logo").setScale(this._scale);
        sizer.add(swLogo, {
            key: "login-logo",
            align: "left-top",
            offsetX: this.applyScale(210),
            offsetY: this.applyScale(115),
            expand: false
        });
        var sw_game = this.add.image(0, 0, "login_game_logo").setScale(this._scale);
        sizer.add(sw_game, {
            key: "login-game-logo",
            align: "left-top",
            offsetX: this.applyScale(464),
            offsetY: this.applyScale(233),
            expand: false
        });
        this._walletConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "connect_wallet_button", true, 1.05).setScale(this._scale);
        this._walletConnectButton.onClick().subscribe((pointer)=>{
            this._walletConnectButton.disableInteractive();
            this.input.setDefaultCursor("default");
            this.walletConnectService.connectWallet();
        });
        this.add.existing(this._walletConnectButton);
        sizer.add(this._walletConnectButton, {
            key: "wallet-button",
            align: "left-top",
            offsetX: this.applyScale(183),
            offsetY: this.applyScale(385),
            expand: false
        });
        var dividerLeft = this.add.image(0, 0, "login_divider").setScale(this._scale);
        sizer.add(dividerLeft, {
            key: "login-divider-left",
            align: "left-top",
            offsetX: this.applyScale(183),
            offsetY: this.applyScale(490),
            expand: false
        });
        var orImage = this.add.image(0, 0, "or_image").setScale(this._scale);
        sizer.add(orImage, {
            key: "login-or-image",
            align: "left-top",
            offsetX: this.applyScale(358),
            offsetY: this.applyScale(475),
            expand: false
        });
        var dividerRight = this.add.image(0, 0, "login_divider").setScale(this._scale);
        sizer.add(dividerRight, {
            key: "login-divider-right",
            align: "left-top",
            offsetX: this.applyScale(402),
            offsetY: this.applyScale(490),
            expand: false
        });
        this._googleConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "google_login_button", true, 1.05).setScale(this._scale);
        this._googleConnectButton.disableInteractive();
        this._googleConnectButton.onClick().subscribe((pointer)=>{});
        this.add.existing(this._googleConnectButton);
        sizer.add(this._googleConnectButton, {
            key: "google-button",
            align: "left-top",
            offsetX: this.applyScale(183),
            offsetY: this.applyScale(536),
            expand: false
        });
        this._appleConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "apple_login_button", true, 1.05).setScale(this._scale);
        this._appleConnectButton.onClick().subscribe((pointer)=>{});
        this._appleConnectButton.disableInteractive();
        this.add.existing(this._appleConnectButton);
        sizer.add(this._appleConnectButton, {
            key: "apple-button",
            align: "left-top",
            offsetX: this.applyScale(183),
            offsetY: this.applyScale(612),
            expand: false
        });
        var disclaimer = this.add.image(0, 0, "disclaimer_image").setScale(this._scale);
        sizer.add(disclaimer, {
            key: "login-disclaimer",
            align: "left-top",
            offsetX: this.applyScale(227),
            offsetY: this.applyScale(738),
            expand: false
        });
        var loginPoster = this.add.image(0, 0, this.randomizeLoginPoster()).setScale(this._scale);
        sizer.add(loginPoster, {
            key: "login-background",
            align: "left-top",
            offsetX: this.applyScale(746),
            offsetY: this.applyScale(10),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    createMobile() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: this.applyScale($c9c77db60c0a7195$var$mobileWidth),
            height: this.applyScale($c9c77db60c0a7195$var$mobileHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Images
        var swLogo = this.add.image(0, 0, "login_sw_logo_mobile").setScale(this._scale);
        sizer.add(swLogo, {
            key: "login-logo",
            align: "left-top",
            offsetX: this.applyScale(89),
            offsetY: this.applyScale(108),
            expand: false
        });
        var sw_game = this.add.image(0, 0, "login_game_logo").setScale(this._scale);
        sizer.add(sw_game, {
            key: "login-game-logo",
            align: "left-top",
            offsetX: this.applyScale(264),
            offsetY: this.applyScale(201),
            expand: false
        });
        this._walletConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "connect_wallet_button", true, 1.05).setScale(this._scale);
        this._walletConnectButton.onClick().subscribe((pointer)=>{
            this._walletConnectButton.disableInteractive();
            this.input.setDefaultCursor("default");
            this.walletConnectService.connectWallet();
        });
        this.add.existing(this._walletConnectButton);
        sizer.add(this._walletConnectButton, {
            key: "wallet-button",
            align: "left-top",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(390),
            expand: false
        });
        var dividerLeft = this.add.image(0, 0, "login_divider").setScale(this._scale);
        sizer.add(dividerLeft, {
            key: "login-divider-left",
            align: "left-top",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(495),
            expand: false
        });
        var orImage = this.add.image(0, 0, "or_image").setScale(this._scale);
        sizer.add(orImage, {
            key: "login-or-image",
            align: "left-top",
            offsetX: this.applyScale(193),
            offsetY: this.applyScale(475),
            expand: false
        });
        var dividerRight = this.add.image(0, 0, "login_divider").setScale(this._scale);
        sizer.add(dividerRight, {
            key: "login-divider-right",
            align: "left-top",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(495),
            expand: false
        });
        this._googleConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "google_login_button", true, 1.05).setScale(this._scale);
        this._googleConnectButton.disableInteractive();
        this._googleConnectButton.onClick().subscribe((pointer)=>{});
        this.add.existing(this._googleConnectButton);
        sizer.add(this._googleConnectButton, {
            key: "google-button",
            align: "left-top",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(541),
            expand: false
        });
        this._appleConnectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "apple_login_button", true, 1.05).setScale(this._scale);
        this._appleConnectButton.onClick().subscribe((pointer)=>{});
        this._appleConnectButton.disableInteractive();
        this.add.existing(this._appleConnectButton);
        sizer.add(this._appleConnectButton, {
            key: "apple-button",
            align: "left-top",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(617),
            expand: false
        });
        var disclaimer = this.add.image(0, 0, "disclaimer_image").setScale(this._scale);
        sizer.add(disclaimer, {
            key: "login-disclaimer",
            align: "left-top",
            offsetX: this.applyScale(65),
            offsetY: this.applyScale(743),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    randomizeLoginPoster() {
        var poster = "login_poster_";
        const randomDecimal = Math.random();
        const randomNumber = Math.floor(randomDecimal * 6) + 1;
        poster += "" + randomNumber;
        return poster;
    }
    applyScale(length) {
        return this._scale * length;
    }
    handleWalletFound() {
        (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().stopWalletConnectListener();
        //this.scene.scene.sound.play('login-button');
        (0, $c802003ad057a939$export$96f2a8cb44ca447b)(this, "LoadingScene");
    }
    handleWalletConnectClosed() {
        this._walletConnectButton.setInteractive();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$c8d88f36354fa59f)));
    }
}





class $bd40851b9a4501c3$var$UserService {
    constructor(){
        this._userData = [];
        this._userName = "";
        this._isNewUser = false;
        if ($bd40851b9a4501c3$var$UserService._instance) throw new Error("Error: Instantiation failed: Use UserService.getInstance() instead of new.");
        $bd40851b9a4501c3$var$UserService._instance = this;
        this._isWhitelisted = false;
    }
    static getInstance() {
        return $bd40851b9a4501c3$var$UserService._instance;
    }
    isWhitelisted() {
        return this._isWhitelisted;
    }
    getIsNewUser() {
        let returnValue = this._isNewUser;
        if (returnValue) this._isNewUser = false;
        return returnValue;
    }
    getUserName() {
        return this._userName;
    }
    setUserName(value) {
        this._userName = value;
    }
    setUserData(value) {
        this._userData = value;
    }
    getUserData(forceUpdate = false, override_wallet_address) {
        return new Promise((resolve, reject)=>{
            if (this._userData && !forceUpdate) return resolve(this._userData);
            else return resolve(this.fetchUserData(override_wallet_address));
        });
    }
    getUserDataSync() {
        return this._userData;
    }
    postUserData(name) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("user", [], {
            name: name,
            wallet: wallet
        }).then((res)=>{
            this._isNewUser = true;
            this._userData = res;
            return res;
        });
    }
    fetchUserData(override_wallet_address) {
        const wallet = override_wallet_address ? override_wallet_address : (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("user", [
            wallet
        ], []).then((res)=>{
            this._userData = res;
            this._userName = res.name;
            return res;
        });
    }
    recordLogin() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("login", [], {
            user_address: wallet
        }).then((res)=>{
            this._isWhitelisted = res.whitelisted;
            return res;
        });
    }
    handleDiscordConnectAction(pointer) {
    // TODO: Implement
    }
    getUserDataIdempotent() {
        return new Promise((resolve, reject)=>{
            return resolve(this.fetchUserDataIdempotent());
        });
    }
    fetchUserDataIdempotent() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("user", [
            wallet
        ], []).then((res)=>{
            return res;
        });
    }
}
$bd40851b9a4501c3$var$UserService._instance = new $bd40851b9a4501c3$var$UserService();
var $bd40851b9a4501c3$export$2e2bcd8739ae039 = $bd40851b9a4501c3$var$UserService;




class $9aa0e57a82cfa80e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "LoadingScene"
        });
    }
    preload() {
        const ignoreList = [
            "party_blob"
        ];
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480), ignoreList);
    }
    create() {
        this.createComponent();
        (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((userData)=>{
            if (userData && !userData.msg) // Get data and start dashboard
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().recordLogin().then((res)=>{
                if (res && res.success) this.scene.launch("HomebaseLoadingScene");
                else // Show a failed login screen
                this.scene.start("ErrorScene");
            });
            else this.scene.start("NameScene");
        }).catch((err)=>{
            // Something went wrong, prompt user to try again
            this.scene.start("ErrorScene");
        });
    }
    createComponent() {
        // Set Background
        //document.body.style.backgroundImage = "url('../assets/sw_bg.png')";
        document.body.style.backgroundRepeat = "repeat";
        document.body.style.backgroundSize = "auto";
        // this.cameras.main.fadeIn(500, 0, 0, 0);
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_bar");
        const text1 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "loading_text_1");
        const text2 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "loading_text_2");
        const text3 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "loading_text_3");
        const text4 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "loading_text_4");
        text2.alpha = 0;
        text3.alpha = 0;
        text4.alpha = 0;
        const prog1 = this.add.image(this.sys.canvas.width / 2 - 122, this.sys.canvas.height / 2 + 50, "loading_prog_1");
        const prog2 = this.add.image(this.sys.canvas.width / 2 - 73, this.sys.canvas.height / 2 + 50, "loading_prog_2");
        const prog3 = this.add.image(this.sys.canvas.width / 2 - 34, this.sys.canvas.height / 2 + 50, "loading_prog_3");
        const prog4 = this.add.image(this.sys.canvas.width / 2 - 13, this.sys.canvas.height / 2 + 50, "loading_prog_4");
        const prog5 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_5");
        prog1.alpha = 0;
        prog2.alpha = 0;
        prog3.alpha = 0;
        prog4.alpha = 0;
        prog5.alpha = 0;
        this.time.addEvent({
            delay: 250,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog1,
                    alpha: 1,
                    duration: 250,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: [
                        text1,
                        prog1
                    ],
                    alpha: 0,
                    duration: 500,
                    ease: "Power2"
                }, this);
                this.tweens.add({
                    targets: [
                        text2,
                        prog2
                    ],
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 1000,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: text2,
                    alpha: 0,
                    duration: 500,
                    ease: "Power2"
                }, this);
                this.tweens.add({
                    targets: [
                        text3,
                        prog3
                    ],
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 1500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: text3,
                    alpha: 0,
                    duration: 500,
                    ease: "Power2"
                }, this);
                this.tweens.add({
                    targets: [
                        text4,
                        prog4
                    ],
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 2000,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog5,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
    }
}






class $19aa4d69fb39075e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "NameScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480));
        this.load.html("name_form", "assets/nameForm.html");
    }
    create() {
        // background
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "name_rect");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "name_text");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 163, "name_btn_disabled");
        this.confirmButton = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 163, "name_btn_enabled").setInteractive();
        this.confirmButton.visible = false;
        this.confirmButton.input.enabled = false;
        this.input.on("gameobjectover", this.hoverHandler, this);
        this.input.on("gameobjectout", this.hoverOutHandler, this);
        this.input.on("gameobjectup", this.clickHandler, this);
        this.nameInput = this.add.dom(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 60).createFromCache("name_form");
        this.returnKey = this.input.keyboard.addKey((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Keyboard.KeyCodes.ENTER);
        this.returnKey.on("down", (event)=>{
            this.handleEnter();
        });
        this.input.keyboard.on("keydown", (event)=>{
            let name = this.nameInput.getChildByName("name");
            if (name.value != "" && name.value.length <= 16) {
                this.confirmButton.visible = true;
                this.confirmButton.input.enabled = true;
            } else {
                this.confirmButton.visible = false;
                this.confirmButton.input.enabled = false;
            }
        });
    }
    hoverHandler(pointer, button) {
        button.setScale(1.05);
    }
    hoverOutHandler(pointer, button) {
        button.setScale(1);
    }
    clickHandler(pointer, button) {
        this.handleEnter();
    }
    handleEnter() {
        let name = this.nameInput.getChildByName("name");
        this.confirmButton.visible = false;
        this.confirmButton.input.enabled = false;
        if (name.value != "" && name.value.length <= 16) (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().postUserData(name.value).then((userData)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().recordLogin().then((res)=>{
                if (res && res.success) this.scene.start("HomebaseLoadingScene");
                else // Show a failed login screen
                this.scene.start("LoginFailedScene");
            });
        });
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480)));
    }
}










const $52d44b882d399a3d$var$noMember = {
    id: 0,
    nft_collection: "Star Wolvez Generative",
    display_name: "None Selected       ",
    image_key: "starwolf_silhouette",
    image_thumbnail_url: "",
    show_yield: false,
    show_hp: false,
    disabled: true,
    hp: 900
};
class $52d44b882d399a3d$var$SquadService {
    constructor(){
        if ($52d44b882d399a3d$var$SquadService._instance) throw new Error("Error: Instantiation failed: Use SquadService.getInstance() instead of new.");
        $52d44b882d399a3d$var$SquadService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $52d44b882d399a3d$var$SquadService._instance;
    }
    setSquad(value) {
        this._squad = value;
    }
    setRandomSquad(value) {
        this._randomSquad = value;
    }
    getSquad(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._squad && !forceUpdate) return resolve(this._squad);
            else return resolve(this.fetchSquad());
        });
    }
    getSquadSync() {
        return this._squad;
    }
    fetchSquad() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("squad", [
            wallet,
            "mining"
        ], []).then((res)=>{
            return this.enrichSquadData(res.squad).then((enrichedSquad)=>{
                this._squad = enrichedSquad;
                this._traits = this.generateTraitsList(this._squad);
                return this._squad;
            });
        });
    }
    getSquadFromMarketplace() {
        return this.fetchSquadFromMarketplace();
    }
    fetchSquadFromMarketplace() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("squad", [
            wallet,
            "mining"
        ], []).then((res)=>{
            return this.enrichSquadDataFromMarketplace(res.squad).then((enrichedSquad)=>{
                this._squad = enrichedSquad;
                this._traits = this.generateTraitsList(this._squad);
                return this._squad;
            });
        });
    }
    getTraitsSync() {
        return this._traits;
    }
    enrichSquadData(squadData) {
        return (0, $57b0159e0c142865$export$2e2bcd8739ae039).getInstance().getNFTs(squadData.map((sm)=>sm.marketplace_nft_id)).then((res)=>{
            if (squadData && squadData.length > 0) {
                const enrichedSquad = squadData.map((squadMember)=>{
                    var nftData = res.nfts.find((nft)=>{
                        return nft.id === squadMember.marketplace_nft_id;
                    });
                    if (nftData) return Object.assign({}, {
                        position: squadMember.position,
                        squad_type_id: squadMember.squad_type_id
                    }, nftData);
                    return undefined;
                });
                var squadArray = [];
                enrichedSquad.forEach((sqMem)=>{
                    if (sqMem) squadArray[sqMem.position] = sqMem;
                });
                for(var i = 0; i < 3; i++)if (!squadArray[i]) squadArray[i] = Object.assign({}, $52d44b882d399a3d$var$noMember, {
                    position: i
                });
                return squadArray;
            } else return [
                Object.assign({}, $52d44b882d399a3d$var$noMember),
                Object.assign({}, $52d44b882d399a3d$var$noMember),
                Object.assign({}, $52d44b882d399a3d$var$noMember)
            ];
        });
    }
    enrichSquadDataFromMarketplace(squadData) {
        return (0, $57b0159e0c142865$export$2e2bcd8739ae039).getInstance().getNFTsFromMarketplace(squadData.map((sm)=>sm.marketplace_nft_id)).then((res)=>{
            if (squadData && squadData.length > 0) {
                const enrichedSquad = squadData.map((squadMember)=>{
                    var nftData = res.nfts.find((nft)=>{
                        return nft.id === squadMember.marketplace_nft_id;
                    });
                    if (nftData) return Object.assign({}, {
                        position: squadMember.position,
                        squad_type_id: squadMember.squad_type_id
                    }, nftData);
                    return undefined;
                });
                var squadArray = [];
                enrichedSquad.forEach((sqMem)=>{
                    if (sqMem) squadArray[sqMem.position] = sqMem;
                });
                for(var i = 0; i < 3; i++)if (!squadArray[i]) squadArray[i] = Object.assign({}, $52d44b882d399a3d$var$noMember, {
                    position: i
                });
                return squadArray;
            } else return [
                Object.assign({}, $52d44b882d399a3d$var$noMember),
                Object.assign({}, $52d44b882d399a3d$var$noMember),
                Object.assign({}, $52d44b882d399a3d$var$noMember)
            ];
        });
    }
    generateTraitsList(squad) {
        var traits = new Array();
        squad.forEach((nft)=>{
            if (nft.traits !== undefined) nft.traits.forEach((trait)=>{
                traits.push({
                    collection: nft.nft_collection,
                    id: nft.nft_id,
                    type: trait.trait_type,
                    trait: trait.value
                });
            });
        });
        return traits;
    }
    saveSquad(currentSquad) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("squad", [
            wallet,
            "mining"
        ], currentSquad).then((res)=>{
            return res;
        });
    }
    getPFPImageKey() {
        return this._squad[0].image_key;
    }
    getPFPUrl() {
        return this._squad[0].image_thumbnail_url;
    }
    getSquadHP() {
        var damage = 0;
        if (this._squad) damage = this._squad.map((sm)=>{
            return sm.hp;
        }).reduce((previous, current)=>{
            return previous + current;
        }) || 1500;
        return damage;
    }
}
$52d44b882d399a3d$var$SquadService._instance = new $52d44b882d399a3d$var$SquadService();
var $52d44b882d399a3d$export$2e2bcd8739ae039 = $52d44b882d399a3d$var$SquadService;


function $5f7ad9227787a545$export$a9d922be773c87b7(traitList) {
    var resourceBoost = 0, xpBoost = 0, stardustBoost = 0, spaceElixirBoost = 0, neonGoldBoost = 0, dphBoost = 0, dphCommonBoost = 0, dphEpicBoost = 0, miningEfficiencyBoost = 0;
    traitList.forEach((trait)=>{
        switch(trait.collection){
            // Genesis Collections
            case "Star Wolvez Genesis":
                resourceBoost += 0.2;
                xpBoost += 0.2;
                break;
            // No Homebase Buffs for Galactic Ape Genesis
            case "GalacticApes Genesis":
                resourceBoost += 0.1;
                xpBoost += 0.1;
                break;
            // Collections
            case "Star Wolvez Generative":
                switch(trait.trait){
                    // Increase XP an Resource Payout
                    case "Cybernetic":
                    case "Elder of the Light":
                    case "Frozen Magma":
                    case "Galaxy":
                    case "Glow in the Dark":
                    case "Gold Skully":
                    case "Gold Spike":
                    case "Goldstone":
                    case "Shadow Samurai":
                    case "Spike":
                        resourceBoost += 0.08;
                        xpBoost += 0.08;
                        break;
                    // Increase XP Payout
                    case "Relic Hunter Helmet Blue":
                    case "Relic Hunter Helmet Brown":
                        xpBoost += 0.1;
                        break;
                    // Increase Stardust Payout
                    case "Deep Core Armor":
                    case "Stardust Hunter Goggles":
                        stardustBoost += 0.02;
                        break;
                    case "X Beam 880":
                    case "Face Mask White":
                    case "Face Mask Blue":
                        stardustBoost += 0.03;
                        break;
                    case "Face Mask V2":
                        stardustBoost += 0.04;
                        break;
                    // Increase Space Elixir Payout
                    case "Undergrounder Helmet":
                        spaceElixirBoost += 0.05;
                        break;
                    case "Space Hurl":
                        spaceElixirBoost += 0.08;
                        break;
                    case "Space Elixir Blob":
                        spaceElixirBoost += 0.15;
                        break;
                    // Increase Neon Gold Payout
                    case "Golden Stash":
                        neonGoldBoost += 0.08;
                        break;
                    case "Space Elixir Body":
                        neonGoldBoost += 0.12;
                        break;
                    case "Neon Gold Blob":
                        neonGoldBoost += 0.15;
                        break;
                    // Increase All mining resources
                    case "Mine Specialist Goggles":
                        stardustBoost += 0.03;
                        spaceElixirBoost += 0.03;
                        neonGoldBoost += 0.03;
                        break;
                    case "Deep Mine Goggles":
                        stardustBoost += 0.04;
                        spaceElixirBoost += 0.04;
                        neonGoldBoost += 0.04;
                        break;
                    // Damage per hour Boost
                    case "Deep Search Goggles Blue":
                        dphBoost += 0.05;
                        break;
                    case "Deep Search Goggles Gold":
                        dphBoost += 0.08;
                        break;
                    case "Star Wolvez Lightning":
                    case "Miner Safety Helmet Mauve":
                        dphBoost += 0.1;
                        break;
                    case "Miner Safety Helmet Red":
                        dphBoost += 0.12;
                        break;
                    // Damage per hour COMMON Boost
                    case "Water Guard Armor":
                    case "Hardened Brown":
                        dphCommonBoost += 0.05;
                        break;
                    case "Hardened Green":
                    case "Hardened Red":
                    case "Hardened Pink":
                    case "Shaggy Earth Fallout":
                    case "Grizzled Earth Fallout":
                    case "Lupine Earth Fallout":
                        dphCommonBoost += 0.07;
                        break;
                    case "Hardened Blue":
                        dphCommonBoost += 0.09;
                        break;
                    case "Hardened Mauve":
                    case "Hardened Teal":
                        dphCommonBoost += 0.1;
                        break;
                    case "Hardened Sage":
                    case "Hardened Yellow":
                    case "Hardened White":
                        dphCommonBoost += 0.12;
                        break;
                    // Damage per hour EPIC Boost
                    case "Grizzled Water Fallout":
                    case "Lupine Water Fallout":
                    case "Shaggy Water Fallout":
                        dphEpicBoost += 0.07;
                        break;
                    case "Water Bearer":
                    case "Young Elder Green":
                    case "Young Elder Sage":
                    case "Young Elder Teal":
                    case "Young Elder White":
                    case "Young Elder Blue":
                    case "Young Elder Brown":
                    case "Mineral Core Armor":
                    case "Young Elder Mauve":
                    case "Young Elder Yellow":
                    case "Young Elder Red":
                        dphEpicBoost += 0.1;
                        break;
                    // Damage per hour COMMON & EPIC boost
                    case "Gold Body":
                        dphCommonBoost += 0.1;
                        dphEpicBoost += 0.1;
                        break;
                    // Increase mining effifiency per hour
                    case "Blob":
                        miningEfficiencyBoost += 0.1;
                        break;
                }
                break;
            case "GalacticApes":
                switch(trait.type){
                    case "Companion":
                        switch(trait.trait){
                            case "Little King Ape":
                                spaceElixirBoost += 0.1;
                                neonGoldBoost += 0.1;
                                break;
                        }
                        break;
                    case "Eye Gear":
                        switch(trait.trait){
                            case "Nerd":
                                stardustBoost += 0.03;
                                spaceElixirBoost += 0.03;
                                neonGoldBoost += 0.03;
                                break;
                            case "Scientist":
                                stardustBoost += 0.04;
                                spaceElixirBoost += 0.04;
                                neonGoldBoost += 0.04;
                                break;
                            case "Pilot Goggles":
                                stardustBoost += 0.05;
                                spaceElixirBoost += 0.05;
                                neonGoldBoost += 0.05;
                                break;
                            case "Cyberpunk VR":
                                dphBoost += 0.08;
                                break;
                            case "Rainbow VR":
                                dphBoost += 0.09;
                                break;
                            case "Scout":
                                dphBoost += 0.1;
                                break;
                        }
                        break;
                    case "Eyes":
                        switch(trait.trait){
                            case "Alien":
                                stardustBoost += 0.03;
                                spaceElixirBoost += 0.03;
                                neonGoldBoost += 0.03;
                                break;
                            case "Reptile":
                                stardustBoost += 0.04;
                                spaceElixirBoost += 0.04;
                                neonGoldBoost += 0.04;
                                break;
                            case "Robot":
                                stardustBoost += 0.03;
                                break;
                        }
                        break;
                    case "Head":
                        switch(trait.trait){
                            case "Goggles":
                                dphBoost += 0.05;
                                break;
                            case "Crystal":
                                dphBoost += 0.06;
                                break;
                            case "Pilot":
                                dphBoost += 0.07;
                                break;
                            case "Blob":
                                stardustBoost += 0.05;
                                spaceElixirBoost += 0.05;
                                neonGoldBoost += 0.05;
                                break;
                            case "Optics":
                                dphBoost += 0.09;
                                break;
                            case "Cosmic Cat":
                                stardustBoost += 0.06;
                                spaceElixirBoost += 0.06;
                                neonGoldBoost += 0.06;
                                break;
                            case "Rainbow Horn":
                                stardustBoost += 0.07;
                                spaceElixirBoost += 0.07;
                                neonGoldBoost += 0.07;
                                break;
                            case "T-Rex":
                                dphBoost += 0.1;
                                break;
                        }
                        break;
                    case "Mouth":
                        switch(trait.trait){
                            case "Robot":
                                stardustBoost += 0.03;
                                break;
                            case "Oni Mask":
                                stardustBoost += 0.03;
                                break;
                            case "Galactic Mask":
                                stardustBoost += 0.04;
                                break;
                            case "Cyber Oni Mask":
                                stardustBoost += 0.04;
                                break;
                        }
                        break;
                    case "Type":
                        switch(trait.trait){
                            case "Steampunk":
                            case "Rune":
                                dphBoost += 0.05;
                                break;
                            case "Slime":
                            case "Explorer":
                                dphBoost += 0.06;
                                break;
                            case "Neon":
                                dphBoost += 0.07;
                                break;
                            case "Shroom":
                            case "Rainbow":
                                dphBoost += 0.08;
                                break;
                            case "Gold":
                            case "Racer":
                            case "Terraform":
                                dphBoost += 0.1;
                                break;
                            case "Intellibot":
                                stardustBoost += 0.06;
                                spaceElixirBoost += 0.06;
                                neonGoldBoost += 0.06;
                                break;
                            case "Dystopian":
                                stardustBoost += 0.07;
                                spaceElixirBoost += 0.07;
                                neonGoldBoost += 0.07;
                                break;
                        }
                        break;
                }
        }
    });
    var traits = {
        resourceBoost: resourceBoost,
        xpBoost: xpBoost,
        stardustBoost: stardustBoost,
        spaceElixirBoost: spaceElixirBoost,
        neonGoldBoost: neonGoldBoost,
        dphBoost: dphBoost,
        dphCommonBoost: dphCommonBoost,
        dphEpicBoost: dphEpicBoost,
        miningEfficiencyBoost: miningEfficiencyBoost
    };
    return traits;
}
function $5f7ad9227787a545$export$a1ed3db95f0f9415(dph, rarity, traits) {
    var boostPercentage = traits.dphBoost;
    switch(rarity){
        case "Common":
            boostPercentage += traits.dphCommonBoost;
            break;
        case "Epic":
            boostPercentage += traits.dphEpicBoost;
            break;
    }
    var boostValue = dph * boostPercentage;
    return dph + Math.round(boostValue);
}
function $5f7ad9227787a545$export$6d24a664fd705150(traitList) {
    var returnList = [];
    traitList.forEach((trait)=>{
        var traitObject = $5f7ad9227787a545$export$e3546004c85a355c.find((item)=>item.collection === trait.collection && item.type == trait.type && item.trait == trait.trait);
        if (traitObject !== undefined) returnList.push({
            trait: traitObject.trait,
            description: traitObject.description,
            id: trait.id
        });
    });
    return returnList;
}
function $5f7ad9227787a545$export$3b8fb5d600233867(xp, boostValue) {
    var returnValue = xp;
    if (boostValue > 0) {
        var boost = returnValue * boostValue;
        returnValue += Math.round(boost);
        console.log("XP Boost Value: " + Math.round(boost) + " Total XP for Win: " + returnValue);
    }
    return returnValue;
}
function $5f7ad9227787a545$export$1a8952599990accc(traitList, machineMultiplier) {
    var upgradeBuildTime = 0, machineBuildTime = 0, reduceCost = 0;
    // Traits
    traitList.forEach((trait)=>{
        switch(trait.collection){
            // Genesis Collections
            case "Star Wolvez Genesis":
                upgradeBuildTime += 0.05;
                machineBuildTime += 0.05;
                reduceCost += 0.05;
                break;
            // No Homebase Buffs for Galactic Ape Genesis
            case "GalacticApes Genesis":
                break;
            // Collections
            case "Star Wolvez Generative":
                switch(trait.trait){
                    // Machine Build and Upgrade Time Improvement
                    case "Only Up Goggles Blue":
                        upgradeBuildTime += 0.04;
                        machineBuildTime += 0.04;
                        break;
                    case "AM III Goggles Silver":
                        upgradeBuildTime += 0.05;
                        machineBuildTime += 0.05;
                        break;
                    case "Only Up Frames Yellow":
                    case "AM III Goggles Purple":
                    case "AM III Goggles Green":
                        upgradeBuildTime += 0.06;
                        machineBuildTime += 0.06;
                        break;
                    case "Binary Clip Goggles":
                        upgradeBuildTime += 0.07;
                        machineBuildTime += 0.07;
                        break;
                    case "Technicolor Goggles":
                        upgradeBuildTime += 0.08;
                        machineBuildTime += 0.08;
                        break;
                    // Upgrade Time Improvement
                    case "Dark Elder":
                        upgradeBuildTime += 0.04;
                        break;
                    // Cost of Building and Upgrade Reduction
                    case "Senator Crown":
                        reduceCost += 0.05;
                        break;
                }
                break;
            case "GalacticApes":
                switch(trait.type){
                    case "Eye Gear":
                        switch(trait.trait){
                            case "LED Glasses":
                            case "Bright Tech":
                            case "Voggles":
                                upgradeBuildTime += 0.04;
                                machineBuildTime += 0.04;
                                break;
                            case "Emergency VR":
                                upgradeBuildTime += 0.05;
                                machineBuildTime += 0.05;
                                break;
                            case "Engineer":
                                upgradeBuildTime += 0.06;
                                machineBuildTime += 0.06;
                                break;
                        }
                        break;
                    case "Eyes":
                        switch(trait.trait){
                            case "One":
                                upgradeBuildTime += 0.05;
                                machineBuildTime += 0.05;
                                break;
                        }
                        break;
                    case "Head":
                        switch(trait.trait){
                            case "Crown":
                                upgradeBuildTime += 0.06;
                                break;
                            case "Dark Crown":
                                reduceCost += 0.05;
                                break;
                            case "Mecha":
                                upgradeBuildTime += 0.08;
                                break;
                        }
                        break;
                }
        }
    });
    // Add Homebase Machine multiplier
    upgradeBuildTime += machineMultiplier;
    machineBuildTime += machineMultiplier;
    reduceCost += machineMultiplier;
    var traits = {
        upgradeBuildTime: upgradeBuildTime,
        machineBuildTime: machineBuildTime,
        reduceCost: reduceCost
    };
    return traits;
}
function $5f7ad9227787a545$export$6be75df766c59f0e(value, reductionValue) {
    var reductionTotal = value / 100 * reductionValue * 100;
    return value - reductionTotal;
}
function $5f7ad9227787a545$export$2f0579b0e62bae17(traits) {
    var traitsList = [];
    traits.forEach((trait)=>{
        var traitObject = $5f7ad9227787a545$export$98bd73206fe417b6.find((item)=>item.collection === trait.collection && item.type == trait.type && item.trait == trait.trait);
        if (traitObject !== undefined) traitsList.push({
            trait: traitObject.trait,
            description: traitObject.description,
            id: trait.id
        });
    });
    return traitsList;
}
var $5f7ad9227787a545$export$e3546004c85a355c = [
    // Starwolvez Genesis
    {
        "collection": "Star Wolvez Genesis",
        "trait": "Genesis",
        "type": "Origin",
        "description": "Increases XP and resource payout for successful mission by 20%."
    },
    // Starwolvez Generative
    // Background
    {
        "collection": "Star Wolvez Generative",
        "trait": "Star Wolvez Lightning",
        "type": "Background",
        "description": "10% boost to damage per hour."
    },
    // Eyes:Headwear:Eyewear
    {
        "collection": "Star Wolvez Generative",
        "trait": "Mine Specialist Goggles",
        "type": "Eyes:Headwear:Eyewear",
        "description": "+3% boost to all mining resources earned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Deep Mine Goggles",
        "type": "Eyes:Headwear:Eyewear",
        "description": "4% boost to all mining resources earned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Deep Search Goggles Blue",
        "type": "Eyes:Headwear:Eyewear",
        "description": "5% boost to damage per hour."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Stardust Hunter Goggles",
        "type": "Eyes:Headwear:Eyewear",
        "description": "2% increase of Stardust per successful mining mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Deep Search Goggles Gold",
        "type": "Eyes:Headwear:Eyewear",
        "description": "8% boost to damage per hour."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Miner Safety Helmet Mauve",
        "type": "Eyes:Headwear:Eyewear",
        "description": "10% boost to damage per hour."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "X Beam 880",
        "type": "Eyes:Headwear:Eyewear",
        "description": "3% increase of Stardust per successful mining mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Miner Safety Helmet Red",
        "type": "Eyes:Headwear:Eyewear",
        "description": "12% boost to damage per hour."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Relic Hunter Helmet Blue",
        "type": "Eyes:Headwear:Eyewear",
        "description": "10% more XP per successful mining mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Undergrounder Helmet",
        "type": "Eyes:Headwear:Eyewear",
        "description": "5% increase in Space Elixir per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Relic Hunter Helmet Brown",
        "type": "Eyes:Headwear:Eyewear",
        "description": "10% more XP per successful mining mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Elixir Blob",
        "type": "Eyes:Headwear:Eyewear",
        "description": "15% increase in Space Elixir won in all game modes."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Neon Gold Blob",
        "type": "Eyes:Headwear:Eyewear",
        "description": "15% increase in Neon Gold won in all game modes."
    },
    // Mouth
    {
        "collection": "Star Wolvez Generative",
        "trait": "Face Mask White",
        "type": "Mouth",
        "description": "3% increase in Stardust per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Hurl",
        "type": "Mouth",
        "description": "8% increase in Space Elixir per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Face Mask Blue",
        "type": "Mouth",
        "description": "3% increase in Stardust per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Golden Stash",
        "type": "Mouth",
        "description": "8% increase in Neon Gold per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Face Mask V2",
        "type": "Mouth",
        "description": "4% increase in Stardust per successful mission."
    },
    // Head
    {
        "collection": "Star Wolvez Generative",
        "trait": "Grizzled Water Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Shaggy Earth Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Lupine Water Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Shaggy Water Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Grizzled Earth Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Water Bearer",
        "type": "Head",
        "description": "10% increase in damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Lupine Earth Fallout",
        "type": "Head",
        "description": "7% increase in damage per hour on Common mining missions.	"
    },
    // Body
    {
        "collection": "Star Wolvez Generative",
        "trait": "Water Guard Armor",
        "type": "Body",
        "description": "5% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Brown",
        "type": "Body",
        "description": "5% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Green",
        "type": "Body",
        "description": "7% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Red",
        "type": "Body",
        "description": "7% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Pink",
        "type": "Body",
        "description": "7% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Deep Core Armor",
        "type": "Body",
        "description": "2% increase in Stardust per successful mission."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Blue",
        "type": "Body",
        "description": "9% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Mauve",
        "type": "Body",
        "description": "10% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Teal",
        "type": "Body",
        "description": "10% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Sage",
        "type": "Body",
        "description": "12% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened Yellow",
        "type": "Body",
        "description": "12% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Hardened White",
        "type": "Body",
        "description": "12% more damage per hour on Common mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Green",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Sage",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Teal",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder White",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Blue",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Brown",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Mineral Core Armor",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Mauve",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Yellow",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Young Elder Red",
        "type": "Body",
        "description": "10% more damage per hour on Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Gold Body",
        "type": "Body",
        "description": "10% more damage per hour on Common and Epic mining missions."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Elixir Body",
        "type": "Body",
        "description": "12% increase in Neon Gold per successful mission."
    },
    // Special
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cybernetic",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Elder of the Light",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Frozen Magma",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Galaxy",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Glow in the Dark",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Gold Skully",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Gold Spike",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Goldstone",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Shadow Samurai",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Spike",
        "type": "Special",
        "description": "Increases XP and resource payout for successful mission by 8%."
    },
    // GalacticApes Genesis
    {
        "collection": "GalacticApes Genesis",
        "trait": "Genesis",
        "type": "",
        "description": "Increases XP and resource payout for successful mission by 10%."
    },
    // GalacticApes
    // Companion
    {
        "collection": "GalacticApes",
        "trait": "Little King Ape",
        "type": "Companion",
        "description": "Increases off-chain resource payout by 10%."
    },
    // Eye Gear
    {
        "collection": "GalacticApes",
        "trait": "Nerd",
        "type": "Eye Gear",
        "description": "+3% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Scientist",
        "type": "Eye Gear",
        "description": "+4% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Pilot Goggles",
        "type": "Eye Gear",
        "description": "+5% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Cyberpunk VR",
        "type": "Eye Gear",
        "description": "8% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Rainbow VR",
        "type": "Eye Gear",
        "description": "9% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Scout",
        "type": "Eye Gear",
        "description": "10% boost to damage per hour."
    },
    // Eyes
    {
        "collection": "GalacticApes",
        "trait": "Alien",
        "type": "Eyes",
        "description": "+3% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Reptile",
        "type": "Eyes",
        "description": "+4% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Robot",
        "type": "Eyes",
        "description": "+5% boost to all mining resources earned."
    },
    // Head
    {
        "collection": "GalacticApes",
        "trait": "Goggles",
        "type": "Head",
        "description": "5% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Crystal",
        "type": "Head",
        "description": "6% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Pilot",
        "type": "Head",
        "description": "7% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Blob",
        "type": "Head",
        "description": "+5% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Optics",
        "type": "Head",
        "description": "9% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Cosmic Cat",
        "type": "Head",
        "description": "+6% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Rainbow Horn",
        "type": "Head",
        "description": "+7% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "T-Rex",
        "type": "Head",
        "description": "10% boost to damage per hour."
    },
    // Mouth
    {
        "collection": "GalacticApes",
        "trait": "Robot",
        "type": "Mouth",
        "description": "3% increase in Stardust per successful mission."
    },
    {
        "collection": "GalacticApes",
        "trait": "Oni Mask",
        "type": "Mouth",
        "description": "3% increase in Stardust per successful mission."
    },
    {
        "collection": "GalacticApes",
        "trait": "Galactic Mask",
        "type": "Mouth",
        "description": "4% increase in Stardust per successful mission."
    },
    {
        "collection": "GalacticApes",
        "trait": "Cyber Oni Mask",
        "type": "Mouth",
        "description": "4% increase in Stardust per successful mission."
    },
    // Type
    {
        "collection": "GalacticApes",
        "trait": "Steampunk",
        "type": "Type",
        "description": "5% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Rune",
        "type": "Type",
        "description": "5% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Slime",
        "type": "Type",
        "description": "6% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Explorer",
        "type": "Type",
        "description": "6% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Neon",
        "type": "Type",
        "description": "7% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Shroom",
        "type": "Type",
        "description": "8% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Rainbow",
        "type": "Type",
        "description": "8% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Gold",
        "type": "Type",
        "description": "10% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Racer",
        "type": "Type",
        "description": "10% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Terraform",
        "type": "Type",
        "description": "10% boost to damage per hour."
    },
    {
        "collection": "GalacticApes",
        "trait": "Intellibot",
        "type": "Type",
        "description": "+6% boost to all mining resources earned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Dystopian",
        "type": "Type",
        "description": "+7% boost to all mining resources earned."
    }
];
var $5f7ad9227787a545$export$98bd73206fe417b6 = [
    // Starwolvez Genesis
    {
        "collection": "Star Wolvez Genesis",
        "trait": "Genesis",
        "type": "Origin",
        "description": "Heavy Attack +15. 20% Resource Boost."
    },
    // Starwolvez Generative
    // Accessories
    {
        "collection": "Star Wolvez Generative",
        "trait": "Plasma Rifle Mark I",
        "type": "Accessories",
        "description": "Heavy Attack does 8 more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Plasma Rifle Mark II",
        "type": "Accessories",
        "description": "Heavy Attack does 10 more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Plasma Rifle Mark Gold",
        "type": "Accessories",
        "description": "Heavy Attack does 12 more damage."
    },
    // Eyes:Headwear:Eyewear
    {
        "collection": "Star Wolvez Generative",
        "trait": "Synthwave Goggles",
        "type": "Eyes:Headwear:Eyewear",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "SW Force Goggles Yellow",
        "type": "Eyes:Headwear:Eyewear",
        "description": "+5% chance to stun opponent."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Rogue Runner Glasses",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Light attacks deal 8 more hit points."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "SW Force Goggles Blue",
        "type": "Eyes:Headwear:Eyewear",
        "description": "+5% chance to stun opponent."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Replicant Vision Goggles",
        "type": "Eyes:Headwear:Eyewear",
        "description": "12% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "SW Force Goggles White",
        "type": "Eyes:Headwear:Eyewear",
        "description": "+6% chance to stun opponent."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "AM III V2 Helmet",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 4% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Red Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Blue Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Orange Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyclops Yellow",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Pink Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Teal Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Green Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Yellow Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyclops Red",
        "type": "Eyes:Headwear:Eyewear",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyclops Blue",
        "type": "Eyes:Headwear:Eyewear",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Mohawk Blue",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 7% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyclops Galaxy",
        "type": "Eyes:Headwear:Eyewear",
        "description": "8% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Round Table Helmet",
        "type": "Eyes:Headwear:Eyewear",
        "description": "12% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Spacetime Helmet",
        "type": "Eyes:Headwear:Eyewear",
        "description": "15% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Mohawk Pink",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Regenerates 10% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Trip Eyes",
        "type": "Eyes:Headwear:Eyewear",
        "description": "10% less likely to be stunned."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Laser Beams",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Increased chance of critial hit by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Elixir Blob",
        "type": "Eyes:Headwear:Eyewear",
        "description": "15% increase in Space Elixir won."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Neon Gold Blob",
        "type": "Eyes:Headwear:Eyewear",
        "description": "15% increase in Neon Gold won."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Bone Head",
        "type": "Eyes:Headwear:Eyewear",
        "description": "Reduces Opponent Heavy Attack by 15%"
    },
    // Mouth
    {
        "collection": "Star Wolvez Generative",
        "trait": "Plasma Blast",
        "type": "Mouth",
        "description": "4% more likely to deal a critical hit."
    },
    // Head
    {
        "collection": "Star Wolvez Generative",
        "trait": "Gold",
        "type": "Head",
        "description": "8% increase in Neon Gold won."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Grizzled Magma",
        "type": "Head",
        "description": "Increased chance of critial hit by 5%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Lupine Magma",
        "type": "Head",
        "description": "Increased chance of critial hit by 5%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Elixir",
        "type": "Head",
        "description": "8% increase in Space Elixir won."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Skully",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Shaggy Magma",
        "type": "Head",
        "description": "Increased chance of critial hit by 5%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Sandstone",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 10%"
    },
    // Body
    {
        "collection": "Star Wolvez Generative",
        "trait": "Sulfur Runner Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Dark Trooper Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Red Centauri Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Elite Guard Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Ground Guard Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Plasma Recon Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Vanguard Bronze Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 5%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Council Person Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 7%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Royal Artillery Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 7%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Elite Trooper Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 7%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Senator Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyberpunk Armor Red",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Vanguard Blue Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 8%."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Oxygen Garden Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 8%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Medic Armor",
        "type": "Body",
        "description": "Regenerates 10% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Blue Centauri Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 10%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Green Warhead Armor",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Cyberpunk Armor Blue",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 10%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Green",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Morning Watch Armor",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Pink",
        "type": "Body",
        "description": "Regenerates 10% HP every 5 rounds."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Carbon Guard Armor",
        "type": "Body",
        "description": "Reduces Opponent Heavy Attack by 10%"
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Sage",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole White",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Pink Warhead Armor",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Brown",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Blue",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Mauve",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Yellow",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Magma Body",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Red",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Swole Teal",
        "type": "Body",
        "description": "Heavy Attacks do 10% more damage."
    },
    // Special
    {
        "collection": "Star Wolvez Generative",
        "trait": "Neon Gold Blob",
        "type": "Special",
        "description": "Recovers 10 HP per turn."
    },
    {
        "collection": "Star Wolvez Generative",
        "trait": "Space Elixir Blob",
        "type": "Special",
        "description": "Recovers 10 HP per turn."
    },
    // GalacticApes Genesis
    {
        "collection": "GalacticApes Genesis",
        "trait": "Genesis",
        "type": "",
        "description": "Heavy Attacks do 7.5% more damage."
    },
    // GalacticApes
    // Companion
    {
        "collection": "GalacticApes",
        "trait": "Little King Ape",
        "type": "Companion",
        "description": "Increases off-chain resource payout by 10%."
    },
    // Eye Gear
    {
        "collection": "GalacticApes",
        "trait": "Glasses",
        "type": "Eye Gear",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Sunglasses",
        "type": "Eye Gear",
        "description": "6% less likely to be stunned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Tribal",
        "type": "Eye Gear",
        "description": "+5% chance to stun opponent."
    },
    // Eyes
    {
        "collection": "GalacticApes",
        "trait": "Bored",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Happy",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Curious",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Standard",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Angry",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Closed",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Scarred",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Tattoo",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Damaged",
        "type": "Eyes",
        "description": "Regenerates 2% HP every 5 rounds."
    },
    {
        "collection": "GalacticApes",
        "trait": "Thorny",
        "type": "Eyes",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Cute",
        "type": "Eyes",
        "description": "5% less likely to be stunned."
    },
    {
        "collection": "GalacticApes",
        "trait": "War Paint",
        "type": "Eyes",
        "description": "+5% chance to stun opponent."
    },
    {
        "collection": "GalacticApes",
        "trait": "Four",
        "type": "Eyes",
        "description": "10% less likely to be stunned."
    },
    {
        "collection": "GalacticApes",
        "trait": "Laser",
        "type": "Eyes",
        "description": "Heavy Attacks do 8% more damage."
    },
    // Head
    {
        "collection": "GalacticApes",
        "trait": "Bald",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 9%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Royal Guard",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 9%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Beam",
        "type": "Head",
        "description": "Heavy Attacks do 5% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Chemical",
        "type": "Head",
        "description": "8% increase in Neon Gold won."
    },
    {
        "collection": "GalacticApes",
        "trait": "Wing Band",
        "type": "Head",
        "description": "8% increase in Neon Gold won."
    },
    {
        "collection": "GalacticApes",
        "trait": "Creature Tech",
        "type": "Head",
        "description": "8% increase in Space Elixir won."
    },
    {
        "collection": "GalacticApes",
        "trait": "Plasma Crown",
        "type": "Head",
        "description": "8% increase in Space Elixir won."
    },
    {
        "collection": "GalacticApes",
        "trait": "Crybernetics",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 8%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Robo Beast",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 9%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Dragon",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Little Ape",
        "type": "Head",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    // Mouth
    {
        "collection": "GalacticApes",
        "trait": "Laser",
        "type": "Mouth",
        "description": "Heavy Attacks do 6% more damage."
    },
    // Type
    {
        "collection": "GalacticApes",
        "trait": "Scrapper",
        "type": "Type",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Spark",
        "type": "Type",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Stone Guardian",
        "type": "Type",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Thorny",
        "type": "Type",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Battleworn",
        "type": "Type",
        "description": "Heavy Attacks do 5% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Brawler",
        "type": "Type",
        "description": "Heavy Attacks do 7% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Specialist",
        "type": "Type",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Magma",
        "type": "Type",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Punk",
        "type": "Type",
        "description": "Heavy Attacks do 10% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Guardian",
        "type": "Type",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Cyberpunk",
        "type": "Type",
        "description": "Heavy Attacks do 7% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Zombie",
        "type": "Type",
        "description": "Heavy Attacks do 8% more damage."
    },
    {
        "collection": "GalacticApes",
        "trait": "Ranger",
        "type": "Type",
        "description": "Reduces Opponent Heavy Attack by 10%."
    },
    {
        "collection": "GalacticApes",
        "trait": "Gedi",
        "type": "Type",
        "description": "Reduces Opponent Heavy Attack by 10%."
    }
];
var $5f7ad9227787a545$export$94ae8033e461c423 = [
    {
        "trait": "Only Up Goggles Blue",
        "description": "Improves machine build and upgrade time by 4%."
    },
    {
        "trait": "AM III Goggles Silver",
        "description": "Improves machine build and upgrade time by 5%."
    },
    {
        "trait": "Only Up Frames Yellow",
        "description": "Improves machine build and upgrade time by 6%."
    },
    {
        "trait": "AM III Goggles Purple",
        "description": "Improves machine build and upgrade time by 6%."
    },
    {
        "trait": "AM III Goggles Green",
        "description": "Improves machine build and upgrade time by 6%."
    },
    {
        "trait": "Binary Clip Goggles",
        "description": "Improves machine build and upgrade time by 7%."
    },
    {
        "trait": "Senator Crown",
        "description": "Cost of building and upgrading decreased by 5%."
    },
    {
        "trait": "Technicolor Goggles",
        "description": "Improves machine build and upgrade time by 8%."
    },
    {
        "trait": "Dark Elder",
        "description": "Improves upgrade times on Machines by 6%."
    }
];


const $a84396f9bb426f08$var$cadetDormCapacities = [
    0,
    3,
    5,
    10,
    15,
    20,
    25,
    35,
    50,
    65,
    80
];
const $a84396f9bb426f08$var$dimXBoosts = [
    0,
    5,
    10,
    15
];
const $a84396f9bb426f08$var$doublePointMachineKeys = [
    "neon_gold_mine",
    "neon_gold_storage",
    "space_elixir_mine",
    "space_elixir_storage"
];
class $a84396f9bb426f08$var$MachineService {
    constructor(){
        if ($a84396f9bb426f08$var$MachineService._instance) throw new Error("Error: Instantiation failed: Use MachineService.getInstance() instead of new.");
        $a84396f9bb426f08$var$MachineService._instance = this;
    }
    static getInstance() {
        return $a84396f9bb426f08$var$MachineService._instance;
    }
    // All machines
    setMachines(value) {
        this._machines = value;
    }
    getMachines(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._machines && !forceUpdate) return resolve(this._machines);
            else return resolve(this.fetchMachines());
        });
    }
    getMachinesSync() {
        return this._machines;
    }
    fetchMachines() {
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            "all"
        ], []).then((res)=>{
            this._machines = res.machines;
            return this._machines;
        });
    }
    getAvailableMachines(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._availableMachines && !forceUpdate) return resolve(this._availableMachines);
            else return resolve(this.fetchAvailableMachines());
        });
    }
    getAvailableMachinesSync() {
        return this._availableMachines;
    }
    fetchAvailableMachines() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            wallet,
            "all"
        ], []).then((res)=>{
            this._availableMachines = res.machines;
            this.applyMachineTraits(false);
            return this._availableMachines;
        });
    }
    // User Machines
    getUserMachines(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._userMachines && !forceUpdate) return resolve(this._userMachines);
            else return resolve(this.fetchUserMachines());
        });
    }
    getUserMachinesSync() {
        return this._userMachines;
    }
    fetchUserMachines() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            wallet
        ], []).then((res)=>{
            this._userMachines = this.enrichMachinesData(res.machines);
            this.applyMachineTraits(true);
            return this._userMachines.map((machine)=>{
                // if (machine.key === 'star_laboratory') {
                //     machine.time_until_inactive = 1000;
                // }
                // machine.level = 10;
                // machine.time_until_next_level = 0;
                // machine.next_level_build_total_time = 0;
                // machine.next_level_storage_neon_gold = 0;
                // machine.next_level_storage_space_elixir = 0;
                // machine.next_level_produce_per_hour_neon_gold = 0;
                // machine.next_level_produce_per_hour_space_elixir = 0;
                // machine.cost_stardust = 0;
                // machine.cost_neon_gold = 0;
                // machine.cost_space_elixir = 0;
                return machine;
            });
        });
    }
    // Purchase Machine
    purchaseMachine(machine_id, timeReductionPercent, costReductionPercent) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const params = {
            decreaseBuildTime: timeReductionPercent,
            decreaseResources: costReductionPercent
        };
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "purchase",
            machine_id
        ], params).then((res)=>{
            return res;
        });
    }
    // Upgrade Machine
    upgradeMachine(user_machine_id, timeReductionPercent, costReductionPercent) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const params = {
            decreaseBuildTime: timeReductionPercent,
            decreaseResources: costReductionPercent
        };
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "upgrade",
            user_machine_id
        ], params).then((res)=>{
            console.log(res);
            return res;
        });
    }
    // Speed Up Upgrade
    speedUpUpgrade(user_machine_id, stardust_amount) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "upgrade",
            user_machine_id
        ], {
            stardust: stardust_amount.toString()
        }).then((res)=>{
            console.log(res);
            return res;
        });
    }
    // Activate Machine
    activateMachine(user_machine_id) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "activate",
            user_machine_id
        ], {}).then((res)=>{
            console.log(res);
            return res;
        });
    }
    // Set Position
    updateMachinePosition(user_machine_id, x, y) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "locations"
        ], {
            locations: [
                {
                    user_machine_id: user_machine_id,
                    x: x,
                    y: y
                }
            ]
        }).then((res)=>{
            console.log(res);
            return res;
        });
    }
    // Applies Machine Trait Values
    applyMachineTraits(isUpgrade) {
        var squadTraits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        var machineMultiplier = $a84396f9bb426f08$var$MachineService.getInstance().getHomebaseMachineMultiplier();
        if (!squadTraits) squadTraits = [];
        var homebaseTraits = (0, $5f7ad9227787a545$export$1a8952599990accc)(squadTraits, machineMultiplier);
        if (isUpgrade) // Applies Traits to Upgrade Machine costs
        this._userMachines.forEach((machine)=>{
            machine.cost_neon_gold = this.calculateTraitReduction(machine.cost_neon_gold, homebaseTraits.reduceCost);
            machine.cost_space_elixir = this.calculateTraitReduction(machine.cost_space_elixir, homebaseTraits.reduceCost);
            machine.cost_stardust = this.calculateTraitReduction(machine.cost_stardust, homebaseTraits.reduceCost);
            machine.next_level_build_total_time = this.calculateTraitReduction(machine.next_level_build_total_time, homebaseTraits.upgradeBuildTime);
        });
        else // Applies Traits to New Machine Costs
        this._availableMachines.forEach((machine)=>{
            machine.cost_neon_gold = this.calculateTraitReduction(machine.cost_neon_gold, homebaseTraits.reduceCost);
            machine.cost_space_elixir = this.calculateTraitReduction(machine.cost_space_elixir, homebaseTraits.reduceCost);
            machine.cost_stardust = this.calculateTraitReduction(machine.cost_stardust, homebaseTraits.reduceCost);
            machine.next_level_build_total_time = this.calculateTraitReduction(machine.next_level_build_total_time, homebaseTraits.machineBuildTime);
        });
    }
    calculateTraitReduction(value, reductionValue) {
        var reductionTotal = value / 100 * reductionValue * 100;
        return value - reductionTotal;
    }
    // Claim machine resources
    claimResources(user_machine_id) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "claim",
            user_machine_id
        ], {}).then((res)=>{
            return res;
        });
    }
    getStorageCapacities() {
        var spaceElixir = 0;
        this._userMachines.forEach((mach)=>{
            if (mach["storage_space_elixir"] && mach["storage_space_elixir"] > 0) spaceElixir = spaceElixir + mach["storage_space_elixir"];
        });
        var neonGold = 0;
        this._userMachines.forEach((mach)=>{
            if (mach["storage_neon_gold"] && mach["storage_neon_gold"] > 0) neonGold = neonGold + mach["storage_neon_gold"];
        });
        return {
            spaceElixir: spaceElixir,
            neonGold: neonGold
        };
    }
    enrichMachinesData(machinesData) {
        var tempData = machinesData.map((mach)=>{
            return Object.assign({}, mach, {
                numberAvailable: this.getNumberOfMachinesAvailable(machinesData, mach),
                maxNumber: this.getMaxNumberOfMachines(mach)
            });
        });
        return tempData;
    }
    getNumberOfMachinesAvailable(machinesData, shopMachine) {
        var max = this.getMaxNumberOfMachines(shopMachine);
        var totalUserMachines = 0;
        machinesData.filter((machine)=>machine.key === shopMachine.key).forEach((mach)=>{
            if (mach.level > 10 && $a84396f9bb426f08$var$doublePointMachineKeys.includes(mach.key)) totalUserMachines += 2;
            else totalUserMachines++;
        });
        return max - totalUserMachines < 0 ? 0 : max - totalUserMachines;
    }
    getMaxNumberOfMachines(shopMachine) {
        var max = shopMachine.max_allowed_from_mf_level;
        return max && max > 0 ? max : 1;
    }
    getKaijuMachineMultiplier() {
        var multiplier = 0;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1029) switch(mach.level){
                case 1:
                    multiplier = 0.15;
                    break;
                case 2:
                    multiplier = 0.25;
                    break;
                case 3:
                    multiplier = 0.5;
                    break;
            }
        });
        return multiplier;
    }
    getHomebaseMachineMultiplier() {
        var multiplier = 0;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1039) switch(mach.level){
                case 1:
                    multiplier = 0.025;
                    break;
                case 2:
                    multiplier = 0.05;
                    break;
                case 3:
                    multiplier = 0.075;
                    break;
                case 4:
                    multiplier = 0.1;
                    break;
            }
        });
        return multiplier;
    }
    ownsBrawlerCage() {
        var hasCage = false;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1021) hasCage = true;
        });
        return hasCage;
    }
    ownsGLFHersArcade() {
        var hasArcade = false;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1060) hasArcade = true;
        });
        return hasArcade;
    }
    ownsPNWoodenGalleon() {
        var hasGalleon = false;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1061) hasGalleon = true;
        });
        return hasGalleon;
    }
    ownsPNGoldenGalleon() {
        var hasGalleon = false;
        this._userMachines.forEach((mach)=>{
            if (mach.machine_id === 1062) hasGalleon = true;
        });
        return hasGalleon;
    }
    getUserMachineLevel(machineId) {
        const machine = this._userMachines.find((mach)=>mach.machine_id === machineId);
        if (!machine) return 0;
        return machine.level;
    }
    getUserMachineFromMachineId(machineId) {
        return this._userMachines.find((userMach)=>userMach.machine_id === machineId);
    }
    getCadetDormsCapacity() {
        const cadetDorms = this._userMachines.filter((mach)=>mach.machine_id === 1034); // 1034 = Cadet Dorms
        if (!cadetDorms || cadetDorms.length === 0) return 0;
        var capacity = 0;
        cadetDorms.forEach((dorm)=>{
            capacity += $a84396f9bb426f08$var$cadetDormCapacities[dorm.level];
        });
        return capacity;
    }
    getCadetDormCapacity(level) {
        return $a84396f9bb426f08$var$cadetDormCapacities[level];
    }
    getDimensionXBoost() {
        const dimX = this._userMachines.find((mach)=>mach.machine_id === 1046); // 1034 = Cadet Dorms
        if (!dimX || dimX.length === 0) return 0;
        return $a84396f9bb426f08$var$dimXBoosts[dimX.level] || 0;
    }
}
$a84396f9bb426f08$var$MachineService._instance = new $a84396f9bb426f08$var$MachineService();
var $a84396f9bb426f08$export$2e2bcd8739ae039 = $a84396f9bb426f08$var$MachineService;





const $682c5d521fb8ae22$export$b9b712abdb918f5b = {
    1: 0x38384e,
    2: 0x039be5,
    3: 0xb803e5,
    4: 0xffa000,
    5: 0xc9e8ff
};
const $682c5d521fb8ae22$export$aaac5bc6d10d929c = {
    1: "Common",
    2: "Rare",
    3: "Epic",
    4: "Legendary",
    5: "Mythical"
};
// /mining/:user_address/last[?marked=1] - returns reward info for last asteroid mined. Setting marked means info won't be returned again.
class $682c5d521fb8ae22$var$MiningService {
    constructor(){
        if ($682c5d521fb8ae22$var$MiningService._instance) throw new Error(`Error: Instatiation failed: use ${$682c5d521fb8ae22$var$MiningService.name}.getInstance() instead of new.`);
        $682c5d521fb8ae22$var$MiningService._instance = this;
    }
    static getInstance() {
        return $682c5d521fb8ae22$var$MiningService._instance;
    }
    getAllAsteroids() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("mining", [
            "all"
        ], []).then((res)=>{
            this._asteroids = res;
            return res;
        });
    }
    getAllAsteroidsSync() {
        return this._asteroids;
    }
    getSixRandomAsteroids() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("mining", [
            address,
            "picksix"
        ], []).then((res)=>{
            return res.asteroids;
        });
    }
    getMiningStatus() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("mining", [
            address,
            "status"
        ], []).then((res)=>{
            this._miningStatus = res.asteroids;
            return res.asteroids;
        });
    }
    getMiningStatusSync() {
        return this._miningStatus;
    }
    getLastMinedReward() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("mining", [
            address,
            "last"
        ], []).then((res)=>{
            this._reward = res;
            return res;
        });
    }
    getLastMinedRewardSync() {
        return this._reward;
    }
    claimLastMinedReward() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("mining", [
            address,
            "last?marked=1"
        ], []).then((res)=>res);
    }
    startMiningAsteroid(asteroidId, miningTraits) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const dimXBoost = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getDimensionXBoost();
        const params = {
            boost_resources: miningTraits.resourceBoost * 100,
            boost_xp: miningTraits.xpBoost * 100,
            boost_stardust: miningTraits.stardustBoost * 100,
            boost_space_elixir: miningTraits.spaceElixirBoost * 100,
            boost_neon_gold: miningTraits.neonGoldBoost * 100,
            boost_dph: miningTraits.dphBoost * 100,
            boost_dph_common: miningTraits.dphCommonBoost * 100,
            boost_dph_epic: miningTraits.dphEpicBoost * 100,
            boost_mining_efficency: miningTraits.miningEfficiencyBoost * 100 + dimXBoost
        };
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("mining", [
            address,
            "start",
            asteroidId
        ], params).then((res)=>res);
    }
    cancelMiningAsteroid(asteroidId) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("mining", [
            address,
            "cancel",
            asteroidId
        ], {});
    }
}
$682c5d521fb8ae22$var$MiningService._instance = new $682c5d521fb8ae22$var$MiningService();
var $682c5d521fb8ae22$export$2e2bcd8739ae039 = $682c5d521fb8ae22$var$MiningService;




const $643405a524e0a7c6$var$objectiveTypes = [
    {
        key: "staking",
        displayName: "Soft Staking",
        isSelected: true
    },
    {
        key: "quick_quests",
        displayName: "Quick Quests",
        isSelected: false
    },
    {
        key: "partner_quests",
        displayName: "Partner Quests",
        isSelected: false
    },
    {
        key: "milestones",
        displayName: "Milestones",
        isSelected: false
    },
    {
        key: "battle_pass_daily",
        displayName: "Battle Pass Daily",
        isSelected: false
    },
    {
        key: "battle_pass_weekly",
        displayName: "Battle Pass Weekly",
        isSelected: false
    },
    {
        key: "battle_pass_monthly",
        displayName: "Battle Pass Monthly",
        isSelected: false
    }
];
class $643405a524e0a7c6$var$ObjectiveService {
    constructor(){
        if ($643405a524e0a7c6$var$ObjectiveService._instance) throw new Error("Error: Instantiation failed: Use ObjectiveService.getInstance() instead of new.");
        $643405a524e0a7c6$var$ObjectiveService._instance = this;
    }
    static getInstance() {
        return $643405a524e0a7c6$var$ObjectiveService._instance;
    }
    setObjectives(value) {
        this._objectives = value;
    }
    getObjectives(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._objectives && !forceUpdate) return resolve(this._objectives);
            else return resolve(this.fetchObjectives());
        });
    }
    getObjectivesSync() {
        return this._objectives;
    }
    updateObjective(objectiveId, newActionValue) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("objectives", [
            wallet,
            objectiveId,
            newActionValue
        ], {}).then((res)=>{
            return res;
        });
    }
    fetchObjectives() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("objectives", [
            wallet,
            "all"
        ], []).then((res)=>{
            this._objectives = res;
            return res;
        });
    }
    getObjectiveTypes() {
        return $643405a524e0a7c6$var$objectiveTypes;
    }
}
$643405a524e0a7c6$var$ObjectiveService._instance = new $643405a524e0a7c6$var$ObjectiveService();
var $643405a524e0a7c6$export$2e2bcd8739ae039 = $643405a524e0a7c6$var$ObjectiveService;






const $e12b36903093d20d$var$sw_yield = 5;
const $e12b36903093d20d$var$sw_genesis_yield = 50;
const $e12b36903093d20d$var$ga_yield = 2;
const $e12b36903093d20d$var$ga_genesis_yield = 8;
const $e12b36903093d20d$var$gm_yield = 1;
class $e12b36903093d20d$var$StakingService {
    constructor(){
        this._netStakingYield = 0;
        if ($e12b36903093d20d$var$StakingService._instance) throw new Error("Error: Instantiation failed: Use StakingService.getInstance() instead of new.");
        $e12b36903093d20d$var$StakingService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $e12b36903093d20d$var$StakingService._instance;
    }
    getStakingInfo(nftIds, collection_slugs, startIndex, numRequested, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._stakingInfo && !forceUpdate) return resolve(this._stakingInfo);
            else return resolve(this.fetchStakingInfo(nftIds, collection_slugs, startIndex, numRequested));
        });
    }
    claimNftStakingReward(nftId) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("staking", [
            wallet,
            "nft",
            nftId
        ], {}).then((res)=>{
            return res;
        });
    }
    claimAllStakingRewards() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("staking", [
            wallet,
            "nft",
            "all"
        ], {}).then((res)=>{
            return res;
        });
    }
    getStakingInfoSync() {
        return this._stakingInfo;
    }
    fetchStakingInfo(nftIds, collection_slugs, startIndex, numRequested) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const queryParams = nftIds && nftIds.length > 0 ? [
            `ids=${nftIds.toString()}`
        ] : [];
        if (collection_slugs) queryParams.push(`collection_slug=${collection_slugs.toString()}`);
        if (startIndex !== undefined && startIndex !== null) queryParams.push(`start_index=${startIndex}`);
        if (numRequested !== undefined && numRequested !== null) queryParams.push(`count=${numRequested}`);
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("staking", [
            wallet
        ], queryParams).then((res)=>{
            this._stakingInfo = Object.assign(Object.assign({}, res), {
                nfts: this.enrichImageData(res)
            });
            this.setNetStakingYield();
            return this._stakingInfo;
        });
    }
    enrichImageData(data) {
        var _a;
        const nfts = (_a = data === null || data === void 0 ? void 0 : data.nfts) === null || _a === void 0 ? void 0 : _a.map((nft)=>{
            nft.image_key = `nft_${nft.marketplace_nft_id}`;
            return nft;
        });
        data.nfts = nfts;
        return data.nfts;
    }
    getNetStakingYield() {
        return this._netStakingYield;
    }
    setNetStakingYield() {
        this._netStakingYield = 0;
        this._netStakingYield += this._stakingInfo.sw_generative_count * $e12b36903093d20d$var$sw_yield;
        this._netStakingYield += this._stakingInfo.sw_genesis_count * $e12b36903093d20d$var$sw_genesis_yield;
        this._netStakingYield += this._stakingInfo.ga_generative_count * $e12b36903093d20d$var$ga_yield;
        this._netStakingYield += this._stakingInfo.ga_genesis_count * $e12b36903093d20d$var$ga_genesis_yield;
        this._netStakingYield += this._stakingInfo.galactic_monkes * $e12b36903093d20d$var$gm_yield;
    }
}
$e12b36903093d20d$var$StakingService._instance = new $e12b36903093d20d$var$StakingService();
var $e12b36903093d20d$export$2e2bcd8739ae039 = $e12b36903093d20d$var$StakingService;





class $6e6c794894cd1ac3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "HomebaseLoadingScene"
        });
    }
    preload() {
        const ignoreList = [
            "blob_room_door",
            "exit_room_door",
            "blob"
        ];
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255), ignoreList);
        this.load.spritesheet("blob_room_door", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).blob_room_door, {
            frameWidth: 168,
            frameHeight: 64,
            endFrame: 22
        });
        this.load.spritesheet("exit_room_door", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).exit_room_door, {
            frameWidth: 168,
            frameHeight: 64,
            endFrame: 22
        });
        this.load.spritesheet("blob", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).blob, {
            frameWidth: 51,
            frameHeight: 42,
            endFrame: 7
        });
        const config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        config.machines.forEach((machConfig)=>{
            if (machConfig.type === "animation") this.load.spritesheet(`${machConfig.key}_level_${machConfig.level}`, machConfig.filePath, {
                frameWidth: machConfig.frameWidth,
                frameHeight: machConfig.frameHeight,
                endFrame: machConfig.numFrames - 1
            });
        });
        this.load.audio("machines-button", "assets/audios/machines-button.wav");
    }
    create() {
        // Using this pattern to avoid blank screen delay between loading screens
        this.scene.stop("LoadingScene");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_bar");
        const text1 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 60, "homebase_loading_text");
        const prog1 = this.add.image(this.sys.canvas.width / 2 - 122, this.sys.canvas.height / 2 + 50, "loading_prog_1");
        const prog2 = this.add.image(this.sys.canvas.width / 2 - 73, this.sys.canvas.height / 2 + 50, "loading_prog_2");
        const prog3 = this.add.image(this.sys.canvas.width / 2 - 34, this.sys.canvas.height / 2 + 50, "loading_prog_3");
        const prog4 = this.add.image(this.sys.canvas.width / 2 - 13, this.sys.canvas.height / 2 + 50, "loading_prog_4");
        const prog5 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_5");
        prog1.alpha = 0;
        prog2.alpha = 0;
        prog3.alpha = 0;
        prog4.alpha = 0;
        prog5.alpha = 0;
        Promise.all([
            (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachines(),
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedReward(),
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus(),
            (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadFromMarketplace(),
            (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfo(undefined, undefined, 0, 30),
            (0, $643405a524e0a7c6$export$2e2bcd8739ae039).getInstance().getObjectives()
        ]).then(()=>(0, $c802003ad057a939$export$96f2a8cb44ca447b)(this, "HomebaseScene"));
        this.time.addEvent({
            delay: 300,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog1,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 600,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog1,
                    alpha: 0,
                    duration: 1000,
                    ease: "Power2"
                }, this);
                this.tweens.add({
                    targets: prog2,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 900,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog3,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 1200,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog4,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 1500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog5,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                }, this);
            }
        });
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480)));
    }
}




var $f1q41 = parcelRequire("f1q41");







const $c59f1da45881961a$var$machineUnitIds = {
    ars: 2,
    healer: 4,
    mercenary: 1,
    super_swole: 3
};
const $c59f1da45881961a$var$capacityUsedPerTroop = [
    0,
    1,
    1,
    10,
    20
];
class $c59f1da45881961a$var$TroopService {
    constructor(){
        if ($c59f1da45881961a$var$TroopService._instance) throw new Error("Error: Instantiation failed: Use TroopService.getInstance() instead of new.");
        $c59f1da45881961a$var$TroopService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this._troopsByMachine = {};
    }
    static getInstance() {
        return $c59f1da45881961a$var$TroopService._instance;
    }
    setTroopsByMachine(userMachineId, value) {
        this._troopsByMachine[userMachineId.toString()] = value;
        if (userMachineId === 0) this._army = value;
    }
    setTrainableTroopsByMachine(machineId, value) {
        this._trainableTroopsByMachine[machineId.toString()] = value;
    }
    // Get Troops
    getTroopsByMachine(userMachineId, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (!this._troopsByMachine) this._troopsByMachine = {};
            if (this._troopsByMachine[userMachineId.toString()] !== undefined && !forceUpdate) return resolve(this._troopsByMachine[userMachineId.toString()]);
            else return resolve(this.fetchTroopsByMachine(userMachineId));
        });
    }
    getTroopsByMachineSync(userMachineId) {
        return this._troopsByMachine[userMachineId.toString()];
    }
    fetchTroopsByMachine(userMachineId) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            wallet,
            "units",
            userMachineId
        ], []).then((res)=>{
            this.setTroopsByMachine(userMachineId, res.units);
            return this._troopsByMachine[userMachineId.toString()];
        });
    }
    // Train Troops
    trainTroops(userMachineId, troopLevel, numberOfUnits) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "units",
            "purchase",
            userMachineId,
            troopLevel,
            numberOfUnits
        ], []).then((res)=>{
            return res;
        });
    }
    // Remove Troop
    removeTroop(userMachineUnitId) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("machines", [
            wallet,
            "units",
            "remove",
            userMachineUnitId
        ], []).then((res)=>{
            return res;
        });
    }
    // Army
    getArmy(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._army !== undefined && !forceUpdate) return resolve(this._army);
            else return resolve(this.fetchArmy());
        });
    }
    getArmySync() {
        return this._army;
    }
    fetchArmy() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            wallet,
            "units",
            0
        ], []).then((res)=>{
            this.setTroopsByMachine(0, res.units);
            return this._army;
        });
    }
    //Trainable Troops
    getTrainableTroopsByMachine(userMachineId, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (!this._trainableTroopsByMachine) this._trainableTroopsByMachine = {};
            if (this._trainableTroopsByMachine[userMachineId.toString()] !== undefined && !forceUpdate) return resolve(this._trainableTroopsByMachine[userMachineId.toString()]);
            else return resolve(this.fetchTrainableTroopsByMachine(userMachineId));
        });
    }
    getTrainableTroopsByMachineSync(userMachineId) {
        return this._trainableTroopsByMachine[userMachineId.toString()];
    }
    fetchTrainableTroopsByMachine(machineId) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("machines", [
            "units",
            machineId
        ], []).then((res)=>{
            this.setTrainableTroopsByMachine(machineId, res.troops);
            return this._trainableTroopsByMachine[machineId.toString()];
        });
    }
    // Troop Count
    getTroopCapacityUsed() {
        if (!this._army || this._army.length === 0) return 0;
        var capacityUsed = 0;
        this._army.forEach((troop)=>{
            capacityUsed += $c59f1da45881961a$var$capacityUsedPerTroop[troop.machine_unit_id];
        });
        return capacityUsed;
    }
    getTroopCapacity(machine_unit_id) {
        return $c59f1da45881961a$var$capacityUsedPerTroop[machine_unit_id];
    }
    getTroopImageKey(machine_unit_id) {
        switch(machine_unit_id){
            case 1:
                return "troops_mercenary";
            case 2:
                return "troops_ars";
            case 3:
                return "troops_super_swole";
            case 4:
                return "troops_healer";
            default:
                return "wolf_silhouette";
        }
    }
    getTroopDisplayName(machine_unit_id) {
        switch(machine_unit_id){
            case 1:
                return "Mercenary";
            case 2:
                return "ARS";
            case 3:
                return "Super Swole";
            case 4:
                return "Healer";
            default:
                return "Unknown Soldier";
        }
    }
}
$c59f1da45881961a$var$TroopService._instance = new $c59f1da45881961a$var$TroopService();
var $c59f1da45881961a$export$2e2bcd8739ae039 = $c59f1da45881961a$var$TroopService;




const $7229471446732a65$var$cellWidth = 64;
const $7229471446732a65$var$upgradeProgressBarColor = 0xd3007f;
const $7229471446732a65$var$activeProgressBarColor = 0x32d96c; //0x21e968; //0xDEA827;
const $7229471446732a65$var$coolDownProgressBarColor = 0x00a6d3;
const $7229471446732a65$var$progressBarAlpha = 1;
const $7229471446732a65$var$glareColor = 0xffffff;
const $7229471446732a65$var$glareAlpha = 0.22;
const $7229471446732a65$var$glareRadius = 2;
const $7229471446732a65$var$glareHeight = 4;
const $7229471446732a65$var$glareOffset = 8;
const $7229471446732a65$var$backgroundColor = 0x0b0b1f;
const $7229471446732a65$var$backgroundAlpha = 0.4;
const $7229471446732a65$var$radius = 7;
const $7229471446732a65$var$progressBarHeight = 14;
const $7229471446732a65$var$progressBarWidth = 105;
const $7229471446732a65$var$progressMin = 0;
const $7229471446732a65$var$progressUpdateDelay = 30; //seconds
const $7229471446732a65$var$tintColor = 0xcdcdcd;
const $7229471446732a65$var$machineDestroyedTintColor = 0x202020;
const $7229471446732a65$var$currencyColors = {
    neon_gold: 0xffe100,
    space_elixir: 0x00d4f7,
    stardust: 0xedffa6
};
const $7229471446732a65$var$machineTypes = {
    mainframe: "mainframe",
    space_elixir_storage: "space_elixir_storage",
    space_elixir_mine: "space_elixir_mine",
    neon_gold_storage: "neon_gold_storage",
    neon_gold_mine: "neon_gold_mine",
    star_lab: "star_laboratory",
    mother_wolf_statue: "mother_wolf_statue",
    little_lemon_tree: "little_lemon_tree",
    space_elixir_accelerator: "space_elixir_accelerator",
    neon_gold_accelerator: "neon_gold_accelerator",
    kuma_ancestor_shrine: "kuma_ancestor_shrine"
};
const $7229471446732a65$var$progressBarTypes = {
    upgrade: "upgrade",
    active: "active",
    cool_down: "cool_down",
    none: "none"
};
const $7229471446732a65$var$trainingMachineIds = [
    // 1033, // Barracks
    // 1034, // Cadet Dorms
    1035,
    1036,
    1037,
    1038
];
const $7229471446732a65$var$troopsMachineIds = [
    1034
];
const $7229471446732a65$var$starLabActiveTime = 1800;
const $7229471446732a65$var$starLabMachineID = 1007;
class $7229471446732a65$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, cellX, cellY, machineData, buildProgressMultiplier, widthInTiles, config){
        let x = $7229471446732a65$var$cellWidth * cellX + $7229471446732a65$var$cellWidth * widthInTiles / 2;
        let y = $7229471446732a65$var$cellWidth * cellY + $7229471446732a65$var$cellWidth;
        let conf = config ? config : {
            x: x,
            y: y,
            width: $7229471446732a65$var$cellWidth,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            machine_info_spacing: {
                left: 10,
                right: 10,
                top: 5,
                bottom: 10
            }
        };
        super(scene, x, y, conf);
        this._scene = scene;
        this._cellX = cellX;
        this._cellY = cellY;
        this._machine = machineData;
        this._machineInfoSpacing = conf.machine_info_spacing;
        this._machineLevel = machineData.level || 1;
        this._progressBarType = this.getProgressBarType();
        this._progressMax = this.getProgressMax();
        this._isMaxLevel = !this._machine.next_level_build_total_time || this._machine.next_level_build_total_time <= 0;
        this._buildProgressMultiplier = buildProgressMultiplier;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        var self = this;
        // Machine Image
        this._machineImage = this.getMachineImage(scene);
        this.add(this._machineImage, {
            key: "machine_image",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
            this._machineImage.setAlpha(0.7);
        }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
            this._machineImage.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
            this._machineImage.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            this._machineImage.setAlpha(0.7);
            if (pointer.getDistance() > 16) return;
            if (!this._dialog) this.createDialog(scene, this._machineImage.getTopCenter().x, this._machineImage.getTopCenter().y - 3);
        });
        // Lightning Bolt
        this._destroyedBolt = this._scene.add.image(0, 0, "starwolvez_bolt_logo").setScale(0.5).setAlpha(0);
        this.add(this._destroyedBolt, {
            key: "bolt_image",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Progress Bar
        this.handleProgressBar(scene);
        scene.input.setDraggable(this);
        this.layout();
        this.alignBottom(y);
    // this.drawBounds(scene.add.graphics(), 0xff0000);
    }
    getMachineImage(scene) {
        var _a;
        var machineAni = this._config.machines.find((mach)=>{
            var level = this._machine.level === 0 ? 1 : this._machine.level;
            return mach.key === this._machine.key && mach.level === level;
        });
        if (!machineAni) {
            // No config found for this machine/level.  Use highest level image available.
            var matchingMachines = (_a = this._config.machines.filter((mach)=>{
                return mach.key === this._machine.key;
            })) === null || _a === void 0 ? void 0 : _a.sort((a, b)=>{
                if (a.level < b.level) return 1;
                if (a.level > b.level) return -1;
                return 0;
            });
            if (matchingMachines.length > 0) machineAni = matchingMachines[0];
        }
        if (machineAni.type === "animation") {
            var keyWithLevel = `${machineAni.key}_level_${machineAni.level}`;
            var animationConfig = {
                key: `${keyWithLevel}_animation`,
                frames: scene.anims.generateFrameNumbers(keyWithLevel, {
                    start: 0,
                    end: machineAni.numFrames - 1,
                    first: 0
                }),
                frameRate: machineAni.frameRate,
                repeat: machineAni.repeat,
                repeatDelay: machineAni.repeatDelay
            };
            scene.anims.create(animationConfig);
            return scene.physics.add.sprite(0, 0, keyWithLevel).setOrigin(0.5, 1).play(`${keyWithLevel}_animation`);
        } else {
            // Applies Skin
            if (this._machine.has_skin === 1 && !machineAni.imageKey.includes("_skin")) machineAni.imageKey = machineAni.imageKey + "_skin";
            return scene.physics.add.sprite(0, 0, machineAni.imageKey).setOrigin(0.5, 1);
        }
    }
    handleProgressBar(scene) {
        switch(this._progressBarType){
            case $7229471446732a65$var$progressBarTypes.upgrade:
                this.createProgressBar(scene, $7229471446732a65$var$progressBarTypes.upgrade);
                this._updateTimeEvent = scene.time.addEvent({
                    delay: $7229471446732a65$var$progressUpdateDelay * 1000,
                    callback: this.updateTimeHandler,
                    callbackScope: this,
                    loop: true
                });
                this.updateProgress(this._machine.star_lab_adjusted_time_until_next_level, $7229471446732a65$var$progressBarTypes.upgrade);
                break;
            case $7229471446732a65$var$progressBarTypes.active:
                this.createProgressBar(scene, $7229471446732a65$var$progressBarTypes.active);
                this._updateTimeEvent = scene.time.addEvent({
                    delay: $7229471446732a65$var$progressUpdateDelay * 1000,
                    callback: this.updateActiveTimeHandler,
                    callbackScope: this,
                    loop: true
                });
                break;
            case $7229471446732a65$var$progressBarTypes.cool_down:
                this._machine.cool_down_time_remaining = this.getRemainingCoolDownTime(this._machine);
                this.createProgressBar(scene, $7229471446732a65$var$progressBarTypes.cool_down);
                this._updateTimeEvent = scene.time.addEvent({
                    delay: $7229471446732a65$var$progressUpdateDelay * 1000,
                    callback: this.updateCoolDownTimeHandler,
                    callbackScope: this,
                    loop: true
                });
                break;
            default:
                return;
        }
    }
    getProgressBarType() {
        const slatunl = this._machine.star_lab_adjusted_time_until_next_level;
        const tui = this._machine.time_until_inactive;
        const cdt = this._machine.cool_down_time;
        const isUpgrade = this._machine.star_lab_adjusted_time_until_next_level && this._machine.star_lab_adjusted_time_until_next_level > 0;
        const isActive = this._machine.time_until_inactive && this._machine.time_until_inactive > 0;
        const isCoolDown = this._machine.cool_down_time && this.getRemainingCoolDownTime(this._machine) > 0;
        return isActive ? $7229471446732a65$var$progressBarTypes.active : isCoolDown ? $7229471446732a65$var$progressBarTypes.cool_down : isUpgrade ? $7229471446732a65$var$progressBarTypes.upgrade : $7229471446732a65$var$progressBarTypes.none;
    }
    getProgressMax() {
        switch(this._progressBarType){
            case $7229471446732a65$var$progressBarTypes.upgrade:
                return this._machine.next_level_build_total_time;
            case $7229471446732a65$var$progressBarTypes.active:
                return $7229471446732a65$var$starLabActiveTime;
            case $7229471446732a65$var$progressBarTypes.cool_down:
                return this._machine.cool_down_time;
            default:
                return;
        }
    }
    createProgressBar(scene, type) {
        let config;
        switch(type){
            case $7229471446732a65$var$progressBarTypes.upgrade:
                config = {
                    progressValue: this._progressMax - parseInt(this._machine.star_lab_adjusted_time_until_next_level),
                    titleText: this._machine.star_lab_adjusted_time_until_next_level,
                    color: $7229471446732a65$var$upgradeProgressBarColor
                };
                break;
            case $7229471446732a65$var$progressBarTypes.active:
                config = {
                    progressValue: this._machine.time_until_inactive,
                    titleText: this._machine.time_until_inactive,
                    color: $7229471446732a65$var$activeProgressBarColor
                };
                break;
            case $7229471446732a65$var$progressBarTypes.cool_down:
                config = {
                    progressValue: this._machine.cool_down_time_remaining,
                    titleText: this._machine.cool_down_time_remaining,
                    color: $7229471446732a65$var$coolDownProgressBarColor
                };
                break;
        }
        if (!config) return;
        // Progress Bar
        this._progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: this.secondsToTime(config.titleText),
                fontStyle: null
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $7229471446732a65$var$progressBarWidth,
                height: $7229471446732a65$var$progressBarHeight,
                radius: $7229471446732a65$var$radius,
                color: config.color,
                alpha: $7229471446732a65$var$progressBarAlpha,
                backgroundColor: $7229471446732a65$var$backgroundColor,
                backgroundAlpha: $7229471446732a65$var$backgroundAlpha,
                minValue: $7229471446732a65$var$progressMin,
                maxValue: this._progressMax,
                progressValue: config.progressValue,
                glare: {
                    height: $7229471446732a65$var$glareHeight,
                    width: $7229471446732a65$var$progressBarWidth - $7229471446732a65$var$glareOffset,
                    radius: $7229471446732a65$var$glareRadius,
                    color: $7229471446732a65$var$glareColor,
                    alpha: $7229471446732a65$var$glareAlpha
                }
            }
        });
        scene.add.existing(this._progressBar);
        this._progressBar.setDepth(this.depth);
        this.add(this._progressBar, {
            key: "machine_progress_bar",
            align: "center-top",
            offsetX: 0,
            offsetY: -25,
            expand: false
        }).layout();
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? `${h}H` : "";
        var mDisplay = m > 0 ? `${m}M` : "";
        // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        if (h === 0 && m === 0 && s > 0) return "< 1m";
        return h > 0 ? `${hDisplay} ${mDisplay}` : mDisplay;
    }
    updateTimeHandler() {
        const timeReduction = $7229471446732a65$var$progressUpdateDelay * this._buildProgressMultiplier;
        this._machine.star_lab_adjusted_time_until_next_level = this._machine.star_lab_adjusted_time_until_next_level - timeReduction;
        if (this._machine.star_lab_adjusted_time_until_next_level <= 0) {
            this._updateTimeEvent.remove(false); // false = don't call this function again
            this.removeProgressBar();
            this.scene.scene.get("HomebaseScene").updateMachines();
        } else {
            let progressValue = this._machine.star_lab_adjusted_time_until_next_level;
            this.updateProgress(progressValue, $7229471446732a65$var$progressBarTypes.upgrade);
        }
    }
    updateActiveTimeHandler() {
        this._machine.time_until_inactive = this._machine.time_until_inactive - $7229471446732a65$var$progressUpdateDelay;
        if (this._machine.time_until_inactive <= 0) {
            this._updateTimeEvent.remove(false); // false = don't call this function again
            this.removeProgressBar();
            this.scene.scene.get("HomebaseScene").updateMachines(true);
        } else {
            let progressValue = this._machine.time_until_inactive;
            this.updateProgress(progressValue, $7229471446732a65$var$progressBarTypes.active);
        }
    }
    updateCoolDownTimeHandler() {
        this._machine.cool_down_time_remaining = this._machine.cool_down_time_remaining - $7229471446732a65$var$progressUpdateDelay;
        if (this._machine.cool_down_time_remaining <= 0) {
            this._updateTimeEvent.remove(false); // false = don't call this function again
            this.removeProgressBar();
            this.scene.scene.get("HomebaseScene").updateMachines(true);
        } else {
            let progressValue = this._machine.cool_down_time_remaining;
            this.updateProgress(progressValue, $7229471446732a65$var$progressBarTypes.cool_down);
        }
    }
    updateProgressText(type) {
        let value = type === $7229471446732a65$var$progressBarTypes.upgrade ? this._machine.star_lab_adjusted_time_until_next_level : this._machine.time_until_inactive;
        switch(type){
            case $7229471446732a65$var$progressBarTypes.upgrade:
                value = this._machine.star_lab_adjusted_time_until_next_level;
                break;
            case $7229471446732a65$var$progressBarTypes.active:
                value = this._machine.time_until_inactive;
                break;
            case $7229471446732a65$var$progressBarTypes.cool_down:
                value = this._machine.cool_down_time_remaining;
                break;
            default:
                return;
        }
        this._progressBar.setTitle(this.secondsToTime(value));
    }
    updateProgress(progressValue, type) {
        this._progressBar.setProgress(this._scene, progressValue > 0 ? progressValue : 1);
        this.updateProgressText(type);
    }
    getRemainingCoolDownTime(machine) {
        const cdt = machine.cool_down_time;
        const now = Math.floor(Date.now() / 1000);
        const la = machine.last_activated;
        const elapsedTime = now - la;
        var remainingTime = cdt - elapsedTime;
        // Account for length of time starLab is active
        if (machine.machine_id === $7229471446732a65$var$starLabMachineID) remainingTime = remainingTime + $7229471446732a65$var$starLabActiveTime;
        return remainingTime > 0 ? remainingTime : 0;
    }
    createDialog(scene, x, y) {
        this._dialog = scene.rexUI.add.dialog({
            x: x,
            y: y,
            //width: 200,
            background: scene.rexUI.add.roundRectangle(0, 0, 100, 100, 16, 0x201425).setAlpha(0.7).setStrokeStyle(2, 0x000000, 0.9).setInteractive(),
            title: this.createTitle(scene, this.getMachineTitle()),
            //content: this.createContent(scene),//this.createTitle(scene, `Level: ${this._machine.level}\n\nYield: N/A\n\nStorage: N/A`, 18, 0.4),
            //description: this.createTitle(scene, 'Yield: N/A\nStorage: N/A', 18, 0.4),
            actions: this.getActions(scene, this._machine.key === $7229471446732a65$var$machineTypes.star_lab || this._machine.key === $7229471446732a65$var$machineTypes.neon_gold_accelerator || this._machine.key === $7229471446732a65$var$machineTypes.space_elixir_accelerator, this._machine.key === $7229471446732a65$var$machineTypes.little_lemon_tree || this._machine.key === $7229471446732a65$var$machineTypes.mother_wolf_statue || this._machine.key === $7229471446732a65$var$machineTypes.kuma_ancestor_shrine),
            // actions: [
            //     this.createButton(scene, 'Action0'),
            //     this.createButton(scene, 'Action1')
            // ],
            space: {
                left: this._machineInfoSpacing.left,
                right: this._machineInfoSpacing.right,
                top: this._machineInfoSpacing.top,
                bottom: this._machineInfoSpacing.bottom,
                title: 10,
                // titleLeft: 30,
                //titleBottom: 20,
                //content: 20,
                //contentLeft: 10,
                //description: 20,
                //descriptionLeft: 10,
                // descriptionRight: 20,
                //descriptionBottom: 20,
                //choices: 20,
                actions: 10,
                //toolbarItem: 5,
                //choice: 15,
                action: 10
            },
            expand: {
                title: false,
                // content: false,
                // description: true,
                choices: false,
                actions: false
            },
            align: {
                title: "center",
                content: "left",
                description: "left",
                choices: "center",
                actions: "center"
            },
            click: {
                mode: "release"
            }
        }).setOrigin(0.5, 1).setDepth(1000)//.setDraggable('background')   // Draggable-background
        .layout()// .drawBounds(this.add.graphics(), 0xff0000)
        .popUp(200);
        var tween = scene.tweens.add({
            targets: this._dialog,
            scaleX: 1,
            scaleY: 1,
            ease: "Bounce",
            duration: 200,
            repeat: 0,
            yoyo: false
        });
        scene.input.on("pointerdown", function(pointer) {
            if (this._dialog && !this._dialog.isInTouching(pointer)) {
                this._dialog.scaleDownDestroy(100);
                this._dialog = undefined;
            }
        }, this);
    }
    getMachineTitle() {
        if (this._machine.key === "tournament_one_competitor_trophy" || this._machine.key === "discord_airdrop_trophy") return this._machine.display_name.toUpperCase();
        return `${this._machine.display_name.toUpperCase()} (LEVEL ${this._machine.level})`;
    }
    createButton(scene, text, wrap) {
        var background = scene.rexUI.add.roundRectangle(0, 0, 100, 40, 10, 0x6501b4);
        var textObj = scene.add.bitmapText(0, 0, "cc_outline", text, 20);
        if (wrap) textObj = scene.rexUI.wrapExpandText(textObj);
        const label = scene.rexUI.add.label({
            width: 40,
            height: 40,
            background: background,
            text: textObj,
            //expandTextWidth: wrap,
            align: "center",
            space: {
                left: 10,
                right: 10,
                top: 12,
                bottom: 10
            }
        });
        if (this._machine.star_lab_adjusted_time_until_next_level && this._machine.star_lab_adjusted_time_until_next_level > 0) {
            label.setText("Upgrading...");
            label.disableInteractive();
        } else label.setInteractive({
            cursor: "pointer"
        });
        return label;
    }
    getActions(scene, canActivate, canClaim) {
        let actions = [];
        // Info
        actions.push(this.createInfoButton(scene));
        if (this._machine.star_lab_adjusted_time_until_next_level > 0) // Speed Up
        actions.push(this.createSpeedUpButton(scene));
        else // Upgrade
        actions.push(this.createUpgradeButton(scene));
        // Activate
        if (canActivate) actions.push(this.createActivateButton(scene));
        // Claim
        if (canClaim) actions.push(this.createClaimButton(scene));
        // Train
        if ($7229471446732a65$var$trainingMachineIds.includes(this._machine.machine_id)) actions.push(this.createTrainButton(scene));
        // Troops
        if ($7229471446732a65$var$troopsMachineIds.includes(this._machine.machine_id)) actions.push(this.createTroopsButton(scene));
        return actions;
    }
    createInfoButton(scene) {
        var infoButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_info_button", false);
        scene.add.existing(infoButton);
        infoButton.onClick().subscribe((pointer)=>{
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            scene.scene.pause("HudScene");
            scene.scene.get("HomebaseScene").input.enabled = false;
            scene.scene.launch("MachineUpgradeModalScene", {
                userMachine: this._machine
            });
        });
        return infoButton;
    }
    createUpgradeButton(scene) {
        var upgradeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_upgrade_button", false);
        scene.add.existing(upgradeButton);
        if (this._isMaxLevel || this._machine.star_lab_adjusted_time_until_next_level > 0 || this._machine.time_until_inactive > 0) {
            upgradeButton.setDisabled(true);
            upgradeButton.setAlpha(0.5);
        } else upgradeButton.onClick().subscribe((pointer)=>{
            upgradeButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            scene.scene.pause("HudScene");
            scene.scene.get("HomebaseScene").input.enabled = false;
            scene.scene.launch("ShopPurchaseConfirmScene", {
                item: this._machine,
                isUpgrade: true
            });
        });
        return upgradeButton;
    }
    createSpeedUpButton(scene) {
        var speedUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_speed_up_button", false);
        scene.add.existing(speedUpButton);
        speedUpButton.onClick().subscribe((pointer)=>{
            speedUpButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            scene.scene.get("HomebaseScene").input.enabled = false;
            scene.scene.pause("HudScene");
            scene.scene.launch("MachineSpeedUpModalScene", {
                machine: this._machine,
                homebaseMachine: this
            });
        });
        return speedUpButton;
    }
    createActivateButton(scene) {
        var activateButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_activate_button", false);
        scene.add.existing(activateButton);
        if (this._machine.time_until_inactive > 0 || this.getRemainingCoolDownTime(this._machine) > 0) {
            activateButton.setDisabled(true);
            activateButton.setAlpha(0.5);
        } else activateButton.onClick().subscribe((pointer)=>{
            activateButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().activateMachine(this._machine.user_machine_id).then((res)=>{
                scene.scene.get("HomebaseScene").input.enabled = false;
                scene.scene.pause("HudScene");
                scene.scene.launch("ShopPurchaseResultScene", {
                    purchaseResult: res,
                    item: this._machine,
                    itemType: "machine_activation"
                });
            });
        });
        return activateButton;
    }
    createClaimButton(scene) {
        var claimButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_claim_button", false);
        scene.add.existing(claimButton);
        if (this._machine.cool_down_time_remaining > 0) {
            claimButton.setDisabled(true);
            claimButton.setAlpha(0.5);
        } else claimButton.onClick().subscribe((pointer)=>{
            claimButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().claimResources(this._machine.user_machine_id).then((res)=>{
                scene.scene.get("HomebaseScene").input.enabled = false;
                scene.scene.pause("HudScene");
                scene.scene.launch("ShopPurchaseResultScene", {
                    purchaseResult: res,
                    item: this._machine,
                    itemType: "machine_claim"
                });
            });
        });
        return claimButton;
    }
    createTrainButton(scene) {
        var trainButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_train_button", false);
        scene.add.existing(trainButton);
        trainButton.onClick().subscribe((pointer)=>{
            trainButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            scene.scene.get("HomebaseScene").input.enabled = false;
            scene.scene.pause("HudScene");
            scene.scene.launch("ArmyModalScene", {
                machine: {
                    user_machine_id: 0,
                    machine_id: 0
                }
            });
        });
        return trainButton;
    }
    createTroopsButton(scene) {
        var troopsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "machine_troops_button", false);
        scene.add.existing(troopsButton);
        troopsButton.onClick().subscribe((pointer)=>{
            troopsButton.setDisabled(true);
            this._dialog.scaleDownDestroy(10);
            this._dialog = undefined;
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(0, true).then((res)=>{
                (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTrainableTroopsByMachine(0).then((tt)=>{
                    scene.scene.get("HomebaseScene").input.enabled = false;
                    scene.scene.pause("HudScene");
                    scene.scene.launch("ArmyModalScene", {
                        machine: {
                            user_machine_id: 0,
                            machine_id: 0
                        },
                        tab: "army"
                    });
                });
            });
        });
        return troopsButton;
    }
    createTitle(scene, text, fontSize, textAlpha, wrap) {
        fontSize = fontSize || 14;
        textAlpha = textAlpha || 1;
        var textObj = scene.add.bitmapText(0, 0, "cc_outline", text, fontSize).setAlpha(textAlpha);
        return scene.rexUI.add.label({
            width: 120,
            text: textObj,
            expandTextWidth: wrap,
            align: "center",
            space: {
                left: 0,
                right: 0,
                top: 8,
                bottom: 0
            }
        });
    }
    getMachine() {
        return this._machine;
    }
    setCell(cellX, cellY) {
        this._cellX = cellX;
        this._cellY = cellY;
    }
    updateMachineImage(scene, alignY) {
        var _a;
        // Stop sprite
        this._machineImage.stop();
        // Get Machine Image config
        var machineAni = this._config.machines.find((mach)=>{
            var level = this._machine.level === 0 ? 1 : this._machine.level;
            return mach.key === this._machine.key && mach.level === level;
        });
        if (!machineAni) {
            // No config found for this machine/level.  Use highest level image available.
            var fallbackConfig;
            var matchingMachines = (_a = this._config.machines.filter((mach)=>{
                return mach.key === this._machine.key;
            })) === null || _a === void 0 ? void 0 : _a.sort((a, b)=>{
                if (a.level < b.level) return 1;
                if (a.level > b.level) return -1;
                return 0;
            });
            if (matchingMachines.length > 0) fallbackConfig = matchingMachines[0];
            if (fallbackConfig.type === "animation") this.setAnimation(scene, fallbackConfig);
            else this._machineImage.setTexture(fallbackConfig.imageKey);
        } else if (machineAni.type === "animation") this.setAnimation(scene, machineAni);
        else this._machineImage.setTexture(machineAni.imageKey);
        this.layout();
        if (alignY) this.alignBottom($7229471446732a65$var$cellWidth * this._cellY + $7229471446732a65$var$cellWidth);
    // this.drawBounds(scene.add.graphics(), 0xffffff);
    }
    setAnimation(scene, machineAni) {
        var keyWithLevel = `${machineAni.key}_level_${machineAni.level}`;
        var animationConfig = {
            key: `${keyWithLevel}_animation`,
            frames: scene.anims.generateFrameNumbers(keyWithLevel, {
                start: 0,
                end: machineAni.numFrames - 1,
                first: 0
            }),
            frameRate: machineAni.frameRate,
            repeat: machineAni.repeat,
            repeatDelay: machineAni.repeatDelay
        };
        scene.anims.create(animationConfig);
        this._machineImage.setTexture(keyWithLevel)//.setOrigin(0.5, 1)
        .play(`${keyWithLevel}_animation`);
    }
    removeProgressBar() {
        if (this._progressBar) {
            this._progressBar.setAlpha(0);
            this.remove(this._progressBar);
            this._progressBar.destroy();
            this._progressBar = undefined;
        // this.layout();
        }
    }
    handleUpdate(machineData, buildProgressMultiplier, isDragging) {
        if (machineData) {
            // Perform equality checks
            const shouldUpdateImage = this._machine.level !== machineData.level;
            var shouldCreateProgBar = false;
            var shouldRemoveProgBar = false;
            const new_slatunl = machineData.star_lab_adjusted_time_until_next_level;
            const new_tui = machineData.time_until_inactive;
            const new_cdt = this.getRemainingCoolDownTime(machineData);
            if ((new_tui && new_tui > 0 || new_slatunl && new_slatunl > 0 || new_cdt && new_cdt > 0) && !this._progressBar) shouldCreateProgBar = true;
            if ((!new_tui || new_tui === 0) && (!new_slatunl || new_slatunl === 0) && (!new_cdt || new_cdt === 0) && this._progressBar) shouldRemoveProgBar = true;
            // Set new machine data
            this._machine = machineData;
            this._machineLevel = machineData.level || 1;
            this._progressBarType = this.getProgressBarType();
            this._progressMax = this.getProgressMax();
            this._buildProgressMultiplier = buildProgressMultiplier;
            this._machine.cool_down_time_remaining = this.getRemainingCoolDownTime(this._machine);
            this._isMaxLevel = !this._machine.next_level_build_total_time || this._machine.next_level_build_total_time <= 0;
            // Perform necessary updates
            if (shouldUpdateImage) this.updateMachineImage(this._scene, true);
            if (shouldRemoveProgBar) {
                this._progressBarType = this.getProgressBarType();
                this.removeProgressBar();
            }
            if (shouldCreateProgBar) this.handleProgressBar(this._scene);
        }
    }
    setDestroyed(isDestroyed) {
        if (isDestroyed) {
            this._machineImage.setTint($7229471446732a65$var$machineDestroyedTintColor);
            this._machineImage.stop();
            this._destroyedBolt.setAlpha(1);
        } else {
            this._machineImage.clearTint();
            this._machineImage.anims.restart();
            this._destroyedBolt.setAlpha(0);
        }
        this.layout();
    }
    removeTimeEvents() {
        this._updateTimeEvent.remove(false);
    }
    destroy() {
        if (this) this.setAlpha(0);
        if (this._updateTimeEvent) this._updateTimeEvent.remove(false);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("homebaseMachine", function(x, y, machineData, widthInTiles, config) {
    // @ts-ignore
    return this.displayList.add(new $7229471446732a65$export$2e2bcd8739ae039(this.scene, x, y, machineData, widthInTiles, config));
});





class $eabaecde5116ddd1$var$BlobService {
    constructor(){
        this._blobInfo = [];
        if ($eabaecde5116ddd1$var$BlobService._instance) throw new Error("Error: Instantiation failed: Use BlobService.getInstance() instead of new.");
        $eabaecde5116ddd1$var$BlobService._instance = this;
    }
    static getInstance() {
        return $eabaecde5116ddd1$var$BlobService._instance;
    }
    setBlobInfo(value) {
        this._blobInfo = value;
    }
    getBlobInfo(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._blobInfo && !forceUpdate) return resolve(this._blobInfo);
            else return resolve(this.fetchBlobInfo());
        });
    }
    getBlobInfoSync() {
        return this._blobInfo;
    }
    performAction(actionId) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("blobs", [
            wallet,
            "action",
            "start",
            actionId
        ], {}).then((res)=>{
            return res;
        });
    }
    fetchBlobInfo() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("blobs", [
            wallet
        ], []).then((res)=>{
            this._blobInfo = res.blob;
            return res;
        });
    }
}
$eabaecde5116ddd1$var$BlobService._instance = new $eabaecde5116ddd1$var$BlobService();
var $eabaecde5116ddd1$export$2e2bcd8739ae039 = $eabaecde5116ddd1$var$BlobService;





class $04c1bebe09f3da3c$var$BaseRaidService {
    constructor(){
        if ($04c1bebe09f3da3c$var$BaseRaidService._instance) throw new Error(`Error: Instatiation failed: use ${$04c1bebe09f3da3c$var$BaseRaidService.name}.getInstance() instead of new.`);
        $04c1bebe09f3da3c$var$BaseRaidService._instance = this;
    }
    static getInstance() {
        return $04c1bebe09f3da3c$var$BaseRaidService._instance;
    }
    getRandomBase(next) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("base_raid", [
            address,
            "view_bases"
        ], {
            next: next
        }).then((res)=>{
            return res;
        });
    }
    startAttack(defender_address) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("base_raid", [
            address,
            "attack",
            defender_address
        ], {}).then((res)=>{
            return res;
        });
    }
    surrenderAttack() {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("base_raid", [
            address,
            "surrender"
        ], {}).then((res)=>{
            return res;
        });
    }
    viewAttack(userViewed = false) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        if (userViewed) return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("base_raid", [
            address,
            "view_attack"
        ], {}, [
            `user_viewed=${userViewed}`
        ]).then((res)=>{
            return res;
        });
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("base_raid", [
            address,
            "view_attack"
        ], {}).then((res)=>{
            this.attackInfo = res;
            return res;
        });
    }
    viewAttackSync() {
        return this.attackInfo;
    }
    getRaidHistory(maxResults) {
        const address = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        const numRequested = maxResults || 100;
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("base_raid", [
            address,
            "history",
            numRequested.toString()
        ], {}).then((res)=>{
            this.raidHistory = res.base_raid_results;
            return res;
        });
    }
    getRaidHistorySync() {
        return this.raidHistory;
    }
}
$04c1bebe09f3da3c$var$BaseRaidService._instance = new $04c1bebe09f3da3c$var$BaseRaidService();
var $04c1bebe09f3da3c$export$2e2bcd8739ae039 = $04c1bebe09f3da3c$var$BaseRaidService;




const $8d346123ca66a5ed$var$cellWidth = 64;
const $8d346123ca66a5ed$var$halfCellWidth = 32;
const $8d346123ca66a5ed$var$starLabMachineId = 1007;
const $8d346123ca66a5ed$var$starLabMultipliers = [
    0,
    1.5,
    3,
    4.5,
    6,
    7.5,
    10
];
class $8d346123ca66a5ed$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(key){
        if (!key) key = "HomebaseScene";
        super(key);
        this.sceneRunning = null;
    }
    preload() {}
    create() {
        this.createComponent();
    }
    createComponent() {
        this.input.mouse.disableContextMenu();
        // Set Background
        document.body.style.backgroundImage = "none";
        this.events.on("shutdown", ()=>{
            // Set Background
            //document.body.style.backgroundImage = "url('../assets/sw_bg.png')";
            document.body.style.backgroundRepeat = "repeat";
            document.body.style.backgroundSize = "auto";
        });
        this._zoomMin = 0.4;
        this._zoomMax = 1.6;
        this._inBlobRoom = false;
        this._map = this.make.tilemap({
            key: "homebase_map"
        });
        this._tileset = this._map.addTilesetImage("homebase_tileset_64", "tiles", 64, 64, 1, 2);
        this._blobLayer = this._map.createLayer("Blob Layer", this._tileset);
        this._blobLayer.setAlpha(0.5);
        this._baseLayer = this._map.createLayer("Tile Layer 1", this._tileset);
        this.addBlobRoomDoor();
        this._userMachines = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync();
        this._machineObjects = [];
        this._machineGroup = this.physics.add.group();
        this._machineConfigs = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().machines;
        this.createMachines();
        this.cameras.main.setBounds(-200, 440, this._map.widthInPixels + 400, this._map.heightInPixels - 200);
        // Handle keyboard arrows
        this.cursors = this.input.keyboard.createCursorKeys();
        // Handle homebase drag
        this.input.on("pointermove", function(p) {
            if (!p.isDown || this._isDragging) return;
            this.cameras.main.scrollX -= (p.x - p.prevPosition.x) / this.cameras.main.zoom;
            this.cameras.main.scrollY -= (p.y - p.prevPosition.y) / this.cameras.main.zoom;
        }, this);
        // Handle machine drag
        this.input.on("dragstart", (pointer, gameObject, dragX, dragY)=>{
            this._isDragging = true;
            const widthInTiles = this.getWidthInTiles(gameObject.getMachine());
            const heightInTiles = this.getHeightInTiles(gameObject.getMachine());
            this._dragStartCell = this._map.getTileAtWorldXY(gameObject.getBottomCenter().x - $8d346123ca66a5ed$var$halfCellWidth * (widthInTiles - 1), gameObject.getBottomCenter().y - $8d346123ca66a5ed$var$halfCellWidth);
            for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                var coveredTile = this._map.getTileAt(this._dragStartCell.x + i, this._dragStartCell.y - h);
                if (coveredTile && coveredTile.properties.buildable) coveredTile.properties.isOccupied = false;
            }
        }, this);
        this.input.on("drag", (pointer, gameObject, dragX, dragY)=>{
            gameObject.x = dragX;
            gameObject.y = dragY;
            const widthInTiles = this.getWidthInTiles(gameObject.getMachine());
            const heightInTiles = this.getHeightInTiles(gameObject.getMachine());
            const tile = this._map.getTileAtWorldXY(gameObject.getBottomCenter().x - $8d346123ca66a5ed$var$halfCellWidth * (widthInTiles - 1), gameObject.getBottomCenter().y - $8d346123ca66a5ed$var$halfCellWidth);
            if (tile) gameObject.setDepth(tile.y);
            this._dragOverCell = this._dragOverCell || tile;
            if (!tile || !this._dragOverCell || this._dragOverCell.x === tile.x && this._dragOverCell.y === tile.y) return;
            if (this._dragOverCell.properties.buildable) {
                this._dragOverCell.index = 31;
                // Check for all tiles covered
                for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                    var coveredTile = this._map.getTileAt(this._dragOverCell.x + i, this._dragOverCell.y - h);
                    if (coveredTile && coveredTile.properties.buildable) coveredTile.index = 31;
                }
            }
            if (tile.properties.buildable && !this.isTileOccupied(tile, gameObject.getMachine())) {
                // Check for extra tiles for machines that are more than 1 tile wide
                var allTilesCovered = [];
                for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                    var coveredTile = this._map.getTileAt(tile.x + i, tile.y - h);
                    allTilesCovered.push(coveredTile);
                }
                var allBuildable = true;
                allTilesCovered.forEach((coveredTile)=>{
                    if (!coveredTile.properties.buildable || this.isTileOccupied(coveredTile, gameObject.getMachine())) allBuildable = false;
                });
                // All tiles are buildable
                if (allBuildable) {
                    tile.index = 27;
                    this._dragOverCell = tile;
                    allTilesCovered.forEach((coveredTile)=>{
                        coveredTile.index = 27;
                    });
                }
            }
        }, this);
        this.input.on("dragend", (pointer, gameObject, dragX, dragY)=>{
            this._isDragging = false;
            const widthInTiles = this.getWidthInTiles(gameObject.getMachine());
            const heightInTiles = this.getHeightInTiles(gameObject.getMachine());
            const endTile = this._map.getTileAtWorldXY(gameObject.getBottomCenter().x - $8d346123ca66a5ed$var$halfCellWidth * (widthInTiles - 1), gameObject.getBottomCenter().y - $8d346123ca66a5ed$var$halfCellWidth);
            var coveredTiles = [];
            var allBuildable = true;
            if (endTile) {
                for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                    var coveredTile = this._map.getTileAt(endTile.x + i, endTile.y - h);
                    if (coveredTile) {
                        coveredTiles.push(coveredTile);
                        if (!coveredTile.properties.buildable || this.isTileOccupied(coveredTile, gameObject.getMachine())) allBuildable = false;
                    }
                }
            }
            if (endTile && endTile.properties.buildable && allBuildable) {
                endTile.index = 31;
                endTile.properties.isOccupied = true;
                coveredTiles.forEach((coveredTile)=>{
                    if (coveredTile && coveredTile.properties.buildable) {
                        coveredTile.index = 31;
                        coveredTile.properties.isOccupied = true;
                    }
                });
                gameObject.x = $8d346123ca66a5ed$var$cellWidth * endTile.x + $8d346123ca66a5ed$var$cellWidth * widthInTiles / 2;
                gameObject.setCell(endTile.x, endTile.y);
                gameObject.alignBottom($8d346123ca66a5ed$var$cellWidth * endTile.y + $8d346123ca66a5ed$var$cellWidth);
                gameObject.setDepth(endTile.y);
                const machine = gameObject.getMachine();
                (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().updateMachinePosition(machine.user_machine_id, endTile.x, endTile.y);
                let userMachine = this._userMachines.find((um)=>um.user_machine_id === machine.user_machine_id);
                if (userMachine) {
                    userMachine.x = endTile.x;
                    userMachine.y = endTile.y;
                }
            } else {
                gameObject.x = $8d346123ca66a5ed$var$cellWidth * this._dragStartCell.x + $8d346123ca66a5ed$var$cellWidth * widthInTiles / 2;
                gameObject.alignBottom($8d346123ca66a5ed$var$cellWidth * this._dragStartCell.y + $8d346123ca66a5ed$var$cellWidth);
                for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                    var coveredTile = this._map.getTileAt(this._dragStartCell.x + i, this._dragStartCell.y - h);
                    if (coveredTile && coveredTile.properties.buildable) coveredTile.properties.isOccupied = true;
                }
                this._dragStartCell = undefined;
            }
        }, this);
        // Handle scroll/zoom
        this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ)=>{
            if (deltaY > 0) {
                var newZoom = this.cameras.main.zoom - 0.1;
                if (newZoom > this._zoomMin) this.cameras.main.setZoom(newZoom);
            }
            if (deltaY < 0) {
                var newZoom = this.cameras.main.zoom + 0.1;
                if (newZoom < this._zoomMax) this.cameras.main.setZoom(newZoom);
            }
        });
        // Handles homebase resume event
        this.events.on("resume", (scene, data)=>{
            this.updateMachines(true);
        });
        // Display HUD
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((res)=>{
            this.launchScene("HudScene", undefined);
        });
    }
    update() {
        if (this.cursors.up.isDown) this.cameras.main.scrollY -= 10 / this.cameras.main.zoom;
        else if (this.cursors.down.isDown) this.cameras.main.scrollY += 10 / this.cameras.main.zoom;
        if (this.cursors.left.isDown) this.cameras.main.scrollX -= 10 / this.cameras.main.zoom;
        else if (this.cursors.right.isDown) this.cameras.main.scrollX += 10 / this.cameras.main.zoom;
    }
    getWidthInTiles(machine) {
        var machineConfig = this._machineConfigs.find((conf)=>conf.key === machine.key && conf.level === machine.level);
        if (!machineConfig) {
            var machinesOfSameType = this._machineConfigs.filter((conf)=>conf.key === machine.key);
            if (machinesOfSameType.length > 0) machineConfig = machine.level === 0 ? machinesOfSameType[0] : machinesOfSameType[machinesOfSameType.length - 1];
        }
        return machineConfig ? machineConfig.baseCellWidth : 1;
    }
    getHeightInTiles(machine) {
        var machineConfig = this._machineConfigs.find((conf)=>conf.key === machine.key && conf.level === machine.level);
        if (!machineConfig) return 1;
        return machineConfig.baseCellHeight;
    }
    addMachine(machine, cellX, cellY, buildProgressMultiplier, isNew) {
        if (cellX === 0 || cellY === 0) {
            var openTile = this.getBuildableTile();
            cellX = openTile.x;
            cellY = openTile.y;
            machine.x = cellX;
            machine.y = cellY;
            openTile.properties.isOccupied = true;
            (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().updateMachinePosition(machine.user_machine_id, cellX, cellY);
        }
        const widthInTiles = this.getWidthInTiles(machine);
        var newMachine = new (0, $7229471446732a65$export$2e2bcd8739ae039)(this, cellX, cellY, machine, buildProgressMultiplier, widthInTiles);
        this.add.existing(newMachine);
        newMachine.setDepth(cellY);
        this._machineObjects.push(newMachine);
        this._machineGroup.add(newMachine);
        // newMachine.x = cellWidth * cellX + (cellWidth * widthInTiles / 2);
        // newMachine.y = cellWidth * cellY + (cellWidth);
        if (isNew) {
            this._userMachines.push(machine);
            this.scene.get("HudScene").updateProgressBars(true);
        }
    }
    createMachines(force = true) {
        if (!this._machineConfigs) this._machineConfigs = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().machines;
        (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachines(force).then((userMachs)=>{
            if (!userMachs || userMachs.length === 0) return;
            // Hack for base raids
            if (!force && this._userMachines && this._userMachines.length > 0) userMachs = this._userMachines;
            this._userMachines = userMachs.sort((a, b)=>{
                if (a.y < b.y) return -1;
                if (a.y > b.y) return 1;
                return 0;
            });
            this.setOccupiedCells(true);
            this.clearMachines();
            // Get build progress multiplier from star lab
            const starLab = this._userMachines.find((mach)=>{
                return mach.machine_id === $8d346123ca66a5ed$var$starLabMachineId;
            });
            let buildProgressMultiplier = starLab && parseInt(starLab.time_until_inactive) > 0 ? $8d346123ca66a5ed$var$starLabMultipliers[parseInt(starLab.level)] : 1;
            // Add image keys to machine data, add new machine objects to UI and object list
            this._userMachines.forEach((mach)=>{
                mach.imageKey = `machines_${mach.key}`;
                this.addMachine(mach, mach.x, mach.y, buildProgressMultiplier);
            });
            this.updateMachines(true);
        });
    }
    updateMachines(force = true) {
        if (!this._machineObjects || this._machineObjects.length === 0) {
            this.createMachines(true);
            return;
        }
        (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachines(force).then((userMachs)=>{
            // Hack for base raids
            if (!force && this._userMachines && this._userMachines.length > 0) userMachs = this._userMachines;
            this.setOccupiedCells(false);
            // Get build progress multiplier from star lab
            const starLab = userMachs.find((mach)=>{
                return mach.machine_id === $8d346123ca66a5ed$var$starLabMachineId && parseInt(mach.time_until_inactive) > 0;
            });
            let buildProgressMultiplier = starLab && parseInt(starLab.time_until_inactive) > 0 ? $8d346123ca66a5ed$var$starLabMultipliers[parseInt(starLab.level)] : 1;
            // Check for changes in machine data and apply changes, add new machines
            userMachs.forEach((mach)=>{
                mach.imageKey = `machines_${mach.key}`;
                var existingMachine = this._userMachines.find((userMachine)=>userMachine.user_machine_id === mach.user_machine_id);
                if (!existingMachine) // Must be a new machine, add it to the tilemap and this._userMachines
                this.addMachine(mach, mach.x, mach.y, buildProgressMultiplier, true);
                else {
                    // Machine exists
                    // Update machine object properties with latest data
                    Object.assign(existingMachine, mach);
                    // Update machine UI component
                    var homebaseMachine = this._machineObjects.find((mo)=>mo.getMachine().user_machine_id === mach.user_machine_id);
                    if (homebaseMachine) homebaseMachine.handleUpdate(mach, buildProgressMultiplier, this._isDragging);
                }
            });
            // Check for removed machines
            this._userMachines.filter((um)=>{
                return userMachs.find((userMach)=>userMach.user_machine_id === um.user_machine_id) === undefined;
            }).forEach((ghostMachine)=>this.removeMachine(ghostMachine.user_machine_id));
            this.setOccupiedCells(true);
            // Update resource totals
            this.scene.get("HudScene").updateProgressBars(true);
        });
    }
    removeMachine(userMachineId) {
        // Find old machine object
        var oldMach = this._machineObjects.find((machObj)=>{
            return machObj.getMachine().user_machine_id === userMachineId;
        });
        if (oldMach) {
            var index = this._machineObjects.indexOf(oldMach);
            // Clear and destroy old machine
            oldMach.setAlpha(0);
            oldMach.destroy();
            // Remove old machine remnant from machines list
            this._machineObjects.splice(index, 1);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).remove(this._userMachines, (um)=>um.user_machine_id === userMachineId);
    }
    clearMachines() {
        this.setOccupiedCells(false);
        if (this._machineGroup) this._machineGroup.clear(true);
        if (this._machineObjects) {
            // Destroy old machines
            this._machineObjects.forEach((machObj)=>{
                machObj.setAlpha(0);
                machObj.destroy();
            });
            // Remove old machines from list
            while(this._machineObjects.length > 0)this._machineObjects.pop();
        }
    }
    addBlobRoomDoor() {
        var aniConfig = {
            key: "blob_room_door_animation",
            frames: this.anims.generateFrameNumbers("blob_room_door", {
                start: 0,
                end: 22,
                first: 0
            }),
            numFrames: 23,
            frameRate: 10,
            frameWidth: 168,
            frameHeight: 64,
            repeat: 0,
            repeatDelay: 0
        };
        this.anims.create(aniConfig);
        var x = $8d346123ca66a5ed$var$cellWidth * 24;
        var y = $8d346123ca66a5ed$var$cellWidth * 10;
        var postFxPlugin = this.plugins.get("rexGlowFilterPipeline");
        this._blobRoomDoor = this.physics.add.sprite(x, y, "blob_room_door").setOrigin(0.5, 0).setInteractive({
            cursor: "pointer"
        });
        var pipeline = postFxPlugin.add(this._blobRoomDoor);
        this._blobRoomDoor.glowTask = this._blobRoomDoor.scene.tweens.add({
            targets: pipeline,
            intensity: 0.011,
            ease: "Linear",
            duration: 1200,
            repeat: -1,
            yoyo: true
        });
        this._blobRoomDoor.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
            // Remove postfx pipeline
            postFxPlugin.remove(this._blobRoomDoor);
            this._blobRoomDoor.glowTask.stop();
            this._blobRoomDoor.glowTask = null;
            this._blobRoomDoor.setTint(0xfffbae);
        }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
            this._blobRoomDoor.clearTint();
            var pipeline = postFxPlugin.add(this._blobRoomDoor);
            this._blobRoomDoor.glowTask = this._blobRoomDoor.scene.tweens.add({
                targets: pipeline,
                intensity: 0.011,
                ease: "Linear",
                duration: 1200,
                repeat: -1,
                yoyo: true
            });
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
            this._blobRoomDoor.clearTint();
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfo(true);
            this._blobRoomDoor.clearTint();
            if (pointer.getDistance() > 16) return;
            this.scene.stop("HudScene");
            this._inBlobRoom = true;
            this._blobRoomDoor.play(`blob_room_door_animation`);
            this.clearMachines();
            this.cameras.main.setZoom(this.sys.canvas.height > 800 ? 1 : 0.8);
            this.cameras.main.centerOn(1536, 704);
            this.input.enabled = false;
        }).on("animationcomplete", this.handleBlobDoorClick, this);
    }
    handleBlobDoorClick(currentAnim, currentFrame, sprite) {
        const blobInfo = (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfoSync();
        if (!blobInfo) {
            window.setTimeout(this.handleBlobDoorClick, 250, this);
            return;
        }
        this.input.enabled = true;
        // Reset camera bounds and zoom
        this.cameras.main.setBounds(-200, -200, this._map.widthInPixels + 800, this._map.heightInPixels - 440);
        this._zoomMin = 0.7;
        this._zoomMax = 1.2;
        // Center camera on blob room
        this.cameras.main.pan(24 * $8d346123ca66a5ed$var$cellWidth, 6 * $8d346123ca66a5ed$var$cellWidth, 800);
        // Update layer alpha
        this._blobLayer.setAlpha(1);
        this._baseLayer.setAlpha(0.3);
        // Hide blob room door
        this._blobRoomDoor.setAlpha(0);
        this._blobRoomDoor.disableInteractive();
        this._blobRoomDoor.destroy();
        // Clear machines from homebase
        this.clearMachines();
        // Set active map layer
        this._map.setLayer("Blob Layer");
        // Add exit door
        this.addBlobRoomExitDoor();
        // Add blob
        this.addBlob();
        // Start Blob HUD
        window.setTimeout(()=>{
            this.scene.launch("BlobHudScene");
        }, 800);
    }
    addBlobRoomExitDoor() {
        var aniConfig = {
            key: "exit_room_door_animation",
            frames: this.anims.generateFrameNumbers("exit_room_door", {
                start: 0,
                end: 22,
                first: 0
            }),
            numFrames: 23,
            frameRate: 10,
            frameWidth: 168,
            frameHeight: 64,
            repeat: 0,
            repeatDelay: 0
        };
        this.anims.create(aniConfig);
        var x = $8d346123ca66a5ed$var$cellWidth * 24;
        var y = $8d346123ca66a5ed$var$cellWidth * 9;
        this._exitBlobRoomDoor = this.physics.add.sprite(x, y, "exit_room_door").setOrigin(0.5, 0).setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
            this._exitBlobRoomDoor.setTint(0xfffbae);
        }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
            this._exitBlobRoomDoor.clearTint();
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
            this._exitBlobRoomDoor.clearTint();
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            this._exitBlobRoomDoor.clearTint();
            if (pointer.getDistance() > 16) return;
            this.scene.stop("BlobHudScene");
            this._exitBlobRoomDoor.play(`exit_room_door_animation`);
            this.cameras.main.setZoom(1);
            this.cameras.main.centerOn(1536, 384);
            this.input.setDefaultCursor("default");
            this.input.enabled = false;
        }).on("animationcomplete", this.handleBlobExitDoorClick, this);
    }
    handleBlobExitDoorClick(currentAnim, currentFrame, sprite) {
        // Center camera on homebase
        //this.cameras.main.pan(17 * 64, 20 * 64, 800, undefined, true, () => {
        // Reset camera bounds and zoom
        this.cameras.main.setBounds(-200, 440, this._map.widthInPixels + 400, this._map.heightInPixels - 200);
        this._zoomMin = 0.6;
        this._zoomMax = 1.6;
        //});
        this.input.enabled = true;
        // Update layer alpha
        this._blobLayer.setAlpha(0.5);
        this._baseLayer.setAlpha(1);
        // Hide exit blob room door
        this._exitBlobRoomDoor.setAlpha(0);
        this._exitBlobRoomDoor.disableInteractive();
        this._exitBlobRoomDoor.destroy();
        // Hide blob
        this._blob.setAlpha(0);
        this._blob.destroy();
        // Update machines on homebase
        this.createMachines(true);
        // Create Blob Room Door
        this.addBlobRoomDoor();
        // Set active map layer
        this._map.setLayer("Tile Layer 1");
        // Start homebase HUD
        this.scene.launch("HudScene");
        this._inBlobRoom = false;
    }
    addBlob() {
        var aniConfig = {
            key: "green_blob_animation",
            frames: this.anims.generateFrameNumbers("blob", {
                start: 0,
                end: 7,
                first: 0
            }),
            numFrames: 8,
            frameRate: 10,
            frameWidth: 51,
            frameHeight: 42,
            repeat: -1,
            repeatDelay: 0
        };
        this.anims.create(aniConfig);
        var x = $8d346123ca66a5ed$var$cellWidth * 24;
        var y = $8d346123ca66a5ed$var$cellWidth * 5 + $8d346123ca66a5ed$var$halfCellWidth;
        this._blob = this.physics.add.sprite(x, y, "blob").setOrigin(0.5, 0.5).play("green_blob_animation");
    }
    isInBlobRoom() {
        return this._inBlobRoom;
    }
    getBuildableTile() {
        return this._map.getTilesWithin(0, 0, 2000, 2000).find((tile)=>{
            return tile.properties.buildable && !this.isTileOccupied(tile);
        }) || {
            x: 5,
            y: 13
        };
    }
    isTileOccupied(tile, machine) {
        let machineOnTile = this._userMachines.find((um)=>{
            let widthInTiles = this.getWidthInTiles(um);
            let heightInTiles = this.getHeightInTiles(um);
            let isOccupied = false;
            for(var i = 0; i < widthInTiles; i++)for(var h = 0; h < heightInTiles; h++){
                var coveredTile = this._map.getTileAt(um.x + i, um.y - h);
                if (coveredTile && coveredTile.x === tile.x && coveredTile.y === tile.y) isOccupied = true;
            }
            return isOccupied;
        });
        return machineOnTile && machineOnTile.user_machine_id !== (machine === null || machine === void 0 ? void 0 : machine.user_machine_id) ? true : false;
    }
    setOccupiedCells(isOccupied) {
        this._userMachines.forEach((mach)=>{
            var builtTile = this._map.getTileAt(mach.x, mach.y);
            if (builtTile) {
                builtTile.properties.isOccupied = isOccupied;
                const widthInTiles = this.getWidthInTiles(mach);
                for(var i = 1; i < widthInTiles; i++){
                    var extraTile = this._map.getTileAt(builtTile.x + i, builtTile.y);
                    if (extraTile && extraTile.properties.buildable) extraTile.properties.isOccupied = isOccupied;
                }
            }
        });
    }
    launchScene(scene, data) {
        this.scene.launch(scene, data);
        this.gameScene = this.scene.get(scene);
    }
    updateResize(scene) {
        scene.scale.on("resize", this.resize, scene);
        const scaleWidth = scene.scale.gameSize.width;
        const scaleHeight = scene.scale.gameSize.height;
        scene.parent = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Structs.Size(scaleWidth, scaleHeight);
        scene.sizer = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Structs.Size(scene.width, scene.height, (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Structs.Size.FIT, scene.parent);
        scene.parent.setSize(scaleWidth, scaleHeight);
        scene.sizer.setSize(scaleWidth, scaleHeight);
        this.updateCamera(scene);
    }
    resize(gameSize) {
        // 'this' means to the current scene that is running
        if (!this.sceneStopped) {
            const width = gameSize.width;
            const height = gameSize.height;
            this.parent.setSize(width, height);
            this.sizer.setSize(width, height);
            const camera = this.cameras.main;
            const scaleX = this.sizer.width / this.game.screenBaseSize.width;
            const scaleY = this.sizer.height / this.game.screenBaseSize.height;
            camera.setZoom(Math.max(scaleX, scaleY));
            camera.centerOn(this.game.screenBaseSize.width / 2, this.game.screenBaseSize.height / 2);
        }
    }
    updateCamera(scene) {
        const camera = scene.cameras.main;
        const scaleX = scene.sizer.width / this.game.screenBaseSize.width;
        const scaleY = scene.sizer.height / this.game.screenBaseSize.height;
        camera.setZoom(Math.max(scaleX, scaleY));
        camera.centerOn(this.game.screenBaseSize.width / 2, this.game.screenBaseSize.height / 2);
    }
    applyScale(length) {
        return length;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$d6d96f2257233255)));
    }
}



var $7WQrb = parcelRequire("7WQrb");









const $8e0e3599fc103993$var$defaultOverScale = 1.01;
const $8e0e3599fc103993$var$useOverScaleDefault = true;
const $8e0e3599fc103993$var$clickAlpha = 0.9;
const $8e0e3599fc103993$var$tintColor = 0xcdcdcd;
class $8e0e3599fc103993$export$2e2bcd8739ae039 extends (0, $53a247a9dadbd479$export$2e2bcd8739ae039) {
    constructor(scene, x, y, texture, config, useOverScaling, overScale){
        super(scene, x, y, texture, "", config);
        this.clickSubject = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        this.upTexture = texture;
        this.downTexture = texture;
        this.overTexture = texture;
        this.disabledTexture = texture;
        this.useOverScaling = useOverScaling === undefined || useOverScaling === null ? $8e0e3599fc103993$var$useOverScaleDefault : useOverScaling;
        this.overScale = overScale === undefined || overScale === null ? $8e0e3599fc103993$var$defaultOverScale : overScale;
        if ((config === null || config === void 0 ? void 0 : config.allowClicks) !== false) this.setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, this.handleUp, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, this.handleOut, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleDown, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.handleOver, this);
    }
    destroy(fromScene = false) {
        this.clickSubject.complete();
        super.destroy(fromScene);
    }
    onClick() {
        return this.clickSubject.asObservable();
    }
    getWidth() {
        return this.displayWidth;
    }
    getHeight() {
        return this.displayHeight;
    }
    setUpTexture(texture) {
        this.upTexture = texture;
        return this;
    }
    setDownTexture(texture) {
        this.downTexture = texture;
        return this;
    }
    setOverTexture(texture) {
        this.overTexture = texture;
        return this;
    }
    setDisabledTexture(texture) {
        this.disabledTexture = texture;
        return this;
    }
    setDisabled(disabled) {
        if (disabled) {
            this.setTexture(this.disabledTexture);
            this.disableInteractive();
            return this;
        }
        this.setTexture(this.upTexture);
        this.setInteractive();
        return this;
    }
    setOverScale(scale) {
        this.overScale = scale;
        return this;
    }
    setUseOverScaling(useOverGrowth) {
        this.useOverScaling = useOverGrowth;
        return this;
    }
    handleUp(pointer) {
        this.handleOver(pointer);
        this.clickSubject.next(pointer);
    }
    handleOut(pointer) {
        this.handleDown(pointer);
    }
    handleDown(pointer) {
        if (this.useOverScaling) this.setScale(this.scaleX / this.overScale);
        else {
            this.setAlpha(1);
            this.clearTint();
        }
    }
    handleOver(pointer) {
        if (this.useOverScaling) this.setScale(this.scaleX * this.overScale);
        else this.setTint($8e0e3599fc103993$var$tintColor);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("roundImageButton", function(x, y, texture, config, useOverScaling, overScale) {
    // @ts-ignore
    return this.displayList.add(new $8e0e3599fc103993$export$2e2bcd8739ae039(this.scene, x, y, texture, config, useOverScaling, overScale));
});




var $7WQrb = parcelRequire("7WQrb");
var $243a0fb2392e59c4$exports = {};
// colyseus.js@0.14.13 (@colyseus/schema 1.0.25)
(function(global1, factory) {
    factory($243a0fb2392e59c4$exports);
})($243a0fb2392e59c4$exports, function(exports1) {
    "use strict";
    //
    // Polyfills for legacy environments
    //
    /*
     * Support Android 4.4.x
     */ if (!ArrayBuffer.isView) ArrayBuffer.isView = function(a) {
        return a !== null && typeof a === "object" && a.buffer instanceof ArrayBuffer;
    };
    // Define globalThis if not available.
    // https://github.com/colyseus/colyseus.js/issues/86
    if (typeof globalThis === "undefined" && typeof window !== "undefined") // @ts-ignore
    window["globalThis"] = window;
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function apply(src, tar) {
        tar.headers = src.headers || {};
        tar.statusMessage = src.statusText;
        tar.statusCode = src.status;
        tar.data = src.response;
    }
    function send(method, uri, opts) {
        return new Promise(function(res, rej) {
            opts = opts || {};
            var req = new XMLHttpRequest;
            var k, tmp, arr, str = opts.body;
            var headers = opts.headers || {};
            // IE compatible
            if (opts.timeout) req.timeout = opts.timeout;
            req.ontimeout = req.onerror = function(err) {
                err.timeout = err.type == "timeout";
                rej(err);
            };
            req.open(method, uri.href || uri);
            req.onload = function() {
                arr = req.getAllResponseHeaders().trim().split(/[\r\n]+/);
                apply(req, req); //=> req.headers
                while(tmp = arr.shift()){
                    tmp = tmp.split(": ");
                    req.headers[tmp.shift().toLowerCase()] = tmp.join(": ");
                }
                tmp = req.headers["content-type"];
                if (tmp && !!~tmp.indexOf("application/json")) try {
                    req.data = JSON.parse(req.data, opts.reviver);
                } catch (err) {
                    apply(req, err);
                    return rej(err);
                }
                (req.status >= 400 ? rej : res)(req);
            };
            if (typeof FormData < "u" && str instanceof FormData) ;
            else if (str && typeof str == "object") {
                headers["content-type"] = "application/json";
                str = JSON.stringify(str);
            }
            req.withCredentials = !!opts.withCredentials;
            for(k in headers)req.setRequestHeader(k, headers[k]);
            req.send(str);
        });
    }
    var get = /*#__PURE__*/ send.bind(send, "GET");
    var post = /*#__PURE__*/ send.bind(send, "POST");
    var patch = /*#__PURE__*/ send.bind(send, "PATCH");
    var del = /*#__PURE__*/ send.bind(send, "DELETE");
    var put = /*#__PURE__*/ send.bind(send, "PUT");
    var del_1 = del;
    var get_1 = get;
    var patch_1 = patch;
    var post_1 = post;
    var put_1 = put;
    var send_1 = send;
    var xhr = {
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    };
    var http = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(/*#__PURE__*/ Object.create(null), xhr, {
        "default": xhr,
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    }));
    var ServerError = /** @class */ function(_super) {
        __extends(ServerError, _super);
        function ServerError(code, message) {
            var _this = _super.call(this, message) || this;
            _this.name = "ServerError";
            _this.code = code;
            return _this;
        }
        return ServerError;
    }(Error);
    /**
     * Copyright (c) 2014 Ion Drive Software Ltd.
     * https://github.com/darrachequesne/notepack/
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */ /**
     * Patch for Colyseus:
     * -------------------
     *
     * added `offset` on Decoder constructor, for messages arriving with a code
     * before actual msgpack data
     */ // 
    // DECODER
    // 
    function Decoder(buffer, offset) {
        this._offset = offset;
        if (buffer instanceof ArrayBuffer) {
            this._buffer = buffer;
            this._view = new DataView(this._buffer);
        } else if (ArrayBuffer.isView(buffer)) {
            this._buffer = buffer.buffer;
            this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
        } else throw new Error("Invalid argument");
    }
    function utf8Read$1(view, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view.getUint8(i);
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view.getUint8(++i) & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view.getUint8(++i) & 0x3f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    Decoder.prototype._array = function(length) {
        var value = new Array(length);
        for(var i = 0; i < length; i++)value[i] = this._parse();
        return value;
    };
    Decoder.prototype._map = function(length) {
        var key = "", value = {};
        for(var i = 0; i < length; i++){
            key = this._parse();
            value[key] = this._parse();
        }
        return value;
    };
    Decoder.prototype._str = function(length) {
        var value = utf8Read$1(this._view, this._offset, length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._bin = function(length) {
        var value = this._buffer.slice(this._offset, this._offset + length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._parse = function() {
        var prefix = this._view.getUint8(this._offset++);
        var value, length = 0, type = 0, hi = 0, lo = 0;
        if (prefix < 0xc0) {
            // positive fixint
            if (prefix < 0x80) return prefix;
            // fixmap
            if (prefix < 0x90) return this._map(prefix & 0x0f);
            // fixarray
            if (prefix < 0xa0) return this._array(prefix & 0x0f);
            // fixstr
            return this._str(prefix & 0x1f);
        }
        // negative fixint
        if (prefix > 0xdf) return (0xff - prefix + 1) * -1;
        switch(prefix){
            // nil
            case 0xc0:
                return null;
            // false
            case 0xc2:
                return false;
            // true
            case 0xc3:
                return true;
            // bin
            case 0xc4:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._bin(length);
            case 0xc5:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._bin(length);
            case 0xc6:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._bin(length);
            // ext
            case 0xc7:
                length = this._view.getUint8(this._offset);
                type = this._view.getInt8(this._offset + 1);
                this._offset += 2;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc8:
                length = this._view.getUint16(this._offset);
                type = this._view.getInt8(this._offset + 2);
                this._offset += 3;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc9:
                length = this._view.getUint32(this._offset);
                type = this._view.getInt8(this._offset + 4);
                this._offset += 5;
                return [
                    type,
                    this._bin(length)
                ];
            // float
            case 0xca:
                value = this._view.getFloat32(this._offset);
                this._offset += 4;
                return value;
            case 0xcb:
                value = this._view.getFloat64(this._offset);
                this._offset += 8;
                return value;
            // uint
            case 0xcc:
                value = this._view.getUint8(this._offset);
                this._offset += 1;
                return value;
            case 0xcd:
                value = this._view.getUint16(this._offset);
                this._offset += 2;
                return value;
            case 0xce:
                value = this._view.getUint32(this._offset);
                this._offset += 4;
                return value;
            case 0xcf:
                hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // int
            case 0xd0:
                value = this._view.getInt8(this._offset);
                this._offset += 1;
                return value;
            case 0xd1:
                value = this._view.getInt16(this._offset);
                this._offset += 2;
                return value;
            case 0xd2:
                value = this._view.getInt32(this._offset);
                this._offset += 4;
                return value;
            case 0xd3:
                hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // fixext
            case 0xd4:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    this._offset += 1;
                    return void 0;
                }
                return [
                    type,
                    this._bin(1)
                ];
            case 0xd5:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(2)
                ];
            case 0xd6:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(4)
                ];
            case 0xd7:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    return new Date(hi + lo);
                }
                return [
                    type,
                    this._bin(8)
                ];
            case 0xd8:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(16)
                ];
            // str
            case 0xd9:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._str(length);
            case 0xda:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._str(length);
            case 0xdb:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._str(length);
            // array
            case 0xdc:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._array(length);
            case 0xdd:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._array(length);
            // map
            case 0xde:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._map(length);
            case 0xdf:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._map(length);
        }
        throw new Error("Could not parse");
    };
    function decode(buffer, offset) {
        if (offset === void 0) offset = 0;
        var decoder = new Decoder(buffer, offset);
        var value = decoder._parse();
        if (decoder._offset !== buffer.byteLength) throw new Error(buffer.byteLength - decoder._offset + " trailing bytes");
        return value;
    }
    // 
    // ENCODER
    // 
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view.setUint8(offset++, c);
            else if (c < 0x800) {
                view.setUint8(offset++, 0xc0 | c >> 6);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xe000) {
                view.setUint8(offset++, 0xe0 | c >> 12);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view.setUint8(offset++, 0xf0 | c >> 18);
                view.setUint8(offset++, 0x80 | c >> 12 & 0x3f);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            }
        }
    }
    function utf8Length$1(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function _encode(bytes, defers, value) {
        var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
        if (type === "string") {
            length = utf8Length$1(value);
            // fixstr
            if (length < 0x20) {
                bytes.push(length | 0xa0);
                size = 1;
            } else if (length < 0x100) {
                bytes.push(0xd9, length);
                size = 2;
            } else if (length < 0x10000) {
                bytes.push(0xda, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("String too long");
            defers.push({
                _str: value,
                _length: length,
                _offset: bytes.length
            });
            return size + length;
        }
        if (type === "number") {
            // TODO: encode to float 32?
            // float 64
            if (Math.floor(value) !== value || !isFinite(value)) {
                bytes.push(0xcb);
                defers.push({
                    _float: value,
                    _length: 8,
                    _offset: bytes.length
                });
                return 9;
            }
            if (value >= 0) {
                // positive fixnum
                if (value < 0x80) {
                    bytes.push(value);
                    return 1;
                }
                // uint 8
                if (value < 0x100) {
                    bytes.push(0xcc, value);
                    return 2;
                }
                // uint 16
                if (value < 0x10000) {
                    bytes.push(0xcd, value >> 8, value);
                    return 3;
                }
                // uint 32
                if (value < 0x100000000) {
                    bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // uint 64
                hi = value / Math.pow(2, 32) >> 0;
                lo = value >>> 0;
                bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            } else {
                // negative fixnum
                if (value >= -32) {
                    bytes.push(value);
                    return 1;
                }
                // int 8
                if (value >= -128) {
                    bytes.push(0xd0, value);
                    return 2;
                }
                // int 16
                if (value >= -32768) {
                    bytes.push(0xd1, value >> 8, value);
                    return 3;
                }
                // int 32
                if (value >= -2147483648) {
                    bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // int 64
                hi = Math.floor(value / Math.pow(2, 32));
                lo = value >>> 0;
                bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            }
        }
        if (type === "object") {
            // nil
            if (value === null) {
                bytes.push(0xc0);
                return 1;
            }
            if (Array.isArray(value)) {
                length = value.length;
                // fixarray
                if (length < 0x10) {
                    bytes.push(length | 0x90);
                    size = 1;
                } else if (length < 0x10000) {
                    bytes.push(0xdc, length >> 8, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Array too large");
                for(i = 0; i < length; i++)size += _encode(bytes, defers, value[i]);
                return size;
            }
            // fixext 8 / Date
            if (value instanceof Date) {
                var time = value.getTime();
                hi = Math.floor(time / Math.pow(2, 32));
                lo = time >>> 0;
                bytes.push(0xd7, 0, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 10;
            }
            if (value instanceof ArrayBuffer) {
                length = value.byteLength;
                // bin 8
                if (length < 0x100) {
                    bytes.push(0xc4, length);
                    size = 2;
                } else // bin 16
                if (length < 0x10000) {
                    bytes.push(0xc5, length >> 8, length);
                    size = 3;
                } else // bin 32
                if (length < 0x100000000) {
                    bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Buffer too large");
                defers.push({
                    _bin: value,
                    _length: length,
                    _offset: bytes.length
                });
                return size + length;
            }
            if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
            var keys = [], key = "";
            var allKeys = Object.keys(value);
            for(i = 0, l = allKeys.length; i < l; i++){
                key = allKeys[i];
                if (typeof value[key] !== "function") keys.push(key);
            }
            length = keys.length;
            // fixmap
            if (length < 0x10) {
                bytes.push(length | 0x80);
                size = 1;
            } else if (length < 0x10000) {
                bytes.push(0xde, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("Object too large");
            for(i = 0; i < length; i++){
                key = keys[i];
                size += _encode(bytes, defers, key);
                size += _encode(bytes, defers, value[key]);
            }
            return size;
        }
        // false/true
        if (type === "boolean") {
            bytes.push(value ? 0xc3 : 0xc2);
            return 1;
        }
        // fixext 1 / undefined
        if (type === "undefined") {
            bytes.push(0xd4, 0, 0);
            return 3;
        }
        throw new Error("Could not encode");
    }
    function encode(value) {
        var bytes = [];
        var defers = [];
        var size = _encode(bytes, defers, value);
        var buf = new ArrayBuffer(size);
        var view = new DataView(buf);
        var deferIndex = 0;
        var deferWritten = 0;
        var nextOffset = -1;
        if (defers.length > 0) nextOffset = defers[0]._offset;
        var defer, deferLength = 0, offset = 0;
        for(var i = 0, l = bytes.length; i < l; i++){
            view.setUint8(deferWritten + i, bytes[i]);
            if (i + 1 !== nextOffset) continue;
            defer = defers[deferIndex];
            deferLength = defer._length;
            offset = deferWritten + nextOffset;
            if (defer._bin) {
                var bin = new Uint8Array(defer._bin);
                for(var j = 0; j < deferLength; j++)view.setUint8(offset + j, bin[j]);
            } else if (defer._str) utf8Write(view, offset, defer._str);
            else if (defer._float !== undefined) view.setFloat64(offset, defer._float);
            deferIndex++;
            deferWritten += deferLength;
            if (defers[deferIndex]) nextOffset = defers[deferIndex]._offset;
        }
        return buf;
    }
    var browser = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
    var WebSocket = globalThis.WebSocket || browser;
    var WebSocketTransport = /** @class */ function() {
        function WebSocketTransport(events) {
            this.events = events;
        }
        WebSocketTransport.prototype.send = function(data) {
            if (data instanceof ArrayBuffer) this.ws.send(data);
            else if (Array.isArray(data)) this.ws.send(new Uint8Array(data).buffer);
        };
        WebSocketTransport.prototype.connect = function(url) {
            this.ws = new WebSocket(url, this.protocols);
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = this.events.onopen;
            this.ws.onmessage = this.events.onmessage;
            this.ws.onclose = this.events.onclose;
            this.ws.onerror = this.events.onerror;
        };
        WebSocketTransport.prototype.close = function(code, reason) {
            this.ws.close(code, reason);
        };
        return WebSocketTransport;
    }();
    var Connection = /** @class */ function() {
        function Connection() {
            this.events = {};
            this.transport = new WebSocketTransport(this.events);
        }
        Connection.prototype.send = function(data) {
            this.transport.send(data);
        };
        Connection.prototype.connect = function(url) {
            this.transport.connect(url);
        };
        Connection.prototype.close = function(code, reason) {
            this.transport.close(code, reason);
        };
        return Connection;
    }();
    var serializers = {};
    function registerSerializer(id, serializer) {
        serializers[id] = serializer;
    }
    function getSerializer(id) {
        var serializer = serializers[id];
        if (!serializer) throw new Error("missing serializer: " + id);
        return serializer;
    }
    // Use codes between 0~127 for lesser throughput (1 byte)
    exports1.Protocol = void 0;
    (function(Protocol) {
        // Room-related (10~19)
        Protocol[Protocol["HANDSHAKE"] = 9] = "HANDSHAKE";
        Protocol[Protocol["JOIN_ROOM"] = 10] = "JOIN_ROOM";
        Protocol[Protocol["ERROR"] = 11] = "ERROR";
        Protocol[Protocol["LEAVE_ROOM"] = 12] = "LEAVE_ROOM";
        Protocol[Protocol["ROOM_DATA"] = 13] = "ROOM_DATA";
        Protocol[Protocol["ROOM_STATE"] = 14] = "ROOM_STATE";
        Protocol[Protocol["ROOM_STATE_PATCH"] = 15] = "ROOM_STATE_PATCH";
        Protocol[Protocol["ROOM_DATA_SCHEMA"] = 16] = "ROOM_DATA_SCHEMA";
    })(exports1.Protocol || (exports1.Protocol = {}));
    exports1.ErrorCode = void 0;
    (function(ErrorCode) {
        ErrorCode[ErrorCode["MATCHMAKE_NO_HANDLER"] = 4210] = "MATCHMAKE_NO_HANDLER";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_CRITERIA"] = 4211] = "MATCHMAKE_INVALID_CRITERIA";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_ROOM_ID"] = 4212] = "MATCHMAKE_INVALID_ROOM_ID";
        ErrorCode[ErrorCode["MATCHMAKE_UNHANDLED"] = 4213] = "MATCHMAKE_UNHANDLED";
        ErrorCode[ErrorCode["MATCHMAKE_EXPIRED"] = 4214] = "MATCHMAKE_EXPIRED";
        ErrorCode[ErrorCode["AUTH_FAILED"] = 4215] = "AUTH_FAILED";
        ErrorCode[ErrorCode["APPLICATION_ERROR"] = 4216] = "APPLICATION_ERROR";
    })(exports1.ErrorCode || (exports1.ErrorCode = {}));
    function utf8Read(view, offset) {
        var length = view[offset++];
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view[++i] & 0x3f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    // Faster for short strings than Buffer.byteLength
    function utf8Length(str) {
        if (str === void 0) str = "";
        var c = 0;
        var length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length + 1;
    }
    let createNanoEvents = ()=>({
            events: {},
            emit (event, ...args) {
                (this.events[event] || []).forEach((i)=>i(...args));
            },
            on (event, cb) {
                (this.events[event] = this.events[event] || []).push(cb);
                return ()=>this.events[event] = (this.events[event] || []).filter((i)=>i !== cb);
            }
        });
    var EventEmitter = /** @class */ function() {
        function EventEmitter() {
            this.handlers = [];
        }
        EventEmitter.prototype.register = function(cb, once) {
            this.handlers.push(cb);
            return this;
        };
        EventEmitter.prototype.invoke = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            this.handlers.forEach(function(handler) {
                return handler.apply(_this, args);
            });
        };
        EventEmitter.prototype.invokeAsync = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return Promise.all(this.handlers.map(function(handler) {
                return handler.apply(_this, args);
            }));
        };
        EventEmitter.prototype.remove = function(cb) {
            var index = this.handlers.indexOf(cb);
            this.handlers[index] = this.handlers[this.handlers.length - 1];
            this.handlers.pop();
        };
        EventEmitter.prototype.clear = function() {
            this.handlers = [];
        };
        return EventEmitter;
    }();
    function createSignal() {
        var emitter = new EventEmitter();
        function register(cb) {
            return emitter.register(cb, this === null);
        }
        register.once = function(cb) {
            var callback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                cb.apply(this, args);
                emitter.remove(callback);
            };
            emitter.register(callback);
        };
        register.remove = function(cb) {
            return emitter.remove(cb);
        };
        register.invoke = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invoke.apply(emitter, args);
        };
        register.invokeAsync = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invokeAsync.apply(emitter, args);
        };
        register.clear = function() {
            return emitter.clear();
        };
        return register;
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            function __extends(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __spreadArray(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            }
            // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
            var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
            var TYPE_ID = 213;
            /**
         * Encoding Schema field operations.
         */ exports1.OPERATION = void 0;
            (function(OPERATION) {
                // add new structure/primitive
                OPERATION[OPERATION["ADD"] = 128] = "ADD";
                // replace structure/primitive
                OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
                // delete field
                OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
                // DELETE field, followed by an ADD
                OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
                // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
                // touches are NOT encoded.
                OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
                // MapSchema Operations
                OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
            })(exports1.OPERATION || (exports1.OPERATION = {}));
            // export enum OPERATION {
            //     // add new structure/primitive
            //     // (128)
            //     ADD = 128, // 10000000,
            //     // replace structure/primitive
            //     REPLACE = 1,// 00000001
            //     // delete field
            //     DELETE = 192, // 11000000
            //     // DELETE field, followed by an ADD
            //     DELETE_AND_ADD = 224, // 11100000
            //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
            //     // touches are NOT encoded.
            //     TOUCH = 0, // 00000000
            //     // MapSchema Operations
            //     CLEAR = 10,
            // }
            //
            // Root holds all schema references by unique id
            //
            var Root = /** @class */ function() {
                function Root() {
                    //
                    // Relation of refId => Schema structure
                    // For direct access of structures during decoding time.
                    //
                    this.refs = new Map();
                    this.refCounts = {};
                    this.deletedRefs = new Set();
                    this.nextUniqueId = 0;
                }
                Root.prototype.getNextUniqueId = function() {
                    return this.nextUniqueId++;
                };
                // for decoding
                Root.prototype.addRef = function(refId, ref, incrementCount) {
                    if (incrementCount === void 0) incrementCount = true;
                    this.refs.set(refId, ref);
                    if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
                };
                // for decoding
                Root.prototype.removeRef = function(refId) {
                    this.refCounts[refId] = this.refCounts[refId] - 1;
                    this.deletedRefs.add(refId);
                };
                Root.prototype.clearRefs = function() {
                    this.refs.clear();
                    this.deletedRefs.clear();
                    this.refCounts = {};
                };
                // for decoding
                Root.prototype.garbageCollectDeletedRefs = function() {
                    var _this = this;
                    this.deletedRefs.forEach(function(refId) {
                        if (_this.refCounts[refId] <= 0) {
                            var ref = _this.refs.get(refId);
                            //
                            // Ensure child schema instances have their references removed as well.
                            //
                            if (ref instanceof Schema) {
                                for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                            } else {
                                var definition = ref["$changes"].parent._definition;
                                var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                                if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                                    return _this.removeRef(child["$changes"].refId);
                                });
                            }
                            _this.refs.delete(refId);
                            delete _this.refCounts[refId];
                        }
                    });
                    // clear deleted refs.
                    this.deletedRefs.clear();
                };
                return Root;
            }();
            var ChangeTree = /** @class */ function() {
                function ChangeTree(ref, parent, root) {
                    this.changed = false;
                    this.changes = new Map();
                    this.allChanges = new Set();
                    // cached indexes for filtering
                    this.caches = {};
                    this.currentCustomOperation = 0;
                    this.ref = ref;
                    this.setParent(parent, root);
                }
                ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
                    var _this = this;
                    if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
                    this.parent = parent;
                    this.parentIndex = parentIndex;
                    // avoid setting parents with empty `root`
                    if (!root) return;
                    this.root = root;
                    //
                    // assign same parent on child structures
                    //
                    if (this.ref instanceof Schema) {
                        var definition = this.ref["_definition"];
                        for(var field in definition.schema){
                            var value = this.ref[field];
                            if (value && value["$changes"]) {
                                var parentIndex_1 = definition.indexes[field];
                                value["$changes"].setParent(this.ref, root, parentIndex_1);
                            }
                        }
                    } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                        if (value instanceof Schema) {
                            var changeTreee = value["$changes"];
                            var parentIndex_2 = _this.ref["$changes"].indexes[key];
                            changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                        }
                    });
                };
                ChangeTree.prototype.operation = function(op) {
                    this.changes.set(--this.currentCustomOperation, op);
                };
                ChangeTree.prototype.change = function(fieldName, operation) {
                    if (operation === void 0) operation = exports1.OPERATION.ADD;
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    var previousChange = this.changes.get(index);
                    if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
                    ) this.changes.set(index, {
                        op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                        // : OPERATION.REPLACE,
                        index: index
                    });
                    this.allChanges.add(index);
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.touch = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    if (!this.changes.has(index)) this.changes.set(index, {
                        op: exports1.OPERATION.TOUCH,
                        index: index
                    });
                    this.allChanges.add(index);
                    // ensure touch is placed until the $root is found.
                    this.touchParents();
                };
                ChangeTree.prototype.touchParents = function() {
                    if (this.parent) this.parent["$changes"].touch(this.parentIndex);
                };
                ChangeTree.prototype.getType = function(index) {
                    if (this.ref["_definition"]) {
                        var definition = this.ref["_definition"];
                        return definition.schema[definition.fieldsByIndex[index]];
                    } else {
                        var definition = this.parent["_definition"];
                        var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                        //
                        // Get the child type from parent structure.
                        // - ["string"] => "string"
                        // - { map: "string" } => "string"
                        // - { set: "string" } => "string"
                        //
                        return Object.values(parentType)[0];
                    }
                };
                ChangeTree.prototype.getChildrenFilter = function() {
                    var childFilters = this.parent["_definition"].childFilters;
                    return childFilters && childFilters[this.parentIndex];
                };
                //
                // used during `.encode()`
                //
                ChangeTree.prototype.getValue = function(index) {
                    return this.ref["getByIndex"](index);
                };
                ChangeTree.prototype.delete = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    if (index === undefined) {
                        console.warn("@colyseus/schema " + this.ref.constructor.name + ": trying to delete non-existing index: " + fieldName + " (" + index + ")");
                        return;
                    }
                    var previousValue = this.getValue(index);
                    // console.log("$changes.delete =>", { fieldName, index, previousValue });
                    this.changes.set(index, {
                        op: exports1.OPERATION.DELETE,
                        index: index
                    });
                    this.allChanges.delete(index);
                    // delete cache
                    delete this.caches[index];
                    // remove `root` reference
                    if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.discard = function(changed, discardAll) {
                    var _this = this;
                    if (changed === void 0) changed = false;
                    if (discardAll === void 0) discardAll = false;
                    //
                    // Map, Array, etc:
                    // Remove cached key to ensure ADD operations is unsed instead of
                    // REPLACE in case same key is used on next patches.
                    //
                    // TODO: refactor this. this is not relevant for Collection and Set.
                    //
                    if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                        if (change.op === exports1.OPERATION.DELETE) {
                            var index = _this.ref["getIndex"](change.index);
                            delete _this.indexes[index];
                        }
                    });
                    this.changes.clear();
                    this.changed = changed;
                    if (discardAll) this.allChanges.clear();
                    // re-set `currentCustomOperation`
                    this.currentCustomOperation = 0;
                };
                /**
             * Recursively discard all changes from this, and child structures.
             */ ChangeTree.prototype.discardAll = function() {
                    var _this = this;
                    this.changes.forEach(function(change) {
                        var value = _this.getValue(change.index);
                        if (value && value["$changes"]) value["$changes"].discardAll();
                    });
                    this.discard();
                };
                // cache(field: number, beginIndex: number, endIndex: number) {
                ChangeTree.prototype.cache = function(field, cachedBytes) {
                    this.caches[field] = cachedBytes;
                };
                ChangeTree.prototype.clone = function() {
                    return new ChangeTree(this.ref, this.parent, this.root);
                };
                ChangeTree.prototype.ensureRefId = function() {
                    // skip if refId is already set.
                    if (this.refId !== undefined) return;
                    this.refId = this.root.getNextUniqueId();
                };
                ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
                    if (index === undefined) throw new Error('ChangeTree: missing index for field "' + fieldName + '"');
                };
                return ChangeTree;
            }();
            //
            // Notes:
            // -----
            //
            // - The tsconfig.json of @colyseus/schema uses ES2018.
            // - ES2019 introduces `flatMap` / `flat`, which is not currently relevant, and caused other issues.
            //
            var DEFAULT_SORT = function(a, b) {
                var A = a.toString();
                var B = b.toString();
                if (A < B) return -1;
                else if (A > B) return 1;
                else return 0;
            };
            function getArrayProxy(value) {
                value["$proxy"] = true;
                //
                // compatibility with @colyseus/schema 0.5.x
                // - allow `map["key"]`
                // - allow `map["key"] = "xxx"`
                // - allow `delete map["key"]`
                //
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                        ) return obj.at(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && !isNaN(prop)) {
                            var indexes = Array.from(obj["$items"].keys());
                            var key = parseInt(indexes[prop] || prop);
                            if (setValue === undefined || setValue === null) obj.deleteAt(key);
                            else obj.setAt(key, setValue);
                        } else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        if (typeof prop === "number") obj.deleteAt(prop);
                        else delete obj[prop];
                        return true;
                    }
                });
                return value;
            }
            var ArraySchema = /** @class */ function() {
                function ArraySchema() {
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    this.push.apply(this, items);
                }
                ArraySchema.is = function(type) {
                    return(// type format: ["string"]
                    Array.isArray(type) || // type format: { array: "string" }
                    type["array"] !== undefined);
                };
                Object.defineProperty(ArraySchema.prototype, "length", {
                    get: function() {
                        return this.$items.size;
                    },
                    set: function(value) {
                        if (value === 0) this.clear();
                        else this.splice(value, this.length - value);
                    },
                    enumerable: false,
                    configurable: true
                });
                ArraySchema.prototype.push = function() {
                    var _this = this;
                    var values = [];
                    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
                    var lastIndex;
                    values.forEach(function(value) {
                        // set "index" for reference.
                        lastIndex = _this.$refId++;
                        _this.setAt(lastIndex, value);
                    });
                    return lastIndex;
                };
                /**
             * Removes the last element from an array and returns it.
             */ ArraySchema.prototype.pop = function() {
                    var key = Array.from(this.$indexes.values()).pop();
                    if (key === undefined) return undefined;
                    this.$changes.delete(key);
                    this.$indexes.delete(key);
                    var value = this.$items.get(key);
                    this.$items.delete(key);
                    return value;
                };
                ArraySchema.prototype.at = function(index) {
                    //
                    // FIXME: this should be O(1)
                    //
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                ArraySchema.prototype.setAt = function(index, value) {
                    var _a, _b;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                };
                ArraySchema.prototype.deleteAt = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    if (key === undefined) return false;
                    return this.$deleteAt(key);
                };
                ArraySchema.prototype.$deleteAt = function(index) {
                    // delete at internal index
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                ArraySchema.prototype.clear = function(isDecoding) {
                    var _this = this;
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    // flag child items for garbage collection.
                    if (isDecoding && typeof this.$changes.getType() !== "string") this.$items.forEach(function(item) {
                        _this.$changes.root.removeRef(item["$changes"].refId);
                    });
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                /**
             * Combines two or more arrays.
             * @param items Additional items to add to the end of array1.
             */ ArraySchema.prototype.concat = function() {
                    var _a;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], (_a = Array.from(this.$items.values())).concat.apply(_a, items))))();
                };
                /**
             * Adds all the elements of an array separated by the specified separator string.
             * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
             */ ArraySchema.prototype.join = function(separator) {
                    return Array.from(this.$items.values()).join(separator);
                };
                /**
             * Reverses the elements in an Array.
             */ ArraySchema.prototype.reverse = function() {
                    var _this = this;
                    var indexes = Array.from(this.$items.keys());
                    var reversedItems = Array.from(this.$items.values()).reverse();
                    reversedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes the first element from an array and returns it.
             */ ArraySchema.prototype.shift = function() {
                    var indexes = Array.from(this.$items.keys());
                    var shiftAt = indexes.shift();
                    if (shiftAt === undefined) return undefined;
                    var value = this.$items.get(shiftAt);
                    this.$deleteAt(shiftAt);
                    return value;
                };
                /**
             * Returns a section of an array.
             * @param start The beginning of the specified portion of the array.
             * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
             */ ArraySchema.prototype.slice = function(start, end) {
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()).slice(start, end))))();
                };
                /**
             * Sorts an array.
             * @param compareFn Function used to determine the order of the elements. It is expected to return
             * a negative value if first argument is less than second argument, zero if they're equal and a positive
             * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
             * ```ts
             * [11,2,22,1].sort((a, b) => a - b)
             * ```
             */ ArraySchema.prototype.sort = function(compareFn) {
                    var _this = this;
                    if (compareFn === void 0) compareFn = DEFAULT_SORT;
                    var indexes = Array.from(this.$items.keys());
                    var sortedItems = Array.from(this.$items.values()).sort(compareFn);
                    sortedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
             * @param start The zero-based location in the array from which to start removing elements.
             * @param deleteCount The number of elements to remove.
             * @param items Elements to insert into the array in place of the deleted elements.
             */ ArraySchema.prototype.splice = function(start, deleteCount) {
                    if (deleteCount === void 0) deleteCount = this.length - start;
                    var items = [];
                    for(var _i = 2; _i < arguments.length; _i++)items[_i - 2] = arguments[_i];
                    var indexes = Array.from(this.$items.keys());
                    var removedItems = [];
                    for(var i = start; i < start + deleteCount; i++){
                        removedItems.push(this.$items.get(indexes[i]));
                        this.$deleteAt(indexes[i]);
                    }
                    return removedItems;
                };
                /**
             * Inserts new elements at the start of an array.
             * @param items  Elements to insert at the start of the Array.
             */ ArraySchema.prototype.unshift = function() {
                    var _this = this;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    var length = this.length;
                    var addedLength = items.length;
                    // const indexes = Array.from(this.$items.keys());
                    var previousValues = Array.from(this.$items.values());
                    items.forEach(function(item, i) {
                        _this.setAt(i, item);
                    });
                    previousValues.forEach(function(previousValue, i) {
                        _this.setAt(addedLength + i, previousValue);
                    });
                    return length + addedLength;
                };
                /**
             * Returns the index of the first occurrence of a value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
             */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
                };
                /**
             * Returns the index of the last occurrence of a specified value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
             */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
                    if (fromIndex === void 0) fromIndex = this.length - 1;
                    return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
                };
                /**
             * Determines whether all the members of an array satisfy the specified test.
             * @param callbackfn A function that accepts up to three arguments. The every method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value false, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).every(callbackfn, thisArg);
                };
                /**
             * Determines whether the specified callback function returns true for any element of an array.
             * @param callbackfn A function that accepts up to three arguments. The some method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value true, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).some(callbackfn, thisArg);
                };
                /**
             * Performs the specified action for each element in an array.
             * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
             * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
                    Array.from(this.$items.values()).forEach(callbackfn, thisArg);
                };
                /**
             * Calls a defined callback function on each element of an array, and returns an array that contains the results.
             * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).map(callbackfn, thisArg);
                };
                ArraySchema.prototype.filter = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).filter(callbackfn, thisArg);
                };
                /**
             * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
                    return Array.from(this.$items.values()).reduce(callbackfn, initialValue);
                };
                /**
             * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
                    return Array.from(this.$items.values()).reduceRight(callbackfn, initialValue);
                };
                /**
             * Returns the value of the first element in the array where predicate is true, and undefined
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found, find
             * immediately returns that element value. Otherwise, find returns undefined.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.find = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).find(predicate, thisArg);
                };
                /**
             * Returns the index of the first element in the array where predicate is true, and -1
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found,
             * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).findIndex(predicate, thisArg);
                };
                /**
             * Returns the this object after filling the section identified by start and end with value
             * @param value value to fill array section with
             * @param start index to start filling the array at. If start is negative, it is treated as
             * length+start where length is the length of the array.
             * @param end index to stop filling the array at. If end is negative, it is treated as
             * length+end.
             */ ArraySchema.prototype.fill = function(value, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#fill() not implemented");
                };
                /**
             * Returns the this object after copying a section of the array identified by start and end
             * to the same array starting at position target
             * @param target If target is negative, it is treated as length+target where length is the
             * length of the array.
             * @param start If start is negative, it is treated as length+start. If end is negative, it
             * is treated as length+end.
             * @param end If not specified, length of the this object is used as its default value.
             */ ArraySchema.prototype.copyWithin = function(target, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#copyWithin() not implemented");
                };
                /**
             * Returns a string representation of an array.
             */ ArraySchema.prototype.toString = function() {
                    return this.$items.toString();
                };
                /**
             * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
             */ ArraySchema.prototype.toLocaleString = function() {
                    return this.$items.toLocaleString();
                };
                /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
                    return Array.from(this.$items.values())[Symbol.iterator]();
                };
                ArraySchema.prototype[Symbol.unscopables] = function() {
                    return this.$items[Symbol.unscopables]();
                };
                /**
             * Returns an iterable of key, value pairs for every entry in the array
             */ ArraySchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                /**
             * Returns an iterable of keys in the array
             */ ArraySchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                /**
             * Returns an iterable of values in the array
             */ ArraySchema.prototype.values = function() {
                    return this.$items.values();
                };
                /**
             * Determines whether an array includes a certain element, returning true or false as appropriate.
             * @param searchElement The element to search for.
             * @param fromIndex The position in this array at which to begin searching for searchElement.
             */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).includes(searchElement, fromIndex);
                };
                /**
             * Calls a defined callback function on each element of an array. Then, flattens the result into
             * a new array.
             * This is identical to a map followed by flat with depth 1.
             *
             * @param callback A function that accepts up to three arguments. The flatMap method calls the
             * callback function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callback function. If
             * thisArg is omitted, undefined is used as the this value.
             */ // @ts-ignore
                ArraySchema.prototype.flatMap = function(callback, thisArg) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flatMap() is not supported.");
                };
                /**
             * Returns a new array with all sub-array elements concatenated into it recursively up to the
             * specified depth.
             *
             * @param depth The maximum recursion depth
             */ // @ts-ignore
                ArraySchema.prototype.flat = function(depth) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flat() is not supported.");
                };
                // get size () {
                //     return this.$items.size;
                // }
                ArraySchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                ArraySchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                ArraySchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                ArraySchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                ArraySchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                ArraySchema.prototype.toJSON = function() {
                    return this.toArray().map(function(value) {
                        return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                };
                //
                // Decoding utilities
                //
                ArraySchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()))))();
                    else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], this.map(function(item) {
                        return item["$changes"] ? item.clone() : item;
                    }))))();
                    return cloned;
                };
                ArraySchema.prototype.triggerAll = function() {
                    Schema.prototype.triggerAll.apply(this);
                };
                return ArraySchema;
            }();
            function getMapProxy(value) {
                value["$proxy"] = true;
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && // accessing properties
                        typeof obj[prop] === "undefined") return obj.get(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                        else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        obj.delete(prop);
                        return true;
                    }
                });
                return value;
            }
            var MapSchema = /** @class */ function() {
                function MapSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) {
                        if (initialValues instanceof Map) initialValues.forEach(function(v, k) {
                            return _this.set(k, v);
                        });
                        else for(var k in initialValues)this.set(k, initialValues[k]);
                    }
                }
                MapSchema.is = function(type) {
                    return type["map"] !== undefined;
                };
                /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
                    return this.$items[Symbol.iterator]();
                };
                Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.$items[Symbol.toStringTag];
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.set = function(key, value) {
                    if (value === undefined || value === null) throw new Error("MapSchema#set('" + key + "', " + value + "): trying to set " + value + " value on '" + key + "'.");
                    // get "index" for this value.
                    var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
                    var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
                    var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    //
                    // (encoding)
                    // set a unique id to relate directly with this key/value.
                    //
                    if (!hasIndex) {
                        this.$changes.indexes[key] = index;
                        this.$indexes.set(index, key);
                    } else if (isRef && // if is schema, force ADD operation if value differ from previous one.
                    this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
                    this.$items.set(key, value);
                    this.$changes.change(key, operation);
                    return this;
                };
                MapSchema.prototype.get = function(key) {
                    return this.$items.get(key);
                };
                MapSchema.prototype.delete = function(key) {
                    //
                    // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
                    //
                    // We don't remove $indexes to allow setting the same key in the same patch
                    // (See "should allow to remove and set an item in the same place" test)
                    //
                    // // const index = this.$changes.indexes[key];
                    // // this.$indexes.delete(index);
                    this.$changes.delete(key);
                    return this.$items.delete(key);
                };
                MapSchema.prototype.clear = function(isDecoding) {
                    var _this = this;
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    // flag child items for garbage collection.
                    if (isDecoding && typeof this.$changes.getType() !== "string") this.$items.forEach(function(item) {
                        _this.$changes.root.removeRef(item["$changes"].refId);
                    });
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                MapSchema.prototype.has = function(key) {
                    return this.$items.has(key);
                };
                MapSchema.prototype.forEach = function(callbackfn) {
                    this.$items.forEach(callbackfn);
                };
                MapSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                MapSchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                MapSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(MapSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                MapSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                MapSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                MapSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                MapSchema.prototype.toJSON = function() {
                    var map = {};
                    this.forEach(function(value, key) {
                        map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                    return map;
                };
                //
                // Decoding utilities
                //
                MapSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new MapSchema(), this);
                    else {
                        // server-side
                        cloned = new MapSchema();
                        this.forEach(function(value, key) {
                            if (value["$changes"]) cloned.set(key, value["clone"]());
                            else cloned.set(key, value);
                        });
                    }
                    return cloned;
                };
                MapSchema.prototype.triggerAll = function() {
                    Schema.prototype.triggerAll.apply(this);
                };
                return MapSchema;
            }();
            var registeredTypes = {};
            function registerType(identifier, definition) {
                registeredTypes[identifier] = definition;
            }
            function getType(identifier) {
                return registeredTypes[identifier];
            }
            var SchemaDefinition = /** @class */ function() {
                function SchemaDefinition() {
                    //
                    // TODO: use a "field" structure combining all these properties per-field.
                    //
                    this.indexes = {};
                    this.fieldsByIndex = {};
                    this.deprecated = {};
                    this.descriptors = {};
                }
                SchemaDefinition.create = function(parent) {
                    var definition = new SchemaDefinition();
                    // support inheritance
                    definition.schema = Object.assign({}, parent && parent.schema || {});
                    definition.indexes = Object.assign({}, parent && parent.indexes || {});
                    definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
                    definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
                    definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
                    return definition;
                };
                SchemaDefinition.prototype.addField = function(field, type) {
                    var index = this.getNextFieldIndex();
                    this.fieldsByIndex[index] = field;
                    this.indexes[field] = index;
                    this.schema[field] = Array.isArray(type) ? {
                        array: type[0]
                    } : type;
                };
                SchemaDefinition.prototype.addFilter = function(field, cb) {
                    if (!this.filters) {
                        this.filters = {};
                        this.indexesWithFilters = [];
                    }
                    this.filters[this.indexes[field]] = cb;
                    this.indexesWithFilters.push(this.indexes[field]);
                    return true;
                };
                SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
                    var index = this.indexes[field];
                    var type = this.schema[field];
                    if (getType(Object.keys(type)[0])) {
                        if (!this.childFilters) this.childFilters = {};
                        this.childFilters[index] = cb;
                        return true;
                    } else console.warn("@filterChildren: field '" + field + "' can't have children. Ignoring filter.");
                };
                SchemaDefinition.prototype.getChildrenFilter = function(field) {
                    return this.childFilters && this.childFilters[this.indexes[field]];
                };
                SchemaDefinition.prototype.getNextFieldIndex = function() {
                    return Object.keys(this.schema || {}).length;
                };
                return SchemaDefinition;
            }();
            function hasFilter(klass) {
                return klass._context && klass._context.useFilters;
            }
            var Context = /** @class */ function() {
                function Context() {
                    this.types = {};
                    this.schemas = new Map();
                    this.useFilters = false;
                }
                Context.prototype.has = function(schema) {
                    return this.schemas.has(schema);
                };
                Context.prototype.get = function(typeid) {
                    return this.types[typeid];
                };
                Context.prototype.add = function(schema, typeid) {
                    if (typeid === void 0) typeid = this.schemas.size;
                    // FIXME: move this to somewhere else?
                    // support inheritance
                    schema._definition = SchemaDefinition.create(schema._definition);
                    schema._typeid = typeid;
                    this.types[typeid] = schema;
                    this.schemas.set(schema, typeid);
                };
                Context.create = function(context) {
                    if (context === void 0) context = new Context;
                    return function(definition) {
                        return type(definition, context);
                    };
                };
                return Context;
            }();
            var globalContext = new Context();
            /**
         * `@type()` decorator for proxies
         */ function type(type, context) {
                if (context === void 0) context = globalContext;
                return function(target, field) {
                    var constructor = target.constructor;
                    constructor._context = context;
                    /*
                 * static schema
                 */ if (!context.has(constructor)) context.add(constructor);
                    var definition = constructor._definition;
                    definition.addField(field, type);
                    /**
                 * skip if descriptor already exists for this field (`@deprecated()`)
                 */ if (definition.descriptors[field]) {
                        if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                        return;
                        else // trying to define same property multiple times across inheritance.
                        // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                        try {
                            throw new Error("@colyseus/schema: Duplicate '" + field + "' definition on '" + constructor.name + "'.\nCheck @type() annotation");
                        } catch (e) {
                            var definitionAtLine = e.stack.split("\n")[4].trim();
                            throw new Error(e.message + " " + definitionAtLine);
                        }
                    }
                    var isArray = ArraySchema.is(type);
                    var isMap = !isArray && MapSchema.is(type);
                    // TODO: refactor me.
                    // Allow abstract intermediary classes with no fields to be serialized
                    // (See "should support an inheritance with a Schema type without fields" test)
                    if (typeof type !== "string" && !Schema.is(type)) {
                        var childType = Object.values(type)[0];
                        if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
                    }
                    var fieldCached = "_" + field;
                    definition.descriptors[fieldCached] = {
                        enumerable: false,
                        configurable: false,
                        writable: true
                    };
                    definition.descriptors[field] = {
                        get: function() {
                            return this[fieldCached];
                        },
                        set: function(value) {
                            /**
                         * Create Proxy for array or map items
                         */ // skip if value is the same as cached.
                            if (value === this[fieldCached]) return;
                            if (value !== undefined && value !== null) {
                                // automaticallty transform Array into ArraySchema
                                if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                                    void 0
                                ], value)))();
                                // automaticallty transform Map into MapSchema
                                if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                                // try to turn provided structure into a Proxy
                                if (value["$proxy"] === undefined) {
                                    if (isMap) value = getMapProxy(value);
                                    else if (isArray) value = getArrayProxy(value);
                                }
                                // flag the change for encoding.
                                this.$changes.change(field);
                                //
                                // call setParent() recursively for this and its child
                                // structures.
                                //
                                if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                            } else //
                            // Setting a field to `null` or `undefined` will delete it.
                            //
                            this.$changes.delete(field);
                            this[fieldCached] = value;
                        },
                        enumerable: true,
                        configurable: true
                    };
                };
            }
            /**
         * `@filter()` decorator for defining data filters per client
         */ function filter(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            function filterChildren(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            /**
         * `@deprecated()` flag a field as deprecated.
         * The previous `@type()` annotation should remain along with this one.
         */ function deprecated(throws, context) {
                if (throws === void 0) throws = true;
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    definition.deprecated[field] = true;
                    if (throws) definition.descriptors[field] = {
                        get: function() {
                            throw new Error(field + " is deprecated.");
                        },
                        set: function(value) {},
                        enumerable: false,
                        configurable: true
                    };
                };
            }
            function defineTypes(target, fields, context) {
                if (context === void 0) context = target._context || globalContext;
                for(var field in fields)type(fields[field], context)(target.prototype, field);
                return target;
            }
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ /**
         * msgpack implementation highly based on notepack.io
         * https://github.com/darrachequesne/notepack
         */ function utf8Length(str) {
                var c = 0, length = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) length += 1;
                    else if (c < 0x800) length += 2;
                    else if (c < 0xd800 || c >= 0xe000) length += 3;
                    else {
                        i++;
                        length += 4;
                    }
                }
                return length;
            }
            function utf8Write(view, offset, str) {
                var c = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) view[offset++] = c;
                    else if (c < 0x800) {
                        view[offset++] = 0xc0 | c >> 6;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800 || c >= 0xe000) {
                        view[offset++] = 0xe0 | c >> 12;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else {
                        i++;
                        c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                        view[offset++] = 0xf0 | c >> 18;
                        view[offset++] = 0x80 | c >> 12 & 0x3f;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    }
                }
            }
            function int8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function uint8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function int16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function uint16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function int32$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
                bytes.push(value >> 16 & 255);
                bytes.push(value >> 24 & 255);
            }
            function uint32$1(bytes, value) {
                var b4 = value >> 24;
                var b3 = value >> 16;
                var b2 = value >> 8;
                var b1 = value;
                bytes.push(b1 & 255);
                bytes.push(b2 & 255);
                bytes.push(b3 & 255);
                bytes.push(b4 & 255);
            }
            function int64$1(bytes, value) {
                var high = Math.floor(value / Math.pow(2, 32));
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function uint64$1(bytes, value) {
                var high = value / Math.pow(2, 32) >> 0;
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function float32$1(bytes, value) {
                writeFloat32(bytes, value);
            }
            function float64$1(bytes, value) {
                writeFloat64(bytes, value);
            }
            var _int32$1 = new Int32Array(2);
            var _float32$1 = new Float32Array(_int32$1.buffer);
            var _float64$1 = new Float64Array(_int32$1.buffer);
            function writeFloat32(bytes, value) {
                _float32$1[0] = value;
                int32$1(bytes, _int32$1[0]);
            }
            function writeFloat64(bytes, value) {
                _float64$1[0] = value;
                int32$1(bytes, _int32$1[0]);
                int32$1(bytes, _int32$1[1]);
            }
            function boolean$1(bytes, value) {
                return uint8$1(bytes, value ? 1 : 0);
            }
            function string$1(bytes, value) {
                // encode `null` strings as empty.
                if (!value) value = "";
                var length = utf8Length(value);
                var size = 0;
                // fixstr
                if (length < 0x20) {
                    bytes.push(length | 0xa0);
                    size = 1;
                } else if (length < 0x100) {
                    bytes.push(0xd9);
                    uint8$1(bytes, length);
                    size = 2;
                } else if (length < 0x10000) {
                    bytes.push(0xda);
                    uint16$1(bytes, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdb);
                    uint32$1(bytes, length);
                    size = 5;
                } else throw new Error("String too long");
                utf8Write(bytes, bytes.length, value);
                return size + length;
            }
            function number$1(bytes, value) {
                if (isNaN(value)) return number$1(bytes, 0);
                else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
                else if (value !== (value | 0)) {
                    bytes.push(0xcb);
                    writeFloat64(bytes, value);
                    return 9;
                // TODO: encode float 32?
                // is it possible to differentiate between float32 / float64 here?
                // // float 32
                // bytes.push(0xca);
                // writeFloat32(bytes, value);
                // return 5;
                }
                if (value >= 0) {
                    // positive fixnum
                    if (value < 0x80) {
                        uint8$1(bytes, value);
                        return 1;
                    }
                    // uint 8
                    if (value < 0x100) {
                        bytes.push(0xcc);
                        uint8$1(bytes, value);
                        return 2;
                    }
                    // uint 16
                    if (value < 0x10000) {
                        bytes.push(0xcd);
                        uint16$1(bytes, value);
                        return 3;
                    }
                    // uint 32
                    if (value < 0x100000000) {
                        bytes.push(0xce);
                        uint32$1(bytes, value);
                        return 5;
                    }
                    // uint 64
                    bytes.push(0xcf);
                    uint64$1(bytes, value);
                    return 9;
                } else {
                    // negative fixnum
                    if (value >= -32) {
                        bytes.push(0xe0 | value + 0x20);
                        return 1;
                    }
                    // int 8
                    if (value >= -128) {
                        bytes.push(0xd0);
                        int8$1(bytes, value);
                        return 2;
                    }
                    // int 16
                    if (value >= -32768) {
                        bytes.push(0xd1);
                        int16$1(bytes, value);
                        return 3;
                    }
                    // int 32
                    if (value >= -2147483648) {
                        bytes.push(0xd2);
                        int32$1(bytes, value);
                        return 5;
                    }
                    // int 64
                    bytes.push(0xd3);
                    int64$1(bytes, value);
                    return 9;
                }
            }
            var encode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                utf8Write: utf8Write,
                int8: int8$1,
                uint8: uint8$1,
                int16: int16$1,
                uint16: uint16$1,
                int32: int32$1,
                uint32: uint32$1,
                int64: int64$1,
                uint64: uint64$1,
                float32: float32$1,
                float64: float64$1,
                writeFloat32: writeFloat32,
                writeFloat64: writeFloat64,
                boolean: boolean$1,
                string: string$1,
                number: number$1
            });
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ function utf8Read(bytes, offset, length) {
                var string = "", chr = 0;
                for(var i = offset, end = offset + length; i < end; i++){
                    var byte = bytes[i];
                    if ((byte & 0x80) === 0x00) {
                        string += String.fromCharCode(byte);
                        continue;
                    }
                    if ((byte & 0xe0) === 0xc0) {
                        string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                        continue;
                    }
                    if ((byte & 0xf0) === 0xe0) {
                        string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                        continue;
                    }
                    if ((byte & 0xf8) === 0xf0) {
                        chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                        if (chr >= 0x010000) {
                            chr -= 0x010000;
                            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                        } else string += String.fromCharCode(chr);
                        continue;
                    }
                    console.error("Invalid byte " + byte.toString(16));
                // (do not throw error to avoid server/client from crashing due to hack attemps)
                // throw new Error('Invalid byte ' + byte.toString(16));
                }
                return string;
            }
            function int8(bytes, it) {
                return uint8(bytes, it) << 24 >> 24;
            }
            function uint8(bytes, it) {
                return bytes[it.offset++];
            }
            function int16(bytes, it) {
                return uint16(bytes, it) << 16 >> 16;
            }
            function uint16(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8;
            }
            function int32(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
            }
            function uint32(bytes, it) {
                return int32(bytes, it) >>> 0;
            }
            function float32(bytes, it) {
                return readFloat32(bytes, it);
            }
            function float64(bytes, it) {
                return readFloat64(bytes, it);
            }
            function int64(bytes, it) {
                var low = uint32(bytes, it);
                var high = int32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            function uint64(bytes, it) {
                var low = uint32(bytes, it);
                var high = uint32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            var _int32 = new Int32Array(2);
            var _float32 = new Float32Array(_int32.buffer);
            var _float64 = new Float64Array(_int32.buffer);
            function readFloat32(bytes, it) {
                _int32[0] = int32(bytes, it);
                return _float32[0];
            }
            function readFloat64(bytes, it) {
                _int32[0] = int32(bytes, it);
                _int32[1] = int32(bytes, it);
                return _float64[0];
            }
            function boolean(bytes, it) {
                return uint8(bytes, it) > 0;
            }
            function string(bytes, it) {
                var prefix = bytes[it.offset++];
                var length;
                if (prefix < 0xc0) // fixstr
                length = prefix & 0x1f;
                else if (prefix === 0xd9) length = uint8(bytes, it);
                else if (prefix === 0xda) length = uint16(bytes, it);
                else if (prefix === 0xdb) length = uint32(bytes, it);
                var value = utf8Read(bytes, it.offset, length);
                it.offset += length;
                return value;
            }
            function stringCheck(bytes, it) {
                var prefix = bytes[it.offset];
                return(// fixstr
                prefix < 0xc0 && prefix > 0xa0 || // str 8
                prefix === 0xd9 || // str 16
                prefix === 0xda || // str 32
                prefix === 0xdb);
            }
            function number(bytes, it) {
                var prefix = bytes[it.offset++];
                if (prefix < 0x80) // positive fixint
                return prefix;
                else if (prefix === 0xca) // float 32
                return readFloat32(bytes, it);
                else if (prefix === 0xcb) // float 64
                return readFloat64(bytes, it);
                else if (prefix === 0xcc) // uint 8
                return uint8(bytes, it);
                else if (prefix === 0xcd) // uint 16
                return uint16(bytes, it);
                else if (prefix === 0xce) // uint 32
                return uint32(bytes, it);
                else if (prefix === 0xcf) // uint 64
                return uint64(bytes, it);
                else if (prefix === 0xd0) // int 8
                return int8(bytes, it);
                else if (prefix === 0xd1) // int 16
                return int16(bytes, it);
                else if (prefix === 0xd2) // int 32
                return int32(bytes, it);
                else if (prefix === 0xd3) // int 64
                return int64(bytes, it);
                else if (prefix > 0xdf) // negative fixint
                return (0xff - prefix + 1) * -1;
            }
            function numberCheck(bytes, it) {
                var prefix = bytes[it.offset];
                // positive fixint - 0x00 - 0x7f
                // float 32        - 0xca
                // float 64        - 0xcb
                // uint 8          - 0xcc
                // uint 16         - 0xcd
                // uint 32         - 0xce
                // uint 64         - 0xcf
                // int 8           - 0xd0
                // int 16          - 0xd1
                // int 32          - 0xd2
                // int 64          - 0xd3
                return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
            }
            function arrayCheck(bytes, it) {
                return bytes[it.offset] < 0xa0;
            // const prefix = bytes[it.offset] ;
            // if (prefix < 0xa0) {
            //   return prefix;
            // // array
            // } else if (prefix === 0xdc) {
            //   it.offset += 2;
            // } else if (0xdd) {
            //   it.offset += 4;
            // }
            // return prefix;
            }
            function switchStructureCheck(bytes, it) {
                return(// previous byte should be `SWITCH_TO_STRUCTURE`
                bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
                (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
            }
            var decode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                int8: int8,
                uint8: uint8,
                int16: int16,
                uint16: uint16,
                int32: int32,
                uint32: uint32,
                float32: float32,
                float64: float64,
                int64: int64,
                uint64: uint64,
                readFloat32: readFloat32,
                readFloat64: readFloat64,
                boolean: boolean,
                string: string,
                stringCheck: stringCheck,
                number: number,
                numberCheck: numberCheck,
                arrayCheck: arrayCheck,
                switchStructureCheck: switchStructureCheck
            });
            var CollectionSchema = /** @class */ function() {
                function CollectionSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                CollectionSchema.is = function(type) {
                    return type["collection"] !== undefined;
                };
                CollectionSchema.prototype.add = function(value) {
                    // set "index" for reference.
                    var index = this.$refId++;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index);
                    return index;
                };
                CollectionSchema.prototype.at = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                CollectionSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                CollectionSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                CollectionSchema.prototype.clear = function(isDecoding) {
                    var _this = this;
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    // flag child items for garbage collection.
                    if (isDecoding && typeof this.$changes.getType() !== "string") this.$items.forEach(function(item) {
                        _this.$changes.root.removeRef(item["$changes"].refId);
                    });
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                CollectionSchema.prototype.has = function(value) {
                    return Array.from(this.$items.values()).some(function(v) {
                        return v === value;
                    });
                };
                CollectionSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                CollectionSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(CollectionSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                CollectionSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                CollectionSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                CollectionSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                CollectionSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                CollectionSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                CollectionSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                CollectionSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new CollectionSchema(), this);
                    else {
                        // server-side
                        cloned = new CollectionSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                CollectionSchema.prototype.triggerAll = function() {
                    Schema.prototype.triggerAll.apply(this);
                };
                return CollectionSchema;
            }();
            var SetSchema = /** @class */ function() {
                function SetSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                SetSchema.is = function(type) {
                    return type["set"] !== undefined;
                };
                SetSchema.prototype.add = function(value) {
                    var _a, _b;
                    // immediatelly return false if value already added.
                    if (this.has(value)) return false;
                    // set "index" for reference.
                    var index = this.$refId++;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                    return index;
                };
                SetSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                SetSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                SetSchema.prototype.clear = function(isDecoding) {
                    var _this = this;
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    // flag child items for garbage collection.
                    if (isDecoding && typeof this.$changes.getType() !== "string") this.$items.forEach(function(item) {
                        _this.$changes.root.removeRef(item["$changes"].refId);
                    });
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                SetSchema.prototype.has = function(value) {
                    var values = this.$items.values();
                    var has = false;
                    var entry;
                    while(entry = values.next()){
                        if (entry.done) break;
                        if (value === entry.value) {
                            has = true;
                            break;
                        }
                    }
                    return has;
                };
                SetSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                SetSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(SetSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                SetSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                SetSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                SetSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                SetSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                SetSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                SetSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                SetSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new SetSchema(), this);
                    else {
                        // server-side
                        cloned = new SetSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                SetSchema.prototype.triggerAll = function() {
                    Schema.prototype.triggerAll.apply(this);
                };
                return SetSchema;
            }();
            /**
         * Extracted from https://www.npmjs.com/package/strong-events
         */ var EventEmitter_ = /** @class */ function() {
                function EventEmitter_() {
                    this.handlers = [];
                }
                EventEmitter_.prototype.register = function(cb, once) {
                    this.handlers.push(cb);
                    return this;
                };
                EventEmitter_.prototype.invoke = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.handlers.forEach(function(handler) {
                        return handler.apply(void 0, args);
                    });
                };
                EventEmitter_.prototype.invokeAsync = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    return Promise.all(this.handlers.map(function(handler) {
                        return handler.apply(void 0, args);
                    }));
                };
                EventEmitter_.prototype.remove = function(cb) {
                    var index = this.handlers.indexOf(cb);
                    this.handlers[index] = this.handlers[this.handlers.length - 1];
                    this.handlers.pop();
                };
                EventEmitter_.prototype.clear = function() {
                    this.handlers = [];
                };
                return EventEmitter_;
            }();
            var ClientState = /** @class */ function() {
                function ClientState() {
                    this.refIds = new WeakSet();
                    this.containerIndexes = new WeakMap();
                }
                // containerIndexes = new Map<ChangeTree, Set<number>>();
                ClientState.prototype.addRefId = function(changeTree) {
                    if (!this.refIds.has(changeTree)) {
                        this.refIds.add(changeTree);
                        this.containerIndexes.set(changeTree, new Set());
                    }
                };
                ClientState.get = function(client) {
                    if (client.$filterState === undefined) client.$filterState = new ClientState();
                    return client.$filterState;
                };
                return ClientState;
            }();
            var EncodeSchemaError = /** @class */ function(_super) {
                __extends(EncodeSchemaError, _super);
                function EncodeSchemaError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EncodeSchemaError;
            }(Error);
            function assertType(value, type, klass, field) {
                var typeofTarget;
                var allowNull = false;
                switch(type){
                    case "number":
                    case "int8":
                    case "uint8":
                    case "int16":
                    case "uint16":
                    case "int32":
                    case "uint32":
                    case "int64":
                    case "uint64":
                    case "float32":
                    case "float64":
                        typeofTarget = "number";
                        if (isNaN(value)) console.log('trying to encode "NaN" in ' + klass.constructor.name + "#" + field);
                        break;
                    case "string":
                        typeofTarget = "string";
                        allowNull = true;
                        break;
                    case "boolean":
                        // boolean is always encoded as true/false based on truthiness
                        return;
                }
                if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
                    var foundValue = "'" + JSON.stringify(value) + "'" + (value && value.constructor && " (" + value.constructor.name + ")" || "");
                    throw new EncodeSchemaError("a '" + typeofTarget + "' was expected, but " + foundValue + " was provided in " + klass.constructor.name + "#" + field);
                }
            }
            function assertInstanceType(value, type, klass, field) {
                if (!(value instanceof type)) throw new EncodeSchemaError("a '" + type.name + "' was expected, but '" + value.constructor.name + "' was provided in " + klass.constructor.name + "#" + field);
            }
            function encodePrimitiveType(type, bytes, value, klass, field) {
                assertType(value, type, klass, field);
                var encodeFunc = encode[type];
                if (encodeFunc) encodeFunc(bytes, value);
                else throw new EncodeSchemaError("a '" + type + "' was expected, but " + value + " was provided in " + klass.constructor.name + "#" + field);
            }
            function decodePrimitiveType(type, bytes, it) {
                return decode[type](bytes, it);
            }
            /**
         * Schema encoder / decoder
         */ var Schema = /** @class */ function() {
                // allow inherited classes to have a constructor
                function Schema() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    // fix enumerability of fields for end-user
                    Object.defineProperties(this, {
                        $changes: {
                            value: new ChangeTree(this, undefined, new Root()),
                            enumerable: false,
                            writable: true
                        },
                        $listeners: {
                            value: {},
                            enumerable: false,
                            writable: true
                        }
                    });
                    var descriptors = this._definition.descriptors;
                    if (descriptors) Object.defineProperties(this, descriptors);
                    //
                    // Assign initial values
                    //
                    if (args[0]) this.assign(args[0]);
                }
                Schema.onError = function(e) {
                    console.error(e);
                };
                Schema.is = function(type) {
                    return type["_definition"] && type["_definition"].schema !== undefined;
                };
                Schema.prototype.assign = function(props) {
                    Object.assign(this, props);
                    return this;
                };
                Object.defineProperty(Schema.prototype, "_definition", {
                    get: function() {
                        return this.constructor._definition;
                    },
                    enumerable: false,
                    configurable: true
                });
                Schema.prototype.listen = function(attr, callback) {
                    var _this = this;
                    if (!this.$listeners[attr]) this.$listeners[attr] = new EventEmitter_();
                    this.$listeners[attr].register(callback);
                    // return un-register callback.
                    return function() {
                        return _this.$listeners[attr].remove(callback);
                    };
                };
                Schema.prototype.decode = function(bytes, it, ref, allChanges) {
                    if (it === void 0) it = {
                        offset: 0
                    };
                    if (ref === void 0) ref = this;
                    if (allChanges === void 0) allChanges = new Map();
                    var $root = this.$changes.root;
                    var totalBytes = bytes.length;
                    var refId = 0;
                    var changes = [];
                    $root.refs.set(refId, this);
                    allChanges.set(refId, changes);
                    while(it.offset < totalBytes){
                        var byte = bytes[it.offset++];
                        if (byte == SWITCH_TO_STRUCTURE) {
                            refId = number(bytes, it);
                            var nextRef = $root.refs.get(refId);
                            //
                            // Trying to access a reference that haven't been decoded yet.
                            //
                            if (!nextRef) throw new Error('"refId" not found: ' + refId);
                            ref = nextRef;
                            // create empty list of changes for this refId.
                            changes = [];
                            allChanges.set(refId, changes);
                            continue;
                        }
                        var changeTree = ref["$changes"];
                        var isSchema = ref["_definition"] !== undefined;
                        var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                         : byte; // "uncompressed" index + operation (array/map items)
                        if (operation === exports1.OPERATION.CLEAR) {
                            //
                            // TODO: refactor me!
                            // The `.clear()` method is calling `$root.removeRef(refId)` for
                            // each item inside this collection
                            //
                            ref.clear(true);
                            continue;
                        }
                        var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                        ) : number(bytes, it);
                        var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                        var type = changeTree.getType(fieldIndex);
                        var value = void 0;
                        var previousValue = void 0;
                        var dynamicIndex = void 0;
                        if (!isSchema) {
                            previousValue = ref["getByIndex"](fieldIndex);
                            if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                                dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                                ref["setIndex"](fieldIndex, dynamicIndex);
                            } else // here
                            dynamicIndex = ref["getIndex"](fieldIndex);
                        } else previousValue = ref["_" + fieldName];
                        //
                        // Delete operations
                        //
                        if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                            if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                            // Flag `refId` for garbage collection.
                            if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                            value = null;
                        }
                        if (fieldName === undefined) {
                            console.warn("@colyseus/schema: definition mismatch");
                            //
                            // keep skipping next bytes until reaches a known structure
                            // by local decoder.
                            //
                            var nextIterator = {
                                offset: it.offset
                            };
                            while(it.offset < totalBytes){
                                if (switchStructureCheck(bytes, it)) {
                                    nextIterator.offset = it.offset + 1;
                                    if ($root.refs.has(number(bytes, nextIterator))) break;
                                }
                                it.offset++;
                            }
                            continue;
                        } else if (operation === exports1.OPERATION.DELETE) ;
                        else if (Schema.is(type)) {
                            var refId_1 = number(bytes, it);
                            value = $root.refs.get(refId_1);
                            if (operation !== exports1.OPERATION.REPLACE) {
                                var childType = this.getSchemaType(bytes, it, type);
                                if (!value) {
                                    value = this.createTypeInstance(childType);
                                    value.$changes.refId = refId_1;
                                    if (previousValue) {
                                        value.onChange = previousValue.onChange;
                                        value.onRemove = previousValue.onRemove;
                                        value.$listeners = previousValue.$listeners;
                                        if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                                    }
                                }
                                $root.addRef(refId_1, value, value !== previousValue);
                            }
                        } else if (typeof type === "string") //
                        // primitive value (number, string, boolean, etc)
                        //
                        value = decodePrimitiveType(type, bytes, it);
                        else {
                            var typeDef = getType(Object.keys(type)[0]);
                            var refId_2 = number(bytes, it);
                            var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                            value = valueRef.clone(true);
                            value.$changes.refId = refId_2;
                            // preserve schema callbacks
                            if (previousValue) {
                                value.onAdd = previousValue.onAdd;
                                value.onRemove = previousValue.onRemove;
                                value.onChange = previousValue.onChange;
                                if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                                    $root.removeRef(previousValue["$changes"].refId);
                                    //
                                    // Trigger onRemove if structure has been replaced.
                                    //
                                    var deletes = [];
                                    var entries = previousValue.entries();
                                    var iter = void 0;
                                    while((iter = entries.next()) && !iter.done){
                                        var _a = iter.value, key = _a[0], value_1 = _a[1];
                                        deletes.push({
                                            op: exports1.OPERATION.DELETE,
                                            field: key,
                                            value: undefined,
                                            previousValue: value_1
                                        });
                                    }
                                    allChanges.set(previousValue["$changes"].refId, deletes);
                                }
                            }
                            $root.addRef(refId_2, value, valueRef !== previousValue);
                            //
                            // TODO: deprecate proxies on next version.
                            // get proxy to target value.
                            //
                            if (typeDef.getProxy) value = typeDef.getProxy(value);
                        }
                        var hasChange = previousValue !== value;
                        if (value !== null && value !== undefined) {
                            if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                            if (ref instanceof Schema) ref[fieldName] = value;
                            else if (ref instanceof MapSchema) {
                                // const key = ref['$indexes'].get(field);
                                var key = dynamicIndex;
                                // ref.set(key, value);
                                ref["$items"].set(key, value);
                            } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                            // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                            // ref[key] = value;
                            ref.setAt(fieldIndex, value);
                            else if (ref instanceof CollectionSchema) {
                                var index = ref.add(value);
                                ref["setIndex"](fieldIndex, index);
                            } else if (ref instanceof SetSchema) {
                                var index = ref.add(value);
                                if (index !== false) ref["setIndex"](fieldIndex, index);
                            }
                        }
                        if (hasChange) changes.push({
                            op: operation,
                            field: fieldName,
                            dynamicIndex: dynamicIndex,
                            value: value,
                            previousValue: previousValue
                        });
                    }
                    this._triggerChanges(allChanges);
                    // drop references of unused schemas
                    $root.garbageCollectDeletedRefs();
                    return allChanges;
                };
                Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
                    if (encodeAll === void 0) encodeAll = false;
                    if (bytes === void 0) bytes = [];
                    if (useFilters === void 0) useFilters = false;
                    var rootChangeTree = this.$changes;
                    var refIdsVisited = new WeakSet();
                    var changeTrees = [
                        rootChangeTree
                    ];
                    var numChangeTrees = 1;
                    for(var i = 0; i < numChangeTrees; i++){
                        var changeTree = changeTrees[i];
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        // Generate unique refId for the ChangeTree.
                        changeTree.ensureRefId();
                        // mark this ChangeTree as visited.
                        refIdsVisited.add(changeTree);
                        // root `refId` is skipped.
                        if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                            uint8$1(bytes, SWITCH_TO_STRUCTURE);
                            number$1(bytes, changeTree.refId);
                        }
                        var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var operation = encodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            var fieldIndex = operation.index;
                            var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                            // cache begin index if `useFilters`
                            var beginIndex = bytes.length;
                            // encode field index + operation
                            if (operation.op !== exports1.OPERATION.TOUCH) {
                                if (isSchema) //
                                // Compress `fieldIndex` + `operation` into a single byte.
                                // This adds a limitaion of 64 fields per Schema structure
                                //
                                uint8$1(bytes, fieldIndex | operation.op);
                                else {
                                    uint8$1(bytes, operation.op);
                                    // custom operations
                                    if (operation.op === exports1.OPERATION.CLEAR) continue;
                                    // indexed operations
                                    number$1(bytes, fieldIndex);
                                }
                            }
                            //
                            // encode "alias" for dynamic fields (maps)
                            //
                            if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                            ) {
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(bytes, dynamicIndex);
                                }
                            }
                            if (operation.op === exports1.OPERATION.DELETE) continue;
                            // const type = changeTree.childType || ref._schema[field];
                            var type = changeTree.getType(fieldIndex);
                            // const type = changeTree.getType(fieldIndex);
                            var value = changeTree.getValue(fieldIndex);
                            // Enqueue ChangeTree to be visited
                            if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                                changeTrees.push(value["$changes"]);
                                value["$changes"].ensureRefId();
                                numChangeTrees++;
                            }
                            if (operation.op === exports1.OPERATION.TOUCH) continue;
                            if (Schema.is(type)) {
                                assertInstanceType(value, type, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                                // Try to encode inherited TYPE_ID if it's an ADD operation.
                                if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                            } else if (typeof type === "string") //
                            // Primitive values
                            //
                            encodePrimitiveType(type, bytes, value, ref, field);
                            else {
                                //
                                // Custom type (MapSchema, ArraySchema, etc)
                                //
                                var definition = getType(Object.keys(type)[0]);
                                //
                                // ensure a ArraySchema has been provided
                                //
                                assertInstanceType(ref["_" + field], definition.constructor, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                            }
                            if (useFilters) // cache begin / end index
                            changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                        }
                        if (!encodeAll && !useFilters) changeTree.discard();
                    }
                    return bytes;
                };
                Schema.prototype.encodeAll = function(useFilters) {
                    return this.encode(true, [], useFilters);
                };
                Schema.prototype.applyFilters = function(client, encodeAll) {
                    var _a, _b;
                    if (encodeAll === void 0) encodeAll = false;
                    var root = this;
                    var refIdsDissallowed = new Set();
                    var $filterState = ClientState.get(client);
                    var changeTrees = [
                        this.$changes
                    ];
                    var numChangeTrees = 1;
                    var filteredBytes = [];
                    var _loop_1 = function(i) {
                        var changeTree = changeTrees[i];
                        if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                        number$1(filteredBytes, changeTree.refId);
                        var clientHasRefId = $filterState.refIds.has(changeTree);
                        var isEncodeAll = encodeAll || !clientHasRefId;
                        // console.log("REF:", ref.constructor.name);
                        // console.log("Encode all?", isEncodeAll);
                        //
                        // include `changeTree` on list of known refIds by this client.
                        //
                        $filterState.addRefId(changeTree);
                        var containerIndexes = $filterState.containerIndexes.get(changeTree);
                        var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        //
                        // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                        // - see "DELETE a field of Schema" test case.
                        //
                        if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                            var indexesWithFilters = ref._definition.indexesWithFilters;
                            indexesWithFilters.forEach(function(indexWithFilter) {
                                if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                                    if (isEncodeAll) changes.push(indexWithFilter);
                                    else changes.push({
                                        op: exports1.OPERATION.ADD,
                                        index: indexWithFilter
                                    });
                                }
                            });
                        }
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var change = isEncodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            // custom operations
                            if (change.op === exports1.OPERATION.CLEAR) {
                                uint8$1(filteredBytes, change.op);
                                continue;
                            }
                            var fieldIndex = change.index;
                            //
                            // Deleting fields: encode the operation + field index
                            //
                            if (change.op === exports1.OPERATION.DELETE) {
                                //
                                // DELETE operations also need to go through filtering.
                                //
                                // TODO: cache the previous value so we can access the value (primitive or `refId`)
                                // (check against `$filterState.refIds`)
                                //
                                if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                                else {
                                    uint8$1(filteredBytes, change.op);
                                    number$1(filteredBytes, fieldIndex);
                                }
                                continue;
                            }
                            // indexed operation
                            var value = changeTree.getValue(fieldIndex);
                            var type = changeTree.getType(fieldIndex);
                            if (isSchema) {
                                // Is a Schema!
                                var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                                if (filter && !filter.call(ref, client, value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            } else {
                                // Is a collection! (map, array, etc.)
                                var parent = changeTree.parent;
                                var filter = changeTree.getChildrenFilter();
                                if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            }
                            // visit child ChangeTree on further iteration.
                            if (value["$changes"]) {
                                changeTrees.push(value["$changes"]);
                                numChangeTrees++;
                            }
                            //
                            // Copy cached bytes
                            //
                            if (change.op !== exports1.OPERATION.TOUCH) {
                                //
                                // TODO: refactor me!
                                //
                                if (change.op === exports1.OPERATION.ADD || isSchema) {
                                    //
                                    // use cached bytes directly if is from Schema type.
                                    //
                                    filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                                    containerIndexes.add(fieldIndex);
                                } else if (containerIndexes.has(fieldIndex)) //
                                // use cached bytes if already has the field
                                //
                                filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                                else {
                                    //
                                    // force ADD operation if field is not known by this client.
                                    //
                                    containerIndexes.add(fieldIndex);
                                    uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                    number$1(filteredBytes, fieldIndex);
                                    if (ref instanceof MapSchema) {
                                        //
                                        // MapSchema dynamic key
                                        //
                                        var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                        string$1(filteredBytes, dynamicIndex);
                                    }
                                    if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                                    else // "encodePrimitiveType" without type checking.
                                    // the type checking has been done on the first .encode() call.
                                    encode[type](filteredBytes, value);
                                }
                            } else if (value["$changes"] && !isSchema) {
                                //
                                // TODO:
                                // - track ADD/REPLACE/DELETE instances on `$filterState`
                                // - do NOT always encode dynamicIndex for MapSchema.
                                //   (If client already has that key, only the first index is necessary.)
                                //
                                uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                number$1(filteredBytes, fieldIndex);
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(filteredBytes, dynamicIndex);
                                }
                                number$1(filteredBytes, value["$changes"].refId);
                            }
                        }
                    };
                    for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                    return filteredBytes;
                };
                Schema.prototype.clone = function() {
                    var cloned = new this.constructor;
                    var schema = this._definition.schema;
                    for(var field in schema)if (typeof this[field] === "object" && typeof this[field].clone === "function") // deep clone
                    cloned[field] = this[field].clone();
                    else // primitive values
                    cloned[field] = this[field];
                    return cloned;
                };
                Schema.prototype.triggerAll = function() {
                    // skip if haven't received any remote refs yet.
                    if (this.$changes.root.refs.size === 0) return;
                    var allChanges = new Map();
                    Schema.prototype._triggerAllFillChanges.call(this, this, allChanges);
                    try {
                        Schema.prototype._triggerChanges.call(this, allChanges);
                    } catch (e) {
                        Schema.onError(e);
                    }
                };
                Schema.prototype.toJSON = function() {
                    var schema = this._definition.schema;
                    var deprecated = this._definition.deprecated;
                    var obj = {};
                    for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_" + field];
                    return obj;
                };
                Schema.prototype.discardAllChanges = function() {
                    this.$changes.discardAll();
                };
                Schema.prototype.getByIndex = function(index) {
                    return this[this._definition.fieldsByIndex[index]];
                };
                Schema.prototype.deleteByIndex = function(index) {
                    this[this._definition.fieldsByIndex[index]] = undefined;
                };
                Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
                    if (type._typeid !== targetType._typeid) {
                        uint8$1(bytes, TYPE_ID);
                        number$1(bytes, targetType._typeid);
                    }
                };
                Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
                    var type;
                    if (bytes[it.offset] === TYPE_ID) {
                        it.offset++;
                        type = this.constructor._context.get(number(bytes, it));
                    }
                    return type || defaultType;
                };
                Schema.prototype.createTypeInstance = function(type) {
                    var instance = new type();
                    // assign root on $changes
                    instance.$changes.root = this.$changes.root;
                    return instance;
                };
                Schema.prototype._triggerAllFillChanges = function(ref, allChanges) {
                    if (allChanges.has(ref["$changes"].refId)) return;
                    var changes = [];
                    allChanges.set(ref["$changes"].refId || 0, changes);
                    if (ref instanceof Schema) {
                        var schema = ref._definition.schema;
                        for(var fieldName in schema){
                            var _field = "_" + fieldName;
                            var value = ref[_field];
                            if (value !== undefined) {
                                changes.push({
                                    op: exports1.OPERATION.ADD,
                                    field: fieldName,
                                    value: value,
                                    previousValue: undefined
                                });
                                if (value["$changes"] !== undefined) Schema.prototype._triggerAllFillChanges.call(this, value, allChanges);
                            }
                        }
                    } else {
                        var entries = ref.entries();
                        var iter = void 0;
                        while((iter = entries.next()) && !iter.done){
                            var _a = iter.value, key = _a[0], value = _a[1];
                            changes.push({
                                op: exports1.OPERATION.ADD,
                                field: key,
                                dynamicIndex: key,
                                value: value,
                                previousValue: undefined
                            });
                            if (value["$changes"] !== undefined) Schema.prototype._triggerAllFillChanges.call(this, value, allChanges);
                        }
                    }
                };
                Schema.prototype._triggerChanges = function(allChanges) {
                    var _this = this;
                    allChanges.forEach(function(changes, refId) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                        if (changes.length > 0) {
                            var ref = _this.$changes.root.refs.get(refId);
                            var isSchema = ref instanceof Schema;
                            for(var i = 0; i < changes.length; i++){
                                var change = changes[i];
                                var listener = ref["$listeners"] && ref["$listeners"][change.field];
                                if (!isSchema) {
                                    if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) (_b = (_a = ref).onAdd) === null || _b === void 0 || _b.call(_a, change.value, (_c = change.dynamicIndex) !== null && _c !== void 0 ? _c : change.field);
                                    else if (change.op === exports1.OPERATION.DELETE) //
                                    // FIXME: `previousValue` should always be avaiiable.
                                    // ADD + DELETE operations are still encoding DELETE operation.
                                    //
                                    {
                                        if (change.previousValue !== undefined) (_e = (_d = ref).onRemove) === null || _e === void 0 || _e.call(_d, change.previousValue, (_f = change.dynamicIndex) !== null && _f !== void 0 ? _f : change.field);
                                    } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                                        if (change.previousValue !== undefined) (_h = (_g = ref).onRemove) === null || _h === void 0 || _h.call(_g, change.previousValue, change.dynamicIndex);
                                        (_k = (_j = ref).onAdd) === null || _k === void 0 || _k.call(_j, change.value, change.dynamicIndex);
                                    } else if (change.op === exports1.OPERATION.REPLACE || change.value !== change.previousValue) (_m = (_l = ref).onChange) === null || _m === void 0 || _m.call(_l, change.value, change.dynamicIndex);
                                }
                                //
                                // trigger onRemove on child structure.
                                //
                                if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema && change.previousValue.onRemove) change.previousValue.onRemove();
                                if (listener) try {
                                    listener.invoke(change.value, change.previousValue);
                                } catch (e) {
                                    Schema.onError(e);
                                }
                            }
                            if (isSchema) {
                                if (ref.onChange) try {
                                    ref.onChange(changes);
                                } catch (e) {
                                    Schema.onError(e);
                                }
                            }
                        }
                    });
                };
                Schema._definition = SchemaDefinition.create();
                return Schema;
            }();
            function dumpChanges(schema) {
                var changeTrees = [
                    schema["$changes"]
                ];
                var numChangeTrees = 1;
                var dump = {};
                var currentStructure = dump;
                var _loop_1 = function(i) {
                    var changeTree = changeTrees[i];
                    changeTree.changes.forEach(function(change) {
                        var ref = changeTree.ref;
                        var fieldIndex = change.index;
                        var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                        currentStructure[field] = changeTree.getValue(fieldIndex);
                    });
                };
                for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                return dump;
            }
            var reflectionContext = new Context();
            /**
         * Reflection
         */ var ReflectionField = /** @class */ function(_super) {
                __extends(ReflectionField, _super);
                function ReflectionField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "name", void 0);
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "type", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionField.prototype, "referencedType", void 0);
                return ReflectionField;
            }(Schema);
            var ReflectionType = /** @class */ function(_super) {
                __extends(ReflectionType, _super);
                function ReflectionType() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fields = new ArraySchema();
                    return _this;
                }
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionType.prototype, "id", void 0);
                __decorate([
                    type([
                        ReflectionField
                    ], reflectionContext)
                ], ReflectionType.prototype, "fields", void 0);
                return ReflectionType;
            }(Schema);
            var Reflection = /** @class */ function(_super) {
                __extends(Reflection, _super);
                function Reflection() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.types = new ArraySchema();
                    return _this;
                }
                Reflection.encode = function(instance) {
                    var rootSchemaType = instance.constructor;
                    var reflection = new Reflection();
                    reflection.rootType = rootSchemaType._typeid;
                    var buildType = function(currentType, schema) {
                        for(var fieldName in schema){
                            var field = new ReflectionField();
                            field.name = fieldName;
                            var fieldType = void 0;
                            if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                            else {
                                var type_1 = schema[fieldName];
                                var childTypeSchema = void 0;
                                //
                                // TODO: refactor below.
                                //
                                if (Schema.is(type_1)) {
                                    fieldType = "ref";
                                    childTypeSchema = schema[fieldName];
                                } else {
                                    fieldType = Object.keys(type_1)[0];
                                    if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                                    else childTypeSchema = type_1[fieldType];
                                }
                                field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                            }
                            field.type = fieldType;
                            currentType.fields.push(field);
                        }
                        reflection.types.push(currentType);
                    };
                    var types = rootSchemaType._context.types;
                    for(var typeid in types){
                        var type_2 = new ReflectionType();
                        type_2.id = Number(typeid);
                        buildType(type_2, types[typeid]._definition.schema);
                    }
                    return reflection.encodeAll();
                };
                Reflection.decode = function(bytes, it) {
                    var context = new Context();
                    var reflection = new Reflection();
                    reflection.decode(bytes, it);
                    var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                        var schema = /** @class */ function(_super) {
                            __extends(_, _super);
                            function _() {
                                return _super !== null && _super.apply(this, arguments) || this;
                            }
                            return _;
                        }(Schema);
                        var typeid = reflectionType.id;
                        types[typeid] = schema;
                        context.add(schema, typeid);
                        return types;
                    }, {});
                    reflection.types.forEach(function(reflectionType) {
                        var schemaType = schemaTypes[reflectionType.id];
                        reflectionType.fields.forEach(function(field) {
                            var _a;
                            if (field.referencedType !== undefined) {
                                var fieldType = field.type;
                                var refType = schemaTypes[field.referencedType];
                                // map or array of primitive type (-1)
                                if (!refType) {
                                    var typeInfo = field.type.split(":");
                                    fieldType = typeInfo[0];
                                    refType = typeInfo[1];
                                }
                                if (fieldType === "ref") type(refType, context)(schemaType.prototype, field.name);
                                else type((_a = {}, _a[fieldType] = refType, _a), context)(schemaType.prototype, field.name);
                            } else type(field.type, context)(schemaType.prototype, field.name);
                        });
                    });
                    var rootType = schemaTypes[reflection.rootType];
                    var rootInstance = new rootType();
                    /**
                 * auto-initialize referenced types on root type
                 * to allow registering listeners immediatelly on client-side
                 */ for(var fieldName in rootType._definition.schema){
                        var fieldType = rootType._definition.schema[fieldName];
                        if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                         : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
                    }
                    return rootInstance;
                };
                __decorate([
                    type([
                        ReflectionType
                    ], reflectionContext)
                ], Reflection.prototype, "types", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], Reflection.prototype, "rootType", void 0);
                return Reflection;
            }(Schema);
            registerType("map", {
                constructor: MapSchema,
                getProxy: getMapProxy
            });
            registerType("array", {
                constructor: ArraySchema,
                getProxy: getArrayProxy
            });
            registerType("set", {
                constructor: SetSchema
            });
            registerType("collection", {
                constructor: CollectionSchema
            });
            exports1.ArraySchema = ArraySchema;
            exports1.CollectionSchema = CollectionSchema;
            exports1.Context = Context;
            exports1.MapSchema = MapSchema;
            exports1.Reflection = Reflection;
            exports1.ReflectionField = ReflectionField;
            exports1.ReflectionType = ReflectionType;
            exports1.Schema = Schema;
            exports1.SchemaDefinition = SchemaDefinition;
            exports1.SetSchema = SetSchema;
            exports1.decode = decode;
            exports1.defineTypes = defineTypes;
            exports1.deprecated = deprecated;
            exports1.dumpChanges = dumpChanges;
            exports1.encode = encode;
            exports1.filter = filter;
            exports1.filterChildren = filterChildren;
            exports1.hasFilter = hasFilter;
            exports1.registerType = registerType;
            exports1.type = type;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var Room = /** @class */ function() {
        function Room(name, rootSchema) {
            var _this = this;
            // Public signals
            this.onStateChange = createSignal();
            this.onError = createSignal();
            this.onLeave = createSignal();
            this.onJoin = createSignal();
            this.hasJoined = false;
            this.onMessageHandlers = createNanoEvents();
            this.id = null;
            this.name = name;
            if (rootSchema) {
                this.serializer = new (getSerializer("schema"));
                this.rootSchema = rootSchema;
                this.serializer.state = new rootSchema();
            }
            this.onError(function(code, message) {
                return console.warn("colyseus.js - onError => (" + code + ") " + message);
            });
            this.onLeave(function() {
                return _this.removeAllListeners();
            });
        }
        Room.prototype.connect = function(endpoint) {
            var _this = this;
            this.connection = new Connection();
            this.connection.events.onmessage = this.onMessageCallback.bind(this);
            this.connection.events.onclose = function(e) {
                if (!_this.hasJoined) {
                    console.warn("Room connection was closed unexpectedly (" + e.code + "): " + e.reason);
                    _this.onError.invoke(e.code, e.reason);
                    return;
                }
                _this.onLeave.invoke(e.code);
                _this.destroy();
            };
            this.connection.events.onerror = function(e) {
                console.warn("Room, onError (" + e.code + "): " + e.reason);
                _this.onError.invoke(e.code, e.reason);
            };
            this.connection.connect(endpoint);
        };
        Room.prototype.leave = function(consented) {
            var _this = this;
            if (consented === void 0) consented = true;
            return new Promise(function(resolve) {
                _this.onLeave(function(code) {
                    return resolve(code);
                });
                if (_this.connection) {
                    if (consented) _this.connection.send([
                        exports1.Protocol.LEAVE_ROOM
                    ]);
                    else _this.connection.close();
                } else _this.onLeave.invoke(4000); // "consented" code
            });
        };
        Room.prototype.onMessage = function(type, callback) {
            return this.onMessageHandlers.on(this.getMessageHandlerKey(type), callback);
        };
        Room.prototype.send = function(type, message) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            if (message !== undefined) {
                var encoded = encode(message);
                arr = new Uint8Array(initialBytes.length + encoded.byteLength);
                arr.set(new Uint8Array(initialBytes), 0);
                arr.set(new Uint8Array(encoded), initialBytes.length);
            } else arr = new Uint8Array(initialBytes);
            this.connection.send(arr.buffer);
        };
        Object.defineProperty(Room.prototype, "state", {
            get: function() {
                return this.serializer.getState();
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.removeAllListeners = function() {
            this.onJoin.clear();
            this.onStateChange.clear();
            this.onError.clear();
            this.onLeave.clear();
            this.onMessageHandlers.events = {};
        };
        Room.prototype.onMessageCallback = function(event) {
            var bytes = Array.from(new Uint8Array(event.data));
            var code = bytes[0];
            if (code === exports1.Protocol.JOIN_ROOM) {
                var offset = 1;
                this.serializerId = utf8Read(bytes, offset);
                offset += utf8Length(this.serializerId);
                // Instantiate serializer if not locally available.
                if (!this.serializer) {
                    var serializer = getSerializer(this.serializerId);
                    this.serializer = new serializer();
                }
                if (bytes.length > offset && this.serializer.handshake) this.serializer.handshake(bytes, {
                    offset: offset
                });
                this.hasJoined = true;
                this.onJoin.invoke();
                // acknowledge successfull JOIN_ROOM
                this.connection.send([
                    exports1.Protocol.JOIN_ROOM
                ]);
            } else if (code === exports1.Protocol.ERROR) {
                var it_1 = {
                    offset: 1
                };
                var code_1 = umd.decode.number(bytes, it_1);
                var message = umd.decode.string(bytes, it_1);
                this.onError.invoke(code_1, message);
            } else if (code === exports1.Protocol.LEAVE_ROOM) this.leave();
            else if (code === exports1.Protocol.ROOM_DATA_SCHEMA) {
                var it_2 = {
                    offset: 1
                };
                var context_1 = this.serializer.getState().constructor._context;
                var type = context_1.get(umd.decode.number(bytes, it_2));
                var message = new type();
                message.decode(bytes, it_2);
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_STATE) {
                bytes.shift(); // drop `code` byte
                this.setState(bytes);
            } else if (code === exports1.Protocol.ROOM_STATE_PATCH) {
                bytes.shift(); // drop `code` byte
                this.patch(bytes);
            } else if (code === exports1.Protocol.ROOM_DATA) {
                var it_3 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_3) ? umd.decode.string(bytes, it_3) : umd.decode.number(bytes, it_3);
                var message = bytes.length > it_3.offset ? decode(event.data, it_3.offset) : undefined;
                this.dispatchMessage(type, message);
            }
        };
        Room.prototype.setState = function(encodedState) {
            this.serializer.setState(encodedState);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.patch = function(binaryPatch) {
            this.serializer.patch(binaryPatch);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.dispatchMessage = function(type, message) {
            var messageType = this.getMessageHandlerKey(type);
            if (this.onMessageHandlers.events[messageType]) this.onMessageHandlers.emit(messageType, message);
            else if (this.onMessageHandlers.events["*"]) this.onMessageHandlers.emit("*", type, message);
            else console.warn("colyseus.js: onMessage() not registered for type '" + type + "'.");
        };
        Room.prototype.destroy = function() {
            if (this.serializer) this.serializer.teardown();
        };
        Room.prototype.getMessageHandlerKey = function(type) {
            switch(typeof type){
                // typeof Schema
                case "function":
                    return "$" + type._typeid;
                // string
                case "string":
                    return type;
                // number
                case "number":
                    return "i" + type;
                default:
                    throw new Error("invalid message type.");
            }
        };
        return Room;
    }();
    /// <reference path="../typings/cocos-creator.d.ts" />
    /**
     * We do not assign 'storage' to window.localStorage immediatelly for React
     * Native compatibility. window.localStorage is not present when this module is
     * loaded.
     */ var storage;
    function getStorage() {
        if (!storage) storage = typeof cc !== "undefined" && cc.sys && cc.sys.localStorage ? cc.sys.localStorage // compatibility with cocos creator
         : typeof window !== "undefined" && window.localStorage //RN does have window object at this point, but localStorage is not defined
         ? window.localStorage // regular browser environment
         : {
            cache: {},
            setItem: function(key, value) {
                this.cache[key] = value;
            },
            getItem: function(key) {
                this.cache[key];
            },
            removeItem: function(key) {
                delete this.cache[key];
            }
        };
        return storage;
    }
    function setItem(key, value) {
        getStorage().setItem(key, value);
    }
    function removeItem(key) {
        getStorage().removeItem(key);
    }
    function getItem(key, callback) {
        var value = getStorage().getItem(key);
        if (typeof Promise === "undefined" || // old browsers
        !(value instanceof Promise)) // browser has synchronous return
        callback(value);
        else // react-native is asynchronous
        value.then(function(id) {
            return callback(id);
        });
    }
    var TOKEN_STORAGE = "colyseus-auth-token";
    exports1.Platform = void 0;
    (function(Platform) {
        Platform["ios"] = "ios";
        Platform["android"] = "android";
    })(exports1.Platform || (exports1.Platform = {}));
    var Auth = /** @class */ function() {
        function Auth(endpoint) {
            var _this = this;
            this._id = undefined;
            this.username = undefined;
            this.displayName = undefined;
            this.avatarUrl = undefined;
            this.isAnonymous = undefined;
            this.email = undefined;
            this.lang = undefined;
            this.location = undefined;
            this.timezone = undefined;
            this.metadata = undefined;
            this.devices = undefined;
            this.facebookId = undefined;
            this.twitterId = undefined;
            this.googleId = undefined;
            this.gameCenterId = undefined;
            this.steamId = undefined;
            this.friendIds = undefined;
            this.blockedUserIds = undefined;
            this.createdAt = undefined;
            this.updatedAt = undefined;
            // auth token
            this.token = undefined;
            this.endpoint = endpoint.replace("ws", "http");
            getItem(TOKEN_STORAGE, function(token) {
                return _this.token = token;
            });
        }
        Object.defineProperty(Auth.prototype, "hasToken", {
            get: function() {
                return !!this.token;
            },
            enumerable: false,
            configurable: true
        });
        Auth.prototype.login = function(options) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, data, attr;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            queryParams = Object.assign({}, options);
                            if (this.hasToken) queryParams.token = this.token;
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/auth", queryParams)
                            ];
                        case 1:
                            data = _a.sent();
                            // set & cache token
                            this.token = data.token;
                            setItem(TOKEN_STORAGE, this.token);
                            for(attr in data)if (this.hasOwnProperty(attr)) this[attr] = data[attr];
                            this.registerPingService();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.save = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/auth", {}, {
                                    username: this.username,
                                    displayName: this.displayName,
                                    avatarUrl: this.avatarUrl,
                                    lang: this.lang,
                                    location: this.location,
                                    timezone: this.timezone
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/all")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getOnlineFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/online")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriendRequests = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/requests")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.sendFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.acceptFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.declineFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("del", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.blockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.unblockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.request = function(method, segments, query, body, headers) {
            if (query === void 0) query = {};
            if (headers === void 0) headers = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, name_1, queryString, opts;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            headers["Accept"] = "application/json";
                            if (this.hasToken) headers["Authorization"] = "Bearer " + this.token;
                            queryParams = [];
                            for(name_1 in query)queryParams.push(name_1 + "=" + query[name_1]);
                            queryString = queryParams.length > 0 ? "?" + queryParams.join("&") : "";
                            opts = {
                                headers: headers
                            };
                            if (body) opts.body = body;
                            return [
                                4 /*yield*/ ,
                                http[method]("" + this.endpoint + segments + queryString, opts)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Auth.prototype.logout = function() {
            this.token = undefined;
            removeItem(TOKEN_STORAGE);
            this.unregisterPingService();
        };
        Auth.prototype.registerPingService = function(timeout) {
            var _this = this;
            if (timeout === void 0) timeout = 15000;
            this.unregisterPingService();
            this.keepOnlineInterval = setInterval(function() {
                return _this.request("get", "/auth");
            }, timeout);
        };
        Auth.prototype.unregisterPingService = function() {
            clearInterval(this.keepOnlineInterval);
        };
        return Auth;
    }();
    var _a;
    var MatchMakeError = /** @class */ function(_super) {
        __extends(MatchMakeError, _super);
        function MatchMakeError(message, code) {
            var _this = _super.call(this, message) || this;
            _this.code = code;
            Object.setPrototypeOf(_this, MatchMakeError.prototype);
            return _this;
        }
        return MatchMakeError;
    }(Error);
    // - React Native does not provide `window.location`
    // - Cocos Creator (Native) does not provide `window.location.hostname` 
    var DEFAULT_ENDPOINT = typeof window !== "undefined" && typeof ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== "undefined" ? window.location.protocol.replace("http", "ws") + "//" + window.location.hostname + (window.location.port && ":" + window.location.port) : "ws://127.0.0.1:2567";
    var Client = /** @class */ function() {
        function Client(endpoint) {
            if (endpoint === void 0) endpoint = DEFAULT_ENDPOINT;
            this.endpoint = endpoint;
        }
        Object.defineProperty(Client.prototype, "auth", {
            get: function() {
                if (!this._auth) this._auth = new Auth(this.endpoint);
                return this._auth;
            },
            enumerable: false,
            configurable: true
        });
        Client.prototype.joinOrCreate = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinOrCreate", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.create = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("create", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.join = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("join", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.joinById = function(roomId, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.reconnect = function(roomId, sessionId, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, {
                                    sessionId: sessionId
                                }, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.getAvailableRooms = function(roomName) {
            if (roomName === void 0) roomName = "";
            return __awaiter(this, void 0, void 0, function() {
                var url;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            url = this.endpoint.replace("ws", "http") + "/matchmake/" + roomName;
                            return [
                                4 /*yield*/ ,
                                get_1(url, {
                                    headers: {
                                        "Accept": "application/json"
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Client.prototype.consumeSeatReservation = function(response, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                var room;
                return __generator(this, function(_a) {
                    room = this.createRoom(response.room.name, rootSchema);
                    room.id = response.room.roomId;
                    room.sessionId = response.sessionId;
                    room.connect(this.buildEndpoint(response.room, {
                        sessionId: room.sessionId
                    }));
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var onError = function(code, message) {
                                return reject(new ServerError(code, message));
                            };
                            room.onError.once(onError);
                            room["onJoin"].once(function() {
                                room.onError.remove(onError);
                                resolve(room);
                            });
                        })
                    ];
                });
            });
        };
        Client.prototype.createMatchMakeRequest = function(method, roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var url, response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            url = this.endpoint.replace("ws", "http") + "/matchmake/" + method + "/" + roomName;
                            // automatically forward auth token, if present
                            if (this._auth && this._auth.hasToken) options.token = this._auth.token;
                            return [
                                4 /*yield*/ ,
                                post_1(url, {
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(options)
                                })
                            ];
                        case 1:
                            response = _a.sent().data;
                            if (response.error) throw new MatchMakeError(response.error, response.code);
                            return [
                                2 /*return*/ ,
                                this.consumeSeatReservation(response, rootSchema)
                            ];
                    }
                });
            });
        };
        Client.prototype.createRoom = function(roomName, rootSchema) {
            return new Room(roomName, rootSchema);
        };
        Client.prototype.buildEndpoint = function(room, options) {
            if (options === void 0) options = {};
            var params = [];
            for(var name_1 in options){
                if (!options.hasOwnProperty(name_1)) continue;
                params.push(name_1 + "=" + options[name_1]);
            }
            return this.endpoint + "/" + room.processId + "/" + room.roomId + "?" + params.join("&");
        };
        return Client;
    }();
    var SchemaSerializer = /** @class */ function() {
        function SchemaSerializer() {}
        SchemaSerializer.prototype.setState = function(rawState) {
            this.state.decode(rawState);
        };
        SchemaSerializer.prototype.getState = function() {
            return this.state;
        };
        SchemaSerializer.prototype.patch = function(patches) {
            this.state.decode(patches);
        };
        SchemaSerializer.prototype.teardown = function() {
            var _a, _b;
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a["$changes"]) === null || _b === void 0 || _b.root.clearRefs();
        };
        SchemaSerializer.prototype.handshake = function(bytes, it) {
            if (this.state) {
                // validate client/server definitinos
                var reflection = new umd.Reflection();
                reflection.decode(bytes, it);
            } else // initialize reflected state from server
            this.state = umd.Reflection.decode(bytes, it);
        };
        return SchemaSerializer;
    }();
    var NoneSerializer = /** @class */ function() {
        function NoneSerializer() {}
        NoneSerializer.prototype.setState = function(rawState) {};
        NoneSerializer.prototype.getState = function() {
            return null;
        };
        NoneSerializer.prototype.patch = function(patches) {};
        NoneSerializer.prototype.teardown = function() {};
        NoneSerializer.prototype.handshake = function(bytes) {};
        return NoneSerializer;
    }();
    registerSerializer("schema", SchemaSerializer);
    registerSerializer("none", NoneSerializer);
    exports1.Auth = Auth;
    exports1.Client = Client;
    exports1.Room = Room;
    exports1.SchemaSerializer = SchemaSerializer;
    exports1.registerSerializer = registerSerializer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});










class $f79188864c3182db$var$BossFightServerService {
    constructor(){
        this._isLocalServer = false;
        this._isServerAlive = false;
        this._initialLength = 0;
        if ($f79188864c3182db$var$BossFightServerService._instance) throw new Error("Error: Instantiation failed: Use BossFightServerService.getInstance() instead of new.");
        $f79188864c3182db$var$BossFightServerService._instance = this;
        if (this._isLocalServer) this.client = new (0, $243a0fb2392e59c4$exports.Client)("ws://localhost:8003");
        else {
            this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
            const wsEndpoint = this._config.websockets["bossfight"];
            if (wsEndpoint) this.client = new (0, $243a0fb2392e59c4$exports.Client)(`${this._config.websockets.base}${wsEndpoint.path}`);
        }
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Events.EventEmitter();
    }
    static getInstance() {
        return $f79188864c3182db$var$BossFightServerService._instance;
    }
    isServerAvailable() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.client.getAvailableRooms("bossfight").then((room)=>{
                this._roomMetaData = room[0];
                this._isServerAlive = true;
            }).catch((err)=>{
                console.log("Boss Fight Server not started");
            });
        });
    }
    isServerAlive() {
        return this._isServerAlive;
    }
    getRoomMetaData() {
        var _a, _b, _c, _d, _e, _f;
        var rarity = "";
        var gameState;
        var participantCount = 0;
        var bossMaxHP = 0;
        var bossRemainingHP = 0;
        var attackingCount = 0;
        if (this._roomMetaData) {
            participantCount = (_a = this._roomMetaData.metadata) === null || _a === void 0 ? void 0 : _a.participantCount;
            gameState = (_b = this._roomMetaData.metadata) === null || _b === void 0 ? void 0 : _b.gameState;
            rarity = (_c = this._roomMetaData.metadata) === null || _c === void 0 ? void 0 : _c.rarity;
            bossMaxHP = (_d = this._roomMetaData.metadata) === null || _d === void 0 ? void 0 : _d.bossMaxHP;
            bossRemainingHP = (_e = this._roomMetaData.metadata) === null || _e === void 0 ? void 0 : _e.bossRemainingHP;
            attackingCount = (_f = this._roomMetaData.metadata) === null || _f === void 0 ? void 0 : _f.attackingCount;
        }
        return {
            participantCount: participantCount,
            gameState: gameState,
            rarity: rarity,
            bossMaxHP: bossMaxHP,
            bossRemainingHP: bossRemainingHP,
            attackingCount: attackingCount
        };
    }
    join() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.client.join("bossfight", {
                player: this.getBossFighterData()
            }).then((room)=>{
                this.room = room;
                this.room.state.listen("gameState", (value)=>{
                    this.events.emit("gamestate-update");
                });
                this.room.state.participants.onAdd = ()=>{
                    var _a, _b, _c, _d;
                    if ((_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.participants) {
                        if (((_c = this.room.state.participants) === null || _c === void 0 ? void 0 : _c.length) > this._initialLength) {
                            this.events.emit("participants-updated");
                            this._initialLength = (_d = this.room.state.participants) === null || _d === void 0 ? void 0 : _d.length;
                        }
                    }
                };
                this.room.state.participants.onRemove = ()=>{
                    var _a, _b, _c;
                    if ((_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.participants) this._initialLength = (_c = this.room.state.participants) === null || _c === void 0 ? void 0 : _c.length;
                    this.events.emit("participants-updated");
                };
                this.room.onMessage("attacking_state_changed", (change)=>{
                    this.events.emit("attacking_state_changed", change);
                });
            });
        });
    }
    leave() {
        var _a;
        (_a = this.room) === null || _a === void 0 || _a.leave();
        this._initialLength = 0;
        this.events.removeAllListeners();
    }
    disableBossFightListeners() {
        this._initialLength = 0;
        this.events.removeAllListeners();
    }
    // setPlayerInactive(inActive: boolean) {
    //     if (!this.room) {
    // 		return
    // 	}
    //     this.room.send("player-inactive", { inActive: inActive, wallet: WalletConnectService.getInstance().getWalletAddress() })
    // }
    playerReady() {
        if (!this.room) return;
        this.room.send("player-ready", {
            playerName: this.getBossFighterData().name,
            wallet: this.getBossFighterData().wallet
        });
    }
    isPlayerReady(playerId) {
        var _a;
        var isReady = false;
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (participant.playerId.toLowerCase() === playerId.toLowerCase()) isReady = participant.isAttacking;
        });
        return isReady;
    }
    onGameStateChanged(cb, context) {
        this.events.on("gamestate-update", cb, context);
    }
    onParticipantsUpdated(cb, context) {
        this.events.on("participants-updated", cb, context);
    }
    onAttackersUpdated(cb, context) {
        this.events.on("attackers-updated", cb, context);
    }
    onParticipantAttacking(cb, context) {
        this.events.on("attacking_state_changed", cb, context);
    }
    getBattleData() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var data = {
            attempt: (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.attempt,
            countDown: (_b = this.room) === null || _b === void 0 ? void 0 : _b.state.countDown,
            rarity: (_c = this.room) === null || _c === void 0 ? void 0 : _c.state.rarity,
            bossMaxHP: (_d = this.room) === null || _d === void 0 ? void 0 : _d.state.bossMaxHP,
            bossRemainingHP: (_e = this.room) === null || _e === void 0 ? void 0 : _e.state.remaining,
            gameState: (_f = this.room) === null || _f === void 0 ? void 0 : _f.state.gameState,
            participantCount: (_g = this.room) === null || _g === void 0 ? void 0 : _g.state.participants.length,
            participants: (_h = this.room) === null || _h === void 0 ? void 0 : _h.state.participants,
            activeParticipants: this.getActiveParticipantsNumber(),
            attackingCount: (_j = this.room) === null || _j === void 0 ? void 0 : _j.state.attackingCount
        };
        return data;
    }
    getCountDown() {
        var _a, _b;
        if (((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) === (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame) return (0, $f12f0c85b935f07d$export$43a43cf967792f11)();
        return (_b = this.room) === null || _b === void 0 ? void 0 : _b.state.countDown;
    }
    getParticipantPayout() {
        var _a;
        var payout = {
            xp: 0,
            spaceElixir: 0,
            neonGold: 0,
            starDust: 0
        };
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (participant.playerId.toLowerCase() === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress().toLowerCase()) {
                payout.spaceElixir = participant.payout.spaceElixir;
                payout.neonGold = participant.payout.neonGold;
                payout.starDust = participant.payout.starDust;
                payout.xp = 500;
            }
        });
        return payout;
    }
    getActiveParticipantsNumber() {
        var _a;
        var activeParticipants = 0;
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (!participant.inactive) activeParticipants++;
        });
        return activeParticipants;
    }
    isBossDefeated() {
        var _a;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.remaining) <= 0;
    }
    showBossFightNotification() {
        var _a, _b;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame && ((_b = this.room) === null || _b === void 0 ? void 0 : _b.state.countDown) < 600;
    }
    isPreGame() {
        var _a, _b;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame && ((_b = this.room) === null || _b === void 0 ? void 0 : _b.state.countDown) < 300;
    }
    isFightActive() {
        var _a, _b, _c, _d;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound || ((_b = this.room) === null || _b === void 0 ? void 0 : _b.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round || ((_c = this.room) === null || _c === void 0 ? void 0 : _c.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults || ((_d = this.room) === null || _d === void 0 ? void 0 : _d.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults;
    }
    isDisplayResults() {
        var _a;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults;
    }
    getGameState() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state;
    }
    getBossRarity() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.rarity;
    }
    convertSecondsToCountdown(seconds) {
        seconds = Number(seconds);
        var hDisplay = Math.floor(seconds / 3600) + "H ";
        var mDisplay = Math.floor(seconds % 3600 / 60) + "M ";
        var sDisplay = Math.floor(seconds % 3600 % 60) + "S";
        console.log(hDisplay + mDisplay + sDisplay);
    }
    outputPlayerList() {
        var _a;
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            console.log(participant.playerName);
        });
    }
    updateParticipantData() {
        if (!this.room) return;
        if ((0, $f12f0c85b935f07d$export$43a43cf967792f11)() < 600) this.room.send("player-updated", {
            playerData: this.getBossFighterData()
        });
    }
    getBossFighterData() {
        var bossFighter = {
            wallet: (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync().wallet,
            name: (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync().name,
            imageKey: (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getPFPImageKey(),
            imageUrl: (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getPFPUrl(),
            damage: (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadHP(),
            brawlerCage: (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().ownsBrawlerCage(),
            kaijuMultiplier: (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getKaijuMachineMultiplier(),
            has_battlepass: (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync().has_battlepass,
            storage: (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getStorageCapacities(),
            traits: (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync()
        };
        return bossFighter;
    }
}
$f79188864c3182db$var$BossFightServerService._instance = new $f79188864c3182db$var$BossFightServerService();
var $f79188864c3182db$export$2e2bcd8739ae039 = $f79188864c3182db$var$BossFightServerService;


const $e78296f6c79d7b0d$var$textStyle = {
    fontFamily: "ccwhatchamacallitbold",
    fontSize: "16px",
    fontStyle: "normal",
    color: "#FFFFFF",
    shadow: {
        offsetX: 2,
        offsetY: 2,
        color: "#000001"
    }
};
const $e78296f6c79d7b0d$var$goldProgressBarColor = 0xdea827;
const $e78296f6c79d7b0d$var$pinkProgressBarColor = 0xde2795;
const $e78296f6c79d7b0d$var$blueProgressBarColor = 0x00a6d3;
const $e78296f6c79d7b0d$var$progressBarAlpha = 1;
const $e78296f6c79d7b0d$var$glareColor = 0xffffff;
const $e78296f6c79d7b0d$var$glareAlpha = 0.17;
const $e78296f6c79d7b0d$var$glareRadius = 3;
const $e78296f6c79d7b0d$var$glareHeight = 6;
const $e78296f6c79d7b0d$var$glareOffset = 10;
const $e78296f6c79d7b0d$var$backgroundColor = 0xb48dc7;
const $e78296f6c79d7b0d$var$backgroundAlpha = 0.4;
const $e78296f6c79d7b0d$var$radius = 7;
const $e78296f6c79d7b0d$var$progressBarHeight = 22;
const $e78296f6c79d7b0d$var$levelBarWidth = 215;
const $e78296f6c79d7b0d$var$stardustBarWidth = 150;
const $e78296f6c79d7b0d$var$neonGoldBarWidth = 175;
const $e78296f6c79d7b0d$var$spaceElixirBarWidth = 175;
const $e78296f6c79d7b0d$var$panelWidth = 860;
const $e78296f6c79d7b0d$var$levelMin = 0;
const $e78296f6c79d7b0d$var$levelMax = 10;
const $e78296f6c79d7b0d$var$stardustMin = 0;
const $e78296f6c79d7b0d$var$stardustMax = 600;
const $e78296f6c79d7b0d$var$neonGoldMin = 0;
const $e78296f6c79d7b0d$var$neonGoldMax = 50000;
const $e78296f6c79d7b0d$var$spaceElixirMin = 0;
const $e78296f6c79d7b0d$var$spaceElixirMax = 50000;
const $e78296f6c79d7b0d$var$squadComponentWidth = 254;
const $e78296f6c79d7b0d$var$squadComponentHeight = 100;
const $e78296f6c79d7b0d$var$squadComponentRadius = 26;
const $e78296f6c79d7b0d$var$squadComponentFill = 0x350926;
const $e78296f6c79d7b0d$var$squadComponentAlpha = 1;
class $e78296f6c79d7b0d$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        let conf = {
            width: $e78296f6c79d7b0d$var$squadComponentWidth * (paneScale || 1),
            height: $e78296f6c79d7b0d$var$squadComponentHeight * (paneScale || 1),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        let displayConfig = config ? config : {
            display_bg: true,
            allow_clicks: true
        };
        this._scale = paneScale;
        if (displayConfig.display_bg) {
            const squadComponentBg = scene.add.rexRoundRectangle(0, 0, $e78296f6c79d7b0d$var$squadComponentWidth, $e78296f6c79d7b0d$var$squadComponentHeight, scene.applyScale($e78296f6c79d7b0d$var$squadComponentRadius), $e78296f6c79d7b0d$var$squadComponentFill, $e78296f6c79d7b0d$var$squadComponentAlpha);
            this.addBackground(squadComponentBg);
        }
        this._squadData = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this.setSquadMembers(this._squadData);
        this.createComponent(scene, x, y, displayConfig);
        this.layout();
    }
    createComponent(scene, x, y, config) {
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0,
            allowClicks: config.allow_clicks
        };
        // Squad Member 1
        const sm1ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._squadMembers[0].image_key);
        const sm1ImageWidth = sm1ImageData.width;
        rectConfig.radius = sm1ImageWidth / 4;
        this._squadMember1 = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[0].image_key, rectConfig, false);
        this._squadMember1.displayHeight = 66;
        this._squadMember1.scaleX = this._squadMember1.scaleY;
        this._squadMember1.setScale(this._squadMember1.scaleY * this._scale);
        sm1ImageData.destroy();
        if (config.allow_clicks) {
            this._squadMember1.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>this.scene.sound.play("hud-button-hover"));
            this._squadMember1.onClick().subscribe((pointer)=>{
                this.squadMemberClickHandler(pointer);
            });
        }
        scene.add.existing(this._squadMember1);
        this.add(this._squadMember1, {
            key: "squad_member_1",
            align: "center",
            offsetX: scene.applyScale(-80),
            offsetY: 0,
            expand: false
        });
        // Squad Member 2
        const sm2ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._squadMembers[1].image_key);
        const sm2ImageWidth = sm2ImageData.width;
        rectConfig.radius = sm2ImageWidth / 4;
        this._squadMember2 = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[1].image_key, rectConfig, false);
        this._squadMember2.displayHeight = 66;
        this._squadMember2.scaleX = this._squadMember2.scaleY;
        this._squadMember2.setScale(this._squadMember2.scaleY * this._scale);
        sm2ImageData.destroy();
        if (config.allow_clicks) {
            this._squadMember2.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>this.scene.sound.play("hud-button-hover"));
            this._squadMember2.onClick().subscribe((pointer)=>{
                this.squadMemberClickHandler(pointer);
            });
        }
        scene.add.existing(this._squadMember2);
        this.add(this._squadMember2, {
            key: "squad_member_2",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Squad Member 3
        const sm3ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._squadMembers[2].image_key);
        const sm3ImageWidth = sm3ImageData.width;
        rectConfig.radius = sm3ImageWidth / 4;
        this._squadMember3 = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[2].image_key, rectConfig, false);
        this._squadMember3.displayHeight = 66;
        this._squadMember3.scaleX = this._squadMember3.scaleY;
        this._squadMember3.setScale(this._squadMember3.scaleY * this._scale);
        sm3ImageData.destroy();
        if (config.allow_clicks) {
            this._squadMember3.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>this.scene.sound.play("hud-button-hover"));
            this._squadMember3.onClick().subscribe((pointer)=>{
                this.squadMemberClickHandler(pointer);
            });
        }
        scene.add.existing(this._squadMember3);
        this.add(this._squadMember3, {
            key: "squad_member_3",
            align: "center",
            offsetX: scene.applyScale(80),
            offsetY: 0,
            expand: false
        });
        return this.layout();
    }
    updateSquad(forceUpdate = true) {
        if (forceUpdate) (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquad(true).then((res)=>{
            this.setSquadMembers(res);
            this.updateImages();
            (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().updateParticipantData();
        });
        else {
            this.setSquadMembers((0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync());
            this.updateImages();
        }
    }
    setSquadMembers(squadData) {
        this._squadMembers = squadData.map((sqMem)=>{
            sqMem.show_yield = false;
            sqMem.show_hp = false;
            return sqMem;
        });
    }
    updateImages() {
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        // Squad Member 1
        const sm1ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this.scene, 0, 0, this._squadMembers[0].image_key);
        const sm1ImageWidth = sm1ImageData.width;
        rectConfig.radius = sm1ImageWidth / 4;
        this._squadMember1.setTexture(this._squadMembers[0].image_key, rectConfig);
        this._squadMember1.displayHeight = 66;
        this._squadMember1.scaleX = this._squadMember1.scaleY;
        this._squadMember1.setScale(this._squadMember1.scaleY * this._scale);
        sm1ImageData.destroy();
        // Squad Member 2
        const sm2ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this.scene, 0, 0, this._squadMembers[1].image_key);
        const sm2ImageWidth = sm2ImageData.width;
        rectConfig.radius = sm2ImageWidth / 4;
        this._squadMember2.setTexture(this._squadMembers[1].image_key, rectConfig);
        this._squadMember2.displayHeight = 66;
        this._squadMember2.scaleX = this._squadMember2.scaleY;
        this._squadMember2.setScale(this._squadMember2.scaleY * this._scale);
        sm2ImageData.destroy();
        // Squad Member 3
        const sm3ImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this.scene, 0, 0, this._squadMembers[2].image_key);
        const sm3ImageWidth = sm3ImageData.width;
        rectConfig.radius = sm3ImageWidth / 4;
        this._squadMember3.setTexture(this._squadMembers[2].image_key, rectConfig);
        this._squadMember3.displayHeight = 66;
        this._squadMember3.scaleX = this._squadMember3.scaleY;
        this._squadMember3.setScale(this._squadMember3.scaleY * this._scale);
        sm3ImageData.destroy();
    }
    squadMemberClickHandler(pointer) {
        this.scene.scene.pause("HomebaseScene");
        this.scene.scene.pause("HudScene");
        this.scene.scene.launch("SquadModalScene");
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("squadComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $e78296f6c79d7b0d$export$2e2bcd8739ae039(this.scene, x, y));
});











const $da58ee258d224181$var$blueProgressBarColor = 0x00a6d3;
const $da58ee258d224181$var$progressBarAlpha = 1;
const $da58ee258d224181$var$glareColor = 0xffffff;
const $da58ee258d224181$var$glareAlpha = 0.17;
const $da58ee258d224181$var$glareRadius = 3;
const $da58ee258d224181$var$glareHeight = 6;
const $da58ee258d224181$var$glareOffset = 10;
const $da58ee258d224181$var$backgroundColor = 0xb48dc7;
const $da58ee258d224181$var$backgroundAlpha = 0.4;
const $da58ee258d224181$var$radius = 7;
const $da58ee258d224181$var$progressBarHeight = 22;
const $da58ee258d224181$var$levelBarWidth = 215;
class $da58ee258d224181$export$2e2bcd8739ae039 extends (0, $60b229d208382899$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, userData, iconScale = 0.7){
        super(scene, x, y, paneScale, {
            rtl: false,
            title: {
                text: userData.name.toString().toUpperCase(),
                fontStyle: null,
                icon: userData.has_battlepass ? "battle_pass_icon" : undefined,
                iconScale: userData.has_battlepass ? 1 : undefined,
                iconSpace: userData.has_battlepass ? 5 : undefined
            },
            icon: {
                key: "bronze_level_1_badge",
                space: 8,
                scale: iconScale
            },
            progressBar: {
                text: userData.level.toString(),
                fontStyle: null,
                width: $da58ee258d224181$var$levelBarWidth,
                height: $da58ee258d224181$var$progressBarHeight,
                radius: $da58ee258d224181$var$radius,
                color: $da58ee258d224181$var$blueProgressBarColor,
                alpha: $da58ee258d224181$var$progressBarAlpha,
                backgroundColor: $da58ee258d224181$var$backgroundColor,
                backgroundAlpha: $da58ee258d224181$var$backgroundAlpha,
                minValue: 1,
                maxValue: 10,
                progressValue: userData.xp,
                glare: {
                    height: $da58ee258d224181$var$glareHeight,
                    width: $da58ee258d224181$var$levelBarWidth - $da58ee258d224181$var$glareOffset,
                    radius: $da58ee258d224181$var$glareRadius,
                    color: $da58ee258d224181$var$glareColor,
                    alpha: $da58ee258d224181$var$glareAlpha
                }
            }
        });
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this.setValues(scene, userData);
    }
    updateValues(scene, userData) {
        if (userData) this.setValues(scene, userData);
    }
    setValues(scene, userData) {
        var levelMinXP = this.getLevelMinXP(userData);
        var levelMaxXP = this.getLevelMaxXP(userData);
        var badgeImageKey = this.getBadgeImageKey(userData, this._config.userBadges);
        this.updateMinValue(scene, levelMinXP);
        this.updateMaxValue(scene, levelMaxXP);
        this.setProgressValue(scene, userData.xp);
        this.setProgressBarText(userData.level.toString());
        this.setIcon(badgeImageKey);
    }
    getLevelMinXP(userData) {
        var level = parseInt(userData.level);
        if (level === 0) return 0;
        else if (level === 1) return 300;
        else if (level >= 2 && level <= 15) return (level - 1) * 500;
        else if (level >= 16 && level <= 30) return (level - 1) * 500 + 250;
        else if (level >= 31 && level <= 45) return (level - 1) * 500 + 450;
        else if (level >= 46 && level <= 60) return (level - 1) * 500 + 650;
        else if (level >= 61 && level <= 75) return (level - 1) * 500 + 1000;
        else if (level >= 76 && level <= 100) return (level - 1) * 500 + 1450;
        else if (level >= 101) return (level - 1) * 500 + 2000;
        else return 1;
    }
    getLevelMaxXP(userData) {
        var nextLevelMinXP = this.getLevelMinXP({
            level: parseInt(userData.level) + 1
        });
        return nextLevelMinXP - 1;
    }
    getBadgeImageKey(userData, userBadges) {
        var badge = userBadges.find((ub)=>{
            if (ub.maxLevel === null) return userData.level >= ub.minLevel;
            else return userData.level >= ub.minLevel && userData.level <= ub.maxLevel;
        });
        return badge.badgeImageKey;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("levelProgressBarComponent", function(x, y, userData) {
    // @ts-ignore
    return this.displayList.add(new $da58ee258d224181$export$2e2bcd8739ae039(this.scene, x, y, userData));
});









const $682301f732d46d2b$var$textStyle = {
    fontFamily: "ccwhatchamacallitbold",
    fontSize: "16px",
    fontStyle: "normal",
    color: "#FFFFFF",
    shadow: {
        offsetX: 2,
        offsetY: 2,
        color: "#000001"
    }
};
const $682301f732d46d2b$var$paneWidth = 685;
const $682301f732d46d2b$var$paneHeight = 108;
const $682301f732d46d2b$var$goldProgressBarColor = 0xdea827;
const $682301f732d46d2b$var$pinkProgressBarColor = 0xde2795;
const $682301f732d46d2b$var$blueProgressBarColor = 0x00a6d3;
const $682301f732d46d2b$var$grayProgressBarColor = 0x9a9a9a;
const $682301f732d46d2b$var$blackProgressBarColor = 0x23232e;
const $682301f732d46d2b$var$progressBarAlpha = 1;
const $682301f732d46d2b$var$glareColor = 0xffffff;
const $682301f732d46d2b$var$glareAlpha = 0.17;
const $682301f732d46d2b$var$glareRadius = 3;
const $682301f732d46d2b$var$glareHeight = 6;
const $682301f732d46d2b$var$glareOffset = 10;
const $682301f732d46d2b$var$backgroundColor = 0xb48dc7;
const $682301f732d46d2b$var$backgroundAlpha = 0.4;
const $682301f732d46d2b$var$progressBarHoverAlpha = 0.8;
const $682301f732d46d2b$var$radius = 7;
const $682301f732d46d2b$var$progressBarHeight = 22;
const $682301f732d46d2b$var$stardustBarWidth = 140;
const $682301f732d46d2b$var$neonGoldBarWidth = 215;
const $682301f732d46d2b$var$spaceElixirBarWidth = 215;
const $682301f732d46d2b$var$stardustMin = 0;
const $682301f732d46d2b$var$stardustMax = 5000;
const $682301f732d46d2b$var$neonGoldMin = 0;
const $682301f732d46d2b$var$neonGoldMax = 250000;
const $682301f732d46d2b$var$spaceElixirMin = 0;
const $682301f732d46d2b$var$spaceElixirMax = 250000;
const $682301f732d46d2b$var$darkMatterMin = 0;
const $682301f732d46d2b$var$darkMatterMax = 1000;
const $682301f732d46d2b$var$tintColor = 0xcdcdcd;
const $682301f732d46d2b$var$resources = {
    space_elixir: "space_elixir",
    neon_gold: "neon_gold",
    dark_matter: "dark_matter",
    stardust: "stardust"
};
class $682301f732d46d2b$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, userMachines, allowClicks, paneScale, config){
        let conf = config ? config : {
            width: scene.applyScale(250),
            height: scene.applyScale(300),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 1
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._userData = data;
        this._userMachines = userMachines;
        this._allowProgressBarClicks = allowClicks || false;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        const userMachines = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync();
        if (this._spaceElixirProgressBar) this._spaceElixirProgressBar.destroy();
        if (this._neonGoldProgressBar) this._neonGoldProgressBar.destroy();
        if (this._darkMatterProgressBar) this._darkMatterProgressBar.destroy();
        if (this._stardustProgressBar) this._stardustProgressBar.destroy();
        if (this._hpProgressBar) this._hpProgressBar.destroy();
        if (this._dpsProgressBar) this._dpsProgressBar.destroy();
        // ADD PROGRESS BARS
        // Space Elixir Progress Bar
        this._spaceElixirProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "space_elixir_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this._userData.space_elixir.toLocaleString("en-us"),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$spaceElixirBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$blueProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: $682301f732d46d2b$var$spaceElixirMin,
                maxValue: this.getStorageCapacity(userMachines, $682301f732d46d2b$var$resources.space_elixir),
                progressValue: this._userData.space_elixir,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$spaceElixirBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._spaceElixirProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "spaceElixirProgressBar"
        });
        // Neon Gold Progress Bar
        this._neonGoldProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "neon_gold_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this._userData.neon_gold.toLocaleString("en-us"),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$neonGoldBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$goldProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: $682301f732d46d2b$var$neonGoldMin,
                maxValue: this.getStorageCapacity(userMachines, $682301f732d46d2b$var$resources.neon_gold),
                progressValue: this._userData.neon_gold,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$neonGoldBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._neonGoldProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(15),
                bottom: 0
            },
            key: "neonGoldProgressBar"
        });
        // Stardust Progress Bar
        this._stardustProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "stardust_icon_44",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: Math.floor(this._userData.stardust).toLocaleString("en-us"),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$stardustBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$pinkProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: $682301f732d46d2b$var$stardustMin,
                maxValue: $682301f732d46d2b$var$stardustMax,
                progressValue: this._userData.stardust,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$stardustBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._stardustProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(15),
                bottom: 0
            },
            key: "stardustProgressBar"
        });
        // Dark Matter Progress Bar
        this._darkMatterProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "dark_matter_icon_44",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: Math.floor(this._userData.dark_matter || 0).toLocaleString("en-us"),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$stardustBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$blackProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: $682301f732d46d2b$var$darkMatterMin,
                maxValue: $682301f732d46d2b$var$darkMatterMax,
                progressValue: this._userData.dark_matter || 0,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$stardustBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._darkMatterProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(15),
                bottom: 0
            },
            key: "darkMatterProgressBar"
        });
        // HP Progress Bar
        this._hpProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "hp_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this.getTotalHPText(this._userMachines),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$stardustBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$grayProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 10,
                progressValue: 0,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$stardustBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._hpProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(15),
                bottom: 0
            },
            key: "hpProgressBar"
        });
        // DPS Progress Bar
        this._dpsProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, 1, {
            rtl: true,
            title: {
                text: "",
                fontStyle: $682301f732d46d2b$var$textStyle
            },
            icon: {
                key: "dps_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this.getTotalDPSText(this._userMachines),
                fontStyle: $682301f732d46d2b$var$textStyle,
                width: $682301f732d46d2b$var$stardustBarWidth,
                height: $682301f732d46d2b$var$progressBarHeight,
                radius: $682301f732d46d2b$var$radius,
                color: $682301f732d46d2b$var$grayProgressBarColor,
                alpha: $682301f732d46d2b$var$progressBarAlpha,
                backgroundColor: $682301f732d46d2b$var$backgroundColor,
                backgroundAlpha: $682301f732d46d2b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 10,
                progressValue: 0,
                glare: {
                    height: $682301f732d46d2b$var$glareHeight,
                    width: $682301f732d46d2b$var$stardustBarWidth - $682301f732d46d2b$var$glareOffset,
                    radius: $682301f732d46d2b$var$glareRadius,
                    color: $682301f732d46d2b$var$glareColor,
                    alpha: $682301f732d46d2b$var$glareAlpha
                }
            }
        });
        this.add(this.scene.add.existing(this._dpsProgressBar), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(15),
                bottom: 0
            },
            key: "dpsProgressBar"
        });
        // ADD CLICK EVENTS
        if (this._allowProgressBarClicks) {
            // Space Elixir Bar Events
            this._spaceElixirProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._spaceElixirProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._spaceElixirProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._spaceElixirProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._spaceElixirProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                this.scene.scene.get("HomebaseScene").input.enabled = false;
                this.scene.scene.launch("ResourceModalScene", {
                    resource: "space_elixir"
                });
                this.scene.scene.pause("HudScene");
            });
            // Neon Gold Bar Events
            this._neonGoldProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._neonGoldProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._neonGoldProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._neonGoldProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._neonGoldProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                this.scene.scene.get("HomebaseScene").input.enabled = false;
                this.scene.scene.launch("ResourceModalScene", {
                    resource: "neon_gold"
                });
                this.scene.scene.pause("HudScene");
            });
            // Stardust Bar Events
            this._stardustProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._stardustProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._stardustProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._stardustProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._stardustProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfo(undefined, undefined, 0, 30).then((res)=>{
                    this.scene.scene.get("HomebaseScene").input.enabled = false;
                    this.scene.scene.launch("ResourceModalScene", {
                        resource: "stardust"
                    });
                    this.scene.scene.pause("HudScene");
                });
            });
            // Dark Matter Bar Events
            this._darkMatterProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._darkMatterProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._darkMatterProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._darkMatterProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._darkMatterProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                this.scene.scene.get("HomebaseScene").input.enabled = false;
                this.scene.scene.launch("ResourceModalScene", {
                    resource: "dark_matter"
                });
                this.scene.scene.pause("HudScene");
            });
            // HP Bar Events
            this._hpProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._hpProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._hpProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._hpProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._hpProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                this.scene.scene.get("HomebaseScene").input.enabled = false;
                this.scene.scene.launch("HpModalScene", {
                    resource: "hp"
                });
                this.scene.scene.pause("HudScene");
            });
            // HP Bar Events
            this._dpsProgressBar.setInteractive({
                cursor: "pointer"
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
                this.scene.sound.play("hud-button-hover");
                this._dpsProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
            }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
                this._dpsProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
                this._dpsProgressBar.setAlpha(1);
            }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
                this._dpsProgressBar.setAlpha($682301f732d46d2b$var$progressBarHoverAlpha);
                if (pointer.getDistance() > 16) return;
                this.scene.scene.get("HomebaseScene").input.enabled = false;
                this.scene.scene.launch("HpModalScene", {
                    resource: "dps"
                });
                this.scene.scene.pause("HudScene");
            });
        }
        this.layout();
    }
    getTotalHPText(userMachines) {
        if (userMachines && userMachines.length > 1) {
            var totalHp = 0;
            userMachines.forEach((mach)=>{
                if (mach.hitpoints && mach.hitpoints > 0) totalHp += mach.hitpoints;
            });
            return totalHp.toLocaleString("en-us");
        } else return "0";
    }
    getTotalDPSText(userMachines) {
        if (userMachines && userMachines.length > 1) {
            var totalDps = 0;
            userMachines.forEach((mach)=>{
                if (mach.dps && mach.dps > 0) totalDps += mach.dps;
            });
            return totalDps.toLocaleString("en-us");
        } else return "0";
    }
    getStorageCapacity(userMachines, resource) {
        var storageTotal = 0;
        const storageProperty = resource === $682301f732d46d2b$var$resources.neon_gold ? "storage_neon_gold" : resource === $682301f732d46d2b$var$resources.space_elixir ? "storage_space_elixir" : "stardust";
        if (storageProperty === "stardust") return 0;
        userMachines.forEach((mach)=>{
            if (mach[storageProperty] && mach[storageProperty] > 0) storageTotal = storageTotal + mach[storageProperty];
        });
        return storageTotal;
    }
    updateProgressBars(userMachines, userData) {
        var _a, _b, _c, _d, _e, _f, _g;
        // Neon Gold Bar
        (_a = this._neonGoldProgressBar) === null || _a === void 0 || _a.setProgress(this.scene, userData.neon_gold);
        (_b = this._neonGoldProgressBar) === null || _b === void 0 || _b.updateMaxValue(this.scene, this.getStorageCapacity(userMachines, $682301f732d46d2b$var$resources.neon_gold));
        // Stardust Bar
        (_c = this._stardustProgressBar) === null || _c === void 0 || _c.setProgress(this.scene, userData.stardust);
        // Space Elixir Bar
        (_d = this._spaceElixirProgressBar) === null || _d === void 0 || _d.setProgress(this.scene, userData.space_elixir);
        (_e = this._spaceElixirProgressBar) === null || _e === void 0 || _e.updateMaxValue(this.scene, this.getStorageCapacity(userMachines, $682301f732d46d2b$var$resources.space_elixir));
        // HP Bar
        (_f = this._hpProgressBar) === null || _f === void 0 || _f.setProgressBarText(this.getTotalHPText(userMachines));
        // DPS Bar
        (_g = this._dpsProgressBar) === null || _g === void 0 || _g.setProgressBarText(this.getTotalDPSText(userMachines));
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("ResourcesComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $682301f732d46d2b$export$2e2bcd8739ae039(this.scene, x, y));
});





const $48a6a2cbeff86768$var$defaultNotifications = [
    {
        number: 1,
        title: "Grab some starter resources",
        description: "Go to the Objectives panel to view all the available objectives and Soft Staking screen. You'll need some!",
        pointerImageKey: "hand_pointing_10_oclock",
        anchorCorner: "top-left",
        noteX: 394,
        noteY: 208,
        handX: 165,
        handY: 177
    },
    {
        number: 2,
        title: "Select your Squad",
        description: "Go here to add your NFTs to your active squad - you'll need them to launch Missions. Pick your rarest collectibles!",
        pointerImageKey: "hand_pointing_7_oclock",
        anchorCorner: "bottom-left",
        noteX: 319,
        noteY: -258,
        handX: 120,
        handY: -170
    },
    {
        number: 3,
        title: "Build your Mainframe",
        description: "Your Mainframe will unlock all new machines that yield, store, and power your Squad's future existence.",
        pointerImageKey: "hand_pointing_9_oclock",
        anchorCorner: "bottom-left",
        noteX: 835,
        noteY: -100,
        handX: 615,
        handY: -90
    }
];
class $48a6a2cbeff86768$var$NotificationService {
    constructor(){
        if ($48a6a2cbeff86768$var$NotificationService._instance) throw new Error("Error: Instantiation failed: Use NotificationService.getInstance() instead of new.");
        $48a6a2cbeff86768$var$NotificationService._instance = this;
        this.setNotifications($48a6a2cbeff86768$var$defaultNotifications);
    }
    static getInstance() {
        return $48a6a2cbeff86768$var$NotificationService._instance;
    }
    setNotifications(value) {
        this._notifications = value;
    }
    getNotifications(forceUpdate = false) {
        // return new Promise((resolve, reject) => {
        //     if (this._notifications && !forceUpdate) {
        //         return resolve(this._notifications);
        //     } else {
        //         return resolve(this.fetchNotifications());
        //     }
        // });
        return this._notifications;
    }
    getNotificationsSync() {
        return this._notifications;
    }
    setNotificationClosed(notificationNumber) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("user", [
            wallet,
            "modal",
            notificationNumber
        ], {}).then((res)=>{
            return res;
        });
    }
}
$48a6a2cbeff86768$var$NotificationService._instance = new $48a6a2cbeff86768$var$NotificationService();
var $48a6a2cbeff86768$export$2e2bcd8739ae039 = $48a6a2cbeff86768$var$NotificationService;







const $252e2f5812e34f90$var$width = 361;
const $252e2f5812e34f90$var$radius = 7;
const $252e2f5812e34f90$var$alpha = 0.8;
const $252e2f5812e34f90$var$color = 0x25182b;
const $252e2f5812e34f90$var$borderWidth = 1;
const $252e2f5812e34f90$var$borderColor = 0x383d57;
const $252e2f5812e34f90$var$descColor = 0xb29fb8;
const $252e2f5812e34f90$var$glareWidth = 349;
const $252e2f5812e34f90$var$glareHeight = 9;
const $252e2f5812e34f90$var$glareRadius = 4;
const $252e2f5812e34f90$var$glareAlpha = 0.17;
const $252e2f5812e34f90$var$glareColor = 0xa0c8ed;
class $252e2f5812e34f90$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, config){
        let conf = {
            width: $252e2f5812e34f90$var$width,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._title = config.title;
        this._description = config.description;
        this._notificationNumber = config.number;
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        this.addBackground(scene.add.rexRoundRectangle(0, 0, 0, 0, $252e2f5812e34f90$var$radius, $252e2f5812e34f90$var$color, $252e2f5812e34f90$var$alpha).setStrokeStyle($252e2f5812e34f90$var$borderWidth, $252e2f5812e34f90$var$borderColor, $252e2f5812e34f90$var$alpha));
        this.add(scene.add.rexRoundRectangle(0, 0, $252e2f5812e34f90$var$glareWidth, $252e2f5812e34f90$var$glareHeight, $252e2f5812e34f90$var$glareRadius, $252e2f5812e34f90$var$glareColor, $252e2f5812e34f90$var$glareAlpha), {
            key: "notification_glare",
            padding: {
                left: 6,
                right: 0,
                top: 6,
                bottom: 0
            }
        });
        this._closeButton = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, "close_notification_button", {
            allowClicks: true
        }, false);
        this._closeButton.onClick().subscribe((pointer)=>{
            (0, $48a6a2cbeff86768$export$2e2bcd8739ae039).getInstance().setNotificationClosed(this._notificationNumber).then((res)=>{
                (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                    scene.closeNotification(this._notificationNumber);
                });
            });
        });
        this.add(scene.add.existing(this._closeButton), {
            key: "close_button",
            padding: {
                left: $252e2f5812e34f90$var$width - 17,
                right: 0,
                top: -30,
                bottom: 0
            }
        });
        this.add(scene.add.bitmapText(0, 0, "cc_outline", `${this._notificationNumber}. ${this._title}`, scene.applyScale(22)).setMaxWidth($252e2f5812e34f90$var$width - 20), {
            key: "notification_title",
            padding: {
                left: 12,
                right: 0,
                top: -3,
                bottom: 0
            }
        }).add(scene.add.bitmapText(0, 0, "cc_outline", this._description, scene.applyScale(18)).setTint($252e2f5812e34f90$var$descColor).setMaxWidth($252e2f5812e34f90$var$width - 20), {
            key: "notification_description",
            padding: {
                left: 12,
                right: 0,
                top: -2,
                bottom: 5
            }
        });
        this.layout();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("hudNotificationComponent", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $252e2f5812e34f90$export$2e2bcd8739ae039(this.scene, x, y, config));
});



var $7WQrb = parcelRequire("7WQrb");


var $51e1646242d4d492$export$eb5ccdbd077479c;
(function(GameState) {
    GameState[GameState["PreGame"] = 0] = "PreGame";
    GameState[GameState["BattleRoyale"] = 1] = "BattleRoyale";
    GameState[GameState["BRIntermission"] = 2] = "BRIntermission";
    GameState[GameState["PVP"] = 3] = "PVP";
    GameState[GameState["GameOver"] = 4] = "GameOver";
    GameState[GameState["Failed"] = 5] = "Failed";
})($51e1646242d4d492$export$eb5ccdbd077479c || ($51e1646242d4d492$export$eb5ccdbd077479c = {}));




class $ef600a3a231959fc$var$BattleRoyaleServerService {
    constructor(){
        this._isLocalServer = false;
        this._isServerAlive = false;
        this._initialParticipantLength = 0;
        this._initialMessageLength = 0;
        if ($ef600a3a231959fc$var$BattleRoyaleServerService._instance) throw new Error("Error: Instantiation failed: Use BattleRoyaleServerService.getInstance() instead of new.");
        $ef600a3a231959fc$var$BattleRoyaleServerService._instance = this;
        if (this._isLocalServer) try {
            this.client = new (0, $243a0fb2392e59c4$exports.Client)("ws://localhost:8004");
        } catch (error) {
            console.log("Battle Royale Server Error");
        }
        else {
            this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
            const wsEndpoint = this._config.websockets["battleroyale"];
            if (wsEndpoint) this.client = new (0, $243a0fb2392e59c4$exports.Client)(`${this._config.websockets.base}${wsEndpoint.path}`);
        }
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Events.EventEmitter();
    }
    static getInstance() {
        return $ef600a3a231959fc$var$BattleRoyaleServerService._instance;
    }
    join(playerData, isParticipant) {
        return this.client.join("battleroyale", {
            player: playerData,
            wallet: (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress(),
            isParticipant: isParticipant
        }).then((room)=>{
            this.room = room;
            this.room.state.listen("gameState", (value)=>{
                this.events.emit("gamestate-update");
            });
            this.room.state.participants.onAdd = ()=>{
                var _a, _b, _c, _d;
                if ((_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.participants) {
                    if (((_c = this.room.state.participants) === null || _c === void 0 ? void 0 : _c.length) > this._initialParticipantLength) {
                        this.events.emit("participants-updated");
                        this._initialParticipantLength = (_d = this.room.state.participants) === null || _d === void 0 ? void 0 : _d.length;
                    }
                }
            };
            this.room.state.messages.onAdd = ()=>{
                var _a, _b, _c, _d;
                if ((_b = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.messages) {
                    if (((_d = (_c = this.room) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.messages.length) > this._initialMessageLength) {
                        this.events.emit("message-received");
                        this._initialMessageLength = this.room.state.messages.length;
                    }
                }
            };
        });
    }
    leave() {
        var _a;
        this._initialMessageLength = 0;
        this._initialParticipantLength = 0;
        (_a = this.room) === null || _a === void 0 || _a.leave();
        this.events.removeAllListeners();
    }
    disableBattleRoyaleListeners() {
        this._initialMessageLength = 0;
        this._initialParticipantLength = 0;
        this.events.removeAllListeners();
    }
    // Listeners
    onParticipantsUpdated(cb, context) {
        this.events.on("participants-updated", cb, context);
    }
    onMessageRecieved(cb, context) {
        this.events.on("message-received", cb, context);
    }
    onGameStateChanged(cb, context) {
        this.events.on("gamestate-update", cb, context);
    }
    getRoomData() {
        var _a, _b, _c, _d, _e, _f, _g;
        var hasGameStarted = false;
        var isParticipant = false;
        var isViewer = false;
        var countDown = 0;
        var participantList = [];
        var viewerList = [];
        var gameState;
        var previousResults = [];
        var messages = [];
        var pfpData = [];
        if (this._roomMetaData) {
            this._metaPlayerList = (_a = this._roomMetaData.metadata) === null || _a === void 0 ? void 0 : _a.participants;
            // Participants already in-game
            (_b = this._roomMetaData.metadata) === null || _b === void 0 || _b.participants.forEach((participant)=>{
                participantList.push(participant);
                pfpData.push({
                    playerImageKey: participant.playerImageKey,
                    playerImageUrl: participant.playerImageUrl
                });
                if (participant.playerId === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) isParticipant = participant.isParticipant;
            });
            // Stores Viewers
            viewerList = (_c = this._roomMetaData.metadata) === null || _c === void 0 ? void 0 : _c.viewers;
            viewerList.forEach((viewer)=>{
                this._metaPlayerList.push(viewer);
                if (viewer.playerId === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) isViewer = viewer.isViewer;
            });
            previousResults = (_d = this._roomMetaData.metadata) === null || _d === void 0 ? void 0 : _d.previousResults;
            // Countdown till game starts
            countDown = (_e = this._roomMetaData.metadata) === null || _e === void 0 ? void 0 : _e.countDown;
            // GameState
            gameState = this.getGameStateEnum((_f = this._roomMetaData.metadata) === null || _f === void 0 ? void 0 : _f.gameState);
            if (((_g = this._roomMetaData.metadata) === null || _g === void 0 ? void 0 : _g.gameState) !== 0) hasGameStarted = true;
        }
        return {
            participants: participantList,
            viewers: viewerList,
            countDown: countDown,
            isParticipant: isParticipant,
            isViewer: isViewer,
            hasGameStarted: hasGameStarted,
            gameState: gameState,
            previousResults: previousResults,
            messages: messages,
            pfpData: pfpData
        };
    }
    getGameStateEnum(number) {
        switch(number){
            case 0:
                return (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame;
            case 1:
                return (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale;
            case 2:
                return (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission;
            case 4:
                return (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver;
            case 5:
                return (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed;
        }
        return (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame;
    }
    isServerAvailable() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.client.getAvailableRooms("battleroyale").then((room)=>{
                this._roomMetaData = room[0];
                this._isServerAlive = true;
            }).catch((err)=>{
            //console.log("BR Server not started")
            });
        });
    }
    updateMetaData() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.client.getAvailableRooms("battleroyale").then((room)=>{
                var _a;
                this._roomMetaData = room[0];
                this._initialParticipantLength = (_a = this._roomMetaData.metadata) === null || _a === void 0 ? void 0 : _a.participants.length;
            }).catch((err)=>{
            //console.log("BR Server not started")
            });
        });
    }
    isServerAlive() {
        return this._isServerAlive;
    }
    // Meta Participant List Functions
    getPlayerFromMetaParticipants(walletId) {
        var user = undefined;
        this._metaPlayerList.forEach((participant)=>{
            if (participant.playerId === walletId) user = participant;
        });
        return user;
    }
    getGameState() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState;
    }
    getMessages() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.messages;
    }
    getUserFromParticipantList(name) {
        var _a;
        var user;
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (participant.playerName === name) user = participant;
        });
        return user;
    }
    getParticipantsList() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.participants;
    }
    getBattleData() {
        var _a, _b, _c, _d, _e, _f;
        return {
            countDown: (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.countDown,
            gameState: (_b = this.room) === null || _b === void 0 ? void 0 : _b.state.gameState,
            round: (_c = this.room) === null || _c === void 0 ? void 0 : _c.state.round,
            participantsRemaining: (_d = this.room) === null || _d === void 0 ? void 0 : _d.state.participantsRemaining,
            messages: (_e = this.room) === null || _e === void 0 ? void 0 : _e.state.messages,
            participants: (_f = this.room) === null || _f === void 0 ? void 0 : _f.state.participants
        };
    }
    battleRoyaleStarted() {
        var _a;
        return ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) === (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale;
    }
    hasPlayerJoinedGame(walletId) {
        var _a, _b;
        var found = false;
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (participant.playerId === walletId) found = true;
        });
        (_b = this.room) === null || _b === void 0 || _b.state.viewers.forEach((participant)=>{
            if (participant.playerId === walletId) found = true;
        });
        return found;
    }
    getRoomInformation() {
        this.client.getAvailableRooms("battleroyale").then((rooms)=>{
            rooms.forEach((room)=>{});
        }).catch((e)=>{
            console.error(e);
        });
    }
    convertSecondsToCountdown(seconds) {
        seconds = Number(seconds);
        var hDisplay = Math.floor(seconds / 3600) + "H ";
        var mDisplay = Math.floor(seconds % 3600 / 60) + "M ";
        var sDisplay = Math.floor(seconds % 3600 % 60) + "S";
    }
    getPlayerFromParticipants(results, walletId) {
        var player = undefined;
        results.forEach((participant)=>{
            if (participant.playerId == walletId) player = participant;
        });
        return player;
    }
    getPlayerImageKeys() {
        var _a;
        var imageKeys = [];
        // gathers metadata keys
        this._metaPlayerList.forEach((participant)=>{
            imageKeys.push(participant.playerImageKey);
        });
        // gather participant key
        (_a = this.room) === null || _a === void 0 || _a.state.participants.forEach((participant)=>{
            if (!imageKeys.includes(participant.playerImageKey)) imageKeys.push(participant.playerImageKey);
        });
        return imageKeys;
    }
}
$ef600a3a231959fc$var$BattleRoyaleServerService._instance = new $ef600a3a231959fc$var$BattleRoyaleServerService();
var $ef600a3a231959fc$export$2e2bcd8739ae039 = $ef600a3a231959fc$var$BattleRoyaleServerService;









// Pane Details
const $21e0f7ed080395ae$var$paneHeight = 184;
const $21e0f7ed080395ae$var$paneWidth = 258;
const $21e0f7ed080395ae$var$paneRadius = 26;
const $21e0f7ed080395ae$var$paneColor = 0x053165;
const $21e0f7ed080395ae$var$paneAlpha = 0.9;
class $21e0f7ed080395ae$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $21e0f7ed080395ae$var$paneWidth,
            height: paneScale * $21e0f7ed080395ae$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scene = scene;
        this._scale = paneScale;
        this._roomData = data;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($21e0f7ed080395ae$var$paneWidth), scene.applyScale($21e0f7ed080395ae$var$paneHeight), scene.applyScale($21e0f7ed080395ae$var$paneRadius), $21e0f7ed080395ae$var$paneColor, $21e0f7ed080395ae$var$paneAlpha);
        this.add(background, {
            key: "background",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Panel
        var panel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($21e0f7ed080395ae$var$paneWidth),
            height: scene.applyScale($21e0f7ed080395ae$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Timer Progress Bar
        this._countDownProgressBar = new (0, $3a9bea67e0e561eb$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, (0, $f12f0c85b935f07d$export$bcbf232a15e036ba)());
        this._countDownProgressBar.setVisible(false);
        panel.add(this._countDownProgressBar, {
            key: "progress_bar",
            align: "left-top",
            offsetX: this.applyScale(24),
            offsetY: this.applyScale(-16),
            expand: false
        });
        // BattleRoyale Text
        this._battleRoyaleText = this.scene.add.bitmapText(0, 0, "cc_outline", "", scene.applyScale(18), 1);
        panel.add(this._battleRoyaleText, {
            key: "battleroyale-text",
            align: "left-top",
            offsetX: this.applyScale(24),
            offsetY: this.applyScale(40),
            expand: true
        });
        // Ready up Button
        this._readyUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "hud_battle_royale_blue_ready_up_button", false).setScale(this._scale);
        this._readyUpButton.onClick().subscribe((pointer)=>{
            this._scene.startBattleRoyaleScene();
        });
        panel.add(scene.add.existing(this._readyUpButton), {
            key: "ready-up-button",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(102),
            expand: false
        });
        this.add(panel, {
            key: "panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    updateCard(roomData) {
        var playerHasJoined = roomData.isParticipant;
        var cardText = "";
        var cardButtonTexture = "hud_battle_royale_blue_view_button";
        switch(roomData.gameState){
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
                this._countDownProgressBar.setVisible(true);
                this.startCountDownUI((0, $f12f0c85b935f07d$export$bcbf232a15e036ba)());
                //cardText = "Battle Royale is coming\n up shortly..."
                cardText = "Battle Royale Game Status\nPre Game";
                cardButtonTexture = playerHasJoined ? "hud_battle_royale_blue_view_button" : "hud_battle_royale_blue_ready_up_button";
                break;
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale:
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission:
                cardText = "Battle Royale Game Status\n Active";
                break;
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed:
                //cardText = "Battle Royale failed\nto start"
                cardText = "Battle Royale Game Status\nFailed to start";
                break;
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver:
                cardText = "Battle Royale Game Status\nPost Game";
                break;
        }
        this._battleRoyaleText.setText(cardText);
        this._readyUpButton.setTexture(cardButtonTexture);
    }
    startCountDownUI(countDown) {
        // Implements Countdown
        var remainingSeconds = countDown;
        // Resets Countdown Bar Values
        this._countDownProgressBar.roundTimerReset(this, remainingSeconds);
        clearInterval(this._internalTimer);
        this._internalTimer = setInterval(()=>{
            //var _timeRemainingInterval = setInterval(() => {
            try {
                if (remainingSeconds <= 0) return clearInterval(this._internalTimer);
                remainingSeconds--;
                this._countDownProgressBar.updateDisplay(this, remainingSeconds);
            } catch (error) {
                return clearInterval(this._internalTimer);
            }
        }, 1000);
    }
    stopTimer() {
        clearInterval(this._internalTimer);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("hudBattleRoyaleCardPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $21e0f7ed080395ae$export$2e2bcd8739ae039(this.scene, x, y));
});






const $2df50fb7fccdbf03$var$leftMargin = 24;
const $2df50fb7fccdbf03$var$topMargin = 24;
const $2df50fb7fccdbf03$var$progressBarHoverAlpha = 0.8;
const $2df50fb7fccdbf03$var$tintColor = 0xcdcdcd;
const $2df50fb7fccdbf03$var$minCanvasWidth = 1330;
const $2df50fb7fccdbf03$var$minCanvasHeight = 800;
const $2df50fb7fccdbf03$var$circleFillColor = 0xea1616;
const $2df50fb7fccdbf03$var$minDaysHeldToStake = 7;
var $2090dedfe0b7dd9a$exports = {};
$2090dedfe0b7dd9a$exports = new URL("hud-button-hover.82c28e77.wav", import.meta.url).toString();


class $2df50fb7fccdbf03$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(key){
        if (!key) key = {
            key: "HudScene"
        };
        super(key);
        this._allowProgressBarClicks = true;
        this._missionsWidget = {};
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f));
        // User Badge Assets
        const userBadges = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().userBadges;
        if (userBadges && userBadges.length > 0) userBadges.forEach((badge)=>{
            this.load.image(badge.badgeImageKey, badge.badgeImagePath);
        });
        // Squad PFPs
        const squad = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        if (squad && squad.length > 0) squad.forEach((sm)=>{
            this.load.image(sm.image_key, sm.image_thumbnail_url);
        });
        this.load.image("bossfight_hud_go_to_battle_button", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_hud_go_to_battle_button);
        this.load.audio("hud-button-hover", $2090dedfe0b7dd9a$exports);
        this.load.image("bossfight_clock_icon", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_clock_icon);
    }
    create() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2df50fb7fccdbf03$var$minCanvasWidth, $2df50fb7fccdbf03$var$minCanvasHeight);
            this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
            if (Array.isArray(this._userData.user)) {
                this._userData = this._userData.user[0];
                this._userData.brawlerCage = false;
            }
            this._userData.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
            this._userData.storage = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getStorageCapacities();
            this._miningStatus = (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatusSync();
            this._baseRaidInfo = (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttackSync();
            this._reward = (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedRewardSync();
            // BossFight
            yield (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().isServerAvailable();
            // Battle Royale
            yield (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().isServerAvailable();
            // Check for mining mission activity/rewards
            if (Object.keys(this._reward).length) this.addLastMinedRewardMissionButton();
            else if (this._miningStatus.length) this.addMissionProgressButton(this._miningStatus[0]);
            else {
                // Check for base raid activity/rewards
                if (this._baseRaidInfo.base_raid_id !== 0 && !this._baseRaidInfo.completed) // Base raid ongoing, show status
                this.addBaseRaidProgressButton(this._baseRaidInfo);
                else if (this._baseRaidInfo.base_raid_id !== 0 && this._baseRaidInfo.completed) // Base raid finished, show results
                this.addLastBaseRaidRewardMissionButton();
                else this.addMissionLaunchButton();
            }
            // Quests button
            this._objectivesButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(68), this.applyScale(140), "hud_quests_button", false).setScale(this._scale).setScrollFactor(0);
            this._objectivesButton.onClick().subscribe((pointer)=>{
                this.objectivesButtonClickHandler(pointer);
            });
            this._objectivesButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.objectivesButtonOnHover);
            this._objectivesButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, this.objectivesButtonOnOut);
            this.add.existing(this._objectivesButton);
            this.add.image(this.applyScale(68), this.applyScale(183), "quests_text").setOrigin(0.5, 0.5).setScale(this._scale);
            this._stakingAlert = this.add.circle(this.applyScale(105), this.applyScale(101), this.applyScale(8), $2df50fb7fccdbf03$var$circleFillColor, 1);
            this.setStakingAlertVisible();
            // Leaderboard button
            this._leaderboardButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(68), this.applyScale(255), "hud_leaderboard_button", false).setScale(this._scale).setScrollFactor(0);
            this._leaderboardButton.onClick().subscribe((pointer)=>{
                this.leaderboardButtonClickHandler(pointer);
            });
            this._leaderboardButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.leaderboardButtonOnHover);
            this._leaderboardButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, this.leaderboardButtonOnOut);
            this.add.existing(this._leaderboardButton);
            this.add.image(this.applyScale(68), this.applyScale(299), "leaders_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Helpdesk Button
            this._helpdeskButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(68), this.applyScale(370), "hud_helpdesk_button", false).setScale(this._scale).setScrollFactor(0);
            this._helpdeskButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.helpdeskButtonOnHover);
            this._helpdeskButton.onClick().subscribe((pointer)=>{
                this.helpdeskButtonClickHandler(pointer);
            });
            this.add.existing(this._helpdeskButton);
            this.add.image(this.applyScale(68), this.applyScale(415), "help_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Raid History Button
            this._raidHistoryButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(68), this.applyScale(485), "hud_raid_history_button", false).setScale(this._scale).setScrollFactor(0);
            this._raidHistoryButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.raidHistoryButtonOnHover);
            this._raidHistoryButton.onClick().subscribe((pointer)=>{
                this.raidHistoryButtonClickHandler(pointer);
            });
            this.add.existing(this._raidHistoryButton);
            this.add.image(this.applyScale(68), this.applyScale(529), "raid_history_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Battle Pass Button
            this._battlePassButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(68), this.applyScale(600), "hud_battlepass_button", false).setScale(this._scale).setScrollFactor(0);
            this._battlePassButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.battlePassButtonOnHover);
            this._battlePassButton.onClick().subscribe((pointer)=>{
                this.battlePassButtonClickHandler(pointer);
            });
            this.add.existing(this._battlePassButton);
            this.add.image(this.applyScale(68), this.applyScale(642), "battlepass_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Squad display
            this._squadComponent = new (0, $e78296f6c79d7b0d$export$2e2bcd8739ae039)(this, this.applyScale(155), this.sys.canvas.height - this.applyScale(80), this._scale);
            this.add.image(this.applyScale(78), this.sys.canvas.height - this.applyScale(129), "your_squad_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Army Button
            this._armyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(347), this.sys.canvas.height - this.applyScale(80), "hud_army_button", false);
            this._armyButton.displayHeight = 100;
            this._armyButton.scaleX = this._armyButton.scaleY;
            this._armyButton.setScale(this._armyButton.scale * this._scale).setScrollFactor(0);
            this._armyButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.armyButtonOnHover);
            this._armyButton.onClick().subscribe((pointer)=>{
                this.armyButtonClickHandler(pointer);
            });
            this.add.existing(this._armyButton);
            this.add.image(this.applyScale(334), this.sys.canvas.height - this.applyScale(129), "troops_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Build button
            this._buildButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(458), this.sys.canvas.height - this.applyScale(80), "hud_build_button", false);
            this._buildButton.displayHeight = 100;
            this._buildButton.scaleX = this._buildButton.scaleY;
            this._buildButton.setScale(this._buildButton.scale * this._scale).setScrollFactor(0);
            this._buildButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.buildButtonOnHover);
            this._buildButton.onClick().subscribe((pointer)=>{
                this.buildButtonClickHandler(pointer);
            });
            this.add.existing(this._buildButton);
            this.add.image(this.applyScale(442), this.sys.canvas.height - this.applyScale(129), "build_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // Shop button
            this._shopButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(567), this.sys.canvas.height - this.applyScale(80), "hud_shop_button", false);
            this._shopButton.displayHeight = 100;
            this._shopButton.scaleX = this._shopButton.scaleY;
            this._shopButton.setScale(this._shopButton.scale * this._scale).setScrollFactor(0);
            this._shopButton.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, this.shopButtonOnHover);
            this._shopButton.onClick().subscribe((pointer)=>{
                this.shopButtonClickHandler(pointer);
            });
            this.add.existing(this._shopButton);
            this.add.image(this.applyScale(549), this.sys.canvas.height - this.applyScale(129), "shop_text").setOrigin(0.5, 0.5).setScale(this._scale);
            // BossFight Widget
            this._bossFightCardPane = new (0, $048630434f6bd4fe$export$2e2bcd8739ae039)(this, this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(350), //this.sys.canvas.height - 80,
            {}, this._scale);
            this.add.existing(this._bossFightCardPane);
            this._bossFightCardPane.setVisible(false);
            this.launchBossFightAlerts();
            // Battle Royale Widget
            this._battleRoyaleCardPane = new (0, $21e0f7ed080395ae$export$2e2bcd8739ae039)(this, this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(350), {}, this._scale);
            this.add.existing(this._battleRoyaleCardPane);
            this._battleRoyaleCardPane.setVisible(false);
            this.launchBattleRoyaleAlerts();
            this.addLevelBar(this);
            this.addResourcesComponent((0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync());
            // Notifications for onboarding
            if (this._notifications) this._notifications = undefined;
            this.displayOnboardingNotifications();
            this.events.on("resume", (scene, data)=>{
                if (data != undefined && data.squadUpdated) this._squadComponent.updateSquad(true);
                this.updateProgressBars(true);
            });
            if ((0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getIsNewUser()) {
                this.scene.pause("HomebaseScene");
                this.scene.pause("HudScene");
                this.scene.launch("SquadModalScene");
            }
        });
    }
    missionsButtonClickHandler(pointer) {
        this.scene.pause("HomebaseScene");
        this.scene.pause("HudScene");
        this.scene.launch("MissionsModalScene");
    }
    buildButtonClickHandler(pointer) {
        this.scene.pause();
        this.scene.get("HomebaseScene").input.enabled = false;
        this.scene.launch("ShopModalScene", {
            active_tab: "machines"
        });
    }
    shopButtonClickHandler(pointer) {
        this.scene.pause();
        this.scene.get("HomebaseScene").input.enabled = false;
        this.scene.launch("ShopModalScene", {
            active_tab: "item_shop"
        });
    }
    launchBattleRoyaleAlerts() {
        // Check if Server is up and running
        if ((0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().isServerAlive()) {
            var roomData = (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().getRoomData();
            var brCountdown = (0, $f12f0c85b935f07d$export$bcbf232a15e036ba)();
            switch(roomData.gameState){
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
                    // Show Small BR Notification
                    if (brCountdown < 1800 /*&& brCountdown > 60*/ ) {
                        // BR Starts in less than 30 minutes. Show UI to player
                        this._battleRoyaleCardPane.setVisible(true);
                        this._battleRoyaleCardPane.updateCard(roomData);
                    }
                    // Show the Battle Royale Game Alert Notification - PreGame
                    if (brCountdown < 60) this.battleRoyaleAlertHandler(roomData.isParticipant);
                    break;
                default:
                    // show blue notification. change display based on gamestate and if player has joined or not
                    this._battleRoyaleCardPane.setVisible(true);
                    this._battleRoyaleCardPane.updateCard(roomData);
                    break;
            }
        }
    }
    launchBossFightAlerts() {
        // Check if Server is up and running
        if ((0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().isServerAlive()) {
            var roomData = (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().getRoomMetaData();
            var bfCountdown = (0, $f12f0c85b935f07d$export$43a43cf967792f11)();
            switch(roomData.gameState){
                case 0:
                    //Show Small BF Notification
                    if (bfCountdown < 1800) {
                        // BF Starts in less than 30 minutes. Show UI to player
                        this._bossFightCardPane.setVisible(true);
                        this._bossFightCardPane.updateCard(roomData);
                    }
                    // Show the Battle Royale Game Alert Notification - PreGame
                    if (bfCountdown < 60) this.bossFightAlertHandler();
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    this._bossFightCardPane.setVisible(true);
                    this._bossFightCardPane.updateCard(roomData);
                    break;
            }
        }
    }
    battleRoyaleAlertHandler(hasPlayerJoined) {
        this.scene.pause("HomebaseScene");
        this.scene.pause("HudScene");
        this.scene.launch("HudBattleRoyaleAlertScene", {
            hasPlayerJoined: hasPlayerJoined
        });
    }
    bossFightAlertHandler() {
        this.scene.pause("HomebaseScene");
        this.scene.pause("HudScene");
        this.scene.launch("HudBossFightAlertScene");
    }
    objectivesButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
        this.scene._objectivesButton.setTint($2df50fb7fccdbf03$var$tintColor);
    }
    objectivesButtonOnOut(pointer) {
        this.scene._objectivesButton.clearTint();
    }
    leaderboardButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
        this.scene._leaderboardButton.setTint($2df50fb7fccdbf03$var$tintColor);
    }
    helpdeskButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    armyButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    raidHistoryButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    battlePassButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    shopButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    buildButtonOnHover(pointer) {
        this.scene.sound.play("hud-button-hover");
    }
    leaderboardButtonOnOut(pointer) {
        this.scene._leaderboardButton.clearTint();
    }
    objectivesButtonClickHandler(pointer) {
        const config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this.scene.pause();
        this.scene.pause("HomebaseScene");
        this.scene.launch(config.features.objectives_modal ? "ObjectivesModalScene" : "DashboardScene");
    }
    leaderboardButtonClickHandler(pointer) {
        this.scene.pause();
        this.scene.pause("HomebaseScene");
        this.scene.launch("LeaderboardScene");
    }
    helpdeskButtonClickHandler(pointer) {
        this.scene.pause();
        this.scene.pause("HomebaseScene");
        this.scene.launch("HelpdeskModalScene");
    }
    armyButtonClickHandler(pointer) {
        this.scene.get("HomebaseScene").input.enabled = false;
        this.scene.pause("HudScene");
        this.scene.launch("ArmyModalScene", {
            machine: {
                user_machine_id: 0,
                machine_id: 0
            }
        });
    }
    raidHistoryButtonClickHandler(pointer) {
        this.scene.stop("HomebaseScene");
        this.scene.stop("HudScene");
        this.scene.start("BaseRaidHistoryScene", {
            tab: "defense_log"
        });
    }
    battlePassButtonClickHandler(pointer) {
        var hasPass = this._userData.has_battlepass === 1 ? true : false;
        if (hasPass) {
            this.scene.stop("HomebaseScene");
            this.scene.stop("HudScene");
            this.scene.start("BattlePassScene", {
                userData: this._userData
            });
        } else {
            // Takes user to purchase scene
            this.scene.stop("HomebaseScene");
            this.scene.stop("HudScene");
            this.scene.start("BattlePassBuyScene" /*, {}*/ );
        }
    }
    stardustButtonClickHandler(pointer) {
        this.scene.pause();
        this.scene.pause("HomebaseScene");
        this.scene.launch("ShopModalStardustStationScene");
    }
    applyScale(number) {
        return number * this._scale;
    }
    addLevelBar() {
        if (this._levelProgressBar) this._levelProgressBar.destroy();
        this._levelProgressBar = new (0, $da58ee258d224181$export$2e2bcd8739ae039)(this, this.applyScale(132), this.applyScale(43), this._scale, this._userData);
        if (this._allowProgressBarClicks) this._levelProgressBar.setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
            this.scene.scene.sound.play("hud-button-hover");
            this._levelProgressBar.setAlpha($2df50fb7fccdbf03$var$progressBarHoverAlpha);
        }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
            this._levelProgressBar.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
            this._levelProgressBar.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            this._levelProgressBar.setAlpha($2df50fb7fccdbf03$var$progressBarHoverAlpha);
            if (pointer.getDistance() > 16) return;
            const config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
            this.scene.get("HomebaseScene").input.enabled = false;
            this.scene.launch(config.features.profile_modal ? "ProfileModalScene" : "UserLevelModalScene", {
                userData: this._userData
            });
            this.scene.pause();
        });
        this.add.existing(this._levelProgressBar);
    }
    addResourcesComponent(userMachines) {
        this._resourcesComponent = new (0, $682301f732d46d2b$export$2e2bcd8739ae039)(this, this.sys.canvas.width - this.applyScale(144), this.applyScale(174), this._userData, userMachines, this._allowProgressBarClicks, this._scale);
        this.add.existing(this._resourcesComponent);
    }
    updateProgressBars(forceUpdate = true) {
        if (forceUpdate) (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((data)=>{
            this._userData = data;
            this.updateProgressBars(false);
        });
        else if (this._resourcesComponent) {
            const userMachines = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync();
            this._resourcesComponent.updateProgressBars(userMachines, this._userData);
        }
    }
    addMissionLaunchButton() {
        this._missionsWidget.rect = this.add.image(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(122), "mission_rect").setScale(this._scale).setScrollFactor(0);
        this._missionsWidget.defaultText = this.add.image(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(160), "mission_default_text").setScale(this._scale).setScrollFactor(0);
        this._missionsWidget.space_elixir_icon = this.add.image(this.sys.canvas.width - this.applyScale(194), this.sys.canvas.height - this.applyScale(214), "space_elixir_icon").setScale(0.8 * this._scale).setScrollFactor(0);
        this._missionsWidget.neon_gold_icon = this.add.image(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(214), "neon_gold_icon").setScale(0.8 * this._scale).setScrollFactor(0);
        this._missionsWidget.stardust_icon = this.add.image(this.sys.canvas.width - this.applyScale(120), this.sys.canvas.height - this.applyScale(214), "stardust_icon").setScale(0.8 * this._scale).setScrollFactor(0);
        this._missionsWidget.button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(80), "mission_btn_enabled", false).setScale(this._scale).setScrollFactor(0);
        this.add.existing(this._missionsWidget.button);
        this._missionsWidget.button.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this.scene.scene.sound.play("hud-button-hover");
        });
        this._missionsWidget.button.onClick().subscribe((pointer)=>{
            this.missionsButtonClickHandler(pointer);
        });
    }
    addLastMinedRewardMissionButton() {
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale(258), this.applyScale(184), this.applyScale(26), 0x350926, 0.9);
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: "Done",
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(169),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 100,
                glare: {
                    width: this.applyScale(159),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        const button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "view_mission_btn", false).setScale(this._scale).setScrollFactor(0);
        this.add.existing(button);
        button.onClick().subscribe(()=>{
            this.scene.start("MiningResultScene");
            this.scene.stop("HomebaseScene");
            this.scene.stop();
        });
        const label = this.add.bitmapText(0, 0, "cc_outline", [
            "Ready to view",
            "mining mission reward"
        ], this.applyScale(18), 1);
        this._missionWidget = this.rexUI.add.sizer(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(122), {
            orientation: "y",
            width: this.applyScale(258),
            height: this.applyScale(184),
            space: this.applyScale(20)
        }).addBackground(background).add(progressBar, {
            padding: {
                top: -this.applyScale(27)
            }
        }).addSpace().add(label).addSpace().add(button).layout();
    }
    addMissionProgressButton(asteroid) {
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale(258), this.applyScale(184), this.applyScale(26), 0x350926, 0.9);
        const startTime = new Date(asteroid.user_mining_started_time * 1000).getTime();
        const endTime = new Date(asteroid.estimated_mine_time_finished * 1000).getTime();
        let nowSeconds = Math.floor(Date.now() / 1000);
        let startSeconds = Math.floor(startTime / 1000);
        let endSeconds = Math.floor(endTime / 1000);
        let remainingSeconds = Math.floor(endSeconds - nowSeconds) + 1;
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: (0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds),
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(169),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: startSeconds,
                maxValue: endSeconds,
                progressValue: startSeconds + remainingSeconds,
                glare: {
                    width: this.applyScale(159),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        let refreshStatus = ()=>{
            clearInterval(progressBarInterval);
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus().then((response)=>{
                const isMiningComplete = !response.length;
                if (isMiningComplete) {
                    this._missionWidget.clear(true);
                    (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedReward().then(()=>this.create());
                } else {
                    const newAsteroid = response[0];
                    const newEndTime = new Date(newAsteroid.estimated_mine_time_finished * 1000).getTime();
                    remainingSeconds = Math.floor(newEndTime / 1000) - Math.floor(Date.now() / 1000);
                    var minimumSeconds = 10;
                    progressBarInterval = setInterval(progressBarIntervalFunction, remainingSeconds > 10 ? remainingSeconds * 1000 : minimumSeconds * 1000);
                }
            });
        };
        let progressBarIntervalFunction = ()=>{
            try {
                if (remainingSeconds <= 0) refreshStatus();
                else {
                    remainingSeconds--;
                    remainingSeconds = remainingSeconds < 0 ? 0 : remainingSeconds;
                    progressBar.setProgressBarText((0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds));
                    progressBar.setProgressValue(this, startSeconds + remainingSeconds);
                }
            } catch (error) {
                clearInterval(progressBarInterval);
            }
        };
        let progressBarInterval = setInterval(progressBarIntervalFunction, 1000);
        const button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "view_mission_btn", false).setScale(this._scale).setScrollFactor(0);
        this.add.existing(button);
        button.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this.scene.scene.sound.play("hud-button-hover");
        });
        button.onClick().subscribe(()=>{
            this.scene.stop("HomebaseScene");
            this.scene.stop();
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus().then((asteroids)=>{
                if (asteroids.length) this.scene.start("MiningStatusScene", {
                    asteroidId: asteroid.asteroid_id
                });
                else (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedReward().then(()=>this.scene.start("MiningResultScene"));
            });
        });
        const label = this.add.bitmapText(0, 0, "cc_outline", [
            "Currently mining",
            `a ${(0, $682c5d521fb8ae22$export$aaac5bc6d10d929c)[asteroid.asteroid_rarity_id]} asteroid`
        ], this.applyScale(18), 1).setWordTint((0, $682c5d521fb8ae22$export$aaac5bc6d10d929c)[asteroid.asteroid_rarity_id], 1, false, asteroid.asteroid_rarity_id === 1 ? 0x75758f : (0, $682c5d521fb8ae22$export$b9b712abdb918f5b)[asteroid.asteroid_rarity_id]);
        this._missionWidget = this.rexUI.add.sizer(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(122), {
            orientation: "y",
            width: this.applyScale(258),
            height: this.applyScale(184),
            space: this.applyScale(20)
        }).addBackground(background).add(progressBar, {
            padding: {
                top: -this.applyScale(27)
            }
        }).addSpace().add(label).addSpace().add(button).layout();
    }
    addLastBaseRaidRewardMissionButton() {
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale(258), this.applyScale(184), this.applyScale(26), 0x350926, 0.9);
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: "Done",
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(169),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 100,
                glare: {
                    width: this.applyScale(159),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        const button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "view_mission_btn", false).setScale(this._scale).setScrollFactor(0);
        this.add.existing(button);
        button.onClick().subscribe(()=>{
            const resultData = {
                isAttacker: true,
                neon_gold: this._baseRaidInfo.attacker_possible_loot.neon_gold,
                space_elixir: this._baseRaidInfo.attacker_possible_loot.space_elixir,
                stardust: this._baseRaidInfo.attacker_possible_loot.stardust,
                xp: this._baseRaidInfo.is_win ? this._baseRaidInfo.attacker_win_xp : this._baseRaidInfo.attacker_lose_xp,
                isVictory: this._baseRaidInfo.is_win
            };
            this.scene.start("BaseRaidResultScene", resultData);
            this.scene.stop("HomebaseScene");
            this.scene.stop();
        });
        const label = this.add.bitmapText(0, 0, "cc_outline", [
            "Ready to view",
            "base raid results"
        ], this.applyScale(18), 1);
        this._missionWidget = this.rexUI.add.sizer(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(122), {
            orientation: "y",
            width: this.applyScale(258),
            height: this.applyScale(184),
            space: this.applyScale(20)
        }).addBackground(background).add(progressBar, {
            padding: {
                top: -this.applyScale(27)
            }
        }).addSpace().add(label).addSpace().add(button).layout();
    }
    addBaseRaidProgressButton(raidInfo) {
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale(258), this.applyScale(184), this.applyScale(26), 0x350926, 0.9);
        const executionSteps = this._baseRaidInfo.base_raid_execution;
        const startTime = this._baseRaidInfo.attack_start_time;
        const endTime = executionSteps[executionSteps.length - 1].end_time;
        let nowSeconds = Math.floor(Date.now() / 1000);
        let remainingSeconds = Math.floor(endTime - nowSeconds) + 1;
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: (0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds),
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(169),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: startTime,
                maxValue: endTime,
                progressValue: startTime + remainingSeconds,
                glare: {
                    width: this.applyScale(159),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        let refreshStatus = ()=>{
            clearInterval(progressBarInterval);
            (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((response)=>{
                this._baseRaidInfo = response;
                const isRaidComplete = response.completed;
                if (isRaidComplete) {
                    this._missionWidget.clear(true);
                    this.create();
                } else {
                    const newEndTime = response.base_raid_execution[response.base_raid_execution.length - 1].end_time;
                    remainingSeconds = Math.floor(newEndTime / 1000) - Math.floor(Date.now() / 1000);
                    var minimumSeconds = 10;
                    progressBarInterval = setInterval(progressBarIntervalFunction, remainingSeconds > 10 ? remainingSeconds * 1000 : minimumSeconds * 1000);
                }
            });
        };
        let progressBarIntervalFunction = ()=>{
            try {
                if (remainingSeconds <= 0) refreshStatus();
                else {
                    remainingSeconds--;
                    remainingSeconds = remainingSeconds < 0 ? 0 : remainingSeconds;
                    progressBar.setProgressBarText((0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds));
                    progressBar.setProgressValue(this, startTime + remainingSeconds);
                }
            } catch (error) {
                clearInterval(progressBarInterval);
            }
        };
        let progressBarInterval = setInterval(progressBarIntervalFunction, 1000);
        const button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "visit_mission_btn", false).setScale(this._scale).setScrollFactor(0);
        this.add.existing(button);
        button.on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this.scene.scene.sound.play("hud-button-hover");
        });
        button.onClick().subscribe(()=>{
            this.scene.stop("HomebaseScene");
            this.scene.stop();
            (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((attackRes)=>{
                this.scene.start("BaseRaidDetailsScene", Object.assign({}, attackRes, {
                    is_attacking: true
                }));
            });
        });
        const label = this.add.bitmapText(0, 0, "cc_outline", [
            "Currently Raiding",
            `${this._baseRaidInfo.defender_user.display_name}'s base.`
        ], this.applyScale(18), 1);
        this._missionWidget = this.rexUI.add.sizer(this.sys.canvas.width - this.applyScale(159), this.sys.canvas.height - this.applyScale(122), {
            orientation: "y",
            width: this.applyScale(258),
            height: this.applyScale(184),
            space: this.applyScale(20)
        }).addBackground(background).add(progressBar, {
            padding: {
                top: -this.applyScale(27)
            }
        }).addSpace().add(label).addSpace().add(button).layout();
    }
    startBossFightScene() {
        this.scene.stop("HomebaseScene");
        this.scene.stop("HudScene");
        this.scene.start("BossFightScene");
    }
    startBattleRoyaleScene() {
        (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().updateMetaData().then(()=>{
            this.scene.get("HomebaseScene").scene.stop();
            this.scene.get("HudScene").scene.stop();
            this.scene.start("BattleRoyaleScene");
        });
    }
    displayOnboardingNotifications() {
        this._notificationData = (0, $48a6a2cbeff86768$export$2e2bcd8739ae039).getInstance().getNotificationsSync();
        this._notificationData.forEach((note)=>{
            if (this._userData[`modal${note.number}`] === 1) {
                // User hasn't closed notication yet, display it
                if (!this._notifications) this._notifications = [];
                if (note.number === 3 && this.sys.canvas.width < $2df50fb7fccdbf03$var$minCanvasWidth) return;
                const coords = this.getNotificationCoords(note);
                const handPointer = this.add.image(coords.handX, coords.handY, note.pointerImageKey);
                const noteComponent = new (0, $252e2f5812e34f90$export$2e2bcd8739ae039)(this, coords.noteX, coords.noteY, {
                    title: note.title,
                    description: note.description,
                    number: note.number
                });
                this.add.existing(noteComponent);
                this._notifications.push({
                    noteNumber: note.number,
                    pointerComponent: handPointer,
                    noteComponent: noteComponent
                });
            }
        });
    }
    getNotificationCoords(note) {
        switch(note.anchorCorner){
            case "top-left":
                return {
                    noteX: note.noteX,
                    noteY: note.noteY,
                    handX: note.handX,
                    handY: note.handY
                };
            case "bottom-left":
                return {
                    noteX: note.noteX,
                    noteY: this.sys.canvas.height + note.noteY,
                    handX: note.handX,
                    handY: this.sys.canvas.height + note.handY
                };
            case "top-right":
                return {
                    noteX: this.sys.canvas.width + note.noteX,
                    noteY: note.noteY,
                    handX: this.sys.canvas.width + note.handX,
                    handY: note.handY
                };
            case "bottom-right":
                return {
                    noteX: this.sys.canvas.width + note.noteX,
                    noteY: this.sys.canvas.height + note.noteY,
                    handX: this.sys.canvas.width + note.handX,
                    handY: this.sys.canvas.height + note.handY
                };
            default:
                return {
                    noteX: note.noteX,
                    noteY: note.noteY,
                    handX: note.handX,
                    handY: note.handY
                };
        }
    }
    closeNotification(notificationNumber) {
        const note = this._notifications.find((notePointer)=>{
            return notePointer.noteNumber === notificationNumber;
        });
        if (note) {
            note.pointerComponent.setAlpha(0);
            note.pointerComponent.destroy();
            note.noteComponent.clear(true);
            this._notifications.filter((item)=>item.noteNumber !== note.noteNumber);
        }
    }
    getUnclaimedStakes() {
        const stakingInfo = (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfoSync();
        return stakingInfo.nfts.filter((nft)=>{
            return nft.days_held >= $2df50fb7fccdbf03$var$minDaysHeldToStake && !nft.staking_reward_info;
        });
    }
    setStakingAlertVisible() {
        const unclaimedStakes = this.getUnclaimedStakes();
        if (unclaimedStakes.length > 0) this._stakingAlert.setAlpha(1);
        else this._stakingAlert.setAlpha(0);
    }
    destroy() {
        this._levelProgressBar.destroy();
        this._objectivesButton.destroy();
        this._leaderboardButton.destroy();
        this._squadComponent.destroy();
        this._bossFightCardPane.destroy();
        this._notifications.forEach((note)=>{
            note.pointerComponent.destroy();
            note.noteComponent.destroy();
        });
        this._notifications = undefined;
    }
    onTabbedOut() {
        this._bossFightCardPane.stopTimer();
        this._bossFightCardPane.setVisible(false);
        this._battleRoyaleCardPane.stopTimer();
        this._battleRoyaleCardPane.setVisible(false);
    }
    onTabbedIn() {
        this.launchBattleRoyaleAlerts();
        this.launchBossFightAlerts();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$8c40c41ae0483b9f)));
    }
}








class $af9bf77f128bbc45$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, useOverScale = true, overScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            width: paneScale * 150,
            space: {
                left: paneScale * 13,
                right: paneScale * 13,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._squadMember = data;
        this._useOverScale = useOverScale;
        this._overScale = overScale || 1.04;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        var _a, _b;
        // Image button
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._squadMember.image_key);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 8;
        this._squadMemberImage = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMember.image_key, rectConfig, this._useOverScale, this._overScale);
        this._squadMemberImage.displayHeight = this.applyScale(149);
        this._squadMemberImage.scaleX = this._squadMemberImage.scaleY;
        if (this._squadMember.disabled === true) this._squadMemberImage.disableInteractive();
        smImageData.destroy();
        scene.add.existing(this._squadMemberImage);
        const labelSizer = new (0, $92d11076da36f893$export$2e2bcd8739ae039)(this.scene, {
            width: this._scale * 149,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        this._squadMemberLabel = scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName().toUpperCase(), this.applyScale(16), 0).setOrigin(0, 0.5);
        labelSizer.add(this._squadMemberLabel, {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "squad_member_label"
        }).layout();
        this.add(this._squadMemberImage, {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "squad_member_image"
        });
        this.add(labelSizer, {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(15),
                bottom: 0
            },
            key: "squad_member_label_sizer"
        });
        this._hpLabel = scene.add.bitmapText(0, 0, "cc_outline", `HP: ${((_a = this._squadMember.hp) === null || _a === void 0 ? void 0 : _a.toString()) || "0"}`, this.applyScale(14), 0);
        this._hpLabel.alpha = 0.4;
        this.add(this._hpLabel, {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(3),
                bottom: 0
            },
            key: "hp_label"
        });
        if (!data.show_hp) this._hpLabel.setAlpha(0);
        // Add Yield display (optional)
        this._yieldLabel = scene.add.bitmapText(0, 0, "cc_outline", `Yield: ${((_b = this._squadMember.yield) === null || _b === void 0 ? void 0 : _b.toString()) || "0"} Stardust/day`, this.applyScale(14), 0);
        this._yieldLabel.alpha = 0.4;
        this.add(this._yieldLabel, {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(3),
                bottom: 0
            },
            key: "yield_label"
        });
        if (!data.show_yield) this._yieldLabel.setAlpha(0);
    }
    applyScale(length) {
        return length * this._scale;
    }
    getDisplayName() {
        if (this._squadMember.nft_collection) switch(this._squadMember.nft_collection){
            case "Star Wolvez Genesis":
                return `Genesis Wolf #${this._squadMember.nft_id}`;
            case "GalacticApes":
                return `Galactic Ape #${parseInt(this._squadMember.nft_id) + 1}`;
            case "Satoshi Runners Genesis":
                return `Satoshi Run... #${this._squadMember.nft_id}`;
            default:
                return this._squadMember.display_name;
        }
        return this._squadMember.display_name;
    }
    setSquadMemberData(data) {
        this._squadMember = data;
        this.updateImage();
        this.updateText();
        this.setVisibility();
        this.setEnabled();
        this.layout();
    }
    updateImage() {
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this.scene, 0, 0, this._squadMember.image_key);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 8;
        this._squadMemberImage.setTexture(this._squadMember.image_key, rectConfig);
        if (this._squadMember.disabled) this._squadMemberImage.displayHeight = this.applyScale(149);
        else this._squadMemberImage.displayHeight = this.applyScale(149);
        this._squadMemberImage.scaleX = this._squadMemberImage.scaleY;
        smImageData.destroy();
    }
    updateText() {
        var _a, _b;
        this._squadMemberLabel.setText(this.getDisplayName().toUpperCase());
        this._hpLabel.setText(`HP: ${((_a = this._squadMember.hp) === null || _a === void 0 ? void 0 : _a.toString()) || "0"}`);
        this._yieldLabel.setText(`Yield: ${((_b = this._squadMember.yield) === null || _b === void 0 ? void 0 : _b.toString()) || "0"} Stardust/day`);
    }
    setVisibility() {
        this._hpLabel.setAlpha(this._squadMember.show_hp ? 0.4 : 0);
        this._yieldLabel.setAlpha(this._squadMember.show_yield ? 0.4 : 0);
    }
    setEnabled() {
        if (this._squadMember.disabled === true) this._squadMemberImage.disableInteractive();
        else this._squadMemberImage.setInteractive();
    }
    onClick() {
        return this._squadMemberImage.clickSubject.asObservable();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("squadMemberComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $af9bf77f128bbc45$export$2e2bcd8739ae039(this.scene, x, y));
});





class $a09da6b186fd2edf$var$CollectionService {
    constructor(){
        if ($a09da6b186fd2edf$var$CollectionService._instance) throw new Error("Error: Instantiation failed: Use CollectionService.getInstance() instead of new.");
        $a09da6b186fd2edf$var$CollectionService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this._collections = this._config.collections;
    }
    static getInstance() {
        return $a09da6b186fd2edf$var$CollectionService._instance;
    }
    getCollections() {
        return this._collections;
    }
    getCollectionsWithAll() {
        // Append 'All' option to collections
        const colClone = JSON.parse(JSON.stringify(this._collections));
        const colsWithAll = colClone.unshift({
            // Adds element to beginning of array clone
            displayName: "All",
            collectionSlugs: this.getAllCollectionSlugs(),
            isSelected: true
        });
        return colClone;
    }
    getAllCollectionSlugs() {
        return this._collections.flatMap((colInfo)=>{
            return colInfo.collectionSlugs;
        });
    }
}
$a09da6b186fd2edf$var$CollectionService._instance = new $a09da6b186fd2edf$var$CollectionService();
var $a09da6b186fd2edf$export$2e2bcd8739ae039 = $a09da6b186fd2edf$var$CollectionService;





const $0e0517e7570e87c7$var$componentHeight = 20;
const $0e0517e7570e87c7$var$maxPagesVisible = 10;
class $0e0517e7570e87c7$export$2e2bcd8739ae039 extends (0, $51cc3ff23d0f8c1d$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, width, scale, config){
        //Data = { totalCount: number, pageSize: number }
        let conf = config ? config : {
            width: scene.applyScale(width),
            height: scene.applyScale($0e0517e7570e87c7$var$componentHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 1
        };
        super(scene, x, y, conf);
        this._totalCount = data.totalCount;
        this._pageSize = data.pageSize;
        this._numPages = Math.ceil(this._totalCount / this._pageSize);
        this._currentPage = 1;
        this._currentFirstPage = 1;
        this._currentLastPage = this._numPages < $0e0517e7570e87c7$var$maxPagesVisible ? this._numPages : $0e0517e7570e87c7$var$maxPagesVisible;
        this._scale = scale || 1;
        return this.createComponent(scene);
    }
    createComponent(scene) {
        this.addPrevButton(scene);
        this.addNumberedButtons(scene);
        this.addNextButton(scene);
        this.updateButtonAlpha();
        return scene.add.existing(this.layout());
    }
    addPrevButton(scene) {
        this._prevButton = scene.add.bitmapText(0, 0, "cc_outline", "<", scene.applyScale(20), 0);
        this._prevButton.setInteractive({
            cursor: "pointer"
        });
        this._prevButton.on("pointerdown", (pointer)=>{
            this.prevButtonClickHandler(pointer);
        }, this);
        this.add(this._prevButton, {
            key: "prev_button",
            padding: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }
        });
        this.addSpace();
    }
    addNumberedButtons(scene) {
        if (this._numberedButtons && this._numberedButtons.length > 0) while(this._numberedButtons.length > 0)this._numberedButtons.pop();
        else this._numberedButtons = [];
        if (this._numPages > $0e0517e7570e87c7$var$maxPagesVisible && !this._prevPageSetButton) this.addPrevPageSetButton(scene);
        console.log(`First page: ${this._currentFirstPage}`);
        console.log(`Last page: ${this._currentLastPage}`);
        for(let i = this._currentFirstPage; i <= this._currentLastPage; i++){
            this._numberedButtons.push(scene.add.bitmapText(0, 0, "cc_outline", `${i}`, scene.applyScale(20), 0));
            this._numberedButtons[i - this._currentFirstPage].setInteractive({
                cursor: "pointer"
            });
            this._numberedButtons[i - this._currentFirstPage].on("pointerdown", (pointer)=>{
                if (this._currentPage === i) return;
                this.disableButtons();
                this._currentPage = i;
                this.updateNumberedButtons();
                this.scene.updatePage(this._currentPage);
            }, this);
            this.add(this._numberedButtons[i - this._currentFirstPage], {
                key: `page_${i}_button`,
                padding: {
                    left: 0,
                    top: 0,
                    right: scene.applyScale(10),
                    bottom: 0
                }
            });
        }
        if (this._numPages > $0e0517e7570e87c7$var$maxPagesVisible && !this._nextPageSetButton) this.addNextPageSetButton(scene);
        this.addSpace();
    }
    addNextButton(scene) {
        this._nextButton = scene.add.bitmapText(0, 0, "cc_outline", ">", scene.applyScale(20), 0);
        this._nextButton.setInteractive({
            cursor: "pointer"
        });
        this._nextButton.on("pointerdown", (pointer)=>{
            this.nextButtonClickHandler(pointer);
        }, this);
        this.add(this._nextButton, {
            key: "next_button",
            padding: {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }
        });
    }
    addPrevPageSetButton(scene) {
        this._prevPageSetButton = scene.add.bitmapText(0, 0, "cc_outline", `<<`, scene.applyScale(20), 0);
        this._prevPageSetButton.setInteractive({
            cursor: "pointer"
        });
        this._prevPageSetButton.on("pointerdown", (pointer)=>{
            this.prevPageSetButtonClickHandler(pointer);
        }, this);
        this.add(this._prevPageSetButton, {
            key: `prev_page_set_button`,
            padding: {
                left: 0,
                top: 0,
                right: scene.applyScale(20),
                bottom: 0
            }
        });
    }
    addNextPageSetButton(scene) {
        this._nextPageSetButton = scene.add.bitmapText(0, 0, "cc_outline", `>>`, scene.applyScale(20), 0);
        this._nextPageSetButton.setInteractive({
            cursor: "pointer"
        });
        this._nextPageSetButton.on("pointerdown", (pointer)=>{
            this.nextPageSetButtonClickHandler(pointer);
        }, this);
        this.add(this._nextPageSetButton, {
            key: `next_page_set_button`,
            padding: {
                left: scene.applyScale(10),
                top: 0,
                right: 0,
                bottom: 0
            }
        });
    }
    prevButtonClickHandler(pointer) {
        if (this._currentPage === 1) return;
        this.disableButtons();
        this._currentPage = this._currentPage - 1;
        this.updateNumberedButtons();
        this.updatePageData();
    }
    nextButtonClickHandler(pointer) {
        if (this._currentPage === this._numPages) return;
        this.disableButtons();
        this._currentPage = this._currentPage + 1;
        this.updateNumberedButtons();
        this.updatePageData();
    }
    prevPageSetButtonClickHandler(pointer) {
        if (this._currentFirstPage === 1) return;
        this.disableButtons();
        const newFirstPage = this.getFirstPage(this._currentFirstPage - 1);
        this._currentPage = newFirstPage;
        this.updateNumberedButtons();
        this.updatePageData();
    }
    nextPageSetButtonClickHandler(pointer) {
        if (this._currentLastPage === this._numPages) return;
        this.disableButtons();
        const newFirstPage = this.getFirstPage(this._currentLastPage + 1);
        this._currentPage = newFirstPage;
        if (this._numPages - this._currentPage <= $0e0517e7570e87c7$var$maxPagesVisible) this._currentPage = this.getLastPage(this._currentLastPage + 1);
        this.updateNumberedButtons();
        this.updatePageData();
    }
    updatePageData() {
        this.scene.updatePage(this._currentPage);
    }
    updateButtonAlpha() {
        this._prevButton.setAlpha(this._currentPage === 1 ? 0.4 : 1);
        if (this._prevPageSetButton) this._prevPageSetButton.setAlpha(this._currentFirstPage === 1 ? 0.4 : 1);
        for(let i = this._currentFirstPage; i <= this._currentLastPage; i++){
            const pageIndex = i - this._currentFirstPage;
            if (this._currentPage === i) this._numberedButtons[pageIndex].setAlpha(1);
            else this._numberedButtons[pageIndex].setAlpha(0.4);
        }
        if (this._nextPageSetButton) this._nextPageSetButton.setAlpha(this._currentLastPage === this._numPages ? 0.4 : 1);
        this._nextButton.setAlpha(this._currentPage === this._numPages ? 0.4 : 1);
    }
    updateNumberedButtons() {
        // New page is within range of numbered buttons already displayed, just set alpha
        if (this._currentPage >= this._currentFirstPage && this._currentPage <= this._currentLastPage) {
            this.updateButtonAlpha();
            return;
        }
        // New page is outside of range of displayed numbered buttons, update numbered button set
        this.removeNextButton();
        this.removeNumberedButtons();
        this.removePrevButton();
        this.getAllChildren().forEach((child)=>this.remove(child, true));
        this._currentFirstPage = this.getFirstPage(this._currentPage);
        this._currentLastPage = this.getLastPage(this._currentPage);
        this.addPrevButton(this.scene);
        this.addNumberedButtons(this.scene);
        this.addNextButton(this.scene);
        this.updateButtonAlpha();
    }
    removeNextButton() {
        this._nextButton.setAlpha(0);
        this.remove(this._nextButton, true);
        this._nextButton = undefined;
    }
    removePrevButton() {
        this._prevButton.setAlpha(0);
        this.remove(this._prevButton, true);
        this._prevButton = undefined;
    }
    removeNumberedButtons() {
        var _a, _b;
        (_a = this._prevPageSetButton) === null || _a === void 0 || _a.setAlpha(0);
        this.remove(this._prevPageSetButton, true);
        this._prevPageSetButton = undefined;
        for(let i = this._currentFirstPage; i <= this._currentLastPage; i++){
            const pageIndex = i - this._currentFirstPage;
            this._numberedButtons[pageIndex].setAlpha(0);
            this.remove(this._numberedButtons[pageIndex], true);
            this._numberedButtons[pageIndex] = undefined;
        }
        this._numberedButtons = undefined;
        (_b = this._nextPageSetButton) === null || _b === void 0 || _b.setAlpha(0);
        this.remove(this._nextPageSetButton, true);
        this._nextPageSetButton = undefined;
    }
    getFirstPage(currentPage) {
        if (currentPage <= $0e0517e7570e87c7$var$maxPagesVisible) // Current page is in the first group
        return 1;
        else if (currentPage + $0e0517e7570e87c7$var$maxPagesVisible > this._numPages) // Current page is in the last group
        return this._numPages - $0e0517e7570e87c7$var$maxPagesVisible + 1;
        else // Current page is not in the first or last group
        return Math.floor(currentPage / 10) * $0e0517e7570e87c7$var$maxPagesVisible + 1;
    }
    getLastPage(currentPage) {
        if (currentPage <= $0e0517e7570e87c7$var$maxPagesVisible) // Current page is in the first group
        return this._numPages < $0e0517e7570e87c7$var$maxPagesVisible ? this._numPages : $0e0517e7570e87c7$var$maxPagesVisible;
        else if (currentPage + $0e0517e7570e87c7$var$maxPagesVisible > this._numPages) // Current page is in the last group
        return this._numPages;
        else // Current page is not in the first or last group
        return Math.ceil(currentPage / 10) * $0e0517e7570e87c7$var$maxPagesVisible;
    }
    enableButtons() {
        var _a, _b, _c, _d;
        (_a = this._nextButton) === null || _a === void 0 || _a.setInteractive({
            cursor: "pointer"
        });
        (_b = this._nextPageSetButton) === null || _b === void 0 || _b.setInteractive({
            cursor: "pointer"
        });
        (_c = this._prevButton) === null || _c === void 0 || _c.setInteractive({
            cursor: "pointer"
        });
        (_d = this._prevPageSetButton) === null || _d === void 0 || _d.setInteractive({
            cursor: "pointer"
        });
        this._numberedButtons.forEach((nb)=>nb.setInteractive({
                cursor: "pointer"
            }));
    }
    disableButtons() {
        var _a, _b, _c, _d;
        (_a = this._nextButton) === null || _a === void 0 || _a.disableInteractive();
        (_b = this._nextPageSetButton) === null || _b === void 0 || _b.disableInteractive();
        (_c = this._prevButton) === null || _c === void 0 || _c.disableInteractive();
        (_d = this._prevPageSetButton) === null || _d === void 0 || _d.disableInteractive();
        this._numberedButtons.forEach((nb)=>nb.disableInteractive());
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("paginationControls", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $0e0517e7570e87c7$export$2e2bcd8739ae039(this.scene, x, y, config));
});



class $e375e881905a228b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Sprite {
    constructor(scene, x, y, scale){
        super(scene, x, y, "party_blob");
        this._scale = scale || 1;
        return this.createIndicator(scene);
    }
    createIndicator(scene) {
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: scene.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        scene.anims.create(animationConfig);
        this.setOrigin(0.5, 0.5).setScale(this._scale).play("blob_animation");
        return scene.add.existing(this);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("loadingIndicator", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $e375e881905a228b$export$2e2bcd8739ae039(this.scene, x, y, config));
});


const $5b590270330d0968$var$noMember = {
    id: 0,
    nft_collection: "Star Wolvez Generative",
    display_name: "None Selected       ",
    image_key: "starwolf_silhouette",
    show_yield: false,
    show_hp: false,
    disabled: true
};
const $5b590270330d0968$var$paneHeight = 805;
const $5b590270330d0968$var$paneWidth = 566;
const $5b590270330d0968$var$pageSize = 30;
class $5b590270330d0968$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        const conf = config ? config : {
            width: $5b590270330d0968$var$paneWidth * paneScale,
            height: $5b590270330d0968$var$paneHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._selectedCollection = data.selectedCollection;
        this._squadData = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._availableCollections = (0, $a09da6b186fd2edf$export$2e2bcd8739ae039).getInstance().getCollections();
        this._currentPage = 1;
        this._nftData = this.filterNFTs(data.nfts);
        this._totalNftCount = data.totalNftCount;
        this._scale = paneScale;
        console.log("adding title");
        // Title
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Active Squad", this.applyScale(22), 0).setOrigin(0);
        this.add(this._title, {
            key: "title",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(27),
                bottom: 0
            }
        });
        this._squadMembers = this._squadData.map((sqMem)=>{
            sqMem.show_yield = sqMem.id === 0 ? false : false;
            sqMem.show_hp = sqMem.id === 0 ? false : true;
            sqMem.disabled = sqMem.id === 0 ? true : false;
            return sqMem;
        });
        this._inactiveMembers = this.getInactiveMembers();
        // Active Squad Components
        var squadMemberSizer = this.scene.rexUI.add.sizer({
            width: scene.applyScale(566)
        });
        this._squadMemberComponent1 = new (0, $af9bf77f128bbc45$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[0], this._scale, false);
        this._squadMemberComponent2 = new (0, $af9bf77f128bbc45$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[1], this._scale, false);
        this._squadMemberComponent3 = new (0, $af9bf77f128bbc45$export$2e2bcd8739ae039)(scene, 0, 0, this._squadMembers[2], this._scale, false);
        this._squadMemberComponent1.onClick().subscribe((pointer)=>{
            if (this._squadMembers[0].display_name === $5b590270330d0968$var$noMember.display_name) return;
            this.removeSquadMember(scene, 0, this._scale);
        });
        this._squadMemberComponent2.onClick().subscribe((pointer)=>{
            if (this._squadMembers[1].display_name === $5b590270330d0968$var$noMember.display_name) return;
            this.removeSquadMember(scene, 1, this._scale);
        });
        this._squadMemberComponent3.onClick().subscribe((pointer)=>{
            if (this._squadMembers[2].display_name === $5b590270330d0968$var$noMember.display_name) return;
            this.removeSquadMember(scene, 2, this._scale);
        });
        squadMemberSizer.add(scene.add.existing(this._squadMemberComponent1.layout()), {
            key: "sm_comp_1",
            padding: {
                left: scene.applyScale(0),
                right: 0,
                top: 0,
                bottom: 0
            }
        }).addSpace();
        squadMemberSizer.add(scene.add.existing(this._squadMemberComponent2.layout()), {
            key: "sm_comp_2",
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        }).addSpace();
        squadMemberSizer.add(scene.add.existing(this._squadMemberComponent3.layout()), {
            key: "sm_comp_3",
            padding: {
                left: 0,
                right: scene.applyScale(35),
                top: 0,
                bottom: 0
            }
        });
        this.add(squadMemberSizer, {
            key: "sm_sizer",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(12),
                bottom: 0
            }
        });
        // Divider
        const divider = scene.add.image(0, 0, "squad_divider_line").setScale(this._scale);
        this.add(divider, {
            key: "divider",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(8),
                bottom: 0
            }
        });
        // Substitutions Label
        var subsTitle = scene.add.bitmapText(0, 0, "cc_outline", "Your Available NFTs", this.applyScale(22), 0).setOrigin(0);
        this.add(subsTitle, {
            key: "subsTitle",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(22),
                bottom: 0
            }
        }).addNewLine();
        // Pagination Controls
        if (this._totalNftCount > $5b590270330d0968$var$pageSize) this.addPagingButtons(scene);
        // Inactive squad table
        this.createTable(scene, this._inactiveMembers, 0, 0, this._scale);
    }
    applyScale(length) {
        return length * this._scale;
    }
    createTable(scene, data, x, y, paneScale) {
        this._table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(531),
            height: this._totalNftCount > $5b590270330d0968$var$pageSize ? this.applyScale($5b590270330d0968$var$paneHeight - 359 - 30) : this.applyScale($5b590270330d0968$var$paneHeight - 359),
            items: data,
            table: {
                cellWidth: this.applyScale(177),
                cellHeight: this.applyScale(225),
                columns: 3,
                clamplTableOXY: false,
                reuseCellContainer: true,
                scrollMode: 0,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var sqComp = new (0, $af9bf77f128bbc45$export$2e2bcd8739ae039)(scene, x, y, item, scene.getScale());
                sqComp.onClick().subscribe((pointer)=>{
                    scene.addSquadMember(item);
                });
                return scene.add.existing(sqComp);
            }
        });
        this._table.setItems(data).scrollToTop();
        this._table.layout();
        this.add(this._table, {
            key: "inactive_members_table",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(12),
                bottom: 0
            }
        }).layout();
    }
    addPagingButtons(scene) {
        this._pagingControls = new (0, $0e0517e7570e87c7$export$2e2bcd8739ae039)(scene, 0, 0, {
            totalCount: this._totalNftCount,
            pageSize: $5b590270330d0968$var$pageSize
        }, 501, this._scale);
        this.add(this._pagingControls, {
            key: "paging_controls",
            padding: {
                left: scene.applyScale(15),
                right: 0,
                top: scene.applyScale(7),
                bottom: scene.applyScale(0)
            }
        });
    }
    addNoNftsLabel(scene) {
        this._noAvailableNftsLabel = scene.add.bitmapText(0, 0, "cc_outline", "You have none of this collection to assign to a squad.", this.applyScale(20), 0).setOrigin(0).setAlpha(0.4);
        this.add(this._noAvailableNftsLabel, {
            key: "no_nfts_label",
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(20),
                bottom: 0
            }
        }).layout();
    }
    addSquadMember(scene, item, scale) {
        if (this._squadMembers[0].display_name === $5b590270330d0968$var$noMember.display_name) {
            this._squadMembers[0] = Object.assign({}, item, {
                show_hp: true,
                show_yield: false
            });
            this.refreshSquadMembers(this._squadMemberComponent1, 0);
            return;
        }
        if (this._squadMembers[1].display_name === $5b590270330d0968$var$noMember.display_name) {
            this._squadMembers[1] = Object.assign({}, item, {
                show_hp: true,
                show_yield: false
            });
            this.refreshSquadMembers(this._squadMemberComponent2, 1);
            return;
        }
        if (this._squadMembers[2].display_name === $5b590270330d0968$var$noMember.display_name) {
            this._squadMembers[2] = Object.assign({}, item, {
                show_hp: true,
                show_yield: false
            });
            this.refreshSquadMembers(this._squadMemberComponent3, 2);
            return;
        }
    }
    removeSquadMember(scene, index, scale) {
        this._squadMembers[index] = Object.assign({}, $5b590270330d0968$var$noMember);
        this.refreshSquadMembers(this[`_squadMemberComponent${index + 1}`], index);
        return;
    }
    filterNFTs(data) {
        return data.filter((nft)=>this._availableCollections.flatMap((col)=>{
                return col.collectionSlugs;
            }).includes(nft.nft_slug));
    }
    sortByCollection(nftData) {
        return nftData.sort((a, b)=>{
            if (a.nft_collection === "Star Wolvez Genesis" || a.nft_collection === "Star Wolvez Generative") return -1;
            if (b.nft_collection === "Star Wolvez Genesis" || b.nft_collection === "Star Wolvez Generative") return 1;
            return 0;
        });
    }
    refreshSquadMembers(component, index, forceUpdate = false) {
        component.setSquadMemberData(this._squadMembers[index]);
        this.updateInactiveMembers();
    }
    updateInactiveMembers() {
        var _a;
        this._inactiveMembers = this.getInactiveMembers();
        (_a = this._table) === null || _a === void 0 || _a.setItems(this._inactiveMembers);
    }
    getInactiveMembers() {
        if (this._squadMembers) return this.sortByCollection(this._nftData).filter((nft)=>{
            return !this._squadMembers.map((sm)=>sm.id).includes(nft.id);
        }).filter((inactiveNft)=>{
            return this._selectedCollection.collectionSlugs.includes(inactiveNft.nft_slug);
        }).map((inSqMem)=>{
            inSqMem.show_hp = true;
            inSqMem.show_yield = false;
            inSqMem.disabled = this.checkSquadFull();
            return inSqMem;
        });
        else return this._nftData.sortByCollection(this._nftData).filter((inactiveNft)=>{
            return this._selectedCollection.collectionSlugs.includes(inactiveNft.nft_slug);
        }).map((inSqMem)=>{
            inSqMem.show_hp = true;
            inSqMem.show_yield = false;
            inSqMem.disabled = this.checkSquadFull();
            return inSqMem;
        });
    }
    fetchNftData(startIndex) {
        return (0, $57b0159e0c142865$export$2e2bcd8739ae039).getInstance().getNFTs(undefined, this._selectedCollection.collectionSlugs, startIndex, $5b590270330d0968$var$pageSize).then((res)=>{
            const nfts = res.nfts;
            const squadMemsNotInData = this._squadMembers.filter((sm)=>!nfts.map((nft)=>nft.id).includes(sm.id));
            this._nftData = squadMemsNotInData && squadMemsNotInData.length > 0 ? nfts.concat(squadMemsNotInData) : nfts;
            this._totalNftCount = res.max_count_returned;
            return this._nftData;
        });
    }
    updatePage(pageNum) {
        this._currentPage = pageNum;
        this.refreshPane(true);
    }
    setCollection(selectedCollection) {
        if (selectedCollection) {
            // Update collection and inactive members
            this._selectedCollection = selectedCollection;
            this._currentPage = 1;
            // Refresh Content Pane
            this.refreshPane();
        }
    }
    refreshPane(isPageUpdate) {
        const sqMemIds = this._squadMembers.map((sm)=>sm.marketplace_nft_id);
        const oldNfts = this._nftData.filter((nft)=>sqMemIds.includes(nft.marketplace_nft_id));
        // Remove Table
        this.removeTable();
        // Remove 'No NFTs label' if it exists
        this.removeNoNftsLabel();
        // Remove pagination controls if only 1 page of data
        if (!isPageUpdate) this.removePaginationButtons();
        // Add loading indicator
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this.scene, 0, 0, 0.8 * this._scale);
        this.add(this._loadingIndicator, {
            key: "loading_indicator",
            padding: {
                left: this.applyScale(200),
                top: this.applyScale(100),
                right: 0,
                bottom: 0
            }
        }).layout();
        this.fetchNftData((this._currentPage - 1) * $5b590270330d0968$var$pageSize).then(()=>{
            this._inactiveMembers = this.getInactiveMembers();
            // Load new nft images and remove old nft images
            this.scene.scene.launch("NftPageLoaderScene", {
                originating_scene: "SquadModalScene",
                nfts: this._inactiveMembers,
                old_nfts: oldNfts
            });
        });
    }
    onPageLoaded() {
        var _a;
        this._loadingIndicator.setAlpha(0);
        this.remove(this._loadingIndicator, true);
        this._loadingIndicator = undefined;
        (_a = this._pagingControls) === null || _a === void 0 || _a.enableButtons();
        if (!this._inactiveMembers || this._inactiveMembers.length === 0) {
            // Show 'No NFTs' label
            this.addNoNftsLabel(this.scene);
            return;
        }
        if (this._totalNftCount > $5b590270330d0968$var$pageSize && !this._pagingControls) this.addPagingButtons(this.scene);
        // Create Table
        this.createTable(this.scene, this._inactiveMembers, 0, 0, this._scale);
    }
    removeTable() {
        var _a;
        // Remove table if it exists
        (_a = this._table) === null || _a === void 0 || _a.setAlpha(0);
        this.remove(this._table, true);
        this._table = undefined;
    }
    removeNoNftsLabel() {
        if (this._noAvailableNftsLabel) {
            this._noAvailableNftsLabel.setAlpha(0);
            this.remove(this._noAvailableNftsLabel, true);
            this._noAvailableNftsLabel = undefined;
        }
    }
    removePaginationButtons() {
        if (this._pagingControls) {
            this._pagingControls.setAlpha(0);
            this.remove(this._pagingControls, true);
            this._pagingControls = undefined;
        }
    }
    checkSquadFull() {
        if (this._squadMembers[0].id === $5b590270330d0968$var$noMember.id || this._squadMembers[1].id === $5b590270330d0968$var$noMember.id || this._squadMembers[2].id === $5b590270330d0968$var$noMember.id) return false;
        return true;
    }
    setNftData(nftData) {
        if (nftData) this._nftData = nftData;
    }
    getCurrentSquad() {
        return this._squadMembers;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("squadContentPane", function(x, y, playersData) {
    // @ts-ignore
    return this.displayList.add(new $5b590270330d0968$export$2e2bcd8739ae039(this.scene, x, y, playersData));
});









const $90cf766f2895e404$var$modalHeight = 803;
const $90cf766f2895e404$var$modalWidth = 814;
const $90cf766f2895e404$var$modalRadius = 25;
const $90cf766f2895e404$var$modalColor = 0x1c1c2c;
const $90cf766f2895e404$var$modalAlpha = 1;
const $90cf766f2895e404$var$spineWidth = 248;
const $90cf766f2895e404$var$spineColor = 0xe6e6ff;
const $90cf766f2895e404$var$spineAlpha = 0.05;
class $90cf766f2895e404$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "SquadModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$3b37c5430056c4ff));
    }
    create() {
        this.createComponent();
        (0, $57b0159e0c142865$export$2e2bcd8739ae039).getInstance().getNFTs(undefined, undefined, 0, 30).then((res)=>{
            this._nfts = res.nfts;
            this._totalNftCount = res.max_count_returned;
            this.scene.launch("NftLoaderScene", {
                originating_scene: "SquadModalScene",
                nfts: res.nfts
            });
        });
    }
    createComponent() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($90cf766f2895e404$var$modalWidth, $90cf766f2895e404$var$modalHeight);
        this._collections = (0, $a09da6b186fd2edf$export$2e2bcd8739ae039).getInstance().getCollectionsWithAll();
        this._squad = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($90cf766f2895e404$var$modalWidth), this.applyScale($90cf766f2895e404$var$modalHeight), this.applyScale($90cf766f2895e404$var$modalRadius), $90cf766f2895e404$var$modalColor, $90cf766f2895e404$var$modalAlpha);
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($90cf766f2895e404$var$spineWidth), this.applyScale($90cf766f2895e404$var$modalHeight), {
            tl: this.applyScale($90cf766f2895e404$var$modalRadius),
            tr: 0,
            bl: this.applyScale($90cf766f2895e404$var$modalRadius),
            br: 0
        }, $90cf766f2895e404$var$spineColor, $90cf766f2895e404$var$spineAlpha);
        // Title text
        const titleText = this.add.image(0, 0, "squad_text").setOrigin(0).setScale(this._scale);
        // Add spine here
        this._spineTable = this.createSpineTable(this, this._collections, 0, 0).setOrigin(0.5, 0.5);
        this._confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "squad_confirm_button", true, 1.04).setScale(this._scale);
        this.add.existing(this._confirmButton);
        this._confirmButton.onClick().subscribe((pointer)=>{
            this.confirmButtonClickHandler(pointer);
        });
        this._selectedCollection = this._collections[0];
        this._sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.add(spineBackground, {
            key: "spineBackground",
            align: "center",
            offsetX: this.applyScale(-($90cf766f2895e404$var$modalWidth / 2 - $90cf766f2895e404$var$spineWidth / 2)),
            offsetY: 0,
            expand: false
        });
        this._sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(31),
            expand: false
        });
        this._sizer.add(this._spineTable, {
            key: "table",
            align: "left-top",
            offsetX: this.applyScale(15),
            offsetY: this.applyScale(60),
            expand: false
        });
        this._sizer.add(this._confirmButton, {
            key: "confirmButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center-top",
            offsetX: this.applyScale(100),
            offsetY: this.applyScale(300),
            expand: false
        });
        this._sizer.layout();
        this._sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
    }
    onLoaded() {
        this._loadingIndicator.setAlpha(0);
        this._sizer.remove(this._loadingIndicator);
        this._loadingIndicator = undefined;
        this._squadContentPane = new (0, $5b590270330d0968$export$2e2bcd8739ae039)(this, 0, 0, {
            nfts: this._nfts,
            totalNftCount: this._totalNftCount,
            selectedCollection: this._selectedCollection
        }, this._scale);
        this.add.existing(this._squadContentPane);
        this._sizer.add(this._squadContentPane, {
            key: "squad-content-pane",
            align: "left-top",
            offsetX: this.applyScale(262),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._sizer.layout();
        this.setIsSelected(this._selectedCollection);
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    updatePage(pageNum) {
        this._squadContentPane.updatePage(pageNum);
    }
    onPageLoaded() {
        this._squadContentPane.onPageLoaded();
    }
    addSquadMember(squadMember) {
        this._squadContentPane.addSquadMember(this, squadMember, this.getScale());
    }
    removeSquadMember(index) {
        this._squadContentPane.removeSquadMember(this, index, this.getScale());
    }
    destroy() {
        this._collections = undefined;
    }
    createSpineTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(220),
            height: this.applyScale(643),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(220),
                cellHeight: this.applyScale(32),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                interactive: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                // Template
                let rectConfig = {
                    maskType: "roundRectangle",
                    radius: 0
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(220),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).setInteractive({
                    useHandCursor: true
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(220), scene.applyScale(32), scene.applyScale(6), 0xe6e6ff, 0.05).setAlpha(item.isSelected ? 1 : 0), {
                    key: "menu_option_bg",
                    align: "center",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.displayName, scene.applyScale(16), 0).setAlpha(item.isSelected ? 1 : 0.4), {
                    key: "menu_option_text",
                    align: "left",
                    offsetX: scene.applyScale(10),
                    offsetY: 0,
                    expand: false
                });
                sizer.setChildrenInteractive({
                    click: {
                        mode: "release",
                        clickInterval: 100
                    },
                    over: true,
                    tap: {
                        time: 250,
                        tapInterval: 200,
                        threshold: 9,
                        tapOffset: 10,
                        taps: undefined,
                        minTaps: undefined,
                        maxTaps: undefined
                    },
                    press: {
                        time: 251,
                        threshold: 9
                    },
                    swipe: {
                        threshold: 10,
                        velocityThreshold: 1000,
                        dir: "8dir"
                    },
                    inputEventPrefix: "child."
                });
                sizer.on("child.over", (child, pointer, event)=>{
                    sizer.getElement("menu_option_text").setAlpha(1);
                });
                sizer.on("child.out", (child, pointer, event)=>{
                    if (!item.isSelected) sizer.getElement("menu_option_text").setAlpha(0.4);
                });
                sizer.on("child.click", (child, pointer, event)=>{
                    scene.setSelectedCollection(item);
                    scene.setIsSelected(item);
                });
                return sizer;
            }
        });
        table.setItems(data).scrollToTop();
        return table;
    }
    setIsSelected(item) {
        if (item.isSelected === true) return;
        this._collections = this._collections.map((collection)=>{
            collection.isSelected = collection.displayName === item.displayName ? true : false;
            return collection;
        });
        this._spineTable.setItems(this._collections);
        this._squadContentPane.setCollection(this._selectedCollection);
    }
    setSelectedCollection(selectedCollection) {
        if (selectedCollection) this._selectedCollection = selectedCollection;
    }
    confirmButtonClickHandler(pointer) {
        const currentSquad = this._squadContentPane.getCurrentSquad();
        const currentSquadIds = currentSquad.slice(0, 3).filter((member)=>member.id !== 0).map((nft)=>{
            return {
                nft_id: nft.id
            };
        });
        (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().saveSquad({
            squad: currentSquadIds
        }).then((res)=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene", {
                squadUpdated: true
            });
            this.scene.stop();
        });
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$3b37c5430056c4ff)));
        //Don't unload squad images, unload all others
        const squadImages = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync().map((sm)=>sm.marketplace_nft_id);
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, this._nfts.filter((nf)=>!squadImages.includes(nf.marketplace_nft_id)).map((nft)=>nft.image_key));
    }
}











const $2f4abd45cd58d712$var$resourceRefillItems = [
    {
        key: "common_ng_refill",
        name: "Common Neon Gold Refill",
        shopImageKey: "shop_common_ng_refill_image",
        description: "Refills your neon gold to 25% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 1,
        refillPercentage: 25,
        count: 1
    },
    {
        key: "rare_ng_refill",
        name: "Rare Neon Gold Refill",
        shopImageKey: "shop_rare_ng_refill_image",
        description: "Refills your neon gold to 50% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 1,
        refillPercentage: 50,
        count: 1
    },
    {
        key: "epic_ng_refill",
        name: "Epic Neon Gold Refill",
        shopImageKey: "shop_epic_ng_refill_image",
        description: "Refills your neon gold to 100% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 1,
        refillPercentage: 100,
        count: 1
    },
    {
        key: "common_se_refill",
        name: "Common Space Elixir Refill",
        shopImageKey: "shop_common_se_refill_image",
        description: "Refills your space elixir to 25% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 2,
        refillPercentage: 25,
        count: 1
    },
    {
        key: "rare_se_refill",
        name: "Rare Space Elixir Refill",
        shopImageKey: "shop_rare_se_refill_image",
        description: "Refills your space elixir to 50% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 2,
        refillPercentage: 50,
        count: 1
    },
    {
        key: "epic_se_refill",
        name: "Epic Space Elixir Refill",
        shopImageKey: "shop_epic_se_refill_image",
        description: "Refills your space elixir to 100% of your storage capacity.",
        category: "resource_packs",
        type: "refill",
        currency_id: 3,
        refillCurrencyId: 2,
        refillPercentage: 100,
        count: 1
    }
];
class $2f4abd45cd58d712$var$ShopService {
    constructor(){
        if ($2f4abd45cd58d712$var$ShopService._instance) throw new Error("Error: Instantiation failed: Use ShopService.getInstance() instead of new.");
        $2f4abd45cd58d712$var$ShopService._instance = this;
    }
    static getInstance() {
        return $2f4abd45cd58d712$var$ShopService._instance;
    }
    setShopItems(value) {
        this._shopItems = value;
    }
    getShopItems(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._shopItems && !forceUpdate) return resolve(this._shopItems);
            else return resolve(this.fetchShopItems());
        });
    }
    getShopItemsSync() {
        return this._shopItems;
    }
    fetchShopItems() {
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("shop", [
            "available"
        ], []).then((res)=>{
            this._shopItems = res.items.filter((item)=>{
                return item.key !== "liminal_wl";
            });
            return res.items;
        });
    }
    getRewardBoxes(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._rewardBoxes && !forceUpdate) return resolve(this._rewardBoxes);
            else return resolve(this.fetchRewardBoxes());
        });
    }
    getRewardBoxesSync() {
        return this._rewardBoxes;
    }
    fetchRewardBoxes() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("rewards", [
            "boxes",
            wallet
        ], []).then((res)=>{
            this._rewardBoxes = res.chests;
            return res.chests;
        });
    }
    purchaseWL(shop_item_id, walletAddress) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("shop", [
            "purchase",
            wallet,
            "whitelist",
            shop_item_id
        ], {
            preferred_user_address: walletAddress
        }).then((res)=>{
            return res;
        });
    }
    purchaseOther(shop_item_id, postBody = {}) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("shop", [
            "purchase",
            wallet,
            "other",
            shop_item_id
        ], postBody).then((res)=>{
            return res;
        });
    }
    purchaseRewardBox(reward_type_id) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("rewards", [
            "boxes",
            wallet,
            reward_type_id
        ], {}).then((res)=>{
            return res;
        });
    }
    getResourceRefillItems() {
        return $2f4abd45cd58d712$var$resourceRefillItems;
    }
    getRefillCost(currency_id, refillPercentage) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("resources", [
            "refill",
            wallet,
            currency_id,
            refillPercentage
        ], []).then((res)=>{
            console.log(`RefillCost: ${res}`);
            return res;
        });
    }
    purchaseResourceRefill(currency_id, refillPercentage) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("resources", [
            "refill",
            wallet,
            currency_id,
            refillPercentage
        ], {}).then((res)=>{
            console.log(`RefillPurchaseResponse: ${res}`);
            return res;
        });
    }
}
$2f4abd45cd58d712$var$ShopService._instance = new $2f4abd45cd58d712$var$ShopService();
var $2f4abd45cd58d712$export$2e2bcd8739ae039 = $2f4abd45cd58d712$var$ShopService;







const $48dab68dbeb53787$var$costContainerHeight = 29;
const $48dab68dbeb53787$var$costContainerWidth = 213;
const $48dab68dbeb53787$var$costContainerRadius = 10;
const $48dab68dbeb53787$var$costContainerColor = 0x000000;
const $48dab68dbeb53787$var$costContainerAlpha = 0.4;
const $48dab68dbeb53787$var$costContainerBorderColor = 0x383d57;
const $48dab68dbeb53787$var$costContainerBorderWidth = 2;
const $48dab68dbeb53787$var$costGlareHeight = 6;
const $48dab68dbeb53787$var$costGlareWidth = 203;
const $48dab68dbeb53787$var$costGlareRadius = 3;
const $48dab68dbeb53787$var$costGlareColor = 0xffffff;
const $48dab68dbeb53787$var$costGlareAlpha = 0.17;
class $48dab68dbeb53787$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, currency, text, barWidth, config){
        let conf = config ? config : {
            x: x,
            y: y,
            width: barWidth * paneScale,
            height: $48dab68dbeb53787$var$costContainerHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._currency = currency;
        this._text = text;
        this._width = barWidth;
        this.createCostLabel(scene, x, y);
    }
    createCostLabel(scene, x, y) {
        this.add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(this._width), scene.applyScale($48dab68dbeb53787$var$costContainerHeight), scene.applyScale($48dab68dbeb53787$var$costContainerRadius), $48dab68dbeb53787$var$costContainerColor, $48dab68dbeb53787$var$costContainerAlpha).setStrokeStyle($48dab68dbeb53787$var$costContainerBorderWidth, $48dab68dbeb53787$var$costContainerBorderColor, $48dab68dbeb53787$var$costContainerAlpha), {
            key: "cost_container",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(this._width - 10), scene.applyScale($48dab68dbeb53787$var$costGlareHeight), scene.applyScale($48dab68dbeb53787$var$costGlareRadius), $48dab68dbeb53787$var$costGlareColor, $48dab68dbeb53787$var$costGlareAlpha), {
            key: "cost_glare",
            align: "center-top",
            offsetX: 0,
            offsetY: scene.applyScale(6),
            expand: false
        });
        this._label = scene.rexUI.add.label({
            x: 0,
            y: 0,
            width: scene.applyScale(this._width - 10),
            height: scene.applyScale(27),
            orientation: "x",
            rtl: false,
            icon: this._currency ? scene.add.image(0, 0, `${this._currency}_icon`).setScale(scene.applyScale(0.4)) : undefined,
            text: scene.add.bitmapText(0, 0, "cc_outline", this._text.toLocaleString("en-us"), scene.applyScale(16), 0),
            space: {
                top: 1,
                icon: 6
            },
            align: "center"
        });
        this.add(this._label, {
            key: "cost_text",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).layout();
    }
    updateLabelText(newText) {
        this._label.setText(newText);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("costLabel", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $48dab68dbeb53787$export$2e2bcd8739ae039(this.scene, x, y, config));
});


const $8f01efa490409a40$var$componentWidth = 250;
const $8f01efa490409a40$var$componentHeight = 357;
const $8f01efa490409a40$var$componentRadius = 16;
const $8f01efa490409a40$var$componentBorderWidth = 2;
const $8f01efa490409a40$var$componentBorderColor = 0x382b42;
const $8f01efa490409a40$var$componentBorderAlpha = 1;
const $8f01efa490409a40$var$componentBorderOverColor = 0x544163;
class $8f01efa490409a40$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, isButton, costText, config){
        var _a, _b;
        let conf = config ? config : {
            width: paneScale * $8f01efa490409a40$var$componentWidth,
            height: paneScale * $8f01efa490409a40$var$componentHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._item = data;
        this._isButton = isButton === undefined ? true : isButton;
        this._costText = costText ? costText : ((_b = (_a = this._item) === null || _a === void 0 ? void 0 : _a.cost) === null || _b === void 0 ? void 0 : _b.toLocaleString("en-us")) || "N/A";
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Item Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: $8f01efa490409a40$var$componentRadius
        };
        if (this._isButton) {
            this._itemImage = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, `shop_${this._item.key}_image`, rectConfig, false).setScale(scene.getScale());
            scene.add.existing(this._itemImage);
            this._itemImage.onClick().subscribe((pointer)=>{
                if (pointer.getDistance() > 20) return;
                scene.scene.pause("ShopModalScene");
                scene.scene.launch("ShopItemInfoScene", {
                    item: this._item,
                    type: "shop_item",
                    scale: this._scale
                });
            });
            this.add(this._itemImage, {
                key: "item_image",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
        } else {
            this._itemImage = scene.add.rexCircleMaskImage(0, 0, `shop_${this._item.key}_image`, "", rectConfig).setScale(scene.getScale());
            this.add(this._itemImage, {
                key: "item_image",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
        }
        // Item Border
        this._itemBorder = scene.add.rexRoundRectangle(0, 0, scene.applyScale($8f01efa490409a40$var$componentWidth), scene.applyScale($8f01efa490409a40$var$componentHeight), scene.applyScale($8f01efa490409a40$var$componentRadius), 0x000000, 0).setStrokeStyle(scene.applyScale($8f01efa490409a40$var$componentBorderWidth), $8f01efa490409a40$var$componentBorderColor, $8f01efa490409a40$var$componentBorderAlpha);
        if (this._isButton) this._itemBorder.setInteractive().on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this._itemBorder.setStrokeStyle(scene.applyScale($8f01efa490409a40$var$componentBorderWidth), $8f01efa490409a40$var$componentBorderOverColor, $8f01efa490409a40$var$componentBorderAlpha);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, ()=>{
            this._itemBorder.setStrokeStyle(scene.applyScale($8f01efa490409a40$var$componentBorderWidth), $8f01efa490409a40$var$componentBorderColor, $8f01efa490409a40$var$componentBorderAlpha);
        });
        this.add(this._itemBorder, {
            key: "item_border",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        if (this._isButton) {
            // Item Label
            this._itemLabel = scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), this.applyScale(22), 0).setMaxWidth(this.applyScale($8f01efa490409a40$var$componentWidth - 70)).setOrigin(0, 0.5);
            this.add(this._itemLabel, {
                key: `item-label`,
                align: "left-top",
                offsetX: scene.applyScale(21),
                offsetY: scene.applyScale(19),
                expand: false
            });
            // Info Circle
            this._infoCircle = scene.add.image(0, 0, "shop_item_info_button").setScale(scene.getScale());
            this.add(this._infoCircle, {
                key: `info-circle`,
                align: "right-top",
                offsetX: scene.applyScale(-18),
                offsetY: scene.applyScale(12),
                expand: false
            });
            this._infoLetter = scene.add.image(0, 0, "shop_item_info_letter").setScale(scene.getScale());
            this.add(this._infoLetter, {
                key: `info-letter`,
                align: "right-top",
                offsetX: scene.applyScale(-28),
                offsetY: scene.applyScale(19),
                expand: false
            });
        }
        // Cost Label
        this._costLabel = new (0, $48dab68dbeb53787$export$2e2bcd8739ae039)(scene, x, y, scene.getScale(), this.getCurrency(), this._costText, 213);
        scene.add.existing(this._costLabel);
        this.add(this._costLabel, {
            key: `cost_label`,
            align: "center-bottom",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(-15),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getDisplayName() {
        if (this._item.type === "whitelist") return this._item.name.slice(-2) === "WL" ? this._item.name : `${this._item.name} WL`;
        else return this._item.name;
    }
    getCurrency() {
        switch(this._item.currency_id){
            case 1:
                return "space_elixir";
            case 2:
                return "neon_gold";
            case 4:
                return "dark_matter";
            default:
                return "stardust";
        }
    }
    updateLabelText(newText) {
        this._costLabel.updateLabelText(newText);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("shopItemComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $8f01efa490409a40$export$2e2bcd8739ae039(this.scene, x, y, data));
});


const $a5183a1ff59d6d84$var$modalWidth = 1008;
const $a5183a1ff59d6d84$var$shopItemHeight = 361;
const $a5183a1ff59d6d84$var$shopItemWidth = 250;
const $a5183a1ff59d6d84$var$cellHeight = $a5183a1ff59d6d84$var$shopItemHeight;
const $a5183a1ff59d6d84$var$cellWidth = $a5183a1ff59d6d84$var$shopItemWidth + 20;
const $a5183a1ff59d6d84$var$tabs = [
    {
        key: "all",
        image_key: "shop_all_button"
    },
    {
        key: "special_items",
        image_key: "shop_special_items_button"
    },
    {
        key: "nfts",
        image_key: "shop_nfts_button"
    }
];
class $a5183a1ff59d6d84$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        let conf = config ? config : {
            width: $a5183a1ff59d6d84$var$modalWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        // Basic Item Data
        this._itemsData = (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getShopItemsSync();
        // Reward Box Data
        this._rewardBoxData = (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getRewardBoxesSync().map((box)=>{
            //box.type = 'other';
            switch(box.key){
                case "common_resource_box":
                    box.name = "Common Daily Resource Box";
                    break;
                case "epic_resource_box":
                    box.name = "Epic Daily Resource Box";
                    break;
                case "legendary_resource_box":
                    box.name = "Legendary Daily Resource Box";
                    break;
            }
            return box;
        });
        this._itemsData = this._itemsData.concat(this._rewardBoxData);
        // Buttons Sizer
        this._buttonSizer = this.scene.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($a5183a1ff59d6d84$var$modalWidth - 70),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Buttons
        $a5183a1ff59d6d84$var$tabs.forEach((item)=>{
            const tabButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, item.key === "all" ? item.image_key : `${item.image_key}_inactive`, false).setScale(this._scale);
            tabButton.onClick().subscribe((pointer)=>{
                this.handleFilterClick(item.key);
            });
            this._buttonSizer.add(this.scene.add.existing(tabButton), {
                padding: {
                    left: 0,
                    right: this.applyScale(15),
                    top: 0,
                    bottom: 0
                },
                key: `item_shop_${item.key}_button`
            });
        });
        this.add(this._buttonSizer, {
            key: "button_sizer",
            align: "left-top",
            offsetX: this.applyScale(35),
            offsetY: this.applyScale(35),
            expand: false
        });
        // Table
        this.addTable(scene, this._itemsData);
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
        this._buttonSizer.setAlpha(0);
    }
    addTable(scene, data) {
        if (data) {
            // Table
            this._table = this.createTable(scene, data, 0, 0).layout();
            this.add(this._table, {
                key: "item_shop_table",
                align: "left-top",
                offsetX: this.applyScale(4),
                offsetY: this.applyScale(110),
                expand: false
            });
        }
    }
    handleFilterClick(selectedFilter) {
        if (selectedFilter === this._selectedFilter) return;
        this.updateFilterButtons(selectedFilter);
        if (selectedFilter === "all") this._filteredData = this._itemsData;
        else this._filteredData = this._itemsData.filter((item)=>{
            return item.category === selectedFilter;
        });
        this.remove(this._table, true);
        if (this._filteredData.length > 0) {
            this.addTable(this.scene, this._filteredData);
            this.layout();
        }
        this._selectedFilter = selectedFilter;
    }
    updateFilterButtons(selectedFilter) {
        $a5183a1ff59d6d84$var$tabs.forEach((tab)=>{
            var button = this._buttonSizer.getElement(`item_shop_${tab.key}_button`);
            if (button) button.setTexture(selectedFilter === tab.key ? tab.image_key : `${tab.image_key}_inactive`);
        });
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($a5183a1ff59d6d84$var$cellWidth * data.length > $a5183a1ff59d6d84$var$modalWidth ? $a5183a1ff59d6d84$var$modalWidth - 8 : $a5183a1ff59d6d84$var$cellWidth * data.length - 1),
            height: this.applyScale($a5183a1ff59d6d84$var$cellHeight),
            items: data,
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale($a5183a1ff59d6d84$var$cellWidth),
                cellHeight: this.applyScale($a5183a1ff59d6d84$var$cellHeight),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.4
            },
            space: {
                table: {
                    left: this.applyScale(23),
                    right: 0
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, item.image_key);
                var imageWidth = imageData.width;
                var shopItemComponent = new (0, $8f01efa490409a40$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale(), true, undefined);
                scene.add.existing(shopItemComponent);
                return shopItemComponent;
            }
        }).setOrigin(0, 0.5);
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("itemShopContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $a5183a1ff59d6d84$export$2e2bcd8739ae039(this.scene, x, y));
});










const $0f6d56d1311b06e9$var$componentWidth = 250;
const $0f6d56d1311b06e9$var$componentHeight = 361;
const $0f6d56d1311b06e9$var$componentRadius = 16;
const $0f6d56d1311b06e9$var$componentColor = 0x262637;
const $0f6d56d1311b06e9$var$componentAlpha = 1;
const $0f6d56d1311b06e9$var$componentBorderWidth = 2;
const $0f6d56d1311b06e9$var$componentBorderColor = 0x382b42;
const $0f6d56d1311b06e9$var$componentBorderAlpha = 1;
const $0f6d56d1311b06e9$var$componentBorderOverColor = 0x544163;
class $0f6d56d1311b06e9$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, isButton, config){
        let conf = config ? config : {
            width: paneScale * $0f6d56d1311b06e9$var$componentWidth,
            height: paneScale * $0f6d56d1311b06e9$var$componentHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._machine = data;
        this._isButton = isButton === undefined ? true : isButton;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Return blank if no item
        if (!data.key) {
            // Item Border
            this._itemBorder = scene.add.rexRoundRectangle(0, 0, scene.applyScale($0f6d56d1311b06e9$var$componentWidth), scene.applyScale($0f6d56d1311b06e9$var$componentHeight), scene.applyScale($0f6d56d1311b06e9$var$componentRadius), 0x000000, 0);
            this.add(this._itemBorder, {
                key: "machine_border",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
            return this.layout();
        }
        // Machine Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: $0f6d56d1311b06e9$var$componentRadius
        };
        if (this._isButton) {
            this._machineImage = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, this._machine.shopImageKey, rectConfig, false).setScale(scene.getScale());
            scene.add.existing(this._machineImage);
            this._machineImage.onClick().subscribe((pointer)=>{
                if (pointer.getDistance() > 20) return;
                scene.scene.pause("ShopModalScene");
                scene.scene.launch("MachineInfoModalScene", {
                    userMachine: this._machine
                });
            });
            if (this._machine.numberAvailable === 0) this._machineImage.disableInteractive();
            this.add(this._machineImage, {
                key: "machine_image",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
        } else {
            this._machineImage = scene.add.rexCircleMaskImage(0, 0, this._machine.shopImageKey, "", rectConfig).setScale(scene.getScale());
            this.add(this._machineImage, {
                key: "machine_image",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
        }
        // Item Border
        this._itemBorder = scene.add.rexRoundRectangle(0, 0, scene.applyScale($0f6d56d1311b06e9$var$componentWidth), scene.applyScale($0f6d56d1311b06e9$var$componentHeight), scene.applyScale($0f6d56d1311b06e9$var$componentRadius), 0x000000, 0).setStrokeStyle(scene.applyScale($0f6d56d1311b06e9$var$componentBorderWidth), $0f6d56d1311b06e9$var$componentBorderColor, $0f6d56d1311b06e9$var$componentBorderAlpha);
        if (this._isButton && this._machine.numberAvailable > 0) this._itemBorder.setInteractive().on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this._itemBorder.setStrokeStyle(scene.applyScale($0f6d56d1311b06e9$var$componentBorderWidth), $0f6d56d1311b06e9$var$componentBorderOverColor, $0f6d56d1311b06e9$var$componentBorderAlpha);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, ()=>{
            this._itemBorder.setStrokeStyle(scene.applyScale($0f6d56d1311b06e9$var$componentBorderWidth), $0f6d56d1311b06e9$var$componentBorderColor, $0f6d56d1311b06e9$var$componentBorderAlpha);
        });
        this.add(this._itemBorder, {
            key: "machine_border",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        if (this._isButton) {
            // Machine Label
            this._machineLabel = scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), this.applyScale(22), 0).setOrigin(0, 0.5).setMaxWidth(scene.applyScale(175));
            this.add(this._machineLabel, {
                key: `machine-label`,
                align: "left-top",
                offsetX: scene.applyScale(21),
                offsetY: scene.applyScale(19),
                expand: false
            });
            // Info Circle
            this._infoCircle = scene.add.image(0, 0, "shop_item_info_button");
            this.add(this._infoCircle, {
                key: `info-circle`,
                align: "right-top",
                offsetX: scene.applyScale(-18),
                offsetY: scene.applyScale(12),
                expand: false
            });
            this._infoLetter = scene.add.image(0, 0, "shop_item_info_letter");
            this.add(this._infoLetter, {
                key: `info-letter`,
                align: "right-top",
                offsetX: scene.applyScale(-28),
                offsetY: scene.applyScale(19),
                expand: false
            });
        }
        const currency = this._machine.cost_stardust > 0 ? "stardust" : this._machine.cost_neon_gold > 0 ? "neon_gold" : "space_elixir";
        // Cost Label
        this._costLabel = new (0, $48dab68dbeb53787$export$2e2bcd8739ae039)(scene, x, y, scene.getScale(), currency, this._machine[`cost_${currency}`] || "N/A", 146);
        scene.add.existing(this._costLabel);
        this.add(this._costLabel, {
            key: `cost_label`,
            align: "left-bottom",
            offsetX: scene.applyScale(19),
            offsetY: scene.applyScale(-15),
            expand: false
        });
        // Count Label
        this._countLabel = new (0, $48dab68dbeb53787$export$2e2bcd8739ae039)(scene, x, y, scene.getScale(), undefined, this.getCountText(), 61);
        scene.add.existing(this._countLabel);
        this.add(this._countLabel, {
            key: `count_label`,
            align: "right-bottom",
            offsetX: scene.applyScale(-19),
            offsetY: scene.applyScale(-15),
            expand: false
        });
        if (this._machine.numberAvailable === 0 && this._isButton) {
            this.setAlpha(0.5);
            this.disableInteractive();
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getDisplayName() {
        if (this._machine.display_name) switch(this._machine.display_name){
            case "Space Elixir Mine":
                return "Space Elixir\nMine";
            case "Neon Gold Storage":
                return "Neon Gold\nStorage";
            case "Space Elixir Storage":
                return "Space Elixir\nStorage";
            default:
                return this._machine.display_name;
        }
        return this._machine.display_name;
    }
    getCountText() {
        return `${this._machine.numberAvailable < 0 ? 0 : this._machine.numberAvailable}/${this._machine.maxNumber}`;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("shopMachineComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $0f6d56d1311b06e9$export$2e2bcd8739ae039(this.scene, x, y, data));
});


const $23d732e8920d7f60$var$modalWidth = 1008;
const $23d732e8920d7f60$var$modalHeight = 513;
const $23d732e8920d7f60$var$shopItemHeight = 361;
const $23d732e8920d7f60$var$shopItemWidth = 273;
const $23d732e8920d7f60$var$cellHeight = $23d732e8920d7f60$var$shopItemHeight;
const $23d732e8920d7f60$var$cellWidth = $23d732e8920d7f60$var$shopItemWidth;
const $23d732e8920d7f60$var$filterKeys = {
    all: 0,
    administrative: 1,
    resources: 2,
    cosmetics: 3,
    research: 4,
    holderExclusive: 5,
    army: 6
};
const $23d732e8920d7f60$var$allButtonImageKey = "shop_all_button";
const $23d732e8920d7f60$var$administrativeButtonImageKey = "shop_administrative_button";
const $23d732e8920d7f60$var$researchButtonImageKey = "shop_research_button";
const $23d732e8920d7f60$var$resourcesButtonImageKey = "shop_resources_button";
const $23d732e8920d7f60$var$cosmeticsButtonImageKey = "shop_cosmetics_button";
const $23d732e8920d7f60$var$armyButtonImageKey = "shop_army_button";
const $23d732e8920d7f60$var$holderExclusiveButtonImageKey = "shop_holder_exclusive_button";
const $23d732e8920d7f60$var$disabledButtonAlpha = 0.4;
const $23d732e8920d7f60$var$doublePointMachineKeys = [
    "neon_gold_mine",
    "neon_gold_storage",
    "space_elixir_mine",
    "space_elixir_storage"
];
class $23d732e8920d7f60$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        let conf = config ? config : {
            width: $23d732e8920d7f60$var$modalWidth * paneScale,
            height: $23d732e8920d7f60$var$modalHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._machinesData = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getAvailableMachinesSync();
        this._selectedFilter = $23d732e8920d7f60$var$filterKeys.all;
        this.enrichMachinesData();
        this.sortMachinesData();
        // Buttons Sizer
        var buttonSizer = this.scene.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($23d732e8920d7f60$var$modalWidth - 70),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Buttons
        this._allButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, $23d732e8920d7f60$var$allButtonImageKey, false).setScale(this._scale);
        this._allButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.all);
        });
        buttonSizer.add(this.scene.add.existing(this._allButton), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_all_button"
        });
        this._administrativeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$administrativeButtonImageKey}_inactive`, false).setScale(this._scale);
        this._administrativeButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.administrative);
        });
        buttonSizer.add(this.scene.add.existing(this._administrativeButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_administrative_button"
        });
        this._researchButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$researchButtonImageKey}_inactive`, false).setScale(this._scale);
        this._researchButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.research);
        });
        buttonSizer.add(this.scene.add.existing(this._researchButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_research_button"
        });
        this._resourcesButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$resourcesButtonImageKey}_inactive`, false).setScale(this._scale);
        this._resourcesButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.resources);
        });
        buttonSizer.add(this.scene.add.existing(this._resourcesButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_resources_button"
        });
        this._cosmeticsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$cosmeticsButtonImageKey}_inactive`, false).setScale(this._scale);
        this._cosmeticsButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.cosmetics);
        });
        buttonSizer.add(this.scene.add.existing(this._cosmeticsButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_cosmetics_button"
        });
        this._armyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$armyButtonImageKey}_inactive`, false).setScale(this._scale);
        this._armyButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.army);
        });
        buttonSizer.add(this.scene.add.existing(this._armyButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_army_button"
        });
        this._holderExclusiveButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${$23d732e8920d7f60$var$holderExclusiveButtonImageKey}_inactive`, false).setScale(this._scale);
        this._holderExclusiveButton.onClick().subscribe((pointer)=>{
            this.handleFilterClick($23d732e8920d7f60$var$filterKeys.holderExclusive);
        });
        buttonSizer.add(this.scene.add.existing(this._holderExclusiveButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "machines_holder_exclusive_button"
        });
        this.add(buttonSizer, {
            key: "button_sizer",
            align: "left-top",
            offsetX: this.applyScale(35),
            offsetY: this.applyScale(35),
            expand: false
        });
        // Table
        this.addTable(scene, this._machinesData);
        this.layout();
    //this._table.drawBounds(scene.add.graphics(), 0x00ff00);
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
        this._allButton.setAlpha(0);
        this._administrativeButton.setAlpha(0);
        this._researchButton.setAlpha(0);
        this._resourcesButton.setAlpha(0);
        this._armyButton.setAlpha(0);
        this._holderExclusiveButton.setAlpha(0);
    //this.table.disableInteractive();
    }
    addTable(scene, data) {
        // Table
        this._table = this.createTable(scene, data, 0, 0).layout();
        this.add(this._table, {
            key: "machines_table",
            align: "left-top",
            offsetX: this.applyScale(4),
            offsetY: this.applyScale(110),
            expand: false
        });
    }
    handleFilterClick(selectedFilter) {
        if (selectedFilter === this._selectedFilter) return;
        this.updateFilterButtons(selectedFilter);
        if (selectedFilter === $23d732e8920d7f60$var$filterKeys.all) this._filteredData = this._machinesData;
        else this._filteredData = this._machinesData.filter((machine)=>{
            return machine.machine_type_id === selectedFilter;
        });
        this.remove(this._table, true);
        if (this._filteredData.length > 0) {
            this.addTable(this.scene, this._filteredData);
            this.layout();
        }
        this._selectedFilter = selectedFilter;
    }
    updateFilterButtons(selectedFilter) {
        this._allButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.all ? $23d732e8920d7f60$var$allButtonImageKey : `${$23d732e8920d7f60$var$allButtonImageKey}_inactive`);
        this._administrativeButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.administrative ? $23d732e8920d7f60$var$administrativeButtonImageKey : `${$23d732e8920d7f60$var$administrativeButtonImageKey}_inactive`);
        this._researchButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.research ? $23d732e8920d7f60$var$researchButtonImageKey : `${$23d732e8920d7f60$var$researchButtonImageKey}_inactive`);
        this._resourcesButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.resources ? $23d732e8920d7f60$var$resourcesButtonImageKey : `${$23d732e8920d7f60$var$resourcesButtonImageKey}_inactive`);
        this._cosmeticsButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.cosmetics ? $23d732e8920d7f60$var$cosmeticsButtonImageKey : `${$23d732e8920d7f60$var$cosmeticsButtonImageKey}_inactive`);
        this._armyButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.army ? $23d732e8920d7f60$var$armyButtonImageKey : `${$23d732e8920d7f60$var$armyButtonImageKey}_inactive`);
        this._holderExclusiveButton.setTexture(selectedFilter === $23d732e8920d7f60$var$filterKeys.holderExclusive ? $23d732e8920d7f60$var$holderExclusiveButtonImageKey : `${$23d732e8920d7f60$var$holderExclusiveButtonImageKey}_inactive`);
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($23d732e8920d7f60$var$cellWidth * data.length > $23d732e8920d7f60$var$modalWidth - 8 ? $23d732e8920d7f60$var$modalWidth - 8 : $23d732e8920d7f60$var$cellWidth * data.length - 1),
            height: this.applyScale($23d732e8920d7f60$var$cellHeight),
            items: data,
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale($23d732e8920d7f60$var$cellWidth),
                cellHeight: this.applyScale($23d732e8920d7f60$var$cellHeight),
                columns: 1,
                clamplTableOXY: false,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.4
            },
            space: {
                table: {
                    left: this.applyScale(23),
                    right: 0
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var machineComponent = new (0, $0f6d56d1311b06e9$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale());
                scene.add.existing(machineComponent);
                return machineComponent;
            }
        }).setOrigin(0, 0.5);
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    enrichMachinesData() {
        var tempData = this._machinesData.map((mach)=>{
            return Object.assign({}, mach, {
                numberAvailable: this.getNumberOfMachinesAvailable(mach),
                maxNumber: this.getMaxNumberOfMachines(mach)
            });
        });
        this._machinesData = tempData;
    }
    getNumberOfMachinesAvailable(shopMachine) {
        var max = this.getMaxNumberOfMachines(shopMachine);
        var totalUserMachines = 0;
        (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync().filter((machine)=>machine.key === shopMachine.key).forEach((mach)=>{
            if (mach.level > 10 && $23d732e8920d7f60$var$doublePointMachineKeys.includes(mach.key)) totalUserMachines += 2;
            else totalUserMachines++;
        });
        return max - totalUserMachines < 0 ? 0 : max - totalUserMachines;
    }
    getMaxNumberOfMachines(shopMachine) {
        var max = shopMachine.max_allowed_from_mf_level;
        return max && max > 0 ? max : 1;
    }
    sortMachinesData() {
        this._machinesData.sort((a, b)=>{
            if (!a.key) return -1;
            if (!b.key) return 1;
            if (a.numberAvailable > 0 && b.numberAvailable === 0) return -1;
            if (a.numberAvailable > 0 && b.numberAvailable > 0) return 1;
            if (a.numberAvailable === 0 && b.numberAvailable === 0) return 1;
            if (a.numberAvailable === 0 && b.numberAvailable > 0) return 1;
            return 1;
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("machinesContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $23d732e8920d7f60$export$2e2bcd8739ae039(this.scene, x, y));
});









const $80e0d3e4e1f8a6d0$var$modalWidth = 1008;
const $80e0d3e4e1f8a6d0$var$shopItemHeight = 361;
const $80e0d3e4e1f8a6d0$var$shopItemWidth = 250;
const $80e0d3e4e1f8a6d0$var$cellHeight = $80e0d3e4e1f8a6d0$var$shopItemHeight;
const $80e0d3e4e1f8a6d0$var$cellWidth = $80e0d3e4e1f8a6d0$var$shopItemWidth + 20;
const $80e0d3e4e1f8a6d0$var$tabs = [
    {
        key: "all",
        image_key: "shop_all_button"
    },
    {
        key: "resource_packs",
        image_key: "shop_resource_packs_button"
    }
];
class $80e0d3e4e1f8a6d0$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        let conf = config ? config : {
            width: $80e0d3e4e1f8a6d0$var$modalWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        // Initialize Item Data
        this._itemsData = [];
        // Refill Resource Data
        this._refillResourceData = (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getResourceRefillItems();
        this._itemsData = this._itemsData.concat(this._refillResourceData);
        // Buttons Sizer
        this._buttonSizer = this.scene.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($80e0d3e4e1f8a6d0$var$modalWidth - 70),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Buttons
        $80e0d3e4e1f8a6d0$var$tabs.forEach((item)=>{
            const tabButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, item.key === "all" ? item.image_key : `${item.image_key}_inactive`, false).setScale(this._scale);
            tabButton.onClick().subscribe((pointer)=>{
                this.handleFilterClick(item.key);
            });
            this._buttonSizer.add(this.scene.add.existing(tabButton), {
                padding: {
                    left: 0,
                    right: this.applyScale(15),
                    top: 0,
                    bottom: 0
                },
                key: `item_shop_${item.key}_button`
            });
        });
        this.add(this._buttonSizer, {
            key: "button_sizer",
            align: "left-top",
            offsetX: this.applyScale(35),
            offsetY: this.applyScale(35),
            expand: false
        });
        // Table
        this.addTable(scene, this._itemsData);
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
        this._buttonSizer.setAlpha(0);
    }
    addTable(scene, data) {
        if (data) {
            // Table
            this._table = this.createTable(scene, data, 0, 0).layout();
            this.add(this._table, {
                key: "item_shop_table",
                align: "left-top",
                offsetX: this.applyScale(4),
                offsetY: this.applyScale(110),
                expand: false
            });
        }
    }
    handleFilterClick(selectedFilter) {
        if (selectedFilter === this._selectedFilter) return;
        this.updateFilterButtons(selectedFilter);
        if (selectedFilter === "all") this._filteredData = this._itemsData;
        else this._filteredData = this._itemsData.filter((item)=>{
            return item.category === selectedFilter;
        });
        this.remove(this._table, true);
        if (this._filteredData.length > 0) {
            this.addTable(this.scene, this._filteredData);
            this.layout();
        }
        this._selectedFilter = selectedFilter;
    }
    updateFilterButtons(selectedFilter) {
        $80e0d3e4e1f8a6d0$var$tabs.forEach((tab)=>{
            var button = this._buttonSizer.getElement(`item_shop_${tab.key}_button`);
            if (button) button.setTexture(selectedFilter === tab.key ? tab.image_key : `${tab.image_key}_inactive`);
        });
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($80e0d3e4e1f8a6d0$var$cellWidth * data.length > $80e0d3e4e1f8a6d0$var$modalWidth ? $80e0d3e4e1f8a6d0$var$modalWidth - 8 : $80e0d3e4e1f8a6d0$var$cellWidth * data.length - 1),
            height: this.applyScale($80e0d3e4e1f8a6d0$var$cellHeight),
            items: data,
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale($80e0d3e4e1f8a6d0$var$cellWidth),
                cellHeight: this.applyScale($80e0d3e4e1f8a6d0$var$cellHeight),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.4
            },
            space: {
                table: {
                    left: this.applyScale(23),
                    right: 0
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, item.image_key);
                var imageWidth = imageData.width;
                var shopItemComponent = new (0, $8f01efa490409a40$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale(), true, item.type === "refill" ? "View Info for Cost" : undefined);
                scene.add.existing(shopItemComponent);
                return shopItemComponent;
            }
        }).setOrigin(0, 0.5);
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("resourcesShopPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $80e0d3e4e1f8a6d0$export$2e2bcd8739ae039(this.scene, x, y));
});




const $a63cc9abfb0a6042$var$modalWidth = 1008;
const $a63cc9abfb0a6042$var$modalHeight = 513;
const $a63cc9abfb0a6042$var$modalRadius = 16;
const $a63cc9abfb0a6042$var$modalColor = 0x1c1c2c;
const $a63cc9abfb0a6042$var$modalAlpha = 1;
const $a63cc9abfb0a6042$var$modalBorderColor = 0x6262de;
const $a63cc9abfb0a6042$var$modalBorderWidth = 3;
const $a63cc9abfb0a6042$var$tabs = {
    machines: "machines",
    itemShop: "item_shop",
    resources: "resources"
};
class $a63cc9abfb0a6042$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._startingTab = data.active_tab;
    }
    constructor(){
        super({
            key: "ShopModalScene"
        });
    }
    preload() {
    // Images loaded in AssetPreloaderScene
    }
    create() {
        this.createComponent();
        this.scene.launch("AssetPreloaderScene", {
            originating_scene: "ShopModalScene",
            assets: (0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)
        });
    }
    createComponent() {
        const self1 = this;
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.dragDistanceThreshold = 16;
        this.input.dragTimeThreshold = 300;
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($a63cc9abfb0a6042$var$modalWidth, $a63cc9abfb0a6042$var$modalHeight + 70);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale(583),
            width: this.applyScale($a63cc9abfb0a6042$var$modalWidth - 8),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($a63cc9abfb0a6042$var$modalWidth), this.applyScale($a63cc9abfb0a6042$var$modalHeight), this.applyScale($a63cc9abfb0a6042$var$modalRadius), $a63cc9abfb0a6042$var$modalColor, $a63cc9abfb0a6042$var$modalAlpha);
        background.setStrokeStyle(this.applyScale($a63cc9abfb0a6042$var$modalBorderWidth), $a63cc9abfb0a6042$var$modalBorderColor, $a63cc9abfb0a6042$var$modalAlpha);
        this._sizer.add(background, {
            key: "shop_bg",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.layout();
        //this._sizer.drawBounds(this.add.graphics(), 0x00ff00);
        this._sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this._selectedTab = "";
            this.removePanes();
            this.unloadAssets();
            this.scene.stop();
            // this.scene.resume('HomebaseScene');
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).layout();
    }
    onLoaded() {
        this._loadingIndicator.setAlpha(0);
        this._sizer.remove(this._loadingIndicator);
        this._loadingIndicator = undefined;
        //Tab Sizer
        const tabSizer = this.rexUI.add.fixWidthSizer(0, 0, {
            width: $a63cc9abfb0a6042$var$modalWidth,
            align: 2,
            name: "tab_sizer",
            draggable: false
        });
        // Tabs
        this._machinesTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "machines_tab_active", false).setOrigin(1, 1).setScale(this._scale);
        this._itemShopTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "item_shop_tab_inactive", false).setOrigin(0, 1).setScale(this._scale);
        this._resourcesTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "resources_tab_inactive", false).setOrigin(0, 1).setScale(this._scale);
        this._machinesTab.onClick().subscribe((pointer)=>{
            this.machinesTabClickHandler(pointer);
        });
        this._itemShopTab.onClick().subscribe((pointer)=>{
            this.itemShopTabClickHandler(pointer);
        });
        this._resourcesTab.onClick().subscribe((pointer)=>{
            this.resourcesTabClickHandler(pointer);
        });
        tabSizer.add(this.add.existing(this._machinesTab), {
            key: "machines_tab",
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        tabSizer.add(this.add.existing(this._itemShopTab), {
            key: "item_shop_tab",
            padding: {
                left: this.applyScale(14),
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        tabSizer.add(this.add.existing(this._resourcesTab), {
            key: "resources_tab",
            padding: {
                left: this.applyScale(14),
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this._sizer.add(tabSizer, {
            key: "tab_sizer",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        switch(this._startingTab){
            case $a63cc9abfb0a6042$var$tabs.machines:
                this.machinesTabClickHandler(self);
                break;
            case $a63cc9abfb0a6042$var$tabs.itemShop:
                this.itemShopTabClickHandler(self);
                break;
            case $a63cc9abfb0a6042$var$tabs.resources:
                this.resourcesTabClickHandler(self);
                break;
            default:
                this.machinesTabClickHandler(self);
                break;
        }
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    machinesTabClickHandler(pointer) {
        if (this._selectedTab === $a63cc9abfb0a6042$var$tabs.machines) return;
        this.removePanes();
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).layout();
        this._selectedTab = $a63cc9abfb0a6042$var$tabs.machines;
        this._machinesTab.setTexture("machines_tab_active");
        this._itemShopTab.setTexture("item_shop_tab_inactive");
        this._resourcesTab.setTexture("resources_tab_inactive");
        (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getAvailableMachines(true).then((res)=>{
            this._loadingIndicator.setAlpha(0);
            this._sizer.remove(this._loadingIndicator);
            this._loadingIndicator = undefined;
            this._machinesContentPane = new (0, $23d732e8920d7f60$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
            this._sizer.add(this.add.existing(this._machinesContentPane), {
                key: "machines_pane",
                align: "center-top",
                offsetX: 0,
                offsetY: this.applyScale(68),
                expand: false
            }).layout();
        });
    //this._machinesContentPane.drawBounds(this.add.graphics(), 0x00ff00);
    }
    itemShopTabClickHandler(pointer) {
        if (this._selectedTab === $a63cc9abfb0a6042$var$tabs.itemShop) return;
        this.removePanes();
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).layout();
        this._selectedTab = $a63cc9abfb0a6042$var$tabs.itemShop;
        this._machinesTab.setTexture("machines_tab_inactive");
        this._itemShopTab.setTexture("item_shop_tab_active");
        this._resourcesTab.setTexture("resources_tab_inactive");
        (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getShopItems(true).then(()=>{
            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getRewardBoxes(true).then(()=>{
                this._loadingIndicator.setAlpha(0);
                this._sizer.remove(this._loadingIndicator);
                this._loadingIndicator = undefined;
                this._itemShopContentPane = new (0, $a5183a1ff59d6d84$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
                this._sizer.add(this.add.existing(this._itemShopContentPane), {
                    key: "item_shop_pane",
                    align: "center-top",
                    offsetX: 0,
                    offsetY: this.applyScale(68),
                    expand: false
                }).layout();
            });
        });
    }
    resourcesTabClickHandler(pointer) {
        if (this._selectedTab === $a63cc9abfb0a6042$var$tabs.resources) return;
        this.removePanes();
        this._selectedTab = $a63cc9abfb0a6042$var$tabs.resources;
        this._machinesTab.setTexture("machines_tab_inactive");
        this._itemShopTab.setTexture("item_shop_tab_inactive");
        this._resourcesTab.setTexture("resources_tab_active");
        this._resourcesContentPane = new (0, $80e0d3e4e1f8a6d0$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
        this._sizer.add(this.add.existing(this._resourcesContentPane), {
            key: "resources_pane",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(68),
            expand: false
        }).layout();
    }
    removePanes() {
        if (this._machinesContentPane) {
            this._machinesContentPane.hidePane();
            this._sizer.remove(this._machinesContentPane, true); //destroys object
            this._machinesContentPane = null;
        }
        if (this._itemShopContentPane) {
            this._itemShopContentPane.hidePane();
            this._sizer.remove(this._itemShopContentPane, true); //destroys object
            this._itemShopContentPane = null;
        }
        if (this._resourcesContentPane) {
            this._resourcesContentPane.hidePane();
            this._sizer.remove(this._resourcesContentPane, true); //destroys object
            this._resourcesContentPane = null;
        }
        if (this._loadingIndicator) {
            this._loadingIndicator.setAlpha(0);
            this._sizer.remove(this._loadingIndicator);
            this._loadingIndicator = undefined;
        }
    }
    destroy() {
        this._itemShopTab.destroy();
        this._machinesTab.destroy();
        this._resourcesTab.destroy();
        this._selectedTab.destroy();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)));
    }
}










const $e336c8aadd390358$var$modalWidth = 1004;
const $e336c8aadd390358$var$modalHeight = 506;
const $e336c8aadd390358$var$modalRadius = 16;
const $e336c8aadd390358$var$modalColor = 0x1c1c2c;
const $e336c8aadd390358$var$modalAlpha = 1;
const $e336c8aadd390358$var$subtitleTint = 0xa3a3b9;
const $e336c8aadd390358$var$backButtonImageKey = "shop_back_button";
const $e336c8aadd390358$var$itemTypes = {
    machine: "machine",
    shop_item: "shop_item"
};
// Progress bar consts
const $e336c8aadd390358$var$goldProgressBarColor = 0xdea827;
const $e336c8aadd390358$var$pinkProgressBarColor = 0xde2795;
const $e336c8aadd390358$var$blueProgressBarColor = 0x00a6d3;
const $e336c8aadd390358$var$progressBarAlpha = 1;
const $e336c8aadd390358$var$glareColor = 0xffffff;
const $e336c8aadd390358$var$glareAlpha = 0.17;
const $e336c8aadd390358$var$glareRadius = 3;
const $e336c8aadd390358$var$glareHeight = 6;
const $e336c8aadd390358$var$glareOffset = 10;
const $e336c8aadd390358$var$backgroundColor = 0xb48dc7;
const $e336c8aadd390358$var$backgroundAlpha = 0.4;
const $e336c8aadd390358$var$radius = 7;
const $e336c8aadd390358$var$progressBarHeight = 22;
const $e336c8aadd390358$var$stardustBarWidth = 448;
const $e336c8aadd390358$var$neonGoldBarWidth = 448;
const $e336c8aadd390358$var$spaceElixirBarWidth = 448;
const $e336c8aadd390358$var$stardustMin = 0;
const $e336c8aadd390358$var$neonGoldMin = 0;
const $e336c8aadd390358$var$spaceElixirMin = 0;
const $e336c8aadd390358$var$buyButtonImage = "shop_buy_button";
const $e336c8aadd390358$var$comingSoonButtonImage = "shop_coming_soon_button";
const $e336c8aadd390358$var$soldOutButtonImage = "shop_sold_out_button";
const $e336c8aadd390358$var$sizerItemLeftPadding = 77;
const $e336c8aadd390358$var$titleBottomPadding = 8;
const $e336c8aadd390358$var$costLabelBottomPadding = 8;
const $e336c8aadd390358$var$progBarTopPadding = 7;
const $e336c8aadd390358$var$lowerDividerTopPadding = 20;
const $e336c8aadd390358$var$lowerDividerBottomPadding = 20;
const $e336c8aadd390358$var$descriptionLabelBottomPadding = 7;
class $e336c8aadd390358$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, item, type, paneScale, config){
        let conf = config ? config : {
            width: $e336c8aadd390358$var$modalWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._item = item;
        this._type = type;
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, this.applyScale($e336c8aadd390358$var$modalWidth), this.applyScale($e336c8aadd390358$var$modalHeight), this.applyScale($e336c8aadd390358$var$modalRadius), $e336c8aadd390358$var$modalColor, $e336c8aadd390358$var$modalAlpha);
        this.add(background, {
            key: "info_scene_bg",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Back Button
        this._backButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, $e336c8aadd390358$var$backButtonImageKey, false).setScale(this._scale);
        this.scene.add.existing(this._backButton);
        this._backButton.onClick().subscribe((pointer)=>{
            this.backButtonHandler();
        });
        this.add(this._backButton, {
            key: "item_info_back_button",
            align: "left-top",
            offsetX: this.applyScale(33),
            offsetY: this.applyScale(27),
            expand: false
        });
        // Item Component
        switch(type){
            case $e336c8aadd390358$var$itemTypes.machine:
                this._itemComponent = new (0, $0f6d56d1311b06e9$export$2e2bcd8739ae039)(scene, 0, 0, this._item, scene.getScale(), false);
                scene.add.existing(this._itemComponent);
                break;
            case $e336c8aadd390358$var$itemTypes.shop_item:
                this._itemComponent = new (0, $8f01efa490409a40$export$2e2bcd8739ae039)(scene, 0, 0, this._item, scene.getScale(), false, this._item.type === "refill" ? "Calculating..." : undefined);
                scene.add.existing(this._itemComponent);
                break;
            default:
                break;
        }
        if (this._itemComponent) this.add(this._itemComponent, {
            key: "item_info_item_component",
            align: "left-top",
            offsetX: this.applyScale(38),
            offsetY: this.applyScale(102),
            expand: false
        });
        // Upper Divider
        const upperDivider = this.scene.add.image(0, 0, "shop_item_info_divider_long");
        this.add(upperDivider, {
            key: "upper_divider",
            align: "left-top",
            offsetX: this.applyScale(260),
            offsetY: this.applyScale(102),
            expand: false
        });
        // Sizer for dynamic height content
        var sizer = this.scene.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($e336c8aadd390358$var$spaceElixirBarWidth + 10),
            height: this.applyScale(350),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Item Title
        this._itemTitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), this.applyScale(28), 0);
        sizer.add(this._itemTitle, {
            key: "item_title",
            padding: {
                left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                right: 0,
                top: 0,
                bottom: this.applyScale($e336c8aadd390358$var$titleBottomPadding)
            }
        }).addNewLine();
        // Cost Subtitle
        this._costSubtitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getCostSubtitle(), this.applyScale(16), 0);
        this._costSubtitle.setTint($e336c8aadd390358$var$subtitleTint);
        sizer.add(this._costSubtitle, {
            key: "cost_subtitle",
            padding: {
                left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                right: 0,
                top: 0,
                bottom: 0
            }
        }).addNewLine();
        if (this._item.type === "refill") {
            this._calcLabel = this.scene.add.bitmapText(0, 0, "cc_outline", "Calculating...", this.applyScale(20), 0);
            this._calcLabel.setTint($e336c8aadd390358$var$subtitleTint);
            sizer.add(this._calcLabel, {
                key: "calc_label",
                padding: {
                    left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                    right: 0,
                    top: this.applyScale($e336c8aadd390358$var$progBarTopPadding),
                    bottom: 0
                }
            });
            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().getRefillCost(this._item.refillCurrencyId, this._item.refillPercentage).then((res)=>{
                this._item.dark_matter_cost = res.dark_matter_cost || 0;
                this._item.stardust_cost = this._item.cost = res.stardust_cost || 0;
                this._item.neon_gold_cost = res.neon_gold_cost || 0;
                this._item.space_elixir_cost = res.space_elixir_cost || 0;
                this._calcLabel.setAlpha(0);
                sizer.remove(this._calcLabel, true);
                this._itemComponent.updateLabelText(this._item.stardust_cost.toLocaleString("en-us"));
                this.addProgressBars(sizer);
                this.layout();
            });
        } else this.addProgressBars(sizer);
        // Lower Divider
        const lowerDivider = this.scene.add.image(0, 0, "shop_item_info_divider_short");
        sizer.add(lowerDivider, {
            key: "lower_divider",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale($e336c8aadd390358$var$lowerDividerTopPadding),
                bottom: this.applyScale($e336c8aadd390358$var$lowerDividerBottomPadding)
            }
        });
        // Description Title
        this._descriptionTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Description", this.applyScale(16), 0);
        this._descriptionTitle.setTint($e336c8aadd390358$var$subtitleTint);
        sizer.add(this._descriptionTitle, {
            key: "description_title",
            padding: {
                left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                right: 0,
                top: 0,
                bottom: this.applyScale($e336c8aadd390358$var$descriptionLabelBottomPadding)
            }
        }).addNewLine();
        // Description Text Area
        this._descriptionText = this.scene.rexUI.add.textArea({
            x: 0,
            y: 0,
            width: this.applyScale(550),
            height: this.applyScale(76),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this.getDescription(), this.applyScale(16), 0),
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            scroller: true
        }).layout();
        this._descriptionText.setText(this.getDescription());
        sizer.add(this._descriptionText, {
            key: "description_text",
            padding: {
                left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        // Add sizer
        this.add(sizer, {
            key: "prog_sizer",
            align: "left-top",
            offsetX: this.applyScale(288),
            offsetY: this.applyScale(122),
            expand: false
        });
        if (this._type === $e336c8aadd390358$var$itemTypes.shop_item) {
            if (this._item.count > 0) {
                // Buy Button
                this._buyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, $e336c8aadd390358$var$buyButtonImage, false).setScale(scene.getScale());
                scene.add.existing(this._buyButton);
                this._buyButton.onClick().subscribe((pointer)=>{
                    this._buyButton.disableInteractive();
                    if (this._item.count > 0) switch(this._item.type){
                        case "whitelist":
                            this.scene.scene.start("ShopWalletScene", {
                                item: this._item
                            });
                            break;
                        case "discord_item":
                            this.scene.scene.start("ShopDiscordScene", {
                                item: this._item
                            });
                            break;
                        case "refill":
                            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().purchaseResourceRefill(this._item.refillCurrencyId, this._item.refillPercentage).then((res)=>{
                                this.scene.scene.start("ShopPurchaseResultScene", {
                                    item: this._item,
                                    itemType: "shop_item",
                                    purchaseResult: res
                                });
                            });
                            break;
                        case "other":
                            if (this._item.shop_item_id === 11) {
                                // Battle Pass Purchase
                                this.scene.scene.stop("ShopModalScene");
                                this.scene.scene.stop("ShopItemInfoScene");
                                this.scene.scene.stop("HomebaseScene");
                                this.scene.scene.stop("HudScene");
                                this.scene.scene.start("BattlePassBuyScene");
                            } else (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().purchaseOther(this._item.shop_item_id).then((res)=>{
                                this.scene.scene.start("ShopPurchaseResultScene", {
                                    item: this._item,
                                    itemType: "shop_item",
                                    purchaseResult: res
                                });
                            });
                            break;
                        case "reward":
                            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().purchaseRewardBox(this._item.reward_type_id).then((res)=>{
                                this.scene.scene.start("ShopRewardScene", {
                                    item: this._item,
                                    itemType: "resource_box",
                                    purchaseResult: res
                                });
                            });
                    }
                });
            } else this._buyButton = scene.add.image(0, 0, $e336c8aadd390358$var$soldOutButtonImage).setScale(scene.getScale());
        } else if (this._type === $e336c8aadd390358$var$itemTypes.machine) {
            // Buy Button
            this._buyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, $e336c8aadd390358$var$buyButtonImage, false).setScale(scene.getScale());
            scene.add.existing(this._buyButton);
            this._buyButton.onClick().subscribe((pointer)=>{
                this.scene.scene.start("ShopPurchaseConfirmScene", {
                    item: this._item,
                    isUpgrade: false
                });
            });
        } else this._buyButton = scene.add.image(0, 0, $e336c8aadd390358$var$comingSoonButtonImage).setScale(scene.getScale());
        this.add(this._buyButton, {
            key: "buy_button",
            align: "right-bottom",
            offsetX: this.applyScale(-33),
            offsetY: this.applyScale(-36),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
        this._backButton.setAlpha(0);
        this._itemComponent.setAlpha(0);
    //this.table.disableInteractive();
    }
    backButtonHandler() {
        this.scene.scene.resume("ShopModalScene");
        this.scene.scene.stop("ShopItemInfoScene");
    }
    getDisplayName() {
        if (this._type === $e336c8aadd390358$var$itemTypes.shop_item) {
            if (this._item.type === "whitelist") return this._item.name.slice(-2) === "WL" ? this._item.name : `${this._item.name} WL`;
            else return this._item.name;
        }
        return this._item.display_name || "Unknown Item";
    }
    getCostSubtitle() {
        if (this._type === $e336c8aadd390358$var$itemTypes.machine) return "Cost to build";
        return "Cost to buy";
    }
    getDescription() {
        if (this._type === $e336c8aadd390358$var$itemTypes.shop_item) switch(this._item.type){
            case "whitelist":
                return `Reserve a spot on the ${this.getDisplayName()}\n\nSpots remaining: ${this._item.count}`;
            default:
                return this._item.description;
        }
        return this._item.description;
    }
    addProgressBars(sizer) {
        var progBarCount = 0;
        var sizerItemIndex = 4;
        // Space Elixir
        const spaceElixirCost = this.getSpaceElixirCost();
        if (spaceElixirCost > 0) {
            progBarCount++;
            this._spaceElixirProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
                rtl: false,
                title: {
                    text: "",
                    fontStyle: null
                },
                icon: {
                    key: "space_elixir_icon",
                    space: 8,
                    scale: 1
                },
                progressBar: {
                    text: spaceElixirCost.toLocaleString("en-us"),
                    fontStyle: null,
                    width: $e336c8aadd390358$var$spaceElixirBarWidth,
                    height: $e336c8aadd390358$var$progressBarHeight,
                    radius: $e336c8aadd390358$var$radius,
                    color: $e336c8aadd390358$var$blueProgressBarColor,
                    alpha: $e336c8aadd390358$var$progressBarAlpha,
                    backgroundColor: $e336c8aadd390358$var$backgroundColor,
                    backgroundAlpha: $e336c8aadd390358$var$backgroundAlpha,
                    minValue: $e336c8aadd390358$var$spaceElixirMin,
                    maxValue: spaceElixirCost > 0 ? spaceElixirCost : 100,
                    progressValue: spaceElixirCost,
                    glare: {
                        height: $e336c8aadd390358$var$glareHeight,
                        width: $e336c8aadd390358$var$spaceElixirBarWidth - $e336c8aadd390358$var$glareOffset,
                        radius: $e336c8aadd390358$var$glareRadius,
                        color: $e336c8aadd390358$var$glareColor,
                        alpha: $e336c8aadd390358$var$glareAlpha
                    }
                }
            });
            this.scene.add.existing(this._spaceElixirProgressBar);
            sizer.add(this._spaceElixirProgressBar, {
                key: "space_elixir_bar",
                padding: {
                    left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                    right: 0,
                    top: this.applyScale($e336c8aadd390358$var$progBarTopPadding),
                    bottom: 0
                },
                index: sizerItemIndex
            });
            sizerItemIndex++;
        }
        // Neon Gold
        const neonGoldCost = this.getNeonGoldCost();
        if (neonGoldCost > 0) {
            progBarCount++;
            this._neonGoldProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
                rtl: false,
                title: {
                    text: "",
                    fontStyle: null
                },
                icon: {
                    key: "neon_gold_icon",
                    space: 8,
                    scale: 1
                },
                progressBar: {
                    text: neonGoldCost.toLocaleString("en-us"),
                    fontStyle: null,
                    width: $e336c8aadd390358$var$neonGoldBarWidth,
                    height: $e336c8aadd390358$var$progressBarHeight,
                    radius: $e336c8aadd390358$var$radius,
                    color: $e336c8aadd390358$var$goldProgressBarColor,
                    alpha: $e336c8aadd390358$var$progressBarAlpha,
                    backgroundColor: $e336c8aadd390358$var$backgroundColor,
                    backgroundAlpha: $e336c8aadd390358$var$backgroundAlpha,
                    minValue: $e336c8aadd390358$var$neonGoldMin,
                    maxValue: neonGoldCost > 0 ? neonGoldCost : 100,
                    progressValue: neonGoldCost,
                    glare: {
                        height: $e336c8aadd390358$var$glareHeight,
                        width: $e336c8aadd390358$var$neonGoldBarWidth - $e336c8aadd390358$var$glareOffset,
                        radius: $e336c8aadd390358$var$glareRadius,
                        color: $e336c8aadd390358$var$glareColor,
                        alpha: $e336c8aadd390358$var$glareAlpha
                    }
                }
            });
            this.scene.add.existing(this._neonGoldProgressBar);
            sizer.add(this._neonGoldProgressBar, {
                key: "neon_gold_bar",
                padding: {
                    left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                    right: 0,
                    top: this.applyScale($e336c8aadd390358$var$progBarTopPadding),
                    bottom: 0
                },
                index: sizerItemIndex
            });
            sizerItemIndex++;
        }
        // Dark Matter
        const darkMatterCost = this.getDarkMatterCost();
        if (darkMatterCost > 0) {
            this._darkMatterProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
                rtl: false,
                title: {
                    text: "",
                    fontStyle: null
                },
                icon: {
                    key: "dark_matter_icon_44",
                    space: 8,
                    scale: 1
                },
                progressBar: {
                    text: darkMatterCost.toLocaleString("en-us"),
                    fontStyle: null,
                    width: $e336c8aadd390358$var$stardustBarWidth,
                    height: $e336c8aadd390358$var$progressBarHeight,
                    radius: $e336c8aadd390358$var$radius,
                    color: $e336c8aadd390358$var$pinkProgressBarColor,
                    alpha: $e336c8aadd390358$var$progressBarAlpha,
                    backgroundColor: $e336c8aadd390358$var$backgroundColor,
                    backgroundAlpha: $e336c8aadd390358$var$backgroundAlpha,
                    minValue: $e336c8aadd390358$var$stardustMin,
                    maxValue: darkMatterCost > 0 ? darkMatterCost : 100,
                    progressValue: darkMatterCost,
                    glare: {
                        height: $e336c8aadd390358$var$glareHeight,
                        width: $e336c8aadd390358$var$stardustBarWidth - $e336c8aadd390358$var$glareOffset,
                        radius: $e336c8aadd390358$var$glareRadius,
                        color: $e336c8aadd390358$var$glareColor,
                        alpha: $e336c8aadd390358$var$glareAlpha
                    }
                }
            });
            this.scene.add.existing(this._darkMatterProgressBar);
            sizer.add(this._darkMatterProgressBar, {
                key: "dark_matter_bar",
                padding: {
                    left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                    right: 0,
                    top: this.applyScale($e336c8aadd390358$var$progBarTopPadding),
                    bottom: 0
                },
                index: sizerItemIndex
            });
            sizerItemIndex++;
        }
        // Stardust
        const stardustCost = this.getStardustCost();
        if (stardustCost > 0 || progBarCount === 0) {
            progBarCount++;
            this._stardustProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
                rtl: false,
                title: {
                    text: "",
                    fontStyle: null
                },
                icon: {
                    key: "stardust_icon_44",
                    space: 8,
                    scale: 1
                },
                progressBar: {
                    text: stardustCost.toLocaleString("en-us"),
                    fontStyle: null,
                    width: $e336c8aadd390358$var$stardustBarWidth,
                    height: $e336c8aadd390358$var$progressBarHeight,
                    radius: $e336c8aadd390358$var$radius,
                    color: $e336c8aadd390358$var$pinkProgressBarColor,
                    alpha: $e336c8aadd390358$var$progressBarAlpha,
                    backgroundColor: $e336c8aadd390358$var$backgroundColor,
                    backgroundAlpha: $e336c8aadd390358$var$backgroundAlpha,
                    minValue: $e336c8aadd390358$var$stardustMin,
                    maxValue: stardustCost > 0 ? stardustCost : 100,
                    progressValue: stardustCost,
                    glare: {
                        height: $e336c8aadd390358$var$glareHeight,
                        width: $e336c8aadd390358$var$stardustBarWidth - $e336c8aadd390358$var$glareOffset,
                        radius: $e336c8aadd390358$var$glareRadius,
                        color: $e336c8aadd390358$var$glareColor,
                        alpha: $e336c8aadd390358$var$glareAlpha
                    }
                }
            });
            this.scene.add.existing(this._stardustProgressBar);
            sizer.add(this._stardustProgressBar, {
                key: "stardust_bar",
                padding: {
                    left: this.applyScale($e336c8aadd390358$var$sizerItemLeftPadding),
                    right: 0,
                    top: this.applyScale($e336c8aadd390358$var$progBarTopPadding),
                    bottom: 0
                },
                index: sizerItemIndex
            });
            sizerItemIndex++;
        }
        sizer.layout();
    }
    getSpaceElixirCost() {
        if (this._type === $e336c8aadd390358$var$itemTypes.machine) return this._item.cost_space_elixir;
        else return this._item.currency_id === 1 ? this._item.cost : 0;
    }
    getNeonGoldCost() {
        if (this._type === $e336c8aadd390358$var$itemTypes.machine) return this._item.cost_neon_gold;
        else return this._item.currency_id === 2 ? this._item.cost : 0;
    }
    getStardustCost() {
        if (this._type === $e336c8aadd390358$var$itemTypes.machine) return this._item.cost_stardust;
        else return this._item.currency_id === 3 ? this._item.cost : 0;
    }
    getDarkMatterCost() {
        if (this._type === $e336c8aadd390358$var$itemTypes.machine) return this._item.cost_dark_matter;
        else return this._item.currency_id === 4 ? this._item.cost : 0;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("shopItemInfoContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $e336c8aadd390358$export$2e2bcd8739ae039(this.scene, x, y));
});


const $7b50ea8ec6e6c901$var$modalWidth = 1004;
class $7b50ea8ec6e6c901$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._scale = data.scale;
        this._item = data.item;
        this._type = data.type;
    }
    constructor(){
        super({
            key: "ShopItemInfoScene"
        });
    }
    preload() {}
    create() {
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $7b50ea8ec6e6c901$var$modalWidth * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        this._pane = new (0, $e336c8aadd390358$export$2e2bcd8739ae039)(this, 0, 0, this._item, this._type, this._scale);
        this.add.existing(this._pane);
        this._sizer.add(this._pane, {
            key: "info_pane",
            align: "left-top",
            offsetX: 0,
            offsetY: this.applyScale(37),
            expand: false
        });
        this._sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {}
}



class $c8c81f9d2a238534$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "LoginFailedScene"
        });
    }
    create() {
        // this.cameras.main.fadeIn(500, 0, 0, 0);
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 90, "cc_outline", "This wallet is\nnot on the whitelist.", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 30, "party_blob").setOrigin(0.5, 0.5);
    }
}






const $76f1d6b415d5b5df$var$modalHeight = 325;
const $76f1d6b415d5b5df$var$modalWidth = 494;
const $76f1d6b415d5b5df$var$modalRadius = 25;
const $76f1d6b415d5b5df$var$modalColor = 0x350926;
const $76f1d6b415d5b5df$var$modalAlpha = 1;
const $76f1d6b415d5b5df$var$modalBorderColor = 0x3d4361;
const $76f1d6b415d5b5df$var$modalBorderWidth = 1;
const $76f1d6b415d5b5df$var$dashboardHeight = 595;
const $76f1d6b415d5b5df$var$dashboardWidth = 914;
const $76f1d6b415d5b5df$var$dashboardRadius = 25;
const $76f1d6b415d5b5df$var$pausedShadeColor = 0x1c1c1c;
const $76f1d6b415d5b5df$var$pausedShadeAlpha = 0.5;
class $76f1d6b415d5b5df$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this.item = data.item;
        this.text = data.text;
        this.type = data.type;
    }
    constructor(){
        super({
            key: "DailyChestModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480));
    }
    create() {
        // Add Shade
        const pausedShade = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $76f1d6b415d5b5df$var$dashboardWidth, $76f1d6b415d5b5df$var$dashboardHeight, $76f1d6b415d5b5df$var$dashboardRadius, $76f1d6b415d5b5df$var$pausedShadeColor, $76f1d6b415d5b5df$var$pausedShadeAlpha);
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $76f1d6b415d5b5df$var$modalWidth, $76f1d6b415d5b5df$var$modalHeight, $76f1d6b415d5b5df$var$modalRadius, $76f1d6b415d5b5df$var$modalColor, $76f1d6b415d5b5df$var$modalAlpha);
        modalBg.setStrokeStyle($76f1d6b415d5b5df$var$modalBorderWidth, $76f1d6b415d5b5df$var$modalBorderColor, $76f1d6b415d5b5df$var$modalAlpha);
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, "chest_icon_large");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_bar");
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 40, "cc_outline", this.text, 28, 1).setOrigin(0.5, 0.5);
        const prog1 = this.add.image(this.sys.canvas.width / 2 - 122, this.sys.canvas.height / 2 + 50, "loading_prog_1");
        const prog2 = this.add.image(this.sys.canvas.width / 2 - 73, this.sys.canvas.height / 2 + 50, "loading_prog_2");
        const prog3 = this.add.image(this.sys.canvas.width / 2 - 34, this.sys.canvas.height / 2 + 50, "loading_prog_3");
        const prog4 = this.add.image(this.sys.canvas.width / 2 - 13, this.sys.canvas.height / 2 + 50, "loading_prog_4");
        const prog5 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_5");
        prog1.alpha = 0;
        prog2.alpha = 0;
        prog3.alpha = 0;
        prog4.alpha = 0;
        prog5.alpha = 0;
        this.time.addEvent({
            delay: 250,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog1,
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog2,
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 750,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog3,
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
            }
        });
        this.time.addEvent({
            delay: 1000,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: prog4,
                    alpha: 1,
                    duration: 500,
                    ease: "Power2"
                }, this);
                switch(this.type){
                    case "nft":
                        (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().claimNftStakingReward(this.item.marketplace_nft_id).then((res)=>{
                            this.tweens.add({
                                targets: prog5,
                                alpha: 1,
                                duration: 500,
                                ease: "Power2"
                            }, this);
                            // Start RewardModalScene with response data
                            this.scene.start("RewardModalScene", {
                                reward: res.nft_staking_reward_info.currency_reward_value,
                                rewardCurrency: res.nft_staking_reward_info.currency_name
                            });
                        });
                        break;
                    case "wallet":
                        break;
                    case "all":
                        (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().claimAllStakingRewards().then((res)=>{
                            this.tweens.add({
                                targets: prog5,
                                alpha: 1,
                                duration: 500,
                                ease: "Power2"
                            }, this);
                            this.scene.resume("ObjectivesModalScene");
                            this.unloadAssets();
                            this.scene.stop();
                        });
                        break;
                }
            }
        });
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f9e0002d98f59480)));
    }
}






const $c8a1a1e87bf46e8e$var$dashboardHeight = 595;
const $c8a1a1e87bf46e8e$var$dashboardWidth = 914;
const $c8a1a1e87bf46e8e$var$dashboardRadius = 25;
const $c8a1a1e87bf46e8e$var$pausedShadeColor = 0x1c1c1c;
const $c8a1a1e87bf46e8e$var$pausedShadeAlpha = 0.5;
const $c8a1a1e87bf46e8e$var$modalHeight = 278;
const $c8a1a1e87bf46e8e$var$modalWidth = 494;
const $c8a1a1e87bf46e8e$var$modalRadius = 25;
const $c8a1a1e87bf46e8e$var$modalColor = 0x350926;
const $c8a1a1e87bf46e8e$var$modalAlpha = 1;
const $c8a1a1e87bf46e8e$var$modalBorderColor = 0x3d4361;
const $c8a1a1e87bf46e8e$var$modalBorderWidth = 1;
const $c8a1a1e87bf46e8e$var$rewardContainerHeight = 43;
const $c8a1a1e87bf46e8e$var$rewardContainerWidth = 213;
const $c8a1a1e87bf46e8e$var$rewardContainerRadius = 11;
const $c8a1a1e87bf46e8e$var$rewardContainerColor = 0x201425;
const $c8a1a1e87bf46e8e$var$rewardContainerAlpha = 0.7;
const $c8a1a1e87bf46e8e$var$rewardContainerBorderColor = 0x383d57;
const $c8a1a1e87bf46e8e$var$rewardContainerBorderWidth = 1;
const $c8a1a1e87bf46e8e$var$rewardGlareHeight = 6;
const $c8a1a1e87bf46e8e$var$rewardGlareWidth = 203;
const $c8a1a1e87bf46e8e$var$rewardGlareRadius = 4;
const $c8a1a1e87bf46e8e$var$rewardGlareColor = 0xffffff;
const $c8a1a1e87bf46e8e$var$rewardGlareAlpha = 0.14;
const $c8a1a1e87bf46e8e$var$currencyColors = {
    neon_gold: 0xffe100,
    space_elixir: 0x00d4f7,
    stardust: 0xedffa6
};
class $c8a1a1e87bf46e8e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this.reward = data.reward;
        this.rewardCurrency = data.rewardCurrency;
    }
    constructor(reward){
        super({
            key: "RewardModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$7e2f8a660ede5d39));
    }
    create() {
        this.createComponent();
    }
    createComponent() {
        // Add Shade
        const pausedShade = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $c8a1a1e87bf46e8e$var$dashboardWidth, $c8a1a1e87bf46e8e$var$dashboardHeight, $c8a1a1e87bf46e8e$var$dashboardRadius, $c8a1a1e87bf46e8e$var$pausedShadeColor, $c8a1a1e87bf46e8e$var$pausedShadeAlpha);
        // Add Window
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $c8a1a1e87bf46e8e$var$modalWidth, $c8a1a1e87bf46e8e$var$modalHeight, $c8a1a1e87bf46e8e$var$modalRadius, $c8a1a1e87bf46e8e$var$modalColor, $c8a1a1e87bf46e8e$var$modalAlpha);
        modalBg.setStrokeStyle($c8a1a1e87bf46e8e$var$modalBorderWidth, $c8a1a1e87bf46e8e$var$modalBorderColor, $c8a1a1e87bf46e8e$var$modalAlpha);
        // Add Icon
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, `${this.rewardCurrency}_icon_large`);
        // Add Text
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 45, "cc_outline", "You earned:", 28, 1).setOrigin(0.5, 0.5);
        // Add Reward Container
        const rewardContainer = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 25, $c8a1a1e87bf46e8e$var$rewardContainerWidth, $c8a1a1e87bf46e8e$var$rewardContainerHeight, $c8a1a1e87bf46e8e$var$rewardContainerRadius, $c8a1a1e87bf46e8e$var$rewardContainerColor, $c8a1a1e87bf46e8e$var$rewardContainerAlpha).setStrokeStyle($c8a1a1e87bf46e8e$var$rewardContainerBorderWidth, $c8a1a1e87bf46e8e$var$rewardContainerBorderColor, $c8a1a1e87bf46e8e$var$rewardContainerAlpha);
        // Add Reward Container Glare
        const rewardContainerGlare = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 12, $c8a1a1e87bf46e8e$var$rewardGlareWidth, $c8a1a1e87bf46e8e$var$rewardGlareHeight, $c8a1a1e87bf46e8e$var$rewardGlareRadius, $c8a1a1e87bf46e8e$var$rewardGlareColor, $c8a1a1e87bf46e8e$var$rewardGlareAlpha);
        // Add Reward Label
        const rewardLabel = this.rexUI.add.label({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2 + 28,
            width: 200,
            height: 30,
            orientation: "x",
            rtl: false,
            icon: this.add.image(0, 0, `${this.rewardCurrency}_icon`).setScale(0.5),
            text: this.add.bitmapText(0, 0, "cc_outline", this.reward.toLocaleString("en-us"), 20, 0),
            space: {
                icon: 8
            },
            align: "center"
        }).layout();
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, "reward_confirm_button", true, 1.05);
        confirmButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.resume("ObjectivesModalScene");
            this.scene.stop();
        });
        this.add.existing(confirmButton);
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$7e2f8a660ede5d39)));
    }
}



class $40531828681dd0a1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "ErrorScene"
        });
    }
    create() {
        // this.cameras.main.fadeIn(500, 0, 0, 0);
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 120, "cc_outline", "Oops! Something went wrong.\nPlease refresh and try again.", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 100, "cc_outline", "*If the problem persists please notify the team in discord.", 17, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 20, "party_blob").setOrigin(0.5, 0.5);
    }
}






const $bcb87a290434e74d$var$subTextColor = 0xbfaac6;
const $bcb87a290434e74d$var$modalHeight = 325;
const $bcb87a290434e74d$var$modalWidth = 494;
const $bcb87a290434e74d$var$modalRadius = 25;
const $bcb87a290434e74d$var$modalColor = 0x350926;
const $bcb87a290434e74d$var$modalAlpha = 1;
const $bcb87a290434e74d$var$modalBorderColor = 0x3d4361;
const $bcb87a290434e74d$var$modalBorderWidth = 1;
const $bcb87a290434e74d$var$dashboardHeight = 900;
const $bcb87a290434e74d$var$dashboardWidth = 1068;
const $bcb87a290434e74d$var$dashboardRadius = 25;
const $bcb87a290434e74d$var$pausedShadeColor = 0x1c1c1c;
const $bcb87a290434e74d$var$pausedShadeAlpha = 0.5;
class $bcb87a290434e74d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "PenaltyScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$7e2f8a660ede5d39));
    }
    create() {
        // Add Shade
        const pausedShade = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.sys.canvas.width, this.sys.canvas.height, 0, $bcb87a290434e74d$var$pausedShadeColor, $bcb87a290434e74d$var$pausedShadeAlpha);
        // Add Window
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $bcb87a290434e74d$var$modalWidth, $bcb87a290434e74d$var$modalHeight, $bcb87a290434e74d$var$modalRadius, $bcb87a290434e74d$var$modalColor, $bcb87a290434e74d$var$modalAlpha);
        modalBg.setStrokeStyle($bcb87a290434e74d$var$modalBorderWidth, $bcb87a290434e74d$var$modalBorderColor, $bcb87a290434e74d$var$modalAlpha);
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 90, "cc_outline", "Are you sure you\nwant to Open All?", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 5, "cc_outline", "Please note that 20% of the\nresources that you will have earned\nwill be penalized.", 20, 0).setOrigin(0.5, 0).setCenterAlign().setTint($bcb87a290434e74d$var$subTextColor);
        // Buttons
        this.confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + 100, modalBg.getBottomLeft().y, "reward_confirm_button", true, 1.05);
        this.confirmButton.onClick().subscribe((pointer)=>{
            this.scene.start("DailyChestModalScene", {
                item: null,
                text: "Opening daily chests...",
                type: "all"
            });
        });
        this.add.existing(this.confirmButton);
        this.cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - 100, modalBg.getBottomLeft().y, "reward_cancel_button", true, 1.05);
        this.cancelButton.onClick().subscribe((pointer)=>{
            this.scene.resume("ObjectivesModalScene");
            this.scene.stop();
        });
        this.add.existing(this.cancelButton);
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$7e2f8a660ede5d39)));
    }
}







var $7WQrb = parcelRequire("7WQrb");


var $f244a5791b15a233$export$eb5ccdbd077479c;
(function(GameState) {
    GameState[GameState["GameEmpty"] = 0] = "GameEmpty";
    GameState[GameState["WaitingForOpponent"] = 1] = "WaitingForOpponent";
    GameState[GameState["Playing"] = 2] = "Playing";
    GameState[GameState["Tie"] = 3] = "Tie";
    GameState[GameState["IdleTie"] = 4] = "IdleTie";
    GameState[GameState["Player1Win"] = 5] = "Player1Win";
    GameState[GameState["Player2Win"] = 6] = "Player2Win";
})($f244a5791b15a233$export$eb5ccdbd077479c || ($f244a5791b15a233$export$eb5ccdbd077479c = {}));
var $f244a5791b15a233$export$da63e7f9fc855de4;
(function(RoundState) {
    RoundState[RoundState["Start"] = 0] = "Start";
    RoundState[RoundState["Complete"] = 1] = "Complete";
})($f244a5791b15a233$export$da63e7f9fc855de4 || ($f244a5791b15a233$export$da63e7f9fc855de4 = {}));
var $f244a5791b15a233$export$c36edca8f8f0427a;
(function(Rank) {
    Rank[Rank["Undefined"] = 0] = "Undefined";
    Rank[Rank["Bronze"] = 1] = "Bronze";
    Rank[Rank["Silver"] = 2] = "Silver";
    Rank[Rank["Gold"] = 3] = "Gold";
    Rank[Rank["Platinum"] = 4] = "Platinum";
    Rank[Rank["Diamond"] = 5] = "Diamond";
})($f244a5791b15a233$export$c36edca8f8f0427a || ($f244a5791b15a233$export$c36edca8f8f0427a = {}));







const $95f314ec8ce1be9b$var$noMember = {
    id: 0,
    nft_collection: "Star Wolvez Generative",
    display_name: "None Selected       ",
    image_key: "starwolf_silhouette",
    hp: 0,
    show_yield: false,
    show_hp: false,
    disabled: true
};
class $95f314ec8ce1be9b$var$BotService {
    constructor(){
        this._botData = {
            wallet: "0x0",
            name: (0, $2e76b527e9362cab$export$c27c5a03b42fc70c)(),
            xp: 0,
            level: 0,
            last_opensea_api_check: 1670224658,
            discord_airdrop: 0,
            tourno_one_airdrop: 0,
            neon_gold: 0,
            space_elixir: 0,
            stardust: "0"
        };
        if ($95f314ec8ce1be9b$var$BotService._instance) throw new Error("Error: Instantiation failed: Use OpponentService.getInstance() instead of new.");
        $95f314ec8ce1be9b$var$BotService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $95f314ec8ce1be9b$var$BotService._instance;
    }
    getBotSync() {
        return this._bot;
    }
    getTraitsSync() {
        return this._traits;
    }
    getBot(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._bot && !forceUpdate) return resolve(this._bot);
            else return resolve(this.fetchBot());
        });
    }
    fetchBot() {
        this._bot = this._botData;
        return this.getSquad(true).then((squad)=>{
            this._bot.squadMembers = squad;
            return this._bot;
        });
    }
    getSquad(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._squad && !forceUpdate) return resolve(this._squad);
            else return resolve(this.fetchRandomSquad());
        });
    }
    fetchRandomSquad() {
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("squad", [
            "random"
        ], []).then((res)=>{
            return this.enrichSquadData(res.squad).then((enrichedSquad)=>{
                this._squad = enrichedSquad;
                this._traits = this.generateTraitsList(this._squad);
                return this._squad;
            });
        });
    }
    getBotSquadSync() {
        return this._squad;
    }
    enrichSquadData(squadData) {
        return this.getNFTs(squadData, true).then((nfts)=>{
            if (squadData && squadData.length > 0) {
                const enrichedSquad = squadData.map((squadMember)=>{
                    var nftData = nfts.find((nft)=>{
                        return nft.id === squadMember.marketplace_nft_id;
                    });
                    if (nftData) return Object.assign({}, {
                        position: squadMember.position,
                        squad_type_id: squadMember.squad_type_id
                    }, nftData);
                    return undefined;
                });
                var squadArray = [];
                var position = 0;
                enrichedSquad.forEach((sqMem)=>{
                    if (sqMem) {
                        squadArray[position] = sqMem;
                        position++;
                    }
                });
                for(var i = 0; i < 3; i++)if (!squadArray[i]) squadArray[i] = Object.assign({}, $95f314ec8ce1be9b$var$noMember, {
                    position: i
                });
                return squadArray;
            } else return [
                Object.assign({}, $95f314ec8ce1be9b$var$noMember),
                Object.assign({}, $95f314ec8ce1be9b$var$noMember),
                Object.assign({}, $95f314ec8ce1be9b$var$noMember)
            ];
        });
    }
    getNFTs(squad, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._nfts && this._nfts.length > 0 && !forceUpdate) return resolve(this._nfts);
            else return resolve(this.fetchNFTs(squad));
        });
    }
    fetchNFTs(squad) {
        var promises = [];
        // ToDo Change when Chance updates API call to get NFTs without Walletid
        squad.forEach((squadMember)=>{
            promises.push((0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("nfts", [
                squadMember.partner_contract_address,
                squadMember.marketplace_nft_id
            ], []));
        });
        this._nfts = [];
        return Promise.all(promises).then((responses)=>{
            responses.forEach((res)=>{
                this._nfts.push(this.enrichImageData(res.nfts[0]));
            });
            return this._nfts;
        });
    }
    enrichImageData(nft) {
        nft.image_key = `nft_${nft.id}`;
        return nft;
    }
    generateTraitsList(squad) {
        var traits = new Array();
        squad.forEach((nft)=>{
            if (nft.traits !== undefined) nft.traits.forEach((trait)=>{
                traits.push({
                    collection: nft.nft_collection,
                    id: nft.nft_id,
                    type: trait.trait_type,
                    trait: trait.value
                });
            });
        });
        return traits;
    }
}
$95f314ec8ce1be9b$var$BotService._instance = new $95f314ec8ce1be9b$var$BotService();
var $95f314ec8ce1be9b$export$2e2bcd8739ae039 = $95f314ec8ce1be9b$var$BotService;




class $a8e8b7ed383db386$var$PVPServerService {
    constructor(){
        this._isLocalServer = false;
        if ($a8e8b7ed383db386$var$PVPServerService._instance) throw new Error("Error: Instantiation failed: Use PVPServerService.getInstance() instead of new.");
        $a8e8b7ed383db386$var$PVPServerService._instance = this;
        if (this._isLocalServer) this.client = new (0, $243a0fb2392e59c4$exports.Client)("ws://localhost:8001");
        else {
            this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
            const wsEndpoint = this._config.websockets["pvp"];
            if (wsEndpoint) this.client = new (0, $243a0fb2392e59c4$exports.Client)(`${this._config.websockets.base}${wsEndpoint.path}`);
        }
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Events.EventEmitter();
    }
    static getInstance() {
        return $a8e8b7ed383db386$var$PVPServerService._instance;
    }
    join(playerData) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            // Prevents player from running pvp games using the same wallet
            var isDuplicateWallet = false;
            yield this.client.getAvailableRooms("pvp").then((rooms)=>{
                rooms.forEach((room)=>{
                    var _a;
                    if (((_a = room.metadata) === null || _a === void 0 ? void 0 : _a.hostWallet) === playerData.wallet) isDuplicateWallet = true;
                });
            });
            if (isDuplicateWallet) return;
            // gets player total pvp health
            if (!playerData || !playerData.squadMembers) return Promise.reject();
            var hp = 1000;
            if (!(0, $2e76b527e9362cab$export$fbc1ed301237afc4)) hp = playerData.squadMembers.map((sm)=>{
                return sm.hp;
            }).reduce((previous, current)=>{
                return previous + current;
            }) || 1000;
            // Adds 10% Payout for Brawler Cage
            playerData.brawlerCage = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().ownsBrawlerCage();
            return this.client.joinOrCreate("pvp", {
                player: playerData,
                maxHealth: hp,
                wallet: (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()
            }).then((room)=>{
                this.room = room;
                this.room.state.listen("round", ()=>{
                    this.events.emit("round-complete");
                });
                this.room.state.listen("countDown", (value)=>{
                    var _a;
                    this.events.emit("timer", value);
                    if (value == 0) {
                        var currentPlayer;
                        (_a = this.room) === null || _a === void 0 || _a.state.players.forEach((player)=>{
                            if (player.wallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) currentPlayer = player;
                        });
                        if (currentPlayer.playerAction.playerAction === "") this.playAction("pvpidle");
                    }
                });
                this.room.state.listen("botTimer", (value)=>{
                    this.events.emit("botTimer", value);
                });
                this.room.state.listen("isBotMatch", (isBotMatch)=>{
                    var _a;
                    if (isBotMatch && ((_a = this.room) === null || _a === void 0 ? void 0 : _a.state.gameState) === (0, $f244a5791b15a233$export$eb5ccdbd077479c).WaitingForOpponent) this.joinBot();
                });
                this.room.state.listen("gameState", (value)=>{
                    this.handleGameStateUpdate(value);
                });
                this.room.state.players.onAdd = (player, key)=>{
                    player.listen("actionValid", ()=>{
                        this.actionSubmitted(player.wallet, player.actionValid);
                    });
                };
                return Promise.resolve(this.room);
            });
        });
    }
    joinBot() {
        // Create a PVP Bot to add to the game. Default to my dev account wallet currently
        var _botData = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync();
        _botData.squadMembers = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSquadSync();
        // gets player total pvp health
        if (!_botData || !_botData.squadMembers) return Promise.reject();
        var hp = 1000;
        if (!(0, $2e76b527e9362cab$export$fbc1ed301237afc4)) hp = _botData.squadMembers.map((sm)=>{
            return sm.hp;
        }).reduce((previous, current)=>{
            return previous + current;
        }) || 1000;
        return this.client.join("pvp", {
            player: _botData,
            maxHealth: hp,
            wallet: _botData.wallet
        });
    }
    actionSubmitted(wallet, actionValid) {
        this.events.emit("action-submitted", {
            submitterWallet: wallet,
            isActionValid: actionValid
        });
    }
    leave() {
        var _a;
        (_a = this.room) === null || _a === void 0 || _a.leave();
        this.events.removeAllListeners();
    }
    getRoom() {
        return this.room;
    }
    getGameState() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state;
    }
    getPVPRoomRank(playerLevel) {
        switch(true){
            case playerLevel <= 10:
                return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Bronze;
            case playerLevel > 10 && playerLevel <= 30:
                return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Silver;
            case playerLevel > 30 && playerLevel <= 50:
                return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Gold;
            case playerLevel > 50 && playerLevel <= 70:
                return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Platinum;
            case playerLevel > 70:
                return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Diamond;
        }
        return (0, $f244a5791b15a233$export$c36edca8f8f0427a).Undefined;
    }
    handleGameStateUpdate(state) {
        var _a, _b;
        var player1 = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.players.at(0);
        var player2 = (_b = this.room) === null || _b === void 0 ? void 0 : _b.state.players.at(1);
        switch(state){
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).Player1Win:
                this.events.emit("game-over", {
                    state: state,
                    winningWallet: player1 === null || player1 === void 0 ? void 0 : player1.wallet,
                    neonGoldBoost: typeof (player1 === null || player1 === void 0 ? void 0 : player1.traits.neonGoldBoostValue) === "undefined" ? 1250 : player1 === null || player1 === void 0 ? void 0 : player1.traits.neonGoldBoostValue,
                    spaceElixirBoost: typeof (player1 === null || player1 === void 0 ? void 0 : player1.traits.spaceElixirBoostValue) === "undefined" ? 1250 : player1 === null || player1 === void 0 ? void 0 : player1.traits.spaceElixirBoostValue,
                    starDust: typeof (player1 === null || player1 === void 0 ? void 0 : player1.traits.starDustBoostValue) === "undefined" ? (player2 === null || player2 === void 0 ? void 0 : player2.isBot) ? 0 : 5 : (player2 === null || player2 === void 0 ? void 0 : player2.isBot) ? 0 : player1 === null || player1 === void 0 ? void 0 : player1.traits.starDustBoostValue
                });
                break;
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).Player2Win:
                this.events.emit("game-over", {
                    state: state,
                    winningWallet: player2 === null || player2 === void 0 ? void 0 : player2.wallet,
                    neonGoldBoost: typeof (player2 === null || player2 === void 0 ? void 0 : player2.traits.neonGoldBoostValue) === "undefined" ? 1500 : player2 === null || player2 === void 0 ? void 0 : player2.traits.neonGoldBoostValue,
                    spaceElixirBoost: typeof (player2 === null || player2 === void 0 ? void 0 : player2.traits.spaceElixirBoostValue) === "undefined" ? 1500 : player2 === null || player2 === void 0 ? void 0 : player2.traits.spaceElixirBoostValue,
                    //starDust: player2?.isBot ? 0 : 5,
                    starDust: typeof (player2 === null || player2 === void 0 ? void 0 : player2.traits.starDustBoostValue) === "undefined" ? (player2 === null || player2 === void 0 ? void 0 : player2.isBot) ? 0 : 5 : (player2 === null || player2 === void 0 ? void 0 : player2.isBot) ? 0 : player2 === null || player2 === void 0 ? void 0 : player2.traits.starDustBoostValue
                });
                break;
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).Tie:
                this.events.emit("game-over", {
                    state: state
                });
                break;
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).IdleTie:
                this.events.emit("game-over", {
                    state: state
                });
                break;
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).Playing:
                this.events.emit("game-started", (0, $f244a5791b15a233$export$eb5ccdbd077479c).Playing);
                break;
            case (0, $f244a5791b15a233$export$eb5ccdbd077479c).WaitingForOpponent:
                this.events.emit("game-waiting", (0, $f244a5791b15a233$export$eb5ccdbd077479c).WaitingForOpponent);
                break;
        }
    }
    playAction(action) {
        if (!this.room) return;
        this.room.send("play-action", {
            wallet: (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress(),
            playerAction: action
        });
    }
    onWaitingForOpponent(cb, context) {
        this.events.on("game-waiting", cb, context);
    }
    onGameStarted(cb, context) {
        this.events.on("game-started", cb, context);
    }
    onRoundComplete(cb, context) {
        this.events.on("round-complete", cb, context);
    }
    onGameOver(cb, context) {
        this.events.on("game-over", cb, context);
    }
    onTimerCountdown(cb, context) {
        this.events.on("timer", cb, context);
    }
    onActionSubmitted(cb, context) {
        this.events.on("action-submitted", cb, context);
    }
    onBotTimerCountdown(cb, context) {
        this.events.on("botTimer", cb, context);
    }
}
$a8e8b7ed383db386$var$PVPServerService._instance = new $a8e8b7ed383db386$var$PVPServerService();
var $a8e8b7ed383db386$export$2e2bcd8739ae039 // attempt at matchmaking ranks
 /*var joined = false;

        var roomsAvailable = await (await this.client.getAvailableRooms("pvp")).length;
        console.log("Rooms Available: " +  roomsAvailable)

        if (roomsAvailable != 0) { //we have rooms. need to check if a current room has the right rank to match if not create another room
            this.client.getAvailableRooms("pvp").then(rooms => {
                var joined = false;
                rooms.forEach((room) => {

                    console.log("RoomId: " + room.roomId + " Metadata: " + room.metadata?.rank);
                    
                    if (room.metadata?.rank == 1) { // = players rank
                        console.log("Found Ranked Game");
                        var room1 = this.client.joinById(room.roomId)
                        this.room = room1 as Room<IPVPState>;
                    }

                    /*if (room.metadata?.rank == 1) {
                        console.log("Found Ranked Game");
                        //this.client.joinById(room.roomId);

                        this.client.joinById(room.roomId).then(room => {
                            console.log("joinById");
                            var joinedRoom = room as Room<IPVPState>;

                            joinedRoom.state.onChange = (changes) => {
                                changes.forEach(change => {
                                    const { field, value } = change
                                    console.log(change)
                                    switch (field) {
                                        case 'roundState':
                                            if (value == RoundState.Complete) {
                                                this.events.emit('round-complete', this.room?.state)
                                            }
                                            break;
                    
                                        case 'gameState':
                                            this.handleGameStateUpdate(value)
                                            break;
                    
                                        case 'countDown':
                                            this.events.emit("timer", value)
                                            if (value == 0) {
                                                if (this.room?.state.player1Action.playerAction == '') {
                                                    this.playAction('pvpidle')
                                                } else if (this.room?.state.player2Action.playerAction == '') {
                                                    this.playAction('pvpidle')
                                                }
                                            }
                                            break;
                    
                                    }
                                })

                            }

                            this.events.emit('game-started', GameState.Playing)
                            return;

                            //joinedRoom.state.gameState = GameState.Playing;

                            //this.room? = room;
                            //room.state.gameState = GameState.Playing;
                        });
                        joined = true;
                        return;
                    }
                })

                if (!joined) {
                    this.createRoom(2);
                }

            })
        } else { // room size == 0 so create room
            console.log("No room available")
            this.createRoom(1);
        }*/  = $a8e8b7ed383db386$var$PVPServerService;






const $15066080e676c08f$var$componentWidth = 261;
const $15066080e676c08f$var$componentHeight = 49;
const $15066080e676c08f$var$componentRadius = 12;
const $15066080e676c08f$var$componentColor = 0x262637;
const $15066080e676c08f$var$componentAlpha = 1;
class $15066080e676c08f$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            width: paneScale * $15066080e676c08f$var$componentWidth,
            height: paneScale * $15066080e676c08f$var$componentHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._squadMember = data;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        var _a;
        // Background
        const background = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($15066080e676c08f$var$componentWidth), this.applyScale($15066080e676c08f$var$componentHeight), this.applyScale($15066080e676c08f$var$componentRadius), $15066080e676c08f$var$componentColor, $15066080e676c08f$var$componentAlpha);
        this.addBackground(background);
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this.getImageKey(this._squadMember));
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 8;
        this._squadMemberImage = this.scene.add.rexCircleMaskImage(0, 0, this.getImageKey(this._squadMember), "", rectConfig);
        this._squadMemberImage.displayHeight = this.applyScale(33);
        this._squadMemberImage.scaleX = this._squadMemberImage.scaleY;
        smImageData.destroy();
        this.add(this._squadMemberImage, {
            key: `squad-member-image`,
            align: "left-center",
            offsetX: scene.applyScale(9),
            offsetY: 0,
            expand: false
        });
        // Squad Member Label
        this._squadMemberLabel = scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName().toUpperCase(), this.applyScale(15), 0).setOrigin(0, 0.5);
        this.add(this._squadMemberLabel, {
            key: `squad-member-label`,
            align: "left-top",
            offsetX: scene.applyScale(52),
            offsetY: scene.applyScale(7),
            expand: false
        });
        // Squad Memmber HP Label
        this._hpLabel = scene.add.bitmapText(0, 0, "cc_outline", `HP: ${((_a = this._squadMember.hp) === null || _a === void 0 ? void 0 : _a.toString()) || "0"}`, this.applyScale(14), 0);
        this._hpLabel.alpha = 0.4;
        this.add(this._hpLabel, {
            key: `squad-member-hp-label`,
            align: "left-bottom",
            offsetX: scene.applyScale(52),
            offsetY: scene.applyScale(-7),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getImageKey(squadMem) {
        if (squadMem.image_thumbnail_url && squadMem.image_thumbnail_url.length > 0 && squadMem.image_key && squadMem.image_key.length > 0) return squadMem.image_key;
        else return "starwolf_silhouette";
    }
    getDisplayName() {
        if (this._squadMember.display_name.length === 0) return "Mystery Wolf ???";
        if (this._squadMember.nft_collection) switch(this._squadMember.nft_collection){
            case "Star Wolvez Genesis":
                return `Genesis Wolf #${this._squadMember.nft_id}`;
            case "GalacticApes":
                return `Galactic Ape #${parseInt(this._squadMember.nft_id) + 1}`;
            case "Satoshi Runners Genesis":
                return `Satoshi Run... #${this._squadMember.nft_id}`;
            default:
                return this._squadMember.display_name;
        }
        return this._squadMember.display_name;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("pvpSquadMemberComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $15066080e676c08f$export$2e2bcd8739ae039(this.scene, x, y, data));
});





const $86e0416011c6fd43$var$paneWidth = 294;
const $86e0416011c6fd43$var$paneHeight = 728; // Special Traits section is 94px - to be added later
const $86e0416011c6fd43$var$paneRadius = 16;
const $86e0416011c6fd43$var$paneColor = 0x1c1c2c;
const $86e0416011c6fd43$var$paneAlpha = 1;
const $86e0416011c6fd43$var$paneCellHeight = 60;
const $86e0416011c6fd43$var$pfpWidth = 262;
const $86e0416011c6fd43$var$pfpRadius = 20;
const $86e0416011c6fd43$var$progressBarWidth = 238;
const $86e0416011c6fd43$var$progressBarHeight = 22;
const $86e0416011c6fd43$var$progressBarRadius = 7;
const $86e0416011c6fd43$var$progressBarBackgroundColor = 0xb48dc7;
const $86e0416011c6fd43$var$progressBarBackgroundAlpha = 0.48;
const $86e0416011c6fd43$var$hpProgressBarColor = 0x00a6d3;
const $86e0416011c6fd43$var$hpProgressBarAlpha = 1;
const $86e0416011c6fd43$var$apProgressBarColor = 0x9f0a76;
const $86e0416011c6fd43$var$apProgressBarAlpha = 1;
const $86e0416011c6fd43$var$glareHeight = 6;
const $86e0416011c6fd43$var$glareColor = 0xffffff;
const $86e0416011c6fd43$var$glareAlpha = 0.17;
const $86e0416011c6fd43$var$glareOffset = 6;
const $86e0416011c6fd43$var$glareRadius = 3;
class $86e0416011c6fd43$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            width: paneScale * $86e0416011c6fd43$var$paneWidth,
            height: paneScale * $86e0416011c6fd43$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._playerData = data;
        this._traits = data.traits;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        var _a, _b, _c, _d;
        // Background
        const background = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($86e0416011c6fd43$var$paneWidth), this.applyScale($86e0416011c6fd43$var$paneHeight), this.applyScale($86e0416011c6fd43$var$paneRadius), $86e0416011c6fd43$var$paneColor, $86e0416011c6fd43$var$paneAlpha);
        this.addBackground(background);
        // PFP Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const pfpImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this.getImageKey(this._playerData.squadMembers[0]));
        const pfpImageWidth = pfpImageData.width;
        rectConfig.radius = pfpImageWidth / 8;
        // Sets PFP based on if Player is a bot or not.
        var imageKey = this.getImageKey(this._playerData.squadMembers[0]);
        this._pfpImage = this.scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        this._pfpImage.displayWidth = this.applyScale($86e0416011c6fd43$var$pfpWidth);
        this._pfpImage.scaleY = this._pfpImage.scaleX;
        pfpImageData.destroy();
        this.add(this._pfpImage, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: this.applyScale(18),
                bottom: this.applyScale(18)
            },
            key: "pfp_image"
        });
        // Player Label
        const usernameLabel = this.scene.add.bitmapText(0, 0, "cc_outline", this.getUserName(this._playerData), this.applyScale(18), 0);
        this.add(usernameLabel, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "username-label"
        });
        // Divider
        const divider = this.scene.add.image(0, 0, "pvp_player_divider").setScale(this._scale);
        this.add(divider, {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "upper-divider"
        });
        // Progress Bars (HP/AP)
        // HP
        this._maxHp = 1000;
        if (!(0, $2e76b527e9362cab$export$fbc1ed301237afc4)) this._maxHp = (_a = this._playerData) === null || _a === void 0 ? void 0 : _a.squadMembers.map((sm)=>{
            return sm.hp || 0;
        }).reduce((previous, current)=>{
            return previous + current;
        });
        if (this._playerData.health !== undefined) this._maxHp = this._playerData.health;
        this._currentHp = this._maxHp;
        this._hpProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: ""
            },
            icon: {
                key: "pvp_hp_icon",
                space: 8,
                scale: 0.5
            },
            progressBar: {
                text: `${this._currentHp} / ${this._maxHp}`,
                width: $86e0416011c6fd43$var$progressBarWidth,
                height: $86e0416011c6fd43$var$progressBarHeight,
                radius: $86e0416011c6fd43$var$progressBarRadius,
                color: $86e0416011c6fd43$var$hpProgressBarColor,
                alpha: $86e0416011c6fd43$var$hpProgressBarAlpha,
                backgroundColor: $86e0416011c6fd43$var$progressBarBackgroundColor,
                backgroundAlpha: $86e0416011c6fd43$var$progressBarBackgroundAlpha,
                minValue: 0,
                maxValue: this._maxHp,
                progressValue: this._currentHp,
                glare: {
                    height: $86e0416011c6fd43$var$glareHeight,
                    width: $86e0416011c6fd43$var$progressBarWidth - $86e0416011c6fd43$var$glareOffset,
                    radius: $86e0416011c6fd43$var$glareRadius,
                    color: $86e0416011c6fd43$var$glareColor,
                    alpha: $86e0416011c6fd43$var$glareAlpha
                }
            }
        });
        this.scene.add.existing(this._hpProgressBar);
        this.add(this._hpProgressBar, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: this.applyScale(18),
                bottom: 0
            },
            key: "hp-progress-bar"
        });
        // AP
        this._maxAp = 1000;
        this._currentAp = 100;
        this._apProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: ""
            },
            icon: {
                key: "pvp_ap_icon",
                space: 8,
                scale: 0.5
            },
            progressBar: {
                text: this._currentAp,
                width: $86e0416011c6fd43$var$progressBarWidth,
                height: $86e0416011c6fd43$var$progressBarHeight,
                radius: $86e0416011c6fd43$var$progressBarRadius,
                color: $86e0416011c6fd43$var$apProgressBarColor,
                alpha: $86e0416011c6fd43$var$apProgressBarAlpha,
                backgroundColor: $86e0416011c6fd43$var$progressBarBackgroundColor,
                backgroundAlpha: $86e0416011c6fd43$var$progressBarBackgroundAlpha,
                minValue: 0,
                maxValue: this._maxAp,
                progressValue: this._currentAp,
                glare: {
                    height: $86e0416011c6fd43$var$glareHeight,
                    width: $86e0416011c6fd43$var$progressBarWidth - $86e0416011c6fd43$var$glareOffset,
                    radius: $86e0416011c6fd43$var$glareRadius,
                    color: $86e0416011c6fd43$var$glareColor,
                    alpha: $86e0416011c6fd43$var$glareAlpha
                }
            }
        });
        this.scene.add.existing(this._apProgressBar);
        this.add(this._apProgressBar, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: this.applyScale(18),
                bottom: 0
            },
            key: "hp-progress-bar"
        });
        // Divider
        const lowerDivider = this.scene.add.image(0, 0, "pvp_player_divider").setScale(this._scale);
        this.add(lowerDivider, {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(18),
                bottom: this.applyScale(18)
            },
            key: "lower-divider"
        });
        // Active Squad Pane
        const activeSquadLabel = this.scene.add.bitmapText(0, 0, "cc_outline", "Active Squad", this.applyScale(17), 0).setAlpha(0.5);
        this.add(activeSquadLabel, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: this.applyScale(12)
            },
            key: "active-squad-label"
        });
        const sm1 = new (0, $15066080e676c08f$export$2e2bcd8739ae039)(this.scene, 0, 0, ((_b = this._playerData) === null || _b === void 0 ? void 0 : _b.squadMembers[0]) || {
            display_name: "Genesis Wolf #001",
            image_key: "starwolf_silhouette",
            hp: 1000
        }, this._scale);
        const sm2 = new (0, $15066080e676c08f$export$2e2bcd8739ae039)(this.scene, 0, 0, ((_c = this._playerData) === null || _c === void 0 ? void 0 : _c.squadMembers[1]) || {
            display_name: "Star Wolf #101",
            image_key: "starwolf_silhouette",
            hp: 1000
        }, this._scale);
        const sm3 = new (0, $15066080e676c08f$export$2e2bcd8739ae039)(this.scene, 0, 0, ((_d = this._playerData) === null || _d === void 0 ? void 0 : _d.squadMembers[2]) || {
            display_name: "Star Wolf #102",
            image_key: "starwolf_silhouette",
            hp: 1000
        }, this._scale);
        this.scene.add.existing(sm1);
        this.scene.add.existing(sm2);
        this.scene.add.existing(sm3);
        this.add(sm1, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: this.applyScale(10)
            },
            key: "squad-member-1"
        });
        this.add(sm2, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: this.applyScale(10)
            },
            key: "squad-member-2"
        });
        this.add(sm3, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "squad-member-3"
        });
        // divider
        const lowestDivider = this.scene.add.image(0, 0, "pvp_player_divider").setScale(this._scale);
        this.add(lowestDivider, {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(18),
                bottom: this.applyScale(18)
            },
            key: "lowest-divider"
        });
        // Special Traits Pane
        const specialTraitsLabel = this.scene.add.bitmapText(0, 0, "cc_outline", "Special Traits", this.applyScale(17), 0).setAlpha(0.5);
        this.add(specialTraitsLabel, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: this.applyScale(12)
            },
            key: "special-traits-label"
        });
        const traitsList = (0, $5f7ad9227787a545$export$2f0579b0e62bae17)(this._traits);
        const table = this.createTraitsTable(this.scene, traitsList, x, y).layout();
        this.add(table, {
            padding: {
                left: this.applyScale(16),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "traits_table"
        });
        this.layout();
    }
    getImageKey(squadMem) {
        if (squadMem.image_thumbnail_url && squadMem.image_thumbnail_url.length > 0 && squadMem.image_key && squadMem.image_key.length > 0) return squadMem.image_key;
        else return "starwolf_silhouette";
    }
    getUserName(user) {
        if (user && user.name && user.name.length > 0) {
            if (user.name.toUpperCase() === "LUKE" || user.name.toUpperCase() === "LUKEH") {
                var hasImages = this._playerData.squadMembers.find((mem)=>mem.image_thumbnail_url.length > 0);
                if (!hasImages) return "PvP Bot";
            }
            return user.name.toUpperCase();
        } else return "Unknown";
    }
    createTraitsTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($86e0416011c6fd43$var$paneWidth),
            height: this.applyScale($86e0416011c6fd43$var$paneCellHeight * 2),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(269),
                cellHeight: this.applyScale(60),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var _a, _b;
                var scene = cell.scene, trait = cell.item;
                // Sizer variables
                const componentWidth = 261, componentHeight = 49, componentRadius = 12, componentColor = 0x262637, componentAlpha = 1;
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(componentWidth),
                    height: scene.applyScale(componentHeight),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                })// Background
                .add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(componentWidth), scene.applyScale(componentHeight), scene.applyScale(componentRadius), componentColor, componentAlpha), {
                    key: "trait_cell_bg",
                    align: "center"
                })// Special Trait Label
                .add(scene.add.bitmapText(0, 0, "cc_outline", ((_a = trait.trait) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + " #" + trait.id, scene.applyScale(15), 0), {
                    key: `special-trait-label`,
                    align: "left-top",
                    offsetX: scene.applyScale(9),
                    offsetY: scene.applyScale(7),
                    expand: false
                })// Special Trait Description Label
                .add(scene.add.bitmapText(0, 0, "cc_outline", (_b = trait.description) === null || _b === void 0 ? void 0 : _b.toString(), scene.applyScale(14), 0).setAlpha(0.4), {
                    key: `special-trait-description-label`,
                    align: "left-bottom",
                    offsetX: scene.applyScale(9),
                    offsetY: scene.applyScale(-7),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    updateProgressBars(hp, ap) {
        if (hp) {
            this._currentHp = hp;
            this._hpProgressBar.setProgress(this, hp);
        }
        if (ap || ap === 0) {
            this._currentAp = ap;
            this._apProgressBar.setProgress(this, ap);
        }
    }
    resetProgressBars(hp, ap) {
        if (hp) {
            this._currentHp = hp;
            this._hpProgressBar.updateMaxValue(this, hp);
            this._hpProgressBar.setProgress(this, hp);
        }
        if (ap) {
            this._currentAp = ap;
            this._apProgressBar.setProgress(this, ap);
        }
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("pvpPlayerPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $86e0416011c6fd43$export$2e2bcd8739ae039(this.scene, x, y));
});








var $4cefe40a6c764e21$export$eb5ccdbd077479c;
(function(GameState) {
    GameState[GameState["GameEmpty"] = 0] = "GameEmpty";
    GameState[GameState["WaitingForOpponent"] = 1] = "WaitingForOpponent";
    GameState[GameState["Playing"] = 2] = "Playing";
    GameState[GameState["Tie"] = 3] = "Tie";
    GameState[GameState["IdleTie"] = 4] = "IdleTie";
    GameState[GameState["Player1Win"] = 5] = "Player1Win";
    GameState[GameState["Player2Win"] = 6] = "Player2Win";
})($4cefe40a6c764e21$export$eb5ccdbd077479c || ($4cefe40a6c764e21$export$eb5ccdbd077479c = {}));
var $4cefe40a6c764e21$export$da63e7f9fc855de4;
(function(RoundState) {
    RoundState[RoundState["Start"] = 0] = "Start";
    RoundState[RoundState["Complete"] = 1] = "Complete";
})($4cefe40a6c764e21$export$da63e7f9fc855de4 || ($4cefe40a6c764e21$export$da63e7f9fc855de4 = {}));
var $4cefe40a6c764e21$export$4fd348e78734ce17;
(function(MatchRoundState) {
    MatchRoundState[MatchRoundState["Start"] = 0] = "Start";
    MatchRoundState[MatchRoundState["Complete"] = 1] = "Complete";
})($4cefe40a6c764e21$export$4fd348e78734ce17 || ($4cefe40a6c764e21$export$4fd348e78734ce17 = {}));
var $4cefe40a6c764e21$export$c36edca8f8f0427a;
(function(Rank) {
    Rank[Rank["Undefined"] = 0] = "Undefined";
    Rank[Rank["Bronze"] = 1] = "Bronze";
    Rank[Rank["Silver"] = 2] = "Silver";
    Rank[Rank["Gold"] = 3] = "Gold";
    Rank[Rank["Platinum"] = 4] = "Platinum";
    Rank[Rank["Diamond"] = 5] = "Diamond";
})($4cefe40a6c764e21$export$c36edca8f8f0427a || ($4cefe40a6c764e21$export$c36edca8f8f0427a = {}));







class $da3d4b8200dd7026$var$PVEServerService {
    constructor(){
        this._isLocalServer = false;
        if ($da3d4b8200dd7026$var$PVEServerService._instance) throw new Error("Error: Instantiation failed: Use PVEServerService.getInstance() instead of new.");
        $da3d4b8200dd7026$var$PVEServerService._instance = this;
        if (this._isLocalServer) this.client = new (0, $243a0fb2392e59c4$exports.Client)("ws://localhost:8002");
        else {
            this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
            const wsEndpoint = this._config.websockets["pve"];
            if (wsEndpoint) this.client = new (0, $243a0fb2392e59c4$exports.Client)(`${this._config.websockets.base}${wsEndpoint.path}`);
        }
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Events.EventEmitter();
    }
    static getInstance() {
        return $da3d4b8200dd7026$var$PVEServerService._instance;
    }
    join(playerData) {
        // gets player total pve health
        if (!playerData || !playerData.squadMembers) return Promise.reject();
        var hp = 300;
        if (!(0, $2e76b527e9362cab$export$fbc1ed301237afc4)) hp = playerData.squadMembers.map((sm)=>{
            return sm.hp;
        }).reduce((previous, current)=>{
            return previous + current;
        }) || 300;
        // Adds 10% Payout for Brawler Cage
        playerData.brawlerCage = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().ownsBrawlerCage();
        return this.client.create("pve", {
            player: playerData,
            maxHealth: hp,
            wallet: (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()
        }).then((room)=>{
            this.room = room;
            this.room.state.listen("matchRoundState", (value)=>{
                this.handleMatchRoundStateUpdate(value);
            });
            this.room.state.listen("round", ()=>{
                this.events.emit("round-complete");
            });
            this.room.state.listen("gameState", (value)=>{
                this.handleGameStateUpdate(value);
            });
            this.room.state.players.onAdd = (player, key)=>{
                player.listen("actionValid", ()=>{
                    this.actionSubmitted(player.wallet, player.actionValid);
                });
            };
            return Promise.resolve(this.room);
        });
    }
    joinBot() {
        // Create a PVE Bot to add to the game. Default to my dev account wallet currently
        var _botData = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync();
        _botData.squadMembers = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSquadSync();
        // gets Bot total pve health
        if (!_botData || !_botData.squadMembers) return Promise.reject();
        var hp = 300;
        if (!(0, $2e76b527e9362cab$export$fbc1ed301237afc4)) hp = _botData.squadMembers.map((sm)=>{
            return sm.hp;
        }).reduce((previous, current)=>{
            return previous + current;
        }) || 300;
        return this.client.join("pve", {
            player: _botData,
            maxHealth: hp
        });
    }
    actionSubmitted(wallet, actionValid) {
        this.events.emit("action-submitted", {
            submitterWallet: wallet,
            isActionValid: actionValid
        });
    }
    leave() {
        var _a;
        (_a = this.room) === null || _a === void 0 || _a.leave();
        this.events.removeAllListeners();
    }
    getRoom() {
        return this.room;
    }
    getGameState() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.state;
    }
    getPVPRoomRank(playerLevel) {
        switch(true){
            case playerLevel <= 10:
                return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Bronze;
            case playerLevel > 10 && playerLevel <= 30:
                return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Silver;
            case playerLevel > 30 && playerLevel <= 50:
                return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Gold;
            case playerLevel > 50 && playerLevel <= 70:
                return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Platinum;
            case playerLevel > 70:
                return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Diamond;
        }
        return (0, $4cefe40a6c764e21$export$c36edca8f8f0427a).Undefined;
    }
    handleGameStateUpdate(state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var player = (_a = this.room) === null || _a === void 0 ? void 0 : _a.state.players.at(0);
        var bot = (_b = this.room) === null || _b === void 0 ? void 0 : _b.state.players.at(1);
        switch(state){
            case (0, $4cefe40a6c764e21$export$eb5ccdbd077479c).Player1Win:
                this.events.emit("game-over", {
                    state: state,
                    winningWallet: player === null || player === void 0 ? void 0 : player.wallet,
                    neonGoldBoost: (_c = this.room) === null || _c === void 0 ? void 0 : _c.state.neonGold,
                    spaceElixirBoost: (_d = this.room) === null || _d === void 0 ? void 0 : _d.state.spaceElixir,
                    starDust: (_e = this.room) === null || _e === void 0 ? void 0 : _e.state.starDust
                });
                break;
            case (0, $4cefe40a6c764e21$export$eb5ccdbd077479c).Player2Win:
                this.events.emit("game-over", {
                    state: state,
                    winningWallet: player === null || player === void 0 ? void 0 : player.wallet,
                    neonGoldBoost: (_f = this.room) === null || _f === void 0 ? void 0 : _f.state.neonGold,
                    spaceElixirBoost: (_g = this.room) === null || _g === void 0 ? void 0 : _g.state.spaceElixir,
                    starDust: (_h = this.room) === null || _h === void 0 ? void 0 : _h.state.starDust
                });
                break;
            case (0, $4cefe40a6c764e21$export$eb5ccdbd077479c).Tie:
                this.events.emit("game-over", {
                    state: state,
                    neonGoldBoost: (_j = this.room) === null || _j === void 0 ? void 0 : _j.state.neonGold,
                    spaceElixirBoost: (_k = this.room) === null || _k === void 0 ? void 0 : _k.state.spaceElixir,
                    starDust: (_l = this.room) === null || _l === void 0 ? void 0 : _l.state.starDust
                });
                break;
            case (0, $4cefe40a6c764e21$export$eb5ccdbd077479c).Playing:
                this.events.emit("game-started", (0, $4cefe40a6c764e21$export$eb5ccdbd077479c).Playing);
                break;
        }
    }
    handleMatchRoundStateUpdate(state) {
        switch(state){
            case (0, $4cefe40a6c764e21$export$4fd348e78734ce17).Start:
                this.events.emit("match-round-start");
                break;
            case (0, $4cefe40a6c764e21$export$4fd348e78734ce17).Complete:
                this.events.emit("match-round-complete");
                break;
        }
    }
    playAction(action) {
        if (!this.room) return;
        this.room.send("play-action", {
            wallet: (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress(),
            playerAction: action
        });
    }
    startNextMatchRound() {
        if (!this.room) return;
        this.room.send("match-continue", {});
    }
    onMatchRoundStart(cb, context) {
        this.events.on("match-round-start", cb, context);
    }
    onMatchRoundComplete(cb, context) {
        this.events.on("match-round-complete", cb, context);
    }
    onGameStarted(cb, context) {
        this.events.on("game-started", cb, context);
    }
    onRoundComplete(cb, context) {
        this.events.on("round-complete", cb, context);
    }
    onGameOver(cb, context) {
        this.events.on("game-over", cb, context);
    }
    onActionSubmitted(cb, context) {
        this.events.on("action-submitted", cb, context);
    }
}
$da3d4b8200dd7026$var$PVEServerService._instance = new $da3d4b8200dd7026$var$PVEServerService();
var $da3d4b8200dd7026$export$2e2bcd8739ae039 = $da3d4b8200dd7026$var$PVEServerService;


const $9f3c1f58fed62fad$var$paneWidth = 685;
const $9f3c1f58fed62fad$var$paneHeight = 108;
const $9f3c1f58fed62fad$var$paneRadius = 16;
const $9f3c1f58fed62fad$var$paneColor = 0x1c1c2c;
const $9f3c1f58fed62fad$var$paneAlpha = 1;
const $9f3c1f58fed62fad$var$heavyOffset = 29;
const $9f3c1f58fed62fad$var$lightOffset = 153;
const $9f3c1f58fed62fad$var$defendOffset = 269;
const $9f3c1f58fed62fad$var$restoreOffset = 367;
const $9f3c1f58fed62fad$var$healOffset = 471;
const $9f3c1f58fed62fad$var$surrenderOffset = 550;
const $9f3c1f58fed62fad$var$buttonMargin = 13;
const $9f3c1f58fed62fad$var$outerMargin = 40;
class $9f3c1f58fed62fad$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            width: paneScale * $9f3c1f58fed62fad$var$paneWidth,
            height: paneScale * $9f3c1f58fed62fad$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._serverType = data.serverType;
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($9f3c1f58fed62fad$var$paneWidth), this.applyScale($9f3c1f58fed62fad$var$paneHeight), this.applyScale($9f3c1f58fed62fad$var$paneRadius), $9f3c1f58fed62fad$var$paneColor, $9f3c1f58fed62fad$var$paneAlpha);
        this.addBackground(background);
        // Heavy Attack Button
        this._heavyAttackButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_heavy_attack_button", false).setScale(this._scale);
        this._heavyAttackButton.setDisabledTexture("pvp_heavy_attack_button_disabled");
        this._heavyAttackButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvpheavy");
        });
        this.scene.add.existing(this._heavyAttackButton);
        this.add(this._heavyAttackButton, {
            key: "heavy-attack-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$heavyOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Light Attack Button
        this._lightAttackButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_light_attack_button", false).setScale(this._scale);
        this._lightAttackButton.setDisabledTexture("pvp_light_attack_button_disabled");
        this._lightAttackButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvplight");
        });
        this.scene.add.existing(this._lightAttackButton);
        this.add(this._lightAttackButton, {
            key: "light-attack-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$lightOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Defend Button
        this._defendButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_defend_button", false).setScale(this._scale);
        this._defendButton.setDisabledTexture("pvp_defend_button_disabled");
        this._defendButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvpdefend");
        });
        this.scene.add.existing(this._defendButton);
        this.add(this._defendButton, {
            key: "defend-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$defendOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Restore Button
        this._restoreButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_restore_button", false).setScale(this._scale);
        this._restoreButton.setDisabledTexture("pvp_restore_button_disabled");
        this._restoreButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvpheal");
        });
        this.scene.add.existing(this._restoreButton);
        this.add(this._restoreButton, {
            key: "restore-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$restoreOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Heal Button
        this._healButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_heal_button", false).setScale(this._scale);
        this._healButton.setDisabledTexture("pvp_heal_button_disabled");
        // disable heal button to start game as player is already at max health
        this._healButton.setDisabled(true);
        this._healButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvpuberheal");
        });
        this.scene.add.existing(this._healButton);
        this.add(this._healButton, {
            key: "heal-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$healOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Surrender Button
        this._surrenderButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "pvp_surrender_button", false).setScale(this._scale);
        this._surrenderButton.setDisabledTexture("pvp_surrender_button_disabled");
        this._surrenderButton.onClick().subscribe((pointer)=>{
            this.handleAction("pvp69");
        });
        this.scene.add.existing(this._surrenderButton);
        this.add(this._surrenderButton, {
            key: "surrender-button",
            align: "left-center",
            offsetX: this.applyScale($9f3c1f58fed62fad$var$surrenderOffset),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    handleAction(action) {
        this.disableButtons();
        if (action === "pvp69") // 'pvp69' === 'surrender' ???
        this.scene.scene.launch("PvpSurrenderScene", {
            serverType: this._serverType
        });
        else if (this._serverType === "pvp") (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().playAction(action);
        else (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().playAction(action);
    }
    applyScale(length) {
        return length * this._scale;
    }
    disableButtons() {
        this._heavyAttackButton.setDisabled(true);
        this._lightAttackButton.setDisabled(true);
        this._defendButton.setDisabled(true);
        this._restoreButton.setDisabled(true);
        this._healButton.setDisabled(true);
        this._surrenderButton.setDisabled(true);
    }
    updateEnabled(player) {
        // Round complete. Enable and Disable based on players action points
        this._heavyAttackButton.setDisabled(this.getButtonDisabled(player, "heavy_attack"));
        this._lightAttackButton.setDisabled(this.getButtonDisabled(player, "light_attack"));
        this._defendButton.setDisabled(this.getButtonDisabled(player, "defend"));
        this._restoreButton.setDisabled(this.getButtonDisabled(player, "restore"));
        this._healButton.setDisabled(this.getButtonDisabled(player, "heal"));
        this._surrenderButton.setDisabled(this.getButtonDisabled(player, "surrender"));
    }
    getButtonDisabled(player, action_name) {
        // Individual button disabled logic
        switch(action_name){
            case "heavy_attack":
                return player.actionPoints < 50 ? true : false;
            case "light_attack":
                return player.actionPoints < 20 ? true : false;
            case "defend":
                return player.actionPoints < 20 ? true : false;
            case "restore":
                return false;
            case "heal":
                if (player.health === player.maxHealth) return true;
                return player.actionPoints < 50 ? true : false;
            case "surrender":
                return false;
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("pvpButtonPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $9f3c1f58fed62fad$export$2e2bcd8739ae039(this.scene, x, y));
});




const $456f00c25efcc44a$var$paneWidth = 685;
const $456f00c25efcc44a$var$paneHeight = 687;
const $456f00c25efcc44a$var$paneRadius = 16;
const $456f00c25efcc44a$var$paneColor = 0x1c1c2c;
const $456f00c25efcc44a$var$paneAlpha = 1;
const $456f00c25efcc44a$var$cellHeight = 58;
const $456f00c25efcc44a$var$tableHeight = 597;
const $456f00c25efcc44a$var$roundNumberColor = 0x75758b;
const $456f00c25efcc44a$var$awaitingActionText = "Awaiting action...";
const $456f00c25efcc44a$var$actionInvalidText = "Action invalid";
const $456f00c25efcc44a$var$actionSubmittedText = "Action submitted";
const $456f00c25efcc44a$var$awaitingActionColor = 0xffd600;
const $456f00c25efcc44a$var$actionSubmittedColor = 0x00ff94;
const $456f00c25efcc44a$var$actionInvalidColor = 0xff0000;
class $456f00c25efcc44a$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            width: paneScale * $456f00c25efcc44a$var$paneWidth,
            height: paneScale * $456f00c25efcc44a$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._battleType = data.battleType;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($456f00c25efcc44a$var$paneWidth), this.applyScale($456f00c25efcc44a$var$paneHeight), this.applyScale($456f00c25efcc44a$var$paneRadius), $456f00c25efcc44a$var$paneColor, $456f00c25efcc44a$var$paneAlpha);
        this.addBackground(background);
        // Vertical Divider
        const divider = this.scene.add.image(0, 0, "pvp_vertical_divider").setScale(this._scale);
        this.add(divider, {
            key: "vertical-divider",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Title Row
        this._titleText = this.scene.add.bitmapText(0, 0, "cc_outline", this._battleType === "pvp" ? "The battle begins..." : "Match Round 1... FIGHT!", this.applyScale(16), 0);
        this.add(this._titleText, {
            key: "title-text",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(15),
            expand: false
        });
        const titleDivider = this.scene.add.image(0, 0, "pvp_game_divider").setScale(this._scale);
        this.add(titleDivider, {
            key: "title-divider",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(45),
            expand: false
        });
        // Actions table
        this._table = this.createTable(this.scene, [
            {
                roundNumber: 1,
                playerAction: "Awaiting action...",
                opponentAction: "Awaiting action..."
            }
        ], 0, 0).layout();
        this.add(this._table, {
            key: "game-table",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(45),
            expand: false
        });
        this.layout();
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($456f00c25efcc44a$var$paneWidth),
            height: this.applyScale($456f00c25efcc44a$var$paneHeight - 45),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($456f00c25efcc44a$var$paneWidth),
                cellHeight: this.applyScale($456f00c25efcc44a$var$cellHeight),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {
                    left: 0,
                    right: 0,
                    bottom: 0
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                function setTextColor(rowItem) {
                    const text = rowItem.text;
                    if (text === $456f00c25efcc44a$var$awaitingActionText) rowItem.setTint($456f00c25efcc44a$var$awaitingActionColor);
                    if (text === $456f00c25efcc44a$var$actionInvalidText) rowItem.setTint($456f00c25efcc44a$var$actionInvalidColor);
                    if (text === $456f00c25efcc44a$var$actionSubmittedText) rowItem.setTint($456f00c25efcc44a$var$actionSubmittedColor);
                    return rowItem;
                }
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($456f00c25efcc44a$var$paneWidth),
                    height: height,
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.roundNumber, scene.applyScale(14), 0).setTint($456f00c25efcc44a$var$roundNumberColor), {
                    key: "round-number-text",
                    align: "left-top",
                    offsetX: scene.applyScale(17),
                    offsetY: scene.applyScale(12),
                    expand: false
                }).add(setTextColor(scene.add.bitmapText(0, 0, "cc_outline", item.playerAction, scene.applyScale(14), 0)), {
                    key: "player-action",
                    align: "left-top",
                    offsetX: scene.applyScale(17),
                    offsetY: scene.applyScale(33),
                    expand: false
                }).add(setTextColor(scene.add.bitmapText(0, 0, "cc_outline", item.opponentAction, scene.applyScale(14), 0)), {
                    key: "opponent-action",
                    align: "left-top",
                    offsetX: scene.applyScale(360),
                    offsetY: scene.applyScale(33),
                    expand: false
                }).add(scene.add.image(0, 0, "pvp_game_divider").setScale(scene.applyScale(1)), {
                    key: "row-divider",
                    align: "center-bottom",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                });
                return sizer;
            }
        });
        return table;
    }
    addRound(round) {
        var roundData = {
            roundNumber: round,
            playerAction: $456f00c25efcc44a$var$awaitingActionText,
            opponentAction: $456f00c25efcc44a$var$awaitingActionText
        };
        var currentItems = this._table.items;
        if (roundData) currentItems.push(roundData);
        this._table.setItems(currentItems).layout().scrollToBottom(); //Refreshes the table UI
    }
    updateExistingRound(updatedRoundData) {
        var currentItems = this._table.items;
        if (updatedRoundData) {
            currentItems.pop();
            currentItems.push(updatedRoundData);
        }
        this._table.setItems(currentItems); //Refreshes the table UI
    }
    clearGameplayLog() {
        this._table.items = [];
        this._table.items.push({
            roundNumber: 1,
            playerAction: "Awaiting action...",
            opponentAction: "Awaiting action..."
        });
        this._table.setItems(this._table.items); //Refreshes the table UI
    }
    updateTitle(text) {
        this._titleText.text = text;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("pvpGamePane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $456f00c25efcc44a$export$2e2bcd8739ae039(this.scene, x, y));
});




const $22153939dd167f91$var$noMember = {
    id: 0,
    nft_collection: "Star Wolvez Generative",
    display_name: "None Selected       ",
    image_key: "starwolf_silhouette",
    hp: 0,
    show_yield: false,
    show_hp: false,
    disabled: true
};
class $22153939dd167f91$var$OpponentService {
    constructor(){
        if ($22153939dd167f91$var$OpponentService._instance) throw new Error("Error: Instantiation failed: Use OpponentService.getInstance() instead of new.");
        $22153939dd167f91$var$OpponentService._instance = this;
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
    }
    static getInstance() {
        return $22153939dd167f91$var$OpponentService._instance;
    }
    getOpponent(wallet, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._opponent && !forceUpdate) return resolve(this._opponent);
            else return resolve(this.fetchOpponent(wallet));
        });
    }
    fetchOpponent(wallet) {
        return this.getUserData(wallet, true).then((userData)=>{
            this._opponent = userData;
            return this.getSquad(wallet, true).then((squad)=>{
                this._opponent.squadMembers = squad;
                return this._opponent;
            });
        });
    }
    getOpponentSync() {
        return this._opponent;
    }
    getTraitsSync() {
        return this._traits;
    }
    getUserData(wallet, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._userData && !forceUpdate) return resolve(this._userData);
            else return resolve(this.fetchUserData(wallet));
        });
    }
    getUserDataSync() {
        return this._userData;
    }
    fetchUserData(wallet) {
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("user", [
            wallet
        ], []).then((res)=>{
            this._userData = res;
            return res;
        });
    }
    setSquad(value) {
        this._squad = value;
    }
    getSquad(wallet, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._squad && !forceUpdate) return resolve(this._squad);
            else return resolve(this.fetchSquad(wallet));
        });
    }
    getSquadSync() {
        return this._squad;
    }
    fetchSquad(wallet) {
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("squad", [
            wallet,
            "mining"
        ], []).then((res)=>{
            return this.enrichSquadData(wallet, res.squad).then((enrichedSquad)=>{
                this._squad = enrichedSquad;
                this._traits = this.generateTraitsList(this._squad);
                return this._squad;
            });
        });
    }
    enrichSquadData(wallet, squadData) {
        return this.getNFTs(wallet, squadData, true).then((nfts)=>{
            if (squadData && squadData.length > 0) {
                const enrichedSquad = squadData.map((squadMember)=>{
                    var nftData = nfts.find((nft)=>{
                        return nft.id === squadMember.marketplace_nft_id;
                    });
                    if (nftData) return Object.assign({}, {
                        position: squadMember.position,
                        squad_type_id: squadMember.squad_type_id
                    }, nftData);
                    return undefined;
                });
                var squadArray = [];
                enrichedSquad.forEach((sqMem)=>{
                    if (sqMem) squadArray[sqMem.position] = sqMem;
                });
                for(var i = 0; i < 3; i++)if (!squadArray[i]) squadArray[i] = Object.assign({}, $22153939dd167f91$var$noMember, {
                    position: i
                });
                return squadArray;
            } else return [
                Object.assign({}, $22153939dd167f91$var$noMember),
                Object.assign({}, $22153939dd167f91$var$noMember),
                Object.assign({}, $22153939dd167f91$var$noMember)
            ];
        });
    }
    getNFTs(wallet, squad, forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._nfts && this._nfts.length > 0 && !forceUpdate) return resolve(this._nfts);
            else return resolve(this.fetchNFTs(wallet, squad));
        });
    }
    fetchNFTs(wallet, squad) {
        var promises = [];
        squad.forEach((squadMember)=>{
            promises.push((0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("nfts", [
                wallet,
                squadMember.marketplace_nft_id
            ], []));
        });
        this._nfts = [];
        return Promise.all(promises).then((responses)=>{
            responses.forEach((res)=>{
                this._nfts.push(this.enrichImageData(res.nfts[0]));
            });
            return this._nfts;
        });
    }
    enrichImageData(nft) {
        nft.image_key = `nft_${nft.id}`;
        return nft;
    }
    generateTraitsList(squad) {
        var traits = new Array();
        squad.forEach((nft)=>{
            if (nft.traits !== undefined) nft.traits.forEach((trait)=>{
                traits.push({
                    collection: nft.nft_collection,
                    id: nft.nft_id,
                    type: trait.trait_type,
                    trait: trait.value
                });
            });
        });
        return traits;
    }
}
$22153939dd167f91$var$OpponentService._instance = new $22153939dd167f91$var$OpponentService();
var $22153939dd167f91$export$2e2bcd8739ae039 = $22153939dd167f91$var$OpponentService;







const $283efebfe660eb78$var$modalHeight = 822;
const $283efebfe660eb78$var$modalWidth = 1393;
const $283efebfe660eb78$var$modalRadius = 16;
const $283efebfe660eb78$var$modalColor = 0x1c1c2c;
const $283efebfe660eb78$var$modalAlpha = 1;
class $283efebfe660eb78$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "PvPScene"
        });
    }
    init(data) {
        this._battle_id = data.battle_id;
    }
    preload() {
        this._gameState = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().getGameState();
        // Image Loading
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59));
        if (this._gameState.isBotMatch) (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync().squadMembers.forEach((sm)=>{
            if (sm.image_key && sm.image_thumbnail_url && sm.image_thumbnail_url.length > 0) this.load.image(sm.image_key, sm.image_thumbnail_url);
        });
        else (0, $22153939dd167f91$export$2e2bcd8739ae039).getInstance().getOpponentSync().squadMembers.forEach((sm)=>{
            if (sm.image_key && sm.image_thumbnail_url && sm.image_thumbnail_url.length > 0) this.load.image(sm.image_key, sm.image_thumbnail_url);
        });
    }
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($283efebfe660eb78$var$modalWidth, $283efebfe660eb78$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $283efebfe660eb78$var$modalWidth * this._scale,
            height: $283efebfe660eb78$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Player Pane
        this._player = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._player.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._player.traits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        this._playerContentPane = new (0, $86e0416011c6fd43$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        this.add.existing(this._playerContentPane);
        sizer.add(this._playerContentPane, {
            key: "player-content-pane",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Game Pane
        this._gamePane = new (0, $456f00c25efcc44a$export$2e2bcd8739ae039)(this, 0, 0, {
            battleType: "pvp"
        }, this._scale);
        this.add.existing(this._gamePane);
        sizer.add(this._gamePane, {
            key: "game-content-pane",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Opponent Pane
        this._opponent = this._gameState.isBotMatch ? (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync() : (0, $22153939dd167f91$export$2e2bcd8739ae039).getInstance().getOpponentSync();
        this._opponent.traits = this._gameState.isBotMatch ? (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getTraitsSync() : (0, $22153939dd167f91$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        this._opponent.health = 1000;
        this._opponentContentPane = new (0, $86e0416011c6fd43$export$2e2bcd8739ae039)(this, 0, 0, this._opponent, this._scale);
        this.add.existing(this._opponentContentPane);
        sizer.add(this._opponentContentPane, {
            key: "opponent-content-pane",
            align: "right-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Button Pane
        this._buttonPane = new (0, $9f3c1f58fed62fad$export$2e2bcd8739ae039)(this, 0, 0, {
            serverType: "pvp"
        }, this._scale);
        this.add.existing(this._buttonPane);
        sizer.add(this._buttonPane, {
            key: "button-content-pane",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Layout the Scene
        sizer.layout();
        // PvP Server Interaction
        (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().onRoundComplete(this.handleRoundComplete, this);
        (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().onGameOver(this.handleGameOver, this);
        (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().onTimerCountdown(this.handleTimer, this);
        (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().onActionSubmitted(this.handleActionSubmitted, this);
        this.scene.get("PvpSurrenderScene").events.on("surrender_cancel_event", ()=>{
            var state = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().getGameState();
            if (state) {
                var user = state.players.find((player)=>{
                    return player.wallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
                });
                this._buttonPane.updateEnabled(user);
            } else console.log("Failed to get game state");
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    handleActionSubmitted(result) {
        const gameState = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().getGameState();
        var actionStatus = result.isActionValid ? "Action submitted" : "Action invalid";
        if (result.isActionValid) {
            if (result.submitterWallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) {
                // disable buttons as action is valid
                this._buttonPane.disableButtons();
                this._gamePane.updateExistingRound({
                    roundNumber: (gameState === null || gameState === void 0 ? void 0 : gameState.round) + 1,
                    playerAction: actionStatus,
                    opponentAction: "Awaiting action..."
                });
            } else // opponent
            this._gamePane.updateExistingRound({
                roundNumber: (gameState === null || gameState === void 0 ? void 0 : gameState.round) + 1,
                playerAction: "Awaiting action...",
                opponentAction: actionStatus
            });
        }
    }
    handleRoundComplete() {
        this._gameState = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().getGameState();
        this.updateUIState(this._gameState);
    }
    updateUIState(state) {
        var user;
        var opponent;
        state.players.forEach((player)=>{
            if (player.wallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) user = player;
            else opponent = player;
        });
        // Update Player and Opponent Panes
        this._playerContentPane.updateProgressBars(user.health, user.actionPoints);
        this._opponentContentPane.updateProgressBars(opponent.health, opponent.actionPoints);
        // Update Button Pane
        this._buttonPane.updateEnabled(user);
        // updates current round data
        this._gamePane.updateExistingRound({
            roundNumber: state.round,
            playerAction: user.roundAction,
            opponentAction: opponent.roundAction
        });
        // create next round
        this._gamePane.addRound(state.round + 1);
    // if player is stunned auto submit their stunned action.
    //if (user.stunned) {PVPServer.getInstance().playAction('pvpstunned')}
    }
    handleGameOver(result) {
        (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().leave();
        if (result.state == (0, $f244a5791b15a233$export$eb5ccdbd077479c).IdleTie) {
            this.scene.start("PvpGameOverScene", {
                isWinner: false
            });
            this.unloadAssets();
            this.scene.stop();
            return;
        }
        if (result.state == (0, $f244a5791b15a233$export$eb5ccdbd077479c).Tie) {
            this.scene.start("PvpRewardsScene", {
                rewards: {
                    isDraw: true,
                    neon_gold: 250,
                    space_elixir: 250,
                    stardust: 5
                }
            });
            this.unloadAssets();
            this.scene.stop();
        } else if (result.winningWallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) {
            this.scene.start("PvpRewardsScene", {
                rewards: {
                    isDraw: false,
                    neon_gold: result.neonGoldBoost,
                    space_elixir: result.spaceElixirBoost,
                    stardust: result.starDust
                }
            });
            this.unloadAssets();
            this.scene.stop();
        } else {
            this.scene.start("PvpGameOverScene", {
                isWinner: false
            });
            this.unloadAssets();
            this.scene.stop();
        }
    }
    handleTimer(countdown) {
    // This method can contain the round countdown timer
    // countdown is received from the game server and when it hits 0 the player is idle
    }
    destroy() {}
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59)));
        // Unload Opponent PFPs
        if (this._gameState.isBotMatch) {
            const botImageKeys = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync().squadMembers.map((sm)=>sm.image_key);
            (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, botImageKeys);
        } else {
            const opponentImageKeys = (0, $22153939dd167f91$export$2e2bcd8739ae039).getInstance().getOpponentSync().squadMembers.map((sm)=>sm.image_key);
            (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, opponentImageKeys);
        }
    }
}










var $f1q41 = parcelRequire("f1q41");





const $64f552616545b373$var$modalHeight = 380;
const $64f552616545b373$var$modalWidth = 494;
const $64f552616545b373$var$modalRadius = 50;
const $64f552616545b373$var$modalColor = 0x350926;
const $64f552616545b373$var$modalAlpha = 1;
const $64f552616545b373$var$modalBorderColor = 0x3d4361;
const $64f552616545b373$var$modalBorderWidth = 1;
class $64f552616545b373$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "MatchmakingScene"
        });
    }
    preload() {
        (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData();
        // Grabs Bot Data from the server incase its needed
        (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBot(true).then((res)=>{});
        // PvP
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$251c17ddc5e37a4c));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($64f552616545b373$var$modalWidth, $64f552616545b373$var$modalHeight + 100);
        this.server = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance();
        this._player = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._player.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        // UI Elements
        const bg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($64f552616545b373$var$modalWidth), this.applyScale($64f552616545b373$var$modalHeight), this.applyScale($64f552616545b373$var$modalRadius), $64f552616545b373$var$modalColor, $64f552616545b373$var$modalAlpha);
        bg.setStrokeStyle(this.applyScale($64f552616545b373$var$modalBorderWidth), $64f552616545b373$var$modalBorderColor, $64f552616545b373$var$modalAlpha);
        // Matchmaking Text to display
        this._matchmakingText = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(120), "cc_outline", "Matchmaking in progress \n Please stand by...", this.applyScale(26), 0).setOrigin(0.5, 0).setCenterAlign();
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + this.applyScale(30), "party_blob").setOrigin(0.5, 0.5).play("blob_animation");
        // cancel button
        this._cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, bg.getBottomLeft().y, "cancel_button", false).setScale(this._scale);
        this._cancelButton.setVisible(false);
        this._cancelButton.onClick().subscribe((pointer)=>{
            this.onCancel();
        });
        this.add.existing(this._cancelButton);
        // stops cancel button from being pressed for 10 seconds
        this.time.addEvent({
            delay: 5000,
            loop: false,
            callback: ()=>{
                this._cancelButton.setVisible(true);
            }
        });
        return this.server.join(this._player).then((room)=>{
            // handles incoming server signals for PVP
            this.server.onWaitingForOpponent(this.handleWaitingForOpponent, this);
            this.server.onBotTimerCountdown(this.handleBotTimerCountdown, this);
            const handleGameStartedCurried = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).curry(this.handleGameStarted)(room === null || room === void 0 ? void 0 : room.id);
            this.server.onGameStarted(handleGameStartedCurried, this);
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    onCancel() {
        this.server.leave();
        this.scene.start("HomebaseScene");
        this.unloadAssets();
        this.scene.stop();
    }
    handleGameStarted(roomId, data) {
        var _a;
        // Disables Cancel button so player cannot leave while a game is being started
        this._cancelButton.setDisabled(true);
        // gets opponent wallet
        var opponent;
        (_a = this.server.getGameState()) === null || _a === void 0 || _a.players.forEach((player)=>{
            if (player.wallet !== (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) opponent = player.wallet;
        });
        (0, $22153939dd167f91$export$2e2bcd8739ae039).getInstance().getOpponent(opponent, true).then((opp)=>{
            var _a;
            this.scene.start("PvPScene", {
                battle_id: (_a = (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().getGameState()) === null || _a === void 0 ? void 0 : _a.battleId
            });
            this.unloadAssets();
            this.scene.stop();
        });
    }
    handleWaitingForOpponent() {
    // timer needs to be kicked off here
    }
    handleBotTimerCountdown(countdown) {
        this._matchmakingText.text = "Matchmaking in progress \n Please stand by...\n\n" + (0, $2e76b527e9362cab$export$f59a0cda704a3e4c)(countdown);
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$251c17ddc5e37a4c)));
    }
}








const $91a7734bc6b0adf0$var$modalHeight = 360;
const $91a7734bc6b0adf0$var$modalWidth = 494;
const $91a7734bc6b0adf0$var$modalRadius = 25;
const $91a7734bc6b0adf0$var$modalColor = 0x350926;
const $91a7734bc6b0adf0$var$modalAlpha = 1;
const $91a7734bc6b0adf0$var$modalBorderColor = 0x3d4361;
const $91a7734bc6b0adf0$var$modalBorderWidth = 1;
const $91a7734bc6b0adf0$var$victoryMessage = "The spoils of your\nvictory are awaiting\nyou at the Homebase";
const $91a7734bc6b0adf0$var$defeatMessage = "You were not\nsuccessful this time,\ndear wolf, but there\nwill be many more\nopportunities ahead...";
const $91a7734bc6b0adf0$var$messageColor = 0x75758b;
class $91a7734bc6b0adf0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._isWinner = data.isWinner;
    }
    constructor(){
        super({
            key: "PvpGameOverScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($91a7734bc6b0adf0$var$modalWidth, $91a7734bc6b0adf0$var$modalHeight + 300); // 220 accounts for icons and button extending beyond modal box
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$28f650127da92c3f));
    }
    create() {
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.setScale($91a7734bc6b0adf0$var$modalWidth), this.setScale($91a7734bc6b0adf0$var$modalHeight), this.setScale($91a7734bc6b0adf0$var$modalRadius), $91a7734bc6b0adf0$var$modalColor, $91a7734bc6b0adf0$var$modalAlpha);
        modalBg.setStrokeStyle(this.setScale($91a7734bc6b0adf0$var$modalBorderWidth), $91a7734bc6b0adf0$var$modalBorderColor, $91a7734bc6b0adf0$var$modalAlpha);
        // Add Icon
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y - this.setScale(80), this._isWinner ? "pvp_victory_icon" : "pvp_defeat_icon").setScale(this._scale);
        // Add Icon Text
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, this._isWinner ? "pvp_victory_icon_label" : "pvp_defeat_icon_label").setScale(this._scale);
        // Add Text
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.setScale(10), "cc_outline", this._isWinner ? $91a7734bc6b0adf0$var$victoryMessage : $91a7734bc6b0adf0$var$defeatMessage, this.setScale(24), 1).setOrigin(0.5, 0.5).setTint($91a7734bc6b0adf0$var$messageColor);
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, "pvp_return_home_button", true, 1.05).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.unloadAssets();
                this.scene.start("HomebaseScene");
                this.scene.launch("HudScene");
                this.scene.stop();
            });
        });
        this.add.existing(returnHomeButton);
    }
    setScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$28f650127da92c3f)));
    }
}






const $f2455290b574f2b7$var$rewardContainerHeight = 43;
const $f2455290b574f2b7$var$rewardContainerWidth = 213;
const $f2455290b574f2b7$var$rewardContainerRadius = 11;
const $f2455290b574f2b7$var$rewardContainerColor = 0x201425;
const $f2455290b574f2b7$var$rewardContainerAlpha = 0.7;
const $f2455290b574f2b7$var$rewardContainerBorderColor = 0x383d57;
const $f2455290b574f2b7$var$rewardContainerBorderWidth = 1;
const $f2455290b574f2b7$var$rewardGlareHeight = 6;
const $f2455290b574f2b7$var$rewardGlareWidth = 203;
const $f2455290b574f2b7$var$rewardGlareRadius = 4;
const $f2455290b574f2b7$var$rewardGlareColor = 0xffffff;
const $f2455290b574f2b7$var$rewardGlareAlpha = 0.14;
class $f2455290b574f2b7$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, currency, text, config){
        let conf = config ? config : {
            x: x,
            y: y,
            width: $f2455290b574f2b7$var$rewardContainerWidth * paneScale,
            height: $f2455290b574f2b7$var$rewardContainerHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._currency = currency;
        this._text = text;
        this.createRewardLabel(scene, x, y);
    }
    createRewardLabel(scene, x, y) {
        this.add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($f2455290b574f2b7$var$rewardContainerWidth), scene.applyScale($f2455290b574f2b7$var$rewardContainerHeight), scene.applyScale($f2455290b574f2b7$var$rewardContainerRadius), $f2455290b574f2b7$var$rewardContainerColor, $f2455290b574f2b7$var$rewardContainerAlpha // alpha
        ).setStrokeStyle($f2455290b574f2b7$var$rewardContainerBorderWidth, $f2455290b574f2b7$var$rewardContainerBorderColor, $f2455290b574f2b7$var$rewardContainerAlpha), {
            key: "reward_container",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($f2455290b574f2b7$var$rewardGlareWidth), scene.applyScale($f2455290b574f2b7$var$rewardGlareHeight), scene.applyScale($f2455290b574f2b7$var$rewardGlareRadius), $f2455290b574f2b7$var$rewardGlareColor, $f2455290b574f2b7$var$rewardGlareAlpha // alpha
        ), {
            key: "reward_glare",
            align: "center-top",
            offsetX: 0,
            offsetY: scene.applyScale(3),
            expand: false
        }).add(scene.rexUI.add.label({
            x: 0,
            y: 0,
            width: scene.applyScale(200),
            height: scene.applyScale(30),
            orientation: "x",
            rtl: false,
            icon: this._currency ? scene.add.image(0, 0, this.getIconKey()).setScale(this.getIconScale()) : null,
            text: scene.add.bitmapText(0, 0, "cc_outline", this._text.toLocaleString("en-us"), scene.applyScale(20), 0),
            space: {
                icon: 8
            },
            align: "center"
        }), {
            key: "reward_text",
            align: "center",
            offsetX: 0,
            offsetY: 2,
            expand: false
        }).layout();
    }
    getIconKey() {
        switch(this._currency){
            case "xp":
                return "trophy_icon_small";
            default:
                return `${this._currency}_icon`;
        }
    }
    getIconScale() {
        switch(this._currency){
            case "xp":
                return this.scene.applyScale(0.9);
            default:
                return this.scene.applyScale(0.5);
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("rewardLabel", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $f2455290b574f2b7$export$2e2bcd8739ae039(this.scene, x, y, config));
});







const $dd23c653b3652fbc$var$modalHeight = 455;
const $dd23c653b3652fbc$var$modalWidth = 494;
const $dd23c653b3652fbc$var$modalRadius = 50;
const $dd23c653b3652fbc$var$modalColor = 0x350926;
const $dd23c653b3652fbc$var$modalAlpha = 1;
const $dd23c653b3652fbc$var$modalBorderColor = 0x3d4361;
const $dd23c653b3652fbc$var$modalBorderWidth = 1;
const $dd23c653b3652fbc$var$spaceElixirFee = 250;
const $dd23c653b3652fbc$var$neonGoldFee = 250;
const $dd23c653b3652fbc$var$stardustFee = 5;
class $dd23c653b3652fbc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(reward){
        super({
            key: "PvpEntryScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$76043ee8727017b5));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($dd23c653b3652fbc$var$modalWidth, $dd23c653b3652fbc$var$modalHeight + 60);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($dd23c653b3652fbc$var$modalWidth), this.applyScale($dd23c653b3652fbc$var$modalHeight), this.applyScale($dd23c653b3652fbc$var$modalRadius), $dd23c653b3652fbc$var$modalColor, $dd23c653b3652fbc$var$modalAlpha);
        modalBg.setStrokeStyle($dd23c653b3652fbc$var$modalBorderWidth, $dd23c653b3652fbc$var$modalBorderColor, $dd23c653b3652fbc$var$modalAlpha);
        // Add Icons
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, "neon_gold_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 - this.applyScale(74), modalBg.getTopLeft().y, "space_elixir_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 + this.applyScale(80), modalBg.getTopLeft().y, "stardust_icon_large").setScale(this._scale);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(249),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Cost to enter:", this.applyScale(28), 1), {
            padding: {
                left: this.applyScale(42),
                right: 0,
                top: 0,
                bottom: this.applyScale(27)
            },
            key: "title_text"
        });
        // Add Fee Labels
        const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", $dd23c653b3652fbc$var$spaceElixirFee.toLocaleString("en-us"));
        const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", $dd23c653b3652fbc$var$neonGoldFee.toLocaleString("en-us"));
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", $dd23c653b3652fbc$var$stardustFee.toLocaleString("en-us"));
        sizer.add(this.add.existing(space_elixir_label), {
            padding: {
                left: this.applyScale(21),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "space_elixir_label"
        });
        sizer.add(this.add.existing(neon_gold_label), {
            padding: {
                left: this.applyScale(21),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "neon_gold_label"
        });
        sizer.add(this.add.existing(stardust_label), {
            padding: {
                left: this.applyScale(21),
                right: 0,
                top: 0,
                bottom: this.applyScale(35)
            },
            key: "stardust_label"
        });
        // Add Note
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Note: Rewards for winning\nwill always be significantly\nhigher than costs to enter.", this.applyScale(20), 1).setAlpha(0.6), {
            padding: {
                left: this.applyScale(9),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "note_text"
        });
        sizer.layout();
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), modalBg.getBottomLeft().y, "pvp_cancel_button", true, 1.05).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.scene.launch("HomebaseScene");
            this.unloadAssets();
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), modalBg.getBottomLeft().y, "pvp_confirm_button", true, 1.05).setScale(this._scale);
        confirmButton.onClick().subscribe((pointer)=>{
            this.scene.start("MatchmakingScene");
            this.unloadAssets();
            this.scene.stop();
        });
        this.add.existing(confirmButton);
        var userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        var squadData = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        if (userData.space_elixir < $dd23c653b3652fbc$var$spaceElixirFee || userData.neon_gold < $dd23c653b3652fbc$var$neonGoldFee || userData.stardust < $dd23c653b3652fbc$var$stardustFee || !squadData || squadData.length === 0 || squadData.filter((sm)=>{
            return sm.hp > 0;
        }).length === 0) {
            confirmButton.setDisabled(true);
            confirmButton.setAlpha(0.5);
        }
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$76043ee8727017b5)));
    }
}









const $4a39541642ee7543$var$modalHeight = 400;
const $4a39541642ee7543$var$modalWidth = 494;
const $4a39541642ee7543$var$modalRadius = 25;
const $4a39541642ee7543$var$modalColor = 0x350926;
const $4a39541642ee7543$var$modalAlpha = 1;
const $4a39541642ee7543$var$modalBorderColor = 0x3d4361;
const $4a39541642ee7543$var$modalBorderWidth = 1;
const $4a39541642ee7543$var$victoryMessage = "You won the\nfollowing resources:";
const $4a39541642ee7543$var$drawMessage = "Your entry fee\nhas been returned:";
class $4a39541642ee7543$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._rewards = data.rewards;
        this._isDraw = this._rewards.isDraw;
    }
    constructor(){
        super({
            key: "PvpRewardsScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($4a39541642ee7543$var$modalWidth, $4a39541642ee7543$var$modalHeight + 300); // 300 accounts for icons and button extending beyond modal box
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$28f650127da92c3f));
    }
    create() {
        var _a, _b, _c, _d, _e, _f;
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($4a39541642ee7543$var$modalWidth), this.applyScale($4a39541642ee7543$var$modalHeight), this.applyScale($4a39541642ee7543$var$modalRadius), $4a39541642ee7543$var$modalColor, $4a39541642ee7543$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($4a39541642ee7543$var$modalBorderWidth), $4a39541642ee7543$var$modalBorderColor, $4a39541642ee7543$var$modalAlpha);
        // Add Icon
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y - this.applyScale(80), this._isDraw ? "pvp_draw_icon" : "pvp_victory_icon").setScale(this._scale);
        // Add Icon Text
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, this._isDraw ? "pvp_draw_icon_label" : "pvp_victory_icon_label").setScale(this._scale);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(215),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this._isDraw ? $4a39541642ee7543$var$drawMessage : $4a39541642ee7543$var$victoryMessage, this.applyScale(24), 1), {
            padding: {
                left: this.applyScale(2),
                right: 0,
                top: 0,
                bottom: this.applyScale(27)
            },
            key: "title_text"
        });
        // Add Fee Labels
        const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", ((_b = (_a = this._rewards) === null || _a === void 0 ? void 0 : _a.space_elixir) === null || _b === void 0 ? void 0 : _b.toLocaleString("en-us")) || "0");
        const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", ((_d = (_c = this._rewards) === null || _c === void 0 ? void 0 : _c.neon_gold) === null || _d === void 0 ? void 0 : _d.toLocaleString("en-us")) || "0");
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", ((_f = (_e = this._rewards) === null || _e === void 0 ? void 0 : _e.stardust) === null || _f === void 0 ? void 0 : _f.toLocaleString("en-us")) || "0");
        sizer.add(this.add.existing(space_elixir_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "space_elixir_label"
        });
        sizer.add(this.add.existing(neon_gold_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "neon_gold_label"
        });
        sizer.add(this.add.existing(stardust_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "stardust_label"
        });
        sizer.layout();
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, "pvp_return_home_button", true, 1.05).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.unloadAssets();
                this.scene.start("HomebaseScene");
                this.scene.launch("HudScene");
                this.scene.stop();
            });
        });
        this.add.existing(returnHomeButton);
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$28f650127da92c3f)));
    }
}















const $02e4045fa9a3d608$var$modalHeight = 822;
const $02e4045fa9a3d608$var$modalWidth = 1393;
const $02e4045fa9a3d608$var$modalRadius = 16;
const $02e4045fa9a3d608$var$modalColor = 0x1c1c2c;
const $02e4045fa9a3d608$var$modalAlpha = 1;
class $02e4045fa9a3d608$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "PvEScene"
        });
    }
    preload() {
        // Image Loading
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59));
        (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync().squadMembers.forEach((sm)=>{
            if (sm.image_key && sm.image_thumbnail_url && sm.image_thumbnail_url.length > 0) this.load.image(sm.image_key, sm.image_thumbnail_url);
        });
        this._gameState = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().getGameState();
    }
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($02e4045fa9a3d608$var$modalWidth, $02e4045fa9a3d608$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $02e4045fa9a3d608$var$modalWidth * this._scale,
            height: $02e4045fa9a3d608$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Player Pane
        this._player = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._player.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._player.traits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        this._player.health = 300;
        this._playerContentPane = new (0, $86e0416011c6fd43$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        this.add.existing(this._playerContentPane);
        sizer.add(this._playerContentPane, {
            key: "player-content-pane",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Game Pane
        this._gamePane = new (0, $456f00c25efcc44a$export$2e2bcd8739ae039)(this, 0, 0, {
            battleType: "pve"
        }, this._scale);
        this.add.existing(this._gamePane);
        sizer.add(this._gamePane, {
            key: "game-content-pane",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Bot Pane
        this._bot = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync();
        this._bot.traits = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        this._bot.health = 300;
        this._bot.isBot = true;
        this._botContentPane = new (0, $86e0416011c6fd43$export$2e2bcd8739ae039)(this, 0, 0, this._bot, this._scale);
        this.add.existing(this._botContentPane);
        sizer.add(this._botContentPane, {
            key: "opponent-content-pane",
            align: "right-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Button Pane
        this._buttonPane = new (0, $9f3c1f58fed62fad$export$2e2bcd8739ae039)(this, 0, 0, {
            serverType: "pve"
        }, this._scale);
        this.add.existing(this._buttonPane);
        sizer.add(this._buttonPane, {
            key: "button-content-pane",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Layout the Scene
        sizer.layout();
        // PvE Server Interaction
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().onRoundComplete(this.handleRoundComplete, this);
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().onGameOver(this.handleGameOver, this);
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().onActionSubmitted(this.handleActionSubmitted, this);
        // Match State Listening
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().onMatchRoundStart(this.handleMatchRoundStart, this);
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().onMatchRoundComplete(this.handleMatchRoundComplete, this);
        // Interacts with PVP Surrender Scene
        this.scene.get("PvpSurrenderScene").events.on("surrender_cancel_event", ()=>{
            var state = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().getGameState();
            if (state) {
                var user = state.players.find((player)=>{
                    return player.wallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
                });
                this._buttonPane.updateEnabled(user);
            } else console.log("Failed to get game state");
        });
        // Interacts with PVE Match Round Complete Scene
        this.scene.get("PveRewardsScene").events.on("pve_continue_event", ()=>{
            (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().startNextMatchRound();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    handleActionSubmitted(result) {
        const gameState = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().getGameState();
        var actionStatus = result.isActionValid ? "Action submitted" : "Action invalid";
        if (result.isActionValid) {
            if (result.submitterWallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) {
                // disable buttons as action is valid
                this._buttonPane.disableButtons();
                this._gamePane.updateExistingRound({
                    roundNumber: (gameState === null || gameState === void 0 ? void 0 : gameState.round) + 1,
                    playerAction: actionStatus,
                    opponentAction: "Awaiting action..."
                });
            } else // bot
            this._gamePane.updateExistingRound({
                roundNumber: (gameState === null || gameState === void 0 ? void 0 : gameState.round) + 1,
                playerAction: "Awaiting action...",
                opponentAction: actionStatus
            });
        }
    }
    handleRoundComplete() {
        this._gameState = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().getGameState();
        if (this._gameState.round != 0) this.updateUIState(this._gameState);
    }
    handleMatchRoundStart() {
        // Update all the front end UI with the new match data
        this._gamePane.updateTitle("Match Round " + (this._gameState.matchRound + 1) + "... FIGHT!");
        this._gamePane.clearGameplayLog();
        this.updateUIState(this._gameState);
    }
    handleMatchRoundComplete() {
        this.scene.launch("PveRewardsScene", {
            matchRound: this._gameState.matchRound,
            rewards: {
                neonGold: this._gameState.neonGold,
                spaceElixir: this._gameState.spaceElixir,
                starDust: this._gameState.starDust
            }
        });
    }
    updateUIState(state) {
        var user;
        var bot;
        state.players.forEach((player)=>{
            if (player.wallet === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress()) user = player;
            else bot = player;
        });
        // Update Button Pane
        this._buttonPane.updateEnabled(user);
        // Update Player and Opponent Panes
        if (state.round == 0) {
            this._playerContentPane.resetProgressBars(user.health, user.actionPoints);
            this._botContentPane.resetProgressBars(bot.health, bot.actionPoints);
        } else {
            this._playerContentPane.updateProgressBars(user.health, user.actionPoints);
            this._botContentPane.updateProgressBars(bot.health, bot.actionPoints);
        }
        // updates current round data IF round isn't 0
        if (state.round != 0) {
            this._gamePane.updateExistingRound({
                roundNumber: state.round,
                playerAction: user.roundAction,
                opponentAction: bot.roundAction
            });
            // create next round
            this._gamePane.addRound(state.round + 1);
        }
    // if player is stunned auto submit their stunned action.
    //if (user.stunned) {PVPServer.getInstance().playAction('pvpstunned')}
    }
    handleGameOver(result) {
        this._gameState = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().getGameState();
        (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().leave();
        this.scene.start("PveGameOverScene", {
            isDraw: this._gameState.gameState === (0, $f244a5791b15a233$export$eb5ccdbd077479c).Tie ? true : false,
            roundsWon: this._gameState.matchRound,
            rewards: {
                neon_gold: result.neonGoldBoost,
                space_elixir: result.spaceElixirBoost,
                stardust: result.starDust
            }
        });
        this.unloadAssets();
        this.scene.stop();
    }
    destroy() {}
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59)));
        // Unload Bot PFPs
        const botImageKeys = (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBotSync().squadMembers.map((sm)=>sm.image_key);
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, botImageKeys);
    }
}








const $2a8af8bd1d2abd4f$var$modalHeight = 455;
const $2a8af8bd1d2abd4f$var$modalWidth = 494;
const $2a8af8bd1d2abd4f$var$modalRadius = 50;
const $2a8af8bd1d2abd4f$var$modalColor = 0x350926;
const $2a8af8bd1d2abd4f$var$modalAlpha = 1;
const $2a8af8bd1d2abd4f$var$modalBorderColor = 0x3d4361;
const $2a8af8bd1d2abd4f$var$modalBorderWidth = 1;
class $2a8af8bd1d2abd4f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(reward){
        super({
            key: "PveRewardsScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$76043ee8727017b5));
    }
    init(data) {
        this._matchRound = data.matchRound;
        this._roundRewards = data.rewards;
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2a8af8bd1d2abd4f$var$modalWidth, $2a8af8bd1d2abd4f$var$modalHeight + 60);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($2a8af8bd1d2abd4f$var$modalWidth), this.applyScale($2a8af8bd1d2abd4f$var$modalHeight), this.applyScale($2a8af8bd1d2abd4f$var$modalRadius), $2a8af8bd1d2abd4f$var$modalColor, $2a8af8bd1d2abd4f$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($2a8af8bd1d2abd4f$var$modalBorderWidth), $2a8af8bd1d2abd4f$var$modalBorderColor, $2a8af8bd1d2abd4f$var$modalAlpha);
        // Add Icons
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, "neon_gold_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 - this.applyScale(74), modalBg.getTopLeft().y, "space_elixir_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 + this.applyScale(80), modalBg.getTopLeft().y, "stardust_icon_large").setScale(this._scale);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(249),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Round " + this._matchRound + " Rewards", this.applyScale(28), 1), {
            padding: {
                left: this.applyScale(42),
                right: 0,
                top: 0,
                bottom: this.applyScale(27)
            },
            key: "title_text"
        });
        // Add Fee Labels
        const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", this._roundRewards.spaceElixir.toLocaleString("en-us"));
        const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", this._roundRewards.neonGold.toLocaleString("en-us"));
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", this._roundRewards.starDust.toLocaleString("en-us"));
        sizer.add(this.add.existing(space_elixir_label), {
            padding: {
                left: this.applyScale(30),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "space_elixir_label"
        });
        sizer.add(this.add.existing(neon_gold_label), {
            padding: {
                left: this.applyScale(30),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "neon_gold_label"
        });
        sizer.add(this.add.existing(stardust_label), {
            padding: {
                left: this.applyScale(30),
                right: 0,
                top: 0,
                bottom: this.applyScale(35)
            },
            key: "stardust_label"
        });
        // Add Note
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Success!\n You have won round " + this._matchRound + "\n Select Continue to start round " + (this._matchRound + 1), this.applyScale(19), 1), {
            padding: {
                left: this.applyScale(2),
                right: 0,
                top: 0,
                bottom: this.applyScale(27)
            },
            key: "note_text"
        });
        sizer.layout();
        // Add Continue Button - Update UI Element & Set to middle
        const continueButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, "pve_continue_button", false).setScale(this._scale);
        continueButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.stop();
            this.events.emit("pve_continue_event", {});
        });
        this.add.existing(continueButton);
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$76043ee8727017b5)));
    }
}









const $26b39195591602fc$var$modalHeight = 400;
const $26b39195591602fc$var$modalWidth = 494;
const $26b39195591602fc$var$modalRadius = 25;
const $26b39195591602fc$var$modalColor = 0x350926;
const $26b39195591602fc$var$modalAlpha = 1;
const $26b39195591602fc$var$modalBorderColor = 0x3d4361;
const $26b39195591602fc$var$modalBorderWidth = 1;
const $26b39195591602fc$var$victoryMessage = "You won the\nfollowing resources:";
const $26b39195591602fc$var$messageColor = 0xffffff;
class $26b39195591602fc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._roundsWon = data.roundsWon;
        this._rewards = data.rewards;
        this._isDraw = data.isDraw;
    }
    constructor(){
        super({
            key: "PveGameOverScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($26b39195591602fc$var$modalWidth, $26b39195591602fc$var$modalHeight + 300); // 300 accounts for icons and button extending beyond modal box
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$fefbcb53f7841b7c));
    }
    create() {
        var _a, _b, _c, _d, _e, _f;
        // Round Result
        var resultIcon = this.getResultIcon(this._roundsWon, this._isDraw);
        var resultIconLabel = this.getResultIconLabel(this._roundsWon, this._isDraw);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($26b39195591602fc$var$modalWidth), this.applyScale($26b39195591602fc$var$modalHeight), this.applyScale($26b39195591602fc$var$modalRadius), $26b39195591602fc$var$modalColor, $26b39195591602fc$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($26b39195591602fc$var$modalBorderWidth), $26b39195591602fc$var$modalBorderColor, $26b39195591602fc$var$modalAlpha);
        // Add Icon
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y - this.applyScale(80), resultIcon).setScale(this._scale);
        // Add Icon Text
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, resultIconLabel).setScale(this._scale);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(215),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", $26b39195591602fc$var$victoryMessage, this.applyScale(24), 1), {
            padding: {
                left: this.applyScale(2),
                right: 0,
                top: 0,
                bottom: this.applyScale(27)
            },
            key: "title_text"
        });
        // Add Fee Labels
        const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", ((_b = (_a = this._rewards) === null || _a === void 0 ? void 0 : _a.space_elixir) === null || _b === void 0 ? void 0 : _b.toLocaleString("en-us")) || "0");
        const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", ((_d = (_c = this._rewards) === null || _c === void 0 ? void 0 : _c.neon_gold) === null || _d === void 0 ? void 0 : _d.toLocaleString("en-us")) || "0");
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", ((_f = (_e = this._rewards) === null || _e === void 0 ? void 0 : _e.stardust) === null || _f === void 0 ? void 0 : _f.toLocaleString("en-us")) || "0");
        sizer.add(this.add.existing(space_elixir_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "space_elixir_label"
        });
        sizer.add(this.add.existing(neon_gold_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "neon_gold_label"
        });
        sizer.add(this.add.existing(stardust_label), {
            padding: {
                left: this.applyScale(1),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "stardust_label"
        });
        sizer.layout();
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, "pvp_return_home_button", true, 1.05).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.unloadAssets();
                this.scene.start("HomebaseScene");
                this.scene.launch("HudScene");
                this.scene.stop();
            });
        });
        this.add.existing(returnHomeButton);
    }
    applyScale(length) {
        return length * this._scale;
    }
    getResultIcon(roundsWon, isDraw) {
        if (isDraw) return "pvp_draw_icon";
        else {
            if (roundsWon === 7) // Player won all battle rounds
            return "pvp_victory_icon";
            else // player lost a round
            return "pvp_defeat_icon";
        }
    }
    getResultIconLabel(roundsWon, isDraw) {
        if (isDraw) return "pvp_draw_icon_label";
        else {
            if (roundsWon === 7) return "pve_victory_bg";
            else return "pve_gameover_bg";
        }
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$fefbcb53f7841b7c)));
    }
}








var $f1q41 = parcelRequire("f1q41");



const $784eff2aeceaba80$var$modalHeight = 380;
const $784eff2aeceaba80$var$modalWidth = 494;
const $784eff2aeceaba80$var$modalRadius = 50;
const $784eff2aeceaba80$var$modalColor = 0x350926;
const $784eff2aeceaba80$var$modalAlpha = 1;
const $784eff2aeceaba80$var$modalBorderColor = 0x3d4361;
const $784eff2aeceaba80$var$modalBorderWidth = 1;
class $784eff2aeceaba80$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BotMatchingScene"
        });
    }
    preload() {
        (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData();
        // Grabs Bot Data from the server incase its needed
        (0, $95f314ec8ce1be9b$export$2e2bcd8739ae039).getInstance().getBot(true).then((res)=>{
            this.server.joinBot();
        });
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$35664250ad2bd612));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($784eff2aeceaba80$var$modalWidth, $784eff2aeceaba80$var$modalHeight + 100);
        this.server = (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance();
        this._player = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._player.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        // UI Elements
        const bg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($784eff2aeceaba80$var$modalWidth), this.applyScale($784eff2aeceaba80$var$modalHeight), this.applyScale($784eff2aeceaba80$var$modalRadius), $784eff2aeceaba80$var$modalColor, $784eff2aeceaba80$var$modalAlpha);
        bg.setStrokeStyle(this.applyScale($784eff2aeceaba80$var$modalBorderWidth), $784eff2aeceaba80$var$modalBorderColor, $784eff2aeceaba80$var$modalAlpha);
        // Matchmaking Text to display
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(120), "cc_outline", "Loading Bot Match \n Please stand by...", this.applyScale(26), 0).setOrigin(0.5, 0).setCenterAlign();
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + this.applyScale(30), "party_blob").setOrigin(0.5, 0.5).play("blob_animation");
        return this.server.join(this._player).then((room)=>{
            // handles incoming server signals for PVE
            const handleGameStartedCurried = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).curry(this.handleGameStarted)(room.id);
            this.server.onGameStarted(handleGameStartedCurried, this);
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    onCancel() {
        this.server.leave();
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.launch("HudScene");
        this.scene.stop();
    }
    handleGameStarted(roomId, data) {
        this.scene.start("PvEScene", {});
        this.unloadAssets();
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$35664250ad2bd612)));
    }
}










const $343d1e593a602b72$export$d07f57595c356899 = (string)=>string.charAt(0).toUpperCase() + string.slice(1);


const $d61debccbbbe3e9c$var$data = [
    {
        order: 3,
        type: "battles",
        name: "pvp",
        scene: "PvpEntryScene",
        bg_image_key: "pvp_button_bg",
        label_image_key: "pvp_button_text",
        enabled: true,
        isModal: false
    },
    {
        order: 1,
        type: "mining",
        name: "mining",
        scene: "MiningModalScene",
        fallbackScene: "MiningNotEnoughResourcesDialogScene",
        bg_image_key: "mining_mission_button_bg",
        label_image_key: "mining_mission_button_text",
        label_offset: 24,
        logo_image_key: "mining_mission_logo_image",
        logo_offset: -18,
        enabled: true,
        isModal: true
    },
    {
        order: 4,
        type: "battles",
        name: "pve",
        scene: "BotMatchingScene",
        bg_image_key: "pve_button_bg",
        label_image_key: "pve_button_text",
        enabled: true
    },
    {
        order: 6,
        type: "battles",
        name: "battle_royale",
        scene: "BattleRoyaleScene",
        bg_image_key: "battle_royale_button_bg",
        label_image_key: "battle_royale_button_text",
        enabled: true,
        isModal: false,
        data: {}
    },
    {
        order: 5,
        type: "battles",
        name: "boss_fight",
        scene: "BossFightScene",
        bg_image_key: "boss_fight_button_bg",
        label_image_key: "boss_fight_button_text",
        enabled: true,
        isModal: false,
        data: {}
    },
    {
        order: 2,
        type: "mining",
        name: "base_raid",
        scene: "BaseRaidConfirmNextBaseLoadScene",
        fallbackScene: "BaseRaidResultScene",
        bg_image_key: "base_raid_button_bg",
        label_image_key: "base_raid_button_text",
        enabled: true,
        isModal: false,
        data: {
            next: 0
        }
    }
];
const $d61debccbbbe3e9c$var$contentTypeMapper = {
    all: $d61debccbbbe3e9c$var$data.sort((a, b)=>a.order - b.order),
    battles: $d61debccbbbe3e9c$var$data.filter((mission)=>mission.type === "battles"),
    mining: $d61debccbbbe3e9c$var$data.filter((mission)=>mission.type === "mining")
};
class $d61debccbbbe3e9c$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, type, config){
        const conf = config ? config : {
            width: 566 * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        // Title
        this._title = scene.add.bitmapText(x - this.applyScale(259), y - this.applyScale(234), "cc_outline", (0, $343d1e593a602b72$export$d07f57595c356899)(type), this.applyScale(22), 0).setOrigin(0);
        // Missions table
        this._table = this.createTable(scene, $d61debccbbbe3e9c$var$contentTypeMapper[type], x, y + this.applyScale(5)).layout();
        this.add(this._title);
        this.add(this._table);
        this.setDirty(false);
    }
    applyScale(length) {
        return length * this._scale;
    }
    updateTable(data) {
        if (data) this._table.setItems(data);
        this._table.layout();
    }
    updateContentType(type) {
        this._title.setText((0, $343d1e593a602b72$export$d07f57595c356899)(type));
        this._table.setItems($d61debccbbbe3e9c$var$contentTypeMapper[type]);
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(530),
            height: this.applyScale(392),
            items: data,
            table: {
                cellWidth: this.applyScale(265),
                cellHeight: this.applyScale(180),
                columns: 2,
                clamplTableOXY: false,
                reuseCellContainer: true,
                scrollMode: 0,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, item = cell.item;
                var rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(25)
                };
                var itemBg = scene.add.rexCircleMaskImage(0, 0, item.bg_image_key, "", rectConfig);
                itemBg.displayHeight = scene.applyScale(145);
                itemBg.scaleX = itemBg.scaleY;
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(235),
                    height: scene.applyScale(145),
                    space: {
                        left: scene.applyScale(15),
                        right: scene.applyScale(0),
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).add(itemBg, {
                    key: "mission_bg",
                    align: "center",
                    expand: false
                });
                if (item.logo_image_key) sizer.add(scene.add.image(0, 0, item.logo_image_key).setScale(scene.getScale()), {
                    key: "mission_logo",
                    align: "center",
                    offsetY: scene.applyScale(item.logo_offset),
                    expand: false
                });
                sizer.add(scene.add.image(0, 0, item.label_image_key).setScale(scene.getScale()), {
                    key: "mission_label",
                    align: "center",
                    offsetY: item.logo_image_key ? scene.applyScale(item.label_offset) : 0,
                    expand: false
                }).layout();
                if (item.enabled) {
                    sizer.setInteractive({
                        cursor: "pointer"
                    });
                    //sizer.enableClick() // Deprecated
                    sizer.setChildrenInteractive({
                        click: {
                            mode: "release",
                            clickInterval: 100
                        },
                        over: true,
                        tap: {
                            time: 250,
                            tapInterval: 200,
                            threshold: 9,
                            tapOffset: 10,
                            taps: undefined,
                            minTaps: undefined,
                            maxTaps: undefined
                        },
                        press: {
                            time: 251,
                            threshold: 9
                        },
                        swipe: {
                            threshold: 10,
                            velocityThreshold: 1000,
                            dir: "8dir"
                        },
                        inputEventPrefix: "child."
                    });
                    sizer.on("child.over", (child, pointer, event)=>{
                        sizer.getElement("mission_bg").setScale(sizer.getElement("mission_bg").scaleX * 1.04);
                        sizer.getElement("mission_label").setScale(sizer.getElement("mission_bg").scaleX * 1.03);
                        if (sizer.getElement("mission_logo")) sizer.getElement("mission_logo").setScale(sizer.getElement("mission_logo").scaleX * 1.04);
                    });
                    sizer.on("child.out", (child, pointer, event)=>{
                        sizer.getElement("mission_bg").setScale(sizer.getElement("mission_bg").scaleX / 1.04);
                        sizer.getElement("mission_label").setScale(sizer.getElement("mission_bg").scaleX / 1.03);
                        if (sizer.getElement("mission_logo")) sizer.getElement("mission_logo").setScale(sizer.getElement("mission_logo").scaleX / 1.04);
                    });
                } else {
                    sizer.disableInteractive();
                    //sizer.disableClick() // Deprecated
                    sizer.setAlpha(0.3);
                }
                sizer.onClick(()=>{
                    //scene.sound.play('mission-button');
                    if (item.isModal) switch(item.name){
                        case "mining":
                            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getSixRandomAsteroids().then((asteroids)=>{
                                if (asteroids.length) scene.scene.start(item.scene, {
                                    asteroids: asteroids
                                });
                                else scene.scene.start(item.fallbackScene);
                            });
                            break;
                        default:
                            scene.scene.start(item.scene);
                            break;
                    }
                    else switch(item.name){
                        case "base_raid":
                            (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((res)=>{
                                if (res.base_raid_id !== 0 && res.completed) {
                                    // Show results of previous raid
                                    const resultData = {
                                        isAttacker: true,
                                        neon_gold: res.attacker_possible_loot.neon_gold,
                                        space_elixir: res.attacker_possible_loot.space_elixir,
                                        stardust: res.attacker_possible_loot.stardust,
                                        xp: res.is_win ? res.attacker_win_xp : res.attacker_lose_xp,
                                        isVictory: res.is_win
                                    };
                                    scene.scene.stop("HomebaseScene");
                                    scene.scene.stop("HudScene");
                                    scene.scene.start("BaseRaidResultScene", resultData);
                                    scene.scene.bringToTop("BaseRaidResultScene");
                                } else {
                                    scene.scene.stop("MissionsModalScene");
                                    scene.scene.start(item.scene, {
                                        isFirst: true
                                    });
                                    scene.scene.bringToTop(item.scene);
                                }
                            });
                            break;
                        case "battle_royale":
                            (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().updateMetaData().then(()=>{
                                scene.scene.stop("HomebaseScene");
                                scene.scene.stop("HudScene");
                                scene.scene.start(item.scene, item.data);
                            });
                            break;
                        default:
                            scene.scene.stop("HomebaseScene");
                            scene.scene.stop("HudScene");
                            scene.scene.start(item.scene, item.data);
                            break;
                    }
                }, this);
                return scene.add.existing(sizer);
            }
        });
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    setCategory(data) {
    // TODO: Implement when mining is available
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("missionsContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $d61debccbbbe3e9c$export$2e2bcd8739ae039(this.scene, x, y));
});




const $074f9006fa99d79c$var$modalHeight = 468;
const $074f9006fa99d79c$var$modalWidth = 814;
const $074f9006fa99d79c$var$modalRadius = 25;
const $074f9006fa99d79c$var$modalColor = 0x1c1c2c;
const $074f9006fa99d79c$var$modalAlpha = 1;
const $074f9006fa99d79c$var$spineWidth = 248;
const $074f9006fa99d79c$var$spineColor = 0xe6e6ff;
const $074f9006fa99d79c$var$spineAlpha = 0.05;
const $074f9006fa99d79c$var$missionTypes = [
    {
        displayName: "Battles",
        isSelected: false
    },
    {
        displayName: "Mining",
        isSelected: false
    }
];
class $074f9006fa99d79c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "MissionsModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$b438e31af3ecff0a));
    }
    init() {
        this._missionTypes = [
            {
                displayName: "All",
                isSelected: true
            },
            ...$074f9006fa99d79c$var$missionTypes
        ];
    }
    create() {
        this.createComponent();
    }
    createComponent() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($074f9006fa99d79c$var$modalWidth, $074f9006fa99d79c$var$modalHeight);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($074f9006fa99d79c$var$modalWidth), this.applyScale($074f9006fa99d79c$var$modalHeight), this.applyScale($074f9006fa99d79c$var$modalRadius), $074f9006fa99d79c$var$modalColor, $074f9006fa99d79c$var$modalAlpha);
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($074f9006fa99d79c$var$spineWidth), this.applyScale($074f9006fa99d79c$var$modalHeight), {
            tl: this.applyScale($074f9006fa99d79c$var$modalRadius),
            tr: 0,
            bl: this.applyScale($074f9006fa99d79c$var$modalRadius),
            br: 0
        }, $074f9006fa99d79c$var$spineColor, $074f9006fa99d79c$var$spineAlpha);
        // Title text
        const titleText = this.add.image(0, 0, "missions_text").setOrigin(0).setScale(this._scale);
        // Add spine here
        this._spineTable = this.createSpineTable(this, this._missionTypes, 0, 0).setOrigin(0.5, 0.5);
        this._cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "cancel_btn_purple", true, 1.04).setScale(this._scale);
        this.add.existing(this._cancelButton);
        this._cancelButton.onClick().subscribe((pointer)=>{
            this.cancelButtonClickHandler(pointer);
        });
        this._missionsContentPane = new (0, $d61debccbbbe3e9c$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "all");
        this.add.existing(this._missionsContentPane);
        sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        sizer.add(spineBackground, {
            key: "spineBackground",
            align: "center",
            offsetX: this.applyScale(-($074f9006fa99d79c$var$modalWidth / 2 - $074f9006fa99d79c$var$spineWidth / 2)),
            offsetY: 0,
            expand: false
        });
        sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(31),
            expand: false
        });
        sizer.add(this._spineTable, {
            key: "table",
            align: "left-top",
            offsetX: this.applyScale(15),
            offsetY: this.applyScale(60),
            expand: false
        });
        sizer.add(this._cancelButton, {
            key: "confirmButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        sizer.add(this._missionsContentPane, {
            key: "squad-content-pane",
            align: "left-top",
            offsetX: this.applyScale(532),
            offsetY: this.applyScale(263),
            expand: false
        });
        sizer.layout();
        sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {}
    createSpineTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(220),
            height: this.applyScale(450),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(220),
                cellHeight: this.applyScale(32),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                interactive: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                // Template
                let rectConfig = {
                    maskType: "roundRectangle",
                    radius: 0
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(220),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(220), scene.applyScale(32), scene.applyScale(6), 0xe6e6ff, 0.05).setAlpha(item.isSelected ? 1 : 0), {
                    key: "menu_option_bg",
                    align: "center",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.displayName, scene.applyScale(16), 0).setAlpha(item.isSelected ? 1 : 0.4), {
                    key: "menu_option_text",
                    align: "left",
                    offsetX: scene.applyScale(10),
                    offsetY: 0,
                    expand: false
                });
                sizer.setChildrenInteractive({
                    click: {
                        mode: "release",
                        clickInterval: 100
                    },
                    over: true,
                    tap: {
                        time: 250,
                        tapInterval: 200,
                        threshold: 9,
                        tapOffset: 10,
                        taps: undefined,
                        minTaps: undefined,
                        maxTaps: undefined
                    },
                    press: {
                        time: 251,
                        threshold: 9
                    },
                    swipe: {
                        threshold: 10,
                        velocityThreshold: 1000,
                        dir: "8dir"
                    },
                    inputEventPrefix: "child."
                });
                sizer.on("child.over", (child, pointer, event)=>{
                    sizer.getElement("menu_option_text").setAlpha(1);
                });
                sizer.on("child.out", (child, pointer, event)=>{
                    if (!item.isSelected) sizer.getElement("menu_option_text").setAlpha(0.4);
                });
                sizer.on("child.click", (child, pointer, event)=>{
                    scene.setIsSelected(item, sizer);
                });
                return sizer;
            }
        });
        table.setItems(data).scrollToTop();
        // table.getElement('table').on('')
        return table;
    }
    setIsSelected(item, sizer) {
        if (item.isSelected === true) return;
        this._missionTypes = this._missionTypes.map((missionType)=>Object.assign(Object.assign({}, missionType), {
                isSelected: missionType.displayName === item.displayName
            }));
        this._spineTable.setItems(this._missionTypes);
        this._missionsContentPane.updateContentType(item.displayName.toLowerCase());
    }
    cancelButtonClickHandler(pointer) {
        this.unloadAssets();
        this.scene.resume("HomebaseScene");
        this.scene.resume("HudScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$b438e31af3ecff0a)));
    }
}












const $71499e2f29a18be8$var$componentWidth = 273;
const $71499e2f29a18be8$var$componentHeight = 413;
const $71499e2f29a18be8$var$componentRadius = 16;
const $71499e2f29a18be8$export$fb4765ede2185826 = {
    1: "common_asteroid",
    2: "rare_asteroid",
    3: "epic_asteroid",
    4: "legendary_asteroid",
    5: "mythical_asteroid"
};
const $71499e2f29a18be8$var$componentAlpha = 1;
class $71499e2f29a18be8$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, asteroid, scale){
        const config = {
            width: scale * $71499e2f29a18be8$var$componentWidth,
            height: scale * $71499e2f29a18be8$var$componentHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, config);
        this._scale = scale;
        this.createComponent(scene, asteroid);
    }
    createComponent(scene, asteroid) {
        // @ts-ignore
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, this.applyScale($71499e2f29a18be8$var$componentWidth / 1.1), this.applyScale($71499e2f29a18be8$var$componentHeight), this.applyScale($71499e2f29a18be8$var$componentRadius), (0, $682c5d521fb8ae22$export$b9b712abdb918f5b)[asteroid.asteroid_rarity_id], $71499e2f29a18be8$var$componentAlpha);
        this.add(background, {
            key: "asteroid_background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        const config = {
            maskType: "roundRectangle",
            radius: $71499e2f29a18be8$var$componentRadius
        };
        const button = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, $71499e2f29a18be8$export$fb4765ede2185826[asteroid.asteroid_rarity_id], config, false);
        scene.add.existing(button);
        button.onClick().subscribe((observer)=>{
            if (observer.getDistance() > 20) return;
            scene.scene.stop("HomebaseScene");
            scene.scene.stop("HudScene");
            scene.scene.stop("MissionsModalScene");
            scene.scene.stop("MiningModalScene");
            scene.scene.get("MiningModalScene").unloadAssets();
            scene.scene.start("MiningLoadingScene", {
                asteroid: asteroid,
                scale: this._scale
            });
        });
        this.add(button, {
            key: "asteroid_image",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        let subrarity_id = "I";
        switch(asteroid.asteroid_subrarity_id){
            case 3:
                subrarity_id = "III";
                break;
            case 2:
                subrarity_id = "II";
                break;
        }
        const label = scene.add.bitmapText(0, 0, "cc_outline", asteroid.asteroid_rarity_name + " - " + subrarity_id, this.applyScale(22), 0);
        this.add(label, {
            key: "asteroid_label",
            align: "left-top",
            offsetX: scene.applyScale(23) * 1.3,
            offsetY: scene.applyScale(23) * 1.1,
            expand: false
        });
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            title: {
                text: "",
                fontStyle: null
            },
            progressBar: {
                text: `Time allowed: ${(0, $2e76b527e9362cab$export$9446e10eb5cfa53)(asteroid.mine_time)}`,
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale($71499e2f29a18be8$var$componentWidth / 1.3),
                height: this.applyScale(29),
                radius: this.applyScale(7),
                alpha: 1,
                color: 0x00a6d3,
                backgroundColor: 0x000000,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 0,
                glare: {
                    width: this.applyScale($71499e2f29a18be8$var$componentWidth / 1.4),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.17
                }
            }
        });
        this.add(progressBar, {
            key: "asteroid_progress_bar",
            align: "center-bottom",
            offsetX: 0,
            offsetY: -this.applyScale(23) * 1.1,
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
Phaser.GameObjects.GameObjectFactory.register("asteroidComponent", function(x, y, data, scale) {
    // @ts-ignore
    return this.displayList.add(// @ts-ignore
    new $71499e2f29a18be8$export$2e2bcd8739ae039(this.scene, x, y, data, scale));
});


const $e819770d5217f27e$var$modalWidth = 1008;
class $e819770d5217f27e$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, asteroids, scale){
        const config = {
            width: scale * $e819770d5217f27e$var$modalWidth,
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, config);
        this._scale = scale;
        if (asteroids && asteroids.length > 0) this.addTable(scene, asteroids);
        this.layout();
    }
    addTable(scene, asteroids) {
        const table = this.createTable(scene, asteroids).layout();
        this.add(table, {
            key: "asteroid_table",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
    }
    createTable(scene, asteroids) {
        // @ts-ignore
        const table = scene.rexUI.add.gridTable({
            width: this.applyScale(273 * asteroids.length > $e819770d5217f27e$var$modalWidth - 8 ? $e819770d5217f27e$var$modalWidth - 8 : 273 * asteroids.length - 1),
            height: this.applyScale(413),
            items: asteroids,
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale(273),
                cellHeight: this.applyScale(413),
                columns: 1,
                clamplTableOXY: false,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.4
            },
            space: {
                table: {
                    left: this.applyScale(23),
                    right: 0
                }
            },
            createCellContainerCallback: function(cell) {
                const cellScene = cell.scene;
                const cellItem = cell.item;
                const cellScale = cellScene.getScale();
                const asteroidComponent = new (0, $71499e2f29a18be8$export$2e2bcd8739ae039)(cellScene, 0, 0, cellItem, cellScale);
                cellScene.add.existing(asteroidComponent);
                return asteroidComponent;
            }
        }).setOrigin(0, 0.5);
        table.setItems(asteroids).scrollToTop();
        return table;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
Phaser.GameObjects.GameObjectFactory.register("asteroidContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $e819770d5217f27e$export$2e2bcd8739ae039(this.scene, x, y));
});


const $2971facc463cf8d8$var$modalWidth = 1008;
const $2971facc463cf8d8$var$modalHeight = 513;
const $2971facc463cf8d8$var$modalRadius = 16;
const $2971facc463cf8d8$var$modalColor = 0x1c1c2c;
const $2971facc463cf8d8$var$modalAlpha = 1;
class $2971facc463cf8d8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._asteroids = data.asteroids;
    }
    constructor(){
        super({
            key: "MiningModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$4560731aa3c2c725));
    }
    create() {
        this.input.topOnly = false;
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2971facc463cf8d8$var$modalWidth, $2971facc463cf8d8$var$modalHeight);
        // @ts-ignore
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale($2971facc463cf8d8$var$modalHeight),
            space: this.applyScale(40),
            sizerEvents: true
        });
        // @ts-ignore
        // Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($2971facc463cf8d8$var$modalWidth), this.applyScale($2971facc463cf8d8$var$modalHeight), this.applyScale($2971facc463cf8d8$var$modalRadius), $2971facc463cf8d8$var$modalColor, $2971facc463cf8d8$var$modalAlpha);
        this._sizer.add(background, {
            key: "mining_mission_availability_bg",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        const title = this.add.bitmapText(0, 0, "cc_outline", "Currently Available Mining Missions", this.applyScale(28), 0).setOrigin(0);
        this._sizer.add(title, {
            key: "mining_mission_title",
            align: "left-top",
            padding: {
                top: this.applyScale(23),
                left: this.applyScale(23)
            },
            expand: false
        });
        this._sizer.layout();
        const asteroidContentPane = new (0, $e819770d5217f27e$export$2e2bcd8739ae039)(this, 0, 0, this._asteroids, this._scale);
        this.add.existing(asteroidContentPane);
        this._sizer.add(asteroidContentPane, {
            key: "asteroid_content_pane",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(68),
            expand: false
        }).layout();
        this._sizer.onClickOutside(()=>{
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.unloadAssets();
            this.scene.stop();
        });
    }
    getScale() {
        return this._scale;
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.unloadAssets();
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$4560731aa3c2c725)));
    }
}




class $94be8e3a03a47712$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningLoadingScene"
        });
    }
    init(data) {
        this._asteroid = data.asteroid;
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f11b8de07dc7df14));
    }
    create() {
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_bar");
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 90, "cc_outline", "Loading Asteroid\ntracking software...", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        const text2 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 90, "cc_outline", "Deploying Asteroid\nscanner...", 26, 0).setOrigin(0.5, 0).setCenterAlign().setAlpha(0);
        const progress1 = this.add.image(this.sys.canvas.width / 2 - 122, this.sys.canvas.height / 2 + 50, "loading_prog_1").setAlpha(0);
        const progress2 = this.add.image(this.sys.canvas.width / 2 - 73, this.sys.canvas.height / 2 + 50, "loading_prog_2").setAlpha(0);
        const progress3 = this.add.image(this.sys.canvas.width / 2 - 34, this.sys.canvas.height / 2 + 50, "loading_prog_3").setAlpha(0);
        const progress4 = this.add.image(this.sys.canvas.width / 2 - 13, this.sys.canvas.height / 2 + 50, "loading_prog_4").setAlpha(0);
        const progress5 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_5").setAlpha(0);
        this.time.addEvent({
            delay: 500,
            loop: false,
            callback: ()=>this.tweens.add({
                    targets: progress1,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                })
        });
        this.time.addEvent({
            delay: 1250,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: [
                        progress2
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            delay: 2000,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: text1,
                    alpha: 0,
                    duration: 1000,
                    ease: "Power2"
                });
                this.tweens.add({
                    targets: [
                        text2,
                        progress3
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            delay: 2750,
            loop: false,
            callback: ()=>this.tweens.add({
                    targets: [
                        progress4
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                })
        });
        this.time.addEvent({
            delay: 3500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: progress5,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            delay: 4250,
            loop: false,
            callback: ()=>{
                this.scene.start("MiningDetailsScene", {
                    asteroid: this._asteroid
                });
            }
        });
    }
}













// Pane Details
const $98c06193e2958b4d$var$paneHeight = 400;
const $98c06193e2958b4d$var$paneWidth = 689;
const $98c06193e2958b4d$var$paneRadius = 16;
const $98c06193e2958b4d$var$paneColor = 0x262637;
const $98c06193e2958b4d$var$paneAlpha = 1;
const $98c06193e2958b4d$var$sizerBgColour = 0x383d57;
class $98c06193e2958b4d$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $98c06193e2958b4d$var$paneWidth,
            height: paneScale * $98c06193e2958b4d$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._playerData = data;
        this._squad = data.squadMembers;
        this._traits = data.traits;
        this._nfts = data.nfts;
        this._rarity = data.rarity;
        this._nft_boost = data.nft_boost;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        const miningTraits = (0, $5f7ad9227787a545$export$a9d922be773c87b7)(this._traits);
        const damagePerHour = (0, $5f7ad9227787a545$export$a1ed3db95f0f9415)(this._squad.reduce((acc, wolf)=>acc + wolf.hp, 0), this._rarity, miningTraits);
        const potentialNetDamage = Math.round(damagePerHour * this.getDamageMultiplyer());
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($98c06193e2958b4d$var$paneWidth), scene.applyScale($98c06193e2958b4d$var$paneHeight), scene.applyScale($98c06193e2958b4d$var$paneRadius), $98c06193e2958b4d$var$paneColor, $98c06193e2958b4d$var$paneAlpha);
        this.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Squad Panel
        var squadPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($98c06193e2958b4d$var$paneWidth),
            height: scene.applyScale(120),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // const squadPanelBg = scene.add.rexRoundRectangle(
        //     0, // x
        //     0, // y
        //     scene.applyScale(paneWidth), // width
        //     scene.applyScale(120), // height
        //     scene.applyScale(0), // radius
        //     0xdea827, // fillColor
        //     paneAlpha, // alpha
        // )
        // squadPanel.add(squadPanelBg, {
        //     key: "squad-panel-background",
        //     align: "center",
        //     offsetX: 0,
        //     offsetY: 0,
        //     expand: false,
        // })
        // Your Squad Label
        const squadLabel = scene.add.bitmapText(0, 0, "cc_outline", "Your Squad", scene.applyScale(18), 1);
        squadPanel.add(squadLabel, {
            key: "squad-label",
            align: "left-top",
            offsetX: this.applyScale(16),
            offsetY: this.applyScale(16),
            expand: false
        });
        var sm1 = this.createSquadMemberImage(scene, this._playerData.squadMembers[0]);
        squadPanel.add(sm1, {
            key: "squad-member-1",
            align: "left-top",
            offsetX: this.applyScale(20),
            offsetY: this.applyScale(50),
            expand: false
        });
        var sm2 = this.createSquadMemberImage(scene, this._playerData.squadMembers[1]);
        squadPanel.add(sm2, {
            key: "squad-member-2",
            align: "left-top",
            offsetX: this.applyScale(80),
            offsetY: this.applyScale(50),
            expand: false
        });
        var sm3 = this.createSquadMemberImage(scene, this._playerData.squadMembers[2]);
        squadPanel.add(sm3, {
            key: "squad-member-3",
            align: "left-top",
            offsetX: this.applyScale(140),
            offsetY: this.applyScale(50),
            expand: false
        });
        var damageLabel = this.scene.add.bitmapText(0, 0, "cc_outline", this.getDamageMultiplyerLabel(), this.applyScale(24), 1);
        squadPanel.add(damageLabel, {
            key: "damage-label",
            align: "right-top",
            offsetX: this.applyScale(-16),
            offsetY: this.applyScale(50),
            expand: false
        });
        var wolfCountLabel = this.scene.add.bitmapText(0, 0, "cc_outline", this.getWolfCountLabel(), this.applyScale(18), 1).setTint(0xa3a3b9);
        squadPanel.add(wolfCountLabel, {
            key: "wolf-count-label",
            align: "right-top",
            offsetX: this.applyScale(-16),
            offsetY: this.applyScale(80),
            expand: false
        });
        const squadDivider = this.scene.add.image(0, 0, "mining_divider").setScale(this._scale);
        squadPanel.add(squadDivider, {
            key: "squad-divider",
            align: "left-bottom",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.add(squadPanel, {
            key: "squad-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Damage Panel
        var damagePanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($98c06193e2958b4d$var$paneWidth),
            height: scene.applyScale(80),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        var dmhProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: `Damage per hour: ${damagePerHour.toLocaleString("en-us")}`,
                align: "left"
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: "",
                textAlign: "left",
                fontStyle: null,
                width: this.applyScale(315),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 100,
                glare: {
                    width: this.applyScale(305),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        damagePanel.add(dmhProgressBar, {
            key: "dph-progressbar",
            align: "left-top",
            offsetX: this.applyScale(20),
            offsetY: this.applyScale(30),
            expand: false
        });
        var pndProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: `Potential net damage: ${potentialNetDamage.toLocaleString("en-us")}`,
                align: "left"
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: "",
                textAlign: "left",
                fontStyle: null,
                width: this.applyScale(315),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 100,
                glare: {
                    width: this.applyScale(305),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        damagePanel.add(pndProgressBar, {
            key: "pnd-progressbar",
            align: "right-top",
            offsetX: this.applyScale(-20),
            offsetY: this.applyScale(30),
            expand: false
        });
        const damageDivider = this.scene.add.image(0, 0, "mining_divider").setScale(this._scale);
        damagePanel.add(damageDivider, {
            key: "damage-divider",
            align: "left-bottom",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.add(damagePanel, {
            key: "damage-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(120),
            expand: false
        });
        // Traits Pane
        var traitsPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($98c06193e2958b4d$var$paneWidth),
            height: scene.applyScale($98c06193e2958b4d$var$paneHeight - 80 - 120),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        const traitsList = (0, $5f7ad9227787a545$export$6d24a664fd705150)(this._traits);
        const table = this.createTraitsTable(this.scene, traitsList, x, y, this.scale).layout();
        traitsPanel.add(table, {
            key: "traits-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.add(traitsPanel, {
            key: "traits-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(200),
            expand: false
        });
        this.layout();
    }
    createSquadMemberImage(scene, squadMember) {
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new Phaser.GameObjects.Image(scene, 0, 0, this.getImageKey(squadMember));
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 3;
        smImageData.destroy();
        var squadMemberImage = this.scene.add.rexCircleMaskImage(0, 0, this.getImageKey(squadMember), "", rectConfig);
        squadMemberImage.displayHeight = scene.applyScale(48);
        squadMemberImage.scaleX = squadMemberImage.scaleY;
        return squadMemberImage;
    }
    getImageKey(squadMem) {
        if (squadMem.image_thumbnail_url && squadMem.image_thumbnail_url.length > 0 && squadMem.image_key && squadMem.image_key.length > 0) return squadMem.image_key;
        else return "starwolf_silhouette";
    }
    createTraitsTable(scene, data, x, y, scale) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($98c06193e2958b4d$var$paneWidth),
            height: this.applyScale($98c06193e2958b4d$var$paneHeight - 200),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($98c06193e2958b4d$var$paneWidth),
                cellHeight: this.applyScale(60),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var _a, _b;
                var scene = cell.scene, trait = cell.item;
                // Sizer variables
                const componentWidth = $98c06193e2958b4d$var$paneWidth, componentHeight = 60, componentRadius = 0, componentColor = 0x262637, componentAlpha = 1;
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(componentWidth),
                    height: scene.applyScale(componentHeight),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                })// Background
                .add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(componentWidth), scene.applyScale(componentHeight), scene.applyScale(componentRadius), componentColor, componentAlpha), {
                    key: "trait_cell_bg",
                    align: "center"
                })// Special Trait Label
                .add(scene.add.bitmapText(0, 0, "cc_outline", ((_a = trait.trait) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + " #" + trait.id, scene.applyScale(18), 0), {
                    key: `special-trait-label`,
                    align: "left-top",
                    offsetX: scene.applyScale(20),
                    offsetY: scene.applyScale(20),
                    expand: false
                })// Special Trait Description Label
                .add(scene.add.bitmapText(0, 0, "cc_outline", (_b = trait.description) === null || _b === void 0 ? void 0 : _b.toString(), scene.applyScale(16), 0).setAlpha(0.4), {
                    key: `special-trait-description-label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-20),
                    offsetY: scene.applyScale(20),
                    expand: false
                })// Divider
                .add(scene.add.image(0, 0, "mining_divider").setScale(scale), {
                    key: "damage-divider",
                    align: "left-bottom",
                    offsetX: scene.applyScale(0),
                    offsetY: scene.applyScale(0),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    getDamageMultiplyer() {
        return this._nft_boost;
    }
    getDamageMultiplyerLabel() {
        const prefix = this.getDamageMultiplyer().toString() + "x";
        const suffix = "dmg";
        return prefix + " " + suffix;
    }
    getWolfCountLabel() {
        var data = (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfoSync();
        const wolfCount = data.sw_genesis_count + data.sw_generative_count;
        if (wolfCount === 1) return "You own 1 wolf";
        return `You own ${wolfCount} wolvez`;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
Phaser.GameObjects.GameObjectFactory.register("miningAsteroidSquadPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $98c06193e2958b4d$export$2e2bcd8739ae039(this.scene, x, y));
});






const $2fff857bde90b115$var$width = 1044;
const $2fff857bde90b115$var$height = 731;
const $2fff857bde90b115$var$radius = 16;
const $2fff857bde90b115$var$color = 0x1c1c2c;
class $2fff857bde90b115$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningDetailsScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$a71a584b9c5c35a7));
    }
    init(data) {
        this._asteroid = data.asteroid;
        this._player = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._player.nft_boost = data.asteroid.nft_boost;
        this._player.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._player.traits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
        this._player.rarity = this._asteroid.asteroid_rarity_name;
        this._miningTraits = (0, $5f7ad9227787a545$export$a9d922be773c87b7)(this._player.traits);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2fff857bde90b115$var$width, $2fff857bde90b115$var$height);
        // @ts-ignore
        // Modal Background
        const modalBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($2fff857bde90b115$var$width), this.applyScale($2fff857bde90b115$var$height), this.applyScale($2fff857bde90b115$var$radius), $2fff857bde90b115$var$color);
        const asteroidRaritySizer = this.createAsteroidRaritySizer();
        const asteroidDetailsSizer = this.createAsteroidDetailsSizer();
        const asteroidActionsSizer = this.createAsteroidActionsSizer();
        // @ts-ignore
        const contentContainer = this.rexUI.add.sizer(0, 0, {
            space: {
                item: this.applyScale(29)
            }
        }).add(asteroidRaritySizer).add(asteroidDetailsSizer, {
            expand: true
        }).layout();
        // @ts-ignore
        const containerSizer = this.rexUI.add.sizer(0, 0, {
            orientation: "y",
            space: {
                item: this.applyScale(29)
            }
        }).add(contentContainer, {
            expand: true
        }).add(asteroidActionsSizer, {
            expand: true
        }).layout();
        // @ts-ignore
        this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2).addBackground(modalBackground).add(containerSizer, {
            expand: true,
            padding: {
                left: this.applyScale(29),
                right: this.applyScale(29),
                top: this.applyScale(29),
                bottom: this.applyScale(29)
            }
        }).layout();
    }
    createAsteroidRaritySizer() {
        // @ts-ignore
        const asteroidRarityBackground = this.add.rexRoundRectangle(0, 0, this.applyScale(257), this.applyScale(563), this.applyScale(16), (0, $682c5d521fb8ae22$export$b9b712abdb918f5b)[this._asteroid.asteroid_rarity_id], 1);
        const asteroidRarityImage = this.add// @ts-ignore
        .rexCircleMaskImage(0, 0, (0, $71499e2f29a18be8$export$fb4765ede2185826)[this._asteroid.asteroid_rarity_id], "").setScale(this._scale);
        const progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, this._scale, {
            title: {
                text: "",
                fontStyle: null
            },
            progressBar: {
                text: `Time allowed: ${(0, $2e76b527e9362cab$export$9446e10eb5cfa53)(this._asteroid.mine_time)}`,
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(257 / 1.3),
                height: this.applyScale(29),
                radius: this.applyScale(7),
                alpha: 1,
                color: 0x00a6d3,
                backgroundColor: 0x000000,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 0,
                glare: {
                    width: this.applyScale(257 / 1.4),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.17
                }
            }
        });
        // @ts-ignore
        return this.rexUI.add.overlapSizer(0, 0, this.applyScale(257), this.applyScale(563)).addBackground(asteroidRarityBackground).add(asteroidRarityImage, {
            align: "center",
            expand: false
        }).add(progressBar, {
            key: "asteroid_progress_bar",
            align: "center-bottom",
            offsetX: 0,
            offsetY: -this.applyScale(23) * 1.1,
            expand: false
        }).layout();
    }
    createAsteroidDetailsSizer() {
        const timeRequiredLabel = this.createAsteroidDetailsLabel("Estimated time required");
        const riskOfFailureLabel = this.createAsteroidDetailsLabel("Risk of failure");
        const asteroidHPLabel = this.createAsteroidDetailsLabel("Asteroid HP");
        const costToMineLabel = this.createAsteroidDetailsLabel("Cost to mine");
        const timeRequiredValue = this.createAsteroidDetailsValue((0, $2e76b527e9362cab$export$95207235cf472c1d)(this._asteroid.estimated_mine_time_finished));
        const riskOfFailureValue = this.createAsteroidDetailsValue(this._asteroid.failure_level);
        const asteroidHPValue = this.createAsteroidDetailsValue(this._asteroid.asteroid_hp.toLocaleString("en-us"));
        const costToMineValue = this.rexUI.add.sizer({
            space: {
                item: this.applyScale(37)
            }
        }).add(this.rexUI.add.sizer({
            space: {
                item: this.applyScale(8)
            }
        }).add(this.rexUI.add.sizer().add(this.add.image(0, 0, "space_elixir_icon").setScale(0.5)), {
            align: "center",
            expand: true
        }).add(this.add.bitmapText(0, 0, "cc_outline", this._asteroid.mine_cost_space_elixir.toLocaleString("en-us"), this.applyScale(22), 1), {
            align: "center",
            expand: true
        })).add(this.rexUI.add.sizer({
            space: {
                item: this.applyScale(8)
            }
        }).add(this.rexUI.add.sizer().add(this.add.image(0, 0, "neon_gold_icon").setScale(0.5)), {
            align: "center",
            expand: true
        }).add(this.add.bitmapText(0, 0, "cc_outline", this._asteroid.mine_cost_neon_gold.toLocaleString("en-us"), this.applyScale(22), 1), {
            align: "center",
            expand: true
        })).add(this.rexUI.add.sizer({
            space: {
                item: this.applyScale(8)
            }
        }).add(this.rexUI.add.sizer().add(this.add.image(0, 0, "stardust_icon").setScale(0.5)), {
            align: "center",
            expand: true
        }).add(this.add.bitmapText(0, 0, "cc_outline", this._asteroid.mine_cost_stardust.toLocaleString("en-us"), this.applyScale(22), 1), {
            align: "center",
            expand: true
        }));
        const offsetX = this.applyScale(689) / 3;
        // @ts-ignore
        const timeRequired = this.rexUI.add.sizer({
            orientation: "y"
        }).add(timeRequiredLabel, {
            align: "left"
        }).add(timeRequiredValue, {
            align: "left"
        }).layout();
        // @ts-ignore
        const riskOfFailure = this.rexUI.add.sizer({
            orientation: "y"
        }).add(riskOfFailureLabel, {
            align: "left"
        }).add(riskOfFailureValue, {
            align: "left"
        }).layout();
        // @ts-ignore
        const asteroidHP = this.rexUI.add.sizer({
            orientation: "y"
        }).add(asteroidHPLabel, {
            align: "left"
        }).add(asteroidHPValue, {
            align: "left"
        }).layout();
        // @ts-ignore
        const costToMine = this.rexUI.add.sizer({
            orientation: "y"
        }).add(costToMineLabel, {
            align: "left"
        }).add(costToMineValue, {
            align: "left"
        }).layout();
        // @ts-ignore
        const row1 = this.rexUI.add.overlapSizer({
            expand: true,
            width: this.applyScale(689)
        }).add(timeRequired).add(riskOfFailure, {
            offsetX: offsetX
        }).add(asteroidHP, {
            offsetX: offsetX + offsetX
        });
        // @ts-ignore
        const row2 = this.rexUI.add.overlapSizer(0, 0, {
            expand: true
        }).add(costToMine);
        // @ts-ignore
        const row3 = new (0, $98c06193e2958b4d$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        // @ts-ignore
        return this.rexUI.add.sizer({
            orientation: "y",
            space: {
                item: this.applyScale(27)
            },
            width: this.applyScale(689)
        }).add(row1, {
            expand: true
        }).add(row2, {
            expand: true
        }).add(row3, {
            expand: true
        }).layout();
    }
    createAsteroidActionsSizer() {
        // Back to Missions Button
        const backToMissionsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "mining_back_to_missions_button").setScale(this._scale);
        this.add.existing(backToMissionsButton);
        backToMissionsButton.onClick().subscribe(()=>{
            this.scene.start("HomebaseScene");
            this.unloadAssets();
            this.scene.stop();
        });
        // Launch Button
        const launchButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "mining_launch_button").setScale(this._scale);
        this.add.existing(launchButton);
        launchButton.onClick().subscribe(()=>{
            const asteroidId = this._asteroid.asteroid_id;
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().startMiningAsteroid(asteroidId, this._miningTraits).then(()=>{
                (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus().then(()=>{
                    this.scene.stop();
                    this.unloadAssets();
                    this.scene.start("MiningStatusScene", {
                        asteroidId: asteroidId
                    });
                });
            });
        });
        // @ts-ignore
        return this.rexUI.add.sizer(0, 0).add(backToMissionsButton, {
            align: "left"
        }).addSpace().add(launchButton, {
            align: "right"
        }).layout();
    }
    createAsteroidDetailsLabel(label) {
        return this.add.bitmapText(0, 0, "cc_outline", label, this.applyScale(16), 1).setTint(0xa3a3b9);
    }
    createAsteroidDetailsValue(value) {
        return this.add.bitmapText(0, 0, "cc_outline", value, this.applyScale(22));
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$a71a584b9c5c35a7)));
    }
}









function $d172780814a5a4b0$export$72be9685acb43539(squad) {
    return squad.reduce((acc, item)=>acc + item.hp, 0);
}




const $1a88a683ff58b16e$var$width = 1044;
const $1a88a683ff58b16e$var$height = 731;
const $1a88a683ff58b16e$var$radius = 16;
const $1a88a683ff58b16e$var$color = 0x1c1c2c;
class $1a88a683ff58b16e$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningStatusScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$905be90bf68d52dc));
    }
    init(data) {
        this._asteroidId = data.asteroidId;
        this._squad = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this._traits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($1a88a683ff58b16e$var$width, $1a88a683ff58b16e$var$height);
        const asteroids = (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatusSync();
        const asteroid = asteroids.find((asteroid)=>asteroid.asteroid_id === this._asteroidId);
        if (!asteroid) return this.destroy();
        const squadNetHP = (0, $d172780814a5a4b0$export$72be9685acb43539)(this._squad);
        const miningTraits = (0, $5f7ad9227787a545$export$a9d922be773c87b7)(this._traits);
        let rarity = "Common";
        switch(asteroid.asteroid_rarity_id){
            case 2:
                rarity = "Rare";
                break;
            case 3:
                rarity = "Epic";
                break;
            case 4:
                rarity = "Legendary";
                break;
            case 5:
                rarity = "Mythical";
                break;
        }
        const damagePerHour = (0, $5f7ad9227787a545$export$a1ed3db95f0f9415)(squadNetHP, rarity, miningTraits);
        const potentialNetDamage = Math.round(damagePerHour * asteroid.nft_boost);
        // @ts-ignore
        const modalBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($1a88a683ff58b16e$var$width), this.applyScale($1a88a683ff58b16e$var$height), this.applyScale($1a88a683ff58b16e$var$radius), $1a88a683ff58b16e$var$color);
        const timeRemainingLabel = this.add.bitmapText(0, 0, "cc_outline", "Time remaining", this.applyScale(16), 1).setTint(0xa3a3b9);
        const startTime = new Date(asteroid.user_mining_started_time * 1000).getTime();
        const endTime = new Date(asteroid.estimated_mine_time_finished * 1000).getTime();
        let nowSeconds = Math.floor(Date.now() / 1000);
        let startSeconds = Math.floor(startTime / 1000);
        let endSeconds = Math.floor(endTime / 1000);
        let remainingSeconds = Math.floor(endSeconds - nowSeconds);
        const timeRemainingProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: ""
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: (0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds),
                textAlign: "center",
                fontStyle: null,
                width: this.applyScale(313),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: startSeconds,
                maxValue: endSeconds,
                progressValue: startSeconds + remainingSeconds,
                glare: {
                    width: this.applyScale(303),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        this._timeRemainingInterval = setInterval(()=>{
            try {
                if (remainingSeconds <= 0) return clearInterval(this._timeRemainingInterval);
                remainingSeconds--;
                timeRemainingProgressBar.setProgressBarText((0, $2e76b527e9362cab$export$95207235cf472c1d)(remainingSeconds));
                timeRemainingProgressBar.setProgressValue(this, startSeconds + remainingSeconds);
            } catch (error) {
                return clearInterval(this._timeRemainingInterval);
            }
        }, 1000);
        this.add.existing(timeRemainingProgressBar);
        const timeRemainingSizer = this.rexUI.add.sizer(0, 0, {
            orientation: "y"
        }).add(timeRemainingLabel).add(timeRemainingProgressBar).layout();
        const damagePerHourProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            title: {
                text: `Damage per hour: ${potentialNetDamage.toLocaleString("en-us")}`
            },
            icon: undefined,
            border: {
                width: this.applyScale(1),
                color: 0x383d57
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: this.applyScale(313),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0x00a6d3,
                backgroundColor: 0x201425,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: 100,
                progressValue: 100,
                glare: {
                    height: this.applyScale(6),
                    width: this.applyScale(303),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        this.add.existing(damagePerHourProgressBar);
        const asteroidHPRemainingProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            title: {
                text: `Asteroid HP remaining: ${asteroid.asteroid_hp.toLocaleString("en-us")}`
            },
            icon: undefined,
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: this.applyScale(313),
                height: this.applyScale(22),
                radius: this.applyScale(7),
                color: 0xed0072,
                backgroundColor: 0xed0072,
                backgroundAlpha: 0.4,
                minValue: 0,
                maxValue: asteroid.asteroid_starting_hp,
                progressValue: asteroid.asteroid_hp,
                glare: {
                    width: this.applyScale(303),
                    height: this.applyScale(6),
                    radius: this.applyScale(3),
                    color: 0xffffff,
                    alpha: 0.14
                }
            }
        });
        this.add.existing(asteroidHPRemainingProgressBar);
        const backToHomebaseButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "mining_back_to_homebase_button").setScale(this._scale);
        this.add.existing(backToHomebaseButton);
        backToHomebaseButton.onClick().subscribe(()=>{
            this.destroy();
        });
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "mining_cancel_mission_button").setScale(this._scale);
        this.add.existing(cancelButton);
        cancelButton.onClick().subscribe(()=>{
            this.scene.launch("MiningCancelDialogScene", {
                asteroidId: this._asteroidId
            });
        });
        // @ts-ignore
        this.rexUI.add.sizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            orientation: "y",
            width: this.applyScale($1a88a683ff58b16e$var$width),
            height: this.applyScale($1a88a683ff58b16e$var$height),
            space: {
                item: this.applyScale(31)
            }
        }).addBackground(modalBackground).addSpace().add(this.add.rexCircleMaskImage(0, 0, "mining_paw").setScale(this._scale), {
            expand: false
        }).add(this.add.bitmapText(0, 0, "cc_outline", [
            "You are currently mining",
            `a ${(0, $682c5d521fb8ae22$export$aaac5bc6d10d929c)[asteroid.asteroid_rarity_id]} Asteroid`
        ], this.applyScale(24), 1).setWordTint((0, $682c5d521fb8ae22$export$aaac5bc6d10d929c)[asteroid.asteroid_rarity_id], 1, false, (0, $682c5d521fb8ae22$export$b9b712abdb918f5b)[asteroid.asteroid_rarity_id]).setTint(0xa3a3b9), {
            align: "center"
        }).add(timeRemainingSizer).add(damagePerHourProgressBar).add(asteroidHPRemainingProgressBar).add(this.add.bitmapText(0, 0, "cc_outline", "You can come back to check your\nprogress any time during the mine.", this.applyScale(16), 1).setTint(0xa3a3b9), {
            align: "center"
        }).addSpace().add(this.rexUI.add.sizer({
            x: 0,
            y: 0,
            width: this.applyScale($1a88a683ff58b16e$var$width),
            space: {
                left: this.applyScale(29),
                right: this.applyScale(29),
                bottom: this.applyScale(29),
                top: this.applyScale(29)
            }
        }).add(cancelButton, {
            align: "left"
        }).addSpace().add(backToHomebaseButton, {
            align: "right"
        }).layout()).layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.scene.start("HomebaseScene");
        this.unloadAssets();
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$905be90bf68d52dc)));
    }
}










const $da2de83273e530a5$var$modalHeight = 760;
class $da2de83273e530a5$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningResultScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$8f18fa8a20ab5c35));
    }
    init() {
        (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().claimLastMinedReward();
        this._traits = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync();
    }
    create() {
        const { height: height, width: width } = this.rexUI.viewport;
        this._reward = (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedRewardSync();
        // Apply Boost to XP Value for UI Display only
        this._reward.xp_earned = (0, $5f7ad9227787a545$export$3b8fb5d600233867)(this._reward.xp_earned, (0, $5f7ad9227787a545$export$a9d922be773c87b7)(this._traits).xpBoost);
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale(width, height);
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "mining_return_home_button");
        this.add.existing(returnHomeButton);
        returnHomeButton.onClick().subscribe(()=>{
            Promise.all([
                (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus(),
                (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getLastMinedReward()
            ]).then(()=>{
                this.scene.start("HomebaseScene");
                this.scene.launch("HudScene");
                this.unloadAssets();
                this.scene.stop();
            });
        });
        const spaceElixirLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", new Number(this._reward.space_elixir_reward).toLocaleString("en-us"));
        const neonGoldLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", new Number(this._reward.neon_gold_reward).toLocaleString("en-us"));
        const stardustLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", new Number(this._reward.stardust_reward).toLocaleString("en-us"));
        const experienceLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, undefined, `${this._reward.xp_earned} xp`);
        this.rexUI.add.sizer(width / 2, height / 2, {
            orientation: "y",
            width: width,
            height: this.applyScale($da2de83273e530a5$var$modalHeight)
        }).add(this.rexUI.add.sizer(0, 0, {
            orientation: "y"
        }).add(this.add.image(0, 0, this._reward.mining_success ? "mining_success_badge" : "mining_defeat_badge"), {
            expand: false,
            align: "center",
            padding: {
                bottom: this.applyScale(-40)
            }
        }).add(this.add.image(0, 0, this._reward.mining_success ? "mining_success_label" : "mining_defeat_label"), {
            expand: false,
            align: "center"
        }), {
            align: "top"
        }).addSpace().add(this.rexUI.add.sizer(0, 0, {
            orientation: "y",
            space: {
                item: this.applyScale(18)
            }
        }).add(this.add.bitmapText(0, 0, "cc_outline", this._reward.mining_success ? "You mined: " : "Mission cost: ", 20, 1)).add(this.add.existing(spaceElixirLabel)).add(this.add.existing(neonGoldLabel)).add(this.add.existing(stardustLabel)).add(this.add.existing(experienceLabel)), {
            align: "center"
        }).addSpace().add(returnHomeButton, {
            align: "bottom"
        }).layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$8f18fa8a20ab5c35)));
    }
}







const $a0b4660f66cdd07e$var$width = 494;
const $a0b4660f66cdd07e$var$height = 325;
const $a0b4660f66cdd07e$var$radius = 50;
class $a0b4660f66cdd07e$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningCancelDialogScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$7c7b01c296abb151));
    }
    init(data) {
        this._asteroidId = data.asteroidId;
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($a0b4660f66cdd07e$var$width, $a0b4660f66cdd07e$var$height);
        // Overlay
        this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c).setOrigin(0).setAlpha(0.5);
        const background = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($a0b4660f66cdd07e$var$width), this.applyScale($a0b4660f66cdd07e$var$height), this.applyScale($a0b4660f66cdd07e$var$radius), 0x350926).setStrokeStyle(1, 0x3d4361);
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), background.getBottomLeft().y, "mining_cancel_dialog_cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(94), background.getBottomLeft().y, "mining_cancel_dialog_confirm_button", false).setScale(this._scale);
        confirmButton.onClick().subscribe(()=>{
            (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().cancelMiningAsteroid(this._asteroidId).then(()=>{
                (0, $682c5d521fb8ae22$export$2e2bcd8739ae039).getInstance().getMiningStatus().then(()=>{
                    this.scene.get("MiningStatusScene").unloadAssets();
                    this.scene.stop("MiningStatusScene");
                    this.scene.start("HomebaseScene");
                    this.unloadAssets();
                    this.scene.stop();
                });
            });
        });
        this.add.existing(confirmButton);
        this.rexUI.add.sizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            orientation: "y",
            width: this.applyScale($a0b4660f66cdd07e$var$width),
            height: this.applyScale($a0b4660f66cdd07e$var$height),
            space: {
                item: this.applyScale(32)
            }
        }).addBackground(background).addSpace().add(this.add.bitmapText(0, 0, "cc_outline", "Are you sure you want to cancel?", this.applyScale(22), 1).setMaxWidth(200)).add(this.add.bitmapText(0, 0, "cc_outline", "Please note that only 80% of the resources that you have spent to launch this Mission will be refunded.", this.applyScale(18), 1).setTint(0xbfaac6).setMaxWidth(300)).addSpace().layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$7c7b01c296abb151)));
    }
}





const $85158c24f40e30dc$var$width = 494;
const $85158c24f40e30dc$var$height = 325;
const $85158c24f40e30dc$var$radius = 50;
class $85158c24f40e30dc$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "MiningNotEnoughResourcesDialogScene"
        });
    }
    preload() {
        this.load.image("mining_not_enough_resources_dialog_got_it_button", (0, $1aa2c39fc1fbb95e$export$538ba78e0dbb1045).mining_not_enough_resources_dialog_got_it_button);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($85158c24f40e30dc$var$width, $85158c24f40e30dc$var$height);
        // Overlay
        this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c).setOrigin(0).setAlpha(0.5);
        const background = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($85158c24f40e30dc$var$width), this.applyScale($85158c24f40e30dc$var$height), this.applyScale($85158c24f40e30dc$var$radius), 0x350926).setStrokeStyle(1, 0x3d4361);
        const gotItButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, background.getBottomLeft().y, "mining_not_enough_resources_dialog_got_it_button", false).setScale(this._scale);
        gotItButton.onClick().subscribe(()=>{
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(gotItButton);
        this.rexUI.add.sizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            orientation: "y",
            width: this.applyScale($85158c24f40e30dc$var$width),
            height: this.applyScale($85158c24f40e30dc$var$height),
            space: {
                item: this.applyScale(32)
            }
        }).addBackground(background).addSpace().add(this.add.bitmapText(0, 0, "cc_outline", "No Asteroids for you right now.", this.applyScale(22), 1).setMaxWidth(300)).add(this.add.bitmapText(0, 0, "cc_outline", "There are either currently no available Asteroids or you do not have the requisite resources to launch any Mining Missions.", this.applyScale(18), 1).setTint(0xbfaac6).setMaxWidth(300)).addSpace().layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}






class $af23907afa7de4a8$export$2e2bcd8739ae039 extends Phaser.Scene {
    constructor(){
        super({
            key: "BaseRaidLoadingScene"
        });
    }
    init(data) {
        this._next = data.next || 0;
        console.log(`data = ${data.next}`);
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$e6bf8b311fe6eef6));
    }
    create() {
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "loading_rect");
        this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_bar");
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 90, "cc_outline", "Finding a base with\njuicy resources...", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        const progress1 = this.add.image(this.sys.canvas.width / 2 - 122, this.sys.canvas.height / 2 + 50, "loading_prog_1").setAlpha(0);
        const progress2 = this.add.image(this.sys.canvas.width / 2 - 73, this.sys.canvas.height / 2 + 50, "loading_prog_2").setAlpha(0);
        const progress3 = this.add.image(this.sys.canvas.width / 2 - 34, this.sys.canvas.height / 2 + 50, "loading_prog_3").setAlpha(0);
        const progress4 = this.add.image(this.sys.canvas.width / 2 - 13, this.sys.canvas.height / 2 + 50, "loading_prog_4").setAlpha(0);
        const progress5 = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 50, "loading_prog_5").setAlpha(0);
        this.time.addEvent({
            delay: 500,
            loop: false,
            callback: ()=>this.tweens.add({
                    targets: progress1,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                })
        });
        this.time.addEvent({
            delay: 1250,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: [
                        progress2
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            delay: 2000,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: [
                        progress3
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            delay: 2750,
            loop: false,
            callback: ()=>this.tweens.add({
                    targets: [
                        progress4
                    ],
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                })
        });
        this.time.addEvent({
            delay: 3500,
            loop: false,
            callback: ()=>{
                this.tweens.add({
                    targets: progress5,
                    alpha: 1,
                    duration: 1000,
                    ease: "Power2"
                });
            }
        });
        this.time.addEvent({
            //delay: 4250,
            delay: 100,
            loop: false,
            callback: ()=>{
                // Get current base raid status
                (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((attackRes)=>{
                    // Remove log statement after testing
                    console.log((0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(attackRes));
                    // Check base raid state
                    if (attackRes.base_raid_id === 0 || attackRes.completed) // UI State 1: No base raid ongoing or results to show, user can attack
                    (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().getRandomBase(this._next).then((data)=>{
                        if (data.success) this.scene.start("BaseRaidDetailsScene", data);
                        else {
                            this.scene.start("HomebaseScene");
                            this.scene.launch("MessageScene", {
                                message: "There are no bases currently available to raid.  Check back later.",
                                title: "Raids Unavailable",
                                scene: this
                            });
                        }
                        this.unloadAssets();
                    });
                    else {
                        // UI State 2: Base raid is ongoing
                        this.scene.start("BaseRaidDetailsScene", Object.assign({}, attackRes, {
                            is_attacking: true
                        }));
                        this.unloadAssets();
                    }
                });
            }
        });
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$e6bf8b311fe6eef6)));
    }
}



const $3bf678e8720894cb$var$machineTypes = {
    mainframe: "mainframe",
    space_elixir_storage: "space_elixir_storage",
    space_elixir_mine: "space_elixir_mine",
    neon_gold_storage: "neon_gold_storage",
    neon_gold_mine: "neon_gold_mine",
    star_lab: "star_laboratory"
};
class $3bf678e8720894cb$export$2e2bcd8739ae039 extends (0, $7229471446732a65$export$2e2bcd8739ae039) {
    getActions(scene) {
        return [];
    }
    createDialog(scene, x, y) {
        this._dialog = scene.rexUI.add.dialog({
            x: x,
            y: y,
            //width: 200,
            background: scene.rexUI.add.roundRectangle(0, 0, 100, 100, 16, 0x201425).setAlpha(0.7).setStrokeStyle(2, 0x000000, 0.9).setInteractive(),
            title: this.createTitle(scene, this.getMachineTitle()),
            //content: this.createContent(scene),//this.createTitle(scene, `Level: ${this._machine.level}\n\nYield: N/A\n\nStorage: N/A`, 18, 0.4),
            //description: this.createTitle(scene, 'Yield: N/A\nStorage: N/A', 18, 0.4),
            actions: this.getActions(scene, this._machine.key === $3bf678e8720894cb$var$machineTypes.star_lab),
            // actions: [
            //     this.createButton(scene, 'Action0'),
            //     this.createButton(scene, 'Action1')
            // ],
            space: {
                left: this._machineInfoSpacing.left,
                right: this._machineInfoSpacing.right,
                top: this._machineInfoSpacing.top,
                bottom: 0,
                title: 10,
                // titleLeft: 30,
                //titleBottom: 20,
                //content: 20,
                //contentLeft: 10,
                //description: 20,
                //descriptionLeft: 10,
                // descriptionRight: 20,
                //descriptionBottom: 20,
                //choices: 20,
                actions: 10,
                //toolbarItem: 5,
                //choice: 15,
                action: 10
            },
            expand: {
                title: false,
                // content: false,
                // description: true,
                choices: false,
                actions: false
            },
            align: {
                title: "center",
                content: "left",
                description: "left",
                choices: "center",
                actions: "center"
            },
            click: {
                mode: "release"
            }
        }).setOrigin(0.5, 1).setDepth(1000)//.setDraggable('background')   // Draggable-background
        .layout()// .drawBounds(this.add.graphics(), 0xff0000)
        .popUp(200);
        var tween = scene.tweens.add({
            targets: this._dialog,
            scaleX: 1,
            scaleY: 1,
            ease: "Bounce",
            duration: 200,
            repeat: 0,
            yoyo: false
        });
        scene.input.on("pointerdown", function(pointer) {
            if (this._dialog && !this._dialog.isInTouching(pointer)) {
                this._dialog.scaleDownDestroy(100);
                this._dialog = undefined;
            }
        }, this);
    // var clickOutside = scene.plugins.get('rexClickOutsiden').add(dialog, {
    //     enable: true,
    //     mode: 1,
    //     clickInterval: 100
    // });
    // clickOutside.on('clickoutside', function (clickoutside, gameObject, pointer) {
    //     dialog.scaleDownDestroy(100);
    //     this._dialog = undefined;
    // }, scene);
    }
}




const $3e8b99fb24af68a7$var$cellWidth = 64;
class $3e8b99fb24af68a7$export$2e2bcd8739ae039 extends (0, $8d346123ca66a5ed$export$2e2bcd8739ae039) {
    constructor(){
        super({
            key: "BaseRaidDetailsScene"
        });
    }
    preload() {}
    init(base) {
        this._base = base;
    }
    create() {
        this.input.mouse.disableContextMenu();
        // Set Background
        document.body.style.backgroundImage = "none";
        this._map = this.make.tilemap({
            key: "homebase_map"
        });
        this._tileset = this._map.addTilesetImage("homebase_tileset_64", "tiles", 64, 64, 1, 2);
        this._blobLayer = this._map.createLayer("Blob Layer", this._tileset);
        this._blobLayer.setAlpha(0.5);
        this._baseLayer = this._map.createLayer("Tile Layer 1", this._tileset);
        this._userMachines = this._base.defender_machines;
        this.createMachines(false);
        this.cameras.main.setBounds(-200, 440, this._map.widthInPixels + 400, this._map.heightInPixels - 200);
        // Handle keyboard arrows
        this.cursors = this.input.keyboard.createCursorKeys();
        // Handle homebase drag
        this.input.on("pointermove", function(p) {
            if (!p.isDown || this._isDragging) return;
            this.cameras.main.scrollX -= (p.x - p.prevPosition.x) / this.cameras.main.zoom;
            this.cameras.main.scrollY -= (p.y - p.prevPosition.y) / this.cameras.main.zoom;
        }, this);
        // Handle scroll/zoom
        this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ)=>{
            if (deltaY > 0) {
                var newZoom = this.cameras.main.zoom - 0.1;
                if (newZoom > 0.6) this.cameras.main.setZoom(newZoom);
            }
            if (deltaY < 0) {
                var newZoom = this.cameras.main.zoom + 0.1;
                if (newZoom < 1.6) this.cameras.main.setZoom(newZoom);
            }
        // this.cameras.main.centerOn(pointer.worldX, pointer.worldY);
        // this.cameras.main.pan(pointer.worldX, pointer.worldY, 2000, "Power2");
        });
        // Display HUD
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy().then((res)=>{
            this.launchScene("BaseRaidHudScene", {
                base_raid_view_info: this._base,
                is_attacking: this._base.is_attacking
            });
        });
    }
    launchScene(scene, data) {
        this.scene.launch(scene, data);
        this.gameScene = this.scene.get(scene);
    }
    addMachine(machine, cellX, cellY) {
        const widthInTiles = this.getWidthInTiles(machine);
        var newMachine = new (0, $3bf678e8720894cb$export$2e2bcd8739ae039)(this, cellX, cellY, machine, 1, widthInTiles);
        if (!this._machineObjects) this._machineObjects = [];
        this._machineObjects.push(newMachine);
    //this.add.existing(newMachine);
    // newMachine.x = cellWidth * cellX + (cellWidth * widthInTiles) / 2
    // newMachine.y = cellWidth * cellY + cellWidth
    }
    applyScale(length) {
        return length;
    }
    updateMachines() {
        // Add image keys to machine data, add new machine objects to UI and object list
        this._userMachines.forEach((mach)=>{
            mach.imageKey = `machines_${mach.key}`;
            this.addMachine(mach, mach.x, mach.y);
        });
    }
    disableDestroyedMachines(baseRaidViewInfo) {
        var remainingDefenderMachineIds = [];
        baseRaidViewInfo.base_raid_execution[0].defender_machines.forEach((dm)=>{
            remainingDefenderMachineIds.push(dm.user_machine_id);
        });
        const destroyedMachines = this._machineObjects.filter((mo)=>!remainingDefenderMachineIds.includes(mo.getMachine().user_machine_id));
        destroyedMachines.forEach((dm)=>{
            dm.setDestroyed(true);
        });
    }
}











const $2a3a93ffca95df28$var$paneWidth = 685;
const $2a3a93ffca95df28$var$paneHeight = 108;
const $2a3a93ffca95df28$var$tintColor = 0xcdcdcd;
const $2a3a93ffca95df28$var$resources = {
    space_elixir: "space_elixir",
    neon_gold: "neon_gold",
    stardust: "stardust"
};
const $2a3a93ffca95df28$var$titleSpace = 11;
const $2a3a93ffca95df28$var$itemSpace = 6;
const $2a3a93ffca95df28$var$groupSpace = 24;
class $2a3a93ffca95df28$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: scene.applyScale(110),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._lootData = data;
        return this.createComponent(scene);
    }
    createComponent(scene) {
        // Available Loot Label
        this.add(scene.add.bitmapText(0, 0, "cc_outline", "Available Loot:", scene.applyScale(16), 0), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "available_loot_label"
        });
        // SE
        this.add(this.scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, `space_elixir_icon`).setScale(0.65 * this._scale),
            text: scene.add.bitmapText(0, 0, "cc_outline", this._lootData.attacker_possible_loot.space_elixir, scene.applyScale(18), 0),
            space: {
                icon: scene.applyScale(8)
            }
        }), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$titleSpace),
                bottom: 0
            },
            key: "available_loot_se"
        });
        // NG
        this.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, "neon_gold_icon").setScale(0.65 * this._scale),
            text: scene.add.bitmapText(0, 0, "cc_outline", this._lootData.attacker_possible_loot.neon_gold, scene.applyScale(18), 0),
            space: {
                icon: scene.applyScale(8)
            }
        }), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$itemSpace),
                bottom: 0
            },
            key: "available_loot_ng"
        });
        // Win Bonus Label
        this.add(scene.add.bitmapText(0, 0, "cc_outline", "Win Bonus:", scene.applyScale(16), 0), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$groupSpace),
                bottom: 0
            },
            key: "win_bonus_label"
        });
        // XP
        this.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, "trophy_icon_small").setScale(this._scale),
            text: scene.add.bitmapText(0, 0, "cc_outline", "500xp", scene.applyScale(18), 0),
            space: {
                icon: scene.applyScale(8)
            }
        }), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$titleSpace),
                bottom: 0
            },
            key: "win_bonus_xp"
        });
        // SD
        /*
        this.add(
          scene.rexUI.add.label({
            orientation: 'x',
            rtl: false,
            icon: scene.add.image(0, 0, 'stardust_icon').setScale(0.65),
            text: scene.add.bitmapText(0, 0, 'cc_outline', '15', 18, 0),
            space: {
              icon: 8,
            },
          }),
          {
            padding: { left: 0, right: 0, top: itemSpace, bottom: 0 },
            key: 'win_bonus_sd',
          },
        );
        */ // Defeat Label
        this.add(scene.add.bitmapText(0, 0, "cc_outline", "Defeat:", scene.applyScale(16), 0), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$groupSpace),
                bottom: 0
            },
            key: "defeat_label"
        });
        // XP
        this.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, "trophy_icon_small").setScale(this._scale),
            text: scene.add.bitmapText(0, 0, "cc_outline", "-500xp", scene.applyScale(18), 0),
            space: {
                icon: scene.applyScale(8)
            }
        }), {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale($2a3a93ffca95df28$var$titleSpace),
                bottom: 0
            },
            key: "defeat_xp"
        });
        return this.layout();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("raidLootInfoComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $2a3a93ffca95df28$export$2e2bcd8739ae039(this.scene, x, y));
});









const $e8759a10eb746fa8$var$componentWidth = 264;
const $e8759a10eb746fa8$var$componentHeight = 70;
const $e8759a10eb746fa8$var$imageHeight = 50;
const $e8759a10eb746fa8$var$imageWidth = 50;
const $e8759a10eb746fa8$var$imageRadius = 9;
const $e8759a10eb746fa8$var$fontColor = 0xffffff;
const $e8759a10eb746fa8$var$secondaryFontAlpha = 0.3;
const $e8759a10eb746fa8$var$grayProgressBarColor = 0x8c8c8c;
const $e8759a10eb746fa8$var$progressBarAlpha = 1;
const $e8759a10eb746fa8$var$glareColor = 0xffffff;
const $e8759a10eb746fa8$var$glareAlpha = 0.17;
const $e8759a10eb746fa8$var$glareRadius = 3;
const $e8759a10eb746fa8$var$glareHeight = 6;
const $e8759a10eb746fa8$var$glareOffset = 10;
const $e8759a10eb746fa8$var$backgroundColor = 0x65526f;
const $e8759a10eb746fa8$var$backgroundAlpha = 0.4;
const $e8759a10eb746fa8$var$radius = 7;
const $e8759a10eb746fa8$var$progressBarBorderColor = 0x383d57;
const $e8759a10eb746fa8$var$progressBarBorderWidth = 1;
const $e8759a10eb746fa8$var$progressBarHeight = 16;
const $e8759a10eb746fa8$var$progressBarWidth = 175;
const $e8759a10eb746fa8$var$progressBarMin = 0;
class $e8759a10eb746fa8$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, unit, paneScale, config){
        console.log(JSON.stringify(unit.shopImageKey));
        let conf = {
            width: $e8759a10eb746fa8$var$componentWidth * (paneScale || 1),
            height: $e8759a10eb746fa8$var$componentHeight * (paneScale || 1),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._unit = unit; // { display_name, level, image_key, max_hp, current_hp }
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        // Unit Image
        this.addUnitImage();
        // Unit Title/Level Sizer
        const titleSizer = scene.rexUI.add.fixWidthSizer(0, 0, {
            width: scene.applyScale(180),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Unit Title
        titleSizer.add(scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), scene.applyScale(16), 0).setMaxWidth(scene.applyScale(140)), {
            key: "title_text",
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        // Unit Level
        titleSizer.add(scene.add.bitmapText(0, 0, "cc_outline", this.getLevelText(), scene.applyScale(16), 0).setMaxWidth(scene.applyScale(40)).setAlpha(0.3), {
            key: "level_text",
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this.add(titleSizer.layout(), {
            key: "title_sizer",
            align: "left-top",
            offsetX: scene.applyScale(74),
            offsetY: this.scene.applyScale(17),
            expand: false
        });
        // Progress Bar
        this.add(this.createProgressBar(scene), {
            key: "unit_prog_bar",
            align: "left-top",
            offsetX: scene.applyScale(74),
            offsetY: this.scene.applyScale(42),
            expand: false
        });
        return this.layout();
    }
    addUnitImage() {
        const imageKey = this.getImageKey();
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        if (this._unit.machine_unit_id) {
            // Troop
            // Image Data
            const imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this.scene, 0, 0, imageKey);
            const imageWidth = imageData.width;
            rectConfig.radius = imageWidth / 5;
            // Image
            const unitImage = this.scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
            // Scale Image
            unitImage.displayHeight = $e8759a10eb746fa8$var$imageHeight;
            unitImage.scaleX = unitImage.scaleY;
            unitImage.setScale(this._scale * unitImage.scaleY);
            imageData.destroy();
            this.add(unitImage, {
                key: "unit_image",
                align: "left-top",
                offsetX: this.scene.applyScale(11),
                offsetY: this.scene.applyScale(11),
                expand: false
            });
        } else {
            // Machine
            const baseTexture = this.scene.textures.get(imageKey);
            const frameName = `${imageKey}_centered`;
            baseTexture.add(`${imageKey}_full`, 0, 0, 0, 250, 361);
            baseTexture.add(frameName, 0, 25, 86, 200, 200);
            const unitImage = this.scene.add.rexCircleMaskImage(0, 0, imageKey, frameName, {
                maskType: "roundRectangle",
                radius: this.scene.applyScale(30),
                origin: {
                    x: 0.5,
                    y: 0.5
                }
            });
            unitImage.displayHeight = $e8759a10eb746fa8$var$imageHeight;
            unitImage.scaleX = unitImage.scaleY;
            unitImage.setScale(unitImage.scaleY * this._scale);
            this.add(unitImage, {
                key: "unit_image",
                align: "left-top",
                offsetX: this.scene.applyScale(11),
                offsetY: this.scene.applyScale(11),
                expand: false
            });
        }
    }
    createProgressBar(scene) {
        const progressValue = 0;
        const maxValue = 100;
        // Progress Bar
        const progBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                offset: 2,
                fontSize: 20
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $e8759a10eb746fa8$var$progressBarWidth,
                height: $e8759a10eb746fa8$var$progressBarHeight,
                radius: $e8759a10eb746fa8$var$radius,
                color: $e8759a10eb746fa8$var$grayProgressBarColor,
                alpha: $e8759a10eb746fa8$var$progressBarAlpha,
                backgroundColor: $e8759a10eb746fa8$var$backgroundColor,
                backgroundAlpha: $e8759a10eb746fa8$var$backgroundAlpha,
                minValue: $e8759a10eb746fa8$var$progressBarMin,
                maxValue: this._unit.initial_hitpoints === undefined ? 1 : this._unit.initial_hitpoints,
                progressValue: this._unit.initial_hitpoints === undefined ? 1 : this._unit.hitpoints,
                glare: {
                    height: $e8759a10eb746fa8$var$glareHeight,
                    width: $e8759a10eb746fa8$var$progressBarWidth - $e8759a10eb746fa8$var$glareOffset,
                    radius: $e8759a10eb746fa8$var$glareRadius,
                    color: $e8759a10eb746fa8$var$glareColor,
                    alpha: $e8759a10eb746fa8$var$glareAlpha
                }
            },
            border: {
                alpha: $e8759a10eb746fa8$var$backgroundAlpha,
                color: $e8759a10eb746fa8$var$progressBarBorderColor,
                width: $e8759a10eb746fa8$var$progressBarBorderWidth
            }
        });
        return scene.add.existing(progBar);
    }
    getImageKey() {
        if (this._unit.machine_id) // Machine
        return this._unit.shopImageKey;
        else // Troop
        return (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopImageKey(this._unit.machine_unit_id);
    }
    getDisplayName() {
        if (this._unit && this._unit.display_name) return this._unit.display_name.length > 16 ? `${this._unit.display_name.toUpperCase().substring(0, 14)}... ` : `${this._unit.display_name.toUpperCase()} `;
        else return "UNKNOWN ";
    }
    getLevelText() {
        if (this._unit && this._unit.level) return `LV. ${this._unit.level}`;
        else return "LV. 0";
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("raidUnitComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $e8759a10eb746fa8$export$2e2bcd8739ae039(this.scene, x, y));
});


const $8aad40827bead1a1$var$panelWidth = 264;
const $8aad40827bead1a1$var$panelHeight = 270;
const $8aad40827bead1a1$var$panelColor = 0x350926;
const $8aad40827bead1a1$var$panelAlpha = 0.9;
const $8aad40827bead1a1$var$panelRadius = 8;
const $8aad40827bead1a1$var$tabHeight = 27;
const $8aad40827bead1a1$var$troopsTabWidth = 71;
const $8aad40827bead1a1$var$machinesTabWidth = 90;
const $8aad40827bead1a1$var$tabRadius = 10;
const $8aad40827bead1a1$var$activeTabColor = 0x6262de;
const $8aad40827bead1a1$var$inactiveTabColor = 0x32324d;
const $8aad40827bead1a1$var$tabFontSize = 18;
class $8aad40827bead1a1$export$2e2bcd8739ae039 extends (0, $0f6ec962fc4b1b22$export$2e2bcd8739ae039) {
    constructor(scene, x, y, baseRaidAttackInfo, paneScale, config){
        var _a, _b;
        var createButton = function(scene, text, width, color) {
            const btn = scene.rexUI.add.label({
                background: scene.rexUI.add.roundRectangle(0, 0, scene.applyScale(width), scene.applyScale($8aad40827bead1a1$var$tabHeight), {
                    tl: scene.applyScale($8aad40827bead1a1$var$tabRadius),
                    tr: scene.applyScale($8aad40827bead1a1$var$tabRadius)
                }, color),
                text: scene.add.bitmapText(0, 0, "cc_outline", text, scene.applyScale($8aad40827bead1a1$var$tabFontSize), 0),
                space: {
                    left: scene.applyScale(10),
                    right: scene.applyScale(10),
                    top: scene.applyScale(10),
                    bottom: scene.applyScale(10)
                }
            });
            btn.setInteractive({
                cursor: "pointer"
            });
            return btn;
        };
        let conf = config ? config : {
            x: x,
            y: y,
            background: scene.rexUI.add.roundRectangle(0, 0, scene.applyScale(10), scene.applyScale(10), 0, 0x333333).setAlpha(0),
            panel: scene.rexUI.add.fixWidthSizer(0, 0, {
                width: scene.applyScale($8aad40827bead1a1$var$panelWidth),
                height: scene.applyScale($8aad40827bead1a1$var$panelHeight),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    item: 0,
                    line: 0
                },
                align: 0
            }).addBackground(scene.rexUI.add.roundRectangle(0, 0, scene.applyScale($8aad40827bead1a1$var$panelWidth), scene.applyScale($8aad40827bead1a1$var$panelHeight), scene.applyScale($8aad40827bead1a1$var$panelRadius), $8aad40827bead1a1$var$panelColor, $8aad40827bead1a1$var$panelAlpha)),
            topButtons: [
                // Troops Tab
                createButton(scene, "Troops", $8aad40827bead1a1$var$troopsTabWidth, $8aad40827bead1a1$var$activeTabColor),
                // Machines Tab
                createButton(scene, "Machines", $8aad40827bead1a1$var$machinesTabWidth, $8aad40827bead1a1$var$inactiveTabColor)
            ],
            space: {
                left: scene.applyScale(20),
                right: scene.applyScale(20),
                top: scene.applyScale(20),
                bottom: scene.applyScale(20),
                topButtonsOffset: scene.applyScale(20),
                topButton: scene.applyScale(10)
            }
        };
        super(scene, conf);
        this._baseRaidAttackInfo = baseRaidAttackInfo;
        this._scale = paneScale;
        this._selectedTabIndex = 0;
        this._troopData = (_a = baseRaidAttackInfo.base_raid_execution[0]) === null || _a === void 0 ? void 0 : _a.attacker_squadtroops;
        this._machineData = (_b = baseRaidAttackInfo.base_raid_execution[0]) === null || _b === void 0 ? void 0 : _b.defender_machines;
        this.enrichData();
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        var _a;
        this.addButtonEvents(scene, x, y);
        this.createTable(scene, this.getTableData());
        if (this._table) (_a = this.getElement("panel")) === null || _a === void 0 || _a.add(this._table);
        this.layout();
    }
    createTable(scene, data) {
        if (!data || data.length === 0) return;
        var table = scene.rexUI.add.gridTable({
            width: scene.applyScale($8aad40827bead1a1$var$panelWidth),
            height: scene.applyScale(70 * data.length > $8aad40827bead1a1$var$panelHeight ? $8aad40827bead1a1$var$panelHeight : 70 * data.length - 1),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: scene.applyScale($8aad40827bead1a1$var$panelWidth),
                cellHeight: scene.applyScale(70),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {}
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                return scene.add.existing(new (0, $e8759a10eb746fa8$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale()));
            }
        });
        this._table = table.layout();
    }
    addButtonEvents(scene, x, y) {
        this.on("button.click", (button, groupName, index, pointer)=>{
            var _a, _b;
            if (this._selectedTabIndex === index) return;
            // Set selected tab
            this._selectedTabIndex = index;
            this._troopData = (_a = this._baseRaidAttackInfo.base_raid_execution[0]) === null || _a === void 0 ? void 0 : _a.attacker_squadtroops;
            this._machineData = (_b = this._baseRaidAttackInfo.base_raid_execution[0]) === null || _b === void 0 ? void 0 : _b.defender_machines;
            this.enrichData();
            this.refreshPanel(this.scene);
        });
        this.on("button.over", (button, groupName, index, pointer)=>{
            if (this._selectedTabIndex === index) return;
            button.setAlpha(0.8);
        });
        this.on("button.out", (button, groupName, index, pointer)=>{
            button.setAlpha(1);
        });
    }
    refreshPanel(scene) {
        var _a, _b, _c;
        // Set tab colors
        this.forEachTopButton((button, index, buttons)=>{
            if (index === this._selectedTabIndex) button.getElement("background").setFillStyle($8aad40827bead1a1$var$activeTabColor, 1);
            else button.getElement("background").setFillStyle($8aad40827bead1a1$var$inactiveTabColor, 1);
        }, this);
        // Clear panel
        (_a = this.getElement("panel")) === null || _a === void 0 || _a.remove(this._table, true);
        this._table = undefined;
        // Add table
        this.createTable(scene, this.getTableData());
        if (this._table) (_b = this.getElement("panel")) === null || _b === void 0 || _b.add(this._table);
        (_c = this.getElement("panel")) === null || _c === void 0 || _c.layout();
    }
    updateData(baseRaidAttackInfo) {
        var _a, _b;
        this._baseRaidAttackInfo = baseRaidAttackInfo;
        this._troopData = (_a = baseRaidAttackInfo.base_raid_execution[0]) === null || _a === void 0 ? void 0 : _a.attacker_squadtroops;
        this._machineData = (_b = baseRaidAttackInfo.base_raid_execution[0]) === null || _b === void 0 ? void 0 : _b.defender_machines;
        this.enrichData();
        this.refreshPanel(this.scene);
    }
    enrichData() {
        const enrichedMachineData = this._machineData.map((mach)=>{
            const fullData = this._baseRaidAttackInfo.defender_machines.find((def_mach)=>def_mach.user_machine_id === mach.user_machine_id);
            const mergedData = Object.assign({}, fullData, mach);
            return mergedData;
        });
        const enrichedTroopData = this._troopData.filter((tr)=>!!tr.machine_unit_id).map((troop)=>{
            return this.enrichTroopData(troop);
        });
        this._machineData = enrichedMachineData;
        this._troopData = enrichedTroopData;
    }
    enrichTroopData(troop) {
        troop.display_name = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopDisplayName(troop.machine_unit_id);
        return troop;
    }
    getTableData() {
        return this._selectedTabIndex === 0 ? this._troopData : this._machineData;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("raidUnitsInfoComponent", function(x, y, config) {
    // @ts-ignore
    return this.displayList.add(new $8aad40827bead1a1$export$2e2bcd8739ae039(this.scene, x, y, config));
});





const $da29a484c2d3441e$var$paneWidth = 110;
const $da29a484c2d3441e$var$defaultTimeUntilAttack = 30; // seconds
class $da29a484c2d3441e$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: scene.applyScale($da29a484c2d3441e$var$paneWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._clockData = data;
        this._timeRemaining = this.getInitialTimeRemaining();
        this.createComponent(scene);
        this.setTimeEvent();
        return this.layout();
    }
    createComponent(scene) {
        this.add(scene.add.bitmapText(0, 0, "cc_outline", this.getHeaderText(), scene.applyScale(16), 1), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "header_text"
        });
        this._timerText = scene.add.bitmapText(0, 0, "cc_outline", this.getTimerText(), scene.applyScale(20), 1);
        this.add(this._timerText, {
            padding: {
                left: 0,
                right: 0,
                top: scene.applyScale(3),
                bottom: 0
            },
            key: "timer_text"
        });
    }
    setTimeEvent() {
        this.scene.time.addEvent({
            delay: 1000,
            loop: true,
            callback: ()=>{
                this.updateTimeHandler();
            }
        });
    }
    getHeaderText() {
        return this._clockData.isAttacking ? "Remaining Time:" : "Raid starts in: ";
    }
    getTimerText() {
        return this._timeRemaining < 10 ? ` ${(0, $f12f0c85b935f07d$export$a14e8754c327dfd0)(this._timeRemaining)}` : (0, $f12f0c85b935f07d$export$a14e8754c327dfd0)(this._timeRemaining);
    }
    getInitialTimeRemaining() {
        return this._clockData.isAttacking ? this._clockData.timeRemaining : $da29a484c2d3441e$var$defaultTimeUntilAttack;
    }
    updateTimeHandler() {
        if (this._timeRemaining > 0) {
            this._timeRemaining = this._timeRemaining - 1;
            this._timerText.text = this.getTimerText();
        } else {
            this._timeRemaining = 0;
            this._timerText.text = this.getTimerText();
            this.timerFinishedHandler();
        }
    }
    timerFinishedHandler() {
        // Remove timer update event
        this.scene.time.removeAllEvents();
        if (this._clockData.isAttacking) // Handle attack finished
        this.scene.scene.get("BaseRaidHudScene").handleAttackFinished();
        else // Start attack
        this.scene.scene.get("BaseRaidHudScene").startAttack();
    }
    setClockData(clockData) {
        if (clockData) {
            // Update data
            this._clockData = clockData;
            this._timeRemaining = clockData.timeRemaining;
            // Remove old timer events
            this.scene.time.removeAllEvents();
            // Set Header text
            this.getElement("header_text").setText(this.getHeaderText());
            // Add new timer event
            this.updateTimeHandler();
            this.setTimeEvent();
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("raidClockComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $da29a484c2d3441e$export$2e2bcd8739ae039(this.scene, x, y));
});




const $6bd66ac4da17bcf8$var$defaultTimeUntilAttack = 30; // seconds
const $6bd66ac4da17bcf8$var$minCanvasWidth = 1330;
const $6bd66ac4da17bcf8$var$minCanvasHeight = 860;
class $6bd66ac4da17bcf8$export$2e2bcd8739ae039 extends (0, $2df50fb7fccdbf03$export$2e2bcd8739ae039) {
    constructor(){
        super({
            key: "BaseRaidHudScene"
        });
        this._self = this;
    }
    init(data) {
        var _a;
        console.log(data);
        this._defenderUserAddress = (_a = data.base_raid_view_info.defender_user) === null || _a === void 0 ? void 0 : _a.user_address;
        this._defenderMachines = data.base_raid_view_info.defender_machines;
        this._baseRaidViewInfo = data.base_raid_view_info;
        this._isAttacking = data.is_attacking || false;
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$d4d19d986b8fcaa2));
        Object.keys((0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)).forEach((sa_key)=>{
            if (sa_key.includes("shop_machines")) this.load.image(sa_key, (0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)[sa_key]);
        });
        super.preload();
    }
    destroy() {
        clearInterval(this._timeoutId);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($6bd66ac4da17bcf8$var$minCanvasWidth, $6bd66ac4da17bcf8$var$minCanvasHeight);
        this.input.keyboard.enabled = true;
        clearInterval(this._timeoutId);
        (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true, this._defenderUserAddress).then((data)=>{
            this._self._userData = data;
            this._allowProgressBarClicks = false;
            this.addLevelBar(this);
            this.addResourcesComponent(this._defenderMachines);
        });
        // Countdown Timer
        this._raidClock = new (0, $da29a484c2d3441e$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, this.applyScale(43), {
            isAttacking: this._isAttacking,
            timeRemaining: this._isAttacking ? this.getTimeRemaining(this._baseRaidViewInfo) : $6bd66ac4da17bcf8$var$defaultTimeUntilAttack
        }, this._scale);
        this.add.existing(this._raidClock);
        // Loot Info
        const lootInfoComponent = new (0, $2a3a93ffca95df28$export$2e2bcd8739ae039)(this, this.applyScale(84), this.applyScale(230), this._baseRaidViewInfo, this._scale).setOrigin(0, 0);
        this.add.existing(lootInfoComponent);
        // Bottom Info Bar
        this.addBottomInfoBar();
        // Action Buttons
        this.addButtons();
        // Set status check interval
        this.addStatusCheckTimer();
        // Raid Units Component
        if (this._isAttacking) {
            this._raidUnitsInfoComponent = new (0, $8aad40827bead1a1$export$2e2bcd8739ae039)(this, this.applyScale(155), this.sys.canvas.height - this.applyScale(360), this._baseRaidViewInfo, this._scale).setOrigin(0, 0);
            this.add.existing(this._raidUnitsInfoComponent);
        }
        this.addKeyBindings();
    }
    addBottomInfoBar() {
        const sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height - this.applyScale(50), {
            width: this.sys.canvas.width,
            height: this.applyScale(100),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        }).addBackground(this.rexUI.add.roundRectangle(0, 0, 0, 0, 0, 0x350926, 0.8));
        this.add.existing(sizer);
        this._squad = new (0, $e78296f6c79d7b0d$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            display_bg: false,
            allow_clicks: false
        });
        sizer.add(this._squad, {
            key: "squad_component",
            align: "left-center",
            offsetX: this.applyScale(7),
            offsetY: 0,
            expand: false
        });
        const attacker_info_bar = this.rexUI.add.overlapSizer({
            width: this.applyScale(380),
            height: this.applyScale(65)
        }).addBackground(this.rexUI.add.roundRectangle(0, 0, 0, 0, this.applyScale(16), 0x350926, 0.9)).add(this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", "YOUR SQUAD'S REMAINING HP", this.applyScale(16)).setAlpha(0.3)
        }), {
            align: "left-top",
            padding: {
                left: this.applyScale(10),
                right: 0,
                top: this.applyScale(5),
                bottom: 0
            },
            expand: false
        });
        this._attackerHpLabel = this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", `${this._baseRaidViewInfo.attacker_hp}/${this._baseRaidViewInfo.attacker_hp_beginning || this._baseRaidViewInfo.attacker_hp}`, this.applyScale(16)).setAlpha(1)
        });
        attacker_info_bar.add(this._attackerHpLabel, {
            align: "right-top",
            padding: {
                left: 0,
                right: this.applyScale(10),
                top: this.applyScale(5),
                bottom: 0
            },
            expand: false
        });
        this._attackerProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(attacker_info_bar.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: 360,
                height: 22,
                radius: 6,
                color: 0x00a6d3,
                alpha: 1,
                backgroundColor: 0xb48dc7,
                backgroundAlpha: 0.4,
                minValue: 1,
                maxValue: this._baseRaidViewInfo.attacker_hp_beginning || this._baseRaidViewInfo.attacker_hp,
                progressValue: this._baseRaidViewInfo.attacker_hp,
                glare: {
                    height: 6,
                    width: 350,
                    radius: 3,
                    color: 0xffffff,
                    alpha: 0.17
                }
            }
        });
        attacker_info_bar.add(this._attackerProgressBar, {
            key: "attacker_progress_bar",
            align: "left-center",
            offsetX: this.applyScale(10),
            offsetY: this.applyScale(10),
            expand: false
        });
        sizer.add(attacker_info_bar, {
            key: "attacker_info_bar",
            align: "left-center",
            offsetX: this.applyScale(260),
            offsetY: 0,
            expand: false
        });
        const dmg_per_sec = this.rexUI.add.overlapSizer({
            width: this.applyScale(165),
            height: this.applyScale(65)
        }).addBackground(this.rexUI.add.roundRectangle(0, 0, 0, 0, this.applyScale(16), 0x350926, 0.9)).add(this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", "YOUR DMG PER SEC", this.applyScale(16)).setAlpha(0.3)
        }), {
            align: "left-top",
            padding: {
                left: this.applyScale(10),
                right: 0,
                top: this.applyScale(5),
                bottom: 0
            },
            expand: false
        }).add(this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", Math.floor(this._baseRaidViewInfo.attacker_dps).toString(), this.applyScale(20)).setAlpha(1)
        }), {
            align: "left-center",
            padding: {
                left: this.applyScale(10),
                right: 0,
                top: this.applyScale(15),
                bottom: 0
            },
            expand: false
        });
        sizer.add(dmg_per_sec, {
            key: "dmg_per_sec",
            align: "left-center",
            offsetX: this.applyScale(655),
            offsetY: 0,
            expand: false
        });
        const defender_info_bar = this.rexUI.add.overlapSizer({
            width: this.applyScale(380),
            height: this.applyScale(65)
        }).addBackground(this.rexUI.add.roundRectangle(0, 0, 0, 0, this.applyScale(16), 0x350926, 0.9)).add(this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", "HOMEBASE HP REMAINING", this.applyScale(16)).setAlpha(0.3)
        }), {
            align: "left-top",
            padding: {
                left: this.applyScale(10),
                right: 0,
                top: this.applyScale(5),
                bottom: 0
            },
            expand: false,
            key: "defender_homebase_hp_label"
        });
        this._defenderHpLabel = this.rexUI.add.label({
            text: this.add.bitmapText(0, 0, "cc_outline", `${this._baseRaidViewInfo.defender_hp}/${this._baseRaidViewInfo.defender_hp_beginning || this._baseRaidViewInfo.defender_hp}`, this.applyScale(16)).setAlpha(1)
        });
        defender_info_bar.add(this._defenderHpLabel, {
            align: "right-top",
            padding: {
                left: 0,
                right: this.applyScale(10),
                top: this.applyScale(5),
                bottom: 0
            },
            expand: false,
            key: "defender_hp_label"
        });
        this._defenderProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(defender_info_bar.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: 360,
                height: 22,
                radius: 6,
                color: 0xd30059,
                alpha: 1,
                backgroundColor: 0xb48dc7,
                backgroundAlpha: 0.4,
                minValue: 1,
                maxValue: this._baseRaidViewInfo.defender_hp_beginning || this._baseRaidViewInfo.defender_hp,
                progressValue: this._baseRaidViewInfo.defender_hp,
                glare: {
                    height: 6,
                    width: 350,
                    radius: 3,
                    color: 0xffffff,
                    alpha: 0.17
                }
            }
        });
        defender_info_bar.add(this._defenderProgressBar, {
            key: "attacker_progress_bar",
            align: "left-center",
            offsetX: this.applyScale(10),
            offsetY: this.applyScale(10),
            expand: false
        });
        sizer.add(defender_info_bar, {
            key: "defender_info_bar",
            align: "right-center",
            offsetX: this.applyScale(-7),
            offsetY: 0,
            expand: false
        });
        sizer.layout();
    }
    addButtons() {
        // Back to Home Button
        this._backToHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.applyScale(20), this.sys.canvas.height - this.applyScale(150), this._isAttacking ? "base_raid_back_to_home_btn_gray" : "base_raid_back_to_home_btn", false).setScrollFactor(0).setScale(this._scale).setOrigin(0, 0.5);
        this._backToHomeButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
            this.scene.scene.sound.play("hud-button-hover");
        });
        this._backToHomeButton.onClick().subscribe(()=>{
            this.backToHomeButtonHandler();
        });
        this.add.existing(this._backToHomeButton);
        // Check attack state for which buttons to draw
        if (this._isAttacking) {
            // Surrender Button
            this._surrenderButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.sys.canvas.width - this.applyScale(20), this.sys.canvas.height - this.applyScale(150), "base_raid_surrender_btn", false).setScrollFactor(0).setScale(this._scale).setOrigin(1, 0.5);
            this._surrenderButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
                this.scene.scene.sound.play("hud-button-hover");
            });
            this._surrenderButton.onClick().subscribe(()=>{
                this.surrenderButtonClickHandler();
            });
            this.add.existing(this._surrenderButton);
        } else {
            // Attack Button
            this._attackButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.sys.canvas.width - this.applyScale(300), this.sys.canvas.height - this.applyScale(150), "base_raid_attack_btn", false).setScrollFactor(0).setScale(this._scale).setOrigin(0, 0.5);
            this._attackButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
                this.scene.scene.sound.play("hud-button-hover");
            });
            this._attackButton.onClick().subscribe(()=>{
                this.startAttack();
            });
            this.add.existing(this._attackButton);
            // View Next Button
            this._nextButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, this.sys.canvas.width - this.applyScale(20), this.sys.canvas.height - this.applyScale(150), "base_raid_next_btn", false).setScrollFactor(0).setScale(this._scale).setInteractive({
                cursor: "pointer"
            }).setOrigin(1, 0.5);
            this._nextButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, ()=>{
                this.scene.scene.sound.play("hud-button-hover");
            });
            this._nextButton.onClick().subscribe(()=>{
                this.nextButtonClickHandler();
            });
            this.add.existing(this._nextButton);
        }
    }
    backToHomeButtonHandler() {
        clearInterval(this._timeoutId);
        (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((data)=>{
            this.unloadBaseRaidAssets();
            this.scene.stop();
            this.scene.stop("BaseRaidDetailsScene");
            this.scene.stop("BaseRaidHudScene");
            this.scene.start("HomebaseScene");
        });
    }
    nextButtonClickHandler() {
        this._nextButton.disableInteractive();
        this.scene.stop();
        this.scene.stop("BaseRaidDetailsScene");
        this.scene.stop("BaseRaidHudScene");
        this.scene.start("BaseRaidLoadingScene", {
            next: 1
        });
    }
    surrenderButtonClickHandler() {
        clearInterval(this._timeoutId);
        // Disable homebase/hud
        this.scene.get("BaseRaidDetailsScene").input.enabled = false;
        this.input.enabled = false;
        this.input.keyboard.enabled = false;
        // Show confirmation modal
        this.scene.launch("BaseRaidConfirmSurrenderScene");
        this.scene.bringToTop("BaseRaidConfirmSurrenderScene");
    }
    addKeyBindings() {
        this.input.keyboard.on("keydown-ENTER", (event)=>{
            if (!this._isAttacking) this.startAttack();
        });
        this.input.keyboard.on("keydown-ESC", (event)=>{
            this.backToHomeButtonHandler();
        });
        this.input.keyboard.on("keydown-SPACE", (event)=>{
            if (!this._isAttacking) this.nextButtonClickHandler();
        });
        this.input.keyboard.on("keydown-END", (event)=>{
            if (this._isAttacking) this.surrenderButtonClickHandler();
        });
    }
    startAttack() {
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().startAttack(this._defenderUserAddress).then((data)=>{
            console.log(data);
            this.switchToAttackMode(data);
        });
    }
    handleAttackFinished() {
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((res)=>{
            // Check if attack is finished on back end, display result scene
            if (res.base_raid_id !== 0 && res.completed) {
                // Clear time intervals
                this.time.removeAllEvents();
                // Show results of previous raid
                const resultData = {
                    isAttacker: true,
                    neon_gold: res.attacker_possible_loot.neon_gold,
                    space_elixir: res.attacker_possible_loot.space_elixir,
                    stardust: res.attacker_possible_loot.stardust,
                    xp: res.is_win ? res.attacker_win_xp : res.attacker_lose_xp,
                    isVictory: res.is_win
                };
                this.scene.stop("BaseRaidDetailsScene");
                this.scene.stop("BaseRaidHudScene");
                this.scene.start("BaseRaidResultScene", resultData);
                this.scene.bringToTop("BaseRaidResultScene");
            } else // Attack must not have finished on back end yet, wait  seconds and try again
            setTimeout(this.handleAttackFinished.bind(this), 2000);
        });
    }
    switchToAttackMode(attackData) {
        // Update base info
        this._baseRaidViewInfo = Object.assign({}, this._baseRaidViewInfo, attackData);
        // Set isAttacking flag
        this._isAttacking = true;
        // Change buttons
        this._backToHomeButton.setAlpha(0).destroy();
        this._nextButton.setAlpha(0).destroy();
        this._attackButton.setAlpha(0).destroy();
        this.addButtons();
        // Set clock time
        this.setAttackTimer(attackData);
        // Set attack update timer
        this.addStatusCheckTimer();
        // Add Troops Component
        this._raidUnitsInfoComponent = new (0, $8aad40827bead1a1$export$2e2bcd8739ae039)(this, this.applyScale(155), this.sys.canvas.height - this.applyScale(360), this._baseRaidViewInfo, this._scale).setOrigin(0, 0);
        this.add.existing(this._raidUnitsInfoComponent);
    }
    setAttackTimer(attackData) {
        const timeRemaining = this.getTimeRemaining(attackData);
        this._raidClock.setClockData({
            timeRemaining: timeRemaining,
            isAttacking: this._isAttacking
        });
    }
    getTimeRemaining(attackData) {
        const unixNow = Math.floor(Date.now() / 1000);
        const lastAttackStep = attackData.base_raid_execution[attackData.base_raid_execution.length - 1];
        var timeRemaining;
        if (!lastAttackStep) // Attack must have finished
        timeRemaining = 0;
        else {
            // Attack is ongoing
            const endTime = lastAttackStep.end_time;
            timeRemaining = endTime - unixNow;
        }
        return timeRemaining;
    }
    getCurrentStepTimeRemaining(attackData) {
        if (attackData && attackData.base_raid_execution) {
            const unixNow = Math.floor(Date.now() / 1000);
            const currentAttackStep = attackData.base_raid_execution[0];
            var timeRemaining;
            if (!currentAttackStep) // Attack must have finished
            timeRemaining = 0;
            else {
                // Attack is ongoing
                const endTime = currentAttackStep.end_time;
                timeRemaining = endTime - unixNow;
            }
            return timeRemaining;
        }
        return 0;
    }
    checkAttackStatus() {
        var _a;
        if (this._baseRaidViewInfo.base_raid_execution) {
            const nextStepFinishTime = ((_a = this._baseRaidViewInfo.base_raid_execution[0]) === null || _a === void 0 ? void 0 : _a.end_time) || 0;
            const timeNow = Math.floor(Date.now() / 1000);
            // console.log(`timeNow: ${timeNow}`);
            // console.log(`nextStepFinishTime: ${nextStepFinishTime}`);
            if (timeNow >= nextStepFinishTime + 1) this.updateRaidStatus(this);
        }
    }
    updateRaidStatus() {
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((attackRes)=>{
            var _a, _b, _c, _d, _e, _f;
            if (attackRes.success) {
                this._baseRaidViewInfo = attackRes;
                // Update labels and progress bars
                (_a = this._defenderHpLabel) === null || _a === void 0 || _a.setText(`${attackRes.defender_hp}/${attackRes.defender_hp_beginning}`);
                (_b = this._defenderProgressBar) === null || _b === void 0 || _b.setProgress(this, attackRes.defender_hp);
                (_c = this._attackerHpLabel) === null || _c === void 0 || _c.setText(`${attackRes.attacker_hp}/${attackRes.attacker_hp_beginning}`);
                (_d = this._attackerProgressBar) === null || _d === void 0 || _d.setProgress(this, attackRes.attacker_hp);
                // Update Raid Units Component
                (_e = this._raidUnitsInfoComponent) === null || _e === void 0 || _e.updateData(this._baseRaidViewInfo);
                // Update machines on homebase
                (_f = this.scene.get("BaseRaidDetailsScene")) === null || _f === void 0 || _f.disableDestroyedMachines(this._baseRaidViewInfo);
                clearInterval(this._timeoutId);
                this.addStatusCheckTimer();
            }
        });
    }
    addStatusCheckTimer() {
        if (this._isAttacking && this._baseRaidViewInfo.base_raid_execution.length > 1) this._timeoutId = setInterval(this.checkAttackStatus.bind(this), 2000);
    }
    restartScene() {
        clearInterval(this._timeoutId);
        this.scene.restart({
            base_raid_view_info: this._baseRaidViewInfo,
            is_attacking: this._isAttacking
        });
    }
    getScale() {
        return this._scale;
    }
    unloadBaseRaidAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$d4d19d986b8fcaa2)));
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)).filter((sa_key)=>sa_key.includes("shop_machines")));
    }
}








class $2a64011460418b87$var$PVPBattleService {
    constructor(){
        if ($2a64011460418b87$var$PVPBattleService._instance) throw new Error("Error: Instantiation failed: Use PVPBattleService.getInstance() instead of new.");
        $2a64011460418b87$var$PVPBattleService._instance = this;
    }
    static getInstance() {
        return $2a64011460418b87$var$PVPBattleService._instance;
    }
    getLeaderData(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._leaderData && !forceUpdate) return resolve(this._leaderData);
            else return resolve(this.fetchLeaderData());
        });
    }
    getLeaderDataSync() {
        return this._leaderData;
    }
    fetchLeaderData() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("pvp_battle", [
            "leaderboard"
        ], []).then((res)=>{
            this._leaderData = res;
            return res;
        });
    }
}
$2a64011460418b87$var$PVPBattleService._instance = new $2a64011460418b87$var$PVPBattleService();
var $2a64011460418b87$export$2e2bcd8739ae039 = $2a64011460418b87$var$PVPBattleService;




const $c7185ff56d44b41b$var$modalHeight = 800;
const $c7185ff56d44b41b$var$modalWidth = 638;
const $c7185ff56d44b41b$var$modalRadius = 16;
const $c7185ff56d44b41b$var$modalColor = 0x1c1c2c;
const $c7185ff56d44b41b$var$modalAlpha = 1;
const $c7185ff56d44b41b$var$leaderItemWidth = $c7185ff56d44b41b$var$modalWidth - 38;
const $c7185ff56d44b41b$var$leaderItemHeight = 73;
const $c7185ff56d44b41b$var$leaderItemRadius = 16;
const $c7185ff56d44b41b$var$leaderItemColor = 0x262637;
const $c7185ff56d44b41b$var$leaderItemAlpha = 1;
const $c7185ff56d44b41b$var$leaderItemGlareWidth = $c7185ff56d44b41b$var$leaderItemWidth - 30;
const $c7185ff56d44b41b$var$leaderItemGlareHeight = 7;
const $c7185ff56d44b41b$var$leaderItemGlareRadius = 3;
const $c7185ff56d44b41b$var$leaderItemGlareColor = 0xffffff;
const $c7185ff56d44b41b$var$leaderItemGlareAlpha = 0.08;
const $c7185ff56d44b41b$var$numWinsColor = 0xff8ca8;
const $c7185ff56d44b41b$var$messageColor = 0xffffff;
const $c7185ff56d44b41b$var$victoryIcon = "pvp_victory_icon";
const $c7185ff56d44b41b$var$leaderboardTitle = "leaderboard_title";
const $c7185ff56d44b41b$var$leaderboardDivider = "leaderboard_divider";
const $c7185ff56d44b41b$var$categories = {
    pvp: "pvp",
    stardust: "stardust",
    logins: "logins",
    pve: "pve",
    xp: "xp",
    mining: "mining",
    base_raid: "base_raid"
};
class $c7185ff56d44b41b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "LeaderboardScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f4c0b61e75a7e807));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($c7185ff56d44b41b$var$modalWidth, $c7185ff56d44b41b$var$modalHeight + 100); // 100 accounts for icons and button extending beyond modal box
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._selectedCategory = $c7185ff56d44b41b$var$categories.pvp;
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($c7185ff56d44b41b$var$modalWidth), this.applyScale($c7185ff56d44b41b$var$modalHeight), this.applyScale($c7185ff56d44b41b$var$modalRadius), $c7185ff56d44b41b$var$modalColor, $c7185ff56d44b41b$var$modalAlpha);
        // Add Icon
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, $c7185ff56d44b41b$var$victoryIcon).setScale(this._scale * 0.5);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($c7185ff56d44b41b$var$modalWidth),
            height: this.applyScale($c7185ff56d44b41b$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add Title Text
        sizer.add(this.add.image(0, 0, $c7185ff56d44b41b$var$leaderboardTitle).setScale(this._scale), {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(43),
                bottom: this.applyScale(24)
            },
            key: "title_text"
        });
        // Add Divider
        sizer.add(this.add.image(0, 0, $c7185ff56d44b41b$var$leaderboardDivider).setScale(this._scale), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "upper_divider"
        });
        // Buttons Sizer
        var buttonSizer = this.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($c7185ff56d44b41b$var$modalWidth),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Pvp Button
        this._pvpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_pvp_button", false).setOrigin(0, 0.5).setScale(this._scale);
        this._pvpButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.pvp;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.wins, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._pvpButton), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "pvp_button"
        });
        // Stardust Button
        this._stardustButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_stardust_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._stardustButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.stardust;
            this._stardustButton.setTexture("leaderboard_stardust_button");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.stardust, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._stardustButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "stardust_button"
        });
        // Logins Button
        this._loginsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_logins_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._loginsButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.logins;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.logins, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._loginsButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "logins_button"
        });
        // Logins Button
        this._pveButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_pve_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._pveButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.pve;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.pve_wins.sort((a, b)=>{
                if (a.rounds_played < b.rounds_played) return 1;
                if (a.rounds_played > b.rounds_played) return -1;
                return 0;
            }), 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._pveButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "pve_button"
        });
        // XP Button
        this._xpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_xp_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._xpButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.xp;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.xp, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._xpButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "xp_button"
        });
        // Mining Button
        this._miningButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_mining_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._miningButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.mining;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.mining, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._miningButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "mining_button"
        });
        // Base Raid Button
        this._baseRaidButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "leaderboard_base_raid_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._baseRaidButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $c7185ff56d44b41b$var$categories.base_raid;
            this._stardustButton.setTexture("leaderboard_stardust_button_inactive");
            this._pvpButton.setTexture("leaderboard_pvp_button_inactive");
            this._loginsButton.setTexture("leaderboard_logins_button_inactive");
            this._pveButton.setTexture("leaderboard_pve_button_inactive");
            this._xpButton.setTexture("leaderboard_xp_button_inactive");
            this._miningButton.setTexture("leaderboard_mining_button_inactive");
            this._baseRaidButton.setTexture("leaderboard_base_raid_button");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(this, this._leaders.base_raid, 0, 0).layout();
            sizer.add(this._table, {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                key: "leaderboard_table"
            });
            sizer.layout();
        });
        buttonSizer.add(this.add.existing(this._baseRaidButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "base_raid_button"
        });
        // Add button sizer to main sizer
        sizer.add(this.add.existing(buttonSizer), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "logins_button"
        });
        // Add Divider
        sizer.add(this.add.image(0, 0, $c7185ff56d44b41b$var$leaderboardDivider).setScale(this._scale), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(24)
            },
            key: "lower_divider"
        }).layout();
        sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(160),
                bottom: 0
            }
        });
        this.input.enabled = false;
        sizer.layout();
        (0, $2a64011460418b87$export$2e2bcd8739ae039).getInstance().getLeaderData(true).then((res)=>{
            this._leaders = res;
            this.addTableOnLoad(sizer);
            this.input.enabled = true;
        });
    }
    addTableOnLoad(sizer) {
        // Remove Loading Indicator
        this._loadingIndicator.setAlpha(0);
        sizer.remove(this._loadingIndicator, true);
        this._loadingIndicator = undefined;
        // Add Table
        this._table = this.createTable(this, this._leaders.wins, 0, 0).layout();
        sizer.add(this._table, {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "leaderboard_table"
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($c7185ff56d44b41b$var$modalWidth),
            height: scene.applyScale(80 * data.length > 534 ? 534 : 80 * data.length - 1),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($c7185ff56d44b41b$var$modalWidth),
                cellHeight: this.applyScale(80),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {
                    bottom: this.applyScale(8)
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                item.num_wins = item.num_wins || 0;
                item.display_name = item.display_name || "Unknown";
                function getValueText(item) {
                    switch(scene._selectedCategory){
                        case $c7185ff56d44b41b$var$categories.pvp:
                            return item.num_wins === 1 ? `1 win` : `${item.num_wins.toLocaleString("en-us")} wins`;
                        case $c7185ff56d44b41b$var$categories.logins:
                            return item.num_logins === 1 ? `1 login` : `${item.num_logins.toLocaleString("en-us")} logins`;
                        case $c7185ff56d44b41b$var$categories.stardust:
                            return `${Math.floor(parseFloat(item.stardust)).toLocaleString("en-us")}`;
                        case $c7185ff56d44b41b$var$categories.pve:
                            return `${item.rounds_played} Rounds (${(item.win_ratio / 6 * 100).toFixed(1)}% K/D)`;
                        case $c7185ff56d44b41b$var$categories.xp:
                            return `${item.xp.toLocaleString("en-us")}`;
                        case $c7185ff56d44b41b$var$categories.mining:
                            return `${item.asteroids_finished.toLocaleString("en-us")}`;
                        case $c7185ff56d44b41b$var$categories.base_raid:
                            return `${Math.floor(parseFloat(item.base_raid_winnings)).toLocaleString("en-us")} looted`;
                    }
                }
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($c7185ff56d44b41b$var$modalWidth - 38),
                    space: {
                        left: scene.applyScale(19),
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($c7185ff56d44b41b$var$leaderItemWidth), scene.applyScale($c7185ff56d44b41b$var$leaderItemHeight), scene.applyScale($c7185ff56d44b41b$var$leaderItemRadius), $c7185ff56d44b41b$var$leaderItemColor, $c7185ff56d44b41b$var$leaderItemAlpha), {
                    key: "leader_item_bg",
                    align: "center-top",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($c7185ff56d44b41b$var$leaderItemGlareWidth), scene.applyScale($c7185ff56d44b41b$var$leaderItemGlareHeight), scene.applyScale($c7185ff56d44b41b$var$leaderItemGlareRadius), $c7185ff56d44b41b$var$leaderItemGlareColor, $c7185ff56d44b41b$var$leaderItemGlareAlpha), {
                    key: "leader_item_bg_glare",
                    align: "center-top",
                    offsetX: 0,
                    offsetY: 7,
                    expand: false
                }).add(scene.rexUI.add.label({
                    orientation: "x",
                    rtl: true,
                    icon: item.has_battlepass ? scene.add.image(0, 0, "battle_pass_icon").setScale(scene.getScale()) : undefined,
                    text: scene.add.bitmapText(0, 0, "cc_outline", item.display_name, scene.applyScale(18), 0),
                    space: {
                        icon: item.has_battlepass ? scene.applyScale(5) : undefined
                    }
                }), {
                    key: "leader_item_display_name",
                    align: "left-center",
                    offsetX: 21,
                    offsetY: 4,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", getValueText(item), scene.applyScale(18), 0).setTint($c7185ff56d44b41b$var$numWinsColor), {
                    key: "leader_item_num_wins",
                    align: "right-center",
                    offsetX: -21,
                    offsetY: 4,
                    expand: false
                });
                sizer.layout();
                return sizer;
            }
        });
        return table;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f4c0b61e75a7e807)));
    }
}







const $2650053de13e16c2$var$modalHeight = 320;
const $2650053de13e16c2$var$modalWidth = 494;
const $2650053de13e16c2$var$modalRadius = 25;
const $2650053de13e16c2$var$modalColor = 0x350926;
const $2650053de13e16c2$var$modalAlpha = 1;
const $2650053de13e16c2$var$modalBorderColor = 0x3d4361;
const $2650053de13e16c2$var$modalBorderWidth = 1;
const $2650053de13e16c2$var$confirmationMessage = "Are you sure you\nwant to surrender?";
const $2650053de13e16c2$var$messageColor = 0x75758b;
class $2650053de13e16c2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "PvpSurrenderScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2650053de13e16c2$var$modalWidth, $2650053de13e16c2$var$modalHeight); // 220 accounts for icons and button extending beyond modal box
    }
    preload() {}
    init(data) {
        this._serverType = data.serverType;
    }
    create() {
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($2650053de13e16c2$var$modalWidth), this.applyScale($2650053de13e16c2$var$modalHeight), this.applyScale($2650053de13e16c2$var$modalRadius), $2650053de13e16c2$var$modalColor, $2650053de13e16c2$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($2650053de13e16c2$var$modalBorderWidth), $2650053de13e16c2$var$modalBorderColor, $2650053de13e16c2$var$modalAlpha);
        // Add Text
        const text1 = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(85), "cc_outline", $2650053de13e16c2$var$confirmationMessage, this.applyScale(24), 1).setOrigin(0.5, 0.5).setTint($2650053de13e16c2$var$messageColor);
        // Add Blob image
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "party_blob").setOrigin(0.5, 0.5);
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), modalBg.getBottomLeft().y, "pvp_cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.scene.stop();
            this.events.emit("surrender_cancel_event", {});
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), modalBg.getBottomLeft().y, "pvp_confirm_button", false).setScale(this._scale);
        confirmButton.onClick().subscribe((pointer)=>{
            if (this._serverType === "pvp") {
                (0, $a8e8b7ed383db386$export$2e2bcd8739ae039).getInstance().playAction("pvp69");
                this.scene.stop();
                this.scene.get("PvPScene").unloadAssets();
            } else {
                (0, $da3d4b8200dd7026$export$2e2bcd8739ae039).getInstance().playAction("pvp69");
                this.scene.stop();
            }
        });
        this.add.existing(confirmButton);
    }
    applyScale(length) {
        return length * this._scale;
    }
}








const $16a6a830d1eab942$var$modalHeight = 440;
const $16a6a830d1eab942$var$modalWidth = 520;
const $16a6a830d1eab942$var$modalRadius = 25;
const $16a6a830d1eab942$var$modalColor = 0x350926;
const $16a6a830d1eab942$var$modalAlpha = 1;
const $16a6a830d1eab942$var$modalBorderColor = 0x3d4361;
const $16a6a830d1eab942$var$modalBorderWidth = 1;
const $16a6a830d1eab942$var$componentRadius = 16;
const $16a6a830d1eab942$var$subtitleTint = 0x75758b;
const $16a6a830d1eab942$var$messageColor = 0xffffff;
const $16a6a830d1eab942$var$submitButtonImage = "squad_confirm_button";
const $16a6a830d1eab942$var$itemTypes = {
    speed_up_upgrade: "speed_up_upgrade",
    machine: "machine",
    shop_item: "shop_item",
    machine_upgrade: "machine_upgrade",
    machine_activation: "machine_activation",
    resource_box: "resource_box",
    machine_claim: "machine_claim"
};
class $16a6a830d1eab942$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._purchaseResult = data.purchaseResult;
        this._item = data.item;
        this._itemType = data.itemType || "shop_item"; // machine or shop_item
    }
    constructor(){
        super({
            key: "ShopPurchaseResultScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($16a6a830d1eab942$var$modalWidth, $16a6a830d1eab942$var$modalHeight + 50); // 50 accounts for button extending beyond modal box
    }
    preload() {
        this.load.image(`shop_machines_${this._item.key}`, (0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)[`shop_machines_${this._item.key}`]);
        this.load.image("squad_confirm_button", (0, $1aa2c39fc1fbb95e$export$3b37c5430056c4ff).squad_confirm_button);
    }
    create() {
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($16a6a830d1eab942$var$modalWidth), this.applyScale($16a6a830d1eab942$var$modalHeight), this.applyScale($16a6a830d1eab942$var$modalRadius), $16a6a830d1eab942$var$modalColor, $16a6a830d1eab942$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($16a6a830d1eab942$var$modalBorderWidth), $16a6a830d1eab942$var$modalBorderColor, $16a6a830d1eab942$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(15), {
            width: this.applyScale(300),
            height: this.applyScale(340),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), this.applyScale(28), 1).setMaxWidth(300), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: 5,
            expand: false
        });
        // Item Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: $16a6a830d1eab942$var$componentRadius
        };
        let itemImageKey;
        switch(this._itemType){
            case $16a6a830d1eab942$var$itemTypes.shop_item:
                itemImageKey = `shop_${this._item.key}_image`;
                break;
            case $16a6a830d1eab942$var$itemTypes.machine:
                itemImageKey = this._item.shopImageKey;
                break;
            case $16a6a830d1eab942$var$itemTypes.machine_upgrade:
                itemImageKey = `shop_machines_${this._item.key}`;
                break;
            case $16a6a830d1eab942$var$itemTypes.speed_up_upgrade:
                itemImageKey = `shop_machines_${this._item.key}`;
                break;
            case $16a6a830d1eab942$var$itemTypes.machine_activation:
                itemImageKey = `shop_machines_${this._item.key}`;
                break;
            default:
                itemImageKey = `shop_machines_${this._item.key}`;
                break;
        }
        this._itemImage = this.add.rexCircleMaskImage(0, 0, itemImageKey, "", rectConfig).setScale(this._scale * 0.5);
        sizer.add(this._itemImage, {
            key: "item_image",
            align: "center-top",
            offsetX: 0,
            offsetY: 60,
            expand: false
        });
        // Add Description Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getDescriptionText(), this.applyScale(24), 1).setTint($16a6a830d1eab942$var$subtitleTint).setMaxWidth(300), {
            key: "desc_text",
            align: "center-top",
            offsetX: 0,
            offsetY: 260,
            expand: false
        });
        sizer.layout();
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, $16a6a830d1eab942$var$submitButtonImage, false).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                if (this._itemType === $16a6a830d1eab942$var$itemTypes.machine_upgrade || this._itemType === $16a6a830d1eab942$var$itemTypes.speed_up_upgrade) {
                    this.scene.get("HomebaseScene").input.enabled = true;
                    this.scene.resume("HudScene");
                } else if (this._itemType === $16a6a830d1eab942$var$itemTypes.machine_claim) {
                    this.scene.get("HomebaseScene").updateMachines(true);
                    this.scene.get("HomebaseScene").input.enabled = true;
                    this.scene.resume("HudScene");
                } else if (this._itemType === $16a6a830d1eab942$var$itemTypes.machine_activation) {
                    this.scene.get("HomebaseScene").input.enabled = true;
                    this.scene.resume("HudScene");
                    this.scene.get("HomebaseScene").updateMachines();
                } else this.scene.resume("ShopModalScene");
                this.unloadAssets();
                this.scene.stop();
            });
        });
        this.add.existing(returnHomeButton);
    }
    getTitleText() {
        if (this._purchaseResult.success) return "Success!";
        else {
            if (this._itemType === $16a6a830d1eab942$var$itemTypes.machine_activation) return "Activation Failed...";
            else if (this._itemType === $16a6a830d1eab942$var$itemTypes.machine_claim) return "Claim Failed...";
            return "Purchase Failed...";
        }
    }
    getDescriptionText() {
        switch(this._itemType){
            case $16a6a830d1eab942$var$itemTypes.shop_item:
                if (this._purchaseResult.success) {
                    if (this._item.type === "whitelist") return `You purchased a spot on the ${this.getDisplayName()}.  Admins have been notified.`;
                    else return `You purchased a ${this.getDisplayName()}.`;
                } else {
                    if (this._purchaseResult.msg === "Whitelist exists") return "You have already purchased this WL.";
                    else if (this._purchaseResult.msg === "Out of inventory") return "Sorry, this WL is sold out.";
                    else return `${this._purchaseResult.msg}.`;
                }
            case $16a6a830d1eab942$var$itemTypes.machine:
                if (this._purchaseResult.success) return `You purchased a ${this._item.display_name} machine.`;
                else return `${this._purchaseResult.msg}.`;
            case $16a6a830d1eab942$var$itemTypes.machine_upgrade:
                if (this._purchaseResult.success) return `You purchased a ${this._item.display_name} machine upgrade.`;
                else return `${this._purchaseResult.msg}.`;
            case $16a6a830d1eab942$var$itemTypes.machine_claim:
                if (this._purchaseResult.success) return `You successfully claimed ${this._purchaseResult.claimed.value} ${this._purchaseResult.claimed.currency_name}.`;
                else return `${this._purchaseResult.msg}.`;
            case $16a6a830d1eab942$var$itemTypes.speed_up_upgrade:
                if (this._purchaseResult.success) return `Your ${this._item.display_name} machine upgrade has been sped up.`;
                else return `${this._purchaseResult.msg}.`;
            case $16a6a830d1eab942$var$itemTypes.machine_activation:
                if (this._purchaseResult.success) return `Your ${this._item.display_name} has been activated.`;
                else {
                    if (this._purchaseResult.msg === "Machine is still cooling down") return `${this._purchaseResult.msg}.\n\nTime Left: ${this.getTimeRemaining()}`;
                    return `${this._purchaseResult.msg}.`;
                }
            case $16a6a830d1eab942$var$itemTypes.resource_box:
                if (this._purchaseResult.success) return `Your ${this._item.display_name} machine upgrade has been sped up.`;
                else return `${this._purchaseResult.msg}.`;
            default:
                return "";
        }
    }
    getDisplayName() {
        if (this._item.type === "whitelist") return this._item.name.slice(-2) === "WL" ? this._item.name : `${this._item.name} WL`;
        else return this._item.name;
    }
    getTimeRemaining() {
        let hours = Math.floor(this._purchaseResult.seconds_left / 3600);
        let minutes = Math.floor((this._purchaseResult.seconds_left - hours * 3600) / 60);
        let seconds = this._purchaseResult.seconds_left % 60;
        return `${hours}h ${minutes}m ${seconds}s`;
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, [
            `shop_machines_${this._item.key}`,
            "squad_confirm_button"
        ]);
    }
}







const $63eb02512e0e5aae$var$modalHeight = 360;
const $63eb02512e0e5aae$var$modalWidth = 860;
const $63eb02512e0e5aae$var$modalRadius = 25;
const $63eb02512e0e5aae$var$modalColor = 0x350926;
const $63eb02512e0e5aae$var$modalAlpha = 1;
const $63eb02512e0e5aae$var$modalBorderColor = 0x3d4361;
const $63eb02512e0e5aae$var$modalBorderWidth = 1;
const $63eb02512e0e5aae$var$componentRadius = 16;
const $63eb02512e0e5aae$var$subtitleTint = 0x75758B;
const $63eb02512e0e5aae$var$messageColor = 0xffffff;
const $63eb02512e0e5aae$var$cancelButtonImage = "reward_cancel_button";
const $63eb02512e0e5aae$var$inputTextWidth = 760;
const $63eb02512e0e5aae$var$inputTextHeight = 50;
class $63eb02512e0e5aae$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._item = data.item;
    }
    constructor(){
        super({
            key: "ShopWalletScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($63eb02512e0e5aae$var$modalWidth, $63eb02512e0e5aae$var$modalHeight + 50); // 50 accounts for button extending beyond modal box
    }
    preload() {}
    create() {
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($63eb02512e0e5aae$var$modalWidth), this.applyScale($63eb02512e0e5aae$var$modalHeight), this.applyScale($63eb02512e0e5aae$var$modalRadius), $63eb02512e0e5aae$var$modalColor, $63eb02512e0e5aae$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($63eb02512e0e5aae$var$modalBorderWidth), $63eb02512e0e5aae$var$modalBorderColor, $63eb02512e0e5aae$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(0), {
            width: this.applyScale(760),
            height: this.applyScale(300),
            space: {
                left: 0,
                right: 0,
                top: this.applyScale(15),
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), this.applyScale(28), 1).setMaxWidth(400), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(15),
            expand: false
        });
        // Wallet Input Text
        const inputTextConfig = {
            x: 0,
            y: 0,
            width: undefined,
            height: undefined,
            type: "textarea",
            id: undefined,
            text: undefined,
            maxLength: 42,
            minLength: undefined,
            placeholder: "Enter Wallet Address",
            tooltip: undefined,
            readOnly: false,
            spellCheck: false,
            autoComplete: "off",
            align: "center",
            paddingLeft: undefined,
            paddingRight: undefined,
            paddingTop: `${this.applyScale(9)}px`,
            paddingBottom: undefined,
            fontFamily: "ccwhatchamacallitbold",
            fontSize: `${this.applyScale(22)}px`,
            color: "#ffffff",
            border: `${this.applyScale(2)}px solid #383D57`,
            backgroundColor: "#440D31",
            borderColor: "#383D57",
            outline: "none",
            direction: "ltr",
            selectAll: false
        };
        this._inputText = this.add.rexInputText(0, 0, this.applyScale($63eb02512e0e5aae$var$inputTextWidth), this.applyScale($63eb02512e0e5aae$var$inputTextHeight), inputTextConfig);
        this._inputText.setText((0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress());
        this._wallet = this._inputText.text;
        this._inputText.on("textchange", (inputText, e)=>{
            this._wallet = inputText.text;
            this._confirmButton.setDisabled(!(0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().isEthAddress(inputText.text));
        }, this);
        sizer.add(this._inputText, {
            key: "input_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(175),
            expand: false
        });
        sizer.layout();
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(119), modalBg.getBottomLeft().y, "cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.scene.resume("ShopModalScene");
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        this._confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(80), modalBg.getBottomLeft().y, "name_btn_enabled", false).setScale(this._scale).setDisabledTexture("name_btn_disabled");
        this._confirmButton.onClick().subscribe((pointer)=>{
            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().purchaseWL(this._item.shop_item_id, this._wallet).then((res)=>{
                this.scene.start("ShopPurchaseResultScene", {
                    purchaseResult: res,
                    item: this._item
                });
            });
        });
        this.add.existing(this._confirmButton);
    }
    getTitleText() {
        return `Please enter the wallet address you would like submitted for the ${this.getDisplayName()}.`;
    }
    getDisplayName() {
        if (this._item.type === "whitelist") return this._item.name.slice(-2) === "WL" ? this._item.name : `${this._item.name} WL`;
        else return this._item.name;
    }
    applyScale(length) {
        return length * this._scale;
    }
}












const $af0ff5e2a1a8c5a0$var$modalHeight = 455;
const $af0ff5e2a1a8c5a0$var$modalWidth = 494;
const $af0ff5e2a1a8c5a0$var$modalRadius = 50;
const $af0ff5e2a1a8c5a0$var$modalColor = 0x350926;
const $af0ff5e2a1a8c5a0$var$modalAlpha = 1;
const $af0ff5e2a1a8c5a0$var$modalBorderColor = 0x3d4361;
const $af0ff5e2a1a8c5a0$var$modalBorderWidth = 1;
class $af0ff5e2a1a8c5a0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._item = data.item;
        this._isUpgrade = data.isUpgrade;
    }
    constructor(){
        super({
            key: "ShopPurchaseConfirmScene"
        });
    }
    preload() {
        this.load.image("pvp_confirm_button", (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59).pvp_confirm_button);
        this.load.image("pvp_cancel_button", (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59).pvp_cancel_button);
    }
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($af0ff5e2a1a8c5a0$var$modalWidth, $af0ff5e2a1a8c5a0$var$modalHeight + 60);
        this._homebaseTraits = (0, $5f7ad9227787a545$export$1a8952599990accc)((0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getTraitsSync(), (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getHomebaseMachineMultiplier());
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($af0ff5e2a1a8c5a0$var$modalWidth), this.applyScale($af0ff5e2a1a8c5a0$var$modalHeight), this.applyScale($af0ff5e2a1a8c5a0$var$modalRadius), $af0ff5e2a1a8c5a0$var$modalColor, $af0ff5e2a1a8c5a0$var$modalAlpha).setInteractive({
            cursor: "default"
        }).setStrokeStyle($af0ff5e2a1a8c5a0$var$modalBorderWidth, $af0ff5e2a1a8c5a0$var$modalBorderColor, $af0ff5e2a1a8c5a0$var$modalAlpha);
        // Add Icons
        this.add.image(this.sys.canvas.width / 2, modalBg.getTopLeft().y, "neon_gold_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 - this.applyScale(74), modalBg.getTopLeft().y, "space_elixir_icon_large").setScale(this._scale);
        this.add.image(this.sys.canvas.width / 2 + this.applyScale(80), modalBg.getTopLeft().y, "stardust_icon_large").setScale(this._scale);
        // Add Sizer for content
        var sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(300),
            height: this.applyScale(320),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this._isUpgrade ? `Purchase ${this._item.display_name} upgrade? Cost:` : `Purchase ${this._item.display_name}? Cost:`, this.applyScale(24), 1).setMaxWidth(300), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Fee Labels
        const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", this._item.cost_space_elixir.toLocaleString("en-us"));
        const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", this._item.cost_neon_gold.toLocaleString("en-us"));
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", this._item.cost_stardust.toLocaleString("en-us"));
        sizer.add(this.add.existing(space_elixir_label), {
            key: "space_elixir_label",
            align: "center",
            offsetX: 0,
            offsetY: this.applyScale(-50),
            expand: false
        });
        sizer.add(this.add.existing(neon_gold_label), {
            key: "neon_gold_label",
            align: "center",
            offsetX: 0,
            offsetY: this.applyScale(5),
            expand: false
        });
        sizer.add(this.add.existing(stardust_label), {
            key: "stardust_label",
            align: "center",
            offsetX: 0,
            offsetY: this.applyScale(60),
            expand: false
        });
        // Add Note
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this._isUpgrade ? `Note: Upgrading this machine will\ntake ${this.secondsToTime(this._item.next_level_build_total_time)}` : "Note: Machines will be automatically\nadded to homebase upon purchase.", this.applyScale(20), 1).setAlpha(0.6), {
            key: "note_text",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        sizer.layout();
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), modalBg.getBottomLeft().y, "pvp_cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            if (this._isUpgrade) {
                this.scene.get("HomebaseScene").input.enabled = true;
                this.scene.resume("HudScene");
            } else this.scene.resume("ShopModalScene");
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), modalBg.getBottomLeft().y, "pvp_confirm_button", false).setScale(this._scale);
        confirmButton.onClick().subscribe((pointer)=>{
            confirmButton.setDisabled(true);
            if (this._isUpgrade) (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().upgradeMachine(this._item.user_machine_id, this._homebaseTraits.upgradeBuildTime * 100, this._homebaseTraits.reduceCost * 100).then((result)=>{
                if (result.success) {
                    this.scene.scene.sound.play("machines-button");
                    this.scene.get("HomebaseScene").updateMachines();
                }
                this.unloadAssets();
                this.scene.start("ShopPurchaseResultScene", {
                    item: this._item,
                    itemType: "machine_upgrade",
                    purchaseResult: result
                });
            });
            else (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().purchaseMachine(this._item.machine_id, this._homebaseTraits.machineBuildTime * 100, this._homebaseTraits.reduceCost * 100).then((result)=>{
                if (result.success) {
                    this.scene.scene.sound.play("machines-button");
                    this.scene.get("HomebaseScene").updateMachines();
                //this.scene.get('HomebaseScene').addMachine(Object.assign({}, this._item, result.machine_info), 0, 0, true);
                }
                this.unloadAssets();
                this.scene.start("ShopPurchaseResultScene", {
                    item: this._item,
                    itemType: "machine",
                    purchaseResult: result
                });
            });
        });
        this.add.existing(confirmButton);
        var userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        if (userData.space_elixir < this._item.cost_space_elixir || userData.neon_gold < this._item.cost_neon_gold || userData.stardust < this._item.cost_stardust) {
            confirmButton.setDisabled(true);
            confirmButton.setAlpha(0.5);
        }
    // sizer.onClickOutside((co, go, pointer) => {
    //     if (pointer.getDistance() > 20) {
    //       return;
    //     }
    //     if (this._isUpgrade) {
    //         this.scene.get("HomebaseScene").input.enabled = true
    //         this.scene.resume("HudScene")
    //     } else {
    //         this.scene.resume("ShopModalScene")
    //     }
    //     this.scene.stop()
    // });
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? `${h} ${h > 1 ? "hours" : "hour"}` : "";
        var mDisplay = m > 0 ? `${m} ${m > 1 ? "minutes" : "minute"}` : "";
        // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        if (h === 0 && m === 0 && s > 0) return "< 1m";
        return h > 0 ? `${hDisplay} ${mDisplay}` : mDisplay;
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, [
            "pvp_confirm_button",
            "pvp_cancel_button"
        ]);
    }
}



class $17434daa1995bc6f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("StartScene");
    }
    preload() {}
    create() {
        this.scene.launch("Preloader");
    }
}












const $e197c18c77ea506c$var$starLabBoosts = [
    0,
    1.5,
    3,
    4.5,
    6,
    7.5,
    10
];
const $e197c18c77ea506c$var$gasaEmbassyBoosts = [
    0,
    5,
    10,
    15,
    20,
    30,
    45
];
const $e197c18c77ea506c$var$goohBoosts = [
    0,
    20,
    40,
    60,
    80,
    100
];
const $e197c18c77ea506c$var$kingmakerBoosts = [
    0,
    1.15,
    1.25,
    1.5
];
const $e197c18c77ea506c$var$kumaShrineBoosts = [
    0,
    15000,
    50000,
    100000
];
const $e197c18c77ea506c$var$littleLemonBoosts = [
    0,
    15000,
    50000,
    100000
];
const $e197c18c77ea506c$var$acceleratorBoosts = [
    0,
    2,
    2.5,
    3,
    3.5,
    4,
    5
];
const $e197c18c77ea506c$var$metaverseHQBoosts = [
    0,
    2.5,
    5,
    7.5,
    10
];
const $e197c18c77ea506c$var$savedSoulsBoosts = [
    0,
    5,
    7.5,
    10
];
const $e197c18c77ea506c$var$shieldBatteryBoosts = [
    0,
    1,
    1,
    1,
    2,
    2,
    2,
    4,
    4,
    4,
    6
];
const $e197c18c77ea506c$var$photonShieldBoosts = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e197c18c77ea506c$var$dimensionXBoosts = [
    0,
    5,
    10,
    15
];
const $e197c18c77ea506c$var$zenGardenBoosts = [
    0,
    5,
    10,
    15
];
class $e197c18c77ea506c$var$BoostService {
    constructor(){
        this._boostInfo = [];
        this.getStarLabBoost = (starLab)=>{
            return {
                boostValue: $e197c18c77ea506c$var$starLabBoosts[parseInt(starLab.level)],
                extraHighlightLength: 1
            };
        };
        this.getGoohBoost = (goohRefinery)=>{
            return {
                boostValue: $e197c18c77ea506c$var$goohBoosts[parseInt(goohRefinery.level)],
                extraHighlightLength: 1
            };
        };
        this.getKingmakerBoost = (kingmaker)=>{
            return {
                boostValue: $e197c18c77ea506c$var$kingmakerBoosts[parseInt(kingmaker.level)],
                extraHighlightLength: 1
            };
        };
        this.getAcceleratorBoost = (accelerator)=>{
            return {
                boostValue: $e197c18c77ea506c$var$acceleratorBoosts[parseInt(accelerator.level)],
                extraHighlightLength: 1
            };
        };
        this.getGasaEmbassyBoost = (gasaEmbassy)=>{
            return {
                boostValue: $e197c18c77ea506c$var$gasaEmbassyBoosts[parseInt(gasaEmbassy.level)],
                extraHighlightLength: 1
            };
        };
        this.getMVHQBoost = (metaverse)=>{
            return {
                boostValue: $e197c18c77ea506c$var$metaverseHQBoosts[parseInt(metaverse.level)],
                extraHighlightLength: 1
            };
        };
        this.getShieldBatteryBoost = (shieldBattery)=>{
            return {
                boostValue: $e197c18c77ea506c$var$shieldBatteryBoosts[parseInt(shieldBattery.level)],
                extraHighlightLength: 1
            };
        };
        this.getKumaShrineBoost = (kumaShrine)=>{
            return {
                boostValue: $e197c18c77ea506c$var$kumaShrineBoosts[parseInt(kumaShrine.level)],
                extraHighlightLength: 1
            };
        };
        this.getLittleLemonBoost = (littleLemon)=>{
            return {
                boostValue: $e197c18c77ea506c$var$littleLemonBoosts[parseInt(littleLemon.level)],
                extraHighlightLength: 1
            };
        };
        this.getPhotonShieldBoost = (photonShield)=>{
            return {
                boostValue: $e197c18c77ea506c$var$photonShieldBoosts[parseInt(photonShield.level)],
                extraHighlightLength: 1
            };
        };
        this.getSavedSoulsBoost = (savedSoul)=>{
            return {
                boostValue: $e197c18c77ea506c$var$savedSoulsBoosts[parseInt(savedSoul.level)],
                extraHighlightLength: 1
            };
        };
        this.getDimensionXBoost = (dimX)=>{
            return {
                boostValue: $e197c18c77ea506c$var$dimensionXBoosts[parseInt(dimX.level)],
                extraHighlightLength: 1
            };
        };
        this.getZenGardenBoost = (zen_garden)=>{
            return {
                boostValue: $e197c18c77ea506c$var$zenGardenBoosts[parseInt(zen_garden.level)],
                extraHighlightLength: 1
            };
        };
        if ($e197c18c77ea506c$var$BoostService._instance) throw new Error("Error: Instantiation failed: Use BoostService.getInstance() instead of new.");
        $e197c18c77ea506c$var$BoostService._instance = this;
        this.setBoostInfo();
    }
    static getInstance() {
        return $e197c18c77ea506c$var$BoostService._instance;
    }
    setBoostInfo() {
        this._boostInfo = [
            {
                machine_id: 1007,
                key: "star_laboratory",
                shopText: "Increases Building Speed for 30 mins.",
                upgradeText: "Increases Building Speed by ${value}x for 30 mins.",
                highlightStartIndex: 28,
                valueFunc: this.getStarLabBoost
            },
            {
                machine_id: 1013,
                key: "gasa_embassy",
                shopText: "Yields 5 Stardust passively per day.",
                upgradeText: "Yields ${value} Stardust passively per day.",
                highlightStartIndex: 7,
                valueFunc: this.getGasaEmbassyBoost
            },
            {
                machine_id: 1019,
                key: "gooh_refinery",
                shopText: "Increases the Stardust output of GASA Embassies.",
                upgradeText: "Increases the Stardust output of GASA Embassies by ${value}%.",
                highlightStartIndex: 51,
                valueFunc: this.getGoohBoost
            },
            {
                machine_id: 1020,
                key: "alchemist_lab",
                shopText: "Increases the amount of active builders by 1.",
                upgradeText: "Increases the amount of active builders by 1.",
                highlightStartIndex: 43,
                highlightLength: 1
            },
            {
                machine_id: 1021,
                key: "brawler_cage",
                shopText: "Increases the rewards gained from PVP, PVE, Boss Battles, and Battle Royale by 10%.",
                upgradeText: "Increases the rewards gained from PVP, PVE, Boss Battles, and Battle Royale by 10%.",
                highlightStartIndex: 78,
                highlightLength: 3
            },
            {
                machine_id: 1022,
                key: "mother_wolf_statue",
                shopText: "Allows you to claim 5 Stardust every 12 hours.",
                upgradeText: "Allows you to claim 5 Stardust every 12 hours.",
                highlightStartIndex: 20,
                highlightLength: 1
            },
            {
                machine_id: 1029,
                key: "kaiju_kingmaker",
                shopText: "Multiplies the damage of your squad in Boss Battles.",
                upgradeText: "Multiplies the damage of your squad in Boss Battles by ${value}x.",
                highlightStartIndex: 55,
                valueFunc: this.getKingmakerBoost
            },
            {
                machine_id: 1030,
                key: "little_lemon_tree",
                shopText: "Allows you to claim Neon Gold every 12 hours.",
                upgradeText: "Allows you to claim Neon Gold every 12 hours.",
                highlightStartIndex: 20,
                highlightLength: 9
            },
            {
                machine_id: 1030,
                key: "little_lemon_tree",
                shopText: "Allows you to claim 15,000 Neon Gold every 12 hours.",
                upgradeText: "Allows you to claim ${value} Neon Gold every 12 hours",
                highlightStartIndex: 20,
                valueFunc: this.getLittleLemonBoost
            },
            {
                machine_id: 1031,
                key: "neon_gold_accelerator",
                shopText: "Boosts your Neon Gold production for 2 hours (Level 6 by 3 hours).",
                upgradeText: "Boosts your Neon Gold production by ${value}x for 2 hours (Level 6 by 3 hours).",
                highlightStartIndex: 36,
                valueFunc: this.getAcceleratorBoost
            },
            {
                machine_id: 1032,
                key: "space_elixir_accelerator",
                shopText: "Boosts your Space Elixir production for 2 hours (Level 6 by 3 hours).",
                upgradeText: "Boosts your Space Elixir production by ${value}x for 2 hours (Level 6 by 3 hours).",
                highlightStartIndex: 39,
                valueFunc: this.getAcceleratorBoost
            },
            {
                machine_id: 1039,
                key: "mvhq",
                shopText: "Reduces machine build & upgrade time and cost by 2.5%.",
                upgradeText: "Reduces machine build & upgrade time and cost by ${value}%.",
                highlightStartIndex: 49,
                valueFunc: this.getMVHQBoost
            },
            {
                machine_id: 1040,
                key: "kuma_ancestor_shrine",
                shopText: "Allows you to claim 15,000 Space Elixir every 12 hours.",
                upgradeText: "Allows you to claim ${value} Space Elixir every 12 hours",
                highlightStartIndex: 20,
                valueFunc: this.getKumaShrineBoost
            },
            {
                machine_id: 1043,
                key: "shield_battery",
                shopText: "Activates your photon shield for 1h.",
                upgradeText: "Activates your photon shield for ${value}h.",
                highlightStartIndex: 33,
                valueFunc: this.getShieldBatteryBoost
            },
            {
                machine_id: 1044,
                key: "photon_shield",
                shopText: "Boosts the HP of your homebase by 1%.",
                upgradeText: "Boosts the HP of your homebase by ${value}%.",
                highlightStartIndex: 34,
                valueFunc: this.getPhotonShieldBoost
            },
            {
                machine_id: 1045,
                key: "saved_souls",
                shopText: "Increases the rewards gained from Base Raids by 5%",
                upgradeText: "Increases the rewards gained from Base Raids by ${value}%",
                highlightStartIndex: 48,
                valueFunc: this.getSavedSoulsBoost
            },
            {
                machine_id: 1046,
                key: "dimension_x",
                shopText: "Boosts Mining Mission efficiency by 5%.",
                upgradeText: "Boosts Mining Mission efficiency by ${value}%.",
                highlightStartIndex: 36,
                valueFunc: this.getDimensionXBoost
            },
            {
                machine_id: 1048,
                key: "zen_garden",
                shopText: "Increase Base Raiding Cooldown by 5%.",
                upgradeText: "Increase Base Raiding Cooldown by ${value}%.",
                highlightStartIndex: 34,
                valueFunc: this.getZenGardenBoost
            },
            {
                machine_id: 1053,
                key: "nine_lives_lounge",
                shopText: "Recover resources from failed mining missions once every 24 hrs.",
                upgradeText: "Recover resources from failed mining missions once every 24 hrs."
            }
        ];
    }
    setDynamicBoostText(machine, boost) {
        const value = boost.valueFunc(machine);
        const dynamicBoost = JSON.parse(JSON.stringify(boost));
        dynamicBoost.upgradeText = boost.upgradeText.replace("${value}", value.boostValue);
        dynamicBoost.highlightLength = value.boostValue.toString().length + value.extraHighlightLength;
        return dynamicBoost;
    }
    getBoostInfoSync() {
        return this._boostInfo;
    }
    getMachineBoosts(machine) {
        const boost = this._boostInfo.find((boost)=>boost.machine_id === machine.machine_id);
        if (!boost) return {
            shopText: "This machine has no additional boosts currently.",
            upgradeText: "This machine has no additional boosts currently."
        };
        if (boost.valueFunc !== undefined) return this.setDynamicBoostText(machine, boost);
        return boost;
    }
}
$e197c18c77ea506c$var$BoostService._instance = new $e197c18c77ea506c$var$BoostService();
var $e197c18c77ea506c$export$2e2bcd8739ae039 = $e197c18c77ea506c$var$BoostService;


const $cc99e0882fef280b$var$modalWidth = 1004;
const $cc99e0882fef280b$var$modalHeight = 735;
const $cc99e0882fef280b$var$modalRadius = 16;
const $cc99e0882fef280b$var$modalColor = 0x1c1c2c;
const $cc99e0882fef280b$var$modalAlpha = 1;
const $cc99e0882fef280b$var$subtitleTint = 0xa3a3b9;
// Progress bar consts
const $cc99e0882fef280b$var$goldProgressBarColor = 0xdea827;
const $cc99e0882fef280b$var$goldPreviewBarColor = 0xffd369;
const $cc99e0882fef280b$var$pinkProgressBarColor = 0xde2795;
const $cc99e0882fef280b$var$pinkPreviewBarColoar = 0xf567a8;
const $cc99e0882fef280b$var$blueProgressBarColor = 0x00a6d3;
const $cc99e0882fef280b$var$bluePreviewBarColor = 0x00e1d3;
const $cc99e0882fef280b$var$hpProgressBarColor = 0x9a9a9a;
const $cc99e0882fef280b$var$hpPreviewBarColor = 0xc2c2c2;
const $cc99e0882fef280b$var$dpsProgressBarColor = 0xbe5b5b;
const $cc99e0882fef280b$var$dpsPreviewBarColor = 0xda8c8c;
const $cc99e0882fef280b$var$progressBarAlpha = 1;
const $cc99e0882fef280b$var$glareColor = 0xffffff;
const $cc99e0882fef280b$var$glareAlpha = 0.17;
const $cc99e0882fef280b$var$glareRadius = 3;
const $cc99e0882fef280b$var$glareHeight = 6;
const $cc99e0882fef280b$var$glareOffset = 10;
const $cc99e0882fef280b$var$backgroundColor = 0xb48dc7;
const $cc99e0882fef280b$var$backgroundAlpha = 0.4;
const $cc99e0882fef280b$var$radius = 7;
const $cc99e0882fef280b$var$progressBarHeight = 22;
const $cc99e0882fef280b$var$stardustBarWidth = 572;
const $cc99e0882fef280b$var$neonGoldBarWidth = 572;
const $cc99e0882fef280b$var$spaceElixirBarWidth = 572;
const $cc99e0882fef280b$var$shortBarWidth = 162;
const $cc99e0882fef280b$var$shortBarSpace = 41;
const $cc99e0882fef280b$var$halfBarWidth = 286;
const $cc99e0882fef280b$var$stardustMin = 0;
const $cc99e0882fef280b$var$neonGoldMin = 0;
const $cc99e0882fef280b$var$spaceElixirMin = 0;
const $cc99e0882fef280b$var$upgradeBoxWidth = 923;
const $cc99e0882fef280b$var$upgradeBoxHeight = 67;
const $cc99e0882fef280b$var$upgradeBoxRadius = 12;
const $cc99e0882fef280b$var$upgradeBoxColor = 0x34344c;
const $cc99e0882fef280b$var$upgradeBoxAlpha = 1;
const $cc99e0882fef280b$var$closeButtonImageKey = "machine_info_close_button";
const $cc99e0882fef280b$var$buyButtonImageKey = "shop_buy_button";
const $cc99e0882fef280b$var$starLabMachineId = 1007;
const $cc99e0882fef280b$var$starLabMultipliers = [
    0,
    1.5,
    3,
    4.5,
    6,
    7.5,
    10
];
const $cc99e0882fef280b$var$textHighlightColor = 0x00ffb2;
class $cc99e0882fef280b$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, item, paneScale, config){
        let conf = config ? config : {
            width: $cc99e0882fef280b$var$modalWidth * paneScale,
            height: $cc99e0882fef280b$var$modalHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._item = item;
        this._hasYield = item.produce_per_hour_neon_gold > 0 || item.produce_per_hour_space_elixir > 0 || item.produce_per_hour_stardust > 0;
        this._hasStorage = item.storage_neon_gold > 0 || item.storage_space_elixir > 0;
        this._hasTroopCapacity = item.machine_id === 1034; // 1034 = Cadet Dorms
        this._hasHP = true;
        this._hasDPS = item.dps && item.dps > 0 ? true : false;
        this._showAdditionalBoosts = true;
        console.log((0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(item));
        // Background
        // const background = scene.add.rexRoundRectangle(
        //     0, // x
        //     0, // y
        //     this.applyScale(modalWidth), // width
        //     this.applyScale(modalHeight), // height
        //     this.applyScale(modalRadius), // radius
        //     modalColor, // fillColor
        //     modalAlpha, // alpha
        // );
        // this.add(background, {
        //     key: 'info_scene_bg',
        //     align: 'left-top',
        //     offsetX: this.applyScale(0),
        //     offsetY: this.applyScale(0),
        //     expand: false
        // });
        // Close Button
        this._closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, $cc99e0882fef280b$var$closeButtonImageKey, false).setScale(this._scale);
        this.scene.add.existing(this._closeButton);
        this._closeButton.onClick().subscribe((pointer)=>{
            this.closeButtonHandler();
        });
        this.add(this._closeButton, {
            key: "machine_info_close_button",
            align: "right-top",
            offsetX: this.applyScale(-21),
            offsetY: this.applyScale(15),
            expand: false
        });
        // Upper Divider
        const upperDivider = this.scene.add.image(0, 0, "machine_item_info_divider_long").setScale(this._scale);
        this.add(upperDivider, {
            key: "upper_divider",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(73),
            expand: false
        });
        // Item Component
        this._item.shopImageKey = `shop_machines_${this._item.key}`;
        this._itemComponent = new (0, $0f6d56d1311b06e9$export$2e2bcd8739ae039)(scene, 0, 0, this._item, scene.getScale(), false);
        scene.add.existing(this._itemComponent);
        if (this._itemComponent) this.add(this._itemComponent, {
            key: "machine_info_item_component",
            align: "left-top",
            offsetX: this.applyScale(38),
            offsetY: this.applyScale(102),
            expand: false
        });
        // Item Title
        this._itemTitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), this.applyScale(28), 0).setCharacterTint(-10, -1, false, $cc99e0882fef280b$var$subtitleTint);
        this.add(this._itemTitle, {
            key: "item_title",
            align: "left-top",
            offsetX: this.applyScale(48),
            offsetY: this.applyScale(23),
            expand: false
        });
        // Cost Subtitle
        this._costSubtitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getCostSubtitle(), this.applyScale(16), 0);
        this._costSubtitle.setTint($cc99e0882fef280b$var$subtitleTint);
        this.add(this._costSubtitle, {
            key: "cost_subtitle",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(108),
            expand: false
        });
        //Cost Progress Bar(s)
        this.addCostProgressBars();
        // Build Time Subtitle
        this._buildTimeSubtitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Build time", this.applyScale(16), 0);
        this._buildTimeSubtitle.setTint($cc99e0882fef280b$var$subtitleTint);
        this.add(this._buildTimeSubtitle, {
            key: "upgrade_time_subtitle",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(189),
            expand: false
        });
        this.addBuildTimeProgressBar();
        // Middle Divider
        const middleDivider = this.scene.add.image(0, 0, "machine_item_info_divider_short").setScale(this._scale);
        this.add(middleDivider, {
            key: "middle_divider",
            align: "left-top",
            offsetX: this.applyScale(288),
            offsetY: this.applyScale(282),
            expand: false
        });
        // Fixed width sizer for dynamic content
        this._dynamicSizer = this.scene.rexUI.add.fixWidthSizer(0, 0, {
            x: 0,
            y: 0,
            width: this.applyScale($cc99e0882fef280b$var$modalWidth - 300),
            height: this.applyScale(320),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        if (this._hasYield) {
            // Yield Title
            this._yieldTitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getYieldText(), this.applyScale(16), 0);
            this._yieldTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(this._yieldTitle, {
                key: "yield_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Yield progress bar
            this.addYieldProgressBar();
        }
        if (this._hasStorage) {
            // Storage Title
            this._storageTitle = this.scene.add.bitmapText(0, 0, "cc_outline", `Storage`, this.applyScale(16), 0);
            this._storageTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(this._storageTitle, {
                key: "storage_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Storage progress bar(s)
            this.addStorageProgressBars();
        }
        if (this._hasYield || this._hasStorage) {
            // Lower Divider
            const lowerDivider = this.scene.add.image(0, 0, "machine_item_info_divider_short").setScale(this._scale);
            this._dynamicSizer.add(lowerDivider, {
                key: "lower_divider",
                padding: {
                    left: this.applyScale(0),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
        }
        if (this._hasHP) {
            // HP Title
            const hpTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "HP", this.applyScale(16), 0);
            hpTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(hpTitle, {
                key: "hp_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // HP Progress Bar
            this.addHpProgressBar();
        }
        if (this._hasDPS) {
            // DPS Title
            const dpsTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Defensive Damage", this.applyScale(16), 0);
            dpsTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(dpsTitle, {
                key: "dps_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // HP Progress Bar
            this.addDpsProgressBar();
        }
        if (this._hasTroopCapacity) {
            // Capacity Title
            const capacityTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Capacity", this.applyScale(16), 0);
            capacityTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(capacityTitle, {
                key: "capacity_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Capacity Progress Bar
            this.addCapacityProgressBar();
        }
        if (this._showAdditionalBoosts) {
            // Additional Boosts Title
            const additionalBoostsTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Additional Boosts", this.applyScale(16), 0);
            additionalBoostsTitle.setTint($cc99e0882fef280b$var$subtitleTint);
            this._dynamicSizer.add(additionalBoostsTitle, {
                key: "additional_boosts_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Additional Boosts Text
            this.addAdditionalBoosts();
        }
        // Add dynamic sizer to parent sizer
        this.add(this._dynamicSizer.layout(), {
            key: "dynamic_sizer",
            align: "left-top",
            offsetX: this.applyScale(288),
            offsetY: this.applyScale(283),
            expand: false
        });
        // Description Title
        this._descriptionTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Description", this.applyScale(16), 0);
        this._descriptionTitle.setTint($cc99e0882fef280b$var$subtitleTint);
        this.add(this._descriptionTitle, {
            key: "description_title",
            align: "left-top",
            offsetX: this.applyScale(45),
            offsetY: this.applyScale(484),
            expand: false
        });
        // Description Text Area
        this._descriptionText = this.scene.rexUI.add.textArea({
            x: 0,
            y: 0,
            width: this.applyScale(244),
            height: this.applyScale(76),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this.getDescription(), this.applyScale(16), 0),
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            scroller: true
        }).layout();
        this._descriptionText.setText(this.getDescription());
        this.add(this._descriptionText, {
            key: "description_text",
            align: "left-top",
            offsetX: this.applyScale(45),
            offsetY: this.applyScale(512),
            expand: false
        });
        // Upgrade box bg
        const upgradeBg = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($cc99e0882fef280b$var$upgradeBoxWidth), this.applyScale($cc99e0882fef280b$var$upgradeBoxHeight), this.applyScale($cc99e0882fef280b$var$upgradeBoxRadius), $cc99e0882fef280b$var$upgradeBoxColor, $cc99e0882fef280b$var$upgradeBoxAlpha);
        this.add(upgradeBg, {
            key: "upgrade_bg",
            align: "center-bottom",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(-33),
            expand: false
        });
        // Purchase message
        this._purchaseMessage = this.scene.add.bitmapText(0, 0, "cc_outline", this.getPurchaseMessage(), this.applyScale(16), 0);
        this.add(this._purchaseMessage, {
            key: "purchase_message",
            align: "left-bottom",
            offsetX: this.applyScale(68),
            offsetY: this.applyScale(-57),
            expand: false
        });
        // Buy Button
        this._buyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, $cc99e0882fef280b$var$buyButtonImageKey, false).setScale(scene.getScale());
        scene.add.existing(this._buyButton);
        this._buyButton.onClick().subscribe((pointer)=>{
            this.scene.scene.start("ShopPurchaseConfirmScene", {
                item: this._item,
                isUpgrade: false
            });
        });
        this.add(this._buyButton, {
            key: "buy_button",
            align: "right-bottom",
            offsetX: this.applyScale(-56),
            offsetY: this.applyScale(-43),
            expand: false
        });
        return this.layout();
    }
    hidePane() {
        this._closeButton.setAlpha(0);
        this._itemComponent.setAlpha(0);
    //this.table.disableInteractive();
    }
    closeButtonHandler() {
        this.scene.scene.resume("ShopModalScene");
        this.scene.scene.stop();
    }
    getDisplayName() {
        return `${this._item.display_name || "Unknown Item"} (Level ${this._item.level})`;
    }
    getCostSubtitle() {
        return "Cost to build";
    }
    getDescription() {
        return this._item.description;
    }
    getYieldText() {
        return this._item.machine_id === $cc99e0882fef280b$var$starLabMachineId ? `Speed Boost` : `Yield per hour`;
    }
    getPurchaseMessage() {
        if (this._item.barracks_level_requirement > 0) return `You will need a Level ${this._item.barracks_level_requirement} Barracks for this purchase.`;
        else return `You will need a Level ${this._item.mainframe_level_required} Mainframe for this purchase.`;
    }
    getStarLabMultiplier() {
        return $cc99e0882fef280b$var$starLabMultipliers[parseInt(this._item.level)];
    }
    addAdditionalBoosts() {
        const textArea = this.scene.rexUI.add.textArea({
            x: 0,
            y: 0,
            width: this.applyScale($cc99e0882fef280b$var$neonGoldBarWidth),
            height: this.applyScale(38),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this.getDescription(), this.applyScale(16), 0),
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            scroller: true
        }).layout();
        const boost = this.getAdditionalBoosts();
        textArea.setText(boost.shopText);
        if (boost.highlightStartIndex) textArea.getElement("text").setCharacterTint(boost.highlightStartIndex, boost.highlightLength, true, $cc99e0882fef280b$var$textHighlightColor);
        this._dynamicSizer.add(textArea, {
            key: "boosts_text_area",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    getAdditionalBoosts() {
        return (0, $e197c18c77ea506c$export$2e2bcd8739ae039).getInstance().getMachineBoosts(this._item);
    }
    addBuildTimeProgressBar() {
        const timeProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "time_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this.secondsToTime(this._item.time_to_build) || "0M",
                fontStyle: null,
                fontSize: undefined,
                width: $cc99e0882fef280b$var$neonGoldBarWidth,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$goldProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 100,
                progressValue: 0,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: $cc99e0882fef280b$var$neonGoldBarWidth - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
        this.add(timeProgBar, {
            key: "time_prog_bar",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(212),
            expand: false
        });
    }
    addCostProgressBars() {
        const spaceElixirCost = this.getSpaceElixirCost();
        const neonGoldCost = this.getNeonGoldCost();
        const stardustCost = this.getStardustCost();
        var resourceCount = 0;
        if (spaceElixirCost > 0) resourceCount++;
        if (neonGoldCost > 0) resourceCount++;
        if (stardustCost > 0) resourceCount++;
        if (resourceCount > 1) {
            //Draw all three progress bars
            const starBar = this.createStardustBar(stardustCost, stardustCost > 0 ? stardustCost : 1, $cc99e0882fef280b$var$shortBarWidth + 3, false, 16);
            const spaceBar = this.createSpaceElixirBar(spaceElixirCost, spaceElixirCost > 0 ? spaceElixirCost : 1, $cc99e0882fef280b$var$shortBarWidth, false, 16);
            const neonBar = this.createNeonGoldBar(neonGoldCost, neonGoldCost > 0 ? neonGoldCost : 1, $cc99e0882fef280b$var$shortBarWidth, false, 16);
            this.scene.add.existing(starBar);
            this.scene.add.existing(spaceBar);
            this.scene.add.existing(neonBar);
            this.add(spaceBar, {
                key: "space_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365),
                offsetY: this.applyScale(133),
                expand: false
            }).add(neonBar, {
                key: "neon_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365 + $cc99e0882fef280b$var$shortBarWidth + $cc99e0882fef280b$var$shortBarSpace),
                offsetY: this.applyScale(133),
                expand: false
            }).add(starBar, {
                key: "star_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365 + $cc99e0882fef280b$var$shortBarWidth * 2 + $cc99e0882fef280b$var$shortBarSpace * 2),
                offsetY: this.applyScale(131),
                expand: false
            });
        } else {
            var costProgBar;
            //Draw only one progress bar
            if (stardustCost > 0) costProgBar = this.createStardustBar(this._item.cost_stardust, this._item.cost_stardust, $cc99e0882fef280b$var$stardustBarWidth);
            else if (neonGoldCost > 0) costProgBar = this.createNeonGoldBar(this._item.cost_neon_gold, this._item.cost_neon_gold, $cc99e0882fef280b$var$neonGoldBarWidth);
            else if (spaceElixirCost > 0) costProgBar = this.createSpaceElixirBar(this._item.cost_space_elixir, this._item.cost_space_elixir, $cc99e0882fef280b$var$spaceElixirBarWidth);
            else // Machine level is maxed out
            costProgBar = this.createNeonGoldBar(neonGoldCost, neonGoldCost > 0 ? neonGoldCost : 1, $cc99e0882fef280b$var$neonGoldBarWidth);
            this.scene.add.existing(costProgBar);
            this.add(costProgBar, {
                key: "cost_prog_bar",
                align: "left-top",
                offsetX: this.applyScale(365),
                offsetY: this.applyScale(133),
                expand: false
            });
        }
    }
    addYieldProgressBar() {
        const spaceElixirYield = this._item.produce_per_hour_space_elixir;
        const neonGoldYield = this._item.produce_per_hour_neon_gold;
        const stardustYield = this._item.produce_per_hour_stardust;
        var resourceCount = 0;
        if (spaceElixirYield > 0) resourceCount++;
        if (neonGoldYield > 0) resourceCount++;
        if (stardustYield > 0) resourceCount++;
        if (resourceCount > 1) {
            //Draw both progress bars
            const mainBar = spaceElixirYield > 0 ? this.createSpaceElixirBar(spaceElixirYield, spaceElixirYield, $cc99e0882fef280b$var$spaceElixirBarWidth, false, undefined) : this.createNeonGoldBar(neonGoldYield, neonGoldYield, $cc99e0882fef280b$var$neonGoldBarWidth, false, undefined);
            const sdBar = this.createStardustBar(stardustYield, stardustYield, $cc99e0882fef280b$var$stardustBarWidth, false, undefined);
            this._dynamicSizer.add(mainBar, {
                key: "main_yield_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            }).add(sdBar, {
                key: "stardust_yield_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(14),
                    bottom: 0
                }
            });
        } else {
            var yieldProgBar;
            if (neonGoldYield > 0) yieldProgBar = this.createNeonGoldBar(neonGoldYield, neonGoldYield, $cc99e0882fef280b$var$neonGoldBarWidth, false);
            else if (spaceElixirYield > 0) yieldProgBar = this.createSpaceElixirBar(spaceElixirYield, spaceElixirYield, $cc99e0882fef280b$var$spaceElixirBarWidth, false);
            else if (stardustYield > 0) yieldProgBar = this.createStardustBar(stardustYield, stardustYield, $cc99e0882fef280b$var$stardustBarWidth, false);
            if (yieldProgBar) {
                this.scene.add.existing(yieldProgBar);
                this._dynamicSizer.add(yieldProgBar, {
                    key: "yield_prog_bar",
                    padding: {
                        left: this.applyScale(77),
                        right: 0,
                        top: this.applyScale(8),
                        bottom: 0
                    }
                });
            }
        }
    }
    addStorageProgressBars() {
        const spaceElixirStorage = this._item.storage_space_elixir;
        const neonGoldStorage = this._item.storage_neon_gold;
        var resourceCount = 0;
        if (spaceElixirStorage > 0) resourceCount++;
        if (neonGoldStorage > 0) resourceCount++;
        if (resourceCount > 1) {
            //Draw both progress bars
            const spaceBar = this.createSpaceElixirBar(spaceElixirStorage, spaceElixirStorage, $cc99e0882fef280b$var$spaceElixirBarWidth, false, undefined);
            const neonBar = this.createNeonGoldBar(neonGoldStorage, neonGoldStorage, $cc99e0882fef280b$var$neonGoldBarWidth, false, undefined);
            this.scene.add.existing(spaceBar);
            this.scene.add.existing(neonBar);
            this._dynamicSizer.add(spaceBar, {
                key: "space_storage_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            }).add(neonBar, {
                key: "neon_storage_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(14),
                    bottom: 0
                }
            });
        } else {
            var storageProgBar;
            //Draw only one progress bar
            if (neonGoldStorage > 0) storageProgBar = this.createNeonGoldBar(neonGoldStorage, neonGoldStorage, $cc99e0882fef280b$var$neonGoldBarWidth, false);
            else if (spaceElixirStorage > 0) storageProgBar = this.createSpaceElixirBar(spaceElixirStorage, spaceElixirStorage, $cc99e0882fef280b$var$spaceElixirBarWidth, false);
            this.scene.add.existing(storageProgBar);
            this._dynamicSizer.add(storageProgBar, {
                key: "storage_prog_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            });
        }
    }
    addHpProgressBar() {
        const progressValue = this._item.hitpoints;
        const hpProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "hp_icon",
                space: 8,
                scale: 1
            },
            // previewBar: {
            //     color: hpPreviewBarColor,
            //     width: neonGoldBarWidth * ((progressValue + 1) / 10),
            //     alpha: 1
            // },
            progressBar: {
                text: progressValue,
                fontStyle: null,
                fontSize: undefined,
                width: $cc99e0882fef280b$var$neonGoldBarWidth,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$hpProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 100,
                progressValue: progressValue,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: $cc99e0882fef280b$var$neonGoldBarWidth - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
        this._dynamicSizer.add(hpProgBar, {
            key: "hp_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    addDpsProgressBar() {
        const progressValue = this._item.dps;
        const dpsProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "dps_icon",
                space: 8,
                scale: 1
            },
            previewBar: {
            },
            progressBar: {
                text: `${progressValue.toLocaleString("en-us")} per second`,
                fontStyle: null,
                fontSize: undefined,
                width: $cc99e0882fef280b$var$neonGoldBarWidth,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$dpsProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 10,
                progressValue: 10,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: $cc99e0882fef280b$var$neonGoldBarWidth - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
        this._dynamicSizer.add(dpsProgBar, {
            key: "dps_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    addCapacityProgressBar() {
        const progressValue = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormCapacity(1);
        const capacityProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "hp_icon",
                space: 8,
                scale: 1
            },
            previewBar: {
            },
            progressBar: {
                text: `${progressValue.toLocaleString("en-us")}`,
                fontStyle: null,
                fontSize: undefined,
                width: $cc99e0882fef280b$var$neonGoldBarWidth,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$hpProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: 0,
                maxValue: 10,
                progressValue: 10,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: $cc99e0882fef280b$var$neonGoldBarWidth - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
        this._dynamicSizer.add(capacityProgBar, {
            key: "capacity_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    createSpaceElixirBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "space_elixir_icon",
                space: 8,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $cc99e0882fef280b$var$bluePreviewBarColor,
                width: width * ((progressValue + 1) / 10),
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$blueProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: $cc99e0882fef280b$var$spaceElixirMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: width - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
    }
    createNeonGoldBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "neon_gold_icon",
                space: 8,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $cc99e0882fef280b$var$goldPreviewBarColor,
                width: width * ((progressValue + 1) / 10),
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$goldProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: $cc99e0882fef280b$var$neonGoldMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: width - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
    }
    createStardustBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "stardust_icon_44",
                space: 5,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $cc99e0882fef280b$var$pinkPreviewBarColoar,
                width: width * 0.8,
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $cc99e0882fef280b$var$progressBarHeight,
                radius: $cc99e0882fef280b$var$radius,
                color: $cc99e0882fef280b$var$pinkProgressBarColor,
                alpha: $cc99e0882fef280b$var$progressBarAlpha,
                backgroundColor: $cc99e0882fef280b$var$backgroundColor,
                backgroundAlpha: $cc99e0882fef280b$var$backgroundAlpha,
                minValue: $cc99e0882fef280b$var$stardustMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $cc99e0882fef280b$var$glareHeight,
                    width: width - $cc99e0882fef280b$var$glareOffset,
                    radius: $cc99e0882fef280b$var$glareRadius,
                    color: $cc99e0882fef280b$var$glareColor,
                    alpha: $cc99e0882fef280b$var$glareAlpha
                }
            }
        });
    }
    getSpaceElixirCost() {
        return this._item.cost_space_elixir;
    }
    getNeonGoldCost() {
        return this._item.cost_neon_gold;
    }
    getStardustCost() {
        return this._item.cost_stardust;
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? `${h}H` : "";
        var mDisplay = m > 0 ? `${m}M` : "";
        // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        if (h === 0 && m === 0 && s > 0) return "< 1M";
        return h > 0 ? `${hDisplay} ${mDisplay}` : mDisplay;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("machineInfoContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new MachineUpgradeContentPane(this.scene, x, y));
});


const $80b14ede02fb82ea$var$modalWidth = 1008;
const $80b14ede02fb82ea$var$modalHeight = 735;
const $80b14ede02fb82ea$var$modalRadius = 16;
const $80b14ede02fb82ea$var$modalColor = 0x1c1c2c;
const $80b14ede02fb82ea$var$modalAlpha = 1;
const $80b14ede02fb82ea$var$modalBorderColor = 0x6262DE;
const $80b14ede02fb82ea$var$modalBorderWidth = 3;
class $80b14ede02fb82ea$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userMachine = data.userMachine;
    }
    constructor(){
        super({
            key: "MachineInfoModalScene"
        });
    }
    preload() {
        this.load.image("machine_info_close_button", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).machine_info_close_button);
        this.load.image("shop_buy_button", (0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79).shop_buy_button);
        this.load.image("machine_info_speed_up_button", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).machine_info_speed_up_button);
        this.load.image("machine_item_info_divider_long", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).machine_item_info_divider_long);
        this.load.image("machine_item_info_divider_short", (0, $1aa2c39fc1fbb95e$export$d6d96f2257233255).machine_item_info_divider_short);
    }
    create() {
        const self = this;
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.dragDistanceThreshold = 16;
        this.input.dragTimeThreshold = 300;
        this.input.topOnly = true;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($80b14ede02fb82ea$var$modalWidth, $80b14ede02fb82ea$var$modalHeight);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale(597),
            width: this.applyScale($80b14ede02fb82ea$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($80b14ede02fb82ea$var$modalWidth), this.applyScale($80b14ede02fb82ea$var$modalHeight), this.applyScale($80b14ede02fb82ea$var$modalRadius), $80b14ede02fb82ea$var$modalColor, $80b14ede02fb82ea$var$modalAlpha);
        background.setStrokeStyle(this.applyScale($80b14ede02fb82ea$var$modalBorderWidth), $80b14ede02fb82ea$var$modalBorderColor, $80b14ede02fb82ea$var$modalAlpha);
        this._sizer.add(background, {
            key: "shop_bg",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._machineInfoContentPane = new (0, $cc99e0882fef280b$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, this.sys.canvas.height / 2, this._userMachine, this._scale);
        this.add.existing(this._machineInfoContentPane);
        this._sizer.add(this._machineInfoContentPane, {
            key: "machine_info_content_pane",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.layout();
        this._sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this._machineInfoContentPane = undefined;
            this.scene.stop();
            // this.scene.resume('HomebaseScene');
            // this.scene.get('HomebaseScene').input.enabled = true;
            this.scene.resume("ShopModalScene");
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {
        this._machineInfoContentPane.destroy();
    }
}










const $c7945900278e79f3$var$modalWidth = 494;
const $c7945900278e79f3$var$modalHeight = 366;
const $c7945900278e79f3$var$modalRadius = 50;
const $c7945900278e79f3$var$modalColor = 0x350926;
const $c7945900278e79f3$var$modalAlpha = 1;
const $c7945900278e79f3$var$modalBorderColor = 0x3d4361;
const $c7945900278e79f3$var$modalBorderWidth = 1;
const $c7945900278e79f3$var$goldProgressBarColor = 0xdea827;
const $c7945900278e79f3$var$pinkProgressBarColor = 0xde2795;
const $c7945900278e79f3$var$blueProgressBarColor = 0x00a6d3;
const $c7945900278e79f3$var$progressBarAlpha = 1;
const $c7945900278e79f3$var$glareColor = 0xffffff;
const $c7945900278e79f3$var$glareAlpha = 0.14;
const $c7945900278e79f3$var$glareRadius = 3;
const $c7945900278e79f3$var$glareHeight = 6;
const $c7945900278e79f3$var$glareOffset = 10;
const $c7945900278e79f3$var$borderWidth = 1;
const $c7945900278e79f3$var$borderColor = 0x383d57;
const $c7945900278e79f3$var$borderAlpha = 1;
const $c7945900278e79f3$var$backgroundColor = 0x201425;
const $c7945900278e79f3$var$backgroundAlpha = 0.4;
const $c7945900278e79f3$var$radius = 11;
const $c7945900278e79f3$var$progressBarHeight = 43;
const $c7945900278e79f3$var$progressBarWidth = 240;
const $c7945900278e79f3$var$minDaysHeldToStake = 7;
const $c7945900278e79f3$var$resources = {
    space_elixir: "space_elixir",
    neon_gold: "neon_gold",
    stardust: "stardust",
    dark_matter: "dark_matter"
};
const $c7945900278e79f3$var$collectionSlugs = {
    sw_genesis: "starwolves",
    sw_generative: "starwolvez-generative",
    ga_generative_new: "gapes-nft",
    ga_generative_old: "galacticapes",
    ga_genesis: "galacticapesgenesis",
    ga_monkes: "galacticmonkes"
};
class $c7945900278e79f3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._resource = data.resource;
    }
    constructor(){
        super({
            key: "ResourceModalScene"
        });
    }
    preload() {}
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($c7945900278e79f3$var$modalWidth, $c7945900278e79f3$var$modalHeight + 60);
        const user = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        const userMachines = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync();
        const storageCapacity = this.getStorageCapacity(userMachines);
        const resourceTotal = this.getResourceTotal(user);
        const yieldTotal = this.getYieldTotal(userMachines);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($c7945900278e79f3$var$modalWidth), this.applyScale($c7945900278e79f3$var$modalHeight), this.applyScale($c7945900278e79f3$var$modalRadius), $c7945900278e79f3$var$modalColor, $c7945900278e79f3$var$modalAlpha);
        modalBg.setStrokeStyle($c7945900278e79f3$var$modalBorderWidth, $c7945900278e79f3$var$modalBorderColor, $c7945900278e79f3$var$modalAlpha);
        const resourceIcon = this._resource === $c7945900278e79f3$var$resources.neon_gold ? "neon_gold_icon_large" : this._resource === $c7945900278e79f3$var$resources.space_elixir ? "space_elixir_icon_large" : this._resource === $c7945900278e79f3$var$resources.dark_matter ? "dark_matter_icon_large" : "stardust_icon_large";
        // Add Icons
        this.add.image(modalBg.getTopCenter().x, modalBg.getTopLeft().y, resourceIcon).setScale(this._scale);
        // Add Sizer for content
        var sizer = new (0, $4d318a74c42de65b$export$2e2bcd8739ae039)(this, {
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($c7945900278e79f3$var$modalWidth),
            height: this.applyScale($c7945900278e79f3$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this.add.existing(sizer);
        // Add Title Text
        const titleText = this._resource === $c7945900278e79f3$var$resources.neon_gold ? "Neon Gold" : this._resource === $c7945900278e79f3$var$resources.space_elixir ? "Space Elixir" : this._resource === $c7945900278e79f3$var$resources.dark_matter ? "Dark Matter" : "Stardust";
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", titleText, this.applyScale(28), 1), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(60),
            expand: false
        });
        if (this._resource === $c7945900278e79f3$var$resources.dark_matter) {
            sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Coming Soon...", this.applyScale(24), 1).setAlpha(0.7), {
                key: "coming_soon_text",
                align: "center-top",
                offsetX: 0,
                offsetY: this.applyScale(175),
                expand: false
            });
            this.addCloseButton(sizer, modalBg);
            sizer.layout();
            return;
        }
        // Storage display
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this._resource === $c7945900278e79f3$var$resources.stardust ? "Your Soft Staking Yield (Daily)" : "Your Storage", this.applyScale(18), 1), {
            key: "storage_title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(116),
            expand: false
        });
        const storageProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this._resource === $c7945900278e79f3$var$resources.stardust ? this.getSDOwnerYieldText() : `${resourceTotal.toLocaleString("en-us")} of ${storageCapacity.toLocaleString("en-us")}`,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $c7945900278e79f3$var$borderWidth,
                color: $c7945900278e79f3$var$borderColor,
                alpha: $c7945900278e79f3$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $c7945900278e79f3$var$progressBarWidth,
                height: $c7945900278e79f3$var$progressBarHeight,
                radius: $c7945900278e79f3$var$radius,
                color: this._resource === $c7945900278e79f3$var$resources.space_elixir ? $c7945900278e79f3$var$blueProgressBarColor : this._resource === $c7945900278e79f3$var$resources.neon_gold ? $c7945900278e79f3$var$goldProgressBarColor : $c7945900278e79f3$var$pinkProgressBarColor,
                alpha: $c7945900278e79f3$var$progressBarAlpha,
                backgroundColor: $c7945900278e79f3$var$backgroundColor,
                backgroundAlpha: $c7945900278e79f3$var$backgroundAlpha,
                minValue: 0,
                maxValue: storageCapacity,
                progressValue: resourceTotal,
                glare: {
                    height: $c7945900278e79f3$var$glareHeight,
                    width: $c7945900278e79f3$var$progressBarWidth - $c7945900278e79f3$var$glareOffset,
                    radius: $c7945900278e79f3$var$glareRadius,
                    color: $c7945900278e79f3$var$glareColor,
                    alpha: $c7945900278e79f3$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(storageProgBar);
        storageProgBar.setProgressBarText("");
        sizer.add(storageProgBar, {
            key: "storage_prog_bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(142),
            expand: false
        });
        // Yield display
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Your Machine Yield (Hourly)", this.applyScale(18), 1), {
            key: "yield_title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(205),
            expand: false
        });
        const yieldProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: `${yieldTotal.toLocaleString("en-us")} per hour`,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $c7945900278e79f3$var$borderWidth,
                color: $c7945900278e79f3$var$borderColor,
                alpha: $c7945900278e79f3$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $c7945900278e79f3$var$progressBarWidth,
                height: $c7945900278e79f3$var$progressBarHeight,
                radius: $c7945900278e79f3$var$radius,
                color: $c7945900278e79f3$var$pinkProgressBarColor,
                alpha: $c7945900278e79f3$var$progressBarAlpha,
                backgroundColor: $c7945900278e79f3$var$backgroundColor,
                backgroundAlpha: $c7945900278e79f3$var$backgroundAlpha,
                minValue: 0,
                maxValue: 1,
                progressValue: this._resource === $c7945900278e79f3$var$resources.stardust ? 1 : 0,
                glare: {
                    height: $c7945900278e79f3$var$glareHeight,
                    width: $c7945900278e79f3$var$progressBarWidth - $c7945900278e79f3$var$glareOffset,
                    radius: $c7945900278e79f3$var$glareRadius,
                    color: $c7945900278e79f3$var$glareColor,
                    alpha: $c7945900278e79f3$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(yieldProgBar);
        yieldProgBar.setProgressBarText("");
        sizer.add(yieldProgBar, {
            key: "yield_prog_bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(231),
            expand: false
        });
        if (resourceTotal > storageCapacity && this._resource !== $c7945900278e79f3$var$resources.stardust) // Yield paused note
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Note: You are not currently yielding rewards from mining this resource as you have exceeded your max storage.", this.applyScale(14), 1).setMaxWidth(this.applyScale(400)), {
            key: "yield_paused_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(290),
            expand: false
        });
        sizer.layout();
        this.addCloseButton(sizer, modalBg);
    }
    addCloseButton(sizer, modalBg) {
        // Add Cancel Button
        const closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "modal_close_button", false).setScale(this._scale);
        closeButton.onClick().subscribe((pointer)=>{
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(closeButton);
        sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this.scene.stop();
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
        });
    }
    getSDOwnerYieldText() {
        return `${(0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getNetStakingYield()} per day`;
    }
    getStorageCapacity(userMachines) {
        var storageTotal = 0;
        const storageProperty = this._resource === $c7945900278e79f3$var$resources.neon_gold ? "storage_neon_gold" : this._resource === $c7945900278e79f3$var$resources.space_elixir ? "storage_space_elixir" : "stardust";
        if (storageProperty === "stardust") return 0;
        userMachines.forEach((mach)=>{
            if (mach[storageProperty] && mach[storageProperty] > 0) storageTotal = storageTotal + mach[storageProperty];
        });
        return storageTotal;
    }
    getResourceTotal(user) {
        return user[this._resource];
    }
    getYieldTotal(userMachines) {
        var yieldTotal = 0.0;
        const yieldProperty = this._resource === $c7945900278e79f3$var$resources.neon_gold ? "produce_per_hour_neon_gold" : this._resource === $c7945900278e79f3$var$resources.space_elixir ? "produce_per_hour_space_elixir" : "produce_per_hour_stardust";
        userMachines.forEach((mach)=>{
            if (mach[yieldProperty] && mach[yieldProperty] > 0) yieldTotal = yieldTotal + parseFloat(mach[yieldProperty]);
        });
        return yieldTotal.toFixed(this._resource === $c7945900278e79f3$var$resources.stardust ? 2 : 0);
    }
    applyScale(length) {
        return length * this._scale;
    }
}











const $dba42957ce8632a0$var$modalHeight = 325;
const $dba42957ce8632a0$var$modalWidth = 494;
const $dba42957ce8632a0$var$modalRadius = 50;
const $dba42957ce8632a0$var$modalColor = 0x350926;
const $dba42957ce8632a0$var$modalAlpha = 1;
const $dba42957ce8632a0$var$modalBorderColor = 0x3d4361;
const $dba42957ce8632a0$var$modalBorderWidth = 1;
const $dba42957ce8632a0$var$progressBarColor = 0xd3007f;
const $dba42957ce8632a0$var$progressBarAlpha = 1;
const $dba42957ce8632a0$var$glareColor = 0xffffff;
const $dba42957ce8632a0$var$glareAlpha = 0.14;
const $dba42957ce8632a0$var$glareRadius = 4;
const $dba42957ce8632a0$var$glareHeight = 8;
const $dba42957ce8632a0$var$glareOffset = 8;
const $dba42957ce8632a0$var$backgroundColor = 0x201425;
const $dba42957ce8632a0$var$backgroundAlpha = 0.7;
const $dba42957ce8632a0$var$radius = 11;
const $dba42957ce8632a0$var$progressBarHeight = 43;
const $dba42957ce8632a0$var$progressBarWidth = 213;
const $dba42957ce8632a0$var$progressBarBorderColor = 0x383d57;
const $dba42957ce8632a0$var$progressBarBorderWidth = 1;
const $dba42957ce8632a0$var$progressMin = 0;
const $dba42957ce8632a0$var$progressUpdateDelay = 1; //seconds
class $dba42957ce8632a0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._machine = data.machine;
        this._homebaseMachine = data.homebaseMachine;
    }
    constructor(){
        super({
            key: "MachineSpeedUpModalScene"
        });
    }
    preload() {
        this.load.image("pvp_confirm_button", (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59).pvp_confirm_button);
        this.load.image("pvp_cancel_button", (0, $1aa2c39fc1fbb95e$export$a4ea34a7e927ea59).pvp_cancel_button);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($dba42957ce8632a0$var$modalWidth, $dba42957ce8632a0$var$modalHeight + 100);
        // Add Background
        this._modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($dba42957ce8632a0$var$modalWidth), this.applyScale($dba42957ce8632a0$var$modalHeight), this.applyScale($dba42957ce8632a0$var$modalRadius), $dba42957ce8632a0$var$modalColor, $dba42957ce8632a0$var$modalAlpha);
        this._modalBg.setStrokeStyle($dba42957ce8632a0$var$modalBorderWidth, $dba42957ce8632a0$var$modalBorderColor, $dba42957ce8632a0$var$modalAlpha);
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this._blob = this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(45), "party_blob").setOrigin(0.5, 0.5).setScale(0.7 * this._scale).play("blob_animation");
        this._calculatingLabel = this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + this.applyScale(45), "cc_outline", "Calculating cost...", this.applyScale(24), 2).setOrigin(0.5, 0.5).setAlpha(0.7);
        (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachines(true).then((res)=>{
            var machine = res.find((mach)=>{
                return mach.user_machine_id === this._machine.user_machine_id;
            });
            if (machine) this._machine = machine;
            this.createComponent();
        });
    }
    createComponent() {
        // Hide Blob and Calculating label
        this._blob.setAlpha(0);
        this._blob.destroy();
        this._blob = undefined;
        this._calculatingLabel.setAlpha(0);
        this._calculatingLabel.destroy();
        this._calculatingLabel = undefined;
        // Add Sizer for content
        this._sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale(300),
            height: this.applyScale(240),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        this._sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Time remaining to\nupgrade machine:", this.applyScale(20), 1).setMaxWidth(300), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Cost Title
        this._sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Speed up cost:", this.applyScale(20), 1), {
            key: "speed_up_cost_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(128),
            expand: false
        });
        // Add Fee Labels
        const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", this._machine.stardust_upgrade_cost.toLocaleString("en-us"));
        this._sizer.add(this.add.existing(stardust_label), {
            key: "stardust_label",
            align: "center",
            offsetX: 0,
            offsetY: this.applyScale(60),
            expand: false
        });
        this.createProgressBar(this);
        this._sizer.layout();
        // Add close Button
        const closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), this._modalBg.getBottomLeft().y, "pvp_cancel_button", false).setScale(this._scale);
        closeButton.onClick().subscribe((pointer)=>{
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
            this.unloadAssets();
            this.scene.stop();
        });
        this.add.existing(closeButton);
        // Add Confirm Button
        this._speedUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), this._modalBg.getBottomLeft().y, "pvp_confirm_button", false).setScale(this._scale);
        this._speedUpButton.onClick().subscribe((pointer)=>{
            this._speedUpButton.setDisabled(true);
            (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().speedUpUpgrade(this._machine.user_machine_id, this._machine.stardust_upgrade_cost).then((result)=>{
                if (result.success) {
                    this._homebaseMachine.removeTimeEvents();
                    this.scene.get("HomebaseScene").updateMachines();
                }
                this.unloadAssets();
                this.scene.start("ShopPurchaseResultScene", {
                    item: this._machine,
                    itemType: "speed_up_upgrade",
                    purchaseResult: result
                });
            });
        });
        this.add.existing(this._speedUpButton);
        var userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        if (userData.stardust < this._machine.stardust_upgrade_cost) {
            this._speedUpButton.setDisabled(true);
            this._speedUpButton.setAlpha(0.5);
        }
        this.time.addEvent({
            delay: 1000,
            loop: true,
            callback: ()=>{
                this.updateTimeHandler();
            }
        });
    }
    createProgressBar(scene) {
        let progressValue = this._machine.next_level_build_total_time - this._machine.star_lab_adjusted_time_until_next_level;
        // Progress Bar
        this._progressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: this.secondsToTime(this._machine.star_lab_adjusted_time_until_next_level),
                offset: 2,
                fontSize: 20
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $dba42957ce8632a0$var$progressBarWidth,
                height: $dba42957ce8632a0$var$progressBarHeight,
                radius: $dba42957ce8632a0$var$radius,
                color: $dba42957ce8632a0$var$progressBarColor,
                alpha: $dba42957ce8632a0$var$progressBarAlpha,
                backgroundColor: $dba42957ce8632a0$var$backgroundColor,
                backgroundAlpha: $dba42957ce8632a0$var$backgroundAlpha,
                minValue: $dba42957ce8632a0$var$progressMin,
                maxValue: this._machine.next_level_build_total_time,
                progressValue: progressValue > 0 ? progressValue : 1,
                glare: {
                    height: $dba42957ce8632a0$var$glareHeight,
                    width: $dba42957ce8632a0$var$progressBarWidth - $dba42957ce8632a0$var$glareOffset,
                    radius: $dba42957ce8632a0$var$glareRadius,
                    color: $dba42957ce8632a0$var$glareColor,
                    alpha: $dba42957ce8632a0$var$glareAlpha
                }
            },
            border: {
                alpha: $dba42957ce8632a0$var$backgroundAlpha,
                color: $dba42957ce8632a0$var$progressBarBorderColor,
                width: $dba42957ce8632a0$var$progressBarBorderWidth
            }
        });
        scene.add.existing(this._progressBar);
        this._sizer.add(this._progressBar, {
            key: "machine_progress_bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(57),
            expand: false
        });
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? `${h}h` : "";
        var mDisplay = m > 0 ? `${m}m` : "";
        var sDisplay = s > 0 ? `${s}s` : "";
        return h > 0 ? `${hDisplay} ${mDisplay} ${sDisplay}` : `${mDisplay} ${sDisplay}`;
    }
    updateTimeHandler() {
        this._machine.star_lab_adjusted_time_until_next_level = this._machine.star_lab_adjusted_time_until_next_level - $dba42957ce8632a0$var$progressUpdateDelay;
        this.updateProgress();
        if (this._machine.star_lab_adjusted_time_until_next_level <= 0) {
            this._speedUpButton.setDisabled(true);
            this._speedUpButton.setAlpha(0.5);
        }
    }
    updateProgressText() {
        this._progressBar.setTitle(this.secondsToTime(this._machine.star_lab_adjusted_time_until_next_level));
    }
    updateProgress() {
        let progressValue = this._machine.next_level_build_total_time - this._machine.star_lab_adjusted_time_until_next_level;
        this._progressBar.setProgress(this, progressValue > 0 ? progressValue : 1);
        this.updateProgressText();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, [
            "pvp_confirm_button",
            "pvp_cancel_button"
        ]);
    }
}








const $f8dc067ac15f14fe$var$helpOptions = [
    {
        name: "game_guide",
        type: "guides",
        target_url: "https://starwolvez.notion.site/Star-Wolvez-Game-Guide-5bd3c15b4f3f465bbf24aaa265d3e9c4",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "guide_game_text",
        enabled: true
    },
    {
        name: "changelog",
        type: "guides",
        target_url: "https://starwolvez.notion.site/Changelog-63d570a408864aae9aecb78c6484b070",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "guide_changelog_text",
        enabled: true
    },
    {
        name: "wolf_e_dex",
        type: "guides",
        target_url: "https://dex.starwolvez.com/",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "guide_wolf_e_dex_text",
        enabled: true
    },
    {
        name: "medium",
        type: "guides",
        target_url: "https://medium.com/@starwolvez",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "guide_medium_text",
        enabled: true
    },
    {
        name: "gameplay_basics",
        type: "litepapers",
        target_url: "https://starwolvez.medium.com/the-game-litepaper-001-gameplay-basics-5dc17a4a8b8d",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "litepaper_1_gameplay_text",
        enabled: true
    },
    {
        name: "tokenomics",
        type: "litepapers",
        target_url: "https://starwolvez.medium.com/the-game-litepaper-002-tokenomics-9337a5c03c64",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "litepaper_2_tokenomics_text",
        enabled: true
    },
    {
        name: "traits",
        type: "traits_and_partners",
        target_url: "https://docs.google.com/spreadsheets/d/15j4HqQOvWkgQ-VukKuixV5Vo8FSFez7HRi1RyuptYnY/edit#gid=0",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "traits_text",
        enabled: true
    },
    {
        name: "partners",
        type: "traits_and_partners",
        target_url: "https://starwolvez.notion.site/Partner-Projects-757feec064be49a3bb8e148df0367a24",
        bg_image_key: "helpdesk_option_bg",
        label_image_key: "partners_text",
        enabled: true
    }
];
const $f8dc067ac15f14fe$var$helpTypes = [
    {
        key: "guides",
        displayName: "Guides",
        isSelected: true
    },
    {
        key: "litepapers",
        displayName: "Litepapers",
        isSelected: false
    },
    {
        key: "traits_and_partners",
        displayName: "Traits and Partners",
        isSelected: false
    }
];
class $f8dc067ac15f14fe$var$HelpDeskService {
    constructor(){
        if ($f8dc067ac15f14fe$var$HelpDeskService._instance) throw new Error("Error: Instantiation failed: Use HelpDeskService.getInstance() instead of new.");
        $f8dc067ac15f14fe$var$HelpDeskService._instance = this;
        this._helpOptions = $f8dc067ac15f14fe$var$helpOptions;
        this._helpTypes = $f8dc067ac15f14fe$var$helpTypes;
    }
    static getInstance() {
        return $f8dc067ac15f14fe$var$HelpDeskService._instance;
    }
    getHelpOptions() {
        return this._helpOptions;
    }
    getHelpTypes() {
        return this._helpTypes;
    }
}
$f8dc067ac15f14fe$var$HelpDeskService._instance = new $f8dc067ac15f14fe$var$HelpDeskService();
var $f8dc067ac15f14fe$export$2e2bcd8739ae039 = $f8dc067ac15f14fe$var$HelpDeskService;


class $b4e9ba502da2bdfb$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, category, paneScale, config){
        const conf = config ? config : {
            width: 566 * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._selectedCategory = category;
        this._helpOptions = (0, $f8dc067ac15f14fe$export$2e2bcd8739ae039).getInstance().getHelpOptions();
        // Title Text
        this._titleText = scene.add.bitmapText(x - this.applyScale(259), y - this.applyScale(234), "cc_outline", this._selectedCategory.displayName, this.applyScale(22), 0).setOrigin(0);
        // Options table
        this._table = this.createTable(scene, this._helpOptions.filter((ho)=>{
            return ho.type === this._selectedCategory.key;
        }), x, y + this.applyScale(5), this._scale).layout();
        this.add(this._titleText);
        this.add(this._table);
        this.setDirty(false);
    }
    applyScale(length) {
        return length * this._scale;
    }
    updateTable(data) {
        if (data) this._table.setItems(data);
        this._table.layout();
    }
    createTable(scene, data, x, y, paneScale) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(530),
            height: this.applyScale(392),
            items: data,
            table: {
                cellWidth: this.applyScale(265),
                cellHeight: this.applyScale(180),
                columns: 2,
                clamplTableOXY: false,
                reuseCellContainer: true,
                scrollMode: 0,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(25)
                };
                var itemBg = scene.add.rexCircleMaskImage(0, 0, item.bg_image_key, "", rectConfig);
                itemBg.displayHeight = scene.applyScale(145);
                itemBg.scaleX = itemBg.scaleY;
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(235),
                    height: scene.applyScale(145),
                    space: {
                        left: scene.applyScale(15),
                        right: scene.applyScale(0),
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).add(itemBg, {
                    key: "help_option_bg",
                    align: "center",
                    expand: false
                }).add(scene.add.image(0, 0, item.label_image_key).setScale(scene.getScale()), {
                    key: "help_option_label",
                    align: "center",
                    expand: false
                }).layout();
                if (item.enabled) {
                    sizer.setInteractive({
                        cursor: "pointer"
                    });
                    sizer.setChildrenInteractive({
                        click: {
                            mode: "release",
                            clickInterval: 100
                        },
                        over: true,
                        tap: {
                            time: 250,
                            tapInterval: 200,
                            threshold: 9,
                            tapOffset: 10,
                            taps: undefined,
                            minTaps: undefined,
                            maxTaps: undefined
                        },
                        press: {
                            time: 251,
                            threshold: 9
                        },
                        swipe: {
                            threshold: 10,
                            velocityThreshold: 1000,
                            dir: "8dir"
                        },
                        inputEventPrefix: "child."
                    });
                    sizer.on("child.over", (child, pointer, event)=>{
                        sizer.getElement("help_option_bg").setScale(sizer.getElement("help_option_bg").scaleX * 1.04);
                        sizer.getElement("help_option_label").setScale(sizer.getElement("help_option_bg").scaleX * 1.03);
                    });
                    sizer.on("child.out", (child, pointer, event)=>{
                        sizer.getElement("help_option_bg").setScale(sizer.getElement("help_option_bg").scaleX / 1.04);
                        sizer.getElement("help_option_label").setScale(sizer.getElement("help_option_bg").scaleX / 1.03);
                    });
                } else {
                    sizer.disableInteractive();
                    sizer.setAlpha(0.3);
                }
                sizer.onClick((button, gameObject, pointer, event)=>{
                    var _a;
                    // Open target url in new tab
                    (_a = window.open(item.target_url, "_blank")) === null || _a === void 0 || _a.focus();
                }, this);
                return scene.add.existing(sizer);
            }
        });
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    setCategory(selectedCategory) {
        console.log((0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(selectedCategory));
        if (selectedCategory) {
            this._selectedCategory = selectedCategory;
            this._titleText.setText(selectedCategory.displayName);
            this._table.setItems(this._helpOptions.filter((ho)=>{
                return ho.type === selectedCategory.key;
            })).scrollToTop();
            this._table.layout();
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("helpdeskContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $b4e9ba502da2bdfb$export$2e2bcd8739ae039(this.scene, x, y));
});





const $ba7c51110faef602$var$modalHeight = 468;
const $ba7c51110faef602$var$modalWidth = 814;
const $ba7c51110faef602$var$modalRadius = 25;
const $ba7c51110faef602$var$modalColor = 0x1c1c2c;
const $ba7c51110faef602$var$modalAlpha = 1;
const $ba7c51110faef602$var$spineWidth = 248;
const $ba7c51110faef602$var$spineColor = 0xe6e6ff;
const $ba7c51110faef602$var$spineAlpha = 0.05;
class $ba7c51110faef602$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "HelpdeskModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$3fff705904dea5e1));
    }
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($ba7c51110faef602$var$modalWidth, $ba7c51110faef602$var$modalHeight);
        this._helpTypes = (0, $f8dc067ac15f14fe$export$2e2bcd8739ae039).getInstance().getHelpTypes();
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($ba7c51110faef602$var$modalWidth), this.applyScale($ba7c51110faef602$var$modalHeight), this.applyScale($ba7c51110faef602$var$modalRadius), $ba7c51110faef602$var$modalColor, $ba7c51110faef602$var$modalAlpha);
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($ba7c51110faef602$var$spineWidth), this.applyScale($ba7c51110faef602$var$modalHeight), {
            tl: this.applyScale($ba7c51110faef602$var$modalRadius),
            tr: 0,
            bl: this.applyScale($ba7c51110faef602$var$modalRadius),
            br: 0
        }, $ba7c51110faef602$var$spineColor, $ba7c51110faef602$var$spineAlpha);
        // Title text
        const titleText = this.add.image(0, 0, "helpdesk_text").setOrigin(0).setScale(this._scale);
        // Add spine here
        this._spineTable = this.createSpineTable(this, this._helpTypes, 0, 0).setOrigin(0.5, 0.5);
        this._cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "cancel_btn_purple", true, 1.04).setScale(this._scale);
        this.add.existing(this._cancelButton);
        this._cancelButton.onClick().subscribe((pointer)=>{
            this.cancelButtonClickHandler(pointer);
        });
        this._helpdeskContentPane = new (0, $b4e9ba502da2bdfb$export$2e2bcd8739ae039)(this, 0, 0, this._helpTypes[0], this._scale);
        this.add.existing(this._helpdeskContentPane);
        sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        sizer.add(spineBackground, {
            key: "spineBackground",
            align: "center",
            offsetX: this.applyScale(-($ba7c51110faef602$var$modalWidth / 2 - $ba7c51110faef602$var$spineWidth / 2)),
            offsetY: 0,
            expand: false
        });
        sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(31),
            expand: false
        });
        sizer.add(this._spineTable, {
            key: "table",
            align: "left-top",
            offsetX: this.applyScale(15),
            offsetY: this.applyScale(60),
            expand: false
        });
        sizer.add(this._cancelButton, {
            key: "confirmButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        sizer.add(this._helpdeskContentPane, {
            key: "helpdesk-content-pane",
            align: "left-top",
            offsetX: this.applyScale(532),
            offsetY: this.applyScale(263),
            expand: false
        });
        sizer.layout();
        this.setIsSelected(this._helpTypes[0]);
        sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {
        this._helpTypes = undefined;
        this._helpdeskContentPane = undefined;
    }
    createSpineTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(220),
            height: this.applyScale(450),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(220),
                cellHeight: this.applyScale(32),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                interactive: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                // Template
                let rectConfig = {
                    maskType: "roundRectangle",
                    radius: 0
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(220),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).setInteractive({
                    useHandCursor: true
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(220), scene.applyScale(32), scene.applyScale(6), 0xe6e6ff, 0.05).setAlpha(item.isSelected ? 1 : 0), {
                    key: "menu_option_bg",
                    align: "center",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.displayName, scene.applyScale(16), 0).setAlpha(item.isSelected ? 1 : 0.4), {
                    key: "menu_option_text",
                    align: "left",
                    offsetX: scene.applyScale(10),
                    offsetY: 0,
                    expand: false
                });
                sizer.setChildrenInteractive({
                    click: {
                        mode: "release",
                        clickInterval: 100
                    },
                    over: true,
                    tap: {
                        time: 250,
                        tapInterval: 200,
                        threshold: 9,
                        tapOffset: 10,
                        taps: undefined,
                        minTaps: undefined,
                        maxTaps: undefined
                    },
                    press: {
                        time: 251,
                        threshold: 9
                    },
                    swipe: {
                        threshold: 10,
                        velocityThreshold: 1000,
                        dir: "8dir"
                    },
                    inputEventPrefix: "child."
                });
                sizer.on("child.over", (child, pointer, event)=>{
                    sizer.getElement("menu_option_text").setAlpha(1);
                });
                sizer.on("child.out", (child, pointer, event)=>{
                    if (!item.isSelected) sizer.getElement("menu_option_text").setAlpha(0.4);
                });
                sizer.on("child.click", (child, pointer, event)=>{
                    scene.setIsSelected(item);
                });
                return sizer;
            }
        });
        table.setItems(data).scrollToTop();
        //table.getElement('table').on('')
        return table;
    }
    setIsSelected(item) {
        if (item.isSelected === true) return;
        this._helpTypes = this._helpTypes.map((mt)=>{
            mt.isSelected = mt.displayName === item.displayName ? true : false;
            return mt;
        });
        this._spineTable.setItems(this._helpTypes);
        this._helpdeskContentPane.setCategory(item);
    }
    cancelButtonClickHandler(pointer) {
        this.unloadAssets();
        this.scene.resume("HomebaseScene");
        this.scene.resume("HudScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$3fff705904dea5e1)));
    }
}



var $7WQrb = parcelRequire("7WQrb");









// Pane Details
const $b1317678cc8ff382$var$paneHeight = 972;
const $b1317678cc8ff382$var$paneWidth = 540;
const $b1317678cc8ff382$var$paneRadius = 16;
const $b1317678cc8ff382$var$paneColor = 0x1c1c2c;
const $b1317678cc8ff382$var$paneAlpha = 1;
const $b1317678cc8ff382$var$itemWidth = 500, $b1317678cc8ff382$var$itemHeight = 73, $b1317678cc8ff382$var$itemRadius = 13, $b1317678cc8ff382$var$itemColor = 0x262637, $b1317678cc8ff382$var$itemAlpha = 1;
const $b1317678cc8ff382$var$itemGlareHeight = 7, $b1317678cc8ff382$var$itemGlareRadius = 4, $b1317678cc8ff382$var$itemGlareColor = 0xffffff, $b1317678cc8ff382$var$itemGlareAlpha = 0.08;
const $b1317678cc8ff382$var$progressBarWidth = 463;
const $b1317678cc8ff382$var$progressBarHeight = 22;
const $b1317678cc8ff382$var$progressBarRadius = 7;
const $b1317678cc8ff382$var$progressBarColor = 0xff5831;
const $b1317678cc8ff382$var$progressBarBackgroundColor = 0x383d57;
const $b1317678cc8ff382$var$progressBarBackgroundAlpha = 0.4;
const $b1317678cc8ff382$var$glareHeight = 6;
const $b1317678cc8ff382$var$glareColor = 0xffffff;
const $b1317678cc8ff382$var$glareAlpha = 0.14;
const $b1317678cc8ff382$var$glareOffset = 6;
const $b1317678cc8ff382$var$glareRadius = 3;
class $b1317678cc8ff382$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $b1317678cc8ff382$var$paneWidth,
            height: paneScale * $b1317678cc8ff382$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._battleData = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($b1317678cc8ff382$var$paneWidth), scene.applyScale($b1317678cc8ff382$var$paneHeight), scene.applyScale($b1317678cc8ff382$var$paneRadius), $b1317678cc8ff382$var$paneColor, $b1317678cc8ff382$var$paneAlpha);
        this.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Battle Panel
        var battlePanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($b1317678cc8ff382$var$paneWidth),
            height: scene.applyScale(120),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        const bossFightBadge = this.scene.add.image(0, 0, "bossfight_badge").setScale(this._scale);
        battlePanel.add(bossFightBadge, {
            key: "bossfight_badge",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(-55),
            expand: false
        });
        // Add Title Text
        const bossFightTitle = this.scene.add.image(0, 0, "bossfight_title_text").setScale(this._scale);
        battlePanel.add(bossFightTitle, {
            key: "bossfight_title_text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(55),
            expand: false
        });
        const bossFightDividerTop = this.scene.add.image(0, 0, "bossfight_divider").setScale(this._scale);
        battlePanel.add(bossFightDividerTop, {
            key: "bf-divider-top",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(165),
            expand: false
        });
        // Add Boss Image
        this._bossFightImage = this.scene.add.image(0, 0, (0, $2e76b527e9362cab$export$706bad4d7728db29)[this._battleData.rarity]).setScale(this._scale);
        battlePanel.add(this._bossFightImage, {
            key: "bossfight_boss",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(166),
            expand: false
        });
        const bossFightDividerBottom = this.scene.add.image(0, 0, "bossfight_divider").setScale(this._scale);
        battlePanel.add(bossFightDividerBottom, {
            key: "bf-divider-bottom",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(166 + this._bossFightImage.height + 1),
            expand: false
        });
        // HP Progress Bar
        this._hpProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "bossfight_hp_icon",
                space: 8,
                scale: 1
            },
            border: {
                width: 1,
                color: 0x383d57
            },
            progressBar: {
                text: this._battleData.gameState == 0 ? "Currently Unknown..." : this._battleData.bossRemainingHP.toLocaleString("en-us") + " of " + this._battleData.bossMaxHP.toLocaleString("en-us"),
                textAlign: "left",
                fontStyle: null,
                width: $b1317678cc8ff382$var$progressBarWidth,
                height: $b1317678cc8ff382$var$progressBarHeight,
                radius: $b1317678cc8ff382$var$progressBarRadius,
                color: $b1317678cc8ff382$var$progressBarColor,
                backgroundColor: $b1317678cc8ff382$var$progressBarBackgroundColor,
                backgroundAlpha: $b1317678cc8ff382$var$progressBarBackgroundAlpha,
                minValue: 0,
                maxValue: this._battleData.bossMaxHP,
                progressValue: this._battleData.bossRemainingHP,
                glare: {
                    width: $b1317678cc8ff382$var$progressBarWidth - $b1317678cc8ff382$var$glareOffset,
                    height: $b1317678cc8ff382$var$glareHeight,
                    radius: $b1317678cc8ff382$var$glareRadius,
                    color: $b1317678cc8ff382$var$glareColor,
                    alpha: $b1317678cc8ff382$var$glareAlpha
                }
            }
        });
        battlePanel.add(this._hpProgressBar, {
            key: "hp-progressbar",
            align: "left-top",
            offsetX: this.applyScale(30),
            offsetY: this.applyScale(140),
            expand: false
        });
        // Participants Text
        this._participantsText = this.scene.add.bitmapText(0, 0, "cc_outline", this.getParticipantsText(this._battleData), scene.applyScale(18), 0);
        battlePanel.add(this._participantsText, {
            key: "participants-text",
            align: "left-top",
            offsetX: this.applyScale(30),
            offsetY: this.applyScale(166 + this._bossFightImage.height + 1 + 20),
            expand: false
        });
        // Status Image
        this._stateImage = this.scene.add.image(0, 0, this.getBossFightGameStatusImage(this._battleData.gameState)).setScale(this._scale);
        battlePanel.add(this._stateImage, {
            key: "status-image",
            align: "right-top",
            offsetX: this.applyScale(-30),
            offsetY: this.applyScale(166 + this._bossFightImage.height + 1 + 20),
            expand: false
        });
        this._participantTable = this.createPlayerTable(this.scene, this._battleData.participants, x, y, this.scale).layout();
        battlePanel.add(this._participantTable, {
            key: "traits-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(166 + this._bossFightImage.height + 1 + 80),
            expand: false
        });
        this.add(battlePanel, {
            key: "battle-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    createPlayerTable(scene, data, x, y, scale) {
        var tableHeight = $b1317678cc8ff382$var$paneHeight - (166 + this._bossFightImage.height + 1 + 100);
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($b1317678cc8ff382$var$paneWidth),
            height: scene.applyScale(tableHeight),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($b1317678cc8ff382$var$itemWidth),
                cellHeight: this.applyScale($b1317678cc8ff382$var$itemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, participant = cell.item;
                const participantName = (0, $2e76b527e9362cab$export$cb1a4a19b5054005)(participant.playerName);
                const rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(40)
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($b1317678cc8ff382$var$itemWidth),
                    space: {
                        left: scene.applyScale(20),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($b1317678cc8ff382$var$itemWidth), scene.applyScale($b1317678cc8ff382$var$itemHeight), scene.applyScale($b1317678cc8ff382$var$itemRadius), $b1317678cc8ff382$var$itemColor, $b1317678cc8ff382$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($b1317678cc8ff382$var$itemWidth - 15), scene.applyScale($b1317678cc8ff382$var$itemGlareHeight), scene.applyScale($b1317678cc8ff382$var$itemGlareRadius), $b1317678cc8ff382$var$itemGlareColor, $b1317678cc8ff382$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "center-top",
                    offsetY: scene.applyScale(7),
                    expand: false
                }).add(scene.rexUI.add.badgeLabel({
                    x: 0,
                    y: 0,
                    space: {
                        left: 0,
                        right: -5,
                        top: 0,
                        bottom: 0
                    },
                    main: scene.rexUI.add.label({
                        orientation: "x",
                        rtl: false,
                        icon: scene.createSquadMemberImage(scene, participant.playerImageKey).setScale(scene.applyScale(0.3)),
                        iconWidth: scene.applyScale(38),
                        iconHeight: scene.applyScale(38),
                        text: scene.add.bitmapText(0, 0, "cc_outline", participantName, scene.applyScale(20), 0).setAlpha(participant.inactive ? 0.4 : 1),
                        space: {
                            icon: scene.applyScale(10),
                            right: scene.applyScale(22)
                        }
                    }),
                    rightCenter: participant.hasBattlePass ? scene.add.image(0, 0, "battle_pass_icon") : undefined
                }), {
                    key: "item_name_label",
                    align: "left-top",
                    offsetX: scene.applyScale(21),
                    offsetY: scene.applyScale(24),
                    expand: false
                })// Attacking Status
                .add(scene.add.bitmapText(0, 0, "cc_outline", scene.getGameState() == ((0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame || (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound) && participant.isAttacking ? "Ready" : scene.getGameState() == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round && participant.isAttacking == true ? "Attacking" : "", scene.applyScale(20), 0).setTint(scene.getGameState() == ((0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound || (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame) ? "0XF5C957" : "0X2FE2A2"), {
                    key: `status_label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-185),
                    offsetY: scene.applyScale(32),
                    expand: false
                })// .add(
                //     scene.rexUI.add.label({
                //         orientation: 'x',
                //         rtl: false,
                //         text: scene.add.bitmapText(0, 0, 'cc_outline', "Atacking...", scene.applyScale(20), 0).setTint(0X2FE2A2),
                //     }),
                //     {
                //         key: 'status_label',
                //         align: 'left-top',
                //         offsetX: scene.applyScale(170),
                //         offsetY: scene.applyScale(24),
                //         expand: false
                //     }
                // )
                // Damage per round
                .add(scene.add.bitmapText(0, 0, "cc_outline", participant.damage.toLocaleString("en-us") + " dmg per turn", scene.applyScale(18), 0), {
                    key: `damage_label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-21),
                    offsetY: scene.applyScale(32),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    applyScale(length) {
        return length * this._scale;
    }
    getGameState() {
        return this._battleData.getGameState();
    }
    updateBattlePane(battleData) {
        this._battleData = battleData;
        // use gamestate to update correctly
        this._hpProgressBar.setProgressBarText(this._battleData.gameState == 0 ? "Currently Unknown..." : this._battleData.bossRemainingHP.toLocaleString("en-us") + " of " + this._battleData.bossMaxHP.toLocaleString("en-us"));
        // Update Participant Number
        this._participantsText.setText(this.getParticipantsText(this._battleData));
        // Updated HP Progress bar based on gamestate
        this.updateHPProgressBar(this._battleData);
        // Set State Image
        this._stateImage.setTexture(this.getBossFightGameStatusImage(this._battleData.gameState));
        // Update Boss Rarity Image
        this._bossFightImage.setTexture((0, $2e76b527e9362cab$export$706bad4d7728db29)[this._battleData.rarity]);
    }
    updateParticipantsList(battleData) {
        this._battleData = battleData;
        this._participantTable.setItems();
        // Sort Participants List by active or not
        this._participantTable.setItems(this._battleData.participants);
        // Update Participant Number
        this._participantsText.setText(this.getParticipantsText(this._battleData));
    }
    setPlayerAttacking(player) {
        this._participantTable.items.forEach((item)=>{
            if (player.playerId === item.playerId) {
                item.isAttacking = true;
                this._participantTable.refresh();
                return;
            }
        });
        // Update Participant Number
        this._participantsText.setText(player.attackingCount + " participants are fighting...");
    }
    getParticipantsText(battleData) {
        switch(battleData.gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                return battleData.participantCount + " participants have joined...";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
                return battleData.activeParticipants + " participants fought";
            default:
                var length = battleData.gameState == 0 ? battleData.activeParticipants : battleData.attackingCount;
                return length + " participants are fighting...";
        }
    }
    getBossFightGameStatusImage(gameState) {
        return gameState == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame ? "bossfight_status_not_started" : "bossfight_status_in_progress";
    }
    updateHPProgressBar(battleData) {
        if (battleData.gameState == (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame) {
            this._hpProgressBar.updateMaxValue(this, battleData.bossMaxHP);
            this._hpProgressBar.setProgressBarText("Currently Unknown...");
        } else {
            this._hpProgressBar.setProgress(this, battleData.bossRemainingHP);
            this._hpProgressBar.setProgressBarText(this._battleData.bossRemainingHP.toLocaleString("en-us") + " of " + this._battleData.bossMaxHP.toLocaleString("en-us"));
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("bossFightBattlePane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $b1317678cc8ff382$export$2e2bcd8739ae039(this.scene, x, y));
});











// Pane Details
const $034f94c8f7241220$var$paneHeight = 290;
const $034f94c8f7241220$var$paneWidth = 259;
const $034f94c8f7241220$var$paneRadius = 16;
const $034f94c8f7241220$var$paneColor = 0x1c1c2c;
const $034f94c8f7241220$var$paneAlpha = 1;
const $034f94c8f7241220$var$bossFightRarityColorMapper = {
    Common: 0x38384e,
    Rare: 0x039be5,
    Epic: 0xb803e5,
    Legendary: 0xffa000
};
class $034f94c8f7241220$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $034f94c8f7241220$var$paneWidth,
            height: paneScale * $034f94c8f7241220$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._battleData = data;
        this._player = data.player;
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Background
        this._background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($034f94c8f7241220$var$paneWidth), scene.applyScale($034f94c8f7241220$var$paneHeight), scene.applyScale($034f94c8f7241220$var$paneRadius), $034f94c8f7241220$var$paneColor, $034f94c8f7241220$var$paneAlpha);
        this.add(this._background, {
            key: "background",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Info Panel
        this._battleInfoPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($034f94c8f7241220$var$paneWidth),
            height: scene.applyScale($034f94c8f7241220$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Attacking Status
        this._title = scene.add.bitmapText(0, 0, "cc_outline", this.getTitle(this._battleData.gameState), scene.applyScale(20), 0);
        this._battleInfoPanel.add(this._title, {
            key: `details-title`,
            align: "left-top",
            offsetX: scene.applyScale(27),
            offsetY: scene.applyScale(29),
            expand: false
        });
        // Timer Progress Bar
        this._countDownProgressBar = new (0, $3a9bea67e0e561eb$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, (0, $f12f0c85b935f07d$export$43a43cf967792f11)());
        // Implements Countdown
        this.startCountDownUI();
        this._battleInfoPanel.add(this._countDownProgressBar, {
            key: "progress_bar",
            align: "left-top",
            offsetX: this.applyScale(27),
            offsetY: this.applyScale(66),
            expand: false
        });
        // Game Text
        this._gameText = scene.add.bitmapText(0, 0, "cc_outline", this.getGameText(this._battleData), scene.applyScale(17), 0);
        //this.setRarityWordColor(this._battleData)
        this._battleInfoPanel.add(this._gameText, {
            key: `game-text`,
            align: "left-top",
            offsetX: scene.applyScale(27),
            offsetY: scene.applyScale(121),
            expand: false
        });
        this._readyUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_ready_up_button", false).setScale(this._scale);
        this._readyUpButton.setDisabledTexture("bossfight_you_are_ready_button");
        this.setButtonStateAndVisibility(this._battleData);
        this._readyUpButton.onClick().subscribe((pointer)=>{
            this._readyUpButton.setDisabled(true);
            (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().playerReady();
        });
        this._battleInfoPanel.add(scene.add.existing(this._readyUpButton), {
            key: "ready-up-button",
            align: "left-bottom",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(32),
            expand: false
        });
        this.add(this._battleInfoPanel, {
            key: "info-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    updateDetailPane(battleData) {
        this._battleData = battleData;
        // Update Countdown UI
        this.startCountDownUI();
        // Update Title
        this._title.setText(this.getTitle(this._battleData.gameState));
        // Set word tint if correct gamestate
        //this.setRarityWordColor(this._battleData)
        this._gameText.setText(this.getGameText(this._battleData));
        this.setButtonStateAndVisibility(battleData);
    }
    setRarityWordColor(battleData) {
        switch(battleData.gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                this._gameText.setWordTint(battleData.rarity, 1, false, $034f94c8f7241220$var$bossFightRarityColorMapper[this._battleData.rarity]);
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                console.log("set Character Tint");
                this._gameText.setCharacterTint(0, -1);
                break;
        }
    }
    setButtonStateAndVisibility(battleData) {
        var isPlayerReady = (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().isPlayerReady((0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress());
        switch(battleData.gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound:
                this._readyUpButton.setVisible(true);
                this._readyUpButton.setTexture("bossfight_ready_up_button");
                this._readyUpButton.setDisabledTexture("bossfight_you_are_ready_button");
                this._readyUpButton.setDisabled(isPlayerReady);
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
                if (!isPlayerReady) {
                    this._readyUpButton.setDisabledTexture("bossfight_sit_out_button");
                    this._readyUpButton.setDisabled(true);
                }
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                this._readyUpButton.setTexture("bossfight_ready_up_button");
                this._readyUpButton.setDisabledTexture("bossfight_you_are_ready_button");
                this._readyUpButton.setDisabled(false);
                this._readyUpButton.setVisible(false);
                break;
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                this._readyUpButton.setVisible(false);
                break;
        }
    }
    getTitle(gameState) {
        switch(gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                return "Launches in...";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound:
                return "Time left to ready up:";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
                return "Time left:";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
                return "Time left:";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
                return "Time left:";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                break;
        }
    }
    getGameText(battleData) {
        switch(battleData.gameState){
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                return "A " + battleData.rarity + " pack of mutant\nvermin have appeared.\n\nYou must team up with\nother Wolf packs to\novercome these\nsavage beasts...";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound:
                return "Round " + battleData.attempt + " is coming!";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
                return "Round " + battleData.attempt + " is underway!";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
                return "Boss Fight has completed.\nWe are processing the results";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
                return "Boss Fight results displayed.";
            case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                break;
        }
    }
    startCountDownUI() {
        var countdown = (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().isFightActive() == true ? (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().getCountDown() : (0, $f12f0c85b935f07d$export$43a43cf967792f11)();
        // Implements Countdown
        var remainingSeconds = countdown;
        // Resets Countdown Bar Values
        this._countDownProgressBar.roundTimerReset(this, remainingSeconds);
        clearInterval(this._intervalTimer);
        this._intervalTimer = setInterval(()=>{
            //var _timeRemainingInterval = setInterval(() => {
            try {
                if (remainingSeconds <= 0) return clearInterval(this._intervalTimer);
                remainingSeconds--;
                this._countDownProgressBar.updateDisplay(this, remainingSeconds);
            } catch (error) {
                return clearInterval(this._intervalTimer);
            }
        }, 1000);
    }
    stopTimer() {
        clearInterval(this._intervalTimer);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("bossFightDetailPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $034f94c8f7241220$export$2e2bcd8739ae039(this.scene, x, y));
});





const $ede1ae94c2b287ca$var$width = 1512;
const $ede1ae94c2b287ca$var$height = 982;
class $ede1ae94c2b287ca$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BossFightScene"
        });
    }
    preload() {
        this._server = (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance();
        this._battleData = this._server.getRoomMetaData();
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$ae4cf7f8491f730f));
    }
    create() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($ede1ae94c2b287ca$var$width, $ede1ae94c2b287ca$var$height);
            // Checks if Boss Fight Server is Alive
            if (this._server.isServerAlive()) {
                // Gathers room data from server before connecting
                switch(this._battleData.gameState){
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreGame:
                        // Game Starts in less than 30 minutes
                        //if (getNextBossFightCountdown() < 100000) {
                        if ((0, $f12f0c85b935f07d$export$43a43cf967792f11)() < 600) // Allow Players to Join the game
                        yield this.joinGame();
                        else {
                            // Display Scene to Notify Players to check back later
                            this.scene.stop();
                            this.scene.start("BossFightLobbyClosedScene");
                        }
                        break;
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).PreRound:
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Round:
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).ProcessResults:
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).DisplayResults:
                        yield this.joinGame();
                        break;
                    case (0, $a589f8dc1045cfaf$export$eb5ccdbd077479c).Finished:
                        break;
                }
                this.createComponent();
            } else // show UI to notify users game server is done
            this.scene.start("BossFightServerUnavailableScene");
        });
    }
    enableBossFightListeners() {
        this._server.onGameStateChanged(this.handleGameStateChanged, this);
        this._server.onParticipantsUpdated(this.handleParticipantsUpdated, this);
        this._server.onParticipantAttacking(this.handleParticipantAttacking, this);
    }
    onTabbedOut() {
        this._server.disableBossFightListeners();
        this._bossFightDetailPane.stopTimer();
    }
    onTabbedIn() {
        this.enableBossFightListeners();
        this._bossFightDetailPane.updateDetailPane(this._server.getBattleData());
        this._bossFightBattlePane.updateBattlePane(this._server.getBattleData());
        this.handleParticipantsUpdated();
    }
    joinGame() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this._server.join();
            this.enableBossFightListeners();
        });
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $ede1ae94c2b287ca$var$width * this._scale,
            height: $ede1ae94c2b287ca$var$height * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Battle Pane
        this._bossFightBattlePane = new (0, $b1317678cc8ff382$export$2e2bcd8739ae039)(this, 0, 0, this._battleData, this._scale);
        sizer.add(this._bossFightBattlePane, {
            key: "bossfight-pane",
            align: "left-top",
            offsetX: this.applyScale(336),
            offsetY: this.applyScale(77),
            expand: false
        });
        // Detail Pane
        this._bossFightDetailPane = new (0, $034f94c8f7241220$export$2e2bcd8739ae039)(this, 0, 0, this._battleData, this._scale);
        sizer.add(this._bossFightDetailPane, {
            key: "bossfight-detail-pane",
            align: "left-top",
            offsetX: this.applyScale(906),
            offsetY: this.applyScale(77),
            expand: false
        });
        // Add Back Button
        this._backButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_back_button", true, 1.05).setScale(this._scale);
        this._backButton.onClick().subscribe((pointer)=>{
            this.onBackButtonPressed();
        });
        this.add.existing(this._backButton);
        sizer.add(this._backButton, {
            key: "back-button",
            align: "left-top",
            offsetX: this.applyScale(24),
            offsetY: this.applyScale(896),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {}
    onBackButtonPressed() {
        this._server.disableBossFightListeners();
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop();
    }
    createSquadMemberImage(scene, imageKey) {
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 3;
        smImageData.destroy();
        var squadMemberImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        squadMemberImage.displayHeight = scene.applyScale(48);
        squadMemberImage.scaleX = squadMemberImage.scaleY;
        return squadMemberImage;
    }
    // Boss Fight Listeners
    handleGameStateChanged() {
        this._bossFightDetailPane.updateDetailPane(this._server.getBattleData());
        this._bossFightBattlePane.updateBattlePane(this._server.getBattleData());
        this._bossFightBattlePane.updateParticipantsList(this._server.getBattleData());
        if (this._server.isDisplayResults()) {
            this._server.disableBossFightListeners();
            if (this._server.isBossDefeated()) {
                this.scene.pause("BossFightScene");
                this.scene.launch("BossFightVictoryScene", {
                    payout: this._server.getParticipantPayout()
                });
            } else {
                this.scene.pause("BossFightScene");
                this.scene.launch("BossFightDefeatScene", {
                    payout: this._server.getParticipantPayout()
                });
            }
        }
    }
    handleParticipantsUpdated() {
        this._battleData = this._server.getBattleData();
        var texturesToLoad = this.getTextureLoadingList();
        if (texturesToLoad.length > 0) {
            this.load.once("complete", ()=>{
                this._bossFightBattlePane.updateParticipantsList(this._server.getBattleData());
            });
            texturesToLoad.forEach((texture)=>{
                if (!this.textures.exists(texture.key)) this.load.image(texture.key, texture.url);
            });
            this.load.start();
        } else this._bossFightBattlePane.updateParticipantsList(this._server.getBattleData());
    }
    getTextureLoadingList() {
        var _a;
        var texturesToLoad = [];
        (_a = this._battleData.participants) === null || _a === void 0 || _a.forEach((participant)=>{
            if (!this.textures.exists(participant.playerImageKey)) texturesToLoad.push({
                key: participant.playerImageKey,
                url: participant.playerImageUrl
            });
        });
        return texturesToLoad;
    }
    handleParticipantAttacking(change) {
        this._bossFightBattlePane.setPlayerAttacking(change);
    }
    getGameState() {
        return this._server.getBattleData().gameState;
    }
    killTimer() {
        this._bossFightDetailPane.killTimer();
    //this.scene.remove(this._bossFightDetailPane)
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$ae4cf7f8491f730f)));
        // Unload Player PFPs
        if (this._battleData.participants) {
            const playerImageKeys = this._battleData.participants.map((participant)=>participant.playerImageKey);
            (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, playerImageKeys);
        }
    }
}








const $b96f5697b2b62217$var$modalWidth = 494;
const $b96f5697b2b62217$var$modalHeight = 469;
const $b96f5697b2b62217$var$modalRadius = 50;
const $b96f5697b2b62217$var$modalColor = 0x350926;
const $b96f5697b2b62217$var$modalAlpha = 1;
const $b96f5697b2b62217$var$modalBorderColor = 0x3d4361;
const $b96f5697b2b62217$var$modalBorderWidth = 1;
const $b96f5697b2b62217$var$goldProgressBarColor = 0xdea827;
const $b96f5697b2b62217$var$blueProgressBarColor = 0x00a6d3;
const $b96f5697b2b62217$var$progressBarAlpha = 1;
const $b96f5697b2b62217$var$glareColor = 0xffffff;
const $b96f5697b2b62217$var$glareAlpha = 0.14;
const $b96f5697b2b62217$var$glareRadius = 3;
const $b96f5697b2b62217$var$glareHeight = 6;
const $b96f5697b2b62217$var$glareOffset = 10;
const $b96f5697b2b62217$var$xpBarOffset = 40;
const $b96f5697b2b62217$var$borderWidth = 1;
const $b96f5697b2b62217$var$borderColor = 0x383d57;
const $b96f5697b2b62217$var$borderAlpha = 1;
const $b96f5697b2b62217$var$backgroundColor = 0x201425;
const $b96f5697b2b62217$var$backgroundAlpha = 0.4;
const $b96f5697b2b62217$var$radius = 11;
const $b96f5697b2b62217$var$progressBarHeight = 43;
const $b96f5697b2b62217$var$progressBarWidth = 240;
const $b96f5697b2b62217$var$resources = {
    space_elixir: "space_elixir",
    neon_gold: "neon_gold",
    stardust: "stardust"
};
class $b96f5697b2b62217$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userData = data.userData;
    }
    constructor(){
        super({
            key: "UserLevelModalScene"
        });
    }
    preload() {}
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($b96f5697b2b62217$var$modalWidth, $b96f5697b2b62217$var$modalHeight + 60);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($b96f5697b2b62217$var$modalWidth), this.applyScale($b96f5697b2b62217$var$modalHeight), this.applyScale($b96f5697b2b62217$var$modalRadius), $b96f5697b2b62217$var$modalColor, $b96f5697b2b62217$var$modalAlpha);
        modalBg.setStrokeStyle($b96f5697b2b62217$var$modalBorderWidth, $b96f5697b2b62217$var$modalBorderColor, $b96f5697b2b62217$var$modalAlpha);
        const badges = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().userBadges;
        const levelBadgeImageKey = this.getBadgeImageKey(this._userData, badges);
        // Add Icons
        this.add.image(modalBg.getTopCenter().x, modalBg.getTopLeft().y, levelBadgeImageKey).setScale(this._scale);
        // Add sizer for content
        var sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($b96f5697b2b62217$var$modalWidth),
            height: this.applyScale($b96f5697b2b62217$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // User level progress bar
        const userLevelBar = new (0, $da58ee258d224181$export$2e2bcd8739ae039)(this, 0, 0, this._scale, this._userData, 1);
        userLevelBar.setIcon("level_icon");
        sizer.add(userLevelBar, {
            align: "center-top",
            offsetX: this.applyScale(-12),
            offsetY: this.applyScale(82),
            expand: false,
            key: "user_level_bar"
        });
        // 'Total XP Earned' label
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Total XP Earned", this.applyScale(18), 1), {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(164),
            expand: false,
            key: "xp_earned_label"
        });
        // XP Progress Bar
        const xpBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this._userData.xp,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $b96f5697b2b62217$var$borderWidth,
                color: $b96f5697b2b62217$var$borderColor,
                alpha: $b96f5697b2b62217$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $b96f5697b2b62217$var$progressBarWidth - $b96f5697b2b62217$var$xpBarOffset,
                height: $b96f5697b2b62217$var$progressBarHeight,
                radius: $b96f5697b2b62217$var$radius,
                color: $b96f5697b2b62217$var$goldProgressBarColor,
                alpha: $b96f5697b2b62217$var$progressBarAlpha,
                backgroundColor: $b96f5697b2b62217$var$backgroundColor,
                backgroundAlpha: $b96f5697b2b62217$var$backgroundAlpha,
                minValue: 0,
                maxValue: 1,
                progressValue: 0,
                glare: {
                    height: $b96f5697b2b62217$var$glareHeight,
                    width: $b96f5697b2b62217$var$progressBarWidth - $b96f5697b2b62217$var$xpBarOffset - $b96f5697b2b62217$var$glareOffset,
                    radius: $b96f5697b2b62217$var$glareRadius,
                    color: $b96f5697b2b62217$var$glareColor,
                    alpha: $b96f5697b2b62217$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(xpBar);
        xpBar.setProgressBarText("");
        sizer.add(xpBar, {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(194),
            expand: false,
            key: "xp_progress_bar"
        });
        // 'Total Battle Pass XP Earned' label
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Battle Pass XP", this.applyScale(18), 1), {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(284),
            expand: false,
            key: "bp_ xp_earned_label"
        });
        // XP Progress Bar
        const bpXPBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this._userData.battlepass_xp,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $b96f5697b2b62217$var$borderWidth,
                color: $b96f5697b2b62217$var$borderColor,
                alpha: $b96f5697b2b62217$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $b96f5697b2b62217$var$progressBarWidth - $b96f5697b2b62217$var$xpBarOffset,
                height: $b96f5697b2b62217$var$progressBarHeight,
                radius: $b96f5697b2b62217$var$radius,
                color: $b96f5697b2b62217$var$goldProgressBarColor,
                alpha: $b96f5697b2b62217$var$progressBarAlpha,
                backgroundColor: $b96f5697b2b62217$var$backgroundColor,
                backgroundAlpha: $b96f5697b2b62217$var$backgroundAlpha,
                minValue: 0,
                maxValue: 1,
                progressValue: 0,
                glare: {
                    height: $b96f5697b2b62217$var$glareHeight,
                    width: $b96f5697b2b62217$var$progressBarWidth - $b96f5697b2b62217$var$xpBarOffset - $b96f5697b2b62217$var$glareOffset,
                    radius: $b96f5697b2b62217$var$glareRadius,
                    color: $b96f5697b2b62217$var$glareColor,
                    alpha: $b96f5697b2b62217$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(bpXPBar);
        bpXPBar.setProgressBarText("");
        sizer.add(bpXPBar, {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(315),
            expand: false,
            key: "bp_xp_progress_bar"
        });
        sizer.layout();
        // Add Cancel Button
        const closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "modal_close_button", false).setScale(this._scale);
        closeButton.onClick().subscribe((pointer)=>{
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(closeButton);
        sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this.scene.stop();
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
        });
    }
    getBadgeImageKey(userData, userBadges) {
        var badge = userBadges.find((ub)=>{
            if (ub.maxLevel === null) return userData.level >= ub.minLevel;
            else return userData.level >= ub.minLevel && userData.level <= ub.maxLevel;
        });
        return badge.badgeImageKey;
    }
    applyScale(length) {
        return length * this._scale;
    }
}







const $b38845d04913730d$var$modalHeight = 527;
const $b38845d04913730d$var$modalWidth = 494;
const $b38845d04913730d$var$modalRadius = 50;
const $b38845d04913730d$var$modalColor = 0x350926;
const $b38845d04913730d$var$modalAlpha = 1;
const $b38845d04913730d$var$modalBorderColor = 0x3d4361;
const $b38845d04913730d$var$modalBorderWidth = 1;
class $b38845d04913730d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "HudBossFightAlertScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$e7e7859328cf2591));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($b38845d04913730d$var$modalWidth, $b38845d04913730d$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $b38845d04913730d$var$modalWidth * this._scale,
            height: $b38845d04913730d$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        const notificationBg = this.add.rexRoundRectangle(0, 0, this.applyScale($b38845d04913730d$var$modalWidth), this.applyScale($b38845d04913730d$var$modalHeight), this.applyScale($b38845d04913730d$var$modalRadius), $b38845d04913730d$var$modalColor, $b38845d04913730d$var$modalAlpha).setStrokeStyle($b38845d04913730d$var$modalBorderWidth, $b38845d04913730d$var$modalBorderColor, $b38845d04913730d$var$modalAlpha);
        sizer.add(notificationBg, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Image
        this._bossFightImage = this.add.image(0, 0, "bossfight_notification_image").setScale(this._scale);
        sizer.add(this._bossFightImage, {
            key: "bossfight_image",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Title
        this._bossFightTitle = this.add.image(0, 0, "bossfight_notification_title_text").setScale(this._scale);
        sizer.add(this._bossFightTitle, {
            key: "bossfight_title_image",
            align: "center-middle",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Text 1
        this._bossFightText1 = this.add.bitmapText(0, 0, "cc_outline", "The pack of Vermins\n have returned...", this.applyScale(22), 1);
        sizer.add(this._bossFightText1, {
            key: "bossfight-text-1",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(325),
            expand: false
        });
        // Text 2
        this._bossFightText2 = this.add.bitmapText(0, 0, "cc_outline", "Team up with your fellow\n Wolvez to take them down. You\n are our only hope...", this.applyScale(18), 1).setTint(0xbfaac6);
        sizer.add(this._bossFightText2, {
            key: "bossfight-text-2",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(390),
            expand: false
        });
        // Add Later Button
        this._laterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_notification_later_button", true, 1.05).setScale(this._scale);
        this._laterButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(this._laterButton);
        sizer.add(this._laterButton, {
            key: "later-button",
            align: "left-top",
            offsetX: this.applyScale(89),
            offsetY: this.applyScale(497),
            expand: false
        });
        // Add Later Button
        this._letsgoButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_notification_letsgo_button", true, 1.05).setScale(this._scale);
        this._letsgoButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.get("HomebaseScene").scene.stop();
            this.scene.get("HudScene").scene.stop();
            this.scene.start("BossFightScene");
        });
        this.add.existing(this._letsgoButton);
        sizer.add(this._letsgoButton, {
            key: "letsgo-button",
            align: "left-top",
            offsetX: this.applyScale(239),
            offsetY: this.applyScale(497),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$e7e7859328cf2591)));
    }
}






const $e25f9cca547c13c9$var$modalHeight = 527;
const $e25f9cca547c13c9$var$modalWidth = 494;
const $e25f9cca547c13c9$var$modalRadius = 50;
const $e25f9cca547c13c9$var$modalColor = 0x350926;
const $e25f9cca547c13c9$var$modalAlpha = 1;
const $e25f9cca547c13c9$var$modalBorderColor = 0x3d4361;
const $e25f9cca547c13c9$var$modalBorderWidth = 1;
class $e25f9cca547c13c9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "HudBossFightMissedAlertScene"
        });
    }
    preload() {
        this.load.image("bossfight_notification_image", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_notification_image);
        this.load.image("bossfight_notification_later_button", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_notification_later_button);
        this.load.image("bossfight_go_to_discord_button", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_go_to_discord_button);
        this.load.image("bossfight_battle_missed_image", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_battle_missed_image);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($e25f9cca547c13c9$var$modalWidth, $e25f9cca547c13c9$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $e25f9cca547c13c9$var$modalWidth * this._scale,
            height: $e25f9cca547c13c9$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($e25f9cca547c13c9$var$modalWidth), this.applyScale($e25f9cca547c13c9$var$modalHeight), this.applyScale($e25f9cca547c13c9$var$modalRadius), $e25f9cca547c13c9$var$modalColor, $e25f9cca547c13c9$var$modalAlpha).setStrokeStyle($e25f9cca547c13c9$var$modalBorderWidth, $e25f9cca547c13c9$var$modalBorderColor, $e25f9cca547c13c9$var$modalAlpha);
        sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Image
        this._bossFightImage = this.add.image(0, 0, "bossfight_notification_image").setScale(this._scale);
        sizer.add(this._bossFightImage, {
            key: "bossfight_image",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Title
        this._bossFightTitle = this.add.image(0, 0, "bossfight_battle_missed_image").setScale(this._scale);
        sizer.add(this._bossFightTitle, {
            key: "bossfight_title_image",
            align: "center-middle",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Text 1
        this._bossFightText1 = this.add.bitmapText(0, 0, "cc_outline", "To get alerted in\n Discord, react to the\n message in the\n following channel...", this.applyScale(22), 1);
        sizer.add(this._bossFightText1, {
            key: "bossfight-text-1",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(325),
            expand: false
        });
        // Add Later Button
        this._laterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_notification_later_button", true, 1.05).setScale(this._scale);
        this._laterButton.onClick().subscribe((pointer)=>{
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(this._laterButton);
        sizer.add(this._laterButton, {
            key: "later-button",
            align: "left-top",
            offsetX: this.applyScale(61),
            offsetY: this.applyScale(497),
            expand: false
        });
        // Add Later Button
        this._discordButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_go_to_discord_button", true, 1.05).setScale(this._scale);
        this._discordButton.onClick().subscribe((pointer)=>{
        // This somehow needs to launch discord
        });
        this.add.existing(this._discordButton);
        sizer.add(this._discordButton, {
            key: "discord-button",
            align: "left-top",
            offsetX: this.applyScale(211),
            offsetY: this.applyScale(497),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}








const $1592a4a96a70ca50$var$modalHeight = 701;
const $1592a4a96a70ca50$var$modalWidth = 387;
class $1592a4a96a70ca50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._payout = data.payout;
    }
    constructor(){
        super({
            key: "BossFightVictoryScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$c209f6ef1d95d3b4));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($1592a4a96a70ca50$var$modalWidth, $1592a4a96a70ca50$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $1592a4a96a70ca50$var$modalWidth * this._scale,
            height: $1592a4a96a70ca50$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Victory Badge
        this._victoryBadge = this.add.image(0, 0, "bossfight_victory_badge").setScale(this._scale);
        sizer.add(this._victoryBadge, {
            key: "bossfight_victory_badge",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Victory Title
        this._victoryTitle = this.add.image(0, 0, "bossfight_victory_title").setScale(this._scale);
        sizer.add(this._victoryTitle, {
            key: "bossfight_victory_title",
            align: "left-top",
            offsetX: this.applyScale(36),
            offsetY: this.applyScale(130),
            expand: false
        });
        // Text
        this._text = this.add.bitmapText(0, 0, "cc_outline", "You got:", this.applyScale(28), 1);
        sizer.add(this._text, {
            key: "bossfight-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(281),
            expand: false
        });
        // Reward Labels
        this._spaceElixirBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", this._payout.spaceElixir.toLocaleString("en-us"));
        sizer.add(this._spaceElixirBar, {
            key: "bossfight-se-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(326),
            expand: false
        });
        this._neonGoldBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", this._payout.neonGold.toLocaleString("en-us"));
        sizer.add(this._neonGoldBar, {
            key: "bossfight-ng-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(387),
            expand: false
        });
        this._starDustBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", this._payout.starDust.toLocaleString("en-us"));
        sizer.add(this._starDustBar, {
            key: "bossfight-sd-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(448),
            expand: false
        });
        this._xpBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, undefined, `${this._payout.xp} xp`);
        sizer.add(this._xpBar, {
            key: "bossfight-xp-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(509),
            expand: false
        });
        // Add Return Home Button
        this._returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_victory_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHomeButton.onClick().subscribe((pointer)=>{
            this.destroy();
        });
        this.add.existing(this._returnHomeButton);
        sizer.add(this._returnHomeButton, {
            key: "return-home-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(680),
            expand: false
        });
        // Add View Results Button
        this._viewResultsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battleroyale_view_results_button", true, 1.05).setScale(this._scale);
        this._viewResultsButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.launch("BossFightResultsScene");
            this.scene.get("BossFightScene").unloadAssets();
            this.scene.stop("BossFightScene");
            this.scene.stop();
        });
        this.add.existing(this._viewResultsButton);
        sizer.add(this._viewResultsButton, {
            key: "view-results-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(600),
            expand: false
        });
        // // Add Tweet This Button
        // this._tweetThisButton = new Button(
        // 	this,
        // 	0,
        // 	0,
        // 	'bossfight_tweet_this_button',
        // 	true,
        // 	1.05
        // ).setScale(this._scale)
        // this._tweetThisButton.onClick().subscribe(pointer => {
        // 	console.log("Tweet This Pressed")
        // })
        // this._tweetThisButton.setDisabled(true)
        // this._tweetThisButton.setVisible(false)
        // this.add.existing(this._tweetThisButton)
        // sizer.add(this._tweetThisButton, {
        // 	key: 'tweet-this-button',
        // 	align: 'left-bottom',
        // 	offsetX: this.applyScale(210),
        // 	offsetY: 0,
        // 	expand: false
        // })
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.get("BossFightScene").unloadAssets();
        this.scene.stop("BossFightScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$c209f6ef1d95d3b4)));
    }
}








const $ea962655dc0d0419$var$modalHeight = 701;
const $ea962655dc0d0419$var$modalWidth = 314;
class $ea962655dc0d0419$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._payout = data.payout;
    }
    constructor(){
        super({
            key: "BossFightDefeatScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$8e35485e4443b4ab));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($ea962655dc0d0419$var$modalWidth, $ea962655dc0d0419$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $ea962655dc0d0419$var$modalWidth * this._scale,
            height: $ea962655dc0d0419$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Defeat Badge
        this._defeatBadge = this.add.image(0, 0, "bossfight_defeat_badge").setScale(this._scale);
        sizer.add(this._defeatBadge, {
            key: "bossfight_defeat_badge",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Defeat Title
        this._defeatTitle = this.add.image(0, 0, "bossfight_defeat_title").setScale(this._scale);
        sizer.add(this._defeatTitle, {
            key: "bossfight_defeat_title",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(145),
            expand: false
        });
        // Text
        this._text = this.add.bitmapText(0, 0, "cc_outline", "You were not\nsuccessful this time,\ndear wolf, but there\nwill be many more\nopportunities ahead...", this.applyScale(24), 1);
        sizer.add(this._text, {
            key: "bossfight-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(240),
            expand: false
        });
        // Text
        this._resourceText = this.add.bitmapText(0, 0, "cc_outline", "You got:", this.applyScale(24), 1);
        sizer.add(this._resourceText, {
            key: "payout-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(400),
            expand: false
        });
        // Reward Labels
        this._spaceElixirBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", this._payout.spaceElixir.toLocaleString("en-us"));
        sizer.add(this._spaceElixirBar, {
            key: "bossfight-se-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(440),
            expand: false
        });
        this._neonGoldBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", this._payout.neonGold.toLocaleString("en-us"));
        sizer.add(this._neonGoldBar, {
            key: "bossfight-ng-bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(500),
            expand: false
        });
        // Add Return Home Button
        this._returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_defeat_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHomeButton.onClick().subscribe((pointer)=>{
            this.destroy();
        });
        this.add.existing(this._returnHomeButton);
        sizer.add(this._returnHomeButton, {
            key: "return-home-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(650),
            expand: false
        });
        // Add View Results Button
        this._viewResultsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battleroyale_view_results_button", true, 1.05).setScale(this._scale);
        this._viewResultsButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.get("BossFightScene").unloadAssets();
            this.scene.launch("BossFightResultsScene");
            this.scene.stop("BossFightScene");
            this.scene.stop();
        });
        this.add.existing(this._viewResultsButton);
        sizer.add(this._viewResultsButton, {
            key: "view-results-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(570),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.unloadAssets();
        this.scene.get("BossFightScene").unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop("BossFightScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$8e35485e4443b4ab)));
    }
}







const $feb88313aba51916$var$modalHeight = 386;
const $feb88313aba51916$var$modalWidth = 494;
const $feb88313aba51916$var$modalRadius = 50;
const $feb88313aba51916$var$modalColor = 0x350926;
const $feb88313aba51916$var$modalAlpha = 1;
const $feb88313aba51916$var$modalBorderColor = 0x3d4361;
const $feb88313aba51916$var$modalBorderWidth = 1;
const $feb88313aba51916$var$componentRadius = 16;
const $feb88313aba51916$var$subtitleTint = 0x75758b;
const $feb88313aba51916$var$messageColor = 0xffffff;
const $feb88313aba51916$var$submitButtonImage = "squad_confirm_button";
const $feb88313aba51916$var$itemTypes = {
    resource_box: "resource_box"
};
class $feb88313aba51916$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._purchaseResult = data.purchaseResult;
        this._item = data.item;
        this._itemType = data.itemType || "shop_item"; // machine or shop_item
    }
    constructor(){
        super({
            key: "ShopRewardScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($feb88313aba51916$var$modalWidth, $feb88313aba51916$var$modalHeight + 50); // 50 accounts for button extending beyond modal box
    }
    preload() {}
    create() {
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($feb88313aba51916$var$modalWidth), this.applyScale($feb88313aba51916$var$modalHeight), this.applyScale($feb88313aba51916$var$modalRadius), $feb88313aba51916$var$modalColor, $feb88313aba51916$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($feb88313aba51916$var$modalBorderWidth), $feb88313aba51916$var$modalBorderColor, $feb88313aba51916$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer(this.sys.canvas.width / 2, modalBg.getTopLeft().y + this.applyScale(177), {
            width: this.applyScale(260),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), this.applyScale(28), 1).setMaxWidth(this.applyScale(260)), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "title_text"
        });
        if (this._purchaseResult.success) {
            const seReward = this._purchaseResult.reward_info.find((ri)=>ri.currency_id === 2);
            const ngReward = this._purchaseResult.reward_info.find((ri)=>ri.currency_id === 1);
            // Add Reward Labels
            const seBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", seReward.value.toLocaleString("en-us"));
            const ngBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", ngReward.value.toLocaleString("en-us"));
            sizer.add(this.add.existing(seBar), {
                padding: {
                    left: 0,
                    right: 0,
                    top: this.applyScale(27),
                    bottom: 0
                },
                key: "se_bar"
            });
            sizer.add(this.add.existing(ngBar), {
                padding: {
                    left: 0,
                    right: 0,
                    top: this.applyScale(18),
                    bottom: 0
                },
                key: "ng_bar"
            });
        }
        sizer.layout();
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, $feb88313aba51916$var$submitButtonImage, false).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.scene.resume("ShopModalScene");
                this.scene.stop();
            });
        });
        this.add.existing(returnHomeButton);
    }
    getTitleText() {
        if (this._purchaseResult.success) return "You gained the following resources:";
        else return `Purchase Failed.  ${this._purchaseResult.msg}.`;
    }
    applyScale(length) {
        return length * this._scale;
    }
}



var $7WQrb = parcelRequire("7WQrb");






// Pane Details
const $559bcda9b38655cb$var$paneHeight = 972;
const $559bcda9b38655cb$var$paneWidth = 540;
const $559bcda9b38655cb$var$paneRadius = 16;
const $559bcda9b38655cb$var$paneColor = 0x1c1c2c;
const $559bcda9b38655cb$var$paneAlpha = 1;
const $559bcda9b38655cb$var$itemWidth = 500, $559bcda9b38655cb$var$itemHeight = 73, $559bcda9b38655cb$var$itemRadius = 13, $559bcda9b38655cb$var$itemColor = 0x262637, $559bcda9b38655cb$var$itemAlpha = 1;
const $559bcda9b38655cb$var$messageItemHeight = 90;
const $559bcda9b38655cb$var$itemGlareHeight = 7, $559bcda9b38655cb$var$itemGlareRadius = 4, $559bcda9b38655cb$var$itemGlareColor = 0xffffff, $559bcda9b38655cb$var$itemGlareAlpha = 0.08;
class $559bcda9b38655cb$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $559bcda9b38655cb$var$paneWidth,
            height: paneScale * $559bcda9b38655cb$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this.x = x;
        this.y = y;
        this._scale = paneScale;
        this._battleData = data;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($559bcda9b38655cb$var$paneWidth), scene.applyScale($559bcda9b38655cb$var$paneHeight), scene.applyScale($559bcda9b38655cb$var$paneRadius), $559bcda9b38655cb$var$paneColor, $559bcda9b38655cb$var$paneAlpha);
        this.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Battle Panel
        this._battlePanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($559bcda9b38655cb$var$paneWidth),
            height: scene.applyScale(120),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        const battleRoyaleBadge = this.scene.add.image(0, 0, "battleroyale_badge").setScale(this._scale);
        this._battlePanel.add(battleRoyaleBadge, {
            key: "battleroyale_badge",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(-55),
            expand: false
        });
        // Add Title Text
        const battleRoyaleTitle = this.scene.add.image(0, 0, "battleroyale_title_text").setScale(this._scale);
        this._battlePanel.add(battleRoyaleTitle, {
            key: "battleroyale_title_text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(55),
            expand: false
        });
        // Top Divider
        const bossFightDividerTop = this.scene.add.image(0, 0, "battleroyale_divider").setScale(this._scale);
        this._battlePanel.add(bossFightDividerTop, {
            key: "br-divider-top",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(165),
            expand: false
        });
        // Add Boss Image
        this._battleRoyaleImage = this.scene.add.image(0, 0, "battleroyale_game_bg").setScale(this._scale);
        this._battlePanel.add(this._battleRoyaleImage, {
            key: "bossfight_boss",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(166),
            expand: false
        });
        // Bottom Divider
        const bossFightDividerBottom = this.scene.add.image(0, 0, "battleroyale_divider").setScale(this._scale);
        this._battlePanel.add(bossFightDividerBottom, {
            key: "bf-divider-bottom",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(166 + this._battleRoyaleImage.height + 1),
            expand: false
        });
        // Participants Text
        var participantCount = this._battleData.participants == undefined ? 0 : this._battleData.participants.length;
        this._participantsText = this.scene.add.bitmapText(0, 0, "cc_outline", participantCount.toLocaleString("en-us") + " participants have joined...", this.applyScale(18), 0);
        this._battlePanel.add(this._participantsText, {
            key: "participants-text",
            align: "left-top",
            offsetX: this.applyScale(30),
            offsetY: this.applyScale(166 + this._battleRoyaleImage.height + 1 + 20),
            expand: false
        });
        // Determines what to display in the Pane Table based on gamestate
        if (this._battleData.hasGameStarted) {
            this._participantTable = this.createGameplayTable(this.scene, this._battleData.messages, x, y, this.scale).layout();
            this._battlePanel.add(this._participantTable, {
                key: "participants-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(166 + this._battleRoyaleImage.height + 1 + 80),
                expand: false
            });
        } else {
            this._participantTable = this.createPlayerTable(this.scene, this._battleData.participants, x, y, this.scale).layout();
            this._battlePanel.add(this._participantTable, {
                key: "participants-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(166 + this._battleRoyaleImage.height + 1 + 80),
                expand: false
            });
        }
        this.add(this._battlePanel, {
            key: "battle-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    createPlayerTable(scene, data, x, y, scale) {
        var tableHeight = $559bcda9b38655cb$var$paneHeight - (166 + this._battleRoyaleImage.height + 1 + 100);
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($559bcda9b38655cb$var$paneWidth),
            height: scene.applyScale(tableHeight),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($559bcda9b38655cb$var$itemWidth),
                cellHeight: this.applyScale($559bcda9b38655cb$var$itemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, participant = cell.item;
                const participantName = participant.playerName;
                const participantLevel = participant.playerLevel;
                const participantPfp = participant.playerImageKey;
                const rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(40)
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($559bcda9b38655cb$var$itemWidth),
                    space: {
                        left: scene.applyScale(20),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($559bcda9b38655cb$var$itemWidth), scene.applyScale($559bcda9b38655cb$var$itemHeight), scene.applyScale($559bcda9b38655cb$var$itemRadius), $559bcda9b38655cb$var$itemColor, $559bcda9b38655cb$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($559bcda9b38655cb$var$itemWidth - 15), scene.applyScale($559bcda9b38655cb$var$itemGlareHeight), scene.applyScale($559bcda9b38655cb$var$itemGlareRadius), $559bcda9b38655cb$var$itemGlareColor, $559bcda9b38655cb$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "center-top",
                    offsetY: scene.applyScale(7),
                    expand: false
                }).add(scene.rexUI.add.badgeLabel({
                    x: 0,
                    y: 0,
                    space: {
                        left: 0,
                        right: -5,
                        top: 0,
                        bottom: 0
                    },
                    main: scene.rexUI.add.label({
                        orientation: "x",
                        rtl: false,
                        icon: scene.createSquadMemberImage(scene, participantPfp).setScale(scene.applyScale(0.3)),
                        iconWidth: scene.applyScale(38),
                        iconHeight: scene.applyScale(38),
                        text: scene.add.bitmapText(0, 0, "cc_outline", participantName, scene.applyScale(20), 0),
                        space: {
                            icon: scene.applyScale(10),
                            right: scene.applyScale(22)
                        }
                    }),
                    rightCenter: participant.hasBattlePass ? scene.add.image(0, 0, "battle_pass_icon") : undefined
                }).layout(), {
                    key: "item_name_label",
                    align: "left-top",
                    offsetX: scene.applyScale(21),
                    offsetY: scene.applyScale(24),
                    expand: false
                })// Level
                .add(scene.add.bitmapText(0, 0, "cc_outline", "Level " + participantLevel, scene.applyScale(18), 0), {
                    key: `level_label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-21),
                    offsetY: scene.applyScale(32),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    createGameplayTable(scene, data, x, y, scale) {
        var tableHeight = $559bcda9b38655cb$var$paneHeight - (166 + this._battleRoyaleImage.height + 1 + 100);
        var table = scene.rexUI.add.gridTable({
            width: scene.applyScale($559bcda9b38655cb$var$paneWidth),
            height: scene.applyScale(tableHeight),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: scene.applyScale($559bcda9b38655cb$var$itemWidth),
                cellHeight: scene.applyScale($559bcda9b38655cb$var$messageItemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, brmessage = cell.item;
                // Stores BR Message info
                const message = brmessage.message;
                const player1 = brmessage.player1;
                const player1Pfp = brmessage.player1Pfp;
                const player2 = brmessage.player2;
                const rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(40)
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($559bcda9b38655cb$var$itemWidth),
                    space: {
                        left: scene.applyScale(20),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($559bcda9b38655cb$var$itemWidth), scene.applyScale($559bcda9b38655cb$var$messageItemHeight), scene.applyScale($559bcda9b38655cb$var$itemRadius), $559bcda9b38655cb$var$itemColor, $559bcda9b38655cb$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(470), scene.applyScale(4.6), scene.applyScale($559bcda9b38655cb$var$itemGlareRadius), $559bcda9b38655cb$var$itemGlareColor, $559bcda9b38655cb$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "left-top",
                    offsetX: scene.applyScale(15),
                    offsetY: scene.applyScale(7.7),
                    expand: false
                }).add(scene.rexUI.add.label({
                    orientation: "x",
                    rtl: false,
                    icon: scene.createSquadMemberImage(scene, player1Pfp).setScale(scene.applyScale(0.3)),
                    iconWidth: scene.applyScale(38),
                    iconHeight: scene.applyScale(38),
                    //icon: scene.add.rexCircleMaskImage(0, 0, , '', rectConfig).setScale(scene.applyScale(0.3)),
                    text: scene.add.bitmapText(0, 0, "cc_outline", message, scene.applyScale(15), 0).setMaxWidth(scene.applyScale(418)).setCharacterTint(//message.indexOf(player1),
                    scene.getTintIndex(player1, message, false), player1.length, true, scene.getTintColor(player1)).setCharacterTint(//message.indexOf(player2),
                    scene.getTintIndex(player2, message, false), player2.length, true, scene.getTintColor(player2)).setCharacterTint(//message.indexOf(player2, message.indexOf(player2) + player2.length),
                    scene.getTintIndex(player2, message, true), player2.length, true, scene.getTintColor(player2)),
                    space: {
                        icon: scene.applyScale(10),
                        right: scene.applyScale(10)
                    }
                }), {
                    key: "item_name_label",
                    align: "left-top",
                    offsetX: scene.applyScale(21),
                    offsetY: scene.applyScale(24),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        table.scrollToBottom();
        return table;
    }
    applyScale(length) {
        return length * this._scale;
    }
    switchDisplayTable(battleData) {
        // Change from Participants List to Battle Royale Message Log
        if (battleData.gameState === (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale) {
            var gameObject = this._battlePanel.getElement("participants-table");
            this._battlePanel.remove(gameObject, true);
            //this._participantTable.setItems();
            this._participantTable.alpha = 0;
            this._participantTable.destroy();
            this._participantTable = undefined;
            this._participantTable = this.createGameplayTable(this.scene, this._battleData.messages, this.x, this.y, this.scale).layout();
            this._battlePanel.add(this._participantTable, {
                key: "participants-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(166 + this._battleRoyaleImage.height + 1 + 80),
                expand: false
            });
            this.layout();
        }
    }
    updateMessageDisplay(battleData) {
        this._participantTable.setItems();
        this._participantTable.setItems(battleData.messages);
        this._participantTable.scrollToBottom();
        this._participantsText.setText(battleData.participantsRemaining + " participants remaining...");
    }
    updateParticipantsList(participants) {
        this._participantTable.setItems();
        this._participantTable.setItems(participants);
        this._participantTable.scrollToBottom();
        this._participantsText.setText(participants.length + " participants have joined...");
    }
}
Phaser.GameObjects.GameObjectFactory.register("battleRoyaleBattlePane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new BossFightBattlePane(this.scene, x, y));
});







// Pane Details
const $a563902d9158455e$var$paneHeight = 290;
const $a563902d9158455e$var$paneWidth = 259;
const $a563902d9158455e$var$paneRadius = 16;
const $a563902d9158455e$var$paneColor = 0x1c1c2c;
const $a563902d9158455e$var$paneAlpha = 1;
class $a563902d9158455e$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $a563902d9158455e$var$paneWidth,
            height: paneScale * $a563902d9158455e$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._battleData = data;
        this._player = data.player;
        this._scale = paneScale;
        this._scene = scene;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Background
        this._background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($a563902d9158455e$var$paneWidth), scene.applyScale($a563902d9158455e$var$paneHeight), scene.applyScale($a563902d9158455e$var$paneRadius), $a563902d9158455e$var$paneColor, $a563902d9158455e$var$paneAlpha);
        this.add(this._background, {
            key: "background",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Info Panel
        this._battleInfoPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($a563902d9158455e$var$paneWidth),
            height: scene.applyScale($a563902d9158455e$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Attacking Status
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Round 1 Launches in:", scene.applyScale(18), 0);
        this._battleInfoPanel.add(this._title, {
            key: `details-title`,
            align: "left-top",
            offsetX: scene.applyScale(27),
            offsetY: scene.applyScale(29),
            expand: false
        });
        // Timer Progress Bar
        var countdown = (0, $f12f0c85b935f07d$export$bcbf232a15e036ba)();
        this._countDownProgressBar = new (0, $3a9bea67e0e561eb$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, countdown);
        if (!this._battleData.isParticipant) this.startCountDownUI(countdown);
        this._battleInfoPanel.add(this._countDownProgressBar, {
            key: "progress_bar",
            align: "left-top",
            offsetX: this.applyScale(27),
            offsetY: this.applyScale(66),
            expand: false
        });
        // Game Text
        this._gameText = scene.add.bitmapText(0, 0, "cc_outline", "Fight it out against other squads in a no holds barred RNG tournament.", scene.applyScale(18), 0).setMaxWidth(scene.applyScale(172));
        this._battleInfoPanel.add(this._gameText, {
            key: `game-text`,
            align: "left-top",
            offsetX: scene.applyScale(27),
            offsetY: scene.applyScale(121),
            expand: false
        });
        // Ready Up Button
        this._readyUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battleroyale_ready_up_button", false).setScale(this._scale);
        this.handleReadyButtonState();
        this._readyUpButton.onClick().subscribe((pointer)=>{
            this.stopTimer();
            scene.scene.pause("BattleRoyaleScene");
            scene.scene.launch("BattleRoyaleEntryScene");
        });
        this._battleInfoPanel.add(scene.add.existing(this._readyUpButton), {
            key: "ready-up-button",
            align: "left-bottom",
            offsetX: this.applyScale(21),
            offsetY: this.applyScale(32),
            expand: false
        });
        this.add(this._battleInfoPanel, {
            key: "info-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    updateButton(joined) {
        this._readyUpButton.setDisabled(joined);
    }
    applyScale(length) {
        return length * this._scale;
    }
    startCountDownUI(countDown) {
        // Implements Countdown
        var remainingSeconds = countDown;
        // Resets Countdown Bar Values
        this._countDownProgressBar.roundTimerReset(this, remainingSeconds);
        this._intervalTimer = setInterval(()=>{
            try {
                if (remainingSeconds <= 0) {
                    this._countDownProgressBar.setBattleRoyaleLive();
                    // Player has joined as Viewer after initial countdown
                    if (this._scene.handleCountdownFinished()) {
                        this._readyUpButton.setDisabledTexture("bossfight_sit_out_button");
                        this._readyUpButton.setDisabled(true);
                    }
                    return clearInterval(this._intervalTimer);
                }
                remainingSeconds--;
                this._countDownProgressBar.updateDisplay(this, remainingSeconds);
            } catch (error) {
                return clearInterval(this._intervalTimer);
            }
        }, 1000);
    }
    updateDetailPane(battleData) {
        this._battleData = battleData;
        if (this._battleData.gameState === 0) this.startCountDownUI((0, $f12f0c85b935f07d$export$bcbf232a15e036ba)());
        if (this._battleData.gameState === 1) {
            this._title.setText("Round " + this._battleData.round + " is:");
            this._countDownProgressBar.setBattleRoyaleLive();
        }
        // Update Countdown UI
        if (this._battleData.gameState === 2) {
            // 2 = GameState.BRIntermission
            this._title.setText("Round " + this._battleData.round + " will start in: ");
            this.startCountDownUI(battleData.countDown);
        }
        if (this._battleData.gameState === 4) {
            // GameState.GameOver
            this._title.setText("Battle Complete. Displaying Results");
            this.startCountDownUI(battleData.countDown);
        }
    }
    handleReadyButtonState() {
        this._readyUpButton.setDisabledTexture("battleroyale_you_are_ready_button");
        if (this._battleData.hasGameStarted && this._player == undefined) {
            this._readyUpButton.setDisabledTexture("bossfight_sit_out_button");
            this._readyUpButton.setDisabled(true);
        }
        if (this._battleData.hasGameStarted && this._player !== undefined && this._player.isViewer) {
            // update this .joined to isParticipant
            this._readyUpButton.setDisabledTexture("bossfight_sit_out_button");
            this._readyUpButton.setDisabled(true);
        }
        if (this._player !== undefined && this._player.isParticipant) this._readyUpButton.setDisabled(true);
    }
    updateReadyButtonViewer() {
        this._readyUpButton.setDisabledTexture("bossfight_sit_out_button");
        this._readyUpButton.setDisabled(true);
    }
    stopTimer() {
        clearInterval(this._intervalTimer);
    }
}
Phaser.GameObjects.GameObjectFactory.register("battleRoyaleDetailPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $a563902d9158455e$export$2e2bcd8739ae039(this.scene, x, y));
});







// Pane Details
const $faa784bdddb4026e$var$paneHeight = 632;
const $faa784bdddb4026e$var$paneWidth = 259;
const $faa784bdddb4026e$var$paneRadius = 16;
const $faa784bdddb4026e$var$paneColor = 0x1c1c2c;
const $faa784bdddb4026e$var$paneAlpha = 1;
// Feed Details
const $faa784bdddb4026e$var$feedHeight = 580;
// Table Item Details
const $faa784bdddb4026e$var$itemWidth = 239, $faa784bdddb4026e$var$itemHeight = 60, $faa784bdddb4026e$var$itemRadius = 13, $faa784bdddb4026e$var$itemColor = 0x262637, $faa784bdddb4026e$var$itemAlpha = 1, $faa784bdddb4026e$var$itemGlareHeight = 5, $faa784bdddb4026e$var$itemGlareRadius = 4, $faa784bdddb4026e$var$itemGlareColor = 0xffffff, $faa784bdddb4026e$var$itemGlareAlpha = 0.08;
class $faa784bdddb4026e$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $faa784bdddb4026e$var$paneWidth,
            height: paneScale * $faa784bdddb4026e$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._feedData = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Background
        this._background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($faa784bdddb4026e$var$paneWidth), scene.applyScale($faa784bdddb4026e$var$paneHeight), scene.applyScale($faa784bdddb4026e$var$paneRadius), $faa784bdddb4026e$var$paneColor, $faa784bdddb4026e$var$paneAlpha);
        this.add(this._background, {
            key: "background",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Info Panel
        this._battleFeedPane = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($faa784bdddb4026e$var$paneWidth),
            height: scene.applyScale($faa784bdddb4026e$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Title
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Kill Feed", scene.applyScale(22), 0);
        this._battleFeedPane.add(this._title, {
            key: `details-title`,
            align: "center-top",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(20),
            expand: false
        });
        this.add(this._battleFeedPane, {
            key: "info-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._feedTable = this.createFeedTable(this.scene, this._feedData, x, y, this.scale).layout();
        this._battleFeedPane.add(this._feedTable, {
            key: "feed-table",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(60),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createFeedTable(scene, data, x, y, scale) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($faa784bdddb4026e$var$paneWidth),
            height: scene.applyScale($faa784bdddb4026e$var$feedHeight - 20),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($faa784bdddb4026e$var$itemWidth),
                cellHeight: this.applyScale($faa784bdddb4026e$var$itemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, message = cell.item;
                const player1 = message.player1;
                const player2 = message.player2;
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($faa784bdddb4026e$var$itemWidth),
                    space: {
                        left: scene.applyScale(10),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($faa784bdddb4026e$var$itemWidth), scene.applyScale($faa784bdddb4026e$var$itemHeight), scene.applyScale($faa784bdddb4026e$var$itemRadius), $faa784bdddb4026e$var$itemColor, $faa784bdddb4026e$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($faa784bdddb4026e$var$itemWidth - 15), scene.applyScale($faa784bdddb4026e$var$itemGlareHeight), scene.applyScale($faa784bdddb4026e$var$itemGlareRadius), $faa784bdddb4026e$var$itemGlareColor, $faa784bdddb4026e$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "center-top",
                    offsetY: scene.applyScale(7),
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", message.feed, scene.applyScale(16), 1).setMaxWidth(scene.applyScale($faa784bdddb4026e$var$itemWidth - 15)).setCharacterTint(scene.getTintIndex(player1, message.feed, false), player1.length, true, scene.getTintColor(player1)).setCharacterTint(scene.getTintIndex(player2, message.feed, false), player2.length, true, scene.getTintColor(player2)).setCharacterTint(scene.getTintIndex(player2, message.feed, true), player2.length, true, scene.getTintColor(player2)), {
                    key: "item_feed",
                    align: "center-top",
                    offsetY: scene.applyScale(20),
                    offsetX: scene.applyScale(0),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    updateFeed(feedData) {
        this._feedData = feedData;
        this._feedTable.setItems();
        this._feedTable.setItems(feedData);
        this._feedTable.scrollToBottom();
    }
}
Phaser.GameObjects.GameObjectFactory.register("battleRoyaleFeedPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $faa784bdddb4026e$export$2e2bcd8739ae039(this.scene, x, y));
});



const $d15e8838d2b2c91b$var$width = 1512;
const $d15e8838d2b2c91b$var$height = 982;
class $d15e8838d2b2c91b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattleRoyaleScene"
        });
    }
    preload() {
        this._server = (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance();
        this._battleData = this._server.getRoomData();
        // Assets
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$2556aa0fb1402c03));
        // Loads Player PFP Assets
        this._battleData.pfpData.forEach((pfp)=>{
            this.load.image(pfp.playerImageKey, pfp.playerImageUrl);
        });
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($d15e8838d2b2c91b$var$width, $d15e8838d2b2c91b$var$height);
        if (this._server.isServerAlive()) {
            // Server has been started
            // Determine if player has already joined the server as participant or viewer
            this._player = this._server.getPlayerFromMetaParticipants((0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress());
            this._battleData.player = this._player; // questionable variable
            if (this._player != undefined) {
                if (this._player.isParticipant) {
                    this._server.join(this.getPlayerAndSquadData(), true);
                    this.enableBattleRoyaleListeners();
                } else {
                    this._server.join(this.getPlayerAndSquadData(), false);
                    this.enableBattleRoyaleViewerListeners();
                }
                // Updating battle data with participants from game server not metadata
                this._battleData.participants = this._server.getParticipantsList();
                switch(this._server.getGameState()){
                    case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
                        break;
                    case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale:
                    case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission:
                        this._battleData.messages = this._server.getMessages();
                        break;
                    case (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver:
                        this._server.disableBattleRoyaleListeners();
                        this.scene.stop("BattleRoyaleScene");
                        this.scene.launch("BattleRoyaleGameOverScene", {
                            participants: this._server.getParticipantsList()
                        });
                        break;
                    case (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed:
                        this._server.disableBattleRoyaleListeners();
                        this.scene.stop("BattleRoyaleScene");
                        this.scene.launch("BattleRoyaleFailedScene");
                        break;
                }
            } else // Player has NOT joined the game either as a participant or viewer
            // Use room data to fill up the UI
            switch(this._battleData.gameState){
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale:
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission:
                    // join player to server as a Viewer
                    this._server.join(this.getPlayerAndSquadData(), false);
                    this.enableBattleRoyaleViewerListeners();
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver:
                    // Launch Game Over Scene
                    this.scene.stop("BattleRoyaleScene");
                    this.scene.launch("BattleRoyaleGameOverScene", {
                        participants: this._battleData.previousResults
                    });
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed:
                    this.scene.stop("BattleRoyaleScene");
                    this.scene.launch("BattleRoyaleFailedScene");
                    break;
            }
            this.createComponent();
            this.events.on("resume", (scene, data)=>{
                if (data !== undefined && data.joined !== undefined) {
                    // Updates state of join button
                    this.enableBattleRoyaleListeners();
                    this._battleRoyaleDetailPane.updateButton(data.joined);
                }
            });
        } else // show UI to notify users game server is done
        this.scene.start("BattleRoyaleServerUnavailableScene");
    }
    createComponent() {
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $d15e8838d2b2c91b$var$width * this._scale,
            height: $d15e8838d2b2c91b$var$height * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Battle Pane
        this._battleRoyaleBattlePane = new (0, $559bcda9b38655cb$export$2e2bcd8739ae039)(this, 0, 0, this._battleData, this._scale);
        sizer.add(this._battleRoyaleBattlePane, {
            key: "bossfight-pane",
            align: "left-top",
            offsetX: this.applyScale(336),
            offsetY: this.applyScale(77),
            expand: false
        });
        // Detail Pane
        this._battleRoyaleDetailPane = new (0, $a563902d9158455e$export$2e2bcd8739ae039)(this, 0, 0, this._battleData, this._scale);
        sizer.add(this._battleRoyaleDetailPane, {
            key: "battleroyale-detail-pane",
            align: "left-top",
            offsetX: this.applyScale(906),
            offsetY: this.applyScale(77),
            expand: false
        });
        // Feed Pane
        this._battleRoyaleFeedPane = new (0, $faa784bdddb4026e$export$2e2bcd8739ae039)(this, 0, 0, this._battleData.messages, this._scale);
        sizer.add(this._battleRoyaleFeedPane, {
            key: "battleroyale-feed-pane",
            align: "left-top",
            offsetX: this.applyScale(906),
            offsetY: this.applyScale(416),
            expand: false
        });
        // Add Back Button
        this._backButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battleroyale_back_button", true, 1.05).setScale(this._scale);
        this._backButton.onClick().subscribe((pointer)=>{
            this.onBackButtonPressed();
        });
        this.add.existing(this._backButton);
        sizer.add(this._backButton, {
            key: "back-button",
            align: "left-top",
            offsetX: this.applyScale(24),
            offsetY: this.applyScale(896),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    onBackButtonPressed() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop();
        this._server.disableBattleRoyaleListeners();
    }
    onTabbedOut() {
        this._server.disableBattleRoyaleListeners();
        this._battleRoyaleDetailPane.stopTimer();
    }
    onTabbedIn() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            var roomData = yield this._server.getRoomData();
            switch(roomData.gameState){
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
                    if (roomData.isParticipant) {
                        this.enableBattleRoyaleListeners();
                        this._battleData = this._server.getBattleData();
                        this._battleRoyaleDetailPane.updateDetailPane(this._battleData);
                        this._battleRoyaleBattlePane.updateParticipantsList(this._battleData.participants);
                    } else {
                        this._battleRoyaleDetailPane.updateDetailPane(roomData);
                        this._battleRoyaleBattlePane.updateParticipantsList(roomData.participants);
                    }
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale:
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission:
                    if (roomData.isParticipant) {
                        this.enableBattleRoyaleListeners();
                        this._battleData = this._server.getBattleData();
                        this._battleRoyaleDetailPane.updateDetailPane(this._battleData);
                        this._battleRoyaleBattlePane.updateMessageDisplay(this._battleData);
                    } else if (roomData.isViewer) {
                        this.enableBattleRoyaleViewerListeners();
                        this._battleData = this._server.getBattleData();
                        this._battleRoyaleDetailPane.updateDetailPane(this._battleData);
                        this._battleRoyaleBattlePane.updateMessageDisplay(this._battleData);
                    } else {
                        // join player to server as a Viewer
                        this._server.join(this.getPlayerAndSquadData(), false);
                        this._battleRoyaleDetailPane.updateReadyButtonViewer();
                        // Boss Fight Service Listeners
                        this.enableBattleRoyaleViewerListeners();
                        this._battleData = this._server.getBattleData();
                        this._battleRoyaleDetailPane.updateDetailPane(this._battleData);
                        this._battleRoyaleBattlePane.updateMessageDisplay(this._battleData);
                    }
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver:
                    this._server.disableBattleRoyaleListeners();
                    this.scene.stop("BattleRoyaleScene");
                    this.scene.launch("BattleRoyaleGameOverScene", {
                        participants: roomData.previousResults
                    });
                    break;
                case (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed:
                    this.scene.stop("BattleRoyaleScene");
                    this.scene.launch("BattleRoyaleFailedScene");
                    break;
            }
        });
    }
    // Listeners
    enableBattleRoyaleViewerListeners() {
        this._server.onMessageRecieved(this.handleBattleRoyaleMessageReceived, this);
        this._server.onGameStateChanged(this.handleGameStateChanged, this);
    }
    enableBattleRoyaleListeners() {
        this._server.onParticipantsUpdated(this.handleParticipantsUpdated, this);
        this._server.onMessageRecieved(this.handleBattleRoyaleMessageReceived, this);
        this._server.onGameStateChanged(this.handleGameStateChanged, this);
    }
    handleParticipantsUpdated() {
        if (this._battleData.gameState === (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame) {
            var texturesToLoad = this.getTextureLoadingList();
            if (texturesToLoad.length > 0) {
                this.load.once("complete", ()=>{
                    this._battleRoyaleBattlePane.updateParticipantsList(this._server.getBattleData());
                });
                texturesToLoad.forEach((texture)=>{
                    if (!this.textures.exists(texture.key)) this.load.image(texture.key, texture.url);
                });
                this.load.start();
            } else this._battleRoyaleBattlePane.updateParticipantsList(this._server.getParticipantsList());
        }
    }
    getTextureLoadingList() {
        var _a;
        var texturesToLoad = [];
        (_a = this._battleData.participants) === null || _a === void 0 || _a.forEach((participant)=>{
            if (!this.textures.exists(participant.playerImageKey)) texturesToLoad.push({
                key: participant.playerImageKey,
                url: participant.playerImageUrl
            });
        });
        return texturesToLoad;
    }
    handleBattleRoyaleMessageReceived() {
        var _a, _b;
        this._battleRoyaleBattlePane.updateMessageDisplay(this._server.getBattleData());
        this._battleRoyaleFeedPane.updateFeed(this._server.getBattleData().messages);
        // get most rescent message
        var lastIndex = ((_a = this._server.getBattleData().messages) === null || _a === void 0 ? void 0 : _a.length) - 1;
        var message = (_b = this._server.getBattleData().messages) === null || _b === void 0 ? void 0 : _b.at(lastIndex);
        // check if a player was killed or committed suicide
        var isSuicide = (message === null || message === void 0 ? void 0 : message.player1) == (message === null || message === void 0 ? void 0 : message.player2);
    // if true display Eliminated Scene
    // if (
    //   WalletConnectService.getInstance().getWalletAddress() == this._server.getBattleData().messages?.at(lastIndex).eliminatedWallet &&
    //   (this._server.getBattleData().participantsRemaining as number) > 2
    // ) {
    //   //this.scene.pause("BattleRoyaleScene")
    //   // this.scene.start("BattleRoyaleEliminatedScene", {
    //   // 	//participants: participants
    //   // })
    // }
    }
    handleGameStateChanged() {
        switch(this._server.getGameState()){
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).PreGame:
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BattleRoyale:
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).BRIntermission:
                if (this._server.getBattleData().round === 1 && this._server.getGameState() === 1) this._battleRoyaleBattlePane.switchDisplayTable(this._server.getBattleData());
                this._battleRoyaleDetailPane.updateDetailPane(this._server.getBattleData());
                break;
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).Failed:
                this.scene.stop("BattleRoyaleScene");
                this.scene.launch("BattleRoyaleFailedScene");
                break;
            case (0, $51e1646242d4d492$export$eb5ccdbd077479c).GameOver:
                var participants = this._server.getParticipantsList();
                this._server.disableBattleRoyaleListeners();
                this.scene.stop("BattleRoyaleScene");
                this.scene.launch("BattleRoyaleGameOverScene", {
                    participants: participants
                });
                break;
        }
    }
    handleCountdownFinished() {
        // 1st time if player isn't in
        if (!this._server.hasPlayerJoinedGame((0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress())) {
            // join player to server as a Viewer
            this._server.join(this.getPlayerAndSquadData(), false);
            this._battleRoyaleDetailPane.updateReadyButtonViewer();
            // Boss Fight Service Listeners
            this.enableBattleRoyaleViewerListeners();
            return true;
        }
        return false;
    }
    createSquadMemberImage(scene, imageKey) {
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 3;
        smImageData.destroy();
        var squadMemberImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        squadMemberImage.displayHeight = scene.applyScale(48);
        squadMemberImage.scaleX = squadMemberImage.scaleY;
        return squadMemberImage;
    }
    // Gets Tint colour for battle royal message display. Gold when players is you!
    getTintColor(name) {
        return name === (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserName() ? 0xdea827 : 0x2fe2a2;
    }
    getTintIndex(name, message, last) {
        var index = last ? message.lastIndexOf(name) : message.indexOf(name);
        if (index == 0 || index < 59) return index;
        else return index - 1;
    }
    getPlayerAndSquadData() {
        var playerData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        playerData.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        return playerData;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$2556aa0fb1402c03)));
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, this._server.getPlayerImageKeys());
    }
}











const $9b87d99c0406e09c$var$modalHeight = 455;
const $9b87d99c0406e09c$var$modalWidth = 494;
const $9b87d99c0406e09c$var$modalRadius = 50;
const $9b87d99c0406e09c$var$modalColor = 0x350926;
const $9b87d99c0406e09c$var$modalAlpha = 90;
const $9b87d99c0406e09c$var$modalBorderColor = 0x3d4361;
const $9b87d99c0406e09c$var$modalBorderWidth = 1;
const $9b87d99c0406e09c$var$spaceElixirFee = 800;
const $9b87d99c0406e09c$var$neonGoldFee = 500;
const $9b87d99c0406e09c$var$stardustFee = 3;
class $9b87d99c0406e09c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattleRoyaleEntryScene"
        });
    }
    preload() {
        // Images
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$5ba68ea21fea4e94));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($9b87d99c0406e09c$var$modalWidth, $9b87d99c0406e09c$var$modalHeight + 60);
        this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._userData.squadMembers = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        this.createComponent();
    }
    createComponent() {
        // Add Background
        // const modalBg = this.add.rexRoundRectangle(
        //     this.sys.canvas.width / 2, // x
        //     this.sys.canvas.height / 2, // y
        //     this.applyScale(modalWidth), // width
        //     this.applyScale(modalHeight), // height
        //     this.applyScale(modalRadius), // radius
        //     modalColor, // fillColor
        //     modalAlpha, // alpha
        // );
        // modalBg.setStrokeStyle(modalBorderWidth, modalBorderColor, modalAlpha);
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $9b87d99c0406e09c$var$modalWidth * this._scale,
            height: $9b87d99c0406e09c$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Icons
        const spaceElixirImage = this.add.image(0, 0, "battleroyale_space_elixir_icon").setScale(this._scale);
        sizer.add(spaceElixirImage, {
            key: "spaceelixir_image",
            align: "left-top",
            offsetX: this.applyScale(156),
            offsetY: this.applyScale(-28),
            expand: false
        });
        const neonGoldImage = this.add.image(0, 0, "battleroyale_neon_gold_icon").setScale(this._scale);
        sizer.add(neonGoldImage, {
            key: "neongold_image",
            align: "left-top",
            offsetX: this.applyScale(215),
            offsetY: this.applyScale(-28),
            expand: false
        });
        const starDustImage = this.add.image(0, 0, "battleroyale_stardust_icon").setScale(this._scale);
        sizer.add(starDustImage, {
            key: "stardust_image",
            align: "left-top",
            offsetX: this.applyScale(281),
            offsetY: this.applyScale(-28),
            expand: false
        });
        // Add Title Text
        const title = this.add.bitmapText(0, 0, "cc_outline", "Cost to enter:", this.applyScale(26), 1);
        sizer.add(title, {
            key: "title",
            align: "left-top",
            offsetX: this.applyScale(161),
            offsetY: this.applyScale(66),
            expand: false
        });
        // Add Note
        const note = this.add.bitmapText(0, 0, "cc_outline", "Note: Rewards for winning\nwill always be significantly\nhigher than costs to enter.", this.applyScale(20), 1).setAlpha(0.6);
        sizer.add(note, {
            key: "note",
            align: "left-top",
            offsetX: this.applyScale(126),
            offsetY: this.applyScale(319),
            expand: false
        });
        // Add Fee Labels
        const spaceElixirRewardLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", $9b87d99c0406e09c$var$spaceElixirFee.toLocaleString("en-us"));
        sizer.add(spaceElixirRewardLabel, {
            key: "spaceelixir_label",
            align: "left-top",
            offsetX: this.applyScale(140),
            offsetY: this.applyScale(119),
            expand: false
        });
        const neonGoldRewardLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", $9b87d99c0406e09c$var$neonGoldFee.toLocaleString("en-us"));
        sizer.add(neonGoldRewardLabel, {
            key: "neongold_label",
            align: "left-top",
            offsetX: this.applyScale(140),
            offsetY: this.applyScale(180),
            expand: false
        });
        const stardustRewardLabel = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", $9b87d99c0406e09c$var$stardustFee.toLocaleString("en-us"));
        sizer.add(stardustRewardLabel, {
            key: "stardust_label",
            align: "left-top",
            offsetX: this.applyScale(140),
            offsetY: this.applyScale(241),
            expand: false
        });
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "pvp_cancel_button", true, 1.05).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.resume("BattleRoyaleScene", {
                joined: false
            });
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        sizer.add(cancelButton, {
            key: "cancel-button",
            align: "left-top",
            offsetX: this.applyScale(89),
            offsetY: this.applyScale(424),
            expand: false
        });
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "pvp_confirm_button", true, 1.05).setScale(this._scale);
        confirmButton.onClick().subscribe((pointer)=>{
            (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().join(this._userData, true);
            this.unloadAssets();
            this.scene.resume("BattleRoyaleScene", {
                joined: true
            });
            this.scene.stop();
        });
        this.add.existing(confirmButton);
        sizer.add(confirmButton, {
            key: "confirm-button",
            align: "left-top",
            offsetX: this.applyScale(238),
            offsetY: this.applyScale(424),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$5ba68ea21fea4e94)));
    }
}






const $9da07dba68f95243$var$modalHeight = 701;
const $9da07dba68f95243$var$modalWidth = 314;
class $9da07dba68f95243$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattleRoyaleEliminatedScene"
        });
    }
    preload() {
        this.load.image("bossfight_defeat_badge", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_defeat_badge);
        this.load.image("bossfight_defeat_title", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_defeat_title);
        this.load.image("bossfight_defeat_return_home_button", (0, $1aa2c39fc1fbb95e$export$2328bd5729fa76e5).bossfight_defeat_return_home_button);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($9da07dba68f95243$var$modalWidth, $9da07dba68f95243$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $9da07dba68f95243$var$modalWidth * this._scale,
            height: $9da07dba68f95243$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Defeat Badge
        this._defeatBadge = this.add.image(0, 0, "bossfight_defeat_badge").setScale(this._scale);
        sizer.add(this._defeatBadge, {
            key: "bossfight_defeat_badge",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Defeat Title
        this._defeatTitle = this.add.image(0, 0, "bossfight_defeat_title").setScale(this._scale);
        sizer.add(this._defeatTitle, {
            key: "bossfight_defeat_title",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(145),
            expand: false
        });
        // Text
        this._text = this.add.bitmapText(0, 0, "cc_outline", "You were not\nsuccessful this time,\ndear wolf, but there\nwill be many more\nopportunities ahead...", this.applyScale(28), 1);
        sizer.add(this._text, {
            key: "bossfight-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(281),
            expand: false
        });
        // Add Return Home Button
        this._returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_defeat_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHomeButton.onClick().subscribe((pointer)=>{
            this.destroy();
        });
        this.add.existing(this._returnHomeButton);
        sizer.add(this._returnHomeButton, {
            key: "return-home-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(542),
            expand: false
        });
        // Add Return Home Button
        this._continueButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_defeat_return_home_button", true, 1.05).setScale(this._scale);
        this._continueButton.onClick().subscribe((pointer)=>{
            this.scene.stop();
        });
        this.add.existing(this._continueButton);
        sizer.add(this._continueButton, {
            key: "continue-button",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(600),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.scene.start("HomebaseScene");
        this.scene.stop("BossFightScene");
        this.scene.stop();
    }
}









const $91fa7cb414ce6d6f$var$modalHeight = 701;
const $91fa7cb414ce6d6f$var$modalWidth = 387;
class $91fa7cb414ce6d6f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._participants = data.participants;
        //this._participants = [{"clientId":"id","playerId":"this is a big wallet id 0","playerName":"Player 0","playerImageKey":"nft_375138076","playerImageUrl":"https://lh3.googleusercontent.com/X0xX39ZHn98PWVfVCtZ4_A-uvWr6MkVImiNDQFGIodAGNF5Gabdeu2QjOXID5L5f5UV6pis7lDd5tDq2kYhvnMX34M1dn_SYTuuaBw","playerLevel":66,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":2,"kills":0,"evades":1,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 1","playerName":"Player 1","playerImageKey":"nft_375137903","playerImageUrl":"https://lh3.googleusercontent.com/uXq7cKznuye2S2tSt8dmSCQWwiwU3jm0e_HRfcikaw8uFfJQW2FnUc6ocjLOy6phWqnNa8uMXzH4vDgX8XcUWzDRBeMsdLo7sbfwgR0","playerLevel":17,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":3,"kills":1,"evades":1,"lazes":0,"suicides":1},{"clientId":"id","playerId":"this is a big wallet id 2","playerName":"Player 2","playerImageKey":"nft_375138183","playerImageUrl":"https://lh3.googleusercontent.com/-WA4eCwPeqog1egAke21QqBE0HqpzadVvTRazDHtfzZkGSI2M3JICySt0dq7CQNMKAGaLahEUx9rgRAyRWTX9SG17iSKT_wj_aQK","playerLevel":92,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":4,"kills":0,"evades":0,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 3","playerName":"Player 3","playerImageKey":"nft_373010558","playerImageUrl":"https://lh3.googleusercontent.com/_6dhMRaY-O4Fz0280tLVQTfy6IKhS1TB4eI4lY7LoMnVWPK2WYDf_5q6PsEEJwigcU0XC5Yk1G7RHEVfcasfk9X-7q2RB2JrjRNvdg","playerLevel":68,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":6,"kills":0,"evades":0,"lazes":0,"suicides":0},{"clientId":"id","playerId":"this is a big wallet id 4","playerName":"Luke","playerImageKey":"nft_375140812","playerImageUrl":"https://lh3.googleusercontent.com/WHqaIoTlifO5UYGJ-2tYcbk76hkGcx2WlQgCfqk6ATgE8HsAtKwzYgYXrIGb7OODrdRtn11M6zYjnFTS-C-84HHny8DIj9QWPfxr","playerLevel":44,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":1,"kills":2,"evades":2,"lazes":0,"suicides":0},{"clientId":"5iLxgWZR_","playerId":"0xA786bAED9d87aAa039C7C97B166A419d9F42eAa6","playerName":"Luke","playerImageKey":"nft_317575408","playerImageUrl":"https://lh3.googleusercontent.com/ySKhT1Qs2zVr9G8t6qd0oZj5PBVp0Jm5BJF8sPHEN-fA9QbykGe-E8Gb88YMvTetCSOzf42RYny8uErs6z4FRMO5b7AOzZBg0HuniA=s128","playerLevel":187,"battleRoyaleTraits":{"hideRoundPercentageBoost":0,"hideTurnPercentageBoost":0,"attackPercentageBoost":0,"neonGoldPercentageBoost":0,"spaceElixirPercentageBoost":0},"placing":5,"kills":0,"evades":1,"lazes":0,"suicides":1}]
        this._winner = this.getWinner(this._participants);
        this._isLocalWinner = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress() === this._winner.playerId ? true : false;
        this._badgeName = this._isLocalWinner ? "bossfight_victory_badge" : "bossfight_defeat_badge";
        this._badgeTitle = this._isLocalWinner ? "bossfight_victory_title" : "bossfight_defeat_title";
    }
    constructor(){
        super({
            key: "BattleRoyaleGameOverScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$178b77bc36b4adf7));
        // Winning Player PFP
        this.load.image(this._winner.playerImageKey, this._winner.playerImageUrl);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($91fa7cb414ce6d6f$var$modalWidth, $91fa7cb414ce6d6f$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $91fa7cb414ce6d6f$var$modalWidth * this._scale,
            height: $91fa7cb414ce6d6f$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Result Badge
        this._resultBadge = this.add.image(0, 0, this._badgeName).setScale(this._scale);
        sizer.add(this._resultBadge, {
            key: "battleroyale_badge",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Victory Title
        this._resultTitle = this.add.image(0, 0, this._badgeTitle).setScale(this._scale);
        sizer.add(this._resultTitle, {
            key: "battleroyale_title",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(130),
            expand: false
        });
        // Winner Name
        const winnerName = this._winner.playerName;
        this._winnerLabel = this.add.bitmapText(0, 0, "cc_outline", winnerName, this.applyScale(28), 1).setCharacterTint(//message.indexOf(player1),
        this.getTintIndex(this._winner.playerName, winnerName, false), this._winner.playerName.length, true, this.getTintColor(this._winner.playerName));
        sizer.add(this._winnerLabel, {
            key: "winner-name",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(270),
            expand: false
        });
        // Player PFP
        var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(this, 0, 0, this._winner.playerImageKey);
        var imageWidth = imageData.width;
        const rectConfig = {
            maskType: "roundRectangle",
            radius: Math.ceil(imageWidth / 8)
        };
        this._winnerPFP = this.add.rexCircleMaskImage(0, 0, this._winner.playerImageKey, "", rectConfig);
        this._winnerPFP.displayHeight = this.applyScale(149);
        this._winnerPFP.scaleX = this._winnerPFP.scaleY;
        imageData.destroy();
        sizer.add(this._winnerPFP, {
            key: "battleroyale_pfp",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(330),
            expand: false
        });
        // Text
        this._text = this.add.bitmapText(0, 0, "cc_outline", "is the Winner", this.applyScale(28), 1);
        sizer.add(this._text, {
            key: "battleroyale-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(520),
            expand: false
        });
        // Add Return Home Button
        this._returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_victory_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHomeButton.onClick().subscribe((pointer)=>{
            this.destroy();
        });
        this.add.existing(this._returnHomeButton);
        sizer.add(this._returnHomeButton, {
            key: "return-home-button",
            align: "left-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add View Results Button
        this._viewResultsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battleroyale_view_results_button", true, 1.05).setScale(this._scale);
        this._viewResultsButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.launch("BattleRoyaleResultsScene", {
                participants: this._participants
            });
            this.scene.stop("BattleRoyaleScene");
            this.scene.stop();
        });
        this.add.existing(this._viewResultsButton);
        sizer.add(this._viewResultsButton, {
            key: "view-results-button",
            align: "left-bottom",
            offsetX: this.applyScale(210),
            offsetY: 0,
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop("BattleRoyaleScene");
        this.scene.stop();
    }
    getWinner(participants) {
        var winner = undefined;
        participants.forEach((participant)=>{
            if (participant.placing == 1) winner = participant;
        });
        return winner;
    }
    getTintColor(name) {
        return name === (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserName() ? 0xdea827 : 0x2fe2a2;
    }
    getTintIndex(name, message, last) {
        var index = last ? message.lastIndexOf(name) : message.indexOf(name);
        if (index == 0 || index < 59) return index;
        else return index - 1;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$178b77bc36b4adf7)));
        // Unloads winning player pfp
        this.textures.remove(this._winner.playerImageKey);
    }
}







const $9f269383f50e2ffc$var$HUD_DISABLED = true;
const $9f269383f50e2ffc$var$statusPaneConfig = {
    height: 351,
    width: 254,
    fillColor: 0x350926,
    alpha: 0.9,
    radius: 26
};
const $9f269383f50e2ffc$var$levelPaneConfig = {
    height: 440,
    width: 254,
    fillColor: 0x350926,
    alpha: 0.9,
    radius: 26
};
const $9f269383f50e2ffc$var$buttonPaneConfig = {
    height: 108,
    width: 512,
    fillColor: 0x1c1c2c,
    alpha: 1,
    radius: 26
};
const $9f269383f50e2ffc$var$grayTextConfig = {
    size: 18,
    color: 0x75758b
};
const $9f269383f50e2ffc$var$whiteTextConfig = {
    smallSize: 18,
    largeSize: 28,
    headingSize: 24,
    color: 0xffffff
};
const $9f269383f50e2ffc$var$statLabelWidth = 222;
const $9f269383f50e2ffc$var$blobActions = {
    giveFood: 1,
    giveMedicine: 2,
    pet: 3,
    putToSleep: 4
};
class $9f269383f50e2ffc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("BlobHudScene");
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845));
    }
    create() {
        this._blobInfo = (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfoSync();
        // Status Pane
        this.createStatusPane();
        // Level Pane
        this.createLevelPane();
        // Button Pane
        this.createButtonPane();
    }
    createStatusPane() {
        var bg = this.add.rexRoundRectangle(0, 0, $9f269383f50e2ffc$var$statusPaneConfig.width, $9f269383f50e2ffc$var$statusPaneConfig.height, $9f269383f50e2ffc$var$statusPaneConfig.radius, $9f269383f50e2ffc$var$statusPaneConfig.fillColor, $9f269383f50e2ffc$var$statusPaneConfig.alpha);
        this._statusPane = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2 - (306 + $9f269383f50e2ffc$var$statusPaneConfig.width),
            y: this.sys.canvas.height > 800 ? 130 : 80,
            width: $9f269383f50e2ffc$var$statusPaneConfig.width,
            height: $9f269383f50e2ffc$var$statusPaneConfig.height,
            align: 0
        }).setOrigin(0, 0).addBackground(bg);
        // Heading
        var heading = this.add.bitmapText(this._statusPane.getTopLeft().x + $9f269383f50e2ffc$var$statusPaneConfig.width / 2, this._statusPane.getTopLeft().y, "cc_outline", "YOUR BLOB", $9f269383f50e2ffc$var$whiteTextConfig.headingSize, 0).setOrigin(0.5, 0.5);
        // Status
        this._statusPane.add(this.add.bitmapText(0, 0, "cc_outline", "STATUS", $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            padding: {
                left: 16,
                right: 0,
                top: 27,
                bottom: 0
            },
            key: "status_label"
        }).addNewLine();
        this._statusPane.add(this.add.bitmapText(0, 0, "cc_outline", $9f269383f50e2ffc$var$HUD_DISABLED ? "COMING SOON" : this._blobInfo.status === "" ? "Idle" : this._blobInfo.status, $9f269383f50e2ffc$var$whiteTextConfig.largeSize, 0), {
            padding: {
                left: 16,
                right: 0,
                top: 8,
                bottom: 0
            },
            key: "status_value"
        }).addNewLine();
        this._statusPane.add(this.add.image(0, 0, "blob_hud_divider_line"), {
            padding: {
                left: 0,
                right: 0,
                top: 25,
                bottom: 0
            },
            key: "upper_divider"
        });
        // Stats
        this._statusPane.add(this.createBlobStat("food", this._blobInfo.food_value, 60), {
            padding: {
                left: 16,
                right: 0,
                top: 25,
                bottom: 0
            },
            key: "food_stat"
        });
        this._statusPane.add(this.createBlobStat("health", this._blobInfo.health_value, 60), {
            padding: {
                left: 16,
                right: 0,
                top: 15,
                bottom: 0
            },
            key: "health_stat"
        });
        this._statusPane.add(this.createBlobStat("happiness", this._blobInfo.happiness_value, 60), {
            padding: {
                left: 16,
                right: 0,
                top: 15,
                bottom: 0
            },
            key: "happiness_stat"
        });
        this._statusPane.add(this.createBlobStat("energy", this._blobInfo.energy_value, 60), {
            padding: {
                left: 16,
                right: 0,
                top: 15,
                bottom: 0
            },
            key: "energy_stat"
        });
        this._statusPane.add(this.add.image(0, 0, "blob_hud_divider_line"), {
            padding: {
                left: 0,
                right: 0,
                top: 25,
                bottom: 0
            },
            key: "lower_divider"
        });
        // Daily Actions
        this._statusPane.add(this.createBlobStat("daily actions", this._blobInfo.actions_remaining, this._blobInfo.actions_allowed_per_day), {
            padding: {
                left: 16,
                right: 0,
                top: 15,
                bottom: 0
            },
            key: "daily_actions_stat"
        });
        this._statusPane.layout();
    }
    createLevelPane() {
        // Background
        var bg = this.add.rexRoundRectangle(0, 0, $9f269383f50e2ffc$var$levelPaneConfig.width, $9f269383f50e2ffc$var$levelPaneConfig.height, $9f269383f50e2ffc$var$levelPaneConfig.radius, $9f269383f50e2ffc$var$levelPaneConfig.fillColor, $9f269383f50e2ffc$var$levelPaneConfig.alpha);
        this._levelPane = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2 + 306,
            y: this.sys.canvas.height > 800 ? 130 : 80,
            width: $9f269383f50e2ffc$var$levelPaneConfig.width,
            height: $9f269383f50e2ffc$var$levelPaneConfig.height,
            align: 0
        }).setOrigin(0, 0).addBackground(bg);
        // Heading
        var heading = this.add.bitmapText(this._levelPane.getTopLeft().x + $9f269383f50e2ffc$var$levelPaneConfig.width / 2, this._levelPane.getTopLeft().y, "cc_outline", "LEVEL", $9f269383f50e2ffc$var$whiteTextConfig.headingSize, 0).setOrigin(0.5, 0.5);
        // Level Area
        this._levelPane.add(this.createLevelLabel($9f269383f50e2ffc$var$HUD_DISABLED ? 0 : this._blobInfo.level), {
            padding: {
                left: 16,
                right: 0,
                top: 27,
                bottom: 0
            },
            key: "level_label"
        });
        // Divider
        this._levelPane.add(this.add.image(0, 0, "blob_hud_divider_line"), {
            padding: {
                left: 0,
                right: 0,
                top: 25,
                bottom: 0
            },
            key: "level_divider"
        });
        // Defense
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", "DEFENSE PER HR", $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            padding: {
                left: 16,
                right: 0,
                top: 25,
                bottom: 0
            },
            key: "defense_label"
        }).addNewLine();
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", `${$9f269383f50e2ffc$var$HUD_DISABLED ? 0 : this._blobInfo.defense_per_hour}HP`, $9f269383f50e2ffc$var$whiteTextConfig.largeSize, 0), {
            padding: {
                left: 16,
                right: 0,
                top: 3,
                bottom: 0
            },
            key: "defense_value"
        }).addNewLine();
        // Machine Multiplier
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", "MACHINE MULTIPLIER", $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            padding: {
                left: 16,
                right: 0,
                top: 18,
                bottom: 0
            },
            key: "machine_multi_label"
        }).addNewLine();
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", `x${$9f269383f50e2ffc$var$HUD_DISABLED ? 0 : this._blobInfo.machine_multiplier}`, $9f269383f50e2ffc$var$whiteTextConfig.largeSize, 0), {
            padding: {
                left: 16,
                right: 0,
                top: 3,
                bottom: 0
            },
            key: "mm_value"
        }).addNewLine();
        // Points
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", "AVAILABLE POINTS", $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            padding: {
                left: 16,
                right: 0,
                top: 18,
                bottom: 0
            },
            key: "points_label"
        }).addNewLine();
        this._levelPane.add(this.add.bitmapText(0, 0, "cc_outline", `${$9f269383f50e2ffc$var$HUD_DISABLED ? 0 : this._blobInfo.unapplied_points}`, $9f269383f50e2ffc$var$whiteTextConfig.largeSize, 0), {
            padding: {
                left: 16,
                right: 0,
                top: 3,
                bottom: 0
            },
            key: "points_value"
        }).addNewLine();
        // Button
        this._assignPointButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "assign_points_button", false).setDisabled($9f269383f50e2ffc$var$HUD_DISABLED).setAlpha($9f269383f50e2ffc$var$HUD_DISABLED ? 0.6 : 1);
        this._assignPointButton.onClick().subscribe((pointer)=>{
            this.scene.pause("HomebaseScene");
            this.scene.pause("BlobHudScene");
            this.scene.launch("UpgradeBlobModalScene");
        });
        this._levelPane.add(this.add.existing(this._assignPointButton), {
            padding: {
                left: 16,
                right: 0,
                top: 22,
                bottom: 0
            },
            key: "assign_points_button"
        });
        this._levelPane.layout();
    }
    createButtonPane() {
        var bg = this.add.rexRoundRectangle(0, 0, $9f269383f50e2ffc$var$buttonPaneConfig.width, $9f269383f50e2ffc$var$buttonPaneConfig.height, $9f269383f50e2ffc$var$buttonPaneConfig.radius, $9f269383f50e2ffc$var$buttonPaneConfig.fillColor, $9f269383f50e2ffc$var$buttonPaneConfig.alpha);
        this._buttonPane = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height - (this.sys.canvas.height > 800 ? 138 : 98),
            width: $9f269383f50e2ffc$var$buttonPaneConfig.width,
            height: $9f269383f50e2ffc$var$buttonPaneConfig.height,
            space: {
                left: 26,
                right: 26,
                top: 29,
                bottom: 29,
                item: 13,
                line: 0
            },
            align: 2
        }).addBackground(bg);
        var buttonsEnabled = $9f269383f50e2ffc$var$HUD_DISABLED ? 0 : this._blobInfo.status === "";
        var buttonAlpha = buttonsEnabled ? 1 : 0.6;
        this._giveFoodButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "give_food_button", false).setAlpha(buttonAlpha).setDisabled(!buttonsEnabled);
        this._giveFoodButton.onClick().subscribe((pointer)=>{
            (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().performAction($9f269383f50e2ffc$var$blobActions.giveFood).then((res)=>{
                if (res.success) {
                    (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().setBlobInfo(res.blob);
                    this.scene.restart();
                }
            });
        });
        this._giveMedicineButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "give_medication_button", false).setAlpha(buttonAlpha).setDisabled(!buttonsEnabled);
        this._giveMedicineButton.onClick().subscribe((pointer)=>{
            (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().performAction($9f269383f50e2ffc$var$blobActions.giveMedicine).then((res)=>{
                if (res.success) {
                    (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().setBlobInfo(res.blob);
                    this.scene.restart();
                }
            });
        });
        this._putToSleepButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "put_to_sleep_button", false).setAlpha(buttonAlpha).setDisabled(!buttonsEnabled);
        this._putToSleepButton.onClick().subscribe((pointer)=>{
            (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().performAction($9f269383f50e2ffc$var$blobActions.putToSleep).then((res)=>{
                if (res.success) {
                    (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().setBlobInfo(res.blob);
                    this.scene.restart();
                }
            });
        });
        this._petButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "pet_button", false).setAlpha(buttonAlpha).setDisabled(!buttonsEnabled);
        this._petButton.onClick().subscribe((pointer)=>{
            (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().performAction($9f269383f50e2ffc$var$blobActions.pet).then((res)=>{
                if (res.success) {
                    (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().setBlobInfo(res.blob);
                    this.scene.restart();
                }
            });
        });
        this._buttonPane.add(this.add.existing(this._giveFoodButton), {
            key: "give_food_button"
        });
        this._buttonPane.add(this.add.existing(this._giveMedicineButton), {
            key: "give_medication_button"
        });
        this._buttonPane.add(this.add.existing(this._putToSleepButton), {
            key: "put_to_sleep_button"
        });
        this._buttonPane.add(this.add.existing(this._petButton), {
            key: "pet_button"
        });
        this._buttonPane.layout();
    }
    createBlobStat(labelText, progressValue, maxValue) {
        var sizer = this.rexUI.add.overlapSizer(0, 0, {
            width: $9f269383f50e2ffc$var$statLabelWidth,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", `${labelText.toUpperCase()}`, $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            key: `${labelText}_label`,
            align: "left-top",
            expand: false
        });
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", `${$9f269383f50e2ffc$var$HUD_DISABLED ? 0 : progressValue} / ${$9f269383f50e2ffc$var$HUD_DISABLED ? 0 : maxValue}`, $9f269383f50e2ffc$var$whiteTextConfig.smallSize, 0), {
            key: `${labelText}_value`,
            align: "right-top",
            expand: false
        });
        return sizer.layout();
    }
    createLevelLabel(level) {
        var sizer = this.rexUI.add.overlapSizer(0, 0, {
            width: $9f269383f50e2ffc$var$statLabelWidth,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "LEVEL", $9f269383f50e2ffc$var$grayTextConfig.size, 0).setTint($9f269383f50e2ffc$var$grayTextConfig.color), {
            key: `level_label`,
            align: "left-top",
            expand: false
        });
        sizer.add(this.add.image(0, 0, "blob_hud_image"), {
            key: `blob_level_image`,
            align: "right-top",
            expand: false
        });
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", `${level}`, $9f269383f50e2ffc$var$whiteTextConfig.largeSize, 0), {
            key: `level_value`,
            align: "left-bottom",
            expand: false
        });
        return sizer.layout();
    }
}











const $4906a209a707dd47$var$grayProgressBarColor = 0xb48dc7;
const $4906a209a707dd47$var$progressBarAlpha = 0.4;
const $4906a209a707dd47$var$glareColor = 0xffffff;
const $4906a209a707dd47$var$glareAlpha = 0.17;
const $4906a209a707dd47$var$glareRadius = 3;
const $4906a209a707dd47$var$glareHeight = 6;
const $4906a209a707dd47$var$glareOffset = 10;
const $4906a209a707dd47$var$backgroundColor = 0x262637;
const $4906a209a707dd47$var$backgroundAlpha = 1;
const $4906a209a707dd47$var$radius = 7;
const $4906a209a707dd47$var$progressBarHeight = 22;
const $4906a209a707dd47$var$levelBarWidth = 492;
const $4906a209a707dd47$var$grayTextColor = 0x75758B;
const $4906a209a707dd47$var$paneWidth = 566;
class $4906a209a707dd47$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        const conf = config ? config : {
            width: $4906a209a707dd47$var$paneWidth * paneScale,
            space: {
                left: 32,
                right: 19,
                top: 31,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._blobInfo = (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfoSync();
        this.createComponent(scene);
    }
    createComponent(scene) {
        const blobInfo = (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfoSync();
        this._upgradeOptions = [
            {
                key: "defense_per_hour",
                titleText: "Defense Per Hour",
                description: "Your Blob will add to your defensive HP during an attack on your Homebase.",
                iconImageKey: "lock_icon",
                progressMin: 0,
                progressMax: 500,
                progressValue: blobInfo.defense_per_hour,
                isAddDisabled: blobInfo.unapplied_points === 0,
                isRemoveDisabled: blobInfo.defense_per_hour_points === 0
            },
            {
                key: "machine_multiplier",
                titleText: "Machine Multiplier",
                description: "Your Blob will use its secret, mysterious powers to boost the HP of all of your Homebase's machines.",
                iconImageKey: "battery_icon",
                progressMin: 1,
                progressMax: 2,
                progressValue: blobInfo.machine_multiplier,
                isAddDisabled: blobInfo.unapplied_points === 0,
                isRemoveDisabled: blobInfo.machine_multiplier_points === 0
            }
        ];
        this.add(this.createTable(scene, this._upgradeOptions, 0, 0, this._scale).layout(), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: `options_table`
        });
        this.layout();
    }
    createTable(scene, data, x, y, paneScale) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: scene.applyScale($4906a209a707dd47$var$paneWidth - 51),
            height: scene.applyScale(552),
            items: data,
            table: {
                cellWidth: scene.applyScale($4906a209a707dd47$var$paneWidth - 51),
                cellHeight: scene.applyScale(276),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                scrollMode: 0,
                mask: {
                    padding: 0
                }
            },
            space: {},
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var sizer = scene.rexUI.add.fixWidthSizer({
                    x: 0,
                    y: 0,
                    width: scene.applyScale($4906a209a707dd47$var$paneWidth - 51),
                    align: 0
                }).setOrigin(0, 0);
                // Title Text
                sizer.add(scene.add.bitmapText(0, 0, "cc_outline", item.titleText.toUpperCase(), scene.applyScale(22), 0).setOrigin(0), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    },
                    key: `${item.key}_title_text`
                }).addNewLine();
                // Description
                sizer.add(scene.add.bitmapText(0, 0, "cc_outline", item.description, scene.applyScale(22), 0).setOrigin(0).setMaxWidth(scene.applyScale($4906a209a707dd47$var$paneWidth - 60)).setTint($4906a209a707dd47$var$grayTextColor), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: scene.applyScale(9),
                        bottom: 0
                    },
                    key: `${item.key}_desc_text`
                }).addNewLine();
                // ProgressBar
                const pointsProgressBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, scene.getScale(), {
                    rtl: false,
                    title: {
                        text: undefined,
                        fontStyle: undefined
                    },
                    icon: {
                        key: item.iconImageKey,
                        space: 8,
                        scale: 1
                    },
                    progressBar: {
                        text: item.progressValue,
                        fontStyle: undefined,
                        width: $4906a209a707dd47$var$levelBarWidth,
                        height: $4906a209a707dd47$var$progressBarHeight,
                        radius: $4906a209a707dd47$var$radius,
                        color: $4906a209a707dd47$var$grayProgressBarColor,
                        alpha: $4906a209a707dd47$var$progressBarAlpha,
                        backgroundColor: $4906a209a707dd47$var$backgroundColor,
                        backgroundAlpha: $4906a209a707dd47$var$backgroundAlpha,
                        minValue: item.progressMin,
                        maxValue: item.progressMax,
                        progressValue: item.progressValue,
                        glare: {
                            height: $4906a209a707dd47$var$glareHeight,
                            width: $4906a209a707dd47$var$levelBarWidth - $4906a209a707dd47$var$glareOffset,
                            radius: $4906a209a707dd47$var$glareRadius,
                            color: $4906a209a707dd47$var$glareColor,
                            alpha: $4906a209a707dd47$var$glareAlpha
                        }
                    }
                });
                sizer.add(scene.add.existing(pointsProgressBar), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: scene.applyScale(16),
                        bottom: 0
                    },
                    key: `${item.key}_desc_text`
                });
                // Buttons
                const addPointsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "add_points_button", false).setScale(scene.getScale()).setAlpha(item.isAddDisabled ? 0.6 : 1).setDisabled(item.isAddDisabled);
                addPointsButton.onClick().subscribe((pointer)=>{});
                sizer.add(scene.add.existing(addPointsButton), {
                    padding: {
                        left: 0,
                        right: scene.applyScale(10),
                        top: scene.applyScale(20),
                        bottom: 0
                    },
                    key: `${item.key}_add_points_button`
                });
                const removePointsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "remove_points_button", false).setScale(scene.getScale()).setAlpha(item.isRemoveDisabled ? 0.6 : 1).setDisabled(item.isRemoveDisabled);
                removePointsButton.onClick().subscribe((pointer)=>{});
                sizer.add(scene.add.existing(removePointsButton), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: scene.applyScale(20),
                        bottom: 0
                    },
                    key: `${item.key}_remove_points_button`
                });
                if (index < data.length - 1) sizer.add(scene.add.image(0, 0, "blob_option_divider_line"), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: scene.applyScale(30),
                        bottom: 0
                    },
                    key: `${item.key}_divider`
                });
                return sizer.layout();
            }
        });
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("upgradeBlobContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $4906a209a707dd47$export$2e2bcd8739ae039(this.scene, x, y));
});



const $5af88f7c0345b8ef$var$modalHeight = 642;
const $5af88f7c0345b8ef$var$modalWidth = 814;
const $5af88f7c0345b8ef$var$modalRadius = 25;
const $5af88f7c0345b8ef$var$modalColor = 0x1c1c2c;
const $5af88f7c0345b8ef$var$modalAlpha = 1;
const $5af88f7c0345b8ef$var$spineWidth = 248;
const $5af88f7c0345b8ef$var$spineColor = 0xe6e6ff;
const $5af88f7c0345b8ef$var$spineAlpha = 0.05;
const $5af88f7c0345b8ef$var$grayTextColor = 0x75758B;
class $5af88f7c0345b8ef$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "UpgradeBlobModalScene"
        });
    }
    preload() {
        this.load.image("add_points_button", (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845).add_points_button);
        this.load.image("remove_points_button", (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845).remove_points_button);
        this.load.image("blob_option_divider_line", (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845).blob_option_divider_line);
        this.load.image("lock_icon", (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845).lock_icon);
        this.load.image("battery_icon", (0, $1aa2c39fc1fbb95e$export$457b77cfbc171845).battery_icon);
    }
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($5af88f7c0345b8ef$var$modalWidth, $5af88f7c0345b8ef$var$modalHeight);
        this._blobInfo = (0, $eabaecde5116ddd1$export$2e2bcd8739ae039).getInstance().getBlobInfoSync();
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($5af88f7c0345b8ef$var$modalWidth), this.applyScale($5af88f7c0345b8ef$var$modalHeight), this.applyScale($5af88f7c0345b8ef$var$modalRadius), $5af88f7c0345b8ef$var$modalColor, $5af88f7c0345b8ef$var$modalAlpha);
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($5af88f7c0345b8ef$var$spineWidth), this.applyScale($5af88f7c0345b8ef$var$modalHeight), {
            tl: this.applyScale($5af88f7c0345b8ef$var$modalRadius),
            tr: 0,
            bl: this.applyScale($5af88f7c0345b8ef$var$modalRadius),
            br: 0
        }, $5af88f7c0345b8ef$var$spineColor, $5af88f7c0345b8ef$var$spineAlpha);
        // Title text
        const titleText = this.add.bitmapText(0, 0, "cc_outline", "UPGRADE BLOB", this.applyScale(22), 0).setOrigin(0);
        // Available Points
        const availablePointsText = this.add.bitmapText(0, 0, "cc_outline", "AVAILABLE POINTS", this.applyScale(20), 0).setOrigin(0).setTint($5af88f7c0345b8ef$var$grayTextColor);
        const apValue = this.add.bitmapText(0, 0, "cc_outline", this._blobInfo.unapplied_points, this.applyScale(28), 0).setOrigin(0);
        // Confirm Button
        this._confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "squad_confirm_button", false).setScale(this._scale);
        this.add.existing(this._confirmButton);
        this._confirmButton.onClick().subscribe((pointer)=>{
            this.confirmButtonClickHandler(pointer);
        });
        this._upgradeBlobContentPane = new (0, $4906a209a707dd47$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
        this.add.existing(this._upgradeBlobContentPane);
        sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        sizer.add(spineBackground, {
            key: "spineBackground",
            align: "center",
            offsetX: this.applyScale(-($5af88f7c0345b8ef$var$modalWidth / 2 - $5af88f7c0345b8ef$var$spineWidth / 2)),
            offsetY: 0,
            expand: false
        });
        sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(18),
            offsetY: this.applyScale(31),
            expand: false
        });
        sizer.add(availablePointsText, {
            key: "apText",
            align: "left-top",
            offsetX: this.applyScale(18),
            offsetY: this.applyScale(468),
            expand: false
        });
        sizer.add(apValue, {
            key: "apValue",
            align: "left-top",
            offsetX: this.applyScale(18),
            offsetY: this.applyScale(494),
            expand: false
        });
        sizer.add(this._confirmButton, {
            key: "confirmButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        sizer.add(this._upgradeBlobContentPane, {
            key: "blob-content-pane",
            align: "left-top",
            offsetX: this.applyScale(248),
            offsetY: this.applyScale(0),
            expand: false
        });
        sizer.layout();
        sizer.onClickOutside(()=>{
            this.scene.resume("HomebaseScene");
            this.scene.resume("BlobHudScene");
            this.scene.stop();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    getContentPane() {
        return this._upgradeBlobContentPane;
    }
    destroy() {}
    confirmButtonClickHandler(pointer) {
        this.scene.resume("HomebaseScene");
        this.scene.resume("BlobHudScene");
        this.scene.stop();
    }
}






const $41f54d2a7fc2451d$var$modalHeight = 360;
const $41f54d2a7fc2451d$var$modalWidth = 560;
const $41f54d2a7fc2451d$var$modalRadius = 25;
const $41f54d2a7fc2451d$var$modalColor = 0x350926;
const $41f54d2a7fc2451d$var$modalAlpha = 1;
const $41f54d2a7fc2451d$var$modalBorderColor = 0x3d4361;
const $41f54d2a7fc2451d$var$modalBorderWidth = 1;
const $41f54d2a7fc2451d$var$componentRadius = 16;
const $41f54d2a7fc2451d$var$subtitleTint = 0x75758B;
const $41f54d2a7fc2451d$var$messageColor = 0xffffff;
const $41f54d2a7fc2451d$var$cancelButtonImage = "reward_cancel_button";
const $41f54d2a7fc2451d$var$inputTextWidth = 460;
const $41f54d2a7fc2451d$var$inputTextHeight = 50;
class $41f54d2a7fc2451d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._item = data.item;
    }
    constructor(){
        super({
            key: "ShopDiscordScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($41f54d2a7fc2451d$var$modalWidth, $41f54d2a7fc2451d$var$modalHeight + 50); // 50 accounts for button extending beyond modal box
    }
    preload() {}
    create() {
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($41f54d2a7fc2451d$var$modalWidth), this.applyScale($41f54d2a7fc2451d$var$modalHeight), this.applyScale($41f54d2a7fc2451d$var$modalRadius), $41f54d2a7fc2451d$var$modalColor, $41f54d2a7fc2451d$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($41f54d2a7fc2451d$var$modalBorderWidth), $41f54d2a7fc2451d$var$modalBorderColor, $41f54d2a7fc2451d$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - this.applyScale(0), {
            width: this.applyScale(760),
            height: this.applyScale(300),
            space: {
                left: 0,
                right: 0,
                top: this.applyScale(15),
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), this.applyScale(28), 1).setMaxWidth(400), {
            key: "title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(15),
            expand: false
        });
        // Discord Username Input Text
        const inputTextConfig = {
            x: 0,
            y: 0,
            width: undefined,
            height: undefined,
            type: "textarea",
            id: undefined,
            text: undefined,
            maxLength: 42,
            minLength: undefined,
            placeholder: "Enter Discord Username",
            tooltip: undefined,
            readOnly: false,
            spellCheck: false,
            autoComplete: "off",
            align: "center",
            paddingLeft: undefined,
            paddingRight: undefined,
            paddingTop: `${this.applyScale(9)}px`,
            paddingBottom: undefined,
            fontFamily: "ccwhatchamacallitbold",
            fontSize: `${this.applyScale(22)}px`,
            color: "#ffffff",
            border: `${this.applyScale(2)}px solid #383D57`,
            backgroundColor: "#440D31",
            borderColor: "#383D57",
            outline: "none",
            direction: "ltr",
            selectAll: false
        };
        this._inputText = this.add.rexInputText(0, 0, this.applyScale($41f54d2a7fc2451d$var$inputTextWidth), this.applyScale($41f54d2a7fc2451d$var$inputTextHeight), inputTextConfig);
        this._discordUsername = this._inputText.text;
        this._inputText.on("textchange", (inputText, e)=>{
            this._discordUsername = inputText.text;
            this._confirmButton.setDisabled(inputText.text === "");
        }, this);
        sizer.add(this._inputText, {
            key: "input_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(175),
            expand: false
        });
        sizer.layout();
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(119), modalBg.getBottomLeft().y, "cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.scene.resume("ShopModalScene");
            this.scene.stop();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        this._confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(80), modalBg.getBottomLeft().y, "name_btn_enabled", false).setScale(this._scale).setDisabledTexture("name_btn_disabled").setDisabled(true);
        this._confirmButton.onClick().subscribe((pointer)=>{
            (0, $2f4abd45cd58d712$export$2e2bcd8739ae039).getInstance().purchaseOther(this._item.shop_item_id, {
                discord_id: this._discordUsername
            }).then((res)=>{
                this.scene.start("ShopPurchaseResultScene", {
                    purchaseResult: res,
                    item: this._item
                });
            });
        });
        this.add.existing(this._confirmButton);
    }
    getTitleText() {
        return `Please enter your discord username to purchase the ${this.getDisplayName()}.`;
    }
    getDisplayName() {
        if (this._item.type === "whitelist") return this._item.name.slice(-2) === "WL" ? this._item.name : `${this._item.name} WL`;
        else return this._item.name;
    }
    applyScale(length) {
        return length * this._scale;
    }
}













const $70e54a6d23704007$var$modalWidth = 1004;
const $70e54a6d23704007$var$modalHeight = 735;
const $70e54a6d23704007$var$modalRadius = 16;
const $70e54a6d23704007$var$modalColor = 0x1c1c2c;
const $70e54a6d23704007$var$modalAlpha = 1;
const $70e54a6d23704007$var$subtitleTint = 0xa3a3b9;
const $70e54a6d23704007$var$starLabMachineId = 1007;
const $70e54a6d23704007$var$starLabMultipliers = [
    0,
    1.5,
    3,
    4.5,
    6,
    7.5,
    10
];
// Progress bar consts
const $70e54a6d23704007$var$goldProgressBarColor = 0xdea827;
const $70e54a6d23704007$var$goldPreviewBarColor = 0xffd369;
const $70e54a6d23704007$var$pinkProgressBarColor = 0xde2795;
const $70e54a6d23704007$var$pinkPreviewBarColoar = 0xf567a8;
const $70e54a6d23704007$var$blueProgressBarColor = 0x00a6d3;
const $70e54a6d23704007$var$bluePreviewBarColor = 0x00e1d3;
const $70e54a6d23704007$var$hpProgressBarColor = 0x9a9a9a;
const $70e54a6d23704007$var$hpPreviewBarColor = 0xc2c2c2;
const $70e54a6d23704007$var$dpsProgressBarColor = 0xbe5b5b;
const $70e54a6d23704007$var$dpsPreviewBarColor = 0xda8c8c;
const $70e54a6d23704007$var$progressBarAlpha = 1;
const $70e54a6d23704007$var$glareColor = 0xffffff;
const $70e54a6d23704007$var$glareAlpha = 0.17;
const $70e54a6d23704007$var$glareRadius = 3;
const $70e54a6d23704007$var$glareHeight = 6;
const $70e54a6d23704007$var$glareOffset = 10;
const $70e54a6d23704007$var$backgroundColor = 0xb48dc7;
const $70e54a6d23704007$var$backgroundAlpha = 0.4;
const $70e54a6d23704007$var$radius = 7;
const $70e54a6d23704007$var$progressBarHeight = 22;
const $70e54a6d23704007$var$stardustBarWidth = 572;
const $70e54a6d23704007$var$neonGoldBarWidth = 572;
const $70e54a6d23704007$var$spaceElixirBarWidth = 572;
const $70e54a6d23704007$var$shortBarWidth = 162;
const $70e54a6d23704007$var$shortBarSpace = 41;
const $70e54a6d23704007$var$halfBarWidth = 286;
const $70e54a6d23704007$var$stardustMin = 0;
const $70e54a6d23704007$var$neonGoldMin = 0;
const $70e54a6d23704007$var$spaceElixirMin = 0;
const $70e54a6d23704007$var$upgradeBoxWidth = 923;
const $70e54a6d23704007$var$upgradeBoxHeight = 67;
const $70e54a6d23704007$var$upgradeBoxRadius = 12;
const $70e54a6d23704007$var$upgradeBoxColor = 0x34344c;
const $70e54a6d23704007$var$upgradeBoxAlpha = 1;
const $70e54a6d23704007$var$closeButtonImageKey = "machine_info_close_button";
const $70e54a6d23704007$var$upgradeButtonImageKey = "machine_info_upgrade_button";
const $70e54a6d23704007$var$speedUpButtonImageKey = "machine_info_speed_up_button";
const $70e54a6d23704007$var$textHighlightColor = 0x00ffb2;
class $70e54a6d23704007$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, item, paneScale, config){
        let conf = config ? config : {
            width: $70e54a6d23704007$var$modalWidth * paneScale,
            height: $70e54a6d23704007$var$modalHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._item = item;
        this._hasYield = item.produce_per_hour_neon_gold > 0 || item.produce_per_hour_space_elixir > 0 || item.produce_per_hour_stardust > 0;
        this._hasStorage = item.storage_neon_gold > 0 || item.storage_space_elixir > 0;
        this._hasHP = true;
        this._hasDPS = item.dps && item.dps > 0 ? true : false;
        this._hasTroopCapacity = item.machine_id === 1034; // 1034 = Cadet Dorms
        this._showAdditionalBoosts = true;
        this._isMaxLevel = !item.next_level_build_total_time || item.next_level_build_total_time <= 0;
        this._isUpgrading = item.time_until_next_level > 0;
        this._isActive = this._item.time_until_inactive > 0;
        console.log((0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(item));
        // Close Button
        this._closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, $70e54a6d23704007$var$closeButtonImageKey, false).setScale(this._scale);
        this.scene.add.existing(this._closeButton);
        this._closeButton.onClick().subscribe((pointer)=>{
            this.closeButtonHandler();
        });
        this.add(this._closeButton, {
            key: "machine_info_close_button",
            align: "right-top",
            offsetX: this.applyScale(-21),
            offsetY: this.applyScale(15),
            expand: false
        });
        // Upper Divider
        const upperDivider = this.scene.add.image(0, 0, "machine_item_info_divider_long").setScale(this._scale);
        this.add(upperDivider, {
            key: "upper_divider",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(73),
            expand: false
        });
        // Item Component
        this._item.shopImageKey = `shop_machines_${this._item.key}`;
        this._itemComponent = new (0, $0f6d56d1311b06e9$export$2e2bcd8739ae039)(scene, 0, 0, this._item, scene.getScale(), false);
        scene.add.existing(this._itemComponent);
        if (this._itemComponent) this.add(this._itemComponent, {
            key: "machine_info_item_component",
            align: "left-top",
            offsetX: this.applyScale(38),
            offsetY: this.applyScale(102),
            expand: false
        });
        // Item Title
        this._itemTitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), this.applyScale(28), 0).setCharacterTint(-10, -1, false, $70e54a6d23704007$var$subtitleTint);
        this.add(this._itemTitle, {
            key: "item_title",
            align: "left-top",
            offsetX: this.applyScale(48),
            offsetY: this.applyScale(23),
            expand: false
        });
        // Cost Subtitle
        this._costSubtitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getCostSubtitle(), this.applyScale(16), 0);
        this._costSubtitle.setTint($70e54a6d23704007$var$subtitleTint);
        this.add(this._costSubtitle, {
            key: "cost_subtitle",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(108),
            expand: false
        });
        //Cost Progress Bar(s)
        this.addCostProgressBars();
        // Upgrade Time Subtitle
        this._upgradeTimeSubtitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Next upgrade build time", this.applyScale(16), 0);
        this._upgradeTimeSubtitle.setTint($70e54a6d23704007$var$subtitleTint);
        this.add(this._upgradeTimeSubtitle, {
            key: "upgrade_time_subtitle",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(189),
            expand: false
        });
        this.addUpgradeTimeProgressBar();
        // Middle Divider
        const middleDivider = this.scene.add.image(0, 0, "machine_item_info_divider_short").setScale(this._scale);
        this.add(middleDivider, {
            key: "middle_divider",
            align: "left-top",
            offsetX: this.applyScale(288),
            offsetY: this.applyScale(282),
            expand: false
        });
        // Fixed width sizer for dynamic content
        this._dynamicSizer = this.scene.rexUI.add.fixWidthSizer(0, 0, {
            x: 0,
            y: 0,
            width: this.applyScale($70e54a6d23704007$var$modalWidth - 300),
            height: this.applyScale(320),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        if (this._hasYield) {
            // Yield Title
            this._yieldTitle = this.scene.add.bitmapText(0, 0, "cc_outline", this.getYieldText(), this.applyScale(16), 0);
            this._yieldTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(this._yieldTitle, {
                key: "yield_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Yield progress bar
            this.addYieldProgressBar();
        }
        if (this._hasStorage) {
            // Storage Title
            this._storageTitle = this.scene.add.bitmapText(0, 0, "cc_outline", `Storage${this._isMaxLevel ? "" : " (& Upgrade)"}`, this.applyScale(16), 0);
            this._storageTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(this._storageTitle, {
                key: "storage_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Storage progress bar(s)
            this.addStorageProgressBars();
        }
        if (this._hasYield || this._hasStorage) {
            // Lower Divider
            const lowerDivider = this.scene.add.image(0, 0, "machine_item_info_divider_short").setScale(this._scale);
            this._dynamicSizer.add(lowerDivider, {
                key: "lower_divider",
                padding: {
                    left: this.applyScale(0),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
        }
        if (this._hasHP) {
            // HP Title
            const hpTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "HP", this.applyScale(16), 0);
            hpTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(hpTitle, {
                key: "hp_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // HP Progress Bar
            this.addHpProgressBar();
        }
        if (this._hasDPS) {
            // DPS Title
            const dpsTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Defensive Damage", this.applyScale(16), 0);
            dpsTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(dpsTitle, {
                key: "dps_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // HP Progress Bar
            this.addDpsProgressBar();
        }
        if (this._hasTroopCapacity) {
            // Capacity Title
            const capacityTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Capacity", this.applyScale(16), 0);
            capacityTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(capacityTitle, {
                key: "capacity_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Capacity Progress Bar
            this.addCapacityProgressBar();
        }
        if (this._showAdditionalBoosts) {
            // Additional Boosts Title
            const additionalBoostsTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Additional Boosts", this.applyScale(16), 0);
            additionalBoostsTitle.setTint($70e54a6d23704007$var$subtitleTint);
            this._dynamicSizer.add(additionalBoostsTitle, {
                key: "additional_boosts_title",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(20),
                    bottom: 0
                }
            });
            // Additional Boosts Text
            this.addAdditionalBoosts();
        }
        // Add dynamic sizer to parent sizer
        this.add(this._dynamicSizer.layout(), {
            key: "dynamic_sizer",
            align: "left-top",
            offsetX: this.applyScale(288),
            offsetY: this.applyScale(283),
            expand: false
        });
        // Description Title
        this._descriptionTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "Description", this.applyScale(16), 0);
        this._descriptionTitle.setTint($70e54a6d23704007$var$subtitleTint);
        this.add(this._descriptionTitle, {
            key: "description_title",
            align: "left-top",
            offsetX: this.applyScale(45),
            offsetY: this.applyScale(484),
            expand: false
        });
        // Description Text Area
        this._descriptionText = this.scene.rexUI.add.textArea({
            x: 0,
            y: 0,
            width: this.applyScale(244),
            height: this.applyScale(76),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this.getDescription(), this.applyScale(16), 0),
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            scroller: true
        }).layout();
        this._descriptionText.setText(this.getDescription());
        this.add(this._descriptionText, {
            key: "description_text",
            align: "left-top",
            offsetX: this.applyScale(45),
            offsetY: this.applyScale(512),
            expand: false
        });
        // Upgrade box bg
        const upgradeBg = this.scene.add.rexRoundRectangle(0, 0, this.applyScale($70e54a6d23704007$var$upgradeBoxWidth), this.applyScale($70e54a6d23704007$var$upgradeBoxHeight), this.applyScale($70e54a6d23704007$var$upgradeBoxRadius), $70e54a6d23704007$var$upgradeBoxColor, $70e54a6d23704007$var$upgradeBoxAlpha);
        this.add(upgradeBg, {
            key: "upgrade_bg",
            align: "center-bottom",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(-33),
            expand: false
        });
        // Upgrade message
        this._upgradeMessage = this.scene.add.bitmapText(0, 0, "cc_outline", this.getUpgradeMessage(), this.applyScale(16), 0);
        this.add(this._upgradeMessage, {
            key: "upgrade_message",
            align: "left-bottom",
            offsetX: this.applyScale(68),
            offsetY: this.applyScale(-57),
            expand: false
        });
        // Upgrade/Speed Up Button
        if (this._isUpgrading) {
            this._speedUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, $70e54a6d23704007$var$speedUpButtonImageKey, false).setScale(scene.getScale());
            scene.add.existing(this._speedUpButton);
            this._speedUpButton.onClick().subscribe((pointer)=>{
                this._speedUpButton.setDisabled(true);
                (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachines(true).then((res)=>{
                    var machine = res.find((mach)=>{
                        return mach.user_machine_id === this._item.user_machine_id;
                    });
                    this.scene.scene.start("MachineSpeedUpModalScene", {
                        machine: machine || this._item
                    });
                });
            });
            this.add(this._speedUpButton, {
                key: "speed_up_button",
                align: "right-bottom",
                offsetX: this.applyScale(-56),
                offsetY: this.applyScale(-43),
                expand: false
            });
        } else {
            this._upgradeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, $70e54a6d23704007$var$upgradeButtonImageKey, false).setScale(scene.getScale());
            scene.add.existing(this._upgradeButton);
            if (this._isMaxLevel || this._isUpgrading || this._isActive) {
                this._upgradeButton.setDisabled(true);
                this._upgradeButton.setAlpha(0.5);
            } else this._upgradeButton.onClick().subscribe((pointer)=>{
                this._upgradeButton.setDisabled(true);
                this.scene.scene.start("ShopPurchaseConfirmScene", {
                    item: this._item,
                    isUpgrade: true
                });
            });
            this.add(this._upgradeButton, {
                key: "upgrade_button",
                align: "right-bottom",
                offsetX: this.applyScale(-56),
                offsetY: this.applyScale(-44),
                expand: false
            });
        }
        return this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
        this._closeButton.setAlpha(0);
        this._itemComponent.setAlpha(0);
    //this.table.disableInteractive();
    }
    closeButtonHandler() {
        this.scene.unloadAssets();
        this.scene.scene.resume("HudScene");
        this.scene.scene.get("HomebaseScene").input.enabled = true;
        this.scene.scene.stop();
    }
    getDisplayName() {
        return `${this._item.display_name || "Unknown Item"} (Level ${this._item.level})`;
    }
    getCostSubtitle() {
        return "Cost to upgrade";
    }
    getDescription() {
        return this._item.description;
    }
    getYieldText() {
        return this._item.machine_id === $70e54a6d23704007$var$starLabMachineId ? `Speed Boost${this._isMaxLevel ? "" : " (& Upgrade)"}` : `Yield per hour${this._isMaxLevel ? "" : " (& Upgrade)"}`;
    }
    getUpgradeMessage() {
        if (this._isMaxLevel) return `This machine is at its maximum level.`;
        if (this._isUpgrading) return "This machine is currently being upgraded...";
        if (this._isActive) return "This machine is currently active...";
        if (this._item.key === "mainframe") return `You will need a Level ${this._item.level} Mainframe for this upgrade.`;
        console.log(this._item.next_level_barracks_level_requirement);
        if (this._item.next_level_barracks_level_requirement > 0) return `You will need a Level ${this._item.next_level_barracks_level_requirement} Barracks for this purchase.`;
        else return `You will need a Level ${this._item.next_level_mainframe_level_required} Mainframe for this purchase.`;
    }
    getStarLabMultiplier() {
        return $70e54a6d23704007$var$starLabMultipliers[parseInt(this._item.level)];
    }
    addAdditionalBoosts() {
        const textArea = this.scene.rexUI.add.textArea({
            x: 0,
            y: 0,
            width: this.applyScale($70e54a6d23704007$var$neonGoldBarWidth),
            height: this.applyScale(38),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this.getDescription(), this.applyScale(16), 0),
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            scroller: true
        }).layout();
        const boost = this.getAdditionalBoosts();
        textArea.setText(boost.upgradeText);
        if (boost.highlightStartIndex) textArea.getElement("text").setCharacterTint(boost.highlightStartIndex, boost.highlightLength, true, $70e54a6d23704007$var$textHighlightColor);
        this._dynamicSizer.add(textArea, {
            key: "boosts_text_area",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    getAdditionalBoosts() {
        return (0, $e197c18c77ea506c$export$2e2bcd8739ae039).getInstance().getMachineBoosts(this._item);
    }
    addUpgradeTimeProgressBar() {
        const timeProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "time_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this._isMaxLevel ? "N/A" : this.secondsToTime(this._item.next_level_build_total_time),
                fontStyle: null,
                fontSize: undefined,
                width: $70e54a6d23704007$var$neonGoldBarWidth,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$goldProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: 0,
                maxValue: 100,
                progressValue: 0,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: $70e54a6d23704007$var$neonGoldBarWidth - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
        this.add(timeProgBar, {
            key: "time_prog_bar",
            align: "left-top",
            offsetX: this.applyScale(365),
            offsetY: this.applyScale(212),
            expand: false
        });
    }
    addCostProgressBars() {
        const spaceElixirCost = this.getSpaceElixirCost();
        const neonGoldCost = this.getNeonGoldCost();
        const stardustCost = this.getStardustCost();
        var resourceCount = 0;
        if (spaceElixirCost > 0) resourceCount++;
        if (neonGoldCost > 0) resourceCount++;
        if (stardustCost > 0) resourceCount++;
        if (resourceCount > 1 || this._isMaxLevel && this._item.key === "mainframe") {
            //Draw all three progress bars
            const starBar = this.createStardustBar(stardustCost, stardustCost > 0 ? stardustCost : 1, $70e54a6d23704007$var$shortBarWidth + 3, false, 16);
            const spaceBar = this.createSpaceElixirBar(spaceElixirCost, spaceElixirCost > 0 ? spaceElixirCost : 1, $70e54a6d23704007$var$shortBarWidth, false, 16);
            const neonBar = this.createNeonGoldBar(neonGoldCost, neonGoldCost > 0 ? neonGoldCost : 1, $70e54a6d23704007$var$shortBarWidth, false, 16);
            this.scene.add.existing(starBar);
            this.scene.add.existing(spaceBar);
            this.scene.add.existing(neonBar);
            this.add(spaceBar, {
                key: "space_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365),
                offsetY: this.applyScale(133),
                expand: false
            }).add(neonBar, {
                key: "neon_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365 + $70e54a6d23704007$var$shortBarWidth + $70e54a6d23704007$var$shortBarSpace),
                offsetY: this.applyScale(133),
                expand: false
            }).add(starBar, {
                key: "star_cost_bar",
                align: "left-top",
                offsetX: this.applyScale(365 + $70e54a6d23704007$var$shortBarWidth * 2 + $70e54a6d23704007$var$shortBarSpace * 2),
                offsetY: this.applyScale(131),
                expand: false
            });
            if (this._isMaxLevel) {
                spaceBar.setProgressBarText("N/A");
                neonBar.setProgressBarText("N/A");
                starBar.setProgressBarText("N/A");
            }
        } else {
            var costProgBar;
            //Draw only one progress bar
            if (stardustCost > 0) costProgBar = this.createStardustBar(this._item.cost_stardust, this._item.cost_stardust, $70e54a6d23704007$var$stardustBarWidth);
            else if (neonGoldCost > 0) costProgBar = this.createNeonGoldBar(this._item.cost_neon_gold, this._item.cost_neon_gold, $70e54a6d23704007$var$neonGoldBarWidth);
            else if (spaceElixirCost > 0) costProgBar = this.createSpaceElixirBar(this._item.cost_space_elixir, this._item.cost_space_elixir, $70e54a6d23704007$var$spaceElixirBarWidth);
            else // Machine level is maxed out
            costProgBar = this.createNeonGoldBar(neonGoldCost, neonGoldCost > 0 ? neonGoldCost : 1, $70e54a6d23704007$var$neonGoldBarWidth);
            if (this._isMaxLevel) costProgBar.setProgressBarText("N/A");
            this.scene.add.existing(costProgBar);
            this.add(costProgBar, {
                key: "cost_prog_bar",
                align: "left-top",
                offsetX: this.applyScale(365),
                offsetY: this.applyScale(133),
                expand: false
            });
        }
    }
    addYieldProgressBar() {
        const spaceElixirYield = this._item.produce_per_hour_space_elixir;
        const neonGoldYield = this._item.produce_per_hour_neon_gold;
        const stardustYield = this._item.produce_per_hour_stardust;
        var resourceCount = 0;
        if (spaceElixirYield > 0) resourceCount++;
        if (neonGoldYield > 0) resourceCount++;
        if (stardustYield > 0) resourceCount++;
        if (resourceCount > 1) {
            //Draw both progress bars
            const mainBar = spaceElixirYield > 0 ? this.createSpaceElixirBar(this._isMaxLevel ? spaceElixirYield : 7, this._isMaxLevel ? spaceElixirYield : 10, $70e54a6d23704007$var$spaceElixirBarWidth, !this._isMaxLevel, undefined) : this.createNeonGoldBar(this._isMaxLevel ? neonGoldYield : 7, this._isMaxLevel ? neonGoldYield : 10, $70e54a6d23704007$var$neonGoldBarWidth, !this._isMaxLevel, undefined);
            const sdBar = this.createStardustBar(this._isMaxLevel ? stardustYield : 7, this._isMaxLevel ? stardustYield : 10, $70e54a6d23704007$var$stardustBarWidth, !this._isMaxLevel, undefined);
            if (!this._isMaxLevel) {
                const mainYield = spaceElixirYield > 0 ? spaceElixirYield : neonGoldYield;
                const mainNextLevelYield = spaceElixirYield > 0 ? this._item.next_level_produce_per_hour_space_elixir : this._item.next_level_produce_per_hour_neon_gold;
                mainBar.setProgressBarText(`${mainYield.toLocaleString("en-us")} (+${(mainNextLevelYield - mainYield).toLocaleString("en-us")} per hour after upgrade)`);
                sdBar.setProgressBarText(`${stardustYield.toLocaleString("en-us")} (+${(this._item.next_level_produce_per_hour_stardust - stardustYield).toLocaleString("en-us")} per hour after upgrade)`);
            }
            this._dynamicSizer.add(mainBar, {
                key: "main_yield_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            }).add(sdBar, {
                key: "stardust_yield_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(14),
                    bottom: 0
                }
            });
        } else {
            var yieldProgBar;
            if (neonGoldYield > 0) {
                yieldProgBar = this.createNeonGoldBar(this._isMaxLevel ? neonGoldYield : 7, this._isMaxLevel ? neonGoldYield : 10, $70e54a6d23704007$var$neonGoldBarWidth, !this._isMaxLevel);
                if (!this._isMaxLevel) yieldProgBar.setProgressBarText(`${neonGoldYield.toLocaleString("en-us")} (+${(this._item.next_level_produce_per_hour_neon_gold - neonGoldYield).toLocaleString("en-us")} per hour after upgrade)`);
            } else if (spaceElixirYield > 0) {
                yieldProgBar = this.createSpaceElixirBar(this._isMaxLevel ? spaceElixirYield : 7, this._isMaxLevel ? spaceElixirYield : 10, $70e54a6d23704007$var$spaceElixirBarWidth, !this._isMaxLevel);
                if (!this._isMaxLevel) yieldProgBar.setProgressBarText(`${spaceElixirYield.toLocaleString("en-us")} (+${(this._item.next_level_produce_per_hour_space_elixir - spaceElixirYield).toLocaleString("en-us")} per hour after upgrade)`);
            } else if (stardustYield > 0) {
                yieldProgBar = this.createStardustBar(this._isMaxLevel ? stardustYield : 7, this._isMaxLevel ? stardustYield : 10, $70e54a6d23704007$var$stardustBarWidth, !this._isMaxLevel);
                if (!this._isMaxLevel) yieldProgBar.setProgressBarText(`${stardustYield.toLocaleString("en-us")} (+${(this._item.next_level_produce_per_hour_stardust - stardustYield).toLocaleString("en-us")} per hour after upgrade)`);
            }
            if (yieldProgBar) {
                this.scene.add.existing(yieldProgBar);
                this._dynamicSizer.add(yieldProgBar, {
                    key: "yield_prog_bar",
                    padding: {
                        left: this.applyScale(77),
                        right: 0,
                        top: this.applyScale(8),
                        bottom: 0
                    }
                });
            }
        }
    }
    addStorageProgressBars() {
        const spaceElixirStorage = this._item.storage_space_elixir;
        const neonGoldStorage = this._item.storage_neon_gold;
        var resourceCount = 0;
        if (spaceElixirStorage > 0) resourceCount++;
        if (neonGoldStorage > 0) resourceCount++;
        if (resourceCount > 1) {
            //Draw both progress bars
            const spaceBar = this.createSpaceElixirBar(this._isMaxLevel ? spaceElixirStorage : 8, this._isMaxLevel ? spaceElixirStorage : 10, $70e54a6d23704007$var$spaceElixirBarWidth, !this._isMaxLevel, undefined);
            const neonBar = this.createNeonGoldBar(this._isMaxLevel ? neonGoldStorage : 8, this._isMaxLevel ? neonGoldStorage : 10, $70e54a6d23704007$var$neonGoldBarWidth, !this._isMaxLevel, undefined);
            if (!this._isMaxLevel) {
                spaceBar.setProgressBarText(`${spaceElixirStorage.toLocaleString("en-us")} (+${(this._item.next_level_storage_space_elixir - spaceElixirStorage).toLocaleString("en-us")} after upgrade)`);
                neonBar.setProgressBarText(`${neonGoldStorage.toLocaleString("en-us")} (+${(this._item.next_level_storage_neon_gold - neonGoldStorage).toLocaleString("en-us")} after upgrade)`);
            }
            this.scene.add.existing(spaceBar);
            this.scene.add.existing(neonBar);
            this._dynamicSizer.add(spaceBar, {
                key: "space_storage_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            }).add(neonBar, {
                key: "neon_storage_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(14),
                    bottom: 0
                }
            });
        } else {
            var storageProgBar;
            //Draw only one progress bar
            if (neonGoldStorage > 0) {
                storageProgBar = this.createNeonGoldBar(this._isMaxLevel ? neonGoldStorage : 7, this._isMaxLevel ? neonGoldStorage : 10, $70e54a6d23704007$var$neonGoldBarWidth, !this._isMaxLevel);
                if (!this._isMaxLevel) storageProgBar.setProgressBarText(`${neonGoldStorage.toLocaleString("en-us")} (+${(this._item.next_level_storage_neon_gold - neonGoldStorage).toLocaleString("en-us")} after upgrade)`);
            } else if (spaceElixirStorage > 0) {
                storageProgBar = this.createSpaceElixirBar(this._isMaxLevel ? spaceElixirStorage : 7, this._isMaxLevel ? spaceElixirStorage : 10, $70e54a6d23704007$var$spaceElixirBarWidth, !this._isMaxLevel);
                if (!this._isMaxLevel) storageProgBar.setProgressBarText(`${spaceElixirStorage.toLocaleString("en-us")} (+${(this._item.next_level_storage_space_elixir - spaceElixirStorage).toLocaleString("en-us")} after upgrade)`);
            }
            this.scene.add.existing(storageProgBar);
            this._dynamicSizer.add(storageProgBar, {
                key: "storage_prog_bar",
                padding: {
                    left: this.applyScale(77),
                    right: 0,
                    top: this.applyScale(8),
                    bottom: 0
                }
            });
        }
    }
    addHpProgressBar() {
        const progressValue = this._item.hitpoints;
        const hpProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "hp_icon",
                space: 8,
                scale: 1
            },
            previewBar: {
                color: this._isMaxLevel ? undefined : $70e54a6d23704007$var$hpPreviewBarColor,
                width: this._isMaxLevel ? undefined : $70e54a6d23704007$var$neonGoldBarWidth * 0.8,
                alpha: this._isMaxLevel ? undefined : 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: undefined,
                width: $70e54a6d23704007$var$neonGoldBarWidth,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$hpProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: 0,
                maxValue: this._isMaxLevel ? progressValue : 10,
                progressValue: this._isMaxLevel ? progressValue : 7,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: $70e54a6d23704007$var$neonGoldBarWidth - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
        if (!this._isMaxLevel) hpProgBar.setProgressBarText(`${progressValue.toLocaleString("en-us")} (+${(this._item.next_level_hitpoints - progressValue).toLocaleString("en-us")} after upgrade)`);
        this._dynamicSizer.add(hpProgBar, {
            key: "hp_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    addDpsProgressBar() {
        const progressValue = this._item.dps;
        const dpsProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "dps_icon",
                space: 8,
                scale: 1
            },
            previewBar: {
                color: this._isMaxLevel ? undefined : $70e54a6d23704007$var$dpsPreviewBarColor,
                width: this._isMaxLevel ? undefined : $70e54a6d23704007$var$neonGoldBarWidth * 0.8,
                alpha: this._isMaxLevel ? undefined : 1
            },
            progressBar: {
                text: `${progressValue.toLocaleString("en-us")} per second`,
                fontStyle: null,
                fontSize: undefined,
                width: $70e54a6d23704007$var$neonGoldBarWidth,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$dpsProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: 0,
                maxValue: this._isMaxLevel ? progressValue : 10,
                progressValue: this._isMaxLevel ? progressValue : 7,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: $70e54a6d23704007$var$neonGoldBarWidth - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
        if (!this._isMaxLevel) dpsProgBar.setProgressBarText(`${progressValue.toLocaleString("en-us")} per second (+${(this._item.next_level_dps - progressValue).toLocaleString("en-us")} after upgrade)`);
        this._dynamicSizer.add(dpsProgBar, {
            key: "dps_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    addCapacityProgressBar() {
        const progressValue = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormCapacity(this._item.level);
        const nextLevelValue = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormCapacity(this._item.level + 1);
        const upgradeDifference = nextLevelValue - progressValue;
        const capacityProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "hp_icon",
                space: 8,
                scale: 1
            },
            previewBar: {
                color: this._isMaxLevel ? undefined : $70e54a6d23704007$var$hpPreviewBarColor,
                width: this._isMaxLevel ? undefined : $70e54a6d23704007$var$neonGoldBarWidth * 0.8,
                alpha: this._isMaxLevel ? undefined : 1
            },
            progressBar: {
                text: `${progressValue.toLocaleString("en-us")}`,
                fontStyle: null,
                fontSize: undefined,
                width: $70e54a6d23704007$var$neonGoldBarWidth,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$hpProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: 0,
                maxValue: this._isMaxLevel ? progressValue : 10,
                progressValue: this._isMaxLevel ? progressValue : 7,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: $70e54a6d23704007$var$neonGoldBarWidth - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
        if (!this._isMaxLevel) capacityProgBar.setProgressBarText(`${progressValue.toLocaleString("en-us")} (+${upgradeDifference} after upgrade)`);
        this._dynamicSizer.add(capacityProgBar, {
            key: "capacity_prog_bar",
            padding: {
                left: this.applyScale(77),
                right: 0,
                top: this.applyScale(8),
                bottom: 0
            }
        });
    }
    createSpaceElixirBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "space_elixir_icon",
                space: 8,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $70e54a6d23704007$var$bluePreviewBarColor,
                width: width * ((progressValue + 1) / 10),
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$blueProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: $70e54a6d23704007$var$spaceElixirMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: width - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
    }
    createNeonGoldBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "neon_gold_icon",
                space: 8,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $70e54a6d23704007$var$goldPreviewBarColor,
                width: width * ((progressValue + 1) / 10),
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$goldProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: $70e54a6d23704007$var$neonGoldMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: width - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
    }
    createStardustBar(progressValue, maxValue, width, isUpgrade = false, fontSize) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: "",
                fontStyle: null
            },
            icon: {
                key: "stardust_icon_44",
                space: 5,
                scale: 1
            },
            previewBar: !isUpgrade ? undefined : {
                color: $70e54a6d23704007$var$pinkPreviewBarColoar,
                width: width * 0.8,
                alpha: 1
            },
            progressBar: {
                text: progressValue.toLocaleString("en-us"),
                fontStyle: null,
                fontSize: fontSize,
                width: width,
                height: $70e54a6d23704007$var$progressBarHeight,
                radius: $70e54a6d23704007$var$radius,
                color: $70e54a6d23704007$var$pinkProgressBarColor,
                alpha: $70e54a6d23704007$var$progressBarAlpha,
                backgroundColor: $70e54a6d23704007$var$backgroundColor,
                backgroundAlpha: $70e54a6d23704007$var$backgroundAlpha,
                minValue: $70e54a6d23704007$var$stardustMin,
                maxValue: maxValue > 0 ? maxValue : 100,
                progressValue: progressValue,
                glare: {
                    height: $70e54a6d23704007$var$glareHeight,
                    width: width - $70e54a6d23704007$var$glareOffset,
                    radius: $70e54a6d23704007$var$glareRadius,
                    color: $70e54a6d23704007$var$glareColor,
                    alpha: $70e54a6d23704007$var$glareAlpha
                }
            }
        });
    }
    getSpaceElixirCost() {
        return this._item.cost_space_elixir;
    }
    getNeonGoldCost() {
        return this._item.cost_neon_gold;
    }
    getStardustCost() {
        return this._item.cost_stardust;
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var h = Math.floor(seconds / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 3600 % 60);
        var hDisplay = h > 0 ? `${h}H` : "";
        var mDisplay = m > 0 ? `${m}M` : "";
        // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        if (h === 0 && m === 0 && s > 0) return "< 1m";
        return h > 0 ? `${hDisplay} ${mDisplay}` : mDisplay;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("machineUpgradeContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $70e54a6d23704007$export$2e2bcd8739ae039(this.scene, x, y));
});



const $2dbd94455af48f08$var$modalWidth = 1008;
const $2dbd94455af48f08$var$modalHeight = 735;
const $2dbd94455af48f08$var$modalRadius = 16;
const $2dbd94455af48f08$var$modalColor = 0x1c1c2c;
const $2dbd94455af48f08$var$modalAlpha = 1;
const $2dbd94455af48f08$var$modalBorderColor = 0x6262de;
const $2dbd94455af48f08$var$modalBorderWidth = 3;
class $2dbd94455af48f08$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userMachine = data.userMachine;
    }
    constructor(){
        super({
            key: "MachineUpgradeModalScene"
        });
    }
    preload() {
        this.load.image(`shop_machines_${this._userMachine.key}`, (0, $1aa2c39fc1fbb95e$export$51715d62b7d83d79)[`shop_machines_${this._userMachine.key}`]);
    }
    create() {
        const self = this;
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.dragDistanceThreshold = 16;
        this.input.dragTimeThreshold = 300;
        this.input.topOnly = true;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2dbd94455af48f08$var$modalWidth, $2dbd94455af48f08$var$modalHeight);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale(597),
            width: this.applyScale($2dbd94455af48f08$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($2dbd94455af48f08$var$modalWidth), this.applyScale($2dbd94455af48f08$var$modalHeight), this.applyScale($2dbd94455af48f08$var$modalRadius), $2dbd94455af48f08$var$modalColor, $2dbd94455af48f08$var$modalAlpha);
        background.setStrokeStyle(this.applyScale($2dbd94455af48f08$var$modalBorderWidth), $2dbd94455af48f08$var$modalBorderColor, $2dbd94455af48f08$var$modalAlpha);
        this._sizer.add(background, {
            key: "shop_bg",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._machineUpgradeContentPane = new (0, $70e54a6d23704007$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, this.sys.canvas.height / 2, this._userMachine, this._scale);
        this.add.existing(this._machineUpgradeContentPane);
        this._sizer.add(this._machineUpgradeContentPane, {
            key: "machine_upgrade_content_pane",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.layout();
        this._sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this._machineUpgradeContentPane = undefined;
            this.unloadAssets();
            this.scene.stop();
            // this.scene.resume('HomebaseScene');
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {
        this._machineUpgradeContentPane.destroy();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, [
            `shop_machines_${this._userMachine.key}`
        ]);
    }
}








const $d250bb9725ceb082$var$modalHeight = 270;
const $d250bb9725ceb082$var$modalWidth = 494;
const $d250bb9725ceb082$var$modalRadius = 50;
const $d250bb9725ceb082$var$modalColor = 0x350926;
const $d250bb9725ceb082$var$modalAlpha = 1;
const $d250bb9725ceb082$var$modalBorderColor = 0x3d4361;
const $d250bb9725ceb082$var$modalBorderWidth = 1;
class $d250bb9725ceb082$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BaseRaidConfirmNextBaseLoadScene"
        });
    }
    init(data) {
        if (data) this._isFirstBaseView = data.isFirst;
        else this._isFirstBaseView = false;
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$13b5492ca3439890));
    }
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($d250bb9725ceb082$var$modalWidth, $d250bb9725ceb082$var$modalHeight + 50);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($d250bb9725ceb082$var$modalWidth), this.applyScale($d250bb9725ceb082$var$modalHeight), this.applyScale($d250bb9725ceb082$var$modalRadius), $d250bb9725ceb082$var$modalColor, $d250bb9725ceb082$var$modalAlpha).setInteractive({
            cursor: "default"
        }).setStrokeStyle($d250bb9725ceb082$var$modalBorderWidth, $d250bb9725ceb082$var$modalBorderColor, $d250bb9725ceb082$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2 - this.applyScale(10),
            width: this.applyScale(350),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Viewing another base will cost the following resources:", this.applyScale(24), 1).setMaxWidth(this.applyScale(350)), {
            key: "title_text",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(20),
                bottom: 0
            }
        });
        sizer.add(this.add.existing(new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", "100")), {
            key: "cost_label",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(30),
                bottom: 0
            }
        });
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), modalBg.getBottomLeft().y, "pvp_cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.cancelButtonClickHandler();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        this._confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), modalBg.getBottomLeft().y, "pvp_confirm_button", false).setScale(this._scale).setInteractive({
            cursor: "pointer"
        });
        this._confirmButton.onClick().subscribe((pointer)=>{
            this.confirmButtonClickHandler();
        });
        this.add.existing(this._confirmButton);
        // Add key bindings
        this.input.keyboard.on("keydown-ENTER", (event)=>{
            this.confirmButtonClickHandler();
        });
        this.input.keyboard.on("keydown-ESC", (event)=>{
            this.cancelButtonClickHandler();
        });
        sizer.layout();
    }
    cancelButtonClickHandler() {
        if (this._isFirstBaseView) {
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        } else {
            this.scene.get("BaseRaidDetailsScene").input.enabled = true;
            this.scene.get("BaseRaidHudScene").input.enabled = true;
            this.scene.stop();
        }
        this.unloadAssets();
    }
    confirmButtonClickHandler() {
        this._confirmButton.disableInteractive();
        if (this._isFirstBaseView) {
            this.scene.stop();
            this.scene.stop("HomebaseScene");
            this.scene.stop("HudScene");
            this.scene.start("BaseRaidLoadingScene", {
                next: 0
            });
        } else {
            this.scene.stop();
            this.scene.stop("BaseRaidDetailsScene");
            this.scene.stop("BaseRaidHudScene");
            this.scene.start("BaseRaidLoadingScene", {
                next: 1
            });
        }
        this.unloadAssets();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$13b5492ca3439890)));
    }
}








const $66056ccc21fc7be2$var$modalWidth = 494;
const $66056ccc21fc7be2$var$modalHeight = 366;
const $66056ccc21fc7be2$var$modalRadius = 50;
const $66056ccc21fc7be2$var$modalColor = 0x350926;
const $66056ccc21fc7be2$var$modalAlpha = 1;
const $66056ccc21fc7be2$var$modalBorderColor = 0x3d4361;
const $66056ccc21fc7be2$var$modalBorderWidth = 1;
const $66056ccc21fc7be2$var$goldProgressBarColor = 0xdea827;
const $66056ccc21fc7be2$var$pinkProgressBarColor = 0xde2795;
const $66056ccc21fc7be2$var$blueProgressBarColor = 0x00a6d3;
const $66056ccc21fc7be2$var$grayProgressBarColor = 0x9a9a9a;
const $66056ccc21fc7be2$var$progressBarAlpha = 1;
const $66056ccc21fc7be2$var$glareColor = 0xffffff;
const $66056ccc21fc7be2$var$glareAlpha = 0.14;
const $66056ccc21fc7be2$var$glareRadius = 3;
const $66056ccc21fc7be2$var$glareHeight = 6;
const $66056ccc21fc7be2$var$glareOffset = 10;
const $66056ccc21fc7be2$var$borderWidth = 1;
const $66056ccc21fc7be2$var$borderColor = 0x383d57;
const $66056ccc21fc7be2$var$borderAlpha = 1;
const $66056ccc21fc7be2$var$backgroundColor = 0x201425;
const $66056ccc21fc7be2$var$backgroundAlpha = 0.4;
const $66056ccc21fc7be2$var$radius = 11;
const $66056ccc21fc7be2$var$progressBarHeight = 43;
const $66056ccc21fc7be2$var$progressBarWidth = 240;
const $66056ccc21fc7be2$var$minDaysHeldToStake = 7;
const $66056ccc21fc7be2$var$resources = {
    space_elixir: "space_elixir",
    neon_gold: "neon_gold",
    stardust: "stardust"
};
class $66056ccc21fc7be2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._resource = data.resource;
    }
    constructor(){
        super({
            key: "HpModalScene"
        });
    }
    preload() {}
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($66056ccc21fc7be2$var$modalWidth, $66056ccc21fc7be2$var$modalHeight);
        const userMachines = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachinesSync();
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($66056ccc21fc7be2$var$modalWidth), this.applyScale($66056ccc21fc7be2$var$modalHeight - 80), this.applyScale($66056ccc21fc7be2$var$modalRadius), $66056ccc21fc7be2$var$modalColor, $66056ccc21fc7be2$var$modalAlpha);
        modalBg.setStrokeStyle($66056ccc21fc7be2$var$modalBorderWidth, $66056ccc21fc7be2$var$modalBorderColor, $66056ccc21fc7be2$var$modalAlpha);
        const resourceIcon = this.getResourceIcon();
        // Add Icons
        this.add.image(modalBg.getTopCenter().x, modalBg.getTopLeft().y, resourceIcon).setScale(this.getIconScale() * this._scale);
        // Add Sizer for content
        var sizer = new (0, $4d318a74c42de65b$export$2e2bcd8739ae039)(this, {
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($66056ccc21fc7be2$var$modalWidth),
            height: this.applyScale($66056ccc21fc7be2$var$modalHeight - 80),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this.add.existing(sizer);
        // HP display
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getResourceTitleText(), this.applyScale(18), 1), {
            key: "hp_title_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(70),
            expand: false
        });
        const hpProgBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this.getProgressText(userMachines),
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $66056ccc21fc7be2$var$borderWidth,
                color: $66056ccc21fc7be2$var$borderColor,
                alpha: $66056ccc21fc7be2$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $66056ccc21fc7be2$var$progressBarWidth,
                height: $66056ccc21fc7be2$var$progressBarHeight,
                radius: $66056ccc21fc7be2$var$radius,
                color: $66056ccc21fc7be2$var$grayProgressBarColor,
                alpha: $66056ccc21fc7be2$var$progressBarAlpha,
                backgroundColor: $66056ccc21fc7be2$var$backgroundColor,
                backgroundAlpha: $66056ccc21fc7be2$var$backgroundAlpha,
                minValue: 0,
                maxValue: 10,
                progressValue: 0,
                glare: {
                    height: $66056ccc21fc7be2$var$glareHeight,
                    width: $66056ccc21fc7be2$var$progressBarWidth - $66056ccc21fc7be2$var$glareOffset,
                    radius: $66056ccc21fc7be2$var$glareRadius,
                    color: $66056ccc21fc7be2$var$glareColor,
                    alpha: $66056ccc21fc7be2$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(hpProgBar);
        hpProgBar.setProgressBarText("");
        sizer.add(hpProgBar, {
            key: "hp_prog_bar",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(98),
            expand: false
        });
        // Tip Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getResourceTipText(), this.applyScale(16), 1).setAlpha(0.4).setMaxWidth(this.applyScale($66056ccc21fc7be2$var$progressBarWidth)), {
            key: "tip_text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(163),
            expand: false
        });
        sizer.layout();
        // Add Close Button
        const closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "modal_close_button", false).setScale(this._scale);
        closeButton.onClick().subscribe((pointer)=>{
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(closeButton);
        sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this.scene.stop();
            this.scene.get("HomebaseScene").input.enabled = true;
            this.scene.resume("HudScene");
        });
    }
    getTotalHPText(userMachines) {
        if (userMachines && userMachines.length > 1) {
            var totalHp = 0;
            userMachines.forEach((mach)=>{
                if (mach.hitpoints && mach.hitpoints > 0) totalHp += mach.hitpoints;
            });
            return totalHp.toLocaleString("en-us");
        } else return "0";
    }
    getTotalDPSText(userMachines) {
        if (userMachines && userMachines.length > 1) {
            var totalDps = 0;
            userMachines.forEach((mach)=>{
                if (mach.dps && mach.dps > 0) totalDps += mach.dps;
            });
            return totalDps.toLocaleString("en-us");
        } else return "0";
    }
    getResourceIcon() {
        switch(this._resource){
            case "dps":
                return "dps_icon_large";
            default:
                return "hp_icon_large";
        }
    }
    getResourceTitleText() {
        switch(this._resource){
            case "dps":
                return "Your Base DPS";
            default:
                return "Your Base HP";
        }
    }
    getResourceTipText() {
        switch(this._resource){
            case "dps":
                return "TIP: Upgrading or building any defensive machine will increase your Base's DPS!";
            default:
                return "TIP: Upgrading or building any machine will increase your Base's HP!";
        }
    }
    getProgressText(userMachines) {
        switch(this._resource){
            case "dps":
                return this.getTotalDPSText(userMachines);
            default:
                return this.getTotalHPText(userMachines);
        }
    }
    getIconScale() {
        switch(this._resource){
            case "dps":
                return 0.85;
            default:
                return 1;
        }
    }
    applyScale(length) {
        return length * this._scale;
    }
}










const $70f442678db48c10$var$modalHeight = 400;
const $70f442678db48c10$var$modalWidth = 494;
const $70f442678db48c10$var$modalRadius = 50;
const $70f442678db48c10$var$modalColor = 0x350926;
const $70f442678db48c10$var$modalAlpha = 1;
const $70f442678db48c10$var$modalBorderColor = 0x3d4361;
const $70f442678db48c10$var$modalBorderWidth = 1;
const $70f442678db48c10$var$okayButtonImageKey = "okay_button";
const $70f442678db48c10$var$bannerImageKey = "raid_result_banner";
const $70f442678db48c10$var$victoryTextImageKey = "thank_heavens_text";
const $70f442678db48c10$var$lossTextImageKey = "oh_no_text";
const $70f442678db48c10$var$defendVictoryMessage = "While you were gone, someone raided you, but they were unsuccessful.\n\nWell done, commander.";
const $70f442678db48c10$var$defendLossMessage = "While you were gone, someone raided you.\n\nYou lost the following resources:";
const $70f442678db48c10$var$attackVictoryMessage = "Your raid was successful.  Well done, commander.\n\nYou gained the following resources:";
const $70f442678db48c10$var$attackLossMessage = "Your raid was unsuccessful.\n\nYou lost the following resources:";
class $70f442678db48c10$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._result = data;
    }
    constructor(){
        super({
            key: "BaseRaidResultScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f6b70d869c907105));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($70f442678db48c10$var$modalWidth, $70f442678db48c10$var$modalHeight + 100); // 100 extra to account for button
        this._isVictory = this._result.isVictory;
        this._isAttacker = this._result.isAttacker;
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($70f442678db48c10$var$modalWidth), this.applyScale($70f442678db48c10$var$modalHeight), this.applyScale($70f442678db48c10$var$modalRadius), $70f442678db48c10$var$modalColor, $70f442678db48c10$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($70f442678db48c10$var$modalBorderWidth), $70f442678db48c10$var$modalBorderColor, $70f442678db48c10$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($70f442678db48c10$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(60),
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add background to sizer
        sizer.addBackground(modalBg);
        // Add banner
        sizer.add(this.add.image(0, 0, $70f442678db48c10$var$bannerImageKey).setScale(this._scale), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "modal_banner"
        });
        // Add Sizer for centered content
        var contentSizer = this.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale(325),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add Title Text image
        contentSizer.add(this.add.image(0, 0, this.getTitleTextImageKey()), {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(this.getTitleTextVerticalOffset()),
                bottom: 0
            },
            key: "title_text_image"
        });
        // Add Message Text
        contentSizer.add(this.add.bitmapText(0, 0, "cc_outline", this.getMessageText(), this.applyScale(24), 1).setMaxWidth(this.applyScale(325)), {
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(23),
                bottom: 0
            },
            key: "message_text"
        });
        if (this._isVictory) {
            // Add Resource Labels
            if (this._result.space_elixir && this._result.space_elixir > 0) {
                const space_elixir_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "space_elixir", this._result.space_elixir.toLocaleString("en-us") || "0");
                contentSizer.add(this.add.existing(space_elixir_label), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: this.applyScale(40),
                        bottom: 0
                    },
                    key: "space_elixir_label"
                });
            }
            if (this._result.neon_gold && this._result.neon_gold > 0) {
                const neon_gold_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "neon_gold", this._result.neon_gold.toLocaleString("en-us") || "0");
                contentSizer.add(this.add.existing(neon_gold_label), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: this.applyScale(18),
                        bottom: 0
                    },
                    key: "neon_gold_label"
                });
            }
            if (this._result.stardust && this._result.stardust > 0) {
                const stardust_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "stardust", this._result.stardust.toLocaleString("en-us") || "0");
                contentSizer.add(this.add.existing(stardust_label), {
                    padding: {
                        left: 0,
                        right: 0,
                        top: this.applyScale(18),
                        bottom: 0
                    },
                    key: "stardust_label"
                });
            }
        }
        if (this._result.xp && this._result.xp !== 0) {
            const xp_label = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "xp", `${this._result.xp.toLocaleString("en-us")}xp` || "0xp");
            contentSizer.add(this.add.existing(xp_label), {
                padding: {
                    left: 0,
                    right: 0,
                    top: this.applyScale(18),
                    bottom: 0
                },
                key: "xp_label"
            });
        }
        sizer.add(contentSizer.layout(), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "content_size"
        });
        sizer.layout();
        // Add Okay Button
        const okayButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, modalBg.getBottomLeft().y, $70f442678db48c10$var$okayButtonImageKey, false).setScale(this._scale);
        okayButton.onClick().subscribe((pointer)=>{
            this.okayButtonClickHandler();
        });
        this.add.existing(okayButton);
        // Add key bindings
        this.input.keyboard.on("keydown-ENTER", (event)=>{
            this.okayButtonClickHandler();
        });
    }
    okayButtonClickHandler() {
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack(true).then((attackRes)=>{
            if (this._isAttacker) // Close modal, go to HomebaseScene
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.scene.start("HomebaseScene");
                this.scene.stop();
                this.unloadAssets();
            });
            else // Close modal, resume homebase and hud
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                this.scene.resume("HomebaseScene");
                this.scene.resume("HudScene");
                this.scene.stop();
                this.unloadAssets();
            });
        });
    }
    getTitleTextImageKey() {
        return this._isVictory ? $70f442678db48c10$var$victoryTextImageKey : $70f442678db48c10$var$lossTextImageKey;
    }
    getTitleTextVerticalOffset() {
        return this._isVictory ? -38 : -26; // Half the height of the image, negative
    }
    getMessageText() {
        return this._isAttacker ? this._isVictory ? $70f442678db48c10$var$attackVictoryMessage : $70f442678db48c10$var$attackLossMessage : this._isVictory ? $70f442678db48c10$var$defendVictoryMessage : $70f442678db48c10$var$defendLossMessage;
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f6b70d869c907105)));
    }
}







const $2a5ff982cdf64ef8$var$modalHeight = 270;
const $2a5ff982cdf64ef8$var$modalWidth = 494;
const $2a5ff982cdf64ef8$var$modalRadius = 50;
const $2a5ff982cdf64ef8$var$modalColor = 0x350926;
const $2a5ff982cdf64ef8$var$modalAlpha = 1;
const $2a5ff982cdf64ef8$var$modalBorderColor = 0x3d4361;
const $2a5ff982cdf64ef8$var$modalBorderWidth = 1;
class $2a5ff982cdf64ef8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BaseRaidConfirmSurrenderScene"
        });
    }
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2a5ff982cdf64ef8$var$modalWidth, $2a5ff982cdf64ef8$var$modalHeight + 50);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($2a5ff982cdf64ef8$var$modalWidth), this.applyScale($2a5ff982cdf64ef8$var$modalHeight), this.applyScale($2a5ff982cdf64ef8$var$modalRadius), $2a5ff982cdf64ef8$var$modalColor, $2a5ff982cdf64ef8$var$modalAlpha).setInteractive({
            cursor: "default"
        }).setStrokeStyle($2a5ff982cdf64ef8$var$modalBorderWidth, $2a5ff982cdf64ef8$var$modalBorderColor, $2a5ff982cdf64ef8$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2 - this.applyScale(10),
            width: this.applyScale(350),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add Title Text
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Are you sure you want to surrender?  You will lose:", this.applyScale(24), 1).setMaxWidth(this.applyScale(350)), {
            key: "title_text",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(20),
                bottom: 0
            }
        });
        sizer.add(this.add.existing(new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(this, 0, 0, this._scale, "xp", "-500xp")), {
            key: "cost_label",
            padding: {
                left: 0,
                right: 0,
                top: this.applyScale(30),
                bottom: 0
            }
        });
        // Add Cancel Button
        const cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 - this.applyScale(94), modalBg.getBottomLeft().y, "pvp_cancel_button", false).setScale(this._scale);
        cancelButton.onClick().subscribe((pointer)=>{
            this.cancelButtonClickHandler();
        });
        this.add.existing(cancelButton);
        // Add Confirm Button
        const confirmButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2 + this.applyScale(75), modalBg.getBottomLeft().y, "pvp_confirm_button", false).setScale(this._scale);
        confirmButton.onClick().subscribe((pointer)=>{
            this.confirmButtonClickHandler();
        });
        this.add.existing(confirmButton);
        // Add key bindings
        this.input.keyboard.on("keydown-ENTER", (event)=>{
            this.confirmButtonClickHandler();
        });
        this.input.keyboard.on("keydown-ESC", (event)=>{
            this.cancelButtonClickHandler();
        });
        sizer.layout();
    }
    cancelButtonClickHandler() {
        this.scene.get("BaseRaidDetailsScene").input.enabled = true;
        this.scene.get("BaseRaidHudScene").input.enabled = true;
        this.scene.get("BaseRaidHudScene").input.keyboard.enabled = true;
        this.scene.stop();
    }
    confirmButtonClickHandler() {
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().surrenderAttack().then((res)=>{
            if (res.success) (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().viewAttack().then((attackRes)=>{
                const resultData = {
                    isAttacker: true,
                    neon_gold: attackRes.attacker_possible_loot.neon_gold,
                    space_elixir: attackRes.attacker_possible_loot.space_elixir,
                    stardust: attackRes.attacker_possible_loot.stardust,
                    xp: attackRes.is_win ? attackRes.attacker_win_xp : attackRes.attacker_lose_xp,
                    isVictory: attackRes.is_win
                };
                this.scene.get("BaseRaidHudScene").input.keyboard.enabled = true;
                this.scene.stop("BaseRaidDetailsScene");
                this.scene.stop("BaseRaidHudScene");
                this.scene.start("BaseRaidResultScene", resultData);
            });
            else {
                this.scene.get("BaseRaidHudScene").input.keyboard.enabled = true;
                this.scene.stop();
                this.scene.stop("BaseRaidDetailsScene");
                this.scene.stop("BaseRaidHudScene");
                this.scene.start("ErrorScene");
            }
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
}






const $bb029119ea11b6e9$var$subTextColor = 0xbfaac6;
const $bb029119ea11b6e9$var$modalHeight = 325;
const $bb029119ea11b6e9$var$modalWidth = 494;
const $bb029119ea11b6e9$var$modalRadius = 25;
const $bb029119ea11b6e9$var$modalColor = 0x350926;
const $bb029119ea11b6e9$var$modalAlpha = 1;
const $bb029119ea11b6e9$var$modalBorderColor = 0x3d4361;
const $bb029119ea11b6e9$var$modalBorderWidth = 1;
class $bb029119ea11b6e9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattleRoyaleServerUnavailableScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$6b05ab6b067cc0c6));
    }
    create() {
        // Add Window
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $bb029119ea11b6e9$var$modalWidth, $bb029119ea11b6e9$var$modalHeight, $bb029119ea11b6e9$var$modalRadius, $bb029119ea11b6e9$var$modalColor, $bb029119ea11b6e9$var$modalAlpha);
        modalBg.setStrokeStyle($bb029119ea11b6e9$var$modalBorderWidth, $bb029119ea11b6e9$var$modalBorderColor, $bb029119ea11b6e9$var$modalAlpha);
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 120, "cc_outline", "Oops! Battle Royale server is down.", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 80, "cc_outline", "*Please notify the team in discord.", 20, 0).setOrigin(0.5, 0).setCenterAlign().setTint($bb029119ea11b6e9$var$subTextColor);
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 40, "party_blob").setOrigin(0.5, 0.5).play("blob_animation");
        // Buttons
        this.cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "bossfight_victory_return_home_button", true, 1.05);
        this.cancelButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.stop("BattleRoyaleScene");
            this.scene.stop();
            this.scene.start("HomebaseScene");
        });
        this.add.existing(this.cancelButton);
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$6b05ab6b067cc0c6)));
    }
}








// Pane Details
const $0db21946d00a4136$var$paneHeight = 300;
const $0db21946d00a4136$var$paneWidth = 500;
const $0db21946d00a4136$var$paneRadius = 25;
const $0db21946d00a4136$var$paneColor = 0x1c1c2c;
const $0db21946d00a4136$var$paneAlpha = 1;
class $0db21946d00a4136$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $0db21946d00a4136$var$paneWidth,
            height: paneScale * $0db21946d00a4136$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._playerData = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        if (this._playerData != undefined) {
            // Add Sizer for content
            var sizer = scene.rexUI.add.overlapSizer({
                width: scene.applyScale($0db21946d00a4136$var$paneWidth),
                height: scene.applyScale($0db21946d00a4136$var$paneHeight),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    item: 0,
                    line: 0
                },
                align: 0
            });
            // Add Results Text
            var title = scene.add.bitmapText(0, 0, "cc_outline", this._playerData.playerName, scene.applyScale(30), 0);
            sizer.add(title, {
                key: `player-title`,
                align: "center-top",
                offsetX: scene.applyScale(0),
                offsetY: scene.applyScale(20),
                expand: false
            });
            // Add Divider Top
            const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerTop, {
                key: "br-divider-top",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(70),
                expand: false
            });
            // Player PFP and Player Name
            var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._playerData.playerImageKey);
            var imageWidth = imageData.width;
            const rectConfig = {
                maskType: "roundRectangle",
                radius: Math.ceil(imageWidth / 8)
            };
            var image = scene.add.rexCircleMaskImage(0, 0, this._playerData.playerImageKey, "", rectConfig);
            image.displayHeight = scene.applyScale(179);
            image.scaleX = image.scaleY;
            imageData.destroy();
            sizer.add(scene.add.existing(image), {
                key: "nft_image",
                align: "left-top",
                offsetX: scene.applyScale(30),
                offsetY: scene.applyScale(90),
                expand: false
            });
            // Placing
            var placing = scene.add.bitmapText(0, 0, "cc_outline", "Placing: " + this.getPlacing(this._playerData), scene.applyScale(24), 0);
            sizer.add(placing, {
                key: `placing_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(90),
                expand: false
            });
            // Kills
            var kills = scene.add.bitmapText(0, 0, "cc_outline", "Kills: " + this.getKillCount(this._playerData), scene.applyScale(24), 0);
            sizer.add(kills, {
                key: `kills_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(120),
                expand: false
            });
            // Evades
            var evades = scene.add.bitmapText(0, 0, "cc_outline", "Evades: " + this.getEvadeCount(this._playerData), scene.applyScale(24), 0);
            sizer.add(evades, {
                key: `evades_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(150),
                expand: false
            });
            // Lazes
            var lazes = scene.add.bitmapText(0, 0, "cc_outline", "Lazes: " + this.getLazesCount(this._playerData), scene.applyScale(24), 0);
            sizer.add(lazes, {
                key: `lazes_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(180),
                expand: false
            });
            // Suicides
            var suicide = scene.add.bitmapText(0, 0, "cc_outline", "Suicides: " + this.getSuicides(this._playerData), scene.applyScale(24), 0);
            sizer.add(suicide, {
                key: `suisides_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(210),
                expand: false
            });
            // Reason of Death
            this.add(sizer, {
                key: "player-panel",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getPlacing(playerData) {
        return playerData.placing;
    }
    getKillCount(playerData) {
        return playerData.kills;
    }
    getEvadeCount(playerData) {
        return playerData.evades;
    }
    getLazesCount(playerData) {
        return playerData.lazes;
    }
    getSuicides(playerData) {
        return playerData.suicides;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battleRoyaleResultsPlayerPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $0db21946d00a4136$export$2e2bcd8739ae039(this.scene, x, y));
});





// Pane Details
const $91b6814afcba0706$var$paneHeight = 300;
const $91b6814afcba0706$var$paneWidth = 500;
const $91b6814afcba0706$var$paneRadius = 25;
const $91b6814afcba0706$var$paneColor = 0x1c1c2c;
const $91b6814afcba0706$var$paneAlpha = 1;
class $91b6814afcba0706$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $91b6814afcba0706$var$paneWidth,
            height: paneScale * $91b6814afcba0706$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._payout = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        if (this._payout != undefined) {
            // Add Sizer for content
            var sizer = scene.rexUI.add.overlapSizer({
                width: scene.applyScale($91b6814afcba0706$var$paneWidth),
                height: scene.applyScale($91b6814afcba0706$var$paneHeight),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    item: 0,
                    line: 0
                },
                align: 0
            });
            // Add Divider Top
            const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerTop, {
                key: "br-divider-top",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
            // Add Payout Text
            var resultsText = scene.add.bitmapText(0, 0, "cc_outline", "Payout", scene.applyScale(30), 0);
            sizer.add(resultsText, {
                key: `payout-title`,
                align: "center-top",
                offsetX: scene.applyScale(0),
                offsetY: scene.applyScale(20),
                expand: false
            });
            // Add Divider Below
            const dividerBelow = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerBelow, {
                key: "br-divider-below",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(70),
                expand: false
            });
            // Payout Details
            this._spaceElixirBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "space_elixir", this._payout.spaceElixir.toLocaleString("en-us"));
            sizer.add(this._spaceElixirBar, {
                key: "br-se-bar",
                align: "left-top",
                offsetX: this.applyScale(25),
                offsetY: this.applyScale(120),
                expand: false
            });
            this._neonGoldBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "neon_gold", this._payout.neonGold.toLocaleString("en-us"));
            sizer.add(this._neonGoldBar, {
                key: "br-ng-bar",
                align: "left-top",
                offsetX: this.applyScale(262),
                offsetY: this.applyScale(120),
                expand: false
            });
            this._starDustBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "stardust", this._payout.starDust.toLocaleString("en-us"));
            sizer.add(this._starDustBar, {
                key: "bossfight-sd-bar",
                align: "left-top",
                offsetX: this.applyScale(25),
                offsetY: this.applyScale(180),
                expand: false
            });
            this._xpBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, undefined, /*`${this._payout.xp} xp`*/ "0 xp");
            sizer.add(this._xpBar, {
                key: "bossfight-xp-bar",
                align: "left-top",
                offsetX: this.applyScale(262),
                offsetY: this.applyScale(180),
                expand: false
            });
            this.add(sizer, {
                key: "resources-panel",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battleRoyaleResultsPayoutPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $91b6814afcba0706$export$2e2bcd8739ae039(this.scene, x, y));
});





// Pane Details
const $8205a0157fdcb402$var$paneHeight = 600;
const $8205a0157fdcb402$var$paneWidth = 500;
const $8205a0157fdcb402$var$paneRadius = 25;
const $8205a0157fdcb402$var$paneColor = 0x1c1c2c;
const $8205a0157fdcb402$var$paneAlpha = 1;
// Table Details
const $8205a0157fdcb402$var$itemWidth = 470, $8205a0157fdcb402$var$itemHeight = 73, $8205a0157fdcb402$var$itemRadius = 13, $8205a0157fdcb402$var$itemColor = 0x463851, $8205a0157fdcb402$var$itemAlpha = 0.3;
// Item Details
const $8205a0157fdcb402$var$itemGlareHeight = 7, $8205a0157fdcb402$var$itemGlareRadius = 4, $8205a0157fdcb402$var$itemGlareColor = 0xffffff, $8205a0157fdcb402$var$itemGlareAlpha = 0.08;
const $8205a0157fdcb402$var$categories = {
    placing: "placings",
    kills: "kills",
    evades: "evades",
    lazes: "lazes"
};
class $8205a0157fdcb402$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $8205a0157fdcb402$var$paneWidth,
            height: paneScale * $8205a0157fdcb402$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._participants = data;
        // Split participants data into sorted lists per category
        this._placings = this.getPlacingsData(this._participants);
        this._kills = this.getKillsData(this._participants);
        this._evades = this.getEvadesData(this._participants);
        this._lazes = this.getLazesData(this._participants);
        this._scale = paneScale;
        scene.input.topOnly = false;
        scene.input.setDefaultCursor("default");
        this._selectedCategory = $8205a0157fdcb402$var$categories.placing;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Add Sizer for content
        var sizer = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($8205a0157fdcb402$var$paneWidth),
            height: scene.applyScale($8205a0157fdcb402$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Pane Divider
        const dividerLeft = scene.add.image(0, 0, "battleroyale_results_pane_divider").setScale(this._scale);
        sizer.add(dividerLeft, {
            key: "br-divider-left",
            align: "left-top",
            offsetX: this.applyScale(1),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Add Results Text
        var resultsText = scene.add.bitmapText(0, 0, "cc_outline", "Leaderboard", scene.applyScale(30), 0);
        sizer.add(resultsText, {
            key: `details-title`,
            align: "center-top",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(20),
            expand: false
        });
        // Add Divider Top
        const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
        sizer.add(dividerTop, {
            key: "br-divider-top",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(70),
            expand: false
        });
        // Buttons Sizer
        var buttonSizer = scene.rexUI.add.fixWidthSizer({
            width: this.applyScale($8205a0157fdcb402$var$paneWidth),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Placings Button
        this._placingsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battleroyale_placing_button", false).setOrigin(0, 0.5).setScale(this._scale);
        this._placingsButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $8205a0157fdcb402$var$categories.placing;
            this._killsButton.setTexture("battleroyale_kills_button_inactive");
            this._placingsButton.setTexture("battleroyale_placing_button");
            this._evadesButton.setTexture("battleroyale_evades_button_inactive");
            this._lazesButton.setTexture("battleroyale_suicides_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._placings, 0, 0, this.scale).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._placingsButton), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "placings_button"
        });
        // Kills Button
        this._killsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battleroyale_kills_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._killsButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $8205a0157fdcb402$var$categories.kills;
            this._killsButton.setTexture("battleroyale_kills_button");
            this._placingsButton.setTexture("battleroyale_placing_button_inactive");
            this._evadesButton.setTexture("battleroyale_evades_button_inactive");
            this._lazesButton.setTexture("battleroyale_suicides_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._kills, 0, 0, this.scale).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._killsButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "kills_button"
        });
        // Evades Button
        this._evadesButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battleroyale_evades_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._evadesButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $8205a0157fdcb402$var$categories.evades;
            this._killsButton.setTexture("battleroyale_kills_button_inactive");
            this._placingsButton.setTexture("battleroyale_placing_button_inactive");
            this._evadesButton.setTexture("battleroyale_evades_button");
            this._lazesButton.setTexture("battleroyale_suicides_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._evades, 0, 0, this.scale).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._evadesButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "evades_button"
        });
        // Lazes Button
        this._lazesButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battleroyale_suicides_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._lazesButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $8205a0157fdcb402$var$categories.lazes;
            this._killsButton.setTexture("battleroyale_kills_button_inactive");
            this._placingsButton.setTexture("battleroyale_placing_button_inactive");
            this._evadesButton.setTexture("battleroyale_evades_button_inactive");
            this._lazesButton.setTexture("battleroyale_suicides_button");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._lazes, 0, 0, this.scale).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._lazesButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "lazes_button"
        });
        sizer.add(scene.add.existing(buttonSizer), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "button_sizer"
        });
        sizer.add(buttonSizer, {
            key: "br-button-sizer",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(100),
            expand: false
        });
        this.add(sizer, {
            key: "battle-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Add Divider Bottom
        const dividerBottom = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
        sizer.add(dividerBottom, {
            key: "br-divider-bottom",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(170),
            expand: false
        });
        // Add Table
        this._table = this.createTable(scene, this._placings, 0, 0, this.scale).layout();
        sizer.add(this._table, {
            key: "results-table",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(190),
            expand: false
        });
        // Return Home Button
        this._returnHome = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_victory_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHome.onClick().subscribe((pointer)=>{
            scene.destroy();
        });
        sizer.add(scene.add.existing(this._returnHome), {
            key: "return-home-button",
            align: "center-bottom",
            offsetX: 0,
            offsetY: scene.applyScale(-10),
            expand: false
        });
        this.layout();
    }
    createTable(scene, data, x, y, scale) {
        var tableHeight = ($8205a0157fdcb402$var$itemHeight + 7) * 4;
        var table = scene.rexUI.add.gridTable({
            width: scene.applyScale($8205a0157fdcb402$var$paneWidth),
            height: scene.applyScale(tableHeight),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($8205a0157fdcb402$var$itemWidth),
                cellHeight: this.applyScale($8205a0157fdcb402$var$itemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, participant = cell.item;
                const participantName = participant.playerName;
                const rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(40)
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($8205a0157fdcb402$var$itemWidth),
                    space: {
                        left: scene.applyScale(20),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($8205a0157fdcb402$var$itemWidth), scene.applyScale($8205a0157fdcb402$var$itemHeight), scene.applyScale($8205a0157fdcb402$var$itemRadius), $8205a0157fdcb402$var$itemColor, $8205a0157fdcb402$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($8205a0157fdcb402$var$itemWidth - 15), scene.applyScale($8205a0157fdcb402$var$itemGlareHeight), scene.applyScale($8205a0157fdcb402$var$itemGlareRadius), $8205a0157fdcb402$var$itemGlareColor, $8205a0157fdcb402$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "center-top",
                    offsetY: scene.applyScale(7),
                    expand: false
                }).add(scene.rexUI.add.label({
                    orientation: "x",
                    rtl: false,
                    icon: scene.createSquadMemberImage(scene, participant.playerImageKey).setScale(scene.applyScale(0.3)),
                    iconWidth: scene.applyScale(38),
                    iconHeight: scene.applyScale(38),
                    text: scene.add.bitmapText(0, 0, "cc_outline", participantName, scene.applyScale(20), 0).setAlpha(participant.inactive ? 0.4 : 1),
                    space: {
                        icon: scene.applyScale(10),
                        right: scene.applyScale(10)
                    }
                }), {
                    key: "item_name_label",
                    align: "left-top",
                    offsetX: scene.applyScale(21),
                    offsetY: scene.applyScale(24),
                    expand: false
                })// Value Display
                .add(scene.add.bitmapText(0, 0, "cc_outline", participant.value, scene.applyScale(18), 0), {
                    key: `value_label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-21),
                    offsetY: scene.applyScale(32),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    applyScale(length) {
        return length * this._scale;
    }
    getPlacingsData(participants) {
        var placings = [];
        participants.forEach((participant)=>{
            placings.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.placing
            });
        });
        // sort list by placing
        placings.sort((participant1, participant2)=>participant1.value - participant2.value);
        return placings;
    }
    getKillsData(participants) {
        var kills = [];
        participants.forEach((participant)=>{
            if (participant.kills !== 0) kills.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.kills
            });
        });
        kills.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return kills;
    }
    getEvadesData(participants) {
        var evades = [];
        participants.forEach((participant)=>{
            if (participant.evades !== 0) evades.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.evades
            });
        });
        evades.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return evades;
    }
    getLazesData(participants) {
        var lazes = [];
        participants.forEach((participant)=>{
            if (participant.suicides !== 0) lazes.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.lazes
            });
        });
        lazes.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return lazes;
    }
    getPlayerFromParticipants(results, walletId) {
        var player = undefined;
        results.forEach((participant)=>{
            if (participant.playerId == walletId) player = participant;
        });
        return player;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battleRoyaleResultsLeadersPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $8205a0157fdcb402$export$2e2bcd8739ae039(this.scene, x, y));
});




const $aa48837ca0f9969e$var$modalHeight = 600;
const $aa48837ca0f9969e$var$modalWidth = 1000;
const $aa48837ca0f9969e$var$modalRadius = 25;
const $aa48837ca0f9969e$var$modalColor = 0x1c1c2c;
const $aa48837ca0f9969e$var$modalAlpha = 1;
const $aa48837ca0f9969e$var$modalBorderColor = 0x3d4361;
const $aa48837ca0f9969e$var$modalBorderWidth = 1;
class $aa48837ca0f9969e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._participants = data.participants;
    }
    constructor(){
        super({
            key: "BattleRoyaleResultsScene"
        });
    }
    preload() {
        // Loads PFPs
        this._participants.forEach((participant)=>{
            this.load.image(participant.playerImageKey, participant.playerImageUrl);
        });
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$5426087ae1039ec0));
    }
    create() {
        // Gathers Player Data to be displayed
        this._player = (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().getPlayerFromParticipants(this._participants, (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress());
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($aa48837ca0f9969e$var$modalWidth, $aa48837ca0f9969e$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($aa48837ca0f9969e$var$modalWidth), this.applyScale($aa48837ca0f9969e$var$modalHeight), this.applyScale($aa48837ca0f9969e$var$modalRadius), $aa48837ca0f9969e$var$modalColor, $aa48837ca0f9969e$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($aa48837ca0f9969e$var$modalBorderWidth), $aa48837ca0f9969e$var$modalBorderColor, $aa48837ca0f9969e$var$modalAlpha);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $aa48837ca0f9969e$var$modalWidth * this._scale,
            height: $aa48837ca0f9969e$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Player Details Pane
        this._playerResultsPane = new (0, $0db21946d00a4136$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        sizer.add(this._playerResultsPane, {
            key: "br-player-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Add Player Payout Component
        this._playerPayoutPane = new (0, $91b6814afcba0706$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        sizer.add(this._playerPayoutPane, {
            key: "br-payout-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(300),
            expand: false
        });
        // Add Leaders Results Component
        this._leadersPane = new (0, $8205a0157fdcb402$export$2e2bcd8739ae039)(this, 0, 0, this._participants, this._scale);
        sizer.add(this._leadersPane, {
            key: "br-leaders-pane",
            align: "left-top",
            offsetX: this.applyScale(500),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createSquadMemberImage(scene, imageKey) {
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 3;
        smImageData.destroy();
        var squadMemberImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        squadMemberImage.displayHeight = scene.applyScale(48);
        squadMemberImage.scaleX = squadMemberImage.scaleY;
        return squadMemberImage;
    }
    destroy() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$5426087ae1039ec0)));
        // Unload Player PFPs
        const playerImageKeys = this._participants.map((participant)=>participant.playerImageKey);
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, playerImageKeys);
    }
}








// Pane Details
const $e492cf13d454f7f7$var$paneHeight = 300;
const $e492cf13d454f7f7$var$paneWidth = 500;
const $e492cf13d454f7f7$var$paneRadius = 25;
const $e492cf13d454f7f7$var$paneColor = 0x1c1c2c;
const $e492cf13d454f7f7$var$paneAlpha = 1;
class $e492cf13d454f7f7$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $e492cf13d454f7f7$var$paneWidth,
            height: paneScale * $e492cf13d454f7f7$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._playerData = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        if (this._playerData != undefined) {
            // Add Sizer for content
            var sizer = scene.rexUI.add.overlapSizer({
                width: scene.applyScale($e492cf13d454f7f7$var$paneWidth),
                height: scene.applyScale($e492cf13d454f7f7$var$paneHeight),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    item: 0,
                    line: 0
                },
                align: 0
            });
            // Add Results Text
            var title = scene.add.bitmapText(0, 0, "cc_outline", this._playerData.playerName, scene.applyScale(30), 0);
            sizer.add(title, {
                key: `player-title`,
                align: "center-top",
                offsetX: scene.applyScale(0),
                offsetY: scene.applyScale(20),
                expand: false
            });
            // Add Divider Top
            const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerTop, {
                key: "br-divider-top",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(70),
                expand: false
            });
            // Player PFP and Player Name
            var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._playerData.playerImageKey);
            var imageWidth = imageData.width;
            const rectConfig = {
                maskType: "roundRectangle",
                radius: Math.ceil(imageWidth / 8)
            };
            var image = scene.add.rexCircleMaskImage(0, 0, this._playerData.playerImageKey, "", rectConfig);
            image.displayHeight = scene.applyScale(179);
            image.scaleX = image.scaleY;
            imageData.destroy();
            sizer.add(scene.add.existing(image), {
                key: "nft_image",
                align: "left-top",
                offsetX: scene.applyScale(30),
                offsetY: scene.applyScale(90),
                expand: false
            });
            // Placing
            var placing = scene.add.bitmapText(0, 0, "cc_outline", "Placing: " + this.getPlacing(this._playerData), scene.applyScale(24), 0);
            sizer.add(placing, {
                key: `placing_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(90),
                expand: false
            });
            // Rounds
            var rounds = scene.add.bitmapText(0, 0, "cc_outline", "Rounds: " + this.getRoundsCount(this._playerData), scene.applyScale(24), 0);
            sizer.add(rounds, {
                key: `rounds_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(120),
                expand: false
            });
            // Damage
            var damage = scene.add.bitmapText(0, 0, "cc_outline", "Damage: " + this.getDamageDealt(this._playerData), scene.applyScale(24), 0);
            sizer.add(damage, {
                key: `damage_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(150),
                expand: false
            });
            // DMG Boost
            var dmgBoost = scene.add.bitmapText(0, 0, "cc_outline", "DMG Boost: " + this.getDamageBoost(this._playerData), scene.applyScale(24), 0);
            sizer.add(dmgBoost, {
                key: `dmgBoost_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(180),
                expand: false
            });
            // Resource Boost
            var rBoost = scene.add.bitmapText(0, 0, "cc_outline", "Resource Boost: " + this.getResourceBoost(this._playerData), scene.applyScale(24), 0);
            sizer.add(rBoost, {
                key: `rboost_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(210),
                expand: false
            });
            // SD Boost
            var sdBoost = scene.add.bitmapText(0, 0, "cc_outline", "StarDust Boost: " + this.getSDBoost(this._playerData), scene.applyScale(24), 0);
            sizer.add(sdBoost, {
                key: `sdboost_label`,
                align: "left-top",
                offsetX: scene.applyScale(250),
                offsetY: scene.applyScale(240),
                expand: false
            });
            this.add(sizer, {
                key: "player-panel",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getPlacing(playerData) {
        return playerData.placing;
    }
    getRoundsCount(playerData) {
        return playerData.roundsParticiapted;
    }
    getDamageDealt(playerData) {
        return `${Math.floor(parseFloat(playerData.damageDealt)).toLocaleString("en-us")}`;
    }
    getDamageBoost(playerData) {
        return playerData.bossFighterTraits.additionalDamagePercentageBoost * 100 + "%";
    }
    getResourceBoost(playerData) {
        return playerData.bossFighterTraits.offChainPercentageBoost * 100 + "%";
    }
    getSDBoost(playerData) {
        return playerData.bossFighterTraits.starDustPercentageBoost * 100 + "%";
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("bossFightResultsPlayerPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $e492cf13d454f7f7$export$2e2bcd8739ae039(this.scene, x, y));
});





// Pane Details
const $16925d52266b5f3f$var$paneHeight = 600;
const $16925d52266b5f3f$var$paneWidth = 500;
const $16925d52266b5f3f$var$paneRadius = 25;
const $16925d52266b5f3f$var$paneColor = 0x1c1c2c;
const $16925d52266b5f3f$var$paneAlpha = 1;
// Table Details
const $16925d52266b5f3f$var$itemWidth = 470, $16925d52266b5f3f$var$itemHeight = 73, $16925d52266b5f3f$var$itemRadius = 13, $16925d52266b5f3f$var$itemColor = 0x463851, $16925d52266b5f3f$var$itemAlpha = 0.3;
// Item Details
const $16925d52266b5f3f$var$itemGlareHeight = 7, $16925d52266b5f3f$var$itemGlareRadius = 4, $16925d52266b5f3f$var$itemGlareColor = 0xffffff, $16925d52266b5f3f$var$itemGlareAlpha = 0.08;
const $16925d52266b5f3f$var$categories = {
    damage: "damage",
    rounds: "rounds",
    spaceElixir: "spaceElixir",
    neonGold: "neonGold",
    starDust: "starDust"
};
class $16925d52266b5f3f$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $16925d52266b5f3f$var$paneWidth,
            height: paneScale * $16925d52266b5f3f$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._participants = data;
        // Split participants data into sorted lists per category
        this._damages = this.getDamageData(this._participants);
        this._rounds = this.getRoundsData(this._participants);
        this._spaceElixirs = this.getSpaceElixirData(this._participants);
        this._neonGolds = this.getNeonGoldData(this._participants);
        this._starDusts = this.getStarDustData(this._participants);
        this._scale = paneScale;
        scene.input.topOnly = false;
        scene.input.setDefaultCursor("default");
        this._selectedCategory = $16925d52266b5f3f$var$categories.damage;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Add Sizer for content
        var sizer = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($16925d52266b5f3f$var$paneWidth),
            height: scene.applyScale($16925d52266b5f3f$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Add Pane Divider
        const dividerLeft = scene.add.image(0, 0, "battleroyale_results_pane_divider").setScale(this._scale);
        sizer.add(dividerLeft, {
            key: "br-divider-left",
            align: "left-top",
            offsetX: this.applyScale(1),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Add Results Text
        var resultsText = scene.add.bitmapText(0, 0, "cc_outline", "Leaderboard", scene.applyScale(30), 0);
        sizer.add(resultsText, {
            key: `details-title`,
            align: "center-top",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(20),
            expand: false
        });
        // Add Divider Top
        const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
        sizer.add(dividerTop, {
            key: "br-divider-top",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(70),
            expand: false
        });
        //Buttons Sizer
        var buttonSizer = scene.rexUI.add.fixWidthSizer({
            width: this.applyScale($16925d52266b5f3f$var$paneWidth),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Damage Button
        this._damageButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_damage_button", false).setOrigin(0, 0.5).setScale(this._scale);
        this._damageButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $16925d52266b5f3f$var$categories.damage;
            this._roundsButton.setTexture("bossfight_rounds_button_inactive");
            this._damageButton.setTexture("bossfight_damage_button");
            this._spaceElixirButton.setTexture("bossfight_space_elixir_button_inactive");
            this._neonGoldButton.setTexture("bossfight_neon_gold_button_inactive");
            this._starDustButton.setTexture("bossfight_star_dust_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._damages, 0, 0, this.scale, $16925d52266b5f3f$var$categories.damage).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._damageButton), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "placings_button"
        });
        // Rounds Button
        this._roundsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_rounds_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._roundsButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $16925d52266b5f3f$var$categories.rounds;
            this._roundsButton.setTexture("bossfight_rounds_button");
            this._damageButton.setTexture("bossfight_damage_button_inactive");
            this._spaceElixirButton.setTexture("bossfight_space_elixir_button_inactive");
            this._neonGoldButton.setTexture("bossfight_neon_gold_button_inactive");
            this._starDustButton.setTexture("bossfight_star_dust_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._rounds, 0, 0, this.scale, $16925d52266b5f3f$var$categories.rounds).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._roundsButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "kills_button"
        });
        // Space Elixir Button
        this._spaceElixirButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_space_elixir_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._spaceElixirButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $16925d52266b5f3f$var$categories.spaceElixir;
            this._roundsButton.setTexture("bossfight_rounds_button_inactive");
            this._damageButton.setTexture("bossfight_damage_button_inactive");
            this._spaceElixirButton.setTexture("bossfight_space_elixir_button");
            this._neonGoldButton.setTexture("bossfight_neon_gold_button_inactive");
            this._starDustButton.setTexture("bossfight_star_dust_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._spaceElixirs, 0, 0, this.scale, $16925d52266b5f3f$var$categories.spaceElixir).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._spaceElixirButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "evades_button"
        });
        // Neon Gold Button
        this._neonGoldButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_neon_gold_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._neonGoldButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $16925d52266b5f3f$var$categories.neonGold;
            this._roundsButton.setTexture("bossfight_rounds_button_inactive");
            this._damageButton.setTexture("bossfight_damage_button_inactive");
            this._spaceElixirButton.setTexture("bossfight_space_elixir_button_inactive");
            this._neonGoldButton.setTexture("bossfight_neon_gold_button");
            this._starDustButton.setTexture("bossfight_star_dust_button_inactive");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._neonGolds, 0, 0, this.scale, $16925d52266b5f3f$var$categories.neonGold).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._neonGoldButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "neongold_button"
        });
        // Star Dust Button
        this._starDustButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_star_dust_button_inactive", false).setOrigin(0, 0.5).setScale(this._scale);
        this._starDustButton.onClick().subscribe((pointer)=>{
            this._selectedCategory = $16925d52266b5f3f$var$categories.starDust;
            this._roundsButton.setTexture("bossfight_rounds_button_inactive");
            this._damageButton.setTexture("bossfight_damage_button_inactive");
            this._spaceElixirButton.setTexture("bossfight_space_elixir_button_inactive");
            this._neonGoldButton.setTexture("bossfight_neon_gold_button_inactive");
            this._starDustButton.setTexture("bossfight_star_dust_button");
            this._table.setAlpha(0);
            sizer.remove(this._table);
            this._table.destroy();
            this._table = undefined;
            this._table = this.createTable(scene, this._starDusts, 0, 0, this.scale, $16925d52266b5f3f$var$categories.starDust).layout();
            sizer.add(this._table, {
                key: "results-table",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(200),
                expand: false
            });
            sizer.layout();
        });
        buttonSizer.add(scene.add.existing(this._starDustButton), {
            padding: {
                left: this.applyScale(15),
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "stardust_button"
        });
        sizer.add(scene.add.existing(buttonSizer), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(18)
            },
            key: "button_sizer"
        });
        sizer.add(buttonSizer, {
            key: "br-button-sizer",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(100),
            expand: false
        });
        this.add(sizer, {
            key: "battle-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Add Divider Bottom
        const dividerBottom = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
        sizer.add(dividerBottom, {
            key: "br-divider-bottom",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(170),
            expand: false
        });
        // Add Table
        this._table = this.createTable(scene, this._damages, 0, 0, this.scale, $16925d52266b5f3f$var$categories.damage).layout();
        sizer.add(this._table, {
            key: "results-table",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(190),
            expand: false
        });
        // Return Home Button
        this._returnHome = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "bossfight_victory_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHome.onClick().subscribe((pointer)=>{
            scene.destroy();
        });
        sizer.add(scene.add.existing(this._returnHome), {
            key: "return-home-button",
            align: "center-bottom",
            offsetX: 0,
            offsetY: scene.applyScale(-10),
            expand: false
        });
        this.layout();
    }
    createTable(scene, data, x, y, scale, category) {
        var tableHeight = ($16925d52266b5f3f$var$itemHeight + 7) * 4;
        var table = scene.rexUI.add.gridTable({
            width: scene.applyScale($16925d52266b5f3f$var$paneWidth),
            height: scene.applyScale(tableHeight),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale($16925d52266b5f3f$var$itemWidth),
                cellHeight: this.applyScale($16925d52266b5f3f$var$itemHeight + 7),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, participant = cell.item;
                const participantName = participant.playerName;
                var value = "";
                switch(category){
                    case $16925d52266b5f3f$var$categories.starDust:
                    case $16925d52266b5f3f$var$categories.rounds:
                        value = participant.value.toLocaleString("en-us");
                        break;
                    case $16925d52266b5f3f$var$categories.damage:
                    case $16925d52266b5f3f$var$categories.spaceElixir:
                    case $16925d52266b5f3f$var$categories.neonGold:
                        value = `${Math.floor(parseFloat(participant.value)).toLocaleString("en-us")}`;
                }
                const rectConfig = {
                    maskType: "roundRectangle",
                    radius: scene.applyScale(40)
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale($16925d52266b5f3f$var$itemWidth),
                    space: {
                        left: scene.applyScale(20),
                        right: 0,
                        top: 0,
                        bottom: scene.applyScale(7),
                        item: 0,
                        line: 0
                    },
                    align: 0
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($16925d52266b5f3f$var$itemWidth), scene.applyScale($16925d52266b5f3f$var$itemHeight), scene.applyScale($16925d52266b5f3f$var$itemRadius), $16925d52266b5f3f$var$itemColor, $16925d52266b5f3f$var$itemAlpha), {
                    key: "staking_item_bg",
                    align: "center"
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale($16925d52266b5f3f$var$itemWidth - 15), scene.applyScale($16925d52266b5f3f$var$itemGlareHeight), scene.applyScale($16925d52266b5f3f$var$itemGlareRadius), $16925d52266b5f3f$var$itemGlareColor, $16925d52266b5f3f$var$itemGlareAlpha), {
                    key: "item_glare",
                    align: "center-top",
                    offsetY: scene.applyScale(7),
                    expand: false
                }).add(scene.rexUI.add.label({
                    orientation: "x",
                    rtl: false,
                    icon: scene.createSquadMemberImage(scene, participant.playerImageKey).setScale(scene.applyScale(0.3)),
                    iconWidth: scene.applyScale(38),
                    iconHeight: scene.applyScale(38),
                    text: scene.add.bitmapText(0, 0, "cc_outline", participantName, scene.applyScale(20), 0).setAlpha(participant.inactive ? 0.4 : 1),
                    space: {
                        icon: scene.applyScale(10),
                        right: scene.applyScale(10)
                    }
                }).setInteractive({
                    useHandCursor: true
                }).on("pointerdown", ()=>scene.newPlayerSelected(participantName)), {
                    key: "item_name_label",
                    align: "left-top",
                    offsetX: scene.applyScale(21),
                    offsetY: scene.applyScale(24),
                    expand: false
                })// Value Display
                .add(scene.add.bitmapText(0, 0, "cc_outline", value, scene.applyScale(18), 0), {
                    key: `value_label`,
                    align: "right-top",
                    offsetX: scene.applyScale(-21),
                    offsetY: scene.applyScale(32),
                    expand: false
                });
                return sizer;
            }
        }).setOrigin(0.5, 0);
        return table;
    }
    callback() {}
    applyScale(length) {
        return length * this._scale;
    }
    getDamageData(participants) {
        var damages = [];
        participants.forEach((participant)=>{
            damages.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.damageDealt
            });
        });
        // List already sorted on backend by damage dealt
        return damages;
    }
    getRoundsData(participants) {
        var rounds = [];
        participants.forEach((participant)=>{
            rounds.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.roundsParticiapted
            });
        });
        rounds.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return rounds;
    }
    getSpaceElixirData(participants) {
        var spaceElixirs = [];
        participants.forEach((participant)=>{
            spaceElixirs.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.payout.spaceElixir
            });
        });
        spaceElixirs.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return spaceElixirs;
    }
    getNeonGoldData(participants) {
        var neonGolds = [];
        participants.forEach((participant)=>{
            neonGolds.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.payout.neonGold
            });
        });
        neonGolds.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return neonGolds;
    }
    getStarDustData(participants) {
        var neonGolds = [];
        participants.forEach((participant)=>{
            neonGolds.push({
                playerName: participant.playerName,
                playerImageKey: participant.playerImageKey,
                value: participant.payout.starDust
            });
        });
        neonGolds.sort((participant1, participant2)=>participant1.value - participant2.value).reverse();
        return neonGolds;
    }
    getPlayerFromParticipants(results, walletId) {
        var player = undefined;
        results.forEach((participant)=>{
            if (participant.playerId.toLowerCase() === walletId.toLowerCase()) player = participant;
        });
        return player;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("bossFightResultsLeadersPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $16925d52266b5f3f$export$2e2bcd8739ae039(this.scene, x, y));
});





// Pane Details
const $614039f87022b0a0$var$paneHeight = 300;
const $614039f87022b0a0$var$paneWidth = 500;
const $614039f87022b0a0$var$paneRadius = 25;
const $614039f87022b0a0$var$paneColor = 0x1c1c2c;
const $614039f87022b0a0$var$paneAlpha = 1;
class $614039f87022b0a0$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $614039f87022b0a0$var$paneWidth,
            height: paneScale * $614039f87022b0a0$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._payout = data;
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        if (this._payout != undefined) {
            // Add Sizer for content
            var sizer = scene.rexUI.add.overlapSizer({
                width: scene.applyScale($614039f87022b0a0$var$paneWidth),
                height: scene.applyScale($614039f87022b0a0$var$paneHeight),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    item: 0,
                    line: 0
                },
                align: 0
            });
            // Add Divider Top
            const dividerTop = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerTop, {
                key: "br-divider-top",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
            // Add Payout Text
            var resultsText = scene.add.bitmapText(0, 0, "cc_outline", "Payout", scene.applyScale(30), 0);
            sizer.add(resultsText, {
                key: `payout-title`,
                align: "center-top",
                offsetX: scene.applyScale(0),
                offsetY: scene.applyScale(20),
                expand: false
            });
            // Add Divider Below
            const dividerBelow = scene.add.image(0, 0, "battleroyale_results_divider").setScale(this._scale);
            sizer.add(dividerBelow, {
                key: "br-divider-below",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(70),
                expand: false
            });
            // Payout Details
            this._spaceElixirBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "space_elixir", this._payout.spaceElixir.toLocaleString("en-us"));
            sizer.add(this._spaceElixirBar, {
                key: "br-se-bar",
                align: "left-top",
                offsetX: this.applyScale(25),
                offsetY: this.applyScale(120),
                expand: false
            });
            this._neonGoldBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "neon_gold", this._payout.neonGold.toLocaleString("en-us"));
            sizer.add(this._neonGoldBar, {
                key: "br-ng-bar",
                align: "left-top",
                offsetX: this.applyScale(262),
                offsetY: this.applyScale(120),
                expand: false
            });
            this._starDustBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, "stardust", this._payout.starDust.toLocaleString("en-us"));
            sizer.add(this._starDustBar, {
                key: "bossfight-sd-bar",
                align: "left-top",
                offsetX: this.applyScale(25),
                offsetY: this.applyScale(180),
                expand: false
            });
            this._xpBar = new (0, $f2455290b574f2b7$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, undefined, /*`${this._payout.xp} xp`*/ "500 xp");
            sizer.add(this._xpBar, {
                key: "bossfight-xp-bar",
                align: "left-top",
                offsetX: this.applyScale(262),
                offsetY: this.applyScale(180),
                expand: false
            });
            this.add(sizer, {
                key: "resources-panel",
                align: "left-top",
                offsetX: this.applyScale(0),
                offsetY: this.applyScale(0),
                expand: false
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("bossFightResultsPayoutPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $614039f87022b0a0$export$2e2bcd8739ae039(this.scene, x, y));
});




const $9a8873bbd90f230f$var$modalHeight = 600;
const $9a8873bbd90f230f$var$modalWidth = 1000;
const $9a8873bbd90f230f$var$modalRadius = 25;
const $9a8873bbd90f230f$var$modalColor = 0x1c1c2c;
const $9a8873bbd90f230f$var$modalAlpha = 1;
const $9a8873bbd90f230f$var$modalBorderColor = 0x3d4361;
const $9a8873bbd90f230f$var$modalBorderWidth = 1;
class $9a8873bbd90f230f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._participants = [
            {
                playerId: "0x07Bc74Bb5273bB29338cB89db90d867136bBfcfA",
                playerName: "!howldoiplay",
                playerImageKey: "nft_328036289",
                playerImageUrl: "https://lh3.googleusercontent.com/ykHwoVKjNupwrDOLhYMoRBcVkVXLqE03pTBNSE57ehsZO7O4MIJegy9c5C-xzt4KXiVaChTAkJeJg8a_0-LbrMFw7JvmRHmSzFG9ow=s128",
                clientId: "bgI1N9OTU",
                placing: 1,
                roundsParticiapted: 6,
                damage: 13703,
                damageDealt: 82218,
                level: 3968,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.45,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 47500000,
                    neonGoldStorageTotal: 47500000,
                    spaceElixir: 1438250,
                    neonGold: 1438250,
                    starDust: 11
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0xeB9BA435B89f701D45b2f3782207d4E824466783",
                playerName: "Dragon",
                playerImageKey: "nft_328036246",
                playerImageUrl: "https://lh3.googleusercontent.com/JaD5FLiuSt9c6EJwACAVzr0WMbnzbI40YLCLUC65PD3OMI2tYt9_IpxKRPaG-Fu89cGh9B53SS-ZE97Q46GoEW7eRFAx-cFa6MOi_po=s128",
                clientId: "d8BSWTOf0",
                placing: 2,
                roundsParticiapted: 5,
                damage: 13703,
                damageDealt: 68515,
                level: 2854,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.45,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 45000000,
                    neonGoldStorageTotal: 43500000,
                    spaceElixir: 1141250,
                    neonGold: 1106875,
                    starDust: 9.16
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0x4D3f9df696d8EFD93e82e33566d037cbb3362EfD",
                playerName: "WHITTY",
                playerImageKey: "nft_328036302",
                playerImageUrl: "https://lh3.googleusercontent.com/GkK-uOqBZot_rKNeQ1wHSmgMKDZKXa86ED4MAL9dc3fCdaPByVLwl1GaowzfBZfTrYW5h4pHJef_21kk1k5RrXKhyLHXB5Lj0BEC9-U=s128",
                clientId: "XPuDEYIG2",
                placing: 3,
                roundsParticiapted: 6,
                damage: 10733,
                damageDealt: 64398,
                level: 6229,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.35,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 13740000,
                    neonGoldStorageTotal: 13250000,
                    spaceElixir: 509850,
                    neonGold: 496375,
                    starDust: 11
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0x831BDF2378d5Af57F50e19F6a28500969B1b1c51",
                playerName: "Tonimeng",
                playerImageKey: "nft_274267157",
                playerImageUrl: "https://lh3.googleusercontent.com/vgdiQog8pa4nPkay9NpINNJgYHrGm-RIh9fuAwJ9QePvxjpSPM5kQ113e6g9ALHL7I18r29XD6VOnAIYUSVeX5usJmzogdRBwJzOYw=s128",
                clientId: "eEK1tvOcc",
                placing: 4,
                roundsParticiapted: 6,
                damage: 10733,
                damageDealt: 64398,
                level: 13534,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.35,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 47500000,
                    neonGoldStorageTotal: 47500000,
                    spaceElixir: 1438250,
                    neonGold: 1438250,
                    starDust: 11
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0x71190CAcB8Dc40d288625B87Ab2a56fD8641AaC3",
                playerName: "yolaEric",
                playerImageKey: "nft_304651248",
                playerImageUrl: "https://lh3.googleusercontent.com/63fXyxO7hTgOCx6TK6CI_ihxrhfHivGumhtkXsaZnqZ4K1_Bhg9zVDxRM9BZopqsqomUkVhKOR9OkHw1F9pNb78D2cBZgSNrABgAdA=s128",
                clientId: "RYp-SaJgU",
                placing: 5,
                roundsParticiapted: 6,
                damage: 8832,
                damageDealt: 52992,
                level: 4535,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.27,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 34400000,
                    neonGoldStorageTotal: 34400000,
                    spaceElixir: 1078000,
                    neonGold: 1078000,
                    starDust: 11
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0x28e15B0eB947333fBc71A83F4A20c2A95AcCcf6a",
                playerName: "OneShot",
                playerImageKey: "nft_236484847",
                playerImageUrl: "https://lh3.googleusercontent.com/TzPEquoszOCO2lTJWNeD-hqtv_bk9NpJ_IrXZYPsabReKRQIPtfqczrzPdxIcc32kOxfqjBfs65CVaJLA_mJjDjMlhpAgRUD1xGT=s128",
                clientId: "V01F1z7Mi",
                placing: 6,
                roundsParticiapted: 5,
                damage: 9135,
                damageDealt: 45675,
                level: 1863,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.45,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 28500000,
                    neonGoldStorageTotal: 28900000,
                    spaceElixir: 763125,
                    neonGold: 772291,
                    starDust: 9.16
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0xA786bAED9d87aAa039C7C97B166A419d9F42eAa6",
                playerName: "Lukeh",
                playerImageKey: "nft_317575408",
                playerImageUrl: "https://lh3.googleusercontent.com/ySKhT1Qs2zVr9G8t6qd0oZj5PBVp0Jm5BJF8sPHEN-fA9QbykGe-E8Gb88YMvTetCSOzf42RYny8uErs6z4FRMO5b7AOzZBg0HuniA=s128",
                clientId: "BxNGBEOD7",
                placing: 7,
                roundsParticiapted: 6,
                damage: 7426,
                damageDealt: 44556,
                level: 622,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.41,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 20100000,
                    neonGoldStorageTotal: 20500000,
                    spaceElixir: 622500,
                    neonGold: 632500,
                    starDust: 10
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0x593ffa500d70b9F64B057C1D45f5a2986C71D9EC",
                playerName: "Wrath",
                playerImageKey: "nft_317575331",
                playerImageUrl: "https://lh3.googleusercontent.com/XDd-uFl1tyn51U3gG7zJWCyUxb_XzzpTKGc4IRopGrb_gzeprORGCjI4Qkbhq22SSiRjtRXdR4jqw645tRpz7ao6q2BRi_6IubDMtg=s128",
                clientId: "tIu6B5BOu",
                placing: 8,
                roundsParticiapted: 6,
                damage: 5849,
                damageDealt: 35094,
                level: 337,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.15,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 3650000,
                    neonGoldStorageTotal: 7350000,
                    spaceElixir: 211250,
                    neonGold: 303750,
                    starDust: 10
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0x4571EB475E04608A83D8ebeC81E88DD170583a1B",
                playerName: "Sir Linkin",
                playerImageKey: "nft_317575304",
                playerImageUrl: "https://lh3.googleusercontent.com/lOnm_jtS40XKhvcwgtVN0xjiJXWDzVRtw8FvHpLFjJCt1oKW7JQuwRq2efNGismMYQ8aRnG9t56ABQExTd5bO5bFS0OmnJk-lSpCkvA=s128",
                clientId: "wQQG4ORO0",
                placing: 9,
                roundsParticiapted: 2,
                damage: 13703,
                damageDealt: 27406,
                level: 4472,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.45,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 46000000,
                    neonGoldStorageTotal: 46000000,
                    spaceElixir: 465666,
                    neonGold: 465666,
                    starDust: 3.66
                },
                squadUpdated: false,
                brawlerCage: true
            },
            {
                playerId: "0x2C8745d428e3052fe79eA7CF9FEAb7a4CB167F67",
                playerName: "Chewbarka",
                playerImageKey: "nft_375138646",
                playerImageUrl: "https://lh3.googleusercontent.com/z_3Ep_vZvMhdQ1b8J6SKM5wDj18cbFkJNB8HzzY8akAXzsirmdeF5QiQFgIXloLi0ybVlT927M_XrbYk1LIjGPtFli121pNrSa3n-w=s128",
                clientId: "fB0lFZXuf",
                placing: 10,
                roundsParticiapted: 6,
                damage: 3842,
                damageDealt: 23052,
                level: 932,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 10000000,
                    neonGoldStorageTotal: 10000000,
                    spaceElixir: 370000,
                    neonGold: 370000,
                    starDust: 10
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0xcBcf5f3f87aaFf8EC6C564A5FE6D34654eB61be4",
                playerName: "Groovy Lizard",
                playerImageKey: "nft_59725359",
                playerImageUrl: "https://lh3.googleusercontent.com/PEf5I1UlERY36q1kQyfFWob1ifhvkT8Exz76yHJdYDFBRhfVAdcILM17Ep74-WJ0Z2j0TPgiPMwfzkrGE9swUPxOihVed2VQlP0xY7M=s128",
                clientId: "TClCogL8o",
                placing: 11,
                roundsParticiapted: 6,
                damage: 2417,
                damageDealt: 14502,
                level: 158,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 1650000,
                    neonGoldStorageTotal: 1650000,
                    spaceElixir: 140625,
                    neonGold: 140625,
                    starDust: 1.5
                },
                squadUpdated: true,
                brawlerCage: false
            },
            {
                playerId: "0xC5924ef2F2D46611bBe352A7d666bF003BD24c5b",
                playerName: "Toyo Carolla",
                playerImageKey: "nft_375141934",
                playerImageUrl: "https://lh3.googleusercontent.com/su8J_iZ0vnGmY9-_229mKECN_MX696neqEzev5eE4mEfamtcS_ztngFDbIJUXPfnXbhQDUoNsjQqmtYwOSmn9WbqVkUaoeLy0ePmyg=s128",
                clientId: "jFczDamNJ",
                placing: 12,
                roundsParticiapted: 2,
                damage: 6823,
                damageDealt: 13646,
                level: 1007,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.43,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 33000000,
                    neonGoldStorageTotal: 33500000,
                    spaceElixir: 177500,
                    neonGold: 179583,
                    starDust: 0.5
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0x988b9ecAA893F324Bb42fbD8A24b953180d7eF51",
                playerName: "Miniwolf",
                playerImageKey: "nft_375141406",
                playerImageUrl: "https://lh3.googleusercontent.com/kGO7EvnD8Vt30nLtjCUQWwYdStnvIqLGmBdy1w8WMTJyaAySbqCmlZSuTHEgRnLG2IMSNjirUwqwrdYRQYMorT1BegOxUQtUrgG0=s128",
                clientId: "Yj-1J08Ui",
                placing: 13,
                roundsParticiapted: 2,
                damage: 6092,
                damageDealt: 12184,
                level: 1089,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 7300000,
                    neonGoldStorageTotal: 8190000,
                    spaceElixir: 70417,
                    neonGold: 74125,
                    starDust: 0.5
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0x9F6C02E1124199C9a21D477dAD5eC93552c5E6Ff",
                playerName: "Linked",
                playerImageKey: "nft_373651677",
                playerImageUrl: "https://lh3.googleusercontent.com/0Z2rK2J5PTDuA4Jmn3jD6oNiJtx4kkoUTKottOUHSDeElyYkosq0WfbWa8kGPghBX69z_t0tKe-A5hrgDX4cWy-ymSDwGFixh9ne=s128",
                clientId: "BLHYl_NM8",
                placing: 14,
                roundsParticiapted: 2,
                damage: 4840,
                damageDealt: 9680,
                level: 1251,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.23,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 7835000,
                    neonGoldStorageTotal: 8640000,
                    spaceElixir: 72646,
                    neonGold: 76000,
                    starDust: 0.5
                },
                squadUpdated: false,
                brawlerCage: false
            },
            {
                playerId: "0x7B33918967eb8F48983cEDCAcBe4601cDa2681c3",
                playerName: "tendies",
                playerImageKey: "nft_373965365",
                playerImageUrl: "https://lh3.googleusercontent.com/cQ_ngOqPOvS6_UahBo92x7MGfmKRlnX8fj7tFNw0zCqjuDUnWvscVSO22lxheZobL0_vu6QR7FNW0K-Nnd0w5Dfmvflp0LI5Ia7nGw=s128",
                clientId: "E9WAyJcjw",
                placing: 15,
                roundsParticiapted: 2,
                damage: 3650,
                damageDealt: 7300,
                level: 152,
                xp: 500,
                nextXpRank: 0,
                isAttacking: false,
                inactive: false,
                bossFighterTraits: {
                    additionalDamagePercentageBoost: 0.08,
                    starDustPercentageBoost: 0,
                    offChainPercentageBoost: 0
                },
                payout: {
                    spaceElixirStorageTotal: 1473000,
                    neonGoldStorageTotal: 1600000,
                    spaceElixir: 46138,
                    neonGold: 46667,
                    starDust: 0.5
                },
                squadUpdated: false,
                brawlerCage: false
            }
        ];
    }
    constructor(){
        super({
            key: "BossFightResultsScene"
        });
    }
    preload() {
        this._participants = (0, $f79188864c3182db$export$2e2bcd8739ae039).getInstance().getBattleData().participants;
        // Loads PFPs
        this._participants.forEach((participant)=>{
            this.load.image(participant.playerImageKey, participant.playerImageUrl);
        });
        // Results Pane
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$2399afebcbea323e));
    }
    create() {
        // Gathers Player Data to be displayed
        this._player = this.getPlayerFromParticipants(this._participants);
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($9a8873bbd90f230f$var$modalWidth, $9a8873bbd90f230f$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($9a8873bbd90f230f$var$modalWidth), this.applyScale($9a8873bbd90f230f$var$modalHeight), this.applyScale($9a8873bbd90f230f$var$modalRadius), $9a8873bbd90f230f$var$modalColor, $9a8873bbd90f230f$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($9a8873bbd90f230f$var$modalBorderWidth), $9a8873bbd90f230f$var$modalBorderColor, $9a8873bbd90f230f$var$modalAlpha);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $9a8873bbd90f230f$var$modalWidth * this._scale,
            height: $9a8873bbd90f230f$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Player Details Pane
        this._playerResultsPane = new (0, $e492cf13d454f7f7$export$2e2bcd8739ae039)(this, 0, 0, this._player, this._scale);
        this._sizer.add(this._playerResultsPane, {
            key: "br-player-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        //Add Player Payout Component
        this._playerPayoutPane = new (0, $614039f87022b0a0$export$2e2bcd8739ae039)(this, 0, 0, this._player.payout, this._scale);
        this._sizer.add(this._playerPayoutPane, {
            key: "br-payout-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(300),
            expand: false
        });
        // Add Leaders Results Component
        this._leadersPane = new (0, $16925d52266b5f3f$export$2e2bcd8739ae039)(this, 0, 0, this._participants, this._scale);
        this._sizer.add(this._leadersPane, {
            key: "br-leaders-pane",
            align: "left-top",
            offsetX: this.applyScale(500),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Layout the Scene
        this._sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createSquadMemberImage(scene, imageKey) {
        // Squad Member Image
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const smImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        const smImageWidth = smImageData.width;
        rectConfig.radius = smImageWidth / 3;
        smImageData.destroy();
        var squadMemberImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        squadMemberImage.displayHeight = scene.applyScale(48);
        squadMemberImage.scaleX = squadMemberImage.scaleY;
        return squadMemberImage;
    }
    destroy() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop();
    }
    getPlayerFromParticipants(results) {
        var player = undefined;
        for(var i = 0; i < results.length; i++){
            var participant = results[i];
            if (participant.playerId.toLowerCase() === (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress().toLowerCase()) player = participant;
        }
        return player;
    }
    getPlayerFromParticipantsByName(participantName) {
        var player = undefined;
        this._participants.forEach((participant)=>{
            if (participant.playerName === participantName) player = participant;
        });
        return player;
    }
    newPlayerSelected(participantName) {
        var selectedPlayer = this.getPlayerFromParticipantsByName(participantName);
        this._playerResultsPane.destroy();
        this._playerPayoutPane.destroy();
        // Player Details Pane
        this._playerResultsPane = new (0, $e492cf13d454f7f7$export$2e2bcd8739ae039)(this, 0, 0, selectedPlayer, this._scale);
        this._sizer.add(this._playerResultsPane, {
            key: "br-player-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        //Add Player Payout Component
        this._playerPayoutPane = new (0, $614039f87022b0a0$export$2e2bcd8739ae039)(this, 0, 0, selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.payout, this._scale);
        this._sizer.add(this._playerPayoutPane, {
            key: "br-payout-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(300),
            expand: false
        });
        this._sizer.layout();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$2399afebcbea323e)));
        // Unload Player PFPs
        const playerImageKeys = this._participants.map((participant)=>participant.playerImageKey);
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, playerImageKeys);
    }
}









var $f1q41 = parcelRequire("f1q41");







const $b16e0f035e16bc60$var$imageHeight = 149;
const $b16e0f035e16bc60$var$blueProgressBarColor = 0x00a6d3;
const $b16e0f035e16bc60$var$progressBarAlpha = 1;
const $b16e0f035e16bc60$var$glareColor = 0xffffff;
const $b16e0f035e16bc60$var$glareAlpha = 0.17;
const $b16e0f035e16bc60$var$glareRadius = 3;
const $b16e0f035e16bc60$var$glareHeight = 6;
const $b16e0f035e16bc60$var$glareOffset = 10;
const $b16e0f035e16bc60$var$backgroundColor = 0x440d31;
const $b16e0f035e16bc60$var$backgroundAlpha = 1;
const $b16e0f035e16bc60$var$radius = 7;
const $b16e0f035e16bc60$var$progressBarBorderColor = 0x383d57;
const $b16e0f035e16bc60$var$progressBarBorderWidth = 1;
const $b16e0f035e16bc60$var$progressBarHeight = 22;
const $b16e0f035e16bc60$var$progressBarWidth = $b16e0f035e16bc60$var$imageHeight - 12;
const $b16e0f035e16bc60$var$progressBarMin = 0;
const $b16e0f035e16bc60$var$stakingWaitPeriod = 604800; // 7 days in seconds
class $b16e0f035e16bc60$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._troopItem = data;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        if (!data.machine_unit_id) {
            if (!data.id) return this.layout();
            // Must be squad member
            return this.createSquadComponent(scene);
        }
        // NFT Image
        var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this.getImageKey());
        var imageWidth = imageData.width;
        const rectConfig = {
            maskType: "roundRectangle",
            radius: Math.ceil(imageWidth / 8)
        };
        this._troopImage = scene.add.rexCircleMaskImage(0, 0, this.getImageKey(), "", rectConfig);
        this._troopImage.displayHeight = scene.applyScale($b16e0f035e16bc60$var$imageHeight);
        this._troopImage.scaleX = this._troopImage.scaleY;
        imageData.destroy();
        this.add(this._troopImage, {
            key: "nft_image",
            align: "center-top",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(12),
            expand: false
        });
        // Count Badge
        if (this._troopItem.count > 1) {
            this._countBadge = scene.rexUI.add.badgeLabel({
                x: 0,
                y: 0,
                width: scene.applyScale(27),
                height: scene.applyScale(29),
                space: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                background: scene.add.image(0, 0, "troop_count_circle").setScale(this._scale),
                main: scene.add.bitmapText(0, 0, "cc_outline", `${this._troopItem.count.toLocaleString("en-us")}`, scene.applyScale(16), 0)
            }).layout();
            this.add(scene.add.existing(this._countBadge), {
                key: "count_badge",
                align: "left-top",
                offsetX: this.applyScale(-8),
                offsetY: this.applyScale(0),
                expand: false
            });
        }
        // Remove Button
        this._removeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "remove_troop_button", false).setScale(this._scale);
        this._removeButton.onClick().subscribe((pointer)=>{
            this.removeButtonClickHandler(pointer);
        });
        this.add(scene.add.existing(this._removeButton), {
            key: "remove_button",
            align: "right-top",
            offsetX: this.applyScale(8),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Progress Bar
        if (this._troopItem.time_until_next_level && this._troopItem.indexByType === 0) {
            const trainableTroops = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTrainableTroopsByMachineSync(0);
            const troopInfo = trainableTroops.find((tt)=>{
                return tt.machine_unit_id === this._troopItem.machine_unit_id && tt.level === this._troopItem.base_level;
            });
            const maxValue = troopInfo ? troopInfo.unit_time_to_build : 0;
            this._trainTimeRemaining = (0, $f12f0c85b935f07d$export$bb44e56f8c7ecf33)(this._troopItem.time_until_next_level);
            this._progressBar = this.createProgressBar(scene, this._trainTimeRemaining, maxValue);
            this.add(this._progressBar, {
                key: "progress_bar",
                align: "center-bottom",
                offsetX: 0,
                offsetY: this.applyScale(-8),
                expand: false
            });
            let progressBarIntervalFunction = ()=>{
                try {
                    if (this._trainTimeRemaining <= 0) {
                        clearInterval(progressBarInterval);
                        scene.updateTrainingPane();
                    } else {
                        this._trainTimeRemaining--;
                        this._trainTimeRemaining = this._trainTimeRemaining < 0 ? 0 : this._trainTimeRemaining;
                        this._progressBar.setTitle((0, $f12f0c85b935f07d$export$a14e8754c327dfd0)(this._trainTimeRemaining));
                        this._progressBar.setProgressValue(this, this._trainTimeRemaining);
                    }
                } catch (error) {
                    clearInterval(progressBarInterval);
                }
            };
            let progressBarInterval = setInterval(progressBarIntervalFunction, 1000);
        }
        return this.layout();
    }
    createSquadComponent(scene) {
        // NFT Image
        var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this.getImageKey());
        var imageWidth = imageData.width;
        const rectConfig = {
            maskType: "roundRectangle",
            radius: Math.ceil(imageWidth / 8)
        };
        this._troopImage = scene.add.rexCircleMaskImage(0, 0, this.getImageKey(), "", rectConfig);
        this._troopImage.displayHeight = scene.applyScale($b16e0f035e16bc60$var$imageHeight);
        this._troopImage.scaleX = this._troopImage.scaleY;
        imageData.destroy();
        this.add(this._troopImage, {
            key: "nft_image",
            align: "center-top",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(12),
            expand: false
        });
        return this.layout();
    }
    createProgressBar(scene, progressValue, maxValue) {
        // Progress Bar
        const progBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: (0, $f12f0c85b935f07d$export$a14e8754c327dfd0)(progressValue),
                offset: 2,
                fontSize: 20
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $b16e0f035e16bc60$var$progressBarWidth,
                height: $b16e0f035e16bc60$var$progressBarHeight,
                radius: $b16e0f035e16bc60$var$radius,
                color: $b16e0f035e16bc60$var$blueProgressBarColor,
                alpha: $b16e0f035e16bc60$var$progressBarAlpha,
                backgroundColor: $b16e0f035e16bc60$var$backgroundColor,
                backgroundAlpha: $b16e0f035e16bc60$var$backgroundAlpha,
                minValue: $b16e0f035e16bc60$var$progressBarMin,
                maxValue: maxValue,
                progressValue: progressValue,
                glare: {
                    height: $b16e0f035e16bc60$var$glareHeight,
                    width: $b16e0f035e16bc60$var$progressBarWidth - $b16e0f035e16bc60$var$glareOffset,
                    radius: $b16e0f035e16bc60$var$glareRadius,
                    color: $b16e0f035e16bc60$var$glareColor,
                    alpha: $b16e0f035e16bc60$var$glareAlpha
                }
            },
            border: {
                alpha: $b16e0f035e16bc60$var$backgroundAlpha,
                color: $b16e0f035e16bc60$var$progressBarBorderColor,
                width: $b16e0f035e16bc60$var$progressBarBorderWidth
            }
        });
        return scene.add.existing(progBar);
    }
    getImageKey() {
        switch(this._troopItem.machine_unit_id){
            case 1:
                return "troops_mercenary";
            case 2:
                return "troops_ars";
            case 3:
                return "troops_super_swole";
            case 4:
                return "troops_healer";
            default:
                return this._troopItem.image_key;
        }
    }
    removeButtonClickHandler(pointer) {
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().removeTroop(this._troopItem.user_machine_unit_id).then((res)=>{
            this.scene.handleTroopRemoved();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("trainingTroopComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $b16e0f035e16bc60$export$2e2bcd8739ae039(this.scene, x, y, data));
});






const $483607ac2d8a2307$var$noTroopsMessage = "You currently do not have any available troops.";
const $483607ac2d8a2307$var$paneHeight = 594;
const $483607ac2d8a2307$var$paneWidth = 1066;
const $483607ac2d8a2307$var$tableHeight = 605;
const $483607ac2d8a2307$var$tableWidth = 1063;
const $483607ac2d8a2307$var$progressBarRadius = 7;
const $483607ac2d8a2307$var$progressBarHeight = 22;
const $483607ac2d8a2307$var$progressBarWidth = 238;
const $483607ac2d8a2307$var$progressBarBackgroundColor = 0xb48dc7;
const $483607ac2d8a2307$var$progressBarBackgroundAlpha = 0.4;
const $483607ac2d8a2307$var$progressBarAlpha = 1;
const $483607ac2d8a2307$var$progressBarMin = 0;
const $483607ac2d8a2307$var$grayProgressBarColor = 0x9a9a9a;
const $483607ac2d8a2307$var$glareColor = 0xffffff;
const $483607ac2d8a2307$var$glareAlpha = 0.17;
const $483607ac2d8a2307$var$glareRadius = 3;
const $483607ac2d8a2307$var$glareHeight = 6;
const $483607ac2d8a2307$var$glareOffset = 10;
const $483607ac2d8a2307$var$machineUnitIds = {
    ars: 2,
    healer: 4,
    mercenary: 1,
    super_swole: 3
};
class $483607ac2d8a2307$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, userMachineId, paneScale, config){
        var _a;
        let conf = config ? config : {
            width: $483607ac2d8a2307$var$paneWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._userMachineId = 0; //userMachineId;
        // Title
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Trained Army", this.applyScale(22), 0).setOrigin(0, 0);
        this.add(this._title, {
            key: "army_pane_title",
            padding: {
                left: this.applyScale(27),
                right: 0,
                top: this.applyScale(27),
                bottom: 0
            }
        });
        // Capacity Progress Bar
        this._capacityProgressBar = this.createCapacityProgressBar(scene);
        this.add(this._capacityProgressBar, {
            key: "capacity_progress_bar",
            padding: {
                left: this.applyScale(774),
                right: 0,
                top: this.applyScale(-32),
                bottom: 0
            }
        });
        // Populate troops
        this._troops = (_a = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachineSync(this._userMachineId)) === null || _a === void 0 ? void 0 : _a.filter((troop)=>troop.level > 0);
        this._squad = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        // Table
        if (this._troops === undefined || this._troops.length === 0) {
            // Show squad if available
            if (this._squad && this._squad.length > 0) {
                // Create table
                this._table = this.createTable(this.scene, this._squad, 0, 0).layout();
                this.add(this._table, {
                    key: "army_pane_table",
                    padding: {
                        left: this.applyScale(2),
                        right: 0,
                        top: this.applyScale(10),
                        bottom: 0
                    }
                });
            } else // Show no troops pane
            this.createNoTroopsPane(this.scene, 0, 0);
        } else {
            this._table = this.createTable(scene, this._squad.concat(this.createTroopGroups()), x, y).layout();
            this.add(this._table, {
                padding: {
                    left: this.applyScale(2),
                    right: 0,
                    top: this.applyScale(10),
                    bottom: 0
                },
                key: "army_pane_table"
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createTroopGroups() {
        this._troopGroups = [];
        this._troops.forEach((troop)=>{
            var existingGroup = this._troopGroups.find((group)=>group.machine_unit_id === troop.machine_unit_id && group.base_level === troop.base_level);
            if (existingGroup) existingGroup.count += 1;
            else this._troopGroups.push(Object.assign({}, troop, {
                count: 1
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(this._troopGroups, [
            "machine_unit_id",
            "level"
        ]);
    }
    createNoTroopsPane(scene, x, y) {
        this._noTroopsLabel = scene.add.bitmapText(x - this.applyScale(507), y + this.applyScale(33), "cc_outline", $483607ac2d8a2307$var$noTroopsMessage, this.applyScale(20), 0).setOrigin(0, 0);
        this._noTroopsLabel.setAlpha(0.4);
        this.add(this._noTroopsLabel, {
            padding: {
                left: this.applyScale(27),
                right: this.applyScale(600),
                top: this.applyScale(10),
                bottom: 0
            },
            key: "no_troops_label"
        });
    }
    createCapacityProgressBar(scene) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: {
                key: "capacity_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this.getCapacityText(),
                width: $483607ac2d8a2307$var$progressBarWidth,
                height: $483607ac2d8a2307$var$progressBarHeight,
                radius: $483607ac2d8a2307$var$progressBarRadius,
                color: $483607ac2d8a2307$var$grayProgressBarColor,
                alpha: $483607ac2d8a2307$var$progressBarAlpha,
                backgroundColor: $483607ac2d8a2307$var$progressBarBackgroundColor,
                backgroundAlpha: $483607ac2d8a2307$var$progressBarBackgroundAlpha,
                minValue: $483607ac2d8a2307$var$progressBarMin,
                maxValue: this.getMaxCapacity(),
                progressValue: this.getTroopTotal(),
                glare: {
                    height: $483607ac2d8a2307$var$glareHeight,
                    width: $483607ac2d8a2307$var$progressBarWidth - $483607ac2d8a2307$var$glareOffset,
                    radius: $483607ac2d8a2307$var$glareRadius,
                    color: $483607ac2d8a2307$var$glareColor,
                    alpha: $483607ac2d8a2307$var$glareAlpha
                }
            }
        });
    }
    getCapacityText() {
        return `${this.getTroopTotal()} / ${this.getMaxCapacity()}`;
    }
    getMaxCapacity() {
        return (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormsCapacity();
    }
    getTroopTotal() {
        return (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacityUsed();
    }
    updateCapacityBar() {
        this._capacityProgressBar.updateMaxValue(this.scene, this.getMaxCapacity());
        this._capacityProgressBar.setProgress(this.scene, this.getTroopTotal());
        this._capacityProgressBar.setProgressBarText(this.getCapacityText());
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale(172 * data.length > $483607ac2d8a2307$var$tableWidth ? $483607ac2d8a2307$var$tableWidth : 172 * data.length + 11),
            height: this.applyScale($483607ac2d8a2307$var$tableHeight),
            items: [
                data[0]
            ],
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(172),
                cellHeight: this.applyScale(230),
                columns: 6,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {
                    left: this.applyScale(23),
                    right: 0
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                function getDisplayName(item) {
                    if (item.nft_collection === "Star Wolvez Genesis") return `Genesis Wolf #${item.nft_id}`;
                    if (item.nft_collection) return item.display_name;
                    if (item.machine_unit_id) switch(item.machine_unit_id){
                        case 1:
                            return `Mercenary LV. ${item.level}`;
                        case 2:
                            return `ARS LV. ${item.level}`;
                        case 3:
                            return `Super Swole LV. ${item.level}`;
                        case 4:
                            return `Healer LV. ${item.level}`;
                    }
                    return "Unknown LV. 0";
                }
                function getDamageText(item) {
                    return item.machine_unit_id === $483607ac2d8a2307$var$machineUnitIds.healer ? `${item.heal_per_second || 0} HEAL PER SEC` : `${item.dps || 0} DMG PER SEC`;
                }
                var sizer = scene.rexUI.add.fixWidthSizer({
                    width: scene.applyScale(149),
                    space: {
                        left: 0,
                        right: scene.applyScale(23),
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                });
                if (item) {
                    var troopImage = new (0, $b16e0f035e16bc60$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale());
                    const troopLabel = scene.add.bitmapText(0, 0, "cc_outline", getDisplayName(item).toUpperCase(), scene.applyScale(16), 0);
                    const damageLabel = scene.add.bitmapText(0, 0, "cc_outline", getDamageText(item), scene.applyScale(16), 0);
                    damageLabel.alpha = 0.4;
                    sizer.add(troopImage, {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        },
                        key: "troop_image"
                    });
                    sizer.add(troopLabel, {
                        padding: {
                            left: scene.applyScale(2),
                            right: 0,
                            top: scene.applyScale(24),
                            bottom: 0
                        },
                        key: "troop_label"
                    });
                    sizer.add(damageLabel, {
                        padding: {
                            left: scene.applyScale(2),
                            right: 0,
                            top: scene.applyScale(-1),
                            bottom: 0
                        },
                        key: "damage_label"
                    });
                }
                return sizer.layout();
            }
        }).setOrigin(0, 0.5);
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    updateTroopsList() {
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(this._userMachineId, true).then((res)=>{
            if (!res) return;
            this._troops = res.length > 0 ? res.filter((troop)=>troop.time_until_next_level === 0) : res;
            if (this._troops.length === 0) {
                if (this._table) {
                    // Remove table
                    this._table.setAlpha(0);
                    this.remove(this._table, true);
                    this._table = undefined;
                    // Show squad if available
                    if (this._squad && this._squad.length > 0) {
                        // Create table
                        this._table = this.createTable(this.scene, this._squad, 0, 0).layout();
                        this.add(this._table, {
                            key: "army_pane_table",
                            padding: {
                                left: this.applyScale(2),
                                right: 0,
                                top: this.applyScale(10),
                                bottom: 0
                            }
                        });
                    } else // Show no troops pane
                    this.createNoTroopsPane(this.scene, 0, 0);
                }
            } else {
                if (this._table) {
                    // Table might need to get smaller, destroy it if it exists
                    this._table.setAlpha(0);
                    this.remove(this._table, true);
                    this._table = undefined;
                } else {
                    // Remove no troops pane if it exists
                    this._noTroopsLabel.setAlpha(0);
                    this.remove(this._noTroopsLabel, true);
                    this._noTroopsLabel = undefined;
                }
                // Create table
                this._table = this.createTable(this.scene, this._squad.concat(this.createTroopGroups()), 0, 0).layout();
                this.add(this._table, {
                    key: "army_pane_table",
                    padding: {
                        left: this.applyScale(2),
                        right: 0,
                        top: this.applyScale(10),
                        bottom: 0
                    }
                });
            }
            this.layout();
        });
    }
    hidePane() {
        var _a;
        this._title.setAlpha(0);
        this._capacityProgressBar.setAlpha(0);
        (_a = this._noTroopsLabel) === null || _a === void 0 || _a.setAlpha(0);
    //this.table.disableInteractive();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("armyContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $483607ac2d8a2307$export$2e2bcd8739ae039(this.scene, x, y));
});








var $f1q41 = parcelRequire("f1q41");








const $f738d345df533523$var$componentWidth = 323;
const $f738d345df533523$var$componentHeight = 188;
const $f738d345df533523$var$backgroundColor = 0x2b2b45;
const $f738d345df533523$var$backgroundRadius = 16;
const $f738d345df533523$var$backgroundAlpha = 1;
const $f738d345df533523$var$imageHeight = 115;
const $f738d345df533523$var$imageWidth = 115;
const $f738d345df533523$var$imageRadius = 16;
const $f738d345df533523$var$costLabelHeight = 24;
const $f738d345df533523$var$costLabelColor = 0x000000;
const $f738d345df533523$var$costLabelAlpha = 0.4;
const $f738d345df533523$var$costIconScale = 0.4;
const $f738d345df533523$var$fontColor = 0xffffff;
const $f738d345df533523$var$secondaryFontColor = 0x866b7d;
const $f738d345df533523$var$hoverAlpha = 0.8;
const $f738d345df533523$var$disabledAlpha = 0.4;
const $f738d345df533523$var$currencyColors = {
    neon_gold: 0xffe100,
    space_elixir: 0x00d4f7,
    stardust: 0xff87ac
};
const $f738d345df533523$var$currencyIcons = {
    neon_gold: "neon_gold_icon",
    space_elixir: "space_elixir_icon",
    stardust: "stardust_icon"
};
const $f738d345df533523$var$machineUnitIds = {
    ars: 2,
    healer: 4,
    mercenary: 1,
    super_swole: 3
};
class $f738d345df533523$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, machine, troopItem, paneScale, config){
        let conf = {
            width: $f738d345df533523$var$componentWidth * (paneScale || 1),
            height: $f738d345df533523$var$componentHeight * (paneScale || 1),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._machine = machine;
        this._troopItem = troopItem;
        this._currency = "space_elixir";
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        // Background
        const bg = scene.add.rexRoundRectangle(scene.sys.canvas.width / 2, scene.sys.canvas.height / 2, scene.applyScale($f738d345df533523$var$componentWidth), scene.applyScale($f738d345df533523$var$componentHeight), scene.applyScale($f738d345df533523$var$backgroundRadius), $f738d345df533523$var$backgroundColor, $f738d345df533523$var$backgroundAlpha);
        this.add(bg, {
            key: "trainable_troop_bg",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Troop Image
        this.addTroopImage();
        // Cost Bar
        this.addCostBar();
        // Troop Title
        this.add(scene.add.bitmapText(0, 0, "cc_outline", this.getDisplayName(), scene.applyScale(18), 0), {
            key: "troop_title",
            align: "left-top",
            offsetX: scene.applyScale(145),
            offsetY: this.scene.applyScale(23),
            expand: false
        });
        // Health Label
        const healthLabel = this.createPropertyLabel("health_icon_small", `${this._troopItem.unit_hitpoints || 0}`);
        this.add(healthLabel, {
            key: "health_label",
            align: "left-top",
            offsetX: scene.applyScale(148),
            offsetY: scene.applyScale(78),
            expand: false
        });
        // Time to Build Label
        const timeToBuildLabel = this.createPropertyLabel("time_icon_small", `${(0, $f12f0c85b935f07d$export$a14e8754c327dfd0)(this._troopItem.unit_time_to_build)}`);
        this.add(timeToBuildLabel, {
            key: "time_to_build_label",
            align: "left-top",
            offsetX: scene.applyScale(228),
            offsetY: scene.applyScale(78),
            expand: false
        });
        // DPS/HPS Label
        if (this._troopItem.machine_unit_id === $f738d345df533523$var$machineUnitIds.healer) {
            // Show HPS
            const hpsLabel = this.createPropertyLabel("hps_icon_small", `${this._troopItem.unit_heal_per_second || 0}`);
            this.add(hpsLabel, {
                key: "hps_label",
                align: "left-top",
                offsetX: scene.applyScale(148),
                offsetY: scene.applyScale(105),
                expand: false
            });
        } else {
            // Show DPS
            const dpsLabel = this.createPropertyLabel("dps_icon_small", `${this._troopItem.unit_dps || 0}`);
            this.add(dpsLabel, {
                key: "dps_label",
                align: "left-top",
                offsetX: scene.applyScale(148),
                offsetY: scene.applyScale(105),
                expand: false
            });
        }
        // Capacity Label
        const capacityLabel = this.createPropertyLabel("capacity_icon_small", (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacity(this._troopItem.machine_unit_id));
        this.add(capacityLabel, {
            key: "capacity_label",
            align: "left-top",
            offsetX: scene.applyScale(228),
            offsetY: scene.applyScale(105),
            expand: false
        });
        this.addTrainingButtons();
        this.setEnabled();
    }
    addTroopImage() {
        const troopImage = this.scene.add.rexCircleMaskImage(0, 0, this.getTroopImageKey(), "", {
            maskType: "roundRectangle",
            radius: $f738d345df533523$var$imageRadius
        }).setScale(this._scale);
        this.add(troopImage, {
            key: "troop_image",
            align: "left-top",
            offsetX: this.scene.applyScale(15),
            offsetY: this.scene.applyScale(12),
            expand: false
        });
    }
    addCostBar() {
        const costBarBg = this.scene.add.rexRoundRectangle(0, 0, this.scene.applyScale($f738d345df533523$var$imageWidth), this.scene.applyScale($f738d345df533523$var$costLabelHeight), {
            tl: 0,
            tr: 0,
            bl: this.scene.applyScale($f738d345df533523$var$imageRadius),
            br: this.scene.applyScale($f738d345df533523$var$imageRadius)
        }, $f738d345df533523$var$costLabelColor, $f738d345df533523$var$costLabelAlpha);
        const costLabel = this.scene.rexUI.add.label({
            x: 0,
            y: 0,
            width: this.scene.applyScale($f738d345df533523$var$imageWidth),
            height: this.scene.applyScale($f738d345df533523$var$costLabelHeight),
            orientation: "x",
            rtl: false,
            icon: this._currency ? this.scene.add.image(0, 0, $f738d345df533523$var$currencyIcons[this._currency]).setScale(this.scene.applyScale($f738d345df533523$var$costIconScale)) : undefined,
            text: this.scene.add.bitmapText(0, 0, "cc_outline", this._troopItem.unit_cost_to_build ? this._troopItem.unit_cost_to_build.toLocaleString("en-us") : 0, this.scene.applyScale(14), 0).setTint($f738d345df533523$var$currencyColors[this._currency]),
            space: {
                icon: this.scene.applyScale(6)
            },
            align: "center"
        });
        this.add(costBarBg, {
            key: "cost_bar_bg",
            align: "left-top",
            offsetX: this.scene.applyScale(15),
            offsetY: this.scene.applyScale(103),
            expand: false
        });
        this.add(costLabel, {
            key: "cost_label",
            align: "left-top",
            offsetX: this.scene.applyScale(15),
            offsetY: this.scene.applyScale(103),
            expand: false
        });
    }
    addTrainingButtons() {
        this._train1Button = this.addTrainingButton(1, 15);
        this._train5Button = this.addTrainingButton(5, 51);
        this._train10Button = this.addTrainingButton(10, 88);
        this._train20Button = this.addTrainingButton(20, 134);
        this._train50Button = this.addTrainingButton(50, 182);
        this._train100Button = this.addTrainingButton(100, 230);
    }
    addTrainingButton(count, offsetX) {
        const button = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `train_${count}_inactive`, false).setScale(this._scale);
        button.onClick().subscribe((pointer)=>{
            button.disableInteractive();
            this.troopTrainingClickListener(button, count);
        });
        this.scene.add.existing(button);
        this.add(button, {
            key: `train${count}-button`,
            align: "left-top",
            offsetX: this.scene.applyScale(offsetX),
            offsetY: this.scene.applyScale(142),
            expand: false
        });
        return button;
    }
    // private getTroopTraitsText() {
    //   return this._troopItem.machine_unit_id === machineUnitIds.healer
    //     ? `${this._troopItem.unit_heal_per_second || 0} heal per sec\n${this._troopItem.unit_hitpoints || 0} HP`
    //     : `${this._troopItem.unit_dps || 0} dmg per sec\n${this._troopItem.unit_hitpoints || 0} HP`;
    // }
    getDisplayName() {
        var _a;
        if (this._troopItem && this._troopItem.machine_unit_name && this._troopItem.level) return `${(_a = this._troopItem.machine_unit_name) === null || _a === void 0 ? void 0 : _a.toUpperCase()} LV. ${this._troopItem.level}`;
        else return "UNKONWN LV. 0";
    }
    getTroopImageKey() {
        switch(this._troopItem.machine_unit_id){
            case $f738d345df533523$var$machineUnitIds.ars:
                return "troops_ars_small";
            case $f738d345df533523$var$machineUnitIds.healer:
                return "troops_healer_small";
            case $f738d345df533523$var$machineUnitIds.mercenary:
                return "troops_mercenary_small";
            case $f738d345df533523$var$machineUnitIds.super_swole:
                return "troops_super_swole_small";
            default:
                return "troops_mercenary_small";
        }
    }
    createPropertyLabel(iconImageKey, propertyValueText) {
        return this.scene.rexUI.add.label({
            x: 0,
            y: 0,
            width: this.scene.applyScale(70),
            height: this.scene.applyScale(20),
            orientation: "x",
            rtl: false,
            icon: this.scene.add.image(0, 0, iconImageKey).setScale(this._scale),
            text: this.scene.add.bitmapText(0, 0, "cc_outline", propertyValueText, this.scene.applyScale(18), 0).setTint($f738d345df533523$var$secondaryFontColor),
            space: {
                //top: this.scene.applyScale(-2),
                icon: this.scene.applyScale(6)
            },
            align: "left"
        });
    }
    isTroopEnabled() {
        // Check capacity
        const capacity = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormsCapacity();
        const troopCapacityUsed = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacityUsed();
        if (troopCapacityUsed >= capacity) return false;
        // Check machine level
        if (this._machine.level) return this._troopItem.base_machine_level_required <= this._machine.level;
        const machineLevel = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachineLevel(this._troopItem.machine_id);
        return this._troopItem.base_machine_level_required <= machineLevel;
    }
    setEnabled() {
        // Enable/Disable component, set/disable interactive
        if (this.isTroopEnabled()) {
            //this.setInteractive({ cursor: 'pointer' });
            this.setChildrenInteractive({
                //click: { mode: 'release', clickInterval: 100 },
                over: true,
                //tap: { time: 250, tapInterval: 200, threshold: 9, tapOffset: 10, taps: undefined, minTaps: undefined, maxTaps: undefined },
                //press: { time: 500, threshold: 9 },
                swipe: {
                    threshold: 10,
                    velocityThreshold: 1000,
                    dir: "8dir"
                },
                inputEventPrefix: "child."
            });
            this.on("child.over", (child, pointer, event)=>{
                this.setAlpha($f738d345df533523$var$hoverAlpha);
            });
            this.on("child.out", (child, pointer, event)=>{
                this.setAlpha(1);
            });
            // this.on('child.down', (child, pointer, event) => {
            //   this.setAlpha(1);
            // });
            // this.on('child.up', (child, pointer, event) => {
            //   this.setAlpha(hoverAlpha);
            // });
            this.setupActiveTrainingButtons();
        } else {
            this.disableInteractive();
            this.setAlpha($f738d345df533523$var$disabledAlpha);
            // update interativity of troop training buttons
            this.disableTroopTrainingButtons();
        }
        this.layout();
    }
    setupActiveTrainingButtons() {
        const capacity = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormsCapacity();
        const troopCapacityUsed = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacityUsed();
        const spaceElixirTotal = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync().space_elixir;
        const troopCapacity = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacity(this._troopItem.machine_unit_id);
        const troopTrainCost = this._troopItem.unit_cost_to_build;
        const remainingTroopCapacity = capacity - troopCapacityUsed;
        // Reusable function to set button properties
        const setButtonProperties = (button, activeSuffix, inactiveSuffix, count)=>{
            const requiredCapacity = count * troopCapacity;
            const requiredTrainCost = troopTrainCost * count;
            if (remainingTroopCapacity >= requiredCapacity && requiredTrainCost <= spaceElixirTotal) {
                button.setTexture(`train_${count}_${activeSuffix}`);
                button.setInteractive();
            } else {
                button.setTexture(`train_${count}_${inactiveSuffix}`);
                button.disableInteractive();
            }
        };
        // Train 1 Button
        setButtonProperties(this._train1Button, "active", "inactive", 1);
        // Train 5 Button
        setButtonProperties(this._train5Button, "active", "inactive", 5);
        // Train 10 Button
        setButtonProperties(this._train10Button, "active", "inactive", 10);
        // Train 20 Button
        setButtonProperties(this._train20Button, "active", "inactive", 20);
        // Train 50 Button
        setButtonProperties(this._train50Button, "active", "inactive", 50);
        // Train 100 Button
        setButtonProperties(this._train100Button, "active", "inactive", 100);
    }
    troopTrainingClickListener(button, units) {
        if (this.isTroopEnabled()) {
            const userMachineId = this._machine.user_machine_id === 0 ? (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachineFromMachineId(this._troopItem.machine_id).user_machine_id : this._machine.user_machine_id;
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().trainTroops(userMachineId, this._troopItem.level, units).then((res)=>{
                (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy(true).then((armyRes)=>{
                    if (res.success) {
                        // Update training troops component
                        this.scene.updateTrainingPane();
                        this.scene.updateCapacityBar();
                    } else {
                        // Show training failed message
                        this.scene.scene.pause();
                        this.scene.scene.launch("MessageScene", {
                            title: "Failed to train troop!",
                            message: "Your Cadet Dorms are at max capacity.",
                            scene: "ArmyModalScene"
                        });
                    }
                    button.setInteractive();
                });
            });
        }
    }
    disableTroopTrainingButtons() {
        this._train1Button.disableInteractive();
        this._train5Button.disableInteractive();
        this._train10Button.disableInteractive();
        this._train20Button.disableInteractive();
        this._train50Button.disableInteractive();
        this._train100Button.disableInteractive();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("trainableTroopComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $f738d345df533523$export$2e2bcd8739ae039(this.scene, x, y));
});





const $f004df958cbba4c6$var$paneHeight = 377;
const $f004df958cbba4c6$var$paneWidth = 1009;
const $f004df958cbba4c6$var$cellWidth = 323;
const $f004df958cbba4c6$var$cellHeight = 188;
const $f004df958cbba4c6$var$levelFilters = [
    "all",
    "level_1",
    "level_2",
    "level_3",
    "level_4",
    "level_5",
    "level_6",
    "level_7",
    "level_8",
    "level_9",
    "level_10"
];
class $f004df958cbba4c6$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, machine, paneScale, config){
        const conf = config ? config : {
            width: $f004df958cbba4c6$var$paneWidth * paneScale,
            height: $f004df958cbba4c6$var$paneHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._machine = machine;
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTrainableTroopsByMachine(this._machine.machine_id, false).then((res)=>{
            this._trainableTroops = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(res.filter((troop)=>troop.machine_unit_id !== null), (tr)=>{
                return !this.isTroopEnabled(tr);
            });
            this.createComponent(scene, x, y);
        });
    }
    createComponent(scene, x, y) {
        // Filter Tabs
        this.addLevelTabs();
        // Trainable Troops table
        this.createTable(scene, this._trainableTroops, 0, 0, this._scale);
        // this._noTroopsToTrainLabel = scene.add.bitmapText(
        //     x - this.scene.applyScale(259),
        //     y + this.scene.applyScale(113),
        //     'cc_outline',
        //     'You have no available troops to train.',
        //     this.scene.applyScale(20),
        //     0
        // ).setOrigin(0).setAlpha(0);
        //this.add(this._noTroopsToTrainLabel);
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    addLevelTabs() {
        // Initialize array
        this._levelTabs = [];
        // Add sizer for buttons
        this._filterTabSizer = this.scene.rexUI.add.fixWidthSizer({
            x: 0,
            y: 0,
            width: this.applyScale($f004df958cbba4c6$var$paneWidth),
            height: this.applyScale(41),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Create buttons, add to sizer, add to array with key
        $f004df958cbba4c6$var$levelFilters.forEach((lf)=>{
            this[`_${lf}_tab`] = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene, 0, 0, `${lf}_tab_inactive`, false).setOrigin(0, 0.5).setScale(this._scale);
            this._filterTabSizer.add(this.scene.add.existing(this[`_${lf}_tab`]), {
                padding: {
                    left: 0,
                    right: lf === "level_10" ? 0 : this.scene.applyScale(14),
                    top: 0,
                    bottom: 0
                },
                key: `${lf}_tab`
            });
            const level = parseInt(lf === "all" ? "-1" : lf.slice(6));
            this._levelTabs.push({
                key: `_${lf}_tab`,
                level: level,
                button: this[`_${lf}_tab`]
            });
        });
        this._levelTabs.forEach((lt)=>{
            const clickHandler = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).curry(this.tabClickHandler)(this, lt.level, this[lt.key]);
            this[lt.key].onClick().subscribe(clickHandler);
        });
        // Set 'All' tab as active tab
        this._all_tab.setTexture("all_tab_active");
        this._selectedLevelTab = this._all_tab;
        // Add button sizer to component
        this.add(this._filterTabSizer, {
            key: "filter_tab_sizer",
            align: "center-top",
            offsetX: this.scene.applyScale(0),
            offsetY: this.scene.applyScale(0),
            expand: false
        });
    }
    tabClickHandler(contentPane, level, tab, pointer) {
        if (contentPane._selectedLevelTab === tab) return;
        contentPane._selectedLevelTab = tab;
        contentPane.setActiveTab(tab);
        contentPane.applyTabFilter(level);
    }
    setActiveTab(tab) {
        this._levelTabs.forEach((lt)=>{
            if (lt.button === tab) lt.button.setTexture(`${lt.key.slice(1)}_active`);
            else lt.button.setTexture(`${lt.key.slice(1)}_inactive`);
        });
    }
    applyTabFilter(level) {
        var filteredData;
        if (level === -1) // 'All' selected - No filter
        filteredData = this._trainableTroops;
        else // Level filter selected, filter data
        filteredData = this._trainableTroops.filter((tt)=>tt.level === level);
        // Redraw table
        this.removeTable();
        this.createTable(this.scene, filteredData, 0, 0, this._scale);
        this.layout();
    }
    removeTable() {
        this._table.setAlpha(0);
        this.remove(this._table, true); // true = destroy table
        this._table = undefined;
    }
    createTable(scene, data, x, y, paneScale) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.scene.applyScale($f004df958cbba4c6$var$paneWidth),
            height: this.scene.applyScale($f004df958cbba4c6$var$paneHeight - 64),
            items: data,
            table: {
                cellWidth: this.scene.applyScale($f004df958cbba4c6$var$cellWidth + 20),
                cellHeight: this.scene.applyScale($f004df958cbba4c6$var$cellHeight + 20),
                columns: 3,
                clamplTableOXY: false,
                reuseCellContainer: true,
                scrollMode: 0,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var machine = scene.getMachine();
                var ttComp = new (0, $f738d345df533523$export$2e2bcd8739ae039)(scene, x, y, machine, item, scene.getScale());
                // if (ttComp.isTroopEnabled()) {
                //   ttComp.onClick((button, gameObject, pointer, event) => {
                //     ttComp.disableInteractive();
                //     const userMachineId =
                //       machine.user_machine_id === 0
                //         ? MachineService.getInstance().getUserMachineFromMachineId(item.machine_id).user_machine_id
                //         : machine.user_machine_id;
                //     TroopService.getInstance()
                //       .trainTroop(userMachineId, item.level)
                //       .then(res => {
                //         TroopService.getInstance()
                //           .getArmy(true)
                //           .then(armyRes => {
                //             if (res.success) {
                //               // Update training troops component
                //               scene.updateTrainingPane();
                //               scene.updateCapacityBar();
                //             } else {
                //               // Show training failed message
                //               scene.scene.pause();
                //               scene.scene.launch('MessageScene', {
                //                 title: 'Failed to train troop!',
                //                 message: 'Your Cadet Dorms are at max capacity.',
                //                 scene: 'ArmyModalScene',
                //               });
                //             }
                //             ttComp.setInteractive();
                //           });
                //       });
                //   }, this);
                //   ttComp.on('child.pressstart', (child, pointer, event) => {
                //     // Show training failed message
                //     scene.scene.pause();
                //     scene.scene.launch('MessageScene', {
                //       title: 'Failed to train troop!',
                //       message: 'Your Cadet Dorms are at max capacity.',
                //       scene: 'ArmyModalScene',
                //     });
                //   });
                //}
                // ttComp.onClick().subscribe(pointer => {
                //     scene.addSquadMember(item);
                // });
                return scene.add.existing(ttComp);
            }
        });
        table.setItems(data).scrollToTop();
        table;
        this._table = table.layout();
        this.add(this._table, {
            key: "trainable_troops_table",
            align: "center-top",
            offsetX: this.scene.applyScale(0),
            offsetY: this.scene.applyScale(64),
            expand: false
        });
    }
    isTroopEnabled(troopItem) {
        // Check capacity
        const capacity = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormsCapacity();
        const troopCapacityUsed = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacityUsed();
        if (troopCapacityUsed >= capacity) return false;
        // Check machine level
        if (this._machine.level) return troopItem.base_machine_level_required <= this._machine.level;
        const machineLevel = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getUserMachineLevel(troopItem.machine_id);
        return troopItem.base_machine_level_required <= machineLevel;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("trainableTroopsContentPane", function(x, y, playersData) {
    // @ts-ignore
    return this.displayList.add(new $f004df958cbba4c6$export$2e2bcd8739ae039(this.scene, x, y, playersData));
});




var $f1q41 = parcelRequire("f1q41");




const $340c5fe2ee354db7$var$noTroopsMessage = "You currently do not have any troops in training. Train some below!";
const $340c5fe2ee354db7$var$paneWidth = 1063;
const $340c5fe2ee354db7$var$paneHeight = 210;
const $340c5fe2ee354db7$var$machineUnitIds = {
    ars: 2,
    healer: 4,
    mercenary: 1,
    super_swole: 3
};
class $340c5fe2ee354db7$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, userMachineId, config){
        let conf = config ? config : {
            width: $340c5fe2ee354db7$var$paneWidth * paneScale,
            height: $340c5fe2ee354db7$var$paneHeight * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._userMachineID = userMachineId;
        const allTroops = (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachineSync(this._userMachineID) || [];
        this._troopData = allTroops.length > 0 ? allTroops.filter((troop)=>troop.time_until_next_level !== 0) : [];
        console.log(`TroopData: ${(0, (/*@__PURE__*/$parcel$interopDefault($093a98c17cb6b6b8$exports))).inspect(this._troopData)}`);
        if (this._troopData.length === 0) this.createNoTroopsPane(scene, x, y);
        else {
            this.indexTroopData();
            this._table = this.createTable(scene, this._troopData, x, y).layout();
            this.add(this._table, {
                key: "army_pane_table",
                align: "left-top",
                offsetX: 0,
                offsetY: 0,
                expand: false
            });
        }
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createNoTroopsPane(scene, x, y) {
        this._noTroopsLabel = scene.add.bitmapText(0, 0, "cc_outline", $340c5fe2ee354db7$var$noTroopsMessage, this.applyScale(20), 0).setOrigin(0, 0);
        this._noTroopsLabel.setAlpha(0.4);
        this.add(this._noTroopsLabel, {
            key: "no_troops_label",
            align: "left-top",
            offsetX: scene.applyScale(24),
            offsetY: scene.applyScale(0),
            expand: false
        });
    }
    createTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale(172 * data.length > 1063 ? 1063 : 172 * data.length - 1 + 23),
            height: this.applyScale(210),
            items: [
                data[0]
            ],
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale(172),
                cellHeight: this.applyScale(210),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                left: this.applyScale(23),
                table: {
                    left: this.applyScale(0),
                    right: this.applyScale(0)
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                function getDisplayName(item) {
                    switch(item.machine_unit_id){
                        case 1:
                            return `Mercenary LV. ${item.base_level}`;
                        case 2:
                            return `ARS LV. ${item.base_level}`;
                        case 3:
                            return `Super Swole LV. ${item.base_level}`;
                        case 4:
                            return `Healer LV. ${item.base_level}`;
                        default:
                            return "Unknown LV. 0";
                    }
                }
                function getDamageText(item) {
                    return item.time_until_next_level ? "TRAINING" : item.machine_unit_id === $340c5fe2ee354db7$var$machineUnitIds.healer ? `${item.heal_per_second || 0} HEAL PER SEC` : `${item.dps || 0} DMG PER SEC`;
                }
                var sizer = scene.rexUI.add.fixWidthSizer({
                    width: scene.applyScale(172),
                    space: {
                        left: 0,
                        right: scene.applyScale(5),
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                });
                if (item && item.machine_unit_id) {
                    var troopImage = new (0, $b16e0f035e16bc60$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale());
                    const troopLabel = scene.add.bitmapText(0, 0, "cc_outline", getDisplayName(item).toUpperCase(), scene.applyScale(16), 0);
                    const damageLabel = scene.add.bitmapText(0, 0, "cc_outline", getDamageText(item), scene.applyScale(16), 0);
                    damageLabel.alpha = 0.4;
                    sizer.add(scene.add.existing(troopImage), {
                        padding: {
                            left: 0,
                            right: 12,
                            top: 0,
                            bottom: 0
                        },
                        key: "troop_image"
                    });
                    sizer.add(troopLabel, {
                        padding: {
                            left: scene.applyScale(2),
                            right: 0,
                            top: scene.applyScale(24),
                            bottom: 0
                        },
                        key: "troop_label"
                    });
                    sizer.addNewLine();
                    sizer.add(damageLabel, {
                        padding: {
                            left: scene.applyScale(2),
                            right: 0,
                            top: scene.applyScale(-1),
                            bottom: 0
                        },
                        key: "damage_label"
                    });
                }
                return sizer.layout();
            }
        }).setOrigin(0, 0.5);
        table.setItems(data).scrollToTop();
        this._table = table;
        return table;
    }
    indexTroopData() {
        const sortedTroops = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(this._troopData, [
            "machine_unit_id"
        ]);
        this._troopData.forEach((troop)=>{
            const firstTroopByType = sortedTroops.find((str)=>str.machine_unit_id === troop.machine_unit_id);
            troop.indexByType = firstTroopByType.user_machine_unit_id === troop.user_machine_unit_id ? 0 : 1;
        });
        this._troopData = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(this._troopData, "indexByType");
    }
    updateTraineeList() {
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(this._userMachineID, true).then((res)=>{
            if (!res) return;
            this._troopData = res.length > 0 ? res.filter((troop)=>troop.time_until_next_level !== 0) : res;
            if (this._troopData.length === 0) {
                if (this._table) {
                    // Remove table
                    this._table.setAlpha(0);
                    this.remove(this._table, true);
                    this._table = undefined;
                    // Show no troops pane
                    this.createNoTroopsPane(this.scene, 0, 0);
                }
            } else {
                if (this._table) {
                    // Table might need to get smaller, destroy it if it exists
                    this._table.setAlpha(0);
                    this.remove(this._table, true);
                    this._table = undefined;
                } else {
                    // Remove no troops pane if it exists
                    this._noTroopsLabel.setAlpha(0);
                    this.remove(this._noTroopsLabel, true);
                    this._noTroopsLabel = undefined;
                }
                this.indexTroopData();
                // Create table
                this._table = this.createTable(this.scene, this._troopData, 0, 0).layout();
                this.add(this._table, {
                    key: "army_pane_table",
                    align: "left-top",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                });
            }
            this.layout();
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("trainingTroopsContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $340c5fe2ee354db7$export$2e2bcd8739ae039(this.scene, x, y));
});



const $84591765261f7735$var$paneHeight = 594;
const $84591765261f7735$var$paneWidth = 1066;
const $84591765261f7735$var$progressBarRadius = 7;
const $84591765261f7735$var$progressBarHeight = 22;
const $84591765261f7735$var$progressBarWidth = 238;
const $84591765261f7735$var$progressBarBackgroundColor = 0xb48dc7;
const $84591765261f7735$var$progressBarBackgroundAlpha = 0.4;
const $84591765261f7735$var$progressBarAlpha = 1;
const $84591765261f7735$var$progressBarMin = 0;
const $84591765261f7735$var$grayProgressBarColor = 0x9a9a9a;
const $84591765261f7735$var$glareColor = 0xffffff;
const $84591765261f7735$var$glareAlpha = 0.17;
const $84591765261f7735$var$glareRadius = 3;
const $84591765261f7735$var$glareHeight = 6;
const $84591765261f7735$var$glareOffset = 10;
class $84591765261f7735$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, machine, paneScale, config){
        let conf = config ? config : {
            width: $84591765261f7735$var$paneWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._machine = machine;
        // Title
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Training Area", this.scene.applyScale(22), 0).setOrigin(0, 0);
        this.add(this._title, {
            key: "army_training_pane_title",
            padding: {
                left: this.scene.applyScale(27),
                right: 0,
                top: this.scene.applyScale(27),
                bottom: 0
            }
        });
        // Capacity Progress Bar
        this._capacityProgressBar = this.createCapacityProgressBar(scene);
        this.add(this._capacityProgressBar, {
            key: "capacity_progress_bar",
            padding: {
                left: this.scene.applyScale(774),
                right: 0,
                top: this.scene.applyScale(-32),
                bottom: 0
            }
        });
        // Training Troops Pane
        this._trainingTroopsPane = new (0, $340c5fe2ee354db7$export$2e2bcd8739ae039)(this.scene, 0, 0, this._scale, this._machine.user_machine_id);
        this.add(this.scene.add.existing(this._trainingTroopsPane), {
            key: "training_troops_pane",
            padding: {
                left: this.scene.applyScale(2),
                right: 0,
                top: this.scene.applyScale(10),
                bottom: 0
            }
        });
        // Trainable Troops Pane
        this._trainableTroopsPane = new (0, $f004df958cbba4c6$export$2e2bcd8739ae039)(this.scene, 0, 0, this._machine, this._scale);
        this.add(this.scene.add.existing(this._trainableTroopsPane), {
            key: "trainable_troops_pane",
            padding: {
                left: this.scene.applyScale(29),
                right: 0,
                top: this.scene.applyScale(20),
                bottom: 0
            }
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createCapacityProgressBar(scene) {
        return new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: ""
            },
            icon: {
                key: "capacity_icon",
                space: 8,
                scale: 1
            },
            progressBar: {
                text: this.getCapacityText(),
                width: $84591765261f7735$var$progressBarWidth,
                height: $84591765261f7735$var$progressBarHeight,
                radius: $84591765261f7735$var$progressBarRadius,
                color: $84591765261f7735$var$grayProgressBarColor,
                alpha: $84591765261f7735$var$progressBarAlpha,
                backgroundColor: $84591765261f7735$var$progressBarBackgroundColor,
                backgroundAlpha: $84591765261f7735$var$progressBarBackgroundAlpha,
                minValue: $84591765261f7735$var$progressBarMin,
                maxValue: this.getMaxCapacity(),
                progressValue: this.getTroopTotal(),
                glare: {
                    height: $84591765261f7735$var$glareHeight,
                    width: $84591765261f7735$var$progressBarWidth - $84591765261f7735$var$glareOffset,
                    radius: $84591765261f7735$var$glareRadius,
                    color: $84591765261f7735$var$glareColor,
                    alpha: $84591765261f7735$var$glareAlpha
                }
            }
        });
    }
    getCapacityText() {
        return `${this.getTroopTotal()} / ${this.getMaxCapacity()}`;
    }
    getMaxCapacity() {
        return (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().getCadetDormsCapacity();
    }
    getTroopTotal() {
        return (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopCapacityUsed();
    }
    updateCapacityBar() {
        this._capacityProgressBar.updateMaxValue(this.scene, this.getMaxCapacity());
        this._capacityProgressBar.setProgress(this.scene, this.getTroopTotal());
        this._capacityProgressBar.setProgressBarText(this.getCapacityText());
    }
    updateTraineeList() {
        this._trainingTroopsPane.updateTraineeList();
    }
    hidePane() {
        this._title.setAlpha(0);
        this._capacityProgressBar.setAlpha(0);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("armyTrainingContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $84591765261f7735$export$2e2bcd8739ae039(this.scene, x, y));
});




const $f38b92966e177ef1$var$modalWidth = 1072;
const $f38b92966e177ef1$var$modalHeight = 771;
const $f38b92966e177ef1$var$modalRadius = 16;
const $f38b92966e177ef1$var$modalColor = 0x1c1c2c;
const $f38b92966e177ef1$var$modalAlpha = 1;
const $f38b92966e177ef1$var$modalBorderColor = 0x6262de;
const $f38b92966e177ef1$var$modalBorderWidth = 3;
const $f38b92966e177ef1$var$tabs = {
    training: "training",
    army: "army"
};
class $f38b92966e177ef1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._machine = data.machine;
        this._startTab = data.tab || $f38b92966e177ef1$var$tabs.training;
    }
    constructor(){
        super({
            key: "ArmyModalScene"
        });
    }
    preload() {
    // Images loaded in AssetPreloaderScene
    }
    create() {
        this.createComponent();
        this.scene.launch("AssetPreloaderScene", {
            originating_scene: "ArmyModalScene",
            assets: (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30)
        });
    }
    createComponent() {
        const self1 = this;
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.dragDistanceThreshold = 16;
        this.input.dragTimeThreshold = 300;
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($f38b92966e177ef1$var$modalWidth, $f38b92966e177ef1$var$modalHeight + 70);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale($f38b92966e177ef1$var$modalHeight + 70),
            width: this.applyScale($f38b92966e177ef1$var$modalWidth - 8),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($f38b92966e177ef1$var$modalWidth), this.applyScale($f38b92966e177ef1$var$modalHeight), this.applyScale($f38b92966e177ef1$var$modalRadius), $f38b92966e177ef1$var$modalColor, $f38b92966e177ef1$var$modalAlpha);
        background.setStrokeStyle(this.applyScale($f38b92966e177ef1$var$modalBorderWidth), $f38b92966e177ef1$var$modalBorderColor, $f38b92966e177ef1$var$modalAlpha);
        this._sizer.add(background, {
            key: "army_modal_bg",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(340),
            expand: false
        });
        this._sizer.layout();
        //this._sizer.drawBounds(this.add.graphics(), 0x00ff00);
        //this._sizer.pushIntoBounds();
        this._sizer.onClickOutside((co, go, pointer)=>{
            this.closeButtonClickHandler(pointer);
        });
    }
    onLoaded() {
        // Tabs
        this._trainingTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "training_tab_active", false).setOrigin(1, 1).setScale(this._scale);
        this._armyTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "army_tab_inactive", false).setOrigin(0, 1).setScale(this._scale);
        this._trainingTab.onClick().subscribe((pointer)=>{
            this.trainingTabClickHandler(pointer);
        });
        this._armyTab.onClick().subscribe((pointer)=>{
            this.armyTabClickHandler(pointer);
        });
        this.add.existing(this._trainingTab);
        this.add.existing(this._armyTab);
        this._sizer.add(this._trainingTab, {
            key: "training_tab",
            align: "center-top",
            offsetX: this.applyScale(-95),
            offsetY: 0,
            expand: false
        });
        this._sizer.add(this._armyTab, {
            key: "army_tab",
            align: "center-top",
            offsetX: this.applyScale(95),
            offsetY: 0,
            expand: false
        });
        // Divider Line
        this._sizer.add(this.add.image(0, 0, "dashboard_divider").setScale(this._scale), {
            key: "divider_line",
            align: "left-bottom",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(-100),
            expand: false
        });
        // Close Button
        this._closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "army_modal_close_button", false).setScale(this._scale);
        this._closeButton.onClick().subscribe((pointer)=>{
            this.closeButtonClickHandler(pointer);
        });
        this._sizer.add(this.add.existing(this._closeButton), {
            key: "close_button",
            align: "left-bottom",
            offsetX: this.applyScale(20),
            offsetY: this.applyScale(-20),
            expand: false
        });
        this._sizer.layout();
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(0, true).then((res)=>{
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTrainableTroopsByMachine(0).then((tt)=>{
                // Remove loading indicator
                this._loadingIndicator.setAlpha(0);
                this._sizer.remove(this._loadingIndicator, true);
                this._loadingIndicator = undefined;
                if (this._startTab === $f38b92966e177ef1$var$tabs.army) this.armyTabClickHandler(self);
                else this.trainingTabClickHandler(self);
            });
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    closeButtonClickHandler(pointer) {
        if (pointer.getDistance() > 20) return;
        this._selectedTab = "";
        this.removePanes();
        this.unloadAssets();
        this.scene.stop();
        // this.scene.resume('HomebaseScene');
        this.scene.get("HomebaseScene").input.enabled = true;
        this.scene.resume("HudScene");
    }
    trainingTabClickHandler(pointer) {
        if (this._selectedTab === $f38b92966e177ef1$var$tabs.training) return;
        this.removePanes();
        this._selectedTab = $f38b92966e177ef1$var$tabs.training;
        this._trainingTab.setTexture("training_tab_active");
        this._armyTab.setTexture("army_tab_inactive");
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy().then(()=>{
            this._trainingContentPane = new (0, $84591765261f7735$export$2e2bcd8739ae039)(this, 0, 0, this._machine, this._scale);
            this.add.existing(this._trainingContentPane);
            this._sizer.add(this._trainingContentPane, {
                key: "training_pane",
                align: "center-top",
                offsetX: 0,
                offsetY: this.applyScale(68),
                expand: false
            }).layout();
        });
    //this._trainingContentPane.drawBounds(this.add.graphics(), 0x00ff00);
    }
    armyTabClickHandler(pointer) {
        if (this._selectedTab === $f38b92966e177ef1$var$tabs.army) return;
        this.removePanes();
        this._selectedTab = $f38b92966e177ef1$var$tabs.army;
        this._trainingTab.setTexture("training_tab_inactive");
        this._armyTab.setTexture("army_tab_active");
        (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(this._machine.user_machine_id, true).then(()=>{
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy().then(()=>{
                this._armyContentPane = new (0, $483607ac2d8a2307$export$2e2bcd8739ae039)(this, 0, 0, this._machine.user_machine_id, this._scale);
                this.add.existing(this._armyContentPane);
                this._sizer.add(this._armyContentPane, {
                    key: "army_pane",
                    align: "center-top",
                    offsetX: 0,
                    offsetY: this.applyScale(68),
                    expand: false
                }).layout();
            });
        });
    }
    getMachine() {
        return this._machine;
    }
    updateTrainingPane() {
        this.time.removeAllEvents();
        this._trainingContentPane.updateTraineeList();
    }
    updateCapacityBar() {
        if (this._selectedTab === $f38b92966e177ef1$var$tabs.army) this._armyContentPane.updateCapacityBar();
        else this._trainingContentPane.updateCapacityBar();
    }
    handleTroopRemoved() {
        if (this._selectedTab === $f38b92966e177ef1$var$tabs.army) (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(this._machine.user_machine_id, true).then((res)=>{
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy(true).then((res)=>{
                this._armyContentPane.updateTroopsList();
                this._armyContentPane.updateCapacityBar();
            });
        });
        else (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getTroopsByMachine(this._machine.user_machine_id, true).then((res)=>{
            (0, $c59f1da45881961a$export$2e2bcd8739ae039).getInstance().getArmy(true).then((res)=>{
                this._trainingContentPane.updateTraineeList();
                this._trainingContentPane.updateCapacityBar();
            });
        });
    }
    removePanes() {
        if (this._trainingContentPane) {
            this._trainingContentPane.hidePane();
            this._sizer.remove(this._trainingContentPane, true); //destroys object
            this._trainingContentPane = null;
        }
        if (this._armyContentPane) {
            this._armyContentPane.hidePane();
            this._sizer.remove(this._armyContentPane, true); //destroys object
            this._armyContentPane = null;
        }
        this.time.removeAllEvents();
    }
    destroy() {
        this._armyTab.destroy();
        this._trainingTab.destroy();
        this._selectedTab.destroy();
        this._armyContentPane.destroy();
        this._trainingContentPane.destroy();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$bef64b52259dad30)));
    }
}






const $8a1b429231f58ae5$var$modalWidth = 494;
const $8a1b429231f58ae5$var$modalHeight = 400;
const $8a1b429231f58ae5$var$modalRadius = 50;
const $8a1b429231f58ae5$var$modalColor = 0x350926;
const $8a1b429231f58ae5$var$modalAlpha = 1;
const $8a1b429231f58ae5$var$modalBorderColor = 0x3d4361;
const $8a1b429231f58ae5$var$modalBorderWidth = 1;
const $8a1b429231f58ae5$var$okayButtonImageKey = "okay_button";
class $8a1b429231f58ae5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._message = data.message;
        this._title = data.title;
        this._launchedFromScene = data.scene;
    }
    constructor(){
        super({
            key: "MessageScene"
        });
    }
    preload() {
        this.load.image("okay_button", (0, $1aa2c39fc1fbb95e$export$11c0038a143c3711).okay_button);
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($8a1b429231f58ae5$var$modalWidth, $8a1b429231f58ae5$var$modalHeight + 100); // 100 extra to account for button
        // Add Background
        const modalBg = this.add.rexRoundRectangle(0, 0, this.applyScale($8a1b429231f58ae5$var$modalWidth), this.applyScale($8a1b429231f58ae5$var$modalHeight), this.applyScale($8a1b429231f58ae5$var$modalRadius), $8a1b429231f58ae5$var$modalColor, $8a1b429231f58ae5$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($8a1b429231f58ae5$var$modalBorderWidth), $8a1b429231f58ae5$var$modalBorderColor, $8a1b429231f58ae5$var$modalAlpha);
        // Add Sizer for content
        var sizer = this.rexUI.add.fixWidthSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($8a1b429231f58ae5$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        // Add background to sizer
        sizer.addBackground(modalBg);
        // Add Title
        const title = this.add.bitmapText(0, 0, "cc_outline", this._title, this.applyScale(26), 1).setOrigin(0.5, 0.5);
        title.setMaxWidth(350);
        sizer.add(title, {
            padding: {
                left: this.applyScale(70),
                right: this.applyScale(70),
                top: this.applyScale(50),
                bottom: this.applyScale(0)
            },
            key: "message"
        });
        // Add Blob
        sizer.add(this.add.sprite(0, 0, "party_blob").setOrigin(0.5, 0.5), {
            padding: {
                left: this.applyScale(100),
                right: this.applyScale(100),
                top: this.applyScale(-40),
                bottom: this.applyScale(20)
            },
            key: "blob_image"
        });
        // Add Message
        const message = this.add.bitmapText(0, 0, "cc_outline", this._message, this.applyScale(22), 1).setOrigin(0.5, 0.5);
        message.setMaxWidth(350);
        sizer.add(message, {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: this.applyScale(60)
            },
            key: "message"
        });
        sizer.layout();
        // Add Okay Button
        const okayButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getTopCenter().x, modalBg.getBottomLeft().y, $8a1b429231f58ae5$var$okayButtonImageKey, false).setScale(this._scale).setOrigin(0.5, 0.5);
        okayButton.onClick().subscribe((pointer)=>{
            this.scene.resume(this._launchedFromScene);
            this.scene.stop();
        });
        // Add key bindings
        this.input.keyboard.on("keydown-ENTER", (event)=>{
            this.scene.resume(this._launchedFromScene);
            this.scene.stop();
        });
        this.add.existing(okayButton);
    }
    applyScale(length) {
        return length * this._scale;
    }
}








const $2d7e70af22a8cacb$var$modalHeight = 527;
const $2d7e70af22a8cacb$var$modalWidth = 494;
const $2d7e70af22a8cacb$var$modalRadius = 50;
const $2d7e70af22a8cacb$var$modalColor = 0x350926;
const $2d7e70af22a8cacb$var$modalAlpha = 1;
const $2d7e70af22a8cacb$var$modalBorderColor = 0x3d4361;
const $2d7e70af22a8cacb$var$modalBorderWidth = 1;
class $2d7e70af22a8cacb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "HudBattleRoyaleAlertScene"
        });
    }
    init(data) {
        this._hasPlayerJoined = data.hasPlayerJoined;
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$cf87557e5793b920));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($2d7e70af22a8cacb$var$modalWidth, $2d7e70af22a8cacb$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $2d7e70af22a8cacb$var$modalWidth * this._scale,
            height: $2d7e70af22a8cacb$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        const notificationBg = this.add.rexRoundRectangle(0, 0, this.applyScale($2d7e70af22a8cacb$var$modalWidth), this.applyScale($2d7e70af22a8cacb$var$modalHeight), this.applyScale($2d7e70af22a8cacb$var$modalRadius), $2d7e70af22a8cacb$var$modalColor, $2d7e70af22a8cacb$var$modalAlpha).setStrokeStyle($2d7e70af22a8cacb$var$modalBorderWidth, $2d7e70af22a8cacb$var$modalBorderColor, $2d7e70af22a8cacb$var$modalAlpha);
        sizer.add(notificationBg, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Image
        this._battleRoyaleImage = this.add.image(0, 0, "hud_battle_royale_background").setScale(this._scale);
        sizer.add(this._battleRoyaleImage, {
            key: "battleroyale_image",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Boss Title
        this._battleRoyaleTitle = this.add.image(0, 0, "hud_battle_royale_text").setScale(this._scale);
        sizer.add(this._battleRoyaleTitle, {
            key: "battleroyale_title_image",
            align: "center-middle",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Text 1
        this._battleRoyaleText1 = this.add.bitmapText(0, 0, "cc_outline", "Show your true grit\nand strength", this.applyScale(22), 1);
        sizer.add(this._battleRoyaleText1, {
            key: "battleroyale-text-1",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(325),
            expand: false
        });
        // Text 2
        this._battleRoyaleText2 = this.add.bitmapText(0, 0, "cc_outline", "A winner-takes-all battle arena,\nwhere you can come away with\nall the goods...", this.applyScale(18), 1).setTint(0xbfaac6);
        sizer.add(this._battleRoyaleText2, {
            key: "bossfight-text-2",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(390),
            expand: false
        });
        // Add Later Button
        this._laterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_notification_later_button", true, 1.05).setScale(this._scale);
        this._laterButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.add.existing(this._laterButton);
        sizer.add(this._laterButton, {
            key: "later-button",
            align: "left-top",
            offsetX: this.applyScale(89),
            offsetY: this.applyScale(497),
            expand: false
        });
        // Add Join Game Button
        var buttonImage = this._hasPlayerJoined ? "hud_battle_royale_view_button" : "hud_battle_royale_ready_up_button";
        this._readyUpButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, buttonImage, true, 1.05).setScale(this._scale);
        this._readyUpButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            (0, $ef600a3a231959fc$export$2e2bcd8739ae039).getInstance().updateMetaData().then(()=>{
                this.scene.get("HomebaseScene").scene.stop();
                this.scene.get("HudScene").scene.stop();
                this.scene.start("BattleRoyaleScene");
            });
        });
        this.add.existing(this._readyUpButton);
        sizer.add(this._readyUpButton, {
            key: "ready-up-button",
            align: "left-top",
            offsetX: this.applyScale(239),
            offsetY: this.applyScale(497),
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$cf87557e5793b920)));
    }
}







const $b0183b4c47a2f044$var$modalHeight = 450;
const $b0183b4c47a2f044$var$modalWidth = 387;
class $b0183b4c47a2f044$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._badgeName = "bossfight_defeat_badge";
        this._badgeTitle = "bossfight_defeat_title";
    }
    constructor(){
        super({
            key: "BattleRoyaleFailedScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$16b2a7db5b493444));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($b0183b4c47a2f044$var$modalWidth, $b0183b4c47a2f044$var$modalHeight);
        this.createComponent();
    }
    createComponent() {
        const background = this.add.rexRoundRectangle(0, 0, this.sys.game.canvas.width * 2, this.sys.game.canvas.height * 2, 0, 0x000000, 0.73);
        this.add.existing(background);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $b0183b4c47a2f044$var$modalWidth * this._scale,
            height: $b0183b4c47a2f044$var$modalHeight * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Add Result Badge
        this._resultBadge = this.add.image(0, 0, this._badgeName).setScale(this._scale);
        sizer.add(this._resultBadge, {
            key: "battleroyale_badge",
            align: "center-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Add Victory Title
        this._resultTitle = this.add.image(0, 0, this._badgeTitle).setScale(this._scale);
        sizer.add(this._resultTitle, {
            key: "battleroyale_title",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(130),
            expand: false
        });
        // Text
        this._text = this.add.bitmapText(0, 0, "cc_outline", "Battle Royale Failed to start\ndue to insufficient players\nregistered.", this.applyScale(28), 1);
        sizer.add(this._text, {
            key: "battleroyale-text",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(250),
            expand: false
        });
        // Add Return Home Button
        this._returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "bossfight_victory_return_home_button", true, 1.05).setScale(this._scale);
        this._returnHomeButton.onClick().subscribe((pointer)=>{
            this.destroy();
        });
        this.add.existing(this._returnHomeButton);
        sizer.add(this._returnHomeButton, {
            key: "return-home-button",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    destroy() {
        this.unloadAssets();
        this.scene.start("HomebaseScene");
        this.scene.stop("BattleRoyaleScene");
        this.scene.stop();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$16b2a7db5b493444)));
    }
}






const $22d285200be5b863$var$subTextColor = 0xbfaac6;
const $22d285200be5b863$var$modalHeight = 325;
const $22d285200be5b863$var$modalWidth = 494;
const $22d285200be5b863$var$modalRadius = 25;
const $22d285200be5b863$var$modalColor = 0x350926;
const $22d285200be5b863$var$modalAlpha = 1;
const $22d285200be5b863$var$modalBorderColor = 0x3d4361;
const $22d285200be5b863$var$modalBorderWidth = 1;
class $22d285200be5b863$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BossFightServerUnavailableScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$6b05ab6b067cc0c6));
    }
    create() {
        // Add Window
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $22d285200be5b863$var$modalWidth, $22d285200be5b863$var$modalHeight, $22d285200be5b863$var$modalRadius, $22d285200be5b863$var$modalColor, $22d285200be5b863$var$modalAlpha);
        modalBg.setStrokeStyle($22d285200be5b863$var$modalBorderWidth, $22d285200be5b863$var$modalBorderColor, $22d285200be5b863$var$modalAlpha);
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 120, "cc_outline", "Oops! Boss Fight server is down.", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 80, "cc_outline", "*Please notify the team in discord.", 20, 0).setOrigin(0.5, 0).setCenterAlign().setTint($22d285200be5b863$var$subTextColor);
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 40, "party_blob").setOrigin(0.5, 0.5).play("blob_animation");
        // Buttons
        this.cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "bossfight_victory_return_home_button", true, 1.05);
        this.cancelButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.stop("BossFightScene");
            this.scene.stop();
            this.scene.start("HomebaseScene");
        });
        this.add.existing(this.cancelButton);
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$6b05ab6b067cc0c6)));
    }
}







const $55dff0db4147c021$var$subTextColor = 0xbfaac6;
const $55dff0db4147c021$var$modalHeight = 325;
const $55dff0db4147c021$var$modalWidth = 494;
const $55dff0db4147c021$var$modalRadius = 25;
const $55dff0db4147c021$var$modalColor = 0x350926;
const $55dff0db4147c021$var$modalAlpha = 1;
const $55dff0db4147c021$var$modalBorderColor = 0x3d4361;
const $55dff0db4147c021$var$modalBorderWidth = 1;
class $55dff0db4147c021$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BossFightLobbyClosedScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$580998fdd520199e));
    }
    create() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($55dff0db4147c021$var$modalWidth, $55dff0db4147c021$var$modalHeight);
        // Add Window
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, $55dff0db4147c021$var$modalWidth, $55dff0db4147c021$var$modalHeight, $55dff0db4147c021$var$modalRadius, $55dff0db4147c021$var$modalColor, $55dff0db4147c021$var$modalAlpha);
        modalBg.setStrokeStyle($55dff0db4147c021$var$modalBorderWidth, $55dff0db4147c021$var$modalBorderColor, $55dff0db4147c021$var$modalAlpha);
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 120, "cc_outline", "Boss Fight Lobby is currently closed", 26, 0).setOrigin(0.5, 0).setCenterAlign();
        this.add.bitmapText(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + 80, "cc_outline", "Lobby will open 10 minutes before game time.", 20, 0).setOrigin(0.5, 0).setCenterAlign().setTint($55dff0db4147c021$var$subTextColor);
        // blob animation
        var animationConfig = {
            key: "blob_animation",
            frames: this.anims.generateFrameNumbers("party_blob", {
                start: 0,
                end: 7,
                first: 7
            }),
            frameRate: 15,
            repeat: -1
        };
        this.anims.create(animationConfig);
        this.add.sprite(this.sys.canvas.width / 2, this.sys.canvas.height / 2 - 30, "party_blob").setOrigin(0.5, 0.5).play("blob_animation");
        // Buttons
        this.cancelButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "bossfight_victory_return_home_button", true, 1.05);
        this.cancelButton.onClick().subscribe((pointer)=>{
            this.unloadAssets();
            this.scene.stop("BattleRoyaleScene");
            this.scene.stop();
            this.scene.start("HomebaseScene");
        });
        this.add.existing(this.cancelButton);
    }
    applyScale(number) {
        return number;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$580998fdd520199e)));
    }
}







class $da12f2862c06501b$var$BattlePassService {
    constructor(){
        this._objectives = [];
        this._daily = [];
        this._weekly = [];
        this._monthly = [];
        if ($da12f2862c06501b$var$BattlePassService._instance) throw new Error("Error: Instantiation failed: Use BattlePassService.getInstance() instead of new.");
        $da12f2862c06501b$var$BattlePassService._instance = this;
        this._objectives = [];
        this._daily = [];
        this._weekly = [];
        this._monthly = [];
    }
    static getInstance() {
        return $da12f2862c06501b$var$BattlePassService._instance;
    }
    getObjectives(forceUpdate = false) {
        return new Promise((resolve, reject)=>{
            if (this._objectives && !forceUpdate) return resolve(this._objectives);
            else return resolve(this.fetchActiveSeasonObjectives());
        });
    }
    getObjectivesSync() {
        return this._objectives;
    }
    getDailyObjectivesSync() {
        return this._daily;
    }
    getWeeklyObjectivesSync() {
        return this._weekly;
    }
    getMonthlyObjectivesSync() {
        return this._monthly;
    }
    fetchActiveSeasonObjectives() {
        ///battle_pass/objectives/active/:user_address
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "objectives",
            "active",
            wallet
        ], []).then((res)=>{
            this._objectives = res.objectives;
            this.splitObjectivesIntoCategories();
            return res.objectives;
        });
    }
    splitObjectivesIntoCategories() {
        // Clear Lists so no duplicated
        this._daily = [];
        this._weekly = [];
        this._monthly = [];
        // Seperate Objectives into Category
        this._objectives.forEach((objective)=>{
            switch(objective.expires_after_days){
                case 1:
                    this._daily.push(objective);
                    break;
                case 7:
                    this._weekly.push(objective);
                    break;
                case 30:
                    this._monthly.push(objective);
                    break;
            }
        });
    }
    getBattlePassData() {
        ///battle_pass/objectives/active/:user_address
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "objectives",
            "active",
            wallet
        ], []).then((res)=>{
            return res;
        });
    }
    purchaseBattlePass() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("battle_pass", [
            "purchase",
            wallet
        ], {}).then((res)=>{
            return res;
        });
    }
    getAllSeasonObjectives() {
        ///battle_pass/objectives/all/:user_address/:season?
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "objectives",
            "all",
            wallet,
            "1"
        ], []).then((res)=>{
            return res;
        });
    }
    getCurrentBattlePassRewards() {
        ///battle_pass/rewards/:season?
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "rewards"
        ], []).then((res)=>{
            return res;
        });
    }
    getRemainingBattlePassCount() {
        ///battle_pass/remaining/
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "remaining"
        ], []).then((res)=>{
            return res;
        });
    }
    getUnclaimedBattlePassRewards() {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().get("battle_pass", [
            "rewards",
            "unclaimed",
            wallet
        ], []).then((res)=>{
            return res;
        });
    }
    claimBattlePassRewards(season, level) {
        const wallet = (0, $8f311ccd3269afe0$export$2e2bcd8739ae039).getInstance().getWalletAddress();
        return (0, $630775c37483ad23$export$2e2bcd8739ae039).getInstance().post("battle_pass", [
            "rewards",
            "unclaimed",
            wallet,
            "claim",
            level,
            "season",
            season
        ], {}).then((res)=>{
            return res;
        });
    }
}
$da12f2862c06501b$var$BattlePassService._instance = new $da12f2862c06501b$var$BattlePassService();
var $da12f2862c06501b$export$2e2bcd8739ae039 = $da12f2862c06501b$var$BattlePassService;





const $0a300af4a3bd78d7$var$width = 1512;
const $0a300af4a3bd78d7$var$height = 982;
class $0a300af4a3bd78d7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattlePassBuyScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f615f228783efcde));
    }
    create() {
        this.setBackgroundColour("#5631FF");
        this.createComponent();
    }
    createComponent() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($0a300af4a3bd78d7$var$width, $0a300af4a3bd78d7$var$height);
        // this._backgroundImage = this.add.image(
        // 	this.sys.canvas.width / 2,
        // 	this.sys.canvas.height / 2,
        // 	"battlepass_background_image"
        // ).setScale(this._scale)
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $0a300af4a3bd78d7$var$width * this._scale,
            height: $0a300af4a3bd78d7$var$height * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Image
        this._backgroundImage = this.add.image(0, 0, "battlepass_background_image").setScale(this._scale);
        sizer.add(this._backgroundImage, {
            key: "bp-background",
            align: "left-center",
            offsetX: this.applyScale(266),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Buttons
        this._backButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_back_button", true, 1.05).setScale(this._scale);
        this._backButton.onClick().subscribe((pointer)=>{
            this.setBackgroundColour("#0f0f1f");
            this.unloadAssets();
            this.scene.stop();
            this.scene.start("HomebaseScene");
        });
        this.add.existing(this._backButton);
        sizer.add(this._backButton, {
            key: "back-button",
            align: "left-top",
            offsetX: this.applyScale(42),
            offsetY: this.applyScale(48),
            expand: false
        });
        this._exploreButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_explore_button", true, 1.05).setScale(this._scale);
        this._exploreButton.onClick().subscribe((pointer)=>{
            var _a;
            (_a = window.open("https://www.starwolvez.com/battle-pass", "_blank")) === null || _a === void 0 || _a.focus();
        });
        this.add.existing(this._exploreButton);
        sizer.add(this._exploreButton, {
            key: "explore-button",
            align: "left-top",
            offsetX: this.applyScale(47),
            offsetY: this.applyScale(851),
            expand: false
        });
        var buyImage = (0, $a84396f9bb426f08$export$2e2bcd8739ae039).getInstance().ownsGLFHersArcade() ? "battlepass_buy_button_glfhers" : "battlepass_buy_button";
        this._buyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, buyImage, true, 1.05).setScale(this._scale);
        this._buyButton.onClick().subscribe((pointer)=>{
            (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().purchaseBattlePass().then((res)=>{
                if (res.success === 1) {
                    // Purchase Successful
                    this.unloadAssets();
                    this.scene.stop();
                    this.scene.start("BattlePassBuySuccessScene");
                }
            });
        });
        this.add.existing(this._buyButton);
        sizer.add(this._buyButton, {
            key: "buy-button",
            align: "left-top",
            offsetX: this.applyScale(303),
            offsetY: this.applyScale(851),
            expand: false
        });
        // Images
        this._seasonText = this.add.image(0, 0, "battlepass_season_text").setScale(this._scale);
        sizer.add(this._seasonText, {
            key: "bp-text",
            align: "left-top",
            offsetX: this.applyScale(42),
            offsetY: this.applyScale(587),
            expand: false
        });
        this._seasonCard = this.add.image(0, 0, "battlepass_season_image").setScale(this._scale);
        sizer.add(this._seasonCard, {
            key: "bp-season-card",
            align: "left-top",
            offsetX: this.applyScale(815),
            offsetY: this.applyScale(170),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    setBackgroundColour(colour) {
        document.body.style.backgroundImage = "none";
        document.body.style.backgroundColor = colour;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f615f228783efcde)));
    }
}



var $7WQrb = parcelRequire("7WQrb");






const $3fd42784f8190fba$var$width = 1512;
const $3fd42784f8190fba$var$height = 982;
class $3fd42784f8190fba$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "BattlePassBuySuccessScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$afdd050f6270ccc4));
    }
    create() {
        // Set Background Color
        this.setBackgroundColour("#5631FF");
        this.createComponent();
    }
    createComponent() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($3fd42784f8190fba$var$width, $3fd42784f8190fba$var$height);
        this._backgroundImage = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "battlepass_buy_success_background").setScale(this._scale);
        var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $3fd42784f8190fba$var$width * this._scale,
            height: $3fd42784f8190fba$var$height * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Buttons
        this._homebaseButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_homebase_button", true, 1.05).setScale(this._scale);
        this._homebaseButton.onClick().subscribe((pointer)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                this.setBackgroundColour("#0f0f1f");
                this.unloadAssets();
                this.scene.stop();
                yield (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((res)=>{
                    this.scene.start("BattlePassScene", {
                        userData: (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync()
                    });
                });
            }));
        this.add.existing(this._homebaseButton);
        sizer.add(this._homebaseButton, {
            key: "back-button",
            align: "left-top",
            offsetX: this.applyScale(581),
            offsetY: this.applyScale(845),
            expand: false
        });
        //Images
        this._successText = this.add.image(0, 0, "battlepass_success_text").setScale(this._scale);
        sizer.add(this._successText, {
            key: "bp-success-text",
            align: "left-top",
            offsetX: this.applyScale(581),
            offsetY: this.applyScale(86),
            expand: false
        });
        this._successInfoText = this.add.image(0, 0, "battlepass_success_info_text").setScale(this._scale);
        sizer.add(this._successInfoText, {
            key: "bp-success-info-text",
            align: "left-top",
            offsetX: this.applyScale(592),
            offsetY: this.applyScale(204),
            expand: false
        });
        this._seasonCard = this.add.image(0, 0, "battlepass_season_image").setScale(this._scale);
        sizer.add(this._seasonCard, {
            key: "bp-season-card",
            align: "left-top",
            offsetX: this.applyScale(497),
            offsetY: this.applyScale(240),
            expand: false
        });
        // Layout the Scene
        sizer.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    setBackgroundColour(colour) {
        document.body.style.backgroundImage = "none";
        document.body.style.backgroundColor = colour;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$afdd050f6270ccc4)));
    }
}



var $7WQrb = parcelRequire("7WQrb");













// Rank
const $ff7e53987a1c953a$var$rankHeight = 48;
const $ff7e53987a1c953a$var$rankWidth = 116;
const $ff7e53987a1c953a$var$rankRadius = 7;
const $ff7e53987a1c953a$var$unlockedBackgroundColor = 0x3dff50;
const $ff7e53987a1c953a$var$lockedBackgroundColor = 0xb48dc7;
const $ff7e53987a1c953a$var$rankAlpha = 60;
const $ff7e53987a1c953a$var$rankUnlockedBorderColor = 0x383d57;
const $ff7e53987a1c953a$var$rankLockedBorderColor = 0xffffff;
const $ff7e53987a1c953a$var$rankLockedBorderColorAlpha = 40;
class $ff7e53987a1c953a$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        var level = data.item.level;
        var unlocked = data.level >= level ? true : false;
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($ff7e53987a1c953a$var$rankWidth),
            height: scene.applyScale($ff7e53987a1c953a$var$rankHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Rank
        this._rankBackground = scene.add.rexRoundRectangle(0, 0, scene.applyScale($ff7e53987a1c953a$var$rankWidth), scene.applyScale($ff7e53987a1c953a$var$rankHeight), scene.applyScale($ff7e53987a1c953a$var$rankRadius), unlocked ? $ff7e53987a1c953a$var$unlockedBackgroundColor : $ff7e53987a1c953a$var$lockedBackgroundColor, $ff7e53987a1c953a$var$rankAlpha);
        this.add(this._rankBackground, {
            key: "rank-background",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Rank Text
        this._rankNumber = scene.add.bitmapText(0, 0, "cc_outline", level, this.applyScale(22), 1);
        sizerPanel.add(this._rankNumber, {
            key: "rank-text",
            align: "center",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassItemRankComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $ff7e53987a1c953a$export$2e2bcd8739ae039(this.scene, x, y, data));
});




const $fb075a83f3812222$var$paneHeight = 257;
const $fb075a83f3812222$var$paneWidth = 130;
const $fb075a83f3812222$var$paneRadius = 7;
const $fb075a83f3812222$var$borderWidth = 1;
// Item
const $fb075a83f3812222$var$itemHeight = 146;
const $fb075a83f3812222$var$itemWidth = 116;
const $fb075a83f3812222$var$itemBackgroundColor = 0xb48dc7;
const $fb075a83f3812222$var$itemAlpha = 40;
const $fb075a83f3812222$var$itemLockedImageAlpha = 50;
class $fb075a83f3812222$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._itemData = data.item;
        this._battlePassLevel = data.level;
        // Determines if Reward has been claimed by player
        this._claimed = this._itemData.claimed == "0" ? false : true;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        //var unlocked = this._battlePassLevel >= this._itemData.level ? true : false;
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($fb075a83f3812222$var$paneWidth),
            height: scene.applyScale($fb075a83f3812222$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Item
        this._itemBackground = scene.add.rexRoundRectangle(0, 0, scene.applyScale($fb075a83f3812222$var$itemWidth), scene.applyScale($fb075a83f3812222$var$itemHeight), scene.applyScale($fb075a83f3812222$var$paneRadius), $fb075a83f3812222$var$itemBackgroundColor, $fb075a83f3812222$var$itemAlpha);
        this.add(this._itemBackground, {
            key: "item-background",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(49),
            expand: false
        });
        this._unlockedTick = scene.add.image(0, 0, "battlepass_unlocked").setScale(this._scale);
        this._unlockedTick.visible = this._claimed;
        sizerPanel.add(this._unlockedTick, {
            key: "bp-tick",
            align: "left-top",
            offsetX: this.applyScale(88),
            offsetY: this.applyScale(33),
            expand: false
        });
        this._itemImage = scene.add.image(0, 0, this._itemData.imageKey).setScale(this._scale);
        sizerPanel.add(this._itemImage, {
            key: "bp-image",
            align: "center",
            offsetX: this.applyScale(-6),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassItemImageComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $fb075a83f3812222$export$2e2bcd8739ae039(this.scene, x, y, data));
});


const $e6a5ba55ea304473$var$paneHeight = 257;
const $e6a5ba55ea304473$var$paneWidth = 130;
const $e6a5ba55ea304473$var$paneRadius = 7;
const $e6a5ba55ea304473$var$borderWidth = 1;
// Item
const $e6a5ba55ea304473$var$itemHeight = 146;
const $e6a5ba55ea304473$var$itemWidth = 116;
const $e6a5ba55ea304473$var$itemBackgroundColor = 0xb48dc7;
const $e6a5ba55ea304473$var$itemAlpha = 40;
// Rank
const $e6a5ba55ea304473$var$rankHeight = 48;
const $e6a5ba55ea304473$var$rankWidth = 116;
const $e6a5ba55ea304473$var$rankBackgroundColor = 0x3dff50;
const $e6a5ba55ea304473$var$rankAlpha = 60;
const $e6a5ba55ea304473$var$rankUnlockedBorderColor = 0x383d57;
const $e6a5ba55ea304473$var$rankLockedBorderColor = 0xffffff;
const $e6a5ba55ea304473$var$rankLockedBorderColorAlpha = 40;
const $e6a5ba55ea304473$var$currentLevel = 51;
var $e6a5ba55ea304473$var$RewardType;
(function(RewardType) {
    RewardType[RewardType["XP"] = 1] = "XP";
    RewardType[RewardType["Currency"] = 2] = "Currency";
    RewardType[RewardType["BronzePack"] = 3] = "BronzePack";
    RewardType[RewardType["ShopItem"] = 4] = "ShopItem";
    RewardType[RewardType["SilverPack"] = 5] = "SilverPack";
    RewardType[RewardType["GoldPack"] = 6] = "GoldPack";
    RewardType[RewardType["Machine"] = 7] = "Machine";
    RewardType[RewardType["RarePack"] = 8] = "RarePack";
    RewardType[RewardType["LegendaryPack"] = 9] = "LegendaryPack";
    RewardType[RewardType["MythicPack"] = 10] = "MythicPack";
    RewardType[RewardType["EpicPack"] = 11] = "EpicPack";
    RewardType[RewardType["NFT"] = 12] = "NFT";
    RewardType[RewardType["MachineSkin"] = 13] = "MachineSkin";
})($e6a5ba55ea304473$var$RewardType || ($e6a5ba55ea304473$var$RewardType = {}));
class $e6a5ba55ea304473$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._level = data.level;
        this._battlepassXP = data.battlepassXP;
        this._itemData = data.item;
        this._itemData.imageKey = this.getImageKey();
        this._itemData.rewardDescription = this.getRewardDescription();
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($e6a5ba55ea304473$var$paneWidth),
            height: scene.applyScale($e6a5ba55ea304473$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Enables Interaction
        sizerPanel.setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            scene.scene.get("BattlePassScene").input.enabled = false;
            scene.scene.launch("BattlePassItemClaimScene", {
                rewardData: this._itemData,
                level: this._level,
                battlepassXP: this._battlepassXP
            });
            scene.scene.pause();
        });
        // Item
        this._itemImageComponent = new (0, $fb075a83f3812222$export$2e2bcd8739ae039)(scene, 0, 0, data, scene.getScale());
        sizerPanel.add(this._itemImageComponent, {
            key: "item-component",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Rank
        var itemRankComponent = new (0, $ff7e53987a1c953a$export$2e2bcd8739ae039)(scene, 0, 0, data, scene.getScale());
        sizerPanel.add(itemRankComponent, {
            key: "rank-component",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(209),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getImageKey() {
        var imageKey = "";
        switch(this._itemData.reward_type){
            case $e6a5ba55ea304473$var$RewardType.XP:
                imageKey = "xp_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.Currency:
                switch(this._itemData.currency_name){
                    case "neon_gold":
                        imageKey = "bp_neon_gold_icon";
                        break;
                    case "space_elixir":
                        imageKey = "bp_space_elixir_icon";
                        break;
                    case "stardust":
                        imageKey = "bp_stardust_icon";
                        break;
                    case "dark_matter":
                        imageKey = "dark_matter_icon";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.BronzePack:
                imageKey = "bronze_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.ShopItem:
                switch(this._itemData.shop_item_name){
                    case "BK-55 Chip":
                        imageKey = "bk55_icon";
                        break;
                    case "Animation Chip":
                        imageKey = "nm8_icon";
                        break;
                    case "Star Wolvez Hoodie":
                        imageKey = "sw_hoodie_icon";
                        break;
                    case "FUR-69":
                        imageKey = "fur_chip_icon";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.SilverPack:
                imageKey = "silver_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.GoldPack:
                imageKey = "gold_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.Machine:
                switch(this._itemData.machine_name){
                    case "Battle Pass Blob Cosmetic":
                        imageKey = "blob_consmetic_icon";
                        break;
                    case "Ice Storm Tracker Cosmetic":
                        imageKey = "ice_storm_tracker_cosmetic";
                        break;
                    case "Fire Storm Tracker Cosmetic":
                        imageKey = "fire_storm_tracker_cosmetic";
                        break;
                    case "Water Cooler Cosmetic":
                        imageKey = "water_cooler_cosmetic_icon";
                        break;
                    case "A Piece of Home Cosmetic":
                        imageKey = "little_piece_of_home_cosmetic";
                        break;
                    case "Star Wolvez Helmet Cosmetic":
                        imageKey = "star_wolvez_helmet_cosmetic";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.RarePack:
                imageKey = "rare_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.EpicPack:
                imageKey = "epic_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.LegendaryPack:
                imageKey = "legendary_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.MythicPack:
                imageKey = "mythical_pack_icon";
                break;
            case $e6a5ba55ea304473$var$RewardType.NFT:
                imageKey = "";
                break;
            case $e6a5ba55ea304473$var$RewardType.MachineSkin:
                imageKey = "gold_plasma_cannon_skin";
                break;
        }
        return imageKey;
    }
    getRewardDescription() {
        var description = "";
        switch(this._itemData.reward_type){
            case $e6a5ba55ea304473$var$RewardType.XP:
                description = this._itemData.value.toLocaleString("en-us") + " XP";
                break;
            case $e6a5ba55ea304473$var$RewardType.Currency:
                switch(this._itemData.currency_name){
                    case "neon_gold":
                        description = this._itemData.value.toLocaleString("en-us") + " NEON GOLD";
                        break;
                    case "space_elixir":
                        description = this._itemData.value.toLocaleString("en-us") + " SPACE ELIXIR";
                        break;
                    case "stardust":
                        description = this._itemData.value.toLocaleString("en-us") + " STARDUST";
                        break;
                    case "dark_matter":
                        description = this._itemData.value.toLocaleString("en-us") + " DARK MATTER";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.BronzePack:
                description = "BRONZE PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.ShopItem:
                switch(this._itemData.shop_item_name){
                    case "BK-55 Chip":
                        description = "BK-55 CHIP";
                        break;
                    case "Animation Chip":
                        description = "ANIMATION CHIP";
                        break;
                    case "Star Wolvez Hoodie":
                        description = "STAR WOLVEZ HOODIE";
                        break;
                    case "FUR-69":
                        description = "FUR-69 CHIP";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.SilverPack:
                description = "SILVER PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.GoldPack:
                description = "GOLD PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.Machine:
                switch(this._itemData.machine_name){
                    case "Battle Pass Blob Cosmetic":
                        description = "BATTLE PASS BLOB COSMETIC";
                        break;
                    case "Ice Storm Tracker Cosmetic":
                        description = "ICE STORM TRACKER COSMETIC";
                        break;
                    case "Fire Storm Tracker Cosmetic":
                        description = "FIRE STORM TRACKER COSMETIC";
                        break;
                    case "Water Cooler Cosmetic":
                        description = "WATER COOLER COSMETIC";
                        break;
                    case "A Piece of Home Cosmetic":
                        description = "A PIECE OF HOME COSMETIC";
                        break;
                    case "Star Wolvez Helmet Cosmetic":
                        description = "STAR WOLVEZ HELMET COSMETIC";
                        break;
                }
                break;
            case $e6a5ba55ea304473$var$RewardType.RarePack:
                description = "RARE PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.EpicPack:
                description = "EPIC PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.LegendaryPack:
                description = "LEGENDARY PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.MythicPack:
                description = "MYTHICAL PACK";
                break;
            case $e6a5ba55ea304473$var$RewardType.NFT:
                description = "";
                break;
            case $e6a5ba55ea304473$var$RewardType.MachineSkin:
                description = "GOLD PLASMA CANNON SKIN";
                break;
        }
        return description;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassItemComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $e6a5ba55ea304473$export$2e2bcd8739ae039(this.scene, x, y, data));
});


// Pane Details
const $4b85ccb33d5b8328$var$paneHeight = 350;
const $4b85ccb33d5b8328$var$paneWidth = 1512;
const $4b85ccb33d5b8328$var$paneRadius = 26;
const $4b85ccb33d5b8328$var$paneColor = 0x053165;
const $4b85ccb33d5b8328$var$paneAlpha = 0.9;
// Table Details
const $4b85ccb33d5b8328$var$tableHeight = 257;
const $4b85ccb33d5b8328$var$tableWidth = 1380;
const $4b85ccb33d5b8328$var$itemWidth = 116;
// Scroll Distance
const $4b85ccb33d5b8328$var$nextScrollDistance = -1390.11;
const $4b85ccb33d5b8328$var$previousScrollDistance = 1390.11;
class $4b85ccb33d5b8328$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $4b85ccb33d5b8328$var$paneWidth,
            height: paneScale * $4b85ccb33d5b8328$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._rowIndex = -1;
        this._scale = paneScale;
        this._claimedRewardLevel = data.claimedLevel;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Sizer
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($4b85ccb33d5b8328$var$paneWidth),
            height: scene.applyScale($4b85ccb33d5b8328$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Levels Table
        this._levelsTable = this.createLevelsTable(this.scene, data, x, y, this.scale).layout();
        // Determines if a reward has been claimed and return levels table index of said claimed reward
        this._rowIndex = this.calculateRowIndex(this._levelsTable.startRowIndex);
        this._levelsTable.scrollToRow(this._rowIndex);
        this._levelsTable.setScrollerEnable(false);
        sizerPanel.add(this._levelsTable, {
            key: "levels-panel",
            align: "left-top",
            offsetX: this.applyScale(79),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Buttons
        this._nextButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battlepass_next_page_button_active", false).setScale(this._scale);
        this._nextButton.onClick().subscribe((pointer)=>{
            if (!(this._rowIndex + 10 > 99)) {
                this._rowIndex += 9.999;
                this._levelsTable.scrollToRow(this._rowIndex);
            }
        });
        sizerPanel.add(scene.add.existing(this._nextButton), {
            key: "next-button",
            align: "left-top",
            offsetX: this.applyScale(1279),
            offsetY: this.applyScale(290),
            expand: false
        });
        this._previousButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battlepass_previous_page_button_active", false).setScale(this._scale);
        this._previousButton.onClick().subscribe((pointer)=>{
            if (!(this._rowIndex - 10 < -1)) {
                this._rowIndex -= 9.999;
                this._levelsTable.scrollToRow(this._rowIndex);
            }
        });
        sizerPanel.add(scene.add.existing(this._previousButton), {
            key: "previous-button",
            align: "left-top",
            offsetX: this.applyScale(1050),
            offsetY: this.applyScale(290),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    createLevelsTable(scene, data, x, y, scale) {
        var table = scene.rexUI.add.gridTable({
            width: this.applyScale($4b85ccb33d5b8328$var$tableWidth),
            height: this.applyScale($4b85ccb33d5b8328$var$tableHeight),
            items: data.rewards,
            scrollMode: 1,
            table: {
                cellWidth: this.applyScale(139),
                cellHeight: this.applyScale(257),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            // mouseWheelScroller: {
            //   focus: true,
            //   speed: 0.2,
            // },
            space: {
                table: {
                    left: this.applyScale(0),
                    right: this.applyScale(0)
                }
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                var sizer = scene.rexUI.add.fixWidthSizer({
                    width: scene.applyScale(149),
                    space: {
                        left: 0,
                        right: scene.applyScale(23),
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0
                });
                var itemComponent = new (0, $e6a5ba55ea304473$export$2e2bcd8739ae039)(scene, 0, 0, {
                    item: item,
                    level: data.level,
                    battlepassXP: data.battlepassXP
                }, scene.getScale());
                sizer.add(itemComponent, {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    },
                    key: "item_component"
                });
                return sizer;
            }
        }).setOrigin(0, 0.5);
        table.setItems(data.rewards).scrollToTop();
        return table;
    }
    calculateRowIndex(startRowIndex) {
        var rowIndex = startRowIndex;
        if (this._claimedRewardLevel <= 10) rowIndex = 0;
        else if (this._claimedRewardLevel > 10 && this._claimedRewardLevel <= 20) rowIndex = 9.999;
        else if (this._claimedRewardLevel > 20 && this._claimedRewardLevel <= 30) rowIndex = 19.998;
        else if (this._claimedRewardLevel > 30 && this._claimedRewardLevel <= 40) rowIndex = 29.997;
        else if (this._claimedRewardLevel > 40 && this._claimedRewardLevel <= 50) rowIndex = 39.996;
        else if (this._claimedRewardLevel > 50 && this._claimedRewardLevel <= 60) rowIndex = 9.999 * 5;
        else if (this._claimedRewardLevel > 60 && this._claimedRewardLevel <= 70) rowIndex = 59.994;
        else if (this._claimedRewardLevel > 70 && this._claimedRewardLevel <= 80) rowIndex = 9.999 * 7;
        else if (this._claimedRewardLevel > 80 && this._claimedRewardLevel <= 90) rowIndex = 79.992;
        else if (this._claimedRewardLevel > 90 && this._claimedRewardLevel <= 100) rowIndex = 89.991;
        return rowIndex;
    }
    hidePane() {
        this._levelsTable.setAlpha(0);
        this._levelsTable.disableInteractive();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassLevelsPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $4b85ccb33d5b8328$export$2e2bcd8739ae039(this.scene, x, y));
});




// Rank
const $c1caaa4eb2ed59a8$var$height = 43;
const $c1caaa4eb2ed59a8$var$width = 308;
const $c1caaa4eb2ed59a8$var$radius = 11;
const $c1caaa4eb2ed59a8$var$backgroundColor = 0x383d57;
const $c1caaa4eb2ed59a8$var$alpha = 100;
class $c1caaa4eb2ed59a8$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($c1caaa4eb2ed59a8$var$width),
            height: scene.applyScale($c1caaa4eb2ed59a8$var$height),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Background
        this._background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($c1caaa4eb2ed59a8$var$width), scene.applyScale($c1caaa4eb2ed59a8$var$height), scene.applyScale($c1caaa4eb2ed59a8$var$radius), $c1caaa4eb2ed59a8$var$backgroundColor, $c1caaa4eb2ed59a8$var$alpha);
        this.add(this._background, {
            key: "background",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._divider = scene.add.image(0, 0, "battlepass_xp_component_divider").setScale(this._scale);
        this.add(this._divider, {
            key: "bp-xp-divider",
            align: "left-top",
            offsetX: this.applyScale(6),
            offsetY: this.applyScale(3),
            expand: false
        });
        // Battle Pass XP Label
        var label = scene.rexUI.add.label({
            orientation: "x",
            //rtl: this.rtl,
            text: scene.add.bitmapText(0, 0, "cc_outline", "Battle Pass Level", scene.applyScale(16), 0)
        });
        this.add(label, {
            key: "bp-label",
            align: "left-top",
            offsetX: this.applyScale(9),
            offsetY: this.applyScale(14),
            expand: false
        });
        // XP Label
        var xpLabel = scene.rexUI.add.label({
            orientation: "x",
            //rtl: this.rtl,
            text: scene.add.bitmapText(0, 0, "cc_outline", data, scene.applyScale(16), 0)
        });
        this.add(xpLabel, {
            key: "bp-xp-label",
            align: "left-top",
            offsetX: this.applyScale(243),
            offsetY: this.applyScale(14),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassXPComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new battlePassXPComponent(this.scene, x, y, data));
});







const $9b6b28d4f52c39e6$var$backgroundHeight = 399;
const $9b6b28d4f52c39e6$var$backgroundWidth = 532;
const $9b6b28d4f52c39e6$var$backgroundRadius = 17;
const $9b6b28d4f52c39e6$var$backgroundColor = 0xb48dc7;
const $9b6b28d4f52c39e6$var$backgroundAlpha = 40;
const $9b6b28d4f52c39e6$var$borderWidth = 1;
class $9b6b28d4f52c39e6$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($9b6b28d4f52c39e6$var$backgroundWidth),
            height: scene.applyScale($9b6b28d4f52c39e6$var$backgroundHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($9b6b28d4f52c39e6$var$backgroundWidth), scene.applyScale($9b6b28d4f52c39e6$var$backgroundHeight), scene.applyScale($9b6b28d4f52c39e6$var$backgroundRadius), $9b6b28d4f52c39e6$var$backgroundColor, $9b6b28d4f52c39e6$var$backgroundAlpha);
        this.add(background, {
            key: "background",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Text
        this._titleText = this.scene.add.bitmapText(0, 0, "cc_outline", "Assign your Raffle Rocks", this.applyScale(18), 0);
        sizerPanel.add(this._titleText, {
            key: "title-text",
            align: "left-top",
            offsetX: this.applyScale(40),
            offsetY: this.applyScale(34),
            expand: false
        });
        this._titleSubtext = this.scene.add.bitmapText(0, 0, "cc_outline", "Each Raffle Rock that you have collected acts as ONE raffle ticket. These can be earned in game or bought from the store.", this.applyScale(14), 0);
        sizerPanel.add(this._titleSubtext, {
            key: "title-sub-text",
            align: "left-top",
            offsetX: this.applyScale(40),
            offsetY: this.applyScale(76),
            expand: false
        });
        // Text
        this._raffleRocksTitle = this.scene.add.bitmapText(0, 0, "cc_outline", "AVAILABLE RAFFLE ROCKS", this.applyScale(18), 0);
        sizerPanel.add(this._raffleRocksTitle, {
            key: "raffle-text",
            align: "left-top",
            offsetX: this.applyScale(40),
            offsetY: this.applyScale(184),
            expand: false
        });
        // Image
        this._raffleRock = scene.add.image(0, 0, "battlepass_mini_rock").setScale(this._scale);
        sizerPanel.add(this._raffleRock, {
            key: "raffle-rock",
            align: "left-top",
            offsetX: this.applyScale(40),
            offsetY: this.applyScale(212),
            expand: false
        });
        this._raffleRockCount = this.scene.add.bitmapText(0, 0, "cc_outline", "5", this.applyScale(26), 0);
        sizerPanel.add(this._raffleRockCount, {
            key: "count-text",
            align: "left-top",
            offsetX: this.applyScale(82),
            offsetY: this.applyScale(212),
            expand: false
        });
        // Buttons
        this._assignButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battlepass_assign_button", true, 1.05).setScale(this._scale);
        this._assignButton.onClick().subscribe((pointer)=>{});
        scene.add.existing(this._assignButton);
        sizerPanel.add(this._assignButton, {
            key: "asign-button",
            align: "left-top",
            offsetX: this.applyScale(40),
            offsetY: this.applyScale(306),
            expand: false
        });
        this._assignAllButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "battlepass_assign_all_button", true, 1.05).setScale(this._scale);
        this._assignAllButton.onClick().subscribe((pointer)=>{});
        scene.add.existing(this._assignAllButton);
        sizerPanel.add(this._assignAllButton, {
            key: "asign-all-button",
            align: "left-top",
            offsetX: this.applyScale(277),
            offsetY: this.applyScale(306),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassWeeklyRaffleComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new BattlePassWeeklyRaffleComponent(this.scene, x, y, data));
});




const $9ae17738a58c01ea$var$paneHeight = 320;
const $9ae17738a58c01ea$var$paneWidth = 290;
const $9ae17738a58c01ea$var$backgroundHeight = 286;
const $9ae17738a58c01ea$var$backgroundWidth = 290;
const $9ae17738a58c01ea$var$backgroundRadius = 17;
const $9ae17738a58c01ea$var$backgroundColor = 0xb48dc7;
const $9ae17738a58c01ea$var$backgroundAlpha = 40;
const $9ae17738a58c01ea$var$borderWidth = 1;
class $9ae17738a58c01ea$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 150,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // Sizer for entrie width and height
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($9ae17738a58c01ea$var$paneWidth),
            height: scene.applyScale($9ae17738a58c01ea$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // Background
        const background = scene.add.rexRoundRectangle(0, 0, scene.applyScale($9ae17738a58c01ea$var$backgroundWidth), scene.applyScale($9ae17738a58c01ea$var$backgroundHeight), scene.applyScale($9ae17738a58c01ea$var$backgroundRadius), $9ae17738a58c01ea$var$backgroundColor, $9ae17738a58c01ea$var$backgroundAlpha);
        this.add(background, {
            key: "background",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(34),
            expand: false
        });
        // Image
        this._raffleImage = scene.add.image(0, 0, "battlepass_present").setScale(this._scale);
        sizerPanel.add(this._raffleImage, {
            key: "bp-background",
            align: "left-top",
            offsetX: this.applyScale(111),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Text
        this._titleText = this.scene.add.bitmapText(0, 0, "cc_outline", "Weekly Raffle", this.applyScale(18), 0);
        sizerPanel.add(this._titleText, {
            key: "title-text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(97),
            expand: false
        });
        this._subText = this.scene.add.bitmapText(0, 0, "cc_outline", "Every week, nothing but prizes", this.applyScale(14), 0);
        sizerPanel.add(this._subText, {
            key: "sub-text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(140),
            expand: false
        });
        this._countdownText = this.scene.add.bitmapText(0, 0, "cc_outline", "Winners announced in", this.applyScale(14), 0);
        sizerPanel.add(this._countdownText, {
            key: "countdown-text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(216),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassWeeklyRaffleComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $9ae17738a58c01ea$export$2e2bcd8739ae039(this.scene, x, y, data));
});


// Pane Details
const $8092574bc3888e94$var$paneHeight = 443;
const $8092574bc3888e94$var$paneWidth = 855;
class $8092574bc3888e94$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        let conf = config ? config : {
            width: paneScale * $8092574bc3888e94$var$paneWidth,
            height: paneScale * $8092574bc3888e94$var$paneHeight,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this.createComponent(scene, x, y, 0);
    }
    createComponent(scene, x, y, data) {
        // Sizer
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: scene.applyScale($8092574bc3888e94$var$paneWidth),
            height: scene.applyScale($8092574bc3888e94$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        var raffleComponent = new (0, $9ae17738a58c01ea$export$2e2bcd8739ae039)(scene, 0, 0, {}, scene.getScale());
        sizerPanel.add(raffleComponent, {
            key: "raffle-component",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        // RaffleRocks
        var rocksComponent = new (0, $9b6b28d4f52c39e6$export$2e2bcd8739ae039)(scene, 0, 0, {}, scene.getScale());
        sizerPanel.add(rocksComponent, {
            key: "rocks-component",
            align: "left-top",
            offsetX: this.applyScale(323),
            offsetY: this.applyScale(34),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
    }
    applyScale(length) {
        return length * this._scale;
    }
    hidePane() {
    //this._levelsTable.setAlpha(0);
    //this._levelsTable.disableInteractive();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassWeeklyRafflePane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $8092574bc3888e94$export$2e2bcd8739ae039(this.scene, x, y));
});




const $ea68bf593fb10e47$var$width = 1512;
const $ea68bf593fb10e47$var$height = 982;
// Progress Bar Data
const $ea68bf593fb10e47$var$battlePassBarHoverAlpha = 0.8;
class $ea68bf593fb10e47$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userData = data.userData;
    }
    constructor(){
        super({
            key: "BattlePassScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$9942a5e7f80a7b1f));
    }
    create() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getCurrentBattlePassRewards().then((res)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                    this._rewards = res.rewards;
                    var level = this._userData.battlepass_level;
                    yield (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getUnclaimedBattlePassRewards().then((res)=>{
                        this.setRewardsClaimed(res.unclaimed_rewards, this._rewards, level);
                    });
                }));
            // Set Background Color
            this.setBackgroundColour("#5631FF");
            this.createComponent();
        });
    }
    createComponent() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($ea68bf593fb10e47$var$width, $ea68bf593fb10e47$var$height);
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: $ea68bf593fb10e47$var$width * this._scale,
            height: $ea68bf593fb10e47$var$height * this._scale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Image
        this._backgroundImage = this.add.image(0, 0, "battlepass_background").setScale(this._scale);
        this._sizer.add(this._backgroundImage, {
            key: "bp-background",
            align: "left-center",
            offsetX: this.applyScale(266),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Level Progress Bar
        this.addLevelBar();
        // Text
        var _subImage = this.add.image(0, 0, "battlepass_chapter").setScale(this._scale);
        this._sizer.add(_subImage, {
            key: "bp-chapter",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(175),
            expand: false
        });
        this._headerText = this.add.bitmapText(0, 0, "cc_outline", "SEASON 0", this.applyScale(46), 1);
        this._sizer.add(this._headerText, {
            key: "header-text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(194),
            expand: false
        });
        // Buttons
        this._battlePassButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_active_button", true, 1.05).setScale(this._scale);
        this._battlePassButton.onClick().subscribe((pointer)=>{
            this.battlePassListener();
        });
        this._battlePassButton.disableInteractive();
        this.add.existing(this._battlePassButton);
        this._sizer.add(this._battlePassButton, {
            key: "battlepass-button",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(15),
            expand: false
        });
        // this._raffleButton = new Button(this, 0, 0, 'battlepass_raffle_inactive_button', true, 1.05).setScale(this._scale);
        // this._raffleButton.onClick().subscribe(pointer => {
        //   this.weeklyRaffleListener()
        // });
        // this._raffleButton.disableInteractive()
        // this.add.existing(this._raffleButton);
        // this._sizer.add(this._raffleButton, {
        //   key: 'raffle-button',
        //   align: 'left-top',
        //   offsetX: this.applyScale(749),
        //   offsetY: this.applyScale(20),
        //   expand: false,
        // });
        this._homeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_home_button", true, 1.05).setScale(this._scale);
        this._homeButton.onClick().subscribe((pointer)=>{
            this.setBackgroundColour("#0f0f1f");
            this.unloadAssets();
            this.scene.stop();
            this.scene.start("HomebaseScene");
        });
        this.add.existing(this._homeButton);
        this._sizer.add(this._homeButton, {
            key: "home-button",
            align: "left-top",
            offsetX: this.applyScale(18),
            offsetY: this.applyScale(898),
            expand: false
        });
        // Panes
        this._battlePassLevelsPane = new (0, $4b85ccb33d5b8328$export$2e2bcd8739ae039)(this, 0, 0, {
            rewards: this._rewards,
            level: this._userData.battlepass_level,
            claimedLevel: undefined,
            battlepassXP: this._userData.battlepass_xp
        }, this._scale);
        this._sizer.add(this._battlePassLevelsPane, {
            key: "bp-levels-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(381),
            expand: false
        });
        this._battlePassXP = this.createBattlePassXPComponent();
        this._sizer.add(this._battlePassXP, {
            key: "xp-component",
            align: "left-top",
            offsetX: this.applyScale(1185),
            offsetY: this.applyScale(15),
            expand: false
        });
        // Layout the Scene
        this._sizer.layout();
    }
    createBattlePassXPComponent() {
        const xpComponent = new (0, $c1caaa4eb2ed59a8$export$2e2bcd8739ae039)(this, 0, 0, this._userData.battlepass_level, this._scale);
        xpComponent.setInteractive({
            cursor: "pointer"
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OVER, (pointer)=>{
            this.scene.scene.sound.play("hud-button-hover");
            xpComponent.setAlpha($ea68bf593fb10e47$var$battlePassBarHoverAlpha);
        }, this).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_OUT, (pointer)=>{
            xpComponent.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer)=>{
            xpComponent.setAlpha(1);
        }).on((0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Input.Events.GAMEOBJECT_POINTER_UP, (pointer)=>{
            this.scene.get("BattlePassScene").input.enabled = false;
            this.scene.launch("UserBattlePassModalScene", {
                userData: this._userData
            });
            this.scene.pause();
        });
        return xpComponent;
    }
    addLevelBar() {
        if (this._levelProgressBar) this._levelProgressBar.destroy();
        this._levelProgressBar = new (0, $da58ee258d224181$export$2e2bcd8739ae039)(this, this.applyScale(132), this.applyScale(43), this._scale, this._userData);
        // if (this._allowProgressBarClicks) {
        //   this._levelProgressBar
        //     .setInteractive({ cursor: 'pointer' })
        //     .on(
        //       Phaser.Input.Events.GAMEOBJECT_POINTER_OVER,
        //       pointer => {
        //         this.scene.scene.sound.play('hud-button-hover');
        //         this._levelProgressBar.setAlpha(progressBarHoverAlpha);
        //       },
        //       this,
        //     )
        //     .on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, pointer => {
        //       this._levelProgressBar.setAlpha(1);
        //     })
        //     .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => {
        //       this._levelProgressBar.setAlpha(1);
        //     })
        //     .on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, pointer => {
        //       this._levelProgressBar.setAlpha(progressBarHoverAlpha);
        //       if (pointer.getDistance() > 16) {
        //         return;
        //       }
        //       this.scene.get('HomebaseScene').input.enabled = false;
        //       this.scene.launch('UserLevelModalScene', {
        //         userData: this._userData,
        //       });
        //       this.scene.pause();
        //     });
        // }
        this.add.existing(this._levelProgressBar);
        this._sizer.add(this._levelProgressBar, {
            key: "bp-level-bar",
            align: "left-top",
            offsetX: this.applyScale(11),
            offsetY: this.applyScale(18),
            expand: false
        });
    }
    battlePassListener() {
        if (this._battlePassLevelsPane) {
            this._battlePassLevelsPane.hidePane();
            this._sizer.remove(this._battlePassLevelsPane, true); //destroys object
        }
        if (this._weeklyRafflePane) {
            this._weeklyRafflePane.hidePane();
            this._sizer.remove(this._weeklyRafflePane, true); //destroys object
        }
        // Create new instance of Pane
        this._battlePassLevelsPane = new (0, $4b85ccb33d5b8328$export$2e2bcd8739ae039)(this, 0, 0, {
            rewards: this._rewards,
            level: this._userData.battlepass_level,
            claimedLevel: undefined,
            battlepassXP: this._userData.battlepass_xp
        }, this._scale);
        this.add.existing(this._battlePassLevelsPane);
        // Set UI to Battle Pass
        this._battlePassButton.setTexture("battlepass_active_button");
        this._battlePassButton.disableInteractive();
        this._raffleButton.setTexture("battlepass_raffle_inactive_button");
        this._raffleButton.setInteractive();
        // Update Title and Subtitle
        this._sizer.add(this._battlePassLevelsPane, {
            key: "bp-levels-pane",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(381),
            expand: false
        }).layout();
    }
    weeklyRaffleListener() {
        if (this._battlePassLevelsPane) {
            this._battlePassLevelsPane.hidePane();
            this._sizer.remove(this._battlePassLevelsPane, true); //destroys object
        }
        if (this._weeklyRafflePane) {
            this._weeklyRafflePane.hidePane();
            this._sizer.remove(this._weeklyRafflePane, true); //destroys object
        }
        // Create new instance of Pane
        this._weeklyRafflePane = new (0, $8092574bc3888e94$export$2e2bcd8739ae039)(this, 0, 0, {}, this._scale);
        this.add.existing(this._battlePassLevelsPane);
        // Update Actiave and Inactive Textures
        this._battlePassButton.setTexture("battlepass_inactive_button");
        this._battlePassButton.setInteractive();
        this._raffleButton.setTexture("battlepass_raffle_active_button");
        this._raffleButton.disableInteractive();
        // Update Title and Subtitle
        this._sizer.add(this._weeklyRafflePane, {
            key: "bp-levels-pane",
            align: "left-top",
            offsetX: this.applyScale(328),
            offsetY: this.applyScale(309),
            expand: false
        }).layout();
    }
    setRewardsClaimed(unclaimedRewards, rewards, battlepassLevel) {
        var unclaimedLevels = [];
        if (unclaimedRewards.length != 0) unclaimedRewards.forEach((unclaimed)=>{
            unclaimedLevels.push(unclaimed.level);
        });
        rewards.forEach((reward)=>{
            if (!unclaimedLevels.includes(reward.level) && reward.level <= battlepassLevel) reward.claimed = 1;
            else reward.claimed = 0;
        });
    }
    refreshBattlepassData(rewardLevel) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserData(true).then((data)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                    this._userData = data;
                    if (this._battlePassXP) this._sizer.remove(this._battlePassXP, true); //destroys object
                    // Create new instance of Pane
                    this._battlePassXP = this.createBattlePassXPComponent();
                    this._sizer.add(this._battlePassXP, {
                        key: "xp-component",
                        align: "left-top",
                        offsetX: this.applyScale(1185),
                        offsetY: this.applyScale(15),
                        expand: false
                    }).layout();
                    yield (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getCurrentBattlePassRewards().then((res)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                            this._rewards = res.rewards;
                            var level = this._userData.battlepass_level;
                            yield (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getUnclaimedBattlePassRewards().then((res)=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                                    this.setRewardsClaimed(res.unclaimed_rewards, this._rewards, level);
                                    if (this._battlePassLevelsPane) this._sizer.remove(this._battlePassLevelsPane, true); //destroys object
                                    // Create new instance of Pane
                                    this._battlePassLevelsPane = new (0, $4b85ccb33d5b8328$export$2e2bcd8739ae039)(this, 0, 0, {
                                        rewards: this._rewards,
                                        level: this._userData.battlepass_level,
                                        claimedLevel: rewardLevel,
                                        battlepassXP: this._userData.battlepass_xp
                                    }, this._scale);
                                    this._sizer.add(this._battlePassLevelsPane, {
                                        key: "bp-levels-pane",
                                        align: "left-top",
                                        offsetX: this.applyScale(0),
                                        offsetY: this.applyScale(381),
                                        expand: false
                                    }).layout();
                                }));
                        }));
                }));
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    setBackgroundColour(colour) {
        document.body.style.backgroundImage = "none";
        document.body.style.backgroundColor = colour;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$9942a5e7f80a7b1f)));
    }
}




var $f1q41 = parcelRequire("f1q41");








const $d55164e13fe4620f$var$componentWidth = 984;
const $d55164e13fe4620f$var$componentHeight = 83;
const $d55164e13fe4620f$var$componentRadius = 8;
const $d55164e13fe4620f$var$componentBgColor = 0x350926;
const $d55164e13fe4620f$var$componentAlpha = 1;
const $d55164e13fe4620f$var$componentBorderColor = 0x3d4361;
const $d55164e13fe4620f$var$componentBorderWidth = 1;
const $d55164e13fe4620f$var$imageHeight = 67;
const $d55164e13fe4620f$var$imageWidth = 67;
const $d55164e13fe4620f$var$imageRadius = 8;
const $d55164e13fe4620f$var$fontColor = 0xffffff;
const $d55164e13fe4620f$var$secondaryFontAlpha = 0.3;
const $d55164e13fe4620f$var$redTextColor = 0xeb5757;
const $d55164e13fe4620f$var$greenTextColor = 0x6fcf97;
const $d55164e13fe4620f$var$pinkProgressBarColor = 0xd30059;
const $d55164e13fe4620f$var$progressBarAlpha = 1;
const $d55164e13fe4620f$var$glareColor = 0xffffff;
const $d55164e13fe4620f$var$glareAlpha = 0.17;
const $d55164e13fe4620f$var$glareRadius = 3;
const $d55164e13fe4620f$var$glareHeight = 6;
const $d55164e13fe4620f$var$glareOffset = 10;
const $d55164e13fe4620f$var$backgroundColor = 0x65526f;
const $d55164e13fe4620f$var$backgroundAlpha = 0.4;
const $d55164e13fe4620f$var$radius = 7;
const $d55164e13fe4620f$var$progressBarBorderColor = 0x383d57;
const $d55164e13fe4620f$var$progressBarBorderWidth = 1;
const $d55164e13fe4620f$var$progressBarHeight = 22;
const $d55164e13fe4620f$var$progressBarWidth = 319;
const $d55164e13fe4620f$var$progressBarMin = 0;
const $d55164e13fe4620f$var$spaceElixirIcon = "space_elixir_icon";
const $d55164e13fe4620f$var$neonGoldIcon = "neon_gold_icon";
const $d55164e13fe4620f$var$darkMatterIcon = "dark_matter_icon";
const $d55164e13fe4620f$var$logTypes = {
    defense: "defense",
    attack: "attack"
};
const $d55164e13fe4620f$var$lootTypes = {
    darkMatter: "dark_matter",
    neonGold: "neon_gold",
    spaceElixir: "space_elixir"
};
class $d55164e13fe4620f$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, raidHistoryItem, logType, paneScale, config){
        let conf = {
            width: $d55164e13fe4620f$var$componentWidth * (paneScale || 1),
            height: $d55164e13fe4620f$var$componentHeight * (paneScale || 1),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._raidHistoryItem = raidHistoryItem;
        this._logType = logType;
        this._levelBadges = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().userBadges;
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        this.addBg(scene);
        this.addOpponentImage(scene);
        this.addTitle(scene);
        this.addLootInfo(scene);
        this.addProgressBar(scene);
        return this.layout();
    }
    addBg(scene) {
        const bg = scene.add.rexRoundRectangle(0, 0, scene.applyScale($d55164e13fe4620f$var$componentWidth), scene.applyScale($d55164e13fe4620f$var$componentHeight), scene.applyScale($d55164e13fe4620f$var$componentRadius), $d55164e13fe4620f$var$componentBgColor, $d55164e13fe4620f$var$componentAlpha);
        bg.setStrokeStyle(scene.applyScale($d55164e13fe4620f$var$componentBorderWidth), $d55164e13fe4620f$var$componentBorderColor, $d55164e13fe4620f$var$componentAlpha);
        this.addBackground(bg);
    }
    addOpponentImage(scene) {
        const imageKey = this.getOpponentImageKey();
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const oppImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        const oppImageWidth = oppImageData.width;
        rectConfig.radius = oppImageWidth / 8;
        const oppImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        oppImage.displayHeight = scene.applyScale(66);
        oppImage.scaleX = oppImage.scaleY;
        oppImageData.destroy();
        this.add(oppImage, {
            key: "opponent_image",
            align: "left-top",
            offsetX: scene.applyScale(9),
            offsetY: scene.applyScale(9),
            expand: false
        });
    }
    addTitle(scene) {
        const titleLabel = scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, this.getLevelImageKey()).setScale(scene.applyScale(0.3)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), scene.applyScale(16), 0),
            space: {
                icon: 6
            }
        });
        const tintColor = this._raidHistoryItem.winner === this._raidHistoryItem.attacker_user_address ? $d55164e13fe4620f$var$greenTextColor : $d55164e13fe4620f$var$redTextColor;
        const tintPosition = this.getTextTintPosition();
        titleLabel.getElement("text").setCharacterTint(tintPosition.startIndex, tintPosition.length, false, tintColor);
        this.add(titleLabel, {
            key: "raid_history_item_title_label",
            align: "left-top",
            offsetX: scene.applyScale(88),
            offsetY: scene.applyScale(15),
            expand: false
        });
    }
    addLootInfo(scene) {
        // Unit Title/Level Sizer
        const lootSizer = scene.rexUI.add.fixWidthSizer(0, 0, {
            width: scene.applyScale(450),
            align: 0
        });
        lootSizer.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, $d55164e13fe4620f$var$spaceElixirIcon).setScale(scene.applyScale(0.5)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.getLootValue($d55164e13fe4620f$var$lootTypes.spaceElixir), scene.applyScale(16), 0),
            space: {
                icon: 4
            }
        }), {
            padding: {
                left: 0,
                right: scene.applyScale(21),
                top: 0,
                bottom: 0
            },
            key: "space_elixir_loot"
        });
        lootSizer.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, $d55164e13fe4620f$var$neonGoldIcon).setScale(scene.applyScale(0.5)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.getLootValue($d55164e13fe4620f$var$lootTypes.neonGold), scene.applyScale(16), 0),
            space: {
                icon: 4
            }
        }), {
            padding: {
                left: 0,
                right: scene.applyScale(21),
                top: 0,
                bottom: 0
            },
            key: "neon_gold_loot"
        });
        lootSizer.add(scene.rexUI.add.label({
            orientation: "x",
            rtl: false,
            icon: scene.add.image(0, 0, $d55164e13fe4620f$var$darkMatterIcon).setScale(scene.applyScale(0.5)),
            text: scene.add.bitmapText(0, 0, "cc_outline", this.getLootValue($d55164e13fe4620f$var$lootTypes.darkMatter), scene.applyScale(16), 0),
            space: {
                icon: 4
            }
        }), {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            key: "dark_matter_loot"
        });
        this.add(lootSizer.layout(), {
            key: "loot_sizer",
            align: "left-top",
            offsetX: scene.applyScale(88),
            offsetY: scene.applyScale(49),
            expand: false
        });
    }
    addProgressBar(scene) {
        // HP Description Text
        this.add(scene.add.bitmapText(0, 0, "cc_outline", "HOMEBASE HP REMAINING", scene.applyScale(14), 0).setAlpha(0.3), {
            key: "hp_desc_text",
            align: "left-top",
            offsetX: scene.applyScale(651),
            offsetY: scene.applyScale(19),
            expand: false
        });
        // HP Value Text
        this.add(scene.add.bitmapText(0, 0, "cc_outline", this.getHpValueText(), scene.applyScale(14), 0), {
            key: "hp_value_text",
            align: "right-top",
            offsetX: scene.applyScale(-14),
            offsetY: scene.applyScale(18),
            expand: false
        });
        // Progress Bar
        this.add(this.createProgressBar(scene), {
            key: "hp_prog_bar",
            align: "left-top",
            offsetX: scene.applyScale(651),
            offsetY: scene.applyScale(40),
            expand: false
        });
    }
    getOpponentImageKey() {
        switch(this._logType){
            case $d55164e13fe4620f$var$logTypes.defense:
                return this._raidHistoryItem.attacker_pfp ? `${this._raidHistoryItem.attacker_name}_pfp` : `starwolf_silhouette`;
            case $d55164e13fe4620f$var$logTypes.attack:
                return this._raidHistoryItem.defender_pfp ? `${this._raidHistoryItem.defender_name}_pfp` : `starwolf_silhouette`;
        }
    }
    getTitleText() {
        const name1 = this._logType === $d55164e13fe4620f$var$logTypes.defense ? this._raidHistoryItem.attacker_name : "you";
        const name2 = this._logType === $d55164e13fe4620f$var$logTypes.defense ? "you" : this._raidHistoryItem.defender_name;
        const successText = this._raidHistoryItem.winner === this._raidHistoryItem.attacker_user_address ? "successfully" : "unsuccessfully";
        return `${name1} ${successText} raided ${name2}.`.toUpperCase();
    }
    getLevelImageKey() {
        const level = this._logType === $d55164e13fe4620f$var$logTypes.defense ? this._raidHistoryItem.attacker_user_level : this._raidHistoryItem.defender_user_level;
        var badge = this._levelBadges.find((lb)=>{
            if (lb.maxLevel === null) return level >= lb.minLevel;
            else return level >= lb.minLevel && level <= lb.maxLevel;
        });
        if (badge) return badge.badgeImageKey;
        return this._levelBadges[0].badgeImageKey;
    }
    getTextTintPosition() {
        const name1 = this._logType === $d55164e13fe4620f$var$logTypes.defense ? this._raidHistoryItem.attacker_name : "you";
        const successLength = 12;
        const failLength = 14;
        const tintLength = this._raidHistoryItem.winner === this._raidHistoryItem.attacker_user_address ? successLength : failLength;
        return {
            startIndex: name1.length + 1,
            length: tintLength
        };
    }
    getLootValue(lootType) {
        if (this._raidHistoryItem.winner === this._raidHistoryItem.attacker_user_address) {
            const responseValue = lootType === $d55164e13fe4620f$var$lootTypes.darkMatter ? this._raidHistoryItem.attacker_loot.dark_matter : lootType === $d55164e13fe4620f$var$lootTypes.neonGold ? this._raidHistoryItem.attacker_loot.neon_gold : this._raidHistoryItem.attacker_loot.space_elixir;
            return Math.floor(responseValue || 0).toLocaleString("en-us");
        }
        return "0";
    }
    getEndHpValue() {
        return this._raidHistoryItem.defender_end_hp ? this._raidHistoryItem.defender_end_hp : this._raidHistoryItem.winner === this._raidHistoryItem.attacker_user_address ? 0 : this._raidHistoryItem.defender_start_hp;
    }
    getHpValueText() {
        return `${this.getEndHpValue().toLocaleString("en-us")}/${this._raidHistoryItem.defender_start_hp.toLocaleString("en-us")}`;
    }
    createProgressBar(scene) {
        const progBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: "",
                offset: 2,
                fontSize: 20
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $d55164e13fe4620f$var$progressBarWidth,
                height: $d55164e13fe4620f$var$progressBarHeight,
                radius: $d55164e13fe4620f$var$radius,
                color: $d55164e13fe4620f$var$pinkProgressBarColor,
                alpha: $d55164e13fe4620f$var$progressBarAlpha,
                backgroundColor: $d55164e13fe4620f$var$backgroundColor,
                backgroundAlpha: $d55164e13fe4620f$var$backgroundAlpha,
                minValue: $d55164e13fe4620f$var$progressBarMin,
                maxValue: this._raidHistoryItem.defender_start_hp === undefined ? 1 : this._raidHistoryItem.defender_start_hp,
                progressValue: this.getEndHpValue(),
                glare: {
                    height: $d55164e13fe4620f$var$glareHeight,
                    width: $d55164e13fe4620f$var$progressBarWidth - $d55164e13fe4620f$var$glareOffset,
                    radius: $d55164e13fe4620f$var$glareRadius,
                    color: $d55164e13fe4620f$var$glareColor,
                    alpha: $d55164e13fe4620f$var$glareAlpha
                }
            },
            border: {
                alpha: $d55164e13fe4620f$var$backgroundAlpha,
                color: $d55164e13fe4620f$var$progressBarBorderColor,
                width: $d55164e13fe4620f$var$progressBarBorderWidth
            }
        });
        return scene.add.existing(progBar);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("raidHistoryItemComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $d55164e13fe4620f$export$2e2bcd8739ae039(this.scene, x, y));
});





const $b8bc76a7cf36e3b5$var$modalWidth = 1014;
const $b8bc76a7cf36e3b5$var$modalHeight = 600;
const $b8bc76a7cf36e3b5$var$modalRadius = 16;
const $b8bc76a7cf36e3b5$var$modalColor = 0x1c1c2c;
const $b8bc76a7cf36e3b5$var$modalAlpha = 1;
const $b8bc76a7cf36e3b5$var$modalBorderColor = 0x6262de;
const $b8bc76a7cf36e3b5$var$modalBorderWidth = 3;
const $b8bc76a7cf36e3b5$var$tableWidth = $b8bc76a7cf36e3b5$var$modalWidth - 30;
const $b8bc76a7cf36e3b5$var$tableHeight = $b8bc76a7cf36e3b5$var$modalHeight - 25;
const $b8bc76a7cf36e3b5$var$cellHeight = 94;
const $b8bc76a7cf36e3b5$var$tabHeight = 70;
const $b8bc76a7cf36e3b5$var$tabs = {
    defense_log: "defense_log",
    attack_log: "attack_log"
};
class $b8bc76a7cf36e3b5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._startTab = data.tab || $b8bc76a7cf36e3b5$var$tabs.defense_log;
    }
    constructor(){
        super({
            key: "BaseRaidHistoryScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$f3db403795e03c3b));
    }
    create() {
        const self = this;
        if (this.game.input.touch && this.game.input.touch.preventDefault) {
            this.game.input.touch.preventDefault = false;
            this.game.input.touch.enabled = true;
        }
        this.input.dragDistanceThreshold = 16;
        this.input.dragTimeThreshold = 300;
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($b8bc76a7cf36e3b5$var$modalWidth, $b8bc76a7cf36e3b5$var$modalHeight + 200);
        const userAddress = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync().wallet;
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            height: this.applyScale($b8bc76a7cf36e3b5$var$modalHeight + $b8bc76a7cf36e3b5$var$tabHeight + 84),
            width: this.applyScale($b8bc76a7cf36e3b5$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($b8bc76a7cf36e3b5$var$modalWidth), this.applyScale($b8bc76a7cf36e3b5$var$modalHeight), this.applyScale($b8bc76a7cf36e3b5$var$modalRadius), $b8bc76a7cf36e3b5$var$modalColor, $b8bc76a7cf36e3b5$var$modalAlpha);
        background.setStrokeStyle(this.applyScale($b8bc76a7cf36e3b5$var$modalBorderWidth), $b8bc76a7cf36e3b5$var$modalBorderColor, $b8bc76a7cf36e3b5$var$modalAlpha);
        this._sizer.add(background, {
            key: "base_raid_history_modal_bg",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale($b8bc76a7cf36e3b5$var$tabHeight),
            expand: false
        });
        // Tabs
        this._defenseLogTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "defense_log_tab", false).setOrigin(1, 1).setScale(this._scale);
        this._attackLogTab = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "attack_log_tab_inactive", false).setOrigin(0, 1).setScale(this._scale);
        this._defenseLogTab.onClick().subscribe((pointer)=>{
            this.defenseLogTabClickHandler(pointer);
        });
        this._attackLogTab.onClick().subscribe((pointer)=>{
            this.attackLogTabClickHandler(pointer);
        });
        this.add.existing(this._defenseLogTab);
        this.add.existing(this._attackLogTab);
        this._sizer.add(this._defenseLogTab, {
            key: "defense_log_tab",
            align: "center-top",
            offsetX: this.applyScale(-85),
            offsetY: 0,
            expand: false
        });
        this._sizer.add(this._attackLogTab, {
            key: "attack_log_tab",
            align: "center-top",
            offsetX: this.applyScale(85),
            offsetY: 0,
            expand: false
        });
        // Button Sizer
        const buttonSizer = this.rexUI.add.overlapSizer(0, 0, {
            height: this.applyScale(62),
            width: this.applyScale($b8bc76a7cf36e3b5$var$modalWidth),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Back To Home Button
        this._backToHomebaseButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "back_to_homebase_button", false).setScale(this._scale);
        this._backToHomebaseButton.onClick().subscribe((pointer)=>{
            this.backToHomebaseButtonClickHandler(pointer);
        });
        buttonSizer.add(this.add.existing(this._backToHomebaseButton), {
            key: "back_to_homebase_button",
            align: "left-center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        // Go Raiding Button
        this._goRaidingButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "go_raiding_button", false).setScale(this._scale);
        this._goRaidingButton.onClick().subscribe((pointer)=>{
            this.goRaidingButtonButtonClickHandler(pointer);
        });
        buttonSizer.add(this.add.existing(this._goRaidingButton), {
            key: "go_raiding_button",
            align: "right-center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.add(buttonSizer.layout(), {
            key: "button_sizer",
            align: "center-bottom",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(250),
            expand: false
        });
        this._sizer.layout();
        (0, $04c1bebe09f3da3c$export$2e2bcd8739ae039).getInstance().getRaidHistory().then((res)=>{
            this._raidHistory = res.base_raid_results;
            const allPfpInfo = this._raidHistory.flatMap((raid)=>{
                return [
                    {
                        name: raid.attacker_name,
                        pfp_url: raid.attacker_pfp
                    },
                    {
                        name: raid.defender_name,
                        pfp_url: raid.defender_pfp
                    }
                ];
            });
            const uniquePfps = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy(allPfpInfo, "name");
            uniquePfps.forEach((pfpInfo)=>{
                if (pfpInfo.name && pfpInfo.pfp_url) this.load.image(`${pfpInfo.name}_pfp`, pfpInfo.pfp_url);
            });
            this._defenseHistory = this._raidHistory.filter((raid)=>{
                return raid.defender_user_address.toLowerCase() === userAddress.toLowerCase();
            });
            this._attackHistory = this._raidHistory.filter((raid)=>{
                return raid.attacker_user_address.toLowerCase() === userAddress.toLowerCase();
            });
            this._loadingIndicator.setAlpha(0);
            this._sizer.remove(this._loadingIndicator, true);
            this._loadingIndicator = undefined;
            if (this._startTab === $b8bc76a7cf36e3b5$var$tabs.defense_log) this.defenseLogTabClickHandler(self);
            else this.attackLogTabClickHandler(self);
        });
    //this._sizer.drawBounds(this.add.graphics(), 0x00ff00);
    //this._sizer.pushIntoBounds();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    backToHomebaseButtonClickHandler(pointer) {
        if (pointer.getDistance() > 20) return;
        this._selectedTab = "";
        this.scene.start("HomebaseScene");
        this.unloadAssets();
        this.scene.stop();
    }
    goRaidingButtonButtonClickHandler(pointer) {
        if (pointer.getDistance() > 20) return;
        this._selectedTab = "";
        this.scene.start("BaseRaidLoadingScene");
        this.unloadAssets();
        this.scene.stop();
    }
    defenseLogTabClickHandler(pointer) {
        if (this._selectedTab === $b8bc76a7cf36e3b5$var$tabs.defense_log) return;
        this._selectedTab = $b8bc76a7cf36e3b5$var$tabs.defense_log;
        this._defenseLogTab.setTexture("defense_log_tab");
        this._attackLogTab.setTexture("attack_log_tab_inactive");
        this.removeNoOtherRaidsLabel();
        this.createTable(this, this._defenseHistory, "defense");
        if (this._defenseHistory.length < 6) this.addNoOtherRaidsLabel(this._defenseHistory);
        this._sizer.layout();
    }
    attackLogTabClickHandler(pointer) {
        if (this._selectedTab === $b8bc76a7cf36e3b5$var$tabs.attack_log) return;
        this._selectedTab = $b8bc76a7cf36e3b5$var$tabs.attack_log;
        this._attackLogTab.setTexture("attack_log_tab");
        this._defenseLogTab.setTexture("defense_log_tab_inactive");
        this.removeNoOtherRaidsLabel();
        this.createTable(this, this._attackHistory, "attack");
        if (this._attackHistory.length < 6) this.addNoOtherRaidsLabel(this._attackHistory);
        this._sizer.layout();
    }
    createTable(scene, data, logType) {
        if (this._table) this.removeTable();
        if (!data || data.length === 0) return;
        var table = scene.rexUI.add.gridTable({
            width: scene.applyScale($b8bc76a7cf36e3b5$var$tableWidth),
            height: this.applyScale(this.getTableHeight(data)),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: scene.applyScale($b8bc76a7cf36e3b5$var$tableWidth),
                cellHeight: scene.applyScale($b8bc76a7cf36e3b5$var$cellHeight),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {}
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                return scene.add.existing(new (0, $d55164e13fe4620f$export$2e2bcd8739ae039)(scene, 0, 0, item, logType, scene.getScale()));
            }
        });
        this._table = table;
        this._sizer.add(this._table, {
            key: "base_raid_history_table",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(93),
            expand: false
        }).layout();
    }
    getTableHeight(data) {
        return $b8bc76a7cf36e3b5$var$cellHeight * data.length > $b8bc76a7cf36e3b5$var$tableHeight ? $b8bc76a7cf36e3b5$var$tableHeight : $b8bc76a7cf36e3b5$var$cellHeight * data.length - 1;
    }
    removeTable() {
        this._table.setAlpha(0);
        this._sizer.remove(this._table);
        this._table = undefined;
    }
    addNoOtherRaidsLabel(raidData) {
        this._noOtherRaidsLabel = this.rexUI.add.label({
            orientation: "y",
            rtl: false,
            icon: this.add.image(0, 0, "hp_icon").setScale(this._scale),
            text: this.add.bitmapText(0, 0, "cc_outline", "NO OTHER RAIDS TO REPORT", this.applyScale(16), 0).setAlpha(0.3),
            space: {
                icon: 4
            }
        });
        const currentTableHeight = this.getTableHeight(raidData);
        const yOffset = $b8bc76a7cf36e3b5$var$tabHeight + currentTableHeight + ($b8bc76a7cf36e3b5$var$modalHeight - currentTableHeight) / 2 - 38; // Half label height + table padding
        this._sizer.add(this._noOtherRaidsLabel, {
            key: "no_other_raids_label",
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(yOffset),
            expand: false
        });
    }
    removeNoOtherRaidsLabel() {
        if (this._noOtherRaidsLabel) {
            this._noOtherRaidsLabel.setAlpha(0);
            this._noOtherRaidsLabel.destroy();
            this._noOtherRaidsLabel = undefined;
        }
    }
    destroy() {
        this._defenseLogTab.destroy();
        this._attackLogTab.destroy();
        this._selectedTab.destroy();
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$f3db403795e03c3b)));
    }
}





class $12f68f64a2e7b2d9$export$2e2bcd8739ae039 {
    static flashElement(scene, element, repeat = true, easing = "Linear", overallDuration = 1500, visiblePauseDuration = 500, delay = 0) {
        if (scene && element) {
            let flashDuration = overallDuration - visiblePauseDuration / 2;
            scene.tweens.timeline({
                tweens: [
                    {
                        targets: element,
                        duration: 0,
                        alpha: 0,
                        ease: easing,
                        delay: delay
                    },
                    {
                        targets: element,
                        duration: flashDuration,
                        alpha: 1,
                        ease: easing
                    },
                    {
                        targets: element,
                        duration: visiblePauseDuration,
                        alpha: 1,
                        ease: easing
                    },
                    {
                        targets: element,
                        duration: flashDuration,
                        alpha: 0,
                        ease: easing,
                        onComplete: ()=>{
                            if (repeat === true) this.flashElement(scene, element, true, easing, overallDuration, visiblePauseDuration);
                        }
                    }
                ]
            });
        }
    }
    static fadeElement(scene, element, alpha = 1, easing = "Power2", duration = 1000, delay = 0) {
        if (scene && element) scene.tweens.add({
            targets: element,
            alpha: alpha,
            duration: duration,
            ease: easing,
            delay: delay
        }, scene);
    }
}




const $8ca7f9710324c4e6$var$imageHeight = 250; // same as imageWidth
const $8ca7f9710324c4e6$var$imageMargin = 10;
const $8ca7f9710324c4e6$var$itemHeight = $8ca7f9710324c4e6$var$imageHeight + 70;
const $8ca7f9710324c4e6$var$itemWidth = $8ca7f9710324c4e6$var$imageHeight + $8ca7f9710324c4e6$var$imageMargin * 2;
const $8ca7f9710324c4e6$var$imageBorderColor = 0xffffff;
const $8ca7f9710324c4e6$var$imageBorderWidth = 1;
const $8ca7f9710324c4e6$var$imageBorderAlpha = 0.7;
const $8ca7f9710324c4e6$var$imageAreaFillColor = 0x000000;
const $8ca7f9710324c4e6$var$imageAreaFillAlpha = 0;
const $8ca7f9710324c4e6$var$imageAreaBorderWidth = 1;
const $8ca7f9710324c4e6$var$imageAreaBorderColor = 0x34333d;
const $8ca7f9710324c4e6$var$imageAreaBorderAlpha = 1;
const $8ca7f9710324c4e6$var$labelFillColor = 0x1d1a2c;
const $8ca7f9710324c4e6$var$labelFillAlpha = 0.7;
const $8ca7f9710324c4e6$var$labelBorderRadius = 7;
const $8ca7f9710324c4e6$var$labelBorderWidth = 1;
const $8ca7f9710324c4e6$var$labelBorderColor = 0x2b2c3b;
const $8ca7f9710324c4e6$var$labelBorderAlpha = 1;
const $8ca7f9710324c4e6$var$labelMargin = 20;
const $8ca7f9710324c4e6$var$ShopItemImageKeys = [
    {
        shop_item_id: 15,
        image_key: "nm8_chip"
    },
    {
        shop_item_id: 16,
        image_key: "bk55_chip"
    },
    {
        shop_item_id: 20,
        image_key: "fur69_chip"
    },
    {
        shop_item_id: 29,
        image_key: "fur70_chip"
    },
    {
        shop_item_id: 22,
        image_key: "artifact_0002"
    },
    {
        shop_item_id: 23,
        image_key: "artifact_0003"
    },
    {
        shop_item_id: 27,
        image_key: "artifact_0004"
    },
    {
        shop_item_id: 24,
        image_key: "artifact_0005"
    },
    {
        shop_item_id: 25,
        image_key: "artifact_0006"
    },
    {
        shop_item_id: 26,
        image_key: "artifact_0007"
    },
    {
        shop_item_id: 28,
        image_key: "artifact_0008"
    },
    {
        shop_item_id: 36,
        image_key: "artifact_0009"
    },
    {
        shop_item_id: 30,
        image_key: "artifact_0010"
    },
    {
        shop_item_id: 35,
        image_key: "artifact_0011"
    }
];
class $8ca7f9710324c4e6$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, isFirst, paneScale, config){
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * $8ca7f9710324c4e6$var$itemWidth,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._item = data;
        this._isFirst = isFirst;
        return this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        if (!data.loot_pack_reward_id) return this.layout();
        // Add Item Image
        this.addItemImage(scene);
        // Add Image Area Border
        this.addImageAreaBorder(scene);
        // Add Label
        this.addItemLabel(scene);
        if (this._isFirst) {
            this.addItemVeil(scene);
            // Add a little delay before reveal sound on first pack item
            scene.time.addEvent({
                delay: 500,
                loop: false,
                callback: ()=>{
                    scene.playPackItemRevealSound();
                }
            });
        } else // Play sound immediately if not first pack item
        scene.playPackItemRevealSound();
        return this.layout();
    }
    addItemImage(scene) {
        // Add Image
        const imageKey = this.getItemImageKey();
        var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, imageKey);
        var imageWidth = imageData.width;
        const rectConfig = {
            maskType: "roundRectangle",
            radius: Math.ceil(imageWidth / 10),
            strokeColor: $8ca7f9710324c4e6$var$imageBorderColor,
            strokeWidth: this.applyScale($8ca7f9710324c4e6$var$imageBorderWidth)
        };
        this._itemImage = scene.add.rexCircleMaskImage(0, 0, imageKey, "", rectConfig);
        this._itemImage.displayWidth = this.applyScale($8ca7f9710324c4e6$var$imageHeight);
        this._itemImage.scaleY = this._itemImage.scaleX;
        imageData.destroy();
        this.add(this._itemImage, {
            key: "item_image",
            align: "left-top",
            offsetX: this.applyScale($8ca7f9710324c4e6$var$imageMargin),
            offsetY: this.applyScale($8ca7f9710324c4e6$var$imageMargin),
            expand: false
        });
    }
    addImageAreaBorder(scene) {
        // Add Image Area Border
        const imageAreaBorder = scene.add.rexRoundRectangle(0, 0, this.applyScale($8ca7f9710324c4e6$var$itemWidth), this._itemImage.displayHeight + this.applyScale($8ca7f9710324c4e6$var$imageMargin * 2), this.applyScale($8ca7f9710324c4e6$var$itemWidth / 8), $8ca7f9710324c4e6$var$imageAreaFillColor, $8ca7f9710324c4e6$var$imageAreaFillAlpha);
        imageAreaBorder.setStrokeStyle(this.applyScale($8ca7f9710324c4e6$var$imageAreaBorderWidth), $8ca7f9710324c4e6$var$imageAreaBorderColor, $8ca7f9710324c4e6$var$imageAreaBorderAlpha);
        this.add(imageAreaBorder, {
            key: "image_area_border",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
    }
    addItemLabel(scene) {
        const labelBg = scene.add.rexRoundRectangle(0, 0, this.applyScale($8ca7f9710324c4e6$var$itemWidth), this.applyScale($8ca7f9710324c4e6$var$itemHeight), this.applyScale($8ca7f9710324c4e6$var$labelBorderRadius), $8ca7f9710324c4e6$var$labelFillColor, $8ca7f9710324c4e6$var$labelFillAlpha);
        labelBg.setStrokeStyle(this.applyScale($8ca7f9710324c4e6$var$labelBorderWidth), $8ca7f9710324c4e6$var$labelBorderColor, $8ca7f9710324c4e6$var$labelBorderAlpha);
        this._itemLabel = scene.rexUI.add.label({
            x: 0,
            y: 0,
            height: 30,
            orientation: "x",
            rtl: false,
            icon: undefined,
            background: labelBg,
            text: scene.add.bitmapText(0, 0, "cc_outline", this._item.reward_name.toUpperCase(), this.applyScale(20), 0),
            space: {
                icon: this.applyScale(8),
                left: this.applyScale(14),
                right: this.applyScale(14),
                top: this.applyScale(6),
                bottom: this.applyScale(3)
            },
            align: "center"
        }).layout();
        this.add(this._itemLabel, {
            key: "item_label",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this._itemImage.displayHeight + this.applyScale($8ca7f9710324c4e6$var$imageMargin * 2 + $8ca7f9710324c4e6$var$labelMargin),
            expand: false
        });
    }
    addItemVeil(scene) {
        this._veil = scene.add.image(0, 0, "pack_item_veil");
        this._veil.displayWidth = $8ca7f9710324c4e6$var$imageHeight + 30;
        this._veil.displayHeight = this._itemImage.displayHeight + 80;
        this.add(this._veil, {
            key: "image_veil",
            align: "left-top",
            offsetX: this.applyScale($8ca7f9710324c4e6$var$imageMargin - 15),
            offsetY: this.applyScale($8ca7f9710324c4e6$var$imageMargin - 15),
            expand: false
        });
        this.addDissolveEffect(scene);
    }
    getItemImageKey() {
        // NFT
        if (this._item.nft_id && this._item.nft_id > 0) return this._item.nft_image_url;
        // Shop Item
        if (this._item.shop_item_id && this._item.shop_item_id > 0) return this.getShopItemImageKey();
        // Currency
        if (this._item.currency_id && this._item.currency_id > 0) return this.getCurrencyImageKey();
    }
    getShopItemImageKey() {
        const shopItem = $8ca7f9710324c4e6$var$ShopItemImageKeys.find((si)=>si.shop_item_id === this._item.shop_item_id);
        return shopItem ? shopItem.image_key : "wolf_silhouette";
    }
    getCurrencyImageKey() {
        switch(this._item.currency_id){
            case 1:
                return "neon_gold_pack_reward";
            case 2:
                return "space_elixir_pack_reward";
            case 3:
                return "stardust_pack_reward";
            default:
                return "dark_matter_pack_reward";
        }
    }
    addDissolveEffect(scene) {
        // Use Dissolve PostFXPipeline for first item reveal
        var postFxPlugin = scene.plugins.get("rexDissolvePipeline");
        var postFxPipeline = postFxPlugin.add(this._veil, {
            // toTexture: nextKey,
            // toFrame: frameName,
            resizeMode: 2,
            noiseX: 20,
            noiseY: 10,
            noiseZ: 20,
            // fromEdgeStart: 0.01,
            // fromEdgeWidth: 0.05,
            // toEdgeStart: 0.01,
            // toEdgeWidth: 0.05,
            progress: 0,
            name: "rexDissolvePostFx"
        });
        var tweenTask;
        tweenTask = scene.tweens.add({
            targets: postFxPipeline,
            resizeMode: 1,
            progress: 1,
            ease: "Quad",
            duration: 3000,
            repeat: 0,
            yoyo: false
        }).on("complete", function() {
            postFxPipeline.setProgress(0);
            this._veil.setAlpha(0);
            tweenTask = undefined;
            scene.revealAdditionalItems(scene);
        }, this);
    }
    addGlimmer(scene) {
        // Image glimmer
        const numImageStars = 3;
        for(let i = 0; i < numImageStars; i++){
            const x = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._itemImage.getTopLeft().x, this._itemImage.getTopRight().x);
            const y = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._itemImage.getTopLeft().y, this._itemImage.getBottomLeft().y);
            this.addStar(scene, x, y);
        }
        // Label glimmer
        const numLabelStars = 2;
        for(let i = 0; i < numLabelStars; i++){
            const x = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._itemLabel.getTopLeft().x, this._itemLabel.getTopRight().x);
            const y = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._itemLabel.getTopLeft().y, this._itemLabel.getBottomLeft().y);
            this.addStar(scene, x, y);
        }
    }
    addStar(scene, x, y) {
        let maxRad = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(20, 50);
        var starBase = scene.add.star(x, y, 8, maxRad / 5, maxRad, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starBase.setAlpha(0.5);
        var starMiddle = scene.add.star(x, y, 8, maxRad * 0.6 / 5, maxRad * 0.6, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starMiddle.setAlpha(0.5);
        var starTop = scene.add.star(x, y, 8, maxRad * 0.2 / 5, maxRad * 0.2, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starTop.setAlpha(0.5);
        scene.tweens.add({
            targets: [
                starBase,
                starMiddle,
                starTop
            ],
            scale: 0.1,
            duration: 1500,
            ease: "Quad",
            yoyo: true,
            repeat: -1
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("packItemComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $8ca7f9710324c4e6$export$2e2bcd8739ae039(this.scene, x, y, data));
});





const $dcc4d55cfe127dd4$var$contentWidth = 800;
const $dcc4d55cfe127dd4$var$contentHeight = 800;
const $dcc4d55cfe127dd4$var$packScale = 0.7;
const $dcc4d55cfe127dd4$var$packOffset = 0;
const $dcc4d55cfe127dd4$var$openTextOffset = 0;
const $dcc4d55cfe127dd4$var$packTypes = [
    "none",
    "bronze_pack",
    "silver_pack",
    "golden_pack",
    "rare_pack",
    "ultimate_rare_pack",
    "rare_legendary_pack",
    "ultimate_legendary_pack"
];
const $dcc4d55cfe127dd4$var$RewardTypes = [
    "none",
    "XP",
    "Currency",
    "bronze_pack",
    "ShopItem",
    "silver_pack",
    "golden_pack",
    "Machine",
    "rare_pack",
    "legendary_pack",
    "mythical_pack",
    "epic_pack",
    "NFT",
    "MachineSkin"
];
class $dcc4d55cfe127dd4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super({
            key: "PackOpeningScene"
        });
    }
    init(data) {
        this._packInfo = data;
    }
    preload() {
        // Packs
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$4a92157dbd1ca5c5));
        this.load.image("mining_return_home_button", (0, $1aa2c39fc1fbb95e$export$538ba78e0dbb1045).mining_return_home_button);
        //const config = ConfigurationService.getInstance().getConfig();
        this.load.audio("open_pack_background_music", "assets/packs/open_pack_background_music.mp3");
        this.load.audio("open_pack_whoosh", "assets/packs/open_pack_whoosh.mp3");
        this.load.audio("open_pack_item_reveal", "assets/packs/open_pack_item_reveal.wav");
        this.load.audio("open_pack_end_sound", "assets/packs/open_pack_end_sound.wav");
    }
    create() {
        // Get Scale
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($dcc4d55cfe127dd4$var$contentWidth, $dcc4d55cfe127dd4$var$contentHeight);
        this._packItems = [];
        // Add sounds
        this._bgMusic = this.sound.add("open_pack_background_music", {
            loop: true
        });
        this._openPackSound = this.sound.add("open_pack_whoosh", {
            loop: false
        });
        this._itemRevealSound = this.sound.add("open_pack_item_reveal", {
            loop: false
        });
        this._packEndSound = this.sound.add("open_pack_end_sound", {
            loop: false
        });
        this._bgMusic.play();
        // Background
        this.add.rectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.sys.canvas.width, this.sys.canvas.height, 0x000000, 1);
        // Pack Image
        this._packImage = this.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2 + this.applyScale($dcc4d55cfe127dd4$var$packOffset), this.getPackImageKey()).setScale(this._scale * $dcc4d55cfe127dd4$var$packScale).setAlpha(0);
        (0, $12f68f64a2e7b2d9$export$2e2bcd8739ae039).fadeElement(this, this._packImage, undefined, undefined, 2000, 1000);
        // Open Text
        this._openText = this.add.bitmapText(this.sys.canvas.width / 2, this._packImage.getBottomLeft().y + this.applyScale($dcc4d55cfe127dd4$var$openTextOffset), "cc_outline", "OPEN", 24, 1).setOrigin(0.5, 0.5).setAlpha(0);
        this.time.addEvent({
            delay: 1000,
            loop: false,
            callback: ()=>{
                (0, $12f68f64a2e7b2d9$export$2e2bcd8739ae039).flashElement(this, this._openText, true, "none", 1000, 1000); //, 1000);
            }
        });
        this._packImage.setInteractive().on("pointerdown", this.packOpenClick, this);
        this._openText.setInteractive().on("pointerdown", this.packOpenClick, this);
    }
    getPackImageKey() {
        return $dcc4d55cfe127dd4$var$RewardTypes[this._packInfo.packType];
    }
    packOpenClick(pointer) {
        // Play Transition Video
        this.playTransitionVideo(this);
    }
    playTransitionVideo() {
        var video = document.getElementById("pack-opening-vid");
        if (!video) {
            console.log("Video not found!");
            self.removePackScreen(this);
            return;
        }
        var self = this;
        video.hidden = false;
        video.play();
        this._openPackSound.play();
        video.onended = ()=>{
            video.hidden = true;
            self.removePackScreen(this);
        };
    }
    removePackScreen() {
        this._packImage.setAlpha(0);
        this._packImage.disableInteractive();
        // this._packImage.destroy();
        // this._packImage = undefined;
        this._openText.setAlpha(0);
        this._openText.destroy();
        this._openText = undefined;
        // Reveal Contents
        this.revealPackContents(this);
    }
    revealPackContents() {
        // Sizer for pack items
        this._itemSizer = this.rexUI.add.fixWidthSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: this.sys.canvas.width,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2
        });
        this.add.existing(this._itemSizer);
        // Add and reveal first item
        this.revealFirstItem(this);
    }
    revealFirstItem() {
        // Create Item
        const firstItem = new (0, $8ca7f9710324c4e6$export$2e2bcd8739ae039)(this, 0, 0, this._packInfo.loot_pack_info[0], true, this._scale);
        this._itemSizer.add(this.add.existing(firstItem), {
            key: "first_item",
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this._packItems.push(firstItem);
        this._itemSizer.layout();
    }
    revealAdditionalItems() {
        if (this._packItems.length === this._packInfo.loot_pack_info.length) {
            this.postRevealAnimation(this);
            return;
        }
        this.revealNextItem(this);
    }
    scaleUpItems() {
        // Grow existing items to ~1.5x scale
        var tween = this.tweens.add({
            targets: this._itemSizer,
            scale: 1.5,
            ease: "Linear",
            duration: 60,
            yoyo: true
        }).on("complete", function() {
            // Add new item at 1.5x scale
            setTimeout(()=>{
                this.revealAdditionalItems();
            }, 1000);
        }, this);
    }
    revealNextItem() {
        // Create Item
        const nextItem = new (0, $8ca7f9710324c4e6$export$2e2bcd8739ae039)(this, 0, 0, this._packInfo.loot_pack_info[this._packItems.length], false, this._scale);
        this._itemSizer.add(this.add.existing(nextItem), {
            key: `item_${this._packItems.length + 1}`,
            padding: {
                left: this.applyScale(30),
                right: 0,
                top: 0,
                bottom: 0
            }
        });
        this._packItems.push(nextItem);
        this._itemSizer.layout();
        this.scaleUpItems(this);
    }
    postRevealAnimation() {
        // Animation Steps:
        // -Slowly slide items down ~25px - DONE
        // -Rotate items -5 degrees - DONE
        // -Quickly slide items up ~300px - DONE
        // -Add Back button on the way up - DONE
        // -Bounce items back to OG position - DONE
        // -Add 'glimmer' on the way down to OG position
        // -Repeat glimmer
        this._packEndSound.play();
        this.slideDownStart(this);
    }
    slideDownStart() {
        this.tweens.add({
            targets: this._packItems,
            props: {
                y: {
                    value: `+=${this.applyScale(25)}`,
                    ease: "Quad",
                    duration: 300,
                    yoyo: false
                }
            }
        }).on("complete", function() {
            // Rotate items after slide down
            this.rotateItems(this);
        }, this);
    }
    slideUp() {
        this.tweens.add({
            targets: this._packItems,
            delay: 600,
            ease: "Quad",
            duration: 50,
            yoyo: false,
            y: `-=${this.applyScale(300)}`
        }).on("complete", function() {
            // Add back button and slide back down after slide up
            this.addBackButton(this);
            this.slideDownFinish(this);
        }, this);
    }
    slideDownFinish() {
        this.tweens.add({
            targets: this._packItems.concat(this._backButton),
            ease: "Quad",
            duration: 50,
            yoyo: false,
            y: `+=${this.applyScale(275)}`
        }).on("complete", function() {
            this.addGlimmer(this);
        }, this);
    }
    rotateItems(rotationDegrees, duration) {
        this.tweens.add({
            targets: this._packItems,
            angle: -1,
            ease: "Quad",
            duration: 300,
            yoyo: true,
            hold: 200
        });
        this.slideUp(this);
    }
    addBackButton() {
        //mining_return_home_button
        this._backButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, this.sys.canvas.width / 2, this._packItems[0].y + this.applyScale(350), "mining_return_home_button", false);
        this._backButton.onClick().subscribe((pointer)=>{
            const userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
            this._bgMusic.stop();
            this.scene.start("BattlePassScene", {
                userData: userData
            });
        });
        this.add.existing(this._backButton);
    }
    addGlimmer() {
        this._packItems.forEach((pi)=>{
            pi.addGlimmer(this);
        });
        // Button Glimmer
        const numButtonStars = 2;
        for(let i = 0; i < numButtonStars; i++){
            console.log(this._backButton.getTopLeft().x);
            const x = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._backButton.getTopLeft().x, this._backButton.getTopRight().x);
            const y = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(this._backButton.getTopLeft().y, this._backButton.getBottomLeft().y);
            this.addStar(this, x, y);
        }
    }
    addStar(x, y) {
        console.log("I got hit.");
        let maxRad = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between(20, 50);
        var starBase = this.add.star(x, y, 8, maxRad / 5, maxRad, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starBase.setAlpha(0.5);
        var starMiddle = this.add.star(x, y, 8, maxRad * 0.6 / 5, maxRad * 0.6, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starMiddle.setAlpha(0.5);
        var starTop = this.add.star(x, y, 8, maxRad * 0.2 / 5, maxRad * 0.2, 0xffffff); // x, y, points, innerRadius, outerRadius, fillColor
        starTop.setAlpha(0.5);
        starBase.setDepth(0);
        this.tweens.add({
            targets: [
                starBase,
                starMiddle,
                starTop
            ],
            scale: 0.1,
            duration: 1500,
            ease: "Quad",
            yoyo: true,
            repeat: -1
        });
    }
    playPackItemRevealSound() {
        this._itemRevealSound.play();
    }
    applyScale(value) {
        return value * this._scale;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$4a92157dbd1ca5c5)));
        (0, $e29d3e9b5d8af317$export$91c11d74e81f7858)(this, [
            "open_pack_background_music",
            "open_pack_whoosh",
            "open_pack_item_reveal",
            "open_pack_end_sound"
        ]);
    }
}













const $82236649ca206195$var$labels = {
    title: "Your Settings",
    level: "User Level",
    levelDesc: "Keep grinding those levels, young wolf!",
    profilePic: "User Profile Pic",
    profilePicDesc: "The first NFT in your Active Squad will be assigned as your PFP.",
    username: "Username",
    usernameDesc: "This cannot be changed at this time.",
    squadName: "Squad Name",
    squadNameDesc: "This can only be changed 3 times.",
    twitter: "Twitter",
    twitterDesc: "Paste your Twitter ID, e.g. @wolflover",
    connectAccounts: "Connect Accounts & Wallets",
    connectedWallets: "Connected Wallets",
    other: "Other"
};
const $82236649ca206195$var$imageKeys = {
    connectWalletButton: "connect_wallet_button",
    disconnectButton: "disconnect_button",
    musicButtonActive: "music_button_active",
    musicButtonInactive: "music_button_active",
    soundsEffectsButtonActive: "sound_effects_button_active",
    soundsEffectsButtonInActive: "sound_effects_button_inactive"
};
const $82236649ca206195$var$defaultVertOffset = 11;
const $82236649ca206195$var$badgeVertOffset = 17;
const $82236649ca206195$var$descTextVertOffset = -1;
const $82236649ca206195$var$buttonSectionVertOffset = 30;
const $82236649ca206195$var$buttonHorizontalOffset = 4;
const $82236649ca206195$var$profilePicVertOffset = 6;
const $82236649ca206195$var$inputTextTopPadding = 5;
const $82236649ca206195$var$inputTextFontSize = 14;
const $82236649ca206195$var$inputTextWidth = 518;
const $82236649ca206195$var$inputTextHeight = 36;
class $82236649ca206195$export$2e2bcd8739ae039 extends (0, $6449a3e76a76d511$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        const conf = config ? config : {
            x: x,
            y: y,
            width: scene.applyScale(566),
            height: scene.applyScale(642),
            scrollMode: 0,
            //background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 10, COLOR_PRIMARY),
            panel: {
                child: scene.rexUI.add.fixWidthSizer({
                    space: {
                        left: scene.applyScale(21),
                        right: scene.applyScale(21),
                        top: 0,
                        bottom: scene.applyScale(21),
                        item: scene.applyScale(10),
                        line: 0
                    }
                }),
                mask: {
                    padding: 1
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                left: 0,
                right: 0,
                top: scene.applyScale(21),
                bottom: 0,
                panel: 0
            }
        };
        super(scene, conf);
        this._scale = paneScale;
        this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this.layout();
        this.createComponent();
    }
    createComponent() {
        var _a, _b, _c;
        this._sizer = this.getElement("panel");
        const scene = this.scene;
        // Title
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $82236649ca206195$var$labels.title, scene.applyScale(20)), {
            key: "title_label",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        // User Level
        this.addLabelAndDesc(scene, "user_level_label", $82236649ca206195$var$labels.level, "user_level_desc", $82236649ca206195$var$labels.levelDesc);
        // Level Bar and Badge
        this._sizer.add(scene.add.image(0, 0, this.getLevelImageKey()).setScale(this._scale), {
            key: "level_badge",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$badgeVertOffset),
                right: scene.applyScale(20),
                bottom: scene.applyScale($82236649ca206195$var$badgeVertOffset - $82236649ca206195$var$defaultVertOffset)
            }
        }).addNewLine();
        // User Profile Pic
        this.addLabelAndDesc(scene, "profile_pic_label", $82236649ca206195$var$labels.profilePic, "profile_pic_desc", $82236649ca206195$var$labels.profilePicDesc);
        // Pfp
        this.addPfpImage();
        console.log(this._userData);
        // Username
        this.addLabelAndDesc(scene, "username_label", $82236649ca206195$var$labels.username, "username_desc", $82236649ca206195$var$labels.usernameDesc);
        this._usernameTextBox = this.createTextBox(scene, 50, "Username", true, (_a = this._userData.name) === null || _a === void 0 ? void 0 : _a.toUpperCase());
        // Squad Name
        this.addLabelAndDesc(scene, "squad_name_label", $82236649ca206195$var$labels.squadName, "squad_name_desc", $82236649ca206195$var$labels.squadNameDesc);
        this._squadNameTextBox = this.createTextBox(scene, 50, "Username", false, (_b = this._userData.squad_name) === null || _b === void 0 ? void 0 : _b.toUpperCase());
        // Twitter
        this.addLabelAndDesc(scene, "twitter_label", $82236649ca206195$var$labels.twitter, "twitter_desc", $82236649ca206195$var$labels.twitterDesc);
        this._twitterTextBox = this.createTextBox(scene, 50, "Username", false, (_c = this._userData.twitter) === null || _c === void 0 ? void 0 : _c.toUpperCase());
        // Connect Accounts
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $82236649ca206195$var$labels.connectAccounts, scene.applyScale(16)), {
            key: "connect_accounts_label",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$buttonSectionVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        //   Connect Wallet Button
        const connectWalletButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "settings_connect_wallet_button", false);
        connectWalletButton.onClick().subscribe(this.connectWalletButtonHandler);
        this._sizer.add(scene.add.existing(connectWalletButton), {
            key: "connect_wallet_button",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        // Connected Wallets
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $82236649ca206195$var$labels.connectedWallets, scene.applyScale(16)), {
            key: "connected_wallets_label",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$buttonSectionVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        // Other settings
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $82236649ca206195$var$labels.other, scene.applyScale(16)), {
            key: "other_settings_label",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$buttonSectionVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        //   Music Button
        const musicButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "music_button_active", false);
        musicButton.onClick().subscribe(this.musicButtonHandler);
        this._sizer.add(scene.add.existing(musicButton), {
            key: "music_button",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: scene.applyScale($82236649ca206195$var$buttonSectionVertOffset)
            }
        });
        //   Sounds Effects Button
        const soundEffectsButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "sound_effects_button_active", false);
        soundEffectsButton.onClick().subscribe(this.soundEffectsButtonHandler);
        this._sizer.add(scene.add.existing(soundEffectsButton), {
            key: "sound_effects_button",
            padding: {
                left: scene.applyScale($82236649ca206195$var$buttonHorizontalOffset),
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: scene.applyScale($82236649ca206195$var$buttonSectionVertOffset)
            }
        }).addNewLine();
        // Layout Sizer
        this.layout();
        // Removes focus from inputTexts when user clicks outside of them
        scene.input.on("pointerdown", function() {
            var _a, _b, _c, _d;
            (_b = (_a = scene.getProfilePane()) === null || _a === void 0 ? void 0 : _a._squadNameTextBox) === null || _b === void 0 || _b.setBlur();
            (_d = (_c = scene.getProfilePane()) === null || _c === void 0 ? void 0 : _c._twitterTextBox) === null || _d === void 0 || _d.setBlur();
        }, this);
    }
    addLabelAndDesc(scene, labelKey, labelText, descKey, descText) {
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", labelText, scene.applyScale(16)), {
            key: labelKey,
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", descText, scene.applyScale(16)).setAlpha(0.3), {
            key: descKey,
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$descTextVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
    }
    addPfpImage() {
        const scene = this.scene;
        const squad = (0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync();
        let pfpKey = !squad || squad.length === 0 ? "starwolf_silhouette" : squad[0].image_key;
        let rectConfig = {
            maskType: "roundRectangle",
            radius: 0
        };
        const pfpImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, pfpKey);
        const pfpImageWidth = pfpImageData.width;
        rectConfig.radius = pfpImageWidth / 15;
        var pfpImage = new (0, $8e0e3599fc103993$export$2e2bcd8739ae039)(scene, 0, 0, pfpKey, rectConfig, false);
        pfpImage.displayHeight = scene.applyScale(100);
        pfpImage.scaleX = pfpImage.scaleY;
        pfpImageData.destroy();
        pfpImage.disableInteractive();
        this._sizer.add(scene.add.existing(pfpImage).setScale(this._scale * pfpImage.scaleY), {
            key: "pfp_image",
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$defaultVertOffset),
                right: 0,
                bottom: scene.applyScale($82236649ca206195$var$profilePicVertOffset)
            }
        }).addNewLine();
    }
    createTextBox(scene, maxLength, placeholderText, readOnly, textValue) {
        // Wallet Input Text
        const inputTextConfig = {
            x: 0,
            y: 0,
            width: undefined,
            height: undefined,
            type: "text",
            id: undefined,
            text: textValue,
            maxLength: maxLength,
            minLength: undefined,
            placeholder: placeholderText,
            tooltip: undefined,
            readOnly: readOnly,
            spellCheck: false,
            autoComplete: "off",
            align: "left",
            paddingLeft: `${scene.applyScale(10)}px`,
            paddingRight: undefined,
            paddingTop: `${scene.applyScale(2)}px`,
            paddingBottom: undefined,
            fontFamily: "ccwhatchamacallitbold",
            fontSize: `${scene.applyScale($82236649ca206195$var$inputTextFontSize)}px`,
            color: "#ffffff",
            border: "none",
            backgroundColor: "#E6E6FF0D",
            borderColor: undefined,
            outline: "none",
            direction: "ltr",
            selectAll: false
        };
        var inputText = scene.add.rexInputText(0, 0, scene.applyScale($82236649ca206195$var$inputTextWidth), scene.applyScale($82236649ca206195$var$inputTextHeight), inputTextConfig);
        inputText.setStyle("border-radius", "8px");
        if (textValue) inputText.setText(textValue);
        this._sizer.add(inputText, {
            key: `${placeholderText}_input_text`,
            padding: {
                left: 0,
                top: scene.applyScale($82236649ca206195$var$inputTextTopPadding),
                right: 0,
                bottom: 0
            }
        });
        // inputText.on('wheel', (pointer, dx, dy, dz, eventInfo) => {
        //   this.emit('wheel', [pointer, dx, dy, dz, eventInfo]);
        // });
        return inputText;
    }
    connectWalletButtonHandler(pointer) {}
    musicButtonHandler(pointer) {}
    soundEffectsButtonHandler(pointer) {}
    getLevelImageKey() {
        const levelBadges = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().userBadges;
        const level = this._userData.level;
        var badge = levelBadges.find((lb)=>{
            if (lb.maxLevel === null) return level >= lb.minLevel;
            else return level >= lb.minLevel && level <= lb.maxLevel;
        });
        if (badge) return badge.badgeImageKey;
        return levelBadges[0].badgeImageKey;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("profileContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $82236649ca206195$export$2e2bcd8739ae039(this.scene, x, y));
});





const $b18b9aeda82f60dd$var$labels = {
    title: "Alliance Settings",
    allianceName: "Alliance Name",
    allianceNameDesc: "Coming soon...",
    allianceMembers: "Alliance Members",
    allianceMembersDesc: "Coming soon..."
};
const $b18b9aeda82f60dd$var$imageKeys = {
    disconnectButton: "disconnect_button",
    kickButton: "kick_button"
};
const $b18b9aeda82f60dd$var$defaultVertOffset = 10;
const $b18b9aeda82f60dd$var$descTextVertOffset = -1;
const $b18b9aeda82f60dd$var$memberSectionVertOffset = 30;
const $b18b9aeda82f60dd$var$inputTextTopPadding = 5;
const $b18b9aeda82f60dd$var$inputTextFontSize = 14;
const $b18b9aeda82f60dd$var$inputTextWidth = 518;
const $b18b9aeda82f60dd$var$inputTextHeight = 36;
class $b18b9aeda82f60dd$export$2e2bcd8739ae039 extends (0, $6449a3e76a76d511$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        const conf = config ? config : {
            x: x,
            y: y,
            width: scene.applyScale(566),
            height: scene.applyScale(642),
            scrollMode: 0,
            //background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 10, COLOR_PRIMARY),
            panel: {
                child: scene.rexUI.add.fixWidthSizer({
                    space: {
                        left: scene.applyScale(21),
                        right: scene.applyScale(21),
                        top: 0,
                        bottom: scene.applyScale(21),
                        item: scene.applyScale(10),
                        line: 0
                    }
                }),
                mask: {
                    padding: 1
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                left: 0,
                right: 0,
                top: scene.applyScale(21),
                bottom: 0,
                panel: 0
            }
        };
        super(scene, conf);
        this._scale = paneScale;
        this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this.layout();
        this.createComponent();
    }
    createComponent() {
        var _a;
        this._sizer = this.getElement("panel");
        const scene = this.scene;
        // Title
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $b18b9aeda82f60dd$var$labels.title, scene.applyScale(20)), {
            key: "title_label",
            padding: {
                left: 0,
                top: scene.applyScale($b18b9aeda82f60dd$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        // Alliance Name
        this.addLabelAndDesc(scene, "alliance_name_label", $b18b9aeda82f60dd$var$labels.allianceName, "alliance_name_desc", $b18b9aeda82f60dd$var$labels.allianceNameDesc);
        this._allianceNameTextBox = this.createTextBox(scene, 50, "-", true, (_a = this._userData.allianceName) === null || _a === void 0 ? void 0 : _a.toUpperCase());
        // Alliance Members
        this.addLabelAndDesc(scene, "alliance_members_label", $b18b9aeda82f60dd$var$labels.allianceMembers, "alliance_members_desc", $b18b9aeda82f60dd$var$labels.allianceMembersDesc, $b18b9aeda82f60dd$var$memberSectionVertOffset);
        // Layout Sizer
        this.layout();
    }
    addLabelAndDesc(scene, labelKey, labelText, descKey, descText, vertOffset) {
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", labelText, scene.applyScale(16)), {
            key: labelKey,
            padding: {
                left: 0,
                top: scene.applyScale(vertOffset || $b18b9aeda82f60dd$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", descText, scene.applyScale(16)).setAlpha(0.3), {
            key: descKey,
            padding: {
                left: 0,
                top: scene.applyScale($b18b9aeda82f60dd$var$descTextVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
    }
    createTextBox(scene, maxLength, placeholderText, readOnly, textValue) {
        // Wallet Input Text
        const inputTextConfig = {
            x: 0,
            y: 0,
            width: undefined,
            height: undefined,
            type: "text",
            id: undefined,
            text: textValue,
            maxLength: maxLength,
            minLength: undefined,
            placeholder: placeholderText,
            tooltip: undefined,
            readOnly: readOnly,
            spellCheck: false,
            autoComplete: "off",
            align: "left",
            paddingLeft: `${scene.applyScale(10)}px`,
            paddingRight: undefined,
            paddingTop: `${scene.applyScale(2)}px`,
            paddingBottom: undefined,
            fontFamily: "ccwhatchamacallitbold",
            fontSize: `${scene.applyScale($b18b9aeda82f60dd$var$inputTextFontSize)}px`,
            color: "#ffffff",
            border: "none",
            backgroundColor: "#E6E6FF0D",
            borderColor: undefined,
            outline: "none",
            direction: "ltr",
            selectAll: false
        };
        var inputText = scene.add.rexInputText(0, 0, scene.applyScale($b18b9aeda82f60dd$var$inputTextWidth), scene.applyScale($b18b9aeda82f60dd$var$inputTextHeight), inputTextConfig);
        inputText.setStyle("border-radius", "8px");
        if (textValue) inputText.setText(textValue);
        this._sizer.add(inputText, {
            key: `${placeholderText}_input_text`,
            padding: {
                left: 0,
                top: scene.applyScale($b18b9aeda82f60dd$var$inputTextTopPadding),
                right: 0,
                bottom: 0
            }
        });
        return inputText;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("allianceContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $b18b9aeda82f60dd$export$2e2bcd8739ae039(this.scene, x, y));
});






const $6f79c95c7c7de073$var$componentWidth = 235;
const $6f79c95c7c7de073$var$componentHeight = 145;
const $6f79c95c7c7de073$var$hoverAlpha = 0.7;
class $6f79c95c7c7de073$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, helpItem, paneScale, config){
        let conf = {
            width: $6f79c95c7c7de073$var$componentWidth * (paneScale || 1),
            height: $6f79c95c7c7de073$var$componentHeight * (paneScale || 1),
            space: {
                left: scene.applyScale(15),
                right: scene.applyScale(0),
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._helpItem = helpItem;
        return this.createComponent(scene, x, y, this._helpItem);
    }
    createComponent(scene, x, y, item) {
        var rectConfig = {
            maskType: "roundRectangle",
            radius: scene.applyScale(25)
        };
        var itemBg = scene.add.rexCircleMaskImage(0, 0, item.bg_image_key, "", rectConfig);
        itemBg.displayHeight = scene.applyScale(145);
        itemBg.scaleX = itemBg.scaleY;
        this.add(itemBg, {
            key: "help_option_bg",
            align: "center",
            expand: false
        });
        if (item.label_image_key) this.add(scene.add.image(0, 0, item.label_image_key).setScale(this._scale), {
            key: "help_option_label",
            align: "center",
            expand: false
        });
        this.layout();
        if (item.enabled) {
            this.setInteractive({
                cursor: "pointer"
            });
            this.setChildrenInteractive({
                click: {
                    mode: "release",
                    clickInterval: 100
                },
                over: true,
                tap: {
                    time: 250,
                    tapInterval: 200,
                    threshold: 9,
                    tapOffset: 10,
                    taps: undefined,
                    minTaps: undefined,
                    maxTaps: undefined
                },
                press: {
                    time: 251,
                    threshold: 9
                },
                swipe: {
                    threshold: 10,
                    velocityThreshold: 1000,
                    dir: "8dir"
                },
                inputEventPrefix: "child."
            });
            this.on("child.over", (child, pointer, event)=>{
                var _a, _b;
                (_a = this.getElement("help_option_bg")) === null || _a === void 0 || _a.setAlpha($6f79c95c7c7de073$var$hoverAlpha);
                (_b = this.getElement("help_option_label")) === null || _b === void 0 || _b.setAlpha($6f79c95c7c7de073$var$hoverAlpha);
            });
            this.on("child.out", (child, pointer, event)=>{
                var _a, _b;
                (_a = this.getElement("help_option_bg")) === null || _a === void 0 || _a.setAlpha(1);
                (_b = this.getElement("help_option_label")) === null || _b === void 0 || _b.setAlpha(1);
            });
        } else {
            this.disableInteractive();
            this.setAlpha(0.3);
        }
        this.onClick((button, gameObject, pointer, event)=>{
            var _a;
            // Open target url in new tab
            (_a = window.open(item.target_url, "_blank")) === null || _a === void 0 || _a.focus();
        }, this);
        return this;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("helpOptionComponent", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $6f79c95c7c7de073$export$2e2bcd8739ae039(this.scene, x, y));
});



const $549159c6edc35856$var$labels = {
    title: "Help Desk",
    litepapers: "Litepapers"
};
const $549159c6edc35856$var$imageKeys = {
    disconnectButton: "disconnect_button",
    kickButton: "kick_button"
};
const $549159c6edc35856$var$mainHelpOptions = [
    {
        name: "help_channel",
        type: "main",
        target_url: "https://starwolvez.notion.site/Partner-Projects-757feec064be49a3bb8e148df0367a24",
        bg_image_key: "help_channel_image",
        enabled: true
    },
    {
        name: "interplanetary",
        type: "main",
        target_url: "https://starwolvez.notion.site/Partner-Projects-757feec064be49a3bb8e148df0367a24",
        bg_image_key: "inter_planetary_image",
        enabled: true
    }
];
const $549159c6edc35856$var$defaultVertOffset = 10;
const $549159c6edc35856$var$rightOptionOffset = 20;
class $549159c6edc35856$export$2e2bcd8739ae039 extends (0, $6449a3e76a76d511$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, config){
        const conf = config ? config : {
            x: x,
            y: y,
            width: scene.applyScale(570),
            height: scene.applyScale(642),
            scrollMode: 0,
            //background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 10, COLOR_PRIMARY),
            panel: {
                child: scene.rexUI.add.fixWidthSizer({
                    space: {
                        left: scene.applyScale(21),
                        right: scene.applyScale(21),
                        top: 0,
                        bottom: scene.applyScale(21),
                        item: scene.applyScale(10),
                        line: 0
                    }
                }),
                mask: {
                    padding: 1
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                left: 0,
                right: 0,
                top: scene.applyScale(21),
                bottom: 0,
                panel: 0
            }
        };
        super(scene, conf);
        this._scale = paneScale;
        this._helpOptions = (0, $f8dc067ac15f14fe$export$2e2bcd8739ae039).getInstance().getHelpOptions();
        this._helpTypes = (0, $f8dc067ac15f14fe$export$2e2bcd8739ae039).getInstance().getHelpTypes();
        this.layout();
        this.createComponent();
    }
    createComponent() {
        this._sizer = this.getElement("panel");
        const scene = this.scene;
        // Title
        this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", $549159c6edc35856$var$labels.title, scene.applyScale(20)), {
            key: "title_label",
            padding: {
                left: 0,
                top: scene.applyScale($549159c6edc35856$var$defaultVertOffset),
                right: 0,
                bottom: 0
            }
        }).addNewLine();
        // TODO: Add main help tiles
        $549159c6edc35856$var$mainHelpOptions.forEach((helpOption)=>{
            this._sizer.add(scene.add.existing(new (0, $6f79c95c7c7de073$export$2e2bcd8739ae039)(scene, 0, 0, helpOption, this._scale)), {
                key: helpOption.name,
                padding: {
                    left: 0,
                    top: scene.applyScale($549159c6edc35856$var$defaultVertOffset),
                    right: 0,
                    bottom: scene.applyScale($549159c6edc35856$var$defaultVertOffset)
                }
            });
        });
        // Add each help type and associated help options (with dividers)
        this._helpTypes.forEach((helpType)=>{
            // TODO: Add divider
            this._sizer.add(scene.add.image(0, 0, "help_pane_divider"), {
                key: `${helpType}_divider`,
                padding: {
                    left: 0,
                    top: scene.applyScale($549159c6edc35856$var$defaultVertOffset * 2),
                    right: 0,
                    bottom: scene.applyScale($549159c6edc35856$var$defaultVertOffset * 1.5)
                }
            });
            // Add type title
            this._sizer.add(scene.add.bitmapText(0, 0, "cc_outline", helpType.displayName, scene.applyScale(20)), {
                key: helpType.key,
                padding: {
                    left: 0,
                    top: scene.applyScale($549159c6edc35856$var$defaultVertOffset * 2),
                    right: 0,
                    bottom: 0
                }
            }).addNewLine();
            // Add help options
            this._helpOptions.filter((opt)=>opt.type === helpType.key).forEach((helpOption)=>{
                this._sizer.add(scene.add.existing(new (0, $6f79c95c7c7de073$export$2e2bcd8739ae039)(scene, 0, 0, helpOption, this._scale)), {
                    key: helpOption.name,
                    padding: {
                        left: 0,
                        top: scene.applyScale($549159c6edc35856$var$defaultVertOffset),
                        right: 0,
                        bottom: scene.applyScale($549159c6edc35856$var$defaultVertOffset)
                    }
                });
            });
        });
        // Layout Sizer
        this.layout();
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("helpContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $549159c6edc35856$export$2e2bcd8739ae039(this.scene, x, y));
});



const $371dd94fe4d1a8e8$var$modalHeight = 642;
const $371dd94fe4d1a8e8$var$modalWidth = 814;
const $371dd94fe4d1a8e8$var$modalRadius = 25;
const $371dd94fe4d1a8e8$var$modalColor = 0x1c1c2c;
const $371dd94fe4d1a8e8$var$modalAlpha = 1;
const $371dd94fe4d1a8e8$var$spineWidth = 248;
const $371dd94fe4d1a8e8$var$spineColor = 0xe6e6ff;
const $371dd94fe4d1a8e8$var$spineAlpha = 0.05;
const $371dd94fe4d1a8e8$var$settingTypes = [
    {
        key: "profile_settings",
        displayName: "Your Settings",
        isSelected: true
    },
    {
        key: "alliance_settings",
        displayName: "Alliance Settings",
        isSelected: false
    },
    {
        key: "help",
        displayName: "Help",
        isSelected: false
    }
];
class $371dd94fe4d1a8e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userData = data.userData;
    }
    constructor(){
        super({
            key: "ProfileModalScene"
        });
        this._scale = 1;
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$12ea44d094a282e0));
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$3fff705904dea5e1));
    }
    create() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($371dd94fe4d1a8e8$var$modalWidth, $371dd94fe4d1a8e8$var$modalHeight);
        this._settingTypes = $371dd94fe4d1a8e8$var$settingTypes;
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($371dd94fe4d1a8e8$var$modalWidth), this.applyScale($371dd94fe4d1a8e8$var$modalHeight), this.applyScale($371dd94fe4d1a8e8$var$modalRadius), $371dd94fe4d1a8e8$var$modalColor, $371dd94fe4d1a8e8$var$modalAlpha);
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($371dd94fe4d1a8e8$var$spineWidth), this.applyScale($371dd94fe4d1a8e8$var$modalHeight), {
            tl: this.applyScale($371dd94fe4d1a8e8$var$modalRadius),
            tr: 0,
            bl: this.applyScale($371dd94fe4d1a8e8$var$modalRadius),
            br: 0
        }, $371dd94fe4d1a8e8$var$spineColor, $371dd94fe4d1a8e8$var$spineAlpha);
        // Title text
        const titleText = this.add.image(0, 0, "settings_text").setOrigin(0).setScale(this._scale);
        // Add spine here
        this._spineTable = this.createSpineTable(this, this._settingTypes, 0, 0).setOrigin(0.5, 0.5);
        this._saveAndExitButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "save_and_exit_button", false).setScale(this._scale);
        this.add.existing(this._saveAndExitButton);
        this._saveAndExitButton.onClick().subscribe((pointer)=>{
            this.saveAndExitButtonClickHandler(pointer);
        });
        this._profileContentPane = new (0, $82236649ca206195$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
        this.add.existing(this._profileContentPane);
        this._sizer.add(background, {
            key: "background",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.add(spineBackground, {
            key: "spineBackground",
            align: "center",
            offsetX: this.applyScale(-($371dd94fe4d1a8e8$var$modalWidth / 2 - $371dd94fe4d1a8e8$var$spineWidth / 2)),
            offsetY: 0,
            expand: false
        });
        this._sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(31),
            expand: false
        });
        this._sizer.add(this._spineTable, {
            key: "table",
            align: "left-top",
            offsetX: this.applyScale(15),
            offsetY: this.applyScale(60),
            expand: false
        });
        this._sizer.add(this._saveAndExitButton, {
            key: "saveAndExitButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        this._sizer.add(this._profileContentPane, {
            key: "profile-content-pane",
            align: "left-top",
            offsetX: this.applyScale(249),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._sizer.layout();
        this.setIsSelected(this._settingTypes[0]);
        this._sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {
        this._settingTypes = undefined;
        this._profileContentPane = undefined;
        this._allianceContentPane = undefined;
        this._helpContentPane = undefined;
    }
    createSpineTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(220),
            height: this.applyScale(450),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(220),
                cellHeight: this.applyScale(32),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                interactive: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                // Template
                let rectConfig = {
                    maskType: "roundRectangle",
                    radius: 0
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(220),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).setInteractive({
                    useHandCursor: true
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(220), scene.applyScale(32), scene.applyScale(6), 0xe6e6ff, 0.05).setAlpha(item.isSelected ? 1 : 0), {
                    key: "menu_option_bg",
                    align: "center",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.displayName, scene.applyScale(16), 0).setAlpha(item.isSelected ? 1 : 0.4), {
                    key: "menu_option_text",
                    align: "left",
                    offsetX: scene.applyScale(10),
                    offsetY: 0,
                    expand: false
                });
                sizer.setChildrenInteractive({
                    click: {
                        mode: "release",
                        clickInterval: 100
                    },
                    over: true,
                    tap: {
                        time: 250,
                        tapInterval: 200,
                        threshold: 9,
                        tapOffset: 10,
                        taps: undefined,
                        minTaps: undefined,
                        maxTaps: undefined
                    },
                    press: {
                        time: 251,
                        threshold: 9
                    },
                    swipe: {
                        threshold: 10,
                        velocityThreshold: 1000,
                        dir: "8dir"
                    },
                    inputEventPrefix: "child."
                });
                sizer.on("child.over", (child, pointer, event)=>{
                    sizer.getElement("menu_option_text").setAlpha(1);
                });
                sizer.on("child.out", (child, pointer, event)=>{
                    if (!item.isSelected) sizer.getElement("menu_option_text").setAlpha(0.4);
                });
                sizer.on("child.click", (child, pointer, event)=>{
                    scene.setIsSelected(item);
                });
                return sizer;
            }
        });
        table.setItems(data).scrollToTop();
        //table.getElement('table').on('')
        return table;
    }
    setIsSelected(item) {
        if (item.isSelected === true) return;
        this._settingTypes = this._settingTypes.map((mt)=>{
            mt.isSelected = mt.displayName === item.displayName ? true : false;
            return mt;
        });
        this._spineTable.setItems(this._settingTypes);
        this.setContentPane(item);
    }
    setContentPane(item) {
        var contentPane;
        var paneKey;
        if (this._profileContentPane) {
            this._profileContentPane.setAlpha(0);
            this._sizer.remove(this._profileContentPane, true);
        }
        if (this._allianceContentPane) {
            this._allianceContentPane.setAlpha(0);
            this._sizer.remove(this._allianceContentPane, true);
        }
        if (this._helpContentPane) {
            this._helpContentPane.setAlpha(0);
            this._sizer.remove(this._helpContentPane, true);
        }
        this.input.removeListener("pointerdown");
        switch(item.key){
            case "profile_settings":
                contentPane = this._profileContentPane = new (0, $82236649ca206195$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
                paneKey = "profile_content_pane";
                break;
            case "alliance_settings":
                contentPane = this._allianceContentPane = new (0, $b18b9aeda82f60dd$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
                paneKey = "alliance_content_pane";
                break;
            case "help":
                contentPane = this._helpContentPane = new (0, $549159c6edc35856$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
                paneKey = "help_content_pane";
                break;
            default:
                break;
        }
        this._sizer.add(this.add.existing(contentPane), {
            key: paneKey,
            align: "left-top",
            offsetX: this.applyScale(249),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._sizer.layout();
    }
    saveAndExitButtonClickHandler(pointer) {
        this.unloadAssets();
        this.scene.resume("HomebaseScene");
        this.scene.resume("HudScene");
        this.scene.stop();
    }
    getProfilePane() {
        return this._profileContentPane;
    }
    unloadAssets() {
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$12ea44d094a282e0)));
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$3fff705904dea5e1)));
    }
}













const $95e3c95bd808ad60$var$minDaysHeldToStake = 7;
// Pane Details
const $95e3c95bd808ad60$var$paneHeight = 180;
const $95e3c95bd808ad60$var$refillTextColor = 0xa3a3b9;
const $95e3c95bd808ad60$var$stakingYieldTextColor = 0xff6eb4;
class $95e3c95bd808ad60$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, paneWidth, config){
        let conf = config ? config : {
            width: paneWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._paneWidth = paneWidth;
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        // Sizer
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: this.applyScale(this._paneWidth),
            height: this.applyScale($95e3c95bd808ad60$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        this._title = scene.add.bitmapText(0, 0, "cc_outline", "Staking", this.applyScale(22), 1);
        sizerPanel.add(this._title, {
            key: "title-text",
            align: "left-top",
            offsetX: this.applyScale(16),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Button
        this._openAllButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "open_all_button_disabled", false).setScale(this._scale);
        this._openAllButton.onClick().subscribe((pointer)=>{
            scene.sound.play("open-all-button");
            scene.scene.pause();
            scene.scene.launch("PenaltyScene");
        });
        this.setOpenAllEnabled();
        sizerPanel.add(scene.add.existing(this._openAllButton), {
            key: "next-button",
            align: "right-top",
            offsetX: this.applyScale(-16),
            offsetY: this.applyScale(-4),
            expand: false
        });
        // Claim Countdown Timer
        this._countdownTimer = scene.add.bitmapText(0, 0, "cc_outline", "Chests refill in 0h 0m", this.applyScale(14), 1).setOrigin(1, 0.5).setTint($95e3c95bd808ad60$var$refillTextColor);
        sizerPanel.add(this._countdownTimer, {
            key: "countdown-timer-text",
            align: "right-top",
            offsetX: this.applyScale(-16),
            offsetY: this.applyScale(60),
            expand: false
        });
        // Staking Yield
        this._stakingYield = scene.add.bitmapText(0, 0, "cc_outline", `Net Staking Yield: ${(0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getNetStakingYield().toLocaleString("en-us")}`, this.applyScale(14), 1).setOrigin(1, 0.5).setTint($95e3c95bd808ad60$var$stakingYieldTextColor);
        sizerPanel.add(this._stakingYield, {
            key: "staking-yield-text",
            align: "left-top",
            offsetX: this.applyScale(16),
            offsetY: this.applyScale(60),
            expand: false
        });
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
        this.updateTimeHandler();
    // scene.time.addEvent({
    //   delay: 15000, //1 minute
    //   loop: true,
    //   callback: () => {
    //     this.updateTimeHandler();
    //   },
    // });
    }
    applyScale(length) {
        return this.scene.applyScale(length);
    }
    setOpenAllEnabled() {
        const unclaimedStakes = this.getUnclaimedStakes();
        if (unclaimedStakes.length > 0) {
            // Enable Open All button
            this._openAllButton.setInteractive();
            this._openAllButton.setTexture("open_all_button");
        } else {
            // Disable Open All button
            this._openAllButton.disableInteractive();
            this._openAllButton.setTexture("open_all_button_disabled");
        }
    }
    getUnclaimedStakes() {
        const stakingInfo = (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfoSync();
        return stakingInfo.nfts.filter((nft)=>{
            return nft.days_held >= $95e3c95bd808ad60$var$minDaysHeldToStake && !nft.staking_reward_info;
        });
    }
    updateTimeHandler() {
        const date = new Date();
        const currentHour = date.getUTCHours();
        const currentMinute = date.getUTCMinutes();
        var hoursRemaining = 24 - currentHour;
        var minutesRemaining = 60 - currentMinute;
        if (minutesRemaining === 60) minutesRemaining = 0;
        else hoursRemaining--;
        this._countdownTimer.setText(`Chests refill in ${hoursRemaining}h ${minutesRemaining}m`);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("stakingHeaderContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $95e3c95bd808ad60$export$2e2bcd8739ae039(this.scene, x, y));
});







var $f1q41 = parcelRequire("f1q41");



const $3dd919349f02986e$var$imageHeight = 90;
const $3dd919349f02986e$var$blueProgressBarColor = 0x00a6d3;
const $3dd919349f02986e$var$progressBarAlpha = 1;
const $3dd919349f02986e$var$glareColor = 0xffffff;
const $3dd919349f02986e$var$glareAlpha = 0.17;
const $3dd919349f02986e$var$glareRadius = 3;
const $3dd919349f02986e$var$glareHeight = 6;
const $3dd919349f02986e$var$glareOffset = 10;
const $3dd919349f02986e$var$backgroundColor = 0x440d31;
const $3dd919349f02986e$var$backgroundAlpha = 1;
const $3dd919349f02986e$var$radius = 7;
const $3dd919349f02986e$var$progressBarBorderColor = 0x383d57;
const $3dd919349f02986e$var$progressBarBorderWidth = 1;
const $3dd919349f02986e$var$progressBarHeight = 18;
const $3dd919349f02986e$var$progressBarWidth = $3dd919349f02986e$var$imageHeight - 12;
const $3dd919349f02986e$var$progressBarMin = 0;
const $3dd919349f02986e$var$stakingWaitPeriod = 604800; // 7 days in seconds
class $3dd919349f02986e$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, data, paneScale, config){
        // data { image_key, display_name, hp, show_yield, show_hp, yield? }
        let conf = config ? config : {
            x: x,
            y: y,
            width: paneScale * 90,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._nft = data;
        this.createComponent(scene, x, y, data);
    }
    createComponent(scene, x, y, data) {
        // if (!data.id) {
        //   return this.layout();
        // }
        // NFT Image
        var imageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, this._nft.image_key);
        var imageWidth = imageData.width;
        const rectConfig = {
            maskType: "roundRectangle",
            radius: Math.ceil(imageWidth / 8)
        };
        this._nftImage = scene.add.rexCircleMaskImage(0, 0, this._nft.image_key, "", rectConfig);
        this._nftImage.displayHeight = scene.applyScale($3dd919349f02986e$var$imageHeight);
        this._nftImage.scaleX = this._nftImage.scaleY;
        imageData.destroy();
        this.add(this._nftImage, {
            key: "nft_image",
            align: "center",
            offsetX: scene.applyScale(0),
            offsetY: scene.applyScale(0),
            expand: false
        });
        // Progress Bar
        let progressValue = this.getTimeBeforeStaked();
        if (progressValue > 0) {
            this._progressBar = this.createProgressBar(scene, progressValue);
            this.add(this._progressBar, {
                key: "progress_bar",
                align: "center-bottom",
                offsetX: 0,
                offsetY: this.applyScale(-4),
                expand: false
            });
        }
        return this.layout();
    }
    createProgressBar(scene, progressValue) {
        // Progress Bar
        const progBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(scene, 0, 0, 1, {
            rtl: false,
            title: {
                text: this.secondsToTime(progressValue),
                offset: 2,
                fontSize: 14
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $3dd919349f02986e$var$progressBarWidth,
                height: $3dd919349f02986e$var$progressBarHeight,
                radius: $3dd919349f02986e$var$radius,
                color: $3dd919349f02986e$var$blueProgressBarColor,
                alpha: $3dd919349f02986e$var$progressBarAlpha,
                backgroundColor: $3dd919349f02986e$var$backgroundColor,
                backgroundAlpha: $3dd919349f02986e$var$backgroundAlpha,
                minValue: $3dd919349f02986e$var$progressBarMin,
                maxValue: $3dd919349f02986e$var$stakingWaitPeriod,
                progressValue: progressValue > 0 ? progressValue : 1,
                glare: {
                    height: $3dd919349f02986e$var$glareHeight,
                    width: $3dd919349f02986e$var$progressBarWidth - $3dd919349f02986e$var$glareOffset,
                    radius: $3dd919349f02986e$var$glareRadius,
                    color: $3dd919349f02986e$var$glareColor,
                    alpha: $3dd919349f02986e$var$glareAlpha
                }
            },
            border: {
                alpha: $3dd919349f02986e$var$backgroundAlpha,
                color: $3dd919349f02986e$var$progressBarBorderColor,
                width: $3dd919349f02986e$var$progressBarBorderWidth
            }
        });
        return scene.add.existing(progBar);
    }
    getTimeBeforeStaked() {
        const now = Math.floor(Date.now() / 1000);
        const timeSpan = !this._nft.purchased_time ? 0 : now - this._nft.purchased_time;
        const timeRemaining = $3dd919349f02986e$var$stakingWaitPeriod - timeSpan;
        return timeRemaining >= 0 ? timeRemaining : 0;
    }
    secondsToTime(seconds) {
        seconds = Number(seconds);
        var d = Math.floor(seconds / 86400);
        var h = Math.floor((seconds - d * 86400) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var dDisplay = d > 0 ? `${d}D` : "";
        var hDisplay = h > 0 ? `${h}H` : "";
        var mDisplay = m > 0 ? `${m}M` : "";
        return d > 0 ? `${dDisplay} ${hDisplay} LEFT` : `${hDisplay} ${mDisplay} LEFT`;
    }
    applyScale(length) {
        return length * this._scale;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("dashboardNftComponent", function(x, y, data) {
    // @ts-ignore
    return this.displayList.add(new $3dd919349f02986e$export$2e2bcd8739ae039(this.scene, x, y, data));
});




const $613d865b5c232b60$var$refillTextColor = 0xa3a3b9;
const $613d865b5c232b60$var$stardustTextColor = 0xff6eb4;
const $613d865b5c232b60$var$currencyColors = {
    neon_gold: 0xffe100,
    space_elixir: 0x00d4f7,
    stardust: 0xff87ac
};
const $613d865b5c232b60$var$defaultTableHeight = 479;
const $613d865b5c232b60$var$itemWidth = 1014, $613d865b5c232b60$var$itemHeight = 107, $613d865b5c232b60$var$itemRadius = 8, $613d865b5c232b60$var$itemColor = 0x262637, $613d865b5c232b60$var$itemAlpha = 1;
const $613d865b5c232b60$var$collectionSlugs = {
    sw_genesis: "starwolves",
    sw_generative: "starwolvez-generative",
    ga_generative_new: "gapes-nft",
    ga_generative_old: "galacticapes",
    ga_genesis: "galacticapesgenesis",
    ga_monkes: "galacticmonkes"
};
const $613d865b5c232b60$var$itemTypes = {
    nft: "nft",
    default: "default",
    header: "header"
};
const $613d865b5c232b60$var$defaultCollectionImage = {
    sw_genesis: "sw_genesis_empty",
    sw_generative: "sw_generative_empty",
    ga_generative: "gape_generative_empty",
    ga_genesis: "gape_genesis_empty",
    ga_monkes: "gape_monke_empty"
};
const $613d865b5c232b60$var$collectionUrls = {
    sw_genesis: "https://opensea.io/collection/starwolves",
    sw_generative: "https://opensea.io/collection/starwolvez-generative",
    ga_generative: "https://opensea.io/collection/galacticapes",
    ga_genesis: "https://opensea.io/collection/galacticapesgenesis",
    ga_monkes: "https://opensea.io/collection/galacticmonkes"
};
const $613d865b5c232b60$var$stakingWaitPeriod = 604800; // 7 days in seconds
const $613d865b5c232b60$var$pageSize = 30;
class $613d865b5c232b60$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, paneWidth, paneHeight, parentSizer, config){
        const conf = config ? config : {
            width: (paneWidth || 1062) * paneScale,
            height: (paneHeight || 473) * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        const self = this;
        this._scale = paneScale;
        this._paneWidth = paneWidth || 660;
        this._paneHeight = paneHeight || $613d865b5c232b60$var$defaultTableHeight;
        this._tableHeight = this._paneHeight;
        this._parentSizer = parentSizer;
        var data = (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfoSync();
        this._currentPage = 1;
        this._nftData = data.nfts;
        this._stakingInfo = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(data, [
            "nfts"
        ]);
        this._totalNftCount = Object.keys(this._stakingInfo).map((coll)=>this._stakingInfo[coll]).reduce((prev, curr, i)=>{
            return prev + curr;
        });
        this.buildAndEnrichData();
        scene.events.emit("set_open_all_enabled");
        // UI Elements
        if (this._tableData && this._tableData.length > 0) {
            // Pagination Controls
            if (this._totalNftCount > $613d865b5c232b60$var$pageSize) this.addPagingButtons(scene);
            // Table
            const table = this.createTable(scene, this._tableData, x, y);
        }
    }
    hidePane() {
        this._title.setAlpha(0);
        this._table.setAlpha(0);
        this._table.disableInteractive();
    }
    showPane() {
        this._title.clearAlpha();
        this._table.clearAlpha();
        this._table.setInteractive();
    }
    updateTable(forceUpdate = true) {
        if (forceUpdate) (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfo(undefined, undefined, (this._currentPage - 1) * $613d865b5c232b60$var$pageSize, $613d865b5c232b60$var$pageSize, true).then((data)=>{
            this._nftData = data.nfts;
            this.buildAndEnrichData();
            this._table.setItems(this._tableData);
            this.scene.events.emit("set_open_all_enabled");
        });
        else this._table.setItems(this._tableData);
    }
    createTable(scene, data, x, y) {
        var _a;
        var cellHeight = $613d865b5c232b60$var$itemHeight + 12;
        var headerHeight = 40;
        var numHeaders = data.filter((itm)=>itm.itemType === $613d865b5c232b60$var$itemTypes.header).length;
        var numNftRows = data.length - numHeaders;
        var tableHeight = scene.applyScale(cellHeight * numNftRows + headerHeight * numHeaders >= this._tableHeight ? this._tableHeight : cellHeight * numNftRows + headerHeight * numHeaders - 1);
        tableHeight = tableHeight < 0 ? 0 : tableHeight;
        if (this._pagingControls && cellHeight * numNftRows + headerHeight * numHeaders >= this._tableHeight) tableHeight = this._tableHeight - scene.applyScale(46);
        this._table = scene.rexUI.add.gridTable({
            width: scene.applyScale(this._paneWidth),
            height: tableHeight,
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: scene.applyScale(this._paneWidth - 32),
                cellHeight: scene.applyScale(cellHeight),
                columns: 1,
                clamplTableOXY: true,
                mask: {
                    padding: 2
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            space: {
                table: {
                    top: scene.applyScale(this._pagingControls ? 0 : 20),
                    left: scene.applyScale(9),
                    bottom: scene.applyScale(20)
                }
            },
            createCellContainerCallback: function(cell) {
                var _a;
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                if (item.itemType === $613d865b5c232b60$var$itemTypes.nft) {
                    var displayName;
                    switch(item.collection_slug){
                        case $613d865b5c232b60$var$collectionSlugs.sw_generative:
                            displayName = `Star Wolf #${item.token_id}`;
                            break;
                        case $613d865b5c232b60$var$collectionSlugs.sw_genesis:
                            displayName = `Genesis Wolf #${item.token_id}`;
                            break;
                        case $613d865b5c232b60$var$collectionSlugs.ga_generative_new:
                            displayName = `Galactic Ape #${item.token_id}`;
                            break;
                        case $613d865b5c232b60$var$collectionSlugs.ga_generative_old:
                            displayName = `Galactic Ape #${item.token_id}`;
                            break;
                        case $613d865b5c232b60$var$collectionSlugs.ga_genesis:
                            var id = item.name.split(" ")[1];
                            displayName = `Genesis Ape ${id}`;
                            break;
                        case $613d865b5c232b60$var$collectionSlugs.ga_monkes:
                            displayName = `Galactic Monke #${item.token_id}`;
                            break;
                    }
                    var sizer = scene.rexUI.add.overlapSizer({
                        width: width,
                        space: {
                            left: scene.applyScale(7),
                            right: 0,
                            top: 0,
                            bottom: 0,
                            item: 0,
                            line: 0
                        },
                        align: 0
                    }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(width), scene.applyScale($613d865b5c232b60$var$itemHeight), scene.applyScale($613d865b5c232b60$var$itemRadius), $613d865b5c232b60$var$itemColor, $613d865b5c232b60$var$itemAlpha), {
                        key: "staking_item_bg",
                        align: "center"
                    }).add(scene.add.existing(new (0, $3dd919349f02986e$export$2e2bcd8739ae039)(scene, 0, 0, item, scene.getScale())), {
                        key: "item-pfp",
                        align: "left-top",
                        offsetX: scene.applyScale(7),
                        offsetY: scene.applyScale(8),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", displayName, scene.applyScale(16), 1), {
                        key: "title-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(11),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", `Held for: ${item.days_held} days`, scene.applyScale(12), 1).setTint($613d865b5c232b60$var$refillTextColor), {
                        key: "held-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(44),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", `Net Yield: ${item.stardust_earned.toLocaleString("en-us")}`, scene.applyScale(12), 1).setTint($613d865b5c232b60$var$refillTextColor), {
                        key: "total-yield-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(62),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", `Daily Yield: ${item.daily_yield.toLocaleString("en-us")}`, scene.applyScale(12), 1).setTint($613d865b5c232b60$var$refillTextColor), {
                        key: "daily-yield-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(80),
                        expand: false
                    });
                    function handleClaimClick(scene, sizer, item, x, y) {
                        scene.scene.pause();
                        scene.scene.launch("DailyChestModalScene", {
                            item: item,
                            text: "Opening daily chest...",
                            type: "nft"
                        });
                    }
                    function addStakingActionDisplay(scene, sizer, item, x, y) {
                        if (!item.staking_reward_info) {
                            const claimButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "daily_chest_button", false).setScale(scene.getScale());
                            claimButton.onClick().subscribe((pointer)=>{
                                handleClaimClick(scene, sizer, item, x, y);
                            });
                            sizer.add(scene.add.existing(claimButton), {
                                key: `claim_button`,
                                align: "right-bottom",
                                offsetX: scene.applyScale(-10),
                                offsetY: scene.applyScale(-10),
                                expand: false
                            });
                        } else addCompletedDisplay(scene, sizer, item, x, y);
                    }
                    function addCompletedDisplay(scene, sizer, item, x, y) {
                        sizer.add(scene.rexUI.add.label({
                            height: scene.applyScale(24),
                            orientation: "x",
                            rtl: true,
                            icon: scene.add.image(0, 0, `${item.staking_reward_info.currency_name}_icon`).setScale(scene.applyScale(0.65)),
                            text: scene.add.bitmapText(0, 0, "cc_outline", item.staking_reward_info.currency_reward_value.toLocaleString("en-US"), scene.applyScale(18), 0).setCharacterTint(0, item.staking_reward_info.currency_reward_value.toLocaleString("en-US").length, true, $613d865b5c232b60$var$currencyColors[item.staking_reward_info.currency_name]),
                            space: {
                                icon: 8
                            }
                        }), {
                            key: "reward_label",
                            align: "right-center",
                            offsetX: scene.applyScale(-21),
                            offsetY: scene.applyScale(0),
                            expand: false
                        });
                    }
                    if (item.isStaked) addStakingActionDisplay(scene, sizer, item, x, y);
                    return sizer.layout();
                } else if (item.itemType === $613d865b5c232b60$var$itemTypes.header) {
                    cell.height = scene.applyScale(40);
                    const collectionName = scene.add.bitmapText(0, 0, "cc_outline", item.collection_name, scene.applyScale(22), 1);
                    var sizer = scene.rexUI.add.overlapSizer({
                        width: width,
                        space: {
                            left: scene.applyScale(7),
                            right: 0,
                            top: 0,
                            bottom: 0,
                            item: 0,
                            line: 0
                        },
                        align: 0
                    });
                    var titleSizer = scene.rexUI.add.fixWidthSizer({
                        width: scene.applyScale(600),
                        align: 0
                    }).add(scene.add.existing(collectionName), {
                        key: "collection-text",
                        padding: {
                            right: scene.applyScale(10),
                            left: 0,
                            top: 0,
                            bottom: 0
                        }
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", item.count, scene.applyScale(22), 1).setTint($613d865b5c232b60$var$refillTextColor), {
                        key: "count-text",
                        padding: {
                            right: 0,
                            left: 0,
                            top: 0,
                            bottom: 0
                        }
                    }).layout();
                    sizer.add(titleSizer, {
                        key: "title_sizer",
                        align: "left-top",
                        offsetX: 0,
                        offsetY: 0,
                        expand: false
                    });
                    sizer.add(scene.rexUI.add.label({
                        x: 0,
                        y: 0,
                        orientation: "x",
                        rtl: true,
                        icon: scene.add.image(0, 0, "objective_stardust_icon").setScale(scene.getScale()),
                        text: scene.add.bitmapText(0, 0, "cc_outline", `${item.perDay} per day`, scene.applyScale(18), 1).setTint($613d865b5c232b60$var$stardustTextColor),
                        space: {
                            icon: scene.applyScale(8),
                            left: scene.applyScale(0),
                            right: scene.applyScale(0),
                            top: scene.applyScale(0),
                            bottom: scene.applyScale(0)
                        },
                        align: "right"
                    }), {
                        key: "stake_reward_label",
                        align: "right-top",
                        offsetX: 0,
                        offsetY: 0,
                        expand: false
                    });
                    return sizer.layout();
                } else {
                    var rectConfig = {
                        maskType: "roundRectangle",
                        radius: 0
                    };
                    var itemImageData = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.Image(scene, 0, 0, item.image_key);
                    rectConfig.radius = itemImageData.width / 4;
                    var itemImage = scene.add.rexCircleMaskImage(0, 0, item.image_key, "", rectConfig);
                    itemImage.displayHeight = scene.applyScale(90);
                    itemImage.scaleX = itemImage.scaleY;
                    itemImageData.destroy();
                    var sizer = scene.rexUI.add.overlapSizer({
                        width: width,
                        space: {
                            left: scene.applyScale(7),
                            right: 0,
                            top: 0,
                            bottom: 0,
                            item: 0,
                            line: 0
                        },
                        align: 0
                    }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(width), scene.applyScale($613d865b5c232b60$var$itemHeight), scene.applyScale($613d865b5c232b60$var$itemRadius), $613d865b5c232b60$var$itemColor, $613d865b5c232b60$var$itemAlpha), {
                        key: "staking_item_bg",
                        align: "center"
                    }).add(scene.add.existing(itemImage.setDepth(100)), {
                        key: "item-pfp",
                        align: "left-top",
                        offsetX: scene.applyScale(7),
                        offsetY: scene.applyScale(8),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", item.collection_name, scene.applyScale(16), 1), {
                        key: "title-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(11),
                        expand: false
                    }).add(scene.add.bitmapText(0, 0, "cc_outline", `Daily Yield: ${(_a = item.daily_yield) === null || _a === void 0 ? void 0 : _a.toLocaleString("en-us")}`, scene.applyScale(12), 1).setTint($613d865b5c232b60$var$refillTextColor), {
                        key: "daily-yield-text",
                        align: "left-top",
                        offsetX: scene.applyScale(108),
                        offsetY: scene.applyScale(80),
                        expand: false
                    });
                    function addBuyButton(scene, sizer, item, x, y) {
                        const buyButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "buy_one_button", false).setScale(scene.getScale());
                        buyButton.onClick().subscribe((pointer)=>{
                            var _a;
                            (_a = window.open(item.url, "_blank")) === null || _a === void 0 || _a.focus();
                        });
                        sizer.add(scene.add.existing(buyButton), {
                            key: `buy_button`,
                            align: "right-bottom",
                            offsetX: scene.applyScale(-10),
                            offsetY: scene.applyScale(-10),
                            expand: false
                        });
                    }
                    addBuyButton(scene, sizer, item, 0, 0);
                    return sizer.layout();
                }
            }
        }).setOrigin(0.5, 0);
        this._table.setItems(data).scrollToTop();
        this.add(this._table, {
            padding: {
                left: 0,
                right: 0,
                top: this._pagingControls ? scene.applyScale(13) : 0,
                bottom: 0
            },
            key: "staking_table"
        });
        (_a = this._parentSizer) === null || _a === void 0 || _a.layout();
    }
    addPagingButtons(scene) {
        this._pagingControls = new (0, $0e0517e7570e87c7$export$2e2bcd8739ae039)(scene, 0, 0, {
            totalCount: this._totalNftCount,
            pageSize: $613d865b5c232b60$var$pageSize
        }, this._paneWidth - 65, this._scale);
        this.add(this._pagingControls, {
            key: "paging_controls",
            padding: {
                left: scene.applyScale(33),
                right: 0,
                bottom: scene.applyScale(0),
                top: scene.applyScale(10)
            }
        });
    }
    buildAndEnrichData() {
        this._allNfts = [];
        while(this._tableData && this._tableData.length > 0)this._tableData.pop();
        this._tableData = undefined;
        const local_sw_genesis_count = this._nftData.filter((nft)=>nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.sw_genesis).length;
        const local_sw_generative_count = this._nftData.filter((nft)=>nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.sw_generative).length;
        const local_ga_genesis_count = this._nftData.filter((nft)=>nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.ga_genesis).length;
        const local_ga_generative_count = this._nftData.filter((nft)=>nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.ga_generative_old || nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.ga_generative_new).length;
        const local_ga_monkes_count = this._nftData.filter((nft)=>nft.collection_slug === $613d865b5c232b60$var$collectionSlugs.ga_monkes).length;
        const numPages = this._totalNftCount === 0 ? 1 : Math.ceil(this._totalNftCount / $613d865b5c232b60$var$pageSize);
        if (local_sw_genesis_count > 0 || this._currentPage === numPages && this._stakingInfo.sw_genesis_count === 0) this.processCollection("Star Wolvez Genesis", $613d865b5c232b60$var$collectionSlugs.sw_genesis, $613d865b5c232b60$var$defaultCollectionImage.sw_genesis, 50, $613d865b5c232b60$var$collectionUrls.sw_genesis);
        if (local_sw_generative_count > 0 || this._currentPage === numPages && this._stakingInfo.sw_generative_count === 0) this.processCollection("Star Wolvez", $613d865b5c232b60$var$collectionSlugs.sw_generative, $613d865b5c232b60$var$defaultCollectionImage.sw_generative, 5, $613d865b5c232b60$var$collectionUrls.sw_generative);
        if (local_ga_genesis_count > 0 || this._currentPage === numPages && this._stakingInfo.ga_genesis_count === 0) this.processCollection("Galactic Apes Genesis", $613d865b5c232b60$var$collectionSlugs.ga_genesis, $613d865b5c232b60$var$defaultCollectionImage.ga_genesis, 8, $613d865b5c232b60$var$collectionUrls.ga_genesis);
        if (local_ga_generative_count > 0 || this._currentPage === numPages && this._stakingInfo.ga_generative_count === 0) this.processCollection("Galactic Apes", [
            $613d865b5c232b60$var$collectionSlugs.ga_generative_new,
            $613d865b5c232b60$var$collectionSlugs.ga_generative_old
        ], $613d865b5c232b60$var$defaultCollectionImage.ga_generative, 2, $613d865b5c232b60$var$collectionUrls.ga_generative);
        if (local_ga_monkes_count > 0 || this._currentPage === numPages && this._stakingInfo.galactic_monkes === 0) this.processCollection("Galactic Monkes", $613d865b5c232b60$var$collectionSlugs.ga_monkes, $613d865b5c232b60$var$defaultCollectionImage.ga_monkes, 1, $613d865b5c232b60$var$collectionUrls.ga_monkes);
        // Combine all collections for table data
        this._tableData = this._allNfts;
    }
    processCollection(collectionName, collectionSlug, defaultImage, dailyYield, url) {
        var filteredNfts = [];
        if (typeof collectionSlug === "string") filteredNfts = this._nftData.filter((nft)=>nft.collection_slug === collectionSlug);
        else if (Array.isArray(collectionSlug)) filteredNfts = this._nftData.filter((nft)=>collectionSlug.includes(nft.collection_slug));
        filteredNfts.forEach((fn)=>fn.daily_yield = dailyYield);
        let perDay = 0;
        let count = 0;
        const si = this._stakingInfo;
        const switchSlug = Array.isArray(collectionSlug) ? collectionSlug[0] : collectionSlug;
        switch(switchSlug){
            case $613d865b5c232b60$var$collectionSlugs.sw_generative:
                count = si.sw_generative_count;
                perDay = si.sw_generative_count * 5;
                break;
            case $613d865b5c232b60$var$collectionSlugs.sw_genesis:
                count = si.sw_genesis_count;
                perDay = si.sw_genesis_count * 50;
                break;
            case $613d865b5c232b60$var$collectionSlugs.ga_generative_old:
                count = si.ga_generative_count;
                perDay = si.ga_generative_count * 2;
                break;
            case $613d865b5c232b60$var$collectionSlugs.ga_generative_new:
                count = si.ga_generative_count;
                perDay = si.ga_generative_count * 2;
                break;
            case $613d865b5c232b60$var$collectionSlugs.ga_genesis:
                count = si.ga_genesis_count;
                perDay = si.ga_genesis_count * 8;
                break;
            case $613d865b5c232b60$var$collectionSlugs.ga_monkes:
                count = si.galactic_monkes;
                perDay = si.galactic_monkes * 1;
                break;
        }
        filteredNfts.forEach((nft)=>{
            nft.itemType = $613d865b5c232b60$var$itemTypes.nft;
            nft.daily_yield = dailyYield;
            if (this.getTimeBeforeStaked(nft) === 0) nft.isStaked = true;
            else nft.isStaked = false;
        });
        if (filteredNfts.length !== 0) {
            this.sortCollectionByUnstaked(filteredNfts);
            const header = {
                collection_name: collectionName,
                itemType: $613d865b5c232b60$var$itemTypes.header,
                count: count,
                perDay: perDay
            };
            filteredNfts.unshift(header);
        } else {
            filteredNfts[0] = {
                collection_name: collectionName,
                itemType: $613d865b5c232b60$var$itemTypes.header,
                count: count,
                perDay: perDay
            };
            filteredNfts[1] = {
                collection_name: collectionName,
                itemType: $613d865b5c232b60$var$itemTypes.default,
                daily_yield: dailyYield,
                image_key: defaultImage,
                url: url
            };
        }
        this._allNfts = this._allNfts.concat(filteredNfts);
    }
    sortCollectionByUnstaked(data) {
        data.sort((a, b)=>{
            const timeA = this.getTimeBeforeStaked(a);
            const timeB = this.getTimeBeforeStaked(b);
            if (timeA > timeB) return -1;
            if (timeB > timeA) return 1;
            return 1;
        });
    }
    getTimeBeforeStaked(nft) {
        const now = Math.floor(Date.now() / 1000);
        const timeSpan = !nft.purchased_time ? 0 : now - nft.purchased_time;
        const timeRemaining = $613d865b5c232b60$var$stakingWaitPeriod - timeSpan;
        return timeRemaining >= 0 ? timeRemaining : 0;
    }
    setWolvezData(nftData) {
        if (nftData) this._nftData = nftData;
    }
    fetchNftData(startIndex) {
        return (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfo(undefined, Object.values($613d865b5c232b60$var$collectionSlugs), startIndex, $613d865b5c232b60$var$pageSize, true).then((res)=>{
            this._nftData = res.nfts;
            return this._nftData;
        });
    }
    updatePage(pageNum) {
        this._currentPage = pageNum;
        this.refreshPane(true);
    }
    refreshPane(isPageUpdate) {
        var _a;
        const oldNfts = this._nftData.filter((nft)=>nft !== undefined);
        // Remove Table
        this.removeTable();
        // Remove pagination controls if only 1 page of data
        if (!isPageUpdate) this.removePaginationButtons();
        // Add loading indicator
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this.scene, 0, 0, 0.8 * this._scale);
        this.add(this._loadingIndicator, {
            key: "loading_indicator",
            padding: {
                left: this.scene.applyScale(255),
                right: 0,
                bottom: 0,
                top: this.scene.applyScale(100)
            }
        });
        (_a = this._parentSizer) === null || _a === void 0 || _a.layout();
        this.fetchNftData((this._currentPage - 1) * $613d865b5c232b60$var$pageSize).then(()=>{
            // Load new nft images and remove old nft images
            this.scene.scene.launch("NftPageLoaderScene", {
                originating_scene: "ObjectivesModalScene",
                nfts: this._nftData,
                old_nfts: oldNfts
            });
        });
    }
    onPageLoaded() {
        var _a;
        this._loadingIndicator.setAlpha(0);
        this.remove(this._loadingIndicator, true);
        this._loadingIndicator = undefined;
        (_a = this._pagingControls) === null || _a === void 0 || _a.enableButtons();
        if (this._totalNftCount > $613d865b5c232b60$var$pageSize && !this._pagingControls) this.addPagingButtons(this.scene);
        // Create Table
        this.buildAndEnrichData();
        this.createTable(this.scene, this._tableData, 0, 0);
    }
    removeTable() {
        var _a;
        // Remove table if it exists
        (_a = this._table) === null || _a === void 0 || _a.setAlpha(0);
        this.remove(this._table, true);
        this._table = undefined;
    }
    removePaginationButtons() {
        if (this._pagingControls) {
            this._pagingControls.setAlpha(0);
            this.remove(this._pagingControls, true);
            this._pagingControls = undefined;
        }
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("stakingWolvezContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $613d865b5c232b60$export$2e2bcd8739ae039(this.scene, x, y));
});


const $50b1dcc97fcf268f$var$imageKeys = {
    openDailyChestButton: "open_daily_chest_button"
};
const $50b1dcc97fcf268f$var$paneWidth = 660;
const $50b1dcc97fcf268f$var$paneHeight = 595;
const $50b1dcc97fcf268f$var$stakingPaneHeight = 473;
const $50b1dcc97fcf268f$var$wolvezPaneOffsetY = 27;
const $50b1dcc97fcf268f$var$stakingPaneOffsetY = 119;
const $50b1dcc97fcf268f$var$dividerOffsetY = 115;
class $50b1dcc97fcf268f$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, parentSizer, config){
        const conf = config ? config : {
            x: x,
            y: y,
            width: $50b1dcc97fcf268f$var$paneWidth * paneScale,
            height: $50b1dcc97fcf268f$var$paneHeight * paneScale,
            scrollMode: 0,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            }
        };
        super(scene, conf);
        this._scale = paneScale;
        this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._parentSizer = parentSizer || this;
        // this.layout();
        this.createComponent();
    }
    createComponent() {
        const scene = this.scene;
        // Staking Header Pane
        this._stakingHeaderContentPane = scene.add.existing(new (0, $95e3c95bd808ad60$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, $50b1dcc97fcf268f$var$paneWidth));
        this._parentSizer.add(this._stakingHeaderContentPane, {
            key: "staking_header_content_pane",
            align: "left-top",
            offsetX: scene.applyScale(251),
            offsetY: scene.applyScale($50b1dcc97fcf268f$var$wolvezPaneOffsetY),
            expand: true
        }).layout();
        // Divider
        this.add(scene.add.image(0, 0, "objectives_divider_line"), {
            key: "staking_divider",
            align: "left-top",
            offsetX: scene.applyScale(-3),
            offsetY: scene.applyScale($50b1dcc97fcf268f$var$dividerOffsetY),
            expand: false
        }).setScale(this._scale);
        // Staking Content Pane
        this._stakingContentPane = new (0, $613d865b5c232b60$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, $50b1dcc97fcf268f$var$paneWidth, $50b1dcc97fcf268f$var$stakingPaneHeight, this);
        //this._stakingContentPane = new StakingContentPane(scene, 0, 0, this._scale, paneWidth, stakingPaneHeight);
        this.add(this._stakingContentPane, {
            key: "staking_content_pane",
            align: "left-top",
            offsetX: 0,
            offsetY: scene.applyScale($50b1dcc97fcf268f$var$stakingPaneOffsetY),
            expand: false
        });
        // Layout Sizer
        this.layout();
    }
    getStakingPane() {
        return this._stakingContentPane;
    }
    getWolvezPane() {
        return this._stakingHeaderContentPane;
    }
    setOpenAllEnabled() {
        this._stakingHeaderContentPane.setOpenAllEnabled();
    }
    updatePage(pageNum) {
        this._stakingContentPane.updatePage(pageNum);
    }
    onPageLoaded() {
        this._stakingContentPane.onPageLoaded();
    }
    destroy() {
        this._parentSizer.remove(this._stakingHeaderContentPane, true);
        this._stakingHeaderContentPane = undefined;
        this.remove(this._stakingContentPane, true);
        this._stakingContentPane = undefined;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("objectivesStakingPane", function(scene, x, y) {
    // @ts-ignore
    return this.displayList.add(new $50b1dcc97fcf268f$export$2e2bcd8739ae039(scene, x, y));
});












const $a34f2ed8bb10d589$var$paneHeight = 90;
const $a34f2ed8bb10d589$var$refillTextColor = 0xa3a3b9;
class $a34f2ed8bb10d589$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, objectiveType, paneWidth, config){
        let conf = config ? config : {
            width: paneWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._objectiveType = objectiveType;
        this._paneWidth = paneWidth;
        this.createComponent(scene, x, y);
    }
    createComponent(scene, x, y) {
        // Sizer
        var sizerPanel = scene.rexUI.add.overlapSizer({
            width: this.applyScale(this._paneWidth),
            height: this.applyScale($a34f2ed8bb10d589$var$paneHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        this._title = scene.add.bitmapText(0, 0, "cc_outline", this.getHeaderTitle(), this.applyScale(22), 1);
        sizerPanel.add(this._title, {
            key: "title-text",
            align: "left-top",
            offsetX: this.applyScale(16),
            offsetY: this.applyScale(0),
            expand: false
        });
        // Claim Countdown Timer
        if (this._objectiveType.includes("battle_pass")) {
            this._countdownTimer = scene.add.bitmapText(0, 0, "cc_outline", "Quests refresh in 0h 0m", this.applyScale(16), 1).setOrigin(1, 0.5).setTint($a34f2ed8bb10d589$var$refillTextColor);
            sizerPanel.add(this._countdownTimer, {
                key: "countdown-timer-text",
                align: "right-top",
                offsetX: this.applyScale(-16),
                offsetY: this.applyScale(6),
                expand: false
            });
        }
        this.add(sizerPanel, {
            key: "sizer-panel",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this.layout();
        this.updateTimeHandler();
    // scene.time.addEvent({
    //   delay: 15000, //1 minute
    //   loop: true,
    //   callback: () => {
    //     this.updateTimeHandler();
    //   },
    // });
    }
    applyScale(length) {
        return this.scene.applyScale(length);
    }
    updateTimeHandler() {
        if (this._objectiveType.includes("battle_pass")) {
            var timerString = "";
            if (this._objectiveType === "battle_pass_daily") timerString = this.calculateTimeDifference(this.getNextDayString());
            else if (this._objectiveType === "battle_pass_weekly") timerString = this.calculateTimeDifference((0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getWeeklyObjectivesSync()[0].week_end_date);
            else timerString = this.calculateTimeDifference((0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getMonthlyObjectivesSync()[0].month_end_date);
            this._countdownTimer.setText(timerString);
        }
    }
    getHeaderTitle() {
        switch(this._objectiveType){
            case "quick_quests":
                return "Quick Quests";
            case "partner_quests":
                return "Partner Quests";
            case "milestones":
                return "Milestones";
            case "battle_pass_daily":
                return "Battle Pass Daily Quests";
            case "battle_pass_weekly":
                return "Battle Pass Weekly Quests";
            case "battle_pass_monthly":
                return "Battle Pass Monthly Quests";
        }
    }
    getNextDayString() {
        const nextDay = new Date();
        nextDay.setUTCHours(0, 0, 0, 0);
        nextDay.setUTCDate(nextDay.getUTCDate() + 1);
        const year = nextDay.getUTCFullYear();
        const month = String(nextDay.getUTCMonth() + 1).padStart(2, "0");
        const day = String(nextDay.getUTCDate()).padStart(2, "0");
        const hours = "00";
        const minutes = "00";
        const seconds = "00";
        const nextDayString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return nextDayString;
    }
    calculateTimeDifference(endTimeString) {
        const endTime = new Date(endTimeString + " UTC");
        const currentTime = new Date();
        const timeDifference = endTime.getTime() - currentTime.getTime();
        // Calculate days, hours, and minutes
        const daysRemaining = Math.floor(timeDifference / 86400000);
        const hoursRemaining = Math.floor(timeDifference % 86400000 / 3600000);
        const minutesRemaining = Math.floor(timeDifference % 3600000 / 60000);
        return `Quests refresh in ${daysRemaining}d ${hoursRemaining}h ${minutesRemaining}m`;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("objectivesHeaderContentPane", function(x, y) {
    // @ts-ignore
    return this.displayList.add(new $a34f2ed8bb10d589$export$2e2bcd8739ae039(this.scene, x, y));
});







const $e6c59525c0a580d2$var$paneWidth = 660;
const $e6c59525c0a580d2$var$paneHeight = 515;
const $e6c59525c0a580d2$var$completedItemColor = 0xa6ffc4;
const $e6c59525c0a580d2$var$cellWidth = 630;
const $e6c59525c0a580d2$var$cellHeight = 69;
const $e6c59525c0a580d2$var$cellRadius = 8;
const $e6c59525c0a580d2$var$cellBgColor = 0x262637;
const $e6c59525c0a580d2$var$cellAlpha = 1;
const $e6c59525c0a580d2$var$verticalCellPadding = 13;
const $e6c59525c0a580d2$var$horizontalCellPadding = 13;
const $e6c59525c0a580d2$var$currencyColors = {
    neon_gold: 0xffe100,
    space_elixir: 0x00d4f7,
    stardust: 0xff87ac,
    xp: 0xa6ffc4
};
const $e6c59525c0a580d2$var$objectiveTypes = {
    staking: "staking",
    quick_quests: "quick_quests",
    partner_quests: "partner_quests",
    milestones: "milestones"
};
const $e6c59525c0a580d2$var$battlepassObjectiveTypes = {
    battle_pass_daily: "battle_pass_daily",
    battle_pass_weekly: "battle_pass_weekly",
    battle_pass_monthly: "battle_pass_monthly"
};
class $e6c59525c0a580d2$export$2e2bcd8739ae039 extends (0, $92d11076da36f893$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, objectiveType, paneWidth, paneHeight, config){
        let conf = config ? config : {
            width: paneWidth * paneScale,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 2,
            sizerEvents: true
        };
        super(scene, x, y, conf);
        this._scale = paneScale;
        this._objectiveType = objectiveType;
        this.createComponent(scene);
    }
    createComponent(scene) {
        if (Object.keys($e6c59525c0a580d2$var$battlepassObjectiveTypes).includes(this._objectiveType)) this._objectives = this.sortObjectives(this.getBattlepassObjectives());
        else {
            this._objectives = (0, $643405a524e0a7c6$export$2e2bcd8739ae039).getInstance().getObjectivesSync();
            this._objectives = this.sortObjectives(this.filterObjectivesData());
        }
        this._table = this.createTable(scene, this._objectives, 0, 0).layout();
        this.add(this._table, {
            key: "objectives_table",
            padding: {
                right: 0,
                left: 0,
                top: 0,
                bottom: 0
            }
        });
    }
    createTable(scene, data, x, y) {
        if (!data || data.lenght === 0) return;
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: scene.applyScale($e6c59525c0a580d2$var$cellWidth),
            height: scene.applyScale(($e6c59525c0a580d2$var$cellHeight + 10) * data.length > $e6c59525c0a580d2$var$paneHeight ? $e6c59525c0a580d2$var$paneHeight : ($e6c59525c0a580d2$var$cellHeight + 10) * data.length + 5),
            items: data,
            table: {
                cellWidth: scene.applyScale($e6c59525c0a580d2$var$cellWidth),
                cellHeight: scene.applyScale($e6c59525c0a580d2$var$cellHeight + 10),
                columns: 1,
                clamplTableOXY: false,
                scrollMode: 0,
                mask: {
                    padding: 2
                }
            },
            space: {
                top: scene.applyScale(3),
                bottom: scene.applyScale(3),
                table: {
                    top: scene.applyScale(11),
                    bottom: scene.applyScale(11)
                }
            },
            mouseWheelScroller: {
                focus: false,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var _a, _b, _c, _d, _e, _f;
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                const rewardString = item.currency === "xp" ? `${(_a = item.reward) === null || _a === void 0 ? void 0 : _a.toLocaleString("en-US")} XP` : (_b = item.reward) === null || _b === void 0 ? void 0 : _b.toLocaleString("en-US");
                var sizer = scene.rexUI.add.overlapSizer(0, 0, {
                    width: scene.applyScale($e6c59525c0a580d2$var$cellWidth),
                    height: scene.applyScale($e6c59525c0a580d2$var$cellHeight),
                    space: {
                        left: scene.applyScale($e6c59525c0a580d2$var$horizontalCellPadding),
                        right: scene.applyScale($e6c59525c0a580d2$var$horizontalCellPadding),
                        top: scene.applyScale($e6c59525c0a580d2$var$verticalCellPadding),
                        bottom: scene.applyScale($e6c59525c0a580d2$var$verticalCellPadding - 2),
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).addBackground(scene.rexUI.add.roundRectangle(0, 0, scene.applyScale($e6c59525c0a580d2$var$cellWidth), scene.applyScale($e6c59525c0a580d2$var$cellHeight), scene.applyScale($e6c59525c0a580d2$var$cellRadius), $e6c59525c0a580d2$var$cellBgColor, $e6c59525c0a580d2$var$cellAlpha), {}, "obj_bg").add(scene.add.bitmapText(0, 0, "cc_outline", item.title, scene.applyScale(18), 0), {
                    key: "title_text",
                    align: "left-top",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", item.description, scene.applyScale(16), 0).setAlpha(0.6), {
                    key: "description_text",
                    align: "left-bottom",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.rexUI.add.label({
                    height: scene.applyScale(24),
                    orientation: "x",
                    rtl: true,
                    icon: item.currency === "xp" ? undefined : scene.add.image(0, 0, `${item.currency}_icon`).setScale(scene.applyScale(0.45)),
                    text: scene.add.bitmapText(0, 0, "cc_outline", rewardString, scene.applyScale(18), 0).setCharacterTint(0, rewardString.length, true, $e6c59525c0a580d2$var$currencyColors[item.currency]),
                    space: {
                        icon: 4
                    }
                }), {
                    key: "reward_label",
                    align: "right-top",
                    offsetX: item.currency === "xp" ? scene.applyScale(0) : scene.applyScale(5),
                    offsetY: -2,
                    expand: false
                }).add(scene.add.bitmapText(0, 0, "cc_outline", `${((_d = (_c = item.action) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toLocaleString("en-us")) || 0} of ${((_f = (_e = item.action) === null || _e === void 0 ? void 0 : _e.target_value) === null || _f === void 0 ? void 0 : _f.toLocaleString("en-us")) || 1}`, scene.applyScale(18), 0).setAlpha(0.6), {
                    key: "progress_text",
                    align: "right-bottom",
                    offsetX: 0,
                    offsetY: scene.applyScale(1),
                    expand: false
                });
                function addObjectiveActionDisplay(scene, sizer, item, x, y) {
                    // Show 'Completed' label if objective is completed
                    if (item.status === "complete") {
                        addCompletedDisplay(scene, sizer, item, x, y);
                        return;
                    }
                    switch(item.action.type){
                        case "connect":
                            addConnectActionDisplay(scene, sizer, item, x, y);
                            break;
                        case "count":
                            break;
                        case "twitter":
                            addTwitterActionDisplay(scene, sizer, item, x, y);
                            break;
                        case "link":
                            addLinkActionDisplay(scene, sizer, item, x, y);
                            break;
                        case "medium":
                            addLinkActionDisplay(scene, sizer, item, x, y);
                            break;
                        case "youtube":
                            addLinkActionDisplay(scene, sizer, item, x, y);
                            break;
                    }
                }
                function addConnectActionDisplay(scene, sizer, item, x, y) {
                    let connectButton;
                    switch(item.action.sub_type){
                        case "discord":
                            connectButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_connect_button", true, 1.05);
                            connectButton.onClick().subscribe((pointer)=>{
                            //ObjectiveService.getInstance().handleDiscordConnectAction(pointer);
                            });
                            break;
                        case "metamask":
                            let fixedItem = {};
                            fixedItem = Object.assign(fixedItem, item);
                            fixedItem.action = {
                                type: "count",
                                sub_type: "consecutive_days",
                                target: "login",
                                target_value: item.action.target_value,
                                value: item.action.value
                            };
                            break;
                    }
                    if (connectButton) {
                        scene.add.existing(connectButton.setScale(scene.getScale()));
                        sizer.add(connectButton, {
                            key: "connect_button",
                            align: "right-center",
                            offsetX: scene.applyScale(-90),
                            offsetY: 0,
                            expand: false
                        });
                    }
                }
                function addTwitterActionDisplay(scene, sizer, item, x, y) {
                    var _a;
                    var twitterButton;
                    switch((_a = item.action.sub_type) === null || _a === void 0 ? void 0 : _a.toLowerCase()){
                        case "follow":
                            twitterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_follow_button", true, 1.05);
                            twitterButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                        case "rt":
                            twitterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_retweet_button", true, 1.05);
                            twitterButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                        case "tweet":
                            twitterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_tweet_button", true, 1.05);
                            twitterButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                        case "like":
                            twitterButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_like_button", true, 1.05);
                            twitterButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                    }
                    if (twitterButton) {
                        scene.add.existing(twitterButton.setScale(scene.getScale()));
                        sizer.add(twitterButton, {
                            key: `twitter_button`,
                            align: "right-center",
                            offsetX: scene.applyScale(-90),
                            offsetY: 0,
                            expand: false
                        });
                    }
                }
                function addLinkActionDisplay(scene, sizer, item, x, y) {
                    var linkButton;
                    switch(item.action.sub_type){
                        case "read":
                            linkButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_read_button", false);
                            linkButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                        case "watch":
                            linkButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_view_button", false);
                            linkButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                        default:
                            linkButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(scene, 0, 0, "objective_open_button", false);
                            linkButton.onClick().subscribe((pointer)=>{
                                handleLinkAction(scene, sizer, item, x, y);
                            });
                            break;
                    }
                    if (linkButton) {
                        scene.add.existing(linkButton.setScale(scene.getScale()));
                        sizer.add(linkButton, {
                            key: `link_button`,
                            align: "right-center",
                            offsetX: scene.applyScale(-90),
                            offsetY: 0,
                            expand: false
                        });
                    }
                }
                function addCompletedDisplay(scene, sizer, item, x, y) {
                    sizer.add(scene.add.bitmapText(0, 0, "cc_outline", "Completed", scene.applyScale(18), 0).setCharacterTint(0, 9, true, $e6c59525c0a580d2$var$completedItemColor), {
                        key: "completed_text_label",
                        align: "right-center",
                        offsetX: scene.applyScale(-90),
                        offsetY: 0,
                        expand: false
                    });
                    disableObjective(sizer, item);
                }
                function setComplete(scene, item, newActionValue) {
                    return (0, $643405a524e0a7c6$export$2e2bcd8739ae039).getInstance().updateObjective(item.objective_id, newActionValue).then((res)=>{
                        scene.events.emit("objective_completed");
                    });
                }
                function disableObjective(sizer, item) {
                    sizer.setAlpha(0.6);
                }
                function getTextAlpha(nftCount) {
                    return 1; // nftCount === 0 ? 0.6 : 1;
                }
                function handleLinkAction(scene, sizer, item, x, y) {
                    var _a;
                    (_a = window.open(item.action.target, "_blank")) === null || _a === void 0 || _a.focus();
                    const newActionValue = 1;
                    return setComplete(scene, item, newActionValue);
                }
                addObjectiveActionDisplay(scene, sizer, item, x, y);
                return sizer.layout();
            }
        });
        table.setItems(data).scrollToTop();
        return table;
    }
    filterObjectivesData() {
        const partnerQuests = this._objectives.filter((obj)=>obj.action.sub_type === "NFTs" && obj.action.target !== "Star Wolvez" && obj.action.target !== "Star Wolvez Genesis");
        const milestones = this._objectives.filter((obj)=>obj.action.type === "count" && (obj.action.sub_type !== "NFTs" || obj.action.target === "Star Wolvez" || obj.action.target === "Star Wolvez Genesis") || obj.action.sub_type === "level");
        switch(this._objectiveType){
            case $e6c59525c0a580d2$var$objectiveTypes.partner_quests:
                return partnerQuests;
            case $e6c59525c0a580d2$var$objectiveTypes.milestones:
                return milestones;
            case $e6c59525c0a580d2$var$objectiveTypes.quick_quests:
                return this._objectives.filter((obj)=>{
                    return !partnerQuests.map((pq)=>pq.objective_id).includes(obj.objective_id) && !milestones.map((ms)=>ms.objective_id).includes(obj.objective_id);
                });
            default:
                return [];
        }
    }
    sortObjectives(objectives) {
        return objectives.sort((a, b)=>{
            const aComplete = a.status === "complete";
            const bComplete = b.status === "complete";
            if (!aComplete && bComplete) return -1;
            if (aComplete && !bComplete) return 1;
            return 1;
        });
    }
    getBattlepassObjectives() {
        var objectives = [];
        var objectiveType = "";
        switch(this._objectiveType){
            case $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_daily:
                objectives = (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getDailyObjectivesSync();
                objectiveType = $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_daily;
                break;
            case $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_weekly:
                objectives = (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getWeeklyObjectivesSync();
                objectiveType = $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_weekly;
                break;
            case $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_monthly:
                objectives = (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getMonthlyObjectivesSync();
                objectiveType = $e6c59525c0a580d2$var$battlepassObjectiveTypes.battle_pass_monthly;
                break;
            default:
                objectives = [];
        }
        const finalObjs = objectives.map((obj)=>{
            return {
                objective_id: obj.objective_id,
                title: obj.name,
                description: obj.description,
                type: "beginner",
                currency_id: 1,
                action: {
                    value: obj.num_completed,
                    target: "",
                    sub_type: "none",
                    target_value: obj.completion_number,
                    type: "count"
                },
                status: obj.is_completed === 1 ? "complete" : "incomplete",
                currency: "xp",
                check_on_login: 0,
                objective_outcome_id: 0,
                reward: obj.xp_reward
            };
        });
        return finalObjs;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("objectivesListContentPane", function(x, y, objectivesData) {
    // @ts-ignore
    return this.displayList.add(new $e6c59525c0a580d2$export$2e2bcd8739ae039(this.scene, x, y, objectivesData));
});


const $7191836ad557c4e4$var$paneWidth = 660;
const $7191836ad557c4e4$var$paneHeight = 595;
const $7191836ad557c4e4$var$stakingPaneHeight = 473;
const $7191836ad557c4e4$var$headerPaneOffsetY = 27;
const $7191836ad557c4e4$var$objectiveListPaneOffsetY = 80;
const $7191836ad557c4e4$var$dividerOffsetY = 70;
class $7191836ad557c4e4$export$2e2bcd8739ae039 extends (0, $4d318a74c42de65b$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, objectiveType, parentSizer, config){
        const conf = config ? config : {
            x: x,
            y: y,
            width: $7191836ad557c4e4$var$paneWidth * paneScale,
            height: $7191836ad557c4e4$var$paneHeight * paneScale,
            scrollMode: 0,
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            }
        };
        super(scene, conf);
        this._scale = paneScale;
        this._userData = (0, $bd40851b9a4501c3$export$2e2bcd8739ae039).getInstance().getUserDataSync();
        this._parentSizer = parentSizer || this;
        this._objectiveType = objectiveType;
        // this.layout();
        this.createComponent();
    }
    createComponent() {
        const scene = this.scene;
        // Objectives Header Pane
        this._objectiveHeaderContentPane = scene.add.existing(new (0, $a34f2ed8bb10d589$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, this._objectiveType, $7191836ad557c4e4$var$paneWidth));
        this._parentSizer.add(this._objectiveHeaderContentPane, {
            key: "objective_header_content_pane",
            align: "left-top",
            offsetX: scene.applyScale(251),
            offsetY: scene.applyScale($7191836ad557c4e4$var$headerPaneOffsetY),
            expand: true
        }).layout();
        // Divider
        this.add(scene.add.image(0, 0, "objectives_divider_line"), {
            key: "staking_divider",
            align: "left-top",
            offsetX: scene.applyScale(-3),
            offsetY: scene.applyScale($7191836ad557c4e4$var$dividerOffsetY),
            expand: false
        }).setScale(this._scale);
        // Objectives List Pane
        this._objectiveListContentPane = new (0, $e6c59525c0a580d2$export$2e2bcd8739ae039)(scene, 0, 0, this._scale, this._objectiveType, $7191836ad557c4e4$var$paneWidth);
        this.add(this._objectiveListContentPane, {
            key: "objective_list_content_pane",
            align: "left-top",
            offsetX: 0,
            offsetY: scene.applyScale($7191836ad557c4e4$var$objectiveListPaneOffsetY),
            expand: false
        });
        // Layout Sizer
        this.layout();
    }
    getObjectiveHeaderPane() {
        return this._objectiveHeaderContentPane;
    }
    getObjectiveListPane() {
        return this._objectiveListContentPane;
    }
    destroy() {
        this._parentSizer.remove(this._objectiveHeaderContentPane, true);
        this._objectiveHeaderContentPane = undefined;
        this.remove(this._objectiveListContentPane, true);
        this._objectiveListContentPane = undefined;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("objectivesContentPane", function(scene, x, y) {
    // @ts-ignore
    return this.displayList.add(new $7191836ad557c4e4$export$2e2bcd8739ae039(scene, x, y));
});



var $b1e253ff07cc6bd1$exports = {};
$b1e253ff07cc6bd1$exports = new URL("open-all-button.7b28754b.wav", import.meta.url).toString();


const $84d0697387ac85be$var$Random = (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Math.Between;
const $84d0697387ac85be$var$modalHeight = 595;
const $84d0697387ac85be$var$modalWidth = 914;
const $84d0697387ac85be$var$modalRadius = 25;
const $84d0697387ac85be$var$modalColor = 0x1c1c2c;
const $84d0697387ac85be$var$modalAlpha = 1;
const $84d0697387ac85be$var$spineWidth = 248;
const $84d0697387ac85be$var$spineColor = 0xe6e6ff;
const $84d0697387ac85be$var$spineAlpha = 0.05;
const $84d0697387ac85be$var$stakingCollectionNames = [
    "starwolvez-generative",
    "starwolves",
    "gapes-nft",
    "galacticapes",
    "galacticapesgenesis",
    "galacticmonkes"
];
class $84d0697387ac85be$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userData = data.userData;
    }
    constructor(){
        super({
            key: "ObjectivesModalScene"
        });
    }
    preload() {
        (0, $e29d3e9b5d8af317$export$f0c7b4edffcddede)(this, (0, $1aa2c39fc1fbb95e$export$77e9ad0d5b42a6f9));
        this.load.image("army_modal_close_button", (0, $1aa2c39fc1fbb95e$export$bef64b52259dad30).army_modal_close_button);
        this.load.audio("open-all-button", $b1e253ff07cc6bd1$exports);
    }
    create() {
        this.createComponent();
        (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().getObjectives(true).then((res)=>{
            (0, $e12b36903093d20d$export$2e2bcd8739ae039).getInstance().getStakingInfo(undefined, $84d0697387ac85be$var$stakingCollectionNames, 0, 30, true).then((res)=>{
                this.scene.launch("NftLoaderScene", {
                    originating_scene: "ObjectivesModalScene",
                    nfts: res.nfts
                });
            });
        });
    }
    createComponent() {
        this.input.topOnly = false;
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($84d0697387ac85be$var$modalWidth, $84d0697387ac85be$var$modalHeight);
        this._objectiveTypes = (0, $643405a524e0a7c6$export$2e2bcd8739ae039).getInstance().getObjectiveTypes();
        this._sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
            width: this.applyScale($84d0697387ac85be$var$modalWidth),
            height: this.applyScale($84d0697387ac85be$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            sizerEvents: true
        });
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Modal Background
        const background = this.add.rexRoundRectangle(0, 0, this.applyScale($84d0697387ac85be$var$modalWidth), this.applyScale($84d0697387ac85be$var$modalHeight), this.applyScale($84d0697387ac85be$var$modalRadius), $84d0697387ac85be$var$modalColor, $84d0697387ac85be$var$modalAlpha);
        this._sizer.addBackground(background, {
            key: "background"
        });
        const spineBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($84d0697387ac85be$var$spineWidth), this.applyScale($84d0697387ac85be$var$modalHeight), {
            tl: this.applyScale($84d0697387ac85be$var$modalRadius),
            tr: 0,
            bl: this.applyScale($84d0697387ac85be$var$modalRadius),
            br: 0
        }, $84d0697387ac85be$var$spineColor, $84d0697387ac85be$var$spineAlpha);
        // Title text
        const titleText = this.add.image(0, 0, "objectives_text").setOrigin(0).setScale(this._scale);
        // Add spine here
        this._spineTable = this.createSpineTable(this, this._objectiveTypes, 0, 0);
        this._closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this.scene.scene, 0, 0, "army_modal_close_button", false).setScale(this._scale);
        this.add.existing(this._closeButton);
        this._closeButton.onClick().subscribe((pointer)=>{
            this.closeButtonClickHandler(pointer);
        });
        this._sizer.add(spineBackground, {
            key: "spineBackground",
            align: "left-top",
            offsetX: 0,
            offsetY: 0,
            expand: false
        });
        this._sizer.add(titleText, {
            key: "titleText",
            align: "left-top",
            offsetX: this.applyScale(17),
            offsetY: this.applyScale(31),
            expand: false
        });
        this._sizer.add(this._spineTable, {
            key: "table",
            align: "left-top",
            offsetX: this.applyScale(15),
            offsetY: this.applyScale(60),
            expand: false
        });
        this._sizer.add(this._closeButton, {
            key: "closeButton",
            align: "left-bottom",
            offsetX: this.applyScale(14),
            offsetY: this.applyScale(-18),
            expand: false
        });
        this._loadingIndicator = new (0, $e375e881905a228b$export$2e2bcd8739ae039)(this, 0, 0, 0.8 * this._scale);
        this._sizer.add(this._loadingIndicator, {
            key: "loading_indicator",
            align: "center",
            offsetX: this.applyScale(100),
            offsetY: 0,
            expand: false
        });
        this._sizer.layout();
        this._sizer.onClickOutside(()=>{
            this.unloadAssets();
            this.scene.resume("HomebaseScene");
            this.scene.resume("HudScene");
            this.scene.stop();
        });
        this.events.on("resume", ()=>{
            if (this._stakingContentPane) {
                this._stakingContentPane.getStakingPane().updateTable(true);
                this.events.emit("staking_reward_claimed");
                this._stakingContentPane.setOpenAllEnabled();
            }
        });
    }
    onLoaded() {
        this._loadingIndicator.setAlpha(0);
        this._sizer.remove(this._loadingIndicator, true);
        this._loadingIndicator = undefined;
        this._stakingContentPane = new (0, $50b1dcc97fcf268f$export$2e2bcd8739ae039)(this, 0, 0, this._scale);
        this._sizer.add(this._stakingContentPane, {
            key: "staking-content-pane",
            align: "left-top",
            offsetX: this.applyScale(251),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._sizer.layout();
        this.setIsSelected(this._objectiveTypes[0], true);
        this._stakingContentPane.setOpenAllEnabled();
    }
    applyScale(length) {
        return length * this._scale;
    }
    getScale() {
        return this._scale;
    }
    destroy() {
        this._objectiveTypes = undefined;
        this._stakingContentPane = undefined;
        this._objectivesContentPane = undefined;
        this._closeButton = undefined;
        this._spineTable = undefined;
        this._sizer = undefined;
    }
    createSpineTable(scene, data, x, y) {
        var table = scene.rexUI.add.gridTable({
            x: x,
            y: y,
            width: this.applyScale(220),
            height: this.applyScale(450),
            items: data,
            scrollMode: 0,
            table: {
                cellWidth: this.applyScale(220),
                cellHeight: this.applyScale(32),
                columns: 1,
                clamplTableOXY: false,
                reuseCellContainer: true,
                interactive: true,
                mask: {
                    padding: 0
                }
            },
            mouseWheelScroller: {
                focus: true,
                speed: 0.2
            },
            createCellContainerCallback: function(cell) {
                var scene = cell.scene, width = cell.width, height = cell.height, item = cell.item, index = cell.index;
                // Template
                let rectConfig = {
                    maskType: "roundRectangle",
                    radius: 0
                };
                var sizer = scene.rexUI.add.overlapSizer({
                    width: scene.applyScale(220),
                    space: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        item: 0,
                        line: 0
                    },
                    align: 0,
                    sizerEvents: true
                }).setInteractive({
                    useHandCursor: true
                }).add(scene.add.rexRoundRectangle(0, 0, scene.applyScale(220), scene.applyScale(32), scene.applyScale(6), 0xe6e6ff, 0.05).setAlpha(item.isSelected ? 1 : 0), {
                    key: "menu_option_bg",
                    align: "center",
                    offsetX: 0,
                    offsetY: 0,
                    expand: false
                }).add(scene.rexUI.add.badgeLabel({
                    x: 0,
                    y: 0,
                    space: {
                        left: 0,
                        right: -5,
                        top: 0,
                        bottom: 0
                    },
                    main: scene.rexUI.add.label({
                        orientation: "x",
                        rtl: false,
                        text: scene.add.bitmapText(0, 0, "cc_outline", item.displayName, scene.applyScale(16), 0).setAlpha(item.isSelected ? 1 : 0.4),
                        space: {
                            icon: scene.applyScale(10),
                            right: scene.applyScale(25)
                        }
                    }),
                    rightCenter: item.displayName.includes("Battle Pass") ? scene.add.image(0, 0, "battle_pass_icon") : undefined
                }), {
                    key: "menu_option_text",
                    align: "left",
                    offsetX: scene.applyScale(10),
                    offsetY: scene.applyScale(0),
                    expand: false
                });
                sizer.setChildrenInteractive({
                    click: {
                        mode: "release",
                        clickInterval: 100
                    },
                    over: true,
                    tap: {
                        time: 250,
                        tapInterval: 200,
                        threshold: 9,
                        tapOffset: 10,
                        taps: undefined,
                        minTaps: undefined,
                        maxTaps: undefined
                    },
                    press: {
                        time: 251,
                        threshold: 9
                    },
                    swipe: {
                        threshold: 10,
                        velocityThreshold: 1000,
                        dir: "8dir"
                    },
                    inputEventPrefix: "child."
                });
                sizer.on("child.over", (child, pointer, event)=>{
                    var _a, _b, _c;
                    if (!item.isSelected) (_c = (_b = (_a = sizer.getElement("menu_option_text")) === null || _a === void 0 ? void 0 : _a.getElement("main")) === null || _b === void 0 ? void 0 : _b.getElement("text")) === null || _c === void 0 || _c.setAlpha(1);
                });
                sizer.on("child.out", (child, pointer, event)=>{
                    var _a, _b, _c;
                    if (!item.isSelected) (_c = (_b = (_a = sizer.getElement("menu_option_text")) === null || _a === void 0 ? void 0 : _a.getElement("main")) === null || _b === void 0 ? void 0 : _b.getElement("text")) === null || _c === void 0 || _c.setAlpha(0.4);
                });
                sizer.on("child.click", (child, pointer, event)=>{
                    scene.setIsSelected(item);
                });
                return sizer;
            }
        });
        table.setItems(data).scrollToTop();
        //table.getElement('table').on('')
        return table;
    }
    setIsSelected(item, bypassCheck) {
        if (!bypassCheck && item.isSelected === true) return;
        this._objectiveTypes = this._objectiveTypes.map((ot)=>{
            ot.isSelected = ot.displayName === item.displayName ? true : false;
            return ot;
        });
        this._spineTable.setItems(this._objectiveTypes);
        this.setContentPane(item);
    }
    setContentPane(item) {
        var contentPane;
        var paneKey;
        if (this._stakingContentPane) {
            this._stakingContentPane.setAlpha(0);
            this._sizer.remove(this._stakingContentPane, true);
            this._stakingContentPane = undefined;
        }
        if (this._objectivesContentPane) {
            this._objectivesContentPane.setAlpha(0);
            this._sizer.remove(this._objectivesContentPane, true);
            this._objectivesContentPane = undefined;
        }
        switch(item.key){
            case "staking":
                contentPane = this._stakingContentPane = new (0, $50b1dcc97fcf268f$export$2e2bcd8739ae039)(this, 0, 0, this._scale, this._sizer);
                this._stakingContentPane.updatePage(1);
                paneKey = "parent_staking_content_pane";
                break;
            default:
                contentPane = this._objectivesContentPane = new (0, $7191836ad557c4e4$export$2e2bcd8739ae039)(this, 0, 0, this._scale, item.key, this._sizer);
                paneKey = `${item.key}_content_pane`;
        }
        this._sizer.add(contentPane, {
            key: paneKey,
            align: "left-top",
            offsetX: this.applyScale(251),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._sizer.layout();
    }
    closeButtonClickHandler(pointer) {
        this.unloadAssets();
        this.scene.resume("HomebaseScene");
        this.scene.resume("HudScene");
        this.scene.stop();
    }
    updatePage(pageNum) {
        this._stakingContentPane.updatePage(pageNum);
    }
    onPageLoaded() {
        this._stakingContentPane.onPageLoaded();
    }
    unloadAssets() {
        this._objectiveTypes = this._objectiveTypes.map((ot)=>{
            ot.isSelected = ot.displayName === "Soft Staking" ? true : false;
            return ot;
        });
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this, Object.keys((0, $1aa2c39fc1fbb95e$export$77e9ad0d5b42a6f9)));
    // this._stakingContentPane.unloadImages();
    }
}










const $9df4ce3029f00965$var$blueProgressBarColor = 0x00a6d3;
const $9df4ce3029f00965$var$progressBarAlpha = 1;
const $9df4ce3029f00965$var$glareColor = 0xffffff;
const $9df4ce3029f00965$var$glareAlpha = 0.17;
const $9df4ce3029f00965$var$glareRadius = 3;
const $9df4ce3029f00965$var$glareHeight = 6;
const $9df4ce3029f00965$var$glareOffset = 10;
const $9df4ce3029f00965$var$backgroundColor = 0xb48dc7;
const $9df4ce3029f00965$var$backgroundAlpha = 0.4;
const $9df4ce3029f00965$var$radius = 7;
const $9df4ce3029f00965$var$progressBarHeight = 22;
const $9df4ce3029f00965$var$levelBarWidth = 215;
class $9df4ce3029f00965$export$2e2bcd8739ae039 extends (0, $60b229d208382899$export$2e2bcd8739ae039) {
    constructor(scene, x, y, paneScale, userData, iconScale = 0.7){
        super(scene, x, y, paneScale, {
            rtl: false,
            title: {
                text: userData.name.toString().toUpperCase(),
                fontStyle: null,
                icon: userData.has_battlepass ? "battle_pass_icon" : undefined,
                iconScale: userData.has_battlepass ? 1 : undefined,
                iconSpace: userData.has_battlepass ? 5 : undefined
            },
            icon: {
                key: "bronze_level_1_badge",
                space: 8,
                scale: iconScale
            },
            progressBar: {
                text: userData.battlepass_level.toString(),
                fontStyle: null,
                width: $9df4ce3029f00965$var$levelBarWidth,
                height: $9df4ce3029f00965$var$progressBarHeight,
                radius: $9df4ce3029f00965$var$radius,
                color: $9df4ce3029f00965$var$blueProgressBarColor,
                alpha: $9df4ce3029f00965$var$progressBarAlpha,
                backgroundColor: $9df4ce3029f00965$var$backgroundColor,
                backgroundAlpha: $9df4ce3029f00965$var$backgroundAlpha,
                minValue: 1,
                maxValue: 10,
                progressValue: userData.battlepass_xp,
                glare: {
                    height: $9df4ce3029f00965$var$glareHeight,
                    width: $9df4ce3029f00965$var$levelBarWidth - $9df4ce3029f00965$var$glareOffset,
                    radius: $9df4ce3029f00965$var$glareRadius,
                    color: $9df4ce3029f00965$var$glareColor,
                    alpha: $9df4ce3029f00965$var$glareAlpha
                }
            }
        });
        this._config = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig();
        this.setValues(scene, userData);
    }
    updateValues(scene, userData) {
        if (userData) this.setValues(scene, userData);
    }
    setValues(scene, userData) {
        var levelMinXP = this.getLevelMinXP(userData);
        var levelMaxXP = this.getLevelMaxXP(userData);
        var badgeImageKey = this.getBadgeImageKey(userData, this._config.userBadges);
        this.updateMinValue(scene, levelMinXP);
        this.updateMaxValue(scene, levelMaxXP);
        this.setProgressValue(scene, userData.battlepass_xp);
        this.setProgressBarText(userData.battlepass_level.toString());
        this.setIcon(badgeImageKey);
    }
    getLevelMinXP(userData) {
        var level = parseInt(userData.battlepass_level);
        if (level === 1) return 0;
        else return (level - 1) * 3000;
    }
    getLevelMaxXP(userData) {
        var nextLevelMaxXP = parseInt(userData.battlepass_level) * 3000;
        return nextLevelMaxXP;
    }
    getBadgeImageKey(userData, userBadges) {
        var badge = userBadges.find((ub)=>{
            if (ub.maxLevel === null) return userData.level >= ub.minLevel;
            else return userData.level >= ub.minLevel && userData.level <= ub.maxLevel;
        });
        return badge.badgeImageKey;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).GameObjects.GameObjectFactory.register("battlePassProgressBarComponent", function(x, y, userData) {
    // @ts-ignore
    return this.displayList.add(new $9df4ce3029f00965$export$2e2bcd8739ae039(this.scene, x, y, userData));
});


const $f2dc29e18a01ed95$var$modalWidth = 494;
const $f2dc29e18a01ed95$var$modalHeight = 469;
const $f2dc29e18a01ed95$var$modalRadius = 50;
const $f2dc29e18a01ed95$var$modalColor = 0x383d57;
const $f2dc29e18a01ed95$var$modalAlpha = 1;
const $f2dc29e18a01ed95$var$modalBorderColor = 0x3d4361;
const $f2dc29e18a01ed95$var$modalBorderWidth = 1;
const $f2dc29e18a01ed95$var$goldProgressBarColor = 0xdea827;
const $f2dc29e18a01ed95$var$progressBarAlpha = 1;
const $f2dc29e18a01ed95$var$glareColor = 0xffffff;
const $f2dc29e18a01ed95$var$glareAlpha = 0.14;
const $f2dc29e18a01ed95$var$glareRadius = 3;
const $f2dc29e18a01ed95$var$glareHeight = 6;
const $f2dc29e18a01ed95$var$glareOffset = 10;
const $f2dc29e18a01ed95$var$xpBarOffset = 40;
const $f2dc29e18a01ed95$var$borderWidth = 1;
const $f2dc29e18a01ed95$var$borderColor = 0x383d57;
const $f2dc29e18a01ed95$var$borderAlpha = 1;
const $f2dc29e18a01ed95$var$backgroundColor = 0x201425;
const $f2dc29e18a01ed95$var$backgroundAlpha = 0.4;
const $f2dc29e18a01ed95$var$radius = 11;
const $f2dc29e18a01ed95$var$progressBarHeight = 43;
const $f2dc29e18a01ed95$var$progressBarWidth = 240;
class $f2dc29e18a01ed95$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._userData = data.userData;
    }
    constructor(){
        super({
            key: "UserBattlePassModalScene"
        });
    }
    preload() {}
    create() {
        this.input.setDefaultCursor("default");
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($f2dc29e18a01ed95$var$modalWidth, $f2dc29e18a01ed95$var$modalHeight + 60);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($f2dc29e18a01ed95$var$modalWidth), this.applyScale($f2dc29e18a01ed95$var$modalHeight), this.applyScale($f2dc29e18a01ed95$var$modalRadius), $f2dc29e18a01ed95$var$modalColor, $f2dc29e18a01ed95$var$modalAlpha);
        modalBg.setStrokeStyle($f2dc29e18a01ed95$var$modalBorderWidth, $f2dc29e18a01ed95$var$modalBorderColor, $f2dc29e18a01ed95$var$modalAlpha);
        const badges = (0, $148681abcefc5921$export$2e2bcd8739ae039).getInstance().getConfig().userBadges;
        const levelBadgeImageKey = this.getBadgeImageKey(this._userData, badges);
        // Add Icons
        this.add.image(modalBg.getTopCenter().x, modalBg.getTopLeft().y, levelBadgeImageKey).setScale(this._scale);
        // Add sizer for content
        var sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($f2dc29e18a01ed95$var$modalWidth),
            height: this.applyScale($f2dc29e18a01ed95$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        // User level progress bar
        const userLevelBar = new (0, $9df4ce3029f00965$export$2e2bcd8739ae039)(this, 0, 0, this._scale, this._userData, 1);
        userLevelBar.setIcon("level_icon");
        sizer.add(userLevelBar, {
            align: "center-top",
            offsetX: this.applyScale(-12),
            offsetY: this.applyScale(82),
            expand: false,
            key: "user_level_bar"
        });
        // 'Total XP Earned' label
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Total Battle Pass XP Earned", this.applyScale(18), 1), {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(164),
            expand: false,
            key: "xp_earned_label"
        });
        // XP Progress Bar
        const xpBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this._userData.battlepass_xp,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $f2dc29e18a01ed95$var$borderWidth,
                color: $f2dc29e18a01ed95$var$borderColor,
                alpha: $f2dc29e18a01ed95$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $f2dc29e18a01ed95$var$progressBarWidth - $f2dc29e18a01ed95$var$xpBarOffset,
                height: $f2dc29e18a01ed95$var$progressBarHeight,
                radius: $f2dc29e18a01ed95$var$radius,
                color: $f2dc29e18a01ed95$var$goldProgressBarColor,
                alpha: $f2dc29e18a01ed95$var$progressBarAlpha,
                backgroundColor: $f2dc29e18a01ed95$var$backgroundColor,
                backgroundAlpha: $f2dc29e18a01ed95$var$backgroundAlpha,
                minValue: 0,
                maxValue: 1,
                progressValue: 0,
                glare: {
                    height: $f2dc29e18a01ed95$var$glareHeight,
                    width: $f2dc29e18a01ed95$var$progressBarWidth - $f2dc29e18a01ed95$var$xpBarOffset - $f2dc29e18a01ed95$var$glareOffset,
                    radius: $f2dc29e18a01ed95$var$glareRadius,
                    color: $f2dc29e18a01ed95$var$glareColor,
                    alpha: $f2dc29e18a01ed95$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(xpBar);
        xpBar.setProgressBarText("");
        sizer.add(xpBar, {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(194),
            expand: false,
            key: "xp_progress_bar"
        });
        // 'Battle Pass Level' label
        sizer.add(this.add.bitmapText(0, 0, "cc_outline", "Battle Pass Level", this.applyScale(18), 1), {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(284),
            expand: false,
            key: "bp_ xp_earned_label"
        });
        // XP Progress Bar
        const bpXPBar = new (0, $60b229d208382899$export$2e2bcd8739ae039)(this, 0, 0, this._scale, {
            rtl: false,
            title: {
                text: this._userData.battlepass_level,
                fontSize: 16,
                offset: 2
            },
            icon: undefined,
            border: {
                width: $f2dc29e18a01ed95$var$borderWidth,
                color: $f2dc29e18a01ed95$var$borderColor,
                alpha: $f2dc29e18a01ed95$var$borderAlpha
            },
            progressBar: {
                text: "",
                fontStyle: null,
                width: $f2dc29e18a01ed95$var$progressBarWidth - $f2dc29e18a01ed95$var$xpBarOffset,
                height: $f2dc29e18a01ed95$var$progressBarHeight,
                radius: $f2dc29e18a01ed95$var$radius,
                color: $f2dc29e18a01ed95$var$goldProgressBarColor,
                alpha: $f2dc29e18a01ed95$var$progressBarAlpha,
                backgroundColor: $f2dc29e18a01ed95$var$backgroundColor,
                backgroundAlpha: $f2dc29e18a01ed95$var$backgroundAlpha,
                minValue: 0,
                maxValue: 1,
                progressValue: 0,
                glare: {
                    height: $f2dc29e18a01ed95$var$glareHeight,
                    width: $f2dc29e18a01ed95$var$progressBarWidth - $f2dc29e18a01ed95$var$xpBarOffset - $f2dc29e18a01ed95$var$glareOffset,
                    radius: $f2dc29e18a01ed95$var$glareRadius,
                    color: $f2dc29e18a01ed95$var$glareColor,
                    alpha: $f2dc29e18a01ed95$var$glareAlpha,
                    offset: -15
                }
            }
        });
        this.add.existing(bpXPBar);
        bpXPBar.setProgressBarText("");
        sizer.add(bpXPBar, {
            align: "center-top",
            offsetX: 0,
            offsetY: this.applyScale(315),
            expand: false,
            key: "bp_xp_progress_bar"
        });
        sizer.layout();
        // Add Cancel Button
        const closeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, modalBg.getBottomCenter().x, modalBg.getBottomLeft().y, "modal_close_button", false).setScale(this._scale);
        closeButton.onClick().subscribe((pointer)=>{
            this.scene.stop();
            this.scene.get("BattlePassScene").input.enabled = true;
            this.scene.resume("BattlePassScene");
        });
        this.add.existing(closeButton);
        sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this.scene.stop();
            this.scene.get("BattlePassScene").input.enabled = true;
            this.scene.resume("BattlePassScene");
        });
    }
    getBadgeImageKey(userData, userBadges) {
        var badge = userBadges.find((ub)=>{
            if (ub.maxLevel === null) return userData.level >= ub.minLevel;
            else return userData.level >= ub.minLevel && userData.level <= ub.maxLevel;
        });
        return badge.badgeImageKey;
    }
    applyScale(length) {
        return length * this._scale;
    }
}






// Model Details
const $9fd41968a44b6cb4$var$modalWidth = 494;
const $9fd41968a44b6cb4$var$modalHeight = 494;
const $9fd41968a44b6cb4$var$modalRadius = 50;
const $9fd41968a44b6cb4$var$modalColor = 0x7d57e8;
const $9fd41968a44b6cb4$var$modalAlpha = 1;
const $9fd41968a44b6cb4$var$modalBorderColor = 0x3d4361;
const $9fd41968a44b6cb4$var$modalBorderWidth = 1;
// Image Background Details
const $9fd41968a44b6cb4$var$imageWidth = 116;
const $9fd41968a44b6cb4$var$imageHeight = 146;
const $9fd41968a44b6cb4$var$imageRadius = 7;
const $9fd41968a44b6cb4$var$imageColor = 0xb48dc7;
const $9fd41968a44b6cb4$var$imageBorderAlpha = 0.4;
const $9fd41968a44b6cb4$var$imageBorderColor = 0xffffff;
const $9fd41968a44b6cb4$var$imageBorderWidth = 1;
class $9fd41968a44b6cb4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._rewardData = data.rewardData;
        this._claimed = this._rewardData.claimed == "0" ? false : true;
        this._rewardLocked = this._rewardData.level > data.level;
        this._battlepassXP = data.battlepassXP;
    }
    constructor(){
        super({
            key: "BattlePassItemClaimScene"
        });
    }
    preload() {}
    create() {
        this.input.setDefaultCursor("default");
        this.createComponent();
        // Update UI based on Reward Locked, Claimed, Unclaimed
        this.updateUIBasedOnRewardState();
    }
    createComponent() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($9fd41968a44b6cb4$var$modalWidth, $9fd41968a44b6cb4$var$modalHeight + 60);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($9fd41968a44b6cb4$var$modalWidth), this.applyScale($9fd41968a44b6cb4$var$modalHeight), this.applyScale($9fd41968a44b6cb4$var$modalRadius), $9fd41968a44b6cb4$var$modalColor);
        modalBg.setStrokeStyle($9fd41968a44b6cb4$var$modalBorderWidth, $9fd41968a44b6cb4$var$modalBorderColor, $9fd41968a44b6cb4$var$modalAlpha);
        // Add sizer for content
        this._sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($9fd41968a44b6cb4$var$modalWidth),
            height: this.applyScale($9fd41968a44b6cb4$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        var imageSizer = this.createImageComponent();
        this._sizer.add(imageSizer, {
            key: "image-sizer",
            align: "left-top",
            offsetX: this.applyScale(189),
            offsetY: this.applyScale(44),
            expand: false
        });
        // Text Section
        this._rewardTitle = this.add.bitmapText(0, 0, "cc_outline", "Reward unlocks in:", this.applyScale(22), 1).setAlpha(0.8);
        this._sizer.add(this.add.existing(this._rewardTitle), {
            key: "reward-title",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(238),
            expand: false
        });
        this._rewardMessage = this.add.bitmapText(0, 0, "cc_outline", "0 xp", this.applyScale(22), 1).setAlpha(0.8);
        this._sizer.add(this.add.existing(this._rewardMessage), {
            key: "reward-message",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(265),
            expand: false
        });
        this._rewardName = this.add.bitmapText(0, 0, "cc_outline", this._rewardData.rewardDescription, this.applyScale(22), 0);
        this._sizer.add(this.add.existing(this._rewardName), {
            key: "reward-name",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(308),
            expand: false
        });
        // Button
        this._claimButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "battlepass_claim_button_inactive", false).setScale(this._scale);
        this._claimButton.disableInteractive();
        this._claimButton.onClick().subscribe((pointer)=>{
            (0, $da12f2862c06501b$export$2e2bcd8739ae039).getInstance().claimBattlePassRewards(1, this._rewardData.level).then((res)=>{
                if (res.success) {
                    // if loot pack reward type
                    if (res.is_loot_pack === 1) {
                        // trigger the loot pack opening scene.
                        this.scene.stop("BattlePassScene");
                        this.scene.start("PackOpeningScene", {
                            packType: this._rewardData.reward_type,
                            loot_pack_info: res.loot_pack_info
                        });
                    } else // Trigger Successful claim scene
                    this.scene.start("BattlePassClaimResultScene", {
                        claimResult: res,
                        reward: this._rewardData
                    });
                }
            });
        });
        this._sizer.add(this.add.existing(this._claimButton), {
            key: "claim-button",
            align: "left-top",
            offsetX: this.applyScale(108),
            offsetY: this.applyScale(398),
            expand: false
        });
        this._sizer.onClickOutside((co, go, pointer)=>{
            if (pointer.getDistance() > 20) return;
            this.scene.stop();
            this.scene.get("BattlePassScene").input.enabled = true;
            this.scene.resume("BattlePassScene");
        });
        this._sizer.layout();
    }
    createImageComponent() {
        var imageSizer = this.rexUI.add.overlapSizer({
            x: 0,
            y: 0,
            width: this.applyScale($9fd41968a44b6cb4$var$imageWidth),
            height: this.applyScale($9fd41968a44b6cb4$var$imageHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        const imageBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($9fd41968a44b6cb4$var$imageWidth), this.applyScale($9fd41968a44b6cb4$var$imageHeight), this.applyScale($9fd41968a44b6cb4$var$imageRadius), $9fd41968a44b6cb4$var$imageColor);
        imageBackground.setStrokeStyle($9fd41968a44b6cb4$var$imageBorderWidth, $9fd41968a44b6cb4$var$imageBorderColor, $9fd41968a44b6cb4$var$imageBorderAlpha);
        imageSizer.add(imageBackground, {
            key: "image-bg",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._itemImage = this.add.image(0, 0, this._rewardData.imageKey).setScale(this._scale);
        imageSizer.add(this._itemImage, {
            key: "bp-image",
            align: "center",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        return imageSizer;
    }
    updateUIBasedOnRewardState() {
        // Reward has been claimed by user
        if (this._claimed) {
            this._claimButton.disableInteractive();
            this._claimButton.setTexture("battlepass_claimed_button");
            this.recreateTextUI("Congratulations!", "You have earned:");
        }
        // Reward is locked
        if (this._rewardLocked) {
            this._claimButton.disableInteractive();
            this._claimButton.setTexture("battlepass_claim_button_inactive");
            this.recreateTextUI("Reward unlocks in:", this.calculateXPTillUnlock(this._rewardData.level, this._battlepassXP));
        }
        // Reward is Unlocked and has yet to be claimed
        if (!this._claimed && !this._rewardLocked) {
            this._claimButton.setInteractive();
            this._claimButton.setTexture("battlepass_claim_button_active");
            this.recreateTextUI("Congratulations!", "You have earned:");
        }
        this._sizer.layout();
    }
    recreateTextUI(rewardTitle, rewardMessage) {
        // Reward Title
        if (this._rewardTitle) this._sizer.remove(this._rewardTitle, true); //destroys object
        this._rewardTitle = this.add.bitmapText(0, 0, "cc_outline", rewardTitle, this.applyScale(22), 1).setAlpha(0.8);
        this._sizer.add(this.add.existing(this._rewardTitle), {
            key: "reward-title",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(238),
            expand: false
        });
        // Reward Message
        if (this._rewardMessage) this._sizer.remove(this._rewardMessage, true); //destroys object
        this._rewardMessage = this.add.bitmapText(0, 0, "cc_outline", rewardMessage, this.applyScale(22), 1).setAlpha(0.8);
        this._sizer.add(this.add.existing(this._rewardMessage), {
            key: "reward-message",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(265),
            expand: false
        });
    }
    calculateXPTillUnlock(level, xpTotal) {
        var xpToNextLevel = (level - 1) * 3000 - xpTotal;
        return xpToNextLevel.toLocaleString("en-us") + " XP";
    }
    applyScale(length) {
        return length * this._scale;
    }
}





// Model Details
const $67a2507677b8c282$var$modalHeight = 494;
const $67a2507677b8c282$var$modalWidth = 494;
const $67a2507677b8c282$var$modalRadius = 50;
const $67a2507677b8c282$var$modalColor = 0x7d57e8;
const $67a2507677b8c282$var$modalAlpha = 1;
const $67a2507677b8c282$var$modalBorderColor = 0x3d4361;
const $67a2507677b8c282$var$modalBorderWidth = 1;
// Image Background Details
const $67a2507677b8c282$var$imageWidth = 116;
const $67a2507677b8c282$var$imageHeight = 146;
const $67a2507677b8c282$var$imageRadius = 7;
const $67a2507677b8c282$var$imageColor = 0xb48dc7;
const $67a2507677b8c282$var$imageBorderAlpha = 0.4;
const $67a2507677b8c282$var$imageBorderColor = 0xffffff;
const $67a2507677b8c282$var$imageBorderWidth = 1;
class $67a2507677b8c282$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    init(data) {
        this._claimResult = data.claimResult;
        this._reward = data.reward;
    }
    constructor(){
        super({
            key: "BattlePassClaimResultScene"
        });
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($67a2507677b8c282$var$modalWidth, $67a2507677b8c282$var$modalHeight + 50); // 50 accounts for button extending beyond modal box
    }
    preload() {}
    create() {
        this.createComponent();
    }
    createComponent() {
        this._scale = (0, $68aeb7e748328303$export$2e2bcd8739ae039).getInstance().getScale($67a2507677b8c282$var$modalWidth, $67a2507677b8c282$var$modalHeight + 60);
        // Background Shade
        const shade = this.add.rectangle(0, 0, this.sys.canvas.width, this.sys.canvas.height, 0x1c1c1c);
        shade.setOrigin(0);
        shade.setAlpha(0.5);
        // Add Background
        const modalBg = this.add.rexRoundRectangle(this.sys.canvas.width / 2, this.sys.canvas.height / 2, this.applyScale($67a2507677b8c282$var$modalWidth), this.applyScale($67a2507677b8c282$var$modalHeight), this.applyScale($67a2507677b8c282$var$modalRadius), $67a2507677b8c282$var$modalColor, $67a2507677b8c282$var$modalAlpha);
        modalBg.setStrokeStyle(this.applyScale($67a2507677b8c282$var$modalBorderWidth), $67a2507677b8c282$var$modalBorderColor, $67a2507677b8c282$var$modalAlpha);
        // Add Sizer for content
        this._sizer = this.rexUI.add.overlapSizer({
            x: this.sys.canvas.width / 2,
            y: this.sys.canvas.height / 2,
            width: this.applyScale($67a2507677b8c282$var$modalWidth),
            height: this.applyScale($67a2507677b8c282$var$modalHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        var imageSizer = this.createImageComponent();
        this._sizer.add(imageSizer, {
            key: "image-sizer",
            align: "left-top",
            offsetX: this.applyScale(189),
            offsetY: this.applyScale(44),
            expand: false
        });
        // Text Section
        this._title = this.add.bitmapText(0, 0, "cc_outline", this.getTitleText(), this.applyScale(22), 1).setAlpha(0.8);
        this._sizer.add(this.add.existing(this._title), {
            key: "title",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(238),
            expand: false
        });
        // Add Description Text
        this._sizer.add(this.add.bitmapText(0, 0, "cc_outline", this._reward.rewardDescription, this.applyScale(24), 1).setMaxWidth(300), {
            key: "desc_text",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(280),
            expand: false
        });
        // Add Return Home Button
        const returnHomeButton = new (0, $4781ea40e0965510$export$2e2bcd8739ae039)(this, 0, 0, "squad_confirm_button", false).setScale(this._scale);
        returnHomeButton.onClick().subscribe((pointer)=>{
            // return to battle pass scene
            this.scene.stop();
            this.scene.stop("BattlePassItemClaimScene");
            this.scene.get("BattlePassScene").input.enabled = true;
            this.scene.resume("BattlePassScene");
            this.scene.get("BattlePassScene").refreshBattlepassData(this._reward.level);
        });
        this._sizer.add(this.add.existing(returnHomeButton), {
            key: "claim-button",
            align: "center-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(398),
            expand: false
        });
        this._sizer.layout();
    }
    createImageComponent() {
        var imageSizer = this.rexUI.add.overlapSizer({
            x: 0,
            y: 0,
            width: this.applyScale($67a2507677b8c282$var$imageWidth),
            height: this.applyScale($67a2507677b8c282$var$imageHeight),
            space: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                item: 0,
                line: 0
            },
            align: 0
        });
        const imageBackground = this.add.rexRoundRectangle(0, 0, this.applyScale($67a2507677b8c282$var$imageWidth), this.applyScale($67a2507677b8c282$var$imageHeight), this.applyScale($67a2507677b8c282$var$imageRadius), $67a2507677b8c282$var$imageColor);
        imageBackground.setStrokeStyle($67a2507677b8c282$var$imageBorderWidth, $67a2507677b8c282$var$imageBorderColor, $67a2507677b8c282$var$imageBorderAlpha);
        imageSizer.add(imageBackground, {
            key: "image-bg",
            align: "left-top",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        this._itemImage = this.add.image(0, 0, this._reward.imageKey).setScale(this._scale);
        imageSizer.add(this._itemImage, {
            key: "bp-image",
            align: "center",
            offsetX: this.applyScale(0),
            offsetY: this.applyScale(0),
            expand: false
        });
        return imageSizer;
    }
    getTitleText() {
        if (this._claimResult.success) return "Successfully Claimed:";
        return "Failed";
    }
    applyScale(length) {
        return length * this._scale;
    }
}



class $ee37bdc5486cfff7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("NftLoaderScene");
    }
    init(data) {
        this._originatingScene = data.originating_scene;
        this._nfts = data.nfts;
    }
    preload() {
        this._nfts.forEach((visibleNft)=>{
            this.load.image(visibleNft.image_key, visibleNft.image_thumbnail_url);
        });
    }
    create() {
        this.scene.get(this._originatingScene).onLoaded();
        this.scene.stop();
    }
}





class $538cfc7721635a0f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("NftPageLoaderScene");
    }
    init(data) {
        this._originatingScene = data.originating_scene;
        this._nfts = data.nfts;
        this._oldNfts = data.old_nfts;
    }
    preload() {
        this._nfts.forEach((visibleNft)=>{
            this.load.image(visibleNft.image_key, visibleNft.image_thumbnail_url);
        });
    }
    create() {
        // Unload images that aren't in squad or new data
        const nftsToUnload = this._oldNfts.filter((oldNft)=>!this._nfts.map((nft)=>nft.id || nft.marketplace_nft_id).includes(oldNft.id || oldNft.marketplace_nft_id)).filter((oldNft)=>!(0, $52d44b882d399a3d$export$2e2bcd8739ae039).getInstance().getSquadSync().map((nft)=>nft.id || nft.marketplace_nft_id).includes(oldNft.id || oldNft.marketplace_nft_id));
        (0, $e29d3e9b5d8af317$export$6d44be7cfb6bbf34)(this.scene.get(this._originatingScene), nftsToUnload.map((nftToUnload)=>nftToUnload.image_key));
        this.scene.get(this._originatingScene).onPageLoaded();
        this.scene.stop();
    }
}



class $d572a28b05271082$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scene {
    constructor(){
        super("AssetPreloaderScene");
    }
    init(data) {
        this._originatingScene = data.originating_scene;
        this._assets = data.assets;
    }
    preload() {
        Object.keys(this._assets).forEach((key)=>{
            this.load.image(key, this._assets[key]);
        });
    }
    create() {
        var _a;
        (_a = this.scene.get(this._originatingScene)) === null || _a === void 0 || _a.onLoaded();
        this.scene.stop();
    }
}


const $46b0125df3b201f4$var$divId = "game";
// const isMetamaskIphone = /(iPhone|iPod|MetaMaskMobile)/i.test(window.navigator.userAgent);
const $46b0125df3b201f4$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Game({
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).AUTO,
    parent: $46b0125df3b201f4$var$divId,
    transparent: true,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x0f0f1f,
    physics: {
        default: "arcade",
        arcade: {
            gravity: {
                y: 0
            }
        }
    },
    scale: {
        parent: $46b0125df3b201f4$var$divId,
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($c631c755fc42cf75$exports))).Scale.NONE
    },
    plugins: {
        scene: [
            {
                key: "rexUI",
                plugin: (0, $3246715e9c0b4015$export$2e2bcd8739ae039),
                mapping: "rexUI"
            }
        ],
        global: [
            {
                key: "rexCircleMaskImagePlugin",
                plugin: (0, $4ee1eb1018340b71$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexRoundRectanglePlugin",
                plugin: (0, $91bb69ca4812315d$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexGridTablePlugin",
                plugin: (0, $23303318b248b6d8$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexInputTextPlugin",
                plugin: (0, $d4f525ef5e7fbe59$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexDynamicTextPlugin",
                plugin: (0, $704e80d2a9f1c27f$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexGlowFilterPipeline",
                plugin: (0, $0d82ebd0a86d72fb$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexDissolvePipeline",
                plugin: (0, $f9d3b9b80d54d861$export$2e2bcd8739ae039),
                start: true
            },
            {
                key: "rexTransitionImagePlugin",
                plugin: (0, $3c0af5a5d252f7bb$export$2e2bcd8739ae039),
                start: true
            }
        ]
    },
    dom: {
        createContainer: true
    },
    input: {
        mouse: {
            target: $46b0125df3b201f4$var$divId
        }
    },
    scene: [
        (0, $17434daa1995bc6f$export$2e2bcd8739ae039),
        (0, $d8b90403e2e18020$export$2e2bcd8739ae039),
        (0, $ee37bdc5486cfff7$export$2e2bcd8739ae039),
        (0, $538cfc7721635a0f$export$2e2bcd8739ae039),
        (0, $d572a28b05271082$export$2e2bcd8739ae039),
        (0, $c9c77db60c0a7195$export$2e2bcd8739ae039),
        (0, $9aa0e57a82cfa80e$export$2e2bcd8739ae039),
        (0, $19aa4d69fb39075e$export$2e2bcd8739ae039),
        (0, $c8c81f9d2a238534$export$2e2bcd8739ae039),
        (0, $40531828681dd0a1$export$2e2bcd8739ae039),
        (0, $6e6c794894cd1ac3$export$2e2bcd8739ae039),
        (0, $8d346123ca66a5ed$export$2e2bcd8739ae039),
        (0, $2df50fb7fccdbf03$export$2e2bcd8739ae039),
        (0, $9f269383f50e2ffc$export$2e2bcd8739ae039),
        (0, $5af88f7c0345b8ef$export$2e2bcd8739ae039),
        (0, $b38845d04913730d$export$2e2bcd8739ae039),
        (0, $e25f9cca547c13c9$export$2e2bcd8739ae039),
        (0, $283efebfe660eb78$export$2e2bcd8739ae039),
        (0, $02e4045fa9a3d608$export$2e2bcd8739ae039),
        (0, $dd23c653b3652fbc$export$2e2bcd8739ae039),
        (0, $64f552616545b373$export$2e2bcd8739ae039),
        (0, $784eff2aeceaba80$export$2e2bcd8739ae039),
        (0, $91a7734bc6b0adf0$export$2e2bcd8739ae039),
        (0, $4a39541642ee7543$export$2e2bcd8739ae039),
        (0, $2650053de13e16c2$export$2e2bcd8739ae039),
        (0, $2a8af8bd1d2abd4f$export$2e2bcd8739ae039),
        (0, $26b39195591602fc$export$2e2bcd8739ae039),
        (0, $ede1ae94c2b287ca$export$2e2bcd8739ae039),
        (0, $1592a4a96a70ca50$export$2e2bcd8739ae039),
        (0, $ea962655dc0d0419$export$2e2bcd8739ae039),
        (0, $d15e8838d2b2c91b$export$2e2bcd8739ae039),
        (0, $9b87d99c0406e09c$export$2e2bcd8739ae039),
        (0, $9da07dba68f95243$export$2e2bcd8739ae039),
        (0, $074f9006fa99d79c$export$2e2bcd8739ae039),
        (0, $2971facc463cf8d8$export$2e2bcd8739ae039),
        (0, $94be8e3a03a47712$export$2e2bcd8739ae039),
        (0, $2fff857bde90b115$export$2e2bcd8739ae039),
        (0, $1a88a683ff58b16e$export$2e2bcd8739ae039),
        (0, $a0b4660f66cdd07e$export$2e2bcd8739ae039),
        (0, $85158c24f40e30dc$export$2e2bcd8739ae039),
        (0, $da2de83273e530a5$export$2e2bcd8739ae039),
        (0, $d250bb9725ceb082$export$2e2bcd8739ae039),
        (0, $af23907afa7de4a8$export$2e2bcd8739ae039),
        (0, $3e8b99fb24af68a7$export$2e2bcd8739ae039),
        (0, $6bd66ac4da17bcf8$export$2e2bcd8739ae039),
        (0, $90cf766f2895e404$export$2e2bcd8739ae039),
        (0, $a63cc9abfb0a6042$export$2e2bcd8739ae039),
        (0, $63eb02512e0e5aae$export$2e2bcd8739ae039),
        (0, $41f54d2a7fc2451d$export$2e2bcd8739ae039),
        (0, $7b50ea8ec6e6c901$export$2e2bcd8739ae039),
        (0, $16a6a830d1eab942$export$2e2bcd8739ae039),
        (0, $af0ff5e2a1a8c5a0$export$2e2bcd8739ae039),
        (0, $feb88313aba51916$export$2e2bcd8739ae039),
        (0, $80b14ede02fb82ea$export$2e2bcd8739ae039),
        (0, $2dbd94455af48f08$export$2e2bcd8739ae039),
        (0, $dba42957ce8632a0$export$2e2bcd8739ae039),
        (0, $b96f5697b2b62217$export$2e2bcd8739ae039),
        (0, $c7185ff56d44b41b$export$2e2bcd8739ae039),
        (0, $ba7c51110faef602$export$2e2bcd8739ae039),
        (0, $c7945900278e79f3$export$2e2bcd8739ae039),
        (0, $821d3a4d53be6799$export$2e2bcd8739ae039),
        (0, $66056ccc21fc7be2$export$2e2bcd8739ae039),
        (0, $70f442678db48c10$export$2e2bcd8739ae039),
        (0, $2a5ff982cdf64ef8$export$2e2bcd8739ae039),
        (0, $91fa7cb414ce6d6f$export$2e2bcd8739ae039),
        (0, $bb029119ea11b6e9$export$2e2bcd8739ae039),
        (0, $aa48837ca0f9969e$export$2e2bcd8739ae039),
        (0, $9a8873bbd90f230f$export$2e2bcd8739ae039),
        (0, $f38b92966e177ef1$export$2e2bcd8739ae039),
        (0, $2d7e70af22a8cacb$export$2e2bcd8739ae039),
        (0, $b0183b4c47a2f044$export$2e2bcd8739ae039),
        (0, $22d285200be5b863$export$2e2bcd8739ae039),
        (0, $55dff0db4147c021$export$2e2bcd8739ae039),
        (0, $0a300af4a3bd78d7$export$2e2bcd8739ae039),
        (0, $3fd42784f8190fba$export$2e2bcd8739ae039),
        (0, $b8bc76a7cf36e3b5$export$2e2bcd8739ae039),
        (0, $dcc4d55cfe127dd4$export$2e2bcd8739ae039),
        (0, $371dd94fe4d1a8e8$export$2e2bcd8739ae039),
        (0, $ea68bf593fb10e47$export$2e2bcd8739ae039),
        (0, $84d0697387ac85be$export$2e2bcd8739ae039),
        (0, $bcb87a290434e74d$export$2e2bcd8739ae039),
        (0, $76f1d6b415d5b5df$export$2e2bcd8739ae039),
        (0, $c8a1a1e87bf46e8e$export$2e2bcd8739ae039),
        (0, $f2dc29e18a01ed95$export$2e2bcd8739ae039),
        (0, $9fd41968a44b6cb4$export$2e2bcd8739ae039),
        (0, $67a2507677b8c282$export$2e2bcd8739ae039),
        (0, $8a1b429231f58ae5$export$2e2bcd8739ae039)
    ]
});
// function resize() {
//   var canvas = document.querySelector("canvas");
//   var windowWidth = window.innerWidth;
//   var windowHeight = window.innerHeight;
//   var windowRatio = windowWidth / windowHeight;
//   var gameRatio = parseInt(game.config.width.toString()) / parseInt(game.config.height.toString());
//   if (!canvas) return;
//   if(windowRatio < gameRatio){
//       canvas.style.width = windowWidth + "px";
//       canvas.style.height = (windowWidth / gameRatio) + "px";
//   }
//   else{
//       canvas.style.width = (windowHeight * gameRatio) + "px";
//       canvas.style.height = windowHeight + "px";
//   }
// }
// resize();
// window.addEventListener("resize", resize, false);
const { ethereum: $46b0125df3b201f4$var$ethereum } = window;
let $46b0125df3b201f4$var$currentAddress;
// Handle active wallet changes after connecting
if ($46b0125df3b201f4$var$ethereum && $46b0125df3b201f4$var$ethereum.isMetaMask) {
    $46b0125df3b201f4$var$currentAddress = $46b0125df3b201f4$var$ethereum.selectedAddress;
    $46b0125df3b201f4$var$ethereum.on("accountsChanged", function(accounts) {
        if ($46b0125df3b201f4$var$currentAddress === undefined || $46b0125df3b201f4$var$currentAddress === null) $46b0125df3b201f4$var$currentAddress = accounts[0];
        if ($46b0125df3b201f4$var$currentAddress && $46b0125df3b201f4$var$currentAddress !== accounts[0] || accounts.length === 0) // User disconnected metamask or changed active wallets.  Force refresh.
        window.location.reload();
    });
}
var $46b0125df3b201f4$export$2e2bcd8739ae039 = $46b0125df3b201f4$var$game;


//# sourceMappingURL=index.753099e0.js.map
